var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a3, b3) => {
  for (var prop in b3 || (b3 = {}))
    if (__hasOwnProp.call(b3, prop))
      __defNormalProp(a3, prop, b3[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b3)) {
      if (__propIsEnum.call(b3, prop))
        __defNormalProp(a3, prop, b3[prop]);
    }
  return a3;
};
var __spreadProps = (a3, b3) => __defProps(a3, __getOwnPropDescs(b3));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { openBlock, createElementBlock, createElementVNode, inject, computed, shallowRef, onBeforeMount, ref as ref$1, watchEffect, defineComponent, provide, toRef as toRef$1, h as h$1R, createBlock, unref, withCtx, renderSlot, onMounted, onUnmounted, isVNode, Comment, Fragment, watch, readonly, TransitionGroup, Transition, withDirectives, vShow, onBeforeUnmount, onActivated, onDeactivated, getCurrentInstance, mergeProps, createTextVNode, Teleport, nextTick, useSlots, createCommentVNode, normalizeClass, createSlots, createVNode, resolveDynamicComponent, toDisplayString, cloneVNode, Text, normalizeStyle, normalizeProps, guardReactiveProps, renderList, reactive, onUpdated, onBeforeUpdate, pushScopeId, popScopeId, markRaw, vModelText, toHandlers, customRef, getCurrentScope, onScopeDispose, vModelDynamic, resolveComponent } from "vue";
/*! Capacitor: https://capacitorjs.com/ - MIT License */
const createCapacitorPlatforms = (win) => {
  const defaultPlatformMap = new Map();
  defaultPlatformMap.set("web", { name: "web" });
  const capPlatforms = win.CapacitorPlatforms || {
    currentPlatform: { name: "web" },
    platforms: defaultPlatformMap
  };
  const addPlatform = (name2, platform2) => {
    capPlatforms.platforms.set(name2, platform2);
  };
  const setPlatform = (name2) => {
    if (capPlatforms.platforms.has(name2)) {
      capPlatforms.currentPlatform = capPlatforms.platforms.get(name2);
    }
  };
  capPlatforms.addPlatform = addPlatform;
  capPlatforms.setPlatform = setPlatform;
  return capPlatforms;
};
const initPlatforms = (win) => win.CapacitorPlatforms = createCapacitorPlatforms(win);
const CapacitorPlatforms = /* @__PURE__ */ initPlatforms(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
CapacitorPlatforms.addPlatform;
CapacitorPlatforms.setPlatform;
var ExceptionCode;
(function(ExceptionCode2) {
  ExceptionCode2["Unimplemented"] = "UNIMPLEMENTED";
  ExceptionCode2["Unavailable"] = "UNAVAILABLE";
})(ExceptionCode || (ExceptionCode = {}));
class CapacitorException extends Error {
  constructor(message, code, data) {
    super(message);
    this.message = message;
    this.code = code;
    this.data = data;
  }
}
const getPlatformId = (win) => {
  var _a2, _b2;
  if (win === null || win === void 0 ? void 0 : win.androidBridge) {
    return "android";
  } else if ((_b2 = (_a2 = win === null || win === void 0 ? void 0 : win.webkit) === null || _a2 === void 0 ? void 0 : _a2.messageHandlers) === null || _b2 === void 0 ? void 0 : _b2.bridge) {
    return "ios";
  } else {
    return "web";
  }
};
const createCapacitor = (win) => {
  var _a2, _b2, _c2, _d2, _e2;
  const capCustomPlatform = win.CapacitorCustomPlatform || null;
  const cap = win.Capacitor || {};
  const Plugins = cap.Plugins = cap.Plugins || {};
  const capPlatforms = win.CapacitorPlatforms;
  const defaultGetPlatform = () => {
    return capCustomPlatform !== null ? capCustomPlatform.name : getPlatformId(win);
  };
  const getPlatform = ((_a2 = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _a2 === void 0 ? void 0 : _a2.getPlatform) || defaultGetPlatform;
  const defaultIsNativePlatform = () => getPlatform() !== "web";
  const isNativePlatform = ((_b2 = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _b2 === void 0 ? void 0 : _b2.isNativePlatform) || defaultIsNativePlatform;
  const defaultIsPluginAvailable = (pluginName) => {
    const plugin = registeredPlugins.get(pluginName);
    if (plugin === null || plugin === void 0 ? void 0 : plugin.platforms.has(getPlatform())) {
      return true;
    }
    if (getPluginHeader(pluginName)) {
      return true;
    }
    return false;
  };
  const isPluginAvailable = ((_c2 = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _c2 === void 0 ? void 0 : _c2.isPluginAvailable) || defaultIsPluginAvailable;
  const defaultGetPluginHeader = (pluginName) => {
    var _a3;
    return (_a3 = cap.PluginHeaders) === null || _a3 === void 0 ? void 0 : _a3.find((h3) => h3.name === pluginName);
  };
  const getPluginHeader = ((_d2 = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _d2 === void 0 ? void 0 : _d2.getPluginHeader) || defaultGetPluginHeader;
  const handleError = (err) => win.console.error(err);
  const pluginMethodNoop = (_target, prop, pluginName) => {
    return Promise.reject(`${pluginName} does not have an implementation of "${prop}".`);
  };
  const registeredPlugins = new Map();
  const defaultRegisterPlugin = (pluginName, jsImplementations = {}) => {
    const registeredPlugin = registeredPlugins.get(pluginName);
    if (registeredPlugin) {
      console.warn(`Capacitor plugin "${pluginName}" already registered. Cannot register plugins twice.`);
      return registeredPlugin.proxy;
    }
    const platform2 = getPlatform();
    const pluginHeader = getPluginHeader(pluginName);
    let jsImplementation;
    const loadPluginImplementation = async () => {
      if (!jsImplementation && platform2 in jsImplementations) {
        jsImplementation = typeof jsImplementations[platform2] === "function" ? jsImplementation = await jsImplementations[platform2]() : jsImplementation = jsImplementations[platform2];
      } else if (capCustomPlatform !== null && !jsImplementation && "web" in jsImplementations) {
        jsImplementation = typeof jsImplementations["web"] === "function" ? jsImplementation = await jsImplementations["web"]() : jsImplementation = jsImplementations["web"];
      }
      return jsImplementation;
    };
    const createPluginMethod = (impl, prop) => {
      var _a3, _b3;
      if (pluginHeader) {
        const methodHeader = pluginHeader === null || pluginHeader === void 0 ? void 0 : pluginHeader.methods.find((m3) => prop === m3.name);
        if (methodHeader) {
          if (methodHeader.rtype === "promise") {
            return (options) => cap.nativePromise(pluginName, prop.toString(), options);
          } else {
            return (options, callback) => cap.nativeCallback(pluginName, prop.toString(), options, callback);
          }
        } else if (impl) {
          return (_a3 = impl[prop]) === null || _a3 === void 0 ? void 0 : _a3.bind(impl);
        }
      } else if (impl) {
        return (_b3 = impl[prop]) === null || _b3 === void 0 ? void 0 : _b3.bind(impl);
      } else {
        throw new CapacitorException(`"${pluginName}" plugin is not implemented on ${platform2}`, ExceptionCode.Unimplemented);
      }
    };
    const createPluginMethodWrapper = (prop) => {
      let remove2;
      const wrapper = (...args) => {
        const p3 = loadPluginImplementation().then((impl) => {
          const fn2 = createPluginMethod(impl, prop);
          if (fn2) {
            const p6 = fn2(...args);
            remove2 = p6 === null || p6 === void 0 ? void 0 : p6.remove;
            return p6;
          } else {
            throw new CapacitorException(`"${pluginName}.${prop}()" is not implemented on ${platform2}`, ExceptionCode.Unimplemented);
          }
        });
        if (prop === "addListener") {
          p3.remove = async () => remove2();
        }
        return p3;
      };
      wrapper.toString = () => `${prop.toString()}() { [capacitor code] }`;
      Object.defineProperty(wrapper, "name", {
        value: prop,
        writable: false,
        configurable: false
      });
      return wrapper;
    };
    const addListener = createPluginMethodWrapper("addListener");
    const removeListener = createPluginMethodWrapper("removeListener");
    const addListenerNative = (eventName, callback) => {
      const call = addListener({ eventName }, callback);
      const remove2 = async () => {
        const callbackId = await call;
        removeListener({
          eventName,
          callbackId
        }, callback);
      };
      const p3 = new Promise((resolve) => call.then(() => resolve({ remove: remove2 })));
      p3.remove = async () => {
        console.warn(`Using addListener() without 'await' is deprecated.`);
        await remove2();
      };
      return p3;
    };
    const proxy = new Proxy({}, {
      get(_3, prop) {
        switch (prop) {
          case "$$typeof":
            return void 0;
          case "toJSON":
            return () => ({});
          case "addListener":
            return pluginHeader ? addListenerNative : addListener;
          case "removeListener":
            return removeListener;
          default:
            return createPluginMethodWrapper(prop);
        }
      }
    });
    Plugins[pluginName] = proxy;
    registeredPlugins.set(pluginName, {
      name: pluginName,
      proxy,
      platforms: new Set([
        ...Object.keys(jsImplementations),
        ...pluginHeader ? [platform2] : []
      ])
    });
    return proxy;
  };
  const registerPlugin2 = ((_e2 = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _e2 === void 0 ? void 0 : _e2.registerPlugin) || defaultRegisterPlugin;
  if (!cap.convertFileSrc) {
    cap.convertFileSrc = (filePath) => filePath;
  }
  cap.getPlatform = getPlatform;
  cap.handleError = handleError;
  cap.isNativePlatform = isNativePlatform;
  cap.isPluginAvailable = isPluginAvailable;
  cap.pluginMethodNoop = pluginMethodNoop;
  cap.registerPlugin = registerPlugin2;
  cap.Exception = CapacitorException;
  cap.DEBUG = !!cap.DEBUG;
  cap.isLoggingEnabled = !!cap.isLoggingEnabled;
  cap.platform = cap.getPlatform();
  cap.isNative = cap.isNativePlatform();
  return cap;
};
const initCapacitorGlobal = (win) => win.Capacitor = createCapacitor(win);
const Capacitor = /* @__PURE__ */ initCapacitorGlobal(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
const registerPlugin = Capacitor.registerPlugin;
Capacitor.Plugins;
class WebPlugin {
  constructor(config) {
    this.listeners = {};
    this.retainedEventArguments = {};
    this.windowListeners = {};
    if (config) {
      console.warn(`Capacitor WebPlugin "${config.name}" config object was deprecated in v3 and will be removed in v4.`);
      this.config = config;
    }
  }
  addListener(eventName, listenerFunc) {
    let firstListener = false;
    const listeners = this.listeners[eventName];
    if (!listeners) {
      this.listeners[eventName] = [];
      firstListener = true;
    }
    this.listeners[eventName].push(listenerFunc);
    const windowListener = this.windowListeners[eventName];
    if (windowListener && !windowListener.registered) {
      this.addWindowListener(windowListener);
    }
    if (firstListener) {
      this.sendRetainedArgumentsForEvent(eventName);
    }
    const remove2 = async () => this.removeListener(eventName, listenerFunc);
    const p3 = Promise.resolve({ remove: remove2 });
    return p3;
  }
  async removeAllListeners() {
    this.listeners = {};
    for (const listener in this.windowListeners) {
      this.removeWindowListener(this.windowListeners[listener]);
    }
    this.windowListeners = {};
  }
  notifyListeners(eventName, data, retainUntilConsumed) {
    const listeners = this.listeners[eventName];
    if (!listeners) {
      if (retainUntilConsumed) {
        let args = this.retainedEventArguments[eventName];
        if (!args) {
          args = [];
        }
        args.push(data);
        this.retainedEventArguments[eventName] = args;
      }
      return;
    }
    listeners.forEach((listener) => listener(data));
  }
  hasListeners(eventName) {
    return !!this.listeners[eventName].length;
  }
  registerWindowListener(windowEventName, pluginEventName) {
    this.windowListeners[pluginEventName] = {
      registered: false,
      windowEventName,
      pluginEventName,
      handler: (event2) => {
        this.notifyListeners(pluginEventName, event2);
      }
    };
  }
  unimplemented(msg = "not implemented") {
    return new Capacitor.Exception(msg, ExceptionCode.Unimplemented);
  }
  unavailable(msg = "not available") {
    return new Capacitor.Exception(msg, ExceptionCode.Unavailable);
  }
  async removeListener(eventName, listenerFunc) {
    const listeners = this.listeners[eventName];
    if (!listeners) {
      return;
    }
    const index = listeners.indexOf(listenerFunc);
    this.listeners[eventName].splice(index, 1);
    if (!this.listeners[eventName].length) {
      this.removeWindowListener(this.windowListeners[eventName]);
    }
  }
  addWindowListener(handle) {
    window.addEventListener(handle.windowEventName, handle.handler);
    handle.registered = true;
  }
  removeWindowListener(handle) {
    if (!handle) {
      return;
    }
    window.removeEventListener(handle.windowEventName, handle.handler);
    handle.registered = false;
  }
  sendRetainedArgumentsForEvent(eventName) {
    const args = this.retainedEventArguments[eventName];
    if (!args) {
      return;
    }
    delete this.retainedEventArguments[eventName];
    args.forEach((arg) => {
      this.notifyListeners(eventName, arg);
    });
  }
}
const encode$3 = (str) => encodeURIComponent(str).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
const decode$1 = (str) => str.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
class CapacitorCookiesPluginWeb extends WebPlugin {
  async getCookies() {
    const cookies2 = document.cookie;
    const cookieMap = {};
    cookies2.split(";").forEach((cookie) => {
      if (cookie.length <= 0)
        return;
      let [key, value] = cookie.replace(/=/, "CAP_COOKIE").split("CAP_COOKIE");
      key = decode$1(key).trim();
      value = decode$1(value).trim();
      cookieMap[key] = value;
    });
    return cookieMap;
  }
  async setCookie(options) {
    try {
      const encodedKey = encode$3(options.key);
      const encodedValue = encode$3(options.value);
      const expires = `; expires=${(options.expires || "").replace("expires=", "")}`;
      const path = (options.path || "/").replace("path=", "");
      const domain = options.url != null && options.url.length > 0 ? `domain=${options.url}` : "";
      document.cookie = `${encodedKey}=${encodedValue || ""}${expires}; path=${path}; ${domain};`;
    } catch (error2) {
      return Promise.reject(error2);
    }
  }
  async deleteCookie(options) {
    try {
      document.cookie = `${options.key}=; Max-Age=0`;
    } catch (error2) {
      return Promise.reject(error2);
    }
  }
  async clearCookies() {
    try {
      const cookies2 = document.cookie.split(";") || [];
      for (const cookie of cookies2) {
        document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
      }
    } catch (error2) {
      return Promise.reject(error2);
    }
  }
  async clearAllCookies() {
    try {
      await this.clearCookies();
    } catch (error2) {
      return Promise.reject(error2);
    }
  }
}
registerPlugin("CapacitorCookies", {
  web: () => new CapacitorCookiesPluginWeb()
});
const readBlobAsBase64 = async (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => {
    const base64String = reader.result;
    resolve(base64String.indexOf(",") >= 0 ? base64String.split(",")[1] : base64String);
  };
  reader.onerror = (error2) => reject(error2);
  reader.readAsDataURL(blob);
});
const normalizeHttpHeaders = (headers = {}) => {
  const originalKeys = Object.keys(headers);
  const loweredKeys = Object.keys(headers).map((k3) => k3.toLocaleLowerCase());
  const normalized = loweredKeys.reduce((acc, key, index) => {
    acc[key] = headers[originalKeys[index]];
    return acc;
  }, {});
  return normalized;
};
const buildUrlParams = (params2, shouldEncode = true) => {
  if (!params2)
    return null;
  const output = Object.entries(params2).reduce((accumulator, entry) => {
    const [key, value] = entry;
    let encodedValue;
    let item;
    if (Array.isArray(value)) {
      item = "";
      value.forEach((str) => {
        encodedValue = shouldEncode ? encodeURIComponent(str) : str;
        item += `${key}=${encodedValue}&`;
      });
      item.slice(0, -1);
    } else {
      encodedValue = shouldEncode ? encodeURIComponent(value) : value;
      item = `${key}=${encodedValue}`;
    }
    return `${accumulator}&${item}`;
  }, "");
  return output.substr(1);
};
const buildRequestInit = (options, extra = {}) => {
  const output = Object.assign({ method: options.method || "GET", headers: options.headers }, extra);
  const headers = normalizeHttpHeaders(options.headers);
  const type = headers["content-type"] || "";
  if (typeof options.data === "string") {
    output.body = options.data;
  } else if (type.includes("application/x-www-form-urlencoded")) {
    const params2 = new URLSearchParams();
    for (const [key, value] of Object.entries(options.data || {})) {
      params2.set(key, value);
    }
    output.body = params2.toString();
  } else if (type.includes("multipart/form-data") || options.data instanceof FormData) {
    const form = new FormData();
    if (options.data instanceof FormData) {
      options.data.forEach((value, key) => {
        form.append(key, value);
      });
    } else {
      for (const key of Object.keys(options.data)) {
        form.append(key, options.data[key]);
      }
    }
    output.body = form;
    const headers2 = new Headers(output.headers);
    headers2.delete("content-type");
    output.headers = headers2;
  } else if (type.includes("application/json") || typeof options.data === "object") {
    output.body = JSON.stringify(options.data);
  }
  return output;
};
class CapacitorHttpPluginWeb extends WebPlugin {
  async request(options) {
    const requestInit = buildRequestInit(options, options.webFetchExtra);
    const urlParams = buildUrlParams(options.params, options.shouldEncodeUrlParams);
    const url = urlParams ? `${options.url}?${urlParams}` : options.url;
    const response = await fetch(url, requestInit);
    const contentType = response.headers.get("content-type") || "";
    let { responseType = "text" } = response.ok ? options : {};
    if (contentType.includes("application/json")) {
      responseType = "json";
    }
    let data;
    let blob;
    switch (responseType) {
      case "arraybuffer":
      case "blob":
        blob = await response.blob();
        data = await readBlobAsBase64(blob);
        break;
      case "json":
        data = await response.json();
        break;
      case "document":
      case "text":
      default:
        data = await response.text();
    }
    const headers = {};
    response.headers.forEach((value, key) => {
      headers[key] = value;
    });
    return {
      data,
      headers,
      status: response.status,
      url: response.url
    };
  }
  async get(options) {
    return this.request(Object.assign(Object.assign({}, options), { method: "GET" }));
  }
  async post(options) {
    return this.request(Object.assign(Object.assign({}, options), { method: "POST" }));
  }
  async put(options) {
    return this.request(Object.assign(Object.assign({}, options), { method: "PUT" }));
  }
  async patch(options) {
    return this.request(Object.assign(Object.assign({}, options), { method: "PATCH" }));
  }
  async delete(options) {
    return this.request(Object.assign(Object.assign({}, options), { method: "DELETE" }));
  }
}
registerPlugin("CapacitorHttp", {
  web: () => new CapacitorHttpPluginWeb()
});
var style$1 = "";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics$1 = function(d3, b3) {
  extendStatics$1 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d6, b10) {
    d6.__proto__ = b10;
  } || function(d6, b10) {
    for (var p3 in b10)
      if (b10.hasOwnProperty(p3))
        d6[p3] = b10[p3];
  };
  return extendStatics$1(d3, b3);
};
function __extends$1(d3, b3) {
  extendStatics$1(d3, b3);
  function __() {
    this.constructor = d3;
  }
  d3.prototype = b3 === null ? Object.create(b3) : (__.prototype = b3.prototype, new __());
}
var __assign = function() {
  __assign = Object.assign || function __assign2(t3) {
    for (var s3, i = 1, n3 = arguments.length; i < n3; i++) {
      s3 = arguments[i];
      for (var p3 in s3)
        if (Object.prototype.hasOwnProperty.call(s3, p3))
          t3[p3] = s3[p3];
    }
    return t3;
  };
  return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P3, generator) {
  function adopt(value) {
    return value instanceof P3 ? value : new P3(function(resolve) {
      resolve(value);
    });
  }
  return new (P3 || (P3 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e28) {
        reject(e28);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e28) {
        reject(e28);
      }
    }
    function step(result2) {
      result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _3 = { label: 0, sent: function() {
    if (t3[0] & 1)
      throw t3[1];
    return t3[1];
  }, trys: [], ops: [] }, f3, y3, t3, g3;
  return g3 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g3[Symbol.iterator] = function() {
    return this;
  }), g3;
  function verb(n3) {
    return function(v3) {
      return step([n3, v3]);
    };
  }
  function step(op2) {
    if (f3)
      throw new TypeError("Generator is already executing.");
    while (_3)
      try {
        if (f3 = 1, y3 && (t3 = op2[0] & 2 ? y3["return"] : op2[0] ? y3["throw"] || ((t3 = y3["return"]) && t3.call(y3), 0) : y3.next) && !(t3 = t3.call(y3, op2[1])).done)
          return t3;
        if (y3 = 0, t3)
          op2 = [op2[0] & 2, t3.value];
        switch (op2[0]) {
          case 0:
          case 1:
            t3 = op2;
            break;
          case 4:
            _3.label++;
            return { value: op2[1], done: false };
          case 5:
            _3.label++;
            y3 = op2[1];
            op2 = [0];
            continue;
          case 7:
            op2 = _3.ops.pop();
            _3.trys.pop();
            continue;
          default:
            if (!(t3 = _3.trys, t3 = t3.length > 0 && t3[t3.length - 1]) && (op2[0] === 6 || op2[0] === 2)) {
              _3 = 0;
              continue;
            }
            if (op2[0] === 3 && (!t3 || op2[1] > t3[0] && op2[1] < t3[3])) {
              _3.label = op2[1];
              break;
            }
            if (op2[0] === 6 && _3.label < t3[1]) {
              _3.label = t3[1];
              t3 = op2;
              break;
            }
            if (t3 && _3.label < t3[2]) {
              _3.label = t3[2];
              _3.ops.push(op2);
              break;
            }
            if (t3[2])
              _3.ops.pop();
            _3.trys.pop();
            continue;
        }
        op2 = body.call(thisArg, _3);
      } catch (e28) {
        op2 = [6, e28];
        y3 = 0;
      } finally {
        f3 = t3 = 0;
      }
    if (op2[0] & 5)
      throw op2[1];
    return { value: op2[0] ? op2[1] : void 0, done: true };
  }
}
function __values$1(o3) {
  var s3 = typeof Symbol === "function" && Symbol.iterator, m3 = s3 && o3[s3], i = 0;
  if (m3)
    return m3.call(o3);
  if (o3 && typeof o3.length === "number")
    return {
      next: function() {
        if (o3 && i >= o3.length)
          o3 = void 0;
        return { value: o3 && o3[i++], done: !o3 };
      }
    };
  throw new TypeError(s3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o3, n3) {
  var m3 = typeof Symbol === "function" && o3[Symbol.iterator];
  if (!m3)
    return o3;
  var i = m3.call(o3), r3, ar2 = [], e28;
  try {
    while ((n3 === void 0 || n3-- > 0) && !(r3 = i.next()).done)
      ar2.push(r3.value);
  } catch (error2) {
    e28 = { error: error2 };
  } finally {
    try {
      if (r3 && !r3.done && (m3 = i["return"]))
        m3.call(i);
    } finally {
      if (e28)
        throw e28.error;
    }
  }
  return ar2;
}
function __spread() {
  for (var ar2 = [], i = 0; i < arguments.length; i++)
    ar2 = ar2.concat(__read(arguments[i]));
  return ar2;
}
function __spreadArrays$1() {
  for (var s3 = 0, i = 0, il = arguments.length; i < il; i++)
    s3 += arguments[i].length;
  for (var r3 = Array(s3), k3 = 0, i = 0; i < il; i++)
    for (var a3 = arguments[i], j3 = 0, jl2 = a3.length; j3 < jl2; j3++, k3++)
      r3[k3] = a3[j3];
  return r3;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var CONSTANTS = {
  NODE_CLIENT: false,
  NODE_ADMIN: false,
  SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var assert = function(assertion, message) {
  if (!assertion) {
    throw assertionError(message);
  }
};
var assertionError = function(message) {
  return new Error("Firebase Database (" + CONSTANTS.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray = function(str) {
  var out = [];
  var p3 = 0;
  for (var i = 0; i < str.length; i++) {
    var c3 = str.charCodeAt(i);
    if (c3 < 128) {
      out[p3++] = c3;
    } else if (c3 < 2048) {
      out[p3++] = c3 >> 6 | 192;
      out[p3++] = c3 & 63 | 128;
    } else if ((c3 & 64512) === 55296 && i + 1 < str.length && (str.charCodeAt(i + 1) & 64512) === 56320) {
      c3 = 65536 + ((c3 & 1023) << 10) + (str.charCodeAt(++i) & 1023);
      out[p3++] = c3 >> 18 | 240;
      out[p3++] = c3 >> 12 & 63 | 128;
      out[p3++] = c3 >> 6 & 63 | 128;
      out[p3++] = c3 & 63 | 128;
    } else {
      out[p3++] = c3 >> 12 | 224;
      out[p3++] = c3 >> 6 & 63 | 128;
      out[p3++] = c3 & 63 | 128;
    }
  }
  return out;
};
var byteArrayToString = function(bytes) {
  var out = [];
  var pos = 0, c3 = 0;
  while (pos < bytes.length) {
    var c1 = bytes[pos++];
    if (c1 < 128) {
      out[c3++] = String.fromCharCode(c1);
    } else if (c1 > 191 && c1 < 224) {
      var c22 = bytes[pos++];
      out[c3++] = String.fromCharCode((c1 & 31) << 6 | c22 & 63);
    } else if (c1 > 239 && c1 < 365) {
      var c22 = bytes[pos++];
      var c32 = bytes[pos++];
      var c42 = bytes[pos++];
      var u3 = ((c1 & 7) << 18 | (c22 & 63) << 12 | (c32 & 63) << 6 | c42 & 63) - 65536;
      out[c3++] = String.fromCharCode(55296 + (u3 >> 10));
      out[c3++] = String.fromCharCode(56320 + (u3 & 1023));
    } else {
      var c22 = bytes[pos++];
      var c32 = bytes[pos++];
      out[c3++] = String.fromCharCode((c1 & 15) << 12 | (c22 & 63) << 6 | c32 & 63);
    }
  }
  return out.join("");
};
var base64 = {
  byteToCharMap_: null,
  charToByteMap_: null,
  byteToCharMapWebSafe_: null,
  charToByteMapWebSafe_: null,
  ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + "+/=";
  },
  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + "-_.";
  },
  HAS_NATIVE_SUPPORT: typeof atob === "function",
  encodeByteArray: function(input, webSafe) {
    if (!Array.isArray(input)) {
      throw Error("encodeByteArray takes an array as a parameter");
    }
    this.init_();
    var byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
    var output = [];
    for (var i = 0; i < input.length; i += 3) {
      var byte1 = input[i];
      var haveByte2 = i + 1 < input.length;
      var byte2 = haveByte2 ? input[i + 1] : 0;
      var haveByte3 = i + 2 < input.length;
      var byte3 = haveByte3 ? input[i + 2] : 0;
      var outByte1 = byte1 >> 2;
      var outByte2 = (byte1 & 3) << 4 | byte2 >> 4;
      var outByte3 = (byte2 & 15) << 2 | byte3 >> 6;
      var outByte4 = byte3 & 63;
      if (!haveByte3) {
        outByte4 = 64;
        if (!haveByte2) {
          outByte3 = 64;
        }
      }
      output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
    }
    return output.join("");
  },
  encodeString: function(input, webSafe) {
    if (this.HAS_NATIVE_SUPPORT && !webSafe) {
      return btoa(input);
    }
    return this.encodeByteArray(stringToByteArray(input), webSafe);
  },
  decodeString: function(input, webSafe) {
    if (this.HAS_NATIVE_SUPPORT && !webSafe) {
      return atob(input);
    }
    return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
  },
  decodeStringToByteArray: function(input, webSafe) {
    this.init_();
    var charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
    var output = [];
    for (var i = 0; i < input.length; ) {
      var byte1 = charToByteMap[input.charAt(i++)];
      var haveByte2 = i < input.length;
      var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
      ++i;
      var haveByte3 = i < input.length;
      var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
      ++i;
      var haveByte4 = i < input.length;
      var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
      ++i;
      if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
        throw Error();
      }
      var outByte1 = byte1 << 2 | byte2 >> 4;
      output.push(outByte1);
      if (byte3 !== 64) {
        var outByte2 = byte2 << 4 & 240 | byte3 >> 2;
        output.push(outByte2);
        if (byte4 !== 64) {
          var outByte3 = byte3 << 6 & 192 | byte4;
          output.push(outByte3);
        }
      }
    }
    return output;
  },
  init_: function() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {};
      this.charToByteMap_ = {};
      this.byteToCharMapWebSafe_ = {};
      this.charToByteMapWebSafe_ = {};
      for (var i = 0; i < this.ENCODED_VALS.length; i++) {
        this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
        this.charToByteMap_[this.byteToCharMap_[i]] = i;
        this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
        this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
        if (i >= this.ENCODED_VALS_BASE.length) {
          this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
          this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
        }
      }
    }
  }
};
var base64Encode = function(str) {
  var utf8Bytes = stringToByteArray(str);
  return base64.encodeByteArray(utf8Bytes, true);
};
var base64Decode = function(str) {
  try {
    return base64.decodeString(str, true);
  } catch (e28) {
    console.error("base64Decode failed: ", e28);
  }
  return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function deepCopy(value) {
  return deepExtend(void 0, value);
}
function deepExtend(target, source) {
  if (!(source instanceof Object)) {
    return source;
  }
  switch (source.constructor) {
    case Date:
      var dateValue = source;
      return new Date(dateValue.getTime());
    case Object:
      if (target === void 0) {
        target = {};
      }
      break;
    case Array:
      target = [];
      break;
    default:
      return source;
  }
  for (var prop in source) {
    if (!source.hasOwnProperty(prop) || !isValidKey$1(prop)) {
      continue;
    }
    target[prop] = deepExtend(target[prop], source[prop]);
  }
  return target;
}
function isValidKey$1(key) {
  return key !== "__proto__";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = function() {
  function Deferred2() {
    var _this = this;
    this.reject = function() {
    };
    this.resolve = function() {
    };
    this.promise = new Promise(function(resolve, reject) {
      _this.resolve = resolve;
      _this.reject = reject;
    });
  }
  Deferred2.prototype.wrapCallback = function(callback) {
    var _this = this;
    return function(error2, value) {
      if (error2) {
        _this.reject(error2);
      } else {
        _this.resolve(value);
      }
      if (typeof callback === "function") {
        _this.promise.catch(function() {
        });
        if (callback.length === 1) {
          callback(error2);
        } else {
          callback(error2, value);
        }
      }
    };
  };
  return Deferred2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getUA() {
  if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") {
    return navigator["userAgent"];
  } else {
    return "";
  }
}
function isMobileCordova() {
  return typeof window !== "undefined" && !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA());
}
function isNode() {
  try {
    return Object.prototype.toString.call(global.process) === "[object process]";
  } catch (e28) {
    return false;
  }
}
function isBrowser$1() {
  return typeof self === "object" && self.self === self;
}
function isBrowserExtension() {
  var runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : void 0;
  return typeof runtime === "object" && runtime.id !== void 0;
}
function isReactNative() {
  return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
function isElectron() {
  return getUA().indexOf("Electron/") >= 0;
}
function isIE() {
  var ua2 = getUA();
  return ua2.indexOf("MSIE ") >= 0 || ua2.indexOf("Trident/") >= 0;
}
function isUWP() {
  return getUA().indexOf("MSAppHost/") >= 0;
}
function isNodeSdk() {
  return CONSTANTS.NODE_ADMIN === true;
}
function isIndexedDBAvailable() {
  return "indexedDB" in self && indexedDB != null;
}
function validateIndexedDBOpenable() {
  return new Promise(function(resolve, reject) {
    try {
      var preExist_1 = true;
      var DB_CHECK_NAME_1 = "validate-browser-context-for-indexeddb-analytics-module";
      var request_1 = window.indexedDB.open(DB_CHECK_NAME_1);
      request_1.onsuccess = function() {
        request_1.result.close();
        if (!preExist_1) {
          window.indexedDB.deleteDatabase(DB_CHECK_NAME_1);
        }
        resolve(true);
      };
      request_1.onupgradeneeded = function() {
        preExist_1 = false;
      };
      request_1.onerror = function() {
        var _a2;
        reject(((_a2 = request_1.error) === null || _a2 === void 0 ? void 0 : _a2.message) || "");
      };
    } catch (error2) {
      reject(error2);
    }
  });
}
function areCookiesEnabled() {
  if (!navigator || !navigator.cookieEnabled) {
    return false;
  }
  return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERROR_NAME = "FirebaseError";
var FirebaseError = function(_super) {
  __extends$1(FirebaseError2, _super);
  function FirebaseError2(code, message, customData) {
    var _this = _super.call(this, message) || this;
    _this.code = code;
    _this.customData = customData;
    _this.name = ERROR_NAME;
    Object.setPrototypeOf(_this, FirebaseError2.prototype);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, ErrorFactory.prototype.create);
    }
    return _this;
  }
  return FirebaseError2;
}(Error);
var ErrorFactory = function() {
  function ErrorFactory2(service, serviceName, errors) {
    this.service = service;
    this.serviceName = serviceName;
    this.errors = errors;
  }
  ErrorFactory2.prototype.create = function(code) {
    var data = [];
    for (var _i2 = 1; _i2 < arguments.length; _i2++) {
      data[_i2 - 1] = arguments[_i2];
    }
    var customData = data[0] || {};
    var fullCode = this.service + "/" + code;
    var template = this.errors[code];
    var message = template ? replaceTemplate(template, customData) : "Error";
    var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
    var error2 = new FirebaseError(fullCode, fullMessage, customData);
    return error2;
  };
  return ErrorFactory2;
}();
function replaceTemplate(template, data) {
  return template.replace(PATTERN, function(_3, key) {
    var value = data[key];
    return value != null ? String(value) : "<" + key + "?>";
  });
}
var PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function jsonEval(str) {
  return JSON.parse(str);
}
function stringify(data) {
  return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var decode = function(token2) {
  var header = {}, claims = {}, data = {}, signature = "";
  try {
    var parts = token2.split(".");
    header = jsonEval(base64Decode(parts[0]) || "");
    claims = jsonEval(base64Decode(parts[1]) || "");
    signature = parts[2];
    data = claims["d"] || {};
    delete claims["d"];
  } catch (e28) {
  }
  return {
    header,
    claims,
    data,
    signature
  };
};
var isValidFormat = function(token2) {
  var decoded = decode(token2), claims = decoded.claims;
  return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
var isAdmin = function(token2) {
  var claims = decode(token2).claims;
  return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
  if (Object.prototype.hasOwnProperty.call(obj, key)) {
    return obj[key];
  } else {
    return void 0;
  }
}
function isEmpty(obj) {
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return false;
    }
  }
  return true;
}
function map$1(obj, fn2, contextObj) {
  var res = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      res[key] = fn2.call(contextObj, obj[key], key, obj);
    }
  }
  return res;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function querystring(querystringParams) {
  var params2 = [];
  var _loop_1 = function(key2, value2) {
    if (Array.isArray(value2)) {
      value2.forEach(function(arrayVal) {
        params2.push(encodeURIComponent(key2) + "=" + encodeURIComponent(arrayVal));
      });
    } else {
      params2.push(encodeURIComponent(key2) + "=" + encodeURIComponent(value2));
    }
  };
  for (var _i2 = 0, _a2 = Object.entries(querystringParams); _i2 < _a2.length; _i2++) {
    var _b2 = _a2[_i2], key = _b2[0], value = _b2[1];
    _loop_1(key, value);
  }
  return params2.length ? "&" + params2.join("&") : "";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Sha1 = function() {
  function Sha12() {
    this.chain_ = [];
    this.buf_ = [];
    this.W_ = [];
    this.pad_ = [];
    this.inbuf_ = 0;
    this.total_ = 0;
    this.blockSize = 512 / 8;
    this.pad_[0] = 128;
    for (var i = 1; i < this.blockSize; ++i) {
      this.pad_[i] = 0;
    }
    this.reset();
  }
  Sha12.prototype.reset = function() {
    this.chain_[0] = 1732584193;
    this.chain_[1] = 4023233417;
    this.chain_[2] = 2562383102;
    this.chain_[3] = 271733878;
    this.chain_[4] = 3285377520;
    this.inbuf_ = 0;
    this.total_ = 0;
  };
  Sha12.prototype.compress_ = function(buf, offset2) {
    if (!offset2) {
      offset2 = 0;
    }
    var W3 = this.W_;
    if (typeof buf === "string") {
      for (var i = 0; i < 16; i++) {
        W3[i] = buf.charCodeAt(offset2) << 24 | buf.charCodeAt(offset2 + 1) << 16 | buf.charCodeAt(offset2 + 2) << 8 | buf.charCodeAt(offset2 + 3);
        offset2 += 4;
      }
    } else {
      for (var i = 0; i < 16; i++) {
        W3[i] = buf[offset2] << 24 | buf[offset2 + 1] << 16 | buf[offset2 + 2] << 8 | buf[offset2 + 3];
        offset2 += 4;
      }
    }
    for (var i = 16; i < 80; i++) {
      var t3 = W3[i - 3] ^ W3[i - 8] ^ W3[i - 14] ^ W3[i - 16];
      W3[i] = (t3 << 1 | t3 >>> 31) & 4294967295;
    }
    var a3 = this.chain_[0];
    var b3 = this.chain_[1];
    var c3 = this.chain_[2];
    var d3 = this.chain_[3];
    var e28 = this.chain_[4];
    var f3, k3;
    for (var i = 0; i < 80; i++) {
      if (i < 40) {
        if (i < 20) {
          f3 = d3 ^ b3 & (c3 ^ d3);
          k3 = 1518500249;
        } else {
          f3 = b3 ^ c3 ^ d3;
          k3 = 1859775393;
        }
      } else {
        if (i < 60) {
          f3 = b3 & c3 | d3 & (b3 | c3);
          k3 = 2400959708;
        } else {
          f3 = b3 ^ c3 ^ d3;
          k3 = 3395469782;
        }
      }
      var t3 = (a3 << 5 | a3 >>> 27) + f3 + e28 + k3 + W3[i] & 4294967295;
      e28 = d3;
      d3 = c3;
      c3 = (b3 << 30 | b3 >>> 2) & 4294967295;
      b3 = a3;
      a3 = t3;
    }
    this.chain_[0] = this.chain_[0] + a3 & 4294967295;
    this.chain_[1] = this.chain_[1] + b3 & 4294967295;
    this.chain_[2] = this.chain_[2] + c3 & 4294967295;
    this.chain_[3] = this.chain_[3] + d3 & 4294967295;
    this.chain_[4] = this.chain_[4] + e28 & 4294967295;
  };
  Sha12.prototype.update = function(bytes, length) {
    if (bytes == null) {
      return;
    }
    if (length === void 0) {
      length = bytes.length;
    }
    var lengthMinusBlock = length - this.blockSize;
    var n3 = 0;
    var buf = this.buf_;
    var inbuf = this.inbuf_;
    while (n3 < length) {
      if (inbuf === 0) {
        while (n3 <= lengthMinusBlock) {
          this.compress_(bytes, n3);
          n3 += this.blockSize;
        }
      }
      if (typeof bytes === "string") {
        while (n3 < length) {
          buf[inbuf] = bytes.charCodeAt(n3);
          ++inbuf;
          ++n3;
          if (inbuf === this.blockSize) {
            this.compress_(buf);
            inbuf = 0;
            break;
          }
        }
      } else {
        while (n3 < length) {
          buf[inbuf] = bytes[n3];
          ++inbuf;
          ++n3;
          if (inbuf === this.blockSize) {
            this.compress_(buf);
            inbuf = 0;
            break;
          }
        }
      }
    }
    this.inbuf_ = inbuf;
    this.total_ += length;
  };
  Sha12.prototype.digest = function() {
    var digest = [];
    var totalBits = this.total_ * 8;
    if (this.inbuf_ < 56) {
      this.update(this.pad_, 56 - this.inbuf_);
    } else {
      this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
    }
    for (var i = this.blockSize - 1; i >= 56; i--) {
      this.buf_[i] = totalBits & 255;
      totalBits /= 256;
    }
    this.compress_(this.buf_);
    var n3 = 0;
    for (var i = 0; i < 5; i++) {
      for (var j3 = 24; j3 >= 0; j3 -= 8) {
        digest[n3] = this.chain_[i] >> j3 & 255;
        ++n3;
      }
    }
    return digest;
  };
  return Sha12;
}();
function createSubscribe(executor, onNoObservers) {
  var proxy = new ObserverProxy(executor, onNoObservers);
  return proxy.subscribe.bind(proxy);
}
var ObserverProxy = function() {
  function ObserverProxy2(executor, onNoObservers) {
    var _this = this;
    this.observers = [];
    this.unsubscribes = [];
    this.observerCount = 0;
    this.task = Promise.resolve();
    this.finalized = false;
    this.onNoObservers = onNoObservers;
    this.task.then(function() {
      executor(_this);
    }).catch(function(e28) {
      _this.error(e28);
    });
  }
  ObserverProxy2.prototype.next = function(value) {
    this.forEachObserver(function(observer) {
      observer.next(value);
    });
  };
  ObserverProxy2.prototype.error = function(error2) {
    this.forEachObserver(function(observer) {
      observer.error(error2);
    });
    this.close(error2);
  };
  ObserverProxy2.prototype.complete = function() {
    this.forEachObserver(function(observer) {
      observer.complete();
    });
    this.close();
  };
  ObserverProxy2.prototype.subscribe = function(nextOrObserver, error2, complete) {
    var _this = this;
    var observer;
    if (nextOrObserver === void 0 && error2 === void 0 && complete === void 0) {
      throw new Error("Missing Observer.");
    }
    if (implementsAnyMethods(nextOrObserver, [
      "next",
      "error",
      "complete"
    ])) {
      observer = nextOrObserver;
    } else {
      observer = {
        next: nextOrObserver,
        error: error2,
        complete
      };
    }
    if (observer.next === void 0) {
      observer.next = noop$2;
    }
    if (observer.error === void 0) {
      observer.error = noop$2;
    }
    if (observer.complete === void 0) {
      observer.complete = noop$2;
    }
    var unsub = this.unsubscribeOne.bind(this, this.observers.length);
    if (this.finalized) {
      this.task.then(function() {
        try {
          if (_this.finalError) {
            observer.error(_this.finalError);
          } else {
            observer.complete();
          }
        } catch (e28) {
        }
        return;
      });
    }
    this.observers.push(observer);
    return unsub;
  };
  ObserverProxy2.prototype.unsubscribeOne = function(i) {
    if (this.observers === void 0 || this.observers[i] === void 0) {
      return;
    }
    delete this.observers[i];
    this.observerCount -= 1;
    if (this.observerCount === 0 && this.onNoObservers !== void 0) {
      this.onNoObservers(this);
    }
  };
  ObserverProxy2.prototype.forEachObserver = function(fn2) {
    if (this.finalized) {
      return;
    }
    for (var i = 0; i < this.observers.length; i++) {
      this.sendOne(i, fn2);
    }
  };
  ObserverProxy2.prototype.sendOne = function(i, fn2) {
    var _this = this;
    this.task.then(function() {
      if (_this.observers !== void 0 && _this.observers[i] !== void 0) {
        try {
          fn2(_this.observers[i]);
        } catch (e28) {
          if (typeof console !== "undefined" && console.error) {
            console.error(e28);
          }
        }
      }
    });
  };
  ObserverProxy2.prototype.close = function(err) {
    var _this = this;
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    if (err !== void 0) {
      this.finalError = err;
    }
    this.task.then(function() {
      _this.observers = void 0;
      _this.onNoObservers = void 0;
    });
  };
  return ObserverProxy2;
}();
function implementsAnyMethods(obj, methods) {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  for (var _i2 = 0, methods_1 = methods; _i2 < methods_1.length; _i2++) {
    var method = methods_1[_i2];
    if (method in obj && typeof obj[method] === "function") {
      return true;
    }
  }
  return false;
}
function noop$2() {
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var validateArgCount = function(fnName, minCount, maxCount, argCount) {
  var argError;
  if (argCount < minCount) {
    argError = "at least " + minCount;
  } else if (argCount > maxCount) {
    argError = maxCount === 0 ? "none" : "no more than " + maxCount;
  }
  if (argError) {
    var error2 = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
    throw new Error(error2);
  }
};
function errorPrefix(fnName, argumentNumber, optional) {
  var argName = "";
  switch (argumentNumber) {
    case 1:
      argName = optional ? "first" : "First";
      break;
    case 2:
      argName = optional ? "second" : "Second";
      break;
    case 3:
      argName = optional ? "third" : "Third";
      break;
    case 4:
      argName = optional ? "fourth" : "Fourth";
      break;
    default:
      throw new Error("errorPrefix called with argumentNumber > 4.  Need to update it?");
  }
  var error2 = fnName + " failed: ";
  error2 += argName + " argument ";
  return error2;
}
function validateCallback(fnName, argumentNumber, callback, optional) {
  if (optional && !callback) {
    return;
  }
  if (typeof callback !== "function") {
    throw new Error(errorPrefix(fnName, argumentNumber, optional) + "must be a valid function.");
  }
}
function validateContextObject(fnName, argumentNumber, context, optional) {
  if (optional && !context) {
    return;
  }
  if (typeof context !== "object" || context === null) {
    throw new Error(errorPrefix(fnName, argumentNumber, optional) + "must be a valid context object.");
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray$1 = function(str) {
  var out = [];
  var p3 = 0;
  for (var i = 0; i < str.length; i++) {
    var c3 = str.charCodeAt(i);
    if (c3 >= 55296 && c3 <= 56319) {
      var high = c3 - 55296;
      i++;
      assert(i < str.length, "Surrogate pair missing trail surrogate.");
      var low = str.charCodeAt(i) - 56320;
      c3 = 65536 + (high << 10) + low;
    }
    if (c3 < 128) {
      out[p3++] = c3;
    } else if (c3 < 2048) {
      out[p3++] = c3 >> 6 | 192;
      out[p3++] = c3 & 63 | 128;
    } else if (c3 < 65536) {
      out[p3++] = c3 >> 12 | 224;
      out[p3++] = c3 >> 6 & 63 | 128;
      out[p3++] = c3 & 63 | 128;
    } else {
      out[p3++] = c3 >> 18 | 240;
      out[p3++] = c3 >> 12 & 63 | 128;
      out[p3++] = c3 >> 6 & 63 | 128;
      out[p3++] = c3 & 63 | 128;
    }
  }
  return out;
};
var stringLength = function(str) {
  var p3 = 0;
  for (var i = 0; i < str.length; i++) {
    var c3 = str.charCodeAt(i);
    if (c3 < 128) {
      p3++;
    } else if (c3 < 2048) {
      p3 += 2;
    } else if (c3 >= 55296 && c3 <= 56319) {
      p3 += 4;
      i++;
    } else {
      p3 += 3;
    }
  }
  return p3;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_INTERVAL_MILLIS = 1e3;
var DEFAULT_BACKOFF_FACTOR = 2;
var MAX_VALUE_MILLIS = 4 * 60 * 60 * 1e3;
var RANDOM_FACTOR = 0.5;
function calculateBackoffMillis(backoffCount, intervalMillis, backoffFactor) {
  if (intervalMillis === void 0) {
    intervalMillis = DEFAULT_INTERVAL_MILLIS;
  }
  if (backoffFactor === void 0) {
    backoffFactor = DEFAULT_BACKOFF_FACTOR;
  }
  var currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
  var randomWait = Math.round(RANDOM_FACTOR * currBaseValue * (Math.random() - 0.5) * 2);
  return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}
var Component = function() {
  function Component2(name2, instanceFactory, type) {
    this.name = name2;
    this.instanceFactory = instanceFactory;
    this.type = type;
    this.multipleInstances = false;
    this.serviceProps = {};
    this.instantiationMode = "LAZY";
  }
  Component2.prototype.setInstantiationMode = function(mode) {
    this.instantiationMode = mode;
    return this;
  };
  Component2.prototype.setMultipleInstances = function(multipleInstances) {
    this.multipleInstances = multipleInstances;
    return this;
  };
  Component2.prototype.setServiceProps = function(props) {
    this.serviceProps = props;
    return this;
  };
  return Component2;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_ENTRY_NAME$2 = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Provider = function() {
  function Provider2(name2, container) {
    this.name = name2;
    this.container = container;
    this.component = null;
    this.instances = new Map();
    this.instancesDeferred = new Map();
  }
  Provider2.prototype.get = function(identifier) {
    if (identifier === void 0) {
      identifier = DEFAULT_ENTRY_NAME$2;
    }
    var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
    if (!this.instancesDeferred.has(normalizedIdentifier)) {
      var deferred = new Deferred();
      this.instancesDeferred.set(normalizedIdentifier, deferred);
      try {
        var instance = this.getOrInitializeService(normalizedIdentifier);
        if (instance) {
          deferred.resolve(instance);
        }
      } catch (e28) {
      }
    }
    return this.instancesDeferred.get(normalizedIdentifier).promise;
  };
  Provider2.prototype.getImmediate = function(options) {
    var _a2 = __assign({ identifier: DEFAULT_ENTRY_NAME$2, optional: false }, options), identifier = _a2.identifier, optional = _a2.optional;
    var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
    try {
      var instance = this.getOrInitializeService(normalizedIdentifier);
      if (!instance) {
        if (optional) {
          return null;
        }
        throw Error("Service " + this.name + " is not available");
      }
      return instance;
    } catch (e28) {
      if (optional) {
        return null;
      } else {
        throw e28;
      }
    }
  };
  Provider2.prototype.getComponent = function() {
    return this.component;
  };
  Provider2.prototype.setComponent = function(component) {
    var e_1, _a2;
    if (component.name !== this.name) {
      throw Error("Mismatching Component " + component.name + " for Provider " + this.name + ".");
    }
    if (this.component) {
      throw Error("Component for " + this.name + " has already been provided");
    }
    this.component = component;
    if (isComponentEager(component)) {
      try {
        this.getOrInitializeService(DEFAULT_ENTRY_NAME$2);
      } catch (e28) {
      }
    }
    try {
      for (var _b2 = __values$1(this.instancesDeferred.entries()), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
        var _d2 = __read(_c2.value, 2), instanceIdentifier = _d2[0], instanceDeferred = _d2[1];
        var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
        try {
          var instance = this.getOrInitializeService(normalizedIdentifier);
          instanceDeferred.resolve(instance);
        } catch (e28) {
        }
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (_c2 && !_c2.done && (_a2 = _b2.return))
          _a2.call(_b2);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
  };
  Provider2.prototype.clearInstance = function(identifier) {
    if (identifier === void 0) {
      identifier = DEFAULT_ENTRY_NAME$2;
    }
    this.instancesDeferred.delete(identifier);
    this.instances.delete(identifier);
  };
  Provider2.prototype.delete = function() {
    return __awaiter(this, void 0, void 0, function() {
      var services;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            services = Array.from(this.instances.values());
            return [4, Promise.all(__spread(services.filter(function(service) {
              return "INTERNAL" in service;
            }).map(function(service) {
              return service.INTERNAL.delete();
            }), services.filter(function(service) {
              return "_delete" in service;
            }).map(function(service) {
              return service._delete();
            })))];
          case 1:
            _a2.sent();
            return [2];
        }
      });
    });
  };
  Provider2.prototype.isComponentSet = function() {
    return this.component != null;
  };
  Provider2.prototype.getOrInitializeService = function(identifier) {
    var instance = this.instances.get(identifier);
    if (!instance && this.component) {
      instance = this.component.instanceFactory(this.container, normalizeIdentifierForFactory(identifier));
      this.instances.set(identifier, instance);
    }
    return instance || null;
  };
  Provider2.prototype.normalizeInstanceIdentifier = function(identifier) {
    if (this.component) {
      return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME$2;
    } else {
      return identifier;
    }
  };
  return Provider2;
}();
function normalizeIdentifierForFactory(identifier) {
  return identifier === DEFAULT_ENTRY_NAME$2 ? void 0 : identifier;
}
function isComponentEager(component) {
  return component.instantiationMode === "EAGER";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ComponentContainer = function() {
  function ComponentContainer2(name2) {
    this.name = name2;
    this.providers = new Map();
  }
  ComponentContainer2.prototype.addComponent = function(component) {
    var provider = this.getProvider(component.name);
    if (provider.isComponentSet()) {
      throw new Error("Component " + component.name + " has already been registered with " + this.name);
    }
    provider.setComponent(component);
  };
  ComponentContainer2.prototype.addOrOverwriteComponent = function(component) {
    var provider = this.getProvider(component.name);
    if (provider.isComponentSet()) {
      this.providers.delete(component.name);
    }
    this.addComponent(component);
  };
  ComponentContainer2.prototype.getProvider = function(name2) {
    if (this.providers.has(name2)) {
      return this.providers.get(name2);
    }
    var provider = new Provider(name2, this);
    this.providers.set(name2, provider);
    return provider;
  };
  ComponentContainer2.prototype.getProviders = function() {
    return Array.from(this.providers.values());
  };
  return ComponentContainer2;
}();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
function __spreadArrays() {
  for (var s3 = 0, i = 0, il = arguments.length; i < il; i++)
    s3 += arguments[i].length;
  for (var r3 = Array(s3), k3 = 0, i = 0; i < il; i++)
    for (var a3 = arguments[i], j3 = 0, jl2 = a3.length; j3 < jl2; j3++, k3++)
      r3[k3] = a3[j3];
  return r3;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a$8;
var instances = [];
var LogLevel;
(function(LogLevel2) {
  LogLevel2[LogLevel2["DEBUG"] = 0] = "DEBUG";
  LogLevel2[LogLevel2["VERBOSE"] = 1] = "VERBOSE";
  LogLevel2[LogLevel2["INFO"] = 2] = "INFO";
  LogLevel2[LogLevel2["WARN"] = 3] = "WARN";
  LogLevel2[LogLevel2["ERROR"] = 4] = "ERROR";
  LogLevel2[LogLevel2["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
var levelStringToEnum = {
  "debug": LogLevel.DEBUG,
  "verbose": LogLevel.VERBOSE,
  "info": LogLevel.INFO,
  "warn": LogLevel.WARN,
  "error": LogLevel.ERROR,
  "silent": LogLevel.SILENT
};
var defaultLogLevel = LogLevel.INFO;
var ConsoleMethod = (_a$8 = {}, _a$8[LogLevel.DEBUG] = "log", _a$8[LogLevel.VERBOSE] = "log", _a$8[LogLevel.INFO] = "info", _a$8[LogLevel.WARN] = "warn", _a$8[LogLevel.ERROR] = "error", _a$8);
var defaultLogHandler = function(instance, logType) {
  var args = [];
  for (var _i2 = 2; _i2 < arguments.length; _i2++) {
    args[_i2 - 2] = arguments[_i2];
  }
  if (logType < instance.logLevel) {
    return;
  }
  var now2 = new Date().toISOString();
  var method = ConsoleMethod[logType];
  if (method) {
    console[method].apply(console, __spreadArrays(["[" + now2 + "]  " + instance.name + ":"], args));
  } else {
    throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
  }
};
var Logger = function() {
  function Logger2(name2) {
    this.name = name2;
    this._logLevel = defaultLogLevel;
    this._logHandler = defaultLogHandler;
    this._userLogHandler = null;
    instances.push(this);
  }
  Object.defineProperty(Logger2.prototype, "logLevel", {
    get: function() {
      return this._logLevel;
    },
    set: function(val) {
      if (!(val in LogLevel)) {
        throw new TypeError('Invalid value "' + val + '" assigned to `logLevel`');
      }
      this._logLevel = val;
    },
    enumerable: false,
    configurable: true
  });
  Logger2.prototype.setLogLevel = function(val) {
    this._logLevel = typeof val === "string" ? levelStringToEnum[val] : val;
  };
  Object.defineProperty(Logger2.prototype, "logHandler", {
    get: function() {
      return this._logHandler;
    },
    set: function(val) {
      if (typeof val !== "function") {
        throw new TypeError("Value assigned to `logHandler` must be a function");
      }
      this._logHandler = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Logger2.prototype, "userLogHandler", {
    get: function() {
      return this._userLogHandler;
    },
    set: function(val) {
      this._userLogHandler = val;
    },
    enumerable: false,
    configurable: true
  });
  Logger2.prototype.debug = function() {
    var args = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      args[_i2] = arguments[_i2];
    }
    this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.DEBUG], args));
    this._logHandler.apply(this, __spreadArrays([this, LogLevel.DEBUG], args));
  };
  Logger2.prototype.log = function() {
    var args = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      args[_i2] = arguments[_i2];
    }
    this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.VERBOSE], args));
    this._logHandler.apply(this, __spreadArrays([this, LogLevel.VERBOSE], args));
  };
  Logger2.prototype.info = function() {
    var args = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      args[_i2] = arguments[_i2];
    }
    this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.INFO], args));
    this._logHandler.apply(this, __spreadArrays([this, LogLevel.INFO], args));
  };
  Logger2.prototype.warn = function() {
    var args = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      args[_i2] = arguments[_i2];
    }
    this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.WARN], args));
    this._logHandler.apply(this, __spreadArrays([this, LogLevel.WARN], args));
  };
  Logger2.prototype.error = function() {
    var args = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      args[_i2] = arguments[_i2];
    }
    this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, LogLevel.ERROR], args));
    this._logHandler.apply(this, __spreadArrays([this, LogLevel.ERROR], args));
  };
  return Logger2;
}();
function setLogLevel(level) {
  instances.forEach(function(inst) {
    inst.setLogLevel(level);
  });
}
function setUserLogHandler(logCallback, options) {
  var _loop_1 = function(instance2) {
    var customLogLevel = null;
    if (options && options.level) {
      customLogLevel = levelStringToEnum[options.level];
    }
    if (logCallback === null) {
      instance2.userLogHandler = null;
    } else {
      instance2.userLogHandler = function(instance3, level) {
        var args = [];
        for (var _i3 = 2; _i3 < arguments.length; _i3++) {
          args[_i3 - 2] = arguments[_i3];
        }
        var message = args.map(function(arg) {
          if (arg == null) {
            return null;
          } else if (typeof arg === "string") {
            return arg;
          } else if (typeof arg === "number" || typeof arg === "boolean") {
            return arg.toString();
          } else if (arg instanceof Error) {
            return arg.message;
          } else {
            try {
              return JSON.stringify(arg);
            } catch (ignored) {
              return null;
            }
          }
        }).filter(function(arg) {
          return arg;
        }).join(" ");
        if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance3.logLevel)) {
          logCallback({
            level: LogLevel[level].toLowerCase(),
            message,
            args,
            type: instance3.name
          });
        }
      };
    }
  };
  for (var _i2 = 0, instances_1 = instances; _i2 < instances_1.length; _i2++) {
    var instance = instances_1[_i2];
    _loop_1(instance);
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a$7;
var ERRORS$1 = (_a$7 = {}, _a$7["no-app"] = "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()", _a$7["bad-app-name"] = "Illegal App name: '{$appName}", _a$7["duplicate-app"] = "Firebase App named '{$appName}' already exists", _a$7["app-deleted"] = "Firebase App named '{$appName}' already deleted", _a$7["invalid-app-argument"] = "firebase.{$appName}() takes either no argument or a Firebase App instance.", _a$7["invalid-log-argument"] = "First argument to `onLog` must be null or a function.", _a$7);
var ERROR_FACTORY$5 = new ErrorFactory("app", "Firebase", ERRORS$1);
var name$1$2 = "@firebase/app";
var version$a = "0.6.13";
var name$2$1 = "@firebase/analytics";
var name$3$1 = "@firebase/auth";
var name$4$1 = "@firebase/database";
var name$5$1 = "@firebase/functions";
var name$6$1 = "@firebase/installations";
var name$7$1 = "@firebase/messaging";
var name$8$1 = "@firebase/performance";
var name$9$1 = "@firebase/remote-config";
var name$a = "@firebase/storage";
var name$b = "@firebase/firestore";
var name$c = "firebase-wrapper";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a$1$1;
var DEFAULT_ENTRY_NAME$1 = "[DEFAULT]";
var PLATFORM_LOG_STRING = (_a$1$1 = {}, _a$1$1[name$1$2] = "fire-core", _a$1$1[name$2$1] = "fire-analytics", _a$1$1[name$3$1] = "fire-auth", _a$1$1[name$4$1] = "fire-rtdb", _a$1$1[name$5$1] = "fire-fn", _a$1$1[name$6$1] = "fire-iid", _a$1$1[name$7$1] = "fire-fcm", _a$1$1[name$8$1] = "fire-perf", _a$1$1[name$9$1] = "fire-rc", _a$1$1[name$a] = "fire-gcs", _a$1$1[name$b] = "fire-fst", _a$1$1["fire-js"] = "fire-js", _a$1$1[name$c] = "fire-js-all", _a$1$1);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logger$3 = new Logger("@firebase/app");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FirebaseAppImpl = function() {
  function FirebaseAppImpl2(options, config, firebase_) {
    var e_1, _a2;
    var _this = this;
    this.firebase_ = firebase_;
    this.isDeleted_ = false;
    this.name_ = config.name;
    this.automaticDataCollectionEnabled_ = config.automaticDataCollectionEnabled || false;
    this.options_ = deepCopy(options);
    this.container = new ComponentContainer(config.name);
    this._addComponent(new Component("app", function() {
      return _this;
    }, "PUBLIC"));
    try {
      for (var _b2 = __values$1(this.firebase_.INTERNAL.components.values()), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
        var component = _c2.value;
        this._addComponent(component);
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (_c2 && !_c2.done && (_a2 = _b2.return))
          _a2.call(_b2);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
  }
  Object.defineProperty(FirebaseAppImpl2.prototype, "automaticDataCollectionEnabled", {
    get: function() {
      this.checkDestroyed_();
      return this.automaticDataCollectionEnabled_;
    },
    set: function(val) {
      this.checkDestroyed_();
      this.automaticDataCollectionEnabled_ = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FirebaseAppImpl2.prototype, "name", {
    get: function() {
      this.checkDestroyed_();
      return this.name_;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FirebaseAppImpl2.prototype, "options", {
    get: function() {
      this.checkDestroyed_();
      return this.options_;
    },
    enumerable: false,
    configurable: true
  });
  FirebaseAppImpl2.prototype.delete = function() {
    var _this = this;
    return new Promise(function(resolve) {
      _this.checkDestroyed_();
      resolve();
    }).then(function() {
      _this.firebase_.INTERNAL.removeApp(_this.name_);
      return Promise.all(_this.container.getProviders().map(function(provider) {
        return provider.delete();
      }));
    }).then(function() {
      _this.isDeleted_ = true;
    });
  };
  FirebaseAppImpl2.prototype._getService = function(name2, instanceIdentifier) {
    if (instanceIdentifier === void 0) {
      instanceIdentifier = DEFAULT_ENTRY_NAME$1;
    }
    this.checkDestroyed_();
    return this.container.getProvider(name2).getImmediate({
      identifier: instanceIdentifier
    });
  };
  FirebaseAppImpl2.prototype._removeServiceInstance = function(name2, instanceIdentifier) {
    if (instanceIdentifier === void 0) {
      instanceIdentifier = DEFAULT_ENTRY_NAME$1;
    }
    this.container.getProvider(name2).clearInstance(instanceIdentifier);
  };
  FirebaseAppImpl2.prototype._addComponent = function(component) {
    try {
      this.container.addComponent(component);
    } catch (e28) {
      logger$3.debug("Component " + component.name + " failed to register with FirebaseApp " + this.name, e28);
    }
  };
  FirebaseAppImpl2.prototype._addOrOverwriteComponent = function(component) {
    this.container.addOrOverwriteComponent(component);
  };
  FirebaseAppImpl2.prototype.checkDestroyed_ = function() {
    if (this.isDeleted_) {
      throw ERROR_FACTORY$5.create("app-deleted", { appName: this.name_ });
    }
  };
  return FirebaseAppImpl2;
}();
FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options || FirebaseAppImpl.prototype.delete || console.log("dc");
var version$1$2 = "8.0.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createFirebaseNamespaceCore(firebaseAppImpl) {
  var apps = {};
  var components = new Map();
  var namespace = {
    __esModule: true,
    initializeApp: initializeApp2,
    app,
    registerVersion,
    setLogLevel,
    onLog,
    apps: null,
    SDK_VERSION: version$1$2,
    INTERNAL: {
      registerComponent,
      removeApp,
      components,
      useAsService
    }
  };
  namespace["default"] = namespace;
  Object.defineProperty(namespace, "apps", {
    get: getApps
  });
  function removeApp(name2) {
    delete apps[name2];
  }
  function app(name2) {
    name2 = name2 || DEFAULT_ENTRY_NAME$1;
    if (!contains(apps, name2)) {
      throw ERROR_FACTORY$5.create("no-app", { appName: name2 });
    }
    return apps[name2];
  }
  app["App"] = firebaseAppImpl;
  function initializeApp2(options, rawConfig) {
    if (rawConfig === void 0) {
      rawConfig = {};
    }
    if (typeof rawConfig !== "object" || rawConfig === null) {
      var name_1 = rawConfig;
      rawConfig = { name: name_1 };
    }
    var config = rawConfig;
    if (config.name === void 0) {
      config.name = DEFAULT_ENTRY_NAME$1;
    }
    var name2 = config.name;
    if (typeof name2 !== "string" || !name2) {
      throw ERROR_FACTORY$5.create("bad-app-name", {
        appName: String(name2)
      });
    }
    if (contains(apps, name2)) {
      throw ERROR_FACTORY$5.create("duplicate-app", { appName: name2 });
    }
    var app2 = new firebaseAppImpl(options, config, namespace);
    apps[name2] = app2;
    return app2;
  }
  function getApps() {
    return Object.keys(apps).map(function(name2) {
      return apps[name2];
    });
  }
  function registerComponent(component) {
    var e_1, _a2;
    var componentName = component.name;
    if (components.has(componentName)) {
      logger$3.debug("There were multiple attempts to register component " + componentName + ".");
      return component.type === "PUBLIC" ? namespace[componentName] : null;
    }
    components.set(componentName, component);
    if (component.type === "PUBLIC") {
      var serviceNamespace = function(appArg) {
        if (appArg === void 0) {
          appArg = app();
        }
        if (typeof appArg[componentName] !== "function") {
          throw ERROR_FACTORY$5.create("invalid-app-argument", {
            appName: componentName
          });
        }
        return appArg[componentName]();
      };
      if (component.serviceProps !== void 0) {
        deepExtend(serviceNamespace, component.serviceProps);
      }
      namespace[componentName] = serviceNamespace;
      firebaseAppImpl.prototype[componentName] = function() {
        var args = [];
        for (var _i2 = 0; _i2 < arguments.length; _i2++) {
          args[_i2] = arguments[_i2];
        }
        var serviceFxn = this._getService.bind(this, componentName);
        return serviceFxn.apply(this, component.multipleInstances ? args : []);
      };
    }
    try {
      for (var _b2 = __values$1(Object.keys(apps)), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
        var appName = _c2.value;
        apps[appName]._addComponent(component);
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (_c2 && !_c2.done && (_a2 = _b2.return))
          _a2.call(_b2);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
    return component.type === "PUBLIC" ? namespace[componentName] : null;
  }
  function registerVersion(libraryKeyOrName, version2, variant) {
    var _a2;
    var library = (_a2 = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a2 !== void 0 ? _a2 : libraryKeyOrName;
    if (variant) {
      library += "-" + variant;
    }
    var libraryMismatch = library.match(/\s|\//);
    var versionMismatch = version2.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
      var warning = [
        'Unable to register library "' + library + '" with version "' + version2 + '":'
      ];
      if (libraryMismatch) {
        warning.push('library name "' + library + '" contains illegal characters (whitespace or "/")');
      }
      if (libraryMismatch && versionMismatch) {
        warning.push("and");
      }
      if (versionMismatch) {
        warning.push('version name "' + version2 + '" contains illegal characters (whitespace or "/")');
      }
      logger$3.warn(warning.join(" "));
      return;
    }
    registerComponent(new Component(library + "-version", function() {
      return { library, version: version2 };
    }, "VERSION"));
  }
  function onLog(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") {
      throw ERROR_FACTORY$5.create("invalid-log-argument", {
        appName: name
      });
    }
    setUserLogHandler(logCallback, options);
  }
  function useAsService(app2, name2) {
    if (name2 === "serverAuth") {
      return null;
    }
    var useService = name2;
    return useService;
  }
  return namespace;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createFirebaseNamespace() {
  var namespace = createFirebaseNamespaceCore(FirebaseAppImpl);
  namespace.INTERNAL = __assign(__assign({}, namespace.INTERNAL), {
    createFirebaseNamespace,
    extendNamespace,
    createSubscribe,
    ErrorFactory,
    deepExtend
  });
  function extendNamespace(props) {
    deepExtend(namespace, props);
  }
  return namespace;
}
var firebase = createFirebaseNamespace();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PlatformLoggerService = function() {
  function PlatformLoggerService2(container) {
    this.container = container;
  }
  PlatformLoggerService2.prototype.getPlatformInfoString = function() {
    var providers = this.container.getProviders();
    return providers.map(function(provider) {
      if (isVersionServiceProvider(provider)) {
        var service = provider.getImmediate();
        return service.library + "/" + service.version;
      } else {
        return null;
      }
    }).filter(function(logString) {
      return logString;
    }).join(" ");
  };
  return PlatformLoggerService2;
}();
function isVersionServiceProvider(provider) {
  var component = provider.getComponent();
  return (component === null || component === void 0 ? void 0 : component.type) === "VERSION";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(firebase2, variant) {
  firebase2.INTERNAL.registerComponent(new Component("platform-logger", function(container) {
    return new PlatformLoggerService(container);
  }, "PRIVATE"));
  firebase2.registerVersion(name$1$2, version$a, variant);
  firebase2.registerVersion("fire-js", "");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
if (isBrowser$1() && self.firebase !== void 0) {
  logger$3.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
  var sdkVersion = self.firebase.SDK_VERSION;
  if (sdkVersion && sdkVersion.indexOf("LITE") >= 0) {
    logger$3.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
  }
}
var initializeApp = firebase.initializeApp;
firebase.initializeApp = function() {
  var args = [];
  for (var _i2 = 0; _i2 < arguments.length; _i2++) {
    args[_i2] = arguments[_i2];
  }
  if (isNode()) {
    logger$3.warn(`
      Warning: This is a browser-targeted Firebase bundle but it appears it is being
      run in a Node environment.  If running in a Node environment, make sure you
      are using the bundle specified by the "main" field in package.json.
      
      If you are using Webpack, you can specify "main" as the first item in
      "resolve.mainFields":
      https://webpack.js.org/configuration/resolve/#resolvemainfields
      
      If using Rollup, use the @rollup/plugin-node-resolve plugin and specify "main"
      as the first item in "mainFields", e.g. ['main', 'module'].
      https://github.com/rollup/@rollup/plugin-node-resolve
      `);
  }
  return initializeApp.apply(void 0, args);
};
var firebase$1 = firebase;
registerCoreComponents(firebase$1);
var name$9 = "firebase";
var version$9 = "8.2.1";
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
firebase$1.registerVersion(name$9, version$9, "app");
/*! js-cookie v3.0.5 | MIT */
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}
var defaultConverter = {
  read: function(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
function init(converter, defaultAttributes) {
  function set2(name2, value, attributes) {
    if (typeof document === "undefined") {
      return;
    }
    attributes = assign({}, defaultAttributes, attributes);
    if (typeof attributes.expires === "number") {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    name2 = encodeURIComponent(name2).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = "";
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += "; " + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }
      stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
    }
    return document.cookie = name2 + "=" + converter.write(value, name2) + stringifiedAttributes;
  }
  function get2(name2) {
    if (typeof document === "undefined" || arguments.length && !name2) {
      return;
    }
    var cookies2 = document.cookie ? document.cookie.split("; ") : [];
    var jar = {};
    for (var i = 0; i < cookies2.length; i++) {
      var parts = cookies2[i].split("=");
      var value = parts.slice(1).join("=");
      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);
        if (name2 === found) {
          break;
        }
      } catch (e28) {
      }
    }
    return name2 ? jar[name2] : jar;
  }
  return Object.create({
    set: set2,
    get: get2,
    remove: function(name2, attributes) {
      set2(name2, "", assign({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function(attributes) {
      return init(this.converter, assign({}, this.attributes, attributes));
    },
    withConverter: function(converter2) {
      return init(assign({}, this.converter, converter2), this.attributes);
    }
  }, {
    attributes: { value: Object.freeze(defaultAttributes) },
    converter: { value: Object.freeze(converter) }
  });
}
var api = init(defaultConverter, { path: "/" });
function render$w(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5 12h14m0 0l-7-7m7 7l-7 7"
    })
  ]);
}
function render$v(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.869 15.46L7 22l4.588-2.753c.15-.09.225-.135.305-.152a.5.5 0 01.214 0c.08.017.155.062.305.152L17 22l-.868-6.543m.294-11.208c.154.373.45.67.824.825l1.309.542a1.525 1.525 0 01.825 1.992l-.542 1.308a1.522 1.522 0 000 1.168l.542 1.307a1.525 1.525 0 01-.826 1.993l-1.308.542c-.373.154-.67.45-.825.824l-.542 1.309a1.524 1.524 0 01-1.992.825l-1.308-.542a1.525 1.525 0 00-1.166 0l-1.31.542a1.524 1.524 0 01-1.99-.824l-.542-1.31a1.524 1.524 0 00-.824-.825l-1.31-.542a1.524 1.524 0 01-.825-1.991l.542-1.308a1.525 1.525 0 000-1.167l-.542-1.31a1.525 1.525 0 01.826-1.992l1.307-.542c.374-.154.67-.45.825-.823l.543-1.309a1.524 1.524 0 011.991-.825l1.308.542c.374.154.793.154 1.167-.001l1.31-.54a1.525 1.525 0 011.99.825l.543 1.31v-.003z"
    })
  ]);
}
function render$u(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14 21h-4m8-13A6 6 0 106 8c0 3.09-.78 5.206-1.65 6.605-.735 1.18-1.102 1.771-1.089 1.936.015.182.054.252.2.36.133.099.732.099 1.928.099H18.61c1.196 0 1.795 0 1.927-.098.147-.11.186-.179.2-.361.014-.165-.353-.755-1.088-1.936C18.78 13.206 18 11.09 18 8z"
    })
  ]);
}
function render$t(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.646 18.015a3 3 0 11-5.796 1.553m-7.793-7.955a4.007 4.007 0 011.052-3.926m9.037-1.946a2.5 2.5 0 10-3.47.93m11.643.049a4.007 4.007 0 00-2.874-2.874m.046 5.6c-.357-1.333-1.31-2.447-2.65-3.098-1.339-.65-2.955-.784-4.492-.373-1.537.412-2.87 1.336-3.704 2.57-.834 1.233-1.102 2.674-.745 4.006.59 2.204.475 3.963.102 5.299-.425 1.522-.637 2.284-.58 2.437.066.175.113.223.288.29.152.06.792-.112 2.071-.455l11.865-3.18c1.28-.342 1.92-.514 2.022-.64.117-.146.134-.212.104-.396-.027-.161-.592-.714-1.721-1.82-.991-.971-1.97-2.437-2.56-4.64z"
    })
  ]);
}
function render$s(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 21l-.1-.15c-.695-1.042-1.042-1.563-1.5-1.94a4 4 0 00-1.378-.737C8.453 18 7.827 18 6.575 18H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.874-.874C2 16.48 2 15.92 2 14.8V6.2c0-1.12 0-1.68.218-2.108a2 2 0 01.874-.874C3.52 3 4.08 3 5.2 3h.4c2.24 0 3.36 0 4.216.436a4 4 0 011.748 1.748C12 6.04 12 7.16 12 9.4M12 21V9.4M12 21l.1-.15c.695-1.042 1.042-1.563 1.5-1.94a3.999 3.999 0 011.378-.737C15.547 18 16.173 18 17.425 18H18.8c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C22 16.48 22 15.92 22 14.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874C20.48 3 19.92 3 18.8 3h-.4c-2.24 0-3.36 0-4.216.436a4 4 0 00-1.748 1.748C12 6.04 12 7.16 12 9.4"
    })
  ]);
}
function render$r(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8 21V7c0-.93 0-1.395.102-1.776a3 3 0 012.121-2.122C10.605 3 11.07 3 12 3c.93 0 1.395 0 1.777.102a3 3 0 012.12 2.122C16 5.605 16 6.07 16 7v14M5.2 21h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C22 19.48 22 18.92 22 17.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 00-.874-.874C20.48 7 19.92 7 18.8 7H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 00-.874.874C2 8.52 2 9.08 2 10.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874C3.52 21 4.08 21 5.2 21z"
    })
  ]);
}
function render$q(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 18l-6-6 6-6"
    })
  ]);
}
function render$p(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 18l6-6-6-6"
    })
  ]);
}
function render$o(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 6v6l4 2m6-2c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
    })
  ]);
}
function render$n(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 16a4 4 0 004 4h4a4 4 0 000-8h-4a4 4 0 010-8h4a4 4 0 014 4m-6-6v20"
    })
  ]);
}
function render$m(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 6a1 1 0 100-2 1 1 0 000 2zM12 13a1 1 0 100-2 1 1 0 000 2zM12 20a1 1 0 100-2 1 1 0 000 2zM19 6a1 1 0 100-2 1 1 0 000 2zM19 13a1 1 0 100-2 1 1 0 000 2zM19 20a1 1 0 100-2 1 1 0 000 2zM5 6a1 1 0 100-2 1 1 0 000 2zM5 13a1 1 0 100-2 1 1 0 000 2zM5 20a1 1 0 100-2 1 1 0 000 2z"
    })
  ]);
}
function render$l(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 13a1 1 0 100-2 1 1 0 000 2zM19 13a1 1 0 100-2 1 1 0 000 2zM5 13a1 1 0 100-2 1 1 0 000 2z"
    })
  ]);
}
function render$k(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 13a1 1 0 100-2 1 1 0 000 2zM12 6a1 1 0 100-2 1 1 0 000 2zM12 20a1 1 0 100-2 1 1 0 000 2z"
    })
  ]);
}
function render$j(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.359 6.246l-5.014 5.014m-4.858 4.858L2 11.63m20-4.68l-9.872 9.872-4.487-4.487"
    })
  ]);
}
function render$i(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2 4.6c0-.56 0-.84.109-1.054a1 1 0 01.437-.437C2.76 3 3.04 3 3.6 3h16.8c.56 0 .84 0 1.054.109a1 1 0 01.437.437C22 3.76 22 4.04 22 4.6v.67c0 .268 0 .403-.033.528-.029.11-.077.215-.141.31-.073.106-.175.194-.378.37l-6.396 5.543c-.203.176-.305.265-.377.371-.065.095-.113.2-.142.31-.033.125-.033.26-.033.529v5.227c0 .196 0 .294-.031.378a.5.5 0 01-.133.196c-.066.06-.157.096-.339.17l-3.4 1.36c-.367.146-.551.22-.699.189a.5.5 0 01-.315-.213c-.083-.126-.083-.324-.083-.72v-6.587c0-.27 0-.404-.033-.529a1.001 1.001 0 00-.141-.31c-.073-.106-.175-.194-.378-.37L2.552 6.478c-.203-.177-.305-.265-.378-.371a1 1 0 01-.141-.31C2 5.673 2 5.538 2 5.269V4.6z"
    })
  ]);
}
function render$h(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12.982 2.764c-.351-.273-.527-.41-.72-.462a1 1 0 00-.523 0c-.194.052-.37.189-.721.462L4.235 8.039c-.453.353-.68.53-.843.75a2 2 0 00-.318.65C3 9.704 3 9.991 3 10.565V17.8c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874C4.52 21 5.08 21 6.2 21h2c.28 0 .42 0 .527-.055a.5.5 0 00.218-.218C9 20.62 9 20.48 9 20.2v-6.6c0-.56 0-.84.109-1.054a1 1 0 01.437-.437C9.76 12 10.04 12 10.6 12h2.8c.56 0 .84 0 1.054.109a1 1 0 01.437.437C15 12.76 15 13.04 15 13.6v6.6c0 .28 0 .42.055.527a.5.5 0 00.218.218c.107.055.247.055.527.055h2c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874C21 19.48 21 18.92 21 17.8v-7.235c0-.574 0-.861-.074-1.126a2.002 2.002 0 00-.318-.65c-.163-.22-.39-.397-.843-.75l-6.783-5.275z"
    })
  ]);
}
function render$g(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.2 21H6.931c-.605 0-.908 0-1.049-.12a.5.5 0 01-.173-.42c.014-.183.228-.397.657-.826l8.503-8.503c.396-.396.594-.594.822-.668a1 1 0 01.618 0c.228.074.426.272.822.668L21 15v1.2M16.2 21c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C21 18.72 21 17.88 21 16.2M16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 011.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 011.311 1.311C21 5.28 21 6.12 21 7.8v8.4M10.5 8.5a2 2 0 11-4 0 2 2 0 014 0z"
    })
  ]);
}
function render$f(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.272 20.728l6.597-6.597c.396-.396.594-.594.822-.668a1 1 0 01.618 0c.228.074.426.272.822.668l6.553 6.553M14 15l2.869-2.869c.396-.396.594-.594.822-.668a1 1 0 01.618 0c.228.074.426.272.822.668L22 15M10 9a2 2 0 11-4 0 2 2 0 014 0zM6.8 21h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C22 18.72 22 17.88 22 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C2 5.28 2 6.12 2 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C4.28 21 5.12 21 6.8 21z"
    })
  ]);
}
function render$e(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17 10V8A5 5 0 007 8v2m5 4.5v2M8.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C20 18.72 20 17.88 20 16.2v-1.4c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C17.72 10 16.88 10 15.2 10H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C4 12.28 4 13.12 4 14.8v1.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C6.28 21 7.12 21 8.8 21z"
    })
  ]);
}
function render$d(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18 8l4 4m0 0l-4 4m4-4H9m6-7.796A8.383 8.383 0 0010.667 3C5.88 3 2 7.03 2 12s3.88 9 8.667 9A8.384 8.384 0 0015 19.796"
    })
  ]);
}
function render$c(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2 7l8.165 5.715c.661.463.992.695 1.351.784a2 2 0 00.968 0c.36-.09.69-.32 1.351-.784L22 7M6.8 20h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C22 17.72 22 16.88 22 15.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C19.72 4 18.88 4 17.2 4H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C2 6.28 2 7.12 2 8.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C4.28 20 5.12 20 6.8 20z"
    })
  ]);
}
function render$b(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 13a3 3 0 100-6 3 3 0 000 6z"
    }),
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 22c4-4 8-7.582 8-12a8 8 0 10-16 0c0 4.418 4 8 8 12z"
    })
  ]);
}
function render$a(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.38 8.853a14.603 14.603 0 002.847 4.01 14.603 14.603 0 004.01 2.847c.124.06.187.09.265.112.28.082.625.023.862-.147.067-.048.124-.105.239-.219.35-.35.524-.524.7-.639a2 2 0 012.18 0c.176.115.35.29.7.64l.195.194c.532.531.797.797.942 1.082a2 2 0 010 1.806c-.145.285-.41.551-.942 1.082l-.157.158c-.53.53-.795.794-1.155.997-.4.224-1.02.386-1.478.384-.413-.001-.695-.081-1.26-.241a19.038 19.038 0 01-8.283-4.874A19.039 19.039 0 013.17 7.761c-.16-.564-.24-.846-.241-1.26a3.377 3.377 0 01.384-1.477c.202-.36.467-.625.997-1.155l.157-.158c.532-.53.798-.797 1.083-.941a2 2 0 011.805 0c.286.144.551.41 1.083.942l.195.194c.35.35.524.525.638.7a2 2 0 010 2.18c-.114.177-.289.352-.638.701-.115.114-.172.172-.22.238-.17.238-.228.582-.147.862.023.08.053.142.113.266z"
    })
  ]);
}
function render$9(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4 7.8c0-1.68 0-2.52.327-3.162a3 3 0 011.311-1.311C6.28 3 7.12 3 8.8 3h6.4c1.68 0 2.52 0 3.162.327a3 3 0 011.311 1.311C20 5.28 20 6.12 20 7.8V21l-2.75-2-2.5 2L12 19l-2.75 2-2.5-2L4 21V7.8z"
    })
  ]);
}
function render$8(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 21l-4.35-4.35M19 11a8 8 0 11-16 0 8 8 0 0116 0z"
    })
  ]);
}
function render$7(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 15a3 3 0 100-6 3 3 0 000 6z"
    }),
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18.727 14.727a1.5 1.5 0 00.3 1.655l.055.054a1.816 1.816 0 010 2.573 1.818 1.818 0 01-2.573 0l-.055-.055a1.5 1.5 0 00-1.654-.3 1.5 1.5 0 00-.91 1.373v.155a1.818 1.818 0 11-3.636 0V20.1a1.5 1.5 0 00-.981-1.373 1.5 1.5 0 00-1.655.3l-.054.055a1.818 1.818 0 01-3.106-1.287 1.818 1.818 0 01.533-1.286l.054-.055a1.5 1.5 0 00.3-1.654 1.5 1.5 0 00-1.372-.91h-.155a1.818 1.818 0 110-3.636H3.9a1.5 1.5 0 001.373-.981 1.5 1.5 0 00-.3-1.655l-.055-.054A1.818 1.818 0 117.491 4.99l.054.054a1.5 1.5 0 001.655.3h.073a1.5 1.5 0 00.909-1.372v-.155a1.818 1.818 0 013.636 0V3.9a1.499 1.499 0 00.91 1.373 1.5 1.5 0 001.654-.3l.054-.055a1.817 1.817 0 012.573 0 1.819 1.819 0 010 2.573l-.055.054a1.5 1.5 0 00-.3 1.655v.073a1.5 1.5 0 001.373.909h.155a1.818 1.818 0 010 3.636H20.1a1.499 1.499 0 00-1.373.91z"
    })
  ]);
}
function render$6(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 11.5l2 2L15.5 9m4.5 3c0 4.908-5.354 8.478-7.302 9.615-.221.129-.332.194-.488.227a1.137 1.137 0 01-.42 0c-.156-.034-.267-.098-.488-.227C9.354 20.478 4 16.908 4 12V7.217c0-.799 0-1.199.13-1.542a2 2 0 01.548-.79c.276-.243.65-.383 1.398-.664l5.362-2.01c.208-.078.312-.117.419-.133a1 1 0 01.286 0c.107.016.21.055.419.133l5.362 2.01c.748.28 1.123.421 1.398.664a2 2 0 01.547.79c.131.343.131.743.131 1.542V12z"
    })
  ]);
}
function render$5(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 3h6M3 6h18m-2 0l-.701 10.52c-.105 1.578-.158 2.367-.499 2.965a3 3 0 01-1.298 1.215c-.62.3-1.41.3-2.993.3h-3.018c-1.582 0-2.373 0-2.993-.3A3 3 0 016.2 19.485c-.34-.598-.394-1.387-.499-2.966L5 6m5 4.5v5m4-5v5"
    })
  ]);
}
function render$4(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20 21c0-1.396 0-2.093-.172-2.661a4 4 0 00-2.667-2.667c-.568-.172-1.265-.172-2.661-.172h-5c-1.396 0-2.093 0-2.661.172a4 4 0 00-2.667 2.667C4 18.907 4 19.604 4 21M16.5 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z"
    })
  ]);
}
function render$3(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 15.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 00-2.667 2.667C2 18.907 2 19.604 2 21M14.5 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM11 21l3.101-.886c.149-.043.223-.064.292-.096a.998.998 0 00.175-.102c.061-.045.116-.1.225-.21l6.457-6.456a1.768 1.768 0 10-2.5-2.5l-6.457 6.457c-.11.11-.164.164-.209.225a.998.998 0 00-.102.175 2.07 2.07 0 00-.096.292L11 21z"
    })
  ]);
}
function render$2(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M22 21v-2a4.002 4.002 0 00-3-3.874M15.5 3.291a4.001 4.001 0 010 7.418M17 21c0-1.864 0-2.796-.305-3.53a4 4 0 00-2.164-2.165C13.796 15 12.864 15 11 15H8c-1.864 0-2.796 0-3.53.305a4 4 0 00-2.166 2.164C2 18.204 2 19.136 2 21M13.5 7a4 4 0 11-8 0 4 4 0 018 0z"
    })
  ]);
}
function i$2g(t3) {
  let n3 = 0;
  for (let e28 = 0; e28 < t3.length; ++e28)
    t3[e28] === "&" && ++n3;
  return n3;
}
const h$1Q = /\s*,(?![^(]*\))\s*/g, p$3V = /\s+/g;
function a$2A(t3, n3) {
  const e28 = [];
  return n3.split(h$1Q).forEach((f3) => {
    let o3 = i$2g(f3);
    if (o3) {
      if (o3 === 1) {
        t3.forEach((r3) => {
          e28.push(f3.replace("&", r3));
        });
        return;
      }
    } else {
      t3.forEach((r3) => {
        e28.push((r3 && r3 + " ") + f3);
      });
      return;
    }
    let u3 = [
      f3
    ];
    for (; o3--; ) {
      const r3 = [];
      u3.forEach((c3) => {
        t3.forEach((s3) => {
          r3.push(c3.replace("&", s3));
        });
      }), u3 = r3;
    }
    u3.forEach((r3) => e28.push(r3));
  }), e28;
}
function x$K(t3, n3) {
  const e28 = [];
  return n3.split(h$1Q).forEach((f3) => {
    t3.forEach((o3) => {
      e28.push((o3 && o3 + " ") + f3);
    });
  }), e28;
}
function E$L(t3) {
  let n3 = [""];
  return t3.forEach((e28) => {
    e28 = e28 && e28.trim(), e28 && (e28.includes("&") ? n3 = a$2A(n3, e28) : n3 = x$K(n3, e28));
  }), n3.join(", ").replace(p$3V, " ");
}
function n$2a(e28) {
  if (!e28)
    return;
  const t3 = e28.parentElement;
  t3 && t3.removeChild(e28);
}
function r$2b(e28) {
  return document.querySelector(`style[cssr-id="${e28}"]`);
}
function u$22(e28) {
  const t3 = document.createElement("style");
  return t3.setAttribute("cssr-id", e28), t3;
}
function s$2n(e28) {
  return e28 ? /^\s*@(s|m)/.test(e28) : false;
}
const w$V = /[A-Z]/g;
function l$26(n3) {
  return n3.replace(w$V, (r3) => "-" + r3.toLowerCase());
}
function C$1b(n3, r3 = "  ") {
  return typeof n3 == "object" && n3 !== null ? ` {
` + Object.entries(n3).map((f3) => r3 + `  ${l$26(f3[0])}: ${f3[1]};`).join(`
`) + `
` + r3 + "}" : `: ${n3};`;
}
function A$H(n3, r3, f3) {
  return typeof n3 == "function" ? n3({
    context: r3.context,
    props: f3
  }) : n3;
}
function b$19(n3, r3, f3, t3) {
  if (!r3)
    return "";
  const i = A$H(r3, f3, t3);
  if (!i)
    return "";
  if (typeof i == "string")
    return `${n3} {
${i}
}`;
  const u3 = Object.keys(i);
  if (u3.length === 0)
    return f3.config.keepEmptyBlock ? n3 + ` {
}` : "";
  const e28 = n3 ? [
    n3 + " {"
  ] : [];
  return u3.forEach((o3) => {
    const s3 = i[o3];
    if (o3 === "raw") {
      e28.push(`
` + s3 + `
`);
      return;
    }
    o3 = l$26(o3), s3 != null && e28.push(`  ${o3}${C$1b(s3)}`);
  }), n3 && e28.push("}"), e28.join(`
`);
}
function x$J(n3, r3, f3) {
  n3 && n3.forEach((t3) => {
    if (Array.isArray(t3))
      x$J(t3, r3, f3);
    else if (typeof t3 == "function") {
      const i = t3(r3);
      Array.isArray(i) ? x$J(i, r3, f3) : i && f3(i);
    } else
      t3 && f3(t3);
  });
}
function y$1b(n3, r3, f3, t3, i, u3) {
  const e28 = n3.$;
  let o3 = "";
  if (!e28 || typeof e28 == "string")
    s$2n(e28) ? o3 = e28 : r3.push(e28);
  else if (typeof e28 == "function") {
    const p3 = e28({
      context: t3.context,
      props: i
    });
    s$2n(p3) ? o3 = p3 : r3.push(p3);
  } else if (e28.before && e28.before(t3.context), !e28.$ || typeof e28.$ == "string")
    s$2n(e28.$) ? o3 = e28.$ : r3.push(e28.$);
  else if (e28.$) {
    const p3 = e28.$({
      context: t3.context,
      props: i
    });
    s$2n(p3) ? o3 = p3 : r3.push(p3);
  }
  const s3 = E$L(r3), c3 = b$19(s3, n3.props, t3, i);
  o3 ? (f3.push(`${o3} {`), u3 && c3 && u3.insertRule(`${o3} {
${c3}
}
`)) : (u3 && c3 && u3.insertRule(c3), !u3 && c3.length && f3.push(c3)), n3.children && x$J(n3.children, {
    context: t3.context,
    props: i
  }, (p3) => {
    if (typeof p3 == "string") {
      const g3 = b$19(s3, { raw: p3 }, t3, i);
      u3 ? u3.insertRule(g3) : f3.push(g3);
    } else
      y$1b(p3, r3, f3, t3, i, u3);
  }), r3.pop(), o3 && f3.push("}"), e28 && e28.after && e28.after(t3.context);
}
function O$F(n3, r3, f3, t3 = false) {
  const i = [];
  return y$1b(n3, [], i, r3, f3, t3 ? n3.instance.__styleSheet : void 0), t3 ? "" : i.join(`

`);
}
function c$2c(e28) {
  for (var f3 = 0, x3, a3 = 0, d3 = e28.length; d3 >= 4; ++a3, d3 -= 4)
    x3 = e28.charCodeAt(a3) & 255 | (e28.charCodeAt(++a3) & 255) << 8 | (e28.charCodeAt(++a3) & 255) << 16 | (e28.charCodeAt(++a3) & 255) << 24, x3 = (x3 & 65535) * 1540483477 + ((x3 >>> 16) * 59797 << 16), x3 ^= x3 >>> 24, f3 = (x3 & 65535) * 1540483477 + ((x3 >>> 16) * 59797 << 16) ^ (f3 & 65535) * 1540483477 + ((f3 >>> 16) * 59797 << 16);
  switch (d3) {
    case 3:
      f3 ^= (e28.charCodeAt(a3 + 2) & 255) << 16;
    case 2:
      f3 ^= (e28.charCodeAt(a3 + 1) & 255) << 8;
    case 1:
      f3 ^= e28.charCodeAt(a3) & 255, f3 = (f3 & 65535) * 1540483477 + ((f3 >>> 16) * 59797 << 16);
  }
  return f3 ^= f3 >>> 13, f3 = (f3 & 65535) * 1540483477 + ((f3 >>> 16) * 59797 << 16), ((f3 ^ f3 >>> 15) >>> 0).toString(36);
}
typeof window < "u" && (window.__cssrContext = {});
function g$1k(l3, e28, n3) {
  const { els: t3 } = e28;
  if (n3 === void 0)
    t3.forEach(n$2a), e28.els = [];
  else {
    const o3 = r$2b(n3);
    o3 && t3.includes(o3) && (n$2a(o3), e28.els = t3.filter((c3) => c3 !== o3));
  }
}
function a$2z(l3, e28) {
  l3.push(e28);
}
function v$1b(l3, e28, n3, t3, o3, c3, w3, m3, d3) {
  if (c3 && !d3) {
    if (n3 === void 0) {
      console.error("[css-render/mount]: `id` is required in `silent` mode.");
      return;
    }
    const f3 = window.__cssrContext;
    f3[n3] || (f3[n3] = true, O$F(e28, l3, t3, c3));
    return;
  }
  let r3;
  if (n3 === void 0 && (r3 = e28.render(t3), n3 = c$2c(r3)), d3) {
    d3.adapter(n3, r3 != null ? r3 : e28.render(t3));
    return;
  }
  const i = r$2b(n3);
  if (i !== null && !w3)
    return i;
  const u3 = i != null ? i : u$22(n3);
  if (r3 === void 0 && (r3 = e28.render(t3)), u3.textContent = r3, i !== null)
    return i;
  if (m3) {
    const f3 = document.head.querySelector(`meta[name="${m3}"]`);
    if (f3)
      return document.head.insertBefore(u3, f3), a$2z(e28.els, u3), u3;
  }
  return o3 ? document.head.insertBefore(u3, document.head.querySelector("style, link")) : document.head.appendChild(u3), a$2z(e28.els, u3), u3;
}
function m$2k(r3) {
  return O$F(this, this.instance, r3);
}
function d$21(r3 = {}) {
  const { id: n3, ssr: t3, props: e28, head: o3 = false, silent: s3 = false, force: i = false, anchorMetaName: a3 } = r3;
  return v$1b(this.instance, this, n3, e28, o3, s3, i, a3, t3);
}
function h$1P(r3 = {}) {
  const { id: n3 } = r3;
  g$1k(this.instance, this, n3);
}
const u$21 = function(r3, n3, t3, e28) {
  return {
    instance: r3,
    $: n3,
    props: t3,
    children: e28,
    els: [],
    render: m$2k,
    mount: d$21,
    unmount: h$1P
  };
}, w$U = function(r3, n3, t3, e28) {
  return Array.isArray(n3) ? u$21(r3, { $: null }, null, n3) : Array.isArray(t3) ? u$21(r3, n3, null, t3) : Array.isArray(e28) ? u$21(r3, n3, t3, e28) : u$21(r3, n3, t3, null);
};
function m$2j(s3 = {}) {
  let t3 = null;
  const n3 = {
    c: (...e28) => w$U(n3, ...e28),
    use: (e28, ...l3) => e28.install(n3, ...l3),
    find: r$2b,
    context: {},
    config: s3,
    get __styleSheet() {
      if (!t3) {
        const e28 = document.createElement("style");
        return document.head.appendChild(e28), t3 = document.styleSheets[document.styleSheets.length - 1], t3;
      }
      return t3;
    }
  };
  return n3;
}
function w$T(u3) {
  let m3 = ".", f3 = "__", r3 = "--", b3;
  if (u3) {
    let e28 = u3.blockPrefix;
    e28 && (m3 = e28), e28 = u3.elementPrefix, e28 && (f3 = e28), e28 = u3.modifierPrefix, e28 && (r3 = e28);
  }
  const s3 = {
    install(e28) {
      b3 = e28.c;
      const n3 = e28.context;
      n3.bem = {}, n3.bem.b = null, n3.bem.els = null;
    }
  };
  function $3(e28) {
    let n3, l3;
    return {
      before(i) {
        n3 = i.bem.b, l3 = i.bem.els, i.bem.els = null;
      },
      after(i) {
        i.bem.b = n3, i.bem.els = l3;
      },
      $({ context: i, props: t3 }) {
        return e28 = typeof e28 == "string" ? e28 : e28({ context: i, props: t3 }), i.bem.b = e28, `${(t3 == null ? void 0 : t3.bPrefix) || m3}${i.bem.b}`;
      }
    };
  }
  function c3(e28) {
    let n3;
    return {
      before(l3) {
        n3 = l3.bem.els;
      },
      after(l3) {
        l3.bem.els = n3;
      },
      $({ context: l3, props: i }) {
        return e28 = typeof e28 == "string" ? e28 : e28({ context: l3, props: i }), l3.bem.els = e28.split(",").map((t3) => t3.trim()), l3.bem.els.map((t3) => `${(i == null ? void 0 : i.bPrefix) || m3}${l3.bem.b}${f3}${t3}`).join(", ");
      }
    };
  }
  function v3(e28) {
    return {
      $({ context: n3, props: l3 }) {
        e28 = typeof e28 == "string" ? e28 : e28({ context: n3, props: l3 });
        const i = e28.split(",").map((o3) => o3.trim());
        function t3(o3) {
          return i.map((P3) => `&${(l3 == null ? void 0 : l3.bPrefix) || m3}${n3.bem.b}${o3 !== void 0 ? `${f3}${o3}` : ""}${r3}${P3}`).join(", ");
        }
        const d3 = n3.bem.els;
        if (d3 !== null) {
          return t3(d3[0]);
        } else
          return t3();
      }
    };
  }
  function E3(e28) {
    return {
      $({ context: n3, props: l3 }) {
        e28 = typeof e28 == "string" ? e28 : e28({ context: n3, props: l3 });
        const i = n3.bem.els;
        return `&:not(${(l3 == null ? void 0 : l3.bPrefix) || m3}${n3.bem.b}${i !== null && i.length > 0 ? `${f3}${i[0]}` : ""}${r3}${e28})`;
      }
    };
  }
  return Object.assign(s3, {
    cB: (...e28) => b3($3(e28[0]), e28[1], e28[2]),
    cE: (...e28) => b3(c3(e28[0]), e28[1], e28[2]),
    cM: (...e28) => b3(v3(e28[0]), e28[1], e28[2]),
    cNotM: (...e28) => b3(E3(e28[0]), e28[1], e28[2])
  }), s3;
}
const a$2y = "n", e$2e = `.${a$2y}-`, u$20 = "__", d$20 = "--", t$29 = m$2j(), c$2b = w$T({
  blockPrefix: e$2e,
  elementPrefix: u$20,
  modifierPrefix: d$20
});
t$29.use(c$2b);
const {
  c: r$2a,
  find: $$r
} = t$29, {
  cB: l$25,
  cE: M$y,
  cM: g$1j,
  cNotM: x$I
} = c$2b;
function C$1a(o3) {
  return r$2a(({
    props: {
      bPrefix: n3
    }
  }) => `${n3 || e$2e}modal, ${n3 || e$2e}drawer`, [o3]);
}
function P$V(o3) {
  return r$2a(({
    props: {
      bPrefix: n3
    }
  }) => `${n3 || e$2e}popover`, [o3]);
}
function v$1a(o3) {
  return r$2a(({
    props: {
      bPrefix: n3
    }
  }) => `&${n3 || e$2e}modal`, o3);
}
const B$U = (...o3) => r$2a(">", [l$25(...o3)]);
function _$H(o3, n3) {
  return o3 + (n3 === "default" ? "" : n3.replace(/^[a-z]/, (s3) => s3.toUpperCase()));
}
const n$29 = l$25("breadcrumb", `
 white-space: nowrap;
 cursor: default;
 line-height: var(--n-item-line-height);
`, [r$2a("ul", `
 list-style: none;
 padding: 0;
 margin: 0;
 `), r$2a("a", `
 color: inherit;
 text-decoration: inherit;
 `), l$25("breadcrumb-item", `
 font-size: var(--n-font-size);
 transition: color .3s var(--n-bezier);
 display: inline-flex;
 align-items: center;
 `, [l$25("icon", `
 font-size: 18px;
 vertical-align: -.2em;
 transition: color .3s var(--n-bezier);
 color: var(--n-item-text-color);
 `), r$2a("&:not(:last-child)", [g$1j("clickable", [M$y("link", `
 cursor: pointer;
 `, [r$2a("&:hover", `
 background-color: var(--n-item-color-hover);
 `), r$2a("&:active", `
 background-color: var(--n-item-color-pressed); 
 `)])])]), M$y("link", `
 padding: 4px;
 border-radius: var(--n-item-border-radius);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 color: var(--n-item-text-color);
 position: relative;
 `, [r$2a("&:hover", `
 color: var(--n-item-text-color-hover);
 `, [l$25("icon", `
 color: var(--n-item-text-color-hover);
 `)]), r$2a("&:active", `
 color: var(--n-item-text-color-pressed);
 `, [l$25("icon", `
 color: var(--n-item-text-color-pressed);
 `)])]), M$y("separator", `
 margin: 0 8px;
 color: var(--n-separator-color);
 transition: color .3s var(--n-bezier);
 user-select: none;
 -webkit-user-select: none;
 `), r$2a("&:last-child", [M$y("link", `
 font-weight: var(--n-font-weight-active);
 cursor: unset;
 color: var(--n-item-text-color-active);
 `, [l$25("icon", `
 color: var(--n-item-text-color-active);
 `)]), M$y("separator", `
 display: none;
 `)])])]);
function n$28(e28) {
  return e28;
}
const n$27 = n$28("n-config-provider");
const u$1$ = "n";
function a$2x(r3 = {}, m3 = {
  defaultBordered: true
}) {
  const e28 = inject(n$27, null);
  return {
    inlineThemeDisabled: e28 == null ? void 0 : e28.inlineThemeDisabled,
    mergedRtlRef: e28 == null ? void 0 : e28.mergedRtlRef,
    mergedComponentPropsRef: e28 == null ? void 0 : e28.mergedComponentPropsRef,
    mergedBreakpointsRef: e28 == null ? void 0 : e28.mergedBreakpointsRef,
    mergedBorderedRef: computed(() => {
      var d3, o3;
      const {
        bordered: n3
      } = r3;
      return n3 !== void 0 ? n3 : (o3 = (d3 = e28 == null ? void 0 : e28.mergedBorderedRef.value) !== null && d3 !== void 0 ? d3 : m3.defaultBordered) !== null && o3 !== void 0 ? o3 : true;
    }),
    mergedClsPrefixRef: e28 ? e28.mergedClsPrefixRef : shallowRef(u$1$),
    namespaceRef: computed(() => e28 == null ? void 0 : e28.mergedNamespaceRef.value)
  };
}
function g$1i() {
  const r3 = inject(n$27, null);
  return r3 ? r3.mergedClsPrefixRef : shallowRef(u$1$);
}
const u$1_ = Symbol("@css-render/vue3-ssr");
function c$2a(n3, e28) {
  return `<style cssr-id="${n3}">
${e28}
</style>`;
}
function l$24(n3, e28) {
  const r3 = inject(u$1_, null);
  if (r3 === null) {
    console.error("[css-render/vue3-ssr]: no ssr context found.");
    return;
  }
  const { styles: t3, ids: s3 } = r3;
  s3.has(n3) || t3 !== null && (s3.add(n3), t3.push(c$2a(n3, e28)));
}
const d$1$ = typeof document < "u";
function f$1Z() {
  if (d$1$)
    return;
  const n3 = inject(u$1_, null);
  if (n3 !== null)
    return {
      adapter: l$24,
      context: n3
    };
}
const e$2d = {
  fontFamily: 'v-sans, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  fontFamilyMono: "v-mono, SFMono-Regular, Menlo, Consolas, Courier, monospace",
  fontWeight: "400",
  fontWeightStrong: "500",
  cubicBezierEaseInOut: "cubic-bezier(.4, 0, .2, 1)",
  cubicBezierEaseOut: "cubic-bezier(0, 0, .2, 1)",
  cubicBezierEaseIn: "cubic-bezier(.4, 0, 1, 1)",
  borderRadius: "3px",
  borderRadiusSmall: "2px",
  fontSize: "14px",
  fontSizeMini: "12px",
  fontSizeTiny: "12px",
  fontSizeSmall: "14px",
  fontSizeMedium: "14px",
  fontSizeLarge: "15px",
  fontSizeHuge: "16px",
  lineHeight: "1.6",
  heightMini: "16px",
  heightTiny: "22px",
  heightSmall: "28px",
  heightMedium: "34px",
  heightLarge: "40px",
  heightHuge: "46px"
};
const {
  fontSize: o$1Z,
  fontFamily: e$2c,
  lineHeight: n$26
} = e$2d, r$29 = r$2a("body", `
 margin: 0;
 font-size: ${o$1Z};
 font-family: ${e$2c};
 line-height: ${n$26};
 -webkit-text-size-adjust: 100%;
 -webkit-tap-highlight-color: transparent;
`, [r$2a("input", `
 font-family: inherit;
 font-size: inherit;
 `)]);
const e$2b = "naive-ui-style";
function t$28() {
  this.__data__ = [], this.size = 0;
}
function t$27(n3, f3) {
  return n3 === f3 || n3 !== n3 && f3 !== f3;
}
function o$1Y(t3, n3) {
  for (var e28 = t3.length; e28--; )
    if (t$27(t3[e28][0], n3))
      return e28;
  return -1;
}
var i$2f = Array.prototype, l$23 = i$2f.splice;
function n$25(r3) {
  var e28 = this.__data__, a3 = o$1Y(e28, r3);
  if (a3 < 0)
    return false;
  var t3 = e28.length - 1;
  return a3 == t3 ? e28.pop() : l$23.call(e28, a3, 1), --this.size, true;
}
function i$2e(e28) {
  var t3 = this.__data__, a3 = o$1Y(t3, e28);
  return a3 < 0 ? void 0 : t3[a3][1];
}
function e$2a(t3) {
  return o$1Y(this.__data__, t3) > -1;
}
function d$1_(s3, i) {
  var t3 = this.__data__, a3 = o$1Y(t3, s3);
  return a3 < 0 ? (++this.size, t3.push([s3, i])) : t3[a3][1] = i, this;
}
function t$26(e28) {
  var o3 = -1, l3 = e28 == null ? 0 : e28.length;
  for (this.clear(); ++o3 < l3; ) {
    var r3 = e28[o3];
    this.set(r3[0], r3[1]);
  }
}
t$26.prototype.clear = t$28;
t$26.prototype.delete = n$25;
t$26.prototype.get = i$2e;
t$26.prototype.has = e$2a;
t$26.prototype.set = d$1_;
function e$29() {
  this.__data__ = new t$26(), this.size = 0;
}
function s$2m(t3) {
  var e28 = this.__data__, a3 = e28.delete(t3);
  return this.size = e28.size, a3;
}
function a$2w(t3) {
  return this.__data__.get(t3);
}
function t$25(a3) {
  return this.__data__.has(a3);
}
var l$22 = typeof global == "object" && global && global.Object === Object && global;
const e$28 = l$22;
var t$24 = typeof self == "object" && self && self.Object === Object && self, o$1X = e$28 || t$24 || Function("return this")();
const f$1Y = o$1X;
var m$2i = f$1Y.Symbol;
const t$23 = m$2i;
var o$1W = Object.prototype, c$29 = o$1W.hasOwnProperty, f$1X = o$1W.toString, r$28 = t$23 ? t$23.toStringTag : void 0;
function p$3U(t3) {
  var a3 = c$29.call(t3, r$28), n3 = t3[r$28];
  try {
    t3[r$28] = void 0;
    var i = true;
  } catch {
  }
  var g3 = f$1X.call(t3);
  return i && (a3 ? t3[r$28] = n3 : delete t3[r$28]), g3;
}
var o$1V = Object.prototype, r$27 = o$1V.toString;
function e$27(t3) {
  return r$27.call(t3);
}
var i$2d = "[object Null]", f$1W = "[object Undefined]", r$26 = t$23 ? t$23.toStringTag : void 0;
function m$2h(n3) {
  return n3 == null ? n3 === void 0 ? f$1W : i$2d : r$26 && r$26 in Object(n3) ? p$3U(n3) : e$27(n3);
}
function n$24(t3) {
  var e28 = typeof t3;
  return t3 != null && (e28 == "object" || e28 == "function");
}
var e$26 = "[object AsyncFunction]", a$2v = "[object Function]", c$28 = "[object GeneratorFunction]", i$2c = "[object Proxy]";
function g$1h(n3) {
  if (!n$24(n3))
    return false;
  var t3 = m$2h(n3);
  return t3 == a$2v || t3 == c$28 || t3 == e$26 || t3 == i$2c;
}
var r$25 = f$1Y["__core-js_shared__"];
const t$22 = r$25;
var a$2u = function() {
  var r3 = /[^.]+$/.exec(t$22 && t$22.keys && t$22.keys.IE_PROTO || "");
  return r3 ? "Symbol(src)_1." + r3 : "";
}();
function t$21(r3) {
  return !!a$2u && a$2u in r3;
}
var o$1U = Function.prototype, n$23 = o$1U.toString;
function e$25(t3) {
  if (t3 != null) {
    try {
      return n$23.call(t3);
    } catch {
    }
    try {
      return t3 + "";
    } catch {
    }
  }
  return "";
}
var p$3T = /[\\^$.*+?()[\]{}|]/g, i$2b = /^\[object .+?Constructor\]$/, s$2l = Function.prototype, c$27 = Object.prototype, f$1V = s$2l.toString, m$2g = c$27.hasOwnProperty, u$1Z = RegExp("^" + f$1V.call(m$2g).replace(p$3T, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function O$E(r3) {
  if (!n$24(r3) || t$21(r3))
    return false;
  var t3 = g$1h(r3) ? u$1Z : i$2b;
  return t3.test(e$25(r3));
}
function u$1Y(e28, n3) {
  return e28 == null ? void 0 : e28[n3];
}
function f$1U(t3, a3) {
  var e28 = u$1Y(t3, a3);
  return O$E(e28) ? e28 : void 0;
}
var a$2t = f$1U(f$1Y, "Map");
const e$24 = a$2t;
var t$20 = f$1U(Object, "create");
const r$24 = t$20;
function e$23() {
  this.__data__ = r$24 ? r$24(null) : {}, this.size = 0;
}
function s$2k(t3) {
  var e28 = this.has(t3) && delete this.__data__[t3];
  return this.size -= e28 ? 1 : 0, e28;
}
var n$22 = "__lodash_hash_undefined__", o$1T = Object.prototype, _$G = o$1T.hasOwnProperty;
function h$1O(a3) {
  var r3 = this.__data__;
  if (r$24) {
    var t3 = r3[a3];
    return t3 === n$22 ? void 0 : t3;
  }
  return _$G.call(r3, a3) ? r3[a3] : void 0;
}
var e$22 = Object.prototype, o$1S = e$22.hasOwnProperty;
function p$3S(t3) {
  var a3 = this.__data__;
  return r$24 ? a3[t3] !== void 0 : o$1S.call(a3, t3);
}
var h$1N = "__lodash_hash_undefined__";
function s$2j(t3, a3) {
  var _3 = this.__data__;
  return this.size += this.has(t3) ? 0 : 1, _3[t3] = r$24 && a3 === void 0 ? h$1N : a3, this;
}
function t$1$(o3) {
  var e28 = -1, h3 = o3 == null ? 0 : o3.length;
  for (this.clear(); ++e28 < h3; ) {
    var r3 = o3[e28];
    this.set(r3[0], r3[1]);
  }
}
t$1$.prototype.clear = e$23;
t$1$.prototype.delete = s$2k;
t$1$.prototype.get = h$1O;
t$1$.prototype.has = p$3S;
t$1$.prototype.set = s$2j;
function o$1R() {
  this.size = 0, this.__data__ = {
    hash: new t$1$(),
    map: new (e$24 || t$26)(),
    string: new t$1$()
  };
}
function e$21(t3) {
  var o3 = typeof t3;
  return o3 == "string" || o3 == "number" || o3 == "symbol" || o3 == "boolean" ? t3 !== "__proto__" : t3 === null;
}
function n$21(r3, a3) {
  var t3 = r3.__data__;
  return e$21(a3) ? t3[typeof a3 == "string" ? "string" : "hash"] : t3.map;
}
function i$2a(e28) {
  var t3 = n$21(this, e28).delete(e28);
  return this.size -= t3 ? 1 : 0, t3;
}
function r$23(t3) {
  return n$21(this, t3).get(t3);
}
function e$20(a3) {
  return n$21(this, a3).has(a3);
}
function h$1M(a3, e28) {
  var t3 = n$21(this, a3), i = t3.size;
  return t3.set(a3, e28), this.size += t3.size == i ? 0 : 1, this;
}
function e$1$(t3) {
  var o3 = -1, a3 = t3 == null ? 0 : t3.length;
  for (this.clear(); ++o3 < a3; ) {
    var p3 = t3[o3];
    this.set(p3[0], p3[1]);
  }
}
e$1$.prototype.clear = o$1R;
e$1$.prototype.delete = i$2a;
e$1$.prototype.get = r$23;
e$1$.prototype.has = e$20;
e$1$.prototype.set = h$1M;
var h$1L = 200;
function m$2f(i, s3) {
  var t3 = this.__data__;
  if (t3 instanceof t$26) {
    var a3 = t3.__data__;
    if (!e$24 || a3.length < h$1L - 1)
      return a3.push([i, s3]), this.size = ++t3.size, this;
    t3 = this.__data__ = new e$1$(a3);
  }
  return t3.set(i, s3), this.size = t3.size, this;
}
function t$1_(o3) {
  var e28 = this.__data__ = new t$26(o3);
  this.size = e28.size;
}
t$1_.prototype.clear = e$29;
t$1_.prototype.delete = s$2m;
t$1_.prototype.get = a$2w;
t$1_.prototype.has = t$25;
t$1_.prototype.set = m$2f;
var t$1Z = function() {
  try {
    var e28 = f$1U(Object, "defineProperty");
    return e28({}, "", {}), e28;
  } catch {
  }
}();
const i$29 = t$1Z;
function i$28(r3, e28, t3) {
  e28 == "__proto__" && i$29 ? i$29(r3, e28, {
    configurable: true,
    enumerable: true,
    value: t3,
    writable: true
  }) : r3[e28] = t3;
}
function m$2e(n3, f3, i) {
  (i !== void 0 && !t$27(n3[f3], i) || i === void 0 && !(f3 in n3)) && i$28(n3, f3, i);
}
function s$2i(i) {
  return function(e28, l3, f3) {
    for (var u3 = -1, r3 = Object(e28), a3 = f3(e28), n3 = a3.length; n3--; ) {
      var t3 = a3[i ? n3 : ++u3];
      if (l3(r3[t3], t3, r3) === false)
        break;
    }
    return e28;
  };
}
var a$2s = s$2i();
const o$1Q = a$2s;
var p$3R = typeof exports == "object" && exports && !exports.nodeType && exports, t$1Y = p$3R && typeof module == "object" && module && !module.nodeType && module, s$2h = t$1Y && t$1Y.exports === p$3R, n$20 = s$2h ? f$1Y.Buffer : void 0, l$21 = n$20 ? n$20.allocUnsafe : void 0;
function a$2r(e28, u3) {
  if (u3)
    return e28.slice();
  var o3 = e28.length, r3 = l$21 ? l$21(o3) : new e28.constructor(o3);
  return e28.copy(r3), r3;
}
var t$1X = f$1Y.Uint8Array;
const o$1P = t$1X;
function o$1O(t3) {
  var e28 = new t3.constructor(t3.byteLength);
  return new o$1P(e28).set(new o$1P(t3)), e28;
}
function u$1X(f3, e28) {
  var n3 = e28 ? o$1O(f3.buffer) : f3.buffer;
  return new f3.constructor(n3, f3.byteOffset, f3.length);
}
function h$1K(t3, e28) {
  var n3 = -1, l3 = t3.length;
  for (e28 || (e28 = Array(l3)); ++n3 < l3; )
    e28[n3] = t3[n3];
  return e28;
}
var r$22 = Object.create, u$1W = function() {
  function e28() {
  }
  return function(t3) {
    if (!n$24(t3))
      return {};
    if (r$22)
      return r$22(t3);
    e28.prototype = t3;
    var n3 = new e28();
    return e28.prototype = void 0, n3;
  };
}();
const o$1N = u$1W;
function e$1_(r3, n3) {
  return function(t3) {
    return r3(n3(t3));
  };
}
var e$1Z = e$1_(Object.getPrototypeOf, Object);
const r$21 = e$1Z;
var p$3Q = Object.prototype;
function e$1Y(t3) {
  var o3 = t3 && t3.constructor, r3 = typeof o3 == "function" && o3.prototype || p$3Q;
  return t3 === r3;
}
function p$3P(t3) {
  return typeof t3.constructor == "function" && !e$1Y(t3) ? o$1N(r$21(t3)) : {};
}
function e$1X(t3) {
  return t3 != null && typeof t3 == "object";
}
var s$2g = "[object Arguments]";
function m$2d(r3) {
  return e$1X(r3) && m$2h(r3) == s$2g;
}
var t$1W = Object.prototype, n$1$ = t$1W.hasOwnProperty, s$2f = t$1W.propertyIsEnumerable, a$2q = m$2d(function() {
  return arguments;
}()) ? m$2d : function(r3) {
  return e$1X(r3) && n$1$.call(r3, "callee") && !s$2f.call(r3, "callee");
};
const m$2c = a$2q;
var r$20 = Array.isArray;
const a$2p = r$20;
var n$1_ = 9007199254740991;
function r$1$(t3) {
  return typeof t3 == "number" && t3 > -1 && t3 % 1 == 0 && t3 <= n$1_;
}
function e$1W(r3) {
  return r3 != null && r$1$(r3.length) && !g$1h(r3);
}
function f$1T(r3) {
  return e$1X(r3) && e$1W(r3);
}
function e$1V() {
  return false;
}
var r$1_ = typeof exports == "object" && exports && !exports.nodeType && exports, e$1U = r$1_ && typeof module == "object" && module && !module.nodeType && module, u$1V = e$1U && e$1U.exports === r$1_, o$1M = u$1V ? f$1Y.Buffer : void 0, s$2e = o$1M ? o$1M.isBuffer : void 0, p$3O = s$2e || e$1V;
const m$2b = p$3O;
var i$27 = "[object Object]", f$1S = Function.prototype, p$3N = Object.prototype, e$1T = f$1S.toString, u$1U = p$3N.hasOwnProperty, b$18 = e$1T.call(Object);
function O$D(r3) {
  if (!e$1X(r3) || m$2h(r3) != i$27)
    return false;
  var o3 = r$21(r3);
  if (o3 === null)
    return true;
  var t3 = u$1U.call(o3, "constructor") && o3.constructor;
  return typeof t3 == "function" && t3 instanceof t3 && e$1T.call(t3) == b$18;
}
var g$1g = "[object Arguments]", b$17 = "[object Array]", c$26 = "[object Boolean]", j$u = "[object Date]", n$1Z = "[object Error]", T$O = "[object Function]", i$26 = "[object Map]", y$1a = "[object Number]", p$3M = "[object Object]", A$G = "[object RegExp]", f$1R = "[object Set]", u$1T = "[object String]", m$2a = "[object WeakMap]", s$2d = "[object ArrayBuffer]", l$20 = "[object DataView]", d$1Z = "[object Float32Array]", I$J = "[object Float64Array]", U$B = "[object Int8Array]", k$M = "[object Int16Array]", w$S = "[object Int32Array]", x$H = "[object Uint8Array]", B$T = "[object Uint8ClampedArray]", F$F = "[object Uint16Array]", M$x = "[object Uint32Array]", a$2o = {};
a$2o[d$1Z] = a$2o[I$J] = a$2o[U$B] = a$2o[k$M] = a$2o[w$S] = a$2o[x$H] = a$2o[B$T] = a$2o[F$F] = a$2o[M$x] = true;
a$2o[g$1g] = a$2o[b$17] = a$2o[s$2d] = a$2o[c$26] = a$2o[l$20] = a$2o[j$u] = a$2o[n$1Z] = a$2o[T$O] = a$2o[i$26] = a$2o[y$1a] = a$2o[p$3M] = a$2o[A$G] = a$2o[f$1R] = a$2o[u$1T] = a$2o[m$2a] = false;
function E$K(t3) {
  return e$1X(t3) && r$1$(t3.length) && !!a$2o[m$2h(t3)];
}
function t$1V(n3) {
  return function(r3) {
    return n3(r3);
  };
}
var t$1U = typeof exports == "object" && exports && !exports.nodeType && exports, e$1S = t$1U && typeof module == "object" && module && !module.nodeType && module, u$1S = e$1S && e$1S.exports === t$1U, r$1Z = u$1S && e$28.process, d$1Y = function() {
  try {
    var o3 = e$1S && e$1S.require && e$1S.require("util").types;
    return o3 || r$1Z && r$1Z.binding && r$1Z.binding("util");
  } catch {
  }
}();
const n$1Y = d$1Y;
var a$2n = n$1Y && n$1Y.isTypedArray, o$1L = a$2n ? t$1V(a$2n) : E$K;
const i$25 = o$1L;
function n$1X(r3, t3) {
  if (!(t3 === "constructor" && typeof r3[t3] == "function") && t3 != "__proto__")
    return r3[t3];
}
var s$2c = Object.prototype, p$3L = s$2c.hasOwnProperty;
function l$1$(r3, a3, o3) {
  var n3 = r3[a3];
  (!(p$3L.call(r3, a3) && t$27(n3, o3)) || o3 === void 0 && !(a3 in r3)) && i$28(r3, a3, o3);
}
function x$G(a3, r3, i, d3) {
  var l3 = !i;
  i || (i = {});
  for (var g3 = -1, s3 = r3.length; ++g3 < s3; ) {
    var n3 = r3[g3], f3 = d3 ? d3(i[n3], a3[n3], n3, i, a3) : void 0;
    f3 === void 0 && (f3 = a3[n3]), l3 ? i$28(i, n3, f3) : l$1$(i, n3, f3);
  }
  return i;
}
function i$24(r3, t3) {
  for (var e28 = -1, a3 = Array(r3); ++e28 < r3; )
    a3[e28] = t3(e28);
  return a3;
}
var o$1K = 9007199254740991, d$1X = /^(?:0|[1-9]\d*)$/;
function f$1Q(r3, s3) {
  var t3 = typeof r3;
  return s3 = s3 != null ? s3 : o$1K, !!s3 && (t3 == "number" || t3 != "symbol" && d$1X.test(r3)) && r3 > -1 && r3 % 1 == 0 && r3 < s3;
}
var d$1W = Object.prototype, O$C = d$1W.hasOwnProperty;
function l$1_(t3, p3) {
  var o3 = a$2p(t3), i = !o3 && m$2c(t3), s3 = !o3 && !i && m$2b(t3), e28 = !o3 && !i && !s3 && i$25(t3), n3 = o3 || i || s3 || e28, f3 = n3 ? i$24(t3.length, String) : [], m3 = f3.length;
  for (var r3 in t3)
    (p3 || O$C.call(t3, r3)) && !(n3 && (r3 == "length" || s3 && (r3 == "offset" || r3 == "parent") || e28 && (r3 == "buffer" || r3 == "byteLength" || r3 == "byteOffset") || f$1Q(r3, m3))) && f3.push(r3);
  return f3;
}
function t$1T(n3) {
  var r3 = [];
  if (n3 != null)
    for (var e28 in Object(n3))
      r3.push(e28);
  return r3;
}
var e$1R = Object.prototype, p$3K = e$1R.hasOwnProperty;
function v$19(r3) {
  if (!n$24(r3))
    return t$1T(r3);
  var s3 = e$1Y(r3), o3 = [];
  for (var t3 in r3)
    t3 == "constructor" && (s3 || !p$3K.call(r3, t3)) || o3.push(t3);
  return o3;
}
function t$1S(r3) {
  return e$1W(r3) ? l$1_(r3, true) : v$19(r3);
}
function c$25(t3) {
  return x$G(t3, t$1S(t3));
}
function U$A(t3, p3, o3, v3, A3, l3, f3) {
  var i = n$1X(t3, o3), e28 = n$1X(p3, o3), s3 = f3.get(e28);
  if (s3) {
    m$2e(t3, o3, s3);
    return;
  }
  var r3 = l3 ? l3(i, e28, o3 + "", t3, p3, f3) : void 0, m3 = r3 === void 0;
  if (m3) {
    var a3 = a$2p(e28), n3 = !a3 && m$2b(e28), u3 = !a3 && !n3 && i$25(e28);
    r3 = e28, a3 || n3 || u3 ? a$2p(i) ? r3 = i : f$1T(i) ? r3 = h$1K(i) : n3 ? (m3 = false, r3 = a$2r(e28, true)) : u3 ? (m3 = false, r3 = u$1X(e28, true)) : r3 = [] : O$D(e28) || m$2c(e28) ? (r3 = i, m$2c(i) ? r3 = c$25(i) : (!n$24(i) || g$1h(i)) && (r3 = p$3P(e28))) : m3 = false;
  }
  m3 && (f3.set(e28, r3), A3(r3, e28, v3, l3, f3), f3.delete(e28)), m$2e(t3, o3, r3);
}
function D$M(f3, r3, e28, n3, i) {
  f3 !== r3 && o$1Q(r3, function(o3, m3) {
    if (i || (i = new t$1_()), n$24(o3))
      U$A(f3, r3, m3, e28, D$M, n3, i);
    else {
      var p3 = n3 ? n3(n$1X(f3, m3), o3, m3 + "", f3, r3, i) : void 0;
      p3 === void 0 && (p3 = o3), m$2e(f3, m3, p3);
    }
  }, t$1S);
}
function e$1Q(t3) {
  return t3;
}
function t$1R(l3, c3, e28) {
  switch (e28.length) {
    case 0:
      return l3.call(c3);
    case 1:
      return l3.call(c3, e28[0]);
    case 2:
      return l3.call(c3, e28[0], e28[1]);
    case 3:
      return l3.call(c3, e28[0], e28[1], e28[2]);
  }
  return l3.apply(c3, e28);
}
var o$1J = Math.max;
function d$1V(i, e28, g3) {
  return e28 = o$1J(e28 === void 0 ? i.length - 1 : e28, 0), function() {
    for (var n3 = arguments, r3 = -1, h3 = o$1J(n3.length - e28, 0), l3 = Array(h3); ++r3 < h3; )
      l3[r3] = n3[e28 + r3];
    r3 = -1;
    for (var a3 = Array(e28 + 1); ++r3 < e28; )
      a3[r3] = n3[r3];
    return a3[e28] = g3(l3), t$1R(i, this, a3);
  };
}
function t$1Q(n3) {
  return function() {
    return n3;
  };
}
var i$23 = i$29 ? function(e28, r3) {
  return i$29(e28, "toString", {
    configurable: true,
    enumerable: false,
    value: t$1Q(r3),
    writable: true
  });
} : e$1Q;
const m$29 = i$23;
var u$1R = 800, i$22 = 16, o$1I = Date.now;
function s$2b(e28) {
  var n3 = 0, t3 = 0;
  return function() {
    var a3 = o$1I(), r3 = i$22 - (a3 - t3);
    if (t3 = a3, r3 > 0) {
      if (++n3 >= u$1R)
        return arguments[0];
    } else
      n3 = 0;
    return e28.apply(void 0, arguments);
  };
}
var r$1Y = s$2b(m$29);
const i$21 = r$1Y;
function n$1W(t3, r3) {
  return i$21(d$1V(t3, r3, e$1Q), t3 + "");
}
function u$1Q(f3, t3, r3) {
  if (!n$24(r3))
    return false;
  var e28 = typeof t3;
  return (e28 == "number" ? e$1W(r3) && f$1Q(t3, r3.length) : e28 == "string" && t3 in r3) ? t$27(r3[t3], f3) : false;
}
function h$1J(d3) {
  return n$1W(function(i, e28) {
    var f3 = -1, n3 = e28.length, t3 = n3 > 1 ? e28[n3 - 1] : void 0, r3 = n3 > 2 ? e28[2] : void 0;
    for (t3 = d3.length > 3 && typeof t3 == "function" ? (n3--, t3) : void 0, r3 && u$1Q(e28[0], e28[1], r3) && (t3 = n3 < 3 ? void 0 : t3, n3 = 1), i = Object(i); ++f3 < n3; ) {
      var a3 = e28[f3];
      a3 && d3(i, a3, f3, t3);
    }
    return i;
  });
}
var a$2m = h$1J(function(e28, r3, o3) {
  D$M(e28, r3, o3);
});
const g$1f = a$2m;
function G$w(n3) {
  return n3;
}
function _$F(n3, t3, d3, i, p3, s3) {
  const l3 = f$1Z(), e28 = inject(n$27, null);
  if (d3) {
    const o3 = () => {
      const r3 = s3 == null ? void 0 : s3.value;
      d3.mount({
        id: r3 === void 0 ? t3 : r3 + t3,
        head: true,
        props: {
          bPrefix: r3 ? `.${r3}-` : void 0
        },
        anchorMetaName: e$2b,
        ssr: l3
      }), e28 != null && e28.preflightStyleDisabled || r$29.mount({
        id: "n-global",
        head: true,
        anchorMetaName: e$2b,
        ssr: l3
      });
    };
    l3 ? o3() : onBeforeMount(o3);
  }
  return computed(() => {
    var o3;
    const {
      theme: {
        common: r3,
        self: g3,
        peers: b3 = {}
      } = {},
      themeOverrides: f3 = {},
      builtinThemeOverrides: c3 = {}
    } = p3, {
      common: O3,
      peers: h3
    } = f3, {
      common: S3 = void 0,
      [n3]: {
        common: C3 = void 0,
        self: T3 = void 0,
        peers: j3 = {}
      } = {}
    } = (e28 == null ? void 0 : e28.mergedThemeRef.value) || {}, {
      common: M3 = void 0,
      [n3]: u3 = {}
    } = (e28 == null ? void 0 : e28.mergedThemeOverridesRef.value) || {}, {
      common: N3,
      peers: P3 = {}
    } = u3, a3 = g$1f({}, r3 || C3 || S3 || i.common, M3, N3, O3), y3 = g$1f((o3 = g3 || T3 || i.self) === null || o3 === void 0 ? void 0 : o3(a3), c3, u3, f3);
    return {
      common: a3,
      self: y3,
      peers: g$1f({}, i.peers, j3, b3),
      peerOverrides: g$1f({}, c3.peers, P3, h3)
    };
  });
}
_$F.props = {
  theme: Object,
  themeOverrides: Object,
  builtinThemeOverrides: Object
};
function s$2a(r3, e28) {
  console.error(`[naive/${r3}]: ${e28}`);
}
function t$1P(r3, e28) {
  throw new Error(`[naive/${r3}]: ${e28}`);
}
function E$J(v3, o3, i, p3) {
  var s3;
  i || t$1P("useThemeClass", "cssVarsRef is not passed");
  const t3 = (s3 = inject(n$27, null)) === null || s3 === void 0 ? void 0 : s3.mergedThemeHashRef, n3 = ref$1(""), y3 = f$1Z();
  let r3;
  const C3 = `__${v3}`, T3 = () => {
    let e28 = C3;
    const m3 = o3 ? o3.value : void 0, l3 = t3 == null ? void 0 : t3.value;
    l3 && (e28 += "-" + l3), m3 && (e28 += "-" + m3);
    const {
      themeOverrides: a3,
      builtinThemeOverrides: f3
    } = p3;
    a3 && (e28 += "-" + c$2c(JSON.stringify(a3))), f3 && (e28 += "-" + c$2c(JSON.stringify(f3))), n3.value = e28, r3 = () => {
      const d3 = i.value;
      let u3 = "";
      for (const c3 in d3)
        u3 += `${c3}: ${d3[c3]};`;
      r$2a(`.${e28}`, u3).mount({
        id: e28,
        ssr: y3
      }), r3 = void 0;
    };
  };
  return watchEffect(() => {
    T3();
  }), {
    themeClass: n3,
    onRender: () => {
      r3 == null || r3();
    }
  };
}
const t$1O = {
  fontWeightActive: "400"
};
const e$1P = {
  black: "#000",
  silver: "#C0C0C0",
  gray: "#808080",
  white: "#FFF",
  maroon: "#800000",
  red: "#F00",
  purple: "#800080",
  fuchsia: "#F0F",
  green: "#008000",
  lime: "#0F0",
  olive: "#808000",
  yellow: "#FF0",
  navy: "#000080",
  blue: "#00F",
  teal: "#008080",
  aqua: "#0FF",
  transparent: "#0000"
};
const f$1P = "^\\s*", x$F = "\\s*$", h$1I = "\\s*((\\.\\d+)|(\\d+(\\.\\d*)?))%\\s*", s$29 = "\\s*((\\.\\d+)|(\\d+(\\.\\d*)?))\\s*", l$1Z = "([0-9A-Fa-f])", a$2l = "([0-9A-Fa-f]{2})", F$E = new RegExp(`${f$1P}hsl\\s*\\(${s$29},${h$1I},${h$1I}\\)${x$F}`), C$19 = new RegExp(`${f$1P}hsv\\s*\\(${s$29},${h$1I},${h$1I}\\)${x$F}`), I$I = new RegExp(`${f$1P}hsla\\s*\\(${s$29},${h$1I},${h$1I},${s$29}\\)${x$F}`), M$w = new RegExp(`${f$1P}hsva\\s*\\(${s$29},${h$1I},${h$1I},${s$29}\\)${x$F}`), N$H = new RegExp(`${f$1P}rgb\\s*\\(${s$29},${s$29},${s$29}\\)${x$F}`), U$z = new RegExp(`${f$1P}rgba\\s*\\(${s$29},${s$29},${s$29},${s$29}\\)${x$F}`), m$28 = new RegExp(`${f$1P}#${l$1Z}${l$1Z}${l$1Z}${x$F}`), y$19 = new RegExp(`${f$1P}#${a$2l}${a$2l}${a$2l}${x$F}`), S$P = new RegExp(`${f$1P}#${l$1Z}${l$1Z}${l$1Z}${l$1Z}${x$F}`), E$I = new RegExp(`${f$1P}#${a$2l}${a$2l}${a$2l}${a$2l}${x$F}`);
function u$1P(r3) {
  return parseInt(r3, 16);
}
function q$D(r3) {
  try {
    let e28;
    if (e28 = I$I.exec(r3))
      return [
        c$24(e28[1]),
        i$20(e28[5]),
        i$20(e28[9]),
        g$1e(e28[13])
      ];
    if (e28 = F$E.exec(r3))
      return [c$24(e28[1]), i$20(e28[5]), i$20(e28[9]), 1];
    throw new Error(`[seemly/hsla]: Invalid color value ${r3}.`);
  } catch (e28) {
    throw e28;
  }
}
function B$S(r3) {
  try {
    let e28;
    if (e28 = M$w.exec(r3))
      return [
        c$24(e28[1]),
        i$20(e28[5]),
        i$20(e28[9]),
        g$1e(e28[13])
      ];
    if (e28 = C$19.exec(r3))
      return [c$24(e28[1]), i$20(e28[5]), i$20(e28[9]), 1];
    throw new Error(`[seemly/hsva]: Invalid color value ${r3}.`);
  } catch (e28) {
    throw e28;
  }
}
function p$3J(r3) {
  try {
    let e28;
    if (e28 = y$19.exec(r3))
      return [u$1P(e28[1]), u$1P(e28[2]), u$1P(e28[3]), 1];
    if (e28 = N$H.exec(r3))
      return [$$q(e28[1]), $$q(e28[5]), $$q(e28[9]), 1];
    if (e28 = U$z.exec(r3))
      return [
        $$q(e28[1]),
        $$q(e28[5]),
        $$q(e28[9]),
        g$1e(e28[13])
      ];
    if (e28 = m$28.exec(r3))
      return [
        u$1P(e28[1] + e28[1]),
        u$1P(e28[2] + e28[2]),
        u$1P(e28[3] + e28[3]),
        1
      ];
    if (e28 = E$I.exec(r3))
      return [
        u$1P(e28[1]),
        u$1P(e28[2]),
        u$1P(e28[3]),
        g$1e(u$1P(e28[4]) / 255)
      ];
    if (e28 = S$P.exec(r3))
      return [
        u$1P(e28[1] + e28[1]),
        u$1P(e28[2] + e28[2]),
        u$1P(e28[3] + e28[3]),
        g$1e(u$1P(e28[4] + e28[4]) / 255)
      ];
    if (r3 in e$1P)
      return p$3J(e$1P[r3]);
    throw new Error(`[seemly/rgba]: Invalid color value ${r3}.`);
  } catch (e28) {
    throw e28;
  }
}
function j$t(r3) {
  return r3 > 1 ? 1 : r3 < 0 ? 0 : r3;
}
function z$v(r3, e28, t3) {
  return `rgb(${$$q(r3)}, ${$$q(e28)}, ${$$q(t3)})`;
}
function d$1U(r3, e28, t3, n3) {
  return `rgba(${$$q(r3)}, ${$$q(e28)}, ${$$q(t3)}, ${j$t(n3)})`;
}
function v$18(r3, e28, t3, n3, o3) {
  return $$q((r3 * e28 * (1 - n3) + t3 * n3) / o3);
}
function G$v(r3, e28) {
  Array.isArray(r3) || (r3 = p$3J(r3)), Array.isArray(e28) || (e28 = p$3J(e28));
  const t3 = r3[3], n3 = e28[3], o3 = g$1e(t3 + n3 - t3 * n3);
  return d$1U(v$18(r3[0], t3, e28[0], n3, o3), v$18(r3[1], t3, e28[1], n3, o3), v$18(r3[2], t3, e28[2], n3, o3), o3);
}
function J$p(r3, e28) {
  const [t3, n3, o3, R3 = 1] = Array.isArray(r3) ? r3 : p$3J(r3);
  return e28.alpha ? d$1U(t3, n3, o3, e28.alpha) : d$1U(t3, n3, o3, R3);
}
function K$r(r3, e28) {
  const [t3, n3, o3, R3 = 1] = Array.isArray(r3) ? r3 : p$3J(r3), { lightness: w3 = 1, alpha: H3 = 1 } = e28;
  return D$L([t3 * w3, n3 * w3, o3 * w3, R3 * H3]);
}
function g$1e(r3) {
  const e28 = Math.round(Number(r3) * 100) / 100;
  return e28 > 1 ? 1 : e28 < 0 ? 0 : e28;
}
function c$24(r3) {
  const e28 = Math.round(Number(r3));
  return e28 >= 360 || e28 < 0 ? 0 : e28;
}
function $$q(r3) {
  const e28 = Math.round(Number(r3));
  return e28 > 255 ? 255 : e28 < 0 ? 0 : e28;
}
function i$20(r3) {
  const e28 = Math.round(Number(r3));
  return e28 > 100 ? 100 : e28 < 0 ? 0 : e28;
}
function L$I(r3) {
  const [e28, t3, n3] = Array.isArray(r3) ? r3 : p$3J(r3);
  return z$v(e28, t3, n3);
}
function D$L(r3) {
  const [e28, t3, n3] = r3;
  return 3 in r3 ? `rgba(${$$q(e28)}, ${$$q(t3)}, ${$$q(n3)}, ${g$1e(r3[3])})` : `rgba(${$$q(e28)}, ${$$q(t3)}, ${$$q(n3)}, 1)`;
}
function O$B(r3) {
  return `hsv(${c$24(r3[0])}, ${i$20(r3[1])}%, ${i$20(r3[2])}%)`;
}
function Q$s(r3) {
  const [e28, t3, n3] = r3;
  return 3 in r3 ? `hsva(${c$24(e28)}, ${i$20(t3)}%, ${i$20(n3)}%, ${g$1e(r3[3])})` : `hsva(${c$24(e28)}, ${i$20(t3)}%, ${i$20(n3)}%, 1)`;
}
function T$N(r3) {
  return `hsl(${c$24(r3[0])}, ${i$20(r3[1])}%, ${i$20(r3[2])}%)`;
}
function W$q(r3) {
  const [e28, t3, n3] = r3;
  return 3 in r3 ? `hsla(${c$24(e28)}, ${i$20(t3)}%, ${i$20(n3)}%, ${g$1e(r3[3])})` : `hsla(${c$24(e28)}, ${i$20(t3)}%, ${i$20(n3)}%, 1)`;
}
function X$m(r3) {
  if (typeof r3 == "string") {
    let n3;
    if (n3 = y$19.exec(r3))
      return `${n3[0]}FF`;
    if (n3 = E$I.exec(r3))
      return n3[0];
    if (n3 = m$28.exec(r3))
      return `#${n3[1]}${n3[1]}${n3[2]}${n3[2]}${n3[3]}${n3[3]}FF`;
    if (n3 = S$P.exec(r3))
      return `#${n3[1]}${n3[1]}${n3[2]}${n3[2]}${n3[3]}${n3[3]}${n3[4]}${n3[4]}`;
    throw new Error(`[seemly/toHexString]: Invalid hex value ${r3}.`);
  }
  const e28 = `#${r3.slice(0, 3).map((n3) => $$q(n3).toString(16).toUpperCase().padStart(2, "0")).join("")}`, t3 = r3.length === 3 ? "FF" : $$q(r3[3] * 255).toString(16).padStart(2, "0").toUpperCase();
  return e28 + t3;
}
function Y$m(r3) {
  if (typeof r3 == "string") {
    let e28;
    if (e28 = y$19.exec(r3))
      return e28[0];
    if (e28 = E$I.exec(r3))
      return e28[0].slice(0, 7);
    if (e28 = m$28.exec(r3) || S$P.exec(r3))
      return `#${e28[1]}${e28[1]}${e28[2]}${e28[2]}${e28[3]}${e28[3]}`;
    throw new Error(`[seemly/toHexString]: Invalid hex value ${r3}.`);
  }
  return `#${r3.slice(0, 3).map((e28) => $$q(e28).toString(16).toUpperCase().padStart(2, "0")).join("")}`;
}
const r$1X = {
  neutralBase: "#FFF",
  neutralInvertBase: "#000",
  neutralTextBase: "#000",
  neutralPopover: "#fff",
  neutralCard: "#fff",
  neutralModal: "#fff",
  neutralBody: "#fff",
  alpha1: "0.82",
  alpha2: "0.72",
  alpha3: "0.38",
  alpha4: "0.24",
  alpha5: "0.18",
  alphaClose: "0.6",
  alphaDisabled: "0.5",
  alphaDisabledInput: "0.02",
  alphaPending: "0.05",
  alphaTablePending: "0.02",
  alphaPressed: "0.07",
  alphaAvatar: "0.2",
  alphaRail: "0.14",
  alphaProgressRail: ".08",
  alphaBorder: "0.12",
  alphaDivider: "0.06",
  alphaInput: "0",
  alphaAction: "0.02",
  alphaTab: "0.04",
  alphaScrollbar: "0.25",
  alphaScrollbarHover: "0.4",
  alphaCode: "0.05",
  alphaTag: "0.02",
  primaryHover: "#36ad6a",
  primaryDefault: "#18a058",
  primaryActive: "#0c7a43",
  primarySuppl: "#36ad6a",
  infoHover: "#4098fc",
  infoDefault: "#2080f0",
  infoActive: "#1060c9",
  infoSuppl: "#4098fc",
  errorHover: "#de576d",
  errorDefault: "#d03050",
  errorActive: "#ab1f3f",
  errorSuppl: "#de576d",
  warningHover: "#fcb040",
  warningDefault: "#f0a020",
  warningActive: "#c97c10",
  warningSuppl: "#fcb040",
  successHover: "#36ad6a",
  successDefault: "#18a058",
  successActive: "#0c7a43",
  successSuppl: "#36ad6a"
}, c$23 = p$3J(r$1X.neutralBase), t$1N = p$3J(r$1X.neutralInvertBase), b$16 = "rgba(" + t$1N.slice(0, 3).join(", ") + ", ";
function p$3I(l3) {
  return b$16 + String(l3) + ")";
}
function o$1H(l3) {
  const e28 = Array.from(t$1N);
  return e28[3] = Number(l3), G$v(c$23, e28);
}
const C$18 = Object.assign(Object.assign({
  name: "common"
}, e$2d), {
  baseColor: r$1X.neutralBase,
  primaryColor: r$1X.primaryDefault,
  primaryColorHover: r$1X.primaryHover,
  primaryColorPressed: r$1X.primaryActive,
  primaryColorSuppl: r$1X.primarySuppl,
  infoColor: r$1X.infoDefault,
  infoColorHover: r$1X.infoHover,
  infoColorPressed: r$1X.infoActive,
  infoColorSuppl: r$1X.infoSuppl,
  successColor: r$1X.successDefault,
  successColorHover: r$1X.successHover,
  successColorPressed: r$1X.successActive,
  successColorSuppl: r$1X.successSuppl,
  warningColor: r$1X.warningDefault,
  warningColorHover: r$1X.warningHover,
  warningColorPressed: r$1X.warningActive,
  warningColorSuppl: r$1X.warningSuppl,
  errorColor: r$1X.errorDefault,
  errorColorHover: r$1X.errorHover,
  errorColorPressed: r$1X.errorActive,
  errorColorSuppl: r$1X.errorSuppl,
  textColorBase: r$1X.neutralTextBase,
  textColor1: "rgb(31, 34, 37)",
  textColor2: "rgb(51, 54, 57)",
  textColor3: "rgb(118, 124, 130)",
  textColorDisabled: o$1H(r$1X.alpha4),
  placeholderColor: o$1H(r$1X.alpha4),
  placeholderColorDisabled: o$1H(r$1X.alpha5),
  iconColor: o$1H(r$1X.alpha4),
  iconColorHover: K$r(o$1H(r$1X.alpha4), {
    lightness: 0.75
  }),
  iconColorPressed: K$r(o$1H(r$1X.alpha4), {
    lightness: 0.9
  }),
  iconColorDisabled: o$1H(r$1X.alpha5),
  opacity1: r$1X.alpha1,
  opacity2: r$1X.alpha2,
  opacity3: r$1X.alpha3,
  opacity4: r$1X.alpha4,
  opacity5: r$1X.alpha5,
  dividerColor: "rgb(239, 239, 245)",
  borderColor: "rgb(224, 224, 230)",
  closeIconColor: o$1H(Number(r$1X.alphaClose)),
  closeIconColorHover: o$1H(Number(r$1X.alphaClose)),
  closeIconColorPressed: o$1H(Number(r$1X.alphaClose)),
  closeColorHover: "rgba(0, 0, 0, .09)",
  closeColorPressed: "rgba(0, 0, 0, .13)",
  clearColor: o$1H(r$1X.alpha4),
  clearColorHover: K$r(o$1H(r$1X.alpha4), {
    lightness: 0.75
  }),
  clearColorPressed: K$r(o$1H(r$1X.alpha4), {
    lightness: 0.9
  }),
  scrollbarColor: p$3I(r$1X.alphaScrollbar),
  scrollbarColorHover: p$3I(r$1X.alphaScrollbarHover),
  scrollbarWidth: "5px",
  scrollbarHeight: "5px",
  scrollbarBorderRadius: "5px",
  progressRailColor: o$1H(r$1X.alphaProgressRail),
  railColor: "rgb(219, 219, 223)",
  popoverColor: r$1X.neutralPopover,
  tableColor: r$1X.neutralCard,
  cardColor: r$1X.neutralCard,
  modalColor: r$1X.neutralModal,
  bodyColor: r$1X.neutralBody,
  tagColor: "#eee",
  avatarColor: o$1H(r$1X.alphaAvatar),
  invertedColor: "rgb(0, 20, 40)",
  inputColor: o$1H(r$1X.alphaInput),
  codeColor: "rgb(244, 244, 248)",
  tabColor: "rgb(247, 247, 250)",
  actionColor: "rgb(250, 250, 252)",
  tableHeaderColor: "rgb(250, 250, 252)",
  hoverColor: "rgb(243, 243, 245)",
  tableColorHover: "rgba(0, 0, 100, 0.03)",
  tableColorStriped: "rgba(0, 0, 100, 0.02)",
  pressedColor: "rgb(237, 237, 239)",
  opacityDisabled: r$1X.alphaDisabled,
  inputColorDisabled: "rgb(250, 250, 252)",
  buttonColor2: "rgba(46, 51, 56, .05)",
  buttonColor2Hover: "rgba(46, 51, 56, .09)",
  buttonColor2Pressed: "rgba(46, 51, 56, .13)",
  boxShadow1: "0 1px 2px -2px rgba(0, 0, 0, .08), 0 3px 6px 0 rgba(0, 0, 0, .06), 0 5px 12px 4px rgba(0, 0, 0, .04)",
  boxShadow2: "0 3px 6px -4px rgba(0, 0, 0, .12), 0 6px 16px 0 rgba(0, 0, 0, .08), 0 9px 28px 8px rgba(0, 0, 0, .05)",
  boxShadow3: "0 6px 16px -9px rgba(0, 0, 0, .08), 0 9px 28px 0 rgba(0, 0, 0, .05), 0 12px 48px 16px rgba(0, 0, 0, .03)"
}), d$1T = C$18;
const l$1Y = (t3) => {
  const {
    fontSize: r3,
    textColor3: e28,
    textColor2: o3,
    borderRadius: i,
    buttonColor2Hover: m3,
    buttonColor2Pressed: s3
  } = t3;
  return Object.assign(Object.assign({}, t$1O), {
    fontSize: r3,
    itemLineHeight: "1.25",
    itemTextColor: e28,
    itemTextColorHover: o3,
    itemTextColorPressed: o3,
    itemTextColorActive: o3,
    itemBorderRadius: i,
    itemColorHover: m3,
    itemColorPressed: s3,
    separatorColor: e28
  });
}, c$22 = {
  name: "Breadcrumb",
  common: d$1T,
  self: l$1Y
}, C$17 = c$22;
const I$H = n$28("n-breadcrumb"), O$A = Object.assign(Object.assign({}, _$F.props), {
  separator: {
    type: String,
    default: "/"
  }
}), D$K = defineComponent({
  name: "Breadcrumb",
  props: O$A,
  setup(e28) {
    const {
      mergedClsPrefixRef: t3,
      inlineThemeDisabled: o3
    } = a$2x(e28), m3 = _$F("Breadcrumb", "-breadcrumb", n$29, C$17, e28, t3);
    provide(I$H, {
      separatorRef: toRef$1(e28, "separator"),
      mergedClsPrefixRef: t3
    });
    const i = computed(() => {
      const {
        common: {
          cubicBezierEaseInOut: a3
        },
        self: {
          separatorColor: l3,
          itemTextColor: d3,
          itemTextColorHover: c3,
          itemTextColorPressed: u3,
          itemTextColorActive: f3,
          fontSize: b3,
          fontWeightActive: h3,
          itemBorderRadius: p3,
          itemColorHover: v3,
          itemColorPressed: C3,
          itemLineHeight: g3
        }
      } = m3.value;
      return {
        "--n-font-size": b3,
        "--n-bezier": a3,
        "--n-item-text-color": d3,
        "--n-item-text-color-hover": c3,
        "--n-item-text-color-pressed": u3,
        "--n-item-text-color-active": f3,
        "--n-separator-color": l3,
        "--n-item-color-hover": v3,
        "--n-item-color-pressed": C3,
        "--n-item-border-radius": p3,
        "--n-font-weight-active": h3,
        "--n-item-line-height": g3
      };
    }), r3 = o3 ? E$J("breadcrumb", void 0, i, e28) : void 0;
    return {
      mergedClsPrefix: t3,
      cssVars: o3 ? void 0 : i,
      themeClass: r3 == null ? void 0 : r3.themeClass,
      onRender: r3 == null ? void 0 : r3.onRender
    };
  },
  render() {
    var e28;
    return (e28 = this.onRender) === null || e28 === void 0 || e28.call(this), h$1R("nav", {
      class: [`${this.mergedClsPrefix}-breadcrumb`, this.themeClass],
      style: this.cssVars,
      "aria-label": "Breadcrumb"
    }, h$1R("ul", null, this.$slots));
  }
});
const u$1O = defineComponent({
  name: "UIBreadcrumb",
  inheritAttrs: false
}), f$1O = defineComponent(__spreadProps(__spreadValues({}, u$1O), {
  props: {
    separator: {
      type: String,
      default: "/"
    }
  },
  setup(e28) {
    return (t3, d3) => (openBlock(), createBlock(unref(D$K), { separator: e28.separator }, {
      default: withCtx(() => [
        renderSlot(t3.$slots, "default")
      ]),
      _: 3
    }, 8, ["separator"]));
  }
})), i$1$ = f$1O;
const e$1O = typeof document < "u" && typeof window < "u";
const m$27 = (e28 = e$1O ? window : null) => {
  const n3 = () => {
    const {
      hash: r3,
      host: a3,
      hostname: h3,
      href: s3,
      origin: i,
      pathname: p3,
      port: v3,
      protocol: l3,
      search: L3
    } = (e28 == null ? void 0 : e28.location) || {};
    return {
      hash: r3,
      host: a3,
      hostname: h3,
      href: s3,
      origin: i,
      pathname: p3,
      port: v3,
      protocol: l3,
      search: L3
    };
  }, t3 = () => {
    o3.value = n3();
  }, o3 = ref$1(n3());
  return onMounted(() => {
    e28 && (e28.addEventListener("popstate", t3), e28.addEventListener("hashchange", t3));
  }), onUnmounted(() => {
    e28 && (e28.removeEventListener("popstate", t3), e28.removeEventListener("hashchange", t3));
  }), o3;
};
function n$1V(r3) {
  return r3.some((e28) => isVNode(e28) ? !(e28.type === Comment || e28.type === Fragment && !n$1V(e28.children)) : true) ? r3 : null;
}
function p$3H(r3, e28) {
  return r3 && n$1V(r3()) || e28();
}
function c$21(r3, e28, t3) {
  return r3 && n$1V(r3(e28)) || t3(e28);
}
function m$26(r3, e28) {
  const t3 = r3 && n$1V(r3());
  return e28(t3 || null);
}
function s$28(r3, e28, t3) {
  const u3 = r3 && n$1V(r3(e28));
  return t3(u3 || null);
}
function a$2k(r3) {
  return !(r3 && n$1V(r3()));
}
const k$L = {
  separator: String,
  href: String,
  clickable: {
    type: Boolean,
    default: true
  },
  onClick: Function
}, I$G = defineComponent({
  name: "BreadcrumbItem",
  props: k$L,
  setup(e28, {
    slots: n3
  }) {
    const o3 = inject(I$H, null);
    if (!o3)
      return () => null;
    const {
      separatorRef: i,
      mergedClsPrefixRef: m3
    } = o3, u3 = m$27(), l3 = computed(() => e28.href ? "a" : "span"), s3 = computed(() => u3.value.href === e28.href ? "location" : null);
    return () => {
      const {
        value: r3
      } = m3;
      return h$1R("li", {
        class: [`${r3}-breadcrumb-item`, e28.clickable && `${r3}-breadcrumb-item--clickable`]
      }, h$1R(l3.value, {
        class: `${r3}-breadcrumb-item__link`,
        "aria-current": s3.value,
        href: e28.href,
        onClick: e28.onClick
      }, n3), h$1R("span", {
        class: `${r3}-breadcrumb-item__separator`,
        "aria-hidden": "true"
      }, p$3H(n3.separator, () => {
        var a3;
        return [(a3 = e28.separator) !== null && a3 !== void 0 ? a3 : i.value];
      })));
    };
  }
});
const u$1N = defineComponent({
  name: "UIBreadcrumbItem",
  inheritAttrs: false
}), i$1_ = defineComponent(__spreadProps(__spreadValues({}, u$1N), {
  props: {
    clickable: {
      type: Boolean,
      default: true
    },
    href: {
      type: String,
      default: void 0
    }
  },
  setup(e28) {
    return (r3, m3) => (openBlock(), createBlock(unref(I$G), {
      clickable: e28.clickable,
      href: e28.href
    }, {
      default: withCtx(() => [
        renderSlot(r3.$slots, "default")
      ]),
      _: 3
    }, 8, ["clickable", "href"]));
  }
})), p$3G = i$1_;
const {
  cubicBezierEaseInOut: e$1N,
  cubicBezierEaseOut: h$1H,
  cubicBezierEaseIn: r$1W
} = e$2d;
function x$E({
  overflow: p3 = "hidden",
  duration: t3 = ".3s",
  originalTransition: i = "",
  leavingDelay: n3 = "0s",
  foldPadding: s3 = false,
  enterToProps: c3 = void 0,
  leaveToProps: d3 = void 0,
  reverse: m3 = false
} = {}) {
  const a3 = m3 ? "leave" : "enter", o3 = m3 ? "enter" : "leave";
  return [r$2a(`&.fade-in-height-expand-transition-${o3}-from,
 &.fade-in-height-expand-transition-${a3}-to`, Object.assign(Object.assign({}, c3), {
    opacity: 1
  })), r$2a(`&.fade-in-height-expand-transition-${o3}-to,
 &.fade-in-height-expand-transition-${a3}-from`, Object.assign(Object.assign({}, d3), {
    opacity: 0,
    marginTop: "0 !important",
    marginBottom: "0 !important",
    paddingTop: s3 ? "0 !important" : void 0,
    paddingBottom: s3 ? "0 !important" : void 0
  })), r$2a(`&.fade-in-height-expand-transition-${o3}-active`, `
 overflow: ${p3};
 transition:
 max-height ${t3} ${e$1N} ${n3},
 opacity ${t3} ${h$1H} ${n3},
 margin-top ${t3} ${e$1N} ${n3},
 margin-bottom ${t3} ${e$1N} ${n3},
 padding-top ${t3} ${e$1N} ${n3},
 padding-bottom ${t3} ${e$1N} ${n3}
 ${i ? "," + i : ""}
 `), r$2a(`&.fade-in-height-expand-transition-${a3}-active`, `
 overflow: ${p3};
 transition:
 max-height ${t3} ${e$1N},
 opacity ${t3} ${r$1W},
 margin-top ${t3} ${e$1N},
 margin-bottom ${t3} ${e$1N},
 padding-top ${t3} ${e$1N},
 padding-bottom ${t3} ${e$1N}
 ${i ? "," + i : ""}
 `)];
}
const s$27 = l$25("collapse", "width: 100%;", [l$25("collapse-item", `
 font-size: var(--n-font-size);
 color: var(--n-text-color);
 transition:
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 margin: var(--n-item-margin);
 `, [g$1j("disabled", [M$y("header", "cursor: not-allowed;", [M$y("header-main", `
 color: var(--n-title-text-color-disabled);
 `), l$25("collapse-item-arrow", `
 color: var(--n-arrow-color-disabled);
 `)])]), l$25("collapse-item", "margin-left: 32px;"), r$2a("&:first-child", "margin-top: 0;"), r$2a("&:first-child >", [M$y("header", "padding-top: 0;")]), g$1j("left-arrow-placement", [M$y("header", [l$25("collapse-item-arrow", "margin-right: 4px;")])]), g$1j("right-arrow-placement", [M$y("header", [l$25("collapse-item-arrow", "margin-left: 4px;")])]), M$y("content-wrapper", [M$y("content-inner", "padding-top: 16px;"), x$E({
  duration: "0.15s"
})]), g$1j("active", [M$y("header", [g$1j("active", [l$25("collapse-item-arrow", "transform: rotate(90deg);")])])]), r$2a("&:not(:first-child)", "border-top: 1px solid var(--n-divider-color);"), x$I("disabled", [g$1j("trigger-area-main", [M$y("header", [M$y("header-main", "cursor: pointer;"), l$25("collapse-item-arrow", "cursor: default;")])]), g$1j("trigger-area-arrow", [M$y("header", [l$25("collapse-item-arrow", "cursor: pointer;")])]), g$1j("trigger-area-extra", [M$y("header", [M$y("header-extra", "cursor: pointer;")])])]), M$y("header", `
 font-size: var(--n-title-font-size);
 display: flex;
 flex-wrap: nowrap;
 align-items: center;
 transition: color .3s var(--n-bezier);
 position: relative;
 padding: var(--n-title-padding);
 color: var(--n-title-text-color);
 `, [M$y("header-main", `
 display: flex;
 flex-wrap: nowrap;
 align-items: center;
 font-weight: var(--n-title-font-weight);
 transition: color .3s var(--n-bezier);
 flex: 1;
 color: var(--n-title-text-color);
 `), M$y("header-extra", `
 display: flex;
 align-items: center;
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 `), l$25("collapse-item-arrow", `
 display: flex;
 transition:
 transform .15s var(--n-bezier),
 color .3s var(--n-bezier);
 font-size: 18px;
 color: var(--n-arrow-color);
 `)])])]);
function f$1N(e28, n3) {
  if (e28 === void 0)
    return false;
  if (n3) {
    const { context: { ids: t3 } } = n3;
    return t3.has(e28);
  }
  return r$2b(e28) !== null;
}
function v$17(r3, o3, c3) {
  if (!o3)
    return;
  const n3 = f$1Z(), s3 = computed(() => {
    const {
      value: t3
    } = o3;
    if (!t3)
      return;
    const e28 = t3[r3];
    if (e28)
      return e28;
  }), u3 = () => {
    watchEffect(() => {
      const {
        value: t3
      } = c3, e28 = `${t3}${r3}Rtl`;
      if (f$1N(e28, n3))
        return;
      const {
        value: f3
      } = s3;
      f3 && f3.style.mount({
        id: e28,
        head: true,
        anchorMetaName: e$2b,
        props: {
          bPrefix: t3 ? `.${t3}-` : void 0
        },
        ssr: n3
      });
    });
  };
  return n3 ? u3() : onBeforeMount(u3), s3;
}
function d$1S(u3, e28) {
  return watch(u3, (r3) => {
    r3 !== void 0 && (e28.value = r3);
  }), computed(() => u3.value === void 0 ? e28.value : u3.value);
}
const s$26 = (l3) => {
  const {
    fontWeight: i,
    textColor1: r3,
    textColor2: o3,
    textColorDisabled: t3,
    dividerColor: n3,
    fontSize: e28
  } = l3;
  return {
    titleFontSize: e28,
    titleFontWeight: i,
    dividerColor: n3,
    titleTextColor: r3,
    titleTextColorDisabled: t3,
    fontSize: e28,
    textColor: o3,
    arrowColor: o3,
    arrowColorDisabled: t3,
    itemMargin: "16px 0 0 0",
    titlePadding: "16px 0 0 0"
  };
}, C$16 = {
  name: "Collapse",
  common: d$1T,
  self: s$26
}, c$20 = C$16;
function i$1Z(r3, ...e28) {
  if (Array.isArray(r3))
    r3.forEach((a3) => i$1Z(a3, ...e28));
  else
    return r3(...e28);
}
const B$R = Object.assign(Object.assign({}, _$F.props), {
  defaultExpandedNames: {
    type: [Array, String],
    default: null
  },
  expandedNames: [Array, String],
  arrowPlacement: {
    type: String,
    default: "left"
  },
  accordion: {
    type: Boolean,
    default: false
  },
  displayDirective: {
    type: String,
    default: "if"
  },
  triggerAreas: {
    type: Array,
    default: () => ["main", "extra", "arrow"]
  },
  onItemHeaderClick: [Function, Array],
  "onUpdate:expandedNames": [Function, Array],
  onUpdateExpandedNames: [Function, Array],
  onExpandedNamesChange: {
    type: [Function, Array],
    validator: () => true,
    default: void 0
  }
}), K$q = n$28("n-collapse"), te$k = defineComponent({
  name: "Collapse",
  props: B$R,
  setup(t3, {
    slots: E3
  }) {
    const {
      mergedClsPrefixRef: s3,
      inlineThemeDisabled: u3,
      mergedRtlRef: v3
    } = a$2x(t3), x3 = ref$1(t3.defaultExpandedNames), R3 = computed(() => t3.expandedNames), g3 = d$1S(R3, x3), C3 = _$F("Collapse", "-collapse", s$27, c$20, t3, s3);
    function l3(n3) {
      const {
        "onUpdate:expandedNames": e28,
        onUpdateExpandedNames: o3,
        onExpandedNamesChange: r3
      } = t3;
      o3 && i$1Z(o3, n3), e28 && i$1Z(e28, n3), r3 && i$1Z(r3, n3), x3.value = n3;
    }
    function i(n3) {
      const {
        onItemHeaderClick: e28
      } = t3;
      e28 && i$1Z(e28, n3);
    }
    function b3(n3, e28, o3) {
      const {
        accordion: r3
      } = t3, {
        value: c3
      } = g3;
      if (r3)
        n3 ? (l3([e28]), i({
          name: e28,
          expanded: true,
          event: o3
        })) : (l3([]), i({
          name: e28,
          expanded: false,
          event: o3
        }));
      else if (!Array.isArray(c3))
        l3([e28]), i({
          name: e28,
          expanded: true,
          event: o3
        });
      else {
        const a3 = c3.slice(), f3 = a3.findIndex((m3) => e28 === m3);
        ~f3 ? (a3.splice(f3, 1), l3(a3), i({
          name: e28,
          expanded: false,
          event: o3
        })) : (a3.push(e28), l3(a3), i({
          name: e28,
          expanded: true,
          event: o3
        }));
      }
    }
    provide(K$q, {
      props: t3,
      mergedClsPrefixRef: s3,
      expandedNamesRef: g3,
      slots: E3,
      toggleItem: b3
    });
    const A3 = v$17("Collapse", v3, s3), h3 = computed(() => {
      const {
        common: {
          cubicBezierEaseInOut: n3
        },
        self: {
          titleFontWeight: e28,
          dividerColor: o3,
          titlePadding: r3,
          titleTextColor: c3,
          titleTextColorDisabled: a3,
          textColor: f3,
          arrowColor: m3,
          fontSize: w3,
          titleFontSize: I3,
          arrowColorDisabled: P3,
          itemMargin: S3
        }
      } = C3.value;
      return {
        "--n-font-size": w3,
        "--n-bezier": n3,
        "--n-text-color": f3,
        "--n-divider-color": o3,
        "--n-title-padding": r3,
        "--n-title-font-size": I3,
        "--n-title-text-color": c3,
        "--n-title-text-color-disabled": a3,
        "--n-title-font-weight": e28,
        "--n-arrow-color": m3,
        "--n-arrow-color-disabled": P3,
        "--n-item-margin": S3
      };
    }), d3 = u3 ? E$J("collapse", void 0, h3, t3) : void 0;
    return {
      rtlEnabled: A3,
      mergedTheme: C3,
      mergedClsPrefix: s3,
      cssVars: u3 ? void 0 : h3,
      themeClass: d3 == null ? void 0 : d3.themeClass,
      onRender: d3 == null ? void 0 : d3.onRender
    };
  },
  render() {
    var t3;
    return (t3 = this.onRender) === null || t3 === void 0 || t3.call(this), h$1R("div", {
      class: [`${this.mergedClsPrefix}-collapse`, this.rtlEnabled && `${this.mergedClsPrefix}-collapse--rtl`, this.themeClass],
      style: this.cssVars
    }, this.$slots);
  }
});
const c$1$ = defineComponent({
  name: "UICollapse",
  inheritAttrs: false
}), f$1M = defineComponent(__spreadProps(__spreadValues({}, c$1$), {
  props: {
    accordion: {
      type: Boolean,
      default: false
    },
    arrowPlacement: {
      type: String,
      default: "left"
    },
    defaultExpandedNames: {
      type: [String, Number, Array],
      default: void 0
    },
    displayDirective: {
      type: String,
      default: "if"
    },
    expandedNames: {
      type: [String, Number, Array],
      default: void 0
    }
  },
  emits: ["itemHeaderClick"],
  setup(e28) {
    return (a3, t3) => (openBlock(), createBlock(unref(te$k), {
      accordion: e28.accordion,
      "arrow-placement": e28.arrowPlacement,
      "default-expanded-names": e28.defaultExpandedNames,
      onItemHeaderClick: t3[0] || (t3[0] = (r3) => a3.$emit("itemHeaderClick", r3)),
      "display-directive": e28.displayDirective,
      "expanded-names": e28.expandedNames
    }, {
      default: withCtx(() => [
        renderSlot(a3.$slots, "default")
      ]),
      _: 3
    }, 8, ["accordion", "arrow-placement", "default-expanded-names", "display-directive", "expanded-names"]));
  }
})), y$18 = f$1M;
function l$1X(e28) {
  const t3 = ref$1(!!e28.value);
  if (t3.value)
    return readonly(t3);
  const u3 = watch(e28, (n3) => {
    n3 && (t3.value = true, u3());
  });
  return readonly(t3);
}
const l$1W = defineComponent({
  name: "FadeInExpandTransition",
  props: {
    appear: Boolean,
    group: Boolean,
    mode: String,
    onLeave: Function,
    onAfterLeave: Function,
    onAfterEnter: Function,
    width: Boolean,
    reverse: Boolean
  },
  setup(i, {
    slots: o3
  }) {
    function a3(t3) {
      i.width ? t3.style.maxWidth = `${t3.offsetWidth}px` : t3.style.maxHeight = `${t3.offsetHeight}px`, t3.offsetWidth;
    }
    function f3(t3) {
      i.width ? t3.style.maxWidth = "0" : t3.style.maxHeight = "0", t3.offsetWidth;
      const {
        onLeave: e28
      } = i;
      e28 && e28();
    }
    function d3(t3) {
      i.width ? t3.style.maxWidth = "" : t3.style.maxHeight = "";
      const {
        onAfterLeave: e28
      } = i;
      e28 && e28();
    }
    function s3(t3) {
      if (t3.style.transition = "none", i.width) {
        const e28 = t3.offsetWidth;
        t3.style.maxWidth = "0", t3.offsetWidth, t3.style.transition = "", t3.style.maxWidth = `${e28}px`;
      } else if (i.reverse)
        t3.style.maxHeight = `${t3.offsetHeight}px`, t3.offsetHeight, t3.style.transition = "", t3.style.maxHeight = "0";
      else {
        const e28 = t3.offsetHeight;
        t3.style.maxHeight = "0", t3.offsetWidth, t3.style.transition = "", t3.style.maxHeight = `${e28}px`;
      }
      t3.offsetWidth;
    }
    function h3(t3) {
      var e28;
      i.width ? t3.style.maxWidth = "" : i.reverse || (t3.style.maxHeight = ""), (e28 = i.onAfterEnter) === null || e28 === void 0 || e28.call(i);
    }
    return () => {
      const {
        group: t3,
        width: e28,
        appear: r3,
        mode: m3
      } = i, x3 = t3 ? TransitionGroup : Transition, n3 = {
        name: e28 ? "fade-in-width-expand-transition" : "fade-in-height-expand-transition",
        appear: r3,
        onEnter: s3,
        onAfterEnter: h3,
        onBeforeLeave: a3,
        onLeave: f3,
        onAfterLeave: d3
      };
      return t3 || (n3.mode = m3), h$1R(x3, n3, o3);
    };
  }
});
const w$R = defineComponent({
  name: "CollapseItemContent",
  props: {
    displayDirective: {
      type: String,
      required: true
    },
    show: Boolean,
    clsPrefix: {
      type: String,
      required: true
    }
  },
  setup(e28) {
    return {
      onceTrue: l$1X(toRef$1(e28, "show"))
    };
  },
  render() {
    return h$1R(l$1W, null, {
      default: () => {
        const {
          show: e28,
          displayDirective: o3,
          onceTrue: s3,
          clsPrefix: n3
        } = this, i = o3 === "show" && s3, r3 = h$1R("div", {
          class: `${n3}-collapse-item__content-wrapper`
        }, h$1R("div", {
          class: `${n3}-collapse-item__content-inner`
        }, this.$slots));
        return i ? withDirectives(r3, [[vShow, e28]]) : e28 ? r3 : null;
      }
    });
  }
});
function i$1Y(n3 = 8) {
  return Math.random().toString(16).slice(2, 2 + n3);
}
function o$1G(n3, e28) {
  const r3 = [];
  for (let t3 = 0; t3 < n3; ++t3)
    r3.push(e28);
  return r3;
}
function u$1M(n3, e28) {
  const r3 = [];
  if (!e28) {
    for (let t3 = 0; t3 < n3; ++t3)
      r3.push(t3);
    return r3;
  }
  for (let t3 = 0; t3 < n3; ++t3)
    r3.push(e28(t3));
  return r3;
}
function n$1U(e28) {
  const a3 = computed(e28), u3 = ref$1(a3.value);
  return watch(a3, (t3) => {
    u3.value = t3;
  }), typeof e28 == "function" ? u3 : {
    __v_isRef: true,
    get value() {
      return u3.value;
    },
    set value(t3) {
      e28.set(t3);
    }
  };
}
function a$2j(t3, n3) {
  let { target: e28 } = t3;
  for (; e28; ) {
    if (e28.dataset && e28.dataset[n3] !== void 0)
      return true;
    e28 = e28.parentElement;
  }
  return false;
}
const l$1V = l$25("base-icon", `
 height: 1em;
 width: 1em;
 line-height: 1em;
 text-align: center;
 display: inline-block;
 position: relative;
 fill: currentColor;
 transform: translateZ(0);
`, [r$2a("svg", `
 height: 1em;
 width: 1em;
 `)]);
function S$O(t3, i, f3) {
  if (!i) {
    return;
  }
  const o3 = f$1Z(), r3 = inject(n$27, null), n3 = () => {
    const e28 = f3.value;
    i.mount({
      id: e28 === void 0 ? t3 : e28 + t3,
      head: true,
      anchorMetaName: e$2b,
      props: {
        bPrefix: e28 ? `.${e28}-` : void 0
      },
      ssr: o3
    }), r3 != null && r3.preflightStyleDisabled || r$29.mount({
      id: "n-global",
      head: true,
      anchorMetaName: e$2b,
      ssr: o3
    });
  };
  o3 ? n3() : onBeforeMount(n3);
}
const d$1R = defineComponent({
  name: "BaseIcon",
  props: {
    role: String,
    ariaLabel: String,
    ariaDisabled: {
      type: Boolean,
      default: void 0
    },
    ariaHidden: {
      type: Boolean,
      default: void 0
    },
    clsPrefix: {
      type: String,
      required: true
    },
    onClick: Function,
    onMousedown: Function,
    onMouseup: Function
  },
  setup(e28) {
    S$O("-base-icon", l$1V, toRef$1(e28, "clsPrefix"));
  },
  render() {
    return h$1R("i", {
      class: `${this.clsPrefix}-base-icon`,
      onClick: this.onClick,
      onMousedown: this.onMousedown,
      onMouseup: this.onMouseup,
      role: this.role,
      "aria-label": this.ariaLabel,
      "aria-hidden": this.ariaHidden,
      "aria-disabled": this.ariaDisabled
    }, this.$slots);
  }
});
const r$1V = defineComponent({
  name: "ChevronLeft",
  render() {
    return h$1R("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, h$1R("path", {
      d: "M10.3536 3.14645C10.5488 3.34171 10.5488 3.65829 10.3536 3.85355L6.20711 8L10.3536 12.1464C10.5488 12.3417 10.5488 12.6583 10.3536 12.8536C10.1583 13.0488 9.84171 13.0488 9.64645 12.8536L5.14645 8.35355C4.95118 8.15829 4.95118 7.84171 5.14645 7.64645L9.64645 3.14645C9.84171 2.95118 10.1583 2.95118 10.3536 3.14645Z",
      fill: "currentColor"
    }));
  }
});
const r$1U = defineComponent({
  name: "ChevronRight",
  render() {
    return h$1R("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, h$1R("path", {
      d: "M5.64645 3.14645C5.45118 3.34171 5.45118 3.65829 5.64645 3.85355L9.79289 8L5.64645 12.1464C5.45118 12.3417 5.45118 12.6583 5.64645 12.8536C5.84171 13.0488 6.15829 13.0488 6.35355 12.8536L10.8536 8.35355C11.0488 8.15829 11.0488 7.84171 10.8536 7.64645L6.35355 3.14645C6.15829 2.95118 5.84171 2.95118 5.64645 3.14645Z",
      fill: "currentColor"
    }));
  }
});
const E$H = {
  title: String,
  name: [String, Number],
  disabled: Boolean,
  displayDirective: String
}, O$z = defineComponent({
  name: "CollapseItem",
  props: E$H,
  setup(a3) {
    const {
      mergedRtlRef: s3
    } = a$2x(a3), i = i$1Y(), t3 = n$1U(() => {
      var e28;
      return (e28 = a3.name) !== null && e28 !== void 0 ? e28 : i;
    }), n3 = inject(K$q);
    n3 || t$1P("collapse-item", "`n-collapse-item` must be placed inside `n-collapse`.");
    const {
      expandedNamesRef: r3,
      props: c3,
      mergedClsPrefixRef: m3,
      slots: d3
    } = n3, p3 = computed(() => {
      const {
        value: e28
      } = r3;
      if (Array.isArray(e28)) {
        const {
          value: o3
        } = t3;
        return !~e28.findIndex((g3) => g3 === o3);
      } else if (e28) {
        const {
          value: o3
        } = t3;
        return o3 !== e28;
      }
      return true;
    });
    return {
      rtlEnabled: v$17("Collapse", s3, m3),
      collapseSlots: d3,
      randomName: i,
      mergedClsPrefix: m3,
      collapsed: p3,
      triggerAreas: toRef$1(c3, "triggerAreas"),
      mergedDisplayDirective: computed(() => {
        const {
          displayDirective: e28
        } = a3;
        return e28 || c3.displayDirective;
      }),
      arrowPlacement: computed(() => c3.arrowPlacement),
      handleClick(e28) {
        let o3 = "main";
        a$2j(e28, "arrow") && (o3 = "arrow"), a$2j(e28, "extra") && (o3 = "extra"), c3.triggerAreas.includes(o3) && n3 && !a3.disabled && n3.toggleItem(p3.value, t3.value, e28);
      }
    };
  },
  render() {
    const {
      collapseSlots: a3,
      $slots: s3,
      arrowPlacement: i,
      collapsed: t3,
      mergedDisplayDirective: n3,
      mergedClsPrefix: r3,
      disabled: c3,
      triggerAreas: m3
    } = this, d3 = c$21(s3.header, {
      collapsed: t3
    }, () => [this.title]), p3 = s3["header-extra"] || a3["header-extra"], u3 = s3.arrow || a3.arrow;
    return h$1R("div", {
      class: [`${r3}-collapse-item`, `${r3}-collapse-item--${i}-arrow-placement`, c3 && `${r3}-collapse-item--disabled`, !t3 && `${r3}-collapse-item--active`, m3.map((e28) => `${r3}-collapse-item--trigger-area-${e28}`)]
    }, h$1R("div", {
      class: [`${r3}-collapse-item__header`, !t3 && `${r3}-collapse-item__header--active`]
    }, h$1R("div", {
      class: `${r3}-collapse-item__header-main`,
      onClick: this.handleClick
    }, i === "right" && d3, h$1R("div", {
      class: `${r3}-collapse-item-arrow`,
      key: this.rtlEnabled ? 0 : 1,
      "data-arrow": true
    }, c$21(u3, {
      collapsed: t3
    }, () => {
      var e28;
      return [h$1R(d$1R, {
        clsPrefix: r3
      }, {
        default: (e28 = a3.expandIcon) !== null && e28 !== void 0 ? e28 : () => this.rtlEnabled ? h$1R(r$1V, null) : h$1R(r$1U, null)
      })];
    })), i === "left" && d3), s$28(p3, {
      collapsed: t3
    }, (e28) => h$1R("div", {
      class: `${r3}-collapse-item__header-extra`,
      onClick: this.handleClick,
      "data-extra": true
    }, e28))), h$1R(w$R, {
      clsPrefix: r3,
      displayDirective: n3,
      show: !t3
    }, s3));
  }
});
const f$1L = defineComponent({
  name: "UICollapseItem",
  inheritAttrs: false
}), u$1L = defineComponent(__spreadProps(__spreadValues({}, f$1L), {
  props: {
    title: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    arrowPlacement: {
      type: String,
      default: "left"
    },
    id: {
      type: String,
      required: true
    }
  },
  emits: ["onItemHeaderClick"],
  setup(t3) {
    return (e28, l3) => (openBlock(), createBlock(unref(O$z), {
      id: t3.id,
      title: t3.title,
      name: t3.name,
      onOnItemHeaderClick: l3[0] || (l3[0] = (i) => e28.$emit("onItemHeaderClick", i))
    }, {
      header: withCtx(() => [
        renderSlot(e28.$slots, "header")
      ]),
      "header-extra": withCtx(() => [
        renderSlot(e28.$slots, "header-extra")
      ]),
      default: withCtx(() => [
        renderSlot(e28.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "title", "name"]));
  }
})), I$F = u$1L;
const n$1T = n$28("n-popover-body");
const e$1M = n$28("n-modal-body"), d$1Q = n$28("n-modal-provider"), t$1M = n$28("n-modal");
const n$1S = n$28("n-drawer-body"), o$1F = n$28("n-drawer");
function n$1R(t3) {
  return t3.composedPath()[0];
}
const f$1K = {
  mousemoveoutside: /* @__PURE__ */ new WeakMap(),
  clickoutside: /* @__PURE__ */ new WeakMap()
};
function l$1U(t3, n3, s3) {
  if (t3 === "mousemoveoutside") {
    const o3 = (e28) => {
      n3.contains(n$1R(e28)) || s3(e28);
    };
    return {
      mousemove: o3,
      touchstart: o3
    };
  } else if (t3 === "clickoutside") {
    let o3 = false;
    const e28 = (u3) => {
      o3 = !n3.contains(n$1R(u3));
    }, r3 = (u3) => {
      o3 && (n3.contains(n$1R(u3)) || s3(u3));
    };
    return {
      mousedown: e28,
      mouseup: r3,
      touchstart: e28,
      touchend: r3
    };
  }
  return console.error(`[evtd/create-trap-handler]: name \`${t3}\` is invalid. This could be a bug of evtd.`), {};
}
function i$1X(t3, n3, s3) {
  const o3 = f$1K[t3];
  let e28 = o3.get(n3);
  e28 === void 0 && o3.set(n3, e28 = /* @__PURE__ */ new WeakMap());
  let r3 = e28.get(s3);
  return r3 === void 0 && e28.set(s3, r3 = l$1U(t3, n3, s3)), r3;
}
function v$16(t3, n3, s3, o3) {
  if (t3 === "mousemoveoutside" || t3 === "clickoutside") {
    const e28 = i$1X(t3, n3, s3);
    return Object.keys(e28).forEach((r3) => {
      J$o(r3, document, e28[r3], o3);
    }), true;
  }
  return false;
}
function H$r(t3, n3, s3, o3) {
  if (t3 === "mousemoveoutside" || t3 === "clickoutside") {
    const e28 = i$1X(t3, n3, s3);
    return Object.keys(e28).forEach((r3) => {
      K$p(r3, document, e28[r3], o3);
    }), true;
  }
  return false;
}
function B$Q() {
  if (typeof window > "u")
    return {
      on: () => {
      },
      off: () => {
      }
    };
  const h3 = /* @__PURE__ */ new WeakMap(), H3 = /* @__PURE__ */ new WeakMap();
  function M3() {
    h3.set(this, true);
  }
  function S3() {
    h3.set(this, true), H3.set(this, true);
  }
  function v3(n3, e28, t3) {
    const r3 = n3[e28];
    return n3[e28] = function() {
      return t3.apply(n3, arguments), r3.apply(n3, arguments);
    }, n3;
  }
  function m3(n3, e28) {
    n3[e28] = Event.prototype[e28];
  }
  const E3 = /* @__PURE__ */ new WeakMap(), T3 = Object.getOwnPropertyDescriptor(Event.prototype, "currentTarget");
  function U3() {
    var n3;
    return (n3 = E3.get(this)) !== null && n3 !== void 0 ? n3 : null;
  }
  function P3(n3, e28) {
    T3 !== void 0 && Object.defineProperty(n3, "currentTarget", {
      configurable: true,
      enumerable: true,
      get: e28 != null ? e28 : T3.get
    });
  }
  const w3 = {
    bubble: {},
    capture: {}
  }, c3 = {};
  function x3() {
    const n3 = function(e28) {
      const { type: t3, eventPhase: r3, bubbles: o3 } = e28, d3 = n$1R(e28);
      if (r3 === 2)
        return;
      const s3 = r3 === 1 ? "capture" : "bubble";
      let i = d3;
      const a3 = [];
      for (; i === null && (i = window), a3.push(i), i !== window; )
        i = i.parentNode || null;
      const u3 = w3.capture[t3], l3 = w3.bubble[t3];
      if (v3(e28, "stopPropagation", M3), v3(e28, "stopImmediatePropagation", S3), P3(e28, U3), s3 === "capture") {
        if (u3 === void 0)
          return;
        for (let f3 = a3.length - 1; f3 >= 0 && !h3.has(e28); --f3) {
          const p3 = a3[f3], g3 = u3.get(p3);
          if (g3 !== void 0) {
            E3.set(e28, p3);
            for (const b3 of g3) {
              if (H3.has(e28))
                break;
              b3(e28);
            }
          }
          if (f3 === 0 && !o3 && l3 !== void 0) {
            const b3 = l3.get(p3);
            if (b3 !== void 0)
              for (const N3 of b3) {
                if (H3.has(e28))
                  break;
                N3(e28);
              }
          }
        }
      } else if (s3 === "bubble") {
        if (l3 === void 0)
          return;
        for (let f3 = 0; f3 < a3.length && !h3.has(e28); ++f3) {
          const p3 = a3[f3], g3 = l3.get(p3);
          if (g3 !== void 0) {
            E3.set(e28, p3);
            for (const b3 of g3) {
              if (H3.has(e28))
                break;
              b3(e28);
            }
          }
        }
      }
      m3(e28, "stopPropagation"), m3(e28, "stopImmediatePropagation"), P3(e28);
    };
    return n3.displayName = "evtdUnifiedHandler", n3;
  }
  function z3() {
    const n3 = function(e28) {
      const { type: t3, eventPhase: r3 } = e28;
      if (r3 !== 2)
        return;
      const o3 = c3[t3];
      o3 !== void 0 && o3.forEach((d3) => d3(e28));
    };
    return n3.displayName = "evtdUnifiedWindowEventHandler", n3;
  }
  const k3 = x3(), W3 = z3();
  function j3(n3, e28) {
    const t3 = w3[n3];
    return t3[e28] === void 0 && (t3[e28] = /* @__PURE__ */ new Map(), window.addEventListener(e28, k3, n3 === "capture")), t3[e28];
  }
  function D3(n3) {
    return c3[n3] === void 0 && (c3[n3] = /* @__PURE__ */ new Set(), window.addEventListener(n3, W3)), c3[n3];
  }
  function O3(n3, e28) {
    let t3 = n3.get(e28);
    return t3 === void 0 && n3.set(e28, t3 = /* @__PURE__ */ new Set()), t3;
  }
  function I3(n3, e28, t3, r3) {
    const o3 = w3[e28][t3];
    if (o3 !== void 0) {
      const d3 = o3.get(n3);
      if (d3 !== void 0 && d3.has(r3))
        return true;
    }
    return false;
  }
  function C3(n3, e28) {
    const t3 = c3[n3];
    return !!(t3 !== void 0 && t3.has(e28));
  }
  function y3(n3, e28, t3, r3) {
    let o3;
    if (typeof r3 == "object" && r3.once === true ? o3 = (u3) => {
      L3(n3, e28, o3, r3), t3(u3);
    } : o3 = t3, v$16(n3, e28, o3, r3))
      return;
    const s3 = r3 === true || typeof r3 == "object" && r3.capture === true ? "capture" : "bubble", i = j3(s3, n3), a3 = O3(i, e28);
    if (a3.has(o3) || a3.add(o3), e28 === window) {
      const u3 = D3(n3);
      u3.has(o3) || u3.add(o3);
    }
  }
  function L3(n3, e28, t3, r3) {
    if (H$r(n3, e28, t3, r3))
      return;
    const d3 = r3 === true || typeof r3 == "object" && r3.capture === true, s3 = d3 ? "capture" : "bubble", i = j3(s3, n3), a3 = O3(i, e28);
    if (e28 === window && !I3(e28, d3 ? "bubble" : "capture", n3, t3) && C3(n3, t3)) {
      const l3 = c3[n3];
      l3.delete(t3), l3.size === 0 && (window.removeEventListener(n3, W3), c3[n3] = void 0);
    }
    a3.has(t3) && a3.delete(t3), a3.size === 0 && i.delete(e28), i.size === 0 && (window.removeEventListener(n3, k3, s3 === "capture"), w3[s3][n3] = void 0);
  }
  return {
    on: y3,
    off: L3
  };
}
const { on: J$o, off: K$p } = B$Q();
const d$1P = "@@coContext", u$1K = {
  mounted(t3, { value: c3, modifiers: e28 }) {
    t3[d$1P] = {
      handler: void 0
    }, typeof c3 == "function" && (t3[d$1P].handler = c3, J$o("clickoutside", t3, c3, {
      capture: e28.capture
    }));
  },
  updated(t3, { value: c3, modifiers: e28 }) {
    const n3 = t3[d$1P];
    typeof c3 == "function" ? n3.handler ? n3.handler !== c3 && (K$p("clickoutside", t3, n3.handler, {
      capture: e28.capture
    }), n3.handler = c3, J$o("clickoutside", t3, c3, {
      capture: e28.capture
    })) : (t3[d$1P].handler = c3, J$o("clickoutside", t3, c3, {
      capture: e28.capture
    })) : n3.handler && (K$p("clickoutside", t3, n3.handler, {
      capture: e28.capture
    }), n3.handler = void 0);
  },
  unmounted(t3, { modifiers: c3 }) {
    const { handler: e28 } = t3[d$1P];
    e28 && K$p("clickoutside", t3, e28, {
      capture: c3.capture
    }), t3[d$1P].handler = void 0;
  }
}, a$2i = u$1K;
function n$1Q(t3) {
  return t3 instanceof HTMLElement;
}
function c$1_(t3) {
  for (let r3 = 0; r3 < t3.childNodes.length; r3++) {
    const e28 = t3.childNodes[r3];
    if (n$1Q(e28) && (u$1J(e28) || c$1_(e28)))
      return true;
  }
  return false;
}
function i$1W(t3) {
  for (let r3 = t3.childNodes.length - 1; r3 >= 0; r3--) {
    const e28 = t3.childNodes[r3];
    if (n$1Q(e28) && (u$1J(e28) || i$1W(e28)))
      return true;
  }
  return false;
}
function u$1J(t3) {
  if (!s$25(t3))
    return false;
  try {
    t3.focus({ preventScroll: true });
  } catch {
  }
  return document.activeElement === t3;
}
function s$25(t3) {
  if (t3.tabIndex > 0 || t3.tabIndex === 0 && t3.getAttribute("tabIndex") !== null)
    return true;
  if (t3.getAttribute("disabled"))
    return false;
  switch (t3.nodeName) {
    case "A":
      return !!t3.href && t3.rel !== "ignore";
    case "INPUT":
      return t3.type !== "hidden" && t3.type !== "file";
    case "BUTTON":
    case "SELECT":
    case "TEXTAREA":
      return true;
    default:
      return false;
  }
}
function r$1T(t3 = 8) {
  return Math.random().toString(16).slice(2, 2 + t3);
}
function e$1L(r3) {
  return typeof r3 == "string" ? document.querySelector(r3) : r3();
}
function t$1L(e28) {
  return e28.composedPath()[0] || null;
}
let r$1S = [];
const V$x = defineComponent({
  name: "FocusTrap",
  props: {
    disabled: Boolean,
    active: Boolean,
    autoFocus: {
      type: Boolean,
      default: true
    },
    onEsc: Function,
    initialFocusTo: String,
    finalFocusTo: String,
    returnFocusOnDeactivated: {
      type: Boolean,
      default: true
    }
  },
  setup(n3) {
    const i = r$1T(), u3 = ref$1(null), E3 = ref$1(null);
    let s3 = false, o3 = false;
    const F3 = typeof document > "u" ? null : document.activeElement;
    function a3() {
      return r$1S[r$1S.length - 1] === i;
    }
    function d3(e28) {
      var t3;
      e28.code === "Escape" && a3() && ((t3 = n3.onEsc) === null || t3 === void 0 || t3.call(n3, e28));
    }
    onMounted(() => {
      watch(() => n3.active, (e28) => {
        e28 ? (y3(), J$o("keydown", document, d3)) : (K$p("keydown", document, d3), s3 && b3());
      }, {
        immediate: true
      });
    }), onBeforeUnmount(() => {
      K$p("keydown", document, d3), s3 && b3();
    });
    function h3(e28) {
      if (!o3 && a3()) {
        const t3 = v3();
        if (t3 === null || t3.contains(t$1L(e28)))
          return;
        l3("first");
      }
    }
    function v3() {
      const e28 = u3.value;
      if (e28 === null)
        return null;
      let t3 = e28;
      for (; t3 = t3.nextSibling, !(t3 === null || t3 instanceof Element && t3.tagName === "DIV"); )
        ;
      return t3;
    }
    function y3() {
      var e28;
      if (!n3.disabled) {
        if (r$1S.push(i), n3.autoFocus) {
          const { initialFocusTo: t3 } = n3;
          t3 === void 0 ? l3("first") : (e28 = e$1L(t3)) === null || e28 === void 0 || e28.focus({ preventScroll: true });
        }
        s3 = true, document.addEventListener("focus", h3, true);
      }
    }
    function b3() {
      var e28;
      if (n3.disabled || (document.removeEventListener("focus", h3, true), r$1S = r$1S.filter((c3) => c3 !== i), a3()))
        return;
      const { finalFocusTo: t3 } = n3;
      t3 !== void 0 ? (e28 = e$1L(t3)) === null || e28 === void 0 || e28.focus({ preventScroll: true }) : n3.returnFocusOnDeactivated && F3 instanceof HTMLElement && (o3 = true, F3.focus({ preventScroll: true }), o3 = false);
    }
    function l3(e28) {
      if (a3() && n3.active) {
        const t3 = u3.value, c3 = E3.value;
        if (t3 !== null && c3 !== null) {
          const f3 = v3();
          if (f3 == null || f3 === c3) {
            o3 = true, t3.focus({ preventScroll: true }), o3 = false;
            return;
          }
          o3 = true;
          const k3 = e28 === "first" ? c$1_(f3) : i$1W(f3);
          o3 = false, k3 || (o3 = true, t3.focus({ preventScroll: true }), o3 = false);
        }
      }
    }
    function w3(e28) {
      if (o3)
        return;
      const t3 = v3();
      t3 !== null && (e28.relatedTarget !== null && t3.contains(e28.relatedTarget) ? l3("last") : l3("first"));
    }
    function D3(e28) {
      o3 || (e28.relatedTarget !== null && e28.relatedTarget === u3.value ? l3("last") : l3("first"));
    }
    return {
      focusableStartRef: u3,
      focusableEndRef: E3,
      focusableStyle: "position: absolute; height: 0; width: 0;",
      handleStartFocus: w3,
      handleEndFocus: D3
    };
  },
  render() {
    const { default: n3 } = this.$slots;
    if (n3 === void 0)
      return null;
    if (this.disabled)
      return n3();
    const { active: i, focusableStyle: u3 } = this;
    return h$1R(Fragment, null, [
      h$1R("div", {
        "aria-hidden": "true",
        tabindex: i ? "0" : "-1",
        ref: "focusableStartRef",
        style: u3,
        onFocus: this.handleStartFocus
      }),
      n3(),
      h$1R("div", {
        "aria-hidden": "true",
        style: u3,
        ref: "focusableEndRef",
        tabindex: i ? "0" : "-1",
        onFocus: this.handleEndFocus
      })
    ]);
  }
});
const {
  cubicBezierEaseInOut: n$1P
} = e$2d;
function l$1T({
  name: t3 = "fade-in",
  enterDuration: o3 = "0.2s",
  leaveDuration: r3 = "0.2s",
  enterCubicBezier: a3 = n$1P,
  leaveCubicBezier: e28 = n$1P
} = {}) {
  return [r$2a(`&.${t3}-transition-enter-active`, {
    transition: `all ${o3} ${a3}!important`
  }), r$2a(`&.${t3}-transition-leave-active`, {
    transition: `all ${r3} ${e28}!important`
  }), r$2a(`&.${t3}-transition-enter-from, &.${t3}-transition-leave-to`, {
    opacity: 0
  }), r$2a(`&.${t3}-transition-leave-from, &.${t3}-transition-enter-to`, {
    opacity: 1
  })];
}
const n$1O = l$25("scrollbar", `
 overflow: hidden;
 position: relative;
 z-index: auto;
 height: 100%;
 width: 100%;
`, [r$2a(">", [l$25("scrollbar-container", `
 width: 100%;
 overflow: scroll;
 height: 100%;
 min-height: inherit;
 max-height: inherit;
 scrollbar-width: none;
 `, [r$2a("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", `
 width: 0;
 height: 0;
 display: none;
 `), r$2a(">", [l$25("scrollbar-content", `
 box-sizing: border-box;
 min-width: 100%;
 `)])])]), r$2a(">, +", [l$25("scrollbar-rail", `
 position: absolute;
 pointer-events: none;
 user-select: none;
 -webkit-user-select: none;
 `, [g$1j("horizontal", `
 left: 2px;
 right: 2px;
 bottom: 4px;
 height: var(--n-scrollbar-height);
 `, [r$2a(">", [M$y("scrollbar", `
 height: var(--n-scrollbar-height);
 border-radius: var(--n-scrollbar-border-radius);
 right: 0;
 `)])]), g$1j("vertical", `
 right: 4px;
 top: 2px;
 bottom: 2px;
 width: var(--n-scrollbar-width);
 `, [r$2a(">", [M$y("scrollbar", `
 width: var(--n-scrollbar-width);
 border-radius: var(--n-scrollbar-border-radius);
 bottom: 0;
 `)])]), g$1j("disabled", [r$2a(">", [M$y("scrollbar", "pointer-events: none;")])]), r$2a(">", [M$y("scrollbar", `
 z-index: 1;
 position: absolute;
 cursor: pointer;
 pointer-events: all;
 background-color: var(--n-scrollbar-color);
 transition: background-color .2s var(--n-scrollbar-bezier);
 `, [l$1T(), r$2a("&:hover", "background-color: var(--n-scrollbar-color-hover);")])])])])]);
const o$1E = (typeof window > "u" ? false : /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) && !window.MSStream;
function t$1K() {
  return o$1E;
}
function s$24(a3) {
  const e28 = {
    isDeactivated: false
  };
  let t3 = false;
  return onActivated(() => {
    if (e28.isDeactivated = false, !t3) {
      t3 = true;
      return;
    }
    a3();
  }), onDeactivated(() => {
    e28.isDeactivated = true, t3 || (t3 = true);
  }), e28;
}
const t$1J = (o3) => {
  const {
    scrollbarColor: r3,
    scrollbarColorHover: l3
  } = o3;
  return {
    color: r3,
    colorHover: l3
  };
}, s$23 = {
  name: "Scrollbar",
  common: d$1T,
  self: t$1J
}, n$1N = s$23;
var e$1K = [];
var n$1M = function() {
  return e$1K.some(function(e28) {
    return e28.activeTargets.length > 0;
  });
};
var t$1I = function() {
  return e$1K.some(function(e28) {
    return e28.skippedTargets.length > 0;
  });
};
var r$1R = "ResizeObserver loop completed with undelivered notifications.", t$1H = function() {
  var e28;
  typeof ErrorEvent == "function" ? e28 = new ErrorEvent("error", {
    message: r$1R
  }) : (e28 = document.createEvent("Event"), e28.initEvent("error", false, false), e28.message = r$1R), window.dispatchEvent(e28);
};
var E$G;
(function(o3) {
  o3.BORDER_BOX = "border-box", o3.CONTENT_BOX = "content-box", o3.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(E$G || (E$G = {}));
var r$1Q = function(e28) {
  return Object.freeze(e28);
};
var s$22 = function() {
  function e28(i, r3) {
    this.inlineSize = i, this.blockSize = r3, r$1Q(this);
  }
  return e28;
}();
var u$1I = function() {
  function h3(t3, i, o3, e28) {
    return this.x = t3, this.y = i, this.width = o3, this.height = e28, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, r$1Q(this);
  }
  return h3.prototype.toJSON = function() {
    var t3 = this, i = t3.x, o3 = t3.y, e28 = t3.top, r3 = t3.right, s3 = t3.bottom, f3 = t3.left, n3 = t3.width, p3 = t3.height;
    return { x: i, y: o3, top: e28, right: r3, bottom: s3, left: f3, width: n3, height: p3 };
  }, h3.fromRect = function(t3) {
    return new h3(t3.x, t3.y, t3.width, t3.height);
  }, h3;
}();
var c$1Z = function(e28) {
  return e28 instanceof SVGElement && "getBBox" in e28;
}, f$1J = function(e28) {
  if (c$1Z(e28)) {
    var n3 = e28.getBBox(), t3 = n3.width, s3 = n3.height;
    return !t3 && !s3;
  }
  var i = e28, r3 = i.offsetWidth, a3 = i.offsetHeight;
  return !(r3 || a3 || e28.getClientRects().length);
}, o$1D = function(e28) {
  var n3;
  if (e28 instanceof Element)
    return true;
  var t3 = (n3 = e28 == null ? void 0 : e28.ownerDocument) === null || n3 === void 0 ? void 0 : n3.defaultView;
  return !!(t3 && e28 instanceof t3.Element);
}, u$1H = function(e28) {
  switch (e28.tagName) {
    case "INPUT":
      if (e28.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return true;
  }
  return false;
};
var o$1C = typeof window < "u" ? window : {};
var l$1S = /* @__PURE__ */ new WeakMap(), S$N = /auto|scroll/, G$u = /^tb|vertical/, N$G = /msie|trident/i.test(o$1C.navigator && o$1C.navigator.userAgent), i$1V = function(e28) {
  return parseFloat(e28 || "0");
}, a$2h = function(e28, t3, r3) {
  return e28 === void 0 && (e28 = 0), t3 === void 0 && (t3 = 0), r3 === void 0 && (r3 = false), new s$22((r3 ? t3 : e28) || 0, (r3 ? e28 : t3) || 0);
}, w$Q = r$1Q({
  devicePixelContentBoxSize: a$2h(),
  borderBoxSize: a$2h(),
  contentBoxSize: a$2h(),
  contentRect: new u$1I(0, 0, 0, 0)
}), F$D = function(e28, t3) {
  if (t3 === void 0 && (t3 = false), l$1S.has(e28) && !t3)
    return l$1S.get(e28);
  if (f$1J(e28))
    return l$1S.set(e28, w$Q), w$Q;
  var r3 = getComputedStyle(e28), o3 = c$1Z(e28) && e28.ownerSVGElement && e28.getBBox(), d3 = !N$G && r3.boxSizing === "border-box", n3 = G$u.test(r3.writingMode || ""), s3 = !o3 && S$N.test(r3.overflowY || ""), W3 = !o3 && S$N.test(r3.overflowX || ""), B3 = o3 ? 0 : i$1V(r3.paddingTop), T3 = o3 ? 0 : i$1V(r3.paddingRight), C3 = o3 ? 0 : i$1V(r3.paddingBottom), f3 = o3 ? 0 : i$1V(r3.paddingLeft), E3 = o3 ? 0 : i$1V(r3.borderTopWidth), H3 = o3 ? 0 : i$1V(r3.borderRightWidth), L3 = o3 ? 0 : i$1V(r3.borderBottomWidth), M3 = o3 ? 0 : i$1V(r3.borderLeftWidth), p3 = f3 + T3, g3 = B3 + C3, h3 = M3 + H3, x3 = E3 + L3, b3 = W3 ? e28.offsetHeight - x3 - e28.clientHeight : 0, m3 = s3 ? e28.offsetWidth - h3 - e28.clientWidth : 0, _3 = d3 ? p3 + h3 : 0, y3 = d3 ? g3 + x3 : 0, v3 = o3 ? o3.width : i$1V(r3.width) - _3 - m3, c3 = o3 ? o3.height : i$1V(r3.height) - y3 - b3, D3 = v3 + p3 + m3 + h3, V10 = c3 + g3 + b3 + x3, u3 = r$1Q({
    devicePixelContentBoxSize: a$2h(Math.round(v3 * devicePixelRatio), Math.round(c3 * devicePixelRatio), n3),
    borderBoxSize: a$2h(D3, V10, n3),
    contentBoxSize: a$2h(v3, c3, n3),
    contentRect: new u$1I(f3, B3, v3, c3)
  });
  return l$1S.set(e28, u3), u3;
}, Q$r = function(e28, t3, r3) {
  var o3 = F$D(e28, r3), d3 = o3.borderBoxSize, n3 = o3.contentBoxSize, s3 = o3.devicePixelContentBoxSize;
  switch (t3) {
    case E$G.DEVICE_PIXEL_CONTENT_BOX:
      return s3;
    case E$G.BORDER_BOX:
      return d3;
    default:
      return n3;
  }
};
var s$21 = function() {
  function i(o3) {
    var e28 = F$D(o3);
    this.target = o3, this.contentRect = e28.contentRect, this.borderBoxSize = r$1Q([e28.borderBoxSize]), this.contentBoxSize = r$1Q([e28.contentBoxSize]), this.devicePixelContentBoxSize = r$1Q([e28.devicePixelContentBoxSize]);
  }
  return i;
}();
var i$1U = function(e28) {
  if (f$1J(e28))
    return 1 / 0;
  for (var t3 = 0, r3 = e28.parentNode; r3; )
    t3 += 1, r3 = r3.parentNode;
  return t3;
};
var T$M = function() {
  var t3 = 1 / 0, s3 = [];
  e$1K.forEach(function(e28) {
    if (e28.activeTargets.length !== 0) {
      var i = [];
      e28.activeTargets.forEach(function(r3) {
        var l3 = new s$21(r3.target), v3 = i$1U(r3.target);
        i.push(l3), r3.lastReportedSize = Q$r(r3.target, r3.observedBox), v3 < t3 && (t3 = v3);
      }), s3.push(function() {
        e28.callback.call(e28.observer, i, e28.observer);
      }), e28.activeTargets.splice(0, e28.activeTargets.length);
    }
  });
  for (var a3 = 0, c3 = s3; a3 < c3.length; a3++) {
    var n3 = c3[a3];
    n3();
  }
  return t3;
};
var n$1L = function(t3) {
  e$1K.forEach(function(e28) {
    e28.activeTargets.splice(0, e28.activeTargets.length), e28.skippedTargets.splice(0, e28.skippedTargets.length), e28.observationTargets.forEach(function(s3) {
      s3.isActive() && (i$1U(s3.target) > t3 ? e28.activeTargets.push(s3) : e28.skippedTargets.push(s3));
    });
  });
};
var n$1K = function() {
  var r3 = 0;
  for (n$1L(r3); n$1M(); )
    r3 = T$M(), n$1L(r3);
  return t$1I() && t$1H(), r3 > 0;
};
var n$1J, a$2g = [], u$1G = function() {
  return a$2g.splice(0).forEach(function(r3) {
    return r3();
  });
}, o$1B = function(r3) {
  if (!n$1J) {
    var t3 = 0, e28 = document.createTextNode(""), c3 = { characterData: true };
    new MutationObserver(function() {
      return u$1G();
    }).observe(e28, c3), n$1J = function() {
      e28.textContent = "".concat(t3 ? t3-- : t3++);
    };
  }
  a$2g.push(r3), n$1J();
};
var u$1F = function(e28) {
  o$1B(function() {
    requestAnimationFrame(e28);
  });
};
var n$1I = 0, d$1O = function() {
  return !!n$1I;
}, p$3F = 250, l$1R = { attributes: true, characterData: true, childList: true, subtree: true }, u$1E = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], a$2f = function(t3) {
  return t3 === void 0 && (t3 = 0), Date.now() + t3;
}, i$1T = false, b$15 = function() {
  function t3() {
    var e28 = this;
    this.stopped = true, this.listener = function() {
      return e28.schedule();
    };
  }
  return t3.prototype.run = function(e28) {
    var r3 = this;
    if (e28 === void 0 && (e28 = p$3F), !i$1T) {
      i$1T = true;
      var c3 = a$2f(e28);
      u$1F(function() {
        var o3 = false;
        try {
          o3 = n$1K();
        } finally {
          if (i$1T = false, e28 = c3 - a$2f(), !d$1O())
            return;
          o3 ? r3.run(1e3) : e28 > 0 ? r3.run(e28) : r3.start();
        }
      });
    }
  }, t3.prototype.schedule = function() {
    this.stop(), this.run();
  }, t3.prototype.observe = function() {
    var e28 = this, r3 = function() {
      return e28.observer && e28.observer.observe(document.body, l$1R);
    };
    document.body ? r3() : o$1C.addEventListener("DOMContentLoaded", r3);
  }, t3.prototype.start = function() {
    var e28 = this;
    this.stopped && (this.stopped = false, this.observer = new MutationObserver(this.listener), this.observe(), u$1E.forEach(function(r3) {
      return o$1C.addEventListener(r3, e28.listener, true);
    }));
  }, t3.prototype.stop = function() {
    var e28 = this;
    this.stopped || (this.observer && this.observer.disconnect(), u$1E.forEach(function(r3) {
      return o$1C.removeEventListener(r3, e28.listener, true);
    }), this.stopped = true);
  }, t3;
}(), v$15 = new b$15(), E$F = function(t3) {
  !n$1I && t3 > 0 && v$15.start(), n$1I += t3, !n$1I && v$15.stop();
};
var l$1Q = function(e28) {
  return !c$1Z(e28) && !u$1H(e28) && getComputedStyle(e28).display === "inline";
}, S$M = function() {
  function e28(i, t3) {
    this.target = i, this.observedBox = t3 || E$G.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return e28.prototype.isActive = function() {
    var i = Q$r(this.target, this.observedBox, true);
    return l$1Q(this.target) && (this.lastReportedSize = i), this.lastReportedSize.inlineSize !== i.inlineSize || this.lastReportedSize.blockSize !== i.blockSize;
  }, e28;
}();
var i$1S = function() {
  function e28(t3, s3) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = t3, this.callback = s3;
  }
  return e28;
}();
var a$2e = /* @__PURE__ */ new WeakMap(), c$1Y = function(o3, t3) {
  for (var e28 = 0; e28 < o3.length; e28 += 1)
    if (o3[e28].target === t3)
      return e28;
  return -1;
}, h$1G = function() {
  function o3() {
  }
  return o3.connect = function(t3, e28) {
    var r3 = new i$1S(t3, e28);
    a$2e.set(t3, r3);
  }, o3.observe = function(t3, e28, r3) {
    var n3 = a$2e.get(t3), i = n3.observationTargets.length === 0;
    c$1Y(n3.observationTargets, e28) < 0 && (i && e$1K.push(n3), n3.observationTargets.push(new S$M(e28, r3 && r3.box)), E$F(1), v$15.schedule());
  }, o3.unobserve = function(t3, e28) {
    var r3 = a$2e.get(t3), n3 = c$1Y(r3.observationTargets, e28), i = r3.observationTargets.length === 1;
    n3 >= 0 && (i && e$1K.splice(e$1K.indexOf(r3), 1), r3.observationTargets.splice(n3, 1), E$F(-1));
  }, o3.disconnect = function(t3) {
    var e28 = this, r3 = a$2e.get(t3);
    r3.observationTargets.slice().forEach(function(n3) {
      return e28.unobserve(t3, n3.target);
    }), r3.activeTargets.splice(0, r3.activeTargets.length);
  }, o3;
}();
var u$1D = function() {
  function r3(e28) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof e28 != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    h$1G.connect(this, e28);
  }
  return r3.prototype.observe = function(e28, n3) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!o$1D(e28))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    h$1G.observe(this, e28, n3);
  }, r3.prototype.unobserve = function(e28) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!o$1D(e28))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    h$1G.unobserve(this, e28);
  }, r3.prototype.disconnect = function() {
    h$1G.disconnect(this);
  }, r3.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, r3;
}();
class i$1R {
  constructor() {
    this.handleResize = this.handleResize.bind(this), this.observer = new (typeof window < "u" && window.ResizeObserver || u$1D)(this.handleResize), this.elHandlersMap = /* @__PURE__ */ new Map();
  }
  handleResize(e28) {
    for (const s3 of e28) {
      const r3 = this.elHandlersMap.get(s3.target);
      r3 !== void 0 && r3(s3);
    }
  }
  registerHandler(e28, s3) {
    this.elHandlersMap.set(e28, s3), this.observer.observe(e28);
  }
  unregisterHandler(e28) {
    this.elHandlersMap.has(e28) && (this.elHandlersMap.delete(e28), this.observer.unobserve(e28));
  }
}
const o$1A = new i$1R();
function e$1J(o3, r3) {
  console.error(`[vueuc/${o3}]: ${r3}`);
}
const x$D = defineComponent({
  name: "ResizeObserver",
  props: {
    onResize: Function
  },
  setup(s3) {
    let n3 = false;
    const r3 = getCurrentInstance().proxy;
    function l3(e28) {
      const { onResize: t3 } = s3;
      t3 !== void 0 && t3(e28);
    }
    onMounted(() => {
      const e28 = r3.$el;
      if (e28 === void 0) {
        e$1J("resize-observer", "$el does not exist.");
        return;
      }
      if (e28.nextElementSibling !== e28.nextSibling && e28.nodeType === 3 && e28.nodeValue !== "") {
        e$1J("resize-observer", "$el can not be observed (it may be a text node).");
        return;
      }
      e28.nextElementSibling !== null && (o$1A.registerHandler(e28.nextElementSibling, l3), n3 = true);
    }), onBeforeUnmount(() => {
      n3 && o$1A.unregisterHandler(r3.$el.nextElementSibling);
    });
  },
  render() {
    return renderSlot(this.$slots, "default");
  }
});
const n$1H = defineComponent({
  render() {
    var e28, r3;
    return (r3 = (e28 = this.$slots).default) === null || r3 === void 0 ? void 0 : r3.call(e28);
  }
});
function t$1G(e28) {
  return e28.composedPath()[0] || null;
}
const Ke$8 = Object.assign(Object.assign({}, _$F.props), {
  size: {
    type: Number,
    default: 5
  },
  duration: {
    type: Number,
    default: 0
  },
  scrollable: {
    type: Boolean,
    default: true
  },
  xScrollable: Boolean,
  trigger: {
    type: String,
    default: "hover"
  },
  useUnifiedContainer: Boolean,
  triggerDisplayManually: Boolean,
  container: Function,
  content: Function,
  containerClass: String,
  containerStyle: [String, Object],
  contentClass: [String, Array],
  contentStyle: [String, Object],
  horizontalRailStyle: [String, Object],
  verticalRailStyle: [String, Object],
  onScroll: Function,
  onWheel: Function,
  onResize: Function,
  internalOnUpdateScrollLeft: Function,
  internalHoistYRail: Boolean
}), de$i = defineComponent({
  name: "Scrollbar",
  props: Ke$8,
  inheritAttrs: false,
  setup(o3) {
    const {
      mergedClsPrefixRef: S3,
      inlineThemeDisabled: f3,
      mergedRtlRef: $3
    } = a$2x(o3), r3 = v$17("Scrollbar", $3, S3), X3 = ref$1(null), g3 = ref$1(null), H3 = ref$1(null), B3 = ref$1(null), p3 = ref$1(null), d3 = ref$1(null), h3 = ref$1(null), T3 = ref$1(null), z3 = ref$1(null), E3 = ref$1(null), D3 = ref$1(null), M3 = ref$1(0), L3 = ref$1(0), U3 = ref$1(false), I3 = ref$1(false);
    let _3 = false, j3 = false, m3, R3, q3 = 0, J3 = 0, F3 = 0, K3 = 0;
    const he2 = t$1K(), N3 = computed(() => {
      const {
        value: e28
      } = T3, {
        value: n3
      } = d3, {
        value: t3
      } = E3;
      return e28 === null || n3 === null || t3 === null ? 0 : Math.min(e28, t3 * e28 / n3 + o3.size * 1.5);
    }), ve2 = computed(() => `${N3.value}px`), V10 = computed(() => {
      const {
        value: e28
      } = z3, {
        value: n3
      } = h3, {
        value: t3
      } = D3;
      return e28 === null || n3 === null || t3 === null ? 0 : t3 * e28 / n3 + o3.size * 1.5;
    }), me2 = computed(() => `${V10.value}px`), Re2 = computed(() => {
      const {
        value: e28
      } = T3, {
        value: n3
      } = M3, {
        value: t3
      } = d3, {
        value: l3
      } = E3;
      if (e28 === null || t3 === null || l3 === null)
        return 0;
      {
        const a3 = t3 - e28;
        return a3 ? n3 / a3 * (l3 - N3.value) : 0;
      }
    }), Se2 = computed(() => `${Re2.value}px`), be2 = computed(() => {
      const {
        value: e28
      } = z3, {
        value: n3
      } = L3, {
        value: t3
      } = h3, {
        value: l3
      } = D3;
      if (e28 === null || t3 === null || l3 === null)
        return 0;
      {
        const a3 = t3 - e28;
        return a3 ? n3 / a3 * (l3 - V10.value) : 0;
      }
    }), we2 = computed(() => `${be2.value}px`), Q3 = computed(() => {
      const {
        value: e28
      } = T3, {
        value: n3
      } = d3;
      return e28 !== null && n3 !== null && n3 > e28;
    }), Z3 = computed(() => {
      const {
        value: e28
      } = z3, {
        value: n3
      } = h3;
      return e28 !== null && n3 !== null && n3 > e28;
    }), ge2 = computed(() => {
      const {
        trigger: e28
      } = o3;
      return e28 === "none" || U3.value;
    }), Be2 = computed(() => {
      const {
        trigger: e28
      } = o3;
      return e28 === "none" || I3.value;
    }), y3 = computed(() => {
      const {
        container: e28
      } = o3;
      return e28 ? e28() : g3.value;
    }), pe2 = computed(() => {
      const {
        content: e28
      } = o3;
      return e28 ? e28() : H3.value;
    }), ee2 = s$24(() => {
      o3.container || ne2({
        top: M3.value,
        left: L3.value
      });
    }), ye2 = () => {
      ee2.isDeactivated || x3();
    }, xe2 = (e28) => {
      if (ee2.isDeactivated)
        return;
      const {
        onResize: n3
      } = o3;
      n3 && n3(e28), x3();
    }, ne2 = (e28, n3) => {
      if (!o3.scrollable)
        return;
      if (typeof e28 == "number") {
        P3(e28, n3 != null ? n3 : 0, 0, false, "auto");
        return;
      }
      const {
        left: t3,
        top: l3,
        index: a3,
        elSize: u3,
        position: b3,
        behavior: i,
        el: w3,
        debounce: Y3 = true
      } = e28;
      (t3 !== void 0 || l3 !== void 0) && P3(t3 != null ? t3 : 0, l3 != null ? l3 : 0, 0, false, i), w3 !== void 0 ? P3(0, w3.offsetTop, w3.offsetHeight, Y3, i) : a3 !== void 0 && u3 !== void 0 ? P3(0, a3 * u3, u3, Y3, i) : b3 === "bottom" ? P3(0, Number.MAX_SAFE_INTEGER, 0, false, i) : b3 === "top" && P3(0, 0, 0, false, i);
    }, Te2 = (e28, n3) => {
      if (!o3.scrollable)
        return;
      const {
        value: t3
      } = y3;
      t3 && (typeof e28 == "object" ? t3.scrollBy(e28) : t3.scrollBy(e28, n3 || 0));
    };
    function P3(e28, n3, t3, l3, a3) {
      const {
        value: u3
      } = y3;
      if (u3) {
        if (l3) {
          const {
            scrollTop: b3,
            offsetHeight: i
          } = u3;
          if (n3 > b3) {
            n3 + t3 <= b3 + i || u3.scrollTo({
              left: e28,
              top: n3 + t3 - i,
              behavior: a3
            });
            return;
          }
        }
        u3.scrollTo({
          left: e28,
          top: n3,
          behavior: a3
        });
      }
    }
    function ze2() {
      Ce2(), Xe2(), x3();
    }
    function Me2() {
      A3();
    }
    function A3() {
      Pe2(), We2();
    }
    function Pe2() {
      R3 !== void 0 && window.clearTimeout(R3), R3 = window.setTimeout(() => {
        I3.value = false;
      }, o3.duration);
    }
    function We2() {
      m3 !== void 0 && window.clearTimeout(m3), m3 = window.setTimeout(() => {
        U3.value = false;
      }, o3.duration);
    }
    function Ce2() {
      m3 !== void 0 && window.clearTimeout(m3), U3.value = true;
    }
    function Xe2() {
      R3 !== void 0 && window.clearTimeout(R3), I3.value = true;
    }
    function He2(e28) {
      const {
        onScroll: n3
      } = o3;
      n3 && n3(e28), te2();
    }
    function te2() {
      const {
        value: e28
      } = y3;
      e28 && (M3.value = e28.scrollTop, L3.value = e28.scrollLeft * (r3 != null && r3.value ? -1 : 1));
    }
    function Le2() {
      const {
        value: e28
      } = pe2;
      e28 && (d3.value = e28.offsetHeight, h3.value = e28.offsetWidth);
      const {
        value: n3
      } = y3;
      n3 && (T3.value = n3.offsetHeight, z3.value = n3.offsetWidth);
      const {
        value: t3
      } = p3, {
        value: l3
      } = B3;
      t3 && (D3.value = t3.offsetWidth), l3 && (E3.value = l3.offsetHeight);
    }
    function le2() {
      const {
        value: e28
      } = y3;
      e28 && (M3.value = e28.scrollTop, L3.value = e28.scrollLeft * (r3 != null && r3.value ? -1 : 1), T3.value = e28.offsetHeight, z3.value = e28.offsetWidth, d3.value = e28.scrollHeight, h3.value = e28.scrollWidth);
      const {
        value: n3
      } = p3, {
        value: t3
      } = B3;
      n3 && (D3.value = n3.offsetWidth), t3 && (E3.value = t3.offsetHeight);
    }
    function x3() {
      o3.scrollable && (o3.useUnifiedContainer ? le2() : (Le2(), te2()));
    }
    function oe2(e28) {
      var n3;
      return !(!((n3 = X3.value) === null || n3 === void 0) && n3.contains(t$1G(e28)));
    }
    function Ye2(e28) {
      e28.preventDefault(), e28.stopPropagation(), j3 = true, J$o("mousemove", window, ie2, true), J$o("mouseup", window, re2, true), J3 = L3.value, F3 = r3 != null && r3.value ? window.innerWidth - e28.clientX : e28.clientX;
    }
    function ie2(e28) {
      if (!j3)
        return;
      m3 !== void 0 && window.clearTimeout(m3), R3 !== void 0 && window.clearTimeout(R3);
      const {
        value: n3
      } = z3, {
        value: t3
      } = h3, {
        value: l3
      } = V10;
      if (n3 === null || t3 === null)
        return;
      const u3 = (r3 != null && r3.value ? window.innerWidth - e28.clientX - F3 : e28.clientX - F3) * (t3 - n3) / (n3 - l3), b3 = t3 - n3;
      let i = J3 + u3;
      i = Math.min(b3, i), i = Math.max(i, 0);
      const {
        value: w3
      } = y3;
      if (w3) {
        w3.scrollLeft = i * (r3 != null && r3.value ? -1 : 1);
        const {
          internalOnUpdateScrollLeft: Y3
        } = o3;
        Y3 && Y3(i);
      }
    }
    function re2(e28) {
      e28.preventDefault(), e28.stopPropagation(), K$p("mousemove", window, ie2, true), K$p("mouseup", window, re2, true), j3 = false, x3(), oe2(e28) && A3();
    }
    function $e2(e28) {
      e28.preventDefault(), e28.stopPropagation(), _3 = true, J$o("mousemove", window, G3, true), J$o("mouseup", window, k3, true), q3 = M3.value, K3 = e28.clientY;
    }
    function G3(e28) {
      if (!_3)
        return;
      m3 !== void 0 && window.clearTimeout(m3), R3 !== void 0 && window.clearTimeout(R3);
      const {
        value: n3
      } = T3, {
        value: t3
      } = d3, {
        value: l3
      } = N3;
      if (n3 === null || t3 === null)
        return;
      const u3 = (e28.clientY - K3) * (t3 - n3) / (n3 - l3), b3 = t3 - n3;
      let i = q3 + u3;
      i = Math.min(b3, i), i = Math.max(i, 0);
      const {
        value: w3
      } = y3;
      w3 && (w3.scrollTop = i);
    }
    function k3(e28) {
      e28.preventDefault(), e28.stopPropagation(), K$p("mousemove", window, G3, true), K$p("mouseup", window, k3, true), _3 = false, x3(), oe2(e28) && A3();
    }
    watchEffect(() => {
      const {
        value: e28
      } = Z3, {
        value: n3
      } = Q3, {
        value: t3
      } = S3, {
        value: l3
      } = p3, {
        value: a3
      } = B3;
      l3 && (e28 ? l3.classList.remove(`${t3}-scrollbar-rail--disabled`) : l3.classList.add(`${t3}-scrollbar-rail--disabled`)), a3 && (n3 ? a3.classList.remove(`${t3}-scrollbar-rail--disabled`) : a3.classList.add(`${t3}-scrollbar-rail--disabled`));
    }), onMounted(() => {
      o3.container || x3();
    }), onBeforeUnmount(() => {
      m3 !== void 0 && window.clearTimeout(m3), R3 !== void 0 && window.clearTimeout(R3), K$p("mousemove", window, G3, true), K$p("mouseup", window, k3, true);
    });
    const Ee2 = _$F("Scrollbar", "-scrollbar", n$1O, n$1N, o3, S3), ae2 = computed(() => {
      const {
        common: {
          cubicBezierEaseInOut: e28,
          scrollbarBorderRadius: n3,
          scrollbarHeight: t3,
          scrollbarWidth: l3
        },
        self: {
          color: a3,
          colorHover: u3
        }
      } = Ee2.value;
      return {
        "--n-scrollbar-bezier": e28,
        "--n-scrollbar-color": a3,
        "--n-scrollbar-color-hover": u3,
        "--n-scrollbar-border-radius": n3,
        "--n-scrollbar-width": l3,
        "--n-scrollbar-height": t3
      };
    }), W3 = f3 ? E$J("scrollbar", void 0, ae2, o3) : void 0;
    return Object.assign(Object.assign({}, {
      scrollTo: ne2,
      scrollBy: Te2,
      sync: x3,
      syncUnifiedContainer: le2,
      handleMouseEnterWrapper: ze2,
      handleMouseLeaveWrapper: Me2
    }), {
      mergedClsPrefix: S3,
      rtlEnabled: r3,
      containerScrollTop: M3,
      wrapperRef: X3,
      containerRef: g3,
      contentRef: H3,
      yRailRef: B3,
      xRailRef: p3,
      needYBar: Q3,
      needXBar: Z3,
      yBarSizePx: ve2,
      xBarSizePx: me2,
      yBarTopPx: Se2,
      xBarLeftPx: we2,
      isShowXBar: ge2,
      isShowYBar: Be2,
      isIos: he2,
      handleScroll: He2,
      handleContentResize: ye2,
      handleContainerResize: xe2,
      handleYScrollMouseDown: $e2,
      handleXScrollMouseDown: Ye2,
      cssVars: f3 ? void 0 : ae2,
      themeClass: W3 == null ? void 0 : W3.themeClass,
      onRender: W3 == null ? void 0 : W3.onRender
    });
  },
  render() {
    var o3;
    const {
      $slots: S3,
      mergedClsPrefix: f3,
      triggerDisplayManually: $3,
      rtlEnabled: r3,
      internalHoistYRail: X3
    } = this;
    if (!this.scrollable)
      return (o3 = S3.default) === null || o3 === void 0 ? void 0 : o3.call(S3);
    const g3 = this.trigger === "none", H3 = (d3, h3) => h$1R("div", {
      ref: "yRailRef",
      class: [`${f3}-scrollbar-rail`, `${f3}-scrollbar-rail--vertical`, d3],
      "data-scrollbar-rail": true,
      style: [h3 || "", this.verticalRailStyle],
      "aria-hidden": true
    }, h$1R(g3 ? n$1H : Transition, g3 ? null : {
      name: "fade-in-transition"
    }, {
      default: () => this.needYBar && this.isShowYBar && !this.isIos ? h$1R("div", {
        class: `${f3}-scrollbar-rail__scrollbar`,
        style: {
          height: this.yBarSizePx,
          top: this.yBarTopPx
        },
        onMousedown: this.handleYScrollMouseDown
      }) : null
    })), B3 = () => {
      var d3, h3;
      return (d3 = this.onRender) === null || d3 === void 0 || d3.call(this), h$1R("div", mergeProps(this.$attrs, {
        role: "none",
        ref: "wrapperRef",
        class: [`${f3}-scrollbar`, this.themeClass, r3 && `${f3}-scrollbar--rtl`],
        style: this.cssVars,
        onMouseenter: $3 ? void 0 : this.handleMouseEnterWrapper,
        onMouseleave: $3 ? void 0 : this.handleMouseLeaveWrapper
      }), [this.container ? (h3 = S3.default) === null || h3 === void 0 ? void 0 : h3.call(S3) : h$1R("div", {
        role: "none",
        ref: "containerRef",
        class: [`${f3}-scrollbar-container`, this.containerClass],
        style: this.containerStyle,
        onScroll: this.handleScroll,
        onWheel: this.onWheel
      }, h$1R(x$D, {
        onResize: this.handleContentResize
      }, {
        default: () => h$1R("div", {
          ref: "contentRef",
          role: "none",
          style: [{
            width: this.xScrollable ? "fit-content" : null
          }, this.contentStyle],
          class: [`${f3}-scrollbar-content`, this.contentClass]
        }, S3)
      })), X3 ? null : H3(void 0, void 0), this.xScrollable && h$1R("div", {
        ref: "xRailRef",
        class: [`${f3}-scrollbar-rail`, `${f3}-scrollbar-rail--horizontal`],
        style: this.horizontalRailStyle,
        "data-scrollbar-rail": true,
        "aria-hidden": true
      }, h$1R(g3 ? n$1H : Transition, g3 ? null : {
        name: "fade-in-transition"
      }, {
        default: () => this.needXBar && this.isShowXBar && !this.isIos ? h$1R("div", {
          class: `${f3}-scrollbar-rail__scrollbar`,
          style: {
            width: this.xBarSizePx,
            right: r3 ? this.xBarLeftPx : void 0,
            left: r3 ? void 0 : this.xBarLeftPx
          },
          onMousedown: this.handleXScrollMouseDown
        }) : null
      }))]);
    }, p3 = this.container ? B3() : h$1R(x$D, {
      onResize: this.handleContainerResize
    }, {
      default: B3
    });
    return X3 ? h$1R(Fragment, null, p3, H3(this.themeClass, this.cssVars)) : p3;
  }
}), hn$2 = de$i, vn$3 = de$i;
let l$1P = 0, r$1P = "", f$1I = "", s$20 = "", a$2d = "";
const d$1N = ref$1("0px");
function y$17(c3) {
  if (typeof document > "u")
    return;
  const e28 = document.documentElement;
  let o3, t3 = false;
  const n3 = () => {
    e28.style.marginRight = r$1P, e28.style.overflow = f$1I, e28.style.overflowX = s$20, e28.style.overflowY = a$2d, d$1N.value = "0px";
  };
  onMounted(() => {
    o3 = watch(c3, (v3) => {
      if (v3) {
        if (!l$1P) {
          const i = window.innerWidth - e28.offsetWidth;
          i > 0 && (r$1P = e28.style.marginRight, e28.style.marginRight = `${i}px`, d$1N.value = `${i}px`), f$1I = e28.style.overflow, s$20 = e28.style.overflowX, a$2d = e28.style.overflowY, e28.style.overflow = "hidden", e28.style.overflowX = "hidden", e28.style.overflowY = "hidden";
        }
        t3 = true, l$1P++;
      } else
        l$1P--, l$1P || n3(), t3 = false;
    }, {
      immediate: true
    });
  }), onBeforeUnmount(() => {
    o3 == null || o3(), t3 && (l$1P--, l$1P || n3(), t3 = false);
  });
}
const de$h = defineComponent({
  name: "NDrawerContent",
  inheritAttrs: false,
  props: {
    blockScroll: Boolean,
    show: {
      type: Boolean,
      default: void 0
    },
    displayDirective: {
      type: String,
      required: true
    },
    placement: {
      type: String,
      required: true
    },
    contentClass: String,
    contentStyle: [Object, String],
    nativeScrollbar: {
      type: Boolean,
      required: true
    },
    scrollbarProps: Object,
    trapFocus: {
      type: Boolean,
      default: true
    },
    autoFocus: {
      type: Boolean,
      default: true
    },
    showMask: {
      type: [Boolean, String],
      required: true
    },
    maxWidth: Number,
    maxHeight: Number,
    minWidth: Number,
    minHeight: Number,
    resizable: Boolean,
    onClickoutside: Function,
    onAfterLeave: Function,
    onAfterEnter: Function,
    onEsc: Function
  },
  setup(t3) {
    const r3 = ref$1(!!t3.show), m3 = ref$1(null), h3 = inject(o$1F);
    let a3 = 0, w3 = "", s3 = null;
    const f3 = ref$1(false), d3 = ref$1(false), y3 = computed(() => t3.placement === "top" || t3.placement === "bottom"), {
      mergedClsPrefixRef: M3,
      mergedRtlRef: B3
    } = a$2x(t3), E3 = v$17("Drawer", B3, M3), D3 = (e28) => {
      d3.value = true, a3 = y3.value ? e28.clientY : e28.clientX, w3 = document.body.style.cursor, document.body.style.cursor = y3.value ? "ns-resize" : "ew-resize", document.body.addEventListener("mousemove", p3), document.body.addEventListener("mouseleave", R3), document.body.addEventListener("mouseup", u3);
    }, C3 = () => {
      s3 !== null && (window.clearTimeout(s3), s3 = null), d3.value ? f3.value = true : s3 = window.setTimeout(() => {
        f3.value = true;
      }, 300);
    }, z3 = () => {
      s3 !== null && (window.clearTimeout(s3), s3 = null), f3.value = false;
    }, {
      doUpdateHeight: L3,
      doUpdateWidth: $3
    } = h3, H3 = (e28) => {
      const {
        maxWidth: o3
      } = t3;
      if (o3 && e28 > o3)
        return o3;
      const {
        minWidth: i
      } = t3;
      return i && e28 < i ? i : e28;
    }, F3 = (e28) => {
      const {
        maxHeight: o3
      } = t3;
      if (o3 && e28 > o3)
        return o3;
      const {
        minHeight: i
      } = t3;
      return i && e28 < i ? i : e28;
    }, p3 = (e28) => {
      var o3, i;
      if (d3.value)
        if (y3.value) {
          let n3 = ((o3 = m3.value) === null || o3 === void 0 ? void 0 : o3.offsetHeight) || 0;
          const c3 = a3 - e28.clientY;
          n3 += t3.placement === "bottom" ? c3 : -c3, n3 = F3(n3), L3(n3), a3 = e28.clientY;
        } else {
          let n3 = ((i = m3.value) === null || i === void 0 ? void 0 : i.offsetWidth) || 0;
          const c3 = a3 - e28.clientX;
          n3 += t3.placement === "right" ? c3 : -c3, n3 = H3(n3), $3(n3), a3 = e28.clientX;
        }
    }, u3 = () => {
      d3.value && (a3 = 0, d3.value = false, document.body.style.cursor = w3, document.body.removeEventListener("mousemove", p3), document.body.removeEventListener("mouseup", u3), document.body.removeEventListener("mouseleave", R3));
    }, R3 = u3;
    watchEffect(() => {
      t3.show && (r3.value = true);
    }), watch(() => t3.show, (e28) => {
      e28 || u3();
    }), onBeforeUnmount(() => {
      u3();
    });
    const N3 = computed(() => {
      const {
        show: e28
      } = t3, o3 = [[vShow, e28]];
      return t3.showMask || o3.push([a$2i, t3.onClickoutside, void 0, {
        capture: true
      }]), o3;
    });
    function k3() {
      var e28;
      r3.value = false, (e28 = t3.onAfterLeave) === null || e28 === void 0 || e28.call(t3);
    }
    return y$17(computed(() => t3.blockScroll && r3.value)), provide(n$1S, m3), provide(n$1T, null), provide(e$1M, null), {
      bodyRef: m3,
      rtlEnabled: E3,
      mergedClsPrefix: h3.mergedClsPrefixRef,
      isMounted: h3.isMountedRef,
      mergedTheme: h3.mergedThemeRef,
      displayed: r3,
      transitionName: computed(() => ({
        right: "slide-in-from-right-transition",
        left: "slide-in-from-left-transition",
        top: "slide-in-from-top-transition",
        bottom: "slide-in-from-bottom-transition"
      })[t3.placement]),
      handleAfterLeave: k3,
      bodyDirectives: N3,
      handleMousedownResizeTrigger: D3,
      handleMouseenterResizeTrigger: C3,
      handleMouseleaveResizeTrigger: z3,
      isDragging: d3,
      isHoverOnResizeTrigger: f3
    };
  },
  render() {
    const {
      $slots: t3,
      mergedClsPrefix: r3
    } = this;
    return this.displayDirective === "show" || this.displayed || this.show ? withDirectives(h$1R("div", {
      role: "none"
    }, h$1R(V$x, {
      disabled: !this.showMask || !this.trapFocus,
      active: this.show,
      autoFocus: this.autoFocus,
      onEsc: this.onEsc
    }, {
      default: () => h$1R(Transition, {
        name: this.transitionName,
        appear: this.isMounted,
        onAfterEnter: this.onAfterEnter,
        onAfterLeave: this.handleAfterLeave
      }, {
        default: () => withDirectives(h$1R("div", mergeProps(this.$attrs, {
          role: "dialog",
          ref: "bodyRef",
          "aria-modal": "true",
          class: [
            `${r3}-drawer`,
            this.rtlEnabled && `${r3}-drawer--rtl`,
            `${r3}-drawer--${this.placement}-placement`,
            this.isDragging && `${r3}-drawer--unselectable`,
            this.nativeScrollbar && `${r3}-drawer--native-scrollbar`
          ]
        }), [this.resizable ? h$1R("div", {
          class: [`${r3}-drawer__resize-trigger`, (this.isDragging || this.isHoverOnResizeTrigger) && `${r3}-drawer__resize-trigger--hover`],
          onMouseenter: this.handleMouseenterResizeTrigger,
          onMouseleave: this.handleMouseleaveResizeTrigger,
          onMousedown: this.handleMousedownResizeTrigger
        }) : null, this.nativeScrollbar ? h$1R("div", {
          class: [`${r3}-drawer-content-wrapper`, this.contentClass],
          style: this.contentStyle,
          role: "none"
        }, t3) : h$1R(hn$2, Object.assign({}, this.scrollbarProps, {
          contentStyle: this.contentStyle,
          contentClass: [`${r3}-drawer-content-wrapper`, this.contentClass],
          theme: this.mergedTheme.peers.Scrollbar,
          themeOverrides: this.mergedTheme.peerOverrides.Scrollbar
        }), t3)]), this.bodyDirectives)
      })
    })), [[vShow, this.displayDirective === "if" || this.displayed || this.show]]) : null;
  }
});
const {
  cubicBezierEaseIn: a$2c,
  cubicBezierEaseOut: s$1$
} = e$2d;
function m$25({
  duration: n3 = "0.3s",
  leaveDuration: i = "0.2s",
  name: t3 = "slide-in-from-right"
} = {}) {
  return [r$2a(`&.${t3}-transition-leave-active`, {
    transition: `transform ${i} ${a$2c}`
  }), r$2a(`&.${t3}-transition-enter-active`, {
    transition: `transform ${n3} ${s$1$}`
  }), r$2a(`&.${t3}-transition-enter-to`, {
    transform: "translateX(0)"
  }), r$2a(`&.${t3}-transition-enter-from`, {
    transform: "translateX(100%)"
  }), r$2a(`&.${t3}-transition-leave-from`, {
    transform: "translateX(0)"
  }), r$2a(`&.${t3}-transition-leave-to`, {
    transform: "translateX(100%)"
  })];
}
const {
  cubicBezierEaseIn: a$2b,
  cubicBezierEaseOut: s$1_
} = e$2d;
function l$1O({
  duration: n3 = "0.3s",
  leaveDuration: i = "0.2s",
  name: t3 = "slide-in-from-left"
} = {}) {
  return [r$2a(`&.${t3}-transition-leave-active`, {
    transition: `transform ${i} ${a$2b}`
  }), r$2a(`&.${t3}-transition-enter-active`, {
    transition: `transform ${n3} ${s$1_}`
  }), r$2a(`&.${t3}-transition-enter-to`, {
    transform: "translateX(0)"
  }), r$2a(`&.${t3}-transition-enter-from`, {
    transform: "translateX(-100%)"
  }), r$2a(`&.${t3}-transition-leave-from`, {
    transform: "translateX(0)"
  }), r$2a(`&.${t3}-transition-leave-to`, {
    transform: "translateX(-100%)"
  })];
}
const {
  cubicBezierEaseIn: a$2a,
  cubicBezierEaseOut: s$1Z
} = e$2d;
function m$24({
  duration: n3 = "0.3s",
  leaveDuration: o3 = "0.2s",
  name: t3 = "slide-in-from-top"
} = {}) {
  return [r$2a(`&.${t3}-transition-leave-active`, {
    transition: `transform ${o3} ${a$2a}`
  }), r$2a(`&.${t3}-transition-enter-active`, {
    transition: `transform ${n3} ${s$1Z}`
  }), r$2a(`&.${t3}-transition-enter-to`, {
    transform: "translateY(0)"
  }), r$2a(`&.${t3}-transition-enter-from`, {
    transform: "translateY(-100%)"
  }), r$2a(`&.${t3}-transition-leave-from`, {
    transform: "translateY(0)"
  }), r$2a(`&.${t3}-transition-leave-to`, {
    transform: "translateY(-100%)"
  })];
}
const {
  cubicBezierEaseIn: a$29,
  cubicBezierEaseOut: s$1Y
} = e$2d;
function f$1H({
  duration: n3 = "0.3s",
  leaveDuration: o3 = "0.2s",
  name: t3 = "slide-in-from-bottom"
} = {}) {
  return [r$2a(`&.${t3}-transition-leave-active`, {
    transition: `transform ${o3} ${a$29}`
  }), r$2a(`&.${t3}-transition-enter-active`, {
    transition: `transform ${n3} ${s$1Y}`
  }), r$2a(`&.${t3}-transition-enter-to`, {
    transform: "translateY(0)"
  }), r$2a(`&.${t3}-transition-enter-from`, {
    transform: "translateY(100%)"
  }), r$2a(`&.${t3}-transition-leave-from`, {
    transform: "translateY(0)"
  }), r$2a(`&.${t3}-transition-leave-to`, {
    transform: "translateY(100%)"
  })];
}
const h$1F = r$2a([l$25("drawer", `
 word-break: break-word;
 line-height: var(--n-line-height);
 position: absolute;
 pointer-events: all;
 box-shadow: var(--n-box-shadow);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 background-color: var(--n-color);
 color: var(--n-text-color);
 box-sizing: border-box;
 `, [m$25(), l$1O(), m$24(), f$1H(), g$1j("unselectable", `
 user-select: none; 
 -webkit-user-select: none;
 `), g$1j("native-scrollbar", [l$25("drawer-content-wrapper", `
 overflow: auto;
 height: 100%;
 `)]), M$y("resize-trigger", `
 position: absolute;
 background-color: #0000;
 transition: background-color .3s var(--n-bezier);
 `, [g$1j("hover", `
 background-color: var(--n-resize-trigger-color-hover);
 `)]), l$25("drawer-content-wrapper", `
 box-sizing: border-box;
 `), l$25("drawer-content", `
 height: 100%;
 display: flex;
 flex-direction: column;
 `, [g$1j("native-scrollbar", [l$25("drawer-body-content-wrapper", `
 height: 100%;
 overflow: auto;
 `)]), l$25("drawer-body", `
 flex: 1 0 0;
 overflow: hidden;
 `), l$25("drawer-body-content-wrapper", `
 box-sizing: border-box;
 padding: var(--n-body-padding);
 `), l$25("drawer-header", `
 font-weight: var(--n-title-font-weight);
 line-height: 1;
 font-size: var(--n-title-font-size);
 color: var(--n-title-text-color);
 padding: var(--n-header-padding);
 transition: border .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-divider-color);
 border-bottom: var(--n-header-border-bottom);
 display: flex;
 justify-content: space-between;
 align-items: center;
 `, [M$y("close", `
 margin-left: 6px;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)]), l$25("drawer-footer", `
 display: flex;
 justify-content: flex-end;
 border-top: var(--n-footer-border-top);
 transition: border .3s var(--n-bezier);
 padding: var(--n-footer-padding);
 `)]), g$1j("right-placement", `
 top: 0;
 bottom: 0;
 right: 0;
 border-top-left-radius: var(--n-border-radius);
 border-bottom-left-radius: var(--n-border-radius);
 `, [M$y("resize-trigger", `
 width: 3px;
 height: 100%;
 top: 0;
 left: 0;
 transform: translateX(-1.5px);
 cursor: ew-resize;
 `)]), g$1j("left-placement", `
 top: 0;
 bottom: 0;
 left: 0;
 border-top-right-radius: var(--n-border-radius);
 border-bottom-right-radius: var(--n-border-radius);
 `, [M$y("resize-trigger", `
 width: 3px;
 height: 100%;
 top: 0;
 right: 0;
 transform: translateX(1.5px);
 cursor: ew-resize;
 `)]), g$1j("top-placement", `
 top: 0;
 left: 0;
 right: 0;
 border-bottom-left-radius: var(--n-border-radius);
 border-bottom-right-radius: var(--n-border-radius);
 `, [M$y("resize-trigger", `
 width: 100%;
 height: 3px;
 bottom: 0;
 left: 0;
 transform: translateY(1.5px);
 cursor: ns-resize;
 `)]), g$1j("bottom-placement", `
 left: 0;
 bottom: 0;
 right: 0;
 border-top-left-radius: var(--n-border-radius);
 border-top-right-radius: var(--n-border-radius);
 `, [M$y("resize-trigger", `
 width: 100%;
 height: 3px;
 top: 0;
 left: 0;
 transform: translateY(-1.5px);
 cursor: ns-resize;
 `)])]), r$2a("body", [r$2a(">", [l$25("drawer-container", `
 position: fixed;
 `)])]), l$25("drawer-container", `
 position: relative;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 pointer-events: none;
 `, [r$2a("> *", `
 pointer-events: all;
 `)]), l$25("drawer-mask", `
 background-color: rgba(0, 0, 0, .3);
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [g$1j("invisible", `
 background-color: rgba(0, 0, 0, 0)
 `), l$1T({
  enterDuration: "0.2s",
  leaveDuration: "0.2s",
  enterCubicBezier: "var(--n-bezier-in)",
  leaveCubicBezier: "var(--n-bezier-out)"
})])]);
function u$1C() {
  const e28 = ref$1(false);
  return onMounted(() => {
    e28.value = true;
  }), readonly(e28);
}
const i$1Q = /^(\d|\.)+$/, n$1G = /(\d|\.)+/;
function o$1z(r3, {
  c: u3 = 1,
  offset: t3 = 0,
  attachPx: s3 = true
} = {}) {
  if (typeof r3 == "number") {
    const e28 = (r3 + t3) * u3;
    return e28 === 0 ? "0" : `${e28}px`;
  } else if (typeof r3 == "string")
    if (i$1Q.test(r3)) {
      const e28 = (Number(r3) + t3) * u3;
      return s3 ? e28 === 0 ? "0" : `${e28}px` : `${e28}`;
    } else {
      const e28 = n$1G.exec(r3);
      return e28 ? r3.replace(n$1G, String((Number(e28[0]) + t3) * u3)) : r3;
    }
  return r3;
}
function h$1E(n3, e28, t3 = "default") {
  const r3 = e28[t3];
  if (r3 === void 0)
    throw new Error(`[vueuc/${n3}]: slot[${t3}] is empty.`);
  return r3();
}
function i$1P(n3, e28 = true, t3 = []) {
  return n3.forEach((r3) => {
    if (r3 !== null) {
      if (typeof r3 != "object") {
        (typeof r3 == "string" || typeof r3 == "number") && t3.push(createTextVNode(String(r3)));
        return;
      }
      if (Array.isArray(r3)) {
        i$1P(r3, e28, t3);
        return;
      }
      if (r3.type === Fragment) {
        if (r3.children === null)
          return;
        Array.isArray(r3.children) && i$1P(r3.children, e28, t3);
      } else
        r3.type !== Comment && t3.push(r3);
    }
  }), t3;
}
function y$16(n3, e28, t3 = "default") {
  const r3 = e28[t3];
  if (r3 === void 0)
    throw new Error(`[vueuc/${n3}]: slot[${t3}] is empty.`);
  const f3 = i$1P(r3());
  if (f3.length === 1)
    return f3[0];
  throw new Error(`[vueuc/${n3}]: slot[${t3}] should have exactly one child.`);
}
const h$1D = defineComponent({
  name: "LazyTeleport",
  props: {
    to: {
      type: [String, Object],
      default: void 0
    },
    disabled: Boolean,
    show: {
      type: Boolean,
      required: true
    }
  },
  setup(t3) {
    return {
      showTeleport: l$1X(toRef$1(t3, "show")),
      mergedTo: computed(() => {
        const { to: e28 } = t3;
        return e28 != null ? e28 : "body";
      })
    };
  },
  render() {
    return this.showTeleport ? this.disabled ? h$1E("lazy-teleport", this.$slots) : h$1R(Teleport, {
      disabled: this.disabled,
      to: this.mergedTo
    }, h$1E("lazy-teleport", this.$slots)) : null;
  }
});
function n$1F(r3, o3) {
  console.error(`[vdirs/${r3}]: ${o3}`);
}
class i$1O {
  constructor() {
    this.elementZIndex = /* @__PURE__ */ new Map(), this.nextZIndex = 2e3;
  }
  get elementCount() {
    return this.elementZIndex.size;
  }
  ensureZIndex(e28, t3) {
    const { elementZIndex: n3 } = this;
    if (t3 !== void 0) {
      e28.style.zIndex = `${t3}`, n3.delete(e28);
      return;
    }
    const { nextZIndex: s3 } = this;
    n3.has(e28) && n3.get(e28) + 1 === this.nextZIndex || (e28.style.zIndex = `${s3}`, n3.set(e28, s3), this.nextZIndex = s3 + 1, this.squashState());
  }
  unregister(e28, t3) {
    const { elementZIndex: n3 } = this;
    n3.has(e28) ? n3.delete(e28) : t3 === void 0 && n$1F("z-index-manager/unregister-element", "Element not found when unregistering."), this.squashState();
  }
  squashState() {
    const { elementCount: e28 } = this;
    e28 || (this.nextZIndex = 2e3), this.nextZIndex - e28 > 2500 && this.rearrange();
  }
  rearrange() {
    const e28 = Array.from(this.elementZIndex.entries());
    e28.sort((t3, n3) => t3[1] - n3[1]), this.nextZIndex = 2e3, e28.forEach((t3) => {
      const n3 = t3[0], s3 = this.nextZIndex++;
      `${s3}` !== n3.style.zIndex && (n3.style.zIndex = `${s3}`);
    });
  }
}
const h$1C = new i$1O();
const n$1E = "@@ziContext", u$1B = {
  mounted(e28, t3) {
    const { value: d3 = {} } = t3, { zIndex: i, enabled: a3 } = d3;
    e28[n$1E] = {
      enabled: !!a3,
      initialized: false
    }, a3 && (h$1C.ensureZIndex(e28, i), e28[n$1E].initialized = true);
  },
  updated(e28, t3) {
    const { value: d3 = {} } = t3, { zIndex: i, enabled: a3 } = d3, s3 = e28[n$1E].enabled;
    a3 && !s3 && (h$1C.ensureZIndex(e28, i), e28[n$1E].initialized = true), e28[n$1E].enabled = !!a3;
  },
  unmounted(e28, t3) {
    if (!e28[n$1E].initialized)
      return;
    const { value: d3 = {} } = t3, { zIndex: i } = d3;
    h$1C.unregister(e28, i);
  }
}, r$1O = u$1B;
const b$14 = (e28) => {
  const {
    modalColor: t3,
    textColor1: l3,
    textColor2: i,
    boxShadow3: d3,
    lineHeight: s3,
    fontWeightStrong: c3,
    dividerColor: o3,
    closeColorHover: a3,
    closeColorPressed: n3,
    closeIconColor: p3,
    closeIconColorHover: x3,
    closeIconColorPressed: m3,
    borderRadius: r3,
    primaryColorHover: g3
  } = e28;
  return {
    bodyPadding: "16px 24px",
    borderRadius: r3,
    headerPadding: "16px 24px",
    footerPadding: "16px 24px",
    color: t3,
    textColor: i,
    titleTextColor: l3,
    titleFontSize: "18px",
    titleFontWeight: c3,
    boxShadow: d3,
    lineHeight: s3,
    headerBorderBottom: `1px solid ${o3}`,
    footerBorderTop: `1px solid ${o3}`,
    closeIconColor: p3,
    closeIconColorHover: x3,
    closeIconColorPressed: m3,
    closeSize: "22px",
    closeIconSize: "18px",
    closeColorHover: a3,
    closeColorPressed: n3,
    closeBorderRadius: r3,
    resizableTriggerColorHover: g3
  };
}, S$L = G$w({
  name: "Drawer",
  common: d$1T,
  peers: {
    Scrollbar: n$1N
  },
  self: b$14
}), P$U = S$L;
const t$1F = /* @__PURE__ */ new WeakSet();
function n$1D(e28) {
  t$1F.add(e28);
}
function f$1G(e28) {
  return !t$1F.has(e28);
}
const e$1I = ref$1(false), n$1C = () => {
  e$1I.value = true;
}, t$1E = () => {
  e$1I.value = false;
};
let o$1y = 0;
const f$1F = () => (e$1O && (onBeforeMount(() => {
  o$1y || (window.addEventListener("compositionstart", n$1C), window.addEventListener("compositionend", t$1E)), o$1y++;
}), onBeforeUnmount(() => {
  o$1y <= 1 ? (window.removeEventListener("compositionstart", n$1C), window.removeEventListener("compositionend", t$1E), o$1y = 0) : o$1y--;
})), e$1I);
const be$f = Object.assign(Object.assign({}, _$F.props), {
  show: Boolean,
  width: [Number, String],
  height: [Number, String],
  placement: {
    type: String,
    default: "right"
  },
  maskClosable: {
    type: Boolean,
    default: true
  },
  showMask: {
    type: [Boolean, String],
    default: true
  },
  to: [String, Object],
  displayDirective: {
    type: String,
    default: "if"
  },
  nativeScrollbar: {
    type: Boolean,
    default: true
  },
  zIndex: Number,
  onMaskClick: Function,
  scrollbarProps: Object,
  contentClass: String,
  contentStyle: [Object, String],
  trapFocus: {
    type: Boolean,
    default: true
  },
  onEsc: Function,
  autoFocus: {
    type: Boolean,
    default: true
  },
  closeOnEsc: {
    type: Boolean,
    default: true
  },
  blockScroll: {
    type: Boolean,
    default: true
  },
  maxWidth: Number,
  maxHeight: Number,
  minWidth: Number,
  minHeight: Number,
  resizable: Boolean,
  defaultWidth: {
    type: [Number, String],
    default: 251
  },
  defaultHeight: {
    type: [Number, String],
    default: 251
  },
  onUpdateWidth: [Function, Array],
  onUpdateHeight: [Function, Array],
  "onUpdate:width": [Function, Array],
  "onUpdate:height": [Function, Array],
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onAfterEnter: Function,
  onAfterLeave: Function,
  drawerStyle: [String, Object],
  drawerClass: String,
  target: null,
  onShow: Function,
  onHide: Function
}), Ae$9 = defineComponent({
  name: "Drawer",
  inheritAttrs: false,
  props: be$f,
  setup(e28) {
    const {
      mergedClsPrefixRef: i,
      namespaceRef: H3,
      inlineThemeDisabled: f3
    } = a$2x(e28), m3 = u$1C(), h3 = _$F("Drawer", "-drawer", h$1F, P$U, e28, i), g3 = ref$1(e28.defaultWidth), p3 = ref$1(e28.defaultHeight), z3 = d$1S(toRef$1(e28, "width"), g3), x3 = d$1S(toRef$1(e28, "height"), p3), B3 = computed(() => {
      const {
        placement: t3
      } = e28;
      return t3 === "top" || t3 === "bottom" ? "" : o$1z(z3.value);
    }), F3 = computed(() => {
      const {
        placement: t3
      } = e28;
      return t3 === "left" || t3 === "right" ? "" : o$1z(x3.value);
    }), R3 = (t3) => {
      const {
        onUpdateWidth: o3,
        "onUpdate:width": n3
      } = e28;
      o3 && i$1Z(o3, t3), n3 && i$1Z(n3, t3), g3.value = t3;
    }, U3 = (t3) => {
      const {
        onUpdateHeight: o3,
        "onUpdate:width": n3
      } = e28;
      o3 && i$1Z(o3, t3), n3 && i$1Z(n3, t3), p3.value = t3;
    }, E3 = computed(() => [{
      width: B3.value,
      height: F3.value
    }, e28.drawerStyle || ""]);
    function w3(t3) {
      const {
        onMaskClick: o3,
        maskClosable: n3
      } = e28;
      n3 && u3(false), o3 && o3(t3);
    }
    function W3(t3) {
      w3(t3);
    }
    const O3 = f$1F();
    function M3(t3) {
      var o3;
      (o3 = e28.onEsc) === null || o3 === void 0 || o3.call(e28), e28.show && e28.closeOnEsc && f$1G(t3) && !O3.value && u3(false);
    }
    function u3(t3) {
      const {
        onHide: o3,
        onUpdateShow: n3,
        "onUpdate:show": l3
      } = e28;
      n3 && i$1Z(n3, t3), l3 && i$1Z(l3, t3), o3 && !t3 && i$1Z(o3, t3);
    }
    provide(o$1F, {
      isMountedRef: m3,
      mergedThemeRef: h3,
      mergedClsPrefixRef: i,
      doUpdateShow: u3,
      doUpdateHeight: U3,
      doUpdateWidth: R3
    });
    const b3 = computed(() => {
      const {
        common: {
          cubicBezierEaseInOut: t3,
          cubicBezierEaseIn: o3,
          cubicBezierEaseOut: n3
        },
        self: {
          color: l3,
          textColor: N3,
          boxShadow: A3,
          lineHeight: P3,
          headerPadding: I3,
          footerPadding: D3,
          borderRadius: T3,
          bodyPadding: j3,
          titleFontSize: $3,
          titleTextColor: L3,
          titleFontWeight: _3,
          headerBorderBottom: V10,
          footerBorderTop: K3,
          closeIconColor: q3,
          closeIconColorHover: G3,
          closeIconColorPressed: J3,
          closeColorHover: Q3,
          closeColorPressed: X3,
          closeIconSize: Y3,
          closeSize: Z3,
          closeBorderRadius: ee2,
          resizableTriggerColorHover: te2
        }
      } = h3.value;
      return {
        "--n-line-height": P3,
        "--n-color": l3,
        "--n-border-radius": T3,
        "--n-text-color": N3,
        "--n-box-shadow": A3,
        "--n-bezier": t3,
        "--n-bezier-out": n3,
        "--n-bezier-in": o3,
        "--n-header-padding": I3,
        "--n-body-padding": j3,
        "--n-footer-padding": D3,
        "--n-title-text-color": L3,
        "--n-title-font-size": $3,
        "--n-title-font-weight": _3,
        "--n-header-border-bottom": V10,
        "--n-footer-border-top": K3,
        "--n-close-icon-color": q3,
        "--n-close-icon-color-hover": G3,
        "--n-close-icon-color-pressed": J3,
        "--n-close-size": Z3,
        "--n-close-color-hover": Q3,
        "--n-close-color-pressed": X3,
        "--n-close-icon-size": Y3,
        "--n-close-border-radius": ee2,
        "--n-resize-trigger-color-hover": te2
      };
    }), s3 = f3 ? E$J("drawer", void 0, b3, e28) : void 0;
    return {
      mergedClsPrefix: i,
      namespace: H3,
      mergedBodyStyle: E3,
      handleOutsideClick: W3,
      handleMaskClick: w3,
      handleEsc: M3,
      mergedTheme: h3,
      cssVars: f3 ? void 0 : b3,
      themeClass: s3 == null ? void 0 : s3.themeClass,
      onRender: s3 == null ? void 0 : s3.onRender,
      isMounted: m3
    };
  },
  render() {
    const {
      mergedClsPrefix: e28
    } = this;
    return h$1R(h$1D, {
      to: this.to,
      show: this.show
    }, {
      default: () => {
        var i;
        return (i = this.onRender) === null || i === void 0 || i.call(this), withDirectives(h$1R("div", {
          class: [`${e28}-drawer-container`, this.namespace, this.themeClass],
          style: this.cssVars,
          role: "none"
        }, this.showMask ? h$1R(Transition, {
          name: "fade-in-transition",
          appear: this.isMounted
        }, {
          default: () => this.show ? h$1R("div", {
            "aria-hidden": true,
            class: [`${e28}-drawer-mask`, this.showMask === "transparent" && `${e28}-drawer-mask--invisible`],
            onClick: this.handleMaskClick
          }) : null
        }) : null, h$1R(de$h, Object.assign({}, this.$attrs, {
          class: [this.drawerClass, this.$attrs.class],
          style: [this.mergedBodyStyle, this.$attrs.style],
          blockScroll: this.blockScroll,
          contentStyle: this.contentStyle,
          contentClass: this.contentClass,
          placement: this.placement,
          scrollbarProps: this.scrollbarProps,
          show: this.show,
          displayDirective: this.displayDirective,
          nativeScrollbar: this.nativeScrollbar,
          onAfterEnter: this.onAfterEnter,
          onAfterLeave: this.onAfterLeave,
          trapFocus: this.trapFocus,
          autoFocus: this.autoFocus,
          resizable: this.resizable,
          maxHeight: this.maxHeight,
          minHeight: this.minHeight,
          maxWidth: this.maxWidth,
          minWidth: this.minWidth,
          showMask: this.showMask,
          onEsc: this.handleEsc,
          onClickoutside: this.handleOutsideClick
        }), this.$slots)), [[r$1O, {
          zIndex: this.zIndex,
          enabled: this.show
        }]]);
      }
    });
  }
});
const f$1E = defineComponent({
  name: "UIDrawer",
  inheritAttrs: false
}), m$23 = defineComponent(__spreadProps(__spreadValues({}, f$1E), {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 502
    },
    placement: {
      type: String,
      default: "right"
    },
    id: {
      type: String,
      required: true
    },
    displayDirective: {
      type: String,
      default: "if"
    }
  },
  emits: ["update:show"],
  setup(e28) {
    return (t3, i) => (openBlock(), createBlock(unref(Ae$9), mergeProps({ id: e28.id }, t3.$attrs, {
      show: e28.show,
      width: e28.width,
      placement: e28.placement,
      "onUpdate:show": i[0] || (i[0] = (a3) => t3.$emit("update:show", a3)),
      "display-directive": e28.displayDirective
    }), {
      default: withCtx(() => [
        renderSlot(t3.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "show", "width", "placement", "display-directive"]));
  }
})), c$1X = m$23;
function t$1D(r3) {
  return G$v(r3, [255, 255, 255, 0.16]);
}
function n$1B(r3) {
  return G$v(r3, [0, 0, 0, 0.12]);
}
const n$1A = n$28("n-button-group");
const i$1N = e$1O && "chrome" in window;
e$1O && navigator.userAgent.includes("Firefox");
const e$1H = e$1O && navigator.userAgent.includes("Safari") && !i$1N;
const {
  cubicBezierEaseInOut: t$1C
} = e$2d;
function $$p({
  duration: i = ".2s",
  delay: n3 = ".1s"
} = {}) {
  return [r$2a("&.fade-in-width-expand-transition-leave-from, &.fade-in-width-expand-transition-enter-to", {
    opacity: 1
  }), r$2a("&.fade-in-width-expand-transition-leave-to, &.fade-in-width-expand-transition-enter-from", `
 opacity: 0!important;
 margin-left: 0!important;
 margin-right: 0!important;
 `), r$2a("&.fade-in-width-expand-transition-leave-active", `
 overflow: hidden;
 transition:
 opacity ${i} ${t$1C},
 max-width ${i} ${t$1C} ${n3},
 margin-left ${i} ${t$1C} ${n3},
 margin-right ${i} ${t$1C} ${n3};
 `), r$2a("&.fade-in-width-expand-transition-enter-active", `
 overflow: hidden;
 transition:
 opacity ${i} ${t$1C} ${n3},
 max-width ${i} ${t$1C},
 margin-left ${i} ${t$1C},
 margin-right ${i} ${t$1C};
 `)];
}
const {
  cubicBezierEaseInOut: a$28
} = e$2d;
function m$22({
  originalTransform: o3 = "",
  left: i = 0,
  top: t3 = 0,
  transition: c3 = `all .3s ${a$28} !important`
} = {}) {
  return [r$2a("&.icon-switch-transition-enter-from, &.icon-switch-transition-leave-to", {
    transform: o3 + " scale(0.75)",
    left: i,
    top: t3,
    opacity: 0
  }), r$2a("&.icon-switch-transition-enter-to, &.icon-switch-transition-leave-from", {
    transform: `scale(1) ${o3}`,
    left: i,
    top: t3,
    opacity: 1
  }), r$2a("&.icon-switch-transition-enter-active, &.icon-switch-transition-leave-active", {
    transformOrigin: "center",
    position: "absolute",
    left: i,
    top: t3,
    transition: c3
  })];
}
const v$14 = r$2a([l$25("button", `
 margin: 0;
 font-weight: var(--n-font-weight);
 line-height: 1;
 font-family: inherit;
 padding: var(--n-padding);
 height: var(--n-height);
 font-size: var(--n-font-size);
 border-radius: var(--n-border-radius);
 color: var(--n-text-color);
 background-color: var(--n-color);
 width: var(--n-width);
 white-space: nowrap;
 outline: none;
 position: relative;
 z-index: auto;
 border: none;
 display: inline-flex;
 flex-wrap: nowrap;
 flex-shrink: 0;
 align-items: center;
 justify-content: center;
 user-select: none;
 -webkit-user-select: none;
 text-align: center;
 cursor: pointer;
 text-decoration: none;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [g$1j("color", [M$y("border", {
  borderColor: "var(--n-border-color)"
}), g$1j("disabled", [M$y("border", {
  borderColor: "var(--n-border-color-disabled)"
})]), x$I("disabled", [r$2a("&:focus", [M$y("state-border", {
  borderColor: "var(--n-border-color-focus)"
})]), r$2a("&:hover", [M$y("state-border", {
  borderColor: "var(--n-border-color-hover)"
})]), r$2a("&:active", [M$y("state-border", {
  borderColor: "var(--n-border-color-pressed)"
})]), g$1j("pressed", [M$y("state-border", {
  borderColor: "var(--n-border-color-pressed)"
})])])]), g$1j("disabled", {
  backgroundColor: "var(--n-color-disabled)",
  color: "var(--n-text-color-disabled)"
}, [M$y("border", {
  border: "var(--n-border-disabled)"
})]), x$I("disabled", [r$2a("&:focus", {
  backgroundColor: "var(--n-color-focus)",
  color: "var(--n-text-color-focus)"
}, [M$y("state-border", {
  border: "var(--n-border-focus)"
})]), r$2a("&:hover", {
  backgroundColor: "var(--n-color-hover)",
  color: "var(--n-text-color-hover)"
}, [M$y("state-border", {
  border: "var(--n-border-hover)"
})]), r$2a("&:active", {
  backgroundColor: "var(--n-color-pressed)",
  color: "var(--n-text-color-pressed)"
}, [M$y("state-border", {
  border: "var(--n-border-pressed)"
})]), g$1j("pressed", {
  backgroundColor: "var(--n-color-pressed)",
  color: "var(--n-text-color-pressed)"
}, [M$y("state-border", {
  border: "var(--n-border-pressed)"
})])]), g$1j("loading", "cursor: wait;"), l$25("base-wave", `
 pointer-events: none;
 top: 0;
 right: 0;
 bottom: 0;
 left: 0;
 animation-iteration-count: 1;
 animation-duration: var(--n-ripple-duration);
 animation-timing-function: var(--n-bezier-ease-out), var(--n-bezier-ease-out);
 `, [g$1j("active", {
  zIndex: 1,
  animationName: "button-wave-spread, button-wave-opacity"
})]), e$1O && "MozBoxSizing" in document.createElement("div").style ? r$2a("&::moz-focus-inner", {
  border: 0
}) : null, M$y("border, state-border", `
 position: absolute;
 left: 0;
 top: 0;
 right: 0;
 bottom: 0;
 border-radius: inherit;
 transition: border-color .3s var(--n-bezier);
 pointer-events: none;
 `), M$y("border", {
  border: "var(--n-border)"
}), M$y("state-border", {
  border: "var(--n-border)",
  borderColor: "#0000",
  zIndex: 1
}), M$y("icon", `
 margin: var(--n-icon-margin);
 margin-left: 0;
 height: var(--n-icon-size);
 width: var(--n-icon-size);
 max-width: var(--n-icon-size);
 font-size: var(--n-icon-size);
 position: relative;
 flex-shrink: 0;
 `, [l$25("icon-slot", `
 height: var(--n-icon-size);
 width: var(--n-icon-size);
 position: absolute;
 left: 0;
 top: 50%;
 transform: translateY(-50%);
 display: flex;
 align-items: center;
 justify-content: center;
 `, [m$22({
  top: "50%",
  originalTransform: "translateY(-50%)"
})]), $$p()]), M$y("content", `
 display: flex;
 align-items: center;
 flex-wrap: nowrap;
 min-width: 0;
 `, [r$2a("~", [M$y("icon", {
  margin: "var(--n-icon-margin)",
  marginRight: 0
})])]), g$1j("block", `
 display: flex;
 width: 100%;
 `), g$1j("dashed", [M$y("border, state-border", {
  borderStyle: "dashed !important"
})]), g$1j("disabled", {
  cursor: "not-allowed",
  opacity: "var(--n-opacity-disabled)"
})]), r$2a("@keyframes button-wave-spread", {
  from: {
    boxShadow: "0 0 0.5px 0 var(--n-ripple-color)"
  },
  to: {
    boxShadow: "0 0 0.5px 4.5px var(--n-ripple-color)"
  }
}), r$2a("@keyframes button-wave-opacity", {
  from: {
    opacity: "var(--n-wave-opacity)"
  },
  to: {
    opacity: 0
  }
})]);
const f$1D = n$28("n-form-item");
function h$1B(t3, {
  defaultSize: a3 = "medium",
  mergedSize: o3,
  mergedDisabled: i
} = {}) {
  const e28 = inject(f$1D, null);
  provide(f$1D, null);
  const d3 = computed(o3 ? () => o3(e28) : () => {
    const {
      size: n3
    } = t3;
    if (n3)
      return n3;
    if (e28) {
      const {
        mergedSize: u3
      } = e28;
      if (u3.value !== void 0)
        return u3.value;
    }
    return a3;
  }), m3 = computed(i ? () => i(e28) : () => {
    const {
      disabled: n3
    } = t3;
    return n3 !== void 0 ? n3 : e28 ? e28.disabled.value : false;
  }), l3 = computed(() => {
    const {
      status: n3
    } = t3;
    return n3 || (e28 == null ? void 0 : e28.mergedValidationStatus.value);
  });
  return onBeforeUnmount(() => {
    e28 && e28.restoreValidation();
  }), {
    mergedSizeRef: d3,
    mergedDisabledRef: m3,
    mergedStatusRef: l3,
    nTriggerFormBlur() {
      e28 && e28.handleContentBlur();
    },
    nTriggerFormChange() {
      e28 && e28.handleContentChange();
    },
    nTriggerFormFocus() {
      e28 && e28.handleContentFocus();
    },
    nTriggerFormInput() {
      e28 && e28.handleContentInput();
    }
  };
}
const i$1M = {
  paddingTiny: "0 6px",
  paddingSmall: "0 10px",
  paddingMedium: "0 14px",
  paddingLarge: "0 18px",
  paddingRoundTiny: "0 10px",
  paddingRoundSmall: "0 14px",
  paddingRoundMedium: "0 18px",
  paddingRoundLarge: "0 22px",
  iconMarginTiny: "6px",
  iconMarginSmall: "6px",
  iconMarginMedium: "6px",
  iconMarginLarge: "6px",
  iconSizeTiny: "14px",
  iconSizeSmall: "18px",
  iconSizeMedium: "18px",
  iconSizeLarge: "20px",
  rippleDuration: ".6s"
};
const z$u = (H3) => {
  const {
    heightTiny: S3,
    heightSmall: f3,
    heightMedium: T3,
    heightLarge: D3,
    borderRadius: u3,
    fontSizeTiny: $3,
    fontSizeSmall: F3,
    fontSizeMedium: G3,
    fontSizeLarge: W3,
    opacityDisabled: E3,
    textColor2: e28,
    textColor3: I3,
    primaryColorHover: r3,
    primaryColorPressed: s3,
    borderColor: h3,
    primaryColor: t3,
    baseColor: o3,
    infoColor: l3,
    infoColorHover: i,
    infoColorPressed: b3,
    successColor: x3,
    successColorHover: d3,
    successColorPressed: P3,
    warningColor: c3,
    warningColorHover: a3,
    warningColorPressed: p3,
    errorColor: n3,
    errorColorHover: C3,
    errorColorPressed: y3,
    fontWeight: L3,
    buttonColor2: v3,
    buttonColor2Hover: m3,
    buttonColor2Pressed: g3,
    fontWeightStrong: O3
  } = H3;
  return Object.assign(Object.assign({}, i$1M), {
    heightTiny: S3,
    heightSmall: f3,
    heightMedium: T3,
    heightLarge: D3,
    borderRadiusTiny: u3,
    borderRadiusSmall: u3,
    borderRadiusMedium: u3,
    borderRadiusLarge: u3,
    fontSizeTiny: $3,
    fontSizeSmall: F3,
    fontSizeMedium: G3,
    fontSizeLarge: W3,
    opacityDisabled: E3,
    colorOpacitySecondary: "0.16",
    colorOpacitySecondaryHover: "0.22",
    colorOpacitySecondaryPressed: "0.28",
    colorSecondary: v3,
    colorSecondaryHover: m3,
    colorSecondaryPressed: g3,
    colorTertiary: v3,
    colorTertiaryHover: m3,
    colorTertiaryPressed: g3,
    colorQuaternary: "#0000",
    colorQuaternaryHover: m3,
    colorQuaternaryPressed: g3,
    color: "#0000",
    colorHover: "#0000",
    colorPressed: "#0000",
    colorFocus: "#0000",
    colorDisabled: "#0000",
    textColor: e28,
    textColorTertiary: I3,
    textColorHover: r3,
    textColorPressed: s3,
    textColorFocus: r3,
    textColorDisabled: e28,
    textColorText: e28,
    textColorTextHover: r3,
    textColorTextPressed: s3,
    textColorTextFocus: r3,
    textColorTextDisabled: e28,
    textColorGhost: e28,
    textColorGhostHover: r3,
    textColorGhostPressed: s3,
    textColorGhostFocus: r3,
    textColorGhostDisabled: e28,
    border: `1px solid ${h3}`,
    borderHover: `1px solid ${r3}`,
    borderPressed: `1px solid ${s3}`,
    borderFocus: `1px solid ${r3}`,
    borderDisabled: `1px solid ${h3}`,
    rippleColor: t3,
    colorPrimary: t3,
    colorHoverPrimary: r3,
    colorPressedPrimary: s3,
    colorFocusPrimary: r3,
    colorDisabledPrimary: t3,
    textColorPrimary: o3,
    textColorHoverPrimary: o3,
    textColorPressedPrimary: o3,
    textColorFocusPrimary: o3,
    textColorDisabledPrimary: o3,
    textColorTextPrimary: t3,
    textColorTextHoverPrimary: r3,
    textColorTextPressedPrimary: s3,
    textColorTextFocusPrimary: r3,
    textColorTextDisabledPrimary: e28,
    textColorGhostPrimary: t3,
    textColorGhostHoverPrimary: r3,
    textColorGhostPressedPrimary: s3,
    textColorGhostFocusPrimary: r3,
    textColorGhostDisabledPrimary: t3,
    borderPrimary: `1px solid ${t3}`,
    borderHoverPrimary: `1px solid ${r3}`,
    borderPressedPrimary: `1px solid ${s3}`,
    borderFocusPrimary: `1px solid ${r3}`,
    borderDisabledPrimary: `1px solid ${t3}`,
    rippleColorPrimary: t3,
    colorInfo: l3,
    colorHoverInfo: i,
    colorPressedInfo: b3,
    colorFocusInfo: i,
    colorDisabledInfo: l3,
    textColorInfo: o3,
    textColorHoverInfo: o3,
    textColorPressedInfo: o3,
    textColorFocusInfo: o3,
    textColorDisabledInfo: o3,
    textColorTextInfo: l3,
    textColorTextHoverInfo: i,
    textColorTextPressedInfo: b3,
    textColorTextFocusInfo: i,
    textColorTextDisabledInfo: e28,
    textColorGhostInfo: l3,
    textColorGhostHoverInfo: i,
    textColorGhostPressedInfo: b3,
    textColorGhostFocusInfo: i,
    textColorGhostDisabledInfo: l3,
    borderInfo: `1px solid ${l3}`,
    borderHoverInfo: `1px solid ${i}`,
    borderPressedInfo: `1px solid ${b3}`,
    borderFocusInfo: `1px solid ${i}`,
    borderDisabledInfo: `1px solid ${l3}`,
    rippleColorInfo: l3,
    colorSuccess: x3,
    colorHoverSuccess: d3,
    colorPressedSuccess: P3,
    colorFocusSuccess: d3,
    colorDisabledSuccess: x3,
    textColorSuccess: o3,
    textColorHoverSuccess: o3,
    textColorPressedSuccess: o3,
    textColorFocusSuccess: o3,
    textColorDisabledSuccess: o3,
    textColorTextSuccess: x3,
    textColorTextHoverSuccess: d3,
    textColorTextPressedSuccess: P3,
    textColorTextFocusSuccess: d3,
    textColorTextDisabledSuccess: e28,
    textColorGhostSuccess: x3,
    textColorGhostHoverSuccess: d3,
    textColorGhostPressedSuccess: P3,
    textColorGhostFocusSuccess: d3,
    textColorGhostDisabledSuccess: x3,
    borderSuccess: `1px solid ${x3}`,
    borderHoverSuccess: `1px solid ${d3}`,
    borderPressedSuccess: `1px solid ${P3}`,
    borderFocusSuccess: `1px solid ${d3}`,
    borderDisabledSuccess: `1px solid ${x3}`,
    rippleColorSuccess: x3,
    colorWarning: c3,
    colorHoverWarning: a3,
    colorPressedWarning: p3,
    colorFocusWarning: a3,
    colorDisabledWarning: c3,
    textColorWarning: o3,
    textColorHoverWarning: o3,
    textColorPressedWarning: o3,
    textColorFocusWarning: o3,
    textColorDisabledWarning: o3,
    textColorTextWarning: c3,
    textColorTextHoverWarning: a3,
    textColorTextPressedWarning: p3,
    textColorTextFocusWarning: a3,
    textColorTextDisabledWarning: e28,
    textColorGhostWarning: c3,
    textColorGhostHoverWarning: a3,
    textColorGhostPressedWarning: p3,
    textColorGhostFocusWarning: a3,
    textColorGhostDisabledWarning: c3,
    borderWarning: `1px solid ${c3}`,
    borderHoverWarning: `1px solid ${a3}`,
    borderPressedWarning: `1px solid ${p3}`,
    borderFocusWarning: `1px solid ${a3}`,
    borderDisabledWarning: `1px solid ${c3}`,
    rippleColorWarning: c3,
    colorError: n3,
    colorHoverError: C3,
    colorPressedError: y3,
    colorFocusError: C3,
    colorDisabledError: n3,
    textColorError: o3,
    textColorHoverError: o3,
    textColorPressedError: o3,
    textColorFocusError: o3,
    textColorDisabledError: o3,
    textColorTextError: n3,
    textColorTextHoverError: C3,
    textColorTextPressedError: y3,
    textColorTextFocusError: C3,
    textColorTextDisabledError: e28,
    textColorGhostError: n3,
    textColorGhostHoverError: C3,
    textColorGhostPressedError: y3,
    textColorGhostFocusError: C3,
    textColorGhostDisabledError: n3,
    borderError: `1px solid ${n3}`,
    borderHoverError: `1px solid ${C3}`,
    borderPressedError: `1px solid ${y3}`,
    borderFocusError: `1px solid ${C3}`,
    borderDisabledError: `1px solid ${n3}`,
    rippleColorError: n3,
    waveOpacity: "0.6",
    fontWeight: L3,
    fontWeightStrong: O3
  });
}, M$v = {
  name: "Button",
  common: d$1T,
  self: z$u
}, B$P = M$v;
function e$1G(r3) {
  return r3.replace(/#|\(|\)|,|\s|\./g, "_");
}
const m$21 = defineComponent({
  name: "BaseIconSwitchTransition",
  setup(r3, {
    slots: n3
  }) {
    const t3 = u$1C();
    return () => h$1R(Transition, {
      name: "icon-switch-transition",
      appear: t3.value
    }, n3);
  }
});
const n$1z = r$2a([r$2a("@keyframes rotator", `
 0% {
 -webkit-transform: rotate(0deg);
 transform: rotate(0deg);
 }
 100% {
 -webkit-transform: rotate(360deg);
 transform: rotate(360deg);
 }`), l$25("base-loading", `
 position: relative;
 line-height: 0;
 width: 1em;
 height: 1em;
 `, [M$y("transition-wrapper", `
 position: absolute;
 width: 100%;
 height: 100%;
 `, [m$22()]), M$y("placeholder", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 `, [m$22({
  left: "50%",
  top: "50%",
  originalTransform: "translateX(-50%) translateY(-50%)"
})]), M$y("container", `
 animation: rotator 3s linear infinite both;
 `, [M$y("icon", `
 height: 1em;
 width: 1em;
 `)])])]);
const r$1N = "1.6s", p$3E = {
  strokeWidth: {
    type: Number,
    default: 28
  },
  stroke: {
    type: String,
    default: void 0
  }
}, h$1A = defineComponent({
  name: "BaseLoading",
  props: Object.assign({
    clsPrefix: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      default: true
    },
    scale: {
      type: Number,
      default: 1
    },
    radius: {
      type: Number,
      default: 100
    }
  }, p$3E),
  setup(a3) {
    S$O("-base-loading", n$1z, toRef$1(a3, "clsPrefix"));
  },
  render() {
    const {
      clsPrefix: a3,
      radius: s3,
      strokeWidth: o3,
      stroke: i,
      scale: n3
    } = this, e28 = s3 / n3;
    return h$1R("div", {
      class: `${a3}-base-loading`,
      role: "img",
      "aria-label": "loading"
    }, h$1R(m$21, null, {
      default: () => this.show ? h$1R("div", {
        key: "icon",
        class: `${a3}-base-loading__transition-wrapper`
      }, h$1R("div", {
        class: `${a3}-base-loading__container`
      }, h$1R("svg", {
        class: `${a3}-base-loading__icon`,
        viewBox: `0 0 ${2 * e28} ${2 * e28}`,
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          color: i
        }
      }, h$1R("g", null, h$1R("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        values: `0 ${e28} ${e28};270 ${e28} ${e28}`,
        begin: "0s",
        dur: r$1N,
        fill: "freeze",
        repeatCount: "indefinite"
      }), h$1R("circle", {
        class: `${a3}-base-loading__icon`,
        fill: "none",
        stroke: "currentColor",
        "stroke-width": o3,
        "stroke-linecap": "round",
        cx: e28,
        cy: e28,
        r: s3 - o3 / 2,
        "stroke-dasharray": 5.67 * s3,
        "stroke-dashoffset": 18.48 * s3
      }, h$1R("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        values: `0 ${e28} ${e28};135 ${e28} ${e28};450 ${e28} ${e28}`,
        begin: "0s",
        dur: r$1N,
        fill: "freeze",
        repeatCount: "indefinite"
      }), h$1R("animate", {
        attributeName: "stroke-dashoffset",
        values: `${5.67 * s3};${1.42 * s3};${5.67 * s3}`,
        begin: "0s",
        dur: r$1N,
        fill: "freeze",
        repeatCount: "indefinite"
      })))))) : h$1R("div", {
        key: "placeholder",
        class: `${a3}-base-loading__placeholder`
      }, this.$slots)
    }));
  }
});
const e$1F = l$25("base-wave", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
`);
const w$P = defineComponent({
  name: "BaseWave",
  props: {
    clsPrefix: {
      type: String,
      required: true
    }
  },
  setup(t3) {
    S$O("-base-wave", e$1F, toRef$1(t3, "clsPrefix"));
    const l3 = ref$1(null), i = ref$1(false);
    let e28 = null;
    return onBeforeUnmount(() => {
      e28 !== null && window.clearTimeout(e28);
    }), {
      active: i,
      selfRef: l3,
      play() {
        e28 !== null && (window.clearTimeout(e28), i.value = false, e28 = null), nextTick(() => {
          var a3;
          (a3 = l3.value) === null || a3 === void 0 || a3.offsetHeight, i.value = true, e28 = window.setTimeout(() => {
            i.value = false, e28 = null;
          }, 1e3);
        });
      }
    };
  },
  render() {
    const {
      clsPrefix: t3
    } = this;
    return h$1R("div", {
      ref: "selfRef",
      "aria-hidden": true,
      class: [`${t3}-base-wave`, this.active && `${t3}-base-wave--active`]
    });
  }
});
const Io$3 = Object.assign(Object.assign({}, _$F.props), {
  color: String,
  textColor: String,
  text: Boolean,
  block: Boolean,
  loading: Boolean,
  disabled: Boolean,
  circle: Boolean,
  size: String,
  ghost: Boolean,
  round: Boolean,
  secondary: Boolean,
  tertiary: Boolean,
  quaternary: Boolean,
  strong: Boolean,
  focusable: {
    type: Boolean,
    default: true
  },
  keyboard: {
    type: Boolean,
    default: true
  },
  tag: {
    type: String,
    default: "button"
  },
  type: {
    type: String,
    default: "default"
  },
  dashed: Boolean,
  renderIcon: Function,
  iconPlacement: {
    type: String,
    default: "left"
  },
  attrType: {
    type: String,
    default: "button"
  },
  bordered: {
    type: Boolean,
    default: true
  },
  onClick: [Function, Array],
  nativeFocusBehavior: {
    type: Boolean,
    default: !e$1H
  }
}), A$F = defineComponent({
  name: "Button",
  props: Io$3,
  setup(e28) {
    const S3 = ref$1(null), v3 = ref$1(null), b3 = ref$1(false), m3 = n$1U(() => !e28.quaternary && !e28.tertiary && !e28.secondary && !e28.text && (!e28.color || e28.ghost || e28.dashed) && e28.bordered), X3 = inject(n$1A, {}), {
      mergedSizeRef: R3
    } = h$1B({}, {
      defaultSize: "medium",
      mergedSize: (t3) => {
        const {
          size: a3
        } = e28;
        if (a3)
          return a3;
        const {
          size: d3
        } = X3;
        if (d3)
          return d3;
        const {
          mergedSize: o3
        } = t3 || {};
        return o3 ? o3.value : "medium";
      }
    }), H3 = computed(() => e28.focusable && !e28.disabled), J3 = (t3) => {
      var a3;
      H3.value || t3.preventDefault(), !e28.nativeFocusBehavior && (t3.preventDefault(), !e28.disabled && H3.value && ((a3 = S3.value) === null || a3 === void 0 || a3.focus({
        preventScroll: true
      })));
    }, U3 = (t3) => {
      var a3;
      if (!e28.disabled && !e28.loading) {
        const {
          onClick: d3
        } = e28;
        d3 && i$1Z(d3, t3), e28.text || (a3 = v3.value) === null || a3 === void 0 || a3.play();
      }
    }, Y3 = (t3) => {
      switch (t3.key) {
        case "Enter":
          if (!e28.keyboard)
            return;
          b3.value = false;
      }
    }, Z3 = (t3) => {
      switch (t3.key) {
        case "Enter":
          if (!e28.keyboard || e28.loading) {
            t3.preventDefault();
            return;
          }
          b3.value = true;
      }
    }, oo2 = () => {
      b3.value = false;
    }, {
      inlineThemeDisabled: G3,
      mergedClsPrefixRef: k3,
      mergedRtlRef: eo2
    } = a$2x(e28), to2 = _$F("Button", "-button", v$14, B$P, e28, k3), ro2 = v$17("Button", eo2, k3), K3 = computed(() => {
      const t3 = to2.value, {
        common: {
          cubicBezierEaseInOut: a3,
          cubicBezierEaseOut: d3
        },
        self: o3
      } = t3, {
        rippleDuration: B3,
        opacityDisabled: C3,
        fontWeight: E3,
        fontWeightStrong: O3
      } = o3, u3 = R3.value, {
        dashed: D3,
        type: y3,
        ghost: F3,
        text: h3,
        color: l3,
        round: V10,
        circle: I3,
        textColor: p3,
        secondary: no2,
        tertiary: q3,
        quaternary: lo2,
        strong: io2
      } = e28, so2 = {
        "font-weight": io2 ? O3 : E3
      };
      let i = {
        "--n-color": "initial",
        "--n-color-hover": "initial",
        "--n-color-pressed": "initial",
        "--n-color-focus": "initial",
        "--n-color-disabled": "initial",
        "--n-ripple-color": "initial",
        "--n-text-color": "initial",
        "--n-text-color-hover": "initial",
        "--n-text-color-pressed": "initial",
        "--n-text-color-focus": "initial",
        "--n-text-color-disabled": "initial"
      };
      const P3 = y3 === "tertiary", M3 = y3 === "default", n3 = P3 ? "default" : y3;
      if (h3) {
        const s3 = p3 || l3;
        i = {
          "--n-color": "#0000",
          "--n-color-hover": "#0000",
          "--n-color-pressed": "#0000",
          "--n-color-focus": "#0000",
          "--n-color-disabled": "#0000",
          "--n-ripple-color": "#0000",
          "--n-text-color": s3 || o3[_$H("textColorText", n3)],
          "--n-text-color-hover": s3 ? t$1D(s3) : o3[_$H("textColorTextHover", n3)],
          "--n-text-color-pressed": s3 ? n$1B(s3) : o3[_$H("textColorTextPressed", n3)],
          "--n-text-color-focus": s3 ? t$1D(s3) : o3[_$H("textColorTextHover", n3)],
          "--n-text-color-disabled": s3 || o3[_$H("textColorTextDisabled", n3)]
        };
      } else if (F3 || D3) {
        const s3 = p3 || l3;
        i = {
          "--n-color": "#0000",
          "--n-color-hover": "#0000",
          "--n-color-pressed": "#0000",
          "--n-color-focus": "#0000",
          "--n-color-disabled": "#0000",
          "--n-ripple-color": l3 || o3[_$H("rippleColor", n3)],
          "--n-text-color": s3 || o3[_$H("textColorGhost", n3)],
          "--n-text-color-hover": s3 ? t$1D(s3) : o3[_$H("textColorGhostHover", n3)],
          "--n-text-color-pressed": s3 ? n$1B(s3) : o3[_$H("textColorGhostPressed", n3)],
          "--n-text-color-focus": s3 ? t$1D(s3) : o3[_$H("textColorGhostHover", n3)],
          "--n-text-color-disabled": s3 || o3[_$H("textColorGhostDisabled", n3)]
        };
      } else if (no2) {
        const s3 = M3 ? o3.textColor : P3 ? o3.textColorTertiary : o3[_$H("color", n3)], c3 = l3 || s3, T3 = y3 !== "default" && y3 !== "tertiary";
        i = {
          "--n-color": T3 ? J$p(c3, {
            alpha: Number(o3.colorOpacitySecondary)
          }) : o3.colorSecondary,
          "--n-color-hover": T3 ? J$p(c3, {
            alpha: Number(o3.colorOpacitySecondaryHover)
          }) : o3.colorSecondaryHover,
          "--n-color-pressed": T3 ? J$p(c3, {
            alpha: Number(o3.colorOpacitySecondaryPressed)
          }) : o3.colorSecondaryPressed,
          "--n-color-focus": T3 ? J$p(c3, {
            alpha: Number(o3.colorOpacitySecondaryHover)
          }) : o3.colorSecondaryHover,
          "--n-color-disabled": o3.colorSecondary,
          "--n-ripple-color": "#0000",
          "--n-text-color": c3,
          "--n-text-color-hover": c3,
          "--n-text-color-pressed": c3,
          "--n-text-color-focus": c3,
          "--n-text-color-disabled": c3
        };
      } else if (q3 || lo2) {
        const s3 = M3 ? o3.textColor : P3 ? o3.textColorTertiary : o3[_$H("color", n3)], c3 = l3 || s3;
        q3 ? (i["--n-color"] = o3.colorTertiary, i["--n-color-hover"] = o3.colorTertiaryHover, i["--n-color-pressed"] = o3.colorTertiaryPressed, i["--n-color-focus"] = o3.colorSecondaryHover, i["--n-color-disabled"] = o3.colorTertiary) : (i["--n-color"] = o3.colorQuaternary, i["--n-color-hover"] = o3.colorQuaternaryHover, i["--n-color-pressed"] = o3.colorQuaternaryPressed, i["--n-color-focus"] = o3.colorQuaternaryHover, i["--n-color-disabled"] = o3.colorQuaternary), i["--n-ripple-color"] = "#0000", i["--n-text-color"] = c3, i["--n-text-color-hover"] = c3, i["--n-text-color-pressed"] = c3, i["--n-text-color-focus"] = c3, i["--n-text-color-disabled"] = c3;
      } else
        i = {
          "--n-color": l3 || o3[_$H("color", n3)],
          "--n-color-hover": l3 ? t$1D(l3) : o3[_$H("colorHover", n3)],
          "--n-color-pressed": l3 ? n$1B(l3) : o3[_$H("colorPressed", n3)],
          "--n-color-focus": l3 ? t$1D(l3) : o3[_$H("colorFocus", n3)],
          "--n-color-disabled": l3 || o3[_$H("colorDisabled", n3)],
          "--n-ripple-color": l3 || o3[_$H("rippleColor", n3)],
          "--n-text-color": p3 || (l3 ? o3.textColorPrimary : P3 ? o3.textColorTertiary : o3[_$H("textColor", n3)]),
          "--n-text-color-hover": p3 || (l3 ? o3.textColorHoverPrimary : o3[_$H("textColorHover", n3)]),
          "--n-text-color-pressed": p3 || (l3 ? o3.textColorPressedPrimary : o3[_$H("textColorPressed", n3)]),
          "--n-text-color-focus": p3 || (l3 ? o3.textColorFocusPrimary : o3[_$H("textColorFocus", n3)]),
          "--n-text-color-disabled": p3 || (l3 ? o3.textColorDisabledPrimary : o3[_$H("textColorDisabled", n3)])
        };
      let N3 = {
        "--n-border": "initial",
        "--n-border-hover": "initial",
        "--n-border-pressed": "initial",
        "--n-border-focus": "initial",
        "--n-border-disabled": "initial"
      };
      h3 ? N3 = {
        "--n-border": "none",
        "--n-border-hover": "none",
        "--n-border-pressed": "none",
        "--n-border-focus": "none",
        "--n-border-disabled": "none"
      } : N3 = {
        "--n-border": o3[_$H("border", n3)],
        "--n-border-hover": o3[_$H("borderHover", n3)],
        "--n-border-pressed": o3[_$H("borderPressed", n3)],
        "--n-border-focus": o3[_$H("borderFocus", n3)],
        "--n-border-disabled": o3[_$H("borderDisabled", n3)]
      };
      const {
        [_$H("height", u3)]: _3,
        [_$H("fontSize", u3)]: ao2,
        [_$H("padding", u3)]: co2,
        [_$H("paddingRound", u3)]: uo2,
        [_$H("iconSize", u3)]: fo2,
        [_$H("borderRadius", u3)]: ho2,
        [_$H("iconMargin", u3)]: bo2,
        waveOpacity: mo2
      } = o3, yo2 = {
        "--n-width": I3 && !h3 ? _3 : "initial",
        "--n-height": h3 ? "initial" : _3,
        "--n-font-size": ao2,
        "--n-padding": I3 || h3 ? "initial" : V10 ? uo2 : co2,
        "--n-icon-size": fo2,
        "--n-icon-margin": bo2,
        "--n-border-radius": h3 ? "initial" : I3 || V10 ? _3 : ho2
      };
      return Object.assign(Object.assign(Object.assign(Object.assign({
        "--n-bezier": a3,
        "--n-bezier-ease-out": d3,
        "--n-ripple-duration": B3,
        "--n-opacity-disabled": C3,
        "--n-wave-opacity": mo2
      }, so2), i), N3), yo2);
    }), g3 = G3 ? E$J("button", computed(() => {
      let t3 = "";
      const {
        dashed: a3,
        type: d3,
        ghost: o3,
        text: B3,
        color: C3,
        round: E3,
        circle: O3,
        textColor: u3,
        secondary: D3,
        tertiary: y3,
        quaternary: F3,
        strong: h3
      } = e28;
      a3 && (t3 += "a"), o3 && (t3 += "b"), B3 && (t3 += "c"), E3 && (t3 += "d"), O3 && (t3 += "e"), D3 && (t3 += "f"), y3 && (t3 += "g"), F3 && (t3 += "h"), h3 && (t3 += "i"), C3 && (t3 += "j" + e$1G(C3)), u3 && (t3 += "k" + e$1G(u3));
      const {
        value: l3
      } = R3;
      return t3 += "l" + l3[0], t3 += "m" + d3[0], t3;
    }), K3, e28) : void 0;
    return {
      selfElRef: S3,
      waveElRef: v3,
      mergedClsPrefix: k3,
      mergedFocusable: H3,
      mergedSize: R3,
      showBorder: m3,
      enterPressed: b3,
      rtlEnabled: ro2,
      handleMousedown: J3,
      handleKeydown: Z3,
      handleBlur: oo2,
      handleKeyup: Y3,
      handleClick: U3,
      customColorCssVars: computed(() => {
        const {
          color: t3
        } = e28;
        if (!t3)
          return null;
        const a3 = t$1D(t3);
        return {
          "--n-border-color": t3,
          "--n-border-color-hover": a3,
          "--n-border-color-pressed": n$1B(t3),
          "--n-border-color-focus": a3,
          "--n-border-color-disabled": t3
        };
      }),
      cssVars: G3 ? void 0 : K3,
      themeClass: g3 == null ? void 0 : g3.themeClass,
      onRender: g3 == null ? void 0 : g3.onRender
    };
  },
  render() {
    const {
      mergedClsPrefix: e28,
      tag: S3,
      onRender: v3
    } = this;
    v3 == null || v3();
    const b3 = m$26(this.$slots.default, (m3) => m3 && h$1R("span", {
      class: `${e28}-button__content`
    }, m3));
    return h$1R(S3, {
      ref: "selfElRef",
      class: [
        this.themeClass,
        `${e28}-button`,
        `${e28}-button--${this.type}-type`,
        `${e28}-button--${this.mergedSize}-type`,
        this.rtlEnabled && `${e28}-button--rtl`,
        this.disabled && `${e28}-button--disabled`,
        this.block && `${e28}-button--block`,
        this.enterPressed && `${e28}-button--pressed`,
        !this.text && this.dashed && `${e28}-button--dashed`,
        this.color && `${e28}-button--color`,
        this.secondary && `${e28}-button--secondary`,
        this.loading && `${e28}-button--loading`,
        this.ghost && `${e28}-button--ghost`
      ],
      tabindex: this.mergedFocusable ? 0 : -1,
      type: this.attrType,
      style: this.cssVars,
      disabled: this.disabled,
      onClick: this.handleClick,
      onBlur: this.handleBlur,
      onMousedown: this.handleMousedown,
      onKeyup: this.handleKeyup,
      onKeydown: this.handleKeydown
    }, this.iconPlacement === "right" && b3, h$1R(l$1W, {
      width: true
    }, {
      default: () => m$26(this.$slots.icon, (m3) => (this.loading || this.renderIcon || m3) && h$1R("span", {
        class: `${e28}-button__icon`,
        style: {
          margin: a$2k(this.$slots.default) ? "0" : ""
        }
      }, h$1R(m$21, null, {
        default: () => this.loading ? h$1R(h$1A, {
          clsPrefix: e28,
          key: "loading",
          class: `${e28}-icon-slot`,
          strokeWidth: 20
        }) : h$1R("div", {
          key: "icon",
          class: `${e28}-icon-slot`,
          role: "none"
        }, this.renderIcon ? this.renderIcon() : m3)
      })))
    }), this.iconPlacement === "left" && b3, this.text ? null : h$1R(w$P, {
      ref: "waveElRef",
      clsPrefix: e28
    }), this.showBorder ? h$1R("div", {
      "aria-hidden": true,
      class: `${e28}-button__border`,
      style: this.customColorCssVars
    }) : null, this.showBorder ? h$1R("div", {
      "aria-hidden": true,
      class: `${e28}-button__state-border`,
      style: this.customColorCssVars
    }) : null);
  }
}), le$g = A$F, ie$h = A$F;
const B$O = defineComponent({
  name: "UIButton"
}), k$K = defineComponent(__spreadProps(__spreadValues({}, B$O), {
  props: {
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "default"
    },
    size: {
      type: String,
      default: "medium"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    ghost: {
      type: Boolean,
      default: false
    },
    quaternary: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: void 0
    },
    linkGray: {
      type: Boolean
    }
  },
  emits: ["click"],
  setup(e28) {
    const o3 = useSlots();
    return (t3, l3) => (openBlock(), createBlock(unref(le$g), mergeProps({
      id: e28.id,
      text: e28.text,
      class: [
        e28.quaternary ? "quaternary" : null,
        e28.circle || e28.text ? "icon-only" : null,
        e28.active ? "hl-active-btn" : null,
        e28.text ? "hl-text-btn" : null,
        e28.linkGray ? "hl-linkgray-btn" : null
      ],
      type: e28.type,
      size: e28.size
    }, t3.$attrs, {
      disabled: e28.disabled,
      loading: e28.loading,
      onClick: l3[0] || (l3[0] = (u3) => t3.$emit("click", u3)),
      quaternary: e28.quaternary,
      circle: e28.circle,
      linkGray: e28.linkGray
    }), {
      default: withCtx(() => [
        renderSlot(t3.$slots, "default"),
        unref(o3).icon ? renderSlot(t3.$slots, "icon", { key: 0 }) : createCommentVNode("", true)
      ]),
      _: 3
    }, 16, ["id", "text", "class", "type", "size", "disabled", "loading", "quaternary", "circle", "linkGray"]));
  }
})), q$C = k$K;
const s$1X = l$25("base-close", `
 display: flex;
 align-items: center;
 justify-content: center;
 cursor: pointer;
 background-color: transparent;
 color: var(--n-close-icon-color);
 border-radius: var(--n-close-border-radius);
 height: var(--n-close-size);
 width: var(--n-close-size);
 font-size: var(--n-close-icon-size);
 outline: none;
 border: none;
 position: relative;
 padding: 0;
`, [g$1j("absolute", `
 height: var(--n-close-icon-size);
 width: var(--n-close-icon-size);
 `), r$2a("&::before", `
 content: "";
 position: absolute;
 width: var(--n-close-size);
 height: var(--n-close-size);
 left: 50%;
 top: 50%;
 transform: translateY(-50%) translateX(-50%);
 transition: inherit;
 border-radius: inherit;
 `), x$I("disabled", [r$2a("&:hover", `
 color: var(--n-close-icon-color-hover);
 `), r$2a("&:hover::before", `
 background-color: var(--n-close-color-hover);
 `), r$2a("&:focus::before", `
 background-color: var(--n-close-color-hover);
 `), r$2a("&:active", `
 color: var(--n-close-icon-color-pressed);
 `), r$2a("&:active::before", `
 background-color: var(--n-close-color-pressed);
 `)]), g$1j("disabled", `
 cursor: not-allowed;
 color: var(--n-close-icon-color-disabled);
 background-color: transparent;
 `), g$1j("round", [r$2a("&::before", `
 border-radius: 50%;
 `)])]);
function c$1W(u3, i, e28) {
  var f3 = -1, l3 = u3.length;
  i < 0 && (i = -i > l3 ? 0 : l3 + i), e28 = e28 > l3 ? l3 : e28, e28 < 0 && (e28 += l3), l3 = i > e28 ? 0 : e28 - i >>> 0, i >>>= 0;
  for (var h3 = Array(l3); ++f3 < l3; )
    h3[f3] = u3[f3 + i];
  return h3;
}
function o$1x(t3, i, e28) {
  var l3 = t3.length;
  return e28 = e28 === void 0 ? l3 : e28, !i && e28 >= l3 ? t3 : c$1W(t3, i, e28);
}
var a$27 = "\\ud800-\\udfff", r$1M = "\\u0300-\\u036f", f$1C = "\\ufe20-\\ufe2f", s$1W = "\\u20d0-\\u20ff", u$1A = r$1M + f$1C + s$1W, o$1w = "\\ufe0e\\ufe0f", n$1y = "\\u200d", d$1M = RegExp("[" + n$1y + a$27 + u$1A + o$1w + "]");
function g$1d(e28) {
  return d$1M.test(e28);
}
function t$1B(r3) {
  return r3.split("");
}
var u$1z = "\\ud800-\\udfff", t$1A = "\\u0300-\\u036f", i$1L = "\\ufe20-\\ufe2f", b$13 = "\\u20d0-\\u20ff", g$1c = t$1A + i$1L + b$13, l$1N = "\\ufe0e\\ufe0f", m$20 = "[" + u$1z + "]", r$1L = "[" + g$1c + "]", f$1B = "\\ud83c[\\udffb-\\udfff]", R$v = "(?:" + r$1L + "|" + f$1B + ")", a$26 = "[^" + u$1z + "]", e$1E = "(?:\\ud83c[\\udde6-\\uddff]){2}", o$1v = "[\\ud800-\\udbff][\\udc00-\\udfff]", c$1V = "\\u200d", s$1V = R$v + "?", d$1L = "[" + l$1N + "]?", p$3D = "(?:" + c$1V + "(?:" + [a$26, e$1E, o$1v].join("|") + ")" + d$1L + s$1V + ")*", C$15 = d$1L + s$1V + p$3D, v$13 = "(?:" + [a$26 + r$1L + "?", r$1L, e$1E, o$1v, m$20].join("|") + ")", A$E = RegExp(f$1B + "(?=" + f$1B + ")|" + v$13 + C$15, "g");
function M$u(n3) {
  return n3.match(A$E) || [];
}
function f$1A(r3) {
  return g$1d(r3) ? M$u(r3) : t$1B(r3);
}
function h$1z(e28, u3) {
  for (var l3 = -1, n3 = e28 == null ? 0 : e28.length, t3 = Array(n3); ++l3 < n3; )
    t3[l3] = u3(e28[l3], l3, e28);
  return t3;
}
var r$1K = "[object Symbol]";
function i$1K(o3) {
  return typeof o3 == "symbol" || e$1X(o3) && m$2h(o3) == r$1K;
}
var s$1U = 1 / 0, i$1J = t$23 ? t$23.prototype : void 0, n$1x = i$1J ? i$1J.toString : void 0;
function y$15(r3) {
  if (typeof r3 == "string")
    return r3;
  if (a$2p(r3))
    return h$1z(r3, y$15) + "";
  if (i$1K(r3))
    return n$1x ? n$1x.call(r3) : "";
  var o3 = r3 + "";
  return o3 == "0" && 1 / r3 == -s$1U ? "-0" : o3;
}
function o$1u(t3) {
  return t3 == null ? "" : y$15(t3);
}
function d$1K(t3) {
  return function(r3) {
    r3 = o$1u(r3);
    var o3 = g$1d(r3) ? f$1A(r3) : void 0, a3 = o3 ? o3[0] : r3.charAt(0), e28 = o3 ? o$1x(o3, 1).join("") : r3.slice(1);
    return a3[t3]() + e28;
  };
}
var e$1D = d$1K("toUpperCase");
const p$3C = e$1D;
function f$1z(n3, t3) {
  return defineComponent({
    name: p$3C(n3),
    setup() {
      var e28;
      const o3 = (e28 = inject(n$27, null)) === null || e28 === void 0 ? void 0 : e28.mergedIconsRef;
      return () => {
        var r3;
        const i = (r3 = o3 == null ? void 0 : o3.value) === null || r3 === void 0 ? void 0 : r3[n3];
        return i ? i() : t3;
      };
    }
  });
}
const L$H = f$1z("close", h$1R("svg", {
  viewBox: "0 0 12 12",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": true
}, h$1R("g", {
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, h$1R("g", {
  fill: "currentColor",
  "fill-rule": "nonzero"
}, h$1R("path", {
  d: "M2.08859116,2.2156945 L2.14644661,2.14644661 C2.32001296,1.97288026 2.58943736,1.95359511 2.7843055,2.08859116 L2.85355339,2.14644661 L6,5.293 L9.14644661,2.14644661 C9.34170876,1.95118446 9.65829124,1.95118446 9.85355339,2.14644661 C10.0488155,2.34170876 10.0488155,2.65829124 9.85355339,2.85355339 L6.707,6 L9.85355339,9.14644661 C10.0271197,9.32001296 10.0464049,9.58943736 9.91140884,9.7843055 L9.85355339,9.85355339 C9.67998704,10.0271197 9.41056264,10.0464049 9.2156945,9.91140884 L9.14644661,9.85355339 L6,6.707 L2.85355339,9.85355339 C2.65829124,10.0488155 2.34170876,10.0488155 2.14644661,9.85355339 C1.95118446,9.65829124 1.95118446,9.34170876 2.14644661,9.14644661 L5.293,6 L2.14644661,2.85355339 C1.97288026,2.67998704 1.95359511,2.41056264 2.08859116,2.2156945 L2.14644661,2.14644661 L2.08859116,2.2156945 Z"
})))));
const g$1b = defineComponent({
  name: "BaseClose",
  props: {
    isButtonTag: {
      type: Boolean,
      default: true
    },
    clsPrefix: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    focusable: {
      type: Boolean,
      default: true
    },
    round: Boolean,
    onClick: Function,
    absolute: Boolean
  },
  setup(e28) {
    return S$O("-base-close", s$1X, toRef$1(e28, "clsPrefix")), () => {
      const {
        clsPrefix: o3,
        disabled: t3,
        absolute: n3,
        round: s3,
        isButtonTag: l3
      } = e28;
      return h$1R(l3 ? "button" : "div", {
        type: l3 ? "button" : void 0,
        tabindex: t3 || !e28.focusable ? -1 : 0,
        "aria-disabled": t3,
        "aria-label": "close",
        role: l3 ? void 0 : "button",
        disabled: t3,
        class: [`${o3}-base-close`, n3 && `${o3}-base-close--absolute`, t3 && `${o3}-base-close--disabled`, s3 && `${o3}-base-close--round`],
        onMousedown: (u3) => {
          e28.focusable || u3.preventDefault();
        },
        onClick: e28.onClick
      }, h$1R(d$1R, {
        clsPrefix: o3
      }, {
        default: () => h$1R(L$H, null)
      }));
    };
  }
});
const v$12 = {
  title: String,
  headerClass: String,
  headerStyle: [Object, String],
  footerClass: String,
  footerStyle: [Object, String],
  bodyClass: String,
  bodyStyle: [Object, String],
  bodyContentClass: String,
  bodyContentStyle: [Object, String],
  nativeScrollbar: {
    type: Boolean,
    default: true
  },
  scrollbarProps: Object,
  closable: Boolean
}, N$F = defineComponent({
  name: "DrawerContent",
  props: v$12,
  setup() {
    const t3 = inject(o$1F, null);
    t3 || t$1P("drawer-content", "`n-drawer-content` must be placed inside `n-drawer`.");
    const {
      doUpdateShow: e28
    } = t3;
    function l3() {
      e28(false);
    }
    return {
      handleCloseClick: l3,
      mergedTheme: t3.mergedThemeRef,
      mergedClsPrefix: t3.mergedClsPrefixRef
    };
  },
  render() {
    const {
      title: t3,
      mergedClsPrefix: e28,
      nativeScrollbar: l3,
      mergedTheme: n3,
      bodyClass: i,
      bodyStyle: c3,
      bodyContentClass: a3,
      bodyContentStyle: s3,
      headerClass: b3,
      headerStyle: y3,
      footerClass: C3,
      footerStyle: f3,
      scrollbarProps: m3,
      closable: d3,
      $slots: o3
    } = this;
    return h$1R("div", {
      role: "none",
      class: [`${e28}-drawer-content`, l3 && `${e28}-drawer-content--native-scrollbar`]
    }, o3.header || t3 || d3 ? h$1R("div", {
      class: [`${e28}-drawer-header`, b3],
      style: y3,
      role: "none"
    }, h$1R("div", {
      class: `${e28}-drawer-header__main`,
      role: "heading",
      "aria-level": "1"
    }, o3.header !== void 0 ? o3.header() : t3), d3 && h$1R(g$1b, {
      onClick: this.handleCloseClick,
      clsPrefix: e28,
      class: `${e28}-drawer-header__close`,
      absolute: true
    })) : null, l3 ? h$1R("div", {
      class: [`${e28}-drawer-body`, i],
      style: c3,
      role: "none"
    }, h$1R("div", {
      class: [`${e28}-drawer-body-content-wrapper`, a3],
      style: s3,
      role: "none"
    }, o3)) : h$1R(hn$2, Object.assign({
      themeOverrides: n3.peerOverrides.Scrollbar,
      theme: n3.peers.Scrollbar
    }, m3, {
      class: `${e28}-drawer-body`,
      contentClass: [`${e28}-drawer-body-content-wrapper`, a3],
      contentStyle: s3
    }), o3), o3.footer ? h$1R("div", {
      class: [`${e28}-drawer-footer`, C3],
      style: f3,
      role: "none"
    }, o3.footer()) : null);
  }
});
const d$1J = {
  key: 0,
  class: "hl-icon-container"
}, f$1y = defineComponent({
  __name: "IconContainer",
  props: {
    type: {
      type: String,
      default: "primary"
    }
  },
  setup(e28) {
    const n3 = {
      success: "icon-success",
      error: "icon-error",
      warning: "icon-warning",
      primary: "icon-primary"
    }, o3 = useSlots();
    return (r3, y3) => unref(o3).default() ? (openBlock(), createElementBlock("div", d$1J, [
      createElementVNode("div", {
        class: normalizeClass(["icon", n3[e28.type]])
      }, [
        renderSlot(r3.$slots, "default")
      ], 2)
    ])) : createCommentVNode("", true);
  }
}), C$14 = f$1y;
const I$E = { class: "hl-drawer-header-container" }, V$w = {
  key: 0,
  class: "hl-drawer-header-icon"
}, F$C = {
  key: 0,
  class: "hl-drawer-title"
}, L$G = {
  key: 1,
  class: "hl-drawer-description"
}, R$u = { class: "hl-drawer-actions" }, U$y = { class: "hl-drawer-action-left" }, E$E = { class: "hl-drawer-action-right" }, q$B = defineComponent({
  name: "UIDrawerContent",
  inheritAttrs: false
}), A$D = defineComponent(__spreadProps(__spreadValues({}, q$B), {
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: void 0
    },
    description: {
      type: String,
      default: void 0
    },
    icon: {
      type: Function,
      default: void 0
    },
    width: {
      type: Number,
      default: 502
    },
    positiveText: {
      type: String,
      default: void 0
    },
    negativeText: {
      type: String,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    }
  },
  emits: ["negativeClick", "positiveClick"],
  setup(e28) {
    const v3 = e28, t3 = useSlots(), w3 = computed(() => v3.positiveText || v3.negativeText || (t3 == null ? void 0 : t3.actionLeft) || (t3 == null ? void 0 : t3.actionRight));
    return (n3, r3) => (openBlock(), createBlock(unref(N$F), mergeProps(n3.$attrs, {
      closable: e28.closable,
      class: "hl-drawer-content"
    }), createSlots({
      default: withCtx(() => [
        renderSlot(n3.$slots, "default")
      ]),
      _: 2
    }, [
      e28.title || e28.description || e28.icon ? {
        name: "header",
        fn: withCtx(() => [
          createElementVNode("div", I$E, [
            e28.icon ? (openBlock(), createElementBlock("div", V$w, [
              createVNode(unref(C$14), null, {
                default: withCtx(() => [
                  (openBlock(), createBlock(resolveDynamicComponent(e28.icon), { class: "w-5 h-5" }))
                ]),
                _: 1
              })
            ])) : createCommentVNode("", true),
            createElementVNode("div", null, [
              e28.title ? (openBlock(), createElementBlock("div", F$C, toDisplayString(e28.title), 1)) : createCommentVNode("", true),
              e28.description ? (openBlock(), createElementBlock("div", L$G, toDisplayString(e28.description), 1)) : createCommentVNode("", true)
            ])
          ])
        ]),
        key: "0"
      } : void 0,
      w3.value ? {
        name: "footer",
        fn: withCtx(() => {
          var m3, h3;
          return [
            createElementVNode("div", R$u, [
              createElementVNode("div", U$y, [
                (m3 = unref(t3)) != null && m3.actionLeft ? renderSlot(n3.$slots, "actionLeft", { key: 0 }) : createCommentVNode("", true)
              ]),
              createElementVNode("div", E$E, [
                (h3 = unref(t3)) != null && h3.actionRight ? renderSlot(n3.$slots, "actionRight", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  e28.negativeText ? (openBlock(), createBlock(unref(q$C), {
                    key: 0,
                    id: `${e28.id}-btn-negative-action`,
                    onClick: r3[0] || (r3[0] = (C3) => n3.$emit("negativeClick"))
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(e28.negativeText), 1)
                    ]),
                    _: 1
                  }, 8, ["id"])) : createCommentVNode("", true),
                  e28.positiveText ? (openBlock(), createBlock(unref(q$C), {
                    key: 1,
                    id: `${e28.id}-btn-positive-action`,
                    loading: e28.loading,
                    disabled: e28.disabled,
                    type: "primary",
                    onClick: r3[1] || (r3[1] = (C3) => n3.$emit("positiveClick"))
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(e28.positiveText), 1)
                    ]),
                    _: 1
                  }, 8, ["id", "loading", "disabled"])) : createCommentVNode("", true)
                ], 64))
              ])
            ])
          ];
        }),
        key: "1"
      } : void 0
    ]), 1040, ["closable"]));
  }
})), K$o = A$D;
const e$1C = l$25("form", [g$1j("inline", `
 width: 100%;
 display: inline-flex;
 align-items: flex-start;
 align-content: space-around;
 `, [l$25("form-item", {
  width: "auto",
  marginRight: "18px"
}, [r$2a("&:last-child", {
  marginRight: 0
})])])]);
const t$1z = n$28("n-form"), e$1B = n$28("n-form-item-insts");
const e$1A = {
  feedbackPadding: "4px 0 0 2px",
  feedbackHeightSmall: "24px",
  feedbackHeightMedium: "24px",
  feedbackHeightLarge: "26px",
  feedbackFontSizeSmall: "13px",
  feedbackFontSizeMedium: "14px",
  feedbackFontSizeLarge: "14px",
  labelFontSizeLeftSmall: "14px",
  labelFontSizeLeftMedium: "14px",
  labelFontSizeLeftLarge: "15px",
  labelFontSizeTopSmall: "13px",
  labelFontSizeTopMedium: "14px",
  labelFontSizeTopLarge: "14px",
  labelHeightSmall: "24px",
  labelHeightMedium: "26px",
  labelHeightLarge: "28px",
  labelPaddingVertical: "0 0 6px 2px",
  labelPaddingHorizontal: "0 12px 0 0",
  labelTextAlignVertical: "left",
  labelTextAlignHorizontal: "right",
  labelFontWeight: "400"
};
const s$1T = (e28) => {
  const {
    heightSmall: r3,
    heightMedium: t3,
    heightLarge: l3,
    textColor1: a3,
    errorColor: o3,
    warningColor: i,
    lineHeight: n3,
    textColor3: m3
  } = e28;
  return Object.assign(Object.assign({}, e$1A), {
    blankHeightSmall: r3,
    blankHeightMedium: t3,
    blankHeightLarge: l3,
    lineHeight: n3,
    labelTextColor: a3,
    asteriskColor: o3,
    feedbackTextColorError: o3,
    feedbackTextColorWarning: i,
    feedbackTextColor: m3
  });
}, c$1U = {
  name: "Form",
  common: d$1T,
  self: s$1T
}, C$13 = c$1U;
function t$1y(e28) {
  return Object.keys(e28);
}
var B$N = globalThis && globalThis.__awaiter || function(n3, c3, o3, r3) {
  function h3(f3) {
    return f3 instanceof o3 ? f3 : new o3(function(a3) {
      a3(f3);
    });
  }
  return new (o3 || (o3 = Promise))(function(f3, a3) {
    function v3(e28) {
      try {
        t3(r3.next(e28));
      } catch (d3) {
        a3(d3);
      }
    }
    function i(e28) {
      try {
        t3(r3.throw(e28));
      } catch (d3) {
        a3(d3);
      }
    }
    function t3(e28) {
      e28.done ? f3(e28.value) : h3(e28.value).then(v3, i);
    }
    t3((r3 = r3.apply(n3, c3 || [])).next());
  });
};
const F$B = Object.assign(Object.assign({}, _$F.props), {
  inline: Boolean,
  labelWidth: [Number, String],
  labelAlign: String,
  labelPlacement: {
    type: String,
    default: "top"
  },
  model: {
    type: Object,
    default: () => {
    }
  },
  rules: Object,
  disabled: Boolean,
  size: String,
  showRequireMark: {
    type: Boolean,
    default: void 0
  },
  requireMarkPlacement: String,
  showFeedback: {
    type: Boolean,
    default: true
  },
  onSubmit: {
    type: Function,
    default: (n3) => {
      n3.preventDefault();
    }
  },
  showLabel: {
    type: Boolean,
    default: void 0
  },
  validateMessages: Object
}), q$A = defineComponent({
  name: "Form",
  props: F$B,
  setup(n3) {
    const {
      mergedClsPrefixRef: c3
    } = a$2x(n3);
    _$F("Form", "-form", e$1C, C$13, n3, c3);
    const o3 = {}, r3 = ref$1(void 0), h3 = (i) => {
      const t3 = r3.value;
      (t3 === void 0 || i >= t3) && (r3.value = i);
    };
    function f3(i, t3 = () => true) {
      return B$N(this, void 0, void 0, function* () {
        return yield new Promise((e28, d3) => {
          const y3 = [];
          for (const u3 of t$1y(o3)) {
            const p3 = o3[u3];
            for (const s3 of p3)
              s3.path && y3.push(s3.internalValidate(null, t3));
          }
          Promise.all(y3).then((u3) => {
            const p3 = u3.some((l3) => !l3.valid), s3 = [], m3 = [];
            u3.forEach((l3) => {
              var g3, b3;
              !((g3 = l3.errors) === null || g3 === void 0) && g3.length && s3.push(l3.errors), !((b3 = l3.warnings) === null || b3 === void 0) && b3.length && m3.push(l3.warnings);
            }), i && i(s3.length ? s3 : void 0, {
              warnings: m3.length ? m3 : void 0
            }), p3 ? d3(s3.length ? s3 : void 0) : e28({
              warnings: m3.length ? m3 : void 0
            });
          });
        });
      });
    }
    function a3() {
      for (const i of t$1y(o3)) {
        const t3 = o3[i];
        for (const e28 of t3)
          e28.restoreValidation();
      }
    }
    return provide(t$1z, {
      props: n3,
      maxChildLabelWidthRef: r3,
      deriveMaxChildLabelWidth: h3
    }), provide(e$1B, {
      formItems: o3
    }), Object.assign({
      validate: f3,
      restoreValidation: a3
    }, {
      mergedClsPrefix: c3
    });
  },
  render() {
    const {
      mergedClsPrefix: n3
    } = this;
    return h$1R("form", {
      class: [`${n3}-form`, this.inline && `${n3}-form--inline`],
      onSubmit: this.onSubmit
    }, this.$slots);
  }
});
const p$3B = defineComponent({
  name: "UIForm"
}), y$14 = defineComponent(__spreadProps(__spreadValues({}, p$3B), {
  props: {
    rules: {
      type: Object
    },
    inline: {
      type: Boolean,
      default: false
    },
    model: {
      type: [String, Object]
    },
    id: {
      type: String,
      required: true
    }
  },
  setup(e28, { expose: n3 }) {
    const r3 = ref$1();
    function l3() {
      return r3.value;
    }
    return n3({ getForm: l3 }), (t3, g3) => (openBlock(), createBlock(unref(q$A), mergeProps({ id: e28.id }, t3.$attrs, {
      rules: e28.rules,
      model: e28.model,
      inline: e28.inline,
      ref_key: "formRef",
      ref: r3
    }), {
      default: withCtx(() => [
        renderSlot(t3.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "rules", "model", "inline"]));
  }
})), B$M = y$14;
const n$1w = l$25("divider", `
 position: relative;
 display: flex;
 width: 100%;
 box-sizing: border-box;
 font-size: 16px;
 color: var(--n-text-color);
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
`, [x$I("vertical", `
 margin-top: 24px;
 margin-bottom: 24px;
 `, [x$I("no-title", `
 display: flex;
 align-items: center;
 `)]), M$y("title", `
 display: flex;
 align-items: center;
 margin-left: 12px;
 margin-right: 12px;
 white-space: nowrap;
 font-weight: var(--n-font-weight);
 `), g$1j("title-position-left", [M$y("line", [g$1j("left", {
  width: "28px"
})])]), g$1j("title-position-right", [M$y("line", [g$1j("right", {
  width: "28px"
})])]), g$1j("dashed", [M$y("line", `
 background-color: #0000;
 height: 0px;
 width: 100%;
 border-style: dashed;
 border-width: 1px 0 0;
 `)]), g$1j("vertical", `
 display: inline-block;
 height: 1em;
 margin: 0 8px;
 vertical-align: middle;
 width: 1px;
 `), M$y("line", `
 border: none;
 transition: background-color .3s var(--n-bezier), border-color .3s var(--n-bezier);
 height: 1px;
 width: 100%;
 margin: 0;
 `), x$I("dashed", [M$y("line", {
  backgroundColor: "var(--n-color)"
})]), g$1j("dashed", [M$y("line", {
  borderColor: "var(--n-color)"
})]), g$1j("vertical", {
  backgroundColor: "var(--n-color)"
})]);
const n$1v = (o3) => {
  const {
    textColor1: t3,
    dividerColor: i,
    fontWeightStrong: r3
  } = o3;
  return {
    textColor: t3,
    color: i,
    fontWeight: r3
  };
}, d$1I = {
  name: "Divider",
  common: d$1T,
  self: n$1v
}, m$1$ = d$1I;
const C$12 = Object.assign(Object.assign({}, _$F.props), {
  titlePlacement: {
    type: String,
    default: "center"
  },
  dashed: Boolean,
  vertical: Boolean
}), y$13 = defineComponent({
  name: "Divider",
  props: C$12,
  setup(t3) {
    const {
      mergedClsPrefixRef: d3,
      inlineThemeDisabled: r3
    } = a$2x(t3), s3 = _$F("Divider", "-divider", n$1w, m$1$, t3, d3), n3 = computed(() => {
      const {
        common: {
          cubicBezierEaseInOut: e28
        },
        self: {
          color: a3,
          textColor: v3,
          fontWeight: c3
        }
      } = s3.value;
      return {
        "--n-bezier": e28,
        "--n-color": a3,
        "--n-text-color": v3,
        "--n-font-weight": c3
      };
    }), i = r3 ? E$J("divider", void 0, n3, t3) : void 0;
    return {
      mergedClsPrefix: d3,
      cssVars: r3 ? void 0 : n3,
      themeClass: i == null ? void 0 : i.themeClass,
      onRender: i == null ? void 0 : i.onRender
    };
  },
  render() {
    var t3;
    const {
      $slots: d3,
      titlePlacement: r3,
      vertical: s3,
      dashed: n3,
      cssVars: i,
      mergedClsPrefix: e28
    } = this;
    return (t3 = this.onRender) === null || t3 === void 0 || t3.call(this), h$1R("div", {
      role: "separator",
      class: [`${e28}-divider`, this.themeClass, {
        [`${e28}-divider--vertical`]: s3,
        [`${e28}-divider--no-title`]: !d3.default,
        [`${e28}-divider--dashed`]: n3,
        [`${e28}-divider--title-position-${r3}`]: d3.default && r3
      }],
      style: i
    }, s3 ? null : h$1R("div", {
      class: `${e28}-divider__line ${e28}-divider__line--left`
    }), !s3 && d3.default ? h$1R(Fragment, null, h$1R("div", {
      class: `${e28}-divider__title`
    }, this.$slots), h$1R("div", {
      class: `${e28}-divider__line ${e28}-divider__line--right`
    })) : null);
  }
});
const f$1x = defineComponent({
  name: "UIDivider",
  inheritAttrs: false
}), m$1_ = defineComponent(__spreadProps(__spreadValues({}, f$1x), {
  props: {
    titlePlacement: {
      type: String,
      default: "center"
    },
    dashed: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  setup(e28) {
    const n3 = useSlots();
    return (c3, u3) => unref(n3).default ? (openBlock(), createBlock(unref(y$13), {
      key: 0,
      "title-placement": e28.titlePlacement,
      dashed: e28.dashed,
      vertical: e28.vertical
    }, {
      default: withCtx(() => [
        renderSlot(c3.$slots, "default")
      ]),
      _: 3
    }, 8, ["title-placement", "dashed", "vertical"])) : (openBlock(), createBlock(unref(y$13), {
      key: 1,
      "title-placement": e28.titlePlacement,
      dashed: e28.dashed,
      vertical: e28.vertical
    }, null, 8, ["title-placement", "dashed", "vertical"]));
  }
})), p$3A = m$1_;
const a$25 = defineComponent({
  name: "UIDisplaySmMedium",
  inheritAttrs: false
}), l$1M = defineComponent(__spreadProps(__spreadValues({}, a$25), {
  setup(n3) {
    return (e28, i) => (openBlock(), createElementBlock("div", mergeProps(e28.$attrs, { class: "hl-display-sm-medium" }), [
      renderSlot(e28.$slots, "default")
    ], 16));
  }
})), c$1T = l$1M;
const l$1L = defineComponent({
  name: "UITextLgMedium",
  inheritAttrs: false
}), m$1Z = defineComponent(__spreadProps(__spreadValues({}, l$1L), {
  setup(a3) {
    return (e28, i) => (openBlock(), createElementBlock("div", mergeProps(e28.$attrs, { class: "hl-text-lg-medium" }), [
      renderSlot(e28.$slots, "default")
    ], 16));
  }
})), p$3z = m$1Z;
const a$24 = defineComponent({
  name: "UITextSmNormal",
  inheritAttrs: false
}), l$1K = defineComponent(__spreadProps(__spreadValues({}, a$24), {
  setup(m3) {
    return (e28, c3) => (openBlock(), createElementBlock("div", mergeProps(e28.$attrs, { class: "hl-text-sm-normal" }), [
      renderSlot(e28.$slots, "default")
    ], 16));
  }
})), f$1w = l$1K;
const n$1u = defineComponent({
  name: "UITextSmNormal",
  inheritAttrs: false
}), a$23 = defineComponent(__spreadProps(__spreadValues({}, n$1u), {
  setup(l3) {
    return (e28, c3) => (openBlock(), createElementBlock("div", mergeProps(e28.$attrs, { class: "hl-text-sm-medium" }), [
      renderSlot(e28.$slots, "default")
    ], 16));
  }
})), d$1H = a$23;
const m$1Y = defineComponent({
  name: "UITextXsMedium",
  inheritAttrs: false
}), a$22 = defineComponent(__spreadProps(__spreadValues({}, m$1Y), {
  setup(l3) {
    return (e28, i) => (openBlock(), createElementBlock("div", mergeProps(e28.$attrs, { class: "hl-text-xs-medium" }), [
      renderSlot(e28.$slots, "default")
    ], 16));
  }
})), p$3y = a$22;
const l$1J = defineComponent({
  name: "UITextXsRegular",
  inheritAttrs: false
}), n$1t = defineComponent(__spreadProps(__spreadValues({}, l$1J), {
  setup(c3) {
    return (e28, p3) => (openBlock(), createElementBlock("div", mergeProps(e28.$attrs, { class: "hl-text-xs-regular" }), [
      renderSlot(e28.$slots, "default")
    ], 16));
  }
})), _$E = n$1t;
const m$1X = defineComponent({
  name: "UITextMdMedium",
  inheritAttrs: false
}), d$1G = defineComponent(__spreadProps(__spreadValues({}, m$1X), {
  setup(a3) {
    return (e28, l3) => (openBlock(), createElementBlock("div", mergeProps(e28.$attrs, { class: "hl-text-md-medium" }), [
      renderSlot(e28.$slots, "default")
    ], 16));
  }
})), p$3x = d$1G;
const a$21 = defineComponent({
  name: "UITextMdNormal",
  inheritAttrs: false
}), l$1I = defineComponent(__spreadProps(__spreadValues({}, a$21), {
  setup(m3) {
    return (e28, c3) => (openBlock(), createElementBlock("div", mergeProps(e28.$attrs, { class: "hl-text-md-normal" }), [
      renderSlot(e28.$slots, "default")
    ], 16));
  }
})), _$D = l$1I;
const a$20 = defineComponent({
  name: "UIDisplaySmSemibold",
  inheritAttrs: false
}), m$1W = defineComponent(__spreadProps(__spreadValues({}, a$20), {
  setup(n3) {
    return (e28, i) => (openBlock(), createElementBlock("div", mergeProps(e28.$attrs, { class: "hl-display-sm-semibold" }), [
      renderSlot(e28.$slots, "default")
    ], 16));
  }
})), c$1S = m$1W;
const l$1H = defineComponent({
  name: "UITextSmRegular",
  inheritAttrs: false
}), n$1s = defineComponent(__spreadProps(__spreadValues({}, l$1H), {
  setup(m3) {
    return (e28, c3) => (openBlock(), createElementBlock("div", mergeProps(e28.$attrs, { class: "hl-text-sm-regular" }), [
      renderSlot(e28.$slots, "default")
    ], 16));
  }
})), _$C = n$1s;
function l$1G(t3, n3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 16v-4m0-4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
    })
  ]);
}
var t$1x = "__lodash_hash_undefined__";
function a$1$(_3) {
  return this.__data__.set(_3, t$1x), this;
}
function t$1w(a3) {
  return this.__data__.has(a3);
}
function e$1z(t3) {
  var o3 = -1, a3 = t3 == null ? 0 : t3.length;
  for (this.__data__ = new e$1$(); ++o3 < a3; )
    this.add(t3[o3]);
}
e$1z.prototype.add = e$1z.prototype.push = a$1$;
e$1z.prototype.has = t$1w;
function u$1y(e28, t3) {
  for (var n3 = -1, l3 = e28 == null ? 0 : e28.length; ++n3 < l3; )
    if (t3(e28[n3], n3, e28))
      return true;
  return false;
}
function t$1v(a3, e28) {
  return a3.has(e28);
}
var x$C = 1, F$A = 2;
function U$x(n3, e28, A3, d3, p3, f3) {
  var E3 = A3 & x$C, R3 = n3.length, P3 = e28.length;
  if (R3 != P3 && !(E3 && P3 > R3))
    return false;
  var S3 = f3.get(n3), _3 = f3.get(e28);
  if (S3 && _3)
    return S3 == e28 && _3 == n3;
  var v3 = -1, g3 = true, l3 = A3 & F$A ? new e$1z() : void 0;
  for (f3.set(n3, e28), f3.set(e28, n3); ++v3 < R3; ) {
    var i = n3[v3], L3 = e28[v3];
    if (d3)
      var C3 = E3 ? d3(L3, i, v3, e28, n3, f3) : d3(i, L3, v3, n3, e28, f3);
    if (C3 !== void 0) {
      if (C3)
        continue;
      g3 = false;
      break;
    }
    if (l3) {
      if (!u$1y(e28, function(O3, w3) {
        if (!t$1v(l3, w3) && (i === O3 || p3(i, O3, A3, d3, f3)))
          return l3.push(w3);
      })) {
        g3 = false;
        break;
      }
    } else if (!(i === L3 || p3(i, L3, A3, d3, f3))) {
      g3 = false;
      break;
    }
  }
  return f3.delete(n3), f3.delete(e28), g3;
}
function o$1t(r3) {
  var e28 = -1, a3 = Array(r3.size);
  return r3.forEach(function(n3, t3) {
    a3[++e28] = [t3, n3];
  }), a3;
}
function t$1u(r3) {
  var e28 = -1, a3 = Array(r3.size);
  return r3.forEach(function(n3) {
    a3[++e28] = n3;
  }), a3;
}
var L$F = 1, O$y = 2, v$11 = "[object Boolean]", E$D = "[object Date]", R$t = "[object Error]", w$O = "[object Map]", B$L = "[object Number]", D$J = "[object RegExp]", P$T = "[object Set]", S$K = "[object String]", _$B = "[object Symbol]", c$1R = "[object ArrayBuffer]", x$B = "[object DataView]", i$1I = t$23 ? t$23.prototype : void 0, n$1r = i$1I ? i$1I.valueOf : void 0;
function N$E(e28, a3, l3, s3, y3, u3, r3) {
  switch (l3) {
    case x$B:
      if (e28.byteLength != a3.byteLength || e28.byteOffset != a3.byteOffset)
        return false;
      e28 = e28.buffer, a3 = a3.buffer;
    case c$1R:
      return !(e28.byteLength != a3.byteLength || !u3(new o$1P(e28), new o$1P(a3)));
    case v$11:
    case E$D:
    case B$L:
      return t$27(+e28, +a3);
    case R$t:
      return e28.name == a3.name && e28.message == a3.message;
    case D$J:
    case S$K:
      return e28 == a3 + "";
    case w$O:
      var f3 = o$1t;
    case P$T:
      var T3 = s3 & L$F;
      if (f3 || (f3 = t$1u), e28.size != a3.size && !T3)
        return false;
      var g3 = r3.get(e28);
      if (g3)
        return g3 == a3;
      s3 |= O$y, r3.set(e28, a3);
      var p3 = U$x(f3(e28), f3(a3), s3, y3, u3, r3);
      return r3.delete(e28), p3;
    case _$B:
      if (n$1r)
        return n$1r.call(e28) == n$1r.call(a3);
  }
  return false;
}
function l$1F(e28, n3) {
  for (var t3 = -1, h3 = n3.length, f3 = e28.length; ++t3 < h3; )
    e28[f3 + t3] = n3[t3];
  return e28;
}
function l$1E(r3, s3, t3) {
  var a3 = s3(r3);
  return a$2p(r3) ? a3 : l$1F(a3, t3(r3));
}
function d$1F(e28, i) {
  for (var n3 = -1, r3 = e28 == null ? 0 : e28.length, u3 = 0, t3 = []; ++n3 < r3; ) {
    var l3 = e28[n3];
    i(l3, n3, e28) && (t3[u3++] = l3);
  }
  return t3;
}
function r$1J() {
  return [];
}
var n$1q = Object.prototype, l$1D = n$1q.propertyIsEnumerable, t$1t = Object.getOwnPropertySymbols, m$1V = t$1t ? function(r3) {
  return r3 == null ? [] : (r3 = Object(r3), d$1F(t$1t(r3), function(e28) {
    return l$1D.call(r3, e28);
  }));
} : r$1J;
const y$12 = m$1V;
var t$1s = e$1_(Object.keys, Object);
const a$1_ = t$1s;
var s$1S = Object.prototype, n$1p = s$1S.hasOwnProperty;
function f$1v(r3) {
  if (!e$1Y(r3))
    return a$1_(r3);
  var o3 = [];
  for (var t3 in Object(r3))
    n$1p.call(r3, t3) && t3 != "constructor" && o3.push(t3);
  return o3;
}
function f$1u(r3) {
  return e$1W(r3) ? l$1_(r3) : f$1v(r3);
}
function f$1t(e28) {
  return l$1E(e28, f$1u, y$12);
}
var q$z = 1, E$C = Object.prototype, F$z = E$C.hasOwnProperty;
function I$D(r3, n3, A3, a3, R3, f3) {
  var v3 = A3 & q$z, d3 = f$1t(r3), g3 = d3.length, S3 = f$1t(n3), _3 = S3.length;
  if (g3 != _3 && !v3)
    return false;
  for (var l3 = g3; l3--; ) {
    var i = d3[l3];
    if (!(v3 ? i in n3 : F$z.call(n3, i)))
      return false;
  }
  var O3 = f3.get(r3), w3 = f3.get(n3);
  if (O3 && w3)
    return O3 == n3 && w3 == r3;
  var s3 = true;
  f3.set(r3, n3), f3.set(n3, r3);
  for (var t3 = v3; ++l3 < g3; ) {
    i = d3[l3];
    var p3 = r3[i], e28 = n3[i];
    if (a3)
      var L3 = v3 ? a3(e28, p3, i, n3, r3, f3) : a3(p3, e28, i, r3, n3, f3);
    if (!(L3 === void 0 ? p3 === e28 || R3(p3, e28, A3, a3, f3) : L3)) {
      s3 = false;
      break;
    }
    t3 || (t3 = i == "constructor");
  }
  if (s3 && !t3) {
    var u3 = r3.constructor, P3 = n3.constructor;
    u3 != P3 && "constructor" in r3 && "constructor" in n3 && !(typeof u3 == "function" && u3 instanceof u3 && typeof P3 == "function" && P3 instanceof P3) && (s3 = false);
  }
  return f3.delete(r3), f3.delete(n3), s3;
}
var o$1s = f$1U(f$1Y, "DataView");
const i$1H = o$1s;
var t$1r = f$1U(f$1Y, "Promise");
const i$1G = t$1r;
var e$1y = f$1U(f$1Y, "Set");
const m$1U = e$1y;
var t$1q = f$1U(f$1Y, "WeakMap");
const p$3w = t$1q;
var g$1a = "[object Map]", T$L = "[object Object]", f$1s = "[object Promise]", u$1x = "[object Set]", w$N = "[object WeakMap]", b$12 = "[object DataView]", j$s = e$25(i$1H), C$11 = e$25(e$24), M$t = e$25(i$1G), d$1E = e$25(m$1U), v$10 = e$25(p$3w), r$1I = m$2h;
(i$1H && r$1I(new i$1H(new ArrayBuffer(1))) != b$12 || e$24 && r$1I(new e$24()) != g$1a || i$1G && r$1I(i$1G.resolve()) != f$1s || m$1U && r$1I(new m$1U()) != u$1x || p$3w && r$1I(new p$3w()) != w$N) && (r$1I = function(c3) {
  var m3 = m$2h(c3), p3 = m3 == T$L ? c3.constructor : void 0, s3 = p3 ? e$25(p3) : "";
  if (s3)
    switch (s3) {
      case j$s:
        return b$12;
      case C$11:
        return g$1a;
      case M$t:
        return f$1s;
      case d$1E:
        return u$1x;
      case v$10:
        return w$N;
    }
  return m3;
});
const h$1y = r$1I;
var S$J = 1, w$M = "[object Arguments]", P$S = "[object Array]", l$1C = "[object Object]", q$y = Object.prototype, I$C = q$y.hasOwnProperty;
function K$n(r3, f3, p3, i, g3, a3) {
  var m3 = a$2p(r3), j3 = a$2p(f3), e28 = m3 ? P$S : h$1y(r3), o3 = j3 ? P$S : h$1y(f3);
  e28 = e28 == w$M ? l$1C : e28, o3 = o3 == w$M ? l$1C : o3;
  var A3 = e28 == l$1C, d3 = o3 == l$1C, n3 = e28 == o3;
  if (n3 && m$2b(r3)) {
    if (!m$2b(f3))
      return false;
    m3 = true, A3 = false;
  }
  if (n3 && !A3)
    return a3 || (a3 = new t$1_()), m3 || i$25(r3) ? U$x(r3, f3, p3, i, g3, a3) : N$E(r3, f3, e28, p3, i, g3, a3);
  if (!(p3 & S$J)) {
    var y3 = A3 && I$C.call(r3, "__wrapped__"), T3 = d3 && I$C.call(f3, "__wrapped__");
    if (y3 || T3) {
      var s3 = y3 ? r3.value() : r3, t3 = T3 ? f3.value() : f3;
      return a3 || (a3 = new t$1_()), g3(s3, t3, p3, i, a3);
    }
  }
  return n3 ? (a3 || (a3 = new t$1_()), I$D(r3, f3, p3, i, g3, a3)) : false;
}
function m$1T(i, n3, f3, s3, t3) {
  return i === n3 ? true : i == null || n3 == null || !e$1X(i) && !e$1X(n3) ? i !== i && n3 !== n3 : K$n(i, n3, f3, s3, m$1T, t3);
}
var p$3v = 1, w$L = 2;
function L$E(n3, O3, e28, i) {
  var f3 = e28.length, v3 = f3, A3 = !i;
  if (n3 == null)
    return !v3;
  for (n3 = Object(n3); f3--; ) {
    var r3 = e28[f3];
    if (A3 && r3[2] ? r3[1] !== n3[r3[0]] : !(r3[0] in n3))
      return false;
  }
  for (; ++f3 < v3; ) {
    r3 = e28[f3];
    var l3 = r3[0], u3 = n3[l3], E3 = r3[1];
    if (A3 && r3[2]) {
      if (u3 === void 0 && !(l3 in n3))
        return false;
    } else {
      var R3 = new t$1_();
      if (i)
        var s3 = i(u3, E3, l3, n3, O3, R3);
      if (!(s3 === void 0 ? m$1T(E3, u3, p$3v | w$L, i, R3) : s3))
        return false;
    }
  }
  return true;
}
function o$1r(t3) {
  return t3 === t3 && !n$24(t3);
}
function f$1r(a3) {
  for (var t3 = f$1u(a3), r3 = t3.length; r3--; ) {
    var e28 = t3[r3], i = a3[e28];
    t3[r3] = [e28, i, o$1r(i)];
  }
  return t3;
}
function e$1x(t3, r3) {
  return function(n3) {
    return n3 == null ? false : n3[t3] === r3 && (r3 !== void 0 || t3 in Object(n3));
  };
}
function h$1x(a3) {
  var t3 = f$1r(a3);
  return t3.length == 1 && t3[0][2] ? e$1x(t3[0][0], t3[0][1]) : function(r3) {
    return r3 === a3 || L$E(r3, a3, t3);
  };
}
var i$1F = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, s$1R = /^\w*$/;
function m$1S(r3, e28) {
  if (a$2p(r3))
    return false;
  var t3 = typeof r3;
  return t3 == "number" || t3 == "symbol" || t3 == "boolean" || r3 == null || i$1K(r3) ? true : s$1R.test(r3) || !i$1F.test(r3) || e28 != null && r3 in Object(e28);
}
var p$3u = "Expected a function";
function o$1q(r3, e28) {
  if (typeof r3 != "function" || e28 != null && typeof e28 != "function")
    throw new TypeError(p$3u);
  var t3 = function() {
    var c3 = arguments, n3 = e28 ? e28.apply(this, c3) : c3[0], a3 = t3.cache;
    if (a3.has(n3))
      return a3.get(n3);
    var i = r3.apply(this, c3);
    return t3.cache = a3.set(n3, i) || a3, i;
  };
  return t3.cache = new (o$1q.Cache || e$1$)(), t3;
}
o$1q.Cache = e$1$;
var i$1E = 500;
function m$1R(a3) {
  var e28 = o$1q(a3, function(t3) {
    return r3.size === i$1E && r3.clear(), t3;
  }), r3 = e28.cache;
  return e28;
}
var n$1o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, s$1Q = /\\(\\)?/g, u$1w = m$1R(function(e28) {
  var r3 = [];
  return e28.charCodeAt(0) === 46 && r3.push(""), e28.replace(n$1o, function(a3, t3, o3, p3) {
    r3.push(o3 ? p3.replace(s$1Q, "$1") : t3 || a3);
  }), r3;
});
const i$1D = u$1w;
function c$1Q(r3, t3) {
  return a$2p(r3) ? r3 : m$1S(r3, t3) ? [r3] : i$1D(o$1u(r3));
}
var f$1q = 1 / 0;
function n$1n(r3) {
  if (typeof r3 == "string" || i$1K(r3))
    return r3;
  var t3 = r3 + "";
  return t3 == "0" && 1 / r3 == -f$1q ? "-0" : t3;
}
function d$1D(n3, e28) {
  e28 = c$1Q(e28, n3);
  for (var r3 = 0, i = e28.length; n3 != null && r3 < i; )
    n3 = n3[n$1n(e28[r3++])];
  return r3 && r3 == i ? n3 : void 0;
}
function f$1p(e28, r3, t3) {
  var n3 = e28 == null ? void 0 : d$1D(e28, r3);
  return n3 === void 0 ? t3 : n3;
}
function e$1w(n3, a3) {
  return n3 != null && a3 in Object(n3);
}
function P$R(r3, m3, s3) {
  m3 = c$1Q(m3, r3);
  for (var n3 = -1, i = m3.length, f3 = false; ++n3 < i; ) {
    var l3 = n$1n(m3[n3]);
    if (!(f3 = r3 != null && s3(r3, l3)))
      break;
    r3 = r3[l3];
  }
  return f3 || ++n3 != i ? f3 : (i = r3 == null ? 0 : r3.length, !!i && r$1$(i) && f$1Q(l3, i) && (a$2p(r3) || m$2c(r3)));
}
function f$1o(a3, r3) {
  return a3 != null && P$R(a3, r3, e$1w);
}
var u$1v = 1, A$C = 2;
function y$11(r3, o3) {
  return m$1S(r3) && o$1r(o3) ? e$1x(n$1n(r3), o3) : function(m3) {
    var t3 = f$1p(m3, r3);
    return t3 === void 0 && t3 === o3 ? f$1o(m3, r3) : m$1T(o3, t3, u$1v | A$C);
  };
}
function r$1H(e28) {
  return function(n3) {
    return n3 == null ? void 0 : n3[e28];
  };
}
function o$1p(e28) {
  return function(r3) {
    return d$1D(r3, e28);
  };
}
function s$1P(r3) {
  return m$1S(r3) ? r$1H(n$1n(r3)) : o$1p(r3);
}
function c$1P(r3) {
  return typeof r3 == "function" ? r3 : r3 == null ? e$1Q : typeof r3 == "object" ? a$2p(r3) ? y$11(r3[0], r3[1]) : h$1x(r3) : s$1P(r3);
}
function m$1Q(r3, o3) {
  return r3 && o$1Q(r3, o3, f$1u);
}
function h$1w(t3, a3) {
  return function(r3, u3) {
    if (r3 == null)
      return r3;
    if (!e$1W(r3))
      return t3(r3, u3);
    for (var f3 = r3.length, e28 = a3 ? f3 : -1, n3 = Object(r3); (a3 ? e28-- : ++e28 < f3) && u3(n3[e28], e28, n3) !== false; )
      ;
    return r3;
  };
}
var r$1G = h$1w(m$1Q);
const t$1p = r$1G;
function o$1o(r3, e28) {
  var t3 = -1, a3 = e$1W(r3) ? Array(r3.length) : [];
  return t$1p(r3, function(f3, i, n3) {
    a3[++t3] = e28(f3, i, n3);
  }), a3;
}
function n$1m(r3, a3) {
  var m3 = a$2p(r3) ? h$1z : o$1o;
  return m3(r3, c$1P(a3));
}
const f$1n = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, t$1o = "var(--n-arrow-height) * 1.414", x$A = r$2a([l$25("popover", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 position: relative;
 font-size: var(--n-font-size);
 color: var(--n-text-color);
 box-shadow: var(--n-box-shadow);
 word-break: break-word;
 `, [r$2a(">", [l$25("scrollbar", `
 height: inherit;
 max-height: inherit;
 `)]), x$I("raw", `
 background-color: var(--n-color);
 border-radius: var(--n-border-radius);
 `, [x$I("scrollable", [x$I("show-header-or-footer", "padding: var(--n-padding);")])]), M$y("header", `
 padding: var(--n-padding);
 border-bottom: 1px solid var(--n-divider-color);
 transition: border-color .3s var(--n-bezier);
 `), M$y("footer", `
 padding: var(--n-padding);
 border-top: 1px solid var(--n-divider-color);
 transition: border-color .3s var(--n-bezier);
 `), g$1j("scrollable, show-header-or-footer", [M$y("content", `
 padding: var(--n-padding);
 `)])]), l$25("popover-shared", `
 transform-origin: inherit;
 `, [
  l$25("popover-arrow-wrapper", `
 position: absolute;
 overflow: hidden;
 pointer-events: none;
 `, [l$25("popover-arrow", `
 transition: background-color .3s var(--n-bezier);
 position: absolute;
 display: block;
 width: calc(${t$1o});
 height: calc(${t$1o});
 box-shadow: 0 0 8px 0 rgba(0, 0, 0, .12);
 transform: rotate(45deg);
 background-color: var(--n-color);
 pointer-events: all;
 `)]),
  r$2a("&.popover-transition-enter-from, &.popover-transition-leave-to", `
 opacity: 0;
 transform: scale(.85);
 `),
  r$2a("&.popover-transition-enter-to, &.popover-transition-leave-from", `
 transform: scale(1);
 opacity: 1;
 `),
  r$2a("&.popover-transition-enter-active", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .15s var(--n-bezier-ease-out),
 transform .15s var(--n-bezier-ease-out);
 `),
  r$2a("&.popover-transition-leave-active", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .15s var(--n-bezier-ease-in),
 transform .15s var(--n-bezier-ease-in);
 `)
]), r$1F("top-start", `
 top: calc(${t$1o} / -2);
 left: calc(${o$1n("top-start")} - var(--v-offset-left));
 `), r$1F("top", `
 top: calc(${t$1o} / -2);
 transform: translateX(calc(${t$1o} / -2)) rotate(45deg);
 left: 50%;
 `), r$1F("top-end", `
 top: calc(${t$1o} / -2);
 right: calc(${o$1n("top-end")} + var(--v-offset-left));
 `), r$1F("bottom-start", `
 bottom: calc(${t$1o} / -2);
 left: calc(${o$1n("bottom-start")} - var(--v-offset-left));
 `), r$1F("bottom", `
 bottom: calc(${t$1o} / -2);
 transform: translateX(calc(${t$1o} / -2)) rotate(45deg);
 left: 50%;
 `), r$1F("bottom-end", `
 bottom: calc(${t$1o} / -2);
 right: calc(${o$1n("bottom-end")} + var(--v-offset-left));
 `), r$1F("left-start", `
 left: calc(${t$1o} / -2);
 top: calc(${o$1n("left-start")} - var(--v-offset-top));
 `), r$1F("left", `
 left: calc(${t$1o} / -2);
 transform: translateY(calc(${t$1o} / -2)) rotate(45deg);
 top: 50%;
 `), r$1F("left-end", `
 left: calc(${t$1o} / -2);
 bottom: calc(${o$1n("left-end")} + var(--v-offset-top));
 `), r$1F("right-start", `
 right: calc(${t$1o} / -2);
 top: calc(${o$1n("right-start")} - var(--v-offset-top));
 `), r$1F("right", `
 right: calc(${t$1o} / -2);
 transform: translateY(calc(${t$1o} / -2)) rotate(45deg);
 top: 50%;
 `), r$1F("right-end", `
 right: calc(${t$1o} / -2);
 bottom: calc(${o$1n("right-end")} + var(--v-offset-top));
 `), ...n$1m({
  top: ["right-start", "left-start"],
  right: ["top-end", "bottom-end"],
  bottom: ["right-end", "left-end"],
  left: ["top-start", "bottom-start"]
}, (i, s3) => {
  const a3 = ["right", "left"].includes(s3), l3 = a3 ? "width" : "height";
  return i.map((p3) => {
    const b3 = p3.split("-")[1] === "end", g3 = `calc((${`var(--v-target-${l3}, 0px)`} - ${t$1o}) / 2)`, h3 = o$1n(p3);
    return r$2a(`[v-placement="${p3}"] >`, [l$25("popover-shared", [g$1j("center-arrow", [l$25("popover-arrow", `${s3}: calc(max(${g3}, ${h3}) ${b3 ? "+" : "-"} var(--v-offset-${a3 ? "left" : "top"}));`)])])]);
  });
})]);
function o$1n(i) {
  return ["top", "bottom"].includes(i.split("-")[0]) ? "var(--n-arrow-offset)" : "var(--n-arrow-offset-vertical)";
}
function r$1F(i, s3) {
  const a3 = i.split("-")[0], l3 = ["top", "bottom"].includes(a3) ? "height: var(--n-space-arrow);" : "width: var(--n-space-arrow);";
  return r$2a(`[v-placement="${i}"] >`, [l$25("popover-shared", `
 margin-${f$1n[a3]}: var(--n-space);
 `, [g$1j("show-arrow", `
 margin-${f$1n[a3]}: var(--n-space-arrow);
 `), g$1j("overlap", `
 margin: 0;
 `), B$U("popover-arrow-wrapper", `
 right: 0;
 left: 0;
 top: 0;
 bottom: 0;
 ${a3}: 100%;
 ${f$1n[a3]}: auto;
 ${l3}
 `, [l$25("popover-arrow", s3)])])]);
}
let e$1v;
function n$1l() {
  return e$1v === void 0 && (e$1v = navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom")), e$1v;
}
const d$1C = "@@mmoContext", m$1P = {
  mounted(o3, { value: e28 }) {
    o3[d$1C] = {
      handler: void 0
    }, typeof e28 == "function" && (o3[d$1C].handler = e28, J$o("mousemoveoutside", o3, e28));
  },
  updated(o3, { value: e28 }) {
    const n3 = o3[d$1C];
    typeof e28 == "function" ? n3.handler ? n3.handler !== e28 && (K$p("mousemoveoutside", o3, n3.handler), n3.handler = e28, J$o("mousemoveoutside", o3, e28)) : (o3[d$1C].handler = e28, J$o("mousemoveoutside", o3, e28)) : n3.handler && (K$p("mousemoveoutside", o3, n3.handler), n3.handler = void 0);
  },
  unmounted(o3) {
    const { handler: e28 } = o3[d$1C];
    e28 && K$p("mousemoveoutside", o3, e28), o3[d$1C].handler = void 0;
  }
}, u$1u = m$1P;
const t$1n = n$28("n-internal-select-menu"), o$1m = n$28("n-internal-select-menu-body");
const i$1C = "__disabled__";
function f$1m(c3) {
  const o3 = inject(e$1M, null), l3 = inject(n$1S, null), u3 = inject(n$1T, null), t3 = inject(o$1m, null), r3 = ref$1();
  if (typeof document < "u") {
    r3.value = document.fullscreenElement;
    const n3 = () => {
      r3.value = document.fullscreenElement;
    };
    onMounted(() => {
      J$o("fullscreenchange", document, n3);
    }), onBeforeUnmount(() => {
      K$p("fullscreenchange", document, n3);
    });
  }
  return n$1U(() => {
    var n3;
    const {
      to: e28
    } = c3;
    return e28 !== void 0 ? e28 === false ? i$1C : e28 === true ? r3.value || "body" : e28 : o3 != null && o3.value ? (n3 = o3.value.$el) !== null && n3 !== void 0 ? n3 : o3.value : l3 != null && l3.value ? l3.value : u3 != null && u3.value ? u3.value : t3 != null && t3.value ? t3.value : e28 != null ? e28 : r3.value || "body";
  });
}
f$1m.tdkey = i$1C;
f$1m.propTo = {
  type: [String, Object, Boolean],
  default: void 0
};
const a$1Z = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, A$B = {
  start: "end",
  center: "center",
  end: "start"
}, X$l = {
  top: "height",
  bottom: "height",
  left: "width",
  right: "width"
}, C$10 = {
  "bottom-start": "top left",
  bottom: "top center",
  "bottom-end": "top right",
  "top-start": "bottom left",
  top: "bottom center",
  "top-end": "bottom right",
  "right-start": "top left",
  right: "center left",
  "right-end": "bottom left",
  "left-start": "top right",
  left: "center right",
  "left-end": "bottom right"
}, z$t = {
  "bottom-start": "bottom left",
  bottom: "bottom center",
  "bottom-end": "bottom right",
  "top-start": "top left",
  top: "top center",
  "top-end": "top right",
  "right-start": "top right",
  right: "center right",
  "right-end": "bottom right",
  "left-start": "top left",
  left: "center left",
  "left-end": "bottom left"
}, k$J = {
  "bottom-start": "right",
  "bottom-end": "left",
  "top-start": "right",
  "top-end": "left",
  "right-start": "bottom",
  "right-end": "top",
  "left-start": "bottom",
  "left-end": "top"
}, O$x = {
  top: true,
  bottom: false,
  left: true,
  right: false
}, v$$ = {
  top: "end",
  bottom: "start",
  left: "end",
  right: "start"
};
function y$10(s3, n3, o3, t3, l3, f3) {
  if (!l3 || f3)
    return { placement: s3, top: 0, left: 0 };
  const [h3, x3] = s3.split("-");
  let u3 = x3 != null ? x3 : "center", $3 = {
    top: 0,
    left: 0
  };
  const m3 = (p3, i, r3) => {
    let d3 = 0, Y3 = 0;
    const M3 = o3[p3] - n3[i] - n3[p3];
    return M3 > 0 && t3 && (r3 ? Y3 = O$x[i] ? M3 : -M3 : d3 = O$x[i] ? M3 : -M3), {
      left: d3,
      top: Y3
    };
  }, b3 = h3 === "left" || h3 === "right";
  if (u3 !== "center") {
    const p3 = k$J[s3], i = a$1Z[p3], r3 = X$l[p3];
    if (o3[r3] > n3[r3]) {
      if (n3[p3] + n3[r3] < o3[r3]) {
        const d3 = (o3[r3] - n3[r3]) / 2;
        n3[p3] < d3 || n3[i] < d3 ? n3[p3] < n3[i] ? (u3 = A$B[x3], $3 = m3(r3, i, b3)) : $3 = m3(r3, p3, b3) : u3 = "center";
      }
    } else
      o3[r3] < n3[r3] && n3[i] < 0 && n3[p3] > n3[i] && (u3 = A$B[x3]);
  } else {
    const p3 = h3 === "bottom" || h3 === "top" ? "left" : "top", i = a$1Z[p3], r3 = X$l[p3], d3 = (o3[r3] - n3[r3]) / 2;
    (n3[p3] < d3 || n3[i] < d3) && (n3[p3] > n3[i] ? (u3 = v$$[p3], $3 = m3(r3, p3, b3)) : (u3 = v$$[i], $3 = m3(r3, i, b3)));
  }
  let w3 = h3;
  return n3[h3] < o3[X$l[h3]] && n3[h3] < n3[a$1Z[h3]] && (w3 = a$1Z[h3]), {
    placement: u3 !== "center" ? `${w3}-${u3}` : w3,
    left: $3.left,
    top: $3.top
  };
}
function D$I(s3, n3) {
  return n3 ? z$t[s3] : C$10[s3];
}
function F$y(s3, n3, o3, t3, l3, f3) {
  if (f3)
    switch (s3) {
      case "bottom-start":
        return {
          top: `${Math.round(o3.top - n3.top + o3.height)}px`,
          left: `${Math.round(o3.left - n3.left)}px`,
          transform: "translateY(-100%)"
        };
      case "bottom-end":
        return {
          top: `${Math.round(o3.top - n3.top + o3.height)}px`,
          left: `${Math.round(o3.left - n3.left + o3.width)}px`,
          transform: "translateX(-100%) translateY(-100%)"
        };
      case "top-start":
        return {
          top: `${Math.round(o3.top - n3.top)}px`,
          left: `${Math.round(o3.left - n3.left)}px`,
          transform: ""
        };
      case "top-end":
        return {
          top: `${Math.round(o3.top - n3.top)}px`,
          left: `${Math.round(o3.left - n3.left + o3.width)}px`,
          transform: "translateX(-100%)"
        };
      case "right-start":
        return {
          top: `${Math.round(o3.top - n3.top)}px`,
          left: `${Math.round(o3.left - n3.left + o3.width)}px`,
          transform: "translateX(-100%)"
        };
      case "right-end":
        return {
          top: `${Math.round(o3.top - n3.top + o3.height)}px`,
          left: `${Math.round(o3.left - n3.left + o3.width)}px`,
          transform: "translateX(-100%) translateY(-100%)"
        };
      case "left-start":
        return {
          top: `${Math.round(o3.top - n3.top)}px`,
          left: `${Math.round(o3.left - n3.left)}px`,
          transform: ""
        };
      case "left-end":
        return {
          top: `${Math.round(o3.top - n3.top + o3.height)}px`,
          left: `${Math.round(o3.left - n3.left)}px`,
          transform: "translateY(-100%)"
        };
      case "top":
        return {
          top: `${Math.round(o3.top - n3.top)}px`,
          left: `${Math.round(o3.left - n3.left + o3.width / 2)}px`,
          transform: "translateX(-50%)"
        };
      case "right":
        return {
          top: `${Math.round(o3.top - n3.top + o3.height / 2)}px`,
          left: `${Math.round(o3.left - n3.left + o3.width)}px`,
          transform: "translateX(-100%) translateY(-50%)"
        };
      case "left":
        return {
          top: `${Math.round(o3.top - n3.top + o3.height / 2)}px`,
          left: `${Math.round(o3.left - n3.left)}px`,
          transform: "translateY(-50%)"
        };
      case "bottom":
      default:
        return {
          top: `${Math.round(o3.top - n3.top + o3.height)}px`,
          left: `${Math.round(o3.left - n3.left + o3.width / 2)}px`,
          transform: "translateX(-50%) translateY(-100%)"
        };
    }
  switch (s3) {
    case "bottom-start":
      return {
        top: `${Math.round(o3.top - n3.top + o3.height + t3)}px`,
        left: `${Math.round(o3.left - n3.left + l3)}px`,
        transform: ""
      };
    case "bottom-end":
      return {
        top: `${Math.round(o3.top - n3.top + o3.height + t3)}px`,
        left: `${Math.round(o3.left - n3.left + o3.width + l3)}px`,
        transform: "translateX(-100%)"
      };
    case "top-start":
      return {
        top: `${Math.round(o3.top - n3.top + t3)}px`,
        left: `${Math.round(o3.left - n3.left + l3)}px`,
        transform: "translateY(-100%)"
      };
    case "top-end":
      return {
        top: `${Math.round(o3.top - n3.top + t3)}px`,
        left: `${Math.round(o3.left - n3.left + o3.width + l3)}px`,
        transform: "translateX(-100%) translateY(-100%)"
      };
    case "right-start":
      return {
        top: `${Math.round(o3.top - n3.top + t3)}px`,
        left: `${Math.round(o3.left - n3.left + o3.width + l3)}px`,
        transform: ""
      };
    case "right-end":
      return {
        top: `${Math.round(o3.top - n3.top + o3.height + t3)}px`,
        left: `${Math.round(o3.left - n3.left + o3.width + l3)}px`,
        transform: "translateY(-100%)"
      };
    case "left-start":
      return {
        top: `${Math.round(o3.top - n3.top + t3)}px`,
        left: `${Math.round(o3.left - n3.left + l3)}px`,
        transform: "translateX(-100%)"
      };
    case "left-end":
      return {
        top: `${Math.round(o3.top - n3.top + o3.height + t3)}px`,
        left: `${Math.round(o3.left - n3.left + l3)}px`,
        transform: "translateX(-100%) translateY(-100%)"
      };
    case "top":
      return {
        top: `${Math.round(o3.top - n3.top + t3)}px`,
        left: `${Math.round(o3.left - n3.left + o3.width / 2 + l3)}px`,
        transform: "translateY(-100%) translateX(-50%)"
      };
    case "right":
      return {
        top: `${Math.round(o3.top - n3.top + o3.height / 2 + t3)}px`,
        left: `${Math.round(o3.left - n3.left + o3.width + l3)}px`,
        transform: "translateY(-50%)"
      };
    case "left":
      return {
        top: `${Math.round(o3.top - n3.top + o3.height / 2 + t3)}px`,
        left: `${Math.round(o3.left - n3.left + l3)}px`,
        transform: "translateY(-50%) translateX(-100%)"
      };
    case "bottom":
    default:
      return {
        top: `${Math.round(o3.top - n3.top + o3.height + t3)}px`,
        left: `${Math.round(o3.left - n3.left + o3.width / 2 + l3)}px`,
        transform: "translateX(-50%)"
      };
  }
}
let o$1l = null;
function i$1B() {
  if (o$1l === null && (o$1l = document.getElementById("v-binder-view-measurer"), o$1l === null)) {
    o$1l = document.createElement("div"), o$1l.id = "v-binder-view-measurer";
    const { style: t3 } = o$1l;
    t3.position = "fixed", t3.left = "0", t3.right = "0", t3.top = "0", t3.bottom = "0", t3.pointerEvents = "none", t3.visibility = "hidden", document.body.appendChild(o$1l);
  }
  return o$1l.getBoundingClientRect();
}
function c$1O(t3, e28) {
  const n3 = i$1B();
  return {
    top: e28,
    left: t3,
    height: 0,
    width: 0,
    right: n3.width - t3,
    bottom: n3.height - e28
  };
}
function f$1l(t3) {
  const e28 = t3.getBoundingClientRect(), n3 = i$1B();
  return {
    left: e28.left - n3.left,
    top: e28.top - n3.top,
    bottom: n3.height + n3.top - e28.bottom,
    right: n3.width + n3.left - e28.right,
    width: e28.width,
    height: e28.height
  };
}
function u$1t(t3) {
  return t3.nodeType === 9 ? null : t3.parentNode;
}
function d$1B(t3) {
  if (t3 === null)
    return null;
  const e28 = u$1t(t3);
  if (e28 === null)
    return null;
  if (e28.nodeType === 9)
    return document;
  if (e28.nodeType === 1) {
    const { overflow: n3, overflowX: r3, overflowY: l3 } = getComputedStyle(e28);
    if (/(auto|scroll|overlay)/.test(n3 + l3 + r3))
      return e28;
  }
  return d$1B(e28);
}
const { c: c$1N } = m$2j(), o$1k = "vueuc-style";
function t$1m() {
  return getCurrentInstance() !== null;
}
const r$1E = typeof window < "u";
let n$1k, t$1l;
const f$1k = () => {
  var o3, e28;
  n$1k = r$1E ? (e28 = (o3 = document) === null || o3 === void 0 ? void 0 : o3.fonts) === null || e28 === void 0 ? void 0 : e28.ready : void 0, t$1l = false, n$1k !== void 0 ? n$1k.then(() => {
    t$1l = true;
  }) : t$1l = true;
};
f$1k();
function a$1Y(o3) {
  if (t$1l)
    return;
  let e28 = false;
  onMounted(() => {
    t$1l || n$1k == null || n$1k.then(() => {
      e28 || o3();
    });
  }), onBeforeUnmount(() => {
    e28 = true;
  });
}
const ne$j = c$1N([
  c$1N(".v-binder-follower-container", {
    position: "absolute",
    left: "0",
    right: "0",
    top: "0",
    height: "0",
    pointerEvents: "none",
    zIndex: "auto"
  }),
  c$1N(".v-binder-follower-content", {
    position: "absolute",
    zIndex: "auto"
  }, [
    c$1N("> *", {
      pointerEvents: "all"
    })
  ])
]), me$h = defineComponent({
  name: "Follower",
  inheritAttrs: false,
  props: {
    show: Boolean,
    enabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: "bottom"
    },
    syncTrigger: {
      type: Array,
      default: ["resize", "scroll"]
    },
    to: [String, Object],
    flip: {
      type: Boolean,
      default: true
    },
    internalShift: Boolean,
    x: Number,
    y: Number,
    width: String,
    minWidth: String,
    containerClass: String,
    teleportDisabled: Boolean,
    zindexable: {
      type: Boolean,
      default: true
    },
    zIndex: Number,
    overlap: Boolean
  },
  setup(n3) {
    const t3 = inject("VBinder"), o3 = n$1U(() => n3.enabled !== void 0 ? n3.enabled : n3.show), v3 = ref$1(null), g3 = ref$1(null), b3 = () => {
      const { syncTrigger: e28 } = n3;
      e28.includes("scroll") && t3.addScrollListener(r3), e28.includes("resize") && t3.addResizeListener(r3);
    }, y3 = () => {
      t3.removeScrollListener(r3), t3.removeResizeListener(r3);
    };
    onMounted(() => {
      o3.value && (r3(), b3());
    });
    const B3 = f$1Z();
    ne$j.mount({
      id: "vueuc/binder",
      head: true,
      anchorMetaName: o$1k,
      ssr: B3
    }), onBeforeUnmount(() => {
      y3();
    }), a$1Y(() => {
      o3.value && r3();
    });
    const r3 = () => {
      if (!o3.value)
        return;
      const e28 = v3.value;
      if (e28 === null)
        return;
      const O3 = t3.targetRef, { x: x3, y: R3, overlap: l3 } = n3, i = x3 !== void 0 && R3 !== void 0 ? c$1O(x3, R3) : f$1l(O3);
      e28.style.setProperty("--v-target-width", `${Math.round(i.width)}px`), e28.style.setProperty("--v-target-height", `${Math.round(i.height)}px`);
      const { width: f3, minWidth: c3, placement: z3, internalShift: E3, flip: N3 } = n3;
      e28.setAttribute("v-placement", z3), l3 ? e28.setAttribute("v-overlap", "") : e28.removeAttribute("v-overlap");
      const { style: s3 } = e28;
      f3 === "target" ? s3.width = `${i.width}px` : f3 !== void 0 ? s3.width = f3 : s3.width = "", c3 === "target" ? s3.minWidth = `${i.width}px` : c3 !== void 0 ? s3.minWidth = c3 : s3.minWidth = "";
      const C3 = f$1l(e28), W3 = f$1l(g3.value), { left: S3, top: T3, placement: u3 } = y$10(z3, i, C3, E3, N3, l3), L3 = D$I(u3, l3), { left: I3, top: D3, transform: F3 } = F$y(u3, W3, i, T3, S3, l3);
      e28.setAttribute("v-placement", u3), e28.style.setProperty("--v-offset-left", `${Math.round(S3)}px`), e28.style.setProperty("--v-offset-top", `${Math.round(T3)}px`), e28.style.transform = `translateX(${I3}) translateY(${D3}) ${F3}`, e28.style.setProperty("--v-transform-origin", L3), e28.style.transformOrigin = L3;
    };
    watch(o3, (e28) => {
      e28 ? (b3(), w3()) : y3();
    });
    const w3 = () => {
      nextTick().then(r3).catch((e28) => console.error(e28));
    };
    [
      "placement",
      "x",
      "y",
      "internalShift",
      "flip",
      "width",
      "overlap",
      "minWidth"
    ].forEach((e28) => {
      watch(toRef$1(n3, e28), r3);
    }), ["teleportDisabled"].forEach((e28) => {
      watch(toRef$1(n3, e28), w3);
    }), watch(toRef$1(n3, "syncTrigger"), (e28) => {
      e28.includes("resize") ? t3.addResizeListener(r3) : t3.removeResizeListener(r3), e28.includes("scroll") ? t3.addScrollListener(r3) : t3.removeScrollListener(r3);
    });
    const M3 = u$1C(), $3 = n$1U(() => {
      const { to: e28 } = n3;
      if (e28 !== void 0)
        return e28;
      M3.value;
    });
    return {
      VBinder: t3,
      mergedEnabled: o3,
      offsetContainerRef: g3,
      followerRef: v3,
      mergedTo: $3,
      syncPosition: r3
    };
  },
  render() {
    return h$1R(h$1D, {
      show: this.show,
      to: this.mergedTo,
      disabled: this.teleportDisabled
    }, {
      default: () => {
        var n3, t3;
        const o3 = h$1R("div", {
          class: ["v-binder-follower-container", this.containerClass],
          ref: "offsetContainerRef"
        }, [
          h$1R("div", {
            class: "v-binder-follower-content",
            ref: "followerRef"
          }, (t3 = (n3 = this.$slots).default) === null || t3 === void 0 ? void 0 : t3.call(n3))
        ]);
        return this.zindexable ? withDirectives(o3, [
          [
            r$1O,
            {
              enabled: this.mergedEnabled,
              zIndex: this.zIndex
            }
          ]
        ]) : o3;
      }
    });
  }
});
const a$1X = {
  space: "6px",
  spaceArrow: "10px",
  arrowOffset: "10px",
  arrowOffsetVertical: "10px",
  arrowHeight: "6px",
  padding: "8px 14px"
};
const c$1M = (o3) => {
  const {
    boxShadow2: r3,
    popoverColor: t3,
    textColor2: e28,
    borderRadius: i,
    fontSize: n3,
    dividerColor: s3
  } = o3;
  return Object.assign(Object.assign({}, a$1X), {
    fontSize: n3,
    borderRadius: i,
    color: t3,
    dividerColor: s3,
    textColor: e28,
    boxShadow: r3
  });
}, p$3t = {
  name: "Popover",
  common: d$1T,
  self: c$1M
}, b$11 = p$3t;
const ge$f = Object.assign(Object.assign({}, _$F.props), {
  to: f$1m.propTo,
  show: Boolean,
  trigger: String,
  showArrow: Boolean,
  delay: Number,
  duration: Number,
  raw: Boolean,
  arrowPointToCenter: Boolean,
  arrowClass: String,
  arrowStyle: [String, Object],
  arrowWrapperClass: String,
  arrowWrapperStyle: [String, Object],
  displayDirective: String,
  x: Number,
  y: Number,
  flip: Boolean,
  overlap: Boolean,
  placement: String,
  width: [Number, String],
  keepAliveOnHover: Boolean,
  scrollable: Boolean,
  contentClass: String,
  contentStyle: [Object, String],
  headerClass: String,
  headerStyle: [Object, String],
  footerClass: String,
  footerStyle: [Object, String],
  internalDeactivateImmediately: Boolean,
  animated: Boolean,
  onClickoutside: Function,
  internalTrapFocus: Boolean,
  internalOnAfterLeave: Function,
  minWidth: Number,
  maxWidth: Number
}), pe$i = ({
  arrowClass: e28,
  arrowStyle: l3,
  arrowWrapperClass: g3,
  arrowWrapperStyle: p3,
  clsPrefix: f3
}) => h$1R("div", {
  key: "__popover-arrow__",
  style: p3,
  class: [`${f3}-popover-arrow-wrapper`, g3]
}, h$1R("div", {
  class: [`${f3}-popover-arrow`, e28],
  style: l3
})), ze$8 = defineComponent({
  name: "PopoverBody",
  inheritAttrs: false,
  props: ge$f,
  setup(e28, {
    slots: l3,
    attrs: g3
  }) {
    const {
      namespaceRef: p3,
      mergedClsPrefixRef: f3,
      inlineThemeDisabled: j3
    } = a$2x(e28), H3 = _$F("Popover", "-popover", x$A, b$11, e28, f3), M3 = ref$1(null), n3 = inject("NPopover"), b3 = ref$1(null), C3 = ref$1(e28.show), h3 = ref$1(false);
    watchEffect(() => {
      const {
        show: o3
      } = e28;
      o3 && !n$1l() && !e28.internalDeactivateImmediately && (h3.value = true);
    });
    const K3 = computed(() => {
      const {
        trigger: o3,
        onClickoutside: r3
      } = e28, a3 = [], {
        positionManuallyRef: {
          value: t3
        }
      } = n3;
      return t3 || (o3 === "click" && !r3 && a3.push([a$2i, k3, void 0, {
        capture: true
      }]), o3 === "hover" && a3.push([u$1u, J3])), r3 && a3.push([a$2i, k3, void 0, {
        capture: true
      }]), (e28.displayDirective === "show" || e28.animated && h3.value) && a3.push([vShow, e28.show]), a3;
    }), N3 = computed(() => {
      const o3 = e28.width === "trigger" ? void 0 : o$1z(e28.width), r3 = [];
      o3 && r3.push({
        width: o3
      });
      const {
        maxWidth: a3,
        minWidth: t3
      } = e28;
      return a3 && r3.push({
        maxWidth: o$1z(a3)
      }), t3 && r3.push({
        maxWidth: o$1z(t3)
      }), j3 || r3.push(P3.value), r3;
    }), P3 = computed(() => {
      const {
        common: {
          cubicBezierEaseInOut: o3,
          cubicBezierEaseIn: r3,
          cubicBezierEaseOut: a3
        },
        self: {
          space: t3,
          spaceArrow: S3,
          padding: B3,
          fontSize: c3,
          textColor: m3,
          dividerColor: u3,
          color: v3,
          boxShadow: w3,
          borderRadius: R3,
          arrowHeight: $3,
          arrowOffset: d3,
          arrowOffsetVertical: X3
        }
      } = H3.value;
      return {
        "--n-box-shadow": w3,
        "--n-bezier": o3,
        "--n-bezier-ease-in": r3,
        "--n-bezier-ease-out": a3,
        "--n-font-size": c3,
        "--n-text-color": m3,
        "--n-color": v3,
        "--n-divider-color": u3,
        "--n-border-radius": R3,
        "--n-arrow-height": $3,
        "--n-arrow-offset": d3,
        "--n-arrow-offset-vertical": X3,
        "--n-padding": B3,
        "--n-space": t3,
        "--n-space-arrow": S3
      };
    }), s3 = j3 ? E$J("popover", void 0, P3, e28) : void 0;
    n3.setBodyInstance({
      syncPosition: V10
    }), onBeforeUnmount(() => {
      n3.setBodyInstance(null);
    }), watch(toRef$1(e28, "show"), (o3) => {
      e28.animated || (o3 ? C3.value = true : C3.value = false);
    });
    function V10() {
      var o3;
      (o3 = M3.value) === null || o3 === void 0 || o3.syncPosition();
    }
    function A3(o3) {
      e28.trigger === "hover" && e28.keepAliveOnHover && e28.show && n3.handleMouseEnter(o3);
    }
    function I3(o3) {
      e28.trigger === "hover" && e28.keepAliveOnHover && n3.handleMouseLeave(o3);
    }
    function J3(o3) {
      e28.trigger === "hover" && !W3().contains(t$1G(o3)) && n3.handleMouseMoveOutside(o3);
    }
    function k3(o3) {
      (e28.trigger === "click" && !W3().contains(t$1G(o3)) || e28.onClickoutside) && n3.handleClickOutside(o3);
    }
    function W3() {
      return n3.getTriggerElement();
    }
    provide(n$1T, b3), provide(n$1S, null), provide(e$1M, null);
    function U3() {
      if (s3 == null || s3.onRender(), !(e28.displayDirective === "show" || e28.show || e28.animated && h3.value))
        return null;
      let r3;
      const a3 = n3.internalRenderBodyRef.value, {
        value: t3
      } = f3;
      if (a3)
        r3 = a3([`${t3}-popover-shared`, s3 == null ? void 0 : s3.themeClass.value, e28.overlap && `${t3}-popover-shared--overlap`, e28.showArrow && `${t3}-popover-shared--show-arrow`, e28.arrowPointToCenter && `${t3}-popover-shared--center-arrow`], b3, N3.value, A3, I3);
      else {
        const {
          value: S3
        } = n3.extraClassRef, {
          internalTrapFocus: B3
        } = e28, c3 = !a$2k(l3.header) || !a$2k(l3.footer), m3 = () => {
          var u3, v3;
          const w3 = c3 ? h$1R(Fragment, null, m$26(l3.header, (d3) => d3 ? h$1R("div", {
            class: [`${t3}-popover__header`, e28.headerClass],
            style: e28.headerStyle
          }, d3) : null), m$26(l3.default, (d3) => d3 ? h$1R("div", {
            class: [`${t3}-popover__content`, e28.contentClass],
            style: e28.contentStyle
          }, l3) : null), m$26(l3.footer, (d3) => d3 ? h$1R("div", {
            class: [`${t3}-popover__footer`, e28.footerClass],
            style: e28.footerStyle
          }, d3) : null)) : e28.scrollable ? (u3 = l3.default) === null || u3 === void 0 ? void 0 : u3.call(l3) : h$1R("div", {
            class: [`${t3}-popover__content`, e28.contentClass],
            style: e28.contentStyle
          }, l3), R3 = e28.scrollable ? h$1R(vn$3, {
            contentClass: c3 ? void 0 : `${t3}-popover__content ${(v3 = e28.contentClass) !== null && v3 !== void 0 ? v3 : ""}`,
            contentStyle: c3 ? void 0 : e28.contentStyle
          }, {
            default: () => w3
          }) : w3, $3 = e28.showArrow ? pe$i({
            arrowClass: e28.arrowClass,
            arrowStyle: e28.arrowStyle,
            arrowWrapperClass: e28.arrowWrapperClass,
            arrowWrapperStyle: e28.arrowWrapperStyle,
            clsPrefix: t3
          }) : null;
          return [R3, $3];
        };
        r3 = h$1R("div", mergeProps({
          class: [`${t3}-popover`, `${t3}-popover-shared`, s3 == null ? void 0 : s3.themeClass.value, S3.map((u3) => `${t3}-${u3}`), {
            [`${t3}-popover--scrollable`]: e28.scrollable,
            [`${t3}-popover--show-header-or-footer`]: c3,
            [`${t3}-popover--raw`]: e28.raw,
            [`${t3}-popover-shared--overlap`]: e28.overlap,
            [`${t3}-popover-shared--show-arrow`]: e28.showArrow,
            [`${t3}-popover-shared--center-arrow`]: e28.arrowPointToCenter
          }],
          ref: b3,
          style: N3.value,
          onKeydown: n3.handleKeydown,
          onMouseenter: A3,
          onMouseleave: I3
        }, g3), B3 ? h$1R(V$x, {
          active: e28.show,
          autoFocus: true
        }, {
          default: m3
        }) : m3());
      }
      return withDirectives(r3, K3.value);
    }
    return {
      displayed: h3,
      namespace: p3,
      isMounted: n3.isMountedRef,
      zIndex: n3.zIndexRef,
      followerRef: M3,
      adjustedTo: f$1m(e28),
      followerEnabled: C3,
      renderContentNode: U3
    };
  },
  render() {
    return h$1R(me$h, {
      ref: "followerRef",
      zIndex: this.zIndex,
      show: this.show,
      enabled: this.followerEnabled,
      to: this.adjustedTo,
      x: this.x,
      y: this.y,
      flip: this.flip,
      placement: this.placement,
      containerClass: this.namespace,
      overlap: this.overlap,
      width: this.width === "trigger" ? "target" : void 0,
      teleportDisabled: this.adjustedTo === f$1m.tdkey
    }, {
      default: () => this.animated ? h$1R(Transition, {
        name: "popover-transition",
        appear: this.isMounted,
        onEnter: () => {
          this.followerEnabled = true;
        },
        onAfterLeave: () => {
          var e28;
          (e28 = this.internalOnAfterLeave) === null || e28 === void 0 || e28.call(this), this.followerEnabled = false, this.displayed = false;
        }
      }, {
        default: this.renderContentNode
      }) : this.renderContentNode()
    });
  }
});
function f$1j(n3, o3) {
  return computed(() => {
    for (const t3 of o3)
      if (n3[t3] !== void 0)
        return n3[t3];
    return n3[o3[o3.length - 1]];
  });
}
function i$1A(f3, t3 = true, n3 = []) {
  return f3.forEach((r3) => {
    if (r3 !== null) {
      if (typeof r3 != "object") {
        (typeof r3 == "string" || typeof r3 == "number") && n3.push(createTextVNode(String(r3)));
        return;
      }
      if (Array.isArray(r3)) {
        i$1A(r3, t3, n3);
        return;
      }
      if (r3.type === Fragment) {
        if (r3.children === null)
          return;
        Array.isArray(r3.children) && i$1A(r3.children, t3, n3);
      } else {
        if (r3.type === Comment && t3)
          return;
        n3.push(r3);
      }
    }
  }), n3;
}
function d$1A(l3, t3 = "default", r3 = void 0) {
  const e28 = l3[t3];
  if (!e28)
    return s$2a("getFirstSlotVNode", `slot[${t3}] is empty`), null;
  const o3 = i$1A(e28(r3));
  return o3.length === 1 ? o3[0] : (s$2a("getFirstSlotVNode", `slot[${t3}] should have exactly one child`), null);
}
let n$1j = [];
const a$1W = /* @__PURE__ */ new WeakMap();
function r$1D() {
  n$1j.forEach((e28) => e28(...a$1W.get(e28))), n$1j = [];
}
function s$1O(e28, ...t3) {
  a$1W.set(e28, t3), !n$1j.includes(e28) && n$1j.push(e28) === 1 && requestAnimationFrame(r$1D);
}
const C$$ = defineComponent({
  name: "Binder",
  props: {
    syncTargetWithParent: Boolean,
    syncTarget: {
      type: Boolean,
      default: true
    }
  },
  setup(u3) {
    var n3;
    provide("VBinder", (n3 = getCurrentInstance()) === null || n3 === void 0 ? void 0 : n3.proxy);
    const c3 = inject("VBinder", null), s3 = ref$1(null), m3 = (e28) => {
      s3.value = e28, c3 && u3.syncTargetWithParent && c3.setTargetRef(e28);
    };
    let t3 = [];
    const p3 = () => {
      let e28 = s3.value;
      for (; e28 = d$1B(e28), e28 !== null; )
        t3.push(e28);
      for (const v3 of t3)
        J$o("scroll", v3, a3, true);
    }, f3 = () => {
      for (const e28 of t3)
        K$p("scroll", e28, a3, true);
      t3 = [];
    }, o3 = /* @__PURE__ */ new Set(), h3 = (e28) => {
      o3.size === 0 && p3(), o3.has(e28) || o3.add(e28);
    }, w3 = (e28) => {
      o3.has(e28) && o3.delete(e28), o3.size === 0 && f3();
    }, a3 = () => {
      s$1O(z3);
    }, z3 = () => {
      o3.forEach((e28) => e28());
    }, r3 = /* @__PURE__ */ new Set(), S3 = (e28) => {
      r3.size === 0 && J$o("resize", window, i), r3.has(e28) || r3.add(e28);
    }, g3 = (e28) => {
      r3.has(e28) && r3.delete(e28), r3.size === 0 && K$p("resize", window, i);
    }, i = () => {
      r3.forEach((e28) => e28());
    };
    return onBeforeUnmount(() => {
      K$p("resize", window, i), f3();
    }), {
      targetRef: s3,
      setTargetRef: m3,
      addScrollListener: h3,
      removeScrollListener: w3,
      addResizeListener: S3,
      removeResizeListener: g3
    };
  },
  render() {
    return h$1E("binder", this.$slots);
  }
}), F$x = C$$;
const g$19 = defineComponent({
  name: "Target",
  setup() {
    const { setTargetRef: e28, syncTarget: t3 } = inject("VBinder");
    return {
      syncTarget: t3,
      setTargetDirective: {
        mounted: e28,
        updated: e28
      }
    };
  },
  render() {
    const { syncTarget: e28, setTargetDirective: t3 } = this;
    return e28 ? withDirectives(y$16("follower", this.$slots), [
      [t3]
    ]) : y$16("follower", this.$slots);
  }
});
function r$1C(c3, n3 = [], o3) {
  const e28 = {};
  return n3.forEach((t3) => {
    e28[t3] = c3[t3];
  }), Object.assign(e28, o3);
}
const ae$i = Object.keys(ge$f), le$f = {
  focus: ["onFocus", "onBlur"],
  click: ["onClick"],
  hover: ["onMouseenter", "onMouseleave"],
  manual: [],
  nested: ["onFocus", "onBlur", "onMouseenter", "onMouseleave", "onClick"]
};
function se$g(e28, p3, c3) {
  le$f[p3].forEach((t3) => {
    e28.props ? e28.props = Object.assign({}, e28.props) : e28.props = {};
    const d3 = e28.props[t3], i = c3[t3];
    d3 ? e28.props[t3] = (...r3) => {
      d3(...r3), i(...r3);
    } : e28.props[t3] = i;
  });
}
const de$g = {
  show: {
    type: Boolean,
    default: void 0
  },
  defaultShow: Boolean,
  showArrow: {
    type: Boolean,
    default: true
  },
  trigger: {
    type: String,
    default: "hover"
  },
  delay: {
    type: Number,
    default: 100
  },
  duration: {
    type: Number,
    default: 100
  },
  raw: Boolean,
  placement: {
    type: String,
    default: "top"
  },
  x: Number,
  y: Number,
  arrowPointToCenter: Boolean,
  disabled: Boolean,
  getDisabled: Function,
  displayDirective: {
    type: String,
    default: "if"
  },
  arrowClass: String,
  arrowStyle: [String, Object],
  arrowWrapperClass: String,
  arrowWrapperStyle: [String, Object],
  flip: {
    type: Boolean,
    default: true
  },
  animated: {
    type: Boolean,
    default: true
  },
  width: {
    type: [Number, String],
    default: void 0
  },
  overlap: Boolean,
  keepAliveOnHover: {
    type: Boolean,
    default: true
  },
  zIndex: Number,
  to: f$1m.propTo,
  scrollable: Boolean,
  contentClass: String,
  contentStyle: [Object, String],
  headerClass: String,
  headerStyle: [Object, String],
  footerClass: String,
  footerStyle: [Object, String],
  onClickoutside: Function,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  internalDeactivateImmediately: Boolean,
  internalSyncTargetWithParent: Boolean,
  internalInheritedEventHandlers: {
    type: Array,
    default: () => []
  },
  internalTrapFocus: Boolean,
  internalExtraClass: {
    type: Array,
    default: () => []
  },
  onShow: [Function, Array],
  onHide: [Function, Array],
  arrow: {
    type: Boolean,
    default: void 0
  },
  minWidth: Number,
  maxWidth: Number
}, ue$i = Object.assign(Object.assign(Object.assign({}, _$F.props), de$g), {
  internalOnAfterLeave: Function,
  internalRenderBody: Function
}), Ie$8 = defineComponent({
  name: "Popover",
  inheritAttrs: false,
  props: ue$i,
  __popover__: true,
  setup(e28) {
    const p3 = u$1C(), c3 = ref$1(null), t3 = computed(() => e28.show), d3 = ref$1(e28.defaultShow), i = d$1S(t3, d3), r3 = n$1U(() => e28.disabled ? false : i.value), o3 = () => {
      if (e28.disabled)
        return true;
      const {
        getDisabled: n3
      } = e28;
      return !!(n3 != null && n3());
    }, u3 = () => o3() ? false : i.value, l3 = f$1j(e28, ["arrow", "showArrow"]), s3 = computed(() => e28.overlap ? false : l3.value);
    let C3 = null;
    const g3 = ref$1(null), m3 = ref$1(null), E3 = n$1U(() => e28.x !== void 0 && e28.y !== void 0);
    function f3(n3) {
      const {
        "onUpdate:show": a3,
        onUpdateShow: h3,
        onShow: R3,
        onHide: k3
      } = e28;
      d3.value = n3, a3 && i$1Z(a3, n3), h3 && i$1Z(h3, n3), n3 && R3 && i$1Z(R3, true), n3 && k3 && i$1Z(k3, false);
    }
    function x3() {
      C3 && C3.syncPosition();
    }
    function y3() {
      const {
        value: n3
      } = g3;
      n3 && (window.clearTimeout(n3), g3.value = null);
    }
    function S3() {
      const {
        value: n3
      } = m3;
      n3 && (window.clearTimeout(n3), m3.value = null);
    }
    function O3() {
      const n3 = o3();
      if (e28.trigger === "focus" && !n3) {
        if (u3())
          return;
        f3(true);
      }
    }
    function D3() {
      const n3 = o3();
      if (e28.trigger === "focus" && !n3) {
        if (!u3())
          return;
        f3(false);
      }
    }
    function I3() {
      const n3 = o3();
      if (e28.trigger === "hover" && !n3) {
        if (S3(), g3.value !== null || u3())
          return;
        const a3 = () => {
          f3(true), g3.value = null;
        }, {
          delay: h3
        } = e28;
        h3 === 0 ? a3() : g3.value = window.setTimeout(a3, h3);
      }
    }
    function M3() {
      const n3 = o3();
      if (e28.trigger === "hover" && !n3) {
        if (y3(), m3.value !== null || !u3())
          return;
        const a3 = () => {
          f3(false), m3.value = null;
        }, {
          duration: h3
        } = e28;
        h3 === 0 ? a3() : m3.value = window.setTimeout(a3, h3);
      }
    }
    function H3() {
      M3();
    }
    function j3(n3) {
      var a3;
      u3() && (e28.trigger === "click" && (y3(), S3(), f3(false)), (a3 = e28.onClickoutside) === null || a3 === void 0 || a3.call(e28, n3));
    }
    function W3() {
      if (e28.trigger === "click" && !o3()) {
        y3(), S3();
        const n3 = !u3();
        f3(n3);
      }
    }
    function N3(n3) {
      e28.internalTrapFocus && n3.key === "Escape" && (y3(), S3(), f3(false));
    }
    function z3(n3) {
      d3.value = n3;
    }
    function U3() {
      var n3;
      return (n3 = c3.value) === null || n3 === void 0 ? void 0 : n3.targetRef;
    }
    function V10(n3) {
      C3 = n3;
    }
    return provide("NPopover", {
      getTriggerElement: U3,
      handleKeydown: N3,
      handleMouseEnter: I3,
      handleMouseLeave: M3,
      handleClickOutside: j3,
      handleMouseMoveOutside: H3,
      setBodyInstance: V10,
      positionManuallyRef: E3,
      isMountedRef: p3,
      zIndexRef: toRef$1(e28, "zIndex"),
      extraClassRef: toRef$1(e28, "internalExtraClass"),
      internalRenderBodyRef: toRef$1(e28, "internalRenderBody")
    }), watchEffect(() => {
      i.value && o3() && f3(false);
    }), {
      binderInstRef: c3,
      positionManually: E3,
      mergedShowConsideringDisabledProp: r3,
      uncontrolledShow: d3,
      mergedShowArrow: s3,
      getMergedShow: u3,
      setShow: z3,
      handleClick: W3,
      handleMouseEnter: I3,
      handleMouseLeave: M3,
      handleFocus: O3,
      handleBlur: D3,
      syncPosition: x3
    };
  },
  render() {
    var e28;
    const {
      positionManually: p3,
      $slots: c3
    } = this;
    let t3, d3 = false;
    if (!p3 && (c3.activator ? t3 = d$1A(c3, "activator") : t3 = d$1A(c3, "trigger"), t3)) {
      t3 = cloneVNode(t3), t3 = t3.type === Text ? h$1R("span", [t3]) : t3;
      const i = {
        onClick: this.handleClick,
        onMouseenter: this.handleMouseEnter,
        onMouseleave: this.handleMouseLeave,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      };
      if (!((e28 = t3.type) === null || e28 === void 0) && e28.__popover__)
        d3 = true, t3.props || (t3.props = {
          internalSyncTargetWithParent: true,
          internalInheritedEventHandlers: []
        }), t3.props.internalSyncTargetWithParent = true, t3.props.internalInheritedEventHandlers ? t3.props.internalInheritedEventHandlers = [i, ...t3.props.internalInheritedEventHandlers] : t3.props.internalInheritedEventHandlers = [i];
      else {
        const {
          internalInheritedEventHandlers: r3
        } = this, o3 = [i, ...r3], u3 = {
          onBlur: (l3) => {
            o3.forEach((s3) => {
              s3.onBlur(l3);
            });
          },
          onFocus: (l3) => {
            o3.forEach((s3) => {
              s3.onFocus(l3);
            });
          },
          onClick: (l3) => {
            o3.forEach((s3) => {
              s3.onClick(l3);
            });
          },
          onMouseenter: (l3) => {
            o3.forEach((s3) => {
              s3.onMouseenter(l3);
            });
          },
          onMouseleave: (l3) => {
            o3.forEach((s3) => {
              s3.onMouseleave(l3);
            });
          }
        };
        se$g(t3, r3 ? "nested" : p3 ? "manual" : this.trigger, u3);
      }
    }
    return h$1R(F$x, {
      ref: "binderInstRef",
      syncTarget: !d3,
      syncTargetWithParent: this.internalSyncTargetWithParent
    }, {
      default: () => {
        this.mergedShowConsideringDisabledProp;
        const i = this.getMergedShow();
        return [this.internalTrapFocus && i ? withDirectives(h$1R("div", {
          style: {
            position: "fixed",
            inset: 0
          }
        }), [[r$1O, {
          enabled: i,
          zIndex: this.zIndex
        }]]) : null, p3 ? null : h$1R(g$19, null, {
          default: () => t3
        }), h$1R(ze$8, r$1C(this.$props, ae$i, Object.assign(Object.assign({}, this.$attrs), {
          showArrow: this.mergedShowArrow,
          show: i
        })), {
          default: () => {
            var r3, o3;
            return (o3 = (r3 = this.$slots).default) === null || o3 === void 0 ? void 0 : o3.call(r3);
          },
          header: () => {
            var r3, o3;
            return (o3 = (r3 = this.$slots).header) === null || o3 === void 0 ? void 0 : o3.call(r3);
          },
          footer: () => {
            var r3, o3;
            return (o3 = (r3 = this.$slots).footer) === null || o3 === void 0 ? void 0 : o3.call(r3);
          }
        })];
      }
    });
  }
});
const a$1V = {
  padding: "8px 14px"
};
const c$1L = (t3) => {
  const {
    borderRadius: r3,
    boxShadow2: e28,
    baseColor: o3
  } = t3;
  return Object.assign(Object.assign({}, a$1V), {
    borderRadius: r3,
    boxShadow: e28,
    color: G$v(o3, "rgba(0, 0, 0, .85)"),
    textColor: o3
  });
}, n$1i = G$w({
  name: "Tooltip",
  common: d$1T,
  peers: {
    Popover: b$11
  },
  self: c$1L
}), d$1z = n$1i;
const f$1i = Object.assign(Object.assign({}, de$g), _$F.props), b$10 = defineComponent({
  name: "Tooltip",
  props: f$1i,
  __popover__: true,
  setup(e28) {
    const {
      mergedClsPrefixRef: o3
    } = a$2x(e28), r3 = _$F("Tooltip", "-tooltip", void 0, d$1z, e28, o3), t3 = ref$1(null);
    return Object.assign(Object.assign({}, {
      syncPosition() {
        t3.value.syncPosition();
      },
      setShow(p3) {
        t3.value.setShow(p3);
      }
    }), {
      popoverRef: t3,
      mergedTheme: r3,
      popoverThemeOverrides: computed(() => r3.value.self)
    });
  },
  render() {
    const {
      mergedTheme: e28,
      internalExtraClass: o3
    } = this;
    return h$1R(Ie$8, Object.assign(Object.assign({}, this.$props), {
      theme: e28.peers.Popover,
      themeOverrides: e28.peerOverrides.Popover,
      builtinThemeOverrides: this.popoverThemeOverrides,
      internalExtraClass: o3.concat("tooltip"),
      ref: "popoverRef"
    }), this.$slots);
  }
});
const m$1O = defineComponent({
  name: "UITooltip",
  inheritAttrs: false
}), d$1y = defineComponent(__spreadProps(__spreadValues({}, m$1O), {
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    placement: {
      type: String,
      default: void 0
    },
    show: {
      type: Boolean,
      default: void 0
    }
  },
  setup(t3) {
    return (e28, o3) => (openBlock(), createBlock(unref(b$10), mergeProps(e28.$attrs, {
      trigger: t3.trigger,
      show: t3.show,
      placement: t3.placement,
      "onUpdate:show": o3[0] || (o3[0] = (l3) => e28.$emit("show", l3))
    }), {
      trigger: withCtx(() => [
        renderSlot(e28.$slots, "trigger")
      ]),
      default: withCtx(() => [
        renderSlot(e28.$slots, "default")
      ]),
      _: 3
    }, 16, ["trigger", "show", "placement"]));
  }
})), w$K = d$1y;
const g$18 = defineComponent({
  name: "UIFormLabelTooltip",
  inheritAttrs: false
}), p$3s = defineComponent(__spreadProps(__spreadValues({}, g$18), {
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    placement: {
      type: String,
      default: void 0
    },
    icon: {
      type: Function,
      default: l$1G
    },
    iconClass: String
  },
  setup(e28) {
    return (l3, u3) => (openBlock(), createBlock(unref(w$K), {
      placement: e28.placement,
      trigger: e28.trigger
    }, {
      trigger: withCtx(() => [
        (openBlock(), createBlock(resolveDynamicComponent(e28.icon), {
          class: normalizeClass(e28.iconClass ? e28.iconClass : "w-4 h-4 text-gray-500")
        }, null, 8, ["class"]))
      ]),
      default: withCtx(() => [
        renderSlot(l3.$slots, "default")
      ]),
      _: 3
    }, 8, ["placement", "trigger"]));
  }
})), S$I = p$3s;
const B$K = { class: "hl-form-content-hz" }, F$w = { class: "col-left" }, N$D = { class: "n-form-custom-label" }, T$K = {
  key: 0,
  class: "asterisk"
}, V$v = { key: 0 }, z$s = {
  key: 0,
  class: "extra"
}, D$H = { class: "col-right" }, _$A = defineComponent({
  name: "UIFormContentHorizontal",
  inheritAttrs: false
}), q$x = defineComponent(__spreadProps(__spreadValues({}, _$A), {
  props: {
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: Object,
      default: null
    }
  },
  setup(t3) {
    const x3 = useSlots();
    return (c3, A3) => {
      var d3, m3, u3, f3;
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(p$3A)),
        createElementVNode("div", B$K, [
          createElementVNode("div", F$w, [
            createElementVNode("div", N$D, [
              createVNode(unref(d$1H), { class: "title" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(t3.label) + " ", 1),
                  t3.required ? (openBlock(), createElementBlock("span", T$K, "\xA0*")) : createCommentVNode("", true)
                ]),
                _: 1
              }),
              t3.tooltip ? (openBlock(), createBlock(S$I, {
                key: 0,
                placement: (d3 = t3.tooltip) == null ? void 0 : d3.placement,
                trigger: (m3 = t3.tooltip) == null ? void 0 : m3.trigger,
                icon: (u3 = t3.tooltip) == null ? void 0 : u3.icon,
                iconClass: (f3 = t3.tooltip) == null ? void 0 : f3.iconClass
              }, {
                default: withCtx(() => [
                  typeof t3.tooltip.text == "string" ? (openBlock(), createElementBlock("span", V$v, toDisplayString(t3.tooltip.text), 1)) : (openBlock(), createBlock(resolveDynamicComponent(t3.tooltip.text), { key: 1 }))
                ]),
                _: 1
              }, 8, ["placement", "trigger", "icon", "iconClass"])) : createCommentVNode("", true)
            ]),
            createVNode(unref(_$C), { class: "description" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(t3.description), 1)
              ]),
              _: 1
            }),
            unref(x3).extra ? (openBlock(), createElementBlock("div", z$s, [
              renderSlot(c3.$slots, "extra")
            ])) : createCommentVNode("", true)
          ]),
          createElementVNode("div", D$H, [
            renderSlot(c3.$slots, "default")
          ])
        ])
      ], 64);
    };
  }
})), R$s = q$x;
function R$r() {
  return R$r = Object.assign ? Object.assign.bind() : function(i) {
    for (var e28 = 1; e28 < arguments.length; e28++) {
      var r3 = arguments[e28];
      for (var n3 in r3)
        Object.prototype.hasOwnProperty.call(r3, n3) && (i[n3] = r3[n3]);
    }
    return i;
  }, R$r.apply(this, arguments);
}
function re$e(i, e28) {
  i.prototype = Object.create(e28.prototype), i.prototype.constructor = i, $$o(i, e28);
}
function U$w(i) {
  return U$w = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r3) {
    return r3.__proto__ || Object.getPrototypeOf(r3);
  }, U$w(i);
}
function $$o(i, e28) {
  return $$o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n3, t3) {
    return n3.__proto__ = t3, n3;
  }, $$o(i, e28);
}
function ne$i() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return false;
  if (typeof Proxy == "function")
    return true;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), true;
  } catch {
    return false;
  }
}
function M$s(i, e28, r3) {
  return ne$i() ? M$s = Reflect.construct.bind() : M$s = function(t3, f3, a3) {
    var s3 = [null];
    s3.push.apply(s3, f3);
    var d3 = Function.bind.apply(t3, s3), w3 = new d3();
    return a3 && $$o(w3, a3.prototype), w3;
  }, M$s.apply(null, arguments);
}
function te$j(i) {
  return Function.toString.call(i).indexOf("[native code]") !== -1;
}
function J$n(i) {
  var e28 = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return J$n = function(n3) {
    if (n3 === null || !te$j(n3))
      return n3;
    if (typeof n3 != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e28 < "u") {
      if (e28.has(n3))
        return e28.get(n3);
      e28.set(n3, t3);
    }
    function t3() {
      return M$s(n3, arguments, U$w(this).constructor);
    }
    return t3.prototype = Object.create(n3.prototype, {
      constructor: {
        value: t3,
        enumerable: false,
        writable: true,
        configurable: true
      }
    }), $$o(t3, n3);
  }, J$n(i);
}
var ie$g = /%[sdj%]/g, C$_ = function() {
};
typeof process < "u" && process.env && false;
function W$p(i) {
  if (!i || !i.length)
    return null;
  var e28 = {};
  return i.forEach(function(r3) {
    var n3 = r3.field;
    e28[n3] = e28[n3] || [], e28[n3].push(r3);
  }), e28;
}
function F$v(i) {
  for (var e28 = arguments.length, r3 = new Array(e28 > 1 ? e28 - 1 : 0), n3 = 1; n3 < e28; n3++)
    r3[n3 - 1] = arguments[n3];
  var t3 = 0, f3 = r3.length;
  if (typeof i == "function")
    return i.apply(null, r3);
  if (typeof i == "string") {
    var a3 = i.replace(ie$g, function(s3) {
      if (s3 === "%%")
        return "%";
      if (t3 >= f3)
        return s3;
      switch (s3) {
        case "%s":
          return String(r3[t3++]);
        case "%d":
          return Number(r3[t3++]);
        case "%j":
          try {
            return JSON.stringify(r3[t3++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return s3;
      }
    });
    return a3;
  }
  return i;
}
function ae$h(i) {
  return i === "string" || i === "url" || i === "hex" || i === "email" || i === "date" || i === "pattern";
}
function v$_(i, e28) {
  return !!(i == null || e28 === "array" && Array.isArray(i) && !i.length || ae$h(e28) && typeof i == "string" && !i);
}
function fe$c(i, e28, r3) {
  var n3 = [], t3 = 0, f3 = i.length;
  function a3(s3) {
    n3.push.apply(n3, s3 || []), t3++, t3 === f3 && r3(n3);
  }
  i.forEach(function(s3) {
    e28(s3, a3);
  });
}
function G$t(i, e28, r3) {
  var n3 = 0, t3 = i.length;
  function f3(a3) {
    if (a3 && a3.length) {
      r3(a3);
      return;
    }
    var s3 = n3;
    n3 = n3 + 1, s3 < t3 ? e28(i[s3], f3) : r3([]);
  }
  f3([]);
}
function se$f(i) {
  var e28 = [];
  return Object.keys(i).forEach(function(r3) {
    e28.push.apply(e28, i[r3] || []);
  }), e28;
}
var K$m = /* @__PURE__ */ function(i) {
  re$e(e28, i);
  function e28(r3, n3) {
    var t3;
    return t3 = i.call(this, "Async Validation Error") || this, t3.errors = r3, t3.fields = n3, t3;
  }
  return e28;
}(/* @__PURE__ */ J$n(Error));
function oe$h(i, e28, r3, n3, t3) {
  if (e28.first) {
    var f3 = new Promise(function(l3, O3) {
      var x3 = function(o3) {
        return n3(o3), o3.length ? O3(new K$m(o3, W$p(o3))) : l3(t3);
      }, u3 = se$f(i);
      G$t(u3, r3, x3);
    });
    return f3.catch(function(l3) {
      return l3;
    }), f3;
  }
  var a3 = e28.firstFields === true ? Object.keys(i) : e28.firstFields || [], s3 = Object.keys(i), d3 = s3.length, w3 = 0, h3 = [], m3 = new Promise(function(l3, O3) {
    var x3 = function(g3) {
      if (h3.push.apply(h3, g3), w3++, w3 === d3)
        return n3(h3), h3.length ? O3(new K$m(h3, W$p(h3))) : l3(t3);
    };
    s3.length || (n3(h3), l3(t3)), s3.forEach(function(u3) {
      var g3 = i[u3];
      a3.indexOf(u3) !== -1 ? G$t(g3, r3, x3) : fe$c(g3, r3, x3);
    });
  });
  return m3.catch(function(l3) {
    return l3;
  }), m3;
}
function de$f(i) {
  return !!(i && i.message !== void 0);
}
function ue$h(i, e28) {
  for (var r3 = i, n3 = 0; n3 < e28.length; n3++) {
    if (r3 == null)
      return r3;
    r3 = r3[e28[n3]];
  }
  return r3;
}
function H$q(i, e28) {
  return function(r3) {
    var n3;
    return i.fullFields ? n3 = ue$h(e28, i.fullFields) : n3 = e28[r3.field || i.fullField], de$f(r3) ? (r3.field = r3.field || i.fullField, r3.fieldValue = n3, r3) : {
      message: typeof r3 == "function" ? r3() : r3,
      fieldValue: n3,
      field: r3.field || i.fullField
    };
  };
}
function Q$q(i, e28) {
  if (e28) {
    for (var r3 in e28)
      if (e28.hasOwnProperty(r3)) {
        var n3 = e28[r3];
        typeof n3 == "object" && typeof i[r3] == "object" ? i[r3] = R$r({}, i[r3], n3) : i[r3] = n3;
      }
  }
  return i;
}
var k$I = function(e28, r3, n3, t3, f3, a3) {
  e28.required && (!n3.hasOwnProperty(e28.field) || v$_(r3, a3 || e28.type)) && t3.push(F$v(f3.messages.required, e28.fullField));
}, ce$c = function(e28, r3, n3, t3, f3) {
  (/^\s+$/.test(r3) || r3 === "") && t3.push(F$v(f3.messages.whitespace, e28.fullField));
}, S$H, pe$h = function() {
  if (S$H)
    return S$H;
  var i = "[a-fA-F\\d:]", e28 = function(y3) {
    return y3 && y3.includeBoundaries ? "(?:(?<=\\s|^)(?=" + i + ")|(?<=" + i + ")(?=\\s|$))" : "";
  }, r3 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", n3 = "[a-fA-F\\d]{1,4}", t3 = (`
(?:
(?:` + n3 + ":){7}(?:" + n3 + `|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:` + n3 + ":){6}(?:" + r3 + "|:" + n3 + `|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:` + n3 + ":){5}(?::" + r3 + "|(?::" + n3 + `){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:` + n3 + ":){4}(?:(?::" + n3 + "){0,1}:" + r3 + "|(?::" + n3 + `){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:` + n3 + ":){3}(?:(?::" + n3 + "){0,2}:" + r3 + "|(?::" + n3 + `){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:` + n3 + ":){2}(?:(?::" + n3 + "){0,3}:" + r3 + "|(?::" + n3 + `){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:` + n3 + ":){1}(?:(?::" + n3 + "){0,4}:" + r3 + "|(?::" + n3 + `){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::` + n3 + "){0,5}:" + r3 + "|(?::" + n3 + `){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`).replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), f3 = new RegExp("(?:^" + r3 + "$)|(?:^" + t3 + "$)"), a3 = new RegExp("^" + r3 + "$"), s3 = new RegExp("^" + t3 + "$"), d3 = function(y3) {
    return y3 && y3.exact ? f3 : new RegExp("(?:" + e28(y3) + r3 + e28(y3) + ")|(?:" + e28(y3) + t3 + e28(y3) + ")", "g");
  };
  d3.v4 = function(p3) {
    return p3 && p3.exact ? a3 : new RegExp("" + e28(p3) + r3 + e28(p3), "g");
  }, d3.v6 = function(p3) {
    return p3 && p3.exact ? s3 : new RegExp("" + e28(p3) + t3 + e28(p3), "g");
  };
  var w3 = "(?:(?:[a-z]+:)?//)", h3 = "(?:\\S+(?::\\S*)?@)?", m3 = d3.v4().source, l3 = d3.v6().source, O3 = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", x3 = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", u3 = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", g3 = "(?::\\d{2,5})?", o3 = '(?:[/?#][^\\s"]*)?', A3 = "(?:" + w3 + "|www\\.)" + h3 + "(?:localhost|" + m3 + "|" + l3 + "|" + O3 + x3 + u3 + ")" + g3 + o3;
  return S$H = new RegExp("(?:^" + A3 + "$)", "i"), S$H;
}, X$k = {
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, D$G = {
  integer: function(e28) {
    return D$G.number(e28) && parseInt(e28, 10) === e28;
  },
  float: function(e28) {
    return D$G.number(e28) && !D$G.integer(e28);
  },
  array: function(e28) {
    return Array.isArray(e28);
  },
  regexp: function(e28) {
    if (e28 instanceof RegExp)
      return true;
    try {
      return !!new RegExp(e28);
    } catch {
      return false;
    }
  },
  date: function(e28) {
    return typeof e28.getTime == "function" && typeof e28.getMonth == "function" && typeof e28.getYear == "function" && !isNaN(e28.getTime());
  },
  number: function(e28) {
    return isNaN(e28) ? false : typeof e28 == "number";
  },
  object: function(e28) {
    return typeof e28 == "object" && !D$G.array(e28);
  },
  method: function(e28) {
    return typeof e28 == "function";
  },
  email: function(e28) {
    return typeof e28 == "string" && e28.length <= 320 && !!e28.match(X$k.email);
  },
  url: function(e28) {
    return typeof e28 == "string" && e28.length <= 2048 && !!e28.match(pe$h());
  },
  hex: function(e28) {
    return typeof e28 == "string" && !!e28.match(X$k.hex);
  }
}, ye$c = function(e28, r3, n3, t3, f3) {
  if (e28.required && r3 === void 0) {
    k$I(e28, r3, n3, t3, f3);
    return;
  }
  var a3 = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], s3 = e28.type;
  a3.indexOf(s3) > -1 ? D$G[s3](r3) || t3.push(F$v(f3.messages.types[s3], e28.fullField, e28.type)) : s3 && typeof r3 !== e28.type && t3.push(F$v(f3.messages.types[s3], e28.fullField, e28.type));
}, ge$e = function(e28, r3, n3, t3, f3) {
  var a3 = typeof e28.len == "number", s3 = typeof e28.min == "number", d3 = typeof e28.max == "number", w3 = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, h3 = r3, m3 = null, l3 = typeof r3 == "number", O3 = typeof r3 == "string", x3 = Array.isArray(r3);
  if (l3 ? m3 = "number" : O3 ? m3 = "string" : x3 && (m3 = "array"), !m3)
    return false;
  x3 && (h3 = r3.length), O3 && (h3 = r3.replace(w3, "_").length), a3 ? h3 !== e28.len && t3.push(F$v(f3.messages[m3].len, e28.fullField, e28.len)) : s3 && !d3 && h3 < e28.min ? t3.push(F$v(f3.messages[m3].min, e28.fullField, e28.min)) : d3 && !s3 && h3 > e28.max ? t3.push(F$v(f3.messages[m3].max, e28.fullField, e28.max)) : s3 && d3 && (h3 < e28.min || h3 > e28.max) && t3.push(F$v(f3.messages[m3].range, e28.fullField, e28.min, e28.max));
}, N$C = "enum", he$f = function(e28, r3, n3, t3, f3) {
  e28[N$C] = Array.isArray(e28[N$C]) ? e28[N$C] : [], e28[N$C].indexOf(r3) === -1 && t3.push(F$v(f3.messages[N$C], e28.fullField, e28[N$C].join(", ")));
}, ve$e = function(e28, r3, n3, t3, f3) {
  if (e28.pattern) {
    if (e28.pattern instanceof RegExp)
      e28.pattern.lastIndex = 0, e28.pattern.test(r3) || t3.push(F$v(f3.messages.pattern.mismatch, e28.fullField, r3, e28.pattern));
    else if (typeof e28.pattern == "string") {
      var a3 = new RegExp(e28.pattern);
      a3.test(r3) || t3.push(F$v(f3.messages.pattern.mismatch, e28.fullField, r3, e28.pattern));
    }
  }
}, c$1K = {
  required: k$I,
  whitespace: ce$c,
  type: ye$c,
  range: ge$e,
  enum: he$f,
  pattern: ve$e
}, me$g = function(e28, r3, n3, t3, f3) {
  var a3 = [], s3 = e28.required || !e28.required && t3.hasOwnProperty(e28.field);
  if (s3) {
    if (v$_(r3, "string") && !e28.required)
      return n3();
    c$1K.required(e28, r3, t3, a3, f3, "string"), v$_(r3, "string") || (c$1K.type(e28, r3, t3, a3, f3), c$1K.range(e28, r3, t3, a3, f3), c$1K.pattern(e28, r3, t3, a3, f3), e28.whitespace === true && c$1K.whitespace(e28, r3, t3, a3, f3));
  }
  n3(a3);
}, le$e = function(e28, r3, n3, t3, f3) {
  var a3 = [], s3 = e28.required || !e28.required && t3.hasOwnProperty(e28.field);
  if (s3) {
    if (v$_(r3) && !e28.required)
      return n3();
    c$1K.required(e28, r3, t3, a3, f3), r3 !== void 0 && c$1K.type(e28, r3, t3, a3, f3);
  }
  n3(a3);
}, we$c = function(e28, r3, n3, t3, f3) {
  var a3 = [], s3 = e28.required || !e28.required && t3.hasOwnProperty(e28.field);
  if (s3) {
    if (r3 === "" && (r3 = void 0), v$_(r3) && !e28.required)
      return n3();
    c$1K.required(e28, r3, t3, a3, f3), r3 !== void 0 && (c$1K.type(e28, r3, t3, a3, f3), c$1K.range(e28, r3, t3, a3, f3));
  }
  n3(a3);
}, qe$7 = function(e28, r3, n3, t3, f3) {
  var a3 = [], s3 = e28.required || !e28.required && t3.hasOwnProperty(e28.field);
  if (s3) {
    if (v$_(r3) && !e28.required)
      return n3();
    c$1K.required(e28, r3, t3, a3, f3), r3 !== void 0 && c$1K.type(e28, r3, t3, a3, f3);
  }
  n3(a3);
}, be$e = function(e28, r3, n3, t3, f3) {
  var a3 = [], s3 = e28.required || !e28.required && t3.hasOwnProperty(e28.field);
  if (s3) {
    if (v$_(r3) && !e28.required)
      return n3();
    c$1K.required(e28, r3, t3, a3, f3), v$_(r3) || c$1K.type(e28, r3, t3, a3, f3);
  }
  n3(a3);
}, Fe$8 = function(e28, r3, n3, t3, f3) {
  var a3 = [], s3 = e28.required || !e28.required && t3.hasOwnProperty(e28.field);
  if (s3) {
    if (v$_(r3) && !e28.required)
      return n3();
    c$1K.required(e28, r3, t3, a3, f3), r3 !== void 0 && (c$1K.type(e28, r3, t3, a3, f3), c$1K.range(e28, r3, t3, a3, f3));
  }
  n3(a3);
}, xe$c = function(e28, r3, n3, t3, f3) {
  var a3 = [], s3 = e28.required || !e28.required && t3.hasOwnProperty(e28.field);
  if (s3) {
    if (v$_(r3) && !e28.required)
      return n3();
    c$1K.required(e28, r3, t3, a3, f3), r3 !== void 0 && (c$1K.type(e28, r3, t3, a3, f3), c$1K.range(e28, r3, t3, a3, f3));
  }
  n3(a3);
}, Oe$8 = function(e28, r3, n3, t3, f3) {
  var a3 = [], s3 = e28.required || !e28.required && t3.hasOwnProperty(e28.field);
  if (s3) {
    if (r3 == null && !e28.required)
      return n3();
    c$1K.required(e28, r3, t3, a3, f3, "array"), r3 != null && (c$1K.type(e28, r3, t3, a3, f3), c$1K.range(e28, r3, t3, a3, f3));
  }
  n3(a3);
}, Ee$8 = function(e28, r3, n3, t3, f3) {
  var a3 = [], s3 = e28.required || !e28.required && t3.hasOwnProperty(e28.field);
  if (s3) {
    if (v$_(r3) && !e28.required)
      return n3();
    c$1K.required(e28, r3, t3, a3, f3), r3 !== void 0 && c$1K.type(e28, r3, t3, a3, f3);
  }
  n3(a3);
}, Ae$8 = "enum", Pe$b = function(e28, r3, n3, t3, f3) {
  var a3 = [], s3 = e28.required || !e28.required && t3.hasOwnProperty(e28.field);
  if (s3) {
    if (v$_(r3) && !e28.required)
      return n3();
    c$1K.required(e28, r3, t3, a3, f3), r3 !== void 0 && c$1K[Ae$8](e28, r3, t3, a3, f3);
  }
  n3(a3);
}, je$6 = function(e28, r3, n3, t3, f3) {
  var a3 = [], s3 = e28.required || !e28.required && t3.hasOwnProperty(e28.field);
  if (s3) {
    if (v$_(r3, "string") && !e28.required)
      return n3();
    c$1K.required(e28, r3, t3, a3, f3), v$_(r3, "string") || c$1K.pattern(e28, r3, t3, a3, f3);
  }
  n3(a3);
}, _e$b = function(e28, r3, n3, t3, f3) {
  var a3 = [], s3 = e28.required || !e28.required && t3.hasOwnProperty(e28.field);
  if (s3) {
    if (v$_(r3, "date") && !e28.required)
      return n3();
    if (c$1K.required(e28, r3, t3, a3, f3), !v$_(r3, "date")) {
      var d3;
      r3 instanceof Date ? d3 = r3 : d3 = new Date(r3), c$1K.type(e28, d3, t3, a3, f3), d3 && c$1K.range(e28, d3.getTime(), t3, a3, f3);
    }
  }
  n3(a3);
}, Re$c = function(e28, r3, n3, t3, f3) {
  var a3 = [], s3 = Array.isArray(r3) ? "array" : typeof r3;
  c$1K.required(e28, r3, t3, a3, f3, s3), n3(a3);
}, B$J = function(e28, r3, n3, t3, f3) {
  var a3 = e28.type, s3 = [], d3 = e28.required || !e28.required && t3.hasOwnProperty(e28.field);
  if (d3) {
    if (v$_(r3, a3) && !e28.required)
      return n3();
    c$1K.required(e28, r3, t3, s3, f3, a3), v$_(r3, a3) || c$1K.type(e28, r3, t3, s3, f3);
  }
  n3(s3);
}, Ne$8 = function(e28, r3, n3, t3, f3) {
  var a3 = [], s3 = e28.required || !e28.required && t3.hasOwnProperty(e28.field);
  if (s3) {
    if (v$_(r3) && !e28.required)
      return n3();
    c$1K.required(e28, r3, t3, a3, f3);
  }
  n3(a3);
}, T$J = {
  string: me$g,
  method: le$e,
  number: we$c,
  boolean: qe$7,
  regexp: be$e,
  integer: Fe$8,
  float: xe$c,
  array: Oe$8,
  object: Ee$8,
  enum: Pe$b,
  pattern: je$6,
  date: _e$b,
  url: B$J,
  hex: B$J,
  email: B$J,
  required: Re$c,
  any: Ne$8
};
function Z$p() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var e28 = JSON.parse(JSON.stringify(this));
      return e28.clone = this.clone, e28;
    }
  };
}
var I$B = Z$p(), L$D = /* @__PURE__ */ function() {
  function i(r3) {
    this.rules = null, this._messages = I$B, this.define(r3);
  }
  var e28 = i.prototype;
  return e28.define = function(n3) {
    var t3 = this;
    if (!n3)
      throw new Error("Cannot configure a schema with no rules");
    if (typeof n3 != "object" || Array.isArray(n3))
      throw new Error("Rules must be an object");
    this.rules = {}, Object.keys(n3).forEach(function(f3) {
      var a3 = n3[f3];
      t3.rules[f3] = Array.isArray(a3) ? a3 : [a3];
    });
  }, e28.messages = function(n3) {
    return n3 && (this._messages = Q$q(Z$p(), n3)), this._messages;
  }, e28.validate = function(n3, t3, f3) {
    var a3 = this;
    t3 === void 0 && (t3 = {}), f3 === void 0 && (f3 = function() {
    });
    var s3 = n3, d3 = t3, w3 = f3;
    if (typeof d3 == "function" && (w3 = d3, d3 = {}), !this.rules || Object.keys(this.rules).length === 0)
      return w3 && w3(null, s3), Promise.resolve(s3);
    function h3(u3) {
      var g3 = [], o3 = {};
      function A3(y3) {
        if (Array.isArray(y3)) {
          var b3;
          g3 = (b3 = g3).concat.apply(b3, y3);
        } else
          g3.push(y3);
      }
      for (var p3 = 0; p3 < u3.length; p3++)
        A3(u3[p3]);
      g3.length ? (o3 = W$p(g3), w3(g3, o3)) : w3(null, s3);
    }
    if (d3.messages) {
      var m3 = this.messages();
      m3 === I$B && (m3 = Z$p()), Q$q(m3, d3.messages), d3.messages = m3;
    } else
      d3.messages = this.messages();
    var l3 = {}, O3 = d3.keys || Object.keys(this.rules);
    O3.forEach(function(u3) {
      var g3 = a3.rules[u3], o3 = s3[u3];
      g3.forEach(function(A3) {
        var p3 = A3;
        typeof p3.transform == "function" && (s3 === n3 && (s3 = R$r({}, s3)), o3 = s3[u3] = p3.transform(o3)), typeof p3 == "function" ? p3 = {
          validator: p3
        } : p3 = R$r({}, p3), p3.validator = a3.getValidationMethod(p3), p3.validator && (p3.field = u3, p3.fullField = p3.fullField || u3, p3.type = a3.getType(p3), l3[u3] = l3[u3] || [], l3[u3].push({
          rule: p3,
          value: o3,
          source: s3,
          field: u3
        }));
      });
    });
    var x3 = {};
    return oe$h(l3, d3, function(u3, g3) {
      var o3 = u3.rule, A3 = (o3.type === "object" || o3.type === "array") && (typeof o3.fields == "object" || typeof o3.defaultField == "object");
      A3 = A3 && (o3.required || !o3.required && u3.value), o3.field = u3.field;
      function p3(q3, _3) {
        return R$r({}, _3, {
          fullField: o3.fullField + "." + q3,
          fullFields: o3.fullFields ? [].concat(o3.fullFields, [q3]) : [q3]
        });
      }
      function y3(q3) {
        q3 === void 0 && (q3 = []);
        var _3 = Array.isArray(q3) ? q3 : [q3];
        !d3.suppressWarning && _3.length && i.warning("async-validator:", _3), _3.length && o3.message !== void 0 && (_3 = [].concat(o3.message));
        var P3 = _3.map(H$q(o3, s3));
        if (d3.first && P3.length)
          return x3[o3.field] = 1, g3(P3);
        if (!A3)
          g3(P3);
        else {
          if (o3.required && !u3.value)
            return o3.message !== void 0 ? P3 = [].concat(o3.message).map(H$q(o3, s3)) : d3.error && (P3 = [d3.error(o3, F$v(d3.messages.required, o3.field))]), g3(P3);
          var V10 = {};
          o3.defaultField && Object.keys(u3.value).map(function(j3) {
            V10[j3] = o3.defaultField;
          }), V10 = R$r({}, V10, u3.rule.fields);
          var Y3 = {};
          Object.keys(V10).forEach(function(j3) {
            var E3 = V10[j3], ee2 = Array.isArray(E3) ? E3 : [E3];
            Y3[j3] = ee2.map(p3.bind(null, j3));
          });
          var z3 = new i(Y3);
          z3.messages(d3.messages), u3.rule.options && (u3.rule.options.messages = d3.messages, u3.rule.options.error = d3.error), z3.validate(u3.value, u3.rule.options || d3, function(j3) {
            var E3 = [];
            P3 && P3.length && E3.push.apply(E3, P3), j3 && j3.length && E3.push.apply(E3, j3), g3(E3.length ? E3 : null);
          });
        }
      }
      var b3;
      if (o3.asyncValidator)
        b3 = o3.asyncValidator(o3, u3.value, y3, u3.source, d3);
      else if (o3.validator) {
        try {
          b3 = o3.validator(o3, u3.value, y3, u3.source, d3);
        } catch (q3) {
          console.error == null || console.error(q3), d3.suppressValidatorError || setTimeout(function() {
            throw q3;
          }, 0), y3(q3.message);
        }
        b3 === true ? y3() : b3 === false ? y3(typeof o3.message == "function" ? o3.message(o3.fullField || o3.field) : o3.message || (o3.fullField || o3.field) + " fails") : b3 instanceof Array ? y3(b3) : b3 instanceof Error && y3(b3.message);
      }
      b3 && b3.then && b3.then(function() {
        return y3();
      }, function(q3) {
        return y3(q3);
      });
    }, function(u3) {
      h3(u3);
    }, s3);
  }, e28.getType = function(n3) {
    if (n3.type === void 0 && n3.pattern instanceof RegExp && (n3.type = "pattern"), typeof n3.validator != "function" && n3.type && !T$J.hasOwnProperty(n3.type))
      throw new Error(F$v("Unknown rule type %s", n3.type));
    return n3.type || "string";
  }, e28.getValidationMethod = function(n3) {
    if (typeof n3.validator == "function")
      return n3.validator;
    var t3 = Object.keys(n3), f3 = t3.indexOf("message");
    return f3 !== -1 && t3.splice(f3, 1), t3.length === 1 && t3[0] === "required" ? T$J.required : T$J[this.getType(n3)] || void 0;
  }, i;
}();
L$D.register = function(e28, r3) {
  if (typeof r3 != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  T$J[e28] = r3;
};
L$D.warning = C$_;
L$D.messages = I$B;
L$D.validators = T$J;
function W$o(n3) {
  const e28 = inject(t$1z, null);
  return {
    mergedSize: computed(() => n3.size !== void 0 ? n3.size : (e28 == null ? void 0 : e28.props.size) !== void 0 ? e28.props.size : "medium")
  };
}
function A$A(n3) {
  const e28 = inject(t$1z, null), l3 = computed(() => {
    const {
      labelPlacement: r3
    } = n3;
    return r3 !== void 0 ? r3 : e28 != null && e28.props.labelPlacement ? e28.props.labelPlacement : "top";
  }), o3 = computed(() => l3.value === "left" && (n3.labelWidth === "auto" || (e28 == null ? void 0 : e28.props.labelWidth) === "auto")), s3 = computed(() => {
    if (l3.value === "top")
      return;
    const {
      labelWidth: r3
    } = n3;
    if (r3 !== void 0 && r3 !== "auto")
      return o$1z(r3);
    if (o3.value) {
      const b3 = e28 == null ? void 0 : e28.maxChildLabelWidthRef.value;
      return b3 !== void 0 ? o$1z(b3) : void 0;
    }
    if ((e28 == null ? void 0 : e28.props.labelWidth) !== void 0)
      return o$1z(e28.props.labelWidth);
  }), m3 = computed(() => {
    const {
      labelAlign: r3
    } = n3;
    if (r3)
      return r3;
    if (e28 != null && e28.props.labelAlign)
      return e28.props.labelAlign;
  }), i = computed(() => {
    var r3;
    return [(r3 = n3.labelProps) === null || r3 === void 0 ? void 0 : r3.style, n3.labelStyle, {
      width: s3.value
    }];
  }), u3 = computed(() => {
    const {
      showRequireMark: r3
    } = n3;
    return r3 !== void 0 ? r3 : e28 == null ? void 0 : e28.props.showRequireMark;
  }), f3 = computed(() => {
    const {
      requireMarkPlacement: r3
    } = n3;
    return r3 !== void 0 ? r3 : (e28 == null ? void 0 : e28.props.requireMarkPlacement) || "right";
  }), a3 = ref$1(false), d3 = ref$1(false), g3 = computed(() => {
    const {
      validationStatus: r3
    } = n3;
    if (r3 !== void 0)
      return r3;
    if (a3.value)
      return "error";
    if (d3.value)
      return "warning";
  }), p3 = computed(() => {
    const {
      showFeedback: r3
    } = n3;
    return r3 !== void 0 ? r3 : (e28 == null ? void 0 : e28.props.showFeedback) !== void 0 ? e28.props.showFeedback : true;
  }), w3 = computed(() => {
    const {
      showLabel: r3
    } = n3;
    return r3 !== void 0 ? r3 : (e28 == null ? void 0 : e28.props.showLabel) !== void 0 ? e28.props.showLabel : true;
  });
  return {
    validationErrored: a3,
    validationWarned: d3,
    mergedLabelStyle: i,
    mergedLabelPlacement: l3,
    mergedLabelAlign: m3,
    mergedShowRequireMark: u3,
    mergedRequireMarkPlacement: f3,
    mergedValidationStatus: g3,
    mergedShowFeedback: p3,
    mergedShowLabel: w3,
    isAutoLabelWidth: o3
  };
}
function y$$(n3) {
  const e28 = inject(t$1z, null), l3 = computed(() => {
    const {
      rulePath: i
    } = n3;
    if (i !== void 0)
      return i;
    const {
      path: u3
    } = n3;
    if (u3 !== void 0)
      return u3;
  }), o3 = computed(() => {
    const i = [], {
      rule: u3
    } = n3;
    if (u3 !== void 0 && (Array.isArray(u3) ? i.push(...u3) : i.push(u3)), e28) {
      const {
        rules: f3
      } = e28.props, {
        value: a3
      } = l3;
      if (f3 !== void 0 && a3 !== void 0) {
        const d3 = f$1p(f3, a3);
        d3 !== void 0 && (Array.isArray(d3) ? i.push(...d3) : i.push(d3));
      }
    }
    return i;
  }), s3 = computed(() => o3.value.some((i) => i.required)), m3 = computed(() => s3.value || n3.required);
  return {
    mergedRules: o3,
    mergedRequired: m3
  };
}
const {
  cubicBezierEaseInOut: s$1N
} = e$2d;
function e$1u({
  name: t3 = "fade-down",
  fromOffset: $3 = "-4px",
  enterDuration: r3 = ".3s",
  leaveDuration: n3 = ".3s",
  enterCubicBezier: i = s$1N,
  leaveCubicBezier: a3 = s$1N
} = {}) {
  return [r$2a(`&.${t3}-transition-enter-from, &.${t3}-transition-leave-to`, {
    opacity: 0,
    transform: `translateY(${$3})`
  }), r$2a(`&.${t3}-transition-enter-to, &.${t3}-transition-leave-from`, {
    opacity: 1,
    transform: "translateY(0)"
  }), r$2a(`&.${t3}-transition-leave-active`, {
    transition: `opacity ${n3} ${a3}, transform ${n3} ${a3}`
  }), r$2a(`&.${t3}-transition-enter-active`, {
    transition: `opacity ${r3} ${i}, transform ${r3} ${i}`
  })];
}
const o$1j = l$25("form-item", `
 display: grid;
 line-height: var(--n-line-height);
`, [l$25("form-item-label", `
 grid-area: label;
 align-items: center;
 line-height: 1.25;
 text-align: var(--n-label-text-align);
 font-size: var(--n-label-font-size);
 min-height: var(--n-label-height);
 padding: var(--n-label-padding);
 color: var(--n-label-text-color);
 transition: color .3s var(--n-bezier);
 box-sizing: border-box;
 font-weight: var(--n-label-font-weight);
 `, [M$y("asterisk", `
 white-space: nowrap;
 user-select: none;
 -webkit-user-select: none;
 color: var(--n-asterisk-color);
 transition: color .3s var(--n-bezier);
 `), M$y("asterisk-placeholder", `
 grid-area: mark;
 user-select: none;
 -webkit-user-select: none;
 visibility: hidden; 
 `)]), l$25("form-item-blank", `
 grid-area: blank;
 min-height: var(--n-blank-height);
 `), g$1j("auto-label-width", [l$25("form-item-label", "white-space: nowrap;")]), g$1j("left-labelled", `
 grid-template-areas:
 "label blank"
 "label feedback";
 grid-template-columns: auto minmax(0, 1fr);
 grid-template-rows: auto 1fr;
 align-items: flex-start;
 `, [l$25("form-item-label", `
 display: grid;
 grid-template-columns: 1fr auto;
 min-height: var(--n-blank-height);
 height: auto;
 box-sizing: border-box;
 flex-shrink: 0;
 flex-grow: 0;
 `, [g$1j("reverse-columns-space", `
 grid-template-columns: auto 1fr;
 `), g$1j("left-mark", `
 grid-template-areas:
 "mark text"
 ". text";
 `), g$1j("right-mark", `
 grid-template-areas: 
 "text mark"
 "text .";
 `), g$1j("right-hanging-mark", `
 grid-template-areas: 
 "text mark"
 "text .";
 `), M$y("text", `
 grid-area: text; 
 `), M$y("asterisk", `
 grid-area: mark; 
 align-self: end;
 `)])]), g$1j("top-labelled", `
 grid-template-areas:
 "label"
 "blank"
 "feedback";
 grid-template-rows: minmax(var(--n-label-height), auto) 1fr;
 grid-template-columns: minmax(0, 100%);
 `, [g$1j("no-label", `
 grid-template-areas:
 "blank"
 "feedback";
 grid-template-rows: 1fr;
 `), l$25("form-item-label", `
 display: flex;
 align-items: flex-start;
 justify-content: var(--n-label-text-align);
 `)]), l$25("form-item-blank", `
 box-sizing: border-box;
 display: flex;
 align-items: center;
 position: relative;
 `), l$25("form-item-feedback-wrapper", `
 grid-area: feedback;
 box-sizing: border-box;
 min-height: var(--n-feedback-height);
 font-size: var(--n-feedback-font-size);
 line-height: 1.25;
 transform-origin: top left;
 `, [r$2a("&:not(:empty)", `
 padding: var(--n-feedback-padding);
 `), l$25("form-item-feedback", {
  transition: "color .3s var(--n-bezier)",
  color: "var(--n-feedback-text-color)"
}, [g$1j("warning", {
  color: "var(--n-feedback-text-color-warning)"
}), g$1j("error", {
  color: "var(--n-feedback-text-color-error)"
}), e$1u({
  fromOffset: "-3px",
  enterDuration: ".3s",
  leaveDuration: ".2s"
})])])]);
function j$r(r3, o3, u3) {
  var f3;
  const d3 = inject(r3, null);
  if (d3 === null)
    return;
  const a3 = (f3 = getCurrentInstance()) === null || f3 === void 0 ? void 0 : f3.proxy;
  watch(u3, e28), e28(u3.value), onBeforeUnmount(() => {
    e28(void 0, u3.value);
  });
  function e28(n3, i) {
    if (!d3)
      return;
    const t3 = d3[o3];
    i !== void 0 && s3(t3, i), n3 !== void 0 && c3(t3, n3);
  }
  function s3(n3, i) {
    n3[i] || (n3[i] = []), n3[i].splice(n3[i].findIndex((t3) => t3 === a3), 1);
  }
  function c3(n3, i) {
    n3[i] || (n3[i] = []), ~n3[i].findIndex((t3) => t3 === a3) || n3[i].push(a3);
  }
}
var Q$p = globalThis && globalThis.__awaiter || function(l3, e28, u3, t3) {
  function b3(o3) {
    return o3 instanceof u3 ? o3 : new u3(function(k3) {
      k3(o3);
    });
  }
  return new (u3 || (u3 = Promise))(function(o3, k3) {
    function C3(r3) {
      try {
        g3(t3.next(r3));
      } catch (s3) {
        k3(s3);
      }
    }
    function v3(r3) {
      try {
        g3(t3.throw(r3));
      } catch (s3) {
        k3(s3);
      }
    }
    function g3(r3) {
      r3.done ? o3(r3.value) : b3(r3.value).then(C3, v3);
    }
    g3((t3 = t3.apply(l3, e28 || [])).next());
  });
};
const Ce$b = Object.assign(Object.assign({}, _$F.props), {
  label: String,
  labelWidth: [Number, String],
  labelStyle: [String, Object],
  labelAlign: String,
  labelPlacement: String,
  path: String,
  first: Boolean,
  rulePath: String,
  required: Boolean,
  showRequireMark: {
    type: Boolean,
    default: void 0
  },
  requireMarkPlacement: String,
  showFeedback: {
    type: Boolean,
    default: void 0
  },
  rule: [Object, Array],
  size: String,
  ignorePathChange: Boolean,
  validationStatus: String,
  feedback: String,
  showLabel: {
    type: Boolean,
    default: void 0
  },
  labelProps: Object
});
function U$v(l3, e28) {
  return (...u3) => {
    try {
      const t3 = l3(...u3);
      return !e28 && (typeof t3 == "boolean" || t3 instanceof Error || Array.isArray(t3)) || t3 != null && t3.then ? t3 : (t3 === void 0 || s$2a("form-item/validate", `You return a ${typeof t3} typed value in the validator method, which is not recommended. Please use ` + (e28 ? "`Promise`" : "`boolean`, `Error` or `Promise`") + " typed value instead."), true);
    } catch (t3) {
      s$2a("form-item/validate", "An error is catched in the validation, so the validation won't be done. Your callback in `validate` method of `n-form` or `n-form-item` won't be called in this validation."), console.error(t3);
      return;
    }
  };
}
const Ke$7 = defineComponent({
  name: "FormItem",
  props: Ce$b,
  setup(l3) {
    j$r(e$1B, "formItems", toRef$1(l3, "path"));
    const {
      mergedClsPrefixRef: e28,
      inlineThemeDisabled: u3
    } = a$2x(l3), t3 = inject(t$1z, null), b3 = W$o(l3), o3 = A$A(l3), {
      validationErrored: k3,
      validationWarned: C3
    } = o3, {
      mergedRequired: v3,
      mergedRules: g3
    } = y$$(l3), {
      mergedSize: r3
    } = b3, {
      mergedLabelPlacement: s3,
      mergedLabelAlign: p3,
      mergedRequireMarkPlacement: B3
    } = o3, j3 = ref$1([]), N3 = ref$1(i$1Y()), Z3 = t3 ? toRef$1(t3.props, "disabled") : ref$1(false), ee2 = _$F("Form", "-form-item", o$1j, C$13, l3, e28);
    watch(toRef$1(l3, "path"), () => {
      l3.ignorePathChange || T3();
    });
    function T3() {
      j3.value = [], k3.value = false, C3.value = false, l3.feedback && (N3.value = i$1Y());
    }
    function te2() {
      P3("blur");
    }
    function ae2() {
      P3("change");
    }
    function ne2() {
      P3("focus");
    }
    function ie2() {
      P3("input");
    }
    function le2(a3, h3) {
      return Q$p(this, void 0, void 0, function* () {
        let c3, f3, _3, $3;
        return typeof a3 == "string" ? (c3 = a3, f3 = h3) : a3 !== null && typeof a3 == "object" && (c3 = a3.trigger, f3 = a3.callback, _3 = a3.shouldRuleBeApplied, $3 = a3.options), yield new Promise((M3, z3) => {
          P3(c3, _3, $3).then(({
            valid: A3,
            errors: w3,
            warnings: y3
          }) => {
            A3 ? (f3 && f3(void 0, {
              warnings: y3
            }), M3({
              warnings: y3
            })) : (f3 && f3(w3, {
              warnings: y3
            }), z3(w3));
          });
        });
      });
    }
    const P3 = (a3 = null, h3 = () => true, c3 = {
      suppressWarning: true
    }) => Q$p(this, void 0, void 0, function* () {
      const {
        path: f3
      } = l3;
      c3 ? c3.first || (c3.first = l3.first) : c3 = {};
      const {
        value: _3
      } = g3, $3 = t3 ? f$1p(t3.props.model, f3 || "") : void 0, M3 = {}, z3 = {}, A3 = (a3 ? _3.filter((n3) => Array.isArray(n3.trigger) ? n3.trigger.includes(a3) : n3.trigger === a3) : _3).filter(h3).map((n3, d3) => {
        const i = Object.assign({}, n3);
        if (i.validator && (i.validator = U$v(i.validator, false)), i.asyncValidator && (i.asyncValidator = U$v(i.asyncValidator, true)), i.renderMessage) {
          const x3 = `__renderMessage__${d3}`;
          z3[x3] = i.message, i.message = x3, M3[x3] = i.renderMessage;
        }
        return i;
      }), w3 = A3.filter((n3) => n3.level !== "warning"), y3 = A3.filter((n3) => n3.level === "warning"), V10 = f3 != null ? f3 : "__n_no_path__", W3 = new L$D({
        [V10]: w3
      }), O3 = new L$D({
        [V10]: y3
      }), {
        validateMessages: E3
      } = (t3 == null ? void 0 : t3.props) || {};
      E3 && (W3.messages(E3), O3.messages(E3));
      const q3 = (n3) => {
        j3.value = n3.map((d3) => {
          const i = (d3 == null ? void 0 : d3.message) || "";
          return {
            key: i,
            render: () => i.startsWith("__renderMessage__") ? M3[i]() : i
          };
        }), n3.forEach((d3) => {
          var i;
          !((i = d3.message) === null || i === void 0) && i.startsWith("__renderMessage__") && (d3.message = z3[d3.message]);
        });
      }, R3 = {
        valid: true,
        errors: void 0,
        warnings: void 0
      };
      if (w3.length) {
        const n3 = yield new Promise((d3) => {
          W3.validate({
            [V10]: $3
          }, c3, d3);
        });
        n3 != null && n3.length && (k3.value = true, R3.valid = false, R3.errors = n3, q3(n3));
      }
      if (y3.length && !R3.errors) {
        const n3 = yield new Promise((d3) => {
          O3.validate({
            [V10]: $3
          }, c3, d3);
        });
        n3 != null && n3.length && (q3(n3), C3.value = true, R3.warnings = n3);
      }
      return w3.length + y3.length > 0 && !R3.errors && !R3.warnings && T3(), R3;
    });
    provide(f$1D, {
      path: toRef$1(l3, "path"),
      disabled: Z3,
      mergedSize: b3.mergedSize,
      mergedValidationStatus: o3.mergedValidationStatus,
      restoreValidation: T3,
      handleContentBlur: te2,
      handleContentChange: ae2,
      handleContentFocus: ne2,
      handleContentInput: ie2
    });
    const re2 = {
      validate: le2,
      restoreValidation: T3,
      internalValidate: P3
    }, K3 = ref$1(null);
    onMounted(() => {
      if (!o3.isAutoLabelWidth.value)
        return;
      const a3 = K3.value;
      if (a3 !== null) {
        const h3 = a3.style.whiteSpace;
        a3.style.whiteSpace = "nowrap", a3.style.width = "", t3 == null || t3.deriveMaxChildLabelWidth(Number(getComputedStyle(a3).width.slice(0, -2))), a3.style.whiteSpace = h3;
      }
    });
    const D3 = computed(() => {
      var a3;
      const {
        value: h3
      } = r3, {
        value: c3
      } = s3, f3 = c3 === "top" ? "vertical" : "horizontal", {
        common: {
          cubicBezierEaseInOut: _3
        },
        self: {
          labelTextColor: $3,
          asteriskColor: M3,
          lineHeight: z3,
          feedbackTextColor: A3,
          feedbackTextColorWarning: w3,
          feedbackTextColorError: y3,
          feedbackPadding: V10,
          labelFontWeight: W3,
          [_$H("labelHeight", h3)]: O3,
          [_$H("blankHeight", h3)]: E3,
          [_$H("feedbackFontSize", h3)]: q3,
          [_$H("feedbackHeight", h3)]: R3,
          [_$H("labelPadding", f3)]: n3,
          [_$H("labelTextAlign", f3)]: d3,
          [_$H(_$H("labelFontSize", c3), h3)]: i
        }
      } = ee2.value;
      let x3 = (a3 = p3.value) !== null && a3 !== void 0 ? a3 : d3;
      return c3 === "top" && (x3 = x3 === "right" ? "flex-end" : "flex-start"), {
        "--n-bezier": _3,
        "--n-line-height": z3,
        "--n-blank-height": E3,
        "--n-label-font-size": i,
        "--n-label-text-align": x3,
        "--n-label-height": O3,
        "--n-label-padding": n3,
        "--n-label-font-weight": W3,
        "--n-asterisk-color": M3,
        "--n-label-text-color": $3,
        "--n-feedback-padding": V10,
        "--n-feedback-font-size": q3,
        "--n-feedback-height": R3,
        "--n-feedback-text-color": A3,
        "--n-feedback-text-color-warning": w3,
        "--n-feedback-text-color-error": y3
      };
    }), I3 = u3 ? E$J("form-item", computed(() => {
      var a3;
      return `${r3.value[0]}${s3.value[0]}${((a3 = p3.value) === null || a3 === void 0 ? void 0 : a3[0]) || ""}`;
    }), D3, l3) : void 0, oe2 = computed(() => s3.value === "left" && B3.value === "left" && p3.value === "left");
    return Object.assign(Object.assign(Object.assign(Object.assign({
      labelElementRef: K3,
      mergedClsPrefix: e28,
      mergedRequired: v3,
      feedbackId: N3,
      renderExplains: j3,
      reverseColSpace: oe2
    }, o3), b3), re2), {
      cssVars: u3 ? void 0 : D3,
      themeClass: I3 == null ? void 0 : I3.themeClass,
      onRender: I3 == null ? void 0 : I3.onRender
    });
  },
  render() {
    const {
      $slots: l3,
      mergedClsPrefix: e28,
      mergedShowLabel: u3,
      mergedShowRequireMark: t3,
      mergedRequireMarkPlacement: b3,
      onRender: o3
    } = this, k3 = t3 !== void 0 ? t3 : this.mergedRequired;
    o3 == null || o3();
    const C3 = () => {
      const v3 = this.$slots.label ? this.$slots.label() : this.label;
      if (!v3)
        return null;
      const g3 = h$1R("span", {
        class: `${e28}-form-item-label__text`
      }, v3), r3 = k3 ? h$1R("span", {
        class: `${e28}-form-item-label__asterisk`
      }, b3 !== "left" ? "\xA0*" : "*\xA0") : b3 === "right-hanging" && h$1R("span", {
        class: `${e28}-form-item-label__asterisk-placeholder`
      }, "\xA0*"), {
        labelProps: s3
      } = this;
      return h$1R("label", Object.assign({}, s3, {
        class: [s3 == null ? void 0 : s3.class, `${e28}-form-item-label`, `${e28}-form-item-label--${b3}-mark`, this.reverseColSpace && `${e28}-form-item-label--reverse-columns-space`],
        style: this.mergedLabelStyle,
        ref: "labelElementRef"
      }), b3 === "left" ? [r3, g3] : [g3, r3]);
    };
    return h$1R("div", {
      class: [`${e28}-form-item`, this.themeClass, `${e28}-form-item--${this.mergedSize}-size`, `${e28}-form-item--${this.mergedLabelPlacement}-labelled`, this.isAutoLabelWidth && `${e28}-form-item--auto-label-width`, !u3 && `${e28}-form-item--no-label`],
      style: this.cssVars
    }, u3 && C3(), h$1R("div", {
      class: [`${e28}-form-item-blank`, this.mergedValidationStatus && `${e28}-form-item-blank--${this.mergedValidationStatus}`]
    }, l3), this.mergedShowFeedback ? h$1R("div", {
      key: this.feedbackId,
      class: `${e28}-form-item-feedback-wrapper`
    }, h$1R(Transition, {
      name: "fade-down-transition",
      mode: "out-in"
    }, {
      default: () => {
        const {
          mergedValidationStatus: v3
        } = this;
        return m$26(l3.feedback, (g3) => {
          var r3;
          const {
            feedback: s3
          } = this, p3 = g3 || s3 ? h$1R("div", {
            key: "__feedback__",
            class: `${e28}-form-item-feedback__line`
          }, g3 || s3) : this.renderExplains.length ? (r3 = this.renderExplains) === null || r3 === void 0 ? void 0 : r3.map(({
            key: B3,
            render: j3
          }) => h$1R("div", {
            key: B3,
            class: `${e28}-form-item-feedback__line`
          }, j3())) : null;
          return p3 ? v3 === "warning" ? h$1R("div", {
            key: "controlled-warning",
            class: `${e28}-form-item-feedback ${e28}-form-item-feedback--warning`
          }, p3) : v3 === "error" ? h$1R("div", {
            key: "controlled-error",
            class: `${e28}-form-item-feedback ${e28}-form-item-feedback--error`
          }, p3) : v3 === "success" ? h$1R("div", {
            key: "controlled-success",
            class: `${e28}-form-item-feedback ${e28}-form-item-feedback--success`
          }, p3) : h$1R("div", {
            key: "controlled-default",
            class: `${e28}-form-item-feedback`
          }, p3) : null;
        });
      }
    })) : null);
  }
});
const B$I = { class: "n-form-custom-label" }, F$u = {
  key: 0,
  class: "asterisk"
}, I$A = { key: 0 }, q$w = defineComponent({
  name: "UIFormItem",
  inheritAttrs: false
}), x$z = defineComponent(__spreadProps(__spreadValues({}, q$w), {
  props: {
    label: {
      type: String
    },
    path: {
      type: String
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    showFeedback: {
      type: Boolean,
      default: true
    },
    rule: {
      type: Object,
      default: void 0
    },
    tooltip: {
      type: Object,
      default: null
    },
    required: Boolean
  },
  setup(e28) {
    return (a3, S3) => (openBlock(), createBlock(unref(Ke$7), mergeProps(a3.$attrs, {
      rule: e28.rule,
      label: e28.label,
      path: e28.path,
      "show-label": e28.showLabel,
      "show-feedback": e28.showFeedback,
      class: { "n-form-has-custom-label": e28.tooltip },
      required: e28.required
    }), createSlots({
      default: withCtx(() => [
        renderSlot(a3.$slots, "default")
      ]),
      _: 2
    }, [
      e28.tooltip ? {
        name: "label",
        fn: withCtx(() => {
          var n3, i, r3, c3;
          return [
            createElementVNode("div", B$I, [
              createElementVNode("span", null, [
                createElementVNode("span", null, toDisplayString(e28.label), 1),
                e28.required ? (openBlock(), createElementBlock("span", F$u, "\xA0*")) : createCommentVNode("", true)
              ]),
              createVNode(S$I, {
                placement: (n3 = e28.tooltip) == null ? void 0 : n3.placement,
                trigger: (i = e28.tooltip) == null ? void 0 : i.trigger,
                icon: (r3 = e28.tooltip) == null ? void 0 : r3.icon,
                iconClass: (c3 = e28.tooltip) == null ? void 0 : c3.iconClass
              }, {
                default: withCtx(() => [
                  typeof e28.tooltip.text == "string" ? (openBlock(), createElementBlock("span", I$A, toDisplayString(e28.tooltip.text), 1)) : (openBlock(), createBlock(resolveDynamicComponent(e28.tooltip.text), { key: 1 }))
                ]),
                _: 1
              }, 8, ["placement", "trigger", "icon", "iconClass"])
            ])
          ];
        }),
        key: "0"
      } : void 0
    ]), 1040, ["rule", "label", "path", "show-label", "show-feedback", "class", "required"]));
  }
})), V$u = x$z;
const e$1t = n$28("n-input");
function C$Z(e28) {
  let r3 = 0;
  for (const i of e28)
    r3++;
  return r3;
}
function T$I(e28) {
  return e28 === "" || e28 == null;
}
function b$$(e28) {
  const r3 = ref$1(null);
  function i() {
    const {
      value: t3
    } = e28;
    if (!(t3 != null && t3.focus)) {
      u3();
      return;
    }
    const {
      selectionStart: l3,
      selectionEnd: n3,
      value: o3
    } = t3;
    if (l3 == null || n3 == null) {
      u3();
      return;
    }
    r3.value = {
      start: l3,
      end: n3,
      beforeText: o3.slice(0, l3),
      afterText: o3.slice(n3)
    };
  }
  function d3() {
    var t3;
    const {
      value: l3
    } = r3, {
      value: n3
    } = e28;
    if (!l3 || !n3)
      return;
    const {
      value: o3
    } = n3, {
      start: f3,
      beforeText: c3,
      afterText: a3
    } = l3;
    let s3 = o3.length;
    if (o3.endsWith(a3))
      s3 = o3.length - a3.length;
    else if (o3.startsWith(c3))
      s3 = c3.length;
    else {
      const h3 = c3[f3 - 1], v3 = o3.indexOf(h3, f3 - 1);
      v3 !== -1 && (s3 = v3 + 1);
    }
    (t3 = n3.setSelectionRange) === null || t3 === void 0 || t3.call(n3, s3, s3);
  }
  function u3() {
    r3.value = null;
  }
  return watch(e28, u3), {
    recordCursor: i,
    restoreCursor: d3
  };
}
const R$q = defineComponent({
  name: "InputWordCount",
  setup(v3, {
    slots: o3
  }) {
    const {
      mergedValueRef: t3,
      maxlengthRef: u3,
      mergedClsPrefixRef: a3,
      countGraphemesRef: l3
    } = inject(e$1t), n3 = computed(() => {
      const {
        value: e28
      } = t3;
      return e28 === null || Array.isArray(e28) ? 0 : (l3.value || C$Z)(e28);
    });
    return () => {
      const {
        value: e28
      } = u3, {
        value: r3
      } = t3;
      return h$1R("span", {
        class: `${a3.value}-input-word-count`
      }, c$21(o3.default, {
        value: r3 === null || Array.isArray(r3) ? "" : r3
      }, () => [e28 === void 0 ? n3.value : `${n3.value} / ${e28}`]));
    };
  }
});
const l$1B = l$25("input", `
 max-width: 100%;
 cursor: text;
 line-height: 1.5;
 z-index: auto;
 outline: none;
 box-sizing: border-box;
 position: relative;
 display: inline-flex;
 border-radius: var(--n-border-radius);
 background-color: var(--n-color);
 transition: background-color .3s var(--n-bezier);
 font-size: var(--n-font-size);
 --n-padding-vertical: calc((var(--n-height) - 1.5 * var(--n-font-size)) / 2);
`, [
  M$y("input, textarea", `
 overflow: hidden;
 flex-grow: 1;
 position: relative;
 `),
  M$y("input-el, textarea-el, input-mirror, textarea-mirror, separator, placeholder", `
 box-sizing: border-box;
 font-size: inherit;
 line-height: 1.5;
 font-family: inherit;
 border: none;
 outline: none;
 background-color: #0000;
 text-align: inherit;
 transition:
 -webkit-text-fill-color .3s var(--n-bezier),
 caret-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 text-decoration-color .3s var(--n-bezier);
 `),
  M$y("input-el, textarea-el", `
 -webkit-appearance: none;
 scrollbar-width: none;
 width: 100%;
 min-width: 0;
 text-decoration-color: var(--n-text-decoration-color);
 color: var(--n-text-color);
 caret-color: var(--n-caret-color);
 background-color: transparent;
 `, [r$2a("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", `
 width: 0;
 height: 0;
 display: none;
 `), r$2a("&::placeholder", `
 color: #0000;
 -webkit-text-fill-color: transparent !important;
 `), r$2a("&:-webkit-autofill ~", [M$y("placeholder", "display: none;")])]),
  g$1j("round", [x$I("textarea", "border-radius: calc(var(--n-height) / 2);")]),
  M$y("placeholder", `
 pointer-events: none;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 overflow: hidden;
 color: var(--n-placeholder-color);
 `, [r$2a("span", `
 width: 100%;
 display: inline-block;
 `)]),
  g$1j("textarea", [M$y("placeholder", "overflow: visible;")]),
  x$I("autosize", "width: 100%;"),
  g$1j("autosize", [M$y("textarea-el, input-el", `
 position: absolute;
 top: 0;
 left: 0;
 height: 100%;
 `)]),
  l$25("input-wrapper", `
 overflow: hidden;
 display: inline-flex;
 flex-grow: 1;
 position: relative;
 padding-left: var(--n-padding-left);
 padding-right: var(--n-padding-right);
 `),
  M$y("input-mirror", `
 padding: 0;
 height: var(--n-height);
 line-height: var(--n-height);
 overflow: hidden;
 visibility: hidden;
 position: static;
 white-space: pre;
 pointer-events: none;
 `),
  M$y("input-el", `
 padding: 0;
 height: var(--n-height);
 line-height: var(--n-height);
 `, [r$2a("&[type=password]::-ms-reveal", "display: none;"), r$2a("+", [M$y("placeholder", `
 display: flex;
 align-items: center; 
 `)])]),
  x$I("textarea", [M$y("placeholder", "white-space: nowrap;")]),
  M$y("eye", `
 display: flex;
 align-items: center;
 justify-content: center;
 transition: color .3s var(--n-bezier);
 `),
  g$1j("textarea", "width: 100%;", [l$25("input-word-count", `
 position: absolute;
 right: var(--n-padding-right);
 bottom: var(--n-padding-vertical);
 `), g$1j("resizable", [l$25("input-wrapper", `
 resize: vertical;
 min-height: var(--n-height);
 `)]), M$y("textarea-el, textarea-mirror, placeholder", `
 height: 100%;
 padding-left: 0;
 padding-right: 0;
 padding-top: var(--n-padding-vertical);
 padding-bottom: var(--n-padding-vertical);
 word-break: break-word;
 display: inline-block;
 vertical-align: bottom;
 box-sizing: border-box;
 line-height: var(--n-line-height-textarea);
 margin: 0;
 resize: none;
 white-space: pre-wrap;
 scroll-padding-block-end: var(--n-padding-vertical);
 `), M$y("textarea-mirror", `
 width: 100%;
 pointer-events: none;
 overflow: hidden;
 visibility: hidden;
 position: static;
 white-space: pre-wrap;
 overflow-wrap: break-word;
 `)]),
  g$1j("pair", [M$y("input-el, placeholder", "text-align: center;"), M$y("separator", `
 display: flex;
 align-items: center;
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 white-space: nowrap;
 `, [l$25("icon", `
 color: var(--n-icon-color);
 `), l$25("base-icon", `
 color: var(--n-icon-color);
 `)])]),
  g$1j("disabled", `
 cursor: not-allowed;
 background-color: var(--n-color-disabled);
 `, [M$y("border", "border: var(--n-border-disabled);"), M$y("input-el, textarea-el", `
 cursor: not-allowed;
 color: var(--n-text-color-disabled);
 text-decoration-color: var(--n-text-color-disabled);
 `), M$y("placeholder", "color: var(--n-placeholder-color-disabled);"), M$y("separator", "color: var(--n-text-color-disabled);", [l$25("icon", `
 color: var(--n-icon-color-disabled);
 `), l$25("base-icon", `
 color: var(--n-icon-color-disabled);
 `)]), l$25("input-word-count", `
 color: var(--n-count-text-color-disabled);
 `), M$y("suffix, prefix", "color: var(--n-text-color-disabled);", [l$25("icon", `
 color: var(--n-icon-color-disabled);
 `), l$25("internal-icon", `
 color: var(--n-icon-color-disabled);
 `)])]),
  x$I("disabled", [M$y("eye", `
 color: var(--n-icon-color);
 cursor: pointer;
 `, [r$2a("&:hover", `
 color: var(--n-icon-color-hover);
 `), r$2a("&:active", `
 color: var(--n-icon-color-pressed);
 `)]), r$2a("&:hover", [M$y("state-border", "border: var(--n-border-hover);")]), g$1j("focus", "background-color: var(--n-color-focus);", [M$y("state-border", `
 border: var(--n-border-focus);
 box-shadow: var(--n-box-shadow-focus);
 `)])]),
  M$y("border, state-border", `
 box-sizing: border-box;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 pointer-events: none;
 border-radius: inherit;
 border: var(--n-border);
 transition:
 box-shadow .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `),
  M$y("state-border", `
 border-color: #0000;
 z-index: 1;
 `),
  M$y("prefix", "margin-right: 4px;"),
  M$y("suffix", `
 margin-left: 4px;
 `),
  M$y("suffix, prefix", `
 transition: color .3s var(--n-bezier);
 flex-wrap: nowrap;
 flex-shrink: 0;
 line-height: var(--n-height);
 white-space: nowrap;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 color: var(--n-suffix-text-color);
 `, [l$25("base-loading", `
 font-size: var(--n-icon-size);
 margin: 0 2px;
 color: var(--n-loading-color);
 `), l$25("base-clear", `
 font-size: var(--n-icon-size);
 `, [M$y("placeholder", [l$25("base-icon", `
 transition: color .3s var(--n-bezier);
 color: var(--n-icon-color);
 font-size: var(--n-icon-size);
 `)])]), r$2a(">", [l$25("icon", `
 transition: color .3s var(--n-bezier);
 color: var(--n-icon-color);
 font-size: var(--n-icon-size);
 `)]), l$25("base-icon", `
 font-size: var(--n-icon-size);
 `)]),
  l$25("input-word-count", `
 pointer-events: none;
 line-height: 1.5;
 font-size: .85em;
 color: var(--n-count-text-color);
 transition: color .3s var(--n-bezier);
 margin-left: 4px;
 font-variant: tabular-nums;
 `),
  ["warning", "error"].map((i) => g$1j(`${i}-status`, [x$I("disabled", [l$25("base-loading", `
 color: var(--n-loading-color-${i})
 `), M$y("input-el, textarea-el", `
 caret-color: var(--n-caret-color-${i});
 `), M$y("state-border", `
 border: var(--n-border-${i});
 `), r$2a("&:hover", [M$y("state-border", `
 border: var(--n-border-hover-${i});
 `)]), r$2a("&:focus", `
 background-color: var(--n-color-focus-${i});
 `, [M$y("state-border", `
 box-shadow: var(--n-box-shadow-focus-${i});
 border: var(--n-border-focus-${i});
 `)]), g$1j("focus", `
 background-color: var(--n-color-focus-${i});
 `, [M$y("state-border", `
 box-shadow: var(--n-box-shadow-focus-${i});
 border: var(--n-border-focus-${i});
 `)])])]))
]), c$1J = l$25("input", [g$1j("disabled", [M$y("input-el, textarea-el", `
 -webkit-text-fill-color: var(--n-text-color-disabled);
 `)])]);
const t$1k = {
  name: "en-US",
  global: {
    undo: "Undo",
    redo: "Redo",
    confirm: "Confirm",
    clear: "Clear"
  },
  Popconfirm: {
    positiveText: "Confirm",
    negativeText: "Cancel"
  },
  Cascader: {
    placeholder: "Please Select",
    loading: "Loading",
    loadingRequiredMessage: (e28) => `Please load all ${e28}'s descendants before checking it.`
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    weekFormat: "yyyy-w",
    clear: "Clear",
    now: "Now",
    confirm: "Confirm",
    selectTime: "Select Time",
    selectDate: "Select Date",
    datePlaceholder: "Select Date",
    datetimePlaceholder: "Select Date and Time",
    monthPlaceholder: "Select Month",
    yearPlaceholder: "Select Year",
    quarterPlaceholder: "Select Quarter",
    weekPlaceholder: "Select Week",
    startDatePlaceholder: "Start Date",
    endDatePlaceholder: "End Date",
    startDatetimePlaceholder: "Start Date and Time",
    endDatetimePlaceholder: "End Date and Time",
    startMonthPlaceholder: "Start Month",
    endMonthPlaceholder: "End Month",
    monthBeforeYear: true,
    firstDayOfWeek: 6,
    today: "Today"
  },
  DataTable: {
    checkTableAll: "Select all in the table",
    uncheckTableAll: "Unselect all in the table",
    confirm: "Confirm",
    clear: "Clear"
  },
  LegacyTransfer: {
    sourceTitle: "Source",
    targetTitle: "Target"
  },
  Transfer: {
    selectAll: "Select all",
    unselectAll: "Unselect all",
    clearAll: "Clear",
    total: (e28) => `Total ${e28} items`,
    selected: (e28) => `${e28} items selected`
  },
  Empty: {
    description: "No Data"
  },
  Select: {
    placeholder: "Please Select"
  },
  TimePicker: {
    placeholder: "Select Time",
    positiveText: "OK",
    negativeText: "Cancel",
    now: "Now",
    clear: "Clear"
  },
  Pagination: {
    goto: "Goto",
    selectionSuffix: "page"
  },
  DynamicTags: {
    add: "Add"
  },
  Log: {
    loading: "Loading"
  },
  Input: {
    placeholder: "Please Input"
  },
  InputNumber: {
    placeholder: "Please Input"
  },
  DynamicInput: {
    create: "Create"
  },
  ThemeEditor: {
    title: "Theme Editor",
    clearAllVars: "Clear All Variables",
    clearSearch: "Clear Search",
    filterCompName: "Filter Component Name",
    filterVarName: "Filter Variable Name",
    import: "Import",
    export: "Export",
    restore: "Reset to Default"
  },
  Image: {
    tipPrevious: "Previous picture (\u2190)",
    tipNext: "Next picture (\u2192)",
    tipCounterclockwise: "Counterclockwise",
    tipClockwise: "Clockwise",
    tipZoomOut: "Zoom out",
    tipZoomIn: "Zoom in",
    tipDownload: "Download",
    tipClose: "Close (Esc)",
    tipOriginalSize: "Zoom to original size"
  }
}, a$1U = t$1k;
var r$1B = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, s$1M = function(a3, n3, o3) {
  var e28, t3 = r$1B[a3];
  return typeof t3 == "string" ? e28 = t3 : n3 === 1 ? e28 = t3.one : e28 = t3.other.replace("{{count}}", n3.toString()), o3 != null && o3.addSuffix ? o3.comparison && o3.comparison > 0 ? "in " + e28 : e28 + " ago" : e28;
};
const h$1v = s$1M;
function u$1s(t3) {
  return function() {
    var n3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r3 = n3.width ? String(n3.width) : t3.defaultWidth, e28 = t3.formats[r3] || t3.formats[t3.defaultWidth];
    return e28;
  };
}
var m$1N = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, a$1T = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, d$1x = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, e$1s = {
  date: u$1s({
    formats: m$1N,
    defaultWidth: "full"
  }),
  time: u$1s({
    formats: a$1T,
    defaultWidth: "full"
  }),
  dateTime: u$1s({
    formats: d$1x,
    defaultWidth: "full"
  })
};
const l$1A = e$1s;
var t$1j = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, a$1S = function(e28, r3, l3, s3) {
  return t$1j[e28];
};
const p$3r = a$1S;
function f$1h(l3) {
  return function(e28, t3) {
    var d3 = t3 != null && t3.context ? String(t3.context) : "standalone", a3;
    if (d3 === "formatting" && l3.formattingValues) {
      var u3 = l3.defaultFormattingWidth || l3.defaultWidth, n3 = t3 != null && t3.width ? String(t3.width) : u3;
      a3 = l3.formattingValues[n3] || l3.formattingValues[u3];
    } else {
      var r3 = l3.defaultWidth, v3 = t3 != null && t3.width ? String(t3.width) : l3.defaultWidth;
      a3 = l3.values[v3] || l3.values[r3];
    }
    var i = l3.argumentCallback ? l3.argumentCallback(e28) : e28;
    return a3[i];
  };
}
var t$1i = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, o$1i = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, d$1w = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, m$1M = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, u$1r = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, g$17 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, h$1u = function(a3, v3) {
  var n3 = Number(a3), r3 = n3 % 100;
  if (r3 > 20 || r3 < 10)
    switch (r3 % 10) {
      case 1:
        return n3 + "st";
      case 2:
        return n3 + "nd";
      case 3:
        return n3 + "rd";
    }
  return n3 + "th";
}, l$1z = {
  ordinalNumber: h$1u,
  era: f$1h({
    values: t$1i,
    defaultWidth: "wide"
  }),
  quarter: f$1h({
    values: o$1i,
    defaultWidth: "wide",
    argumentCallback: function(a3) {
      return a3 - 1;
    }
  }),
  month: f$1h({
    values: d$1w,
    defaultWidth: "wide"
  }),
  day: f$1h({
    values: m$1M,
    defaultWidth: "wide"
  }),
  dayPeriod: f$1h({
    values: u$1r,
    defaultWidth: "wide",
    formattingValues: g$17,
    defaultFormattingWidth: "wide"
  })
};
const b$_ = l$1z;
function o$1h(t3) {
  return function(e28) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = n3.width, c3 = r3 && t3.matchPatterns[r3] || t3.matchPatterns[t3.defaultMatchWidth], f3 = e28.match(c3);
    if (!f3)
      return null;
    var u3 = f3[0], l3 = r3 && t3.parsePatterns[r3] || t3.parsePatterns[t3.defaultParseWidth], d3 = Array.isArray(l3) ? s$1L(l3, function(i) {
      return i.test(u3);
    }) : h$1t(l3, function(i) {
      return i.test(u3);
    }), a3;
    a3 = t3.valueCallback ? t3.valueCallback(d3) : d3, a3 = n3.valueCallback ? n3.valueCallback(a3) : a3;
    var v3 = e28.slice(u3.length);
    return {
      value: a3,
      rest: v3
    };
  };
}
function h$1t(t3, e28) {
  for (var n3 in t3)
    if (t3.hasOwnProperty(n3) && e28(t3[n3]))
      return n3;
}
function s$1L(t3, e28) {
  for (var n3 = 0; n3 < t3.length; n3++)
    if (e28(t3[n3]))
      return n3;
}
function v$Z(a3) {
  return function(t3) {
    var u3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n3 = t3.match(a3.matchPattern);
    if (!n3)
      return null;
    var r3 = n3[0], l3 = t3.match(a3.parsePattern);
    if (!l3)
      return null;
    var e28 = a3.valueCallback ? a3.valueCallback(l3[0]) : l3[0];
    e28 = u3.valueCallback ? u3.valueCallback(e28) : e28;
    var c3 = t3.slice(r3.length);
    return {
      value: e28,
      rest: c3
    };
  };
}
var i$1z = /^(\d+)(th|st|nd|rd)?/i, n$1h = /\d+/i, s$1K = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, d$1v = {
  any: [/^b/i, /^(a|c)/i]
}, o$1g = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, m$1L = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, h$1s = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, u$1q = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, c$1I = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, P$Q = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, f$1g = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, l$1y = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, y$_ = {
  ordinalNumber: v$Z({
    matchPattern: i$1z,
    parsePattern: n$1h,
    valueCallback: function(t3) {
      return parseInt(t3, 10);
    }
  }),
  era: o$1h({
    matchPatterns: s$1K,
    defaultMatchWidth: "wide",
    parsePatterns: d$1v,
    defaultParseWidth: "any"
  }),
  quarter: o$1h({
    matchPatterns: o$1g,
    defaultMatchWidth: "wide",
    parsePatterns: m$1L,
    defaultParseWidth: "any",
    valueCallback: function(t3) {
      return t3 + 1;
    }
  }),
  month: o$1h({
    matchPatterns: h$1s,
    defaultMatchWidth: "wide",
    parsePatterns: u$1q,
    defaultParseWidth: "any"
  }),
  day: o$1h({
    matchPatterns: c$1I,
    defaultMatchWidth: "wide",
    parsePatterns: P$Q,
    defaultParseWidth: "any"
  }),
  dayPeriod: o$1h({
    matchPatterns: f$1g,
    defaultMatchWidth: "any",
    parsePatterns: l$1y,
    defaultParseWidth: "any"
  })
};
const p$3q = y$_;
var m$1K = {
  code: "en-US",
  formatDistance: h$1v,
  formatLong: l$1A,
  formatRelative: p$3r,
  localize: b$_,
  match: p$3q,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const s$1J = m$1K;
const n$1g = {
  name: "en-US",
  locale: s$1J
}, a$1R = n$1g;
function R$p(t3) {
  const {
    mergedLocaleRef: o3,
    mergedDateLocaleRef: l3
  } = inject(n$27, null) || {}, a3 = computed(() => {
    var e28, r3;
    return (r3 = (e28 = o3 == null ? void 0 : o3.value) === null || e28 === void 0 ? void 0 : e28[t3]) !== null && r3 !== void 0 ? r3 : a$1U[t3];
  });
  return {
    dateLocaleRef: computed(() => {
      var e28;
      return (e28 = l3 == null ? void 0 : l3.value) !== null && e28 !== void 0 ? e28 : a$1R;
    }),
    localeRef: a3
  };
}
function i$1y(t3) {
  return typeof t3 == "string" ? t3.endsWith("px") ? Number(t3.slice(0, t3.length - 2)) : Number(t3) : t3;
}
function o$1f(t3) {
  if (t3 != null)
    return typeof t3 == "number" ? `${t3}px` : t3.endsWith("px") ? t3 : `${t3}px`;
}
function f$1f(t3, e28) {
  const r3 = t3.trim().split(/\s+/g), n3 = {
    top: r3[0]
  };
  switch (r3.length) {
    case 1:
      n3.right = r3[0], n3.bottom = r3[0], n3.left = r3[0];
      break;
    case 2:
      n3.right = r3[1], n3.left = r3[1], n3.bottom = r3[0];
      break;
    case 3:
      n3.right = r3[1], n3.bottom = r3[2], n3.left = r3[1];
      break;
    case 4:
      n3.right = r3[1], n3.bottom = r3[2], n3.left = r3[3];
      break;
    default:
      throw new Error("[seemly/getMargin]:" + t3 + " is not a valid value.");
  }
  return e28 === void 0 ? n3 : n3[e28];
}
function s$1I(t3, e28) {
  const [r3, n3] = t3.split(" ");
  return e28 ? e28 === "row" ? r3 : n3 : {
    row: r3,
    col: n3 || r3
  };
}
const a$1Q = {
  paddingTiny: "0 8px",
  paddingSmall: "0 10px",
  paddingMedium: "0 12px",
  paddingLarge: "0 14px",
  clearSize: "16px"
};
const P$P = (p3) => {
  const {
    textColor2: o3,
    textColor3: x3,
    textColorDisabled: t3,
    primaryColor: i,
    primaryColorHover: d3,
    inputColor: r3,
    inputColorDisabled: g3,
    borderColor: a3,
    warningColor: e28,
    warningColorHover: s3,
    errorColor: l3,
    errorColorHover: c3,
    borderRadius: b3,
    lineHeight: C3,
    fontSizeTiny: u3,
    fontSizeSmall: h3,
    fontSizeMedium: m3,
    fontSizeLarge: $3,
    heightTiny: f3,
    heightSmall: H3,
    heightMedium: S3,
    heightLarge: F3,
    actionColor: v3,
    clearColor: D3,
    clearColorHover: L3,
    clearColorPressed: E3,
    placeholderColor: T3,
    placeholderColorDisabled: W3,
    iconColor: w3,
    iconColorDisabled: z3,
    iconColorHover: y3,
    iconColorPressed: j3
  } = p3;
  return Object.assign(Object.assign({}, a$1Q), {
    countTextColorDisabled: t3,
    countTextColor: x3,
    heightTiny: f3,
    heightSmall: H3,
    heightMedium: S3,
    heightLarge: F3,
    fontSizeTiny: u3,
    fontSizeSmall: h3,
    fontSizeMedium: m3,
    fontSizeLarge: $3,
    lineHeight: C3,
    lineHeightTextarea: C3,
    borderRadius: b3,
    iconSize: "16px",
    groupLabelColor: v3,
    groupLabelTextColor: o3,
    textColor: o3,
    textColorDisabled: t3,
    textDecorationColor: o3,
    caretColor: i,
    placeholderColor: T3,
    placeholderColorDisabled: W3,
    color: r3,
    colorDisabled: g3,
    colorFocus: r3,
    groupLabelBorder: `1px solid ${a3}`,
    border: `1px solid ${a3}`,
    borderHover: `1px solid ${d3}`,
    borderDisabled: `1px solid ${a3}`,
    borderFocus: `1px solid ${d3}`,
    boxShadowFocus: `0 0 0 2px ${J$p(i, {
      alpha: 0.2
    })}`,
    loadingColor: i,
    loadingColorWarning: e28,
    borderWarning: `1px solid ${e28}`,
    borderHoverWarning: `1px solid ${s3}`,
    colorFocusWarning: r3,
    borderFocusWarning: `1px solid ${s3}`,
    boxShadowFocusWarning: `0 0 0 2px ${J$p(e28, {
      alpha: 0.2
    })}`,
    caretColorWarning: e28,
    loadingColorError: l3,
    borderError: `1px solid ${l3}`,
    borderHoverError: `1px solid ${c3}`,
    colorFocusError: r3,
    borderFocusError: `1px solid ${c3}`,
    boxShadowFocusError: `0 0 0 2px ${J$p(l3, {
      alpha: 0.2
    })}`,
    caretColorError: l3,
    clearColor: D3,
    clearColorHover: L3,
    clearColorPressed: E3,
    iconColor: w3,
    iconColorDisabled: z3,
    iconColorHover: y3,
    iconColorPressed: j3,
    suffixTextColor: o3
  });
}, B$H = {
  name: "Input",
  common: d$1T,
  self: P$P
}, k$H = B$H;
const i$1x = l$25("base-clear", `
 flex-shrink: 0;
 height: 1em;
 width: 1em;
 position: relative;
`, [r$2a(">", [M$y("clear", `
 font-size: var(--n-clear-size);
 height: 1em;
 width: 1em;
 cursor: pointer;
 color: var(--n-clear-color);
 transition: color .3s var(--n-bezier);
 display: flex;
 `, [r$2a("&:hover", `
 color: var(--n-clear-color-hover)!important;
 `), r$2a("&:active", `
 color: var(--n-clear-color-pressed)!important;
 `)]), M$y("placeholder", `
 display: flex;
 `), M$y("clear, placeholder", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 `, [m$22({
  originalTransform: "translateX(-50%) translateY(-50%)",
  left: "50%",
  top: "50%"
})])])]);
const l$1x = f$1z("clear", h$1R("svg", {
  viewBox: "0 0 16 16",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("g", {
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, h$1R("g", {
  fill: "currentColor",
  "fill-rule": "nonzero"
}, h$1R("path", {
  d: "M8,2 C11.3137085,2 14,4.6862915 14,8 C14,11.3137085 11.3137085,14 8,14 C4.6862915,14 2,11.3137085 2,8 C2,4.6862915 4.6862915,2 8,2 Z M6.5343055,5.83859116 C6.33943736,5.70359511 6.07001296,5.72288026 5.89644661,5.89644661 L5.89644661,5.89644661 L5.83859116,5.9656945 C5.70359511,6.16056264 5.72288026,6.42998704 5.89644661,6.60355339 L5.89644661,6.60355339 L7.293,8 L5.89644661,9.39644661 L5.83859116,9.4656945 C5.70359511,9.66056264 5.72288026,9.92998704 5.89644661,10.1035534 L5.89644661,10.1035534 L5.9656945,10.1614088 C6.16056264,10.2964049 6.42998704,10.2771197 6.60355339,10.1035534 L6.60355339,10.1035534 L8,8.707 L9.39644661,10.1035534 L9.4656945,10.1614088 C9.66056264,10.2964049 9.92998704,10.2771197 10.1035534,10.1035534 L10.1035534,10.1035534 L10.1614088,10.0343055 C10.2964049,9.83943736 10.2771197,9.57001296 10.1035534,9.39644661 L10.1035534,9.39644661 L8.707,8 L10.1035534,6.60355339 L10.1614088,6.5343055 C10.2964049,6.33943736 10.2771197,6.07001296 10.1035534,5.89644661 L10.1035534,5.89644661 L10.0343055,5.83859116 C9.83943736,5.70359511 9.57001296,5.72288026 9.39644661,5.89644661 L9.39644661,5.89644661 L8,7.293 L6.60355339,5.89644661 Z"
})))));
const _$z = defineComponent({
  name: "BaseClear",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    show: Boolean,
    onClear: Function
  },
  setup(e28) {
    return S$O("-base-clear", i$1x, toRef$1(e28, "clsPrefix")), {
      handleMouseDown(r3) {
        r3.preventDefault();
      }
    };
  },
  render() {
    const {
      clsPrefix: e28
    } = this;
    return h$1R("div", {
      class: `${e28}-base-clear`
    }, h$1R(m$21, null, {
      default: () => {
        var r3, l3;
        return this.show ? h$1R("div", {
          key: "dismiss",
          class: `${e28}-base-clear__clear`,
          onClick: this.onClear,
          onMousedown: this.handleMouseDown,
          "data-clear": true
        }, p$3H(this.$slots.icon, () => [h$1R(d$1R, {
          clsPrefix: e28
        }, {
          default: () => h$1R(l$1x, null)
        })])) : h$1R("div", {
          key: "icon",
          class: `${e28}-base-clear__placeholder`
        }, (l3 = (r3 = this.$slots).placeholder) === null || l3 === void 0 ? void 0 : l3.call(r3));
      }
    }));
  }
});
const r$1A = defineComponent({
  name: "ChevronDown",
  render() {
    return h$1R("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, h$1R("path", {
      d: "M3.14645 5.64645C3.34171 5.45118 3.65829 5.45118 3.85355 5.64645L8 9.79289L12.1464 5.64645C12.3417 5.45118 12.6583 5.45118 12.8536 5.64645C13.0488 5.84171 13.0488 6.15829 12.8536 6.35355L8.35355 10.8536C8.15829 11.0488 7.84171 11.0488 7.64645 10.8536L3.14645 6.35355C2.95118 6.15829 2.95118 5.84171 3.14645 5.64645Z",
      fill: "currentColor"
    }));
  }
});
const x$y = defineComponent({
  name: "InternalSelectionSuffix",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    showArrow: {
      type: Boolean,
      default: void 0
    },
    showClear: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    onClear: Function
  },
  setup(e28, {
    slots: l3
  }) {
    return () => {
      const {
        clsPrefix: o3
      } = e28;
      return h$1R(h$1A, {
        clsPrefix: o3,
        class: `${o3}-base-suffix`,
        strokeWidth: 24,
        scale: 0.85,
        show: e28.loading
      }, {
        default: () => e28.showArrow ? h$1R(_$z, {
          clsPrefix: o3,
          show: e28.showClear,
          onClear: e28.onClear
        }, {
          placeholder: () => h$1R(d$1R, {
            clsPrefix: o3,
            class: `${o3}-base-suffix__arrow`
          }, {
            default: () => p$3H(l3.default, () => [h$1R(r$1A, null)])
          })
        }) : null
      });
    };
  }
});
const t$1h = defineComponent({
  name: "Eye",
  render() {
    return h$1R("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512"
    }, h$1R("path", {
      d: "M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 0 0-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 0 0 0-17.47C428.89 172.28 347.8 112 255.66 112z",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "32"
    }), h$1R("circle", {
      cx: "256",
      cy: "256",
      r: "80",
      fill: "none",
      stroke: "currentColor",
      "stroke-miterlimit": "10",
      "stroke-width": "32"
    }));
  }
});
const o$1e = defineComponent({
  name: "EyeOff",
  render() {
    return h$1R("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512"
    }, h$1R("path", {
      d: "M432 448a15.92 15.92 0 0 1-11.31-4.69l-352-352a16 16 0 0 1 22.62-22.62l352 352A16 16 0 0 1 432 448z",
      fill: "currentColor"
    }), h$1R("path", {
      d: "M255.66 384c-41.49 0-81.5-12.28-118.92-36.5c-34.07-22-64.74-53.51-88.7-91v-.08c19.94-28.57 41.78-52.73 65.24-72.21a2 2 0 0 0 .14-2.94L93.5 161.38a2 2 0 0 0-2.71-.12c-24.92 21-48.05 46.76-69.08 76.92a31.92 31.92 0 0 0-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416a239.13 239.13 0 0 0 75.8-12.58a2 2 0 0 0 .77-3.31l-21.58-21.58a4 4 0 0 0-3.83-1a204.8 204.8 0 0 1-51.16 6.47z",
      fill: "currentColor"
    }), h$1R("path", {
      d: "M490.84 238.6c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96a227.34 227.34 0 0 0-74.89 12.83a2 2 0 0 0-.75 3.31l21.55 21.55a4 4 0 0 0 3.88 1a192.82 192.82 0 0 1 50.21-6.69c40.69 0 80.58 12.43 118.55 37c34.71 22.4 65.74 53.88 89.76 91a.13.13 0 0 1 0 .16a310.72 310.72 0 0 1-64.12 72.73a2 2 0 0 0-.15 2.95l19.9 19.89a2 2 0 0 0 2.7.13a343.49 343.49 0 0 0 68.64-78.48a32.2 32.2 0 0 0-.1-34.78z",
      fill: "currentColor"
    }), h$1R("path", {
      d: "M256 160a95.88 95.88 0 0 0-21.37 2.4a2 2 0 0 0-1 3.38l112.59 112.56a2 2 0 0 0 3.38-1A96 96 0 0 0 256 160z",
      fill: "currentColor"
    }), h$1R("path", {
      d: "M165.78 233.66a2 2 0 0 0-3.38 1a96 96 0 0 0 115 115a2 2 0 0 0 1-3.38z",
      fill: "currentColor"
    }));
  }
});
const Sn$2 = Object.assign(Object.assign({}, _$F.props), {
  bordered: {
    type: Boolean,
    default: void 0
  },
  type: {
    type: String,
    default: "text"
  },
  placeholder: [Array, String],
  defaultValue: {
    type: [String, Array],
    default: null
  },
  value: [String, Array],
  disabled: {
    type: Boolean,
    default: void 0
  },
  size: String,
  rows: {
    type: [Number, String],
    default: 3
  },
  round: Boolean,
  minlength: [String, Number],
  maxlength: [String, Number],
  clearable: Boolean,
  autosize: {
    type: [Boolean, Object],
    default: false
  },
  pair: Boolean,
  separator: String,
  readonly: {
    type: [String, Boolean],
    default: false
  },
  passivelyActivated: Boolean,
  showPasswordOn: String,
  stateful: {
    type: Boolean,
    default: true
  },
  autofocus: Boolean,
  inputProps: Object,
  resizable: {
    type: Boolean,
    default: true
  },
  showCount: Boolean,
  loading: {
    type: Boolean,
    default: void 0
  },
  allowInput: Function,
  renderCount: Function,
  onMousedown: Function,
  onKeydown: Function,
  onKeyup: [Function, Array],
  onInput: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onClick: [Function, Array],
  onChange: [Function, Array],
  onClear: [Function, Array],
  countGraphemes: Function,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  textDecoration: [String, Array],
  attrSize: {
    type: Number,
    default: 20
  },
  onInputBlur: [Function, Array],
  onInputFocus: [Function, Array],
  onDeactivate: [Function, Array],
  onActivate: [Function, Array],
  onWrapperFocus: [Function, Array],
  onWrapperBlur: [Function, Array],
  internalDeactivateOnEnter: Boolean,
  internalForceFocus: Boolean,
  internalLoadingBeforeSuffix: {
    type: Boolean,
    default: true
  },
  showPasswordToggle: Boolean
}), Zn$3 = defineComponent({
  name: "Input",
  props: Sn$2,
  setup(n3) {
    const {
      mergedClsPrefixRef: y3,
      mergedBorderedRef: r3,
      inlineThemeDisabled: P3,
      mergedRtlRef: G3
    } = a$2x(n3), b3 = _$F("Input", "-input", l$1B, k$H, n3, y3);
    e$1H && S$O("-input-safari", c$1J, y3);
    const v3 = ref$1(null), f3 = ref$1(null), c3 = ref$1(null), i = ref$1(null), a3 = ref$1(null), h3 = ref$1(null), m3 = ref$1(null), M3 = b$$(m3), S3 = ref$1(null), {
      localeRef: xe2
    } = R$p("Input"), W3 = ref$1(n3.defaultValue), we2 = toRef$1(n3, "value"), x3 = d$1S(we2, W3), T3 = h$1B(n3), {
      mergedSizeRef: X3,
      mergedDisabledRef: _3,
      mergedStatusRef: Ce2
    } = T3, B3 = ref$1(false), I3 = ref$1(false), w3 = ref$1(false), $3 = ref$1(false);
    let Y3 = null;
    const q3 = computed(() => {
      const {
        placeholder: e28,
        pair: t3
      } = n3;
      return t3 ? Array.isArray(e28) ? e28 : e28 === void 0 ? ["", ""] : [e28, e28] : e28 === void 0 ? [xe2.value.placeholder] : [e28];
    }), Se2 = computed(() => {
      const {
        value: e28
      } = w3, {
        value: t3
      } = x3, {
        value: o3
      } = q3;
      return !e28 && (T$I(t3) || Array.isArray(t3) && T$I(t3[0])) && o3[0];
    }), Ae2 = computed(() => {
      const {
        value: e28
      } = w3, {
        value: t3
      } = x3, {
        value: o3
      } = q3;
      return !e28 && o3[1] && (T$I(t3) || Array.isArray(t3) && T$I(t3[1]));
    }), J3 = n$1U(() => n3.internalForceFocus || B3.value), Fe2 = n$1U(() => {
      if (_3.value || n3.readonly || !n3.clearable || !J3.value && !I3.value)
        return false;
      const {
        value: e28
      } = x3, {
        value: t3
      } = J3;
      return n3.pair ? !!(Array.isArray(e28) && (e28[0] || e28[1])) && (I3.value || t3) : !!e28 && (I3.value || t3);
    }), Q3 = computed(() => {
      const {
        showPasswordOn: e28
      } = n3;
      if (e28)
        return e28;
      if (n3.showPasswordToggle)
        return "click";
    }), V10 = ref$1(false), Re2 = computed(() => {
      const {
        textDecoration: e28
      } = n3;
      return e28 ? Array.isArray(e28) ? e28.map((t3) => ({
        textDecoration: t3
      })) : [{
        textDecoration: e28
      }] : ["", ""];
    }), le2 = ref$1(void 0), _e2 = () => {
      var e28, t3;
      if (n3.type === "textarea") {
        const {
          autosize: o3
        } = n3;
        if (o3 && (le2.value = (t3 = (e28 = S3.value) === null || e28 === void 0 ? void 0 : e28.$el) === null || t3 === void 0 ? void 0 : t3.offsetWidth), !f3.value || typeof o3 == "boolean")
          return;
        const {
          paddingTop: u3,
          paddingBottom: d3,
          lineHeight: s3
        } = window.getComputedStyle(f3.value), A3 = Number(u3.slice(0, -2)), F3 = Number(d3.slice(0, -2)), R3 = Number(s3.slice(0, -2)), {
          value: z3
        } = c3;
        if (!z3)
          return;
        if (o3.minRows) {
          const D3 = Math.max(o3.minRows, 1), te2 = `${A3 + F3 + R3 * D3}px`;
          z3.style.minHeight = te2;
        }
        if (o3.maxRows) {
          const D3 = `${A3 + F3 + R3 * o3.maxRows}px`;
          z3.style.maxHeight = D3;
        }
      }
    }, Be2 = computed(() => {
      const {
        maxlength: e28
      } = n3;
      return e28 === void 0 ? void 0 : Number(e28);
    });
    onMounted(() => {
      const {
        value: e28
      } = x3;
      Array.isArray(e28) || ee2(e28);
    });
    const Ee2 = getCurrentInstance().proxy;
    function O3(e28, t3) {
      const {
        onUpdateValue: o3,
        "onUpdate:value": u3,
        onInput: d3
      } = n3, {
        nTriggerFormInput: s3
      } = T3;
      o3 && i$1Z(o3, e28, t3), u3 && i$1Z(u3, e28, t3), d3 && i$1Z(d3, e28, t3), W3.value = e28, s3();
    }
    function N3(e28, t3) {
      const {
        onChange: o3
      } = n3, {
        nTriggerFormChange: u3
      } = T3;
      o3 && i$1Z(o3, e28, t3), W3.value = e28, u3();
    }
    function Pe2(e28) {
      const {
        onBlur: t3
      } = n3, {
        nTriggerFormBlur: o3
      } = T3;
      t3 && i$1Z(t3, e28), o3();
    }
    function Te2(e28) {
      const {
        onFocus: t3
      } = n3, {
        nTriggerFormFocus: o3
      } = T3;
      t3 && i$1Z(t3, e28), o3();
    }
    function Ie2(e28) {
      const {
        onClear: t3
      } = n3;
      t3 && i$1Z(t3, e28);
    }
    function $e2(e28) {
      const {
        onInputBlur: t3
      } = n3;
      t3 && i$1Z(t3, e28);
    }
    function Ve2(e28) {
      const {
        onInputFocus: t3
      } = n3;
      t3 && i$1Z(t3, e28);
    }
    function ze2() {
      const {
        onDeactivate: e28
      } = n3;
      e28 && i$1Z(e28);
    }
    function De2() {
      const {
        onActivate: e28
      } = n3;
      e28 && i$1Z(e28);
    }
    function Me2(e28) {
      const {
        onClick: t3
      } = n3;
      t3 && i$1Z(t3, e28);
    }
    function We2(e28) {
      const {
        onWrapperFocus: t3
      } = n3;
      t3 && i$1Z(t3, e28);
    }
    function Oe2(e28) {
      const {
        onWrapperBlur: t3
      } = n3;
      t3 && i$1Z(t3, e28);
    }
    function Ne2() {
      w3.value = true;
    }
    function ke2(e28) {
      w3.value = false, e28.target === h3.value ? k3(e28, 1) : k3(e28, 0);
    }
    function k3(e28, t3 = 0, o3 = "input") {
      const u3 = e28.target.value;
      if (ee2(u3), e28 instanceof InputEvent && !e28.isComposing && (w3.value = false), n3.type === "textarea") {
        const {
          value: s3
        } = S3;
        s3 && s3.syncUnifiedContainer();
      }
      if (Y3 = u3, w3.value)
        return;
      M3.recordCursor();
      const d3 = He2(u3);
      if (d3)
        if (!n3.pair)
          o3 === "input" ? O3(u3, {
            source: t3
          }) : N3(u3, {
            source: t3
          });
        else {
          let {
            value: s3
          } = x3;
          Array.isArray(s3) ? s3 = [s3[0], s3[1]] : s3 = ["", ""], s3[t3] = u3, o3 === "input" ? O3(s3, {
            source: t3
          }) : N3(s3, {
            source: t3
          });
        }
      Ee2.$forceUpdate(), d3 || nextTick(M3.restoreCursor);
    }
    function He2(e28) {
      const {
        countGraphemes: t3,
        maxlength: o3,
        minlength: u3
      } = n3;
      if (t3) {
        let s3;
        if (o3 !== void 0 && (s3 === void 0 && (s3 = t3(e28)), s3 > Number(o3)) || u3 !== void 0 && (s3 === void 0 && (s3 = t3(e28)), s3 < Number(o3)))
          return false;
      }
      const {
        allowInput: d3
      } = n3;
      return typeof d3 == "function" ? d3(e28) : true;
    }
    function Ke2(e28) {
      $e2(e28), e28.relatedTarget === v3.value && ze2(), e28.relatedTarget !== null && (e28.relatedTarget === a3.value || e28.relatedTarget === h3.value || e28.relatedTarget === f3.value) || ($3.value = false), H3(e28, "blur"), m3.value = null;
    }
    function Ue2(e28, t3) {
      Ve2(e28), B3.value = true, $3.value = true, De2(), H3(e28, "focus"), t3 === 0 ? m3.value = a3.value : t3 === 1 ? m3.value = h3.value : t3 === 2 && (m3.value = f3.value);
    }
    function Le2(e28) {
      n3.passivelyActivated && (Oe2(e28), H3(e28, "blur"));
    }
    function je2(e28) {
      n3.passivelyActivated && (B3.value = true, We2(e28), H3(e28, "focus"));
    }
    function H3(e28, t3) {
      e28.relatedTarget !== null && (e28.relatedTarget === a3.value || e28.relatedTarget === h3.value || e28.relatedTarget === f3.value || e28.relatedTarget === v3.value) || (t3 === "focus" ? (Te2(e28), B3.value = true) : t3 === "blur" && (Pe2(e28), B3.value = false));
    }
    function Ge2(e28, t3) {
      k3(e28, t3, "change");
    }
    function Xe2(e28) {
      Me2(e28);
    }
    function Ye2(e28) {
      Ie2(e28), ae2();
    }
    function ae2() {
      n3.pair ? (O3(["", ""], {
        source: "clear"
      }), N3(["", ""], {
        source: "clear"
      })) : (O3("", {
        source: "clear"
      }), N3("", {
        source: "clear"
      }));
    }
    function qe2(e28) {
      const {
        onMousedown: t3
      } = n3;
      t3 && t3(e28);
      const {
        tagName: o3
      } = e28.target;
      if (o3 !== "INPUT" && o3 !== "TEXTAREA") {
        if (n3.resizable) {
          const {
            value: u3
          } = v3;
          if (u3) {
            const {
              left: d3,
              top: s3,
              width: A3,
              height: F3
            } = u3.getBoundingClientRect(), R3 = 14;
            if (d3 + A3 - R3 < e28.clientX && e28.clientX < d3 + A3 && s3 + F3 - R3 < e28.clientY && e28.clientY < s3 + F3)
              return;
          }
        }
        e28.preventDefault(), B3.value || ie2();
      }
    }
    function Je2() {
      var e28;
      I3.value = true, n3.type === "textarea" && ((e28 = S3.value) === null || e28 === void 0 || e28.handleMouseEnterWrapper());
    }
    function Qe2() {
      var e28;
      I3.value = false, n3.type === "textarea" && ((e28 = S3.value) === null || e28 === void 0 || e28.handleMouseLeaveWrapper());
    }
    function Ze2() {
      _3.value || Q3.value === "click" && (V10.value = !V10.value);
    }
    function et2(e28) {
      if (_3.value)
        return;
      e28.preventDefault();
      const t3 = (u3) => {
        u3.preventDefault(), K$p("mouseup", document, t3);
      };
      if (J$o("mouseup", document, t3), Q3.value !== "mousedown")
        return;
      V10.value = true;
      const o3 = () => {
        V10.value = false, K$p("mouseup", document, o3);
      };
      J$o("mouseup", document, o3);
    }
    function tt2(e28) {
      n3.onKeyup && i$1Z(n3.onKeyup, e28);
    }
    function nt2(e28) {
      switch (n3.onKeydown && i$1Z(n3.onKeydown, e28), e28.key) {
        case "Escape":
          Z3();
          break;
        case "Enter":
          ot2(e28);
          break;
      }
    }
    function ot2(e28) {
      var t3, o3;
      if (n3.passivelyActivated) {
        const {
          value: u3
        } = $3;
        if (u3) {
          n3.internalDeactivateOnEnter && Z3();
          return;
        }
        e28.preventDefault(), n3.type === "textarea" ? (t3 = f3.value) === null || t3 === void 0 || t3.focus() : (o3 = a3.value) === null || o3 === void 0 || o3.focus();
      }
    }
    function Z3() {
      n3.passivelyActivated && ($3.value = false, nextTick(() => {
        var e28;
        (e28 = v3.value) === null || e28 === void 0 || e28.focus();
      }));
    }
    function ie2() {
      var e28, t3, o3;
      _3.value || (n3.passivelyActivated ? (e28 = v3.value) === null || e28 === void 0 || e28.focus() : ((t3 = f3.value) === null || t3 === void 0 || t3.focus(), (o3 = a3.value) === null || o3 === void 0 || o3.focus()));
    }
    function rt2() {
      var e28;
      !((e28 = v3.value) === null || e28 === void 0) && e28.contains(document.activeElement) && document.activeElement.blur();
    }
    function lt2() {
      var e28, t3;
      (e28 = f3.value) === null || e28 === void 0 || e28.select(), (t3 = a3.value) === null || t3 === void 0 || t3.select();
    }
    function at2() {
      _3.value || (f3.value ? f3.value.focus() : a3.value && a3.value.focus());
    }
    function it2() {
      const {
        value: e28
      } = v3;
      e28 != null && e28.contains(document.activeElement) && e28 !== document.activeElement && Z3();
    }
    function st2(e28) {
      if (n3.type === "textarea") {
        const {
          value: t3
        } = f3;
        t3 == null || t3.scrollTo(e28);
      } else {
        const {
          value: t3
        } = a3;
        t3 == null || t3.scrollTo(e28);
      }
    }
    function ee2(e28) {
      const {
        type: t3,
        pair: o3,
        autosize: u3
      } = n3;
      if (!o3 && u3)
        if (t3 === "textarea") {
          const {
            value: d3
          } = c3;
          d3 && (d3.textContent = (e28 != null ? e28 : "") + `\r
`);
        } else {
          const {
            value: d3
          } = i;
          d3 && (e28 ? d3.textContent = e28 : d3.innerHTML = "&nbsp;");
        }
    }
    function ut2() {
      _e2();
    }
    const se2 = ref$1({
      top: "0"
    });
    function dt2(e28) {
      var t3;
      const {
        scrollTop: o3
      } = e28.target;
      se2.value.top = `${-o3}px`, (t3 = S3.value) === null || t3 === void 0 || t3.syncUnifiedContainer();
    }
    let K3 = null;
    watchEffect(() => {
      const {
        autosize: e28,
        type: t3
      } = n3;
      e28 && t3 === "textarea" ? K3 = watch(x3, (o3) => {
        !Array.isArray(o3) && o3 !== Y3 && ee2(o3);
      }) : K3 == null || K3();
    });
    let U3 = null;
    watchEffect(() => {
      n3.type === "textarea" ? U3 = watch(x3, (e28) => {
        var t3;
        !Array.isArray(e28) && e28 !== Y3 && ((t3 = S3.value) === null || t3 === void 0 || t3.syncUnifiedContainer());
      }) : U3 == null || U3();
    }), provide(e$1t, {
      mergedValueRef: x3,
      maxlengthRef: Be2,
      mergedClsPrefixRef: y3,
      countGraphemesRef: toRef$1(n3, "countGraphemes")
    });
    const ct2 = {
      wrapperElRef: v3,
      inputElRef: a3,
      textareaElRef: f3,
      isCompositing: w3,
      clear: ae2,
      focus: ie2,
      blur: rt2,
      select: lt2,
      deactivate: it2,
      activate: at2,
      scrollTo: st2
    }, ft2 = v$17("Input", G3, y3), ue2 = computed(() => {
      const {
        value: e28
      } = X3, {
        common: {
          cubicBezierEaseInOut: t3
        },
        self: {
          color: o3,
          borderRadius: u3,
          textColor: d3,
          caretColor: s3,
          caretColorError: A3,
          caretColorWarning: F3,
          textDecorationColor: R3,
          border: z3,
          borderDisabled: D3,
          borderHover: te2,
          borderFocus: ht2,
          placeholderColor: vt2,
          placeholderColorDisabled: pt2,
          lineHeightTextarea: gt2,
          colorDisabled: mt2,
          colorFocus: yt2,
          textColorDisabled: bt2,
          boxShadowFocus: xt2,
          iconSize: wt2,
          colorFocusWarning: Ct2,
          boxShadowFocusWarning: St2,
          borderWarning: At2,
          borderFocusWarning: Ft2,
          borderHoverWarning: Rt2,
          colorFocusError: _t2,
          boxShadowFocusError: Bt2,
          borderError: Et2,
          borderFocusError: Pt2,
          borderHoverError: Tt2,
          clearSize: It2,
          clearColor: $t2,
          clearColorHover: Vt2,
          clearColorPressed: zt2,
          iconColor: Dt2,
          iconColorDisabled: Mt2,
          suffixTextColor: Wt2,
          countTextColor: Ot2,
          countTextColorDisabled: Nt2,
          iconColorHover: kt2,
          iconColorPressed: Ht2,
          loadingColor: Kt2,
          loadingColorError: Ut2,
          loadingColorWarning: Lt2,
          [_$H("padding", e28)]: jt2,
          [_$H("fontSize", e28)]: Gt2,
          [_$H("height", e28)]: Xt2
        }
      } = b3.value, {
        left: Yt2,
        right: qt2
      } = f$1f(jt2);
      return {
        "--n-bezier": t3,
        "--n-count-text-color": Ot2,
        "--n-count-text-color-disabled": Nt2,
        "--n-color": o3,
        "--n-font-size": Gt2,
        "--n-border-radius": u3,
        "--n-height": Xt2,
        "--n-padding-left": Yt2,
        "--n-padding-right": qt2,
        "--n-text-color": d3,
        "--n-caret-color": s3,
        "--n-text-decoration-color": R3,
        "--n-border": z3,
        "--n-border-disabled": D3,
        "--n-border-hover": te2,
        "--n-border-focus": ht2,
        "--n-placeholder-color": vt2,
        "--n-placeholder-color-disabled": pt2,
        "--n-icon-size": wt2,
        "--n-line-height-textarea": gt2,
        "--n-color-disabled": mt2,
        "--n-color-focus": yt2,
        "--n-text-color-disabled": bt2,
        "--n-box-shadow-focus": xt2,
        "--n-loading-color": Kt2,
        "--n-caret-color-warning": F3,
        "--n-color-focus-warning": Ct2,
        "--n-box-shadow-focus-warning": St2,
        "--n-border-warning": At2,
        "--n-border-focus-warning": Ft2,
        "--n-border-hover-warning": Rt2,
        "--n-loading-color-warning": Lt2,
        "--n-caret-color-error": A3,
        "--n-color-focus-error": _t2,
        "--n-box-shadow-focus-error": Bt2,
        "--n-border-error": Et2,
        "--n-border-focus-error": Pt2,
        "--n-border-hover-error": Tt2,
        "--n-loading-color-error": Ut2,
        "--n-clear-color": $t2,
        "--n-clear-size": It2,
        "--n-clear-color-hover": Vt2,
        "--n-clear-color-pressed": zt2,
        "--n-icon-color": Dt2,
        "--n-icon-color-hover": kt2,
        "--n-icon-color-pressed": Ht2,
        "--n-icon-color-disabled": Mt2,
        "--n-suffix-text-color": Wt2
      };
    }), E3 = P3 ? E$J("input", computed(() => {
      const {
        value: e28
      } = X3;
      return e28[0];
    }), ue2, n3) : void 0;
    return Object.assign(Object.assign({}, ct2), {
      wrapperElRef: v3,
      inputElRef: a3,
      inputMirrorElRef: i,
      inputEl2Ref: h3,
      textareaElRef: f3,
      textareaMirrorElRef: c3,
      textareaScrollbarInstRef: S3,
      rtlEnabled: ft2,
      uncontrolledValue: W3,
      mergedValue: x3,
      passwordVisible: V10,
      mergedPlaceholder: q3,
      showPlaceholder1: Se2,
      showPlaceholder2: Ae2,
      mergedFocus: J3,
      isComposing: w3,
      activated: $3,
      showClearButton: Fe2,
      mergedSize: X3,
      mergedDisabled: _3,
      textDecorationStyle: Re2,
      mergedClsPrefix: y3,
      mergedBordered: r3,
      mergedShowPasswordOn: Q3,
      placeholderStyle: se2,
      mergedStatus: Ce2,
      textAreaScrollContainerWidth: le2,
      handleTextAreaScroll: dt2,
      handleCompositionStart: Ne2,
      handleCompositionEnd: ke2,
      handleInput: k3,
      handleInputBlur: Ke2,
      handleInputFocus: Ue2,
      handleWrapperBlur: Le2,
      handleWrapperFocus: je2,
      handleMouseEnter: Je2,
      handleMouseLeave: Qe2,
      handleMouseDown: qe2,
      handleChange: Ge2,
      handleClick: Xe2,
      handleClear: Ye2,
      handlePasswordToggleClick: Ze2,
      handlePasswordToggleMousedown: et2,
      handleWrapperKeydown: nt2,
      handleWrapperKeyup: tt2,
      handleTextAreaMirrorResize: ut2,
      getTextareaScrollContainer: () => f3.value,
      mergedTheme: b3,
      cssVars: P3 ? void 0 : ue2,
      themeClass: E3 == null ? void 0 : E3.themeClass,
      onRender: E3 == null ? void 0 : E3.onRender
    });
  },
  render() {
    var n3, y3;
    const {
      mergedClsPrefix: r3,
      mergedStatus: P3,
      themeClass: G3,
      type: b3,
      countGraphemes: v3,
      onRender: f3
    } = this, c3 = this.$slots;
    return f3 == null || f3(), h$1R("div", {
      ref: "wrapperElRef",
      class: [`${r3}-input`, G3, P3 && `${r3}-input--${P3}-status`, {
        [`${r3}-input--rtl`]: this.rtlEnabled,
        [`${r3}-input--disabled`]: this.mergedDisabled,
        [`${r3}-input--textarea`]: b3 === "textarea",
        [`${r3}-input--resizable`]: this.resizable && !this.autosize,
        [`${r3}-input--autosize`]: this.autosize,
        [`${r3}-input--round`]: this.round && b3 !== "textarea",
        [`${r3}-input--pair`]: this.pair,
        [`${r3}-input--focus`]: this.mergedFocus,
        [`${r3}-input--stateful`]: this.stateful
      }],
      style: this.cssVars,
      tabindex: !this.mergedDisabled && this.passivelyActivated && !this.activated ? 0 : void 0,
      onFocus: this.handleWrapperFocus,
      onBlur: this.handleWrapperBlur,
      onClick: this.handleClick,
      onMousedown: this.handleMouseDown,
      onMouseenter: this.handleMouseEnter,
      onMouseleave: this.handleMouseLeave,
      onCompositionstart: this.handleCompositionStart,
      onCompositionend: this.handleCompositionEnd,
      onKeyup: this.handleWrapperKeyup,
      onKeydown: this.handleWrapperKeydown
    }, h$1R("div", {
      class: `${r3}-input-wrapper`
    }, m$26(c3.prefix, (i) => i && h$1R("div", {
      class: `${r3}-input__prefix`
    }, i)), b3 === "textarea" ? h$1R(hn$2, {
      ref: "textareaScrollbarInstRef",
      class: `${r3}-input__textarea`,
      container: this.getTextareaScrollContainer,
      triggerDisplayManually: true,
      useUnifiedContainer: true,
      internalHoistYRail: true
    }, {
      default: () => {
        var i, a3;
        const {
          textAreaScrollContainerWidth: h3
        } = this, m3 = {
          width: this.autosize && h3 && `${h3}px`
        };
        return h$1R(Fragment, null, h$1R("textarea", Object.assign({}, this.inputProps, {
          ref: "textareaElRef",
          class: [`${r3}-input__textarea-el`, (i = this.inputProps) === null || i === void 0 ? void 0 : i.class],
          autofocus: this.autofocus,
          rows: Number(this.rows),
          placeholder: this.placeholder,
          value: this.mergedValue,
          disabled: this.mergedDisabled,
          maxlength: v3 ? void 0 : this.maxlength,
          minlength: v3 ? void 0 : this.minlength,
          readonly: this.readonly,
          tabindex: this.passivelyActivated && !this.activated ? -1 : void 0,
          style: [this.textDecorationStyle[0], (a3 = this.inputProps) === null || a3 === void 0 ? void 0 : a3.style, m3],
          onBlur: this.handleInputBlur,
          onFocus: (M3) => {
            this.handleInputFocus(M3, 2);
          },
          onInput: this.handleInput,
          onChange: this.handleChange,
          onScroll: this.handleTextAreaScroll
        })), this.showPlaceholder1 ? h$1R("div", {
          class: `${r3}-input__placeholder`,
          style: [this.placeholderStyle, m3],
          key: "placeholder"
        }, this.mergedPlaceholder[0]) : null, this.autosize ? h$1R(x$D, {
          onResize: this.handleTextAreaMirrorResize
        }, {
          default: () => h$1R("div", {
            ref: "textareaMirrorElRef",
            class: `${r3}-input__textarea-mirror`,
            key: "mirror"
          })
        }) : null);
      }
    }) : h$1R("div", {
      class: `${r3}-input__input`
    }, h$1R("input", Object.assign({
      type: b3 === "password" && this.mergedShowPasswordOn && this.passwordVisible ? "text" : b3
    }, this.inputProps, {
      ref: "inputElRef",
      class: [`${r3}-input__input-el`, (n3 = this.inputProps) === null || n3 === void 0 ? void 0 : n3.class],
      style: [this.textDecorationStyle[0], (y3 = this.inputProps) === null || y3 === void 0 ? void 0 : y3.style],
      tabindex: this.passivelyActivated && !this.activated ? -1 : void 0,
      placeholder: this.mergedPlaceholder[0],
      disabled: this.mergedDisabled,
      maxlength: v3 ? void 0 : this.maxlength,
      minlength: v3 ? void 0 : this.minlength,
      value: Array.isArray(this.mergedValue) ? this.mergedValue[0] : this.mergedValue,
      readonly: this.readonly,
      autofocus: this.autofocus,
      size: this.attrSize,
      onBlur: this.handleInputBlur,
      onFocus: (i) => {
        this.handleInputFocus(i, 0);
      },
      onInput: (i) => {
        this.handleInput(i, 0);
      },
      onChange: (i) => {
        this.handleChange(i, 0);
      }
    })), this.showPlaceholder1 ? h$1R("div", {
      class: `${r3}-input__placeholder`
    }, h$1R("span", null, this.mergedPlaceholder[0])) : null, this.autosize ? h$1R("div", {
      class: `${r3}-input__input-mirror`,
      key: "mirror",
      ref: "inputMirrorElRef"
    }, "\xA0") : null), !this.pair && m$26(c3.suffix, (i) => i || this.clearable || this.showCount || this.mergedShowPasswordOn || this.loading !== void 0 ? h$1R("div", {
      class: `${r3}-input__suffix`
    }, [m$26(c3["clear-icon-placeholder"], (a3) => (this.clearable || a3) && h$1R(_$z, {
      clsPrefix: r3,
      show: this.showClearButton,
      onClear: this.handleClear
    }, {
      placeholder: () => a3,
      icon: () => {
        var h3, m3;
        return (m3 = (h3 = this.$slots)["clear-icon"]) === null || m3 === void 0 ? void 0 : m3.call(h3);
      }
    })), this.internalLoadingBeforeSuffix ? null : i, this.loading !== void 0 ? h$1R(x$y, {
      clsPrefix: r3,
      loading: this.loading,
      showArrow: false,
      showClear: false,
      style: this.cssVars
    }) : null, this.internalLoadingBeforeSuffix ? i : null, this.showCount && this.type !== "textarea" ? h$1R(R$q, null, {
      default: (a3) => {
        var h3;
        return (h3 = c3.count) === null || h3 === void 0 ? void 0 : h3.call(c3, a3);
      }
    }) : null, this.mergedShowPasswordOn && this.type === "password" ? h$1R("div", {
      class: `${r3}-input__eye`,
      onMousedown: this.handlePasswordToggleMousedown,
      onClick: this.handlePasswordToggleClick
    }, this.passwordVisible ? p$3H(c3["password-visible-icon"], () => [h$1R(d$1R, {
      clsPrefix: r3
    }, {
      default: () => h$1R(t$1h, null)
    })]) : p$3H(c3["password-invisible-icon"], () => [h$1R(d$1R, {
      clsPrefix: r3
    }, {
      default: () => h$1R(o$1e, null)
    })])) : null]) : null)), this.pair ? h$1R("span", {
      class: `${r3}-input__separator`
    }, p$3H(c3.separator, () => [this.separator])) : null, this.pair ? h$1R("div", {
      class: `${r3}-input-wrapper`
    }, h$1R("div", {
      class: `${r3}-input__input`
    }, h$1R("input", {
      ref: "inputEl2Ref",
      type: this.type,
      class: `${r3}-input__input-el`,
      tabindex: this.passivelyActivated && !this.activated ? -1 : void 0,
      placeholder: this.mergedPlaceholder[1],
      disabled: this.mergedDisabled,
      maxlength: v3 ? void 0 : this.maxlength,
      minlength: v3 ? void 0 : this.minlength,
      value: Array.isArray(this.mergedValue) ? this.mergedValue[1] : void 0,
      readonly: this.readonly,
      style: this.textDecorationStyle[1],
      onBlur: this.handleInputBlur,
      onFocus: (i) => {
        this.handleInputFocus(i, 1);
      },
      onInput: (i) => {
        this.handleInput(i, 1);
      },
      onChange: (i) => {
        this.handleChange(i, 1);
      }
    }), this.showPlaceholder2 ? h$1R("div", {
      class: `${r3}-input__placeholder`
    }, h$1R("span", null, this.mergedPlaceholder[1])) : null), m$26(c3.suffix, (i) => (this.clearable || i) && h$1R("div", {
      class: `${r3}-input__suffix`
    }, [this.clearable && h$1R(_$z, {
      clsPrefix: r3,
      show: this.showClearButton,
      onClear: this.handleClear
    }, {
      icon: () => {
        var a3;
        return (a3 = c3["clear-icon"]) === null || a3 === void 0 ? void 0 : a3.call(c3);
      },
      placeholder: () => {
        var a3;
        return (a3 = c3["clear-icon-placeholder"]) === null || a3 === void 0 ? void 0 : a3.call(c3);
      }
    }), i]))) : null, this.mergedBordered ? h$1R("div", {
      class: `${r3}-input__border`
    }) : null, this.mergedBordered ? h$1R("div", {
      class: `${r3}-input__state-border`
    }) : null, this.showCount && b3 === "textarea" ? h$1R(R$q, null, {
      default: (i) => {
        var a3;
        const {
          renderCount: h3
        } = this;
        return h3 ? h3(i) : (a3 = c3.count) === null || a3 === void 0 ? void 0 : a3.call(c3, i);
      }
    }) : null);
  }
});
const v$Y = defineComponent({
  name: "UIInput"
}), B$G = defineComponent(__spreadProps(__spreadValues({}, v$Y), {
  props: {
    id: {
      type: String,
      required: true
    },
    modelValue: {
      type: [String, Array],
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: { type: String, default: void 0 },
    readonly: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 3
    },
    maxlength: Number,
    minlength: Number,
    loading: {
      type: Boolean
    },
    autosize: {
      type: [Boolean, Object]
    },
    clearable: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "large"
    },
    showCount: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    inputProps: {
      type: Object
    },
    showPasswordOn: {
      type: String,
      default: void 0
    }
  },
  emits: ["update:modelValue", "onBlur", "onChange"],
  setup(e28, { emit: d3 }) {
    const s3 = ["text", "textarea", "password"], n3 = e28, p3 = d3, m3 = computed(() => s3.includes(n3.type) ? n3.type : "text"), y3 = computed(() => {
      if (!s3.includes(n3.type))
        return __spreadValues({
          type: n3.type
        }, n3.inputProps);
      if (n3.inputProps)
        return n3.inputProps;
    });
    function f3(t3) {
      p3("update:modelValue", t3);
    }
    return (t3, o3) => (openBlock(), createBlock(unref(Zn$3), mergeProps(t3.$attrs, {
      id: e28.id,
      clearable: e28.clearable,
      disabled: e28.disabled,
      loading: e28.loading,
      maxlength: e28.maxlength,
      minlength: e28.minlength,
      placeholder: e28.placeholder,
      readonly: e28.readonly,
      rows: e28.rows,
      "show-count": e28.showCount,
      size: e28.size,
      type: m3.value,
      "input-props": y3.value,
      value: e28.modelValue,
      autosize: e28.autosize,
      "show-password-on": e28.showPasswordOn,
      "onUpdate:value": f3,
      onOnBlur: o3[0] || (o3[0] = (i) => t3.$emit("onBlur", i)),
      onOnChange: o3[1] || (o3[1] = (i) => t3.$emit("onChange", i)),
      class: "hl-input-text font-sans"
    }), {
      prefix: withCtx(() => [
        renderSlot(t3.$slots, "prefix")
      ]),
      suffix: withCtx(() => [
        renderSlot(t3.$slots, "suffix")
      ]),
      "password-visible-icon": withCtx(() => [
        renderSlot(t3.$slots, "password-visible-icon")
      ]),
      "password-invisible-icon": withCtx(() => [
        renderSlot(t3.$slots, "password-invisible-icon")
      ]),
      _: 3
    }, 16, ["id", "clearable", "disabled", "loading", "maxlength", "minlength", "placeholder", "readonly", "rows", "show-count", "size", "type", "input-props", "value", "autosize", "show-password-on"]));
  }
})), P$O = B$G;
const a$1P = l$25("input-group", `
 display: inline-flex;
 width: 100%;
 flex-wrap: nowrap;
 vertical-align: bottom;
`, [r$2a(">", [l$25("input", [r$2a("&:not(:last-child)", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), r$2a("&:not(:first-child)", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 margin-left: -1px!important;
 `)]), l$25("button", [r$2a("&:not(:last-child)", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `, [M$y("state-border, border", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `)]), r$2a("&:not(:first-child)", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `, [M$y("state-border, border", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `)])]), r$2a("*", [r$2a("&:not(:last-child)", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `, [r$2a(">", [l$25("input", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), l$25("base-selection", [l$25("base-selection-label", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), l$25("base-selection-tags", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), M$y("box-shadow, border, state-border", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `)])])]), r$2a("&:not(:first-child)", `
 margin-left: -1px!important;
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `, [r$2a(">", [l$25("input", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `), l$25("base-selection", [l$25("base-selection-label", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `), l$25("base-selection-tags", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `), M$y("box-shadow, border, state-border", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `)])])])])])]);
const u$1p = {}, d$1u = defineComponent({
  name: "InputGroup",
  props: u$1p,
  setup(r3) {
    const {
      mergedClsPrefixRef: e28
    } = a$2x(r3);
    return S$O("-input-group", a$1P, e28), {
      mergedClsPrefix: e28
    };
  },
  render() {
    const {
      mergedClsPrefix: r3
    } = this;
    return h$1R("div", {
      class: `${r3}-input-group`
    }, this.$slots);
  }
});
const s$1H = defineComponent({
  name: "UIInputGroup",
  inheritAttrs: false
}), a$1O = defineComponent(__spreadProps(__spreadValues({}, s$1H), {
  setup(f3) {
    return (e28, _3) => (openBlock(), createBlock(unref(d$1u), null, {
      default: withCtx(() => [
        renderSlot(e28.$slots, "default")
      ]),
      _: 3
    }));
  }
})), m$1J = a$1O;
const i$1w = l$25("input-group-label", `
 position: relative;
 user-select: none;
 -webkit-user-select: none;
 box-sizing: border-box;
 padding: 0 12px;
 display: inline-block;
 border-radius: var(--n-border-radius);
 background-color: var(--n-group-label-color);
 color: var(--n-group-label-text-color);
 font-size: var(--n-font-size);
 line-height: var(--n-height);
 height: var(--n-height);
 flex-shrink: 0;
 white-space: nowrap;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
`, [M$y("border", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 border: var(--n-group-label-border);
 transition: border-color .3s var(--n-bezier);
 `)]);
const y$Z = Object.assign(Object.assign({}, _$F.props), {
  size: {
    type: String,
    default: "medium"
  },
  bordered: {
    type: Boolean,
    default: void 0
  }
}), V$t = defineComponent({
  name: "InputGroupLabel",
  props: y$Z,
  setup(e28) {
    const {
      mergedBorderedRef: n3,
      mergedClsPrefixRef: r3,
      inlineThemeDisabled: t3
    } = a$2x(e28), m3 = _$F("Input", "-input-group-label", i$1w, k$H, e28, r3), i = computed(() => {
      const {
        size: l3
      } = e28, {
        common: {
          cubicBezierEaseInOut: p3
        },
        self: {
          groupLabelColor: f3,
          borderRadius: c3,
          groupLabelTextColor: g3,
          lineHeight: h3,
          groupLabelBorder: b3,
          [_$H("fontSize", l3)]: v3,
          [_$H("height", l3)]: C3
        }
      } = m3.value;
      return {
        "--n-bezier": p3,
        "--n-group-label-color": f3,
        "--n-group-label-border": b3,
        "--n-border-radius": c3,
        "--n-group-label-text-color": g3,
        "--n-font-size": v3,
        "--n-line-height": h3,
        "--n-height": C3
      };
    }), o3 = t3 ? E$J("input-group-label", computed(() => e28.size[0]), i, e28) : void 0;
    return {
      mergedClsPrefix: r3,
      mergedBordered: n3,
      cssVars: t3 ? void 0 : i,
      themeClass: o3 == null ? void 0 : o3.themeClass,
      onRender: o3 == null ? void 0 : o3.onRender
    };
  },
  render() {
    var e28, n3, r3;
    const {
      mergedClsPrefix: t3
    } = this;
    return (e28 = this.onRender) === null || e28 === void 0 || e28.call(this), h$1R("div", {
      class: [`${t3}-input-group-label`, this.themeClass],
      style: this.cssVars
    }, (r3 = (n3 = this.$slots).default) === null || r3 === void 0 ? void 0 : r3.call(n3), this.mergedBordered ? h$1R("div", {
      class: `${t3}-input-group-label__border`
    }) : null);
  }
});
const i$1v = defineComponent({
  name: "UIInputGroupLabel",
  inheritAttrs: false
}), f$1e = defineComponent(__spreadProps(__spreadValues({}, i$1v), {
  props: {
    size: {
      type: String,
      default: "large"
    }
  },
  setup(r3) {
    return (e28, c3) => (openBlock(), createBlock(unref(V$t), mergeProps(e28.$attrs, { size: r3.size }), {
      default: withCtx(() => [
        renderSlot(e28.$slots, "default")
      ]),
      _: 3
    }, 16, ["size"]));
  }
})), _$y = f$1e;
const r$1z = n$28("n-dialog-provider");
const o$1d = {
  icon: Function,
  type: {
    type: String,
    default: "default"
  },
  title: [String, Function],
  closable: {
    type: Boolean,
    default: true
  },
  negativeText: String,
  positiveText: String,
  positiveButtonProps: Object,
  negativeButtonProps: Object,
  content: [String, Function],
  action: Function,
  showIcon: {
    type: Boolean,
    default: true
  },
  loading: Boolean,
  bordered: Boolean,
  iconPlacement: String,
  onPositiveClick: Function,
  onNegativeClick: Function,
  onClose: Function
}, e$1r = t$1y(o$1d);
const c$1H = r$2a([l$25("card", `
 font-size: var(--n-font-size);
 line-height: var(--n-line-height);
 display: flex;
 flex-direction: column;
 width: 100%;
 box-sizing: border-box;
 position: relative;
 border-radius: var(--n-border-radius);
 background-color: var(--n-color);
 color: var(--n-text-color);
 word-break: break-word;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [v$1a({
  background: "var(--n-color-modal)"
}), g$1j("hoverable", [r$2a("&:hover", "box-shadow: var(--n-box-shadow);")]), g$1j("content-segmented", [r$2a(">", [M$y("content", {
  paddingTop: "var(--n-padding-bottom)"
})])]), g$1j("content-soft-segmented", [r$2a(">", [M$y("content", `
 margin: 0 var(--n-padding-left);
 padding: var(--n-padding-bottom) 0;
 `)])]), g$1j("footer-segmented", [r$2a(">", [M$y("footer", {
  paddingTop: "var(--n-padding-bottom)"
})])]), g$1j("footer-soft-segmented", [r$2a(">", [M$y("footer", `
 padding: var(--n-padding-bottom) 0;
 margin: 0 var(--n-padding-left);
 `)])]), r$2a(">", [l$25("card-header", `
 box-sizing: border-box;
 display: flex;
 align-items: center;
 font-size: var(--n-title-font-size);
 padding:
 var(--n-padding-top)
 var(--n-padding-left)
 var(--n-padding-bottom)
 var(--n-padding-left);
 `, [M$y("main", `
 font-weight: var(--n-title-font-weight);
 transition: color .3s var(--n-bezier);
 flex: 1;
 min-width: 0;
 color: var(--n-title-text-color);
 `), M$y("extra", `
 display: flex;
 align-items: center;
 font-size: var(--n-font-size);
 font-weight: 400;
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 `), M$y("close", `
 margin: 0 0 0 8px;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)]), M$y("action", `
 box-sizing: border-box;
 transition:
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 background-clip: padding-box;
 background-color: var(--n-action-color);
 `), M$y("content", "flex: 1; min-width: 0;"), M$y("content, footer", `
 box-sizing: border-box;
 padding: 0 var(--n-padding-left) var(--n-padding-bottom) var(--n-padding-left);
 font-size: var(--n-font-size);
 `, [r$2a("&:first-child", {
  paddingTop: "var(--n-padding-bottom)"
})]), M$y("action", `
 background-color: var(--n-action-color);
 padding: var(--n-padding-bottom) var(--n-padding-left);
 border-bottom-left-radius: var(--n-border-radius);
 border-bottom-right-radius: var(--n-border-radius);
 `)]), l$25("card-cover", `
 overflow: hidden;
 width: 100%;
 border-radius: var(--n-border-radius) var(--n-border-radius) 0 0;
 `, [r$2a("img", `
 display: block;
 width: 100%;
 `)]), g$1j("bordered", `
 border: 1px solid var(--n-border-color);
 `, [r$2a("&:target", "border-color: var(--n-color-target);")]), g$1j("action-segmented", [r$2a(">", [M$y("action", [r$2a("&:not(:first-child)", {
  borderTop: "1px solid var(--n-border-color)"
})])])]), g$1j("content-segmented, content-soft-segmented", [r$2a(">", [M$y("content", {
  transition: "border-color 0.3s var(--n-bezier)"
}, [r$2a("&:not(:first-child)", {
  borderTop: "1px solid var(--n-border-color)"
})])])]), g$1j("footer-segmented, footer-soft-segmented", [r$2a(">", [M$y("footer", {
  transition: "border-color 0.3s var(--n-bezier)"
}, [r$2a("&:not(:first-child)", {
  borderTop: "1px solid var(--n-border-color)"
})])])]), g$1j("embedded", `
 background-color: var(--n-color-embedded);
 `)]), C$1a(l$25("card", `
 background: var(--n-color-modal);
 `, [g$1j("embedded", `
 background-color: var(--n-color-embedded-modal);
 `)])), P$V(l$25("card", `
 background: var(--n-color-popover);
 `, [g$1j("embedded", `
 background-color: var(--n-color-embedded-popover);
 `)]))]);
const p$3p = {
  paddingSmall: "12px 16px 12px",
  paddingMedium: "19px 24px 20px",
  paddingLarge: "23px 32px 24px",
  paddingHuge: "27px 40px 28px",
  titleFontSizeSmall: "16px",
  titleFontSizeMedium: "18px",
  titleFontSizeLarge: "18px",
  titleFontSizeHuge: "18px",
  closeIconSize: "18px",
  closeSize: "22px"
};
const v$X = (l3) => {
  const {
    primaryColor: t3,
    borderRadius: e28,
    lineHeight: c3,
    fontSize: o3,
    cardColor: d3,
    textColor2: i,
    textColor1: n3,
    dividerColor: a3,
    fontWeightStrong: s3,
    closeIconColor: m3,
    closeIconColorHover: C3,
    closeIconColorPressed: g3,
    closeColorHover: b3,
    closeColorPressed: f3,
    modalColor: S3,
    boxShadow1: h3,
    popoverColor: p3,
    actionColor: r3
  } = l3;
  return Object.assign(Object.assign({}, p$3p), {
    lineHeight: c3,
    color: d3,
    colorModal: S3,
    colorPopover: p3,
    colorTarget: t3,
    colorEmbedded: r3,
    colorEmbeddedModal: r3,
    colorEmbeddedPopover: r3,
    textColor: i,
    titleTextColor: n3,
    borderColor: a3,
    actionColor: r3,
    titleFontWeight: s3,
    closeColorHover: b3,
    closeColorPressed: f3,
    closeBorderRadius: e28,
    closeIconColor: m3,
    closeIconColorHover: C3,
    closeIconColorPressed: g3,
    fontSizeSmall: o3,
    fontSizeMedium: o3,
    fontSizeLarge: o3,
    fontSizeHuge: o3,
    boxShadow: h3,
    borderRadius: e28
  });
}, z$r = {
  name: "Card",
  common: d$1T,
  self: v$X
}, P$N = z$r;
const p$3o = {
  title: String,
  contentClass: String,
  contentStyle: [Object, String],
  headerClass: String,
  headerStyle: [Object, String],
  headerExtraClass: String,
  headerExtraStyle: [Object, String],
  footerClass: String,
  footerStyle: [Object, String],
  embedded: Boolean,
  segmented: {
    type: [Boolean, Object],
    default: false
  },
  size: {
    type: String,
    default: "medium"
  },
  bordered: {
    type: Boolean,
    default: true
  },
  closable: Boolean,
  hoverable: Boolean,
  role: String,
  onClose: [Function, Array],
  tag: {
    type: String,
    default: "div"
  }
}, pe$g = t$1y(p$3o), te$i = Object.assign(Object.assign({}, _$F.props), p$3o), Ce$a = defineComponent({
  name: "Card",
  props: te$i,
  setup(t3) {
    const i = () => {
      const {
        onClose: o3
      } = t3;
      o3 && i$1Z(o3);
    }, {
      inlineThemeDisabled: d3,
      mergedClsPrefixRef: e28,
      mergedRtlRef: m3
    } = a$2x(t3), s3 = _$F("Card", "-card", c$1H, P$N, t3, e28), f3 = v$17("Card", m3, e28), a3 = computed(() => {
      const {
        size: o3
      } = t3, {
        self: {
          color: c3,
          colorModal: C3,
          colorTarget: u3,
          textColor: v3,
          titleTextColor: S3,
          titleFontWeight: y3,
          borderColor: $3,
          actionColor: x3,
          borderRadius: z3,
          lineHeight: R3,
          closeIconColor: _3,
          closeIconColorHover: B3,
          closeIconColorPressed: E3,
          closeColorHover: P3,
          closeColorPressed: O3,
          closeBorderRadius: j3,
          closeIconSize: T3,
          closeSize: I3,
          boxShadow: k3,
          colorPopover: F3,
          colorEmbedded: H3,
          colorEmbeddedModal: w3,
          colorEmbeddedPopover: M3,
          [_$H("padding", o3)]: V10,
          [_$H("fontSize", o3)]: K3,
          [_$H("titleFontSize", o3)]: L3
        },
        common: {
          cubicBezierEaseInOut: N3
        }
      } = s3.value, {
        top: W3,
        left: A3,
        bottom: D3
      } = f$1f(V10);
      return {
        "--n-bezier": N3,
        "--n-border-radius": z3,
        "--n-color": c3,
        "--n-color-modal": C3,
        "--n-color-popover": F3,
        "--n-color-embedded": H3,
        "--n-color-embedded-modal": w3,
        "--n-color-embedded-popover": M3,
        "--n-color-target": u3,
        "--n-text-color": v3,
        "--n-line-height": R3,
        "--n-action-color": x3,
        "--n-title-text-color": S3,
        "--n-title-font-weight": y3,
        "--n-close-icon-color": _3,
        "--n-close-icon-color-hover": B3,
        "--n-close-icon-color-pressed": E3,
        "--n-close-color-hover": P3,
        "--n-close-color-pressed": O3,
        "--n-border-color": $3,
        "--n-box-shadow": k3,
        "--n-padding-top": W3,
        "--n-padding-bottom": D3,
        "--n-padding-left": A3,
        "--n-font-size": K3,
        "--n-title-font-size": L3,
        "--n-close-size": I3,
        "--n-close-icon-size": T3,
        "--n-close-border-radius": j3
      };
    }), r3 = d3 ? E$J("card", computed(() => t3.size[0]), a3, t3) : void 0;
    return {
      rtlEnabled: f3,
      mergedClsPrefix: e28,
      mergedTheme: s3,
      handleCloseClick: i,
      cssVars: d3 ? void 0 : a3,
      themeClass: r3 == null ? void 0 : r3.themeClass,
      onRender: r3 == null ? void 0 : r3.onRender
    };
  },
  render() {
    const {
      segmented: t3,
      bordered: i,
      hoverable: d3,
      mergedClsPrefix: e28,
      rtlEnabled: m3,
      onRender: s3,
      embedded: f3,
      tag: a3,
      $slots: r3
    } = this;
    return s3 == null || s3(), h$1R(a3, {
      class: [`${e28}-card`, this.themeClass, f3 && `${e28}-card--embedded`, {
        [`${e28}-card--rtl`]: m3,
        [`${e28}-card--content${typeof t3 != "boolean" && t3.content === "soft" ? "-soft" : ""}-segmented`]: t3 === true || t3 !== false && t3.content,
        [`${e28}-card--footer${typeof t3 != "boolean" && t3.footer === "soft" ? "-soft" : ""}-segmented`]: t3 === true || t3 !== false && t3.footer,
        [`${e28}-card--action-segmented`]: t3 === true || t3 !== false && t3.action,
        [`${e28}-card--bordered`]: i,
        [`${e28}-card--hoverable`]: d3
      }],
      style: this.cssVars,
      role: this.role
    }, m$26(r3.cover, (o3) => o3 && h$1R("div", {
      class: `${e28}-card-cover`,
      role: "none"
    }, o3)), m$26(r3.header, (o3) => o3 || this.title || this.closable ? h$1R("div", {
      class: [`${e28}-card-header`, this.headerClass],
      style: this.headerStyle
    }, h$1R("div", {
      class: `${e28}-card-header__main`,
      role: "heading"
    }, o3 || this.title), m$26(r3["header-extra"], (c3) => c3 && h$1R("div", {
      class: [`${e28}-card-header__extra`, this.headerExtraClass],
      style: this.headerExtraStyle
    }, c3)), this.closable ? h$1R(g$1b, {
      clsPrefix: e28,
      class: `${e28}-card-header__close`,
      onClick: this.handleCloseClick,
      absolute: true
    }) : null) : null), m$26(r3.default, (o3) => o3 && h$1R("div", {
      class: [`${e28}-card__content`, this.contentClass],
      style: this.contentStyle,
      role: "none"
    }, o3)), m$26(r3.footer, (o3) => o3 && [h$1R("div", {
      class: [`${e28}-card__footer`, this.footerClass],
      style: this.footerStyle,
      role: "none"
    }, o3)]), m$26(r3.action, (o3) => o3 && h$1R("div", {
      class: `${e28}-card__action`,
      role: "none"
    }, o3)));
  }
});
const e$1q = Object.assign(Object.assign({}, p$3o), o$1d), m$1I = t$1y(e$1q);
const c$1G = r$2a([l$25("dialog", `
 --n-icon-margin: var(--n-icon-margin-top) var(--n-icon-margin-right) var(--n-icon-margin-bottom) var(--n-icon-margin-left);
 word-break: break-word;
 line-height: var(--n-line-height);
 position: relative;
 background: var(--n-color);
 color: var(--n-text-color);
 box-sizing: border-box;
 margin: auto;
 border-radius: var(--n-border-radius);
 padding: var(--n-padding);
 transition: 
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `, [M$y("icon", {
  color: "var(--n-icon-color)"
}), g$1j("bordered", {
  border: "var(--n-border)"
}), g$1j("icon-top", [M$y("close", {
  margin: "var(--n-close-margin)"
}), M$y("icon", {
  margin: "var(--n-icon-margin)"
}), M$y("content", {
  textAlign: "center"
}), M$y("title", {
  justifyContent: "center"
}), M$y("action", {
  justifyContent: "center"
})]), g$1j("icon-left", [M$y("icon", {
  margin: "var(--n-icon-margin)"
}), g$1j("closable", [M$y("title", `
 padding-right: calc(var(--n-close-size) + 6px);
 `)])]), M$y("close", `
 position: absolute;
 right: 0;
 top: 0;
 margin: var(--n-close-margin);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 z-index: 1;
 `), M$y("content", `
 font-size: var(--n-font-size);
 margin: var(--n-content-margin);
 position: relative;
 word-break: break-word;
 `, [g$1j("last", "margin-bottom: 0;")]), M$y("action", `
 display: flex;
 justify-content: flex-end;
 `, [r$2a("> *:not(:last-child)", `
 margin-right: var(--n-action-space);
 `)]), M$y("icon", `
 font-size: var(--n-icon-size);
 transition: color .3s var(--n-bezier);
 `), M$y("title", `
 transition: color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 font-size: var(--n-title-font-size);
 font-weight: var(--n-title-font-weight);
 color: var(--n-title-text-color);
 `), l$25("dialog-icon-container", `
 display: flex;
 justify-content: center;
 `)]), C$1a(l$25("dialog", `
 width: 446px;
 max-width: calc(100vw - 32px);
 `)), l$25("dialog", [v$1a(`
 width: 446px;
 max-width: calc(100vw - 32px);
 `)])]);
const p$3n = {
  titleFontSize: "18px",
  padding: "16px 28px 20px 28px",
  iconSize: "28px",
  actionSpace: "12px",
  contentMargin: "8px 0 16px 0",
  iconMargin: "0 4px 0 0",
  iconMarginIconTop: "4px 0 8px 0",
  closeSize: "22px",
  closeIconSize: "18px",
  closeMargin: "20px 26px 0 0",
  closeMarginIconTop: "10px 16px 0 0"
};
const H$p = (r3) => {
  const {
    textColor1: e28,
    textColor2: t3,
    modalColor: l3,
    closeIconColor: i,
    closeIconColorHover: n3,
    closeIconColorPressed: s3,
    closeColorHover: c3,
    closeColorPressed: C3,
    infoColor: m3,
    successColor: a3,
    warningColor: g3,
    errorColor: d3,
    primaryColor: f3,
    dividerColor: h3,
    borderRadius: o3,
    fontWeightStrong: p3,
    lineHeight: u3,
    fontSize: x3
  } = r3;
  return Object.assign(Object.assign({}, p$3n), {
    fontSize: x3,
    lineHeight: u3,
    border: `1px solid ${h3}`,
    titleTextColor: e28,
    textColor: t3,
    color: l3,
    closeColorHover: c3,
    closeColorPressed: C3,
    closeIconColor: i,
    closeIconColorHover: n3,
    closeIconColorPressed: s3,
    closeBorderRadius: o3,
    iconColor: f3,
    iconColorInfo: m3,
    iconColorSuccess: a3,
    iconColorWarning: g3,
    iconColorError: d3,
    borderRadius: o3,
    titleFontWeight: p3
  });
}, S$G = G$w({
  name: "Dialog",
  common: d$1T,
  peers: {
    Button: B$P
  },
  self: H$p
}), P$M = S$G;
const o$1c = (e28, ...n3) => typeof e28 == "function" ? e28(...n3) : typeof e28 == "string" ? createTextVNode(e28) : typeof e28 == "number" ? createTextVNode(String(e28)) : null;
const n$1f = f$1z("info", h$1R("svg", {
  viewBox: "0 0 28 28",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("g", {
  stroke: "none",
  "stroke-width": "1",
  "fill-rule": "evenodd"
}, h$1R("g", {
  "fill-rule": "nonzero"
}, h$1R("path", {
  d: "M14,2 C20.6274,2 26,7.37258 26,14 C26,20.6274 20.6274,26 14,26 C7.37258,26 2,20.6274 2,14 C2,7.37258 7.37258,2 14,2 Z M14,11 C13.4477,11 13,11.4477 13,12 L13,12 L13,20 C13,20.5523 13.4477,21 14,21 C14.5523,21 15,20.5523 15,20 L15,20 L15,12 C15,11.4477 14.5523,11 14,11 Z M14,6.75 C13.3096,6.75 12.75,7.30964 12.75,8 C12.75,8.69036 13.3096,9.25 14,9.25 C14.6904,9.25 15.25,8.69036 15.25,8 C15.25,7.30964 14.6904,6.75 14,6.75 Z"
})))));
const t$1g = f$1z("success", h$1R("svg", {
  viewBox: "0 0 48 48",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("g", {
  stroke: "none",
  "stroke-width": "1",
  "fill-rule": "evenodd"
}, h$1R("g", {
  "fill-rule": "nonzero"
}, h$1R("path", {
  d: "M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M32.6338835,17.6161165 C32.1782718,17.1605048 31.4584514,17.1301307 30.9676119,17.5249942 L30.8661165,17.6161165 L20.75,27.732233 L17.1338835,24.1161165 C16.6457281,23.6279612 15.8542719,23.6279612 15.3661165,24.1161165 C14.9105048,24.5717282 14.8801307,25.2915486 15.2749942,25.7823881 L15.3661165,25.8838835 L19.8661165,30.3838835 C20.3217282,30.8394952 21.0415486,30.8698693 21.5323881,30.4750058 L21.6338835,30.3838835 L32.6338835,19.3838835 C33.1220388,18.8957281 33.1220388,18.1042719 32.6338835,17.6161165 Z"
})))));
const C$Y = f$1z("warning", h$1R("svg", {
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("g", {
  stroke: "none",
  "stroke-width": "1",
  "fill-rule": "evenodd"
}, h$1R("g", {
  "fill-rule": "nonzero"
}, h$1R("path", {
  d: "M12,2 C17.523,2 22,6.478 22,12 C22,17.522 17.523,22 12,22 C6.477,22 2,17.522 2,12 C2,6.478 6.477,2 12,2 Z M12.0018002,15.0037242 C11.450254,15.0037242 11.0031376,15.4508407 11.0031376,16.0023869 C11.0031376,16.553933 11.450254,17.0010495 12.0018002,17.0010495 C12.5533463,17.0010495 13.0004628,16.553933 13.0004628,16.0023869 C13.0004628,15.4508407 12.5533463,15.0037242 12.0018002,15.0037242 Z M11.99964,7 C11.4868042,7.00018474 11.0642719,7.38637706 11.0066858,7.8837365 L11,8.00036004 L11.0018003,13.0012393 L11.00857,13.117858 C11.0665141,13.6151758 11.4893244,14.0010638 12.0021602,14.0008793 C12.514996,14.0006946 12.9375283,13.6145023 12.9951144,13.1171428 L13.0018002,13.0005193 L13,7.99964009 L12.9932303,7.8830214 C12.9352861,7.38570354 12.5124758,6.99981552 11.99964,7 Z"
})))));
const C$X = f$1z("error", h$1R("svg", {
  viewBox: "0 0 48 48",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("g", {
  stroke: "none",
  "stroke-width": "1",
  "fill-rule": "evenodd"
}, h$1R("g", {
  "fill-rule": "nonzero"
}, h$1R("path", {
  d: "M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M17.8838835,16.1161165 L17.7823881,16.0249942 C17.3266086,15.6583353 16.6733914,15.6583353 16.2176119,16.0249942 L16.1161165,16.1161165 L16.0249942,16.2176119 C15.6583353,16.6733914 15.6583353,17.3266086 16.0249942,17.7823881 L16.1161165,17.8838835 L22.233,24 L16.1161165,30.1161165 L16.0249942,30.2176119 C15.6583353,30.6733914 15.6583353,31.3266086 16.0249942,31.7823881 L16.1161165,31.8838835 L16.2176119,31.9750058 C16.6733914,32.3416647 17.3266086,32.3416647 17.7823881,31.9750058 L17.8838835,31.8838835 L24,25.767 L30.1161165,31.8838835 L30.2176119,31.9750058 C30.6733914,32.3416647 31.3266086,32.3416647 31.7823881,31.9750058 L31.8838835,31.8838835 L31.9750058,31.7823881 C32.3416647,31.3266086 32.3416647,30.6733914 31.9750058,30.2176119 L31.8838835,30.1161165 L25.767,24 L31.8838835,17.8838835 L31.9750058,17.7823881 C32.3416647,17.3266086 32.3416647,16.6733914 31.9750058,16.2176119 L31.8838835,16.1161165 L31.7823881,16.0249942 C31.3266086,15.6583353 30.6733914,15.6583353 30.2176119,16.0249942 L30.1161165,16.1161165 L24,22.233 L17.8838835,16.1161165 L17.7823881,16.0249942 L17.8838835,16.1161165 Z"
})))));
const ae$g = {
  default: () => h$1R(n$1f, null),
  info: () => h$1R(n$1f, null),
  success: () => h$1R(t$1g, null),
  warning: () => h$1R(C$Y, null),
  error: () => h$1R(C$X, null)
}, Be$9 = defineComponent({
  name: "Dialog",
  alias: [
    "NimbusConfirmCard",
    "Confirm"
  ],
  props: Object.assign(Object.assign({}, _$F.props), o$1d),
  setup(t3) {
    const {
      mergedComponentPropsRef: d3,
      mergedClsPrefixRef: c3,
      inlineThemeDisabled: u3,
      mergedRtlRef: x3
    } = a$2x(t3), m3 = v$17("Dialog", x3, c3), g3 = computed(() => {
      var i, n3;
      const {
        iconPlacement: r3
      } = t3;
      return r3 || ((n3 = (i = d3 == null ? void 0 : d3.value) === null || i === void 0 ? void 0 : i.Dialog) === null || n3 === void 0 ? void 0 : n3.iconPlacement) || "left";
    });
    function R3(i) {
      const {
        onPositiveClick: n3
      } = t3;
      n3 && n3(i);
    }
    function f3(i) {
      const {
        onNegativeClick: n3
      } = t3;
      n3 && n3(i);
    }
    function _3() {
      const {
        onClose: i
      } = t3;
      i && i();
    }
    const h3 = _$F("Dialog", "-dialog", c$1G, P$M, t3, c3), v3 = computed(() => {
      const {
        type: i
      } = t3, n3 = g3.value, {
        common: {
          cubicBezierEaseInOut: r3
        },
        self: {
          fontSize: p3,
          lineHeight: C3,
          border: e28,
          titleTextColor: b3,
          textColor: $3,
          color: l3,
          closeBorderRadius: P3,
          closeColorHover: y3,
          closeColorPressed: O3,
          closeIconColor: S3,
          closeIconColorHover: D3,
          closeIconColorPressed: E3,
          closeIconSize: j3,
          borderRadius: H3,
          titleFontWeight: w3,
          titleFontSize: V10,
          padding: W3,
          iconSize: F3,
          actionSpace: K3,
          contentMargin: L3,
          closeSize: q3,
          [n3 === "top" ? "iconMarginIconTop" : "iconMargin"]: A3,
          [n3 === "top" ? "closeMarginIconTop" : "closeMargin"]: G3,
          [_$H("iconColor", i)]: J3
        }
      } = h3.value, I3 = f$1f(A3);
      return {
        "--n-font-size": p3,
        "--n-icon-color": J3,
        "--n-bezier": r3,
        "--n-close-margin": G3,
        "--n-icon-margin-top": I3.top,
        "--n-icon-margin-right": I3.right,
        "--n-icon-margin-bottom": I3.bottom,
        "--n-icon-margin-left": I3.left,
        "--n-icon-size": F3,
        "--n-close-size": q3,
        "--n-close-icon-size": j3,
        "--n-close-border-radius": P3,
        "--n-close-color-hover": y3,
        "--n-close-color-pressed": O3,
        "--n-close-icon-color": S3,
        "--n-close-icon-color-hover": D3,
        "--n-close-icon-color-pressed": E3,
        "--n-color": l3,
        "--n-text-color": $3,
        "--n-border-radius": H3,
        "--n-padding": W3,
        "--n-line-height": C3,
        "--n-border": e28,
        "--n-content-margin": L3,
        "--n-title-font-size": V10,
        "--n-title-font-weight": w3,
        "--n-title-text-color": b3,
        "--n-action-space": K3
      };
    }), s3 = u3 ? E$J("dialog", computed(() => `${t3.type[0]}${g3.value[0]}`), v3, t3) : void 0;
    return {
      mergedClsPrefix: c3,
      rtlEnabled: m3,
      mergedIconPlacement: g3,
      mergedTheme: h3,
      handlePositiveClick: R3,
      handleNegativeClick: f3,
      handleCloseClick: _3,
      cssVars: u3 ? void 0 : v3,
      themeClass: s3 == null ? void 0 : s3.themeClass,
      onRender: s3 == null ? void 0 : s3.onRender
    };
  },
  render() {
    var t3;
    const {
      bordered: d3,
      mergedIconPlacement: c3,
      cssVars: u3,
      closable: x3,
      showIcon: m3,
      title: g3,
      content: R3,
      action: f3,
      negativeText: _3,
      positiveText: h3,
      positiveButtonProps: v3,
      negativeButtonProps: s3,
      handlePositiveClick: i,
      handleNegativeClick: n3,
      mergedTheme: r3,
      loading: p3,
      type: C3,
      mergedClsPrefix: e28
    } = this;
    (t3 = this.onRender) === null || t3 === void 0 || t3.call(this);
    const b3 = m3 ? h$1R(d$1R, {
      clsPrefix: e28,
      class: `${e28}-dialog__icon`
    }, {
      default: () => m$26(this.$slots.icon, (l3) => l3 || (this.icon ? o$1c(this.icon) : ae$g[this.type]()))
    }) : null, $3 = m$26(this.$slots.action, (l3) => l3 || h3 || _3 || f3 ? h$1R("div", {
      class: `${e28}-dialog__action`
    }, l3 || (f3 ? [o$1c(f3)] : [this.negativeText && h$1R(le$g, Object.assign({
      theme: r3.peers.Button,
      themeOverrides: r3.peerOverrides.Button,
      ghost: true,
      size: "small",
      onClick: n3
    }, s3), {
      default: () => o$1c(this.negativeText)
    }), this.positiveText && h$1R(le$g, Object.assign({
      theme: r3.peers.Button,
      themeOverrides: r3.peerOverrides.Button,
      size: "small",
      type: C3 === "default" ? "primary" : C3,
      disabled: p3,
      loading: p3,
      onClick: i
    }, v3), {
      default: () => o$1c(this.positiveText)
    })])) : null);
    return h$1R("div", {
      class: [`${e28}-dialog`, this.themeClass, this.closable && `${e28}-dialog--closable`, `${e28}-dialog--icon-${c3}`, d3 && `${e28}-dialog--bordered`, this.rtlEnabled && `${e28}-dialog--rtl`],
      style: u3,
      role: "dialog"
    }, x3 ? m$26(this.$slots.close, (l3) => {
      const P3 = [`${e28}-dialog__close`, this.rtlEnabled && `${e28}-dialog--rtl`];
      return l3 ? h$1R("div", {
        class: P3
      }, l3) : h$1R(g$1b, {
        clsPrefix: e28,
        class: P3,
        onClick: this.handleCloseClick
      });
    }) : null, m3 && c3 === "top" ? h$1R("div", {
      class: `${e28}-dialog-icon-container`
    }, b3) : null, h$1R("div", {
      class: `${e28}-dialog__title`
    }, m3 && c3 === "left" ? b3 : null, p$3H(this.$slots.header, () => [o$1c(g3)])), h$1R("div", {
      class: [`${e28}-dialog__content`, $3 ? "" : `${e28}-dialog__content--last`]
    }, p$3H(this.$slots.default, () => [o$1c(R3)])), $3);
  }
});
const pe$f = defineComponent({
  name: "ModalBody",
  inheritAttrs: false,
  props: Object.assign(Object.assign({
    show: {
      type: Boolean,
      required: true
    },
    preset: String,
    displayDirective: {
      type: String,
      required: true
    },
    trapFocus: {
      type: Boolean,
      default: true
    },
    autoFocus: {
      type: Boolean,
      default: true
    },
    blockScroll: Boolean
  }, e$1q), {
    renderMask: Function,
    onClickoutside: Function,
    onBeforeLeave: {
      type: Function,
      required: true
    },
    onAfterLeave: {
      type: Function,
      required: true
    },
    onPositiveClick: {
      type: Function,
      required: true
    },
    onNegativeClick: {
      type: Function,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    },
    onAfterEnter: Function,
    onEsc: Function
  }),
  setup(t3) {
    const s3 = ref$1(null), n3 = ref$1(null), l3 = ref$1(t3.show), d3 = ref$1(null), u3 = ref$1(null);
    watch(toRef$1(t3, "show"), (e28) => {
      e28 && (l3.value = true);
    }), y$17(computed(() => t3.blockScroll && l3.value));
    const r3 = inject(t$1M);
    function i() {
      if (r3.transformOriginRef.value === "center")
        return "";
      const {
        value: e28
      } = d3, {
        value: o3
      } = u3;
      if (e28 === null || o3 === null)
        return "";
      if (n3.value) {
        const v3 = n3.value.containerScrollTop;
        return `${e28}px ${o3 + v3}px`;
      }
      return "";
    }
    function f3(e28) {
      if (r3.transformOriginRef.value === "center")
        return;
      const o3 = r3.getMousePosition();
      if (!o3 || !n3.value)
        return;
      const v3 = n3.value.containerScrollTop, {
        offsetLeft: $3,
        offsetTop: w3
      } = e28;
      if (o3) {
        const N3 = o3.y, L3 = o3.x;
        d3.value = -($3 - L3), u3.value = -(w3 - N3 - v3);
      }
      e28.style.transformOrigin = i();
    }
    function m3(e28) {
      nextTick(() => {
        f3(e28);
      });
    }
    function p3(e28) {
      e28.style.transformOrigin = i(), t3.onBeforeLeave();
    }
    function h3() {
      l3.value = false, d3.value = null, u3.value = null, t3.onAfterLeave();
    }
    function b3() {
      const {
        onClose: e28
      } = t3;
      e28 && e28();
    }
    function F3() {
      t3.onNegativeClick();
    }
    function B3() {
      t3.onPositiveClick();
    }
    const y3 = ref$1(null);
    return watch(y3, (e28) => {
      e28 && nextTick(() => {
        const o3 = e28.el;
        o3 && s3.value !== o3 && (s3.value = o3);
      });
    }), provide(e$1M, s3), provide(n$1S, null), provide(n$1T, null), {
      mergedTheme: r3.mergedThemeRef,
      appear: r3.appearRef,
      isMounted: r3.isMountedRef,
      mergedClsPrefix: r3.mergedClsPrefixRef,
      bodyRef: s3,
      scrollbarRef: n3,
      displayed: l3,
      childNodeRef: y3,
      handlePositiveClick: B3,
      handleNegativeClick: F3,
      handleCloseClick: b3,
      handleAfterLeave: h3,
      handleBeforeLeave: p3,
      handleEnter: m3
    };
  },
  render() {
    const {
      $slots: t3,
      $attrs: s3,
      handleEnter: n3,
      handleAfterLeave: l3,
      handleBeforeLeave: d3,
      preset: u3,
      mergedClsPrefix: r3
    } = this;
    let i = null;
    if (!u3) {
      if (i = d$1A(t3), !i) {
        s$2a("modal", "default slot is empty");
        return;
      }
      i = cloneVNode(i), i.props = mergeProps({
        class: `${r3}-modal`
      }, s3, i.props || {});
    }
    return this.displayDirective === "show" || this.displayed || this.show ? withDirectives(h$1R("div", {
      role: "none",
      class: `${r3}-modal-body-wrapper`
    }, h$1R(hn$2, {
      ref: "scrollbarRef",
      theme: this.mergedTheme.peers.Scrollbar,
      themeOverrides: this.mergedTheme.peerOverrides.Scrollbar,
      contentClass: `${r3}-modal-scroll-content`
    }, {
      default: () => {
        var f3;
        return [(f3 = this.renderMask) === null || f3 === void 0 ? void 0 : f3.call(this), h$1R(V$x, {
          disabled: !this.trapFocus,
          active: this.show,
          onEsc: this.onEsc,
          autoFocus: this.autoFocus
        }, {
          default: () => {
            var m3;
            return h$1R(Transition, {
              name: "fade-in-scale-up-transition",
              appear: (m3 = this.appear) !== null && m3 !== void 0 ? m3 : this.isMounted,
              onEnter: n3,
              onAfterEnter: this.onAfterEnter,
              onAfterLeave: l3,
              onBeforeLeave: d3
            }, {
              default: () => {
                const p3 = [[vShow, this.show]], {
                  onClickoutside: h3
                } = this;
                return h3 && p3.push([a$2i, this.onClickoutside, void 0, {
                  capture: true
                }]), withDirectives(this.preset === "confirm" || this.preset === "dialog" ? h$1R(Be$9, Object.assign({}, this.$attrs, {
                  class: [`${r3}-modal`, this.$attrs.class],
                  ref: "bodyRef",
                  theme: this.mergedTheme.peers.Dialog,
                  themeOverrides: this.mergedTheme.peerOverrides.Dialog
                }, r$1C(this.$props, e$1r), {
                  "aria-modal": "true"
                }), t3) : this.preset === "card" ? h$1R(Ce$a, Object.assign({}, this.$attrs, {
                  ref: "bodyRef",
                  class: [`${r3}-modal`, this.$attrs.class],
                  theme: this.mergedTheme.peers.Card,
                  themeOverrides: this.mergedTheme.peerOverrides.Card
                }, r$1C(this.$props, pe$g), {
                  "aria-modal": "true",
                  role: "dialog"
                }), t3) : this.childNodeRef = i, p3);
              }
            });
          }
        })];
      }
    })), [[vShow, this.displayDirective === "if" || this.displayed || this.show]]) : null;
  }
});
const {
  cubicBezierEaseIn: i$1u,
  cubicBezierEaseOut: s$1G
} = e$2d;
function $$n({
  transformOrigin: c3 = "inherit",
  duration: e28 = ".2s",
  enterScale: o3 = ".9",
  originalTransform: n3 = "",
  originalTransition: t3 = ""
} = {}) {
  return [r$2a("&.fade-in-scale-up-transition-leave-active", {
    transformOrigin: c3,
    transition: `opacity ${e28} ${i$1u}, transform ${e28} ${i$1u} ${t3 && "," + t3}`
  }), r$2a("&.fade-in-scale-up-transition-enter-active", {
    transformOrigin: c3,
    transition: `opacity ${e28} ${s$1G}, transform ${e28} ${s$1G} ${t3 && "," + t3}`
  }), r$2a("&.fade-in-scale-up-transition-enter-from, &.fade-in-scale-up-transition-leave-to", {
    opacity: 0,
    transform: `${n3} scale(${o3})`
  }), r$2a("&.fade-in-scale-up-transition-leave-from, &.fade-in-scale-up-transition-enter-to", {
    opacity: 1,
    transform: `${n3} scale(1)`
  })];
}
const l$1w = r$2a([l$25("modal-container", `
 position: fixed;
 left: 0;
 top: 0;
 height: 0;
 width: 0;
 display: flex;
 `), l$25("modal-mask", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 background-color: rgba(0, 0, 0, .4);
 `, [l$1T({
  enterDuration: ".25s",
  leaveDuration: ".25s",
  enterCubicBezier: "var(--n-bezier-ease-out)",
  leaveCubicBezier: "var(--n-bezier-ease-out)"
})]), l$25("modal-body-wrapper", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 overflow: visible;
 `, [l$25("modal-scroll-content", `
 min-height: 100%;
 display: flex;
 position: relative;
 `)]), l$25("modal", `
 position: relative;
 align-self: center;
 color: var(--n-text-color);
 margin: auto;
 box-shadow: var(--n-box-shadow);
 `, [$$n({
  duration: ".25s",
  enterScale: ".5"
})])]);
const T$H = ref$1(void 0);
let e$1p = 0;
function a$1N() {
  T$H.value = Date.now();
}
let d$1t = true;
function h$1r(s3) {
  if (!r$1E)
    return readonly(ref$1(false));
  const n3 = ref$1(false);
  let i = null;
  function t3() {
    i !== null && window.clearTimeout(i);
  }
  function l3() {
    t3(), n3.value = true, i = window.setTimeout(() => {
      n3.value = false;
    }, s3);
  }
  e$1p === 0 && J$o("click", window, a$1N, true);
  const r3 = () => {
    e$1p += 1, J$o("click", window, l3, true);
  };
  return d$1t && (d$1t = t$1m()) ? (onBeforeMount(r3), onBeforeUnmount(() => {
    e$1p -= 1, e$1p === 0 && K$p("click", window, a$1N, true), K$p("click", window, l3, true), t3();
  })) : r3(), readonly(n3);
}
const t$1f = ref$1(null);
function c$1F(e28) {
  if (e28.clientX > 0 || e28.clientY > 0)
    t$1f.value = {
      x: e28.clientX,
      y: e28.clientY
    };
  else {
    const { target: o3 } = e28;
    if (o3 instanceof Element) {
      const { left: l3, top: i, width: s3, height: a3 } = o3.getBoundingClientRect();
      l3 > 0 || i > 0 ? t$1f.value = {
        x: l3 + s3 / 2,
        y: i + a3 / 2
      } : t$1f.value = { x: 0, y: 0 };
    } else
      t$1f.value = null;
  }
}
let n$1e = 0, r$1y = true;
function B$F() {
  if (!r$1E)
    return readonly(ref$1(null));
  n$1e === 0 && J$o("click", document, c$1F, true);
  const e28 = () => {
    n$1e += 1;
  };
  return r$1y && (r$1y = t$1m()) ? (onBeforeMount(e28), onBeforeUnmount(() => {
    n$1e -= 1, n$1e === 0 && K$p("click", document, c$1F, true);
  })) : e28(), readonly(t$1f);
}
const d$1s = (o3) => {
  const {
    modalColor: r3,
    textColor2: t3,
    boxShadow3: m3
  } = o3;
  return {
    color: r3,
    textColor: t3,
    boxShadow: m3
  };
}, h$1q = G$w({
  name: "Modal",
  common: d$1T,
  peers: {
    Scrollbar: n$1N,
    Dialog: P$M,
    Card: P$N
  },
  self: d$1s
}), L$C = h$1q;
const ne$h = Object.assign(Object.assign(Object.assign(Object.assign({}, _$F.props), {
  show: Boolean,
  unstableShowMask: {
    type: Boolean,
    default: true
  },
  maskClosable: {
    type: Boolean,
    default: true
  },
  preset: String,
  to: [String, Object],
  displayDirective: {
    type: String,
    default: "if"
  },
  transformOrigin: {
    type: String,
    default: "mouse"
  },
  zIndex: Number,
  autoFocus: {
    type: Boolean,
    default: true
  },
  trapFocus: {
    type: Boolean,
    default: true
  },
  closeOnEsc: {
    type: Boolean,
    default: true
  },
  blockScroll: {
    type: Boolean,
    default: true
  }
}), e$1q), {
  onEsc: Function,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onAfterEnter: Function,
  onBeforeLeave: Function,
  onAfterLeave: Function,
  onClose: Function,
  onPositiveClick: Function,
  onNegativeClick: Function,
  onMaskClick: Function,
  internalDialog: Boolean,
  internalModal: Boolean,
  internalAppear: {
    type: Boolean,
    default: void 0
  },
  overlayStyle: [String, Object],
  onBeforeHide: Function,
  onAfterHide: Function,
  onHide: Function
}), Fe$7 = defineComponent({
  name: "Modal",
  inheritAttrs: false,
  props: ne$h,
  setup(o3) {
    const s3 = ref$1(null), {
      mergedClsPrefixRef: a3,
      namespaceRef: l3,
      inlineThemeDisabled: m3
    } = a$2x(o3), h3 = _$F("Modal", "-modal", l$1w, L$C, o3, a3), P3 = h$1r(64), b3 = B$F(), v3 = u$1C(), B3 = o3.internalDialog ? inject(r$1z, null) : null, R3 = o3.internalModal ? inject(d$1Q, null) : null, F3 = f$1F();
    function i(e28) {
      const {
        onUpdateShow: t3,
        "onUpdate:show": n3,
        onHide: c3
      } = o3;
      t3 && i$1Z(t3, e28), n3 && i$1Z(n3, e28), c3 && !e28 && c3(e28);
    }
    function S3() {
      const {
        onClose: e28
      } = o3;
      e28 ? Promise.resolve(e28()).then((t3) => {
        t3 !== false && i(false);
      }) : i(false);
    }
    function w3() {
      const {
        onPositiveClick: e28
      } = o3;
      e28 ? Promise.resolve(e28()).then((t3) => {
        t3 !== false && i(false);
      }) : i(false);
    }
    function A3() {
      const {
        onNegativeClick: e28
      } = o3;
      e28 ? Promise.resolve(e28()).then((t3) => {
        t3 !== false && i(false);
      }) : i(false);
    }
    function M3() {
      const {
        onBeforeLeave: e28,
        onBeforeHide: t3
      } = o3;
      e28 && i$1Z(e28), t3 && t3();
    }
    function E3() {
      const {
        onAfterLeave: e28,
        onAfterHide: t3
      } = o3;
      e28 && i$1Z(e28), t3 && t3();
    }
    function O3(e28) {
      var t3;
      const {
        onMaskClick: n3
      } = o3;
      n3 && n3(e28), o3.maskClosable && !((t3 = s3.value) === null || t3 === void 0) && t3.contains(t$1G(e28)) && i(false);
    }
    function N3(e28) {
      var t3;
      (t3 = o3.onEsc) === null || t3 === void 0 || t3.call(o3), o3.show && o3.closeOnEsc && f$1G(e28) && !F3.value && i(false);
    }
    provide(t$1M, {
      getMousePosition: () => {
        const e28 = B3 || R3;
        if (e28) {
          const {
            clickedRef: t3,
            clickedPositionRef: n3
          } = e28;
          if (t3.value && n3.value)
            return n3.value;
        }
        return P3.value ? b3.value : null;
      },
      mergedClsPrefixRef: a3,
      mergedThemeRef: h3,
      isMountedRef: v3,
      appearRef: toRef$1(o3, "internalAppear"),
      transformOriginRef: toRef$1(o3, "transformOrigin")
    });
    const p3 = computed(() => {
      const {
        common: {
          cubicBezierEaseOut: e28
        },
        self: {
          boxShadow: t3,
          color: n3,
          textColor: c3
        }
      } = h3.value;
      return {
        "--n-bezier-ease-out": e28,
        "--n-box-shadow": t3,
        "--n-color": n3,
        "--n-text-color": c3
      };
    }), r3 = m3 ? E$J("theme-class", void 0, p3, o3) : void 0;
    return {
      mergedClsPrefix: a3,
      namespace: l3,
      isMounted: v3,
      containerRef: s3,
      presetProps: computed(() => r$1C(o3, m$1I)),
      handleEsc: N3,
      handleAfterLeave: E3,
      handleClickoutside: O3,
      handleBeforeLeave: M3,
      doUpdateShow: i,
      handleNegativeClick: A3,
      handlePositiveClick: w3,
      handleCloseClick: S3,
      cssVars: m3 ? void 0 : p3,
      themeClass: r3 == null ? void 0 : r3.themeClass,
      onRender: r3 == null ? void 0 : r3.onRender
    };
  },
  render() {
    const {
      mergedClsPrefix: o3
    } = this;
    return h$1R(h$1D, {
      to: this.to,
      show: this.show
    }, {
      default: () => {
        var s3;
        (s3 = this.onRender) === null || s3 === void 0 || s3.call(this);
        const {
          unstableShowMask: a3
        } = this;
        return withDirectives(h$1R("div", {
          role: "none",
          ref: "containerRef",
          class: [`${o3}-modal-container`, this.themeClass, this.namespace],
          style: this.cssVars
        }, h$1R(pe$f, Object.assign({
          style: this.overlayStyle
        }, this.$attrs, {
          ref: "bodyWrapper",
          displayDirective: this.displayDirective,
          show: this.show,
          preset: this.preset,
          autoFocus: this.autoFocus,
          trapFocus: this.trapFocus,
          blockScroll: this.blockScroll
        }, this.presetProps, {
          onEsc: this.handleEsc,
          onClose: this.handleCloseClick,
          onNegativeClick: this.handleNegativeClick,
          onPositiveClick: this.handlePositiveClick,
          onBeforeLeave: this.handleBeforeLeave,
          onAfterEnter: this.onAfterEnter,
          onAfterLeave: this.handleAfterLeave,
          onClickoutside: a3 ? void 0 : this.handleClickoutside,
          renderMask: a3 ? () => {
            var l3;
            return h$1R(Transition, {
              name: "fade-in-transition",
              key: "mask",
              appear: (l3 = this.internalAppear) !== null && l3 !== void 0 ? l3 : this.isMounted
            }, {
              default: () => this.show ? h$1R("div", {
                "aria-hidden": true,
                ref: "containerRef",
                class: `${o3}-modal-mask`,
                onClick: this.handleClickoutside
              }) : null
            });
          } : void 0
        }), this.$slots)), [[r$1O, {
          zIndex: this.zIndex,
          enabled: this.show
        }]]);
      }
    });
  }
});
const w$J = defineComponent({
  name: "UIModal",
  inheritAttrs: false
}), y$Y = defineComponent(__spreadProps(__spreadValues({}, w$J), {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 544
    },
    zIndex: {
      type: Number,
      default: void 0
    },
    to: {
      type: String,
      default: "body"
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ""
    },
    maskClosable: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:show"],
  setup(e28) {
    return (t3, l3) => (openBlock(), createBlock(unref(Fe$7), {
      show: e28.show,
      "onUpdate:show": l3[0] || (l3[0] = (r3) => t3.$emit("update:show", r3)),
      "z-index": e28.zIndex,
      "auto-focus": e28.autoFocus,
      to: e28.to,
      "mask-closable": e28.maskClosable
    }, {
      default: withCtx(() => [
        createVNode(unref(Ce$a), {
          style: normalizeStyle({ width: `${e28.width}px` }),
          bordered: false,
          size: "huge",
          role: "dialog",
          "aria-modal": "true",
          class: normalizeClass(["hl-modal", e28.className])
        }, {
          header: withCtx(() => [
            renderSlot(t3.$slots, "header")
          ]),
          footer: withCtx(() => [
            renderSlot(t3.$slots, "footer")
          ]),
          default: withCtx(() => [
            renderSlot(t3.$slots, "default")
          ]),
          _: 3
        }, 8, ["style", "class"])
      ]),
      _: 3
    }, 8, ["show", "z-index", "auto-focus", "to", "mask-closable"]));
  }
})), k$G = y$Y;
function c$1E(t3, n3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17 7L7 17M7 7l10 10"
    })
  ]);
}
const w$I = { class: "hl-modal-heading" }, B$E = { key: 0 }, D$F = { key: 1 }, H$o = {
  key: 0,
  class: "hl-icon-container"
}, N$B = { class: "action" }, V$s = { class: "title" }, q$v = {
  key: 0,
  class: "action"
}, b$Z = { key: 1 }, E$B = {
  key: 2,
  class: "description"
}, I$z = defineComponent({
  __name: "ModalHeader",
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    icon: {
      type: Function,
      default: void 0
    },
    type: {
      type: String,
      default: "primary"
    }
  },
  emits: ["close"],
  setup(e28) {
    const f3 = {
      custom: "icon-custom",
      success: "icon-success",
      error: "icon-error",
      warning: "icon-warning",
      primary: "icon-primary"
    }, l3 = useSlots();
    return (n3, s3) => (openBlock(), createElementBlock("div", w$I, [
      unref(l3).customHeader ? (openBlock(), createElementBlock("div", B$E, [
        renderSlot(n3.$slots, "customHeader")
      ])) : (openBlock(), createElementBlock("div", D$F, [
        e28.icon ? (openBlock(), createElementBlock("div", H$o, [
          createElementVNode("div", {
            class: normalizeClass(["icon", f3[e28.type]])
          }, [
            (openBlock(), createBlock(resolveDynamicComponent(e28.icon)))
          ], 2),
          createElementVNode("div", N$B, [
            createVNode(unref(q$C), {
              circle: "",
              quaternary: "",
              onClick: s3[0] || (s3[0] = (p3) => n3.$emit("close")),
              id: `${e28.id}-modal-close-btn`
            }, {
              default: withCtx(() => [
                createVNode(unref(c$1E), { class: "w-5 h-5" })
              ]),
              _: 1
            }, 8, ["id"])
          ])
        ])) : createCommentVNode("", true),
        createElementVNode("div", V$s, [
          createTextVNode(toDisplayString(e28.title) + " ", 1),
          e28.icon ? createCommentVNode("", true) : (openBlock(), createElementBlock("div", q$v, [
            createVNode(unref(q$C), {
              circle: "",
              quaternary: "",
              onClick: s3[1] || (s3[1] = (p3) => n3.$emit("close")),
              id: `${e28.id}-modal-close-btn`
            }, {
              default: withCtx(() => [
                createVNode(unref(c$1E), { class: "w-6 h-6" })
              ]),
              _: 1
            }, 8, ["id"])
          ]))
        ]),
        unref(l3).customDescription ? (openBlock(), createElementBlock("div", b$Z, [
          renderSlot(n3.$slots, "customDescription")
        ])) : e28.description ? (openBlock(), createElementBlock("div", E$B, toDisplayString(e28.description), 1)) : createCommentVNode("", true)
      ]))
    ]));
  }
}), z$q = I$z;
const b$Y = { class: "hl-modal-footer-actions" }, C$W = { class: "action-left" }, T$G = { class: "action-right" };
defineComponent({
  name: "UIModalFooter"
});
const h$1p = defineComponent({
  __name: "ModalFooter",
  props: {
    id: {
      type: String,
      required: true
    },
    positiveText: {
      type: String,
      default: ""
    },
    negativeText: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "primary"
    }
  },
  setup(e28) {
    const v3 = useSlots(), y3 = computed(() => !!v3.actionRight);
    return (t3, i) => (openBlock(), createElementBlock("div", b$Y, [
      createElementVNode("div", C$W, [
        renderSlot(t3.$slots, "actionLeft")
      ]),
      createElementVNode("div", T$G, [
        renderSlot(t3.$slots, "actionRight"),
        y3.value ? createCommentVNode("", true) : (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          e28.negativeText ? (openBlock(), createBlock(unref(q$C), {
            key: 0,
            onClick: i[0] || (i[0] = (p3) => t3.$emit("negativeClick")),
            id: `${e28.id}-btn-negative-action`
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(e28.negativeText), 1)
            ]),
            _: 1
          }, 8, ["id"])) : createCommentVNode("", true),
          e28.positiveText ? (openBlock(), createBlock(unref(q$C), {
            key: 1,
            loading: e28.loading,
            disabled: e28.disabled,
            type: e28.type,
            id: `${e28.id}-btn-positive-action`,
            onClick: i[1] || (i[1] = (p3) => t3.$emit("positiveClick"))
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(e28.positiveText), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled", "type", "id"])) : createCommentVNode("", true)
        ], 64))
      ])
    ]));
  }
}), E$A = h$1p;
const l$1v = { class: "hl-modal-content" };
defineComponent({
  name: "UIModalContent"
});
const r$1x = defineComponent({
  __name: "ModalContent",
  setup(s3) {
    return (e28, c3) => (openBlock(), createElementBlock("div", l$1v, [
      renderSlot(e28.$slots, "default")
    ]));
  }
}), _$x = r$1x;
const T$F = {
  name: String,
  value: {
    type: [String, Number, Boolean],
    default: "on"
  },
  checked: {
    type: Boolean,
    default: void 0
  },
  defaultChecked: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  },
  label: String,
  size: String,
  onUpdateChecked: [Function, Array],
  "onUpdate:checked": [Function, Array],
  checkedValue: {
    type: Boolean,
    default: void 0
  }
}, E$z = n$28("n-radio-group");
function _$w(d3) {
  const l3 = h$1B(d3, {
    mergedSize(e28) {
      const {
        size: t3
      } = d3;
      if (t3 !== void 0)
        return t3;
      if (n3) {
        const {
          mergedSizeRef: {
            value: r3
          }
        } = n3;
        if (r3 !== void 0)
          return r3;
      }
      return e28 ? e28.mergedSize.value : "medium";
    },
    mergedDisabled(e28) {
      return !!(d3.disabled || n3 != null && n3.disabledRef.value || e28 != null && e28.disabled.value);
    }
  }), {
    mergedSizeRef: g3,
    mergedDisabledRef: c3
  } = l3, i = ref$1(null), h3 = ref$1(null), n3 = inject(E$z, null), s3 = ref$1(d3.defaultChecked), v3 = toRef$1(d3, "checked"), R3 = d$1S(v3, s3), o3 = n$1U(() => n3 ? n3.valueRef.value === d3.value : R3.value), k3 = n$1U(() => {
    const {
      name: e28
    } = d3;
    if (e28 !== void 0)
      return e28;
    if (n3)
      return n3.nameRef.value;
  }), a3 = ref$1(false);
  function C3() {
    if (n3) {
      const {
        doUpdateValue: e28
      } = n3, {
        value: t3
      } = d3;
      i$1Z(e28, t3);
    } else {
      const {
        onUpdateChecked: e28,
        "onUpdate:checked": t3
      } = d3, {
        nTriggerFormInput: r3,
        nTriggerFormChange: z3
      } = l3;
      e28 && i$1Z(e28, true), t3 && i$1Z(t3, true), r3(), z3(), s3.value = true;
    }
  }
  function p3() {
    c3.value || o3.value || C3();
  }
  function S3() {
    p3(), i.value && (i.value.checked = o3.value);
  }
  function b3() {
    a3.value = false;
  }
  function y3() {
    a3.value = true;
  }
  return {
    mergedClsPrefix: n3 ? n3.mergedClsPrefixRef : a$2x(d3).mergedClsPrefixRef,
    inputRef: i,
    labelRef: h3,
    mergedName: k3,
    mergedDisabled: c3,
    renderSafeChecked: o3,
    focus: a3,
    mergedSize: g3,
    handleRadioInputChange: S3,
    handleRadioInputBlur: b3,
    handleRadioInputFocus: y3
  };
}
const n$1d = l$25("radio", `
 line-height: var(--n-label-line-height);
 outline: none;
 position: relative;
 user-select: none;
 -webkit-user-select: none;
 display: inline-flex;
 align-items: flex-start;
 flex-wrap: nowrap;
 font-size: var(--n-font-size);
 word-break: break-word;
`, [g$1j("checked", [M$y("dot", `
 background-color: var(--n-color-active);
 `)]), M$y("dot-wrapper", `
 position: relative;
 flex-shrink: 0;
 flex-grow: 0;
 width: var(--n-radio-size);
 `), l$25("radio-input", `
 position: absolute;
 border: 0;
 border-radius: inherit;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 opacity: 0;
 z-index: 1;
 cursor: pointer;
 `), M$y("dot", `
 position: absolute;
 top: 50%;
 left: 0;
 transform: translateY(-50%);
 height: var(--n-radio-size);
 width: var(--n-radio-size);
 background: var(--n-color);
 box-shadow: var(--n-box-shadow);
 border-radius: 50%;
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 `, [r$2a("&::before", `
 content: "";
 opacity: 0;
 position: absolute;
 left: 4px;
 top: 4px;
 height: calc(100% - 8px);
 width: calc(100% - 8px);
 border-radius: 50%;
 transform: scale(.8);
 background: var(--n-dot-color-active);
 transition: 
 opacity .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 transform .3s var(--n-bezier);
 `), g$1j("checked", {
  boxShadow: "var(--n-box-shadow-active)"
}, [r$2a("&::before", `
 opacity: 1;
 transform: scale(1);
 `)])]), M$y("label", `
 color: var(--n-text-color);
 padding: var(--n-label-padding);
 font-weight: var(--n-label-font-weight);
 display: inline-block;
 transition: color .3s var(--n-bezier);
 `), x$I("disabled", `
 cursor: pointer;
 `, [r$2a("&:hover", [M$y("dot", {
  boxShadow: "var(--n-box-shadow-hover)"
})]), g$1j("focus", [r$2a("&:not(:active)", [M$y("dot", {
  boxShadow: "var(--n-box-shadow-focus)"
})])])]), g$1j("disabled", `
 cursor: not-allowed;
 `, [M$y("dot", {
  boxShadow: "var(--n-box-shadow-disabled)",
  backgroundColor: "var(--n-color-disabled)"
}, [r$2a("&::before", {
  backgroundColor: "var(--n-dot-color-disabled)"
}), g$1j("checked", `
 opacity: 1;
 `)]), M$y("label", {
  color: "var(--n-text-color-disabled)"
}), l$25("radio-input", `
 cursor: not-allowed;
 `)])]);
const a$1M = {
  radioSizeSmall: "14px",
  radioSizeMedium: "16px",
  radioSizeLarge: "18px",
  labelPadding: "0 8px",
  labelFontWeight: "400"
};
const S$F = (a3) => {
  const {
    borderColor: t3,
    primaryColor: o3,
    baseColor: e28,
    textColorDisabled: l3,
    inputColorDisabled: n3,
    textColor2: r3,
    opacityDisabled: b3,
    borderRadius: d3,
    fontSizeSmall: s3,
    fontSizeMedium: h3,
    fontSizeLarge: u3,
    heightSmall: x3,
    heightMedium: c3,
    heightLarge: m3,
    lineHeight: p3
  } = a3;
  return Object.assign(Object.assign({}, a$1M), {
    labelLineHeight: p3,
    buttonHeightSmall: x3,
    buttonHeightMedium: c3,
    buttonHeightLarge: m3,
    fontSizeSmall: s3,
    fontSizeMedium: h3,
    fontSizeLarge: u3,
    boxShadow: `inset 0 0 0 1px ${t3}`,
    boxShadowActive: `inset 0 0 0 1px ${o3}`,
    boxShadowFocus: `inset 0 0 0 1px ${o3}, 0 0 0 2px ${J$p(o3, {
      alpha: 0.2
    })}`,
    boxShadowHover: `inset 0 0 0 1px ${o3}`,
    boxShadowDisabled: `inset 0 0 0 1px ${t3}`,
    color: e28,
    colorDisabled: n3,
    colorActive: "#0000",
    textColor: r3,
    textColorDisabled: l3,
    dotColorActive: o3,
    dotColorDisabled: t3,
    buttonBorderColor: t3,
    buttonBorderColorActive: o3,
    buttonBorderColorHover: t3,
    buttonColor: e28,
    buttonColorActive: e28,
    buttonTextColor: r3,
    buttonTextColorActive: o3,
    buttonTextColorHover: o3,
    opacityDisabled: b3,
    buttonBoxShadowFocus: `inset 0 0 0 1px ${o3}, 0 0 0 2px ${J$p(o3, {
      alpha: 0.3
    })}`,
    buttonBoxShadowHover: "inset 0 0 0 1px #0000",
    buttonBoxShadow: "inset 0 0 0 1px #0000",
    buttonBorderRadius: d3
  });
}, v$W = {
  name: "Radio",
  common: d$1T,
  self: S$F
}, w$H = v$W;
const L$B = Object.assign(Object.assign({}, _$F.props), T$F), Y$l = defineComponent({
  name: "Radio",
  props: L$B,
  setup(o3) {
    const e28 = _$w(o3), d3 = _$F("Radio", "-radio", n$1d, w$H, o3, e28.mergedClsPrefix), a3 = computed(() => {
      const {
        mergedSize: {
          value: t3
        }
      } = e28, {
        common: {
          cubicBezierEaseInOut: b3
        },
        self: {
          boxShadow: f3,
          boxShadowActive: p3,
          boxShadowDisabled: v3,
          boxShadowFocus: g3,
          boxShadowHover: C3,
          color: R3,
          colorDisabled: x3,
          colorActive: S3,
          textColor: w3,
          textColorDisabled: z3,
          dotColorActive: $3,
          dotColorDisabled: _3,
          labelPadding: D3,
          labelLineHeight: k3,
          labelFontWeight: P3,
          [_$H("fontSize", t3)]: y3,
          [_$H("radioSize", t3)]: A3
        }
      } = d3.value;
      return {
        "--n-bezier": b3,
        "--n-label-line-height": k3,
        "--n-label-font-weight": P3,
        "--n-box-shadow": f3,
        "--n-box-shadow-active": p3,
        "--n-box-shadow-disabled": v3,
        "--n-box-shadow-focus": g3,
        "--n-box-shadow-hover": C3,
        "--n-color": R3,
        "--n-color-active": S3,
        "--n-color-disabled": x3,
        "--n-dot-color-active": $3,
        "--n-dot-color-disabled": _3,
        "--n-font-size": y3,
        "--n-radio-size": A3,
        "--n-text-color": w3,
        "--n-text-color-disabled": z3,
        "--n-label-padding": D3
      };
    }), {
      inlineThemeDisabled: r3,
      mergedClsPrefixRef: h3,
      mergedRtlRef: m3
    } = a$2x(o3), u3 = v$17("Radio", m3, h3), i = r3 ? E$J("radio", computed(() => e28.mergedSize.value[0]), a3, o3) : void 0;
    return Object.assign(e28, {
      rtlEnabled: u3,
      cssVars: r3 ? void 0 : a3,
      themeClass: i == null ? void 0 : i.themeClass,
      onRender: i == null ? void 0 : i.onRender
    });
  },
  render() {
    const {
      $slots: o3,
      mergedClsPrefix: e28,
      onRender: d3,
      label: a3
    } = this;
    return d3 == null || d3(), h$1R("label", {
      class: [`${e28}-radio`, this.themeClass, this.rtlEnabled && `${e28}-radio--rtl`, this.mergedDisabled && `${e28}-radio--disabled`, this.renderSafeChecked && `${e28}-radio--checked`, this.focus && `${e28}-radio--focus`],
      style: this.cssVars
    }, h$1R("input", {
      ref: "inputRef",
      type: "radio",
      class: `${e28}-radio-input`,
      value: this.value,
      name: this.mergedName,
      checked: this.renderSafeChecked,
      disabled: this.mergedDisabled,
      onChange: this.handleRadioInputChange,
      onFocus: this.handleRadioInputFocus,
      onBlur: this.handleRadioInputBlur
    }), h$1R("div", {
      class: `${e28}-radio__dot-wrapper`
    }, "\xA0", h$1R("div", {
      class: [`${e28}-radio__dot`, this.renderSafeChecked && `${e28}-radio__dot--checked`]
    })), m$26(o3.default, (r3) => !r3 && !a3 ? null : h$1R("div", {
      ref: "labelRef",
      class: `${e28}-radio__label`
    }, r3 || a3)));
  }
});
const f$1d = defineComponent({
  name: "UIRadio",
  inheritAttrs: false
}), b$X = defineComponent(__spreadProps(__spreadValues({}, f$1d), {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Boolean]
    },
    name: {
      type: String
    },
    label: {
      type: String
    },
    checked: {
      type: Boolean
    },
    id: {
      type: String,
      required: true
    }
  },
  emits: ["change", "checked", "value"],
  setup(e28) {
    return (t3, a3) => (openBlock(), createBlock(unref(Y$l), mergeProps({
      id: e28.id,
      disabled: e28.disabled,
      label: e28.label,
      value: e28.value,
      name: e28.name
    }, t3.$attrs, {
      checked: e28.checked,
      onChange: a3[0] || (a3[0] = (l3) => t3.$emit("change", l3)),
      onChecked: a3[1] || (a3[1] = (l3) => t3.$emit("checked", l3)),
      "onUpdate:value": a3[2] || (a3[2] = (l3) => t3.$emit("value", l3)),
      size: "large"
    }), {
      default: withCtx(() => [
        renderSlot(t3.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "disabled", "label", "value", "name", "checked"]));
  }
})), c$1D = b$X;
const a$1L = l$25("radio-group", `
 display: inline-block;
 font-size: var(--n-font-size);
`, [M$y("splitor", `
 display: inline-block;
 vertical-align: bottom;
 width: 1px;
 transition:
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 background: var(--n-button-border-color);
 `, [g$1j("checked", {
  backgroundColor: "var(--n-button-border-color-active)"
}), g$1j("disabled", {
  opacity: "var(--n-opacity-disabled)"
})]), g$1j("button-group", `
 white-space: nowrap;
 height: var(--n-height);
 line-height: var(--n-height);
 `, [l$25("radio-button", {
  height: "var(--n-height)",
  lineHeight: "var(--n-height)"
}), M$y("splitor", {
  height: "var(--n-height)"
})]), l$25("radio-button", `
 vertical-align: bottom;
 outline: none;
 position: relative;
 user-select: none;
 -webkit-user-select: none;
 display: inline-block;
 box-sizing: border-box;
 padding-left: 14px;
 padding-right: 14px;
 white-space: nowrap;
 transition:
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 background: var(--n-button-color);
 color: var(--n-button-text-color);
 border-top: 1px solid var(--n-button-border-color);
 border-bottom: 1px solid var(--n-button-border-color);
 `, [l$25("radio-input", `
 pointer-events: none;
 position: absolute;
 border: 0;
 border-radius: inherit;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 opacity: 0;
 z-index: 1;
 `), M$y("state-border", `
 z-index: 1;
 pointer-events: none;
 position: absolute;
 box-shadow: var(--n-button-box-shadow);
 transition: box-shadow .3s var(--n-bezier);
 left: -1px;
 bottom: -1px;
 right: -1px;
 top: -1px;
 `), r$2a("&:first-child", `
 border-top-left-radius: var(--n-button-border-radius);
 border-bottom-left-radius: var(--n-button-border-radius);
 border-left: 1px solid var(--n-button-border-color);
 `, [M$y("state-border", `
 border-top-left-radius: var(--n-button-border-radius);
 border-bottom-left-radius: var(--n-button-border-radius);
 `)]), r$2a("&:last-child", `
 border-top-right-radius: var(--n-button-border-radius);
 border-bottom-right-radius: var(--n-button-border-radius);
 border-right: 1px solid var(--n-button-border-color);
 `, [M$y("state-border", `
 border-top-right-radius: var(--n-button-border-radius);
 border-bottom-right-radius: var(--n-button-border-radius);
 `)]), x$I("disabled", `
 cursor: pointer;
 `, [r$2a("&:hover", [M$y("state-border", `
 transition: box-shadow .3s var(--n-bezier);
 box-shadow: var(--n-button-box-shadow-hover);
 `), x$I("checked", {
  color: "var(--n-button-text-color-hover)"
})]), g$1j("focus", [r$2a("&:not(:active)", [M$y("state-border", {
  boxShadow: "var(--n-button-box-shadow-focus)"
})])])]), g$1j("checked", `
 background: var(--n-button-color-active);
 color: var(--n-button-text-color-active);
 border-color: var(--n-button-border-color-active);
 `), g$1j("disabled", `
 cursor: not-allowed;
 opacity: var(--n-opacity-disabled);
 `)])]);
function l$1u(o3, s3 = "default", n3 = []) {
  const t3 = o3.$slots[s3];
  return t3 === void 0 ? n3 : t3();
}
function no$3(o3, a3, e28) {
  var u3;
  const t3 = [];
  let l3 = false;
  for (let s3 = 0; s3 < o3.length; ++s3) {
    const d3 = o3[s3], i = (u3 = d3.type) === null || u3 === void 0 ? void 0 : u3.name;
    if (i === "RadioButton" && (l3 = true), false)
      ;
    const f3 = d3.props;
    if (i !== "RadioButton") {
      t3.push(d3);
      continue;
    }
    if (s3 === 0)
      t3.push(d3);
    else {
      const b3 = t3[t3.length - 1].props, g3 = a3 === b3.value, m3 = b3.disabled, h3 = a3 === f3.value, p3 = f3.disabled, C3 = (g3 ? 2 : 0) + (m3 ? 0 : 1), B3 = (h3 ? 2 : 0) + (p3 ? 0 : 1), F3 = {
        [`${e28}-radio-group__splitor--disabled`]: m3,
        [`${e28}-radio-group__splitor--checked`]: g3
      }, V10 = {
        [`${e28}-radio-group__splitor--disabled`]: p3,
        [`${e28}-radio-group__splitor--checked`]: h3
      }, v3 = C3 < B3 ? V10 : F3;
      t3.push(h$1R("div", {
        class: [`${e28}-radio-group__splitor`, v3]
      }), d3);
    }
  }
  return {
    children: t3,
    isButtonGroup: l3
  };
}
const ro$3 = Object.assign(Object.assign({}, _$F.props), {
  name: String,
  value: [String, Number, Boolean],
  defaultValue: {
    type: [String, Number, Boolean],
    default: null
  },
  size: String,
  disabled: {
    type: Boolean,
    default: void 0
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array]
}), Bo$2 = defineComponent({
  name: "RadioGroup",
  props: ro$3,
  setup(o3) {
    const a3 = ref$1(null), {
      mergedSizeRef: e28,
      mergedDisabledRef: u3,
      nTriggerFormChange: t3,
      nTriggerFormInput: l3,
      nTriggerFormBlur: s3,
      nTriggerFormFocus: d3
    } = h$1B(o3), {
      mergedClsPrefixRef: i,
      inlineThemeDisabled: f3,
      mergedRtlRef: b3
    } = a$2x(o3), g3 = _$F("Radio", "-radio-group", a$1L, w$H, o3, i), m3 = ref$1(o3.defaultValue), h3 = toRef$1(o3, "value"), p3 = d$1S(h3, m3);
    function C3(n3) {
      const {
        onUpdateValue: r3,
        "onUpdate:value": R3
      } = o3;
      r3 && i$1Z(r3, n3), R3 && i$1Z(R3, n3), m3.value = n3, t3(), l3();
    }
    function B3(n3) {
      const {
        value: r3
      } = a3;
      r3 && (r3.contains(n3.relatedTarget) || d3());
    }
    function F3(n3) {
      const {
        value: r3
      } = a3;
      r3 && (r3.contains(n3.relatedTarget) || s3());
    }
    provide(E$z, {
      mergedClsPrefixRef: i,
      nameRef: toRef$1(o3, "name"),
      valueRef: p3,
      disabledRef: u3,
      mergedSizeRef: e28,
      doUpdateValue: C3
    });
    const V10 = v$17("Radio", b3, i), v3 = computed(() => {
      const {
        value: n3
      } = e28, {
        common: {
          cubicBezierEaseInOut: r3
        },
        self: {
          buttonBorderColor: R3,
          buttonBorderColorActive: w3,
          buttonBorderRadius: z3,
          buttonBoxShadow: $3,
          buttonBoxShadowFocus: D3,
          buttonBoxShadowHover: G3,
          buttonColor: U3,
          buttonColorActive: k3,
          buttonTextColor: A3,
          buttonTextColorActive: N3,
          buttonTextColorHover: H3,
          opacityDisabled: O3,
          [_$H("buttonHeight", n3)]: P3,
          [_$H("fontSize", n3)]: j3
        }
      } = g3.value;
      return {
        "--n-font-size": j3,
        "--n-bezier": r3,
        "--n-button-border-color": R3,
        "--n-button-border-color-active": w3,
        "--n-button-border-radius": z3,
        "--n-button-box-shadow": $3,
        "--n-button-box-shadow-focus": D3,
        "--n-button-box-shadow-hover": G3,
        "--n-button-color": U3,
        "--n-button-color-active": k3,
        "--n-button-text-color": A3,
        "--n-button-text-color-hover": H3,
        "--n-button-text-color-active": N3,
        "--n-height": P3,
        "--n-opacity-disabled": O3
      };
    }), c3 = f3 ? E$J("radio-group", computed(() => e28.value[0]), v3, o3) : void 0;
    return {
      selfElRef: a3,
      rtlEnabled: V10,
      mergedClsPrefix: i,
      mergedValue: p3,
      handleFocusout: F3,
      handleFocusin: B3,
      cssVars: f3 ? void 0 : v3,
      themeClass: c3 == null ? void 0 : c3.themeClass,
      onRender: c3 == null ? void 0 : c3.onRender
    };
  },
  render() {
    var o3;
    const {
      mergedValue: a3,
      mergedClsPrefix: e28,
      handleFocusin: u3,
      handleFocusout: t3
    } = this, {
      children: l3,
      isButtonGroup: s3
    } = no$3(i$1A(l$1u(this)), a3, e28);
    return (o3 = this.onRender) === null || o3 === void 0 || o3.call(this), h$1R("div", {
      onFocusin: u3,
      onFocusout: t3,
      ref: "selfElRef",
      class: [`${e28}-radio-group`, this.rtlEnabled && `${e28}-radio-group--rtl`, this.themeClass, s3 && `${e28}-radio-group--button-group`],
      style: this.cssVars
    }, l3);
  }
});
const f$1c = defineComponent({
  name: "UIRadioGroup",
  inheritAttrs: false
}), p$3m = defineComponent(__spreadProps(__spreadValues({}, f$1c), {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Boolean]
    },
    name: {
      type: String
    },
    size: {
      type: String,
      default: "medium"
    },
    defaultValue: {
      type: [String, Number, Boolean, null]
    }
  },
  emits: ["update:value"],
  setup(e28) {
    return (a3, t3) => (openBlock(), createBlock(unref(Bo$2), mergeProps({
      disabled: e28.disabled,
      "default-value": e28.defaultValue,
      value: e28.value,
      name: e28.name
    }, a3.$attrs, {
      size: e28.size,
      "onUpdate:value": t3[0] || (t3[0] = (u3) => a3.$emit("update:value", u3))
    }), {
      default: withCtx(() => [
        renderSlot(a3.$slots, "default")
      ]),
      _: 3
    }, 16, ["disabled", "default-value", "value", "name", "size"]));
  }
})), g$16 = p$3m;
const M$r = "data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iNDAiCiAgaGVpZ2h0PSI0MCIKICB2aWV3Qm94PSIwIDAgNDAgNDAiCiAgZmlsbD0ibm9uZSIKPgogIDxwYXRoCiAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICBkPSJNMjguNDkzOSAxMi4zMTY4TDE2LjU2MDYgMjMuODMzNEwxMy4zOTM5IDIwLjQ1MDFDMTIuODEwNiAxOS45MDAxIDExLjg5MzkgMTkuODY2OCAxMS4yMjczIDIwLjMzMzRDMTAuNTc3MyAyMC44MTY4IDEwLjM5MzkgMjEuNjY2OCAxMC43OTM5IDIyLjM1MDFMMTQuNTQzOSAyOC40NTAxQzE0LjkxMDYgMjkuMDE2OCAxNS41NDM5IDI5LjM2NjggMTYuMjYwNiAyOS4zNjY4QzE2Ljk0MzkgMjkuMzY2OCAxNy41OTM5IDI5LjAxNjggMTcuOTYwNiAyOC40NTAxQzE4LjU2MDYgMjcuNjY2OCAzMC4wMTA2IDE0LjAxNjggMzAuMDEwNiAxNC4wMTY4QzMxLjUxMDYgMTIuNDgzNCAyOS42OTM5IDExLjEzMzQgMjguNDkzOSAxMi4zMDAxVjEyLjMxNjhaIgogICAgZmlsbD0iIzI5NzBmZiIKICAvPgo8L3N2Zz4=";
const s$1F = l$25("steps", `
 width: 100%;
 display: flex;
`, [l$25("step", `
 position: relative;
 display: flex;
 flex: 1;
 `, [g$1j("disabled", "cursor: not-allowed"), g$1j("clickable", `
 cursor: pointer;
 `), r$2a("&:last-child", [l$25("step-splitor", "display: none;")])]), l$25("step-splitor", `
 background-color: var(--n-splitor-color);
 margin-top: calc(var(--n-step-header-font-size) / 2);
 height: 1px;
 flex: 1;
 align-self: flex-start;
 margin-left: 12px;
 margin-right: 12px;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `), l$25("step-content", "flex: 1;", [l$25("step-content-header", `
 color: var(--n-header-text-color);
 margin-top: calc(var(--n-indicator-size) / 2 - var(--n-step-header-font-size) / 2);
 line-height: var(--n-step-header-font-size);
 font-size: var(--n-step-header-font-size);
 position: relative;
 display: flex;
 font-weight: var(--n-step-header-font-weight);
 margin-left: 9px;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `, [M$y("title", `
 white-space: nowrap;
 flex: 0;
 `)]), M$y("description", `
 color: var(--n-description-text-color);
 margin-top: 12px;
 margin-left: 9px;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `)]), l$25("step-indicator", `
 background-color: var(--n-indicator-color);
 box-shadow: 0 0 0 1px var(--n-indicator-border-color);
 height: var(--n-indicator-size);
 width: var(--n-indicator-size);
 border-radius: 50%;
 display: flex;
 align-items: center;
 justify-content: center;
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 `, [l$25("step-indicator-slot", `
 position: relative;
 width: var(--n-indicator-icon-size);
 height: var(--n-indicator-icon-size);
 font-size: var(--n-indicator-icon-size);
 line-height: var(--n-indicator-icon-size);
 `, [M$y("index", `
 display: inline-block;
 text-align: center;
 position: absolute;
 left: 0;
 top: 0;
 white-space: nowrap;
 font-size: var(--n-indicator-index-font-size);
 width: var(--n-indicator-icon-size);
 height: var(--n-indicator-icon-size);
 line-height: var(--n-indicator-icon-size);
 color: var(--n-indicator-text-color);
 transition: color .3s var(--n-bezier);
 `, [m$22()]), l$25("icon", `
 color: var(--n-indicator-text-color);
 transition: color .3s var(--n-bezier);
 `, [m$22()]), l$25("base-icon", `
 color: var(--n-indicator-text-color);
 transition: color .3s var(--n-bezier);
 `, [m$22()])])]), g$1j("vertical", "flex-direction: column;", [x$I("show-description", [r$2a(">", [l$25("step", "padding-bottom: 8px;")])]), r$2a(">", [l$25("step", "margin-bottom: 16px;", [r$2a("&:last-child", "margin-bottom: 0;"), r$2a(">", [l$25("step-indicator", [r$2a(">", [l$25("step-splitor", `
 position: absolute;
 bottom: -8px;
 width: 1px;
 margin: 0 !important;
 left: calc(var(--n-indicator-size) / 2);
 height: calc(100% - var(--n-indicator-size));
 `)])]), l$25("step-content", [M$y("description", "margin-top: 8px;")])])])])])]);
const i$1t = {
  stepHeaderFontSizeSmall: "14px",
  stepHeaderFontSizeMedium: "16px",
  indicatorIndexFontSizeSmall: "14px",
  indicatorIndexFontSizeMedium: "16px",
  indicatorSizeSmall: "22px",
  indicatorSizeMedium: "28px",
  indicatorIconSizeSmall: "14px",
  indicatorIconSizeMedium: "18px"
};
const C$V = (i) => {
  const {
    fontWeightStrong: e28,
    baseColor: s3,
    textColorDisabled: o3,
    primaryColor: r3,
    errorColor: t3,
    textColor1: l3,
    textColor2: n3
  } = i;
  return Object.assign(Object.assign({}, i$1t), {
    stepHeaderFontWeight: e28,
    indicatorTextColorProcess: s3,
    indicatorTextColorWait: o3,
    indicatorTextColorFinish: r3,
    indicatorTextColorError: t3,
    indicatorBorderColorProcess: r3,
    indicatorBorderColorWait: o3,
    indicatorBorderColorFinish: r3,
    indicatorBorderColorError: t3,
    indicatorColorProcess: r3,
    indicatorColorWait: "#0000",
    indicatorColorFinish: "#0000",
    indicatorColorError: "#0000",
    splitorColorProcess: o3,
    splitorColorWait: o3,
    splitorColorFinish: r3,
    splitorColorError: o3,
    headerTextColorProcess: l3,
    headerTextColorWait: o3,
    headerTextColorFinish: o3,
    headerTextColorError: t3,
    descriptionTextColorProcess: n3,
    descriptionTextColorWait: o3,
    descriptionTextColorFinish: o3,
    descriptionTextColorError: t3
  });
}, d$1r = {
  name: "Steps",
  common: d$1T,
  self: C$V
}, h$1o = d$1r;
function y$X(e28, r3) {
  return typeof e28 != "object" || e28 === null || Array.isArray(e28) ? null : (e28.props || (e28.props = {}), e28.props.internalIndex = r3 + 1, e28);
}
function S$E(e28) {
  return e28.map((r3, t3) => y$X(r3, t3));
}
const b$W = Object.assign(Object.assign({}, _$F.props), {
  current: Number,
  status: {
    type: String,
    default: "process"
  },
  size: {
    type: String,
    default: "medium"
  },
  vertical: Boolean,
  "onUpdate:current": [Function, Array],
  onUpdateCurrent: [Function, Array]
}), x$x = n$28("n-steps"), F$t = defineComponent({
  name: "Steps",
  props: b$W,
  setup(e28, {
    slots: r3
  }) {
    const {
      mergedClsPrefixRef: t3,
      mergedRtlRef: n3
    } = a$2x(e28), o3 = v$17("Steps", n3, t3), i = _$F("Steps", "-steps", s$1F, h$1o, e28, t3);
    return provide(x$x, {
      props: e28,
      mergedThemeRef: i,
      mergedClsPrefixRef: t3,
      stepsSlots: r3
    }), {
      mergedClsPrefix: t3,
      rtlEnabled: o3
    };
  },
  render() {
    const {
      mergedClsPrefix: e28
    } = this;
    return h$1R("div", {
      class: [`${e28}-steps`, this.rtlEnabled && `${e28}-steps--rtl`, this.vertical && `${e28}-steps--vertical`]
    }, S$E(i$1A(l$1u(this))));
  }
});
const m$1H = ["src"], d$1q = defineComponent({
  name: "UISteps",
  inheritAttrs: false
}), p$3l = defineComponent(__spreadProps(__spreadValues({}, d$1q), {
  props: {
    current: {
      type: Number
    },
    status: {
      type: String
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  setup(t3) {
    return (e28, h3) => (openBlock(), createBlock(unref(F$t), mergeProps(e28.$attrs, {
      current: t3.current,
      status: t3.status,
      vertical: t3.vertical
    }), {
      "finish-icon": withCtx(() => [
        createElementVNode("img", {
          src: unref(M$r),
          width: "18",
          height: "18",
          alt: "finished"
        }, null, 8, m$1H)
      ]),
      default: withCtx(() => [
        renderSlot(e28.$slots, "default")
      ]),
      _: 3
    }, 16, ["current", "status", "vertical"]));
  }
})), v$V = p$3l;
const r$1w = defineComponent({
  name: "Checkmark",
  render() {
    return h$1R("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    }, h$1R("g", {
      fill: "none"
    }, h$1R("path", {
      d: "M14.046 3.486a.75.75 0 0 1-.032 1.06l-7.93 7.474a.85.85 0 0 1-1.188-.022l-2.68-2.72a.75.75 0 1 1 1.068-1.053l2.234 2.267l7.468-7.038a.75.75 0 0 1 1.06.032z",
      fill: "currentColor"
    })));
  }
});
const W$n = {
  status: String,
  title: String,
  description: String,
  disabled: Boolean,
  internalIndex: {
    type: Number,
    default: 0
  }
}, te$h = defineComponent({
  name: "Step",
  props: W$n,
  setup(e28) {
    const l3 = inject(x$x, null);
    l3 || t$1P("step", "`n-step` must be placed inside `n-steps`.");
    const {
      inlineThemeDisabled: a3
    } = a$2x(), {
      props: n3,
      mergedThemeRef: f3,
      mergedClsPrefixRef: p3,
      stepsSlots: o3
    } = l3, m3 = computed(() => n3.vertical), h3 = computed(() => {
      const {
        status: t3
      } = e28;
      if (t3)
        return t3;
      {
        const {
          internalIndex: r3
        } = e28, {
          current: c3
        } = n3;
        if (c3 === void 0)
          return "process";
        if (r3 < c3)
          return "finish";
        if (r3 === c3)
          return n3.status || "process";
        if (r3 > c3)
          return "wait";
      }
      return "process";
    }), v3 = computed(() => {
      const {
        value: t3
      } = h3, {
        size: r3
      } = n3, {
        common: {
          cubicBezierEaseInOut: c3
        },
        self: {
          stepHeaderFontWeight: I3,
          [_$H("stepHeaderFontSize", r3)]: g3,
          [_$H("indicatorIndexFontSize", r3)]: b3,
          [_$H("indicatorSize", r3)]: T3,
          [_$H("indicatorIconSize", r3)]: R3,
          [_$H("indicatorTextColor", t3)]: k3,
          [_$H("indicatorBorderColor", t3)]: y3,
          [_$H("headerTextColor", t3)]: P3,
          [_$H("splitorColor", t3)]: _3,
          [_$H("indicatorColor", t3)]: F3,
          [_$H("descriptionTextColor", t3)]: N3
        }
      } = f3.value;
      return {
        "--n-bezier": c3,
        "--n-description-text-color": N3,
        "--n-header-text-color": P3,
        "--n-indicator-border-color": y3,
        "--n-indicator-color": F3,
        "--n-indicator-icon-size": R3,
        "--n-indicator-index-font-size": b3,
        "--n-indicator-size": T3,
        "--n-indicator-text-color": k3,
        "--n-splitor-color": _3,
        "--n-step-header-font-size": g3,
        "--n-step-header-font-weight": I3
      };
    }), d3 = a3 ? E$J("step", computed(() => {
      const {
        value: t3
      } = h3, {
        size: r3
      } = n3;
      return `${t3[0]}${r3[0]}`;
    }), v3, n3) : void 0, z3 = computed(() => {
      if (e28.disabled)
        return;
      const {
        onUpdateCurrent: t3,
        "onUpdate:current": r3
      } = n3;
      return t3 || r3 ? () => {
        t3 && i$1Z(t3, e28.internalIndex), r3 && i$1Z(r3, e28.internalIndex);
      } : void 0;
    });
    return {
      stepsSlots: o3,
      mergedClsPrefix: p3,
      vertical: m3,
      mergedStatus: h3,
      handleStepClick: z3,
      cssVars: a3 ? void 0 : v3,
      themeClass: d3 == null ? void 0 : d3.themeClass,
      onRender: d3 == null ? void 0 : d3.onRender
    };
  },
  render() {
    const {
      mergedClsPrefix: e28,
      onRender: l3,
      handleStepClick: a3,
      disabled: n3
    } = this, f3 = m$26(this.$slots.default, (p3) => {
      const o3 = p3 || this.description;
      return o3 ? h$1R("div", {
        class: `${e28}-step-content__description`
      }, o3) : null;
    });
    return l3 == null || l3(), h$1R("div", {
      class: [`${e28}-step`, n3 && `${e28}-step--disabled`, !n3 && a3 && `${e28}-step--clickable`, this.themeClass, f3 && `${e28}-step--show-description`, `${e28}-step--${this.mergedStatus}-status`],
      style: this.cssVars,
      onClick: a3
    }, h$1R("div", {
      class: `${e28}-step-indicator`
    }, h$1R("div", {
      class: `${e28}-step-indicator-slot`
    }, h$1R(m$21, null, {
      default: () => m$26(this.$slots.icon, (p3) => {
        const {
          mergedStatus: o3,
          stepsSlots: m3
        } = this;
        return o3 === "finish" || o3 === "error" ? o3 === "finish" ? h$1R(d$1R, {
          clsPrefix: e28,
          key: "finish"
        }, {
          default: () => p$3H(m3["finish-icon"], () => [h$1R(r$1w, null)])
        }) : o3 === "error" ? h$1R(d$1R, {
          clsPrefix: e28,
          key: "error"
        }, {
          default: () => p$3H(m3["error-icon"], () => [h$1R(L$H, null)])
        }) : null : p3 || h$1R("div", {
          key: this.internalIndex,
          class: `${e28}-step-indicator-slot__index`
        }, this.internalIndex);
      })
    })), this.vertical ? h$1R("div", {
      class: `${e28}-step-splitor`
    }) : null), h$1R("div", {
      class: `${e28}-step-content`
    }, h$1R("div", {
      class: `${e28}-step-content-header`
    }, h$1R("div", {
      class: `${e28}-step-content-header__title`
    }, p$3H(this.$slots.title, () => [this.title])), this.vertical ? null : h$1R("div", {
      class: `${e28}-step-splitor`
    })), f3));
  }
});
const c$1C = defineComponent({
  name: "UIStep",
  inheritAttrs: false
}), d$1p = defineComponent(__spreadProps(__spreadValues({}, c$1C), {
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    }
  },
  setup(t3) {
    return (e28, f3) => (openBlock(), createBlock(unref(te$h), mergeProps(e28.$attrs, {
      title: t3.title,
      description: t3.description
    }), {
      default: withCtx(() => [
        renderSlot(e28.$slots, "default")
      ]),
      _: 3
    }, 16, ["title", "description"]));
  }
})), S$D = d$1p;
function a$1K(t3, n3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 21l-3.5-3.5m2.5-6a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z"
    })
  ]);
}
function n$1c({
  array: t3,
  oldIndex: r3,
  newIndex: l3
}) {
  const e28 = [...t3];
  if (l3 >= e28.length) {
    let i = l3 - e28.length + 1;
    for (; i--; )
      e28.push(void 0);
  }
  return e28.splice(l3, 0, e28.splice(r3, 1)[0]), e28;
}
const r$1v = "0!important", s$1E = "-1px!important";
function i$1s(n3) {
  return g$1j(n3 + "-type", [r$2a("& +", [l$25("button", {}, [g$1j(n3 + "-type", [M$y("border", {
    borderLeftWidth: r$1v
  }), M$y("state-border", {
    left: s$1E
  })])])])]);
}
function e$1o(n3) {
  return g$1j(n3 + "-type", [r$2a("& +", [l$25("button", [g$1j(n3 + "-type", [M$y("border", {
    borderTopWidth: r$1v
  }), M$y("state-border", {
    top: s$1E
  })])])])]);
}
const f$1b = l$25("button-group", `
 flex-wrap: nowrap;
 display: inline-flex;
 position: relative;
`, [x$I("vertical", {
  flexDirection: "row"
}, [x$I("rtl", [l$25("button", [r$2a("&:first-child:not(:last-child)", `
 margin-right: ${r$1v};
 border-top-right-radius: ${r$1v};
 border-bottom-right-radius: ${r$1v};
 `), r$2a("&:last-child:not(:first-child)", `
 margin-left: ${r$1v};
 border-top-left-radius: ${r$1v};
 border-bottom-left-radius: ${r$1v};
 `), r$2a("&:not(:first-child):not(:last-child)", `
 margin-left: ${r$1v};
 margin-right: ${r$1v};
 border-radius: ${r$1v};
 `), i$1s("default"), g$1j("ghost", [i$1s("primary"), i$1s("info"), i$1s("success"), i$1s("warning"), i$1s("error")])])])]), g$1j("vertical", {
  flexDirection: "column"
}, [l$25("button", [r$2a("&:first-child:not(:last-child)", `
 margin-bottom: ${r$1v};
 margin-left: ${r$1v};
 margin-right: ${r$1v};
 border-bottom-left-radius: ${r$1v};
 border-bottom-right-radius: ${r$1v};
 `), r$2a("&:last-child:not(:first-child)", `
 margin-top: ${r$1v};
 margin-left: ${r$1v};
 margin-right: ${r$1v};
 border-top-left-radius: ${r$1v};
 border-top-right-radius: ${r$1v};
 `), r$2a("&:not(:first-child):not(:last-child)", `
 margin: ${r$1v};
 border-radius: ${r$1v};
 `), e$1o("default"), g$1j("ghost", [e$1o("primary"), e$1o("info"), e$1o("success"), e$1o("warning"), e$1o("error")])])])]);
const m$1G = {
  size: {
    type: String,
    default: void 0
  },
  vertical: Boolean
}, v$U = defineComponent({
  name: "ButtonGroup",
  props: m$1G,
  setup(t3) {
    const {
      mergedClsPrefixRef: e28,
      mergedRtlRef: r3
    } = a$2x(t3);
    return S$O("-button-group", f$1b, e28), provide(n$1A, t3), {
      rtlEnabled: v$17("ButtonGroup", r3, e28),
      mergedClsPrefix: e28
    };
  },
  render() {
    const {
      mergedClsPrefix: t3
    } = this;
    return h$1R("div", {
      class: [`${t3}-button-group`, this.rtlEnabled && `${t3}-button-group--rtl`, this.vertical && `${t3}-button-group--vertical`],
      role: "group"
    }, this.$slots);
  }
});
const l$1t = defineComponent({
  name: "UIButtonGroup",
  inheritAttrs: false
}), c$1B = defineComponent(__spreadProps(__spreadValues({}, l$1t), {
  setup(i) {
    return (t3, _3) => (openBlock(), createBlock(unref(v$U), normalizeProps(guardReactiveProps(t3.$attrs)), {
      default: withCtx(() => [
        renderSlot(t3.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
})), B$D = c$1B;
function c$1A(t3, n3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 12h12M3 6h18M9 18h6"
    })
  ]);
}
function f$1a(e28, n3) {
  for (var l3 = -1, t3 = e28 == null ? 0 : e28.length; ++l3 < t3 && n3(e28[l3], l3, e28) !== false; )
    ;
  return e28;
}
function m$1F(r3, t3) {
  return r3 && x$G(t3, f$1u(t3), r3);
}
function i$1r(n3, r3) {
  return n3 && x$G(r3, t$1S(r3), n3);
}
function f$19(o3, t3) {
  return x$G(o3, y$12(o3), t3);
}
var a$1J = Object.getOwnPropertySymbols, y$W = a$1J ? function(r3) {
  for (var t3 = []; r3; )
    l$1F(t3, y$12(r3)), r3 = r$21(r3);
  return t3;
} : r$1J;
const f$18 = y$W;
function e$1n(o3, t3) {
  return x$G(o3, f$18(o3), t3);
}
function s$1D(e28) {
  return l$1E(e28, t$1S, f$18);
}
var o$1b = Object.prototype, i$1q = o$1b.hasOwnProperty;
function p$3k(t3) {
  var n3 = t3.length, e28 = new t3.constructor(n3);
  return n3 && typeof t3[0] == "string" && i$1q.call(t3, "index") && (e28.index = t3.index, e28.input = t3.input), e28;
}
function t$1e(r3, f3) {
  var e28 = f3 ? o$1O(r3.buffer) : r3.buffer;
  return new r3.constructor(e28, r3.byteOffset, r3.byteLength);
}
var a$1I = /\w*$/;
function e$1m(t3) {
  var n3 = new t3.constructor(t3.source, a$1I.exec(t3));
  return n3.lastIndex = t3.lastIndex, n3;
}
var e$1l = t$23 ? t$23.prototype : void 0, l$1s = e$1l ? e$1l.valueOf : void 0;
function r$1u(t3) {
  return l$1s ? Object(l$1s.call(t3)) : {};
}
var s$1C = "[object Boolean]", u$1o = "[object Date]", T$E = "[object Map]", b$V = "[object Number]", l$1r = "[object RegExp]", m$1E = "[object Set]", y$V = "[object String]", f$17 = "[object Symbol]", p$3j = "[object ArrayBuffer]", j$q = "[object DataView]", A$z = "[object Float32Array]", w$G = "[object Float64Array]", d$1o = "[object Int8Array]", B$C = "[object Int16Array]", x$w = "[object Int32Array]", C$U = "[object Uint8Array]", S$C = "[object Uint8ClampedArray]", U$u = "[object Uint16Array]", v$T = "[object Uint32Array]";
function R$o(a3, t3, r3) {
  var e28 = a3.constructor;
  switch (t3) {
    case p$3j:
      return o$1O(a3);
    case s$1C:
    case u$1o:
      return new e28(+a3);
    case j$q:
      return t$1e(a3, r3);
    case A$z:
    case w$G:
    case d$1o:
    case B$C:
    case x$w:
    case C$U:
    case S$C:
    case U$u:
    case v$T:
      return u$1X(a3, r3);
    case T$E:
      return new e28();
    case b$V:
    case y$V:
      return new e28(a3);
    case l$1r:
      return e$1m(a3);
    case m$1E:
      return new e28();
    case f$17:
      return r$1u(a3);
  }
}
var e$1k = "[object Map]";
function i$1p(t3) {
  return e$1X(t3) && h$1y(t3) == e$1k;
}
var o$1a = n$1Y && n$1Y.isMap, s$1B = o$1a ? t$1V(o$1a) : i$1p;
const m$1D = s$1B;
var o$19 = "[object Set]";
function s$1A(t3) {
  return e$1X(t3) && h$1y(t3) == o$19;
}
var e$1j = n$1Y && n$1Y.isSet, s$1z = e$1j ? t$1V(e$1j) : s$1A;
const S$B = s$1z;
var Q$o = 1, V$r = 2, X$j = 4, s$1y = "[object Arguments]", Z$o = "[object Array]", $$m = "[object Boolean]", z$p = "[object Date]", u$1n = "[object Error]", d$1n = "[object Function]", k$F = "[object GeneratorFunction]", v$S = "[object Map]", rr$2 = "[object Number]", E$y = "[object Object]", or$3 = "[object RegExp]", tr$2 = "[object Set]", ir$2 = "[object String]", nr$2 = "[object Symbol]", er$2 = "[object WeakMap]", fr$2 = "[object ArrayBuffer]", ar$3 = "[object DataView]", mr$3 = "[object Float32Array]", gr$3 = "[object Float64Array]", pr$2 = "[object Int8Array]", cr$3 = "[object Int16Array]", br$3 = "[object Int32Array]", Tr$3 = "[object Uint8Array]", jr$4 = "[object Uint8ClampedArray]", yr$3 = "[object Uint16Array]", Ar$2 = "[object Uint32Array]", o$18 = {};
o$18[s$1y] = o$18[Z$o] = o$18[fr$2] = o$18[ar$3] = o$18[$$m] = o$18[z$p] = o$18[mr$3] = o$18[gr$3] = o$18[pr$2] = o$18[cr$3] = o$18[br$3] = o$18[v$S] = o$18[rr$2] = o$18[E$y] = o$18[or$3] = o$18[tr$2] = o$18[ir$2] = o$18[nr$2] = o$18[Tr$3] = o$18[jr$4] = o$18[yr$3] = o$18[Ar$2] = true;
o$18[u$1n] = o$18[d$1n] = o$18[er$2] = false;
function b$U(r3, f3, a3, F3, g3, i) {
  var t3, p3 = f3 & Q$o, c3 = f3 & V$r, C3 = f3 & X$j;
  if (a3 && (t3 = g3 ? a3(r3, F3, g3, i) : a3(r3)), t3 !== void 0)
    return t3;
  if (!n$24(r3))
    return r3;
  var T3 = a$2p(r3);
  if (T3) {
    if (t3 = p$3k(r3), !p3)
      return h$1K(r3, t3);
  } else {
    var m3 = h$1y(r3), j3 = m3 == d$1n || m3 == k$F;
    if (m$2b(r3))
      return a$2r(r3, p3);
    if (m3 == E$y || m3 == s$1y || j3 && !g3) {
      if (t3 = c3 || j3 ? {} : p$3P(r3), !p3)
        return c3 ? e$1n(r3, i$1r(t3, r3)) : f$19(r3, m$1F(t3, r3));
    } else {
      if (!o$18[m3])
        return g3 ? r3 : {};
      t3 = R$o(r3, m3, p3);
    }
  }
  i || (i = new t$1_());
  var y3 = i.get(r3);
  if (y3)
    return y3;
  i.set(r3, t3), S$B(r3) ? r3.forEach(function(n3) {
    t3.add(b$U(n3, f3, a3, n3, r3, i));
  }) : m$1D(r3) && r3.forEach(function(n3, e28) {
    t3.set(e28, b$U(n3, f3, a3, e28, r3, i));
  });
  var S3 = C3 ? c3 ? s$1D : f$1t : c3 ? t$1S : f$1u, A3 = T3 ? void 0 : S3(r3);
  return f$1a(A3 || r3, function(n3, e28) {
    A3 && (e28 = n3, n3 = r3[e28]), l$1$(t3, e28, b$U(n3, f3, a3, e28, r3, i));
  }), t3;
}
var r$1t = 1, n$1b = 4;
function L$A(e28) {
  return b$U(e28, r$1t | n$1b);
}
const e$1i = {
  color: Object,
  type: {
    type: String,
    default: "default"
  },
  round: Boolean,
  size: {
    type: String,
    default: "medium"
  },
  closable: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  }
};
const i$1o = l$25("tag", `
 --n-close-margin: var(--n-close-margin-top) var(--n-close-margin-right) var(--n-close-margin-bottom) var(--n-close-margin-left);
 white-space: nowrap;
 position: relative;
 box-sizing: border-box;
 cursor: default;
 display: inline-flex;
 align-items: center;
 flex-wrap: nowrap;
 padding: var(--n-padding);
 border-radius: var(--n-border-radius);
 color: var(--n-text-color);
 background-color: var(--n-color);
 transition: 
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 line-height: 1;
 height: var(--n-height);
 font-size: var(--n-font-size);
`, [g$1j("strong", `
 font-weight: var(--n-font-weight-strong);
 `), M$y("border", `
 pointer-events: none;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 border: var(--n-border);
 transition: border-color .3s var(--n-bezier);
 `), M$y("icon", `
 display: flex;
 margin: 0 4px 0 0;
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 font-size: var(--n-avatar-size-override);
 `), M$y("avatar", `
 display: flex;
 margin: 0 6px 0 0;
 `), M$y("close", `
 margin: var(--n-close-margin);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `), g$1j("round", `
 padding: 0 calc(var(--n-height) / 3);
 border-radius: calc(var(--n-height) / 2);
 `, [M$y("icon", `
 margin: 0 4px 0 calc((var(--n-height) - 8px) / -2);
 `), M$y("avatar", `
 margin: 0 6px 0 calc((var(--n-height) - 8px) / -2);
 `), g$1j("closable", `
 padding: 0 calc(var(--n-height) / 4) 0 calc(var(--n-height) / 3);
 `)]), g$1j("icon, avatar", [g$1j("round", `
 padding: 0 calc(var(--n-height) / 3) 0 calc(var(--n-height) / 2);
 `)]), g$1j("disabled", `
 cursor: not-allowed !important;
 opacity: var(--n-opacity-disabled);
 `), g$1j("checkable", `
 cursor: pointer;
 box-shadow: none;
 color: var(--n-text-color-checkable);
 background-color: var(--n-color-checkable);
 `, [x$I("disabled", [r$2a("&:hover", "background-color: var(--n-color-hover-checkable);", [x$I("checked", "color: var(--n-text-color-hover-checkable);")]), r$2a("&:active", "background-color: var(--n-color-pressed-checkable);", [x$I("checked", "color: var(--n-text-color-pressed-checkable);")])]), g$1j("checked", `
 color: var(--n-text-color-checked);
 background-color: var(--n-color-checked);
 `, [x$I("disabled", [r$2a("&:hover", "background-color: var(--n-color-checked-hover);"), r$2a("&:active", "background-color: var(--n-color-checked-pressed);")])])])]);
const e$1h = {
  closeIconSizeTiny: "12px",
  closeIconSizeSmall: "12px",
  closeIconSizeMedium: "14px",
  closeIconSizeLarge: "14px",
  closeSizeTiny: "16px",
  closeSizeSmall: "16px",
  closeSizeMedium: "18px",
  closeSizeLarge: "18px",
  padding: "0 7px",
  closeMargin: "0 0 0 4px"
};
const L$z = (i) => {
  const {
    textColor2: a3,
    primaryColorHover: t3,
    primaryColorPressed: C3,
    primaryColor: r3,
    infoColor: e28,
    successColor: l3,
    warningColor: c3,
    errorColor: s3,
    baseColor: d3,
    borderColor: h3,
    opacityDisabled: p3,
    tagColor: m3,
    closeIconColor: g3,
    closeIconColorHover: I3,
    closeIconColorPressed: P3,
    borderRadiusSmall: n3,
    fontSizeMini: f3,
    fontSizeTiny: b3,
    fontSizeSmall: S3,
    fontSizeMedium: u3,
    heightMini: x3,
    heightTiny: v3,
    heightSmall: y3,
    heightMedium: H3,
    closeColorHover: k3,
    closeColorPressed: W3,
    buttonColor2Hover: E3,
    buttonColor2Pressed: z3,
    fontWeightStrong: B3
  } = i;
  return Object.assign(Object.assign({}, e$1h), {
    closeBorderRadius: n3,
    heightTiny: x3,
    heightSmall: v3,
    heightMedium: y3,
    heightLarge: H3,
    borderRadius: n3,
    opacityDisabled: p3,
    fontSizeTiny: f3,
    fontSizeSmall: b3,
    fontSizeMedium: S3,
    fontSizeLarge: u3,
    fontWeightStrong: B3,
    textColorCheckable: a3,
    textColorHoverCheckable: a3,
    textColorPressedCheckable: a3,
    textColorChecked: d3,
    colorCheckable: "#0000",
    colorHoverCheckable: E3,
    colorPressedCheckable: z3,
    colorChecked: r3,
    colorCheckedHover: t3,
    colorCheckedPressed: C3,
    border: `1px solid ${h3}`,
    textColor: a3,
    color: m3,
    colorBordered: "rgb(250, 250, 252)",
    closeIconColor: g3,
    closeIconColorHover: I3,
    closeIconColorPressed: P3,
    closeColorHover: k3,
    closeColorPressed: W3,
    borderPrimary: `1px solid ${J$p(r3, {
      alpha: 0.3
    })}`,
    textColorPrimary: r3,
    colorPrimary: J$p(r3, {
      alpha: 0.12
    }),
    colorBorderedPrimary: J$p(r3, {
      alpha: 0.1
    }),
    closeIconColorPrimary: r3,
    closeIconColorHoverPrimary: r3,
    closeIconColorPressedPrimary: r3,
    closeColorHoverPrimary: J$p(r3, {
      alpha: 0.12
    }),
    closeColorPressedPrimary: J$p(r3, {
      alpha: 0.18
    }),
    borderInfo: `1px solid ${J$p(e28, {
      alpha: 0.3
    })}`,
    textColorInfo: e28,
    colorInfo: J$p(e28, {
      alpha: 0.12
    }),
    colorBorderedInfo: J$p(e28, {
      alpha: 0.1
    }),
    closeIconColorInfo: e28,
    closeIconColorHoverInfo: e28,
    closeIconColorPressedInfo: e28,
    closeColorHoverInfo: J$p(e28, {
      alpha: 0.12
    }),
    closeColorPressedInfo: J$p(e28, {
      alpha: 0.18
    }),
    borderSuccess: `1px solid ${J$p(l3, {
      alpha: 0.3
    })}`,
    textColorSuccess: l3,
    colorSuccess: J$p(l3, {
      alpha: 0.12
    }),
    colorBorderedSuccess: J$p(l3, {
      alpha: 0.1
    }),
    closeIconColorSuccess: l3,
    closeIconColorHoverSuccess: l3,
    closeIconColorPressedSuccess: l3,
    closeColorHoverSuccess: J$p(l3, {
      alpha: 0.12
    }),
    closeColorPressedSuccess: J$p(l3, {
      alpha: 0.18
    }),
    borderWarning: `1px solid ${J$p(c3, {
      alpha: 0.35
    })}`,
    textColorWarning: c3,
    colorWarning: J$p(c3, {
      alpha: 0.15
    }),
    colorBorderedWarning: J$p(c3, {
      alpha: 0.12
    }),
    closeIconColorWarning: c3,
    closeIconColorHoverWarning: c3,
    closeIconColorPressedWarning: c3,
    closeColorHoverWarning: J$p(c3, {
      alpha: 0.12
    }),
    closeColorPressedWarning: J$p(c3, {
      alpha: 0.18
    }),
    borderError: `1px solid ${J$p(s3, {
      alpha: 0.23
    })}`,
    textColorError: s3,
    colorError: J$p(s3, {
      alpha: 0.1
    }),
    colorBorderedError: J$p(s3, {
      alpha: 0.08
    }),
    closeIconColorError: s3,
    closeIconColorHoverError: s3,
    closeIconColorPressedError: s3,
    closeColorHoverError: J$p(s3, {
      alpha: 0.12
    }),
    closeColorPressedError: J$p(s3, {
      alpha: 0.18
    })
  });
}, T$D = {
  name: "Tag",
  common: d$1T,
  self: L$z
}, w$F = T$D;
const me$f = Object.assign(Object.assign(Object.assign({}, _$F.props), e$1i), {
  bordered: {
    type: Boolean,
    default: void 0
  },
  checked: Boolean,
  checkable: Boolean,
  strong: Boolean,
  triggerClickOnClose: Boolean,
  onClose: [Array, Function],
  onMouseenter: Function,
  onMouseleave: Function,
  "onUpdate:checked": Function,
  onUpdateChecked: Function,
  internalCloseFocusable: {
    type: Boolean,
    default: true
  },
  internalCloseIsButtonTag: {
    type: Boolean,
    default: true
  },
  onCheckedChange: Function
}), be$d = n$28("n-tag"), He$7 = defineComponent({
  name: "Tag",
  props: me$f,
  setup(t3) {
    const a3 = ref$1(null), {
      mergedBorderedRef: o3,
      mergedClsPrefixRef: g3,
      inlineThemeDisabled: C3,
      mergedRtlRef: p3
    } = a$2x(t3), u3 = _$F("Tag", "-tag", i$1o, w$F, t3, g3);
    provide(be$d, {
      roundRef: toRef$1(t3, "round")
    });
    function f3(e28) {
      if (!t3.disabled && t3.checkable) {
        const {
          checked: c3,
          onCheckedChange: d3,
          onUpdateChecked: r3,
          "onUpdate:checked": s3
        } = t3;
        r3 && r3(!c3), s3 && s3(!c3), d3 && d3(!c3);
      }
    }
    function m3(e28) {
      if (t3.triggerClickOnClose || e28.stopPropagation(), !t3.disabled) {
        const {
          onClose: c3
        } = t3;
        c3 && i$1Z(c3, e28);
      }
    }
    const b3 = {
      setTextContent(e28) {
        const {
          value: c3
        } = a3;
        c3 && (c3.textContent = e28);
      }
    }, k3 = v$17("Tag", p3, g3), l3 = computed(() => {
      const {
        type: e28,
        size: c3,
        color: {
          color: d3,
          textColor: r3
        } = {}
      } = t3, {
        common: {
          cubicBezierEaseInOut: s3
        },
        self: {
          padding: z3,
          closeMargin: _3,
          borderRadius: I3,
          opacityDisabled: T3,
          textColorCheckable: M3,
          textColorHoverCheckable: O3,
          textColorPressedCheckable: F3,
          textColorChecked: H3,
          colorCheckable: S3,
          colorHoverCheckable: j3,
          colorPressedCheckable: E3,
          colorChecked: N3,
          colorCheckedHover: U3,
          colorCheckedPressed: D3,
          closeBorderRadius: V10,
          fontWeightStrong: w3,
          [_$H("colorBordered", e28)]: K3,
          [_$H("closeSize", c3)]: W3,
          [_$H("closeIconSize", c3)]: A3,
          [_$H("fontSize", c3)]: L3,
          [_$H("height", c3)]: x3,
          [_$H("color", e28)]: q3,
          [_$H("textColor", e28)]: G3,
          [_$H("border", e28)]: J3,
          [_$H("closeIconColor", e28)]: $3,
          [_$H("closeIconColorHover", e28)]: Q3,
          [_$H("closeIconColorPressed", e28)]: X3,
          [_$H("closeColorHover", e28)]: Y3,
          [_$H("closeColorPressed", e28)]: Z3
        }
      } = u3.value, v3 = f$1f(_3);
      return {
        "--n-font-weight-strong": w3,
        "--n-avatar-size-override": `calc(${x3} - 8px)`,
        "--n-bezier": s3,
        "--n-border-radius": I3,
        "--n-border": J3,
        "--n-close-icon-size": A3,
        "--n-close-color-pressed": Z3,
        "--n-close-color-hover": Y3,
        "--n-close-border-radius": V10,
        "--n-close-icon-color": $3,
        "--n-close-icon-color-hover": Q3,
        "--n-close-icon-color-pressed": X3,
        "--n-close-icon-color-disabled": $3,
        "--n-close-margin-top": v3.top,
        "--n-close-margin-right": v3.right,
        "--n-close-margin-bottom": v3.bottom,
        "--n-close-margin-left": v3.left,
        "--n-close-size": W3,
        "--n-color": d3 || (o3.value ? K3 : q3),
        "--n-color-checkable": S3,
        "--n-color-checked": N3,
        "--n-color-checked-hover": U3,
        "--n-color-checked-pressed": D3,
        "--n-color-hover-checkable": j3,
        "--n-color-pressed-checkable": E3,
        "--n-font-size": L3,
        "--n-height": x3,
        "--n-opacity-disabled": T3,
        "--n-padding": z3,
        "--n-text-color": r3 || G3,
        "--n-text-color-checkable": M3,
        "--n-text-color-checked": H3,
        "--n-text-color-hover-checkable": O3,
        "--n-text-color-pressed-checkable": F3
      };
    }), i = C3 ? E$J("tag", computed(() => {
      let e28 = "";
      const {
        type: c3,
        size: d3,
        color: {
          color: r3,
          textColor: s3
        } = {}
      } = t3;
      return e28 += c3[0], e28 += d3[0], r3 && (e28 += `a${e$1G(r3)}`), s3 && (e28 += `b${e$1G(s3)}`), o3.value && (e28 += "c"), e28;
    }), l3, t3) : void 0;
    return Object.assign(Object.assign({}, b3), {
      rtlEnabled: k3,
      mergedClsPrefix: g3,
      contentRef: a3,
      mergedBordered: o3,
      handleClick: f3,
      handleCloseClick: m3,
      cssVars: C3 ? void 0 : l3,
      themeClass: i == null ? void 0 : i.themeClass,
      onRender: i == null ? void 0 : i.onRender
    });
  },
  render() {
    var t3, a3;
    const {
      mergedClsPrefix: o3,
      rtlEnabled: g3,
      closable: C3,
      color: {
        borderColor: p3
      } = {},
      round: u3,
      onRender: f3,
      $slots: m3
    } = this;
    f3 == null || f3();
    const b3 = m$26(m3.avatar, (l3) => l3 && h$1R("div", {
      class: `${o3}-tag__avatar`
    }, l3)), k3 = m$26(m3.icon, (l3) => l3 && h$1R("div", {
      class: `${o3}-tag__icon`
    }, l3));
    return h$1R("div", {
      class: [`${o3}-tag`, this.themeClass, {
        [`${o3}-tag--rtl`]: g3,
        [`${o3}-tag--strong`]: this.strong,
        [`${o3}-tag--disabled`]: this.disabled,
        [`${o3}-tag--checkable`]: this.checkable,
        [`${o3}-tag--checked`]: this.checkable && this.checked,
        [`${o3}-tag--round`]: u3,
        [`${o3}-tag--avatar`]: b3,
        [`${o3}-tag--icon`]: k3,
        [`${o3}-tag--closable`]: C3
      }],
      style: this.cssVars,
      onClick: this.handleClick,
      onMouseenter: this.onMouseenter,
      onMouseleave: this.onMouseleave
    }, k3 || b3, h$1R("span", {
      class: `${o3}-tag__content`,
      ref: "contentRef"
    }, (a3 = (t3 = this.$slots).default) === null || a3 === void 0 ? void 0 : a3.call(t3)), !this.checkable && C3 ? h$1R(g$1b, {
      clsPrefix: o3,
      class: `${o3}-tag__close`,
      disabled: this.disabled,
      onClick: this.handleCloseClick,
      focusable: this.internalCloseFocusable,
      round: u3,
      isButtonTag: this.internalCloseIsButtonTag,
      absolute: true
    }) : null, !this.checkable && this.mergedBordered ? h$1R("div", {
      class: `${o3}-tag__border`,
      style: {
        borderColor: p3
      }
    }) : null);
  }
});
const d$1m = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  padding: "8px",
  width: "100%"
}, g$15 = (e28, r3) => h$1R("div", {
  style: {
    display: "flex",
    alignItems: "center"
  }
}, [
  h$1R("div", {
    style: d$1m
  }, [
    h$1R("p", {
      style: {
        margin: 0,
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden"
      }
    }, { default: () => e28 == null ? void 0 : e28.label }),
    h$1R("span", {
      style: {
        color: e28.disabled ? "var(--gray-300)" : "var(--gray-500)"
      }
    }, {
      default: () => e28 != null && e28.description ? e28 == null ? void 0 : e28.description : void 0
    })
  ])
]), f$16 = ({ option: e28 }) => e28.label, i$1n = ({
  option: e28,
  handleClose: r3
}) => h$1R(He$7, {
  closable: true,
  onClose: (a3) => {
    a3.stopPropagation(), r3();
  }
}, {
  default: () => e28.label
});
const r$1s = (o3) => {
  if (o3 == null)
    return "hsl(216,24%, 96%)";
  let e28 = 0;
  if (o3 = o3.trim().toLowerCase(), o3.length == 0)
    return e28.toString();
  for (let t3 = 0; t3 < o3.length; t3++)
    e28 = o3.charCodeAt(t3) + ((e28 << 5) - e28), e28 = e28 & e28;
  return "hsl(" + Math.abs(e28) % 360 + ",35%, 60%)";
};
const n$1a = (t3 = "") => {
  if (t3 === null || !t3.trim())
    return t3;
  const e28 = (t3 != null ? t3 : "").toLocaleUpperCase().split(" ").filter((r3) => r3.trim());
  return e28.length > 1 ? e28.splice(0, 2).reduce((r3, i) => r3 + i[0], "") : e28[0].slice(0, 2);
};
const t$1d = e$1O && "loading" in document.createElement("img");
const O$w = (e28 = {}) => {
  var o3;
  const {
    root: n3 = null
  } = e28;
  return {
    hash: `${e28.rootMargin || "0px 0px 0px 0px"}-${Array.isArray(e28.threshold) ? e28.threshold.join(",") : (o3 = e28.threshold) !== null && o3 !== void 0 ? o3 : "0"}`,
    options: Object.assign(Object.assign({}, e28), {
      root: (typeof n3 == "string" ? document.querySelector(n3) : n3) || document.documentElement
    })
  };
}, h$1n = /* @__PURE__ */ new WeakMap(), c$1z = /* @__PURE__ */ new WeakMap(), u$1m = /* @__PURE__ */ new WeakMap(), M$q = (e28, o3, n3) => {
  if (!e28)
    return () => {
    };
  const r3 = O$w(o3), {
    root: i
  } = r3.options;
  let s3;
  const v3 = h$1n.get(i);
  v3 ? s3 = v3 : (s3 = /* @__PURE__ */ new Map(), h$1n.set(i, s3));
  let a3, t3;
  s3.has(r3.hash) ? (t3 = s3.get(r3.hash), t3[1].has(e28) || (a3 = t3[0], t3[1].add(e28), a3.observe(e28))) : (a3 = new IntersectionObserver((p3) => {
    p3.forEach((d3) => {
      if (d3.isIntersecting) {
        const l3 = c$1z.get(d3.target), g3 = u$1m.get(d3.target);
        l3 && l3(), g3 && (g3.value = true);
      }
    });
  }, r3.options), a3.observe(e28), t3 = [a3, /* @__PURE__ */ new Set([e28])], s3.set(r3.hash, t3));
  let b3 = false;
  const f3 = () => {
    b3 || (c$1z.delete(e28), u$1m.delete(e28), b3 = true, t3[1].has(e28) && (t3[0].unobserve(e28), t3[1].delete(e28)), t3[1].size <= 0 && s3.delete(r3.hash), s3.size || h$1n.delete(i));
  };
  return c$1z.set(e28, f3), u$1m.set(e28, n3), f3;
};
const t$1c = n$28("n-avatar-group");
const t$1b = l$25("avatar", `
 width: var(--n-merged-size);
 height: var(--n-merged-size);
 color: #FFF;
 font-size: var(--n-font-size);
 display: inline-flex;
 position: relative;
 overflow: hidden;
 text-align: center;
 border: var(--n-border);
 border-radius: var(--n-border-radius);
 --n-merged-color: var(--n-color);
 background-color: var(--n-merged-color);
 transition:
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
`, [C$1a(r$2a("&", "--n-merged-color: var(--n-color-modal);")), P$V(r$2a("&", "--n-merged-color: var(--n-color-popover);")), r$2a("img", `
 width: 100%;
 height: 100%;
 `), M$y("text", `
 white-space: nowrap;
 display: inline-block;
 position: absolute;
 left: 50%;
 top: 50%;
 `), l$25("icon", `
 vertical-align: bottom;
 font-size: calc(var(--n-merged-size) - 6px);
 `), M$y("text", "line-height: 1.25")]);
const p$3i = (a3) => {
  const {
    borderRadius: e28,
    avatarColor: o3,
    cardColor: t3,
    fontSize: i,
    heightTiny: l3,
    heightSmall: h3,
    heightMedium: m3,
    heightLarge: c3,
    heightHuge: g3,
    modalColor: n3,
    popoverColor: d3
  } = a3;
  return {
    borderRadius: e28,
    fontSize: i,
    border: `2px solid ${t3}`,
    heightTiny: l3,
    heightSmall: h3,
    heightMedium: m3,
    heightLarge: c3,
    heightHuge: g3,
    color: G$v(t3, o3),
    colorModal: G$v(n3, o3),
    colorPopover: G$v(d3, o3)
  };
}, v$R = {
  name: "Avatar",
  common: d$1T,
  self: p$3i
}, C$T = v$R;
const Z$n = Object.assign(Object.assign({}, _$F.props), {
  size: [String, Number],
  src: String,
  circle: {
    type: Boolean,
    default: void 0
  },
  objectFit: String,
  round: {
    type: Boolean,
    default: void 0
  },
  bordered: {
    type: Boolean,
    default: void 0
  },
  onError: Function,
  fallbackSrc: String,
  intersectionObserverOptions: Object,
  lazy: Boolean,
  onLoad: Function,
  renderPlaceholder: Function,
  renderFallback: Function,
  imgProps: Object,
  color: String
}), ve$d = defineComponent({
  name: "Avatar",
  props: Z$n,
  setup(t3) {
    const {
      mergedClsPrefixRef: l3,
      inlineThemeDisabled: h3
    } = a$2x(t3), g3 = ref$1(false);
    let d3 = null;
    const c3 = ref$1(null), s3 = ref$1(null), L3 = () => {
      const {
        value: e28
      } = c3;
      if (e28 && (d3 === null || d3 !== e28.innerHTML)) {
        d3 = e28.innerHTML;
        const {
          value: r3
        } = s3;
        if (r3) {
          const {
            offsetWidth: o3,
            offsetHeight: i
          } = r3, {
            offsetWidth: n3,
            offsetHeight: j3
          } = e28, R3 = 0.9, x3 = Math.min(o3 / n3 * R3, i / j3 * R3, 1);
          e28.style.transform = `translateX(-50%) translateY(-50%) scale(${x3})`;
        }
      }
    }, b3 = inject(t$1c, null), a3 = computed(() => {
      const {
        size: e28
      } = t3;
      if (e28)
        return e28;
      const {
        size: r3
      } = b3 || {};
      return r3 || "medium";
    }), f3 = _$F("Avatar", "-avatar", t$1b, C$T, t3, l3), p3 = inject(be$d, null), u3 = computed(() => {
      if (b3)
        return true;
      const {
        round: e28,
        circle: r3
      } = t3;
      return e28 !== void 0 || r3 !== void 0 ? e28 || r3 : p3 ? p3.roundRef.value : false;
    }), m3 = computed(() => b3 ? true : t3.bordered || false), P3 = computed(() => {
      const e28 = a3.value, r3 = u3.value, o3 = m3.value, {
        color: i
      } = t3, {
        self: {
          borderRadius: n3,
          fontSize: j3,
          color: R3,
          border: x3,
          colorModal: H3,
          colorPopover: $3
        },
        common: {
          cubicBezierEaseInOut: B3
        }
      } = f3.value;
      let E3;
      return typeof e28 == "number" ? E3 = `${e28}px` : E3 = f3.value.self[_$H("height", e28)], {
        "--n-font-size": j3,
        "--n-border": o3 ? x3 : "none",
        "--n-border-radius": r3 ? "50%" : n3,
        "--n-color": i || R3,
        "--n-color-modal": i || H3,
        "--n-color-popover": i || $3,
        "--n-bezier": B3,
        "--n-merged-size": `var(--n-avatar-size-override, ${E3})`
      };
    }), v3 = h3 ? E$J("avatar", computed(() => {
      const e28 = a3.value, r3 = u3.value, o3 = m3.value, {
        color: i
      } = t3;
      let n3 = "";
      return e28 && (typeof e28 == "number" ? n3 += `a${e28}` : n3 += e28[0]), r3 && (n3 += "b"), o3 && (n3 += "c"), i && (n3 += e$1G(i)), n3;
    }), P3, t3) : void 0, S3 = ref$1(!t3.lazy);
    onMounted(() => {
      if (t3.lazy && t3.intersectionObserverOptions) {
        let e28;
        const r3 = watchEffect(() => {
          e28 == null || e28(), e28 = void 0, t3.lazy && (e28 = M$q(s3.value, t3.intersectionObserverOptions, S3));
        });
        onBeforeUnmount(() => {
          r3(), e28 == null || e28();
        });
      }
    }), watch(() => {
      var e28;
      return t3.src || ((e28 = t3.imgProps) === null || e28 === void 0 ? void 0 : e28.src);
    }, () => {
      g3.value = false;
    });
    const C3 = ref$1(!t3.lazy);
    return {
      textRef: c3,
      selfRef: s3,
      mergedRoundRef: u3,
      mergedClsPrefix: l3,
      fitTextTransform: L3,
      cssVars: h3 ? void 0 : P3,
      themeClass: v3 == null ? void 0 : v3.themeClass,
      onRender: v3 == null ? void 0 : v3.onRender,
      hasLoadError: g3,
      shouldStartLoading: S3,
      loaded: C3,
      mergedOnError: (e28) => {
        if (!S3.value)
          return;
        g3.value = true;
        const {
          onError: r3,
          imgProps: {
            onError: o3
          } = {}
        } = t3;
        r3 == null || r3(e28), o3 == null || o3(e28);
      },
      mergedOnLoad: (e28) => {
        const {
          onLoad: r3,
          imgProps: {
            onLoad: o3
          } = {}
        } = t3;
        r3 == null || r3(e28), o3 == null || o3(e28), C3.value = true;
      }
    };
  },
  render() {
    var t3, l3;
    const {
      $slots: h3,
      src: g3,
      mergedClsPrefix: d3,
      lazy: c3,
      onRender: s3,
      loaded: L3,
      hasLoadError: b3,
      imgProps: a3 = {}
    } = this;
    s3 == null || s3();
    let f3;
    const p3 = !L3 && !b3 && (this.renderPlaceholder ? this.renderPlaceholder() : (l3 = (t3 = this.$slots).placeholder) === null || l3 === void 0 ? void 0 : l3.call(t3));
    return this.hasLoadError ? f3 = this.renderFallback ? this.renderFallback() : p$3H(h3.fallback, () => [h$1R("img", {
      src: this.fallbackSrc,
      style: {
        objectFit: this.objectFit
      }
    })]) : f3 = m$26(h3.default, (u3) => {
      if (u3)
        return h$1R(x$D, {
          onResize: this.fitTextTransform
        }, {
          default: () => h$1R("span", {
            ref: "textRef",
            class: `${d3}-avatar__text`
          }, u3)
        });
      if (g3 || a3.src) {
        const m3 = this.src || a3.src;
        return h$1R("img", Object.assign(Object.assign({}, a3), {
          loading: t$1d && !this.intersectionObserverOptions && c3 ? "lazy" : "eager",
          src: c3 && this.intersectionObserverOptions ? this.shouldStartLoading ? m3 : void 0 : m3,
          "data-image-src": m3,
          onLoad: this.mergedOnLoad,
          onError: this.mergedOnError,
          style: [a3.style || "", {
            objectFit: this.objectFit
          }, p3 ? {
            height: "0",
            width: "0",
            visibility: "hidden",
            position: "absolute"
          } : ""]
        }));
      }
    }), h$1R("span", {
      ref: "selfRef",
      class: [`${d3}-avatar`, this.themeClass],
      style: this.cssVars
    }, f3, c3 && p3);
  }
});
const t$1a = (r3 = {}) => ({
  round: true,
  size: 24,
  style: r3
}), g$14 = (r3) => r3.imageUrl ? h$1R(ve$d, __spreadValues({
  src: r3.imageUrl
}, t$1a(__spreadValues({
  flex: "none"
}, r3.avatarClass)))) : h$1R(ve$d, t$1a(__spreadValues({
  backgroundColor: r$1s(r3.label),
  fontSize: "10px",
  flex: "none"
}, r3.avatarClass)), {
  default: () => n$1a(r3.label)
});
const a$1H = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  marginLeft: "8px",
  padding: "4px 0px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, s$1x = (e28) => h$1R("div", {
  style: {
    display: "flex",
    alignItems: "center"
  }
}, [
  g$14(e28),
  h$1R("div", {
    style: a$1H
  }, [
    h$1R("p", {
      style: {
        margin: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, [e28.label]),
    h$1R("span", {
      style: {
        color: e28.disabled ? "var(--gray-300)" : "var(--gray-500)"
      }
    }, {
      default: () => e28 == null ? void 0 : e28.description
    })
  ])
]);
const n$19 = (e28) => h$1R("div", {}, [h$1R("span", {}, [e28.label])]);
const t$19 = l$25("ellipsis", {
  overflow: "hidden"
}, [x$I("line-clamp", `
 white-space: nowrap;
 display: inline-block;
 vertical-align: bottom;
 max-width: 100%;
 `), g$1j("line-clamp", `
 display: -webkit-inline-box;
 -webkit-box-orient: vertical;
 `), g$1j("cursor-pointer", `
 cursor: pointer;
 `)]);
const m$1C = G$w({
  name: "Ellipsis",
  common: d$1T,
  peers: {
    Tooltip: d$1z
  }
}), l$1q = m$1C;
function b$T(i) {
  return `${i}-ellipsis--line-clamp`;
}
function R$n(i, s3) {
  return `${i}-ellipsis--cursor-${s3}`;
}
const B$B = Object.assign(Object.assign({}, _$F.props), {
  expandTrigger: String,
  lineClamp: [Number, String],
  tooltip: {
    type: [Boolean, Object],
    default: true
  }
}), q$u = defineComponent({
  name: "Ellipsis",
  inheritAttrs: false,
  props: B$B,
  setup(i, {
    slots: s3,
    attrs: o3
  }) {
    const n3 = g$1i(), a3 = _$F("Ellipsis", "-ellipsis", t$19, l$1q, i, n3), m3 = ref$1(null), g3 = ref$1(null), u3 = ref$1(null), c3 = ref$1(false), v3 = computed(() => {
      const {
        lineClamp: e28
      } = i, {
        value: l3
      } = c3;
      return e28 !== void 0 ? {
        textOverflow: "",
        "-webkit-line-clamp": l3 ? "" : e28
      } : {
        textOverflow: l3 ? "" : "ellipsis",
        "-webkit-line-clamp": ""
      };
    });
    function C3() {
      let e28 = false;
      const {
        value: l3
      } = c3;
      if (l3)
        return true;
      const {
        value: t3
      } = m3;
      if (t3) {
        const {
          lineClamp: r3
        } = i;
        if (O3(t3), r3 !== void 0)
          e28 = t3.scrollHeight <= t3.offsetHeight;
        else {
          const {
            value: T3
          } = g3;
          T3 && (e28 = T3.getBoundingClientRect().width <= t3.getBoundingClientRect().width);
        }
        w3(t3, e28);
      }
      return e28;
    }
    const h3 = computed(() => i.expandTrigger === "click" ? () => {
      var e28;
      const {
        value: l3
      } = c3;
      l3 && ((e28 = u3.value) === null || e28 === void 0 || e28.setShow(false)), c3.value = !l3;
    } : void 0);
    onDeactivated(() => {
      var e28;
      i.tooltip && ((e28 = u3.value) === null || e28 === void 0 || e28.setShow(false));
    });
    const y3 = () => h$1R("span", Object.assign({}, mergeProps(o3, {
      class: [`${n3.value}-ellipsis`, i.lineClamp !== void 0 ? b$T(n3.value) : void 0, i.expandTrigger === "click" ? R$n(n3.value, "pointer") : void 0],
      style: v3.value
    }), {
      ref: "triggerRef",
      onClick: h3.value,
      onMouseenter: i.expandTrigger === "click" ? C3 : void 0
    }), i.lineClamp ? s3 : h$1R("span", {
      ref: "triggerInnerRef"
    }, s3));
    function O3(e28) {
      if (!e28)
        return;
      const l3 = v3.value, t3 = b$T(n3.value);
      i.lineClamp !== void 0 ? d3(e28, t3, "add") : d3(e28, t3, "remove");
      for (const r3 in l3)
        e28.style[r3] !== l3[r3] && (e28.style[r3] = l3[r3]);
    }
    function w3(e28, l3) {
      const t3 = R$n(n3.value, "pointer");
      i.expandTrigger === "click" && !l3 ? d3(e28, t3, "add") : d3(e28, t3, "remove");
    }
    function d3(e28, l3, t3) {
      t3 === "add" ? e28.classList.contains(l3) || e28.classList.add(l3) : e28.classList.contains(l3) && e28.classList.remove(l3);
    }
    return {
      mergedTheme: a3,
      triggerRef: m3,
      triggerInnerRef: g3,
      tooltipRef: u3,
      handleClick: h3,
      renderTrigger: y3,
      getTooltipDisabled: C3
    };
  },
  render() {
    var i;
    const {
      tooltip: s3,
      renderTrigger: o3,
      $slots: n3
    } = this;
    if (s3) {
      const {
        mergedTheme: a3
      } = this;
      return h$1R(b$10, Object.assign({
        ref: "tooltipRef",
        placement: "top"
      }, s3, {
        getDisabled: this.getTooltipDisabled,
        theme: a3.peers.Tooltip,
        themeOverrides: a3.peerOverrides.Tooltip
      }), {
        trigger: o3,
        default: (i = n3.tooltip) !== null && i !== void 0 ? i : n3.default
      });
    } else
      return o3();
  }
});
const y$U = defineComponent({
  name: "PerformantEllipsis",
  props: B$B,
  inheritAttrs: false,
  setup(i, {
    attrs: p3,
    slots: t3
  }) {
    const n3 = ref$1(false), l3 = g$1i();
    return S$O("-ellipsis", t$19, l3), {
      mouseEntered: n3,
      renderTrigger: () => {
        const {
          lineClamp: e28
        } = i, r3 = l3.value;
        return h$1R("span", Object.assign({}, mergeProps(p3, {
          class: [`${r3}-ellipsis`, e28 !== void 0 ? b$T(r3) : void 0, i.expandTrigger === "click" ? R$n(r3, "pointer") : void 0],
          style: e28 === void 0 ? {
            textOverflow: "ellipsis"
          } : {
            "-webkit-line-clamp": e28
          }
        }), {
          onMouseenter: () => {
            n3.value = true;
          }
        }), e28 ? t3 : h$1R("span", null, t3));
      }
    };
  },
  render() {
    return this.mouseEntered ? h$1R(q$u, mergeProps({}, this.$attrs, this.$props), this.$slots) : this.renderTrigger();
  }
});
const l$1p = (r3) => h$1R(y$U, {}, [r3.label]);
const h$1m = { class: "flex items-center space-x-1" }, p$3h = {
  key: 0,
  class: "flex items-center"
}, b$S = { style: { width: "100%" } }, g$13 = defineComponent({
  name: "UITag",
  inheritAttrs: false
}), B$A = defineComponent(__spreadProps(__spreadValues({}, g$13), {
  props: {
    type: {
      type: String,
      default: "default"
    },
    closable: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "medium"
    },
    round: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: true
    }
  },
  setup(e28) {
    const r3 = useSlots();
    return (t3, k3) => (openBlock(), createBlock(unref(He$7), mergeProps({
      class: [`hl-${e28.type}`, e28.bordered ? null : "hl-border-hidden"]
    }, t3.$attrs, {
      type: e28.type,
      closable: e28.closable,
      size: e28.size,
      round: e28.round
    }), {
      default: withCtx(() => [
        createElementVNode("div", h$1m, [
          unref(r3).icon ? (openBlock(), createElementBlock("div", p$3h, [
            renderSlot(t3.$slots, "icon")
          ])) : createCommentVNode("", true),
          createElementVNode("div", b$S, [
            renderSlot(t3.$slots, "default")
          ])
        ])
      ]),
      _: 3
    }, 16, ["class", "type", "closable", "size", "round"]));
  }
})), $$l = B$A;
const l$1o = {
  display: "flex",
  alignItems: "center",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "24px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, f$15 = ({ option: e28 }) => h$1R("div", {
  style: l$1o
}, [
  g$14(e28),
  h$1R("p", {
    style: {
      margin: 0,
      marginLeft: "8px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  }, { default: () => e28.label })
]), m$1B = ({
  option: e28,
  handleClose: i
}) => h$1R($$l, {
  style: {
    padding: "0 6px 0 4px"
  },
  round: true,
  closable: true,
  onClose: (o3) => {
    o3.stopPropagation(), i();
  }
}, {
  default: () => h$1R("div", {
    style: l$1o
  }, [
    g$14(e28),
    h$1R("p", {
      style: {
        margin: 0,
        marginLeft: "8px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, { default: () => e28.label })
  ])
});
function c$1y(r3) {
  return r3.type === "group";
}
function a$1G(r3) {
  return r3.type === "ignored";
}
function g$12(r3, t3) {
  try {
    return !!(1 + t3.toString().toLowerCase().indexOf(r3.trim().toLowerCase()));
  } catch {
    return false;
  }
}
function p$3g(r3, t3) {
  return {
    getIsGroup: c$1y,
    getIgnored: a$1G,
    getKey(e28) {
      return c$1y(e28) ? e28.name || e28.key || "key-required" : e28[r3];
    },
    getChildren(e28) {
      return e28[t3];
    }
  };
}
function h$1l(r3, t3, f3, e28) {
  if (!t3)
    return r3;
  function n3(s3) {
    if (!Array.isArray(s3))
      return [];
    const i = [];
    for (const u3 of s3)
      if (c$1y(u3)) {
        const o3 = n3(u3[e28]);
        o3.length && i.push(Object.assign({}, u3, {
          [e28]: o3
        }));
      } else {
        if (a$1G(u3))
          continue;
        t3(f3, u3) && i.push(u3);
      }
    return i;
  }
  return n3(r3);
}
function y$T(r3, t3, f3) {
  const e28 = /* @__PURE__ */ new Map();
  return r3.forEach((n3) => {
    c$1y(n3) ? n3[f3].forEach((s3) => {
      e28.set(s3[t3], s3);
    }) : e28.set(n3[t3], n3);
  }), e28;
}
const r$1r = r$2a([l$25("select", `
 z-index: auto;
 outline: none;
 width: 100%;
 position: relative;
 `), l$25("select-menu", `
 margin: 4px 0;
 box-shadow: var(--n-menu-box-shadow);
 `, [$$n({
  originalTransition: "background-color .3s var(--n-bezier), box-shadow .3s var(--n-bezier)"
})])]);
function c$1x(n3) {
  return Array.isArray(n3) ? n3 : [n3];
}
const a$1F = {
  STOP: "STOP"
};
function s$1w(n3, r3) {
  const e28 = r3(n3);
  n3.children !== void 0 && e28 !== a$1F.STOP && n3.children.forEach((i) => s$1w(i, r3));
}
function o$17(n3, r3 = {}) {
  const { preserveGroup: e28 = false } = r3, i = [], f3 = e28 ? (t3) => {
    t3.isLeaf || (i.push(t3.key), u3(t3.children));
  } : (t3) => {
    t3.isLeaf || (t3.isGroup || i.push(t3.key), u3(t3.children));
  };
  function u3(t3) {
    t3.forEach(f3);
  }
  return u3(n3), i;
}
function l$1n(n3, r3) {
  const { isLeaf: e28 } = n3;
  return e28 !== void 0 ? e28 : !r3(n3);
}
function d$1l(n3) {
  return n3.children;
}
function y$S(n3) {
  return n3.key;
}
function h$1k() {
  return false;
}
function A$y(n3, r3) {
  const { isLeaf: e28 } = n3;
  return !(e28 === false && !Array.isArray(r3(n3)));
}
function p$3f(n3) {
  return n3.disabled === true;
}
function v$Q(n3, r3) {
  return n3.isLeaf === false && !Array.isArray(r3(n3));
}
function m$1A(n3) {
  var r3;
  return n3 == null ? [] : Array.isArray(n3) ? n3 : (r3 = n3.checkedKeys) !== null && r3 !== void 0 ? r3 : [];
}
function E$x(n3) {
  var r3;
  return n3 == null || Array.isArray(n3) ? [] : (r3 = n3.indeterminateKeys) !== null && r3 !== void 0 ? r3 : [];
}
function S$A(n3, r3) {
  const e28 = new Set(n3);
  return r3.forEach((i) => {
    e28.has(i) || e28.add(i);
  }), Array.from(e28);
}
function G$s(n3, r3) {
  const e28 = new Set(n3);
  return r3.forEach((i) => {
    e28.has(i) && e28.delete(i);
  }), Array.from(e28);
}
function K$l(n3) {
  return (n3 == null ? void 0 : n3.type) === "group";
}
function g$11(n3) {
  const r3 = /* @__PURE__ */ new Map();
  return n3.forEach((e28, i) => {
    r3.set(e28.key, i);
  }), (e28) => {
    var i;
    return (i = r3.get(e28)) !== null && i !== void 0 ? i : null;
  };
}
class R$m extends Error {
  constructor() {
    super(), this.message = "SubtreeNotLoadedError: checking a subtree whose required nodes are not fully loaded.";
  }
}
function U$t(r3, s3, e28, n3) {
  return m$1z(s3.concat(r3), e28, n3, false);
}
function D$E(r3, s3) {
  const e28 = /* @__PURE__ */ new Set();
  return r3.forEach((n3) => {
    const d3 = s3.treeNodeMap.get(n3);
    if (d3 !== void 0) {
      let t3 = d3.parent;
      for (; t3 !== null && !(t3.disabled || e28.has(t3.key)); )
        e28.add(t3.key), t3 = t3.parent;
    }
  }), e28;
}
function q$t(r3, s3, e28, n3) {
  const d3 = m$1z(s3, e28, n3, false), t3 = m$1z(r3, e28, n3, true), f3 = D$E(r3, e28), l3 = [];
  return d3.forEach((o3) => {
    (t3.has(o3) || f3.has(o3)) && l3.push(o3);
  }), l3.forEach((o3) => d3.delete(o3)), d3;
}
function V$q(r3, s3) {
  const { checkedKeys: e28, keysToCheck: n3, keysToUncheck: d3, indeterminateKeys: t3, cascade: f3, leafOnly: l3, checkStrategy: o3, allowNotLoaded: h3 } = r3;
  if (!f3)
    return n3 !== void 0 ? {
      checkedKeys: S$A(e28, n3),
      indeterminateKeys: Array.from(t3)
    } : d3 !== void 0 ? {
      checkedKeys: G$s(e28, d3),
      indeterminateKeys: Array.from(t3)
    } : {
      checkedKeys: Array.from(e28),
      indeterminateKeys: Array.from(t3)
    };
  const { levelTreeNodeMap: y3 } = s3;
  let a3;
  d3 !== void 0 ? a3 = q$t(d3, e28, s3, h3) : n3 !== void 0 ? a3 = U$t(n3, e28, s3, h3) : a3 = m$1z(e28, s3, h3, false);
  const T3 = o3 === "parent", E3 = o3 === "child" || l3, i = a3, b3 = /* @__PURE__ */ new Set(), x3 = Math.max.apply(null, Array.from(y3.keys()));
  for (let k3 = x3; k3 >= 0; k3 -= 1) {
    const w3 = k3 === 0, L3 = y3.get(k3);
    for (const u3 of L3) {
      if (u3.isLeaf)
        continue;
      const { key: S3, shallowLoaded: p3 } = u3;
      if (E3 && p3 && u3.children.forEach((c3) => {
        !c3.disabled && !c3.isLeaf && c3.shallowLoaded && i.has(c3.key) && i.delete(c3.key);
      }), u3.disabled || !p3)
        continue;
      let C3 = true, K3 = false, g3 = true;
      for (const c3 of u3.children) {
        const A3 = c3.key;
        if (!c3.disabled) {
          if (g3 && (g3 = false), i.has(A3))
            K3 = true;
          else if (b3.has(A3)) {
            K3 = true, C3 = false;
            break;
          } else if (C3 = false, K3)
            break;
        }
      }
      C3 && !g3 ? (T3 && u3.children.forEach((c3) => {
        !c3.disabled && i.has(c3.key) && i.delete(c3.key);
      }), i.add(S3)) : K3 && b3.add(S3), w3 && E3 && i.has(S3) && i.delete(S3);
    }
  }
  return {
    checkedKeys: Array.from(i),
    indeterminateKeys: Array.from(b3)
  };
}
function m$1z(r3, s3, e28, n3) {
  const { treeNodeMap: d3, getChildren: t3 } = s3, f3 = /* @__PURE__ */ new Set(), l3 = new Set(r3);
  return r3.forEach((o3) => {
    const h3 = d3.get(o3);
    h3 !== void 0 && s$1w(h3, (y3) => {
      if (y3.disabled)
        return a$1F.STOP;
      const { key: a3 } = y3;
      if (!f3.has(a3) && (f3.add(a3), l3.add(a3), v$Q(y3.rawNode, t3))) {
        if (n3)
          return a$1F.STOP;
        if (!e28)
          throw new R$m();
      }
    });
  }), l3;
}
function i$1m(r3, { includeGroup: d3 = false, includeSelf: n3 = true }, a3) {
  var o3;
  const l3 = a3.treeNodeMap;
  let e28 = r3 == null ? null : (o3 = l3.get(r3)) !== null && o3 !== void 0 ? o3 : null;
  const t3 = {
    keyPath: [],
    treeNodePath: [],
    treeNode: e28
  };
  if (e28 != null && e28.ignored)
    return t3.treeNode = null, t3;
  for (; e28; )
    !e28.ignored && (d3 || !e28.isGroup) && t3.treeNodePath.push(e28), e28 = e28.parent;
  return t3.treeNodePath.reverse(), n3 || t3.treeNodePath.pop(), t3.keyPath = t3.treeNodePath.map((u3) => u3.key), t3;
}
function G$r(e28) {
  if (e28.length === 0)
    return null;
  const r3 = e28[0];
  return r3.isGroup || r3.ignored || r3.disabled ? r3.getNext() : r3;
}
function v$P(e28, r3) {
  const n3 = e28.siblings, s3 = n3.length, { index: i } = e28;
  return r3 ? n3[(i + 1) % s3] : i === n3.length - 1 ? null : n3[i + 1];
}
function h$1j(e28, r3, { loop: n3 = false, includeDisabled: s3 = false } = {}) {
  const i = r3 === "prev" ? d$1k : v$P, a3 = {
    reverse: r3 === "prev"
  };
  let f3 = false, c3 = null;
  function l3(t3) {
    if (t3 !== null) {
      if (t3 === e28) {
        if (!f3)
          f3 = true;
        else if (!e28.disabled && !e28.isGroup) {
          c3 = e28;
          return;
        }
      } else if ((!t3.disabled || s3) && !t3.ignored && !t3.isGroup) {
        c3 = t3;
        return;
      }
      if (t3.isGroup) {
        const u3 = g$10(t3, a3);
        u3 !== null ? c3 = u3 : l3(i(t3, n3));
      } else {
        const u3 = i(t3, false);
        if (u3 !== null)
          l3(u3);
        else {
          const o3 = p$3e(t3);
          o3 != null && o3.isGroup ? l3(i(o3, n3)) : n3 && l3(i(t3, true));
        }
      }
    }
  }
  return l3(e28), c3;
}
function d$1k(e28, r3) {
  const n3 = e28.siblings, s3 = n3.length, { index: i } = e28;
  return r3 ? n3[(i - 1 + s3) % s3] : i === 0 ? null : n3[i - 1];
}
function p$3e(e28) {
  return e28.parent;
}
function g$10(e28, r3 = {}) {
  const { reverse: n3 = false } = r3, { children: s3 } = e28;
  if (s3) {
    const { length: i } = s3, a3 = n3 ? i - 1 : 0, f3 = n3 ? -1 : i, c3 = n3 ? -1 : 1;
    for (let l3 = a3; l3 !== f3; l3 += c3) {
      const t3 = s3[l3];
      if (!t3.disabled && !t3.ignored)
        if (t3.isGroup) {
          const u3 = g$10(t3, r3);
          if (u3 !== null)
            return u3;
        } else
          return t3;
    }
  }
  return null;
}
const b$R = {
  getChild() {
    return this.ignored ? null : g$10(this);
  },
  getParent() {
    const { parent: e28 } = this;
    return e28 != null && e28.isGroup ? e28.getParent() : e28;
  },
  getNext(e28 = {}) {
    return h$1j(this, "next", e28);
  },
  getPrev(e28 = {}) {
    return h$1j(this, "prev", e28);
  }
};
function a$1E(u3, f3) {
  const c3 = f3 ? new Set(f3) : void 0, s3 = [];
  function i(t3) {
    t3.forEach((n3) => {
      s3.push(n3), !(n3.isLeaf || !n3.children || n3.ignored) && (n3.isGroup || c3 === void 0 || c3.has(n3.key)) && i(n3.children);
    });
  }
  return i(u3), s3;
}
function r$1q(n3, e28) {
  const t3 = n3.key;
  for (; e28; ) {
    if (e28.key === t3)
      return true;
    e28 = e28.parent;
  }
  return false;
}
function G$q(p3, d3, o3, a3, s3, K3 = null, l3 = 0) {
  const g3 = [];
  return p3.forEach((c3, f3) => {
    var i;
    const r3 = Object.create(a3);
    if (r3.rawNode = c3, r3.siblings = g3, r3.level = l3, r3.index = f3, r3.isFirstChild = f3 === 0, r3.isLastChild = f3 + 1 === p3.length, r3.parent = K3, !r3.ignored) {
      const u3 = s3(c3);
      Array.isArray(u3) && (r3.children = G$q(u3, d3, o3, a3, s3, r3, l3 + 1));
    }
    g3.push(r3), d3.set(r3.key, r3), o3.has(l3) || o3.set(l3, []), (i = o3.get(l3)) === null || i === void 0 || i.push(r3);
  }), g3;
}
function U$s(p3, d3 = {}) {
  var o3;
  const a3 = /* @__PURE__ */ new Map(), s3 = /* @__PURE__ */ new Map(), { getDisabled: K3 = p$3f, getIgnored: l3 = h$1k, getIsGroup: g3 = K$l, getKey: c3 = y$S } = d3, f3 = (o3 = d3.getChildren) !== null && o3 !== void 0 ? o3 : d$1l, i = d3.ignoreEmptyChildren ? (e28) => {
    const t3 = f3(e28);
    return Array.isArray(t3) ? t3.length ? t3 : null : t3;
  } : f3, r3 = Object.assign({
    get key() {
      return c3(this.rawNode);
    },
    get disabled() {
      return K3(this.rawNode);
    },
    get isGroup() {
      return g3(this.rawNode);
    },
    get isLeaf() {
      return l$1n(this.rawNode, i);
    },
    get shallowLoaded() {
      return A$y(this.rawNode, i);
    },
    get ignored() {
      return l3(this.rawNode);
    },
    contains(e28) {
      return r$1q(this, e28);
    }
  }, b$R), u3 = G$q(p3, a3, s3, r3, i);
  function O3(e28) {
    if (e28 == null)
      return null;
    const t3 = a3.get(e28);
    return t3 && !t3.isGroup && !t3.ignored ? t3 : null;
  }
  function w3(e28) {
    if (e28 == null)
      return null;
    const t3 = a3.get(e28);
    return t3 && !t3.ignored ? t3 : null;
  }
  function P3(e28, t3) {
    const n3 = w3(e28);
    return n3 ? n3.getPrev(t3) : null;
  }
  function I3(e28, t3) {
    const n3 = w3(e28);
    return n3 ? n3.getNext(t3) : null;
  }
  function _3(e28) {
    const t3 = w3(e28);
    return t3 ? t3.getParent() : null;
  }
  function x3(e28) {
    const t3 = w3(e28);
    return t3 ? t3.getChild() : null;
  }
  const h3 = {
    treeNodes: u3,
    treeNodeMap: a3,
    levelTreeNodeMap: s3,
    maxLevel: Math.max(...s3.keys()),
    getChildren: i,
    getFlattenedNodes(e28) {
      return a$1E(u3, e28);
    },
    getNode: O3,
    getPrev: P3,
    getNext: I3,
    getParent: _3,
    getChild: x3,
    getFirstAvailableNode() {
      return G$r(u3);
    },
    getPath(e28, t3 = {}) {
      return i$1m(e28, t3, h3);
    },
    getCheckedKeys(e28, t3 = {}) {
      const { cascade: n3 = true, leafOnly: m3 = false, checkStrategy: N3 = "all", allowNotLoaded: y3 = false } = t3;
      return V$q({
        checkedKeys: m$1A(e28),
        indeterminateKeys: E$x(e28),
        cascade: n3,
        leafOnly: m3,
        checkStrategy: N3,
        allowNotLoaded: y3
      }, h3);
    },
    check(e28, t3, n3 = {}) {
      const { cascade: m3 = true, leafOnly: N3 = false, checkStrategy: y3 = "all", allowNotLoaded: L3 = false } = n3;
      return V$q({
        checkedKeys: m$1A(t3),
        indeterminateKeys: E$x(t3),
        keysToCheck: e28 == null ? [] : c$1x(e28),
        cascade: m3,
        leafOnly: N3,
        checkStrategy: y3,
        allowNotLoaded: L3
      }, h3);
    },
    uncheck(e28, t3, n3 = {}) {
      const { cascade: m3 = true, leafOnly: N3 = false, checkStrategy: y3 = "all", allowNotLoaded: L3 = false } = n3;
      return V$q({
        checkedKeys: m$1A(t3),
        indeterminateKeys: E$x(t3),
        keysToUncheck: e28 == null ? [] : c$1x(e28),
        cascade: m3,
        leafOnly: N3,
        checkStrategy: y3,
        allowNotLoaded: L3
      }, h3);
    },
    getNonLeafKeys(e28 = {}) {
      return o$17(u3, e28);
    }
  };
  return h3;
}
const l$1m = r$2a([l$25("base-selection", `
 --n-padding-single: var(--n-padding-single-top) var(--n-padding-single-right) var(--n-padding-single-bottom) var(--n-padding-single-left);
 --n-padding-multiple: var(--n-padding-multiple-top) var(--n-padding-multiple-right) var(--n-padding-multiple-bottom) var(--n-padding-multiple-left);
 position: relative;
 z-index: auto;
 box-shadow: none;
 width: 100%;
 max-width: 100%;
 display: inline-block;
 vertical-align: bottom;
 border-radius: var(--n-border-radius);
 min-height: var(--n-height);
 line-height: 1.5;
 font-size: var(--n-font-size);
 `, [l$25("base-loading", `
 color: var(--n-loading-color);
 `), l$25("base-selection-tags", "min-height: var(--n-height);"), M$y("border, state-border", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 pointer-events: none;
 border: var(--n-border);
 border-radius: inherit;
 transition:
 box-shadow .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `), M$y("state-border", `
 z-index: 1;
 border-color: #0000;
 `), l$25("base-suffix", `
 cursor: pointer;
 position: absolute;
 top: 50%;
 transform: translateY(-50%);
 right: 10px;
 `, [M$y("arrow", `
 font-size: var(--n-arrow-size);
 color: var(--n-arrow-color);
 transition: color .3s var(--n-bezier);
 `)]), l$25("base-selection-overlay", `
 display: flex;
 align-items: center;
 white-space: nowrap;
 pointer-events: none;
 position: absolute;
 top: 0;
 right: 0;
 bottom: 0;
 left: 0;
 padding: var(--n-padding-single);
 transition: color .3s var(--n-bezier);
 `, [M$y("wrapper", `
 flex-basis: 0;
 flex-grow: 1;
 overflow: hidden;
 text-overflow: ellipsis;
 `)]), l$25("base-selection-placeholder", `
 color: var(--n-placeholder-color);
 `, [M$y("inner", `
 max-width: 100%;
 overflow: hidden;
 `)]), l$25("base-selection-tags", `
 cursor: pointer;
 outline: none;
 box-sizing: border-box;
 position: relative;
 z-index: auto;
 display: flex;
 padding: var(--n-padding-multiple);
 flex-wrap: wrap;
 align-items: center;
 width: 100%;
 vertical-align: bottom;
 background-color: var(--n-color);
 border-radius: inherit;
 transition:
 color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `), l$25("base-selection-label", `
 height: var(--n-height);
 display: inline-flex;
 width: 100%;
 vertical-align: bottom;
 cursor: pointer;
 outline: none;
 z-index: auto;
 box-sizing: border-box;
 position: relative;
 transition:
 color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 border-radius: inherit;
 background-color: var(--n-color);
 align-items: center;
 `, [l$25("base-selection-input", `
 font-size: inherit;
 line-height: inherit;
 outline: none;
 cursor: pointer;
 box-sizing: border-box;
 border:none;
 width: 100%;
 padding: var(--n-padding-single);
 background-color: #0000;
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 caret-color: var(--n-caret-color);
 `, [M$y("content", `
 text-overflow: ellipsis;
 overflow: hidden;
 white-space: nowrap; 
 `)]), M$y("render-label", `
 color: var(--n-text-color);
 `)]), x$I("disabled", [r$2a("&:hover", [M$y("state-border", `
 box-shadow: var(--n-box-shadow-hover);
 border: var(--n-border-hover);
 `)]), g$1j("focus", [M$y("state-border", `
 box-shadow: var(--n-box-shadow-focus);
 border: var(--n-border-focus);
 `)]), g$1j("active", [M$y("state-border", `
 box-shadow: var(--n-box-shadow-active);
 border: var(--n-border-active);
 `), l$25("base-selection-label", "background-color: var(--n-color-active);"), l$25("base-selection-tags", "background-color: var(--n-color-active);")])]), g$1j("disabled", "cursor: not-allowed;", [M$y("arrow", `
 color: var(--n-arrow-color-disabled);
 `), l$25("base-selection-label", `
 cursor: not-allowed;
 background-color: var(--n-color-disabled);
 `, [l$25("base-selection-input", `
 cursor: not-allowed;
 color: var(--n-text-color-disabled);
 `), M$y("render-label", `
 color: var(--n-text-color-disabled);
 `)]), l$25("base-selection-tags", `
 cursor: not-allowed;
 background-color: var(--n-color-disabled);
 `), l$25("base-selection-placeholder", `
 cursor: not-allowed;
 color: var(--n-placeholder-color-disabled);
 `)]), l$25("base-selection-input-tag", `
 height: calc(var(--n-height) - 6px);
 line-height: calc(var(--n-height) - 6px);
 outline: none;
 display: none;
 position: relative;
 margin-bottom: 3px;
 max-width: 100%;
 vertical-align: bottom;
 `, [M$y("input", `
 font-size: inherit;
 font-family: inherit;
 min-width: 1px;
 padding: 0;
 background-color: #0000;
 outline: none;
 border: none;
 max-width: 100%;
 overflow: hidden;
 width: 1em;
 line-height: inherit;
 cursor: pointer;
 color: var(--n-text-color);
 caret-color: var(--n-caret-color);
 `), M$y("mirror", `
 position: absolute;
 left: 0;
 top: 0;
 white-space: pre;
 visibility: hidden;
 user-select: none;
 -webkit-user-select: none;
 opacity: 0;
 `)]), ["warning", "error"].map((r3) => g$1j(`${r3}-status`, [M$y("state-border", `border: var(--n-border-${r3});`), x$I("disabled", [r$2a("&:hover", [M$y("state-border", `
 box-shadow: var(--n-box-shadow-hover-${r3});
 border: var(--n-border-hover-${r3});
 `)]), g$1j("active", [M$y("state-border", `
 box-shadow: var(--n-box-shadow-active-${r3});
 border: var(--n-border-active-${r3});
 `), l$25("base-selection-label", `background-color: var(--n-color-active-${r3});`), l$25("base-selection-tags", `background-color: var(--n-color-active-${r3});`)]), g$1j("focus", [M$y("state-border", `
 box-shadow: var(--n-box-shadow-focus-${r3});
 border: var(--n-border-focus-${r3});
 `)])])]))]), l$25("base-selection-popover", `
 margin-bottom: -3px;
 display: flex;
 flex-wrap: wrap;
 margin-right: -8px;
 `), l$25("base-selection-tag-wrapper", `
 max-width: 100%;
 display: inline-flex;
 padding: 0 7px 3px 0;
 `, [r$2a("&:last-child", "padding-right: 0;"), l$25("tag", `
 font-size: 14px;
 max-width: 100%;
 `, [M$y("content", `
 line-height: 1.25;
 text-overflow: ellipsis;
 overflow: hidden;
 `)])])]);
const p$3d = {
  paddingSingle: "0 26px 0 12px",
  paddingMultiple: "3px 26px 0 12px",
  clearSize: "16px",
  arrowSize: "16px"
};
const T$C = (d3) => {
  const {
    borderRadius: c3,
    textColor2: p3,
    textColorDisabled: s3,
    inputColor: i,
    inputColorDisabled: b3,
    primaryColor: r3,
    primaryColorHover: a3,
    warningColor: e28,
    warningColorHover: n3,
    errorColor: l3,
    errorColorHover: t3,
    borderColor: h3,
    iconColor: x3,
    iconColorDisabled: C3,
    clearColor: g3,
    clearColorHover: m3,
    clearColorPressed: v3,
    placeholderColor: $3,
    placeholderColorDisabled: S3,
    fontSizeTiny: u3,
    fontSizeSmall: w3,
    fontSizeMedium: f3,
    fontSizeLarge: H3,
    heightTiny: A3,
    heightSmall: E3,
    heightMedium: W3,
    heightLarge: D3
  } = d3;
  return Object.assign(Object.assign({}, p$3d), {
    fontSizeTiny: u3,
    fontSizeSmall: w3,
    fontSizeMedium: f3,
    fontSizeLarge: H3,
    heightTiny: A3,
    heightSmall: E3,
    heightMedium: W3,
    heightLarge: D3,
    borderRadius: c3,
    textColor: p3,
    textColorDisabled: s3,
    placeholderColor: $3,
    placeholderColorDisabled: S3,
    color: i,
    colorDisabled: b3,
    colorActive: i,
    border: `1px solid ${h3}`,
    borderHover: `1px solid ${a3}`,
    borderActive: `1px solid ${r3}`,
    borderFocus: `1px solid ${a3}`,
    boxShadowHover: "none",
    boxShadowActive: `0 0 0 2px ${J$p(r3, {
      alpha: 0.2
    })}`,
    boxShadowFocus: `0 0 0 2px ${J$p(r3, {
      alpha: 0.2
    })}`,
    caretColor: r3,
    arrowColor: x3,
    arrowColorDisabled: C3,
    loadingColor: r3,
    borderWarning: `1px solid ${e28}`,
    borderHoverWarning: `1px solid ${n3}`,
    borderActiveWarning: `1px solid ${e28}`,
    borderFocusWarning: `1px solid ${n3}`,
    boxShadowHoverWarning: "none",
    boxShadowActiveWarning: `0 0 0 2px ${J$p(e28, {
      alpha: 0.2
    })}`,
    boxShadowFocusWarning: `0 0 0 2px ${J$p(e28, {
      alpha: 0.2
    })}`,
    colorActiveWarning: i,
    caretColorWarning: e28,
    borderError: `1px solid ${l3}`,
    borderHoverError: `1px solid ${t3}`,
    borderActiveError: `1px solid ${l3}`,
    borderFocusError: `1px solid ${t3}`,
    boxShadowHoverError: "none",
    boxShadowActiveError: `0 0 0 2px ${J$p(l3, {
      alpha: 0.2
    })}`,
    boxShadowFocusError: `0 0 0 2px ${J$p(l3, {
      alpha: 0.2
    })}`,
    colorActiveError: i,
    caretColorError: l3,
    clearColor: g3,
    clearColorHover: m3,
    clearColorPressed: v3
  });
}, j$p = G$w({
  name: "InternalSelection",
  common: d$1T,
  peers: {
    Popover: b$11
  },
  self: T$C
}), V$p = j$p;
const n$18 = "v-hidden", j$o = c$1N("[v-hidden]", {
  display: "none!important"
}), D$D = defineComponent({
  name: "Overflow",
  props: {
    getCounter: Function,
    getTail: Function,
    updateCounter: Function,
    onUpdateCount: Function,
    onUpdateOverflow: Function
  },
  setup(e28, { slots: m3 }) {
    const v3 = ref$1(null), A3 = ref$1(null);
    function p3(U3) {
      const { value: s3 } = v3, { getCounter: b3, getTail: c3 } = e28;
      let o3;
      if (b3 !== void 0 ? o3 = b3() : o3 = A3.value, !s3 || !o3)
        return;
      o3.hasAttribute(n$18) && o3.removeAttribute(n$18);
      const { children: C3 } = s3;
      if (U3.showAllItemsBeforeCalculate)
        for (const t3 of C3)
          t3.hasAttribute(n$18) && t3.removeAttribute(n$18);
      const d3 = s3.offsetWidth, W3 = [], i = m3.tail ? c3 == null ? void 0 : c3() : null;
      let f3 = i ? i.offsetWidth : 0, a3 = false;
      const w3 = s3.children.length - (m3.tail ? 1 : 0);
      for (let t3 = 0; t3 < w3 - 1; ++t3) {
        if (t3 < 0)
          continue;
        const r3 = C3[t3];
        if (a3) {
          r3.hasAttribute(n$18) || r3.setAttribute(n$18, "");
          continue;
        } else
          r3.hasAttribute(n$18) && r3.removeAttribute(n$18);
        const y3 = r3.offsetWidth;
        if (f3 += y3, W3[t3] = y3, f3 > d3) {
          const { updateCounter: x3 } = e28;
          for (let l3 = t3; l3 >= 0; --l3) {
            const h3 = w3 - 1 - l3;
            x3 !== void 0 ? x3(h3) : o3.textContent = `${h3}`;
            const g3 = o3.offsetWidth;
            if (f3 -= W3[l3], f3 + g3 <= d3 || l3 === 0) {
              a3 = true, t3 = l3 - 1, i && (t3 === -1 ? (i.style.maxWidth = `${d3 - g3}px`, i.style.boxSizing = "border-box") : i.style.maxWidth = "");
              const { onUpdateCount: F3 } = e28;
              F3 && F3(h3);
              break;
            }
          }
        }
      }
      const { onUpdateOverflow: u3 } = e28;
      a3 ? u3 !== void 0 && u3(true) : (u3 !== void 0 && u3(false), o3.setAttribute(n$18, ""));
    }
    const S3 = f$1Z();
    return j$o.mount({
      id: "vueuc/overflow",
      head: true,
      anchorMetaName: o$1k,
      ssr: S3
    }), onMounted(() => p3({
      showAllItemsBeforeCalculate: false
    })), {
      selfRef: v3,
      counterRef: A3,
      sync: p3
    };
  },
  render() {
    const { $slots: e28 } = this;
    return nextTick(() => this.sync({
      showAllItemsBeforeCalculate: false
    })), h$1R("div", {
      class: "v-overflow",
      ref: "selfRef"
    }, [
      renderSlot(e28, "default"),
      e28.counter ? e28.counter() : h$1R("span", {
        style: {
          display: "inline-block"
        },
        ref: "counterRef"
      }),
      e28.tail ? e28.tail() : null
    ]);
  }
});
function e$1g(t3) {
  switch (typeof t3) {
    case "string":
      return t3 || void 0;
    case "number":
      return String(t3);
    default:
      return;
  }
}
function a$1D(r3, n3) {
  n3 && (onMounted(() => {
    const {
      value: e28
    } = r3;
    e28 && o$1A.registerHandler(e28, n3);
  }), onBeforeUnmount(() => {
    const {
      value: e28
    } = r3;
    e28 && o$1A.unregisterHandler(e28);
  }));
}
const Kt$3 = defineComponent({
  name: "InternalSelection",
  props: Object.assign(Object.assign({}, _$F.props), {
    clsPrefix: {
      type: String,
      required: true
    },
    bordered: {
      type: Boolean,
      default: void 0
    },
    active: Boolean,
    pattern: {
      type: String,
      default: ""
    },
    placeholder: String,
    selectedOption: {
      type: Object,
      default: null
    },
    selectedOptions: {
      type: Array,
      default: null
    },
    labelField: {
      type: String,
      default: "label"
    },
    valueField: {
      type: String,
      default: "value"
    },
    multiple: Boolean,
    filterable: Boolean,
    clearable: Boolean,
    disabled: Boolean,
    size: {
      type: String,
      default: "medium"
    },
    loading: Boolean,
    autofocus: Boolean,
    showArrow: {
      type: Boolean,
      default: true
    },
    inputProps: Object,
    focused: Boolean,
    renderTag: Function,
    onKeydown: Function,
    onClick: Function,
    onBlur: Function,
    onFocus: Function,
    onDeleteOption: Function,
    maxTagCount: [String, Number],
    ellipsisTagPopoverProps: Object,
    onClear: Function,
    onPatternInput: Function,
    onPatternFocus: Function,
    onPatternBlur: Function,
    renderLabel: Function,
    status: String,
    inlineThemeDisabled: Boolean,
    ignoreComposition: {
      type: Boolean,
      default: true
    },
    onResize: Function
  }),
  setup(t3) {
    const {
      mergedClsPrefixRef: _3,
      mergedRtlRef: F3
    } = a$2x(t3), c3 = v$17("InternalSelection", F3, _3), p3 = ref$1(null), s3 = ref$1(null), y3 = ref$1(null), o3 = ref$1(null), O3 = ref$1(null), g3 = ref$1(null), f3 = ref$1(null), h3 = ref$1(null), m3 = ref$1(null), w3 = ref$1(null), C3 = ref$1(false), u3 = ref$1(false), x3 = ref$1(false), v3 = _$F("InternalSelection", "-internal-selection", l$1m, V$p, t3, toRef$1(t3, "clsPrefix")), d3 = computed(() => t3.clearable && !t3.disabled && (x3.value || t3.active)), b3 = computed(() => t3.selectedOption ? t3.renderTag ? t3.renderTag({
      option: t3.selectedOption,
      handleClose: () => {
      }
    }) : t3.renderLabel ? t3.renderLabel(t3.selectedOption, true) : o$1c(t3.selectedOption[t3.labelField], t3.selectedOption, true) : t3.placeholder), E3 = computed(() => {
      const e28 = t3.selectedOption;
      if (e28)
        return e28[t3.labelField];
    }), I3 = computed(() => t3.multiple ? !!(Array.isArray(t3.selectedOptions) && t3.selectedOptions.length) : t3.selectedOption !== null);
    function P3() {
      var e28;
      const {
        value: n3
      } = p3;
      if (n3) {
        const {
          value: i
        } = s3;
        i && (i.style.width = `${n3.offsetWidth}px`, t3.maxTagCount !== "responsive" && ((e28 = m3.value) === null || e28 === void 0 || e28.sync({
          showAllItemsBeforeCalculate: false
        })));
      }
    }
    function S3() {
      const {
        value: e28
      } = w3;
      e28 && (e28.style.display = "none");
    }
    function A3() {
      const {
        value: e28
      } = w3;
      e28 && (e28.style.display = "inline-block");
    }
    watch(toRef$1(t3, "active"), (e28) => {
      e28 || S3();
    }), watch(toRef$1(t3, "pattern"), () => {
      t3.multiple && nextTick(P3);
    });
    function W3(e28) {
      const {
        onFocus: n3
      } = t3;
      n3 && n3(e28);
    }
    function U3(e28) {
      const {
        onBlur: n3
      } = t3;
      n3 && n3(e28);
    }
    function k3(e28) {
      const {
        onDeleteOption: n3
      } = t3;
      n3 && n3(e28);
    }
    function B3(e28) {
      const {
        onClear: n3
      } = t3;
      n3 && n3(e28);
    }
    function r3(e28) {
      const {
        onPatternInput: n3
      } = t3;
      n3 && n3(e28);
    }
    function te2(e28) {
      var n3;
      (!e28.relatedTarget || !(!((n3 = y3.value) === null || n3 === void 0) && n3.contains(e28.relatedTarget))) && W3(e28);
    }
    function ne2(e28) {
      var n3;
      !((n3 = y3.value) === null || n3 === void 0) && n3.contains(e28.relatedTarget) || U3(e28);
    }
    function oe2(e28) {
      B3(e28);
    }
    function le2() {
      x3.value = true;
    }
    function ie2() {
      x3.value = false;
    }
    function re2(e28) {
      !t3.active || !t3.filterable || e28.target !== s3.value && e28.preventDefault();
    }
    function q3(e28) {
      k3(e28);
    }
    function ae2(e28) {
      if (e28.key === "Backspace" && !$3.value && !t3.pattern.length) {
        const {
          selectedOptions: n3
        } = t3;
        n3 != null && n3.length && q3(n3[n3.length - 1]);
      }
    }
    const $3 = ref$1(false);
    let L3 = null;
    function se2(e28) {
      const {
        value: n3
      } = p3;
      if (n3) {
        const i = e28.target.value;
        n3.textContent = i, P3();
      }
      t3.ignoreComposition && $3.value ? L3 = e28 : r3(e28);
    }
    function ue2() {
      $3.value = true;
    }
    function de2() {
      $3.value = false, t3.ignoreComposition && r3(L3), L3 = null;
    }
    function ce2(e28) {
      var n3;
      u3.value = true, (n3 = t3.onPatternFocus) === null || n3 === void 0 || n3.call(t3, e28);
    }
    function fe2(e28) {
      var n3;
      u3.value = false, (n3 = t3.onPatternBlur) === null || n3 === void 0 || n3.call(t3, e28);
    }
    function he2() {
      var e28, n3;
      if (t3.filterable)
        u3.value = false, (e28 = g3.value) === null || e28 === void 0 || e28.blur(), (n3 = s3.value) === null || n3 === void 0 || n3.blur();
      else if (t3.multiple) {
        const {
          value: i
        } = o3;
        i == null || i.blur();
      } else {
        const {
          value: i
        } = O3;
        i == null || i.blur();
      }
    }
    function ve2() {
      var e28, n3, i;
      t3.filterable ? (u3.value = false, (e28 = g3.value) === null || e28 === void 0 || e28.focus()) : t3.multiple ? (n3 = o3.value) === null || n3 === void 0 || n3.focus() : (i = O3.value) === null || i === void 0 || i.focus();
    }
    function be2() {
      const {
        value: e28
      } = s3;
      e28 && (A3(), e28.focus());
    }
    function pe2() {
      const {
        value: e28
      } = s3;
      e28 && e28.blur();
    }
    function ge2(e28) {
      const {
        value: n3
      } = f3;
      n3 && n3.setTextContent(`+${e28}`);
    }
    function me2() {
      const {
        value: e28
      } = h3;
      return e28;
    }
    function we2() {
      return s3.value;
    }
    let j3 = null;
    function H3() {
      j3 !== null && window.clearTimeout(j3);
    }
    function Ce2() {
      t3.active || (H3(), j3 = window.setTimeout(() => {
        I3.value && (C3.value = true);
      }, 100));
    }
    function xe2() {
      H3();
    }
    function ye2(e28) {
      e28 || (H3(), C3.value = false);
    }
    watch(I3, (e28) => {
      e28 || (C3.value = false);
    }), onMounted(() => {
      watchEffect(() => {
        const e28 = g3.value;
        e28 && (t3.disabled ? e28.removeAttribute("tabindex") : e28.tabIndex = u3.value ? -1 : 0);
      });
    }), a$1D(y3, t3.onResize);
    const {
      inlineThemeDisabled: G3
    } = t3, J3 = computed(() => {
      const {
        size: e28
      } = t3, {
        common: {
          cubicBezierEaseInOut: n3
        },
        self: {
          borderRadius: i,
          color: Ie2,
          placeholderColor: Pe2,
          textColor: Re2,
          paddingSingle: Te2,
          paddingMultiple: Fe2,
          caretColor: Oe2,
          colorDisabled: $e2,
          textColorDisabled: _e2,
          placeholderColorDisabled: Ee2,
          colorActive: Se2,
          boxShadowFocus: Be2,
          boxShadowActive: Me2,
          boxShadowHover: ze2,
          border: De2,
          borderFocus: Ae2,
          borderHover: We2,
          borderActive: ke2,
          arrowColor: Le2,
          arrowColorDisabled: je2,
          loadingColor: He2,
          colorActiveWarning: Ke2,
          boxShadowFocusWarning: Ne2,
          boxShadowActiveWarning: Ve2,
          boxShadowHoverWarning: Ue2,
          borderWarning: qe2,
          borderFocusWarning: Ge2,
          borderHoverWarning: Je2,
          borderActiveWarning: Qe2,
          colorActiveError: Xe2,
          boxShadowFocusError: Ye2,
          boxShadowActiveError: Ze2,
          boxShadowHoverError: et2,
          borderError: tt2,
          borderFocusError: nt2,
          borderHoverError: ot2,
          borderActiveError: lt2,
          clearColor: it2,
          clearColorHover: rt2,
          clearColorPressed: at2,
          clearSize: st2,
          arrowSize: ut2,
          [_$H("height", e28)]: dt2,
          [_$H("fontSize", e28)]: ct2
        }
      } = v3.value, M3 = f$1f(Te2), z3 = f$1f(Fe2);
      return {
        "--n-bezier": n3,
        "--n-border": De2,
        "--n-border-active": ke2,
        "--n-border-focus": Ae2,
        "--n-border-hover": We2,
        "--n-border-radius": i,
        "--n-box-shadow-active": Me2,
        "--n-box-shadow-focus": Be2,
        "--n-box-shadow-hover": ze2,
        "--n-caret-color": Oe2,
        "--n-color": Ie2,
        "--n-color-active": Se2,
        "--n-color-disabled": $e2,
        "--n-font-size": ct2,
        "--n-height": dt2,
        "--n-padding-single-top": M3.top,
        "--n-padding-multiple-top": z3.top,
        "--n-padding-single-right": M3.right,
        "--n-padding-multiple-right": z3.right,
        "--n-padding-single-left": M3.left,
        "--n-padding-multiple-left": z3.left,
        "--n-padding-single-bottom": M3.bottom,
        "--n-padding-multiple-bottom": z3.bottom,
        "--n-placeholder-color": Pe2,
        "--n-placeholder-color-disabled": Ee2,
        "--n-text-color": Re2,
        "--n-text-color-disabled": _e2,
        "--n-arrow-color": Le2,
        "--n-arrow-color-disabled": je2,
        "--n-loading-color": He2,
        "--n-color-active-warning": Ke2,
        "--n-box-shadow-focus-warning": Ne2,
        "--n-box-shadow-active-warning": Ve2,
        "--n-box-shadow-hover-warning": Ue2,
        "--n-border-warning": qe2,
        "--n-border-focus-warning": Ge2,
        "--n-border-hover-warning": Je2,
        "--n-border-active-warning": Qe2,
        "--n-color-active-error": Xe2,
        "--n-box-shadow-focus-error": Ye2,
        "--n-box-shadow-active-error": Ze2,
        "--n-box-shadow-hover-error": et2,
        "--n-border-error": tt2,
        "--n-border-focus-error": nt2,
        "--n-border-hover-error": ot2,
        "--n-border-active-error": lt2,
        "--n-clear-size": st2,
        "--n-clear-color": it2,
        "--n-clear-color-hover": rt2,
        "--n-clear-color-pressed": at2,
        "--n-arrow-size": ut2
      };
    }), R3 = G3 ? E$J("internal-selection", computed(() => t3.size[0]), J3, t3) : void 0;
    return {
      mergedTheme: v3,
      mergedClearable: d3,
      mergedClsPrefix: _3,
      rtlEnabled: c3,
      patternInputFocused: u3,
      filterablePlaceholder: b3,
      label: E3,
      selected: I3,
      showTagsPanel: C3,
      isComposing: $3,
      counterRef: f3,
      counterWrapperRef: h3,
      patternInputMirrorRef: p3,
      patternInputRef: s3,
      selfRef: y3,
      multipleElRef: o3,
      singleElRef: O3,
      patternInputWrapperRef: g3,
      overflowRef: m3,
      inputTagElRef: w3,
      handleMouseDown: re2,
      handleFocusin: te2,
      handleClear: oe2,
      handleMouseEnter: le2,
      handleMouseLeave: ie2,
      handleDeleteOption: q3,
      handlePatternKeyDown: ae2,
      handlePatternInputInput: se2,
      handlePatternInputBlur: fe2,
      handlePatternInputFocus: ce2,
      handleMouseEnterCounter: Ce2,
      handleMouseLeaveCounter: xe2,
      handleFocusout: ne2,
      handleCompositionEnd: de2,
      handleCompositionStart: ue2,
      onPopoverUpdateShow: ye2,
      focus: ve2,
      focusInput: be2,
      blur: he2,
      blurInput: pe2,
      updateCounter: ge2,
      getCounter: me2,
      getTail: we2,
      renderLabel: t3.renderLabel,
      cssVars: G3 ? void 0 : J3,
      themeClass: R3 == null ? void 0 : R3.themeClass,
      onRender: R3 == null ? void 0 : R3.onRender
    };
  },
  render() {
    const {
      status: t3,
      multiple: _3,
      size: F3,
      disabled: c3,
      filterable: p3,
      maxTagCount: s3,
      bordered: y3,
      clsPrefix: o3,
      ellipsisTagPopoverProps: O3,
      onRender: g3,
      renderTag: f3,
      renderLabel: h3
    } = this;
    g3 == null || g3();
    const m3 = s3 === "responsive", w3 = typeof s3 == "number", C3 = m3 || w3, u3 = h$1R(n$1H, null, {
      default: () => h$1R(x$y, {
        clsPrefix: o3,
        loading: this.loading,
        showArrow: this.showArrow,
        showClear: this.mergedClearable && this.selected,
        onClear: this.handleClear
      }, {
        default: () => {
          var v3, d3;
          return (d3 = (v3 = this.$slots).arrow) === null || d3 === void 0 ? void 0 : d3.call(v3);
        }
      })
    });
    let x3;
    if (_3) {
      const {
        labelField: v3
      } = this, d3 = (r3) => h$1R("div", {
        class: `${o3}-base-selection-tag-wrapper`,
        key: r3.value
      }, f3 ? f3({
        option: r3,
        handleClose: () => {
          this.handleDeleteOption(r3);
        }
      }) : h$1R(He$7, {
        size: F3,
        closable: !r3.disabled,
        disabled: c3,
        onClose: () => {
          this.handleDeleteOption(r3);
        },
        internalCloseIsButtonTag: false,
        internalCloseFocusable: false
      }, {
        default: () => h3 ? h3(r3, true) : o$1c(r3[v3], r3, true)
      })), b3 = () => (w3 ? this.selectedOptions.slice(0, s3) : this.selectedOptions).map(d3), E3 = p3 ? h$1R("div", {
        class: `${o3}-base-selection-input-tag`,
        ref: "inputTagElRef",
        key: "__input-tag__"
      }, h$1R("input", Object.assign({}, this.inputProps, {
        ref: "patternInputRef",
        tabindex: -1,
        disabled: c3,
        value: this.pattern,
        autofocus: this.autofocus,
        class: `${o3}-base-selection-input-tag__input`,
        onBlur: this.handlePatternInputBlur,
        onFocus: this.handlePatternInputFocus,
        onKeydown: this.handlePatternKeyDown,
        onInput: this.handlePatternInputInput,
        onCompositionstart: this.handleCompositionStart,
        onCompositionend: this.handleCompositionEnd
      })), h$1R("span", {
        ref: "patternInputMirrorRef",
        class: `${o3}-base-selection-input-tag__mirror`
      }, this.pattern)) : null, I3 = m3 ? () => h$1R("div", {
        class: `${o3}-base-selection-tag-wrapper`,
        ref: "counterWrapperRef"
      }, h$1R(He$7, {
        size: F3,
        ref: "counterRef",
        onMouseenter: this.handleMouseEnterCounter,
        onMouseleave: this.handleMouseLeaveCounter,
        disabled: c3
      })) : void 0;
      let P3;
      if (w3) {
        const r3 = this.selectedOptions.length - s3;
        r3 > 0 && (P3 = h$1R("div", {
          class: `${o3}-base-selection-tag-wrapper`,
          key: "__counter__"
        }, h$1R(He$7, {
          size: F3,
          ref: "counterRef",
          onMouseenter: this.handleMouseEnterCounter,
          disabled: c3
        }, {
          default: () => `+${r3}`
        })));
      }
      const S3 = m3 ? p3 ? h$1R(D$D, {
        ref: "overflowRef",
        updateCounter: this.updateCounter,
        getCounter: this.getCounter,
        getTail: this.getTail,
        style: {
          width: "100%",
          display: "flex",
          overflow: "hidden"
        }
      }, {
        default: b3,
        counter: I3,
        tail: () => E3
      }) : h$1R(D$D, {
        ref: "overflowRef",
        updateCounter: this.updateCounter,
        getCounter: this.getCounter,
        style: {
          width: "100%",
          display: "flex",
          overflow: "hidden"
        }
      }, {
        default: b3,
        counter: I3
      }) : w3 && P3 ? b3().concat(P3) : b3(), A3 = C3 ? () => h$1R("div", {
        class: `${o3}-base-selection-popover`
      }, m3 ? b3() : this.selectedOptions.map(d3)) : void 0, W3 = C3 ? Object.assign({
        show: this.showTagsPanel,
        trigger: "hover",
        overlap: true,
        placement: "top",
        width: "trigger",
        onUpdateShow: this.onPopoverUpdateShow,
        theme: this.mergedTheme.peers.Popover,
        themeOverrides: this.mergedTheme.peerOverrides.Popover
      }, O3) : null, k3 = (this.selected ? false : this.active ? !this.pattern && !this.isComposing : true) ? h$1R("div", {
        class: `${o3}-base-selection-placeholder ${o3}-base-selection-overlay`
      }, h$1R("div", {
        class: `${o3}-base-selection-placeholder__inner`
      }, this.placeholder)) : null, B3 = p3 ? h$1R("div", {
        ref: "patternInputWrapperRef",
        class: `${o3}-base-selection-tags`
      }, S3, m3 ? null : E3, u3) : h$1R("div", {
        ref: "multipleElRef",
        class: `${o3}-base-selection-tags`,
        tabindex: c3 ? void 0 : 0
      }, S3, u3);
      x3 = h$1R(Fragment, null, C3 ? h$1R(Ie$8, Object.assign({}, W3, {
        scrollable: true,
        style: "max-height: calc(var(--v-target-height) * 6.6);"
      }), {
        trigger: () => B3,
        default: A3
      }) : B3, k3);
    } else if (p3) {
      const v3 = this.pattern || this.isComposing, d3 = this.active ? !v3 : !this.selected, b3 = this.active ? false : this.selected;
      x3 = h$1R("div", {
        ref: "patternInputWrapperRef",
        class: `${o3}-base-selection-label`,
        title: this.patternInputFocused ? void 0 : e$1g(this.label)
      }, h$1R("input", Object.assign({}, this.inputProps, {
        ref: "patternInputRef",
        class: `${o3}-base-selection-input`,
        value: this.active ? this.pattern : "",
        placeholder: "",
        readonly: c3,
        disabled: c3,
        tabindex: -1,
        autofocus: this.autofocus,
        onFocus: this.handlePatternInputFocus,
        onBlur: this.handlePatternInputBlur,
        onInput: this.handlePatternInputInput,
        onCompositionstart: this.handleCompositionStart,
        onCompositionend: this.handleCompositionEnd
      })), b3 ? h$1R("div", {
        class: `${o3}-base-selection-label__render-label ${o3}-base-selection-overlay`,
        key: "input"
      }, h$1R("div", {
        class: `${o3}-base-selection-overlay__wrapper`
      }, f3 ? f3({
        option: this.selectedOption,
        handleClose: () => {
        }
      }) : h3 ? h3(this.selectedOption, true) : o$1c(this.label, this.selectedOption, true))) : null, d3 ? h$1R("div", {
        class: `${o3}-base-selection-placeholder ${o3}-base-selection-overlay`,
        key: "placeholder"
      }, h$1R("div", {
        class: `${o3}-base-selection-overlay__wrapper`
      }, this.filterablePlaceholder)) : null, u3);
    } else
      x3 = h$1R("div", {
        ref: "singleElRef",
        class: `${o3}-base-selection-label`,
        tabindex: this.disabled ? void 0 : 0
      }, this.label !== void 0 ? h$1R("div", {
        class: `${o3}-base-selection-input`,
        title: e$1g(this.label),
        key: "input"
      }, h$1R("div", {
        class: `${o3}-base-selection-input__content`
      }, f3 ? f3({
        option: this.selectedOption,
        handleClose: () => {
        }
      }) : h3 ? h3(this.selectedOption, true) : o$1c(this.label, this.selectedOption, true))) : h$1R("div", {
        class: `${o3}-base-selection-placeholder ${o3}-base-selection-overlay`,
        key: "placeholder"
      }, h$1R("div", {
        class: `${o3}-base-selection-placeholder__inner`
      }, this.placeholder)), u3);
    return h$1R("div", {
      ref: "selfRef",
      class: [`${o3}-base-selection`, this.rtlEnabled && `${o3}-base-selection--rtl`, this.themeClass, t3 && `${o3}-base-selection--${t3}-status`, {
        [`${o3}-base-selection--active`]: this.active,
        [`${o3}-base-selection--selected`]: this.selected || this.active && this.pattern,
        [`${o3}-base-selection--disabled`]: this.disabled,
        [`${o3}-base-selection--multiple`]: this.multiple,
        [`${o3}-base-selection--focus`]: this.focused
      }],
      style: this.cssVars,
      onClick: this.onClick,
      onMouseenter: this.handleMouseEnter,
      onMouseleave: this.handleMouseLeave,
      onKeydown: this.onKeydown,
      onFocusin: this.handleFocusin,
      onFocusout: this.handleFocusout,
      onMousedown: this.handleMouseDown
    }, x3, y3 ? h$1R("div", {
      class: `${o3}-base-selection__border`
    }) : null, y3 ? h$1R("div", {
      class: `${o3}-base-selection__state-border`
    }) : null);
  }
});
const u$1l = defineComponent({
  props: {
    onFocus: Function,
    onBlur: Function
  },
  setup(o3) {
    return () => h$1R("div", {
      style: "width: 0; height: 0",
      tabindex: 0,
      onFocus: o3.onFocus,
      onBlur: o3.onBlur
    });
  }
});
function f$14(r3) {
  const e28 = r3.filter((n3) => n3 !== void 0);
  if (e28.length !== 0)
    return e28.length === 1 ? e28[0] : (n3) => {
      r3.forEach((t3) => {
        t3 && t3(n3);
      });
    };
}
function j$n(n3, o3) {
  return h$1R(Transition, {
    name: "fade-in-scale-up-transition"
  }, {
    default: () => n3 ? h$1R(d$1R, {
      clsPrefix: o3,
      class: `${o3}-base-select-option__check`
    }, {
      default: () => h$1R(r$1w)
    }) : null
  });
}
const B$z = defineComponent({
  name: "NBaseSelectOption",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    tmNode: {
      type: Object,
      required: true
    }
  },
  setup(n3) {
    const {
      valueRef: o3,
      pendingTmNodeRef: l3,
      multipleRef: u3,
      valueSetRef: h3,
      renderLabelRef: s3,
      renderOptionRef: r3,
      labelFieldRef: m3,
      valueFieldRef: p3,
      showCheckmarkRef: b3,
      nodePropsRef: k3,
      handleOptionClick: N3,
      handleOptionMouseEnter: d3
    } = inject(t$1n), f3 = n$1U(() => {
      const {
        value: t3
      } = l3;
      return t3 ? n3.tmNode.key === t3.key : false;
    });
    function e28(t3) {
      const {
        tmNode: i
      } = n3;
      i.disabled || N3(t3, i);
    }
    function a3(t3) {
      const {
        tmNode: i
      } = n3;
      i.disabled || d3(t3, i);
    }
    function R3(t3) {
      const {
        tmNode: i
      } = n3, {
        value: v3
      } = f3;
      i.disabled || v3 || d3(t3, i);
    }
    return {
      multiple: u3,
      isGrouped: n$1U(() => {
        const {
          tmNode: t3
        } = n3, {
          parent: i
        } = t3;
        return i && i.rawNode.type === "group";
      }),
      showCheckmark: b3,
      nodeProps: k3,
      isPending: f3,
      isSelected: n$1U(() => {
        const {
          value: t3
        } = o3, {
          value: i
        } = u3;
        if (t3 === null)
          return false;
        const v3 = n3.tmNode.rawNode[p3.value];
        if (i) {
          const {
            value: C3
          } = h3;
          return C3.has(v3);
        } else
          return t3 === v3;
      }),
      labelField: m3,
      renderLabel: s3,
      renderOption: r3,
      handleMouseMove: R3,
      handleMouseEnter: a3,
      handleClick: e28
    };
  },
  render() {
    const {
      clsPrefix: n3,
      tmNode: {
        rawNode: o3
      },
      isSelected: l3,
      isPending: u3,
      isGrouped: h3,
      showCheckmark: s3,
      nodeProps: r3,
      renderOption: m3,
      renderLabel: p3,
      handleClick: b3,
      handleMouseEnter: k3,
      handleMouseMove: N3
    } = this, d3 = j$n(l3, n3), f3 = p3 ? [p3(o3, l3), s3 && d3] : [o$1c(o3[this.labelField], o3, l3), s3 && d3], e28 = r3 == null ? void 0 : r3(o3), a3 = h$1R("div", Object.assign({}, e28, {
      class: [`${n3}-base-select-option`, o3.class, e28 == null ? void 0 : e28.class, {
        [`${n3}-base-select-option--disabled`]: o3.disabled,
        [`${n3}-base-select-option--selected`]: l3,
        [`${n3}-base-select-option--grouped`]: h3,
        [`${n3}-base-select-option--pending`]: u3,
        [`${n3}-base-select-option--show-checkmark`]: s3
      }],
      style: [(e28 == null ? void 0 : e28.style) || "", o3.style || ""],
      onClick: f$14([b3, e28 == null ? void 0 : e28.onClick]),
      onMouseenter: f$14([k3, e28 == null ? void 0 : e28.onMouseenter]),
      onMousemove: f$14([N3, e28 == null ? void 0 : e28.onMousemove])
    }), h$1R("div", {
      class: `${n3}-base-select-option__content`
    }, f3));
    return o3.render ? o3.render({
      node: a3,
      option: o3,
      selected: l3
    }) : m3 ? m3({
      node: a3,
      option: o3,
      selected: l3
    }) : a3;
  }
});
const h$1i = defineComponent({
  name: "NBaseSelectGroupHeader",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    tmNode: {
      type: Object,
      required: true
    }
  },
  setup() {
    const {
      renderLabelRef: d3,
      renderOptionRef: n3,
      labelFieldRef: o3,
      nodePropsRef: r3
    } = inject(t$1n);
    return {
      labelField: o3,
      nodeProps: r3,
      renderLabel: d3,
      renderOption: n3
    };
  },
  render() {
    const {
      clsPrefix: d3,
      renderLabel: n3,
      renderOption: o3,
      nodeProps: r3,
      tmNode: {
        rawNode: e28
      }
    } = this, t3 = r3 == null ? void 0 : r3(e28), i = n3 ? n3(e28, false) : o$1c(e28[this.labelField], e28, false), l3 = h$1R("div", Object.assign({}, t3, {
      class: [`${d3}-base-select-group-header`, t3 == null ? void 0 : t3.class]
    }), i);
    return e28.render ? e28.render({
      node: l3,
      option: e28
    }) : o3 ? o3({
      node: l3,
      option: e28,
      selected: false
    }) : l3;
  }
});
const l$1l = l$25("base-select-menu", `
 line-height: 1.5;
 outline: none;
 z-index: 0;
 position: relative;
 border-radius: var(--n-border-radius);
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 background-color: var(--n-color);
`, [l$25("scrollbar", `
 max-height: var(--n-height);
 `), l$25("virtual-list", `
 max-height: var(--n-height);
 `), l$25("base-select-option", `
 min-height: var(--n-option-height);
 font-size: var(--n-option-font-size);
 display: flex;
 align-items: center;
 `, [M$y("content", `
 z-index: 1;
 white-space: nowrap;
 text-overflow: ellipsis;
 overflow: hidden;
 `)]), l$25("base-select-group-header", `
 min-height: var(--n-option-height);
 font-size: .93em;
 display: flex;
 align-items: center;
 `), l$25("base-select-menu-option-wrapper", `
 position: relative;
 width: 100%;
 `), M$y("loading, empty", `
 display: flex;
 padding: 12px 32px;
 flex: 1;
 justify-content: center;
 `), M$y("loading", `
 color: var(--n-loading-color);
 font-size: var(--n-loading-size);
 `), M$y("header", `
 padding: 8px var(--n-option-padding-left);
 font-size: var(--n-option-font-size);
 transition: 
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-action-divider-color);
 color: var(--n-action-text-color);
 `), M$y("action", `
 padding: 8px var(--n-option-padding-left);
 font-size: var(--n-option-font-size);
 transition: 
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 border-top: 1px solid var(--n-action-divider-color);
 color: var(--n-action-text-color);
 `), l$25("base-select-group-header", `
 position: relative;
 cursor: default;
 padding: var(--n-option-padding);
 color: var(--n-group-header-text-color);
 `), l$25("base-select-option", `
 cursor: pointer;
 position: relative;
 padding: var(--n-option-padding);
 transition:
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 box-sizing: border-box;
 color: var(--n-option-text-color);
 opacity: 1;
 `, [g$1j("show-checkmark", `
 padding-right: calc(var(--n-option-padding-right) + 20px);
 `), r$2a("&::before", `
 content: "";
 position: absolute;
 left: 4px;
 right: 4px;
 top: 0;
 bottom: 0;
 border-radius: var(--n-border-radius);
 transition: background-color .3s var(--n-bezier);
 `), r$2a("&:active", `
 color: var(--n-option-text-color-pressed);
 `), g$1j("grouped", `
 padding-left: calc(var(--n-option-padding-left) * 1.5);
 `), g$1j("pending", [r$2a("&::before", `
 background-color: var(--n-option-color-pending);
 `)]), g$1j("selected", `
 color: var(--n-option-text-color-active);
 `, [r$2a("&::before", `
 background-color: var(--n-option-color-active);
 `), g$1j("pending", [r$2a("&::before", `
 background-color: var(--n-option-color-active-pending);
 `)])]), g$1j("disabled", `
 cursor: not-allowed;
 `, [x$I("selected", `
 color: var(--n-option-text-color-disabled);
 `), g$1j("selected", `
 opacity: var(--n-option-opacity-disabled);
 `)]), M$y("check", `
 font-size: 16px;
 position: absolute;
 right: calc(var(--n-option-padding-right) - 4px);
 top: calc(50% - 7px);
 color: var(--n-option-check-color);
 transition: color .3s var(--n-bezier);
 `, [$$n({
  enterScale: "0.5"
})])])]);
const d$1j = {
  height: "calc(var(--n-option-height) * 7.6)",
  paddingSmall: "4px 0",
  paddingMedium: "4px 0",
  paddingLarge: "4px 0",
  paddingHuge: "4px 0",
  optionPaddingSmall: "0 12px",
  optionPaddingMedium: "0 12px",
  optionPaddingLarge: "0 12px",
  optionPaddingHuge: "0 12px",
  loadingSize: "18px"
};
const e$1f = {
  iconSizeSmall: "34px",
  iconSizeMedium: "40px",
  iconSizeLarge: "46px",
  iconSizeHuge: "52px"
};
const l$1k = (o3) => {
  const {
    textColorDisabled: t3,
    iconColor: e28,
    textColor2: m3,
    fontSizeSmall: n3,
    fontSizeMedium: r3,
    fontSizeLarge: i,
    fontSizeHuge: s3
  } = o3;
  return Object.assign(Object.assign({}, e$1f), {
    fontSizeSmall: n3,
    fontSizeMedium: r3,
    fontSizeLarge: i,
    fontSizeHuge: s3,
    textColor: t3,
    iconColor: e28,
    extraTextColor: m3
  });
}, f$13 = {
  name: "Empty",
  common: d$1T,
  self: l$1k
}, x$v = f$13;
const v$O = (i) => {
  const {
    borderRadius: r3,
    popoverColor: n3,
    textColor3: l3,
    dividerColor: a3,
    textColor2: e28,
    primaryColorPressed: p3,
    textColorDisabled: m3,
    primaryColor: o3,
    opacityDisabled: g3,
    hoverColor: t3,
    fontSizeSmall: c3,
    fontSizeMedium: s3,
    fontSizeLarge: C3,
    fontSizeHuge: d3,
    heightSmall: h3,
    heightMedium: S3,
    heightLarge: u3,
    heightHuge: b3
  } = i;
  return Object.assign(Object.assign({}, d$1j), {
    optionFontSizeSmall: c3,
    optionFontSizeMedium: s3,
    optionFontSizeLarge: C3,
    optionFontSizeHuge: d3,
    optionHeightSmall: h3,
    optionHeightMedium: S3,
    optionHeightLarge: u3,
    optionHeightHuge: b3,
    borderRadius: r3,
    color: n3,
    groupHeaderTextColor: l3,
    actionDividerColor: a3,
    optionTextColor: e28,
    optionTextColorPressed: p3,
    optionTextColorDisabled: m3,
    optionTextColorActive: o3,
    optionOpacityDisabled: g3,
    optionCheckColor: o3,
    optionColorPending: t3,
    optionColorActive: "rgba(0, 0, 0, 0)",
    optionColorActivePending: t3,
    actionTextColor: e28,
    loadingColor: o3
  });
}, M$p = G$w({
  name: "InternalSelectMenu",
  common: d$1T,
  peers: {
    Scrollbar: n$1N,
    Empty: x$v
  },
  self: v$O
}), A$x = M$p;
let e$1e;
function i$1l() {
  return typeof document > "u" ? false : (e$1e === void 0 && ("matchMedia" in window ? e$1e = window.matchMedia("(pointer:coarse)").matches : e$1e = false), e$1e);
}
let n$17;
function t$18() {
  return typeof document > "u" ? 1 : (n$17 === void 0 && (n$17 = "chrome" in window ? window.devicePixelRatio : 1), n$17);
}
function i$1k(u3) {
  return u3 & -u3;
}
class f$12 {
  constructor(t3, e28) {
    this.l = t3, this.min = e28;
    const n3 = new Array(t3 + 1);
    for (let r3 = 0; r3 < t3 + 1; ++r3)
      n3[r3] = 0;
    this.ft = n3;
  }
  add(t3, e28) {
    if (e28 === 0)
      return;
    const { l: n3, ft: r3 } = this;
    for (t3 += 1; t3 <= n3; )
      r3[t3] += e28, t3 += i$1k(t3);
  }
  get(t3) {
    return this.sum(t3 + 1) - this.sum(t3);
  }
  sum(t3) {
    if (t3 === void 0 && (t3 = this.l), t3 <= 0)
      return 0;
    const { ft: e28, min: n3, l: r3 } = this;
    if (t3 > r3)
      throw new Error("[FinweckTree.sum]: `i` is larger than length.");
    let s3 = t3 * n3;
    for (; t3 > 0; )
      s3 += e28[t3], t3 -= i$1k(t3);
    return s3;
  }
  getBound(t3) {
    let e28 = 0, n3 = this.l;
    for (; n3 > e28; ) {
      const r3 = Math.floor((e28 + n3) / 2), s3 = this.sum(r3);
      if (s3 > t3) {
        n3 = r3;
        continue;
      } else if (s3 < t3) {
        if (e28 === r3)
          return this.sum(e28 + 1) <= t3 ? e28 + 1 : r3;
        e28 = r3;
      } else
        return r3;
    }
    return e28;
  }
}
function r$1p(n3) {
  return typeof n3 == "string" ? n3.endsWith("px") ? Number(n3.slice(0, n3.length - 2)) : Number(n3) : n3;
}
function t$17(n3) {
  if (n3 != null)
    return typeof n3 == "number" ? `${n3}px` : n3.endsWith("px") ? n3 : `${n3}px`;
}
const oe$g = c$1N(".v-vl", {
  maxHeight: "inherit",
  height: "100%",
  overflow: "auto",
  minWidth: "1px"
}, [
  c$1N("&:not(.v-vl--show-scrollbar)", {
    scrollbarWidth: "none"
  }, [
    c$1N("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", {
      width: 0,
      height: 0,
      display: "none"
    })
  ])
]), ve$c = defineComponent({
  name: "VirtualList",
  inheritAttrs: false,
  props: {
    showScrollbar: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
      default: () => []
    },
    itemSize: {
      type: Number,
      required: true
    },
    itemResizable: Boolean,
    itemsStyle: [String, Object],
    visibleItemsTag: {
      type: [String, Object],
      default: "div"
    },
    visibleItemsProps: Object,
    ignoreItemResize: Boolean,
    onScroll: Function,
    onWheel: Function,
    onResize: Function,
    defaultScrollKey: [Number, String],
    defaultScrollIndex: Number,
    keyField: {
      type: String,
      default: "key"
    },
    paddingTop: {
      type: [Number, String],
      default: 0
    },
    paddingBottom: {
      type: [Number, String],
      default: 0
    }
  },
  setup(i) {
    const E3 = f$1Z();
    oe$g.mount({
      id: "vueuc/virtual-list",
      head: true,
      anchorMetaName: o$1k,
      ssr: E3
    }), onMounted(() => {
      const { defaultScrollIndex: e28, defaultScrollKey: t3 } = i;
      e28 != null ? z3({ index: e28 }) : t3 != null && z3({ key: t3 });
    });
    let g3 = false, b3 = false;
    onActivated(() => {
      if (g3 = false, !b3) {
        b3 = true;
        return;
      }
      z3({ top: B3.value, left: R3 });
    }), onDeactivated(() => {
      g3 = true, b3 || (b3 = true);
    });
    const p3 = computed(() => {
      const e28 = /* @__PURE__ */ new Map(), { keyField: t3 } = i;
      return i.items.forEach((l3, o3) => {
        e28.set(l3[t3], o3);
      }), e28;
    }), u3 = ref$1(null), d3 = ref$1(void 0), c3 = /* @__PURE__ */ new Map(), m3 = computed(() => {
      const { items: e28, itemSize: t3, keyField: l3 } = i, o3 = new f$12(e28.length, t3);
      return e28.forEach((s3, r3) => {
        const n3 = s3[l3], a3 = c3.get(n3);
        a3 !== void 0 && o3.add(r3, a3);
      }), o3;
    }), h3 = ref$1(0);
    let R3 = 0;
    const B3 = ref$1(0), _3 = n$1U(() => Math.max(m3.value.getBound(B3.value - r$1p(i.paddingTop)) - 1, 0)), $3 = computed(() => {
      const { value: e28 } = d3;
      if (e28 === void 0)
        return [];
      const { items: t3, itemSize: l3 } = i, o3 = _3.value, s3 = Math.min(o3 + Math.ceil(e28 / l3 + 1), t3.length - 1), r3 = [];
      for (let n3 = o3; n3 <= s3; ++n3)
        r3.push(t3[n3]);
      return r3;
    }), z3 = (e28, t3) => {
      if (typeof e28 == "number") {
        k3(e28, t3, "auto");
        return;
      }
      const { left: l3, top: o3, index: s3, key: r3, position: n3, behavior: a3, debounce: f3 = true } = e28;
      if (l3 !== void 0 || o3 !== void 0)
        k3(l3, o3, a3);
      else if (s3 !== void 0)
        A3(s3, a3, f3);
      else if (r3 !== void 0) {
        const N3 = p3.value.get(r3);
        N3 !== void 0 && A3(N3, a3, f3);
      } else
        n3 === "bottom" ? k3(0, Number.MAX_SAFE_INTEGER, a3) : n3 === "top" && k3(0, 0, a3);
    };
    let y3, x3 = null;
    function A3(e28, t3, l3) {
      const { value: o3 } = m3, s3 = o3.sum(e28) + r$1p(i.paddingTop);
      if (!l3)
        u3.value.scrollTo({
          left: 0,
          top: s3,
          behavior: t3
        });
      else {
        y3 = e28, x3 !== null && window.clearTimeout(x3), x3 = window.setTimeout(() => {
          y3 = void 0, x3 = null;
        }, 16);
        const { scrollTop: r3, offsetHeight: n3 } = u3.value;
        if (s3 > r3) {
          const a3 = o3.get(e28);
          s3 + a3 <= r3 + n3 || u3.value.scrollTo({
            left: 0,
            top: s3 + a3 - n3,
            behavior: t3
          });
        } else
          u3.value.scrollTo({
            left: 0,
            top: s3,
            behavior: t3
          });
      }
    }
    function k3(e28, t3, l3) {
      u3.value.scrollTo({
        left: e28,
        top: t3,
        behavior: l3
      });
    }
    function D3(e28, t3) {
      var l3, o3, s3;
      if (g3 || i.ignoreItemResize || V10(t3.target))
        return;
      const { value: r3 } = m3, n3 = p3.value.get(e28), a3 = r3.get(n3), f3 = (s3 = (o3 = (l3 = t3.borderBoxSize) === null || l3 === void 0 ? void 0 : l3[0]) === null || o3 === void 0 ? void 0 : o3.blockSize) !== null && s3 !== void 0 ? s3 : t3.contentRect.height;
      if (f3 === a3)
        return;
      f3 - i.itemSize === 0 ? c3.delete(e28) : c3.set(e28, f3 - i.itemSize);
      const S3 = f3 - a3;
      if (S3 === 0)
        return;
      r3.add(n3, S3);
      const v3 = u3.value;
      if (v3 != null) {
        if (y3 === void 0) {
          const F3 = r3.sum(n3);
          v3.scrollTop > F3 && v3.scrollBy(0, S3);
        } else if (n3 < y3)
          v3.scrollBy(0, S3);
        else if (n3 === y3) {
          const F3 = r3.sum(n3);
          f3 + F3 > v3.scrollTop + v3.offsetHeight && v3.scrollBy(0, S3);
        }
        L3();
      }
      h3.value++;
    }
    const O3 = !i$1l();
    let M3 = false;
    function X3(e28) {
      var t3;
      (t3 = i.onScroll) === null || t3 === void 0 || t3.call(i, e28), (!O3 || !M3) && L3();
    }
    function C3(e28) {
      var t3;
      if ((t3 = i.onWheel) === null || t3 === void 0 || t3.call(i, e28), O3) {
        const l3 = u3.value;
        if (l3 != null) {
          if (e28.deltaX === 0 && (l3.scrollTop === 0 && e28.deltaY <= 0 || l3.scrollTop + l3.offsetHeight >= l3.scrollHeight && e28.deltaY >= 0))
            return;
          e28.preventDefault(), l3.scrollTop += e28.deltaY / t$18(), l3.scrollLeft += e28.deltaX / t$18(), L3(), M3 = true, s$1O(() => {
            M3 = false;
          });
        }
      }
    }
    function K3(e28) {
      if (g3 || V10(e28.target) || e28.contentRect.height === d3.value)
        return;
      d3.value = e28.contentRect.height;
      const { onResize: t3 } = i;
      t3 !== void 0 && t3(e28);
    }
    function L3() {
      const { value: e28 } = u3;
      e28 != null && (B3.value = e28.scrollTop, R3 = e28.scrollLeft);
    }
    function V10(e28) {
      let t3 = e28;
      for (; t3 !== null; ) {
        if (t3.style.display === "none")
          return true;
        t3 = t3.parentElement;
      }
      return false;
    }
    return {
      listHeight: d3,
      listStyle: {
        overflow: "auto"
      },
      keyToIndex: p3,
      itemsStyle: computed(() => {
        const { itemResizable: e28 } = i, t3 = t$17(m3.value.sum());
        return h3.value, [
          i.itemsStyle,
          {
            boxSizing: "content-box",
            height: e28 ? "" : t3,
            minHeight: e28 ? t3 : "",
            paddingTop: t$17(i.paddingTop),
            paddingBottom: t$17(i.paddingBottom)
          }
        ];
      }),
      visibleItemsStyle: computed(() => (h3.value, {
        transform: `translateY(${t$17(m3.value.sum(_3.value))})`
      })),
      viewportItems: $3,
      listElRef: u3,
      itemsElRef: ref$1(null),
      scrollTo: z3,
      handleListResize: K3,
      handleListScroll: X3,
      handleListWheel: C3,
      handleItemResize: D3
    };
  },
  render() {
    const { itemResizable: i, keyField: E3, keyToIndex: g3, visibleItemsTag: b3 } = this;
    return h$1R(x$D, {
      onResize: this.handleListResize
    }, {
      default: () => {
        var p3, u3;
        return h$1R("div", mergeProps(this.$attrs, {
          class: ["v-vl", this.showScrollbar && "v-vl--show-scrollbar"],
          onScroll: this.handleListScroll,
          onWheel: this.handleListWheel,
          ref: "listElRef"
        }), [
          this.items.length !== 0 ? h$1R("div", {
            ref: "itemsElRef",
            class: "v-vl-items",
            style: this.itemsStyle
          }, [
            h$1R(b3, Object.assign({
              class: "v-vl-visible-items",
              style: this.visibleItemsStyle
            }, this.visibleItemsProps), {
              default: () => this.viewportItems.map((d3) => {
                const c3 = d3[E3], m3 = g3.get(c3), h3 = this.$slots.default({
                  item: d3,
                  index: m3
                })[0];
                return i ? h$1R(x$D, {
                  key: c3,
                  onResize: (R3) => this.handleItemResize(c3, R3)
                }, {
                  default: () => h3
                }) : (h3.key = c3, h3);
              })
            })
          ]) : (u3 = (p3 = this.$slots).empty) === null || u3 === void 0 ? void 0 : u3.call(p3)
        ]);
      }
    });
  }
});
const e$1d = l$25("empty", `
 display: flex;
 flex-direction: column;
 align-items: center;
 font-size: var(--n-font-size);
`, [M$y("icon", `
 width: var(--n-icon-size);
 height: var(--n-icon-size);
 font-size: var(--n-icon-size);
 line-height: var(--n-icon-size);
 color: var(--n-icon-color);
 transition:
 color .3s var(--n-bezier);
 `, [r$2a("+", [M$y("description", `
 margin-top: 8px;
 `)])]), M$y("description", `
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 `), M$y("extra", `
 text-align: center;
 transition: color .3s var(--n-bezier);
 margin-top: 12px;
 color: var(--n-extra-text-color);
 `)]);
const t$16 = defineComponent({
  name: "Empty",
  render() {
    return h$1R("svg", {
      viewBox: "0 0 28 28",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, h$1R("path", {
      d: "M26 7.5C26 11.0899 23.0899 14 19.5 14C15.9101 14 13 11.0899 13 7.5C13 3.91015 15.9101 1 19.5 1C23.0899 1 26 3.91015 26 7.5ZM16.8536 4.14645C16.6583 3.95118 16.3417 3.95118 16.1464 4.14645C15.9512 4.34171 15.9512 4.65829 16.1464 4.85355L18.7929 7.5L16.1464 10.1464C15.9512 10.3417 15.9512 10.6583 16.1464 10.8536C16.3417 11.0488 16.6583 11.0488 16.8536 10.8536L19.5 8.20711L22.1464 10.8536C22.3417 11.0488 22.6583 11.0488 22.8536 10.8536C23.0488 10.6583 23.0488 10.3417 22.8536 10.1464L20.2071 7.5L22.8536 4.85355C23.0488 4.65829 23.0488 4.34171 22.8536 4.14645C22.6583 3.95118 22.3417 3.95118 22.1464 4.14645L19.5 6.79289L16.8536 4.14645Z",
      fill: "currentColor"
    }), h$1R("path", {
      d: "M25 22.75V12.5991C24.5572 13.0765 24.053 13.4961 23.5 13.8454V16H17.5L17.3982 16.0068C17.0322 16.0565 16.75 16.3703 16.75 16.75C16.75 18.2688 15.5188 19.5 14 19.5C12.4812 19.5 11.25 18.2688 11.25 16.75L11.2432 16.6482C11.1935 16.2822 10.8797 16 10.5 16H4.5V7.25C4.5 6.2835 5.2835 5.5 6.25 5.5H12.2696C12.4146 4.97463 12.6153 4.47237 12.865 4H6.25C4.45507 4 3 5.45507 3 7.25V22.75C3 24.5449 4.45507 26 6.25 26H21.75C23.5449 26 25 24.5449 25 22.75ZM4.5 22.75V17.5H9.81597L9.85751 17.7041C10.2905 19.5919 11.9808 21 14 21L14.215 20.9947C16.2095 20.8953 17.842 19.4209 18.184 17.5H23.5V22.75C23.5 23.7165 22.7165 24.5 21.75 24.5H6.25C5.2835 24.5 4.5 23.7165 4.5 22.75Z",
      fill: "currentColor"
    }));
  }
});
const j$m = Object.assign(Object.assign({}, _$F.props), {
  description: String,
  showDescription: {
    type: Boolean,
    default: true
  },
  showIcon: {
    type: Boolean,
    default: true
  },
  size: {
    type: String,
    default: "medium"
  },
  renderIcon: Function
}), q$s = defineComponent({
  name: "Empty",
  props: j$m,
  setup(e28) {
    const {
      mergedClsPrefixRef: n3,
      inlineThemeDisabled: i
    } = a$2x(e28), p3 = _$F("Empty", "-empty", e$1d, x$v, e28, n3), {
      localeRef: f3
    } = R$p("Empty"), r3 = inject(n$27, null), v3 = computed(() => {
      var o3, t3, c3;
      return (o3 = e28.description) !== null && o3 !== void 0 ? o3 : (c3 = (t3 = r3 == null ? void 0 : r3.mergedComponentPropsRef.value) === null || t3 === void 0 ? void 0 : t3.Empty) === null || c3 === void 0 ? void 0 : c3.description;
    }), h3 = computed(() => {
      var o3, t3;
      return ((t3 = (o3 = r3 == null ? void 0 : r3.mergedComponentPropsRef.value) === null || o3 === void 0 ? void 0 : o3.Empty) === null || t3 === void 0 ? void 0 : t3.renderIcon) || (() => h$1R(t$16, null));
    }), m3 = computed(() => {
      const {
        size: o3
      } = e28, {
        common: {
          cubicBezierEaseInOut: t3
        },
        self: {
          [_$H("iconSize", o3)]: c3,
          [_$H("fontSize", o3)]: y3,
          textColor: g3,
          iconColor: C3,
          extraTextColor: x3
        }
      } = p3.value;
      return {
        "--n-icon-size": c3,
        "--n-font-size": y3,
        "--n-bezier": t3,
        "--n-text-color": g3,
        "--n-icon-color": C3,
        "--n-extra-text-color": x3
      };
    }), s3 = i ? E$J("empty", computed(() => {
      let o3 = "";
      const {
        size: t3
      } = e28;
      return o3 += t3[0], o3;
    }), m3, e28) : void 0;
    return {
      mergedClsPrefix: n3,
      mergedRenderIcon: h3,
      localizedDescription: computed(() => v3.value || f3.value.description),
      cssVars: i ? void 0 : m3,
      themeClass: s3 == null ? void 0 : s3.themeClass,
      onRender: s3 == null ? void 0 : s3.onRender
    };
  },
  render() {
    const {
      $slots: e28,
      mergedClsPrefix: n3,
      onRender: i
    } = this;
    return i == null || i(), h$1R("div", {
      class: [`${n3}-empty`, this.themeClass],
      style: this.cssVars
    }, this.showIcon ? h$1R("div", {
      class: `${n3}-empty__icon`
    }, e28.icon ? e28.icon() : h$1R(d$1R, {
      clsPrefix: n3
    }, {
      default: this.mergedRenderIcon
    })) : null, this.showDescription ? h$1R("div", {
      class: `${n3}-empty__description`
    }, e28.default ? e28.default() : this.localizedDescription) : null, e28.extra ? h$1R("div", {
      class: `${n3}-empty__extra`
    }, e28.extra()) : null);
  }
});
const rn$3 = defineComponent({
  name: "InternalSelectMenu",
  props: Object.assign(Object.assign({}, _$F.props), {
    clsPrefix: {
      type: String,
      required: true
    },
    scrollable: {
      type: Boolean,
      default: true
    },
    treeMate: {
      type: Object,
      required: true
    },
    multiple: Boolean,
    size: {
      type: String,
      default: "medium"
    },
    value: {
      type: [String, Number, Array],
      default: null
    },
    autoPending: Boolean,
    virtualScroll: {
      type: Boolean,
      default: true
    },
    show: {
      type: Boolean,
      default: true
    },
    labelField: {
      type: String,
      default: "label"
    },
    valueField: {
      type: String,
      default: "value"
    },
    loading: Boolean,
    focusable: Boolean,
    renderLabel: Function,
    renderOption: Function,
    nodeProps: Function,
    showCheckmark: {
      type: Boolean,
      default: true
    },
    onMousedown: Function,
    onScroll: Function,
    onFocus: Function,
    onBlur: Function,
    onKeyup: Function,
    onKeydown: Function,
    onTabOut: Function,
    onMouseenter: Function,
    onMouseleave: Function,
    onResize: Function,
    resetMenuOnOptionsChange: {
      type: Boolean,
      default: true
    },
    inlineThemeDisabled: Boolean,
    onToggle: Function
  }),
  setup(t3) {
    const {
      mergedClsPrefixRef: c3,
      mergedRtlRef: l3
    } = a$2x(t3), v3 = v$17("InternalSelectMenu", l3, c3), m3 = _$F("InternalSelectMenu", "-internal-select-menu", l$1l, A$x, t3, toRef$1(t3, "clsPrefix")), r3 = ref$1(null), o3 = ref$1(null), g3 = ref$1(null), S3 = computed(() => t3.treeMate.getFlattenedNodes()), K3 = computed(() => g$11(S3.value)), u3 = ref$1(null);
    function D3() {
      const {
        treeMate: e28
      } = t3;
      let n3 = null;
      const {
        value: i
      } = t3;
      i === null ? n3 = e28.getFirstAvailableNode() : (t3.multiple ? n3 = e28.getNode((i || [])[(i || []).length - 1]) : n3 = e28.getNode(i), (!n3 || n3.disabled) && (n3 = e28.getFirstAvailableNode())), p3(n3 || null);
    }
    function C3() {
      const {
        value: e28
      } = u3;
      e28 && !t3.treeMate.getNode(e28.key) && (u3.value = null);
    }
    let f3;
    watch(() => t3.show, (e28) => {
      e28 ? f3 = watch(() => t3.treeMate, () => {
        t3.resetMenuOnOptionsChange ? (t3.autoPending ? D3() : C3(), nextTick(M3)) : C3();
      }, {
        immediate: true
      }) : f3 == null || f3();
    }, {
      immediate: true
    }), onBeforeUnmount(() => {
      f3 == null || f3();
    });
    const T3 = computed(() => i$1y(m3.value.self[_$H("optionHeight", t3.size)])), E3 = computed(() => f$1f(m3.value.self[_$H("padding", t3.size)])), $3 = computed(() => t3.multiple && Array.isArray(t3.value) ? new Set(t3.value) : /* @__PURE__ */ new Set()), A3 = computed(() => {
      const e28 = S3.value;
      return e28 && e28.length === 0;
    });
    function V10(e28) {
      const {
        onToggle: n3
      } = t3;
      n3 && n3(e28);
    }
    function P3(e28) {
      const {
        onScroll: n3
      } = t3;
      n3 && n3(e28);
    }
    function H3(e28) {
      var n3;
      (n3 = g3.value) === null || n3 === void 0 || n3.sync(), P3(e28);
    }
    function j3() {
      var e28;
      (e28 = g3.value) === null || e28 === void 0 || e28.sync();
    }
    function G3() {
      const {
        value: e28
      } = u3;
      return e28 || null;
    }
    function U3(e28, n3) {
      n3.disabled || p3(n3, false);
    }
    function W3(e28, n3) {
      n3.disabled || V10(n3);
    }
    function q3(e28) {
      var n3;
      a$2j(e28, "action") || (n3 = t3.onKeyup) === null || n3 === void 0 || n3.call(t3, e28);
    }
    function J3(e28) {
      var n3;
      a$2j(e28, "action") || (n3 = t3.onKeydown) === null || n3 === void 0 || n3.call(t3, e28);
    }
    function Q3(e28) {
      var n3;
      (n3 = t3.onMousedown) === null || n3 === void 0 || n3.call(t3, e28), !t3.focusable && e28.preventDefault();
    }
    function X3() {
      const {
        value: e28
      } = u3;
      e28 && p3(e28.getNext({
        loop: true
      }), true);
    }
    function Y3() {
      const {
        value: e28
      } = u3;
      e28 && p3(e28.getPrev({
        loop: true
      }), true);
    }
    function p3(e28, n3 = false) {
      u3.value = e28, n3 && M3();
    }
    function M3() {
      var e28, n3;
      const i = u3.value;
      if (!i)
        return;
      const b3 = K3.value(i.key);
      b3 !== null && (t3.virtualScroll ? (e28 = o3.value) === null || e28 === void 0 || e28.scrollTo({
        index: b3
      }) : (n3 = g3.value) === null || n3 === void 0 || n3.scrollTo({
        index: b3,
        elSize: T3.value
      }));
    }
    function Z3(e28) {
      var n3, i;
      !((n3 = r3.value) === null || n3 === void 0) && n3.contains(e28.target) && ((i = t3.onFocus) === null || i === void 0 || i.call(t3, e28));
    }
    function ee2(e28) {
      var n3, i;
      !((n3 = r3.value) === null || n3 === void 0) && n3.contains(e28.relatedTarget) || (i = t3.onBlur) === null || i === void 0 || i.call(t3, e28);
    }
    provide(t$1n, {
      handleOptionMouseEnter: U3,
      handleOptionClick: W3,
      valueSetRef: $3,
      pendingTmNodeRef: u3,
      nodePropsRef: toRef$1(t3, "nodeProps"),
      showCheckmarkRef: toRef$1(t3, "showCheckmark"),
      multipleRef: toRef$1(t3, "multiple"),
      valueRef: toRef$1(t3, "value"),
      renderLabelRef: toRef$1(t3, "renderLabel"),
      renderOptionRef: toRef$1(t3, "renderOption"),
      labelFieldRef: toRef$1(t3, "labelField"),
      valueFieldRef: toRef$1(t3, "valueField")
    }), provide(o$1m, r3), onMounted(() => {
      const {
        value: e28
      } = g3;
      e28 && e28.sync();
    });
    const N3 = computed(() => {
      const {
        size: e28
      } = t3, {
        common: {
          cubicBezierEaseInOut: n3
        },
        self: {
          height: i,
          borderRadius: b3,
          color: te2,
          groupHeaderTextColor: oe2,
          actionDividerColor: ie2,
          optionTextColorPressed: le2,
          optionTextColor: ae2,
          optionTextColorDisabled: re2,
          optionTextColorActive: de2,
          optionOpacityDisabled: ue2,
          optionCheckColor: se2,
          actionTextColor: ce2,
          optionColorPending: fe2,
          optionColorActive: ve2,
          loadingColor: me2,
          loadingSize: he2,
          optionColorActivePending: ge2,
          [_$H("optionFontSize", e28)]: pe2,
          [_$H("optionHeight", e28)]: be2,
          [_$H("optionPadding", e28)]: x3
        }
      } = m3.value;
      return {
        "--n-height": i,
        "--n-action-divider-color": ie2,
        "--n-action-text-color": ce2,
        "--n-bezier": n3,
        "--n-border-radius": b3,
        "--n-color": te2,
        "--n-option-font-size": pe2,
        "--n-group-header-text-color": oe2,
        "--n-option-check-color": se2,
        "--n-option-color-pending": fe2,
        "--n-option-color-active": ve2,
        "--n-option-color-active-pending": ge2,
        "--n-option-height": be2,
        "--n-option-opacity-disabled": ue2,
        "--n-option-text-color": ae2,
        "--n-option-text-color-active": de2,
        "--n-option-text-color-disabled": re2,
        "--n-option-text-color-pressed": le2,
        "--n-option-padding": x3,
        "--n-option-padding-left": f$1f(x3, "left"),
        "--n-option-padding-right": f$1f(x3, "right"),
        "--n-loading-color": me2,
        "--n-loading-size": he2
      };
    }), {
      inlineThemeDisabled: k3
    } = t3, h3 = k3 ? E$J("internal-select-menu", computed(() => t3.size[0]), N3, t3) : void 0, ne2 = {
      selfRef: r3,
      next: X3,
      prev: Y3,
      getPendingTmNode: G3
    };
    return a$1D(r3, t3.onResize), Object.assign({
      mergedTheme: m3,
      mergedClsPrefix: c3,
      rtlEnabled: v3,
      virtualListRef: o3,
      scrollbarRef: g3,
      itemSize: T3,
      padding: E3,
      flattenedNodes: S3,
      empty: A3,
      virtualListContainer() {
        const {
          value: e28
        } = o3;
        return e28 == null ? void 0 : e28.listElRef;
      },
      virtualListContent() {
        const {
          value: e28
        } = o3;
        return e28 == null ? void 0 : e28.itemsElRef;
      },
      doScroll: P3,
      handleFocusin: Z3,
      handleFocusout: ee2,
      handleKeyUp: q3,
      handleKeyDown: J3,
      handleMouseDown: Q3,
      handleVirtualListResize: j3,
      handleVirtualListScroll: H3,
      cssVars: k3 ? void 0 : N3,
      themeClass: h3 == null ? void 0 : h3.themeClass,
      onRender: h3 == null ? void 0 : h3.onRender
    }, ne2);
  },
  render() {
    const {
      $slots: t3,
      virtualScroll: c3,
      clsPrefix: l3,
      mergedTheme: v3,
      themeClass: m3,
      onRender: r3
    } = this;
    return r3 == null || r3(), h$1R("div", {
      ref: "selfRef",
      tabindex: this.focusable ? 0 : -1,
      class: [`${l3}-base-select-menu`, this.rtlEnabled && `${l3}-base-select-menu--rtl`, m3, this.multiple && `${l3}-base-select-menu--multiple`],
      style: this.cssVars,
      onFocusin: this.handleFocusin,
      onFocusout: this.handleFocusout,
      onKeyup: this.handleKeyUp,
      onKeydown: this.handleKeyDown,
      onMousedown: this.handleMouseDown,
      onMouseenter: this.onMouseenter,
      onMouseleave: this.onMouseleave
    }, m$26(t3.header, (o3) => o3 && h$1R("div", {
      class: `${l3}-base-select-menu__header`,
      "data-header": true,
      key: "header"
    }, o3)), this.loading ? h$1R("div", {
      class: `${l3}-base-select-menu__loading`
    }, h$1R(h$1A, {
      clsPrefix: l3,
      strokeWidth: 20
    })) : this.empty ? h$1R("div", {
      class: `${l3}-base-select-menu__empty`,
      "data-empty": true
    }, p$3H(t3.empty, () => [h$1R(q$s, {
      theme: v3.peers.Empty,
      themeOverrides: v3.peerOverrides.Empty
    })])) : h$1R(hn$2, {
      ref: "scrollbarRef",
      theme: v3.peers.Scrollbar,
      themeOverrides: v3.peerOverrides.Scrollbar,
      scrollable: this.scrollable,
      container: c3 ? this.virtualListContainer : void 0,
      content: c3 ? this.virtualListContent : void 0,
      onScroll: c3 ? void 0 : this.doScroll
    }, {
      default: () => c3 ? h$1R(ve$c, {
        ref: "virtualListRef",
        class: `${l3}-virtual-list`,
        items: this.flattenedNodes,
        itemSize: this.itemSize,
        showScrollbar: false,
        paddingTop: this.padding.top,
        paddingBottom: this.padding.bottom,
        onResize: this.handleVirtualListResize,
        onScroll: this.handleVirtualListScroll,
        itemResizable: true
      }, {
        default: ({
          item: o3
        }) => o3.isGroup ? h$1R(h$1i, {
          key: o3.key,
          clsPrefix: l3,
          tmNode: o3
        }) : o3.ignored ? null : h$1R(B$z, {
          clsPrefix: l3,
          key: o3.key,
          tmNode: o3
        })
      }) : h$1R("div", {
        class: `${l3}-base-select-menu-option-wrapper`,
        style: {
          paddingTop: this.padding.top,
          paddingBottom: this.padding.bottom
        }
      }, this.flattenedNodes.map((o3) => o3.isGroup ? h$1R(h$1i, {
        key: o3.key,
        clsPrefix: l3,
        tmNode: o3
      }) : h$1R(B$z, {
        clsPrefix: l3,
        key: o3.key,
        tmNode: o3
      })))
    }), m$26(t3.action, (o3) => o3 && [h$1R("div", {
      class: `${l3}-base-select-menu__action`,
      "data-action": true,
      key: "action"
    }, o3), h$1R(u$1l, {
      onFocus: this.onTabOut,
      key: "focus-detector"
    })]));
  }
});
function c$1w(e28) {
  const {
    boxShadow2: t3
  } = e28;
  return {
    menuBoxShadow: t3
  };
}
const i$1j = G$w({
  name: "Select",
  common: d$1T,
  peers: {
    InternalSelection: V$p,
    InternalSelectMenu: A$x
  },
  self: c$1w
}), f$11 = i$1j;
const ct$7 = Object.assign(Object.assign({}, _$F.props), {
  to: f$1m.propTo,
  bordered: {
    type: Boolean,
    default: void 0
  },
  clearable: Boolean,
  clearFilterAfterSelect: {
    type: Boolean,
    default: true
  },
  options: {
    type: Array,
    default: () => []
  },
  defaultValue: {
    type: [String, Number, Array],
    default: null
  },
  keyboard: {
    type: Boolean,
    default: true
  },
  value: [String, Number, Array],
  placeholder: String,
  menuProps: Object,
  multiple: Boolean,
  size: String,
  filterable: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  },
  remote: Boolean,
  loading: Boolean,
  filter: Function,
  placement: {
    type: String,
    default: "bottom-start"
  },
  widthMode: {
    type: String,
    default: "trigger"
  },
  tag: Boolean,
  onCreate: Function,
  fallbackOption: {
    type: [Function, Boolean],
    default: void 0
  },
  show: {
    type: Boolean,
    default: void 0
  },
  showArrow: {
    type: Boolean,
    default: true
  },
  maxTagCount: [Number, String],
  ellipsisTagPopoverProps: Object,
  consistentMenuWidth: {
    type: Boolean,
    default: true
  },
  virtualScroll: {
    type: Boolean,
    default: true
  },
  labelField: {
    type: String,
    default: "label"
  },
  valueField: {
    type: String,
    default: "value"
  },
  childrenField: {
    type: String,
    default: "children"
  },
  renderLabel: Function,
  renderOption: Function,
  renderTag: Function,
  "onUpdate:value": [Function, Array],
  inputProps: Object,
  nodeProps: Function,
  ignoreComposition: {
    type: Boolean,
    default: true
  },
  showOnFocus: Boolean,
  onUpdateValue: [Function, Array],
  onBlur: [Function, Array],
  onClear: [Function, Array],
  onFocus: [Function, Array],
  onScroll: [Function, Array],
  onSearch: [Function, Array],
  onUpdateShow: [Function, Array],
  "onUpdate:show": [Function, Array],
  displayDirective: {
    type: String,
    default: "show"
  },
  resetMenuOnOptionsChange: {
    type: Boolean,
    default: true
  },
  status: String,
  showCheckmark: {
    type: Boolean,
    default: true
  },
  onChange: [Function, Array],
  items: Array
}), zt$3 = defineComponent({
  name: "Select",
  props: ct$7,
  setup(n3) {
    const {
      mergedClsPrefixRef: f3,
      mergedBorderedRef: M3,
      namespaceRef: h3,
      inlineThemeDisabled: s3
    } = a$2x(n3), $3 = _$F("Select", "-select", r$1r, f$11, n3, f3), z3 = ref$1(n3.defaultValue), ce2 = toRef$1(n3, "value"), T3 = d$1S(ce2, z3), C3 = ref$1(false), w3 = ref$1(""), fe2 = computed(() => {
      const {
        valueField: e28,
        childrenField: t3
      } = n3, l3 = p$3g(e28, t3);
      return U$s(ge2.value, l3);
    }), W3 = computed(() => y$T(q3.value, n3.valueField, n3.childrenField)), A3 = ref$1(false), v3 = d$1S(toRef$1(n3, "show"), A3), d3 = ref$1(null), K3 = ref$1(null), R3 = ref$1(null), {
      localeRef: he2
    } = R$p("Select"), ve2 = computed(() => {
      var e28;
      return (e28 = n3.placeholder) !== null && e28 !== void 0 ? e28 : he2.value.placeholder;
    }), j3 = f$1j(n3, ["items", "options"]), B3 = [], p3 = ref$1([]), O3 = ref$1([]), _3 = ref$1(/* @__PURE__ */ new Map()), H3 = computed(() => {
      const {
        fallbackOption: e28
      } = n3;
      if (e28 === void 0) {
        const {
          labelField: t3,
          valueField: l3
        } = n3;
        return (r3) => ({
          [t3]: String(r3),
          [l3]: r3
        });
      }
      return e28 === false ? false : (t3) => Object.assign(e28(t3), {
        value: t3
      });
    }), q3 = computed(() => O3.value.concat(p3.value).concat(j3.value)), me2 = computed(() => {
      const {
        filter: e28
      } = n3;
      if (e28)
        return e28;
      const {
        labelField: t3,
        valueField: l3
      } = n3;
      return (r3, o3) => {
        if (!o3)
          return false;
        const i = o3[t3];
        if (typeof i == "string")
          return g$12(r3, i);
        const a3 = o3[l3];
        return typeof a3 == "string" ? g$12(r3, a3) : typeof a3 == "number" ? g$12(r3, String(a3)) : false;
      };
    }), ge2 = computed(() => {
      if (n3.remote)
        return j3.value;
      {
        const {
          value: e28
        } = q3, {
          value: t3
        } = w3;
        return !t3.length || !n3.filterable ? e28 : h$1l(e28, me2.value, t3, n3.childrenField);
      }
    });
    function U3(e28) {
      const t3 = n3.remote, {
        value: l3
      } = _3, {
        value: r3
      } = W3, {
        value: o3
      } = H3, i = [];
      return e28.forEach((a3) => {
        if (r3.has(a3))
          i.push(r3.get(a3));
        else if (t3 && l3.has(a3))
          i.push(l3.get(a3));
        else if (o3) {
          const u3 = o3(a3);
          u3 && i.push(u3);
        }
      }), i;
    }
    const G3 = computed(() => {
      if (n3.multiple) {
        const {
          value: e28
        } = T3;
        return Array.isArray(e28) ? U3(e28) : [];
      }
      return null;
    }), J3 = computed(() => {
      const {
        value: e28
      } = T3;
      return !n3.multiple && !Array.isArray(e28) ? e28 === null ? null : U3([e28])[0] || null : null;
    }), V10 = h$1B(n3), {
      mergedSizeRef: pe2,
      mergedDisabledRef: I3,
      mergedStatusRef: be2
    } = V10;
    function k3(e28, t3) {
      const {
        onChange: l3,
        "onUpdate:value": r3,
        onUpdateValue: o3
      } = n3, {
        nTriggerFormChange: i,
        nTriggerFormInput: a3
      } = V10;
      l3 && i$1Z(l3, e28, t3), o3 && i$1Z(o3, e28, t3), r3 && i$1Z(r3, e28, t3), z3.value = e28, i(), a3();
    }
    function Q3(e28) {
      const {
        onBlur: t3
      } = n3, {
        nTriggerFormBlur: l3
      } = V10;
      t3 && i$1Z(t3, e28), l3();
    }
    function Oe2() {
      const {
        onClear: e28
      } = n3;
      e28 && i$1Z(e28);
    }
    function Fe2(e28) {
      const {
        onFocus: t3,
        showOnFocus: l3
      } = n3, {
        nTriggerFormFocus: r3
      } = V10;
      t3 && i$1Z(t3, e28), r3(), l3 && P3();
    }
    function ye2(e28) {
      const {
        onSearch: t3
      } = n3;
      t3 && i$1Z(t3, e28);
    }
    function we2(e28) {
      const {
        onScroll: t3
      } = n3;
      t3 && i$1Z(t3, e28);
    }
    function X3() {
      var e28;
      const {
        remote: t3,
        multiple: l3
      } = n3;
      if (t3) {
        const {
          value: r3
        } = _3;
        if (l3) {
          const {
            valueField: o3
          } = n3;
          (e28 = G3.value) === null || e28 === void 0 || e28.forEach((i) => {
            r3.set(i[o3], i);
          });
        } else {
          const o3 = J3.value;
          o3 && r3.set(o3[n3.valueField], o3);
        }
      }
    }
    function Y3(e28) {
      const {
        onUpdateShow: t3,
        "onUpdate:show": l3
      } = n3;
      t3 && i$1Z(t3, e28), l3 && i$1Z(l3, e28), A3.value = e28;
    }
    function P3() {
      I3.value || (Y3(true), A3.value = true, n3.filterable && ie2());
    }
    function b3() {
      Y3(false);
    }
    function Z3() {
      w3.value = "", O3.value = B3;
    }
    const D3 = ref$1(false);
    function Se2() {
      n3.filterable && (D3.value = true);
    }
    function Me2() {
      n3.filterable && (D3.value = false, v3.value || Z3());
    }
    function Te2() {
      I3.value || (v3.value ? n3.filterable ? ie2() : b3() : P3());
    }
    function Ce2(e28) {
      var t3, l3;
      !((l3 = (t3 = R3.value) === null || t3 === void 0 ? void 0 : t3.selfRef) === null || l3 === void 0) && l3.contains(e28.relatedTarget) || (C3.value = false, Q3(e28), b3());
    }
    function Re2(e28) {
      Fe2(e28), C3.value = true;
    }
    function Be2(e28) {
      C3.value = true;
    }
    function Pe2(e28) {
      var t3;
      !((t3 = d3.value) === null || t3 === void 0) && t3.$el.contains(e28.relatedTarget) || (C3.value = false, Q3(e28), b3());
    }
    function Ae2() {
      var e28;
      (e28 = d3.value) === null || e28 === void 0 || e28.focus(), b3();
    }
    function _e2(e28) {
      var t3;
      v3.value && (!((t3 = d3.value) === null || t3 === void 0) && t3.$el.contains(t$1G(e28)) || b3());
    }
    function Ve2(e28) {
      if (!Array.isArray(e28))
        return [];
      if (H3.value)
        return Array.from(e28);
      {
        const {
          remote: t3
        } = n3, {
          value: l3
        } = W3;
        if (t3) {
          const {
            value: r3
          } = _3;
          return e28.filter((o3) => l3.has(o3) || r3.has(o3));
        } else
          return e28.filter((r3) => l3.has(r3));
      }
    }
    function ee2(e28) {
      x3(e28.rawNode);
    }
    function x3(e28) {
      if (I3.value)
        return;
      const {
        tag: t3,
        remote: l3,
        clearFilterAfterSelect: r3,
        valueField: o3
      } = n3;
      if (t3 && !l3) {
        const {
          value: i
        } = O3, a3 = i[0] || null;
        if (a3) {
          const u3 = p3.value;
          u3.length ? u3.push(a3) : p3.value = [a3], O3.value = B3;
        }
      }
      if (l3 && _3.value.set(e28[o3], e28), n3.multiple) {
        const i = Ve2(T3.value), a3 = i.findIndex((u3) => u3 === e28[o3]);
        if (~a3) {
          if (i.splice(a3, 1), t3 && !l3) {
            const u3 = te2(e28[o3]);
            ~u3 && (p3.value.splice(u3, 1), r3 && (w3.value = ""));
          }
        } else
          i.push(e28[o3]), r3 && (w3.value = "");
        k3(i, U3(i));
      } else {
        if (t3 && !l3) {
          const i = te2(e28[o3]);
          ~i ? p3.value = [p3.value[i]] : p3.value = B3;
        }
        le2(), b3(), k3(e28[o3], e28);
      }
    }
    function te2(e28) {
      return p3.value.findIndex((l3) => l3[n3.valueField] === e28);
    }
    function Ie2(e28) {
      v3.value || P3();
      const {
        value: t3
      } = e28.target;
      w3.value = t3;
      const {
        tag: l3,
        remote: r3
      } = n3;
      if (ye2(t3), l3 && !r3) {
        if (!t3) {
          O3.value = B3;
          return;
        }
        const {
          onCreate: o3
        } = n3, i = o3 ? o3(t3) : {
          [n3.labelField]: t3,
          [n3.valueField]: t3
        }, {
          valueField: a3,
          labelField: u3
        } = n3;
        j3.value.some((F3) => F3[a3] === i[a3] || F3[u3] === i[u3]) || p3.value.some((F3) => F3[a3] === i[a3] || F3[u3] === i[u3]) ? O3.value = B3 : O3.value = [i];
      }
    }
    function ke2(e28) {
      e28.stopPropagation();
      const {
        multiple: t3
      } = n3;
      !t3 && n3.filterable && b3(), Oe2(), t3 ? k3([], []) : k3(null, null);
    }
    function De2(e28) {
      !a$2j(e28, "action") && !a$2j(e28, "empty") && e28.preventDefault();
    }
    function xe2(e28) {
      we2(e28);
    }
    function ne2(e28) {
      var t3, l3, r3, o3, i;
      if (!n3.keyboard) {
        e28.preventDefault();
        return;
      }
      switch (e28.key) {
        case " ":
          if (n3.filterable)
            break;
          e28.preventDefault();
        case "Enter":
          if (!(!((t3 = d3.value) === null || t3 === void 0) && t3.isComposing)) {
            if (v3.value) {
              const a3 = (l3 = R3.value) === null || l3 === void 0 ? void 0 : l3.getPendingTmNode();
              a3 ? ee2(a3) : n3.filterable || (b3(), le2());
            } else if (P3(), n3.tag && D3.value) {
              const a3 = O3.value[0];
              if (a3) {
                const u3 = a3[n3.valueField], {
                  value: F3
                } = T3;
                n3.multiple && Array.isArray(F3) && F3.some((Ue2) => Ue2 === u3) || x3(a3);
              }
            }
          }
          e28.preventDefault();
          break;
        case "ArrowUp":
          if (e28.preventDefault(), n3.loading)
            return;
          v3.value && ((r3 = R3.value) === null || r3 === void 0 || r3.prev());
          break;
        case "ArrowDown":
          if (e28.preventDefault(), n3.loading)
            return;
          v3.value ? (o3 = R3.value) === null || o3 === void 0 || o3.next() : P3();
          break;
        case "Escape":
          v3.value && (n$1D(e28), b3()), (i = d3.value) === null || i === void 0 || i.focus();
          break;
      }
    }
    function le2() {
      var e28;
      (e28 = d3.value) === null || e28 === void 0 || e28.focus();
    }
    function ie2() {
      var e28;
      (e28 = d3.value) === null || e28 === void 0 || e28.focusInput();
    }
    function ze2() {
      var e28;
      v3.value && ((e28 = K3.value) === null || e28 === void 0 || e28.syncPosition());
    }
    X3(), watch(toRef$1(n3, "options"), X3);
    const je2 = {
      focus: () => {
        var e28;
        (e28 = d3.value) === null || e28 === void 0 || e28.focus();
      },
      focusInput: () => {
        var e28;
        (e28 = d3.value) === null || e28 === void 0 || e28.focusInput();
      },
      blur: () => {
        var e28;
        (e28 = d3.value) === null || e28 === void 0 || e28.blur();
      },
      blurInput: () => {
        var e28;
        (e28 = d3.value) === null || e28 === void 0 || e28.blurInput();
      }
    }, oe2 = computed(() => {
      const {
        self: {
          menuBoxShadow: e28
        }
      } = $3.value;
      return {
        "--n-menu-box-shadow": e28
      };
    }), S3 = s3 ? E$J("select", void 0, oe2, n3) : void 0;
    return Object.assign(Object.assign({}, je2), {
      mergedStatus: be2,
      mergedClsPrefix: f3,
      mergedBordered: M3,
      namespace: h3,
      treeMate: fe2,
      isMounted: u$1C(),
      triggerRef: d3,
      menuRef: R3,
      pattern: w3,
      uncontrolledShow: A3,
      mergedShow: v3,
      adjustedTo: f$1m(n3),
      uncontrolledValue: z3,
      mergedValue: T3,
      followerRef: K3,
      localizedPlaceholder: ve2,
      selectedOption: J3,
      selectedOptions: G3,
      mergedSize: pe2,
      mergedDisabled: I3,
      focused: C3,
      activeWithoutMenuOpen: D3,
      inlineThemeDisabled: s3,
      onTriggerInputFocus: Se2,
      onTriggerInputBlur: Me2,
      handleTriggerOrMenuResize: ze2,
      handleMenuFocus: Be2,
      handleMenuBlur: Pe2,
      handleMenuTabOut: Ae2,
      handleTriggerClick: Te2,
      handleToggle: ee2,
      handleDeleteOption: x3,
      handlePatternInput: Ie2,
      handleClear: ke2,
      handleTriggerBlur: Ce2,
      handleTriggerFocus: Re2,
      handleKeydown: ne2,
      handleMenuAfterLeave: Z3,
      handleMenuClickOutside: _e2,
      handleMenuScroll: xe2,
      handleMenuKeydown: ne2,
      handleMenuMousedown: De2,
      mergedTheme: $3,
      cssVars: s3 ? void 0 : oe2,
      themeClass: S3 == null ? void 0 : S3.themeClass,
      onRender: S3 == null ? void 0 : S3.onRender
    });
  },
  render() {
    return h$1R("div", {
      class: `${this.mergedClsPrefix}-select`
    }, h$1R(F$x, null, {
      default: () => [h$1R(g$19, null, {
        default: () => h$1R(Kt$3, {
          ref: "triggerRef",
          inlineThemeDisabled: this.inlineThemeDisabled,
          status: this.mergedStatus,
          inputProps: this.inputProps,
          clsPrefix: this.mergedClsPrefix,
          showArrow: this.showArrow,
          maxTagCount: this.maxTagCount,
          ellipsisTagPopoverProps: this.ellipsisTagPopoverProps,
          bordered: this.mergedBordered,
          active: this.activeWithoutMenuOpen || this.mergedShow,
          pattern: this.pattern,
          placeholder: this.localizedPlaceholder,
          selectedOption: this.selectedOption,
          selectedOptions: this.selectedOptions,
          multiple: this.multiple,
          renderTag: this.renderTag,
          renderLabel: this.renderLabel,
          filterable: this.filterable,
          clearable: this.clearable,
          disabled: this.mergedDisabled,
          size: this.mergedSize,
          theme: this.mergedTheme.peers.InternalSelection,
          labelField: this.labelField,
          valueField: this.valueField,
          themeOverrides: this.mergedTheme.peerOverrides.InternalSelection,
          loading: this.loading,
          focused: this.focused,
          onClick: this.handleTriggerClick,
          onDeleteOption: this.handleDeleteOption,
          onPatternInput: this.handlePatternInput,
          onClear: this.handleClear,
          onBlur: this.handleTriggerBlur,
          onFocus: this.handleTriggerFocus,
          onKeydown: this.handleKeydown,
          onPatternBlur: this.onTriggerInputBlur,
          onPatternFocus: this.onTriggerInputFocus,
          onResize: this.handleTriggerOrMenuResize,
          ignoreComposition: this.ignoreComposition
        }, {
          arrow: () => {
            var n3, f3;
            return [(f3 = (n3 = this.$slots).arrow) === null || f3 === void 0 ? void 0 : f3.call(n3)];
          }
        })
      }), h$1R(me$h, {
        ref: "followerRef",
        show: this.mergedShow,
        to: this.adjustedTo,
        teleportDisabled: this.adjustedTo === f$1m.tdkey,
        containerClass: this.namespace,
        width: this.consistentMenuWidth ? "target" : void 0,
        minWidth: "target",
        placement: this.placement
      }, {
        default: () => h$1R(Transition, {
          name: "fade-in-scale-up-transition",
          appear: this.isMounted,
          onAfterLeave: this.handleMenuAfterLeave
        }, {
          default: () => {
            var n3, f3, M3;
            return this.mergedShow || this.displayDirective === "show" ? ((n3 = this.onRender) === null || n3 === void 0 || n3.call(this), withDirectives(h$1R(rn$3, Object.assign({}, this.menuProps, {
              ref: "menuRef",
              onResize: this.handleTriggerOrMenuResize,
              inlineThemeDisabled: this.inlineThemeDisabled,
              virtualScroll: this.consistentMenuWidth && this.virtualScroll,
              class: [`${this.mergedClsPrefix}-select-menu`, this.themeClass, (f3 = this.menuProps) === null || f3 === void 0 ? void 0 : f3.class],
              clsPrefix: this.mergedClsPrefix,
              focusable: true,
              labelField: this.labelField,
              valueField: this.valueField,
              autoPending: true,
              nodeProps: this.nodeProps,
              theme: this.mergedTheme.peers.InternalSelectMenu,
              themeOverrides: this.mergedTheme.peerOverrides.InternalSelectMenu,
              treeMate: this.treeMate,
              multiple: this.multiple,
              size: "medium",
              renderOption: this.renderOption,
              renderLabel: this.renderLabel,
              value: this.mergedValue,
              style: [(M3 = this.menuProps) === null || M3 === void 0 ? void 0 : M3.style, this.cssVars],
              onToggle: this.handleToggle,
              onScroll: this.handleMenuScroll,
              onFocus: this.handleMenuFocus,
              onBlur: this.handleMenuBlur,
              onKeydown: this.handleMenuKeydown,
              onTabOut: this.handleMenuTabOut,
              onMousedown: this.handleMenuMousedown,
              show: this.mergedShow,
              showCheckmark: this.showCheckmark,
              resetMenuOnOptionsChange: this.resetMenuOnOptionsChange
            }), {
              empty: () => {
                var h3, s3;
                return [(s3 = (h3 = this.$slots).empty) === null || s3 === void 0 ? void 0 : s3.call(h3)];
              },
              header: () => {
                var h3, s3;
                return [(s3 = (h3 = this.$slots).header) === null || s3 === void 0 ? void 0 : s3.call(h3)];
              },
              action: () => {
                var h3, s3;
                return [(s3 = (h3 = this.$slots).action) === null || s3 === void 0 ? void 0 : s3.call(h3)];
              }
            }), this.displayDirective === "show" ? [[vShow, this.mergedShow], [a$2i, this.handleMenuClickOutside, void 0, {
              capture: true
            }]] : [[a$2i, this.handleMenuClickOutside, void 0, {
              capture: true
            }]])) : null;
          }
        })
      })]
    }));
  }
});
const L$y = defineComponent({
  name: "UISelect",
  inheritAttrs: false
}), C$S = defineComponent(__spreadProps(__spreadValues({}, L$y), {
  props: {
    id: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    show: {
      type: Boolean,
      default: void 0
    },
    multiple: {
      type: Boolean,
      default: void 0
    },
    filterable: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: void 0
    },
    clearable: {
      type: Boolean,
      default: false
    },
    remote: {
      type: Boolean,
      default: void 0
    },
    tag: {
      type: Boolean,
      default: void 0
    },
    type: {
      type: String,
      default: "default"
    },
    resetMenuOnOptionsChange: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "large"
    },
    maxTagCount: {
      type: Number,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String
    },
    value: {
      type: [String, Array]
    },
    renderLabel: {
      type: Function,
      default: void 0
    },
    renderTag: {
      type: Function,
      default: void 0
    },
    showTooltip: {
      type: Boolean,
      default: false
    }
  },
  emits: ["search", "update:value", "scroll"],
  setup(e28) {
    const n3 = e28, s3 = (t3, a3) => {
      var _a2;
      switch ((_a2 = t3.type) != null ? _a2 : n3.type) {
        case "avatar":
        default:
          return s$1x(t3);
        case "group":
          return n$19(t3);
      }
    }, m3 = computed(() => n3.multiple ? m$1B : f$15), f3 = computed(() => n3.multiple ? i$1n : f$16);
    return (t3, a3) => (openBlock(), createBlock(unref(zt$3), mergeProps({
      "reset-menu-on-options-change": e28.resetMenuOnOptionsChange,
      "render-label": e28.renderLabel ? e28.renderLabel : e28.type === "avatar" ? s3 : e28.showTooltip ? unref(l$1p) : unref(g$15),
      "render-tag": e28.renderTag ? e28.renderTag : e28.type === "avatar" ? m3.value : f3.value,
      id: e28.id
    }, t3.$attrs, {
      placeholder: e28.placeholder,
      options: e28.options,
      disabled: e28.disabled,
      value: e28.value,
      class: "hl-select",
      filterable: e28.filterable,
      show: e28.show,
      multiple: e28.multiple,
      loading: e28.loading,
      clearable: e28.clearable,
      remote: e28.remote,
      tag: e28.tag,
      size: e28.size,
      "max-tag-count": e28.maxTagCount,
      onScroll: a3[0] || (a3[0] = (l3) => t3.$emit("scroll", l3)),
      onSearch: a3[1] || (a3[1] = (l3) => t3.$emit("search", l3)),
      "onUpdate:value": a3[2] || (a3[2] = (l3, c3) => t3.$emit("update:value", l3, c3))
    }), {
      header: withCtx(() => [
        renderSlot(t3.$slots, "header")
      ]),
      action: withCtx(() => [
        renderSlot(t3.$slots, "action")
      ]),
      arrow: withCtx(() => [
        renderSlot(t3.$slots, "arrow")
      ]),
      empty: withCtx(() => [
        renderSlot(t3.$slots, "empty")
      ]),
      _: 3
    }, 16, ["reset-menu-on-options-change", "render-label", "render-tag", "id", "placeholder", "options", "disabled", "value", "filterable", "show", "multiple", "loading", "clearable", "remote", "tag", "size", "max-tag-count"]));
  }
})), I$y = C$S;
var i$1i = /* @__PURE__ */ ((r3) => (r3.englishUS = "en-US", r3.danish = "da", r3.dutch = "nl", r3.finnish = "fi", r3.frenchFrance = "fr-FR", r3.frenchCanada = "fr-CA", r3.german = "de", r3.italian = "it", r3.norwegian = "no", r3.portuguesePortugal = "pt-PT", r3.portugueseBrazil = "pt-BR", r3.spanish = "es", r3.swedish = "sv", r3.croatian = "hr", r3.hungarian = "hu", r3))(i$1i || {});
const a$1C = {
  name: i$1i.englishUS,
  global: {
    undo: "Undo",
    redo: "Redo",
    confirm: "Confirm",
    clear: "Clear",
    more: "more",
    cancel: "Cancel"
  },
  Popconfirm: {
    positiveText: "Confirm",
    negativeText: "Cancel"
  },
  Cascader: {
    placeholder: "Please Select",
    loading: "Loading",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Clear",
    now: "Now",
    confirm: "Confirm",
    selectTime: "Select Time",
    selectDate: "Select Date",
    datePlaceholder: "Select Date",
    datetimePlaceholder: "Select Date and Time",
    monthPlaceholder: "Select Month",
    yearPlaceholder: "Select Year",
    quarterPlaceholder: "Select Quarter",
    startDatePlaceholder: "Start Date",
    endDatePlaceholder: "End Date",
    startDatetimePlaceholder: "Start Date and Time",
    endDatetimePlaceholder: "End Date and Time",
    startMonthPlaceholder: "Start Month",
    endMonthPlaceholder: "End Month",
    monthBeforeYear: true,
    firstDayOfWeek: 6,
    today: "Today"
  },
  DataTable: {
    checkTableAll: "Select all in the table",
    uncheckTableAll: "Unselect all in the table",
    confirm: "Confirm",
    clear: "Clear",
    apply: "Apply",
    filters: "Filters",
    sort: "Sort"
  },
  LegacyTransfer: {
    sourceTitle: "Source",
    targetTitle: "Target"
  },
  Transfer: {
    selectAll: "Select all",
    unselectAll: "Unselect all",
    clearAll: "Clear"
  },
  Empty: {
    description: "No Data"
  },
  Select: {
    placeholder: "Please Select"
  },
  TimePicker: {
    placeholder: "Select Time",
    positiveText: "OK",
    negativeText: "Cancel",
    now: "Now"
  },
  Pagination: {
    goto: "Goto",
    selectionSuffix: "page",
    next: "Next",
    previous: "Previous"
  },
  DynamicTags: {
    add: "Add"
  },
  Log: {
    loading: "Loading"
  },
  Input: {
    placeholder: "Please Input"
  },
  InputNumber: {
    placeholder: "Please Input"
  },
  DynamicInput: {
    create: "Create"
  },
  ThemeEditor: {
    title: "Theme Editor",
    clearAllVars: "Clear All Variables",
    clearSearch: "Clear Search",
    filterCompName: "Filter Component Name",
    filterVarName: "Filter Variable Name",
    import: "Import",
    export: "Export",
    restore: "Reset to Default"
  },
  Image: {
    tipPrevious: "Previous picture (\u2190)",
    tipNext: "Next picture (\u2192)",
    tipCounterclockwise: "Counterclockwise",
    tipClockwise: "Clockwise",
    tipZoomOut: "Zoom out",
    tipZoomIn: "Zoom in",
    tipClose: "Close (Esc)",
    tipOriginalSize: "Zoom to original size"
  },
  SortFilter: {
    heading: "Sort and Filters",
    sortHeading: "Sort By",
    newestFirst: "Newest First",
    oldestFirst: "Oldest First",
    ascending: "Asc",
    descending: "Desc",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Apply",
    clear: "Clear",
    cancel: "Cancel",
    filters: "Filters"
  },
  IconPicker: {
    noMatchingFound: "No matching results found"
  }
};
function s$1v(t3) {
  const o3 = inject("customLocale", null) || {};
  return computed(() => {
    var _a2;
    var r3;
    return (_a2 = (r3 = o3 == null ? void 0 : o3.value) == null ? void 0 : r3[t3]) != null ? _a2 : a$1C[t3];
  });
}
const e$1c = r$2a([r$2a("@keyframes badge-wave-spread", {
  from: {
    boxShadow: "0 0 0.5px 0px var(--n-ripple-color)",
    opacity: 0.6
  },
  to: {
    boxShadow: "0 0 0.5px 4.5px var(--n-ripple-color)",
    opacity: 0
  }
}), l$25("badge", `
 display: inline-flex;
 position: relative;
 vertical-align: middle;
 font-family: var(--n-font-family);
 `, [g$1j("as-is", [l$25("badge-sup", {
  position: "static",
  transform: "translateX(0)"
}, [$$n({
  transformOrigin: "left bottom",
  originalTransform: "translateX(0)"
})])]), g$1j("dot", [l$25("badge-sup", `
 height: 8px;
 width: 8px;
 padding: 0;
 min-width: 8px;
 left: 100%;
 bottom: calc(100% - 4px);
 `, [r$2a("::before", "border-radius: 4px;")])]), l$25("badge-sup", `
 background: var(--n-color);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 color: #FFF;
 position: absolute;
 height: 18px;
 line-height: 18px;
 border-radius: 9px;
 padding: 0 6px;
 text-align: center;
 font-size: var(--n-font-size);
 transform: translateX(-50%);
 left: 100%;
 bottom: calc(100% - 9px);
 font-variant-numeric: tabular-nums;
 z-index: 1;
 display: flex;
 align-items: center;
 `, [$$n({
  transformOrigin: "left bottom",
  originalTransform: "translateX(-50%)"
}), l$25("base-wave", {
  zIndex: 1,
  animationDuration: "2s",
  animationIterationCount: "infinite",
  animationDelay: "1s",
  animationTimingFunction: "var(--n-ripple-bezier)",
  animationName: "badge-wave-spread"
}), r$2a("&::before", `
 opacity: 0;
 transform: scale(1);
 border-radius: 9px;
 content: "";
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `)])])]);
const s$1u = (r3) => {
  const {
    errorColor: o3,
    infoColor: n3,
    successColor: c3,
    warningColor: t3,
    fontFamily: e28
  } = r3;
  return {
    color: o3,
    colorInfo: n3,
    colorSuccess: c3,
    colorError: o3,
    colorWarning: t3,
    fontSize: "12px",
    fontFamily: e28
  };
}, a$1B = {
  name: "Badge",
  common: d$1T,
  self: s$1u
}, g$$ = a$1B;
const R$l = defineComponent({
  name: "SlotMachineNumber",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      required: true
    },
    oldOriginalNumber: {
      type: Number,
      default: void 0
    },
    newOriginalNumber: {
      type: Number,
      default: void 0
    }
  },
  setup(n3) {
    const o3 = ref$1(null), u3 = ref$1(n3.value), s3 = ref$1(n3.value), i = ref$1("up"), t3 = ref$1(false), d3 = computed(() => t3.value ? `${n3.clsPrefix}-base-slot-machine-current-number--${i.value}-scroll` : null), c3 = computed(() => t3.value ? `${n3.clsPrefix}-base-slot-machine-old-number--${i.value}-scroll` : null);
    watch(toRef$1(n3, "value"), (e28, l3) => {
      u3.value = l3, s3.value = e28, nextTick(v3);
    });
    function v3() {
      const e28 = n3.newOriginalNumber, l3 = n3.oldOriginalNumber;
      l3 === void 0 || e28 === void 0 || (e28 > l3 ? m3("up") : l3 > e28 && m3("down"));
    }
    function m3(e28) {
      i.value = e28, t3.value = false, nextTick(() => {
        var l3;
        (l3 = o3.value) === null || l3 === void 0 || l3.offsetWidth, t3.value = true;
      });
    }
    return () => {
      const {
        clsPrefix: e28
      } = n3;
      return h$1R("span", {
        ref: o3,
        class: `${e28}-base-slot-machine-number`
      }, u3.value !== null ? h$1R("span", {
        class: [`${e28}-base-slot-machine-old-number ${e28}-base-slot-machine-old-number--top`, c3.value]
      }, u3.value) : null, h$1R("span", {
        class: [`${e28}-base-slot-machine-current-number`, d3.value]
      }, h$1R("span", {
        ref: "numberWrapper",
        class: [`${e28}-base-slot-machine-current-number__inner`, typeof n3.value != "number" && `${e28}-base-slot-machine-current-number__inner--not-number`]
      }, s3.value)), u3.value !== null ? h$1R("span", {
        class: [`${e28}-base-slot-machine-old-number ${e28}-base-slot-machine-old-number--bottom`, c3.value]
      }, u3.value) : null);
    };
  }
});
const {
  cubicBezierEaseOut: n$16
} = e$2d;
function o$16({
  duration: t3 = ".2s"
} = {}) {
  return [r$2a("&.fade-up-width-expand-transition-leave-active", {
    transition: `
 opacity ${t3} ${n$16},
 max-width ${t3} ${n$16},
 transform ${t3} ${n$16}
 `
  }), r$2a("&.fade-up-width-expand-transition-enter-active", {
    transition: `
 opacity ${t3} ${n$16},
 max-width ${t3} ${n$16},
 transform ${t3} ${n$16}
 `
  }), r$2a("&.fade-up-width-expand-transition-enter-to", {
    opacity: 1,
    transform: "translateX(0) translateY(0)"
  }), r$2a("&.fade-up-width-expand-transition-enter-from", {
    maxWidth: "0 !important",
    opacity: 0,
    transform: "translateY(60%)"
  }), r$2a("&.fade-up-width-expand-transition-leave-from", {
    opacity: 1,
    transform: "translateY(0)"
  }), r$2a("&.fade-up-width-expand-transition-leave-to", {
    maxWidth: "0 !important",
    opacity: 0,
    transform: "translateY(60%)"
  })];
}
const m$1y = r$2a([r$2a("@keyframes n-base-slot-machine-fade-up-in", `
 from {
 transform: translateY(60%);
 opacity: 0;
 }
 to {
 transform: translateY(0);
 opacity: 1;
 }
 `), r$2a("@keyframes n-base-slot-machine-fade-down-in", `
 from {
 transform: translateY(-60%);
 opacity: 0;
 }
 to {
 transform: translateY(0);
 opacity: 1;
 }
 `), r$2a("@keyframes n-base-slot-machine-fade-up-out", `
 from {
 transform: translateY(0%);
 opacity: 1;
 }
 to {
 transform: translateY(-60%);
 opacity: 0;
 }
 `), r$2a("@keyframes n-base-slot-machine-fade-down-out", `
 from {
 transform: translateY(0%);
 opacity: 1;
 }
 to {
 transform: translateY(60%);
 opacity: 0;
 }
 `), l$25("base-slot-machine", `
 overflow: hidden;
 white-space: nowrap;
 display: inline-block;
 height: 18px;
 line-height: 18px;
 `, [l$25("base-slot-machine-number", `
 display: inline-block;
 position: relative;
 height: 18px;
 width: .6em;
 max-width: .6em;
 `, [
  o$16({
    duration: ".2s"
  }),
  $$p({
    duration: ".2s",
    delay: "0s"
  }),
  l$25("base-slot-machine-old-number", `
 display: inline-block;
 opacity: 0;
 position: absolute;
 left: 0;
 right: 0;
 `, [g$1j("top", {
    transform: "translateY(-100%)"
  }), g$1j("bottom", {
    transform: "translateY(100%)"
  }), g$1j("down-scroll", {
    animation: "n-base-slot-machine-fade-down-out .2s cubic-bezier(0, 0, .2, 1)",
    animationIterationCount: 1
  }), g$1j("up-scroll", {
    animation: "n-base-slot-machine-fade-up-out .2s cubic-bezier(0, 0, .2, 1)",
    animationIterationCount: 1
  })]),
  l$25("base-slot-machine-current-number", `
 display: inline-block;
 position: absolute;
 left: 0;
 top: 0;
 bottom: 0;
 right: 0;
 opacity: 1;
 transform: translateY(0);
 width: .6em;
 `, [g$1j("down-scroll", {
    animation: "n-base-slot-machine-fade-down-in .2s cubic-bezier(0, 0, .2, 1)",
    animationIterationCount: 1
  }), g$1j("up-scroll", {
    animation: "n-base-slot-machine-fade-up-in .2s cubic-bezier(0, 0, .2, 1)",
    animationIterationCount: 1
  }), M$y("inner", `
 display: inline-block;
 position: absolute;
 right: 0;
 top: 0;
 width: .6em;
 `, [g$1j("not-number", `
 right: unset;
 left: 0;
 `)])])
])])]);
const M$o = defineComponent({
  name: "BaseSlotMachine",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: Number,
      default: void 0
    },
    appeared: {
      type: Boolean,
      required: true
    }
  },
  setup(n3) {
    S$O("-base-slot-machine", m$1y, toRef$1(n3, "clsPrefix"));
    const u3 = ref$1(), l3 = ref$1(), i = computed(() => {
      if (typeof n3.value == "string")
        return [];
      if (n3.value < 1)
        return [0];
      const a3 = [];
      let e28 = n3.value;
      for (n3.max !== void 0 && (e28 = Math.min(n3.max, e28)); e28 >= 1; )
        a3.push(e28 % 10), e28 /= 10, e28 = Math.floor(e28);
      return a3.reverse(), a3;
    });
    return watch(toRef$1(n3, "value"), (a3, e28) => {
      typeof a3 == "string" ? (l3.value = void 0, u3.value = void 0) : typeof e28 == "string" ? (l3.value = a3, u3.value = void 0) : (l3.value = a3, u3.value = e28);
    }), () => {
      const {
        value: a3,
        clsPrefix: e28
      } = n3;
      return typeof a3 == "number" ? h$1R("span", {
        class: `${e28}-base-slot-machine`
      }, h$1R(TransitionGroup, {
        name: "fade-up-width-expand-transition",
        tag: "span"
      }, {
        default: () => i.value.map((m3, o3) => h$1R(R$l, {
          clsPrefix: e28,
          key: i.value.length - o3 - 1,
          oldOriginalNumber: u3.value,
          newOriginalNumber: l3.value,
          value: m3
        }))
      }), h$1R(l$1W, {
        key: "+",
        width: true
      }, {
        default: () => n3.max !== void 0 && n3.max < a3 ? h$1R(R$l, {
          clsPrefix: e28,
          value: "+"
        }) : null
      })) : h$1R("span", {
        class: `${e28}-base-slot-machine`
      }, a3);
    };
  }
});
const F$s = Object.assign(Object.assign({}, _$F.props), {
  value: [String, Number],
  max: Number,
  dot: Boolean,
  type: {
    type: String,
    default: "default"
  },
  show: {
    type: Boolean,
    default: true
  },
  showZero: Boolean,
  processing: Boolean,
  color: String,
  offset: Array
}), ee$f = defineComponent({
  name: "Badge",
  props: F$s,
  setup(e28, {
    slots: t3
  }) {
    const {
      mergedClsPrefixRef: n3,
      inlineThemeDisabled: f3,
      mergedRtlRef: a3
    } = a$2x(e28), d3 = _$F("Badge", "-badge", e$1c, g$$, e28, n3), u3 = ref$1(false), y3 = () => {
      u3.value = true;
    }, B3 = () => {
      u3.value = false;
    }, p3 = computed(() => e28.show && (e28.dot || e28.value !== void 0 && !(!e28.showZero && Number(e28.value) <= 0) || !a$2k(t3.value)));
    onMounted(() => {
      p3.value && (u3.value = true);
    });
    const m3 = v$17("Badge", a3, n3), g3 = computed(() => {
      const {
        type: r3,
        color: o3
      } = e28, {
        common: {
          cubicBezierEaseInOut: s3,
          cubicBezierEaseOut: v3
        },
        self: {
          [_$H("color", r3)]: c3,
          fontFamily: x3,
          fontSize: C3
        }
      } = d3.value;
      return {
        "--n-font-size": C3,
        "--n-font-family": x3,
        "--n-color": o3 || c3,
        "--n-ripple-color": o3 || c3,
        "--n-bezier": s3,
        "--n-ripple-bezier": v3
      };
    }), l3 = f3 ? E$J("badge", computed(() => {
      let r3 = "";
      const {
        type: o3,
        color: s3
      } = e28;
      return o3 && (r3 += o3[0]), s3 && (r3 += e$1G(s3)), r3;
    }), g3, e28) : void 0, R3 = computed(() => {
      const {
        offset: r3
      } = e28;
      if (!r3)
        return;
      const [o3, s3] = r3, v3 = typeof o3 == "number" ? `${o3}px` : o3, c3 = typeof s3 == "number" ? `${s3}px` : s3;
      return {
        transform: `translate(calc(${m3 != null && m3.value ? "50%" : "-50%"} + ${v3}), ${c3})`
      };
    });
    return {
      rtlEnabled: m3,
      mergedClsPrefix: n3,
      appeared: u3,
      showBadge: p3,
      handleAfterEnter: y3,
      handleAfterLeave: B3,
      cssVars: f3 ? void 0 : g3,
      themeClass: l3 == null ? void 0 : l3.themeClass,
      onRender: l3 == null ? void 0 : l3.onRender,
      offsetStyle: R3
    };
  },
  render() {
    var e28;
    const {
      mergedClsPrefix: t3,
      onRender: n3,
      themeClass: f3,
      $slots: a3
    } = this;
    n3 == null || n3();
    const d3 = (e28 = a3.default) === null || e28 === void 0 ? void 0 : e28.call(a3);
    return h$1R("div", {
      class: [`${t3}-badge`, this.rtlEnabled && `${t3}-badge--rtl`, f3, {
        [`${t3}-badge--dot`]: this.dot,
        [`${t3}-badge--as-is`]: !d3
      }],
      style: this.cssVars
    }, d3, h$1R(Transition, {
      name: "fade-in-scale-up-transition",
      onAfterEnter: this.handleAfterEnter,
      onAfterLeave: this.handleAfterLeave
    }, {
      default: () => this.showBadge ? h$1R("sup", {
        class: `${t3}-badge-sup`,
        title: e$1g(this.value),
        style: this.offsetStyle
      }, p$3H(a3.value, () => [this.dot ? null : h$1R(M$o, {
        clsPrefix: t3,
        appeared: this.appeared,
        max: this.max,
        value: this.value
      })]), this.processing ? h$1R(w$P, {
        clsPrefix: t3
      }) : null) : null
    }));
  }
});
const G$p = { class: "mr-1" }, H$n = { class: "flex items-center justify-between w-60 filter-heading" }, J$m = { class: "flex items-center text-primary-600 space-x-2 actions" }, K$k = defineComponent({
  name: "UIFilter",
  inheritAttrs: false
}), Q$n = defineComponent(__spreadProps(__spreadValues({}, K$k), {
  props: {
    collapseItems: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      required: true
    }
  },
  emits: ["update:filter", "onSelectOption"],
  setup(s3, { emit: F3 }) {
    const d3 = s3, g3 = F3, m3 = ref$1(), i = ref$1([]), b3 = ref$1(), u3 = ref$1({}), v3 = ref$1(0);
    watch(() => d3.options, (l3) => {
      i.value = l3;
    }, {
      immediate: true
    });
    function N3(l3) {
      const t3 = i.value.find((e28) => l3.key === e28.key);
      return t3 ? (t3 == null ? void 0 : t3.options) || [] : [];
    }
    function S3(l3) {
      const t3 = i.value.find((e28) => l3.key === e28.key);
      return t3 ? (t3 == null ? void 0 : t3.value) || "" : [];
    }
    function I3(l3, t3) {
      const e28 = L$A(i.value);
      e28.forEach((r3) => (r3.key === t3.key && (r3.value = l3), r3)), i.value = e28, m3.value = L$A(e28).map((r3) => (delete r3.options, r3)), u3.value[t3.key] = l3, g3("onSelectOption", __spreadValues({ value: l3 }, t3));
    }
    function O3() {
      i.value = d3.options, m3.value = {}, u3.value = {}, x3(), C3();
    }
    function x3() {
      v3.value = 0;
      for (const l3 in u3.value) {
        const t3 = u3.value[l3], e28 = d3.options.find((r3) => r3.key === l3);
        e28.key === l3 && e28.value !== t3 && (v3.value += 1);
      }
      g3("update:filter", {
        filters: m3.value,
        options: i.value
      });
    }
    function B3() {
      x3(), C3();
    }
    function C3() {
      b3.value.handleClick();
    }
    const f3 = s$1v("DataTable");
    return (l3, t3) => (openBlock(), createBlock(unref(Ie$8), {
      trigger: "click",
      "show-arrow": false,
      ref_key: "popoverRef",
      ref: b3,
      placement: "bottom"
    }, {
      trigger: withCtx(() => [
        createVNode(unref(q$C), {
          size: "large",
          class: "hl-table-filter-btn",
          id: ""
        }, {
          default: withCtx(() => [
            createVNode(unref(c$1A), { class: "w-5 h-5 mr-1" }),
            createElementVNode("span", G$p, toDisplayString(unref(f3).filters), 1),
            createVNode(unref(ee$f), {
              class: "badge",
              value: v3.value,
              color: "#F2F4F7"
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      header: withCtx(() => [
        createElementVNode("div", H$n, [
          createVNode(unref(d$1H), { class: "title text-gray-900" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(f3).filters), 1)
            ]),
            _: 1
          }),
          createElementVNode("div", J$m, [
            createVNode(unref(q$C), {
              text: "",
              onClick: O3,
              id: `hl-table-${s3.id}-filter-clear`
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(f3).clear), 1)
              ]),
              _: 1
            }, 8, ["id"]),
            createVNode(unref(q$C), {
              text: "",
              onClick: B3,
              id: `hl-table-${s3.id}-filter-apply`
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(f3).apply), 1)
              ]),
              _: 1
            }, 8, ["id"])
          ])
        ])
      ]),
      default: withCtx(() => [
        createVNode(unref(te$k), null, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(s3.collapseItems, (e28) => (openBlock(), createBlock(unref(O$z), {
              title: e28.label,
              name: e28.key,
              key: e28.key
            }, {
              default: withCtx(() => [
                createVNode(unref(I$y), {
                  options: N3(e28),
                  value: S3(e28),
                  id: s3.id,
                  "onUpdate:value": (r3) => I3(r3, e28)
                }, null, 8, ["options", "value", "id", "onUpdate:value"])
              ]),
              _: 2
            }, 1032, ["title", "name"]))), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512));
  }
})), ue$g = Q$n;
const u$1k = (a3) => {
  var s3;
  if (!a3)
    return 10;
  const {
    defaultPageSize: f3
  } = a3;
  if (f3 !== void 0)
    return f3;
  const e28 = (s3 = a3.pageSizes) === null || s3 === void 0 ? void 0 : s3[0];
  return typeof e28 == "number" ? e28 : (e28 == null ? void 0 : e28.value) || 10;
};
function h$1h(a3, s3, f3, e28) {
  let m3 = false, y3 = false, F3 = 1, o3 = s3;
  if (s3 === 1)
    return {
      hasFastBackward: false,
      hasFastForward: false,
      fastForwardTo: o3,
      fastBackwardTo: F3,
      items: [{
        type: "page",
        label: 1,
        active: a3 === 1,
        mayBeFastBackward: false,
        mayBeFastForward: false
      }]
    };
  if (s3 === 2)
    return {
      hasFastBackward: false,
      hasFastForward: false,
      fastForwardTo: o3,
      fastBackwardTo: F3,
      items: [{
        type: "page",
        label: 1,
        active: a3 === 1,
        mayBeFastBackward: false,
        mayBeFastForward: false
      }, {
        type: "page",
        label: 2,
        active: a3 === 2,
        mayBeFastBackward: true,
        mayBeFastForward: false
      }]
    };
  const i = 1, t3 = s3;
  let d3 = a3, r3 = a3;
  const c3 = (f3 - 5) / 2;
  r3 += Math.ceil(c3), r3 = Math.min(Math.max(r3, i + f3 - 3), t3 - 2), d3 -= Math.floor(c3), d3 = Math.max(Math.min(d3, t3 - f3 + 3), i + 2);
  let n3 = false, p3 = false;
  d3 > i + 2 && (n3 = true), r3 < t3 - 2 && (p3 = true);
  const l3 = [];
  l3.push({
    type: "page",
    label: 1,
    active: a3 === 1,
    mayBeFastBackward: false,
    mayBeFastForward: false
  }), n3 ? (m3 = true, F3 = d3 - 1, l3.push({
    type: "fast-backward",
    active: false,
    label: void 0,
    options: e28 ? w$E(i + 1, d3 - 1) : null
  })) : t3 >= i + 1 && l3.push({
    type: "page",
    label: i + 1,
    mayBeFastBackward: true,
    mayBeFastForward: false,
    active: a3 === i + 1
  });
  for (let B3 = d3; B3 <= r3; ++B3)
    l3.push({
      type: "page",
      label: B3,
      mayBeFastBackward: false,
      mayBeFastForward: false,
      active: a3 === B3
    });
  return p3 ? (y3 = true, o3 = r3 + 1, l3.push({
    type: "fast-forward",
    active: false,
    label: void 0,
    options: e28 ? w$E(r3 + 1, t3 - 1) : null
  })) : r3 === t3 - 2 && l3[l3.length - 1].label !== t3 - 1 && l3.push({
    type: "page",
    mayBeFastForward: true,
    mayBeFastBackward: false,
    label: t3 - 1,
    active: a3 === t3 - 1
  }), l3[l3.length - 1].label !== t3 && l3.push({
    type: "page",
    mayBeFastForward: false,
    mayBeFastBackward: false,
    label: t3,
    active: a3 === t3
  }), {
    hasFastBackward: m3,
    hasFastForward: y3,
    fastBackwardTo: F3,
    fastForwardTo: o3,
    items: l3
  };
}
function w$E(a3, s3) {
  const f3 = [];
  for (let e28 = a3; e28 <= s3; ++e28)
    f3.push({
      label: `${e28}`,
      value: e28
    });
  return f3;
}
const n$15 = `
 background: var(--n-item-color-hover);
 color: var(--n-item-text-color-hover);
 border: var(--n-item-border-hover);
`, i$1h = [g$1j("button", `
 background: var(--n-button-color-hover);
 border: var(--n-button-border-hover);
 color: var(--n-button-icon-color-hover);
 `)], c$1v = l$25("pagination", `
 display: flex;
 vertical-align: middle;
 font-size: var(--n-item-font-size);
 flex-wrap: nowrap;
`, [l$25("pagination-prefix", `
 display: flex;
 align-items: center;
 margin: var(--n-prefix-margin);
 `), l$25("pagination-suffix", `
 display: flex;
 align-items: center;
 margin: var(--n-suffix-margin);
 `), r$2a("> *:not(:first-child)", `
 margin: var(--n-item-margin);
 `), l$25("select", `
 width: var(--n-select-width);
 `), r$2a("&.transition-disabled", [l$25("pagination-item", "transition: none!important;")]), l$25("pagination-quick-jumper", `
 white-space: nowrap;
 display: flex;
 color: var(--n-jumper-text-color);
 transition: color .3s var(--n-bezier);
 align-items: center;
 font-size: var(--n-jumper-font-size);
 `, [l$25("input", `
 margin: var(--n-input-margin);
 width: var(--n-input-width);
 `)]), l$25("pagination-item", `
 position: relative;
 cursor: pointer;
 user-select: none;
 -webkit-user-select: none;
 display: flex;
 align-items: center;
 justify-content: center;
 box-sizing: border-box;
 min-width: var(--n-item-size);
 height: var(--n-item-size);
 padding: var(--n-item-padding);
 background-color: var(--n-item-color);
 color: var(--n-item-text-color);
 border-radius: var(--n-item-border-radius);
 border: var(--n-item-border);
 fill: var(--n-button-icon-color);
 transition:
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 fill .3s var(--n-bezier);
 `, [g$1j("button", `
 background: var(--n-button-color);
 color: var(--n-button-icon-color);
 border: var(--n-button-border);
 padding: 0;
 `, [l$25("base-icon", `
 font-size: var(--n-button-icon-size);
 `)]), x$I("disabled", [g$1j("hover", n$15, i$1h), r$2a("&:hover", n$15, i$1h), r$2a("&:active", `
 background: var(--n-item-color-pressed);
 color: var(--n-item-text-color-pressed);
 border: var(--n-item-border-pressed);
 `, [g$1j("button", `
 background: var(--n-button-color-pressed);
 border: var(--n-button-border-pressed);
 color: var(--n-button-icon-color-pressed);
 `)]), g$1j("active", `
 background: var(--n-item-color-active);
 color: var(--n-item-text-color-active);
 border: var(--n-item-border-active);
 `, [r$2a("&:hover", `
 background: var(--n-item-color-active-hover);
 `)])]), g$1j("disabled", `
 cursor: not-allowed;
 color: var(--n-item-text-color-disabled);
 `, [g$1j("active, button", `
 background-color: var(--n-item-color-disabled);
 border: var(--n-item-border-disabled);
 `)])]), g$1j("disabled", `
 cursor: not-allowed;
 `, [l$25("pagination-quick-jumper", `
 color: var(--n-jumper-text-color-disabled);
 `)]), g$1j("simple", `
 display: flex;
 align-items: center;
 flex-wrap: nowrap;
 `, [l$25("pagination-quick-jumper", [l$25("input", `
 margin: 0;
 `)])])]);
function r$1o(e28) {
  switch (e28) {
    case "tiny":
      return "mini";
    case "small":
      return "tiny";
    case "medium":
      return "small";
    case "large":
      return "medium";
    case "huge":
      return "large";
  }
  throw Error(`${e28} has no smaller size.`);
}
const n$14 = defineComponent({
  name: "Forward",
  render() {
    return h$1R("svg", {
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, h$1R("path", {
      d: "M7.73271 4.20694C8.03263 3.92125 8.50737 3.93279 8.79306 4.23271L13.7944 9.48318C14.0703 9.77285 14.0703 10.2281 13.7944 10.5178L8.79306 15.7682C8.50737 16.0681 8.03263 16.0797 7.73271 15.794C7.43279 15.5083 7.42125 15.0336 7.70694 14.7336L12.2155 10.0005L7.70694 5.26729C7.42125 4.96737 7.43279 4.49264 7.73271 4.20694Z",
      fill: "currentColor"
    }));
  }
});
const o$15 = defineComponent({
  name: "Backward",
  render() {
    return h$1R("svg", {
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, h$1R("path", {
      d: "M12.2674 15.793C11.9675 16.0787 11.4927 16.0672 11.2071 15.7673L6.20572 10.5168C5.9298 10.2271 5.9298 9.7719 6.20572 9.48223L11.2071 4.23177C11.4927 3.93184 11.9675 3.92031 12.2674 4.206C12.5673 4.49169 12.5789 4.96642 12.2932 5.26634L7.78458 9.99952L12.2932 14.7327C12.5789 15.0326 12.5673 15.5074 12.2674 15.793Z",
      fill: "currentColor"
    }));
  }
});
const n$13 = defineComponent({
  name: "FastForward",
  render() {
    return h$1R("svg", {
      viewBox: "0 0 20 20",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, h$1R("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, h$1R("g", {
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, h$1R("path", {
      d: "M11.2654,3.20511 C10.9644,2.92049 10.4897,2.93371 10.2051,3.23464 C9.92049,3.53558 9.93371,4.01027 10.2346,4.29489 L15.4737,9.25 L2.75,9.25 C2.33579,9.25 2,9.58579 2,10.0000012 C2,10.4142 2.33579,10.75 2.75,10.75 L15.476,10.75 L10.2346,15.7073 C9.93371,15.9919 9.92049,16.4666 10.2051,16.7675 C10.4897,17.0684 10.9644,17.0817 11.2654,16.797 L17.6826,10.7276 C17.8489,10.5703 17.9489,10.3702 17.9826,10.1614 C17.994,10.1094 18,10.0554 18,10.0000012 C18,9.94241 17.9935,9.88633 17.9812,9.83246 C17.9462,9.62667 17.8467,9.42976 17.6826,9.27455 L11.2654,3.20511 Z"
    }))));
  }
});
const n$12 = defineComponent({
  name: "FastBackward",
  render() {
    return h$1R("svg", {
      viewBox: "0 0 20 20",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, h$1R("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, h$1R("g", {
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, h$1R("path", {
      d: "M8.73171,16.7949 C9.03264,17.0795 9.50733,17.0663 9.79196,16.7654 C10.0766,16.4644 10.0634,15.9897 9.76243,15.7051 L4.52339,10.75 L17.2471,10.75 C17.6613,10.75 17.9971,10.4142 17.9971,10 C17.9971,9.58579 17.6613,9.25 17.2471,9.25 L4.52112,9.25 L9.76243,4.29275 C10.0634,4.00812 10.0766,3.53343 9.79196,3.2325 C9.50733,2.93156 9.03264,2.91834 8.73171,3.20297 L2.31449,9.27241 C2.14819,9.4297 2.04819,9.62981 2.01448,9.8386 C2.00308,9.89058 1.99707,9.94459 1.99707,10 C1.99707,10.0576 2.00356,10.1137 2.01585,10.1675 C2.05084,10.3733 2.15039,10.5702 2.31449,10.7254 L8.73171,16.7949 Z"
    }))));
  }
});
const n$11 = defineComponent({
  name: "More",
  render() {
    return h$1R("svg", {
      viewBox: "0 0 16 16",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, h$1R("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, h$1R("g", {
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, h$1R("path", {
      d: "M4,7 C4.55228,7 5,7.44772 5,8 C5,8.55229 4.55228,9 4,9 C3.44772,9 3,8.55229 3,8 C3,7.44772 3.44772,7 4,7 Z M8,7 C8.55229,7 9,7.44772 9,8 C9,8.55229 8.55229,9 8,9 C7.44772,9 7,8.55229 7,8 C7,7.44772 7.44772,7 8,7 Z M12,7 C12.5523,7 13,7.44772 13,8 C13,8.55229 12.5523,9 12,9 C11.4477,9 11,8.55229 11,8 C11,7.44772 11.4477,7 12,7 Z"
    }))));
  }
});
const t$15 = n$28("n-popselect");
const s$1t = l$25("popselect-menu", `
 box-shadow: var(--n-menu-box-shadow);
`);
function p$3c(e28) {
  const {
    boxShadow2: o3
  } = e28;
  return {
    menuBoxShadow: o3
  };
}
const c$1u = G$w({
  name: "Popselect",
  common: d$1T,
  peers: {
    Popover: b$11,
    InternalSelectMenu: A$x
  },
  self: p$3c
}), h$1g = c$1u;
const w$D = {
  multiple: Boolean,
  value: {
    type: [String, Number, Array],
    default: null
  },
  cancelable: Boolean,
  options: {
    type: Array,
    default: () => []
  },
  size: {
    type: String,
    default: "medium"
  },
  scrollable: Boolean,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onMouseenter: Function,
  onMouseleave: Function,
  renderLabel: Function,
  showCheckmark: {
    type: Boolean,
    default: void 0
  },
  nodeProps: Function,
  virtualScroll: Boolean,
  onChange: [Function, Array]
}, oe$f = t$1y(w$D), te$g = defineComponent({
  name: "PopselectPanel",
  props: w$D,
  setup(t3) {
    const o3 = inject(t$15), {
      mergedClsPrefixRef: n3,
      inlineThemeDisabled: m3
    } = a$2x(t3), M3 = _$F("Popselect", "-pop-select", s$1t, h$1g, o3.props, n3), f3 = computed(() => U$s(t3.options, p$3g("value", "children")));
    function u3(e28, r3) {
      const {
        onUpdateValue: s3,
        "onUpdate:value": l3,
        onChange: a3
      } = t3;
      s3 && i$1Z(s3, e28, r3), l3 && i$1Z(l3, e28, r3), a3 && i$1Z(a3, e28, r3);
    }
    function P3(e28) {
      b3(e28.key);
    }
    function C3(e28) {
      !a$2j(e28, "action") && !a$2j(e28, "empty") && !a$2j(e28, "header") && e28.preventDefault();
    }
    function b3(e28) {
      const {
        value: {
          getNode: r3
        }
      } = f3;
      if (t3.multiple)
        if (Array.isArray(t3.value)) {
          const s3 = [], l3 = [];
          let a3 = true;
          t3.value.forEach((v3) => {
            if (v3 === e28) {
              a3 = false;
              return;
            }
            const c3 = r3(v3);
            c3 && (s3.push(c3.key), l3.push(c3.rawNode));
          }), a3 && (s3.push(e28), l3.push(r3(e28).rawNode)), u3(s3, l3);
        } else {
          const s3 = r3(e28);
          s3 && u3([e28], [s3.rawNode]);
        }
      else if (t3.value === e28 && t3.cancelable)
        u3(null, null);
      else {
        const s3 = r3(e28);
        s3 && u3(e28, s3.rawNode);
        const {
          "onUpdate:show": l3,
          onUpdateShow: a3
        } = o3.props;
        l3 && i$1Z(l3, false), a3 && i$1Z(a3, false), o3.setShow(false);
      }
      nextTick(() => {
        o3.syncPosition();
      });
    }
    watch(toRef$1(t3, "options"), () => {
      nextTick(() => {
        o3.syncPosition();
      });
    });
    const p3 = computed(() => {
      const {
        self: {
          menuBoxShadow: e28
        }
      } = M3.value;
      return {
        "--n-menu-box-shadow": e28
      };
    }), i = m3 ? E$J("select", void 0, p3, o3.props) : void 0;
    return {
      mergedTheme: o3.mergedThemeRef,
      mergedClsPrefix: n3,
      treeMate: f3,
      handleToggle: P3,
      handleMenuMousedown: C3,
      cssVars: m3 ? void 0 : p3,
      themeClass: i == null ? void 0 : i.themeClass,
      onRender: i == null ? void 0 : i.onRender
    };
  },
  render() {
    var t3;
    return (t3 = this.onRender) === null || t3 === void 0 || t3.call(this), h$1R(rn$3, {
      clsPrefix: this.mergedClsPrefix,
      focusable: true,
      nodeProps: this.nodeProps,
      class: [`${this.mergedClsPrefix}-popselect-menu`, this.themeClass],
      style: this.cssVars,
      theme: this.mergedTheme.peers.InternalSelectMenu,
      themeOverrides: this.mergedTheme.peerOverrides.InternalSelectMenu,
      multiple: this.multiple,
      treeMate: this.treeMate,
      size: this.size,
      value: this.value,
      virtualScroll: this.virtualScroll,
      scrollable: this.scrollable,
      renderLabel: this.renderLabel,
      onToggle: this.handleToggle,
      onMouseenter: this.onMouseenter,
      onMouseleave: this.onMouseenter,
      onMousedown: this.handleMenuMousedown,
      showCheckmark: this.showCheckmark
    }, {
      header: () => {
        var o3, n3;
        return ((n3 = (o3 = this.$slots).header) === null || n3 === void 0 ? void 0 : n3.call(o3)) || [];
      },
      action: () => {
        var o3, n3;
        return ((n3 = (o3 = this.$slots).action) === null || n3 === void 0 ? void 0 : n3.call(o3)) || [];
      },
      empty: () => {
        var o3, n3;
        return ((n3 = (o3 = this.$slots).empty) === null || n3 === void 0 ? void 0 : n3.call(o3)) || [];
      }
    });
  }
});
function t$14(e28) {
  return (l3) => {
    l3 ? e28.value = l3.$el : e28.value = null;
  };
}
function i$1g(e28, s3 = [], c3) {
  const n3 = {};
  return Object.getOwnPropertyNames(e28).forEach((t3) => {
    s3.includes(t3) || (n3[t3] = e28[t3]);
  }), Object.assign(n3, c3);
}
const w$C = Object.assign(Object.assign(Object.assign(Object.assign({}, _$F.props), i$1g(de$g, ["showArrow", "arrow"])), {
  placement: Object.assign(Object.assign({}, de$g.placement), {
    default: "bottom"
  }),
  trigger: {
    type: String,
    default: "hover"
  }
}), w$D), E$w = defineComponent({
  name: "Popselect",
  props: w$C,
  inheritAttrs: false,
  __popover__: true,
  setup(n3) {
    const {
      mergedClsPrefixRef: a3
    } = a$2x(n3), s3 = _$F("Popselect", "-popselect", void 0, h$1g, n3, a3), r3 = ref$1(null);
    function i() {
      var o3;
      (o3 = r3.value) === null || o3 === void 0 || o3.syncPosition();
    }
    function p3(o3) {
      var e28;
      (e28 = r3.value) === null || e28 === void 0 || e28.setShow(o3);
    }
    return provide(t$15, {
      props: n3,
      mergedThemeRef: s3,
      syncPosition: i,
      setShow: p3
    }), Object.assign(Object.assign({}, {
      syncPosition: i,
      setShow: p3
    }), {
      popoverInstRef: r3,
      mergedTheme: s3
    });
  },
  render() {
    const {
      mergedTheme: n3
    } = this, a3 = {
      theme: n3.peers.Popover,
      themeOverrides: n3.peerOverrides.Popover,
      builtinThemeOverrides: {
        padding: "0"
      },
      ref: "popoverInstRef",
      internalRenderBody: (s3, r3, i, p3, l3) => {
        const {
          $attrs: o3
        } = this;
        return h$1R(te$g, Object.assign({}, o3, {
          class: [o3.class, s3],
          style: [o3.style, ...i]
        }, r$1C(this.$props, oe$f), {
          ref: t$14(r3),
          onMouseenter: f$14([p3, o3.onMouseenter]),
          onMouseleave: f$14([l3, o3.onMouseleave])
        }), {
          header: () => {
            var e28, t3;
            return (t3 = (e28 = this.$slots).header) === null || t3 === void 0 ? void 0 : t3.call(e28);
          },
          action: () => {
            var e28, t3;
            return (t3 = (e28 = this.$slots).action) === null || t3 === void 0 ? void 0 : t3.call(e28);
          },
          empty: () => {
            var e28, t3;
            return (t3 = (e28 = this.$slots).empty) === null || t3 === void 0 ? void 0 : t3.call(e28);
          }
        });
      }
    };
    return h$1R(Ie$8, Object.assign({}, i$1g(this.$props, oe$f), a3, {
      internalDeactivateImmediately: true
    }), {
      trigger: () => {
        var s3, r3;
        return (r3 = (s3 = this.$slots).default) === null || r3 === void 0 ? void 0 : r3.call(s3);
      }
    });
  }
});
const i$1f = {
  itemPaddingSmall: "0 4px",
  itemMarginSmall: "0 0 0 8px",
  itemMarginSmallRtl: "0 8px 0 0",
  itemPaddingMedium: "0 4px",
  itemMarginMedium: "0 0 0 8px",
  itemMarginMediumRtl: "0 8px 0 0",
  itemPaddingLarge: "0 4px",
  itemMarginLarge: "0 0 0 8px",
  itemMarginLargeRtl: "0 8px 0 0",
  buttonIconSizeSmall: "14px",
  buttonIconSizeMedium: "16px",
  buttonIconSizeLarge: "18px",
  inputWidthSmall: "60px",
  selectWidthSmall: "unset",
  inputMarginSmall: "0 0 0 8px",
  inputMarginSmallRtl: "0 8px 0 0",
  selectMarginSmall: "0 0 0 8px",
  prefixMarginSmall: "0 8px 0 0",
  suffixMarginSmall: "0 0 0 8px",
  inputWidthMedium: "60px",
  selectWidthMedium: "unset",
  inputMarginMedium: "0 0 0 8px",
  inputMarginMediumRtl: "0 8px 0 0",
  selectMarginMedium: "0 0 0 8px",
  prefixMarginMedium: "0 8px 0 0",
  suffixMarginMedium: "0 0 0 8px",
  inputWidthLarge: "60px",
  selectWidthLarge: "unset",
  inputMarginLarge: "0 0 0 8px",
  inputMarginLargeRtl: "0 8px 0 0",
  selectMarginLarge: "0 0 0 8px",
  prefixMarginLarge: "0 8px 0 0",
  suffixMarginLarge: "0 0 0 8px"
};
const z$o = (s3) => {
  const {
    textColor2: o3,
    primaryColor: t3,
    primaryColorHover: n3,
    primaryColorPressed: d3,
    inputColorDisabled: a3,
    textColorDisabled: r3,
    borderColor: e28,
    borderRadius: p3,
    fontSizeTiny: i,
    fontSizeSmall: m3,
    fontSizeMedium: l3,
    heightTiny: u3,
    heightSmall: C3,
    heightMedium: c3
  } = s3;
  return Object.assign(Object.assign({}, i$1f), {
    buttonColor: "#0000",
    buttonColorHover: "#0000",
    buttonColorPressed: "#0000",
    buttonBorder: `1px solid ${e28}`,
    buttonBorderHover: `1px solid ${e28}`,
    buttonBorderPressed: `1px solid ${e28}`,
    buttonIconColor: o3,
    buttonIconColorHover: o3,
    buttonIconColorPressed: o3,
    itemTextColor: o3,
    itemTextColorHover: n3,
    itemTextColorPressed: d3,
    itemTextColorActive: t3,
    itemTextColorDisabled: r3,
    itemColor: "#0000",
    itemColorHover: "#0000",
    itemColorPressed: "#0000",
    itemColorActive: "#0000",
    itemColorActiveHover: "#0000",
    itemColorDisabled: a3,
    itemBorder: "1px solid #0000",
    itemBorderHover: "1px solid #0000",
    itemBorderPressed: "1px solid #0000",
    itemBorderActive: `1px solid ${t3}`,
    itemBorderDisabled: `1px solid ${e28}`,
    itemBorderRadius: p3,
    itemSizeSmall: u3,
    itemSizeMedium: C3,
    itemSizeLarge: c3,
    itemFontSizeSmall: i,
    itemFontSizeMedium: m3,
    itemFontSizeLarge: l3,
    jumperFontSizeSmall: i,
    jumperFontSizeMedium: m3,
    jumperFontSizeLarge: l3,
    jumperTextColor: o3,
    jumperTextColorDisabled: r3
  });
}, f$10 = G$w({
  name: "Pagination",
  common: d$1T,
  peers: {
    Select: f$11,
    Input: k$H,
    Popselect: h$1g
  },
  self: z$o
}), D$C = f$10;
const gt$7 = Object.assign(Object.assign({}, _$F.props), {
  simple: Boolean,
  page: Number,
  defaultPage: {
    type: Number,
    default: 1
  },
  itemCount: Number,
  pageCount: Number,
  defaultPageCount: {
    type: Number,
    default: 1
  },
  showSizePicker: Boolean,
  pageSize: Number,
  defaultPageSize: Number,
  pageSizes: {
    type: Array,
    default() {
      return [10];
    }
  },
  showQuickJumper: Boolean,
  size: {
    type: String,
    default: "medium"
  },
  disabled: Boolean,
  pageSlot: {
    type: Number,
    default: 9
  },
  selectProps: Object,
  prev: Function,
  next: Function,
  goto: Function,
  prefix: Function,
  suffix: Function,
  label: Function,
  displayOrder: {
    type: Array,
    default: ["pages", "size-picker", "quick-jumper"]
  },
  to: f$1m.propTo,
  showQuickJumpDropdown: {
    type: Boolean,
    default: true
  },
  "onUpdate:page": [Function, Array],
  onUpdatePage: [Function, Array],
  "onUpdate:pageSize": [Function, Array],
  onUpdatePageSize: [Function, Array],
  onPageSizeChange: [Function, Array],
  onChange: [Function, Array]
}), Dt$5 = defineComponent({
  name: "Pagination",
  props: gt$7,
  setup(t3) {
    const {
      mergedComponentPropsRef: n3,
      mergedClsPrefixRef: l3,
      inlineThemeDisabled: U3,
      mergedRtlRef: g3
    } = a$2x(t3), h3 = _$F("Pagination", "-pagination", c$1v, D$C, t3, l3), {
      localeRef: E3
    } = R$p("Pagination"), $3 = ref$1(null), V10 = ref$1(t3.defaultPage), m3 = ref$1(u$1k(t3)), d3 = d$1S(toRef$1(t3, "page"), V10), v3 = d$1S(toRef$1(t3, "pageSize"), m3), b3 = computed(() => {
      const {
        itemCount: e28
      } = t3;
      if (e28 !== void 0)
        return Math.max(1, Math.ceil(e28 / v3.value));
      const {
        pageCount: a3
      } = t3;
      return a3 !== void 0 ? Math.max(a3, 1) : 1;
    }), u3 = ref$1("");
    watchEffect(() => {
      t3.simple, u3.value = String(d3.value);
    });
    const I3 = ref$1(false), P3 = ref$1(false), S3 = ref$1(false), D3 = ref$1(false), W3 = () => {
      t3.disabled || (I3.value = true, k3());
    }, L3 = () => {
      t3.disabled || (I3.value = false, k3());
    }, q3 = () => {
      P3.value = true, k3();
    }, K3 = () => {
      P3.value = false, k3();
    }, J3 = (e28) => {
      c3(e28);
    }, C3 = computed(() => h$1h(d3.value, b3.value, t3.pageSlot, t3.showQuickJumpDropdown));
    watchEffect(() => {
      C3.value.hasFastBackward ? C3.value.hasFastForward || (I3.value = false, S3.value = false) : (P3.value = false, D3.value = false);
    });
    const G3 = computed(() => {
      const e28 = E3.value.selectionSuffix;
      return t3.pageSizes.map((a3) => typeof a3 == "number" ? {
        label: `${a3} / ${e28}`,
        value: a3
      } : a3);
    }), X3 = computed(() => {
      var e28, a3;
      return ((a3 = (e28 = n3 == null ? void 0 : n3.value) === null || e28 === void 0 ? void 0 : e28.Pagination) === null || a3 === void 0 ? void 0 : a3.inputSize) || r$1o(t3.size);
    }), Y3 = computed(() => {
      var e28, a3;
      return ((a3 = (e28 = n3 == null ? void 0 : n3.value) === null || e28 === void 0 ? void 0 : e28.Pagination) === null || a3 === void 0 ? void 0 : a3.selectSize) || r$1o(t3.size);
    }), Z3 = computed(() => (d3.value - 1) * v3.value), H3 = computed(() => {
      const e28 = d3.value * v3.value - 1, {
        itemCount: a3
      } = t3;
      return a3 !== void 0 && e28 > a3 - 1 ? a3 - 1 : e28;
    }), N3 = computed(() => {
      const {
        itemCount: e28
      } = t3;
      return e28 !== void 0 ? e28 : (t3.pageCount || 1) * v3.value;
    }), _3 = v$17("Pagination", g3, l3), k3 = () => {
      nextTick(() => {
        var e28;
        const {
          value: a3
        } = $3;
        a3 && (a3.classList.add("transition-disabled"), (e28 = $3.value) === null || e28 === void 0 || e28.offsetWidth, a3.classList.remove("transition-disabled"));
      });
    };
    function c3(e28) {
      if (e28 === d3.value)
        return;
      const {
        "onUpdate:page": a3,
        onUpdatePage: M3,
        onChange: B3,
        simple: ae2
      } = t3;
      a3 && i$1Z(a3, e28), M3 && i$1Z(M3, e28), B3 && i$1Z(B3, e28), V10.value = e28, ae2 && (u3.value = String(e28));
    }
    function O3(e28) {
      if (e28 === v3.value)
        return;
      const {
        "onUpdate:pageSize": a3,
        onUpdatePageSize: M3,
        onPageSizeChange: B3
      } = t3;
      a3 && i$1Z(a3, e28), M3 && i$1Z(M3, e28), B3 && i$1Z(B3, e28), m3.value = e28, b3.value < d3.value && c3(b3.value);
    }
    function x3() {
      if (t3.disabled)
        return;
      const e28 = Math.min(d3.value + 1, b3.value);
      c3(e28);
    }
    function ee2() {
      if (t3.disabled)
        return;
      const e28 = Math.max(d3.value - 1, 1);
      c3(e28);
    }
    function o3() {
      if (t3.disabled)
        return;
      const e28 = Math.min(C3.value.fastForwardTo, b3.value);
      c3(e28);
    }
    function te2() {
      if (t3.disabled)
        return;
      const e28 = Math.max(C3.value.fastBackwardTo, 1);
      c3(e28);
    }
    function w3(e28) {
      O3(e28);
    }
    function A3() {
      const e28 = parseInt(u3.value);
      Number.isNaN(e28) || (c3(Math.max(1, Math.min(e28, b3.value))), t3.simple || (u3.value = ""));
    }
    function j3() {
      A3();
    }
    function f3(e28) {
      if (!t3.disabled)
        switch (e28.type) {
          case "page":
            c3(e28.label);
            break;
          case "fast-backward":
            te2();
            break;
          case "fast-forward":
            o3();
            break;
        }
    }
    function T3(e28) {
      u3.value = e28.replace(/\D+/g, "");
    }
    watchEffect(() => {
      d3.value, v3.value, k3();
    });
    const z3 = computed(() => {
      const {
        size: e28
      } = t3, {
        self: {
          buttonBorder: a3,
          buttonBorderHover: M3,
          buttonBorderPressed: B3,
          buttonIconColor: ae2,
          buttonIconColorHover: ge2,
          buttonIconColorPressed: he2,
          itemTextColor: ve2,
          itemTextColorHover: be2,
          itemTextColorPressed: we2,
          itemTextColorActive: Ce2,
          itemTextColorDisabled: ke2,
          itemColor: xe2,
          itemColorHover: Fe2,
          itemColorPressed: Pe2,
          itemColorActive: Se2,
          itemColorActiveHover: ze2,
          itemColorDisabled: Me2,
          itemBorder: Be2,
          itemBorderHover: Ie2,
          itemBorderPressed: ye2,
          itemBorderActive: Re2,
          itemBorderDisabled: $e2,
          itemBorderRadius: Ne2,
          jumperTextColor: Oe2,
          jumperTextColorDisabled: Ae2,
          buttonColor: je2,
          buttonColorHover: Te2,
          buttonColorPressed: Ue2,
          [_$H("itemPadding", e28)]: Ee2,
          [_$H("itemMargin", e28)]: Ve2,
          [_$H("inputWidth", e28)]: De2,
          [_$H("selectWidth", e28)]: Je2,
          [_$H("inputMargin", e28)]: He2,
          [_$H("selectMargin", e28)]: _e2,
          [_$H("jumperFontSize", e28)]: Qe2,
          [_$H("prefixMargin", e28)]: We2,
          [_$H("suffixMargin", e28)]: Le2,
          [_$H("itemSize", e28)]: qe2,
          [_$H("buttonIconSize", e28)]: Ke2,
          [_$H("itemFontSize", e28)]: Ge2,
          [`${_$H("itemMargin", e28)}Rtl`]: Xe2,
          [`${_$H("inputMargin", e28)}Rtl`]: Ye2
        },
        common: {
          cubicBezierEaseInOut: Ze2
        }
      } = h3.value;
      return {
        "--n-prefix-margin": We2,
        "--n-suffix-margin": Le2,
        "--n-item-font-size": Ge2,
        "--n-select-width": Je2,
        "--n-select-margin": _e2,
        "--n-input-width": De2,
        "--n-input-margin": He2,
        "--n-input-margin-rtl": Ye2,
        "--n-item-size": qe2,
        "--n-item-text-color": ve2,
        "--n-item-text-color-disabled": ke2,
        "--n-item-text-color-hover": be2,
        "--n-item-text-color-active": Ce2,
        "--n-item-text-color-pressed": we2,
        "--n-item-color": xe2,
        "--n-item-color-hover": Fe2,
        "--n-item-color-disabled": Me2,
        "--n-item-color-active": Se2,
        "--n-item-color-active-hover": ze2,
        "--n-item-color-pressed": Pe2,
        "--n-item-border": Be2,
        "--n-item-border-hover": Ie2,
        "--n-item-border-disabled": $e2,
        "--n-item-border-active": Re2,
        "--n-item-border-pressed": ye2,
        "--n-item-padding": Ee2,
        "--n-item-border-radius": Ne2,
        "--n-bezier": Ze2,
        "--n-jumper-font-size": Qe2,
        "--n-jumper-text-color": Oe2,
        "--n-jumper-text-color-disabled": Ae2,
        "--n-item-margin": Ve2,
        "--n-item-margin-rtl": Xe2,
        "--n-button-icon-size": Ke2,
        "--n-button-icon-color": ae2,
        "--n-button-icon-color-hover": ge2,
        "--n-button-icon-color-pressed": he2,
        "--n-button-color-hover": Te2,
        "--n-button-color": je2,
        "--n-button-color-pressed": Ue2,
        "--n-button-border": a3,
        "--n-button-border-hover": M3,
        "--n-button-border-pressed": B3
      };
    }), s3 = U3 ? E$J("pagination", computed(() => {
      let e28 = "";
      const {
        size: a3
      } = t3;
      return e28 += a3[0], e28;
    }), z3, t3) : void 0;
    return {
      rtlEnabled: _3,
      mergedClsPrefix: l3,
      locale: E3,
      selfRef: $3,
      mergedPage: d3,
      pageItems: computed(() => C3.value.items),
      mergedItemCount: N3,
      jumperValue: u3,
      pageSizeOptions: G3,
      mergedPageSize: v3,
      inputSize: X3,
      selectSize: Y3,
      mergedTheme: h3,
      mergedPageCount: b3,
      startIndex: Z3,
      endIndex: H3,
      showFastForwardMenu: S3,
      showFastBackwardMenu: D3,
      fastForwardActive: I3,
      fastBackwardActive: P3,
      handleMenuSelect: J3,
      handleFastForwardMouseenter: W3,
      handleFastForwardMouseleave: L3,
      handleFastBackwardMouseenter: q3,
      handleFastBackwardMouseleave: K3,
      handleJumperInput: T3,
      handleBackwardClick: ee2,
      handleForwardClick: x3,
      handlePageItemClick: f3,
      handleSizePickerChange: w3,
      handleQuickJumperChange: j3,
      cssVars: U3 ? void 0 : z3,
      themeClass: s3 == null ? void 0 : s3.themeClass,
      onRender: s3 == null ? void 0 : s3.onRender
    };
  },
  render() {
    const {
      $slots: t3,
      mergedClsPrefix: n3,
      disabled: l3,
      cssVars: U3,
      mergedPage: g3,
      mergedPageCount: h3,
      pageItems: E3,
      showSizePicker: $3,
      showQuickJumper: V10,
      mergedTheme: m3,
      locale: d3,
      inputSize: v3,
      selectSize: b3,
      mergedPageSize: u3,
      pageSizeOptions: I3,
      jumperValue: P3,
      simple: S3,
      prev: D3,
      next: W3,
      prefix: L3,
      suffix: q3,
      label: K3,
      goto: J3,
      handleJumperInput: C3,
      handleSizePickerChange: G3,
      handleBackwardClick: X3,
      handlePageItemClick: Y3,
      handleForwardClick: Z3,
      handleQuickJumperChange: H3,
      onRender: N3
    } = this;
    N3 == null || N3();
    const _3 = t3.prefix || L3, k3 = t3.suffix || q3, c3 = D3 || t3.prev, O3 = W3 || t3.next, x3 = K3 || t3.label;
    return h$1R("div", {
      ref: "selfRef",
      class: [`${n3}-pagination`, this.themeClass, this.rtlEnabled && `${n3}-pagination--rtl`, l3 && `${n3}-pagination--disabled`, S3 && `${n3}-pagination--simple`],
      style: U3
    }, _3 ? h$1R("div", {
      class: `${n3}-pagination-prefix`
    }, _3({
      page: g3,
      pageSize: u3,
      pageCount: h3,
      startIndex: this.startIndex,
      endIndex: this.endIndex,
      itemCount: this.mergedItemCount
    })) : null, this.displayOrder.map((ee2) => {
      switch (ee2) {
        case "pages":
          return h$1R(Fragment, null, h$1R("div", {
            class: [`${n3}-pagination-item`, !c3 && `${n3}-pagination-item--button`, (g3 <= 1 || g3 > h3 || l3) && `${n3}-pagination-item--disabled`],
            onClick: X3
          }, c3 ? c3({
            page: g3,
            pageSize: u3,
            pageCount: h3,
            startIndex: this.startIndex,
            endIndex: this.endIndex,
            itemCount: this.mergedItemCount
          }) : h$1R(d$1R, {
            clsPrefix: n3
          }, {
            default: () => this.rtlEnabled ? h$1R(n$14, null) : h$1R(o$15, null)
          })), S3 ? h$1R(Fragment, null, h$1R("div", {
            class: `${n3}-pagination-quick-jumper`
          }, h$1R(Zn$3, {
            value: P3,
            onUpdateValue: C3,
            size: v3,
            placeholder: "",
            disabled: l3,
            theme: m3.peers.Input,
            themeOverrides: m3.peerOverrides.Input,
            onChange: H3
          })), "\xA0/ ", h3) : E3.map((o3, te2) => {
            let w3, A3, j3;
            const {
              type: f3
            } = o3;
            switch (f3) {
              case "page":
                const z3 = o3.label;
                x3 ? w3 = x3({
                  type: "page",
                  node: z3,
                  active: o3.active
                }) : w3 = z3;
                break;
              case "fast-forward":
                const s3 = this.fastForwardActive ? h$1R(d$1R, {
                  clsPrefix: n3
                }, {
                  default: () => this.rtlEnabled ? h$1R(n$12, null) : h$1R(n$13, null)
                }) : h$1R(d$1R, {
                  clsPrefix: n3
                }, {
                  default: () => h$1R(n$11, null)
                });
                x3 ? w3 = x3({
                  type: "fast-forward",
                  node: s3,
                  active: this.fastForwardActive || this.showFastForwardMenu
                }) : w3 = s3, A3 = this.handleFastForwardMouseenter, j3 = this.handleFastForwardMouseleave;
                break;
              case "fast-backward":
                const e28 = this.fastBackwardActive ? h$1R(d$1R, {
                  clsPrefix: n3
                }, {
                  default: () => this.rtlEnabled ? h$1R(n$13, null) : h$1R(n$12, null)
                }) : h$1R(d$1R, {
                  clsPrefix: n3
                }, {
                  default: () => h$1R(n$11, null)
                });
                x3 ? w3 = x3({
                  type: "fast-backward",
                  node: e28,
                  active: this.fastBackwardActive || this.showFastBackwardMenu
                }) : w3 = e28, A3 = this.handleFastBackwardMouseenter, j3 = this.handleFastBackwardMouseleave;
                break;
            }
            const T3 = h$1R("div", {
              key: te2,
              class: [`${n3}-pagination-item`, o3.active && `${n3}-pagination-item--active`, f3 !== "page" && (f3 === "fast-backward" && this.showFastBackwardMenu || f3 === "fast-forward" && this.showFastForwardMenu) && `${n3}-pagination-item--hover`, l3 && `${n3}-pagination-item--disabled`, f3 === "page" && `${n3}-pagination-item--clickable`],
              onClick: () => {
                Y3(o3);
              },
              onMouseenter: A3,
              onMouseleave: j3
            }, w3);
            if (f3 === "page" && !o3.mayBeFastBackward && !o3.mayBeFastForward)
              return T3;
            {
              const z3 = o3.type === "page" ? o3.mayBeFastBackward ? "fast-backward" : "fast-forward" : o3.type;
              return o3.type !== "page" && !o3.options ? T3 : h$1R(E$w, {
                to: this.to,
                key: z3,
                disabled: l3,
                trigger: "hover",
                virtualScroll: true,
                style: {
                  width: "60px"
                },
                theme: m3.peers.Popselect,
                themeOverrides: m3.peerOverrides.Popselect,
                builtinThemeOverrides: {
                  peers: {
                    InternalSelectMenu: {
                      height: "calc(var(--n-option-height) * 4.6)"
                    }
                  }
                },
                nodeProps: () => ({
                  style: {
                    justifyContent: "center"
                  }
                }),
                show: f3 === "page" ? false : f3 === "fast-backward" ? this.showFastBackwardMenu : this.showFastForwardMenu,
                onUpdateShow: (s3) => {
                  f3 !== "page" && (s3 ? f3 === "fast-backward" ? this.showFastBackwardMenu = s3 : this.showFastForwardMenu = s3 : (this.showFastBackwardMenu = false, this.showFastForwardMenu = false));
                },
                options: o3.type !== "page" && o3.options ? o3.options : [],
                onUpdateValue: this.handleMenuSelect,
                scrollable: true,
                showCheckmark: false
              }, {
                default: () => T3
              });
            }
          }), h$1R("div", {
            class: [`${n3}-pagination-item`, !O3 && `${n3}-pagination-item--button`, {
              [`${n3}-pagination-item--disabled`]: g3 < 1 || g3 >= h3 || l3
            }],
            onClick: Z3
          }, O3 ? O3({
            page: g3,
            pageSize: u3,
            pageCount: h3,
            itemCount: this.mergedItemCount,
            startIndex: this.startIndex,
            endIndex: this.endIndex
          }) : h$1R(d$1R, {
            clsPrefix: n3
          }, {
            default: () => this.rtlEnabled ? h$1R(o$15, null) : h$1R(n$14, null)
          })));
        case "size-picker":
          return !S3 && $3 ? h$1R(zt$3, Object.assign({
            consistentMenuWidth: false,
            placeholder: "",
            showCheckmark: false,
            to: this.to
          }, this.selectProps, {
            size: b3,
            options: I3,
            value: u3,
            disabled: l3,
            theme: m3.peers.Select,
            themeOverrides: m3.peerOverrides.Select,
            onUpdateValue: G3
          })) : null;
        case "quick-jumper":
          return !S3 && V10 ? h$1R("div", {
            class: `${n3}-pagination-quick-jumper`
          }, J3 ? J3() : p$3H(this.$slots.goto, () => [d3.goto]), h$1R(Zn$3, {
            value: P3,
            onUpdateValue: C3,
            size: v3,
            placeholder: "",
            disabled: l3,
            theme: m3.peers.Input,
            themeOverrides: m3.peerOverrides.Input,
            onChange: H3
          })) : null;
        default:
          return null;
      }
    }), k3 ? h$1R("div", {
      class: `${n3}-pagination-suffix`
    }, k3({
      page: g3,
      pageSize: u3,
      pageCount: h3,
      startIndex: this.startIndex,
      endIndex: this.endIndex,
      itemCount: this.mergedItemCount
    })) : null);
  }
});
const S$z = defineComponent({
  name: "UIPagination",
  inheritAttrs: false
}), y$R = defineComponent(__spreadProps(__spreadValues({}, S$z), {
  props: {
    pageCount: {
      type: Number,
      default: 10
    },
    page: {
      type: Number
    },
    id: {
      type: String,
      required: true
    },
    pageSize: {
      type: Number,
      default: void 0
    },
    pageSlot: {
      type: Number,
      default: 9
    },
    showSizePicker: {
      type: Boolean,
      default: false
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40]
    }
  },
  emits: ["update:page", "update:page-size"],
  setup(e28, { emit: l3 }) {
    const p3 = l3, n3 = s$1v("Pagination");
    return (x3, a3) => (openBlock(), createBlock(unref(Dt$5), {
      "page-size": e28.pageSize,
      "page-sizes": e28.pageSizes,
      "show-size-picker": e28.showSizePicker,
      "page-count": e28.pageCount,
      page: e28.page,
      "page-slot": e28.pageSlot,
      "onUpdate:page": a3[0] || (a3[0] = (o3) => p3("update:page", o3)),
      "onUpdate:pageSize": a3[1] || (a3[1] = (o3) => p3("update:page-size", o3))
    }, {
      prev: withCtx(() => [
        createVNode(unref(q$C), {
          id: `${e28.id}-previous`,
          size: "small"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(n3).previous), 1)
          ]),
          _: 1
        }, 8, ["id"])
      ]),
      next: withCtx(() => [
        createVNode(unref(q$C), {
          id: `${e28.id}-next`,
          size: "small"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(n3).next), 1)
          ]),
          _: 1
        }, 8, ["id"])
      ]),
      _: 1
    }, 8, ["page-size", "page-sizes", "show-size-picker", "page-count", "page", "page-slot"]));
  }
})), v$N = y$R;
class t$13 {
  constructor(e28) {
    this._canceled = false, this.data = e28;
  }
  get type() {
    return this.constructor.type;
  }
  get cancelable() {
    return this.constructor.cancelable;
  }
  cancel() {
    this._canceled = true;
  }
  canceled() {
    return this._canceled;
  }
  clone(e28) {
    return new this.constructor(__spreadValues(__spreadValues({}, this.data), e28));
  }
}
t$13.type = "event";
t$13.cancelable = false;
class e$1b extends t$13 {
  get originalEvent() {
    return this.data.originalEvent;
  }
  get clientX() {
    return this.data.clientX;
  }
  get clientY() {
    return this.data.clientY;
  }
  get target() {
    return this.data.target;
  }
  get container() {
    return this.data.container;
  }
  get originalSource() {
    return this.data.originalSource;
  }
  get pressure() {
    return this.data.pressure;
  }
}
class a$1A extends e$1b {
}
a$1A.type = "drag:start";
class s$1s extends e$1b {
}
s$1s.type = "drag:move";
class n$10 extends e$1b {
}
n$10.type = "drag:stop";
class i$1e extends e$1b {
}
i$1e.type = "drag:pressure";
function u$1j(e28, t3) {
  if (e28 == null)
    return null;
  function i(o3) {
    return o3 == null || t3 == null ? false : l$1j(t3) ? Element.prototype.matches.call(o3, t3) : r$1n(t3) ? [...t3].includes(o3) : s$1r(t3) ? t3 === o3 : f$$(t3) ? t3(o3) : false;
  }
  let n3 = e28;
  do {
    if (n3 = n3.correspondingUseElement || n3.correspondingElement || n3, i(n3))
      return n3;
    n3 = (n3 == null ? void 0 : n3.parentNode) || null;
  } while (n3 != null && n3 !== document.body && n3 !== document);
  return null;
}
function l$1j(e28) {
  return typeof e28 == "string";
}
function r$1n(e28) {
  return e28 instanceof NodeList || e28 instanceof Array;
}
function s$1r(e28) {
  return e28 instanceof Node;
}
function f$$(e28) {
  return typeof e28 == "function";
}
function r$1m(t3, a3, e28, n3) {
  return Math.sqrt((e28 - t3) ** 2 + (n3 - a3) ** 2);
}
function e$1a(c3) {
  const {
    touches: o3,
    changedTouches: t3
  } = c3;
  return o3 && o3[0] || t3 && t3[0];
}
const r$1l = {
  mouse: 0,
  drag: 0,
  touch: 100
};
class c$1t {
  constructor(e28 = [], t3 = {}) {
    this.containers = [...e28], this.options = __spreadValues({}, t3), this.dragging = false, this.currentContainer = null, this.originalSource = null, this.startEvent = null, this.delay = a$1z(t3.delay);
  }
  attach() {
    return this;
  }
  detach() {
    return this;
  }
  addContainer(...e28) {
    this.containers = [...this.containers, ...e28];
  }
  removeContainer(...e28) {
    this.containers = this.containers.filter((t3) => !e28.includes(t3));
  }
  trigger(e28, t3) {
    const i = document.createEvent("Event");
    return i.detail = t3, i.initEvent(t3.type, true, true), e28.dispatchEvent(i), this.lastEvent = t3, t3;
  }
}
function a$1z(n3) {
  const e28 = {};
  if (n3 === void 0)
    return __spreadValues({}, r$1l);
  if (typeof n3 == "number") {
    for (const t3 in r$1l)
      Object.prototype.hasOwnProperty.call(r$1l, t3) && (e28[t3] = n3);
    return e28;
  }
  for (const t3 in r$1l)
    Object.prototype.hasOwnProperty.call(r$1l, t3) && (n3[t3] === void 0 ? e28[t3] = r$1l[t3] : e28[t3] = n3[t3]);
  return e28;
}
const u$1i = Symbol("onTouchStart"), r$1k = Symbol("onTouchEnd"), g$_ = Symbol("onTouchMove"), l$1i = Symbol("startDrag"), s$1q = Symbol("onDistanceChange");
let d$1i = false;
window.addEventListener("touchmove", (c3) => {
  d$1i && c3.preventDefault();
}, {
  passive: false
});
class y$Q extends c$1t {
  constructor(t3 = [], e28 = {}) {
    super(t3, e28), this.currentScrollableParent = null, this.tapTimeout = null, this.touchMoved = false, this.pageX = null, this.pageY = null, this[u$1i] = this[u$1i].bind(this), this[r$1k] = this[r$1k].bind(this), this[g$_] = this[g$_].bind(this), this[l$1i] = this[l$1i].bind(this), this[s$1q] = this[s$1q].bind(this);
  }
  attach() {
    document.addEventListener("touchstart", this[u$1i]);
  }
  detach() {
    document.removeEventListener("touchstart", this[u$1i]);
  }
  [u$1i](t3) {
    const e28 = u$1j(t3.target, this.containers);
    if (!e28 || this.options.handle && t3.target && !u$1j(t3.target, this.options.handle))
      return;
    const n3 = u$1j(t3.target, this.options.draggable);
    if (!n3)
      return;
    const {
      distance: i = 0
    } = this.options, {
      delay: o3
    } = this, {
      pageX: h3,
      pageY: m3
    } = e$1a(t3);
    Object.assign(this, {
      pageX: h3,
      pageY: m3
    }), this.onTouchStartAt = Date.now(), this.startEvent = t3, this.currentContainer = e28, this.originalSource = n3, document.addEventListener("touchend", this[r$1k]), document.addEventListener("touchcancel", this[r$1k]), document.addEventListener("touchmove", this[s$1q]), e28.addEventListener("contextmenu", p$3b), i && (d$1i = true), this.tapTimeout = window.setTimeout(() => {
      this[s$1q]({
        touches: [{
          pageX: this.pageX,
          pageY: this.pageY
        }]
      });
    }, o3.touch);
  }
  [l$1i]() {
    const t3 = this.startEvent, e28 = this.currentContainer, n3 = e$1a(t3), i = this.originalSource, o3 = new a$1A({
      clientX: n3.pageX,
      clientY: n3.pageY,
      target: t3.target,
      container: e28,
      originalSource: i,
      originalEvent: t3
    });
    this.trigger(this.currentContainer, o3), this.dragging = !o3.canceled(), this.dragging && document.addEventListener("touchmove", this[g$_]), d$1i = this.dragging;
  }
  [s$1q](t3) {
    const {
      distance: e28
    } = this.options, {
      startEvent: n3,
      delay: i
    } = this, o3 = e$1a(n3), h3 = e$1a(t3), m3 = Date.now() - this.onTouchStartAt, E3 = r$1m(o3.pageX, o3.pageY, h3.pageX, h3.pageY);
    Object.assign(this, h3), clearTimeout(this.tapTimeout), m3 < i.touch ? document.removeEventListener("touchmove", this[s$1q]) : E3 >= e28 && (document.removeEventListener("touchmove", this[s$1q]), this[l$1i]());
  }
  [g$_](t3) {
    if (!this.dragging)
      return;
    const {
      pageX: e28,
      pageY: n3
    } = e$1a(t3), i = document.elementFromPoint(e28 - window.scrollX, n3 - window.scrollY), o3 = new s$1s({
      clientX: e28,
      clientY: n3,
      target: i,
      container: this.currentContainer,
      originalEvent: t3
    });
    this.trigger(this.currentContainer, o3);
  }
  [r$1k](t3) {
    if (clearTimeout(this.tapTimeout), d$1i = false, document.removeEventListener("touchend", this[r$1k]), document.removeEventListener("touchcancel", this[r$1k]), document.removeEventListener("touchmove", this[s$1q]), this.currentContainer && this.currentContainer.removeEventListener("contextmenu", p$3b), !this.dragging)
      return;
    document.removeEventListener("touchmove", this[g$_]);
    const {
      pageX: e28,
      pageY: n3
    } = e$1a(t3), i = document.elementFromPoint(e28 - window.scrollX, n3 - window.scrollY);
    t3.preventDefault();
    const o3 = new n$10({
      clientX: e28,
      clientY: n3,
      target: i,
      container: this.currentContainer,
      originalEvent: t3
    });
    this.trigger(this.currentContainer, o3), this.currentContainer = null, this.dragging = false, this.startEvent = null;
  }
}
function p$3b(c3) {
  c3.preventDefault(), c3.stopPropagation();
}
class e$19 {
  constructor(t3) {
    this.draggable = t3;
  }
  attach() {
    throw new Error("Not Implemented");
  }
  detach() {
    throw new Error("Not Implemented");
  }
}
class t$12 extends t$13 {
  constructor(n3) {
    super(n3), this.data = n3;
  }
  get source() {
    return this.data.source;
  }
  get originalSource() {
    return this.data.originalSource;
  }
  get mirror() {
    return this.data.mirror;
  }
  get sourceContainer() {
    return this.data.sourceContainer;
  }
  get sensorEvent() {
    return this.data.sensorEvent;
  }
  get originalEvent() {
    return this.sensorEvent ? this.sensorEvent.originalEvent : null;
  }
}
t$12.type = "drag";
class a$1y extends t$12 {
}
a$1y.type = "drag:start";
a$1y.cancelable = true;
class i$1d extends t$12 {
}
i$1d.type = "drag:move";
class r$1j extends t$12 {
  get overContainer() {
    return this.data.overContainer;
  }
  get over() {
    return this.data.over;
  }
}
r$1j.type = "drag:over";
r$1j.cancelable = true;
class g$Z extends t$12 {
  get overContainer() {
    return this.data.overContainer;
  }
  get over() {
    return this.data.over;
  }
}
g$Z.type = "drag:out";
class v$M extends t$12 {
  get overContainer() {
    return this.data.overContainer;
  }
}
v$M.type = "drag:over:container";
class u$1h extends t$12 {
  get overContainer() {
    return this.data.overContainer;
  }
}
u$1h.type = "drag:out:container";
class d$1h extends t$12 {
  get pressure() {
    return this.data.pressure;
  }
}
d$1h.type = "drag:pressure";
class s$1p extends t$12 {
}
s$1p.type = "drag:stop";
s$1p.cancelable = true;
class c$1s extends t$12 {
}
c$1s.type = "drag:stopped";
const n$$ = Symbol("onInitialize"), o$14 = Symbol("onDestroy"), a$1x = Symbol("announceEvent"), s$1o = Symbol("announceMessage"), l$1h = "aria-relevant", d$1g = "aria-atomic", c$1r = "aria-live", h$1f = "role", u$1g = {
  expire: 7e3
};
class y$P extends e$19 {
  constructor(e28) {
    super(e28), this.options = __spreadValues(__spreadValues({}, u$1g), this.getOptions()), this.originalTriggerMethod = this.draggable.trigger, this[n$$] = this[n$$].bind(this), this[o$14] = this[o$14].bind(this);
  }
  attach() {
    this.draggable.on("draggable:initialize", this[n$$]);
  }
  detach() {
    this.draggable.off("draggable:destroy", this[o$14]);
  }
  getOptions() {
    return this.draggable.options.announcements || {};
  }
  [a$1x](e28) {
    const i = this.options[e28.type];
    i && typeof i == "string" && this[s$1o](i), i && typeof i == "function" && this[s$1o](i(e28));
  }
  [s$1o](e28) {
    p$3a(e28, {
      expire: this.options.expire
    });
  }
  [n$$]() {
    this.draggable.trigger = (e28) => {
      try {
        this[a$1x](e28);
      } finally {
        this.originalTriggerMethod.call(this.draggable, e28);
      }
    };
  }
  [o$14]() {
    this.draggable.trigger = this.originalTriggerMethod;
  }
}
const r$1i = b$Q();
function p$3a(t3, {
  expire: e28
}) {
  const i = document.createElement("div");
  return i.textContent = t3, r$1i.appendChild(i), setTimeout(() => {
    r$1i.removeChild(i);
  }, e28);
}
function b$Q() {
  const t3 = document.createElement("div");
  return t3.setAttribute("id", "draggable-live-region"), t3.setAttribute(l$1h, "additions"), t3.setAttribute(d$1g, "true"), t3.setAttribute(c$1r, "assertive"), t3.setAttribute(h$1f, "log"), t3.style.position = "fixed", t3.style.width = "1px", t3.style.height = "1px", t3.style.top = "-1px", t3.style.overflow = "hidden", t3;
}
document.addEventListener("DOMContentLoaded", () => {
  document.body.appendChild(r$1i);
});
const e$18 = Symbol("onInitialize"), s$1n = Symbol("onDestroy"), o$13 = {};
class l$1g extends e$19 {
  constructor(t3) {
    super(t3), this.options = __spreadValues(__spreadValues({}, o$13), this.getOptions()), this[e$18] = this[e$18].bind(this), this[s$1n] = this[s$1n].bind(this);
  }
  attach() {
    this.draggable.on("draggable:initialize", this[e$18]).on("draggable:destroy", this[s$1n]);
  }
  detach() {
    this.draggable.off("draggable:initialize", this[e$18]).off("draggable:destroy", this[s$1n]), this[s$1n]();
  }
  getOptions() {
    return this.draggable.options.focusable || {};
  }
  getElements() {
    return [...this.draggable.containers, ...this.draggable.getDraggableElements()];
  }
  [e$18]() {
    requestAnimationFrame(() => {
      this.getElements().forEach((t3) => r$1h(t3));
    });
  }
  [s$1n]() {
    requestAnimationFrame(() => {
      this.getElements().forEach((t3) => g$Y(t3));
    });
  }
}
const n$_ = [];
function r$1h(i) {
  !i.getAttribute("tabindex") && i.tabIndex === -1 && (n$_.push(i), i.tabIndex = 0);
}
function g$Y(i) {
  const t3 = n$_.indexOf(i);
  t3 !== -1 && (i.tabIndex = -1, n$_.splice(t3, 1));
}
class e$17 extends t$13 {
  constructor(t3) {
    super(t3), this.data = t3;
  }
  get source() {
    return this.data.source;
  }
  get originalSource() {
    return this.data.originalSource;
  }
  get sourceContainer() {
    return this.data.sourceContainer;
  }
  get sensorEvent() {
    return this.data.sensorEvent;
  }
  get dragEvent() {
    return this.data.dragEvent;
  }
  get originalEvent() {
    return this.sensorEvent ? this.sensorEvent.originalEvent : null;
  }
}
class i$1c extends e$17 {
}
i$1c.type = "mirror:create";
class o$12 extends e$17 {
  get mirror() {
    return this.data.mirror;
  }
}
o$12.type = "mirror:created";
class d$1f extends e$17 {
  get mirror() {
    return this.data.mirror;
  }
}
d$1f.type = "mirror:attached";
class s$1m extends e$17 {
  get mirror() {
    return this.data.mirror;
  }
  get passedThreshX() {
    return this.data.passedThreshX;
  }
  get passedThreshY() {
    return this.data.passedThreshY;
  }
}
s$1m.type = "mirror:move";
s$1m.cancelable = true;
class h$1e extends e$17 {
  get mirror() {
    return this.data.mirror;
  }
  get passedThreshX() {
    return this.data.passedThreshX;
  }
  get passedThreshY() {
    return this.data.passedThreshY;
  }
}
h$1e.type = "mirror:moved";
class a$1w extends e$17 {
  get mirror() {
    return this.data.mirror;
  }
}
a$1w.type = "mirror:destroy";
a$1w.cancelable = true;
const u$1f = Symbol("onDragStart"), g$X = Symbol("onDragMove"), p$39 = Symbol("onDragStop"), M$n = Symbol("onMirrorCreated"), y$O = Symbol("onMirrorMove"), m$1x = Symbol("onScroll"), S$y = Symbol("getAppendableContainer"), L$x = {
  constrainDimensions: false,
  xAxis: true,
  yAxis: true,
  cursorOffsetX: null,
  cursorOffsetY: null,
  thresholdX: null,
  thresholdY: null
};
class z$n extends e$19 {
  constructor(t3) {
    super(t3), this.options = __spreadValues(__spreadValues({}, L$x), this.getOptions()), this.scrollOffset = {
      x: 0,
      y: 0
    }, this.initialScrollOffset = {
      x: window.scrollX,
      y: window.scrollY
    }, this[u$1f] = this[u$1f].bind(this), this[g$X] = this[g$X].bind(this), this[p$39] = this[p$39].bind(this), this[M$n] = this[M$n].bind(this), this[y$O] = this[y$O].bind(this), this[m$1x] = this[m$1x].bind(this);
  }
  attach() {
    this.draggable.on("drag:start", this[u$1f]).on("drag:move", this[g$X]).on("drag:stop", this[p$39]).on("mirror:created", this[M$n]).on("mirror:move", this[y$O]);
  }
  detach() {
    this.draggable.off("drag:start", this[u$1f]).off("drag:move", this[g$X]).off("drag:stop", this[p$39]).off("mirror:created", this[M$n]).off("mirror:move", this[y$O]);
  }
  getOptions() {
    return this.draggable.options.mirror || {};
  }
  [u$1f](t3) {
    if (t3.canceled())
      return;
    "ontouchstart" in window && document.addEventListener("scroll", this[m$1x], true), this.initialScrollOffset = {
      x: window.scrollX,
      y: window.scrollY
    };
    const {
      source: e28,
      originalSource: i,
      sourceContainer: o3,
      sensorEvent: r3
    } = t3;
    this.lastMirrorMovedClient = {
      x: r3.clientX,
      y: r3.clientY
    };
    const n3 = new i$1c({
      source: e28,
      originalSource: i,
      sourceContainer: o3,
      sensorEvent: r3,
      dragEvent: t3
    });
    if (this.draggable.trigger(n3), B$y(r3) || n3.canceled())
      return;
    const a3 = this[S$y](e28) || o3;
    this.mirror = e28.cloneNode(true);
    const l3 = new o$12({
      source: e28,
      originalSource: i,
      sourceContainer: o3,
      sensorEvent: r3,
      dragEvent: t3,
      mirror: this.mirror
    }), h3 = new d$1f({
      source: e28,
      originalSource: i,
      sourceContainer: o3,
      sensorEvent: r3,
      dragEvent: t3,
      mirror: this.mirror
    });
    this.draggable.trigger(l3), a3.appendChild(this.mirror), this.draggable.trigger(h3);
  }
  [g$X](t3) {
    if (!this.mirror || t3.canceled())
      return;
    const {
      source: e28,
      originalSource: i,
      sourceContainer: o3,
      sensorEvent: r3
    } = t3;
    let n3 = true, a3 = true;
    if (this.options.thresholdX || this.options.thresholdY) {
      const {
        x: h3,
        y: d3
      } = this.lastMirrorMovedClient;
      if (Math.abs(h3 - r3.clientX) < this.options.thresholdX ? n3 = false : this.lastMirrorMovedClient.x = r3.clientX, Math.abs(d3 - r3.clientY) < this.options.thresholdY ? a3 = false : this.lastMirrorMovedClient.y = r3.clientY, !n3 && !a3)
        return;
    }
    const l3 = new s$1m({
      source: e28,
      originalSource: i,
      sourceContainer: o3,
      sensorEvent: r3,
      dragEvent: t3,
      mirror: this.mirror,
      passedThreshX: n3,
      passedThreshY: a3
    });
    this.draggable.trigger(l3);
  }
  [p$39](t3) {
    if ("ontouchstart" in window && document.removeEventListener("scroll", this[m$1x], true), this.initialScrollOffset = {
      x: 0,
      y: 0
    }, this.scrollOffset = {
      x: 0,
      y: 0
    }, !this.mirror)
      return;
    const {
      source: e28,
      sourceContainer: i,
      sensorEvent: o3
    } = t3, r3 = new a$1w({
      source: e28,
      mirror: this.mirror,
      sourceContainer: i,
      sensorEvent: o3,
      dragEvent: t3
    });
    this.draggable.trigger(r3), r3.canceled() || this.mirror.remove();
  }
  [m$1x]() {
    this.scrollOffset = {
      x: window.scrollX - this.initialScrollOffset.x,
      y: window.scrollY - this.initialScrollOffset.y
    };
  }
  [M$n]({
    mirror: t3,
    source: e28,
    sensorEvent: i
  }) {
    const o3 = this.draggable.getClassNamesFor("mirror"), r3 = (_a2) => {
      var _b2 = _a2, {
        mirrorOffset: a3,
        initialX: l3,
        initialY: h3
      } = _b2, d3 = __objRest(_b2, [
        "mirrorOffset",
        "initialX",
        "initialY"
      ]);
      return this.mirrorOffset = a3, this.initialX = l3, this.initialY = h3, this.lastMovedX = l3, this.lastMovedY = h3, __spreadValues({
        mirrorOffset: a3,
        initialX: l3,
        initialY: h3
      }, d3);
    };
    t3.style.display = "none";
    const n3 = {
      mirror: t3,
      source: e28,
      sensorEvent: i,
      mirrorClasses: o3,
      scrollOffset: this.scrollOffset,
      options: this.options,
      passedThreshX: true,
      passedThreshY: true
    };
    return Promise.resolve(n3).then(N$A).then(q$r).then(F$r).then(H$m).then(b$P({
      initial: true
    })).then(V$o).then(r3);
  }
  [y$O](t3) {
    if (t3.canceled())
      return null;
    const e28 = (_a2) => {
      var _b2 = _a2, {
        lastMovedX: r3,
        lastMovedY: n3
      } = _b2, a3 = __objRest(_b2, [
        "lastMovedX",
        "lastMovedY"
      ]);
      return this.lastMovedX = r3, this.lastMovedY = n3, __spreadValues({
        lastMovedX: r3,
        lastMovedY: n3
      }, a3);
    }, i = (r3) => {
      const n3 = new h$1e({
        source: t3.source,
        originalSource: t3.originalSource,
        sourceContainer: t3.sourceContainer,
        sensorEvent: t3.sensorEvent,
        dragEvent: t3.dragEvent,
        mirror: this.mirror,
        passedThreshX: t3.passedThreshX,
        passedThreshY: t3.passedThreshY
      });
      return this.draggable.trigger(n3), r3;
    }, o3 = {
      mirror: t3.mirror,
      sensorEvent: t3.sensorEvent,
      mirrorOffset: this.mirrorOffset,
      options: this.options,
      initialX: this.initialX,
      initialY: this.initialY,
      scrollOffset: this.scrollOffset,
      passedThreshX: t3.passedThreshX,
      passedThreshY: t3.passedThreshY,
      lastMovedX: this.lastMovedX,
      lastMovedY: this.lastMovedY
    };
    return Promise.resolve(o3).then(b$P({
      raf: true
    })).then(e28).then(i);
  }
  [S$y](t3) {
    const e28 = this.options.appendTo;
    return typeof e28 == "string" ? document.querySelector(e28) : e28 instanceof HTMLElement ? e28 : typeof e28 == "function" ? e28(t3) : t3.parentNode;
  }
}
function N$A(_a2) {
  var _b2 = _a2, {
    source: s3
  } = _b2, t3 = __objRest(_b2, [
    "source"
  ]);
  return c$1q((e28) => {
    const i = s3.getBoundingClientRect();
    e28(__spreadValues({
      source: s3,
      sourceRect: i
    }, t3));
  });
}
function q$r(_c2) {
  var _d2 = _c2, {
    sensorEvent: s3,
    sourceRect: t3,
    options: e28
  } = _d2, i = __objRest(_d2, [
    "sensorEvent",
    "sourceRect",
    "options"
  ]);
  return c$1q((o3) => {
    const r3 = e28.cursorOffsetY === null ? s3.clientY - t3.top : e28.cursorOffsetY, n3 = e28.cursorOffsetX === null ? s3.clientX - t3.left : e28.cursorOffsetX;
    o3(__spreadValues({
      sensorEvent: s3,
      sourceRect: t3,
      mirrorOffset: {
        top: r3,
        left: n3
      },
      options: e28
    }, i));
  });
}
function F$r(_e2) {
  var _f = _e2, {
    mirror: s3,
    source: t3,
    options: e28
  } = _f, i = __objRest(_f, [
    "mirror",
    "source",
    "options"
  ]);
  return c$1q((o3) => {
    let r3, n3;
    if (e28.constrainDimensions) {
      const a3 = getComputedStyle(t3);
      r3 = a3.getPropertyValue("height"), n3 = a3.getPropertyValue("width");
    }
    s3.style.display = null, s3.style.position = "fixed", s3.style.pointerEvents = "none", s3.style.top = 0, s3.style.left = 0, s3.style.margin = 0, e28.constrainDimensions && (s3.style.height = r3, s3.style.width = n3), o3(__spreadValues({
      mirror: s3,
      source: t3,
      options: e28
    }, i));
  });
}
function H$m(_g) {
  var _h = _g, {
    mirror: s3,
    mirrorClasses: t3
  } = _h, e28 = __objRest(_h, [
    "mirror",
    "mirrorClasses"
  ]);
  return c$1q((i) => {
    s3.classList.add(...t3), i(__spreadValues({
      mirror: s3,
      mirrorClasses: t3
    }, e28));
  });
}
function V$o(_i2) {
  var _j2 = _i2, {
    mirror: s3
  } = _j2, t3 = __objRest(_j2, [
    "mirror"
  ]);
  return c$1q((e28) => {
    s3.removeAttribute("id"), delete s3.id, e28(__spreadValues({
      mirror: s3
    }, t3));
  });
}
function b$P({
  withFrame: s3 = false,
  initial: t3 = false
} = {}) {
  return (_a2) => {
    var _b2 = _a2, {
      mirror: e28,
      sensorEvent: i,
      mirrorOffset: o3,
      initialY: r3,
      initialX: n3,
      scrollOffset: a3,
      options: l3,
      passedThreshX: h3,
      passedThreshY: d3,
      lastMovedX: X3,
      lastMovedY: Y3
    } = _b2, w3 = __objRest(_b2, [
      "mirror",
      "sensorEvent",
      "mirrorOffset",
      "initialY",
      "initialX",
      "scrollOffset",
      "options",
      "passedThreshX",
      "passedThreshY",
      "lastMovedX",
      "lastMovedY"
    ]);
    return c$1q((C3) => {
      const f3 = __spreadValues({
        mirror: e28,
        sensorEvent: i,
        mirrorOffset: o3,
        options: l3
      }, w3);
      if (o3) {
        const v3 = h3 ? Math.round((i.clientX - o3.left - a3.x) / (l3.thresholdX || 1)) * (l3.thresholdX || 1) : Math.round(X3), x3 = d3 ? Math.round((i.clientY - o3.top - a3.y) / (l3.thresholdY || 1)) * (l3.thresholdY || 1) : Math.round(Y3);
        l3.xAxis && l3.yAxis || t3 ? e28.style.transform = `translate3d(${v3}px, ${x3}px, 0)` : l3.xAxis && !l3.yAxis ? e28.style.transform = `translate3d(${v3}px, ${r3}px, 0)` : l3.yAxis && !l3.xAxis && (e28.style.transform = `translate3d(${n3}px, ${x3}px, 0)`), t3 && (f3.initialX = v3, f3.initialY = x3), f3.lastMovedX = v3, f3.lastMovedY = x3;
      }
      C3(f3);
    }, {
      frame: s3
    });
  };
}
function c$1q(s3, {
  raf: t3 = false
} = {}) {
  return new Promise((e28, i) => {
    t3 ? requestAnimationFrame(() => {
      s3(e28, i);
    }) : s3(e28, i);
  });
}
function B$y(s3) {
  return /^drag/.test(s3.originalEvent.type);
}
const s$1l = Symbol("onDragStart"), i$1b = Symbol("onDragMove"), r$1g = Symbol("onDragStop"), c$1p = Symbol("scroll"), S$x = {
  speed: 6,
  sensitivity: 50,
  scrollableElements: []
};
class O$v extends e$19 {
  constructor(t3) {
    super(t3), this.options = __spreadValues(__spreadValues({}, S$x), this.getOptions()), this.currentMousePosition = null, this.scrollAnimationFrame = null, this.scrollableElement = null, this.findScrollableElementFrame = null, this[s$1l] = this[s$1l].bind(this), this[i$1b] = this[i$1b].bind(this), this[r$1g] = this[r$1g].bind(this), this[c$1p] = this[c$1p].bind(this);
  }
  attach() {
    this.draggable.on("drag:start", this[s$1l]).on("drag:move", this[i$1b]).on("drag:stop", this[r$1g]);
  }
  detach() {
    this.draggable.off("drag:start", this[s$1l]).off("drag:move", this[i$1b]).off("drag:stop", this[r$1g]);
  }
  getOptions() {
    return this.draggable.options.scrollable || {};
  }
  getScrollableElement(t3) {
    return this.hasDefinedScrollableElements() ? u$1j(t3, this.options.scrollableElements) || document.documentElement : w$B(t3);
  }
  hasDefinedScrollableElements() {
    return this.options.scrollableElements.length !== 0;
  }
  [s$1l](t3) {
    this.findScrollableElementFrame = requestAnimationFrame(() => {
      this.scrollableElement = this.getScrollableElement(t3.source);
    });
  }
  [i$1b](t3) {
    if (this.findScrollableElementFrame = requestAnimationFrame(() => {
      this.scrollableElement = this.getScrollableElement(t3.sensorEvent.target);
    }), !this.scrollableElement)
      return;
    const e28 = t3.sensorEvent, o3 = {
      x: 0,
      y: 0
    };
    "ontouchstart" in window && (o3.y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0, o3.x = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0), this.currentMousePosition = {
      clientX: e28.clientX - o3.x,
      clientY: e28.clientY - o3.y
    }, this.scrollAnimationFrame = requestAnimationFrame(this[c$1p]);
  }
  [r$1g]() {
    cancelAnimationFrame(this.scrollAnimationFrame), cancelAnimationFrame(this.findScrollableElementFrame), this.scrollableElement = null, this.scrollAnimationFrame = null, this.findScrollableElementFrame = null, this.currentMousePosition = null;
  }
  [c$1p]() {
    if (!this.scrollableElement || !this.currentMousePosition)
      return;
    cancelAnimationFrame(this.scrollAnimationFrame);
    const {
      speed: t3,
      sensitivity: e28
    } = this.options, o3 = this.scrollableElement.getBoundingClientRect(), a3 = o3.bottom > window.innerHeight, p3 = o3.top < 0 || a3, m3 = b$O(), n3 = this.scrollableElement, u3 = this.currentMousePosition.clientX, f3 = this.currentMousePosition.clientY;
    if (n3 !== document.body && n3 !== document.documentElement && !p3) {
      const {
        offsetHeight: h3,
        offsetWidth: d3
      } = n3;
      o3.top + h3 - f3 < e28 ? n3.scrollTop += t3 : f3 - o3.top < e28 && (n3.scrollTop -= t3), o3.left + d3 - u3 < e28 ? n3.scrollLeft += t3 : u3 - o3.left < e28 && (n3.scrollLeft -= t3);
    } else {
      const {
        innerHeight: h3,
        innerWidth: d3
      } = window;
      f3 < e28 ? m3.scrollTop -= t3 : h3 - f3 < e28 && (m3.scrollTop += t3), u3 < e28 ? m3.scrollLeft -= t3 : d3 - u3 < e28 && (m3.scrollLeft += t3);
    }
    this.scrollAnimationFrame = requestAnimationFrame(this[c$1p]);
  }
}
function y$N(l3) {
  const t3 = /(auto|scroll)/, e28 = getComputedStyle(l3, null), o3 = e28.getPropertyValue("overflow") + e28.getPropertyValue("overflow-y") + e28.getPropertyValue("overflow-x");
  return t3.test(o3);
}
function F$q(l3) {
  return getComputedStyle(l3).getPropertyValue("position") === "static";
}
function w$B(l3) {
  if (!l3)
    return b$O();
  const t3 = getComputedStyle(l3).getPropertyValue("position"), e28 = t3 === "absolute", o3 = u$1j(l3, (a3) => e28 && F$q(a3) ? false : y$N(a3));
  return t3 === "fixed" || !o3 ? b$O() : o3;
}
function b$O() {
  return document.scrollingElement || document.documentElement;
}
class h$1d {
  constructor() {
    this.callbacks = {};
  }
  on(l3, ...s3) {
    return this.callbacks[l3] || (this.callbacks[l3] = []), this.callbacks[l3].push(...s3), this;
  }
  off(l3, s3) {
    if (!this.callbacks[l3])
      return null;
    const r3 = this.callbacks[l3].slice(0);
    for (let c3 = 0; c3 < r3.length; c3++)
      s3 === r3[c3] && this.callbacks[l3].splice(c3, 1);
    return this;
  }
  trigger(l3) {
    if (!this.callbacks[l3.type])
      return null;
    const s3 = [...this.callbacks[l3.type]], r3 = [];
    for (let c3 = s3.length - 1; c3 >= 0; c3--) {
      const t3 = s3[c3];
      try {
        t3(l3);
      } catch (a3) {
        r3.push(a3);
      }
    }
    return r3.length && console.error(`Draggable caught errors while triggering '${l3.type}'`, r3), this;
  }
}
const s$1k = Symbol("onContextMenuWhileDragging"), r$1f = Symbol("onMouseDown"), a$1v = Symbol("onMouseMove"), c$1o = Symbol("onMouseUp"), h$1c = Symbol("startDrag"), i$1a = Symbol("onDistanceChange");
class Y$k extends c$1t {
  constructor(t3 = [], e28 = {}) {
    super(t3, e28), this.mouseDownTimeout = null, this.pageX = null, this.pageY = null, this[s$1k] = this[s$1k].bind(this), this[r$1f] = this[r$1f].bind(this), this[a$1v] = this[a$1v].bind(this), this[c$1o] = this[c$1o].bind(this), this[h$1c] = this[h$1c].bind(this), this[i$1a] = this[i$1a].bind(this);
  }
  attach() {
    document.addEventListener("mousedown", this[r$1f], true);
  }
  detach() {
    document.removeEventListener("mousedown", this[r$1f], true);
  }
  [r$1f](t3) {
    if (t3.button !== 0 || t3.ctrlKey || t3.metaKey)
      return;
    const e28 = u$1j(t3.target, this.containers);
    if (!e28 || this.options.handle && t3.target && !u$1j(t3.target, this.options.handle))
      return;
    const n3 = u$1j(t3.target, this.options.draggable);
    if (!n3)
      return;
    const {
      delay: o3
    } = this, {
      pageX: u3,
      pageY: m3
    } = t3;
    Object.assign(this, {
      pageX: u3,
      pageY: m3
    }), this.onMouseDownAt = Date.now(), this.startEvent = t3, this.currentContainer = e28, this.originalSource = n3, document.addEventListener("mouseup", this[c$1o]), document.addEventListener("dragstart", l$1f), document.addEventListener("mousemove", this[i$1a]), this.mouseDownTimeout = window.setTimeout(() => {
      this[i$1a]({
        pageX: this.pageX,
        pageY: this.pageY
      });
    }, o3.mouse);
  }
  [h$1c]() {
    const t3 = this.startEvent, e28 = this.currentContainer, n3 = this.originalSource, o3 = new a$1A({
      clientX: t3.clientX,
      clientY: t3.clientY,
      target: t3.target,
      container: e28,
      originalSource: n3,
      originalEvent: t3
    });
    this.trigger(this.currentContainer, o3), this.dragging = !o3.canceled(), this.dragging && (document.addEventListener("contextmenu", this[s$1k], true), document.addEventListener("mousemove", this[a$1v]));
  }
  [i$1a](t3) {
    const {
      pageX: e28,
      pageY: n3
    } = t3, {
      distance: o3
    } = this.options, {
      startEvent: u3,
      delay: m3
    } = this;
    if (Object.assign(this, {
      pageX: e28,
      pageY: n3
    }), !this.currentContainer)
      return;
    const v3 = Date.now() - this.onMouseDownAt, p3 = r$1m(u3.pageX, u3.pageY, e28, n3) || 0;
    clearTimeout(this.mouseDownTimeout), v3 < m3.mouse ? document.removeEventListener("mousemove", this[i$1a]) : p3 >= o3 && (document.removeEventListener("mousemove", this[i$1a]), this[h$1c]());
  }
  [a$1v](t3) {
    if (!this.dragging)
      return;
    const e28 = document.elementFromPoint(t3.clientX, t3.clientY), n3 = new s$1s({
      clientX: t3.clientX,
      clientY: t3.clientY,
      target: e28,
      container: this.currentContainer,
      originalEvent: t3
    });
    this.trigger(this.currentContainer, n3);
  }
  [c$1o](t3) {
    if (clearTimeout(this.mouseDownTimeout), t3.button !== 0 || (document.removeEventListener("mouseup", this[c$1o]), document.removeEventListener("dragstart", l$1f), document.removeEventListener("mousemove", this[i$1a]), !this.dragging))
      return;
    const e28 = document.elementFromPoint(t3.clientX, t3.clientY), n3 = new n$10({
      clientX: t3.clientX,
      clientY: t3.clientY,
      target: e28,
      container: this.currentContainer,
      originalEvent: t3
    });
    this.trigger(this.currentContainer, n3), document.removeEventListener("contextmenu", this[s$1k], true), document.removeEventListener("mousemove", this[a$1v]), this.currentContainer = null, this.dragging = false, this.startEvent = null;
  }
  [s$1k](t3) {
    t3.preventDefault();
  }
}
function l$1f(d3) {
  d3.preventDefault();
}
class e$16 extends t$13 {
  get draggable() {
    return this.data.draggable;
  }
}
e$16.type = "draggable";
class g$W extends e$16 {
}
g$W.type = "draggable:initialize";
class r$1e extends e$16 {
}
r$1e.type = "draggable:destroy";
const g$V = Symbol("onDragStart"), l$1e = Symbol("onDragMove"), u$1e = Symbol("onDragStop"), h$1b = Symbol("onDragPressure"), d$1e = Symbol("dragStop"), k$E = {
  "drag:start": (i) => `Picked up ${i.source.textContent.trim() || i.source.id || "draggable element"}`,
  "drag:stop": (i) => `Released ${i.source.textContent.trim() || i.source.id || "draggable element"}`
}, q$q = {
  "container:dragging": "draggable-container--is-dragging",
  "source:dragging": "draggable-source--is-dragging",
  "source:placed": "draggable-source--placed",
  "container:placed": "draggable-container--placed",
  "body:dragging": "draggable--is-dragging",
  "draggable:over": "draggable--over",
  "container:over": "draggable-container--over",
  "source:original": "draggable--original",
  mirror: "draggable-mirror"
}, $$k = {
  draggable: ".draggable-source",
  handle: null,
  delay: {},
  distance: 0,
  placedTimeout: 800,
  plugins: [],
  sensors: [],
  exclude: {
    plugins: [],
    sensors: []
  }
};
class m$1w {
  constructor(r3 = [document.body], e28 = {}) {
    if (r3 instanceof NodeList || r3 instanceof Array)
      this.containers = [...r3];
    else if (r3 instanceof HTMLElement)
      this.containers = [r3];
    else
      throw new Error("Draggable containers are expected to be of type `NodeList`, `HTMLElement[]` or `HTMLElement`");
    this.options = __spreadProps(__spreadValues(__spreadValues({}, $$k), e28), {
      classes: __spreadValues(__spreadValues({}, q$q), e28.classes || {}),
      announcements: __spreadValues(__spreadValues({}, k$E), e28.announcements || {}),
      exclude: {
        plugins: e28.exclude && e28.exclude.plugins || [],
        sensors: e28.exclude && e28.exclude.sensors || []
      }
    }), this.emitter = new h$1d(), this.dragging = false, this.plugins = [], this.sensors = [], this[g$V] = this[g$V].bind(this), this[l$1e] = this[l$1e].bind(this), this[u$1e] = this[u$1e].bind(this), this[h$1b] = this[h$1b].bind(this), this[d$1e] = this[d$1e].bind(this), document.addEventListener("drag:start", this[g$V], true), document.addEventListener("drag:move", this[l$1e], true), document.addEventListener("drag:stop", this[u$1e], true), document.addEventListener("drag:pressure", this[h$1b], true);
    const t3 = Object.values(m$1w.Plugins).filter((n3) => !this.options.exclude.plugins.includes(n3)), s3 = Object.values(m$1w.Sensors).filter((n3) => !this.options.exclude.sensors.includes(n3));
    this.addPlugin(...t3, ...this.options.plugins), this.addSensor(...s3, ...this.options.sensors);
    const c3 = new g$W({
      draggable: this
    });
    this.on("mirror:created", ({
      mirror: n3
    }) => this.mirror = n3), this.on("mirror:destroy", () => this.mirror = null), this.trigger(c3);
  }
  destroy() {
    document.removeEventListener("drag:start", this[g$V], true), document.removeEventListener("drag:move", this[l$1e], true), document.removeEventListener("drag:stop", this[u$1e], true), document.removeEventListener("drag:pressure", this[h$1b], true);
    const r3 = new r$1e({
      draggable: this
    });
    this.trigger(r3), this.removePlugin(...this.plugins.map((e28) => e28.constructor)), this.removeSensor(...this.sensors.map((e28) => e28.constructor));
  }
  addPlugin(...r3) {
    const e28 = r3.map((t3) => new t3(this));
    return e28.forEach((t3) => t3.attach()), this.plugins = [...this.plugins, ...e28], this;
  }
  removePlugin(...r3) {
    return this.plugins.filter((t3) => r3.includes(t3.constructor)).forEach((t3) => t3.detach()), this.plugins = this.plugins.filter((t3) => !r3.includes(t3.constructor)), this;
  }
  addSensor(...r3) {
    const e28 = r3.map((t3) => new t3(this.containers, this.options));
    return e28.forEach((t3) => t3.attach()), this.sensors = [...this.sensors, ...e28], this;
  }
  removeSensor(...r3) {
    return this.sensors.filter((t3) => r3.includes(t3.constructor)).forEach((t3) => t3.detach()), this.sensors = this.sensors.filter((t3) => !r3.includes(t3.constructor)), this;
  }
  addContainer(...r3) {
    return this.containers = [...this.containers, ...r3], this.sensors.forEach((e28) => e28.addContainer(...r3)), this;
  }
  removeContainer(...r3) {
    return this.containers = this.containers.filter((e28) => !r3.includes(e28)), this.sensors.forEach((e28) => e28.removeContainer(...r3)), this;
  }
  on(r3, ...e28) {
    return this.emitter.on(r3, ...e28), this;
  }
  off(r3, e28) {
    return this.emitter.off(r3, e28), this;
  }
  trigger(r3) {
    return this.emitter.trigger(r3), this;
  }
  getClassNameFor(r3) {
    return this.getClassNamesFor(r3)[0];
  }
  getClassNamesFor(r3) {
    const e28 = this.options.classes[r3];
    return e28 instanceof Array ? e28 : typeof e28 == "string" || e28 instanceof String ? [e28] : [];
  }
  isDragging() {
    return !!this.dragging;
  }
  getDraggableElements() {
    return this.containers.reduce((r3, e28) => [...r3, ...this.getDraggableElementsForContainer(e28)], []);
  }
  getDraggableElementsForContainer(r3) {
    return [...r3.querySelectorAll(this.options.draggable)].filter((t3) => t3 !== this.originalSource && t3 !== this.mirror);
  }
  cancel() {
    this[d$1e]();
  }
  [g$V](r3) {
    const e28 = S$w(r3), {
      target: t3,
      container: s3,
      originalSource: c3
    } = e28;
    if (!this.containers.includes(s3))
      return;
    if (this.options.handle && t3 && !u$1j(t3, this.options.handle)) {
      e28.cancel();
      return;
    }
    this.originalSource = c3, this.sourceContainer = s3, this.lastPlacedSource && this.lastPlacedContainer && (clearTimeout(this.placedTimeoutID), this.lastPlacedSource.classList.remove(...this.getClassNamesFor("source:placed")), this.lastPlacedContainer.classList.remove(...this.getClassNamesFor("container:placed"))), this.source = this.originalSource.cloneNode(true), this.originalSource.parentNode.insertBefore(this.source, this.originalSource), this.originalSource.style.display = "none";
    const n3 = new a$1y({
      source: this.source,
      originalSource: this.originalSource,
      sourceContainer: s3,
      sensorEvent: e28
    });
    if (this.trigger(n3), this.dragging = !n3.canceled(), n3.canceled()) {
      this.source.remove(), this.originalSource.style.display = null;
      return;
    }
    this.originalSource.classList.add(...this.getClassNamesFor("source:original")), this.source.classList.add(...this.getClassNamesFor("source:dragging")), this.sourceContainer.classList.add(...this.getClassNamesFor("container:dragging")), document.body.classList.add(...this.getClassNamesFor("body:dragging")), C$R(document.body, "none"), requestAnimationFrame(() => {
      const p3 = S$w(r3).clone({
        target: this.source
      });
      this[l$1e](__spreadProps(__spreadValues({}, r3), {
        detail: p3
      }));
    });
  }
  [l$1e](r3) {
    if (!this.dragging)
      return;
    const e28 = S$w(r3), {
      container: t3
    } = e28;
    let s3 = e28.target;
    const c3 = new i$1d({
      source: this.source,
      originalSource: this.originalSource,
      sourceContainer: t3,
      sensorEvent: e28
    });
    this.trigger(c3), c3.canceled() && e28.cancel(), s3 = u$1j(s3, this.options.draggable);
    const n3 = u$1j(e28.target, this.containers), o3 = e28.overContainer || n3, p3 = this.currentOverContainer && o3 !== this.currentOverContainer, f3 = this.currentOver && s3 !== this.currentOver, b3 = o3 && this.currentOverContainer !== o3, E3 = n3 && s3 && this.currentOver !== s3;
    if (f3) {
      const a3 = new g$Z({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: t3,
        sensorEvent: e28,
        over: this.currentOver,
        overContainer: this.currentOverContainer
      });
      this.currentOver.classList.remove(...this.getClassNamesFor("draggable:over")), this.currentOver = null, this.trigger(a3);
    }
    if (p3) {
      const a3 = new u$1h({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: t3,
        sensorEvent: e28,
        overContainer: this.currentOverContainer
      });
      this.currentOverContainer.classList.remove(...this.getClassNamesFor("container:over")), this.currentOverContainer = null, this.trigger(a3);
    }
    if (b3) {
      o3.classList.add(...this.getClassNamesFor("container:over"));
      const a3 = new v$M({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: t3,
        sensorEvent: e28,
        overContainer: o3
      });
      this.currentOverContainer = o3, this.trigger(a3);
    }
    if (E3) {
      s3.classList.add(...this.getClassNamesFor("draggable:over"));
      const a3 = new r$1j({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: t3,
        sensorEvent: e28,
        overContainer: o3,
        over: s3
      });
      this.currentOver = s3, this.trigger(a3);
    }
  }
  [d$1e](r3) {
    if (!this.dragging)
      return;
    this.dragging = false;
    const e28 = new s$1p({
      source: this.source,
      originalSource: this.originalSource,
      sensorEvent: r3 ? r3.sensorEvent : null,
      sourceContainer: this.sourceContainer
    });
    this.trigger(e28), e28.canceled() || this.source.parentNode.insertBefore(this.originalSource, this.source), this.source.remove(), this.originalSource.style.display = "", this.source.classList.remove(...this.getClassNamesFor("source:dragging")), this.originalSource.classList.remove(...this.getClassNamesFor("source:original")), this.originalSource.classList.add(...this.getClassNamesFor("source:placed")), this.sourceContainer.classList.add(...this.getClassNamesFor("container:placed")), this.sourceContainer.classList.remove(...this.getClassNamesFor("container:dragging")), document.body.classList.remove(...this.getClassNamesFor("body:dragging")), C$R(document.body, ""), this.currentOver && this.currentOver.classList.remove(...this.getClassNamesFor("draggable:over")), this.currentOverContainer && this.currentOverContainer.classList.remove(...this.getClassNamesFor("container:over")), this.lastPlacedSource = this.originalSource, this.lastPlacedContainer = this.sourceContainer, this.placedTimeoutID = setTimeout(() => {
      this.lastPlacedSource && this.lastPlacedSource.classList.remove(...this.getClassNamesFor("source:placed")), this.lastPlacedContainer && this.lastPlacedContainer.classList.remove(...this.getClassNamesFor("container:placed")), this.lastPlacedSource = null, this.lastPlacedContainer = null;
    }, this.options.placedTimeout);
    const t3 = new c$1s({
      source: this.source,
      originalSource: this.originalSource,
      sensorEvent: r3 ? r3.sensorEvent : null,
      sourceContainer: this.sourceContainer
    });
    this.trigger(t3), this.source = null, this.originalSource = null, this.currentOverContainer = null, this.currentOver = null, this.sourceContainer = null;
  }
  [u$1e](r3) {
    this[d$1e](r3);
  }
  [h$1b](r3) {
    if (!this.dragging)
      return;
    const e28 = S$w(r3), t3 = this.source || u$1j(e28.originalEvent.target, this.options.draggable), s3 = new d$1h({
      sensorEvent: e28,
      source: t3,
      pressure: e28.pressure
    });
    this.trigger(s3);
  }
}
m$1w.Plugins = {
  Announcement: y$P,
  Focusable: l$1g,
  Mirror: z$n,
  Scrollable: O$v
};
m$1w.Sensors = {
  MouseSensor: Y$k,
  TouchSensor: y$Q
};
function S$w(i) {
  return i.detail;
}
function C$R(i, r3) {
  i.style.webkitUserSelect = r3, i.style.mozUserSelect = r3, i.style.msUserSelect = r3, i.style.oUserSelect = r3, i.style.userSelect = r3;
}
class t$11 extends t$13 {
  constructor(r3) {
    super(r3), this.data = r3;
  }
  get dragEvent() {
    return this.data.dragEvent;
  }
}
t$11.type = "sortable";
class n$Z extends t$11 {
  get startIndex() {
    return this.data.startIndex;
  }
  get startContainer() {
    return this.data.startContainer;
  }
}
n$Z.type = "sortable:start";
n$Z.cancelable = true;
class a$1u extends t$11 {
  get currentIndex() {
    return this.data.currentIndex;
  }
  get over() {
    return this.data.over;
  }
  get overContainer() {
    return this.data.dragEvent.overContainer;
  }
}
a$1u.type = "sortable:sort";
a$1u.cancelable = true;
class o$11 extends t$11 {
  get oldIndex() {
    return this.data.oldIndex;
  }
  get newIndex() {
    return this.data.newIndex;
  }
  get oldContainer() {
    return this.data.oldContainer;
  }
  get newContainer() {
    return this.data.newContainer;
  }
}
o$11.type = "sortable:sorted";
class d$1d extends t$11 {
  get oldIndex() {
    return this.data.oldIndex;
  }
  get newIndex() {
    return this.data.newIndex;
  }
  get oldContainer() {
    return this.data.oldContainer;
  }
  get newContainer() {
    return this.data.newContainer;
  }
}
d$1d.type = "sortable:stop";
const d$1c = Symbol("onDragStart"), l$1d = Symbol("onDragOverContainer"), c$1n = Symbol("onDragOver"), h$1a = Symbol("onDragStop");
function E$v({
  dragEvent: n3
}) {
  const t3 = n3.source.textContent.trim() || n3.source.id || "sortable element";
  if (n3.over) {
    const e28 = n3.over.textContent.trim() || n3.over.id || "sortable element";
    return n3.source.compareDocumentPosition(n3.over) & Node.DOCUMENT_POSITION_FOLLOWING ? `Placed ${t3} after ${e28}` : `Placed ${t3} before ${e28}`;
  } else
    return `Placed ${t3} into a different container`;
}
const D$B = {
  "sortable:sorted": E$v
};
class _$v extends m$1w {
  constructor(t3 = [], e28 = {}) {
    super(t3, __spreadProps(__spreadValues({}, e28), {
      announcements: __spreadValues(__spreadValues({}, D$B), e28.announcements || {})
    })), this.startIndex = null, this.startContainer = null, this[d$1c] = this[d$1c].bind(this), this[l$1d] = this[l$1d].bind(this), this[c$1n] = this[c$1n].bind(this), this[h$1a] = this[h$1a].bind(this), this.on("drag:start", this[d$1c]).on("drag:over:container", this[l$1d]).on("drag:over", this[c$1n]).on("drag:stop", this[h$1a]);
  }
  destroy() {
    super.destroy(), this.off("drag:start", this[d$1c]).off("drag:over:container", this[l$1d]).off("drag:over", this[c$1n]).off("drag:stop", this[h$1a]);
  }
  index(t3) {
    return this.getSortableElementsForContainer(t3.parentNode).indexOf(t3);
  }
  getSortableElementsForContainer(t3) {
    return [...t3.querySelectorAll(this.options.draggable)].filter((r3) => r3 !== this.originalSource && r3 !== this.mirror && r3.parentNode === t3);
  }
  [d$1c](t3) {
    this.startContainer = t3.source.parentNode, this.startIndex = this.index(t3.source);
    const e28 = new n$Z({
      dragEvent: t3,
      startIndex: this.startIndex,
      startContainer: this.startContainer
    });
    this.trigger(e28), e28.canceled() && t3.cancel();
  }
  [l$1d](t3) {
    if (t3.canceled())
      return;
    const {
      source: e28,
      over: r3,
      overContainer: o3
    } = t3, i = this.index(e28), s3 = new a$1u({
      dragEvent: t3,
      currentIndex: i,
      source: e28,
      over: r3
    });
    if (this.trigger(s3), s3.canceled())
      return;
    const u3 = this.getSortableElementsForContainer(o3), a3 = x$u({
      source: e28,
      over: r3,
      overContainer: o3,
      children: u3
    });
    if (!a3)
      return;
    const {
      oldContainer: f3,
      newContainer: g3
    } = a3, p3 = this.index(t3.source), m3 = new o$11({
      dragEvent: t3,
      oldIndex: i,
      newIndex: p3,
      oldContainer: f3,
      newContainer: g3
    });
    this.trigger(m3);
  }
  [c$1n](t3) {
    if (t3.over === t3.originalSource || t3.over === t3.source)
      return;
    const {
      source: e28,
      over: r3,
      overContainer: o3
    } = t3, i = this.index(e28), s3 = new a$1u({
      dragEvent: t3,
      currentIndex: i,
      source: e28,
      over: r3
    });
    if (this.trigger(s3), s3.canceled())
      return;
    const u3 = this.getDraggableElementsForContainer(o3), a3 = x$u({
      source: e28,
      over: r3,
      overContainer: o3,
      children: u3
    });
    if (!a3)
      return;
    const {
      oldContainer: f3,
      newContainer: g3
    } = a3, p3 = this.index(e28), m3 = new o$11({
      dragEvent: t3,
      oldIndex: i,
      newIndex: p3,
      oldContainer: f3,
      newContainer: g3
    });
    this.trigger(m3);
  }
  [h$1a](t3) {
    const e28 = new d$1d({
      dragEvent: t3,
      oldIndex: this.startIndex,
      newIndex: this.index(t3.source),
      oldContainer: this.startContainer,
      newContainer: t3.source.parentNode
    });
    this.trigger(e28), this.startIndex = null, this.startContainer = null;
  }
}
function b$N(n3) {
  return Array.prototype.indexOf.call(n3.parentNode.children, n3);
}
function x$u({
  source: n3,
  over: t3,
  overContainer: e28,
  children: r3
}) {
  const o3 = !r3.length, i = n3.parentNode !== e28, s3 = t3 && n3.parentNode === t3.parentNode;
  return o3 ? O$u(n3, e28) : s3 ? v$L(n3, t3) : i ? y$M(n3, t3, e28) : null;
}
function O$u(n3, t3) {
  const e28 = n3.parentNode;
  return t3.appendChild(n3), {
    oldContainer: e28,
    newContainer: t3
  };
}
function v$L(n3, t3) {
  const e28 = b$N(n3), r3 = b$N(t3);
  return e28 < r3 ? n3.parentNode.insertBefore(n3, t3.nextElementSibling) : n3.parentNode.insertBefore(n3, t3), {
    oldContainer: n3.parentNode,
    newContainer: n3.parentNode
  };
}
function y$M(n3, t3, e28) {
  const r3 = n3.parentNode;
  return t3 ? t3.parentNode.insertBefore(n3, t3) : e28.appendChild(n3), {
    oldContainer: r3,
    newContainer: n3.parentNode
  };
}
function v$K(o3) {
  const r3 = document.querySelectorAll(".n-data-table-tbody");
  if (r3.length === 0)
    return null;
  const t3 = {
    draggable: ".n-data-table-tr",
    mirror: {
      appendTo: r3,
      constrainDimensions: true
    },
    delay: 300,
    classes: {
      mirror: "draggable-mirror",
      "body:dragging": "",
      "container:dragging": "",
      "source:dragging": "",
      "source:placed": "",
      "container:placed": "",
      "draggable:over": "",
      "container:over": "",
      "source:original": ""
    }
  };
  return o3 && (t3.handle = `.${o3}`), new _$v(r3, t3);
}
const o$10 = defineComponent({
  name: "DataTableRenderSorter",
  props: {
    render: {
      type: Function,
      required: true
    },
    order: {
      type: [String, Boolean],
      default: false
    }
  },
  render() {
    const {
      render: e28,
      order: r3
    } = this;
    return e28({
      order: r3
    });
  }
});
const a$1t = Object.assign(Object.assign({}, _$F.props), {
  onUnstableColumnResize: Function,
  pagination: {
    type: [Object, Boolean],
    default: false
  },
  paginateSinglePage: {
    type: Boolean,
    default: true
  },
  minHeight: [Number, String],
  maxHeight: [Number, String],
  columns: {
    type: Array,
    default: () => []
  },
  rowClassName: [String, Function],
  rowProps: Function,
  rowKey: Function,
  summary: [Function],
  data: {
    type: Array,
    default: () => []
  },
  loading: Boolean,
  bordered: {
    type: Boolean,
    default: void 0
  },
  bottomBordered: {
    type: Boolean,
    default: void 0
  },
  striped: Boolean,
  scrollX: [Number, String],
  defaultCheckedRowKeys: {
    type: Array,
    default: () => []
  },
  checkedRowKeys: Array,
  singleLine: {
    type: Boolean,
    default: true
  },
  singleColumn: Boolean,
  size: {
    type: String,
    default: "medium"
  },
  remote: Boolean,
  defaultExpandedRowKeys: {
    type: Array,
    default: []
  },
  defaultExpandAll: Boolean,
  expandedRowKeys: Array,
  stickyExpandedRows: Boolean,
  virtualScroll: Boolean,
  tableLayout: {
    type: String,
    default: "auto"
  },
  allowCheckingNotLoaded: Boolean,
  cascade: {
    type: Boolean,
    default: true
  },
  childrenKey: {
    type: String,
    default: "children"
  },
  indent: {
    type: Number,
    default: 16
  },
  flexHeight: Boolean,
  summaryPlacement: {
    type: String,
    default: "bottom"
  },
  paginationBehaviorOnFilter: {
    type: String,
    default: "current"
  },
  scrollbarProps: Object,
  renderCell: Function,
  renderExpandIcon: Function,
  spinProps: {
    type: Object,
    default: {}
  },
  onLoad: Function,
  "onUpdate:page": [Function, Array],
  onUpdatePage: [Function, Array],
  "onUpdate:pageSize": [Function, Array],
  onUpdatePageSize: [Function, Array],
  "onUpdate:sorter": [Function, Array],
  onUpdateSorter: [Function, Array],
  "onUpdate:filters": [Function, Array],
  onUpdateFilters: [Function, Array],
  "onUpdate:checkedRowKeys": [Function, Array],
  onUpdateCheckedRowKeys: [Function, Array],
  "onUpdate:expandedRowKeys": [Function, Array],
  onUpdateExpandedRowKeys: [Function, Array],
  onScroll: Function,
  onPageChange: [Function, Array],
  onPageSizeChange: [Function, Array],
  onSorterChange: [Function, Array],
  onFiltersChange: [Function, Array],
  onCheckedRowKeysChange: [Function, Array]
}), r$1d = n$28("n-data-table");
const n$Y = defineComponent({
  name: "ArrowDown",
  render() {
    return h$1R("svg", {
      viewBox: "0 0 28 28",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, h$1R("g", {
      stroke: "none",
      "stroke-width": "1",
      "fill-rule": "evenodd"
    }, h$1R("g", {
      "fill-rule": "nonzero"
    }, h$1R("path", {
      d: "M23.7916,15.2664 C24.0788,14.9679 24.0696,14.4931 23.7711,14.206 C23.4726,13.9188 22.9978,13.928 22.7106,14.2265 L14.7511,22.5007 L14.7511,3.74792 C14.7511,3.33371 14.4153,2.99792 14.0011,2.99792 C13.5869,2.99792 13.2511,3.33371 13.2511,3.74793 L13.2511,22.4998 L5.29259,14.2265 C5.00543,13.928 4.53064,13.9188 4.23213,14.206 C3.93361,14.4931 3.9244,14.9679 4.21157,15.2664 L13.2809,24.6944 C13.6743,25.1034 14.3289,25.1034 14.7223,24.6944 L23.7916,15.2664 Z"
    }))));
  }
});
const O$t = defineComponent({
  name: "SortIcon",
  props: {
    column: {
      type: Object,
      required: true
    }
  },
  setup(o3) {
    const {
      mergedComponentPropsRef: e28
    } = a$2x(), {
      mergedSortStateRef: t3,
      mergedClsPrefixRef: n3
    } = inject(r$1d), m3 = computed(() => t3.value.find((r3) => r3.columnKey === o3.column.key)), c3 = computed(() => m3.value !== void 0), l3 = computed(() => {
      const {
        value: r3
      } = m3;
      return r3 && c3.value ? r3.order : false;
    }), u3 = computed(() => {
      var r3, s3;
      return ((s3 = (r3 = e28 == null ? void 0 : e28.value) === null || r3 === void 0 ? void 0 : r3.DataTable) === null || s3 === void 0 ? void 0 : s3.renderSorter) || o3.column.renderSorter;
    });
    return {
      mergedClsPrefix: n3,
      active: c3,
      mergedSortOrder: l3,
      mergedRenderSorter: u3
    };
  },
  render() {
    const {
      mergedRenderSorter: o3,
      mergedSortOrder: e28,
      mergedClsPrefix: t3
    } = this, {
      renderSorterIcon: n3
    } = this.column;
    return o3 ? h$1R(o$10, {
      render: o3,
      order: e28
    }) : h$1R("span", {
      class: [`${t3}-data-table-sorter`, e28 === "ascend" && `${t3}-data-table-sorter--asc`, e28 === "descend" && `${t3}-data-table-sorter--desc`]
    }, n3 ? n3({
      order: e28
    }) : h$1R(d$1R, {
      clsPrefix: t3
    }, {
      default: () => h$1R(n$Y, null)
    }));
  }
});
const a$1s = defineComponent({
  name: "DataTableRenderFilter",
  props: {
    render: {
      type: Function,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  render() {
    const {
      render: e28,
      active: t3,
      show: r3
    } = this;
    return e28({
      active: t3,
      show: r3
    });
  }
});
const o$$ = 40, l$1c = 40;
function g$U(e28) {
  if (e28.type === "selection")
    return e28.width === void 0 ? o$$ : i$1y(e28.width);
  if (e28.type === "expand")
    return e28.width === void 0 ? l$1c : i$1y(e28.width);
  if (!("children" in e28))
    return typeof e28.width == "string" ? i$1y(e28.width) : e28.width;
}
function p$38(e28) {
  var n3, t3;
  if (e28.type === "selection")
    return o$1z((n3 = e28.width) !== null && n3 !== void 0 ? n3 : o$$);
  if (e28.type === "expand")
    return o$1z((t3 = e28.width) !== null && t3 !== void 0 ? t3 : l$1c);
  if (!("children" in e28))
    return o$1z(e28.width);
}
function C$Q(e28) {
  return e28.type === "selection" ? "__n_selection__" : e28.type === "expand" ? "__n_expand__" : e28.key;
}
function _$u(e28) {
  return e28 && (typeof e28 == "object" ? Object.assign({}, e28) : e28);
}
function O$s(e28) {
  return e28 === "ascend" ? 1 : e28 === "descend" ? -1 : 0;
}
function w$A(e28, n3, t3) {
  return t3 !== void 0 && (e28 = Math.min(e28, typeof t3 == "number" ? t3 : parseFloat(t3))), n3 !== void 0 && (e28 = Math.max(e28, typeof n3 == "number" ? n3 : parseFloat(n3))), e28;
}
function x$t(e28, n3) {
  if (n3 !== void 0)
    return {
      width: n3,
      minWidth: n3,
      maxWidth: n3
    };
  const t3 = p$38(e28), {
    minWidth: f3,
    maxWidth: d3
  } = e28;
  return {
    width: t3,
    minWidth: o$1z(f3) || t3,
    maxWidth: o$1z(d3)
  };
}
function b$M(e28, n3, t3) {
  return typeof t3 == "function" ? t3(e28, n3) : t3 || "";
}
function m$1v(e28) {
  return e28.filterOptionValues !== void 0 || e28.filterOptionValue === void 0 && e28.defaultFilterOptionValues !== void 0;
}
function W$m(e28) {
  return "children" in e28 ? false : !!e28.sorter;
}
function F$p(e28) {
  return "children" in e28 && e28.children.length ? false : !!e28.resizable;
}
function k$D(e28) {
  return "children" in e28 ? false : !!e28.filter && (!!e28.filterOptions || !!e28.renderFilterMenu);
}
function s$1j(e28) {
  if (e28) {
    if (e28 === "descend")
      return "ascend";
  } else
    return "descend";
  return false;
}
function j$l(e28, n3) {
  return e28.sorter === void 0 ? null : n3 === null || n3.columnKey !== e28.key ? {
    columnKey: e28.key,
    sorter: e28.sorter,
    order: s$1j(false)
  } : Object.assign(Object.assign({}, n3), {
    order: s$1j(n3.order)
  });
}
function I$x(e28, n3) {
  return n3.find((t3) => t3.columnKey === e28.key && t3.order) !== void 0;
}
function h$19(e28) {
  return typeof e28 == "string" ? e28.replace(/,/g, "\\,") : e28 == null ? "" : `${e28}`.replace(/,/g, "\\,");
}
function K$j(e28, n3) {
  const t3 = e28.filter((r3) => r3.type !== "expand" && r3.type !== "selection"), f3 = t3.map((r3) => r3.title).join(","), d3 = n3.map((r3) => t3.map((a3) => h$19(r3[a3.key])).join(","));
  return [f3, ...d3].join(`
`);
}
const _$t = n$28("n-checkbox-group"), j$k = {
  min: Number,
  max: Number,
  size: String,
  value: Array,
  defaultValue: {
    type: Array,
    default: null
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onChange: [Function, Array]
}, b$L = defineComponent({
  name: "CheckboxGroup",
  props: j$k,
  setup(t3) {
    const {
      mergedClsPrefixRef: g3
    } = a$2x(t3), p3 = h$1B(t3), {
      mergedSizeRef: y3,
      mergedDisabledRef: h3
    } = p3, f3 = ref$1(t3.defaultValue), C3 = computed(() => t3.value), l3 = d$1S(C3, f3), R3 = computed(() => {
      var u3;
      return ((u3 = l3.value) === null || u3 === void 0 ? void 0 : u3.length) || 0;
    }), A3 = computed(() => Array.isArray(l3.value) ? new Set(l3.value) : /* @__PURE__ */ new Set());
    function T3(u3, e28) {
      const {
        nTriggerFormInput: c3,
        nTriggerFormChange: d3
      } = p3, {
        onChange: o3,
        "onUpdate:value": a3,
        onUpdateValue: i
      } = t3;
      if (Array.isArray(l3.value)) {
        const r3 = Array.from(l3.value), s3 = r3.findIndex((F3) => F3 === e28);
        u3 ? ~s3 || (r3.push(e28), i && i$1Z(i, r3, {
          actionType: "check",
          value: e28
        }), a3 && i$1Z(a3, r3, {
          actionType: "check",
          value: e28
        }), c3(), d3(), f3.value = r3, o3 && i$1Z(o3, r3)) : ~s3 && (r3.splice(s3, 1), i && i$1Z(i, r3, {
          actionType: "uncheck",
          value: e28
        }), a3 && i$1Z(a3, r3, {
          actionType: "uncheck",
          value: e28
        }), o3 && i$1Z(o3, r3), f3.value = r3, c3(), d3());
      } else
        u3 ? (i && i$1Z(i, [e28], {
          actionType: "check",
          value: e28
        }), a3 && i$1Z(a3, [e28], {
          actionType: "check",
          value: e28
        }), o3 && i$1Z(o3, [e28]), f3.value = [e28], c3(), d3()) : (i && i$1Z(i, [], {
          actionType: "uncheck",
          value: e28
        }), a3 && i$1Z(a3, [], {
          actionType: "uncheck",
          value: e28
        }), o3 && i$1Z(o3, []), f3.value = [], c3(), d3());
    }
    return provide(_$t, {
      checkedCountRef: R3,
      maxRef: toRef$1(t3, "max"),
      minRef: toRef$1(t3, "min"),
      valueSetRef: A3,
      disabledRef: h3,
      mergedSizeRef: y3,
      toggleCheckbox: T3
    }), {
      mergedClsPrefix: g3
    };
  },
  render() {
    return h$1R("div", {
      class: `${this.mergedClsPrefix}-checkbox-group`,
      role: "group"
    }, this.$slots);
  }
});
const a$1r = h$1R("svg", {
  viewBox: "0 0 64 64",
  class: "check-icon"
}, h$1R("path", {
  d: "M50.42,16.76L22.34,39.45l-8.1-11.46c-1.12-1.58-3.3-1.96-4.88-0.84c-1.58,1.12-1.95,3.3-0.84,4.88l10.26,14.51  c0.56,0.79,1.42,1.31,2.38,1.45c0.16,0.02,0.32,0.03,0.48,0.03c0.8,0,1.57-0.27,2.2-0.78l30.99-25.03c1.5-1.21,1.74-3.42,0.52-4.92  C54.13,15.78,51.93,15.55,50.42,16.76z"
}));
const a$1q = h$1R("svg", {
  viewBox: "0 0 100 100",
  class: "line-icon"
}, h$1R("path", {
  d: "M80.2,55.5H21.4c-2.8,0-5.1-2.5-5.1-5.5l0,0c0-3,2.3-5.5,5.1-5.5h58.7c2.8,0,5.1,2.5,5.1,5.5l0,0C85.2,53.1,82.9,55.5,80.2,55.5z"
}));
const t$10 = r$2a([
  l$25("checkbox", `
 font-size: var(--n-font-size);
 outline: none;
 cursor: pointer;
 display: inline-flex;
 flex-wrap: nowrap;
 align-items: flex-start;
 word-break: break-word;
 line-height: var(--n-size);
 --n-merged-color-table: var(--n-color-table);
 `, [g$1j("show-label", "line-height: var(--n-label-line-height);"), r$2a("&:hover", [l$25("checkbox-box", [M$y("border", "border: var(--n-border-checked);")])]), r$2a("&:focus:not(:active)", [l$25("checkbox-box", [M$y("border", `
 border: var(--n-border-focus);
 box-shadow: var(--n-box-shadow-focus);
 `)])]), g$1j("inside-table", [l$25("checkbox-box", `
 background-color: var(--n-merged-color-table);
 `)]), g$1j("checked", [l$25("checkbox-box", `
 background-color: var(--n-color-checked);
 `, [l$25("checkbox-icon", [
    r$2a(".check-icon", `
 opacity: 1;
 transform: scale(1);
 `)
  ])])]), g$1j("indeterminate", [l$25("checkbox-box", [l$25("checkbox-icon", [r$2a(".check-icon", `
 opacity: 0;
 transform: scale(.5);
 `), r$2a(".line-icon", `
 opacity: 1;
 transform: scale(1);
 `)])])]), g$1j("checked, indeterminate", [r$2a("&:focus:not(:active)", [l$25("checkbox-box", [M$y("border", `
 border: var(--n-border-checked);
 box-shadow: var(--n-box-shadow-focus);
 `)])]), l$25("checkbox-box", `
 background-color: var(--n-color-checked);
 border-left: 0;
 border-top: 0;
 `, [M$y("border", {
    border: "var(--n-border-checked)"
  })])]), g$1j("disabled", {
    cursor: "not-allowed"
  }, [g$1j("checked", [l$25("checkbox-box", `
 background-color: var(--n-color-disabled-checked);
 `, [M$y("border", {
    border: "var(--n-border-disabled-checked)"
  }), l$25("checkbox-icon", [r$2a(".check-icon, .line-icon", {
    fill: "var(--n-check-mark-color-disabled-checked)"
  })])])]), l$25("checkbox-box", `
 background-color: var(--n-color-disabled);
 `, [M$y("border", `
 border: var(--n-border-disabled);
 `), l$25("checkbox-icon", [r$2a(".check-icon, .line-icon", `
 fill: var(--n-check-mark-color-disabled);
 `)])]), M$y("label", `
 color: var(--n-text-color-disabled);
 `)]), l$25("checkbox-box-wrapper", `
 position: relative;
 width: var(--n-size);
 flex-shrink: 0;
 flex-grow: 0;
 user-select: none;
 -webkit-user-select: none;
 `), l$25("checkbox-box", `
 position: absolute;
 left: 0;
 top: 50%;
 transform: translateY(-50%);
 height: var(--n-size);
 width: var(--n-size);
 display: inline-block;
 box-sizing: border-box;
 border-radius: var(--n-border-radius);
 background-color: var(--n-color);
 transition: background-color 0.3s var(--n-bezier);
 `, [M$y("border", `
 transition:
 border-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 border-radius: inherit;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border: var(--n-border);
 `), l$25("checkbox-icon", `
 display: flex;
 align-items: center;
 justify-content: center;
 position: absolute;
 left: 1px;
 right: 1px;
 top: 1px;
 bottom: 1px;
 `, [r$2a(".check-icon, .line-icon", `
 width: 100%;
 fill: var(--n-check-mark-color);
 opacity: 0;
 transform: scale(0.5);
 transform-origin: center;
 transition:
 fill 0.3s var(--n-bezier),
 transform 0.3s var(--n-bezier),
 opacity 0.3s var(--n-bezier),
 border-color 0.3s var(--n-bezier);
 `), m$22({
    left: "1px",
    top: "1px"
  })])]), M$y("label", `
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 user-select: none;
 -webkit-user-select: none;
 padding: var(--n-label-padding);
 font-weight: var(--n-label-font-weight);
 `, [r$2a("&:empty", {
    display: "none"
  })])]),
  C$1a(l$25("checkbox", `
 --n-merged-color-table: var(--n-color-table-modal);
 `)),
  P$V(l$25("checkbox", `
 --n-merged-color-table: var(--n-color-table-popover);
 `))
]);
const e$15 = {
  sizeSmall: "14px",
  sizeMedium: "16px",
  sizeLarge: "18px",
  labelPadding: "0 8px",
  labelFontWeight: "400"
};
const g$T = (d3) => {
  const {
    baseColor: l3,
    inputColorDisabled: a3,
    cardColor: c3,
    modalColor: i,
    popoverColor: s3,
    textColorDisabled: e28,
    borderColor: r3,
    primaryColor: o3,
    textColor2: b3,
    fontSizeSmall: t3,
    fontSizeMedium: C3,
    fontSizeLarge: h3,
    borderRadiusSmall: m3,
    lineHeight: n3
  } = d3;
  return Object.assign(Object.assign({}, e$15), {
    labelLineHeight: n3,
    fontSizeSmall: t3,
    fontSizeMedium: C3,
    fontSizeLarge: h3,
    borderRadius: m3,
    color: l3,
    colorChecked: o3,
    colorDisabled: a3,
    colorDisabledChecked: a3,
    colorTableHeader: c3,
    colorTableHeaderModal: i,
    colorTableHeaderPopover: s3,
    checkMarkColor: l3,
    checkMarkColorDisabled: e28,
    checkMarkColorDisabledChecked: e28,
    border: `1px solid ${r3}`,
    borderDisabled: `1px solid ${r3}`,
    borderDisabledChecked: `1px solid ${r3}`,
    borderChecked: `1px solid ${o3}`,
    borderFocus: `1px solid ${o3}`,
    boxShadowFocus: `0 0 0 2px ${J$p(o3, {
      alpha: 0.3
    })}`,
    textColor: b3,
    textColorDisabled: e28
  });
}, f$_ = {
  name: "Checkbox",
  common: d$1T,
  self: g$T
}, S$v = f$_;
const xe$b = Object.assign(Object.assign({}, _$F.props), {
  size: String,
  checked: {
    type: [Boolean, String, Number],
    default: void 0
  },
  defaultChecked: {
    type: [Boolean, String, Number],
    default: false
  },
  value: [String, Number],
  disabled: {
    type: Boolean,
    default: void 0
  },
  indeterminate: Boolean,
  label: String,
  focusable: {
    type: Boolean,
    default: true
  },
  checkedValue: {
    type: [Boolean, String, Number],
    default: true
  },
  uncheckedValue: {
    type: [Boolean, String, Number],
    default: false
  },
  "onUpdate:checked": [Function, Array],
  onUpdateChecked: [Function, Array],
  privateInsideTable: Boolean,
  onChange: [Function, Array]
}), Pe$a = defineComponent({
  name: "Checkbox",
  props: xe$b,
  setup(o3) {
    const h3 = ref$1(null), {
      mergedClsPrefixRef: i,
      inlineThemeDisabled: m3,
      mergedRtlRef: x3
    } = a$2x(o3), k3 = h$1B(o3, {
      mergedSize(e28) {
        const {
          size: c3
        } = o3;
        if (c3 !== void 0)
          return c3;
        if (r3) {
          const {
            value: l3
          } = r3.mergedSizeRef;
          if (l3 !== void 0)
            return l3;
        }
        if (e28) {
          const {
            mergedSize: l3
          } = e28;
          if (l3 !== void 0)
            return l3.value;
        }
        return "medium";
      },
      mergedDisabled(e28) {
        const {
          disabled: c3
        } = o3;
        if (c3 !== void 0)
          return c3;
        if (r3) {
          if (r3.disabledRef.value)
            return true;
          const {
            maxRef: {
              value: l3
            },
            checkedCountRef: t3
          } = r3;
          if (l3 !== void 0 && t3.value >= l3 && !a3.value)
            return true;
          const {
            minRef: {
              value: f3
            }
          } = r3;
          if (f3 !== void 0 && t3.value <= f3 && a3.value)
            return true;
        }
        return e28 ? e28.disabled.value : false;
      }
    }), {
      mergedDisabledRef: v3,
      mergedSizeRef: g3
    } = k3, r3 = inject(_$t, null), n3 = ref$1(o3.defaultChecked), R3 = toRef$1(o3, "checked"), y3 = d$1S(R3, n3), a3 = n$1U(() => {
      if (r3) {
        const e28 = r3.valueSetRef.value;
        return e28 && o3.value !== void 0 ? e28.has(o3.value) : false;
      } else
        return y3.value === o3.checkedValue;
    }), p3 = _$F("Checkbox", "-checkbox", t$10, S$v, o3, i);
    function C3(e28) {
      if (r3 && o3.value !== void 0)
        r3.toggleCheckbox(!a3.value, o3.value);
      else {
        const {
          onChange: c3,
          "onUpdate:checked": l3,
          onUpdateChecked: t3
        } = o3, {
          nTriggerFormInput: f3,
          nTriggerFormChange: S3
        } = k3, b3 = a3.value ? o3.uncheckedValue : o3.checkedValue;
        l3 && i$1Z(l3, b3, e28), t3 && i$1Z(t3, b3, e28), c3 && i$1Z(c3, b3, e28), f3(), S3(), n3.value = b3;
      }
    }
    function s3(e28) {
      v3.value || C3(e28);
    }
    function V10(e28) {
      if (!v3.value)
        switch (e28.key) {
          case " ":
          case "Enter":
            C3(e28);
        }
    }
    function B3(e28) {
      switch (e28.key) {
        case " ":
          e28.preventDefault();
      }
    }
    const I3 = {
      focus: () => {
        var e28;
        (e28 = h3.value) === null || e28 === void 0 || e28.focus();
      },
      blur: () => {
        var e28;
        (e28 = h3.value) === null || e28 === void 0 || e28.blur();
      }
    }, N3 = v$17("Checkbox", x3, i), w3 = computed(() => {
      const {
        value: e28
      } = g3, {
        common: {
          cubicBezierEaseInOut: c3
        },
        self: {
          borderRadius: l3,
          color: t3,
          colorChecked: f3,
          colorDisabled: S3,
          colorTableHeader: b3,
          colorTableHeaderModal: _3,
          colorTableHeaderPopover: E3,
          checkMarkColor: K3,
          checkMarkColorDisabled: F3,
          border: U3,
          borderFocus: O3,
          borderDisabled: P3,
          borderChecked: j3,
          boxShadowFocus: H3,
          textColor: A3,
          textColorDisabled: L3,
          checkMarkColorDisabledChecked: G3,
          colorDisabledChecked: W3,
          borderDisabledChecked: q3,
          labelPadding: J3,
          labelLineHeight: Q3,
          labelFontWeight: X3,
          [_$H("fontSize", e28)]: Y3,
          [_$H("size", e28)]: Z3
        }
      } = p3.value;
      return {
        "--n-label-line-height": Q3,
        "--n-label-font-weight": X3,
        "--n-size": Z3,
        "--n-bezier": c3,
        "--n-border-radius": l3,
        "--n-border": U3,
        "--n-border-checked": j3,
        "--n-border-focus": O3,
        "--n-border-disabled": P3,
        "--n-border-disabled-checked": q3,
        "--n-box-shadow-focus": H3,
        "--n-color": t3,
        "--n-color-checked": f3,
        "--n-color-table": b3,
        "--n-color-table-modal": _3,
        "--n-color-table-popover": E3,
        "--n-color-disabled": S3,
        "--n-color-disabled-checked": W3,
        "--n-text-color": A3,
        "--n-text-color-disabled": L3,
        "--n-check-mark-color": K3,
        "--n-check-mark-color-disabled": F3,
        "--n-check-mark-color-disabled-checked": G3,
        "--n-font-size": Y3,
        "--n-label-padding": J3
      };
    }), u3 = m3 ? E$J("checkbox", computed(() => g3.value[0]), w3, o3) : void 0;
    return Object.assign(k3, I3, {
      rtlEnabled: N3,
      selfRef: h3,
      mergedClsPrefix: i,
      mergedDisabled: v3,
      renderedChecked: a3,
      mergedTheme: p3,
      labelId: i$1Y(),
      handleClick: s3,
      handleKeyUp: V10,
      handleKeyDown: B3,
      cssVars: m3 ? void 0 : w3,
      themeClass: u3 == null ? void 0 : u3.themeClass,
      onRender: u3 == null ? void 0 : u3.onRender
    });
  },
  render() {
    var o3;
    const {
      $slots: h3,
      renderedChecked: i,
      mergedDisabled: m3,
      indeterminate: x3,
      privateInsideTable: k3,
      cssVars: v3,
      labelId: g3,
      label: r3,
      mergedClsPrefix: n3,
      focusable: R3,
      handleKeyUp: y3,
      handleKeyDown: a3,
      handleClick: p3
    } = this;
    (o3 = this.onRender) === null || o3 === void 0 || o3.call(this);
    const C3 = m$26(h3.default, (s3) => r3 || s3 ? h$1R("span", {
      class: `${n3}-checkbox__label`,
      id: g3
    }, r3 || s3) : null);
    return h$1R("div", {
      ref: "selfRef",
      class: [`${n3}-checkbox`, this.themeClass, this.rtlEnabled && `${n3}-checkbox--rtl`, i && `${n3}-checkbox--checked`, m3 && `${n3}-checkbox--disabled`, x3 && `${n3}-checkbox--indeterminate`, k3 && `${n3}-checkbox--inside-table`, C3 && `${n3}-checkbox--show-label`],
      tabindex: m3 || !R3 ? void 0 : 0,
      role: "checkbox",
      "aria-checked": x3 ? "mixed" : i,
      "aria-labelledby": g3,
      style: v3,
      onKeyup: y3,
      onKeydown: a3,
      onClick: p3,
      onMousedown: () => {
        J$o("selectstart", window, (s3) => {
          s3.preventDefault();
        }, {
          once: true
        });
      }
    }, h$1R("div", {
      class: `${n3}-checkbox-box-wrapper`
    }, "\xA0", h$1R("div", {
      class: `${n3}-checkbox-box`
    }, h$1R(m$21, null, {
      default: () => this.indeterminate ? h$1R("div", {
        key: "indeterminate",
        class: `${n3}-checkbox-icon`
      }, a$1q) : h$1R("div", {
        key: "check",
        class: `${n3}-checkbox-icon`
      }, a$1r)
    }), h$1R("div", {
      class: `${n3}-checkbox-box__border`
    }))), C3);
  }
});
const U$r = defineComponent({
  name: "DataTableFilterMenu",
  props: {
    column: {
      type: Object,
      required: true
    },
    radioGroupName: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean,
      required: true
    },
    value: {
      type: [Array, String, Number],
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    onConfirm: {
      type: Function,
      required: true
    },
    onClear: {
      type: Function,
      required: true
    },
    onChange: {
      type: Function,
      required: true
    }
  },
  setup(e28) {
    const {
      mergedClsPrefixRef: i,
      mergedRtlRef: a3
    } = a$2x(e28), n3 = v$17("DataTable", a3, i), {
      mergedClsPrefixRef: o3,
      mergedThemeRef: t3,
      localeRef: c3
    } = inject(r$1d), u3 = ref$1(e28.value), h3 = computed(() => {
      const {
        value: r3
      } = u3;
      return Array.isArray(r3) ? r3 : null;
    }), p3 = computed(() => {
      const {
        value: r3
      } = u3;
      return m$1v(e28.column) ? Array.isArray(r3) && r3.length && r3[0] || null : Array.isArray(r3) ? null : r3;
    });
    function m3(r3) {
      e28.onChange(r3);
    }
    function C3(r3) {
      e28.multiple && Array.isArray(r3) ? u3.value = r3 : m$1v(e28.column) && !Array.isArray(r3) ? u3.value = [r3] : u3.value = r3;
    }
    function y3() {
      m3(u3.value), e28.onConfirm();
    }
    function b3() {
      e28.multiple || m$1v(e28.column) ? m3([]) : m3(null), e28.onClear();
    }
    return {
      mergedClsPrefix: o3,
      rtlEnabled: n3,
      mergedTheme: t3,
      locale: c3,
      checkboxGroupValue: h3,
      radioGroupValue: p3,
      handleChange: C3,
      handleConfirmClick: y3,
      handleClearClick: b3
    };
  },
  render() {
    const {
      mergedTheme: e28,
      locale: i,
      mergedClsPrefix: a3
    } = this;
    return h$1R("div", {
      class: [`${a3}-data-table-filter-menu`, this.rtlEnabled && `${a3}-data-table-filter-menu--rtl`]
    }, h$1R(hn$2, null, {
      default: () => {
        const {
          checkboxGroupValue: n3,
          handleChange: o3
        } = this;
        return this.multiple ? h$1R(b$L, {
          value: n3,
          class: `${a3}-data-table-filter-menu__group`,
          onUpdateValue: o3
        }, {
          default: () => this.options.map((t3) => h$1R(Pe$a, {
            key: t3.value,
            theme: e28.peers.Checkbox,
            themeOverrides: e28.peerOverrides.Checkbox,
            value: t3.value
          }, {
            default: () => t3.label
          }))
        }) : h$1R(Bo$2, {
          name: this.radioGroupName,
          class: `${a3}-data-table-filter-menu__group`,
          value: this.radioGroupValue,
          onUpdateValue: this.handleChange
        }, {
          default: () => this.options.map((t3) => h$1R(Y$l, {
            key: t3.value,
            value: t3.value,
            theme: e28.peers.Radio,
            themeOverrides: e28.peerOverrides.Radio
          }, {
            default: () => t3.label
          }))
        });
      }
    }), h$1R("div", {
      class: `${a3}-data-table-filter-menu__action`
    }, h$1R(le$g, {
      size: "tiny",
      theme: e28.peers.Button,
      themeOverrides: e28.peerOverrides.Button,
      onClick: this.handleClearClick
    }, {
      default: () => i.clear
    }), h$1R(le$g, {
      theme: e28.peers.Button,
      themeOverrides: e28.peerOverrides.Button,
      type: "primary",
      size: "tiny",
      onClick: this.handleConfirmClick
    }, {
      default: () => i.confirm
    })));
  }
});
const n$X = defineComponent({
  name: "Filter",
  render() {
    return h$1R("svg", {
      viewBox: "0 0 28 28",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, h$1R("g", {
      stroke: "none",
      "stroke-width": "1",
      "fill-rule": "evenodd"
    }, h$1R("g", {
      "fill-rule": "nonzero"
    }, h$1R("path", {
      d: "M17,19 C17.5522847,19 18,19.4477153 18,20 C18,20.5522847 17.5522847,21 17,21 L11,21 C10.4477153,21 10,20.5522847 10,20 C10,19.4477153 10.4477153,19 11,19 L17,19 Z M21,13 C21.5522847,13 22,13.4477153 22,14 C22,14.5522847 21.5522847,15 21,15 L7,15 C6.44771525,15 6,14.5522847 6,14 C6,13.4477153 6.44771525,13 7,13 L21,13 Z M24,7 C24.5522847,7 25,7.44771525 25,8 C25,8.55228475 24.5522847,9 24,9 L4,9 C3.44771525,9 3,8.55228475 3,8 C3,7.44771525 3.44771525,7 4,7 L24,7 Z"
    }))));
  }
});
function k$C(r3, i, o3) {
  const e28 = Object.assign({}, r3);
  return e28[i] = o3, e28;
}
const q$p = defineComponent({
  name: "DataTableFilterButton",
  props: {
    column: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  setup(r3) {
    const {
      mergedComponentPropsRef: i
    } = a$2x(), {
      mergedThemeRef: o3,
      mergedClsPrefixRef: e28,
      mergedFilterStateRef: a3,
      filterMenuCssVarsRef: m3,
      paginationBehaviorOnFilterRef: h3,
      doUpdatePage: p3,
      doUpdateFilters: v3
    } = inject(r$1d), u3 = ref$1(false), d3 = a3, f3 = computed(() => r3.column.filterMultiple !== false), c3 = computed(() => {
      const t3 = d3.value[r3.column.key];
      if (t3 === void 0) {
        const {
          value: l3
        } = f3;
        return l3 ? [] : null;
      }
      return t3;
    }), g3 = computed(() => {
      const {
        value: t3
      } = c3;
      return Array.isArray(t3) ? t3.length > 0 : t3 !== null;
    }), F3 = computed(() => {
      var t3, l3;
      return ((l3 = (t3 = i == null ? void 0 : i.value) === null || t3 === void 0 ? void 0 : t3.DataTable) === null || l3 === void 0 ? void 0 : l3.renderFilter) || r3.column.renderFilter;
    });
    function C3(t3) {
      const l3 = k$C(d3.value, r3.column.key, t3);
      v3(l3, r3.column), h3.value === "first" && p3(1);
    }
    function P3() {
      u3.value = false;
    }
    function R3() {
      u3.value = false;
    }
    return {
      mergedTheme: o3,
      mergedClsPrefix: e28,
      active: g3,
      showPopover: u3,
      mergedRenderFilter: F3,
      filterMultiple: f3,
      mergedFilterValue: c3,
      filterMenuCssVars: m3,
      handleFilterChange: C3,
      handleFilterMenuConfirm: R3,
      handleFilterMenuCancel: P3
    };
  },
  render() {
    const {
      mergedTheme: r3,
      mergedClsPrefix: i,
      handleFilterMenuCancel: o3
    } = this;
    return h$1R(Ie$8, {
      show: this.showPopover,
      onUpdateShow: (e28) => this.showPopover = e28,
      trigger: "click",
      theme: r3.peers.Popover,
      themeOverrides: r3.peerOverrides.Popover,
      placement: "bottom",
      style: {
        padding: 0
      }
    }, {
      trigger: () => {
        const {
          mergedRenderFilter: e28
        } = this;
        if (e28)
          return h$1R(a$1s, {
            "data-data-table-filter": true,
            render: e28,
            active: this.active,
            show: this.showPopover
          });
        const {
          renderFilterIcon: a3
        } = this.column;
        return h$1R("div", {
          "data-data-table-filter": true,
          class: [`${i}-data-table-filter`, {
            [`${i}-data-table-filter--active`]: this.active,
            [`${i}-data-table-filter--show`]: this.showPopover
          }]
        }, a3 ? a3({
          active: this.active,
          show: this.showPopover
        }) : h$1R(d$1R, {
          clsPrefix: i
        }, {
          default: () => h$1R(n$X, null)
        }));
      },
      default: () => {
        const {
          renderFilterMenu: e28
        } = this.column;
        return e28 ? e28({
          hide: o3
        }) : h$1R(U$r, {
          style: this.filterMenuCssVars,
          radioGroupName: String(this.column.key),
          multiple: this.filterMultiple,
          value: this.mergedFilterValue,
          options: this.options,
          column: this.column,
          onChange: this.handleFilterChange,
          onClear: this.handleFilterMenuCancel,
          onConfirm: this.handleFilterMenuConfirm
        });
      }
    });
  }
});
const g$S = defineComponent({
  name: "ColumnResizeButton",
  props: {
    onResizeStart: Function,
    onResize: Function,
    onResizeEnd: Function
  },
  setup(n3) {
    const {
      mergedClsPrefixRef: r3
    } = inject(r$1d), t3 = ref$1(false);
    let s3 = 0;
    function l3(e28) {
      return e28.clientX;
    }
    function c3(e28) {
      var o3;
      e28.preventDefault();
      const m3 = t3.value;
      s3 = l3(e28), t3.value = true, m3 || (J$o("mousemove", window, i), J$o("mouseup", window, u3), (o3 = n3.onResizeStart) === null || o3 === void 0 || o3.call(n3));
    }
    function i(e28) {
      var o3;
      (o3 = n3.onResize) === null || o3 === void 0 || o3.call(n3, l3(e28) - s3);
    }
    function u3() {
      var e28;
      t3.value = false, (e28 = n3.onResizeEnd) === null || e28 === void 0 || e28.call(n3), K$p("mousemove", window, i), K$p("mouseup", window, u3);
    }
    return onBeforeUnmount(() => {
      K$p("mousemove", window, i), K$p("mouseup", window, u3);
    }), {
      mergedClsPrefix: r3,
      active: t3,
      handleMousedown: c3
    };
  },
  render() {
    const {
      mergedClsPrefix: n3
    } = this;
    return h$1R("span", {
      "data-data-table-resizable": true,
      class: [`${n3}-data-table-resize-button`, this.active && `${n3}-data-table-resize-button--active`],
      onMousedown: this.handleMousedown
    });
  }
});
const d$1b = defineComponent({
  name: "DropdownDivider",
  props: {
    clsPrefix: {
      type: String,
      required: true
    }
  },
  render() {
    return h$1R("div", {
      class: `${this.clsPrefix}-dropdown-divider`
    });
  }
});
const e$14 = n$28("n-dropdown-menu"), d$1a = n$28("n-dropdown"), t$$ = n$28("n-dropdown-option");
function u$1d(e28, n3) {
  return e28.type === "submenu" || e28.type === void 0 && e28[n3] !== void 0;
}
function i$19(e28) {
  return e28.type === "group";
}
function r$1c(e28) {
  return e28.type === "divider";
}
function t$_(e28) {
  return e28.type === "render";
}
function a$1p(r3, u3, i) {
  if (!u3)
    return r3;
  const e28 = ref$1(r3.value);
  let t3 = null;
  return watch(r3, (l3) => {
    t3 !== null && window.clearTimeout(t3), l3 === true ? i && !i.value ? e28.value = true : t3 = window.setTimeout(() => {
      e28.value = true;
    }, u3) : e28.value = false;
  }), e28;
}
const r$1b = l$25("icon", `
 height: 1em;
 width: 1em;
 line-height: 1em;
 text-align: center;
 display: inline-block;
 position: relative;
 fill: currentColor;
 transform: translateZ(0);
`, [g$1j("color-transition", {
  transition: "color .3s var(--n-bezier)"
}), g$1j("depth", {
  color: "var(--n-color)"
}, [r$2a("svg", {
  opacity: "var(--n-opacity)",
  transition: "opacity .3s var(--n-bezier)"
})]), r$2a("svg", {
  height: "1em",
  width: "1em"
})]);
const y$L = (o3) => {
  const {
    textColorBase: t3,
    opacity1: c3,
    opacity2: p3,
    opacity3: i,
    opacity4: a3,
    opacity5: e28
  } = o3;
  return {
    color: t3,
    opacity1Depth: c3,
    opacity2Depth: p3,
    opacity3Depth: i,
    opacity4Depth: a3,
    opacity5Depth: e28
  };
}, h$18 = {
  name: "Icon",
  common: d$1T,
  self: y$L
}, r$1a = h$18;
const y$K = Object.assign(Object.assign({}, _$F.props), {
  depth: [String, Number],
  size: [Number, String],
  color: String,
  component: Object
}), N$z = defineComponent({
  _n_icon__: true,
  name: "Icon",
  inheritAttrs: false,
  props: y$K,
  setup(e28) {
    const {
      mergedClsPrefixRef: o3,
      inlineThemeDisabled: i
    } = a$2x(e28), r3 = _$F("Icon", "-icon", r$1b, r$1a, e28, o3), s3 = computed(() => {
      const {
        depth: t3
      } = e28, {
        common: {
          cubicBezierEaseInOut: c3
        },
        self: a3
      } = r3.value;
      if (t3 !== void 0) {
        const {
          color: f3,
          [`opacity${t3}Depth`]: u3
        } = a3;
        return {
          "--n-bezier": c3,
          "--n-color": f3,
          "--n-opacity": u3
        };
      }
      return {
        "--n-bezier": c3,
        "--n-color": "",
        "--n-opacity": ""
      };
    }), n3 = i ? E$J("icon", computed(() => `${e28.depth || "d"}`), s3, e28) : void 0;
    return {
      mergedClsPrefix: o3,
      mergedStyle: computed(() => {
        const {
          size: t3,
          color: c3
        } = e28;
        return {
          fontSize: o$1z(t3),
          color: c3
        };
      }),
      cssVars: i ? void 0 : s3,
      themeClass: n3 == null ? void 0 : n3.themeClass,
      onRender: n3 == null ? void 0 : n3.onRender
    };
  },
  render() {
    var e28;
    const {
      $parent: o3,
      depth: i,
      mergedClsPrefix: r3,
      component: s3,
      onRender: n3,
      themeClass: t3
    } = this;
    return !((e28 = o3 == null ? void 0 : o3.$options) === null || e28 === void 0) && e28._n_icon__ && s$2a("icon", "don't wrap `n-icon` inside `n-icon`"), n3 == null || n3(), h$1R("i", mergeProps(this.$attrs, {
      role: "img",
      class: [`${r3}-icon`, t3, {
        [`${r3}-icon--depth`]: i,
        [`${r3}-icon--color-transition`]: i !== void 0
      }],
      style: [this.cssVars, this.mergedStyle]
    }), s3 ? h$1R(s3) : this.$slots);
  }
});
const Se$9 = defineComponent({
  name: "DropdownOption",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    tmNode: {
      type: Object,
      required: true
    },
    parentKey: {
      type: [String, Number],
      default: null
    },
    placement: {
      type: String,
      default: "right-start"
    },
    props: Object,
    scrollable: Boolean
  },
  setup(t3) {
    const l3 = inject(d$1a), {
      hoverKeyRef: c3,
      keyboardKeyRef: d3,
      lastToggledSubmenuKeyRef: v3,
      pendingKeyPathRef: o3,
      activeKeyPathRef: y3,
      animatedRef: w3,
      mergedShowRef: u3,
      renderLabelRef: g3,
      renderIconRef: N3,
      labelFieldRef: f3,
      childrenFieldRef: P3,
      renderOptionRef: S3,
      nodePropsRef: p3,
      menuPropsRef: K3
    } = l3, i = inject(t$$, null), m3 = inject(e$14), I3 = inject(n$1T), j3 = computed(() => t3.tmNode.rawNode), M3 = computed(() => {
      const {
        value: e28
      } = P3;
      return u$1d(t3.tmNode.rawNode, e28);
    }), B3 = computed(() => {
      const {
        disabled: e28
      } = t3.tmNode;
      return e28;
    }), E3 = computed(() => {
      if (!M3.value)
        return false;
      const {
        key: e28,
        disabled: n3
      } = t3.tmNode;
      if (n3)
        return false;
      const {
        value: a3
      } = c3, {
        value: h3
      } = d3, {
        value: U3
      } = v3, {
        value: b3
      } = o3;
      return a3 !== null ? b3.includes(e28) : h3 !== null ? b3.includes(e28) && b3[b3.length - 1] !== e28 : U3 !== null ? b3.includes(e28) : false;
    }), F3 = computed(() => d3.value === null && !w3.value), T3 = a$1p(E3, 300, F3), A3 = computed(() => !!(i != null && i.enteringSubmenuRef.value)), k3 = ref$1(false);
    provide(t$$, {
      enteringSubmenuRef: k3
    });
    function C3() {
      k3.value = true;
    }
    function L3() {
      k3.value = false;
    }
    function x3() {
      const {
        parentKey: e28,
        tmNode: n3
      } = t3;
      n3.disabled || u3.value && (v3.value = e28, d3.value = null, c3.value = n3.key);
    }
    function H3() {
      const {
        tmNode: e28
      } = t3;
      e28.disabled || u3.value && c3.value !== e28.key && x3();
    }
    function V10(e28) {
      if (t3.tmNode.disabled || !u3.value)
        return;
      const {
        relatedTarget: n3
      } = e28;
      n3 && !a$2j({
        target: n3
      }, "dropdownOption") && !a$2j({
        target: n3
      }, "scrollbarRail") && (c3.value = null);
    }
    function q3() {
      const {
        value: e28
      } = M3, {
        tmNode: n3
      } = t3;
      u3.value && !e28 && !n3.disabled && (l3.doSelect(n3.key, n3.rawNode), l3.doUpdateShow(false));
    }
    return {
      labelField: f3,
      renderLabel: g3,
      renderIcon: N3,
      siblingHasIcon: m3.showIconRef,
      siblingHasSubmenu: m3.hasSubmenuRef,
      menuProps: K3,
      popoverBody: I3,
      animated: w3,
      mergedShowSubmenu: computed(() => T3.value && !A3.value),
      rawNode: j3,
      hasSubmenu: M3,
      pending: n$1U(() => {
        const {
          value: e28
        } = o3, {
          key: n3
        } = t3.tmNode;
        return e28.includes(n3);
      }),
      childActive: n$1U(() => {
        const {
          value: e28
        } = y3, {
          key: n3
        } = t3.tmNode, a3 = e28.findIndex((h3) => n3 === h3);
        return a3 === -1 ? false : a3 < e28.length - 1;
      }),
      active: n$1U(() => {
        const {
          value: e28
        } = y3, {
          key: n3
        } = t3.tmNode, a3 = e28.findIndex((h3) => n3 === h3);
        return a3 === -1 ? false : a3 === e28.length - 1;
      }),
      mergedDisabled: B3,
      renderOption: S3,
      nodeProps: p3,
      handleClick: q3,
      handleMouseMove: H3,
      handleMouseEnter: x3,
      handleMouseLeave: V10,
      handleSubmenuBeforeEnter: C3,
      handleSubmenuAfterEnter: L3
    };
  },
  render() {
    var t3, l3;
    const {
      animated: c3,
      rawNode: d3,
      mergedShowSubmenu: v3,
      clsPrefix: o3,
      siblingHasIcon: y3,
      siblingHasSubmenu: w3,
      renderLabel: u3,
      renderIcon: g3,
      renderOption: N3,
      nodeProps: f3,
      props: P3,
      scrollable: S3
    } = this;
    let p3 = null;
    if (v3) {
      const I3 = (t3 = this.menuProps) === null || t3 === void 0 ? void 0 : t3.call(this, d3, d3.children);
      p3 = h$1R(X$i, Object.assign({}, I3, {
        clsPrefix: o3,
        scrollable: this.scrollable,
        tmNodes: this.tmNode.children,
        parentKey: this.tmNode.key
      }));
    }
    const K3 = {
      class: [`${o3}-dropdown-option-body`, this.pending && `${o3}-dropdown-option-body--pending`, this.active && `${o3}-dropdown-option-body--active`, this.childActive && `${o3}-dropdown-option-body--child-active`, this.mergedDisabled && `${o3}-dropdown-option-body--disabled`],
      onMousemove: this.handleMouseMove,
      onMouseenter: this.handleMouseEnter,
      onMouseleave: this.handleMouseLeave,
      onClick: this.handleClick
    }, i = f3 == null ? void 0 : f3(d3), m3 = h$1R("div", Object.assign({
      class: [`${o3}-dropdown-option`, i == null ? void 0 : i.class],
      "data-dropdown-option": true
    }, i), h$1R("div", mergeProps(K3, P3), [h$1R("div", {
      class: [`${o3}-dropdown-option-body__prefix`, y3 && `${o3}-dropdown-option-body__prefix--show-icon`]
    }, [g3 ? g3(d3) : o$1c(d3.icon)]), h$1R("div", {
      "data-dropdown-option": true,
      class: `${o3}-dropdown-option-body__label`
    }, u3 ? u3(d3) : o$1c((l3 = d3[this.labelField]) !== null && l3 !== void 0 ? l3 : d3.title)), h$1R("div", {
      "data-dropdown-option": true,
      class: [`${o3}-dropdown-option-body__suffix`, w3 && `${o3}-dropdown-option-body__suffix--has-submenu`]
    }, this.hasSubmenu ? h$1R(N$z, null, {
      default: () => h$1R(r$1U, null)
    }) : null)]), this.hasSubmenu ? h$1R(F$x, null, {
      default: () => [h$1R(g$19, null, {
        default: () => h$1R("div", {
          class: `${o3}-dropdown-offset-container`
        }, h$1R(me$h, {
          show: this.mergedShowSubmenu,
          placement: this.placement,
          to: S3 && this.popoverBody || void 0,
          teleportDisabled: !S3
        }, {
          default: () => h$1R("div", {
            class: `${o3}-dropdown-menu-wrapper`
          }, c3 ? h$1R(Transition, {
            onBeforeEnter: this.handleSubmenuBeforeEnter,
            onAfterEnter: this.handleSubmenuAfterEnter,
            name: "fade-in-scale-up-transition",
            appear: true
          }, {
            default: () => p3
          }) : p3)
        }))
      })]
    }) : null);
    return N3 ? N3({
      node: m3,
      option: d3
    }) : m3;
  }
});
const y$J = defineComponent({
  name: "DropdownGroupHeader",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    tmNode: {
      type: Object,
      required: true
    }
  },
  setup() {
    const {
      showIconRef: n3,
      hasSubmenuRef: o3
    } = inject(e$14), {
      renderLabelRef: i,
      labelFieldRef: p3,
      nodePropsRef: d3,
      renderOptionRef: t3
    } = inject(d$1a);
    return {
      labelField: p3,
      showIcon: n3,
      hasSubmenu: o3,
      renderLabel: i,
      nodeProps: d3,
      renderOption: t3
    };
  },
  render() {
    var n3;
    const {
      clsPrefix: o3,
      hasSubmenu: i,
      showIcon: p3,
      nodeProps: d3,
      renderLabel: t3,
      renderOption: s3
    } = this, {
      rawNode: e28
    } = this.tmNode, a3 = h$1R("div", Object.assign({
      class: `${o3}-dropdown-option`
    }, d3 == null ? void 0 : d3(e28)), h$1R("div", {
      class: `${o3}-dropdown-option-body ${o3}-dropdown-option-body--group`
    }, h$1R("div", {
      "data-dropdown-option": true,
      class: [`${o3}-dropdown-option-body__prefix`, p3 && `${o3}-dropdown-option-body__prefix--show-icon`]
    }, o$1c(e28.icon)), h$1R("div", {
      class: `${o3}-dropdown-option-body__label`,
      "data-dropdown-option": true
    }, t3 ? t3(e28) : o$1c((n3 = e28.title) !== null && n3 !== void 0 ? n3 : e28[this.labelField])), h$1R("div", {
      class: [`${o3}-dropdown-option-body__suffix`, i && `${o3}-dropdown-option-body__suffix--has-submenu`],
      "data-dropdown-option": true
    })));
    return s3 ? s3({
      node: a3,
      option: e28
    }) : a3;
  }
});
const g$R = defineComponent({
  name: "NDropdownGroup",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    tmNode: {
      type: Object,
      required: true
    },
    parentKey: {
      type: [String, Number],
      default: null
    }
  },
  render() {
    const {
      tmNode: o3,
      parentKey: i,
      clsPrefix: t3
    } = this, {
      children: n3
    } = o3;
    return h$1R(Fragment, null, h$1R(y$J, {
      clsPrefix: t3,
      tmNode: o3,
      key: o3.key
    }), n3 == null ? void 0 : n3.map((r3) => {
      const {
        rawNode: p3
      } = r3;
      return p3.show === false ? null : r$1c(p3) ? h$1R(d$1b, {
        clsPrefix: t3,
        key: r3.key
      }) : r3.isGroup ? (s$2a("dropdown", "`group` node is not allowed to be put in `group` node."), null) : h$1R(Se$9, {
        clsPrefix: t3,
        tmNode: r3,
        parentKey: i,
        key: r3.key
      });
    }));
  }
});
const t$Z = defineComponent({
  name: "DropdownRenderOption",
  props: {
    tmNode: {
      type: Object,
      required: true
    }
  },
  render() {
    const {
      rawNode: {
        render: e28,
        props: o3
      }
    } = this.tmNode;
    return h$1R("div", o3, [e28 == null ? void 0 : e28()]);
  }
});
const X$i = defineComponent({
  name: "DropdownMenu",
  props: {
    scrollable: Boolean,
    showArrow: Boolean,
    arrowStyle: [String, Object],
    clsPrefix: {
      type: String,
      required: true
    },
    tmNodes: {
      type: Array,
      default: () => []
    },
    parentKey: {
      type: [String, Number],
      default: null
    }
  },
  setup(i) {
    const {
      renderIconRef: o3,
      childrenFieldRef: d3
    } = inject(d$1a);
    provide(e$14, {
      showIconRef: computed(() => {
        const r3 = o3.value;
        return i.tmNodes.some((e28) => {
          var n3;
          if (e28.isGroup)
            return (n3 = e28.children) === null || n3 === void 0 ? void 0 : n3.some(({
              rawNode: p3
            }) => r3 ? r3(p3) : p3.icon);
          const {
            rawNode: s3
          } = e28;
          return r3 ? r3(s3) : s3.icon;
        });
      }),
      hasSubmenuRef: computed(() => {
        const {
          value: r3
        } = d3;
        return i.tmNodes.some((e28) => {
          var n3;
          if (e28.isGroup)
            return (n3 = e28.children) === null || n3 === void 0 ? void 0 : n3.some(({
              rawNode: p3
            }) => u$1d(p3, r3));
          const {
            rawNode: s3
          } = e28;
          return u$1d(s3, r3);
        });
      })
    });
    const l3 = ref$1(null);
    return provide(e$1M, null), provide(n$1S, null), provide(n$1T, l3), {
      bodyRef: l3
    };
  },
  render() {
    const {
      parentKey: i,
      clsPrefix: o3,
      scrollable: d3
    } = this, l3 = this.tmNodes.map((r3) => {
      const {
        rawNode: e28
      } = r3;
      return e28.show === false ? null : t$_(e28) ? h$1R(t$Z, {
        tmNode: r3,
        key: r3.key
      }) : r$1c(e28) ? h$1R(d$1b, {
        clsPrefix: o3,
        key: r3.key
      }) : i$19(e28) ? h$1R(g$R, {
        clsPrefix: o3,
        tmNode: r3,
        parentKey: i,
        key: r3.key
      }) : h$1R(Se$9, {
        clsPrefix: o3,
        tmNode: r3,
        parentKey: i,
        key: r3.key,
        props: e28.props,
        scrollable: d3
      });
    });
    return h$1R("div", {
      class: [`${o3}-dropdown-menu`, d3 && `${o3}-dropdown-menu--scrollable`],
      ref: "bodyRef"
    }, d3 ? h$1R(vn$3, {
      contentClass: `${o3}-dropdown-menu__content`
    }, {
      default: () => l3
    }) : l3, this.showArrow ? pe$i({
      clsPrefix: o3,
      arrowStyle: this.arrowStyle,
      arrowClass: void 0,
      arrowWrapperClass: void 0,
      arrowWrapperStyle: void 0
    }) : null);
  }
});
const l$1b = l$25("dropdown-menu", `
 transform-origin: var(--v-transform-origin);
 background-color: var(--n-color);
 border-radius: var(--n-border-radius);
 box-shadow: var(--n-box-shadow);
 position: relative;
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
`, [$$n(), l$25("dropdown-option", `
 position: relative;
 `, [r$2a("a", `
 text-decoration: none;
 color: inherit;
 outline: none;
 `, [r$2a("&::before", `
 content: "";
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `)]), l$25("dropdown-option-body", `
 display: flex;
 cursor: pointer;
 position: relative;
 height: var(--n-option-height);
 line-height: var(--n-option-height);
 font-size: var(--n-font-size);
 color: var(--n-option-text-color);
 transition: color .3s var(--n-bezier);
 `, [r$2a("&::before", `
 content: "";
 position: absolute;
 top: 0;
 bottom: 0;
 left: 4px;
 right: 4px;
 transition: background-color .3s var(--n-bezier);
 border-radius: var(--n-border-radius);
 `), x$I("disabled", [g$1j("pending", `
 color: var(--n-option-text-color-hover);
 `, [M$y("prefix, suffix", `
 color: var(--n-option-text-color-hover);
 `), r$2a("&::before", "background-color: var(--n-option-color-hover);")]), g$1j("active", `
 color: var(--n-option-text-color-active);
 `, [M$y("prefix, suffix", `
 color: var(--n-option-text-color-active);
 `), r$2a("&::before", "background-color: var(--n-option-color-active);")]), g$1j("child-active", `
 color: var(--n-option-text-color-child-active);
 `, [M$y("prefix, suffix", `
 color: var(--n-option-text-color-child-active);
 `)])]), g$1j("disabled", `
 cursor: not-allowed;
 opacity: var(--n-option-opacity-disabled);
 `), g$1j("group", `
 font-size: calc(var(--n-font-size) - 1px);
 color: var(--n-group-header-text-color);
 `, [M$y("prefix", `
 width: calc(var(--n-option-prefix-width) / 2);
 `, [g$1j("show-icon", `
 width: calc(var(--n-option-icon-prefix-width) / 2);
 `)])]), M$y("prefix", `
 width: var(--n-option-prefix-width);
 display: flex;
 justify-content: center;
 align-items: center;
 color: var(--n-prefix-color);
 transition: color .3s var(--n-bezier);
 z-index: 1;
 `, [g$1j("show-icon", `
 width: var(--n-option-icon-prefix-width);
 `), l$25("icon", `
 font-size: var(--n-option-icon-size);
 `)]), M$y("label", `
 white-space: nowrap;
 flex: 1;
 z-index: 1;
 `), M$y("suffix", `
 box-sizing: border-box;
 flex-grow: 0;
 flex-shrink: 0;
 display: flex;
 justify-content: flex-end;
 align-items: center;
 min-width: var(--n-option-suffix-width);
 padding: 0 8px;
 transition: color .3s var(--n-bezier);
 color: var(--n-suffix-color);
 z-index: 1;
 `, [g$1j("has-submenu", `
 width: var(--n-option-icon-suffix-width);
 `), l$25("icon", `
 font-size: var(--n-option-icon-size);
 `)]), l$25("dropdown-menu", "pointer-events: all;")]), l$25("dropdown-offset-container", `
 pointer-events: none;
 position: absolute;
 left: 0;
 right: 0;
 top: -4px;
 bottom: -4px;
 `)]), l$25("dropdown-divider", `
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-divider-color);
 height: 1px;
 margin: 4px 0;
 `), l$25("dropdown-menu-wrapper", `
 transform-origin: var(--v-transform-origin);
 width: fit-content;
 `), r$2a(">", [l$25("scrollbar", `
 height: inherit;
 max-height: inherit;
 `)]), x$I("scrollable", `
 padding: var(--n-padding);
 `), g$1j("scrollable", [M$y("content", `
 padding: var(--n-padding);
 `)])]);
function B$x(p3 = {}, o3) {
  const t3 = reactive({
    ctrl: false,
    command: false,
    win: false,
    shift: false,
    tab: false
  }), { keydown: i, keyup: u3 } = p3, s3 = (e28) => {
    switch (e28.key) {
      case "Control":
        t3.ctrl = true;
        break;
      case "Meta":
        t3.command = true, t3.win = true;
        break;
      case "Shift":
        t3.shift = true;
        break;
      case "Tab":
        t3.tab = true;
        break;
    }
    i !== void 0 && Object.keys(i).forEach((a3) => {
      if (a3 !== e28.key)
        return;
      const n3 = i[a3];
      if (typeof n3 == "function")
        n3(e28);
      else {
        const { stop: d3 = false, prevent: l3 = false } = n3;
        d3 && e28.stopPropagation(), l3 && e28.preventDefault(), n3.handler(e28);
      }
    });
  }, f3 = (e28) => {
    switch (e28.key) {
      case "Control":
        t3.ctrl = false;
        break;
      case "Meta":
        t3.command = false, t3.win = false;
        break;
      case "Shift":
        t3.shift = false;
        break;
      case "Tab":
        t3.tab = false;
        break;
    }
    u3 !== void 0 && Object.keys(u3).forEach((a3) => {
      if (a3 !== e28.key)
        return;
      const n3 = u3[a3];
      if (typeof n3 == "function")
        n3(e28);
      else {
        const { stop: d3 = false, prevent: l3 = false } = n3;
        d3 && e28.stopPropagation(), l3 && e28.preventDefault(), n3.handler(e28);
      }
    });
  }, k3 = () => {
    (o3 === void 0 || o3.value) && (J$o("keydown", document, s3), J$o("keyup", document, f3)), o3 !== void 0 && watch(o3, (e28) => {
      e28 ? (J$o("keydown", document, s3), J$o("keyup", document, f3)) : (K$p("keydown", document, s3), K$p("keyup", document, f3));
    });
  };
  return t$1m() ? (onBeforeMount(k3), onBeforeUnmount(() => {
    (o3 === void 0 || o3.value) && (K$p("keydown", document, s3), K$p("keyup", document, f3));
  })) : k3(), readonly(t3);
}
const i$18 = {
  padding: "4px 0",
  optionIconSizeSmall: "14px",
  optionIconSizeMedium: "16px",
  optionIconSizeLarge: "16px",
  optionIconSizeHuge: "18px",
  optionSuffixWidthSmall: "14px",
  optionSuffixWidthMedium: "14px",
  optionSuffixWidthLarge: "16px",
  optionSuffixWidthHuge: "16px",
  optionIconSuffixWidthSmall: "32px",
  optionIconSuffixWidthMedium: "32px",
  optionIconSuffixWidthLarge: "36px",
  optionIconSuffixWidthHuge: "36px",
  optionPrefixWidthSmall: "14px",
  optionPrefixWidthMedium: "14px",
  optionPrefixWidthLarge: "16px",
  optionPrefixWidthHuge: "16px",
  optionIconPrefixWidthSmall: "36px",
  optionIconPrefixWidthMedium: "36px",
  optionIconPrefixWidthLarge: "40px",
  optionIconPrefixWidthHuge: "40px"
};
const T$B = (r3) => {
  const {
    primaryColor: o3,
    textColor2: e28,
    dividerColor: t3,
    hoverColor: i,
    popoverColor: n3,
    invertedColor: l3,
    borderRadius: p3,
    fontSizeSmall: d3,
    fontSizeMedium: C3,
    fontSizeLarge: v3,
    fontSizeHuge: a3,
    heightSmall: m3,
    heightMedium: g3,
    heightLarge: h3,
    heightHuge: c3,
    textColor3: f3,
    opacityDisabled: s3
  } = r3;
  return Object.assign(Object.assign({}, i$18), {
    optionHeightSmall: m3,
    optionHeightMedium: g3,
    optionHeightLarge: h3,
    optionHeightHuge: c3,
    borderRadius: p3,
    fontSizeSmall: d3,
    fontSizeMedium: C3,
    fontSizeLarge: v3,
    fontSizeHuge: a3,
    optionTextColor: e28,
    optionTextColorHover: e28,
    optionTextColorActive: o3,
    optionTextColorChildActive: o3,
    color: n3,
    dividerColor: t3,
    suffixColor: e28,
    prefixColor: e28,
    optionColorHover: i,
    optionColorActive: J$p(o3, {
      alpha: 0.1
    }),
    groupHeaderTextColor: f3,
    optionTextColorInverted: "#BBB",
    optionTextColorHoverInverted: "#FFF",
    optionTextColorActiveInverted: "#FFF",
    optionTextColorChildActiveInverted: "#FFF",
    colorInverted: l3,
    dividerColorInverted: "#BBB",
    suffixColorInverted: "#BBB",
    prefixColorInverted: "#BBB",
    optionColorHoverInverted: o3,
    optionColorActiveInverted: o3,
    groupHeaderTextColorInverted: "#AAA",
    optionOpacityDisabled: s3
  });
}, A$w = G$w({
  name: "Dropdown",
  common: d$1T,
  peers: {
    Popover: b$11
  },
  self: T$B
}), w$z = A$w;
const ve$b = {
  animated: {
    type: Boolean,
    default: true
  },
  keyboard: {
    type: Boolean,
    default: true
  },
  size: {
    type: String,
    default: "medium"
  },
  inverted: Boolean,
  placement: {
    type: String,
    default: "bottom"
  },
  onSelect: [Function, Array],
  options: {
    type: Array,
    default: () => []
  },
  menuProps: Function,
  showArrow: Boolean,
  renderLabel: Function,
  renderIcon: Function,
  renderOption: Function,
  nodeProps: Function,
  labelField: {
    type: String,
    default: "label"
  },
  keyField: {
    type: String,
    default: "key"
  },
  childrenField: {
    type: String,
    default: "children"
  },
  value: [String, Number]
}, me$e = Object.keys(de$g), ge$d = Object.assign(Object.assign(Object.assign({}, de$g), ve$b), _$F.props), Le$6 = defineComponent({
  name: "Dropdown",
  inheritAttrs: false,
  props: ge$d,
  setup(t3) {
    const w3 = ref$1(false), c3 = d$1S(toRef$1(t3, "show"), w3), d3 = computed(() => {
      const {
        keyField: e28,
        childrenField: i
      } = t3;
      return U$s(t3.options, {
        getKey(n3) {
          return n3[e28];
        },
        getDisabled(n3) {
          return n3.disabled === true;
        },
        getIgnored(n3) {
          return n3.type === "divider" || n3.type === "render";
        },
        getChildren(n3) {
          return n3[i];
        }
      });
    }), u3 = computed(() => d3.value.treeNodes), v3 = ref$1(null), m3 = ref$1(null), y3 = ref$1(null), f3 = computed(() => {
      var e28, i, n3;
      return (n3 = (i = (e28 = v3.value) !== null && e28 !== void 0 ? e28 : m3.value) !== null && i !== void 0 ? i : y3.value) !== null && n3 !== void 0 ? n3 : null;
    }), b3 = computed(() => d3.value.getPath(f3.value).keyPath), x3 = computed(() => d3.value.getPath(t3.value).keyPath), K3 = n$1U(() => t3.keyboard && c3.value);
    B$x({
      keydown: {
        ArrowUp: {
          prevent: true,
          handler: W3
        },
        ArrowRight: {
          prevent: true,
          handler: U3
        },
        ArrowDown: {
          prevent: true,
          handler: _3
        },
        ArrowLeft: {
          prevent: true,
          handler: H3
        },
        Enter: {
          prevent: true,
          handler: j3
        },
        Escape: D3
      }
    }, K3);
    const {
      mergedClsPrefixRef: P3,
      inlineThemeDisabled: C3
    } = a$2x(t3), A3 = _$F("Dropdown", "-dropdown", l$1b, w$z, t3, P3);
    provide(d$1a, {
      labelFieldRef: toRef$1(t3, "labelField"),
      childrenFieldRef: toRef$1(t3, "childrenField"),
      renderLabelRef: toRef$1(t3, "renderLabel"),
      renderIconRef: toRef$1(t3, "renderIcon"),
      hoverKeyRef: v3,
      keyboardKeyRef: m3,
      lastToggledSubmenuKeyRef: y3,
      pendingKeyPathRef: b3,
      activeKeyPathRef: x3,
      animatedRef: toRef$1(t3, "animated"),
      mergedShowRef: c3,
      nodePropsRef: toRef$1(t3, "nodeProps"),
      renderOptionRef: toRef$1(t3, "renderOption"),
      menuPropsRef: toRef$1(t3, "menuProps"),
      doSelect: k3,
      doUpdateShow: S3
    }), watch(c3, (e28) => {
      !t3.animated && !e28 && T3();
    });
    function k3(e28, i) {
      const {
        onSelect: n3
      } = t3;
      n3 && i$1Z(n3, e28, i);
    }
    function S3(e28) {
      const {
        "onUpdate:show": i,
        onUpdateShow: n3
      } = t3;
      i && i$1Z(i, e28), n3 && i$1Z(n3, e28), w3.value = e28;
    }
    function T3() {
      v3.value = null, m3.value = null, y3.value = null;
    }
    function D3() {
      S3(false);
    }
    function H3() {
      R3("left");
    }
    function U3() {
      R3("right");
    }
    function W3() {
      R3("up");
    }
    function _3() {
      R3("down");
    }
    function j3() {
      const e28 = F3();
      e28 != null && e28.isLeaf && c3.value && (k3(e28.key, e28.rawNode), S3(false));
    }
    function F3() {
      var e28;
      const {
        value: i
      } = d3, {
        value: n3
      } = f3;
      return !i || n3 === null ? null : (e28 = i.getNode(n3)) !== null && e28 !== void 0 ? e28 : null;
    }
    function R3(e28) {
      const {
        value: i
      } = f3, {
        value: {
          getFirstAvailableNode: n3
        }
      } = d3;
      let o3 = null;
      if (i === null) {
        const l3 = n3();
        l3 !== null && (o3 = l3.key);
      } else {
        const l3 = F3();
        if (l3) {
          let s3;
          switch (e28) {
            case "down":
              s3 = l3.getNext();
              break;
            case "up":
              s3 = l3.getPrev();
              break;
            case "right":
              s3 = l3.getChild();
              break;
            case "left":
              s3 = l3.getParent();
              break;
          }
          s3 && (o3 = s3.key);
        }
      }
      o3 !== null && (v3.value = null, m3.value = o3);
    }
    const O3 = computed(() => {
      const {
        size: e28,
        inverted: i
      } = t3, {
        common: {
          cubicBezierEaseInOut: n3
        },
        self: o3
      } = A3.value, {
        padding: l3,
        dividerColor: s3,
        borderRadius: E3,
        optionOpacityDisabled: $3,
        [_$H("optionIconSuffixWidth", e28)]: M3,
        [_$H("optionSuffixWidth", e28)]: V10,
        [_$H("optionIconPrefixWidth", e28)]: q3,
        [_$H("optionPrefixWidth", e28)]: G3,
        [_$H("fontSize", e28)]: J3,
        [_$H("optionHeight", e28)]: Q3,
        [_$H("optionIconSize", e28)]: X3
      } = o3, r3 = {
        "--n-bezier": n3,
        "--n-font-size": J3,
        "--n-padding": l3,
        "--n-border-radius": E3,
        "--n-option-height": Q3,
        "--n-option-prefix-width": G3,
        "--n-option-icon-prefix-width": q3,
        "--n-option-suffix-width": V10,
        "--n-option-icon-suffix-width": M3,
        "--n-option-icon-size": X3,
        "--n-divider-color": s3,
        "--n-option-opacity-disabled": $3
      };
      return i ? (r3["--n-color"] = o3.colorInverted, r3["--n-option-color-hover"] = o3.optionColorHoverInverted, r3["--n-option-color-active"] = o3.optionColorActiveInverted, r3["--n-option-text-color"] = o3.optionTextColorInverted, r3["--n-option-text-color-hover"] = o3.optionTextColorHoverInverted, r3["--n-option-text-color-active"] = o3.optionTextColorActiveInverted, r3["--n-option-text-color-child-active"] = o3.optionTextColorChildActiveInverted, r3["--n-prefix-color"] = o3.prefixColorInverted, r3["--n-suffix-color"] = o3.suffixColorInverted, r3["--n-group-header-text-color"] = o3.groupHeaderTextColorInverted) : (r3["--n-color"] = o3.color, r3["--n-option-color-hover"] = o3.optionColorHover, r3["--n-option-color-active"] = o3.optionColorActive, r3["--n-option-text-color"] = o3.optionTextColor, r3["--n-option-text-color-hover"] = o3.optionTextColorHover, r3["--n-option-text-color-active"] = o3.optionTextColorActive, r3["--n-option-text-color-child-active"] = o3.optionTextColorChildActive, r3["--n-prefix-color"] = o3.prefixColor, r3["--n-suffix-color"] = o3.suffixColor, r3["--n-group-header-text-color"] = o3.groupHeaderTextColor), r3;
    }), g3 = C3 ? E$J("dropdown", computed(() => `${t3.size[0]}${t3.inverted ? "i" : ""}`), O3, t3) : void 0;
    return {
      mergedClsPrefix: P3,
      mergedTheme: A3,
      tmNodes: u3,
      mergedShow: c3,
      handleAfterLeave: () => {
        t3.animated && T3();
      },
      doUpdateShow: S3,
      cssVars: C3 ? void 0 : O3,
      themeClass: g3 == null ? void 0 : g3.themeClass,
      onRender: g3 == null ? void 0 : g3.onRender
    };
  },
  render() {
    const t3 = (d3, u3, v3, m3, y3) => {
      var f3;
      const {
        mergedClsPrefix: b3,
        menuProps: x3
      } = this;
      (f3 = this.onRender) === null || f3 === void 0 || f3.call(this);
      const K3 = (x3 == null ? void 0 : x3(void 0, this.tmNodes.map((C3) => C3.rawNode))) || {}, P3 = {
        ref: t$14(u3),
        class: [d3, `${b3}-dropdown`, this.themeClass],
        clsPrefix: b3,
        tmNodes: this.tmNodes,
        style: [...v3, this.cssVars],
        showArrow: this.showArrow,
        arrowStyle: this.arrowStyle,
        scrollable: this.scrollable,
        onMouseenter: m3,
        onMouseleave: y3
      };
      return h$1R(X$i, mergeProps(this.$attrs, P3, K3));
    }, {
      mergedTheme: w3
    } = this, c3 = {
      show: this.mergedShow,
      theme: w3.peers.Popover,
      themeOverrides: w3.peerOverrides.Popover,
      internalOnAfterLeave: this.handleAfterLeave,
      internalRenderBody: t3,
      onUpdateShow: this.doUpdateShow,
      "onUpdate:show": void 0
    };
    return h$1R(Ie$8, Object.assign({}, r$1C(this.$props, me$e), c3), {
      trigger: () => {
        var d3, u3;
        return (u3 = (d3 = this.$slots).default) === null || u3 === void 0 ? void 0 : u3.call(d3);
      }
    });
  }
});
const p$37 = "_n_all__", m$1u = "_n_none__";
function x$s(e28, t3, n3, o3) {
  return e28 ? (l3) => {
    for (const r3 of e28)
      switch (l3) {
        case p$37:
          n3(true);
          return;
        case m$1u:
          o3(true);
          return;
        default:
          if (typeof r3 == "object" && r3.key === l3) {
            r3.onSelect(t3.value);
            return;
          }
      }
  } : () => {
  };
}
function P$L(e28, t3) {
  return e28 ? e28.map((n3) => {
    switch (n3) {
      case "all":
        return {
          label: t3.checkTableAll,
          key: p$37
        };
      case "none":
        return {
          label: t3.uncheckTableAll,
          key: m$1u
        };
      default:
        return n3;
    }
  }) : [];
}
const C$P = defineComponent({
  name: "DataTableSelectionMenu",
  props: {
    clsPrefix: {
      type: String,
      required: true
    }
  },
  setup(e28) {
    const {
      props: t3,
      localeRef: n3,
      checkOptionsRef: o3,
      rawPaginatedDataRef: l3,
      doCheckAll: r3,
      doUncheckAll: v3
    } = inject(r$1d), h3 = computed(() => x$s(o3.value, l3, r3, v3)), _3 = computed(() => P$L(o3.value, n3.value));
    return () => {
      var a3, c3, u3, i;
      const {
        clsPrefix: s3
      } = e28;
      return h$1R(Le$6, {
        theme: (c3 = (a3 = t3.theme) === null || a3 === void 0 ? void 0 : a3.peers) === null || c3 === void 0 ? void 0 : c3.Dropdown,
        themeOverrides: (i = (u3 = t3.themeOverrides) === null || u3 === void 0 ? void 0 : u3.peers) === null || i === void 0 ? void 0 : i.Dropdown,
        options: _3.value,
        onSelect: h3.value
      }, {
        default: () => h$1R(d$1R, {
          clsPrefix: s3,
          class: `${s3}-data-table-check-extra`
        }, {
          default: () => h$1R(r$1A, null)
        })
      });
    };
  }
});
function P$K(d3) {
  return typeof d3.title == "function" ? d3.title(d3) : d3.title;
}
const ue$f = defineComponent({
  name: "DataTableHeader",
  props: {
    discrete: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const {
      mergedClsPrefixRef: d3,
      scrollXRef: a3,
      fixedColumnLeftMapRef: f3,
      fixedColumnRightMapRef: c3,
      mergedCurrentPageRef: k3,
      allRowsCheckedRef: p3,
      someRowsCheckedRef: y3,
      rowsRef: x3,
      colsRef: S3,
      mergedThemeRef: b3,
      checkOptionsRef: v3,
      mergedSortStateRef: m3,
      componentId: w3,
      mergedTableLayoutRef: T3,
      headerCheckboxDisabledRef: $3,
      onUnstableColumnResize: z3,
      doUpdateResizableWidth: M3,
      handleTableHeaderScroll: L3,
      deriveNextSorter: W3,
      doUncheckAll: _3,
      doCheckAll: C3
    } = inject(r$1d), u3 = ref$1({});
    function R3(l3) {
      const r3 = u3.value[l3];
      return r3 == null ? void 0 : r3.getBoundingClientRect().width;
    }
    function s3() {
      p3.value ? _3() : C3();
    }
    function e28(l3, r3) {
      if (a$2j(l3, "dataTableFilter") || a$2j(l3, "dataTableResizable") || !W$m(r3))
        return;
      const i = m3.value.find((n3) => n3.columnKey === r3.key) || null, o3 = j$l(r3, i);
      W3(o3);
    }
    const g3 = /* @__PURE__ */ new Map();
    function F3(l3) {
      g3.set(l3.key, R3(l3.key));
    }
    function N3(l3, r3) {
      const i = g3.get(l3.key);
      if (i === void 0)
        return;
      const o3 = i + r3, n3 = w$A(o3, l3.minWidth, l3.maxWidth);
      z3(o3, n3, l3, R3), M3(l3, n3);
    }
    return {
      cellElsRef: u3,
      componentId: w3,
      mergedSortState: m3,
      mergedClsPrefix: d3,
      scrollX: a3,
      fixedColumnLeftMap: f3,
      fixedColumnRightMap: c3,
      currentPage: k3,
      allRowsChecked: p3,
      someRowsChecked: y3,
      rows: x3,
      cols: S3,
      mergedTheme: b3,
      checkOptions: v3,
      mergedTableLayout: T3,
      headerCheckboxDisabled: $3,
      handleCheckboxUpdateChecked: s3,
      handleColHeaderClick: e28,
      handleTableHeaderScroll: L3,
      handleColumnResizeStart: F3,
      handleColumnResize: N3
    };
  },
  render() {
    const {
      cellElsRef: d3,
      mergedClsPrefix: a3,
      fixedColumnLeftMap: f3,
      fixedColumnRightMap: c3,
      currentPage: k3,
      allRowsChecked: p3,
      someRowsChecked: y3,
      rows: x3,
      cols: S3,
      mergedTheme: b3,
      checkOptions: v3,
      componentId: m3,
      discrete: w3,
      mergedTableLayout: T3,
      headerCheckboxDisabled: $3,
      mergedSortState: z3,
      handleColHeaderClick: M3,
      handleCheckboxUpdateChecked: L3,
      handleColumnResizeStart: W3,
      handleColumnResize: _3
    } = this, C3 = h$1R("thead", {
      class: `${a3}-data-table-thead`,
      "data-n-id": m3
    }, x3.map((s3) => h$1R("tr", {
      class: `${a3}-data-table-tr`
    }, s3.map(({
      column: e28,
      colSpan: g3,
      rowSpan: F3,
      isLast: N3
    }) => {
      var l3, r3;
      const i = C$Q(e28), {
        ellipsis: o3
      } = e28, n3 = () => e28.type === "selection" ? e28.multiple !== false ? h$1R(Fragment, null, h$1R(Pe$a, {
        key: k3,
        privateInsideTable: true,
        checked: p3,
        indeterminate: y3,
        disabled: $3,
        onUpdateChecked: L3
      }), v3 ? h$1R(C$P, {
        clsPrefix: a3
      }) : null) : null : h$1R(Fragment, null, h$1R("div", {
        class: `${a3}-data-table-th__title-wrapper`
      }, h$1R("div", {
        class: `${a3}-data-table-th__title`
      }, o3 === true || o3 && !o3.tooltip ? h$1R("div", {
        class: `${a3}-data-table-th__ellipsis`
      }, P$K(e28)) : o3 && typeof o3 == "object" ? h$1R(q$u, Object.assign({}, o3, {
        theme: b3.peers.Ellipsis,
        themeOverrides: b3.peerOverrides.Ellipsis
      }), {
        default: () => P$K(e28)
      }) : P$K(e28)), W$m(e28) ? h$1R(O$t, {
        column: e28
      }) : null), k$D(e28) ? h$1R(q$p, {
        column: e28,
        options: e28.filterOptions
      }) : null, F$p(e28) ? h$1R(g$S, {
        onResizeStart: () => {
          W3(e28);
        },
        onResize: (h3) => {
          _3(e28, h3);
        }
      }) : null), A3 = i in f3, I3 = i in c3;
      return h$1R("th", {
        ref: (h3) => d3[i] = h3,
        key: i,
        style: {
          textAlign: e28.titleAlign || e28.align,
          left: o$1f((l3 = f3[i]) === null || l3 === void 0 ? void 0 : l3.start),
          right: o$1f((r3 = c3[i]) === null || r3 === void 0 ? void 0 : r3.start)
        },
        colspan: g3,
        rowspan: F3,
        "data-col-key": i,
        class: [`${a3}-data-table-th`, (A3 || I3) && `${a3}-data-table-th--fixed-${A3 ? "left" : "right"}`, {
          [`${a3}-data-table-th--hover`]: I$x(e28, z3),
          [`${a3}-data-table-th--filterable`]: k$D(e28),
          [`${a3}-data-table-th--sortable`]: W$m(e28),
          [`${a3}-data-table-th--selection`]: e28.type === "selection",
          [`${a3}-data-table-th--last`]: N3
        }, e28.className],
        onClick: e28.type !== "selection" && e28.type !== "expand" && !("children" in e28) ? (h3) => {
          M3(h3, e28);
        } : void 0
      }, n3());
    }))));
    if (!w3)
      return C3;
    const {
      handleTableHeaderScroll: u3,
      scrollX: R3
    } = this;
    return h$1R("div", {
      class: `${a3}-data-table-base-table-header`,
      onScroll: u3
    }, h$1R("table", {
      ref: "body",
      class: `${a3}-data-table-table`,
      style: {
        minWidth: o$1z(R3),
        tableLayout: T3
      }
    }, h$1R("colgroup", null, S3.map((s3) => h$1R("col", {
      key: s3.key,
      style: s3.style
    }))), C3));
  }
});
const v$J = defineComponent({
  name: "DataTableCell",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    row: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    column: {
      type: Object,
      required: true
    },
    isSummary: Boolean,
    mergedTheme: {
      type: Object,
      required: true
    },
    renderCell: Function
  },
  render() {
    var s3;
    const {
      isSummary: p3,
      column: l3,
      row: r3,
      renderCell: m3
    } = this;
    let e28;
    const {
      render: d3,
      key: n3,
      ellipsis: i
    } = l3;
    if (d3 && !p3 ? e28 = d3(r3, this.index) : p3 ? e28 = (s3 = r3[n3]) === null || s3 === void 0 ? void 0 : s3.value : e28 = m3 ? m3(f$1p(r3, n3), r3, l3) : f$1p(r3, n3), i)
      if (typeof i == "object") {
        const {
          mergedTheme: t3
        } = this;
        return l3.ellipsisComponent === "performant-ellipsis" ? h$1R(y$U, Object.assign({}, i, {
          theme: t3.peers.Ellipsis,
          themeOverrides: t3.peerOverrides.Ellipsis
        }), {
          default: () => e28
        }) : h$1R(q$u, Object.assign({}, i, {
          theme: t3.peers.Ellipsis,
          themeOverrides: t3.peerOverrides.Ellipsis
        }), {
          default: () => e28
        });
      } else
        return h$1R("span", {
          class: `${this.clsPrefix}-data-table-td__ellipsis`
        }, e28);
    return e28;
  }
});
const u$1c = defineComponent({
  name: "DataTableExpandTrigger",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    expanded: Boolean,
    loading: Boolean,
    onClick: {
      type: Function,
      required: true
    },
    renderExpandIcon: {
      type: Function
    }
  },
  render() {
    const {
      clsPrefix: n3
    } = this;
    return h$1R("div", {
      class: [`${n3}-data-table-expand-trigger`, this.expanded && `${n3}-data-table-expand-trigger--expanded`],
      onClick: this.onClick,
      onMousedown: (r3) => {
        r3.preventDefault();
      }
    }, h$1R(m$21, null, {
      default: () => this.loading ? h$1R(h$1A, {
        key: "loading",
        clsPrefix: this.clsPrefix,
        radius: 85,
        strokeWidth: 15,
        scale: 0.88
      }) : this.renderExpandIcon ? this.renderExpandIcon({
        expanded: this.expanded
      }) : h$1R(d$1R, {
        clsPrefix: n3,
        key: "base-icon"
      }, {
        default: () => h$1R(r$1U, null)
      })
    }));
  }
});
const p$36 = defineComponent({
  name: "DataTableBodyCheckbox",
  props: {
    rowKey: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    onUpdateChecked: {
      type: Function,
      required: true
    }
  },
  setup(e28) {
    const {
      mergedCheckedRowKeySetRef: r3,
      mergedInderminateRowKeySetRef: d3
    } = inject(r$1d);
    return () => {
      const {
        rowKey: t3
      } = e28;
      return h$1R(Pe$a, {
        privateInsideTable: true,
        disabled: e28.disabled,
        indeterminate: d3.value.has(t3),
        checked: r3.value.has(t3),
        onUpdateChecked: e28.onUpdateChecked
      });
    };
  }
});
const l$1a = defineComponent({
  name: "DataTableBodyRadio",
  props: {
    rowKey: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    onUpdateChecked: {
      type: Function,
      required: true
    }
  },
  setup(e28) {
    const {
      mergedCheckedRowKeySetRef: t3,
      componentId: d3
    } = inject(r$1d);
    return () => {
      const {
        rowKey: o3
      } = e28;
      return h$1R(Y$l, {
        name: d3,
        disabled: e28.disabled,
        checked: t3.value.has(o3),
        onUpdateChecked: e28.onUpdateChecked
      });
    };
  }
});
function ot$8(v3, b3) {
  const l3 = [];
  function c3(m3, u3) {
    m3.forEach((x3) => {
      x3.children && b3.has(x3.key) ? (l3.push({
        tmNode: x3,
        striped: false,
        key: x3.key,
        index: u3
      }), c3(x3.children, u3)) : l3.push({
        key: x3.key,
        tmNode: x3,
        striped: false,
        index: u3
      });
    });
  }
  return v3.forEach((m3) => {
    l3.push(m3);
    const {
      children: u3
    } = m3.tmNode;
    u3 && b3.has(m3.key) && c3(u3, m3.index);
  }), l3;
}
const rt$8 = defineComponent({
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    cols: {
      type: Array,
      required: true
    },
    onMouseenter: Function,
    onMouseleave: Function
  },
  render() {
    const {
      clsPrefix: v3,
      id: b3,
      cols: l3,
      onMouseenter: c3,
      onMouseleave: m3
    } = this;
    return h$1R("table", {
      style: {
        tableLayout: "fixed"
      },
      class: `${v3}-data-table-table`,
      onMouseenter: c3,
      onMouseleave: m3
    }, h$1R("colgroup", null, l3.map((u3) => h$1R("col", {
      key: u3.key,
      style: u3.style
    }))), h$1R("tbody", {
      "data-n-id": b3,
      class: `${v3}-data-table-tbody`
    }, this.$slots));
  }
}), Et$8 = defineComponent({
  name: "DataTableBody",
  props: {
    onResize: Function,
    showHeader: Boolean,
    flexHeight: Boolean,
    bodyStyle: Object
  },
  setup(v3) {
    const {
      slots: b3,
      bodyWidthRef: l3,
      mergedExpandedRowKeysRef: c3,
      mergedClsPrefixRef: m3,
      mergedThemeRef: u3,
      scrollXRef: x3,
      colsRef: ye2,
      paginatedDataRef: P3,
      rawPaginatedDataRef: pe2,
      fixedColumnLeftMapRef: Z3,
      fixedColumnRightMapRef: I3,
      mergedCurrentPageRef: he2,
      rowClassNameRef: W3,
      leftActiveFixedColKeyRef: ee2,
      leftActiveFixedChildrenColKeysRef: g3,
      rightActiveFixedColKeyRef: q3,
      rightActiveFixedChildrenColKeysRef: O3,
      renderExpandRef: ve2,
      hoverKeyRef: te2,
      summaryRef: be2,
      mergedSortStateRef: xe2,
      virtualScrollRef: D3,
      componentId: $3,
      mergedTableLayoutRef: ge2,
      childTriggerColIndexRef: X3,
      indentRef: ae2,
      rowPropsRef: le2,
      maxHeightRef: Re2,
      stripedRef: ne2,
      loadingRef: oe2,
      onLoadRef: G3,
      loadingKeySetRef: E3,
      expandableRef: re2,
      stickyExpandedRowsRef: Se2,
      renderExpandIconRef: Ce2,
      summaryPlacementRef: de2,
      treeMateRef: se2,
      scrollbarPropsRef: F3,
      setHeaderScrollLeft: J3,
      doUpdateExpandedRowKeys: N3,
      handleTableBodyScroll: T3,
      doCheck: Q3,
      doUncheck: K3,
      renderCell: ie2
    } = inject(r$1d), L3 = ref$1(null), M3 = ref$1(null), ce2 = ref$1(null), z3 = n$1U(() => P3.value.length === 0), n3 = n$1U(() => v3.showHeader || !z3.value), r3 = n$1U(() => v3.showHeader || z3.value);
    let _3 = "";
    const y3 = computed(() => new Set(c3.value));
    function f3(e28) {
      var a3;
      return (a3 = se2.value.getNode(e28)) === null || a3 === void 0 ? void 0 : a3.rawNode;
    }
    function ke2(e28, a3, d3) {
      const t3 = f3(e28.key);
      if (!t3) {
        s$2a("data-table", `fail to get row data with key ${e28.key}`);
        return;
      }
      if (d3) {
        const s3 = P3.value.findIndex((p3) => p3.key === _3);
        if (s3 !== -1) {
          const p3 = P3.value.findIndex((V10) => V10.key === e28.key), B3 = Math.min(s3, p3), R3 = Math.max(s3, p3), w3 = [];
          P3.value.slice(B3, R3 + 1).forEach((V10) => {
            V10.disabled || w3.push(V10.key);
          }), a3 ? Q3(w3, false, t3) : K3(w3, t3), _3 = e28.key;
          return;
        }
      }
      a3 ? Q3(e28.key, false, t3) : K3(e28.key, t3), _3 = e28.key;
    }
    function we2(e28) {
      const a3 = f3(e28.key);
      if (!a3) {
        s$2a("data-table", `fail to get row data with key ${e28.key}`);
        return;
      }
      Q3(e28.key, true, a3);
    }
    function C3() {
      if (!n3.value) {
        const {
          value: a3
        } = ce2;
        return a3 || null;
      }
      if (D3.value)
        return ue2();
      const {
        value: e28
      } = L3;
      return e28 ? e28.containerRef : null;
    }
    function k3(e28, a3) {
      var d3;
      if (E3.value.has(e28))
        return;
      const {
        value: t3
      } = c3, s3 = t3.indexOf(e28), p3 = Array.from(t3);
      ~s3 ? (p3.splice(s3, 1), N3(p3)) : a3 && !a3.isLeaf && !a3.shallowLoaded ? (E3.value.add(e28), (d3 = G3.value) === null || d3 === void 0 || d3.call(G3, a3.rawNode).then(() => {
        const {
          value: B3
        } = c3, R3 = Array.from(B3);
        ~R3.indexOf(e28) || R3.push(e28), N3(R3);
      }).finally(() => {
        E3.value.delete(e28);
      })) : (p3.push(e28), N3(p3));
    }
    function Y3() {
      te2.value = null;
    }
    function ue2() {
      const {
        value: e28
      } = M3;
      return (e28 == null ? void 0 : e28.listElRef) || null;
    }
    function $e2() {
      const {
        value: e28
      } = M3;
      return (e28 == null ? void 0 : e28.itemsElRef) || null;
    }
    function Pe2(e28) {
      var a3;
      T3(e28), (a3 = L3.value) === null || a3 === void 0 || a3.sync();
    }
    function H3(e28) {
      var a3;
      const {
        onResize: d3
      } = v3;
      d3 && d3(e28), (a3 = L3.value) === null || a3 === void 0 || a3.sync();
    }
    const i = {
      getScrollContainer: C3,
      scrollTo(e28, a3) {
        var d3, t3;
        D3.value ? (d3 = M3.value) === null || d3 === void 0 || d3.scrollTo(e28, a3) : (t3 = L3.value) === null || t3 === void 0 || t3.scrollTo(e28, a3);
      }
    }, U3 = r$2a([({
      props: e28
    }) => {
      const a3 = (t3) => t3 === null ? null : r$2a(`[data-n-id="${e28.componentId}"] [data-col-key="${t3}"]::after`, {
        boxShadow: "var(--n-box-shadow-after)"
      }), d3 = (t3) => t3 === null ? null : r$2a(`[data-n-id="${e28.componentId}"] [data-col-key="${t3}"]::before`, {
        boxShadow: "var(--n-box-shadow-before)"
      });
      return r$2a([a3(e28.leftActiveFixedColKey), d3(e28.rightActiveFixedColKey), e28.leftActiveFixedChildrenColKeys.map((t3) => a3(t3)), e28.rightActiveFixedChildrenColKeys.map((t3) => d3(t3))]);
    }]);
    let j3 = false;
    return watchEffect(() => {
      const {
        value: e28
      } = ee2, {
        value: a3
      } = g3, {
        value: d3
      } = q3, {
        value: t3
      } = O3;
      if (!j3 && e28 === null && d3 === null)
        return;
      const s3 = {
        leftActiveFixedColKey: e28,
        leftActiveFixedChildrenColKeys: a3,
        rightActiveFixedColKey: d3,
        rightActiveFixedChildrenColKeys: t3,
        componentId: $3
      };
      U3.mount({
        id: `n-${$3}`,
        force: true,
        props: s3,
        anchorMetaName: e$2b
      }), j3 = true;
    }), onUnmounted(() => {
      U3.unmount({
        id: `n-${$3}`
      });
    }), Object.assign({
      bodyWidth: l3,
      summaryPlacement: de2,
      dataTableSlots: b3,
      componentId: $3,
      scrollbarInstRef: L3,
      virtualListRef: M3,
      emptyElRef: ce2,
      summary: be2,
      mergedClsPrefix: m3,
      mergedTheme: u3,
      scrollX: x3,
      cols: ye2,
      loading: oe2,
      bodyShowHeaderOnly: r3,
      shouldDisplaySomeTablePart: n3,
      empty: z3,
      paginatedDataAndInfo: computed(() => {
        const {
          value: e28
        } = ne2;
        let a3 = false;
        return {
          data: P3.value.map(e28 ? (t3, s3) => (t3.isLeaf || (a3 = true), {
            tmNode: t3,
            key: t3.key,
            striped: s3 % 2 === 1,
            index: s3
          }) : (t3, s3) => (t3.isLeaf || (a3 = true), {
            tmNode: t3,
            key: t3.key,
            striped: false,
            index: s3
          })),
          hasChildren: a3
        };
      }),
      rawPaginatedData: pe2,
      fixedColumnLeftMap: Z3,
      fixedColumnRightMap: I3,
      currentPage: he2,
      rowClassName: W3,
      renderExpand: ve2,
      mergedExpandedRowKeySet: y3,
      hoverKey: te2,
      mergedSortState: xe2,
      virtualScroll: D3,
      mergedTableLayout: ge2,
      childTriggerColIndex: X3,
      indent: ae2,
      rowProps: le2,
      maxHeight: Re2,
      loadingKeySet: E3,
      expandable: re2,
      stickyExpandedRows: Se2,
      renderExpandIcon: Ce2,
      scrollbarProps: F3,
      setHeaderScrollLeft: J3,
      handleVirtualListScroll: Pe2,
      handleVirtualListResize: H3,
      handleMouseleaveTable: Y3,
      virtualListContainer: ue2,
      virtualListContent: $e2,
      handleTableBodyScroll: T3,
      handleCheckboxUpdateChecked: ke2,
      handleRadioUpdateChecked: we2,
      handleUpdateExpanded: k3,
      renderCell: ie2
    }, i);
  },
  render() {
    const {
      mergedTheme: v3,
      scrollX: b3,
      mergedClsPrefix: l3,
      virtualScroll: c3,
      maxHeight: m3,
      mergedTableLayout: u3,
      flexHeight: x3,
      loadingKeySet: ye2,
      onResize: P3,
      setHeaderScrollLeft: pe2
    } = this, Z3 = b3 !== void 0 || m3 !== void 0 || x3, I3 = !Z3 && u3 === "auto", he2 = b3 !== void 0 || I3, W3 = {
      minWidth: o$1z(b3) || "100%"
    };
    b3 && (W3.width = "100%");
    const ee2 = h$1R(hn$2, Object.assign({}, this.scrollbarProps, {
      ref: "scrollbarInstRef",
      scrollable: Z3 || I3,
      class: `${l3}-data-table-base-table-body`,
      style: this.empty ? void 0 : this.bodyStyle,
      theme: v3.peers.Scrollbar,
      themeOverrides: v3.peerOverrides.Scrollbar,
      contentStyle: W3,
      container: c3 ? this.virtualListContainer : void 0,
      content: c3 ? this.virtualListContent : void 0,
      horizontalRailStyle: {
        zIndex: 3
      },
      verticalRailStyle: {
        zIndex: 3
      },
      xScrollable: he2,
      onScroll: c3 ? void 0 : this.handleTableBodyScroll,
      internalOnUpdateScrollLeft: pe2,
      onResize: P3
    }), {
      default: () => {
        const g3 = {}, q3 = {}, {
          cols: O3,
          paginatedDataAndInfo: ve2,
          mergedTheme: te2,
          fixedColumnLeftMap: be2,
          fixedColumnRightMap: xe2,
          currentPage: D3,
          rowClassName: $3,
          mergedSortState: ge2,
          mergedExpandedRowKeySet: X3,
          stickyExpandedRows: ae2,
          componentId: le2,
          childTriggerColIndex: Re2,
          expandable: ne2,
          rowProps: oe2,
          handleMouseleaveTable: G3,
          renderExpand: E3,
          summary: re2,
          handleCheckboxUpdateChecked: Se2,
          handleRadioUpdateChecked: Ce2,
          handleUpdateExpanded: de2
        } = this, {
          length: se2
        } = O3;
        let F3;
        const {
          data: J3,
          hasChildren: N3
        } = ve2, T3 = N3 ? ot$8(J3, X3) : J3;
        if (re2) {
          const n3 = re2(this.rawPaginatedData);
          if (Array.isArray(n3)) {
            const r3 = n3.map((_3, y3) => ({
              isSummaryRow: true,
              key: `__n_summary__${y3}`,
              tmNode: {
                rawNode: _3,
                disabled: true
              },
              index: -1
            }));
            F3 = this.summaryPlacement === "top" ? [...r3, ...T3] : [...T3, ...r3];
          } else {
            const r3 = {
              isSummaryRow: true,
              key: "__n_summary__",
              tmNode: {
                rawNode: n3,
                disabled: true
              },
              index: -1
            };
            F3 = this.summaryPlacement === "top" ? [r3, ...T3] : [...T3, r3];
          }
        } else
          F3 = T3;
        const Q3 = N3 ? {
          width: o$1f(this.indent)
        } : void 0, K3 = [];
        F3.forEach((n3) => {
          E3 && X3.has(n3.key) && (!ne2 || ne2(n3.tmNode.rawNode)) ? K3.push(n3, {
            isExpandedRow: true,
            key: `${n3.key}-expand`,
            tmNode: n3.tmNode,
            index: n3.index
          }) : K3.push(n3);
        });
        const {
          length: ie2
        } = K3, L3 = {};
        J3.forEach(({
          tmNode: n3
        }, r3) => {
          L3[r3] = n3.key;
        });
        const M3 = ae2 ? this.bodyWidth : null, ce2 = M3 === null ? void 0 : `${M3}px`, z3 = (n3, r3, _3) => {
          const {
            index: y3
          } = n3;
          if ("isExpandedRow" in n3) {
            const {
              tmNode: {
                key: H3,
                rawNode: i
              }
            } = n3;
            return h$1R("tr", {
              class: `${l3}-data-table-tr ${l3}-data-table-tr--expanded`,
              key: `${H3}__expand`
            }, h$1R("td", {
              class: [`${l3}-data-table-td`, `${l3}-data-table-td--last-col`, r3 + 1 === ie2 && `${l3}-data-table-td--last-row`],
              colspan: se2
            }, ae2 ? h$1R("div", {
              class: `${l3}-data-table-expand`,
              style: {
                width: ce2
              }
            }, E3(i, y3)) : E3(i, y3)));
          }
          const f3 = "isSummaryRow" in n3, ke2 = !f3 && n3.striped, {
            tmNode: we2,
            key: C3
          } = n3, {
            rawNode: k3
          } = we2, Y3 = X3.has(C3), ue2 = oe2 ? oe2(k3, y3) : void 0, $e2 = typeof $3 == "string" ? $3 : b$M(k3, y3, $3);
          return h$1R("tr", Object.assign({
            onMouseenter: () => {
              this.hoverKey = C3;
            },
            key: C3,
            class: [`${l3}-data-table-tr`, f3 && `${l3}-data-table-tr--summary`, ke2 && `${l3}-data-table-tr--striped`, Y3 && `${l3}-data-table-tr--expanded`, $e2]
          }, ue2), O3.map((H3, i) => {
            var U3, j3, e28, a3, d3;
            if (r3 in g3) {
              const h3 = g3[r3], S3 = h3.indexOf(i);
              if (~S3)
                return h3.splice(S3, 1), null;
            }
            const {
              column: t3
            } = H3, s3 = C$Q(H3), {
              rowSpan: p3,
              colSpan: B3
            } = t3, R3 = f3 ? ((U3 = n3.tmNode.rawNode[s3]) === null || U3 === void 0 ? void 0 : U3.colSpan) || 1 : B3 ? B3(k3, y3) : 1, w3 = f3 ? ((j3 = n3.tmNode.rawNode[s3]) === null || j3 === void 0 ? void 0 : j3.rowSpan) || 1 : p3 ? p3(k3, y3) : 1, V10 = i + R3 === se2, Fe2 = r3 + w3 === ie2, fe2 = w3 > 1;
            if (fe2 && (q3[r3] = {
              [i]: []
            }), R3 > 1 || fe2)
              for (let h3 = r3; h3 < r3 + w3; ++h3) {
                fe2 && q3[r3][i].push(L3[h3]);
                for (let S3 = i; S3 < i + R3; ++S3)
                  h3 === r3 && S3 === i || (h3 in g3 ? g3[h3].push(S3) : g3[h3] = [S3]);
              }
            const Ne2 = fe2 ? this.hoverKey : null, {
              cellProps: Ee2
            } = t3, A3 = Ee2 == null ? void 0 : Ee2(k3, y3), Me2 = {
              "--indent-offset": ""
            };
            return h$1R("td", Object.assign({}, A3, {
              key: s3,
              style: [{
                textAlign: t3.align || void 0,
                left: o$1f((e28 = be2[s3]) === null || e28 === void 0 ? void 0 : e28.start),
                right: o$1f((a3 = xe2[s3]) === null || a3 === void 0 ? void 0 : a3.start)
              }, Me2, (A3 == null ? void 0 : A3.style) || ""],
              colspan: R3,
              rowspan: _3 ? void 0 : w3,
              "data-col-key": s3,
              class: [`${l3}-data-table-td`, t3.className, A3 == null ? void 0 : A3.class, f3 && `${l3}-data-table-td--summary`, (Ne2 !== null && q3[r3][i].includes(Ne2) || I$x(t3, ge2)) && `${l3}-data-table-td--hover`, t3.fixed && `${l3}-data-table-td--fixed-${t3.fixed}`, t3.align && `${l3}-data-table-td--${t3.align}-align`, t3.type === "selection" && `${l3}-data-table-td--selection`, t3.type === "expand" && `${l3}-data-table-td--expand`, V10 && `${l3}-data-table-td--last-col`, Fe2 && `${l3}-data-table-td--last-row`]
            }), N3 && i === Re2 ? [o$1G(Me2["--indent-offset"] = f3 ? 0 : n3.tmNode.level, h$1R("div", {
              class: `${l3}-data-table-indent`,
              style: Q3
            })), f3 || n3.tmNode.isLeaf ? h$1R("div", {
              class: `${l3}-data-table-expand-placeholder`
            }) : h$1R(u$1c, {
              class: `${l3}-data-table-expand-trigger`,
              clsPrefix: l3,
              expanded: Y3,
              renderExpandIcon: this.renderExpandIcon,
              loading: ye2.has(n3.key),
              onClick: () => {
                de2(C3, n3.tmNode);
              }
            })] : null, t3.type === "selection" ? f3 ? null : t3.multiple === false ? h$1R(l$1a, {
              key: D3,
              rowKey: C3,
              disabled: n3.tmNode.disabled,
              onUpdateChecked: () => {
                Ce2(n3.tmNode);
              }
            }) : h$1R(p$36, {
              key: D3,
              rowKey: C3,
              disabled: n3.tmNode.disabled,
              onUpdateChecked: (h3, S3) => {
                Se2(n3.tmNode, h3, S3.shiftKey);
              }
            }) : t3.type === "expand" ? f3 ? null : !t3.expandable || !((d3 = t3.expandable) === null || d3 === void 0) && d3.call(t3, k3) ? h$1R(u$1c, {
              clsPrefix: l3,
              expanded: Y3,
              renderExpandIcon: this.renderExpandIcon,
              onClick: () => {
                de2(C3, null);
              }
            }) : null : h$1R(v$J, {
              clsPrefix: l3,
              index: y3,
              row: k3,
              column: t3,
              isSummary: f3,
              mergedTheme: te2,
              renderCell: this.renderCell
            }));
          }));
        };
        return c3 ? h$1R(ve$c, {
          ref: "virtualListRef",
          items: K3,
          itemSize: 28,
          visibleItemsTag: rt$8,
          visibleItemsProps: {
            clsPrefix: l3,
            id: le2,
            cols: O3,
            onMouseleave: G3
          },
          showScrollbar: false,
          onResize: this.handleVirtualListResize,
          onScroll: this.handleVirtualListScroll,
          itemsStyle: W3,
          itemResizable: true
        }, {
          default: ({
            item: n3,
            index: r3
          }) => z3(n3, r3, true)
        }) : h$1R("table", {
          class: `${l3}-data-table-table`,
          onMouseleave: G3,
          style: {
            tableLayout: this.mergedTableLayout
          }
        }, h$1R("colgroup", null, O3.map((n3) => h$1R("col", {
          key: n3.key,
          style: n3.style
        }))), this.showHeader ? h$1R(ue$f, {
          discrete: false
        }) : null, this.empty ? null : h$1R("tbody", {
          "data-n-id": le2,
          class: `${l3}-data-table-tbody`
        }, K3.map((n3, r3) => z3(n3, r3, false))));
      }
    });
    if (this.empty) {
      const g3 = () => h$1R("div", {
        class: [`${l3}-data-table-empty`, this.loading && `${l3}-data-table-empty--hide`],
        style: this.bodyStyle,
        ref: "emptyElRef"
      }, p$3H(this.dataTableSlots.empty, () => [h$1R(q$s, {
        theme: this.mergedTheme.peers.Empty,
        themeOverrides: this.mergedTheme.peerOverrides.Empty
      })]));
      return this.shouldDisplaySomeTablePart ? h$1R(Fragment, null, ee2, g3()) : h$1R(x$D, {
        onResize: this.onResize
      }, {
        default: g3
      });
    }
    return ee2;
  }
});
const $$j = defineComponent({
  name: "MainTable",
  setup() {
    const {
      mergedClsPrefixRef: t3,
      rightFixedColumnsRef: i,
      leftFixedColumnsRef: l3,
      bodyWidthRef: n3,
      maxHeightRef: u3,
      minHeightRef: b3,
      flexHeightRef: g3,
      syncScrollState: R3
    } = inject(r$1d), c3 = ref$1(null), s3 = ref$1(null), m3 = ref$1(null), r3 = ref$1(!(l3.value.length || i.value.length)), v3 = computed(() => ({
      maxHeight: o$1z(u3.value),
      minHeight: o$1z(b3.value)
    }));
    function y3(e28) {
      n3.value = e28.contentRect.width, R3(), r3.value || (r3.value = true);
    }
    function x3() {
      const {
        value: e28
      } = c3;
      return e28 ? e28.$el : null;
    }
    function H3() {
      const {
        value: e28
      } = s3;
      return e28 ? e28.getScrollContainer() : null;
    }
    const p3 = {
      getBodyElement: H3,
      getHeaderElement: x3,
      scrollTo(e28, a3) {
        var f3;
        (f3 = s3.value) === null || f3 === void 0 || f3.scrollTo(e28, a3);
      }
    };
    return watchEffect(() => {
      const {
        value: e28
      } = m3;
      if (!e28)
        return;
      const a3 = `${t3.value}-data-table-base-table--transition-disabled`;
      r3.value ? setTimeout(() => {
        e28.classList.remove(a3);
      }, 0) : e28.classList.add(a3);
    }), Object.assign({
      maxHeight: u3,
      mergedClsPrefix: t3,
      selfElRef: m3,
      headerInstRef: c3,
      bodyInstRef: s3,
      bodyStyle: v3,
      flexHeight: g3,
      handleBodyResize: y3
    }, p3);
  },
  render() {
    const {
      mergedClsPrefix: t3,
      maxHeight: i,
      flexHeight: l3
    } = this, n3 = i === void 0 && !l3;
    return h$1R("div", {
      class: `${t3}-data-table-base-table`,
      ref: "selfElRef"
    }, n3 ? null : h$1R(ue$f, {
      ref: "headerInstRef"
    }), h$1R(Et$8, {
      ref: "bodyInstRef",
      bodyStyle: this.bodyStyle,
      showHeader: n3,
      flexHeight: l3,
      onResize: this.handleBodyResize
    }));
  }
});
function M$m(n3, m3) {
  const {
    paginatedDataRef: d3,
    treeMateRef: t3,
    selectionColumnRef: f3
  } = m3, R3 = ref$1(n3.defaultCheckedRowKeys), w3 = computed(() => {
    var e28;
    const {
      checkedRowKeys: a3
    } = n3, c3 = a3 === void 0 ? R3.value : a3;
    return ((e28 = f3.value) === null || e28 === void 0 ? void 0 : e28.multiple) === false ? {
      checkedKeys: c3.slice(0, 1),
      indeterminateKeys: []
    } : t3.value.getCheckedKeys(c3, {
      cascade: n3.cascade,
      allowNotLoaded: n3.allowCheckingNotLoaded
    });
  }), u3 = computed(() => w3.value.checkedKeys), N3 = computed(() => w3.value.indeterminateKeys), C3 = computed(() => new Set(u3.value)), g3 = computed(() => new Set(N3.value)), h3 = computed(() => {
    const {
      value: e28
    } = C3;
    return d3.value.reduce((a3, c3) => {
      const {
        key: o3,
        disabled: r3
      } = c3;
      return a3 + (!r3 && e28.has(o3) ? 1 : 0);
    }, 0);
  }), y3 = computed(() => d3.value.filter((e28) => e28.disabled).length), L3 = computed(() => {
    const {
      length: e28
    } = d3.value, {
      value: a3
    } = g3;
    return h3.value > 0 && h3.value < e28 - y3.value || d3.value.some((c3) => a3.has(c3.key));
  }), b3 = computed(() => {
    const {
      length: e28
    } = d3.value;
    return h3.value !== 0 && h3.value === e28 - y3.value;
  }), S3 = computed(() => d3.value.length === 0);
  function s3(e28, a3, c3) {
    const {
      "onUpdate:checkedRowKeys": o3,
      onUpdateCheckedRowKeys: r3,
      onCheckedRowKeysChange: K3
    } = n3, i = [], {
      value: {
        getNode: _3
      }
    } = t3;
    e28.forEach((x3) => {
      var k3;
      const I3 = (k3 = _3(x3)) === null || k3 === void 0 ? void 0 : k3.rawNode;
      i.push(I3);
    }), o3 && i$1Z(o3, e28, i, {
      row: a3,
      action: c3
    }), r3 && i$1Z(r3, e28, i, {
      row: a3,
      action: c3
    }), K3 && i$1Z(K3, e28, i, {
      row: a3,
      action: c3
    }), R3.value = e28;
  }
  function U3(e28, a3 = false, c3) {
    if (!n3.loading) {
      if (a3) {
        s3(Array.isArray(e28) ? e28.slice(0, 1) : [e28], c3, "check");
        return;
      }
      s3(t3.value.check(e28, u3.value, {
        cascade: n3.cascade,
        allowNotLoaded: n3.allowCheckingNotLoaded
      }).checkedKeys, c3, "check");
    }
  }
  function A3(e28, a3) {
    n3.loading || s3(t3.value.uncheck(e28, u3.value, {
      cascade: n3.cascade,
      allowNotLoaded: n3.allowCheckingNotLoaded
    }).checkedKeys, a3, "uncheck");
  }
  function D3(e28 = false) {
    const {
      value: a3
    } = f3;
    if (!a3 || n3.loading)
      return;
    const c3 = [];
    (e28 ? t3.value.treeNodes : d3.value).forEach((o3) => {
      o3.disabled || c3.push(o3.key);
    }), s3(t3.value.check(c3, u3.value, {
      cascade: true,
      allowNotLoaded: n3.allowCheckingNotLoaded
    }).checkedKeys, void 0, "checkAll");
  }
  function E3(e28 = false) {
    const {
      value: a3
    } = f3;
    if (!a3 || n3.loading)
      return;
    const c3 = [];
    (e28 ? t3.value.treeNodes : d3.value).forEach((o3) => {
      o3.disabled || c3.push(o3.key);
    }), s3(t3.value.uncheck(c3, u3.value, {
      cascade: true,
      allowNotLoaded: n3.allowCheckingNotLoaded
    }).checkedKeys, void 0, "uncheckAll");
  }
  return {
    mergedCheckedRowKeySetRef: C3,
    mergedCheckedRowKeysRef: u3,
    mergedInderminateRowKeySetRef: g3,
    someRowsCheckedRef: L3,
    allRowsCheckedRef: b3,
    headerCheckboxDisabledRef: S3,
    doUpdateCheckedRowKeys: s3,
    doCheckAll: D3,
    doUncheckAll: E3,
    doCheck: U3,
    doUncheck: A3
  };
}
function c$1m(o3) {
  return typeof o3 == "object" && typeof o3.multiple == "number" ? o3.multiple : false;
}
function k$B(o3, l3) {
  return l3 && (o3 === void 0 || o3 === "default" || typeof o3 == "object" && o3.compare === "default") ? w$y(l3) : typeof o3 == "function" ? o3 : o3 && typeof o3 == "object" && o3.compare && o3.compare !== "default" ? o3.compare : false;
}
function w$y(o3) {
  return (l3, d3) => {
    const f3 = l3[o3], i = d3[o3];
    return f3 == null ? i == null ? 0 : -1 : i == null ? 1 : typeof f3 == "number" && typeof i == "number" ? f3 - i : typeof f3 == "string" && typeof i == "string" ? f3.localeCompare(i) : 0;
  };
}
function T$A(o3, {
  dataRelatedColsRef: l3,
  filteredDataRef: d3
}) {
  const f3 = [];
  l3.value.forEach((e28) => {
    var r3;
    e28.sorter !== void 0 && v3(f3, {
      columnKey: e28.key,
      sorter: e28.sorter,
      order: (r3 = e28.defaultSortOrder) !== null && r3 !== void 0 ? r3 : false
    });
  });
  const i = ref$1(f3), a3 = computed(() => {
    const e28 = l3.value.filter((n3) => n3.type !== "selection" && n3.sorter !== void 0 && (n3.sortOrder === "ascend" || n3.sortOrder === "descend" || n3.sortOrder === false)), r3 = e28.filter((n3) => n3.sortOrder !== false);
    if (r3.length)
      return r3.map((n3) => ({
        columnKey: n3.key,
        order: n3.sortOrder,
        sorter: n3.sorter
      }));
    if (e28.length)
      return [];
    const {
      value: t3
    } = i;
    return Array.isArray(t3) ? t3 : t3 ? [t3] : [];
  }), h3 = computed(() => {
    const e28 = a3.value.slice().sort((r3, t3) => {
      const n3 = c$1m(r3.sorter) || 0;
      return (c$1m(t3.sorter) || 0) - n3;
    });
    return e28.length ? d3.value.slice().sort((t3, n3) => {
      let u3 = 0;
      return e28.some((U3) => {
        const {
          columnKey: F3,
          sorter: N3,
          order: S3
        } = U3, g3 = k$B(N3, F3);
        return g3 && S3 && (u3 = g3(t3.rawNode, n3.rawNode), u3 !== 0) ? (u3 = u3 * O$s(S3), true) : false;
      }), u3;
    }) : d3.value;
  });
  function b3(e28) {
    let r3 = a3.value.slice();
    return e28 && c$1m(e28.sorter) !== false ? (r3 = r3.filter((t3) => c$1m(t3.sorter) !== false), v3(r3, e28), r3) : e28 || null;
  }
  function p3(e28) {
    const r3 = b3(e28);
    y3(r3);
  }
  function y3(e28) {
    const {
      "onUpdate:sorter": r3,
      onUpdateSorter: t3,
      onSorterChange: n3
    } = o3;
    r3 && i$1Z(r3, e28), t3 && i$1Z(t3, e28), n3 && i$1Z(n3, e28), i.value = e28;
  }
  function x3(e28, r3 = "ascend") {
    if (!e28)
      m3();
    else {
      const t3 = l3.value.find((u3) => u3.type !== "selection" && u3.type !== "expand" && u3.key === e28);
      if (!(t3 != null && t3.sorter))
        return;
      const n3 = t3.sorter;
      p3({
        columnKey: e28,
        sorter: n3,
        order: r3
      });
    }
  }
  function m3() {
    y3(null);
  }
  function v3(e28, r3) {
    const t3 = e28.findIndex((n3) => (r3 == null ? void 0 : r3.columnKey) && n3.columnKey === r3.columnKey);
    t3 !== void 0 && t3 >= 0 ? e28[t3] = r3 : e28.push(r3);
  }
  return {
    clearSorter: m3,
    sort: x3,
    sortedDataRef: h3,
    mergedSortStateRef: a3,
    deriveNextSorter: p3
  };
}
function ve$a(a3, {
  dataRelatedColsRef: m3
}) {
  const F3 = computed(() => {
    const e28 = (t3) => {
      for (let i = 0; i < t3.length; ++i) {
        const n3 = t3[i];
        if ("children" in n3)
          return e28(n3.children);
        if (n3.type === "selection")
          return n3;
      }
      return null;
    };
    return e28(a3.columns);
  }), P3 = computed(() => {
    const {
      childrenKey: e28
    } = a3;
    return U$s(a3.data, {
      ignoreEmptyChildren: true,
      getKey: a3.rowKey,
      getChildren: (t3) => t3[e28],
      getDisabled: (t3) => {
        var i, n3;
        return !!(!((n3 = (i = F3.value) === null || i === void 0 ? void 0 : i.disabled) === null || n3 === void 0) && n3.call(i, t3));
      }
    });
  }), K3 = n$1U(() => {
    const {
      columns: e28
    } = a3, {
      length: t3
    } = e28;
    let i = null;
    for (let n3 = 0; n3 < t3; ++n3) {
      const r3 = e28[n3];
      if (!r3.type && i === null && (i = n3), "tree" in r3 && r3.tree)
        return n3;
    }
    return i || 0;
  }), u3 = ref$1({}), {
    pagination: h3
  } = a3, O3 = ref$1(h3 && h3.defaultPage || 1), z3 = ref$1(u$1k(h3)), b3 = computed(() => {
    const e28 = m3.value.filter((n3) => n3.filterOptionValues !== void 0 || n3.filterOptionValue !== void 0), t3 = {};
    return e28.forEach((n3) => {
      var r3;
      n3.type === "selection" || n3.type === "expand" || (n3.filterOptionValues === void 0 ? t3[n3.key] = (r3 = n3.filterOptionValue) !== null && r3 !== void 0 ? r3 : null : t3[n3.key] = n3.filterOptionValues);
    }), Object.assign(_$u(u3.value), t3);
  }), S3 = computed(() => {
    const e28 = b3.value, {
      columns: t3
    } = a3;
    function i(f3) {
      return (c3, s3) => !!~String(s3[f3]).indexOf(String(c3));
    }
    const {
      value: {
        treeNodes: n3
      }
    } = P3, r3 = [];
    return t3.forEach((f3) => {
      f3.type === "selection" || f3.type === "expand" || "children" in f3 || r3.push([f3.key, f3]);
    }), n3 ? n3.filter((f3) => {
      const {
        rawNode: c3
      } = f3;
      for (const [s3, g3] of r3) {
        let d3 = e28[s3];
        if (d3 == null || (Array.isArray(d3) || (d3 = [d3]), !d3.length))
          continue;
        const y3 = g3.filter === "default" ? i(s3) : g3.filter;
        if (g3 && typeof y3 == "function")
          if (g3.filterMode === "and") {
            if (d3.some((R3) => !y3(R3, c3)))
              return false;
          } else {
            if (d3.some((R3) => y3(R3, c3)))
              continue;
            return false;
          }
      }
      return true;
    }) : [];
  }), {
    sortedDataRef: _3,
    deriveNextSorter: I3,
    mergedSortStateRef: T3,
    sort: A3,
    clearSorter: W3
  } = T$A(a3, {
    dataRelatedColsRef: m3,
    filteredDataRef: S3
  });
  m3.value.forEach((e28) => {
    var t3;
    if (e28.filter) {
      const i = e28.defaultFilterOptionValues;
      e28.filterMultiple ? u3.value[e28.key] = i || [] : i !== void 0 ? u3.value[e28.key] = i === null ? [] : i : u3.value[e28.key] = (t3 = e28.defaultFilterOptionValue) !== null && t3 !== void 0 ? t3 : null;
    }
  });
  const q3 = computed(() => {
    const {
      pagination: e28
    } = a3;
    if (e28 !== false)
      return e28.page;
  }), B3 = computed(() => {
    const {
      pagination: e28
    } = a3;
    if (e28 !== false)
      return e28.pageSize;
  }), G3 = d$1S(q3, O3), p3 = d$1S(B3, z3), U3 = n$1U(() => {
    const e28 = G3.value;
    return a3.remote ? e28 : Math.max(1, Math.min(Math.ceil(S3.value.length / p3.value), e28));
  }), H3 = computed(() => {
    const {
      pagination: e28
    } = a3;
    if (e28) {
      const {
        pageCount: t3
      } = e28;
      if (t3 !== void 0)
        return t3;
    }
  }), M3 = computed(() => {
    if (a3.remote)
      return P3.value.treeNodes;
    if (!a3.pagination)
      return _3.value;
    const e28 = p3.value, t3 = (U3.value - 1) * e28;
    return _3.value.slice(t3, t3 + e28);
  }), J3 = computed(() => M3.value.map((e28) => e28.rawNode));
  function L3(e28) {
    const {
      pagination: t3
    } = a3;
    if (t3) {
      const {
        onChange: i,
        "onUpdate:page": n3,
        onUpdatePage: r3
      } = t3;
      i && i$1Z(i, e28), r3 && i$1Z(r3, e28), n3 && i$1Z(n3, e28), C3(e28);
    }
  }
  function Q3(e28) {
    const {
      pagination: t3
    } = a3;
    if (t3) {
      const {
        onPageSizeChange: i,
        "onUpdate:pageSize": n3,
        onUpdatePageSize: r3
      } = t3;
      i && i$1Z(i, e28), r3 && i$1Z(r3, e28), n3 && i$1Z(n3, e28), x3(e28);
    }
  }
  const V10 = computed(() => {
    if (a3.remote) {
      const {
        pagination: e28
      } = a3;
      if (e28) {
        const {
          itemCount: t3
        } = e28;
        if (t3 !== void 0)
          return t3;
      }
      return;
    }
    return S3.value.length;
  }), X3 = computed(() => Object.assign(Object.assign({}, a3.pagination), {
    onChange: void 0,
    onUpdatePage: void 0,
    onUpdatePageSize: void 0,
    onPageSizeChange: void 0,
    "onUpdate:page": L3,
    "onUpdate:pageSize": Q3,
    page: U3.value,
    pageSize: p3.value,
    pageCount: V10.value === void 0 ? H3.value : void 0,
    itemCount: V10.value
  }));
  function C3(e28) {
    const {
      "onUpdate:page": t3,
      onPageChange: i,
      onUpdatePage: n3
    } = a3;
    n3 && i$1Z(n3, e28), t3 && i$1Z(t3, e28), i && i$1Z(i, e28), O3.value = e28;
  }
  function x3(e28) {
    const {
      "onUpdate:pageSize": t3,
      onPageSizeChange: i,
      onUpdatePageSize: n3
    } = a3;
    i && i$1Z(i, e28), n3 && i$1Z(n3, e28), t3 && i$1Z(t3, e28), z3.value = e28;
  }
  function Y3(e28, t3) {
    const {
      onUpdateFilters: i,
      "onUpdate:filters": n3,
      onFiltersChange: r3
    } = a3;
    i && i$1Z(i, e28, t3), n3 && i$1Z(n3, e28, t3), r3 && i$1Z(r3, e28, t3), u3.value = e28;
  }
  function Z3(e28, t3, i, n3) {
    var r3;
    (r3 = a3.onUnstableColumnResize) === null || r3 === void 0 || r3.call(a3, e28, t3, i, n3);
  }
  function $3(e28) {
    C3(e28);
  }
  function ee2() {
    D3();
  }
  function D3() {
    w3({});
  }
  function w3(e28) {
    E3(e28);
  }
  function E3(e28) {
    e28 ? e28 ? u3.value = _$u(e28) : false : u3.value = {};
  }
  return {
    treeMateRef: P3,
    mergedCurrentPageRef: U3,
    mergedPaginationRef: X3,
    paginatedDataRef: M3,
    rawPaginatedDataRef: J3,
    mergedFilterStateRef: b3,
    mergedSortStateRef: T3,
    hoverKeyRef: ref$1(null),
    selectionColumnRef: F3,
    childTriggerColIndexRef: K3,
    doUpdateFilters: Y3,
    deriveNextSorter: I3,
    doUpdatePageSize: x3,
    doUpdatePage: C3,
    onUnstableColumnResize: Z3,
    filter: E3,
    filters: w3,
    clearFilter: ee2,
    clearFilters: D3,
    clearSorter: W3,
    page: $3,
    sort: A3
  };
}
let n$W = [];
const a$1o = /* @__PURE__ */ new WeakMap();
function r$19() {
  n$W.forEach((e28) => e28(...a$1o.get(e28))), n$W = [];
}
function s$1i(e28, ...t3) {
  a$1o.set(e28, t3), !n$W.includes(e28) && n$W.push(e28) === 1 && requestAnimationFrame(r$19);
}
function Q$m(r3, {
  mainTableInstRef: h3,
  mergedCurrentPageRef: W3,
  bodyWidthRef: S3
}) {
  let u3 = 0;
  const f3 = ref$1(), x3 = ref$1(null), g3 = ref$1([]), C3 = ref$1(null), F3 = ref$1([]), _3 = computed(() => o$1z(r3.scrollX)), y3 = computed(() => r3.columns.filter((e28) => e28.fixed === "left")), L3 = computed(() => r3.columns.filter((e28) => e28.fixed === "right")), K3 = computed(() => {
    const e28 = {};
    let l3 = 0;
    function t3(o3) {
      o3.forEach((n3) => {
        const i = {
          start: l3,
          end: 0
        };
        e28[C$Q(n3)] = i, "children" in n3 ? (t3(n3.children), i.end = l3) : (l3 += g$U(n3) || 0, i.end = l3);
      });
    }
    return t3(y3.value), e28;
  }), H3 = computed(() => {
    const e28 = {};
    let l3 = 0;
    function t3(o3) {
      for (let n3 = o3.length - 1; n3 >= 0; --n3) {
        const i = o3[n3], c3 = {
          start: l3,
          end: 0
        };
        e28[C$Q(i)] = c3, "children" in i ? (t3(i.children), c3.end = l3) : (l3 += g$U(i) || 0, c3.end = l3);
      }
    }
    return t3(L3.value), e28;
  });
  function E3() {
    var e28, l3;
    const {
      value: t3
    } = y3;
    let o3 = 0;
    const {
      value: n3
    } = K3;
    let i = null;
    for (let c3 = 0; c3 < t3.length; ++c3) {
      const s3 = C$Q(t3[c3]);
      if (u3 > (((e28 = n3[s3]) === null || e28 === void 0 ? void 0 : e28.start) || 0) - o3)
        i = s3, o3 = ((l3 = n3[s3]) === null || l3 === void 0 ? void 0 : l3.end) || 0;
      else
        break;
    }
    x3.value = i;
  }
  function w3() {
    g3.value = [];
    let e28 = r3.columns.find((l3) => C$Q(l3) === x3.value);
    for (; e28 && "children" in e28; ) {
      const l3 = e28.children.length;
      if (l3 === 0)
        break;
      const t3 = e28.children[l3 - 1];
      g3.value.push(C$Q(t3)), e28 = t3;
    }
  }
  function B3() {
    var e28, l3;
    const {
      value: t3
    } = L3, o3 = Number(r3.scrollX), {
      value: n3
    } = S3;
    if (n3 === null)
      return;
    let i = 0, c3 = null;
    const {
      value: s3
    } = H3;
    for (let A3 = t3.length - 1; A3 >= 0; --A3) {
      const R3 = C$Q(t3[A3]);
      if (Math.round(u3 + (((e28 = s3[R3]) === null || e28 === void 0 ? void 0 : e28.start) || 0) + n3 - i) < o3)
        c3 = R3, i = ((l3 = s3[R3]) === null || l3 === void 0 ? void 0 : l3.end) || 0;
      else
        break;
    }
    C3.value = c3;
  }
  function N3() {
    F3.value = [];
    let e28 = r3.columns.find((l3) => C$Q(l3) === C3.value);
    for (; e28 && "children" in e28 && e28.children.length; ) {
      const l3 = e28.children[0];
      F3.value.push(C$Q(l3)), e28 = l3;
    }
  }
  function b3() {
    const e28 = h3.value ? h3.value.getHeaderElement() : null, l3 = h3.value ? h3.value.getBodyElement() : null;
    return {
      header: e28,
      body: l3
    };
  }
  function T3() {
    const {
      body: e28
    } = b3();
    e28 && (e28.scrollTop = 0);
  }
  function X3() {
    f3.value !== "body" ? s$1i(m3) : f3.value = void 0;
  }
  function O3(e28) {
    var l3;
    (l3 = r3.onScroll) === null || l3 === void 0 || l3.call(r3, e28), f3.value !== "head" ? s$1i(m3) : f3.value = void 0;
  }
  function m3() {
    const {
      header: e28,
      body: l3
    } = b3();
    if (!l3)
      return;
    const {
      value: t3
    } = S3;
    if (t3 !== null) {
      if (r3.maxHeight || r3.flexHeight) {
        if (!e28)
          return;
        const o3 = u3 - e28.scrollLeft;
        f3.value = o3 !== 0 ? "head" : "body", f3.value === "head" ? (u3 = e28.scrollLeft, l3.scrollLeft = u3) : (u3 = l3.scrollLeft, e28.scrollLeft = u3);
      } else
        u3 = l3.scrollLeft;
      E3(), w3(), B3(), N3();
    }
  }
  function P3(e28) {
    const {
      header: l3
    } = b3();
    l3 && (l3.scrollLeft = e28, m3());
  }
  return watch(W3, () => {
    T3();
  }), {
    styleScrollXRef: _3,
    fixedColumnLeftMapRef: K3,
    fixedColumnRightMapRef: H3,
    leftFixedColumnsRef: y3,
    rightFixedColumnsRef: L3,
    leftActiveFixedColKeyRef: x3,
    leftActiveFixedChildrenColKeysRef: g3,
    rightActiveFixedColKeyRef: C3,
    rightActiveFixedChildrenColKeysRef: F3,
    syncScrollState: m3,
    handleTableBodyScroll: O3,
    handleTableHeaderScroll: X3,
    setHeaderScrollLeft: P3
  };
}
function u$1b() {
  const i = ref$1({});
  function t3(e28) {
    return i.value[e28];
  }
  function r3(e28, n3) {
    F$p(e28) && "key" in e28 && (i.value[e28.key] = n3);
  }
  function a3() {
    i.value = {};
  }
  return {
    getResizableWidth: t3,
    doUpdateResizableWidth: r3,
    clearResizableWidth: a3
  };
}
function E$u(d3, r3) {
  const s3 = [], R3 = [], y3 = [], c3 = /* @__PURE__ */ new WeakMap();
  let p3 = -1, u3 = 0, h3 = false;
  function x3(w3, t3) {
    t3 > p3 && (s3[t3] = [], p3 = t3);
    for (const e28 of w3)
      if ("children" in e28)
        x3(e28.children, t3 + 1);
      else {
        const o3 = "key" in e28 ? e28.key : void 0;
        R3.push({
          key: C$Q(e28),
          style: x$t(e28, o3 !== void 0 ? o$1z(r3(o3)) : void 0),
          column: e28
        }), u3 += 1, h3 || (h3 = !!e28.ellipsis), y3.push(e28);
      }
  }
  x3(d3, 0);
  let n3 = 0;
  function L3(w3, t3) {
    let e28 = 0;
    w3.forEach((o3, g3) => {
      var C3;
      if ("children" in o3) {
        const l3 = n3, a3 = {
          column: o3,
          colSpan: 0,
          rowSpan: 1,
          isLast: false
        };
        L3(o3.children, t3 + 1), o3.children.forEach((f3) => {
          var S3, v3;
          a3.colSpan += (v3 = (S3 = c3.get(f3)) === null || S3 === void 0 ? void 0 : S3.colSpan) !== null && v3 !== void 0 ? v3 : 0;
        }), l3 + a3.colSpan === u3 && (a3.isLast = true), c3.set(o3, a3), s3[t3].push(a3);
      } else {
        if (n3 < e28) {
          n3 += 1;
          return;
        }
        let l3 = 1;
        "titleColSpan" in o3 && (l3 = (C3 = o3.titleColSpan) !== null && C3 !== void 0 ? C3 : 1), l3 > 1 && (e28 = n3 + l3);
        const a3 = n3 + l3 === u3, f3 = {
          column: o3,
          colSpan: l3,
          rowSpan: p3 - t3 + 1,
          isLast: a3
        };
        c3.set(o3, f3), s3[t3].push(f3), n3 += 1;
      }
    });
  }
  return L3(d3, 0), {
    hasEllipsis: h3,
    rows: s3,
    cols: R3,
    dataRelatedCols: y3
  };
}
function W$l(d3, r3) {
  const s3 = computed(() => E$u(d3.columns, r3));
  return {
    rowsRef: computed(() => s3.value.rows),
    colsRef: computed(() => s3.value.cols),
    hasEllipsisRef: computed(() => s3.value.hasEllipsis),
    dataRelatedColsRef: computed(() => s3.value.dataRelatedCols)
  };
}
function h$17(o3, r3) {
  const a3 = n$1U(() => {
    for (const e28 of o3.columns)
      if (e28.type === "expand")
        return e28.renderExpand;
  }), t3 = n$1U(() => {
    let e28;
    for (const n3 of o3.columns)
      if (n3.type === "expand") {
        e28 = n3.expandable;
        break;
      }
    return e28;
  }), l3 = ref$1(o3.defaultExpandAll ? a3 != null && a3.value ? (() => {
    const e28 = [];
    return r3.value.treeNodes.forEach((n3) => {
      var d3;
      !((d3 = t3.value) === null || d3 === void 0) && d3.call(t3, n3.rawNode) && e28.push(n3.key);
    }), e28;
  })() : r3.value.getNonLeafKeys() : o3.defaultExpandedRowKeys), c3 = toRef$1(o3, "expandedRowKeys"), u3 = toRef$1(o3, "stickyExpandedRows"), x3 = d$1S(c3, l3);
  function i(e28) {
    const {
      onUpdateExpandedRowKeys: n3,
      "onUpdate:expandedRowKeys": d3
    } = o3;
    n3 && i$1Z(n3, e28), d3 && i$1Z(d3, e28), l3.value = e28;
  }
  return {
    stickyExpandedRowsRef: u3,
    mergedExpandedRowKeysRef: x3,
    renderExpandRef: a3,
    expandableRef: t3,
    doUpdateExpandedRowKeys: i
  };
}
const i$17 = s$1h(), v$I = r$2a([l$25("data-table", `
 width: 100%;
 font-size: var(--n-font-size);
 display: flex;
 flex-direction: column;
 position: relative;
 --n-merged-th-color: var(--n-th-color);
 --n-merged-td-color: var(--n-td-color);
 --n-merged-border-color: var(--n-border-color);
 --n-merged-th-color-hover: var(--n-th-color-hover);
 --n-merged-td-color-hover: var(--n-td-color-hover);
 --n-merged-td-color-striped: var(--n-td-color-striped);
 `, [l$25("data-table-wrapper", `
 flex-grow: 1;
 display: flex;
 flex-direction: column;
 `), g$1j("flex-height", [r$2a(">", [l$25("data-table-wrapper", [r$2a(">", [l$25("data-table-base-table", `
 display: flex;
 flex-direction: column;
 flex-grow: 1;
 `, [r$2a(">", [l$25("data-table-base-table-body", "flex-basis: 0;", [
  r$2a("&:last-child", "flex-grow: 1;")
])])])])])])]), r$2a(">", [l$25("data-table-loading-wrapper", `
 color: var(--n-loading-color);
 font-size: var(--n-loading-size);
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 transition: color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 justify-content: center;
 `, [$$n({
  originalTransform: "translateX(-50%) translateY(-50%)"
})])]), l$25("data-table-expand-placeholder", `
 margin-right: 8px;
 display: inline-block;
 width: 16px;
 height: 1px;
 `), l$25("data-table-indent", `
 display: inline-block;
 height: 1px;
 `), l$25("data-table-expand-trigger", `
 display: inline-flex;
 margin-right: 8px;
 cursor: pointer;
 font-size: 16px;
 vertical-align: -0.2em;
 position: relative;
 width: 16px;
 height: 16px;
 color: var(--n-td-text-color);
 transition: color .3s var(--n-bezier);
 `, [g$1j("expanded", [l$25("icon", "transform: rotate(90deg);", [m$22({
  originalTransform: "rotate(90deg)"
})]), l$25("base-icon", "transform: rotate(90deg);", [m$22({
  originalTransform: "rotate(90deg)"
})])]), l$25("base-loading", `
 color: var(--n-loading-color);
 transition: color .3s var(--n-bezier);
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [m$22()]), l$25("icon", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [m$22()]), l$25("base-icon", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [m$22()])]), l$25("data-table-thead", `
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-merged-th-color);
 `), l$25("data-table-tr", `
 box-sizing: border-box;
 background-clip: padding-box;
 transition: background-color .3s var(--n-bezier);
 `, [l$25("data-table-expand", `
 position: sticky;
 left: 0;
 overflow: hidden;
 margin: calc(var(--n-th-padding) * -1);
 padding: var(--n-th-padding);
 box-sizing: border-box;
 `), g$1j("striped", "background-color: var(--n-merged-td-color-striped);", [l$25("data-table-td", "background-color: var(--n-merged-td-color-striped);")]), x$I("summary", [r$2a("&:hover", "background-color: var(--n-merged-td-color-hover);", [r$2a(">", [l$25("data-table-td", "background-color: var(--n-merged-td-color-hover);")])])])]), l$25("data-table-th", `
 padding: var(--n-th-padding);
 position: relative;
 text-align: start;
 box-sizing: border-box;
 background-color: var(--n-merged-th-color);
 border-color: var(--n-merged-border-color);
 border-bottom: 1px solid var(--n-merged-border-color);
 color: var(--n-th-text-color);
 transition:
 border-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 font-weight: var(--n-th-font-weight);
 `, [g$1j("filterable", `
 padding-right: 36px;
 `, [g$1j("sortable", `
 padding-right: calc(var(--n-th-padding) + 36px);
 `)]), i$17, g$1j("selection", `
 padding: 0;
 text-align: center;
 line-height: 0;
 z-index: 3;
 `), M$y("title-wrapper", `
 display: flex;
 align-items: center;
 flex-wrap: nowrap;
 max-width: 100%;
 `, [M$y("title", `
 flex: 1;
 min-width: 0;
 `)]), M$y("ellipsis", `
 display: inline-block;
 vertical-align: bottom;
 text-overflow: ellipsis;
 overflow: hidden;
 white-space: nowrap;
 max-width: 100%;
 `), g$1j("hover", `
 background-color: var(--n-merged-th-color-hover);
 `), g$1j("sortable", `
 cursor: pointer;
 `, [M$y("ellipsis", `
 max-width: calc(100% - 18px);
 `), r$2a("&:hover", `
 background-color: var(--n-merged-th-color-hover);
 `)]), l$25("data-table-sorter", `
 height: var(--n-sorter-size);
 width: var(--n-sorter-size);
 margin-left: 4px;
 position: relative;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 vertical-align: -0.2em;
 color: var(--n-th-icon-color);
 transition: color .3s var(--n-bezier);
 `, [l$25("base-icon", "transition: transform .3s var(--n-bezier)"), g$1j("desc", [l$25("base-icon", `
 transform: rotate(0deg);
 `)]), g$1j("asc", [l$25("base-icon", `
 transform: rotate(-180deg);
 `)]), g$1j("asc, desc", `
 color: var(--n-th-icon-color-active);
 `)]), l$25("data-table-resize-button", `
 width: var(--n-resizable-container-size);
 position: absolute;
 top: 0;
 right: calc(var(--n-resizable-container-size) / 2);
 bottom: 0;
 cursor: col-resize;
 user-select: none;
 `, [r$2a("&::after", `
 width: var(--n-resizable-size);
 height: 50%;
 position: absolute;
 top: 50%;
 left: calc(var(--n-resizable-container-size) / 2);
 bottom: 0;
 background-color: var(--n-merged-border-color);
 transform: translateY(-50%);
 transition: background-color .3s var(--n-bezier);
 z-index: 1;
 content: '';
 `), g$1j("active", [r$2a("&::after", ` 
 background-color: var(--n-th-icon-color-active);
 `)]), r$2a("&:hover::after", `
 background-color: var(--n-th-icon-color-active);
 `)]), l$25("data-table-filter", `
 position: absolute;
 z-index: auto;
 right: 0;
 width: 36px;
 top: 0;
 bottom: 0;
 cursor: pointer;
 display: flex;
 justify-content: center;
 align-items: center;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 font-size: var(--n-filter-size);
 color: var(--n-th-icon-color);
 `, [r$2a("&:hover", `
 background-color: var(--n-th-button-color-hover);
 `), g$1j("show", `
 background-color: var(--n-th-button-color-hover);
 `), g$1j("active", `
 background-color: var(--n-th-button-color-hover);
 color: var(--n-th-icon-color-active);
 `)])]), l$25("data-table-td", `
 padding: var(--n-td-padding);
 text-align: start;
 box-sizing: border-box;
 border: none;
 background-color: var(--n-merged-td-color);
 color: var(--n-td-text-color);
 border-bottom: 1px solid var(--n-merged-border-color);
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `, [g$1j("expand", [l$25("data-table-expand-trigger", `
 margin-right: 0;
 `)]), g$1j("last-row", `
 border-bottom: 0 solid var(--n-merged-border-color);
 `, [
  r$2a("&::after", `
 bottom: 0 !important;
 `),
  r$2a("&::before", `
 bottom: 0 !important;
 `)
]), g$1j("summary", `
 background-color: var(--n-merged-th-color);
 `), g$1j("hover", `
 background-color: var(--n-merged-td-color-hover);
 `), M$y("ellipsis", `
 display: inline-block;
 text-overflow: ellipsis;
 overflow: hidden;
 white-space: nowrap;
 max-width: 100%;
 vertical-align: bottom;
 max-width: calc(100% - var(--indent-offset, -1.5) * 16px - 24px);
 `), g$1j("selection, expand", `
 text-align: center;
 padding: 0;
 line-height: 0;
 `), i$17]), l$25("data-table-empty", `
 box-sizing: border-box;
 padding: var(--n-empty-padding);
 flex-grow: 1;
 flex-shrink: 0;
 opacity: 1;
 display: flex;
 align-items: center;
 justify-content: center;
 transition: opacity .3s var(--n-bezier);
 `, [g$1j("hide", `
 opacity: 0;
 `)]), M$y("pagination", `
 margin: var(--n-pagination-margin);
 display: flex;
 justify-content: flex-end;
 `), l$25("data-table-wrapper", `
 position: relative;
 opacity: 1;
 transition: opacity .3s var(--n-bezier), border-color .3s var(--n-bezier);
 border-top-left-radius: var(--n-border-radius);
 border-top-right-radius: var(--n-border-radius);
 line-height: var(--n-line-height);
 `), g$1j("loading", [l$25("data-table-wrapper", `
 opacity: var(--n-opacity-loading);
 pointer-events: none;
 `)]), g$1j("single-column", [l$25("data-table-td", `
 border-bottom: 0 solid var(--n-merged-border-color);
 `, [r$2a("&::after, &::before", `
 bottom: 0 !important;
 `)])]), x$I("single-line", [l$25("data-table-th", `
 border-right: 1px solid var(--n-merged-border-color);
 `, [g$1j("last", `
 border-right: 0 solid var(--n-merged-border-color);
 `)]), l$25("data-table-td", `
 border-right: 1px solid var(--n-merged-border-color);
 `, [g$1j("last-col", `
 border-right: 0 solid var(--n-merged-border-color);
 `)])]), g$1j("bordered", [l$25("data-table-wrapper", `
 border: 1px solid var(--n-merged-border-color);
 border-bottom-left-radius: var(--n-border-radius);
 border-bottom-right-radius: var(--n-border-radius);
 overflow: hidden;
 `)]), l$25("data-table-base-table", [g$1j("transition-disabled", [l$25("data-table-th", [r$2a("&::after, &::before", "transition: none;")]), l$25("data-table-td", [r$2a("&::after, &::before", "transition: none;")])])]), g$1j("bottom-bordered", [l$25("data-table-td", [g$1j("last-row", `
 border-bottom: 1px solid var(--n-merged-border-color);
 `)])]), l$25("data-table-table", `
 font-variant-numeric: tabular-nums;
 width: 100%;
 word-break: break-word;
 transition: background-color .3s var(--n-bezier);
 border-collapse: separate;
 border-spacing: 0;
 background-color: var(--n-merged-td-color);
 `), l$25("data-table-base-table-header", `
 border-top-left-radius: calc(var(--n-border-radius) - 1px);
 border-top-right-radius: calc(var(--n-border-radius) - 1px);
 z-index: 3;
 overflow: scroll;
 flex-shrink: 0;
 transition: border-color .3s var(--n-bezier);
 scrollbar-width: none;
 `, [r$2a("&::-webkit-scrollbar", `
 width: 0;
 height: 0;
 `)]), l$25("data-table-check-extra", `
 transition: color .3s var(--n-bezier);
 color: var(--n-th-icon-color);
 position: absolute;
 font-size: 14px;
 right: -4px;
 top: 50%;
 transform: translateY(-50%);
 z-index: 1;
 `)]), l$25("data-table-filter-menu", [l$25("scrollbar", `
 max-height: 240px;
 `), M$y("group", `
 display: flex;
 flex-direction: column;
 padding: 12px 12px 0 12px;
 `, [l$25("checkbox", `
 margin-bottom: 12px;
 margin-right: 0;
 `), l$25("radio", `
 margin-bottom: 12px;
 margin-right: 0;
 `)]), M$y("action", `
 padding: var(--n-action-padding);
 display: flex;
 flex-wrap: nowrap;
 justify-content: space-evenly;
 border-top: 1px solid var(--n-action-divider-color);
 `, [l$25("button", [r$2a("&:not(:last-child)", `
 margin: var(--n-action-button-margin);
 `), r$2a("&:last-child", `
 margin-right: 0;
 `)])]), l$25("divider", `
 margin: 0 !important;
 `)]), C$1a(l$25("data-table", `
 --n-merged-th-color: var(--n-th-color-modal);
 --n-merged-td-color: var(--n-td-color-modal);
 --n-merged-border-color: var(--n-border-color-modal);
 --n-merged-th-color-hover: var(--n-th-color-hover-modal);
 --n-merged-td-color-hover: var(--n-td-color-hover-modal);
 --n-merged-td-color-striped: var(--n-td-color-striped-modal);
 `)), P$V(l$25("data-table", `
 --n-merged-th-color: var(--n-th-color-popover);
 --n-merged-td-color: var(--n-td-color-popover);
 --n-merged-border-color: var(--n-border-color-popover);
 --n-merged-th-color-hover: var(--n-th-color-hover-popover);
 --n-merged-td-color-hover: var(--n-td-color-hover-popover);
 --n-merged-td-color-striped: var(--n-td-color-striped-popover);
 `))]);
function s$1h() {
  return [g$1j("fixed-left", `
 left: 0;
 position: sticky;
 z-index: 2;
 `, [r$2a("&::after", `
 pointer-events: none;
 content: "";
 width: 36px;
 display: inline-block;
 position: absolute;
 top: 0;
 bottom: -1px;
 transition: box-shadow .2s var(--n-bezier);
 right: -36px;
 `)]), g$1j("fixed-right", `
 right: 0;
 position: sticky;
 z-index: 1;
 `, [r$2a("&::before", `
 pointer-events: none;
 content: "";
 width: 36px;
 display: inline-block;
 position: absolute;
 top: 0;
 bottom: -1px;
 transition: box-shadow .2s var(--n-bezier);
 left: -36px;
 `)])];
}
const a$1n = {
  thPaddingSmall: "8px",
  thPaddingMedium: "12px",
  thPaddingLarge: "12px",
  tdPaddingSmall: "8px",
  tdPaddingMedium: "12px",
  tdPaddingLarge: "12px",
  sorterSize: "15px",
  resizableContainerSize: "8px",
  resizableSize: "2px",
  filterSize: "15px",
  paginationMargin: "12px 0 0 0",
  emptyPadding: "48px 0",
  actionPadding: "8px 12px",
  actionButtonMargin: "0 8px 0 0"
};
const k$A = (m3) => {
  const {
    cardColor: t3,
    modalColor: e28,
    popoverColor: i,
    textColor2: C3,
    textColor1: n3,
    tableHeaderColor: l3,
    tableColorHover: r3,
    iconColor: h3,
    primaryColor: d3,
    fontWeightStrong: g3,
    borderRadius: c3,
    lineHeight: b3,
    fontSizeSmall: s3,
    fontSizeMedium: f3,
    fontSizeLarge: v3,
    dividerColor: a3,
    heightSmall: x3,
    opacityDisabled: L3,
    tableColorStriped: p3
  } = m3;
  return Object.assign(Object.assign({}, a$1n), {
    actionDividerColor: a3,
    lineHeight: b3,
    borderRadius: c3,
    fontSizeSmall: s3,
    fontSizeMedium: f3,
    fontSizeLarge: v3,
    borderColor: G$v(t3, a3),
    tdColorHover: G$v(t3, r3),
    tdColorStriped: G$v(t3, p3),
    thColor: G$v(t3, l3),
    thColorHover: G$v(G$v(t3, l3), r3),
    tdColor: t3,
    tdTextColor: C3,
    thTextColor: n3,
    thFontWeight: g3,
    thButtonColorHover: r3,
    thIconColor: h3,
    thIconColorActive: d3,
    borderColorModal: G$v(e28, a3),
    tdColorHoverModal: G$v(e28, r3),
    tdColorStripedModal: G$v(e28, p3),
    thColorModal: G$v(e28, l3),
    thColorHoverModal: G$v(G$v(e28, l3), r3),
    tdColorModal: e28,
    borderColorPopover: G$v(i, a3),
    tdColorHoverPopover: G$v(i, r3),
    tdColorStripedPopover: G$v(i, p3),
    thColorPopover: G$v(i, l3),
    thColorHoverPopover: G$v(G$v(i, l3), r3),
    tdColorPopover: i,
    boxShadowBefore: "inset -12px 0 8px -12px rgba(0, 0, 0, .18)",
    boxShadowAfter: "inset 12px 0 8px -12px rgba(0, 0, 0, .18)",
    loadingColor: d3,
    loadingSize: x3,
    opacityLoading: L3
  });
}, A$v = G$w({
  name: "DataTable",
  common: d$1T,
  peers: {
    Button: B$P,
    Checkbox: S$v,
    Radio: w$H,
    Pagination: D$C,
    Scrollbar: n$1N,
    Empty: x$v,
    Popover: b$11,
    Ellipsis: l$1q,
    Dropdown: w$z
  },
  self: k$A
}), Q$l = A$v;
const n$V = (e28, o3) => {
  if (!e28)
    return;
  const d3 = document.createElement("a");
  d3.href = e28, o3 !== void 0 && (d3.download = o3), document.body.appendChild(d3), d3.click(), document.body.removeChild(d3);
};
const st$8 = defineComponent({
  name: "DataTable",
  alias: ["AdvancedTable"],
  props: a$1t,
  setup(e28, {
    slots: h3
  }) {
    const {
      mergedBorderedRef: d3,
      mergedClsPrefixRef: l3,
      inlineThemeDisabled: f3,
      mergedRtlRef: B3
    } = a$2x(e28), D3 = v$17("DataTable", B3, l3), E3 = computed(() => {
      const {
        bottomBordered: o3
      } = e28;
      return d3.value ? false : o3 !== void 0 ? o3 : true;
    }), m3 = _$F("DataTable", "-data-table", v$I, Q$l, e28, l3), S3 = ref$1(null), u3 = ref$1(null), {
      getResizableWidth: w3,
      clearResizableWidth: K3,
      doUpdateResizableWidth: L3
    } = u$1b(), {
      rowsRef: F3,
      colsRef: M3,
      dataRelatedColsRef: O3,
      hasEllipsisRef: $3
    } = W$l(e28, w3), I3 = (o3) => {
      const {
        fileName: a3 = "data.csv",
        keepOriginalData: n3 = false
      } = o3 || {}, v3 = n3 ? e28.data : z3.value, C3 = K$j(e28.columns, v3), p3 = new Blob([C3], {
        type: "text/csv;charset=utf-8"
      }), g3 = URL.createObjectURL(p3);
      n$V(g3, a3.endsWith(".csv") ? a3 : `${a3}.csv`), URL.revokeObjectURL(g3);
    }, {
      treeMateRef: R3,
      mergedCurrentPageRef: y3,
      paginatedDataRef: b3,
      rawPaginatedDataRef: z3,
      selectionColumnRef: T3,
      hoverKeyRef: U3,
      mergedPaginationRef: H3,
      mergedFilterStateRef: A3,
      mergedSortStateRef: N3,
      childTriggerColIndexRef: W3,
      doUpdatePage: j3,
      doUpdateFilters: V10,
      onUnstableColumnResize: _3,
      deriveNextSorter: X3,
      filter: G3,
      filters: q3,
      clearFilter: J3,
      clearFilters: Q3,
      clearSorter: Y3,
      page: Z3,
      sort: ee2
    } = ve$a(e28, {
      dataRelatedColsRef: O3
    }), {
      doCheckAll: oe2,
      doUncheckAll: te2,
      doCheck: ae2,
      doUncheck: ne2,
      headerCheckboxDisabledRef: re2,
      someRowsCheckedRef: ie2,
      allRowsCheckedRef: de2,
      mergedCheckedRowKeySetRef: le2,
      mergedInderminateRowKeySetRef: se2
    } = M$m(e28, {
      selectionColumnRef: T3,
      treeMateRef: R3,
      paginatedDataRef: b3
    }), {
      stickyExpandedRowsRef: ce2,
      mergedExpandedRowKeysRef: fe2,
      renderExpandRef: me2,
      expandableRef: ge2,
      doUpdateExpandedRowKeys: he2
    } = h$17(e28, R3), {
      handleTableBodyScroll: ue2,
      handleTableHeaderScroll: Re2,
      syncScrollState: be2,
      setHeaderScrollLeft: ve2,
      leftActiveFixedColKeyRef: Ce2,
      leftActiveFixedChildrenColKeysRef: pe2,
      rightActiveFixedColKeyRef: xe2,
      rightActiveFixedChildrenColKeysRef: Pe2,
      leftFixedColumnsRef: Se2,
      rightFixedColumnsRef: we2,
      fixedColumnLeftMapRef: ye2,
      fixedColumnRightMapRef: ze2
    } = Q$m(e28, {
      bodyWidthRef: S3,
      mainTableInstRef: u3,
      mergedCurrentPageRef: y3
    }), {
      localeRef: Te2
    } = R$p("DataTable"), He2 = computed(() => e28.virtualScroll || e28.flexHeight || e28.maxHeight !== void 0 || $3.value ? "fixed" : e28.tableLayout);
    provide(r$1d, {
      props: e28,
      treeMateRef: R3,
      renderExpandIconRef: toRef$1(e28, "renderExpandIcon"),
      loadingKeySetRef: ref$1(/* @__PURE__ */ new Set()),
      slots: h3,
      indentRef: toRef$1(e28, "indent"),
      childTriggerColIndexRef: W3,
      bodyWidthRef: S3,
      componentId: i$1Y(),
      hoverKeyRef: U3,
      mergedClsPrefixRef: l3,
      mergedThemeRef: m3,
      scrollXRef: computed(() => e28.scrollX),
      rowsRef: F3,
      colsRef: M3,
      paginatedDataRef: b3,
      leftActiveFixedColKeyRef: Ce2,
      leftActiveFixedChildrenColKeysRef: pe2,
      rightActiveFixedColKeyRef: xe2,
      rightActiveFixedChildrenColKeysRef: Pe2,
      leftFixedColumnsRef: Se2,
      rightFixedColumnsRef: we2,
      fixedColumnLeftMapRef: ye2,
      fixedColumnRightMapRef: ze2,
      mergedCurrentPageRef: y3,
      someRowsCheckedRef: ie2,
      allRowsCheckedRef: de2,
      mergedSortStateRef: N3,
      mergedFilterStateRef: A3,
      loadingRef: toRef$1(e28, "loading"),
      rowClassNameRef: toRef$1(e28, "rowClassName"),
      mergedCheckedRowKeySetRef: le2,
      mergedExpandedRowKeysRef: fe2,
      mergedInderminateRowKeySetRef: se2,
      localeRef: Te2,
      expandableRef: ge2,
      stickyExpandedRowsRef: ce2,
      rowKeyRef: toRef$1(e28, "rowKey"),
      renderExpandRef: me2,
      summaryRef: toRef$1(e28, "summary"),
      virtualScrollRef: toRef$1(e28, "virtualScroll"),
      rowPropsRef: toRef$1(e28, "rowProps"),
      stripedRef: toRef$1(e28, "striped"),
      checkOptionsRef: computed(() => {
        const {
          value: o3
        } = T3;
        return o3 == null ? void 0 : o3.options;
      }),
      rawPaginatedDataRef: z3,
      filterMenuCssVarsRef: computed(() => {
        const {
          self: {
            actionDividerColor: o3,
            actionPadding: a3,
            actionButtonMargin: n3
          }
        } = m3.value;
        return {
          "--n-action-padding": a3,
          "--n-action-button-margin": n3,
          "--n-action-divider-color": o3
        };
      }),
      onLoadRef: toRef$1(e28, "onLoad"),
      mergedTableLayoutRef: He2,
      maxHeightRef: toRef$1(e28, "maxHeight"),
      minHeightRef: toRef$1(e28, "minHeight"),
      flexHeightRef: toRef$1(e28, "flexHeight"),
      headerCheckboxDisabledRef: re2,
      paginationBehaviorOnFilterRef: toRef$1(e28, "paginationBehaviorOnFilter"),
      summaryPlacementRef: toRef$1(e28, "summaryPlacement"),
      scrollbarPropsRef: toRef$1(e28, "scrollbarProps"),
      syncScrollState: be2,
      doUpdatePage: j3,
      doUpdateFilters: V10,
      getResizableWidth: w3,
      onUnstableColumnResize: _3,
      clearResizableWidth: K3,
      doUpdateResizableWidth: L3,
      deriveNextSorter: X3,
      doCheck: ae2,
      doUncheck: ne2,
      doCheckAll: oe2,
      doUncheckAll: te2,
      doUpdateExpandedRowKeys: he2,
      handleTableHeaderScroll: Re2,
      handleTableBodyScroll: ue2,
      setHeaderScrollLeft: ve2,
      renderCell: toRef$1(e28, "renderCell")
    });
    const ke2 = {
      filter: G3,
      filters: q3,
      clearFilters: Q3,
      clearSorter: Y3,
      page: Z3,
      sort: ee2,
      clearFilter: J3,
      downloadCsv: I3,
      scrollTo: (o3, a3) => {
        var n3;
        (n3 = u3.value) === null || n3 === void 0 || n3.scrollTo(o3, a3);
      }
    }, k3 = computed(() => {
      const {
        size: o3
      } = e28, {
        common: {
          cubicBezierEaseInOut: a3
        },
        self: {
          borderColor: n3,
          tdColorHover: v3,
          thColor: C3,
          thColorHover: p3,
          tdColor: g3,
          tdTextColor: De2,
          thTextColor: Ee2,
          thFontWeight: Ke2,
          thButtonColorHover: Le2,
          thIconColor: Fe2,
          thIconColorActive: Me2,
          filterSize: Oe2,
          borderRadius: $e2,
          lineHeight: Ie2,
          tdColorModal: Ue2,
          thColorModal: Ae2,
          borderColorModal: Ne2,
          thColorHoverModal: We2,
          tdColorHoverModal: je2,
          borderColorPopover: Ve2,
          thColorPopover: _e2,
          tdColorPopover: Xe2,
          tdColorHoverPopover: Ge2,
          thColorHoverPopover: qe2,
          paginationMargin: Je2,
          emptyPadding: Qe2,
          boxShadowAfter: Ye2,
          boxShadowBefore: Ze2,
          sorterSize: eo2,
          resizableContainerSize: oo2,
          resizableSize: to2,
          loadingColor: ao2,
          loadingSize: no2,
          opacityLoading: ro2,
          tdColorStriped: io2,
          tdColorStripedModal: lo2,
          tdColorStripedPopover: so2,
          [_$H("fontSize", o3)]: co2,
          [_$H("thPadding", o3)]: fo2,
          [_$H("tdPadding", o3)]: mo2
        }
      } = m3.value;
      return {
        "--n-font-size": co2,
        "--n-th-padding": fo2,
        "--n-td-padding": mo2,
        "--n-bezier": a3,
        "--n-border-radius": $e2,
        "--n-line-height": Ie2,
        "--n-border-color": n3,
        "--n-border-color-modal": Ne2,
        "--n-border-color-popover": Ve2,
        "--n-th-color": C3,
        "--n-th-color-hover": p3,
        "--n-th-color-modal": Ae2,
        "--n-th-color-hover-modal": We2,
        "--n-th-color-popover": _e2,
        "--n-th-color-hover-popover": qe2,
        "--n-td-color": g3,
        "--n-td-color-hover": v3,
        "--n-td-color-modal": Ue2,
        "--n-td-color-hover-modal": je2,
        "--n-td-color-popover": Xe2,
        "--n-td-color-hover-popover": Ge2,
        "--n-th-text-color": Ee2,
        "--n-td-text-color": De2,
        "--n-th-font-weight": Ke2,
        "--n-th-button-color-hover": Le2,
        "--n-th-icon-color": Fe2,
        "--n-th-icon-color-active": Me2,
        "--n-filter-size": Oe2,
        "--n-pagination-margin": Je2,
        "--n-empty-padding": Qe2,
        "--n-box-shadow-before": Ze2,
        "--n-box-shadow-after": Ye2,
        "--n-sorter-size": eo2,
        "--n-resizable-container-size": oo2,
        "--n-resizable-size": to2,
        "--n-loading-size": no2,
        "--n-loading-color": ao2,
        "--n-opacity-loading": ro2,
        "--n-td-color-striped": io2,
        "--n-td-color-striped-modal": lo2,
        "--n-td-color-striped-popover": so2
      };
    }), s3 = f3 ? E$J("data-table", computed(() => e28.size[0]), k3, e28) : void 0, Be2 = computed(() => {
      if (!e28.pagination)
        return false;
      if (e28.paginateSinglePage)
        return true;
      const o3 = H3.value, {
        pageCount: a3
      } = o3;
      return a3 !== void 0 ? a3 > 1 : o3.itemCount && o3.pageSize && o3.itemCount > o3.pageSize;
    });
    return Object.assign({
      mainTableInstRef: u3,
      mergedClsPrefix: l3,
      rtlEnabled: D3,
      mergedTheme: m3,
      paginatedData: b3,
      mergedBordered: d3,
      mergedBottomBordered: E3,
      mergedPagination: H3,
      mergedShowPagination: Be2,
      cssVars: f3 ? void 0 : k3,
      themeClass: s3 == null ? void 0 : s3.themeClass,
      onRender: s3 == null ? void 0 : s3.onRender
    }, ke2);
  },
  render() {
    const {
      mergedClsPrefix: e28,
      themeClass: h3,
      onRender: d3,
      $slots: l3,
      spinProps: f3
    } = this;
    return d3 == null || d3(), h$1R("div", {
      class: [`${e28}-data-table`, this.rtlEnabled && `${e28}-data-table--rtl`, h3, {
        [`${e28}-data-table--bordered`]: this.mergedBordered,
        [`${e28}-data-table--bottom-bordered`]: this.mergedBottomBordered,
        [`${e28}-data-table--single-line`]: this.singleLine,
        [`${e28}-data-table--single-column`]: this.singleColumn,
        [`${e28}-data-table--loading`]: this.loading,
        [`${e28}-data-table--flex-height`]: this.flexHeight
      }],
      style: this.cssVars
    }, h$1R("div", {
      class: `${e28}-data-table-wrapper`
    }, h$1R($$j, {
      ref: "mainTableInstRef"
    })), this.mergedShowPagination ? h$1R("div", {
      class: `${e28}-data-table__pagination`
    }, h$1R(Dt$5, Object.assign({
      theme: this.mergedTheme.peers.Pagination,
      themeOverrides: this.mergedTheme.peerOverrides.Pagination,
      disabled: this.loading
    }, this.mergedPagination))) : null, h$1R(Transition, {
      name: "fade-in-scale-up-transition"
    }, {
      default: () => this.loading ? h$1R("div", {
        class: `${e28}-data-table-loading-wrapper`
      }, p$3H(l3.loading, () => [h$1R(h$1A, Object.assign({
        clsPrefix: e28,
        strokeWidth: 20
      }, f3))])) : null
    }));
  }
});
const G$o = { class: "ghl-table-custom-header" }, M$l = { class: "filter-bar--left" }, J$l = { class: "filter-bar--right" }, Q$k = {
  key: 1,
  class: "hl-breadcrumb"
}, W$k = { class: "ghl-table-container" }, Y$j = { key: 0 }, Z$m = {
  key: 0,
  class: "ghl-table-footer"
}, _$s = { class: "ghl-table-footer-left" }, ee$e = { class: "ghl-table-footer-right" }, te$f = {
  key: 1,
  class: "pagination"
}, ae$f = defineComponent({
  name: "UITable",
  inheritAttrs: false
}), le$d = defineComponent(__spreadProps(__spreadValues({}, ae$f), {
  props: {
    id: {
      type: String,
      required: true
    },
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    page: {
      type: Number
    },
    pageCount: {
      type: Number
    },
    tabs: {
      type: Array,
      default: () => []
    },
    enableTextSearch: {
      type: Boolean,
      default: true
    },
    enableFilter: {
      type: Boolean,
      default: true
    },
    filterCollapseItems: {
      type: Array,
      default: () => []
    },
    filterOptions: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    defaultTab: {
      type: String,
      default: ""
    },
    rowKey: Function,
    checkedRowKeys: Array,
    searchInputPlaceholder: {
      type: String,
      default: void 0
    },
    defaultExpandAll: {
      type: Boolean,
      default: false
    },
    searchText: {
      type: String,
      default: ""
    },
    transparent: {
      type: Boolean,
      default: false
    },
    showSizePicker: {
      type: Boolean,
      default: false
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40]
    },
    pageSize: {
      type: Number,
      default: void 0
    },
    pageSlot: {
      type: Number,
      default: 9
    },
    dragSort: {
      type: Boolean,
      default: false
    },
    dragIconClass: {
      type: String,
      required: false
    },
    scrollX: {
      type: [Number, void 0],
      required: false,
      default: void 0
    },
    scrollbarProps: {
      type: Object,
      required: false,
      default: void 0
    },
    virtualScroll: {
      type: Boolean,
      required: false,
      default: false
    },
    flexHeight: {
      type: Boolean,
      required: false,
      default: false
    },
    maxHeight: {
      type: [Number, String],
      default: void 0
    },
    minHeight: {
      type: Number,
      default: void 0
    },
    tableLayout: {
      type: String,
      default: "auto"
    },
    rowClassName: {
      type: String,
      default: void 0
    },
    rowProps: {
      type: Function,
      default: void 0
    },
    hideBorder: {
      type: Boolean,
      default: false
    },
    hideCellBorder: {
      type: Boolean,
      default: false
    },
    hideHeadingBorder: {
      type: Boolean,
      default: false
    },
    cascade: {
      type: Boolean,
      default: true
    },
    indent: {
      type: Number,
      default: 16
    },
    remote: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    onLoad: {
      type: Function,
      default: void 0
    },
    onScroll: {
      type: Function,
      default: void 0
    },
    hideFooter: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "update:page",
    "update:page-size",
    "update:searchText",
    "update:filter",
    "update:checkedRowKeys",
    "update:sorter",
    "update:defaultTab",
    "update:dragSort"
  ],
  setup(e28, { emit: z3 }) {
    const t3 = e28, m3 = z3;
    function w3(a3) {
      m3("update:defaultTab", a3.key);
    }
    function $3(a3) {
      m3("update:searchText", a3);
    }
    const i = useSlots(), v3 = ref$1(false), c3 = ref$1([]), C3 = (a3) => {
      if (t3.dragSort) {
        const {
          data: { oldIndex: r3, newIndex: g3 }
        } = a3, h3 = n$1c({
          array: c3.value.length ? c3.value : t3.data,
          oldIndex: r3,
          newIndex: g3
        });
        m3("update:dragSort", {
          updatedList: h3,
          sorted: c3.value.length ? c3.value[r3] : t3.data[r3],
          oldIndex: r3,
          newIndex: g3
        }), c3.value = h3;
      }
    }, S3 = () => {
      if ((t3 == null ? void 0 : t3.dragSort) === true && (t3 != null && t3.data) && !v3.value) {
        const a3 = v$K(t3 == null ? void 0 : t3.dragIconClass);
        a3 ? (a3.on("sortable:stop", C3), v3.value = true) : console.warn(`ghl-ui:: Dragging is not initialized for table - ${t3.id}`);
      }
    };
    onMounted(() => {
      S3();
    }), onUpdated(() => S3());
    const x3 = computed(() => (t3 == null ? void 0 : t3.tabs.length) || (t3 == null ? void 0 : t3.enableTextSearch) || i["filter-right"] || i["filter-left"] || i["filter-left-start"] || i["filter-left-end"] || i["filter-right-start"] || i["filter-right-end"] || (t3 == null ? void 0 : t3.filterCollapseItems.length));
    return (a3, r3) => {
      var g3, h3;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["table-container", {
          "ghl-transparent-heading": e28.transparent,
          "hide-border": e28.hideBorder,
          "hide-cell-border": e28.hideCellBorder,
          "hide-header-border": e28.hideHeadingBorder,
          "hide-footer": e28.hideFooter
        }])
      }, [
        createElementVNode("div", G$o, [
          x3.value ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(i).breadcrumb ? "filter-bar-breadcrumb" : "filter-bar")
          }, [
            createElementVNode("div", M$l, [
              renderSlot(a3.$slots, "filter-left"),
              (g3 = unref(i)) != null && g3["filter-left"] ? createCommentVNode("", true) : renderSlot(a3.$slots, "filter-left-start", { key: 0 }),
              e28.tabs.length ? (openBlock(), createBlock(unref(B$D), { key: 1 }, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(e28.tabs, (l3) => (openBlock(), createBlock(unref(q$C), {
                    size: "large",
                    key: l3.key,
                    onClick: (re2) => w3(l3),
                    id: `hl-table-${e28.id}-filter-tab-${l3.key}`,
                    active: e28.defaultTab === l3.key
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(l3 == null ? void 0 : l3.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "id", "active"]))), 128))
                ]),
                _: 1
              })) : createCommentVNode("", true),
              renderSlot(a3.$slots, "filter-left-end")
            ]),
            createElementVNode("div", J$l, [
              renderSlot(a3.$slots, "filter-right"),
              (h3 = unref(i)) != null && h3["filter-right"] ? createCommentVNode("", true) : renderSlot(a3.$slots, "filter-right-start", { key: 0 }),
              e28.enableTextSearch ? (openBlock(), createBlock(unref(P$O), {
                key: 1,
                class: "filter-search",
                modelValue: e28.searchText,
                "onUpdate:modelValue": $3,
                clearable: "",
                size: "large",
                placeholder: e28.searchInputPlaceholder,
                id: `hl-table-${e28.id}-filter-text-search`
              }, {
                prefix: withCtx(() => [
                  createVNode(unref(a$1K), { class: "w-4 h-4" })
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder", "id"])) : createCommentVNode("", true),
              e28.filterCollapseItems.length ? (openBlock(), createBlock(unref(ue$g), {
                key: 2,
                options: e28.filterOptions,
                collapseItems: e28.filterCollapseItems,
                id: e28.id,
                "onUpdate:filter": r3[0] || (r3[0] = (l3) => m3("update:filter", l3))
              }, null, 8, ["options", "collapseItems", "id"])) : createCommentVNode("", true),
              renderSlot(a3.$slots, "filter-right-end")
            ])
          ], 2)) : createCommentVNode("", true),
          unref(i).breadcrumb ? (openBlock(), createElementBlock("div", Q$k, [
            renderSlot(a3.$slots, "breadcrumb")
          ])) : createCommentVNode("", true)
        ]),
        createElementVNode("div", W$k, [
          createVNode(unref(st$8), {
            "default-expand-all": e28.defaultExpandAll,
            "onUpdate:sorter": r3[1] || (r3[1] = (l3) => a3.$emit("update:sorter", l3)),
            "checked-row-keys": e28.checkedRowKeys,
            "onUpdate:checkedRowKeys": r3[2] || (r3[2] = (l3) => a3.$emit("update:checkedRowKeys", l3)),
            "row-key": e28.rowKey,
            columns: t3.columns,
            data: e28.data,
            pagination: false,
            bordered: false,
            loading: e28.loading,
            "scroll-x": e28.scrollX,
            "scrollbar-props": e28.scrollbarProps,
            "virtual-scroll": e28.virtualScroll,
            "flex-height": e28.flexHeight,
            "max-height": e28.maxHeight,
            "min-height": e28.minHeight,
            "table-layout": e28.tableLayout,
            "row-class-name": e28.rowClassName,
            "row-props": e28.rowProps,
            cascade: e28.cascade,
            indent: e28.indent,
            remote: e28.remote,
            striped: e28.striped,
            onLoad: e28.onLoad,
            onScroll: e28.onScroll
          }, {
            empty: withCtx(() => [
              renderSlot(a3.$slots, "empty")
            ]),
            _: 3
          }, 8, ["default-expand-all", "checked-row-keys", "row-key", "columns", "data", "loading", "scroll-x", "scrollbar-props", "virtual-scroll", "flex-height", "max-height", "min-height", "table-layout", "row-class-name", "row-props", "cascade", "indent", "remote", "striped", "onLoad", "onScroll"]),
          e28.hideFooter ? createCommentVNode("", true) : (openBlock(), createElementBlock("div", Y$j, [
            e28.data.length ? (openBlock(), createElementBlock("div", Z$m, [
              createElementVNode("div", _$s, [
                unref(i)["footer-left"] ? renderSlot(a3.$slots, "footer-left", { key: 0 }) : createCommentVNode("", true)
              ]),
              createElementVNode("div", ee$e, [
                unref(i).pagination ? renderSlot(a3.$slots, "pagination", { key: 0 }) : (openBlock(), createElementBlock("div", te$f, [
                  createVNode(unref(v$N), {
                    "show-size-picker": e28.showSizePicker,
                    "page-sizes": e28.pageSizes,
                    "page-size": e28.pageSize,
                    "page-count": e28.pageCount,
                    "onUpdate:page": r3[3] || (r3[3] = (l3) => a3.$emit("update:page", l3)),
                    "onUpdate:pageSize": r3[4] || (r3[4] = (l3) => a3.$emit("update:page-size", l3)),
                    page: e28.page,
                    id: e28.id,
                    "page-slot": e28.pageSlot
                  }, null, 8, ["show-size-picker", "page-sizes", "page-size", "page-count", "page", "id", "page-slot"])
                ]))
              ])
            ])) : createCommentVNode("", true)
          ]))
        ])
      ], 2);
    };
  }
})), ke$b = le$d;
const _$r = { class: "flex space-x-1" };
defineComponent({
  name: "UIActionButtons"
});
const h$16 = defineComponent({
  __name: "ActionButtons",
  props: {
    options: Array,
    id: {
      type: String,
      required: true
    },
    placement: String
  },
  emits: ["click"],
  setup(n3, { emit: r3 }) {
    const m3 = r3, p3 = (c3, l3) => {
      l3.preventDefault(), m3("click", c3);
    };
    return (c3, l3) => (openBlock(), createElementBlock("div", _$r, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(n3.options, (e28) => (openBlock(), createBlock(unref(q$C), {
        id: `${n3.id}-action-btn-${e28.key}`,
        disabled: e28 == null ? void 0 : e28.disabled,
        key: e28.key,
        tooltip: "test",
        onClick: (u3) => p3(e28, u3),
        circle: "",
        quaternary: ""
      }, {
        default: withCtx(() => [
          createVNode(unref(w$K), {
            placement: n3.placement,
            disabled: !e28.label
          }, {
            trigger: withCtx(() => [
              (openBlock(), createBlock(resolveDynamicComponent(e28 == null ? void 0 : e28.icon)))
            ]),
            default: withCtx(() => [
              createTextVNode(" " + toDisplayString(e28.label), 1)
            ]),
            _: 2
          }, 1032, ["placement", "disabled"])
        ]),
        _: 2
      }, 1032, ["id", "disabled", "onClick"]))), 128))
    ]));
  }
}), S$u = h$16;
function l$19(t3, n3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 13a1 1 0 100-2 1 1 0 000 2zM12 6a1 1 0 100-2 1 1 0 000 2zM12 20a1 1 0 100-2 1 1 0 000 2z"
    })
  ]);
}
const p$35 = defineComponent({
  name: "UIDropdown",
  inheritAttrs: false
}), f$Z = defineComponent(__spreadProps(__spreadValues({}, p$35), {
  props: {
    trigger: {
      type: String,
      default: "click"
    },
    options: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: "medium"
    },
    placement: {
      type: String,
      default: "top"
    },
    show: {
      type: Boolean,
      default: void 0
    },
    renderOption: {
      type: Function,
      default: void 0
    },
    renderLabel: {
      type: Function,
      default: void 0
    },
    renderIcon: {
      type: Function,
      default: void 0
    }
  },
  emits: ["select", "update:show", "clickoutside"],
  setup(e28) {
    return (n3, t3) => (openBlock(), createBlock(unref(Le$6), {
      id: e28.id,
      trigger: e28.trigger,
      options: e28.options,
      placement: e28.placement,
      size: e28.size,
      show: e28.show,
      "render-label": e28.renderLabel,
      "render-icon": e28.renderIcon,
      "render-option": e28.renderOption,
      onSelect: t3[0] || (t3[0] = (o3) => n3.$emit("select", o3)),
      "onUpdate:show": t3[1] || (t3[1] = (o3) => n3.$emit("update:show", o3)),
      onClickoutside: t3[2] || (t3[2] = (o3) => n3.$emit("clickoutside"))
    }, {
      default: withCtx(() => [
        renderSlot(n3.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "trigger", "options", "placement", "size", "show", "render-label", "render-icon", "render-option"]));
  }
})), g$Q = f$Z;
defineComponent({
  name: "UIActionDropdown"
});
const w$x = defineComponent({
  __name: "ActionDropdown",
  props: __spreadProps(__spreadValues({}, g$Q.props), {
    id: {
      type: String,
      required: true
    }
  }),
  emits: ["select"],
  setup(t3, { emit: c3 }) {
    const d3 = c3;
    function m3(o3) {
      d3("select", o3);
    }
    return (o3, g3) => (openBlock(), createBlock(unref(g$Q), mergeProps({
      options: o3.options,
      onSelect: m3,
      id: `${t3.id}-action-dropdown`
    }, o3.$props), {
      default: withCtx(() => [
        createVNode(unref(q$C), {
          quaternary: "",
          circle: "",
          iconOnly: "",
          id: `${t3.id}-action-dropdown-trigger`
        }, {
          default: withCtx(() => [
            createVNode(unref(l$19), { class: "w-5 h-5" })
          ]),
          _: 1
        }, 8, ["id"])
      ]),
      _: 1
    }, 16, ["options", "id"]));
  }
}), A$u = w$x;
const n$U = n$28("n-tabs");
const b$K = {
  tab: [String, Number, Object, Function],
  name: {
    type: [String, Number],
    required: true
  },
  disabled: Boolean,
  displayDirective: {
    type: String,
    default: "if"
  },
  closable: {
    type: Boolean,
    default: void 0
  },
  tabProps: Object,
  label: [String, Number, Object, Function]
}, f$Y = defineComponent({
  __TAB_PANE__: true,
  name: "TabPane",
  alias: ["TabPanel"],
  props: b$K,
  setup(t3) {
    const e28 = inject(n$U, null);
    return e28 || t$1P("tab-pane", "`n-tab-pane` must be placed inside `n-tabs`."), {
      style: e28.paneStyleRef,
      class: e28.paneClassRef,
      mergedClsPrefix: e28.mergedClsPrefixRef
    };
  },
  render() {
    return h$1R("div", {
      class: [`${this.mergedClsPrefix}-tab-pane`, this.class],
      style: this.style
    }, this.$slots);
  }
});
const r$18 = defineComponent({
  name: "Add",
  render() {
    return h$1R("svg", {
      width: "512",
      height: "512",
      viewBox: "0 0 512 512",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, h$1R("path", {
      d: "M256 112V400M400 256H112",
      stroke: "currentColor",
      "stroke-width": "32",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }));
  }
});
const I$w = Object.assign({
  internalLeftPadded: Boolean,
  internalAddable: Boolean,
  internalCreatedByPane: Boolean
}, i$1g(b$K, ["displayDirective"])), q$o = defineComponent({
  __TAB__: true,
  inheritAttrs: false,
  name: "Tab",
  props: I$w,
  setup(a3) {
    const {
      mergedClsPrefixRef: e28,
      valueRef: l3,
      typeRef: d3,
      closableRef: i,
      tabStyleRef: f3,
      addTabStyleRef: c3,
      tabClassRef: o3,
      addTabClassRef: b3,
      tabChangeIdRef: r3,
      onBeforeLeaveRef: n3,
      triggerRef: h3,
      handleAdd: v3,
      activateTab: u3,
      handleClose: C3
    } = inject(n$U);
    return {
      trigger: h3,
      mergedClosable: computed(() => {
        if (a3.internalAddable)
          return false;
        const {
          closable: s3
        } = a3;
        return s3 === void 0 ? i.value : s3;
      }),
      style: f3,
      addStyle: c3,
      tabClass: o3,
      addTabClass: b3,
      clsPrefix: e28,
      value: l3,
      type: d3,
      handleClose(s3) {
        s3.stopPropagation(), !a3.disabled && C3(a3.name);
      },
      activateTab() {
        if (a3.disabled)
          return;
        if (a3.internalAddable) {
          v3();
          return;
        }
        const {
          name: s3
        } = a3, g3 = ++r3.id;
        if (s3 !== l3.value) {
          const {
            value: m3
          } = n3;
          m3 ? Promise.resolve(m3(a3.name, l3.value)).then((p3) => {
            p3 && r3.id === g3 && u3(s3);
          }) : u3(s3);
        }
      }
    };
  },
  render() {
    const {
      internalAddable: a3,
      clsPrefix: e28,
      name: l3,
      disabled: d3,
      label: i,
      tab: f3,
      value: c3,
      mergedClosable: o3,
      trigger: b3,
      $slots: {
        default: r3
      }
    } = this, n3 = i != null ? i : f3;
    return h$1R("div", {
      class: `${e28}-tabs-tab-wrapper`
    }, this.internalLeftPadded ? h$1R("div", {
      class: `${e28}-tabs-tab-pad`
    }) : null, h$1R("div", Object.assign({
      key: l3,
      "data-name": l3,
      "data-disabled": d3 ? true : void 0
    }, mergeProps({
      class: [`${e28}-tabs-tab`, c3 === l3 && `${e28}-tabs-tab--active`, d3 && `${e28}-tabs-tab--disabled`, o3 && `${e28}-tabs-tab--closable`, a3 && `${e28}-tabs-tab--addable`, a3 ? this.addTabClass : this.tabClass],
      onClick: b3 === "click" ? this.activateTab : void 0,
      onMouseenter: b3 === "hover" ? this.activateTab : void 0,
      style: a3 ? this.addStyle : this.style
    }, this.internalCreatedByPane ? this.tabProps || {} : this.$attrs)), h$1R("span", {
      class: `${e28}-tabs-tab__label`
    }, a3 ? h$1R(Fragment, null, h$1R("div", {
      class: `${e28}-tabs-tab__height-placeholder`
    }, "\xA0"), h$1R(d$1R, {
      clsPrefix: e28
    }, {
      default: () => h$1R(r$18, null)
    })) : r3 ? r3() : typeof n3 == "object" ? n3 : o$1c(n3 != null ? n3 : l3)), o3 && this.type === "card" ? h$1R(g$1b, {
      clsPrefix: e28,
      class: `${e28}-tabs-tab__close`,
      onClick: this.handleClose,
      disabled: d3
    }) : null));
  }
});
const n$T = l$25("tabs", `
 box-sizing: border-box;
 width: 100%;
 display: flex;
 flex-direction: column;
 transition:
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
`, [g$1j("segment-type", [l$25("tabs-rail", [r$2a("&.transition-disabled", [l$25("tabs-capsule", `
 transition: none;
 `)])])]), g$1j("top", [l$25("tab-pane", `
 padding: var(--n-pane-padding-top) var(--n-pane-padding-right) var(--n-pane-padding-bottom) var(--n-pane-padding-left);
 `)]), g$1j("left", [l$25("tab-pane", `
 padding: var(--n-pane-padding-right) var(--n-pane-padding-bottom) var(--n-pane-padding-left) var(--n-pane-padding-top);
 `)]), g$1j("left, right", `
 flex-direction: row;
 `, [l$25("tabs-bar", `
 width: 2px;
 right: 0;
 transition:
 top .2s var(--n-bezier),
 max-height .2s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `), l$25("tabs-tab", `
 padding: var(--n-tab-padding-vertical); 
 `)]), g$1j("right", `
 flex-direction: row-reverse;
 `, [l$25("tab-pane", `
 padding: var(--n-pane-padding-left) var(--n-pane-padding-top) var(--n-pane-padding-right) var(--n-pane-padding-bottom);
 `), l$25("tabs-bar", `
 left: 0;
 `)]), g$1j("bottom", `
 flex-direction: column-reverse;
 justify-content: flex-end;
 `, [l$25("tab-pane", `
 padding: var(--n-pane-padding-bottom) var(--n-pane-padding-right) var(--n-pane-padding-top) var(--n-pane-padding-left);
 `), l$25("tabs-bar", `
 top: 0;
 `)]), l$25("tabs-rail", `
 padding: 3px;
 border-radius: var(--n-tab-border-radius);
 width: 100%;
 background-color: var(--n-color-segment);
 transition: background-color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 `, [l$25("tabs-capsule", `
 border-radius: var(--n-tab-border-radius);
 position: absolute;
 pointer-events: none;
 background-color: var(--n-tab-color-segment);
 box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .08);
 transition: transform 0.3s var(--n-bezier);
 `), l$25("tabs-tab-wrapper", `
 flex-basis: 0;
 flex-grow: 1;
 display: flex;
 align-items: center;
 justify-content: center;
 `, [l$25("tabs-tab", `
 overflow: hidden;
 border-radius: var(--n-tab-border-radius);
 width: 100%;
 display: flex;
 align-items: center;
 justify-content: center;
 `, [g$1j("active", `
 font-weight: var(--n-font-weight-strong);
 color: var(--n-tab-text-color-active);
 `), r$2a("&:hover", `
 color: var(--n-tab-text-color-hover);
 `)])])]), g$1j("flex", [l$25("tabs-nav", `
 width: 100%;
 position: relative;
 `, [l$25("tabs-wrapper", `
 width: 100%;
 `, [l$25("tabs-tab", `
 margin-right: 0;
 `)])])]), l$25("tabs-nav", `
 box-sizing: border-box;
 line-height: 1.5;
 display: flex;
 transition: border-color .3s var(--n-bezier);
 `, [M$y("prefix, suffix", `
 display: flex;
 align-items: center;
 `), M$y("prefix", "padding-right: 16px;"), M$y("suffix", "padding-left: 16px;")]), g$1j("top, bottom", [l$25("tabs-nav-scroll-wrapper", [r$2a("&::before", `
 top: 0;
 bottom: 0;
 left: 0;
 width: 20px;
 `), r$2a("&::after", `
 top: 0;
 bottom: 0;
 right: 0;
 width: 20px;
 `), g$1j("shadow-start", [r$2a("&::before", `
 box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, .12);
 `)]), g$1j("shadow-end", [r$2a("&::after", `
 box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, .12);
 `)])])]), g$1j("left, right", [l$25("tabs-nav-scroll-content", `
 flex-direction: column;
 `), l$25("tabs-nav-scroll-wrapper", [r$2a("&::before", `
 top: 0;
 left: 0;
 right: 0;
 height: 20px;
 `), r$2a("&::after", `
 bottom: 0;
 left: 0;
 right: 0;
 height: 20px;
 `), g$1j("shadow-start", [r$2a("&::before", `
 box-shadow: inset 0 10px 8px -8px rgba(0, 0, 0, .12);
 `)]), g$1j("shadow-end", [r$2a("&::after", `
 box-shadow: inset 0 -10px 8px -8px rgba(0, 0, 0, .12);
 `)])])]), l$25("tabs-nav-scroll-wrapper", `
 flex: 1;
 position: relative;
 overflow: hidden;
 `, [l$25("tabs-nav-y-scroll", `
 height: 100%;
 width: 100%;
 overflow-y: auto; 
 scrollbar-width: none;
 `, [r$2a("&::-webkit-scrollbar", `
 width: 0;
 height: 0;
 `)]), r$2a("&::before, &::after", `
 transition: box-shadow .3s var(--n-bezier);
 pointer-events: none;
 content: "";
 position: absolute;
 z-index: 1;
 `)]), l$25("tabs-nav-scroll-content", `
 display: flex;
 position: relative;
 min-width: 100%;
 min-height: 100%;
 width: fit-content;
 box-sizing: border-box;
 `), l$25("tabs-wrapper", `
 display: inline-flex;
 flex-wrap: nowrap;
 position: relative;
 `), l$25("tabs-tab-wrapper", `
 display: flex;
 flex-wrap: nowrap;
 flex-shrink: 0;
 flex-grow: 0;
 `), l$25("tabs-tab", `
 cursor: pointer;
 white-space: nowrap;
 flex-wrap: nowrap;
 display: inline-flex;
 align-items: center;
 color: var(--n-tab-text-color);
 font-size: var(--n-tab-font-size);
 background-clip: padding-box;
 padding: var(--n-tab-padding);
 transition:
 box-shadow .3s var(--n-bezier),
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [g$1j("disabled", {
  cursor: "not-allowed"
}), M$y("close", `
 margin-left: 6px;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `), M$y("label", `
 display: flex;
 align-items: center;
 z-index: 1;
 `)]), l$25("tabs-bar", `
 position: absolute;
 bottom: 0;
 height: 2px;
 border-radius: 1px;
 background-color: var(--n-bar-color);
 transition:
 left .2s var(--n-bezier),
 max-width .2s var(--n-bezier),
 opacity .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `, [r$2a("&.transition-disabled", `
 transition: none;
 `), g$1j("disabled", `
 background-color: var(--n-tab-text-color-disabled)
 `)]), l$25("tabs-pane-wrapper", `
 position: relative;
 overflow: hidden;
 transition: max-height .2s var(--n-bezier);
 `), l$25("tab-pane", `
 color: var(--n-pane-text-color);
 width: 100%;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 opacity .2s var(--n-bezier);
 left: 0;
 right: 0;
 top: 0;
 `, [r$2a("&.next-transition-leave-active, &.prev-transition-leave-active, &.next-transition-enter-active, &.prev-transition-enter-active", `
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 transform .2s var(--n-bezier),
 opacity .2s var(--n-bezier);
 `), r$2a("&.next-transition-leave-active, &.prev-transition-leave-active", `
 position: absolute;
 `), r$2a("&.next-transition-enter-from, &.prev-transition-leave-to", `
 transform: translateX(32px);
 opacity: 0;
 `), r$2a("&.next-transition-leave-to, &.prev-transition-enter-from", `
 transform: translateX(-32px);
 opacity: 0;
 `), r$2a("&.next-transition-leave-from, &.next-transition-enter-to, &.prev-transition-leave-from, &.prev-transition-enter-to", `
 transform: translateX(0);
 opacity: 1;
 `)]), l$25("tabs-tab-pad", `
 box-sizing: border-box;
 width: var(--n-tab-gap);
 flex-grow: 0;
 flex-shrink: 0;
 `), g$1j("line-type, bar-type", [l$25("tabs-tab", `
 font-weight: var(--n-tab-font-weight);
 box-sizing: border-box;
 vertical-align: bottom;
 `, [r$2a("&:hover", {
  color: "var(--n-tab-text-color-hover)"
}), g$1j("active", `
 color: var(--n-tab-text-color-active);
 font-weight: var(--n-tab-font-weight-active);
 `), g$1j("disabled", {
  color: "var(--n-tab-text-color-disabled)"
})])]), l$25("tabs-nav", [g$1j("line-type", [g$1j("top", [M$y("prefix, suffix", `
 border-bottom: 1px solid var(--n-tab-border-color);
 `), l$25("tabs-nav-scroll-content", `
 border-bottom: 1px solid var(--n-tab-border-color);
 `), l$25("tabs-bar", `
 bottom: -1px;
 `)]), g$1j("left", [M$y("prefix, suffix", `
 border-right: 1px solid var(--n-tab-border-color);
 `), l$25("tabs-nav-scroll-content", `
 border-right: 1px solid var(--n-tab-border-color);
 `), l$25("tabs-bar", `
 right: -1px;
 `)]), g$1j("right", [M$y("prefix, suffix", `
 border-left: 1px solid var(--n-tab-border-color);
 `), l$25("tabs-nav-scroll-content", `
 border-left: 1px solid var(--n-tab-border-color);
 `), l$25("tabs-bar", `
 left: -1px;
 `)]), g$1j("bottom", [M$y("prefix, suffix", `
 border-top: 1px solid var(--n-tab-border-color);
 `), l$25("tabs-nav-scroll-content", `
 border-top: 1px solid var(--n-tab-border-color);
 `), l$25("tabs-bar", `
 top: -1px;
 `)]), M$y("prefix, suffix", `
 transition: border-color .3s var(--n-bezier);
 `), l$25("tabs-nav-scroll-content", `
 transition: border-color .3s var(--n-bezier);
 `), l$25("tabs-bar", `
 border-radius: 0;
 `)]), g$1j("card-type", [M$y("prefix, suffix", `
 transition: border-color .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-tab-border-color);
 `), l$25("tabs-pad", `
 flex-grow: 1;
 transition: border-color .3s var(--n-bezier);
 `), l$25("tabs-tab-pad", `
 transition: border-color .3s var(--n-bezier);
 `), l$25("tabs-tab", `
 font-weight: var(--n-tab-font-weight);
 border: 1px solid var(--n-tab-border-color);
 background-color: var(--n-tab-color);
 box-sizing: border-box;
 position: relative;
 vertical-align: bottom;
 display: flex;
 justify-content: space-between;
 font-size: var(--n-tab-font-size);
 color: var(--n-tab-text-color);
 `, [g$1j("addable", `
 padding-left: 8px;
 padding-right: 8px;
 font-size: 16px;
 `, [M$y("height-placeholder", `
 width: 0;
 font-size: var(--n-tab-font-size);
 `), x$I("disabled", [r$2a("&:hover", `
 color: var(--n-tab-text-color-hover);
 `)])]), g$1j("closable", "padding-right: 8px;"), g$1j("active", `
 background-color: #0000;
 font-weight: var(--n-tab-font-weight-active);
 color: var(--n-tab-text-color-active);
 `), g$1j("disabled", "color: var(--n-tab-text-color-disabled);")]), l$25("tabs-scroll-padding", "border-bottom: 1px solid var(--n-tab-border-color);")]), g$1j("left, right", [l$25("tabs-wrapper", `
 flex-direction: column;
 `, [l$25("tabs-tab-wrapper", `
 flex-direction: column;
 `, [l$25("tabs-tab-pad", `
 height: var(--n-tab-gap-vertical);
 width: 100%;
 `)])])]), g$1j("top", [g$1j("card-type", [l$25("tabs-tab", `
 border-top-left-radius: var(--n-tab-border-radius);
 border-top-right-radius: var(--n-tab-border-radius);
 `, [g$1j("active", `
 border-bottom: 1px solid #0000;
 `)]), l$25("tabs-tab-pad", `
 border-bottom: 1px solid var(--n-tab-border-color);
 `), l$25("tabs-pad", `
 border-bottom: 1px solid var(--n-tab-border-color);
 `)])]), g$1j("left", [g$1j("card-type", [l$25("tabs-tab", `
 border-top-left-radius: var(--n-tab-border-radius);
 border-bottom-left-radius: var(--n-tab-border-radius);
 `, [g$1j("active", `
 border-right: 1px solid #0000;
 `)]), l$25("tabs-tab-pad", `
 border-right: 1px solid var(--n-tab-border-color);
 `), l$25("tabs-pad", `
 border-right: 1px solid var(--n-tab-border-color);
 `)])]), g$1j("right", [g$1j("card-type", [l$25("tabs-tab", `
 border-top-right-radius: var(--n-tab-border-radius);
 border-bottom-right-radius: var(--n-tab-border-radius);
 `, [g$1j("active", `
 border-left: 1px solid #0000;
 `)]), l$25("tabs-tab-pad", `
 border-left: 1px solid var(--n-tab-border-color);
 `), l$25("tabs-pad", `
 border-left: 1px solid var(--n-tab-border-color);
 `)])]), g$1j("bottom", [g$1j("card-type", [l$25("tabs-tab", `
 border-bottom-left-radius: var(--n-tab-border-radius);
 border-bottom-right-radius: var(--n-tab-border-radius);
 `, [g$1j("active", `
 border-top: 1px solid #0000;
 `)]), l$25("tabs-tab-pad", `
 border-top: 1px solid var(--n-tab-border-color);
 `), l$25("tabs-pad", `
 border-top: 1px solid var(--n-tab-border-color);
 `)])])])]);
var t$Y = function() {
  return f$1Y.Date.now();
};
const r$17 = t$Y;
var r$16 = /\s/;
function a$1m(t3) {
  for (var e28 = t3.length; e28-- && r$16.test(t3.charAt(e28)); )
    ;
  return e28;
}
var a$1l = /^\s+/;
function t$X(e28) {
  return e28 && e28.slice(0, a$1m(e28) + 1).replace(a$1l, "");
}
var s$1g = 0 / 0, m$1t = /^[-+]0x[0-9a-f]+$/i, p$34 = /^0b[01]+$/i, e$13 = /^0o[0-7]+$/i, b$J = parseInt;
function O$r(r3) {
  if (typeof r3 == "number")
    return r3;
  if (i$1K(r3))
    return s$1g;
  if (n$24(r3)) {
    var t3 = typeof r3.valueOf == "function" ? r3.valueOf() : r3;
    r3 = n$24(t3) ? t3 + "" : t3;
  }
  if (typeof r3 != "string")
    return r3 === 0 ? r3 : +r3;
  r3 = t$X(r3);
  var i = p$34.test(r3);
  return i || e$13.test(r3) ? b$J(r3.slice(2), i ? 2 : 8) : m$1t.test(r3) ? s$1g : +r3;
}
var y$I = "Expected a function", R$k = Math.max, A$t = Math.min;
function _$q(x3, i, u3) {
  var a3, d3, c3, f3, n3, r3, l3 = 0, E3 = false, m3 = false, g3 = true;
  if (typeof x3 != "function")
    throw new TypeError(y$I);
  i = O$r(i) || 0, n$24(u3) && (E3 = !!u3.leading, m3 = "maxWait" in u3, c3 = m3 ? R$k(O$r(u3.maxWait) || 0, i) : c3, g3 = "trailing" in u3 ? !!u3.trailing : g3);
  function v3(e28) {
    var t3 = a3, o3 = d3;
    return a3 = d3 = void 0, l3 = e28, f3 = x3.apply(o3, t3), f3;
  }
  function b3(e28) {
    return l3 = e28, n3 = setTimeout(s3, i), E3 ? v3(e28) : f3;
  }
  function C3(e28) {
    var t3 = e28 - r3, o3 = e28 - l3, p3 = i - t3;
    return m3 ? A$t(p3, c3 - o3) : p3;
  }
  function k3(e28) {
    var t3 = e28 - r3, o3 = e28 - l3;
    return r3 === void 0 || t3 >= i || t3 < 0 || m3 && o3 >= c3;
  }
  function s3() {
    var e28 = r$17();
    if (k3(e28))
      return I3(e28);
    n3 = setTimeout(s3, C3(e28));
  }
  function I3(e28) {
    return n3 = void 0, g3 && a3 ? v3(e28) : (a3 = d3 = void 0, f3);
  }
  function L3() {
    n3 !== void 0 && clearTimeout(n3), l3 = 0, a3 = r3 = d3 = n3 = void 0;
  }
  function M3() {
    return n3 === void 0 ? f3 : I3(r$17());
  }
  function T3() {
    var e28 = r$17(), t3 = k3(e28);
    if (a3 = arguments, d3 = this, r3 = e28, t3) {
      if (n3 === void 0)
        return b3(r3);
      if (m3)
        return clearTimeout(n3), n3 = setTimeout(s3, i), v3(r3);
    }
    return n3 === void 0 && (n3 = setTimeout(s3, i)), f3;
  }
  return T3.cancel = L3, T3.flush = M3, T3;
}
var f$X = "Expected a function";
function u$1a(t3, a3, r3) {
  var e28 = true, i = true;
  if (typeof t3 != "function")
    throw new TypeError(f$X);
  return n$24(r3) && (e28 = "leading" in r3 ? !!r3.leading : e28, i = "trailing" in r3 ? !!r3.trailing : i), _$q(t3, a3, {
    leading: e28,
    maxWait: a3,
    trailing: i
  });
}
const h$15 = c$1N(".v-x-scroll", {
  overflow: "auto",
  scrollbarWidth: "none"
}, [
  c$1N("&::-webkit-scrollbar", {
    width: 0,
    height: 0
  })
]), m$1s = defineComponent({
  name: "XScroll",
  props: {
    disabled: Boolean,
    onScroll: Function
  },
  setup() {
    const o3 = ref$1(null);
    function l3(e28) {
      !(e28.currentTarget.offsetWidth < e28.currentTarget.scrollWidth) || e28.deltaY === 0 || (e28.currentTarget.scrollLeft += e28.deltaY + e28.deltaX, e28.preventDefault());
    }
    const s3 = f$1Z();
    return h$15.mount({
      id: "vueuc/x-scroll",
      head: true,
      anchorMetaName: o$1k,
      ssr: s3
    }), Object.assign({
      selfRef: o3,
      handleWheel: l3
    }, {
      scrollTo(...e28) {
        var r3;
        (r3 = o3.value) === null || r3 === void 0 || r3.scrollTo(...e28);
      }
    });
  },
  render() {
    return h$1R("div", {
      ref: "selfRef",
      onScroll: this.onScroll,
      onWheel: this.disabled ? void 0 : this.handleWheel,
      class: "v-x-scroll"
    }, this.$slots);
  }
});
const a$1k = {
  tabFontSizeSmall: "14px",
  tabFontSizeMedium: "14px",
  tabFontSizeLarge: "16px",
  tabGapSmallLine: "36px",
  tabGapMediumLine: "36px",
  tabGapLargeLine: "36px",
  tabGapSmallLineVertical: "8px",
  tabGapMediumLineVertical: "8px",
  tabGapLargeLineVertical: "8px",
  tabPaddingSmallLine: "6px 0",
  tabPaddingMediumLine: "10px 0",
  tabPaddingLargeLine: "14px 0",
  tabPaddingVerticalSmallLine: "6px 12px",
  tabPaddingVerticalMediumLine: "8px 16px",
  tabPaddingVerticalLargeLine: "10px 20px",
  tabGapSmallBar: "36px",
  tabGapMediumBar: "36px",
  tabGapLargeBar: "36px",
  tabGapSmallBarVertical: "8px",
  tabGapMediumBarVertical: "8px",
  tabGapLargeBarVertical: "8px",
  tabPaddingSmallBar: "4px 0",
  tabPaddingMediumBar: "6px 0",
  tabPaddingLargeBar: "10px 0",
  tabPaddingVerticalSmallBar: "6px 12px",
  tabPaddingVerticalMediumBar: "8px 16px",
  tabPaddingVerticalLargeBar: "10px 20px",
  tabGapSmallCard: "4px",
  tabGapMediumCard: "4px",
  tabGapLargeCard: "4px",
  tabGapSmallCardVertical: "4px",
  tabGapMediumCardVertical: "4px",
  tabGapLargeCardVertical: "4px",
  tabPaddingSmallCard: "8px 16px",
  tabPaddingMediumCard: "10px 20px",
  tabPaddingLargeCard: "12px 24px",
  tabPaddingSmallSegment: "4px 0",
  tabPaddingMediumSegment: "6px 0",
  tabPaddingLargeSegment: "8px 0",
  tabPaddingVerticalLargeSegment: "0 8px",
  tabPaddingVerticalSmallCard: "8px 12px",
  tabPaddingVerticalMediumCard: "10px 16px",
  tabPaddingVerticalLargeCard: "12px 20px",
  tabPaddingVerticalSmallSegment: "0 4px",
  tabPaddingVerticalMediumSegment: "0 6px",
  tabGapSmallSegment: "0",
  tabGapMediumSegment: "0",
  tabGapLargeSegment: "0",
  tabGapSmallSegmentVertical: "0",
  tabGapMediumSegmentVertical: "0",
  tabGapLargeSegmentVertical: "0",
  panePaddingSmall: "8px 0 0 0",
  panePaddingMedium: "12px 0 0 0",
  panePaddingLarge: "16px 0 0 0",
  closeSize: "18px",
  closeIconSize: "14px"
};
const f$W = (C3) => {
  const {
    textColor2: r3,
    primaryColor: o3,
    textColorDisabled: t3,
    closeIconColor: i,
    closeIconColorHover: s3,
    closeIconColorPressed: n3,
    closeColorHover: c3,
    closeColorPressed: d3,
    tabColor: a3,
    baseColor: x3,
    dividerColor: T3,
    fontWeight: l3,
    textColor1: e28,
    borderRadius: b3,
    fontSize: g3,
    fontWeightStrong: m3
  } = C3;
  return Object.assign(Object.assign({}, a$1k), {
    colorSegment: a3,
    tabFontSizeCard: g3,
    tabTextColorLine: e28,
    tabTextColorActiveLine: o3,
    tabTextColorHoverLine: o3,
    tabTextColorDisabledLine: t3,
    tabTextColorSegment: e28,
    tabTextColorActiveSegment: r3,
    tabTextColorHoverSegment: r3,
    tabTextColorDisabledSegment: t3,
    tabTextColorBar: e28,
    tabTextColorActiveBar: o3,
    tabTextColorHoverBar: o3,
    tabTextColorDisabledBar: t3,
    tabTextColorCard: e28,
    tabTextColorHoverCard: e28,
    tabTextColorActiveCard: o3,
    tabTextColorDisabledCard: t3,
    barColor: o3,
    closeIconColor: i,
    closeIconColorHover: s3,
    closeIconColorPressed: n3,
    closeColorHover: c3,
    closeColorPressed: d3,
    closeBorderRadius: b3,
    tabColor: a3,
    tabColorSegment: x3,
    tabBorderColor: T3,
    tabFontWeightActive: l3,
    tabFontWeight: l3,
    tabBorderRadius: b3,
    paneTextColor: r3,
    fontWeightStrong: m3
  });
}, h$14 = {
  name: "Tabs",
  common: d$1T,
  self: f$W
}, H$l = h$14;
const yt$8 = Object.assign(Object.assign({}, _$F.props), {
  value: [String, Number],
  defaultValue: [String, Number],
  trigger: {
    type: String,
    default: "click"
  },
  type: {
    type: String,
    default: "bar"
  },
  closable: Boolean,
  justifyContent: String,
  size: {
    type: String,
    default: "medium"
  },
  placement: {
    type: String,
    default: "top"
  },
  tabStyle: [String, Object],
  tabClass: String,
  addTabStyle: [String, Object],
  addTabClass: String,
  barWidth: Number,
  paneClass: String,
  paneStyle: [String, Object],
  paneWrapperClass: String,
  paneWrapperStyle: [String, Object],
  addable: [Boolean, Object],
  tabsPadding: {
    type: Number,
    default: 0
  },
  animated: Boolean,
  onBeforeLeave: Function,
  onAdd: Function,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onClose: [Function, Array],
  labelSize: String,
  activeName: [String, Number],
  onActiveNameChange: [Function, Array]
}), It$6 = defineComponent({
  name: "Tabs",
  props: yt$8,
  setup(a3, {
    slots: r3
  }) {
    var $3, P3, m3, _3;
    const {
      mergedClsPrefixRef: d3,
      inlineThemeDisabled: y3
    } = a$2x(a3), T3 = _$F("Tabs", "-tabs", n$T, H$l, a3, d3), v3 = ref$1(null), p3 = ref$1(null), B3 = ref$1(null), L3 = ref$1(null), f3 = ref$1(null), b3 = ref$1(null), z3 = ref$1(true), S3 = ref$1(true), A3 = f$1j(a3, ["labelSize", "size"]), g3 = f$1j(a3, ["activeName", "value"]), O3 = ref$1((P3 = ($3 = g3.value) !== null && $3 !== void 0 ? $3 : a3.defaultValue) !== null && P3 !== void 0 ? P3 : r3.default ? (_3 = (m3 = i$1A(r3.default())[0]) === null || m3 === void 0 ? void 0 : m3.props) === null || _3 === void 0 ? void 0 : _3.name : null), h3 = d$1S(g3, O3), l3 = {
      id: 0
    }, c3 = computed(() => {
      if (!(!a3.justifyContent || a3.type === "card"))
        return {
          display: "flex",
          justifyContent: a3.justifyContent
        };
    });
    watch(h3, () => {
      l3.id = 0, D3(), se2();
    });
    function w3() {
      var t3;
      const {
        value: e28
      } = h3;
      return e28 === null ? null : (t3 = v3.value) === null || t3 === void 0 ? void 0 : t3.querySelector(`[data-name="${e28}"]`);
    }
    function ve2(t3) {
      if (a3.type === "card")
        return;
      const {
        value: e28
      } = p3;
      if (!e28)
        return;
      const n3 = e28.style.opacity === "0";
      if (t3) {
        const s3 = `${d3.value}-tabs-bar--disabled`, {
          barWidth: o3,
          placement: W3
        } = a3;
        if (t3.dataset.disabled === "true" ? e28.classList.add(s3) : e28.classList.remove(s3), ["top", "bottom"].includes(W3)) {
          if (ne2(["top", "maxHeight", "height"]), typeof o3 == "number" && t3.offsetWidth >= o3) {
            const C3 = Math.floor((t3.offsetWidth - o3) / 2) + t3.offsetLeft;
            e28.style.left = `${C3}px`, e28.style.maxWidth = `${o3}px`;
          } else
            e28.style.left = `${t3.offsetLeft}px`, e28.style.maxWidth = `${t3.offsetWidth}px`;
          e28.style.width = "8192px", n3 && (e28.style.transition = "none"), e28.offsetWidth, n3 && (e28.style.transition = "", e28.style.opacity = "1");
        } else {
          if (ne2(["left", "maxWidth", "width"]), typeof o3 == "number" && t3.offsetHeight >= o3) {
            const C3 = Math.floor((t3.offsetHeight - o3) / 2) + t3.offsetTop;
            e28.style.top = `${C3}px`, e28.style.maxHeight = `${o3}px`;
          } else
            e28.style.top = `${t3.offsetTop}px`, e28.style.maxHeight = `${t3.offsetHeight}px`;
          e28.style.height = "8192px", n3 && (e28.style.transition = "none"), e28.offsetHeight, n3 && (e28.style.transition = "", e28.style.opacity = "1");
        }
      }
    }
    function ge2() {
      if (a3.type === "card")
        return;
      const {
        value: t3
      } = p3;
      t3 && (t3.style.opacity = "0");
    }
    function ne2(t3) {
      const {
        value: e28
      } = p3;
      if (e28)
        for (const n3 of t3)
          e28.style[n3] = "";
    }
    function D3() {
      if (a3.type === "card")
        return;
      const t3 = w3();
      t3 ? ve2(t3) : ge2();
    }
    function se2(t3) {
      var e28;
      const n3 = (e28 = f3.value) === null || e28 === void 0 ? void 0 : e28.$el;
      if (!n3)
        return;
      const s3 = w3();
      if (!s3)
        return;
      const {
        scrollLeft: o3,
        offsetWidth: W3
      } = n3, {
        offsetLeft: C3,
        offsetWidth: V10
      } = s3;
      o3 > C3 ? n3.scrollTo({
        top: 0,
        left: C3,
        behavior: "smooth"
      }) : C3 + V10 > o3 + W3 && n3.scrollTo({
        top: 0,
        left: C3 + V10 - W3,
        behavior: "smooth"
      });
    }
    const F3 = ref$1(null);
    let G3 = 0, E3 = null;
    function ye2(t3) {
      const e28 = F3.value;
      if (e28) {
        G3 = t3.getBoundingClientRect().height;
        const n3 = `${G3}px`, s3 = () => {
          e28.style.height = n3, e28.style.maxHeight = n3;
        };
        E3 ? (s3(), E3(), E3 = null) : E3 = s3;
      }
    }
    function Se2(t3) {
      const e28 = F3.value;
      if (e28) {
        const n3 = t3.getBoundingClientRect().height, s3 = () => {
          document.body.offsetHeight, e28.style.maxHeight = `${n3}px`, e28.style.height = `${Math.max(G3, n3)}px`;
        };
        E3 ? (E3(), E3 = null, s3()) : E3 = s3;
      }
    }
    function Ce2() {
      const t3 = F3.value;
      if (t3) {
        t3.style.maxHeight = "", t3.style.height = "";
        const {
          paneWrapperStyle: e28
        } = a3;
        if (typeof e28 == "string")
          t3.style.cssText = e28;
        else if (e28) {
          const {
            maxHeight: n3,
            height: s3
          } = e28;
          n3 !== void 0 && (t3.style.maxHeight = n3), s3 !== void 0 && (t3.style.height = s3);
        }
      }
    }
    const ie2 = {
      value: []
    }, le2 = ref$1("next");
    function xe2(t3) {
      const e28 = h3.value;
      let n3 = "next";
      for (const s3 of ie2.value) {
        if (s3 === e28)
          break;
        if (s3 === t3) {
          n3 = "prev";
          break;
        }
      }
      le2.value = n3, Re2(t3);
    }
    function Re2(t3) {
      const {
        onActiveNameChange: e28,
        onUpdateValue: n3,
        "onUpdate:value": s3
      } = a3;
      e28 && i$1Z(e28, t3), n3 && i$1Z(n3, t3), s3 && i$1Z(s3, t3), O3.value = t3;
    }
    function $e2(t3) {
      const {
        onClose: e28
      } = a3;
      e28 && i$1Z(e28, t3);
    }
    function oe2() {
      const {
        value: t3
      } = p3;
      if (!t3)
        return;
      const e28 = "transition-disabled";
      t3.classList.add(e28), D3(), t3.classList.remove(e28);
    }
    const H3 = ref$1(null);
    function N3({
      transitionDisabled: t3
    }) {
      const e28 = v3.value;
      if (!e28)
        return;
      t3 && e28.classList.add("transition-disabled");
      const n3 = w3();
      n3 && H3.value && (H3.value.style.width = `${n3.offsetWidth}px`, H3.value.style.height = `${n3.offsetHeight}px`, H3.value.style.transform = `translateX(${n3.offsetLeft - e28.offsetLeft - i$1y(getComputedStyle(e28).paddingLeft)}px)`, t3 && H3.value.offsetWidth), t3 && e28.classList.remove("transition-disabled");
    }
    watch([h3], () => {
      a3.type === "segment" && nextTick(() => {
        N3({
          transitionDisabled: false
        });
      });
    }), onMounted(() => {
      a3.type === "segment" && N3({
        transitionDisabled: true
      });
    });
    let re2 = 0;
    function Te2(t3) {
      var e28;
      if (t3.contentRect.width === 0 && t3.contentRect.height === 0 || re2 === t3.contentRect.width)
        return;
      re2 = t3.contentRect.width;
      const {
        type: n3
      } = a3;
      if ((n3 === "line" || n3 === "bar") && oe2(), n3 !== "segment") {
        const {
          placement: s3
        } = a3;
        K3((s3 === "top" || s3 === "bottom" ? (e28 = f3.value) === null || e28 === void 0 ? void 0 : e28.$el : b3.value) || null);
      }
    }
    const We2 = u$1a(Te2, 64);
    watch([() => a3.justifyContent, () => a3.size], () => {
      nextTick(() => {
        const {
          type: t3
        } = a3;
        (t3 === "line" || t3 === "bar") && oe2();
      });
    });
    const I3 = ref$1(false);
    function Pe2(t3) {
      var e28;
      const {
        target: n3,
        contentRect: {
          width: s3
        }
      } = t3, o3 = n3.parentElement.offsetWidth;
      if (!I3.value)
        o3 < s3 && (I3.value = true);
      else {
        const {
          value: W3
        } = L3;
        if (!W3)
          return;
        o3 - s3 > W3.$el.offsetWidth && (I3.value = false);
      }
      K3(((e28 = f3.value) === null || e28 === void 0 ? void 0 : e28.$el) || null);
    }
    const Le2 = u$1a(Pe2, 64);
    function ze2() {
      const {
        onAdd: t3
      } = a3;
      t3 && t3(), nextTick(() => {
        const e28 = w3(), {
          value: n3
        } = f3;
        !e28 || !n3 || n3.scrollTo({
          left: e28.offsetLeft,
          top: 0,
          behavior: "smooth"
        });
      });
    }
    function K3(t3) {
      if (!t3)
        return;
      const {
        placement: e28
      } = a3;
      if (e28 === "top" || e28 === "bottom") {
        const {
          scrollLeft: n3,
          scrollWidth: s3,
          offsetWidth: o3
        } = t3;
        z3.value = n3 <= 0, S3.value = n3 + o3 >= s3;
      } else {
        const {
          scrollTop: n3,
          scrollHeight: s3,
          offsetHeight: o3
        } = t3;
        z3.value = n3 <= 0, S3.value = n3 + o3 >= s3;
      }
    }
    const we2 = u$1a((t3) => {
      K3(t3.target);
    }, 64);
    provide(n$U, {
      triggerRef: toRef$1(a3, "trigger"),
      tabStyleRef: toRef$1(a3, "tabStyle"),
      tabClassRef: toRef$1(a3, "tabClass"),
      addTabStyleRef: toRef$1(a3, "addTabStyle"),
      addTabClassRef: toRef$1(a3, "addTabClass"),
      paneClassRef: toRef$1(a3, "paneClass"),
      paneStyleRef: toRef$1(a3, "paneStyle"),
      mergedClsPrefixRef: d3,
      typeRef: toRef$1(a3, "type"),
      closableRef: toRef$1(a3, "closable"),
      valueRef: h3,
      tabChangeIdRef: l3,
      onBeforeLeaveRef: toRef$1(a3, "onBeforeLeave"),
      activateTab: xe2,
      handleClose: $e2,
      handleAdd: ze2
    }), a$1Y(() => {
      D3(), se2();
    }), watchEffect(() => {
      const {
        value: t3
      } = B3;
      if (!t3)
        return;
      const {
        value: e28
      } = d3, n3 = `${e28}-tabs-nav-scroll-wrapper--shadow-start`, s3 = `${e28}-tabs-nav-scroll-wrapper--shadow-end`;
      z3.value ? t3.classList.remove(n3) : t3.classList.add(n3), S3.value ? t3.classList.remove(s3) : t3.classList.add(s3);
    });
    const Ee2 = {
      syncBarPosition: () => {
        D3();
      }
    }, _e2 = () => {
      N3({
        transitionDisabled: true
      });
    }, de2 = computed(() => {
      const {
        value: t3
      } = A3, {
        type: e28
      } = a3, n3 = {
        card: "Card",
        bar: "Bar",
        line: "Line",
        segment: "Segment"
      }[e28], s3 = `${t3}${n3}`, {
        self: {
          barColor: o3,
          closeIconColor: W3,
          closeIconColorHover: C3,
          closeIconColorPressed: V10,
          tabColor: Ae2,
          tabBorderColor: Be2,
          paneTextColor: He2,
          tabFontWeight: je2,
          tabBorderRadius: Oe2,
          tabFontWeightActive: De2,
          colorSegment: Fe2,
          fontWeightStrong: Ie2,
          tabColorSegment: Ve2,
          closeSize: Me2,
          closeIconSize: ke2,
          closeColorHover: Ue2,
          closeColorPressed: Ge2,
          closeBorderRadius: Ne2,
          [_$H("panePadding", t3)]: M3,
          [_$H("tabPadding", s3)]: Ke2,
          [_$H("tabPaddingVertical", s3)]: Xe2,
          [_$H("tabGap", s3)]: qe2,
          [_$H("tabGap", `${s3}Vertical`)]: Je2,
          [_$H("tabTextColor", e28)]: Qe2,
          [_$H("tabTextColorActive", e28)]: Ye2,
          [_$H("tabTextColorHover", e28)]: Ze2,
          [_$H("tabTextColorDisabled", e28)]: et2,
          [_$H("tabFontSize", t3)]: tt2
        },
        common: {
          cubicBezierEaseInOut: at2
        }
      } = T3.value;
      return {
        "--n-bezier": at2,
        "--n-color-segment": Fe2,
        "--n-bar-color": o3,
        "--n-tab-font-size": tt2,
        "--n-tab-text-color": Qe2,
        "--n-tab-text-color-active": Ye2,
        "--n-tab-text-color-disabled": et2,
        "--n-tab-text-color-hover": Ze2,
        "--n-pane-text-color": He2,
        "--n-tab-border-color": Be2,
        "--n-tab-border-radius": Oe2,
        "--n-close-size": Me2,
        "--n-close-icon-size": ke2,
        "--n-close-color-hover": Ue2,
        "--n-close-color-pressed": Ge2,
        "--n-close-border-radius": Ne2,
        "--n-close-icon-color": W3,
        "--n-close-icon-color-hover": C3,
        "--n-close-icon-color-pressed": V10,
        "--n-tab-color": Ae2,
        "--n-tab-font-weight": je2,
        "--n-tab-font-weight-active": De2,
        "--n-tab-padding": Ke2,
        "--n-tab-padding-vertical": Xe2,
        "--n-tab-gap": qe2,
        "--n-tab-gap-vertical": Je2,
        "--n-pane-padding-left": f$1f(M3, "left"),
        "--n-pane-padding-right": f$1f(M3, "right"),
        "--n-pane-padding-top": f$1f(M3, "top"),
        "--n-pane-padding-bottom": f$1f(M3, "bottom"),
        "--n-font-weight-strong": Ie2,
        "--n-tab-color-segment": Ve2
      };
    }), j3 = y3 ? E$J("tabs", computed(() => `${A3.value[0]}${a3.type[0]}`), de2, a3) : void 0;
    return Object.assign({
      mergedClsPrefix: d3,
      mergedValue: h3,
      renderedNames: /* @__PURE__ */ new Set(),
      segmentCapsuleElRef: H3,
      tabsPaneWrapperRef: F3,
      tabsElRef: v3,
      barElRef: p3,
      addTabInstRef: L3,
      xScrollInstRef: f3,
      scrollWrapperElRef: B3,
      addTabFixed: I3,
      tabWrapperStyle: c3,
      handleNavResize: We2,
      mergedSize: A3,
      handleScroll: we2,
      handleTabsResize: Le2,
      cssVars: y3 ? void 0 : de2,
      themeClass: j3 == null ? void 0 : j3.themeClass,
      animationDirection: le2,
      renderNameListRef: ie2,
      yScrollElRef: b3,
      handleSegmentResize: _e2,
      onAnimationBeforeLeave: ye2,
      onAnimationEnter: Se2,
      onAnimationAfterEnter: Ce2,
      onRender: j3 == null ? void 0 : j3.onRender
    }, Ee2);
  },
  render() {
    const {
      mergedClsPrefix: a3,
      type: r3,
      placement: $3,
      addTabFixed: P3,
      addable: m3,
      mergedSize: _3,
      renderNameListRef: d3,
      onRender: y3,
      paneWrapperClass: T3,
      paneWrapperStyle: v3,
      $slots: {
        default: p3,
        prefix: B3,
        suffix: L3
      }
    } = this;
    y3 == null || y3();
    const f3 = p3 ? i$1A(p3()).filter((l3) => l3.type.__TAB_PANE__ === true) : [], b3 = p3 ? i$1A(p3()).filter((l3) => l3.type.__TAB__ === true) : [], z3 = !b3.length, S3 = r3 === "card", A3 = r3 === "segment", g3 = !S3 && !A3 && this.justifyContent;
    d3.value = [];
    const O3 = () => {
      const l3 = h$1R("div", {
        style: this.tabWrapperStyle,
        class: [`${a3}-tabs-wrapper`]
      }, g3 ? null : h$1R("div", {
        class: `${a3}-tabs-scroll-padding`,
        style: {
          width: `${this.tabsPadding}px`
        }
      }), z3 ? f3.map((c3, w3) => (d3.value.push(c3.props.name), te$e(h$1R(q$o, Object.assign({}, c3.props, {
        internalCreatedByPane: true,
        internalLeftPadded: w3 !== 0 && (!g3 || g3 === "center" || g3 === "start" || g3 === "end")
      }), c3.children ? {
        default: c3.children.tab
      } : void 0)))) : b3.map((c3, w3) => (d3.value.push(c3.props.name), te$e(w3 !== 0 && !g3 ? he$e(c3) : c3))), !P3 && m3 && S3 ? be$c(m3, (z3 ? f3.length : b3.length) !== 0) : null, g3 ? null : h$1R("div", {
        class: `${a3}-tabs-scroll-padding`,
        style: {
          width: `${this.tabsPadding}px`
        }
      }));
      return h$1R("div", {
        ref: "tabsElRef",
        class: `${a3}-tabs-nav-scroll-content`
      }, S3 && m3 ? h$1R(x$D, {
        onResize: this.handleTabsResize
      }, {
        default: () => l3
      }) : l3, S3 ? h$1R("div", {
        class: `${a3}-tabs-pad`
      }) : null, S3 ? null : h$1R("div", {
        ref: "barElRef",
        class: `${a3}-tabs-bar`
      }));
    }, h3 = A3 ? "top" : $3;
    return h$1R("div", {
      class: [`${a3}-tabs`, this.themeClass, `${a3}-tabs--${r3}-type`, `${a3}-tabs--${_3}-size`, g3 && `${a3}-tabs--flex`, `${a3}-tabs--${h3}`],
      style: this.cssVars
    }, h$1R("div", {
      class: [
        `${a3}-tabs-nav--${r3}-type`,
        `${a3}-tabs-nav--${h3}`,
        `${a3}-tabs-nav`
      ]
    }, m$26(B3, (l3) => l3 && h$1R("div", {
      class: `${a3}-tabs-nav__prefix`
    }, l3)), A3 ? h$1R(x$D, {
      onResize: this.handleSegmentResize
    }, {
      default: () => h$1R("div", {
        class: `${a3}-tabs-rail`,
        ref: "tabsElRef"
      }, h$1R("div", {
        class: `${a3}-tabs-capsule`,
        ref: "segmentCapsuleElRef"
      }, h$1R("div", {
        class: `${a3}-tabs-wrapper`
      }, h$1R("div", {
        class: `${a3}-tabs-tab`
      }))), z3 ? f3.map((l3, c3) => (d3.value.push(l3.props.name), h$1R(q$o, Object.assign({}, l3.props, {
        internalCreatedByPane: true,
        internalLeftPadded: c3 !== 0
      }), l3.children ? {
        default: l3.children.tab
      } : void 0))) : b3.map((l3, c3) => (d3.value.push(l3.props.name), c3 === 0 ? l3 : he$e(l3))))
    }) : h$1R(x$D, {
      onResize: this.handleNavResize
    }, {
      default: () => h$1R("div", {
        class: `${a3}-tabs-nav-scroll-wrapper`,
        ref: "scrollWrapperElRef"
      }, ["top", "bottom"].includes(h3) ? h$1R(m$1s, {
        ref: "xScrollInstRef",
        onScroll: this.handleScroll
      }, {
        default: O3
      }) : h$1R("div", {
        class: `${a3}-tabs-nav-y-scroll`,
        onScroll: this.handleScroll,
        ref: "yScrollElRef"
      }, O3()))
    }), P3 && m3 && S3 ? be$c(m3, true) : null, m$26(L3, (l3) => l3 && h$1R("div", {
      class: `${a3}-tabs-nav__suffix`
    }, l3))), z3 && (this.animated && (h3 === "top" || h3 === "bottom") ? h$1R("div", {
      ref: "tabsPaneWrapperRef",
      style: v3,
      class: [`${a3}-tabs-pane-wrapper`, T3]
    }, pe$e(f3, this.mergedValue, this.renderedNames, this.onAnimationBeforeLeave, this.onAnimationEnter, this.onAnimationAfterEnter, this.animationDirection)) : pe$e(f3, this.mergedValue, this.renderedNames)));
  }
});
function pe$e(a3, r3, $3, P3, m3, _3, d3) {
  const y3 = [];
  return a3.forEach((T3) => {
    const {
      name: v3,
      displayDirective: p3,
      "display-directive": B3
    } = T3.props, L3 = (b3) => p3 === b3 || B3 === b3, f3 = r3 === v3;
    if (T3.key !== void 0 && (T3.key = v3), f3 || L3("show") || L3("show:lazy") && $3.has(v3)) {
      $3.has(v3) || $3.add(v3);
      const b3 = !L3("if");
      y3.push(b3 ? withDirectives(T3, [[vShow, f3]]) : T3);
    }
  }), d3 ? h$1R(TransitionGroup, {
    name: `${d3}-transition`,
    onBeforeLeave: P3,
    onEnter: m3,
    onAfterEnter: _3
  }, {
    default: () => y3
  }) : y3;
}
function be$c(a3, r3) {
  return h$1R(q$o, {
    ref: "addTabInstRef",
    key: "__addable",
    name: "__addable",
    internalCreatedByPane: true,
    internalAddable: true,
    internalLeftPadded: r3,
    disabled: typeof a3 == "object" && a3.disabled
  });
}
function he$e(a3) {
  const r3 = cloneVNode(a3);
  return r3.props ? r3.props.internalLeftPadded = true : r3.props = {
    internalLeftPadded: true
  }, r3;
}
function te$e(a3) {
  return Array.isArray(a3.dynamicProps) ? a3.dynamicProps.includes("internalLeftPadded") || a3.dynamicProps.push("internalLeftPadded") : a3.dynamicProps = ["internalLeftPadded"], a3;
}
const c$1l = defineComponent({
  name: "UITabs",
  inheritAttrs: false
}), v$H = defineComponent(__spreadProps(__spreadValues({}, c$1l), {
  props: {
    value: {
      type: [String, Number]
    },
    type: {
      type: String,
      default: "line"
    },
    defaultValue: {
      type: String,
      default: void 0
    },
    justifyContent: {
      type: String,
      default: ""
    },
    animated: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: "top"
    }
  },
  emits: ["update:value"],
  setup(e28, { expose: u3 }) {
    const a3 = ref$1(null);
    return u3({ syncBarPosition: () => {
      nextTick(() => {
        var t3;
        return (t3 = a3.value) == null ? void 0 : t3.syncBarPosition();
      });
    } }), (t3, n3) => (openBlock(), createBlock(unref(It$6), {
      ref_key: "tabsInstRef",
      ref: a3,
      value: e28.value,
      "onUpdate:value": n3[0] || (n3[0] = (i) => t3.$emit("update:value", i)),
      type: e28.type,
      animated: e28.animated,
      placement: e28.placement,
      "justify-content": e28.justifyContent,
      "default-value": e28.defaultValue
    }, {
      default: withCtx(() => [
        renderSlot(t3.$slots, "default")
      ]),
      _: 3
    }, 8, ["value", "type", "animated", "placement", "justify-content", "default-value"]));
  }
})), g$P = v$H;
const l$18 = defineComponent({
  __TAB_PANE__: true,
  props: {
    name: {
      type: [String, Number]
    },
    tab: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(e28, { slots: a3, expose: r3 }) {
    const n3 = ref$1(null);
    return r3({
      syncBarPosition: () => {
        nextTick(() => {
          var t3;
          return (t3 = n3.value) == null ? void 0 : t3.syncBarPosition();
        });
      }
    }), () => h$1R(f$Y, {
      ref: n3,
      name: e28.name,
      tab: e28.tab,
      disabled: e28.disabled
    }, () => a3 == null ? void 0 : a3.default());
  }
});
const o$_ = defineComponent({
  __TAB__: true,
  props: {
    name: {
      type: [String, Number]
    },
    key: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(e28, { slots: t3 }) {
    return () => h$1R(q$o, {
      name: e28.name,
      key: e28.key,
      disabled: e28.disabled
    }, () => t3.default());
  }
});
const s$1f = defineComponent({
  name: "UIToolbar",
  inheritAttrs: false
}), m$1r = defineComponent(__spreadProps(__spreadValues({}, s$1f), {
  props: {
    theme: {
      type: String,
      default: "dark"
    }
  },
  setup(o3) {
    return (e28, p3) => (openBlock(), createElementBlock("div", mergeProps(e28.$attrs, {
      class: ["hl-toolbar", o3.theme]
    }), [
      renderSlot(e28.$slots, "default")
    ], 16));
  }
})), f$V = m$1r;
const s$1e = defineComponent({
  name: "UIToolbarGroup",
  inheritAttrs: false
}), d$19 = defineComponent(__spreadProps(__spreadValues({}, s$1e), {
  props: {
    borderLeft: Boolean,
    borderRight: Boolean
  },
  setup(o3) {
    return (e28, p3) => (openBlock(), createElementBlock("div", mergeProps(e28.$attrs, {
      class: ["hl-toolbar-group", { "hl-br": o3.borderRight, "hl-bl": o3.borderLeft }]
    }), [
      renderSlot(e28.$slots, "default")
    ], 16));
  }
})), f$U = d$19;
function a$1j(t3, n3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 21l-4.35-4.35M19 11a8 8 0 11-16 0 8 8 0 0116 0z"
    })
  ]);
}
function u$19(n3, d3, i, t3) {
  for (var l3 = n3.length, e28 = i + (t3 ? 1 : -1); t3 ? e28-- : ++e28 < l3; )
    if (d3(n3[e28], e28, n3))
      return e28;
  return -1;
}
function a$1i(t3) {
  return t3 !== t3;
}
function f$T(t3, n3, i) {
  for (var e28 = i - 1, r3 = t3.length; ++e28 < r3; )
    if (t3[e28] === n3)
      return e28;
  return -1;
}
function d$18(o3, t3, r3) {
  return t3 === t3 ? f$T(o3, t3, r3) : u$19(o3, a$1i, r3);
}
function f$S(e28, n3) {
  var t3 = e28 == null ? 0 : e28.length;
  return !!t3 && d$18(e28, n3, 0) > -1;
}
function i$16(e28, t3, l3) {
  for (var n3 = -1, u3 = e28 == null ? 0 : e28.length; ++n3 < u3; )
    if (l3(t3, e28[n3]))
      return true;
  return false;
}
function o$Z() {
}
var a$1h = 1 / 0, n$S = m$1U && 1 / t$1u(new m$1U([, -0]))[1] == a$1h ? function(t3) {
  return new m$1U(t3);
} : o$Z;
const c$1k = n$S;
var C$O = 200;
function x$r(h3, n3, l3) {
  var m3 = -1, o3 = f$S, t3 = h3.length, e28 = true, f3 = [], i = f3;
  if (l3)
    e28 = false, o3 = i$16;
  else if (t3 >= C$O) {
    var p3 = n3 ? null : c$1k(h3);
    if (p3)
      return t$1u(p3);
    e28 = false, o3 = t$1v, i = new e$1z();
  } else
    i = n3 ? [] : f3;
  i:
    for (; ++m3 < t3; ) {
      var r3 = h3[m3], s3 = n3 ? n3(r3) : r3;
      if (r3 = l3 || r3 !== 0 ? r3 : 0, e28 && s3 === s3) {
        for (var u3 = i.length; u3--; )
          if (i[u3] === s3)
            continue i;
        n3 && i.push(s3), f3.push(r3);
      } else
        o3(i, s3, l3) || (i !== f3 && i.push(s3), f3.push(r3));
    }
  return f3;
}
function m$1q(e28, t3) {
  return e28 && e28.length ? x$r(e28, c$1P(t3)) : [];
}
var C$N = 200;
function x$q(s3, r3, i, o3) {
  var e28 = -1, t3 = f$S, m3 = true, g3 = s3.length, n3 = [], c3 = r3.length;
  if (!g3)
    return n3;
  i && (r3 = h$1z(r3, t$1V(i))), o3 ? (t3 = i$16, m3 = false) : r3.length >= C$N && (t3 = t$1v, m3 = false, r3 = new e$1z(r3));
  r:
    for (; ++e28 < g3; ) {
      var f3 = s3[e28], h3 = i == null ? f3 : i(f3);
      if (f3 = o3 || f3 !== 0 ? f3 : 0, m3 && h3 === h3) {
        for (var p3 = c3; p3--; )
          if (r3[p3] === h3)
            continue r;
        n3.push(f3);
      } else
        t3(r3, h3, o3) || n3.push(f3);
    }
  return n3;
}
var f$R = n$1W(function(t3, e28) {
  return f$1T(t3) ? x$q(t3, e28) : [];
});
const u$18 = f$R;
const h$13 = ({
  path: n3,
  options: t3,
  pathSeparator: l3 = "/"
}) => {
  const o3 = n3.split(l3).filter(Boolean);
  let e28 = t3;
  for (const r3 of o3) {
    const s3 = e28.find((c3) => c3.value === r3);
    if (!s3)
      return null;
    e28 = s3.children || [];
  }
  return m$1q(e28, "value");
}, d$17 = (n3, t3) => {
  console.log(n3, t3);
}, g$O = (n3) => {
  const t3 = [], l3 = (o3, e28 = "/") => {
    const _a2 = o3, { label: r3, value: s3, children: c3 } = _a2, u3 = __objRest(_a2, ["label", "value", "children"]), a3 = __spreadValues({ label: r3, value: s3, _pathFromRoot: e28 }, u3);
    c3 ? (t3.push(__spreadProps(__spreadValues({}, a3), { type: "parent" })), c3.forEach((f3) => l3(f3, `${e28}${r3}/`))) : t3.push(a3);
  };
  return n3.forEach((o3) => l3(o3)), m$1q(t3, "value");
};
function c$1j(t3, n3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20 6L9 17l-5-5"
    })
  ]);
}
const z$m = { class: "item__label" }, O$q = defineComponent({
  __name: "ItemDetails",
  props: {
    item: {
      type: Object,
      required: true
    },
    isActive: Boolean,
    isDisabled: Boolean,
    renderOption: {
      type: Function,
      default: null
    },
    randomColor: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "default"
    }
  },
  emits: ["onForwardTraverse", "onSelect"],
  setup(e28, { emit: v3 }) {
    const n3 = e28, C3 = v3, D3 = () => {
      if (n3.isDisabled)
        return false;
      C3("onSelect", n3.item);
    };
    return (T3, V10) => {
      var c3, d3, s3;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["item", [e28.isDisabled ? "disabled" : ""]]),
        onClick: D3
      }, [
        e28.item.render ? (openBlock(), createBlock(resolveDynamicComponent(e28.item.render(e28.item, e28.isActive)), { key: 0 })) : e28.renderOption ? (openBlock(), createBlock(resolveDynamicComponent(e28.renderOption(e28.item, e28.isActive)), { key: 1 })) : (openBlock(), createElementBlock("div", {
          key: 2,
          class: normalizeClass(["item__details", [e28.type === "grouped" ? "grouped" : ""]])
        }, [
          (c3 = e28.item) != null && c3.imageUrl ? (openBlock(), createBlock(unref(ve$d), {
            key: 0,
            size: 32,
            src: (d3 = e28.item) == null ? void 0 : d3.imageUrl,
            round: "",
            class: "item__icon",
            "object-fit": "cover"
          }, null, 8, ["src"])) : (openBlock(), createBlock(unref(ve$d), {
            key: 1,
            src: (s3 = e28.item) == null ? void 0 : s3.imageUrl,
            size: 32,
            round: "",
            class: "item__name",
            "object-fit": "cover",
            style: normalizeStyle({
              backgroundColor: e28.randomColor ? unref(r$1s)(e28.item.label) : ""
            })
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(n$1a)(e28.item.label)), 1)
            ]),
            _: 1
          }, 8, ["src", "style"])),
          createElementVNode("div", z$m, [
            e28.item.label ? (openBlock(), createBlock(unref(d$1H), { key: 0 }, {
              default: withCtx(() => [
                createVNode(unref(q$u), {
                  class: "item__title",
                  tooltip: !e28.item.disabled
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(e28.item.label), 1)
                  ]),
                  _: 1
                }, 8, ["tooltip"])
              ]),
              _: 1
            })) : createCommentVNode("", true),
            e28.item.description ? (openBlock(), createBlock(unref(_$E), { key: 1 }, {
              default: withCtx(() => [
                createVNode(unref(q$u), {
                  class: "item__description",
                  tooltip: false
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(e28.item.description), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })) : createCommentVNode("", true)
          ]),
          e28.isActive ? (openBlock(), createBlock(unref(c$1j), {
            key: 2,
            class: "item__checked"
          })) : createCommentVNode("", true)
        ], 2))
      ], 2);
    };
  }
}), J$k = O$q;
function c$1i(t3, n3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 5v14m-7-7h14"
    })
  ]);
}
var g$N = "[object Map]", c$1h = "[object Set]", a$1g = Object.prototype, b$I = a$1g.hasOwnProperty;
function k$z(r3) {
  if (r3 == null)
    return true;
  if (e$1W(r3) && (a$2p(r3) || typeof r3 == "string" || typeof r3.splice == "function" || m$2b(r3) || i$25(r3) || m$2c(r3)))
    return !r3.length;
  var t3 = h$1y(r3);
  if (t3 == g$N || t3 == c$1h)
    return !r3.size;
  if (e$1Y(r3))
    return !f$1v(r3).length;
  for (var o3 in r3)
    if (b$I.call(r3, o3))
      return false;
  return true;
}
const C$M = {
  key: 0,
  class: "ghl-avatar-container"
}, F$o = defineComponent({
  name: "UIAvatar",
  inheritAttrs: false
}), M$k = defineComponent(__spreadProps(__spreadValues({}, F$o), {
  props: {
    size: {
      type: [Number, String],
      default: "medium"
    },
    objectFit: {
      type: String,
      default: "fill"
    },
    round: {
      type: Boolean,
      default: true
    },
    src: {
      type: String,
      default: void 0
    },
    fallbackSrc: {
      type: String
    },
    style: {
      type: Object
    },
    indicator: {
      type: String,
      required: false
    }
  },
  setup(e28) {
    const d3 = e28, g3 = (t3) => typeof t3 == "number" ? t3 : {
      small: 24,
      medium: 32,
      large: 40
    }[t3] || t3, k3 = computed(() => {
      const t3 = g3(d3.size);
      return Math.floor(typeof t3 == "number" ? t3 * 0.42 : t3);
    }), v3 = (t3) => typeof t3 == "number" ? { width: `${t3 + 4}px`, height: `${t3 + 4}px` } : {
      small: { width: "34px", height: "34px" },
      medium: { width: "40px", height: "40px" },
      large: { width: "46px", height: "46px" }
    }[t3] || { width: `${t3 + 4}px`, height: `${t3 + 4}px` }, S3 = computed(() => v3(d3.size)), $3 = useSlots(), o3 = (t3) => !isNaN(t3) && !isNaN(parseFloat(t3));
    return (t3, u3) => unref($3).overlay ? (openBlock(), createElementBlock("div", C$M, [
      createVNode(unref(ve$d), mergeProps(t3.$attrs, {
        class: "ghl-avatar",
        style: e28.style,
        src: unref(k$z)(e28.src) ? "undefined" : e28.src,
        "fallback-src": e28.fallbackSrc,
        round: e28.round,
        "object-fit": e28.objectFit,
        size: e28.size
      }), {
        default: withCtx(() => [
          renderSlot(t3.$slots, "default")
        ]),
        _: 3
      }, 16, ["style", "src", "fallback-src", "round", "object-fit", "size"]),
      createElementVNode("div", {
        class: normalizeClass(["ghl-avatar-backdrop", [
          `ghl-avatar-backdrop-${e28.size}`,
          e28.round ? "ghl-avatar-round-backdrop" : null
        ]]),
        style: normalizeStyle({
          width: o3(e28.size) ? e28.size + "px" : null,
          height: o3(e28.size) ? e28.size + "px" : null
        })
      }, [
        renderSlot(t3.$slots, "overlay")
      ], 6)
    ])) : e28.indicator ? (openBlock(), createElementBlock("div", {
      key: 1,
      class: "n-avatar-with-indicator",
      style: normalizeStyle(S3.value)
    }, [
      createVNode(unref(ve$d), mergeProps(t3.$attrs, {
        class: "ghl-avatar",
        style: e28.style,
        src: unref(k$z)(e28.src) ? "undefined" : e28.src,
        "fallback-src": e28.fallbackSrc,
        round: e28.round,
        "object-fit": e28.objectFit,
        size: e28.size
      }), {
        default: withCtx(() => [
          renderSlot(t3.$slots, "default")
        ]),
        _: 3
      }, 16, ["style", "src", "fallback-src", "round", "object-fit", "size"]),
      e28.indicator ? (openBlock(), createBlock(unref(ve$d), {
        key: 0,
        size: k3.value,
        src: e28.indicator,
        round: e28.round,
        class: "indicator"
      }, null, 8, ["size", "src", "round"])) : createCommentVNode("", true)
    ], 4)) : (openBlock(), createBlock(unref(ve$d), mergeProps({ key: 2 }, t3.$attrs, {
      class: "default-avatar",
      style: e28.style,
      src: unref(k$z)(e28.src) ? "undefined" : e28.src,
      "fallback-src": e28.fallbackSrc,
      round: e28.round,
      "object-fit": e28.objectFit,
      size: e28.size
    }), {
      default: withCtx(() => [
        renderSlot(t3.$slots, "default")
      ]),
      _: 3
    }, 16, ["style", "src", "fallback-src", "round", "object-fit", "size"]));
  }
})), I$v = M$k;
const s$1d = (t3, e28) => {
  const o3 = t3.__vccOpts || t3;
  for (const [r3, c3] of e28)
    o3[r3] = c3;
  return o3;
};
const o$Y = l$25("avatar-group", `
 flex-wrap: nowrap;
 display: inline-flex;
 position: relative;
`, [g$1j("expand-on-hover", [l$25("avatar", [r$2a("&:not(:first-child)", `
 transition: margin .3s var(--n-bezier);
 `)]), r$2a("&:hover", [x$I("vertical", [l$25("avatar", [r$2a("&:not(:first-child)", `
 margin-left: 0 !important;
 `)])]), g$1j("vertical", [l$25("avatar", [r$2a("&:not(:first-child)", `
 margin-top: 0 !important;
 `)])])])]), x$I("vertical", `
 flex-direction: row;
 `, [l$25("avatar", [r$2a("&:not(:first-child)", `
 margin-left: var(--n-gap);
 `)])]), g$1j("vertical", `
 flex-direction: column;
 `, [l$25("avatar", [r$2a("&:not(:first-child)", `
 margin-top: var(--n-gap);
 `)])])]);
const o$X = () => ({
  gap: "-12px"
}), m$1p = G$w({
  name: "AvatarGroup",
  common: d$1T,
  peers: {
    Avatar: C$T
  },
  self: o$X
}), n$R = m$1p;
const y$H = Object.assign(Object.assign({}, _$F.props), {
  max: Number,
  maxStyle: [Object, String],
  options: {
    type: Array,
    default: () => []
  },
  vertical: Boolean,
  expandOnHover: Boolean,
  size: [String, Number]
}), P$J = defineComponent({
  name: "AvatarGroup",
  props: y$H,
  setup(e28) {
    const {
      mergedClsPrefixRef: o3,
      mergedRtlRef: a3
    } = a$2x(e28), s3 = _$F("AvatarGroup", "-avatar-group", o$Y, n$R, e28, o3);
    provide(t$1c, e28);
    const n3 = v$17("AvatarGroup", a3, o3), i = computed(() => {
      const {
        max: r3
      } = e28;
      if (r3 === void 0)
        return;
      const {
        options: t3
      } = e28;
      return t3.length > r3 ? t3.slice(r3 - 1, t3.length) : [];
    }), u3 = computed(() => {
      const {
        options: r3,
        max: t3
      } = e28;
      return t3 === void 0 ? r3 : r3.length > t3 ? r3.slice(0, t3 - 1) : r3.length === t3 ? r3.slice(0, t3) : r3;
    });
    return {
      mergedTheme: s3,
      rtlEnabled: n3,
      mergedClsPrefix: o3,
      restOptions: i,
      displayedOptions: u3,
      cssVars: computed(() => ({
        "--n-gap": s3.value.self.gap
      }))
    };
  },
  render() {
    const {
      mergedClsPrefix: e28,
      displayedOptions: o3,
      restOptions: a3,
      mergedTheme: s3,
      $slots: n3
    } = this;
    return h$1R("div", {
      class: [`${e28}-avatar-group`, this.rtlEnabled && `${e28}-avatar-group--rtl`, this.vertical && `${e28}-avatar-group--vertical`, this.expandOnHover && `${e28}-avatar-group--expand-on-hover`],
      style: this.cssVars,
      role: "group"
    }, o3.map((i) => n3.avatar ? n3.avatar({
      option: i
    }) : h$1R(ve$d, {
      src: i.src,
      theme: s3.peers.Avatar,
      themeOverrides: s3.peerOverrides.Avatar
    })), a3 !== void 0 && a3.length > 0 && (n3.rest ? n3.rest({
      options: a3,
      rest: a3.length
    }) : h$1R(ve$d, {
      style: this.maxStyle,
      theme: s3.peers.Avatar,
      themeOverrides: s3.peerOverrides.Avatar
    }, {
      default: () => `+${a3.length}`
    })));
  }
});
const w$w = { class: "trigger-multiple__container" }, D$A = { class: "trigger-multiple__empty" }, F$n = { class: "trigger-single__container" }, G$n = {
  key: 1,
  class: "trigger-single__empty"
}, P$I = defineComponent({
  __name: "Trigger",
  props: {
    value: {
      type: Array,
      default: () => []
    },
    max: {
      type: Number,
      default: 5,
      validator(n3) {
        return n3 <= 10;
      }
    },
    disabled: Boolean,
    multiple: Boolean,
    randomColor: {
      type: Boolean,
      default: true
    }
  },
  emits: ["onRemove"],
  setup(n3, { emit: T3 }) {
    const e28 = n3, V10 = T3, y3 = (p3, c3) => {
      p3 && !e28.disabled && (c3.stopImmediatePropagation(), V10("onRemove", p3));
    };
    return (p3, c3) => {
      var k3, C3;
      return e28.multiple ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["trigger-multiple", e28.disabled && "disabled"])
      }, [
        (k3 = e28.value) != null && k3.length ? (openBlock(), createBlock(unref(P$J), {
          key: 0,
          options: e28.value,
          max: n3.max,
          class: "trigger-multiple__avatars"
        }, {
          avatar: withCtx(({ option: { name: t3, src: o3, value: g3 } }) => [
            createVNode(w$K, null, {
              trigger: withCtx(() => [
                createElementVNode("div", w$w, [
                  o3 ? (openBlock(), createBlock(I$v, {
                    key: 0,
                    src: o3,
                    class: "trigger-multiple__avatar"
                  }, null, 8, ["src"])) : (openBlock(), createBlock(I$v, {
                    key: 1,
                    src: o3,
                    class: "trigger-multiple__avatar",
                    style: normalizeStyle({
                      backgroundColor: n3.randomColor ? unref(r$1s)(t3) : ""
                    })
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(n$1a)(t3)), 1)
                    ]),
                    _: 2
                  }, 1032, ["src", "style"])),
                  createVNode(unref(c$1E), {
                    class: "trigger-multiple__close",
                    onClick: (i) => y3(g3, i)
                  }, null, 8, ["onClick"])
                ])
              ]),
              default: withCtx(() => [
                createTextVNode(" " + toDisplayString(t3), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["options", "max"])) : createCommentVNode("", true),
        createElementVNode("div", D$A, [
          createVNode(unref(c$1i), { class: "trigger-multiple__empty-icon" })
        ])
      ], 2)) : (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass(["trigger-single", e28.disabled && "disabled"])
      }, [
        (C3 = e28.value) != null && C3.length ? (openBlock(), createBlock(w$K, { key: 0 }, {
          trigger: withCtx(() => {
            var t3, o3, g3;
            return [
              createElementVNode("div", F$n, [
                (t3 = e28.value[0]) != null && t3.src ? (openBlock(), createBlock(I$v, {
                  key: 0,
                  src: (o3 = e28.value[0]) == null ? void 0 : o3.src,
                  class: "trigger-single__avatar"
                }, null, 8, ["src"])) : (openBlock(), createBlock(I$v, {
                  key: 1,
                  src: (g3 = e28.value[0]) == null ? void 0 : g3.src,
                  class: "trigger-single__avatar"
                }, {
                  default: withCtx(() => {
                    var i;
                    return [
                      createTextVNode(toDisplayString(unref(n$1a)((i = e28.value[0]) == null ? void 0 : i.name)), 1)
                    ];
                  }),
                  _: 1
                }, 8, ["src"])),
                createVNode(unref(c$1E), {
                  class: "trigger-single__close",
                  onClick: c3[0] || (c3[0] = (i) => {
                    var b3;
                    return y3((b3 = e28.value[0]) == null ? void 0 : b3.value, i);
                  })
                })
              ])
            ];
          }),
          default: withCtx(() => {
            var t3;
            return [
              createTextVNode(" " + toDisplayString((t3 = e28.value[0]) == null ? void 0 : t3.name), 1)
            ];
          }),
          _: 1
        })) : (openBlock(), createElementBlock("div", G$n, [
          createVNode(unref(c$1i), { class: "trigger-single__empty-icon" })
        ]))
      ], 2));
    };
  }
}), W$j = /* @__PURE__ */ s$1d(P$I, [["__scopeId", "data-v-19fabca5"]]);
const i$15 = (e28, l3) => {
  const r3 = [];
  return !(l3 != null && l3.trim()) || !(e28 != null && e28.length) ? e28 : (e28.forEach((s3) => {
    var h3;
    if ((h3 = s3.children) != null && h3.length) {
      const c3 = s3.children.filter((n3) => n3.label.toLowerCase().includes(l3.toLowerCase()));
      c3.length > 0 && r3.push(__spreadProps(__spreadValues({}, s3), { children: c3 }));
    } else
      s3.label.toLowerCase().includes(l3.toLowerCase()) && r3.push(s3);
  }), r3);
};
const le$c = { class: "advanced-select__search" }, oe$e = {
  key: 0,
  class: "advanced-select___action-top-slot"
}, ae$e = {
  key: 0,
  class: "advanced-select__group"
}, re$d = { key: 1 }, ne$g = {
  key: 1,
  class: "no-data"
}, se$e = { key: 2 }, ie$f = {
  key: 1,
  class: "empty-search"
}, ue$e = {
  key: 3,
  class: "advanced-select___action-bottom-slot"
}, de$e = defineComponent({
  name: "UIAdvancedSelect",
  inheritAttrs: false
}), ce$b = defineComponent(__spreadProps(__spreadValues({}, de$e), {
  props: {
    renderOption: {
      type: Function,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    remote: Boolean,
    disabled: Boolean,
    loading: Boolean,
    searchPlaceholder: {
      type: String,
      required: false,
      default: "Search"
    },
    value: {
      type: [String, Number, Array],
      default: () => {
      }
    },
    trigger: {
      type: String,
      default: "click"
    },
    virtualScroll: {
      type: Boolean,
      default: false
    },
    multiple: Boolean,
    randomColor: {
      type: Boolean,
      default: true
    },
    sortSelectedValues: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: void 0
    },
    show: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["onChange", "onSearch", "onScroll", "onClose", "onChangeSrc"],
  setup(o3, { emit: H3 }) {
    const t3 = o3, g3 = useSlots(), s3 = H3, d3 = ref$1(m$1q(t3.options, "value")), C3 = ref$1(null), m3 = ref$1(null), c3 = computed(() => t3.multiple && Array.isArray(t3.value) ? t3.value : [t3.value]), I3 = computed(() => {
      var e28, a3;
      return !t3.options || !((e28 = c3.value) != null && e28.length) ? [] : (a3 = g$O(t3.options).filter((l3) => c3.value.includes(l3.value))) == null ? void 0 : a3.map((l3) => ({
        name: l3.label,
        text: n$1a(l3.label),
        src: l3 == null ? void 0 : l3.imageUrl,
        value: l3.value
      }));
    }), F3 = () => {
      var e28;
      s3("onClose"), (e28 = C3 == null ? void 0 : C3.value) == null || e28.setShow(false);
    }, G3 = (e28) => t3.remote ? (s3("onSearch", e28), false) : !(e28 == null ? void 0 : e28.trim()) || !e28 ? (d3.value = t3.options, false) : (d3.value = i$15(t3.options, e28), true), w3 = (e28) => {
      var _a2;
      var a3;
      if (s3("onChangeSrc", "DROPDOWN"), t3.multiple) {
        const l3 = e28.value;
        if ((a3 = c3.value) != null && a3.includes(l3))
          return s3("onChange", u$18(c3.value, l3)), true;
        s3("onChange", [...(_a2 = c3.value) != null ? _a2 : [], l3]);
      } else
        return t3.value === e28.value ? s3("onChange", null) : s3("onChange", e28.value), F3(), true;
    }, U3 = computed(() => t3.options.some((e28) => {
      var a3;
      return (a3 = e28.children) == null ? void 0 : a3.length;
    })), P3 = (e28) => {
      var r3;
      if (!e28)
        return s3("onClose"), true;
      if (!t3.value || !t3.sortSelectedValues || U3.value)
        return false;
      let a3 = [], l3 = [];
      const v3 = function() {
        return t3.multiple && Array.isArray(t3.value) ? t3.value : [t3.value];
      }();
      (r3 = m$1q(t3.options, "value")) == null || r3.forEach((f3) => {
        v3.includes(f3.value) ? a3 = [...a3, f3] : l3 = [...l3, f3];
      }), d3.value = [...a3, ...l3];
    }, q3 = (e28) => {
      const a3 = e28.target.clientHeight, l3 = e28.target.scrollHeight, v3 = e28.target.scrollTop;
      s3("onScroll", { clientHeight: a3, scrollHeight: l3, scrollTop: v3 });
    }, x3 = (e28) => {
      if (s3("onChangeSrc", "TRIGGER"), t3.multiple)
        return s3("onChange", u$18(t3 == null ? void 0 : t3.value, e28)), true;
      s3("onChange", null);
    };
    watch(() => m3, _$q((e28) => {
      G3(e28.value);
    }, 0), { deep: true }), watch(() => t3.options, (e28) => {
      d3.value = m$1q(e28, "value");
    }), watch(() => t3.sortSelectedValues, (e28) => {
      e28 ? P3(true) : d3.value = t3.options;
    });
    const z3 = () => {
      m3.value = null;
    };
    return (e28, a3) => (openBlock(), createBlock(unref(Ie$8), {
      class: "advanced-select override-shadow",
      "show-arrow": false,
      trigger: o3.trigger,
      disabled: o3.disabled,
      ref_key: "popper",
      ref: C3,
      raw: "",
      "onUpdate:show": P3,
      onClickoutside: z3,
      show: o3.show,
      placement: o3.placement
    }, {
      trigger: withCtx(() => [
        unref(g3).trigger ? renderSlot(e28.$slots, "trigger", {
          key: 0,
          disabled: o3.disabled,
          value: I3.value
        }) : (openBlock(), createBlock(W$j, {
          key: 1,
          value: I3.value,
          disabled: o3.disabled,
          multiple: o3.multiple,
          onOnRemove: x3,
          randomColor: o3.randomColor
        }, null, 8, ["value", "disabled", "multiple", "randomColor"]))
      ]),
      default: withCtx(() => {
        var l3, v3;
        return [
          createElementVNode("div", {
            class: "advanced-select__container",
            onScroll: q3
          }, [
            createElementVNode("div", le$c, [
              createVNode(unref(Zn$3), {
                id: "advanced-select-search",
                value: m3.value,
                "onUpdate:value": a3[0] || (a3[0] = (r3) => m3.value = r3),
                loading: o3.loading,
                placeholder: o3.searchPlaceholder,
                size: "large"
              }, {
                prefix: withCtx(() => [
                  createVNode(unref(a$1j), { class: "icon" })
                ]),
                _: 1
              }, 8, ["value", "loading", "placeholder"]),
              unref(g3)["action-top"] ? (openBlock(), createElementBlock("div", oe$e, [
                renderSlot(e28.$slots, "action-top")
              ])) : createCommentVNode("", true)
            ]),
            o3.virtualScroll && !U3.value ? (openBlock(), createBlock(unref(ve$c), {
              key: 0,
              class: "virtual-list",
              items: d3.value,
              itemSize: 50
            }, {
              default: withCtx(({ item: r3 }) => [
                createVNode(J$k, {
                  item: r3,
                  "is-active": c3.value.includes(r3.value),
                  "is-disabled": r3.disabled,
                  randomColor: o3.randomColor,
                  onOnSelect: w3
                }, null, 8, ["item", "is-active", "is-disabled", "randomColor"])
              ]),
              _: 1
            }, 8, ["items"])) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(d3.value, (r3) => {
              var f3;
              return openBlock(), createElementBlock(Fragment, {
                key: r3.value.toString()
              }, [
                (f3 = r3.children) != null && f3.length ? (openBlock(), createElementBlock("div", ae$e, [
                  createVNode(unref(p$3y), { class: "advanced-select__group-title" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(r3.label), 1)
                    ]),
                    _: 2
                  }, 1024),
                  (openBlock(true), createElementBlock(Fragment, null, renderList(r3.children, (b3) => (openBlock(), createBlock(J$k, {
                    type: "grouped",
                    key: b3.value.toString(),
                    item: b3,
                    "is-active": c3.value.includes(b3.value),
                    "is-disabled": b3.disabled,
                    "render-option": o3.renderOption,
                    onOnSelect: w3,
                    randomColor: o3.randomColor
                  }, null, 8, ["item", "is-active", "is-disabled", "render-option", "randomColor"]))), 128))
                ])) : (openBlock(), createBlock(J$k, {
                  key: 1,
                  item: r3,
                  "is-active": c3.value.includes(r3.value),
                  "is-disabled": r3.disabled,
                  "render-option": o3.renderOption,
                  onOnSelect: w3,
                  randomColor: o3.randomColor
                }, null, 8, ["item", "is-active", "is-disabled", "render-option", "randomColor"]))
              ], 64);
            }), 128)),
            !m3.value && !((l3 = o3.options) != null && l3.length) ? (openBlock(), createElementBlock("div", re$d, [
              unref(g3).empty ? renderSlot(e28.$slots, "empty", { key: 0 }) : (openBlock(), createElementBlock("p", ne$g, "No data"))
            ])) : createCommentVNode("", true),
            m3.value && !((v3 = d3.value) != null && v3.length) ? (openBlock(), createElementBlock("div", se$e, [
              unref(g3).emptySearch ? renderSlot(e28.$slots, "emptySearch", { key: 0 }) : (openBlock(), createElementBlock("p", ie$f, "No matching results found"))
            ])) : createCommentVNode("", true),
            unref(g3)["action-bottom"] ? (openBlock(), createElementBlock("div", ue$e, [
              renderSlot(e28.$slots, "action-bottom")
            ])) : createCommentVNode("", true)
          ], 32)
        ];
      }),
      _: 3
    }, 8, ["trigger", "disabled", "show", "placement"]));
  }
})), Ne$7 = ce$b;
function a$1f(t3, n3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v4m0 4h.01M10.615 3.892L2.39 18.098c-.456.788-.684 1.182-.65 1.506a1 1 0 00.406.705c.263.191.718.191 1.629.191h16.45c.91 0 1.365 0 1.628-.191a1 1 0 00.407-.705c.034-.324-.195-.718-.65-1.506L13.383 3.892c-.454-.785-.681-1.178-.978-1.31a1 1 0 00-.813 0c-.296.132-.523.525-.978 1.31z"
    })
  ]);
}
function c$1g(t3, n3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.5 12l3 3 6-6m5.5 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
    })
  ]);
}
const s$1c = l$25("alert", `
 line-height: var(--n-line-height);
 border-radius: var(--n-border-radius);
 position: relative;
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-color);
 text-align: start;
 word-break: break-word;
`, [
  M$y("border", `
 border-radius: inherit;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 transition: border-color .3s var(--n-bezier);
 border: var(--n-border);
 pointer-events: none;
 `),
  g$1j("closable", [l$25("alert-body", [M$y("title", `
 padding-right: 24px;
 `)])]),
  M$y("icon", {
    color: "var(--n-icon-color)"
  }),
  l$25("alert-body", {
    padding: "var(--n-padding)"
  }, [M$y("title", {
    color: "var(--n-title-text-color)"
  }), M$y("content", {
    color: "var(--n-content-text-color)"
  })]),
  x$E({
    originalTransition: "transform .3s var(--n-bezier)",
    enterToProps: {
      transform: "scale(1)"
    },
    leaveToProps: {
      transform: "scale(0.9)"
    }
  }),
  M$y("icon", `
 position: absolute;
 left: 0;
 top: 0;
 align-items: center;
 justify-content: center;
 display: flex;
 width: var(--n-icon-size);
 height: var(--n-icon-size);
 font-size: var(--n-icon-size);
 margin: var(--n-icon-margin);
 `),
  M$y("close", `
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 position: absolute;
 right: 0;
 top: 0;
 margin: var(--n-close-margin);
 `),
  g$1j("show-icon", [l$25("alert-body", {
    paddingLeft: "calc(var(--n-icon-margin-left) + var(--n-icon-size) + var(--n-icon-margin-right))"
  })]),
  g$1j("right-adjust", [l$25("alert-body", {
    paddingRight: "calc(var(--n-close-size) + var(--n-padding) + 2px)"
  })]),
  l$25("alert-body", `
 border-radius: var(--n-border-radius);
 transition: border-color .3s var(--n-bezier);
 `, [M$y("title", `
 transition: color .3s var(--n-bezier);
 font-size: 16px;
 line-height: 19px;
 font-weight: var(--n-title-font-weight);
 `, [r$2a("& +", [M$y("content", {
    marginTop: "9px"
  })])]), M$y("content", {
    transition: "color .3s var(--n-bezier)",
    fontSize: "var(--n-font-size)"
  })]),
  M$y("icon", {
    transition: "color .3s var(--n-bezier)"
  })
]);
const p$33 = {
  iconMargin: "11px 8px 0 12px",
  iconMarginRtl: "11px 12px 0 8px",
  iconSize: "24px",
  closeIconSize: "16px",
  closeSize: "20px",
  closeMargin: "13px 14px 0 0",
  closeMarginRtl: "13px 0 0 14px",
  padding: "13px"
};
const H$k = (p3) => {
  const {
    lineHeight: x3,
    borderRadius: f3,
    fontWeightStrong: h3,
    baseColor: o3,
    dividerColor: u3,
    actionColor: m3,
    textColor1: c3,
    textColor2: l3,
    closeColorHover: s3,
    closeColorPressed: n3,
    closeIconColor: t3,
    closeIconColorHover: C3,
    closeIconColorPressed: i,
    infoColor: a3,
    successColor: d3,
    warningColor: I3,
    errorColor: g3,
    fontSize: S3
  } = p3;
  return Object.assign(Object.assign({}, p$33), {
    fontSize: S3,
    lineHeight: x3,
    titleFontWeight: h3,
    borderRadius: f3,
    border: `1px solid ${u3}`,
    color: m3,
    titleTextColor: c3,
    iconColor: l3,
    contentTextColor: l3,
    closeBorderRadius: f3,
    closeColorHover: s3,
    closeColorPressed: n3,
    closeIconColor: t3,
    closeIconColorHover: C3,
    closeIconColorPressed: i,
    borderInfo: `1px solid ${G$v(o3, J$p(a3, {
      alpha: 0.25
    }))}`,
    colorInfo: G$v(o3, J$p(a3, {
      alpha: 0.08
    })),
    titleTextColorInfo: c3,
    iconColorInfo: a3,
    contentTextColorInfo: l3,
    closeColorHoverInfo: s3,
    closeColorPressedInfo: n3,
    closeIconColorInfo: t3,
    closeIconColorHoverInfo: C3,
    closeIconColorPressedInfo: i,
    borderSuccess: `1px solid ${G$v(o3, J$p(d3, {
      alpha: 0.25
    }))}`,
    colorSuccess: G$v(o3, J$p(d3, {
      alpha: 0.08
    })),
    titleTextColorSuccess: c3,
    iconColorSuccess: d3,
    contentTextColorSuccess: l3,
    closeColorHoverSuccess: s3,
    closeColorPressedSuccess: n3,
    closeIconColorSuccess: t3,
    closeIconColorHoverSuccess: C3,
    closeIconColorPressedSuccess: i,
    borderWarning: `1px solid ${G$v(o3, J$p(I3, {
      alpha: 0.33
    }))}`,
    colorWarning: G$v(o3, J$p(I3, {
      alpha: 0.08
    })),
    titleTextColorWarning: c3,
    iconColorWarning: I3,
    contentTextColorWarning: l3,
    closeColorHoverWarning: s3,
    closeColorPressedWarning: n3,
    closeIconColorWarning: t3,
    closeIconColorHoverWarning: C3,
    closeIconColorPressedWarning: i,
    borderError: `1px solid ${G$v(o3, J$p(g3, {
      alpha: 0.25
    }))}`,
    colorError: G$v(o3, J$p(g3, {
      alpha: 0.08
    })),
    titleTextColorError: c3,
    iconColorError: g3,
    contentTextColorError: l3,
    closeColorHoverError: s3,
    closeColorPressedError: n3,
    closeIconColorError: t3,
    closeIconColorHoverError: C3,
    closeIconColorPressedError: i
  });
}, E$t = {
  name: "Alert",
  common: d$1T,
  self: H$k
}, $$i = E$t;
const Z$l = Object.assign(Object.assign({}, _$F.props), {
  title: String,
  showIcon: {
    type: Boolean,
    default: true
  },
  type: {
    type: String,
    default: "default"
  },
  bordered: {
    type: Boolean,
    default: true
  },
  closable: Boolean,
  onClose: Function,
  onAfterLeave: Function,
  onAfterHide: Function
}), Re$b = defineComponent({
  name: "Alert",
  inheritAttrs: false,
  props: Z$l,
  setup(r3) {
    const {
      mergedClsPrefixRef: e28,
      mergedBorderedRef: i,
      inlineThemeDisabled: d3,
      mergedRtlRef: f3
    } = a$2x(r3), a3 = _$F("Alert", "-alert", s$1c, $$i, r3, e28), b3 = v$17("Alert", f3, e28), m3 = computed(() => {
      const {
        common: {
          cubicBezierEaseInOut: s3
        },
        self: o3
      } = a3.value, {
        fontSize: C3,
        borderRadius: R3,
        titleFontWeight: A3,
        lineHeight: I3,
        iconSize: y3,
        iconMargin: h3,
        iconMarginRtl: $3,
        closeIconSize: _3,
        closeBorderRadius: x3,
        closeSize: z3,
        closeMargin: B3,
        closeMarginRtl: P3,
        padding: w3
      } = o3, {
        type: n3
      } = r3, {
        left: E3,
        right: S3
      } = f$1f(h3);
      return {
        "--n-bezier": s3,
        "--n-color": o3[_$H("color", n3)],
        "--n-close-icon-size": _3,
        "--n-close-border-radius": x3,
        "--n-close-color-hover": o3[_$H("closeColorHover", n3)],
        "--n-close-color-pressed": o3[_$H("closeColorPressed", n3)],
        "--n-close-icon-color": o3[_$H("closeIconColor", n3)],
        "--n-close-icon-color-hover": o3[_$H("closeIconColorHover", n3)],
        "--n-close-icon-color-pressed": o3[_$H("closeIconColorPressed", n3)],
        "--n-icon-color": o3[_$H("iconColor", n3)],
        "--n-border": o3[_$H("border", n3)],
        "--n-title-text-color": o3[_$H("titleTextColor", n3)],
        "--n-content-text-color": o3[_$H("contentTextColor", n3)],
        "--n-line-height": I3,
        "--n-border-radius": R3,
        "--n-font-size": C3,
        "--n-title-font-weight": A3,
        "--n-icon-size": y3,
        "--n-icon-margin": h3,
        "--n-icon-margin-rtl": $3,
        "--n-close-size": z3,
        "--n-close-margin": B3,
        "--n-close-margin-rtl": P3,
        "--n-padding": w3,
        "--n-icon-margin-left": E3,
        "--n-icon-margin-right": S3
      };
    }), c3 = d3 ? E$J("alert", computed(() => r3.type[0]), m3, r3) : void 0, u3 = ref$1(true), p3 = () => {
      const {
        onAfterLeave: s3,
        onAfterHide: o3
      } = r3;
      s3 && s3(), o3 && o3();
    };
    return {
      rtlEnabled: b3,
      mergedClsPrefix: e28,
      mergedBordered: i,
      visible: u3,
      handleCloseClick: () => {
        var s3;
        Promise.resolve((s3 = r3.onClose) === null || s3 === void 0 ? void 0 : s3.call(r3)).then((o3) => {
          o3 !== false && (u3.value = false);
        });
      },
      handleAfterLeave: () => {
        p3();
      },
      mergedTheme: a3,
      cssVars: d3 ? void 0 : m3,
      themeClass: c3 == null ? void 0 : c3.themeClass,
      onRender: c3 == null ? void 0 : c3.onRender
    };
  },
  render() {
    var r3;
    return (r3 = this.onRender) === null || r3 === void 0 || r3.call(this), h$1R(l$1W, {
      onAfterLeave: this.handleAfterLeave
    }, {
      default: () => {
        const {
          mergedClsPrefix: e28,
          $slots: i
        } = this, d3 = {
          class: [
            `${e28}-alert`,
            this.themeClass,
            this.closable && `${e28}-alert--closable`,
            this.showIcon && `${e28}-alert--show-icon`,
            !this.title && this.closable && `${e28}-alert--right-adjust`,
            this.rtlEnabled && `${e28}-alert--rtl`
          ],
          style: this.cssVars,
          role: "alert"
        };
        return this.visible ? h$1R("div", Object.assign({}, mergeProps(this.$attrs, d3)), this.closable && h$1R(g$1b, {
          clsPrefix: e28,
          class: `${e28}-alert__close`,
          onClick: this.handleCloseClick
        }), this.bordered && h$1R("div", {
          class: `${e28}-alert__border`
        }), this.showIcon && h$1R("div", {
          class: `${e28}-alert__icon`,
          "aria-hidden": "true"
        }, p$3H(i.icon, () => [h$1R(d$1R, {
          clsPrefix: e28
        }, {
          default: () => {
            switch (this.type) {
              case "success":
                return h$1R(t$1g, null);
              case "info":
                return h$1R(n$1f, null);
              case "warning":
                return h$1R(C$Y, null);
              case "error":
                return h$1R(C$X, null);
              default:
                return null;
            }
          }
        })])), h$1R("div", {
          class: [`${e28}-alert-body`, this.mergedBordered && `${e28}-alert-body--bordered`]
        }, m$26(i.header, (f3) => {
          const a3 = f3 || this.title;
          return a3 ? h$1R("div", {
            class: `${e28}-alert-body__title`
          }, a3) : null;
        }), i.default && h$1R("div", {
          class: `${e28}-alert-body__content`
        }, i))) : null;
      }
    });
  }
});
const C$L = { class: "body" }, S$t = {
  key: 2,
  class: "mt-3"
}, A$s = defineComponent({
  name: "UIAlert",
  inheritAttrs: false
}), B$w = defineComponent(__spreadProps(__spreadValues({}, A$s), {
  props: {
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "default"
    },
    closable: {
      type: Boolean,
      default: true
    }
  },
  emits: ["close"],
  setup(t3) {
    const s3 = useSlots();
    return (r3, a3) => (openBlock(), createBlock(unref(Re$b), {
      id: t3.id,
      type: t3.type,
      closable: t3.closable,
      class: normalizeClass(["rounded-[12px]", [`hl-${t3.type}`]]),
      onClose: a3[0] || (a3[0] = () => r3.$emit("close", t3.id))
    }, {
      icon: withCtx(() => [
        t3.type === "warning" ? (openBlock(), createBlock(unref(a$1f), {
          key: 0,
          class: "w-5 h-5"
        })) : t3.type === "success" ? (openBlock(), createBlock(unref(c$1g), {
          key: 1,
          class: "w-5 h-5"
        })) : (openBlock(), createBlock(unref(l$1G), {
          key: 2,
          class: "w-5 h-5"
        }))
      ]),
      default: withCtx(() => [
        createElementVNode("div", C$L, [
          unref(s3).title ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(s3).content || unref(s3).actions ? "title" : "")
          }, [
            createVNode(unref(d$1H), null, {
              default: withCtx(() => [
                renderSlot(r3.$slots, "title", {}, void 0, true)
              ]),
              _: 3
            })
          ], 2)) : createCommentVNode("", true),
          unref(s3).content ? renderSlot(r3.$slots, "content", { key: 1 }, void 0, true) : createCommentVNode("", true),
          unref(s3).actions ? (openBlock(), createElementBlock("div", S$t, [
            renderSlot(r3.$slots, "actions", {}, void 0, true)
          ])) : createCommentVNode("", true)
        ])
      ]),
      _: 3
    }, 8, ["id", "type", "closable", "class"]));
  }
})), M$j = /* @__PURE__ */ s$1d(B$w, [["__scopeId", "data-v-1cd95d1d"]]);
function t$W(r3) {
  return r3 < 1e3 ? r3.toString() : (r3 / 1e3).toFixed(1) + "K";
}
const c$1f = defineComponent({
  name: "UIPopover",
  inheritAttrs: false
}), w$v = defineComponent(__spreadProps(__spreadValues({}, c$1f), {
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    delay: {
      type: Number
    },
    duration: {
      type: Number
    },
    placement: {
      type: String,
      default: "top"
    },
    show: {
      type: Boolean,
      default: void 0
    },
    showArrow: {
      type: Boolean,
      default: true
    },
    positionX: {
      type: Number,
      default: void 0
    },
    positionY: {
      type: Number,
      default: void 0
    },
    onClickoutside: {
      type: Function,
      default: void 0
    },
    onUpdateShow: {
      type: Function,
      default: void 0
    },
    animated: {
      type: Boolean,
      default: true
    },
    arrowPointToCenter: {
      type: Boolean,
      default: false
    },
    arrowClass: {
      type: String,
      default: void 0
    },
    arrowStyle: {
      type: String || Object,
      default: void 0
    },
    arrowWrapperClass: {
      type: String,
      default: void 0
    },
    arrowWrapperStyle: {
      type: String || Object,
      default: void 0
    },
    contentClass: {
      type: String,
      default: void 0
    },
    contentStyle: {
      type: String || Object,
      default: void 0
    },
    footerClass: {
      type: String,
      default: void 0
    },
    footerStyle: {
      type: String || Object,
      default: void 0
    },
    headerClass: {
      type: String,
      default: void 0
    },
    headerStyle: {
      type: String || Object,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    flip: {
      type: Boolean,
      default: true
    },
    keepAliveOnHover: {
      type: Boolean,
      default: true
    },
    overlap: {
      type: Boolean,
      default: false
    },
    raw: {
      type: Boolean,
      default: false
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: void 0
    },
    to: {
      type: [String, Object, Boolean],
      default: "body"
    },
    width: {
      type: [Number, String],
      default: void 0
    },
    zIndex: {
      type: Number,
      default: void 0
    }
  },
  setup(e28) {
    const r3 = useSlots();
    return (t3, v3) => (openBlock(), createBlock(unref(Ie$8), mergeProps(t3.$attrs, {
      "show-arrow": e28.showArrow,
      show: e28.show,
      placement: e28.placement,
      trigger: e28.trigger,
      delay: e28.delay,
      duration: e28.duration,
      x: e28.positionX,
      y: e28.positionY,
      "on-clickoutside": e28.onClickoutside,
      animated: e28.animated,
      "arrow-point-to-center": e28.arrowPointToCenter,
      "arrow-class": e28.arrowClass,
      "arrow-style": e28.arrowStyle,
      "arrow-wrapper-class": e28.arrowWrapperClass,
      "arrow-wrapper-style": e28.arrowWrapperStyle,
      "content-class": e28.contentClass,
      "content-style": e28.contentStyle,
      disabled: e28.disabled,
      flip: e28.flip,
      "footer-class": e28.footerClass,
      "footer-style": e28.footerStyle,
      "header-class": e28.headerClass,
      "header-style": e28.headerStyle,
      "keep-alive-on-hover": e28.keepAliveOnHover,
      overlap: e28.overlap,
      raw: e28.raw,
      scrollable: e28.scrollable,
      title: e28.title,
      to: e28.to,
      width: e28.width,
      "z-index": e28.zIndex,
      "on-update:show": e28.onUpdateShow
    }), createSlots({
      default: withCtx(() => [
        renderSlot(t3.$slots, "default")
      ]),
      _: 2
    }, [
      unref(r3).trigger ? {
        name: "trigger",
        fn: withCtx(() => [
          renderSlot(t3.$slots, "trigger")
        ]),
        key: "0"
      } : void 0,
      unref(r3).header ? {
        name: "header",
        fn: withCtx(() => [
          renderSlot(t3.$slots, "header")
        ]),
        key: "1"
      } : void 0,
      unref(r3).footer ? {
        name: "footer",
        fn: withCtx(() => [
          renderSlot(t3.$slots, "footer")
        ]),
        key: "2"
      } : void 0
    ]), 1040, ["show-arrow", "show", "placement", "trigger", "delay", "duration", "x", "y", "on-clickoutside", "animated", "arrow-point-to-center", "arrow-class", "arrow-style", "arrow-wrapper-class", "arrow-wrapper-style", "content-class", "content-style", "disabled", "flip", "footer-class", "footer-style", "header-class", "header-style", "keep-alive-on-hover", "overlap", "raw", "scrollable", "title", "to", "width", "z-index", "on-update:show"]));
  }
})), S$s = w$v;
const E$s = { class: "rest-list" }, j$j = {
  key: 0,
  class: "rest-item rest__suppressed"
}, q$n = defineComponent({
  name: "UIAvatarGroup",
  inheritAttrs: false
}), L$w = defineComponent(__spreadProps(__spreadValues({}, q$n), {
  props: {
    size: {
      type: [Number, String],
      default: "large"
    },
    vertical: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 5
    },
    id: {
      type: String,
      required: true
    },
    options: {
      type: Array
    },
    defaultClassName: {
      type: String
    },
    restClassName: {
      type: String
    },
    src: {
      type: String
    },
    onClose: Function,
    maxRestCount: {
      type: Number,
      default: 10
    },
    disableDropdown: {
      type: Boolean,
      default: void 0
    },
    randomizeColor: {
      type: Boolean,
      default: true
    }
  },
  setup(e28) {
    const h3 = e28, x3 = s$1v("global"), p3 = computed(() => {
      var u3;
      return (u3 = h3.options) == null ? void 0 : u3.some((v3) => v3.indicator);
    });
    return (u3, v3) => (openBlock(), createBlock(unref(P$J), {
      options: e28.options,
      class: normalizeClass({ "with-indicator": p3.value }),
      max: e28.max,
      vertical: e28.vertical
    }, {
      avatar: withCtx(({
        option: { name: l3, src: m3, icon: o3, text: N3, className: c3, indicator: f3, fallbackSrc: k3 }
      }) => [
        createVNode(unref(w$K), null, {
          trigger: withCtx(() => [
            m3 ? (openBlock(), createBlock(resolveDynamicComponent(unref(I$v)), {
              key: 0,
              src: m3,
              size: e28.size,
              class: normalizeClass(c3 || e28.defaultClassName),
              indicator: f3,
              fallbackSrc: k3
            }, null, 8, ["src", "size", "class", "indicator", "fallbackSrc"])) : o3 ? (openBlock(), createBlock(unref(I$v), {
              key: 1,
              size: e28.size,
              class: normalizeClass(c3 || e28.defaultClassName),
              indicator: f3
            }, {
              default: withCtx(() => [
                (openBlock(), createBlock(resolveDynamicComponent(o3)))
              ]),
              _: 2
            }, 1032, ["size", "class", "indicator"])) : (openBlock(), createBlock(resolveDynamicComponent(unref(I$v)), {
              key: 2,
              size: e28.size,
              class: normalizeClass(c3 || e28.defaultClassName),
              style: normalizeStyle({
                backgroundColor: e28.randomizeColor ? unref(r$1s)(N3 != null ? N3 : l3) : ""
              }),
              indicator: f3
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(n$1a)(N3 != null ? N3 : l3)), 1)
              ]),
              _: 2
            }, 1032, ["size", "class", "style", "indicator"]))
          ]),
          default: withCtx(() => [
            createTextVNode(" " + toDisplayString(l3), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      rest: withCtx(({ options: l3, rest: m3 }) => [
        createVNode(unref(S$s), {
          disabled: e28.disableDropdown,
          "show-arrow": false,
          raw: "",
          class: "p-1 rounded bg-white"
        }, {
          trigger: withCtx(() => [
            createVNode(unref(I$v), {
              id: `${e28.id}-dropdown-trigger`,
              class: normalizeClass([
                p3.value ? "with-indicator" : null,
                e28.restClassName || e28.defaultClassName
              ].join(" ")),
              size: e28.size
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(`+${unref(t$W)(m3)}`), 1)
              ]),
              _: 2
            }, 1032, ["id", "class", "size"])
          ]),
          default: withCtx(() => [
            createElementVNode("ul", E$s, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(l3.slice(0, e28.maxRestCount), (o3) => (openBlock(), createElementBlock("li", {
                class: "rest-item",
                key: o3.name
              }, toDisplayString(o3.name), 1))), 128)),
              l3.length > e28.maxRestCount ? (openBlock(), createElementBlock("li", j$j, toDisplayString(`+ ${l3.length - e28.maxRestCount} ${unref(x3).more}`), 1)) : createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1032, ["disabled"])
      ]),
      _: 1
    }, 8, ["options", "class", "max", "vertical"]));
  }
})), te$d = L$w;
const i$14 = defineComponent({
  name: "UIBadge",
  inheritAttrs: false
}), y$G = defineComponent(__spreadProps(__spreadValues({}, i$14), {
  props: {
    id: {
      type: String,
      required: true
    },
    color: {
      type: String
    },
    dot: {
      type: Boolean
    },
    max: {
      type: Number
    },
    processing: {
      type: Boolean
    },
    showZero: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "default"
    },
    value: {
      type: [Number, String],
      default: void 0
    },
    offset: {
      type: Array
    }
  },
  setup(e28) {
    const s3 = useSlots();
    return (t3, m3) => (openBlock(), createBlock(unref(ee$f), {
      color: e28.color,
      dot: e28.dot,
      max: e28.max,
      processing: e28.processing,
      "show-zero": e28.showZero,
      show: e28.show,
      type: e28.type,
      value: e28.value,
      offset: e28.offset
    }, createSlots({
      default: withCtx(() => [
        renderSlot(t3.$slots, "content")
      ]),
      _: 2
    }, [
      unref(s3).value ? {
        name: "value",
        fn: withCtx(() => [
          renderSlot(t3.$slots, "value")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["color", "dot", "max", "processing", "show-zero", "show", "type", "value", "offset"]));
  }
})), p$32 = y$G;
const p$31 = defineComponent({
  name: "UIDataTable"
}), s$1b = defineComponent(__spreadProps(__spreadValues({}, p$31), {
  setup(_3) {
    return (a3, m3) => (openBlock(), createBlock(unref(st$8), normalizeProps(guardReactiveProps(a3.$attrs)), null, 16));
  }
})), i$13 = s$1b;
const M$i = "data:image/svg+xml;base64,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";
const y$F = ["id"], x$p = ["src"], k$y = { class: "gui__builder-card--icon" }, S$r = defineComponent({
  name: "UIDraggableElement",
  inheritAttrs: false,
  components: { UITextXsMedium: p$3y }
}), B$v = defineComponent(__spreadProps(__spreadValues({}, S$r), {
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    icon: {
      type: Function,
      default: null
    },
    disabled: Boolean
  },
  setup(e28) {
    const n3 = useSlots();
    return (o3, C3) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["gui__builder-card", e28.disabled ? "disabled" : ""]),
      id: e28.id,
      tabindex: "0"
    }, [
      createElementVNode("img", {
        src: unref(M$i),
        class: "gui__builder-card--handler",
        draggable: "false"
      }, null, 8, x$p),
      createElementVNode("div", k$y, [
        unref(n3).icon ? renderSlot(o3.$slots, "icon", { key: 0 }) : (openBlock(), createBlock(resolveDynamicComponent(e28.icon), {
          key: 1,
          class: "w-8 h-8 p-2 text-gray-600"
        }))
      ]),
      createVNode(unref(p$3y), { class: "gui__builder-card--label" }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(e28.label), 1)
        ]),
        _: 1
      })
    ], 10, y$F));
  }
})), U$q = B$v;
function a$1e(t3, n3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4 7h10a6 6 0 010 12H4M4 7l4-4M4 7l4 4"
    })
  ]);
}
function c$1e(e28) {
  return window.TouchEvent && e28 instanceof window.TouchEvent;
}
function f$Q() {
  const e28 = /* @__PURE__ */ new Map(), n3 = (o3) => (t3) => {
    e28.set(o3, t3);
  };
  return onBeforeUpdate(() => {
    e28.clear();
  }), [e28, n3];
}
const s$1a = r$2a([l$25("slider", `
 display: block;
 padding: calc((var(--n-handle-size) - var(--n-rail-height)) / 2) 0;
 position: relative;
 z-index: 0;
 width: 100%;
 cursor: pointer;
 user-select: none;
 -webkit-user-select: none;
 `, [g$1j("reverse", [l$25("slider-handles", [l$25("slider-handle-wrapper", `
 transform: translate(50%, -50%);
 `)]), l$25("slider-dots", [l$25("slider-dot", `
 transform: translateX(50%, -50%);
 `)]), g$1j("vertical", [l$25("slider-handles", [l$25("slider-handle-wrapper", `
 transform: translate(-50%, -50%);
 `)]), l$25("slider-marks", [l$25("slider-mark", `
 transform: translateY(calc(-50% + var(--n-dot-height) / 2));
 `)]), l$25("slider-dots", [l$25("slider-dot", `
 transform: translateX(-50%) translateY(0);
 `)])])]), g$1j("vertical", `
 padding: 0 calc((var(--n-handle-size) - var(--n-rail-height)) / 2);
 width: var(--n-rail-width-vertical);
 height: 100%;
 `, [l$25("slider-handles", `
 top: calc(var(--n-handle-size) / 2);
 right: 0;
 bottom: calc(var(--n-handle-size) / 2);
 left: 0;
 `, [l$25("slider-handle-wrapper", `
 top: unset;
 left: 50%;
 transform: translate(-50%, 50%);
 `)]), l$25("slider-rail", `
 height: 100%;
 `, [M$y("fill", `
 top: unset;
 right: 0;
 bottom: unset;
 left: 0;
 `)]), g$1j("with-mark", `
 width: var(--n-rail-width-vertical);
 margin: 0 32px 0 8px;
 `), l$25("slider-marks", `
 top: calc(var(--n-handle-size) / 2);
 right: unset;
 bottom: calc(var(--n-handle-size) / 2);
 left: 22px;
 font-size: var(--n-mark-font-size);
 `, [l$25("slider-mark", `
 transform: translateY(50%);
 white-space: nowrap;
 `)]), l$25("slider-dots", `
 top: calc(var(--n-handle-size) / 2);
 right: unset;
 bottom: calc(var(--n-handle-size) / 2);
 left: 50%;
 `, [l$25("slider-dot", `
 transform: translateX(-50%) translateY(50%);
 `)])]), g$1j("disabled", `
 cursor: not-allowed;
 opacity: var(--n-opacity-disabled);
 `, [l$25("slider-handle", `
 cursor: not-allowed;
 `)]), g$1j("with-mark", `
 width: 100%;
 margin: 8px 0 32px 0;
 `), r$2a("&:hover", [l$25("slider-rail", {
  backgroundColor: "var(--n-rail-color-hover)"
}, [M$y("fill", {
  backgroundColor: "var(--n-fill-color-hover)"
})]), l$25("slider-handle", {
  boxShadow: "var(--n-handle-box-shadow-hover)"
})]), g$1j("active", [l$25("slider-rail", {
  backgroundColor: "var(--n-rail-color-hover)"
}, [M$y("fill", {
  backgroundColor: "var(--n-fill-color-hover)"
})]), l$25("slider-handle", {
  boxShadow: "var(--n-handle-box-shadow-hover)"
})]), l$25("slider-marks", `
 position: absolute;
 top: 18px;
 left: calc(var(--n-handle-size) / 2);
 right: calc(var(--n-handle-size) / 2);
 `, [l$25("slider-mark", `
 position: absolute;
 transform: translateX(-50%);
 white-space: nowrap;
 `)]), l$25("slider-rail", `
 width: 100%;
 position: relative;
 height: var(--n-rail-height);
 background-color: var(--n-rail-color);
 transition: background-color .3s var(--n-bezier);
 border-radius: calc(var(--n-rail-height) / 2);
 `, [M$y("fill", `
 position: absolute;
 top: 0;
 bottom: 0;
 border-radius: calc(var(--n-rail-height) / 2);
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-fill-color);
 `)]), l$25("slider-handles", `
 position: absolute;
 top: 0;
 right: calc(var(--n-handle-size) / 2);
 bottom: 0;
 left: calc(var(--n-handle-size) / 2);
 `, [l$25("slider-handle-wrapper", `
 outline: none;
 position: absolute;
 top: 50%;
 transform: translate(-50%, -50%);
 cursor: pointer;
 display: flex;
 `, [l$25("slider-handle", `
 height: var(--n-handle-size);
 width: var(--n-handle-size);
 border-radius: 50%;
 overflow: hidden;
 transition: box-shadow .2s var(--n-bezier), background-color .3s var(--n-bezier);
 background-color: var(--n-handle-color);
 box-shadow: var(--n-handle-box-shadow);
 `, [r$2a("&:hover", `
 box-shadow: var(--n-handle-box-shadow-hover);
 `)]), r$2a("&:focus", [l$25("slider-handle", `
 box-shadow: var(--n-handle-box-shadow-focus);
 `, [r$2a("&:hover", `
 box-shadow: var(--n-handle-box-shadow-active);
 `)])])])]), l$25("slider-dots", `
 position: absolute;
 top: 50%;
 left: calc(var(--n-handle-size) / 2);
 right: calc(var(--n-handle-size) / 2);
 `, [g$1j("transition-disabled", [l$25("slider-dot", "transition: none;")]), l$25("slider-dot", `
 transition:
 border-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 position: absolute;
 transform: translate(-50%, -50%);
 height: var(--n-dot-height);
 width: var(--n-dot-width);
 border-radius: var(--n-dot-border-radius);
 overflow: hidden;
 box-sizing: border-box;
 border: var(--n-dot-border);
 background-color: var(--n-dot-color);
 `, [g$1j("active", "border: var(--n-dot-border-active);")])])]), l$25("slider-handle-indicator", `
 font-size: var(--n-font-size);
 padding: 6px 10px;
 border-radius: var(--n-indicator-border-radius);
 color: var(--n-indicator-text-color);
 background-color: var(--n-indicator-color);
 box-shadow: var(--n-indicator-box-shadow);
 `, [$$n()]), l$25("slider-handle-indicator", `
 font-size: var(--n-font-size);
 padding: 6px 10px;
 border-radius: var(--n-indicator-border-radius);
 color: var(--n-indicator-text-color);
 background-color: var(--n-indicator-color);
 box-shadow: var(--n-indicator-box-shadow);
 `, [g$1j("top", `
 margin-bottom: 12px;
 `), g$1j("right", `
 margin-left: 12px;
 `), g$1j("bottom", `
 margin-top: 12px;
 `), g$1j("left", `
 margin-right: 12px;
 `), $$n()]), C$1a(l$25("slider", [l$25("slider-dot", "background-color: var(--n-dot-color-modal);")])), P$V(l$25("slider", [l$25("slider-dot", "background-color: var(--n-dot-color-popover);")]))]);
const i$12 = {
  railHeight: "4px",
  railWidthVertical: "4px",
  handleSize: "18px",
  dotHeight: "8px",
  dotWidth: "8px",
  dotBorderRadius: "4px"
};
const g$M = (i) => {
  const d3 = "rgba(0, 0, 0, .85)", e28 = "0 2px 8px 0 rgba(0, 0, 0, 0.12)", {
    railColor: o3,
    primaryColor: r3,
    baseColor: l3,
    cardColor: t3,
    modalColor: n3,
    popoverColor: s3,
    borderRadius: x3,
    fontSize: a3,
    opacityDisabled: p3
  } = i;
  return Object.assign(Object.assign({}, i$12), {
    fontSize: a3,
    markFontSize: a3,
    railColor: o3,
    railColorHover: o3,
    fillColor: r3,
    fillColorHover: r3,
    opacityDisabled: p3,
    handleColor: "#FFF",
    dotColor: t3,
    dotColorModal: n3,
    dotColorPopover: s3,
    handleBoxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)",
    handleBoxShadowHover: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)",
    handleBoxShadowActive: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)",
    handleBoxShadowFocus: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)",
    indicatorColor: d3,
    indicatorBoxShadow: e28,
    indicatorTextColor: l3,
    indicatorBorderRadius: x3,
    dotBorder: `2px solid ${o3}`,
    dotBorderActive: `2px solid ${r3}`,
    dotBoxShadow: ""
  });
}, h$12 = {
  name: "Slider",
  common: d$1T,
  self: g$M
}, S$q = h$12;
const ot$7 = 0, lt$9 = Object.assign(Object.assign({}, _$F.props), {
  to: f$1m.propTo,
  defaultValue: {
    type: [Number, Array],
    default: 0
  },
  marks: Object,
  disabled: {
    type: Boolean,
    default: void 0
  },
  formatTooltip: Function,
  keyboard: {
    type: Boolean,
    default: true
  },
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 100
  },
  step: {
    type: [Number, String],
    default: 1
  },
  range: Boolean,
  value: [Number, Array],
  placement: String,
  showTooltip: {
    type: Boolean,
    default: void 0
  },
  tooltip: {
    type: Boolean,
    default: true
  },
  vertical: Boolean,
  reverse: Boolean,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onDragstart: [Function],
  onDragend: [Function]
}), pt$8 = defineComponent({
  name: "Slider",
  props: lt$9,
  setup(o3) {
    const {
      mergedClsPrefixRef: a3,
      namespaceRef: N3,
      inlineThemeDisabled: R3
    } = a$2x(o3), f3 = _$F("Slider", "-slider", s$1a, S$q, o3, a3), s3 = ref$1(null), [V10, D3] = f$Q(), [ue2, ce2] = f$Q(), fe2 = ref$1(/* @__PURE__ */ new Set()), X3 = h$1B(o3), {
      mergedDisabledRef: x3
    } = X3, Y3 = computed(() => {
      const {
        step: e28
      } = o3;
      if (Number(e28) <= 0 || e28 === "mark")
        return 0;
      const t3 = e28.toString();
      let n3 = 0;
      return t3.includes(".") && (n3 = t3.length - t3.indexOf(".") - 1), n3;
    }), P3 = ref$1(o3.defaultValue), he2 = toRef$1(o3, "value"), z3 = d$1S(he2, P3), h3 = computed(() => {
      const {
        value: e28
      } = z3;
      return (o3.range ? e28 : [e28]).map(te2);
    }), q3 = computed(() => h3.value.length > 2), me2 = computed(() => o3.placement === void 0 ? o3.vertical ? "right" : "top" : o3.placement), G3 = computed(() => {
      const {
        marks: e28
      } = o3;
      return e28 ? Object.keys(e28).map(parseFloat) : null;
    }), m3 = ref$1(-1), J3 = ref$1(-1), w3 = ref$1(-1), S3 = ref$1(false), C3 = ref$1(false), j3 = computed(() => {
      const {
        vertical: e28,
        reverse: t3
      } = o3;
      return e28 ? t3 ? "top" : "bottom" : t3 ? "right" : "left";
    }), ve2 = computed(() => {
      if (q3.value)
        return;
      const e28 = h3.value, t3 = k3(o3.range ? Math.min(...e28) : o3.min), n3 = k3(o3.range ? Math.max(...e28) : e28[0]), {
        value: l3
      } = j3;
      return o3.vertical ? {
        [l3]: `${t3}%`,
        height: `${n3 - t3}%`
      } : {
        [l3]: `${t3}%`,
        width: `${n3 - t3}%`
      };
    }), ge2 = computed(() => {
      const e28 = [], {
        marks: t3
      } = o3;
      if (t3) {
        const n3 = h3.value.slice();
        n3.sort((d3, u3) => d3 - u3);
        const {
          value: l3
        } = j3, {
          value: i
        } = q3, {
          range: r3
        } = o3, v3 = i ? () => false : (d3) => r3 ? d3 >= n3[0] && d3 <= n3[n3.length - 1] : d3 <= n3[0];
        for (const d3 of Object.keys(t3)) {
          const u3 = Number(d3);
          e28.push({
            active: v3(u3),
            label: t3[d3],
            style: {
              [l3]: `${k3(u3)}%`
            }
          });
        }
      }
      return e28;
    });
    function be2(e28, t3) {
      const n3 = k3(e28), {
        value: l3
      } = j3;
      return {
        [l3]: `${n3}%`,
        zIndex: t3 === m3.value ? 1 : 0
      };
    }
    function Q3(e28) {
      return o3.showTooltip || w3.value === e28 || m3.value === e28 && S3.value;
    }
    function ye2(e28) {
      return S3.value ? !(m3.value === e28 && J3.value === e28) : true;
    }
    function Re2(e28) {
      var t3;
      ~e28 && (m3.value = e28, (t3 = V10.get(e28)) === null || t3 === void 0 || t3.focus());
    }
    function we2() {
      ue2.forEach((e28, t3) => {
        Q3(t3) && e28.syncPosition();
      });
    }
    function Z3(e28) {
      const {
        "onUpdate:value": t3,
        onUpdateValue: n3
      } = o3, {
        nTriggerFormInput: l3,
        nTriggerFormChange: i
      } = X3;
      n3 && i$1Z(n3, e28), t3 && i$1Z(t3, e28), P3.value = e28, l3(), i();
    }
    function ee2(e28) {
      const {
        range: t3
      } = o3;
      if (t3) {
        if (Array.isArray(e28)) {
          const {
            value: n3
          } = h3;
          e28.join() !== n3.join() && Z3(e28);
        }
      } else
        Array.isArray(e28) || h3.value[0] !== e28 && Z3(e28);
    }
    function U3(e28, t3) {
      if (o3.range) {
        const n3 = h3.value.slice();
        n3.splice(t3, 1, e28), ee2(n3);
      } else
        ee2(e28);
    }
    function O3(e28, t3, n3) {
      const l3 = n3 !== void 0;
      n3 || (n3 = e28 - t3 > 0 ? 1 : -1);
      const i = G3.value || [], {
        step: r3
      } = o3;
      if (r3 === "mark") {
        const u3 = M3(e28, i.concat(t3), l3 ? n3 : void 0);
        return u3 ? u3.value : t3;
      }
      if (r3 <= 0)
        return t3;
      const {
        value: v3
      } = Y3;
      let d3;
      if (l3) {
        const u3 = Number((t3 / r3).toFixed(v3)), b3 = Math.floor(u3), _3 = u3 > b3 ? b3 : b3 - 1, L3 = u3 < b3 ? b3 : b3 + 1;
        d3 = M3(t3, [Number((_3 * r3).toFixed(v3)), Number((L3 * r3).toFixed(v3)), ...i], n3);
      } else {
        const u3 = pe2(e28);
        d3 = M3(e28, [...i, u3]);
      }
      return d3 ? te2(d3.value) : t3;
    }
    function te2(e28) {
      return Math.min(o3.max, Math.max(o3.min, e28));
    }
    function k3(e28) {
      const {
        max: t3,
        min: n3
      } = o3;
      return (e28 - n3) / (t3 - n3) * 100;
    }
    function Se2(e28) {
      const {
        max: t3,
        min: n3
      } = o3;
      return n3 + (t3 - n3) * e28;
    }
    function pe2(e28) {
      const {
        step: t3,
        min: n3
      } = o3;
      if (Number(t3) <= 0 || t3 === "mark")
        return e28;
      const l3 = Math.round((e28 - n3) / t3) * t3 + n3;
      return Number(l3.toFixed(Y3.value));
    }
    function M3(e28, t3 = G3.value, n3) {
      if (!(t3 != null && t3.length))
        return null;
      let l3 = null, i = -1;
      for (; ++i < t3.length; ) {
        const r3 = t3[i] - e28, v3 = Math.abs(r3);
        (n3 === void 0 || r3 * n3 > 0) && (l3 === null || v3 < l3.distance) && (l3 = {
          index: i,
          distance: v3,
          value: t3[i]
        });
      }
      return l3;
    }
    function ne2(e28) {
      const t3 = s3.value;
      if (!t3)
        return;
      const n3 = c$1e(e28) ? e28.touches[0] : e28, l3 = t3.getBoundingClientRect();
      let i;
      return o3.vertical ? i = (l3.bottom - n3.clientY) / l3.height : i = (n3.clientX - l3.left) / l3.width, o3.reverse && (i = 1 - i), Se2(i);
    }
    function Te2(e28) {
      if (x3.value || !o3.keyboard)
        return;
      const {
        vertical: t3,
        reverse: n3
      } = o3;
      switch (e28.key) {
        case "ArrowUp":
          e28.preventDefault(), $3(t3 && n3 ? -1 : 1);
          break;
        case "ArrowRight":
          e28.preventDefault(), $3(!t3 && n3 ? -1 : 1);
          break;
        case "ArrowDown":
          e28.preventDefault(), $3(t3 && n3 ? 1 : -1);
          break;
        case "ArrowLeft":
          e28.preventDefault(), $3(!t3 && n3 ? 1 : -1);
          break;
      }
    }
    function $3(e28) {
      const t3 = m3.value;
      if (t3 === -1)
        return;
      const {
        step: n3
      } = o3, l3 = h3.value[t3], i = Number(n3) <= 0 || n3 === "mark" ? l3 : l3 + n3 * e28;
      U3(O3(i, l3, e28 > 0 ? 1 : -1), t3);
    }
    function De2(e28) {
      var t3, n3;
      if (x3.value || !c$1e(e28) && e28.button !== ot$7)
        return;
      const l3 = ne2(e28);
      if (l3 === void 0)
        return;
      const i = h3.value.slice(), r3 = o3.range ? (n3 = (t3 = M3(l3, i)) === null || t3 === void 0 ? void 0 : t3.index) !== null && n3 !== void 0 ? n3 : -1 : 0;
      r3 !== -1 && (e28.preventDefault(), Re2(r3), Ve2(), U3(O3(l3, h3.value[r3]), r3));
    }
    function Ve2() {
      S3.value || (S3.value = true, o3.onDragstart && i$1Z(o3.onDragstart), J$o("touchend", document, F3), J$o("mouseup", document, F3), J$o("touchmove", document, B3), J$o("mousemove", document, B3));
    }
    function I3() {
      S3.value && (S3.value = false, o3.onDragend && i$1Z(o3.onDragend), K$p("touchend", document, F3), K$p("mouseup", document, F3), K$p("touchmove", document, B3), K$p("mousemove", document, B3));
    }
    function B3(e28) {
      const {
        value: t3
      } = m3;
      if (!S3.value || t3 === -1) {
        I3();
        return;
      }
      const n3 = ne2(e28);
      n3 !== void 0 && U3(O3(n3, h3.value[t3]), t3);
    }
    function F3() {
      I3();
    }
    function xe2(e28) {
      m3.value = e28, x3.value || (w3.value = e28);
    }
    function Ce2(e28) {
      m3.value === e28 && (m3.value = -1, I3()), w3.value === e28 && (w3.value = -1);
    }
    function ke2(e28) {
      w3.value = e28;
    }
    function Me2(e28) {
      w3.value === e28 && (w3.value = -1);
    }
    watch(m3, (e28, t3) => void nextTick(() => J3.value = t3)), watch(z3, () => {
      if (o3.marks) {
        if (C3.value)
          return;
        C3.value = true, nextTick(() => {
          C3.value = false;
        });
      }
      nextTick(we2);
    }), onBeforeUnmount(() => {
      I3();
    });
    const oe2 = computed(() => {
      const {
        self: {
          markFontSize: e28,
          railColor: t3,
          railColorHover: n3,
          fillColor: l3,
          fillColorHover: i,
          handleColor: r3,
          opacityDisabled: v3,
          dotColor: d3,
          dotColorModal: u3,
          handleBoxShadow: b3,
          handleBoxShadowHover: _3,
          handleBoxShadowActive: L3,
          handleBoxShadowFocus: $e2,
          dotBorder: Ie2,
          dotBoxShadow: Be2,
          railHeight: Fe2,
          railWidthVertical: He2,
          handleSize: Ae2,
          dotHeight: Ee2,
          dotWidth: Ne2,
          dotBorderRadius: Pe2,
          fontSize: ze2,
          dotBorderActive: je2,
          dotColorPopover: Ue2
        },
        common: {
          cubicBezierEaseInOut: Oe2
        }
      } = f3.value;
      return {
        "--n-bezier": Oe2,
        "--n-dot-border": Ie2,
        "--n-dot-border-active": je2,
        "--n-dot-border-radius": Pe2,
        "--n-dot-box-shadow": Be2,
        "--n-dot-color": d3,
        "--n-dot-color-modal": u3,
        "--n-dot-color-popover": Ue2,
        "--n-dot-height": Ee2,
        "--n-dot-width": Ne2,
        "--n-fill-color": l3,
        "--n-fill-color-hover": i,
        "--n-font-size": ze2,
        "--n-handle-box-shadow": b3,
        "--n-handle-box-shadow-active": L3,
        "--n-handle-box-shadow-focus": $e2,
        "--n-handle-box-shadow-hover": _3,
        "--n-handle-color": r3,
        "--n-handle-size": Ae2,
        "--n-opacity-disabled": v3,
        "--n-rail-color": t3,
        "--n-rail-color-hover": n3,
        "--n-rail-height": Fe2,
        "--n-rail-width-vertical": He2,
        "--n-mark-font-size": e28
      };
    }), p3 = R3 ? E$J("slider", void 0, oe2, o3) : void 0, le2 = computed(() => {
      const {
        self: {
          fontSize: e28,
          indicatorColor: t3,
          indicatorBoxShadow: n3,
          indicatorTextColor: l3,
          indicatorBorderRadius: i
        }
      } = f3.value;
      return {
        "--n-font-size": e28,
        "--n-indicator-border-radius": i,
        "--n-indicator-box-shadow": n3,
        "--n-indicator-color": t3,
        "--n-indicator-text-color": l3
      };
    }), T3 = R3 ? E$J("slider-indicator", void 0, le2, o3) : void 0;
    return {
      mergedClsPrefix: a3,
      namespace: N3,
      uncontrolledValue: P3,
      mergedValue: z3,
      mergedDisabled: x3,
      mergedPlacement: me2,
      isMounted: u$1C(),
      adjustedTo: f$1m(o3),
      dotTransitionDisabled: C3,
      markInfos: ge2,
      isShowTooltip: Q3,
      shouldKeepTooltipTransition: ye2,
      handleRailRef: s3,
      setHandleRefs: D3,
      setFollowerRefs: ce2,
      fillStyle: ve2,
      getHandleStyle: be2,
      activeIndex: m3,
      arrifiedValues: h3,
      followerEnabledIndexSet: fe2,
      handleRailMouseDown: De2,
      handleHandleFocus: xe2,
      handleHandleBlur: Ce2,
      handleHandleMouseEnter: ke2,
      handleHandleMouseLeave: Me2,
      handleRailKeyDown: Te2,
      indicatorCssVars: R3 ? void 0 : le2,
      indicatorThemeClass: T3 == null ? void 0 : T3.themeClass,
      indicatorOnRender: T3 == null ? void 0 : T3.onRender,
      cssVars: R3 ? void 0 : oe2,
      themeClass: p3 == null ? void 0 : p3.themeClass,
      onRender: p3 == null ? void 0 : p3.onRender
    };
  },
  render() {
    var o3;
    const {
      mergedClsPrefix: a3,
      themeClass: N3,
      formatTooltip: R3
    } = this;
    return (o3 = this.onRender) === null || o3 === void 0 || o3.call(this), h$1R("div", {
      class: [`${a3}-slider`, N3, {
        [`${a3}-slider--disabled`]: this.mergedDisabled,
        [`${a3}-slider--active`]: this.activeIndex !== -1,
        [`${a3}-slider--with-mark`]: this.marks,
        [`${a3}-slider--vertical`]: this.vertical,
        [`${a3}-slider--reverse`]: this.reverse
      }],
      style: this.cssVars,
      onKeydown: this.handleRailKeyDown,
      onMousedown: this.handleRailMouseDown,
      onTouchstart: this.handleRailMouseDown
    }, h$1R("div", {
      class: `${a3}-slider-rail`
    }, h$1R("div", {
      class: `${a3}-slider-rail__fill`,
      style: this.fillStyle
    }), this.marks ? h$1R("div", {
      class: [`${a3}-slider-dots`, this.dotTransitionDisabled && `${a3}-slider-dots--transition-disabled`]
    }, this.markInfos.map((f3) => h$1R("div", {
      key: f3.label,
      class: [`${a3}-slider-dot`, {
        [`${a3}-slider-dot--active`]: f3.active
      }],
      style: f3.style
    }))) : null, h$1R("div", {
      ref: "handleRailRef",
      class: `${a3}-slider-handles`
    }, this.arrifiedValues.map((f3, s3) => {
      const V10 = this.isShowTooltip(s3);
      return h$1R(F$x, null, {
        default: () => [h$1R(g$19, null, {
          default: () => h$1R("div", {
            ref: this.setHandleRefs(s3),
            class: `${a3}-slider-handle-wrapper`,
            tabindex: this.mergedDisabled ? -1 : 0,
            style: this.getHandleStyle(f3, s3),
            onFocus: () => {
              this.handleHandleFocus(s3);
            },
            onBlur: () => {
              this.handleHandleBlur(s3);
            },
            onMouseenter: () => {
              this.handleHandleMouseEnter(s3);
            },
            onMouseleave: () => {
              this.handleHandleMouseLeave(s3);
            }
          }, p$3H(this.$slots.thumb, () => [h$1R("div", {
            class: `${a3}-slider-handle`
          })]))
        }), this.tooltip && h$1R(me$h, {
          ref: this.setFollowerRefs(s3),
          show: V10,
          to: this.adjustedTo,
          enabled: this.showTooltip && !this.range || this.followerEnabledIndexSet.has(s3),
          teleportDisabled: this.adjustedTo === f$1m.tdkey,
          placement: this.mergedPlacement,
          containerClass: this.namespace
        }, {
          default: () => h$1R(Transition, {
            name: "fade-in-scale-up-transition",
            appear: this.isMounted,
            css: this.shouldKeepTooltipTransition(s3),
            onEnter: () => {
              this.followerEnabledIndexSet.add(s3);
            },
            onAfterLeave: () => {
              this.followerEnabledIndexSet.delete(s3);
            }
          }, {
            default: () => {
              var D3;
              return V10 ? ((D3 = this.indicatorOnRender) === null || D3 === void 0 || D3.call(this), h$1R("div", {
                class: [`${a3}-slider-handle-indicator`, this.indicatorThemeClass, `${a3}-slider-handle-indicator--${this.mergedPlacement}`],
                style: this.indicatorCssVars
              }, typeof R3 == "function" ? R3(f3) : f3)) : null;
            }
          })
        })]
      });
    })), this.marks ? h$1R("div", {
      class: `${a3}-slider-marks`
    }, this.markInfos.map((f3) => h$1R("div", {
      key: f3.label,
      class: `${a3}-slider-mark`,
      style: f3.style
    }, f3.label))) : null));
  }
});
const r$15 = defineComponent({
  name: "UISlider",
  inheritAttrs: false
}), f$P = defineComponent(__spreadProps(__spreadValues({}, r$15), {
  props: {
    value: {
      type: [Number, Array]
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    marks: {
      type: Object,
      default: void 0
    },
    tooltip: {
      type: Boolean,
      default: true
    },
    defaultValue: {
      type: Number,
      default: void 0
    },
    formatTooltip: {
      type: Function,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["update:value"],
  setup(e28) {
    return (l3, t3) => (openBlock(), createBlock(unref(pt$8), {
      "default-value": e28.defaultValue,
      "format-tooltip": e28.formatTooltip,
      tooltip: e28.tooltip,
      marks: e28.marks,
      step: e28.step,
      max: e28.max,
      min: e28.min,
      value: e28.value,
      "onUpdate:value": t3[0] || (t3[0] = (u3) => l3.$emit("update:value", u3)),
      disabled: e28.disabled
    }, null, 8, ["default-value", "format-tooltip", "tooltip", "marks", "step", "max", "min", "value", "disabled"]));
  }
})), s$19 = f$P;
var r$14 = /* @__PURE__ */ ((e28) => (e28.setDefault = "setDefault", e28.setCurrentToAll = "setCurrentToAll", e28.setAuto = "setAuto", e28.setAutoToAll = "setAutoToAll", e28.removeCurrent = "removeCurrent", e28.removeAll = "removeAll", e28))(r$14 || {}), t$V = /* @__PURE__ */ ((e28) => (e28.Pixels = "px", e28.Percent = "%", e28.Rem = "rem", e28.Em = "em", e28.ViewportWidth = "vw", e28.ViewportHeight = "vh", e28))(t$V || {}), l$17 = /* @__PURE__ */ ((e28) => (e28.Auto = "auto", e28))(l$17 || {});
const m$1o = {
  key: 0,
  class: "ghl-spacing__trigger-unit"
}, p$30 = defineComponent({
  __name: "Trigger",
  props: {
    isValid: {
      type: Boolean,
      defaultValue: true
    },
    value: {
      type: String,
      required: true
    },
    unit: {
      type: String,
      required: true
    },
    positionType: {
      type: String,
      required: true
    },
    readonly: Boolean
  },
  setup(e28) {
    return (y3, f3) => (openBlock(), createElementBlock("div", {
      class: normalizeClass([
        "ghl-spacing__trigger",
        e28.isValid ? "" : "invalid",
        ["left", "right"].includes(e28.positionType) ? "under" : "aside",
        e28.readonly ? "read-only" : ""
      ])
    }, [
      createVNode(unref(f$1w), { class: "ghl-spacing__trigger-value" }, {
        default: withCtx(() => {
          var _a2;
          return [
            createTextVNode(toDisplayString((_a2 = e28.value) != null ? _a2 : "-"), 1)
          ];
        }),
        _: 1
      }),
      Object.values(unref(l$17)).includes(e28.unit) ? createCommentVNode("", true) : (openBlock(), createElementBlock("span", m$1o, toDisplayString(e28.unit), 1))
    ], 2));
  }
}), S$p = p$30;
r$14.setDefault, r$14.setCurrentToAll, r$14.setAuto, r$14.setAutoToAll, r$14.removeCurrent, r$14.removeAll;
const n$Q = {
  margin: {
    min: -50,
    max: 50,
    suggestions: [l$17.Auto, "0", "10", "20", "40", "60", "80"]
  },
  padding: {
    min: 0,
    max: 50,
    suggestions: ["0", "10", "20", "40", "60", "80", "100", "140"]
  }
}, l$16 = {
  margin: {
    min: 0,
    max: 100,
    suggestions: [l$17.Auto, "0", "5", "10", "25", "50", "75"]
  },
  padding: {
    min: 0,
    max: 100,
    suggestions: ["0", "5", "10", "20", "25", "50", "75", "80"]
  }
}, i$11 = {
  margin: {
    step: 0.5,
    min: -10,
    max: 10,
    suggestions: [l$17.Auto, "0", "0.125", "0.25", "0.5", "1", "2"]
  },
  padding: {
    step: 0.5,
    min: 0,
    max: 10,
    suggestions: ["0", "0.125", "0.25", "0.5", "0.75", "1", "2", "3"]
  }
}, o$W = {
  [t$V.Pixels]: n$Q,
  [t$V.Percent]: l$16,
  [t$V.ViewportWidth]: l$16,
  [t$V.ViewportHeight]: l$16,
  [t$V.Rem]: i$11,
  [t$V.Em]: i$11,
  [l$17.Auto]: n$Q
}, m$1n = Object.values(t$V).map((e28) => ({
  label: e28,
  value: e28,
  meta: o$W[e28]
})), u$17 = Object.values(l$17).map((e28) => ({
  label: e28,
  value: e28,
  meta: o$W[e28]
})), r$13 = m$1n.concat(u$17), c$1d = m$1n;
const ie$e = { class: "spacing-comp-dropdown" }, ne$f = { class: "spacing-comp-dropdown__container" }, ue$d = { class: "ghl-spacing__menu" }, le$b = { class: "ghl-spacing__menu-top" }, se$d = { class: "ghl-spacing__suggestion" }, re$c = { class: "ghl-spacing__footer" }, pe$d = defineComponent({
  __name: "Dropdown",
  props: {
    id: String,
    value: String,
    spaceType: {
      type: String,
      required: true
    },
    positionType: {
      type: String,
      required: true
    },
    defaultValue: {
      type: String,
      required: true
    },
    showSuggestions: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: "bottom"
    },
    readonly: Boolean
  },
  emits: [
    "update:value",
    "update:action",
    "update:popOverStatus"
  ],
  setup(v3, { emit: B3 }) {
    const i = v3, a3 = ref$1(l$17.Auto), t3 = ref$1("0"), T3 = B3, D3 = (e28) => {
      const s3 = a3.value, n3 = Object.values(t$V);
      return a3.value = e28, n3.includes(e28) && n3.includes(s3) ? (r3(), false) : (e28.includes("auto") ? t3.value = l$17.Auto : t3.value = "0", r3(), true);
    }, P3 = () => {
      const e28 = t3.value.toString().trim();
      return a3.value.includes("auto") ? (t3.value = l$17.Auto, r3(), false) : isNaN(Number(e28)) || !CSS.supports(`${i.spaceType}-${i.positionType}`, `${t3.value}${a3.value}`) ? (t3.value = "0", r3(), false) : (t3.value = e28, r3(), true);
    }, z3 = (e28) => {
      t3.value = e28.toString(), r3();
    }, E3 = (e28) => {
      if (e28 === l$17.Auto)
        return t3.value = l$17.Auto, a3.value = l$17.Auto, r3(), false;
      a3.value === l$17.Auto && (a3.value = t$V.Pixels), t3.value = e28, r3();
    }, O3 = () => {
      t3.value = "0", a3.value = t$V.Pixels, r3();
    }, r3 = () => {
      T3("update:value", {
        spaceType: i.spaceType,
        position: i.positionType,
        value: t3.value,
        unit: a3.value
      });
    }, x3 = (e28) => {
      const s3 = /^(auto|-\d+(?:px|%|rem|em)|inherit|unset)$/;
      i.spaceType === "padding" && s3.test(i.value) && (t3.value = "0");
      const n3 = new RegExp(`(${Object.values(t$V).join("|")})`);
      if (e28 != null && e28.includes("auto"))
        t3.value = l$17.Auto, a3.value = l$17.Auto;
      else if (n3.test(e28)) {
        const [d3, c3] = e28.split(n3);
        t3.value = d3, a3.value = c3;
      }
    };
    onMounted(() => {
      var _a2;
      const e28 = (_a2 = i.value) != null ? _a2 : "0";
      x3(e28);
    }), onUpdated(() => {
      var _a2;
      const e28 = (_a2 = i.value) != null ? _a2 : "0";
      x3(e28);
    });
    const y3 = computed(() => {
      var _a2, _b2;
      var e28, s3, n3, d3, c3, f3;
      return i.spaceType === "margin" ? (_a2 = (s3 = (e28 = r$13.find((u3) => u3.value === a3.value)) == null ? void 0 : e28.meta) == null ? void 0 : s3.margin) != null ? _a2 : (n3 = o$W.auto) == null ? void 0 : n3.margin : (_b2 = (c3 = (d3 = c$1d.find((u3) => u3.value === a3.value)) == null ? void 0 : d3.meta) == null ? void 0 : c3.padding) != null ? _b2 : (f3 = o$W.auto) == null ? void 0 : f3.padding;
    }), U3 = computed(() => CSS.supports(`${i.spaceType}-${i.positionType}`, i.value)), R3 = (e28) => {
      T3("update:popOverStatus", e28);
    };
    return (e28, s3) => (openBlock(), createElementBlock("div", ie$e, [
      createElementVNode("div", ne$f, [
        createVNode(unref(Ie$8), {
          raw: "",
          trigger: "click",
          class: "override-shadow",
          placement: v3.placement,
          disabled: v3.readonly,
          "on-update:show": R3
        }, {
          trigger: withCtx(() => [
            createVNode(S$p, {
              isValid: U3.value,
              value: t3.value,
              unit: a3.value,
              positionType: v3.positionType,
              readonly: v3.readonly
            }, null, 8, ["isValid", "value", "unit", "positionType", "readonly"])
          ]),
          default: withCtx(() => {
            var _a2;
            var n3, d3, c3, f3;
            return [
              createElementVNode("div", ue$d, [
                createElementVNode("div", le$b, [
                  createVNode(unref(s$19), {
                    disabled: a3.value.includes("auto"),
                    min: (n3 = y3.value) == null ? void 0 : n3.min,
                    max: (d3 = y3.value) == null ? void 0 : d3.max,
                    value: Number(t3.value),
                    "onUpdate:value": z3,
                    tooltip: false,
                    step: (_a2 = (c3 = y3.value) == null ? void 0 : c3.step) != null ? _a2 : 1
                  }, null, 8, ["disabled", "min", "max", "value", "step"]),
                  createVNode(unref(m$1J), null, {
                    default: withCtx(() => [
                      createVNode(unref(P$O), {
                        placeholder: null,
                        size: "small",
                        id: "spacing",
                        value: t3.value,
                        "onUpdate:value": s3[0] || (s3[0] = (u3) => t3.value = u3),
                        onBlur: P3,
                        status: U3.value ? void 0 : "error"
                      }, null, 8, ["value", "status"]),
                      createVNode(unref(E$w), {
                        options: v3.spaceType === "padding" ? unref(c$1d) : unref(r$13),
                        value: a3.value,
                        "onUpdate:value": D3,
                        trigger: "click"
                      }, {
                        default: withCtx(() => [
                          createVNode(unref(q$C), {
                            id: "unit",
                            size: "small",
                            class: "units-button"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(a3.value !== "auto" ? a3.value : "-"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["options", "value"])
                    ]),
                    _: 1
                  })
                ]),
                createVNode(unref(p$3A)),
                createElementVNode("div", se$d, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList((f3 = y3.value) == null ? void 0 : f3.suggestions, (u3) => (openBlock(), createBlock(unref(le$g), {
                    key: u3,
                    size: "tiny",
                    id: u3,
                    class: normalizeClass([u3 === "auto" && "highlight", "ghl-spacing__suggestion--button"]),
                    onClick: (de2) => E3(u3)
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(u3.toUpperCase()), 1)
                    ]),
                    _: 2
                  }, 1032, ["id", "class", "onClick"]))), 128))
                ]),
                createVNode(unref(p$3A)),
                createElementVNode("div", re$c, [
                  createElementVNode("span", {
                    class: "clear",
                    onClick: O3
                  }, [
                    createVNode(unref(a$1e), { class: "w-4 h-4 text-gray-500 mr-1" }),
                    createTextVNode(" Reset ")
                  ]),
                  U3.value ? createCommentVNode("", true) : (openBlock(), createBlock(unref(_$E), {
                    key: 0,
                    class: "warning"
                  }, {
                    default: withCtx(() => [
                      createVNode(unref(l$1G)),
                      createTextVNode(" Provided value is invalid. ")
                    ]),
                    _: 1
                  }))
                ])
              ])
            ];
          }),
          _: 1
        }, 8, ["placement", "disabled"])
      ])
    ]));
  }
}), Be$8 = pe$d;
const T$z = (i) => (pushScopeId("data-v-31244a1f"), i = i(), popScopeId(), i), Y$i = { class: "ghl-spacing margin" }, q$m = /* @__PURE__ */ T$z(() => /* @__PURE__ */ createElementVNode("div", { class: "ghl-spacing__title" }, "Margin", -1)), G$m = ["onMouseover"], J$j = { class: "ghl-spacing__children" }, K$i = { class: "ghl-spacing padding" }, Q$j = /* @__PURE__ */ T$z(() => /* @__PURE__ */ createElementVNode("div", { class: "ghl-spacing__title" }, "padding", -1)), W$i = ["onMouseover"], Z$k = /* @__PURE__ */ T$z(() => /* @__PURE__ */ createElementVNode("div", { class: "padding--children empty" }, null, -1)), ee$d = defineComponent({
  __name: "Spacing",
  props: {
    margin: {
      type: Object,
      default: () => ({
        top: "auto",
        bottom: "auto",
        left: "auto",
        right: "auto"
      })
    },
    marginPositions: {
      type: Array,
      default: ["top", "bottom", "right", "left"]
    },
    padding: {
      type: Object,
      default: () => ({
        top: "0px",
        bottom: "0px",
        left: "0px",
        right: "0px"
      })
    },
    paddingPositions: {
      type: Array,
      default: ["top", "bottom", "right", "left"]
    },
    marginReadonly: Boolean,
    paddingReadonly: Boolean,
    placement: String
  },
  emits: ["update:value"],
  setup(i, { emit: C3 }) {
    const g3 = i, b3 = C3, a3 = ref$1({
      spacingType: "",
      marginPosition: ""
    }), o3 = ref$1(false), m3 = ref$1(false), l3 = ref$1({ margin: g3.margin, padding: g3.padding }), _3 = ({
      spaceType: t3,
      position: n3,
      value: e28,
      unit: s3
    }) => {
      s3 === l$17.Auto ? (b3("update:value", {
        changed: { [t3]: { [n3]: `${e28}` } },
        value: `${e28}`
      }), l3.value[t3][n3] = e28) : (b3("update:value", {
        changed: { [t3]: { [n3]: `${e28}${s3}` } },
        value: `${e28}${s3}`
      }), l3.value[t3][n3] = `${e28}${s3}`);
    };
    watch(() => g3.margin, (t3) => {
      l3.value.margin = t3;
    }), watch(() => g3.padding, (t3) => {
      l3.value.padding = t3;
    });
    const r3 = ref$1(0), $3 = (t3, n3) => {
      o3.value || (a3.value.marginPosition = n3, a3.value.spacingType = t3, document.body.style.cursor = n3 === "top" || n3 === "bottom" ? "ns-resize" : "ew-resize", N3());
    }, x3 = (t3) => {
      o3.value = t3, t3 || (document.body.style.cursor = "", a3.value = {
        spacingType: "",
        marginPosition: ""
      });
    }, N3 = () => {
      document.addEventListener("mousemove", S3), document.addEventListener("mouseup", u3), document.addEventListener("mouseleave", u3), document.addEventListener("mousedown", E3);
    }, E3 = () => {
      o3.value = true, x3(o3.value);
    }, S3 = async (t3) => {
      if (o3.value) {
        const e28 = a3.value.marginPosition === "top" || a3.value.marginPosition === "bottom" ? t3.clientY : t3.clientX;
        if (r3.value === 0)
          r3.value = e28;
        else {
          const s3 = e28 - r3.value, y3 = M3(l3.value[a3.value.spacingType][a3.value.marginPosition]), f3 = y3.unit;
          let h3 = y3.value;
          if (s3 !== 0) {
            const U3 = parseInt(h3) + s3;
            a3.value.spacingType === "padding" && U3 < 0 ? h3 = "0" : h3 = U3.toString();
          }
          l3.value[a3.value.spacingType][a3.value.marginPosition] = h3 + f3, r3.value = e28;
        }
      }
    }, u3 = () => {
      if (a3.value.spacingType && o3.value) {
        const t3 = M3(l3.value[a3.value.spacingType][a3.value.marginPosition]);
        _3({
          spaceType: a3.value.spacingType,
          position: a3.value.marginPosition,
          value: t3.value,
          unit: t3.unit
        });
      }
      o3.value = false, R3(), L3(), x3(o3.value), r3.value = 0;
    }, R3 = () => {
      document.removeEventListener("mousemove", S3), document.removeEventListener("mouseup", u3), document.removeEventListener("mouseleave", u3), document.removeEventListener("mousedown", E3), L3();
    }, V10 = () => {
      o3.value || u3();
    }, L3 = () => {
      document.body.style.cursor = "";
    }, M3 = (t3) => {
      const n3 = t3.match(/^([+-]?\d*\.?\d+)(px|%|rem|em|vw|vh)?$/);
      if (n3) {
        const [, e28, s3] = n3, y3 = s3 || t$V.Pixels, f3 = parseFloat(e28);
        return {
          unit: y3,
          value: isNaN(f3) ? "0" : f3.toString()
        };
      }
      return {
        unit: t$V.Pixels,
        value: "0"
      };
    }, D3 = (t3) => {
      u3(), t3 ? m3.value = true : m3.value = false;
    };
    return (t3, n3) => (openBlock(), createElementBlock("div", Y$i, [
      q$m,
      (openBlock(true), createElementBlock(Fragment, null, renderList(i.marginPositions, (e28) => (openBlock(), createElementBlock("div", {
        class: normalizeClass(["ghl-spacing__input", [
          `margin--${e28}`,
          o3.value && (a3.value.marginPosition !== e28 || a3.value.spacingType !== "margin") || m3.value ? "pointer-events-none" : "",
          a3.value.marginPosition === e28 && a3.value.spacingType === "margin" ? "ghl-spacing__input-background-color" : ""
        ]]),
        key: e28,
        onMouseover: (s3) => $3("margin", e28),
        onMouseleave: V10
      }, [
        createVNode(Be$8, {
          readonly: i.marginReadonly,
          positionType: e28,
          spaceType: "margin",
          defaultValue: "auto",
          value: l3.value.margin[e28],
          "onUpdate:value": _3,
          "onUpdate:popOverStatus": D3
        }, null, 8, ["readonly", "positionType", "value"])
      ], 42, G$m))), 128)),
      createElementVNode("div", J$j, [
        createElementVNode("div", K$i, [
          Q$j,
          (openBlock(true), createElementBlock(Fragment, null, renderList(i.paddingPositions, (e28) => (openBlock(), createElementBlock("div", {
            class: normalizeClass(["ghl-spacing__input", [
              `padding--${e28}`,
              o3.value && (a3.value.marginPosition !== e28 || a3.value.spacingType !== "padding") || m3.value ? "pointer-events-none" : "",
              a3.value.marginPosition === e28 && a3.value.spacingType === "padding" ? "ghl-spacing__input-background-color" : ""
            ]]),
            key: e28,
            onMouseover: (s3) => $3("padding", e28),
            onMouseleave: V10
          }, [
            createVNode(Be$8, {
              readonly: i.paddingReadonly,
              positionType: e28,
              spaceType: "padding",
              defaultValue: "0px",
              value: l3.value.padding[e28],
              "onUpdate:value": _3,
              "onUpdate:popOverStatus": D3
            }, null, 8, ["readonly", "positionType", "value"])
          ], 42, W$i))), 128)),
          Z$k
        ])
      ])
    ]));
  }
}), ie$d = /* @__PURE__ */ s$1d(ee$d, [["__scopeId", "data-v-31244a1f"]]);
const h$11 = {
  key: 0,
  class: "hl-card-header"
}, _$p = { class: "hl-card-content" }, f$O = {
  key: 1,
  class: "hl-card-footer"
}, m$1m = defineComponent({
  name: "UICard",
  inheritAttrs: false
}), u$16 = defineComponent(__spreadProps(__spreadValues({}, m$1m), {
  setup(p3) {
    const r3 = useSlots();
    return (e28, k3) => (openBlock(), createElementBlock("div", mergeProps(e28.$attrs, { class: "hl-card" }), [
      unref(r3).header ? (openBlock(), createElementBlock("div", h$11, [
        renderSlot(e28.$slots, "header")
      ])) : createCommentVNode("", true),
      createElementVNode("div", _$p, [
        renderSlot(e28.$slots, "default")
      ]),
      unref(r3).footer ? (openBlock(), createElementBlock("div", f$O, [
        renderSlot(e28.$slots, "footer")
      ])) : createCommentVNode("", true)
    ], 16));
  }
})), $$h = u$16;
function i$10(t3, r3) {
  let {
    offsetWidth: e28,
    offsetHeight: n3
  } = t3;
  if (r3) {
    const o3 = getComputedStyle(t3);
    e28 = e28 - parseFloat(o3.getPropertyValue("padding-left")) - parseFloat(o3.getPropertyValue("padding-right")), n3 = n3 - parseFloat(o3.getPropertyValue("padding-top")) - parseFloat(o3.getPropertyValue("padding-bottom"));
  }
  return {
    width: e28,
    height: n3
  };
}
function p$2$(t3, r3, e28) {
  return t3 < r3 ? r3 : t3 > e28 ? e28 : t3;
}
function a$1d(t3) {
  if (t3 === void 0)
    return 0;
  if (typeof t3 == "number")
    return t3;
  const r3 = /^((\d+)?\.?\d+?)(ms|s)?$/, e28 = t3.match(r3);
  if (e28) {
    const [, n3, , o3 = "ms"] = e28;
    return Number(n3) * (o3 === "ms" ? 1 : 1e3);
  }
  return 0;
}
const t$U = n$28("n-carousel-methods"), p$2_ = (o3) => {
  provide(t$U, o3);
}, l$15 = (o3 = "unknown", r3 = "component") => {
  const e28 = inject(t$U);
  return e28 || t$1P(o3, `\`${r3}\` must be placed inside \`n-carousel\`.`), e28;
};
const _$o = {
  total: {
    type: Number,
    default: 0
  },
  currentIndex: {
    type: Number,
    default: 0
  },
  dotType: {
    type: String,
    default: "dot"
  },
  trigger: {
    type: String,
    default: "click"
  },
  keyboard: Boolean
}, A$r = defineComponent({
  name: "CarouselDots",
  props: _$o,
  setup(o3) {
    const {
      mergedClsPrefixRef: i
    } = a$2x(o3), r3 = ref$1([]), t3 = l$15();
    function a3(e28, n3) {
      switch (e28.key) {
        case "Enter":
        case " ":
          e28.preventDefault(), t3.to(n3);
          return;
      }
      o3.keyboard && p3(e28);
    }
    function h3(e28) {
      o3.trigger === "hover" && t3.to(e28);
    }
    function m3(e28) {
      o3.trigger === "click" && t3.to(e28);
    }
    function p3(e28) {
      var n3;
      if (e28.shiftKey || e28.altKey || e28.ctrlKey || e28.metaKey)
        return;
      const c3 = (n3 = document.activeElement) === null || n3 === void 0 ? void 0 : n3.nodeName.toLowerCase();
      if (c3 === "input" || c3 === "textarea")
        return;
      const {
        code: s3
      } = e28, y3 = s3 === "PageUp" || s3 === "ArrowUp", g3 = s3 === "PageDown" || s3 === "ArrowDown", x3 = s3 === "PageUp" || s3 === "ArrowRight", w3 = s3 === "PageDown" || s3 === "ArrowLeft", d3 = t3.isVertical(), u3 = d3 ? y3 : x3, f3 = d3 ? g3 : w3;
      !u3 && !f3 || (e28.preventDefault(), u3 && !t3.isNextDisabled() ? (t3.next(), l3(t3.currentIndexRef.value)) : f3 && !t3.isPrevDisabled() && (t3.prev(), l3(t3.currentIndexRef.value)));
    }
    function l3(e28) {
      var n3;
      (n3 = r3.value[e28]) === null || n3 === void 0 || n3.focus();
    }
    return onBeforeUpdate(() => r3.value.length = 0), {
      mergedClsPrefix: i,
      dotEls: r3,
      handleKeydown: a3,
      handleMouseenter: h3,
      handleClick: m3
    };
  },
  render() {
    const {
      mergedClsPrefix: o3,
      dotEls: i
    } = this;
    return h$1R("div", {
      class: [`${o3}-carousel__dots`, `${o3}-carousel__dots--${this.dotType}`],
      role: "tablist"
    }, u$1M(this.total, (r3) => {
      const t3 = r3 === this.currentIndex;
      return h$1R("div", {
        "aria-selected": t3,
        ref: (a3) => i.push(a3),
        role: "button",
        tabindex: "0",
        class: [`${o3}-carousel__dot`, t3 && `${o3}-carousel__dot--active`],
        key: r3,
        onClick: () => {
          this.handleClick(r3);
        },
        onMouseenter: () => {
          this.handleMouseenter(r3);
        },
        onKeydown: (a3) => {
          this.handleKeydown(a3, r3);
        }
      });
    }));
  }
});
const u$15 = h$1R("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, h$1R("g", {
  fill: "none"
}, h$1R("path", {
  d: "M10.26 3.2a.75.75 0 0 1 .04 1.06L6.773 8l3.527 3.74a.75.75 0 1 1-1.1 1.02l-4-4.25a.75.75 0 0 1 0-1.02l4-4.25a.75.75 0 0 1 1.06-.04z",
  fill: "currentColor"
}))), w$u = h$1R("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, h$1R("g", {
  fill: "none"
}, h$1R("path", {
  d: "M5.74 3.2a.75.75 0 0 0-.04 1.06L9.227 8L5.7 11.74a.75.75 0 1 0 1.1 1.02l4-4.25a.75.75 0 0 0 0-1.02l-4-4.25a.75.75 0 0 0-1.06-.04z",
  fill: "currentColor"
}))), p$2Z = defineComponent({
  name: "CarouselArrow",
  setup(e28) {
    const {
      mergedClsPrefixRef: o3
    } = a$2x(e28), {
      isVertical: s3,
      isPrevDisabled: l3,
      isNextDisabled: a3,
      prev: t3,
      next: i
    } = l$15();
    return {
      mergedClsPrefix: o3,
      isVertical: s3,
      isPrevDisabled: l3,
      isNextDisabled: a3,
      prev: t3,
      next: i
    };
  },
  render() {
    const {
      mergedClsPrefix: e28
    } = this;
    return h$1R("div", {
      class: `${e28}-carousel__arrow-group`
    }, h$1R("div", {
      class: [`${e28}-carousel__arrow`, this.isPrevDisabled() && `${e28}-carousel__arrow--disabled`],
      role: "button",
      onClick: this.prev
    }, u$15), h$1R("div", {
      class: [`${e28}-carousel__arrow`, this.isNextDisabled() && `${e28}-carousel__arrow--disabled`],
      role: "button",
      onClick: this.next
    }, w$u));
  }
});
function p$2Y(r3) {
  return p$3C(o$1u(r3).toLowerCase());
}
function l$14(e28, f3, n3, h3) {
  var i = -1, d3 = e28 == null ? 0 : e28.length;
  for (h3 && d3 && (n3 = e28[++i]); ++i < d3; )
    n3 = f3(n3, e28[i], i, e28);
  return n3;
}
function r$12(n3) {
  return function(e28) {
    return n3 == null ? void 0 : n3[e28];
  };
}
var x$o = {
  \u00C0: "A",
  \u00C1: "A",
  \u00C2: "A",
  \u00C3: "A",
  \u00C4: "A",
  \u00C5: "A",
  \u00E0: "a",
  \u00E1: "a",
  \u00E2: "a",
  \u00E3: "a",
  \u00E4: "a",
  \u00E5: "a",
  \u00C7: "C",
  \u00E7: "c",
  \u00D0: "D",
  \u00F0: "d",
  \u00C8: "E",
  \u00C9: "E",
  \u00CA: "E",
  \u00CB: "E",
  \u00E8: "e",
  \u00E9: "e",
  \u00EA: "e",
  \u00EB: "e",
  \u00CC: "I",
  \u00CD: "I",
  \u00CE: "I",
  \u00CF: "I",
  \u00EC: "i",
  \u00ED: "i",
  \u00EE: "i",
  \u00EF: "i",
  \u00D1: "N",
  \u00F1: "n",
  \u00D2: "O",
  \u00D3: "O",
  \u00D4: "O",
  \u00D5: "O",
  \u00D6: "O",
  \u00D8: "O",
  \u00F2: "o",
  \u00F3: "o",
  \u00F4: "o",
  \u00F5: "o",
  \u00F6: "o",
  \u00F8: "o",
  \u00D9: "U",
  \u00DA: "U",
  \u00DB: "U",
  \u00DC: "U",
  \u00F9: "u",
  \u00FA: "u",
  \u00FB: "u",
  \u00FC: "u",
  \u00DD: "Y",
  \u00FD: "y",
  \u00FF: "y",
  \u00C6: "Ae",
  \u00E6: "ae",
  \u00DE: "Th",
  \u00FE: "th",
  \u00DF: "ss",
  \u0100: "A",
  \u0102: "A",
  \u0104: "A",
  \u0101: "a",
  \u0103: "a",
  \u0105: "a",
  \u0106: "C",
  \u0108: "C",
  \u010A: "C",
  \u010C: "C",
  \u0107: "c",
  \u0109: "c",
  \u010B: "c",
  \u010D: "c",
  \u010E: "D",
  \u0110: "D",
  \u010F: "d",
  \u0111: "d",
  \u0112: "E",
  \u0114: "E",
  \u0116: "E",
  \u0118: "E",
  \u011A: "E",
  \u0113: "e",
  \u0115: "e",
  \u0117: "e",
  \u0119: "e",
  \u011B: "e",
  \u011C: "G",
  \u011E: "G",
  \u0120: "G",
  \u0122: "G",
  \u011D: "g",
  \u011F: "g",
  \u0121: "g",
  \u0123: "g",
  \u0124: "H",
  \u0126: "H",
  \u0125: "h",
  \u0127: "h",
  \u0128: "I",
  \u012A: "I",
  \u012C: "I",
  \u012E: "I",
  \u0130: "I",
  \u0129: "i",
  \u012B: "i",
  \u012D: "i",
  \u012F: "i",
  \u0131: "i",
  \u0134: "J",
  \u0135: "j",
  \u0136: "K",
  \u0137: "k",
  \u0138: "k",
  \u0139: "L",
  \u013B: "L",
  \u013D: "L",
  \u013F: "L",
  \u0141: "L",
  \u013A: "l",
  \u013C: "l",
  \u013E: "l",
  \u0140: "l",
  \u0142: "l",
  \u0143: "N",
  \u0145: "N",
  \u0147: "N",
  \u014A: "N",
  \u0144: "n",
  \u0146: "n",
  \u0148: "n",
  \u014B: "n",
  \u014C: "O",
  \u014E: "O",
  \u0150: "O",
  \u014D: "o",
  \u014F: "o",
  \u0151: "o",
  \u0154: "R",
  \u0156: "R",
  \u0158: "R",
  \u0155: "r",
  \u0157: "r",
  \u0159: "r",
  \u015A: "S",
  \u015C: "S",
  \u015E: "S",
  \u0160: "S",
  \u015B: "s",
  \u015D: "s",
  \u015F: "s",
  \u0161: "s",
  \u0162: "T",
  \u0164: "T",
  \u0166: "T",
  \u0163: "t",
  \u0165: "t",
  \u0167: "t",
  \u0168: "U",
  \u016A: "U",
  \u016C: "U",
  \u016E: "U",
  \u0170: "U",
  \u0172: "U",
  \u0169: "u",
  \u016B: "u",
  \u016D: "u",
  \u016F: "u",
  \u0171: "u",
  \u0173: "u",
  \u0174: "W",
  \u0175: "w",
  \u0176: "Y",
  \u0177: "y",
  \u0178: "Y",
  \u0179: "Z",
  \u017B: "Z",
  \u017D: "Z",
  \u017A: "z",
  \u017C: "z",
  \u017E: "z",
  \u0132: "IJ",
  \u0133: "ij",
  \u0152: "Oe",
  \u0153: "oe",
  \u0149: "'n",
  \u017F: "s"
}, e$12 = r$12(x$o);
const c$1c = e$12;
var a$1c = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, f$N = "\\u0300-\\u036f", u$14 = "\\ufe20-\\ufe2f", m$1l = "\\u20d0-\\u20ff", b$H = f$N + u$14 + m$1l, t$T = "[" + b$H + "]", x$n = RegExp(t$T, "g");
function p$2X(r3) {
  return r3 = o$1u(r3), r3 && r3.replace(a$1c, c$1c).replace(x$n, "");
}
var r$11 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function a$1b(x3) {
  return x3.match(r$11) || [];
}
var e$11 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function r$10(a3) {
  return e$11.test(a3);
}
var f$M = "\\ud800-\\udfff", l$13 = "\\u0300-\\u036f", C$K = "\\ufe20-\\ufe2f", O$p = "\\u20d0-\\u20ff", L$v = l$13 + C$K + O$p, d$16 = "\\u2700-\\u27bf", o$V = "a-z\\xdf-\\xf6\\xf8-\\xff", j$i = "\\xac\\xb1\\xd7\\xf7", D$z = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", S$o = "\\u2000-\\u206f", U$p = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", n$P = "A-Z\\xc0-\\xd6\\xd8-\\xde", v$G = "\\ufe0e\\ufe0f", t$S = j$i + D$z + S$o + U$p, x$m = "['\u2019]", u$13 = "[" + t$S + "]", w$t = "[" + L$v + "]", i$$ = "\\d+", A$q = "[" + d$16 + "]", g$L = "[" + o$V + "]", p$2W = "[^" + f$M + t$S + i$$ + d$16 + o$V + n$P + "]", h$10 = "\\ud83c[\\udffb-\\udfff]", k$x = "(?:" + w$t + "|" + h$10 + ")", E$r = "[^" + f$M + "]", b$G = "(?:\\ud83c[\\udde6-\\uddff]){2}", R$j = "[\\ud800-\\udbff][\\udc00-\\udfff]", r$$ = "[" + n$P + "]", z$l = "\\u200d", s$18 = "(?:" + g$L + "|" + p$2W + ")", N$y = "(?:" + r$$ + "|" + p$2W + ")", e$10 = "(?:" + x$m + "(?:d|ll|m|re|s|t|ve))?", a$1a = "(?:" + x$m + "(?:D|LL|M|RE|S|T|VE))?", c$1b = k$x + "?", m$1k = "[" + v$G + "]?", T$y = "(?:" + z$l + "(?:" + [E$r, b$G, R$j].join("|") + ")" + m$1k + c$1b + ")*", V$n = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", W$h = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Z$j = m$1k + c$1b + T$y, B$u = "(?:" + [A$q, b$G, R$j].join("|") + ")" + Z$j, H$j = RegExp([
  r$$ + "?" + g$L + "+" + e$10 + "(?=" + [u$13, r$$, "$"].join("|") + ")",
  N$y + "+" + a$1a + "(?=" + [u$13, r$$ + s$18, "$"].join("|") + ")",
  r$$ + "?" + s$18 + "+" + e$10,
  r$$ + "+" + a$1a,
  W$h,
  V$n,
  i$$,
  B$u
].join("|"), "g");
function J$i(M3) {
  return M3.match(H$j) || [];
}
function a$19(o3, d3, r3) {
  return o3 = o$1u(o3), d3 = r3 ? void 0 : d3, d3 === void 0 ? r$10(o3) ? J$i(o3) : a$1b(o3) : o3.match(d3) || [];
}
var u$12 = "['\u2019]", a$18 = RegExp(u$12, "g");
function c$1a(r3) {
  return function(e28) {
    return l$14(a$19(p$2X(e28).replace(a$18, "")), r3, "");
  };
}
var m$1j = c$1a(function(a3, e28, t3) {
  return e28 = e28.toLowerCase(), a3 + (t3 ? p$2Y(e28) : e28);
});
const n$O = m$1j;
const d$15 = "CarouselItem", $$g = (l3) => {
  var t3;
  return ((t3 = l3.type) === null || t3 === void 0 ? void 0 : t3.name) === d$15;
}, S$n = defineComponent({
  name: d$15,
  setup(l3) {
    const {
      mergedClsPrefixRef: t3
    } = a$2x(l3), e28 = l$15(n$O(d$15), `n-${n$O(d$15)}`), o3 = ref$1(), s3 = computed(() => {
      const {
        value: a3
      } = o3;
      return a3 ? e28.getSlideIndex(a3) : -1;
    }), i = computed(() => e28.isPrev(s3.value)), r3 = computed(() => e28.isNext(s3.value)), u3 = computed(() => e28.isActive(s3.value)), c3 = computed(() => e28.getSlideStyle(s3.value));
    onMounted(() => {
      e28.addSlide(o3.value);
    }), onBeforeUnmount(() => {
      e28.removeSlide(o3.value);
    });
    function m3(a3) {
      const {
        value: f3
      } = s3;
      f3 !== void 0 && (e28 == null || e28.onCarouselItemClick(f3, a3));
    }
    return {
      mergedClsPrefix: t3,
      selfElRef: o3,
      isPrev: i,
      isNext: r3,
      isActive: u3,
      index: s3,
      style: c3,
      handleClick: m3
    };
  },
  render() {
    var l3;
    const {
      $slots: t3,
      mergedClsPrefix: e28,
      isPrev: o3,
      isNext: s3,
      isActive: i,
      index: r3,
      style: u3
    } = this, c3 = [`${e28}-carousel__slide`, {
      [`${e28}-carousel__slide--current`]: i,
      [`${e28}-carousel__slide--prev`]: o3,
      [`${e28}-carousel__slide--next`]: s3
    }];
    return h$1R("div", {
      ref: "selfElRef",
      class: c3,
      role: "option",
      tabindex: "-1",
      "data-index": r3,
      "aria-hidden": !i,
      style: u3,
      onClickCapture: this.handleClick
    }, (l3 = t3.default) === null || l3 === void 0 ? void 0 : l3.call(t3, {
      isPrev: o3,
      isNext: s3,
      isActive: i,
      index: r3
    }));
  }
});
const n$N = l$25("carousel", `
 position: relative;
 width: 100%;
 height: 100%;
 touch-action: pan-y;
 overflow: hidden;
`, [M$y("slides", `
 display: flex;
 width: 100%;
 height: 100%;
 transition-timing-function: var(--n-bezier);
 transition-property: transform;
 `, [M$y("slide", `
 flex-shrink: 0;
 position: relative;
 width: 100%;
 height: 100%;
 outline: none;
 overflow: hidden;
 `, [r$2a("> img", `
 display: block;
 `)])]), M$y("dots", `
 position: absolute;
 display: flex;
 flex-wrap: nowrap;
 `, [g$1j("dot", [M$y("dot", `
 height: var(--n-dot-size);
 width: var(--n-dot-size);
 background-color: var(--n-dot-color);
 border-radius: 50%;
 cursor: pointer;
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [r$2a("&:focus", `
 background-color: var(--n-dot-color-focus);
 `), g$1j("active", `
 background-color: var(--n-dot-color-active);
 `)])]), g$1j("line", [M$y("dot", `
 border-radius: 9999px;
 width: var(--n-dot-line-width);
 height: 4px;
 background-color: var(--n-dot-color);
 cursor: pointer;
 transition:
 width .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [r$2a("&:focus", `
 background-color: var(--n-dot-color-focus);
 `), g$1j("active", `
 width: var(--n-dot-line-width-active);
 background-color: var(--n-dot-color-active);
 `)])])]), M$y("arrow", `
 transition: background-color .3s var(--n-bezier);
 cursor: pointer;
 height: 28px;
 width: 28px;
 display: flex;
 align-items: center;
 justify-content: center;
 background-color: rgba(255, 255, 255, .2);
 color: var(--n-arrow-color);
 border-radius: 8px;
 user-select: none;
 -webkit-user-select: none;
 font-size: 18px;
 `, [r$2a("svg", `
 height: 1em;
 width: 1em;
 `), r$2a("&:hover", `
 background-color: rgba(255, 255, 255, .3);
 `)]), g$1j("vertical", `
 touch-action: pan-x;
 `, [M$y("slides", `
 flex-direction: column;
 `), g$1j("fade", [M$y("slide", `
 top: 50%;
 left: unset;
 transform: translateY(-50%);
 `)]), g$1j("card", [M$y("slide", `
 top: 50%;
 left: unset;
 transform: translateY(-50%) translateZ(-400px);
 `, [g$1j("current", `
 transform: translateY(-50%) translateZ(0);
 `), g$1j("prev", `
 transform: translateY(-100%) translateZ(-200px);
 `), g$1j("next", `
 transform: translateY(0%) translateZ(-200px);
 `)])])]), g$1j("usercontrol", [M$y("slides", [r$2a(">", [r$2a("div", `
 position: absolute;
 top: 50%;
 left: 50%;
 width: 100%;
 height: 100%;
 transform: translate(-50%, -50%);
 `)])])]), g$1j("left", [M$y("dots", `
 transform: translateY(-50%);
 top: 50%;
 left: 12px;
 flex-direction: column;
 `, [g$1j("line", [M$y("dot", `
 width: 4px;
 height: var(--n-dot-line-width);
 margin: 4px 0;
 transition:
 height .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [g$1j("active", `
 height: var(--n-dot-line-width-active);
 `)])])]), M$y("dot", `
 margin: 4px 0;
 `)]), M$y("arrow-group", `
 position: absolute;
 display: flex;
 flex-wrap: nowrap;
 `), g$1j("vertical", [M$y("arrow", `
 transform: rotate(90deg);
 `)]), g$1j("show-arrow", [g$1j("bottom", [M$y("dots", `
 transform: translateX(0);
 bottom: 18px;
 left: 18px;
 `)]), g$1j("top", [M$y("dots", `
 transform: translateX(0);
 top: 18px;
 left: 18px;
 `)]), g$1j("left", [M$y("dots", `
 transform: translateX(0);
 top: 18px;
 left: 18px;
 `)]), g$1j("right", [M$y("dots", `
 transform: translateX(0);
 top: 18px;
 right: 18px;
 `)])]), g$1j("left", [M$y("arrow-group", `
 bottom: 12px;
 left: 12px;
 flex-direction: column;
 `, [r$2a("> *:first-child", `
 margin-bottom: 12px;
 `)])]), g$1j("right", [M$y("dots", `
 transform: translateY(-50%);
 top: 50%;
 right: 12px;
 flex-direction: column;
 `, [g$1j("line", [M$y("dot", `
 width: 4px;
 height: var(--n-dot-line-width);
 margin: 4px 0;
 transition:
 height .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [g$1j("active", `
 height: var(--n-dot-line-width-active);
 `)])])]), M$y("dot", `
 margin: 4px 0;
 `), M$y("arrow-group", `
 bottom: 12px;
 right: 12px;
 flex-direction: column;
 `, [r$2a("> *:first-child", `
 margin-bottom: 12px;
 `)])]), g$1j("top", [M$y("dots", `
 transform: translateX(-50%);
 top: 12px;
 left: 50%;
 `, [g$1j("line", [M$y("dot", `
 margin: 0 4px;
 `)])]), M$y("dot", `
 margin: 0 4px;
 `), M$y("arrow-group", `
 top: 12px;
 right: 12px;
 `, [r$2a("> *:first-child", `
 margin-right: 12px;
 `)])]), g$1j("bottom", [M$y("dots", `
 transform: translateX(-50%);
 bottom: 12px;
 left: 50%;
 `, [g$1j("line", [M$y("dot", `
 margin: 0 4px;
 `)])]), M$y("dot", `
 margin: 0 4px;
 `), M$y("arrow-group", `
 bottom: 12px;
 right: 12px;
 `, [r$2a("> *:first-child", `
 margin-right: 12px;
 `)])]), g$1j("fade", [M$y("slide", `
 position: absolute;
 opacity: 0;
 transition-property: opacity;
 pointer-events: none;
 `, [g$1j("current", `
 opacity: 1;
 pointer-events: auto;
 `)])]), g$1j("card", [M$y("slides", `
 perspective: 1000px;
 `), M$y("slide", `
 position: absolute;
 left: 50%;
 opacity: 0;
 transform: translateX(-50%) translateZ(-400px);
 transition-property: opacity, transform;
 `, [g$1j("current", `
 opacity: 1;
 transform: translateX(-50%) translateZ(0);
 z-index: 1;
 `), g$1j("prev", `
 opacity: 0.4;
 transform: translateX(-100%) translateZ(-200px);
 `), g$1j("next", `
 opacity: 0.4;
 transform: translateX(0%) translateZ(-200px);
 `)])])]);
function o$U(n3) {
  const {
    length: e28
  } = n3;
  return e28 > 1 && (n3.push(t$R(n3[0], 0, "append")), n3.unshift(t$R(n3[e28 - 1], e28 - 1, "prepend"))), n3;
}
function t$R(n3, e28, u3) {
  return cloneVNode(n3, {
    key: `carousel-item-duplicate-${e28}-${u3}`
  });
}
function p$2V(n3, e28, u3) {
  return e28 === 1 ? 0 : u3 ? n3 === 0 ? e28 - 3 : n3 === e28 - 1 ? 0 : n3 - 1 : n3;
}
function r$_(n3, e28) {
  return e28 ? n3 + 1 : n3;
}
function l$12(n3, e28, u3) {
  return n3 < 0 ? null : n3 === 0 ? u3 ? e28 - 1 : null : n3 - 1;
}
function a$17(n3, e28, u3) {
  return n3 > e28 - 1 ? null : n3 === e28 - 1 ? u3 ? 0 : null : n3 + 1;
}
function d$14(n3, e28) {
  return e28 && n3 > 3 ? n3 - 2 : n3;
}
function o$T(n3) {
  return window.TouchEvent && n3 instanceof window.TouchEvent;
}
const t$Q = (e28) => ({
  dotSize: "8px",
  dotColor: "rgba(255, 255, 255, .3)",
  dotColorActive: "rgba(255, 255, 255, 1)",
  dotColorFocus: "rgba(255, 255, 255, .5)",
  dotLineWidth: "16px",
  dotLineWidthActive: "24px",
  arrowColor: "#eee"
}), r$Z = {
  name: "Carousel",
  common: d$1T,
  self: t$Q
}, i$_ = r$Z;
const Dt$4 = ["transitionDuration", "transitionTimingFunction"], Et$7 = Object.assign(Object.assign({}, _$F.props), {
  defaultIndex: {
    type: Number,
    default: 0
  },
  currentIndex: Number,
  showArrow: Boolean,
  dotType: {
    type: String,
    default: "dot"
  },
  dotPlacement: {
    type: String,
    default: "bottom"
  },
  slidesPerView: {
    type: [Number, String],
    default: 1
  },
  spaceBetween: {
    type: Number,
    default: 0
  },
  centeredSlides: Boolean,
  direction: {
    type: String,
    default: "horizontal"
  },
  autoplay: Boolean,
  interval: {
    type: Number,
    default: 5e3
  },
  loop: {
    type: Boolean,
    default: true
  },
  effect: {
    type: String,
    default: "slide"
  },
  showDots: {
    type: Boolean,
    default: true
  },
  trigger: {
    type: String,
    default: "click"
  },
  transitionStyle: {
    type: Object,
    default: () => ({
      transitionDuration: "300ms"
    })
  },
  transitionProps: Object,
  draggable: Boolean,
  prevSlideStyle: [Object, String],
  nextSlideStyle: [Object, String],
  touchable: {
    type: Boolean,
    default: true
  },
  mousewheel: Boolean,
  keyboard: Boolean,
  "onUpdate:currentIndex": Function,
  onUpdateCurrentIndex: Function
});
let ge$c = false;
const Zt$4 = defineComponent({
  name: "Carousel",
  props: Et$7,
  setup(l3) {
    const {
      mergedClsPrefixRef: f3,
      inlineThemeDisabled: P3
    } = a$2x(l3), $3 = ref$1(null), F3 = ref$1(null), x3 = ref$1([]), A3 = {
      value: []
    }, y3 = computed(() => l3.direction === "vertical"), R3 = computed(() => y3.value ? "height" : "width"), le2 = computed(() => y3.value ? "bottom" : "right"), c3 = computed(() => l3.effect === "slide"), d3 = computed(() => l3.loop && l3.slidesPerView === 1 && c3.value), V10 = computed(() => l3.effect === "custom"), D3 = computed(() => !c3.value || l3.centeredSlides ? 1 : l3.slidesPerView), B3 = computed(() => V10.value ? 1 : l3.slidesPerView), v3 = computed(() => D3.value === "auto" || l3.slidesPerView === "auto" && l3.centeredSlides), m3 = ref$1({
      width: 0,
      height: 0
    }), w3 = computed(() => {
      const {
        value: e28
      } = x3;
      if (!e28.length)
        return [];
      const {
        value: t3
      } = v3;
      if (t3)
        return e28.map((r3) => i$10(r3));
      const {
        value: n3
      } = B3, {
        value: i
      } = m3, {
        value: a3
      } = R3;
      let o3 = i[a3];
      if (n3 !== "auto") {
        const {
          spaceBetween: r3
        } = l3, h3 = o3 - (n3 - 1) * r3, ee2 = 1 / Math.max(1, n3);
        o3 = h3 * ee2;
      }
      const s3 = Object.assign(Object.assign({}, i), {
        [a3]: o3
      });
      return e28.map(() => s3);
    }), E3 = computed(() => {
      const {
        value: e28
      } = w3;
      if (!e28.length)
        return [];
      const {
        centeredSlides: t3,
        spaceBetween: n3
      } = l3, {
        value: i
      } = R3, {
        [i]: a3
      } = m3.value;
      let o3 = 0;
      return e28.map(({
        [i]: s3
      }) => {
        let r3 = o3;
        return t3 && (r3 += (s3 - a3) / 2), o3 += s3 + n3, r3;
      });
    }), Se2 = ref$1(false), oe2 = computed(() => {
      const {
        transitionStyle: e28
      } = l3;
      return e28 ? r$1C(e28, Dt$4) : {};
    }), ie2 = computed(() => V10.value ? 0 : a$1d(oe2.value.transitionDuration)), pe2 = computed(() => {
      const {
        value: e28
      } = x3;
      if (!e28.length)
        return [];
      const t3 = !(v3.value || B3.value === 1), n3 = (s3) => {
        if (t3) {
          const {
            value: r3
          } = R3;
          return {
            [r3]: `${w3.value[s3][r3]}px`
          };
        }
      };
      if (V10.value)
        return e28.map((s3, r3) => n3(r3));
      const {
        effect: i,
        spaceBetween: a3
      } = l3, {
        value: o3
      } = le2;
      return e28.reduce((s3, r3, h3) => {
        const ee2 = Object.assign(Object.assign({}, n3(h3)), {
          [`margin-${o3}`]: `${a3}px`
        });
        return s3.push(ee2), Se2.value && (i === "fade" || i === "card") && Object.assign(ee2, oe2.value), s3;
      }, []);
    }), g3 = computed(() => {
      const {
        value: e28
      } = D3, {
        length: t3
      } = x3.value;
      if (e28 !== "auto")
        return Math.max(t3 - e28, 0) + 1;
      {
        const {
          value: n3
        } = w3, {
          length: i
        } = n3;
        if (!i)
          return t3;
        const {
          value: a3
        } = E3, {
          value: o3
        } = R3, s3 = m3.value[o3];
        let r3 = n3[n3.length - 1][o3], h3 = i;
        for (; h3 > 1 && r3 < s3; )
          h3--, r3 += a3[h3] - a3[h3 - 1];
        return p$2$(h3 + 1, 1, i);
      }
    }), X3 = computed(() => d$14(g3.value, d3.value)), je2 = r$_(l3.defaultIndex, d3.value), ae2 = ref$1(p$2V(je2, g3.value, d3.value)), b3 = d$1S(toRef$1(l3, "currentIndex"), ae2), S3 = computed(() => r$_(b3.value, d3.value));
    function k3(e28) {
      var t3, n3;
      e28 = p$2$(e28, 0, g3.value - 1);
      const i = p$2V(e28, g3.value, d3.value), {
        value: a3
      } = b3;
      i !== b3.value && (ae2.value = i, (t3 = l3["onUpdate:currentIndex"]) === null || t3 === void 0 || t3.call(l3, i, a3), (n3 = l3.onUpdateCurrentIndex) === null || n3 === void 0 || n3.call(l3, i, a3));
    }
    function Y3(e28 = S3.value) {
      return l$12(e28, g3.value, l3.loop);
    }
    function q3(e28 = S3.value) {
      return a$17(e28, g3.value, l3.loop);
    }
    function $e2(e28) {
      const t3 = N3(e28);
      return t3 !== null && Y3() === t3;
    }
    function Ae2(e28) {
      const t3 = N3(e28);
      return t3 !== null && q3() === t3;
    }
    function xe2(e28) {
      return S3.value === N3(e28);
    }
    function Be2(e28) {
      return b3.value === e28;
    }
    function ye2() {
      return Y3() === null;
    }
    function we2() {
      return q3() === null;
    }
    function se2(e28) {
      const t3 = p$2$(r$_(e28, d3.value), 0, g3.value);
      (e28 !== b3.value || t3 !== S3.value) && k3(t3);
    }
    function re2() {
      const e28 = Y3();
      e28 !== null && k3(e28);
    }
    function H3() {
      const e28 = q3();
      e28 !== null && k3(e28);
    }
    function ke2() {
      (!p3 || !d3.value) && re2();
    }
    function _e2() {
      (!p3 || !d3.value) && H3();
    }
    let p3 = false, I3 = 0;
    const ue2 = ref$1({});
    function K3(e28, t3 = 0) {
      ue2.value = Object.assign({}, oe2.value, {
        transform: y3.value ? `translateY(${-e28}px)` : `translateX(${-e28}px)`,
        transitionDuration: `${t3}ms`
      });
    }
    function _3(e28 = 0) {
      c3.value ? ce2(S3.value, e28) : I3 !== 0 && (!p3 && e28 > 0 && (p3 = true), K3(I3 = 0, e28));
    }
    function ce2(e28, t3) {
      const n3 = be2(e28);
      n3 !== I3 && t3 > 0 && (p3 = true), I3 = be2(S3.value), K3(n3, t3);
    }
    function be2(e28) {
      let t3;
      return e28 >= g3.value - 1 ? t3 = Re2() : t3 = E3.value[e28] || 0, t3;
    }
    function Re2() {
      if (D3.value === "auto") {
        const {
          value: e28
        } = R3, {
          [e28]: t3
        } = m3.value, {
          value: n3
        } = E3, i = n3[n3.length - 1];
        let a3;
        if (i === void 0)
          a3 = t3;
        else {
          const {
            value: o3
          } = w3;
          a3 = i + o3[o3.length - 1][e28];
        }
        return a3 - t3;
      } else {
        const {
          value: e28
        } = E3;
        return e28[g3.value - 1] || 0;
      }
    }
    const L3 = {
      currentIndexRef: b3,
      to: se2,
      prev: ke2,
      next: _e2,
      isVertical: () => y3.value,
      isHorizontal: () => !y3.value,
      isPrev: $e2,
      isNext: Ae2,
      isActive: xe2,
      isPrevDisabled: ye2,
      isNextDisabled: we2,
      getSlideIndex: N3,
      getSlideStyle: Ue2,
      addSlide: Le2,
      removeSlide: We2,
      onCarouselItemClick: Fe2
    };
    p$2_(L3);
    function Le2(e28) {
      e28 && x3.value.push(e28);
    }
    function We2(e28) {
      if (!e28)
        return;
      const t3 = N3(e28);
      t3 !== -1 && x3.value.splice(t3, 1);
    }
    function N3(e28) {
      return typeof e28 == "number" ? e28 : e28 ? x3.value.indexOf(e28) : -1;
    }
    function Ue2(e28) {
      const t3 = N3(e28);
      if (t3 !== -1) {
        const n3 = [pe2.value[t3]], i = L3.isPrev(t3), a3 = L3.isNext(t3);
        return i && n3.push(l3.prevSlideStyle || ""), a3 && n3.push(l3.nextSlideStyle || ""), normalizeStyle(n3);
      }
    }
    function Fe2(e28, t3) {
      let n3 = !p3 && !Q3 && !me2;
      l3.effect === "card" && n3 && !xe2(e28) && (se2(e28), n3 = false), n3 || (t3.preventDefault(), t3.stopPropagation());
    }
    let G3 = null;
    function J3() {
      G3 && (clearInterval(G3), G3 = null);
    }
    function O3() {
      J3(), !l3.autoplay || X3.value < 2 || (G3 = window.setInterval(H3, l3.interval));
    }
    let de2 = 0, fe2 = 0, C3 = 0, ve2 = 0, Q3 = false, me2 = false;
    function Ce2(e28) {
      var t3;
      if (ge$c || !(!((t3 = F3.value) === null || t3 === void 0) && t3.contains(t$1G(e28))))
        return;
      ge$c = true, Q3 = true, me2 = false, ve2 = Date.now(), J3(), e28.type !== "touchstart" && !e28.target.isContentEditable && e28.preventDefault();
      const n3 = o$T(e28) ? e28.touches[0] : e28;
      y3.value ? fe2 = n3.clientY : de2 = n3.clientX, l3.touchable && (J$o("touchmove", document, Z3), J$o("touchend", document, M3), J$o("touchcancel", document, M3)), l3.draggable && (J$o("mousemove", document, Z3), J$o("mouseup", document, M3));
    }
    function Z3(e28) {
      const {
        value: t3
      } = y3, {
        value: n3
      } = R3, i = o$T(e28) ? e28.touches[0] : e28, a3 = t3 ? i.clientY - fe2 : i.clientX - de2, o3 = m3.value[n3];
      C3 = p$2$(a3, -o3, o3), e28.cancelable && e28.preventDefault(), c3.value && K3(I3 - C3, 0);
    }
    function M3() {
      const {
        value: e28
      } = S3;
      let t3 = e28;
      if (!p3 && C3 !== 0 && c3.value) {
        const n3 = I3 - C3, i = [...E3.value.slice(0, g3.value - 1), Re2()];
        let a3 = null;
        for (let o3 = 0; o3 < i.length; o3++) {
          const s3 = Math.abs(i[o3] - n3);
          if (a3 !== null && a3 < s3)
            break;
          a3 = s3, t3 = o3;
        }
      }
      if (t3 === e28) {
        const n3 = Date.now() - ve2, {
          value: i
        } = R3, a3 = m3.value[i];
        C3 > a3 / 2 || C3 / n3 > 0.4 ? t3 = Y3(e28) : (C3 < -a3 / 2 || C3 / n3 < -0.4) && (t3 = q3(e28));
      }
      t3 !== null && t3 !== e28 ? (me2 = true, k3(t3), nextTick(() => {
        (!d3.value || ae2.value !== b3.value) && _3(ie2.value);
      })) : _3(ie2.value), ze2(), O3();
    }
    function ze2() {
      Q3 && (ge$c = false), Q3 = false, de2 = 0, fe2 = 0, C3 = 0, ve2 = 0, K$p("touchmove", document, Z3), K$p("touchend", document, M3), K$p("touchcancel", document, M3), K$p("mousemove", document, Z3), K$p("mouseup", document, M3);
    }
    function Xe2() {
      if (c3.value && p3) {
        const {
          value: e28
        } = S3;
        ce2(e28, 0);
      } else
        O3();
      c3.value && (ue2.value.transitionDuration = "0ms"), p3 = false;
    }
    function Ye2(e28) {
      if (e28.preventDefault(), p3)
        return;
      let {
        deltaX: t3,
        deltaY: n3
      } = e28;
      e28.shiftKey && !t3 && (t3 = n3);
      const i = -1, a3 = 1, o3 = (t3 || n3) > 0 ? a3 : i;
      let s3 = 0, r3 = 0;
      y3.value ? r3 = o3 : s3 = o3;
      const h3 = 10;
      (r3 * n3 >= h3 || s3 * t3 >= h3) && (o3 === a3 && !we2() ? H3() : o3 === i && !ye2() && re2());
    }
    function qe2() {
      m3.value = i$10($3.value, true), O3();
    }
    function He2() {
      var e28, t3;
      v3.value && ((t3 = (e28 = w3.effect).scheduler) === null || t3 === void 0 || t3.call(e28), w3.effect.run());
    }
    function Ke2() {
      l3.autoplay && J3();
    }
    function Ge2() {
      l3.autoplay && O3();
    }
    onMounted(() => {
      watchEffect(O3), requestAnimationFrame(() => Se2.value = true);
    }), onBeforeUnmount(() => {
      ze2(), J3();
    }), onUpdated(() => {
      const {
        value: e28
      } = x3, {
        value: t3
      } = A3, n3 = /* @__PURE__ */ new Map(), i = (o3) => n3.has(o3) ? n3.get(o3) : -1;
      let a3 = false;
      for (let o3 = 0; o3 < e28.length; o3++) {
        const s3 = t3.findIndex((r3) => r3.el === e28[o3]);
        s3 !== o3 && (a3 = true), n3.set(e28[o3], s3);
      }
      a3 && e28.sort((o3, s3) => i(o3) - i(s3));
    }), watch(S3, (e28, t3) => {
      if (e28 !== t3)
        if (O3(), c3.value) {
          if (d3.value) {
            const {
              value: n3
            } = g3;
            X3.value > 2 && e28 === n3 - 2 && t3 === 1 ? e28 = 0 : e28 === 1 && t3 === n3 - 2 && (e28 = n3 - 1);
          }
          ce2(e28, ie2.value);
        } else
          _3();
    }, {
      immediate: true
    }), watch([d3, D3], () => void nextTick(() => {
      k3(S3.value);
    })), watch(E3, () => {
      c3.value && _3();
    }, {
      deep: true
    }), watch(c3, (e28) => {
      e28 ? _3() : (p3 = false, K3(I3 = 0));
    });
    const Je2 = computed(() => ({
      onTouchstartPassive: l3.touchable ? Ce2 : void 0,
      onMousedown: l3.draggable ? Ce2 : void 0,
      onWheel: l3.mousewheel ? Ye2 : void 0
    })), Qe2 = computed(() => Object.assign(Object.assign({}, r$1C(L3, ["to", "prev", "next", "isPrevDisabled", "isNextDisabled"])), {
      total: X3.value,
      currentIndex: b3.value
    })), Ze2 = computed(() => ({
      total: X3.value,
      currentIndex: b3.value,
      to: L3.to
    })), et2 = {
      getCurrentIndex: () => b3.value,
      to: se2,
      prev: re2,
      next: H3
    }, tt2 = _$F("Carousel", "-carousel", n$N, i$_, l3, f3), Pe2 = computed(() => {
      const {
        common: {
          cubicBezierEaseInOut: e28
        },
        self: {
          dotSize: t3,
          dotColor: n3,
          dotColorActive: i,
          dotColorFocus: a3,
          dotLineWidth: o3,
          dotLineWidthActive: s3,
          arrowColor: r3
        }
      } = tt2.value;
      return {
        "--n-bezier": e28,
        "--n-dot-color": n3,
        "--n-dot-color-focus": a3,
        "--n-dot-color-active": i,
        "--n-dot-size": t3,
        "--n-dot-line-width": o3,
        "--n-dot-line-width-active": s3,
        "--n-arrow-color": r3
      };
    }), j3 = P3 ? E$J("carousel", void 0, Pe2, l3) : void 0;
    return Object.assign(Object.assign({
      mergedClsPrefix: f3,
      selfElRef: $3,
      slidesElRef: F3,
      slideVNodes: A3,
      duplicatedable: d3,
      userWantsControl: V10,
      autoSlideSize: v3,
      realIndex: S3,
      slideStyles: pe2,
      translateStyle: ue2,
      slidesControlListeners: Je2,
      handleTransitionEnd: Xe2,
      handleResize: qe2,
      handleSlideResize: He2,
      handleMouseenter: Ke2,
      handleMouseleave: Ge2,
      isActive: Be2,
      arrowSlotProps: Qe2,
      dotSlotProps: Ze2
    }, et2), {
      cssVars: P3 ? void 0 : Pe2,
      themeClass: j3 == null ? void 0 : j3.themeClass,
      onRender: j3 == null ? void 0 : j3.onRender
    });
  },
  render() {
    var l3;
    const {
      mergedClsPrefix: f3,
      showArrow: P3,
      userWantsControl: $3,
      slideStyles: F3,
      dotType: x3,
      dotPlacement: A3,
      slidesControlListeners: y3,
      transitionProps: R3 = {},
      arrowSlotProps: le2,
      dotSlotProps: c3,
      $slots: {
        default: d3,
        dots: V10,
        arrow: D3
      }
    } = this, B3 = d3 && i$1A(d3()) || [];
    let v3 = Nt$5(B3);
    return v3.length || (v3 = B3.map((m3) => h$1R(S$n, null, {
      default: () => cloneVNode(m3)
    }))), this.duplicatedable && (v3 = o$U(v3)), this.slideVNodes.value = v3, this.autoSlideSize && (v3 = v3.map((m3) => h$1R(x$D, {
      onResize: this.handleSlideResize
    }, {
      default: () => m3
    }))), (l3 = this.onRender) === null || l3 === void 0 || l3.call(this), h$1R("div", Object.assign({
      ref: "selfElRef",
      class: [this.themeClass, `${f3}-carousel`, this.direction === "vertical" && `${f3}-carousel--vertical`, this.showArrow && `${f3}-carousel--show-arrow`, `${f3}-carousel--${A3}`, `${f3}-carousel--${this.direction}`, `${f3}-carousel--${this.effect}`, $3 && `${f3}-carousel--usercontrol`],
      style: this.cssVars
    }, y3, {
      onMouseenter: this.handleMouseenter,
      onMouseleave: this.handleMouseleave
    }), h$1R(x$D, {
      onResize: this.handleResize
    }, {
      default: () => h$1R("div", {
        ref: "slidesElRef",
        class: `${f3}-carousel__slides`,
        role: "listbox",
        style: this.translateStyle,
        onTransitionend: this.handleTransitionEnd
      }, $3 ? v3.map((m3, w3) => h$1R("div", {
        style: F3[w3],
        key: w3
      }, withDirectives(h$1R(Transition, Object.assign({}, R3), {
        default: () => m3
      }), [[vShow, this.isActive(w3)]]))) : v3)
    }), this.showDots && c3.total > 1 && c$21(V10, c3, () => [h$1R(A$r, {
      key: x3 + A3,
      total: c3.total,
      currentIndex: c3.currentIndex,
      dotType: x3,
      trigger: this.trigger,
      keyboard: this.keyboard
    })]), P3 && c$21(D3, le2, () => [h$1R(p$2Z, null)]));
  }
});
function Nt$5(l3) {
  return l3.reduce((f3, P3) => ($$g(P3) && f3.push(P3), f3), []);
}
const P$H = ["src"], A$p = defineComponent({
  name: "UICarousel",
  inheritAttrs: false,
  components: { NCarousel: Zt$4, NCarouselItem: S$n }
}), D$y = defineComponent(__spreadProps(__spreadValues({}, A$p), {
  props: {
    showArrow: Boolean,
    autoPlay: Boolean,
    direction: {
      type: String,
      default: "horizontal"
    },
    dotPlacement: {
      type: String,
      default: "bottom"
    },
    dotType: {
      type: String,
      default: "dot"
    },
    itemsPerView: {
      type: [Number, String],
      default: 1
    },
    spaceBetweenItems: {
      type: Number,
      default: 0
    },
    draggable: Boolean,
    loop: Boolean,
    centeredItems: Boolean,
    mousewheel: Boolean,
    showDots: Boolean,
    interval: {
      type: Number,
      default: 5e3
    },
    effect: {
      type: String,
      default: "slide"
    },
    touchable: {
      type: Boolean,
      default: true
    },
    transitionProps: {
      type: Object,
      default: void 0
    },
    transitionStyle: {
      type: Object,
      default: () => ({
        transitionDuration: "300ms"
      })
    },
    carouselItems: {
      type: Array,
      default: void 0
    },
    classNames: String,
    currentIndex: {
      type: Number,
      default: void 0
    }
  },
  emits: ["onUpdatedIndex"],
  setup(e28, { emit: h3 }) {
    const g3 = h3, c3 = useSlots(), b3 = (o3, u3) => {
      g3("onUpdatedIndex", o3, u3);
    };
    return (o3, u3) => (openBlock(), createBlock(unref(Zt$4), {
      "show-arrow": e28.showArrow,
      autoplay: e28.autoPlay,
      direction: e28.direction,
      "dot-type": e28.dotType,
      "dot-placement": e28.dotPlacement,
      class: normalizeClass(e28.classNames),
      "slides-per-view": e28.itemsPerView,
      "space-between": e28.spaceBetweenItems,
      draggable: e28.draggable,
      loop: e28.loop,
      "centered-slides": e28.centeredItems,
      mousewheel: e28.mousewheel,
      "show-dots": e28.showDots,
      touchable: e28.touchable,
      interval: e28.interval,
      effect: e28.effect,
      "transition-props": e28.transitionProps,
      "transition-style": e28.transitionStyle,
      "current-index": e28.currentIndex,
      "on-update:current-index": b3
    }, createSlots({
      dots: withCtx(({ total: t3, currentIndex: r3, to: s3 }) => [
        renderSlot(o3.$slots, "customDots", {
          total: t3,
          currentIndex: r3,
          changeTo: s3
        }, void 0, true)
      ]),
      default: withCtx(() => [
        unref(c3).customRender ? renderSlot(o3.$slots, "customRender", { key: 0 }, void 0, true) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(e28.carouselItems, (t3) => (openBlock(), createBlock(unref(S$n), {
          key: t3.key,
          class: normalizeClass(t3 == null ? void 0 : t3.class)
        }, {
          default: withCtx(() => [
            createElementVNode("img", {
              src: t3.src,
              class: normalizeClass(`ghl-carousel-image-${t3.key}`)
            }, null, 10, P$H)
          ]),
          _: 2
        }, 1032, ["class"]))), 128))
      ]),
      _: 2
    }, [
      unref(c3).customArrows ? {
        name: "arrow",
        fn: withCtx(({ total: t3, to: r3, currentIndex: s3, prev: p3, next: v3 }) => [
          renderSlot(o3.$slots, "customArrows", {
            total: t3,
            currrentIndex: s3,
            to: r3,
            prev: p3,
            next: v3
          }, void 0, true)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["show-arrow", "autoplay", "direction", "dot-type", "dot-placement", "class", "slides-per-view", "space-between", "draggable", "loop", "centered-slides", "mousewheel", "show-dots", "touchable", "interval", "effect", "transition-props", "transition-style", "current-index"]));
  }
})), z$k = /* @__PURE__ */ s$1d(D$y, [["__scopeId", "data-v-340e80ef"]]);
function a$16(t3, c3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.272 20.728l6.597-6.597c.396-.396.594-.594.822-.668a1 1 0 01.618 0c.228.074.426.272.822.668l6.553 6.553M14 15l2.869-2.869c.396-.396.594-.594.822-.668a1 1 0 01.618 0c.228.074.426.272.822.668L22 15M10 9a2 2 0 11-4 0 2 2 0 014 0zM6.8 21h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C22 18.72 22 17.88 22 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C2 5.28 2 6.12 2 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C4.28 21 5.12 21 6.8 21z"
    })
  ]);
}
const r$Y = Object.assign(Object.assign({}, _$F.props), {
  onPreviewPrev: Function,
  onPreviewNext: Function,
  showToolbar: {
    type: Boolean,
    default: true
  },
  showToolbarTooltip: Boolean
}), i$Z = n$28("n-image");
const t$P = h$1R("svg", {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("path", {
  d: "M6 5C5.75454 5 5.55039 5.17688 5.50806 5.41012L5.5 5.5V14.5C5.5 14.7761 5.72386 15 6 15C6.24546 15 6.44961 14.8231 6.49194 14.5899L6.5 14.5V5.5C6.5 5.22386 6.27614 5 6 5ZM13.8536 5.14645C13.68 4.97288 13.4106 4.9536 13.2157 5.08859L13.1464 5.14645L8.64645 9.64645C8.47288 9.82001 8.4536 10.0894 8.58859 10.2843L8.64645 10.3536L13.1464 14.8536C13.3417 15.0488 13.6583 15.0488 13.8536 14.8536C14.0271 14.68 14.0464 14.4106 13.9114 14.2157L13.8536 14.1464L9.70711 10L13.8536 5.85355C14.0488 5.65829 14.0488 5.34171 13.8536 5.14645Z",
  fill: "currentColor"
})), n$M = h$1R("svg", {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("path", {
  d: "M13.5 5C13.7455 5 13.9496 5.17688 13.9919 5.41012L14 5.5V14.5C14 14.7761 13.7761 15 13.5 15C13.2545 15 13.0504 14.8231 13.0081 14.5899L13 14.5V5.5C13 5.22386 13.2239 5 13.5 5ZM5.64645 5.14645C5.82001 4.97288 6.08944 4.9536 6.28431 5.08859L6.35355 5.14645L10.8536 9.64645C11.0271 9.82001 11.0464 10.0894 10.9114 10.2843L10.8536 10.3536L6.35355 14.8536C6.15829 15.0488 5.84171 15.0488 5.64645 14.8536C5.47288 14.68 5.4536 14.4106 5.58859 14.2157L5.64645 14.1464L9.79289 10L5.64645 5.85355C5.45118 5.65829 5.45118 5.34171 5.64645 5.14645Z",
  fill: "currentColor"
})), c$19 = h$1R("svg", {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("path", {
  d: "M4.089 4.216l.057-.07a.5.5 0 0 1 .638-.057l.07.057L10 9.293l5.146-5.147a.5.5 0 0 1 .638-.057l.07.057a.5.5 0 0 1 .057.638l-.057.07L10.707 10l5.147 5.146a.5.5 0 0 1 .057.638l-.057.07a.5.5 0 0 1-.638.057l-.07-.057L10 10.707l-5.146 5.147a.5.5 0 0 1-.638.057l-.07-.057a.5.5 0 0 1-.057-.638l.057-.07L9.293 10L4.146 4.854a.5.5 0 0 1-.057-.638l.057-.07l-.057.07z",
  fill: "currentColor"
})), L$u = h$1R("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 1024 1024"
}, h$1R("path", {
  fill: "currentColor",
  d: "M505.7 661a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
}));
const l$11 = r$2a([r$2a("body >", [l$25("image-container", "position: fixed;")]), l$25("image-preview-container", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 display: flex;
 `), l$25("image-preview-overlay", `
 z-index: -1;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 background: rgba(0, 0, 0, .3);
 `, [l$1T()]), l$25("image-preview-toolbar", `
 z-index: 1;
 position: absolute;
 left: 50%;
 transform: translateX(-50%);
 border-radius: var(--n-toolbar-border-radius);
 height: 48px;
 bottom: 40px;
 padding: 0 12px;
 background: var(--n-toolbar-color);
 box-shadow: var(--n-toolbar-box-shadow);
 color: var(--n-toolbar-icon-color);
 transition: color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 `, [l$25("base-icon", `
 padding: 0 8px;
 font-size: 28px;
 cursor: pointer;
 `), l$1T()]), l$25("image-preview-wrapper", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 display: flex;
 pointer-events: none;
 `, [$$n()]), l$25("image-preview", `
 user-select: none;
 -webkit-user-select: none;
 pointer-events: all;
 margin: auto;
 max-height: calc(100vh - 32px);
 max-width: calc(100vw - 32px);
 transition: transform .3s var(--n-bezier);
 `), l$25("image", `
 display: inline-flex;
 max-height: 100%;
 max-width: 100%;
 `, [x$I("preview-disabled", `
 cursor: pointer;
 `), r$2a("img", `
 border-radius: inherit;
 `)])]);
function e$$() {
  return {
    toolbarIconColor: "rgba(255, 255, 255, .9)",
    toolbarColor: "rgba(0, 0, 0, .35)",
    toolbarBoxShadow: "none",
    toolbarBorderRadius: "24px"
  };
}
const n$L = G$w({
  name: "Image",
  common: d$1T,
  peers: {
    Tooltip: d$1z
  },
  self: e$$
});
const e$_ = f$1z("rotateClockwise", h$1R("svg", {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("path", {
  d: "M17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 12.7916 4.63419 15.2026 7 16.3265V14.5C7 14.2239 7.22386 14 7.5 14C7.77614 14 8 14.2239 8 14.5V17.5C8 17.7761 7.77614 18 7.5 18H4.5C4.22386 18 4 17.7761 4 17.5C4 17.2239 4.22386 17 4.5 17H6.12422C3.66539 15.6357 2 13.0128 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 10.2761 17.7761 10.5 17.5 10.5C17.2239 10.5 17 10.2761 17 10Z",
  fill: "currentColor"
}), h$1R("path", {
  d: "M10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C11.1046 8 12 8.89543 12 10C12 11.1046 11.1046 12 10 12ZM10 11C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11Z",
  fill: "currentColor"
})));
const r$X = f$1z("rotateClockwise", h$1R("svg", {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("path", {
  d: "M3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 12.7916 15.3658 15.2026 13 16.3265V14.5C13 14.2239 12.7761 14 12.5 14C12.2239 14 12 14.2239 12 14.5V17.5C12 17.7761 12.2239 18 12.5 18H15.5C15.7761 18 16 17.7761 16 17.5C16 17.2239 15.7761 17 15.5 17H13.8758C16.3346 15.6357 18 13.0128 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 10.2761 2.22386 10.5 2.5 10.5C2.77614 10.5 3 10.2761 3 10Z",
  fill: "currentColor"
}), h$1R("path", {
  d: "M10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12ZM10 11C9.44772 11 9 10.5523 9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10C11 10.5523 10.5523 11 10 11Z",
  fill: "currentColor"
})));
const h$$ = defineComponent({
  name: "ResizeSmall",
  render() {
    return h$1R("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, h$1R("g", {
      fill: "none"
    }, h$1R("path", {
      d: "M5.5 4A1.5 1.5 0 0 0 4 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1h-1zM16 5.5A1.5 1.5 0 0 0 14.5 4h-1a.5.5 0 0 1 0-1h1A2.5 2.5 0 0 1 17 5.5v1a.5.5 0 0 1-1 0v-1zm0 9a1.5 1.5 0 0 1-1.5 1.5h-1a.5.5 0 0 0 0 1h1a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-1 0v1zm-12 0A1.5 1.5 0 0 0 5.5 16h1.25a.5.5 0 0 1 0 1H5.5A2.5 2.5 0 0 1 3 14.5v-1.25a.5.5 0 0 1 1 0v1.25zM8.5 7A1.5 1.5 0 0 0 7 8.5v3A1.5 1.5 0 0 0 8.5 13h3a1.5 1.5 0 0 0 1.5-1.5v-3A1.5 1.5 0 0 0 11.5 7h-3zM8 8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3z",
      fill: "currentColor"
    })));
  }
});
const l$10 = f$1z("zoomOut", h$1R("svg", {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("path", {
  d: "M11 8C11.2761 8 11.5 8.22386 11.5 8.5C11.5 8.77614 11.2761 9 11 9H6C5.72386 9 5.5 8.77614 5.5 8.5C5.5 8.22386 5.72386 8 6 8H11Z",
  fill: "currentColor"
}), h$1R("path", {
  d: "M14 8.5C14 5.46243 11.5376 3 8.5 3C5.46243 3 3 5.46243 3 8.5C3 11.5376 5.46243 14 8.5 14C9.83879 14 11.0659 13.5217 12.0196 12.7266L16.1464 16.8536L16.2157 16.9114C16.4106 17.0464 16.68 17.0271 16.8536 16.8536C17.0488 16.6583 17.0488 16.3417 16.8536 16.1464L12.7266 12.0196C13.5217 11.0659 14 9.83879 14 8.5ZM4 8.5C4 6.01472 6.01472 4 8.5 4C10.9853 4 13 6.01472 13 8.5C13 10.9853 10.9853 13 8.5 13C6.01472 13 4 10.9853 4 8.5Z",
  fill: "currentColor"
})));
const t$O = f$1z("zoomIn", h$1R("svg", {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("path", {
  d: "M11.5 8.5C11.5 8.22386 11.2761 8 11 8H9V6C9 5.72386 8.77614 5.5 8.5 5.5C8.22386 5.5 8 5.72386 8 6V8H6C5.72386 8 5.5 8.22386 5.5 8.5C5.5 8.77614 5.72386 9 6 9H8V11C8 11.2761 8.22386 11.5 8.5 11.5C8.77614 11.5 9 11.2761 9 11V9H11C11.2761 9 11.5 8.77614 11.5 8.5Z",
  fill: "currentColor"
}), h$1R("path", {
  d: "M8.5 3C11.5376 3 14 5.46243 14 8.5C14 9.83879 13.5217 11.0659 12.7266 12.0196L16.8536 16.1464C17.0488 16.3417 17.0488 16.6583 16.8536 16.8536C16.68 17.0271 16.4106 17.0464 16.2157 16.9114L16.1464 16.8536L12.0196 12.7266C11.0659 13.5217 9.83879 14 8.5 14C5.46243 14 3 11.5376 3 8.5C3 5.46243 5.46243 3 8.5 3ZM8.5 4C6.01472 4 4 6.01472 4 8.5C4 10.9853 6.01472 13 8.5 13C10.9853 13 13 10.9853 13 8.5C13 6.01472 10.9853 4 8.5 4Z",
  fill: "currentColor"
})));
var t$N = c$1a(function(e28, a3, o3) {
  return e28 + (o3 ? "-" : "") + a3.toLowerCase();
});
const s$17 = t$N;
const R$i = 32, mt$7 = defineComponent({
  name: "ImagePreview",
  props: Object.assign(Object.assign({}, r$Y), {
    onNext: Function,
    onPrev: Function,
    clsPrefix: {
      type: String,
      required: true
    }
  }),
  setup(a3) {
    const b3 = _$F("Image", "-image", l$11, n$L, a3, toRef$1(a3, "clsPrefix"));
    let r3 = null;
    const v3 = ref$1(null), s3 = ref$1(null), M3 = ref$1(void 0), I3 = ref$1(false), D3 = ref$1(false), {
      localeRef: G3
    } = R$p("Image");
    function J3() {
      const {
        value: e28
      } = s3;
      if (!r3 || !e28)
        return;
      const {
        style: o3
      } = e28, t3 = r3.getBoundingClientRect(), n3 = t3.left + t3.width / 2, l3 = t3.top + t3.height / 2;
      o3.transformOrigin = `${n3}px ${l3}px`;
    }
    function O3(e28) {
      var o3, t3;
      switch (e28.key) {
        case " ":
          e28.preventDefault();
          break;
        case "ArrowLeft":
          (o3 = a3.onPrev) === null || o3 === void 0 || o3.call(a3);
          break;
        case "ArrowRight":
          (t3 = a3.onNext) === null || t3 === void 0 || t3.call(a3);
          break;
        case "Escape":
          j3();
          break;
      }
    }
    watch(I3, (e28) => {
      e28 ? J$o("keydown", document, O3) : K$p("keydown", document, O3);
    }), onBeforeUnmount(() => {
      K$p("keydown", document, O3);
    });
    let _3 = 0, B3 = 0, g3 = 0, x3 = 0, z3 = 0, T3 = 0, N3 = 0, L3 = 0, H3 = false;
    function E3(e28) {
      const {
        clientX: o3,
        clientY: t3
      } = e28;
      g3 = o3 - _3, x3 = t3 - B3, s$1i(h3);
    }
    function Q3(e28) {
      const {
        mouseUpClientX: o3,
        mouseUpClientY: t3,
        mouseDownClientX: n3,
        mouseDownClientY: l3
      } = e28, f3 = n3 - o3, u3 = l3 - t3, m3 = `vertical${u3 > 0 ? "Top" : "Bottom"}`, p3 = `horizontal${f3 > 0 ? "Left" : "Right"}`;
      return {
        moveVerticalDirection: m3,
        moveHorizontalDirection: p3,
        deltaHorizontal: f3,
        deltaVertical: u3
      };
    }
    function V10(e28) {
      const {
        value: o3
      } = v3;
      if (!o3)
        return {
          offsetX: 0,
          offsetY: 0
        };
      const t3 = o3.getBoundingClientRect(), {
        moveVerticalDirection: n3,
        moveHorizontalDirection: l3,
        deltaHorizontal: f3,
        deltaVertical: u3
      } = e28 || {};
      let m3 = 0, p3 = 0;
      return t3.width <= window.innerWidth ? m3 = 0 : t3.left > 0 ? m3 = (t3.width - window.innerWidth) / 2 : t3.right < window.innerWidth ? m3 = -(t3.width - window.innerWidth) / 2 : l3 === "horizontalRight" ? m3 = Math.min((t3.width - window.innerWidth) / 2, z3 - (f3 != null ? f3 : 0)) : m3 = Math.max(-((t3.width - window.innerWidth) / 2), z3 - (f3 != null ? f3 : 0)), t3.height <= window.innerHeight ? p3 = 0 : t3.top > 0 ? p3 = (t3.height - window.innerHeight) / 2 : t3.bottom < window.innerHeight ? p3 = -(t3.height - window.innerHeight) / 2 : n3 === "verticalBottom" ? p3 = Math.min((t3.height - window.innerHeight) / 2, T3 - (u3 != null ? u3 : 0)) : p3 = Math.max(-((t3.height - window.innerHeight) / 2), T3 - (u3 != null ? u3 : 0)), {
        offsetX: m3,
        offsetY: p3
      };
    }
    function A3(e28) {
      K$p("mousemove", document, E3), K$p("mouseup", document, A3);
      const {
        clientX: o3,
        clientY: t3
      } = e28;
      H3 = false;
      const n3 = Q3({
        mouseUpClientX: o3,
        mouseUpClientY: t3,
        mouseDownClientX: N3,
        mouseDownClientY: L3
      }), l3 = V10(n3);
      g3 = l3.offsetX, x3 = l3.offsetY, h3();
    }
    const c3 = inject(i$Z, null);
    function ee2(e28) {
      var o3, t3;
      if ((t3 = (o3 = c3 == null ? void 0 : c3.previewedImgPropsRef.value) === null || o3 === void 0 ? void 0 : o3.onMousedown) === null || t3 === void 0 || t3.call(o3, e28), e28.button !== 0)
        return;
      const {
        clientX: n3,
        clientY: l3
      } = e28;
      H3 = true, _3 = n3 - g3, B3 = l3 - x3, z3 = g3, T3 = x3, N3 = n3, L3 = l3, h3(), J$o("mousemove", document, E3), J$o("mouseup", document, A3);
    }
    function te2(e28) {
      var o3, t3;
      (t3 = (o3 = c3 == null ? void 0 : c3.previewedImgPropsRef.value) === null || o3 === void 0 ? void 0 : o3.onDblclick) === null || t3 === void 0 || t3.call(o3, e28);
      const n3 = U3();
      d3 = d3 === n3 ? 1 : n3, h3();
    }
    const W3 = 1.5;
    let C3 = 0, d3 = 1, S3 = 0;
    function X3() {
      d3 = 1, C3 = 0;
    }
    function oe2() {
      var e28;
      X3(), S3 = 0, (e28 = a3.onPrev) === null || e28 === void 0 || e28.call(a3);
    }
    function ie2() {
      var e28;
      X3(), S3 = 0, (e28 = a3.onNext) === null || e28 === void 0 || e28.call(a3);
    }
    function ne2() {
      S3 -= 90, h3();
    }
    function le2() {
      S3 += 90, h3();
    }
    function re2() {
      const {
        value: e28
      } = v3;
      if (!e28)
        return 1;
      const {
        innerWidth: o3,
        innerHeight: t3
      } = window, n3 = Math.max(1, e28.naturalHeight / (t3 - R$i)), l3 = Math.max(1, e28.naturalWidth / (o3 - R$i));
      return Math.max(3, n3 * 2, l3 * 2);
    }
    function U3() {
      const {
        value: e28
      } = v3;
      if (!e28)
        return 1;
      const {
        innerWidth: o3,
        innerHeight: t3
      } = window, n3 = e28.naturalHeight / (t3 - R$i), l3 = e28.naturalWidth / (o3 - R$i);
      return n3 < 1 && l3 < 1 ? 1 : Math.max(n3, l3);
    }
    function ae2() {
      const e28 = re2();
      d3 < e28 && (C3 += 1, d3 = Math.min(e28, Math.pow(W3, C3)), h3());
    }
    function se2() {
      if (d3 > 0.5) {
        const e28 = d3;
        C3 -= 1, d3 = Math.max(0.5, Math.pow(W3, C3));
        const o3 = e28 - d3;
        h3(false);
        const t3 = V10();
        d3 += o3, h3(false), d3 -= o3, g3 = t3.offsetX, x3 = t3.offsetY, h3();
      }
    }
    function ce2() {
      const e28 = M3.value;
      e28 && n$V(e28, void 0);
    }
    function h3(e28 = true) {
      var o3;
      const {
        value: t3
      } = v3;
      if (!t3)
        return;
      const {
        style: n3
      } = t3, l3 = normalizeStyle((o3 = c3 == null ? void 0 : c3.previewedImgPropsRef.value) === null || o3 === void 0 ? void 0 : o3.style);
      let f3 = "";
      if (typeof l3 == "string")
        f3 = l3 + ";";
      else
        for (const m3 in l3)
          f3 += `${s$17(m3)}: ${l3[m3]};`;
      const u3 = `transform-origin: center; transform: translateX(${g3}px) translateY(${x3}px) rotate(${S3}deg) scale(${d3});`;
      H3 ? n3.cssText = f3 + "cursor: grabbing; transition: none;" + u3 : n3.cssText = f3 + "cursor: grab;" + u3 + (e28 ? "" : "transition: none;"), e28 || t3.offsetHeight;
    }
    function j3() {
      I3.value = !I3.value, D3.value = true;
    }
    function de2() {
      d3 = U3(), C3 = Math.ceil(Math.log(d3) / Math.log(W3)), g3 = 0, x3 = 0, h3();
    }
    const fe2 = {
      setPreviewSrc: (e28) => {
        M3.value = e28;
      },
      setThumbnailEl: (e28) => {
        r3 = e28;
      },
      toggleShow: j3
    };
    function ue2(e28, o3) {
      if (a3.showToolbarTooltip) {
        const {
          value: t3
        } = b3;
        return h$1R(b$10, {
          to: false,
          theme: t3.peers.Tooltip,
          themeOverrides: t3.peerOverrides.Tooltip,
          keepAliveOnHover: false
        }, {
          default: () => G3.value[o3],
          trigger: () => e28
        });
      } else
        return e28;
    }
    const F3 = computed(() => {
      const {
        common: {
          cubicBezierEaseInOut: e28
        },
        self: {
          toolbarIconColor: o3,
          toolbarBorderRadius: t3,
          toolbarBoxShadow: n3,
          toolbarColor: l3
        }
      } = b3.value;
      return {
        "--n-bezier": e28,
        "--n-toolbar-icon-color": o3,
        "--n-toolbar-color": l3,
        "--n-toolbar-border-radius": t3,
        "--n-toolbar-box-shadow": n3
      };
    }), {
      inlineThemeDisabled: Z3
    } = a$2x(), k3 = Z3 ? E$J("image-preview", void 0, F3, a3) : void 0;
    return Object.assign({
      previewRef: v3,
      previewWrapperRef: s3,
      previewSrc: M3,
      show: I3,
      appear: u$1C(),
      displayed: D3,
      previewedImgProps: c3 == null ? void 0 : c3.previewedImgPropsRef,
      handleWheel(e28) {
        e28.preventDefault();
      },
      handlePreviewMousedown: ee2,
      handlePreviewDblclick: te2,
      syncTransformOrigin: J3,
      handleAfterLeave: () => {
        X3(), S3 = 0, D3.value = false;
      },
      handleDragStart: (e28) => {
        var o3, t3;
        (t3 = (o3 = c3 == null ? void 0 : c3.previewedImgPropsRef.value) === null || o3 === void 0 ? void 0 : o3.onDragstart) === null || t3 === void 0 || t3.call(o3, e28), e28.preventDefault();
      },
      zoomIn: ae2,
      zoomOut: se2,
      handleDownloadClick: ce2,
      rotateCounterclockwise: ne2,
      rotateClockwise: le2,
      handleSwitchPrev: oe2,
      handleSwitchNext: ie2,
      withTooltip: ue2,
      resizeToOrignalImageSize: de2,
      cssVars: Z3 ? void 0 : F3,
      themeClass: k3 == null ? void 0 : k3.themeClass,
      onRender: k3 == null ? void 0 : k3.onRender
    }, fe2);
  },
  render() {
    var a3, b3;
    const {
      clsPrefix: r3
    } = this;
    return h$1R(Fragment, null, (b3 = (a3 = this.$slots).default) === null || b3 === void 0 ? void 0 : b3.call(a3), h$1R(h$1D, {
      show: this.show
    }, {
      default: () => {
        var v3;
        return this.show || this.displayed ? ((v3 = this.onRender) === null || v3 === void 0 || v3.call(this), withDirectives(h$1R("div", {
          class: [`${r3}-image-preview-container`, this.themeClass],
          style: this.cssVars,
          onWheel: this.handleWheel
        }, h$1R(Transition, {
          name: "fade-in-transition",
          appear: this.appear
        }, {
          default: () => this.show ? h$1R("div", {
            class: `${r3}-image-preview-overlay`,
            onClick: this.toggleShow
          }) : null
        }), this.showToolbar ? h$1R(Transition, {
          name: "fade-in-transition",
          appear: this.appear
        }, {
          default: () => {
            if (!this.show)
              return null;
            const {
              withTooltip: s3
            } = this;
            return h$1R("div", {
              class: `${r3}-image-preview-toolbar`
            }, this.onPrev ? h$1R(Fragment, null, s3(h$1R(d$1R, {
              clsPrefix: r3,
              onClick: this.handleSwitchPrev
            }, {
              default: () => t$P
            }), "tipPrevious"), s3(h$1R(d$1R, {
              clsPrefix: r3,
              onClick: this.handleSwitchNext
            }, {
              default: () => n$M
            }), "tipNext")) : null, s3(h$1R(d$1R, {
              clsPrefix: r3,
              onClick: this.rotateCounterclockwise
            }, {
              default: () => h$1R(e$_, null)
            }), "tipCounterclockwise"), s3(h$1R(d$1R, {
              clsPrefix: r3,
              onClick: this.rotateClockwise
            }, {
              default: () => h$1R(r$X, null)
            }), "tipClockwise"), s3(h$1R(d$1R, {
              clsPrefix: r3,
              onClick: this.resizeToOrignalImageSize
            }, {
              default: () => h$1R(h$$, null)
            }), "tipOriginalSize"), s3(h$1R(d$1R, {
              clsPrefix: r3,
              onClick: this.zoomOut
            }, {
              default: () => h$1R(l$10, null)
            }), "tipZoomOut"), s3(h$1R(d$1R, {
              clsPrefix: r3,
              onClick: this.zoomIn
            }, {
              default: () => h$1R(t$O, null)
            }), "tipZoomIn"), s3(h$1R(d$1R, {
              clsPrefix: r3,
              onClick: this.handleDownloadClick
            }, {
              default: () => L$u
            }), "tipDownload"), s3(h$1R(d$1R, {
              clsPrefix: r3,
              onClick: this.toggleShow
            }, {
              default: () => c$19
            }), "tipClose"));
          }
        }) : null, h$1R(Transition, {
          name: "fade-in-scale-up-transition",
          onAfterLeave: this.handleAfterLeave,
          appear: this.appear,
          onEnter: this.syncTransformOrigin,
          onBeforeLeave: this.syncTransformOrigin
        }, {
          default: () => {
            const {
              previewedImgProps: s3 = {}
            } = this;
            return withDirectives(h$1R("div", {
              class: `${r3}-image-preview-wrapper`,
              ref: "previewWrapperRef"
            }, h$1R("img", Object.assign({}, s3, {
              draggable: false,
              onMousedown: this.handlePreviewMousedown,
              onDblclick: this.handlePreviewDblclick,
              class: [`${r3}-image-preview`, s3.class],
              key: this.previewSrc,
              src: this.previewSrc,
              ref: "previewRef",
              onDragstart: this.handleDragStart
            }))), [[vShow, this.show]]);
          }
        })), [[r$1O, {
          enabled: this.show
        }]])) : null;
      }
    }));
  }
});
const b$F = n$28("n-image-group"), y$E = r$Y, j$h = defineComponent({
  name: "ImageGroup",
  props: y$E,
  setup(t3) {
    let s3;
    const {
      mergedClsPrefixRef: v3
    } = a$2x(t3), m3 = `c${i$1Y()}`, i = getCurrentInstance(), l3 = (e28) => {
      var r3;
      s3 = e28, (r3 = n3.value) === null || r3 === void 0 || r3.setPreviewSrc(e28);
    };
    function d3(e28) {
      var r3, a3;
      if (!(i != null && i.proxy))
        return;
      const o3 = i.proxy.$el.parentElement.querySelectorAll(`[data-group-id=${m3}]:not([data-error=true])`);
      if (!o3.length)
        return;
      const u3 = Array.from(o3).findIndex((c3) => c3.dataset.previewSrc === s3);
      ~u3 ? l3(o3[(u3 + e28 + o3.length) % o3.length].dataset.previewSrc) : l3(o3[0].dataset.previewSrc), e28 === 1 ? (r3 = t3.onPreviewNext) === null || r3 === void 0 || r3.call(t3) : (a3 = t3.onPreviewPrev) === null || a3 === void 0 || a3.call(t3);
    }
    provide(b$F, {
      mergedClsPrefixRef: v3,
      setPreviewSrc: l3,
      setThumbnailEl: (e28) => {
        var r3;
        (r3 = n3.value) === null || r3 === void 0 || r3.setThumbnailEl(e28);
      },
      toggleShow: () => {
        var e28;
        (e28 = n3.value) === null || e28 === void 0 || e28.toggleShow();
      },
      groupId: m3
    });
    const n3 = ref$1(null);
    return {
      mergedClsPrefix: v3,
      previewInstRef: n3,
      next: () => {
        d3(1);
      },
      prev: () => {
        d3(-1);
      }
    };
  },
  render() {
    return h$1R(mt$7, {
      theme: this.theme,
      themeOverrides: this.themeOverrides,
      clsPrefix: this.mergedClsPrefix,
      ref: "previewInstRef",
      onPrev: this.prev,
      onNext: this.next,
      showToolbar: this.showToolbar,
      showToolbarTooltip: this.showToolbarTooltip
    }, this.$slots);
  }
});
const C$J = Object.assign({
  alt: String,
  height: [String, Number],
  imgProps: Object,
  previewedImgProps: Object,
  lazy: Boolean,
  intersectionObserverOptions: Object,
  objectFit: {
    type: String,
    default: "fill"
  },
  previewSrc: String,
  fallbackSrc: String,
  width: [String, Number],
  src: String,
  previewDisabled: Boolean,
  loadDescription: String,
  onError: Function,
  onLoad: Function
}, r$Y), F$m = defineComponent({
  name: "Image",
  props: C$J,
  inheritAttrs: false,
  setup(r3) {
    const n3 = ref$1(null), l3 = ref$1(false), s3 = ref$1(null), o3 = inject(b$F, null), {
      mergedClsPrefixRef: h3
    } = o3 || a$2x(r3), d3 = {
      click: () => {
        if (r3.previewDisabled || l3.value)
          return;
        const e28 = r3.previewSrc || r3.src;
        if (o3) {
          o3.setPreviewSrc(e28), o3.setThumbnailEl(n3.value), o3.toggleShow();
          return;
        }
        const {
          value: i
        } = s3;
        i && (i.setPreviewSrc(e28), i.setThumbnailEl(n3.value), i.toggleShow());
      }
    }, a3 = ref$1(!r3.lazy);
    onMounted(() => {
      var e28;
      (e28 = n3.value) === null || e28 === void 0 || e28.setAttribute("data-group-id", (o3 == null ? void 0 : o3.groupId) || "");
    }), onMounted(() => {
      if (r3.lazy && r3.intersectionObserverOptions) {
        let e28;
        const i = watchEffect(() => {
          e28 == null || e28(), e28 = void 0, e28 = M$q(n3.value, r3.intersectionObserverOptions, a3);
        });
        onBeforeUnmount(() => {
          i(), e28 == null || e28();
        });
      }
    }), watchEffect(() => {
      var e28;
      r3.src || ((e28 = r3.imgProps) === null || e28 === void 0 || e28.src), l3.value = false;
    });
    const c3 = ref$1(false);
    return provide(i$Z, {
      previewedImgPropsRef: toRef$1(r3, "previewedImgProps")
    }), Object.assign({
      mergedClsPrefix: h3,
      groupId: o3 == null ? void 0 : o3.groupId,
      previewInstRef: s3,
      imageRef: n3,
      showError: l3,
      shouldStartLoading: a3,
      loaded: c3,
      mergedOnClick: (e28) => {
        var i, t3;
        d3.click(), (t3 = (i = r3.imgProps) === null || i === void 0 ? void 0 : i.onClick) === null || t3 === void 0 || t3.call(i, e28);
      },
      mergedOnError: (e28) => {
        if (!a3.value)
          return;
        l3.value = true;
        const {
          onError: i,
          imgProps: {
            onError: t3
          } = {}
        } = r3;
        i == null || i(e28), t3 == null || t3(e28);
      },
      mergedOnLoad: (e28) => {
        const {
          onLoad: i,
          imgProps: {
            onLoad: t3
          } = {}
        } = r3;
        i == null || i(e28), t3 == null || t3(e28), c3.value = true;
      }
    }, d3);
  },
  render() {
    var r3, n3;
    const {
      mergedClsPrefix: l3,
      imgProps: s3 = {},
      loaded: o3,
      $attrs: h3,
      lazy: d3
    } = this, a3 = (n3 = (r3 = this.$slots).placeholder) === null || n3 === void 0 ? void 0 : n3.call(r3), c3 = this.src || s3.src, e28 = h$1R("img", Object.assign(Object.assign({}, s3), {
      ref: "imageRef",
      width: this.width || s3.width,
      height: this.height || s3.height,
      src: this.showError ? this.fallbackSrc : d3 && this.intersectionObserverOptions ? this.shouldStartLoading ? c3 : void 0 : c3,
      alt: this.alt || s3.alt,
      "aria-label": this.alt || s3.alt,
      onClick: this.mergedOnClick,
      onError: this.mergedOnError,
      onLoad: this.mergedOnLoad,
      loading: t$1d && d3 && !this.intersectionObserverOptions ? "lazy" : "eager",
      style: [s3.style || "", a3 && !o3 ? {
        height: "0",
        width: "0",
        visibility: "hidden"
      } : "", {
        objectFit: this.objectFit
      }],
      "data-error": this.showError,
      "data-preview-src": this.previewSrc || this.src
    }));
    return h$1R("div", Object.assign({}, h3, {
      role: "none",
      class: [h3.class, `${l3}-image`, (this.previewDisabled || this.showError) && `${l3}-image--preview-disabled`]
    }), this.groupId ? e28 : h$1R(mt$7, {
      theme: this.theme,
      themeOverrides: this.themeOverrides,
      clsPrefix: l3,
      ref: "previewInstRef",
      showToolbar: this.showToolbar,
      showToolbarTooltip: this.showToolbarTooltip
    }, {
      default: () => e28
    }), !o3 && a3);
  }
});
const w$s = ["id"], y$D = { class: "hl-image-checkbox__wrapper" }, B$t = defineComponent({
  __name: "CheckboxImage",
  props: {
    id: {
      type: String,
      required: true
    },
    src: {
      type: String,
      default: ""
    },
    fallbackSrc: {
      type: String,
      default: ""
    },
    checked: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["onSelect"],
  setup(c3, { emit: i }) {
    const l3 = c3, e28 = ref$1(l3.checked || false), d3 = i, r3 = () => {
      e28.value ? d3("onSelect", { url: l3.src }) : d3("onSelect", { url: null });
    }, n3 = (a3, s3) => {
      if (l3.disabled)
        return false;
      s3.stopPropagation(), e28.value = a3, r3();
    }, m3 = () => {
      if (l3.disabled)
        return false;
      e28.value = !e28.value, r3();
    };
    return watch(() => l3.checked, (a3) => {
      e28.value = a3;
    }), (a3, s3) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["hl-image-checkbox", [e28.value ? "image-checked" : null, c3.disabled ? "disabled" : null]]),
      onClick: m3,
      id: c3.id
    }, [
      createVNode(unref(F$m), {
        "preview-disabled": "",
        width: "112",
        src: c3.src,
        "fallback-src": c3.fallbackSrc
      }, {
        placeholder: withCtx(() => [
          createVNode(unref(a$16), { class: "fallback-icon" })
        ]),
        _: 1
      }, 8, ["src", "fallback-src"]),
      createElementVNode("div", y$D, [
        createVNode(unref(Pe$a), {
          size: "small",
          checked: e28.value,
          disabled: c3.disabled,
          "onUpdate:checked": n3
        }, null, 8, ["checked", "disabled"])
      ])
    ], 10, w$s));
  }
}), V$m = B$t;
const u$11 = defineComponent({
  name: "UICheckbox",
  inheritAttrs: false
}), b$E = defineComponent(__spreadProps(__spreadValues({}, u$11), {
  props: {
    disabled: {
      type: Boolean,
      default: void 0
    },
    checked: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "default"
    },
    src: {
      type: String,
      default: ""
    },
    fallbackSrc: {
      type: String,
      default: ""
    }
  },
  emits: ["update:checked", "onSelect"],
  setup(e28) {
    return (t3, d3) => e28.type === "image" ? (openBlock(), createBlock(V$m, {
      key: 0,
      id: e28.id,
      src: e28.src,
      fallbackSrc: e28.fallbackSrc,
      checked: e28.checked,
      disabled: e28.disabled,
      onOnSelect: d3[0] || (d3[0] = (l3) => t3.$emit("onSelect", l3))
    }, null, 8, ["id", "src", "fallbackSrc", "checked", "disabled"])) : (openBlock(), createBlock(unref(Pe$a), mergeProps({
      key: 1,
      id: e28.id,
      disabled: e28.disabled
    }, t3.$attrs, {
      checked: e28.checked,
      size: "large",
      "onUpdate:checked": d3[1] || (d3[1] = (l3) => t3.$emit("update:checked", l3))
    }), {
      default: withCtx(() => [
        renderSlot(t3.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "disabled", "checked"]));
  }
})), y$C = b$E;
const i$Y = defineComponent({
  name: "UICheckboxGroup",
  inheritAttrs: false
}), p$2U = defineComponent(__spreadProps(__spreadValues({}, i$Y), {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, null]
    },
    defaultValue: {
      type: [Array, null]
    }
  },
  emits: ["update:value"],
  setup(e28) {
    return (a3, l3) => (openBlock(), createBlock(unref(b$L), {
      disabled: e28.disabled,
      "default-value": e28.defaultValue,
      value: e28.value,
      "onUpdate:value": l3[0] || (l3[0] = (u3) => a3.$emit("update:value", u3))
    }, {
      default: withCtx(() => [
        renderSlot(a3.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "default-value", "value"]));
  }
})), b$D = p$2U;
const V$l = { class: "hl-checkbox-group-item-container" }, E$q = {
  key: 0,
  class: "hl-checkbox-group-item-icon"
}, L$t = {
  key: 1,
  class: "hl-checkbox-group-item-content"
}, P$G = { class: "hl-checkbox-group-item-action" }, U$o = defineComponent({
  name: "UICheckboxItem",
  inheritAttrs: false
}), w$r = defineComponent(__spreadProps(__spreadValues({}, U$o), {
  props: {
    disabled: {
      type: Boolean,
      default: void 0
    },
    value: {
      type: [String, Number]
    }
  },
  emits: ["update:checked"],
  setup(i, { emit: p3 }) {
    const v3 = i, o3 = ref$1(), r3 = useSlots(), t3 = ref$1(false), s3 = ref$1(v3.disabled), f3 = p3, x3 = () => {
      var e28;
      return (e28 = o3.value) == null ? void 0 : e28.$el.classList.contains("n-checkbox--checked");
    }, _3 = () => {
      var e28;
      return (e28 = o3.value) == null ? void 0 : e28.$el.classList.contains("n-checkbox--disabled");
    }, d3 = (e28) => {
      var l3;
      if (e28.stopPropagation(), _3()) {
        s3.value = true;
        return;
      }
      (l3 = o3.value) == null || l3.handleClick(), t3.value = !t3.value, f3("update:checked", t3.value);
    };
    return onMounted(() => {
      t3.value = x3();
    }), (e28, l3) => (openBlock(), createBlock(unref(le$g), {
      disabled: s3.value,
      size: "large",
      class: normalizeClass(["hl-checkbox-group-item", t3.value ? "active" : ""]),
      bordered: false,
      onClick: d3
    }, {
      default: withCtx(() => [
        createElementVNode("div", V$l, [
          unref(r3).icon ? (openBlock(), createElementBlock("div", E$q, [
            renderSlot(e28.$slots, "icon")
          ])) : createCommentVNode("", true),
          unref(r3).content ? (openBlock(), createElementBlock("div", L$t, [
            renderSlot(e28.$slots, "content")
          ])) : createCommentVNode("", true),
          createElementVNode("div", P$G, [
            createVNode(unref(Pe$a), mergeProps({
              ref_key: "checkBox",
              ref: o3,
              disabled: s3.value
            }, e28.$attrs, {
              size: "large",
              value: i.value,
              checked: t3.value,
              onClick: d3
            }), null, 16, ["disabled", "value", "checked"])
          ])
        ])
      ]),
      _: 3
    }, 8, ["disabled", "class"]));
  }
})), q$l = w$r;
class x$l {
  lineAt(e28) {
    if (e28 < 0 || e28 > this.length)
      throw new RangeError(`Invalid position ${e28} in document of length ${this.length}`);
    return this.lineInner(e28, false, 1, 0);
  }
  line(e28) {
    if (e28 < 1 || e28 > this.lines)
      throw new RangeError(`Invalid line number ${e28} in ${this.lines}-line document`);
    return this.lineInner(e28, true, 1, 0);
  }
  replace(e28, t3, n3) {
    let i = [];
    return this.decompose(0, e28, i, 2), n3.length && n3.decompose(0, n3.length, i, 3), this.decompose(t3, this.length, i, 1), O$o.from(i, this.length - (t3 - e28) + n3.length);
  }
  append(e28) {
    return this.replace(this.length, this.length, e28);
  }
  slice(e28, t3 = this.length) {
    let n3 = [];
    return this.decompose(e28, t3, n3, 0), O$o.from(n3, t3 - e28);
  }
  eq(e28) {
    if (e28 == this)
      return true;
    if (e28.length != this.length || e28.lines != this.lines)
      return false;
    let t3 = this.scanIdentical(e28, 1), n3 = this.length - this.scanIdentical(e28, -1), i = new D$x(this), s3 = new D$x(e28);
    for (let r3 = t3, h3 = t3; ; ) {
      if (i.next(r3), s3.next(r3), r3 = 0, i.lineBreak != s3.lineBreak || i.done != s3.done || i.value != s3.value)
        return false;
      if (h3 += i.value.length, i.done || h3 >= n3)
        return true;
    }
  }
  iter(e28 = 1) {
    return new D$x(this, e28);
  }
  iterRange(e28, t3 = this.length) {
    return new Pe$9(this, e28, t3);
  }
  iterLines(e28, t3) {
    let n3;
    if (e28 == null)
      n3 = this.iter();
    else {
      t3 == null && (t3 = this.lines + 1);
      let i = this.line(e28).from;
      n3 = this.iterRange(i, Math.max(i, t3 == this.lines + 1 ? this.length : t3 <= 1 ? 0 : this.line(t3 - 1).to));
    }
    return new be$b(n3);
  }
  toString() {
    return this.sliceString(0);
  }
  toJSON() {
    let e28 = [];
    return this.flatten(e28), e28;
  }
  constructor() {
  }
  static of(e28) {
    if (e28.length == 0)
      throw new RangeError("A document must have at least one line");
    return e28.length == 1 && !e28[0] ? x$l.empty : e28.length <= 32 ? new m$1i(e28) : O$o.from(m$1i.split(e28, []));
  }
}
class m$1i extends x$l {
  constructor(e28, t3 = We$7(e28)) {
    super(), this.text = e28, this.length = t3;
  }
  get lines() {
    return this.text.length;
  }
  get children() {
    return null;
  }
  lineInner(e28, t3, n3, i) {
    for (let s3 = 0; ; s3++) {
      let r3 = this.text[s3], h3 = i + r3.length;
      if ((t3 ? n3 : h3) >= e28)
        return new Ue$5(i, h3, n3, r3);
      i = h3 + 1, n3++;
    }
  }
  decompose(e28, t3, n3, i) {
    let s3 = e28 <= 0 && t3 >= this.length ? this : new m$1i(me$d(this.text, e28, t3), Math.min(t3, this.length) - Math.max(0, e28));
    if (i & 1) {
      let r3 = n3.pop(), h3 = j$g(s3.text, r3.text.slice(), 0, s3.length);
      if (h3.length <= 32)
        n3.push(new m$1i(h3, r3.length + s3.length));
      else {
        let o3 = h3.length >> 1;
        n3.push(new m$1i(h3.slice(0, o3)), new m$1i(h3.slice(o3)));
      }
    } else
      n3.push(s3);
  }
  replace(e28, t3, n3) {
    if (!(n3 instanceof m$1i))
      return super.replace(e28, t3, n3);
    let i = j$g(this.text, j$g(n3.text, me$d(this.text, 0, e28)), t3), s3 = this.length + n3.length - (t3 - e28);
    return i.length <= 32 ? new m$1i(i, s3) : O$o.from(m$1i.split(i, []), s3);
  }
  sliceString(e28, t3 = this.length, n3 = `
`) {
    let i = "";
    for (let s3 = 0, r3 = 0; s3 <= t3 && r3 < this.text.length; r3++) {
      let h3 = this.text[r3], o3 = s3 + h3.length;
      s3 > e28 && r3 && (i += n3), e28 < o3 && t3 > s3 && (i += h3.slice(Math.max(0, e28 - s3), t3 - s3)), s3 = o3 + 1;
    }
    return i;
  }
  flatten(e28) {
    for (let t3 of this.text)
      e28.push(t3);
  }
  scanIdentical() {
    return 0;
  }
  static split(e28, t3) {
    let n3 = [], i = -1;
    for (let s3 of e28)
      n3.push(s3), i += s3.length + 1, n3.length == 32 && (t3.push(new m$1i(n3, i)), n3 = [], i = -1);
    return i > -1 && t3.push(new m$1i(n3, i)), t3;
  }
}
class O$o extends x$l {
  constructor(e28, t3) {
    super(), this.children = e28, this.length = t3, this.lines = 0;
    for (let n3 of e28)
      this.lines += n3.lines;
  }
  lineInner(e28, t3, n3, i) {
    for (let s3 = 0; ; s3++) {
      let r3 = this.children[s3], h3 = i + r3.length, o3 = n3 + r3.lines - 1;
      if ((t3 ? o3 : h3) >= e28)
        return r3.lineInner(e28, t3, n3, i);
      i = h3 + 1, n3 = o3 + 1;
    }
  }
  decompose(e28, t3, n3, i) {
    for (let s3 = 0, r3 = 0; r3 <= t3 && s3 < this.children.length; s3++) {
      let h3 = this.children[s3], o3 = r3 + h3.length;
      if (e28 <= o3 && t3 >= r3) {
        let a3 = i & ((r3 <= e28 ? 1 : 0) | (o3 >= t3 ? 2 : 0));
        r3 >= e28 && o3 <= t3 && !a3 ? n3.push(h3) : h3.decompose(e28 - r3, t3 - r3, n3, a3);
      }
      r3 = o3 + 1;
    }
  }
  replace(e28, t3, n3) {
    if (n3.lines < this.lines)
      for (let i = 0, s3 = 0; i < this.children.length; i++) {
        let r3 = this.children[i], h3 = s3 + r3.length;
        if (e28 >= s3 && t3 <= h3) {
          let o3 = r3.replace(e28 - s3, t3 - s3, n3), a3 = this.lines - r3.lines + o3.lines;
          if (o3.lines < a3 >> 5 - 1 && o3.lines > a3 >> 5 + 1) {
            let f3 = this.children.slice();
            return f3[i] = o3, new O$o(f3, this.length - (t3 - e28) + n3.length);
          }
          return super.replace(s3, h3, o3);
        }
        s3 = h3 + 1;
      }
    return super.replace(e28, t3, n3);
  }
  sliceString(e28, t3 = this.length, n3 = `
`) {
    let i = "";
    for (let s3 = 0, r3 = 0; s3 < this.children.length && r3 <= t3; s3++) {
      let h3 = this.children[s3], o3 = r3 + h3.length;
      r3 > e28 && s3 && (i += n3), e28 < o3 && t3 > r3 && (i += h3.sliceString(e28 - r3, t3 - r3, n3)), r3 = o3 + 1;
    }
    return i;
  }
  flatten(e28) {
    for (let t3 of this.children)
      t3.flatten(e28);
  }
  scanIdentical(e28, t3) {
    if (!(e28 instanceof O$o))
      return 0;
    let n3 = 0, [i, s3, r3, h3] = t3 > 0 ? [0, 0, this.children.length, e28.children.length] : [this.children.length - 1, e28.children.length - 1, -1, -1];
    for (; ; i += t3, s3 += t3) {
      if (i == r3 || s3 == h3)
        return n3;
      let o3 = this.children[i], a3 = e28.children[s3];
      if (o3 != a3)
        return n3 + o3.scanIdentical(a3, t3);
      n3 += o3.length + 1;
    }
  }
  static from(e28, t3 = e28.reduce((n3, i) => n3 + i.length + 1, -1)) {
    let n3 = 0;
    for (let c3 of e28)
      n3 += c3.lines;
    if (n3 < 32) {
      let c3 = [];
      for (let p3 of e28)
        p3.flatten(c3);
      return new m$1i(c3, t3);
    }
    let i = Math.max(32, n3 >> 5), s3 = i << 1, r3 = i >> 1, h3 = [], o3 = 0, a3 = -1, f3 = [];
    function u3(c3) {
      let p3;
      if (c3.lines > s3 && c3 instanceof O$o)
        for (let b3 of c3.children)
          u3(b3);
      else
        c3.lines > r3 && (o3 > r3 || !o3) ? (d3(), h3.push(c3)) : c3 instanceof m$1i && o3 && (p3 = f3[f3.length - 1]) instanceof m$1i && c3.lines + p3.lines <= 32 ? (o3 += c3.lines, a3 += c3.length + 1, f3[f3.length - 1] = new m$1i(p3.text.concat(c3.text), p3.length + 1 + c3.length)) : (o3 + c3.lines > i && d3(), o3 += c3.lines, a3 += c3.length + 1, f3.push(c3));
    }
    function d3() {
      o3 != 0 && (h3.push(f3.length == 1 ? f3[0] : O$o.from(f3, a3)), a3 = -1, o3 = f3.length = 0);
    }
    for (let c3 of e28)
      u3(c3);
    return d3(), h3.length == 1 ? h3[0] : new O$o(h3, t3);
  }
}
x$l.empty = /* @__PURE__ */ new m$1i([""], 0);
function We$7(l3) {
  let e28 = -1;
  for (let t3 of l3)
    e28 += t3.length + 1;
  return e28;
}
function j$g(l3, e28, t3 = 0, n3 = 1e9) {
  for (let i = 0, s3 = 0, r3 = true; s3 < l3.length && i <= n3; s3++) {
    let h3 = l3[s3], o3 = i + h3.length;
    o3 >= t3 && (o3 > n3 && (h3 = h3.slice(0, n3 - i)), i < t3 && (h3 = h3.slice(t3 - i)), r3 ? (e28[e28.length - 1] += h3, r3 = false) : e28.push(h3)), i = o3 + 1;
  }
  return e28;
}
function me$d(l3, e28, t3) {
  return j$g(l3, [""], e28, t3);
}
class D$x {
  constructor(e28, t3 = 1) {
    this.dir = t3, this.done = false, this.lineBreak = false, this.value = "", this.nodes = [e28], this.offsets = [t3 > 0 ? 1 : (e28 instanceof m$1i ? e28.text.length : e28.children.length) << 1];
  }
  nextInner(e28, t3) {
    for (this.done = this.lineBreak = false; ; ) {
      let n3 = this.nodes.length - 1, i = this.nodes[n3], s3 = this.offsets[n3], r3 = s3 >> 1, h3 = i instanceof m$1i ? i.text.length : i.children.length;
      if (r3 == (t3 > 0 ? h3 : 0)) {
        if (n3 == 0)
          return this.done = true, this.value = "", this;
        t3 > 0 && this.offsets[n3 - 1]++, this.nodes.pop(), this.offsets.pop();
      } else if ((s3 & 1) == (t3 > 0 ? 0 : 1)) {
        if (this.offsets[n3] += t3, e28 == 0)
          return this.lineBreak = true, this.value = `
`, this;
        e28--;
      } else if (i instanceof m$1i) {
        let o3 = i.text[r3 + (t3 < 0 ? -1 : 0)];
        if (this.offsets[n3] += t3, o3.length > Math.max(0, e28))
          return this.value = e28 == 0 ? o3 : t3 > 0 ? o3.slice(e28) : o3.slice(0, o3.length - e28), this;
        e28 -= o3.length;
      } else {
        let o3 = i.children[r3 + (t3 < 0 ? -1 : 0)];
        e28 > o3.length ? (e28 -= o3.length, this.offsets[n3] += t3) : (t3 < 0 && this.offsets[n3]--, this.nodes.push(o3), this.offsets.push(t3 > 0 ? 1 : (o3 instanceof m$1i ? o3.text.length : o3.children.length) << 1));
      }
    }
  }
  next(e28 = 0) {
    return e28 < 0 && (this.nextInner(-e28, -this.dir), e28 = this.value.length), this.nextInner(e28, this.dir);
  }
}
class Pe$9 {
  constructor(e28, t3, n3) {
    this.value = "", this.done = false, this.cursor = new D$x(e28, t3 > n3 ? -1 : 1), this.pos = t3 > n3 ? e28.length : 0, this.from = Math.min(t3, n3), this.to = Math.max(t3, n3);
  }
  nextInner(e28, t3) {
    if (t3 < 0 ? this.pos <= this.from : this.pos >= this.to)
      return this.value = "", this.done = true, this;
    e28 += Math.max(0, t3 < 0 ? this.pos - this.to : this.from - this.pos);
    let n3 = t3 < 0 ? this.pos - this.from : this.to - this.pos;
    e28 > n3 && (e28 = n3), n3 -= e28;
    let { value: i } = this.cursor.next(e28);
    return this.pos += (i.length + e28) * t3, this.value = i.length <= n3 ? i : t3 < 0 ? i.slice(i.length - n3) : i.slice(0, n3), this.done = !this.value, this;
  }
  next(e28 = 0) {
    return e28 < 0 ? e28 = Math.max(e28, this.from - this.pos) : e28 > 0 && (e28 = Math.min(e28, this.to - this.pos)), this.nextInner(e28, this.cursor.dir);
  }
  get lineBreak() {
    return this.cursor.lineBreak && this.value != "";
  }
}
class be$b {
  constructor(e28) {
    this.inner = e28, this.afterBreak = true, this.value = "", this.done = false;
  }
  next(e28 = 0) {
    let { done: t3, lineBreak: n3, value: i } = this.inner.next(e28);
    return t3 ? (this.done = true, this.value = "") : n3 ? this.afterBreak ? this.value = "" : (this.afterBreak = true, this.next()) : (this.value = i, this.afterBreak = false), this;
  }
  get lineBreak() {
    return false;
  }
}
typeof Symbol < "u" && (x$l.prototype[Symbol.iterator] = function() {
  return this.iter();
}, D$x.prototype[Symbol.iterator] = Pe$9.prototype[Symbol.iterator] = be$b.prototype[Symbol.iterator] = function() {
  return this;
});
class Ue$5 {
  constructor(e28, t3, n3, i) {
    this.from = e28, this.to = t3, this.number = n3, this.text = i;
  }
  get length() {
    return this.to - this.from;
  }
}
let F$l = /* @__PURE__ */ "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((l3) => l3 ? parseInt(l3, 36) : 1);
for (let l3 = 1; l3 < F$l.length; l3++)
  F$l[l3] += F$l[l3 - 1];
function Ge$6(l3) {
  for (let e28 = 1; e28 < F$l.length; e28 += 2)
    if (F$l[e28] > l3)
      return F$l[e28 - 1] <= l3;
  return false;
}
function we$b(l3) {
  return l3 >= 127462 && l3 <= 127487;
}
const ve$9 = 8205;
function K$h(l3, e28, t3 = true, n3 = true) {
  return (t3 ? Oe$7 : He$6)(l3, e28, n3);
}
function Oe$7(l3, e28, t3) {
  if (e28 == l3.length)
    return e28;
  e28 && Ee$7(l3.charCodeAt(e28)) && Ce$9(l3.charCodeAt(e28 - 1)) && e28--;
  let n3 = ne$e(l3, e28);
  for (e28 += xe$a(n3); e28 < l3.length; ) {
    let i = ne$e(l3, e28);
    if (n3 == ve$9 || i == ve$9 || t3 && Ge$6(i))
      e28 += xe$a(i), n3 = i;
    else if (we$b(i)) {
      let s3 = 0, r3 = e28 - 2;
      for (; r3 >= 0 && we$b(ne$e(l3, r3)); )
        s3++, r3 -= 2;
      if (s3 % 2 == 0)
        break;
      e28 += 2;
    } else
      break;
  }
  return e28;
}
function He$6(l3, e28, t3) {
  for (; e28 > 0; ) {
    let n3 = Oe$7(l3, e28 - 2, t3);
    if (n3 < e28)
      return n3;
    e28--;
  }
  return 0;
}
function Ee$7(l3) {
  return l3 >= 56320 && l3 < 57344;
}
function Ce$9(l3) {
  return l3 >= 55296 && l3 < 56320;
}
function ne$e(l3, e28) {
  let t3 = l3.charCodeAt(e28);
  if (!Ce$9(t3) || e28 + 1 == l3.length)
    return t3;
  let n3 = l3.charCodeAt(e28 + 1);
  return Ee$7(n3) ? (t3 - 55296 << 10) + (n3 - 56320) + 65536 : t3;
}
function rt$7(l3) {
  return l3 <= 65535 ? String.fromCharCode(l3) : (l3 -= 65536, String.fromCharCode((l3 >> 10) + 55296, (l3 & 1023) + 56320));
}
function xe$a(l3) {
  return l3 < 65536 ? 1 : 2;
}
const se$c = /\r\n?|\n/;
var C$I = /* @__PURE__ */ function(l3) {
  return l3[l3.Simple = 0] = "Simple", l3[l3.TrackDel = 1] = "TrackDel", l3[l3.TrackBefore = 2] = "TrackBefore", l3[l3.TrackAfter = 3] = "TrackAfter", l3;
}(C$I || (C$I = {}));
class E$p {
  constructor(e28) {
    this.sections = e28;
  }
  get length() {
    let e28 = 0;
    for (let t3 = 0; t3 < this.sections.length; t3 += 2)
      e28 += this.sections[t3];
    return e28;
  }
  get newLength() {
    let e28 = 0;
    for (let t3 = 0; t3 < this.sections.length; t3 += 2) {
      let n3 = this.sections[t3 + 1];
      e28 += n3 < 0 ? this.sections[t3] : n3;
    }
    return e28;
  }
  get empty() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  }
  iterGaps(e28) {
    for (let t3 = 0, n3 = 0, i = 0; t3 < this.sections.length; ) {
      let s3 = this.sections[t3++], r3 = this.sections[t3++];
      r3 < 0 ? (e28(n3, i, s3), i += s3) : i += r3, n3 += s3;
    }
  }
  iterChangedRanges(e28, t3 = false) {
    re$b(this, e28, t3);
  }
  get invertedDesc() {
    let e28 = [];
    for (let t3 = 0; t3 < this.sections.length; ) {
      let n3 = this.sections[t3++], i = this.sections[t3++];
      i < 0 ? e28.push(n3, i) : e28.push(i, n3);
    }
    return new E$p(e28);
  }
  composeDesc(e28) {
    return this.empty ? e28 : e28.empty ? this : Re$a(this, e28);
  }
  mapDesc(e28, t3 = false) {
    return e28.empty ? this : le$a(this, e28, t3);
  }
  mapPos(e28, t3 = -1, n3 = C$I.Simple) {
    let i = 0, s3 = 0;
    for (let r3 = 0; r3 < this.sections.length; ) {
      let h3 = this.sections[r3++], o3 = this.sections[r3++], a3 = i + h3;
      if (o3 < 0) {
        if (a3 > e28)
          return s3 + (e28 - i);
        s3 += h3;
      } else {
        if (n3 != C$I.Simple && a3 >= e28 && (n3 == C$I.TrackDel && i < e28 && a3 > e28 || n3 == C$I.TrackBefore && i < e28 || n3 == C$I.TrackAfter && a3 > e28))
          return null;
        if (a3 > e28 || a3 == e28 && t3 < 0 && !h3)
          return e28 == i || t3 < 0 ? s3 : s3 + o3;
        s3 += o3;
      }
      i = a3;
    }
    if (e28 > i)
      throw new RangeError(`Position ${e28} is out of range for changeset of length ${i}`);
    return s3;
  }
  touchesRange(e28, t3 = e28) {
    for (let n3 = 0, i = 0; n3 < this.sections.length && i <= t3; ) {
      let s3 = this.sections[n3++], r3 = this.sections[n3++], h3 = i + s3;
      if (r3 >= 0 && i <= t3 && h3 >= e28)
        return i < e28 && h3 > t3 ? "cover" : true;
      i = h3;
    }
    return false;
  }
  toString() {
    let e28 = "";
    for (let t3 = 0; t3 < this.sections.length; ) {
      let n3 = this.sections[t3++], i = this.sections[t3++];
      e28 += (e28 ? " " : "") + n3 + (i >= 0 ? ":" + i : "");
    }
    return e28;
  }
  toJSON() {
    return this.sections;
  }
  static fromJSON(e28) {
    if (!Array.isArray(e28) || e28.length % 2 || e28.some((t3) => typeof t3 != "number"))
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    return new E$p(e28);
  }
  static create(e28) {
    return new E$p(e28);
  }
}
class k$w extends E$p {
  constructor(e28, t3) {
    super(e28), this.inserted = t3;
  }
  apply(e28) {
    if (this.length != e28.length)
      throw new RangeError("Applying change set to a document with the wrong length");
    return re$b(this, (t3, n3, i, s3, r3) => e28 = e28.replace(i, i + (n3 - t3), r3), false), e28;
  }
  mapDesc(e28, t3 = false) {
    return le$a(this, e28, t3, true);
  }
  invert(e28) {
    let t3 = this.sections.slice(), n3 = [];
    for (let i = 0, s3 = 0; i < t3.length; i += 2) {
      let r3 = t3[i], h3 = t3[i + 1];
      if (h3 >= 0) {
        t3[i] = h3, t3[i + 1] = r3;
        let o3 = i >> 1;
        for (; n3.length < o3; )
          n3.push(x$l.empty);
        n3.push(r3 ? e28.slice(s3, s3 + r3) : x$l.empty);
      }
      s3 += r3;
    }
    return new k$w(t3, n3);
  }
  compose(e28) {
    return this.empty ? e28 : e28.empty ? this : Re$a(this, e28, true);
  }
  map(e28, t3 = false) {
    return e28.empty ? this : le$a(this, e28, t3, true);
  }
  iterChanges(e28, t3 = false) {
    re$b(this, e28, t3);
  }
  get desc() {
    return E$p.create(this.sections);
  }
  filter(e28) {
    let t3 = [], n3 = [], i = [], s3 = new $$f(this);
    e:
      for (let r3 = 0, h3 = 0; ; ) {
        let o3 = r3 == e28.length ? 1e9 : e28[r3++];
        for (; h3 < o3 || h3 == o3 && s3.len == 0; ) {
          if (s3.done)
            break e;
          let f3 = Math.min(s3.len, o3 - h3);
          y$B(i, f3, -1);
          let u3 = s3.ins == -1 ? -1 : s3.off == 0 ? s3.ins : 0;
          y$B(t3, f3, u3), u3 > 0 && R$h(n3, t3, s3.text), s3.forward(f3), h3 += f3;
        }
        let a3 = e28[r3++];
        for (; h3 < a3; ) {
          if (s3.done)
            break e;
          let f3 = Math.min(s3.len, a3 - h3);
          y$B(t3, f3, -1), y$B(i, f3, s3.ins == -1 ? -1 : s3.off == 0 ? s3.ins : 0), s3.forward(f3), h3 += f3;
        }
      }
    return {
      changes: new k$w(t3, n3),
      filtered: E$p.create(i)
    };
  }
  toJSON() {
    let e28 = [];
    for (let t3 = 0; t3 < this.sections.length; t3 += 2) {
      let n3 = this.sections[t3], i = this.sections[t3 + 1];
      i < 0 ? e28.push(n3) : i == 0 ? e28.push([n3]) : e28.push([n3].concat(this.inserted[t3 >> 1].toJSON()));
    }
    return e28;
  }
  static of(e28, t3, n3) {
    let i = [], s3 = [], r3 = 0, h3 = null;
    function o3(f3 = false) {
      if (!f3 && !i.length)
        return;
      r3 < t3 && y$B(i, t3 - r3, -1);
      let u3 = new k$w(i, s3);
      h3 = h3 ? h3.compose(u3.map(h3)) : u3, i = [], s3 = [], r3 = 0;
    }
    function a3(f3) {
      if (Array.isArray(f3))
        for (let u3 of f3)
          a3(u3);
      else if (f3 instanceof k$w) {
        if (f3.length != t3)
          throw new RangeError(`Mismatched change set length (got ${f3.length}, expected ${t3})`);
        o3(), h3 = h3 ? h3.compose(f3.map(h3)) : f3;
      } else {
        let { from: u3, to: d3 = u3, insert: c3 } = f3;
        if (u3 > d3 || u3 < 0 || d3 > t3)
          throw new RangeError(`Invalid change range ${u3} to ${d3} (in doc of length ${t3})`);
        let p3 = c3 ? typeof c3 == "string" ? x$l.of(c3.split(n3 || se$c)) : c3 : x$l.empty, b3 = p3.length;
        if (u3 == d3 && b3 == 0)
          return;
        u3 < r3 && o3(), u3 > r3 && y$B(i, u3 - r3, -1), y$B(i, d3 - u3, b3), R$h(s3, i, p3), r3 = d3;
      }
    }
    return a3(e28), o3(!h3), h3;
  }
  static empty(e28) {
    return new k$w(e28 ? [e28, -1] : [], []);
  }
  static fromJSON(e28) {
    if (!Array.isArray(e28))
      throw new RangeError("Invalid JSON representation of ChangeSet");
    let t3 = [], n3 = [];
    for (let i = 0; i < e28.length; i++) {
      let s3 = e28[i];
      if (typeof s3 == "number")
        t3.push(s3, -1);
      else {
        if (!Array.isArray(s3) || typeof s3[0] != "number" || s3.some((r3, h3) => h3 && typeof r3 != "string"))
          throw new RangeError("Invalid JSON representation of ChangeSet");
        if (s3.length == 1)
          t3.push(s3[0], 0);
        else {
          for (; n3.length < i; )
            n3.push(x$l.empty);
          n3[i] = x$l.of(s3.slice(1)), t3.push(s3[0], n3[i].length);
        }
      }
    }
    return new k$w(t3, n3);
  }
  static createSet(e28, t3) {
    return new k$w(e28, t3);
  }
}
function y$B(l3, e28, t3, n3 = false) {
  if (e28 == 0 && t3 <= 0)
    return;
  let i = l3.length - 2;
  i >= 0 && t3 <= 0 && t3 == l3[i + 1] ? l3[i] += e28 : e28 == 0 && l3[i] == 0 ? l3[i + 1] += t3 : n3 ? (l3[i] += e28, l3[i + 1] += t3) : l3.push(e28, t3);
}
function R$h(l3, e28, t3) {
  if (t3.length == 0)
    return;
  let n3 = e28.length - 2 >> 1;
  if (n3 < l3.length)
    l3[l3.length - 1] = l3[l3.length - 1].append(t3);
  else {
    for (; l3.length < n3; )
      l3.push(x$l.empty);
    l3.push(t3);
  }
}
function re$b(l3, e28, t3) {
  let n3 = l3.inserted;
  for (let i = 0, s3 = 0, r3 = 0; r3 < l3.sections.length; ) {
    let h3 = l3.sections[r3++], o3 = l3.sections[r3++];
    if (o3 < 0)
      i += h3, s3 += h3;
    else {
      let a3 = i, f3 = s3, u3 = x$l.empty;
      for (; a3 += h3, f3 += o3, o3 && n3 && (u3 = u3.append(n3[r3 - 2 >> 1])), !(t3 || r3 == l3.sections.length || l3.sections[r3 + 1] < 0); )
        h3 = l3.sections[r3++], o3 = l3.sections[r3++];
      e28(i, a3, s3, f3, u3), i = a3, s3 = f3;
    }
  }
}
function le$a(l3, e28, t3, n3 = false) {
  let i = [], s3 = n3 ? [] : null, r3 = new $$f(l3), h3 = new $$f(e28);
  for (let o3 = -1; ; )
    if (r3.ins == -1 && h3.ins == -1) {
      let a3 = Math.min(r3.len, h3.len);
      y$B(i, a3, -1), r3.forward(a3), h3.forward(a3);
    } else if (h3.ins >= 0 && (r3.ins < 0 || o3 == r3.i || r3.off == 0 && (h3.len < r3.len || h3.len == r3.len && !t3))) {
      let a3 = h3.len;
      for (y$B(i, h3.ins, -1); a3; ) {
        let f3 = Math.min(r3.len, a3);
        r3.ins >= 0 && o3 < r3.i && r3.len <= f3 && (y$B(i, 0, r3.ins), s3 && R$h(s3, i, r3.text), o3 = r3.i), r3.forward(f3), a3 -= f3;
      }
      h3.next();
    } else if (r3.ins >= 0) {
      let a3 = 0, f3 = r3.len;
      for (; f3; )
        if (h3.ins == -1) {
          let u3 = Math.min(f3, h3.len);
          a3 += u3, f3 -= u3, h3.forward(u3);
        } else if (h3.ins == 0 && h3.len < f3)
          f3 -= h3.len, h3.next();
        else
          break;
      y$B(i, a3, o3 < r3.i ? r3.ins : 0), s3 && o3 < r3.i && R$h(s3, i, r3.text), o3 = r3.i, r3.forward(r3.len - f3);
    } else {
      if (r3.done && h3.done)
        return s3 ? k$w.createSet(i, s3) : E$p.create(i);
      throw new Error("Mismatched change set lengths");
    }
}
function Re$a(l3, e28, t3 = false) {
  let n3 = [], i = t3 ? [] : null, s3 = new $$f(l3), r3 = new $$f(e28);
  for (let h3 = false; ; ) {
    if (s3.done && r3.done)
      return i ? k$w.createSet(n3, i) : E$p.create(n3);
    if (s3.ins == 0)
      y$B(n3, s3.len, 0, h3), s3.next();
    else if (r3.len == 0 && !r3.done)
      y$B(n3, 0, r3.ins, h3), i && R$h(i, n3, r3.text), r3.next();
    else {
      if (s3.done || r3.done)
        throw new Error("Mismatched change set lengths");
      {
        let o3 = Math.min(s3.len2, r3.len), a3 = n3.length;
        if (s3.ins == -1) {
          let f3 = r3.ins == -1 ? -1 : r3.off ? 0 : r3.ins;
          y$B(n3, o3, f3, h3), i && f3 && R$h(i, n3, r3.text);
        } else
          r3.ins == -1 ? (y$B(n3, s3.off ? 0 : s3.len, o3, h3), i && R$h(i, n3, s3.textBit(o3))) : (y$B(n3, s3.off ? 0 : s3.len, r3.off ? 0 : r3.ins, h3), i && !r3.off && R$h(i, n3, r3.text));
        h3 = (s3.ins > o3 || r3.ins >= 0 && r3.len > o3) && (h3 || n3.length > a3), s3.forward2(o3), r3.forward(o3);
      }
    }
  }
}
class $$f {
  constructor(e28) {
    this.set = e28, this.i = 0, this.next();
  }
  next() {
    let { sections: e28 } = this.set;
    this.i < e28.length ? (this.len = e28[this.i++], this.ins = e28[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
  }
  get done() {
    return this.ins == -2;
  }
  get len2() {
    return this.ins < 0 ? this.len : this.ins;
  }
  get text() {
    let { inserted: e28 } = this.set, t3 = this.i - 2 >> 1;
    return t3 >= e28.length ? x$l.empty : e28[t3];
  }
  textBit(e28) {
    let { inserted: t3 } = this.set, n3 = this.i - 2 >> 1;
    return n3 >= t3.length && !e28 ? x$l.empty : t3[n3].slice(this.off, e28 == null ? void 0 : this.off + e28);
  }
  forward(e28) {
    e28 == this.len ? this.next() : (this.len -= e28, this.off += e28);
  }
  forward2(e28) {
    this.ins == -1 ? this.forward(e28) : e28 == this.ins ? this.next() : (this.ins -= e28, this.off += e28);
  }
}
class M$h {
  constructor(e28, t3, n3) {
    this.from = e28, this.to = t3, this.flags = n3;
  }
  get anchor() {
    return this.flags & 32 ? this.to : this.from;
  }
  get head() {
    return this.flags & 32 ? this.from : this.to;
  }
  get empty() {
    return this.from == this.to;
  }
  get assoc() {
    return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
  }
  get bidiLevel() {
    let e28 = this.flags & 7;
    return e28 == 7 ? null : e28;
  }
  get goalColumn() {
    let e28 = this.flags >> 6;
    return e28 == 16777215 ? void 0 : e28;
  }
  map(e28, t3 = -1) {
    let n3, i;
    return this.empty ? n3 = i = e28.mapPos(this.from, t3) : (n3 = e28.mapPos(this.from, 1), i = e28.mapPos(this.to, -1)), n3 == this.from && i == this.to ? this : new M$h(n3, i, this.flags);
  }
  extend(e28, t3 = e28) {
    if (e28 <= this.anchor && t3 >= this.anchor)
      return g$K.range(e28, t3);
    let n3 = Math.abs(e28 - this.anchor) > Math.abs(t3 - this.anchor) ? e28 : t3;
    return g$K.range(this.anchor, n3);
  }
  eq(e28) {
    return this.anchor == e28.anchor && this.head == e28.head;
  }
  toJSON() {
    return { anchor: this.anchor, head: this.head };
  }
  static fromJSON(e28) {
    if (!e28 || typeof e28.anchor != "number" || typeof e28.head != "number")
      throw new RangeError("Invalid JSON representation for SelectionRange");
    return g$K.range(e28.anchor, e28.head);
  }
  static create(e28, t3, n3) {
    return new M$h(e28, t3, n3);
  }
}
class g$K {
  constructor(e28, t3) {
    this.ranges = e28, this.mainIndex = t3;
  }
  map(e28, t3 = -1) {
    return e28.empty ? this : g$K.create(this.ranges.map((n3) => n3.map(e28, t3)), this.mainIndex);
  }
  eq(e28) {
    if (this.ranges.length != e28.ranges.length || this.mainIndex != e28.mainIndex)
      return false;
    for (let t3 = 0; t3 < this.ranges.length; t3++)
      if (!this.ranges[t3].eq(e28.ranges[t3]))
        return false;
    return true;
  }
  get main() {
    return this.ranges[this.mainIndex];
  }
  asSingle() {
    return this.ranges.length == 1 ? this : new g$K([this.main], 0);
  }
  addRange(e28, t3 = true) {
    return g$K.create([e28].concat(this.ranges), t3 ? 0 : this.mainIndex + 1);
  }
  replaceRange(e28, t3 = this.mainIndex) {
    let n3 = this.ranges.slice();
    return n3[t3] = e28, g$K.create(n3, this.mainIndex);
  }
  toJSON() {
    return { ranges: this.ranges.map((e28) => e28.toJSON()), main: this.mainIndex };
  }
  static fromJSON(e28) {
    if (!e28 || !Array.isArray(e28.ranges) || typeof e28.main != "number" || e28.main >= e28.ranges.length)
      throw new RangeError("Invalid JSON representation for EditorSelection");
    return new g$K(e28.ranges.map((t3) => M$h.fromJSON(t3)), e28.main);
  }
  static single(e28, t3 = e28) {
    return new g$K([g$K.range(e28, t3)], 0);
  }
  static create(e28, t3 = 0) {
    if (e28.length == 0)
      throw new RangeError("A selection needs at least one range");
    for (let n3 = 0, i = 0; i < e28.length; i++) {
      let s3 = e28[i];
      if (s3.empty ? s3.from <= n3 : s3.from < n3)
        return g$K.normalized(e28.slice(), t3);
      n3 = s3.to;
    }
    return new g$K(e28, t3);
  }
  static cursor(e28, t3 = 0, n3, i) {
    return M$h.create(e28, e28, (t3 == 0 ? 0 : t3 < 0 ? 8 : 16) | (n3 == null ? 7 : Math.min(6, n3)) | (i != null ? i : 16777215) << 6);
  }
  static range(e28, t3, n3, i) {
    let s3 = (n3 != null ? n3 : 16777215) << 6 | (i == null ? 7 : Math.min(6, i));
    return t3 < e28 ? M$h.create(t3, e28, 48 | s3) : M$h.create(e28, t3, (t3 > e28 ? 8 : 0) | s3);
  }
  static normalized(e28, t3 = 0) {
    let n3 = e28[t3];
    e28.sort((i, s3) => i.from - s3.from), t3 = e28.indexOf(n3);
    for (let i = 1; i < e28.length; i++) {
      let s3 = e28[i], r3 = e28[i - 1];
      if (s3.empty ? s3.from <= r3.to : s3.from < r3.to) {
        let h3 = r3.from, o3 = Math.max(s3.to, r3.to);
        i <= t3 && t3--, e28.splice(--i, 2, s3.anchor > s3.head ? g$K.range(o3, h3) : g$K.range(h3, o3));
      }
    }
    return new g$K(e28, t3);
  }
}
function Te$9(l3, e28) {
  for (let t3 of l3.ranges)
    if (t3.to > e28)
      throw new RangeError("Selection points outside of document");
}
let de$d = 0;
class A$o {
  constructor(e28, t3, n3, i, s3) {
    this.combine = e28, this.compareInput = t3, this.compare = n3, this.isStatic = i, this.id = de$d++, this.default = e28([]), this.extensions = typeof s3 == "function" ? s3(this) : s3;
  }
  get reader() {
    return this;
  }
  static define(e28 = {}) {
    return new A$o(e28.combine || ((t3) => t3), e28.compareInput || ((t3, n3) => t3 === n3), e28.compare || (e28.combine ? (t3, n3) => t3 === n3 : ge$b), !!e28.static, e28.enables);
  }
  of(e28) {
    return new Z$i([], this, 0, e28);
  }
  compute(e28, t3) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new Z$i(e28, this, 1, t3);
  }
  computeN(e28, t3) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new Z$i(e28, this, 2, t3);
  }
  from(e28, t3) {
    return t3 || (t3 = (n3) => n3), this.compute([e28], (n3) => t3(n3.field(e28)));
  }
}
function ge$b(l3, e28) {
  return l3 == e28 || l3.length == e28.length && l3.every((t3, n3) => t3 === e28[n3]);
}
class Z$i {
  constructor(e28, t3, n3, i) {
    this.dependencies = e28, this.facet = t3, this.type = n3, this.value = i, this.id = de$d++;
  }
  dynamicSlot(e28) {
    var t3;
    let n3 = this.value, i = this.facet.compareInput, s3 = this.id, r3 = e28[s3] >> 1, h3 = this.type == 2, o3 = false, a3 = false, f3 = [];
    for (let u3 of this.dependencies)
      u3 == "doc" ? o3 = true : u3 == "selection" ? a3 = true : ((t3 = e28[u3.id]) !== null && t3 !== void 0 ? t3 : 1) & 1 || f3.push(e28[u3.id]);
    return {
      create(u3) {
        return u3.values[r3] = n3(u3), 1;
      },
      update(u3, d3) {
        if (o3 && d3.docChanged || a3 && (d3.docChanged || d3.selection) || he$d(u3, f3)) {
          let c3 = n3(u3);
          if (h3 ? !ke$a(c3, u3.values[r3], i) : !i(c3, u3.values[r3]))
            return u3.values[r3] = c3, 1;
        }
        return 0;
      },
      reconfigure: (u3, d3) => {
        let c3, p3 = d3.config.address[s3];
        if (p3 != null) {
          let b3 = X$h(d3, p3);
          if (this.dependencies.every((v3) => v3 instanceof A$o ? d3.facet(v3) === u3.facet(v3) : v3 instanceof L$s ? d3.field(v3, false) == u3.field(v3, false) : true) || (h3 ? ke$a(c3 = n3(u3), b3, i) : i(c3 = n3(u3), b3)))
            return u3.values[r3] = b3, 0;
        } else
          c3 = n3(u3);
        return u3.values[r3] = c3, 1;
      }
    };
  }
}
function ke$a(l3, e28, t3) {
  if (l3.length != e28.length)
    return false;
  for (let n3 = 0; n3 < l3.length; n3++)
    if (!t3(l3[n3], e28[n3]))
      return false;
  return true;
}
function he$d(l3, e28) {
  let t3 = false;
  for (let n3 of e28)
    q$k(l3, n3) & 1 && (t3 = true);
  return t3;
}
function je$5(l3, e28, t3) {
  let n3 = t3.map((o3) => l3[o3.id]), i = t3.map((o3) => o3.type), s3 = n3.filter((o3) => !(o3 & 1)), r3 = l3[e28.id] >> 1;
  function h3(o3) {
    let a3 = [];
    for (let f3 = 0; f3 < n3.length; f3++) {
      let u3 = X$h(o3, n3[f3]);
      if (i[f3] == 2)
        for (let d3 of u3)
          a3.push(d3);
      else
        a3.push(u3);
    }
    return e28.combine(a3);
  }
  return {
    create(o3) {
      for (let a3 of n3)
        q$k(o3, a3);
      return o3.values[r3] = h3(o3), 1;
    },
    update(o3, a3) {
      if (!he$d(o3, s3))
        return 0;
      let f3 = h3(o3);
      return e28.compare(f3, o3.values[r3]) ? 0 : (o3.values[r3] = f3, 1);
    },
    reconfigure(o3, a3) {
      let f3 = he$d(o3, n3), u3 = a3.config.facets[e28.id], d3 = a3.facet(e28);
      if (u3 && !f3 && ge$b(t3, u3))
        return o3.values[r3] = d3, 0;
      let c3 = h3(o3);
      return e28.compare(c3, d3) ? (o3.values[r3] = d3, 0) : (o3.values[r3] = c3, 1);
    }
  };
}
const ye$b = /* @__PURE__ */ A$o.define({ static: true });
class L$s {
  constructor(e28, t3, n3, i, s3) {
    this.id = e28, this.createF = t3, this.updateF = n3, this.compareF = i, this.spec = s3, this.provides = void 0;
  }
  static define(e28) {
    let t3 = new L$s(de$d++, e28.create, e28.update, e28.compare || ((n3, i) => n3 === i), e28);
    return e28.provide && (t3.provides = e28.provide(t3)), t3;
  }
  create(e28) {
    let t3 = e28.facet(ye$b).find((n3) => n3.field == this);
    return ((t3 == null ? void 0 : t3.create) || this.createF)(e28);
  }
  slot(e28) {
    let t3 = e28[this.id] >> 1;
    return {
      create: (n3) => (n3.values[t3] = this.create(n3), 1),
      update: (n3, i) => {
        let s3 = n3.values[t3], r3 = this.updateF(s3, i);
        return this.compareF(s3, r3) ? 0 : (n3.values[t3] = r3, 1);
      },
      reconfigure: (n3, i) => i.config.address[this.id] != null ? (n3.values[t3] = i.field(this), 0) : (n3.values[t3] = this.create(n3), 1)
    };
  }
  init(e28) {
    return [this, ye$b.of({ field: this, create: e28 })];
  }
  get extension() {
    return this;
  }
}
const B$s = { lowest: 4, low: 3, default: 2, high: 1, highest: 0 };
function V$k(l3) {
  return (e28) => new Be$7(e28, l3);
}
const lt$8 = {
  highest: /* @__PURE__ */ V$k(B$s.highest),
  high: /* @__PURE__ */ V$k(B$s.high),
  default: /* @__PURE__ */ V$k(B$s.default),
  low: /* @__PURE__ */ V$k(B$s.low),
  lowest: /* @__PURE__ */ V$k(B$s.lowest)
};
class Be$7 {
  constructor(e28, t3) {
    this.inner = e28, this.prec = t3;
  }
}
class ee$c {
  of(e28) {
    return new oe$d(this, e28);
  }
  reconfigure(e28) {
    return ee$c.reconfigure.of({ compartment: this, extension: e28 });
  }
  get(e28) {
    return e28.config.compartments.get(this);
  }
}
class oe$d {
  constructor(e28, t3) {
    this.compartment = e28, this.inner = t3;
  }
}
class Q$i {
  constructor(e28, t3, n3, i, s3, r3) {
    for (this.base = e28, this.compartments = t3, this.dynamicSlots = n3, this.address = i, this.staticValues = s3, this.facets = r3, this.statusTemplate = []; this.statusTemplate.length < n3.length; )
      this.statusTemplate.push(0);
  }
  staticFacet(e28) {
    let t3 = this.address[e28.id];
    return t3 == null ? e28.default : this.staticValues[t3 >> 1];
  }
  static resolve(e28, t3, n3) {
    let i = [], s3 = /* @__PURE__ */ Object.create(null), r3 = /* @__PURE__ */ new Map();
    for (let d3 of Ze$5(e28, t3, r3))
      d3 instanceof L$s ? i.push(d3) : (s3[d3.facet.id] || (s3[d3.facet.id] = [])).push(d3);
    let h3 = /* @__PURE__ */ Object.create(null), o3 = [], a3 = [];
    for (let d3 of i)
      h3[d3.id] = a3.length << 1, a3.push((c3) => d3.slot(c3));
    let f3 = n3 == null ? void 0 : n3.config.facets;
    for (let d3 in s3) {
      let c3 = s3[d3], p3 = c3[0].facet, b3 = f3 && f3[d3] || [];
      if (c3.every((v3) => v3.type == 0))
        if (h3[p3.id] = o3.length << 1 | 1, ge$b(b3, c3))
          o3.push(n3.facet(p3));
        else {
          let v3 = p3.combine(c3.map((te2) => te2.value));
          o3.push(n3 && p3.compare(v3, n3.facet(p3)) ? n3.facet(p3) : v3);
        }
      else {
        for (let v3 of c3)
          v3.type == 0 ? (h3[v3.id] = o3.length << 1 | 1, o3.push(v3.value)) : (h3[v3.id] = a3.length << 1, a3.push((te2) => v3.dynamicSlot(te2)));
        h3[p3.id] = a3.length << 1, a3.push((v3) => je$5(v3, p3, c3));
      }
    }
    let u3 = a3.map((d3) => d3(h3));
    return new Q$i(e28, r3, u3, h3, o3, s3);
  }
}
function Ze$5(l3, e28, t3) {
  let n3 = [[], [], [], [], []], i = /* @__PURE__ */ new Map();
  function s3(r3, h3) {
    let o3 = i.get(r3);
    if (o3 != null) {
      if (o3 <= h3)
        return;
      let a3 = n3[o3].indexOf(r3);
      a3 > -1 && n3[o3].splice(a3, 1), r3 instanceof oe$d && t3.delete(r3.compartment);
    }
    if (i.set(r3, h3), Array.isArray(r3))
      for (let a3 of r3)
        s3(a3, h3);
    else if (r3 instanceof oe$d) {
      if (t3.has(r3.compartment))
        throw new RangeError("Duplicate use of compartment in extensions");
      let a3 = e28.get(r3.compartment) || r3.inner;
      t3.set(r3.compartment, a3), s3(a3, h3);
    } else if (r3 instanceof Be$7)
      s3(r3.inner, r3.prec);
    else if (r3 instanceof L$s)
      n3[h3].push(r3), r3.provides && s3(r3.provides, h3);
    else if (r3 instanceof Z$i)
      n3[h3].push(r3), r3.facet.extensions && s3(r3.facet.extensions, B$s.default);
    else {
      let a3 = r3.extension;
      if (!a3)
        throw new Error(`Unrecognized extension value in extension set (${r3}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
      s3(a3, h3);
    }
  }
  return s3(l3, B$s.default), n3.reduce((r3, h3) => r3.concat(h3));
}
function q$k(l3, e28) {
  if (e28 & 1)
    return 2;
  let t3 = e28 >> 1, n3 = l3.status[t3];
  if (n3 == 4)
    throw new Error("Cyclic dependency between fields and/or facets");
  if (n3 & 2)
    return n3;
  l3.status[t3] = 4;
  let i = l3.computeSlot(l3, l3.config.dynamicSlots[t3]);
  return l3.status[t3] = 2 | i;
}
function X$h(l3, e28) {
  return e28 & 1 ? l3.config.staticValues[e28 >> 1] : l3.values[e28 >> 1];
}
const Me$6 = /* @__PURE__ */ A$o.define(), Fe$6 = /* @__PURE__ */ A$o.define({
  combine: (l3) => l3.some((e28) => e28),
  static: true
}), Je$5 = /* @__PURE__ */ A$o.define({
  combine: (l3) => l3.length ? l3[0] : void 0,
  static: true
}), Le$5 = /* @__PURE__ */ A$o.define(), Ve$8 = /* @__PURE__ */ A$o.define(), Ne$6 = /* @__PURE__ */ A$o.define(), De$4 = /* @__PURE__ */ A$o.define({
  combine: (l3) => l3.length ? l3[0] : false
});
class U$n {
  constructor(e28, t3) {
    this.type = e28, this.value = t3;
  }
  static define() {
    return new Ke$6();
  }
}
class Ke$6 {
  of(e28) {
    return new U$n(this, e28);
  }
}
class Qe$6 {
  constructor(e28) {
    this.map = e28;
  }
  of(e28) {
    return new S$m(this, e28);
  }
}
class S$m {
  constructor(e28, t3) {
    this.type = e28, this.value = t3;
  }
  map(e28) {
    let t3 = this.type.map(this.value, e28);
    return t3 === void 0 ? void 0 : t3 == this.value ? this : new S$m(this.type, t3);
  }
  is(e28) {
    return this.type == e28;
  }
  static define(e28 = {}) {
    return new Qe$6(e28.map || ((t3) => t3));
  }
  static mapEffects(e28, t3) {
    if (!e28.length)
      return e28;
    let n3 = [];
    for (let i of e28) {
      let s3 = i.map(t3);
      s3 && n3.push(s3);
    }
    return n3;
  }
}
S$m.reconfigure = /* @__PURE__ */ S$m.define();
S$m.appendConfig = /* @__PURE__ */ S$m.define();
class I$u {
  constructor(e28, t3, n3, i, s3, r3) {
    this.startState = e28, this.changes = t3, this.selection = n3, this.effects = i, this.annotations = s3, this.scrollIntoView = r3, this._doc = null, this._state = null, n3 && Te$9(n3, t3.newLength), s3.some((h3) => h3.type == I$u.time) || (this.annotations = s3.concat(I$u.time.of(Date.now())));
  }
  static create(e28, t3, n3, i, s3, r3) {
    return new I$u(e28, t3, n3, i, s3, r3);
  }
  get newDoc() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  }
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  get state() {
    return this._state || this.startState.applyTransaction(this), this._state;
  }
  annotation(e28) {
    for (let t3 of this.annotations)
      if (t3.type == e28)
        return t3.value;
  }
  get docChanged() {
    return !this.changes.empty;
  }
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  isUserEvent(e28) {
    let t3 = this.annotation(I$u.userEvent);
    return !!(t3 && (t3 == e28 || t3.length > e28.length && t3.slice(0, e28.length) == e28 && t3[e28.length] == "."));
  }
}
I$u.time = /* @__PURE__ */ U$n.define();
I$u.userEvent = /* @__PURE__ */ U$n.define();
I$u.addToHistory = /* @__PURE__ */ U$n.define();
I$u.remote = /* @__PURE__ */ U$n.define();
function Xe$8(l3, e28) {
  let t3 = [];
  for (let n3 = 0, i = 0; ; ) {
    let s3, r3;
    if (n3 < l3.length && (i == e28.length || e28[i] >= l3[n3]))
      s3 = l3[n3++], r3 = l3[n3++];
    else if (i < e28.length)
      s3 = e28[i++], r3 = e28[i++];
    else
      return t3;
    !t3.length || t3[t3.length - 1] < s3 ? t3.push(s3, r3) : t3[t3.length - 1] < r3 && (t3[t3.length - 1] = r3);
  }
}
function qe$6(l3, e28, t3) {
  var n3;
  let i, s3, r3;
  return t3 ? (i = e28.changes, s3 = k$w.empty(e28.changes.length), r3 = l3.changes.compose(e28.changes)) : (i = e28.changes.map(l3.changes), s3 = l3.changes.mapDesc(e28.changes, true), r3 = l3.changes.compose(i)), {
    changes: r3,
    selection: e28.selection ? e28.selection.map(s3) : (n3 = l3.selection) === null || n3 === void 0 ? void 0 : n3.map(i),
    effects: S$m.mapEffects(l3.effects, i).concat(S$m.mapEffects(e28.effects, s3)),
    annotations: l3.annotations.length ? l3.annotations.concat(e28.annotations) : e28.annotations,
    scrollIntoView: l3.scrollIntoView || e28.scrollIntoView
  };
}
function ae$d(l3, e28, t3) {
  let n3 = e28.selection, i = J$h(e28.annotations);
  return e28.userEvent && (i = i.concat(I$u.userEvent.of(e28.userEvent))), {
    changes: e28.changes instanceof k$w ? e28.changes : k$w.of(e28.changes || [], t3, l3.facet(Je$5)),
    selection: n3 && (n3 instanceof g$K ? n3 : g$K.single(n3.anchor, n3.head)),
    effects: J$h(e28.effects),
    annotations: i,
    scrollIntoView: !!e28.scrollIntoView
  };
}
function $e$5(l3, e28, t3) {
  let n3 = ae$d(l3, e28.length ? e28[0] : {}, l3.doc.length);
  e28.length && e28[0].filter === false && (t3 = false);
  for (let s3 = 1; s3 < e28.length; s3++) {
    e28[s3].filter === false && (t3 = false);
    let r3 = !!e28[s3].sequential;
    n3 = qe$6(n3, ae$d(l3, e28[s3], r3 ? n3.changes.newLength : l3.doc.length), r3);
  }
  let i = I$u.create(l3, n3.changes, n3.selection, n3.effects, n3.annotations, n3.scrollIntoView);
  return _e$a(t3 ? Ye$5(i) : i);
}
function Ye$5(l3) {
  let e28 = l3.startState, t3 = true;
  for (let i of e28.facet(Le$5)) {
    let s3 = i(l3);
    if (s3 === false) {
      t3 = false;
      break;
    }
    Array.isArray(s3) && (t3 = t3 === true ? s3 : Xe$8(t3, s3));
  }
  if (t3 !== true) {
    let i, s3;
    if (t3 === false)
      s3 = l3.changes.invertedDesc, i = k$w.empty(e28.doc.length);
    else {
      let r3 = l3.changes.filter(t3);
      i = r3.changes, s3 = r3.filtered.mapDesc(r3.changes).invertedDesc;
    }
    l3 = I$u.create(e28, i, l3.selection && l3.selection.map(s3), S$m.mapEffects(l3.effects, s3), l3.annotations, l3.scrollIntoView);
  }
  let n3 = e28.facet(Ve$8);
  for (let i = n3.length - 1; i >= 0; i--) {
    let s3 = n3[i](l3);
    s3 instanceof I$u ? l3 = s3 : Array.isArray(s3) && s3.length == 1 && s3[0] instanceof I$u ? l3 = s3[0] : l3 = $e$5(e28, J$h(s3), false);
  }
  return l3;
}
function _e$a(l3) {
  let e28 = l3.startState, t3 = e28.facet(Ne$6), n3 = l3;
  for (let i = t3.length - 1; i >= 0; i--) {
    let s3 = t3[i](l3);
    s3 && Object.keys(s3).length && (n3 = qe$6(n3, ae$d(e28, s3, l3.changes.newLength), true));
  }
  return n3 == l3 ? l3 : I$u.create(e28, l3.changes, l3.selection, n3.effects, n3.annotations, n3.scrollIntoView);
}
const et$5 = [];
function J$h(l3) {
  return l3 == null ? et$5 : Array.isArray(l3) ? l3 : [l3];
}
var T$x = /* @__PURE__ */ function(l3) {
  return l3[l3.Word = 0] = "Word", l3[l3.Space = 1] = "Space", l3[l3.Other = 2] = "Other", l3;
}(T$x || (T$x = {}));
const tt$4 = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let fe$b;
try {
  fe$b = /* @__PURE__ */ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch {
}
function nt$6(l3) {
  if (fe$b)
    return fe$b.test(l3);
  for (let e28 = 0; e28 < l3.length; e28++) {
    let t3 = l3[e28];
    if (/\w/.test(t3) || t3 > "\x80" && (t3.toUpperCase() != t3.toLowerCase() || tt$4.test(t3)))
      return true;
  }
  return false;
}
function it$6(l3) {
  return (e28) => {
    if (!/\S/.test(e28))
      return T$x.Space;
    if (nt$6(e28))
      return T$x.Word;
    for (let t3 = 0; t3 < l3.length; t3++)
      if (e28.indexOf(l3[t3]) > -1)
        return T$x.Word;
    return T$x.Other;
  };
}
class w$q {
  constructor(e28, t3, n3, i, s3, r3) {
    this.config = e28, this.doc = t3, this.selection = n3, this.values = i, this.status = e28.statusTemplate.slice(), this.computeSlot = s3, r3 && (r3._state = this);
    for (let h3 = 0; h3 < this.config.dynamicSlots.length; h3++)
      q$k(this, h3 << 1);
    this.computeSlot = null;
  }
  field(e28, t3 = true) {
    let n3 = this.config.address[e28.id];
    if (n3 == null) {
      if (t3)
        throw new RangeError("Field is not present in this state");
      return;
    }
    return q$k(this, n3), X$h(this, n3);
  }
  update(...e28) {
    return $e$5(this, e28, true);
  }
  applyTransaction(e28) {
    let t3 = this.config, { base: n3, compartments: i } = t3;
    for (let r3 of e28.effects)
      r3.is(ee$c.reconfigure) ? (t3 && (i = /* @__PURE__ */ new Map(), t3.compartments.forEach((h3, o3) => i.set(o3, h3)), t3 = null), i.set(r3.value.compartment, r3.value.extension)) : r3.is(S$m.reconfigure) ? (t3 = null, n3 = r3.value) : r3.is(S$m.appendConfig) && (t3 = null, n3 = J$h(n3).concat(r3.value));
    let s3;
    t3 ? s3 = e28.startState.values.slice() : (t3 = Q$i.resolve(n3, i, this), s3 = new w$q(t3, this.doc, this.selection, t3.dynamicSlots.map(() => null), (h3, o3) => o3.reconfigure(h3, this), null).values), new w$q(t3, e28.newDoc, e28.newSelection, s3, (r3, h3) => h3.update(r3, e28), e28);
  }
  replaceSelection(e28) {
    return typeof e28 == "string" && (e28 = this.toText(e28)), this.changeByRange((t3) => ({
      changes: { from: t3.from, to: t3.to, insert: e28 },
      range: g$K.cursor(t3.from + e28.length)
    }));
  }
  changeByRange(e28) {
    let t3 = this.selection, n3 = e28(t3.ranges[0]), i = this.changes(n3.changes), s3 = [n3.range], r3 = J$h(n3.effects);
    for (let h3 = 1; h3 < t3.ranges.length; h3++) {
      let o3 = e28(t3.ranges[h3]), a3 = this.changes(o3.changes), f3 = a3.map(i);
      for (let d3 = 0; d3 < h3; d3++)
        s3[d3] = s3[d3].map(f3);
      let u3 = i.mapDesc(a3, true);
      s3.push(o3.range.map(u3)), i = i.compose(f3), r3 = S$m.mapEffects(r3, f3).concat(S$m.mapEffects(J$h(o3.effects), u3));
    }
    return {
      changes: i,
      selection: g$K.create(s3, t3.mainIndex),
      effects: r3
    };
  }
  changes(e28 = []) {
    return e28 instanceof k$w ? e28 : k$w.of(e28, this.doc.length, this.facet(w$q.lineSeparator));
  }
  toText(e28) {
    return x$l.of(e28.split(this.facet(w$q.lineSeparator) || se$c));
  }
  sliceDoc(e28 = 0, t3 = this.doc.length) {
    return this.doc.sliceString(e28, t3, this.lineBreak);
  }
  facet(e28) {
    let t3 = this.config.address[e28.id];
    return t3 == null ? e28.default : (q$k(this, t3), X$h(this, t3));
  }
  toJSON(e28) {
    let t3 = {
      doc: this.sliceDoc(),
      selection: this.selection.toJSON()
    };
    if (e28)
      for (let n3 in e28) {
        let i = e28[n3];
        i instanceof L$s && this.config.address[i.id] != null && (t3[n3] = i.spec.toJSON(this.field(e28[n3]), this));
      }
    return t3;
  }
  static fromJSON(e28, t3 = {}, n3) {
    if (!e28 || typeof e28.doc != "string")
      throw new RangeError("Invalid JSON representation for EditorState");
    let i = [];
    if (n3) {
      for (let s3 in n3)
        if (Object.prototype.hasOwnProperty.call(e28, s3)) {
          let r3 = n3[s3], h3 = e28[s3];
          i.push(r3.init((o3) => r3.spec.fromJSON(h3, o3)));
        }
    }
    return w$q.create({
      doc: e28.doc,
      selection: g$K.fromJSON(e28.selection),
      extensions: t3.extensions ? i.concat([t3.extensions]) : i
    });
  }
  static create(e28 = {}) {
    let t3 = Q$i.resolve(e28.extensions || [], /* @__PURE__ */ new Map()), n3 = e28.doc instanceof x$l ? e28.doc : x$l.of((e28.doc || "").split(t3.staticFacet(w$q.lineSeparator) || se$c)), i = e28.selection ? e28.selection instanceof g$K ? e28.selection : g$K.single(e28.selection.anchor, e28.selection.head) : g$K.single(0);
    return Te$9(i, n3.length), t3.staticFacet(Fe$6) || (i = i.asSingle()), new w$q(t3, n3, i, t3.dynamicSlots.map(() => null), (s3, r3) => r3.create(s3), null);
  }
  get tabSize() {
    return this.facet(w$q.tabSize);
  }
  get lineBreak() {
    return this.facet(w$q.lineSeparator) || `
`;
  }
  get readOnly() {
    return this.facet(De$4);
  }
  phrase(e28, ...t3) {
    for (let n3 of this.facet(w$q.phrases))
      if (Object.prototype.hasOwnProperty.call(n3, e28)) {
        e28 = n3[e28];
        break;
      }
    return t3.length && (e28 = e28.replace(/\$(\$|\d*)/g, (n3, i) => {
      if (i == "$")
        return "$";
      let s3 = +(i || 1);
      return !s3 || s3 > t3.length ? n3 : t3[s3 - 1];
    })), e28;
  }
  languageDataAt(e28, t3, n3 = -1) {
    let i = [];
    for (let s3 of this.facet(Me$6))
      for (let r3 of s3(this, t3, n3))
        Object.prototype.hasOwnProperty.call(r3, e28) && i.push(r3[e28]);
    return i;
  }
  charCategorizer(e28) {
    return it$6(this.languageDataAt("wordChars", e28).join(""));
  }
  wordAt(e28) {
    let { text: t3, from: n3, length: i } = this.doc.lineAt(e28), s3 = this.charCategorizer(e28), r3 = e28 - n3, h3 = e28 - n3;
    for (; r3 > 0; ) {
      let o3 = K$h(t3, r3, false);
      if (s3(t3.slice(o3, r3)) != T$x.Word)
        break;
      r3 = o3;
    }
    for (; h3 < i; ) {
      let o3 = K$h(t3, h3);
      if (s3(t3.slice(h3, o3)) != T$x.Word)
        break;
      h3 = o3;
    }
    return r3 == h3 ? null : g$K.range(r3 + n3, h3 + n3);
  }
}
w$q.allowMultipleSelections = Fe$6;
w$q.tabSize = /* @__PURE__ */ A$o.define({
  combine: (l3) => l3.length ? l3[0] : 4
});
w$q.lineSeparator = Je$5;
w$q.readOnly = De$4;
w$q.phrases = /* @__PURE__ */ A$o.define({
  compare(l3, e28) {
    let t3 = Object.keys(l3), n3 = Object.keys(e28);
    return t3.length == n3.length && t3.every((i) => l3[i] == e28[i]);
  }
});
w$q.languageData = Me$6;
w$q.changeFilter = Le$5;
w$q.transactionFilter = Ve$8;
w$q.transactionExtender = Ne$6;
ee$c.reconfigure = /* @__PURE__ */ S$m.define();
function ht$7(l3, e28, t3 = {}) {
  let n3 = {};
  for (let i of l3)
    for (let s3 of Object.keys(i)) {
      let r3 = i[s3], h3 = n3[s3];
      if (h3 === void 0)
        n3[s3] = r3;
      else if (!(h3 === r3 || r3 === void 0))
        if (Object.hasOwnProperty.call(t3, s3))
          n3[s3] = t3[s3](h3, r3);
        else
          throw new Error("Config merge conflict for field " + s3);
    }
  for (let i in e28)
    n3[i] === void 0 && (n3[i] = e28[i]);
  return n3;
}
class Y$h {
  eq(e28) {
    return this == e28;
  }
  range(e28, t3 = e28) {
    return z$j.create(e28, t3, this);
  }
}
Y$h.prototype.startSide = Y$h.prototype.endSide = 0;
Y$h.prototype.point = false;
Y$h.prototype.mapMode = C$I.TrackDel;
class z$j {
  constructor(e28, t3, n3) {
    this.from = e28, this.to = t3, this.value = n3;
  }
  static create(e28, t3, n3) {
    return new z$j(e28, t3, n3);
  }
}
function ue$c(l3, e28) {
  return l3.from - e28.from || l3.value.startSide - e28.value.startSide;
}
class pe$c {
  constructor(e28, t3, n3, i) {
    this.from = e28, this.to = t3, this.value = n3, this.maxPoint = i;
  }
  get length() {
    return this.to[this.to.length - 1];
  }
  findIndex(e28, t3, n3, i = 0) {
    let s3 = n3 ? this.to : this.from;
    for (let r3 = i, h3 = s3.length; ; ) {
      if (r3 == h3)
        return r3;
      let o3 = r3 + h3 >> 1, a3 = s3[o3] - e28 || (n3 ? this.value[o3].endSide : this.value[o3].startSide) - t3;
      if (o3 == r3)
        return a3 >= 0 ? r3 : h3;
      a3 >= 0 ? h3 = o3 : r3 = o3 + 1;
    }
  }
  between(e28, t3, n3, i) {
    for (let s3 = this.findIndex(t3, -1e9, true), r3 = this.findIndex(n3, 1e9, false, s3); s3 < r3; s3++)
      if (i(this.from[s3] + e28, this.to[s3] + e28, this.value[s3]) === false)
        return false;
  }
  map(e28, t3) {
    let n3 = [], i = [], s3 = [], r3 = -1, h3 = -1;
    for (let o3 = 0; o3 < this.value.length; o3++) {
      let a3 = this.value[o3], f3 = this.from[o3] + e28, u3 = this.to[o3] + e28, d3, c3;
      if (f3 == u3) {
        let p3 = t3.mapPos(f3, a3.startSide, a3.mapMode);
        if (p3 == null || (d3 = c3 = p3, a3.startSide != a3.endSide && (c3 = t3.mapPos(f3, a3.endSide), c3 < d3)))
          continue;
      } else if (d3 = t3.mapPos(f3, a3.startSide), c3 = t3.mapPos(u3, a3.endSide), d3 > c3 || d3 == c3 && a3.startSide > 0 && a3.endSide <= 0)
        continue;
      (c3 - d3 || a3.endSide - a3.startSide) < 0 || (r3 < 0 && (r3 = d3), a3.point && (h3 = Math.max(h3, c3 - d3)), n3.push(a3), i.push(d3 - r3), s3.push(c3 - r3));
    }
    return { mapped: n3.length ? new pe$c(i, s3, n3, h3) : null, pos: r3 };
  }
}
class P$F {
  constructor(e28, t3, n3, i) {
    this.chunkPos = e28, this.chunk = t3, this.nextLayer = n3, this.maxPoint = i;
  }
  static create(e28, t3, n3, i) {
    return new P$F(e28, t3, n3, i);
  }
  get length() {
    let e28 = this.chunk.length - 1;
    return e28 < 0 ? 0 : Math.max(this.chunkEnd(e28), this.nextLayer.length);
  }
  get size() {
    if (this.isEmpty)
      return 0;
    let e28 = this.nextLayer.size;
    for (let t3 of this.chunk)
      e28 += t3.value.length;
    return e28;
  }
  chunkEnd(e28) {
    return this.chunkPos[e28] + this.chunk[e28].length;
  }
  update(e28) {
    let { add: t3 = [], sort: n3 = false, filterFrom: i = 0, filterTo: s3 = this.length } = e28, r3 = e28.filter;
    if (t3.length == 0 && !r3)
      return this;
    if (n3 && (t3 = t3.slice().sort(ue$c)), this.isEmpty)
      return t3.length ? P$F.of(t3) : this;
    let h3 = new ze$7(this, null, -1).goto(0), o3 = 0, a3 = [], f3 = new _$n();
    for (; h3.value || o3 < t3.length; )
      if (o3 < t3.length && (h3.from - t3[o3].from || h3.startSide - t3[o3].value.startSide) >= 0) {
        let u3 = t3[o3++];
        f3.addInner(u3.from, u3.to, u3.value) || a3.push(u3);
      } else
        h3.rangeIndex == 1 && h3.chunkIndex < this.chunk.length && (o3 == t3.length || this.chunkEnd(h3.chunkIndex) < t3[o3].from) && (!r3 || i > this.chunkEnd(h3.chunkIndex) || s3 < this.chunkPos[h3.chunkIndex]) && f3.addChunk(this.chunkPos[h3.chunkIndex], this.chunk[h3.chunkIndex]) ? h3.nextChunk() : ((!r3 || i > h3.to || s3 < h3.from || r3(h3.from, h3.to, h3.value)) && (f3.addInner(h3.from, h3.to, h3.value) || a3.push(z$j.create(h3.from, h3.to, h3.value))), h3.next());
    return f3.finishInner(this.nextLayer.isEmpty && !a3.length ? P$F.empty : this.nextLayer.update({ add: a3, filter: r3, filterFrom: i, filterTo: s3 }));
  }
  map(e28) {
    if (e28.empty || this.isEmpty)
      return this;
    let t3 = [], n3 = [], i = -1;
    for (let r3 = 0; r3 < this.chunk.length; r3++) {
      let h3 = this.chunkPos[r3], o3 = this.chunk[r3], a3 = e28.touchesRange(h3, h3 + o3.length);
      if (a3 === false)
        i = Math.max(i, o3.maxPoint), t3.push(o3), n3.push(e28.mapPos(h3));
      else if (a3 === true) {
        let { mapped: f3, pos: u3 } = o3.map(h3, e28);
        f3 && (i = Math.max(i, f3.maxPoint), t3.push(f3), n3.push(u3));
      }
    }
    let s3 = this.nextLayer.map(e28);
    return t3.length == 0 ? s3 : new P$F(n3, t3, s3 || P$F.empty, i);
  }
  between(e28, t3, n3) {
    if (!this.isEmpty) {
      for (let i = 0; i < this.chunk.length; i++) {
        let s3 = this.chunkPos[i], r3 = this.chunk[i];
        if (t3 >= s3 && e28 <= s3 + r3.length && r3.between(s3, e28 - s3, t3 - s3, n3) === false)
          return;
      }
      this.nextLayer.between(e28, t3, n3);
    }
  }
  iter(e28 = 0) {
    return W$g.from([this]).goto(e28);
  }
  get isEmpty() {
    return this.nextLayer == this;
  }
  static iter(e28, t3 = 0) {
    return W$g.from(e28).goto(t3);
  }
  static compare(e28, t3, n3, i, s3 = -1) {
    let r3 = e28.filter((u3) => u3.maxPoint > 0 || !u3.isEmpty && u3.maxPoint >= s3), h3 = t3.filter((u3) => u3.maxPoint > 0 || !u3.isEmpty && u3.maxPoint >= s3), o3 = Se$8(r3, h3, n3), a3 = new N$x(r3, o3, s3), f3 = new N$x(h3, o3, s3);
    n3.iterGaps((u3, d3, c3) => Ie$7(a3, u3, f3, d3, c3, i)), n3.empty && n3.length == 0 && Ie$7(a3, 0, f3, 0, 0, i);
  }
  static eq(e28, t3, n3 = 0, i) {
    i == null && (i = 1e9 - 1);
    let s3 = e28.filter((f3) => !f3.isEmpty && t3.indexOf(f3) < 0), r3 = t3.filter((f3) => !f3.isEmpty && e28.indexOf(f3) < 0);
    if (s3.length != r3.length)
      return false;
    if (!s3.length)
      return true;
    let h3 = Se$8(s3, r3), o3 = new N$x(s3, h3, 0).goto(n3), a3 = new N$x(r3, h3, 0).goto(n3);
    for (; ; ) {
      if (o3.to != a3.to || !ce$a(o3.active, a3.active) || o3.point && (!a3.point || !o3.point.eq(a3.point)))
        return false;
      if (o3.to > i)
        return true;
      o3.next(), a3.next();
    }
  }
  static spans(e28, t3, n3, i, s3 = -1) {
    let r3 = new N$x(e28, null, s3).goto(t3), h3 = t3, o3 = r3.openStart;
    for (; ; ) {
      let a3 = Math.min(r3.to, n3);
      if (r3.point) {
        let f3 = r3.activeForPoint(r3.to), u3 = r3.pointFrom < t3 ? f3.length + 1 : Math.min(f3.length, o3);
        i.point(h3, a3, r3.point, f3, u3, r3.pointRank), o3 = Math.min(r3.openEnd(a3), f3.length);
      } else
        a3 > h3 && (i.span(h3, a3, r3.active, o3), o3 = r3.openEnd(a3));
      if (r3.to > n3)
        return o3 + (r3.point && r3.to > n3 ? 1 : 0);
      h3 = r3.to, r3.next();
    }
  }
  static of(e28, t3 = false) {
    let n3 = new _$n();
    for (let i of e28 instanceof z$j ? [e28] : t3 ? st$7(e28) : e28)
      n3.add(i.from, i.to, i.value);
    return n3.finish();
  }
}
P$F.empty = /* @__PURE__ */ new P$F([], [], null, -1);
function st$7(l3) {
  if (l3.length > 1)
    for (let e28 = l3[0], t3 = 1; t3 < l3.length; t3++) {
      let n3 = l3[t3];
      if (ue$c(e28, n3) > 0)
        return l3.slice().sort(ue$c);
      e28 = n3;
    }
  return l3;
}
P$F.empty.nextLayer = P$F.empty;
class _$n {
  finishChunk(e28) {
    this.chunks.push(new pe$c(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, e28 && (this.from = [], this.to = [], this.value = []);
  }
  constructor() {
    this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1e9, this.lastTo = -1e9, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
  }
  add(e28, t3, n3) {
    this.addInner(e28, t3, n3) || (this.nextLayer || (this.nextLayer = new _$n())).add(e28, t3, n3);
  }
  addInner(e28, t3, n3) {
    let i = e28 - this.lastTo || n3.startSide - this.last.endSide;
    if (i <= 0 && (e28 - this.lastFrom || n3.startSide - this.last.startSide) < 0)
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    return i < 0 ? false : (this.from.length == 250 && this.finishChunk(true), this.chunkStart < 0 && (this.chunkStart = e28), this.from.push(e28 - this.chunkStart), this.to.push(t3 - this.chunkStart), this.last = n3, this.lastFrom = e28, this.lastTo = t3, this.value.push(n3), n3.point && (this.maxPoint = Math.max(this.maxPoint, t3 - e28)), true);
  }
  addChunk(e28, t3) {
    if ((e28 - this.lastTo || t3.value[0].startSide - this.last.endSide) < 0)
      return false;
    this.from.length && this.finishChunk(true), this.setMaxPoint = Math.max(this.setMaxPoint, t3.maxPoint), this.chunks.push(t3), this.chunkPos.push(e28);
    let n3 = t3.value.length - 1;
    return this.last = t3.value[n3], this.lastFrom = t3.from[n3] + e28, this.lastTo = t3.to[n3] + e28, true;
  }
  finish() {
    return this.finishInner(P$F.empty);
  }
  finishInner(e28) {
    if (this.from.length && this.finishChunk(false), this.chunks.length == 0)
      return e28;
    let t3 = P$F.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(e28) : e28, this.setMaxPoint);
    return this.from = null, t3;
  }
}
function Se$8(l3, e28, t3) {
  let n3 = /* @__PURE__ */ new Map();
  for (let s3 of l3)
    for (let r3 = 0; r3 < s3.chunk.length; r3++)
      s3.chunk[r3].maxPoint <= 0 && n3.set(s3.chunk[r3], s3.chunkPos[r3]);
  let i = /* @__PURE__ */ new Set();
  for (let s3 of e28)
    for (let r3 = 0; r3 < s3.chunk.length; r3++) {
      let h3 = n3.get(s3.chunk[r3]);
      h3 != null && (t3 ? t3.mapPos(h3) : h3) == s3.chunkPos[r3] && !(t3 != null && t3.touchesRange(h3, h3 + s3.chunk[r3].length)) && i.add(s3.chunk[r3]);
    }
  return i;
}
class ze$7 {
  constructor(e28, t3, n3, i = 0) {
    this.layer = e28, this.skip = t3, this.minPoint = n3, this.rank = i;
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  get endSide() {
    return this.value ? this.value.endSide : 0;
  }
  goto(e28, t3 = -1e9) {
    return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(e28, t3, false), this;
  }
  gotoInner(e28, t3, n3) {
    for (; this.chunkIndex < this.layer.chunk.length; ) {
      let i = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(i) || this.layer.chunkEnd(this.chunkIndex) < e28 || i.maxPoint < this.minPoint))
        break;
      this.chunkIndex++, n3 = false;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      let i = this.layer.chunk[this.chunkIndex].findIndex(e28 - this.layer.chunkPos[this.chunkIndex], t3, true);
      (!n3 || this.rangeIndex < i) && this.setRangeIndex(i);
    }
    this.next();
  }
  forward(e28, t3) {
    (this.to - e28 || this.endSide - t3) < 0 && this.gotoInner(e28, t3, true);
  }
  next() {
    for (; ; )
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9, this.value = null;
        break;
      } else {
        let e28 = this.layer.chunkPos[this.chunkIndex], t3 = this.layer.chunk[this.chunkIndex], n3 = e28 + t3.from[this.rangeIndex];
        if (this.from = n3, this.to = e28 + t3.to[this.rangeIndex], this.value = t3.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint)
          break;
      }
  }
  setRangeIndex(e28) {
    if (e28 == this.layer.chunk[this.chunkIndex].value.length) {
      if (this.chunkIndex++, this.skip)
        for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]); )
          this.chunkIndex++;
      this.rangeIndex = 0;
    } else
      this.rangeIndex = e28;
  }
  nextChunk() {
    this.chunkIndex++, this.rangeIndex = 0, this.next();
  }
  compare(e28) {
    return this.from - e28.from || this.startSide - e28.startSide || this.rank - e28.rank || this.to - e28.to || this.endSide - e28.endSide;
  }
}
class W$g {
  constructor(e28) {
    this.heap = e28;
  }
  static from(e28, t3 = null, n3 = -1) {
    let i = [];
    for (let s3 = 0; s3 < e28.length; s3++)
      for (let r3 = e28[s3]; !r3.isEmpty; r3 = r3.nextLayer)
        r3.maxPoint >= n3 && i.push(new ze$7(r3, t3, n3, s3));
    return i.length == 1 ? i[0] : new W$g(i);
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  goto(e28, t3 = -1e9) {
    for (let n3 of this.heap)
      n3.goto(e28, t3);
    for (let n3 = this.heap.length >> 1; n3 >= 0; n3--)
      ie$c(this.heap, n3);
    return this.next(), this;
  }
  forward(e28, t3) {
    for (let n3 of this.heap)
      n3.forward(e28, t3);
    for (let n3 = this.heap.length >> 1; n3 >= 0; n3--)
      ie$c(this.heap, n3);
    (this.to - e28 || this.value.endSide - t3) < 0 && this.next();
  }
  next() {
    if (this.heap.length == 0)
      this.from = this.to = 1e9, this.value = null, this.rank = -1;
    else {
      let e28 = this.heap[0];
      this.from = e28.from, this.to = e28.to, this.value = e28.value, this.rank = e28.rank, e28.value && e28.next(), ie$c(this.heap, 0);
    }
  }
}
function ie$c(l3, e28) {
  for (let t3 = l3[e28]; ; ) {
    let n3 = (e28 << 1) + 1;
    if (n3 >= l3.length)
      break;
    let i = l3[n3];
    if (n3 + 1 < l3.length && i.compare(l3[n3 + 1]) >= 0 && (i = l3[n3 + 1], n3++), t3.compare(i) < 0)
      break;
    l3[n3] = t3, l3[e28] = i, e28 = n3;
  }
}
class N$x {
  constructor(e28, t3, n3) {
    this.minPoint = n3, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = W$g.from(e28, t3, n3);
  }
  goto(e28, t3 = -1e9) {
    return this.cursor.goto(e28, t3), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = e28, this.endSide = t3, this.openStart = -1, this.next(), this;
  }
  forward(e28, t3) {
    for (; this.minActive > -1 && (this.activeTo[this.minActive] - e28 || this.active[this.minActive].endSide - t3) < 0; )
      this.removeActive(this.minActive);
    this.cursor.forward(e28, t3);
  }
  removeActive(e28) {
    G$l(this.active, e28), G$l(this.activeTo, e28), G$l(this.activeRank, e28), this.minActive = Ae$7(this.active, this.activeTo);
  }
  addActive(e28) {
    let t3 = 0, { value: n3, to: i, rank: s3 } = this.cursor;
    for (; t3 < this.activeRank.length && this.activeRank[t3] <= s3; )
      t3++;
    H$i(this.active, t3, n3), H$i(this.activeTo, t3, i), H$i(this.activeRank, t3, s3), e28 && H$i(e28, t3, this.cursor.from), this.minActive = Ae$7(this.active, this.activeTo);
  }
  next() {
    let e28 = this.to, t3 = this.point;
    this.point = null;
    let n3 = this.openStart < 0 ? [] : null;
    for (; ; ) {
      let i = this.minActive;
      if (i > -1 && (this.activeTo[i] - this.cursor.from || this.active[i].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[i] > e28) {
          this.to = this.activeTo[i], this.endSide = this.active[i].endSide;
          break;
        }
        this.removeActive(i), n3 && G$l(n3, i);
      } else if (this.cursor.value)
        if (this.cursor.from > e28) {
          this.to = this.cursor.from, this.endSide = this.cursor.startSide;
          break;
        } else {
          let s3 = this.cursor.value;
          if (!s3.point)
            this.addActive(n3), this.cursor.next();
          else if (t3 && this.cursor.to == this.to && this.cursor.from < this.cursor.to)
            this.cursor.next();
          else {
            this.point = s3, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = s3.endSide, this.cursor.next(), this.forward(this.to, this.endSide);
            break;
          }
        }
      else {
        this.to = this.endSide = 1e9;
        break;
      }
    }
    if (n3) {
      this.openStart = 0;
      for (let i = n3.length - 1; i >= 0 && n3[i] < e28; i--)
        this.openStart++;
    }
  }
  activeForPoint(e28) {
    if (!this.active.length)
      return this.active;
    let t3 = [];
    for (let n3 = this.active.length - 1; n3 >= 0 && !(this.activeRank[n3] < this.pointRank); n3--)
      (this.activeTo[n3] > e28 || this.activeTo[n3] == e28 && this.active[n3].endSide >= this.point.endSide) && t3.push(this.active[n3]);
    return t3.reverse();
  }
  openEnd(e28) {
    let t3 = 0;
    for (let n3 = this.activeTo.length - 1; n3 >= 0 && this.activeTo[n3] > e28; n3--)
      t3++;
    return t3;
  }
}
function Ie$7(l3, e28, t3, n3, i, s3) {
  l3.goto(e28), t3.goto(n3);
  let r3 = n3 + i, h3 = n3, o3 = n3 - e28;
  for (; ; ) {
    let a3 = l3.to + o3 - t3.to || l3.endSide - t3.endSide, f3 = a3 < 0 ? l3.to + o3 : t3.to, u3 = Math.min(f3, r3);
    if (l3.point || t3.point ? l3.point && t3.point && (l3.point == t3.point || l3.point.eq(t3.point)) && ce$a(l3.activeForPoint(l3.to), t3.activeForPoint(t3.to)) || s3.comparePoint(h3, u3, l3.point, t3.point) : u3 > h3 && !ce$a(l3.active, t3.active) && s3.compareRange(h3, u3, l3.active, t3.active), f3 > r3)
      break;
    h3 = f3, a3 <= 0 && l3.next(), a3 >= 0 && t3.next();
  }
}
function ce$a(l3, e28) {
  if (l3.length != e28.length)
    return false;
  for (let t3 = 0; t3 < l3.length; t3++)
    if (l3[t3] != e28[t3] && !l3[t3].eq(e28[t3]))
      return false;
  return true;
}
function G$l(l3, e28) {
  for (let t3 = e28, n3 = l3.length - 1; t3 < n3; t3++)
    l3[t3] = l3[t3 + 1];
  l3.pop();
}
function H$i(l3, e28, t3) {
  for (let n3 = l3.length - 1; n3 >= e28; n3--)
    l3[n3 + 1] = l3[n3];
  l3[e28] = t3;
}
function Ae$7(l3, e28) {
  let t3 = -1, n3 = 1e9;
  for (let i = 0; i < e28.length; i++)
    (e28[i] - n3 || l3[i].endSide - l3[t3].endSide) < 0 && (t3 = i, n3 = e28[i]);
  return t3;
}
function ot$6(l3, e28, t3 = l3.length) {
  let n3 = 0;
  for (let i = 0; i < t3; )
    l3.charCodeAt(i) == 9 ? (n3 += e28 - n3 % e28, i++) : (n3++, i = K$h(l3, i));
  return n3;
}
function at$5(l3, e28, t3, n3) {
  for (let i = 0, s3 = 0; ; ) {
    if (s3 >= e28)
      return i;
    if (i == l3.length)
      break;
    s3 += l3.charCodeAt(i) == 9 ? t3 - s3 % t3 : 1, i = K$h(l3, i);
  }
  return n3 === true ? -1 : l3.length;
}
const y$A = "\u037C", m$1h = typeof Symbol > "u" ? "__" + y$A : Symbol.for(y$A), S$l = typeof Symbol > "u" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet"), g$J = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : {};
class C$H {
  constructor(e28, n3) {
    this.rules = [];
    let { finish: i } = n3 || {};
    function s3(t3) {
      return /^@/.test(t3) ? [t3] : t3.split(/,\s*/);
    }
    function l3(t3, h3, a3, T3) {
      let f3 = [], r3 = /^@(\w+)\b/.exec(t3[0]), c3 = r3 && r3[1] == "keyframes";
      if (r3 && h3 == null)
        return a3.push(t3[0] + ";");
      for (let u3 in h3) {
        let o3 = h3[u3];
        if (/&/.test(u3))
          l3(u3.split(/,\s*/).map((d3) => t3.map((p3) => d3.replace(/&/, p3))).reduce((d3, p3) => d3.concat(p3)), o3, a3);
        else if (o3 && typeof o3 == "object") {
          if (!r3)
            throw new RangeError("The value of a property (" + u3 + ") should be a primitive value.");
          l3(s3(u3), o3, f3, c3);
        } else
          o3 != null && f3.push(u3.replace(/_.*/, "").replace(/[A-Z]/g, (d3) => "-" + d3.toLowerCase()) + ": " + o3 + ";");
      }
      (f3.length || c3) && a3.push((i && !r3 && !T3 ? t3.map(i) : t3).join(", ") + " {" + f3.join(" ") + "}");
    }
    for (let t3 in e28)
      l3(s3(t3), e28[t3], this.rules);
  }
  getRules() {
    return this.rules.join(`
`);
  }
  static newName() {
    let e28 = g$J[m$1h] || 1;
    return g$J[m$1h] = e28 + 1, y$A + e28.toString(36);
  }
  static mount(e28, n3, i) {
    let s3 = e28[S$l], l3 = i && i.nonce;
    s3 ? l3 && s3.setNonce(l3) : s3 = new A$n(e28, l3), s3.mount(Array.isArray(n3) ? n3 : [n3]);
  }
}
let w$p = /* @__PURE__ */ new Map();
class A$n {
  constructor(e28, n3) {
    let i = e28.ownerDocument || e28, s3 = i.defaultView;
    if (!e28.head && e28.adoptedStyleSheets && s3.CSSStyleSheet) {
      let l3 = w$p.get(i);
      if (l3)
        return e28.adoptedStyleSheets = [l3.sheet, ...e28.adoptedStyleSheets], e28[S$l] = l3;
      this.sheet = new s3.CSSStyleSheet(), e28.adoptedStyleSheets = [this.sheet, ...e28.adoptedStyleSheets], w$p.set(i, this);
    } else {
      this.styleTag = i.createElement("style"), n3 && this.styleTag.setAttribute("nonce", n3);
      let l3 = e28.head || e28;
      l3.insertBefore(this.styleTag, l3.firstChild);
    }
    this.modules = [], e28[S$l] = this;
  }
  mount(e28) {
    let n3 = this.sheet, i = 0, s3 = 0;
    for (let l3 = 0; l3 < e28.length; l3++) {
      let t3 = e28[l3], h3 = this.modules.indexOf(t3);
      if (h3 < s3 && h3 > -1 && (this.modules.splice(h3, 1), s3--, h3 = -1), h3 == -1) {
        if (this.modules.splice(s3++, 0, t3), n3)
          for (let a3 = 0; a3 < t3.rules.length; a3++)
            n3.insertRule(t3.rules[a3], i++);
      } else {
        for (; s3 < h3; )
          i += this.modules[s3++].rules.length;
        i += t3.rules.length, s3++;
      }
    }
    if (!n3) {
      let l3 = "";
      for (let t3 = 0; t3 < this.modules.length; t3++)
        l3 += this.modules[t3].getRules() + `
`;
      this.styleTag.textContent = l3;
    }
  }
  setNonce(e28) {
    this.styleTag && this.styleTag.getAttribute("nonce") != e28 && this.styleTag.setAttribute("nonce", e28);
  }
}
var t$M = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, a$15 = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, n$K = typeof navigator < "u" && /Mac/.test(navigator.platform), y$z = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var r$W = 0; r$W < 10; r$W++)
  t$M[48 + r$W] = t$M[96 + r$W] = String(r$W);
for (var r$W = 1; r$W <= 24; r$W++)
  t$M[r$W + 111] = "F" + r$W;
for (var r$W = 65; r$W <= 90; r$W++)
  t$M[r$W] = String.fromCharCode(r$W + 32), a$15[r$W] = String.fromCharCode(r$W);
for (var i$X in t$M)
  a$15.hasOwnProperty(i$X) || (a$15[i$X] = t$M[i$X]);
function g$I(o3) {
  var f3 = n$K && o3.metaKey && o3.shiftKey && !o3.ctrlKey && !o3.altKey || y$z && o3.shiftKey && o3.key && o3.key.length == 1 || o3.key == "Unidentified", e28 = !f3 && o3.key || (o3.shiftKey ? a$15 : t$M)[o3.keyCode] || o3.key || "Unidentified";
  return e28 == "Esc" && (e28 = "Escape"), e28 == "Del" && (e28 = "Delete"), e28 == "Left" && (e28 = "ArrowLeft"), e28 == "Up" && (e28 = "ArrowUp"), e28 == "Right" && (e28 = "ArrowRight"), e28 == "Down" && (e28 = "ArrowDown"), e28;
}
function ne$d(n3) {
  let t3;
  return n3.nodeType == 11 ? t3 = n3.getSelection ? n3 : n3.ownerDocument : t3 = n3, t3.getSelection();
}
function Ce$8(n3, t3) {
  return t3 ? n3 == t3 || n3.contains(t3.nodeType != 1 ? t3.parentNode : t3) : false;
}
function pn$2(n3) {
  let t3 = n3.activeElement;
  for (; t3 && t3.shadowRoot; )
    t3 = t3.shadowRoot.activeElement;
  return t3;
}
function Zt$3(n3, t3) {
  if (!t3.anchorNode)
    return false;
  try {
    return Ce$8(n3, t3.anchorNode);
  } catch {
    return false;
  }
}
function Rt$5(n3) {
  return n3.nodeType == 3 ? ft$5(n3, 0, n3.nodeValue.length).getClientRects() : n3.nodeType == 1 ? n3.getClientRects() : [];
}
function re$a(n3, t3, e28, i) {
  return e28 ? ti$2(n3, t3, e28, i, -1) || ti$2(n3, t3, e28, i, 1) : false;
}
function Lt$4(n3) {
  for (var t3 = 0; ; t3++)
    if (n3 = n3.previousSibling, !n3)
      return t3;
}
function ti$2(n3, t3, e28, i, s3) {
  for (; ; ) {
    if (n3 == e28 && t3 == i)
      return true;
    if (t3 == (s3 < 0 ? 0 : J$g(n3))) {
      if (n3.nodeName == "DIV")
        return false;
      let r3 = n3.parentNode;
      if (!r3 || r3.nodeType != 1)
        return false;
      t3 = Lt$4(n3) + (s3 < 0 ? 0 : 1), n3 = r3;
    } else if (n3.nodeType == 1) {
      if (n3 = n3.childNodes[t3 + (s3 < 0 ? -1 : 0)], n3.nodeType == 1 && n3.contentEditable == "false")
        return false;
      t3 = s3 < 0 ? J$g(n3) : 0;
    } else
      return false;
  }
}
function J$g(n3) {
  return n3.nodeType == 3 ? n3.nodeValue.length : n3.childNodes.length;
}
function Ge$5(n3, t3) {
  let e28 = t3 ? n3.left : n3.right;
  return { left: e28, right: e28, top: n3.top, bottom: n3.bottom };
}
function mn$1(n3) {
  return {
    left: 0,
    right: n3.innerWidth,
    top: 0,
    bottom: n3.innerHeight
  };
}
function bn$2(n3, t3, e28, i, s3, r3, o3, l3) {
  let h3 = n3.ownerDocument, c3 = h3.defaultView || window;
  for (let a3 = n3, f3 = false; a3 && !f3; )
    if (a3.nodeType == 1) {
      let d3, u3 = a3 == h3.body, g3 = 1, m3 = 1;
      if (u3)
        d3 = mn$1(c3);
      else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(a3).position) && (f3 = true), a3.scrollHeight <= a3.clientHeight && a3.scrollWidth <= a3.clientWidth) {
          a3 = a3.assignedSlot || a3.parentNode;
          continue;
        }
        let v3 = a3.getBoundingClientRect();
        g3 = v3.width / a3.offsetWidth, m3 = v3.height / a3.offsetHeight, d3 = {
          left: v3.left,
          right: v3.left + a3.clientWidth * g3,
          top: v3.top,
          bottom: v3.top + a3.clientHeight * m3
        };
      }
      let p3 = 0, b3 = 0;
      if (s3 == "nearest")
        t3.top < d3.top ? (b3 = -(d3.top - t3.top + o3), e28 > 0 && t3.bottom > d3.bottom + b3 && (b3 = t3.bottom - d3.bottom + b3 + o3)) : t3.bottom > d3.bottom && (b3 = t3.bottom - d3.bottom + o3, e28 < 0 && t3.top - b3 < d3.top && (b3 = -(d3.top + b3 - t3.top + o3)));
      else {
        let v3 = t3.bottom - t3.top, x3 = d3.bottom - d3.top;
        b3 = (s3 == "center" && v3 <= x3 ? t3.top + v3 / 2 - x3 / 2 : s3 == "start" || s3 == "center" && e28 < 0 ? t3.top - o3 : t3.bottom - x3 + o3) - d3.top;
      }
      if (i == "nearest" ? t3.left < d3.left ? (p3 = -(d3.left - t3.left + r3), e28 > 0 && t3.right > d3.right + p3 && (p3 = t3.right - d3.right + p3 + r3)) : t3.right > d3.right && (p3 = t3.right - d3.right + r3, e28 < 0 && t3.left < d3.left + p3 && (p3 = -(d3.left + p3 - t3.left + r3))) : p3 = (i == "center" ? t3.left + (t3.right - t3.left) / 2 - (d3.right - d3.left) / 2 : i == "start" == l3 ? t3.left - r3 : t3.right - (d3.right - d3.left) + r3) - d3.left, p3 || b3)
        if (u3)
          c3.scrollBy(p3, b3);
        else {
          let v3 = 0, x3 = 0;
          if (b3) {
            let y3 = a3.scrollTop;
            a3.scrollTop += b3 / m3, x3 = (a3.scrollTop - y3) * m3;
          }
          if (p3) {
            let y3 = a3.scrollLeft;
            a3.scrollLeft += p3 / g3, v3 = (a3.scrollLeft - y3) * g3;
          }
          t3 = {
            left: t3.left - v3,
            top: t3.top - x3,
            right: t3.right - v3,
            bottom: t3.bottom - x3
          }, v3 && Math.abs(v3 - p3) < 1 && (i = "nearest"), x3 && Math.abs(x3 - b3) < 1 && (s3 = "nearest");
        }
      if (u3)
        break;
      a3 = a3.assignedSlot || a3.parentNode;
    } else if (a3.nodeType == 11)
      a3 = a3.host;
    else
      break;
}
function wn$1(n3) {
  let t3 = n3.ownerDocument;
  for (let e28 = n3.parentNode; e28 && e28 != t3.body; )
    if (e28.nodeType == 1) {
      if (e28.scrollHeight > e28.clientHeight || e28.scrollWidth > e28.clientWidth)
        return e28;
      e28 = e28.assignedSlot || e28.parentNode;
    } else if (e28.nodeType == 11)
      e28 = e28.host;
    else
      break;
  return null;
}
class yn$2 {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  eq(t3) {
    return this.anchorNode == t3.anchorNode && this.anchorOffset == t3.anchorOffset && this.focusNode == t3.focusNode && this.focusOffset == t3.focusOffset;
  }
  setRange(t3) {
    let { anchorNode: e28, focusNode: i } = t3;
    this.set(e28, Math.min(t3.anchorOffset, e28 ? J$g(e28) : 0), i, Math.min(t3.focusOffset, i ? J$g(i) : 0));
  }
  set(t3, e28, i, s3) {
    this.anchorNode = t3, this.anchorOffset = e28, this.focusNode = i, this.focusOffset = s3;
  }
}
let ut$5 = null;
function ts$1(n3) {
  if (n3.setActive)
    return n3.setActive();
  if (ut$5)
    return n3.focus(ut$5);
  let t3 = [];
  for (let e28 = n3; e28 && (t3.push(e28, e28.scrollTop, e28.scrollLeft), e28 != e28.ownerDocument); e28 = e28.parentNode)
    ;
  if (n3.focus(ut$5 == null ? {
    get preventScroll() {
      return ut$5 = { preventScroll: true }, true;
    }
  } : void 0), !ut$5) {
    ut$5 = false;
    for (let e28 = 0; e28 < t3.length; ) {
      let i = t3[e28++], s3 = t3[e28++], r3 = t3[e28++];
      i.scrollTop != s3 && (i.scrollTop = s3), i.scrollLeft != r3 && (i.scrollLeft = r3);
    }
  }
}
let ei$2;
function ft$5(n3, t3, e28 = t3) {
  let i = ei$2 || (ei$2 = document.createRange());
  return i.setEnd(n3, e28), i.setStart(n3, t3), i;
}
function bt$5(n3, t3, e28) {
  let i = { key: t3, code: t3, keyCode: e28, which: e28, cancelable: true }, s3 = new KeyboardEvent("keydown", i);
  s3.synthetic = true, n3.dispatchEvent(s3);
  let r3 = new KeyboardEvent("keyup", i);
  return r3.synthetic = true, n3.dispatchEvent(r3), s3.defaultPrevented || r3.defaultPrevented;
}
function vn$2(n3) {
  for (; n3; ) {
    if (n3 && (n3.nodeType == 9 || n3.nodeType == 11 && n3.host))
      return n3;
    n3 = n3.assignedSlot || n3.parentNode;
  }
  return null;
}
function es$1(n3) {
  for (; n3.attributes.length; )
    n3.removeAttributeNode(n3.attributes[0]);
}
function Sn$1(n3, t3) {
  let e28 = t3.focusNode, i = t3.focusOffset;
  if (!e28 || t3.anchorNode != e28 || t3.anchorOffset != i)
    return false;
  for (i = Math.min(i, J$g(e28)); ; )
    if (i) {
      if (e28.nodeType != 1)
        return false;
      let s3 = e28.childNodes[i - 1];
      s3.contentEditable == "false" ? i-- : (e28 = s3, i = J$g(e28));
    } else {
      if (e28 == n3)
        return true;
      i = Lt$4(e28), e28 = e28.parentNode;
    }
}
function is$1(n3) {
  return n3.scrollTop > Math.max(1, n3.scrollHeight - n3.clientHeight - 4);
}
class H$h {
  constructor(t3, e28, i = true) {
    this.node = t3, this.offset = e28, this.precise = i;
  }
  static before(t3, e28) {
    return new H$h(t3.parentNode, Lt$4(t3), e28);
  }
  static after(t3, e28) {
    return new H$h(t3.parentNode, Lt$4(t3) + 1, e28);
  }
}
const _e$9 = [];
class T$w {
  constructor() {
    this.parent = null, this.dom = null, this.flags = 2;
  }
  get overrideDOMText() {
    return null;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(t3) {
    let e28 = this.posAtStart;
    for (let i of this.children) {
      if (i == t3)
        return e28;
      e28 += i.length + i.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(t3) {
    return this.posBefore(t3) + t3.length;
  }
  sync(t3, e28) {
    if (this.flags & 2) {
      let i = this.dom, s3 = null, r3;
      for (let o3 of this.children) {
        if (o3.flags & 7) {
          if (!o3.dom && (r3 = s3 ? s3.nextSibling : i.firstChild)) {
            let l3 = T$w.get(r3);
            (!l3 || !l3.parent && l3.canReuseDOM(o3)) && o3.reuseDOM(r3);
          }
          o3.sync(t3, e28), o3.flags &= -8;
        }
        if (r3 = s3 ? s3.nextSibling : i.firstChild, e28 && !e28.written && e28.node == i && r3 != o3.dom && (e28.written = true), o3.dom.parentNode == i)
          for (; r3 && r3 != o3.dom; )
            r3 = ii$2(r3);
        else
          i.insertBefore(o3.dom, r3);
        s3 = o3.dom;
      }
      for (r3 = s3 ? s3.nextSibling : i.firstChild, r3 && e28 && e28.node == i && (e28.written = true); r3; )
        r3 = ii$2(r3);
    } else if (this.flags & 1)
      for (let i of this.children)
        i.flags & 7 && (i.sync(t3, e28), i.flags &= -8);
  }
  reuseDOM(t3) {
  }
  localPosFromDOM(t3, e28) {
    let i;
    if (t3 == this.dom)
      i = this.dom.childNodes[e28];
    else {
      let s3 = J$g(t3) == 0 ? 0 : e28 == 0 ? -1 : 1;
      for (; ; ) {
        let r3 = t3.parentNode;
        if (r3 == this.dom)
          break;
        s3 == 0 && r3.firstChild != r3.lastChild && (t3 == r3.firstChild ? s3 = -1 : s3 = 1), t3 = r3;
      }
      s3 < 0 ? i = t3 : i = t3.nextSibling;
    }
    if (i == this.dom.firstChild)
      return 0;
    for (; i && !T$w.get(i); )
      i = i.nextSibling;
    if (!i)
      return this.length;
    for (let s3 = 0, r3 = 0; ; s3++) {
      let o3 = this.children[s3];
      if (o3.dom == i)
        return r3;
      r3 += o3.length + o3.breakAfter;
    }
  }
  domBoundsAround(t3, e28, i = 0) {
    let s3 = -1, r3 = -1, o3 = -1, l3 = -1;
    for (let h3 = 0, c3 = i, a3 = i; h3 < this.children.length; h3++) {
      let f3 = this.children[h3], d3 = c3 + f3.length;
      if (c3 < t3 && d3 > e28)
        return f3.domBoundsAround(t3, e28, c3);
      if (d3 >= t3 && s3 == -1 && (s3 = h3, r3 = c3), c3 > e28 && f3.dom.parentNode == this.dom) {
        o3 = h3, l3 = a3;
        break;
      }
      a3 = d3, c3 = d3 + f3.breakAfter;
    }
    return {
      from: r3,
      to: l3 < 0 ? i + this.length : l3,
      startDOM: (s3 ? this.children[s3 - 1].dom.nextSibling : null) || this.dom.firstChild,
      endDOM: o3 < this.children.length && o3 >= 0 ? this.children[o3].dom : null
    };
  }
  markDirty(t3 = false) {
    this.flags |= 2, this.markParentsDirty(t3);
  }
  markParentsDirty(t3) {
    for (let e28 = this.parent; e28; e28 = e28.parent) {
      if (t3 && (e28.flags |= 2), e28.flags & 1)
        return;
      e28.flags |= 1, t3 = false;
    }
  }
  setParent(t3) {
    this.parent != t3 && (this.parent = t3, this.flags & 7 && this.markParentsDirty(true));
  }
  setDOM(t3) {
    this.dom != t3 && (this.dom && (this.dom.cmView = null), this.dom = t3, t3.cmView = this);
  }
  get rootView() {
    for (let t3 = this; ; ) {
      let e28 = t3.parent;
      if (!e28)
        return t3;
      t3 = e28;
    }
  }
  replaceChildren(t3, e28, i = _e$9) {
    this.markDirty();
    for (let s3 = t3; s3 < e28; s3++) {
      let r3 = this.children[s3];
      r3.parent == this && r3.destroy();
    }
    this.children.splice(t3, e28 - t3, ...i);
    for (let s3 = 0; s3 < i.length; s3++)
      i[s3].setParent(this);
  }
  ignoreMutation(t3) {
    return false;
  }
  ignoreEvent(t3) {
    return false;
  }
  childCursor(t3 = this.length) {
    return new ss$2(this.children, t3, this.children.length);
  }
  childPos(t3, e28 = 1) {
    return this.childCursor().findPos(t3, e28);
  }
  toString() {
    let t3 = this.constructor.name.replace("View", "");
    return t3 + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (t3 == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  }
  static get(t3) {
    return t3.cmView;
  }
  get isEditable() {
    return true;
  }
  get isWidget() {
    return false;
  }
  get isHidden() {
    return false;
  }
  merge(t3, e28, i, s3, r3, o3) {
    return false;
  }
  become(t3) {
    return false;
  }
  canReuseDOM(t3) {
    return t3.constructor == this.constructor && !((this.flags | t3.flags) & 8);
  }
  getSide() {
    return 0;
  }
  destroy() {
    this.parent = null;
  }
}
T$w.prototype.breakAfter = 0;
function ii$2(n3) {
  let t3 = n3.nextSibling;
  return n3.parentNode.removeChild(n3), t3;
}
class ss$2 {
  constructor(t3, e28, i) {
    this.children = t3, this.pos = e28, this.i = i, this.off = 0;
  }
  findPos(t3, e28 = 1) {
    for (; ; ) {
      if (t3 > this.pos || t3 == this.pos && (e28 > 0 || this.i == 0 || this.children[this.i - 1].breakAfter))
        return this.off = t3 - this.pos, this;
      let i = this.children[--this.i];
      this.pos -= i.length + i.breakAfter;
    }
  }
}
function ns$1(n3, t3, e28, i, s3, r3, o3, l3, h3) {
  let { children: c3 } = n3, a3 = c3.length ? c3[t3] : null, f3 = r3.length ? r3[r3.length - 1] : null, d3 = f3 ? f3.breakAfter : o3;
  if (!(t3 == i && a3 && !o3 && !d3 && r3.length < 2 && a3.merge(e28, s3, r3.length ? f3 : null, e28 == 0, l3, h3))) {
    if (i < c3.length) {
      let u3 = c3[i];
      u3 && (s3 < u3.length || u3.breakAfter && (f3 != null && f3.breakAfter)) ? (t3 == i && (u3 = u3.split(s3), s3 = 0), !d3 && f3 && u3.merge(0, s3, f3, true, 0, h3) ? r3[r3.length - 1] = u3 : ((s3 || u3.children.length && !u3.children[0].length) && u3.merge(0, s3, null, false, 0, h3), r3.push(u3))) : u3 != null && u3.breakAfter && (f3 ? f3.breakAfter = 1 : o3 = 1), i++;
    }
    for (a3 && (a3.breakAfter = o3, e28 > 0 && (!o3 && r3.length && a3.merge(e28, a3.length, r3[0], false, l3, 0) ? a3.breakAfter = r3.shift().breakAfter : (e28 < a3.length || a3.children.length && a3.children[a3.children.length - 1].length == 0) && a3.merge(e28, a3.length, null, false, l3, 0), t3++)); t3 < i && r3.length; )
      if (c3[i - 1].become(r3[r3.length - 1]))
        i--, r3.pop(), h3 = r3.length ? 0 : l3;
      else if (c3[t3].become(r3[0]))
        t3++, r3.shift(), l3 = r3.length ? 0 : h3;
      else
        break;
    !r3.length && t3 && i < c3.length && !c3[t3 - 1].breakAfter && c3[i].merge(0, 0, c3[t3 - 1], false, l3, h3) && t3--, (t3 < i || r3.length) && n3.replaceChildren(t3, i, r3);
  }
}
function rs$1(n3, t3, e28, i, s3, r3) {
  let o3 = n3.childCursor(), { i: l3, off: h3 } = o3.findPos(e28, 1), { i: c3, off: a3 } = o3.findPos(t3, -1), f3 = t3 - e28;
  for (let d3 of i)
    f3 += d3.length;
  n3.length += f3, ns$1(n3, c3, a3, l3, h3, i, 0, s3, r3);
}
let K$g = typeof navigator < "u" ? navigator : { userAgent: "", vendor: "", platform: "" }, Me$5 = typeof document < "u" ? document : { documentElement: { style: {} } };
const ke$9 = /* @__PURE__ */ /Edge\/(\d+)/.exec(K$g.userAgent), os$1 = /* @__PURE__ */ /MSIE \d/.test(K$g.userAgent), Ae$6 = /* @__PURE__ */ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(K$g.userAgent), ce$9 = !!(os$1 || Ae$6 || ke$9), si$2 = !ce$9 && /* @__PURE__ */ /gecko\/(\d+)/i.test(K$g.userAgent), de$c = !ce$9 && /* @__PURE__ */ /Chrome\/(\d+)/.exec(K$g.userAgent), ni$2 = "webkitFontSmoothing" in Me$5.documentElement.style, ls$2 = !ce$9 && /* @__PURE__ */ /Apple Computer/.test(K$g.vendor), ri$2 = ls$2 && (/* @__PURE__ */ /Mobile\/\w+/.test(K$g.userAgent) || K$g.maxTouchPoints > 2);
var w$o = {
  mac: ri$2 || /* @__PURE__ */ /Mac/.test(K$g.platform),
  windows: /* @__PURE__ */ /Win/.test(K$g.platform),
  linux: /* @__PURE__ */ /Linux|X11/.test(K$g.platform),
  ie: ce$9,
  ie_version: os$1 ? Me$5.documentMode || 6 : Ae$6 ? +Ae$6[1] : ke$9 ? +ke$9[1] : 0,
  gecko: si$2,
  gecko_version: si$2 ? +(/* @__PURE__ */ /Firefox\/(\d+)/.exec(K$g.userAgent) || [0, 0])[1] : 0,
  chrome: !!de$c,
  chrome_version: de$c ? +de$c[1] : 0,
  ios: ri$2,
  android: /* @__PURE__ */ /Android\b/.test(K$g.userAgent),
  webkit: ni$2,
  safari: ls$2,
  webkit_version: ni$2 ? +(/* @__PURE__ */ /\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0,
  tabSize: Me$5.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const xn$3 = 256;
class Z$h extends T$w {
  constructor(t3) {
    super(), this.text = t3;
  }
  get length() {
    return this.text.length;
  }
  createDOM(t3) {
    this.setDOM(t3 || document.createTextNode(this.text));
  }
  sync(t3, e28) {
    this.dom || this.createDOM(), this.dom.nodeValue != this.text && (e28 && e28.node == this.dom && (e28.written = true), this.dom.nodeValue = this.text);
  }
  reuseDOM(t3) {
    t3.nodeType == 3 && this.createDOM(t3);
  }
  merge(t3, e28, i) {
    return this.flags & 8 || i && (!(i instanceof Z$h) || this.length - (e28 - t3) + i.length > xn$3 || i.flags & 8) ? false : (this.text = this.text.slice(0, t3) + (i ? i.text : "") + this.text.slice(e28), this.markDirty(), true);
  }
  split(t3) {
    let e28 = new Z$h(this.text.slice(t3));
    return this.text = this.text.slice(0, t3), this.markDirty(), e28.flags |= this.flags & 8, e28;
  }
  localPosFromDOM(t3, e28) {
    return t3 == this.dom ? e28 : e28 ? this.text.length : 0;
  }
  domAtPos(t3) {
    return new H$h(this.dom, t3);
  }
  domBoundsAround(t3, e28, i) {
    return { from: i, to: i + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  }
  coordsAt(t3, e28) {
    return Cn$1(this.dom, t3, e28);
  }
}
class Q$h extends T$w {
  constructor(t3, e28 = [], i = 0) {
    super(), this.mark = t3, this.children = e28, this.length = i;
    for (let s3 of e28)
      s3.setParent(this);
  }
  setAttrs(t3) {
    if (es$1(t3), this.mark.class && (t3.className = this.mark.class), this.mark.attrs)
      for (let e28 in this.mark.attrs)
        t3.setAttribute(e28, this.mark.attrs[e28]);
    return t3;
  }
  canReuseDOM(t3) {
    return super.canReuseDOM(t3) && !((this.flags | t3.flags) & 8);
  }
  reuseDOM(t3) {
    t3.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(t3), this.flags |= 6);
  }
  sync(t3, e28) {
    this.dom ? this.flags & 4 && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), super.sync(t3, e28);
  }
  merge(t3, e28, i, s3, r3, o3) {
    return i && (!(i instanceof Q$h && i.mark.eq(this.mark)) || t3 && r3 <= 0 || e28 < this.length && o3 <= 0) ? false : (rs$1(this, t3, e28, i ? i.children : [], r3 - 1, o3 - 1), this.markDirty(), true);
  }
  split(t3) {
    let e28 = [], i = 0, s3 = -1, r3 = 0;
    for (let l3 of this.children) {
      let h3 = i + l3.length;
      h3 > t3 && e28.push(i < t3 ? l3.split(t3 - i) : l3), s3 < 0 && i >= t3 && (s3 = r3), i = h3, r3++;
    }
    let o3 = this.length - t3;
    return this.length = t3, s3 > -1 && (this.children.length = s3, this.markDirty()), new Q$h(this.mark, e28, o3);
  }
  domAtPos(t3) {
    return hs$2(this, t3);
  }
  coordsAt(t3, e28) {
    return cs$2(this, t3, e28);
  }
}
function Cn$1(n3, t3, e28) {
  let i = n3.nodeValue.length;
  t3 > i && (t3 = i);
  let s3 = t3, r3 = t3, o3 = 0;
  t3 == 0 && e28 < 0 || t3 == i && e28 >= 0 ? w$o.chrome || w$o.gecko || (t3 ? (s3--, o3 = 1) : r3 < i && (r3++, o3 = -1)) : e28 < 0 ? s3-- : r3 < i && r3++;
  let l3 = ft$5(n3, s3, r3).getClientRects();
  if (!l3.length)
    return null;
  let h3 = l3[(o3 ? o3 < 0 : e28 >= 0) ? 0 : l3.length - 1];
  return w$o.safari && !o3 && h3.width == 0 && (h3 = Array.prototype.find.call(l3, (c3) => c3.width) || h3), o3 ? Ge$5(h3, o3 < 0) : h3 || null;
}
class st$6 extends T$w {
  static create(t3, e28, i) {
    return new st$6(t3, e28, i);
  }
  constructor(t3, e28, i) {
    super(), this.widget = t3, this.length = e28, this.side = i, this.prevWidget = null;
  }
  split(t3) {
    let e28 = st$6.create(this.widget, this.length - t3, this.side);
    return this.length -= t3, e28;
  }
  sync(t3) {
    (!this.dom || !this.widget.updateDOM(this.dom, t3)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(t3)), this.dom.contentEditable = "false");
  }
  getSide() {
    return this.side;
  }
  merge(t3, e28, i, s3, r3, o3) {
    return i && (!(i instanceof st$6) || !this.widget.compare(i.widget) || t3 > 0 && r3 <= 0 || e28 < this.length && o3 <= 0) ? false : (this.length = t3 + (i ? i.length : 0) + (this.length - e28), true);
  }
  become(t3) {
    return t3 instanceof st$6 && t3.side == this.side && this.widget.constructor == t3.widget.constructor ? (this.widget.compare(t3.widget) || this.markDirty(true), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = t3.widget, this.length = t3.length, true) : false;
  }
  ignoreMutation() {
    return true;
  }
  ignoreEvent(t3) {
    return this.widget.ignoreEvent(t3);
  }
  get overrideDOMText() {
    if (this.length == 0)
      return x$l.empty;
    let t3 = this;
    for (; t3.parent; )
      t3 = t3.parent;
    let { view: e28 } = t3, i = e28 && e28.state.doc, s3 = this.posAtStart;
    return i ? i.slice(s3, s3 + this.length) : x$l.empty;
  }
  domAtPos(t3) {
    return (this.length ? t3 == 0 : this.side > 0) ? H$h.before(this.dom) : H$h.after(this.dom, t3 == this.length);
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(t3, e28) {
    let i = this.widget.coordsAt(this.dom, t3, e28);
    if (i)
      return i;
    let s3 = this.dom.getClientRects(), r3 = null;
    if (!s3.length)
      return null;
    let o3 = this.side ? this.side < 0 : t3 > 0;
    for (let l3 = o3 ? s3.length - 1 : 0; r3 = s3[l3], !(t3 > 0 ? l3 == 0 : l3 == s3.length - 1 || r3.top < r3.bottom); l3 += o3 ? -1 : 1)
      ;
    return Ge$5(r3, !o3);
  }
  get isEditable() {
    return false;
  }
  get isWidget() {
    return true;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
}
class yt$7 extends T$w {
  constructor(t3) {
    super(), this.side = t3;
  }
  get length() {
    return 0;
  }
  merge() {
    return false;
  }
  become(t3) {
    return t3 instanceof yt$7 && t3.side == this.side;
  }
  split() {
    return new yt$7(this.side);
  }
  sync() {
    if (!this.dom) {
      let t3 = document.createElement("img");
      t3.className = "cm-widgetBuffer", t3.setAttribute("aria-hidden", "true"), this.setDOM(t3);
    }
  }
  getSide() {
    return this.side;
  }
  domAtPos(t3) {
    return this.side > 0 ? H$h.before(this.dom) : H$h.after(this.dom);
  }
  localPosFromDOM() {
    return 0;
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(t3) {
    return this.dom.getBoundingClientRect();
  }
  get overrideDOMText() {
    return x$l.empty;
  }
  get isHidden() {
    return true;
  }
}
Z$h.prototype.children = st$6.prototype.children = yt$7.prototype.children = _e$9;
function hs$2(n3, t3) {
  let e28 = n3.dom, { children: i } = n3, s3 = 0;
  for (let r3 = 0; s3 < i.length; s3++) {
    let o3 = i[s3], l3 = r3 + o3.length;
    if (!(l3 == r3 && o3.getSide() <= 0)) {
      if (t3 > r3 && t3 < l3 && o3.dom.parentNode == e28)
        return o3.domAtPos(t3 - r3);
      if (t3 <= r3)
        break;
      r3 = l3;
    }
  }
  for (let r3 = s3; r3 > 0; r3--) {
    let o3 = i[r3 - 1];
    if (o3.dom.parentNode == e28)
      return o3.domAtPos(o3.length);
  }
  for (let r3 = s3; r3 < i.length; r3++) {
    let o3 = i[r3];
    if (o3.dom.parentNode == e28)
      return o3.domAtPos(0);
  }
  return new H$h(e28, 0);
}
function as$2(n3, t3, e28) {
  let i, { children: s3 } = n3;
  e28 > 0 && t3 instanceof Q$h && s3.length && (i = s3[s3.length - 1]) instanceof Q$h && i.mark.eq(t3.mark) ? as$2(i, t3.children[0], e28 - 1) : (s3.push(t3), t3.setParent(n3)), n3.length += t3.length;
}
function cs$2(n3, t3, e28) {
  let i = null, s3 = -1, r3 = null, o3 = -1;
  function l3(c3, a3) {
    for (let f3 = 0, d3 = 0; f3 < c3.children.length && d3 <= a3; f3++) {
      let u3 = c3.children[f3], g3 = d3 + u3.length;
      g3 >= a3 && (u3.children.length ? l3(u3, a3 - d3) : (!r3 || r3.isHidden && e28 > 0) && (g3 > a3 || d3 == g3 && u3.getSide() > 0) ? (r3 = u3, o3 = a3 - d3) : (d3 < a3 || d3 == g3 && u3.getSide() < 0 && !u3.isHidden) && (i = u3, s3 = a3 - d3)), d3 = g3;
    }
  }
  l3(n3, t3);
  let h3 = (e28 < 0 ? i : r3) || i || r3;
  return h3 ? h3.coordsAt(Math.max(0, h3 == i ? s3 : o3), e28) : Mn$1(n3);
}
function Mn$1(n3) {
  let t3 = n3.dom.lastChild;
  if (!t3)
    return n3.dom.getBoundingClientRect();
  let e28 = Rt$5(t3);
  return e28[e28.length - 1] || null;
}
function De$3(n3, t3) {
  for (let e28 in n3)
    e28 == "class" && t3.class ? t3.class += " " + n3.class : e28 == "style" && t3.style ? t3.style += ";" + n3.style : t3[e28] = n3[e28];
  return t3;
}
const oi$2 = /* @__PURE__ */ Object.create(null);
function Xe$7(n3, t3, e28) {
  if (n3 == t3)
    return true;
  n3 || (n3 = oi$2), t3 || (t3 = oi$2);
  let i = Object.keys(n3), s3 = Object.keys(t3);
  if (i.length - (e28 && i.indexOf(e28) > -1 ? 1 : 0) != s3.length - (e28 && s3.indexOf(e28) > -1 ? 1 : 0))
    return false;
  for (let r3 of i)
    if (r3 != e28 && (s3.indexOf(r3) == -1 || n3[r3] !== t3[r3]))
      return false;
  return true;
}
function Oe$6(n3, t3, e28) {
  let i = false;
  if (t3)
    for (let s3 in t3)
      e28 && s3 in e28 || (i = true, s3 == "style" ? n3.style.cssText = "" : n3.removeAttribute(s3));
  if (e28)
    for (let s3 in e28)
      t3 && t3[s3] == e28[s3] || (i = true, s3 == "style" ? n3.style.cssText = e28[s3] : n3.setAttribute(s3, e28[s3]));
  return i;
}
function kn$2(n3) {
  let t3 = /* @__PURE__ */ Object.create(null);
  for (let e28 = 0; e28 < n3.attributes.length; e28++) {
    let i = n3.attributes[e28];
    t3[i.name] = i.value;
  }
  return t3;
}
class B$r extends T$w {
  constructor() {
    super(...arguments), this.children = [], this.length = 0, this.prevAttrs = void 0, this.attrs = null, this.breakAfter = 0;
  }
  merge(t3, e28, i, s3, r3, o3) {
    if (i) {
      if (!(i instanceof B$r))
        return false;
      this.dom || i.transferDOM(this);
    }
    return s3 && this.setDeco(i ? i.attrs : null), rs$1(this, t3, e28, i ? i.children : [], r3, o3), true;
  }
  split(t3) {
    let e28 = new B$r();
    if (e28.breakAfter = this.breakAfter, this.length == 0)
      return e28;
    let { i, off: s3 } = this.childPos(t3);
    s3 && (e28.append(this.children[i].split(s3), 0), this.children[i].merge(s3, this.children[i].length, null, false, 0, 0), i++);
    for (let r3 = i; r3 < this.children.length; r3++)
      e28.append(this.children[r3], 0);
    for (; i > 0 && this.children[i - 1].length == 0; )
      this.children[--i].destroy();
    return this.children.length = i, this.markDirty(), this.length = t3, e28;
  }
  transferDOM(t3) {
    this.dom && (this.markDirty(), t3.setDOM(this.dom), t3.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
  }
  setDeco(t3) {
    Xe$7(this.attrs, t3) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = t3);
  }
  append(t3, e28) {
    as$2(this, t3, e28);
  }
  addLineDeco(t3) {
    let e28 = t3.spec.attributes, i = t3.spec.class;
    e28 && (this.attrs = De$3(e28, this.attrs || {})), i && (this.attrs = De$3({ class: i }, this.attrs || {}));
  }
  domAtPos(t3) {
    return hs$2(this, t3);
  }
  reuseDOM(t3) {
    t3.nodeName == "DIV" && (this.setDOM(t3), this.flags |= 6);
  }
  sync(t3, e28) {
    var i;
    this.dom ? this.flags & 4 && (es$1(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), this.prevAttrs !== void 0 && (Oe$6(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), super.sync(t3, e28);
    let s3 = this.dom.lastChild;
    for (; s3 && T$w.get(s3) instanceof Q$h; )
      s3 = s3.lastChild;
    if (!s3 || !this.length || s3.nodeName != "BR" && ((i = T$w.get(s3)) === null || i === void 0 ? void 0 : i.isEditable) == false && (!w$o.ios || !this.children.some((r3) => r3 instanceof Z$h))) {
      let r3 = document.createElement("BR");
      r3.cmIgnore = true, this.dom.appendChild(r3);
    }
  }
  measureTextSize() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    let t3 = 0, e28;
    for (let i of this.children) {
      if (!(i instanceof Z$h) || /[^ -~]/.test(i.text))
        return null;
      let s3 = Rt$5(i.dom);
      if (s3.length != 1)
        return null;
      t3 += s3[0].width, e28 = s3[0].height;
    }
    return t3 ? {
      lineHeight: this.dom.getBoundingClientRect().height,
      charWidth: t3 / this.length,
      textHeight: e28
    } : null;
  }
  coordsAt(t3, e28) {
    let i = cs$2(this, t3, e28);
    if (!this.children.length && i && this.parent) {
      let { heightOracle: s3 } = this.parent.view.viewState, r3 = i.bottom - i.top;
      if (Math.abs(r3 - s3.lineHeight) < 2 && s3.textHeight < r3) {
        let o3 = (r3 - s3.textHeight) / 2;
        return { top: i.top + o3, bottom: i.bottom - o3, left: i.left, right: i.left };
      }
    }
    return i;
  }
  become(t3) {
    return false;
  }
  covers() {
    return true;
  }
  static find(t3, e28) {
    for (let i = 0, s3 = 0; i < t3.children.length; i++) {
      let r3 = t3.children[i], o3 = s3 + r3.length;
      if (o3 >= e28) {
        if (r3 instanceof B$r)
          return r3;
        if (o3 > e28)
          break;
      }
      s3 = o3 + r3.breakAfter;
    }
    return null;
  }
}
class rt$6 extends T$w {
  constructor(t3, e28, i) {
    super(), this.widget = t3, this.length = e28, this.deco = i, this.breakAfter = 0, this.prevWidget = null;
  }
  merge(t3, e28, i, s3, r3, o3) {
    return i && (!(i instanceof rt$6) || !this.widget.compare(i.widget) || t3 > 0 && r3 <= 0 || e28 < this.length && o3 <= 0) ? false : (this.length = t3 + (i ? i.length : 0) + (this.length - e28), true);
  }
  domAtPos(t3) {
    return t3 == 0 ? H$h.before(this.dom) : H$h.after(this.dom, t3 == this.length);
  }
  split(t3) {
    let e28 = this.length - t3;
    this.length = t3;
    let i = new rt$6(this.widget, e28, this.deco);
    return i.breakAfter = this.breakAfter, i;
  }
  get children() {
    return _e$9;
  }
  sync(t3) {
    (!this.dom || !this.widget.updateDOM(this.dom, t3)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(t3)), this.dom.contentEditable = "false");
  }
  get overrideDOMText() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : x$l.empty;
  }
  domBoundsAround() {
    return null;
  }
  become(t3) {
    return t3 instanceof rt$6 && t3.widget.constructor == this.widget.constructor ? (t3.widget.compare(this.widget) || this.markDirty(true), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = t3.widget, this.length = t3.length, this.deco = t3.deco, this.breakAfter = t3.breakAfter, true) : false;
  }
  ignoreMutation() {
    return true;
  }
  ignoreEvent(t3) {
    return this.widget.ignoreEvent(t3);
  }
  get isEditable() {
    return false;
  }
  get isWidget() {
    return true;
  }
  coordsAt(t3, e28) {
    return this.widget.coordsAt(this.dom, t3, e28);
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
  covers(t3) {
    let { startSide: e28, endSide: i } = this.deco;
    return e28 == i ? false : t3 < 0 ? e28 < 0 : i > 0;
  }
}
class Nt$4 {
  eq(t3) {
    return false;
  }
  updateDOM(t3, e28) {
    return false;
  }
  compare(t3) {
    return this == t3 || this.constructor == t3.constructor && this.eq(t3);
  }
  get estimatedHeight() {
    return -1;
  }
  get lineBreaks() {
    return 0;
  }
  ignoreEvent(t3) {
    return true;
  }
  coordsAt(t3, e28, i) {
    return null;
  }
  get isHidden() {
    return false;
  }
  destroy(t3) {
  }
}
var N$w = /* @__PURE__ */ function(n3) {
  return n3[n3.Text = 0] = "Text", n3[n3.WidgetBefore = 1] = "WidgetBefore", n3[n3.WidgetAfter = 2] = "WidgetAfter", n3[n3.WidgetRange = 3] = "WidgetRange", n3;
}(N$w || (N$w = {}));
class V$j extends Y$h {
  constructor(t3, e28, i, s3) {
    super(), this.startSide = t3, this.endSide = e28, this.widget = i, this.spec = s3;
  }
  get heightRelevant() {
    return false;
  }
  static mark(t3) {
    return new Vt$3(t3);
  }
  static widget(t3) {
    let e28 = Math.max(-1e4, Math.min(1e4, t3.side || 0)), i = !!t3.block;
    return e28 += i && !t3.inlineOrder ? e28 > 0 ? 3e8 : -4e8 : e28 > 0 ? 1e8 : -1e8, new ot$5(t3, e28, e28, i, t3.widget || null, false);
  }
  static replace(t3) {
    let e28 = !!t3.block, i, s3;
    if (t3.isBlockGap)
      i = -5e8, s3 = 4e8;
    else {
      let { start: r3, end: o3 } = fs$2(t3, e28);
      i = (r3 ? e28 ? -3e8 : -1 : 5e8) - 1, s3 = (o3 ? e28 ? 2e8 : 1 : -6e8) + 1;
    }
    return new ot$5(t3, i, s3, e28, t3.widget || null, true);
  }
  static line(t3) {
    return new Wt$5(t3);
  }
  static set(t3, e28 = false) {
    return P$F.of(t3, e28);
  }
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : false;
  }
}
V$j.none = P$F.empty;
class Vt$3 extends V$j {
  constructor(t3) {
    let { start: e28, end: i } = fs$2(t3);
    super(e28 ? -1 : 5e8, i ? 1 : -6e8, null, t3), this.tagName = t3.tagName || "span", this.class = t3.class || "", this.attrs = t3.attributes || null;
  }
  eq(t3) {
    var e28, i;
    return this == t3 || t3 instanceof Vt$3 && this.tagName == t3.tagName && (this.class || ((e28 = this.attrs) === null || e28 === void 0 ? void 0 : e28.class)) == (t3.class || ((i = t3.attrs) === null || i === void 0 ? void 0 : i.class)) && Xe$7(this.attrs, t3.attrs, "class");
  }
  range(t3, e28 = t3) {
    if (t3 >= e28)
      throw new RangeError("Mark decorations may not be empty");
    return super.range(t3, e28);
  }
}
Vt$3.prototype.point = false;
class Wt$5 extends V$j {
  constructor(t3) {
    super(-2e8, -2e8, null, t3);
  }
  eq(t3) {
    return t3 instanceof Wt$5 && this.spec.class == t3.spec.class && Xe$7(this.spec.attributes, t3.spec.attributes);
  }
  range(t3, e28 = t3) {
    if (e28 != t3)
      throw new RangeError("Line decoration ranges must be zero-length");
    return super.range(t3, e28);
  }
}
Wt$5.prototype.mapMode = C$I.TrackBefore;
Wt$5.prototype.point = true;
class ot$5 extends V$j {
  constructor(t3, e28, i, s3, r3, o3) {
    super(e28, i, r3, t3), this.block = s3, this.isReplace = o3, this.mapMode = s3 ? e28 <= 0 ? C$I.TrackBefore : C$I.TrackAfter : C$I.TrackDel;
  }
  get type() {
    return this.startSide != this.endSide ? N$w.WidgetRange : this.startSide <= 0 ? N$w.WidgetBefore : N$w.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(t3) {
    return t3 instanceof ot$5 && An$1(this.widget, t3.widget) && this.block == t3.block && this.startSide == t3.startSide && this.endSide == t3.endSide;
  }
  range(t3, e28 = t3) {
    if (this.isReplace && (t3 > e28 || t3 == e28 && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && e28 != t3)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return super.range(t3, e28);
  }
}
ot$5.prototype.point = true;
function fs$2(n3, t3 = false) {
  let { inclusiveStart: e28, inclusiveEnd: i } = n3;
  return e28 == null && (e28 = n3.inclusive), i == null && (i = n3.inclusive), { start: e28 != null ? e28 : t3, end: i != null ? i : t3 };
}
function An$1(n3, t3) {
  return n3 == t3 || !!(n3 && t3 && n3.compare(t3));
}
function Te$8(n3, t3, e28, i = 0) {
  let s3 = e28.length - 1;
  s3 >= 0 && e28[s3] + i >= n3 ? e28[s3] = Math.max(e28[s3], t3) : e28.push(n3, t3);
}
class Ot$5 {
  constructor(t3, e28, i, s3) {
    this.doc = t3, this.pos = e28, this.end = i, this.disallowBlockEffectsFor = s3, this.content = [], this.curLine = null, this.breakAtStart = 0, this.pendingBuffer = 0, this.bufferMarks = [], this.atCursorPos = true, this.openStart = -1, this.openEnd = -1, this.text = "", this.textOff = 0, this.cursor = t3.iter(), this.skip = e28;
  }
  posCovered() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    let t3 = this.content[this.content.length - 1];
    return !(t3.breakAfter || t3 instanceof rt$6 && t3.deco.endSide < 0);
  }
  getLine() {
    return this.curLine || (this.content.push(this.curLine = new B$r()), this.atCursorPos = true), this.curLine;
  }
  flushBuffer(t3 = this.bufferMarks) {
    this.pendingBuffer && (this.curLine.append(qt$3(new yt$7(-1), t3), t3.length), this.pendingBuffer = 0);
  }
  addBlockWidget(t3) {
    this.flushBuffer(), this.curLine = null, this.content.push(t3);
  }
  finish(t3) {
    this.pendingBuffer && t3 <= this.bufferMarks.length ? this.flushBuffer() : this.pendingBuffer = 0, !this.posCovered() && !(t3 && this.content.length && this.content[this.content.length - 1] instanceof rt$6) && this.getLine();
  }
  buildText(t3, e28, i) {
    for (; t3 > 0; ) {
      if (this.textOff == this.text.length) {
        let { value: r3, lineBreak: o3, done: l3 } = this.cursor.next(this.skip);
        if (this.skip = 0, l3)
          throw new Error("Ran out of text content when drawing inline views");
        if (o3) {
          this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer(), this.curLine = null, this.atCursorPos = true, t3--;
          continue;
        } else
          this.text = r3, this.textOff = 0;
      }
      let s3 = Math.min(this.text.length - this.textOff, t3, 512);
      this.flushBuffer(e28.slice(e28.length - i)), this.getLine().append(qt$3(new Z$h(this.text.slice(this.textOff, this.textOff + s3)), e28), i), this.atCursorPos = true, this.textOff += s3, t3 -= s3, i = 0;
    }
  }
  span(t3, e28, i, s3) {
    this.buildText(e28 - t3, i, s3), this.pos = e28, this.openStart < 0 && (this.openStart = s3);
  }
  point(t3, e28, i, s3, r3, o3) {
    if (this.disallowBlockEffectsFor[o3] && i instanceof ot$5) {
      if (i.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (e28 > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    let l3 = e28 - t3;
    if (i instanceof ot$5)
      if (i.block)
        i.startSide > 0 && !this.posCovered() && this.getLine(), this.addBlockWidget(new rt$6(i.widget || new li$2("div"), l3, i));
      else {
        let h3 = st$6.create(i.widget || new li$2("span"), l3, l3 ? 0 : i.startSide), c3 = this.atCursorPos && !h3.isEditable && r3 <= s3.length && (t3 < e28 || i.startSide > 0), a3 = !h3.isEditable && (t3 < e28 || r3 > s3.length || i.startSide <= 0), f3 = this.getLine();
        this.pendingBuffer == 2 && !c3 && !h3.isEditable && (this.pendingBuffer = 0), this.flushBuffer(s3), c3 && (f3.append(qt$3(new yt$7(1), s3), r3), r3 = s3.length + Math.max(0, r3 - s3.length)), f3.append(qt$3(h3, s3), r3), this.atCursorPos = a3, this.pendingBuffer = a3 ? t3 < e28 || r3 > s3.length ? 1 : 2 : 0, this.pendingBuffer && (this.bufferMarks = s3.slice());
      }
    else
      this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(i);
    l3 && (this.textOff + l3 <= this.text.length ? this.textOff += l3 : (this.skip += l3 - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = e28), this.openStart < 0 && (this.openStart = r3);
  }
  static build(t3, e28, i, s3, r3) {
    let o3 = new Ot$5(t3, e28, i, r3);
    return o3.openEnd = P$F.spans(s3, e28, i, o3), o3.openStart < 0 && (o3.openStart = o3.openEnd), o3.finish(o3.openEnd), o3;
  }
}
function qt$3(n3, t3) {
  for (let e28 of t3)
    n3 = new Q$h(e28, [n3], n3.length);
  return n3;
}
class li$2 extends Nt$4 {
  constructor(t3) {
    super(), this.tag = t3;
  }
  eq(t3) {
    return t3.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(t3) {
    return t3.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return true;
  }
}
const ds$2 = /* @__PURE__ */ A$o.define(), us$2 = /* @__PURE__ */ A$o.define(), gs$2 = /* @__PURE__ */ A$o.define(), ps$2 = /* @__PURE__ */ A$o.define(), Re$9 = /* @__PURE__ */ A$o.define(), ms$2 = /* @__PURE__ */ A$o.define(), bs$2 = /* @__PURE__ */ A$o.define(), ws$2 = /* @__PURE__ */ A$o.define({
  combine: (n3) => n3.some((t3) => t3)
}), ys$2 = /* @__PURE__ */ A$o.define({
  combine: (n3) => n3.some((t3) => t3)
});
class oe$c {
  constructor(t3, e28 = "nearest", i = "nearest", s3 = 5, r3 = 5) {
    this.range = t3, this.y = e28, this.x = i, this.yMargin = s3, this.xMargin = r3;
  }
  map(t3) {
    return t3.empty ? this : new oe$c(this.range.map(t3), this.y, this.x, this.yMargin, this.xMargin);
  }
}
const hi$1 = /* @__PURE__ */ S$m.define({ map: (n3, t3) => n3.map(t3) });
function ct$6(n3, t3, e28) {
  let i = n3.facet(ps$2);
  i.length ? i[0](t3) : window.onerror ? window.onerror(String(t3), e28, void 0, void 0, t3) : e28 ? console.error(e28 + ":", t3) : console.error(t3);
}
const fe$a = /* @__PURE__ */ A$o.define({ combine: (n3) => n3.length ? n3[0] : true });
let Dn$2 = 0;
const xt$6 = /* @__PURE__ */ A$o.define();
class z$i {
  constructor(t3, e28, i, s3, r3) {
    this.id = t3, this.create = e28, this.domEventHandlers = i, this.domEventObservers = s3, this.extension = r3(this);
  }
  static define(t3, e28) {
    const { eventHandlers: i, eventObservers: s3, provide: r3, decorations: o3 } = e28 || {};
    return new z$i(Dn$2++, t3, i, s3, (l3) => {
      let h3 = [xt$6.of(l3)];
      return o3 && h3.push(Bt$4.of((c3) => {
        let a3 = c3.plugin(l3);
        return a3 ? o3(a3) : V$j.none;
      })), r3 && h3.push(r3(l3)), h3;
    });
  }
  static fromClass(t3, e28) {
    return z$i.define((i) => new t3(i), e28);
  }
}
class ue$b {
  constructor(t3) {
    this.spec = t3, this.mustUpdate = null, this.value = null;
  }
  update(t3) {
    if (this.value) {
      if (this.mustUpdate) {
        let e28 = this.mustUpdate;
        if (this.mustUpdate = null, this.value.update)
          try {
            this.value.update(e28);
          } catch (i) {
            if (ct$6(e28.state, i, "CodeMirror plugin crashed"), this.value.destroy)
              try {
                this.value.destroy();
              } catch {
              }
            this.deactivate();
          }
      }
    } else if (this.spec)
      try {
        this.value = this.spec.create(t3);
      } catch (e28) {
        ct$6(t3.state, e28, "CodeMirror plugin crashed"), this.deactivate();
      }
    return this;
  }
  destroy(t3) {
    var e28;
    if (!((e28 = this.value) === null || e28 === void 0) && e28.destroy)
      try {
        this.value.destroy();
      } catch (i) {
        ct$6(t3.state, i, "CodeMirror plugin crashed");
      }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}
const vs$2 = /* @__PURE__ */ A$o.define(), $e$4 = /* @__PURE__ */ A$o.define(), Bt$4 = /* @__PURE__ */ A$o.define(), Ue$4 = /* @__PURE__ */ A$o.define(), Ss$2 = /* @__PURE__ */ A$o.define();
function ai$2(n3, t3, e28) {
  let i = n3.state.facet(Ss$2);
  if (!i.length)
    return i;
  let s3 = i.map((o3) => o3 instanceof Function ? o3(n3) : o3), r3 = [];
  return P$F.spans(s3, t3, e28, {
    point() {
    },
    span(o3, l3, h3, c3) {
      let a3 = r3;
      for (let f3 = h3.length - 1; f3 >= 0; f3--, c3--) {
        let d3 = h3[f3].spec.bidiIsolate, u3;
        if (d3 != null)
          if (c3 > 0 && a3.length && (u3 = a3[a3.length - 1]).to == o3 && u3.direction == d3)
            u3.to = l3, a3 = u3.inner;
          else {
            let g3 = { from: o3, to: l3, direction: d3, inner: [] };
            a3.push(g3), a3 = g3.inner;
          }
      }
    }
  }), r3;
}
const xs$2 = /* @__PURE__ */ A$o.define();
function Cs$2(n3) {
  let t3 = 0, e28 = 0, i = 0, s3 = 0;
  for (let r3 of n3.state.facet(xs$2)) {
    let o3 = r3(n3);
    o3 && (o3.left != null && (t3 = Math.max(t3, o3.left)), o3.right != null && (e28 = Math.max(e28, o3.right)), o3.top != null && (i = Math.max(i, o3.top)), o3.bottom != null && (s3 = Math.max(s3, o3.bottom)));
  }
  return { left: t3, right: e28, top: i, bottom: s3 };
}
const Ct$6 = /* @__PURE__ */ A$o.define();
class q$j {
  constructor(t3, e28, i, s3) {
    this.fromA = t3, this.toA = e28, this.fromB = i, this.toB = s3;
  }
  join(t3) {
    return new q$j(Math.min(this.fromA, t3.fromA), Math.max(this.toA, t3.toA), Math.min(this.fromB, t3.fromB), Math.max(this.toB, t3.toB));
  }
  addToSet(t3) {
    let e28 = t3.length, i = this;
    for (; e28 > 0; e28--) {
      let s3 = t3[e28 - 1];
      if (!(s3.fromA > i.toA)) {
        if (s3.toA < i.fromA)
          break;
        i = i.join(s3), t3.splice(e28 - 1, 1);
      }
    }
    return t3.splice(e28, 0, i), t3;
  }
  static extendWithRanges(t3, e28) {
    if (e28.length == 0)
      return t3;
    let i = [];
    for (let s3 = 0, r3 = 0, o3 = 0, l3 = 0; ; s3++) {
      let h3 = s3 == t3.length ? null : t3[s3], c3 = o3 - l3, a3 = h3 ? h3.fromB : 1e9;
      for (; r3 < e28.length && e28[r3] < a3; ) {
        let f3 = e28[r3], d3 = e28[r3 + 1], u3 = Math.max(l3, f3), g3 = Math.min(a3, d3);
        if (u3 <= g3 && new q$j(u3 + c3, g3 + c3, u3, g3).addToSet(i), d3 > a3)
          break;
        r3 += 2;
      }
      if (!h3)
        return i;
      new q$j(h3.fromA, h3.toA, h3.fromB, h3.toB).addToSet(i), o3 = h3.toA, l3 = h3.toB;
    }
  }
}
class le$9 {
  constructor(t3, e28, i) {
    this.view = t3, this.state = e28, this.transactions = i, this.flags = 0, this.startState = t3.state, this.changes = k$w.empty(this.startState.doc.length);
    for (let r3 of i)
      this.changes = this.changes.compose(r3.changes);
    let s3 = [];
    this.changes.iterChangedRanges((r3, o3, l3, h3) => s3.push(new q$j(r3, o3, l3, h3))), this.changedRanges = s3;
  }
  static create(t3, e28, i) {
    return new le$9(t3, e28, i);
  }
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  get geometryChanged() {
    return this.docChanged || (this.flags & 10) > 0;
  }
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  get docChanged() {
    return !this.changes.empty;
  }
  get selectionSet() {
    return this.transactions.some((t3) => t3.selection);
  }
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}
var L$r = /* @__PURE__ */ function(n3) {
  return n3[n3.LTR = 0] = "LTR", n3[n3.RTL = 1] = "RTL", n3;
}(L$r || (L$r = {}));
const Et$6 = L$r.LTR, Ms$2 = L$r.RTL;
function ks$2(n3) {
  let t3 = [];
  for (let e28 = 0; e28 < n3.length; e28++)
    t3.push(1 << +n3[e28]);
  return t3;
}
const On$1 = /* @__PURE__ */ ks$2("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), Tn$1 = /* @__PURE__ */ ks$2("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), Le$4 = /* @__PURE__ */ Object.create(null), Y$g = [];
for (let n3 of ["()", "[]", "{}"]) {
  let t3 = /* @__PURE__ */ n3.charCodeAt(0), e28 = /* @__PURE__ */ n3.charCodeAt(1);
  Le$4[t3] = e28, Le$4[e28] = -t3;
}
function Rn$1(n3) {
  return n3 <= 247 ? On$1[n3] : 1424 <= n3 && n3 <= 1524 ? 2 : 1536 <= n3 && n3 <= 1785 ? Tn$1[n3 - 1536] : 1774 <= n3 && n3 <= 2220 ? 4 : 8192 <= n3 && n3 <= 8203 ? 256 : 64336 <= n3 && n3 <= 65023 ? 4 : n3 == 8204 ? 256 : 1;
}
const Ln$1 = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
class nt$5 {
  get dir() {
    return this.level % 2 ? Ms$2 : Et$6;
  }
  constructor(t3, e28, i) {
    this.from = t3, this.to = e28, this.level = i;
  }
  side(t3, e28) {
    return this.dir == e28 == t3 ? this.to : this.from;
  }
  static find(t3, e28, i, s3) {
    let r3 = -1;
    for (let o3 = 0; o3 < t3.length; o3++) {
      let l3 = t3[o3];
      if (l3.from <= e28 && l3.to >= e28) {
        if (l3.level == i)
          return o3;
        (r3 < 0 || (s3 != 0 ? s3 < 0 ? l3.from < e28 : l3.to > e28 : t3[r3].level > l3.level)) && (r3 = o3);
      }
    }
    if (r3 < 0)
      throw new RangeError("Index out of range");
    return r3;
  }
}
function As$2(n3, t3) {
  if (n3.length != t3.length)
    return false;
  for (let e28 = 0; e28 < n3.length; e28++) {
    let i = n3[e28], s3 = t3[e28];
    if (i.from != s3.from || i.to != s3.to || i.direction != s3.direction || !As$2(i.inner, s3.inner))
      return false;
  }
  return true;
}
const D$w = [];
function Bn$1(n3, t3, e28, i, s3) {
  for (let r3 = 0; r3 <= i.length; r3++) {
    let o3 = r3 ? i[r3 - 1].to : t3, l3 = r3 < i.length ? i[r3].from : e28, h3 = r3 ? 256 : s3;
    for (let c3 = o3, a3 = h3, f3 = h3; c3 < l3; c3++) {
      let d3 = Rn$1(n3.charCodeAt(c3));
      d3 == 512 ? d3 = a3 : d3 == 8 && f3 == 4 && (d3 = 16), D$w[c3] = d3 == 4 ? 2 : d3, d3 & 7 && (f3 = d3), a3 = d3;
    }
    for (let c3 = o3, a3 = h3, f3 = h3; c3 < l3; c3++) {
      let d3 = D$w[c3];
      if (d3 == 128)
        c3 < l3 - 1 && a3 == D$w[c3 + 1] && a3 & 24 ? d3 = D$w[c3] = a3 : D$w[c3] = 256;
      else if (d3 == 64) {
        let u3 = c3 + 1;
        for (; u3 < l3 && D$w[u3] == 64; )
          u3++;
        let g3 = c3 && a3 == 8 || u3 < e28 && D$w[u3] == 8 ? f3 == 1 ? 1 : 8 : 256;
        for (let m3 = c3; m3 < u3; m3++)
          D$w[m3] = g3;
        c3 = u3 - 1;
      } else
        d3 == 8 && f3 == 1 && (D$w[c3] = 1);
      a3 = d3, d3 & 7 && (f3 = d3);
    }
  }
}
function En$2(n3, t3, e28, i, s3) {
  let r3 = s3 == 1 ? 2 : 1;
  for (let o3 = 0, l3 = 0, h3 = 0; o3 <= i.length; o3++) {
    let c3 = o3 ? i[o3 - 1].to : t3, a3 = o3 < i.length ? i[o3].from : e28;
    for (let f3 = c3, d3, u3, g3; f3 < a3; f3++)
      if (u3 = Le$4[d3 = n3.charCodeAt(f3)])
        if (u3 < 0) {
          for (let m3 = l3 - 3; m3 >= 0; m3 -= 3)
            if (Y$g[m3 + 1] == -u3) {
              let p3 = Y$g[m3 + 2], b3 = p3 & 2 ? s3 : p3 & 4 ? p3 & 1 ? r3 : s3 : 0;
              b3 && (D$w[f3] = D$w[Y$g[m3]] = b3), l3 = m3;
              break;
            }
        } else {
          if (Y$g.length == 189)
            break;
          Y$g[l3++] = f3, Y$g[l3++] = d3, Y$g[l3++] = h3;
        }
      else if ((g3 = D$w[f3]) == 2 || g3 == 1) {
        let m3 = g3 == s3;
        h3 = m3 ? 0 : 1;
        for (let p3 = l3 - 3; p3 >= 0; p3 -= 3) {
          let b3 = Y$g[p3 + 2];
          if (b3 & 2)
            break;
          if (m3)
            Y$g[p3 + 2] |= 2;
          else {
            if (b3 & 4)
              break;
            Y$g[p3 + 2] |= 4;
          }
        }
      }
  }
}
function Pn$2(n3, t3, e28, i) {
  for (let s3 = 0, r3 = i; s3 <= e28.length; s3++) {
    let o3 = s3 ? e28[s3 - 1].to : n3, l3 = s3 < e28.length ? e28[s3].from : t3;
    for (let h3 = o3; h3 < l3; ) {
      let c3 = D$w[h3];
      if (c3 == 256) {
        let a3 = h3 + 1;
        for (; ; )
          if (a3 == l3) {
            if (s3 == e28.length)
              break;
            a3 = e28[s3++].to, l3 = s3 < e28.length ? e28[s3].from : t3;
          } else if (D$w[a3] == 256)
            a3++;
          else
            break;
        let f3 = r3 == 1, d3 = (a3 < t3 ? D$w[a3] : i) == 1, u3 = f3 == d3 ? f3 ? 1 : 2 : i;
        for (let g3 = a3, m3 = s3, p3 = m3 ? e28[m3 - 1].to : n3; g3 > h3; )
          g3 == p3 && (g3 = e28[--m3].from, p3 = m3 ? e28[m3 - 1].to : n3), D$w[--g3] = u3;
        h3 = a3;
      } else
        r3 = c3, h3++;
    }
  }
}
function Be$6(n3, t3, e28, i, s3, r3, o3) {
  let l3 = i % 2 ? 2 : 1;
  if (i % 2 == s3 % 2)
    for (let h3 = t3, c3 = 0; h3 < e28; ) {
      let a3 = true, f3 = false;
      if (c3 == r3.length || h3 < r3[c3].from) {
        let m3 = D$w[h3];
        m3 != l3 && (a3 = false, f3 = m3 == 16);
      }
      let d3 = !a3 && l3 == 1 ? [] : null, u3 = a3 ? i : i + 1, g3 = h3;
      t:
        for (; ; )
          if (c3 < r3.length && g3 == r3[c3].from) {
            if (f3)
              break t;
            let m3 = r3[c3];
            if (!a3)
              for (let p3 = m3.to, b3 = c3 + 1; ; ) {
                if (p3 == e28)
                  break t;
                if (b3 < r3.length && r3[b3].from == p3)
                  p3 = r3[b3++].to;
                else {
                  if (D$w[p3] == l3)
                    break t;
                  break;
                }
              }
            if (c3++, d3)
              d3.push(m3);
            else {
              m3.from > h3 && o3.push(new nt$5(h3, m3.from, u3));
              let p3 = m3.direction == Et$6 != !(u3 % 2);
              Ee$6(n3, p3 ? i + 1 : i, s3, m3.inner, m3.from, m3.to, o3), h3 = m3.to;
            }
            g3 = m3.to;
          } else {
            if (g3 == e28 || (a3 ? D$w[g3] != l3 : D$w[g3] == l3))
              break;
            g3++;
          }
      d3 ? Be$6(n3, h3, g3, i + 1, s3, d3, o3) : h3 < g3 && o3.push(new nt$5(h3, g3, u3)), h3 = g3;
    }
  else
    for (let h3 = e28, c3 = r3.length; h3 > t3; ) {
      let a3 = true, f3 = false;
      if (!c3 || h3 > r3[c3 - 1].to) {
        let m3 = D$w[h3 - 1];
        m3 != l3 && (a3 = false, f3 = m3 == 16);
      }
      let d3 = !a3 && l3 == 1 ? [] : null, u3 = a3 ? i : i + 1, g3 = h3;
      t:
        for (; ; )
          if (c3 && g3 == r3[c3 - 1].to) {
            if (f3)
              break t;
            let m3 = r3[--c3];
            if (!a3)
              for (let p3 = m3.from, b3 = c3; ; ) {
                if (p3 == t3)
                  break t;
                if (b3 && r3[b3 - 1].to == p3)
                  p3 = r3[--b3].from;
                else {
                  if (D$w[p3 - 1] == l3)
                    break t;
                  break;
                }
              }
            if (d3)
              d3.push(m3);
            else {
              m3.to < h3 && o3.push(new nt$5(m3.to, h3, u3));
              let p3 = m3.direction == Et$6 != !(u3 % 2);
              Ee$6(n3, p3 ? i + 1 : i, s3, m3.inner, m3.from, m3.to, o3), h3 = m3.from;
            }
            g3 = m3.from;
          } else {
            if (g3 == t3 || (a3 ? D$w[g3 - 1] != l3 : D$w[g3 - 1] == l3))
              break;
            g3--;
          }
      d3 ? Be$6(n3, g3, h3, i + 1, s3, d3, o3) : g3 < h3 && o3.push(new nt$5(g3, h3, u3)), h3 = g3;
    }
}
function Ee$6(n3, t3, e28, i, s3, r3, o3) {
  let l3 = t3 % 2 ? 2 : 1;
  Bn$1(n3, s3, r3, i, l3), En$2(n3, s3, r3, i, l3), Pn$2(s3, r3, i, l3), Be$6(n3, s3, r3, t3, e28, i, o3);
}
function Hn$1(n3, t3, e28) {
  if (!n3)
    return [new nt$5(0, 0, t3 == Ms$2 ? 1 : 0)];
  if (t3 == Et$6 && !e28.length && !Ln$1.test(n3))
    return Ds$2(n3.length);
  if (e28.length)
    for (; n3.length > D$w.length; )
      D$w[D$w.length] = 256;
  let i = [], s3 = t3 == Et$6 ? 0 : 1;
  return Ee$6(n3, s3, s3, e28, 0, n3.length, i), i;
}
function Ds$2(n3) {
  return [new nt$5(0, n3, 0)];
}
let Os$2 = "";
function Nn$2(n3, t3, e28, i, s3) {
  var r3;
  let o3 = i.head - n3.from, l3 = -1;
  if (o3 == 0) {
    if (!s3 || !n3.length)
      return null;
    t3[0].level != e28 && (o3 = t3[0].side(false, e28), l3 = 0);
  } else if (o3 == n3.length) {
    if (s3)
      return null;
    let d3 = t3[t3.length - 1];
    d3.level != e28 && (o3 = d3.side(true, e28), l3 = t3.length - 1);
  }
  l3 < 0 && (l3 = nt$5.find(t3, o3, (r3 = i.bidiLevel) !== null && r3 !== void 0 ? r3 : -1, i.assoc));
  let h3 = t3[l3];
  o3 == h3.side(s3, e28) && (h3 = t3[l3 += s3 ? 1 : -1], o3 = h3.side(!s3, e28));
  let c3 = s3 == (h3.dir == e28), a3 = K$h(n3.text, o3, c3);
  if (Os$2 = n3.text.slice(Math.min(o3, a3), Math.max(o3, a3)), a3 != h3.side(s3, e28))
    return g$K.cursor(a3 + n3.from, c3 ? -1 : 1, h3.level);
  let f3 = l3 == (s3 ? t3.length - 1 : 0) ? null : t3[l3 + (s3 ? 1 : -1)];
  return !f3 && h3.level != e28 ? g$K.cursor(s3 ? n3.to : n3.from, s3 ? -1 : 1, e28) : f3 && f3.level < h3.level ? g$K.cursor(f3.side(!s3, e28) + n3.from, s3 ? 1 : -1, f3.level) : g$K.cursor(a3 + n3.from, s3 ? -1 : 1, h3.level);
}
class ci$2 extends T$w {
  get length() {
    return this.view.state.doc.length;
  }
  constructor(t3) {
    super(), this.view = t3, this.decorations = [], this.dynamicDecorationMap = [], this.domChanged = null, this.hasComposition = null, this.markedForComposition = /* @__PURE__ */ new Set(), this.minWidth = 0, this.minWidthFrom = 0, this.minWidthTo = 0, this.impreciseAnchor = null, this.impreciseHead = null, this.forceSelection = false, this.lastUpdate = Date.now(), this.setDOM(t3.contentDOM), this.children = [new B$r()], this.children[0].setParent(this), this.updateDeco(), this.updateInner([new q$j(0, 0, 0, t3.state.doc.length)], 0, null);
  }
  update(t3) {
    var e28;
    let i = t3.changedRanges;
    this.minWidth > 0 && i.length && (i.every(({ fromA: c3, toA: a3 }) => a3 < this.minWidthFrom || c3 > this.minWidthTo) ? (this.minWidthFrom = t3.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = t3.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0);
    let s3 = -1;
    this.view.inputState.composing >= 0 && (!((e28 = this.domChanged) === null || e28 === void 0) && e28.newSel ? s3 = this.domChanged.newSel.head : !qn$2(t3.changes, this.hasComposition) && !t3.selectionSet && (s3 = t3.state.selection.main.head));
    let r3 = s3 > -1 ? Wn$2(this.view, t3.changes, s3) : null;
    if (this.domChanged = null, this.hasComposition) {
      this.markedForComposition.clear();
      let { from: c3, to: a3 } = this.hasComposition;
      i = new q$j(c3, a3, t3.changes.mapPos(c3, -1), t3.changes.mapPos(a3, 1)).addToSet(i.slice());
    }
    this.hasComposition = r3 ? { from: r3.range.fromB, to: r3.range.toB } : null, (w$o.ie || w$o.chrome) && !r3 && t3 && t3.state.doc.lines != t3.startState.doc.lines && (this.forceSelection = true);
    let o3 = this.decorations, l3 = this.updateDeco(), h3 = In$2(o3, l3, t3.changes);
    return i = q$j.extendWithRanges(i, h3), !(this.flags & 7) && i.length == 0 ? false : (this.updateInner(i, t3.startState.doc.length, r3), t3.transactions.length && (this.lastUpdate = Date.now()), true);
  }
  updateInner(t3, e28, i) {
    this.view.viewState.mustMeasureContent = true, this.updateChildren(t3, e28, i);
    let { observer: s3 } = this.view;
    s3.ignore(() => {
      this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px", this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let o3 = w$o.chrome || w$o.ios ? { node: s3.selectionRange.focusNode, written: false } : void 0;
      this.sync(this.view, o3), this.flags &= -8, o3 && (o3.written || s3.selectionRange.focusNode != o3.node) && (this.forceSelection = true), this.dom.style.height = "";
    }), this.markedForComposition.forEach((o3) => o3.flags &= -9);
    let r3 = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length)
      for (let o3 of this.children)
        o3 instanceof rt$6 && o3.widget instanceof fi$1 && r3.push(o3.dom);
    s3.updateGaps(r3);
  }
  updateChildren(t3, e28, i) {
    let s3 = i ? i.range.addToSet(t3.slice()) : t3, r3 = this.childCursor(e28);
    for (let o3 = s3.length - 1; ; o3--) {
      let l3 = o3 >= 0 ? s3[o3] : null;
      if (!l3)
        break;
      let { fromA: h3, toA: c3, fromB: a3, toB: f3 } = l3, d3, u3, g3, m3;
      if (i && i.range.fromB < f3 && i.range.toB > a3) {
        let y3 = Ot$5.build(this.view.state.doc, a3, i.range.fromB, this.decorations, this.dynamicDecorationMap), S3 = Ot$5.build(this.view.state.doc, i.range.toB, f3, this.decorations, this.dynamicDecorationMap);
        u3 = y3.breakAtStart, g3 = y3.openStart, m3 = S3.openEnd;
        let C3 = this.compositionView(i);
        S3.breakAtStart ? C3.breakAfter = 1 : S3.content.length && C3.merge(C3.length, C3.length, S3.content[0], false, S3.openStart, 0) && (C3.breakAfter = S3.content[0].breakAfter, S3.content.shift()), y3.content.length && C3.merge(0, 0, y3.content[y3.content.length - 1], true, 0, y3.openEnd) && y3.content.pop(), d3 = y3.content.concat(C3).concat(S3.content);
      } else
        ({ content: d3, breakAtStart: u3, openStart: g3, openEnd: m3 } = Ot$5.build(this.view.state.doc, a3, f3, this.decorations, this.dynamicDecorationMap));
      let { i: p3, off: b3 } = r3.findPos(c3, 1), { i: v3, off: x3 } = r3.findPos(h3, -1);
      ns$1(this, v3, x3, p3, b3, d3, u3, g3, m3);
    }
    i && this.fixCompositionDOM(i);
  }
  compositionView(t3) {
    let e28 = new Z$h(t3.text.nodeValue);
    e28.flags |= 8;
    for (let { deco: s3 } of t3.marks)
      e28 = new Q$h(s3, [e28], e28.length);
    let i = new B$r();
    return i.append(e28, 0), i;
  }
  fixCompositionDOM(t3) {
    let e28 = (r3, o3) => {
      o3.flags |= 8 | (o3.children.some((h3) => h3.flags & 7) ? 1 : 0), this.markedForComposition.add(o3);
      let l3 = T$w.get(r3);
      l3 && l3 != o3 && (l3.dom = null), o3.setDOM(r3);
    }, i = this.childPos(t3.range.fromB, 1), s3 = this.children[i.i];
    e28(t3.line, s3);
    for (let r3 = t3.marks.length - 1; r3 >= -1; r3--)
      i = s3.childPos(i.off, 1), s3 = s3.children[i.i], e28(r3 >= 0 ? t3.marks[r3].node : t3.text, s3);
  }
  updateSelection(t3 = false, e28 = false) {
    (t3 || !this.view.observer.selectionRange.focusNode) && this.view.observer.readSelectionRange();
    let i = this.view.root.activeElement, s3 = i == this.dom, r3 = !s3 && Zt$3(this.dom, this.view.observer.selectionRange) && !(i && this.dom.contains(i));
    if (!(s3 || e28 || r3))
      return;
    let o3 = this.forceSelection;
    this.forceSelection = false;
    let l3 = this.view.state.selection.main, h3 = this.moveToLine(this.domAtPos(l3.anchor)), c3 = l3.empty ? h3 : this.moveToLine(this.domAtPos(l3.head));
    if (w$o.gecko && l3.empty && !this.hasComposition && Vn$1(h3)) {
      let f3 = document.createTextNode("");
      this.view.observer.ignore(() => h3.node.insertBefore(f3, h3.node.childNodes[h3.offset] || null)), h3 = c3 = new H$h(f3, 0), o3 = true;
    }
    let a3 = this.view.observer.selectionRange;
    (o3 || !a3.focusNode || !re$a(h3.node, h3.offset, a3.anchorNode, a3.anchorOffset) || !re$a(c3.node, c3.offset, a3.focusNode, a3.focusOffset)) && (this.view.observer.ignore(() => {
      w$o.android && w$o.chrome && this.dom.contains(a3.focusNode) && Kn$1(a3.focusNode, this.dom) && (this.dom.blur(), this.dom.focus({ preventScroll: true }));
      let f3 = ne$d(this.view.root);
      if (f3)
        if (l3.empty) {
          if (w$o.gecko) {
            let d3 = Fn$2(h3.node, h3.offset);
            if (d3 && d3 != 3) {
              let u3 = Rs$2(h3.node, h3.offset, d3 == 1 ? 1 : -1);
              u3 && (h3 = new H$h(u3.node, u3.offset));
            }
          }
          f3.collapse(h3.node, h3.offset), l3.bidiLevel != null && f3.caretBidiLevel !== void 0 && (f3.caretBidiLevel = l3.bidiLevel);
        } else if (f3.extend) {
          f3.collapse(h3.node, h3.offset);
          try {
            f3.extend(c3.node, c3.offset);
          } catch {
          }
        } else {
          let d3 = document.createRange();
          l3.anchor > l3.head && ([h3, c3] = [c3, h3]), d3.setEnd(c3.node, c3.offset), d3.setStart(h3.node, h3.offset), f3.removeAllRanges(), f3.addRange(d3);
        }
      r3 && this.view.root.activeElement == this.dom && (this.dom.blur(), i && i.focus());
    }), this.view.observer.setSelectionRange(h3, c3)), this.impreciseAnchor = h3.precise ? null : new H$h(a3.anchorNode, a3.anchorOffset), this.impreciseHead = c3.precise ? null : new H$h(a3.focusNode, a3.focusOffset);
  }
  enforceCursorAssoc() {
    if (this.hasComposition)
      return;
    let { view: t3 } = this, e28 = t3.state.selection.main, i = ne$d(t3.root), { anchorNode: s3, anchorOffset: r3 } = t3.observer.selectionRange;
    if (!i || !e28.empty || !e28.assoc || !i.modify)
      return;
    let o3 = B$r.find(this, e28.head);
    if (!o3)
      return;
    let l3 = o3.posAtStart;
    if (e28.head == l3 || e28.head == l3 + o3.length)
      return;
    let h3 = this.coordsAt(e28.head, -1), c3 = this.coordsAt(e28.head, 1);
    if (!h3 || !c3 || h3.bottom > c3.top)
      return;
    let a3 = this.domAtPos(e28.head + e28.assoc);
    i.collapse(a3.node, a3.offset), i.modify("move", e28.assoc < 0 ? "forward" : "backward", "lineboundary"), t3.observer.readSelectionRange();
    let f3 = t3.observer.selectionRange;
    t3.docView.posFromDOM(f3.anchorNode, f3.anchorOffset) != e28.from && i.collapse(s3, r3);
  }
  moveToLine(t3) {
    let e28 = this.dom, i;
    if (t3.node != e28)
      return t3;
    for (let s3 = t3.offset; !i && s3 < e28.childNodes.length; s3++) {
      let r3 = T$w.get(e28.childNodes[s3]);
      r3 instanceof B$r && (i = r3.domAtPos(0));
    }
    for (let s3 = t3.offset - 1; !i && s3 >= 0; s3--) {
      let r3 = T$w.get(e28.childNodes[s3]);
      r3 instanceof B$r && (i = r3.domAtPos(r3.length));
    }
    return i ? new H$h(i.node, i.offset, true) : t3;
  }
  nearest(t3) {
    for (let e28 = t3; e28; ) {
      let i = T$w.get(e28);
      if (i && i.rootView == this)
        return i;
      e28 = e28.parentNode;
    }
    return null;
  }
  posFromDOM(t3, e28) {
    let i = this.nearest(t3);
    if (!i)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return i.localPosFromDOM(t3, e28) + i.posAtStart;
  }
  domAtPos(t3) {
    let { i: e28, off: i } = this.childCursor().findPos(t3, -1);
    for (; e28 < this.children.length - 1; ) {
      let s3 = this.children[e28];
      if (i < s3.length || s3 instanceof B$r)
        break;
      e28++, i = 0;
    }
    return this.children[e28].domAtPos(i);
  }
  coordsAt(t3, e28) {
    let i = null, s3 = 0;
    for (let r3 = this.length, o3 = this.children.length - 1; o3 >= 0; o3--) {
      let l3 = this.children[o3], h3 = r3 - l3.breakAfter, c3 = h3 - l3.length;
      if (h3 < t3)
        break;
      c3 <= t3 && (c3 < t3 || l3.covers(-1)) && (h3 > t3 || l3.covers(1)) && (!i || l3 instanceof B$r && !(i instanceof B$r && e28 >= 0)) && (i = l3, s3 = c3), r3 = c3;
    }
    return i ? i.coordsAt(t3 - s3, e28) : null;
  }
  coordsForChar(t3) {
    let { i: e28, off: i } = this.childPos(t3, 1), s3 = this.children[e28];
    if (!(s3 instanceof B$r))
      return null;
    for (; s3.children.length; ) {
      let { i: l3, off: h3 } = s3.childPos(i, 1);
      for (; ; l3++) {
        if (l3 == s3.children.length)
          return null;
        if ((s3 = s3.children[l3]).length)
          break;
      }
      i = h3;
    }
    if (!(s3 instanceof Z$h))
      return null;
    let r3 = K$h(s3.text, i);
    if (r3 == i)
      return null;
    let o3 = ft$5(s3.dom, i, r3).getClientRects();
    for (let l3 = 0; l3 < o3.length; l3++) {
      let h3 = o3[l3];
      if (l3 == o3.length - 1 || h3.top < h3.bottom && h3.left < h3.right)
        return h3;
    }
    return null;
  }
  measureVisibleLineHeights(t3) {
    let e28 = [], { from: i, to: s3 } = t3, r3 = this.view.contentDOM.clientWidth, o3 = r3 > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, l3 = -1, h3 = this.view.textDirection == L$r.LTR;
    for (let c3 = 0, a3 = 0; a3 < this.children.length; a3++) {
      let f3 = this.children[a3], d3 = c3 + f3.length;
      if (d3 > s3)
        break;
      if (c3 >= i) {
        let u3 = f3.dom.getBoundingClientRect();
        if (e28.push(u3.height), o3) {
          let g3 = f3.dom.lastChild, m3 = g3 ? Rt$5(g3) : [];
          if (m3.length) {
            let p3 = m3[m3.length - 1], b3 = h3 ? p3.right - u3.left : u3.right - p3.left;
            b3 > l3 && (l3 = b3, this.minWidth = r3, this.minWidthFrom = c3, this.minWidthTo = d3);
          }
        }
      }
      c3 = d3 + f3.breakAfter;
    }
    return e28;
  }
  textDirectionAt(t3) {
    let { i: e28 } = this.childPos(t3, 1);
    return getComputedStyle(this.children[e28].dom).direction == "rtl" ? L$r.RTL : L$r.LTR;
  }
  measureTextSize() {
    for (let r3 of this.children)
      if (r3 instanceof B$r) {
        let o3 = r3.measureTextSize();
        if (o3)
          return o3;
      }
    let t3 = document.createElement("div"), e28, i, s3;
    return t3.className = "cm-line", t3.style.width = "99999px", t3.style.position = "absolute", t3.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(() => {
      this.dom.appendChild(t3);
      let r3 = Rt$5(t3.firstChild)[0];
      e28 = t3.getBoundingClientRect().height, i = r3 ? r3.width / 27 : 7, s3 = r3 ? r3.height : e28, t3.remove();
    }), { lineHeight: e28, charWidth: i, textHeight: s3 };
  }
  childCursor(t3 = this.length) {
    let e28 = this.children.length;
    return e28 && (t3 -= this.children[--e28].length), new ss$2(this.children, t3, e28);
  }
  computeBlockGapDeco() {
    let t3 = [], e28 = this.view.viewState;
    for (let i = 0, s3 = 0; ; s3++) {
      let r3 = s3 == e28.viewports.length ? null : e28.viewports[s3], o3 = r3 ? r3.from - 1 : this.length;
      if (o3 > i) {
        let l3 = (e28.lineBlockAt(o3).bottom - e28.lineBlockAt(i).top) / this.view.scaleY;
        t3.push(V$j.replace({
          widget: new fi$1(l3),
          block: true,
          inclusive: true,
          isBlockGap: true
        }).range(i, o3));
      }
      if (!r3)
        break;
      i = r3.to + 1;
    }
    return V$j.set(t3);
  }
  updateDeco() {
    let t3 = this.view.state.facet(Bt$4).map((e28, i) => (this.dynamicDecorationMap[i] = typeof e28 == "function") ? e28(this.view) : e28);
    for (let e28 = t3.length; e28 < t3.length + 3; e28++)
      this.dynamicDecorationMap[e28] = false;
    return this.decorations = [
      ...t3,
      this.computeBlockGapDeco(),
      this.view.viewState.lineGapDeco
    ];
  }
  scrollIntoView(t3) {
    let { range: e28 } = t3, i = this.coordsAt(e28.head, e28.empty ? e28.assoc : e28.head > e28.anchor ? -1 : 1), s3;
    if (!i)
      return;
    !e28.empty && (s3 = this.coordsAt(e28.anchor, e28.anchor > e28.head ? -1 : 1)) && (i = {
      left: Math.min(i.left, s3.left),
      top: Math.min(i.top, s3.top),
      right: Math.max(i.right, s3.right),
      bottom: Math.max(i.bottom, s3.bottom)
    });
    let r3 = Cs$2(this.view), o3 = {
      left: i.left - r3.left,
      top: i.top - r3.top,
      right: i.right + r3.right,
      bottom: i.bottom + r3.bottom
    };
    bn$2(this.view.scrollDOM, o3, e28.head < e28.anchor ? -1 : 1, t3.x, t3.y, t3.xMargin, t3.yMargin, this.view.textDirection == L$r.LTR);
  }
}
function Vn$1(n3) {
  return n3.node.nodeType == 1 && n3.node.firstChild && (n3.offset == 0 || n3.node.childNodes[n3.offset - 1].contentEditable == "false") && (n3.offset == n3.node.childNodes.length || n3.node.childNodes[n3.offset].contentEditable == "false");
}
class fi$1 extends Nt$4 {
  constructor(t3) {
    super(), this.height = t3;
  }
  toDOM() {
    let t3 = document.createElement("div");
    return this.updateDOM(t3), t3;
  }
  eq(t3) {
    return t3.height == this.height;
  }
  updateDOM(t3) {
    return t3.style.height = this.height + "px", true;
  }
  get estimatedHeight() {
    return this.height;
  }
}
function Ts$2(n3, t3) {
  let e28 = n3.observer.selectionRange, i = e28.focusNode && Rs$2(e28.focusNode, e28.focusOffset, 0);
  if (!i)
    return null;
  let s3 = t3 - i.offset;
  return { from: s3, to: s3 + i.node.nodeValue.length, node: i.node };
}
function Wn$2(n3, t3, e28) {
  let i = Ts$2(n3, e28);
  if (!i)
    return null;
  let { node: s3, from: r3, to: o3 } = i, l3 = s3.nodeValue;
  if (/[\n\r]/.test(l3) || n3.state.doc.sliceString(i.from, i.to) != l3)
    return null;
  let h3 = t3.invertedDesc, c3 = new q$j(h3.mapPos(r3), h3.mapPos(o3), r3, o3), a3 = [];
  for (let f3 = s3.parentNode; ; f3 = f3.parentNode) {
    let d3 = T$w.get(f3);
    if (d3 instanceof Q$h)
      a3.push({ node: f3, deco: d3.mark });
    else {
      if (d3 instanceof B$r || f3.nodeName == "DIV" && f3.parentNode == n3.contentDOM)
        return { range: c3, text: s3, marks: a3, line: f3 };
      if (f3 != n3.contentDOM)
        a3.push({ node: f3, deco: new Vt$3({
          inclusive: true,
          attributes: kn$2(f3),
          tagName: f3.tagName.toLowerCase()
        }) });
      else
        return null;
    }
  }
}
function Rs$2(n3, t3, e28) {
  if (e28 <= 0)
    for (let i = n3, s3 = t3; ; ) {
      if (i.nodeType == 3)
        return { node: i, offset: s3 };
      if (i.nodeType == 1 && s3 > 0)
        i = i.childNodes[s3 - 1], s3 = J$g(i);
      else
        break;
    }
  if (e28 >= 0)
    for (let i = n3, s3 = t3; ; ) {
      if (i.nodeType == 3)
        return { node: i, offset: s3 };
      if (i.nodeType == 1 && s3 < i.childNodes.length && e28 >= 0)
        i = i.childNodes[s3], s3 = 0;
      else
        break;
    }
  return null;
}
function Fn$2(n3, t3) {
  return n3.nodeType != 1 ? 0 : (t3 && n3.childNodes[t3 - 1].contentEditable == "false" ? 1 : 0) | (t3 < n3.childNodes.length && n3.childNodes[t3].contentEditable == "false" ? 2 : 0);
}
let zn$1 = class {
  constructor() {
    this.changes = [];
  }
  compareRange(t3, e28) {
    Te$8(t3, e28, this.changes);
  }
  comparePoint(t3, e28) {
    Te$8(t3, e28, this.changes);
  }
};
function In$2(n3, t3, e28) {
  let i = new zn$1();
  return P$F.compare(n3, t3, e28, i), i.changes;
}
function Kn$1(n3, t3) {
  for (let e28 = n3; e28 && e28 != t3; e28 = e28.assignedSlot || e28.parentNode)
    if (e28.nodeType == 1 && e28.contentEditable == "false")
      return true;
  return false;
}
function qn$2(n3, t3) {
  let e28 = false;
  return t3 && n3.iterChangedRanges((i, s3) => {
    i < t3.to && s3 > t3.from && (e28 = true);
  }), e28;
}
function jn$2(n3, t3, e28 = 1) {
  let i = n3.charCategorizer(t3), s3 = n3.doc.lineAt(t3), r3 = t3 - s3.from;
  if (s3.length == 0)
    return g$K.cursor(t3);
  r3 == 0 ? e28 = 1 : r3 == s3.length && (e28 = -1);
  let o3 = r3, l3 = r3;
  e28 < 0 ? o3 = K$h(s3.text, r3, false) : l3 = K$h(s3.text, r3);
  let h3 = i(s3.text.slice(o3, l3));
  for (; o3 > 0; ) {
    let c3 = K$h(s3.text, o3, false);
    if (i(s3.text.slice(c3, o3)) != h3)
      break;
    o3 = c3;
  }
  for (; l3 < s3.length; ) {
    let c3 = K$h(s3.text, l3);
    if (i(s3.text.slice(l3, c3)) != h3)
      break;
    l3 = c3;
  }
  return g$K.range(o3 + s3.from, l3 + s3.from);
}
function Yn$3(n3, t3) {
  return t3.left > n3 ? t3.left - n3 : Math.max(0, n3 - t3.right);
}
function Gn$1(n3, t3) {
  return t3.top > n3 ? t3.top - n3 : Math.max(0, n3 - t3.bottom);
}
function ge$a(n3, t3) {
  return n3.top < t3.bottom - 1 && n3.bottom > t3.top + 1;
}
function di$1(n3, t3) {
  return t3 < n3.top ? { top: t3, left: n3.left, right: n3.right, bottom: n3.bottom } : n3;
}
function ui$2(n3, t3) {
  return t3 > n3.bottom ? { top: n3.top, left: n3.left, right: n3.right, bottom: t3 } : n3;
}
function Pe$8(n3, t3, e28) {
  let i, s3, r3, o3, l3 = false, h3, c3, a3, f3;
  for (let g3 = n3.firstChild; g3; g3 = g3.nextSibling) {
    let m3 = Rt$5(g3);
    for (let p3 = 0; p3 < m3.length; p3++) {
      let b3 = m3[p3];
      s3 && ge$a(s3, b3) && (b3 = di$1(ui$2(b3, s3.bottom), s3.top));
      let v3 = Yn$3(t3, b3), x3 = Gn$1(e28, b3);
      if (v3 == 0 && x3 == 0)
        return g3.nodeType == 3 ? gi$2(g3, t3, e28) : Pe$8(g3, t3, e28);
      if (!i || o3 > x3 || o3 == x3 && r3 > v3) {
        i = g3, s3 = b3, r3 = v3, o3 = x3;
        let y3 = x3 ? e28 < b3.top ? -1 : 1 : v3 ? t3 < b3.left ? -1 : 1 : 0;
        l3 = !y3 || (y3 > 0 ? p3 < m3.length - 1 : p3 > 0);
      }
      v3 == 0 ? e28 > b3.bottom && (!a3 || a3.bottom < b3.bottom) ? (h3 = g3, a3 = b3) : e28 < b3.top && (!f3 || f3.top > b3.top) && (c3 = g3, f3 = b3) : a3 && ge$a(a3, b3) ? a3 = ui$2(a3, b3.bottom) : f3 && ge$a(f3, b3) && (f3 = di$1(f3, b3.top));
    }
  }
  if (a3 && a3.bottom >= e28 ? (i = h3, s3 = a3) : f3 && f3.top <= e28 && (i = c3, s3 = f3), !i)
    return { node: n3, offset: 0 };
  let d3 = Math.max(s3.left, Math.min(s3.right, t3));
  if (i.nodeType == 3)
    return gi$2(i, d3, e28);
  if (l3 && i.contentEditable != "false")
    return Pe$8(i, d3, e28);
  let u3 = Array.prototype.indexOf.call(n3.childNodes, i) + (t3 >= (s3.left + s3.right) / 2 ? 1 : 0);
  return { node: n3, offset: u3 };
}
function gi$2(n3, t3, e28) {
  let i = n3.nodeValue.length, s3 = -1, r3 = 1e9, o3 = 0;
  for (let l3 = 0; l3 < i; l3++) {
    let h3 = ft$5(n3, l3, l3 + 1).getClientRects();
    for (let c3 = 0; c3 < h3.length; c3++) {
      let a3 = h3[c3];
      if (a3.top == a3.bottom)
        continue;
      o3 || (o3 = t3 - a3.left);
      let f3 = (a3.top > e28 ? a3.top - e28 : e28 - a3.bottom) - 1;
      if (a3.left - 1 <= t3 && a3.right + 1 >= t3 && f3 < r3) {
        let d3 = t3 >= (a3.left + a3.right) / 2, u3 = d3;
        if ((w$o.chrome || w$o.gecko) && ft$5(n3, l3).getBoundingClientRect().left == a3.right && (u3 = !d3), f3 <= 0)
          return { node: n3, offset: l3 + (u3 ? 1 : 0) };
        s3 = l3 + (u3 ? 1 : 0), r3 = f3;
      }
    }
  }
  return { node: n3, offset: s3 > -1 ? s3 : o3 > 0 ? n3.nodeValue.length : 0 };
}
function Ls$2(n3, t3, e28, i = -1) {
  var s3, r3;
  let o3 = n3.contentDOM.getBoundingClientRect(), l3 = o3.top + n3.viewState.paddingTop, h3, { docHeight: c3 } = n3.viewState, { x: a3, y: f3 } = t3, d3 = f3 - l3;
  if (d3 < 0)
    return 0;
  if (d3 > c3)
    return n3.state.doc.length;
  for (let y3 = n3.viewState.heightOracle.textHeight / 2, S3 = false; h3 = n3.elementAtHeight(d3), h3.type != N$w.Text; )
    for (; d3 = i > 0 ? h3.bottom + y3 : h3.top - y3, !(d3 >= 0 && d3 <= c3); ) {
      if (S3)
        return e28 ? null : 0;
      S3 = true, i = -i;
    }
  f3 = l3 + d3;
  let u3 = h3.from;
  if (u3 < n3.viewport.from)
    return n3.viewport.from == 0 ? 0 : e28 ? null : pi$1(n3, o3, h3, a3, f3);
  if (u3 > n3.viewport.to)
    return n3.viewport.to == n3.state.doc.length ? n3.state.doc.length : e28 ? null : pi$1(n3, o3, h3, a3, f3);
  let g3 = n3.dom.ownerDocument, m3 = n3.root.elementFromPoint ? n3.root : g3, p3 = m3.elementFromPoint(a3, f3);
  p3 && !n3.contentDOM.contains(p3) && (p3 = null), p3 || (a3 = Math.max(o3.left + 1, Math.min(o3.right - 1, a3)), p3 = m3.elementFromPoint(a3, f3), p3 && !n3.contentDOM.contains(p3) && (p3 = null));
  let b3, v3 = -1;
  if (p3 && ((s3 = n3.docView.nearest(p3)) === null || s3 === void 0 ? void 0 : s3.isEditable) != false) {
    if (g3.caretPositionFromPoint) {
      let y3 = g3.caretPositionFromPoint(a3, f3);
      y3 && ({ offsetNode: b3, offset: v3 } = y3);
    } else if (g3.caretRangeFromPoint) {
      let y3 = g3.caretRangeFromPoint(a3, f3);
      y3 && ({ startContainer: b3, startOffset: v3 } = y3, (!n3.contentDOM.contains(b3) || w$o.safari && _n$1(b3, v3, a3) || w$o.chrome && Xn$2(b3, v3, a3)) && (b3 = void 0));
    }
  }
  if (!b3 || !n3.docView.dom.contains(b3)) {
    let y3 = B$r.find(n3.docView, u3);
    if (!y3)
      return d3 > h3.top + h3.height / 2 ? h3.to : h3.from;
    ({ node: b3, offset: v3 } = Pe$8(y3.dom, a3, f3));
  }
  let x3 = n3.docView.nearest(b3);
  if (!x3)
    return null;
  if (x3.isWidget && ((r3 = x3.dom) === null || r3 === void 0 ? void 0 : r3.nodeType) == 1) {
    let y3 = x3.dom.getBoundingClientRect();
    return t3.y < y3.top || t3.y <= y3.bottom && t3.x <= (y3.left + y3.right) / 2 ? x3.posAtStart : x3.posAtEnd;
  } else
    return x3.localPosFromDOM(b3, v3) + x3.posAtStart;
}
function pi$1(n3, t3, e28, i, s3) {
  let r3 = Math.round((i - t3.left) * n3.defaultCharacterWidth);
  if (n3.lineWrapping && e28.height > n3.defaultLineHeight * 1.5) {
    let l3 = n3.viewState.heightOracle.textHeight, h3 = Math.floor((s3 - e28.top - (n3.defaultLineHeight - l3) * 0.5) / l3);
    r3 += h3 * n3.viewState.heightOracle.lineLength;
  }
  let o3 = n3.state.sliceDoc(e28.from, e28.to);
  return e28.from + at$5(o3, r3, n3.state.tabSize);
}
function _n$1(n3, t3, e28) {
  let i;
  if (n3.nodeType != 3 || t3 != (i = n3.nodeValue.length))
    return false;
  for (let s3 = n3.nextSibling; s3; s3 = s3.nextSibling)
    if (s3.nodeType != 1 || s3.nodeName != "BR")
      return false;
  return ft$5(n3, i - 1, i).getBoundingClientRect().left > e28;
}
function Xn$2(n3, t3, e28) {
  if (t3 != 0)
    return false;
  for (let s3 = n3; ; ) {
    let r3 = s3.parentNode;
    if (!r3 || r3.nodeType != 1 || r3.firstChild != s3)
      return false;
    if (r3.classList.contains("cm-line"))
      break;
    s3 = r3;
  }
  let i = n3.nodeType == 1 ? n3.getBoundingClientRect() : ft$5(n3, 0, Math.max(n3.nodeValue.length, 1)).getBoundingClientRect();
  return e28 - i.left > 5;
}
function He$5(n3, t3) {
  let e28 = n3.lineBlockAt(t3);
  if (Array.isArray(e28.type)) {
    for (let i of e28.type)
      if (i.to > t3 || i.to == t3 && (i.to == e28.to || i.type == N$w.Text))
        return i;
  }
  return e28;
}
function $n$1(n3, t3, e28, i) {
  let s3 = He$5(n3, t3.head), r3 = !i || s3.type != N$w.Text || !(n3.lineWrapping || s3.widgetLineBreaks) ? null : n3.coordsAtPos(t3.assoc < 0 && t3.head > s3.from ? t3.head - 1 : t3.head);
  if (r3) {
    let o3 = n3.dom.getBoundingClientRect(), l3 = n3.textDirectionAt(s3.from), h3 = n3.posAtCoords({
      x: e28 == (l3 == L$r.LTR) ? o3.right - 1 : o3.left + 1,
      y: (r3.top + r3.bottom) / 2
    });
    if (h3 != null)
      return g$K.cursor(h3, e28 ? -1 : 1);
  }
  return g$K.cursor(e28 ? s3.to : s3.from, e28 ? -1 : 1);
}
function mi$1(n3, t3, e28, i) {
  let s3 = n3.state.doc.lineAt(t3.head), r3 = n3.bidiSpans(s3), o3 = n3.textDirectionAt(s3.from);
  for (let l3 = t3, h3 = null; ; ) {
    let c3 = Nn$2(s3, r3, o3, l3, e28), a3 = Os$2;
    if (!c3) {
      if (s3.number == (e28 ? n3.state.doc.lines : 1))
        return l3;
      a3 = `
`, s3 = n3.state.doc.line(s3.number + (e28 ? 1 : -1)), r3 = n3.bidiSpans(s3), c3 = g$K.cursor(e28 ? s3.from : s3.to);
    }
    if (h3) {
      if (!h3(a3))
        return l3;
    } else {
      if (!i)
        return c3;
      h3 = i(a3);
    }
    l3 = c3;
  }
}
function Un$1(n3, t3, e28) {
  let i = n3.state.charCategorizer(t3), s3 = i(e28);
  return (r3) => {
    let o3 = i(r3);
    return s3 == T$x.Space && (s3 = o3), s3 == o3;
  };
}
function Jn$2(n3, t3, e28, i) {
  let s3 = t3.head, r3 = e28 ? 1 : -1;
  if (s3 == (e28 ? n3.state.doc.length : 0))
    return g$K.cursor(s3, t3.assoc);
  let o3 = t3.goalColumn, l3, h3 = n3.contentDOM.getBoundingClientRect(), c3 = n3.coordsAtPos(s3, t3.assoc || -1), a3 = n3.documentTop;
  if (c3)
    o3 == null && (o3 = c3.left - h3.left), l3 = r3 < 0 ? c3.top : c3.bottom;
  else {
    let u3 = n3.viewState.lineBlockAt(s3);
    o3 == null && (o3 = Math.min(h3.right - h3.left, n3.defaultCharacterWidth * (s3 - u3.from))), l3 = (r3 < 0 ? u3.top : u3.bottom) + a3;
  }
  let f3 = h3.left + o3, d3 = i != null ? i : n3.viewState.heightOracle.textHeight >> 1;
  for (let u3 = 0; ; u3 += 10) {
    let g3 = l3 + (d3 + u3) * r3, m3 = Ls$2(n3, { x: f3, y: g3 }, false, r3);
    if (g3 < h3.top || g3 > h3.bottom || (r3 < 0 ? m3 < s3 : m3 > s3)) {
      let p3 = n3.docView.coordsForChar(m3), b3 = !p3 || g3 < p3.top ? -1 : 1;
      return g$K.cursor(m3, b3, void 0, o3);
    }
  }
}
function Qt$3(n3, t3, e28) {
  for (; ; ) {
    let i = 0;
    for (let s3 of n3)
      s3.between(t3 - 1, t3 + 1, (r3, o3, l3) => {
        if (t3 > r3 && t3 < o3) {
          let h3 = i || e28 || (t3 - r3 < o3 - t3 ? -1 : 1);
          t3 = h3 < 0 ? r3 : o3, i = h3;
        }
      });
    if (!i)
      return t3;
  }
}
function pe$b(n3, t3, e28) {
  let i = Qt$3(n3.state.facet(Ue$4).map((s3) => s3(n3)), e28.from, t3.head > e28.from ? -1 : 1);
  return i == e28.from ? e28 : g$K.cursor(i, i < e28.from ? 1 : -1);
}
class Zn$2 {
  setSelectionOrigin(t3) {
    this.lastSelectionOrigin = t3, this.lastSelectionTime = Date.now();
  }
  constructor(t3) {
    this.view = t3, this.lastKeyCode = 0, this.lastKeyTime = 0, this.lastTouchTime = 0, this.lastFocusTime = 0, this.lastScrollTop = 0, this.lastScrollLeft = 0, this.pendingIOSKey = void 0, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastEscPress = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.handlers = /* @__PURE__ */ Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.compositionPendingKey = false, this.compositionPendingChange = false, this.mouseSelection = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = t3.hasFocus, w$o.safari && t3.contentDOM.addEventListener("input", () => null), w$o.gecko && gr$2(t3.contentDOM.ownerDocument);
  }
  handleEvent(t3) {
    !or$2(this.view, t3) || this.ignoreDuringComposition(t3) || t3.type == "keydown" && this.keydown(t3) || this.runHandlers(t3.type, t3);
  }
  runHandlers(t3, e28) {
    let i = this.handlers[t3];
    if (i) {
      for (let s3 of i.observers)
        s3(this.view, e28);
      for (let s3 of i.handlers) {
        if (e28.defaultPrevented)
          break;
        if (s3(this.view, e28)) {
          e28.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(t3) {
    let e28 = Qn$2(t3), i = this.handlers, s3 = this.view.contentDOM;
    for (let r3 in e28)
      if (r3 != "scroll") {
        let o3 = !e28[r3].handlers.length, l3 = i[r3];
        l3 && o3 != !l3.handlers.length && (s3.removeEventListener(r3, this.handleEvent), l3 = null), l3 || s3.addEventListener(r3, this.handleEvent, { passive: o3 });
      }
    for (let r3 in i)
      r3 != "scroll" && !e28[r3] && s3.removeEventListener(r3, this.handleEvent);
    this.handlers = e28;
  }
  keydown(t3) {
    if (this.lastKeyCode = t3.keyCode, this.lastKeyTime = Date.now(), t3.keyCode == 9 && Date.now() < this.lastEscPress + 2e3)
      return true;
    if (t3.keyCode != 27 && Es$2.indexOf(t3.keyCode) < 0 && (this.view.inputState.lastEscPress = 0), w$o.android && w$o.chrome && !t3.synthetic && (t3.keyCode == 13 || t3.keyCode == 8))
      return this.view.observer.delayAndroidKey(t3.key, t3.keyCode), true;
    let e28;
    return w$o.ios && !t3.synthetic && !t3.altKey && !t3.metaKey && ((e28 = Bs$2.find((i) => i.keyCode == t3.keyCode)) && !t3.ctrlKey || tr$1.indexOf(t3.key) > -1 && t3.ctrlKey && !t3.shiftKey) ? (this.pendingIOSKey = e28 || t3, setTimeout(() => this.flushIOSKey(), 250), true) : (t3.keyCode != 229 && this.view.observer.forceFlush(), false);
  }
  flushIOSKey() {
    let t3 = this.pendingIOSKey;
    return t3 ? (this.pendingIOSKey = void 0, bt$5(this.view.contentDOM, t3.key, t3.keyCode)) : false;
  }
  ignoreDuringComposition(t3) {
    return /^key/.test(t3.type) ? this.composing > 0 ? true : w$o.safari && !w$o.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100 ? (this.compositionPendingKey = false, true) : false : false;
  }
  startMouseSelection(t3) {
    this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = t3;
  }
  update(t3) {
    this.mouseSelection && this.mouseSelection.update(t3), t3.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
  }
  destroy() {
    this.mouseSelection && this.mouseSelection.destroy();
  }
}
function bi$2(n3, t3) {
  return (e28, i) => {
    try {
      return t3.call(n3, i, e28);
    } catch (s3) {
      ct$6(e28.state, s3);
    }
  };
}
function Qn$2(n3) {
  let t3 = /* @__PURE__ */ Object.create(null);
  function e28(i) {
    return t3[i] || (t3[i] = { observers: [], handlers: [] });
  }
  for (let i of n3) {
    let s3 = i.spec;
    if (s3 && s3.domEventHandlers)
      for (let r3 in s3.domEventHandlers) {
        let o3 = s3.domEventHandlers[r3];
        o3 && e28(r3).handlers.push(bi$2(i.value, o3));
      }
    if (s3 && s3.domEventObservers)
      for (let r3 in s3.domEventObservers) {
        let o3 = s3.domEventObservers[r3];
        o3 && e28(r3).observers.push(bi$2(i.value, o3));
      }
  }
  for (let i in X$g)
    e28(i).handlers.push(X$g[i]);
  for (let i in j$f)
    e28(i).observers.push(j$f[i]);
  return t3;
}
const Bs$2 = [
  { key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" },
  { key: "Enter", keyCode: 13, inputType: "insertParagraph" },
  { key: "Enter", keyCode: 13, inputType: "insertLineBreak" },
  { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }
], tr$1 = "dthko", Es$2 = [16, 17, 18, 20, 91, 92, 224, 225], jt$4 = 6;
function Yt$4(n3) {
  return Math.max(0, n3) * 0.7 + 8;
}
function er$1(n3, t3) {
  return Math.max(Math.abs(n3.clientX - t3.clientX), Math.abs(n3.clientY - t3.clientY));
}
class ir$1 {
  constructor(t3, e28, i, s3) {
    this.view = t3, this.startEvent = e28, this.style = i, this.mustSelect = s3, this.scrollSpeed = { x: 0, y: 0 }, this.scrolling = -1, this.lastEvent = e28, this.scrollParent = wn$1(t3.contentDOM), this.atoms = t3.state.facet(Ue$4).map((o3) => o3(t3));
    let r3 = t3.contentDOM.ownerDocument;
    r3.addEventListener("mousemove", this.move = this.move.bind(this)), r3.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = e28.shiftKey, this.multiple = t3.state.facet(w$q.allowMultipleSelections) && sr$3(t3, e28), this.dragging = rr$1(t3, e28) && Vs$2(e28) == 1 ? null : false;
  }
  start(t3) {
    this.dragging === false && this.select(t3);
  }
  move(t3) {
    var e28;
    if (t3.buttons == 0)
      return this.destroy();
    if (this.dragging || this.dragging == null && er$1(this.startEvent, t3) < 10)
      return;
    this.select(this.lastEvent = t3);
    let i = 0, s3 = 0, r3 = ((e28 = this.scrollParent) === null || e28 === void 0 ? void 0 : e28.getBoundingClientRect()) || { left: 0, top: 0, right: this.view.win.innerWidth, bottom: this.view.win.innerHeight }, o3 = Cs$2(this.view);
    t3.clientX - o3.left <= r3.left + jt$4 ? i = -Yt$4(r3.left - t3.clientX) : t3.clientX + o3.right >= r3.right - jt$4 && (i = Yt$4(t3.clientX - r3.right)), t3.clientY - o3.top <= r3.top + jt$4 ? s3 = -Yt$4(r3.top - t3.clientY) : t3.clientY + o3.bottom >= r3.bottom - jt$4 && (s3 = Yt$4(t3.clientY - r3.bottom)), this.setScrollSpeed(i, s3);
  }
  up(t3) {
    this.dragging == null && this.select(this.lastEvent), this.dragging || t3.preventDefault(), this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let t3 = this.view.contentDOM.ownerDocument;
    t3.removeEventListener("mousemove", this.move), t3.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = null;
  }
  setScrollSpeed(t3, e28) {
    this.scrollSpeed = { x: t3, y: e28 }, t3 || e28 ? this.scrolling < 0 && (this.scrolling = setInterval(() => this.scroll(), 50)) : this.scrolling > -1 && (clearInterval(this.scrolling), this.scrolling = -1);
  }
  scroll() {
    this.scrollParent ? (this.scrollParent.scrollLeft += this.scrollSpeed.x, this.scrollParent.scrollTop += this.scrollSpeed.y) : this.view.win.scrollBy(this.scrollSpeed.x, this.scrollSpeed.y), this.dragging === false && this.select(this.lastEvent);
  }
  skipAtoms(t3) {
    let e28 = null;
    for (let i = 0; i < t3.ranges.length; i++) {
      let s3 = t3.ranges[i], r3 = null;
      if (s3.empty) {
        let o3 = Qt$3(this.atoms, s3.from, 0);
        o3 != s3.from && (r3 = g$K.cursor(o3, -1));
      } else {
        let o3 = Qt$3(this.atoms, s3.from, -1), l3 = Qt$3(this.atoms, s3.to, 1);
        (o3 != s3.from || l3 != s3.to) && (r3 = g$K.range(s3.from == s3.anchor ? o3 : l3, s3.from == s3.head ? o3 : l3));
      }
      r3 && (e28 || (e28 = t3.ranges.slice()), e28[i] = r3);
    }
    return e28 ? g$K.create(e28, t3.mainIndex) : t3;
  }
  select(t3) {
    let { view: e28 } = this, i = this.skipAtoms(this.style.get(t3, this.extend, this.multiple));
    (this.mustSelect || !i.eq(e28.state.selection) || i.main.assoc != e28.state.selection.main.assoc && this.dragging === false) && this.view.dispatch({
      selection: i,
      userEvent: "select.pointer"
    }), this.mustSelect = false;
  }
  update(t3) {
    t3.docChanged && this.dragging && (this.dragging = this.dragging.map(t3.changes)), this.style.update(t3) && setTimeout(() => this.select(this.lastEvent), 20);
  }
}
function sr$3(n3, t3) {
  let e28 = n3.state.facet(ds$2);
  return e28.length ? e28[0](t3) : w$o.mac ? t3.metaKey : t3.ctrlKey;
}
function nr$1(n3, t3) {
  let e28 = n3.state.facet(us$2);
  return e28.length ? e28[0](t3) : w$o.mac ? !t3.altKey : !t3.ctrlKey;
}
function rr$1(n3, t3) {
  let { main: e28 } = n3.state.selection;
  if (e28.empty)
    return false;
  let i = ne$d(n3.root);
  if (!i || i.rangeCount == 0)
    return true;
  let s3 = i.getRangeAt(0).getClientRects();
  for (let r3 = 0; r3 < s3.length; r3++) {
    let o3 = s3[r3];
    if (o3.left <= t3.clientX && o3.right >= t3.clientX && o3.top <= t3.clientY && o3.bottom >= t3.clientY)
      return true;
  }
  return false;
}
function or$2(n3, t3) {
  if (!t3.bubbles)
    return true;
  if (t3.defaultPrevented)
    return false;
  for (let e28 = t3.target, i; e28 != n3.contentDOM; e28 = e28.parentNode)
    if (!e28 || e28.nodeType == 11 || (i = T$w.get(e28)) && i.ignoreEvent(t3))
      return false;
  return true;
}
const X$g = /* @__PURE__ */ Object.create(null), j$f = /* @__PURE__ */ Object.create(null), Ps$2 = w$o.ie && w$o.ie_version < 15 || w$o.ios && w$o.webkit_version < 604;
function lr$2(n3) {
  let t3 = n3.dom.parentNode;
  if (!t3)
    return;
  let e28 = t3.appendChild(document.createElement("textarea"));
  e28.style.cssText = "position: fixed; left: -10000px; top: 10px", e28.focus(), setTimeout(() => {
    n3.focus(), e28.remove(), Hs$2(n3, e28.value);
  }, 50);
}
function Hs$2(n3, t3) {
  let { state: e28 } = n3, i, s3 = 1, r3 = e28.toText(t3), o3 = r3.lines == e28.selection.ranges.length;
  if (Ne$5 != null && e28.selection.ranges.every((h3) => h3.empty) && Ne$5 == r3.toString()) {
    let h3 = -1;
    i = e28.changeByRange((c3) => {
      let a3 = e28.doc.lineAt(c3.from);
      if (a3.from == h3)
        return { range: c3 };
      h3 = a3.from;
      let f3 = e28.toText((o3 ? r3.line(s3++).text : t3) + e28.lineBreak);
      return {
        changes: { from: a3.from, insert: f3 },
        range: g$K.cursor(c3.from + f3.length)
      };
    });
  } else
    o3 ? i = e28.changeByRange((h3) => {
      let c3 = r3.line(s3++);
      return {
        changes: { from: h3.from, to: h3.to, insert: c3.text },
        range: g$K.cursor(h3.from + c3.length)
      };
    }) : i = e28.replaceSelection(r3);
  n3.dispatch(i, {
    userEvent: "input.paste",
    scrollIntoView: true
  });
}
j$f.scroll = (n3) => {
  n3.inputState.lastScrollTop = n3.scrollDOM.scrollTop, n3.inputState.lastScrollLeft = n3.scrollDOM.scrollLeft;
};
X$g.keydown = (n3, t3) => (n3.inputState.setSelectionOrigin("select"), t3.keyCode == 27 && (n3.inputState.lastEscPress = Date.now()), false);
j$f.touchstart = (n3, t3) => {
  n3.inputState.lastTouchTime = Date.now(), n3.inputState.setSelectionOrigin("select.pointer");
};
j$f.touchmove = (n3) => {
  n3.inputState.setSelectionOrigin("select.pointer");
};
X$g.mousedown = (n3, t3) => {
  if (n3.observer.flush(), n3.inputState.lastTouchTime > Date.now() - 2e3)
    return false;
  let e28 = null;
  for (let i of n3.state.facet(gs$2))
    if (e28 = i(n3, t3), e28)
      break;
  if (!e28 && t3.button == 0 && (e28 = cr$2(n3, t3)), e28) {
    let i = !n3.hasFocus;
    n3.inputState.startMouseSelection(new ir$1(n3, t3, e28, i)), i && n3.observer.ignore(() => ts$1(n3.contentDOM));
    let s3 = n3.inputState.mouseSelection;
    if (s3)
      return s3.start(t3), s3.dragging === false;
  }
  return false;
};
function wi$1(n3, t3, e28, i) {
  if (i == 1)
    return g$K.cursor(t3, e28);
  if (i == 2)
    return jn$2(n3.state, t3, e28);
  {
    let s3 = B$r.find(n3.docView, t3), r3 = n3.state.doc.lineAt(s3 ? s3.posAtEnd : t3), o3 = s3 ? s3.posAtStart : r3.from, l3 = s3 ? s3.posAtEnd : r3.to;
    return l3 < n3.state.doc.length && l3 == r3.to && l3++, g$K.range(o3, l3);
  }
}
let Ns$2 = (n3, t3) => n3 >= t3.top && n3 <= t3.bottom, yi$2 = (n3, t3, e28) => Ns$2(t3, e28) && n3 >= e28.left && n3 <= e28.right;
function hr$1(n3, t3, e28, i) {
  let s3 = B$r.find(n3.docView, t3);
  if (!s3)
    return 1;
  let r3 = t3 - s3.posAtStart;
  if (r3 == 0)
    return 1;
  if (r3 == s3.length)
    return -1;
  let o3 = s3.coordsAt(r3, -1);
  if (o3 && yi$2(e28, i, o3))
    return -1;
  let l3 = s3.coordsAt(r3, 1);
  return l3 && yi$2(e28, i, l3) ? 1 : o3 && Ns$2(i, o3) ? -1 : 1;
}
function vi$2(n3, t3) {
  let e28 = n3.posAtCoords({ x: t3.clientX, y: t3.clientY }, false);
  return { pos: e28, bias: hr$1(n3, e28, t3.clientX, t3.clientY) };
}
const ar$2 = w$o.ie && w$o.ie_version <= 11;
let Si$2 = null, xi$2 = 0, Ci$2 = 0;
function Vs$2(n3) {
  if (!ar$2)
    return n3.detail;
  let t3 = Si$2, e28 = Ci$2;
  return Si$2 = n3, Ci$2 = Date.now(), xi$2 = !t3 || e28 > Date.now() - 400 && Math.abs(t3.clientX - n3.clientX) < 2 && Math.abs(t3.clientY - n3.clientY) < 2 ? (xi$2 + 1) % 3 : 1;
}
function cr$2(n3, t3) {
  let e28 = vi$2(n3, t3), i = Vs$2(t3), s3 = n3.state.selection;
  return {
    update(r3) {
      r3.docChanged && (e28.pos = r3.changes.mapPos(e28.pos), s3 = s3.map(r3.changes));
    },
    get(r3, o3, l3) {
      let h3 = vi$2(n3, r3), c3, a3 = wi$1(n3, h3.pos, h3.bias, i);
      if (e28.pos != h3.pos && !o3) {
        let f3 = wi$1(n3, e28.pos, e28.bias, i), d3 = Math.min(f3.from, a3.from), u3 = Math.max(f3.to, a3.to);
        a3 = d3 < a3.from ? g$K.range(d3, u3) : g$K.range(u3, d3);
      }
      return o3 ? s3.replaceRange(s3.main.extend(a3.from, a3.to)) : l3 && i == 1 && s3.ranges.length > 1 && (c3 = fr$1(s3, h3.pos)) ? c3 : l3 ? s3.addRange(a3) : g$K.create([a3]);
    }
  };
}
function fr$1(n3, t3) {
  for (let e28 = 0; e28 < n3.ranges.length; e28++) {
    let { from: i, to: s3 } = n3.ranges[e28];
    if (i <= t3 && s3 >= t3)
      return g$K.create(n3.ranges.slice(0, e28).concat(n3.ranges.slice(e28 + 1)), n3.mainIndex == e28 ? 0 : n3.mainIndex - (n3.mainIndex > e28 ? 1 : 0));
  }
  return null;
}
X$g.dragstart = (n3, t3) => {
  let { selection: { main: e28 } } = n3.state, { mouseSelection: i } = n3.inputState;
  return i && (i.dragging = e28), t3.dataTransfer && (t3.dataTransfer.setData("Text", n3.state.sliceDoc(e28.from, e28.to)), t3.dataTransfer.effectAllowed = "copyMove"), false;
};
function Mi$2(n3, t3, e28, i) {
  if (!e28)
    return;
  let s3 = n3.posAtCoords({ x: t3.clientX, y: t3.clientY }, false), { mouseSelection: r3 } = n3.inputState, o3 = i && r3 && r3.dragging && nr$1(n3, t3) ? { from: r3.dragging.from, to: r3.dragging.to } : null, l3 = { from: s3, insert: e28 }, h3 = n3.state.changes(o3 ? [o3, l3] : l3);
  n3.focus(), n3.dispatch({
    changes: h3,
    selection: { anchor: h3.mapPos(s3, -1), head: h3.mapPos(s3, 1) },
    userEvent: o3 ? "move.drop" : "input.drop"
  });
}
X$g.drop = (n3, t3) => {
  if (!t3.dataTransfer)
    return false;
  if (n3.state.readOnly)
    return true;
  let e28 = t3.dataTransfer.files;
  if (e28 && e28.length) {
    let i = Array(e28.length), s3 = 0, r3 = () => {
      ++s3 == e28.length && Mi$2(n3, t3, i.filter((o3) => o3 != null).join(n3.state.lineBreak), false);
    };
    for (let o3 = 0; o3 < e28.length; o3++) {
      let l3 = new FileReader();
      l3.onerror = r3, l3.onload = () => {
        /[\x00-\x08\x0e-\x1f]{2}/.test(l3.result) || (i[o3] = l3.result), r3();
      }, l3.readAsText(e28[o3]);
    }
    return true;
  } else {
    let i = t3.dataTransfer.getData("Text");
    if (i)
      return Mi$2(n3, t3, i, true), true;
  }
  return false;
};
X$g.paste = (n3, t3) => {
  if (n3.state.readOnly)
    return true;
  n3.observer.flush();
  let e28 = Ps$2 ? null : t3.clipboardData;
  return e28 ? (Hs$2(n3, e28.getData("text/plain") || e28.getData("text/uri-text")), true) : (lr$2(n3), false);
};
function dr$1(n3, t3) {
  let e28 = n3.dom.parentNode;
  if (!e28)
    return;
  let i = e28.appendChild(document.createElement("textarea"));
  i.style.cssText = "position: fixed; left: -10000px; top: 10px", i.value = t3, i.focus(), i.selectionEnd = t3.length, i.selectionStart = 0, setTimeout(() => {
    i.remove(), n3.focus();
  }, 50);
}
function ur$2(n3) {
  let t3 = [], e28 = [], i = false;
  for (let s3 of n3.selection.ranges)
    s3.empty || (t3.push(n3.sliceDoc(s3.from, s3.to)), e28.push(s3));
  if (!t3.length) {
    let s3 = -1;
    for (let { from: r3 } of n3.selection.ranges) {
      let o3 = n3.doc.lineAt(r3);
      o3.number > s3 && (t3.push(o3.text), e28.push({ from: o3.from, to: Math.min(n3.doc.length, o3.to + 1) })), s3 = o3.number;
    }
    i = true;
  }
  return { text: t3.join(n3.lineBreak), ranges: e28, linewise: i };
}
let Ne$5 = null;
X$g.copy = X$g.cut = (n3, t3) => {
  let { text: e28, ranges: i, linewise: s3 } = ur$2(n3.state);
  if (!e28 && !s3)
    return false;
  Ne$5 = s3 ? e28 : null, t3.type == "cut" && !n3.state.readOnly && n3.dispatch({
    changes: i,
    scrollIntoView: true,
    userEvent: "delete.cut"
  });
  let r3 = Ps$2 ? null : t3.clipboardData;
  return r3 ? (r3.clearData(), r3.setData("text/plain", e28), true) : (dr$1(n3, e28), false);
};
const Ws$2 = /* @__PURE__ */ U$n.define();
function Fs$2(n3, t3) {
  let e28 = [];
  for (let i of n3.facet(bs$2)) {
    let s3 = i(n3, t3);
    s3 && e28.push(s3);
  }
  return e28 ? n3.update({ effects: e28, annotations: Ws$2.of(true) }) : null;
}
function zs$2(n3) {
  setTimeout(() => {
    let t3 = n3.hasFocus;
    if (t3 != n3.inputState.notifiedFocused) {
      let e28 = Fs$2(n3.state, t3);
      e28 ? n3.dispatch(e28) : n3.update([]);
    }
  }, 10);
}
j$f.focus = (n3) => {
  n3.inputState.lastFocusTime = Date.now(), !n3.scrollDOM.scrollTop && (n3.inputState.lastScrollTop || n3.inputState.lastScrollLeft) && (n3.scrollDOM.scrollTop = n3.inputState.lastScrollTop, n3.scrollDOM.scrollLeft = n3.inputState.lastScrollLeft), zs$2(n3);
};
j$f.blur = (n3) => {
  n3.observer.clearSelectionRange(), zs$2(n3);
};
j$f.compositionstart = j$f.compositionupdate = (n3) => {
  n3.inputState.compositionFirstChange == null && (n3.inputState.compositionFirstChange = true), n3.inputState.composing < 0 && (n3.inputState.composing = 0);
};
j$f.compositionend = (n3) => {
  n3.inputState.composing = -1, n3.inputState.compositionEndedAt = Date.now(), n3.inputState.compositionPendingKey = true, n3.inputState.compositionPendingChange = n3.observer.pendingRecords().length > 0, n3.inputState.compositionFirstChange = null, w$o.chrome && w$o.android ? n3.observer.flushSoon() : n3.inputState.compositionPendingChange ? Promise.resolve().then(() => n3.observer.flush()) : setTimeout(() => {
    n3.inputState.composing < 0 && n3.docView.hasComposition && n3.update([]);
  }, 50);
};
j$f.contextmenu = (n3) => {
  n3.inputState.lastContextMenu = Date.now();
};
X$g.beforeinput = (n3, t3) => {
  var e28;
  let i;
  if (w$o.chrome && w$o.android && (i = Bs$2.find((s3) => s3.inputType == t3.inputType)) && (n3.observer.delayAndroidKey(i.key, i.keyCode), i.key == "Backspace" || i.key == "Delete")) {
    let s3 = ((e28 = window.visualViewport) === null || e28 === void 0 ? void 0 : e28.height) || 0;
    setTimeout(() => {
      var r3;
      (((r3 = window.visualViewport) === null || r3 === void 0 ? void 0 : r3.height) || 0) > s3 + 10 && n3.hasFocus && (n3.contentDOM.blur(), n3.focus());
    }, 100);
  }
  return false;
};
const ki$2 = /* @__PURE__ */ new Set();
function gr$2(n3) {
  ki$2.has(n3) || (ki$2.add(n3), n3.addEventListener("copy", () => {
  }), n3.addEventListener("cut", () => {
  }));
}
const Ai$1 = ["pre-wrap", "normal", "pre-line", "break-spaces"];
class pr$1 {
  constructor(t3) {
    this.lineWrapping = t3, this.doc = x$l.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30, this.heightChanged = false;
  }
  heightForGap(t3, e28) {
    let i = this.doc.lineAt(e28).number - this.doc.lineAt(t3).number + 1;
    return this.lineWrapping && (i += Math.max(0, Math.ceil((e28 - t3 - i * this.lineLength * 0.5) / this.lineLength))), this.lineHeight * i;
  }
  heightForLine(t3) {
    return this.lineWrapping ? (1 + Math.max(0, Math.ceil((t3 - this.lineLength) / (this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
  }
  setDoc(t3) {
    return this.doc = t3, this;
  }
  mustRefreshForWrapping(t3) {
    return Ai$1.indexOf(t3) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(t3) {
    let e28 = false;
    for (let i = 0; i < t3.length; i++) {
      let s3 = t3[i];
      s3 < 0 ? i++ : this.heightSamples[Math.floor(s3 * 10)] || (e28 = true, this.heightSamples[Math.floor(s3 * 10)] = true);
    }
    return e28;
  }
  refresh(t3, e28, i, s3, r3, o3) {
    let l3 = Ai$1.indexOf(t3) > -1, h3 = Math.round(e28) != Math.round(this.lineHeight) || this.lineWrapping != l3;
    if (this.lineWrapping = l3, this.lineHeight = e28, this.charWidth = i, this.textHeight = s3, this.lineLength = r3, h3) {
      this.heightSamples = {};
      for (let c3 = 0; c3 < o3.length; c3++) {
        let a3 = o3[c3];
        a3 < 0 ? c3++ : this.heightSamples[Math.floor(a3 * 10)] = true;
      }
    }
    return h3;
  }
}
class mr$2 {
  constructor(t3, e28) {
    this.from = t3, this.heights = e28, this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}
class G$k {
  constructor(t3, e28, i, s3, r3) {
    this.from = t3, this.length = e28, this.top = i, this.height = s3, this._content = r3;
  }
  get type() {
    return typeof this._content == "number" ? N$w.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  get to() {
    return this.from + this.length;
  }
  get bottom() {
    return this.top + this.height;
  }
  get widget() {
    return this._content instanceof ot$5 ? this._content.widget : null;
  }
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  join(t3) {
    let e28 = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(t3._content) ? t3._content : [t3]);
    return new G$k(this.from, this.length + t3.length, this.top, this.height + t3.height, e28);
  }
}
var O$n = /* @__PURE__ */ function(n3) {
  return n3[n3.ByPos = 0] = "ByPos", n3[n3.ByHeight = 1] = "ByHeight", n3[n3.ByPosNoHeight = 2] = "ByPosNoHeight", n3;
}(O$n || (O$n = {}));
const te$c = 1e-3;
class W$f {
  constructor(t3, e28, i = 2) {
    this.length = t3, this.height = e28, this.flags = i;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(t3) {
    this.flags = (t3 ? 2 : 0) | this.flags & -3;
  }
  setHeight(t3, e28) {
    this.height != e28 && (Math.abs(this.height - e28) > te$c && (t3.heightChanged = true), this.height = e28);
  }
  replace(t3, e28, i) {
    return W$f.of(i);
  }
  decomposeLeft(t3, e28) {
    e28.push(this);
  }
  decomposeRight(t3, e28) {
    e28.push(this);
  }
  applyChanges(t3, e28, i, s3) {
    let r3 = this, o3 = i.doc;
    for (let l3 = s3.length - 1; l3 >= 0; l3--) {
      let { fromA: h3, toA: c3, fromB: a3, toB: f3 } = s3[l3], d3 = r3.lineAt(h3, O$n.ByPosNoHeight, i.setDoc(e28), 0, 0), u3 = d3.to >= c3 ? d3 : r3.lineAt(c3, O$n.ByPosNoHeight, i, 0, 0);
      for (f3 += u3.to - c3, c3 = u3.to; l3 > 0 && d3.from <= s3[l3 - 1].toA; )
        h3 = s3[l3 - 1].fromA, a3 = s3[l3 - 1].fromB, l3--, h3 < d3.from && (d3 = r3.lineAt(h3, O$n.ByPosNoHeight, i, 0, 0));
      a3 += d3.from - h3, h3 = d3.from;
      let g3 = Je$4.build(i.setDoc(o3), t3, a3, f3);
      r3 = r3.replace(h3, c3, g3);
    }
    return r3.updateHeight(i, 0);
  }
  static empty() {
    return new I$t(0, 0);
  }
  static of(t3) {
    if (t3.length == 1)
      return t3[0];
    let e28 = 0, i = t3.length, s3 = 0, r3 = 0;
    for (; ; )
      if (e28 == i)
        if (s3 > r3 * 2) {
          let l3 = t3[e28 - 1];
          l3.break ? t3.splice(--e28, 1, l3.left, null, l3.right) : t3.splice(--e28, 1, l3.left, l3.right), i += 1 + l3.break, s3 -= l3.size;
        } else if (r3 > s3 * 2) {
          let l3 = t3[i];
          l3.break ? t3.splice(i, 1, l3.left, null, l3.right) : t3.splice(i, 1, l3.left, l3.right), i += 2 + l3.break, r3 -= l3.size;
        } else
          break;
      else if (s3 < r3) {
        let l3 = t3[e28++];
        l3 && (s3 += l3.size);
      } else {
        let l3 = t3[--i];
        l3 && (r3 += l3.size);
      }
    let o3 = 0;
    return t3[e28 - 1] == null ? (o3 = 1, e28--) : t3[e28] == null && (o3 = 1, i++), new br$2(W$f.of(t3.slice(0, e28)), o3, W$f.of(t3.slice(i)));
  }
}
W$f.prototype.size = 1;
class Is$2 extends W$f {
  constructor(t3, e28, i) {
    super(t3, e28), this.deco = i;
  }
  blockAt(t3, e28, i, s3) {
    return new G$k(s3, this.length, i, this.height, this.deco || 0);
  }
  lineAt(t3, e28, i, s3, r3) {
    return this.blockAt(0, i, s3, r3);
  }
  forEachLine(t3, e28, i, s3, r3, o3) {
    t3 <= r3 + this.length && e28 >= r3 && o3(this.blockAt(0, i, s3, r3));
  }
  updateHeight(t3, e28 = 0, i = false, s3) {
    return s3 && s3.from <= e28 && s3.more && this.setHeight(t3, s3.heights[s3.index++]), this.outdated = false, this;
  }
  toString() {
    return `block(${this.length})`;
  }
}
class I$t extends Is$2 {
  constructor(t3, e28) {
    super(t3, e28, null), this.collapsed = 0, this.widgetHeight = 0, this.breaks = 0;
  }
  blockAt(t3, e28, i, s3) {
    return new G$k(s3, this.length, i, this.height, this.breaks);
  }
  replace(t3, e28, i) {
    let s3 = i[0];
    return i.length == 1 && (s3 instanceof I$t || s3 instanceof P$E && s3.flags & 4) && Math.abs(this.length - s3.length) < 10 ? (s3 instanceof P$E ? s3 = new I$t(s3.length, this.height) : s3.height = this.height, this.outdated || (s3.outdated = false), s3) : W$f.of(i);
  }
  updateHeight(t3, e28 = 0, i = false, s3) {
    return s3 && s3.from <= e28 && s3.more ? this.setHeight(t3, s3.heights[s3.index++]) : (i || this.outdated) && this.setHeight(t3, Math.max(this.widgetHeight, t3.heightForLine(this.length - this.collapsed)) + this.breaks * t3.lineHeight), this.outdated = false, this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}
class P$E extends W$f {
  constructor(t3) {
    super(t3, 0);
  }
  heightMetrics(t3, e28) {
    let i = t3.doc.lineAt(e28).number, s3 = t3.doc.lineAt(e28 + this.length).number, r3 = s3 - i + 1, o3, l3 = 0;
    if (t3.lineWrapping) {
      let h3 = Math.min(this.height, t3.lineHeight * r3);
      o3 = h3 / r3, this.length > r3 + 1 && (l3 = (this.height - h3) / (this.length - r3 - 1));
    } else
      o3 = this.height / r3;
    return { firstLine: i, lastLine: s3, perLine: o3, perChar: l3 };
  }
  blockAt(t3, e28, i, s3) {
    let { firstLine: r3, lastLine: o3, perLine: l3, perChar: h3 } = this.heightMetrics(e28, s3);
    if (e28.lineWrapping) {
      let c3 = s3 + Math.round(Math.max(0, Math.min(1, (t3 - i) / this.height)) * this.length), a3 = e28.doc.lineAt(c3), f3 = l3 + a3.length * h3, d3 = Math.max(i, t3 - f3 / 2);
      return new G$k(a3.from, a3.length, d3, f3, 0);
    } else {
      let c3 = Math.max(0, Math.min(o3 - r3, Math.floor((t3 - i) / l3))), { from: a3, length: f3 } = e28.doc.line(r3 + c3);
      return new G$k(a3, f3, i + l3 * c3, l3, 0);
    }
  }
  lineAt(t3, e28, i, s3, r3) {
    if (e28 == O$n.ByHeight)
      return this.blockAt(t3, i, s3, r3);
    if (e28 == O$n.ByPosNoHeight) {
      let { from: u3, to: g3 } = i.doc.lineAt(t3);
      return new G$k(u3, g3 - u3, 0, 0, 0);
    }
    let { firstLine: o3, perLine: l3, perChar: h3 } = this.heightMetrics(i, r3), c3 = i.doc.lineAt(t3), a3 = l3 + c3.length * h3, f3 = c3.number - o3, d3 = s3 + l3 * f3 + h3 * (c3.from - r3 - f3);
    return new G$k(c3.from, c3.length, Math.max(s3, Math.min(d3, s3 + this.height - a3)), a3, 0);
  }
  forEachLine(t3, e28, i, s3, r3, o3) {
    t3 = Math.max(t3, r3), e28 = Math.min(e28, r3 + this.length);
    let { firstLine: l3, perLine: h3, perChar: c3 } = this.heightMetrics(i, r3);
    for (let a3 = t3, f3 = s3; a3 <= e28; ) {
      let d3 = i.doc.lineAt(a3);
      if (a3 == t3) {
        let g3 = d3.number - l3;
        f3 += h3 * g3 + c3 * (t3 - r3 - g3);
      }
      let u3 = h3 + c3 * d3.length;
      o3(new G$k(d3.from, d3.length, f3, u3, 0)), f3 += u3, a3 = d3.to + 1;
    }
  }
  replace(t3, e28, i) {
    let s3 = this.length - e28;
    if (s3 > 0) {
      let r3 = i[i.length - 1];
      r3 instanceof P$E ? i[i.length - 1] = new P$E(r3.length + s3) : i.push(null, new P$E(s3 - 1));
    }
    if (t3 > 0) {
      let r3 = i[0];
      r3 instanceof P$E ? i[0] = new P$E(t3 + r3.length) : i.unshift(new P$E(t3 - 1), null);
    }
    return W$f.of(i);
  }
  decomposeLeft(t3, e28) {
    e28.push(new P$E(t3 - 1), null);
  }
  decomposeRight(t3, e28) {
    e28.push(null, new P$E(this.length - t3 - 1));
  }
  updateHeight(t3, e28 = 0, i = false, s3) {
    let r3 = e28 + this.length;
    if (s3 && s3.from <= e28 + this.length && s3.more) {
      let o3 = [], l3 = Math.max(e28, s3.from), h3 = -1;
      for (s3.from > e28 && o3.push(new P$E(s3.from - e28 - 1).updateHeight(t3, e28)); l3 <= r3 && s3.more; ) {
        let a3 = t3.doc.lineAt(l3).length;
        o3.length && o3.push(null);
        let f3 = s3.heights[s3.index++];
        h3 == -1 ? h3 = f3 : Math.abs(f3 - h3) >= te$c && (h3 = -2);
        let d3 = new I$t(a3, f3);
        d3.outdated = false, o3.push(d3), l3 += a3 + 1;
      }
      l3 <= r3 && o3.push(null, new P$E(r3 - l3).updateHeight(t3, l3));
      let c3 = W$f.of(o3);
      return (h3 < 0 || Math.abs(c3.height - this.height) >= te$c || Math.abs(h3 - this.heightMetrics(t3, e28).perLine) >= te$c) && (t3.heightChanged = true), c3;
    } else
      (i || this.outdated) && (this.setHeight(t3, t3.heightForGap(e28, e28 + this.length)), this.outdated = false);
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
}
class br$2 extends W$f {
  constructor(t3, e28, i) {
    super(t3.length + e28 + i.length, t3.height + i.height, e28 | (t3.outdated || i.outdated ? 2 : 0)), this.left = t3, this.right = i, this.size = t3.size + i.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(t3, e28, i, s3) {
    let r3 = i + this.left.height;
    return t3 < r3 ? this.left.blockAt(t3, e28, i, s3) : this.right.blockAt(t3, e28, r3, s3 + this.left.length + this.break);
  }
  lineAt(t3, e28, i, s3, r3) {
    let o3 = s3 + this.left.height, l3 = r3 + this.left.length + this.break, h3 = e28 == O$n.ByHeight ? t3 < o3 : t3 < l3, c3 = h3 ? this.left.lineAt(t3, e28, i, s3, r3) : this.right.lineAt(t3, e28, i, o3, l3);
    if (this.break || (h3 ? c3.to < l3 : c3.from > l3))
      return c3;
    let a3 = e28 == O$n.ByPosNoHeight ? O$n.ByPosNoHeight : O$n.ByPos;
    return h3 ? c3.join(this.right.lineAt(l3, a3, i, o3, l3)) : this.left.lineAt(l3, a3, i, s3, r3).join(c3);
  }
  forEachLine(t3, e28, i, s3, r3, o3) {
    let l3 = s3 + this.left.height, h3 = r3 + this.left.length + this.break;
    if (this.break)
      t3 < h3 && this.left.forEachLine(t3, e28, i, s3, r3, o3), e28 >= h3 && this.right.forEachLine(t3, e28, i, l3, h3, o3);
    else {
      let c3 = this.lineAt(h3, O$n.ByPos, i, s3, r3);
      t3 < c3.from && this.left.forEachLine(t3, c3.from - 1, i, s3, r3, o3), c3.to >= t3 && c3.from <= e28 && o3(c3), e28 > c3.to && this.right.forEachLine(c3.to + 1, e28, i, l3, h3, o3);
    }
  }
  replace(t3, e28, i) {
    let s3 = this.left.length + this.break;
    if (e28 < s3)
      return this.balanced(this.left.replace(t3, e28, i), this.right);
    if (t3 > this.left.length)
      return this.balanced(this.left, this.right.replace(t3 - s3, e28 - s3, i));
    let r3 = [];
    t3 > 0 && this.decomposeLeft(t3, r3);
    let o3 = r3.length;
    for (let l3 of i)
      r3.push(l3);
    if (t3 > 0 && Di$2(r3, o3 - 1), e28 < this.length) {
      let l3 = r3.length;
      this.decomposeRight(e28, r3), Di$2(r3, l3);
    }
    return W$f.of(r3);
  }
  decomposeLeft(t3, e28) {
    let i = this.left.length;
    if (t3 <= i)
      return this.left.decomposeLeft(t3, e28);
    e28.push(this.left), this.break && (i++, t3 >= i && e28.push(null)), t3 > i && this.right.decomposeLeft(t3 - i, e28);
  }
  decomposeRight(t3, e28) {
    let i = this.left.length, s3 = i + this.break;
    if (t3 >= s3)
      return this.right.decomposeRight(t3 - s3, e28);
    t3 < i && this.left.decomposeRight(t3, e28), this.break && t3 < s3 && e28.push(null), e28.push(this.right);
  }
  balanced(t3, e28) {
    return t3.size > 2 * e28.size || e28.size > 2 * t3.size ? W$f.of(this.break ? [t3, null, e28] : [t3, e28]) : (this.left = t3, this.right = e28, this.height = t3.height + e28.height, this.outdated = t3.outdated || e28.outdated, this.size = t3.size + e28.size, this.length = t3.length + this.break + e28.length, this);
  }
  updateHeight(t3, e28 = 0, i = false, s3) {
    let { left: r3, right: o3 } = this, l3 = e28 + r3.length + this.break, h3 = null;
    return s3 && s3.from <= e28 + r3.length && s3.more ? h3 = r3 = r3.updateHeight(t3, e28, i, s3) : r3.updateHeight(t3, e28, i), s3 && s3.from <= l3 + o3.length && s3.more ? h3 = o3 = o3.updateHeight(t3, l3, i, s3) : o3.updateHeight(t3, l3, i), h3 ? this.balanced(r3, o3) : (this.height = this.left.height + this.right.height, this.outdated = false, this);
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}
function Di$2(n3, t3) {
  let e28, i;
  n3[t3] == null && (e28 = n3[t3 - 1]) instanceof P$E && (i = n3[t3 + 1]) instanceof P$E && n3.splice(t3 - 1, 3, new P$E(e28.length + 1 + i.length));
}
const wr$1 = 5;
class Je$4 {
  constructor(t3, e28) {
    this.pos = t3, this.oracle = e28, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = t3;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(t3, e28) {
    if (this.lineStart > -1) {
      let i = Math.min(e28, this.lineEnd), s3 = this.nodes[this.nodes.length - 1];
      s3 instanceof I$t ? s3.length += i - this.pos : (i > this.pos || !this.isCovered) && this.nodes.push(new I$t(i - this.pos, -1)), this.writtenTo = i, e28 > i && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
    }
    this.pos = e28;
  }
  point(t3, e28, i) {
    if (t3 < e28 || i.heightRelevant) {
      let s3 = i.widget ? i.widget.estimatedHeight : 0, r3 = i.widget ? i.widget.lineBreaks : 0;
      s3 < 0 && (s3 = this.oracle.lineHeight);
      let o3 = e28 - t3;
      i.block ? this.addBlock(new Is$2(o3, s3, i)) : (o3 || r3 || s3 >= wr$1) && this.addLineDeco(s3, r3, o3);
    } else
      e28 > t3 && this.span(t3, e28);
    this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
  }
  enterLine() {
    if (this.lineStart > -1)
      return;
    let { from: t3, to: e28 } = this.oracle.doc.lineAt(this.pos);
    this.lineStart = t3, this.lineEnd = e28, this.writtenTo < t3 && ((this.writtenTo < t3 - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, t3 - 1)), this.nodes.push(null)), this.pos > t3 && this.nodes.push(new I$t(this.pos - t3, -1)), this.writtenTo = this.pos;
  }
  blankContent(t3, e28) {
    let i = new P$E(e28 - t3);
    return this.oracle.doc.lineAt(t3).to == e28 && (i.flags |= 4), i;
  }
  ensureLine() {
    this.enterLine();
    let t3 = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (t3 instanceof I$t)
      return t3;
    let e28 = new I$t(0, -1);
    return this.nodes.push(e28), e28;
  }
  addBlock(t3) {
    this.enterLine();
    let e28 = t3.deco;
    e28 && e28.startSide > 0 && !this.isCovered && this.ensureLine(), this.nodes.push(t3), this.writtenTo = this.pos = this.pos + t3.length, e28 && e28.endSide > 0 && (this.covering = t3);
  }
  addLineDeco(t3, e28, i) {
    let s3 = this.ensureLine();
    s3.length += i, s3.collapsed += i, s3.widgetHeight = Math.max(s3.widgetHeight, t3), s3.breaks += e28, this.writtenTo = this.pos = this.pos + i;
  }
  finish(t3) {
    let e28 = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    this.lineStart > -1 && !(e28 instanceof I$t) && !this.isCovered ? this.nodes.push(new I$t(0, -1)) : (this.writtenTo < this.pos || e28 == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let i = t3;
    for (let s3 of this.nodes)
      s3 instanceof I$t && s3.updateHeight(this.oracle, i), i += s3 ? s3.length : 1;
    return this.nodes;
  }
  static build(t3, e28, i, s3) {
    let r3 = new Je$4(i, t3);
    return P$F.spans(e28, i, s3, r3, 0), r3.finish(i);
  }
}
function yr$2(n3, t3, e28) {
  let i = new vr$2();
  return P$F.compare(n3, t3, e28, i, 0), i.changes;
}
class vr$2 {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(t3, e28, i, s3) {
    (t3 < e28 || i && i.heightRelevant || s3 && s3.heightRelevant) && Te$8(t3, e28, this.changes, 5);
  }
}
function Sr$1(n3, t3) {
  let e28 = n3.getBoundingClientRect(), i = n3.ownerDocument, s3 = i.defaultView || window, r3 = Math.max(0, e28.left), o3 = Math.min(s3.innerWidth, e28.right), l3 = Math.max(0, e28.top), h3 = Math.min(s3.innerHeight, e28.bottom);
  for (let c3 = n3.parentNode; c3 && c3 != i.body; )
    if (c3.nodeType == 1) {
      let a3 = c3, f3 = window.getComputedStyle(a3);
      if ((a3.scrollHeight > a3.clientHeight || a3.scrollWidth > a3.clientWidth) && f3.overflow != "visible") {
        let d3 = a3.getBoundingClientRect();
        r3 = Math.max(r3, d3.left), o3 = Math.min(o3, d3.right), l3 = Math.max(l3, d3.top), h3 = c3 == n3.parentNode ? d3.bottom : Math.min(h3, d3.bottom);
      }
      c3 = f3.position == "absolute" || f3.position == "fixed" ? a3.offsetParent : a3.parentNode;
    } else if (c3.nodeType == 11)
      c3 = c3.host;
    else
      break;
  return {
    left: r3 - e28.left,
    right: Math.max(r3, o3) - e28.left,
    top: l3 - (e28.top + t3),
    bottom: Math.max(l3, h3) - (e28.top + t3)
  };
}
function xr$2(n3, t3) {
  let e28 = n3.getBoundingClientRect();
  return {
    left: 0,
    right: e28.right - e28.left,
    top: t3,
    bottom: e28.bottom - (e28.top + t3)
  };
}
class me$c {
  constructor(t3, e28, i) {
    this.from = t3, this.to = e28, this.size = i;
  }
  static same(t3, e28) {
    if (t3.length != e28.length)
      return false;
    for (let i = 0; i < t3.length; i++) {
      let s3 = t3[i], r3 = e28[i];
      if (s3.from != r3.from || s3.to != r3.to || s3.size != r3.size)
        return false;
    }
    return true;
  }
  draw(t3, e28) {
    return V$j.replace({
      widget: new Cr$2(this.size * (e28 ? t3.scaleY : t3.scaleX), e28)
    }).range(this.from, this.to);
  }
}
class Cr$2 extends Nt$4 {
  constructor(t3, e28) {
    super(), this.size = t3, this.vertical = e28;
  }
  eq(t3) {
    return t3.size == this.size && t3.vertical == this.vertical;
  }
  toDOM() {
    let t3 = document.createElement("div");
    return this.vertical ? t3.style.height = this.size + "px" : (t3.style.width = this.size + "px", t3.style.height = "2px", t3.style.display = "inline-block"), t3;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}
class Oi$2 {
  constructor(t3) {
    this.state = t3, this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 }, this.inView = true, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.scrollTop = 0, this.scrolledToBottom = true, this.scaleX = 1, this.scaleY = 1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = Ti$1, this.scrollTarget = null, this.printing = false, this.mustMeasureContent = true, this.defaultTextDirection = L$r.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = false;
    let e28 = t3.facet($e$4).some((i) => typeof i != "function" && i.class == "cm-lineWrapping");
    this.heightOracle = new pr$1(e28), this.stateDeco = t3.facet(Bt$4).filter((i) => typeof i != "function"), this.heightMap = W$f.empty().applyChanges(this.stateDeco, x$l.empty, this.heightOracle.setDoc(t3.doc), [new q$j(0, 0, 0, t3.doc.length)]), this.viewport = this.getViewport(0, null), this.updateViewportLines(), this.updateForViewport(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = V$j.set(this.lineGaps.map((i) => i.draw(this, false))), this.computeVisibleRanges();
  }
  updateForViewport() {
    let t3 = [this.viewport], { main: e28 } = this.state.selection;
    for (let i = 0; i <= 1; i++) {
      let s3 = i ? e28.head : e28.anchor;
      if (!t3.some(({ from: r3, to: o3 }) => s3 >= r3 && s3 <= o3)) {
        let { from: r3, to: o3 } = this.lineBlockAt(s3);
        t3.push(new Gt$5(r3, o3));
      }
    }
    this.viewports = t3.sort((i, s3) => i.from - s3.from), this.scaler = this.heightMap.height <= 7e6 ? Ti$1 : new Ar$1(this.heightOracle, this.heightMap, this.viewports);
  }
  updateViewportLines() {
    this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (t3) => {
      this.viewportLines.push(this.scaler.scale == 1 ? t3 : Mt$5(t3, this.scaler));
    });
  }
  update(t3, e28 = null) {
    this.state = t3.state;
    let i = this.stateDeco;
    this.stateDeco = this.state.facet(Bt$4).filter((a3) => typeof a3 != "function");
    let s3 = t3.changedRanges, r3 = q$j.extendWithRanges(s3, yr$2(i, this.stateDeco, t3 ? t3.changes : k$w.empty(this.state.doc.length))), o3 = this.heightMap.height, l3 = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
    this.heightMap = this.heightMap.applyChanges(this.stateDeco, t3.startState.doc, this.heightOracle.setDoc(this.state.doc), r3), this.heightMap.height != o3 && (t3.flags |= 2), l3 ? (this.scrollAnchorPos = t3.changes.mapPos(l3.from, -1), this.scrollAnchorHeight = l3.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = this.heightMap.height);
    let h3 = r3.length ? this.mapViewport(this.viewport, t3.changes) : this.viewport;
    (e28 && (e28.range.head < h3.from || e28.range.head > h3.to) || !this.viewportIsAppropriate(h3)) && (h3 = this.getViewport(0, e28));
    let c3 = !t3.changes.empty || t3.flags & 2 || h3.from != this.viewport.from || h3.to != this.viewport.to;
    this.viewport = h3, this.updateForViewport(), c3 && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, t3.changes))), t3.flags |= this.computeVisibleRanges(), e28 && (this.scrollTarget = e28), !this.mustEnforceCursorAssoc && t3.selectionSet && t3.view.lineWrapping && t3.state.selection.main.empty && t3.state.selection.main.assoc && !t3.state.facet(ys$2) && (this.mustEnforceCursorAssoc = true);
  }
  measure(t3) {
    let e28 = t3.contentDOM, i = window.getComputedStyle(e28), s3 = this.heightOracle, r3 = i.whiteSpace;
    this.defaultTextDirection = i.direction == "rtl" ? L$r.RTL : L$r.LTR;
    let o3 = this.heightOracle.mustRefreshForWrapping(r3), l3 = e28.getBoundingClientRect(), h3 = o3 || this.mustMeasureContent || this.contentDOMHeight != l3.height;
    this.contentDOMHeight = l3.height, this.mustMeasureContent = false;
    let c3 = 0, a3 = 0;
    if (l3.width && l3.height) {
      let y3 = l3.width / e28.offsetWidth, S3 = l3.height / e28.offsetHeight;
      (y3 > 0.995 && y3 < 1.005 || !isFinite(y3) || Math.abs(l3.width - e28.offsetWidth) < 1) && (y3 = 1), (S3 > 0.995 && S3 < 1.005 || !isFinite(S3) || Math.abs(l3.height - e28.offsetHeight) < 1) && (S3 = 1), (this.scaleX != y3 || this.scaleY != S3) && (this.scaleX = y3, this.scaleY = S3, c3 |= 8, o3 = h3 = true);
    }
    let f3 = (parseInt(i.paddingTop) || 0) * this.scaleY, d3 = (parseInt(i.paddingBottom) || 0) * this.scaleY;
    (this.paddingTop != f3 || this.paddingBottom != d3) && (this.paddingTop = f3, this.paddingBottom = d3, c3 |= 10), this.editorWidth != t3.scrollDOM.clientWidth && (s3.lineWrapping && (h3 = true), this.editorWidth = t3.scrollDOM.clientWidth, c3 |= 8);
    let u3 = t3.scrollDOM.scrollTop * this.scaleY;
    this.scrollTop != u3 && (this.scrollAnchorHeight = -1, this.scrollTop = u3), this.scrolledToBottom = is$1(t3.scrollDOM);
    let g3 = (this.printing ? xr$2 : Sr$1)(e28, this.paddingTop), m3 = g3.top - this.pixelViewport.top, p3 = g3.bottom - this.pixelViewport.bottom;
    this.pixelViewport = g3;
    let b3 = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (b3 != this.inView && (this.inView = b3, b3 && (h3 = true)), !this.inView && !this.scrollTarget)
      return 0;
    let v3 = l3.width;
    if ((this.contentDOMWidth != v3 || this.editorHeight != t3.scrollDOM.clientHeight) && (this.contentDOMWidth = l3.width, this.editorHeight = t3.scrollDOM.clientHeight, c3 |= 8), h3) {
      let y3 = t3.docView.measureVisibleLineHeights(this.viewport);
      if (s3.mustRefreshForHeights(y3) && (o3 = true), o3 || s3.lineWrapping && Math.abs(v3 - this.contentDOMWidth) > s3.charWidth) {
        let { lineHeight: S3, charWidth: C3, textHeight: R3 } = t3.docView.measureTextSize();
        o3 = S3 > 0 && s3.refresh(r3, S3, C3, R3, v3 / C3, y3), o3 && (t3.docView.minWidth = 0, c3 |= 8);
      }
      m3 > 0 && p3 > 0 ? a3 = Math.max(m3, p3) : m3 < 0 && p3 < 0 && (a3 = Math.min(m3, p3)), s3.heightChanged = false;
      for (let S3 of this.viewports) {
        let C3 = S3.from == this.viewport.from ? y3 : t3.docView.measureVisibleLineHeights(S3);
        this.heightMap = (o3 ? W$f.empty().applyChanges(this.stateDeco, x$l.empty, this.heightOracle, [new q$j(0, 0, 0, t3.state.doc.length)]) : this.heightMap).updateHeight(s3, 0, o3, new mr$2(S3.from, C3));
      }
      s3.heightChanged && (c3 |= 2);
    }
    let x3 = !this.viewportIsAppropriate(this.viewport, a3) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    return x3 && (this.viewport = this.getViewport(a3, this.scrollTarget)), this.updateForViewport(), (c3 & 2 || x3) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(o3 ? [] : this.lineGaps, t3)), c3 |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = false, t3.docView.enforceCursorAssoc()), c3;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(t3, e28) {
    let i = 0.5 - Math.max(-0.5, Math.min(0.5, t3 / 1e3 / 2)), s3 = this.heightMap, r3 = this.heightOracle, { visibleTop: o3, visibleBottom: l3 } = this, h3 = new Gt$5(s3.lineAt(o3 - i * 1e3, O$n.ByHeight, r3, 0, 0).from, s3.lineAt(l3 + (1 - i) * 1e3, O$n.ByHeight, r3, 0, 0).to);
    if (e28) {
      let { head: c3 } = e28.range;
      if (c3 < h3.from || c3 > h3.to) {
        let a3 = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), f3 = s3.lineAt(c3, O$n.ByPos, r3, 0, 0), d3;
        e28.y == "center" ? d3 = (f3.top + f3.bottom) / 2 - a3 / 2 : e28.y == "start" || e28.y == "nearest" && c3 < h3.from ? d3 = f3.top : d3 = f3.bottom - a3, h3 = new Gt$5(s3.lineAt(d3 - 1e3 / 2, O$n.ByHeight, r3, 0, 0).from, s3.lineAt(d3 + a3 + 1e3 / 2, O$n.ByHeight, r3, 0, 0).to);
      }
    }
    return h3;
  }
  mapViewport(t3, e28) {
    let i = e28.mapPos(t3.from, -1), s3 = e28.mapPos(t3.to, 1);
    return new Gt$5(this.heightMap.lineAt(i, O$n.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(s3, O$n.ByPos, this.heightOracle, 0, 0).to);
  }
  viewportIsAppropriate({ from: t3, to: e28 }, i = 0) {
    if (!this.inView)
      return true;
    let { top: s3 } = this.heightMap.lineAt(t3, O$n.ByPos, this.heightOracle, 0, 0), { bottom: r3 } = this.heightMap.lineAt(e28, O$n.ByPos, this.heightOracle, 0, 0), { visibleTop: o3, visibleBottom: l3 } = this;
    return (t3 == 0 || s3 <= o3 - Math.max(10, Math.min(-i, 250))) && (e28 == this.state.doc.length || r3 >= l3 + Math.max(10, Math.min(i, 250))) && s3 > o3 - 2 * 1e3 && r3 < l3 + 2 * 1e3;
  }
  mapLineGaps(t3, e28) {
    if (!t3.length || e28.empty)
      return t3;
    let i = [];
    for (let s3 of t3)
      e28.touchesRange(s3.from, s3.to) || i.push(new me$c(e28.mapPos(s3.from), e28.mapPos(s3.to), s3.size));
    return i;
  }
  ensureLineGaps(t3, e28) {
    let i = this.heightOracle.lineWrapping, s3 = i ? 1e4 : 2e3, r3 = s3 >> 1, o3 = s3 << 1;
    if (this.defaultTextDirection != L$r.LTR && !i)
      return [];
    let l3 = [], h3 = (c3, a3, f3, d3) => {
      if (a3 - c3 < r3)
        return;
      let u3 = this.state.selection.main, g3 = [u3.from];
      u3.empty || g3.push(u3.to);
      for (let p3 of g3)
        if (p3 > c3 && p3 < a3) {
          h3(c3, p3 - 10, f3, d3), h3(p3 + 10, a3, f3, d3);
          return;
        }
      let m3 = kr$1(t3, (p3) => p3.from >= f3.from && p3.to <= f3.to && Math.abs(p3.from - c3) < r3 && Math.abs(p3.to - a3) < r3 && !g3.some((b3) => p3.from < b3 && p3.to > b3));
      if (!m3) {
        if (a3 < f3.to && e28 && i && e28.visibleRanges.some((p3) => p3.from <= a3 && p3.to >= a3)) {
          let p3 = e28.moveToLineBoundary(g$K.cursor(a3), false, true).head;
          p3 > c3 && (a3 = p3);
        }
        m3 = new me$c(c3, a3, this.gapSize(f3, c3, a3, d3));
      }
      l3.push(m3);
    };
    for (let c3 of this.viewportLines) {
      if (c3.length < o3)
        continue;
      let a3 = Mr$2(c3.from, c3.to, this.stateDeco);
      if (a3.total < o3)
        continue;
      let f3 = this.scrollTarget ? this.scrollTarget.range.head : null, d3, u3;
      if (i) {
        let g3 = s3 / this.heightOracle.lineLength * this.heightOracle.lineHeight, m3, p3;
        if (f3 != null) {
          let b3 = Xt$3(a3, f3), v3 = ((this.visibleBottom - this.visibleTop) / 2 + g3) / c3.height;
          m3 = b3 - v3, p3 = b3 + v3;
        } else
          m3 = (this.visibleTop - c3.top - g3) / c3.height, p3 = (this.visibleBottom - c3.top + g3) / c3.height;
        d3 = _t$3(a3, m3), u3 = _t$3(a3, p3);
      } else {
        let g3 = a3.total * this.heightOracle.charWidth, m3 = s3 * this.heightOracle.charWidth, p3, b3;
        if (f3 != null) {
          let v3 = Xt$3(a3, f3), x3 = ((this.pixelViewport.right - this.pixelViewport.left) / 2 + m3) / g3;
          p3 = v3 - x3, b3 = v3 + x3;
        } else
          p3 = (this.pixelViewport.left - m3) / g3, b3 = (this.pixelViewport.right + m3) / g3;
        d3 = _t$3(a3, p3), u3 = _t$3(a3, b3);
      }
      d3 > c3.from && h3(c3.from, d3, c3, a3), u3 < c3.to && h3(u3, c3.to, c3, a3);
    }
    return l3;
  }
  gapSize(t3, e28, i, s3) {
    let r3 = Xt$3(s3, i) - Xt$3(s3, e28);
    return this.heightOracle.lineWrapping ? t3.height * r3 : s3.total * this.heightOracle.charWidth * r3;
  }
  updateLineGaps(t3) {
    me$c.same(t3, this.lineGaps) || (this.lineGaps = t3, this.lineGapDeco = V$j.set(t3.map((e28) => e28.draw(this, this.heightOracle.lineWrapping))));
  }
  computeVisibleRanges() {
    let t3 = this.stateDeco;
    this.lineGaps.length && (t3 = t3.concat(this.lineGapDeco));
    let e28 = [];
    P$F.spans(t3, this.viewport.from, this.viewport.to, {
      span(s3, r3) {
        e28.push({ from: s3, to: r3 });
      },
      point() {
      }
    }, 20);
    let i = e28.length != this.visibleRanges.length || this.visibleRanges.some((s3, r3) => s3.from != e28[r3].from || s3.to != e28[r3].to);
    return this.visibleRanges = e28, i ? 4 : 0;
  }
  lineBlockAt(t3) {
    return t3 >= this.viewport.from && t3 <= this.viewport.to && this.viewportLines.find((e28) => e28.from <= t3 && e28.to >= t3) || Mt$5(this.heightMap.lineAt(t3, O$n.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(t3) {
    return Mt$5(this.heightMap.lineAt(this.scaler.fromDOM(t3), O$n.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  scrollAnchorAt(t3) {
    let e28 = this.lineBlockAtHeight(t3 + 8);
    return e28.from >= this.viewport.from || this.viewportLines[0].top - t3 > 200 ? e28 : this.viewportLines[0];
  }
  elementAtHeight(t3) {
    return Mt$5(this.heightMap.blockAt(this.scaler.fromDOM(t3), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}
class Gt$5 {
  constructor(t3, e28) {
    this.from = t3, this.to = e28;
  }
}
function Mr$2(n3, t3, e28) {
  let i = [], s3 = n3, r3 = 0;
  return P$F.spans(e28, n3, t3, {
    span() {
    },
    point(o3, l3) {
      o3 > s3 && (i.push({ from: s3, to: o3 }), r3 += o3 - s3), s3 = l3;
    }
  }, 20), s3 < t3 && (i.push({ from: s3, to: t3 }), r3 += t3 - s3), { total: r3, ranges: i };
}
function _t$3({ total: n3, ranges: t3 }, e28) {
  if (e28 <= 0)
    return t3[0].from;
  if (e28 >= 1)
    return t3[t3.length - 1].to;
  let i = Math.floor(n3 * e28);
  for (let s3 = 0; ; s3++) {
    let { from: r3, to: o3 } = t3[s3], l3 = o3 - r3;
    if (i <= l3)
      return r3 + i;
    i -= l3;
  }
}
function Xt$3(n3, t3) {
  let e28 = 0;
  for (let { from: i, to: s3 } of n3.ranges) {
    if (t3 <= s3) {
      e28 += t3 - i;
      break;
    }
    e28 += s3 - i;
  }
  return e28 / n3.total;
}
function kr$1(n3, t3) {
  for (let e28 of n3)
    if (t3(e28))
      return e28;
}
const Ti$1 = {
  toDOM(n3) {
    return n3;
  },
  fromDOM(n3) {
    return n3;
  },
  scale: 1
};
class Ar$1 {
  constructor(t3, e28, i) {
    let s3 = 0, r3 = 0, o3 = 0;
    this.viewports = i.map(({ from: l3, to: h3 }) => {
      let c3 = e28.lineAt(l3, O$n.ByPos, t3, 0, 0).top, a3 = e28.lineAt(h3, O$n.ByPos, t3, 0, 0).bottom;
      return s3 += a3 - c3, { from: l3, to: h3, top: c3, bottom: a3, domTop: 0, domBottom: 0 };
    }), this.scale = (7e6 - s3) / (e28.height - s3);
    for (let l3 of this.viewports)
      l3.domTop = o3 + (l3.top - r3) * this.scale, o3 = l3.domBottom = l3.domTop + (l3.bottom - l3.top), r3 = l3.bottom;
  }
  toDOM(t3) {
    for (let e28 = 0, i = 0, s3 = 0; ; e28++) {
      let r3 = e28 < this.viewports.length ? this.viewports[e28] : null;
      if (!r3 || t3 < r3.top)
        return s3 + (t3 - i) * this.scale;
      if (t3 <= r3.bottom)
        return r3.domTop + (t3 - r3.top);
      i = r3.bottom, s3 = r3.domBottom;
    }
  }
  fromDOM(t3) {
    for (let e28 = 0, i = 0, s3 = 0; ; e28++) {
      let r3 = e28 < this.viewports.length ? this.viewports[e28] : null;
      if (!r3 || t3 < r3.domTop)
        return i + (t3 - s3) / this.scale;
      if (t3 <= r3.domBottom)
        return r3.top + (t3 - r3.domTop);
      i = r3.bottom, s3 = r3.domBottom;
    }
  }
}
function Mt$5(n3, t3) {
  if (t3.scale == 1)
    return n3;
  let e28 = t3.toDOM(n3.top), i = t3.toDOM(n3.bottom);
  return new G$k(n3.from, n3.length, e28, i - e28, Array.isArray(n3._content) ? n3._content.map((s3) => Mt$5(s3, t3)) : n3._content);
}
const $t$7 = /* @__PURE__ */ A$o.define({ combine: (n3) => n3.join(" ") }), Ve$7 = /* @__PURE__ */ A$o.define({ combine: (n3) => n3.indexOf(true) > -1 }), We$6 = /* @__PURE__ */ C$H.newName(), Ks$2 = /* @__PURE__ */ C$H.newName(), qs$2 = /* @__PURE__ */ C$H.newName(), js$2 = { "&light": "." + Ks$2, "&dark": "." + qs$2 };
function Fe$5(n3, t3, e28) {
  return new C$H(t3, {
    finish(i) {
      return /&/.test(i) ? i.replace(/&\w*/, (s3) => {
        if (s3 == "&")
          return n3;
        if (!e28 || !e28[s3])
          throw new RangeError(`Unsupported selector: ${s3}`);
        return e28[s3];
      }) : n3 + " " + i;
    }
  });
}
const Dr$1 = /* @__PURE__ */ Fe$5("." + We$6, {
  "&": {
    position: "relative !important",
    boxSizing: "border-box",
    "&.cm-focused": {
      outline: "1px dotted #212121"
    },
    display: "flex !important",
    flexDirection: "column"
  },
  ".cm-scroller": {
    display: "flex !important",
    alignItems: "flex-start !important",
    fontFamily: "monospace",
    lineHeight: 1.4,
    height: "100%",
    overflowX: "auto",
    position: "relative",
    zIndex: 0
  },
  ".cm-content": {
    margin: 0,
    flexGrow: 2,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre",
    wordWrap: "normal",
    boxSizing: "border-box",
    minHeight: "100%",
    padding: "4px 0",
    outline: "none",
    "&[contenteditable=true]": {
      WebkitUserModify: "read-write-plaintext-only"
    }
  },
  ".cm-lineWrapping": {
    whiteSpace_fallback: "pre-wrap",
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    flexShrink: 1
  },
  "&light .cm-content": { caretColor: "black" },
  "&dark .cm-content": { caretColor: "white" },
  ".cm-line": {
    display: "block",
    padding: "0 2px 0 6px"
  },
  ".cm-layer": {
    position: "absolute",
    left: 0,
    top: 0,
    contain: "size style",
    "& > *": {
      position: "absolute"
    }
  },
  "&light .cm-selectionBackground": {
    background: "#d9d9d9"
  },
  "&dark .cm-selectionBackground": {
    background: "#222"
  },
  "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#d7d4f0"
  },
  "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#233"
  },
  ".cm-cursorLayer": {
    pointerEvents: "none"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
    animation: "steps(1) cm-blink 1.2s infinite"
  },
  "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  ".cm-cursor, .cm-dropCursor": {
    borderLeft: "1.2px solid black",
    marginLeft: "-0.6px",
    pointerEvents: "none"
  },
  ".cm-cursor": {
    display: "none"
  },
  "&dark .cm-cursor": {
    borderLeftColor: "#444"
  },
  ".cm-dropCursor": {
    position: "absolute"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
    display: "block"
  },
  "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
  "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
  "&light .cm-specialChar": { color: "red" },
  "&dark .cm-specialChar": { color: "#f78" },
  ".cm-gutters": {
    flexShrink: 0,
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    insetInlineStart: 0,
    zIndex: 200
  },
  "&light .cm-gutters": {
    backgroundColor: "#f5f5f5",
    color: "#6c6c6c",
    borderRight: "1px solid #ddd"
  },
  "&dark .cm-gutters": {
    backgroundColor: "#333338",
    color: "#ccc"
  },
  ".cm-gutter": {
    display: "flex !important",
    flexDirection: "column",
    flexShrink: 0,
    boxSizing: "border-box",
    minHeight: "100%",
    overflow: "hidden"
  },
  ".cm-gutterElement": {
    boxSizing: "border-box"
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 3px 0 5px",
    minWidth: "20px",
    textAlign: "right",
    whiteSpace: "nowrap"
  },
  "&light .cm-activeLineGutter": {
    backgroundColor: "#e2f2ff"
  },
  "&dark .cm-activeLineGutter": {
    backgroundColor: "#222227"
  },
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tab": {
    display: "inline-block",
    overflow: "hidden",
    verticalAlign: "bottom"
  },
  ".cm-widgetBuffer": {
    verticalAlign: "text-top",
    height: "1em",
    width: 0,
    display: "inline"
  },
  ".cm-placeholder": {
    color: "#888",
    display: "inline-block",
    verticalAlign: "top"
  },
  ".cm-highlightSpace:before": {
    content: "attr(data-display)",
    position: "absolute",
    pointerEvents: "none",
    color: "#888"
  },
  ".cm-highlightTab": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
    backgroundSize: "auto 100%",
    backgroundPosition: "right 90%",
    backgroundRepeat: "no-repeat"
  },
  ".cm-trailingSpace": {
    backgroundColor: "#ff332255"
  },
  ".cm-button": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    padding: ".2em 1em",
    borderRadius: "1px"
  },
  "&light .cm-button": {
    backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
    }
  },
  "&dark .cm-button": {
    backgroundImage: "linear-gradient(#393939, #111)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#111, #333)"
    }
  },
  ".cm-textfield": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    border: "1px solid silver",
    padding: ".2em .5em"
  },
  "&light .cm-textfield": {
    backgroundColor: "white"
  },
  "&dark .cm-textfield": {
    border: "1px solid #555",
    backgroundColor: "inherit"
  }
}, js$2), kt$6 = "\uFFFF";
class Or$2 {
  constructor(t3, e28) {
    this.points = t3, this.text = "", this.lineSeparator = e28.facet(w$q.lineSeparator);
  }
  append(t3) {
    this.text += t3;
  }
  lineBreak() {
    this.text += kt$6;
  }
  readRange(t3, e28) {
    if (!t3)
      return this;
    let i = t3.parentNode;
    for (let s3 = t3; ; ) {
      this.findPointBefore(i, s3);
      let r3 = this.text.length;
      this.readNode(s3);
      let o3 = s3.nextSibling;
      if (o3 == e28)
        break;
      let l3 = T$w.get(s3), h3 = T$w.get(o3);
      (l3 && h3 ? l3.breakAfter : (l3 ? l3.breakAfter : Ri$2(s3)) || Ri$2(o3) && (s3.nodeName != "BR" || s3.cmIgnore) && this.text.length > r3) && this.lineBreak(), s3 = o3;
    }
    return this.findPointBefore(i, e28), this;
  }
  readTextNode(t3) {
    let e28 = t3.nodeValue;
    for (let i of this.points)
      i.node == t3 && (i.pos = this.text.length + Math.min(i.offset, e28.length));
    for (let i = 0, s3 = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      let r3 = -1, o3 = 1, l3;
      if (this.lineSeparator ? (r3 = e28.indexOf(this.lineSeparator, i), o3 = this.lineSeparator.length) : (l3 = s3.exec(e28)) && (r3 = l3.index, o3 = l3[0].length), this.append(e28.slice(i, r3 < 0 ? e28.length : r3)), r3 < 0)
        break;
      if (this.lineBreak(), o3 > 1)
        for (let h3 of this.points)
          h3.node == t3 && h3.pos > this.text.length && (h3.pos -= o3 - 1);
      i = r3 + o3;
    }
  }
  readNode(t3) {
    if (t3.cmIgnore)
      return;
    let e28 = T$w.get(t3), i = e28 && e28.overrideDOMText;
    if (i != null) {
      this.findPointInside(t3, i.length);
      for (let s3 = i.iter(); !s3.next().done; )
        s3.lineBreak ? this.lineBreak() : this.append(s3.value);
    } else
      t3.nodeType == 3 ? this.readTextNode(t3) : t3.nodeName == "BR" ? t3.nextSibling && this.lineBreak() : t3.nodeType == 1 && this.readRange(t3.firstChild, null);
  }
  findPointBefore(t3, e28) {
    for (let i of this.points)
      i.node == t3 && t3.childNodes[i.offset] == e28 && (i.pos = this.text.length);
  }
  findPointInside(t3, e28) {
    for (let i of this.points)
      (t3.nodeType == 3 ? i.node == t3 : t3.contains(i.node)) && (i.pos = this.text.length + (Tr$2(t3, i.node, i.offset) ? e28 : 0));
  }
}
function Tr$2(n3, t3, e28) {
  for (; ; ) {
    if (!t3 || e28 < J$g(t3))
      return false;
    if (t3 == n3)
      return true;
    e28 = Lt$4(t3) + 1, t3 = t3.parentNode;
  }
}
function Ri$2(n3) {
  return n3.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(n3.nodeName);
}
class Li$2 {
  constructor(t3, e28) {
    this.node = t3, this.offset = e28, this.pos = -1;
  }
}
class Rr$2 {
  constructor(t3, e28, i, s3) {
    this.typeOver = s3, this.bounds = null, this.text = "";
    let { impreciseHead: r3, impreciseAnchor: o3 } = t3.docView;
    if (t3.state.readOnly && e28 > -1)
      this.newSel = null;
    else if (e28 > -1 && (this.bounds = t3.docView.domBoundsAround(e28, i, 0))) {
      let l3 = r3 || o3 ? [] : Er$2(t3), h3 = new Or$2(l3, t3.state);
      h3.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = h3.text, this.newSel = Pr$2(l3, this.bounds.from);
    } else {
      let l3 = t3.observer.selectionRange, h3 = r3 && r3.node == l3.focusNode && r3.offset == l3.focusOffset || !Ce$8(t3.contentDOM, l3.focusNode) ? t3.state.selection.main.head : t3.docView.posFromDOM(l3.focusNode, l3.focusOffset), c3 = o3 && o3.node == l3.anchorNode && o3.offset == l3.anchorOffset || !Ce$8(t3.contentDOM, l3.anchorNode) ? t3.state.selection.main.anchor : t3.docView.posFromDOM(l3.anchorNode, l3.anchorOffset);
      this.newSel = g$K.single(c3, h3);
    }
  }
}
function Ys$2(n3, t3) {
  let e28, { newSel: i } = t3, s3 = n3.state.selection.main, r3 = n3.inputState.lastKeyTime > Date.now() - 100 ? n3.inputState.lastKeyCode : -1;
  if (t3.bounds) {
    let { from: o3, to: l3 } = t3.bounds, h3 = s3.from, c3 = null;
    (r3 === 8 || w$o.android && t3.text.length < l3 - o3) && (h3 = s3.to, c3 = "end");
    let a3 = Br$2(n3.state.doc.sliceString(o3, l3, kt$6), t3.text, h3 - o3, c3);
    a3 && (w$o.chrome && r3 == 13 && a3.toB == a3.from + 2 && t3.text.slice(a3.from, a3.toB) == kt$6 + kt$6 && a3.toB--, e28 = {
      from: o3 + a3.from,
      to: o3 + a3.toA,
      insert: x$l.of(t3.text.slice(a3.from, a3.toB).split(kt$6))
    });
  } else
    i && (!n3.hasFocus && n3.state.facet(fe$a) || i.main.eq(s3)) && (i = null);
  if (!e28 && !i)
    return false;
  if (!e28 && t3.typeOver && !s3.empty && i && i.main.empty ? e28 = { from: s3.from, to: s3.to, insert: n3.state.doc.slice(s3.from, s3.to) } : e28 && e28.from >= s3.from && e28.to <= s3.to && (e28.from != s3.from || e28.to != s3.to) && s3.to - s3.from - (e28.to - e28.from) <= 4 ? e28 = {
    from: s3.from,
    to: s3.to,
    insert: n3.state.doc.slice(s3.from, e28.from).append(e28.insert).append(n3.state.doc.slice(e28.to, s3.to))
  } : (w$o.mac || w$o.android) && e28 && e28.from == e28.to && e28.from == s3.head - 1 && /^\. ?$/.test(e28.insert.toString()) && n3.contentDOM.getAttribute("autocorrect") == "off" ? (i && e28.insert.length == 2 && (i = g$K.single(i.main.anchor - 1, i.main.head - 1)), e28 = { from: s3.from, to: s3.to, insert: x$l.of([" "]) }) : w$o.chrome && e28 && e28.from == e28.to && e28.from == s3.head && e28.insert.toString() == `
 ` && n3.lineWrapping && (i && (i = g$K.single(i.main.anchor - 1, i.main.head - 1)), e28 = { from: s3.from, to: s3.to, insert: x$l.of([" "]) }), e28) {
    if (w$o.ios && n3.inputState.flushIOSKey() || w$o.android && (e28.from == s3.from && e28.to == s3.to && e28.insert.length == 1 && e28.insert.lines == 2 && bt$5(n3.contentDOM, "Enter", 13) || (e28.from == s3.from - 1 && e28.to == s3.to && e28.insert.length == 0 || r3 == 8 && e28.insert.length < e28.to - e28.from && e28.to > s3.head) && bt$5(n3.contentDOM, "Backspace", 8) || e28.from == s3.from && e28.to == s3.to + 1 && e28.insert.length == 0 && bt$5(n3.contentDOM, "Delete", 46)))
      return true;
    let o3 = e28.insert.toString();
    n3.inputState.composing >= 0 && n3.inputState.composing++;
    let l3, h3 = () => l3 || (l3 = Lr$3(n3, e28, i));
    return n3.state.facet(ms$2).some((c3) => c3(n3, e28.from, e28.to, o3, h3)) || n3.dispatch(h3()), true;
  } else if (i && !i.main.eq(s3)) {
    let o3 = false, l3 = "select";
    return n3.inputState.lastSelectionTime > Date.now() - 50 && (n3.inputState.lastSelectionOrigin == "select" && (o3 = true), l3 = n3.inputState.lastSelectionOrigin), n3.dispatch({ selection: i, scrollIntoView: o3, userEvent: l3 }), true;
  } else
    return false;
}
function Lr$3(n3, t3, e28) {
  let i, s3 = n3.state, r3 = s3.selection.main;
  if (t3.from >= r3.from && t3.to <= r3.to && t3.to - t3.from >= (r3.to - r3.from) / 3 && (!e28 || e28.main.empty && e28.main.from == t3.from + t3.insert.length) && n3.inputState.composing < 0) {
    let l3 = r3.from < t3.from ? s3.sliceDoc(r3.from, t3.from) : "", h3 = r3.to > t3.to ? s3.sliceDoc(t3.to, r3.to) : "";
    i = s3.replaceSelection(n3.state.toText(l3 + t3.insert.sliceString(0, void 0, n3.state.lineBreak) + h3));
  } else {
    let l3 = s3.changes(t3), h3 = e28 && e28.main.to <= l3.newLength ? e28.main : void 0;
    if (s3.selection.ranges.length > 1 && n3.inputState.composing >= 0 && t3.to <= r3.to && t3.to >= r3.to - 10) {
      let c3 = n3.state.sliceDoc(t3.from, t3.to), a3, f3 = e28 && Ts$2(n3, e28.main.head);
      if (f3) {
        let g3 = t3.insert.length - (t3.to - t3.from);
        a3 = { from: f3.from, to: f3.to - g3 };
      } else
        a3 = n3.state.doc.lineAt(r3.head);
      let d3 = r3.to - t3.to, u3 = r3.to - r3.from;
      i = s3.changeByRange((g3) => {
        if (g3.from == r3.from && g3.to == r3.to)
          return { changes: l3, range: h3 || g3.map(l3) };
        let m3 = g3.to - d3, p3 = m3 - c3.length;
        if (g3.to - g3.from != u3 || n3.state.sliceDoc(p3, m3) != c3 || g3.to >= a3.from && g3.from <= a3.to)
          return { range: g3 };
        let b3 = s3.changes({ from: p3, to: m3, insert: t3.insert }), v3 = g3.to - r3.to;
        return {
          changes: b3,
          range: h3 ? g$K.range(Math.max(0, h3.anchor + v3), Math.max(0, h3.head + v3)) : g3.map(b3)
        };
      });
    } else
      i = {
        changes: l3,
        selection: h3 && s3.selection.replaceRange(h3)
      };
  }
  let o3 = "input.type";
  return (n3.composing || n3.inputState.compositionPendingChange && n3.inputState.compositionEndedAt > Date.now() - 50) && (n3.inputState.compositionPendingChange = false, o3 += ".compose", n3.inputState.compositionFirstChange && (o3 += ".start", n3.inputState.compositionFirstChange = false)), s3.update(i, { userEvent: o3, scrollIntoView: true });
}
function Br$2(n3, t3, e28, i) {
  let s3 = Math.min(n3.length, t3.length), r3 = 0;
  for (; r3 < s3 && n3.charCodeAt(r3) == t3.charCodeAt(r3); )
    r3++;
  if (r3 == s3 && n3.length == t3.length)
    return null;
  let o3 = n3.length, l3 = t3.length;
  for (; o3 > 0 && l3 > 0 && n3.charCodeAt(o3 - 1) == t3.charCodeAt(l3 - 1); )
    o3--, l3--;
  if (i == "end") {
    let h3 = Math.max(0, r3 - Math.min(o3, l3));
    e28 -= o3 + h3 - r3;
  }
  if (o3 < r3 && n3.length < t3.length) {
    let h3 = e28 <= r3 && e28 >= o3 ? r3 - e28 : 0;
    r3 -= h3, l3 = r3 + (l3 - o3), o3 = r3;
  } else if (l3 < r3) {
    let h3 = e28 <= r3 && e28 >= l3 ? r3 - e28 : 0;
    r3 -= h3, o3 = r3 + (o3 - l3), l3 = r3;
  }
  return { from: r3, toA: o3, toB: l3 };
}
function Er$2(n3) {
  let t3 = [];
  if (n3.root.activeElement != n3.contentDOM)
    return t3;
  let { anchorNode: e28, anchorOffset: i, focusNode: s3, focusOffset: r3 } = n3.observer.selectionRange;
  return e28 && (t3.push(new Li$2(e28, i)), (s3 != e28 || r3 != i) && t3.push(new Li$2(s3, r3))), t3;
}
function Pr$2(n3, t3) {
  if (n3.length == 0)
    return null;
  let e28 = n3[0].pos, i = n3.length == 2 ? n3[1].pos : e28;
  return e28 > -1 && i > -1 ? g$K.single(e28 + t3, i + t3) : null;
}
const Hr$1 = {
  childList: true,
  characterData: true,
  subtree: true,
  attributes: true,
  characterDataOldValue: true
}, be$a = w$o.ie && w$o.ie_version <= 11;
class Nr$2 {
  constructor(t3) {
    this.view = t3, this.active = false, this.selectionRange = new yn$2(), this.selectionChanged = false, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.intersection = null, this.resizeScroll = null, this.intersecting = false, this.gapIntersection = null, this.gaps = [], this.parentCheck = -1, this.dom = t3.contentDOM, this.observer = new MutationObserver((e28) => {
      for (let i of e28)
        this.queue.push(i);
      (w$o.ie && w$o.ie_version <= 11 || w$o.ios && t3.composing) && e28.some((i) => i.type == "childList" && i.removedNodes.length || i.type == "characterData" && i.oldValue.length > i.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), be$a && (this.onCharData = (e28) => {
      this.queue.push({
        target: e28.target,
        type: "characterData",
        oldValue: e28.prevValue
      }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), typeof ResizeObserver == "function" && (this.resizeScroll = new ResizeObserver(() => {
      var e28;
      ((e28 = this.view.docView) === null || e28 === void 0 ? void 0 : e28.lastUpdate) < Date.now() - 75 && this.onResize();
    }), this.resizeScroll.observe(t3.scrollDOM)), this.addWindowListeners(this.win = t3.win), this.start(), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver((e28) => {
      this.parentCheck < 0 && (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)), e28.length > 0 && e28[e28.length - 1].intersectionRatio > 0 != this.intersecting && (this.intersecting = !this.intersecting, this.intersecting != this.view.inView && this.onScrollChanged(document.createEvent("Event")));
    }, { threshold: [0, 1e-3] }), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver((e28) => {
      e28.length > 0 && e28[e28.length - 1].intersectionRatio > 0 && this.onScrollChanged(document.createEvent("Event"));
    }, {})), this.listenForScroll(), this.readSelectionRange();
  }
  onScrollChanged(t3) {
    this.view.inputState.runHandlers("scroll", t3), this.intersecting && this.view.measure();
  }
  onScroll(t3) {
    this.intersecting && this.flush(false), this.onScrollChanged(t3);
  }
  onResize() {
    this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(() => {
      this.resizeTimeout = -1, this.view.requestMeasure();
    }, 50));
  }
  onPrint() {
    this.view.viewState.printing = true, this.view.measure(), setTimeout(() => {
      this.view.viewState.printing = false, this.view.requestMeasure();
    }, 500);
  }
  updateGaps(t3) {
    if (this.gapIntersection && (t3.length != this.gaps.length || this.gaps.some((e28, i) => e28 != t3[i]))) {
      this.gapIntersection.disconnect();
      for (let e28 of t3)
        this.gapIntersection.observe(e28);
      this.gaps = t3;
    }
  }
  onSelectionChange(t3) {
    let e28 = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey)
      return;
    let { view: i } = this, s3 = this.selectionRange;
    if (i.state.facet(fe$a) ? i.root.activeElement != this.dom : !Zt$3(i.dom, s3))
      return;
    let r3 = s3.anchorNode && i.docView.nearest(s3.anchorNode);
    if (r3 && r3.ignoreEvent(t3)) {
      e28 || (this.selectionChanged = false);
      return;
    }
    (w$o.ie && w$o.ie_version <= 11 || w$o.android && w$o.chrome) && !i.state.selection.main.empty && s3.focusNode && re$a(s3.focusNode, s3.focusOffset, s3.anchorNode, s3.anchorOffset) ? this.flushSoon() : this.flush(false);
  }
  readSelectionRange() {
    let { view: t3 } = this, e28 = w$o.safari && t3.root.nodeType == 11 && pn$2(this.dom.ownerDocument) == this.dom && Vr$1(this.view) || ne$d(t3.root);
    if (!e28 || this.selectionRange.eq(e28))
      return false;
    let i = Zt$3(this.dom, e28);
    return i && !this.selectionChanged && t3.inputState.lastFocusTime > Date.now() - 200 && t3.inputState.lastTouchTime < Date.now() - 300 && Sn$1(this.dom, e28) ? (this.view.inputState.lastFocusTime = 0, t3.docView.updateSelection(), false) : (this.selectionRange.setRange(e28), i && (this.selectionChanged = true), true);
  }
  setSelectionRange(t3, e28) {
    this.selectionRange.set(t3.node, t3.offset, e28.node, e28.offset), this.selectionChanged = false;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let t3 = 0, e28 = null;
    for (let i = this.dom; i; )
      if (i.nodeType == 1)
        !e28 && t3 < this.scrollTargets.length && this.scrollTargets[t3] == i ? t3++ : e28 || (e28 = this.scrollTargets.slice(0, t3)), e28 && e28.push(i), i = i.assignedSlot || i.parentNode;
      else if (i.nodeType == 11)
        i = i.host;
      else
        break;
    if (t3 < this.scrollTargets.length && !e28 && (e28 = this.scrollTargets.slice(0, t3)), e28) {
      for (let i of this.scrollTargets)
        i.removeEventListener("scroll", this.onScroll);
      for (let i of this.scrollTargets = e28)
        i.addEventListener("scroll", this.onScroll);
    }
  }
  ignore(t3) {
    if (!this.active)
      return t3();
    try {
      return this.stop(), t3();
    } finally {
      this.start(), this.clear();
    }
  }
  start() {
    this.active || (this.observer.observe(this.dom, Hr$1), be$a && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = true);
  }
  stop() {
    this.active && (this.active = false, this.observer.disconnect(), be$a && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
  }
  clear() {
    this.processRecords(), this.queue.length = 0, this.selectionChanged = false;
  }
  delayAndroidKey(t3, e28) {
    var i;
    if (!this.delayedAndroidKey) {
      let s3 = () => {
        let r3 = this.delayedAndroidKey;
        r3 && (this.clearDelayedAndroidKey(), this.view.inputState.lastKeyCode = r3.keyCode, this.view.inputState.lastKeyTime = Date.now(), !this.flush() && r3.force && bt$5(this.dom, r3.key, r3.keyCode));
      };
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(s3);
    }
    (!this.delayedAndroidKey || t3 == "Enter") && (this.delayedAndroidKey = {
      key: t3,
      keyCode: e28,
      force: this.lastChange < Date.now() - 50 || !!(!((i = this.delayedAndroidKey) === null || i === void 0) && i.force)
    });
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
  }
  flushSoon() {
    this.delayedFlush < 0 && (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
      this.delayedFlush = -1, this.flush();
    }));
  }
  forceFlush() {
    this.delayedFlush >= 0 && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
  }
  pendingRecords() {
    for (let t3 of this.observer.takeRecords())
      this.queue.push(t3);
    return this.queue;
  }
  processRecords() {
    let t3 = this.pendingRecords();
    t3.length && (this.queue = []);
    let e28 = -1, i = -1, s3 = false;
    for (let r3 of t3) {
      let o3 = this.readMutation(r3);
      o3 && (o3.typeOver && (s3 = true), e28 == -1 ? { from: e28, to: i } = o3 : (e28 = Math.min(o3.from, e28), i = Math.max(o3.to, i)));
    }
    return { from: e28, to: i, typeOver: s3 };
  }
  readChange() {
    let { from: t3, to: e28, typeOver: i } = this.processRecords(), s3 = this.selectionChanged && Zt$3(this.dom, this.selectionRange);
    if (t3 < 0 && !s3)
      return null;
    t3 > -1 && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = false;
    let r3 = new Rr$2(this.view, t3, e28, i);
    return this.view.docView.domChanged = { newSel: r3.newSel ? r3.newSel.main : null }, r3;
  }
  flush(t3 = true) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey)
      return false;
    t3 && this.readSelectionRange();
    let e28 = this.readChange();
    if (!e28)
      return this.view.requestMeasure(), false;
    let i = this.view.state, s3 = Ys$2(this.view, e28);
    return this.view.state == i && this.view.update([]), s3;
  }
  readMutation(t3) {
    let e28 = this.view.docView.nearest(t3.target);
    if (!e28 || e28.ignoreMutation(t3))
      return null;
    if (e28.markDirty(t3.type == "attributes"), t3.type == "attributes" && (e28.flags |= 4), t3.type == "childList") {
      let i = Bi$2(e28, t3.previousSibling || t3.target.previousSibling, -1), s3 = Bi$2(e28, t3.nextSibling || t3.target.nextSibling, 1);
      return {
        from: i ? e28.posAfter(i) : e28.posAtStart,
        to: s3 ? e28.posBefore(s3) : e28.posAtEnd,
        typeOver: false
      };
    } else
      return t3.type == "characterData" ? { from: e28.posAtStart, to: e28.posAtEnd, typeOver: t3.target.nodeValue == t3.oldValue } : null;
  }
  setWindow(t3) {
    t3 != this.win && (this.removeWindowListeners(this.win), this.win = t3, this.addWindowListeners(this.win));
  }
  addWindowListeners(t3) {
    t3.addEventListener("resize", this.onResize), t3.addEventListener("beforeprint", this.onPrint), t3.addEventListener("scroll", this.onScroll), t3.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(t3) {
    t3.removeEventListener("scroll", this.onScroll), t3.removeEventListener("resize", this.onResize), t3.removeEventListener("beforeprint", this.onPrint), t3.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  destroy() {
    var t3, e28, i;
    this.stop(), (t3 = this.intersection) === null || t3 === void 0 || t3.disconnect(), (e28 = this.gapIntersection) === null || e28 === void 0 || e28.disconnect(), (i = this.resizeScroll) === null || i === void 0 || i.disconnect();
    for (let s3 of this.scrollTargets)
      s3.removeEventListener("scroll", this.onScroll);
    this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey);
  }
}
function Bi$2(n3, t3, e28) {
  for (; t3; ) {
    let i = T$w.get(t3);
    if (i && i.parent == n3)
      return i;
    let s3 = t3.parentNode;
    t3 = s3 != n3.dom ? s3 : e28 > 0 ? t3.nextSibling : t3.previousSibling;
  }
  return null;
}
function Vr$1(n3) {
  let t3 = null;
  function e28(h3) {
    h3.preventDefault(), h3.stopImmediatePropagation(), t3 = h3.getTargetRanges()[0];
  }
  if (n3.contentDOM.addEventListener("beforeinput", e28, true), n3.dom.ownerDocument.execCommand("indent"), n3.contentDOM.removeEventListener("beforeinput", e28, true), !t3)
    return null;
  let i = t3.startContainer, s3 = t3.startOffset, r3 = t3.endContainer, o3 = t3.endOffset, l3 = n3.docView.domAtPos(n3.state.selection.main.anchor);
  return re$a(l3.node, l3.offset, r3, o3) && ([i, s3, r3, o3] = [r3, o3, i, s3]), { anchorNode: i, anchorOffset: s3, focusNode: r3, focusOffset: o3 };
}
class A$m {
  get state() {
    return this.viewState.state;
  }
  get viewport() {
    return this.viewState.viewport;
  }
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  get inView() {
    return this.viewState.inView;
  }
  get composing() {
    return this.inputState.composing > 0;
  }
  get compositionStarted() {
    return this.inputState.composing >= 0;
  }
  get root() {
    return this._root;
  }
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  constructor(t3 = {}) {
    this.plugins = [], this.pluginMap = /* @__PURE__ */ new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = false, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.style.cssText = "position: fixed; top: -10000px", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM);
    let { dispatch: e28 } = t3;
    this.dispatchTransactions = t3.dispatchTransactions || e28 && ((i) => i.forEach((s3) => e28(s3, this))) || ((i) => this.update(i)), this.dispatch = this.dispatch.bind(this), this._root = t3.root || vn$2(t3.parent) || document, this.viewState = new Oi$2(t3.state || w$q.create(t3)), this.plugins = this.state.facet(xt$6).map((i) => new ue$b(i));
    for (let i of this.plugins)
      i.update(this);
    this.observer = new Nr$2(this), this.inputState = new Zn$2(this), this.inputState.ensureHandlers(this.plugins), this.docView = new ci$2(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure(), t3.parent && t3.parent.appendChild(this.dom);
  }
  dispatch(...t3) {
    let e28 = t3.length == 1 && t3[0] instanceof I$u ? t3 : t3.length == 1 && Array.isArray(t3[0]) ? t3[0] : [this.state.update(...t3)];
    this.dispatchTransactions(e28, this);
  }
  update(t3) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    let e28 = false, i = false, s3, r3 = this.state;
    for (let d3 of t3) {
      if (d3.startState != r3)
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      r3 = d3.state;
    }
    if (this.destroyed) {
      this.viewState.state = r3;
      return;
    }
    let o3 = this.hasFocus, l3 = 0, h3 = null;
    t3.some((d3) => d3.annotation(Ws$2)) ? (this.inputState.notifiedFocused = o3, l3 = 1) : o3 != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = o3, h3 = Fs$2(r3, o3), h3 || (l3 = 1));
    let c3 = this.observer.delayedAndroidKey, a3 = null;
    if (c3 ? (this.observer.clearDelayedAndroidKey(), a3 = this.observer.readChange(), (a3 && !this.state.doc.eq(r3.doc) || !this.state.selection.eq(r3.selection)) && (a3 = null)) : this.observer.clear(), r3.facet(w$q.phrases) != this.state.facet(w$q.phrases))
      return this.setState(r3);
    s3 = le$9.create(this, r3, t3), s3.flags |= l3;
    let f3 = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let d3 of t3) {
        if (f3 && (f3 = f3.map(d3.changes)), d3.scrollIntoView) {
          let { main: u3 } = d3.state.selection;
          f3 = new oe$c(u3.empty ? u3 : g$K.cursor(u3.head, u3.head > u3.anchor ? -1 : 1));
        }
        for (let u3 of d3.effects)
          u3.is(hi$1) && (f3 = u3.value);
      }
      this.viewState.update(s3, f3), this.bidiCache = he$c.update(this.bidiCache, s3.changes), s3.empty || (this.updatePlugins(s3), this.inputState.update(s3)), e28 = this.docView.update(s3), this.state.facet(Ct$6) != this.styleModules && this.mountStyles(), i = this.updateAttrs(), this.showAnnouncements(t3), this.docView.updateSelection(e28, t3.some((d3) => d3.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (s3.startState.facet($t$7) != s3.state.facet($t$7) && (this.viewState.mustMeasureContent = true), (e28 || i || f3 || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), !s3.empty)
      for (let d3 of this.state.facet(Re$9))
        d3(s3);
    (h3 || a3) && Promise.resolve().then(() => {
      h3 && this.state == h3.startState && this.dispatch(h3), a3 && !Ys$2(this, a3) && c3.force && bt$5(this.contentDOM, c3.key, c3.keyCode);
    });
  }
  setState(t3) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed) {
      this.viewState.state = t3;
      return;
    }
    this.updateState = 2;
    let e28 = this.hasFocus;
    try {
      for (let i of this.plugins)
        i.destroy(this);
      this.viewState = new Oi$2(t3), this.plugins = t3.facet(xt$6).map((i) => new ue$b(i)), this.pluginMap.clear();
      for (let i of this.plugins)
        i.update(this);
      this.docView = new ci$2(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    e28 && this.focus(), this.requestMeasure();
  }
  updatePlugins(t3) {
    let e28 = t3.startState.facet(xt$6), i = t3.state.facet(xt$6);
    if (e28 != i) {
      let s3 = [];
      for (let r3 of i) {
        let o3 = e28.indexOf(r3);
        if (o3 < 0)
          s3.push(new ue$b(r3));
        else {
          let l3 = this.plugins[o3];
          l3.mustUpdate = t3, s3.push(l3);
        }
      }
      for (let r3 of this.plugins)
        r3.mustUpdate != t3 && r3.destroy(this);
      this.plugins = s3, this.pluginMap.clear();
    } else
      for (let s3 of this.plugins)
        s3.mustUpdate = t3;
    for (let s3 = 0; s3 < this.plugins.length; s3++)
      this.plugins[s3].update(this);
    e28 != i && this.inputState.ensureHandlers(this.plugins);
  }
  measure(t3 = true) {
    if (this.destroyed)
      return;
    if (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) {
      this.measureScheduled = -1, this.requestMeasure();
      return;
    }
    this.measureScheduled = 0, t3 && this.observer.forceFlush();
    let e28 = null, i = this.scrollDOM, s3 = i.scrollTop * this.scaleY, { scrollAnchorPos: r3, scrollAnchorHeight: o3 } = this.viewState;
    Math.abs(s3 - this.viewState.scrollTop) > 1 && (o3 = -1), this.viewState.scrollAnchorHeight = -1;
    try {
      for (let l3 = 0; ; l3++) {
        if (o3 < 0)
          if (is$1(i))
            r3 = -1, o3 = this.viewState.heightMap.height;
          else {
            let u3 = this.viewState.scrollAnchorAt(s3);
            r3 = u3.from, o3 = u3.top;
          }
        this.updateState = 1;
        let h3 = this.viewState.measure(this);
        if (!h3 && !this.measureRequests.length && this.viewState.scrollTarget == null)
          break;
        if (l3 > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let c3 = [];
        h3 & 4 || ([this.measureRequests, c3] = [c3, this.measureRequests]);
        let a3 = c3.map((u3) => {
          try {
            return u3.read(this);
          } catch (g3) {
            return ct$6(this.state, g3), Ei$2;
          }
        }), f3 = le$9.create(this, this.state, []), d3 = false;
        f3.flags |= h3, e28 ? e28.flags |= h3 : e28 = f3, this.updateState = 2, f3.empty || (this.updatePlugins(f3), this.inputState.update(f3), this.updateAttrs(), d3 = this.docView.update(f3));
        for (let u3 = 0; u3 < c3.length; u3++)
          if (a3[u3] != Ei$2)
            try {
              let g3 = c3[u3];
              g3.write && g3.write(a3[u3], this);
            } catch (g3) {
              ct$6(this.state, g3);
            }
        if (d3 && this.docView.updateSelection(true), !f3.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight)
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null;
              continue;
            } else {
              let g3 = (r3 < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(r3).top) - o3;
              if (g3 > 1 || g3 < -1) {
                s3 = s3 + g3, i.scrollTop = s3 / this.scaleY, o3 = -1;
                continue;
              }
            }
          break;
        }
      }
    } finally {
      this.updateState = 0, this.measureScheduled = -1;
    }
    if (e28 && !e28.empty)
      for (let l3 of this.state.facet(Re$9))
        l3(e28);
  }
  get themeClasses() {
    return We$6 + " " + (this.state.facet(Ve$7) ? qs$2 : Ks$2) + " " + this.state.facet($t$7);
  }
  updateAttrs() {
    let t3 = Pi$1(this, vs$2, {
      class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
    }), e28 = {
      spellcheck: "false",
      autocorrect: "off",
      autocapitalize: "off",
      translate: "no",
      contenteditable: this.state.facet(fe$a) ? "true" : "false",
      class: "cm-content",
      style: `${w$o.tabSize}: ${this.state.tabSize}`,
      role: "textbox",
      "aria-multiline": "true"
    };
    this.state.readOnly && (e28["aria-readonly"] = "true"), Pi$1(this, $e$4, e28);
    let i = this.observer.ignore(() => {
      let s3 = Oe$6(this.contentDOM, this.contentAttrs, e28), r3 = Oe$6(this.dom, this.editorAttrs, t3);
      return s3 || r3;
    });
    return this.editorAttrs = t3, this.contentAttrs = e28, i;
  }
  showAnnouncements(t3) {
    let e28 = true;
    for (let i of t3)
      for (let s3 of i.effects)
        if (s3.is(A$m.announce)) {
          e28 && (this.announceDOM.textContent = ""), e28 = false;
          let r3 = this.announceDOM.appendChild(document.createElement("div"));
          r3.textContent = s3.value;
        }
  }
  mountStyles() {
    this.styleModules = this.state.facet(Ct$6);
    let t3 = this.state.facet(A$m.cspNonce);
    C$H.mount(this.root, this.styleModules.concat(Dr$1).reverse(), t3 ? { nonce: t3 } : void 0);
  }
  readMeasured() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    this.updateState == 0 && this.measureScheduled > -1 && this.measure(false);
  }
  requestMeasure(t3) {
    if (this.measureScheduled < 0 && (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())), t3) {
      if (this.measureRequests.indexOf(t3) > -1)
        return;
      if (t3.key != null) {
        for (let e28 = 0; e28 < this.measureRequests.length; e28++)
          if (this.measureRequests[e28].key === t3.key) {
            this.measureRequests[e28] = t3;
            return;
          }
      }
      this.measureRequests.push(t3);
    }
  }
  plugin(t3) {
    let e28 = this.pluginMap.get(t3);
    return (e28 === void 0 || e28 && e28.spec != t3) && this.pluginMap.set(t3, e28 = this.plugins.find((i) => i.spec == t3) || null), e28 && e28.update(this).value;
  }
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  get documentPadding() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  }
  get scaleX() {
    return this.viewState.scaleX;
  }
  get scaleY() {
    return this.viewState.scaleY;
  }
  elementAtHeight(t3) {
    return this.readMeasured(), this.viewState.elementAtHeight(t3);
  }
  lineBlockAtHeight(t3) {
    return this.readMeasured(), this.viewState.lineBlockAtHeight(t3);
  }
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  lineBlockAt(t3) {
    return this.viewState.lineBlockAt(t3);
  }
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  moveByChar(t3, e28, i) {
    return pe$b(this, t3, mi$1(this, t3, e28, i));
  }
  moveByGroup(t3, e28) {
    return pe$b(this, t3, mi$1(this, t3, e28, (i) => Un$1(this, t3.head, i)));
  }
  moveToLineBoundary(t3, e28, i = true) {
    return $n$1(this, t3, e28, i);
  }
  moveVertically(t3, e28, i) {
    return pe$b(this, t3, Jn$2(this, t3, e28, i));
  }
  domAtPos(t3) {
    return this.docView.domAtPos(t3);
  }
  posAtDOM(t3, e28 = 0) {
    return this.docView.posFromDOM(t3, e28);
  }
  posAtCoords(t3, e28 = true) {
    return this.readMeasured(), Ls$2(this, t3, e28);
  }
  coordsAtPos(t3, e28 = 1) {
    this.readMeasured();
    let i = this.docView.coordsAt(t3, e28);
    if (!i || i.left == i.right)
      return i;
    let s3 = this.state.doc.lineAt(t3), r3 = this.bidiSpans(s3), o3 = r3[nt$5.find(r3, t3 - s3.from, -1, e28)];
    return Ge$5(i, o3.dir == L$r.LTR == e28 > 0);
  }
  coordsForChar(t3) {
    return this.readMeasured(), this.docView.coordsForChar(t3);
  }
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  textDirectionAt(t3) {
    return !this.state.facet(ws$2) || t3 < this.viewport.from || t3 > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(t3));
  }
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  bidiSpans(t3) {
    if (t3.length > Wr$1)
      return Ds$2(t3.length);
    let e28 = this.textDirectionAt(t3.from), i;
    for (let r3 of this.bidiCache)
      if (r3.from == t3.from && r3.dir == e28 && (r3.fresh || As$2(r3.isolates, i = ai$2(this, t3.from, t3.to))))
        return r3.order;
    i || (i = ai$2(this, t3.from, t3.to));
    let s3 = Hn$1(t3.text, e28, i);
    return this.bidiCache.push(new he$c(t3.from, t3.to, e28, i, true, s3)), s3;
  }
  get hasFocus() {
    var t3;
    return (this.dom.ownerDocument.hasFocus() || w$o.safari && ((t3 = this.inputState) === null || t3 === void 0 ? void 0 : t3.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  focus() {
    this.observer.ignore(() => {
      ts$1(this.contentDOM), this.docView.updateSelection();
    });
  }
  setRoot(t3) {
    this._root != t3 && (this._root = t3, this.observer.setWindow((t3.nodeType == 9 ? t3 : t3.ownerDocument).defaultView || window), this.mountStyles());
  }
  destroy() {
    for (let t3 of this.plugins)
      t3.destroy(this);
    this.plugins = [], this.inputState.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = true;
  }
  static scrollIntoView(t3, e28 = {}) {
    return hi$1.of(new oe$c(typeof t3 == "number" ? g$K.cursor(t3) : t3, e28.y, e28.x, e28.yMargin, e28.xMargin));
  }
  static domEventHandlers(t3) {
    return z$i.define(() => ({}), { eventHandlers: t3 });
  }
  static domEventObservers(t3) {
    return z$i.define(() => ({}), { eventObservers: t3 });
  }
  static theme(t3, e28) {
    let i = C$H.newName(), s3 = [$t$7.of(i), Ct$6.of(Fe$5(`.${i}`, t3))];
    return e28 && e28.dark && s3.push(Ve$7.of(true)), s3;
  }
  static baseTheme(t3) {
    return lt$8.lowest(Ct$6.of(Fe$5("." + We$6, t3, js$2)));
  }
  static findFromDOM(t3) {
    var e28;
    let i = t3.querySelector(".cm-content"), s3 = i && T$w.get(i) || T$w.get(t3);
    return ((e28 = s3 == null ? void 0 : s3.rootView) === null || e28 === void 0 ? void 0 : e28.view) || null;
  }
}
A$m.styleModule = Ct$6;
A$m.inputHandler = ms$2;
A$m.focusChangeEffect = bs$2;
A$m.perLineTextDirection = ws$2;
A$m.exceptionSink = ps$2;
A$m.updateListener = Re$9;
A$m.editable = fe$a;
A$m.mouseSelectionStyle = gs$2;
A$m.dragMovesSelection = us$2;
A$m.clickAddsSelectionRange = ds$2;
A$m.decorations = Bt$4;
A$m.atomicRanges = Ue$4;
A$m.bidiIsolatedRanges = Ss$2;
A$m.scrollMargins = xs$2;
A$m.darkTheme = Ve$7;
A$m.cspNonce = /* @__PURE__ */ A$o.define({ combine: (n3) => n3.length ? n3[0] : "" });
A$m.contentAttributes = $e$4;
A$m.editorAttributes = vs$2;
A$m.lineWrapping = /* @__PURE__ */ A$m.contentAttributes.of({ class: "cm-lineWrapping" });
A$m.announce = /* @__PURE__ */ S$m.define();
const Wr$1 = 4096, Ei$2 = {};
class he$c {
  constructor(t3, e28, i, s3, r3, o3) {
    this.from = t3, this.to = e28, this.dir = i, this.isolates = s3, this.fresh = r3, this.order = o3;
  }
  static update(t3, e28) {
    if (e28.empty && !t3.some((r3) => r3.fresh))
      return t3;
    let i = [], s3 = t3.length ? t3[t3.length - 1].dir : L$r.LTR;
    for (let r3 = Math.max(0, t3.length - 10); r3 < t3.length; r3++) {
      let o3 = t3[r3];
      o3.dir == s3 && !e28.touchesRange(o3.from, o3.to) && i.push(new he$c(e28.mapPos(o3.from, 1), e28.mapPos(o3.to, -1), o3.dir, o3.isolates, false, o3.order));
    }
    return i;
  }
}
function Pi$1(n3, t3, e28) {
  for (let i = n3.state.facet(t3), s3 = i.length - 1; s3 >= 0; s3--) {
    let r3 = i[s3], o3 = typeof r3 == "function" ? r3(n3) : r3;
    o3 && De$3(o3, e28);
  }
  return e28;
}
const Fr$1 = w$o.mac ? "mac" : w$o.windows ? "win" : w$o.linux ? "linux" : "key";
function zr$1(n3, t3) {
  const e28 = n3.split(/-(?!$)/);
  let i = e28[e28.length - 1];
  i == "Space" && (i = " ");
  let s3, r3, o3, l3;
  for (let h3 = 0; h3 < e28.length - 1; ++h3) {
    const c3 = e28[h3];
    if (/^(cmd|meta|m)$/i.test(c3))
      l3 = true;
    else if (/^a(lt)?$/i.test(c3))
      s3 = true;
    else if (/^(c|ctrl|control)$/i.test(c3))
      r3 = true;
    else if (/^s(hift)?$/i.test(c3))
      o3 = true;
    else if (/^mod$/i.test(c3))
      t3 == "mac" ? l3 = true : r3 = true;
    else
      throw new Error("Unrecognized modifier name: " + c3);
  }
  return s3 && (i = "Alt-" + i), r3 && (i = "Ctrl-" + i), l3 && (i = "Meta-" + i), o3 && (i = "Shift-" + i), i;
}
function Ut$5(n3, t3, e28) {
  return t3.altKey && (n3 = "Alt-" + n3), t3.ctrlKey && (n3 = "Ctrl-" + n3), t3.metaKey && (n3 = "Meta-" + n3), e28 !== false && t3.shiftKey && (n3 = "Shift-" + n3), n3;
}
const Ir$2 = /* @__PURE__ */ lt$8.default(/* @__PURE__ */ A$m.domEventHandlers({
  keydown(n3, t3) {
    return _s$2(Gs$2(t3.state), n3, t3, "editor");
  }
})), Kr$1 = /* @__PURE__ */ A$o.define({ enables: Ir$2 }), Hi$1 = /* @__PURE__ */ new WeakMap();
function Gs$2(n3) {
  let t3 = n3.facet(Kr$1), e28 = Hi$1.get(t3);
  return e28 || Hi$1.set(t3, e28 = jr$3(t3.reduce((i, s3) => i.concat(s3), []))), e28;
}
function Ho$1(n3, t3, e28) {
  return _s$2(Gs$2(n3.state), t3, n3, e28);
}
let it$5 = null;
const qr$1 = 4e3;
function jr$3(n3, t3 = Fr$1) {
  let e28 = /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null), s3 = (o3, l3) => {
    let h3 = i[o3];
    if (h3 == null)
      i[o3] = l3;
    else if (h3 != l3)
      throw new Error("Key binding " + o3 + " is used both as a regular binding and as a multi-stroke prefix");
  }, r3 = (o3, l3, h3, c3, a3) => {
    var f3, d3;
    let u3 = e28[o3] || (e28[o3] = /* @__PURE__ */ Object.create(null)), g3 = l3.split(/ (?!$)/).map((b3) => zr$1(b3, t3));
    for (let b3 = 1; b3 < g3.length; b3++) {
      let v3 = g3.slice(0, b3).join(" ");
      s3(v3, true), u3[v3] || (u3[v3] = {
        preventDefault: true,
        stopPropagation: false,
        run: [(x3) => {
          let y3 = it$5 = { view: x3, prefix: v3, scope: o3 };
          return setTimeout(() => {
            it$5 == y3 && (it$5 = null);
          }, qr$1), true;
        }]
      });
    }
    let m3 = g3.join(" ");
    s3(m3, false);
    let p3 = u3[m3] || (u3[m3] = {
      preventDefault: false,
      stopPropagation: false,
      run: ((d3 = (f3 = u3._any) === null || f3 === void 0 ? void 0 : f3.run) === null || d3 === void 0 ? void 0 : d3.slice()) || []
    });
    h3 && p3.run.push(h3), c3 && (p3.preventDefault = true), a3 && (p3.stopPropagation = true);
  };
  for (let o3 of n3) {
    let l3 = o3.scope ? o3.scope.split(" ") : ["editor"];
    if (o3.any)
      for (let c3 of l3) {
        let a3 = e28[c3] || (e28[c3] = /* @__PURE__ */ Object.create(null));
        a3._any || (a3._any = { preventDefault: false, stopPropagation: false, run: [] });
        for (let f3 in a3)
          a3[f3].run.push(o3.any);
      }
    let h3 = o3[t3] || o3.key;
    if (h3)
      for (let c3 of l3)
        r3(c3, h3, o3.run, o3.preventDefault, o3.stopPropagation), o3.shift && r3(c3, "Shift-" + h3, o3.shift, o3.preventDefault, o3.stopPropagation);
  }
  return e28;
}
function _s$2(n3, t3, e28, i) {
  let s3 = g$I(t3), r3 = ne$e(s3, 0), o3 = xe$a(r3) == s3.length && s3 != " ", l3 = "", h3 = false, c3 = false, a3 = false;
  it$5 && it$5.view == e28 && it$5.scope == i && (l3 = it$5.prefix + " ", Es$2.indexOf(t3.keyCode) < 0 && (c3 = true, it$5 = null));
  let f3 = /* @__PURE__ */ new Set(), d3 = (p3) => {
    if (p3) {
      for (let b3 of p3.run)
        if (!f3.has(b3) && (f3.add(b3), b3(e28, t3)))
          return p3.stopPropagation && (a3 = true), true;
      p3.preventDefault && (p3.stopPropagation && (a3 = true), c3 = true);
    }
    return false;
  }, u3 = n3[i], g3, m3;
  return u3 && (d3(u3[l3 + Ut$5(s3, t3, !o3)]) ? h3 = true : o3 && (t3.altKey || t3.metaKey || t3.ctrlKey) && !(w$o.windows && t3.ctrlKey && t3.altKey) && (g3 = t$M[t3.keyCode]) && g3 != s3 ? (d3(u3[l3 + Ut$5(g3, t3, true)]) || t3.shiftKey && (m3 = a$15[t3.keyCode]) != s3 && m3 != g3 && d3(u3[l3 + Ut$5(m3, t3, false)])) && (h3 = true) : o3 && t3.shiftKey && d3(u3[l3 + Ut$5(s3, t3, true)]) && (h3 = true), !h3 && d3(u3._any) && (h3 = true)), c3 && (h3 = true), h3 && a3 && t3.stopPropagation(), h3;
}
class Ft$5 {
  constructor(t3, e28, i, s3, r3) {
    this.className = t3, this.left = e28, this.top = i, this.width = s3, this.height = r3;
  }
  draw() {
    let t3 = document.createElement("div");
    return t3.className = this.className, this.adjust(t3), t3;
  }
  update(t3, e28) {
    return e28.className != this.className ? false : (this.adjust(t3), true);
  }
  adjust(t3) {
    t3.style.left = this.left + "px", t3.style.top = this.top + "px", this.width != null && (t3.style.width = this.width + "px"), t3.style.height = this.height + "px";
  }
  eq(t3) {
    return this.left == t3.left && this.top == t3.top && this.width == t3.width && this.height == t3.height && this.className == t3.className;
  }
  static forRange(t3, e28, i) {
    if (i.empty) {
      let s3 = t3.coordsAtPos(i.head, i.assoc || 1);
      if (!s3)
        return [];
      let r3 = Xs$2(t3);
      return [new Ft$5(e28, s3.left - r3.left, s3.top - r3.top, null, s3.bottom - s3.top)];
    } else
      return Yr$2(t3, e28, i);
  }
}
function Xs$2(n3) {
  let t3 = n3.scrollDOM.getBoundingClientRect();
  return { left: (n3.textDirection == L$r.LTR ? t3.left : t3.right - n3.scrollDOM.clientWidth * n3.scaleX) - n3.scrollDOM.scrollLeft * n3.scaleX, top: t3.top - n3.scrollDOM.scrollTop * n3.scaleY };
}
function Ni$2(n3, t3, e28) {
  let i = g$K.cursor(t3);
  return {
    from: Math.max(e28.from, n3.moveToLineBoundary(i, false, true).from),
    to: Math.min(e28.to, n3.moveToLineBoundary(i, true, true).from),
    type: N$w.Text
  };
}
function Yr$2(n3, t3, e28) {
  if (e28.to <= n3.viewport.from || e28.from >= n3.viewport.to)
    return [];
  let i = Math.max(e28.from, n3.viewport.from), s3 = Math.min(e28.to, n3.viewport.to), r3 = n3.textDirection == L$r.LTR, o3 = n3.contentDOM, l3 = o3.getBoundingClientRect(), h3 = Xs$2(n3), c3 = o3.querySelector(".cm-line"), a3 = c3 && window.getComputedStyle(c3), f3 = l3.left + (a3 ? parseInt(a3.paddingLeft) + Math.min(0, parseInt(a3.textIndent)) : 0), d3 = l3.right - (a3 ? parseInt(a3.paddingRight) : 0), u3 = He$5(n3, i), g3 = He$5(n3, s3), m3 = u3.type == N$w.Text ? u3 : null, p3 = g3.type == N$w.Text ? g3 : null;
  if (m3 && (n3.lineWrapping || u3.widgetLineBreaks) && (m3 = Ni$2(n3, i, m3)), p3 && (n3.lineWrapping || g3.widgetLineBreaks) && (p3 = Ni$2(n3, s3, p3)), m3 && p3 && m3.from == p3.from)
    return v3(x3(e28.from, e28.to, m3));
  {
    let S3 = m3 ? x3(e28.from, null, m3) : y3(u3, false), C3 = p3 ? x3(null, e28.to, p3) : y3(g3, true), R3 = [];
    return (m3 || u3).to < (p3 || g3).from - (m3 && p3 ? 1 : 0) || u3.widgetLineBreaks > 1 && S3.bottom + n3.defaultLineHeight / 2 < C3.top ? R3.push(b3(f3, S3.bottom, d3, C3.top)) : S3.bottom < C3.top && n3.elementAtHeight((S3.bottom + C3.top) / 2).type == N$w.Text && (S3.bottom = C3.top = (S3.bottom + C3.top) / 2), v3(S3).concat(R3).concat(v3(C3));
  }
  function b3(S3, C3, R3, E3) {
    return new Ft$5(t3, S3 - h3.left, C3 - h3.top - 0.01, R3 - S3, E3 - C3 + 0.01);
  }
  function v3({ top: S3, bottom: C3, horizontal: R3 }) {
    let E3 = [];
    for (let tt2 = 0; tt2 < R3.length; tt2 += 2)
      E3.push(b3(R3[tt2], S3, R3[tt2 + 1], C3));
    return E3;
  }
  function x3(S3, C3, R3) {
    let E3 = 1e9, tt2 = -1e9, zt2 = [];
    function Qe2(ht2, et2, dt2, at2, vt2) {
      let $3 = n3.coordsAtPos(ht2, ht2 == R3.to ? -2 : 2), U3 = n3.coordsAtPos(dt2, dt2 == R3.from ? 2 : -2);
      !$3 || !U3 || (E3 = Math.min($3.top, U3.top, E3), tt2 = Math.max($3.bottom, U3.bottom, tt2), vt2 == L$r.LTR ? zt2.push(r3 && et2 ? f3 : $3.left, r3 && at2 ? d3 : U3.right) : zt2.push(!r3 && at2 ? f3 : U3.left, !r3 && et2 ? d3 : $3.right));
    }
    let It2 = S3 != null ? S3 : R3.from, Kt2 = C3 != null ? C3 : R3.to;
    for (let ht2 of n3.visibleRanges)
      if (ht2.to > It2 && ht2.from < Kt2)
        for (let et2 = Math.max(ht2.from, It2), dt2 = Math.min(ht2.to, Kt2); ; ) {
          let at2 = n3.state.doc.lineAt(et2);
          for (let vt2 of n3.bidiSpans(at2)) {
            let $3 = vt2.from + at2.from, U3 = vt2.to + at2.from;
            if ($3 >= dt2)
              break;
            U3 > et2 && Qe2(Math.max($3, et2), S3 == null && $3 <= It2, Math.min(U3, dt2), C3 == null && U3 >= Kt2, vt2.dir);
          }
          if (et2 = at2.to + 1, et2 >= dt2)
            break;
        }
    return zt2.length == 0 && Qe2(It2, S3 == null, Kt2, C3 == null, n3.textDirection), { top: E3, bottom: tt2, horizontal: zt2 };
  }
  function y3(S3, C3) {
    let R3 = l3.top + (C3 ? S3.top : S3.bottom);
    return { top: R3, bottom: R3, horizontal: [] };
  }
}
function Gr$1(n3, t3) {
  return n3.constructor == t3.constructor && n3.eq(t3);
}
class _r$1 {
  constructor(t3, e28) {
    this.view = t3, this.layer = e28, this.drawn = [], this.scaleX = 1, this.scaleY = 1, this.measureReq = { read: this.measure.bind(this), write: this.draw.bind(this) }, this.dom = t3.scrollDOM.appendChild(document.createElement("div")), this.dom.classList.add("cm-layer"), e28.above && this.dom.classList.add("cm-layer-above"), e28.class && this.dom.classList.add(e28.class), this.scale(), this.dom.setAttribute("aria-hidden", "true"), this.setOrder(t3.state), t3.requestMeasure(this.measureReq), e28.mount && e28.mount(this.dom, t3);
  }
  update(t3) {
    t3.startState.facet(ee$b) != t3.state.facet(ee$b) && this.setOrder(t3.state), (this.layer.update(t3, this.dom) || t3.geometryChanged) && (this.scale(), t3.view.requestMeasure(this.measureReq));
  }
  setOrder(t3) {
    let e28 = 0, i = t3.facet(ee$b);
    for (; e28 < i.length && i[e28] != this.layer; )
      e28++;
    this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - e28);
  }
  measure() {
    return this.layer.markers(this.view);
  }
  scale() {
    let { scaleX: t3, scaleY: e28 } = this.view;
    (t3 != this.scaleX || e28 != this.scaleY) && (this.scaleX = t3, this.scaleY = e28, this.dom.style.transform = `scale(${1 / t3}, ${1 / e28})`);
  }
  draw(t3) {
    if (t3.length != this.drawn.length || t3.some((e28, i) => !Gr$1(e28, this.drawn[i]))) {
      let e28 = this.dom.firstChild, i = 0;
      for (let s3 of t3)
        s3.update && e28 && s3.constructor && this.drawn[i].constructor && s3.update(e28, this.drawn[i]) ? (e28 = e28.nextSibling, i++) : this.dom.insertBefore(s3.draw(), e28);
      for (; e28; ) {
        let s3 = e28.nextSibling;
        e28.remove(), e28 = s3;
      }
      this.drawn = t3;
    }
  }
  destroy() {
    this.layer.destroy && this.layer.destroy(this.dom, this.view), this.dom.remove();
  }
}
const ee$b = /* @__PURE__ */ A$o.define();
function $s$2(n3) {
  return [
    z$i.define((t3) => new _r$1(t3, n3)),
    ee$b.of(n3)
  ];
}
const Us$2 = !w$o.ios, Pt$4 = /* @__PURE__ */ A$o.define({
  combine(n3) {
    return ht$7(n3, {
      cursorBlinkRate: 1200,
      drawRangeCursor: true
    }, {
      cursorBlinkRate: (t3, e28) => Math.min(t3, e28),
      drawRangeCursor: (t3, e28) => t3 || e28
    });
  }
});
function No$3(n3 = {}) {
  return [
    Pt$4.of(n3),
    Xr$2,
    $r$1,
    Ur$1,
    ys$2.of(true)
  ];
}
function Js$2(n3) {
  return n3.startState.facet(Pt$4) != n3.state.facet(Pt$4);
}
const Xr$2 = /* @__PURE__ */ $s$2({
  above: true,
  markers(n3) {
    let { state: t3 } = n3, e28 = t3.facet(Pt$4), i = [];
    for (let s3 of t3.selection.ranges) {
      let r3 = s3 == t3.selection.main;
      if (s3.empty ? !r3 || Us$2 : e28.drawRangeCursor) {
        let o3 = r3 ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary", l3 = s3.empty ? s3 : g$K.cursor(s3.head, s3.head > s3.anchor ? -1 : 1);
        for (let h3 of Ft$5.forRange(n3, o3, l3))
          i.push(h3);
      }
    }
    return i;
  },
  update(n3, t3) {
    n3.transactions.some((i) => i.selection) && (t3.style.animationName = t3.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink");
    let e28 = Js$2(n3);
    return e28 && Vi$2(n3.state, t3), n3.docChanged || n3.selectionSet || e28;
  },
  mount(n3, t3) {
    Vi$2(t3.state, n3);
  },
  class: "cm-cursorLayer"
});
function Vi$2(n3, t3) {
  t3.style.animationDuration = n3.facet(Pt$4).cursorBlinkRate + "ms";
}
const $r$1 = /* @__PURE__ */ $s$2({
  above: false,
  markers(n3) {
    return n3.state.selection.ranges.map((t3) => t3.empty ? [] : Ft$5.forRange(n3, "cm-selectionBackground", t3)).reduce((t3, e28) => t3.concat(e28));
  },
  update(n3, t3) {
    return n3.docChanged || n3.selectionSet || n3.viewportChanged || Js$2(n3);
  },
  class: "cm-selectionLayer"
}), Zs$2 = {
  ".cm-line": {
    "& ::selection": { backgroundColor: "transparent !important" },
    "&::selection": { backgroundColor: "transparent !important" }
  }
};
Us$2 && (Zs$2[".cm-line"].caretColor = "transparent !important");
const Ur$1 = /* @__PURE__ */ lt$8.highest(/* @__PURE__ */ A$m.theme(Zs$2)), Qs$2 = /* @__PURE__ */ S$m.define({
  map(n3, t3) {
    return n3 == null ? null : t3.mapPos(n3);
  }
}), At$6 = /* @__PURE__ */ L$s.define({
  create() {
    return null;
  },
  update(n3, t3) {
    return n3 != null && (n3 = t3.changes.mapPos(n3)), t3.effects.reduce((e28, i) => i.is(Qs$2) ? i.value : e28, n3);
  }
}), Jr$2 = /* @__PURE__ */ z$i.fromClass(class {
  constructor(n3) {
    this.view = n3, this.cursor = null, this.measureReq = { read: this.readPos.bind(this), write: this.drawCursor.bind(this) };
  }
  update(n3) {
    var t3;
    let e28 = n3.state.field(At$6);
    e28 == null ? this.cursor != null && ((t3 = this.cursor) === null || t3 === void 0 || t3.remove(), this.cursor = null) : (this.cursor || (this.cursor = this.view.scrollDOM.appendChild(document.createElement("div")), this.cursor.className = "cm-dropCursor"), (n3.startState.field(At$6) != e28 || n3.docChanged || n3.geometryChanged) && this.view.requestMeasure(this.measureReq));
  }
  readPos() {
    let { view: n3 } = this, t3 = n3.state.field(At$6), e28 = t3 != null && n3.coordsAtPos(t3);
    if (!e28)
      return null;
    let i = n3.scrollDOM.getBoundingClientRect();
    return {
      left: e28.left - i.left + n3.scrollDOM.scrollLeft * n3.scaleX,
      top: e28.top - i.top + n3.scrollDOM.scrollTop * n3.scaleY,
      height: e28.bottom - e28.top
    };
  }
  drawCursor(n3) {
    if (this.cursor) {
      let { scaleX: t3, scaleY: e28 } = this.view;
      n3 ? (this.cursor.style.left = n3.left / t3 + "px", this.cursor.style.top = n3.top / e28 + "px", this.cursor.style.height = n3.height / e28 + "px") : this.cursor.style.left = "-100000px";
    }
  }
  destroy() {
    this.cursor && this.cursor.remove();
  }
  setDropPos(n3) {
    this.view.state.field(At$6) != n3 && this.view.dispatch({ effects: Qs$2.of(n3) });
  }
}, {
  eventObservers: {
    dragover(n3) {
      this.setDropPos(this.view.posAtCoords({ x: n3.clientX, y: n3.clientY }));
    },
    dragleave(n3) {
      (n3.target == this.view.contentDOM || !this.view.contentDOM.contains(n3.relatedTarget)) && this.setDropPos(null);
    },
    dragend() {
      this.setDropPos(null);
    },
    drop() {
      this.setDropPos(null);
    }
  }
});
function Vo$2() {
  return [At$6, Jr$2];
}
function Wi$2(n3, t3, e28, i, s3) {
  t3.lastIndex = 0;
  for (let r3 = n3.iterRange(e28, i), o3 = e28, l3; !r3.next().done; o3 += r3.value.length)
    if (!r3.lineBreak)
      for (; l3 = t3.exec(r3.value); )
        s3(o3 + l3.index, l3);
}
function Zr$2(n3, t3) {
  let e28 = n3.visibleRanges;
  if (e28.length == 1 && e28[0].from == n3.viewport.from && e28[0].to == n3.viewport.to)
    return e28;
  let i = [];
  for (let { from: s3, to: r3 } of e28)
    s3 = Math.max(n3.state.doc.lineAt(s3).from, s3 - t3), r3 = Math.min(n3.state.doc.lineAt(r3).to, r3 + t3), i.length && i[i.length - 1].to >= s3 ? i[i.length - 1].to = r3 : i.push({ from: s3, to: r3 });
  return i;
}
class Qr$2 {
  constructor(t3) {
    const { regexp: e28, decoration: i, decorate: s3, boundary: r3, maxLength: o3 = 1e3 } = t3;
    if (!e28.global)
      throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
    if (this.regexp = e28, s3)
      this.addMatch = (l3, h3, c3, a3) => s3(a3, c3, c3 + l3[0].length, l3, h3);
    else if (typeof i == "function")
      this.addMatch = (l3, h3, c3, a3) => {
        let f3 = i(l3, h3, c3);
        f3 && a3(c3, c3 + l3[0].length, f3);
      };
    else if (i)
      this.addMatch = (l3, h3, c3, a3) => a3(c3, c3 + l3[0].length, i);
    else
      throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
    this.boundary = r3, this.maxLength = o3;
  }
  createDeco(t3) {
    let e28 = new _$n(), i = e28.add.bind(e28);
    for (let { from: s3, to: r3 } of Zr$2(t3, this.maxLength))
      Wi$2(t3.state.doc, this.regexp, s3, r3, (o3, l3) => this.addMatch(l3, t3, o3, i));
    return e28.finish();
  }
  updateDeco(t3, e28) {
    let i = 1e9, s3 = -1;
    return t3.docChanged && t3.changes.iterChanges((r3, o3, l3, h3) => {
      h3 > t3.view.viewport.from && l3 < t3.view.viewport.to && (i = Math.min(l3, i), s3 = Math.max(h3, s3));
    }), t3.viewportChanged || s3 - i > 1e3 ? this.createDeco(t3.view) : s3 > -1 ? this.updateRange(t3.view, e28.map(t3.changes), i, s3) : e28;
  }
  updateRange(t3, e28, i, s3) {
    for (let r3 of t3.visibleRanges) {
      let o3 = Math.max(r3.from, i), l3 = Math.min(r3.to, s3);
      if (l3 > o3) {
        let h3 = t3.state.doc.lineAt(o3), c3 = h3.to < l3 ? t3.state.doc.lineAt(l3) : h3, a3 = Math.max(r3.from, h3.from), f3 = Math.min(r3.to, c3.to);
        if (this.boundary) {
          for (; o3 > h3.from; o3--)
            if (this.boundary.test(h3.text[o3 - 1 - h3.from])) {
              a3 = o3;
              break;
            }
          for (; l3 < c3.to; l3++)
            if (this.boundary.test(c3.text[l3 - c3.from])) {
              f3 = l3;
              break;
            }
        }
        let d3 = [], u3, g3 = (m3, p3, b3) => d3.push(b3.range(m3, p3));
        if (h3 == c3)
          for (this.regexp.lastIndex = a3 - h3.from; (u3 = this.regexp.exec(h3.text)) && u3.index < f3 - h3.from; )
            this.addMatch(u3, t3, u3.index + h3.from, g3);
        else
          Wi$2(t3.state.doc, this.regexp, a3, f3, (m3, p3) => this.addMatch(p3, t3, m3, g3));
        e28 = e28.update({ filterFrom: a3, filterTo: f3, filter: (m3, p3) => m3 < a3 || p3 > f3, add: d3 });
      }
    }
    return e28;
  }
}
const ze$6 = /x/.unicode != null ? "gu" : "g", to$3 = /* @__PURE__ */ new RegExp(`[\0-\b
-\x7F-\x9F\xAD\u061C\u200B\u200E\u200F\u2028\u2029\u202D\u202E\u2066\u2067\u2069\uFEFF\uFFF9-\uFFFC]`, ze$6), eo$2 = {
  0: "null",
  7: "bell",
  8: "backspace",
  10: "newline",
  11: "vertical tab",
  13: "carriage return",
  27: "escape",
  8203: "zero width space",
  8204: "zero width non-joiner",
  8205: "zero width joiner",
  8206: "left-to-right mark",
  8207: "right-to-left mark",
  8232: "line separator",
  8237: "left-to-right override",
  8238: "right-to-left override",
  8294: "left-to-right isolate",
  8295: "right-to-left isolate",
  8297: "pop directional isolate",
  8233: "paragraph separator",
  65279: "zero width no-break space",
  65532: "object replacement"
};
let we$a = null;
function io$2() {
  var n3;
  if (we$a == null && typeof document < "u" && document.body) {
    let t3 = document.body.style;
    we$a = ((n3 = t3.tabSize) !== null && n3 !== void 0 ? n3 : t3.MozTabSize) != null;
  }
  return we$a || false;
}
const ie$b = /* @__PURE__ */ A$o.define({
  combine(n3) {
    let t3 = ht$7(n3, {
      render: null,
      specialChars: to$3,
      addSpecialChars: null
    });
    return (t3.replaceTabs = !io$2()) && (t3.specialChars = new RegExp("	|" + t3.specialChars.source, ze$6)), t3.addSpecialChars && (t3.specialChars = new RegExp(t3.specialChars.source + "|" + t3.addSpecialChars.source, ze$6)), t3;
  }
});
function Wo$1(n3 = {}) {
  return [ie$b.of(n3), so$1()];
}
let Fi$1 = null;
function so$1() {
  return Fi$1 || (Fi$1 = z$i.fromClass(class {
    constructor(n3) {
      this.view = n3, this.decorations = V$j.none, this.decorationCache = /* @__PURE__ */ Object.create(null), this.decorator = this.makeDecorator(n3.state.facet(ie$b)), this.decorations = this.decorator.createDeco(n3);
    }
    makeDecorator(n3) {
      return new Qr$2({
        regexp: n3.specialChars,
        decoration: (t3, e28, i) => {
          let { doc: s3 } = e28.state, r3 = ne$e(t3[0], 0);
          if (r3 == 9) {
            let o3 = s3.lineAt(i), l3 = e28.state.tabSize, h3 = ot$6(o3.text, l3, i - o3.from);
            return V$j.replace({
              widget: new lo$2((l3 - h3 % l3) * this.view.defaultCharacterWidth / this.view.scaleX)
            });
          }
          return this.decorationCache[r3] || (this.decorationCache[r3] = V$j.replace({ widget: new oo$1(n3, r3) }));
        },
        boundary: n3.replaceTabs ? void 0 : /[^]/
      });
    }
    update(n3) {
      let t3 = n3.state.facet(ie$b);
      n3.startState.facet(ie$b) != t3 ? (this.decorator = this.makeDecorator(t3), this.decorations = this.decorator.createDeco(n3.view)) : this.decorations = this.decorator.updateDeco(n3, this.decorations);
    }
  }, {
    decorations: (n3) => n3.decorations
  }));
}
const no$2 = "\u2022";
function ro$2(n3) {
  return n3 >= 32 ? no$2 : n3 == 10 ? "\u2424" : String.fromCharCode(9216 + n3);
}
class oo$1 extends Nt$4 {
  constructor(t3, e28) {
    super(), this.options = t3, this.code = e28;
  }
  eq(t3) {
    return t3.code == this.code;
  }
  toDOM(t3) {
    let e28 = ro$2(this.code), i = t3.state.phrase("Control character") + " " + (eo$2[this.code] || "0x" + this.code.toString(16)), s3 = this.options.render && this.options.render(this.code, i, e28);
    if (s3)
      return s3;
    let r3 = document.createElement("span");
    return r3.textContent = e28, r3.title = i, r3.setAttribute("aria-label", i), r3.className = "cm-specialChar", r3;
  }
  ignoreEvent() {
    return false;
  }
}
class lo$2 extends Nt$4 {
  constructor(t3) {
    super(), this.width = t3;
  }
  eq(t3) {
    return t3.width == this.width;
  }
  toDOM() {
    let t3 = document.createElement("span");
    return t3.textContent = "	", t3.className = "cm-tab", t3.style.width = this.width + "px", t3;
  }
  ignoreEvent() {
    return false;
  }
}
function Fo$2() {
  return ao$2;
}
const ho$1 = /* @__PURE__ */ V$j.line({ class: "cm-activeLine" }), ao$2 = /* @__PURE__ */ z$i.fromClass(class {
  constructor(n3) {
    this.decorations = this.getDeco(n3);
  }
  update(n3) {
    (n3.docChanged || n3.selectionSet) && (this.decorations = this.getDeco(n3.view));
  }
  getDeco(n3) {
    let t3 = -1, e28 = [];
    for (let i of n3.state.selection.ranges) {
      let s3 = n3.lineBlockAt(i.head);
      s3.from > t3 && (e28.push(ho$1.range(s3.from)), t3 = s3.from);
    }
    return V$j.set(e28);
  }
}, {
  decorations: (n3) => n3.decorations
}), Ie$6 = 2e3;
function co$1(n3, t3, e28) {
  let i = Math.min(t3.line, e28.line), s3 = Math.max(t3.line, e28.line), r3 = [];
  if (t3.off > Ie$6 || e28.off > Ie$6 || t3.col < 0 || e28.col < 0) {
    let o3 = Math.min(t3.off, e28.off), l3 = Math.max(t3.off, e28.off);
    for (let h3 = i; h3 <= s3; h3++) {
      let c3 = n3.doc.line(h3);
      c3.length <= l3 && r3.push(g$K.range(c3.from + o3, c3.to + l3));
    }
  } else {
    let o3 = Math.min(t3.col, e28.col), l3 = Math.max(t3.col, e28.col);
    for (let h3 = i; h3 <= s3; h3++) {
      let c3 = n3.doc.line(h3), a3 = at$5(c3.text, o3, n3.tabSize, true);
      if (a3 < 0)
        r3.push(g$K.cursor(c3.to));
      else {
        let f3 = at$5(c3.text, l3, n3.tabSize);
        r3.push(g$K.range(c3.from + a3, c3.from + f3));
      }
    }
  }
  return r3;
}
function fo$1(n3, t3) {
  let e28 = n3.coordsAtPos(n3.viewport.from);
  return e28 ? Math.round(Math.abs((e28.left - t3) / n3.defaultCharacterWidth)) : -1;
}
function zi$2(n3, t3) {
  let e28 = n3.posAtCoords({ x: t3.clientX, y: t3.clientY }, false), i = n3.state.doc.lineAt(e28), s3 = e28 - i.from, r3 = s3 > Ie$6 ? -1 : s3 == i.length ? fo$1(n3, t3.clientX) : ot$6(i.text, n3.state.tabSize, e28 - i.from);
  return { line: i.number, col: r3, off: s3 };
}
function uo$1(n3, t3) {
  let e28 = zi$2(n3, t3), i = n3.state.selection;
  return e28 ? {
    update(s3) {
      if (s3.docChanged) {
        let r3 = s3.changes.mapPos(s3.startState.doc.line(e28.line).from), o3 = s3.state.doc.lineAt(r3);
        e28 = { line: o3.number, col: e28.col, off: Math.min(e28.off, o3.length) }, i = i.map(s3.changes);
      }
    },
    get(s3, r3, o3) {
      let l3 = zi$2(n3, s3);
      if (!l3)
        return i;
      let h3 = co$1(n3.state, e28, l3);
      return h3.length ? o3 ? g$K.create(h3.concat(i.ranges)) : g$K.create(h3) : i;
    }
  } : null;
}
function zo$1(n3) {
  let t3 = (n3 == null ? void 0 : n3.eventFilter) || ((e28) => e28.altKey && e28.button == 0);
  return A$m.mouseSelectionStyle.of((e28, i) => t3(i) ? uo$1(e28, i) : null);
}
const go$1 = {
  Alt: [18, (n3) => !!n3.altKey],
  Control: [17, (n3) => !!n3.ctrlKey],
  Shift: [16, (n3) => !!n3.shiftKey],
  Meta: [91, (n3) => !!n3.metaKey]
}, po$1 = { style: "cursor: crosshair" };
function Io$2(n3 = {}) {
  let [t3, e28] = go$1[n3.key || "Alt"], i = z$i.fromClass(class {
    constructor(s3) {
      this.view = s3, this.isDown = false;
    }
    set(s3) {
      this.isDown != s3 && (this.isDown = s3, this.view.update([]));
    }
  }, {
    eventObservers: {
      keydown(s3) {
        this.set(s3.keyCode == t3 || e28(s3));
      },
      keyup(s3) {
        (s3.keyCode == t3 || !e28(s3)) && this.set(false);
      },
      mousemove(s3) {
        this.set(e28(s3));
      }
    }
  });
  return [
    i,
    A$m.contentAttributes.of((s3) => {
      var r3;
      return !((r3 = s3.plugin(i)) === null || r3 === void 0) && r3.isDown ? po$1 : null;
    })
  ];
}
const St$6 = "-10000px";
class tn$1 {
  constructor(t3, e28, i) {
    this.facet = e28, this.createTooltipView = i, this.input = t3.state.facet(e28), this.tooltips = this.input.filter((s3) => s3), this.tooltipViews = this.tooltips.map(i);
  }
  update(t3, e28) {
    var i;
    let s3 = t3.state.facet(this.facet), r3 = s3.filter((h3) => h3);
    if (s3 === this.input) {
      for (let h3 of this.tooltipViews)
        h3.update && h3.update(t3);
      return false;
    }
    let o3 = [], l3 = e28 ? [] : null;
    for (let h3 = 0; h3 < r3.length; h3++) {
      let c3 = r3[h3], a3 = -1;
      if (c3) {
        for (let f3 = 0; f3 < this.tooltips.length; f3++) {
          let d3 = this.tooltips[f3];
          d3 && d3.create == c3.create && (a3 = f3);
        }
        if (a3 < 0)
          o3[h3] = this.createTooltipView(c3), l3 && (l3[h3] = !!c3.above);
        else {
          let f3 = o3[h3] = this.tooltipViews[a3];
          l3 && (l3[h3] = e28[a3]), f3.update && f3.update(t3);
        }
      }
    }
    for (let h3 of this.tooltipViews)
      o3.indexOf(h3) < 0 && (h3.dom.remove(), (i = h3.destroy) === null || i === void 0 || i.call(h3));
    return e28 && (l3.forEach((h3, c3) => e28[c3] = h3), e28.length = l3.length), this.input = s3, this.tooltips = r3, this.tooltipViews = o3, true;
  }
}
function mo$1(n3) {
  let { win: t3 } = n3;
  return { top: 0, left: 0, bottom: t3.innerHeight, right: t3.innerWidth };
}
const ye$a = /* @__PURE__ */ A$o.define({
  combine: (n3) => {
    var t3, e28, i;
    return {
      position: w$o.ios ? "absolute" : ((t3 = n3.find((s3) => s3.position)) === null || t3 === void 0 ? void 0 : t3.position) || "fixed",
      parent: ((e28 = n3.find((s3) => s3.parent)) === null || e28 === void 0 ? void 0 : e28.parent) || null,
      tooltipSpace: ((i = n3.find((s3) => s3.tooltipSpace)) === null || i === void 0 ? void 0 : i.tooltipSpace) || mo$1
    };
  }
}), Ii$1 = /* @__PURE__ */ new WeakMap(), en$2 = /* @__PURE__ */ z$i.fromClass(class {
  constructor(n3) {
    this.view = n3, this.above = [], this.inView = true, this.madeAbsolute = false, this.lastTransaction = 0, this.measureTimeout = -1;
    let t3 = n3.state.facet(ye$a);
    this.position = t3.position, this.parent = t3.parent, this.classes = n3.themeClasses, this.createContainer(), this.measureReq = { read: this.readMeasure.bind(this), write: this.writeMeasure.bind(this), key: this }, this.manager = new tn$1(n3, sn$3, (e28) => this.createTooltip(e28)), this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((e28) => {
      Date.now() > this.lastTransaction - 50 && e28.length > 0 && e28[e28.length - 1].intersectionRatio < 1 && this.measureSoon();
    }, { threshold: [1] }) : null, this.observeIntersection(), n3.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
  }
  createContainer() {
    this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
  }
  observeIntersection() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      for (let n3 of this.manager.tooltipViews)
        this.intersectionObserver.observe(n3.dom);
    }
  }
  measureSoon() {
    this.measureTimeout < 0 && (this.measureTimeout = setTimeout(() => {
      this.measureTimeout = -1, this.maybeMeasure();
    }, 50));
  }
  update(n3) {
    n3.transactions.length && (this.lastTransaction = Date.now());
    let t3 = this.manager.update(n3, this.above);
    t3 && this.observeIntersection();
    let e28 = t3 || n3.geometryChanged, i = n3.state.facet(ye$a);
    if (i.position != this.position && !this.madeAbsolute) {
      this.position = i.position;
      for (let s3 of this.manager.tooltipViews)
        s3.dom.style.position = this.position;
      e28 = true;
    }
    if (i.parent != this.parent) {
      this.parent && this.container.remove(), this.parent = i.parent, this.createContainer();
      for (let s3 of this.manager.tooltipViews)
        this.container.appendChild(s3.dom);
      e28 = true;
    } else
      this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
    e28 && this.maybeMeasure();
  }
  createTooltip(n3) {
    let t3 = n3.create(this.view);
    if (t3.dom.classList.add("cm-tooltip"), n3.arrow && !t3.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
      let e28 = document.createElement("div");
      e28.className = "cm-tooltip-arrow", t3.dom.appendChild(e28);
    }
    return t3.dom.style.position = this.position, t3.dom.style.top = St$6, t3.dom.style.left = "0px", this.container.appendChild(t3.dom), t3.mount && t3.mount(this.view), t3;
  }
  destroy() {
    var n3, t3;
    this.view.win.removeEventListener("resize", this.measureSoon);
    for (let e28 of this.manager.tooltipViews)
      e28.dom.remove(), (n3 = e28.destroy) === null || n3 === void 0 || n3.call(e28);
    this.parent && this.container.remove(), (t3 = this.intersectionObserver) === null || t3 === void 0 || t3.disconnect(), clearTimeout(this.measureTimeout);
  }
  readMeasure() {
    let n3 = this.view.dom.getBoundingClientRect(), t3 = 1, e28 = 1, i = false;
    if (this.position == "fixed" && this.manager.tooltipViews.length) {
      let { dom: s3 } = this.manager.tooltipViews[0];
      if (w$o.gecko)
        i = s3.offsetParent != this.container.ownerDocument.body;
      else if (this.view.scaleX != 1 || this.view.scaleY != 1)
        i = true;
      else if (s3.style.top == St$6 && s3.style.left == "0px") {
        let r3 = s3.getBoundingClientRect();
        i = Math.abs(r3.top + 1e4) > 1 || Math.abs(r3.left) > 1;
      }
    }
    if (i || this.position == "absolute")
      if (this.parent) {
        let s3 = this.parent.getBoundingClientRect();
        s3.width && s3.height && (t3 = s3.width / this.parent.offsetWidth, e28 = s3.height / this.parent.offsetHeight);
      } else
        ({ scaleX: t3, scaleY: e28 } = this.view.viewState);
    return {
      editor: n3,
      parent: this.parent ? this.container.getBoundingClientRect() : n3,
      pos: this.manager.tooltips.map((s3, r3) => {
        let o3 = this.manager.tooltipViews[r3];
        return o3.getCoords ? o3.getCoords(s3.pos) : this.view.coordsAtPos(s3.pos);
      }),
      size: this.manager.tooltipViews.map(({ dom: s3 }) => s3.getBoundingClientRect()),
      space: this.view.state.facet(ye$a).tooltipSpace(this.view),
      scaleX: t3,
      scaleY: e28,
      makeAbsolute: i
    };
  }
  writeMeasure(n3) {
    var t3;
    if (n3.makeAbsolute) {
      this.madeAbsolute = true, this.position = "absolute";
      for (let l3 of this.manager.tooltipViews)
        l3.dom.style.position = "absolute";
    }
    let { editor: e28, space: i, scaleX: s3, scaleY: r3 } = n3, o3 = [];
    for (let l3 = 0; l3 < this.manager.tooltips.length; l3++) {
      let h3 = this.manager.tooltips[l3], c3 = this.manager.tooltipViews[l3], { dom: a3 } = c3, f3 = n3.pos[l3], d3 = n3.size[l3];
      if (!f3 || f3.bottom <= Math.max(e28.top, i.top) || f3.top >= Math.min(e28.bottom, i.bottom) || f3.right < Math.max(e28.left, i.left) - 0.1 || f3.left > Math.min(e28.right, i.right) + 0.1) {
        a3.style.top = St$6;
        continue;
      }
      let u3 = h3.arrow ? c3.dom.querySelector(".cm-tooltip-arrow") : null, g3 = u3 ? 7 : 0, m3 = d3.right - d3.left, p3 = (t3 = Ii$1.get(c3)) !== null && t3 !== void 0 ? t3 : d3.bottom - d3.top, b3 = c3.offset || wo$2, v3 = this.view.textDirection == L$r.LTR, x3 = d3.width > i.right - i.left ? v3 ? i.left : i.right - d3.width : v3 ? Math.min(f3.left - (u3 ? 14 : 0) + b3.x, i.right - m3) : Math.max(i.left, f3.left - m3 + (u3 ? 14 : 0) - b3.x), y3 = this.above[l3];
      !h3.strictSide && (y3 ? f3.top - (d3.bottom - d3.top) - b3.y < i.top : f3.bottom + (d3.bottom - d3.top) + b3.y > i.bottom) && y3 == i.bottom - f3.bottom > f3.top - i.top && (y3 = this.above[l3] = !y3);
      let S3 = (y3 ? f3.top - i.top : i.bottom - f3.bottom) - g3;
      if (S3 < p3 && c3.resize !== false) {
        if (S3 < this.view.defaultLineHeight) {
          a3.style.top = St$6;
          continue;
        }
        Ii$1.set(c3, p3), a3.style.height = (p3 = S3) / r3 + "px";
      } else
        a3.style.height && (a3.style.height = "");
      let C3 = y3 ? f3.top - p3 - g3 - b3.y : f3.bottom + g3 + b3.y, R3 = x3 + m3;
      if (c3.overlap !== true)
        for (let E3 of o3)
          E3.left < R3 && E3.right > x3 && E3.top < C3 + p3 && E3.bottom > C3 && (C3 = y3 ? E3.top - p3 - 2 - g3 : E3.bottom + g3 + 2);
      if (this.position == "absolute" ? (a3.style.top = (C3 - n3.parent.top) / r3 + "px", a3.style.left = (x3 - n3.parent.left) / s3 + "px") : (a3.style.top = C3 / r3 + "px", a3.style.left = x3 / s3 + "px"), u3) {
        let E3 = f3.left + (v3 ? b3.x : -b3.x) - (x3 + 14 - 7);
        u3.style.left = E3 / s3 + "px";
      }
      c3.overlap !== true && o3.push({ left: x3, top: C3, right: R3, bottom: C3 + p3 }), a3.classList.toggle("cm-tooltip-above", y3), a3.classList.toggle("cm-tooltip-below", !y3), c3.positioned && c3.positioned(n3.space);
    }
  }
  maybeMeasure() {
    if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView)))
      for (let n3 of this.manager.tooltipViews)
        n3.dom.style.top = St$6;
  }
}, {
  eventObservers: {
    scroll() {
      this.maybeMeasure();
    }
  }
}), bo$3 = /* @__PURE__ */ A$m.baseTheme({
  ".cm-tooltip": {
    zIndex: 100,
    boxSizing: "border-box"
  },
  "&light .cm-tooltip": {
    border: "1px solid #bbb",
    backgroundColor: "#f5f5f5"
  },
  "&light .cm-tooltip-section:not(:first-child)": {
    borderTop: "1px solid #bbb"
  },
  "&dark .cm-tooltip": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tooltip-arrow": {
    height: "7px",
    width: `${7 * 2}px`,
    position: "absolute",
    zIndex: -1,
    overflow: "hidden",
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      width: 0,
      height: 0,
      borderLeft: "7px solid transparent",
      borderRight: "7px solid transparent"
    },
    ".cm-tooltip-above &": {
      bottom: "-7px",
      "&:before": {
        borderTop: "7px solid #bbb"
      },
      "&:after": {
        borderTop: "7px solid #f5f5f5",
        bottom: "1px"
      }
    },
    ".cm-tooltip-below &": {
      top: "-7px",
      "&:before": {
        borderBottom: "7px solid #bbb"
      },
      "&:after": {
        borderBottom: "7px solid #f5f5f5",
        top: "1px"
      }
    }
  },
  "&dark .cm-tooltip .cm-tooltip-arrow": {
    "&:before": {
      borderTopColor: "#333338",
      borderBottomColor: "#333338"
    },
    "&:after": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    }
  }
}), wo$2 = { x: 0, y: 0 }, sn$3 = /* @__PURE__ */ A$o.define({
  enables: [en$2, bo$3]
}), ae$c = /* @__PURE__ */ A$o.define();
class Ze$4 {
  static create(t3) {
    return new Ze$4(t3);
  }
  constructor(t3) {
    this.view = t3, this.mounted = false, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new tn$1(t3, ae$c, (e28) => this.createHostedView(e28));
  }
  createHostedView(t3) {
    let e28 = t3.create(this.view);
    return e28.dom.classList.add("cm-tooltip-section"), this.dom.appendChild(e28.dom), this.mounted && e28.mount && e28.mount(this.view), e28;
  }
  mount(t3) {
    for (let e28 of this.manager.tooltipViews)
      e28.mount && e28.mount(t3);
    this.mounted = true;
  }
  positioned(t3) {
    for (let e28 of this.manager.tooltipViews)
      e28.positioned && e28.positioned(t3);
  }
  update(t3) {
    this.manager.update(t3);
  }
  destroy() {
    var t3;
    for (let e28 of this.manager.tooltipViews)
      (t3 = e28.destroy) === null || t3 === void 0 || t3.call(e28);
  }
  passProp(t3) {
    let e28;
    for (let i of this.manager.tooltipViews) {
      let s3 = i[t3];
      if (s3 !== void 0) {
        if (e28 === void 0)
          e28 = s3;
        else if (e28 !== s3)
          return;
      }
    }
    return e28;
  }
  get offset() {
    return this.passProp("offset");
  }
  get getCoords() {
    return this.passProp("getCoords");
  }
  get overlap() {
    return this.passProp("overlap");
  }
  get resize() {
    return this.passProp("resize");
  }
}
const yo$1 = /* @__PURE__ */ sn$3.compute([ae$c], (n3) => {
  let t3 = n3.facet(ae$c).filter((e28) => e28);
  return t3.length === 0 ? null : {
    pos: Math.min(...t3.map((e28) => e28.pos)),
    end: Math.max(...t3.filter((e28) => e28.end != null).map((e28) => e28.end)),
    create: Ze$4.create,
    above: t3[0].above,
    arrow: t3.some((e28) => e28.arrow)
  };
});
class vo$3 {
  constructor(t3, e28, i, s3, r3) {
    this.view = t3, this.source = e28, this.field = i, this.setHover = s3, this.hoverTime = r3, this.hoverTimeout = -1, this.restartTimeout = -1, this.pending = null, this.lastMove = { x: 0, y: 0, target: t3.dom, time: 0 }, this.checkHover = this.checkHover.bind(this), t3.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), t3.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
  }
  update() {
    this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(() => this.startHover(), 20));
  }
  get active() {
    return this.view.state.field(this.field);
  }
  checkHover() {
    if (this.hoverTimeout = -1, this.active)
      return;
    let t3 = Date.now() - this.lastMove.time;
    t3 < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - t3) : this.startHover();
  }
  startHover() {
    clearTimeout(this.restartTimeout);
    let { view: t3, lastMove: e28 } = this, i = t3.docView.nearest(e28.target);
    if (!i)
      return;
    let s3, r3 = 1;
    if (i instanceof st$6)
      s3 = i.posAtStart;
    else {
      if (s3 = t3.posAtCoords(e28), s3 == null)
        return;
      let l3 = t3.coordsAtPos(s3);
      if (!l3 || e28.y < l3.top || e28.y > l3.bottom || e28.x < l3.left - t3.defaultCharacterWidth || e28.x > l3.right + t3.defaultCharacterWidth)
        return;
      let h3 = t3.bidiSpans(t3.state.doc.lineAt(s3)).find((a3) => a3.from <= s3 && a3.to >= s3), c3 = h3 && h3.dir == L$r.RTL ? -1 : 1;
      r3 = e28.x < l3.left ? -c3 : c3;
    }
    let o3 = this.source(t3, s3, r3);
    if (o3 != null && o3.then) {
      let l3 = this.pending = { pos: s3 };
      o3.then((h3) => {
        this.pending == l3 && (this.pending = null, h3 && t3.dispatch({ effects: this.setHover.of(h3) }));
      }, (h3) => ct$6(t3.state, h3, "hover tooltip"));
    } else
      o3 && t3.dispatch({ effects: this.setHover.of(o3) });
  }
  mousemove(t3) {
    var e28;
    this.lastMove = { x: t3.clientX, y: t3.clientY, target: t3.target, time: Date.now() }, this.hoverTimeout < 0 && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
    let i = this.active;
    if (i && !Ki$1(this.lastMove.target) || this.pending) {
      let { pos: s3 } = i || this.pending, r3 = (e28 = i == null ? void 0 : i.end) !== null && e28 !== void 0 ? e28 : s3;
      (s3 == r3 ? this.view.posAtCoords(this.lastMove) != s3 : !So$3(this.view, s3, r3, t3.clientX, t3.clientY)) && (this.view.dispatch({ effects: this.setHover.of(null) }), this.pending = null);
    }
  }
  mouseleave(t3) {
    clearTimeout(this.hoverTimeout), this.hoverTimeout = -1, this.active && !Ki$1(t3.relatedTarget) && this.view.dispatch({ effects: this.setHover.of(null) });
  }
  destroy() {
    clearTimeout(this.hoverTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
  }
}
function Ki$1(n3) {
  for (let t3 = n3; t3; t3 = t3.parentNode)
    if (t3.nodeType == 1 && t3.classList.contains("cm-tooltip"))
      return true;
  return false;
}
function So$3(n3, t3, e28, i, s3, r3) {
  let o3 = n3.scrollDOM.getBoundingClientRect(), l3 = n3.documentTop + n3.documentPadding.top + n3.contentHeight;
  if (o3.left > i || o3.right < i || o3.top > s3 || Math.min(o3.bottom, l3) < s3)
    return false;
  let h3 = n3.posAtCoords({ x: i, y: s3 }, false);
  return h3 >= t3 && h3 <= e28;
}
function Ko$1(n3, t3 = {}) {
  let e28 = S$m.define(), i = L$s.define({
    create() {
      return null;
    },
    update(s3, r3) {
      if (s3 && (t3.hideOnChange && (r3.docChanged || r3.selection) || t3.hideOn && t3.hideOn(r3, s3)))
        return null;
      if (s3 && r3.docChanged) {
        let o3 = r3.changes.mapPos(s3.pos, -1, C$I.TrackDel);
        if (o3 == null)
          return null;
        let l3 = Object.assign(/* @__PURE__ */ Object.create(null), s3);
        l3.pos = o3, s3.end != null && (l3.end = r3.changes.mapPos(s3.end)), s3 = l3;
      }
      for (let o3 of r3.effects)
        o3.is(e28) && (s3 = o3.value), o3.is(xo$2) && (s3 = null);
      return s3;
    },
    provide: (s3) => ae$c.from(s3)
  });
  return [
    i,
    z$i.define((s3) => new vo$3(s3, n3, i, e28, t3.hoverTime || 300)),
    yo$1
  ];
}
function qo$2(n3, t3) {
  let e28 = n3.plugin(en$2);
  if (!e28)
    return null;
  let i = e28.manager.tooltips.indexOf(t3);
  return i < 0 ? null : e28.manager.tooltipViews[i];
}
const xo$2 = /* @__PURE__ */ S$m.define(), qi$3 = /* @__PURE__ */ A$o.define({
  combine(n3) {
    let t3, e28;
    for (let i of n3)
      t3 = t3 || i.topContainer, e28 = e28 || i.bottomContainer;
    return { topContainer: t3, bottomContainer: e28 };
  }
});
function jo$2(n3, t3) {
  let e28 = n3.plugin(nn$2), i = e28 ? e28.specs.indexOf(t3) : -1;
  return i > -1 ? e28.panels[i] : null;
}
const nn$2 = /* @__PURE__ */ z$i.fromClass(class {
  constructor(n3) {
    this.input = n3.state.facet(Yi$1), this.specs = this.input.filter((e28) => e28), this.panels = this.specs.map((e28) => e28(n3));
    let t3 = n3.state.facet(qi$3);
    this.top = new Jt$3(n3, true, t3.topContainer), this.bottom = new Jt$3(n3, false, t3.bottomContainer), this.top.sync(this.panels.filter((e28) => e28.top)), this.bottom.sync(this.panels.filter((e28) => !e28.top));
    for (let e28 of this.panels)
      e28.dom.classList.add("cm-panel"), e28.mount && e28.mount();
  }
  update(n3) {
    let t3 = n3.state.facet(qi$3);
    this.top.container != t3.topContainer && (this.top.sync([]), this.top = new Jt$3(n3.view, true, t3.topContainer)), this.bottom.container != t3.bottomContainer && (this.bottom.sync([]), this.bottom = new Jt$3(n3.view, false, t3.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses();
    let e28 = n3.state.facet(Yi$1);
    if (e28 != this.input) {
      let i = e28.filter((h3) => h3), s3 = [], r3 = [], o3 = [], l3 = [];
      for (let h3 of i) {
        let c3 = this.specs.indexOf(h3), a3;
        c3 < 0 ? (a3 = h3(n3.view), l3.push(a3)) : (a3 = this.panels[c3], a3.update && a3.update(n3)), s3.push(a3), (a3.top ? r3 : o3).push(a3);
      }
      this.specs = i, this.panels = s3, this.top.sync(r3), this.bottom.sync(o3);
      for (let h3 of l3)
        h3.dom.classList.add("cm-panel"), h3.mount && h3.mount();
    } else
      for (let i of this.panels)
        i.update && i.update(n3);
  }
  destroy() {
    this.top.sync([]), this.bottom.sync([]);
  }
}, {
  provide: (n3) => A$m.scrollMargins.of((t3) => {
    let e28 = t3.plugin(n3);
    return e28 && { top: e28.top.scrollMargin(), bottom: e28.bottom.scrollMargin() };
  })
});
class Jt$3 {
  constructor(t3, e28, i) {
    this.view = t3, this.top = e28, this.container = i, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
  }
  sync(t3) {
    for (let e28 of this.panels)
      e28.destroy && t3.indexOf(e28) < 0 && e28.destroy();
    this.panels = t3, this.syncDOM();
  }
  syncDOM() {
    if (this.panels.length == 0) {
      this.dom && (this.dom.remove(), this.dom = void 0);
      return;
    }
    if (!this.dom) {
      this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
      let e28 = this.container || this.view.dom;
      e28.insertBefore(this.dom, this.top ? e28.firstChild : null);
    }
    let t3 = this.dom.firstChild;
    for (let e28 of this.panels)
      if (e28.dom.parentNode == this.dom) {
        for (; t3 != e28.dom; )
          t3 = ji$2(t3);
        t3 = t3.nextSibling;
      } else
        this.dom.insertBefore(e28.dom, t3);
    for (; t3; )
      t3 = ji$2(t3);
  }
  scrollMargin() {
    return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
  }
  syncClasses() {
    if (!(!this.container || this.classes == this.view.themeClasses)) {
      for (let t3 of this.classes.split(" "))
        t3 && this.container.classList.remove(t3);
      for (let t3 of (this.classes = this.view.themeClasses).split(" "))
        t3 && this.container.classList.add(t3);
    }
  }
}
function ji$2(n3) {
  let t3 = n3.nextSibling;
  return n3.remove(), t3;
}
const Yi$1 = /* @__PURE__ */ A$o.define({
  enables: nn$2
});
class lt$7 extends Y$h {
  compare(t3) {
    return this == t3 || this.constructor == t3.constructor && this.eq(t3);
  }
  eq(t3) {
    return false;
  }
  destroy(t3) {
  }
}
lt$7.prototype.elementClass = "";
lt$7.prototype.toDOM = void 0;
lt$7.prototype.mapMode = C$I.TrackBefore;
lt$7.prototype.startSide = lt$7.prototype.endSide = -1;
lt$7.prototype.point = true;
const se$b = /* @__PURE__ */ A$o.define(), Co$2 = {
  class: "",
  renderEmptyElements: false,
  elementStyle: "",
  markers: () => P$F.empty,
  lineMarker: () => null,
  widgetMarker: () => null,
  lineMarkerChange: null,
  initialSpacer: null,
  updateSpacer: null,
  domEventHandlers: {}
}, Tt$5 = /* @__PURE__ */ A$o.define();
function Yo$1(n3) {
  return [rn$2(), Tt$5.of(Object.assign(Object.assign({}, Co$2), n3))];
}
const Ke$5 = /* @__PURE__ */ A$o.define({
  combine: (n3) => n3.some((t3) => t3)
});
function rn$2(n3) {
  let t3 = [
    Mo$2
  ];
  return n3 && n3.fixed === false && t3.push(Ke$5.of(true)), t3;
}
const Mo$2 = /* @__PURE__ */ z$i.fromClass(class {
  constructor(n3) {
    this.view = n3, this.prevViewport = n3.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.gutters = n3.state.facet(Tt$5).map((t3) => new _i$1(n3, t3));
    for (let t3 of this.gutters)
      this.dom.appendChild(t3.dom);
    this.fixed = !n3.state.facet(Ke$5), this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(false), n3.scrollDOM.insertBefore(this.dom, n3.contentDOM);
  }
  update(n3) {
    if (this.updateGutters(n3)) {
      let t3 = this.prevViewport, e28 = n3.view.viewport, i = Math.min(t3.to, e28.to) - Math.max(t3.from, e28.from);
      this.syncGutters(i < (e28.to - e28.from) * 0.8);
    }
    n3.geometryChanged && (this.dom.style.minHeight = this.view.contentHeight + "px"), this.view.state.facet(Ke$5) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : ""), this.prevViewport = n3.view.viewport;
  }
  syncGutters(n3) {
    let t3 = this.dom.nextSibling;
    n3 && this.dom.remove();
    let e28 = P$F.iter(this.view.state.facet(se$b), this.view.viewport.from), i = [], s3 = this.gutters.map((r3) => new ko$2(r3, this.view.viewport, -this.view.documentPadding.top));
    for (let r3 of this.view.viewportLineBlocks)
      if (i.length && (i = []), Array.isArray(r3.type)) {
        let o3 = true;
        for (let l3 of r3.type)
          if (l3.type == N$w.Text && o3) {
            qe$5(e28, i, l3.from);
            for (let h3 of s3)
              h3.line(this.view, l3, i);
            o3 = false;
          } else if (l3.widget)
            for (let h3 of s3)
              h3.widget(this.view, l3);
      } else if (r3.type == N$w.Text) {
        qe$5(e28, i, r3.from);
        for (let o3 of s3)
          o3.line(this.view, r3, i);
      } else if (r3.widget)
        for (let o3 of s3)
          o3.widget(this.view, r3);
    for (let r3 of s3)
      r3.finish();
    n3 && this.view.scrollDOM.insertBefore(this.dom, t3);
  }
  updateGutters(n3) {
    let t3 = n3.startState.facet(Tt$5), e28 = n3.state.facet(Tt$5), i = n3.docChanged || n3.heightChanged || n3.viewportChanged || !P$F.eq(n3.startState.facet(se$b), n3.state.facet(se$b), n3.view.viewport.from, n3.view.viewport.to);
    if (t3 == e28)
      for (let s3 of this.gutters)
        s3.update(n3) && (i = true);
    else {
      i = true;
      let s3 = [];
      for (let r3 of e28) {
        let o3 = t3.indexOf(r3);
        o3 < 0 ? s3.push(new _i$1(this.view, r3)) : (this.gutters[o3].update(n3), s3.push(this.gutters[o3]));
      }
      for (let r3 of this.gutters)
        r3.dom.remove(), s3.indexOf(r3) < 0 && r3.destroy();
      for (let r3 of s3)
        this.dom.appendChild(r3.dom);
      this.gutters = s3;
    }
    return i;
  }
  destroy() {
    for (let n3 of this.gutters)
      n3.destroy();
    this.dom.remove();
  }
}, {
  provide: (n3) => A$m.scrollMargins.of((t3) => {
    let e28 = t3.plugin(n3);
    return !e28 || e28.gutters.length == 0 || !e28.fixed ? null : t3.textDirection == L$r.LTR ? { left: e28.dom.offsetWidth * t3.scaleX } : { right: e28.dom.offsetWidth * t3.scaleX };
  })
});
function Gi$2(n3) {
  return Array.isArray(n3) ? n3 : [n3];
}
function qe$5(n3, t3, e28) {
  for (; n3.value && n3.from <= e28; )
    n3.from == e28 && t3.push(n3.value), n3.next();
}
class ko$2 {
  constructor(t3, e28, i) {
    this.gutter = t3, this.height = i, this.i = 0, this.cursor = P$F.iter(t3.markers, e28.from);
  }
  addElement(t3, e28, i) {
    let { gutter: s3 } = this, r3 = (e28.top - this.height) / t3.scaleY, o3 = e28.height / t3.scaleY;
    if (this.i == s3.elements.length) {
      let l3 = new on$2(t3, o3, r3, i);
      s3.elements.push(l3), s3.dom.appendChild(l3.dom);
    } else
      s3.elements[this.i].update(t3, o3, r3, i);
    this.height = e28.bottom, this.i++;
  }
  line(t3, e28, i) {
    let s3 = [];
    qe$5(this.cursor, s3, e28.from), i.length && (s3 = s3.concat(i));
    let r3 = this.gutter.config.lineMarker(t3, e28, s3);
    r3 && s3.unshift(r3);
    let o3 = this.gutter;
    s3.length == 0 && !o3.config.renderEmptyElements || this.addElement(t3, e28, s3);
  }
  widget(t3, e28) {
    let i = this.gutter.config.widgetMarker(t3, e28.widget, e28);
    i && this.addElement(t3, e28, [i]);
  }
  finish() {
    let t3 = this.gutter;
    for (; t3.elements.length > this.i; ) {
      let e28 = t3.elements.pop();
      t3.dom.removeChild(e28.dom), e28.destroy();
    }
  }
}
class _i$1 {
  constructor(t3, e28) {
    this.view = t3, this.config = e28, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    for (let i in e28.domEventHandlers)
      this.dom.addEventListener(i, (s3) => {
        let r3 = s3.target, o3;
        if (r3 != this.dom && this.dom.contains(r3)) {
          for (; r3.parentNode != this.dom; )
            r3 = r3.parentNode;
          let h3 = r3.getBoundingClientRect();
          o3 = (h3.top + h3.bottom) / 2;
        } else
          o3 = s3.clientY;
        let l3 = t3.lineBlockAtHeight(o3 - t3.documentTop);
        e28.domEventHandlers[i](t3, l3, s3) && s3.preventDefault();
      });
    this.markers = Gi$2(e28.markers(t3)), e28.initialSpacer && (this.spacer = new on$2(t3, 0, 0, [e28.initialSpacer(t3)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
  }
  update(t3) {
    let e28 = this.markers;
    if (this.markers = Gi$2(this.config.markers(t3.view)), this.spacer && this.config.updateSpacer) {
      let s3 = this.config.updateSpacer(this.spacer.markers[0], t3);
      s3 != this.spacer.markers[0] && this.spacer.update(t3.view, 0, 0, [s3]);
    }
    let i = t3.view.viewport;
    return !P$F.eq(this.markers, e28, i.from, i.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(t3) : false);
  }
  destroy() {
    for (let t3 of this.elements)
      t3.destroy();
  }
}
class on$2 {
  constructor(t3, e28, i, s3) {
    this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(t3, e28, i, s3);
  }
  update(t3, e28, i, s3) {
    this.height != e28 && (this.height = e28, this.dom.style.height = e28 + "px"), this.above != i && (this.dom.style.marginTop = (this.above = i) ? i + "px" : ""), Ao$2(this.markers, s3) || this.setMarkers(t3, s3);
  }
  setMarkers(t3, e28) {
    let i = "cm-gutterElement", s3 = this.dom.firstChild;
    for (let r3 = 0, o3 = 0; ; ) {
      let l3 = o3, h3 = r3 < e28.length ? e28[r3++] : null, c3 = false;
      if (h3) {
        let a3 = h3.elementClass;
        a3 && (i += " " + a3);
        for (let f3 = o3; f3 < this.markers.length; f3++)
          if (this.markers[f3].compare(h3)) {
            l3 = f3, c3 = true;
            break;
          }
      } else
        l3 = this.markers.length;
      for (; o3 < l3; ) {
        let a3 = this.markers[o3++];
        if (a3.toDOM) {
          a3.destroy(s3);
          let f3 = s3.nextSibling;
          s3.remove(), s3 = f3;
        }
      }
      if (!h3)
        break;
      h3.toDOM && (c3 ? s3 = s3.nextSibling : this.dom.insertBefore(h3.toDOM(t3), s3)), c3 && o3++;
    }
    this.dom.className = i, this.markers = e28;
  }
  destroy() {
    this.setMarkers(null, []);
  }
}
function Ao$2(n3, t3) {
  if (n3.length != t3.length)
    return false;
  for (let e28 = 0; e28 < n3.length; e28++)
    if (!n3[e28].compare(t3[e28]))
      return false;
  return true;
}
const Do$2 = /* @__PURE__ */ A$o.define(), pt$7 = /* @__PURE__ */ A$o.define({
  combine(n3) {
    return ht$7(n3, { formatNumber: String, domEventHandlers: {} }, {
      domEventHandlers(t3, e28) {
        let i = Object.assign({}, t3);
        for (let s3 in e28) {
          let r3 = i[s3], o3 = e28[s3];
          i[s3] = r3 ? (l3, h3, c3) => r3(l3, h3, c3) || o3(l3, h3, c3) : o3;
        }
        return i;
      }
    });
  }
});
class ve$8 extends lt$7 {
  constructor(t3) {
    super(), this.number = t3;
  }
  eq(t3) {
    return this.number == t3.number;
  }
  toDOM() {
    return document.createTextNode(this.number);
  }
}
function Se$7(n3, t3) {
  return n3.state.facet(pt$7).formatNumber(t3, n3.state);
}
const Oo$2 = /* @__PURE__ */ Tt$5.compute([pt$7], (n3) => ({
  class: "cm-lineNumbers",
  renderEmptyElements: false,
  markers(t3) {
    return t3.state.facet(Do$2);
  },
  lineMarker(t3, e28, i) {
    return i.some((s3) => s3.toDOM) ? null : new ve$8(Se$7(t3, t3.state.doc.lineAt(e28.from).number));
  },
  widgetMarker: () => null,
  lineMarkerChange: (t3) => t3.startState.facet(pt$7) != t3.state.facet(pt$7),
  initialSpacer(t3) {
    return new ve$8(Se$7(t3, Xi$1(t3.state.doc.lines)));
  },
  updateSpacer(t3, e28) {
    let i = Se$7(e28.view, Xi$1(e28.view.state.doc.lines));
    return i == t3.number ? t3 : new ve$8(i);
  },
  domEventHandlers: n3.facet(pt$7).domEventHandlers
}));
function Go$1(n3 = {}) {
  return [
    pt$7.of(n3),
    rn$2(),
    Oo$2
  ];
}
function Xi$1(n3) {
  let t3 = 9;
  for (; t3 < n3; )
    t3 = t3 * 10 + 9;
  return t3;
}
const To$2 = /* @__PURE__ */ new class extends lt$7 {
  constructor() {
    super(...arguments), this.elementClass = "cm-activeLineGutter";
  }
}(), Ro$3 = /* @__PURE__ */ se$b.compute(["selection"], (n3) => {
  let t3 = [], e28 = -1;
  for (let i of n3.selection.ranges) {
    let s3 = n3.doc.lineAt(i.head).from;
    s3 > e28 && (e28 = s3, t3.push(To$2.range(s3)));
  }
  return P$F.of(t3);
});
function _o$2() {
  return Ro$3;
}
const ze$5 = 1024;
let xe$9 = 0;
class z$h {
  constructor(e28, t3) {
    this.from = e28, this.to = t3;
  }
}
class C$G {
  constructor(e28 = {}) {
    this.id = xe$9++, this.perNode = !!e28.perNode, this.deserialize = e28.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
  }
  add(e28) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof e28 != "function" && (e28 = T$v.match(e28)), (t3) => {
      let r3 = e28(t3);
      return r3 === void 0 ? null : [this, r3];
    };
  }
}
C$G.closedBy = new C$G({ deserialize: (l3) => l3.split(" ") });
C$G.openedBy = new C$G({ deserialize: (l3) => l3.split(" ") });
C$G.group = new C$G({ deserialize: (l3) => l3.split(" ") });
C$G.contextHash = new C$G({ perNode: true });
C$G.lookAhead = new C$G({ perNode: true });
C$G.mounted = new C$G({ perNode: true });
class G$j {
  constructor(e28, t3, r3) {
    this.tree = e28, this.overlay = t3, this.parser = r3;
  }
  static get(e28) {
    return e28 && e28.props && e28.props[C$G.mounted.id];
  }
}
const be$9 = /* @__PURE__ */ Object.create(null);
class T$v {
  constructor(e28, t3, r3, i = 0) {
    this.name = e28, this.props = t3, this.id = r3, this.flags = i;
  }
  static define(e28) {
    let t3 = e28.props && e28.props.length ? /* @__PURE__ */ Object.create(null) : be$9, r3 = (e28.top ? 1 : 0) | (e28.skipped ? 2 : 0) | (e28.error ? 4 : 0) | (e28.name == null ? 8 : 0), i = new T$v(e28.name || "", t3, e28.id, r3);
    if (e28.props) {
      for (let n3 of e28.props)
        if (Array.isArray(n3) || (n3 = n3(i)), n3) {
          if (n3[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          t3[n3[0].id] = n3[1];
        }
    }
    return i;
  }
  prop(e28) {
    return this.props[e28.id];
  }
  get isTop() {
    return (this.flags & 1) > 0;
  }
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  get isError() {
    return (this.flags & 4) > 0;
  }
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  is(e28) {
    if (typeof e28 == "string") {
      if (this.name == e28)
        return true;
      let t3 = this.prop(C$G.group);
      return t3 ? t3.indexOf(e28) > -1 : false;
    }
    return this.id == e28;
  }
  static match(e28) {
    let t3 = /* @__PURE__ */ Object.create(null);
    for (let r3 in e28)
      for (let i of r3.split(" "))
        t3[i] = e28[r3];
    return (r3) => {
      for (let i = r3.prop(C$G.group), n3 = -1; n3 < (i ? i.length : 0); n3++) {
        let s3 = t3[n3 < 0 ? r3.name : i[n3]];
        if (s3)
          return s3;
      }
    };
  }
}
T$v.none = new T$v("", /* @__PURE__ */ Object.create(null), 0, 8);
class de$b {
  constructor(e28) {
    this.types = e28;
    for (let t3 = 0; t3 < e28.length; t3++)
      if (e28[t3].id != t3)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  extend(...e28) {
    let t3 = [];
    for (let r3 of this.types) {
      let i = null;
      for (let n3 of e28) {
        let s3 = n3(r3);
        s3 && (i || (i = Object.assign({}, r3.props)), i[s3[0].id] = s3[1]);
      }
      t3.push(i ? new T$v(r3.name, i, r3.id, r3.flags) : r3);
    }
    return new de$b(t3);
  }
}
const Q$g = /* @__PURE__ */ new WeakMap(), le$8 = /* @__PURE__ */ new WeakMap();
var k$v;
(function(l3) {
  l3[l3.ExcludeBuffers = 1] = "ExcludeBuffers", l3[l3.IncludeAnonymous = 2] = "IncludeAnonymous", l3[l3.IgnoreMounts = 4] = "IgnoreMounts", l3[l3.IgnoreOverlays = 8] = "IgnoreOverlays";
})(k$v || (k$v = {}));
class B$q {
  constructor(e28, t3, r3, i, n3) {
    if (this.type = e28, this.children = t3, this.positions = r3, this.length = i, this.props = null, n3 && n3.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [s3, h3] of n3)
        this.props[typeof s3 == "number" ? s3 : s3.id] = h3;
    }
  }
  toString() {
    let e28 = G$j.get(this);
    if (e28 && !e28.overlay)
      return e28.tree.toString();
    let t3 = "";
    for (let r3 of this.children) {
      let i = r3.toString();
      i && (t3 && (t3 += ","), t3 += i);
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (t3.length ? "(" + t3 + ")" : "") : t3;
  }
  cursor(e28 = 0) {
    return new Y$f(this.topNode, e28);
  }
  cursorAt(e28, t3 = 0, r3 = 0) {
    let i = Q$g.get(this) || this.topNode, n3 = new Y$f(i);
    return n3.moveTo(e28, t3), Q$g.set(this, n3._tree), n3;
  }
  get topNode() {
    return new P$D(this, 0, 0, null);
  }
  resolve(e28, t3 = 0) {
    let r3 = $$e(Q$g.get(this) || this.topNode, e28, t3, false);
    return Q$g.set(this, r3), r3;
  }
  resolveInner(e28, t3 = 0) {
    let r3 = $$e(le$8.get(this) || this.topNode, e28, t3, true);
    return le$8.set(this, r3), r3;
  }
  resolveStack(e28, t3 = 0) {
    return ke$8(this, e28, t3);
  }
  iterate(e28) {
    let { enter: t3, leave: r3, from: i = 0, to: n3 = this.length } = e28, s3 = e28.mode || 0, h3 = (s3 & k$v.IncludeAnonymous) > 0;
    for (let f3 = this.cursor(s3 | k$v.IncludeAnonymous); ; ) {
      let u3 = false;
      if (f3.from <= n3 && f3.to >= i && (!h3 && f3.type.isAnonymous || t3(f3) !== false)) {
        if (f3.firstChild())
          continue;
        u3 = true;
      }
      for (; u3 && r3 && (h3 || !f3.type.isAnonymous) && r3(f3), !f3.nextSibling(); ) {
        if (!f3.parent())
          return;
        u3 = true;
      }
    }
  }
  prop(e28) {
    return e28.perNode ? this.props ? this.props[e28.id] : void 0 : this.type.prop(e28);
  }
  get propValues() {
    let e28 = [];
    if (this.props)
      for (let t3 in this.props)
        e28.push([+t3, this.props[t3]]);
    return e28;
  }
  balance(e28 = {}) {
    return this.children.length <= 8 ? this : ie$a(T$v.none, this.children, this.positions, 0, this.children.length, 0, this.length, (t3, r3, i) => new B$q(this.type, t3, r3, i, this.propValues), e28.makeTree || ((t3, r3, i) => new B$q(T$v.none, t3, r3, i)));
  }
  static build(e28) {
    return Ce$7(e28);
  }
}
B$q.empty = new B$q(T$v.none, [], [], 0);
class te$b {
  constructor(e28, t3) {
    this.buffer = e28, this.index = t3;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new te$b(this.buffer, this.index);
  }
}
class U$m {
  constructor(e28, t3, r3) {
    this.buffer = e28, this.length = t3, this.set = r3;
  }
  get type() {
    return T$v.none;
  }
  toString() {
    let e28 = [];
    for (let t3 = 0; t3 < this.buffer.length; )
      e28.push(this.childString(t3)), t3 = this.buffer[t3 + 3];
    return e28.join(",");
  }
  childString(e28) {
    let t3 = this.buffer[e28], r3 = this.buffer[e28 + 3], i = this.set.types[t3], n3 = i.name;
    if (/\W/.test(n3) && !i.isError && (n3 = JSON.stringify(n3)), e28 += 4, r3 == e28)
      return n3;
    let s3 = [];
    for (; e28 < r3; )
      s3.push(this.childString(e28)), e28 = this.buffer[e28 + 3];
    return n3 + "(" + s3.join(",") + ")";
  }
  findChild(e28, t3, r3, i, n3) {
    let { buffer: s3 } = this, h3 = -1;
    for (let f3 = e28; f3 != t3 && !(ge$9(n3, i, s3[f3 + 1], s3[f3 + 2]) && (h3 = f3, r3 > 0)); f3 = s3[f3 + 3])
      ;
    return h3;
  }
  slice(e28, t3, r3) {
    let i = this.buffer, n3 = new Uint16Array(t3 - e28), s3 = 0;
    for (let h3 = e28, f3 = 0; h3 < t3; ) {
      n3[f3++] = i[h3++], n3[f3++] = i[h3++] - r3;
      let u3 = n3[f3++] = i[h3++] - r3;
      n3[f3++] = i[h3++] - e28, s3 = Math.max(s3, u3);
    }
    return new U$m(n3, s3, this.set);
  }
}
function ge$9(l3, e28, t3, r3) {
  switch (l3) {
    case -2:
      return t3 < e28;
    case -1:
      return r3 >= e28 && t3 < e28;
    case 0:
      return t3 < e28 && r3 > e28;
    case 1:
      return t3 <= e28 && r3 > e28;
    case 2:
      return r3 > e28;
    case 4:
      return true;
  }
}
function $$e(l3, e28, t3, r3) {
  for (var i; l3.from == l3.to || (t3 < 1 ? l3.from >= e28 : l3.from > e28) || (t3 > -1 ? l3.to <= e28 : l3.to < e28); ) {
    let s3 = !r3 && l3 instanceof P$D && l3.index < 0 ? null : l3.parent;
    if (!s3)
      return l3;
    l3 = s3;
  }
  let n3 = r3 ? 0 : k$v.IgnoreOverlays;
  if (r3)
    for (let s3 = l3, h3 = s3.parent; h3; s3 = h3, h3 = s3.parent)
      s3 instanceof P$D && s3.index < 0 && ((i = h3.enter(e28, t3, n3)) === null || i === void 0 ? void 0 : i.from) != s3.from && (l3 = h3);
  for (; ; ) {
    let s3 = l3.enter(e28, t3, n3);
    if (!s3)
      return l3;
    l3 = s3;
  }
}
class me$b {
  cursor(e28 = 0) {
    return new Y$f(this, e28);
  }
  getChild(e28, t3 = null, r3 = null) {
    let i = he$b(this, e28, t3, r3);
    return i.length ? i[0] : null;
  }
  getChildren(e28, t3 = null, r3 = null) {
    return he$b(this, e28, t3, r3);
  }
  resolve(e28, t3 = 0) {
    return $$e(this, e28, t3, false);
  }
  resolveInner(e28, t3 = 0) {
    return $$e(this, e28, t3, true);
  }
  matchContext(e28) {
    return Z$g(this, e28);
  }
  enterUnfinishedNodesBefore(e28) {
    let t3 = this.childBefore(e28), r3 = this;
    for (; t3; ) {
      let i = t3.lastChild;
      if (!i || i.to != t3.to)
        break;
      i.type.isError && i.from == i.to ? (r3 = t3, t3 = i.prevSibling) : t3 = i;
    }
    return r3;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
class P$D extends me$b {
  constructor(e28, t3, r3, i) {
    super(), this._tree = e28, this.from = t3, this.index = r3, this._parent = i;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(e28, t3, r3, i, n3 = 0) {
    for (let s3 = this; ; ) {
      for (let { children: h3, positions: f3 } = s3._tree, u3 = t3 > 0 ? h3.length : -1; e28 != u3; e28 += t3) {
        let o3 = h3[e28], c3 = f3[e28] + s3.from;
        if (ge$9(i, r3, c3, c3 + o3.length)) {
          if (o3 instanceof U$m) {
            if (n3 & k$v.ExcludeBuffers)
              continue;
            let a3 = o3.findChild(0, o3.buffer.length, t3, r3 - c3, i);
            if (a3 > -1)
              return new O$m(new we$9(s3, o3, e28, c3), null, a3);
          } else if (n3 & k$v.IncludeAnonymous || !o3.type.isAnonymous || re$9(o3)) {
            let a3;
            if (!(n3 & k$v.IgnoreMounts) && (a3 = G$j.get(o3)) && !a3.overlay)
              return new P$D(a3.tree, c3, e28, s3);
            let x3 = new P$D(o3, c3, e28, s3);
            return n3 & k$v.IncludeAnonymous || !x3.type.isAnonymous ? x3 : x3.nextChild(t3 < 0 ? o3.children.length - 1 : 0, t3, r3, i);
          }
        }
      }
      if (n3 & k$v.IncludeAnonymous || !s3.type.isAnonymous || (s3.index >= 0 ? e28 = s3.index + t3 : e28 = t3 < 0 ? -1 : s3._parent._tree.children.length, s3 = s3._parent, !s3))
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(0, 1, 0, 4);
  }
  get lastChild() {
    return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
  }
  childAfter(e28) {
    return this.nextChild(0, 1, e28, 2);
  }
  childBefore(e28) {
    return this.nextChild(this._tree.children.length - 1, -1, e28, -2);
  }
  enter(e28, t3, r3 = 0) {
    let i;
    if (!(r3 & k$v.IgnoreOverlays) && (i = G$j.get(this._tree)) && i.overlay) {
      let n3 = e28 - this.from;
      for (let { from: s3, to: h3 } of i.overlay)
        if ((t3 > 0 ? s3 <= n3 : s3 < n3) && (t3 < 0 ? h3 >= n3 : h3 > n3))
          return new P$D(i.tree, i.overlay[0].from + this.from, -1, this);
    }
    return this.nextChild(0, 1, e28, t3, r3);
  }
  nextSignificantParent() {
    let e28 = this;
    for (; e28.type.isAnonymous && e28._parent; )
      e28 = e28._parent;
    return e28;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  toString() {
    return this._tree.toString();
  }
}
function he$b(l3, e28, t3, r3) {
  let i = l3.cursor(), n3 = [];
  if (!i.firstChild())
    return n3;
  if (t3 != null) {
    for (; !i.type.is(t3); )
      if (!i.nextSibling())
        return n3;
  }
  for (; ; ) {
    if (r3 != null && i.type.is(r3))
      return n3;
    if (i.type.is(e28) && n3.push(i.node), !i.nextSibling())
      return r3 == null ? n3 : [];
  }
}
function Z$g(l3, e28, t3 = e28.length - 1) {
  for (let r3 = l3.parent; t3 >= 0; r3 = r3.parent) {
    if (!r3)
      return false;
    if (!r3.type.isAnonymous) {
      if (e28[t3] && e28[t3] != r3.name)
        return false;
      t3--;
    }
  }
  return true;
}
class we$9 {
  constructor(e28, t3, r3, i) {
    this.parent = e28, this.buffer = t3, this.index = r3, this.start = i;
  }
}
class O$m extends me$b {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(e28, t3, r3) {
    super(), this.context = e28, this._parent = t3, this.index = r3, this.type = e28.buffer.set.types[e28.buffer.buffer[r3]];
  }
  child(e28, t3, r3) {
    let { buffer: i } = this.context, n3 = i.findChild(this.index + 4, i.buffer[this.index + 3], e28, t3 - this.context.start, r3);
    return n3 < 0 ? null : new O$m(this.context, this, n3);
  }
  get firstChild() {
    return this.child(1, 0, 4);
  }
  get lastChild() {
    return this.child(-1, 0, 4);
  }
  childAfter(e28) {
    return this.child(1, e28, 2);
  }
  childBefore(e28) {
    return this.child(-1, e28, -2);
  }
  enter(e28, t3, r3 = 0) {
    if (r3 & k$v.ExcludeBuffers)
      return null;
    let { buffer: i } = this.context, n3 = i.findChild(this.index + 4, i.buffer[this.index + 3], t3 > 0 ? 1 : -1, e28 - this.context.start, t3);
    return n3 < 0 ? null : new O$m(this.context, this, n3);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(e28) {
    return this._parent ? null : this.context.parent.nextChild(this.context.index + e28, e28, 0, 4);
  }
  get nextSibling() {
    let { buffer: e28 } = this.context, t3 = e28.buffer[this.index + 3];
    return t3 < (this._parent ? e28.buffer[this._parent.index + 3] : e28.buffer.length) ? new O$m(this.context, this._parent, t3) : this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer: e28 } = this.context, t3 = this._parent ? this._parent.index + 4 : 0;
    return this.index == t3 ? this.externalSibling(-1) : new O$m(this.context, this._parent, e28.findChild(t3, this.index, -1, 0, 4));
  }
  get tree() {
    return null;
  }
  toTree() {
    let e28 = [], t3 = [], { buffer: r3 } = this.context, i = this.index + 4, n3 = r3.buffer[this.index + 3];
    if (n3 > i) {
      let s3 = r3.buffer[this.index + 1];
      e28.push(r3.slice(i, n3, s3)), t3.push(0);
    }
    return new B$q(this.type, e28, t3, this.to - this.from);
  }
  toString() {
    return this.context.buffer.childString(this.index);
  }
}
function ye$9(l3) {
  if (!l3.length)
    return null;
  if (l3.length == 1)
    return l3[0];
  let e28 = 0, t3 = l3[0];
  for (let n3 = 1; n3 < l3.length; n3++) {
    let s3 = l3[n3];
    (s3.from > t3.from || s3.to < t3.to) && (t3 = s3, e28 = n3);
  }
  let r3 = t3 instanceof P$D && t3.index < 0 ? null : t3.parent, i = l3.slice();
  return r3 ? i[e28] = r3 : i.splice(e28, 1), new ve$7(i, t3);
}
class ve$7 {
  constructor(e28, t3) {
    this.heads = e28, this.node = t3;
  }
  get next() {
    return ye$9(this.heads);
  }
}
function ke$8(l3, e28, t3) {
  let r3 = l3.resolveInner(e28, t3), i = null;
  for (let n3 = r3 instanceof P$D ? r3 : r3.context.parent; n3; n3 = n3.parent)
    if (n3.index < 0) {
      let s3 = n3.parent;
      (i || (i = [r3])).push(s3.resolve(e28, t3)), n3 = s3;
    } else {
      let s3 = G$j.get(n3.tree);
      if (s3 && s3.overlay && s3.overlay[0].from <= e28 && s3.overlay[s3.overlay.length - 1].to >= e28) {
        let h3 = new P$D(s3.tree, s3.overlay[0].from + n3.from, 0, null);
        (i || (i = [r3])).push($$e(h3, e28, t3, false));
      }
    }
  return i ? ye$9(i) : r3;
}
class Y$f {
  get name() {
    return this.type.name;
  }
  constructor(e28, t3 = 0) {
    if (this.mode = t3, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, e28 instanceof P$D)
      this.yieldNode(e28);
    else {
      this._tree = e28.context.parent, this.buffer = e28.context;
      for (let r3 = e28._parent; r3; r3 = r3._parent)
        this.stack.unshift(r3.index);
      this.bufferNode = e28, this.yieldBuf(e28.index);
    }
  }
  yieldNode(e28) {
    return e28 ? (this._tree = e28, this.type = e28.type, this.from = e28.from, this.to = e28.to, true) : false;
  }
  yieldBuf(e28, t3) {
    this.index = e28;
    let { start: r3, buffer: i } = this.buffer;
    return this.type = t3 || i.set.types[i.buffer[e28]], this.from = r3 + i.buffer[e28 + 1], this.to = r3 + i.buffer[e28 + 2], true;
  }
  yield(e28) {
    return e28 ? e28 instanceof P$D ? (this.buffer = null, this.yieldNode(e28)) : (this.buffer = e28.context, this.yieldBuf(e28.index, e28.type)) : false;
  }
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  enterChild(e28, t3, r3) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(e28 < 0 ? this._tree._tree.children.length - 1 : 0, e28, t3, r3, this.mode));
    let { buffer: i } = this.buffer, n3 = i.findChild(this.index + 4, i.buffer[this.index + 3], e28, t3 - this.buffer.start, r3);
    return n3 < 0 ? false : (this.stack.push(this.index), this.yieldBuf(n3));
  }
  firstChild() {
    return this.enterChild(1, 0, 4);
  }
  lastChild() {
    return this.enterChild(-1, 0, 4);
  }
  childAfter(e28) {
    return this.enterChild(1, e28, 2);
  }
  childBefore(e28) {
    return this.enterChild(-1, e28, -2);
  }
  enter(e28, t3, r3 = this.mode) {
    return this.buffer ? r3 & k$v.ExcludeBuffers ? false : this.enterChild(1, e28, t3) : this.yield(this._tree.enter(e28, t3, r3));
  }
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & k$v.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let e28 = this.mode & k$v.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(e28);
  }
  sibling(e28) {
    if (!this.buffer)
      return this._tree._parent ? this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e28, e28, 0, 4, this.mode)) : false;
    let { buffer: t3 } = this.buffer, r3 = this.stack.length - 1;
    if (e28 < 0) {
      let i = r3 < 0 ? 0 : this.stack[r3] + 4;
      if (this.index != i)
        return this.yieldBuf(t3.findChild(i, this.index, -1, 0, 4));
    } else {
      let i = t3.buffer[this.index + 3];
      if (i < (r3 < 0 ? t3.buffer.length : t3.buffer[this.stack[r3] + 3]))
        return this.yieldBuf(i);
    }
    return r3 < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + e28, e28, 0, 4, this.mode)) : false;
  }
  nextSibling() {
    return this.sibling(1);
  }
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(e28) {
    let t3, r3, { buffer: i } = this;
    if (i) {
      if (e28 > 0) {
        if (this.index < i.buffer.buffer.length)
          return false;
      } else
        for (let n3 = 0; n3 < this.index; n3++)
          if (i.buffer.buffer[n3 + 3] < this.index)
            return false;
      ({ index: t3, parent: r3 } = i);
    } else
      ({ index: t3, _parent: r3 } = this._tree);
    for (; r3; { index: t3, _parent: r3 } = r3)
      if (t3 > -1)
        for (let n3 = t3 + e28, s3 = e28 < 0 ? -1 : r3._tree.children.length; n3 != s3; n3 += e28) {
          let h3 = r3._tree.children[n3];
          if (this.mode & k$v.IncludeAnonymous || h3 instanceof U$m || !h3.type.isAnonymous || re$9(h3))
            return false;
        }
    return true;
  }
  move(e28, t3) {
    if (t3 && this.enterChild(e28, 0, 4))
      return true;
    for (; ; ) {
      if (this.sibling(e28))
        return true;
      if (this.atLastNode(e28) || !this.parent())
        return false;
    }
  }
  next(e28 = true) {
    return this.move(1, e28);
  }
  prev(e28 = true) {
    return this.move(-1, e28);
  }
  moveTo(e28, t3 = 0) {
    for (; (this.from == this.to || (t3 < 1 ? this.from >= e28 : this.from > e28) || (t3 > -1 ? this.to <= e28 : this.to < e28)) && this.parent(); )
      ;
    for (; this.enterChild(1, e28, t3); )
      ;
    return this;
  }
  get node() {
    if (!this.buffer)
      return this._tree;
    let e28 = this.bufferNode, t3 = null, r3 = 0;
    if (e28 && e28.context == this.buffer)
      e:
        for (let i = this.index, n3 = this.stack.length; n3 >= 0; ) {
          for (let s3 = e28; s3; s3 = s3._parent)
            if (s3.index == i) {
              if (i == this.index)
                return s3;
              t3 = s3, r3 = n3 + 1;
              break e;
            }
          i = this.stack[--n3];
        }
    for (let i = r3; i < this.stack.length; i++)
      t3 = new O$m(this.buffer, t3, this.stack[i]);
    return this.bufferNode = new O$m(this.buffer, t3, this.index);
  }
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  iterate(e28, t3) {
    for (let r3 = 0; ; ) {
      let i = false;
      if (this.type.isAnonymous || e28(this) !== false) {
        if (this.firstChild()) {
          r3++;
          continue;
        }
        this.type.isAnonymous || (i = true);
      }
      for (; i && t3 && t3(this), i = this.type.isAnonymous, !this.nextSibling(); ) {
        if (!r3)
          return;
        this.parent(), r3--, i = true;
      }
    }
  }
  matchContext(e28) {
    if (!this.buffer)
      return Z$g(this.node, e28);
    let { buffer: t3 } = this.buffer, { types: r3 } = t3.set;
    for (let i = e28.length - 1, n3 = this.stack.length - 1; i >= 0; n3--) {
      if (n3 < 0)
        return Z$g(this.node, e28, i);
      let s3 = r3[t3.buffer[this.stack[n3]]];
      if (!s3.isAnonymous) {
        if (e28[i] && e28[i] != s3.name)
          return false;
        i--;
      }
    }
    return true;
  }
}
function re$9(l3) {
  return l3.children.some((e28) => e28 instanceof U$m || !e28.type.isAnonymous || re$9(e28));
}
function Ce$7(l3) {
  var e28;
  let { buffer: t3, nodeSet: r3, maxBufferLength: i = 1024, reused: n3 = [], minRepeatType: s3 = r3.types.length } = l3, h3 = Array.isArray(t3) ? new te$b(t3, t3.length) : t3, f3 = r3.types, u3 = 0, o3 = 0;
  function c3(b3, w3, p3, m3, A3) {
    let { id: y3, start: g3, end: v3, size: N3 } = h3, M3 = o3;
    for (; N3 < 0; )
      if (h3.next(), N3 == -1) {
        let W3 = n3[y3];
        p3.push(W3), m3.push(g3 - b3);
        return;
      } else if (N3 == -3) {
        u3 = y3;
        return;
      } else if (N3 == -4) {
        o3 = y3;
        return;
      } else
        throw new RangeError(`Unrecognized record size: ${N3}`);
    let J3 = f3[y3], L3, D3, ne2 = g3 - b3;
    if (v3 - g3 <= i && (D3 = _3(h3.pos - w3, A3))) {
      let W3 = new Uint16Array(D3.size - D3.skip), E3 = h3.pos - D3.size, R3 = W3.length;
      for (; h3.pos > E3; )
        R3 = F3(D3.start, W3, R3);
      L3 = new U$m(W3, v3 - D3.start, r3), ne2 = D3.start - b3;
    } else {
      let W3 = h3.pos - N3;
      h3.next();
      let E3 = [], R3 = [], H3 = y3 >= s3 ? y3 : -1, V10 = 0, K3 = v3;
      for (; h3.pos > W3; )
        H3 >= 0 && h3.id == H3 && h3.size >= 0 ? (h3.end <= K3 - i && (x3(E3, R3, g3, V10, h3.end, K3, H3, M3), V10 = E3.length, K3 = h3.end), h3.next()) : c3(g3, W3, E3, R3, H3);
      if (H3 >= 0 && V10 > 0 && V10 < E3.length && x3(E3, R3, g3, V10, g3, K3, H3, M3), E3.reverse(), R3.reverse(), H3 > -1 && V10 > 0) {
        let se2 = a3(J3);
        L3 = ie$a(J3, E3, R3, 0, E3.length, 0, v3 - g3, se2, se2);
      } else
        L3 = d3(J3, E3, R3, v3 - g3, M3 - v3);
    }
    p3.push(L3), m3.push(ne2);
  }
  function a3(b3) {
    return (w3, p3, m3) => {
      let A3 = 0, y3 = w3.length - 1, g3, v3;
      if (y3 >= 0 && (g3 = w3[y3]) instanceof B$q) {
        if (!y3 && g3.type == b3 && g3.length == m3)
          return g3;
        (v3 = g3.prop(C$G.lookAhead)) && (A3 = p3[y3] + g3.length + v3);
      }
      return d3(b3, w3, p3, m3, A3);
    };
  }
  function x3(b3, w3, p3, m3, A3, y3, g3, v3) {
    let N3 = [], M3 = [];
    for (; b3.length > m3; )
      N3.push(b3.pop()), M3.push(w3.pop() + p3 - A3);
    b3.push(d3(r3.types[g3], N3, M3, y3 - A3, v3 - y3)), w3.push(A3 - p3);
  }
  function d3(b3, w3, p3, m3, A3 = 0, y3) {
    if (u3) {
      let g3 = [C$G.contextHash, u3];
      y3 = y3 ? [g3].concat(y3) : [g3];
    }
    if (A3 > 25) {
      let g3 = [C$G.lookAhead, A3];
      y3 = y3 ? [g3].concat(y3) : [g3];
    }
    return new B$q(b3, w3, p3, m3, y3);
  }
  function _3(b3, w3) {
    let p3 = h3.fork(), m3 = 0, A3 = 0, y3 = 0, g3 = p3.end - i, v3 = { size: 0, start: 0, skip: 0 };
    e:
      for (let N3 = p3.pos - b3; p3.pos > N3; ) {
        let M3 = p3.size;
        if (p3.id == w3 && M3 >= 0) {
          v3.size = m3, v3.start = A3, v3.skip = y3, y3 += 4, m3 += 4, p3.next();
          continue;
        }
        let J3 = p3.pos - M3;
        if (M3 < 0 || J3 < N3 || p3.start < g3)
          break;
        let L3 = p3.id >= s3 ? 4 : 0, D3 = p3.start;
        for (p3.next(); p3.pos > J3; ) {
          if (p3.size < 0)
            if (p3.size == -3)
              L3 += 4;
            else
              break e;
          else
            p3.id >= s3 && (L3 += 4);
          p3.next();
        }
        A3 = D3, m3 += M3, y3 += L3;
      }
    return (w3 < 0 || m3 == b3) && (v3.size = m3, v3.start = A3, v3.skip = y3), v3.size > 4 ? v3 : void 0;
  }
  function F3(b3, w3, p3) {
    let { id: m3, start: A3, end: y3, size: g3 } = h3;
    if (h3.next(), g3 >= 0 && m3 < s3) {
      let v3 = p3;
      if (g3 > 4) {
        let N3 = h3.pos - (g3 - 4);
        for (; h3.pos > N3; )
          p3 = F3(b3, w3, p3);
      }
      w3[--p3] = v3, w3[--p3] = y3 - b3, w3[--p3] = A3 - b3, w3[--p3] = m3;
    } else
      g3 == -3 ? u3 = m3 : g3 == -4 && (o3 = m3);
    return p3;
  }
  let I3 = [], j3 = [];
  for (; h3.pos > 0; )
    c3(l3.start || 0, l3.bufferStart || 0, I3, j3, -1);
  let S3 = (e28 = l3.length) !== null && e28 !== void 0 ? e28 : I3.length ? j3[0] + I3[0].length : 0;
  return new B$q(f3[l3.topID], I3.reverse(), j3.reverse(), S3);
}
const fe$9 = /* @__PURE__ */ new WeakMap();
function X$f(l3, e28) {
  if (!l3.isAnonymous || e28 instanceof U$m || e28.type != l3)
    return 1;
  let t3 = fe$9.get(e28);
  if (t3 == null) {
    t3 = 1;
    for (let r3 of e28.children) {
      if (r3.type != l3 || !(r3 instanceof B$q)) {
        t3 = 1;
        break;
      }
      t3 += X$f(l3, r3);
    }
    fe$9.set(e28, t3);
  }
  return t3;
}
function ie$a(l3, e28, t3, r3, i, n3, s3, h3, f3) {
  let u3 = 0;
  for (let d3 = r3; d3 < i; d3++)
    u3 += X$f(l3, e28[d3]);
  let o3 = Math.ceil(u3 * 1.5 / 8), c3 = [], a3 = [];
  function x3(d3, _3, F3, I3, j3) {
    for (let S3 = F3; S3 < I3; ) {
      let b3 = S3, w3 = _3[S3], p3 = X$f(l3, d3[S3]);
      for (S3++; S3 < I3; S3++) {
        let m3 = X$f(l3, d3[S3]);
        if (p3 + m3 >= o3)
          break;
        p3 += m3;
      }
      if (S3 == b3 + 1) {
        if (p3 > o3) {
          let m3 = d3[b3];
          x3(m3.children, m3.positions, 0, m3.children.length, _3[b3] + j3);
          continue;
        }
        c3.push(d3[b3]);
      } else {
        let m3 = _3[S3 - 1] + d3[S3 - 1].length - w3;
        c3.push(ie$a(l3, d3, _3, b3, S3, w3, m3, null, f3));
      }
      a3.push(w3 + j3 - n3);
    }
  }
  return x3(e28, t3, r3, i, 0), (h3 || f3)(c3, a3, s3);
}
class Me$4 {
  constructor() {
    this.map = /* @__PURE__ */ new WeakMap();
  }
  setBuffer(e28, t3, r3) {
    let i = this.map.get(e28);
    i || this.map.set(e28, i = /* @__PURE__ */ new Map()), i.set(t3, r3);
  }
  getBuffer(e28, t3) {
    let r3 = this.map.get(e28);
    return r3 && r3.get(t3);
  }
  set(e28, t3) {
    e28 instanceof O$m ? this.setBuffer(e28.context.buffer, e28.index, t3) : e28 instanceof P$D && this.map.set(e28.tree, t3);
  }
  get(e28) {
    return e28 instanceof O$m ? this.getBuffer(e28.context.buffer, e28.index) : e28 instanceof P$D ? this.map.get(e28.tree) : void 0;
  }
  cursorSet(e28, t3) {
    e28.buffer ? this.setBuffer(e28.buffer.buffer, e28.index, t3) : this.map.set(e28.tree, t3);
  }
  cursorGet(e28) {
    return e28.buffer ? this.getBuffer(e28.buffer.buffer, e28.index) : this.map.get(e28.tree);
  }
}
class q$i {
  constructor(e28, t3, r3, i, n3 = false, s3 = false) {
    this.from = e28, this.to = t3, this.tree = r3, this.offset = i, this.open = (n3 ? 1 : 0) | (s3 ? 2 : 0);
  }
  get openStart() {
    return (this.open & 1) > 0;
  }
  get openEnd() {
    return (this.open & 2) > 0;
  }
  static addTree(e28, t3 = [], r3 = false) {
    let i = [new q$i(0, e28.length, e28, 0, false, r3)];
    for (let n3 of t3)
      n3.to > e28.length && i.push(n3);
    return i;
  }
  static applyChanges(e28, t3, r3 = 128) {
    if (!t3.length)
      return e28;
    let i = [], n3 = 1, s3 = e28.length ? e28[0] : null;
    for (let h3 = 0, f3 = 0, u3 = 0; ; h3++) {
      let o3 = h3 < t3.length ? t3[h3] : null, c3 = o3 ? o3.fromA : 1e9;
      if (c3 - f3 >= r3)
        for (; s3 && s3.from < c3; ) {
          let a3 = s3;
          if (f3 >= a3.from || c3 <= a3.to || u3) {
            let x3 = Math.max(a3.from, f3) - u3, d3 = Math.min(a3.to, c3) - u3;
            a3 = x3 >= d3 ? null : new q$i(x3, d3, a3.tree, a3.offset + u3, h3 > 0, !!o3);
          }
          if (a3 && i.push(a3), s3.to > c3)
            break;
          s3 = n3 < e28.length ? e28[n3++] : null;
        }
      if (!o3)
        break;
      f3 = o3.toA, u3 = o3.toA - o3.toB;
    }
    return i;
  }
}
class Ee$5 {
  startParse(e28, t3, r3) {
    return typeof e28 == "string" && (e28 = new Ae$5(e28)), r3 = r3 ? r3.length ? r3.map((i) => new z$h(i.from, i.to)) : [new z$h(0, 0)] : [new z$h(0, e28.length)], this.createParse(e28, t3 || [], r3);
  }
  parse(e28, t3, r3) {
    let i = this.startParse(e28, t3, r3);
    for (; ; ) {
      let n3 = i.advance();
      if (n3)
        return n3;
    }
  }
}
class Ae$5 {
  constructor(e28) {
    this.string = e28;
  }
  get length() {
    return this.string.length;
  }
  chunk(e28) {
    return this.string.slice(e28);
  }
  get lineChunks() {
    return false;
  }
  read(e28, t3) {
    return this.string.slice(e28, t3);
  }
}
function Te$7(l3) {
  return (e28, t3, r3, i) => new _e$8(e28, l3, t3, r3, i);
}
class oe$b {
  constructor(e28, t3, r3, i, n3) {
    if (this.parser = e28, this.parse = t3, this.overlay = r3, this.target = i, this.ranges = n3, !n3.length || n3.some((s3) => s3.from >= s3.to))
      throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(n3));
  }
}
class Se$6 {
  constructor(e28, t3, r3, i, n3, s3, h3) {
    this.parser = e28, this.predicate = t3, this.mounts = r3, this.index = i, this.start = n3, this.target = s3, this.prev = h3, this.depth = 0, this.ranges = [];
  }
}
const ee$a = new C$G({ perNode: true });
class _e$8 {
  constructor(e28, t3, r3, i, n3) {
    this.nest = t3, this.input = r3, this.fragments = i, this.ranges = n3, this.inner = [], this.innerDone = 0, this.baseTree = null, this.stoppedAt = null, this.baseParse = e28;
  }
  advance() {
    if (this.baseParse) {
      let r3 = this.baseParse.advance();
      if (!r3)
        return null;
      if (this.baseParse = null, this.baseTree = r3, this.startInner(), this.stoppedAt != null)
        for (let i of this.inner)
          i.parse.stopAt(this.stoppedAt);
    }
    if (this.innerDone == this.inner.length) {
      let r3 = this.baseTree;
      return this.stoppedAt != null && (r3 = new B$q(r3.type, r3.children, r3.positions, r3.length, r3.propValues.concat([[ee$a, this.stoppedAt]]))), r3;
    }
    let e28 = this.inner[this.innerDone], t3 = e28.parse.advance();
    if (t3) {
      this.innerDone++;
      let r3 = Object.assign(/* @__PURE__ */ Object.create(null), e28.target.props);
      r3[C$G.mounted.id] = new G$j(t3, e28.overlay, e28.parser), e28.target.props = r3;
    }
    return null;
  }
  get parsedPos() {
    if (this.baseParse)
      return 0;
    let e28 = this.input.length;
    for (let t3 = this.innerDone; t3 < this.inner.length; t3++)
      this.inner[t3].ranges[0].from < e28 && (e28 = Math.min(e28, this.inner[t3].parse.parsedPos));
    return e28;
  }
  stopAt(e28) {
    if (this.stoppedAt = e28, this.baseParse)
      this.baseParse.stopAt(e28);
    else
      for (let t3 = this.innerDone; t3 < this.inner.length; t3++)
        this.inner[t3].parse.stopAt(e28);
  }
  startInner() {
    let e28 = new Be$5(this.fragments), t3 = null, r3 = null, i = new Y$f(new P$D(this.baseTree, this.ranges[0].from, 0, null), k$v.IncludeAnonymous | k$v.IgnoreMounts);
    e:
      for (let n3, s3; this.stoppedAt == null || i.from < this.stoppedAt; ) {
        let h3 = true, f3;
        if (e28.hasNode(i)) {
          if (t3) {
            let u3 = t3.mounts.find((o3) => o3.frag.from <= i.from && o3.frag.to >= i.to && o3.mount.overlay);
            if (u3)
              for (let o3 of u3.mount.overlay) {
                let c3 = o3.from + u3.pos, a3 = o3.to + u3.pos;
                c3 >= i.from && a3 <= i.to && !t3.ranges.some((x3) => x3.from < a3 && x3.to > c3) && t3.ranges.push({ from: c3, to: a3 });
              }
          }
          h3 = false;
        } else if (r3 && (s3 = Pe$7(r3.ranges, i.from, i.to)))
          h3 = s3 != 2;
        else if (!i.type.isAnonymous && i.from < i.to && (n3 = this.nest(i, this.input))) {
          i.tree || Ne$4(i);
          let u3 = e28.findMounts(i.from, n3.parser);
          if (typeof n3.overlay == "function")
            t3 = new Se$6(n3.parser, n3.overlay, u3, this.inner.length, i.from, i.tree, t3);
          else {
            let o3 = pe$a(this.ranges, n3.overlay || [new z$h(i.from, i.to)]);
            o3.length && this.inner.push(new oe$b(n3.parser, n3.parser.startParse(this.input, ce$8(u3, o3), o3), n3.overlay ? n3.overlay.map((c3) => new z$h(c3.from - i.from, c3.to - i.from)) : null, i.tree, o3)), n3.overlay ? o3.length && (r3 = { ranges: o3, depth: 0, prev: r3 }) : h3 = false;
          }
        } else
          t3 && (f3 = t3.predicate(i)) && (f3 === true && (f3 = new z$h(i.from, i.to)), f3.from < f3.to && t3.ranges.push(f3));
        if (h3 && i.firstChild())
          t3 && t3.depth++, r3 && r3.depth++;
        else
          for (; !i.nextSibling(); ) {
            if (!i.parent())
              break e;
            if (t3 && !--t3.depth) {
              let u3 = pe$a(this.ranges, t3.ranges);
              u3.length && this.inner.splice(t3.index, 0, new oe$b(t3.parser, t3.parser.startParse(this.input, ce$8(t3.mounts, u3), u3), t3.ranges.map((o3) => new z$h(o3.from - t3.start, o3.to - t3.start)), t3.target, u3)), t3 = t3.prev;
            }
            r3 && !--r3.depth && (r3 = r3.prev);
          }
      }
  }
}
function Pe$7(l3, e28, t3) {
  for (let r3 of l3) {
    if (r3.from >= t3)
      break;
    if (r3.to > e28)
      return r3.from <= e28 && r3.to >= t3 ? 2 : 1;
  }
  return 0;
}
function ue$a(l3, e28, t3, r3, i, n3) {
  if (e28 < t3) {
    let s3 = l3.buffer[e28 + 1];
    r3.push(l3.slice(e28, t3, s3)), i.push(s3 - n3);
  }
}
function Ne$4(l3) {
  let { node: e28 } = l3, t3 = 0;
  do
    l3.parent(), t3++;
  while (!l3.tree);
  let r3 = 0, i = l3.tree, n3 = 0;
  for (; n3 = i.positions[r3] + l3.from, !(n3 <= e28.from && n3 + i.children[r3].length >= e28.to); r3++)
    ;
  let s3 = i.children[r3], h3 = s3.buffer;
  function f3(u3, o3, c3, a3, x3) {
    let d3 = u3;
    for (; h3[d3 + 2] + n3 <= e28.from; )
      d3 = h3[d3 + 3];
    let _3 = [], F3 = [];
    ue$a(s3, u3, d3, _3, F3, a3);
    let I3 = h3[d3 + 1], j3 = h3[d3 + 2], S3 = I3 + n3 == e28.from && j3 + n3 == e28.to && h3[d3] == e28.type.id;
    return _3.push(S3 ? e28.toTree() : f3(d3 + 4, h3[d3 + 3], s3.set.types[h3[d3]], I3, j3 - I3)), F3.push(I3 - a3), ue$a(s3, h3[d3 + 3], o3, _3, F3, a3), new B$q(c3, _3, F3, x3);
  }
  i.children[r3] = f3(0, h3.length, T$v.none, 0, s3.length);
  for (let u3 = 0; u3 <= t3; u3++)
    l3.childAfter(e28.from);
}
class ae$b {
  constructor(e28, t3) {
    this.offset = t3, this.done = false, this.cursor = e28.cursor(k$v.IncludeAnonymous | k$v.IgnoreMounts);
  }
  moveTo(e28) {
    let { cursor: t3 } = this, r3 = e28 - this.offset;
    for (; !this.done && t3.from < r3; )
      t3.to >= e28 && t3.enter(r3, 1, k$v.IgnoreOverlays | k$v.ExcludeBuffers) || t3.next(false) || (this.done = true);
  }
  hasNode(e28) {
    if (this.moveTo(e28.from), !this.done && this.cursor.from + this.offset == e28.from && this.cursor.tree)
      for (let t3 = this.cursor.tree; ; ) {
        if (t3 == e28.tree)
          return true;
        if (t3.children.length && t3.positions[0] == 0 && t3.children[0] instanceof B$q)
          t3 = t3.children[0];
        else
          break;
      }
    return false;
  }
}
class Be$5 {
  constructor(e28) {
    var t3;
    if (this.fragments = e28, this.curTo = 0, this.fragI = 0, e28.length) {
      let r3 = this.curFrag = e28[0];
      this.curTo = (t3 = r3.tree.prop(ee$a)) !== null && t3 !== void 0 ? t3 : r3.to, this.inner = new ae$b(r3.tree, -r3.offset);
    } else
      this.curFrag = this.inner = null;
  }
  hasNode(e28) {
    for (; this.curFrag && e28.from >= this.curTo; )
      this.nextFrag();
    return this.curFrag && this.curFrag.from <= e28.from && this.curTo >= e28.to && this.inner.hasNode(e28);
  }
  nextFrag() {
    var e28;
    if (this.fragI++, this.fragI == this.fragments.length)
      this.curFrag = this.inner = null;
    else {
      let t3 = this.curFrag = this.fragments[this.fragI];
      this.curTo = (e28 = t3.tree.prop(ee$a)) !== null && e28 !== void 0 ? e28 : t3.to, this.inner = new ae$b(t3.tree, -t3.offset);
    }
  }
  findMounts(e28, t3) {
    var r3;
    let i = [];
    if (this.inner) {
      this.inner.cursor.moveTo(e28, 1);
      for (let n3 = this.inner.cursor.node; n3; n3 = n3.parent) {
        let s3 = (r3 = n3.tree) === null || r3 === void 0 ? void 0 : r3.prop(C$G.mounted);
        if (s3 && s3.parser == t3)
          for (let h3 = this.fragI; h3 < this.fragments.length; h3++) {
            let f3 = this.fragments[h3];
            if (f3.from >= n3.to)
              break;
            f3.tree == this.curFrag.tree && i.push({
              frag: f3,
              pos: n3.from - f3.offset,
              mount: s3
            });
          }
      }
    }
    return i;
  }
}
function pe$a(l3, e28) {
  let t3 = null, r3 = e28;
  for (let i = 1, n3 = 0; i < l3.length; i++) {
    let s3 = l3[i - 1].to, h3 = l3[i].from;
    for (; n3 < r3.length; n3++) {
      let f3 = r3[n3];
      if (f3.from >= h3)
        break;
      f3.to <= s3 || (t3 || (r3 = t3 = e28.slice()), f3.from < s3 ? (t3[n3] = new z$h(f3.from, s3), f3.to > h3 && t3.splice(n3 + 1, 0, new z$h(h3, f3.to))) : f3.to > h3 ? t3[n3--] = new z$h(h3, f3.to) : t3.splice(n3--, 1));
    }
  }
  return r3;
}
function Ie$5(l3, e28, t3, r3) {
  let i = 0, n3 = 0, s3 = false, h3 = false, f3 = -1e9, u3 = [];
  for (; ; ) {
    let o3 = i == l3.length ? 1e9 : s3 ? l3[i].to : l3[i].from, c3 = n3 == e28.length ? 1e9 : h3 ? e28[n3].to : e28[n3].from;
    if (s3 != h3) {
      let a3 = Math.max(f3, t3), x3 = Math.min(o3, c3, r3);
      a3 < x3 && u3.push(new z$h(a3, x3));
    }
    if (f3 = Math.min(o3, c3), f3 == 1e9)
      break;
    o3 == f3 && (s3 ? (s3 = false, i++) : s3 = true), c3 == f3 && (h3 ? (h3 = false, n3++) : h3 = true);
  }
  return u3;
}
function ce$8(l3, e28) {
  let t3 = [];
  for (let { pos: r3, mount: i, frag: n3 } of l3) {
    let s3 = r3 + (i.overlay ? i.overlay[0].from : 0), h3 = s3 + i.tree.length, f3 = Math.max(n3.from, s3), u3 = Math.min(n3.to, h3);
    if (i.overlay) {
      let o3 = i.overlay.map((a3) => new z$h(a3.from + r3, a3.to + r3)), c3 = Ie$5(e28, o3, f3, u3);
      for (let a3 = 0, x3 = f3; ; a3++) {
        let d3 = a3 == c3.length, _3 = d3 ? u3 : c3[a3].from;
        if (_3 > x3 && t3.push(new q$i(x3, _3, i.tree, -s3, n3.from >= x3 || n3.openStart, n3.to <= _3 || n3.openEnd)), d3)
          break;
        x3 = c3[a3].to;
      }
    } else
      t3.push(new q$i(f3, u3, i.tree, -s3, n3.from >= s3 || n3.openStart, n3.to <= h3 || n3.openEnd));
  }
  return t3;
}
let z$g = 0;
class k$u {
  constructor(t3, a3, i) {
    this.set = t3, this.base = a3, this.modified = i, this.id = z$g++;
  }
  static define(t3) {
    if (t3 != null && t3.base)
      throw new Error("Can not derive from a modified tag");
    let a3 = new k$u([], null, []);
    if (a3.set.push(a3), t3)
      for (let i of t3.set)
        a3.set.push(i);
    return a3;
  }
  static defineModifier() {
    let t3 = new C$F();
    return (a3) => a3.modified.indexOf(t3) > -1 ? a3 : C$F.get(a3.base || a3, a3.modified.concat(t3).sort((i, l3) => i.id - l3.id));
  }
}
let G$i = 0;
class C$F {
  constructor() {
    this.instances = [], this.id = G$i++;
  }
  static get(t3, a3) {
    if (!a3.length)
      return t3;
    let i = a3[0].instances.find((r3) => r3.base == t3 && L$q(a3, r3.modified));
    if (i)
      return i;
    let l3 = [], s3 = new k$u(l3, t3, a3);
    for (let r3 of a3)
      r3.instances.push(s3);
    let g3 = Q$f(a3);
    for (let r3 of t3.set)
      if (!r3.modified.length)
        for (let d3 of g3)
          l3.push(C$F.get(r3, d3));
    return s3;
  }
}
function L$q(o3, t3) {
  return o3.length == t3.length && o3.every((a3, i) => a3 == t3[i]);
}
function Q$f(o3) {
  let t3 = [[]];
  for (let a3 = 0; a3 < o3.length; a3++)
    for (let i = 0, l3 = t3.length; i < l3; i++)
      t3.push(t3[i].concat(o3[a3]));
  return t3.sort((a3, i) => i.length - a3.length);
}
function $$d(o3) {
  let t3 = /* @__PURE__ */ Object.create(null);
  for (let a3 in o3) {
    let i = o3[a3];
    Array.isArray(i) || (i = [i]);
    for (let l3 of a3.split(" "))
      if (l3) {
        let s3 = [], g3 = 2, r3 = l3;
        for (let f3 = 0; ; ) {
          if (r3 == "..." && f3 > 0 && f3 + 3 == l3.length) {
            g3 = 1;
            break;
          }
          let c3 = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(r3);
          if (!c3)
            throw new RangeError("Invalid path: " + l3);
          if (s3.push(c3[0] == "*" ? "" : c3[0][0] == '"' ? JSON.parse(c3[0]) : c3[0]), f3 += c3[0].length, f3 == l3.length)
            break;
          let N3 = l3[f3++];
          if (f3 == l3.length && N3 == "!") {
            g3 = 0;
            break;
          }
          if (N3 != "/")
            throw new RangeError("Invalid path: " + l3);
          r3 = l3.slice(f3);
        }
        let d3 = s3.length - 1, h3 = s3[d3];
        if (!h3)
          throw new RangeError("Invalid path: " + l3);
        let v3 = new q$h(i, g3, d3 > 0 ? s3.slice(0, d3) : null);
        t3[h3] = v3.sort(t3[h3]);
      }
  }
  return J$f.add(t3);
}
const J$f = new C$G();
class q$h {
  constructor(t3, a3, i, l3) {
    this.tags = t3, this.mode = a3, this.context = i, this.next = l3;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(t3) {
    return !t3 || t3.depth < this.depth ? (this.next = t3, this) : (t3.next = this.sort(t3.next), t3);
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}
q$h.empty = new q$h([], 2, null);
function U$l(o3, t3) {
  let a3 = /* @__PURE__ */ Object.create(null);
  for (let s3 of o3)
    if (!Array.isArray(s3.tag))
      a3[s3.tag.id] = s3.class;
    else
      for (let g3 of s3.tag)
        a3[g3.id] = s3.class;
  let { scope: i, all: l3 = null } = t3 || {};
  return {
    style: (s3) => {
      let g3 = l3;
      for (let r3 of s3)
        for (let d3 of r3.set) {
          let h3 = a3[d3.id];
          if (h3) {
            g3 = g3 ? g3 + " " + h3 : h3;
            break;
          }
        }
      return g3;
    },
    scope: i
  };
}
function W$e(o3, t3) {
  let a3 = null;
  for (let i of o3) {
    let l3 = i.style(t3);
    l3 && (a3 = a3 ? a3 + " " + l3 : l3);
  }
  return a3;
}
function _$m(o3, t3, a3, i = 0, l3 = o3.length) {
  let s3 = new X$e(i, Array.isArray(t3) ? t3 : [t3], a3);
  s3.highlightRange(o3.cursor(), i, l3, "", s3.highlighters), s3.flush(l3);
}
class X$e {
  constructor(t3, a3, i) {
    this.at = t3, this.highlighters = a3, this.span = i, this.class = "";
  }
  startSpan(t3, a3) {
    a3 != this.class && (this.flush(t3), t3 > this.at && (this.at = t3), this.class = a3);
  }
  flush(t3) {
    t3 > this.at && this.class && this.span(this.at, t3, this.class);
  }
  highlightRange(t3, a3, i, l3, s3) {
    let { type: g3, from: r3, to: d3 } = t3;
    if (r3 >= i || d3 <= a3)
      return;
    g3.isTop && (s3 = this.highlighters.filter((N3) => !N3.scope || N3.scope(g3)));
    let h3 = l3, v3 = Y$e(t3) || q$h.empty, f3 = W$e(s3, v3.tags);
    if (f3 && (h3 && (h3 += " "), h3 += f3, v3.mode == 1 && (l3 += (l3 ? " " : "") + f3)), this.startSpan(Math.max(a3, r3), h3), v3.opaque)
      return;
    let c3 = t3.tree && t3.tree.prop(C$G.mounted);
    if (c3 && c3.overlay) {
      let N3 = t3.node.enter(c3.overlay[0].from + r3, 1), V10 = this.highlighters.filter((x3) => !x3.scope || x3.scope(c3.tree.type)), B3 = t3.firstChild();
      for (let x3 = 0, M3 = r3; ; x3++) {
        let O3 = x3 < c3.overlay.length ? c3.overlay[x3] : null, E3 = O3 ? O3.from + r3 : d3, H3 = Math.max(a3, M3), R3 = Math.min(i, E3);
        if (H3 < R3 && B3)
          for (; t3.from < R3 && (this.highlightRange(t3, H3, R3, l3, s3), this.startSpan(Math.min(R3, t3.to), h3), !(t3.to >= E3 || !t3.nextSibling())); )
            ;
        if (!O3 || E3 > i)
          break;
        M3 = O3.to + r3, M3 > a3 && (this.highlightRange(N3.cursor(), Math.max(a3, O3.from + r3), Math.min(i, M3), "", V10), this.startSpan(Math.min(i, M3), h3));
      }
      B3 && t3.parent();
    } else if (t3.firstChild()) {
      c3 && (l3 = "");
      do
        if (!(t3.to <= a3)) {
          if (t3.from >= i)
            break;
          this.highlightRange(t3, a3, i, l3, s3), this.startSpan(Math.min(i, t3.to), h3);
        }
      while (t3.nextSibling());
      t3.parent();
    }
  }
}
function Y$e(o3) {
  let t3 = o3.type.prop(J$f);
  for (; t3 && t3.context && !o3.matchContext(t3.context); )
    t3 = t3.next;
  return t3 || null;
}
const e$Z = k$u.define, A$l = e$Z(), y$y = e$Z(), P$C = e$Z(y$y), D$v = e$Z(y$y), b$C = e$Z(), T$u = e$Z(b$C), K$f = e$Z(b$C), u$10 = e$Z(), w$n = e$Z(u$10), p$2T = e$Z(), m$1g = e$Z(), j$e = e$Z(), S$k = e$Z(j$e), I$s = e$Z(), n$J = {
  comment: A$l,
  lineComment: e$Z(A$l),
  blockComment: e$Z(A$l),
  docComment: e$Z(A$l),
  name: y$y,
  variableName: e$Z(y$y),
  typeName: P$C,
  tagName: e$Z(P$C),
  propertyName: D$v,
  attributeName: e$Z(D$v),
  className: e$Z(y$y),
  labelName: e$Z(y$y),
  namespace: e$Z(y$y),
  macroName: e$Z(y$y),
  literal: b$C,
  string: T$u,
  docString: e$Z(T$u),
  character: e$Z(T$u),
  attributeValue: e$Z(T$u),
  number: K$f,
  integer: e$Z(K$f),
  float: e$Z(K$f),
  bool: e$Z(b$C),
  regexp: e$Z(b$C),
  escape: e$Z(b$C),
  color: e$Z(b$C),
  url: e$Z(b$C),
  keyword: p$2T,
  self: e$Z(p$2T),
  null: e$Z(p$2T),
  atom: e$Z(p$2T),
  unit: e$Z(p$2T),
  modifier: e$Z(p$2T),
  operatorKeyword: e$Z(p$2T),
  controlKeyword: e$Z(p$2T),
  definitionKeyword: e$Z(p$2T),
  moduleKeyword: e$Z(p$2T),
  operator: m$1g,
  derefOperator: e$Z(m$1g),
  arithmeticOperator: e$Z(m$1g),
  logicOperator: e$Z(m$1g),
  bitwiseOperator: e$Z(m$1g),
  compareOperator: e$Z(m$1g),
  updateOperator: e$Z(m$1g),
  definitionOperator: e$Z(m$1g),
  typeOperator: e$Z(m$1g),
  controlOperator: e$Z(m$1g),
  punctuation: j$e,
  separator: e$Z(j$e),
  bracket: S$k,
  angleBracket: e$Z(S$k),
  squareBracket: e$Z(S$k),
  paren: e$Z(S$k),
  brace: e$Z(S$k),
  content: u$10,
  heading: w$n,
  heading1: e$Z(w$n),
  heading2: e$Z(w$n),
  heading3: e$Z(w$n),
  heading4: e$Z(w$n),
  heading5: e$Z(w$n),
  heading6: e$Z(w$n),
  contentSeparator: e$Z(u$10),
  list: e$Z(u$10),
  quote: e$Z(u$10),
  emphasis: e$Z(u$10),
  strong: e$Z(u$10),
  link: e$Z(u$10),
  monospace: e$Z(u$10),
  strikethrough: e$Z(u$10),
  inserted: e$Z(),
  deleted: e$Z(),
  changed: e$Z(),
  invalid: e$Z(),
  meta: I$s,
  documentMeta: e$Z(I$s),
  annotation: e$Z(I$s),
  processingInstruction: e$Z(I$s),
  definition: k$u.defineModifier(),
  constant: k$u.defineModifier(),
  function: k$u.defineModifier(),
  standard: k$u.defineModifier(),
  local: k$u.defineModifier(),
  special: k$u.defineModifier()
};
U$l([
  { tag: n$J.link, class: "tok-link" },
  { tag: n$J.heading, class: "tok-heading" },
  { tag: n$J.emphasis, class: "tok-emphasis" },
  { tag: n$J.strong, class: "tok-strong" },
  { tag: n$J.keyword, class: "tok-keyword" },
  { tag: n$J.atom, class: "tok-atom" },
  { tag: n$J.bool, class: "tok-bool" },
  { tag: n$J.url, class: "tok-url" },
  { tag: n$J.labelName, class: "tok-labelName" },
  { tag: n$J.inserted, class: "tok-inserted" },
  { tag: n$J.deleted, class: "tok-deleted" },
  { tag: n$J.literal, class: "tok-literal" },
  { tag: n$J.string, class: "tok-string" },
  { tag: n$J.number, class: "tok-number" },
  { tag: [n$J.regexp, n$J.escape, n$J.special(n$J.string)], class: "tok-string2" },
  { tag: n$J.variableName, class: "tok-variableName" },
  { tag: n$J.local(n$J.variableName), class: "tok-variableName tok-local" },
  { tag: n$J.definition(n$J.variableName), class: "tok-variableName tok-definition" },
  { tag: n$J.special(n$J.variableName), class: "tok-variableName2" },
  { tag: n$J.definition(n$J.propertyName), class: "tok-propertyName tok-definition" },
  { tag: n$J.typeName, class: "tok-typeName" },
  { tag: n$J.namespace, class: "tok-namespace" },
  { tag: n$J.className, class: "tok-className" },
  { tag: n$J.macroName, class: "tok-macroName" },
  { tag: n$J.propertyName, class: "tok-propertyName" },
  { tag: n$J.operator, class: "tok-operator" },
  { tag: n$J.comment, class: "tok-comment" },
  { tag: n$J.meta, class: "tok-meta" },
  { tag: n$J.invalid, class: "tok-invalid" },
  { tag: n$J.punctuation, class: "tok-punctuation" }
]);
var R$g;
const T$t = /* @__PURE__ */ new C$G();
function He$4(n3) {
  return A$o.define({
    combine: n3 ? (e28) => e28.concat(n3) : void 0
  });
}
const Le$3 = /* @__PURE__ */ new C$G();
class m$1f {
  constructor(e28, t3, r3 = [], i = "") {
    this.data = e28, this.name = i, w$q.prototype.hasOwnProperty("tree") || Object.defineProperty(w$q.prototype, "tree", { get() {
      return k$t(this);
    } }), this.parser = t3, this.extension = [
      v$F.of(this),
      w$q.languageData.of((s3, o3, a3) => {
        let l3 = te$a(s3, o3, a3), c3 = l3.type.prop(T$t);
        if (!c3)
          return [];
        let f3 = s3.facet(c3), h3 = l3.type.prop(Le$3);
        if (h3) {
          let p3 = l3.resolve(o3 - l3.from, a3);
          for (let d3 of h3)
            if (d3.test(p3, s3)) {
              let S3 = s3.facet(d3.facet);
              return d3.type == "replace" ? S3 : S3.concat(f3);
            }
        }
        return f3;
      })
    ].concat(r3);
  }
  isActiveAt(e28, t3, r3 = -1) {
    return te$a(e28, t3, r3).type.prop(T$t) == this.data;
  }
  findRegions(e28) {
    let t3 = e28.facet(v$F);
    if ((t3 == null ? void 0 : t3.data) == this.data)
      return [{ from: 0, to: e28.doc.length }];
    if (!t3 || !t3.allowsNesting)
      return [];
    let r3 = [], i = (s3, o3) => {
      if (s3.prop(T$t) == this.data) {
        r3.push({ from: o3, to: o3 + s3.length });
        return;
      }
      let a3 = s3.prop(C$G.mounted);
      if (a3) {
        if (a3.tree.prop(T$t) == this.data) {
          if (a3.overlay)
            for (let l3 of a3.overlay)
              r3.push({ from: l3.from + o3, to: l3.to + o3 });
          else
            r3.push({ from: o3, to: o3 + s3.length });
          return;
        } else if (a3.overlay) {
          let l3 = r3.length;
          if (i(a3.tree, a3.overlay[0].from + o3), r3.length > l3)
            return;
        }
      }
      for (let l3 = 0; l3 < s3.children.length; l3++) {
        let c3 = s3.children[l3];
        c3 instanceof B$q && i(c3, s3.positions[l3] + o3);
      }
    };
    return i(k$t(e28), 0), r3;
  }
  get allowsNesting() {
    return true;
  }
}
m$1f.setState = /* @__PURE__ */ S$m.define();
function te$a(n3, e28, t3) {
  let r3 = n3.facet(v$F), i = k$t(n3).topNode;
  if (!r3 || r3.allowsNesting)
    for (let s3 = i; s3; s3 = s3.enter(e28, t3, k$v.ExcludeBuffers))
      s3.type.isTop && (i = s3);
  return i;
}
class G$h extends m$1f {
  constructor(e28, t3, r3) {
    super(e28, t3, [], r3), this.parser = t3;
  }
  static define(e28) {
    let t3 = He$4(e28.languageData);
    return new G$h(t3, e28.parser.configure({
      props: [T$t.add((r3) => r3.isTop ? t3 : void 0)]
    }), e28.name);
  }
  configure(e28, t3) {
    return new G$h(this.data, this.parser.configure(e28), t3 || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
}
function k$t(n3) {
  let e28 = n3.field(m$1f.state, false);
  return e28 ? e28.tree : B$q.empty;
}
class We$5 {
  constructor(e28) {
    this.doc = e28, this.cursorPos = 0, this.string = "", this.cursor = e28.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(e28) {
    return this.string = this.cursor.next(e28 - this.cursorPos).value, this.cursorPos = e28 + this.string.length, this.cursorPos - this.string.length;
  }
  chunk(e28) {
    return this.syncTo(e28), this.string;
  }
  get lineChunks() {
    return true;
  }
  read(e28, t3) {
    let r3 = this.cursorPos - this.string.length;
    return e28 < r3 || t3 >= this.cursorPos ? this.doc.sliceString(e28, t3) : this.string.slice(e28 - r3, t3 - r3);
  }
}
let D$u = null;
class N$v {
  constructor(e28, t3, r3 = [], i, s3, o3, a3, l3) {
    this.parser = e28, this.state = t3, this.fragments = r3, this.tree = i, this.treeLen = s3, this.viewport = o3, this.skipped = a3, this.scheduleOn = l3, this.parse = null, this.tempSkipped = [];
  }
  static create(e28, t3, r3) {
    return new N$v(e28, t3, [], B$q.empty, 0, r3, [], null);
  }
  startParse() {
    return this.parser.startParse(new We$5(this.state.doc), this.fragments);
  }
  work(e28, t3) {
    return t3 != null && t3 >= this.state.doc.length && (t3 = void 0), this.tree != B$q.empty && this.isDone(t3 != null ? t3 : this.state.doc.length) ? (this.takeTree(), true) : this.withContext(() => {
      var r3;
      if (typeof e28 == "number") {
        let i = Date.now() + e28;
        e28 = () => Date.now() > i;
      }
      for (this.parse || (this.parse = this.startParse()), t3 != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > t3) && t3 < this.state.doc.length && this.parse.stopAt(t3); ; ) {
        let i = this.parse.advance();
        if (i)
          if (this.fragments = this.withoutTempSkipped(q$i.addTree(i, this.fragments, this.parse.stoppedAt != null)), this.treeLen = (r3 = this.parse.stoppedAt) !== null && r3 !== void 0 ? r3 : this.state.doc.length, this.tree = i, this.parse = null, this.treeLen < (t3 != null ? t3 : this.state.doc.length))
            this.parse = this.startParse();
          else
            return true;
        if (e28())
          return false;
      }
    });
  }
  takeTree() {
    let e28, t3;
    this.parse && (e28 = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > e28) && this.parse.stopAt(e28), this.withContext(() => {
      for (; !(t3 = this.parse.advance()); )
        ;
    }), this.treeLen = e28, this.tree = t3, this.fragments = this.withoutTempSkipped(q$i.addTree(this.tree, this.fragments, true)), this.parse = null);
  }
  withContext(e28) {
    let t3 = D$u;
    D$u = this;
    try {
      return e28();
    } finally {
      D$u = t3;
    }
  }
  withoutTempSkipped(e28) {
    for (let t3; t3 = this.tempSkipped.pop(); )
      e28 = ne$c(e28, t3.from, t3.to);
    return e28;
  }
  changes(e28, t3) {
    let { fragments: r3, tree: i, treeLen: s3, viewport: o3, skipped: a3 } = this;
    if (this.takeTree(), !e28.empty) {
      let l3 = [];
      if (e28.iterChangedRanges((c3, f3, h3, p3) => l3.push({ fromA: c3, toA: f3, fromB: h3, toB: p3 })), r3 = q$i.applyChanges(r3, l3), i = B$q.empty, s3 = 0, o3 = { from: e28.mapPos(o3.from, -1), to: e28.mapPos(o3.to, 1) }, this.skipped.length) {
        a3 = [];
        for (let c3 of this.skipped) {
          let f3 = e28.mapPos(c3.from, 1), h3 = e28.mapPos(c3.to, -1);
          f3 < h3 && a3.push({ from: f3, to: h3 });
        }
      }
    }
    return new N$v(this.parser, t3, r3, i, s3, o3, a3, this.scheduleOn);
  }
  updateViewport(e28) {
    if (this.viewport.from == e28.from && this.viewport.to == e28.to)
      return false;
    this.viewport = e28;
    let t3 = this.skipped.length;
    for (let r3 = 0; r3 < this.skipped.length; r3++) {
      let { from: i, to: s3 } = this.skipped[r3];
      i < e28.to && s3 > e28.from && (this.fragments = ne$c(this.fragments, i, s3), this.skipped.splice(r3--, 1));
    }
    return this.skipped.length >= t3 ? false : (this.reset(), true);
  }
  reset() {
    this.parse && (this.takeTree(), this.parse = null);
  }
  skipUntilInView(e28, t3) {
    this.skipped.push({ from: e28, to: t3 });
  }
  static getSkippingParser(e28) {
    return new class extends Ee$5 {
      createParse(t3, r3, i) {
        let s3 = i[0].from, o3 = i[i.length - 1].to;
        return {
          parsedPos: s3,
          advance() {
            let l3 = D$u;
            if (l3) {
              for (let c3 of i)
                l3.tempSkipped.push(c3);
              e28 && (l3.scheduleOn = l3.scheduleOn ? Promise.all([l3.scheduleOn, e28]) : e28);
            }
            return this.parsedPos = o3, new B$q(T$v.none, [], [], o3 - s3);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
      }
    }();
  }
  isDone(e28) {
    e28 = Math.min(e28, this.state.doc.length);
    let t3 = this.fragments;
    return this.treeLen >= e28 && t3.length && t3[0].from == 0 && t3[0].to >= e28;
  }
  static get() {
    return D$u;
  }
}
function ne$c(n3, e28, t3) {
  return q$i.applyChanges(n3, [{ fromA: e28, toA: t3, fromB: e28, toB: t3 }]);
}
class P$B {
  constructor(e28) {
    this.context = e28, this.tree = e28.tree;
  }
  apply(e28) {
    if (!e28.docChanged && this.tree == this.context.tree)
      return this;
    let t3 = this.context.changes(e28.changes, e28.state), r3 = this.context.treeLen == e28.startState.doc.length ? void 0 : Math.max(e28.changes.mapPos(this.context.treeLen), t3.viewport.to);
    return t3.work(20, r3) || t3.takeTree(), new P$B(t3);
  }
  static init(e28) {
    let t3 = Math.min(3e3, e28.doc.length), r3 = N$v.create(e28.facet(v$F).parser, e28, { from: 0, to: t3 });
    return r3.work(20, t3) || r3.takeTree(), new P$B(r3);
  }
}
m$1f.state = /* @__PURE__ */ L$s.define({
  create: P$B.init,
  update(n3, e28) {
    for (let t3 of e28.effects)
      if (t3.is(m$1f.setState))
        return t3.value;
    return e28.startState.facet(v$F) != e28.state.facet(v$F) ? P$B.init(e28.state) : n3.apply(e28);
  }
});
let fe$8 = (n3) => {
  let e28 = setTimeout(() => n3(), 500);
  return () => clearTimeout(e28);
};
typeof requestIdleCallback < "u" && (fe$8 = (n3) => {
  let e28 = -1, t3 = setTimeout(() => {
    e28 = requestIdleCallback(n3, {
      timeout: 500 - 100
    });
  }, 100);
  return () => e28 < 0 ? clearTimeout(t3) : cancelIdleCallback(e28);
});
const $$c = typeof navigator < "u" && (!((R$g = navigator.scheduling) === null || R$g === void 0) && R$g.isInputPending) ? () => navigator.scheduling.isInputPending() : null, Ue$3 = /* @__PURE__ */ z$i.fromClass(class {
  constructor(e28) {
    this.view = e28, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
  }
  update(e28) {
    let t3 = this.view.state.field(m$1f.state).context;
    (t3.updateViewport(e28.view.viewport) || this.view.viewport.to > t3.treeLen) && this.scheduleWork(), (e28.docChanged || e28.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(t3);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state: e28 } = this.view, t3 = e28.field(m$1f.state);
    (t3.tree != t3.context.tree || !t3.context.isDone(e28.doc.length)) && (this.working = fe$8(this.work));
  }
  work(e28) {
    this.working = null;
    let t3 = Date.now();
    if (this.chunkEnd < t3 && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = t3 + 3e4, this.chunkBudget = 3e3), this.chunkBudget <= 0)
      return;
    let { state: r3, viewport: { to: i } } = this.view, s3 = r3.field(m$1f.state);
    if (s3.tree == s3.context.tree && s3.context.isDone(i + 1e5))
      return;
    let o3 = Date.now() + Math.min(this.chunkBudget, 100, e28 && !$$c ? Math.max(25, e28.timeRemaining() - 5) : 1e9), a3 = s3.context.treeLen < i && r3.doc.length > i + 1e3, l3 = s3.context.work(() => $$c && $$c() || Date.now() > o3, i + (a3 ? 0 : 1e5));
    this.chunkBudget -= Date.now() - t3, (l3 || this.chunkBudget <= 0) && (s3.context.takeTree(), this.view.dispatch({ effects: m$1f.setState.of(new P$B(s3.context)) })), this.chunkBudget > 0 && !(l3 && !a3) && this.scheduleWork(), this.checkAsyncSchedule(s3.context);
  }
  checkAsyncSchedule(e28) {
    e28.scheduleOn && (this.workScheduled++, e28.scheduleOn.then(() => this.scheduleWork()).catch((t3) => ct$6(this.view.state, t3)).then(() => this.workScheduled--), e28.scheduleOn = null);
  }
  destroy() {
    this.working && this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
}), v$F = /* @__PURE__ */ A$o.define({
  combine(n3) {
    return n3.length ? n3[0] : null;
  },
  enables: (n3) => [
    m$1f.state,
    Ue$3,
    A$m.contentAttributes.compute([n3], (e28) => {
      let t3 = e28.facet(n3);
      return t3 && t3.name ? { "data-language": t3.name } : {};
    })
  ]
});
class It$5 {
  constructor(e28, t3 = []) {
    this.language = e28, this.support = t3, this.extension = [e28, t3];
  }
}
const Re$8 = /* @__PURE__ */ A$o.define(), ce$7 = /* @__PURE__ */ A$o.define({
  combine: (n3) => {
    if (!n3.length)
      return "  ";
    let e28 = n3[0];
    if (!e28 || /\S/.test(e28) || Array.from(e28).some((t3) => t3 != e28[0]))
      throw new Error("Invalid indent unit: " + JSON.stringify(n3[0]));
    return e28;
  }
});
function $e$3(n3) {
  let e28 = n3.facet(ce$7);
  return e28.charCodeAt(0) == 9 ? n3.tabSize * e28.length : e28.length;
}
function je$4(n3, e28) {
  let t3 = "", r3 = n3.tabSize, i = n3.facet(ce$7)[0];
  if (i == "	") {
    for (; e28 >= r3; )
      t3 += "	", e28 -= r3;
    i = " ";
  }
  for (let s3 = 0; s3 < e28; s3++)
    t3 += i;
  return t3;
}
function qe$4(n3, e28) {
  n3 instanceof w$q && (n3 = new ue$9(n3));
  for (let r3 of n3.state.facet(Re$8)) {
    let i = r3(n3, e28);
    if (i !== void 0)
      return i;
  }
  let t3 = k$t(n3.state);
  return t3.length >= e28 ? Ge$4(n3, t3, e28) : null;
}
class ue$9 {
  constructor(e28, t3 = {}) {
    this.state = e28, this.options = t3, this.unit = $e$3(e28);
  }
  lineAt(e28, t3 = 1) {
    let r3 = this.state.doc.lineAt(e28), { simulateBreak: i, simulateDoubleBreak: s3 } = this.options;
    return i != null && i >= r3.from && i <= r3.to ? s3 && i == e28 ? { text: "", from: e28 } : (t3 < 0 ? i < e28 : i <= e28) ? { text: r3.text.slice(i - r3.from), from: i } : { text: r3.text.slice(0, i - r3.from), from: r3.from } : r3;
  }
  textAfterPos(e28, t3 = 1) {
    if (this.options.simulateDoubleBreak && e28 == this.options.simulateBreak)
      return "";
    let { text: r3, from: i } = this.lineAt(e28, t3);
    return r3.slice(e28 - i, Math.min(r3.length, e28 + 100 - i));
  }
  column(e28, t3 = 1) {
    let { text: r3, from: i } = this.lineAt(e28, t3), s3 = this.countColumn(r3, e28 - i), o3 = this.options.overrideIndentation ? this.options.overrideIndentation(i) : -1;
    return o3 > -1 && (s3 += o3 - this.countColumn(r3, r3.search(/\S|$/))), s3;
  }
  countColumn(e28, t3 = e28.length) {
    return ot$6(e28, this.state.tabSize, t3);
  }
  lineIndent(e28, t3 = 1) {
    let { text: r3, from: i } = this.lineAt(e28, t3), s3 = this.options.overrideIndentation;
    if (s3) {
      let o3 = s3(i);
      if (o3 > -1)
        return o3;
    }
    return this.countColumn(r3, r3.search(/\S|$/));
  }
  get simulatedBreak() {
    return this.options.simulateBreak || null;
  }
}
const ze$4 = /* @__PURE__ */ new C$G();
function Ge$4(n3, e28, t3) {
  let r3 = e28.resolveStack(t3), i = r3.node.enterUnfinishedNodesBefore(t3);
  if (i != r3.node) {
    let s3 = [];
    for (let o3 = i; o3 != r3.node; o3 = o3.parent)
      s3.push(o3);
    for (let o3 = s3.length - 1; o3 >= 0; o3--)
      r3 = { node: s3[o3], next: r3 };
  }
  return he$a(r3, n3, t3);
}
function he$a(n3, e28, t3) {
  for (let r3 = n3; r3; r3 = r3.next) {
    let i = Ve$6(r3.node);
    if (i)
      return i(Z$f.create(e28, t3, r3));
  }
  return 0;
}
function Je$3(n3) {
  return n3.pos == n3.options.simulateBreak && n3.options.simulateDoubleBreak;
}
function Ve$6(n3) {
  let e28 = n3.type.prop(ze$4);
  if (e28)
    return e28;
  let t3 = n3.firstChild, r3;
  if (t3 && (r3 = t3.type.prop(C$G.closedBy))) {
    let i = n3.lastChild, s3 = i && r3.indexOf(i.name) > -1;
    return (o3) => de$a(o3, true, 1, void 0, s3 && !Je$3(o3) ? i.from : void 0);
  }
  return n3.parent == null ? Ke$4 : null;
}
function Ke$4() {
  return 0;
}
class Z$f extends ue$9 {
  constructor(e28, t3, r3) {
    super(e28.state, e28.options), this.base = e28, this.pos = t3, this.context = r3;
  }
  get node() {
    return this.context.node;
  }
  static create(e28, t3, r3) {
    return new Z$f(e28, t3, r3);
  }
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  baseIndentFor(e28) {
    let t3 = this.state.doc.lineAt(e28.from);
    for (; ; ) {
      let r3 = e28.resolve(t3.from);
      for (; r3.parent && r3.parent.from == r3.from; )
        r3 = r3.parent;
      if (Qe$5(r3, e28))
        break;
      t3 = this.state.doc.lineAt(r3.from);
    }
    return this.lineIndent(t3.from);
  }
  continue() {
    return he$a(this.context.next, this.base, this.pos);
  }
}
function Qe$5(n3, e28) {
  for (let t3 = e28; t3; t3 = t3.parent)
    if (n3 == t3)
      return true;
  return false;
}
function Xe$6(n3) {
  let e28 = n3.node, t3 = e28.childAfter(e28.from), r3 = e28.lastChild;
  if (!t3)
    return null;
  let i = n3.options.simulateBreak, s3 = n3.state.doc.lineAt(t3.from), o3 = i == null || i <= s3.from ? s3.to : Math.min(s3.to, i);
  for (let a3 = t3.to; ; ) {
    let l3 = e28.childAfter(a3);
    if (!l3 || l3 == r3)
      return null;
    if (!l3.type.isSkipped)
      return l3.from < o3 ? t3 : null;
    a3 = l3.to;
  }
}
function Mt$4({ closing: n3, align: e28 = true, units: t3 = 1 }) {
  return (r3) => de$a(r3, e28, t3, n3);
}
function de$a(n3, e28, t3, r3, i) {
  let s3 = n3.textAfter, o3 = s3.match(/^\s*/)[0].length, a3 = r3 && s3.slice(o3, o3 + r3.length) == r3 || i == n3.pos + o3, l3 = e28 ? Xe$6(n3) : null;
  return l3 ? a3 ? n3.column(l3.from) : n3.column(l3.to) : n3.baseIndent + (a3 ? 0 : n3.unit * t3);
}
const Nt$3 = (n3) => n3.baseIndent;
function Et$5({ except: n3, units: e28 = 1 } = {}) {
  return (t3) => {
    let r3 = n3 && n3.test(t3.textAfter);
    return t3.baseIndent + (r3 ? 0 : e28 * t3.unit);
  };
}
const Ye$4 = 200;
function Ft$4() {
  return w$q.transactionFilter.of((n3) => {
    if (!n3.docChanged || !n3.isUserEvent("input.type") && !n3.isUserEvent("input.complete"))
      return n3;
    let e28 = n3.startState.languageDataAt("indentOnInput", n3.startState.selection.main.head);
    if (!e28.length)
      return n3;
    let t3 = n3.newDoc, { head: r3 } = n3.newSelection.main, i = t3.lineAt(r3);
    if (r3 > i.from + Ye$4)
      return n3;
    let s3 = t3.sliceString(i.from, r3);
    if (!e28.some((c3) => c3.test(s3)))
      return n3;
    let { state: o3 } = n3, a3 = -1, l3 = [];
    for (let { head: c3 } of o3.selection.ranges) {
      let f3 = o3.doc.lineAt(c3);
      if (f3.from == a3)
        continue;
      a3 = f3.from;
      let h3 = qe$4(o3, f3.from);
      if (h3 == null)
        continue;
      let p3 = /^\s*/.exec(f3.text)[0], d3 = je$4(o3, h3);
      p3 != d3 && l3.push({ from: f3.from, to: f3.from + p3.length, insert: d3 });
    }
    return l3.length ? [n3, { changes: l3, sequential: true }] : n3;
  });
}
const Ze$3 = /* @__PURE__ */ A$o.define(), _e$7 = /* @__PURE__ */ new C$G();
function Ht$3(n3) {
  let e28 = n3.firstChild, t3 = n3.lastChild;
  return e28 && e28.to < t3.from ? { from: e28.to, to: t3.type.isError ? n3.to : t3.from } : null;
}
function et$4(n3, e28, t3) {
  let r3 = k$t(n3);
  if (r3.length < t3)
    return null;
  let i = r3.resolveStack(t3, 1), s3 = null;
  for (let o3 = i; o3; o3 = o3.next) {
    let a3 = o3.node;
    if (a3.to <= t3 || a3.from > t3)
      continue;
    if (s3 && a3.from < e28)
      break;
    let l3 = a3.type.prop(_e$7);
    if (l3 && (a3.to < r3.length - 50 || r3.length == n3.doc.length || !tt$3(a3))) {
      let c3 = l3(a3, n3);
      c3 && c3.from <= t3 && c3.from >= e28 && c3.to > t3 && (s3 = c3);
    }
  }
  return s3;
}
function tt$3(n3) {
  let e28 = n3.lastChild;
  return e28 && e28.to == n3.to && e28.type.isError;
}
function E$o(n3, e28, t3) {
  for (let r3 of n3.facet(Ze$3)) {
    let i = r3(n3, e28, t3);
    if (i)
      return i;
  }
  return et$4(n3, e28, t3);
}
function pe$9(n3, e28) {
  let t3 = e28.mapPos(n3.from, 1), r3 = e28.mapPos(n3.to, -1);
  return t3 >= r3 ? void 0 : { from: t3, to: r3 };
}
const L$p = /* @__PURE__ */ S$m.define({ map: pe$9 }), B$p = /* @__PURE__ */ S$m.define({ map: pe$9 });
function me$a(n3) {
  let e28 = [];
  for (let { head: t3 } of n3.state.selection.ranges)
    e28.some((r3) => r3.from <= t3 && r3.to >= t3) || e28.push(n3.lineBlockAt(t3));
  return e28;
}
const x$k = /* @__PURE__ */ L$s.define({
  create() {
    return V$j.none;
  },
  update(n3, e28) {
    n3 = n3.map(e28.changes);
    for (let t3 of e28.effects)
      if (t3.is(L$p) && !nt$4(n3, t3.value.from, t3.value.to)) {
        let { preparePlaceholder: r3 } = e28.state.facet(_$l), i = r3 ? V$j.replace({ widget: new at$4(r3(e28.state, t3.value)) }) : re$8;
        n3 = n3.update({ add: [i.range(t3.value.from, t3.value.to)] });
      } else
        t3.is(B$p) && (n3 = n3.update({
          filter: (r3, i) => t3.value.from != r3 || t3.value.to != i,
          filterFrom: t3.value.from,
          filterTo: t3.value.to
        }));
    if (e28.selection) {
      let t3 = false, { head: r3 } = e28.selection.main;
      n3.between(r3, r3, (i, s3) => {
        i < r3 && s3 > r3 && (t3 = true);
      }), t3 && (n3 = n3.update({
        filterFrom: r3,
        filterTo: r3,
        filter: (i, s3) => s3 <= r3 || i >= r3
      }));
    }
    return n3;
  },
  provide: (n3) => A$m.decorations.from(n3),
  toJSON(n3, e28) {
    let t3 = [];
    return n3.between(0, e28.doc.length, (r3, i) => {
      t3.push(r3, i);
    }), t3;
  },
  fromJSON(n3) {
    if (!Array.isArray(n3) || n3.length % 2)
      throw new RangeError("Invalid JSON for fold state");
    let e28 = [];
    for (let t3 = 0; t3 < n3.length; ) {
      let r3 = n3[t3++], i = n3[t3++];
      if (typeof r3 != "number" || typeof i != "number")
        throw new RangeError("Invalid JSON for fold state");
      e28.push(re$8.range(r3, i));
    }
    return V$j.set(e28, true);
  }
});
function F$k(n3, e28, t3) {
  var r3;
  let i = null;
  return (r3 = n3.field(x$k, false)) === null || r3 === void 0 || r3.between(e28, t3, (s3, o3) => {
    (!i || i.from > s3) && (i = { from: s3, to: o3 });
  }), i;
}
function nt$4(n3, e28, t3) {
  let r3 = false;
  return n3.between(e28, e28, (i, s3) => {
    i == e28 && s3 == t3 && (r3 = true);
  }), r3;
}
function ge$8(n3, e28) {
  return n3.field(x$k, false) ? e28 : e28.concat(S$m.appendConfig.of(be$8()));
}
const rt$5 = (n3) => {
  for (let e28 of me$a(n3)) {
    let t3 = E$o(n3.state, e28.from, e28.to);
    if (t3)
      return n3.dispatch({ effects: ge$8(n3.state, [L$p.of(t3), ke$7(n3, t3)]) }), true;
  }
  return false;
}, it$4 = (n3) => {
  if (!n3.state.field(x$k, false))
    return false;
  let e28 = [];
  for (let t3 of me$a(n3)) {
    let r3 = F$k(n3.state, t3.from, t3.to);
    r3 && e28.push(B$p.of(r3), ke$7(n3, r3, false));
  }
  return e28.length && n3.dispatch({ effects: e28 }), e28.length > 0;
};
function ke$7(n3, e28, t3 = true) {
  let r3 = n3.state.doc.lineAt(e28.from).number, i = n3.state.doc.lineAt(e28.to).number;
  return A$m.announce.of(`${n3.state.phrase(t3 ? "Folded lines" : "Unfolded lines")} ${r3} ${n3.state.phrase("to")} ${i}.`);
}
const ot$4 = (n3) => {
  let { state: e28 } = n3, t3 = [];
  for (let r3 = 0; r3 < e28.doc.length; ) {
    let i = n3.lineBlockAt(r3), s3 = E$o(e28, i.from, i.to);
    s3 && t3.push(L$p.of(s3)), r3 = (s3 ? n3.lineBlockAt(s3.to) : i).to + 1;
  }
  return t3.length && n3.dispatch({ effects: ge$8(n3.state, t3) }), !!t3.length;
}, st$5 = (n3) => {
  let e28 = n3.state.field(x$k, false);
  if (!e28 || !e28.size)
    return false;
  let t3 = [];
  return e28.between(0, n3.state.doc.length, (r3, i) => {
    t3.push(B$p.of({ from: r3, to: i }));
  }), n3.dispatch({ effects: t3 }), true;
}, Lt$3 = [
  { key: "Ctrl-Shift-[", mac: "Cmd-Alt-[", run: rt$5 },
  { key: "Ctrl-Shift-]", mac: "Cmd-Alt-]", run: it$4 },
  { key: "Ctrl-Alt-[", run: ot$4 },
  { key: "Ctrl-Alt-]", run: st$5 }
], lt$6 = {
  placeholderDOM: null,
  preparePlaceholder: null,
  placeholderText: "\u2026"
}, _$l = /* @__PURE__ */ A$o.define({
  combine(n3) {
    return ht$7(n3, lt$6);
  }
});
function be$8(n3) {
  let e28 = [x$k, ct$5];
  return n3 && e28.push(_$l.of(n3)), e28;
}
function ye$8(n3, e28) {
  let { state: t3 } = n3, r3 = t3.facet(_$l), i = (o3) => {
    let a3 = n3.lineBlockAt(n3.posAtDOM(o3.target)), l3 = F$k(n3.state, a3.from, a3.to);
    l3 && n3.dispatch({ effects: B$p.of(l3) }), o3.preventDefault();
  };
  if (r3.placeholderDOM)
    return r3.placeholderDOM(n3, i, e28);
  let s3 = document.createElement("span");
  return s3.textContent = r3.placeholderText, s3.setAttribute("aria-label", t3.phrase("folded code")), s3.title = t3.phrase("unfold"), s3.className = "cm-foldPlaceholder", s3.onclick = i, s3;
}
const re$8 = /* @__PURE__ */ V$j.replace({ widget: /* @__PURE__ */ new class extends Nt$4 {
  toDOM(n3) {
    return ye$8(n3, null);
  }
}() });
class at$4 extends Nt$4 {
  constructor(e28) {
    super(), this.value = e28;
  }
  eq(e28) {
    return this.value == e28.value;
  }
  toDOM(e28) {
    return ye$8(e28, this.value);
  }
}
const ft$4 = {
  openText: "\u2304",
  closedText: "\u203A",
  markerDOM: null,
  domEventHandlers: {},
  foldingChanged: () => false
};
class j$d extends lt$7 {
  constructor(e28, t3) {
    super(), this.config = e28, this.open = t3;
  }
  eq(e28) {
    return this.config == e28.config && this.open == e28.open;
  }
  toDOM(e28) {
    if (this.config.markerDOM)
      return this.config.markerDOM(this.open);
    let t3 = document.createElement("span");
    return t3.textContent = this.open ? this.config.openText : this.config.closedText, t3.title = e28.state.phrase(this.open ? "Fold line" : "Unfold line"), t3;
  }
}
function Wt$4(n3 = {}) {
  let e28 = Object.assign(Object.assign({}, ft$4), n3), t3 = new j$d(e28, true), r3 = new j$d(e28, false), i = z$i.fromClass(class {
    constructor(o3) {
      this.from = o3.viewport.from, this.markers = this.buildMarkers(o3);
    }
    update(o3) {
      (o3.docChanged || o3.viewportChanged || o3.startState.facet(v$F) != o3.state.facet(v$F) || o3.startState.field(x$k, false) != o3.state.field(x$k, false) || k$t(o3.startState) != k$t(o3.state) || e28.foldingChanged(o3)) && (this.markers = this.buildMarkers(o3.view));
    }
    buildMarkers(o3) {
      let a3 = new _$n();
      for (let l3 of o3.viewportLineBlocks) {
        let c3 = F$k(o3.state, l3.from, l3.to) ? r3 : E$o(o3.state, l3.from, l3.to) ? t3 : null;
        c3 && a3.add(l3.from, l3.from, c3);
      }
      return a3.finish();
    }
  }), { domEventHandlers: s3 } = e28;
  return [
    i,
    Yo$1({
      class: "cm-foldGutter",
      markers(o3) {
        var a3;
        return ((a3 = o3.plugin(i)) === null || a3 === void 0 ? void 0 : a3.markers) || P$F.empty;
      },
      initialSpacer() {
        return new j$d(e28, false);
      },
      domEventHandlers: Object.assign(Object.assign({}, s3), { click: (o3, a3, l3) => {
        if (s3.click && s3.click(o3, a3, l3))
          return true;
        let c3 = F$k(o3.state, a3.from, a3.to);
        if (c3)
          return o3.dispatch({ effects: B$p.of(c3) }), true;
        let f3 = E$o(o3.state, a3.from, a3.to);
        return f3 ? (o3.dispatch({ effects: L$p.of(f3) }), true) : false;
      } })
    }),
    be$8()
  ];
}
const ct$5 = /* @__PURE__ */ A$m.baseTheme({
  ".cm-foldPlaceholder": {
    backgroundColor: "#eee",
    border: "1px solid #ddd",
    color: "#888",
    borderRadius: ".2em",
    margin: "0 1px",
    padding: "0 1px",
    cursor: "pointer"
  },
  ".cm-foldGutter span": {
    padding: "0 1px",
    cursor: "pointer"
  }
});
class W$d {
  constructor(e28, t3) {
    this.specs = e28;
    let r3;
    function i(a3) {
      let l3 = C$H.newName();
      return (r3 || (r3 = /* @__PURE__ */ Object.create(null)))["." + l3] = a3, l3;
    }
    const s3 = typeof t3.all == "string" ? t3.all : t3.all ? i(t3.all) : void 0, o3 = t3.scope;
    this.scope = o3 instanceof m$1f ? (a3) => a3.prop(T$t) == o3.data : o3 ? (a3) => a3 == o3 : void 0, this.style = U$l(e28.map((a3) => ({
      tag: a3.tag,
      class: a3.class || i(Object.assign({}, a3, { tag: null }))
    })), {
      all: s3
    }).style, this.module = r3 ? new C$H(r3) : null, this.themeType = t3.themeType;
  }
  static define(e28, t3) {
    return new W$d(e28, t3 || {});
  }
}
const J$e = /* @__PURE__ */ A$o.define(), we$8 = /* @__PURE__ */ A$o.define({
  combine(n3) {
    return n3.length ? [n3[0]] : null;
  }
});
function q$g(n3) {
  let e28 = n3.facet(J$e);
  return e28.length ? e28 : n3.facet(we$8);
}
function Ut$4(n3, e28) {
  let t3 = [ht$6], r3;
  return n3 instanceof W$d && (n3.module && t3.push(A$m.styleModule.of(n3.module)), r3 = n3.themeType), e28 != null && e28.fallback ? t3.push(we$8.of(n3)) : r3 ? t3.push(J$e.computeN([A$m.darkTheme], (i) => i.facet(A$m.darkTheme) == (r3 == "dark") ? [n3] : [])) : t3.push(J$e.of(n3)), t3;
}
class ut$4 {
  constructor(e28) {
    this.markCache = /* @__PURE__ */ Object.create(null), this.tree = k$t(e28.state), this.decorations = this.buildDeco(e28, q$g(e28.state));
  }
  update(e28) {
    let t3 = k$t(e28.state), r3 = q$g(e28.state), i = r3 != q$g(e28.startState);
    t3.length < e28.view.viewport.to && !i && t3.type == this.tree.type ? this.decorations = this.decorations.map(e28.changes) : (t3 != this.tree || e28.viewportChanged || i) && (this.tree = t3, this.decorations = this.buildDeco(e28.view, r3));
  }
  buildDeco(e28, t3) {
    if (!t3 || !this.tree.length)
      return V$j.none;
    let r3 = new _$n();
    for (let { from: i, to: s3 } of e28.visibleRanges)
      _$m(this.tree, t3, (o3, a3, l3) => {
        r3.add(o3, a3, this.markCache[l3] || (this.markCache[l3] = V$j.mark({ class: l3 })));
      }, i, s3);
    return r3.finish();
  }
}
const ht$6 = /* @__PURE__ */ lt$8.high(/* @__PURE__ */ z$i.fromClass(ut$4, {
  decorations: (n3) => n3.decorations
})), Rt$4 = /* @__PURE__ */ W$d.define([
  {
    tag: n$J.meta,
    color: "#404740"
  },
  {
    tag: n$J.link,
    textDecoration: "underline"
  },
  {
    tag: n$J.heading,
    textDecoration: "underline",
    fontWeight: "bold"
  },
  {
    tag: n$J.emphasis,
    fontStyle: "italic"
  },
  {
    tag: n$J.strong,
    fontWeight: "bold"
  },
  {
    tag: n$J.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: n$J.keyword,
    color: "#708"
  },
  {
    tag: [n$J.atom, n$J.bool, n$J.url, n$J.contentSeparator, n$J.labelName],
    color: "#219"
  },
  {
    tag: [n$J.literal, n$J.inserted],
    color: "#164"
  },
  {
    tag: [n$J.string, n$J.deleted],
    color: "#a11"
  },
  {
    tag: [n$J.regexp, n$J.escape, /* @__PURE__ */ n$J.special(n$J.string)],
    color: "#e40"
  },
  {
    tag: /* @__PURE__ */ n$J.definition(n$J.variableName),
    color: "#00f"
  },
  {
    tag: /* @__PURE__ */ n$J.local(n$J.variableName),
    color: "#30a"
  },
  {
    tag: [n$J.typeName, n$J.namespace],
    color: "#085"
  },
  {
    tag: n$J.className,
    color: "#167"
  },
  {
    tag: [/* @__PURE__ */ n$J.special(n$J.variableName), n$J.macroName],
    color: "#256"
  },
  {
    tag: /* @__PURE__ */ n$J.definition(n$J.propertyName),
    color: "#00c"
  },
  {
    tag: n$J.comment,
    color: "#940"
  },
  {
    tag: n$J.invalid,
    color: "#f00"
  }
]), dt$6 = /* @__PURE__ */ A$m.baseTheme({
  "&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" },
  "&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" }
}), ve$6 = 1e4, xe$8 = "()[]{}", Se$5 = /* @__PURE__ */ A$o.define({
  combine(n3) {
    return ht$7(n3, {
      afterCursor: true,
      brackets: xe$8,
      maxScanDistance: ve$6,
      renderMatch: gt$6
    });
  }
}), pt$6 = /* @__PURE__ */ V$j.mark({ class: "cm-matchingBracket" }), mt$6 = /* @__PURE__ */ V$j.mark({ class: "cm-nonmatchingBracket" });
function gt$6(n3) {
  let e28 = [], t3 = n3.matched ? pt$6 : mt$6;
  return e28.push(t3.range(n3.start.from, n3.start.to)), n3.end && e28.push(t3.range(n3.end.from, n3.end.to)), e28;
}
const kt$5 = /* @__PURE__ */ L$s.define({
  create() {
    return V$j.none;
  },
  update(n3, e28) {
    if (!e28.docChanged && !e28.selection)
      return n3;
    let t3 = [], r3 = e28.state.facet(Se$5);
    for (let i of e28.state.selection.ranges) {
      if (!i.empty)
        continue;
      let s3 = I$r(e28.state, i.head, -1, r3) || i.head > 0 && I$r(e28.state, i.head - 1, 1, r3) || r3.afterCursor && (I$r(e28.state, i.head, 1, r3) || i.head < e28.state.doc.length && I$r(e28.state, i.head + 1, -1, r3));
      s3 && (t3 = t3.concat(r3.renderMatch(s3, e28.state)));
    }
    return V$j.set(t3, true);
  },
  provide: (n3) => A$m.decorations.from(n3)
}), bt$4 = [
  kt$5,
  dt$6
];
function $t$6(n3 = {}) {
  return [Se$5.of(n3), bt$4];
}
const yt$6 = /* @__PURE__ */ new C$G();
function V$i(n3, e28, t3) {
  let r3 = n3.prop(e28 < 0 ? C$G.openedBy : C$G.closedBy);
  if (r3)
    return r3;
  if (n3.name.length == 1) {
    let i = t3.indexOf(n3.name);
    if (i > -1 && i % 2 == (e28 < 0 ? 1 : 0))
      return [t3[i + e28]];
  }
  return null;
}
function K$e(n3) {
  let e28 = n3.type.prop(yt$6);
  return e28 ? e28(n3.node) : n3;
}
function I$r(n3, e28, t3, r3 = {}) {
  let i = r3.maxScanDistance || ve$6, s3 = r3.brackets || xe$8, o3 = k$t(n3), a3 = o3.resolveInner(e28, t3);
  for (let l3 = a3; l3; l3 = l3.parent) {
    let c3 = V$i(l3.type, t3, s3);
    if (c3 && l3.from < l3.to) {
      let f3 = K$e(l3);
      if (f3 && (t3 > 0 ? e28 >= f3.from && e28 < f3.to : e28 > f3.from && e28 <= f3.to))
        return wt$6(n3, e28, t3, l3, f3, c3, s3);
    }
  }
  return vt$4(n3, e28, t3, o3, a3.type, i, s3);
}
function wt$6(n3, e28, t3, r3, i, s3, o3) {
  let a3 = r3.parent, l3 = { from: i.from, to: i.to }, c3 = 0, f3 = a3 == null ? void 0 : a3.cursor();
  if (f3 && (t3 < 0 ? f3.childBefore(r3.from) : f3.childAfter(r3.to)))
    do
      if (t3 < 0 ? f3.to <= r3.from : f3.from >= r3.to) {
        if (c3 == 0 && s3.indexOf(f3.type.name) > -1 && f3.from < f3.to) {
          let h3 = K$e(f3);
          return { start: l3, end: h3 ? { from: h3.from, to: h3.to } : void 0, matched: true };
        } else if (V$i(f3.type, t3, o3))
          c3++;
        else if (V$i(f3.type, -t3, o3)) {
          if (c3 == 0) {
            let h3 = K$e(f3);
            return {
              start: l3,
              end: h3 && h3.from < h3.to ? { from: h3.from, to: h3.to } : void 0,
              matched: false
            };
          }
          c3--;
        }
      }
    while (t3 < 0 ? f3.prevSibling() : f3.nextSibling());
  return { start: l3, matched: false };
}
function vt$4(n3, e28, t3, r3, i, s3, o3) {
  let a3 = t3 < 0 ? n3.sliceDoc(e28 - 1, e28) : n3.sliceDoc(e28, e28 + 1), l3 = o3.indexOf(a3);
  if (l3 < 0 || l3 % 2 == 0 != t3 > 0)
    return null;
  let c3 = { from: t3 < 0 ? e28 - 1 : e28, to: t3 > 0 ? e28 + 1 : e28 }, f3 = n3.doc.iterRange(e28, t3 > 0 ? n3.doc.length : 0), h3 = 0;
  for (let p3 = 0; !f3.next().done && p3 <= s3; ) {
    let d3 = f3.value;
    t3 < 0 && (p3 += d3.length);
    let S3 = e28 + p3 * t3;
    for (let C3 = t3 > 0 ? 0 : d3.length - 1, Ce2 = t3 > 0 ? d3.length : -1; C3 != Ce2; C3 += t3) {
      let U3 = o3.indexOf(d3[C3]);
      if (!(U3 < 0 || r3.resolveInner(S3 + C3, 1).type != i))
        if (U3 % 2 == 0 == t3 > 0)
          h3++;
        else {
          if (h3 == 1)
            return { start: c3, end: { from: S3 + C3, to: S3 + C3 + 1 }, matched: U3 >> 1 == l3 >> 1 };
          h3--;
        }
    }
    t3 > 0 && (p3 += d3.length);
  }
  return f3.done ? { start: c3, matched: false } : null;
}
const xt$5 = /* @__PURE__ */ Object.create(null), ie$9 = [T$v.none], oe$a = [], St$5 = /* @__PURE__ */ Object.create(null);
for (let [n3, e28] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  St$5[n3] = /* @__PURE__ */ Ct$5(xt$5, e28);
function z$f(n3, e28) {
  oe$a.indexOf(n3) > -1 || (oe$a.push(n3), console.warn(e28));
}
function Ct$5(n3, e28) {
  let t3 = [];
  for (let s3 of e28.split(" ")) {
    let o3 = [];
    for (let a3 of s3.split(".")) {
      let l3 = n3[a3] || n$J[a3];
      l3 ? typeof l3 == "function" ? o3.length ? o3 = o3.map(l3) : z$f(a3, `Modifier ${a3} used at start of tag`) : o3.length ? z$f(a3, `Tag ${a3} used as modifier`) : o3 = Array.isArray(l3) ? l3 : [l3] : z$f(a3, `Unknown highlighting tag ${a3}`);
    }
    for (let a3 of o3)
      t3.push(a3);
  }
  if (!t3.length)
    return 0;
  let r3 = e28.replace(/ /g, "_"), i = T$v.define({
    id: ie$9.length,
    name: r3,
    props: [$$d({ [r3]: t3 })]
  });
  return ie$9.push(i), i.id;
}
const We$4 = (e28) => {
  let { state: t3 } = e28, r3 = t3.doc.lineAt(t3.selection.main.from), n3 = _$k(e28.state, r3.from);
  return n3.line ? _e$6(e28) : n3.block ? Xe$5(e28) : false;
};
function W$c(e28, t3) {
  return ({ state: r3, dispatch: n3 }) => {
    if (r3.readOnly)
      return false;
    let l3 = e28(t3, r3);
    return l3 ? (n3(r3.update(l3)), true) : false;
  };
}
const _e$6 = /* @__PURE__ */ W$c(je$3, 0), Qe$4 = /* @__PURE__ */ W$c(se$a, 0), Xe$5 = /* @__PURE__ */ W$c((e28, t3) => se$a(e28, t3, Ze$2(t3)), 0);
function _$k(e28, t3) {
  let r3 = e28.languageDataAt("commentTokens", t3);
  return r3.length ? r3[0] : {};
}
const M$g = 50;
function Ye$3(e28, { open: t3, close: r3 }, n3, l3) {
  let o3 = e28.sliceDoc(n3 - M$g, n3), c3 = e28.sliceDoc(l3, l3 + M$g), i = /\s*$/.exec(o3)[0].length, s3 = /^\s*/.exec(c3)[0].length, f3 = o3.length - i;
  if (o3.slice(f3 - t3.length, f3) == t3 && c3.slice(s3, s3 + r3.length) == r3)
    return {
      open: { pos: n3 - i, margin: i && 1 },
      close: { pos: l3 + s3, margin: s3 && 1 }
    };
  let u3, a3;
  l3 - n3 <= 2 * M$g ? u3 = a3 = e28.sliceDoc(n3, l3) : (u3 = e28.sliceDoc(n3, n3 + M$g), a3 = e28.sliceDoc(l3 - M$g, l3));
  let p3 = /^\s*/.exec(u3)[0].length, O3 = /\s*$/.exec(a3)[0].length, C3 = a3.length - O3 - r3.length;
  return u3.slice(p3, p3 + t3.length) == t3 && a3.slice(C3, C3 + r3.length) == r3 ? {
    open: {
      pos: n3 + p3 + t3.length,
      margin: /\s/.test(u3.charAt(p3 + t3.length)) ? 1 : 0
    },
    close: {
      pos: l3 - O3 - r3.length,
      margin: /\s/.test(a3.charAt(C3 - 1)) ? 1 : 0
    }
  } : null;
}
function Ze$2(e28) {
  let t3 = [];
  for (let r3 of e28.selection.ranges) {
    let n3 = e28.doc.lineAt(r3.from), l3 = r3.to <= n3.to ? n3 : e28.doc.lineAt(r3.to), o3 = t3.length - 1;
    o3 >= 0 && t3[o3].to > n3.from ? t3[o3].to = l3.to : t3.push({ from: n3.from + /^\s*/.exec(n3.text)[0].length, to: l3.to });
  }
  return t3;
}
function se$a(e28, t3, r3 = t3.selection.ranges) {
  let n3 = r3.map((o3) => _$k(t3, o3.from).block);
  if (!n3.every((o3) => o3))
    return null;
  let l3 = r3.map((o3, c3) => Ye$3(t3, n3[c3], o3.from, o3.to));
  if (e28 != 2 && !l3.every((o3) => o3))
    return { changes: t3.changes(r3.map((o3, c3) => l3[c3] ? [] : [{ from: o3.from, insert: n3[c3].open + " " }, { from: o3.to, insert: " " + n3[c3].close }])) };
  if (e28 != 1 && l3.some((o3) => o3)) {
    let o3 = [];
    for (let c3 = 0, i; c3 < l3.length; c3++)
      if (i = l3[c3]) {
        let s3 = n3[c3], { open: f3, close: u3 } = i;
        o3.push({ from: f3.pos - s3.open.length, to: f3.pos + f3.margin }, { from: u3.pos - u3.margin, to: u3.pos + s3.close.length });
      }
    return { changes: o3 };
  }
  return null;
}
function je$3(e28, t3, r3 = t3.selection.ranges) {
  let n3 = [], l3 = -1;
  for (let { from: o3, to: c3 } of r3) {
    let i = n3.length, s3 = 1e9, f3 = _$k(t3, o3).line;
    if (f3) {
      for (let u3 = o3; u3 <= c3; ) {
        let a3 = t3.doc.lineAt(u3);
        if (a3.from > l3 && (o3 == c3 || c3 > a3.from)) {
          l3 = a3.from;
          let p3 = /^\s*/.exec(a3.text)[0].length, O3 = p3 == a3.length, C3 = a3.text.slice(p3, p3 + f3.length) == f3 ? p3 : -1;
          p3 < a3.text.length && p3 < s3 && (s3 = p3), n3.push({ line: a3, comment: C3, token: f3, indent: p3, empty: O3, single: false });
        }
        u3 = a3.to + 1;
      }
      if (s3 < 1e9)
        for (let u3 = i; u3 < n3.length; u3++)
          n3[u3].indent < n3[u3].line.text.length && (n3[u3].indent = s3);
      n3.length == i + 1 && (n3[i].single = true);
    }
  }
  if (e28 != 2 && n3.some((o3) => o3.comment < 0 && (!o3.empty || o3.single))) {
    let o3 = [];
    for (let { line: i, token: s3, indent: f3, empty: u3, single: a3 } of n3)
      (a3 || !u3) && o3.push({ from: i.from + f3, insert: s3 + " " });
    let c3 = t3.changes(o3);
    return { changes: c3, selection: t3.selection.map(c3, 1) };
  } else if (e28 != 1 && n3.some((o3) => o3.comment >= 0)) {
    let o3 = [];
    for (let { line: c3, comment: i, token: s3 } of n3)
      if (i >= 0) {
        let f3 = c3.from + i, u3 = f3 + s3.length;
        c3.text[u3 - c3.from] == " " && u3++, o3.push({ from: f3, to: u3 });
      }
    return { changes: o3 };
  }
  return null;
}
const F$j = /* @__PURE__ */ U$n.define(), et$3 = /* @__PURE__ */ U$n.define(), tt$2 = /* @__PURE__ */ A$o.define(), ue$8 = /* @__PURE__ */ A$o.define({
  combine(e28) {
    return ht$7(e28, {
      minDepth: 100,
      newGroupDelay: 500,
      joinToEvent: (t3, r3) => r3
    }, {
      minDepth: Math.max,
      newGroupDelay: Math.min,
      joinToEvent: (t3, r3) => (n3, l3) => t3(n3, l3) || r3(n3, l3)
    });
  }
});
function nt$3(e28) {
  let t3 = 0;
  return e28.iterChangedRanges((r3, n3) => t3 = n3), t3;
}
const fe$7 = /* @__PURE__ */ L$s.define({
  create() {
    return A$k.empty;
  },
  update(e28, t3) {
    let r3 = t3.state.facet(ue$8), n3 = t3.annotation(F$j);
    if (n3) {
      let s3 = t3.docChanged ? g$K.single(nt$3(t3.changes)) : void 0, f3 = m$1e.fromTransaction(t3, s3), u3 = n3.side, a3 = u3 == 0 ? e28.undone : e28.done;
      return f3 ? a3 = v$E(a3, a3.length, r3.minDepth, f3) : a3 = de$9(a3, t3.startState.selection), new A$k(u3 == 0 ? n3.rest : a3, u3 == 0 ? a3 : n3.rest);
    }
    let l3 = t3.annotation(et$3);
    if ((l3 == "full" || l3 == "before") && (e28 = e28.isolate()), t3.annotation(I$u.addToHistory) === false)
      return t3.changes.empty ? e28 : e28.addMapping(t3.changes.desc);
    let o3 = m$1e.fromTransaction(t3), c3 = t3.annotation(I$u.time), i = t3.annotation(I$u.userEvent);
    return o3 ? e28 = e28.addChanges(o3, c3, i, r3, t3) : t3.selection && (e28 = e28.addSelection(t3.startState.selection, c3, i, r3.newGroupDelay)), (l3 == "full" || l3 == "after") && (e28 = e28.isolate()), e28;
  },
  toJSON(e28) {
    return { done: e28.done.map((t3) => t3.toJSON()), undone: e28.undone.map((t3) => t3.toJSON()) };
  },
  fromJSON(e28) {
    return new A$k(e28.done.map(m$1e.fromJSON), e28.undone.map(m$1e.fromJSON));
  }
});
function ln$2(e28 = {}) {
  return [
    fe$7,
    ue$8.of(e28),
    A$m.domEventHandlers({
      beforeinput(t3, r3) {
        let n3 = t3.inputType == "historyUndo" ? ae$a : t3.inputType == "historyRedo" ? H$g : null;
        return n3 ? (t3.preventDefault(), n3(r3)) : false;
      }
    })
  ];
}
function I$q(e28, t3) {
  return function({ state: r3, dispatch: n3 }) {
    if (!t3 && r3.readOnly)
      return false;
    let l3 = r3.field(fe$7, false);
    if (!l3)
      return false;
    let o3 = l3.pop(e28, r3, t3);
    return o3 ? (n3(o3), true) : false;
  };
}
const ae$a = /* @__PURE__ */ I$q(0, false), H$g = /* @__PURE__ */ I$q(1, false), rt$4 = /* @__PURE__ */ I$q(0, true), ot$3 = /* @__PURE__ */ I$q(1, true);
class m$1e {
  constructor(t3, r3, n3, l3, o3) {
    this.changes = t3, this.effects = r3, this.mapped = n3, this.startSelection = l3, this.selectionsAfter = o3;
  }
  setSelAfter(t3) {
    return new m$1e(this.changes, this.effects, this.mapped, this.startSelection, t3);
  }
  toJSON() {
    var t3, r3, n3;
    return {
      changes: (t3 = this.changes) === null || t3 === void 0 ? void 0 : t3.toJSON(),
      mapped: (r3 = this.mapped) === null || r3 === void 0 ? void 0 : r3.toJSON(),
      startSelection: (n3 = this.startSelection) === null || n3 === void 0 ? void 0 : n3.toJSON(),
      selectionsAfter: this.selectionsAfter.map((l3) => l3.toJSON())
    };
  }
  static fromJSON(t3) {
    return new m$1e(t3.changes && k$w.fromJSON(t3.changes), [], t3.mapped && E$p.fromJSON(t3.mapped), t3.startSelection && g$K.fromJSON(t3.startSelection), t3.selectionsAfter.map(g$K.fromJSON));
  }
  static fromTransaction(t3, r3) {
    let n3 = g$H;
    for (let l3 of t3.startState.facet(tt$2)) {
      let o3 = l3(t3);
      o3.length && (n3 = n3.concat(o3));
    }
    return !n3.length && t3.changes.empty ? null : new m$1e(t3.changes.invert(t3.startState.doc), n3, void 0, r3 || t3.startState.selection, g$H);
  }
  static selection(t3) {
    return new m$1e(void 0, g$H, void 0, void 0, t3);
  }
}
function v$E(e28, t3, r3, n3) {
  let l3 = t3 + 1 > r3 + 20 ? t3 - r3 - 1 : 0, o3 = e28.slice(l3, t3);
  return o3.push(n3), o3;
}
function lt$5(e28, t3) {
  let r3 = [], n3 = false;
  return e28.iterChangedRanges((l3, o3) => r3.push(l3, o3)), t3.iterChangedRanges((l3, o3, c3, i) => {
    for (let s3 = 0; s3 < r3.length; ) {
      let f3 = r3[s3++], u3 = r3[s3++];
      i >= f3 && c3 <= u3 && (n3 = true);
    }
  }), n3;
}
function ct$4(e28, t3) {
  return e28.ranges.length == t3.ranges.length && e28.ranges.filter((r3, n3) => r3.empty != t3.ranges[n3].empty).length === 0;
}
function he$9(e28, t3) {
  return e28.length ? t3.length ? e28.concat(t3) : e28 : t3;
}
const g$H = [], it$3 = 200;
function de$9(e28, t3) {
  if (e28.length) {
    let r3 = e28[e28.length - 1], n3 = r3.selectionsAfter.slice(Math.max(0, r3.selectionsAfter.length - it$3));
    return n3.length && n3[n3.length - 1].eq(t3) ? e28 : (n3.push(t3), v$E(e28, e28.length - 1, 1e9, r3.setSelAfter(n3)));
  } else
    return [m$1e.selection([t3])];
}
function st$4(e28) {
  let t3 = e28[e28.length - 1], r3 = e28.slice();
  return r3[e28.length - 1] = t3.setSelAfter(t3.selectionsAfter.slice(0, t3.selectionsAfter.length - 1)), r3;
}
function J$d(e28, t3) {
  if (!e28.length)
    return e28;
  let r3 = e28.length, n3 = g$H;
  for (; r3; ) {
    let l3 = ut$3(e28[r3 - 1], t3, n3);
    if (l3.changes && !l3.changes.empty || l3.effects.length) {
      let o3 = e28.slice(0, r3);
      return o3[r3 - 1] = l3, o3;
    } else
      t3 = l3.mapped, r3--, n3 = l3.selectionsAfter;
  }
  return n3.length ? [m$1e.selection(n3)] : g$H;
}
function ut$3(e28, t3, r3) {
  let n3 = he$9(e28.selectionsAfter.length ? e28.selectionsAfter.map((i) => i.map(t3)) : g$H, r3);
  if (!e28.changes)
    return m$1e.selection(n3);
  let l3 = e28.changes.map(t3), o3 = t3.mapDesc(e28.changes, true), c3 = e28.mapped ? e28.mapped.composeDesc(o3) : o3;
  return new m$1e(l3, S$m.mapEffects(e28.effects, t3), c3, e28.startSelection.map(o3), n3);
}
const ft$3 = /^(input\.type|delete)($|\.)/;
class A$k {
  constructor(t3, r3, n3 = 0, l3 = void 0) {
    this.done = t3, this.undone = r3, this.prevTime = n3, this.prevUserEvent = l3;
  }
  isolate() {
    return this.prevTime ? new A$k(this.done, this.undone) : this;
  }
  addChanges(t3, r3, n3, l3, o3) {
    let c3 = this.done, i = c3[c3.length - 1];
    return i && i.changes && !i.changes.empty && t3.changes && (!n3 || ft$3.test(n3)) && (!i.selectionsAfter.length && r3 - this.prevTime < l3.newGroupDelay && l3.joinToEvent(o3, lt$5(i.changes, t3.changes)) || n3 == "input.type.compose") ? c3 = v$E(c3, c3.length - 1, l3.minDepth, new m$1e(t3.changes.compose(i.changes), he$9(t3.effects, i.effects), i.mapped, i.startSelection, g$H)) : c3 = v$E(c3, c3.length, l3.minDepth, t3), new A$k(c3, g$H, r3, n3);
  }
  addSelection(t3, r3, n3, l3) {
    let o3 = this.done.length ? this.done[this.done.length - 1].selectionsAfter : g$H;
    return o3.length > 0 && r3 - this.prevTime < l3 && n3 == this.prevUserEvent && n3 && /^select($|\.)/.test(n3) && ct$4(o3[o3.length - 1], t3) ? this : new A$k(de$9(this.done, t3), this.undone, r3, n3);
  }
  addMapping(t3) {
    return new A$k(J$d(this.done, t3), J$d(this.undone, t3), this.prevTime, this.prevUserEvent);
  }
  pop(t3, r3, n3) {
    let l3 = t3 == 0 ? this.done : this.undone;
    if (l3.length == 0)
      return null;
    let o3 = l3[l3.length - 1];
    if (n3 && o3.selectionsAfter.length)
      return r3.update({
        selection: o3.selectionsAfter[o3.selectionsAfter.length - 1],
        annotations: F$j.of({ side: t3, rest: st$4(l3) }),
        userEvent: t3 == 0 ? "select.undo" : "select.redo",
        scrollIntoView: true
      });
    if (o3.changes) {
      let c3 = l3.length == 1 ? g$H : l3.slice(0, l3.length - 1);
      return o3.mapped && (c3 = J$d(c3, o3.mapped)), r3.update({
        changes: o3.changes,
        selection: o3.startSelection,
        effects: o3.effects,
        annotations: F$j.of({ side: t3, rest: c3 }),
        filter: false,
        userEvent: t3 == 0 ? "undo" : "redo",
        scrollIntoView: true
      });
    } else
      return null;
  }
}
A$k.empty = /* @__PURE__ */ new A$k(g$H, g$H);
const cn$1 = [
  { key: "Mod-z", run: ae$a, preventDefault: true },
  { key: "Mod-y", mac: "Mod-Shift-z", run: H$g, preventDefault: true },
  { linux: "Ctrl-Shift-z", run: H$g, preventDefault: true },
  { key: "Mod-u", run: rt$4, preventDefault: true },
  { key: "Alt-u", mac: "Mod-Shift-u", run: ot$3, preventDefault: true }
];
function L$o(e28, t3) {
  return g$K.create(e28.ranges.map(t3), e28.mainIndex);
}
function B$o(e28, t3) {
  return e28.update({ selection: t3, scrollIntoView: true, userEvent: "select" });
}
function k$s({ state: e28, dispatch: t3 }, r3) {
  let n3 = L$o(e28.selection, r3);
  return n3.eq(e28.selection) ? false : (t3(B$o(e28, n3)), true);
}
function N$u(e28, t3) {
  return g$K.cursor(t3 ? e28.to : e28.from);
}
function me$9(e28, t3) {
  return k$s(e28, (r3) => r3.empty ? e28.moveByChar(r3, t3) : N$u(r3, t3));
}
function d$13(e28) {
  return e28.textDirectionAt(e28.state.selection.main.head) == L$r.LTR;
}
const pe$8 = (e28) => me$9(e28, !d$13(e28)), ge$7 = (e28) => me$9(e28, d$13(e28));
function ye$7(e28, t3) {
  return k$s(e28, (r3) => r3.empty ? e28.moveByGroup(r3, t3) : N$u(r3, t3));
}
const at$3 = (e28) => ye$7(e28, !d$13(e28)), ht$5 = (e28) => ye$7(e28, d$13(e28));
function dt$5(e28, t3, r3) {
  if (t3.type.prop(r3))
    return true;
  let n3 = t3.to - t3.from;
  return n3 && (n3 > 2 || /[^\s,.;:]/.test(e28.sliceDoc(t3.from, t3.to))) || t3.firstChild;
}
function U$k(e28, t3, r3) {
  let n3 = k$t(e28).resolveInner(t3.head), l3 = r3 ? C$G.closedBy : C$G.openedBy;
  for (let s3 = t3.head; ; ) {
    let f3 = r3 ? n3.childAfter(s3) : n3.childBefore(s3);
    if (!f3)
      break;
    dt$5(e28, f3, l3) ? n3 = f3 : s3 = r3 ? f3.to : f3.from;
  }
  let o3 = n3.type.prop(l3), c3, i;
  return o3 && (c3 = r3 ? I$r(e28, n3.from, 1) : I$r(e28, n3.to, -1)) && c3.matched ? i = r3 ? c3.end.to : c3.end.from : i = r3 ? n3.to : n3.from, g$K.cursor(i, r3 ? -1 : 1);
}
const mt$5 = (e28) => k$s(e28, (t3) => U$k(e28.state, t3, !d$13(e28))), pt$5 = (e28) => k$s(e28, (t3) => U$k(e28.state, t3, d$13(e28)));
function ke$6(e28, t3) {
  return k$s(e28, (r3) => {
    if (!r3.empty)
      return N$u(r3, t3);
    let n3 = e28.moveVertically(r3, t3);
    return n3.head != r3.head ? n3 : e28.moveToLineBoundary(r3, t3);
  });
}
const Ae$4 = (e28) => ke$6(e28, false), Be$4 = (e28) => ke$6(e28, true);
function Se$4(e28) {
  let t3 = e28.scrollDOM.clientHeight < e28.scrollDOM.scrollHeight - 2, r3 = 0, n3 = 0, l3;
  if (t3) {
    for (let o3 of e28.state.facet(A$m.scrollMargins)) {
      let c3 = o3(e28);
      c3 != null && c3.top && (r3 = Math.max(c3 == null ? void 0 : c3.top, r3)), c3 != null && c3.bottom && (n3 = Math.max(c3 == null ? void 0 : c3.bottom, n3));
    }
    l3 = e28.scrollDOM.clientHeight - r3 - n3;
  } else
    l3 = (e28.dom.ownerDocument.defaultView || window).innerHeight;
  return {
    marginTop: r3,
    marginBottom: n3,
    selfScroll: t3,
    height: Math.max(e28.defaultLineHeight, l3 - 5)
  };
}
function xe$7(e28, t3) {
  let r3 = Se$4(e28), { state: n3 } = e28, l3 = L$o(n3.selection, (c3) => c3.empty ? e28.moveVertically(c3, t3, r3.height) : N$u(c3, t3));
  if (l3.eq(n3.selection))
    return false;
  let o3;
  if (r3.selfScroll) {
    let c3 = e28.coordsAtPos(n3.selection.main.head), i = e28.scrollDOM.getBoundingClientRect(), s3 = i.top + r3.marginTop, f3 = i.bottom - r3.marginBottom;
    c3 && c3.top > s3 && c3.bottom < f3 && (o3 = A$m.scrollIntoView(l3.main.head, { y: "start", yMargin: c3.top - s3 }));
  }
  return e28.dispatch(B$o(n3, l3), { effects: o3 }), true;
}
const X$d = (e28) => xe$7(e28, false), q$f = (e28) => xe$7(e28, true);
function S$j(e28, t3, r3) {
  let n3 = e28.lineBlockAt(t3.head), l3 = e28.moveToLineBoundary(t3, r3);
  if (l3.head == t3.head && l3.head != (r3 ? n3.to : n3.from) && (l3 = e28.moveToLineBoundary(t3, r3, false)), !r3 && l3.head == n3.from && n3.length) {
    let o3 = /^\s*/.exec(e28.state.sliceDoc(n3.from, Math.min(n3.from + 100, n3.to)))[0].length;
    o3 && t3.head != n3.from + o3 && (l3 = g$K.cursor(n3.from + o3));
  }
  return l3;
}
const gt$5 = (e28) => k$s(e28, (t3) => S$j(e28, t3, true)), yt$5 = (e28) => k$s(e28, (t3) => S$j(e28, t3, false)), kt$4 = (e28) => k$s(e28, (t3) => S$j(e28, t3, !d$13(e28))), At$5 = (e28) => k$s(e28, (t3) => S$j(e28, t3, d$13(e28))), Bt$3 = (e28) => k$s(e28, (t3) => g$K.cursor(e28.lineBlockAt(t3.head).from, 1)), St$4 = (e28) => k$s(e28, (t3) => g$K.cursor(e28.lineBlockAt(t3.head).to, -1));
function xt$4(e28, t3, r3) {
  let n3 = false, l3 = L$o(e28.selection, (o3) => {
    let c3 = I$r(e28, o3.head, -1) || I$r(e28, o3.head, 1) || o3.head > 0 && I$r(e28, o3.head - 1, 1) || o3.head < e28.doc.length && I$r(e28, o3.head + 1, -1);
    if (!c3 || !c3.end)
      return o3;
    n3 = true;
    let i = c3.start.from == o3.head ? c3.end.to : c3.end.from;
    return r3 ? g$K.range(o3.anchor, i) : g$K.cursor(i);
  });
  return n3 ? (t3(B$o(e28, l3)), true) : false;
}
const Dt$3 = ({ state: e28, dispatch: t3 }) => xt$4(e28, t3, false);
function y$x(e28, t3) {
  let r3 = L$o(e28.state.selection, (n3) => {
    let l3 = t3(n3);
    return g$K.range(n3.anchor, l3.head, l3.goalColumn, l3.bidiLevel || void 0);
  });
  return r3.eq(e28.state.selection) ? false : (e28.dispatch(B$o(e28.state, r3)), true);
}
function De$2(e28, t3) {
  return y$x(e28, (r3) => e28.moveByChar(r3, t3));
}
const Le$2 = (e28) => De$2(e28, !d$13(e28)), Ce$6 = (e28) => De$2(e28, d$13(e28));
function Me$3(e28, t3) {
  return y$x(e28, (r3) => e28.moveByGroup(r3, t3));
}
const Lt$2 = (e28) => Me$3(e28, !d$13(e28)), Ct$4 = (e28) => Me$3(e28, d$13(e28)), Mt$3 = (e28) => y$x(e28, (t3) => U$k(e28.state, t3, !d$13(e28))), Et$4 = (e28) => y$x(e28, (t3) => U$k(e28.state, t3, d$13(e28)));
function Ee$4(e28, t3) {
  return y$x(e28, (r3) => e28.moveVertically(r3, t3));
}
const Oe$5 = (e28) => Ee$4(e28, false), Te$6 = (e28) => Ee$4(e28, true);
function Re$7(e28, t3) {
  return y$x(e28, (r3) => e28.moveVertically(r3, t3, Se$4(e28).height));
}
const Y$d = (e28) => Re$7(e28, false), Z$e = (e28) => Re$7(e28, true), Ot$4 = (e28) => y$x(e28, (t3) => S$j(e28, t3, true)), Tt$4 = (e28) => y$x(e28, (t3) => S$j(e28, t3, false)), Rt$3 = (e28) => y$x(e28, (t3) => S$j(e28, t3, !d$13(e28))), bt$3 = (e28) => y$x(e28, (t3) => S$j(e28, t3, d$13(e28))), vt$3 = (e28) => y$x(e28, (t3) => g$K.cursor(e28.lineBlockAt(t3.head).from)), It$4 = (e28) => y$x(e28, (t3) => g$K.cursor(e28.lineBlockAt(t3.head).to)), j$c = ({ state: e28, dispatch: t3 }) => (t3(B$o(e28, { anchor: 0 })), true), ee$9 = ({ state: e28, dispatch: t3 }) => (t3(B$o(e28, { anchor: e28.doc.length })), true), te$9 = ({ state: e28, dispatch: t3 }) => (t3(B$o(e28, { anchor: e28.selection.main.anchor, head: 0 })), true), ne$b = ({ state: e28, dispatch: t3 }) => (t3(B$o(e28, { anchor: e28.selection.main.anchor, head: e28.doc.length })), true), Nt$2 = ({ state: e28, dispatch: t3 }) => (t3(e28.update({ selection: { anchor: 0, head: e28.doc.length }, userEvent: "select" })), true), Ut$3 = ({ state: e28, dispatch: t3 }) => {
  let r3 = P$A(e28).map(({ from: n3, to: l3 }) => g$K.range(n3, Math.min(l3 + 1, e28.doc.length)));
  return t3(e28.update({ selection: g$K.create(r3), userEvent: "select" })), true;
}, Pt$3 = ({ state: e28, dispatch: t3 }) => {
  let r3 = L$o(e28.selection, (n3) => {
    var l3;
    let o3 = k$t(e28).resolveStack(n3.from, 1);
    for (let c3 = o3; c3; c3 = c3.next) {
      let { node: i } = c3;
      if ((i.from < n3.from && i.to >= n3.to || i.to > n3.to && i.from <= n3.from) && (!((l3 = i.parent) === null || l3 === void 0) && l3.parent))
        return g$K.range(i.to, i.from);
    }
    return n3;
  });
  return t3(B$o(e28, r3)), true;
}, Vt$2 = ({ state: e28, dispatch: t3 }) => {
  let r3 = e28.selection, n3 = null;
  return r3.ranges.length > 1 ? n3 = g$K.create([r3.main]) : r3.main.empty || (n3 = g$K.create([g$K.cursor(r3.main.head)])), n3 ? (t3(B$o(e28, n3)), true) : false;
};
function E$n(e28, t3) {
  if (e28.state.readOnly)
    return false;
  let r3 = "delete.selection", { state: n3 } = e28, l3 = n3.changeByRange((o3) => {
    let { from: c3, to: i } = o3;
    if (c3 == i) {
      let s3 = t3(o3);
      s3 < c3 ? (r3 = "delete.backward", s3 = T$s(e28, s3, false)) : s3 > c3 && (r3 = "delete.forward", s3 = T$s(e28, s3, true)), c3 = Math.min(c3, s3), i = Math.max(i, s3);
    } else
      c3 = T$s(e28, c3, false), i = T$s(e28, i, true);
    return c3 == i ? { range: o3 } : { changes: { from: c3, to: i }, range: g$K.cursor(c3, c3 < o3.head ? -1 : 1) };
  });
  return l3.changes.empty ? false : (e28.dispatch(n3.update(l3, {
    scrollIntoView: true,
    userEvent: r3,
    effects: r3 == "delete.selection" ? A$m.announce.of(n3.phrase("Selection deleted")) : void 0
  })), true);
}
function T$s(e28, t3, r3) {
  if (e28 instanceof A$m)
    for (let n3 of e28.state.facet(A$m.atomicRanges).map((l3) => l3(e28)))
      n3.between(t3, t3, (l3, o3) => {
        l3 < t3 && o3 > t3 && (t3 = r3 ? o3 : l3);
      });
  return t3;
}
const be$7 = (e28, t3) => E$n(e28, (r3) => {
  let n3 = r3.from, { state: l3 } = e28, o3 = l3.doc.lineAt(n3), c3, i;
  if (!t3 && n3 > o3.from && n3 < o3.from + 200 && !/[^ \t]/.test(c3 = o3.text.slice(0, n3 - o3.from))) {
    if (c3[c3.length - 1] == "	")
      return n3 - 1;
    let s3 = ot$6(c3, l3.tabSize), f3 = s3 % $e$3(l3) || $e$3(l3);
    for (let u3 = 0; u3 < f3 && c3[c3.length - 1 - u3] == " "; u3++)
      n3--;
    i = n3;
  } else
    i = K$h(o3.text, n3 - o3.from, t3, t3) + o3.from, i == n3 && o3.number != (t3 ? l3.doc.lines : 1) && (i += t3 ? 1 : -1);
  return i;
}), K$d = (e28) => be$7(e28, false), ve$5 = (e28) => be$7(e28, true), Ie$4 = (e28, t3) => E$n(e28, (r3) => {
  let n3 = r3.head, { state: l3 } = e28, o3 = l3.doc.lineAt(n3), c3 = l3.charCategorizer(n3);
  for (let i = null; ; ) {
    if (n3 == (t3 ? o3.to : o3.from)) {
      n3 == r3.head && o3.number != (t3 ? l3.doc.lines : 1) && (n3 += t3 ? 1 : -1);
      break;
    }
    let s3 = K$h(o3.text, n3 - o3.from, t3) + o3.from, f3 = o3.text.slice(Math.min(n3, s3) - o3.from, Math.max(n3, s3) - o3.from), u3 = c3(f3);
    if (i != null && u3 != i)
      break;
    (f3 != " " || n3 != r3.head) && (i = u3), n3 = s3;
  }
  return n3;
}), Ne$3 = (e28) => Ie$4(e28, false), Jt$2 = (e28) => Ie$4(e28, true), Gt$4 = (e28) => E$n(e28, (t3) => {
  let r3 = e28.lineBlockAt(t3.head).to;
  return t3.head < r3 ? r3 : Math.min(e28.state.doc.length, t3.head + 1);
}), zt$2 = (e28) => E$n(e28, (t3) => {
  let r3 = e28.moveToLineBoundary(t3, false).head;
  return t3.head > r3 ? r3 : Math.max(0, t3.head - 1);
}), Ft$3 = (e28) => E$n(e28, (t3) => {
  let r3 = e28.moveToLineBoundary(t3, true).head;
  return t3.head < r3 ? r3 : Math.min(e28.state.doc.length, t3.head + 1);
}), Ht$2 = ({ state: e28, dispatch: t3 }) => {
  if (e28.readOnly)
    return false;
  let r3 = e28.changeByRange((n3) => ({
    changes: { from: n3.from, to: n3.to, insert: x$l.of(["", ""]) },
    range: g$K.cursor(n3.from)
  }));
  return t3(e28.update(r3, { scrollIntoView: true, userEvent: "input" })), true;
}, qt$2 = ({ state: e28, dispatch: t3 }) => {
  if (e28.readOnly)
    return false;
  let r3 = e28.changeByRange((n3) => {
    if (!n3.empty || n3.from == 0 || n3.from == e28.doc.length)
      return { range: n3 };
    let l3 = n3.from, o3 = e28.doc.lineAt(l3), c3 = l3 == o3.from ? l3 - 1 : K$h(o3.text, l3 - o3.from, false) + o3.from, i = l3 == o3.to ? l3 + 1 : K$h(o3.text, l3 - o3.from, true) + o3.from;
    return {
      changes: { from: c3, to: i, insert: e28.doc.slice(l3, i).append(e28.doc.slice(c3, l3)) },
      range: g$K.cursor(i)
    };
  });
  return r3.changes.empty ? false : (t3(e28.update(r3, { scrollIntoView: true, userEvent: "move.character" })), true);
};
function P$A(e28) {
  let t3 = [], r3 = -1;
  for (let n3 of e28.selection.ranges) {
    let l3 = e28.doc.lineAt(n3.from), o3 = e28.doc.lineAt(n3.to);
    if (!n3.empty && n3.to == o3.from && (o3 = e28.doc.lineAt(n3.to - 1)), r3 >= l3.number) {
      let c3 = t3[t3.length - 1];
      c3.to = o3.to, c3.ranges.push(n3);
    } else
      t3.push({ from: l3.from, to: o3.to, ranges: [n3] });
    r3 = o3.number + 1;
  }
  return t3;
}
function Ue$2(e28, t3, r3) {
  if (e28.readOnly)
    return false;
  let n3 = [], l3 = [];
  for (let o3 of P$A(e28)) {
    if (r3 ? o3.to == e28.doc.length : o3.from == 0)
      continue;
    let c3 = e28.doc.lineAt(r3 ? o3.to + 1 : o3.from - 1), i = c3.length + 1;
    if (r3) {
      n3.push({ from: o3.to, to: c3.to }, { from: o3.from, insert: c3.text + e28.lineBreak });
      for (let s3 of o3.ranges)
        l3.push(g$K.range(Math.min(e28.doc.length, s3.anchor + i), Math.min(e28.doc.length, s3.head + i)));
    } else {
      n3.push({ from: c3.from, to: o3.from }, { from: o3.to, insert: e28.lineBreak + c3.text });
      for (let s3 of o3.ranges)
        l3.push(g$K.range(s3.anchor - i, s3.head - i));
    }
  }
  return n3.length ? (t3(e28.update({
    changes: n3,
    scrollIntoView: true,
    selection: g$K.create(l3, e28.selection.mainIndex),
    userEvent: "move.line"
  })), true) : false;
}
const Kt$2 = ({ state: e28, dispatch: t3 }) => Ue$2(e28, t3, false), $t$5 = ({ state: e28, dispatch: t3 }) => Ue$2(e28, t3, true);
function Pe$6(e28, t3, r3) {
  if (e28.readOnly)
    return false;
  let n3 = [];
  for (let l3 of P$A(e28))
    r3 ? n3.push({ from: l3.from, insert: e28.doc.slice(l3.from, l3.to) + e28.lineBreak }) : n3.push({ from: l3.to, insert: e28.lineBreak + e28.doc.slice(l3.from, l3.to) });
  return t3(e28.update({ changes: n3, scrollIntoView: true, userEvent: "input.copyline" })), true;
}
const wt$5 = ({ state: e28, dispatch: t3 }) => Pe$6(e28, t3, false), Wt$3 = ({ state: e28, dispatch: t3 }) => Pe$6(e28, t3, true), _t$2 = (e28) => {
  if (e28.state.readOnly)
    return false;
  let { state: t3 } = e28, r3 = t3.changes(P$A(t3).map(({ from: l3, to: o3 }) => (l3 > 0 ? l3-- : o3 < t3.doc.length && o3++, { from: l3, to: o3 }))), n3 = L$o(t3.selection, (l3) => e28.moveVertically(l3, true)).map(r3);
  return e28.dispatch({ changes: r3, selection: n3, scrollIntoView: true, userEvent: "delete.line" }), true;
};
function Qt$2(e28, t3) {
  if (/\(\)|\[\]|\{\}/.test(e28.sliceDoc(t3 - 1, t3 + 1)))
    return { from: t3, to: t3 };
  let r3 = k$t(e28).resolveInner(t3), n3 = r3.childBefore(t3), l3 = r3.childAfter(t3), o3;
  return n3 && l3 && n3.to <= t3 && l3.from >= t3 && (o3 = n3.type.prop(C$G.closedBy)) && o3.indexOf(l3.name) > -1 && e28.doc.lineAt(n3.to).from == e28.doc.lineAt(l3.from).from && !/\S/.test(e28.sliceDoc(n3.to, l3.from)) ? { from: n3.to, to: l3.from } : null;
}
const Xt$2 = /* @__PURE__ */ Ve$5(false), Yt$3 = /* @__PURE__ */ Ve$5(true);
function Ve$5(e28) {
  return ({ state: t3, dispatch: r3 }) => {
    if (t3.readOnly)
      return false;
    let n3 = t3.changeByRange((l3) => {
      let { from: o3, to: c3 } = l3, i = t3.doc.lineAt(o3), s3 = !e28 && o3 == c3 && Qt$2(t3, o3);
      e28 && (o3 = c3 = (c3 <= i.to ? i : t3.doc.lineAt(c3)).to);
      let f3 = new ue$9(t3, { simulateBreak: o3, simulateDoubleBreak: !!s3 }), u3 = qe$4(f3, o3);
      for (u3 == null && (u3 = ot$6(/^\s*/.exec(t3.doc.lineAt(o3).text)[0], t3.tabSize)); c3 < i.to && /\s/.test(i.text[c3 - i.from]); )
        c3++;
      s3 ? { from: o3, to: c3 } = s3 : o3 > i.from && o3 < i.from + 100 && !/\S/.test(i.text.slice(0, o3)) && (o3 = i.from);
      let a3 = ["", je$4(t3, u3)];
      return s3 && a3.push(je$4(t3, f3.lineIndent(i.from, -1))), {
        changes: { from: o3, to: c3, insert: x$l.of(a3) },
        range: g$K.cursor(o3 + 1 + a3[1].length)
      };
    });
    return r3(t3.update(n3, { scrollIntoView: true, userEvent: "input" })), true;
  };
}
function Q$e(e28, t3) {
  let r3 = -1;
  return e28.changeByRange((n3) => {
    let l3 = [];
    for (let c3 = n3.from; c3 <= n3.to; ) {
      let i = e28.doc.lineAt(c3);
      i.number > r3 && (n3.empty || n3.to > i.from) && (t3(i, l3, n3), r3 = i.number), c3 = i.to + 1;
    }
    let o3 = e28.changes(l3);
    return {
      changes: l3,
      range: g$K.range(o3.mapPos(n3.anchor, 1), o3.mapPos(n3.head, 1))
    };
  });
}
const Zt$2 = ({ state: e28, dispatch: t3 }) => {
  if (e28.readOnly)
    return false;
  let r3 = /* @__PURE__ */ Object.create(null), n3 = new ue$9(e28, { overrideIndentation: (o3) => {
    let c3 = r3[o3];
    return c3 != null ? c3 : -1;
  } }), l3 = Q$e(e28, (o3, c3, i) => {
    let s3 = qe$4(n3, o3.from);
    if (s3 == null)
      return;
    /\S/.test(o3.text) || (s3 = 0);
    let f3 = /^\s*/.exec(o3.text)[0], u3 = je$4(e28, s3);
    (f3 != u3 || i.from < o3.from + f3.length) && (r3[o3.from] = s3, c3.push({ from: o3.from, to: o3.from + f3.length, insert: u3 }));
  });
  return l3.changes.empty || t3(e28.update(l3, { userEvent: "indent" })), true;
}, Je$2 = ({ state: e28, dispatch: t3 }) => e28.readOnly ? false : (t3(e28.update(Q$e(e28, (r3, n3) => {
  n3.push({ from: r3.from, insert: e28.facet(ce$7) });
}), { userEvent: "input.indent" })), true), Ge$3 = ({ state: e28, dispatch: t3 }) => e28.readOnly ? false : (t3(e28.update(Q$e(e28, (r3, n3) => {
  let l3 = /^\s*/.exec(r3.text)[0];
  if (!l3)
    return;
  let o3 = ot$6(l3, e28.tabSize), c3 = 0, i = je$4(e28, Math.max(0, o3 - $e$3(e28)));
  for (; c3 < l3.length && c3 < i.length && l3.charCodeAt(c3) == i.charCodeAt(c3); )
    c3++;
  n3.push({ from: r3.from + c3, to: r3.from + l3.length, insert: i.slice(c3) });
}), { userEvent: "delete.dedent" })), true), jt$3 = [
  { key: "Ctrl-b", run: pe$8, shift: Le$2, preventDefault: true },
  { key: "Ctrl-f", run: ge$7, shift: Ce$6 },
  { key: "Ctrl-p", run: Ae$4, shift: Oe$5 },
  { key: "Ctrl-n", run: Be$4, shift: Te$6 },
  { key: "Ctrl-a", run: Bt$3, shift: vt$3 },
  { key: "Ctrl-e", run: St$4, shift: It$4 },
  { key: "Ctrl-d", run: ve$5 },
  { key: "Ctrl-h", run: K$d },
  { key: "Ctrl-k", run: Gt$4 },
  { key: "Ctrl-Alt-h", run: Ne$3 },
  { key: "Ctrl-o", run: Ht$2 },
  { key: "Ctrl-t", run: qt$2 },
  { key: "Ctrl-v", run: q$f }
], en$1 = /* @__PURE__ */ [
  { key: "ArrowLeft", run: pe$8, shift: Le$2, preventDefault: true },
  { key: "Mod-ArrowLeft", mac: "Alt-ArrowLeft", run: at$3, shift: Lt$2, preventDefault: true },
  { mac: "Cmd-ArrowLeft", run: kt$4, shift: Rt$3, preventDefault: true },
  { key: "ArrowRight", run: ge$7, shift: Ce$6, preventDefault: true },
  { key: "Mod-ArrowRight", mac: "Alt-ArrowRight", run: ht$5, shift: Ct$4, preventDefault: true },
  { mac: "Cmd-ArrowRight", run: At$5, shift: bt$3, preventDefault: true },
  { key: "ArrowUp", run: Ae$4, shift: Oe$5, preventDefault: true },
  { mac: "Cmd-ArrowUp", run: j$c, shift: te$9 },
  { mac: "Ctrl-ArrowUp", run: X$d, shift: Y$d },
  { key: "ArrowDown", run: Be$4, shift: Te$6, preventDefault: true },
  { mac: "Cmd-ArrowDown", run: ee$9, shift: ne$b },
  { mac: "Ctrl-ArrowDown", run: q$f, shift: Z$e },
  { key: "PageUp", run: X$d, shift: Y$d },
  { key: "PageDown", run: q$f, shift: Z$e },
  { key: "Home", run: yt$5, shift: Tt$4, preventDefault: true },
  { key: "Mod-Home", run: j$c, shift: te$9 },
  { key: "End", run: gt$5, shift: Ot$4, preventDefault: true },
  { key: "Mod-End", run: ee$9, shift: ne$b },
  { key: "Enter", run: Xt$2 },
  { key: "Mod-a", run: Nt$2 },
  { key: "Backspace", run: K$d, shift: K$d },
  { key: "Delete", run: ve$5 },
  { key: "Mod-Backspace", mac: "Alt-Backspace", run: Ne$3 },
  { key: "Mod-Delete", mac: "Alt-Delete", run: Jt$2 },
  { mac: "Mod-Backspace", run: zt$2 },
  { mac: "Mod-Delete", run: Ft$3 }
].concat(/* @__PURE__ */ jt$3.map((e28) => ({ mac: e28.key, run: e28.run, shift: e28.shift }))), sn$2 = /* @__PURE__ */ [
  { key: "Alt-ArrowLeft", mac: "Ctrl-ArrowLeft", run: mt$5, shift: Mt$3 },
  { key: "Alt-ArrowRight", mac: "Ctrl-ArrowRight", run: pt$5, shift: Et$4 },
  { key: "Alt-ArrowUp", run: Kt$2 },
  { key: "Shift-Alt-ArrowUp", run: wt$5 },
  { key: "Alt-ArrowDown", run: $t$5 },
  { key: "Shift-Alt-ArrowDown", run: Wt$3 },
  { key: "Escape", run: Vt$2 },
  { key: "Mod-Enter", run: Yt$3 },
  { key: "Alt-l", mac: "Ctrl-l", run: Ut$3 },
  { key: "Mod-i", run: Pt$3, preventDefault: true },
  { key: "Mod-[", run: Ge$3 },
  { key: "Mod-]", run: Je$2 },
  { key: "Mod-Alt-\\", run: Zt$2 },
  { key: "Shift-Mod-k", run: _t$2 },
  { key: "Shift-Mod-\\", run: Dt$3 },
  { key: "Mod-/", run: We$4 },
  { key: "Alt-A", run: Qe$4 }
].concat(en$1), un$1 = { key: "Tab", run: Je$2, shift: Ge$3 };
class v$D {
  constructor(t3, e28, s3, i, h3, r3, n3, o3, a3, u3 = 0, f3) {
    this.p = t3, this.stack = e28, this.state = s3, this.reducePos = i, this.pos = h3, this.score = r3, this.buffer = n3, this.bufferBase = o3, this.curContext = a3, this.lookAhead = u3, this.parent = f3;
  }
  toString() {
    return `[${this.stack.filter((t3, e28) => e28 % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  static start(t3, e28, s3 = 0) {
    let i = t3.parser.context;
    return new v$D(t3, [], e28, s3, s3, 0, [], 0, i ? new N$t(i, i.start) : null, 0, null);
  }
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  pushState(t3, e28) {
    this.stack.push(this.state, e28, this.bufferBase + this.buffer.length), this.state = t3;
  }
  reduce(t3) {
    var e28;
    let s3 = t3 >> 19, i = t3 & 65535, { parser: h3 } = this.p, r3 = h3.dynamicPrecedence(i);
    if (r3 && (this.score += r3), s3 == 0) {
      this.pushState(h3.getGoto(this.state, i, true), this.reducePos), i < h3.minRepeatTerm && this.storeNode(i, this.reducePos, this.reducePos, 4, true), this.reduceContext(i, this.reducePos);
      return;
    }
    let n3 = this.stack.length - (s3 - 1) * 3 - (t3 & 262144 ? 6 : 0), o3 = n3 ? this.stack[n3 - 2] : this.p.ranges[0].from, a3 = this.reducePos - o3;
    a3 >= 2e3 && !(!((e28 = this.p.parser.nodeSet.types[i]) === null || e28 === void 0) && e28.isAnonymous) && (o3 == this.p.lastBigReductionStart ? (this.p.bigReductionCount++, this.p.lastBigReductionSize = a3) : this.p.lastBigReductionSize < a3 && (this.p.bigReductionCount = 1, this.p.lastBigReductionStart = o3, this.p.lastBigReductionSize = a3));
    let u3 = n3 ? this.stack[n3 - 1] : 0, f3 = this.bufferBase + this.buffer.length - u3;
    if (i < h3.minRepeatTerm || t3 & 131072) {
      let c3 = h3.stateFlag(this.state, 1) ? this.pos : this.reducePos;
      this.storeNode(i, o3, c3, f3 + 4, true);
    }
    if (t3 & 262144)
      this.state = this.stack[n3];
    else {
      let c3 = this.stack[n3 - 3];
      this.state = h3.getGoto(c3, i, true);
    }
    for (; this.stack.length > n3; )
      this.stack.pop();
    this.reduceContext(i, o3);
  }
  storeNode(t3, e28, s3, i = 4, h3 = false) {
    if (t3 == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let r3 = this, n3 = this.buffer.length;
      if (n3 == 0 && r3.parent && (n3 = r3.bufferBase - r3.parent.bufferBase, r3 = r3.parent), n3 > 0 && r3.buffer[n3 - 4] == 0 && r3.buffer[n3 - 1] > -1) {
        if (e28 == s3)
          return;
        if (r3.buffer[n3 - 2] >= e28) {
          r3.buffer[n3 - 2] = s3;
          return;
        }
      }
    }
    if (!h3 || this.pos == s3)
      this.buffer.push(t3, e28, s3, i);
    else {
      let r3 = this.buffer.length;
      if (r3 > 0 && this.buffer[r3 - 4] != 0)
        for (; r3 > 0 && this.buffer[r3 - 2] > s3; )
          this.buffer[r3] = this.buffer[r3 - 4], this.buffer[r3 + 1] = this.buffer[r3 - 3], this.buffer[r3 + 2] = this.buffer[r3 - 2], this.buffer[r3 + 3] = this.buffer[r3 - 1], r3 -= 4, i > 4 && (i -= 4);
      this.buffer[r3] = t3, this.buffer[r3 + 1] = e28, this.buffer[r3 + 2] = s3, this.buffer[r3 + 3] = i;
    }
  }
  shift(t3, e28, s3, i) {
    if (t3 & 131072)
      this.pushState(t3 & 65535, this.pos);
    else if (t3 & 262144)
      this.pos = i, this.shiftContext(e28, s3), e28 <= this.p.parser.maxNode && this.buffer.push(e28, s3, i, 4);
    else {
      let h3 = t3, { parser: r3 } = this.p;
      (i > this.pos || e28 <= r3.maxNode) && (this.pos = i, r3.stateFlag(h3, 1) || (this.reducePos = i)), this.pushState(h3, s3), this.shiftContext(e28, s3), e28 <= r3.maxNode && this.buffer.push(e28, s3, i, 4);
    }
  }
  apply(t3, e28, s3, i) {
    t3 & 65536 ? this.reduce(t3) : this.shift(t3, e28, s3, i);
  }
  useNode(t3, e28) {
    let s3 = this.p.reused.length - 1;
    (s3 < 0 || this.p.reused[s3] != t3) && (this.p.reused.push(t3), s3++);
    let i = this.pos;
    this.reducePos = this.pos = i + t3.length, this.pushState(e28, i), this.buffer.push(s3, i, this.reducePos, -1), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, t3, this, this.p.stream.reset(this.pos - t3.length)));
  }
  split() {
    let t3 = this, e28 = t3.buffer.length;
    for (; e28 > 0 && t3.buffer[e28 - 2] > t3.reducePos; )
      e28 -= 4;
    let s3 = t3.buffer.slice(e28), i = t3.bufferBase + e28;
    for (; t3 && i == t3.bufferBase; )
      t3 = t3.parent;
    return new v$D(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, s3, i, this.curContext, this.lookAhead, t3);
  }
  recoverByDelete(t3, e28) {
    let s3 = t3 <= this.p.parser.maxNode;
    s3 && this.storeNode(t3, this.pos, e28, 4), this.storeNode(0, this.pos, e28, s3 ? 8 : 4), this.pos = this.reducePos = e28, this.score -= 190;
  }
  canShift(t3) {
    for (let e28 = new G$g(this); ; ) {
      let s3 = this.p.parser.stateSlot(e28.state, 4) || this.p.parser.hasAction(e28.state, t3);
      if (s3 == 0)
        return false;
      if (!(s3 & 65536))
        return true;
      e28.reduce(s3);
    }
  }
  recoverByInsert(t3) {
    if (this.stack.length >= 300)
      return [];
    let e28 = this.p.parser.nextStates(this.state);
    if (e28.length > 8 || this.stack.length >= 120) {
      let i = [];
      for (let h3 = 0, r3; h3 < e28.length; h3 += 2)
        (r3 = e28[h3 + 1]) != this.state && this.p.parser.hasAction(r3, t3) && i.push(e28[h3], r3);
      if (this.stack.length < 120)
        for (let h3 = 0; i.length < 8 && h3 < e28.length; h3 += 2) {
          let r3 = e28[h3 + 1];
          i.some((n3, o3) => o3 & 1 && n3 == r3) || i.push(e28[h3], r3);
        }
      e28 = i;
    }
    let s3 = [];
    for (let i = 0; i < e28.length && s3.length < 4; i += 2) {
      let h3 = e28[i + 1];
      if (h3 == this.state)
        continue;
      let r3 = this.split();
      r3.pushState(h3, this.pos), r3.storeNode(0, r3.pos, r3.pos, 4, true), r3.shiftContext(e28[i], this.pos), r3.reducePos = this.pos, r3.score -= 200, s3.push(r3);
    }
    return s3;
  }
  forceReduce() {
    let { parser: t3 } = this.p, e28 = t3.stateSlot(this.state, 5);
    if (!(e28 & 65536))
      return false;
    if (!t3.validAction(this.state, e28)) {
      let s3 = e28 >> 19, i = e28 & 65535, h3 = this.stack.length - s3 * 3;
      if (h3 < 0 || t3.getGoto(this.stack[h3], i, false) < 0) {
        let r3 = this.findForcedReduction();
        if (r3 == null)
          return false;
        e28 = r3;
      }
      this.storeNode(0, this.pos, this.pos, 4, true), this.score -= 100;
    }
    return this.reducePos = this.pos, this.reduce(e28), true;
  }
  findForcedReduction() {
    let { parser: t3 } = this.p, e28 = [], s3 = (i, h3) => {
      if (!e28.includes(i))
        return e28.push(i), t3.allActions(i, (r3) => {
          if (!(r3 & 393216))
            if (r3 & 65536) {
              let n3 = (r3 >> 19) - h3;
              if (n3 > 1) {
                let o3 = r3 & 65535, a3 = this.stack.length - n3 * 3;
                if (a3 >= 0 && t3.getGoto(this.stack[a3], o3, false) >= 0)
                  return n3 << 19 | 65536 | o3;
              }
            } else {
              let n3 = s3(r3, h3 + 1);
              if (n3 != null)
                return n3;
            }
        });
    };
    return s3(this.state, 0);
  }
  forceAll() {
    for (; !this.p.parser.stateFlag(this.state, 2); )
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, true);
        break;
      }
    return this;
  }
  get deadEnd() {
    if (this.stack.length != 3)
      return false;
    let { parser: t3 } = this.p;
    return t3.data[t3.stateSlot(this.state, 1)] == 65535 && !t3.stateSlot(this.state, 4);
  }
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, true), this.state = this.stack[0], this.stack.length = 0;
  }
  sameState(t3) {
    if (this.state != t3.state || this.stack.length != t3.stack.length)
      return false;
    for (let e28 = 0; e28 < this.stack.length; e28 += 3)
      if (this.stack[e28] != t3.stack[e28])
        return false;
    return true;
  }
  get parser() {
    return this.p.parser;
  }
  dialectEnabled(t3) {
    return this.p.parser.dialect.flags[t3];
  }
  shiftContext(t3, e28) {
    this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, t3, this, this.p.stream.reset(e28)));
  }
  reduceContext(t3, e28) {
    this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, t3, this, this.p.stream.reset(e28)));
  }
  emitContext() {
    let t3 = this.buffer.length - 1;
    (t3 < 0 || this.buffer[t3] != -3) && this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  emitLookAhead() {
    let t3 = this.buffer.length - 1;
    (t3 < 0 || this.buffer[t3] != -4) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(t3) {
    if (t3 != this.curContext.context) {
      let e28 = new N$t(this.curContext.tracker, t3);
      e28.hash != this.curContext.hash && this.emitContext(), this.curContext = e28;
    }
  }
  setLookAhead(t3) {
    t3 > this.lookAhead && (this.emitLookAhead(), this.lookAhead = t3);
  }
  close() {
    this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
  }
}
class N$t {
  constructor(t3, e28) {
    this.tracker = t3, this.context = e28, this.hash = t3.strict ? t3.hash(e28) : 0;
  }
}
class G$g {
  constructor(t3) {
    this.start = t3, this.state = t3.state, this.stack = t3.stack, this.base = this.stack.length;
  }
  reduce(t3) {
    let e28 = t3 & 65535, s3 = t3 >> 19;
    s3 == 0 ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= (s3 - 1) * 3;
    let i = this.start.p.parser.getGoto(this.stack[this.base - 3], e28, true);
    this.state = i;
  }
}
class A$j {
  constructor(t3, e28, s3) {
    this.stack = t3, this.pos = e28, this.index = s3, this.buffer = t3.buffer, this.index == 0 && this.maybeNext();
  }
  static create(t3, e28 = t3.bufferBase + t3.buffer.length) {
    return new A$j(t3, e28, e28 - t3.bufferBase);
  }
  maybeNext() {
    let t3 = this.stack.parent;
    t3 != null && (this.index = this.stack.bufferBase - t3.bufferBase, this.stack = t3, this.buffer = t3.buffer);
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4, this.pos -= 4, this.index == 0 && this.maybeNext();
  }
  fork() {
    return new A$j(this.stack, this.pos, this.index);
  }
}
function x$j(l3, t3 = Uint16Array) {
  if (typeof l3 != "string")
    return l3;
  let e28 = null;
  for (let s3 = 0, i = 0; s3 < l3.length; ) {
    let h3 = 0;
    for (; ; ) {
      let r3 = l3.charCodeAt(s3++), n3 = false;
      if (r3 == 126) {
        h3 = 65535;
        break;
      }
      r3 >= 92 && r3--, r3 >= 34 && r3--;
      let o3 = r3 - 32;
      if (o3 >= 46 && (o3 -= 46, n3 = true), h3 += o3, n3)
        break;
      h3 *= 46;
    }
    e28 ? e28[i++] = h3 : e28 = new t3(h3);
  }
  return e28;
}
class P$z {
  constructor() {
    this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
  }
}
const R$f = new P$z();
class U$j {
  constructor(t3, e28) {
    this.input = t3, this.ranges = e28, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = R$f, this.rangeIndex = 0, this.pos = this.chunkPos = e28[0].from, this.range = e28[0], this.end = e28[e28.length - 1].to, this.readNext();
  }
  resolveOffset(t3, e28) {
    let s3 = this.range, i = this.rangeIndex, h3 = this.pos + t3;
    for (; h3 < s3.from; ) {
      if (!i)
        return null;
      let r3 = this.ranges[--i];
      h3 -= s3.from - r3.to, s3 = r3;
    }
    for (; e28 < 0 ? h3 > s3.to : h3 >= s3.to; ) {
      if (i == this.ranges.length - 1)
        return null;
      let r3 = this.ranges[++i];
      h3 += r3.from - s3.to, s3 = r3;
    }
    return h3;
  }
  clipPos(t3) {
    if (t3 >= this.range.from && t3 < this.range.to)
      return t3;
    for (let e28 of this.ranges)
      if (e28.to > t3)
        return Math.max(t3, e28.from);
    return this.end;
  }
  peek(t3) {
    let e28 = this.chunkOff + t3, s3, i;
    if (e28 >= 0 && e28 < this.chunk.length)
      s3 = this.pos + t3, i = this.chunk.charCodeAt(e28);
    else {
      let h3 = this.resolveOffset(t3, 1);
      if (h3 == null)
        return -1;
      if (s3 = h3, s3 >= this.chunk2Pos && s3 < this.chunk2Pos + this.chunk2.length)
        i = this.chunk2.charCodeAt(s3 - this.chunk2Pos);
      else {
        let r3 = this.rangeIndex, n3 = this.range;
        for (; n3.to <= s3; )
          n3 = this.ranges[++r3];
        this.chunk2 = this.input.chunk(this.chunk2Pos = s3), s3 + this.chunk2.length > n3.to && (this.chunk2 = this.chunk2.slice(0, n3.to - s3)), i = this.chunk2.charCodeAt(0);
      }
    }
    return s3 >= this.token.lookAhead && (this.token.lookAhead = s3 + 1), i;
  }
  acceptToken(t3, e28 = 0) {
    let s3 = e28 ? this.resolveOffset(e28, -1) : this.pos;
    if (s3 == null || s3 < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = t3, this.token.end = s3;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk: t3, chunkPos: e28 } = this;
      this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = t3, this.chunk2Pos = e28, this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
      let t3 = this.input.chunk(this.pos), e28 = this.pos + t3.length;
      this.chunk = e28 > this.range.to ? t3.slice(0, this.range.to - this.pos) : t3, this.chunkPos = this.pos, this.chunkOff = 0;
    }
  }
  readNext() {
    return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  advance(t3 = 1) {
    for (this.chunkOff += t3; this.pos + t3 >= this.range.to; ) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      t3 -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
    }
    return this.pos += t3, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
  }
  setDone() {
    return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
  }
  reset(t3, e28) {
    if (e28 ? (this.token = e28, e28.start = t3, e28.lookAhead = t3 + 1, e28.value = e28.extended = -1) : this.token = R$f, this.pos != t3) {
      if (this.pos = t3, t3 == this.end)
        return this.setDone(), this;
      for (; t3 < this.range.from; )
        this.range = this.ranges[--this.rangeIndex];
      for (; t3 >= this.range.to; )
        this.range = this.ranges[++this.rangeIndex];
      t3 >= this.chunkPos && t3 < this.chunkPos + this.chunk.length ? this.chunkOff = t3 - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
    }
    return this;
  }
  read(t3, e28) {
    if (t3 >= this.chunkPos && e28 <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(t3 - this.chunkPos, e28 - this.chunkPos);
    if (t3 >= this.chunk2Pos && e28 <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(t3 - this.chunk2Pos, e28 - this.chunk2Pos);
    if (t3 >= this.range.from && e28 <= this.range.to)
      return this.input.read(t3, e28);
    let s3 = "";
    for (let i of this.ranges) {
      if (i.from >= e28)
        break;
      i.to > t3 && (s3 += this.input.read(Math.max(i.from, t3), Math.min(i.to, e28)));
    }
    return s3;
  }
}
class m$1d {
  constructor(t3, e28) {
    this.data = t3, this.id = e28;
  }
  token(t3, e28) {
    let { parser: s3 } = e28.p;
    F$i(this.data, t3, e28, this.id, s3.data, s3.tokenPrecTable);
  }
}
m$1d.prototype.contextual = m$1d.prototype.fallback = m$1d.prototype.extend = false;
class H$f {
  constructor(t3, e28, s3) {
    this.precTable = e28, this.elseToken = s3, this.data = typeof t3 == "string" ? x$j(t3) : t3;
  }
  token(t3, e28) {
    let s3 = t3.pos, i = 0;
    for (; ; ) {
      let h3 = t3.next < 0, r3 = t3.resolveOffset(1, 1);
      if (F$i(this.data, t3, e28, 0, this.data, this.precTable), t3.token.value > -1)
        break;
      if (this.elseToken == null)
        return;
      if (h3 || i++, r3 == null)
        break;
      t3.reset(r3, t3.token);
    }
    i && (t3.reset(s3, t3.token), t3.acceptToken(this.elseToken, i));
  }
}
H$f.prototype.contextual = m$1d.prototype.fallback = m$1d.prototype.extend = false;
class Y$c {
  constructor(t3, e28 = {}) {
    this.token = t3, this.contextual = !!e28.contextual, this.fallback = !!e28.fallback, this.extend = !!e28.extend;
  }
}
function F$i(l3, t3, e28, s3, i, h3) {
  let r3 = 0, n3 = 1 << s3, { dialect: o3 } = e28.p.parser;
  t:
    for (; n3 & l3[r3]; ) {
      let a3 = l3[r3 + 1];
      for (let p3 = r3 + 3; p3 < a3; p3 += 2)
        if ((l3[p3 + 1] & n3) > 0) {
          let d3 = l3[p3];
          if (o3.allows(d3) && (t3.token.value == -1 || t3.token.value == d3 || W$b(d3, t3.token.value, i, h3))) {
            t3.acceptToken(d3);
            break;
          }
        }
      let u3 = t3.next, f3 = 0, c3 = l3[r3 + 2];
      if (t3.next < 0 && c3 > f3 && l3[a3 + c3 * 3 - 3] == 65535 && l3[a3 + c3 * 3 - 3] == 65535) {
        r3 = l3[a3 + c3 * 3 - 1];
        continue t;
      }
      for (; f3 < c3; ) {
        let p3 = f3 + c3 >> 1, d3 = a3 + p3 + (p3 << 1), b3 = l3[d3], O3 = l3[d3 + 1] || 65536;
        if (u3 < b3)
          c3 = p3;
        else if (u3 >= O3)
          f3 = p3 + 1;
        else {
          r3 = l3[d3 + 2], t3.advance();
          continue t;
        }
      }
      break;
    }
}
function z$e(l3, t3, e28) {
  for (let s3 = t3, i; (i = l3[s3]) != 65535; s3++)
    if (i == e28)
      return s3 - t3;
  return -1;
}
function W$b(l3, t3, e28, s3) {
  let i = z$e(e28, s3, t3);
  return i < 0 || z$e(e28, s3, l3) < i;
}
const g$G = typeof process < "u" && process.env && /\bparse\b/.test({}.LOG);
let C$E = null;
function I$p(l3, t3, e28) {
  let s3 = l3.cursor(k$v.IncludeAnonymous);
  for (s3.moveTo(t3); ; )
    if (!(e28 < 0 ? s3.childBefore(t3) : s3.childAfter(t3)))
      for (; ; ) {
        if ((e28 < 0 ? s3.to < t3 : s3.from > t3) && !s3.type.isError)
          return e28 < 0 ? Math.max(0, Math.min(s3.to - 1, t3 - 25)) : Math.min(l3.length, Math.max(s3.from + 1, t3 + 25));
        if (e28 < 0 ? s3.prevSibling() : s3.nextSibling())
          break;
        if (!s3.parent())
          return e28 < 0 ? 0 : l3.length;
      }
}
class q$e {
  constructor(t3, e28) {
    this.fragments = t3, this.nodeSet = e28, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
  }
  nextFragment() {
    let t3 = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (t3) {
      for (this.safeFrom = t3.openStart ? I$p(t3.tree, t3.from + t3.offset, 1) - t3.offset : t3.from, this.safeTo = t3.openEnd ? I$p(t3.tree, t3.to + t3.offset, -1) - t3.offset : t3.to; this.trees.length; )
        this.trees.pop(), this.start.pop(), this.index.pop();
      this.trees.push(t3.tree), this.start.push(-t3.offset), this.index.push(0), this.nextStart = this.safeFrom;
    } else
      this.nextStart = 1e9;
  }
  nodeAt(t3) {
    if (t3 < this.nextStart)
      return null;
    for (; this.fragment && this.safeTo <= t3; )
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let e28 = this.trees.length - 1;
      if (e28 < 0)
        return this.nextFragment(), null;
      let s3 = this.trees[e28], i = this.index[e28];
      if (i == s3.children.length) {
        this.trees.pop(), this.start.pop(), this.index.pop();
        continue;
      }
      let h3 = s3.children[i], r3 = this.start[e28] + s3.positions[i];
      if (r3 > t3)
        return this.nextStart = r3, null;
      if (h3 instanceof B$q) {
        if (r3 == t3) {
          if (r3 < this.safeFrom)
            return null;
          let n3 = r3 + h3.length;
          if (n3 <= this.safeTo) {
            let o3 = h3.prop(C$G.lookAhead);
            if (!o3 || n3 + o3 < this.fragment.to)
              return h3;
          }
        }
        this.index[e28]++, r3 + h3.length >= Math.max(this.safeFrom, t3) && (this.trees.push(h3), this.start.push(r3), this.index.push(0));
      } else
        this.index[e28]++, this.nextStart = r3 + h3.length;
    }
  }
}
class J$c {
  constructor(t3, e28) {
    this.stream = e28, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = t3.tokenizers.map((s3) => new P$z());
  }
  getActions(t3) {
    let e28 = 0, s3 = null, { parser: i } = t3.p, { tokenizers: h3 } = i, r3 = i.stateSlot(t3.state, 3), n3 = t3.curContext ? t3.curContext.hash : 0, o3 = 0;
    for (let a3 = 0; a3 < h3.length; a3++) {
      if (!(1 << a3 & r3))
        continue;
      let u3 = h3[a3], f3 = this.tokens[a3];
      if (!(s3 && !u3.fallback) && ((u3.contextual || f3.start != t3.pos || f3.mask != r3 || f3.context != n3) && (this.updateCachedToken(f3, u3, t3), f3.mask = r3, f3.context = n3), f3.lookAhead > f3.end + 25 && (o3 = Math.max(f3.lookAhead, o3)), f3.value != 0)) {
        let c3 = e28;
        if (f3.extended > -1 && (e28 = this.addActions(t3, f3.extended, f3.end, e28)), e28 = this.addActions(t3, f3.value, f3.end, e28), !u3.extend && (s3 = f3, e28 > c3))
          break;
      }
    }
    for (; this.actions.length > e28; )
      this.actions.pop();
    return o3 && t3.setLookAhead(o3), !s3 && t3.pos == this.stream.end && (s3 = new P$z(), s3.value = t3.p.parser.eofTerm, s3.start = s3.end = t3.pos, e28 = this.addActions(t3, s3.value, s3.end, e28)), this.mainToken = s3, this.actions;
  }
  getMainToken(t3) {
    if (this.mainToken)
      return this.mainToken;
    let e28 = new P$z(), { pos: s3, p: i } = t3;
    return e28.start = s3, e28.end = Math.min(s3 + 1, i.stream.end), e28.value = s3 == i.stream.end ? i.parser.eofTerm : 0, e28;
  }
  updateCachedToken(t3, e28, s3) {
    let i = this.stream.clipPos(s3.pos);
    if (e28.token(this.stream.reset(i, t3), s3), t3.value > -1) {
      let { parser: h3 } = s3.p;
      for (let r3 = 0; r3 < h3.specialized.length; r3++)
        if (h3.specialized[r3] == t3.value) {
          let n3 = h3.specializers[r3](this.stream.read(t3.start, t3.end), s3);
          if (n3 >= 0 && s3.p.parser.dialect.allows(n3 >> 1)) {
            n3 & 1 ? t3.extended = n3 >> 1 : t3.value = n3 >> 1;
            break;
          }
        }
    } else
      t3.value = 0, t3.end = this.stream.clipPos(i + 1);
  }
  putAction(t3, e28, s3, i) {
    for (let h3 = 0; h3 < i; h3 += 3)
      if (this.actions[h3] == t3)
        return i;
    return this.actions[i++] = t3, this.actions[i++] = e28, this.actions[i++] = s3, i;
  }
  addActions(t3, e28, s3, i) {
    let { state: h3 } = t3, { parser: r3 } = t3.p, { data: n3 } = r3;
    for (let o3 = 0; o3 < 2; o3++)
      for (let a3 = r3.stateSlot(h3, o3 ? 2 : 1); ; a3 += 3) {
        if (n3[a3] == 65535)
          if (n3[a3 + 1] == 1)
            a3 = k$r(n3, a3 + 2);
          else {
            i == 0 && n3[a3 + 1] == 2 && (i = this.putAction(k$r(n3, a3 + 2), e28, s3, i));
            break;
          }
        n3[a3] == e28 && (i = this.putAction(k$r(n3, a3 + 1), e28, s3, i));
      }
    return i;
  }
}
class K$c {
  constructor(t3, e28, s3, i) {
    this.parser = t3, this.input = e28, this.ranges = i, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.lastBigReductionStart = -1, this.lastBigReductionSize = 0, this.bigReductionCount = 0, this.stream = new U$j(e28, i), this.tokens = new J$c(t3, this.stream), this.topTerm = t3.top[1];
    let { from: h3 } = i[0];
    this.stacks = [v$D.start(this, t3.top[0], h3)], this.fragments = s3.length && this.stream.end - h3 > t3.bufferLength * 4 ? new q$e(s3, t3.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  advance() {
    let t3 = this.stacks, e28 = this.minStackPos, s3 = this.stacks = [], i, h3;
    if (this.bigReductionCount > 300 && t3.length == 1) {
      let [r3] = t3;
      for (; r3.forceReduce() && r3.stack.length && r3.stack[r3.stack.length - 2] >= this.lastBigReductionStart; )
        ;
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let r3 = 0; r3 < t3.length; r3++) {
      let n3 = t3[r3];
      for (; ; ) {
        if (this.tokens.mainToken = null, n3.pos > e28)
          s3.push(n3);
        else {
          if (this.advanceStack(n3, s3, t3))
            continue;
          {
            i || (i = [], h3 = []), i.push(n3);
            let o3 = this.tokens.getMainToken(n3);
            h3.push(o3.value, o3.end);
          }
        }
        break;
      }
    }
    if (!s3.length) {
      let r3 = i && V$h(i);
      if (r3)
        return g$G && console.log("Finish with " + this.stackID(r3)), this.stackToTree(r3);
      if (this.parser.strict)
        throw g$G && i && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + e28);
      this.recovering || (this.recovering = 5);
    }
    if (this.recovering && i) {
      let r3 = this.stoppedAt != null && i[0].pos > this.stoppedAt ? i[0] : this.runRecovery(i, h3, s3);
      if (r3)
        return g$G && console.log("Force-finish " + this.stackID(r3)), this.stackToTree(r3.forceAll());
    }
    if (this.recovering) {
      let r3 = this.recovering == 1 ? 1 : this.recovering * 3;
      if (s3.length > r3)
        for (s3.sort((n3, o3) => o3.score - n3.score); s3.length > r3; )
          s3.pop();
      s3.some((n3) => n3.reducePos > e28) && this.recovering--;
    } else if (s3.length > 1) {
      t:
        for (let r3 = 0; r3 < s3.length - 1; r3++) {
          let n3 = s3[r3];
          for (let o3 = r3 + 1; o3 < s3.length; o3++) {
            let a3 = s3[o3];
            if (n3.sameState(a3) || n3.buffer.length > 500 && a3.buffer.length > 500)
              if ((n3.score - a3.score || n3.buffer.length - a3.buffer.length) > 0)
                s3.splice(o3--, 1);
              else {
                s3.splice(r3--, 1);
                continue t;
              }
          }
        }
      s3.length > 12 && s3.splice(12, s3.length - 12);
    }
    this.minStackPos = s3[0].pos;
    for (let r3 = 1; r3 < s3.length; r3++)
      s3[r3].pos < this.minStackPos && (this.minStackPos = s3[r3].pos);
    return null;
  }
  stopAt(t3) {
    if (this.stoppedAt != null && this.stoppedAt < t3)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = t3;
  }
  advanceStack(t3, e28, s3) {
    let i = t3.pos, { parser: h3 } = this, r3 = g$G ? this.stackID(t3) + " -> " : "";
    if (this.stoppedAt != null && i > this.stoppedAt)
      return t3.forceReduce() ? t3 : null;
    if (this.fragments) {
      let a3 = t3.curContext && t3.curContext.tracker.strict, u3 = a3 ? t3.curContext.hash : 0;
      for (let f3 = this.fragments.nodeAt(i); f3; ) {
        let c3 = this.parser.nodeSet.types[f3.type.id] == f3.type ? h3.getGoto(t3.state, f3.type.id) : -1;
        if (c3 > -1 && f3.length && (!a3 || (f3.prop(C$G.contextHash) || 0) == u3))
          return t3.useNode(f3, c3), g$G && console.log(r3 + this.stackID(t3) + ` (via reuse of ${h3.getName(f3.type.id)})`), true;
        if (!(f3 instanceof B$q) || f3.children.length == 0 || f3.positions[0] > 0)
          break;
        let p3 = f3.children[0];
        if (p3 instanceof B$q && f3.positions[0] == 0)
          f3 = p3;
        else
          break;
      }
    }
    let n3 = h3.stateSlot(t3.state, 4);
    if (n3 > 0)
      return t3.reduce(n3), g$G && console.log(r3 + this.stackID(t3) + ` (via always-reduce ${h3.getName(n3 & 65535)})`), true;
    if (t3.stack.length >= 9e3)
      for (; t3.stack.length > 6e3 && t3.forceReduce(); )
        ;
    let o3 = this.tokens.getActions(t3);
    for (let a3 = 0; a3 < o3.length; ) {
      let u3 = o3[a3++], f3 = o3[a3++], c3 = o3[a3++], p3 = a3 == o3.length || !s3, d3 = p3 ? t3 : t3.split(), b3 = this.tokens.mainToken;
      if (d3.apply(u3, f3, b3 ? b3.start : d3.pos, c3), g$G && console.log(r3 + this.stackID(d3) + ` (via ${u3 & 65536 ? `reduce of ${h3.getName(u3 & 65535)}` : "shift"} for ${h3.getName(f3)} @ ${i}${d3 == t3 ? "" : ", split"})`), p3)
        return true;
      d3.pos > i ? e28.push(d3) : s3.push(d3);
    }
    return false;
  }
  advanceFully(t3, e28) {
    let s3 = t3.pos;
    for (; ; ) {
      if (!this.advanceStack(t3, null, null))
        return false;
      if (t3.pos > s3)
        return D$t(t3, e28), true;
    }
  }
  runRecovery(t3, e28, s3) {
    let i = null, h3 = false;
    for (let r3 = 0; r3 < t3.length; r3++) {
      let n3 = t3[r3], o3 = e28[r3 << 1], a3 = e28[(r3 << 1) + 1], u3 = g$G ? this.stackID(n3) + " -> " : "";
      if (n3.deadEnd && (h3 || (h3 = true, n3.restart(), g$G && console.log(u3 + this.stackID(n3) + " (restarted)"), this.advanceFully(n3, s3))))
        continue;
      let f3 = n3.split(), c3 = u3;
      for (let p3 = 0; f3.forceReduce() && p3 < 10 && (g$G && console.log(c3 + this.stackID(f3) + " (via force-reduce)"), !this.advanceFully(f3, s3)); p3++)
        g$G && (c3 = this.stackID(f3) + " -> ");
      for (let p3 of n3.recoverByInsert(o3))
        g$G && console.log(u3 + this.stackID(p3) + " (via recover-insert)"), this.advanceFully(p3, s3);
      this.stream.end > n3.pos ? (a3 == n3.pos && (a3++, o3 = 0), n3.recoverByDelete(o3, a3), g$G && console.log(u3 + this.stackID(n3) + ` (via recover-delete ${this.parser.getName(o3)})`), D$t(n3, s3)) : (!i || i.score < n3.score) && (i = n3);
    }
    return i;
  }
  stackToTree(t3) {
    return t3.close(), B$q.build({
      buffer: A$j.create(t3),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: t3.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(t3) {
    let e28 = (C$E || (C$E = /* @__PURE__ */ new WeakMap())).get(t3);
    return e28 || C$E.set(t3, e28 = String.fromCodePoint(this.nextStackID++)), e28 + t3;
  }
}
function D$t(l3, t3) {
  for (let e28 = 0; e28 < t3.length; e28++) {
    let s3 = t3[e28];
    if (s3.pos == l3.pos && s3.sameState(l3)) {
      t3[e28].score < l3.score && (t3[e28] = l3);
      return;
    }
  }
  t3.push(l3);
}
class Q$d {
  constructor(t3, e28, s3) {
    this.source = t3, this.flags = e28, this.disabled = s3;
  }
  allows(t3) {
    return !this.disabled || this.disabled[t3] == 0;
  }
}
const T$r = (l3) => l3;
class Z$d {
  constructor(t3) {
    this.start = t3.start, this.shift = t3.shift || T$r, this.reduce = t3.reduce || T$r, this.reuse = t3.reuse || T$r, this.hash = t3.hash || (() => 0), this.strict = t3.strict !== false;
  }
}
class w$m extends Ee$5 {
  constructor(t3) {
    if (super(), this.wrappers = [], t3.version != 14)
      throw new RangeError(`Parser version (${t3.version}) doesn't match runtime version (14)`);
    let e28 = t3.nodeNames.split(" ");
    this.minRepeatTerm = e28.length;
    for (let n3 = 0; n3 < t3.repeatNodeCount; n3++)
      e28.push("");
    let s3 = Object.keys(t3.topRules).map((n3) => t3.topRules[n3][1]), i = [];
    for (let n3 = 0; n3 < e28.length; n3++)
      i.push([]);
    function h3(n3, o3, a3) {
      i[n3].push([o3, o3.deserialize(String(a3))]);
    }
    if (t3.nodeProps)
      for (let n3 of t3.nodeProps) {
        let o3 = n3[0];
        typeof o3 == "string" && (o3 = C$G[o3]);
        for (let a3 = 1; a3 < n3.length; ) {
          let u3 = n3[a3++];
          if (u3 >= 0)
            h3(u3, o3, n3[a3++]);
          else {
            let f3 = n3[a3 + -u3];
            for (let c3 = -u3; c3 > 0; c3--)
              h3(n3[a3++], o3, f3);
            a3++;
          }
        }
      }
    this.nodeSet = new de$b(e28.map((n3, o3) => T$v.define({
      name: o3 >= this.minRepeatTerm ? void 0 : n3,
      id: o3,
      props: i[o3],
      top: s3.indexOf(o3) > -1,
      error: o3 == 0,
      skipped: t3.skippedNodes && t3.skippedNodes.indexOf(o3) > -1
    }))), t3.propSources && (this.nodeSet = this.nodeSet.extend(...t3.propSources)), this.strict = false, this.bufferLength = ze$5;
    let r3 = x$j(t3.tokenData);
    this.context = t3.context, this.specializerSpecs = t3.specialized || [], this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let n3 = 0; n3 < this.specializerSpecs.length; n3++)
      this.specialized[n3] = this.specializerSpecs[n3].term;
    this.specializers = this.specializerSpecs.map(B$n), this.states = x$j(t3.states, Uint32Array), this.data = x$j(t3.stateData), this.goto = x$j(t3.goto), this.maxTerm = t3.maxTerm, this.tokenizers = t3.tokenizers.map((n3) => typeof n3 == "number" ? new m$1d(r3, n3) : n3), this.topRules = t3.topRules, this.dialects = t3.dialects || {}, this.dynamicPrecedences = t3.dynamicPrecedences || null, this.tokenPrecTable = t3.tokenPrec, this.termNames = t3.termNames || null, this.maxNode = this.nodeSet.types.length - 1, this.dialect = this.parseDialect(), this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(t3, e28, s3) {
    let i = new K$c(this, t3, e28, s3);
    for (let h3 of this.wrappers)
      i = h3(i, t3, e28, s3);
    return i;
  }
  getGoto(t3, e28, s3 = false) {
    let i = this.goto;
    if (e28 >= i[0])
      return -1;
    for (let h3 = i[e28 + 1]; ; ) {
      let r3 = i[h3++], n3 = r3 & 1, o3 = i[h3++];
      if (n3 && s3)
        return o3;
      for (let a3 = h3 + (r3 >> 1); h3 < a3; h3++)
        if (i[h3] == t3)
          return o3;
      if (n3)
        return -1;
    }
  }
  hasAction(t3, e28) {
    let s3 = this.data;
    for (let i = 0; i < 2; i++)
      for (let h3 = this.stateSlot(t3, i ? 2 : 1), r3; ; h3 += 3) {
        if ((r3 = s3[h3]) == 65535)
          if (s3[h3 + 1] == 1)
            r3 = s3[h3 = k$r(s3, h3 + 2)];
          else {
            if (s3[h3 + 1] == 2)
              return k$r(s3, h3 + 2);
            break;
          }
        if (r3 == e28 || r3 == 0)
          return k$r(s3, h3 + 1);
      }
    return 0;
  }
  stateSlot(t3, e28) {
    return this.states[t3 * 6 + e28];
  }
  stateFlag(t3, e28) {
    return (this.stateSlot(t3, 0) & e28) > 0;
  }
  validAction(t3, e28) {
    return !!this.allActions(t3, (s3) => s3 == e28 ? true : null);
  }
  allActions(t3, e28) {
    let s3 = this.stateSlot(t3, 4), i = s3 ? e28(s3) : void 0;
    for (let h3 = this.stateSlot(t3, 1); i == null; h3 += 3) {
      if (this.data[h3] == 65535)
        if (this.data[h3 + 1] == 1)
          h3 = k$r(this.data, h3 + 2);
        else
          break;
      i = e28(k$r(this.data, h3 + 1));
    }
    return i;
  }
  nextStates(t3) {
    let e28 = [];
    for (let s3 = this.stateSlot(t3, 1); ; s3 += 3) {
      if (this.data[s3] == 65535)
        if (this.data[s3 + 1] == 1)
          s3 = k$r(this.data, s3 + 2);
        else
          break;
      if (!(this.data[s3 + 2] & 1)) {
        let i = this.data[s3 + 1];
        e28.some((h3, r3) => r3 & 1 && h3 == i) || e28.push(this.data[s3], i);
      }
    }
    return e28;
  }
  configure(t3) {
    let e28 = Object.assign(Object.create(w$m.prototype), this);
    if (t3.props && (e28.nodeSet = this.nodeSet.extend(...t3.props)), t3.top) {
      let s3 = this.topRules[t3.top];
      if (!s3)
        throw new RangeError(`Invalid top rule name ${t3.top}`);
      e28.top = s3;
    }
    return t3.tokenizers && (e28.tokenizers = this.tokenizers.map((s3) => {
      let i = t3.tokenizers.find((h3) => h3.from == s3);
      return i ? i.to : s3;
    })), t3.specializers && (e28.specializers = this.specializers.slice(), e28.specializerSpecs = this.specializerSpecs.map((s3, i) => {
      let h3 = t3.specializers.find((n3) => n3.from == s3.external);
      if (!h3)
        return s3;
      let r3 = Object.assign(Object.assign({}, s3), { external: h3.to });
      return e28.specializers[i] = B$n(r3), r3;
    })), t3.contextTracker && (e28.context = t3.contextTracker), t3.dialect && (e28.dialect = this.parseDialect(t3.dialect)), t3.strict != null && (e28.strict = t3.strict), t3.wrap && (e28.wrappers = e28.wrappers.concat(t3.wrap)), t3.bufferLength != null && (e28.bufferLength = t3.bufferLength), e28;
  }
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  getName(t3) {
    return this.termNames ? this.termNames[t3] : String(t3 <= this.maxNode && this.nodeSet.types[t3].name || t3);
  }
  get eofTerm() {
    return this.maxNode + 1;
  }
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  dynamicPrecedence(t3) {
    let e28 = this.dynamicPrecedences;
    return e28 == null ? 0 : e28[t3] || 0;
  }
  parseDialect(t3) {
    let e28 = Object.keys(this.dialects), s3 = e28.map(() => false);
    if (t3)
      for (let h3 of t3.split(" ")) {
        let r3 = e28.indexOf(h3);
        r3 >= 0 && (s3[r3] = true);
      }
    let i = null;
    for (let h3 = 0; h3 < e28.length; h3++)
      if (!s3[h3])
        for (let r3 = this.dialects[e28[h3]], n3; (n3 = this.data[r3++]) != 65535; )
          (i || (i = new Uint8Array(this.maxTerm + 1)))[n3] = 1;
    return new Q$d(t3, s3, i);
  }
  static deserialize(t3) {
    return new w$m(t3);
  }
}
function k$r(l3, t3) {
  return l3[t3] | l3[t3 + 1] << 16;
}
function V$h(l3) {
  let t3 = null;
  for (let e28 of l3) {
    let s3 = e28.p.stoppedAt;
    (e28.pos == e28.p.stream.end || s3 != null && e28.pos > s3) && e28.p.parser.stateFlag(e28.state, 2) && (!t3 || t3.score < e28.score) && (t3 = e28);
  }
  return t3;
}
function B$n(l3) {
  if (l3.external) {
    let t3 = l3.extend ? 1 : 0;
    return (e28, s3) => l3.external(e28, s3) << 1 | t3;
  }
  return l3.get;
}
const d$12 = 96, P$y = 1, R$e = 97, W$a = 98, n$I = 2, i$W = [
  9,
  10,
  11,
  12,
  13,
  32,
  133,
  160,
  5760,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8199,
  8200,
  8201,
  8202,
  8232,
  8233,
  8239,
  8287,
  12288
], X$c = 58, m$1c = 40, s$16 = 95, z$d = 91, S$i = 45, g$F = 46, b$B = 35, f$L = 37;
function t$L(e28) {
  return e28 >= 65 && e28 <= 90 || e28 >= 97 && e28 <= 122 || e28 >= 161;
}
function T$q(e28) {
  return e28 >= 48 && e28 <= 57;
}
const u$$ = new Y$c((e28, Q3) => {
  for (let o3 = false, l3 = 0, $3 = 0; ; $3++) {
    let { next: a3 } = e28;
    if (t$L(a3) || a3 == S$i || a3 == s$16 || o3 && T$q(a3))
      !o3 && (a3 != S$i || $3 > 0) && (o3 = true), l3 === $3 && a3 == S$i && l3++, e28.advance();
    else {
      o3 && e28.acceptToken(a3 == m$1c ? R$e : l3 == 2 && Q3.canShift(n$I) ? n$I : W$a);
      break;
    }
  }
}), U$i = new Y$c((e28) => {
  if (i$W.includes(e28.peek(-1))) {
    let { next: Q3 } = e28;
    (t$L(Q3) || Q3 == s$16 || Q3 == b$B || Q3 == g$F || Q3 == z$d || Q3 == X$c || Q3 == S$i) && e28.acceptToken(d$12);
  }
}), h$_ = new Y$c((e28) => {
  if (!i$W.includes(e28.peek(-1))) {
    let { next: Q3 } = e28;
    if (Q3 == f$L && (e28.advance(), e28.acceptToken(P$y)), t$L(Q3)) {
      do
        e28.advance();
      while (t$L(e28.next));
      e28.acceptToken(P$y);
    }
  }
}), Z$c = $$d({
  "AtKeyword import charset namespace keyframes media supports": n$J.definitionKeyword,
  "from to selector": n$J.keyword,
  NamespaceName: n$J.namespace,
  KeyframeName: n$J.labelName,
  KeyframeRangeName: n$J.operatorKeyword,
  TagName: n$J.tagName,
  ClassName: n$J.className,
  PseudoClassName: n$J.constant(n$J.className),
  IdName: n$J.labelName,
  "FeatureName PropertyName": n$J.propertyName,
  AttributeName: n$J.attributeName,
  NumberLiteral: n$J.number,
  KeywordQuery: n$J.keyword,
  UnaryQueryOp: n$J.operatorKeyword,
  "CallTag ValueName": n$J.atom,
  VariableName: n$J.variableName,
  Callee: n$J.operatorKeyword,
  Unit: n$J.unit,
  "UniversalSelector NestingSelector": n$J.definitionOperator,
  MatchOp: n$J.compareOperator,
  "ChildOp SiblingOp, LogicOp": n$J.logicOperator,
  BinOp: n$J.arithmeticOperator,
  Important: n$J.modifier,
  Comment: n$J.blockComment,
  ColorLiteral: n$J.color,
  "ParenthesizedContent StringLiteral": n$J.string,
  ":": n$J.punctuation,
  "PseudoOp #": n$J.derefOperator,
  "; ,": n$J.separator,
  "( )": n$J.paren,
  "[ ]": n$J.squareBracket,
  "{ }": n$J.brace
}), _$j = { __proto__: null, lang: 32, "nth-child": 32, "nth-last-child": 32, "nth-of-type": 32, "nth-last-of-type": 32, dir: 32, "host-context": 32, url: 60, "url-prefix": 60, domain: 60, regexp: 60, selector: 134 }, G$f = { __proto__: null, "@import": 114, "@media": 138, "@charset": 142, "@namespace": 146, "@keyframes": 152, "@supports": 164 }, V$g = { __proto__: null, not: 128, only: 128 }, Y$b = w$m.deserialize({
  version: 14,
  states: "9bQYQ[OOO#_Q[OOP#fOWOOOOQP'#Cd'#CdOOQP'#Cc'#CcO#kQ[O'#CfO$_QXO'#CaO$fQ[O'#ChO$qQ[O'#DPO$vQ[O'#DTOOQP'#Ej'#EjO${QdO'#DeO%gQ[O'#DrO${QdO'#DtO%xQ[O'#DvO&TQ[O'#DyO&]Q[O'#EPO&kQ[O'#EROOQS'#Ei'#EiOOQS'#EU'#EUQYQ[OOO&rQXO'#CdO'gQWO'#DaO'lQWO'#EpO'wQ[O'#EpQOQWOOP(RO#tO'#C_POOO)C@X)C@XOOQP'#Cg'#CgOOQP,59Q,59QO#kQ[O,59QO(^Q[O'#EXO(xQWO,58{O)QQ[O,59SO$qQ[O,59kO$vQ[O,59oO(^Q[O,59sO(^Q[O,59uO(^Q[O,59vO)]Q[O'#D`OOQS,58{,58{OOQP'#Ck'#CkOOQO'#C}'#C}OOQP,59S,59SO)dQWO,59SO)iQWO,59SOOQP'#DR'#DROOQP,59k,59kOOQO'#DV'#DVO)nQ`O,59oOOQS'#Cp'#CpO${QdO'#CqO)vQvO'#CsO+TQtO,5:POOQO'#Cx'#CxO)iQWO'#CwO+iQWO'#CyOOQS'#Em'#EmOOQO'#Dh'#DhO+nQ[O'#DoO+|QWO'#EqO&]Q[O'#DmO,[QWO'#DpOOQO'#Er'#ErO({QWO,5:^O,aQpO,5:`OOQS'#Dx'#DxO,iQWO,5:bO,nQ[O,5:bOOQO'#D{'#D{O,vQWO,5:eO,{QWO,5:kO-TQWO,5:mOOQS-E8S-E8SO${QdO,59{O-]Q[O'#EZO-jQWO,5;[O-jQWO,5;[POOO'#ET'#ETP-uO#tO,58yPOOO,58y,58yOOQP1G.l1G.lO.lQXO,5:sOOQO-E8V-E8VOOQS1G.g1G.gOOQP1G.n1G.nO)dQWO1G.nO)iQWO1G.nOOQP1G/V1G/VO.yQ`O1G/ZO/dQXO1G/_O/zQXO1G/aO0bQXO1G/bO0xQWO,59zO0}Q[O'#DOO1UQdO'#CoOOQP1G/Z1G/ZO${QdO1G/ZO1]QpO,59]OOQS,59_,59_O${QdO,59aO1eQWO1G/kOOQS,59c,59cO1jQ!bO,59eO1rQWO'#DhO1}QWO,5:TO2SQWO,5:ZO&]Q[O,5:VO&]Q[O'#E[O2[QWO,5;]O2gQWO,5:XO(^Q[O,5:[OOQS1G/x1G/xOOQS1G/z1G/zOOQS1G/|1G/|O2xQWO1G/|O2}QdO'#D|OOQS1G0P1G0POOQS1G0V1G0VOOQS1G0X1G0XO3YQtO1G/gOOQO,5:u,5:uO3pQ[O,5:uOOQO-E8X-E8XO3}QWO1G0vPOOO-E8R-E8RPOOO1G.e1G.eOOQP7+$Y7+$YOOQP7+$u7+$uO${QdO7+$uOOQS1G/f1G/fO4YQXO'#EoO4aQWO,59jO4fQtO'#EVO5ZQdO'#ElO5eQWO,59ZO5jQpO7+$uOOQS1G.w1G.wOOQS1G.{1G.{OOQS7+%V7+%VO5rQWO1G/PO${QdO1G/oOOQO1G/u1G/uOOQO1G/q1G/qO5wQWO,5:vOOQO-E8Y-E8YO6VQXO1G/vOOQS7+%h7+%hO6^QYO'#CsOOQO'#EO'#EOO6iQ`O'#D}OOQO'#D}'#D}O6tQWO'#E]O6|QdO,5:hOOQS,5:h,5:hO7XQtO'#EYO${QdO'#EYO8VQdO7+%ROOQO7+%R7+%ROOQO1G0a1G0aO8jQpO<<HaO8rQWO,5;ZOOQP1G/U1G/UOOQS-E8T-E8TO${QdO'#EWO8zQWO,5;WOOQT1G.u1G.uOOQP<<Ha<<HaOOQS7+$k7+$kO9SQdO7+%ZOOQO7+%b7+%bOOQO,5:i,5:iO3QQdO'#E^O6tQWO,5:wOOQS,5:w,5:wOOQS-E8Z-E8ZOOQS1G0S1G0SO9ZQtO,5:tOOQS-E8W-E8WOOQO<<Hm<<HmOOQPAN={AN={O:XQdO,5:rOOQO-E8U-E8UOOQO<<Hu<<HuOOQO,5:x,5:xOOQO-E8[-E8[OOQS1G0c1G0c",
  stateData: ":k~O#WOS#XQQ~OUYOXYO]VO^VOtWOxXO!YaO!ZZO!g[O!i]O!k^O!n_O!t`O#URO#_TO~OQfOUYOXYO]VO^VOtWOxXO!YaO!ZZO!g[O!i]O!k^O!n_O!t`O#UeO#_TO~O#R#dP~P!ZO#XjO~O#UlO~O]qO^qOpoOtrOxsO|tO!PvO#SuO#_nO~O!RwO~P#pO`}O#TzO#UyO~O#U!OO~O#U!QO~OQ!ZOb!TOf!ZOh!ZOn!YO#T!WO#U!SO#b!UO~Ob!]O!b!_O!e!`O#U![O!R#eP~Oh!eOn!YO#U!dO~Oh!gO#U!gO~Ob!]O!b!_O!e!`O#U![O~O!W#eP~P%gO]WX]!UX^WXpWXtWXxWX|WX!PWX!RWX#SWX#_WX~O]!lO~O!W!mO#R#dX!Q#dX~O#R#dX!Q#dX~P!ZO#Y!pO#Z!pO#[!rO~OUYOXYO]VO^VOtWOxXO#URO#_TO~OpoO!RwO~O`!yO#TzO#UyO~O!Q#dP~P!ZOb#QO~Ob#RO~Ov#SOz#TO~OP#VObgXjgX!WgX!bgX!egX#UgXagXQgXfgXhgXngXpgX!VgX#RgX#TgX#bgXvgX!QgX~Ob!]Oj#WO!b!_O!e!`O#U![O!W#eP~Ob#ZO~Ob!]O!b!_O!e!`O#U#[O~Op#`O!`#_O!R#eX!W#eX~Ob#cO~Oj#WO!W#eO~O!W#fO~Oh#gOn!YO~O!R#hO~O!RwO!`#_O~O!RwO!W#kO~O!W!}X#R!}X!Q!}X~P!ZO!W!mO#R#da!Q#da~O#Y!pO#Z!pO#[#rO~O]qO^qOtrOxsO|tO!PvO#SuO#_nO~Op!{a!R!{aa!{a~P.QOv#tOz#uO~O]qO^qOtrOxsO#_nO~Op{i|{i!P{i!R{i#S{ia{i~P/ROp}i|}i!P}i!R}i#S}ia}i~P/ROp!Oi|!Oi!P!Oi!R!Oi#S!Oia!Oi~P/RO!Q#vO~Oa#cP~P(^Oa#`P~P${Oa#}Oj#WO~O!W$PO~Oh$QOo$QO~O]!^Xa![X!`![X~O]$RO~Oa$SO!`#_O~Op#`O!R#ea!W#ea~O!`#_Op!aa!R!aa!W!aaa!aa~O!W$XO~O!Q$`O#U$ZO#b$YO~Oj#WOp$bO!V$dO!W!Ti#R!Ti!Q!Ti~P${O!W!}a#R!}a!Q!}a~P!ZO!W!mO#R#di!Q#di~Oa#cX~P#pOa$hO~Oj#WOQ!yXa!yXb!yXf!yXh!yXn!yXp!yX#T!yX#U!yX#b!yX~Op$jOa#`X~P${Oa$lO~Oj#WOv$mO~Oa$nO~O!`#_Op#Oa!R#Oa!W#Oa~Oa$pO~P.QOP#VOpgX!RgX~O#b$YOp!qX!R!qX~Op$rO!RwO~O!Q$vO#U$ZO#b$YO~Oj#WOQ!|Xb!|Xf!|Xh!|Xn!|Xp!|X!V!|X!W!|X#R!|X#T!|X#U!|X#b!|X!Q!|X~Op$bO!V$yO!W!Tq#R!Tq!Q!Tq~P${Oj#WOv$zO~OpoOa#ca~Op$jOa#`a~Oa$}O~P${Oj#WOQ!|ab!|af!|ah!|an!|ap!|a!V!|a!W!|a#R!|a#T!|a#U!|a#b!|a!Q!|a~Oa!zap!za~P${O#Wo#X#bj!P#b~",
  goto: "-Y#gPPP#hP#kP#t$TP#t$d#tPP$jPPP$p$y$yP%]P$yP$y%w&ZPPP&s&y#tP'PP#tP'VP#tP#t#tPPP']'r(PPP#kPP(W(W(b(WP(WP(W(WP#kP#kP#kP(e#kP(h(k(n(u#kP#kP(z)Q)a)o)u*P*V*a*g*mPPPPPPPPPP*s*|P+i+lP,b,e,k,tRkQ_bOPdhw!m#nkYOPdhotuvw!m#Q#c#nkSOPdhotuvw!m#Q#c#nQmTR!snQ{VR!wqQ!w}Q#Y!XR#s!yq!ZZ]!T!l#R#T#W#l#u#z$R$b$c$j$o${p!ZZ]!T!l#R#T#W#l#u#z$R$b$c$j$o${U$]#h$_$rR$q$[q!XZ]!T!l#R#T#W#l#u#z$R$b$c$j$o${p!ZZ]!T!l#R#T#W#l#u#z$R$b$c$j$o${Q!e^R#g!fQ|VR!xqQ!w|R#s!xQ!PWR!zrQ!RXR!{sQxUQ!vpQ#d!bQ#j!iQ#k!jQ$t$^R%Q$sSgPwQ!ohQ#m!mR$e#nZfPhw!m#na!a[`a!V!]!_#_#`R#]!]R!f^R!h_R#i!hS$^#h$_R%O$rV$[#h$_$rQ!qjR#q!qQdOShPwU!kdh#nR#n!mQ#z#RU$i#z$o${Q$o$RR${$jQ$k#zR$|$kQpUS!up$gR$g#wQ$c#lR$x$cQ!ngS#o!n#pR#p!oQ#a!^R$V#aQ$_#hR$u$_Q$s$^R%P$s_cOPdhw!m#n^UOPdhw!m#nQ!toQ!|tQ!}uQ#OvQ#w#QR$W#cR#{#RQ!VZQ!c]Q#U!TQ#l!l[#y#R#z$R$j$o${Q#|#TQ$O#WS$a#l$cQ$f#uR$w$bR#x#QQiPR#PwQ!b[Q!jaR#X!VU!^[a!VQ!i`Q#^!]Q#b!_Q$T#_R$U#`",
  nodeNames: "\u26A0 Unit VariableName Comment StyleSheet RuleSet UniversalSelector TagSelector TagName NestingSelector ClassSelector ClassName PseudoClassSelector : :: PseudoClassName PseudoClassName ) ( ArgList ValueName ParenthesizedValue ColorLiteral NumberLiteral StringLiteral BinaryExpression BinOp CallExpression Callee CallLiteral CallTag ParenthesizedContent , PseudoClassName ArgList IdSelector # IdName ] AttributeSelector [ AttributeName MatchOp ChildSelector ChildOp DescendantSelector SiblingSelector SiblingOp } { Block Declaration PropertyName Important ; ImportStatement AtKeyword import KeywordQuery FeatureQuery FeatureName BinaryQuery LogicOp UnaryQuery UnaryQueryOp ParenthesizedQuery SelectorQuery selector MediaStatement media CharsetStatement charset NamespaceStatement namespace NamespaceName KeyframesStatement keyframes KeyframeName KeyframeList KeyframeSelector KeyframeRangeName SupportsStatement supports AtRule Styles",
  maxTerm: 114,
  nodeProps: [
    ["openedBy", 17, "(", 48, "{"],
    ["closedBy", 18, ")", 49, "}"]
  ],
  propSources: [Z$c],
  skippedNodes: [0, 3, 85],
  repeatNodeCount: 10,
  tokenData: "J^~R!^OX$}X^%u^p$}pq%uqr)Xrs.Rst/utu6duv$}vw7^wx7oxy9^yz9oz{9t{|:_|}?Q}!O?c!O!P@Q!P!Q@i!Q![Ab![!]B]!]!^CX!^!_$}!_!`Cj!`!aC{!a!b$}!b!cDw!c!}$}!}#OFa#O#P$}#P#QFr#Q#R6d#R#T$}#T#UGT#U#c$}#c#dHf#d#o$}#o#pH{#p#q6d#q#rI^#r#sIo#s#y$}#y#z%u#z$f$}$f$g%u$g#BY$}#BY#BZ%u#BZ$IS$}$IS$I_%u$I_$I|$}$I|$JO%u$JO$JT$}$JT$JU%u$JU$KV$}$KV$KW%u$KW&FU$}&FU&FV%u&FV;'S$};'S;=`JW<%lO$}`%QSOy%^z;'S%^;'S;=`%o<%lO%^`%cSo`Oy%^z;'S%^;'S;=`%o<%lO%^`%rP;=`<%l%^~%zh#W~OX%^X^'f^p%^pq'fqy%^z#y%^#y#z'f#z$f%^$f$g'f$g#BY%^#BY#BZ'f#BZ$IS%^$IS$I_'f$I_$I|%^$I|$JO'f$JO$JT%^$JT$JU'f$JU$KV%^$KV$KW'f$KW&FU%^&FU&FV'f&FV;'S%^;'S;=`%o<%lO%^~'mh#W~o`OX%^X^'f^p%^pq'fqy%^z#y%^#y#z'f#z$f%^$f$g'f$g#BY%^#BY#BZ'f#BZ$IS%^$IS$I_'f$I_$I|%^$I|$JO'f$JO$JT%^$JT$JU'f$JU$KV%^$KV$KW'f$KW&FU%^&FU&FV'f&FV;'S%^;'S;=`%o<%lO%^l)[UOy%^z#]%^#]#^)n#^;'S%^;'S;=`%o<%lO%^l)sUo`Oy%^z#a%^#a#b*V#b;'S%^;'S;=`%o<%lO%^l*[Uo`Oy%^z#d%^#d#e*n#e;'S%^;'S;=`%o<%lO%^l*sUo`Oy%^z#c%^#c#d+V#d;'S%^;'S;=`%o<%lO%^l+[Uo`Oy%^z#f%^#f#g+n#g;'S%^;'S;=`%o<%lO%^l+sUo`Oy%^z#h%^#h#i,V#i;'S%^;'S;=`%o<%lO%^l,[Uo`Oy%^z#T%^#T#U,n#U;'S%^;'S;=`%o<%lO%^l,sUo`Oy%^z#b%^#b#c-V#c;'S%^;'S;=`%o<%lO%^l-[Uo`Oy%^z#h%^#h#i-n#i;'S%^;'S;=`%o<%lO%^l-uS!V[o`Oy%^z;'S%^;'S;=`%o<%lO%^~.UWOY.RZr.Rrs.ns#O.R#O#P.s#P;'S.R;'S;=`/o<%lO.R~.sOh~~.vRO;'S.R;'S;=`/P;=`O.R~/SXOY.RZr.Rrs.ns#O.R#O#P.s#P;'S.R;'S;=`/o;=`<%l.R<%lO.R~/rP;=`<%l.Rn/zYtQOy%^z!Q%^!Q![0j![!c%^!c!i0j!i#T%^#T#Z0j#Z;'S%^;'S;=`%o<%lO%^l0oYo`Oy%^z!Q%^!Q![1_![!c%^!c!i1_!i#T%^#T#Z1_#Z;'S%^;'S;=`%o<%lO%^l1dYo`Oy%^z!Q%^!Q![2S![!c%^!c!i2S!i#T%^#T#Z2S#Z;'S%^;'S;=`%o<%lO%^l2ZYf[o`Oy%^z!Q%^!Q![2y![!c%^!c!i2y!i#T%^#T#Z2y#Z;'S%^;'S;=`%o<%lO%^l3QYf[o`Oy%^z!Q%^!Q![3p![!c%^!c!i3p!i#T%^#T#Z3p#Z;'S%^;'S;=`%o<%lO%^l3uYo`Oy%^z!Q%^!Q![4e![!c%^!c!i4e!i#T%^#T#Z4e#Z;'S%^;'S;=`%o<%lO%^l4lYf[o`Oy%^z!Q%^!Q![5[![!c%^!c!i5[!i#T%^#T#Z5[#Z;'S%^;'S;=`%o<%lO%^l5aYo`Oy%^z!Q%^!Q![6P![!c%^!c!i6P!i#T%^#T#Z6P#Z;'S%^;'S;=`%o<%lO%^l6WSf[o`Oy%^z;'S%^;'S;=`%o<%lO%^d6gUOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^d7QSzSo`Oy%^z;'S%^;'S;=`%o<%lO%^b7cSXQOy%^z;'S%^;'S;=`%o<%lO%^~7rWOY7oZw7owx.nx#O7o#O#P8[#P;'S7o;'S;=`9W<%lO7o~8_RO;'S7o;'S;=`8h;=`O7o~8kXOY7oZw7owx.nx#O7o#O#P8[#P;'S7o;'S;=`9W;=`<%l7o<%lO7o~9ZP;=`<%l7on9cSb^Oy%^z;'S%^;'S;=`%o<%lO%^~9tOa~n9{UUQjWOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^n:fWjW!PQOy%^z!O%^!O!P;O!P!Q%^!Q![>T![;'S%^;'S;=`%o<%lO%^l;TUo`Oy%^z!Q%^!Q![;g![;'S%^;'S;=`%o<%lO%^l;nYo`#b[Oy%^z!Q%^!Q![;g![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^l<cYo`Oy%^z{%^{|=R|}%^}!O=R!O!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l=WUo`Oy%^z!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l=qUo`#b[Oy%^z!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l>[[o`#b[Oy%^z!O%^!O!P;g!P!Q%^!Q![>T![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^n?VSp^Oy%^z;'S%^;'S;=`%o<%lO%^l?hWjWOy%^z!O%^!O!P;O!P!Q%^!Q![>T![;'S%^;'S;=`%o<%lO%^n@VU#_QOy%^z!Q%^!Q![;g![;'S%^;'S;=`%o<%lO%^~@nTjWOy%^z{@}{;'S%^;'S;=`%o<%lO%^~AUSo`#X~Oy%^z;'S%^;'S;=`%o<%lO%^lAg[#b[Oy%^z!O%^!O!P;g!P!Q%^!Q![>T![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^bBbU]QOy%^z![%^![!]Bt!];'S%^;'S;=`%o<%lO%^bB{S^Qo`Oy%^z;'S%^;'S;=`%o<%lO%^nC^S!W^Oy%^z;'S%^;'S;=`%o<%lO%^dCoSzSOy%^z;'S%^;'S;=`%o<%lO%^bDQU|QOy%^z!`%^!`!aDd!a;'S%^;'S;=`%o<%lO%^bDkS|Qo`Oy%^z;'S%^;'S;=`%o<%lO%^bDzWOy%^z!c%^!c!}Ed!}#T%^#T#oEd#o;'S%^;'S;=`%o<%lO%^bEk[!YQo`Oy%^z}%^}!OEd!O!Q%^!Q![Ed![!c%^!c!}Ed!}#T%^#T#oEd#o;'S%^;'S;=`%o<%lO%^bFfSxQOy%^z;'S%^;'S;=`%o<%lO%^lFwSv[Oy%^z;'S%^;'S;=`%o<%lO%^bGWUOy%^z#b%^#b#cGj#c;'S%^;'S;=`%o<%lO%^bGoUo`Oy%^z#W%^#W#XHR#X;'S%^;'S;=`%o<%lO%^bHYS!`Qo`Oy%^z;'S%^;'S;=`%o<%lO%^bHiUOy%^z#f%^#f#gHR#g;'S%^;'S;=`%o<%lO%^fIQS!RUOy%^z;'S%^;'S;=`%o<%lO%^nIcS!Q^Oy%^z;'S%^;'S;=`%o<%lO%^fItU!PQOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^`JZP;=`<%l$}",
  tokenizers: [U$i, h$_, u$$, 1, 2, 3, 4, new H$f("m~RRYZ[z{a~~g~aO#Z~~dP!P!Qg~lO#[~~", 28, 102)],
  topRules: { StyleSheet: [0, 4], Styles: [1, 84] },
  specialized: [{ term: 97, get: (e28) => _$j[e28] || -1 }, { term: 56, get: (e28) => G$f[e28] || -1 }, { term: 98, get: (e28) => V$g[e28] || -1 }],
  tokenPrec: 1169
});
let c$18 = null;
function u$_() {
  if (!c$18 && typeof document == "object" && document.body) {
    let { style: r3 } = document.body, a3 = [], o3 = /* @__PURE__ */ new Set();
    for (let t3 in r3)
      t3 != "cssText" && t3 != "cssFloat" && typeof r3[t3] == "string" && (/[A-Z]/.test(t3) && (t3 = t3.replace(/[A-Z]/g, (e28) => "-" + e28.toLowerCase())), o3.has(t3) || (a3.push(t3), o3.add(t3)));
    c$18 = a3.sort().map((t3) => ({ type: "property", label: t3 }));
  }
  return c$18 || [];
}
const p$2S = /* @__PURE__ */ [
  "active",
  "after",
  "any-link",
  "autofill",
  "backdrop",
  "before",
  "checked",
  "cue",
  "default",
  "defined",
  "disabled",
  "empty",
  "enabled",
  "file-selector-button",
  "first",
  "first-child",
  "first-letter",
  "first-line",
  "first-of-type",
  "focus",
  "focus-visible",
  "focus-within",
  "fullscreen",
  "has",
  "host",
  "host-context",
  "hover",
  "in-range",
  "indeterminate",
  "invalid",
  "is",
  "lang",
  "last-child",
  "last-of-type",
  "left",
  "link",
  "marker",
  "modal",
  "not",
  "nth-child",
  "nth-last-child",
  "nth-last-of-type",
  "nth-of-type",
  "only-child",
  "only-of-type",
  "optional",
  "out-of-range",
  "part",
  "placeholder",
  "placeholder-shown",
  "read-only",
  "read-write",
  "required",
  "right",
  "root",
  "scope",
  "selection",
  "slotted",
  "target",
  "target-text",
  "valid",
  "visited",
  "where"
].map((r3) => ({ type: "class", label: r3 })), m$1b = /* @__PURE__ */ [
  "above",
  "absolute",
  "activeborder",
  "additive",
  "activecaption",
  "after-white-space",
  "ahead",
  "alias",
  "all",
  "all-scroll",
  "alphabetic",
  "alternate",
  "always",
  "antialiased",
  "appworkspace",
  "asterisks",
  "attr",
  "auto",
  "auto-flow",
  "avoid",
  "avoid-column",
  "avoid-page",
  "avoid-region",
  "axis-pan",
  "background",
  "backwards",
  "baseline",
  "below",
  "bidi-override",
  "blink",
  "block",
  "block-axis",
  "bold",
  "bolder",
  "border",
  "border-box",
  "both",
  "bottom",
  "break",
  "break-all",
  "break-word",
  "bullets",
  "button",
  "button-bevel",
  "buttonface",
  "buttonhighlight",
  "buttonshadow",
  "buttontext",
  "calc",
  "capitalize",
  "caps-lock-indicator",
  "caption",
  "captiontext",
  "caret",
  "cell",
  "center",
  "checkbox",
  "circle",
  "cjk-decimal",
  "clear",
  "clip",
  "close-quote",
  "col-resize",
  "collapse",
  "color",
  "color-burn",
  "color-dodge",
  "column",
  "column-reverse",
  "compact",
  "condensed",
  "contain",
  "content",
  "contents",
  "content-box",
  "context-menu",
  "continuous",
  "copy",
  "counter",
  "counters",
  "cover",
  "crop",
  "cross",
  "crosshair",
  "currentcolor",
  "cursive",
  "cyclic",
  "darken",
  "dashed",
  "decimal",
  "decimal-leading-zero",
  "default",
  "default-button",
  "dense",
  "destination-atop",
  "destination-in",
  "destination-out",
  "destination-over",
  "difference",
  "disc",
  "discard",
  "disclosure-closed",
  "disclosure-open",
  "document",
  "dot-dash",
  "dot-dot-dash",
  "dotted",
  "double",
  "down",
  "e-resize",
  "ease",
  "ease-in",
  "ease-in-out",
  "ease-out",
  "element",
  "ellipse",
  "ellipsis",
  "embed",
  "end",
  "ethiopic-abegede-gez",
  "ethiopic-halehame-aa-er",
  "ethiopic-halehame-gez",
  "ew-resize",
  "exclusion",
  "expanded",
  "extends",
  "extra-condensed",
  "extra-expanded",
  "fantasy",
  "fast",
  "fill",
  "fill-box",
  "fixed",
  "flat",
  "flex",
  "flex-end",
  "flex-start",
  "footnotes",
  "forwards",
  "from",
  "geometricPrecision",
  "graytext",
  "grid",
  "groove",
  "hand",
  "hard-light",
  "help",
  "hidden",
  "hide",
  "higher",
  "highlight",
  "highlighttext",
  "horizontal",
  "hsl",
  "hsla",
  "hue",
  "icon",
  "ignore",
  "inactiveborder",
  "inactivecaption",
  "inactivecaptiontext",
  "infinite",
  "infobackground",
  "infotext",
  "inherit",
  "initial",
  "inline",
  "inline-axis",
  "inline-block",
  "inline-flex",
  "inline-grid",
  "inline-table",
  "inset",
  "inside",
  "intrinsic",
  "invert",
  "italic",
  "justify",
  "keep-all",
  "landscape",
  "large",
  "larger",
  "left",
  "level",
  "lighter",
  "lighten",
  "line-through",
  "linear",
  "linear-gradient",
  "lines",
  "list-item",
  "listbox",
  "listitem",
  "local",
  "logical",
  "loud",
  "lower",
  "lower-hexadecimal",
  "lower-latin",
  "lower-norwegian",
  "lowercase",
  "ltr",
  "luminosity",
  "manipulation",
  "match",
  "matrix",
  "matrix3d",
  "medium",
  "menu",
  "menutext",
  "message-box",
  "middle",
  "min-intrinsic",
  "mix",
  "monospace",
  "move",
  "multiple",
  "multiple_mask_images",
  "multiply",
  "n-resize",
  "narrower",
  "ne-resize",
  "nesw-resize",
  "no-close-quote",
  "no-drop",
  "no-open-quote",
  "no-repeat",
  "none",
  "normal",
  "not-allowed",
  "nowrap",
  "ns-resize",
  "numbers",
  "numeric",
  "nw-resize",
  "nwse-resize",
  "oblique",
  "opacity",
  "open-quote",
  "optimizeLegibility",
  "optimizeSpeed",
  "outset",
  "outside",
  "outside-shape",
  "overlay",
  "overline",
  "padding",
  "padding-box",
  "painted",
  "page",
  "paused",
  "perspective",
  "pinch-zoom",
  "plus-darker",
  "plus-lighter",
  "pointer",
  "polygon",
  "portrait",
  "pre",
  "pre-line",
  "pre-wrap",
  "preserve-3d",
  "progress",
  "push-button",
  "radial-gradient",
  "radio",
  "read-only",
  "read-write",
  "read-write-plaintext-only",
  "rectangle",
  "region",
  "relative",
  "repeat",
  "repeating-linear-gradient",
  "repeating-radial-gradient",
  "repeat-x",
  "repeat-y",
  "reset",
  "reverse",
  "rgb",
  "rgba",
  "ridge",
  "right",
  "rotate",
  "rotate3d",
  "rotateX",
  "rotateY",
  "rotateZ",
  "round",
  "row",
  "row-resize",
  "row-reverse",
  "rtl",
  "run-in",
  "running",
  "s-resize",
  "sans-serif",
  "saturation",
  "scale",
  "scale3d",
  "scaleX",
  "scaleY",
  "scaleZ",
  "screen",
  "scroll",
  "scrollbar",
  "scroll-position",
  "se-resize",
  "self-start",
  "self-end",
  "semi-condensed",
  "semi-expanded",
  "separate",
  "serif",
  "show",
  "single",
  "skew",
  "skewX",
  "skewY",
  "skip-white-space",
  "slide",
  "slider-horizontal",
  "slider-vertical",
  "sliderthumb-horizontal",
  "sliderthumb-vertical",
  "slow",
  "small",
  "small-caps",
  "small-caption",
  "smaller",
  "soft-light",
  "solid",
  "source-atop",
  "source-in",
  "source-out",
  "source-over",
  "space",
  "space-around",
  "space-between",
  "space-evenly",
  "spell-out",
  "square",
  "start",
  "static",
  "status-bar",
  "stretch",
  "stroke",
  "stroke-box",
  "sub",
  "subpixel-antialiased",
  "svg_masks",
  "super",
  "sw-resize",
  "symbolic",
  "symbols",
  "system-ui",
  "table",
  "table-caption",
  "table-cell",
  "table-column",
  "table-column-group",
  "table-footer-group",
  "table-header-group",
  "table-row",
  "table-row-group",
  "text",
  "text-bottom",
  "text-top",
  "textarea",
  "textfield",
  "thick",
  "thin",
  "threeddarkshadow",
  "threedface",
  "threedhighlight",
  "threedlightshadow",
  "threedshadow",
  "to",
  "top",
  "transform",
  "translate",
  "translate3d",
  "translateX",
  "translateY",
  "translateZ",
  "transparent",
  "ultra-condensed",
  "ultra-expanded",
  "underline",
  "unidirectional-pan",
  "unset",
  "up",
  "upper-latin",
  "uppercase",
  "url",
  "var",
  "vertical",
  "vertical-text",
  "view-box",
  "visible",
  "visibleFill",
  "visiblePainted",
  "visibleStroke",
  "visual",
  "w-resize",
  "wait",
  "wave",
  "wider",
  "window",
  "windowframe",
  "windowtext",
  "words",
  "wrap",
  "wrap-reverse",
  "x-large",
  "x-small",
  "xor",
  "xx-large",
  "xx-small"
].map((r3) => ({ type: "keyword", label: r3 })).concat(/* @__PURE__ */ [
  "aliceblue",
  "antiquewhite",
  "aqua",
  "aquamarine",
  "azure",
  "beige",
  "bisque",
  "black",
  "blanchedalmond",
  "blue",
  "blueviolet",
  "brown",
  "burlywood",
  "cadetblue",
  "chartreuse",
  "chocolate",
  "coral",
  "cornflowerblue",
  "cornsilk",
  "crimson",
  "cyan",
  "darkblue",
  "darkcyan",
  "darkgoldenrod",
  "darkgray",
  "darkgreen",
  "darkkhaki",
  "darkmagenta",
  "darkolivegreen",
  "darkorange",
  "darkorchid",
  "darkred",
  "darksalmon",
  "darkseagreen",
  "darkslateblue",
  "darkslategray",
  "darkturquoise",
  "darkviolet",
  "deeppink",
  "deepskyblue",
  "dimgray",
  "dodgerblue",
  "firebrick",
  "floralwhite",
  "forestgreen",
  "fuchsia",
  "gainsboro",
  "ghostwhite",
  "gold",
  "goldenrod",
  "gray",
  "grey",
  "green",
  "greenyellow",
  "honeydew",
  "hotpink",
  "indianred",
  "indigo",
  "ivory",
  "khaki",
  "lavender",
  "lavenderblush",
  "lawngreen",
  "lemonchiffon",
  "lightblue",
  "lightcoral",
  "lightcyan",
  "lightgoldenrodyellow",
  "lightgray",
  "lightgreen",
  "lightpink",
  "lightsalmon",
  "lightseagreen",
  "lightskyblue",
  "lightslategray",
  "lightsteelblue",
  "lightyellow",
  "lime",
  "limegreen",
  "linen",
  "magenta",
  "maroon",
  "mediumaquamarine",
  "mediumblue",
  "mediumorchid",
  "mediumpurple",
  "mediumseagreen",
  "mediumslateblue",
  "mediumspringgreen",
  "mediumturquoise",
  "mediumvioletred",
  "midnightblue",
  "mintcream",
  "mistyrose",
  "moccasin",
  "navajowhite",
  "navy",
  "oldlace",
  "olive",
  "olivedrab",
  "orange",
  "orangered",
  "orchid",
  "palegoldenrod",
  "palegreen",
  "paleturquoise",
  "palevioletred",
  "papayawhip",
  "peachpuff",
  "peru",
  "pink",
  "plum",
  "powderblue",
  "purple",
  "rebeccapurple",
  "red",
  "rosybrown",
  "royalblue",
  "saddlebrown",
  "salmon",
  "sandybrown",
  "seagreen",
  "seashell",
  "sienna",
  "silver",
  "skyblue",
  "slateblue",
  "slategray",
  "snow",
  "springgreen",
  "steelblue",
  "tan",
  "teal",
  "thistle",
  "tomato",
  "turquoise",
  "violet",
  "wheat",
  "white",
  "whitesmoke",
  "yellow",
  "yellowgreen"
].map((r3) => ({ type: "constant", label: r3 }))), F$h = /* @__PURE__ */ [
  "a",
  "abbr",
  "address",
  "article",
  "aside",
  "b",
  "bdi",
  "bdo",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "figcaption",
  "figure",
  "footer",
  "form",
  "header",
  "hgroup",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "main",
  "meter",
  "nav",
  "ol",
  "output",
  "p",
  "pre",
  "ruby",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "tr",
  "u",
  "ul"
].map((r3) => ({ type: "type", label: r3 })), s$15 = /^(\w[\w-]*|-\w[\w-]*|)$/, N$s = /^-(-[\w-]*)?$/;
function L$n(r3, a3) {
  var o3;
  if ((r3.name == "(" || r3.type.isError) && (r3 = r3.parent || r3), r3.name != "ArgList")
    return false;
  let t3 = (o3 = r3.parent) === null || o3 === void 0 ? void 0 : o3.firstChild;
  return (t3 == null ? void 0 : t3.name) != "Callee" ? false : a3.sliceString(t3.from, t3.to) == "var";
}
const h$Z = /* @__PURE__ */ new Me$4(), P$x = ["Declaration"];
function T$p(r3) {
  for (let a3 = r3; ; ) {
    if (a3.type.isTop)
      return a3;
    if (!(a3 = a3.parent))
      return r3;
  }
}
function b$A(r3, a3, o3) {
  if (a3.to - a3.from > 4096) {
    let t3 = h$Z.get(a3);
    if (t3)
      return t3;
    let e28 = [], l3 = /* @__PURE__ */ new Set(), i = a3.cursor(k$v.IncludeAnonymous);
    if (i.firstChild())
      do
        for (let n3 of b$A(r3, i.node, o3))
          l3.has(n3.label) || (l3.add(n3.label), e28.push(n3));
      while (i.nextSibling());
    return h$Z.set(a3, e28), e28;
  } else {
    let t3 = [], e28 = /* @__PURE__ */ new Set();
    return a3.cursor().iterate((l3) => {
      var i;
      if (o3(l3) && l3.matchContext(P$x) && ((i = l3.node.nextSibling) === null || i === void 0 ? void 0 : i.name) == ":") {
        let n3 = r3.sliceString(l3.from, l3.to);
        e28.has(n3) || (e28.add(n3), t3.push({ label: n3, type: "variable" }));
      }
    }), t3;
  }
}
const A$i = (r3) => (a3) => {
  let { state: o3, pos: t3 } = a3, e28 = k$t(o3).resolveInner(t3, -1), l3 = e28.type.isError && e28.from == e28.to - 1 && o3.doc.sliceString(e28.from, e28.to) == "-";
  if (e28.name == "PropertyName" || (l3 || e28.name == "TagName") && /^(Block|Styles)$/.test(e28.resolve(e28.to).name))
    return { from: e28.from, options: u$_(), validFor: s$15 };
  if (e28.name == "ValueName")
    return { from: e28.from, options: m$1b, validFor: s$15 };
  if (e28.name == "PseudoClassName")
    return { from: e28.from, options: p$2S, validFor: s$15 };
  if (r3(e28) || (a3.explicit || l3) && L$n(e28, o3.doc))
    return {
      from: r3(e28) || l3 ? e28.from : t3,
      options: b$A(o3.doc, T$p(e28), r3),
      validFor: N$s
    };
  if (e28.name == "TagName") {
    for (let { parent: d3 } = e28; d3; d3 = d3.parent)
      if (d3.name == "Block")
        return { from: e28.from, options: u$_(), validFor: s$15 };
    return { from: e28.from, options: F$h, validFor: s$15 };
  }
  if (!a3.explicit)
    return null;
  let i = e28.resolve(t3), n3 = i.childBefore(t3);
  return n3 && n3.name == ":" && i.name == "PseudoClassSelector" ? { from: t3, options: p$2S, validFor: s$15 } : n3 && n3.name == ":" && i.name == "Declaration" || i.name == "ArgList" ? { from: t3, options: m$1b, validFor: s$15 } : i.name == "Block" || i.name == "Styles" ? { from: t3, options: u$_(), validFor: s$15 } : null;
}, B$m = /* @__PURE__ */ A$i((r3) => r3.name == "VariableName"), g$E = /* @__PURE__ */ G$h.define({
  name: "css",
  parser: /* @__PURE__ */ Y$b.configure({
    props: [
      /* @__PURE__ */ ze$4.add({
        Declaration: /* @__PURE__ */ Et$5()
      }),
      /* @__PURE__ */ _e$7.add({
        "Block KeyframeList": Ht$3
      })
    ]
  }),
  languageData: {
    commentTokens: { block: { open: "/*", close: "*/" } },
    indentOnInput: /^\s*\}$/,
    wordChars: "-"
  }
});
function Z$b() {
  return new It$5(g$E, g$E.data.of({ autocomplete: B$m }));
}
const F$g = 54, K$b = 1, J$b = 55, L$m = 2, ee$8 = 56, te$8 = 3, Q$c = 4, Oe$4 = 5, p$2R = 6, R$d = 7, y$w = 8, Z$a = 9, B$l = 10, re$7 = 11, ae$9 = 12, se$9 = 13, i$V = 57, le$7 = 14, k$q = 58, W$9 = 20, Se$3 = 22, E$m = 23, ne$a = 24, g$D = 26, z$c = 27, oe$9 = 28, Pe$5 = 31, ce$6 = 34, Ve$4 = 36, xe$6 = 37, fe$6 = 0, ue$7 = 1, Te$5 = {
  area: true,
  base: true,
  br: true,
  col: true,
  command: true,
  embed: true,
  frame: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true,
  menuitem: true
}, pe$7 = {
  dd: true,
  li: true,
  optgroup: true,
  option: true,
  p: true,
  rp: true,
  rt: true,
  tbody: true,
  td: true,
  tfoot: true,
  th: true,
  tr: true
}, b$z = {
  dd: { dd: true, dt: true },
  dt: { dd: true, dt: true },
  li: { li: true },
  option: { option: true, optgroup: true },
  optgroup: { optgroup: true },
  p: {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    dir: true,
    div: true,
    dl: true,
    fieldset: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    menu: true,
    nav: true,
    ol: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    ul: true
  },
  rp: { rp: true, rt: true },
  rt: { rp: true, rt: true },
  tbody: { tbody: true, tfoot: true },
  td: { td: true, th: true },
  tfoot: { tbody: true },
  th: { td: true, th: true },
  thead: { tbody: true, tfoot: true },
  tr: { tr: true }
};
function he$8(e28) {
  return e28 == 45 || e28 == 46 || e28 == 58 || e28 >= 65 && e28 <= 90 || e28 == 95 || e28 >= 97 && e28 <= 122 || e28 >= 161;
}
function D$s(e28) {
  return e28 == 9 || e28 == 10 || e28 == 13 || e28 == 32;
}
let Y$a = null, v$C = null, C$D = 0;
function m$1a(e28, t3) {
  let a3 = e28.pos + t3;
  if (C$D == a3 && v$C == e28)
    return Y$a;
  let r3 = e28.peek(t3);
  for (; D$s(r3); )
    r3 = e28.peek(++t3);
  let O3 = "";
  for (; he$8(r3); )
    O3 += String.fromCharCode(r3), r3 = e28.peek(++t3);
  return v$C = e28, C$D = a3, Y$a = O3 ? O3.toLowerCase() : r3 == Xe$4 || r3 == ie$8 ? void 0 : null;
}
const G$e = 60, h$Y = 62, $$b = 47, Xe$4 = 63, ie$8 = 33, de$8 = 45;
function A$h(e28, t3) {
  this.name = e28, this.parent = t3, this.hash = t3 ? t3.hash : 0;
  for (let a3 = 0; a3 < e28.length; a3++)
    this.hash += (this.hash << 4) + e28.charCodeAt(a3) + (e28.charCodeAt(a3) << 8);
}
const ge$6 = [p$2R, B$l, R$d, y$w, Z$a], me$8 = new Z$d({
  start: null,
  shift(e28, t3, a3, r3) {
    return ge$6.indexOf(t3) > -1 ? new A$h(m$1a(r3, 1) || "", e28) : e28;
  },
  reduce(e28, t3) {
    return t3 == W$9 && e28 ? e28.parent : e28;
  },
  reuse(e28, t3, a3, r3) {
    let O3 = t3.type.id;
    return O3 == p$2R || O3 == Ve$4 ? new A$h(m$1a(r3, 1) || "", e28) : e28;
  },
  hash(e28) {
    return e28 ? e28.hash : 0;
  },
  strict: false
}), $e$2 = new Y$c((e28, t3) => {
  if (e28.next != G$e) {
    e28.next < 0 && t3.context && e28.acceptToken(i$V);
    return;
  }
  e28.advance();
  let a3 = e28.next == $$b;
  a3 && e28.advance();
  let r3 = m$1a(e28, 0);
  if (r3 === void 0)
    return;
  if (!r3)
    return e28.acceptToken(a3 ? le$7 : p$2R);
  let O3 = t3.context ? t3.context.name : null;
  if (a3) {
    if (r3 == O3)
      return e28.acceptToken(re$7);
    if (O3 && pe$7[O3])
      return e28.acceptToken(i$V, -2);
    if (t3.dialectEnabled(fe$6))
      return e28.acceptToken(ae$9);
    for (let s3 = t3.context; s3; s3 = s3.parent)
      if (s3.name == r3)
        return;
    e28.acceptToken(se$9);
  } else {
    if (r3 == "script")
      return e28.acceptToken(R$d);
    if (r3 == "style")
      return e28.acceptToken(y$w);
    if (r3 == "textarea")
      return e28.acceptToken(Z$a);
    if (Te$5.hasOwnProperty(r3))
      return e28.acceptToken(B$l);
    O3 && b$z[O3] && b$z[O3][r3] ? e28.acceptToken(i$V, -1) : e28.acceptToken(p$2R);
  }
}, { contextual: true }), we$7 = new Y$c((e28) => {
  for (let t3 = 0, a3 = 0; ; a3++) {
    if (e28.next < 0) {
      a3 && e28.acceptToken(k$q);
      break;
    }
    if (e28.next == de$8)
      t3++;
    else if (e28.next == h$Y && t3 >= 2) {
      a3 > 3 && e28.acceptToken(k$q, -2);
      break;
    } else
      t3 = 0;
    e28.advance();
  }
});
function _e$5(e28) {
  for (; e28; e28 = e28.parent)
    if (e28.name == "svg" || e28.name == "math")
      return true;
  return false;
}
const qe$3 = new Y$c((e28, t3) => {
  if (e28.next == $$b && e28.peek(1) == h$Y) {
    let a3 = t3.dialectEnabled(ue$7) || _e$5(t3.context);
    e28.acceptToken(a3 ? Oe$4 : Q$c, 2);
  } else
    e28.next == h$Y && e28.acceptToken(Q$c, 1);
});
function w$l(e28, t3, a3) {
  let r3 = 2 + e28.length;
  return new Y$c((O3) => {
    for (let s3 = 0, o3 = 0, l3 = 0; ; l3++) {
      if (O3.next < 0) {
        l3 && O3.acceptToken(t3);
        break;
      }
      if (s3 == 0 && O3.next == G$e || s3 == 1 && O3.next == $$b || s3 >= 2 && s3 < r3 && O3.next == e28.charCodeAt(s3 - 2))
        s3++, o3++;
      else if ((s3 == 2 || s3 == r3) && D$s(O3.next))
        o3++;
      else if (s3 == r3 && O3.next == h$Y) {
        l3 > o3 ? O3.acceptToken(t3, -o3) : O3.acceptToken(a3, -(o3 - 2));
        break;
      } else if ((O3.next == 10 || O3.next == 13) && l3) {
        O3.acceptToken(t3, 1);
        break;
      } else
        s3 = o3 = 0;
      O3.advance();
    }
  });
}
const Qe$3 = w$l("script", F$g, K$b), ke$5 = w$l("style", J$b, L$m), be$6 = w$l("textarea", ee$8, te$8), Ye$2 = $$d({
  "Text RawText": n$J.content,
  "StartTag StartCloseTag SelfClosingEndTag EndTag": n$J.angleBracket,
  TagName: n$J.tagName,
  "MismatchedCloseTag/TagName": [n$J.tagName, n$J.invalid],
  AttributeName: n$J.attributeName,
  "AttributeValue UnquotedAttributeValue": n$J.attributeValue,
  Is: n$J.definitionOperator,
  "EntityReference CharacterReference": n$J.character,
  Comment: n$J.blockComment,
  ProcessingInst: n$J.processingInstruction,
  DoctypeDecl: n$J.documentMeta
}), Me$2 = w$m.deserialize({
  version: 14,
  states: ",xOVO!rOOO!WQ#tO'#CqO!]Q#tO'#CzO!bQ#tO'#C}O!gQ#tO'#DQO!lQ#tO'#DSO!qOaO'#CpO!|ObO'#CpO#XOdO'#CpO$eO!rO'#CpOOO`'#Cp'#CpO$lO$fO'#DTO$tQ#tO'#DVO$yQ#tO'#DWOOO`'#Dk'#DkOOO`'#DY'#DYQVO!rOOO%OQ&rO,59]O%WQ&rO,59fO%`Q&rO,59iO%hQ&rO,59lO%sQ&rO,59nOOOa'#D^'#D^O%{OaO'#CxO&WOaO,59[OOOb'#D_'#D_O&`ObO'#C{O&kObO,59[OOOd'#D`'#D`O&sOdO'#DOO'OOdO,59[OOO`'#Da'#DaO'WO!rO,59[O'_Q#tO'#DROOO`,59[,59[OOOp'#Db'#DbO'dO$fO,59oOOO`,59o,59oO'lQ#|O,59qO'qQ#|O,59rOOO`-E7W-E7WO'vQ&rO'#CsOOQW'#DZ'#DZO(UQ&rO1G.wOOOa1G.w1G.wO(^Q&rO1G/QOOOb1G/Q1G/QO(fQ&rO1G/TOOOd1G/T1G/TO(nQ&rO1G/WOOO`1G/W1G/WOOO`1G/Y1G/YO(yQ&rO1G/YOOOa-E7[-E7[O)RQ#tO'#CyOOO`1G.v1G.vOOOb-E7]-E7]O)WQ#tO'#C|OOOd-E7^-E7^O)]Q#tO'#DPOOO`-E7_-E7_O)bQ#|O,59mOOOp-E7`-E7`OOO`1G/Z1G/ZOOO`1G/]1G/]OOO`1G/^1G/^O)gQ,UO,59_OOQW-E7X-E7XOOOa7+$c7+$cOOOb7+$l7+$lOOOd7+$o7+$oOOO`7+$r7+$rOOO`7+$t7+$tO)rQ#|O,59eO)wQ#|O,59hO)|Q#|O,59kOOO`1G/X1G/XO*RO7[O'#CvO*dOMhO'#CvOOQW1G.y1G.yOOO`1G/P1G/POOO`1G/S1G/SOOO`1G/V1G/VOOOO'#D['#D[O*uO7[O,59bOOQW,59b,59bOOOO'#D]'#D]O+WOMhO,59bOOOO-E7Y-E7YOOQW1G.|1G.|OOOO-E7Z-E7Z",
  stateData: "+s~O!^OS~OUSOVPOWQOXROYTO[]O][O^^O`^Oa^Ob^Oc^Ox^O{_O!dZO~OfaO~OfbO~OfcO~OfdO~OfeO~O!WfOPlP!ZlP~O!XiOQoP!ZoP~O!YlORrP!ZrP~OUSOVPOWQOXROYTOZqO[]O][O^^O`^Oa^Ob^Oc^Ox^O!dZO~O!ZrO~P#dO![sO!euO~OfvO~OfwO~OS|OhyO~OS!OOhyO~OS!QOhyO~OS!SOT!TOhyO~OS!TOhyO~O!WfOPlX!ZlX~OP!WO!Z!XO~O!XiOQoX!ZoX~OQ!ZO!Z!XO~O!YlORrX!ZrX~OR!]O!Z!XO~O!Z!XO~P#dOf!_O~O![sO!e!aO~OS!bO~OS!cO~Oi!dOSgXhgXTgX~OS!fOhyO~OS!gOhyO~OS!hOhyO~OS!iOT!jOhyO~OS!jOhyO~Of!kO~Of!lO~Of!mO~OS!nO~Ok!qO!`!oO!b!pO~OS!rO~OS!sO~OS!tO~Oa!uOb!uOc!uO!`!wO!a!uO~Oa!xOb!xOc!xO!b!wO!c!xO~Oa!uOb!uOc!uO!`!{O!a!uO~Oa!xOb!xOc!xO!b!{O!c!xO~OT~bac!dx{!d~",
  goto: "%p!`PPPPPPPPPPPPPPPPPPPP!a!gP!mPP!yP!|#P#S#Y#]#`#f#i#l#r#x!aP!a!aP$O$U$l$r$x%O%U%[%bPPPPPPPP%hX^OX`pXUOX`pezabcde{}!P!R!UR!q!dRhUR!XhXVOX`pRkVR!XkXWOX`pRnWR!XnXXOX`pQrXR!XpXYOX`pQ`ORx`Q{aQ}bQ!PcQ!RdQ!UeZ!e{}!P!R!UQ!v!oR!z!vQ!y!pR!|!yQgUR!VgQjVR!YjQmWR![mQpXR!^pQtZR!`tS_O`ToXp",
  nodeNames: "\u26A0 StartCloseTag StartCloseTag StartCloseTag EndTag SelfClosingEndTag StartTag StartTag StartTag StartTag StartTag StartCloseTag StartCloseTag StartCloseTag IncompleteCloseTag Document Text EntityReference CharacterReference InvalidEntity Element OpenTag TagName Attribute AttributeName Is AttributeValue UnquotedAttributeValue ScriptText CloseTag OpenTag StyleText CloseTag OpenTag TextareaText CloseTag OpenTag CloseTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag CloseTag DoctypeDecl",
  maxTerm: 67,
  context: me$8,
  nodeProps: [
    ["closedBy", -10, 1, 2, 3, 7, 8, 9, 10, 11, 12, 13, "EndTag", 6, "EndTag SelfClosingEndTag", -4, 21, 30, 33, 36, "CloseTag"],
    ["openedBy", 4, "StartTag StartCloseTag", 5, "StartTag", -4, 29, 32, 35, 37, "OpenTag"],
    ["group", -9, 14, 17, 18, 19, 20, 39, 40, 41, 42, "Entity", 16, "Entity TextContent", -3, 28, 31, 34, "TextContent Entity"]
  ],
  propSources: [Ye$2],
  skippedNodes: [0],
  repeatNodeCount: 9,
  tokenData: "!<p!aR!YOX$qXY,QYZ,QZ[$q[]&X]^,Q^p$qpq,Qqr-_rs3_sv-_vw3}wxHYx}-_}!OH{!O!P-_!P!Q$q!Q![-_![!]Mz!]!^-_!^!_!$S!_!`!;x!`!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4U-_4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!Z$|c`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr$qrs&}sv$qvw+Pwx(tx!^$q!^!_*V!_!a&X!a#S$q#S#T&X#T;'S$q;'S;=`+z<%lO$q!R&bX`P!a`!cpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&Xq'UV`P!cpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}P'pT`POv'kw!^'k!_;'S'k;'S;=`(P<%lO'kP(SP;=`<%l'kp([S!cpOv(Vx;'S(V;'S;=`(h<%lO(Vp(kP;=`<%l(Vq(qP;=`<%l&}a({W`P!a`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t`)jT!a`Or)esv)ew;'S)e;'S;=`)y<%lO)e`)|P;=`<%l)ea*SP;=`<%l(t!Q*^V!a`!cpOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!Q*vP;=`<%l*V!R*|P;=`<%l&XW+UYkWOX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+PW+wP;=`<%l+P!Z+}P;=`<%l$q!a,]``P!a`!cp!^^OX&XXY,QYZ,QZ]&X]^,Q^p&Xpq,Qqr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!_-ljhS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q[/ebhSkWOX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+PS0rXhSqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0mS1bP;=`<%l0m[1hP;=`<%l/^!V1vchS`P!a`!cpOq&Xqr1krs&}sv1kvw0mwx(tx!P1k!P!Q&X!Q!^1k!^!_*V!_!a&X!a#s1k#s$f&X$f;'S1k;'S;=`3R<%l?Ah1k?Ah?BY&X?BY?Mn1k?MnO&X!V3UP;=`<%l1k!_3[P;=`<%l-_!Z3hV!`h`P!cpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}!_4WihSkWc!ROX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst>]tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^/^!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!Z5zbkWOX5uXZ7SZ[5u[^7S^p5uqr5urs7Sst+Ptw5uwx7Sx!]5u!]!^7w!^!a7S!a#S5u#S#T7S#T;'S5u;'S;=`8n<%lO5u!R7VVOp7Sqs7St!]7S!]!^7l!^;'S7S;'S;=`7q<%lO7S!R7qOa!R!R7tP;=`<%l7S!Z8OYkWa!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!Z8qP;=`<%l5u!_8{ihSkWOX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst/^tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^:j!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!_:sbhSkWa!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!V<QchSOp7Sqr;{rs7Sst0mtw;{wx7Sx!P;{!P!Q7S!Q!];{!]!^=]!^!a7S!a#s;{#s$f7S$f;'S;{;'S;=`>P<%l?Ah;{?Ah?BY7S?BY?Mn;{?MnO7S!V=dXhSa!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!V>SP;=`<%l;{!_>YP;=`<%l8t!_>dhhSkWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^/^!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!Z@TakWOX@OXZAYZ[@O[^AY^p@Oqr@OrsAYsw@OwxAYx!]@O!]!^Az!^!aAY!a#S@O#S#TAY#T;'S@O;'S;=`Bq<%lO@O!RA]UOpAYq!]AY!]!^Ao!^;'SAY;'S;=`At<%lOAY!RAtOb!R!RAwP;=`<%lAY!ZBRYkWb!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!ZBtP;=`<%l@O!_COhhSkWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^Dj!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!_DsbhSkWb!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!VFQbhSOpAYqrE{rsAYswE{wxAYx!PE{!P!QAY!Q!]E{!]!^GY!^!aAY!a#sE{#s$fAY$f;'SE{;'S;=`G|<%l?AhE{?Ah?BYAY?BY?MnE{?MnOAY!VGaXhSb!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!VHPP;=`<%lE{!_HVP;=`<%lBw!ZHcW!bx`P!a`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t!aIYlhS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OKQ!O!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!aK_khS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!`&X!`!aMS!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!TM_X`P!a`!cp!eQOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!aNZ!ZhSfQ`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OMz!O!PMz!P!Q$q!Q![Mz![!]Mz!]!^-_!^!_*V!_!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f$}-_$}%OMz%O%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4UMz4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Je-_$Je$JgMz$Jg$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!a!$PP;=`<%lMz!R!$ZY!a`!cpOq*Vqr!$yrs(Vsv*Vwx)ex!a*V!a!b!4t!b;'S*V;'S;=`*s<%lO*V!R!%Q]!a`!cpOr*Vrs(Vsv*Vwx)ex}*V}!O!%y!O!f*V!f!g!']!g#W*V#W#X!0`#X;'S*V;'S;=`*s<%lO*V!R!&QX!a`!cpOr*Vrs(Vsv*Vwx)ex}*V}!O!&m!O;'S*V;'S;=`*s<%lO*V!R!&vV!a`!cp!dPOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!'dX!a`!cpOr*Vrs(Vsv*Vwx)ex!q*V!q!r!(P!r;'S*V;'S;=`*s<%lO*V!R!(WX!a`!cpOr*Vrs(Vsv*Vwx)ex!e*V!e!f!(s!f;'S*V;'S;=`*s<%lO*V!R!(zX!a`!cpOr*Vrs(Vsv*Vwx)ex!v*V!v!w!)g!w;'S*V;'S;=`*s<%lO*V!R!)nX!a`!cpOr*Vrs(Vsv*Vwx)ex!{*V!{!|!*Z!|;'S*V;'S;=`*s<%lO*V!R!*bX!a`!cpOr*Vrs(Vsv*Vwx)ex!r*V!r!s!*}!s;'S*V;'S;=`*s<%lO*V!R!+UX!a`!cpOr*Vrs(Vsv*Vwx)ex!g*V!g!h!+q!h;'S*V;'S;=`*s<%lO*V!R!+xY!a`!cpOr!+qrs!,hsv!+qvw!-Swx!.[x!`!+q!`!a!/j!a;'S!+q;'S;=`!0Y<%lO!+qq!,mV!cpOv!,hvx!-Sx!`!,h!`!a!-q!a;'S!,h;'S;=`!.U<%lO!,hP!-VTO!`!-S!`!a!-f!a;'S!-S;'S;=`!-k<%lO!-SP!-kO{PP!-nP;=`<%l!-Sq!-xS!cp{POv(Vx;'S(V;'S;=`(h<%lO(Vq!.XP;=`<%l!,ha!.aX!a`Or!.[rs!-Ssv!.[vw!-Sw!`!.[!`!a!.|!a;'S!.[;'S;=`!/d<%lO!.[a!/TT!a`{POr)esv)ew;'S)e;'S;=`)y<%lO)ea!/gP;=`<%l!.[!R!/sV!a`!cp{POr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!0]P;=`<%l!+q!R!0gX!a`!cpOr*Vrs(Vsv*Vwx)ex#c*V#c#d!1S#d;'S*V;'S;=`*s<%lO*V!R!1ZX!a`!cpOr*Vrs(Vsv*Vwx)ex#V*V#V#W!1v#W;'S*V;'S;=`*s<%lO*V!R!1}X!a`!cpOr*Vrs(Vsv*Vwx)ex#h*V#h#i!2j#i;'S*V;'S;=`*s<%lO*V!R!2qX!a`!cpOr*Vrs(Vsv*Vwx)ex#m*V#m#n!3^#n;'S*V;'S;=`*s<%lO*V!R!3eX!a`!cpOr*Vrs(Vsv*Vwx)ex#d*V#d#e!4Q#e;'S*V;'S;=`*s<%lO*V!R!4XX!a`!cpOr*Vrs(Vsv*Vwx)ex#X*V#X#Y!+q#Y;'S*V;'S;=`*s<%lO*V!R!4{Y!a`!cpOr!4trs!5ksv!4tvw!6Vwx!8]x!a!4t!a!b!:]!b;'S!4t;'S;=`!;r<%lO!4tq!5pV!cpOv!5kvx!6Vx!a!5k!a!b!7W!b;'S!5k;'S;=`!8V<%lO!5kP!6YTO!a!6V!a!b!6i!b;'S!6V;'S;=`!7Q<%lO!6VP!6lTO!`!6V!`!a!6{!a;'S!6V;'S;=`!7Q<%lO!6VP!7QOxPP!7TP;=`<%l!6Vq!7]V!cpOv!5kvx!6Vx!`!5k!`!a!7r!a;'S!5k;'S;=`!8V<%lO!5kq!7yS!cpxPOv(Vx;'S(V;'S;=`(h<%lO(Vq!8YP;=`<%l!5ka!8bX!a`Or!8]rs!6Vsv!8]vw!6Vw!a!8]!a!b!8}!b;'S!8];'S;=`!:V<%lO!8]a!9SX!a`Or!8]rs!6Vsv!8]vw!6Vw!`!8]!`!a!9o!a;'S!8];'S;=`!:V<%lO!8]a!9vT!a`xPOr)esv)ew;'S)e;'S;=`)y<%lO)ea!:YP;=`<%l!8]!R!:dY!a`!cpOr!4trs!5ksv!4tvw!6Vwx!8]x!`!4t!`!a!;S!a;'S!4t;'S;=`!;r<%lO!4t!R!;]V!a`!cpxPOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!;uP;=`<%l!4t!V!<TXiS`P!a`!cpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X",
  tokenizers: [Qe$3, ke$5, be$6, qe$3, $e$2, we$7, 0, 1, 2, 3, 4, 5],
  topRules: { Document: [0, 15] },
  dialects: { noMatch: 0, selfClosing: 485 },
  tokenPrec: 487
});
function N$r(e28, t3) {
  let a3 = /* @__PURE__ */ Object.create(null);
  for (let r3 of e28.getChildren(E$m)) {
    let O3 = r3.getChild(ne$a), s3 = r3.getChild(g$D) || r3.getChild(z$c);
    O3 && (a3[t3.read(O3.from, O3.to)] = s3 ? s3.type.id == g$D ? t3.read(s3.from + 1, s3.to - 1) : t3.read(s3.from, s3.to) : "");
  }
  return a3;
}
function M$f(e28, t3) {
  let a3 = e28.getChild(Se$3);
  return a3 ? t3.read(a3.from, a3.to) : " ";
}
function d$11(e28, t3, a3) {
  let r3;
  for (let O3 of a3)
    if (!O3.attrs || O3.attrs(r3 || (r3 = N$r(e28.node.parent.firstChild, t3))))
      return { parser: O3.parser };
  return null;
}
function Re$6(e28 = [], t3 = []) {
  let a3 = [], r3 = [], O3 = [], s3 = [];
  for (let l3 of e28)
    (l3.tag == "script" ? a3 : l3.tag == "style" ? r3 : l3.tag == "textarea" ? O3 : s3).push(l3);
  let o3 = t3.length ? /* @__PURE__ */ Object.create(null) : null;
  for (let l3 of t3)
    (o3[l3.name] || (o3[l3.name] = [])).push(l3);
  return Te$7((l3, P3) => {
    let f3 = l3.type.id;
    if (f3 == oe$9)
      return d$11(l3, P3, a3);
    if (f3 == Pe$5)
      return d$11(l3, P3, r3);
    if (f3 == ce$6)
      return d$11(l3, P3, O3);
    if (f3 == W$9 && s3.length) {
      let c3 = l3.node, V10 = c3.firstChild, u3 = V10 && M$f(V10, P3), x3;
      if (u3) {
        for (let S3 of s3)
          if (S3.tag == u3 && (!S3.attrs || S3.attrs(x3 || (x3 = N$r(c3, P3))))) {
            let T3 = c3.lastChild;
            return { parser: S3.parser, overlay: [{ from: V10.to, to: T3.type.id == xe$6 ? T3.from : c3.to }] };
          }
      }
    }
    if (o3 && f3 == E$m) {
      let c3 = l3.node, V10;
      if (V10 = c3.firstChild) {
        let u3 = o3[P3.read(V10.from, V10.to)];
        if (u3)
          for (let x3 of u3) {
            if (x3.tagName && x3.tagName != M$f(c3.parent, P3))
              continue;
            let S3 = c3.lastChild;
            if (S3.type.id == g$D) {
              let T3 = S3.from + 1, _3 = S3.lastChild, q3 = S3.to - (_3 && _3.isError ? 0 : 1);
              if (q3 > T3)
                return { parser: x3.parser, overlay: [{ from: T3, to: q3 }] };
            } else if (S3.type.id == z$c)
              return { parser: x3.parser, overlay: [{ from: S3.from, to: S3.to }] };
          }
      }
    }
    return null;
  });
}
const X$b = 304, e$Y = 1, p$2Q = 2, l$$ = 305, t$K = 307, n$H = 308, c$17 = 3, b$y = 4, s$14 = [
  9,
  10,
  11,
  12,
  13,
  32,
  133,
  160,
  5760,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8199,
  8200,
  8201,
  8202,
  8232,
  8233,
  8239,
  8287,
  12288
], P$w = 125, m$19 = 59, r$V = 47, x$i = 42, w$k = 43, U$h = 45, d$10 = new Z$d({
  start: false,
  shift(Q3, i) {
    return i == c$17 || i == b$y || i == t$K ? Q3 : i == n$H;
  },
  strict: false
}), _$i = new Y$c((Q3, i) => {
  let { next: $3 } = Q3;
  ($3 == P$w || $3 == -1 || i.context) && Q3.acceptToken(l$$);
}, { contextual: true, fallback: true }), W$8 = new Y$c((Q3, i) => {
  let { next: $3 } = Q3, Z3;
  s$14.indexOf($3) > -1 || $3 == r$V && ((Z3 = Q3.peek(1)) == r$V || Z3 == x$i) || $3 != P$w && $3 != m$19 && $3 != -1 && !i.context && Q3.acceptToken(X$b);
}, { contextual: true }), y$v = new Y$c((Q3, i) => {
  let { next: $3 } = Q3;
  if (($3 == w$k || $3 == U$h) && (Q3.advance(), $3 == Q3.next)) {
    Q3.advance();
    let Z3 = !i.context && i.canShift(e$Y);
    Q3.acceptToken(Z3 ? e$Y : p$2Q);
  }
}, { contextual: true }), T$o = $$d({
  "get set async static": n$J.modifier,
  "for while do if else switch try catch finally return throw break continue default case": n$J.controlKeyword,
  "in of await yield void typeof delete instanceof": n$J.operatorKeyword,
  "let var const using function class extends": n$J.definitionKeyword,
  "import export from": n$J.moduleKeyword,
  "with debugger as new": n$J.keyword,
  TemplateString: n$J.special(n$J.string),
  super: n$J.atom,
  BooleanLiteral: n$J.bool,
  this: n$J.self,
  null: n$J.null,
  Star: n$J.modifier,
  VariableName: n$J.variableName,
  "CallExpression/VariableName TaggedTemplateExpression/VariableName": n$J.function(n$J.variableName),
  VariableDefinition: n$J.definition(n$J.variableName),
  Label: n$J.labelName,
  PropertyName: n$J.propertyName,
  PrivatePropertyName: n$J.special(n$J.propertyName),
  "CallExpression/MemberExpression/PropertyName": n$J.function(n$J.propertyName),
  "FunctionDeclaration/VariableDefinition": n$J.function(n$J.definition(n$J.variableName)),
  "ClassDeclaration/VariableDefinition": n$J.definition(n$J.className),
  PropertyDefinition: n$J.definition(n$J.propertyName),
  PrivatePropertyDefinition: n$J.definition(n$J.special(n$J.propertyName)),
  UpdateOp: n$J.updateOperator,
  "LineComment Hashbang": n$J.lineComment,
  BlockComment: n$J.blockComment,
  Number: n$J.number,
  String: n$J.string,
  Escape: n$J.escape,
  ArithOp: n$J.arithmeticOperator,
  LogicOp: n$J.logicOperator,
  BitOp: n$J.bitwiseOperator,
  CompareOp: n$J.compareOperator,
  RegExp: n$J.regexp,
  Equals: n$J.definitionOperator,
  Arrow: n$J.function(n$J.punctuation),
  ": Spread": n$J.punctuation,
  "( )": n$J.paren,
  "[ ]": n$J.squareBracket,
  "{ }": n$J.brace,
  "InterpolationStart InterpolationEnd": n$J.special(n$J.brace),
  ".": n$J.derefOperator,
  ", ;": n$J.separator,
  "@": n$J.meta,
  TypeName: n$J.typeName,
  TypeDefinition: n$J.definition(n$J.typeName),
  "type enum interface implements namespace module declare": n$J.definitionKeyword,
  "abstract global Privacy readonly override": n$J.modifier,
  "is keyof unique infer": n$J.operatorKeyword,
  JSXAttributeValue: n$J.attributeValue,
  JSXText: n$J.content,
  "JSXStartTag JSXStartCloseTag JSXSelfCloseEndTag JSXEndTag": n$J.angleBracket,
  "JSXIdentifier JSXNameSpacedName": n$J.tagName,
  "JSXAttribute/JSXIdentifier JSXAttribute/JSXNameSpacedName": n$J.attributeName,
  "JSXBuiltin/JSXIdentifier": n$J.standard(n$J.tagName)
}), v$B = { __proto__: null, export: 16, as: 21, from: 29, default: 32, async: 37, function: 38, extends: 48, this: 52, true: 60, false: 60, null: 72, void: 76, typeof: 80, super: 98, new: 132, delete: 148, yield: 157, await: 161, class: 166, public: 223, private: 223, protected: 223, readonly: 225, instanceof: 244, satisfies: 247, in: 248, const: 250, import: 282, keyof: 337, unique: 341, infer: 347, is: 383, abstract: 403, implements: 405, type: 407, let: 410, var: 412, using: 415, interface: 421, enum: 425, namespace: 431, module: 433, declare: 437, global: 441, for: 460, of: 469, while: 472, with: 476, do: 480, if: 484, else: 486, switch: 490, case: 496, try: 502, catch: 506, finally: 510, return: 514, throw: 518, break: 522, continue: 526, debugger: 530 }, j$b = { __proto__: null, async: 119, get: 121, set: 123, declare: 183, public: 185, private: 185, protected: 185, static: 187, abstract: 189, override: 191, readonly: 197, accessor: 199, new: 387 }, q$d = { __proto__: null, "<": 139 }, G$d = w$m.deserialize({
  version: 14,
  states: "$6zO%TQUOOO%[QUOOO'_QWOOP(lOSOOO*zQ(CjO'#CgO+ROpO'#ChO+aO!bO'#ChO+oO07`O'#D[O.QQUO'#DbO.bQUO'#DmO%[QUO'#DwO0fQUO'#EPOOQ(CY'#EX'#EXO1PQSO'#EUOOQO'#Ej'#EjOOQO'#Id'#IdO1XQSO'#GlO1dQSO'#EiO1iQSO'#EiO3kQ(CjO'#JeO6[Q(CjO'#JfO6xQSO'#FXO6}Q#tO'#FpOOQ(CY'#Fa'#FaO7YO&jO'#FaO7hQ,UO'#FwO9OQSO'#FvOOQ(CY'#Jf'#JfOOQ(CW'#Je'#JeO9TQSO'#GpOOQQ'#KQ'#KQO9`QSO'#IQO9eQ(C[O'#IROOQQ'#JR'#JROOQQ'#IV'#IVQ`QUOOO`QUOOO%[QUO'#DoO9mQUO'#D{O9tQUO'#D}O9ZQSO'#GlO9{Q,UO'#CmO:ZQSO'#EhO:fQSO'#EsO:kQ,UO'#F`O;YQSO'#GlOOQO'#KR'#KRO;_QSO'#KRO;mQSO'#GtO;mQSO'#GuO;mQSO'#GwO9ZQSO'#GzO<dQSO'#G}O={QSO'#CcO>]QSO'#HZO>eQSO'#HaO>eQSO'#HcO`QUO'#HeO>eQSO'#HgO>eQSO'#HjO>jQSO'#HpO>oQ(C]O'#HvO%[QUO'#HxO>zQ(C]O'#HzO?VQ(C]O'#H|O9eQ(C[O'#IOO?bQ(CjO'#CgO@dQWO'#DgQOQSOOO%[QUO'#D}O@zQSO'#EQO9{Q,UO'#EhOAVQSO'#EhOAbQ`O'#F`OOQQ'#Ce'#CeOOQ(CW'#Dl'#DlOOQ(CW'#Ji'#JiO%[QUO'#JiOOQO'#Jm'#JmOOQO'#Ia'#IaOBbQWO'#EaOOQ(CW'#E`'#E`OC^Q(C`O'#EaOChQWO'#ETOOQO'#Jl'#JlOC|QWO'#JmOEZQWO'#ETOChQWO'#EaPEhO?MpO'#C`POOO)CDp)CDpOOOO'#IW'#IWOEsOpO,59SOOQ(CY,59S,59SOOOO'#IX'#IXOFRO!bO,59SO%[QUO'#D^OOOO'#IZ'#IZOFaO07`O,59vOOQ(CY,59v,59vOFoQUO'#I[OGSQSO'#JgOIUQbO'#JgO+}QUO'#JgOI]QSO,59|OIsQSO'#EjOJQQSO'#JuOJ]QSO'#JtOJ]QSO'#JtOJeQSO,5;WOJjQSO'#JsOOQ(CY,5:X,5:XOJqQUO,5:XOLrQ(CjO,5:cOMcQSO,5:kOM|Q(C[O'#JrONTQSO'#JqO9TQSO'#JqONiQSO'#JqONqQSO,5;VONvQSO'#JqO!#OQbO'#JfOOQ(CY'#Cg'#CgO%[QUO'#EPO!#nQ`O,5:pOOQO'#Jn'#JnOOQO-E<b-E<bO9ZQSO,5=WO!$UQSO,5=WO!$ZQUO,5;TO!&^Q,UO'#EeO!'qQSO,5;TO!)ZQ,UO'#DqO!)bQUO'#DvO!)lQWO,5;^O!)tQWO,5;^O%[QUO,5;^OOQQ'#FP'#FPOOQQ'#FR'#FRO%[QUO,5;_O%[QUO,5;_O%[QUO,5;_O%[QUO,5;_O%[QUO,5;_O%[QUO,5;_O%[QUO,5;_O%[QUO,5;_O%[QUO,5;_O%[QUO,5;_O%[QUO,5;_OOQQ'#FV'#FVO!*SQUO,5;pOOQ(CY,5;u,5;uOOQ(CY,5;v,5;vO!,VQSO,5;vOOQ(CY,5;w,5;wO%[QUO'#IhO!,_Q(C[O,5<dO!&^Q,UO,5;_O!,|Q,UO,5;_O%[QUO,5;sO!-TQ#tO'#FfO!.QQ#tO'#JyO!-lQ#tO'#JyO!.XQ#tO'#JyOOQO'#Jy'#JyO!.mQ#tO,5<OOOOO,5<[,5<[O!/OQUO'#FrOOOO'#Ig'#IgO7YO&jO,5;{O!/VQ#tO'#FtOOQ(CY,5;{,5;{O!/vQ7[O'#CsOOQ(CY'#Cw'#CwO!0ZQSO'#CwO!0`O07`O'#C{O!0|Q,UO,5<aO!1TQSO,5<cO!2jQMhO'#GRO!2wQSO'#GSO!2|QSO'#GSO!3RQMhO'#GWO!4QQWO'#G[O!4sQ7[O'#J`OOQ(CY'#J`'#J`O!4}QSO'#J_O!5]QSO'#J^O!5eQSO'#CrOOQ(CY'#Cu'#CuOOQ(CY'#DP'#DPOOQ(CY'#DR'#DRO1SQSO'#DTO!'vQ,UO'#FyO!'vQ,UO'#F{O!5mQSO'#F}O!5rQSO'#GOO!2|QSO'#GUO!'vQ,UO'#GZO!5wQSO'#EkO!6fQSO,5<bOOQ(CW'#Cp'#CpO!6nQSO'#ElO!7hQWO'#EmOOQ(CW'#Js'#JsO!7oQ(C[O'#KSO9eQ(C[O,5=[O`QUO,5>lOOQQ'#JZ'#JZOOQQ,5>m,5>mOOQQ-E<T-E<TO!9qQ(CjO,5:ZO!<_Q(CjO,5:gO%[QUO,5:gO!>xQ(CjO,5:iOOQO,5@m,5@mO!?iQ,UO,5=WO!?wQ(C[O'#J[O9OQSO'#J[O!@YQ(C[O,59XO!@eQWO,59XO!@mQ,UO,59XO9{Q,UO,59XO!@xQSO,5;TO!AQQSO'#HYO!AfQSO'#KVO%[QUO,5;xO!7cQWO,5;zO!AnQSO,5=sO!AsQSO,5=sO!AxQSO,5=sO9eQ(C[O,5=sO;mQSO,5=cOOQO'#Cs'#CsO!BWQWO,5=`O!B`Q,UO,5=aO!BkQSO,5=cO!BpQ`O,5=fO!BxQSO'#KRO>jQSO'#HPO9ZQSO'#HRO!B}QSO'#HRO9{Q,UO'#HTO!CSQSO'#HTOOQQ,5=i,5=iO!CXQSO'#HUO!CjQSO'#CmO!CoQSO,58}O!CyQSO,58}O!FOQUO,58}OOQQ,58},58}O!F`Q(C[O,58}O%[QUO,58}O!HkQUO'#H]OOQQ'#H^'#H^OOQQ'#H_'#H_O`QUO,5=uO!IRQSO,5=uO`QUO,5={O`QUO,5=}O!IWQSO,5>PO`QUO,5>RO!I]QSO,5>UO!IbQUO,5>[OOQQ,5>b,5>bO%[QUO,5>bO9eQ(C[O,5>dOOQQ,5>f,5>fO!MlQSO,5>fOOQQ,5>h,5>hO!MlQSO,5>hOOQQ,5>j,5>jO!MqQWO'#DYO%[QUO'#JiO!N`QWO'#JiO!N}QWO'#DhO# `QWO'#DhO##qQUO'#DhO##xQSO'#JhO#$QQSO,5:RO#$VQSO'#EnO#$eQSO'#JvO#$mQSO,5;XO#$rQWO'#DhO#%PQWO'#ESOOQ(CY,5:l,5:lO%[QUO,5:lO#%WQSO,5:lO>jQSO,5;SO!@eQWO,5;SO!@mQ,UO,5;SO9{Q,UO,5;SO#%`QSO,5@TO#%eQ!LQO,5:pOOQO-E<_-E<_O#&kQ(C`O,5:{OChQWO,5:oO#&uQWO,5:oOChQWO,5:{O!@YQ(C[O,5:oOOQ(CW'#Ed'#EdOOQO,5:{,5:{O%[QUO,5:{O#'SQ(C[O,5:{O#'_Q(C[O,5:{O!@eQWO,5:oOOQO,5;R,5;RO#'mQ(C[O,5:{POOO'#IU'#IUP#(RO?MpO,58zPOOO,58z,58zOOOO-E<U-E<UOOQ(CY1G.n1G.nOOOO-E<V-E<VO#(^Q`O,59xOOOO-E<X-E<XOOQ(CY1G/b1G/bO#(cQbO,5>vO+}QUO,5>vOOQO,5>|,5>|O#(mQUO'#I[OOQO-E<Y-E<YO#(zQSO,5@RO#)SQbO,5@RO#)ZQSO,5@`OOQ(CY1G/h1G/hO%[QUO,5@aO#)cQSO'#IbOOQO-E<`-E<`O#)ZQSO,5@`OOQ(CW1G0r1G0rOOQ(CY1G/s1G/sOOQ(CY1G0V1G0VO%[QUO,5@^O#)wQ(C[O,5@^O#*YQ(C[O,5@^O#*aQSO,5@]O9TQSO,5@]O#*iQSO,5@]O#*wQSO'#IeO#*aQSO,5@]OOQ(CW1G0q1G0qO!)lQWO,5:rO!)wQWO,5:rOOQO,5:t,5:tO#+iQSO,5:tO#+qQ,UO1G2rO9ZQSO1G2rOOQ(CY1G0o1G0oO#,PQ(CjO1G0oO#-UQ(ChO,5;POOQ(CY'#GQ'#GQO#-rQ(CjO'#J`O!$ZQUO1G0oO#/zQ,UO'#JjO#0UQSO,5:]O#0ZQbO'#JkO%[QUO'#JkO#0eQSO,5:bOOQ(CY'#DY'#DYOOQ(CY1G0x1G0xO%[QUO1G0xOOQ(CY1G1b1G1bO#0jQSO1G0xO#3RQ(CjO1G0yO#3YQ(CjO1G0yO#5sQ(CjO1G0yO#5zQ(CjO1G0yO#8UQ(CjO1G0yO#8lQ(CjO1G0yO#;fQ(CjO1G0yO#;mQ(CjO1G0yO#>WQ(CjO1G0yO#>_Q(CjO1G0yO#@VQ(CjO1G0yO#CVQ$IUO'#CgO#ETQ$IUO1G1[O#E[Q$IUO'#JfO!,YQSO1G1bO#ElQ(CjO,5?SOOQ(CW-E<f-E<fO#F`Q(CjO1G0yOOQ(CY1G0y1G0yO#HkQ(CjO1G1_O#I_Q#tO,5<SO#IgQ#tO,5<TO#IoQ#tO'#FkO#JWQSO'#FjOOQO'#Jz'#JzOOQO'#If'#IfO#J]Q#tO1G1jOOQ(CY1G1j1G1jOOOO1G1u1G1uO#JnQ$IUO'#JeO#JxQSO,5<^O!*SQUO,5<^OOOO-E<e-E<eOOQ(CY1G1g1G1gO#J}QWO'#JyOOQ(CY,5<`,5<`O#KVQWO,5<`OOQ(CY,59c,59cO!&^Q,UO'#C}OOOO'#IY'#IYO#K[O07`O,59gOOQ(CY,59g,59gO%[QUO1G1{O!5rQSO'#IjO#KgQ,UO,5<tOOQ(CY,5<q,5<qOOQO'#Gg'#GgO!'vQ,UO,5=QOOQO'#Gi'#GiO!'vQ,UO,5=SO!&^Q,UO,5=UOOQO1G1}1G1}O#KnQ`O'#CpO#LRQ`O,5<mO#LYQSO'#J}O9ZQSO'#J}O#LhQSO,5<oO!'vQ,UO,5<nO#LmQSO'#GTO#LxQSO,5<nO#L}Q`O'#GQO#M[Q`O'#KOO#MfQSO'#KOO!&^Q,UO'#KOO#MkQSO,5<rO#MpQWO'#G]O!3{QWO'#G]O#NRQSO'#G_O#NWQSO'#GaO!2|QSO'#GdO#N]Q(C[O'#IlO#NhQWO,5<vOOQ(CY,5<v,5<vO#NoQWO'#G]O#N}QWO'#G^O$ VQWO'#G^OOQ(CY,5=V,5=VO!'vQ,UO,5?yO!'vQ,UO,5?yO$ [QSO'#ImO$ gQSO,5?xO$ oQSO,59^O$!`Q,UO,59oOOQ(CY,59o,59oO$#RQ,UO,5<eO$#tQ,UO,5<gO@[QSO,5<iOOQ(CY,5<j,5<jO$$OQSO,5<pO$$TQ,UO,5<uO$$eQSO'#JqO!$ZQUO1G1|O$$jQSO1G1|O9TQSO'#JtO9TQSO'#EnO%[QUO'#EnO9TQSO'#IoO$$oQ(C[O,5@nOOQQ1G2v1G2vOOQQ1G4W1G4WOOQ(CY1G/u1G/uO!,VQSO1G/uO$&tQ(CjO1G0ROOQQ1G2r1G2rO!&^Q,UO1G2rO%[QUO1G2rO$'eQSO1G2rO$'pQ,UO'#EeOOQ(CW,5?v,5?vO$'zQ(C[O,5?vOOQQ1G.s1G.sO!@YQ(C[O1G.sO!@eQWO1G.sO!@mQ,UO1G.sO$(]QSO1G0oO$(bQSO'#CgO$(mQSO'#KWO$(uQSO,5=tO$(zQSO'#KWO$)PQSO'#KWO$)_QSO'#IuO$)mQSO,5@qO$)uQbO1G1dOOQ(CY1G1f1G1fO9ZQSO1G3_O@[QSO1G3_O$)|QSO1G3_O$*RQSO1G3_OOQQ1G3_1G3_O!BkQSO1G2}O!&^Q,UO1G2zO$*WQSO1G2zOOQQ1G2{1G2{O!&^Q,UO1G2{O$*]QSO1G2{O$*eQWO'#GyOOQQ1G2}1G2}O!3{QWO'#IqO!BpQ`O1G3QOOQQ1G3Q1G3QOOQQ,5=k,5=kO$*mQ,UO,5=mO9ZQSO,5=mO#NWQSO,5=oO9OQSO,5=oO!@eQWO,5=oO!@mQ,UO,5=oO9{Q,UO,5=oO$*{QSO'#KUO$+WQSO,5=pOOQQ1G.i1G.iO$+]Q(C[O1G.iO@[QSO1G.iO$+hQSO1G.iO9eQ(C[O1G.iO$-mQbO,5@sO$-}QSO,5@sO9TQSO,5@sO$.YQUO,5=wO$.aQSO,5=wOOQQ1G3a1G3aO`QUO1G3aOOQQ1G3g1G3gOOQQ1G3i1G3iO>eQSO1G3kO$.fQUO1G3mO$2jQUO'#HlOOQQ1G3p1G3pO$2wQSO'#HrO>jQSO'#HtOOQQ1G3v1G3vO$3PQUO1G3vO9eQ(C[O1G3|OOQQ1G4O1G4OOOQ(CW'#GX'#GXO9eQ(C[O1G4QO9eQ(C[O1G4SO$7WQSO,5@TO!*SQUO,5;YO9TQSO,5;YO>jQSO,5:SO!*SQUO,5:SO!@eQWO,5:SO$7]Q$IUO,5:SOOQO,5;Y,5;YO$7gQWO'#I]O$7}QSO,5@SOOQ(CY1G/m1G/mO$8VQWO'#IcO$8aQSO,5@bOOQ(CW1G0s1G0sO# `QWO,5:SOOQO'#I`'#I`O$8iQWO,5:nOOQ(CY,5:n,5:nO#%ZQSO1G0WOOQ(CY1G0W1G0WO%[QUO1G0WOOQ(CY1G0n1G0nO>jQSO1G0nO!@eQWO1G0nO!@mQ,UO1G0nOOQ(CW1G5o1G5oO!@YQ(C[O1G0ZOOQO1G0g1G0gO%[QUO1G0gO$8pQ(C[O1G0gO$8{Q(C[O1G0gO!@eQWO1G0ZOChQWO1G0ZO$9ZQ(C[O1G0gOOQO1G0Z1G0ZO$9oQ(CjO1G0gPOOO-E<S-E<SPOOO1G.f1G.fOOOO1G/d1G/dO$9yQ`O,5<dO$:RQbO1G4bOOQO1G4h1G4hO%[QUO,5>vO$:]QSO1G5mO$:eQSO1G5zO$:mQbO1G5{O9TQSO,5>|O$:wQ(CjO1G5xO%[QUO1G5xO$;XQ(C[O1G5xO$;jQSO1G5wO$;jQSO1G5wO9TQSO1G5wO$;rQSO,5?PO9TQSO,5?POOQO,5?P,5?PO$<WQSO,5?PO$$eQSO,5?POOQO-E<c-E<cOOQO1G0^1G0^OOQO1G0`1G0`O!,YQSO1G0`OOQQ7+(^7+(^O!&^Q,UO7+(^O%[QUO7+(^O$<fQSO7+(^O$<qQ,UO7+(^O$=PQ(CjO,59oO$?XQ(CjO,5<eO$AdQ(CjO,5<gO$CoQ(CjO,5<uOOQ(CY7+&Z7+&ZO$FQQ(CjO7+&ZO$FtQ,UO'#I^O$GOQSO,5@UOOQ(CY1G/w1G/wO$GWQUO'#I_O$GeQSO,5@VO$GmQbO,5@VOOQ(CY1G/|1G/|O$GwQSO7+&dOOQ(CY7+&d7+&dO$G|Q$IUO,5:cO%[QUO7+&vO$HWQ$IUO,5:ZO$HeQ$IUO,5:gO$HoQ$IUO,5:iOOQ(CY7+&|7+&|OOQO1G1n1G1nOOQO1G1o1G1oO$HyQ#tO,5<VO!*SQUO,5<UOOQO-E<d-E<dOOQ(CY7+'U7+'UOOOO7+'a7+'aOOOO1G1x1G1xO$IUQSO1G1xOOQ(CY1G1z1G1zO$IZQ`O,59iOOOO-E<W-E<WOOQ(CY1G/R1G/RO$IbQ(CjO7+'gOOQ(CY,5?U,5?UO$JUQ`O,5?UOOQ(CY1G2`1G2`P!&^Q,UO'#IjPOQ(CY-E<h-E<hO$JtQ,UO1G2lO$KgQ,UO1G2nO$KqQ`O1G2pOOQ(CY1G2X1G2XO$KxQSO'#IiO$LWQSO,5@iO$LWQSO,5@iO$L`QSO,5@iO$LkQSO,5@iOOQO1G2Z1G2ZO$LyQ,UO1G2YO!'vQ,UO1G2YO$MZQMhO'#IkO$MkQSO,5@jO!&^Q,UO,5@jO$MsQ`O,5@jOOQ(CY1G2^1G2^OOQ(CW,5<w,5<wOOQ(CW,5<x,5<xO$$eQSO,5<xOCXQSO,5<xO!@eQWO,5<wOOQO'#G`'#G`O$M}QSO,5<yOOQ(CW,5<{,5<{O$$eQSO,5=OOOQO,5?W,5?WOOQO-E<j-E<jOOQ(CY1G2b1G2bO!3{QWO,5<wO$NVQSO,5<xO#NRQSO,5<yO!3{QWO,5<xO$NbQ,UO1G5eO$NlQ,UO1G5eOOQO,5?X,5?XOOQO-E<k-E<kOOQO1G.x1G.xO!7cQWO,59qO%[QUO,59qO$NyQSO1G2TO!'vQ,UO1G2[O% OQ(CjO7+'hOOQ(CY7+'h7+'hO!$ZQUO7+'hO% rQSO,5;YOOQ(CW,5?Z,5?ZOOQ(CW-E<m-E<mOOQ(CY7+%a7+%aO% wQ`O'#KPO#%ZQSO7+(^O%!RQbO7+(^O$<iQSO7+(^O%!YQ(ChO'#CgO%!mQ(ChO,5<|O%#_QSO,5<|OOQ(CW1G5b1G5bOOQQ7+$_7+$_O!@YQ(C[O7+$_O!@eQWO7+$_O!$ZQUO7+&ZO%#dQSO'#ItO%#{QSO,5@rOOQO1G3`1G3`O9ZQSO,5@rO%#{QSO,5@rO%$TQSO,5@rOOQO,5?a,5?aOOQO-E<s-E<sOOQ(CY7+'O7+'OO%$YQSO7+(yO9eQ(C[O7+(yO9ZQSO7+(yO@[QSO7+(yOOQQ7+(i7+(iO%$_Q(ChO7+(fO!&^Q,UO7+(fO%$iQ`O7+(gOOQQ7+(g7+(gO!&^Q,UO7+(gO%$pQSO'#KTO%${QSO,5=eOOQO,5?],5?]OOQO-E<o-E<oOOQQ7+(l7+(lO%&[QWO'#HSOOQQ1G3X1G3XO!&^Q,UO1G3XO%[QUO1G3XO%&cQSO1G3XO%&nQ,UO1G3XO9eQ(C[O1G3ZO#NWQSO1G3ZO9OQSO1G3ZO!@eQWO1G3ZO!@mQ,UO1G3ZO%&|QSO'#IsO%'bQSO,5@pO%'jQWO,5@pOOQ(CW1G3[1G3[OOQQ7+$T7+$TO@[QSO7+$TO9eQ(C[O7+$TO%'uQSO7+$TO%[QUO1G6_O%[QUO1G6`O%'zQ(C[O1G6_O%(UQUO1G3cO%(]QSO1G3cO%(bQUO1G3cOOQQ7+({7+({O9eQ(C[O7+)VO`QUO7+)XOOQQ'#KZ'#KZOOQQ'#Iv'#IvO%(iQUO,5>WOOQQ,5>W,5>WO%[QUO'#HmO%(vQSO'#HoOOQQ,5>^,5>^O9TQSO,5>^OOQQ,5>`,5>`OOQQ7+)b7+)bOOQQ7+)h7+)hOOQQ7+)l7+)lOOQQ7+)n7+)nO%({QWO1G5oO%)aQ$IUO1G0tO%)kQSO1G0tOOQO1G/n1G/nO%)vQ$IUO1G/nO>jQSO1G/nO!*SQUO'#DhOOQO,5>w,5>wOOQO-E<Z-E<ZOOQO,5>},5>}OOQO-E<a-E<aO!@eQWO1G/nOOQO-E<^-E<^OOQ(CY1G0Y1G0YOOQ(CY7+%r7+%rO#%ZQSO7+%rOOQ(CY7+&Y7+&YO>jQSO7+&YO!@eQWO7+&YOOQO7+%u7+%uO$9oQ(CjO7+&ROOQO7+&R7+&RO%[QUO7+&RO%*QQ(C[O7+&RO!@YQ(C[O7+%uO!@eQWO7+%uO%*]Q(C[O7+&RO%*kQ(CjO7++dO%[QUO7++dO%*{QSO7++cO%*{QSO7++cOOQO1G4k1G4kO9TQSO1G4kO%+TQSO1G4kOOQO7+%z7+%zO#%ZQSO<<KxO%!RQbO<<KxO%+cQSO<<KxOOQQ<<Kx<<KxO!&^Q,UO<<KxO%[QUO<<KxO%+kQSO<<KxO%+vQ(CjO1G2lO%.RQ(CjO1G2nO%0^Q(CjO1G2YO%2oQ,UO,5>xOOQO-E<[-E<[O%2yQbO,5>yO%[QUO,5>yOOQO-E<]-E<]O%3TQSO1G5qOOQ(CY<<JO<<JOO%3]Q$IUO1G0oO%5gQ$IUO1G0yO%5nQ$IUO1G0yO%7rQ$IUO1G0yO%7yQ$IUO1G0yO%9nQ$IUO1G0yO%:UQ$IUO1G0yO%<iQ$IUO1G0yO%<pQ$IUO1G0yO%>tQ$IUO1G0yO%>{Q$IUO1G0yO%@sQ$IUO1G0yO%AWQ(CjO<<JbO%B]Q$IUO1G0yO%DRQ$IUO'#J`O%FUQ$IUO1G1_O%FcQ$IUO1G0RO!*SQUO'#FmOOQO'#J{'#J{OOQO1G1q1G1qO%FmQSO1G1pO%FrQ$IUO,5?SOOOO7+'d7+'dOOOO1G/T1G/TOOQ(CY1G4p1G4pO!'vQ,UO7+([O%F|QSO,5?TO9ZQSO,5?TOOQO-E<g-E<gO%G[QSO1G6TO%G[QSO1G6TO%GdQSO1G6TO%GoQ,UO7+'tO%HPQ`O,5?VO%HZQSO,5?VO!&^Q,UO,5?VOOQO-E<i-E<iO%H`Q`O1G6UO%HjQSO1G6UOOQ(CW1G2d1G2dO$$eQSO1G2dOOQ(CW1G2c1G2cO%HrQSO1G2eO!&^Q,UO1G2eOOQ(CW1G2j1G2jO!@eQWO1G2cOCXQSO1G2dO%HwQSO1G2eO%IPQSO1G2dO!'vQ,UO7++POOQ(CY1G/]1G/]O%I[QSO1G/]OOQ(CY7+'o7+'oO%IaQ,UO7+'vO%IqQ(CjO<<KSOOQ(CY<<KS<<KSO%JeQSO1G0tO!&^Q,UO'#InO%JjQSO,5@kO!&^Q,UO1G2hOOQQ<<Gy<<GyO!@YQ(C[O<<GyO%JrQ(CjO<<IuOOQ(CY<<Iu<<IuOOQO,5?`,5?`O%KfQSO,5?`O%KkQSO,5?`OOQO-E<r-E<rO%KyQSO1G6^O%KyQSO1G6^O9ZQSO1G6^O@[QSO<<LeOOQQ<<Le<<LeO%LRQSO<<LeO9eQ(C[O<<LeOOQQ<<LQ<<LQO%$_Q(ChO<<LQOOQQ<<LR<<LRO%$iQ`O<<LRO%LWQWO'#IpO%LcQSO,5@oO!*SQUO,5@oOOQQ1G3P1G3PO%LkQUO'#JiOOQO'#Ir'#IrO9eQ(C[O'#IrO%LuQWO,5=nOOQQ,5=n,5=nO%L|QWO'#EaO%MbQSO7+(sO%MgQSO7+(sOOQQ7+(s7+(sO!&^Q,UO7+(sO%[QUO7+(sO%MoQSO7+(sOOQQ7+(u7+(uO9eQ(C[O7+(uO#NWQSO7+(uO9OQSO7+(uO!@eQWO7+(uO%MzQSO,5?_OOQO-E<q-E<qOOQO'#HV'#HVO%NVQSO1G6[O9eQ(C[O<<GoOOQQ<<Go<<GoO@[QSO<<GoO%N_QSO7++yO%NdQSO7++zO%[QUO7++yO%[QUO7++zOOQQ7+(}7+(}O%NiQSO7+(}O%NnQUO7+(}O%NuQSO7+(}OOQQ<<Lq<<LqOOQQ<<Ls<<LsOOQQ-E<t-E<tOOQQ1G3r1G3rO%NzQSO,5>XOOQQ,5>Z,5>ZO& PQSO1G3xO9TQSO7+&`O!*SQUO7+&`OOQO7+%Y7+%YO& UQ$IUO1G5{O>jQSO7+%YOOQ(CY<<I^<<I^OOQ(CY<<It<<ItO>jQSO<<ItOOQO<<Im<<ImO$9oQ(CjO<<ImO%[QUO<<ImOOQO<<Ia<<IaO!@YQ(C[O<<IaO& `Q(C[O<<ImO& kQ(CjO<= OO& {QSO<<N}OOQO7+*V7+*VO9TQSO7+*VOOQQANAdANAdO&!TQSOANAdO!&^Q,UOANAdO#%ZQSOANAdO%!RQbOANAdO%[QUOANAdO&!]Q(CjO7+'tO&$nQ(CjO7+'vO&'PQbO1G4eO&'ZQ$IUO7+&ZO&'hQ$IUO,59oO&)kQ$IUO,5<eO&+nQ$IUO,5<gO&-qQ$IUO,5<uO&/gQ$IUO7+'gO&/tQ$IUO7+'hO&0RQSO,5<XOOQO7+'[7+'[O&0WQ,UO<<KvOOQO1G4o1G4oO&0_QSO1G4oO&0jQSO1G4oO&0xQSO7++oO&0xQSO7++oO!&^Q,UO1G4qO&1QQ`O1G4qO&1[QSO7++pOOQ(CW7+(O7+(OO$$eQSO7+(PO&1dQ`O7+(POOQ(CW7+'}7+'}O$$eQSO7+(OO&1kQSO7+(PO!&^Q,UO7+(POCXQSO7+(OO&1pQ,UO<<NkOOQ(CY7+$w7+$wO&1zQ`O,5?YOOQO-E<l-E<lO&2UQ(ChO7+(SOOQQAN=eAN=eO9ZQSO1G4zOOQO1G4z1G4zO&2fQSO1G4zO&2kQSO7++xO&2kQSO7++xO9eQ(C[OANBPO@[QSOANBPOOQQANBPANBPOOQQANAlANAlOOQQANAmANAmO&2sQSO,5?[OOQO-E<n-E<nO&3OQ$IUO1G6ZO&5`QbO'#CgOOQO,5?^,5?^OOQO-E<p-E<pOOQQ1G3Y1G3YO%LkQUO,5<yOOQQ<<L_<<L_O!&^Q,UO<<L_O%MbQSO<<L_O&5jQSO<<L_O%[QUO<<L_OOQQ<<La<<LaO9eQ(C[O<<LaO#NWQSO<<LaO9OQSO<<LaO&5rQWO1G4yO&5}QSO7++vOOQQAN=ZAN=ZO9eQ(C[OAN=ZOOQQ<= e<= eOOQQ<= f<= fO&6VQSO<= eO&6[QSO<= fOOQQ<<Li<<LiO&6aQSO<<LiO&6fQUO<<LiOOQQ1G3s1G3sO>jQSO7+)dO&6mQSO<<IzO&6xQ$IUO<<IzOOQO<<Ht<<HtOOQ(CYAN?`AN?`OOQOAN?XAN?XO$9oQ(CjOAN?XOOQOAN>{AN>{O%[QUOAN?XOOQO<<Mq<<MqOOQQG27OG27OO!&^Q,UOG27OO#%ZQSOG27OO&7SQSOG27OO%!RQbOG27OO&7[Q$IUO<<JbO&7iQ$IUO1G2YO&9_Q$IUO1G2lO&;bQ$IUO1G2nO&=eQ$IUO<<KSO&=rQ$IUO<<IuOOQO1G1s1G1sO!'vQ,UOANAbOOQO7+*Z7+*ZO&>PQSO7+*ZO&>[QSO<= ZO&>dQ`O7+*]OOQ(CW<<Kk<<KkO$$eQSO<<KkOOQ(CW<<Kj<<KjO&>nQ`O<<KkO$$eQSO<<KjOOQO7+*f7+*fO9ZQSO7+*fO&>uQSO<= dOOQQG27kG27kO9eQ(C[OG27kO!*SQUO1G4vO&>}QSO7++uO%MbQSOANAyOOQQANAyANAyO!&^Q,UOANAyO&?VQSOANAyOOQQANA{ANA{O9eQ(C[OANA{O#NWQSOANA{OOQO'#HW'#HWOOQO7+*e7+*eOOQQG22uG22uOOQQANEPANEPOOQQANEQANEQOOQQANBTANBTO&?_QSOANBTOOQQ<<MO<<MOO!*SQUOAN?fOOQOG24sG24sO$9oQ(CjOG24sO#%ZQSOLD,jOOQQLD,jLD,jO!&^Q,UOLD,jO&?dQSOLD,jO&?lQ$IUO7+'tO&AbQ$IUO7+'vO&CWQ,UOG26|OOQO<<Mu<<MuOOQ(CWANAVANAVO$$eQSOANAVOOQ(CWANAUANAUOOQO<<NQ<<NQOOQQLD-VLD-VO&ChQ$IUO7+*bOOQQG27eG27eO%MbQSOG27eO!&^Q,UOG27eOOQQG27gG27gO9eQ(C[OG27gOOQQG27oG27oO&CrQ$IUOG25QOOQOLD*_LD*_OOQQ!$(!U!$(!UO#%ZQSO!$(!UO!&^Q,UO!$(!UO&C|Q(CjOG26|OOQ(CWG26qG26qOOQQLD-PLD-PO%MbQSOLD-POOQQLD-RLD-ROOQQ!)9Ep!)9EpO#%ZQSO!)9EpOOQQ!$(!k!$(!kOOQQ!.K;[!.K;[O&F_Q$IUOG26|O!*SQUO'#DwO1PQSO'#EUO&HTQbO'#JeO!*SQUO'#DoO&H[QUO'#D{O&HcQbO'#CgO&JyQbO'#CgO!*SQUO'#D}O&KZQUO,5;TO!*SQUO,5;_O!*SQUO,5;_O!*SQUO,5;_O!*SQUO,5;_O!*SQUO,5;_O!*SQUO,5;_O!*SQUO,5;_O!*SQUO,5;_O!*SQUO,5;_O!*SQUO,5;_O!*SQUO,5;_O!*SQUO'#IhO&M^QSO,5<dO&MfQ,UO,5;_O&NyQ,UO,5;_O!*SQUO,5;sO1SQSO'#DTO1SQSO'#DTO!&^Q,UO'#FyO&MfQ,UO'#FyO!&^Q,UO'#F{O&MfQ,UO'#F{O!&^Q,UO'#GZO&MfQ,UO'#GZO!*SQUO,5:gO!*SQUO,5@aO&KZQUO1G0oO' QQ$IUO'#CgO!*SQUO1G1{O!&^Q,UO,5=QO&MfQ,UO,5=QO!&^Q,UO,5=SO&MfQ,UO,5=SO!&^Q,UO,5<nO&MfQ,UO,5<nO&KZQUO1G1|O!*SQUO7+&vO!&^Q,UO1G2YO&MfQ,UO1G2YO!&^Q,UO1G2[O&MfQ,UO1G2[O&KZQUO7+'hO&KZQUO7+&ZO!&^Q,UOANAbO&MfQ,UOANAbO' [QSO'#EiO' aQSO'#EiO' iQSO'#FXO' nQSO'#EsO' sQSO'#JuO'!OQSO'#JsO'!ZQSO,5;TO'!`Q,UO,5<aO'!gQSO'#GSO'!lQSO'#GSO'!qQSO,5<bO'!yQSO,5;TO'#RQ$IUO1G1[O'#YQSO,5<nO'#_QSO,5<nO'#dQSO,5<pO'#iQSO,5<pO'#nQSO1G1|O'#sQSO1G0oO'#xQ,UO<<KvO'$PQ,UO<<KvO7hQ,UO'#FwO9OQSO'#FvOAVQSO'#EhO!*SQUO,5;pO!2|QSO'#GSO!2|QSO'#GSO!2|QSO'#GUO!2|QSO'#GUO!'vQ,UO7+([O!'vQ,UO7+([O$KqQ`O1G2pO$KqQ`O1G2pO!&^Q,UO,5=UO!&^Q,UO,5=U",
  stateData: "'%Y~O'oOS'pOSROS'qRQ~OPYOQYOW!VO_qObzOcyOjkOlYOmkOnkOtkOvYOxYO}WO!RkO!SkO!YXO!duO!iZO!lYO!mYO!nYO!pvO!rwO!uxO!y]O#q!PO$R|O$VfO%a}O%c!QO%e!OO%f!OO%g!OO%j!RO%l!SO%o!TO%p!TO%r!UO&O!WO&U!XO&W!YO&Y!ZO&[![O&_!]O&e!^O&k!_O&m!`O&o!aO&q!bO&s!cO'vSO'xTO'{UO(TVO(c[O(piO~OUtO~P`OPYOQYOb!jOc!iOjkOlYOmkOnkOtkOvYOxYO}WO!RkO!SkO!Y!eO!duO!iZO!lYO!mYO!nYO!pvO!r!gO!u!hO$R!kO$VfO'v!dO'xTO'{UO(TVO(c[O(piO~O_!vOm!nO}!oO!]!xO!^!uO!_!uO!y9rO!}!pO#O!pO#P!wO#Q!pO#R!pO#U!yO#V!yO'w!lO'xTO'{UO(W!mO(c!sO~O'q!zO~OPZXYZX_ZXlZXzZX{ZX}ZX!WZX!fZX!gZX!iZX!mZX#YZX#edX#hZX#iZX#jZX#kZX#lZX#mZX#nZX#oZX#pZX#rZX#tZX#vZX#wZX#|ZX'mZX(TZX(dZX(kZX(lZX~O!b${X~P(qO]!|O'x#OO'y!|O'z#OO~O]#PO'z#OO'{#OO'|#PO~Or#RO!P#SO(U#SO(V#UO~OPYOQYOb!jOc!iOjkOlYOmkOnkOtkOvYOxYO}WO!RkO!SkO!Y!eO!duO!iZO!lYO!mYO!nYO!pvO!r!gO!u!hO$R!kO$VfO'v9vO'xTO'{UO(TVO(c[O(piO~O!V#YO!W#VO!T(ZP!T(hP~P+}O!X#bO~P`OPYOQYOb!jOc!iOlYOmkOnkOtkOvYOxYO}WO!RkO!SkO!Y!eO!duO!iZO!lYO!mYO!nYO!pvO!r!gO!u!hO$R!kO$VfO'xTO'{UO(TVO(c[O(piO~Oj#lO!V#hO!y]O#c#kO#d#hO'v9wO!h(eP~P.iO!i#nO'v#mO~O!u#rO!y]O%a#sO~O#e#tO~O!b#uO#e#tO~OP$]OY$dOl$QOz#yO{#zO}#{O!W$aO!f$SO!g#wO!i#xO!m$]O#h$OO#i$PO#j$PO#k$PO#l$RO#m$SO#n$SO#o$cO#p$SO#r$TO#t$VO#v$XO#w$YO(TVO(d$ZO(k#|O(l#}O~O_(XX'm(XX'k(XX!h(XX!T(XX!Y(XX%b(XX!b(XX~P1qO#Y$eO#|$eOP(YXY(YXl(YXz(YX{(YX}(YX!W(YX!f(YX!i(YX!m(YX#h(YX#i(YX#j(YX#k(YX#l(YX#m(YX#n(YX#o(YX#p(YX#r(YX#t(YX#v(YX#w(YX(T(YX(d(YX(k(YX(l(YX!Y(YX%b(YX~O_(YX!g(YX'm(YX'k(YX!T(YX!h(YXp(YX!b(YX~P4XO#Y$eO~O$X$gO$Z$fO$b$lO~O!Y$mO$VfO$e$nO$g$pO~Oj%SOl$tOm$sOn$sOt%TOv%UOx%VO}${O!Y$|O!d%[O!i$xO#d%]O$R%YO$n%WO$p%XO$s%ZO'v$rO'xTO'{UO(P%RO(T$uOe(QP~O!i%^O~O}%aO!Y%bO'v%`O~O!b%fO~O_%gO'm%gO~O'w!lO~P%[O%g%nO~P%[O!i%^O'v%`O'w!lO(P%RO~Oc%uO!i%^O'v%`O~O#p$SO~Oz%zO!Y%wO!i%yO%c%}O'v%`O'w!lO'xTO'{UO^(yP~O!u#rO~O%l&PO}(uX!Y(uX'v(uX~O'v&QO~O!r&VO#q!PO%c!QO%e!OO%f!OO%g!OO%j!RO%l!SO%o!TO%p!TO~Ob&[Oc&ZO!u&XO%a&YO%t&WO~P;rOb&_OcyO!Y&^O!r&VO!uxO!y]O#q!PO%a}O%e!OO%f!OO%g!OO%j!RO%l!SO%o!TO%p!TO%r!UO~O`&bO#Y&eO%c&`O'w!lO~P<wO!i&fO!r&jO~O!i#nO~O!YXO~O_%gO'l&rO'm%gO~O_%gO'l&uO'm%gO~O_%gO'l&wO'm%gO~O'kZX!TZXpZX!hZX&SZX!YZX%bZX!bZX~P(qO!]'UO!^&}O!_&}O'w!lO'xTO'{UO~Om&{O}&zO!V'OO(W&yO!X([P!X(jP~P@OOh'XO!Y'VO'v%`O~Oc'^O!i%^O'v%`O~Oz%zO!i%yO~Om!nO}!oO!y9rO!}!pO#O!pO#Q!pO#R!pO'w!lO'xTO'{UO(W!mO(c!sO~O!]'dO!^'cO!_'cO#P!pO#U'eO#V'eO~PAjO_%gO!b#uO!i%^O'm%gO(P%RO(d'gO~O!m'kO#Y'iO~PBxOm!nO}!oO'xTO'{UO(W!mO(c!sO~O!YXOm(aX}(aX!](aX!^(aX!_(aX!y(aX!}(aX#O(aX#P(aX#Q(aX#R(aX#U(aX#V(aX'w(aX'x(aX'{(aX(W(aX(c(aX~O!^'cO!_'cO'w!lO~PChO'r'oO's'oO't'qO~O]!|O'x'sO'y!|O'z'sO~O]#PO'z'sO'{'sO'|#PO~Or#RO!P#SO(U#SO(V'wO~O!V'yO!T'OX!T'UX!W'OX!W'UX~P+}O!W'{O!T(ZX~OP$]OY$dOl$QOz#yO{#zO}#{O!W'{O!f$SO!g#wO!i#xO!m$]O#h$OO#i$PO#j$PO#k$PO#l$RO#m$SO#n$SO#o$cO#p$SO#r$TO#t$VO#v$XO#w$YO(TVO(d$ZO(k#|O(l#}O~O!T(ZX~PG[O!T(QO~O!T(gX!W(gX!b(gX!h(gX(d(gX~O#Y(gX#e#^X!X(gX~PIbO#Y(RO!T(iX!W(iX~O!W(SO!T(hX~O!T(VO~O#Y$eO~PIbO!X(WO~P`Oz#yO{#zO}#{O!g#wO!i#xO(TVOP!kaY!kal!ka!W!ka!f!ka!m!ka#h!ka#i!ka#j!ka#k!ka#l!ka#m!ka#n!ka#o!ka#p!ka#r!ka#t!ka#v!ka#w!ka(d!ka(k!ka(l!ka~O_!ka'm!ka'k!ka!T!ka!h!kap!ka!Y!ka%b!ka!b!ka~PJxO!h(XO~O!b#uO#Y(YO(d'gO!W(fX_(fX'm(fX~O!h(fX~PMhO}%aO!Y%bO!y]O#c(_O#d(^O'v%`O~O!W(`O!h(eX~O!h(bO~O}%aO!Y%bO#d(^O'v%`O~OP(YXY(YXl(YXz(YX{(YX}(YX!W(YX!f(YX!g(YX!i(YX!m(YX#h(YX#i(YX#j(YX#k(YX#l(YX#m(YX#n(YX#o(YX#p(YX#r(YX#t(YX#v(YX#w(YX(T(YX(d(YX(k(YX(l(YX~O!b#uO!h(YX~P! UOz(cO{(dO!g#wO!i#xO!y!xa}!xa~O!u!xa%a!xa!Y!xa#c!xa#d!xa'v!xa~P!#YO!u(hO~OPYOQYOb!jOc!iOjkOlYOmkOnkOtkOvYOxYO}WO!RkO!SkO!YXO!duO!iZO!lYO!mYO!nYO!pvO!r!gO!u!hO$R!kO$VfO'v!dO'xTO'{UO(TVO(c[O(piO~Oj%SOl$tOm$sOn$sOt%TOv%UOx:[O}${O!Y$|O!d;fO!i$xO#d:bO$R%YO$n:^O$p:`O$s%ZO'v(lO'xTO'{UO(P%RO(T$uO~O#e(nO~Oj%SOl$tOm$sOn$sOt%TOv%UOx%VO}${O!Y$|O!d%[O!i$xO#d%]O$R%YO$n%WO$p%XO$s%ZO'v(lO'xTO'{UO(P%RO(T$uO~Oe(^P~P!'vO!V(rO!h(_P~P%[O(W(tO(c[O~O}(vO!i#xO(W(tO(c[O~OP9qOQ9qOb;bOc!iOjkOl9qOmkOnkOtkOv9qOx9qO}WO!RkO!SkO!Y!eO!d9tO!iZO!l9qO!m9qO!n9qO!p9uO!r9xO!u!hO$R!kO$VfO'v)UO'xTO'{UO(TVO(c[O(p;`O~O{)XO!i#xO~O!W$aO_$la'm$la'k$la!h$la!T$la!Y$la%b$la!b$la~O#q)]O~P!&^Oz)`O!b)_O!Y$YX$U$YX$X$YX$Z$YX$b$YX~O!b)_O!Y(mX$U(mX$X(mX$Z(mX$b(mX~Oz)`O~P!-lOz)`O!Y(mX$U(mX$X(mX$Z(mX$b(mX~O!Y)bO$U)fO$X)aO$Z)aO$b)gO~O!V)jO~P!*SO$X$gO$Z$fO$b)nO~Oh$tXz$tX}$tX!g$tX(k$tX(l$tX~OegXe$tXhgX!WgX#YgX~P!/bOm)pO~Or)qO(U)rO(V)tO~Oh)}Oz)vO})wO(k)yO(l){O~Oe)uO~P!0kOe*OO~Oj%SOl$tOm$sOn$sOt%TOv%UOx:[O}${O!Y$|O!d;fO!i$xO#d:bO$R%YO$n:^O$p:`O$s%ZO'xTO'{UO(P%RO(T$uO~O!V*SO'v*PO!h(qP~P!1YO#e*UO~O!i*VO~O!V*[O'v*XO!T(rP~P!1YOl*hO}*`O!]*fO!^*_O!_*_O!i*VO#U*gO%X*bO'w!lO(W!mO~O!X*eO~P!3`O!g#wOh(SXz(SX}(SX(k(SX(l(SX!W(SX#Y(SX~Oe(SX#z(SX~P!4XOh*kO#Y*jOe(RX!W(RX~O!W*lOe(QX~O'v&QOe(QP~O!i*sO~O'v(lO~Oj*wO}%aO!V#hO!Y%bO!y]O#c#kO#d#hO'v%`O!h(eP~O!b#uO#e*xO~O}%aO!V*zO!W(SO!Y%bO'v%`O!T(hP~Om'RO}*|O!V*{O'xTO'{UO(W(tO~O!X(jP~P!7SO!W*}O_(vX'm(vX~OP$]OY$dOl$QOz#yO{#zO}#{O!f$SO!g#wO!i#xO!m$]O#h$OO#i$PO#j$PO#k$PO#l$RO#m$SO#n$SO#o$cO#p$SO#r$TO#t$VO#v$XO#w$YO(TVO(d$ZO(k#|O(l#}O~O_!ca!W!ca'm!ca'k!ca!T!ca!h!cap!ca!Y!ca%b!ca!b!ca~P!7zOz#yO{#zO}#{O!g#wO!i#xO(TVOP!oaY!oal!oa!W!oa!f!oa!m!oa#h!oa#i!oa#j!oa#k!oa#l!oa#m!oa#n!oa#o!oa#p!oa#r!oa#t!oa#v!oa#w!oa(d!oa(k!oa(l!oa~O_!oa'm!oa'k!oa!T!oa!h!oap!oa!Y!oa%b!oa!b!oa~P!:eOz#yO{#zO}#{O!g#wO!i#xO(TVOP!qaY!qal!qa!W!qa!f!qa!m!qa#h!qa#i!qa#j!qa#k!qa#l!qa#m!qa#n!qa#o!qa#p!qa#r!qa#t!qa#v!qa#w!qa(d!qa(k!qa(l!qa~O_!qa'm!qa'k!qa!T!qa!h!qap!qa!Y!qa%b!qa!b!qa~P!=OOh+WO!Y'VO%b+VO(P%RO~O!b+YO_(OX!Y(OX'm(OX!W(OX~O_%gO!YXO'm%gO~O!i%^O(P%RO~O!i%^O'v%`O(P%RO~O!b#uO#e(nO~O`+eO%c+fO'v+bO'xTO'{UO!X(zP~O!W+gO^(yX~OY+kO~O^+lO~O!Y%wO'v%`O'w!lO^(yP~O#Y+qO(P%RO~Oh+tO!Y$|O(P%RO~O!Y+vO~Oz+xO!YXO~O%g%nO~O!u+}O~Oc,SO~O`,TO'v#mO'xTO'{UO!X(xP~Oc%uO~O%c!QO'v&QO~P<wOY,YO^,XO~OPYOQYObzOcyOjkOlYOmkOnkOtkOvYOxYO}WO!RkO!SkO!duO!iZO!lYO!mYO!nYO!pvO!uxO!y]O$VfO%a}O'xTO'{UO(TVO(c[O(piO~O!Y!eO!r!gO$R!kO'v!dO~P!DRO^,XO_%gO'm%gO~OPYOQYOb!jOc!iOjkOlYOmkOnkOtkOvYOxYO}WO!RkO!SkO!Y!eO!duO!iZO!lYO!mYO!nYO!pvO!u!hO$R!kO$VfO'v!dO'xTO'{UO(TVO(c[O(piO~O_,_O!rwO#q!OO%e!OO%f!OO%g!OO~P!FkO!i&fO~O&U,eO~O!Y,gO~O&g,iO&i,jOP&daQ&daW&da_&dab&dac&daj&dal&dam&dan&dat&dav&dax&da}&da!R&da!S&da!Y&da!d&da!i&da!l&da!m&da!n&da!p&da!r&da!u&da!y&da#q&da$R&da$V&da%a&da%c&da%e&da%f&da%g&da%j&da%l&da%o&da%p&da%r&da&O&da&U&da&W&da&Y&da&[&da&_&da&e&da&k&da&m&da&o&da&q&da&s&da'k&da'v&da'x&da'{&da(T&da(c&da(p&da!X&da&]&da`&da&b&da~O'v,oO~O!W|X!W!`X!X|X!X!`X!b|X!b!`X!i!`X#Y|X(P!`X~O!b,tO#Y,sO!W#bX!W(]X!X#bX!X(]X!b(]X!i(]X(P(]X~O!b,vO!i%^O(P%RO!W![X!X![X~Om!nO}!oO'xTO'{UO(W!mO~OP9qOQ9qOb;bOc!iOjkOl9qOmkOnkOtkOv9qOx9qO}WO!RkO!SkO!Y!eO!d9tO!iZO!l9qO!m9qO!n9qO!p9uO!r9xO!u!hO$R!kO$VfO'xTO'{UO(TVO(c[O(p;`O~O'v:gO~P# qO!W,zO!X([X~O!X,|O~O!b,tO#Y,sO!W#bX!X#bX~O!W,}O!X(jX~O!X-PO~O!^-QO!_-QO'w!lO~P# `O!X-TO~P'_Oh-WO!Y'VO~O!T-]O~Om!xa!]!xa!^!xa!_!xa!}!xa#O!xa#P!xa#Q!xa#R!xa#U!xa#V!xa'w!xa'x!xa'{!xa(W!xa(c!xa~P!#YO!m-bO#Y-`O~PBxO!^-dO!_-dO'w!lO~PChO_%gO#Y-`O'm%gO~O_%gO!b#uO#Y-`O'm%gO~O_%gO!b#uO!m-bO#Y-`O'm%gO(d'gO~O'r'oO's'oO't-iO~Op-jO~O!T'Oa!W'Oa~P!7zO!V-nO!T'OX!W'OX~P%[O!W'{O!T(Za~O!T(Za~PG[O!W(SO!T(ha~O}%aO!V-rO!Y%bO'v%`O!T'UX!W'UX~O#Y-tO!W(fa!h(fa_(fa'm(fa~O!b#uO~P#)wO!W(`O!h(ea~O}%aO!Y%bO#d-xO'v%`O~Oj-}O}%aO!V-zO!Y%bO!y]O#c-|O#d-zO'v%`O!W'XX!h'XX~O{.RO!i#xO~Oh.UO!Y'VO%b.TO(P%RO~O_#]i!W#]i'm#]i'k#]i!T#]i!h#]ip#]i!Y#]i%b#]i!b#]i~P!7zOh;lOz)vO})wO(k)yO(l){O~O#e#Xa_#Xa#Y#Xa'm#Xa!W#Xa!h#Xa!Y#Xa!T#Xa~P#,sO#e(SXP(SXY(SX_(SXl(SX{(SX!f(SX!i(SX!m(SX#h(SX#i(SX#j(SX#k(SX#l(SX#m(SX#n(SX#o(SX#p(SX#r(SX#t(SX#v(SX#w(SX'm(SX(T(SX(d(SX!h(SX!T(SX'k(SXp(SX!Y(SX%b(SX!b(SX~P!4XO!W._Oe(^X~P!0kOe.aO~O!W.bO!h(_X~P!7zO!h.eO~O!T.gO~OP$]Oz#yO{#zO}#{O!g#wO!i#xO!m$]O(TVOY#gi_#gil#gi!W#gi!f#gi#i#gi#j#gi#k#gi#l#gi#m#gi#n#gi#o#gi#p#gi#r#gi#t#gi#v#gi#w#gi'm#gi(d#gi(k#gi(l#gi'k#gi!T#gi!h#gip#gi!Y#gi%b#gi!b#gi~O#h#gi~P#0oO#h$OO~P#0oOP$]Oz#yO{#zO}#{O!g#wO!i#xO!m$]O#h$OO#i$PO#j$PO#k$PO(TVOY#gi_#gi!W#gi!f#gi#l#gi#m#gi#n#gi#o#gi#p#gi#r#gi#t#gi#v#gi#w#gi'm#gi(d#gi(k#gi(l#gi'k#gi!T#gi!h#gip#gi!Y#gi%b#gi!b#gi~Ol#gi~P#3aOl$QO~P#3aOP$]Ol$QOz#yO{#zO}#{O!g#wO!i#xO!m$]O#h$OO#i$PO#j$PO#k$PO#l$RO(TVO_#gi!W#gi#r#gi#t#gi#v#gi#w#gi'm#gi(d#gi(k#gi(l#gi'k#gi!T#gi!h#gip#gi!Y#gi%b#gi!b#gi~OY#gi!f#gi#m#gi#n#gi#o#gi#p#gi~P#6ROY$dO!f$SO#m$SO#n$SO#o$cO#p$SO~P#6ROP$]OY$dOl$QOz#yO{#zO}#{O!f$SO!g#wO!i#xO!m$]O#h$OO#i$PO#j$PO#k$PO#l$RO#m$SO#n$SO#o$cO#p$SO#r$TO(TVO_#gi!W#gi#t#gi#v#gi#w#gi'm#gi(d#gi(l#gi'k#gi!T#gi!h#gip#gi!Y#gi%b#gi!b#gi~O(k#gi~P#9SO(k#|O~P#9SOP$]OY$dOl$QOz#yO{#zO}#{O!f$SO!g#wO!i#xO!m$]O#h$OO#i$PO#j$PO#k$PO#l$RO#m$SO#n$SO#o$cO#p$SO#r$TO#t$VO(TVO(k#|O_#gi!W#gi#v#gi#w#gi'm#gi(d#gi'k#gi!T#gi!h#gip#gi!Y#gi%b#gi!b#gi~O(l#gi~P#;tO(l#}O~P#;tOP$]OY$dOl$QOz#yO{#zO}#{O!f$SO!g#wO!i#xO!m$]O#h$OO#i$PO#j$PO#k$PO#l$RO#m$SO#n$SO#o$cO#p$SO#r$TO#t$VO#v$XO(TVO(k#|O(l#}O~O_#gi!W#gi#w#gi'm#gi(d#gi'k#gi!T#gi!h#gip#gi!Y#gi%b#gi!b#gi~P#>fOPZXYZXlZXzZX{ZX}ZX!fZX!gZX!iZX!mZX#YZX#edX#hZX#iZX#jZX#kZX#lZX#mZX#nZX#oZX#pZX#rZX#tZX#vZX#wZX#|ZX(TZX(dZX(kZX(lZX!WZX!XZX~O#zZX~P#APOP$]OY:YOl9|Oz#yO{#zO}#{O!f:OO!g#wO!i#xO!m$]O#h9zO#i9{O#j9{O#k9{O#l9}O#m:OO#n:OO#o:XO#p:OO#r:PO#t:RO#v:TO#w:UO(TVO(d$ZO(k#|O(l#}O~O#z.iO~P#C^O#Y:ZO#|:ZO#z(YX!X(YX~P! UO_'[a!W'[a'm'[a'k'[a!h'[a!T'[ap'[a!Y'[a%b'[a!b'[a~P!7zOP#giY#gi_#gil#gi{#gi!W#gi!f#gi!g#gi!i#gi!m#gi#h#gi#i#gi#j#gi#k#gi#l#gi#m#gi#n#gi#o#gi#p#gi#r#gi#t#gi#v#gi#w#gi'm#gi(T#gi(d#gi'k#gi!T#gi!h#gip#gi!Y#gi%b#gi!b#gi~P#,sO_#{i!W#{i'm#{i'k#{i!T#{i!h#{ip#{i!Y#{i%b#{i!b#{i~P!7zO$X.nO$Z.nO~O$X.oO$Z.oO~O!b)_O#Y.pO!Y$_X$U$_X$X$_X$Z$_X$b$_X~O!V.qO~O!Y)bO$U.sO$X)aO$Z)aO$b.tO~O!W:VO!X(XX~P#C^O!X.uO~O!b)_O$b(mX~O$b.wO~Or)qO(U)rO(V.zO~O!T/OO~P!&^O!WdX!bdX!hdX!h$tX(ddX~P!/bO!h/UO~P#,sO!W/VO!b#uO(d'gO!h(qX~O!h/[O~O!V*SO'v%`O!h(qP~O#e/^O~O!T$tX!W$tX!b${X~P!/bO!W/_O!T(rX~P#,sO!b/aO~O!T/cO~Ol/gO!b#uO!i%^O(P%RO(d'gO~O'v/iO~O!b+YO~O_%gO!W/mO'm%gO~O!X/oO~P!3`O!^/pO!_/pO'w!lO(W!mO~O}/rO(W!mO~O#U/sO~O'v&QOe'aX!W'aX~O!W*lOe(Qa~Oe/xO~Oz/yO{/yO}/zOhwa(kwa(lwa!Wwa#Ywa~Oewa#zwa~P$ tOz)vO})wOh$ma(k$ma(l$ma!W$ma#Y$ma~Oe$ma#z$ma~P$!jOz)vO})wOh$oa(k$oa(l$oa!W$oa#Y$oa~Oe$oa#z$oa~P$#]O#e/|O~Oe$}a!W$}a#Y$}a#z$}a~P!0kO!b#uO~O#e0PO~O!W*}O_(va'm(va~Oz#yO{#zO}#{O!g#wO!i#xO(TVOP!oiY!oil!oi!W!oi!f!oi!m!oi#h!oi#i!oi#j!oi#k!oi#l!oi#m!oi#n!oi#o!oi#p!oi#r!oi#t!oi#v!oi#w!oi(d!oi(k!oi(l!oi~O_!oi'm!oi'k!oi!T!oi!h!oip!oi!Y!oi%b!oi!b!oi~P$$zOh.UO!Y'VO%b.TO~Oj0ZO'v0YO~P!1]O!b+YO_(Oa!Y(Oa'm(Oa!W(Oa~O#e0aO~OYZX!WdX!XdX~O!W0bO!X(zX~O!X0dO~OY0eO~O`0gO'v+bO'xTO'{UO~O!Y%wO'v%`O^'iX!W'iX~O!W+gO^(ya~O!h0jO~P!7zOY0mO~O^0nO~O#Y0qO~Oh0tO!Y$|O~O(W(tO!X(wP~Oh0}O!Y0zO%b0|O(P%RO~OY1XO!W1VO!X(xX~O!X1YO~O^1[O_%gO'm%gO~O'v#mO'xTO'{UO~O#Y$eO#|$eOP(YXY(YXl(YXz(YX{(YX}(YX!W(YX!f(YX!i(YX!m(YX#h(YX#i(YX#j(YX#k(YX#l(YX#m(YX#n(YX#o(YX#r(YX#t(YX#v(YX#w(YX(T(YX(d(YX(k(YX(l(YX~O#p1_O&S1`O_(YX!g(YX~P$+sO#Y$eO#p1_O&S1`O~O_1bO~P%[O_1dO~O&]1gOP&ZiQ&ZiW&Zi_&Zib&Zic&Zij&Zil&Zim&Zin&Zit&Ziv&Zix&Zi}&Zi!R&Zi!S&Zi!Y&Zi!d&Zi!i&Zi!l&Zi!m&Zi!n&Zi!p&Zi!r&Zi!u&Zi!y&Zi#q&Zi$R&Zi$V&Zi%a&Zi%c&Zi%e&Zi%f&Zi%g&Zi%j&Zi%l&Zi%o&Zi%p&Zi%r&Zi&O&Zi&U&Zi&W&Zi&Y&Zi&[&Zi&_&Zi&e&Zi&k&Zi&m&Zi&o&Zi&q&Zi&s&Zi'k&Zi'v&Zi'x&Zi'{&Zi(T&Zi(c&Zi(p&Zi!X&Zi`&Zi&b&Zi~O`1mO!X1kO&b1lO~P`O!YXO!i1oO~O&i,jOP&diQ&diW&di_&dib&dic&dij&dil&dim&din&dit&div&dix&di}&di!R&di!S&di!Y&di!d&di!i&di!l&di!m&di!n&di!p&di!r&di!u&di!y&di#q&di$R&di$V&di%a&di%c&di%e&di%f&di%g&di%j&di%l&di%o&di%p&di%r&di&O&di&U&di&W&di&Y&di&[&di&_&di&e&di&k&di&m&di&o&di&q&di&s&di'k&di'v&di'x&di'{&di(T&di(c&di(p&di!X&di&]&di`&di&b&di~O!T1uO~O!W![a!X![a~P#C^Om!nO}!oO!V1{O(W!mO!W'PX!X'PX~P@OO!W,zO!X([a~O!W'VX!X'VX~P!7SO!W,}O!X(ja~O!X2SO~P'_O_%gO#Y2]O'm%gO~O_%gO!b#uO#Y2]O'm%gO~O_%gO!b#uO!m2aO#Y2]O'm%gO(d'gO~O_%gO'm%gO~P!7zO!W$aOp$la~O!T'Oi!W'Oi~P!7zO!W'{O!T(Zi~O!W(SO!T(hi~O!T(ii!W(ii~P!7zO!W(fi!h(fi_(fi'm(fi~P!7zO#Y2cO!W(fi!h(fi_(fi'm(fi~O!W(`O!h(ei~O}%aO!Y%bO!y]O#c2hO#d2gO'v%`O~O}%aO!Y%bO#d2gO'v%`O~Oh2oO!Y'VO%b2nO~Oh2oO!Y'VO%b2nO(P%RO~O#ewaPwaYwa_walwa!fwa!gwa!iwa!mwa#hwa#iwa#jwa#kwa#lwa#mwa#nwa#owa#pwa#rwa#twa#vwa#wwa'mwa(Twa(dwa!hwa!Twa'kwapwa!Ywa%bwa!bwa~P$ tO#e$maP$maY$ma_$mal$ma{$ma!f$ma!g$ma!i$ma!m$ma#h$ma#i$ma#j$ma#k$ma#l$ma#m$ma#n$ma#o$ma#p$ma#r$ma#t$ma#v$ma#w$ma'm$ma(T$ma(d$ma!h$ma!T$ma'k$map$ma!Y$ma%b$ma!b$ma~P$!jO#e$oaP$oaY$oa_$oal$oa{$oa!f$oa!g$oa!i$oa!m$oa#h$oa#i$oa#j$oa#k$oa#l$oa#m$oa#n$oa#o$oa#p$oa#r$oa#t$oa#v$oa#w$oa'm$oa(T$oa(d$oa!h$oa!T$oa'k$oap$oa!Y$oa%b$oa!b$oa~P$#]O#e$}aP$}aY$}a_$}al$}a{$}a!W$}a!f$}a!g$}a!i$}a!m$}a#h$}a#i$}a#j$}a#k$}a#l$}a#m$}a#n$}a#o$}a#p$}a#r$}a#t$}a#v$}a#w$}a'm$}a(T$}a(d$}a!h$}a!T$}a'k$}a#Y$}ap$}a!Y$}a%b$}a!b$}a~P#,sO_#]q!W#]q'm#]q'k#]q!T#]q!h#]qp#]q!Y#]q%b#]q!b#]q~P!7zOe'QX!W'QX~P!'vO!W._Oe(^a~O!V2wO!W'RX!h'RX~P%[O!W.bO!h(_a~O!W.bO!h(_a~P!7zO!T2zO~O#z!ka!X!ka~PJxO#z!ca!W!ca!X!ca~P#C^O#z!oa!X!oa~P!:eO#z!qa!X!qa~P!=OO!Y3^O$VfO$`3_O~O!X3cO~Op3dO~P#,sO_$iq!W$iq'm$iq'k$iq!T$iq!h$iqp$iq!Y$iq%b$iq!b$iq~P!7zO!T3eO~P#,sOz)vO})wO(l){Oh%Yi(k%Yi!W%Yi#Y%Yi~Oe%Yi#z%Yi~P$J]Oz)vO})wOh%[i(k%[i(l%[i!W%[i#Y%[i~Oe%[i#z%[i~P$KOO(d$ZO~P#,sO!V3hO'v%`O!W']X!h']X~O!W/VO!h(qa~O!W/VO!b#uO!h(qa~O!W/VO!b#uO(d'gO!h(qa~Oe$vi!W$vi#Y$vi#z$vi~P!0kO!V3pO'v*XO!T'_X!W'_X~P!1YO!W/_O!T(ra~O!W/_O!T(ra~P#,sO!b#uO#p3xO~Ol3{O!b#uO(d'gO~Oe(Ri!W(Ri~P!0kO#Y4OOe(Ri!W(Ri~P!0kO!h4RO~O_$jq!W$jq'm$jq'k$jq!T$jq!h$jqp$jq!Y$jq%b$jq!b$jq~P!7zO!T4VO~O!W4WO!Y(sX~P#,sO!g#wO~P4XO_$tX!Y$tX%VZX'm$tX!W$tX~P!/bO%V4YO_iXhiXziX}iX!YiX'miX(kiX(liX!WiX~O%V4YO~O`4`O%c4aO'v+bO'xTO'{UO!W'hX!X'hX~O!W0bO!X(za~OY4eO~O^4fO~O_%gO'm%gO~P#,sO!Y$|O~P#,sO!W4nO#Y4pO!X(wX~O!X4qO~Om!nO}4rO!]!xO!^!uO!_!uO!y9rO!}!pO#O!pO#P!pO#Q!pO#R!pO#U4wO#V!yO'w!lO'xTO'{UO(W!mO(c!sO~O!X4vO~P%%QOh4|O!Y0zO%b4{O~Oh4|O!Y0zO%b4{O(P%RO~O`5TO'v#mO'xTO'{UO!W'gX!X'gX~O!W1VO!X(xa~O'xTO'{UO(W5VO~O^5ZO~O#p5^O&S5_O~PMhO!h5`O~P%[O_5bO~O_5bO~P%[O`1mO!X5gO&b1lO~P`O!b5iO~O!b5kO!W(]i!X(]i!b(]i!i(]i(P(]i~O!W#bi!X#bi~P#C^O#Y5lO!W#bi!X#bi~O!W![i!X![i~P#C^O_%gO#Y5uO'm%gO~O_%gO!b#uO#Y5uO'm%gO~O!W(fq!h(fq_(fq'm(fq~P!7zO!W(`O!h(eq~O}%aO!Y%bO#d5|O'v%`O~O!Y'VO%b6PO~Oh6SO!Y'VO%b6PO~O#e%YiP%YiY%Yi_%Yil%Yi{%Yi!f%Yi!g%Yi!i%Yi!m%Yi#h%Yi#i%Yi#j%Yi#k%Yi#l%Yi#m%Yi#n%Yi#o%Yi#p%Yi#r%Yi#t%Yi#v%Yi#w%Yi'm%Yi(T%Yi(d%Yi!h%Yi!T%Yi'k%Yip%Yi!Y%Yi%b%Yi!b%Yi~P$J]O#e%[iP%[iY%[i_%[il%[i{%[i!f%[i!g%[i!i%[i!m%[i#h%[i#i%[i#j%[i#k%[i#l%[i#m%[i#n%[i#o%[i#p%[i#r%[i#t%[i#v%[i#w%[i'm%[i(T%[i(d%[i!h%[i!T%[i'k%[ip%[i!Y%[i%b%[i!b%[i~P$KOO#e$viP$viY$vi_$vil$vi{$vi!W$vi!f$vi!g$vi!i$vi!m$vi#h$vi#i$vi#j$vi#k$vi#l$vi#m$vi#n$vi#o$vi#p$vi#r$vi#t$vi#v$vi#w$vi'm$vi(T$vi(d$vi!h$vi!T$vi'k$vi#Y$vip$vi!Y$vi%b$vi!b$vi~P#,sOe'Qa!W'Qa~P!0kO!W'Ra!h'Ra~P!7zO!W.bO!h(_i~O#z#]i!W#]i!X#]i~P#C^OP$]Oz#yO{#zO}#{O!g#wO!i#xO!m$]O(TVOY#gil#gi!f#gi#i#gi#j#gi#k#gi#l#gi#m#gi#n#gi#o#gi#p#gi#r#gi#t#gi#v#gi#w#gi#z#gi(d#gi(k#gi(l#gi!W#gi!X#gi~O#h#gi~P%3jO#h9zO~P%3jOP$]Oz#yO{#zO}#{O!g#wO!i#xO!m$]O#h9zO#i9{O#j9{O#k9{O(TVOY#gi!f#gi#l#gi#m#gi#n#gi#o#gi#p#gi#r#gi#t#gi#v#gi#w#gi#z#gi(d#gi(k#gi(l#gi!W#gi!X#gi~Ol#gi~P%5uOl9|O~P%5uOP$]Ol9|Oz#yO{#zO}#{O!g#wO!i#xO!m$]O#h9zO#i9{O#j9{O#k9{O#l9}O(TVO#r#gi#t#gi#v#gi#w#gi#z#gi(d#gi(k#gi(l#gi!W#gi!X#gi~OY#gi!f#gi#m#gi#n#gi#o#gi#p#gi~P%8QOY:YO!f:OO#m:OO#n:OO#o:XO#p:OO~P%8QOP$]OY:YOl9|Oz#yO{#zO}#{O!f:OO!g#wO!i#xO!m$]O#h9zO#i9{O#j9{O#k9{O#l9}O#m:OO#n:OO#o:XO#p:OO#r:PO(TVO#t#gi#v#gi#w#gi#z#gi(d#gi(l#gi!W#gi!X#gi~O(k#gi~P%:lO(k#|O~P%:lOP$]OY:YOl9|Oz#yO{#zO}#{O!f:OO!g#wO!i#xO!m$]O#h9zO#i9{O#j9{O#k9{O#l9}O#m:OO#n:OO#o:XO#p:OO#r:PO#t:RO(TVO(k#|O#v#gi#w#gi#z#gi(d#gi!W#gi!X#gi~O(l#gi~P%<wO(l#}O~P%<wOP$]OY:YOl9|Oz#yO{#zO}#{O!f:OO!g#wO!i#xO!m$]O#h9zO#i9{O#j9{O#k9{O#l9}O#m:OO#n:OO#o:XO#p:OO#r:PO#t:RO#v:TO(TVO(k#|O(l#}O~O#w#gi#z#gi(d#gi!W#gi!X#gi~P%?SO_#xy!W#xy'm#xy'k#xy!T#xy!h#xyp#xy!Y#xy%b#xy!b#xy~P!7zOh;mOz)vO})wO(k)yO(l){O~OP#giY#gil#gi{#gi!f#gi!g#gi!i#gi!m#gi#h#gi#i#gi#j#gi#k#gi#l#gi#m#gi#n#gi#o#gi#p#gi#r#gi#t#gi#v#gi#w#gi#z#gi(T#gi(d#gi!W#gi!X#gi~P%AzO!g#wOP(SXY(SXh(SXl(SXz(SX{(SX}(SX!f(SX!i(SX!m(SX#h(SX#i(SX#j(SX#k(SX#l(SX#m(SX#n(SX#o(SX#p(SX#r(SX#t(SX#v(SX#w(SX#z(SX(T(SX(d(SX(k(SX(l(SX!W(SX!X(SX~O#z#{i!W#{i!X#{i~P#C^O#z!oi!X!oi~P$$zO!X6`O~O!W'[a!X'[a~P#C^O!b#uO(d'gO!W']a!h']a~O!W/VO!h(qi~O!W/VO!b#uO!h(qi~Oe$vq!W$vq#Y$vq#z$vq~P!0kO!T'_a!W'_a~P#,sO!b6gO~O!W/_O!T(ri~P#,sO!W/_O!T(ri~O!T6kO~O!b#uO#p6pO~Ol6qO!b#uO(d'gO~O!T6sO~Oe$xq!W$xq#Y$xq#z$xq~P!0kO_$jy!W$jy'm$jy'k$jy!T$jy!h$jyp$jy!Y$jy%b$jy!b$jy~P!7zO!b5kO~O!W4WO!Y(sa~O_#]y!W#]y'm#]y'k#]y!T#]y!h#]yp#]y!Y#]y%b#]y!b#]y~P!7zOY6xO~O`6zO'v+bO'xTO'{UO~O!W0bO!X(zi~O^7OO~O(W(tO!W'dX!X'dX~O!W4nO!X(wa~OjkO'v7VO~P.iO!X7YO~P%%QOm!nO}7ZO'xTO'{UO(W!mO(c!sO~O!Y0zO~O!Y0zO%b7]O~Oh7`O!Y0zO%b7]O~OY7eO!W'ga!X'ga~O!W1VO!X(xi~O!h7iO~O!h7jO~O!h7mO~O!h7mO~P%[O_7oO~O!b7pO~O!h7qO~O!W(ii!X(ii~P#C^O_%gO#Y7yO'm%gO~O!W(fy!h(fy_(fy'm(fy~P!7zO!W(`O!h(ey~O!Y'VO%b7|O~O#e$vqP$vqY$vq_$vql$vq{$vq!W$vq!f$vq!g$vq!i$vq!m$vq#h$vq#i$vq#j$vq#k$vq#l$vq#m$vq#n$vq#o$vq#p$vq#r$vq#t$vq#v$vq#w$vq'm$vq(T$vq(d$vq!h$vq!T$vq'k$vq#Y$vqp$vq!Y$vq%b$vq!b$vq~P#,sO#e$xqP$xqY$xq_$xql$xq{$xq!W$xq!f$xq!g$xq!i$xq!m$xq#h$xq#i$xq#j$xq#k$xq#l$xq#m$xq#n$xq#o$xq#p$xq#r$xq#t$xq#v$xq#w$xq'm$xq(T$xq(d$xq!h$xq!T$xq'k$xq#Y$xqp$xq!Y$xq%b$xq!b$xq~P#,sO!W'Ri!h'Ri~P!7zO#z#]q!W#]q!X#]q~P#C^Oz/yO{/yO}/zOPwaYwahwalwa!fwa!gwa!iwa!mwa#hwa#iwa#jwa#kwa#lwa#mwa#nwa#owa#pwa#rwa#twa#vwa#wwa#zwa(Twa(dwa(kwa(lwa!Wwa!Xwa~Oz)vO})wOP$maY$mah$mal$ma{$ma!f$ma!g$ma!i$ma!m$ma#h$ma#i$ma#j$ma#k$ma#l$ma#m$ma#n$ma#o$ma#p$ma#r$ma#t$ma#v$ma#w$ma#z$ma(T$ma(d$ma(k$ma(l$ma!W$ma!X$ma~Oz)vO})wOP$oaY$oah$oal$oa{$oa!f$oa!g$oa!i$oa!m$oa#h$oa#i$oa#j$oa#k$oa#l$oa#m$oa#n$oa#o$oa#p$oa#r$oa#t$oa#v$oa#w$oa#z$oa(T$oa(d$oa(k$oa(l$oa!W$oa!X$oa~OP$}aY$}al$}a{$}a!f$}a!g$}a!i$}a!m$}a#h$}a#i$}a#j$}a#k$}a#l$}a#m$}a#n$}a#o$}a#p$}a#r$}a#t$}a#v$}a#w$}a#z$}a(T$}a(d$}a!W$}a!X$}a~P%AzO#z$iq!W$iq!X$iq~P#C^O#z$jq!W$jq!X$jq~P#C^O!X8WO~O#z8XO~P!0kO!b#uO!W']i!h']i~O!b#uO(d'gO!W']i!h']i~O!W/VO!h(qq~O!T'_i!W'_i~P#,sO!W/_O!T(rq~O!T8_O~P#,sO!T8_O~Oe(Ry!W(Ry~P!0kO!W'ba!Y'ba~P#,sO_%Uq!Y%Uq'm%Uq!W%Uq~P#,sOY8dO~O!W0bO!X(zq~O#Y8hO!W'da!X'da~O!W4nO!X(wi~P#C^OPZXYZXlZXzZX{ZX}ZX!TZX!WZX!fZX!gZX!iZX!mZX#YZX#edX#hZX#iZX#jZX#kZX#lZX#mZX#nZX#oZX#pZX#rZX#tZX#vZX#wZX#|ZX(TZX(dZX(kZX(lZX~O!b%SX#p%SX~P&3YO!Y0zO%b8lO~O'xTO'{UO(W8qO~O!W1VO!X(xq~O!h8tO~O!h8uO~O!h8vO~O!h8vO~P%[O#Y8yO!W#by!X#by~O!W#by!X#by~P#C^O!Y'VO%b9OO~O#z#xy!W#xy!X#xy~P#C^OP$viY$vil$vi{$vi!f$vi!g$vi!i$vi!m$vi#h$vi#i$vi#j$vi#k$vi#l$vi#m$vi#n$vi#o$vi#p$vi#r$vi#t$vi#v$vi#w$vi#z$vi(T$vi(d$vi!W$vi!X$vi~P%AzOz)vO})wO(l){OP%YiY%Yih%Yil%Yi{%Yi!f%Yi!g%Yi!i%Yi!m%Yi#h%Yi#i%Yi#j%Yi#k%Yi#l%Yi#m%Yi#n%Yi#o%Yi#p%Yi#r%Yi#t%Yi#v%Yi#w%Yi#z%Yi(T%Yi(d%Yi(k%Yi!W%Yi!X%Yi~Oz)vO})wOP%[iY%[ih%[il%[i{%[i!f%[i!g%[i!i%[i!m%[i#h%[i#i%[i#j%[i#k%[i#l%[i#m%[i#n%[i#o%[i#p%[i#r%[i#t%[i#v%[i#w%[i#z%[i(T%[i(d%[i(k%[i(l%[i!W%[i!X%[i~O#z$jy!W$jy!X$jy~P#C^O#z#]y!W#]y!X#]y~P#C^O!b#uO!W']q!h']q~O!W/VO!h(qy~O!T'_q!W'_q~P#,sO!T9VO~P#,sO!W0bO!X(zy~O!W4nO!X(wq~O!Y0zO%b9^O~O!h9aO~O!Y'VO%b9fO~OP$vqY$vql$vq{$vq!f$vq!g$vq!i$vq!m$vq#h$vq#i$vq#j$vq#k$vq#l$vq#m$vq#n$vq#o$vq#p$vq#r$vq#t$vq#v$vq#w$vq#z$vq(T$vq(d$vq!W$vq!X$vq~P%AzOP$xqY$xql$xq{$xq!f$xq!g$xq!i$xq!m$xq#h$xq#i$xq#j$xq#k$xq#l$xq#m$xq#n$xq#o$xq#p$xq#r$xq#t$xq#v$xq#w$xq#z$xq(T$xq(d$xq!W$xq!X$xq~P%AzOe%^!Z!W%^!Z#Y%^!Z#z%^!Z~P!0kO!W'dq!X'dq~P#C^O!W#b!Z!X#b!Z~P#C^O#e%^!ZP%^!ZY%^!Z_%^!Zl%^!Z{%^!Z!W%^!Z!f%^!Z!g%^!Z!i%^!Z!m%^!Z#h%^!Z#i%^!Z#j%^!Z#k%^!Z#l%^!Z#m%^!Z#n%^!Z#o%^!Z#p%^!Z#r%^!Z#t%^!Z#v%^!Z#w%^!Z'm%^!Z(T%^!Z(d%^!Z!h%^!Z!T%^!Z'k%^!Z#Y%^!Zp%^!Z!Y%^!Z%b%^!Z!b%^!Z~P#,sOP%^!ZY%^!Zl%^!Z{%^!Z!f%^!Z!g%^!Z!i%^!Z!m%^!Z#h%^!Z#i%^!Z#j%^!Z#k%^!Z#l%^!Z#m%^!Z#n%^!Z#o%^!Z#p%^!Z#r%^!Z#t%^!Z#v%^!Z#w%^!Z#z%^!Z(T%^!Z(d%^!Z!W%^!Z!X%^!Z~P%AzOp(XX~P1qO'w!lO~P!*SO!TdX!WdX#YdX~P&3YOPZXYZXlZXzZX{ZX}ZX!WZX!WdX!fZX!gZX!iZX!mZX#YZX#YdX#edX#hZX#iZX#jZX#kZX#lZX#mZX#nZX#oZX#pZX#rZX#tZX#vZX#wZX#|ZX(TZX(dZX(kZX(lZX~O!bdX!hZX!hdX(ddX~P&HpOP9qOQ9qOb;bOc!iOjkOl9qOmkOnkOtkOv9qOx9qO}WO!RkO!SkO!YXO!d9tO!iZO!l9qO!m9qO!n9qO!p9uO!r9xO!u!hO$R!kO$VfO'v)UO'xTO'{UO(TVO(c[O(p;`O~O!W:VO!X$la~Oj%SOl$tOm$sOn$sOt%TOv%UOx:]O}${O!Y$|O!d;gO!i$xO#d:cO$R%YO$n:_O$p:aO$s%ZO'v(lO'xTO'{UO(P%RO(T$uO~O#q)]O~P&MfO!XZX!XdX~P&HpO#e9yO~O!b#uO#e9yO~O#Y:ZO~O#p:OO~O#Y:eO!W(iX!X(iX~O#Y:ZO!W(gX!X(gX~O#e:fO~Oe:hO~P!0kO#e:mO~O#e:nO~O!b#uO#e:oO~O!b#uO#e:fO~O#z:pO~P#C^O#e:qO~O#e:rO~O#e:sO~O#e:tO~O#e:uO~O#e:vO~O#z:wO~P!0kO#z:xO~P!0kO$V~!g!}#O#Q#R#U#c#d#o(p$n$p$s%V%a%b%c%j%l%o%p%r%t~'qR$V(p#i!S'o'w#jm#h#klz'p(W'p'v$X$Z$X~",
  goto: "$'X)OPPPP)PPP)SP)eP*t.xPPPP5`PP5vP;r>yP?^P?^PPP?^PAOP?^P?^P?^PASPPAXPArPFjPPPFnPPPPFnIoPPPIuJpPFnPMOPPPP! ^FnPPPFnPFnP!#lFnP!'Q!(S!(]P!)P!)T!)PPPPPP!,`!(SPP!,|!-vP!0jFnFn!0o!3y!8`!8`!<UPPP!<]FnPPPPPPPPPPP!?jP!@{PPFn!BYPFnPFnFnFnFnPFn!ClPP!FtP!IxP!I|!JW!J[!J[P!FqP!J`!J`P!MdP!MhFnFn!Mn#!q?^P?^P?^?^P##|?^?^#%x?^#(X?^#)}?^?^#*l#,j#,j#,n#,v#,j#-OP#,jP?^#-h?^#.q?^?^5`PPP#/}PPP#0h#0hP#0hP#1O#0hPP#1UP#0{P#0{#1i#0{#2T#2Z5])S#2^)SP#2e#2e#2eP)SP)SP)SP)SPP)SP#2k#2nP#2n)SP#2rP#2uP)SP)SP)SP)SP)SP)S)SPP#2{#3R#3^#3d#3j#3p#3v#4U#4[#4b#4l#4r#4|#5]#5c#6T#6g#6m#6s#7R#7h#8y#9X#9_#9e#9k#9q#9{#:R#:X#:c#:u#:{PPPPPPPPPP#;RPPPPPPP#;v#>}P#@^#@e#@mPPPP#D{#Gr#NZ#N^#Na$ Y$ ]$ `$ g$ oPP$ u$ y$!q$#p$#t$$YPP$$^$$d$$hP$$k$$o$$r$%h$&P$&h$&l$&o$&r$&x$&{$'P$'TR!{RoqOXst!Z#c%f&i&k&l&n,b,g1g1jY!uQ'V-S0z4uQ%lvQ%tyQ%{|Q&a!VS&}!e,zQ']!iS'c!r!xS*_$|*dQ+`%uQ+m%}Q,R&ZQ-Q'UQ-['^Q-d'dQ/p*fQ1U,SR:d9u%OdOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$a$e%f%l%y&b&e&i&k&l&n&r&z'X'i'y'{(R(Y(n(r(v)u*x*|,_,b,g-W-`-n-t.b.i/z0P0a0}1_1`1b1d1g1j1l2]2c2w4r4|5^5_5b5u7Z7`7o7yS#p]9r!r)W$[$m'O)j,s,v.q1{3^4p5l8h8y9q9t9u9x9y9z9{9|9}:O:P:Q:R:S:T:U:V:Z:d:e:f:h:o:p:u:v;cQ*o%VQ+e%wQ,T&^Q,[&fQ.X:[Q0W+WQ0[+YQ0g+fQ1^,YQ2k.UQ4`0bQ5T1VQ6R2oQ6X:]Q6z4aR8P6S&|kOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m%f%l%y&b&e&f&i&k&l&n&r&z'O'X'i'y'{(R(Y(n(r(v)j)u*x*|+W,_,b,g,s,v-W-`-n-t.U.b.i.q/z0P0a0}1_1`1b1d1g1j1l1{2]2c2o2w3^4p4r4|5^5_5b5l5u6S7Z7`7o7y8h8y9q9t9u9x9y9z9{9|9}:O:P:Q:R:S:T:U:V:Z:d:e:f:h:o:p:u:v;ct!nQ!r!u!x!y&}'U'V'c'd'e,z-Q-S-d0z4u4w$^$si#u#w$c$d$x${%W%X%])q)w)z)|)}*U*[*j*k+V+Y+q+t.T._/P/^/_/a/|0q0t0|2n3f3p3x4O4W4Y4{6P6g6p7]7|8X8l9O9^9f:X:Y:^:_:`:a:b:c:i:j:k:l:m:n:q:r:s:t:w:x;`;h;i;l;mQ&O|Q&{!eS'R%b,}Q+e%wQ,T&^Q/{*sQ0g+fQ0l+lQ1],XQ1^,YQ4`0bQ4i0nQ5T1VQ5W1XQ5X1[Q6z4aQ6}4fQ7h5ZQ8g7OR8r7ernOXst!V!Z#c%f&`&i&k&l&n,b,g1g1jR,V&b&v^OPXYstuvwz!Z!`!g!j!o#R#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m%f%l%y&b&e&f&i&k&l&n&r&z'X'i'{(R(Y(n(r(v)j)u*x*|+W,_,b,g,s,v-W-`-n-t.U.b.i.q/z0P0a0}1_1`1b1d1g1j1l1{2]2c2o2w3^4p4r4|5^5_5b5l5u6S7Z7`7o7y8h8y9q9t9u9x9y9z9{9|9}:O:P:Q:R:S:T:U:V:Z:d:e:f:h:o:p:u:v;b;c[#[WZ#V#Y'O'y!S%cm#g#h#k%^%a(S(^(_(`*z*{*},^,t-r-x-y-z-|1o2g2h5k5|Q%oxQ%syS%x|%}Q&U!TQ'Y!hQ'[!iQ(g#rS*R$x*VS+_%t%uQ+c%wQ+|&XQ,Q&ZS-Z']'^Q.W(hQ/Z*SQ0`+`Q0f+fQ0h+gQ0k+kQ1P+}S1T,R,SQ2X-[Q3g/VQ4_0bQ4c0eQ4h0mQ5S1UQ6d3hQ6y4aQ6|4eQ8c6xR9X8dv$zi#w%W%X%])z)|*U*j*k._/^/|3f4O8X;`;h;i!S%qy!i!t%s%t%u&|'[']'^'b'l*^+_+`,w-Z-[-c/h0`2Q2X2`3zQ+X%oQ+r&RQ+u&SQ,P&ZQ.V(gQ1O+|U1S,Q,R,SQ2p.WQ4}1PS5R1T1UQ7d5S#O;d#u$c$d$x${)q)w)}*[+V+Y+q+t.T/P/_/a0q0t0|2n3p3x4W4Y4{6P6g6p7]7|8l9O9^9f:^:`:b:i:k:m:q:s:w;l;mg;e:X:Y:_:a:c:j:l:n:r:t:xW%Pi%R*l;`S&R!Q&`Q&S!RQ&T!SR+p&P$_%Oi#u#w$c$d$x${%W%X%])q)w)z)|)}*U*[*j*k+V+Y+q+t.T._/P/^/_/a/|0q0t0|2n3f3p3x4O4W4Y4{6P6g6p7]7|8X8l9O9^9f:X:Y:^:_:`:a:b:c:i:j:k:l:m:n:q:r:s:t:w:x;`;h;i;l;mT)r$u)sV*p%V:[:]U'R!e%b,}S(u#y#zQ+j%zS.P(c(dQ0u+vQ4P/yR7S4n&|kOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m%f%l%y&b&e&f&i&k&l&n&r&z'O'X'i'y'{(R(Y(n(r(v)j)u*x*|+W,_,b,g,s,v-W-`-n-t.U.b.i.q/z0P0a0}1_1`1b1d1g1j1l1{2]2c2o2w3^4p4r4|5^5_5b5l5u6S7Z7`7o7y8h8y9q9t9u9x9y9z9{9|9}:O:P:Q:R:S:T:U:V:Z:d:e:f:h:o:p:u:v;c$i$`c#X#d%j%k%m'x(O(j(q(y(z({(|(})O)P)Q)R)S)T)V)Y)^)h+T+i,x-g-l-q-s.^.d.h.j.k.l.{/}1v1y2Z2b2v2{2|2}3O3P3Q3R3S3T3U3V3W3X3[3]3b4T4]5n5t5y6V6W6]6^7U7s7w8Q8U8V8{9Z9b9s;VT#SV#T&}kOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m%f%l%y&b&e&f&i&k&l&n&r&z'O'X'i'y'{(R(Y(n(r(v)j)u*x*|+W,_,b,g,s,v-W-`-n-t.U.b.i.q/z0P0a0}1_1`1b1d1g1j1l1{2]2c2o2w3^4p4r4|5^5_5b5l5u6S7Z7`7o7y8h8y9q9t9u9x9y9z9{9|9}:O:P:Q:R:S:T:U:V:Z:d:e:f:h:o:p:u:v;cQ'P!eR1|,zv!nQ!e!r!u!x!y&}'U'V'c'd'e,z-Q-S-d0z4u4wS*^$|*dS/h*_*fQ/q*gQ0w+xQ3z/pR3}/snqOXst!Z#c%f&i&k&l&n,b,g1g1jQ&p!^Q'm!wS(i#t9yQ+]%rQ+z&UQ+{&WQ-X'ZQ-f'fS.](n:fS0O*x:oQ0^+^Q0y+yQ1n,iQ1p,jQ1x,uQ2V-YQ2Y-^S4U0P:uQ4Z0_S4^0a:vQ5m1zQ5q2WQ5v2_Q6w4[Q7t5oQ7u5rQ7x5wR8x7q$d$_c#X#d%k%m'x(O(j(q(y(z({(|(})O)P)Q)R)S)T)V)Y)^)h+T+i,x-g-l-q-s.^.d.h.k.l.{/}1v1y2Z2b2v2{2|2}3O3P3Q3R3S3T3U3V3W3X3[3]3b4T4]5n5t5y6V6W6]6^7U7s7w8Q8U8V8{9Z9b9s;VS(f#o'`U*i$}(m3ZS+S%j.jQ2l0WQ6O2kQ8O6RR9P8P$d$^c#X#d%k%m'x(O(j(q(y(z({(|(})O)P)Q)R)S)T)V)Y)^)h+T+i,x-g-l-q-s.^.d.h.k.l.{/}1v1y2Z2b2v2{2|2}3O3P3Q3R3S3T3U3V3W3X3[3]3b4T4]5n5t5y6V6W6]6^7U7s7w8Q8U8V8{9Z9b9s;VS(e#o'`S(w#z$_S+R%j.jS.Q(d(fQ.m)XQ0T+SR2i.R&|kOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m%f%l%y&b&e&f&i&k&l&n&r&z'O'X'i'y'{(R(Y(n(r(v)j)u*x*|+W,_,b,g,s,v-W-`-n-t.U.b.i.q/z0P0a0}1_1`1b1d1g1j1l1{2]2c2o2w3^4p4r4|5^5_5b5l5u6S7Z7`7o7y8h8y9q9t9u9x9y9z9{9|9}:O:P:Q:R:S:T:U:V:Z:d:e:f:h:o:p:u:v;cS#p]9rQ&k!XQ&l!YQ&n![Q&o!]R1f,eQ'W!hQ+U%oQ-V'YS.S(g+XQ2T-UW2m.V.W0V0XQ5p2UU5}2j2l2pS7{6O6QS8}7}8OS9d8|9PQ9l9eR9o9mU!vQ'V-ST4s0z4u!Q_OXZ`st!V!Z#c#g%^%f&`&b&i&k&l&n(`,b,g-y1g1j]!pQ!r'V-S0z4uT#p]9r%Y{OPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$a$e%f%l%y&b&e&f&i&k&l&n&r&z'X'i'y'{(R(Y(n(r(v)u*x*|+W,_,b,g-W-`-n-t.U.b.i/z0P0a0}1_1`1b1d1g1j1l2]2c2o2w4r4|5^5_5b5u6S7Z7`7o7yS(u#y#zS.P(c(d!s:|$[$m'O)j,s,v.q1{3^4p5l8h8y9q9t9u9x9y9z9{9|9}:O:P:Q:R:S:T:U:V:Z:d:e:f:h:o:p:u:v;cY!tQ'V-S0z4uQ'b!rS'l!u!xS'n!y4wS-c'c'dQ-e'eR2`-dQ'k!tS([#f1aS-b'b'nQ/Y*RQ/f*^Q2a-eQ3l/ZS3u/g/qQ6c3gS6n3{3}Q8Z6dR8b6qQ#vbQ'j!tS(Z#f1aS(]#l*wQ*y%_Q+Z%pQ+a%vU-a'b'k'nQ-u([Q/X*RQ/e*^Q/k*aQ0]+[Q1Q,OS2^-b-eQ2f-}S3k/Y/ZS3t/f/qQ3w/jQ3y/lQ5P1RQ5x2aQ6b3gQ6f3lS6j3u3}Q6o3|Q7b5QS8Y6c6dQ8^6kQ8`6nQ8o7cQ9T8ZQ9U8_Q9W8bQ9`8pQ9h9VQ;P:zQ;[;TR;];UV!vQ'V-S%YaOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$a$e%f%l%y&b&e&f&i&k&l&n&r&z'X'i'y'{(R(Y(n(r(v)u*x*|+W,_,b,g-W-`-n-t.U.b.i/z0P0a0}1_1`1b1d1g1j1l2]2c2o2w4r4|5^5_5b5u6S7Z7`7o7yS#vz!j!r:y$[$m'O)j,s,v.q1{3^4p5l8h8y9q9t9u9x9y9z9{9|9}:O:P:Q:R:S:T:U:V:Z:d:e:f:h:o:p:u:v;cR;P;b%YbOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$a$e%f%l%y&b&e&f&i&k&l&n&r&z'X'i'y'{(R(Y(n(r(v)u*x*|+W,_,b,g-W-`-n-t.U.b.i/z0P0a0}1_1`1b1d1g1j1l2]2c2o2w4r4|5^5_5b5u6S7Z7`7o7yQ%_j!S%py!i!t%s%t%u&|'[']'^'b'l*^+_+`,w-Z-[-c/h0`2Q2X2`3zS%vz!jQ+[%qQ,O&ZW1R,P,Q,R,SU5Q1S1T1US7c5R5SQ8p7d!r:z$[$m'O)j,s,v.q1{3^4p5l8h8y9q9t9u9x9y9z9{9|9}:O:P:Q:R:S:T:U:V:Z:d:e:f:h:o:p:u:v;cQ;T;aR;U;b$|eOPXYstuvw!Z!`!g!o#R#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$a$e%f%l%y&b&e&i&k&l&n&r&z'X'i'{(R(Y(n(r(v)u*x*|+W,_,b,g-W-`-n-t.U.b.i/z0P0a0}1_1`1b1d1g1j1l2]2c2o2w4r4|5^5_5b5u6S7Z7`7o7yY#aWZ#V#Y'y!S%cm#g#h#k%^%a(S(^(_(`*z*{*},^,t-r-x-y-z-|1o2g2h5k5|Q,]&f!p:{$[$m)j,s,v.q1{3^4p5l8h8y9q9t9u9x9y9z9{9|9}:O:P:Q:R:S:T:U:V:Z:d:e:f:h:o:p:u:v;cR;O'OS'S!e%bR2O,}%OdOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$a$e%f%l%y&b&e&i&k&l&n&r&z'X'i'y'{(R(Y(n(r(v)u*x*|,_,b,g-W-`-n-t.b.i/z0P0a0}1_1`1b1d1g1j1l2]2c2w4r4|5^5_5b5u7Z7`7o7y!r)W$[$m'O)j,s,v.q1{3^4p5l8h8y9q9t9u9x9y9z9{9|9}:O:P:Q:R:S:T:U:V:Z:d:e:f:h:o:p:u:v;cQ,[&fQ0W+WQ2k.UQ6R2oR8P6S!f$Uc#X%j'x(O(j(q)Q)R)S)T)Y)^+i-g-l-q-s.^.d.{/}2Z2b2v3X4T4]5t5y6V7w8{9s!T:Q)V)h,x.j1v1y2{3T3U3V3W3[3b5n6W6]6^7U7s8Q8U8V9Z9b;V!b$Wc#X%j'x(O(j(q)S)T)Y)^+i-g-l-q-s.^.d.{/}2Z2b2v3X4T4]5t5y6V7w8{9s!P:S)V)h,x.j1v1y2{3V3W3[3b5n6W6]6^7U7s8Q8U8V9Z9b;V!^$[c#X%j'x(O(j(q)Y)^+i-g-l-q-s.^.d.{/}2Z2b2v3X4T4]5t5y6V7w8{9sQ3f/Tz;c)V)h,x.j1v1y2{3[3b5n6W6]6^7U7s8Q8U8V9Z9b;VQ;h;jR;i;k&|kOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m%f%l%y&b&e&f&i&k&l&n&r&z'O'X'i'y'{(R(Y(n(r(v)j)u*x*|+W,_,b,g,s,v-W-`-n-t.U.b.i.q/z0P0a0}1_1`1b1d1g1j1l1{2]2c2o2w3^4p4r4|5^5_5b5l5u6S7Z7`7o7y8h8y9q9t9u9x9y9z9{9|9}:O:P:Q:R:S:T:U:V:Z:d:e:f:h:o:p:u:v;cS$nh$oR3_.p'TgOPWXYZhstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m$o%f%l%y&b&e&f&i&k&l&n&r&z'O'X'i'y'{(R(Y(n(r(v)j)u*x*|+W,_,b,g,s,v-W-`-n-t.U.b.i.p.q/z0P0a0}1_1`1b1d1g1j1l1{2]2c2o2w3^4p4r4|5^5_5b5l5u6S7Z7`7o7y8h8y9q9t9u9x9y9z9{9|9}:O:P:Q:R:S:T:U:V:Z:d:e:f:h:o:p:u:v;cT$jf$pQ$hfS)a$k)eR)m$pT$if$pT)c$k)e'ThOPWXYZhstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$[$a$e$m$o%f%l%y&b&e&f&i&k&l&n&r&z'O'X'i'y'{(R(Y(n(r(v)j)u*x*|+W,_,b,g,s,v-W-`-n-t.U.b.i.p.q/z0P0a0}1_1`1b1d1g1j1l1{2]2c2o2w3^4p4r4|5^5_5b5l5u6S7Z7`7o7y8h8y9q9t9u9x9y9z9{9|9}:O:P:Q:R:S:T:U:V:Z:d:e:f:h:o:p:u:v;cT$nh$oQ$qhR)l$o%YjOPWXYZstuvw!Z!`!g!o#R#V#Y#c#n#t#x#{$O$P$Q$R$S$T$U$V$W$X$Y$a$e%f%l%y&b&e&f&i&k&l&n&r&z'X'i'y'{(R(Y(n(r(v)u*x*|+W,_,b,g-W-`-n-t.U.b.i/z0P0a0}1_1`1b1d1g1j1l2]2c2o2w4r4|5^5_5b5u6S7Z7`7o7y!s;a$[$m'O)j,s,v.q1{3^4p5l8h8y9q9t9u9x9y9z9{9|9}:O:P:Q:R:S:T:U:V:Z:d:e:f:h:o:p:u:v;c#clOPXZst!Z!`!o#R#c#n#{$m%f&b&e&f&i&k&l&n&r&z'X(v)j*|+W,_,b,g-W.U.q/z0}1_1`1b1d1g1j1l2o3^4r4|5^5_5b6S7Z7`7ov$}i#w%W%X%])z)|*U*j*k._/^/|3f4O8X;`;h;i#O(m#u$c$d$x${)q)w)}*[+V+Y+q+t.T/P/_/a0q0t0|2n3p3x4W4Y4{6P6g6p7]7|8l9O9^9f:^:`:b:i:k:m:q:s:w;l;mQ*t%ZQ.|)vg3Z:X:Y:_:a:c:j:l:n:r:t:xv$yi#w%W%X%])z)|*U*j*k._/^/|3f4O8X;`;h;iQ*W$zS*a$|*dQ*u%[Q/l*b#O;R#u$c$d$x${)q)w)}*[+V+Y+q+t.T/P/_/a0q0t0|2n3p3x4W4Y4{6P6g6p7]7|8l9O9^9f:^:`:b:i:k:m:q:s:w;l;mf;S:X:Y:_:a:c:j:l:n:r:t:xQ;W;dQ;X;eQ;Y;fR;Z;gv$}i#w%W%X%])z)|*U*j*k._/^/|3f4O8X;`;h;i#O(m#u$c$d$x${)q)w)}*[+V+Y+q+t.T/P/_/a0q0t0|2n3p3x4W4Y4{6P6g6p7]7|8l9O9^9f:^:`:b:i:k:m:q:s:w;l;mg3Z:X:Y:_:a:c:j:l:n:r:t:xnoOXst!Z#c%f&i&k&l&n,b,g1g1jQ*Z${Q,p&uQ,q&wR3o/_$^%Oi#u#w$c$d$x${%W%X%])q)w)z)|)}*U*[*j*k+V+Y+q+t.T._/P/^/_/a/|0q0t0|2n3f3p3x4O4W4Y4{6P6g6p7]7|8X8l9O9^9f:X:Y:^:_:`:a:b:c:i:j:k:l:m:n:q:r:s:t:w:x;`;h;i;l;mQ+s&SQ0s+uQ4l0rR7R4mT*c$|*dS*c$|*dT4t0z4uS/j*`4rT3|/r7ZQ+Z%pQ/k*aQ0]+[Q1Q,OQ5P1RQ7b5QQ8o7cR9`8pn)z$v(o*v/]/t/u2t3m4S6a6r9S;Q;^;_!Y:i(k)[*Q*Y.[.x.}/T/b0U0p0r2s3n3r4k4m6T6U6h6l6t6v8]8a9g;j;k]:j3Y6[8R9Q9R9pp)|$v(o*v/R/]/t/u2t3m4S6a6r9S;Q;^;_![:k(k)[*Q*Y.[.x.}/T/b0U0p0r2q2s3n3r4k4m6T6U6h6l6t6v8]8a9g;j;k_:l3Y6[8R8S9Q9R9prnOXst!V!Z#c%f&`&i&k&l&n,b,g1g1jQ&]!UR,_&frnOXst!V!Z#c%f&`&i&k&l&n,b,g1g1jR&]!UQ+w&TR0o+psnOXst!V!Z#c%f&`&i&k&l&n,b,g1g1jQ0{+|S4z1O1PU7[4x4y4}S8k7^7_S9[8j8mQ9i9]R9n9jQ&d!VR,W&`R5W1XS%x|%}R0h+gQ&i!WR,b&jR,h&oT1h,g1jR,l&pQ,k&pR1q,lQ'p!zR-h'pSsOtQ#cXT%is#cQ!}TR'r!}Q#QUR't#QQ)s$uR.y)sQ#TVR'v#TQ#WWU'|#W'}-oQ'}#XR-o(OQ,{'PR1},{Q.`(oR2u.`Q.c(qS2x.c2yR2y.dQ-S'VR2R-SY!rQ'V-S0z4uR'a!rS#^W%aU(T#^(U-pQ(U#_R-p(PQ-O'SR2P-Ot`OXst!V!Z#c%f&`&b&i&k&l&n,b,g1g1jS#gZ%^U#q`#g-yR-y(`Q(a#iQ-v(]W.O(a-v2d5zQ2d-wR5z2eQ)e$kR.r)eQ$ohR)k$oQ$bcU)Z$b-k:WQ-k9sR:W)hQ/W*RW3i/W3j6e8[U3j/X/Y/ZS6e3k3lR8[6f#o)x$v(k(o)[*Q*Y*q*r*v.Y.Z.[.x.}/R/S/T/]/b/t/u0U0p0r2q2r2s2t3Y3m3n3r4S4k4m6T6U6Y6Z6[6a6h6l6r6t6v8R8S8T8]8a9Q9R9S9g9p;Q;^;_;j;kQ/`*YU3q/`3s6iQ3s/bR6i3rQ*d$|R/n*dQ*m%QR/w*mQ4X0UR6u4XQ+O%dR0S+OQ4o0uS7T4o8iR8i7UQ+y&UR0x+yQ4u0zR7X4uQ1W,TS5U1W7fR7f5WQ0c+cW4b0c4d6{8eQ4d0fQ6{4cR8e6|Q+h%xR0i+hQ1j,gR5f1jYrOXst#cQ&m!ZQ+Q%fQ,a&iQ,c&kQ,d&lQ,f&nQ1e,bS1h,g1jR5e1gQ%hpQ&q!_Q&t!aQ&v!bQ&x!cQ'h!tQ+P%eQ+]%rQ+o&OQ,V&dQ,n&sW-_'b'j'k'nQ-f'fQ/m*cQ0^+^S1Z,W,ZQ1r,mQ1s,pQ1t,qQ2Y-^W2[-a-b-e-gQ4Z0_Q4g0lQ4j0pQ5O1QQ5Y1]Q5d1fU5s2Z2^2aQ5v2_Q6w4[Q7P4iQ7Q4kQ7W4tQ7a5PQ7g5XS7v5t5xQ7x5wQ8f6}Q8n7bQ8s7hQ8z7wQ9Y8gQ9_8oQ9c8{R9k9`Q%ryQ'Z!iQ'f!tU+^%s%t%uQ,u&|U-Y'[']'^S-^'b'lQ/d*^S0_+_+`Q1z,wS2W-Z-[Q2_-cQ3v/hQ4[0`Q5o2QQ5r2XQ5w2`R6m3zS$wi;`R*n%RU%Qi%R;`R/v*lQ$viS(k#u+YQ(o#wS)[$c$dQ*Q$xQ*Y${Q*q%WQ*r%XQ*v%]Q.Y:^Q.Z:`Q.[:bQ.x)qS.})w/PQ/R)zQ/S)|Q/T)}Q/]*UQ/b*[Q/t*jQ/u*kh0U+V.T0|2n4{6P7]7|8l9O9^9fQ0p+qQ0r+tQ2q:iQ2r:kQ2s:mQ2t._S3Y:X:YQ3m/^Q3n/_Q3r/aQ4S/|Q4k0qQ4m0tQ6T:qQ6U:sQ6Y:_Q6Z:aQ6[:cQ6a3fQ6h3pQ6l3xQ6r4OQ6t4WQ6v4YQ8R:nQ8S:jQ8T:lQ8]6gQ8a6pQ9Q:rQ9R:tQ9S8XQ9g:wQ9p:xQ;Q;`Q;^;hQ;_;iQ;j;lR;k;mnpOXst!Z#c%f&i&k&l&n,b,g1g1jQ!fPS#eZ#nQ&s!`U'_!o4r7ZQ'u#RQ(x#{Q)i$mS,Z&b&eQ,`&fQ,m&rQ,r&zQ-U'XQ.f(vQ.v)jQ0Q*|Q0X+WQ1c,_Q2U-WQ2l.UQ3a.qQ4Q/zQ4y0}Q5[1_Q5]1`Q5a1bQ5c1dQ5h1lQ6O2oQ6_3^Q7_4|Q7k5^Q7l5_Q7n5bQ8O6SQ8m7`R8w7o#WcOPXZst!Z!`!o#c#n#{%f&b&e&f&i&k&l&n&r&z'X(v*|+W,_,b,g-W.U/z0}1_1`1b1d1g1j1l2o4r4|5^5_5b6S7Z7`7oQ#XWQ#dYQ%juQ%kvS%mw!gS'x#V'{Q(O#YQ(j#tQ(q#xQ(y$OQ(z$PQ({$QQ(|$RQ(}$SQ)O$TQ)P$UQ)Q$VQ)R$WQ)S$XQ)T$YQ)V$[Q)Y$aQ)^$eW)h$m)j.q3^Q+T%lQ+i%yS,x'O1{Q-g'iS-l'y-nQ-q(RQ-s(YQ.^(nQ.d(rQ.h9qQ.j9tQ.k9uQ.l9xQ.{)uQ/}*xQ1v,sQ1y,vQ2Z-`Q2b-tQ2v.bQ2{9yQ2|9zQ2}9{Q3O9|Q3P9}Q3Q:OQ3R:PQ3S:QQ3T:RQ3U:SQ3V:TQ3W:UQ3X.iQ3[:ZQ3]:dQ3b:VQ4T0PQ4]0aQ5n:eQ5t2]Q5y2cQ6V2wQ6W:fQ6]:hQ6^:oQ7U4pQ7s5lQ7w5uQ8Q:pQ8U:uQ8V:vQ8{7yQ9Z8hQ9b8yQ9s#RR;V;cR#ZWR'Q!eY!tQ'V-S0z4uS&|!e,zQ'b!rS'l!u!xS'n!y4wS,w&}'US-c'c'dQ-e'eQ2Q-QR2`-dR(p#wR(s#xQ!fQT-R'V-S]!qQ!r'V-S0z4uQ#o]R'`9rT#jZ%^S#iZ%^S%dm,^U(]#g#h#kS-w(^(_Q-{(`Q0R*}Q2e-xU2f-y-z-|S5{2g2hR7z5|`#]W#V#Y%a'y(S*z-rr#fZm#g#h#k%^(^(_(`*}-x-y-z-|2g2h5|Q1a,^Q1w,tQ5j1oQ7r5kT:}'O*{T#`W%aS#_W%aS'z#V(SS(P#Y*zS,y'O*{T-m'y-rT'T!e%bQ$kfR)o$pT)d$k)eR3`.pT*T$x*VR*]${Q0V+VQ2j.TQ4x0|Q6Q2nQ7^4{Q7}6PQ8j7]Q8|7|Q9]8lQ9e9OQ9j9^R9m9fnqOXst!Z#c%f&i&k&l&n,b,g1g1jQ&c!VR,V&`tmOXst!U!V!Z#c%f&`&i&k&l&n,b,g1g1jR,^&fT%em,^R0v+vR,U&^Q%||R+n%}R+d%wT&g!W&jT&h!W&jT1i,g1j",
  nodeNames: "\u26A0 ArithOp ArithOp LineComment BlockComment Script Hashbang ExportDeclaration export Star as VariableName String Escape from ; default FunctionDeclaration async function VariableDefinition > TypeParamList TypeDefinition extends ThisType this LiteralType ArithOp Number BooleanLiteral TemplateType InterpolationEnd Interpolation InterpolationStart NullType null VoidType void TypeofType typeof MemberExpression . ?. PropertyName [ TemplateString Escape Interpolation super RegExp ] ArrayExpression Spread , } { ObjectExpression Property async get set PropertyDefinition Block : NewExpression new TypeArgList CompareOp < ) ( ArgList UnaryExpression delete LogicOp BitOp YieldExpression yield AwaitExpression await ParenthesizedExpression ClassExpression class ClassBody MethodDeclaration Decorator @ MemberExpression PrivatePropertyName CallExpression declare Privacy static abstract override PrivatePropertyDefinition PropertyDeclaration readonly accessor Optional TypeAnnotation Equals StaticBlock FunctionExpression ArrowFunction ParamList ParamList ArrayPattern ObjectPattern PatternProperty Privacy readonly Arrow MemberExpression BinaryExpression ArithOp ArithOp ArithOp ArithOp BitOp CompareOp instanceof satisfies in const CompareOp BitOp BitOp BitOp LogicOp LogicOp ConditionalExpression LogicOp LogicOp AssignmentExpression UpdateOp PostfixExpression CallExpression TaggedTemplateExpression DynamicImport import ImportMeta JSXElement JSXSelfCloseEndTag JSXStartTag JSXSelfClosingTag JSXIdentifier JSXBuiltin JSXIdentifier JSXNamespacedName JSXMemberExpression JSXSpreadAttribute JSXAttribute JSXAttributeValue JSXEscape JSXEndTag JSXOpenTag JSXFragmentTag JSXText JSXEscape JSXStartCloseTag JSXCloseTag PrefixCast ArrowFunction TypeParamList SequenceExpression KeyofType keyof UniqueType unique ImportType InferredType infer TypeName ParenthesizedType FunctionSignature ParamList NewSignature IndexedType TupleType Label ArrayType ReadonlyType ObjectType MethodType PropertyType IndexSignature PropertyDefinition CallSignature TypePredicate is NewSignature new UnionType LogicOp IntersectionType LogicOp ConditionalType ParameterizedType ClassDeclaration abstract implements type VariableDeclaration let var using TypeAliasDeclaration InterfaceDeclaration interface EnumDeclaration enum EnumBody NamespaceDeclaration namespace module AmbientDeclaration declare GlobalDeclaration global ClassDeclaration ClassBody AmbientFunctionDeclaration ExportGroup VariableName VariableName ImportDeclaration ImportGroup ForStatement for ForSpec ForInSpec ForOfSpec of WhileStatement while WithStatement with DoStatement do IfStatement if else SwitchStatement switch SwitchBody CaseLabel case DefaultLabel TryStatement try CatchClause catch FinallyClause finally ReturnStatement return ThrowStatement throw BreakStatement break ContinueStatement continue DebuggerStatement debugger LabeledStatement ExpressionStatement SingleExpression SingleClassItem",
  maxTerm: 367,
  context: d$10,
  nodeProps: [
    ["group", -26, 7, 15, 17, 63, 200, 204, 208, 209, 211, 214, 217, 227, 229, 235, 237, 239, 241, 244, 250, 256, 258, 260, 262, 264, 266, 267, "Statement", -32, 11, 12, 26, 29, 30, 36, 46, 49, 50, 52, 57, 65, 73, 77, 79, 81, 82, 104, 105, 114, 115, 132, 135, 137, 138, 139, 140, 142, 143, 163, 164, 166, "Expression", -23, 25, 27, 31, 35, 37, 39, 167, 169, 171, 172, 174, 175, 176, 178, 179, 180, 182, 183, 184, 194, 196, 198, 199, "Type", -3, 85, 97, 103, "ClassItem"],
    ["openedBy", 32, "InterpolationStart", 51, "[", 55, "{", 70, "(", 144, "JSXStartTag", 156, "JSXStartTag JSXStartCloseTag"],
    ["closedBy", 34, "InterpolationEnd", 45, "]", 56, "}", 71, ")", 145, "JSXSelfCloseEndTag JSXEndTag", 161, "JSXEndTag"]
  ],
  propSources: [T$o],
  skippedNodes: [0, 3, 4, 270],
  repeatNodeCount: 33,
  tokenData: "$Fl(CSR!bOX%ZXY+gYZ-yZ[+g[]%Z]^.c^p%Zpq+gqr/mrs3cst:_tuEruvJSvwLkwx! Yxy!'iyz!(sz{!)}{|!,q|}!.O}!O!,q!O!P!/Y!P!Q!9j!Q!R#8g!R![#:v![!]#Gv!]!^#IS!^!_#J^!_!`#Nu!`!a$#a!a!b$(n!b!c$,m!c!}Er!}#O$-w#O#P$/R#P#Q$4j#Q#R$5t#R#SEr#S#T$7R#T#o$8]#o#p$<m#p#q$=c#q#r$>s#r#s$@P#s$f%Z$f$g+g$g#BYEr#BY#BZ$AZ#BZ$ISEr$IS$I_$AZ$I_$I|Er$I|$I}$Df$I}$JO$Df$JO$JTEr$JT$JU$AZ$JU$KVEr$KV$KW$AZ$KW&FUEr&FU&FV$AZ&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$AZ?HUOEr(n%d_$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&j&hT$e&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c&j&zP;=`<%l&c'|'U]$e&j'|!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!b(SU'|!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!b(iP;=`<%l'}'|(oP;=`<%l&}'[(y]$e&j'ypOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(rp)wU'ypOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)rp*^P;=`<%l)r'[*dP;=`<%l(r#S*nX'yp'|!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g#S+^P;=`<%l*g(n+dP;=`<%l%Z(CS+rq$e&j'yp'|!b'o(;dOX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p$f%Z$f$g+g$g#BY%Z#BY#BZ+g#BZ$IS%Z$IS$I_+g$I_$JT%Z$JT$JU+g$JU$KV%Z$KV$KW+g$KW&FU%Z&FU&FV+g&FV;'S%Z;'S;=`+a<%l?HT%Z?HT?HU+g?HUO%Z(CS.ST'z#S$e&j'p(;dO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c(CS.n_$e&j'yp'|!b'p(;dOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#`/x`$e&j!m$Ip'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S1V`#r$Id$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`2X!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S2d_#r$Id$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$2b3l_'x$(n$e&j'|!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k*r4r_$e&j'|!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k)`5vX$e&jOr5qrs6cs!^5q!^!_6y!_#o5q#o#p6y#p;'S5q;'S;=`7h<%lO5q)`6jT$`#t$e&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c#t6|TOr6yrs7]s;'S6y;'S;=`7b<%lO6y#t7bO$`#t#t7eP;=`<%l6y)`7kP;=`<%l5q*r7w]$`#t$e&j'|!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}%W8uZ'|!bOY8pYZ6yZr8prs9hsw8pwx6yx#O8p#O#P6y#P;'S8p;'S;=`:R<%lO8p%W9oU$`#t'|!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}%W:UP;=`<%l8p*r:[P;=`<%l4k#%|:hh$e&j'yp'|!bOY%ZYZ&cZq%Zqr<Srs&}st%ZtuCruw%Zwx(rx!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr(r<__US$e&j'yp'|!bOY<SYZ&cZr<Srs=^sw<Swx@nx!^<S!^!_Bm!_#O<S#O#P>`#P#o<S#o#pBm#p;'S<S;'S;=`Cl<%lO<S(Q=g]US$e&j'|!bOY=^YZ&cZw=^wx>`x!^=^!^!_?q!_#O=^#O#P>`#P#o=^#o#p?q#p;'S=^;'S;=`@h<%lO=^&n>gXUS$e&jOY>`YZ&cZ!^>`!^!_?S!_#o>`#o#p?S#p;'S>`;'S;=`?k<%lO>`S?XSUSOY?SZ;'S?S;'S;=`?e<%lO?SS?hP;=`<%l?S&n?nP;=`<%l>`!f?xWUS'|!bOY?qZw?qwx?Sx#O?q#O#P?S#P;'S?q;'S;=`@b<%lO?q!f@eP;=`<%l?q(Q@kP;=`<%l=^'`@w]US$e&j'ypOY@nYZ&cZr@nrs>`s!^@n!^!_Ap!_#O@n#O#P>`#P#o@n#o#pAp#p;'S@n;'S;=`Bg<%lO@ntAwWUS'ypOYApZrAprs?Ss#OAp#O#P?S#P;'SAp;'S;=`Ba<%lOAptBdP;=`<%lAp'`BjP;=`<%l@n#WBvYUS'yp'|!bOYBmZrBmrs?qswBmwxApx#OBm#O#P?S#P;'SBm;'S;=`Cf<%lOBm#WCiP;=`<%lBm(rCoP;=`<%l<S#%|C}i$e&j(c!L^'yp'|!bOY%ZYZ&cZr%Zrs&}st%ZtuCruw%Zwx(rx!Q%Z!Q![Cr![!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr#%|EoP;=`<%lCr(CSFRk$e&j'yp'|!b(W!LY'v&;d$X#tOY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr+dHRk$e&j'yp'|!b$X#tOY%ZYZ&cZr%Zrs&}st%ZtuGvuw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Gv![!^%Z!^!_*g!_!c%Z!c!}Gv!}#O%Z#O#P&c#P#R%Z#R#SGv#S#T%Z#T#oGv#o#p*g#p$g%Z$g;'SGv;'S;=`Iv<%lOGv+dIyP;=`<%lGv(CSJPP;=`<%lEr%#SJ_`$e&j'yp'|!b#j$IdOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#SKl_$e&j#|$Id'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%DfLva(l%<v$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sv%ZvwM{wx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#SNW`$e&j#v$Id'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$2b! c_'{$)`$e&j'ypOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b*Q!!i_$e&j'ypOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b)`!#mX$e&jOw!#hwx6cx!^!#h!^!_!$Y!_#o!#h#o#p!$Y#p;'S!#h;'S;=`!$r<%lO!#h#t!$]TOw!$Ywx7]x;'S!$Y;'S;=`!$l<%lO!$Y#t!$oP;=`<%l!$Y)`!$uP;=`<%l!#h*Q!%R]$`#t$e&j'ypOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r$f!&PZ'ypOY!%zYZ!$YZr!%zrs!$Ysw!%zwx!&rx#O!%z#O#P!$Y#P;'S!%z;'S;=`!']<%lO!%z$f!&yU$`#t'ypOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)r$f!'`P;=`<%l!%z*Q!'fP;=`<%l!!b(*Q!'t_!i(!b$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z!'l!)O_!hM|$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'+h!*[b$e&j'yp'|!b'w#)d#k$IdOY%ZYZ&cZr%Zrs&}sw%Zwx(rxz%Zz{!+d{!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S!+o`$e&j'yp'|!b#h$IdOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&-O!,|`$e&j'yp'|!bl&%`OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&C[!.Z_!W&;l$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(CS!/ec$e&j'yp'|!bz'<nOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!0p!P!Q%Z!Q![!3Y![!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z!'d!0ya$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!2O!P!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z!'d!2Z_!VMt$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l!3eg$e&j'yp'|!bm$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!3Y![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S!3Y#S#X%Z#X#Y!4|#Y#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l!5Vg$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx{%Z{|!6n|}%Z}!O!6n!O!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l!6wc$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l!8_c$e&j'yp'|!bm$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(CS!9uf$e&j'yp'|!b#i$IdOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Kpxz!;Zz{#,f{!P!;Z!P!Q#-{!Q!^!;Z!^!_#'Z!_!`#5k!`!a#7Q!a!}!;Z!}#O#*}#O#P!Dj#P#o!;Z#o#p#'Z#p;'S!;Z;'S;=`#,`<%lO!;Z(r!;fb$e&j'yp'|!b!SSOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Kpx!P!;Z!P!Q#%Z!Q!^!;Z!^!_#'Z!_!}!;Z!}#O#*}#O#P!Dj#P#o!;Z#o#p#'Z#p;'S!;Z;'S;=`#,`<%lO!;Z(Q!<w`$e&j'|!b!SSOY!<nYZ&cZw!<nwx!=yx!P!<n!P!Q!Eb!Q!^!<n!^!_!GY!_!}!<n!}#O!Ja#O#P!Dj#P#o!<n#o#p!GY#p;'S!<n;'S;=`!Kj<%lO!<n&n!>Q^$e&j!SSOY!=yYZ&cZ!P!=y!P!Q!>|!Q!^!=y!^!_!@Y!_!}!=y!}#O!Bw#O#P!Dj#P#o!=y#o#p!@Y#p;'S!=y;'S;=`!E[<%lO!=y&n!?Ta$e&j!SSO!^&c!_#Z&c#Z#[!>|#[#]&c#]#^!>|#^#a&c#a#b!>|#b#g&c#g#h!>|#h#i&c#i#j!>|#j#m&c#m#n!>|#n#o&c#p;'S&c;'S;=`&w<%lO&cS!@_X!SSOY!@YZ!P!@Y!P!Q!@z!Q!}!@Y!}#O!Ac#O#P!Bb#P;'S!@Y;'S;=`!Bq<%lO!@YS!APU!SS#Z#[!@z#]#^!@z#a#b!@z#g#h!@z#i#j!@z#m#n!@zS!AfVOY!AcZ#O!Ac#O#P!A{#P#Q!@Y#Q;'S!Ac;'S;=`!B[<%lO!AcS!BOSOY!AcZ;'S!Ac;'S;=`!B[<%lO!AcS!B_P;=`<%l!AcS!BeSOY!@YZ;'S!@Y;'S;=`!Bq<%lO!@YS!BtP;=`<%l!@Y&n!B|[$e&jOY!BwYZ&cZ!^!Bw!^!_!Ac!_#O!Bw#O#P!Cr#P#Q!=y#Q#o!Bw#o#p!Ac#p;'S!Bw;'S;=`!Dd<%lO!Bw&n!CwX$e&jOY!BwYZ&cZ!^!Bw!^!_!Ac!_#o!Bw#o#p!Ac#p;'S!Bw;'S;=`!Dd<%lO!Bw&n!DgP;=`<%l!Bw&n!DoX$e&jOY!=yYZ&cZ!^!=y!^!_!@Y!_#o!=y#o#p!@Y#p;'S!=y;'S;=`!E[<%lO!=y&n!E_P;=`<%l!=y(Q!Eki$e&j'|!b!SSOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#Z&}#Z#[!Eb#[#]&}#]#^!Eb#^#a&}#a#b!Eb#b#g&}#g#h!Eb#h#i&}#i#j!Eb#j#m&}#m#n!Eb#n#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!f!GaZ'|!b!SSOY!GYZw!GYwx!@Yx!P!GY!P!Q!HS!Q!}!GY!}#O!Ic#O#P!Bb#P;'S!GY;'S;=`!JZ<%lO!GY!f!HZb'|!b!SSOY'}Zw'}x#O'}#P#Z'}#Z#[!HS#[#]'}#]#^!HS#^#a'}#a#b!HS#b#g'}#g#h!HS#h#i'}#i#j!HS#j#m'}#m#n!HS#n;'S'};'S;=`(f<%lO'}!f!IhX'|!bOY!IcZw!Icwx!Acx#O!Ic#O#P!A{#P#Q!GY#Q;'S!Ic;'S;=`!JT<%lO!Ic!f!JWP;=`<%l!Ic!f!J^P;=`<%l!GY(Q!Jh^$e&j'|!bOY!JaYZ&cZw!Jawx!Bwx!^!Ja!^!_!Ic!_#O!Ja#O#P!Cr#P#Q!<n#Q#o!Ja#o#p!Ic#p;'S!Ja;'S;=`!Kd<%lO!Ja(Q!KgP;=`<%l!Ja(Q!KmP;=`<%l!<n'`!Ky`$e&j'yp!SSOY!KpYZ&cZr!Kprs!=ys!P!Kp!P!Q!L{!Q!^!Kp!^!_!Ns!_!}!Kp!}#O##z#O#P!Dj#P#o!Kp#o#p!Ns#p;'S!Kp;'S;=`#%T<%lO!Kp'`!MUi$e&j'yp!SSOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#Z(r#Z#[!L{#[#](r#]#^!L{#^#a(r#a#b!L{#b#g(r#g#h!L{#h#i(r#i#j!L{#j#m(r#m#n!L{#n#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(rt!NzZ'yp!SSOY!NsZr!Nsrs!@Ys!P!Ns!P!Q# m!Q!}!Ns!}#O#!|#O#P!Bb#P;'S!Ns;'S;=`##t<%lO!Nst# tb'yp!SSOY)rZr)rs#O)r#P#Z)r#Z#[# m#[#])r#]#^# m#^#a)r#a#b# m#b#g)r#g#h# m#h#i)r#i#j# m#j#m)r#m#n# m#n;'S)r;'S;=`*Z<%lO)rt##RX'ypOY#!|Zr#!|rs!Acs#O#!|#O#P!A{#P#Q!Ns#Q;'S#!|;'S;=`##n<%lO#!|t##qP;=`<%l#!|t##wP;=`<%l!Ns'`#$R^$e&j'ypOY##zYZ&cZr##zrs!Bws!^##z!^!_#!|!_#O##z#O#P!Cr#P#Q!Kp#Q#o##z#o#p#!|#p;'S##z;'S;=`#$}<%lO##z'`#%QP;=`<%l##z'`#%WP;=`<%l!Kp(r#%fk$e&j'yp'|!b!SSOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#Z%Z#Z#[#%Z#[#]%Z#]#^#%Z#^#a%Z#a#b#%Z#b#g%Z#g#h#%Z#h#i%Z#i#j#%Z#j#m%Z#m#n#%Z#n#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#W#'d]'yp'|!b!SSOY#'ZZr#'Zrs!GYsw#'Zwx!Nsx!P#'Z!P!Q#(]!Q!}#'Z!}#O#)w#O#P!Bb#P;'S#'Z;'S;=`#*w<%lO#'Z#W#(fe'yp'|!b!SSOY*gZr*grs'}sw*gwx)rx#O*g#P#Z*g#Z#[#(]#[#]*g#]#^#(]#^#a*g#a#b#(]#b#g*g#g#h#(]#h#i*g#i#j#(]#j#m*g#m#n#(]#n;'S*g;'S;=`+Z<%lO*g#W#*OZ'yp'|!bOY#)wZr#)wrs!Icsw#)wwx#!|x#O#)w#O#P!A{#P#Q#'Z#Q;'S#)w;'S;=`#*q<%lO#)w#W#*tP;=`<%l#)w#W#*zP;=`<%l#'Z(r#+W`$e&j'yp'|!bOY#*}YZ&cZr#*}rs!Jasw#*}wx##zx!^#*}!^!_#)w!_#O#*}#O#P!Cr#P#Q!;Z#Q#o#*}#o#p#)w#p;'S#*};'S;=`#,Y<%lO#*}(r#,]P;=`<%l#*}(r#,cP;=`<%l!;Z(CS#,sb$e&j'yp'|!b'q(;d!SSOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Kpx!P!;Z!P!Q#%Z!Q!^!;Z!^!_#'Z!_!}!;Z!}#O#*}#O#P!Dj#P#o!;Z#o#p#'Z#p;'S!;Z;'S;=`#,`<%lO!;Z(CS#.W_$e&j'yp'|!bR(;dOY#-{YZ&cZr#-{rs#/Vsw#-{wx#2gx!^#-{!^!_#4f!_#O#-{#O#P#0X#P#o#-{#o#p#4f#p;'S#-{;'S;=`#5e<%lO#-{(Bb#/`]$e&j'|!bR(;dOY#/VYZ&cZw#/Vwx#0Xx!^#/V!^!_#1j!_#O#/V#O#P#0X#P#o#/V#o#p#1j#p;'S#/V;'S;=`#2a<%lO#/V(AO#0`X$e&jR(;dOY#0XYZ&cZ!^#0X!^!_#0{!_#o#0X#o#p#0{#p;'S#0X;'S;=`#1d<%lO#0X(;d#1QSR(;dOY#0{Z;'S#0{;'S;=`#1^<%lO#0{(;d#1aP;=`<%l#0{(AO#1gP;=`<%l#0X(<v#1qW'|!bR(;dOY#1jZw#1jwx#0{x#O#1j#O#P#0{#P;'S#1j;'S;=`#2Z<%lO#1j(<v#2^P;=`<%l#1j(Bb#2dP;=`<%l#/V(Ap#2p]$e&j'ypR(;dOY#2gYZ&cZr#2grs#0Xs!^#2g!^!_#3i!_#O#2g#O#P#0X#P#o#2g#o#p#3i#p;'S#2g;'S;=`#4`<%lO#2g(<U#3pW'ypR(;dOY#3iZr#3irs#0{s#O#3i#O#P#0{#P;'S#3i;'S;=`#4Y<%lO#3i(<U#4]P;=`<%l#3i(Ap#4cP;=`<%l#2g(=h#4oY'yp'|!bR(;dOY#4fZr#4frs#1jsw#4fwx#3ix#O#4f#O#P#0{#P;'S#4f;'S;=`#5_<%lO#4f(=h#5bP;=`<%l#4f(CS#5hP;=`<%l#-{%#W#5xb$e&j#|$Id'yp'|!b!SSOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Kpx!P!;Z!P!Q#%Z!Q!^!;Z!^!_#'Z!_!}!;Z!}#O#*}#O#P!Dj#P#o!;Z#o#p#'Z#p;'S!;Z;'S;=`#,`<%lO!;Z+h#7_b$U#t$e&j'yp'|!b!SSOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Kpx!P!;Z!P!Q#%Z!Q!^!;Z!^!_#'Z!_!}!;Z!}#O#*}#O#P!Dj#P#o!;Z#o#p#'Z#p;'S!;Z;'S;=`#,`<%lO!;Z$/l#8rp$e&j'yp'|!bm$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#:v![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#:v#S#U%Z#U#V#>Q#V#X%Z#X#Y!4|#Y#b%Z#b#c#<v#c#d#AY#d#l%Z#l#m#D[#m#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#;Rk$e&j'yp'|!bm$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#:v![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#:v#S#X%Z#X#Y!4|#Y#b%Z#b#c#<v#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#=R_$e&j'yp'|!bm$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#>Zd$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#?i!R!S#?i!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#?i#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#?tf$e&j'yp'|!bm$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#?i!R!S#?i!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#?i#S#b%Z#b#c#<v#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#Acc$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#Bn!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#Bn#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#Bye$e&j'yp'|!bm$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#Bn!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#Bn#S#b%Z#b#c#<v#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#Deg$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#E|![!^%Z!^!_*g!_!c%Z!c!i#E|!i#O%Z#O#P&c#P#R%Z#R#S#E|#S#T%Z#T#Z#E|#Z#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#FXi$e&j'yp'|!bm$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#E|![!^%Z!^!_*g!_!c%Z!c!i#E|!i#O%Z#O#P&c#P#R%Z#R#S#E|#S#T%Z#T#Z#E|#Z#b%Z#b#c#<v#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%Gh#HT_!b$b$e&j#z%<f'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)[#I___l$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(CS#Jm^(P!*v!f'.r'yp'|!b$V)d(pSOY*gZr*grs'}sw*gwx)rx!P*g!P!Q#Ki!Q!^*g!^!_#L_!_!`#NP!`#O*g#P;'S*g;'S;=`+Z<%lO*g(n#KrX$g&j'yp'|!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g$Kh#LhZ#l$Id'yp'|!bOY*gZr*grs'}sw*gwx)rx!_*g!_!`#MZ!`#O*g#P;'S*g;'S;=`+Z<%lO*g$Kh#MdX#|$Id'yp'|!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g$Kh#NYX#m$Id'yp'|!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g%Gh$ Qa#Y%?x$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`!a$!V!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#W$!b_#e$Ih$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%Gh$#paeBf#m$Id$b#|$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`$$u!`!a$&P!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S$%Q_#m$Id$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S$&[a#l$Id$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`!a$'a!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S$'l`#l$Id$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'+h$(yc(d$Ip$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P$*U!P!^%Z!^!_*g!_!a%Z!a!b$+`!b#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'+`$*a_{'#p$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S$+k`$e&j#w$Id'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#&^$,x_!y!Ln$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(@^$.S_}(8n$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(n$/WZ$e&jO!^$/y!^!_$0a!_#i$/y#i#j$0f#j#l$/y#l#m$2X#m#o$/y#o#p$0a#p;'S$/y;'S;=`$4d<%lO$/y(n$0QT]#S$e&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c#S$0fO]#S(n$0k[$e&jO!Q&c!Q![$1a![!^&c!_!c&c!c!i$1a!i#T&c#T#Z$1a#Z#o&c#o#p$3w#p;'S&c;'S;=`&w<%lO&c(n$1fZ$e&jO!Q&c!Q![$2X![!^&c!_!c&c!c!i$2X!i#T&c#T#Z$2X#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$2^Z$e&jO!Q&c!Q![$3P![!^&c!_!c&c!c!i$3P!i#T&c#T#Z$3P#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$3UZ$e&jO!Q&c!Q![$/y![!^&c!_!c&c!c!i$/y!i#T&c#T#Z$/y#Z#o&c#p;'S&c;'S;=`&w<%lO&c#S$3zR!Q![$4T!c!i$4T#T#Z$4T#S$4WS!Q![$4T!c!i$4T#T#Z$4T#q#r$0a(n$4gP;=`<%l$/y!2r$4u_!T!+S$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S$6P`#t$Id$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&,v$7^_$e&j'yp'|!b(T&%WOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(CS$8lk$e&j'yp'|!b(W!LY'v&;d$Z#tOY%ZYZ&cZr%Zrs&}st%Ztu$8]uw%Zwx(rx}%Z}!O$:a!O!Q%Z!Q![$8]![!^%Z!^!_*g!_!c%Z!c!}$8]!}#O%Z#O#P&c#P#R%Z#R#S$8]#S#T%Z#T#o$8]#o#p*g#p$g%Z$g;'S$8];'S;=`$<g<%lO$8]+d$:lk$e&j'yp'|!b$Z#tOY%ZYZ&cZr%Zrs&}st%Ztu$:auw%Zwx(rx}%Z}!O$:a!O!Q%Z!Q![$:a![!^%Z!^!_*g!_!c%Z!c!}$:a!}#O%Z#O#P&c#P#R%Z#R#S$:a#S#T%Z#T#o$:a#o#p*g#p$g%Z$g;'S$:a;'S;=`$<a<%lO$:a+d$<dP;=`<%l$:a(CS$<jP;=`<%l$8]!5p$<vX!Y!3l'yp'|!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g%Df$=na(k%<v$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p#q$+`#q;'S%Z;'S;=`+a<%lO%Z%#`$?Q_!X$I`p`$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(r$@[_!nS$e&j'yp'|!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(CS$Al|$e&j'yp'|!b'o(;d(W!LY'v&;d$X#tOX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$f%Z$f$g+g$g#BYEr#BY#BZ$AZ#BZ$ISEr$IS$I_$AZ$I_$JTEr$JT$JU$AZ$JU$KVEr$KV$KW$AZ$KW&FUEr&FU&FV$AZ&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$AZ?HUOEr(CS$Dwk$e&j'yp'|!b'p(;d(W!LY'v&;d$X#tOY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr",
  tokenizers: [W$8, y$v, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, _$i, new H$f("$S~RRtu[#O#Pg#S#T#|~_P#o#pb~gOr~~jVO#i!P#i#j!U#j#l!P#l#m!q#m;'S!P;'S;=`#v<%lO!P~!UO!P~~!XS!Q![!e!c!i!e#T#Z!e#o#p#Z~!hR!Q![!q!c!i!q#T#Z!q~!tR!Q![!}!c!i!}#T#Z!}~#QR!Q![!P!c!i!P#T#Z!P~#^R!Q![#g!c!i#g#T#Z#g~#jS!Q![#g!c!i#g#T#Z#g#q#r!P~#yP;=`<%l!P~$RO(V~~", 141, 328), new H$f("j~RQYZXz{^~^O's~~aP!P!Qd~iO't~~", 25, 310)],
  topRules: { Script: [0, 5], SingleExpression: [1, 268], SingleClassItem: [2, 269] },
  dialects: { jsx: 12842, ts: 12844 },
  dynamicPrecedences: { 67: 1, 77: 1, 79: 1, 164: 1, 192: 1 },
  specialized: [{ term: 314, get: (Q3) => v$B[Q3] || -1 }, { term: 330, get: (Q3) => j$b[Q3] || -1 }, { term: 68, get: (Q3) => q$d[Q3] || -1 }],
  tokenPrec: 12868
});
class xe$5 {
  constructor(e28, t3, i) {
    this.state = e28, this.pos = t3, this.explicit = i, this.abortListeners = [];
  }
  tokenBefore(e28) {
    let t3 = k$t(this.state).resolveInner(this.pos, -1);
    for (; t3 && e28.indexOf(t3.name) < 0; )
      t3 = t3.parent;
    return t3 ? {
      from: t3.from,
      to: this.pos,
      text: this.state.sliceDoc(t3.from, this.pos),
      type: t3.type
    } : null;
  }
  matchBefore(e28) {
    let t3 = this.state.doc.lineAt(this.pos), i = Math.max(t3.from, this.pos - 250), o3 = t3.text.slice(i - t3.from, this.pos - t3.from), s3 = o3.search(we$6(e28, false));
    return s3 < 0 ? null : { from: i + s3, to: this.pos, text: o3.slice(s3) };
  }
  get aborted() {
    return this.abortListeners == null;
  }
  addEventListener(e28, t3) {
    e28 == "abort" && this.abortListeners && this.abortListeners.push(t3);
  }
}
function se$8(n3) {
  let e28 = Object.keys(n3).join(""), t3 = /\w/.test(e28);
  return t3 && (e28 = e28.replace(/\w/g, "")), `[${t3 ? "\\w" : ""}${e28.replace(/[^\w\s]/g, "\\$&")}]`;
}
function Ne$2(n3) {
  let e28 = /* @__PURE__ */ Object.create(null), t3 = /* @__PURE__ */ Object.create(null);
  for (let { label: o3 } of n3) {
    e28[o3[0]] = true;
    for (let s3 = 1; s3 < o3.length; s3++)
      t3[o3[s3]] = true;
  }
  let i = se$8(e28) + se$8(t3) + "*$";
  return [new RegExp("^" + i), new RegExp(i)];
}
function We$3(n3) {
  let e28 = n3.map((o3) => typeof o3 == "string" ? { label: o3 } : o3), [t3, i] = e28.every((o3) => /^\w+$/.test(o3.label)) ? [/\w*$/, /\w+$/] : Ne$2(e28);
  return (o3) => {
    let s3 = o3.matchBefore(i);
    return s3 || o3.explicit ? { from: s3 ? s3.from : o3.pos, options: e28, validFor: t3 } : null;
  };
}
function Bt$2(n3, e28) {
  return (t3) => {
    for (let i = k$t(t3.state).resolveInner(t3.pos, -1); i; i = i.parent) {
      if (n3.indexOf(i.name) > -1)
        return null;
      if (i.type.isTop)
        break;
    }
    return e28(t3);
  };
}
class le$6 {
  constructor(e28, t3, i, o3) {
    this.completion = e28, this.source = t3, this.match = i, this.score = o3;
  }
}
function I$o(n3) {
  return n3.selection.main.from;
}
function we$6(n3, e28) {
  var t3;
  let { source: i } = n3, o3 = e28 && i[0] != "^", s3 = i[i.length - 1] != "$";
  return !o3 && !s3 ? n3 : new RegExp(`${o3 ? "^" : ""}(?:${i})${s3 ? "$" : ""}`, (t3 = n3.flags) !== null && t3 !== void 0 ? t3 : n3.ignoreCase ? "i" : "");
}
const Ce$5 = /* @__PURE__ */ U$n.define();
function Ve$3(n3, e28, t3, i) {
  let { main: o3 } = n3.selection, s3 = t3 - o3.from, l3 = i - o3.from;
  return Object.assign(Object.assign({}, n3.changeByRange((r3) => r3 != o3 && t3 != i && n3.sliceDoc(r3.from + s3, r3.from + l3) != n3.sliceDoc(t3, i) ? { range: r3 } : {
    changes: { from: r3.from + s3, to: i == o3.from ? r3.to : r3.from + l3, insert: e28 },
    range: g$K.cursor(r3.from + s3 + e28.length)
  })), { scrollIntoView: true, userEvent: "input.complete" });
}
const re$6 = /* @__PURE__ */ new WeakMap();
function He$3(n3) {
  if (!Array.isArray(n3))
    return n3;
  let e28 = re$6.get(n3);
  return e28 || re$6.set(n3, e28 = We$3(n3)), e28;
}
const _$h = /* @__PURE__ */ S$m.define(), M$e = /* @__PURE__ */ S$m.define();
class qe$2 {
  constructor(e28) {
    this.pattern = e28, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [], this.score = 0, this.matched = [];
    for (let t3 = 0; t3 < e28.length; ) {
      let i = ne$e(e28, t3), o3 = xe$a(i);
      this.chars.push(i);
      let s3 = e28.slice(t3, t3 + o3), l3 = s3.toUpperCase();
      this.folded.push(ne$e(l3 == s3 ? s3.toLowerCase() : l3, 0)), t3 += o3;
    }
    this.astral = e28.length != this.chars.length;
  }
  ret(e28, t3) {
    return this.score = e28, this.matched = t3, true;
  }
  match(e28) {
    if (this.pattern.length == 0)
      return this.ret(-100, []);
    if (e28.length < this.pattern.length)
      return false;
    let { chars: t3, folded: i, any: o3, precise: s3, byWord: l3 } = this;
    if (t3.length == 1) {
      let d3 = ne$e(e28, 0), P3 = xe$a(d3), v3 = P3 == e28.length ? 0 : -100;
      if (d3 != t3[0])
        if (d3 == i[0])
          v3 += -200;
        else
          return false;
      return this.ret(v3, [0, P3]);
    }
    let r3 = e28.indexOf(this.pattern);
    if (r3 == 0)
      return this.ret(e28.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
    let a3 = t3.length, c3 = 0;
    if (r3 < 0) {
      for (let d3 = 0, P3 = Math.min(e28.length, 200); d3 < P3 && c3 < a3; ) {
        let v3 = ne$e(e28, d3);
        (v3 == t3[c3] || v3 == i[c3]) && (o3[c3++] = d3), d3 += xe$a(v3);
      }
      if (c3 < a3)
        return false;
    }
    let f3 = 0, h3 = 0, p3 = false, u3 = 0, w3 = -1, T3 = -1, q3 = /[a-z]/.test(e28), L3 = true;
    for (let d3 = 0, P3 = Math.min(e28.length, 200), v3 = 0; d3 < P3 && h3 < a3; ) {
      let g3 = ne$e(e28, d3);
      r3 < 0 && (f3 < a3 && g3 == t3[f3] && (s3[f3++] = d3), u3 < a3 && (g3 == t3[u3] || g3 == i[u3] ? (u3 == 0 && (w3 = d3), T3 = d3 + 1, u3++) : u3 = 0));
      let $3, z3 = g3 < 255 ? g3 >= 48 && g3 <= 57 || g3 >= 97 && g3 <= 122 ? 2 : g3 >= 65 && g3 <= 90 ? 1 : 0 : ($3 = rt$7(g3)) != $3.toLowerCase() ? 1 : $3 != $3.toUpperCase() ? 2 : 0;
      (!d3 || z3 == 1 && q3 || v3 == 0 && z3 != 0) && (t3[h3] == g3 || i[h3] == g3 && (p3 = true) ? l3[h3++] = d3 : l3.length && (L3 = false)), v3 = z3, d3 += xe$a(g3);
    }
    return h3 == a3 && l3[0] == 0 && L3 ? this.result(-100 + (p3 ? -200 : 0), l3, e28) : u3 == a3 && w3 == 0 ? this.ret(-200 - e28.length + (T3 == e28.length ? 0 : -100), [0, T3]) : r3 > -1 ? this.ret(-700 - e28.length, [r3, r3 + this.pattern.length]) : u3 == a3 ? this.ret(-200 + -700 - e28.length, [w3, T3]) : h3 == a3 ? this.result(-100 + (p3 ? -200 : 0) + -700 + (L3 ? 0 : -1100), l3, e28) : t3.length == 2 ? false : this.result((o3[0] ? -700 : 0) + -200 + -1100, o3, e28);
  }
  result(e28, t3, i) {
    let o3 = [], s3 = 0;
    for (let l3 of t3) {
      let r3 = l3 + (this.astral ? xe$a(ne$e(i, l3)) : 1);
      s3 && o3[s3 - 1] == l3 ? o3[s3 - 1] = r3 : (o3[s3++] = l3, o3[s3++] = r3);
    }
    return this.ret(e28 - i.length, o3);
  }
}
const m$18 = /* @__PURE__ */ A$o.define({
  combine(n3) {
    return ht$7(n3, {
      activateOnTyping: true,
      selectOnOpen: true,
      override: null,
      closeOnBlur: true,
      maxRenderedOptions: 100,
      defaultKeymap: true,
      tooltipClass: () => "",
      optionClass: () => "",
      aboveCursor: false,
      icons: true,
      addToOptions: [],
      positionInfo: ze$3,
      compareCompletions: (e28, t3) => e28.label.localeCompare(t3.label),
      interactionDelay: 75,
      updateSyncTime: 100
    }, {
      defaultKeymap: (e28, t3) => e28 && t3,
      closeOnBlur: (e28, t3) => e28 && t3,
      icons: (e28, t3) => e28 && t3,
      tooltipClass: (e28, t3) => (i) => ae$8(e28(i), t3(i)),
      optionClass: (e28, t3) => (i) => ae$8(e28(i), t3(i)),
      addToOptions: (e28, t3) => e28.concat(t3)
    });
  }
});
function ae$8(n3, e28) {
  return n3 ? e28 ? n3 + " " + e28 : n3 : e28;
}
function ze$3(n3, e28, t3, i, o3, s3) {
  let l3 = n3.textDirection == L$r.RTL, r3 = l3, a3 = false, c3 = "top", f3, h3, p3 = e28.left - o3.left, u3 = o3.right - e28.right, w3 = i.right - i.left, T3 = i.bottom - i.top;
  if (r3 && p3 < Math.min(w3, u3) ? r3 = false : !r3 && u3 < Math.min(w3, p3) && (r3 = true), w3 <= (r3 ? p3 : u3))
    f3 = Math.max(o3.top, Math.min(t3.top, o3.bottom - T3)) - e28.top, h3 = Math.min(400, r3 ? p3 : u3);
  else {
    a3 = true, h3 = Math.min(400, (l3 ? e28.right : o3.right - e28.left) - 30);
    let d3 = o3.bottom - e28.bottom;
    d3 >= T3 || d3 > e28.top ? f3 = t3.bottom - e28.top : (c3 = "bottom", f3 = e28.bottom - t3.top);
  }
  let q3 = (e28.bottom - e28.top) / s3.offsetHeight, L3 = (e28.right - e28.left) / s3.offsetWidth;
  return {
    style: `${c3}: ${f3 / q3}px; max-width: ${h3 / L3}px`,
    class: "cm-completionInfo-" + (a3 ? l3 ? "left-narrow" : "right-narrow" : r3 ? "left" : "right")
  };
}
function Ke$3(n3) {
  let e28 = n3.addToOptions.slice();
  return n3.icons && e28.push({
    render(t3) {
      let i = document.createElement("div");
      return i.classList.add("cm-completionIcon"), t3.type && i.classList.add(...t3.type.split(/\s+/g).map((o3) => "cm-completionIcon-" + o3)), i.setAttribute("aria-hidden", "true"), i;
    },
    position: 20
  }), e28.push({
    render(t3, i, o3) {
      let s3 = document.createElement("span");
      s3.className = "cm-completionLabel";
      let l3 = t3.displayLabel || t3.label, r3 = 0;
      for (let a3 = 0; a3 < o3.length; ) {
        let c3 = o3[a3++], f3 = o3[a3++];
        c3 > r3 && s3.appendChild(document.createTextNode(l3.slice(r3, c3)));
        let h3 = s3.appendChild(document.createElement("span"));
        h3.appendChild(document.createTextNode(l3.slice(c3, f3))), h3.className = "cm-completionMatchedText", r3 = f3;
      }
      return r3 < l3.length && s3.appendChild(document.createTextNode(l3.slice(r3))), s3;
    },
    position: 50
  }, {
    render(t3) {
      if (!t3.detail)
        return null;
      let i = document.createElement("span");
      return i.className = "cm-completionDetail", i.textContent = t3.detail, i;
    },
    position: 80
  }), e28.sort((t3, i) => t3.position - i.position).map((t3) => t3.render);
}
function K$a(n3, e28, t3) {
  if (n3 <= t3)
    return { from: 0, to: n3 };
  if (e28 < 0 && (e28 = 0), e28 <= n3 >> 1) {
    let o3 = Math.floor(e28 / t3);
    return { from: o3 * t3, to: (o3 + 1) * t3 };
  }
  let i = Math.floor((n3 - e28) / t3);
  return { from: n3 - (i + 1) * t3, to: n3 - i * t3 };
}
class Qe$2 {
  constructor(e28, t3, i) {
    this.view = e28, this.stateField = t3, this.applyCompletion = i, this.info = null, this.infoDestroy = null, this.placeInfoReq = {
      read: () => this.measureInfo(),
      write: (a3) => this.placeInfo(a3),
      key: this
    }, this.space = null, this.currentClass = "";
    let o3 = e28.state.field(t3), { options: s3, selected: l3 } = o3.open, r3 = e28.state.facet(m$18);
    this.optionContent = Ke$3(r3), this.optionClass = r3.optionClass, this.tooltipClass = r3.tooltipClass, this.range = K$a(s3.length, l3, r3.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.updateTooltipClass(e28.state), this.dom.addEventListener("mousedown", (a3) => {
      let { options: c3 } = e28.state.field(t3).open;
      for (let f3 = a3.target, h3; f3 && f3 != this.dom; f3 = f3.parentNode)
        if (f3.nodeName == "LI" && (h3 = /-(\d+)$/.exec(f3.id)) && +h3[1] < c3.length) {
          this.applyCompletion(e28, c3[+h3[1]]), a3.preventDefault();
          return;
        }
    }), this.dom.addEventListener("focusout", (a3) => {
      let c3 = e28.state.field(this.stateField, false);
      c3 && c3.tooltip && e28.state.facet(m$18).closeOnBlur && a3.relatedTarget != e28.contentDOM && e28.dispatch({ effects: M$e.of(null) });
    }), this.showOptions(s3, o3.id);
  }
  mount() {
    this.updateSel();
  }
  showOptions(e28, t3) {
    this.list && this.list.remove(), this.list = this.dom.appendChild(this.createListBox(e28, t3, this.range)), this.list.addEventListener("scroll", () => {
      this.info && this.view.requestMeasure(this.placeInfoReq);
    });
  }
  update(e28) {
    var t3;
    let i = e28.state.field(this.stateField), o3 = e28.startState.field(this.stateField);
    if (this.updateTooltipClass(e28.state), i != o3) {
      let { options: s3, selected: l3, disabled: r3 } = i.open;
      (!o3.open || o3.open.options != s3) && (this.range = K$a(s3.length, l3, e28.state.facet(m$18).maxRenderedOptions), this.showOptions(s3, i.id)), this.updateSel(), r3 != ((t3 = o3.open) === null || t3 === void 0 ? void 0 : t3.disabled) && this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!r3);
    }
  }
  updateTooltipClass(e28) {
    let t3 = this.tooltipClass(e28);
    if (t3 != this.currentClass) {
      for (let i of this.currentClass.split(" "))
        i && this.dom.classList.remove(i);
      for (let i of t3.split(" "))
        i && this.dom.classList.add(i);
      this.currentClass = t3;
    }
  }
  positioned(e28) {
    this.space = e28, this.info && this.view.requestMeasure(this.placeInfoReq);
  }
  updateSel() {
    let e28 = this.view.state.field(this.stateField), t3 = e28.open;
    if ((t3.selected > -1 && t3.selected < this.range.from || t3.selected >= this.range.to) && (this.range = K$a(t3.options.length, t3.selected, this.view.state.facet(m$18).maxRenderedOptions), this.showOptions(t3.options, e28.id)), this.updateSelectedOption(t3.selected)) {
      this.destroyInfo();
      let { completion: i } = t3.options[t3.selected], { info: o3 } = i;
      if (!o3)
        return;
      let s3 = typeof o3 == "string" ? document.createTextNode(o3) : o3(i);
      if (!s3)
        return;
      "then" in s3 ? s3.then((l3) => {
        l3 && this.view.state.field(this.stateField, false) == e28 && this.addInfoPane(l3, i);
      }).catch((l3) => ct$6(this.view.state, l3, "completion info")) : this.addInfoPane(s3, i);
    }
  }
  addInfoPane(e28, t3) {
    this.destroyInfo();
    let i = this.info = document.createElement("div");
    if (i.className = "cm-tooltip cm-completionInfo", e28.nodeType != null)
      i.appendChild(e28), this.infoDestroy = null;
    else {
      let { dom: o3, destroy: s3 } = e28;
      i.appendChild(o3), this.infoDestroy = s3 || null;
    }
    this.dom.appendChild(i), this.view.requestMeasure(this.placeInfoReq);
  }
  updateSelectedOption(e28) {
    let t3 = null;
    for (let i = this.list.firstChild, o3 = this.range.from; i; i = i.nextSibling, o3++)
      i.nodeName != "LI" || !i.id ? o3-- : o3 == e28 ? i.hasAttribute("aria-selected") || (i.setAttribute("aria-selected", "true"), t3 = i) : i.hasAttribute("aria-selected") && i.removeAttribute("aria-selected");
    return t3 && Ye$1(this.list, t3), t3;
  }
  measureInfo() {
    let e28 = this.dom.querySelector("[aria-selected]");
    if (!e28 || !this.info)
      return null;
    let t3 = this.dom.getBoundingClientRect(), i = this.info.getBoundingClientRect(), o3 = e28.getBoundingClientRect(), s3 = this.space;
    if (!s3) {
      let l3 = this.dom.ownerDocument.defaultView || window;
      s3 = { left: 0, top: 0, right: l3.innerWidth, bottom: l3.innerHeight };
    }
    return o3.top > Math.min(s3.bottom, t3.bottom) - 10 || o3.bottom < Math.max(s3.top, t3.top) + 10 ? null : this.view.state.facet(m$18).positionInfo(this.view, t3, o3, i, s3, this.dom);
  }
  placeInfo(e28) {
    this.info && (e28 ? (e28.style && (this.info.style.cssText = e28.style), this.info.className = "cm-tooltip cm-completionInfo " + (e28.class || "")) : this.info.style.cssText = "top: -1e6px");
  }
  createListBox(e28, t3, i) {
    const o3 = document.createElement("ul");
    o3.id = t3, o3.setAttribute("role", "listbox"), o3.setAttribute("aria-expanded", "true"), o3.setAttribute("aria-label", this.view.state.phrase("Completions"));
    let s3 = null;
    for (let l3 = i.from; l3 < i.to; l3++) {
      let { completion: r3, match: a3 } = e28[l3], { section: c3 } = r3;
      if (c3) {
        let p3 = typeof c3 == "string" ? c3 : c3.name;
        if (p3 != s3 && (l3 > i.from || i.from == 0))
          if (s3 = p3, typeof c3 != "string" && c3.header)
            o3.appendChild(c3.header(c3));
          else {
            let u3 = o3.appendChild(document.createElement("completion-section"));
            u3.textContent = p3;
          }
      }
      const f3 = o3.appendChild(document.createElement("li"));
      f3.id = t3 + "-" + l3, f3.setAttribute("role", "option");
      let h3 = this.optionClass(r3);
      h3 && (f3.className = h3);
      for (let p3 of this.optionContent) {
        let u3 = p3(r3, this.view.state, a3);
        u3 && f3.appendChild(u3);
      }
    }
    return i.from && o3.classList.add("cm-completionListIncompleteTop"), i.to < e28.length && o3.classList.add("cm-completionListIncompleteBottom"), o3;
  }
  destroyInfo() {
    this.info && (this.infoDestroy && this.infoDestroy(), this.info.remove(), this.info = null);
  }
  destroy() {
    this.destroyInfo();
  }
}
function Xe$3(n3, e28) {
  return (t3) => new Qe$2(t3, n3, e28);
}
function Ye$1(n3, e28) {
  let t3 = n3.getBoundingClientRect(), i = e28.getBoundingClientRect(), o3 = t3.height / n3.offsetHeight;
  i.top < t3.top ? n3.scrollTop -= (t3.top - i.top) / o3 : i.bottom > t3.bottom && (n3.scrollTop += (i.bottom - t3.bottom) / o3);
}
function ce$5(n3) {
  return (n3.boost || 0) * 100 + (n3.apply ? 10 : 0) + (n3.info ? 5 : 0) + (n3.type ? 1 : 0);
}
function Ge$2(n3, e28) {
  let t3 = [], i = null, o3 = (a3) => {
    t3.push(a3);
    let { section: c3 } = a3.completion;
    if (c3) {
      i || (i = []);
      let f3 = typeof c3 == "string" ? c3 : c3.name;
      i.some((h3) => h3.name == f3) || i.push(typeof c3 == "string" ? { name: f3 } : c3);
    }
  };
  for (let a3 of n3)
    if (a3.hasResult()) {
      let c3 = a3.result.getMatch;
      if (a3.result.filter === false)
        for (let f3 of a3.result.options)
          o3(new le$6(f3, a3.source, c3 ? c3(f3) : [], 1e9 - t3.length));
      else {
        let f3 = new qe$2(e28.sliceDoc(a3.from, a3.to));
        for (let h3 of a3.result.options)
          if (f3.match(h3.label)) {
            let p3 = h3.displayLabel ? c3 ? c3(h3, f3.matched) : [] : f3.matched;
            o3(new le$6(h3, a3.source, p3, f3.score + (h3.boost || 0)));
          }
      }
    }
  if (i) {
    let a3 = /* @__PURE__ */ Object.create(null), c3 = 0, f3 = (h3, p3) => {
      var u3, w3;
      return ((u3 = h3.rank) !== null && u3 !== void 0 ? u3 : 1e9) - ((w3 = p3.rank) !== null && w3 !== void 0 ? w3 : 1e9) || (h3.name < p3.name ? -1 : 1);
    };
    for (let h3 of i.sort(f3))
      c3 -= 1e5, a3[h3.name] = c3;
    for (let h3 of t3) {
      let { section: p3 } = h3.completion;
      p3 && (h3.score += a3[typeof p3 == "string" ? p3 : p3.name]);
    }
  }
  let s3 = [], l3 = null, r3 = e28.facet(m$18).compareCompletions;
  for (let a3 of t3.sort((c3, f3) => f3.score - c3.score || r3(c3.completion, f3.completion))) {
    let c3 = a3.completion;
    !l3 || l3.label != c3.label || l3.detail != c3.detail || l3.type != null && c3.type != null && l3.type != c3.type || l3.apply != c3.apply || l3.boost != c3.boost ? s3.push(a3) : ce$5(a3.completion) > ce$5(l3) && (s3[s3.length - 1] = a3), l3 = a3.completion;
  }
  return s3;
}
class A$g {
  constructor(e28, t3, i, o3, s3, l3) {
    this.options = e28, this.attrs = t3, this.tooltip = i, this.timestamp = o3, this.selected = s3, this.disabled = l3;
  }
  setSelected(e28, t3) {
    return e28 == this.selected || e28 >= this.options.length ? this : new A$g(this.options, fe$5(t3, e28), this.tooltip, this.timestamp, e28, this.disabled);
  }
  static build(e28, t3, i, o3, s3) {
    let l3 = Ge$2(e28, t3);
    if (!l3.length)
      return o3 && e28.some((a3) => a3.state == 1) ? new A$g(o3.options, o3.attrs, o3.tooltip, o3.timestamp, o3.selected, true) : null;
    let r3 = t3.facet(m$18).selectOnOpen ? 0 : -1;
    if (o3 && o3.selected != r3 && o3.selected != -1) {
      let a3 = o3.options[o3.selected].completion;
      for (let c3 = 0; c3 < l3.length; c3++)
        if (l3[c3].completion == a3) {
          r3 = c3;
          break;
        }
    }
    return new A$g(l3, fe$5(i, r3), {
      pos: e28.reduce((a3, c3) => c3.hasResult() ? Math.min(a3, c3.from) : a3, 1e8),
      create: tt$1,
      above: s3.aboveCursor
    }, o3 ? o3.timestamp : Date.now(), r3, false);
  }
  map(e28) {
    return new A$g(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), { pos: e28.mapPos(this.tooltip.pos) }), this.timestamp, this.selected, this.disabled);
  }
}
class N$q {
  constructor(e28, t3, i) {
    this.active = e28, this.id = t3, this.open = i;
  }
  static start() {
    return new N$q(_e$4, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
  }
  update(e28) {
    let { state: t3 } = e28, i = t3.facet(m$18), s3 = (i.override || t3.languageDataAt("autocomplete", I$o(t3)).map(He$3)).map((r3) => (this.active.find((c3) => c3.source == r3) || new b$x(r3, this.active.some((c3) => c3.state != 0) ? 1 : 0)).update(e28, i));
    s3.length == this.active.length && s3.every((r3, a3) => r3 == this.active[a3]) && (s3 = this.active);
    let l3 = this.open;
    l3 && e28.docChanged && (l3 = l3.map(e28.changes)), e28.selection || s3.some((r3) => r3.hasResult() && e28.changes.touchesRange(r3.from, r3.to)) || !Je$1(s3, this.active) ? l3 = A$g.build(s3, t3, this.id, l3, i) : l3 && l3.disabled && !s3.some((r3) => r3.state == 1) && (l3 = null), !l3 && s3.every((r3) => r3.state != 1) && s3.some((r3) => r3.hasResult()) && (s3 = s3.map((r3) => r3.hasResult() ? new b$x(r3.source, 0) : r3));
    for (let r3 of e28.effects)
      r3.is(Se$2) && (l3 = l3 && l3.setSelected(r3.value, this.id));
    return s3 == this.active && l3 == this.open ? this : new N$q(s3, this.id, l3);
  }
  get tooltip() {
    return this.open ? this.open.tooltip : null;
  }
  get attrs() {
    return this.open ? this.open.attrs : Ze$1;
  }
}
function Je$1(n3, e28) {
  if (n3 == e28)
    return true;
  for (let t3 = 0, i = 0; ; ) {
    for (; t3 < n3.length && !n3[t3].hasResult; )
      t3++;
    for (; i < e28.length && !e28[i].hasResult; )
      i++;
    let o3 = t3 == n3.length, s3 = i == e28.length;
    if (o3 || s3)
      return o3 == s3;
    if (n3[t3++].result != e28[i++].result)
      return false;
  }
}
const Ze$1 = {
  "aria-autocomplete": "list"
};
function fe$5(n3, e28) {
  let t3 = {
    "aria-autocomplete": "list",
    "aria-haspopup": "listbox",
    "aria-controls": n3
  };
  return e28 > -1 && (t3["aria-activedescendant"] = n3 + "-" + e28), t3;
}
const _e$4 = [];
function J$a(n3) {
  return n3.isUserEvent("input.type") ? "input" : n3.isUserEvent("delete.backward") ? "delete" : null;
}
class b$x {
  constructor(e28, t3, i = -1) {
    this.source = e28, this.state = t3, this.explicitPos = i;
  }
  hasResult() {
    return false;
  }
  update(e28, t3) {
    let i = J$a(e28), o3 = this;
    i ? o3 = o3.handleUserEvent(e28, i, t3) : e28.docChanged ? o3 = o3.handleChange(e28) : e28.selection && o3.state != 0 && (o3 = new b$x(o3.source, 0));
    for (let s3 of e28.effects)
      if (s3.is(_$h))
        o3 = new b$x(o3.source, 1, s3.value ? I$o(e28.state) : -1);
      else if (s3.is(M$e))
        o3 = new b$x(o3.source, 0);
      else if (s3.is(ve$4))
        for (let l3 of s3.value)
          l3.source == o3.source && (o3 = l3);
    return o3;
  }
  handleUserEvent(e28, t3, i) {
    return t3 == "delete" || !i.activateOnTyping ? this.map(e28.changes) : new b$x(this.source, 1);
  }
  handleChange(e28) {
    return e28.changes.touchesRange(I$o(e28.startState)) ? new b$x(this.source, 0) : this.map(e28.changes);
  }
  map(e28) {
    return e28.empty || this.explicitPos < 0 ? this : new b$x(this.source, this.state, e28.mapPos(this.explicitPos));
  }
}
class R$c extends b$x {
  constructor(e28, t3, i, o3, s3) {
    super(e28, 2, t3), this.result = i, this.from = o3, this.to = s3;
  }
  hasResult() {
    return true;
  }
  handleUserEvent(e28, t3, i) {
    var o3;
    let s3 = e28.changes.mapPos(this.from), l3 = e28.changes.mapPos(this.to, 1), r3 = I$o(e28.state);
    if ((this.explicitPos < 0 ? r3 <= s3 : r3 < this.from) || r3 > l3 || t3 == "delete" && I$o(e28.startState) == this.from)
      return new b$x(this.source, t3 == "input" && i.activateOnTyping ? 1 : 0);
    let a3 = this.explicitPos < 0 ? -1 : e28.changes.mapPos(this.explicitPos), c3;
    return et$2(this.result.validFor, e28.state, s3, l3) ? new R$c(this.source, a3, this.result, s3, l3) : this.result.update && (c3 = this.result.update(this.result, s3, l3, new xe$5(e28.state, r3, a3 >= 0))) ? new R$c(this.source, a3, c3, c3.from, (o3 = c3.to) !== null && o3 !== void 0 ? o3 : I$o(e28.state)) : new b$x(this.source, 1, a3);
  }
  handleChange(e28) {
    return e28.changes.touchesRange(this.from, this.to) ? new b$x(this.source, 0) : this.map(e28.changes);
  }
  map(e28) {
    return e28.empty ? this : new R$c(this.source, this.explicitPos < 0 ? -1 : e28.mapPos(this.explicitPos), this.result, e28.mapPos(this.from), e28.mapPos(this.to, 1));
  }
}
function et$2(n3, e28, t3, i) {
  if (!n3)
    return false;
  let o3 = e28.sliceDoc(t3, i);
  return typeof n3 == "function" ? n3(o3, t3, i, e28) : we$6(n3, true).test(o3);
}
const ve$4 = /* @__PURE__ */ S$m.define({
  map(n3, e28) {
    return n3.map((t3) => t3.map(e28));
  }
}), Se$2 = /* @__PURE__ */ S$m.define(), y$u = /* @__PURE__ */ L$s.define({
  create() {
    return N$q.start();
  },
  update(n3, e28) {
    return n3.update(e28);
  },
  provide: (n3) => [
    sn$3.from(n3, (e28) => e28.tooltip),
    A$m.contentAttributes.from(n3, (e28) => e28.attrs)
  ]
});
function Ie$3(n3, e28) {
  const t3 = e28.completion.apply || e28.completion.label;
  let i = n3.state.field(y$u).active.find((o3) => o3.source == e28.source);
  return i instanceof R$c ? (typeof t3 == "string" ? n3.dispatch(Object.assign(Object.assign({}, Ve$3(n3.state, t3, i.from, i.to)), { annotations: Ce$5.of(e28.completion) })) : t3(n3, e28.completion, i.from, i.to), true) : false;
}
const tt$1 = /* @__PURE__ */ Xe$3(y$u, Ie$3);
function U$g(n3, e28 = "option") {
  return (t3) => {
    let i = t3.state.field(y$u, false);
    if (!i || !i.open || i.open.disabled || Date.now() - i.open.timestamp < t3.state.facet(m$18).interactionDelay)
      return false;
    let o3 = 1, s3;
    e28 == "page" && (s3 = qo$2(t3, i.open.tooltip)) && (o3 = Math.max(2, Math.floor(s3.dom.offsetHeight / s3.dom.querySelector("li").offsetHeight) - 1));
    let { length: l3 } = i.open.options, r3 = i.open.selected > -1 ? i.open.selected + o3 * (n3 ? 1 : -1) : n3 ? 0 : l3 - 1;
    return r3 < 0 ? r3 = e28 == "page" ? 0 : l3 - 1 : r3 >= l3 && (r3 = e28 == "page" ? l3 - 1 : 0), t3.dispatch({ effects: Se$2.of(r3) }), true;
  };
}
const it$2 = (n3) => {
  let e28 = n3.state.field(y$u, false);
  return n3.state.readOnly || !e28 || !e28.open || e28.open.selected < 0 || e28.open.disabled || Date.now() - e28.open.timestamp < n3.state.facet(m$18).interactionDelay ? false : Ie$3(n3, e28.open.options[e28.open.selected]);
}, nt$2 = (n3) => n3.state.field(y$u, false) ? (n3.dispatch({ effects: _$h.of(true) }), true) : false, ot$2 = (n3) => {
  let e28 = n3.state.field(y$u, false);
  return !e28 || !e28.active.some((t3) => t3.state != 0) ? false : (n3.dispatch({ effects: M$e.of(null) }), true);
};
class st$3 {
  constructor(e28, t3) {
    this.active = e28, this.context = t3, this.time = Date.now(), this.updates = [], this.done = void 0;
  }
}
const lt$4 = 50, rt$3 = 1e3, at$2 = /* @__PURE__ */ z$i.fromClass(class {
  constructor(n3) {
    this.view = n3, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.composing = 0;
    for (let e28 of n3.state.field(y$u).active)
      e28.state == 1 && this.startQuery(e28);
  }
  update(n3) {
    let e28 = n3.state.field(y$u);
    if (!n3.selectionSet && !n3.docChanged && n3.startState.field(y$u) == e28)
      return;
    let t3 = n3.transactions.some((i) => (i.selection || i.docChanged) && !J$a(i));
    for (let i = 0; i < this.running.length; i++) {
      let o3 = this.running[i];
      if (t3 || o3.updates.length + n3.transactions.length > lt$4 && Date.now() - o3.time > rt$3) {
        for (let s3 of o3.context.abortListeners)
          try {
            s3();
          } catch (l3) {
            ct$6(this.view.state, l3);
          }
        o3.context.abortListeners = null, this.running.splice(i--, 1);
      } else
        o3.updates.push(...n3.transactions);
    }
    if (this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), this.debounceUpdate = e28.active.some((i) => i.state == 1 && !this.running.some((o3) => o3.active.source == i.source)) ? setTimeout(() => this.startUpdate(), 50) : -1, this.composing != 0)
      for (let i of n3.transactions)
        J$a(i) == "input" ? this.composing = 2 : this.composing == 2 && i.selection && (this.composing = 3);
  }
  startUpdate() {
    this.debounceUpdate = -1;
    let { state: n3 } = this.view, e28 = n3.field(y$u);
    for (let t3 of e28.active)
      t3.state == 1 && !this.running.some((i) => i.active.source == t3.source) && this.startQuery(t3);
  }
  startQuery(n3) {
    let { state: e28 } = this.view, t3 = I$o(e28), i = new xe$5(e28, t3, n3.explicitPos == t3), o3 = new st$3(n3, i);
    this.running.push(o3), Promise.resolve(n3.source(i)).then((s3) => {
      o3.context.aborted || (o3.done = s3 || null, this.scheduleAccept());
    }, (s3) => {
      this.view.dispatch({ effects: M$e.of(null) }), ct$6(this.view.state, s3);
    });
  }
  scheduleAccept() {
    this.running.every((n3) => n3.done !== void 0) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(m$18).updateSyncTime));
  }
  accept() {
    var n3;
    this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
    let e28 = [], t3 = this.view.state.facet(m$18);
    for (let i = 0; i < this.running.length; i++) {
      let o3 = this.running[i];
      if (o3.done === void 0)
        continue;
      if (this.running.splice(i--, 1), o3.done) {
        let l3 = new R$c(o3.active.source, o3.active.explicitPos, o3.done, o3.done.from, (n3 = o3.done.to) !== null && n3 !== void 0 ? n3 : I$o(o3.updates.length ? o3.updates[0].startState : this.view.state));
        for (let r3 of o3.updates)
          l3 = l3.update(r3, t3);
        if (l3.hasResult()) {
          e28.push(l3);
          continue;
        }
      }
      let s3 = this.view.state.field(y$u).active.find((l3) => l3.source == o3.active.source);
      if (s3 && s3.state == 1)
        if (o3.done == null) {
          let l3 = new b$x(o3.active.source, 0);
          for (let r3 of o3.updates)
            l3 = l3.update(r3, t3);
          l3.state != 1 && e28.push(l3);
        } else
          this.startQuery(s3);
    }
    e28.length && this.view.dispatch({ effects: ve$4.of(e28) });
  }
}, {
  eventHandlers: {
    blur(n3) {
      let e28 = this.view.state.field(y$u, false);
      if (e28 && e28.tooltip && this.view.state.facet(m$18).closeOnBlur) {
        let t3 = e28.open && qo$2(this.view, e28.open.tooltip);
        (!t3 || !t3.dom.contains(n3.relatedTarget)) && this.view.dispatch({ effects: M$e.of(null) });
      }
    },
    compositionstart() {
      this.composing = 1;
    },
    compositionend() {
      this.composing == 3 && setTimeout(() => this.view.dispatch({ effects: _$h.of(false) }), 20), this.composing = 0;
    }
  }
}), Oe$3 = /* @__PURE__ */ A$m.baseTheme({
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: "monospace",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li, & > completion-section": {
        padding: "1px 3px",
        lineHeight: 1.2
      },
      "& > li": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer"
      },
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7
      }
    }
  },
  "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#17c",
    color: "white"
  },
  "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#777"
  },
  "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#347",
    color: "white"
  },
  "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#444"
  },
  ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
    content: '"\xB7\xB7\xB7"',
    opacity: 0.5,
    display: "block",
    textAlign: "center"
  },
  ".cm-tooltip.cm-completionInfo": {
    position: "absolute",
    padding: "3px 9px",
    width: "max-content",
    maxWidth: "400px",
    boxSizing: "border-box"
  },
  ".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
  ".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
  ".cm-completionInfo.cm-completionInfo-left-narrow": { right: "30px" },
  ".cm-completionInfo.cm-completionInfo-right-narrow": { left: "30px" },
  "&light .cm-snippetField": { backgroundColor: "#00000022" },
  "&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
  ".cm-snippetFieldPosition": {
    verticalAlign: "text-top",
    width: 0,
    height: "1.15em",
    display: "inline-block",
    margin: "0 -0.7px -.7em",
    borderLeft: "1.4px dotted #888"
  },
  ".cm-completionMatchedText": {
    textDecoration: "underline"
  },
  ".cm-completionDetail": {
    marginLeft: "0.5em",
    fontStyle: "italic"
  },
  ".cm-completionIcon": {
    fontSize: "90%",
    width: ".8em",
    display: "inline-block",
    textAlign: "center",
    paddingRight: ".6em",
    opacity: "0.6",
    boxSizing: "content-box"
  },
  ".cm-completionIcon-function, .cm-completionIcon-method": {
    "&:after": { content: "'\u0192'" }
  },
  ".cm-completionIcon-class": {
    "&:after": { content: "'\u25CB'" }
  },
  ".cm-completionIcon-interface": {
    "&:after": { content: "'\u25CC'" }
  },
  ".cm-completionIcon-variable": {
    "&:after": { content: "'\u{1D465}'" }
  },
  ".cm-completionIcon-constant": {
    "&:after": { content: "'\u{1D436}'" }
  },
  ".cm-completionIcon-type": {
    "&:after": { content: "'\u{1D461}'" }
  },
  ".cm-completionIcon-enum": {
    "&:after": { content: "'\u222A'" }
  },
  ".cm-completionIcon-property": {
    "&:after": { content: "'\u25A1'" }
  },
  ".cm-completionIcon-keyword": {
    "&:after": { content: "'\u{1F511}\uFE0E'" }
  },
  ".cm-completionIcon-namespace": {
    "&:after": { content: "'\u25A2'" }
  },
  ".cm-completionIcon-text": {
    "&:after": { content: "'abc'", fontSize: "50%", verticalAlign: "middle" }
  }
});
class ct$3 {
  constructor(e28, t3, i, o3) {
    this.field = e28, this.line = t3, this.from = i, this.to = o3;
  }
}
class ee$7 {
  constructor(e28, t3, i) {
    this.field = e28, this.from = t3, this.to = i;
  }
  map(e28) {
    let t3 = e28.mapPos(this.from, -1, C$I.TrackDel), i = e28.mapPos(this.to, 1, C$I.TrackDel);
    return t3 == null || i == null ? null : new ee$7(this.field, t3, i);
  }
}
class te$7 {
  constructor(e28, t3) {
    this.lines = e28, this.fieldPositions = t3;
  }
  instantiate(e28, t3) {
    let i = [], o3 = [t3], s3 = e28.doc.lineAt(t3), l3 = /^\s*/.exec(s3.text)[0];
    for (let a3 of this.lines) {
      if (i.length) {
        let c3 = l3, f3 = /^\t*/.exec(a3)[0].length;
        for (let h3 = 0; h3 < f3; h3++)
          c3 += e28.facet(ce$7);
        o3.push(t3 + c3.length - f3), a3 = c3 + a3.slice(f3);
      }
      i.push(a3), t3 += a3.length + 1;
    }
    let r3 = this.fieldPositions.map((a3) => new ee$7(a3.field, o3[a3.line] + a3.from, o3[a3.line] + a3.to));
    return { text: i, ranges: r3 };
  }
  static parse(e28) {
    let t3 = [], i = [], o3 = [], s3;
    for (let l3 of e28.split(/\r\n?|\n/)) {
      for (; s3 = /[#$]\{(?:(\d+)(?::([^}]*))?|([^}]*))\}/.exec(l3); ) {
        let r3 = s3[1] ? +s3[1] : null, a3 = s3[2] || s3[3] || "", c3 = -1;
        for (let f3 = 0; f3 < t3.length; f3++)
          (r3 != null ? t3[f3].seq == r3 : a3 && t3[f3].name == a3) && (c3 = f3);
        if (c3 < 0) {
          let f3 = 0;
          for (; f3 < t3.length && (r3 == null || t3[f3].seq != null && t3[f3].seq < r3); )
            f3++;
          t3.splice(f3, 0, { seq: r3, name: a3 }), c3 = f3;
          for (let h3 of o3)
            h3.field >= c3 && h3.field++;
        }
        o3.push(new ct$3(c3, i.length, s3.index, s3.index + a3.length)), l3 = l3.slice(0, s3.index) + a3 + l3.slice(s3.index + s3[0].length);
      }
      for (let r3; r3 = /\\([{}])/.exec(l3); ) {
        l3 = l3.slice(0, r3.index) + r3[1] + l3.slice(r3.index + r3[0].length);
        for (let a3 of o3)
          a3.line == i.length && a3.from > r3.index && (a3.from--, a3.to--);
      }
      i.push(l3);
    }
    return new te$7(i, o3);
  }
}
let ft$2 = /* @__PURE__ */ V$j.widget({ widget: /* @__PURE__ */ new class extends Nt$4 {
  toDOM() {
    let n3 = document.createElement("span");
    return n3.className = "cm-snippetFieldPosition", n3;
  }
  ignoreEvent() {
    return false;
  }
}() }), ht$4 = /* @__PURE__ */ V$j.mark({ class: "cm-snippetField" });
class D$r {
  constructor(e28, t3) {
    this.ranges = e28, this.active = t3, this.deco = V$j.set(e28.map((i) => (i.from == i.to ? ft$2 : ht$4).range(i.from, i.to)));
  }
  map(e28) {
    let t3 = [];
    for (let i of this.ranges) {
      let o3 = i.map(e28);
      if (!o3)
        return null;
      t3.push(o3);
    }
    return new D$r(t3, this.active);
  }
  selectionInsideField(e28) {
    return e28.ranges.every((t3) => this.ranges.some((i) => i.field == this.active && i.from <= t3.from && i.to >= t3.to));
  }
}
const j$a = /* @__PURE__ */ S$m.define({
  map(n3, e28) {
    return n3 && n3.map(e28);
  }
}), pt$4 = /* @__PURE__ */ S$m.define(), B$k = /* @__PURE__ */ L$s.define({
  create() {
    return null;
  },
  update(n3, e28) {
    for (let t3 of e28.effects) {
      if (t3.is(j$a))
        return t3.value;
      if (t3.is(pt$4) && n3)
        return new D$r(n3.ranges, t3.value);
    }
    return n3 && e28.docChanged && (n3 = n3.map(e28.changes)), n3 && e28.selection && !n3.selectionInsideField(e28.selection) && (n3 = null), n3;
  },
  provide: (n3) => A$m.decorations.from(n3, (e28) => e28 ? e28.deco : V$j.none)
});
function ie$7(n3, e28) {
  return g$K.create(n3.filter((t3) => t3.field == e28).map((t3) => g$K.range(t3.from, t3.to)));
}
function ut$2(n3) {
  let e28 = te$7.parse(n3);
  return (t3, i, o3, s3) => {
    let { text: l3, ranges: r3 } = e28.instantiate(t3.state, o3), a3 = {
      changes: { from: o3, to: s3, insert: x$l.of(l3) },
      scrollIntoView: true,
      annotations: i ? Ce$5.of(i) : void 0
    };
    if (r3.length && (a3.selection = ie$7(r3, 0)), r3.length > 1) {
      let c3 = new D$r(r3, 0), f3 = a3.effects = [j$a.of(c3)];
      t3.state.field(B$k, false) === void 0 && f3.push(S$m.appendConfig.of([B$k, yt$4, xt$3, Oe$3]));
    }
    t3.dispatch(t3.state.update(a3));
  };
}
function Te$4(n3) {
  return ({ state: e28, dispatch: t3 }) => {
    let i = e28.field(B$k, false);
    if (!i || n3 < 0 && i.active == 0)
      return false;
    let o3 = i.active + n3, s3 = n3 > 0 && !i.ranges.some((l3) => l3.field == o3 + n3);
    return t3(e28.update({
      selection: ie$7(i.ranges, o3),
      effects: j$a.of(s3 ? null : new D$r(i.ranges, o3)),
      scrollIntoView: true
    })), true;
  };
}
const dt$4 = ({ state: n3, dispatch: e28 }) => n3.field(B$k, false) ? (e28(n3.update({ effects: j$a.of(null) })), true) : false, mt$4 = /* @__PURE__ */ Te$4(1), gt$4 = /* @__PURE__ */ Te$4(-1), bt$2 = [
  { key: "Tab", run: mt$4, shift: gt$4 },
  { key: "Escape", run: dt$4 }
], he$7 = /* @__PURE__ */ A$o.define({
  combine(n3) {
    return n3.length ? n3[0] : bt$2;
  }
}), yt$4 = /* @__PURE__ */ lt$8.highest(/* @__PURE__ */ Kr$1.compute([he$7], (n3) => n3.facet(he$7)));
function kt$3(n3, e28) {
  return Object.assign(Object.assign({}, e28), { apply: ut$2(n3) });
}
const xt$3 = /* @__PURE__ */ A$m.domEventHandlers({
  mousedown(n3, e28) {
    let t3 = e28.state.field(B$k, false), i;
    if (!t3 || (i = e28.posAtCoords({ x: n3.clientX, y: n3.clientY })) == null)
      return false;
    let o3 = t3.ranges.find((s3) => s3.from <= i && s3.to >= i);
    return !o3 || o3.field == t3.active ? false : (e28.dispatch({
      selection: ie$7(t3.ranges, o3.field),
      effects: j$a.of(t3.ranges.some((s3) => s3.field > o3.field) ? new D$r(t3.ranges, o3.field) : null),
      scrollIntoView: true
    }), true);
  }
}), k$p = {
  brackets: ["(", "[", "{", "'", '"'],
  before: ")]}:;>",
  stringPrefixes: []
}, E$l = /* @__PURE__ */ S$m.define({
  map(n3, e28) {
    let t3 = e28.mapPos(n3, -1, C$I.TrackAfter);
    return t3 != null ? t3 : void 0;
  }
}), ne$9 = /* @__PURE__ */ new class extends Y$h {
}();
ne$9.startSide = 1;
ne$9.endSide = -1;
const Ee$3 = /* @__PURE__ */ L$s.define({
  create() {
    return P$F.empty;
  },
  update(n3, e28) {
    if (e28.selection) {
      let t3 = e28.state.doc.lineAt(e28.selection.main.head).from, i = e28.startState.doc.lineAt(e28.startState.selection.main.head).from;
      t3 != e28.changes.mapPos(i, -1) && (n3 = P$F.empty);
    }
    n3 = n3.map(e28.changes);
    for (let t3 of e28.effects)
      t3.is(E$l) && (n3 = n3.update({ add: [ne$9.range(t3.value, t3.value + 1)] }));
    return n3;
  }
});
function Ft$2() {
  return [Ct$3, Ee$3];
}
const Q$b = "()[]{}<>";
function Pe$4(n3) {
  for (let e28 = 0; e28 < Q$b.length; e28 += 2)
    if (Q$b.charCodeAt(e28) == n3)
      return Q$b.charAt(e28 + 1);
  return rt$7(n3 < 128 ? n3 : n3 + 1);
}
function Ae$3(n3, e28) {
  return n3.languageDataAt("closeBrackets", e28)[0] || k$p;
}
const wt$4 = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent), Ct$3 = /* @__PURE__ */ A$m.inputHandler.of((n3, e28, t3, i) => {
  if ((wt$4 ? n3.composing : n3.compositionStarted) || n3.state.readOnly)
    return false;
  let o3 = n3.state.selection.main;
  if (i.length > 2 || i.length == 2 && xe$a(ne$e(i, 0)) == 1 || e28 != o3.from || t3 != o3.to)
    return false;
  let s3 = St$3(n3.state, i);
  return s3 ? (n3.dispatch(s3), true) : false;
}), vt$2 = ({ state: n3, dispatch: e28 }) => {
  if (n3.readOnly)
    return false;
  let i = Ae$3(n3, n3.selection.main.head).brackets || k$p.brackets, o3 = null, s3 = n3.changeByRange((l3) => {
    if (l3.empty) {
      let r3 = It$3(n3.doc, l3.head);
      for (let a3 of i)
        if (a3 == r3 && H$e(n3.doc, l3.head) == Pe$4(ne$e(a3, 0)))
          return {
            changes: { from: l3.head - a3.length, to: l3.head + a3.length },
            range: g$K.cursor(l3.head - a3.length)
          };
    }
    return { range: o3 = l3 };
  });
  return o3 || e28(n3.update(s3, { scrollIntoView: true, userEvent: "delete.backward" })), !o3;
}, jt$2 = [
  { key: "Backspace", run: vt$2 }
];
function St$3(n3, e28) {
  let t3 = Ae$3(n3, n3.selection.main.head), i = t3.brackets || k$p.brackets;
  for (let o3 of i) {
    let s3 = Pe$4(ne$e(o3, 0));
    if (e28 == o3)
      return s3 == o3 ? Et$3(n3, o3, i.indexOf(o3 + o3 + o3) > -1, t3) : Ot$3(n3, o3, s3, t3.before || k$p.before);
    if (e28 == s3 && Re$5(n3, n3.selection.main.from))
      return Tt$3(n3, o3, s3);
  }
  return null;
}
function Re$5(n3, e28) {
  let t3 = false;
  return n3.field(Ee$3).between(0, n3.doc.length, (i) => {
    i == e28 && (t3 = true);
  }), t3;
}
function H$e(n3, e28) {
  let t3 = n3.sliceString(e28, e28 + 2);
  return t3.slice(0, xe$a(ne$e(t3, 0)));
}
function It$3(n3, e28) {
  let t3 = n3.sliceString(e28 - 2, e28);
  return xe$a(ne$e(t3, 0)) == t3.length ? t3 : t3.slice(1);
}
function Ot$3(n3, e28, t3, i) {
  let o3 = null, s3 = n3.changeByRange((l3) => {
    if (!l3.empty)
      return {
        changes: [{ insert: e28, from: l3.from }, { insert: t3, from: l3.to }],
        effects: E$l.of(l3.to + e28.length),
        range: g$K.range(l3.anchor + e28.length, l3.head + e28.length)
      };
    let r3 = H$e(n3.doc, l3.head);
    return !r3 || /\s/.test(r3) || i.indexOf(r3) > -1 ? {
      changes: { insert: e28 + t3, from: l3.head },
      effects: E$l.of(l3.head + e28.length),
      range: g$K.cursor(l3.head + e28.length)
    } : { range: o3 = l3 };
  });
  return o3 ? null : n3.update(s3, {
    scrollIntoView: true,
    userEvent: "input.type"
  });
}
function Tt$3(n3, e28, t3) {
  let i = null, o3 = n3.changeByRange((s3) => s3.empty && H$e(n3.doc, s3.head) == t3 ? {
    changes: { from: s3.head, to: s3.head + t3.length, insert: t3 },
    range: g$K.cursor(s3.head + t3.length)
  } : i = { range: s3 });
  return i ? null : n3.update(o3, {
    scrollIntoView: true,
    userEvent: "input.type"
  });
}
function Et$3(n3, e28, t3, i) {
  let o3 = i.stringPrefixes || k$p.stringPrefixes, s3 = null, l3 = n3.changeByRange((r3) => {
    if (!r3.empty)
      return {
        changes: [{ insert: e28, from: r3.from }, { insert: e28, from: r3.to }],
        effects: E$l.of(r3.to + e28.length),
        range: g$K.range(r3.anchor + e28.length, r3.head + e28.length)
      };
    let a3 = r3.head, c3 = H$e(n3.doc, a3), f3;
    if (c3 == e28) {
      if (pe$6(n3, a3))
        return {
          changes: { insert: e28 + e28, from: a3 },
          effects: E$l.of(a3 + e28.length),
          range: g$K.cursor(a3 + e28.length)
        };
      if (Re$5(n3, a3)) {
        let p3 = t3 && n3.sliceDoc(a3, a3 + e28.length * 3) == e28 + e28 + e28 ? e28 + e28 + e28 : e28;
        return {
          changes: { from: a3, to: a3 + p3.length, insert: p3 },
          range: g$K.cursor(a3 + p3.length)
        };
      }
    } else {
      if (t3 && n3.sliceDoc(a3 - 2 * e28.length, a3) == e28 + e28 && (f3 = ue$6(n3, a3 - 2 * e28.length, o3)) > -1 && pe$6(n3, f3))
        return {
          changes: { insert: e28 + e28 + e28 + e28, from: a3 },
          effects: E$l.of(a3 + e28.length),
          range: g$K.cursor(a3 + e28.length)
        };
      if (n3.charCategorizer(a3)(c3) != T$x.Word && ue$6(n3, a3, o3) > -1 && !Pt$2(n3, a3, e28, o3))
        return {
          changes: { insert: e28 + e28, from: a3 },
          effects: E$l.of(a3 + e28.length),
          range: g$K.cursor(a3 + e28.length)
        };
    }
    return { range: s3 = r3 };
  });
  return s3 ? null : n3.update(l3, {
    scrollIntoView: true,
    userEvent: "input.type"
  });
}
function pe$6(n3, e28) {
  let t3 = k$t(n3).resolveInner(e28 + 1);
  return t3.parent && t3.from == e28;
}
function Pt$2(n3, e28, t3, i) {
  let o3 = k$t(n3).resolveInner(e28, -1), s3 = i.reduce((l3, r3) => Math.max(l3, r3.length), 0);
  for (let l3 = 0; l3 < 5; l3++) {
    let r3 = n3.sliceDoc(o3.from, Math.min(o3.to, o3.from + t3.length + s3)), a3 = r3.indexOf(t3);
    if (!a3 || a3 > -1 && i.indexOf(r3.slice(0, a3)) > -1) {
      let f3 = o3.firstChild;
      for (; f3 && f3.from == o3.from && f3.to - f3.from > t3.length + a3; ) {
        if (n3.sliceDoc(f3.to - t3.length, f3.to) == t3)
          return false;
        f3 = f3.firstChild;
      }
      return true;
    }
    let c3 = o3.to == e28 && o3.parent;
    if (!c3)
      break;
    o3 = c3;
  }
  return false;
}
function ue$6(n3, e28, t3) {
  let i = n3.charCategorizer(e28);
  if (i(n3.sliceDoc(e28 - 1, e28)) != T$x.Word)
    return e28;
  for (let o3 of t3) {
    let s3 = e28 - o3.length;
    if (n3.sliceDoc(s3, e28) == o3 && i(n3.sliceDoc(s3 - 1, s3)) != T$x.Word)
      return s3;
  }
  return -1;
}
function $t$4(n3 = {}) {
  return [
    y$u,
    m$18.of(n3),
    at$2,
    Rt$2,
    Oe$3
  ];
}
const At$4 = [
  { key: "Ctrl-Space", run: nt$2 },
  { key: "Escape", run: ot$2 },
  { key: "ArrowDown", run: /* @__PURE__ */ U$g(true) },
  { key: "ArrowUp", run: /* @__PURE__ */ U$g(false) },
  { key: "PageDown", run: /* @__PURE__ */ U$g(true, "page") },
  { key: "PageUp", run: /* @__PURE__ */ U$g(false, "page") },
  { key: "Enter", run: it$2 }
], Rt$2 = /* @__PURE__ */ lt$8.highest(/* @__PURE__ */ Kr$1.computeN([m$18], (n3) => n3.facet(m$18).defaultKeymap ? [At$4] : []));
const I$n = [
  /* @__PURE__ */ kt$3("function ${name}(${params}) {\n	${}\n}", {
    label: "function",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3("for (let ${index} = 0; ${index} < ${bound}; ${index}++) {\n	${}\n}", {
    label: "for",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3("for (let ${name} of ${collection}) {\n	${}\n}", {
    label: "for",
    detail: "of loop",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3("do {\n	${}\n} while (${})", {
    label: "do",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3("while (${}) {\n	${}\n}", {
    label: "while",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3(`try {
	\${}
} catch (\${error}) {
	\${}
}`, {
    label: "try",
    detail: "/ catch block",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3("if (${}) {\n	${}\n}", {
    label: "if",
    detail: "block",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3(`if (\${}) {
	\${}
} else {
	\${}
}`, {
    label: "if",
    detail: "/ else block",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3(`class \${name} {
	constructor(\${params}) {
		\${}
	}
}`, {
    label: "class",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3('import {${names}} from "${module}"\n${}', {
    label: "import",
    detail: "named",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3('import ${name} from "${module}"\n${}', {
    label: "import",
    detail: "default",
    type: "keyword"
  })
], q$c = /* @__PURE__ */ I$n.concat([
  /* @__PURE__ */ kt$3("interface ${name} {\n	${}\n}", {
    label: "interface",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3("type ${name} = ${type}", {
    label: "type",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3("enum ${name} {\n	${}\n}", {
    label: "enum",
    detail: "definition",
    type: "keyword"
  })
]), h$X = /* @__PURE__ */ new Me$4(), D$q = /* @__PURE__ */ new Set([
  "Script",
  "Block",
  "FunctionExpression",
  "FunctionDeclaration",
  "ArrowFunction",
  "MethodDeclaration",
  "ForStatement"
]);
function d$$(e28) {
  return (t3, o3) => {
    let n3 = t3.node.getChild("VariableDefinition");
    return n3 && o3(n3, e28), true;
  };
}
const z$b = ["FunctionDeclaration"], G$c = {
  FunctionDeclaration: /* @__PURE__ */ d$$("function"),
  ClassDeclaration: /* @__PURE__ */ d$$("class"),
  ClassExpression: () => true,
  EnumDeclaration: /* @__PURE__ */ d$$("constant"),
  TypeAliasDeclaration: /* @__PURE__ */ d$$("type"),
  NamespaceDeclaration: /* @__PURE__ */ d$$("namespace"),
  VariableDefinition(e28, t3) {
    e28.matchContext(z$b) || t3(e28, "variable");
  },
  TypeDefinition(e28, t3) {
    t3(e28, "type");
  },
  __proto__: null
};
function J$9(e28, t3) {
  let o3 = h$X.get(t3);
  if (o3)
    return o3;
  let n3 = [], l3 = true;
  function u3(a3, s3) {
    let f3 = e28.sliceString(a3.from, a3.to);
    n3.push({ label: f3, type: s3 });
  }
  return t3.cursor(k$v.IncludeAnonymous).iterate((a3) => {
    if (l3)
      l3 = false;
    else if (a3.name) {
      let s3 = G$c[a3.name];
      if (s3 && s3(a3, u3) || D$q.has(a3.name))
        return false;
    } else if (a3.to - a3.from > 8192) {
      for (let s3 of J$9(e28, a3.node))
        n3.push(s3);
      return false;
    }
  }), h$X.set(t3, n3), n3;
}
const k$o = /^[\w$\xa1-\uffff][\w$\d\xa1-\uffff]*$/, X$a = [
  "TemplateString",
  "String",
  "RegExp",
  "LineComment",
  "BlockComment",
  "VariableDefinition",
  "TypeDefinition",
  "Label",
  "PropertyDefinition",
  "PropertyName",
  "PrivatePropertyDefinition",
  "PrivatePropertyName",
  ".",
  "?."
];
function Q$a(e28) {
  let t3 = k$t(e28.state).resolveInner(e28.pos, -1);
  if (X$a.indexOf(t3.name) > -1)
    return null;
  let o3 = t3.name == "VariableName" || t3.to - t3.from < 20 && k$o.test(e28.state.sliceDoc(t3.from, t3.to));
  if (!o3 && !e28.explicit)
    return null;
  let n3 = [];
  for (let l3 = t3; l3; l3 = l3.parent)
    D$q.has(l3.name) && (n3 = n3.concat(J$9(e28.state.doc, l3)));
  return {
    options: n3,
    from: o3 ? t3.from : e28.pos,
    validFor: k$o
  };
}
const p$2P = /* @__PURE__ */ G$h.define({
  name: "javascript",
  parser: /* @__PURE__ */ G$d.configure({
    props: [
      /* @__PURE__ */ ze$4.add({
        IfStatement: /* @__PURE__ */ Et$5({ except: /^\s*({|else\b)/ }),
        TryStatement: /* @__PURE__ */ Et$5({ except: /^\s*({|catch\b|finally\b)/ }),
        LabeledStatement: Nt$3,
        SwitchBody: (e28) => {
          let t3 = e28.textAfter, o3 = /^\s*\}/.test(t3), n3 = /^\s*(case|default)\b/.test(t3);
          return e28.baseIndent + (o3 ? 0 : n3 ? 1 : 2) * e28.unit;
        },
        Block: /* @__PURE__ */ Mt$4({ closing: "}" }),
        ArrowFunction: (e28) => e28.baseIndent + e28.unit,
        "TemplateString BlockComment": () => null,
        "Statement Property": /* @__PURE__ */ Et$5({ except: /^{/ }),
        JSXElement(e28) {
          let t3 = /^\s*<\//.test(e28.textAfter);
          return e28.lineIndent(e28.node.from) + (t3 ? 0 : e28.unit);
        },
        JSXEscape(e28) {
          let t3 = /\s*\}/.test(e28.textAfter);
          return e28.lineIndent(e28.node.from) + (t3 ? 0 : e28.unit);
        },
        "JSXOpenTag JSXSelfClosingTag"(e28) {
          return e28.column(e28.node.from) + e28.unit;
        }
      }),
      /* @__PURE__ */ _e$7.add({
        "Block ClassBody SwitchBody EnumBody ObjectExpression ArrayExpression ObjectType": Ht$3,
        BlockComment(e28) {
          return { from: e28.from + 2, to: e28.to - 2 };
        }
      })
    ]
  }),
  languageData: {
    closeBrackets: { brackets: ["(", "[", "{", "'", '"', "`"] },
    commentTokens: { line: "//", block: { open: "/*", close: "*/" } },
    indentOnInput: /^\s*(?:case |default:|\{|\}|<\/)$/,
    wordChars: "$"
  }
}), v$A = {
  test: (e28) => /^JSX/.test(e28.name),
  facet: /* @__PURE__ */ He$4({ commentTokens: { block: { open: "{/*", close: "*/}" } } })
}, U$f = /* @__PURE__ */ p$2P.configure({ dialect: "ts" }, "typescript"), Y$9 = /* @__PURE__ */ p$2P.configure({
  dialect: "jsx",
  props: [/* @__PURE__ */ Le$3.add((e28) => e28.isTop ? [v$A] : void 0)]
}), Z$9 = /* @__PURE__ */ p$2P.configure({
  dialect: "jsx ts",
  props: [/* @__PURE__ */ Le$3.add((e28) => e28.isTop ? [v$A] : void 0)]
}, "typescript");
let E$k = (e28) => ({ label: e28, type: "keyword" });
const A$f = /* @__PURE__ */ "break case const continue default delete export extends false finally in instanceof let new return static super switch this throw true typeof var yield".split(" ").map(E$k), ee$6 = /* @__PURE__ */ A$f.concat(/* @__PURE__ */ ["declare", "implements", "private", "protected", "public"].map(E$k));
function pe$5(e28 = {}) {
  let t3 = e28.jsx ? e28.typescript ? Z$9 : Y$9 : e28.typescript ? U$f : p$2P, o3 = e28.typescript ? q$c.concat(ee$6) : I$n.concat(A$f);
  return new It$5(t3, [
    p$2P.data.of({
      autocomplete: Bt$2(X$a, We$3(o3))
    }),
    p$2P.data.of({
      autocomplete: Q$a
    }),
    e28.jsx ? ae$7 : []
  ]);
}
function te$6(e28) {
  for (; ; ) {
    if (e28.name == "JSXOpenTag" || e28.name == "JSXSelfClosingTag" || e28.name == "JSXFragmentTag")
      return e28;
    if (e28.name == "JSXEscape" || !e28.parent)
      return null;
    e28 = e28.parent;
  }
}
function w$j(e28, t3, o3 = e28.length) {
  for (let n3 = t3 == null ? void 0 : t3.firstChild; n3; n3 = n3.nextSibling)
    if (n3.name == "JSXIdentifier" || n3.name == "JSXBuiltin" || n3.name == "JSXNamespacedName" || n3.name == "JSXMemberExpression")
      return e28.sliceString(n3.from, Math.min(n3.to, o3));
  return "";
}
const ne$8 = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent), ae$7 = /* @__PURE__ */ A$m.inputHandler.of((e28, t3, o3, n3, l3) => {
  if ((ne$8 ? e28.composing : e28.compositionStarted) || e28.state.readOnly || t3 != o3 || n3 != ">" && n3 != "/" || !p$2P.isActiveAt(e28.state, t3, -1))
    return false;
  let u3 = l3(), { state: a3 } = u3, s3 = a3.changeByRange((f3) => {
    var g3;
    let { head: i } = f3, c3 = k$t(a3).resolveInner(i - 1, -1), y3;
    if (c3.name == "JSXStartTag" && (c3 = c3.parent), !(a3.doc.sliceString(i - 1, i) != n3 || c3.name == "JSXAttributeValue" && c3.to > i)) {
      if (n3 == ">" && c3.name == "JSXFragmentTag")
        return { range: f3, changes: { from: i, insert: "</>" } };
      if (n3 == "/" && c3.name == "JSXStartCloseTag") {
        let m3 = c3.parent, b3 = m3.parent;
        if (b3 && m3.from == i - 2 && ((y3 = w$j(a3.doc, b3.firstChild, i)) || ((g3 = b3.firstChild) === null || g3 === void 0 ? void 0 : g3.name) == "JSXFragmentTag")) {
          let $3 = `${y3}>`;
          return { range: g$K.cursor(i + $3.length, -1), changes: { from: i, insert: $3 } };
        }
      } else if (n3 == ">") {
        let m3 = te$6(c3);
        if (m3 && !/^\/?>|^<\//.test(a3.doc.sliceString(i, i + 2)) && (y3 = w$j(a3.doc, m3, i)))
          return { range: f3, changes: { from: i, insert: `</${y3}>` } };
      }
    }
    return { range: f3 };
  });
  return s3.changes.empty ? false : (e28.dispatch([
    u3,
    a3.update(s3, { userEvent: "input.complete", scrollIntoView: true })
  ]), true);
});
const w$i = ["_blank", "_self", "_top", "_parent"], A$e = ["ascii", "utf-8", "utf-16", "latin1", "latin1"], S$h = ["get", "post", "put", "delete"], N$p = ["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"], m$17 = ["true", "false"], l$_ = {}, ne$7 = {
  a: {
    attrs: {
      href: null,
      ping: null,
      type: null,
      media: null,
      target: w$i,
      hreflang: null
    }
  },
  abbr: l$_,
  address: l$_,
  area: {
    attrs: {
      alt: null,
      coords: null,
      href: null,
      target: null,
      ping: null,
      media: null,
      hreflang: null,
      type: null,
      shape: ["default", "rect", "circle", "poly"]
    }
  },
  article: l$_,
  aside: l$_,
  audio: {
    attrs: {
      src: null,
      mediagroup: null,
      crossorigin: ["anonymous", "use-credentials"],
      preload: ["none", "metadata", "auto"],
      autoplay: ["autoplay"],
      loop: ["loop"],
      controls: ["controls"]
    }
  },
  b: l$_,
  base: { attrs: { href: null, target: w$i } },
  bdi: l$_,
  bdo: l$_,
  blockquote: { attrs: { cite: null } },
  body: l$_,
  br: l$_,
  button: {
    attrs: {
      form: null,
      formaction: null,
      name: null,
      value: null,
      autofocus: ["autofocus"],
      disabled: ["autofocus"],
      formenctype: N$p,
      formmethod: S$h,
      formnovalidate: ["novalidate"],
      formtarget: w$i,
      type: ["submit", "reset", "button"]
    }
  },
  canvas: { attrs: { width: null, height: null } },
  caption: l$_,
  center: l$_,
  cite: l$_,
  code: l$_,
  col: { attrs: { span: null } },
  colgroup: { attrs: { span: null } },
  command: {
    attrs: {
      type: ["command", "checkbox", "radio"],
      label: null,
      icon: null,
      radiogroup: null,
      command: null,
      title: null,
      disabled: ["disabled"],
      checked: ["checked"]
    }
  },
  data: { attrs: { value: null } },
  datagrid: { attrs: { disabled: ["disabled"], multiple: ["multiple"] } },
  datalist: { attrs: { data: null } },
  dd: l$_,
  del: { attrs: { cite: null, datetime: null } },
  details: { attrs: { open: ["open"] } },
  dfn: l$_,
  div: l$_,
  dl: l$_,
  dt: l$_,
  em: l$_,
  embed: { attrs: { src: null, type: null, width: null, height: null } },
  eventsource: { attrs: { src: null } },
  fieldset: { attrs: { disabled: ["disabled"], form: null, name: null } },
  figcaption: l$_,
  figure: l$_,
  footer: l$_,
  form: {
    attrs: {
      action: null,
      name: null,
      "accept-charset": A$e,
      autocomplete: ["on", "off"],
      enctype: N$p,
      method: S$h,
      novalidate: ["novalidate"],
      target: w$i
    }
  },
  h1: l$_,
  h2: l$_,
  h3: l$_,
  h4: l$_,
  h5: l$_,
  h6: l$_,
  head: {
    children: ["title", "base", "link", "style", "meta", "script", "noscript", "command"]
  },
  header: l$_,
  hgroup: l$_,
  hr: l$_,
  html: {
    attrs: { manifest: null }
  },
  i: l$_,
  iframe: {
    attrs: {
      src: null,
      srcdoc: null,
      name: null,
      width: null,
      height: null,
      sandbox: ["allow-top-navigation", "allow-same-origin", "allow-forms", "allow-scripts"],
      seamless: ["seamless"]
    }
  },
  img: {
    attrs: {
      alt: null,
      src: null,
      ismap: null,
      usemap: null,
      width: null,
      height: null,
      crossorigin: ["anonymous", "use-credentials"]
    }
  },
  input: {
    attrs: {
      alt: null,
      dirname: null,
      form: null,
      formaction: null,
      height: null,
      list: null,
      max: null,
      maxlength: null,
      min: null,
      name: null,
      pattern: null,
      placeholder: null,
      size: null,
      src: null,
      step: null,
      value: null,
      width: null,
      accept: ["audio/*", "video/*", "image/*"],
      autocomplete: ["on", "off"],
      autofocus: ["autofocus"],
      checked: ["checked"],
      disabled: ["disabled"],
      formenctype: N$p,
      formmethod: S$h,
      formnovalidate: ["novalidate"],
      formtarget: w$i,
      multiple: ["multiple"],
      readonly: ["readonly"],
      required: ["required"],
      type: [
        "hidden",
        "text",
        "search",
        "tel",
        "url",
        "email",
        "password",
        "datetime",
        "date",
        "month",
        "week",
        "time",
        "datetime-local",
        "number",
        "range",
        "color",
        "checkbox",
        "radio",
        "file",
        "submit",
        "image",
        "reset",
        "button"
      ]
    }
  },
  ins: { attrs: { cite: null, datetime: null } },
  kbd: l$_,
  keygen: {
    attrs: {
      challenge: null,
      form: null,
      name: null,
      autofocus: ["autofocus"],
      disabled: ["disabled"],
      keytype: ["RSA"]
    }
  },
  label: { attrs: { for: null, form: null } },
  legend: l$_,
  li: { attrs: { value: null } },
  link: {
    attrs: {
      href: null,
      type: null,
      hreflang: null,
      media: null,
      sizes: ["all", "16x16", "16x16 32x32", "16x16 32x32 64x64"]
    }
  },
  map: { attrs: { name: null } },
  mark: l$_,
  menu: { attrs: { label: null, type: ["list", "context", "toolbar"] } },
  meta: {
    attrs: {
      content: null,
      charset: A$e,
      name: ["viewport", "application-name", "author", "description", "generator", "keywords"],
      "http-equiv": ["content-language", "content-type", "default-style", "refresh"]
    }
  },
  meter: { attrs: { value: null, min: null, low: null, high: null, max: null, optimum: null } },
  nav: l$_,
  noscript: l$_,
  object: {
    attrs: {
      data: null,
      type: null,
      name: null,
      usemap: null,
      form: null,
      width: null,
      height: null,
      typemustmatch: ["typemustmatch"]
    }
  },
  ol: {
    attrs: { reversed: ["reversed"], start: null, type: ["1", "a", "A", "i", "I"] },
    children: ["li", "script", "template", "ul", "ol"]
  },
  optgroup: { attrs: { disabled: ["disabled"], label: null } },
  option: { attrs: { disabled: ["disabled"], label: null, selected: ["selected"], value: null } },
  output: { attrs: { for: null, form: null, name: null } },
  p: l$_,
  param: { attrs: { name: null, value: null } },
  pre: l$_,
  progress: { attrs: { value: null, max: null } },
  q: { attrs: { cite: null } },
  rp: l$_,
  rt: l$_,
  ruby: l$_,
  samp: l$_,
  script: {
    attrs: {
      type: ["text/javascript"],
      src: null,
      async: ["async"],
      defer: ["defer"],
      charset: A$e
    }
  },
  section: l$_,
  select: {
    attrs: {
      form: null,
      name: null,
      size: null,
      autofocus: ["autofocus"],
      disabled: ["disabled"],
      multiple: ["multiple"]
    }
  },
  slot: { attrs: { name: null } },
  small: l$_,
  source: { attrs: { src: null, type: null, media: null } },
  span: l$_,
  strong: l$_,
  style: {
    attrs: {
      type: ["text/css"],
      media: null,
      scoped: null
    }
  },
  sub: l$_,
  summary: l$_,
  sup: l$_,
  table: l$_,
  tbody: l$_,
  td: { attrs: { colspan: null, rowspan: null, headers: null } },
  template: l$_,
  textarea: {
    attrs: {
      dirname: null,
      form: null,
      maxlength: null,
      name: null,
      placeholder: null,
      rows: null,
      cols: null,
      autofocus: ["autofocus"],
      disabled: ["disabled"],
      readonly: ["readonly"],
      required: ["required"],
      wrap: ["soft", "hard"]
    }
  },
  tfoot: l$_,
  th: { attrs: { colspan: null, rowspan: null, headers: null, scope: ["row", "col", "rowgroup", "colgroup"] } },
  thead: l$_,
  time: { attrs: { datetime: null } },
  title: l$_,
  tr: l$_,
  track: {
    attrs: {
      src: null,
      label: null,
      default: null,
      kind: ["subtitles", "captions", "descriptions", "chapters", "metadata"],
      srclang: null
    }
  },
  ul: { children: ["li", "script", "template", "ul", "ol"] },
  var: l$_,
  video: {
    attrs: {
      src: null,
      poster: null,
      width: null,
      height: null,
      crossorigin: ["anonymous", "use-credentials"],
      preload: ["auto", "metadata", "none"],
      autoplay: ["autoplay"],
      mediagroup: ["movie"],
      muted: ["muted"],
      controls: ["controls"]
    }
  },
  wbr: l$_
}, D$p = {
  accesskey: null,
  class: null,
  contenteditable: m$17,
  contextmenu: null,
  dir: ["ltr", "rtl", "auto"],
  draggable: ["true", "false", "auto"],
  dropzone: ["copy", "move", "link", "string:", "file:"],
  hidden: ["hidden"],
  id: null,
  inert: ["inert"],
  itemid: null,
  itemprop: null,
  itemref: null,
  itemscope: ["itemscope"],
  itemtype: null,
  lang: ["ar", "bn", "de", "en-GB", "en-US", "es", "fr", "hi", "id", "ja", "pa", "pt", "ru", "tr", "zh"],
  spellcheck: m$17,
  autocorrect: m$17,
  autocapitalize: m$17,
  style: null,
  tabindex: null,
  title: null,
  translate: ["yes", "no"],
  rel: ["stylesheet", "alternate", "author", "bookmark", "help", "license", "next", "nofollow", "noreferrer", "prefetch", "prev", "search", "tag"],
  role: /* @__PURE__ */ "alert application article banner button cell checkbox complementary contentinfo dialog document feed figure form grid gridcell heading img list listbox listitem main navigation region row rowgroup search switch tab table tabpanel textbox timer".split(" "),
  "aria-activedescendant": null,
  "aria-atomic": m$17,
  "aria-autocomplete": ["inline", "list", "both", "none"],
  "aria-busy": m$17,
  "aria-checked": ["true", "false", "mixed", "undefined"],
  "aria-controls": null,
  "aria-describedby": null,
  "aria-disabled": m$17,
  "aria-dropeffect": null,
  "aria-expanded": ["true", "false", "undefined"],
  "aria-flowto": null,
  "aria-grabbed": ["true", "false", "undefined"],
  "aria-haspopup": m$17,
  "aria-hidden": m$17,
  "aria-invalid": ["true", "false", "grammar", "spelling"],
  "aria-label": null,
  "aria-labelledby": null,
  "aria-level": null,
  "aria-live": ["off", "polite", "assertive"],
  "aria-multiline": m$17,
  "aria-multiselectable": m$17,
  "aria-owns": null,
  "aria-posinset": null,
  "aria-pressed": ["true", "false", "mixed", "undefined"],
  "aria-readonly": m$17,
  "aria-relevant": null,
  "aria-required": m$17,
  "aria-selected": ["true", "false", "undefined"],
  "aria-setsize": null,
  "aria-sort": ["ascending", "descending", "none", "other"],
  "aria-valuemax": null,
  "aria-valuemin": null,
  "aria-valuenow": null,
  "aria-valuetext": null
}, F$f = /* @__PURE__ */ "beforeunload copy cut dragstart dragover dragleave dragenter dragend drag paste focus blur change click load mousedown mouseenter mouseleave mouseup keydown keyup resize scroll unload".split(" ").map((e28) => "on" + e28);
for (let e28 of F$f)
  D$p[e28] = null;
class T$n {
  constructor(n3, r3) {
    this.tags = Object.assign(Object.assign({}, ne$7), n3), this.globalAttrs = Object.assign(Object.assign({}, D$p), r3), this.allTags = Object.keys(this.tags), this.globalAttrNames = Object.keys(this.globalAttrs);
  }
}
T$n.default = /* @__PURE__ */ new T$n();
function y$t(e28, n3, r3 = e28.length) {
  if (!n3)
    return "";
  let a3 = n3.firstChild, t3 = a3 && a3.getChild("TagName");
  return t3 ? e28.sliceString(t3.from, Math.min(t3.to, r3)) : "";
}
function v$z(e28, n3 = false) {
  for (; e28; e28 = e28.parent)
    if (e28.name == "Element")
      if (n3)
        n3 = false;
      else
        return e28;
  return null;
}
function P$v(e28, n3, r3) {
  let a3 = r3.tags[y$t(e28, v$z(n3))];
  return (a3 == null ? void 0 : a3.children) || r3.allTags;
}
function E$j(e28, n3) {
  let r3 = [];
  for (let a3 = v$z(n3); a3 && !a3.type.isTop; a3 = v$z(a3.parent)) {
    let t3 = y$t(e28, a3);
    if (t3 && a3.lastChild.name == "CloseTag")
      break;
    t3 && r3.indexOf(t3) < 0 && (n3.name == "EndTag" || n3.from >= a3.firstChild.to) && r3.push(t3);
  }
  return r3;
}
const V$f = /^[:\-\.\w\u00b7-\uffff]*$/;
function $$a(e28, n3, r3, a3, t3) {
  let o3 = /\s*>/.test(e28.sliceDoc(t3, t3 + 5)) ? "" : ">", s3 = v$z(r3, true);
  return {
    from: a3,
    to: t3,
    options: P$v(e28.doc, s3, n3).map((u3) => ({ label: u3, type: "type" })).concat(E$j(e28.doc, r3).map((u3, i) => ({
      label: "/" + u3,
      apply: "/" + u3 + o3,
      type: "type",
      boost: 99 - i
    }))),
    validFor: /^\/?[:\-\.\w\u00b7-\uffff]*$/
  };
}
function L$l(e28, n3, r3, a3) {
  let t3 = /\s*>/.test(e28.sliceDoc(a3, a3 + 5)) ? "" : ">";
  return {
    from: r3,
    to: a3,
    options: E$j(e28.doc, n3).map((o3, s3) => ({ label: o3, apply: o3 + t3, type: "type", boost: 99 - s3 })),
    validFor: V$f
  };
}
function re$5(e28, n3, r3, a3) {
  let t3 = [], o3 = 0;
  for (let s3 of P$v(e28.doc, r3, n3))
    t3.push({ label: "<" + s3, type: "type" });
  for (let s3 of E$j(e28.doc, r3))
    t3.push({ label: "</" + s3 + ">", type: "type", boost: 99 - o3++ });
  return { from: a3, to: a3, options: t3, validFor: /^<\/?[:\-\.\w\u00b7-\uffff]*$/ };
}
function se$7(e28, n3, r3, a3, t3) {
  let o3 = v$z(r3), s3 = o3 ? n3.tags[y$t(e28.doc, o3)] : null, u3 = s3 && s3.attrs ? Object.keys(s3.attrs) : [], i = s3 && s3.globalAttrs === false ? u3 : u3.length ? u3.concat(n3.globalAttrNames) : n3.globalAttrNames;
  return {
    from: a3,
    to: t3,
    options: i.map((g3) => ({ label: g3, type: "property" })),
    validFor: V$f
  };
}
function oe$8(e28, n3, r3, a3, t3) {
  var o3;
  let s3 = (o3 = r3.parent) === null || o3 === void 0 ? void 0 : o3.getChild("AttributeName"), u3 = [], i;
  if (s3) {
    let g3 = e28.sliceDoc(s3.from, s3.to), h3 = n3.globalAttrs[g3];
    if (!h3) {
      let c3 = v$z(r3), f3 = c3 ? n3.tags[y$t(e28.doc, c3)] : null;
      h3 = (f3 == null ? void 0 : f3.attrs) && f3.attrs[g3];
    }
    if (h3) {
      let c3 = e28.sliceDoc(a3, t3).toLowerCase(), f3 = '"', d3 = '"';
      /^['"]/.test(c3) ? (i = c3[0] == '"' ? /^[^"]*$/ : /^[^']*$/, f3 = "", d3 = e28.sliceDoc(t3, t3 + 1) == c3[0] ? "" : c3[0], c3 = c3.slice(1), a3++) : i = /^[^\s<>='"]*$/;
      for (let p3 of h3)
        u3.push({ label: p3, apply: f3 + p3 + d3, type: "constant" });
    }
  }
  return { from: a3, to: t3, options: u3, validFor: i };
}
function B$j(e28, n3) {
  let { state: r3, pos: a3 } = n3, t3 = k$t(r3).resolveInner(a3, -1), o3 = t3.resolve(a3);
  for (let s3 = a3, u3; o3 == t3 && (u3 = t3.childBefore(s3)); ) {
    let i = u3.lastChild;
    if (!i || !i.type.isError || i.from < i.to)
      break;
    o3 = t3 = u3, s3 = i.from;
  }
  return t3.name == "TagName" ? t3.parent && /CloseTag$/.test(t3.parent.name) ? L$l(r3, t3, t3.from, a3) : $$a(r3, e28, t3, t3.from, a3) : t3.name == "StartTag" ? $$a(r3, e28, t3, a3, a3) : t3.name == "StartCloseTag" || t3.name == "IncompleteCloseTag" ? L$l(r3, t3, a3, a3) : t3.name == "OpenTag" || t3.name == "SelfClosingTag" || t3.name == "AttributeName" ? se$7(r3, e28, t3, t3.name == "AttributeName" ? t3.from : a3, a3) : t3.name == "Is" || t3.name == "AttributeValue" || t3.name == "UnquotedAttributeValue" ? oe$8(r3, e28, t3, t3.name == "Is" ? a3 : t3.from, a3) : n3.explicit && (o3.name == "Element" || o3.name == "Text" || o3.name == "Document") ? re$5(r3, e28, t3, a3) : null;
}
function be$5(e28) {
  return B$j(T$n.default, e28);
}
function ie$6(e28) {
  let { extraTags: n3, extraGlobalAttributes: r3 } = e28, a3 = r3 || n3 ? new T$n(n3, r3) : T$n.default;
  return (t3) => B$j(a3, t3);
}
const ue$5 = /* @__PURE__ */ p$2P.parser.configure({ top: "SingleExpression" }), M$d = [
  {
    tag: "script",
    attrs: (e28) => e28.type == "text/typescript" || e28.lang == "ts",
    parser: U$f.parser
  },
  {
    tag: "script",
    attrs: (e28) => e28.type == "text/babel" || e28.type == "text/jsx",
    parser: Y$9.parser
  },
  {
    tag: "script",
    attrs: (e28) => e28.type == "text/typescript-jsx",
    parser: Z$9.parser
  },
  {
    tag: "script",
    attrs(e28) {
      return /^(importmap|speculationrules|application\/(.+\+)?json)$/i.test(e28.type);
    },
    parser: ue$5
  },
  {
    tag: "script",
    attrs(e28) {
      return !e28.type || /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i.test(e28.type);
    },
    parser: p$2P.parser
  },
  {
    tag: "style",
    attrs(e28) {
      return (!e28.lang || e28.lang == "css") && (!e28.type || /^(text\/)?(x-)?(stylesheet|css)$/i.test(e28.type));
    },
    parser: g$E.parser
  }
], G$b = /* @__PURE__ */ [
  {
    name: "style",
    parser: /* @__PURE__ */ g$E.parser.configure({ top: "Styles" })
  }
].concat(/* @__PURE__ */ F$f.map((e28) => ({ name: e28, parser: p$2P.parser }))), R$b = /* @__PURE__ */ G$h.define({
  name: "html",
  parser: /* @__PURE__ */ Me$2.configure({
    props: [
      /* @__PURE__ */ ze$4.add({
        Element(e28) {
          let n3 = /^(\s*)(<\/)?/.exec(e28.textAfter);
          return e28.node.to <= e28.pos + n3[0].length ? e28.continue() : e28.lineIndent(e28.node.from) + (n3[2] ? 0 : e28.unit);
        },
        "OpenTag CloseTag SelfClosingTag"(e28) {
          return e28.column(e28.node.from) + e28.unit;
        },
        Document(e28) {
          if (e28.pos + /\s*/.exec(e28.textAfter)[0].length < e28.node.to)
            return e28.continue();
          let n3 = null, r3;
          for (let a3 = e28.node; ; ) {
            let t3 = a3.lastChild;
            if (!t3 || t3.name != "Element" || t3.to != a3.to)
              break;
            n3 = a3 = t3;
          }
          return n3 && !((r3 = n3.lastChild) && (r3.name == "CloseTag" || r3.name == "SelfClosingTag")) ? e28.lineIndent(n3.from) + e28.unit : null;
        }
      }),
      /* @__PURE__ */ _e$7.add({
        Element(e28) {
          let n3 = e28.firstChild, r3 = e28.lastChild;
          return !n3 || n3.name != "OpenTag" ? null : { from: n3.to, to: r3.name == "CloseTag" ? r3.from : e28.to };
        }
      }),
      /* @__PURE__ */ yt$6.add({
        "OpenTag CloseTag": (e28) => e28.getChild("TagName")
      })
    ]
  }),
  languageData: {
    commentTokens: { block: { open: "<!--", close: "-->" } },
    indentOnInput: /^\s*<\/\w+\W$/,
    wordChars: "-._"
  }
}), k$n = /* @__PURE__ */ R$b.configure({
  wrap: /* @__PURE__ */ Re$6(M$d, G$b)
});
function ye$6(e28 = {}) {
  let n3 = "", r3;
  e28.matchClosingTags === false && (n3 = "noMatch"), e28.selfClosingTags === true && (n3 = (n3 ? n3 + " " : "") + "selfClosing"), (e28.nestedLanguages && e28.nestedLanguages.length || e28.nestedAttributes && e28.nestedAttributes.length) && (r3 = Re$6((e28.nestedLanguages || []).concat(M$d), (e28.nestedAttributes || []).concat(G$b)));
  let a3 = r3 ? R$b.configure({ wrap: r3, dialect: n3 }) : n3 ? k$n.configure({ dialect: n3 }) : k$n;
  return new It$5(a3, [
    k$n.data.of({ autocomplete: ie$6(e28) }),
    e28.autoCloseTags !== false ? de$7 : [],
    pe$5().support,
    Z$b().support
  ]);
}
const I$m = /* @__PURE__ */ new Set(/* @__PURE__ */ "area base br col command embed frame hr img input keygen link meta param source track wbr menuitem".split(" ")), de$7 = /* @__PURE__ */ A$m.inputHandler.of((e28, n3, r3, a3, t3) => {
  if (e28.composing || e28.state.readOnly || n3 != r3 || a3 != ">" && a3 != "/" || !k$n.isActiveAt(e28.state, n3, -1))
    return false;
  let o3 = t3(), { state: s3 } = o3, u3 = s3.changeByRange((i) => {
    var g3, h3, c3;
    let f3 = s3.doc.sliceString(i.from - 1, i.to) == a3, { head: d3 } = i, p3 = k$t(s3).resolveInner(d3 - 1, -1), b3;
    if ((p3.name == "TagName" || p3.name == "StartTag") && (p3 = p3.parent), f3 && a3 == ">" && p3.name == "OpenTag") {
      if (((h3 = (g3 = p3.parent) === null || g3 === void 0 ? void 0 : g3.lastChild) === null || h3 === void 0 ? void 0 : h3.name) != "CloseTag" && (b3 = y$t(s3.doc, p3.parent, d3)) && !I$m.has(b3)) {
        let C3 = d3 + (s3.doc.sliceString(d3, d3 + 1) === ">" ? 1 : 0), x3 = `</${b3}>`;
        return { range: i, changes: { from: d3, to: C3, insert: x3 } };
      }
    } else if (f3 && a3 == "/" && p3.name == "IncompleteCloseTag") {
      let C3 = p3.parent;
      if (p3.from == d3 - 2 && ((c3 = C3.lastChild) === null || c3 === void 0 ? void 0 : c3.name) != "CloseTag" && (b3 = y$t(s3.doc, C3, d3)) && !I$m.has(b3)) {
        let x3 = d3 + (s3.doc.sliceString(d3, d3 + 1) === ">" ? 1 : 0), O3 = `${b3}>`;
        return {
          range: g$K.cursor(d3 + O3.length, -1),
          changes: { from: d3, to: x3, insert: O3 }
        };
      }
    }
    return { range: i };
  });
  return u3.changes.empty ? false : (e28.dispatch([
    o3,
    s3.update(u3, {
      userEvent: "input.complete",
      scrollIntoView: true
    })
  ]), true);
});
const D$o = [
  /* @__PURE__ */ kt$3("function ${name}(${params}) {\n	${}\n}", {
    label: "function",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3("for (let ${index} = 0; ${index} < ${bound}; ${index}++) {\n	${}\n}", {
    label: "for",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3("for (let ${name} of ${collection}) {\n	${}\n}", {
    label: "for",
    detail: "of loop",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3("do {\n	${}\n} while (${})", {
    label: "do",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3("while (${}) {\n	${}\n}", {
    label: "while",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3(`try {
	\${}
} catch (\${error}) {
	\${}
}`, {
    label: "try",
    detail: "/ catch block",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3("if (${}) {\n	${}\n}", {
    label: "if",
    detail: "block",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3(`if (\${}) {
	\${}
} else {
	\${}
}`, {
    label: "if",
    detail: "/ else block",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3(`class \${name} {
	constructor(\${params}) {
		\${}
	}
}`, {
    label: "class",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3('import {${names}} from "${module}"\n${}', {
    label: "import",
    detail: "named",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3('import ${name} from "${module}"\n${}', {
    label: "import",
    detail: "default",
    type: "keyword"
  })
], q$b = /* @__PURE__ */ D$o.concat([
  /* @__PURE__ */ kt$3("interface ${name} {\n	${}\n}", {
    label: "interface",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3("type ${name} = ${type}", {
    label: "type",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ kt$3("enum ${name} {\n	${}\n}", {
    label: "enum",
    detail: "definition",
    type: "keyword"
  })
]), C$C = /* @__PURE__ */ new Me$4(), J$8 = /* @__PURE__ */ new Set([
  "Script",
  "Block",
  "FunctionExpression",
  "FunctionDeclaration",
  "ArrowFunction",
  "MethodDeclaration",
  "ForStatement"
]);
function y$s(e28) {
  return (t3, r3) => {
    let n3 = t3.node.getChild("VariableDefinition");
    return n3 && r3(n3, e28), true;
  };
}
const G$a = ["FunctionDeclaration"], Q$9 = {
  FunctionDeclaration: /* @__PURE__ */ y$s("function"),
  ClassDeclaration: /* @__PURE__ */ y$s("class"),
  ClassExpression: () => true,
  EnumDeclaration: /* @__PURE__ */ y$s("constant"),
  TypeAliasDeclaration: /* @__PURE__ */ y$s("type"),
  NamespaceDeclaration: /* @__PURE__ */ y$s("namespace"),
  VariableDefinition(e28, t3) {
    e28.matchContext(G$a) || t3(e28, "variable");
  },
  TypeDefinition(e28, t3) {
    t3(e28, "type");
  },
  __proto__: null
};
function X$9(e28, t3) {
  let r3 = C$C.get(t3);
  if (r3)
    return r3;
  let n3 = [], a3 = true;
  function i(o3, l3) {
    let c3 = e28.sliceString(o3.from, o3.to);
    n3.push({ label: c3, type: l3 });
  }
  return t3.cursor(k$v.IncludeAnonymous).iterate((o3) => {
    if (a3)
      a3 = false;
    else if (o3.name) {
      let l3 = Q$9[o3.name];
      if (l3 && l3(o3, i) || J$8.has(o3.name))
        return false;
    } else if (o3.to - o3.from > 8192) {
      for (let l3 of X$9(e28, o3.node))
        n3.push(l3);
      return false;
    }
  }), C$C.set(t3, n3), n3;
}
const h$W = /^[\w$\xa1-\uffff][\w$\d\xa1-\uffff]*$/, k$m = [
  "TemplateString",
  "String",
  "RegExp",
  "LineComment",
  "BlockComment",
  "VariableDefinition",
  "TypeDefinition",
  "Label",
  "PropertyDefinition",
  "PropertyName",
  "PrivatePropertyDefinition",
  "PrivatePropertyName",
  ".",
  "?."
];
function U$e(e28) {
  let t3 = k$t(e28.state).resolveInner(e28.pos, -1);
  if (k$m.indexOf(t3.name) > -1)
    return null;
  let r3 = t3.name == "VariableName" || t3.to - t3.from < 20 && h$W.test(e28.state.sliceDoc(t3.from, t3.to));
  if (!r3 && !e28.explicit)
    return null;
  let n3 = [];
  for (let a3 = t3; a3; a3 = a3.parent)
    J$8.has(a3.name) && (n3 = n3.concat(X$9(e28.state.doc, a3)));
  return {
    options: n3,
    from: r3 ? t3.from : e28.pos,
    validFor: h$W
  };
}
function $$9(e28, t3, r3) {
  var n3;
  let a3 = [];
  for (; ; ) {
    let i = t3.firstChild, o3;
    if ((i == null ? void 0 : i.name) == "VariableName")
      return a3.push(e28(i)), { path: a3.reverse(), name: r3 };
    if ((i == null ? void 0 : i.name) == "MemberExpression" && ((n3 = o3 = i.lastChild) === null || n3 === void 0 ? void 0 : n3.name) == "PropertyName")
      a3.push(e28(o3)), t3 = i;
    else
      return null;
  }
}
function Y$8(e28) {
  let t3 = (n3) => e28.state.doc.sliceString(n3.from, n3.to), r3 = k$t(e28.state).resolveInner(e28.pos, -1);
  return r3.name == "PropertyName" ? $$9(t3, r3.parent, t3(r3)) : (r3.name == "." || r3.name == "?.") && r3.parent.name == "MemberExpression" ? $$9(t3, r3.parent, "") : k$m.indexOf(r3.name) > -1 ? null : r3.name == "VariableName" || r3.to - r3.from < 20 && h$W.test(t3(r3)) ? { path: [], name: t3(r3) } : r3.name == "MemberExpression" ? $$9(t3, r3, "") : e28.explicit ? { path: [], name: "" } : null;
}
function ee$5(e28, t3) {
  let r3 = [], n3 = /* @__PURE__ */ new Set();
  for (let a3 = 0; ; a3++) {
    for (let o3 of (Object.getOwnPropertyNames || Object.keys)(e28)) {
      if (!/^[a-zA-Z_$\xaa-\uffdc][\w$\xaa-\uffdc]*$/.test(o3) || n3.has(o3))
        continue;
      n3.add(o3);
      let l3;
      try {
        l3 = e28[o3];
      } catch {
        continue;
      }
      r3.push({
        label: o3,
        type: typeof l3 == "function" ? /^[A-Z]/.test(o3) ? "class" : t3 ? "function" : "method" : t3 ? "variable" : "property",
        boost: -a3
      });
    }
    let i = Object.getPrototypeOf(e28);
    if (!i)
      return r3;
    e28 = i;
  }
}
function ye$5(e28) {
  let t3 = /* @__PURE__ */ new Map();
  return (r3) => {
    let n3 = Y$8(r3);
    if (!n3)
      return null;
    let a3 = e28;
    for (let o3 of n3.path)
      if (a3 = a3[o3], !a3)
        return null;
    let i = t3.get(a3);
    return i || t3.set(a3, i = ee$5(a3, !n3.path.length)), {
      from: r3.pos - n3.name.length,
      options: i,
      validFor: h$W
    };
  };
}
const m$16 = /* @__PURE__ */ G$h.define({
  name: "javascript",
  parser: /* @__PURE__ */ G$d.configure({
    props: [
      /* @__PURE__ */ ze$4.add({
        IfStatement: /* @__PURE__ */ Et$5({ except: /^\s*({|else\b)/ }),
        TryStatement: /* @__PURE__ */ Et$5({ except: /^\s*({|catch\b|finally\b)/ }),
        LabeledStatement: Nt$3,
        SwitchBody: (e28) => {
          let t3 = e28.textAfter, r3 = /^\s*\}/.test(t3), n3 = /^\s*(case|default)\b/.test(t3);
          return e28.baseIndent + (r3 ? 0 : n3 ? 1 : 2) * e28.unit;
        },
        Block: /* @__PURE__ */ Mt$4({ closing: "}" }),
        ArrowFunction: (e28) => e28.baseIndent + e28.unit,
        "TemplateString BlockComment": () => null,
        "Statement Property": /* @__PURE__ */ Et$5({ except: /^{/ }),
        JSXElement(e28) {
          let t3 = /^\s*<\//.test(e28.textAfter);
          return e28.lineIndent(e28.node.from) + (t3 ? 0 : e28.unit);
        },
        JSXEscape(e28) {
          let t3 = /\s*\}/.test(e28.textAfter);
          return e28.lineIndent(e28.node.from) + (t3 ? 0 : e28.unit);
        },
        "JSXOpenTag JSXSelfClosingTag"(e28) {
          return e28.column(e28.node.from) + e28.unit;
        }
      }),
      /* @__PURE__ */ _e$7.add({
        "Block ClassBody SwitchBody EnumBody ObjectExpression ArrayExpression ObjectType": Ht$3,
        BlockComment(e28) {
          return { from: e28.from + 2, to: e28.to - 2 };
        }
      })
    ]
  }),
  languageData: {
    closeBrackets: { brackets: ["(", "[", "{", "'", '"', "`"] },
    commentTokens: { line: "//", block: { open: "/*", close: "*/" } },
    indentOnInput: /^\s*(?:case |default:|\{|\}|<\/)$/,
    wordChars: "$"
  }
}), E$i = {
  test: (e28) => /^JSX/.test(e28.name),
  facet: /* @__PURE__ */ He$4({ commentTokens: { block: { open: "{/*", close: "*/}" } } })
}, te$5 = /* @__PURE__ */ m$16.configure({ dialect: "ts" }, "typescript"), ne$6 = /* @__PURE__ */ m$16.configure({
  dialect: "jsx",
  props: [/* @__PURE__ */ Le$3.add((e28) => e28.isTop ? [E$i] : void 0)]
}), re$4 = /* @__PURE__ */ m$16.configure({
  dialect: "jsx ts",
  props: [/* @__PURE__ */ Le$3.add((e28) => e28.isTop ? [E$i] : void 0)]
}, "typescript");
let N$o = (e28) => ({ label: e28, type: "keyword" });
const P$u = /* @__PURE__ */ "break case const continue default delete export extends false finally in instanceof let new return static super switch this throw true typeof var yield".split(" ").map(N$o), oe$7 = /* @__PURE__ */ P$u.concat(/* @__PURE__ */ ["declare", "implements", "private", "protected", "public"].map(N$o));
function ge$5(e28 = {}) {
  let t3 = e28.jsx ? e28.typescript ? re$4 : ne$6 : e28.typescript ? te$5 : m$16, r3 = e28.typescript ? q$b.concat(oe$7) : D$o.concat(P$u);
  return new It$5(t3, [
    m$16.data.of({
      autocomplete: Bt$2(k$m, We$3(r3))
    }),
    m$16.data.of({
      autocomplete: U$e
    }),
    e28.jsx ? le$5 : []
  ]);
}
function ae$6(e28) {
  for (; ; ) {
    if (e28.name == "JSXOpenTag" || e28.name == "JSXSelfClosingTag" || e28.name == "JSXFragmentTag")
      return e28;
    if (e28.name == "JSXEscape" || !e28.parent)
      return null;
    e28 = e28.parent;
  }
}
function T$m(e28, t3, r3 = e28.length) {
  for (let n3 = t3 == null ? void 0 : t3.firstChild; n3; n3 = n3.nextSibling)
    if (n3.name == "JSXIdentifier" || n3.name == "JSXBuiltin" || n3.name == "JSXNamespacedName" || n3.name == "JSXMemberExpression")
      return e28.sliceString(n3.from, Math.min(n3.to, r3));
  return "";
}
const ie$5 = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent), le$5 = /* @__PURE__ */ A$m.inputHandler.of((e28, t3, r3, n3, a3) => {
  if ((ie$5 ? e28.composing : e28.compositionStarted) || e28.state.readOnly || t3 != r3 || n3 != ">" && n3 != "/" || !m$16.isActiveAt(e28.state, t3, -1))
    return false;
  let i = a3(), { state: o3 } = i, l3 = o3.changeByRange((c3) => {
    var u3;
    let { head: s3 } = c3, f3 = k$t(o3).resolveInner(s3 - 1, -1), g3;
    if (f3.name == "JSXStartTag" && (f3 = f3.parent), !(o3.doc.sliceString(s3 - 1, s3) != n3 || f3.name == "JSXAttributeValue" && f3.to > s3)) {
      if (n3 == ">" && f3.name == "JSXFragmentTag")
        return { range: c3, changes: { from: s3, insert: "</>" } };
      if (n3 == "/" && f3.name == "JSXStartCloseTag") {
        let d3 = f3.parent, b3 = d3.parent;
        if (b3 && d3.from == s3 - 2 && ((g3 = T$m(o3.doc, b3.firstChild, s3)) || ((u3 = b3.firstChild) === null || u3 === void 0 ? void 0 : u3.name) == "JSXFragmentTag")) {
          let v3 = `${g3}>`;
          return { range: g$K.cursor(s3 + v3.length, -1), changes: { from: s3, insert: v3 } };
        }
      } else if (n3 == ">") {
        let d3 = ae$6(f3);
        if (d3 && d3.name == "JSXOpenTag" && !/^\/?>|^<\//.test(o3.doc.sliceString(s3, s3 + 2)) && (g3 = T$m(o3.doc, d3, s3)))
          return { range: c3, changes: { from: s3, insert: `</${g3}>` } };
      }
    }
    return { range: c3 };
  });
  return l3.changes.empty ? false : (e28.dispatch([
    i,
    o3.update(l3, { userEvent: "input.complete", scrollIntoView: true })
  ]), true);
});
function he$6(e28, t3) {
  return t3 || (t3 = {
    parserOptions: { ecmaVersion: 2019, sourceType: "module" },
    env: { browser: true, node: true, es6: true, es2015: true, es2017: true, es2020: true },
    rules: {}
  }, e28.getRules().forEach((r3, n3) => {
    r3.meta.docs.recommended && (t3.rules[n3] = 2);
  })), (r3) => {
    let { state: n3 } = r3, a3 = [];
    for (let { from: i, to: o3 } of m$16.findRegions(n3)) {
      let l3 = n3.doc.lineAt(i), c3 = { line: l3.number - 1, col: i - l3.from, pos: i };
      for (let u3 of e28.verify(n3.sliceDoc(i, o3), t3))
        a3.push(se$6(u3, n3.doc, c3));
    }
    return a3;
  };
}
function I$l(e28, t3, r3, n3) {
  return r3.line(e28 + n3.line).from + t3 + (e28 == 1 ? n3.col - 1 : -1);
}
function se$6(e28, t3, r3) {
  let n3 = I$l(e28.line, e28.column, t3, r3), a3 = {
    from: n3,
    to: e28.endLine != null && e28.endColumn != 1 ? I$l(e28.endLine, e28.endColumn, t3, r3) : n3,
    message: e28.message,
    source: e28.ruleId ? "eslint:" + e28.ruleId : "eslint",
    severity: e28.severity == 1 ? "warning" : "error"
  };
  if (e28.fix) {
    let { range: i, text: o3 } = e28.fix, l3 = i[0] + r3.pos - n3, c3 = i[1] + r3.pos - n3;
    a3.actions = [{
      name: "fix",
      apply(u3, s3) {
        u3.dispatch({ changes: { from: s3 + l3, to: s3 + c3, insert: o3 }, scrollIntoView: true });
      }
    }];
  }
  return a3;
}
const Q$8 = $$d({
  String: n$J.string,
  Number: n$J.number,
  "True False": n$J.bool,
  PropertyName: n$J.propertyName,
  Null: n$J.null,
  ",": n$J.separator,
  "[ ]": n$J.squareBracket,
  "{ }": n$J.brace
}), o$S = w$m.deserialize({
  version: 14,
  states: "$bOVQPOOOOQO'#Cb'#CbOnQPO'#CeOvQPO'#CjOOQO'#Cp'#CpQOQPOOOOQO'#Cg'#CgO}QPO'#CfO!SQPO'#CrOOQO,59P,59PO![QPO,59PO!aQPO'#CuOOQO,59U,59UO!iQPO,59UOVQPO,59QOqQPO'#CkO!nQPO,59^OOQO1G.k1G.kOVQPO'#ClO!vQPO,59aOOQO1G.p1G.pOOQO1G.l1G.lOOQO,59V,59VOOQO-E6i-E6iOOQO,59W,59WOOQO-E6j-E6j",
  stateData: "#O~OcOS~OQSORSOSSOTSOWQO]ROePO~OVXOeUO~O[[O~PVOg^O~Oh_OVfX~OVaO~OhbO[iX~O[dO~Oh_OVfa~OhbO[ia~O",
  goto: "!kjPPPPPPkPPkqwPPk{!RPPP!XP!ePP!hXSOR^bQWQRf_TVQ_Q`WRg`QcZRicQTOQZRQe^RhbRYQR]R",
  nodeNames: "\u26A0 JsonText True False Null Number String } { Object Property PropertyName ] [ Array",
  maxTerm: 25,
  nodeProps: [
    ["openedBy", 7, "{", 12, "["],
    ["closedBy", 8, "}", 13, "]"]
  ],
  propSources: [Q$8],
  skippedNodes: [0],
  repeatNodeCount: 2,
  tokenData: "(|~RaXY!WYZ!W]^!Wpq!Wrs!]|}$u}!O$z!Q!R%T!R![&c![!]&t!}#O&y#P#Q'O#Y#Z'T#b#c'r#h#i(Z#o#p(r#q#r(w~!]Oc~~!`Wpq!]qr!]rs!xs#O!]#O#P!}#P;'S!];'S;=`$o<%lO!]~!}Oe~~#QXrs!]!P!Q!]#O#P!]#U#V!]#Y#Z!]#b#c!]#f#g!]#h#i!]#i#j#m~#pR!Q![#y!c!i#y#T#Z#y~#|R!Q![$V!c!i$V#T#Z$V~$YR!Q![$c!c!i$c#T#Z$c~$fR!Q![!]!c!i!]#T#Z!]~$rP;=`<%l!]~$zOh~~$}Q!Q!R%T!R![&c~%YRT~!O!P%c!g!h%w#X#Y%w~%fP!Q![%i~%nRT~!Q![%i!g!h%w#X#Y%w~%zR{|&T}!O&T!Q![&Z~&WP!Q![&Z~&`PT~!Q![&Z~&hST~!O!P%c!Q![&c!g!h%w#X#Y%w~&yOg~~'OO]~~'TO[~~'WP#T#U'Z~'^P#`#a'a~'dP#g#h'g~'jP#X#Y'm~'rOR~~'uP#i#j'x~'{P#`#a(O~(RP#`#a(U~(ZOS~~(^P#f#g(a~(dP#i#j(g~(jP#X#Y(m~(rOQ~~(wOW~~(|OV~",
  tokenizers: [0],
  topRules: { JsonText: [0, 1] },
  tokenPrec: 0
});
const f$K = () => (n3) => {
  try {
    JSON.parse(n3.state.doc.toString());
  } catch (e28) {
    if (!(e28 instanceof SyntaxError))
      throw e28;
    const t3 = g$C(e28, n3.state.doc);
    return [{
      from: t3,
      message: e28.message,
      severity: "error",
      to: t3
    }];
  }
  return [];
};
function g$C(n3, e28) {
  let t3;
  return (t3 = n3.message.match(/at position (\d+)/)) ? Math.min(+t3[1], e28.length) : (t3 = n3.message.match(/at line (\d+) column (\d+)/)) ? Math.min(e28.line(+t3[1]).from + +t3[2] - 1, e28.length) : 0;
}
const m$15 = /* @__PURE__ */ G$h.define({
  name: "json",
  parser: /* @__PURE__ */ o$S.configure({
    props: [
      /* @__PURE__ */ ze$4.add({
        Object: /* @__PURE__ */ Et$5({ except: /^\s*\}/ }),
        Array: /* @__PURE__ */ Et$5({ except: /^\s*\]/ })
      }),
      /* @__PURE__ */ _e$7.add({
        "Object Array": Ht$3
      })
    ]
  }),
  languageData: {
    closeBrackets: { brackets: ["[", "{", '"'] },
    indentOnInput: /^\s*[\}\]]$/
  }
});
function l$Z() {
  return new It$5(m$15);
}
function s$13() {
  var r3 = arguments[0];
  typeof r3 == "string" && (r3 = document.createElement(r3));
  var e28 = 1, t3 = arguments[1];
  if (t3 && typeof t3 == "object" && t3.nodeType == null && !Array.isArray(t3)) {
    for (var n3 in t3)
      if (Object.prototype.hasOwnProperty.call(t3, n3)) {
        var o3 = t3[n3];
        typeof o3 == "string" ? r3.setAttribute(n3, o3) : o3 != null && (r3[n3] = o3);
      }
    e28++;
  }
  for (; e28 < arguments.length; e28++)
    f$J(r3, arguments[e28]);
  return r3;
}
function f$J(r3, e28) {
  if (typeof e28 == "string")
    r3.appendChild(document.createTextNode(e28));
  else if (e28 != null)
    if (e28.nodeType != null)
      r3.appendChild(e28);
    else if (Array.isArray(e28))
      for (var t3 = 0; t3 < e28.length; t3++)
        f$J(r3, e28[t3]);
    else
      throw new RangeError("Unsupported child node: " + e28);
}
class ee$4 {
  constructor(e28, n3, i) {
    this.from = e28, this.to = n3, this.diagnostic = i;
  }
}
class u$Z {
  constructor(e28, n3, i) {
    this.diagnostics = e28, this.panel = n3, this.selected = i;
  }
  static init(e28, n3, i) {
    let o3 = e28, s3 = i.facet(h$V).markerFilter;
    s3 && (o3 = s3(o3));
    let l3 = V$j.set(o3.map((r3) => r3.from == r3.to || r3.from == r3.to - 1 && i.doc.lineAt(r3.from).to == r3.from ? V$j.widget({
      widget: new le$4(r3),
      diagnostic: r3
    }).range(r3.from) : V$j.mark({
      attributes: { class: "cm-lintRange cm-lintRange-" + r3.severity + (r3.markClass ? " " + r3.markClass : "") },
      diagnostic: r3
    }).range(r3.from, r3.to)), true);
    return new u$Z(l3, n3, b$w(l3));
  }
}
function b$w(t3, e28 = null, n3 = 0) {
  let i = null;
  return t3.between(n3, 1e9, (o3, s3, { spec: l3 }) => {
    if (!(e28 && l3.diagnostic != e28))
      return i = new ee$4(o3, s3, l3.diagnostic), false;
  }), i;
}
function B$i(t3, e28) {
  let n3 = t3.startState.doc.lineAt(e28.pos);
  return !!(t3.effects.some((i) => i.is(v$y)) || t3.changes.touchesRange(n3.from, n3.to));
}
function O$l(t3, e28) {
  return t3.field(f$I, false) ? e28 : e28.concat(S$m.appendConfig.of(Y$7));
}
function te$4(t3, e28) {
  return {
    effects: O$l(t3, [v$y.of(e28)])
  };
}
const v$y = /* @__PURE__ */ S$m.define(), R$a = /* @__PURE__ */ S$m.define(), G$9 = /* @__PURE__ */ S$m.define(), f$I = /* @__PURE__ */ L$s.define({
  create() {
    return new u$Z(V$j.none, null, null);
  },
  update(t3, e28) {
    if (e28.docChanged) {
      let n3 = t3.diagnostics.map(e28.changes), i = null;
      if (t3.selected) {
        let o3 = e28.changes.mapPos(t3.selected.from, 1);
        i = b$w(n3, t3.selected.diagnostic, o3) || b$w(n3, null, o3);
      }
      t3 = new u$Z(n3, t3.panel, i);
    }
    for (let n3 of e28.effects)
      n3.is(v$y) ? t3 = u$Z.init(n3.value, t3.panel, e28.state) : n3.is(R$a) ? t3 = new u$Z(t3.diagnostics, n3.value ? C$B.open : null, t3.selected) : n3.is(G$9) && (t3 = new u$Z(t3.diagnostics, t3.panel, n3.value));
    return t3;
  },
  provide: (t3) => [
    Yi$1.from(t3, (e28) => e28.panel),
    A$m.decorations.from(t3, (e28) => e28.diagnostics)
  ]
}), ie$4 = /* @__PURE__ */ V$j.mark({ class: "cm-lintRange cm-lintRange-active" });
function ne$5(t3, e28, n3) {
  let { diagnostics: i } = t3.state.field(f$I), o3 = [], s3 = 2e8, l3 = 0;
  i.between(e28 - (n3 < 0 ? 1 : 0), e28 + (n3 > 0 ? 1 : 0), (c3, d3, { spec: a3 }) => {
    e28 >= c3 && e28 <= d3 && (c3 == d3 || (e28 > c3 || n3 > 0) && (e28 < d3 || n3 < 0)) && (o3.push(a3.diagnostic), s3 = Math.min(c3, s3), l3 = Math.max(d3, l3));
  });
  let r3 = t3.state.facet(h$V).tooltipFilter;
  return r3 && (o3 = r3(o3)), o3.length ? {
    pos: s3,
    end: l3,
    above: t3.state.doc.lineAt(s3).to < l3,
    create() {
      return { dom: j$9(t3, o3) };
    }
  } : null;
}
function j$9(t3, e28) {
  return s$13("ul", { class: "cm-tooltip-lint" }, e28.map((n3) => $$8(t3, n3, false)));
}
const oe$6 = (t3) => {
  let e28 = t3.state.field(f$I, false);
  (!e28 || !e28.panel) && t3.dispatch({ effects: O$l(t3.state, [R$a.of(true)]) });
  let n3 = jo$2(t3, C$B.open);
  return n3 && n3.dom.querySelector(".cm-panel-lint ul").focus(), true;
}, D$n = (t3) => {
  let e28 = t3.state.field(f$I, false);
  return !e28 || !e28.panel ? false : (t3.dispatch({ effects: R$a.of(false) }), true);
}, se$5 = (t3) => {
  let e28 = t3.state.field(f$I, false);
  if (!e28)
    return false;
  let n3 = t3.state.selection.main, i = e28.diagnostics.iter(n3.to + 1);
  return !i.value && (i = e28.diagnostics.iter(0), !i.value || i.from == n3.from && i.to == n3.to) ? false : (t3.dispatch({ selection: { anchor: i.from, head: i.to }, scrollIntoView: true }), true);
}, we$5 = [
  { key: "Mod-Shift-m", run: oe$6, preventDefault: true },
  { key: "F8", run: se$5 }
], re$3 = /* @__PURE__ */ z$i.fromClass(class {
  constructor(t3) {
    this.view = t3, this.timeout = -1, this.set = true;
    let { delay: e28 } = t3.state.facet(h$V);
    this.lintTime = Date.now() + e28, this.run = this.run.bind(this), this.timeout = setTimeout(this.run, e28);
  }
  run() {
    let t3 = Date.now();
    if (t3 < this.lintTime - 10)
      this.timeout = setTimeout(this.run, this.lintTime - t3);
    else {
      this.set = false;
      let { state: e28 } = this.view, { sources: n3 } = e28.facet(h$V);
      Promise.all(n3.map((i) => Promise.resolve(i(this.view)))).then((i) => {
        let o3 = i.reduce((s3, l3) => s3.concat(l3));
        this.view.state.doc == e28.doc && this.view.dispatch(te$4(this.view.state, o3));
      }, (i) => {
        ct$6(this.view.state, i);
      });
    }
  }
  update(t3) {
    let e28 = t3.state.facet(h$V);
    (t3.docChanged || e28 != t3.startState.facet(h$V) || e28.needsRefresh && e28.needsRefresh(t3)) && (this.lintTime = Date.now() + e28.delay, this.set || (this.set = true, this.timeout = setTimeout(this.run, e28.delay)));
  }
  force() {
    this.set && (this.lintTime = Date.now(), this.run());
  }
  destroy() {
    clearTimeout(this.timeout);
  }
}), h$V = /* @__PURE__ */ A$o.define({
  combine(t3) {
    return Object.assign({ sources: t3.map((e28) => e28.source) }, ht$7(t3.map((e28) => e28.config), {
      delay: 750,
      markerFilter: null,
      tooltipFilter: null,
      needsRefresh: null
    }, {
      needsRefresh: (e28, n3) => e28 ? n3 ? (i) => e28(i) || n3(i) : e28 : n3
    }));
  }
});
function ke$4(t3, e28 = {}) {
  return [
    h$V.of({ source: t3, config: e28 }),
    re$3,
    Y$7
  ];
}
function H$d(t3) {
  let e28 = [];
  if (t3)
    e:
      for (let { name: n3 } of t3) {
        for (let i = 0; i < n3.length; i++) {
          let o3 = n3[i];
          if (/[a-zA-Z]/.test(o3) && !e28.some((s3) => s3.toLowerCase() == o3.toLowerCase())) {
            e28.push(o3);
            continue e;
          }
        }
        e28.push("");
      }
  return e28;
}
function $$8(t3, e28, n3) {
  var i;
  let o3 = n3 ? H$d(e28.actions) : [];
  return s$13("li", { class: "cm-diagnostic cm-diagnostic-" + e28.severity }, s$13("span", { class: "cm-diagnosticText" }, e28.renderMessage ? e28.renderMessage() : e28.message), (i = e28.actions) === null || i === void 0 ? void 0 : i.map((s3, l3) => {
    let r3 = false, c3 = (_3) => {
      if (_3.preventDefault(), r3)
        return;
      r3 = true;
      let S3 = b$w(t3.state.field(f$I).diagnostics, e28);
      S3 && s3.apply(t3, S3.from, S3.to);
    }, { name: d3 } = s3, a3 = o3[l3] ? d3.indexOf(o3[l3]) : -1, p3 = a3 < 0 ? d3 : [
      d3.slice(0, a3),
      s$13("u", d3.slice(a3, a3 + 1)),
      d3.slice(a3 + 1)
    ];
    return s$13("button", {
      type: "button",
      class: "cm-diagnosticAction",
      onclick: c3,
      onmousedown: c3,
      "aria-label": ` Action: ${d3}${a3 < 0 ? "" : ` (access key "${o3[l3]})"`}.`
    }, p3);
  }), e28.source && s$13("div", { class: "cm-diagnosticSource" }, e28.source));
}
class le$4 extends Nt$4 {
  constructor(e28) {
    super(), this.diagnostic = e28;
  }
  eq(e28) {
    return e28.diagnostic == this.diagnostic;
  }
  toDOM() {
    return s$13("span", { class: "cm-lintPoint cm-lintPoint-" + this.diagnostic.severity });
  }
}
class A$d {
  constructor(e28, n3) {
    this.diagnostic = n3, this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16), this.dom = $$8(e28, n3, true), this.dom.id = this.id, this.dom.setAttribute("role", "option");
  }
}
class C$B {
  constructor(e28) {
    this.view = e28, this.items = [];
    let n3 = (o3) => {
      if (o3.keyCode == 27)
        D$n(this.view), this.view.focus();
      else if (o3.keyCode == 38 || o3.keyCode == 33)
        this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
      else if (o3.keyCode == 40 || o3.keyCode == 34)
        this.moveSelection((this.selectedIndex + 1) % this.items.length);
      else if (o3.keyCode == 36)
        this.moveSelection(0);
      else if (o3.keyCode == 35)
        this.moveSelection(this.items.length - 1);
      else if (o3.keyCode == 13)
        this.view.focus();
      else if (o3.keyCode >= 65 && o3.keyCode <= 90 && this.selectedIndex >= 0) {
        let { diagnostic: s3 } = this.items[this.selectedIndex], l3 = H$d(s3.actions);
        for (let r3 = 0; r3 < l3.length; r3++)
          if (l3[r3].toUpperCase().charCodeAt(0) == o3.keyCode) {
            let c3 = b$w(this.view.state.field(f$I).diagnostics, s3);
            c3 && s3.actions[r3].apply(e28, c3.from, c3.to);
          }
      } else
        return;
      o3.preventDefault();
    }, i = (o3) => {
      for (let s3 = 0; s3 < this.items.length; s3++)
        this.items[s3].dom.contains(o3.target) && this.moveSelection(s3);
    };
    this.list = s$13("ul", {
      tabIndex: 0,
      role: "listbox",
      "aria-label": this.view.state.phrase("Diagnostics"),
      onkeydown: n3,
      onclick: i
    }), this.dom = s$13("div", { class: "cm-panel-lint" }, this.list, s$13("button", {
      type: "button",
      name: "close",
      "aria-label": this.view.state.phrase("close"),
      onclick: () => D$n(this.view)
    }, "\xD7")), this.update();
  }
  get selectedIndex() {
    let e28 = this.view.state.field(f$I).selected;
    if (!e28)
      return -1;
    for (let n3 = 0; n3 < this.items.length; n3++)
      if (this.items[n3].diagnostic == e28.diagnostic)
        return n3;
    return -1;
  }
  update() {
    let { diagnostics: e28, selected: n3 } = this.view.state.field(f$I), i = 0, o3 = false, s3 = null;
    for (e28.between(0, this.view.state.doc.length, (l3, r3, { spec: c3 }) => {
      let d3 = -1, a3;
      for (let p3 = i; p3 < this.items.length; p3++)
        if (this.items[p3].diagnostic == c3.diagnostic) {
          d3 = p3;
          break;
        }
      d3 < 0 ? (a3 = new A$d(this.view, c3.diagnostic), this.items.splice(i, 0, a3), o3 = true) : (a3 = this.items[d3], d3 > i && (this.items.splice(i, d3 - i), o3 = true)), n3 && a3.diagnostic == n3.diagnostic ? a3.dom.hasAttribute("aria-selected") || (a3.dom.setAttribute("aria-selected", "true"), s3 = a3) : a3.dom.hasAttribute("aria-selected") && a3.dom.removeAttribute("aria-selected"), i++;
    }); i < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0); )
      o3 = true, this.items.pop();
    this.items.length == 0 && (this.items.push(new A$d(this.view, {
      from: -1,
      to: -1,
      severity: "info",
      message: this.view.state.phrase("No diagnostics")
    })), o3 = true), s3 ? (this.list.setAttribute("aria-activedescendant", s3.id), this.view.requestMeasure({
      key: this,
      read: () => ({ sel: s3.dom.getBoundingClientRect(), panel: this.list.getBoundingClientRect() }),
      write: ({ sel: l3, panel: r3 }) => {
        let c3 = r3.height / this.list.offsetHeight;
        l3.top < r3.top ? this.list.scrollTop -= (r3.top - l3.top) / c3 : l3.bottom > r3.bottom && (this.list.scrollTop += (l3.bottom - r3.bottom) / c3);
      }
    })) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), o3 && this.sync();
  }
  sync() {
    let e28 = this.list.firstChild;
    function n3() {
      let i = e28;
      e28 = i.nextSibling, i.remove();
    }
    for (let i of this.items)
      if (i.dom.parentNode == this.list) {
        for (; e28 != i.dom; )
          n3();
        e28 = i.dom.nextSibling;
      } else
        this.list.insertBefore(i.dom, e28);
    for (; e28; )
      n3();
  }
  moveSelection(e28) {
    if (this.selectedIndex < 0)
      return;
    let n3 = this.view.state.field(f$I), i = b$w(n3.diagnostics, this.items[e28].diagnostic);
    i && this.view.dispatch({
      selection: { anchor: i.from, head: i.to },
      scrollIntoView: true,
      effects: G$9.of(i)
    });
  }
  static open(e28) {
    return new C$B(e28);
  }
}
function x$h(t3, e28 = 'viewBox="0 0 40 40"') {
  return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${e28}>${encodeURIComponent(t3)}</svg>')`;
}
function k$l(t3) {
  return x$h(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${t3}" fill="none" stroke-width=".7"/>`, 'width="6" height="3"');
}
const ae$5 = /* @__PURE__ */ A$m.baseTheme({
  ".cm-diagnostic": {
    padding: "3px 6px 3px 8px",
    marginLeft: "-1px",
    display: "block",
    whiteSpace: "pre-wrap"
  },
  ".cm-diagnostic-error": { borderLeft: "5px solid #d11" },
  ".cm-diagnostic-warning": { borderLeft: "5px solid orange" },
  ".cm-diagnostic-info": { borderLeft: "5px solid #999" },
  ".cm-diagnostic-hint": { borderLeft: "5px solid #66d" },
  ".cm-diagnosticAction": {
    font: "inherit",
    border: "none",
    padding: "2px 4px",
    backgroundColor: "#444",
    color: "white",
    borderRadius: "3px",
    marginLeft: "8px",
    cursor: "pointer"
  },
  ".cm-diagnosticSource": {
    fontSize: "70%",
    opacity: 0.7
  },
  ".cm-lintRange": {
    backgroundPosition: "left bottom",
    backgroundRepeat: "repeat-x",
    paddingBottom: "0.7px"
  },
  ".cm-lintRange-error": { backgroundImage: /* @__PURE__ */ k$l("#d11") },
  ".cm-lintRange-warning": { backgroundImage: /* @__PURE__ */ k$l("orange") },
  ".cm-lintRange-info": { backgroundImage: /* @__PURE__ */ k$l("#999") },
  ".cm-lintRange-hint": { backgroundImage: /* @__PURE__ */ k$l("#66d") },
  ".cm-lintRange-active": { backgroundColor: "#ffdd9980" },
  ".cm-tooltip-lint": {
    padding: 0,
    margin: 0
  },
  ".cm-lintPoint": {
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "-2px",
      borderLeft: "3px solid transparent",
      borderRight: "3px solid transparent",
      borderBottom: "4px solid #d11"
    }
  },
  ".cm-lintPoint-warning": {
    "&:after": { borderBottomColor: "orange" }
  },
  ".cm-lintPoint-info": {
    "&:after": { borderBottomColor: "#999" }
  },
  ".cm-lintPoint-hint": {
    "&:after": { borderBottomColor: "#66d" }
  },
  ".cm-panel.cm-panel-lint": {
    position: "relative",
    "& ul": {
      maxHeight: "100px",
      overflowY: "auto",
      "& [aria-selected]": {
        backgroundColor: "#ddd",
        "& u": { textDecoration: "underline" }
      },
      "&:focus [aria-selected]": {
        background_fallback: "#bdf",
        backgroundColor: "Highlight",
        color_fallback: "white",
        color: "HighlightText"
      },
      "& u": { textDecoration: "none" },
      padding: 0,
      margin: 0
    },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "2px",
      background: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    }
  }
});
function I$k(t3) {
  return t3 == "error" ? 4 : t3 == "warning" ? 3 : t3 == "info" ? 2 : 1;
}
class ce$4 extends lt$7 {
  constructor(e28) {
    super(), this.diagnostics = e28, this.severity = e28.reduce((n3, i) => I$k(n3) < I$k(i.severity) ? i.severity : n3, "hint");
  }
  toDOM(e28) {
    let n3 = document.createElement("div");
    n3.className = "cm-lint-marker cm-lint-marker-" + this.severity;
    let i = this.diagnostics, o3 = e28.state.facet(T$l).tooltipFilter;
    return o3 && (i = o3(i)), i.length && (n3.onmouseover = () => fe$4(e28, n3, i)), n3;
  }
}
function de$6(t3, e28) {
  let n3 = (i) => {
    let o3 = e28.getBoundingClientRect();
    if (!(i.clientX > o3.left - 10 && i.clientX < o3.right + 10 && i.clientY > o3.top - 10 && i.clientY < o3.bottom + 10)) {
      for (let s3 = i.target; s3; s3 = s3.parentNode)
        if (s3.nodeType == 1 && s3.classList.contains("cm-tooltip-lint"))
          return;
      window.removeEventListener("mousemove", n3), t3.state.field(V$e) && t3.dispatch({ effects: L$k.of(null) });
    }
  };
  window.addEventListener("mousemove", n3);
}
function fe$4(t3, e28, n3) {
  function i() {
    let l3 = t3.elementAtHeight(e28.getBoundingClientRect().top + 5 - t3.documentTop);
    t3.coordsAtPos(l3.from) && t3.dispatch({ effects: L$k.of({
      pos: l3.from,
      above: false,
      create() {
        return {
          dom: j$9(t3, n3),
          getCoords: () => e28.getBoundingClientRect()
        };
      }
    }) }), e28.onmouseout = e28.onmousemove = null, de$6(t3, e28);
  }
  let { hoverTime: o3 } = t3.state.facet(T$l), s3 = setTimeout(i, o3);
  e28.onmouseout = () => {
    clearTimeout(s3), e28.onmouseout = e28.onmousemove = null;
  }, e28.onmousemove = () => {
    clearTimeout(s3), s3 = setTimeout(i, o3);
  };
}
function me$7(t3, e28) {
  let n3 = /* @__PURE__ */ Object.create(null);
  for (let o3 of e28) {
    let s3 = t3.lineAt(o3.from);
    (n3[s3.from] || (n3[s3.from] = [])).push(o3);
  }
  let i = [];
  for (let o3 in n3)
    i.push(new ce$4(n3[o3]).range(+o3));
  return P$F.of(i, true);
}
const ue$4 = /* @__PURE__ */ Yo$1({
  class: "cm-gutter-lint",
  markers: (t3) => t3.state.field(N$n)
}), N$n = /* @__PURE__ */ L$s.define({
  create() {
    return P$F.empty;
  },
  update(t3, e28) {
    t3 = t3.map(e28.changes);
    let n3 = e28.state.facet(T$l).markerFilter;
    for (let i of e28.effects)
      if (i.is(v$y)) {
        let o3 = i.value;
        n3 && (o3 = n3(o3 || [])), t3 = me$7(e28.state.doc, o3.slice(0));
      }
    return t3;
  }
}), L$k = /* @__PURE__ */ S$m.define(), V$e = /* @__PURE__ */ L$s.define({
  create() {
    return null;
  },
  update(t3, e28) {
    return t3 && e28.docChanged && (t3 = B$i(e28, t3) ? null : Object.assign(Object.assign({}, t3), { pos: e28.changes.mapPos(t3.pos) })), e28.effects.reduce((n3, i) => i.is(L$k) ? i.value : n3, t3);
  },
  provide: (t3) => sn$3.from(t3)
}), he$5 = /* @__PURE__ */ A$m.baseTheme({
  ".cm-gutter-lint": {
    width: "1.4em",
    "& .cm-gutterElement": {
      padding: ".2em"
    }
  },
  ".cm-lint-marker": {
    width: "1em",
    height: "1em"
  },
  ".cm-lint-marker-info": {
    content: /* @__PURE__ */ x$h('<path fill="#aaf" stroke="#77e" stroke-width="6" stroke-linejoin="round" d="M5 5L35 5L35 35L5 35Z"/>')
  },
  ".cm-lint-marker-warning": {
    content: /* @__PURE__ */ x$h('<path fill="#fe8" stroke="#fd7" stroke-width="6" stroke-linejoin="round" d="M20 6L37 35L3 35Z"/>')
  },
  ".cm-lint-marker-error": {
    content: /* @__PURE__ */ x$h('<circle cx="20" cy="20" r="15" fill="#f87" stroke="#f43" stroke-width="6"/>')
  }
}), Y$7 = [
  f$I,
  /* @__PURE__ */ A$m.decorations.compute([f$I], (t3) => {
    let { selected: e28, panel: n3 } = t3.field(f$I);
    return !e28 || !n3 || e28.from == e28.to ? V$j.none : V$j.set([
      ie$4.range(e28.from, e28.to)
    ]);
  }),
  /* @__PURE__ */ Ko$1(ne$5, { hideOn: B$i }),
  ae$5
], T$l = /* @__PURE__ */ A$o.define({
  combine(t3) {
    return ht$7(t3, {
      hoverTime: 300,
      markerFilter: null,
      tooltipFilter: null
    });
  }
});
function xe$4(t3 = {}) {
  return [T$l.of(t3), N$n, ue$4, he$5, V$e];
}
const J$7 = typeof String.prototype.normalize == "function" ? (t3) => t3.normalize("NFKD") : (t3) => t3;
class b$v {
  constructor(e28, r3, n3 = 0, i = e28.length, s3, l3) {
    this.test = l3, this.value = { from: 0, to: 0 }, this.done = false, this.matches = [], this.buffer = "", this.bufferPos = 0, this.iter = e28.iterRange(n3, i), this.bufferStart = n3, this.normalize = s3 ? (o3) => s3(J$7(o3)) : J$7, this.query = this.normalize(r3);
  }
  peek() {
    if (this.bufferPos == this.buffer.length) {
      if (this.bufferStart += this.buffer.length, this.iter.next(), this.iter.done)
        return -1;
      this.bufferPos = 0, this.buffer = this.iter.value;
    }
    return ne$e(this.buffer, this.bufferPos);
  }
  next() {
    for (; this.matches.length; )
      this.matches.pop();
    return this.nextOverlapping();
  }
  nextOverlapping() {
    for (; ; ) {
      let e28 = this.peek();
      if (e28 < 0)
        return this.done = true, this;
      let r3 = rt$7(e28), n3 = this.bufferStart + this.bufferPos;
      this.bufferPos += xe$a(e28);
      let i = this.normalize(r3);
      for (let s3 = 0, l3 = n3; ; s3++) {
        let o3 = i.charCodeAt(s3), c3 = this.match(o3, l3);
        if (s3 == i.length - 1) {
          if (c3)
            return this.value = c3, this;
          break;
        }
        l3 == n3 && s3 < r3.length && r3.charCodeAt(s3) == o3 && l3++;
      }
    }
  }
  match(e28, r3) {
    let n3 = null;
    for (let i = 0; i < this.matches.length; i += 2) {
      let s3 = this.matches[i], l3 = false;
      this.query.charCodeAt(s3) == e28 && (s3 == this.query.length - 1 ? n3 = { from: this.matches[i + 1], to: r3 + 1 } : (this.matches[i]++, l3 = true)), l3 || (this.matches.splice(i, 2), i -= 2);
    }
    return this.query.charCodeAt(0) == e28 && (this.query.length == 1 ? n3 = { from: r3, to: r3 + 1 } : this.matches.push(1, r3)), n3 && this.test && !this.test(n3.from, n3.to, this.buffer, this.bufferStart) && (n3 = null), n3;
  }
}
typeof Symbol < "u" && (b$v.prototype[Symbol.iterator] = function() {
  return this;
});
const se$4 = { from: -1, to: -1, match: /* @__PURE__ */ /.*/.exec("") }, N$m = "gm" + (/x/.unicode == null ? "" : "u");
class le$3 {
  constructor(e28, r3, n3, i = 0, s3 = e28.length) {
    if (this.text = e28, this.to = s3, this.curLine = "", this.done = false, this.value = se$4, /\\[sWDnr]|\n|\r|\[\^/.test(r3))
      return new oe$5(e28, r3, n3, i, s3);
    this.re = new RegExp(r3, N$m + (n3 != null && n3.ignoreCase ? "i" : "")), this.test = n3 == null ? void 0 : n3.test, this.iter = e28.iter();
    let l3 = e28.lineAt(i);
    this.curLineStart = l3.from, this.matchPos = q$a(e28, i), this.getLine(this.curLineStart);
  }
  getLine(e28) {
    this.iter.next(e28), this.iter.lineBreak ? this.curLine = "" : (this.curLine = this.iter.value, this.curLineStart + this.curLine.length > this.to && (this.curLine = this.curLine.slice(0, this.to - this.curLineStart)), this.iter.next());
  }
  nextLine() {
    this.curLineStart = this.curLineStart + this.curLine.length + 1, this.curLineStart > this.to ? this.curLine = "" : this.getLine(0);
  }
  next() {
    for (let e28 = this.matchPos - this.curLineStart; ; ) {
      this.re.lastIndex = e28;
      let r3 = this.matchPos <= this.to && this.re.exec(this.curLine);
      if (r3) {
        let n3 = this.curLineStart + r3.index, i = n3 + r3[0].length;
        if (this.matchPos = q$a(this.text, i + (n3 == i ? 1 : 0)), n3 == this.curLineStart + this.curLine.length && this.nextLine(), (n3 < i || n3 > this.value.to) && (!this.test || this.test(n3, i, r3)))
          return this.value = { from: n3, to: i, match: r3 }, this;
        e28 = this.matchPos - this.curLineStart;
      } else if (this.curLineStart + this.curLine.length < this.to)
        this.nextLine(), e28 = 0;
      else
        return this.done = true, this;
    }
  }
}
const Q$7 = /* @__PURE__ */ new WeakMap();
class v$x {
  constructor(e28, r3) {
    this.from = e28, this.text = r3;
  }
  get to() {
    return this.from + this.text.length;
  }
  static get(e28, r3, n3) {
    let i = Q$7.get(e28);
    if (!i || i.from >= n3 || i.to <= r3) {
      let o3 = new v$x(r3, e28.sliceString(r3, n3));
      return Q$7.set(e28, o3), o3;
    }
    if (i.from == r3 && i.to == n3)
      return i;
    let { text: s3, from: l3 } = i;
    return l3 > r3 && (s3 = e28.sliceString(r3, l3) + s3, l3 = r3), i.to < n3 && (s3 += e28.sliceString(i.to, n3)), Q$7.set(e28, new v$x(l3, s3)), new v$x(r3, s3.slice(r3 - l3, n3 - l3));
  }
}
class oe$5 {
  constructor(e28, r3, n3, i, s3) {
    this.text = e28, this.to = s3, this.done = false, this.value = se$4, this.matchPos = q$a(e28, i), this.re = new RegExp(r3, N$m + (n3 != null && n3.ignoreCase ? "i" : "")), this.test = n3 == null ? void 0 : n3.test, this.flat = v$x.get(e28, i, this.chunkEnd(i + 5e3));
  }
  chunkEnd(e28) {
    return e28 >= this.to ? this.to : this.text.lineAt(e28).to;
  }
  next() {
    for (; ; ) {
      let e28 = this.re.lastIndex = this.matchPos - this.flat.from, r3 = this.re.exec(this.flat.text);
      if (r3 && !r3[0] && r3.index == e28 && (this.re.lastIndex = e28 + 1, r3 = this.re.exec(this.flat.text)), r3) {
        let n3 = this.flat.from + r3.index, i = n3 + r3[0].length;
        if ((this.flat.to >= this.to || r3.index + r3[0].length <= this.flat.text.length - 10) && (!this.test || this.test(n3, i, r3)))
          return this.value = { from: n3, to: i, match: r3 }, this.matchPos = q$a(this.text, i + (n3 == i ? 1 : 0)), this;
      }
      if (this.flat.to == this.to)
        return this.done = true, this;
      this.flat = v$x.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
    }
  }
}
typeof Symbol < "u" && (le$3.prototype[Symbol.iterator] = oe$5.prototype[Symbol.iterator] = function() {
  return this;
});
function be$4(t3) {
  try {
    return new RegExp(t3, N$m), true;
  } catch {
    return false;
  }
}
function q$a(t3, e28) {
  if (e28 >= t3.length)
    return e28;
  let r3 = t3.lineAt(e28), n3;
  for (; e28 < r3.to && (n3 = r3.text.charCodeAt(e28 - r3.from)) >= 56320 && n3 < 57344; )
    e28++;
  return e28;
}
function _$g(t3) {
  let e28 = String(t3.state.doc.lineAt(t3.state.selection.main.head).number), r3 = s$13("input", { class: "cm-textfield", name: "line", value: e28 }), n3 = s$13("form", {
    class: "cm-gotoLine",
    onkeydown: (s3) => {
      s3.keyCode == 27 ? (s3.preventDefault(), t3.dispatch({ effects: P$t.of(false) }), t3.focus()) : s3.keyCode == 13 && (s3.preventDefault(), i());
    },
    onsubmit: (s3) => {
      s3.preventDefault(), i();
    }
  }, s$13("label", t3.state.phrase("Go to line"), ": ", r3), " ", s$13("button", { class: "cm-button", type: "submit" }, t3.state.phrase("go")));
  function i() {
    let s3 = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(r3.value);
    if (!s3)
      return;
    let { state: l3 } = t3, o3 = l3.doc.lineAt(l3.selection.main.head), [, c3, a3, u3, g3] = s3, A3 = u3 ? +u3.slice(1) : 0, k3 = a3 ? +a3 : o3.number;
    if (a3 && g3) {
      let O3 = k3 / 100;
      c3 && (O3 = O3 * (c3 == "-" ? -1 : 1) + o3.number / l3.doc.lines), k3 = Math.round(l3.doc.lines * O3);
    } else
      a3 && c3 && (k3 = k3 * (c3 == "-" ? -1 : 1) + o3.number);
    let G3 = l3.doc.line(Math.max(1, Math.min(l3.doc.lines, k3))), j3 = g$K.cursor(G3.from + Math.max(0, Math.min(A3, G3.length)));
    t3.dispatch({
      effects: [P$t.of(false), A$m.scrollIntoView(j3.from, { y: "center" })],
      selection: j3
    }), t3.focus();
  }
  return { dom: n3 };
}
const P$t = /* @__PURE__ */ S$m.define(), U$d = /* @__PURE__ */ L$s.define({
  create() {
    return true;
  },
  update(t3, e28) {
    for (let r3 of e28.effects)
      r3.is(P$t) && (t3 = r3.value);
    return t3;
  },
  provide: (t3) => Yi$1.from(t3, (e28) => e28 ? _$g : null)
}), Ce$4 = (t3) => {
  let e28 = jo$2(t3, _$g);
  if (!e28) {
    let r3 = [P$t.of(true)];
    t3.state.field(U$d, false) == null && r3.push(S$m.appendConfig.of([U$d, ke$3])), t3.dispatch({ effects: r3 }), e28 = jo$2(t3, _$g);
  }
  return e28 && e28.dom.querySelector("input").select(), true;
}, ke$3 = /* @__PURE__ */ A$m.baseTheme({
  ".cm-panel.cm-gotoLine": {
    padding: "2px 6px 4px",
    "& label": { fontSize: "80%" }
  }
}), Le$1 = {
  highlightWordAroundCursor: false,
  minSelectionLength: 1,
  maxMatches: 100,
  wholeWords: false
}, ce$3 = /* @__PURE__ */ A$o.define({
  combine(t3) {
    return ht$7(t3, Le$1, {
      highlightWordAroundCursor: (e28, r3) => e28 || r3,
      minSelectionLength: Math.min,
      maxMatches: Math.min
    });
  }
});
function Ue$1(t3) {
  let e28 = [Ee$2, De$1];
  return t3 && e28.push(ce$3.of(t3)), e28;
}
const We$2 = /* @__PURE__ */ V$j.mark({ class: "cm-selectionMatch" }), Fe$4 = /* @__PURE__ */ V$j.mark({ class: "cm-selectionMatch cm-selectionMatch-main" });
function X$8(t3, e28, r3, n3) {
  return (r3 == 0 || t3(e28.sliceDoc(r3 - 1, r3)) != T$x.Word) && (n3 == e28.doc.length || t3(e28.sliceDoc(n3, n3 + 1)) != T$x.Word);
}
function Ae$2(t3, e28, r3, n3) {
  return t3(e28.sliceDoc(r3, r3 + 1)) == T$x.Word && t3(e28.sliceDoc(n3 - 1, n3)) == T$x.Word;
}
const De$1 = /* @__PURE__ */ z$i.fromClass(class {
  constructor(t3) {
    this.decorations = this.getDeco(t3);
  }
  update(t3) {
    (t3.selectionSet || t3.docChanged || t3.viewportChanged) && (this.decorations = this.getDeco(t3.view));
  }
  getDeco(t3) {
    let e28 = t3.state.facet(ce$3), { state: r3 } = t3, n3 = r3.selection;
    if (n3.ranges.length > 1)
      return V$j.none;
    let i = n3.main, s3, l3 = null;
    if (i.empty) {
      if (!e28.highlightWordAroundCursor)
        return V$j.none;
      let c3 = r3.wordAt(i.head);
      if (!c3)
        return V$j.none;
      l3 = r3.charCategorizer(i.head), s3 = r3.sliceDoc(c3.from, c3.to);
    } else {
      let c3 = i.to - i.from;
      if (c3 < e28.minSelectionLength || c3 > 200)
        return V$j.none;
      if (e28.wholeWords) {
        if (s3 = r3.sliceDoc(i.from, i.to), l3 = r3.charCategorizer(i.head), !(X$8(l3, r3, i.from, i.to) && Ae$2(l3, r3, i.from, i.to)))
          return V$j.none;
      } else if (s3 = r3.sliceDoc(i.from, i.to).trim(), !s3)
        return V$j.none;
    }
    let o3 = [];
    for (let c3 of t3.visibleRanges) {
      let a3 = new b$v(r3.doc, s3, c3.from, c3.to);
      for (; !a3.next().done; ) {
        let { from: u3, to: g3 } = a3.value;
        if ((!l3 || X$8(l3, r3, u3, g3)) && (i.empty && u3 <= i.from && g3 >= i.to ? o3.push(Fe$4.range(u3, g3)) : (u3 >= i.to || g3 <= i.from) && o3.push(We$2.range(u3, g3)), o3.length > e28.maxMatches))
          return V$j.none;
      }
    }
    return V$j.set(o3);
  }
}, {
  decorations: (t3) => t3.decorations
}), Ee$2 = /* @__PURE__ */ A$m.baseTheme({
  ".cm-selectionMatch": { backgroundColor: "#99ff7780" },
  ".cm-searchMatch .cm-selectionMatch": { backgroundColor: "transparent" }
}), Re$4 = ({ state: t3, dispatch: e28 }) => {
  let { selection: r3 } = t3, n3 = g$K.create(r3.ranges.map((i) => t3.wordAt(i.head) || g$K.cursor(i.head)), r3.mainIndex);
  return n3.eq(r3) ? false : (e28(t3.update({ selection: n3 })), true);
};
function qe$1(t3, e28) {
  let { main: r3, ranges: n3 } = t3.selection, i = t3.wordAt(r3.head), s3 = i && i.from == r3.from && i.to == r3.to;
  for (let l3 = false, o3 = new b$v(t3.doc, e28, n3[n3.length - 1].to); ; )
    if (o3.next(), o3.done) {
      if (l3)
        return null;
      o3 = new b$v(t3.doc, e28, 0, Math.max(0, n3[n3.length - 1].from - 1)), l3 = true;
    } else {
      if (l3 && n3.some((c3) => c3.from == o3.value.from))
        continue;
      if (s3) {
        let c3 = t3.wordAt(o3.value.from);
        if (!c3 || c3.from != o3.value.from || c3.to != o3.value.to)
          continue;
      }
      return o3.value;
    }
}
const Pe$3 = ({ state: t3, dispatch: e28 }) => {
  let { ranges: r3 } = t3.selection;
  if (r3.some((s3) => s3.from === s3.to))
    return Re$4({ state: t3, dispatch: e28 });
  let n3 = t3.sliceDoc(r3[0].from, r3[0].to);
  if (t3.selection.ranges.some((s3) => t3.sliceDoc(s3.from, s3.to) != n3))
    return false;
  let i = qe$1(t3, n3);
  return i ? (e28(t3.update({
    selection: t3.selection.addRange(g$K.range(i.from, i.to), false),
    effects: A$m.scrollIntoView(i.to)
  })), true) : false;
}, C$A = /* @__PURE__ */ A$o.define({
  combine(t3) {
    return ht$7(t3, {
      top: false,
      caseSensitive: false,
      literal: false,
      regexp: false,
      wholeWord: false,
      createPanel: (e28) => new Ve$2(e28),
      scrollToMatch: (e28) => A$m.scrollIntoView(e28)
    });
  }
});
class ae$4 {
  constructor(e28) {
    this.search = e28.search, this.caseSensitive = !!e28.caseSensitive, this.literal = !!e28.literal, this.regexp = !!e28.regexp, this.replace = e28.replace || "", this.valid = !!this.search && (!this.regexp || be$4(this.search)), this.unquoted = this.unquote(this.search), this.wholeWord = !!e28.wholeWord;
  }
  unquote(e28) {
    return this.literal ? e28 : e28.replace(/\\([nrt\\])/g, (r3, n3) => n3 == "n" ? `
` : n3 == "r" ? "\r" : n3 == "t" ? "	" : "\\");
  }
  eq(e28) {
    return this.search == e28.search && this.replace == e28.replace && this.caseSensitive == e28.caseSensitive && this.regexp == e28.regexp && this.wholeWord == e28.wholeWord;
  }
  create() {
    return this.regexp ? new $e$1(this) : new Ie$2(this);
  }
  getCursor(e28, r3 = 0, n3) {
    let i = e28.doc ? e28 : w$q.create({ doc: e28 });
    return n3 == null && (n3 = i.doc.length), this.regexp ? M$c(this, i, r3, n3) : y$r(this, i, r3, n3);
  }
}
class he$4 {
  constructor(e28) {
    this.spec = e28;
  }
}
function y$r(t3, e28, r3, n3) {
  return new b$v(e28.doc, t3.unquoted, r3, n3, t3.caseSensitive ? void 0 : (i) => i.toLowerCase(), t3.wholeWord ? Te$3(e28.doc, e28.charCategorizer(e28.selection.main.head)) : void 0);
}
function Te$3(t3, e28) {
  return (r3, n3, i, s3) => ((s3 > r3 || s3 + i.length < n3) && (s3 = Math.max(0, r3 - 2), i = t3.sliceString(s3, Math.min(t3.length, n3 + 2))), (e28(T$k(i, r3 - s3)) != T$x.Word || e28(I$j(i, r3 - s3)) != T$x.Word) && (e28(I$j(i, n3 - s3)) != T$x.Word || e28(T$k(i, n3 - s3)) != T$x.Word));
}
class Ie$2 extends he$4 {
  constructor(e28) {
    super(e28);
  }
  nextMatch(e28, r3, n3) {
    let i = y$r(this.spec, e28, n3, e28.doc.length).nextOverlapping();
    return i.done && (i = y$r(this.spec, e28, 0, r3).nextOverlapping()), i.done ? null : i.value;
  }
  prevMatchInRange(e28, r3, n3) {
    for (let i = n3; ; ) {
      let s3 = Math.max(r3, i - 1e4 - this.spec.unquoted.length), l3 = y$r(this.spec, e28, s3, i), o3 = null;
      for (; !l3.nextOverlapping().done; )
        o3 = l3.value;
      if (o3)
        return o3;
      if (s3 == r3)
        return null;
      i -= 1e4;
    }
  }
  prevMatch(e28, r3, n3) {
    return this.prevMatchInRange(e28, 0, r3) || this.prevMatchInRange(e28, n3, e28.doc.length);
  }
  getReplacement(e28) {
    return this.spec.unquote(this.spec.replace);
  }
  matchAll(e28, r3) {
    let n3 = y$r(this.spec, e28, 0, e28.doc.length), i = [];
    for (; !n3.next().done; ) {
      if (i.length >= r3)
        return null;
      i.push(n3.value);
    }
    return i;
  }
  highlight(e28, r3, n3, i) {
    let s3 = y$r(this.spec, e28, Math.max(0, r3 - this.spec.unquoted.length), Math.min(n3 + this.spec.unquoted.length, e28.doc.length));
    for (; !s3.next().done; )
      i(s3.value.from, s3.value.to);
  }
}
function M$c(t3, e28, r3, n3) {
  return new le$3(e28.doc, t3.search, {
    ignoreCase: !t3.caseSensitive,
    test: t3.wholeWord ? we$4(e28.charCategorizer(e28.selection.main.head)) : void 0
  }, r3, n3);
}
function T$k(t3, e28) {
  return t3.slice(K$h(t3, e28, false), e28);
}
function I$j(t3, e28) {
  return t3.slice(e28, K$h(t3, e28));
}
function we$4(t3) {
  return (e28, r3, n3) => !n3[0].length || (t3(T$k(n3.input, n3.index)) != T$x.Word || t3(I$j(n3.input, n3.index)) != T$x.Word) && (t3(I$j(n3.input, n3.index + n3[0].length)) != T$x.Word || t3(T$k(n3.input, n3.index + n3[0].length)) != T$x.Word);
}
class $e$1 extends he$4 {
  nextMatch(e28, r3, n3) {
    let i = M$c(this.spec, e28, n3, e28.doc.length).next();
    return i.done && (i = M$c(this.spec, e28, 0, r3).next()), i.done ? null : i.value;
  }
  prevMatchInRange(e28, r3, n3) {
    for (let i = 1; ; i++) {
      let s3 = Math.max(r3, n3 - i * 1e4), l3 = M$c(this.spec, e28, s3, n3), o3 = null;
      for (; !l3.next().done; )
        o3 = l3.value;
      if (o3 && (s3 == r3 || o3.from > s3 + 10))
        return o3;
      if (s3 == r3)
        return null;
    }
  }
  prevMatch(e28, r3, n3) {
    return this.prevMatchInRange(e28, 0, r3) || this.prevMatchInRange(e28, n3, e28.doc.length);
  }
  getReplacement(e28) {
    return this.spec.unquote(this.spec.replace.replace(/\$([$&\d+])/g, (r3, n3) => n3 == "$" ? "$" : n3 == "&" ? e28.match[0] : n3 != "0" && +n3 < e28.match.length ? e28.match[n3] : r3));
  }
  matchAll(e28, r3) {
    let n3 = M$c(this.spec, e28, 0, e28.doc.length), i = [];
    for (; !n3.next().done; ) {
      if (i.length >= r3)
        return null;
      i.push(n3.value);
    }
    return i;
  }
  highlight(e28, r3, n3, i) {
    let s3 = M$c(this.spec, e28, Math.max(0, r3 - 250), Math.min(n3 + 250, e28.doc.length));
    for (; !s3.next().done; )
      i(s3.value.from, s3.value.to);
  }
}
const L$j = /* @__PURE__ */ S$m.define(), V$d = /* @__PURE__ */ S$m.define(), S$g = /* @__PURE__ */ L$s.define({
  create(t3) {
    return new z$a(B$h(t3).create(), null);
  },
  update(t3, e28) {
    for (let r3 of e28.effects)
      r3.is(L$j) ? t3 = new z$a(r3.value.create(), t3.panel) : r3.is(V$d) && (t3 = new z$a(t3.query, r3.value ? H$c : null));
    return t3;
  },
  provide: (t3) => Yi$1.from(t3, (e28) => e28.panel)
});
class z$a {
  constructor(e28, r3) {
    this.query = e28, this.panel = r3;
  }
}
const Oe$2 = /* @__PURE__ */ V$j.mark({ class: "cm-searchMatch" }), Qe$1 = /* @__PURE__ */ V$j.mark({ class: "cm-searchMatch cm-searchMatch-selected" }), ze$2 = /* @__PURE__ */ z$i.fromClass(class {
  constructor(t3) {
    this.view = t3, this.decorations = this.highlight(t3.state.field(S$g));
  }
  update(t3) {
    let e28 = t3.state.field(S$g);
    (e28 != t3.startState.field(S$g) || t3.docChanged || t3.selectionSet || t3.viewportChanged) && (this.decorations = this.highlight(e28));
  }
  highlight({ query: t3, panel: e28 }) {
    if (!e28 || !t3.spec.valid)
      return V$j.none;
    let { view: r3 } = this, n3 = new _$n();
    for (let i = 0, s3 = r3.visibleRanges, l3 = s3.length; i < l3; i++) {
      let { from: o3, to: c3 } = s3[i];
      for (; i < l3 - 1 && c3 > s3[i + 1].from - 2 * 250; )
        c3 = s3[++i].to;
      t3.highlight(r3.state, o3, c3, (a3, u3) => {
        let g3 = r3.state.selection.ranges.some((A3) => A3.from == a3 && A3.to == u3);
        n3.add(a3, u3, g3 ? Qe$1 : Oe$2);
      });
    }
    return n3.finish();
  }
}, {
  decorations: (t3) => t3.decorations
});
function F$e(t3) {
  return (e28) => {
    let r3 = e28.state.field(S$g, false);
    return r3 && r3.query.spec.valid ? t3(e28, r3) : de$5(e28);
  };
}
const w$h = /* @__PURE__ */ F$e((t3, { query: e28 }) => {
  let { to: r3 } = t3.state.selection.main, n3 = e28.nextMatch(t3.state, r3, r3);
  if (!n3)
    return false;
  let i = g$K.single(n3.from, n3.to), s3 = t3.state.facet(C$A);
  return t3.dispatch({
    selection: i,
    effects: [K$9(t3, n3), s3.scrollToMatch(i.main, t3)],
    userEvent: "select.search"
  }), fe$3(t3), true;
}), $$7 = /* @__PURE__ */ F$e((t3, { query: e28 }) => {
  let { state: r3 } = t3, { from: n3 } = r3.selection.main, i = e28.prevMatch(r3, n3, n3);
  if (!i)
    return false;
  let s3 = g$K.single(i.from, i.to), l3 = t3.state.facet(C$A);
  return t3.dispatch({
    selection: s3,
    effects: [K$9(t3, i), l3.scrollToMatch(s3.main, t3)],
    userEvent: "select.search"
  }), fe$3(t3), true;
}), _e$3 = /* @__PURE__ */ F$e((t3, { query: e28 }) => {
  let r3 = e28.matchAll(t3.state, 1e3);
  return !r3 || !r3.length ? false : (t3.dispatch({
    selection: g$K.create(r3.map((n3) => g$K.range(n3.from, n3.to))),
    userEvent: "select.search.matches"
  }), true);
}), Be$3 = ({ state: t3, dispatch: e28 }) => {
  let r3 = t3.selection;
  if (r3.ranges.length > 1 || r3.main.empty)
    return false;
  let { from: n3, to: i } = r3.main, s3 = [], l3 = 0;
  for (let o3 = new b$v(t3.doc, t3.sliceDoc(n3, i)); !o3.next().done; ) {
    if (s3.length > 1e3)
      return false;
    o3.value.from == n3 && (l3 = s3.length), s3.push(g$K.range(o3.value.from, o3.value.to));
  }
  return e28(t3.update({
    selection: g$K.create(s3, l3),
    userEvent: "select.search.matches"
  })), true;
}, Y$6 = /* @__PURE__ */ F$e((t3, { query: e28 }) => {
  let { state: r3 } = t3, { from: n3, to: i } = r3.selection.main;
  if (r3.readOnly)
    return false;
  let s3 = e28.nextMatch(r3, n3, n3);
  if (!s3)
    return false;
  let l3 = [], o3, c3, a3 = [];
  if (s3.from == n3 && s3.to == i && (c3 = r3.toText(e28.getReplacement(s3)), l3.push({ from: s3.from, to: s3.to, insert: c3 }), s3 = e28.nextMatch(r3, s3.from, s3.to), a3.push(A$m.announce.of(r3.phrase("replaced match on line $", r3.doc.lineAt(n3).number) + "."))), s3) {
    let u3 = l3.length == 0 || l3[0].from >= s3.to ? 0 : s3.to - s3.from - c3.length;
    o3 = g$K.single(s3.from - u3, s3.to - u3), a3.push(K$9(t3, s3)), a3.push(r3.facet(C$A).scrollToMatch(o3.main, t3));
  }
  return t3.dispatch({
    changes: l3,
    selection: o3,
    effects: a3,
    userEvent: "input.replace"
  }), true;
}), Ne$1 = /* @__PURE__ */ F$e((t3, { query: e28 }) => {
  if (t3.state.readOnly)
    return false;
  let r3 = e28.matchAll(t3.state, 1e9).map((i) => {
    let { from: s3, to: l3 } = i;
    return { from: s3, to: l3, insert: e28.getReplacement(i) };
  });
  if (!r3.length)
    return false;
  let n3 = t3.state.phrase("replaced $ matches", r3.length) + ".";
  return t3.dispatch({
    changes: r3,
    effects: A$m.announce.of(n3),
    userEvent: "input.replace.all"
  }), true;
});
function H$c(t3) {
  return t3.state.facet(C$A).createPanel(t3);
}
function B$h(t3, e28) {
  var r3, n3, i, s3, l3;
  let o3 = t3.selection.main, c3 = o3.empty || o3.to > o3.from + 100 ? "" : t3.sliceDoc(o3.from, o3.to);
  if (e28 && !c3)
    return e28;
  let a3 = t3.facet(C$A);
  return new ae$4({
    search: ((r3 = e28 == null ? void 0 : e28.literal) !== null && r3 !== void 0 ? r3 : a3.literal) ? c3 : c3.replace(/\n/g, "\\n"),
    caseSensitive: (n3 = e28 == null ? void 0 : e28.caseSensitive) !== null && n3 !== void 0 ? n3 : a3.caseSensitive,
    literal: (i = e28 == null ? void 0 : e28.literal) !== null && i !== void 0 ? i : a3.literal,
    regexp: (s3 = e28 == null ? void 0 : e28.regexp) !== null && s3 !== void 0 ? s3 : a3.regexp,
    wholeWord: (l3 = e28 == null ? void 0 : e28.wholeWord) !== null && l3 !== void 0 ? l3 : a3.wholeWord
  });
}
function ue$3(t3) {
  let e28 = jo$2(t3, H$c);
  return e28 && e28.dom.querySelector("[main-field]");
}
function fe$3(t3) {
  let e28 = ue$3(t3);
  e28 && e28 == t3.root.activeElement && e28.select();
}
const de$5 = (t3) => {
  let e28 = t3.state.field(S$g, false);
  if (e28 && e28.panel) {
    let r3 = ue$3(t3);
    if (r3 && r3 != t3.root.activeElement) {
      let n3 = B$h(t3.state, e28.query.spec);
      n3.valid && t3.dispatch({ effects: L$j.of(n3) }), r3.focus(), r3.select();
    }
  } else
    t3.dispatch({ effects: [
      V$d.of(true),
      e28 ? L$j.of(B$h(t3.state, e28.query.spec)) : S$m.appendConfig.of(Ke$2)
    ] });
  return true;
}, me$6 = (t3) => {
  let e28 = t3.state.field(S$g, false);
  if (!e28 || !e28.panel)
    return false;
  let r3 = jo$2(t3, H$c);
  return r3 && r3.dom.contains(t3.root.activeElement) && t3.focus(), t3.dispatch({ effects: V$d.of(false) }), true;
}, Xe$2 = [
  { key: "Mod-f", run: de$5, scope: "editor search-panel" },
  { key: "F3", run: w$h, shift: $$7, scope: "editor search-panel", preventDefault: true },
  { key: "Mod-g", run: w$h, shift: $$7, scope: "editor search-panel", preventDefault: true },
  { key: "Escape", run: me$6, scope: "editor search-panel" },
  { key: "Mod-Shift-l", run: Be$3 },
  { key: "Alt-g", run: Ce$4 },
  { key: "Mod-d", run: Pe$3, preventDefault: true }
];
class Ve$2 {
  constructor(e28) {
    this.view = e28;
    let r3 = this.query = e28.state.field(S$g).query.spec;
    this.commit = this.commit.bind(this), this.searchField = s$13("input", {
      value: r3.search,
      placeholder: f$H(e28, "Find"),
      "aria-label": f$H(e28, "Find"),
      class: "cm-textfield",
      name: "search",
      form: "",
      "main-field": "true",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.replaceField = s$13("input", {
      value: r3.replace,
      placeholder: f$H(e28, "Replace"),
      "aria-label": f$H(e28, "Replace"),
      class: "cm-textfield",
      name: "replace",
      form: "",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.caseField = s$13("input", {
      type: "checkbox",
      name: "case",
      form: "",
      checked: r3.caseSensitive,
      onchange: this.commit
    }), this.reField = s$13("input", {
      type: "checkbox",
      name: "re",
      form: "",
      checked: r3.regexp,
      onchange: this.commit
    }), this.wordField = s$13("input", {
      type: "checkbox",
      name: "word",
      form: "",
      checked: r3.wholeWord,
      onchange: this.commit
    });
    function n3(i, s3, l3) {
      return s$13("button", { class: "cm-button", name: i, onclick: s3, type: "button" }, l3);
    }
    this.dom = s$13("div", { onkeydown: (i) => this.keydown(i), class: "cm-search" }, [
      this.searchField,
      n3("next", () => w$h(e28), [f$H(e28, "next")]),
      n3("prev", () => $$7(e28), [f$H(e28, "previous")]),
      n3("select", () => _e$3(e28), [f$H(e28, "all")]),
      s$13("label", null, [this.caseField, f$H(e28, "match case")]),
      s$13("label", null, [this.reField, f$H(e28, "regexp")]),
      s$13("label", null, [this.wordField, f$H(e28, "by word")]),
      ...e28.state.readOnly ? [] : [
        s$13("br"),
        this.replaceField,
        n3("replace", () => Y$6(e28), [f$H(e28, "replace")]),
        n3("replaceAll", () => Ne$1(e28), [f$H(e28, "replace all")])
      ],
      s$13("button", {
        name: "close",
        onclick: () => me$6(e28),
        "aria-label": f$H(e28, "close"),
        type: "button"
      }, ["\xD7"])
    ]);
  }
  commit() {
    let e28 = new ae$4({
      search: this.searchField.value,
      caseSensitive: this.caseField.checked,
      regexp: this.reField.checked,
      wholeWord: this.wordField.checked,
      replace: this.replaceField.value
    });
    e28.eq(this.query) || (this.query = e28, this.view.dispatch({ effects: L$j.of(e28) }));
  }
  keydown(e28) {
    Ho$1(this.view, e28, "search-panel") ? e28.preventDefault() : e28.keyCode == 13 && e28.target == this.searchField ? (e28.preventDefault(), (e28.shiftKey ? $$7 : w$h)(this.view)) : e28.keyCode == 13 && e28.target == this.replaceField && (e28.preventDefault(), Y$6(this.view));
  }
  update(e28) {
    for (let r3 of e28.transactions)
      for (let n3 of r3.effects)
        n3.is(L$j) && !n3.value.eq(this.query) && this.setQuery(n3.value);
  }
  setQuery(e28) {
    this.query = e28, this.searchField.value = e28.search, this.replaceField.value = e28.replace, this.caseField.checked = e28.caseSensitive, this.reField.checked = e28.regexp, this.wordField.checked = e28.wholeWord;
  }
  mount() {
    this.searchField.select();
  }
  get pos() {
    return 80;
  }
  get top() {
    return this.view.state.facet(C$A).top;
  }
}
function f$H(t3, e28) {
  return t3.state.phrase(e28);
}
const D$m = 30, E$h = /[\s\.,:;?!]/;
function K$9(t3, { from: e28, to: r3 }) {
  let n3 = t3.state.doc.lineAt(e28), i = t3.state.doc.lineAt(r3).to, s3 = Math.max(n3.from, e28 - D$m), l3 = Math.min(i, r3 + D$m), o3 = t3.state.sliceDoc(s3, l3);
  if (s3 != n3.from) {
    for (let c3 = 0; c3 < D$m; c3++)
      if (!E$h.test(o3[c3 + 1]) && E$h.test(o3[c3])) {
        o3 = o3.slice(c3);
        break;
      }
  }
  if (l3 != i) {
    for (let c3 = o3.length - 1; c3 > o3.length - D$m; c3--)
      if (!E$h.test(o3[c3 - 1]) && E$h.test(o3[c3])) {
        o3 = o3.slice(0, c3);
        break;
      }
  }
  return A$m.announce.of(`${t3.state.phrase("current match")}. ${o3} ${t3.state.phrase("on line")} ${n3.number}.`);
}
const He$2 = /* @__PURE__ */ A$m.baseTheme({
  ".cm-panel.cm-search": {
    padding: "2px 6px 4px",
    position: "relative",
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "4px",
      backgroundColor: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    },
    "& input, & button, & label": {
      margin: ".2em .6em .2em 0"
    },
    "& input[type=checkbox]": {
      marginRight: ".2em"
    },
    "& label": {
      fontSize: "80%",
      whiteSpace: "pre"
    }
  },
  "&light .cm-searchMatch": { backgroundColor: "#ffff0054" },
  "&dark .cm-searchMatch": { backgroundColor: "#00ffff8a" },
  "&light .cm-searchMatch-selected": { backgroundColor: "#ff6a0054" },
  "&dark .cm-searchMatch-selected": { backgroundColor: "#ff00ff8a" }
}), Ke$2 = [
  S$g,
  /* @__PURE__ */ lt$8.low(ze$2),
  He$2
];
const I$i = /* @__PURE__ */ (() => [
  Go$1(),
  _o$2(),
  Wo$1(),
  ln$2(),
  Wt$4(),
  No$3(),
  Vo$2(),
  w$q.allowMultipleSelections.of(true),
  Ft$4(),
  Ut$4(Rt$4, { fallback: true }),
  $t$6(),
  Ft$2(),
  $t$4(),
  zo$1(),
  Io$2(),
  Fo$2(),
  Ue$1(),
  Kr$1.of([
    ...jt$2,
    ...sn$2,
    ...Xe$2,
    ...cn$1,
    ...Lt$3,
    ...At$4,
    ...we$5
  ])
])();
var ni$1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Z2(e28) {
  return e28 && e28.__esModule && Object.prototype.hasOwnProperty.call(e28, "default") ? e28.default : e28;
}
function gt$3(e28, t3) {
  return e28(t3 = { exports: {} }, t3.exports), t3.exports;
}
function Cr$1(e28) {
  return e28 && e28.default || e28;
}
function xe$3(e28) {
  return (xe$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t3) {
    return typeof t3;
  } : function(t3) {
    return t3 && typeof Symbol == "function" && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
  })(e28);
}
function We$1(e28, t3) {
  if (!(e28 instanceof t3))
    throw new TypeError("Cannot call a class as a function");
}
function hy(e28, t3) {
  for (var n3 = 0; n3 < t3.length; n3++) {
    var r3 = t3[n3];
    r3.enumerable = r3.enumerable || false, r3.configurable = true, "value" in r3 && (r3.writable = true), Object.defineProperty(e28, r3.key, r3);
  }
}
function Xe$1(e28, t3, n3) {
  return t3 && hy(e28.prototype, t3), n3 && hy(e28, n3), e28;
}
function Fn$1(e28, t3, n3) {
  return t3 in e28 ? Object.defineProperty(e28, t3, { value: n3, enumerable: true, configurable: true, writable: true }) : e28[t3] = n3, e28;
}
function dy(e28, t3) {
  var n3 = Object.keys(e28);
  if (Object.getOwnPropertySymbols) {
    var r3 = Object.getOwnPropertySymbols(e28);
    t3 && (r3 = r3.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e28, i).enumerable;
    })), n3.push.apply(n3, r3);
  }
  return n3;
}
function Sa$2(e28) {
  for (var t3 = 1; t3 < arguments.length; t3++) {
    var n3 = arguments[t3] != null ? arguments[t3] : {};
    t3 % 2 ? dy(Object(n3), true).forEach(function(r3) {
      Fn$1(e28, r3, n3[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e28, Object.getOwnPropertyDescriptors(n3)) : dy(Object(n3)).forEach(function(r3) {
      Object.defineProperty(e28, r3, Object.getOwnPropertyDescriptor(n3, r3));
    });
  }
  return e28;
}
function $t$3(e28, t3) {
  if (typeof t3 != "function" && t3 !== null)
    throw new TypeError("Super expression must either be null or a function");
  e28.prototype = Object.create(t3 && t3.prototype, { constructor: { value: e28, writable: true, configurable: true } }), t3 && tf(e28, t3);
}
function rt$2(e28) {
  return (rt$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function(t3) {
    return t3.__proto__ || Object.getPrototypeOf(t3);
  })(e28);
}
function tf(e28, t3) {
  return (tf = Object.setPrototypeOf || function(n3, r3) {
    return n3.__proto__ = r3, n3;
  })(e28, t3);
}
function g0(e28, t3, n3) {
  return (g0 = function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return false;
    if (typeof Proxy == "function")
      return true;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), true;
    } catch {
      return false;
    }
  }() ? Reflect.construct : function(r3, i, a3) {
    var s3 = [null];
    s3.push.apply(s3, i);
    var o3 = new (Function.bind.apply(r3, s3))();
    return a3 && tf(o3, a3.prototype), o3;
  }).apply(null, arguments);
}
function eE(e28) {
  var t3 = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return (eE = function(n3) {
    if (n3 === null || (r3 = n3, Function.toString.call(r3).indexOf("[native code]") === -1))
      return n3;
    var r3;
    if (typeof n3 != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (t3 !== void 0) {
      if (t3.has(n3))
        return t3.get(n3);
      t3.set(n3, i);
    }
    function i() {
      return g0(n3, arguments, rt$2(this).constructor);
    }
    return i.prototype = Object.create(n3.prototype, { constructor: { value: i, enumerable: false, writable: true, configurable: true } }), tf(i, n3);
  })(e28);
}
function tE(e28) {
  if (e28 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e28;
}
function Gt$3(e28, t3) {
  return !t3 || typeof t3 != "object" && typeof t3 != "function" ? tE(e28) : t3;
}
function Yn$2(e28, t3, n3) {
  return (Yn$2 = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(r3, i, a3) {
    var s3 = function(u3, c3) {
      for (; !Object.prototype.hasOwnProperty.call(u3, c3) && (u3 = rt$2(u3)) !== null; )
        ;
      return u3;
    }(r3, i);
    if (s3) {
      var o3 = Object.getOwnPropertyDescriptor(s3, i);
      return o3.get ? o3.get.call(a3) : o3.value;
    }
  })(e28, t3, n3 || e28);
}
function bn$1(e28, t3) {
  return nE(e28) || function(n3, r3) {
    if (Symbol.iterator in Object(n3) || Object.prototype.toString.call(n3) === "[object Arguments]") {
      var i = [], a3 = true, s3 = false, o3 = void 0;
      try {
        for (var u3, c3 = n3[Symbol.iterator](); !(a3 = (u3 = c3.next()).done) && (i.push(u3.value), !r3 || i.length !== r3); a3 = true)
          ;
      } catch (f3) {
        s3 = true, o3 = f3;
      } finally {
        try {
          a3 || c3.return == null || c3.return();
        } finally {
          if (s3)
            throw o3;
        }
      }
      return i;
    }
  }(e28, t3) || iE();
}
function Mt$2(e28) {
  return function(t3) {
    if (Array.isArray(t3)) {
      for (var n3 = 0, r3 = new Array(t3.length); n3 < t3.length; n3++)
        r3[n3] = t3[n3];
      return r3;
    }
  }(e28) || rE(e28) || function() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }();
}
function nE(e28) {
  if (Array.isArray(e28))
    return e28;
}
function rE(e28) {
  if (Symbol.iterator in Object(e28) || Object.prototype.toString.call(e28) === "[object Arguments]")
    return Array.from(e28);
}
function iE() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
var Re$3 = gt$3(function(e28) {
  var t3 = e28.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
  typeof __g == "number" && (__g = t3);
}), v6 = {}.hasOwnProperty, At$3 = function(e28, t3) {
  return v6.call(e28, t3);
}, pt$3 = function(e28) {
  try {
    return !!e28();
  } catch {
    return true;
  }
}, rn$1 = !pt$3(function() {
  return Object.defineProperty({}, "a", { get: function() {
    return 7;
  } }).a != 7;
}), hn$1 = gt$3(function(e28) {
  var t3 = e28.exports = { version: "2.6.10" };
  typeof __e == "number" && (__e = t3);
}), ht$3 = (hn$1.version, function(e28) {
  return xe$3(e28) === "object" ? e28 !== null : typeof e28 == "function";
}), Ct$2 = function(e28) {
  if (!ht$3(e28))
    throw TypeError(e28 + " is not an object!");
  return e28;
}, hm = Re$3.document, x6 = ht$3(hm) && ht$3(hm.createElement), bp = function(e28) {
  return x6 ? hm.createElement(e28) : {};
}, aE = !rn$1 && !pt$3(function() {
  return Object.defineProperty(bp("div"), "a", { get: function() {
    return 7;
  } }).a != 7;
}), Gi$1 = function(e28, t3) {
  if (!ht$3(e28))
    return e28;
  var n3, r3;
  if (t3 && typeof (n3 = e28.toString) == "function" && !ht$3(r3 = n3.call(e28)) || typeof (n3 = e28.valueOf) == "function" && !ht$3(r3 = n3.call(e28)) || !t3 && typeof (n3 = e28.toString) == "function" && !ht$3(r3 = n3.call(e28)))
    return r3;
  throw TypeError("Can't convert object to primitive value");
}, b6 = Object.defineProperty, En$1 = { f: rn$1 ? Object.defineProperty : function(e28, t3, n3) {
  if (Ct$2(e28), t3 = Gi$1(t3, true), Ct$2(n3), aE)
    try {
      return b6(e28, t3, n3);
    } catch {
    }
  if ("get" in n3 || "set" in n3)
    throw TypeError("Accessors not supported!");
  return "value" in n3 && (e28[t3] = n3.value), e28;
} }, $i$1 = function(e28, t3) {
  return { enumerable: !(1 & e28), configurable: !(2 & e28), writable: !(4 & e28), value: t3 };
}, Pn$1 = rn$1 ? function(e28, t3, n3) {
  return En$1.f(e28, t3, $i$1(1, n3));
} : function(e28, t3, n3) {
  return e28[t3] = n3, e28;
}, E6 = 0, C6 = Math.random(), to$2 = function(e28) {
  return "Symbol(".concat(e28 === void 0 ? "" : e28, ")_", (++E6 + C6).toString(36));
}, Js$1 = gt$3(function(e28) {
  var t3 = Re$3["__core-js_shared__"] || (Re$3["__core-js_shared__"] = {});
  (e28.exports = function(n3, r3) {
    return t3[n3] || (t3[n3] = r3 !== void 0 ? r3 : {});
  })("versions", []).push({ version: hn$1.version, mode: "global", copyright: "\xA9 2019 Denis Pushkarev (zloirock.ru)" });
}), Bh = Js$1("native-function-to-string", Function.toString), Er$1 = gt$3(function(e28) {
  var t3 = to$2("src"), n3 = ("" + Bh).split("toString");
  hn$1.inspectSource = function(r3) {
    return Bh.call(r3);
  }, (e28.exports = function(r3, i, a3, s3) {
    var o3 = typeof a3 == "function";
    o3 && (At$3(a3, "name") || Pn$1(a3, "name", i)), r3[i] !== a3 && (o3 && (At$3(a3, t3) || Pn$1(a3, t3, r3[i] ? "" + r3[i] : n3.join(String(i)))), r3 === Re$3 ? r3[i] = a3 : s3 ? r3[i] ? r3[i] = a3 : Pn$1(r3, i, a3) : (delete r3[i], Pn$1(r3, i, a3)));
  })(Function.prototype, "toString", function() {
    return typeof this == "function" && this[t3] || Bh.call(this);
  });
}), oi$1 = function(e28) {
  if (typeof e28 != "function")
    throw TypeError(e28 + " is not a function!");
  return e28;
}, In$1 = function(e28, t3, n3) {
  if (oi$1(e28), t3 === void 0)
    return e28;
  switch (n3) {
    case 1:
      return function(r3) {
        return e28.call(t3, r3);
      };
    case 2:
      return function(r3, i) {
        return e28.call(t3, r3, i);
      };
    case 3:
      return function(r3, i, a3) {
        return e28.call(t3, r3, i, a3);
      };
  }
  return function() {
    return e28.apply(t3, arguments);
  };
}, pa$2 = function e(t3, n3, r3) {
  var i, a3, s3, o3, u3 = t3 & e.F, c3 = t3 & e.G, f3 = t3 & e.P, p3 = t3 & e.B, d3 = c3 ? Re$3 : t3 & e.S ? Re$3[n3] || (Re$3[n3] = {}) : (Re$3[n3] || {}).prototype, m3 = c3 ? hn$1 : hn$1[n3] || (hn$1[n3] = {}), y3 = m3.prototype || (m3.prototype = {});
  for (i in c3 && (r3 = n3), r3)
    s3 = ((a3 = !u3 && d3 && d3[i] !== void 0) ? d3 : r3)[i], o3 = p3 && a3 ? In$1(s3, Re$3) : f3 && typeof s3 == "function" ? In$1(Function.call, s3) : s3, d3 && Er$1(d3, i, s3, t3 & e.U), m3[i] != s3 && Pn$1(m3, i, o3), f3 && y3[i] != s3 && (y3[i] = s3);
};
Re$3.core = hn$1, pa$2.F = 1, pa$2.G = 2, pa$2.S = 4, pa$2.P = 8, pa$2.B = 16, pa$2.W = 32, pa$2.U = 64, pa$2.R = 128;
var H$b = pa$2, br$1 = gt$3(function(e28) {
  var t3 = to$2("meta"), n3 = En$1.f, r3 = 0, i = Object.isExtensible || function() {
    return true;
  }, a3 = !pt$3(function() {
    return i(Object.preventExtensions({}));
  }), s3 = function(u3) {
    n3(u3, t3, { value: { i: "O" + ++r3, w: {} } });
  }, o3 = e28.exports = { KEY: t3, NEED: false, fastKey: function(u3, c3) {
    if (!ht$3(u3))
      return xe$3(u3) == "symbol" ? u3 : (typeof u3 == "string" ? "S" : "P") + u3;
    if (!At$3(u3, t3)) {
      if (!i(u3))
        return "F";
      if (!c3)
        return "E";
      s3(u3);
    }
    return u3[t3].i;
  }, getWeak: function(u3, c3) {
    if (!At$3(u3, t3)) {
      if (!i(u3))
        return true;
      if (!c3)
        return false;
      s3(u3);
    }
    return u3[t3].w;
  }, onFreeze: function(u3) {
    return a3 && o3.NEED && i(u3) && !At$3(u3, t3) && s3(u3), u3;
  } };
}), Ut$2 = (br$1.KEY, br$1.NEED, br$1.fastKey, br$1.getWeak, br$1.onFreeze, gt$3(function(e28) {
  var t3 = Js$1("wks"), n3 = Re$3.Symbol, r3 = typeof n3 == "function";
  (e28.exports = function(i) {
    return t3[i] || (t3[i] = r3 && n3[i] || (r3 ? n3 : to$2)("Symbol." + i));
  }).store = t3;
})), S6 = En$1.f, my = Ut$2("toStringTag"), ka$2 = function(e28, t3, n3) {
  e28 && !At$3(e28 = n3 ? e28 : e28.prototype, my) && S6(e28, my, { configurable: true, value: t3 });
}, y0 = { f: Ut$2 }, k6 = En$1.f, oE = function(e28) {
  var t3 = hn$1.Symbol || (hn$1.Symbol = Re$3.Symbol || {});
  e28.charAt(0) == "_" || e28 in t3 || k6(t3, e28, { value: y0.f(e28) });
}, D6 = {}.toString, si$1 = function(e28) {
  return D6.call(e28).slice(8, -1);
}, yc$2 = Object("z").propertyIsEnumerable(0) ? Object : function(e28) {
  return si$1(e28) == "String" ? e28.split("") : Object(e28);
}, Ta$2 = function(e28) {
  if (e28 == null)
    throw TypeError("Can't call method on  " + e28);
  return e28;
}, lr$1 = function(e28) {
  return yc$2(Ta$2(e28));
}, F6 = Math.ceil, w6 = Math.floor, zi$1 = function(e28) {
  return isNaN(e28 = +e28) ? 0 : (e28 > 0 ? w6 : F6)(e28);
}, A6 = Math.min, sn$1 = function(e28) {
  return e28 > 0 ? A6(zi$1(e28), 9007199254740991) : 0;
}, _6 = Math.max, T6 = Math.min, ai$1 = function(e28, t3) {
  return (e28 = zi$1(e28)) < 0 ? _6(e28 + t3, 0) : T6(e28, t3);
}, nf = function(e28) {
  return function(t3, n3, r3) {
    var i, a3 = lr$1(t3), s3 = sn$1(a3.length), o3 = ai$1(r3, s3);
    if (e28 && n3 != n3) {
      for (; s3 > o3; )
        if ((i = a3[o3++]) != i)
          return true;
    } else
      for (; s3 > o3; o3++)
        if ((e28 || o3 in a3) && a3[o3] === n3)
          return e28 || o3 || 0;
    return !e28 && -1;
  };
}, gy = Js$1("keys"), v0 = function(e28) {
  return gy[e28] || (gy[e28] = to$2(e28));
}, P6 = nf(false), I6 = v0("IE_PROTO"), sE = function(e28, t3) {
  var n3, r3 = lr$1(e28), i = 0, a3 = [];
  for (n3 in r3)
    n3 != I6 && At$3(r3, n3) && a3.push(n3);
  for (; t3.length > i; )
    At$3(r3, n3 = t3[i++]) && (~P6(a3, n3) || a3.push(n3));
  return a3;
}, Ep = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","), no$1 = Object.keys || function(e28) {
  return sE(e28, Ep);
}, Uo$1 = { f: Object.getOwnPropertySymbols }, vc$2 = { f: {}.propertyIsEnumerable }, ic$2 = Array.isArray || function(e28) {
  return si$1(e28) == "Array";
}, Zn$1 = function(e28) {
  return Object(Ta$2(e28));
}, uE = rn$1 ? Object.defineProperties : function(e28, t3) {
  Ct$2(e28);
  for (var n3, r3 = no$1(t3), i = r3.length, a3 = 0; i > a3; )
    En$1.f(e28, n3 = r3[a3++], t3[n3]);
  return e28;
}, yy = Re$3.document, ac$2 = yy && yy.documentElement, B6 = v0("IE_PROTO"), Oh = function() {
}, tp = function() {
  var e28, t3 = bp("iframe"), n3 = Ep.length;
  for (t3.style.display = "none", ac$2.appendChild(t3), t3.src = "javascript:", (e28 = t3.contentWindow.document).open(), e28.write("<script>document.F=Object<\/script>"), e28.close(), tp = e28.F; n3--; )
    delete tp.prototype[Ep[n3]];
  return tp();
}, Ei$1 = Object.create || function(e28, t3) {
  var n3;
  return e28 !== null ? (Oh.prototype = Ct$2(e28), n3 = new Oh(), Oh.prototype = null, n3[B6] = e28) : n3 = tp(), t3 === void 0 ? n3 : uE(n3, t3);
}, O6 = Ep.concat("length", "prototype"), qo$1 = { f: Object.getOwnPropertyNames || function(e28) {
  return sE(e28, O6);
} }, vy = qo$1.f, L6 = {}.toString, xy = (typeof window > "u" ? "undefined" : xe$3(window)) == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], x0 = { f: function(e28) {
  return xy && L6.call(e28) == "[object Window]" ? function(t3) {
    try {
      return vy(t3);
    } catch {
      return xy.slice();
    }
  }(e28) : vy(lr$1(e28));
} }, by = Object.getOwnPropertyDescriptor, ui$1 = { f: rn$1 ? by : function(e28, t3) {
  if (e28 = lr$1(e28), t3 = Gi$1(t3, true), aE)
    try {
      return by(e28, t3);
    } catch {
    }
  if (At$3(e28, t3))
    return $i$1(!vc$2.f.call(e28, t3), e28[t3]);
} }, N6 = br$1.KEY, cE = ui$1.f, _o$1 = En$1.f, lE = x0.f, Nr$1 = Re$3.Symbol, Cp = Re$3.JSON, bl = Cp && Cp.stringify, vr$1 = Ut$2("_hidden"), Ey = Ut$2("toPrimitive"), j6 = {}.propertyIsEnumerable, yu$1 = Js$1("symbol-registry"), wa$2 = Js$1("symbols"), xc$1 = Js$1("op-symbols"), ri$1 = Object.prototype, Ns$1 = typeof Nr$1 == "function" && !!Uo$1.f, Lh = Re$3.QObject, dm = !Lh || !Lh.prototype || !Lh.prototype.findChild, mm = rn$1 && pt$3(function() {
  return Ei$1(_o$1({}, "a", { get: function() {
    return _o$1(this, "a", { value: 7 }).a;
  } })).a != 7;
}) ? function(e28, t3, n3) {
  var r3 = cE(ri$1, t3);
  r3 && delete ri$1[t3], _o$1(e28, t3, n3), r3 && e28 !== ri$1 && _o$1(ri$1, t3, r3);
} : _o$1, Cy = function(e28) {
  var t3 = wa$2[e28] = Ei$1(Nr$1.prototype);
  return t3._k = e28, t3;
}, gm = Ns$1 && xe$3(Nr$1.iterator) == "symbol" ? function(e28) {
  return xe$3(e28) == "symbol";
} : function(e28) {
  return e28 instanceof Nr$1;
}, rf = function(e28, t3, n3) {
  return e28 === ri$1 && rf(xc$1, t3, n3), Ct$2(e28), t3 = Gi$1(t3, true), Ct$2(n3), At$3(wa$2, t3) ? (n3.enumerable ? (At$3(e28, vr$1) && e28[vr$1][t3] && (e28[vr$1][t3] = false), n3 = Ei$1(n3, { enumerable: $i$1(0, false) })) : (At$3(e28, vr$1) || _o$1(e28, vr$1, $i$1(1, {})), e28[vr$1][t3] = true), mm(e28, t3, n3)) : _o$1(e28, t3, n3);
}, Sy = function(e28, t3) {
  Ct$2(e28);
  for (var n3, r3 = function(s3) {
    var o3 = no$1(s3), u3 = Uo$1.f;
    if (u3)
      for (var c3, f3 = u3(s3), p3 = vc$2.f, d3 = 0; f3.length > d3; )
        p3.call(s3, c3 = f3[d3++]) && o3.push(c3);
    return o3;
  }(t3 = lr$1(t3)), i = 0, a3 = r3.length; a3 > i; )
    rf(e28, n3 = r3[i++], t3[n3]);
  return e28;
}, ky = function(e28) {
  var t3 = j6.call(this, e28 = Gi$1(e28, true));
  return !(this === ri$1 && At$3(wa$2, e28) && !At$3(xc$1, e28)) && (!(t3 || !At$3(this, e28) || !At$3(wa$2, e28) || At$3(this, vr$1) && this[vr$1][e28]) || t3);
}, pE = function(e28, t3) {
  if (e28 = lr$1(e28), t3 = Gi$1(t3, true), e28 !== ri$1 || !At$3(wa$2, t3) || At$3(xc$1, t3)) {
    var n3 = cE(e28, t3);
    return !n3 || !At$3(wa$2, t3) || At$3(e28, vr$1) && e28[vr$1][t3] || (n3.enumerable = true), n3;
  }
}, fE = function(e28) {
  for (var t3, n3 = lE(lr$1(e28)), r3 = [], i = 0; n3.length > i; )
    At$3(wa$2, t3 = n3[i++]) || t3 == vr$1 || t3 == N6 || r3.push(t3);
  return r3;
}, hE = function(e28) {
  for (var t3, n3 = e28 === ri$1, r3 = lE(n3 ? xc$1 : lr$1(e28)), i = [], a3 = 0; r3.length > a3; )
    !At$3(wa$2, t3 = r3[a3++]) || n3 && !At$3(ri$1, t3) || i.push(wa$2[t3]);
  return i;
};
Ns$1 || (Er$1((Nr$1 = function() {
  if (this instanceof Nr$1)
    throw TypeError("Symbol is not a constructor!");
  var e28 = to$2(arguments.length > 0 ? arguments[0] : void 0), t3 = function n3(r3) {
    this === ri$1 && n3.call(xc$1, r3), At$3(this, vr$1) && At$3(this[vr$1], e28) && (this[vr$1][e28] = false), mm(this, e28, $i$1(1, r3));
  };
  return rn$1 && dm && mm(ri$1, e28, { configurable: true, set: t3 }), Cy(e28);
}).prototype, "toString", function() {
  return this._k;
}), ui$1.f = pE, En$1.f = rf, qo$1.f = x0.f = fE, vc$2.f = ky, Uo$1.f = hE, rn$1 && Er$1(ri$1, "propertyIsEnumerable", ky, true), y0.f = function(e28) {
  return Cy(Ut$2(e28));
}), H$b(H$b.G + H$b.W + H$b.F * !Ns$1, { Symbol: Nr$1 });
for (var Dy = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), Fy = 0; Dy.length > Fy; )
  Ut$2(Dy[Fy++]);
for (var wy = no$1(Ut$2.store), Ay = 0; wy.length > Ay; )
  oE(wy[Ay++]);
H$b(H$b.S + H$b.F * !Ns$1, "Symbol", { for: function(e28) {
  return At$3(yu$1, e28 += "") ? yu$1[e28] : yu$1[e28] = Nr$1(e28);
}, keyFor: function(e28) {
  if (!gm(e28))
    throw TypeError(e28 + " is not a symbol!");
  for (var t3 in yu$1)
    if (yu$1[t3] === e28)
      return t3;
}, useSetter: function() {
  dm = true;
}, useSimple: function() {
  dm = false;
} }), H$b(H$b.S + H$b.F * !Ns$1, "Object", { create: function(e28, t3) {
  return t3 === void 0 ? Ei$1(e28) : Sy(Ei$1(e28), t3);
}, defineProperty: rf, defineProperties: Sy, getOwnPropertyDescriptor: pE, getOwnPropertyNames: fE, getOwnPropertySymbols: hE });
var R6 = pt$3(function() {
  Uo$1.f(1);
});
H$b(H$b.S + H$b.F * R6, "Object", { getOwnPropertySymbols: function(e28) {
  return Uo$1.f(Zn$1(e28));
} }), Cp && H$b(H$b.S + H$b.F * (!Ns$1 || pt$3(function() {
  var e28 = Nr$1();
  return bl([e28]) != "[null]" || bl({ a: e28 }) != "{}" || bl(Object(e28)) != "{}";
})), "JSON", { stringify: function(e28) {
  for (var t3, n3, r3 = [e28], i = 1; arguments.length > i; )
    r3.push(arguments[i++]);
  if (n3 = t3 = r3[1], (ht$3(t3) || e28 !== void 0) && !gm(e28))
    return ic$2(t3) || (t3 = function(a3, s3) {
      if (typeof n3 == "function" && (s3 = n3.call(this, a3, s3)), !gm(s3))
        return s3;
    }), r3[1] = t3, bl.apply(Cp, r3);
} }), Nr$1.prototype[Ey] || Pn$1(Nr$1.prototype, Ey, Nr$1.prototype.valueOf), ka$2(Nr$1, "Symbol"), ka$2(Math, "Math", true), ka$2(Re$3.JSON, "JSON", true), H$b(H$b.S, "Object", { create: Ei$1 }), H$b(H$b.S + H$b.F * !rn$1, "Object", { defineProperty: En$1.f }), H$b(H$b.S + H$b.F * !rn$1, "Object", { defineProperties: uE });
var Ui$2 = function(e28, t3) {
  var n3 = (hn$1.Object || {})[e28] || Object[e28], r3 = {};
  r3[e28] = t3(n3), H$b(H$b.S + H$b.F * pt$3(function() {
    n3(1);
  }), "Object", r3);
}, M6 = ui$1.f;
Ui$2("getOwnPropertyDescriptor", function() {
  return function(e28, t3) {
    return M6(lr$1(e28), t3);
  };
});
var _y = v0("IE_PROTO"), V6 = Object.prototype, No$2 = Object.getPrototypeOf || function(e28) {
  return e28 = Zn$1(e28), At$3(e28, _y) ? e28[_y] : typeof e28.constructor == "function" && e28 instanceof e28.constructor ? e28.constructor.prototype : e28 instanceof Object ? V6 : null;
};
Ui$2("getPrototypeOf", function() {
  return function(e28) {
    return No$2(Zn$1(e28));
  };
}), Ui$2("keys", function() {
  return function(e28) {
    return no$1(Zn$1(e28));
  };
}), Ui$2("getOwnPropertyNames", function() {
  return x0.f;
});
var U6 = br$1.onFreeze;
Ui$2("freeze", function(e28) {
  return function(t3) {
    return e28 && ht$3(t3) ? e28(U6(t3)) : t3;
  };
});
var q6 = br$1.onFreeze;
Ui$2("seal", function(e28) {
  return function(t3) {
    return e28 && ht$3(t3) ? e28(q6(t3)) : t3;
  };
});
var W6 = br$1.onFreeze;
Ui$2("preventExtensions", function(e28) {
  return function(t3) {
    return e28 && ht$3(t3) ? e28(W6(t3)) : t3;
  };
}), Ui$2("isFrozen", function(e28) {
  return function(t3) {
    return !ht$3(t3) || !!e28 && e28(t3);
  };
}), Ui$2("isSealed", function(e28) {
  return function(t3) {
    return !ht$3(t3) || !!e28 && e28(t3);
  };
}), Ui$2("isExtensible", function(e28) {
  return function(t3) {
    return !!ht$3(t3) && (!e28 || e28(t3));
  };
});
var El = Object.assign, dE = !El || pt$3(function() {
  var e28 = {}, t3 = {}, n3 = Symbol(), r3 = "abcdefghijklmnopqrst";
  return e28[n3] = 7, r3.split("").forEach(function(i) {
    t3[i] = i;
  }), El({}, e28)[n3] != 7 || Object.keys(El({}, t3)).join("") != r3;
}) ? function(e28, t3) {
  for (var n3 = Zn$1(e28), r3 = arguments.length, i = 1, a3 = Uo$1.f, s3 = vc$2.f; r3 > i; )
    for (var o3, u3 = yc$2(arguments[i++]), c3 = a3 ? no$1(u3).concat(a3(u3)) : no$1(u3), f3 = c3.length, p3 = 0; f3 > p3; )
      o3 = c3[p3++], rn$1 && !s3.call(u3, o3) || (n3[o3] = u3[o3]);
  return n3;
} : El;
H$b(H$b.S + H$b.F, "Object", { assign: dE });
var ym = Object.is || function(e28, t3) {
  return e28 === t3 ? e28 !== 0 || 1 / e28 == 1 / t3 : e28 != e28 && t3 != t3;
};
H$b(H$b.S, "Object", { is: ym });
var Ty = function(e28, t3) {
  if (Ct$2(e28), !ht$3(t3) && t3 !== null)
    throw TypeError(t3 + ": can't set as prototype!");
}, Qu$1 = { set: Object.setPrototypeOf || ("__proto__" in {} ? function(e28, t3, n3) {
  try {
    (n3 = In$1(Function.call, ui$1.f(Object.prototype, "__proto__").set, 2))(e28, []), t3 = !(e28 instanceof Array);
  } catch {
    t3 = true;
  }
  return function(r3, i) {
    return Ty(r3, i), t3 ? r3.__proto__ = i : n3(r3, i), r3;
  };
}({}, false) : void 0), check: Ty };
H$b(H$b.S, "Object", { setPrototypeOf: Qu$1.set });
var $6 = Ut$2("toStringTag"), G6 = si$1(function() {
  return arguments;
}()) == "Arguments", bc$2 = function(e28) {
  var t3, n3, r3;
  return e28 === void 0 ? "Undefined" : e28 === null ? "Null" : typeof (n3 = function(i, a3) {
    try {
      return i[a3];
    } catch {
    }
  }(t3 = Object(e28), $6)) == "string" ? n3 : G6 ? si$1(t3) : (r3 = si$1(t3)) == "Object" && typeof t3.callee == "function" ? "Arguments" : r3;
}, Py = {};
Py[Ut$2("toStringTag")] = "z", Py + "" != "[object z]" && Er$1(Object.prototype, "toString", function() {
  return "[object " + bc$2(this) + "]";
}, true);
var mE = function(e28, t3, n3) {
  var r3 = n3 === void 0;
  switch (t3.length) {
    case 0:
      return r3 ? e28() : e28.call(n3);
    case 1:
      return r3 ? e28(t3[0]) : e28.call(n3, t3[0]);
    case 2:
      return r3 ? e28(t3[0], t3[1]) : e28.call(n3, t3[0], t3[1]);
    case 3:
      return r3 ? e28(t3[0], t3[1], t3[2]) : e28.call(n3, t3[0], t3[1], t3[2]);
    case 4:
      return r3 ? e28(t3[0], t3[1], t3[2], t3[3]) : e28.call(n3, t3[0], t3[1], t3[2], t3[3]);
  }
  return e28.apply(n3, t3);
}, Iy = [].slice, Nh = {}, z6 = function(e28, t3, n3) {
  if (!(t3 in Nh)) {
    for (var r3 = [], i = 0; i < t3; i++)
      r3[i] = "a[" + i + "]";
    Nh[t3] = Function("F,a", "return new F(" + r3.join(",") + ")");
  }
  return Nh[t3](e28, n3);
}, gE = Function.bind || function(e28) {
  var t3 = oi$1(this), n3 = Iy.call(arguments, 1), r3 = function i() {
    var a3 = n3.concat(Iy.call(arguments));
    return this instanceof i ? z6(t3, a3.length, a3) : mE(t3, a3, e28);
  };
  return ht$3(t3.prototype) && (r3.prototype = t3.prototype), r3;
};
H$b(H$b.P, "Function", { bind: gE });
var H6 = En$1.f, By = Function.prototype, K6 = /^\s*function ([^ (]*)/;
"name" in By || rn$1 && H6(By, "name", { configurable: true, get: function() {
  try {
    return ("" + this).match(K6)[1];
  } catch {
    return "";
  }
} });
var Oy = Ut$2("hasInstance"), Ly = Function.prototype;
Oy in Ly || En$1.f(Ly, Oy, { value: function(e28) {
  if (typeof this != "function" || !ht$3(e28))
    return false;
  if (!ht$3(this.prototype))
    return e28 instanceof this;
  for (; e28 = No$2(e28); )
    if (this.prototype === e28)
      return true;
  return false;
} });
var js$1 = `	
\v\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF`, Sp = "[" + js$1 + "]", J6 = RegExp("^" + Sp + Sp + "*"), Q6 = RegExp(Sp + Sp + "*$"), yE = function(e28, t3, n3) {
  var r3 = {}, i = pt$3(function() {
    return !!js$1[e28]() || "\u200B\x85"[e28]() != "\u200B\x85";
  }), a3 = r3[e28] = i ? t3(X6) : js$1[e28];
  n3 && (r3[n3] = a3), H$b(H$b.P + H$b.F * i, "String", r3);
}, X6 = yE.trim = function(e28, t3) {
  return e28 = String(Ta$2(e28)), 1 & t3 && (e28 = e28.replace(J6, "")), 2 & t3 && (e28 = e28.replace(Q6, "")), e28;
}, Qs$1 = yE, Cl = Re$3.parseInt, Y6 = Qs$1.trim, Z6 = /^[-+]?0[xX]/, kp = Cl(js$1 + "08") !== 8 || Cl(js$1 + "0x16") !== 22 ? function(e28, t3) {
  var n3 = Y6(String(e28), 3);
  return Cl(n3, t3 >>> 0 || (Z6.test(n3) ? 16 : 10));
} : Cl;
H$b(H$b.G + H$b.F * (parseInt != kp), { parseInt: kp });
var jh = Re$3.parseFloat, e7 = Qs$1.trim, Dp = 1 / jh(js$1 + "-0") != -1 / 0 ? function(e28) {
  var t3 = e7(String(e28), 3), n3 = jh(t3);
  return n3 === 0 && t3.charAt(0) == "-" ? -0 : n3;
} : jh;
H$b(H$b.G + H$b.F * (parseFloat != Dp), { parseFloat: Dp });
var Ny = Qu$1.set, b0 = function(e28, t3, n3) {
  var r3, i = t3.constructor;
  return i !== n3 && typeof i == "function" && (r3 = i.prototype) !== n3.prototype && ht$3(r3) && Ny && Ny(e28, r3), e28;
}, t7 = qo$1.f, n7 = ui$1.f, r7 = En$1.f, i7 = Qs$1.trim, Br$1 = Re$3.Number, Sl = Br$1, np = Br$1.prototype, a7 = si$1(Ei$1(np)) == "Number", o7 = "trim" in String.prototype, jy = function(e28) {
  var t3 = Gi$1(e28, false);
  if (typeof t3 == "string" && t3.length > 2) {
    var n3, r3, i, a3 = (t3 = o7 ? t3.trim() : i7(t3, 3)).charCodeAt(0);
    if (a3 === 43 || a3 === 45) {
      if ((n3 = t3.charCodeAt(2)) === 88 || n3 === 120)
        return NaN;
    } else if (a3 === 48) {
      switch (t3.charCodeAt(1)) {
        case 66:
        case 98:
          r3 = 2, i = 49;
          break;
        case 79:
        case 111:
          r3 = 8, i = 55;
          break;
        default:
          return +t3;
      }
      for (var s3, o3 = t3.slice(2), u3 = 0, c3 = o3.length; u3 < c3; u3++)
        if ((s3 = o3.charCodeAt(u3)) < 48 || s3 > i)
          return NaN;
      return parseInt(o3, r3);
    }
  }
  return +t3;
};
if (!Br$1(" 0o1") || !Br$1("0b1") || Br$1("+0x1")) {
  Br$1 = function(e28) {
    var t3 = arguments.length < 1 ? 0 : e28, n3 = this;
    return n3 instanceof Br$1 && (a7 ? pt$3(function() {
      np.valueOf.call(n3);
    }) : si$1(n3) != "Number") ? b0(new Sl(jy(t3)), n3, Br$1) : jy(t3);
  };
  for (var kl, Ry = rn$1 ? t7(Sl) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), Rh = 0; Ry.length > Rh; Rh++)
    At$3(Sl, kl = Ry[Rh]) && !At$3(Br$1, kl) && r7(Br$1, kl, n7(Sl, kl));
  Br$1.prototype = np, np.constructor = Br$1, Er$1(Re$3, "Number", Br$1);
}
var vE = function(e28, t3) {
  if (typeof e28 != "number" && si$1(e28) != "Number")
    throw TypeError(t3);
  return +e28;
}, oc$2 = function(e28) {
  var t3 = String(Ta$2(this)), n3 = "", r3 = zi$1(e28);
  if (r3 < 0 || r3 == 1 / 0)
    throw RangeError("Count can't be negative");
  for (; r3 > 0; (r3 >>>= 1) && (t3 += t3))
    1 & r3 && (n3 += t3);
  return n3;
}, My = 1 .toFixed, xE = Math.floor, Rs$1 = [0, 0, 0, 0, 0, 0], Vy = "Number.toFixed: incorrect invocation!", ss$1 = function(e28, t3) {
  for (var n3 = -1, r3 = t3; ++n3 < 6; )
    r3 += e28 * Rs$1[n3], Rs$1[n3] = r3 % 1e7, r3 = xE(r3 / 1e7);
}, Mh = function(e28) {
  for (var t3 = 6, n3 = 0; --t3 >= 0; )
    n3 += Rs$1[t3], Rs$1[t3] = xE(n3 / e28), n3 = n3 % e28 * 1e7;
}, Uy = function() {
  for (var e28 = 6, t3 = ""; --e28 >= 0; )
    if (t3 !== "" || e28 === 0 || Rs$1[e28] !== 0) {
      var n3 = String(Rs$1[e28]);
      t3 = t3 === "" ? n3 : t3 + oc$2.call("0", 7 - n3.length) + n3;
    }
  return t3;
}, Dl = function e2(t3, n3, r3) {
  return n3 === 0 ? r3 : n3 % 2 == 1 ? e2(t3, n3 - 1, r3 * t3) : e2(t3 * t3, n3 / 2, r3);
};
H$b(H$b.P + H$b.F * (!!My && (8e-5 .toFixed(3) !== "0.000" || 0.9 .toFixed(0) !== "1" || 1.255 .toFixed(2) !== "1.25" || 1000000000000000100 .toFixed(0) !== "1000000000000000128") || !pt$3(function() {
  My.call({});
})), "Number", { toFixed: function(e28) {
  var t3, n3, r3, i, a3 = vE(this, Vy), s3 = zi$1(e28), o3 = "", u3 = "0";
  if (s3 < 0 || s3 > 20)
    throw RangeError(Vy);
  if (a3 != a3)
    return "NaN";
  if (a3 <= -1e21 || a3 >= 1e21)
    return String(a3);
  if (a3 < 0 && (o3 = "-", a3 = -a3), a3 > 1e-21)
    if (n3 = (t3 = function(c3) {
      for (var f3 = 0, p3 = c3; p3 >= 4096; )
        f3 += 12, p3 /= 4096;
      for (; p3 >= 2; )
        f3 += 1, p3 /= 2;
      return f3;
    }(a3 * Dl(2, 69, 1)) - 69) < 0 ? a3 * Dl(2, -t3, 1) : a3 / Dl(2, t3, 1), n3 *= 4503599627370496, (t3 = 52 - t3) > 0) {
      for (ss$1(0, n3), r3 = s3; r3 >= 7; )
        ss$1(1e7, 0), r3 -= 7;
      for (ss$1(Dl(10, r3, 1), 0), r3 = t3 - 1; r3 >= 23; )
        Mh(1 << 23), r3 -= 23;
      Mh(1 << r3), ss$1(1, 1), Mh(2), u3 = Uy();
    } else
      ss$1(0, n3), ss$1(1 << -t3, 0), u3 = Uy() + oc$2.call("0", s3);
  return u3 = s3 > 0 ? o3 + ((i = u3.length) <= s3 ? "0." + oc$2.call("0", s3 - i) + u3 : u3.slice(0, i - s3) + "." + u3.slice(i - s3)) : o3 + u3;
} });
var Fl = 1 .toPrecision;
H$b(H$b.P + H$b.F * (pt$3(function() {
  return Fl.call(1, void 0) !== "1";
}) || !pt$3(function() {
  Fl.call({});
})), "Number", { toPrecision: function(e28) {
  var t3 = vE(this, "Number#toPrecision: incorrect invocation!");
  return e28 === void 0 ? Fl.call(t3) : Fl.call(t3, e28);
} }), H$b(H$b.S, "Number", { EPSILON: Math.pow(2, -52) });
var s7 = Re$3.isFinite;
H$b(H$b.S, "Number", { isFinite: function(e28) {
  return typeof e28 == "number" && s7(e28);
} });
var u7 = Math.floor, bE = function(e28) {
  return !ht$3(e28) && isFinite(e28) && u7(e28) === e28;
};
H$b(H$b.S, "Number", { isInteger: bE }), H$b(H$b.S, "Number", { isNaN: function(e28) {
  return e28 != e28;
} });
var c7 = Math.abs;
H$b(H$b.S, "Number", { isSafeInteger: function(e28) {
  return bE(e28) && c7(e28) <= 9007199254740991;
} }), H$b(H$b.S, "Number", { MAX_SAFE_INTEGER: 9007199254740991 }), H$b(H$b.S, "Number", { MIN_SAFE_INTEGER: -9007199254740991 }), H$b(H$b.S + H$b.F * (Number.parseFloat != Dp), "Number", { parseFloat: Dp }), H$b(H$b.S + H$b.F * (Number.parseInt != kp), "Number", { parseInt: kp });
var EE = Math.log1p || function(e28) {
  return (e28 = +e28) > -1e-8 && e28 < 1e-8 ? e28 - e28 * e28 / 2 : Math.log(1 + e28);
}, qy = Math.sqrt, Vh = Math.acosh;
H$b(H$b.S + H$b.F * !(Vh && Math.floor(Vh(Number.MAX_VALUE)) == 710 && Vh(1 / 0) == 1 / 0), "Math", { acosh: function(e28) {
  return (e28 = +e28) < 1 ? NaN : e28 > 9490626562425156e-8 ? Math.log(e28) + Math.LN2 : EE(e28 - 1 + qy(e28 - 1) * qy(e28 + 1));
} });
var Wy = Math.asinh;
H$b(H$b.S + H$b.F * !(Wy && 1 / Wy(0) > 0), "Math", { asinh: function e3(t3) {
  return isFinite(t3 = +t3) && t3 != 0 ? t3 < 0 ? -e3(-t3) : Math.log(t3 + Math.sqrt(t3 * t3 + 1)) : t3;
} });
var $y = Math.atanh;
H$b(H$b.S + H$b.F * !($y && 1 / $y(-0) < 0), "Math", { atanh: function(e28) {
  return (e28 = +e28) == 0 ? e28 : Math.log((1 + e28) / (1 - e28)) / 2;
} });
var E0 = Math.sign || function(e28) {
  return (e28 = +e28) == 0 || e28 != e28 ? e28 : e28 < 0 ? -1 : 1;
};
H$b(H$b.S, "Math", { cbrt: function(e28) {
  return E0(e28 = +e28) * Math.pow(Math.abs(e28), 1 / 3);
} }), H$b(H$b.S, "Math", { clz32: function(e28) {
  return (e28 >>>= 0) ? 31 - Math.floor(Math.log(e28 + 0.5) * Math.LOG2E) : 32;
} });
var Gy = Math.exp;
H$b(H$b.S, "Math", { cosh: function(e28) {
  return (Gy(e28 = +e28) + Gy(-e28)) / 2;
} });
var vu$1 = Math.expm1, Ms$1 = !vu$1 || vu$1(10) > 22025.465794806718 || vu$1(10) < 22025.465794806718 || vu$1(-2e-17) != -2e-17 ? function(e28) {
  return (e28 = +e28) == 0 ? e28 : e28 > -1e-6 && e28 < 1e-6 ? e28 + e28 * e28 / 2 : Math.exp(e28) - 1;
} : vu$1;
H$b(H$b.S + H$b.F * (Ms$1 != Math.expm1), "Math", { expm1: Ms$1 });
var af = Math.pow, Uh = af(2, -52), rp = af(2, -23), l7 = af(2, 127) * (2 - rp), qh = af(2, -126), p7 = Math.fround || function(e28) {
  var t3, n3, r3 = Math.abs(e28), i = E0(e28);
  return r3 < qh ? i * (r3 / qh / rp + 1 / Uh - 1 / Uh) * qh * rp : (n3 = (t3 = (1 + rp / Uh) * r3) - (t3 - r3)) > l7 || n3 != n3 ? i * (1 / 0) : i * n3;
};
H$b(H$b.S, "Math", { fround: p7 });
var f7 = Math.abs;
H$b(H$b.S, "Math", { hypot: function(e28, t3) {
  for (var n3, r3, i = 0, a3 = 0, s3 = arguments.length, o3 = 0; a3 < s3; )
    o3 < (n3 = f7(arguments[a3++])) ? (i = i * (r3 = o3 / n3) * r3 + 1, o3 = n3) : i += n3 > 0 ? (r3 = n3 / o3) * r3 : n3;
  return o3 === 1 / 0 ? 1 / 0 : o3 * Math.sqrt(i);
} });
var zy = Math.imul;
H$b(H$b.S + H$b.F * pt$3(function() {
  return zy(4294967295, 5) != -5 || zy.length != 2;
}), "Math", { imul: function(e28, t3) {
  var n3 = +e28, r3 = +t3, i = 65535 & n3, a3 = 65535 & r3;
  return 0 | i * a3 + ((65535 & n3 >>> 16) * a3 + i * (65535 & r3 >>> 16) << 16 >>> 0);
} }), H$b(H$b.S, "Math", { log10: function(e28) {
  return Math.log(e28) * Math.LOG10E;
} }), H$b(H$b.S, "Math", { log1p: EE }), H$b(H$b.S, "Math", { log2: function(e28) {
  return Math.log(e28) / Math.LN2;
} }), H$b(H$b.S, "Math", { sign: E0 });
var Hy = Math.exp;
H$b(H$b.S + H$b.F * pt$3(function() {
  return !Math.sinh(-2e-17) != -2e-17;
}), "Math", { sinh: function(e28) {
  return Math.abs(e28 = +e28) < 1 ? (Ms$1(e28) - Ms$1(-e28)) / 2 : (Hy(e28 - 1) - Hy(-e28 - 1)) * (Math.E / 2);
} });
var Ky = Math.exp;
H$b(H$b.S, "Math", { tanh: function(e28) {
  var t3 = Ms$1(e28 = +e28), n3 = Ms$1(-e28);
  return t3 == 1 / 0 ? 1 : n3 == 1 / 0 ? -1 : (t3 - n3) / (Ky(e28) + Ky(-e28));
} }), H$b(H$b.S, "Math", { trunc: function(e28) {
  return (e28 > 0 ? Math.floor : Math.ceil)(e28);
} });
var Jy = String.fromCharCode, Qy = String.fromCodePoint;
H$b(H$b.S + H$b.F * (!!Qy && Qy.length != 1), "String", { fromCodePoint: function(e28) {
  for (var t3, n3 = [], r3 = arguments.length, i = 0; r3 > i; ) {
    if (t3 = +arguments[i++], ai$1(t3, 1114111) !== t3)
      throw RangeError(t3 + " is not a valid code point");
    n3.push(t3 < 65536 ? Jy(t3) : Jy(55296 + ((t3 -= 65536) >> 10), t3 % 1024 + 56320));
  }
  return n3.join("");
} }), H$b(H$b.S, "String", { raw: function(e28) {
  for (var t3 = lr$1(e28.raw), n3 = sn$1(t3.length), r3 = arguments.length, i = [], a3 = 0; n3 > a3; )
    i.push(String(t3[a3++])), a3 < r3 && i.push(String(arguments[a3]));
  return i.join("");
} }), Qs$1("trim", function(e28) {
  return function() {
    return e28(this, 3);
  };
});
var C0 = function(e28) {
  return function(t3, n3) {
    var r3, i, a3 = String(Ta$2(t3)), s3 = zi$1(n3), o3 = a3.length;
    return s3 < 0 || s3 >= o3 ? e28 ? "" : void 0 : (r3 = a3.charCodeAt(s3)) < 55296 || r3 > 56319 || s3 + 1 === o3 || (i = a3.charCodeAt(s3 + 1)) < 56320 || i > 57343 ? e28 ? a3.charAt(s3) : r3 : e28 ? a3.slice(s3, s3 + 2) : i - 56320 + (r3 - 55296 << 10) + 65536;
  };
}, Aa$2 = {}, CE = {};
Pn$1(CE, Ut$2("iterator"), function() {
  return this;
});
var SE = function(e28, t3, n3) {
  e28.prototype = Ei$1(CE, { next: $i$1(1, n3) }), ka$2(e28, t3 + " Iterator");
}, xu$1 = Ut$2("iterator"), Wh = !([].keys && "next" in [].keys()), Xy = function() {
  return this;
}, S0 = function(e28, t3, n3, r3, i, a3, s3) {
  SE(n3, t3, r3);
  var o3, u3, c3, f3 = function(k3) {
    if (!Wh && k3 in y3)
      return y3[k3];
    switch (k3) {
      case "keys":
      case "values":
        return function() {
          return new n3(this, k3);
        };
    }
    return function() {
      return new n3(this, k3);
    };
  }, p3 = t3 + " Iterator", d3 = i == "values", m3 = false, y3 = e28.prototype, v3 = y3[xu$1] || y3["@@iterator"] || i && y3[i], b3 = v3 || f3(i), x3 = i ? d3 ? f3("entries") : b3 : void 0, C3 = t3 == "Array" && y3.entries || v3;
  if (C3 && (c3 = No$2(C3.call(new e28()))) !== Object.prototype && c3.next && (ka$2(c3, p3, true), typeof c3[xu$1] != "function" && Pn$1(c3, xu$1, Xy)), d3 && v3 && v3.name !== "values" && (m3 = true, b3 = function() {
    return v3.call(this);
  }), (Wh || m3 || !y3[xu$1]) && Pn$1(y3, xu$1, b3), Aa$2[t3] = b3, Aa$2[p3] = Xy, i)
    if (o3 = { values: d3 ? b3 : f3("values"), keys: a3 ? b3 : f3("keys"), entries: x3 }, s3)
      for (u3 in o3)
        u3 in y3 || Er$1(y3, u3, o3[u3]);
    else
      H$b(H$b.P + H$b.F * (Wh || m3), t3, o3);
  return o3;
}, h7 = C0(true);
S0(String, "String", function(e28) {
  this._t = String(e28), this._i = 0;
}, function() {
  var e28, t3 = this._t, n3 = this._i;
  return n3 >= t3.length ? { value: void 0, done: true } : (e28 = h7(t3, n3), this._i += e28.length, { value: e28, done: false });
});
var d7 = C0(false);
H$b(H$b.P, "String", { codePointAt: function(e28) {
  return d7(this, e28);
} });
var m7 = Ut$2("match"), k0 = function(e28) {
  var t3;
  return ht$3(e28) && ((t3 = e28[m7]) !== void 0 ? !!t3 : si$1(e28) == "RegExp");
}, D0 = function(e28, t3, n3) {
  if (k0(t3))
    throw TypeError("String#" + n3 + " doesn't accept regex!");
  return String(Ta$2(e28));
}, g7 = Ut$2("match"), F0 = function(e28) {
  var t3 = /./;
  try {
    "/./"[e28](t3);
  } catch {
    try {
      return t3[g7] = false, !"/./"[e28](t3);
    } catch {
    }
  }
  return true;
}, Yy = "".endsWith;
H$b(H$b.P + H$b.F * F0("endsWith"), "String", { endsWith: function(e28) {
  var t3 = D0(this, e28, "endsWith"), n3 = arguments.length > 1 ? arguments[1] : void 0, r3 = sn$1(t3.length), i = n3 === void 0 ? r3 : Math.min(sn$1(n3), r3), a3 = String(e28);
  return Yy ? Yy.call(t3, a3, i) : t3.slice(i - a3.length, i) === a3;
} });
H$b(H$b.P + H$b.F * F0("includes"), "String", { includes: function(e28) {
  return !!~D0(this, e28, "includes").indexOf(e28, arguments.length > 1 ? arguments[1] : void 0);
} }), H$b(H$b.P, "String", { repeat: oc$2 });
var Zy = "".startsWith;
H$b(H$b.P + H$b.F * F0("startsWith"), "String", { startsWith: function(e28) {
  var t3 = D0(this, e28, "startsWith"), n3 = sn$1(Math.min(arguments.length > 1 ? arguments[1] : void 0, t3.length)), r3 = String(e28);
  return Zy ? Zy.call(t3, r3, n3) : t3.slice(n3, n3 + r3.length) === r3;
} });
var y7 = /"/g, v7 = function(e28, t3, n3, r3) {
  var i = String(Ta$2(e28)), a3 = "<" + t3;
  return n3 !== "" && (a3 += " " + n3 + '="' + String(r3).replace(y7, "&quot;") + '"'), a3 + ">" + i + "</" + t3 + ">";
}, Tr$1 = function(e28, t3) {
  var n3 = {};
  n3[e28] = t3(v7), H$b(H$b.P + H$b.F * pt$3(function() {
    var r3 = ""[e28]('"');
    return r3 !== r3.toLowerCase() || r3.split('"').length > 3;
  }), "String", n3);
};
Tr$1("anchor", function(e28) {
  return function(t3) {
    return e28(this, "a", "name", t3);
  };
}), Tr$1("big", function(e28) {
  return function() {
    return e28(this, "big", "", "");
  };
}), Tr$1("blink", function(e28) {
  return function() {
    return e28(this, "blink", "", "");
  };
}), Tr$1("bold", function(e28) {
  return function() {
    return e28(this, "b", "", "");
  };
}), Tr$1("fixed", function(e28) {
  return function() {
    return e28(this, "tt", "", "");
  };
}), Tr$1("fontcolor", function(e28) {
  return function(t3) {
    return e28(this, "font", "color", t3);
  };
}), Tr$1("fontsize", function(e28) {
  return function(t3) {
    return e28(this, "font", "size", t3);
  };
}), Tr$1("italics", function(e28) {
  return function() {
    return e28(this, "i", "", "");
  };
}), Tr$1("link", function(e28) {
  return function(t3) {
    return e28(this, "a", "href", t3);
  };
}), Tr$1("small", function(e28) {
  return function() {
    return e28(this, "small", "", "");
  };
}), Tr$1("strike", function(e28) {
  return function() {
    return e28(this, "strike", "", "");
  };
}), Tr$1("sub", function(e28) {
  return function() {
    return e28(this, "sub", "", "");
  };
}), Tr$1("sup", function(e28) {
  return function() {
    return e28(this, "sup", "", "");
  };
}), H$b(H$b.S, "Date", { now: function() {
  return (/* @__PURE__ */ new Date()).getTime();
} }), H$b(H$b.P + H$b.F * pt$3(function() {
  return (/* @__PURE__ */ new Date(NaN)).toJSON() !== null || Date.prototype.toJSON.call({ toISOString: function() {
    return 1;
  } }) !== 1;
}), "Date", { toJSON: function(e28) {
  var t3 = Zn$1(this), n3 = Gi$1(t3);
  return typeof n3 != "number" || isFinite(n3) ? t3.toISOString() : null;
} });
var x7 = Date.prototype.getTime, $h = Date.prototype.toISOString, us$1 = function(e28) {
  return e28 > 9 ? e28 : "0" + e28;
}, ev = pt$3(function() {
  return $h.call(new Date(-5e13 - 1)) != "0385-07-25T07:06:39.999Z";
}) || !pt$3(function() {
  $h.call(/* @__PURE__ */ new Date(NaN));
}) ? function() {
  if (!isFinite(x7.call(this)))
    throw RangeError("Invalid time value");
  var e28 = this, t3 = e28.getUTCFullYear(), n3 = e28.getUTCMilliseconds(), r3 = t3 < 0 ? "-" : t3 > 9999 ? "+" : "";
  return r3 + ("00000" + Math.abs(t3)).slice(r3 ? -6 : -4) + "-" + us$1(e28.getUTCMonth() + 1) + "-" + us$1(e28.getUTCDate()) + "T" + us$1(e28.getUTCHours()) + ":" + us$1(e28.getUTCMinutes()) + ":" + us$1(e28.getUTCSeconds()) + "." + (n3 > 99 ? n3 : "0" + us$1(n3)) + "Z";
} : $h;
H$b(H$b.P + H$b.F * (Date.prototype.toISOString !== ev), "Date", { toISOString: ev });
var w0 = Date.prototype, b7 = w0.toString, E7 = w0.getTime;
/* @__PURE__ */ new Date(NaN) + "" != "Invalid Date" && Er$1(w0, "toString", function() {
  var e28 = E7.call(this);
  return e28 == e28 ? b7.call(this) : "Invalid Date";
});
var tv = Ut$2("toPrimitive"), nv = Date.prototype;
tv in nv || Pn$1(nv, tv, function(e28) {
  if (e28 !== "string" && e28 !== "number" && e28 !== "default")
    throw TypeError("Incorrect hint");
  return Gi$1(Ct$2(this), e28 != "number");
}), H$b(H$b.S, "Array", { isArray: ic$2 });
var kE = function(e28, t3, n3, r3) {
  try {
    return r3 ? t3(Ct$2(n3)[0], n3[1]) : t3(n3);
  } catch (a3) {
    var i = e28.return;
    throw i !== void 0 && Ct$2(i.call(e28)), a3;
  }
}, C7 = Ut$2("iterator"), S7 = Array.prototype, A0 = function(e28) {
  return e28 !== void 0 && (Aa$2.Array === e28 || S7[C7] === e28);
}, ip = function(e28, t3, n3) {
  t3 in e28 ? En$1.f(e28, t3, $i$1(0, n3)) : e28[t3] = n3;
}, k7 = Ut$2("iterator"), _0 = hn$1.getIteratorMethod = function(e28) {
  if (e28 != null)
    return e28[k7] || e28["@@iterator"] || Aa$2[bc$2(e28)];
}, vm = Ut$2("iterator"), DE = false;
try {
  var rv = [7][vm]();
  rv.return = function() {
    DE = true;
  }, Array.from(rv, function() {
    throw 2;
  });
} catch {
}
var of = function(e28, t3) {
  if (!t3 && !DE)
    return false;
  var n3 = false;
  try {
    var r3 = [7], i = r3[vm]();
    i.next = function() {
      return { done: n3 = true };
    }, r3[vm] = function() {
      return i;
    }, e28(r3);
  } catch {
  }
  return n3;
};
H$b(H$b.S + H$b.F * !of(function(e28) {
  Array.from(e28);
}), "Array", { from: function(e28) {
  var t3, n3, r3, i, a3 = Zn$1(e28), s3 = typeof this == "function" ? this : Array, o3 = arguments.length, u3 = o3 > 1 ? arguments[1] : void 0, c3 = u3 !== void 0, f3 = 0, p3 = _0(a3);
  if (c3 && (u3 = In$1(u3, o3 > 2 ? arguments[2] : void 0, 2)), p3 == null || s3 == Array && A0(p3))
    for (n3 = new s3(t3 = sn$1(a3.length)); t3 > f3; f3++)
      ip(n3, f3, c3 ? u3(a3[f3], f3) : a3[f3]);
  else
    for (i = p3.call(a3), n3 = new s3(); !(r3 = i.next()).done; f3++)
      ip(n3, f3, c3 ? kE(i, u3, [r3.value, f3], true) : r3.value);
  return n3.length = f3, n3;
} }), H$b(H$b.S + H$b.F * pt$3(function() {
  function e28() {
  }
  return !(Array.of.call(e28) instanceof e28);
}), "Array", { of: function() {
  for (var e28 = 0, t3 = arguments.length, n3 = new (typeof this == "function" ? this : Array)(t3); t3 > e28; )
    ip(n3, e28, arguments[e28++]);
  return n3.length = t3, n3;
} });
var Ci$1 = function(e28, t3) {
  return !!e28 && pt$3(function() {
    t3 ? e28.call(null, function() {
    }, 1) : e28.call(null);
  });
}, iv = [].join;
H$b(H$b.P + H$b.F * (yc$2 != Object || !Ci$1(iv)), "Array", { join: function(e28) {
  return iv.call(lr$1(this), e28 === void 0 ? "," : e28);
} });
var av = [].slice;
H$b(H$b.P + H$b.F * pt$3(function() {
  ac$2 && av.call(ac$2);
}), "Array", { slice: function(e28, t3) {
  var n3 = sn$1(this.length), r3 = si$1(this);
  if (t3 = t3 === void 0 ? n3 : t3, r3 == "Array")
    return av.call(this, e28, t3);
  for (var i = ai$1(e28, n3), a3 = ai$1(t3, n3), s3 = sn$1(a3 - i), o3 = new Array(s3), u3 = 0; u3 < s3; u3++)
    o3[u3] = r3 == "String" ? this.charAt(i + u3) : this[i + u3];
  return o3;
} });
var Gh = [].sort, ov = [1, 2, 3];
H$b(H$b.P + H$b.F * (pt$3(function() {
  ov.sort(void 0);
}) || !pt$3(function() {
  ov.sort(null);
}) || !Ci$1(Gh)), "Array", { sort: function(e28) {
  return e28 === void 0 ? Gh.call(Zn$1(this)) : Gh.call(Zn$1(this), oi$1(e28));
} });
var D7 = Ut$2("species"), FE = function(e28, t3) {
  return new (function(n3) {
    var r3;
    return ic$2(n3) && (typeof (r3 = n3.constructor) != "function" || r3 !== Array && !ic$2(r3.prototype) || (r3 = void 0), ht$3(r3) && (r3 = r3[D7]) === null && (r3 = void 0)), r3 === void 0 ? Array : r3;
  }(e28))(t3);
}, Si$1 = function(e28, t3) {
  var n3 = e28 == 1, r3 = e28 == 2, i = e28 == 3, a3 = e28 == 4, s3 = e28 == 6, o3 = e28 == 5 || s3, u3 = t3 || FE;
  return function(c3, f3, p3) {
    for (var d3, m3, y3 = Zn$1(c3), v3 = yc$2(y3), b3 = In$1(f3, p3, 3), x3 = sn$1(v3.length), C3 = 0, k3 = n3 ? u3(c3, x3) : r3 ? u3(c3, 0) : void 0; x3 > C3; C3++)
      if ((o3 || C3 in v3) && (m3 = b3(d3 = v3[C3], C3, y3), e28)) {
        if (n3)
          k3[C3] = m3;
        else if (m3)
          switch (e28) {
            case 3:
              return true;
            case 5:
              return d3;
            case 6:
              return C3;
            case 2:
              k3.push(d3);
          }
        else if (a3)
          return false;
      }
    return s3 ? -1 : i || a3 ? a3 : k3;
  };
}, F7 = Si$1(0), w7 = Ci$1([].forEach, true);
H$b(H$b.P + H$b.F * !w7, "Array", { forEach: function(e28) {
  return F7(this, e28, arguments[1]);
} });
var A7 = Si$1(1);
H$b(H$b.P + H$b.F * !Ci$1([].map, true), "Array", { map: function(e28) {
  return A7(this, e28, arguments[1]);
} });
var _7 = Si$1(2);
H$b(H$b.P + H$b.F * !Ci$1([].filter, true), "Array", { filter: function(e28) {
  return _7(this, e28, arguments[1]);
} });
var T7 = Si$1(3);
H$b(H$b.P + H$b.F * !Ci$1([].some, true), "Array", { some: function(e28) {
  return T7(this, e28, arguments[1]);
} });
var P7 = Si$1(4);
H$b(H$b.P + H$b.F * !Ci$1([].every, true), "Array", { every: function(e28) {
  return P7(this, e28, arguments[1]);
} });
var sv = function(e28, t3, n3, r3, i) {
  oi$1(t3);
  var a3 = Zn$1(e28), s3 = yc$2(a3), o3 = sn$1(a3.length), u3 = i ? o3 - 1 : 0, c3 = i ? -1 : 1;
  if (n3 < 2)
    for (; ; ) {
      if (u3 in s3) {
        r3 = s3[u3], u3 += c3;
        break;
      }
      if (u3 += c3, i ? u3 < 0 : o3 <= u3)
        throw TypeError("Reduce of empty array with no initial value");
    }
  for (; i ? u3 >= 0 : o3 > u3; u3 += c3)
    u3 in s3 && (r3 = t3(r3, s3[u3], u3, a3));
  return r3;
};
H$b(H$b.P + H$b.F * !Ci$1([].reduce, true), "Array", { reduce: function(e28) {
  return sv(this, e28, arguments.length, arguments[1], false);
} }), H$b(H$b.P + H$b.F * !Ci$1([].reduceRight, true), "Array", { reduceRight: function(e28) {
  return sv(this, e28, arguments.length, arguments[1], true);
} });
var I7 = nf(false), xm = [].indexOf, uv = !!xm && 1 / [1].indexOf(1, -0) < 0;
H$b(H$b.P + H$b.F * (uv || !Ci$1(xm)), "Array", { indexOf: function(e28) {
  return uv ? xm.apply(this, arguments) || 0 : I7(this, e28, arguments[1]);
} });
var bm = [].lastIndexOf, cv = !!bm && 1 / [1].lastIndexOf(1, -0) < 0;
H$b(H$b.P + H$b.F * (cv || !Ci$1(bm)), "Array", { lastIndexOf: function(e28) {
  if (cv)
    return bm.apply(this, arguments) || 0;
  var t3 = lr$1(this), n3 = sn$1(t3.length), r3 = n3 - 1;
  for (arguments.length > 1 && (r3 = Math.min(r3, zi$1(arguments[1]))), r3 < 0 && (r3 = n3 + r3); r3 >= 0; r3--)
    if (r3 in t3 && t3[r3] === e28)
      return r3 || 0;
  return -1;
} });
var wE = [].copyWithin || function(e28, t3) {
  var n3 = Zn$1(this), r3 = sn$1(n3.length), i = ai$1(e28, r3), a3 = ai$1(t3, r3), s3 = arguments.length > 2 ? arguments[2] : void 0, o3 = Math.min((s3 === void 0 ? r3 : ai$1(s3, r3)) - a3, r3 - i), u3 = 1;
  for (a3 < i && i < a3 + o3 && (u3 = -1, a3 += o3 - 1, i += o3 - 1); o3-- > 0; )
    a3 in n3 ? n3[i] = n3[a3] : delete n3[i], i += u3, a3 += u3;
  return n3;
}, Em = Ut$2("unscopables"), Cm = Array.prototype;
Cm[Em] == null && Pn$1(Cm, Em, {});
var Da$2 = function(e28) {
  Cm[Em][e28] = true;
};
H$b(H$b.P, "Array", { copyWithin: wE }), Da$2("copyWithin");
var T0 = function(e28) {
  for (var t3 = Zn$1(this), n3 = sn$1(t3.length), r3 = arguments.length, i = ai$1(r3 > 1 ? arguments[1] : void 0, n3), a3 = r3 > 2 ? arguments[2] : void 0, s3 = a3 === void 0 ? n3 : ai$1(a3, n3); s3 > i; )
    t3[i++] = e28;
  return t3;
};
H$b(H$b.P, "Array", { fill: T0 }), Da$2("fill");
var B7 = Si$1(5), lv = true;
"find" in [] && Array(1).find(function() {
  lv = false;
}), H$b(H$b.P + H$b.F * lv, "Array", { find: function(e28) {
  return B7(this, e28, arguments.length > 1 ? arguments[1] : void 0);
} }), Da$2("find");
var O7 = Si$1(6), pv = true;
"findIndex" in [] && Array(1).findIndex(function() {
  pv = false;
}), H$b(H$b.P + H$b.F * pv, "Array", { findIndex: function(e28) {
  return O7(this, e28, arguments.length > 1 ? arguments[1] : void 0);
} }), Da$2("findIndex");
var fv = Ut$2("species"), Xs$1 = function(e28) {
  var t3 = Re$3[e28];
  rn$1 && t3 && !t3[fv] && En$1.f(t3, fv, { configurable: true, get: function() {
    return this;
  } });
};
Xs$1("Array");
var Fp = function(e28, t3) {
  return { value: t3, done: !!e28 };
}, Sm = S0(Array, "Array", function(e28, t3) {
  this._t = lr$1(e28), this._i = 0, this._k = t3;
}, function() {
  var e28 = this._t, t3 = this._k, n3 = this._i++;
  return !e28 || n3 >= e28.length ? (this._t = void 0, Fp(1)) : Fp(0, t3 == "keys" ? n3 : t3 == "values" ? e28[n3] : [n3, e28[n3]]);
}, "values");
Aa$2.Arguments = Aa$2.Array, Da$2("keys"), Da$2("values"), Da$2("entries");
var sf = function() {
  var e28 = Ct$2(this), t3 = "";
  return e28.global && (t3 += "g"), e28.ignoreCase && (t3 += "i"), e28.multiline && (t3 += "m"), e28.unicode && (t3 += "u"), e28.sticky && (t3 += "y"), t3;
}, L7 = En$1.f, N7 = qo$1.f, Xn$1 = Re$3.RegExp, bu$1 = Xn$1, zh = Xn$1.prototype, Xu$1 = /a/g, Hh = /a/g, hv = new Xn$1(Xu$1) !== Xu$1;
if (rn$1 && (!hv || pt$3(function() {
  return Hh[Ut$2("match")] = false, Xn$1(Xu$1) != Xu$1 || Xn$1(Hh) == Hh || Xn$1(Xu$1, "i") != "/a/i";
}))) {
  Xn$1 = function(e28, t3) {
    var n3 = this instanceof Xn$1, r3 = k0(e28), i = t3 === void 0;
    return !n3 && r3 && e28.constructor === Xn$1 && i ? e28 : b0(hv ? new bu$1(r3 && !i ? e28.source : e28, t3) : bu$1((r3 = e28 instanceof Xn$1) ? e28.source : e28, r3 && i ? sf.call(e28) : t3), n3 ? this : zh, Xn$1);
  };
  for (var j7 = function(e28) {
    e28 in Xn$1 || L7(Xn$1, e28, { configurable: true, get: function() {
      return bu$1[e28];
    }, set: function(t3) {
      bu$1[e28] = t3;
    } });
  }, dv = N7(bu$1), mv = 0; dv.length > mv; )
    j7(dv[mv++]);
  zh.constructor = Xn$1, Xn$1.prototype = zh, Er$1(Re$3, "RegExp", Xn$1);
}
Xs$1("RegExp");
var wp = RegExp.prototype.exec, R7 = String.prototype.replace, AE = wp, Kh = function() {
  var e28 = /a/, t3 = /b*/g;
  return wp.call(e28, "a"), wp.call(t3, "a"), e28.lastIndex !== 0 || t3.lastIndex !== 0;
}(), Jh = /()??/.exec("")[1] !== void 0;
(Kh || Jh) && (AE = function(e28) {
  var t3, n3, r3, i, a3 = this;
  return Jh && (n3 = new RegExp("^" + a3.source + "$(?!\\s)", sf.call(a3))), Kh && (t3 = a3.lastIndex), r3 = wp.call(a3, e28), Kh && r3 && (a3.lastIndex = a3.global ? r3.index + r3[0].length : t3), Jh && r3 && r3.length > 1 && R7.call(r3[0], n3, function() {
    for (i = 1; i < arguments.length - 2; i++)
      arguments[i] === void 0 && (r3[i] = void 0);
  }), r3;
});
var Ap = AE;
H$b({ target: "RegExp", proto: true, forced: Ap !== /./.exec }, { exec: Ap }), rn$1 && /./g.flags != "g" && En$1.f(RegExp.prototype, "flags", { configurable: true, get: sf });
var Qh = /./.toString, gv = function(e28) {
  Er$1(RegExp.prototype, "toString", e28, true);
};
pt$3(function() {
  return Qh.call({ source: "a", flags: "b" }) != "/a/b";
}) ? gv(function() {
  var e28 = Ct$2(this);
  return "/".concat(e28.source, "/", "flags" in e28 ? e28.flags : !rn$1 && e28 instanceof RegExp ? sf.call(e28) : void 0);
}) : Qh.name != "toString" && gv(function() {
  return Qh.call(this);
});
var M7 = C0(true), P0 = function(e28, t3, n3) {
  return t3 + (n3 ? M7(e28, t3).length : 1);
}, V7 = RegExp.prototype.exec, Vs$1 = function(e28, t3) {
  var n3 = e28.exec;
  if (typeof n3 == "function") {
    var r3 = n3.call(e28, t3);
    if (xe$3(r3) !== "object")
      throw new TypeError("RegExp exec method returned something other than an Object or null");
    return r3;
  }
  if (bc$2(e28) !== "RegExp")
    throw new TypeError("RegExp#exec called on incompatible receiver");
  return V7.call(e28, t3);
}, U7 = Ut$2("species"), q7 = !pt$3(function() {
  var e28 = /./;
  return e28.exec = function() {
    var t3 = [];
    return t3.groups = { a: "7" }, t3;
  }, "".replace(e28, "$<a>") !== "7";
}), W7 = function() {
  var e28 = /(?:)/, t3 = e28.exec;
  e28.exec = function() {
    return t3.apply(this, arguments);
  };
  var n3 = "ab".split(e28);
  return n3.length === 2 && n3[0] === "a" && n3[1] === "b";
}(), _p = function(e28, t3, n3) {
  var r3 = Ut$2(e28), i = !pt$3(function() {
    var f3 = {};
    return f3[r3] = function() {
      return 7;
    }, ""[e28](f3) != 7;
  }), a3 = i ? !pt$3(function() {
    var f3 = false, p3 = /a/;
    return p3.exec = function() {
      return f3 = true, null;
    }, e28 === "split" && (p3.constructor = {}, p3.constructor[U7] = function() {
      return p3;
    }), p3[r3](""), !f3;
  }) : void 0;
  if (!i || !a3 || e28 === "replace" && !q7 || e28 === "split" && !W7) {
    var s3 = /./[r3], o3 = n3(Ta$2, r3, ""[e28], function(f3, p3, d3, m3, y3) {
      return p3.exec === Ap ? i && !y3 ? { done: true, value: s3.call(p3, d3, m3) } : { done: true, value: f3.call(d3, p3, m3) } : { done: false };
    }), u3 = o3[0], c3 = o3[1];
    Er$1(String.prototype, e28, u3), Pn$1(RegExp.prototype, r3, t3 == 2 ? function(f3, p3) {
      return c3.call(f3, this, p3);
    } : function(f3) {
      return c3.call(f3, this);
    });
  }
};
_p("match", 1, function(e28, t3, n3, r3) {
  return [function(i) {
    var a3 = e28(this), s3 = i == null ? void 0 : i[t3];
    return s3 !== void 0 ? s3.call(i, a3) : new RegExp(i)[t3](String(a3));
  }, function(i) {
    var a3 = r3(n3, i, this);
    if (a3.done)
      return a3.value;
    var s3 = Ct$2(i), o3 = String(this);
    if (!s3.global)
      return Vs$1(s3, o3);
    var u3 = s3.unicode;
    s3.lastIndex = 0;
    for (var c3, f3 = [], p3 = 0; (c3 = Vs$1(s3, o3)) !== null; ) {
      var d3 = String(c3[0]);
      f3[p3] = d3, d3 === "" && (s3.lastIndex = P0(o3, sn$1(s3.lastIndex), u3)), p3++;
    }
    return p3 === 0 ? null : f3;
  }];
});
var $7 = Math.max, G7 = Math.min, z7 = Math.floor, H7 = /\$([$&`']|\d\d?|<[^>]*>)/g, K7 = /\$([$&`']|\d\d?)/g;
_p("replace", 2, function(e28, t3, n3, r3) {
  return [function(a3, s3) {
    var o3 = e28(this), u3 = a3 == null ? void 0 : a3[t3];
    return u3 !== void 0 ? u3.call(a3, o3, s3) : n3.call(String(o3), a3, s3);
  }, function(a3, s3) {
    var o3 = r3(n3, a3, this, s3);
    if (o3.done)
      return o3.value;
    var u3 = Ct$2(a3), c3 = String(this), f3 = typeof s3 == "function";
    f3 || (s3 = String(s3));
    var p3 = u3.global;
    if (p3) {
      var d3 = u3.unicode;
      u3.lastIndex = 0;
    }
    for (var m3 = []; ; ) {
      var y3 = Vs$1(u3, c3);
      if (y3 === null || (m3.push(y3), !p3))
        break;
      String(y3[0]) === "" && (u3.lastIndex = P0(c3, sn$1(u3.lastIndex), d3));
    }
    for (var v3, b3 = "", x3 = 0, C3 = 0; C3 < m3.length; C3++) {
      y3 = m3[C3];
      for (var k3 = String(y3[0]), F3 = $7(G7(zi$1(y3.index), c3.length), 0), B3 = [], O3 = 1; O3 < y3.length; O3++)
        B3.push((v3 = y3[O3]) === void 0 ? v3 : String(v3));
      var S3 = y3.groups;
      if (f3) {
        var w3 = [k3].concat(B3, F3, c3);
        S3 !== void 0 && w3.push(S3);
        var D3 = String(s3.apply(void 0, w3));
      } else
        D3 = i(k3, c3, F3, B3, S3, s3);
      F3 >= x3 && (b3 += c3.slice(x3, F3) + D3, x3 = F3 + k3.length);
    }
    return b3 + c3.slice(x3);
  }];
  function i(a3, s3, o3, u3, c3, f3) {
    var p3 = o3 + a3.length, d3 = u3.length, m3 = K7;
    return c3 !== void 0 && (c3 = Zn$1(c3), m3 = H7), n3.call(f3, m3, function(y3, v3) {
      var b3;
      switch (v3.charAt(0)) {
        case "$":
          return "$";
        case "&":
          return a3;
        case "`":
          return s3.slice(0, o3);
        case "'":
          return s3.slice(p3);
        case "<":
          b3 = c3[v3.slice(1, -1)];
          break;
        default:
          var x3 = +v3;
          if (x3 === 0)
            return y3;
          if (x3 > d3) {
            var C3 = z7(x3 / 10);
            return C3 === 0 ? y3 : C3 <= d3 ? u3[C3 - 1] === void 0 ? v3.charAt(1) : u3[C3 - 1] + v3.charAt(1) : y3;
          }
          b3 = u3[x3 - 1];
      }
      return b3 === void 0 ? "" : b3;
    });
  }
}), _p("search", 1, function(e28, t3, n3, r3) {
  return [function(i) {
    var a3 = e28(this), s3 = i == null ? void 0 : i[t3];
    return s3 !== void 0 ? s3.call(i, a3) : new RegExp(i)[t3](String(a3));
  }, function(i) {
    var a3 = r3(n3, i, this);
    if (a3.done)
      return a3.value;
    var s3 = Ct$2(i), o3 = String(this), u3 = s3.lastIndex;
    ym(u3, 0) || (s3.lastIndex = 0);
    var c3 = Vs$1(s3, o3);
    return ym(s3.lastIndex, u3) || (s3.lastIndex = u3), c3 === null ? -1 : c3.index;
  }];
});
var J7 = Ut$2("species"), Ec$2 = function(e28, t3) {
  var n3, r3 = Ct$2(e28).constructor;
  return r3 === void 0 || (n3 = Ct$2(r3)[J7]) == null ? t3 : oi$1(n3);
}, Q7 = Math.min, X7 = [].push, Eu$1 = !pt$3(function() {
  RegExp(4294967295, "y");
});
_p("split", 2, function(e28, t3, n3, r3) {
  var i;
  return i = "abbc".split(/(b)*/)[1] == "c" || "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function(a3, s3) {
    var o3 = String(this);
    if (a3 === void 0 && s3 === 0)
      return [];
    if (!k0(a3))
      return n3.call(o3, a3, s3);
    for (var u3, c3, f3, p3 = [], d3 = (a3.ignoreCase ? "i" : "") + (a3.multiline ? "m" : "") + (a3.unicode ? "u" : "") + (a3.sticky ? "y" : ""), m3 = 0, y3 = s3 === void 0 ? 4294967295 : s3 >>> 0, v3 = new RegExp(a3.source, d3 + "g"); (u3 = Ap.call(v3, o3)) && !((c3 = v3.lastIndex) > m3 && (p3.push(o3.slice(m3, u3.index)), u3.length > 1 && u3.index < o3.length && X7.apply(p3, u3.slice(1)), f3 = u3[0].length, m3 = c3, p3.length >= y3)); )
      v3.lastIndex === u3.index && v3.lastIndex++;
    return m3 === o3.length ? !f3 && v3.test("") || p3.push("") : p3.push(o3.slice(m3)), p3.length > y3 ? p3.slice(0, y3) : p3;
  } : "0".split(void 0, 0).length ? function(a3, s3) {
    return a3 === void 0 && s3 === 0 ? [] : n3.call(this, a3, s3);
  } : n3, [function(a3, s3) {
    var o3 = e28(this), u3 = a3 == null ? void 0 : a3[t3];
    return u3 !== void 0 ? u3.call(a3, o3, s3) : i.call(String(o3), a3, s3);
  }, function(a3, s3) {
    var o3 = r3(i, a3, this, s3, i !== n3);
    if (o3.done)
      return o3.value;
    var u3 = Ct$2(a3), c3 = String(this), f3 = Ec$2(u3, RegExp), p3 = u3.unicode, d3 = (u3.ignoreCase ? "i" : "") + (u3.multiline ? "m" : "") + (u3.unicode ? "u" : "") + (Eu$1 ? "y" : "g"), m3 = new f3(Eu$1 ? u3 : "^(?:" + u3.source + ")", d3), y3 = s3 === void 0 ? 4294967295 : s3 >>> 0;
    if (y3 === 0)
      return [];
    if (c3.length === 0)
      return Vs$1(m3, c3) === null ? [c3] : [];
    for (var v3 = 0, b3 = 0, x3 = []; b3 < c3.length; ) {
      m3.lastIndex = Eu$1 ? b3 : 0;
      var C3, k3 = Vs$1(m3, Eu$1 ? c3 : c3.slice(b3));
      if (k3 === null || (C3 = Q7(sn$1(m3.lastIndex + (Eu$1 ? 0 : b3)), c3.length)) === v3)
        b3 = P0(c3, b3, p3);
      else {
        if (x3.push(c3.slice(v3, b3)), x3.length === y3)
          return x3;
        for (var F3 = 1; F3 <= k3.length - 1; F3++)
          if (x3.push(k3[F3]), x3.length === y3)
            return x3;
        b3 = v3 = C3;
      }
    }
    return x3.push(c3.slice(v3)), x3;
  }];
});
var cs$1, yv, Xh, xa$1 = function(e28, t3, n3, r3) {
  if (!(e28 instanceof t3) || r3 !== void 0 && r3 in e28)
    throw TypeError(n3 + ": incorrect invocation!");
  return e28;
}, sc$2 = gt$3(function(e28) {
  var t3 = {}, n3 = {}, r3 = e28.exports = function(i, a3, s3, o3, u3) {
    var c3, f3, p3, d3, m3 = u3 ? function() {
      return i;
    } : _0(i), y3 = In$1(s3, o3, a3 ? 2 : 1), v3 = 0;
    if (typeof m3 != "function")
      throw TypeError(i + " is not iterable!");
    if (A0(m3)) {
      for (c3 = sn$1(i.length); c3 > v3; v3++)
        if ((d3 = a3 ? y3(Ct$2(f3 = i[v3])[0], f3[1]) : y3(i[v3])) === t3 || d3 === n3)
          return d3;
    } else
      for (p3 = m3.call(i); !(f3 = p3.next()).done; )
        if ((d3 = kE(p3, y3, f3.value, a3)) === t3 || d3 === n3)
          return d3;
  };
  r3.BREAK = t3, r3.RETURN = n3;
}), vv = Re$3.process, km = Re$3.setImmediate, Dm = Re$3.clearImmediate, xv = Re$3.MessageChannel, Yh = Re$3.Dispatch, Zh = 0, Yu$1 = {}, Nu$1 = function() {
  var e28 = +this;
  if (Yu$1.hasOwnProperty(e28)) {
    var t3 = Yu$1[e28];
    delete Yu$1[e28], t3();
  }
}, bv = function(e28) {
  Nu$1.call(e28.data);
};
km && Dm || (km = function(e28) {
  for (var t3 = [], n3 = 1; arguments.length > n3; )
    t3.push(arguments[n3++]);
  return Yu$1[++Zh] = function() {
    mE(typeof e28 == "function" ? e28 : Function(e28), t3);
  }, cs$1(Zh), Zh;
}, Dm = function(e28) {
  delete Yu$1[e28];
}, si$1(vv) == "process" ? cs$1 = function(e28) {
  vv.nextTick(In$1(Nu$1, e28, 1));
} : Yh && Yh.now ? cs$1 = function(e28) {
  Yh.now(In$1(Nu$1, e28, 1));
} : xv ? (Xh = (yv = new xv()).port2, yv.port1.onmessage = bv, cs$1 = In$1(Xh.postMessage, Xh, 1)) : Re$3.addEventListener && typeof postMessage == "function" && !Re$3.importScripts ? (cs$1 = function(e28) {
  Re$3.postMessage(e28 + "", "*");
}, Re$3.addEventListener("message", bv, false)) : cs$1 = "onreadystatechange" in bp("script") ? function(e28) {
  ac$2.appendChild(bp("script")).onreadystatechange = function() {
    ac$2.removeChild(this), Nu$1.call(e28);
  };
} : function(e28) {
  setTimeout(In$1(Nu$1, e28, 1), 0);
});
var Tp = { set: km, clear: Dm }, Y7 = Tp.set, Ev = Re$3.MutationObserver || Re$3.WebKitMutationObserver, Fm = Re$3.process, ed$1 = Re$3.Promise, Cv = si$1(Fm) == "process";
function Z7(e28) {
  var t3, n3;
  this.promise = new e28(function(r3, i) {
    if (t3 !== void 0 || n3 !== void 0)
      throw TypeError("Bad Promise constructor");
    t3 = r3, n3 = i;
  }), this.resolve = oi$1(t3), this.reject = oi$1(n3);
}
var td$1, _E, Sv, kv, I0 = { f: function(e28) {
  return new Z7(e28);
} }, wm = function(e28) {
  try {
    return { e: false, v: e28() };
  } catch (t3) {
    return { e: true, v: t3 };
  }
}, Dv = Re$3.navigator, uf = Dv && Dv.userAgent || "", Am = function(e28, t3) {
  if (Ct$2(e28), ht$3(t3) && t3.constructor === e28)
    return t3;
  var n3 = I0.f(e28);
  return (0, n3.resolve)(t3), n3.promise;
}, jo$1 = function(e28, t3, n3) {
  for (var r3 in t3)
    Er$1(e28, r3, t3[r3], n3);
  return e28;
}, TE = Tp.set, PE = function() {
  var e28, t3, n3, r3 = function() {
    var o3, u3;
    for (Cv && (o3 = Fm.domain) && o3.exit(); e28; ) {
      u3 = e28.fn, e28 = e28.next;
      try {
        u3();
      } catch (c3) {
        throw e28 ? n3() : t3 = void 0, c3;
      }
    }
    t3 = void 0, o3 && o3.enter();
  };
  if (Cv)
    n3 = function() {
      Fm.nextTick(r3);
    };
  else if (!Ev || Re$3.navigator && Re$3.navigator.standalone)
    if (ed$1 && ed$1.resolve) {
      var i = ed$1.resolve(void 0);
      n3 = function() {
        i.then(r3);
      };
    } else
      n3 = function() {
        Y7.call(Re$3, r3);
      };
  else {
    var a3 = true, s3 = document.createTextNode("");
    new Ev(r3).observe(s3, { characterData: true }), n3 = function() {
      s3.data = a3 = !a3;
    };
  }
  return function(o3) {
    var u3 = { fn: o3, next: void 0 };
    t3 && (t3.next = u3), e28 || (e28 = u3, n3()), t3 = u3;
  };
}(), IE = Re$3.TypeError, Us$1 = Re$3.process, Fv = Us$1 && Us$1.versions, e4 = Fv && Fv.v8 || "", fa$2 = Re$3.Promise, uc$2 = bc$2(Us$1) == "process", ap = function() {
}, Cu$1 = _E = I0.f, Su$1 = !!function() {
  try {
    var e28 = fa$2.resolve(1), t3 = (e28.constructor = {})[Ut$2("species")] = function(n3) {
      n3(ap, ap);
    };
    return (uc$2 || typeof PromiseRejectionEvent == "function") && e28.then(ap) instanceof t3 && e4.indexOf("6.6") !== 0 && uf.indexOf("Chrome/66") === -1;
  } catch {
  }
}(), BE = function(e28) {
  var t3;
  return !(!ht$3(e28) || typeof (t3 = e28.then) != "function") && t3;
}, B0 = function(e28, t3) {
  if (!e28._n) {
    e28._n = true;
    var n3 = e28._c;
    PE(function() {
      for (var r3 = e28._v, i = e28._s == 1, a3 = 0, s3 = function(o3) {
        var u3, c3, f3, p3 = i ? o3.ok : o3.fail, d3 = o3.resolve, m3 = o3.reject, y3 = o3.domain;
        try {
          p3 ? (i || (e28._h == 2 && n4(e28), e28._h = 1), p3 === true ? u3 = r3 : (y3 && y3.enter(), u3 = p3(r3), y3 && (y3.exit(), f3 = true)), u3 === o3.promise ? m3(IE("Promise-chain cycle")) : (c3 = BE(u3)) ? c3.call(u3, d3, m3) : d3(u3)) : m3(r3);
        } catch (v3) {
          y3 && !f3 && y3.exit(), m3(v3);
        }
      }; n3.length > a3; )
        s3(n3[a3++]);
      e28._c = [], e28._n = false, t3 && !e28._h && t4(e28);
    });
  }
}, t4 = function(e28) {
  TE.call(Re$3, function() {
    var t3, n3, r3, i = e28._v, a3 = wv(e28);
    if (a3 && (t3 = wm(function() {
      uc$2 ? Us$1.emit("unhandledRejection", i, e28) : (n3 = Re$3.onunhandledrejection) ? n3({ promise: e28, reason: i }) : (r3 = Re$3.console) && r3.error && r3.error("Unhandled promise rejection", i);
    }), e28._h = uc$2 || wv(e28) ? 2 : 1), e28._a = void 0, a3 && t3.e)
      throw t3.v;
  });
}, wv = function(e28) {
  return e28._h !== 1 && (e28._a || e28._c).length === 0;
}, n4 = function(e28) {
  TE.call(Re$3, function() {
    var t3;
    uc$2 ? Us$1.emit("rejectionHandled", e28) : (t3 = Re$3.onrejectionhandled) && t3({ promise: e28, reason: e28._v });
  });
}, ws$1 = function(e28) {
  var t3 = this;
  t3._d || (t3._d = true, (t3 = t3._w || t3)._v = e28, t3._s = 2, t3._a || (t3._a = t3._c.slice()), B0(t3, true));
}, Av = function e5(t3) {
  var n3, r3 = this;
  if (!r3._d) {
    r3._d = true, r3 = r3._w || r3;
    try {
      if (r3 === t3)
        throw IE("Promise can't be resolved itself");
      (n3 = BE(t3)) ? PE(function() {
        var i = { _w: r3, _d: false };
        try {
          n3.call(t3, In$1(e5, i, 1), In$1(ws$1, i, 1));
        } catch (a3) {
          ws$1.call(i, a3);
        }
      }) : (r3._v = t3, r3._s = 1, B0(r3, false));
    } catch (i) {
      ws$1.call({ _w: r3, _d: false }, i);
    }
  }
};
Su$1 || (fa$2 = function(e28) {
  xa$1(this, fa$2, "Promise", "_h"), oi$1(e28), td$1.call(this);
  try {
    e28(In$1(Av, this, 1), In$1(ws$1, this, 1));
  } catch (t3) {
    ws$1.call(this, t3);
  }
}, (td$1 = function(e28) {
  this._c = [], this._a = void 0, this._s = 0, this._d = false, this._v = void 0, this._h = 0, this._n = false;
}).prototype = jo$1(fa$2.prototype, { then: function(e28, t3) {
  var n3 = Cu$1(Ec$2(this, fa$2));
  return n3.ok = typeof e28 != "function" || e28, n3.fail = typeof t3 == "function" && t3, n3.domain = uc$2 ? Us$1.domain : void 0, this._c.push(n3), this._a && this._a.push(n3), this._s && B0(this, false), n3.promise;
}, catch: function(e28) {
  return this.then(void 0, e28);
} }), Sv = function() {
  var e28 = new td$1();
  this.promise = e28, this.resolve = In$1(Av, e28, 1), this.reject = In$1(ws$1, e28, 1);
}, I0.f = Cu$1 = function(e28) {
  return e28 === fa$2 || e28 === kv ? new Sv(e28) : _E(e28);
}), H$b(H$b.G + H$b.W + H$b.F * !Su$1, { Promise: fa$2 }), ka$2(fa$2, "Promise"), Xs$1("Promise"), kv = hn$1.Promise, H$b(H$b.S + H$b.F * !Su$1, "Promise", { reject: function(e28) {
  var t3 = Cu$1(this);
  return (0, t3.reject)(e28), t3.promise;
} }), H$b(H$b.S + H$b.F * !Su$1, "Promise", { resolve: function(e28) {
  return Am(this, e28);
} }), H$b(H$b.S + H$b.F * !(Su$1 && of(function(e28) {
  fa$2.all(e28).catch(ap);
})), "Promise", { all: function(e28) {
  var t3 = this, n3 = Cu$1(t3), r3 = n3.resolve, i = n3.reject, a3 = wm(function() {
    var s3 = [], o3 = 0, u3 = 1;
    sc$2(e28, false, function(c3) {
      var f3 = o3++, p3 = false;
      s3.push(void 0), u3++, t3.resolve(c3).then(function(d3) {
        p3 || (p3 = true, s3[f3] = d3, --u3 || r3(s3));
      }, i);
    }), --u3 || r3(s3);
  });
  return a3.e && i(a3.v), n3.promise;
}, race: function(e28) {
  var t3 = this, n3 = Cu$1(t3), r3 = n3.reject, i = wm(function() {
    sc$2(e28, false, function(a3) {
      t3.resolve(a3).then(n3.resolve, r3);
    });
  });
  return i.e && r3(i.v), n3.promise;
} });
var cr$1 = function(e28, t3) {
  if (!ht$3(e28) || e28._t !== t3)
    throw TypeError("Incompatible receiver, " + t3 + " required!");
  return e28;
}, r4 = En$1.f, OE = br$1.fastKey, ku$1 = rn$1 ? "_s" : "size", wl = function(e28, t3) {
  var n3, r3 = OE(t3);
  if (r3 !== "F")
    return e28._i[r3];
  for (n3 = e28._f; n3; n3 = n3.n)
    if (n3.k == t3)
      return n3;
}, Du$1 = { getConstructor: function(e28, t3, n3, r3) {
  var i = e28(function(a3, s3) {
    xa$1(a3, i, t3, "_i"), a3._t = t3, a3._i = Ei$1(null), a3._f = void 0, a3._l = void 0, a3[ku$1] = 0, s3 != null && sc$2(s3, n3, a3[r3], a3);
  });
  return jo$1(i.prototype, { clear: function() {
    for (var a3 = cr$1(this, t3), s3 = a3._i, o3 = a3._f; o3; o3 = o3.n)
      o3.r = true, o3.p && (o3.p = o3.p.n = void 0), delete s3[o3.i];
    a3._f = a3._l = void 0, a3[ku$1] = 0;
  }, delete: function(a3) {
    var s3 = cr$1(this, t3), o3 = wl(s3, a3);
    if (o3) {
      var u3 = o3.n, c3 = o3.p;
      delete s3._i[o3.i], o3.r = true, c3 && (c3.n = u3), u3 && (u3.p = c3), s3._f == o3 && (s3._f = u3), s3._l == o3 && (s3._l = c3), s3[ku$1]--;
    }
    return !!o3;
  }, forEach: function(a3) {
    cr$1(this, t3);
    for (var s3, o3 = In$1(a3, arguments.length > 1 ? arguments[1] : void 0, 3); s3 = s3 ? s3.n : this._f; )
      for (o3(s3.v, s3.k, this); s3 && s3.r; )
        s3 = s3.p;
  }, has: function(a3) {
    return !!wl(cr$1(this, t3), a3);
  } }), rn$1 && r4(i.prototype, "size", { get: function() {
    return cr$1(this, t3)[ku$1];
  } }), i;
}, def: function(e28, t3, n3) {
  var r3, i, a3 = wl(e28, t3);
  return a3 ? a3.v = n3 : (e28._l = a3 = { i: i = OE(t3, true), k: t3, v: n3, p: r3 = e28._l, n: void 0, r: false }, e28._f || (e28._f = a3), r3 && (r3.n = a3), e28[ku$1]++, i !== "F" && (e28._i[i] = a3)), e28;
}, getEntry: wl, setStrong: function(e28, t3, n3) {
  S0(e28, t3, function(r3, i) {
    this._t = cr$1(r3, t3), this._k = i, this._l = void 0;
  }, function() {
    for (var r3 = this._k, i = this._l; i && i.r; )
      i = i.p;
    return this._t && (this._l = i = i ? i.n : this._t._f) ? Fp(0, r3 == "keys" ? i.k : r3 == "values" ? i.v : [i.k, i.v]) : (this._t = void 0, Fp(1));
  }, n3 ? "entries" : "values", !n3, true), Xs$1(t3);
} }, Pp = function(e28, t3, n3, r3, i, a3) {
  var s3 = Re$3[e28], o3 = s3, u3 = i ? "set" : "add", c3 = o3 && o3.prototype, f3 = {}, p3 = function(x3) {
    var C3 = c3[x3];
    Er$1(c3, x3, x3 == "delete" ? function(k3) {
      return !(a3 && !ht$3(k3)) && C3.call(this, k3 === 0 ? 0 : k3);
    } : x3 == "has" ? function(k3) {
      return !(a3 && !ht$3(k3)) && C3.call(this, k3 === 0 ? 0 : k3);
    } : x3 == "get" ? function(k3) {
      return a3 && !ht$3(k3) ? void 0 : C3.call(this, k3 === 0 ? 0 : k3);
    } : x3 == "add" ? function(k3) {
      return C3.call(this, k3 === 0 ? 0 : k3), this;
    } : function(k3, F3) {
      return C3.call(this, k3 === 0 ? 0 : k3, F3), this;
    });
  };
  if (typeof o3 == "function" && (a3 || c3.forEach && !pt$3(function() {
    new o3().entries().next();
  }))) {
    var d3 = new o3(), m3 = d3[u3](a3 ? {} : -0, 1) != d3, y3 = pt$3(function() {
      d3.has(1);
    }), v3 = of(function(x3) {
      new o3(x3);
    }), b3 = !a3 && pt$3(function() {
      for (var x3 = new o3(), C3 = 5; C3--; )
        x3[u3](C3, C3);
      return !x3.has(-0);
    });
    v3 || ((o3 = t3(function(x3, C3) {
      xa$1(x3, o3, e28);
      var k3 = b0(new s3(), x3, o3);
      return C3 != null && sc$2(C3, i, k3[u3], k3), k3;
    })).prototype = c3, c3.constructor = o3), (y3 || b3) && (p3("delete"), p3("has"), i && p3("get")), (b3 || m3) && p3(u3), a3 && c3.clear && delete c3.clear;
  } else
    o3 = r3.getConstructor(t3, e28, i, u3), jo$1(o3.prototype, n3), br$1.NEED = true;
  return ka$2(o3, e28), f3[e28] = o3, H$b(H$b.G + H$b.W + H$b.F * (o3 != s3), f3), a3 || r3.setStrong(o3, e28, i), o3;
}, nd$1 = (Pp("Map", function(e28) {
  return function() {
    return e28(this, arguments.length > 0 ? arguments[0] : void 0);
  };
}, { get: function(e28) {
  var t3 = Du$1.getEntry(cr$1(this, "Map"), e28);
  return t3 && t3.v;
}, set: function(e28, t3) {
  return Du$1.def(cr$1(this, "Map"), e28 === 0 ? 0 : e28, t3);
} }, Du$1, true), Pp("Set", function(e28) {
  return function() {
    return e28(this, arguments.length > 0 ? arguments[0] : void 0);
  };
}, { add: function(e28) {
  return Du$1.def(cr$1(this, "Set"), e28 = e28 === 0 ? 0 : e28, e28);
} }, Du$1), br$1.getWeak), i4 = Si$1(5), a4 = Si$1(6), o4 = 0, Al = function(e28) {
  return e28._l || (e28._l = new LE());
}, LE = function() {
  this.a = [];
}, rd$1 = function(e28, t3) {
  return i4(e28.a, function(n3) {
    return n3[0] === t3;
  });
};
LE.prototype = { get: function(e28) {
  var t3 = rd$1(this, e28);
  if (t3)
    return t3[1];
}, has: function(e28) {
  return !!rd$1(this, e28);
}, set: function(e28, t3) {
  var n3 = rd$1(this, e28);
  n3 ? n3[1] = t3 : this.a.push([e28, t3]);
}, delete: function(e28) {
  var t3 = a4(this.a, function(n3) {
    return n3[0] === e28;
  });
  return ~t3 && this.a.splice(t3, 1), !!~t3;
} };
var Ss$1 = { getConstructor: function(e28, t3, n3, r3) {
  var i = e28(function(a3, s3) {
    xa$1(a3, i, t3, "_i"), a3._t = t3, a3._i = o4++, a3._l = void 0, s3 != null && sc$2(s3, n3, a3[r3], a3);
  });
  return jo$1(i.prototype, { delete: function(a3) {
    if (!ht$3(a3))
      return false;
    var s3 = nd$1(a3);
    return s3 === true ? Al(cr$1(this, t3)).delete(a3) : s3 && At$3(s3, this._i) && delete s3[this._i];
  }, has: function(a3) {
    if (!ht$3(a3))
      return false;
    var s3 = nd$1(a3);
    return s3 === true ? Al(cr$1(this, t3)).has(a3) : s3 && At$3(s3, this._i);
  } }), i;
}, def: function(e28, t3, n3) {
  var r3 = nd$1(Ct$2(t3), true);
  return r3 === true ? Al(e28).set(t3, n3) : r3[e28._i] = n3, e28;
}, ufstore: Al };
gt$3(function(e28) {
  var t3, n3 = Si$1(0), r3 = cr$1, i = !Re$3.ActiveXObject && "ActiveXObject" in Re$3, a3 = br$1.getWeak, s3 = Object.isExtensible, o3 = Ss$1.ufstore, u3 = function(p3) {
    return function() {
      return p3(this, arguments.length > 0 ? arguments[0] : void 0);
    };
  }, c3 = { get: function(p3) {
    if (ht$3(p3)) {
      var d3 = a3(p3);
      return d3 === true ? o3(cr$1(this, "WeakMap")).get(p3) : d3 ? d3[this._i] : void 0;
    }
  }, set: function(p3, d3) {
    return Ss$1.def(cr$1(this, "WeakMap"), p3, d3);
  } }, f3 = e28.exports = Pp("WeakMap", u3, c3, Ss$1, true, true);
  r3 && i && (t3 = Ss$1.getConstructor(u3, "WeakMap"), dE(t3.prototype, c3), br$1.NEED = true, n3(["delete", "has", "get", "set"], function(p3) {
    var d3 = f3.prototype, m3 = d3[p3];
    Er$1(d3, p3, function(y3, v3) {
      if (ht$3(y3) && !s3(y3)) {
        this._f || (this._f = new t3());
        var b3 = this._f[p3](y3, v3);
        return p3 == "set" ? this : b3;
      }
      return m3.call(this, y3, v3);
    });
  }));
});
Pp("WeakSet", function(e28) {
  return function() {
    return e28(this, arguments.length > 0 ? arguments[0] : void 0);
  };
}, { add: function(e28) {
  return Ss$1.def(cr$1(this, "WeakSet"), e28, true);
} }, Ss$1, false, true);
for (var id$1, NE = to$2("typed_array"), jE = to$2("view"), RE = !(!Re$3.ArrayBuffer || !Re$3.DataView), ME = RE, _v = 0, s4 = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(","); _v < 9; )
  (id$1 = Re$3[s4[_v++]]) ? (Pn$1(id$1.prototype, NE, true), Pn$1(id$1.prototype, jE, true)) : ME = false;
var Ro$2 = { ABV: RE, CONSTR: ME, TYPED: NE, VIEW: jE }, ju$1 = function(e28) {
  if (e28 === void 0)
    return 0;
  var t3 = zi$1(e28), n3 = sn$1(t3);
  if (t3 !== n3)
    throw RangeError("Wrong length!");
  return n3;
}, cf = gt$3(function(e28, t3) {
  var n3 = qo$1.f, r3 = En$1.f, i = "prototype", a3 = "Wrong index!", s3 = Re$3.ArrayBuffer, o3 = Re$3.DataView, u3 = Re$3.Math, c3 = Re$3.RangeError, f3 = Re$3.Infinity, p3 = s3, d3 = u3.abs, m3 = u3.pow, y3 = u3.floor, v3 = u3.log, b3 = u3.LN2, x3 = rn$1 ? "_b" : "buffer", C3 = rn$1 ? "_l" : "byteLength", k3 = rn$1 ? "_o" : "byteOffset";
  function F3(M3, ne2, de2) {
    var he2, j3, ie2, fe2 = new Array(de2), ge2 = 8 * de2 - ne2 - 1, Fe2 = (1 << ge2) - 1, Pe2 = Fe2 >> 1, _3 = ne2 === 23 ? m3(2, -24) - m3(2, -77) : 0, Q3 = 0, Y3 = M3 < 0 || M3 === 0 && 1 / M3 < 0 ? 1 : 0;
    for ((M3 = d3(M3)) != M3 || M3 === f3 ? (j3 = M3 != M3 ? 1 : 0, he2 = Fe2) : (he2 = y3(v3(M3) / b3), M3 * (ie2 = m3(2, -he2)) < 1 && (he2--, ie2 *= 2), (M3 += he2 + Pe2 >= 1 ? _3 / ie2 : _3 * m3(2, 1 - Pe2)) * ie2 >= 2 && (he2++, ie2 /= 2), he2 + Pe2 >= Fe2 ? (j3 = 0, he2 = Fe2) : he2 + Pe2 >= 1 ? (j3 = (M3 * ie2 - 1) * m3(2, ne2), he2 += Pe2) : (j3 = M3 * m3(2, Pe2 - 1) * m3(2, ne2), he2 = 0)); ne2 >= 8; fe2[Q3++] = 255 & j3, j3 /= 256, ne2 -= 8)
      ;
    for (he2 = he2 << ne2 | j3, ge2 += ne2; ge2 > 0; fe2[Q3++] = 255 & he2, he2 /= 256, ge2 -= 8)
      ;
    return fe2[--Q3] |= 128 * Y3, fe2;
  }
  function B3(M3, ne2, de2) {
    var he2, j3 = 8 * de2 - ne2 - 1, ie2 = (1 << j3) - 1, fe2 = ie2 >> 1, ge2 = j3 - 7, Fe2 = de2 - 1, Pe2 = M3[Fe2--], _3 = 127 & Pe2;
    for (Pe2 >>= 7; ge2 > 0; _3 = 256 * _3 + M3[Fe2], Fe2--, ge2 -= 8)
      ;
    for (he2 = _3 & (1 << -ge2) - 1, _3 >>= -ge2, ge2 += ne2; ge2 > 0; he2 = 256 * he2 + M3[Fe2], Fe2--, ge2 -= 8)
      ;
    if (_3 === 0)
      _3 = 1 - fe2;
    else {
      if (_3 === ie2)
        return he2 ? NaN : Pe2 ? -f3 : f3;
      he2 += m3(2, ne2), _3 -= fe2;
    }
    return (Pe2 ? -1 : 1) * he2 * m3(2, _3 - ne2);
  }
  function O3(M3) {
    return M3[3] << 24 | M3[2] << 16 | M3[1] << 8 | M3[0];
  }
  function S3(M3) {
    return [255 & M3];
  }
  function w3(M3) {
    return [255 & M3, M3 >> 8 & 255];
  }
  function D3(M3) {
    return [255 & M3, M3 >> 8 & 255, M3 >> 16 & 255, M3 >> 24 & 255];
  }
  function I3(M3) {
    return F3(M3, 52, 8);
  }
  function L3(M3) {
    return F3(M3, 23, 4);
  }
  function V10(M3, ne2, de2) {
    r3(M3[i], ne2, { get: function() {
      return this[de2];
    } });
  }
  function K3(M3, ne2, de2, he2) {
    var j3 = ju$1(+de2);
    if (j3 + ne2 > M3[C3])
      throw c3(a3);
    var ie2 = M3[x3]._b, fe2 = j3 + M3[k3], ge2 = ie2.slice(fe2, fe2 + ne2);
    return he2 ? ge2 : ge2.reverse();
  }
  function W3(M3, ne2, de2, he2, j3, ie2) {
    var fe2 = ju$1(+de2);
    if (fe2 + ne2 > M3[C3])
      throw c3(a3);
    for (var ge2 = M3[x3]._b, Fe2 = fe2 + M3[k3], Pe2 = he2(+j3), _3 = 0; _3 < ne2; _3++)
      ge2[Fe2 + _3] = Pe2[ie2 ? _3 : ne2 - _3 - 1];
  }
  if (Ro$2.ABV) {
    if (!pt$3(function() {
      s3(1);
    }) || !pt$3(function() {
      new s3(-1);
    }) || pt$3(function() {
      return new s3(), new s3(1.5), new s3(NaN), s3.name != "ArrayBuffer";
    })) {
      for (var R3, q3 = (s3 = function(M3) {
        return xa$1(this, s3), new p3(ju$1(M3));
      })[i] = p3[i], J3 = n3(p3), X3 = 0; J3.length > X3; )
        (R3 = J3[X3++]) in s3 || Pn$1(s3, R3, p3[R3]);
      q3.constructor = s3;
    }
    var ce2 = new o3(new s3(2)), A3 = o3[i].setInt8;
    ce2.setInt8(0, 2147483648), ce2.setInt8(1, 2147483649), !ce2.getInt8(0) && ce2.getInt8(1) || jo$1(o3[i], { setInt8: function(M3, ne2) {
      A3.call(this, M3, ne2 << 24 >> 24);
    }, setUint8: function(M3, ne2) {
      A3.call(this, M3, ne2 << 24 >> 24);
    } }, true);
  } else
    s3 = function(M3) {
      xa$1(this, s3, "ArrayBuffer");
      var ne2 = ju$1(M3);
      this._b = T0.call(new Array(ne2), 0), this[C3] = ne2;
    }, o3 = function(M3, ne2, de2) {
      xa$1(this, o3, "DataView"), xa$1(M3, s3, "DataView");
      var he2 = M3[C3], j3 = zi$1(ne2);
      if (j3 < 0 || j3 > he2)
        throw c3("Wrong offset!");
      if (j3 + (de2 = de2 === void 0 ? he2 - j3 : sn$1(de2)) > he2)
        throw c3("Wrong length!");
      this[x3] = M3, this[k3] = j3, this[C3] = de2;
    }, rn$1 && (V10(s3, "byteLength", "_l"), V10(o3, "buffer", "_b"), V10(o3, "byteLength", "_l"), V10(o3, "byteOffset", "_o")), jo$1(o3[i], { getInt8: function(M3) {
      return K3(this, 1, M3)[0] << 24 >> 24;
    }, getUint8: function(M3) {
      return K3(this, 1, M3)[0];
    }, getInt16: function(M3) {
      var ne2 = K3(this, 2, M3, arguments[1]);
      return (ne2[1] << 8 | ne2[0]) << 16 >> 16;
    }, getUint16: function(M3) {
      var ne2 = K3(this, 2, M3, arguments[1]);
      return ne2[1] << 8 | ne2[0];
    }, getInt32: function(M3) {
      return O3(K3(this, 4, M3, arguments[1]));
    }, getUint32: function(M3) {
      return O3(K3(this, 4, M3, arguments[1])) >>> 0;
    }, getFloat32: function(M3) {
      return B3(K3(this, 4, M3, arguments[1]), 23, 4);
    }, getFloat64: function(M3) {
      return B3(K3(this, 8, M3, arguments[1]), 52, 8);
    }, setInt8: function(M3, ne2) {
      W3(this, 1, M3, S3, ne2);
    }, setUint8: function(M3, ne2) {
      W3(this, 1, M3, S3, ne2);
    }, setInt16: function(M3, ne2) {
      W3(this, 2, M3, w3, ne2, arguments[2]);
    }, setUint16: function(M3, ne2) {
      W3(this, 2, M3, w3, ne2, arguments[2]);
    }, setInt32: function(M3, ne2) {
      W3(this, 4, M3, D3, ne2, arguments[2]);
    }, setUint32: function(M3, ne2) {
      W3(this, 4, M3, D3, ne2, arguments[2]);
    }, setFloat32: function(M3, ne2) {
      W3(this, 4, M3, L3, ne2, arguments[2]);
    }, setFloat64: function(M3, ne2) {
      W3(this, 8, M3, I3, ne2, arguments[2]);
    } });
  ka$2(s3, "ArrayBuffer"), ka$2(o3, "DataView"), Pn$1(o3[i], Ro$2.VIEW, true), t3.ArrayBuffer = s3, t3.DataView = o3;
}), VE = Re$3.ArrayBuffer, Ru$1 = cf.ArrayBuffer, Tv = cf.DataView, Pv = Ro$2.ABV && VE.isView, Iv = Ru$1.prototype.slice, u4 = Ro$2.VIEW;
H$b(H$b.G + H$b.W + H$b.F * (VE !== Ru$1), { ArrayBuffer: Ru$1 }), H$b(H$b.S + H$b.F * !Ro$2.CONSTR, "ArrayBuffer", { isView: function(e28) {
  return Pv && Pv(e28) || ht$3(e28) && u4 in e28;
} }), H$b(H$b.P + H$b.U + H$b.F * pt$3(function() {
  return !new Ru$1(2).slice(1, void 0).byteLength;
}), "ArrayBuffer", { slice: function(e28, t3) {
  if (Iv !== void 0 && t3 === void 0)
    return Iv.call(Ct$2(this), e28);
  for (var n3 = Ct$2(this).byteLength, r3 = ai$1(e28, n3), i = ai$1(t3 === void 0 ? n3 : t3, n3), a3 = new (Ec$2(this, Ru$1))(sn$1(i - r3)), s3 = new Tv(this), o3 = new Tv(a3), u3 = 0; r3 < i; )
    o3.setUint8(u3++, s3.getUint8(r3++));
  return a3;
} }), Xs$1("ArrayBuffer"), H$b(H$b.G + H$b.W + H$b.F * !Ro$2.ABV, { DataView: cf.DataView });
var oa$2 = gt$3(function(e28) {
  if (rn$1) {
    var t3 = Re$3, n3 = pt$3, r3 = H$b, i = Ro$2, a3 = cf, s3 = In$1, o3 = xa$1, u3 = $i$1, c3 = Pn$1, f3 = jo$1, p3 = zi$1, d3 = sn$1, m3 = ju$1, y3 = ai$1, v3 = Gi$1, b3 = At$3, x3 = bc$2, C3 = ht$3, k3 = Zn$1, F3 = A0, B3 = Ei$1, O3 = No$2, S3 = qo$1.f, w3 = _0, D3 = to$2, I3 = Ut$2, L3 = Si$1, V10 = nf, K3 = Ec$2, W3 = Sm, R3 = Aa$2, q3 = of, J3 = Xs$1, X3 = T0, ce2 = wE, A3 = En$1, M3 = ui$1, ne2 = A3.f, de2 = M3.f, he2 = t3.RangeError, j3 = t3.TypeError, ie2 = t3.Uint8Array, fe2 = Array.prototype, ge2 = a3.ArrayBuffer, Fe2 = a3.DataView, Pe2 = L3(0), _3 = L3(2), Q3 = L3(3), Y3 = L3(4), ae2 = L3(5), ue2 = L3(6), De2 = V10(true), Ee2 = V10(false), _e2 = W3.values, Oe2 = W3.keys, Ye2 = W3.entries, _t2 = fe2.lastIndexOf, Kt2 = fe2.reduce, Jt2 = fe2.reduceRight, zt2 = fe2.join, wn2 = fe2.sort, Z3 = fe2.slice, ee2 = fe2.toString, oe2 = fe2.toLocaleString, le2 = I3("iterator"), we2 = I3("toStringTag"), Me2 = D3("typed_constructor"), Ve2 = D3("def_constructor"), $e2 = i.CONSTR, yt2 = i.TYPED, ze2 = i.VIEW, vt2 = L3(1, function(Ie2, je2) {
      return jt2(K3(Ie2, Ie2[Ve2]), je2);
    }), Nt2 = n3(function() {
      return new ie2(new Uint16Array([1]).buffer)[0] === 1;
    }), Qt2 = !!ie2 && !!ie2.prototype.set && n3(function() {
      new ie2(1).set({});
    }), bt2 = function(Ie2, je2) {
      var Ze2 = p3(Ie2);
      if (Ze2 < 0 || Ze2 % je2)
        throw he2("Wrong offset!");
      return Ze2;
    }, at2 = function(Ie2) {
      if (C3(Ie2) && yt2 in Ie2)
        return Ie2;
      throw j3(Ie2 + " is not a typed array!");
    }, jt2 = function(Ie2, je2) {
      if (!(C3(Ie2) && Me2 in Ie2))
        throw j3("It is not a typed array constructor!");
      return new Ie2(je2);
    }, dn2 = function(Ie2, je2) {
      return Rn2(K3(Ie2, Ie2[Ve2]), je2);
    }, Rn2 = function(Ie2, je2) {
      for (var Ze2 = 0, an2 = je2.length, Rt2 = jt2(Ie2, an2); an2 > Ze2; )
        Rt2[Ze2] = je2[Ze2++];
      return Rt2;
    }, qn2 = function(Ie2, je2, Ze2) {
      ne2(Ie2, je2, { get: function() {
        return this._d[Ze2];
      } });
    }, Sr2 = function(Ie2) {
      var je2, Ze2, an2, Rt2, wi2, Wo2, ot2 = k3(Ie2), Mn2 = arguments.length, Ji2 = Mn2 > 1 ? arguments[1] : void 0, uo2 = Ji2 !== void 0, Qi2 = w3(ot2);
      if (Qi2 != null && !F3(Qi2)) {
        for (Wo2 = Qi2.call(ot2), an2 = [], je2 = 0; !(wi2 = Wo2.next()).done; je2++)
          an2.push(wi2.value);
        ot2 = an2;
      }
      for (uo2 && Mn2 > 2 && (Ji2 = s3(Ji2, arguments[2], 2)), je2 = 0, Ze2 = d3(ot2.length), Rt2 = jt2(this, Ze2); Ze2 > je2; je2++)
        Rt2[je2] = uo2 ? Ji2(ot2[je2], je2) : ot2[je2];
      return Rt2;
    }, pi2 = function() {
      for (var Ie2 = 0, je2 = arguments.length, Ze2 = jt2(this, je2); je2 > Ie2; )
        Ze2[Ie2] = arguments[Ie2++];
      return Ze2;
    }, Bn2 = !!ie2 && n3(function() {
      oe2.call(new ie2(1));
    }), er2 = function() {
      return oe2.apply(Bn2 ? Z3.call(at2(this)) : at2(this), arguments);
    }, fi2 = { copyWithin: function(Ie2, je2) {
      return ce2.call(at2(this), Ie2, je2, arguments.length > 2 ? arguments[2] : void 0);
    }, every: function(Ie2) {
      return Y3(at2(this), Ie2, arguments.length > 1 ? arguments[1] : void 0);
    }, fill: function(Ie2) {
      return X3.apply(at2(this), arguments);
    }, filter: function(Ie2) {
      return dn2(this, _3(at2(this), Ie2, arguments.length > 1 ? arguments[1] : void 0));
    }, find: function(Ie2) {
      return ae2(at2(this), Ie2, arguments.length > 1 ? arguments[1] : void 0);
    }, findIndex: function(Ie2) {
      return ue2(at2(this), Ie2, arguments.length > 1 ? arguments[1] : void 0);
    }, forEach: function(Ie2) {
      Pe2(at2(this), Ie2, arguments.length > 1 ? arguments[1] : void 0);
    }, indexOf: function(Ie2) {
      return Ee2(at2(this), Ie2, arguments.length > 1 ? arguments[1] : void 0);
    }, includes: function(Ie2) {
      return De2(at2(this), Ie2, arguments.length > 1 ? arguments[1] : void 0);
    }, join: function(Ie2) {
      return zt2.apply(at2(this), arguments);
    }, lastIndexOf: function(Ie2) {
      return _t2.apply(at2(this), arguments);
    }, map: function(Ie2) {
      return vt2(at2(this), Ie2, arguments.length > 1 ? arguments[1] : void 0);
    }, reduce: function(Ie2) {
      return Kt2.apply(at2(this), arguments);
    }, reduceRight: function(Ie2) {
      return Jt2.apply(at2(this), arguments);
    }, reverse: function() {
      for (var Ie2, je2 = at2(this).length, Ze2 = Math.floor(je2 / 2), an2 = 0; an2 < Ze2; )
        Ie2 = this[an2], this[an2++] = this[--je2], this[je2] = Ie2;
      return this;
    }, some: function(Ie2) {
      return Q3(at2(this), Ie2, arguments.length > 1 ? arguments[1] : void 0);
    }, sort: function(Ie2) {
      return wn2.call(at2(this), Ie2);
    }, subarray: function(Ie2, je2) {
      var Ze2 = at2(this), an2 = Ze2.length, Rt2 = y3(Ie2, an2);
      return new (K3(Ze2, Ze2[Ve2]))(Ze2.buffer, Ze2.byteOffset + Rt2 * Ze2.BYTES_PER_ELEMENT, d3((je2 === void 0 ? an2 : y3(je2, an2)) - Rt2));
    } }, kr2 = function(Ie2, je2) {
      return dn2(this, Z3.call(at2(this), Ie2, je2));
    }, oo2 = function(Ie2) {
      at2(this);
      var je2 = bt2(arguments[1], 1), Ze2 = this.length, an2 = k3(Ie2), Rt2 = d3(an2.length), wi2 = 0;
      if (Rt2 + je2 > Ze2)
        throw he2("Wrong length!");
      for (; wi2 < Rt2; )
        this[je2 + wi2] = an2[wi2++];
    }, Fi2 = { entries: function() {
      return Ye2.call(at2(this));
    }, keys: function() {
      return Oe2.call(at2(this));
    }, values: function() {
      return _e2.call(at2(this));
    } }, so2 = function(Ie2, je2) {
      return C3(Ie2) && Ie2[yt2] && xe$3(je2) != "symbol" && je2 in Ie2 && String(+je2) == String(je2);
    }, Hi2 = function(Ie2, je2) {
      return so2(Ie2, je2 = v3(je2, true)) ? u3(2, Ie2[je2]) : de2(Ie2, je2);
    }, Ki2 = function(Ie2, je2, Ze2) {
      return !(so2(Ie2, je2 = v3(je2, true)) && C3(Ze2) && b3(Ze2, "value")) || b3(Ze2, "get") || b3(Ze2, "set") || Ze2.configurable || b3(Ze2, "writable") && !Ze2.writable || b3(Ze2, "enumerable") && !Ze2.enumerable ? ne2(Ie2, je2, Ze2) : (Ie2[je2] = Ze2.value, Ie2);
    };
    $e2 || (M3.f = Hi2, A3.f = Ki2), r3(r3.S + r3.F * !$e2, "Object", { getOwnPropertyDescriptor: Hi2, defineProperty: Ki2 }), n3(function() {
      ee2.call({});
    }) && (ee2 = oe2 = function() {
      return zt2.call(this);
    });
    var Wn2 = f3({}, fi2);
    f3(Wn2, Fi2), c3(Wn2, le2, Fi2.values), f3(Wn2, { slice: kr2, set: oo2, constructor: function() {
    }, toString: ee2, toLocaleString: er2 }), qn2(Wn2, "buffer", "b"), qn2(Wn2, "byteOffset", "o"), qn2(Wn2, "byteLength", "l"), qn2(Wn2, "length", "e"), ne2(Wn2, we2, { get: function() {
      return this[yt2];
    } }), e28.exports = function(Ie2, je2, Ze2, an2) {
      var Rt2 = Ie2 + ((an2 = !!an2) ? "Clamped" : "") + "Array", wi2 = "get" + Ie2, Wo2 = "set" + Ie2, ot2 = t3[Rt2], Mn2 = ot2 || {}, Ji2 = ot2 && O3(ot2), uo2 = !ot2 || !i.ABV, Qi2 = {}, On2 = ot2 && ot2.prototype, Fc2 = function($n2, Ht2) {
        ne2($n2, Ht2, { get: function() {
          return function(Dr2, Vr2) {
            var Gn2 = Dr2._d;
            return Gn2.v[wi2](Vr2 * je2 + Gn2.o, Nt2);
          }(this, Ht2);
        }, set: function(Dr2) {
          return function(Vr2, Gn2, zn2) {
            var tr2 = Vr2._d;
            an2 && (zn2 = (zn2 = Math.round(zn2)) < 0 ? 0 : zn2 > 255 ? 255 : 255 & zn2), tr2.v[Wo2](Gn2 * je2 + tr2.o, zn2, Nt2);
          }(this, Ht2, Dr2);
        }, enumerable: true });
      };
      uo2 ? (ot2 = Ze2(function($n2, Ht2, Dr2, Vr2) {
        o3($n2, ot2, Rt2, "_d");
        var Gn2, zn2, tr2, tu2, Ac2 = 0, co2 = 0;
        if (C3(Ht2)) {
          if (!(Ht2 instanceof ge2 || (tu2 = x3(Ht2)) == "ArrayBuffer" || tu2 == "SharedArrayBuffer"))
            return yt2 in Ht2 ? Rn2(ot2, Ht2) : Sr2.call(ot2, Ht2);
          Gn2 = Ht2, co2 = bt2(Dr2, je2);
          var Go2 = Ht2.byteLength;
          if (Vr2 === void 0) {
            if (Go2 % je2 || (zn2 = Go2 - co2) < 0)
              throw he2("Wrong length!");
          } else if ((zn2 = d3(Vr2) * je2) + co2 > Go2)
            throw he2("Wrong length!");
          tr2 = zn2 / je2;
        } else
          tr2 = m3(Ht2), Gn2 = new ge2(zn2 = tr2 * je2);
        for (c3($n2, "_d", { b: Gn2, o: co2, l: zn2, e: tr2, v: new Fe2(Gn2) }); Ac2 < tr2; )
          Fc2($n2, Ac2++);
      }), On2 = ot2.prototype = B3(Wn2), c3(On2, "constructor", ot2)) : n3(function() {
        ot2(1);
      }) && n3(function() {
        new ot2(-1);
      }) && q3(function($n2) {
        new ot2(), new ot2(null), new ot2(1.5), new ot2($n2);
      }, true) || (ot2 = Ze2(function($n2, Ht2, Dr2, Vr2) {
        var Gn2;
        return o3($n2, ot2, Rt2), C3(Ht2) ? Ht2 instanceof ge2 || (Gn2 = x3(Ht2)) == "ArrayBuffer" || Gn2 == "SharedArrayBuffer" ? Vr2 !== void 0 ? new Mn2(Ht2, bt2(Dr2, je2), Vr2) : Dr2 !== void 0 ? new Mn2(Ht2, bt2(Dr2, je2)) : new Mn2(Ht2) : yt2 in Ht2 ? Rn2(ot2, Ht2) : Sr2.call(ot2, Ht2) : new Mn2(m3(Ht2));
      }), Pe2(Ji2 !== Function.prototype ? S3(Mn2).concat(S3(Ji2)) : S3(Mn2), function($n2) {
        $n2 in ot2 || c3(ot2, $n2, Mn2[$n2]);
      }), ot2.prototype = On2, On2.constructor = ot2);
      var Xi2 = On2[le2], $o2 = !!Xi2 && (Xi2.name == "values" || Xi2.name == null), wc2 = Fi2.values;
      c3(ot2, Me2, true), c3(On2, yt2, Rt2), c3(On2, ze2, true), c3(On2, Ve2, ot2), (an2 ? new ot2(1)[we2] == Rt2 : we2 in On2) || ne2(On2, we2, { get: function() {
        return Rt2;
      } }), Qi2[Rt2] = ot2, r3(r3.G + r3.W + r3.F * (ot2 != Mn2), Qi2), r3(r3.S, Rt2, { BYTES_PER_ELEMENT: je2 }), r3(r3.S + r3.F * n3(function() {
        Mn2.of.call(ot2, 1);
      }), Rt2, { from: Sr2, of: pi2 }), "BYTES_PER_ELEMENT" in On2 || c3(On2, "BYTES_PER_ELEMENT", je2), r3(r3.P, Rt2, fi2), J3(Rt2), r3(r3.P + r3.F * Qt2, Rt2, { set: oo2 }), r3(r3.P + r3.F * !$o2, Rt2, Fi2), On2.toString != ee2 && (On2.toString = ee2), r3(r3.P + r3.F * n3(function() {
        new ot2(1).slice();
      }), Rt2, { slice: kr2 }), r3(r3.P + r3.F * (n3(function() {
        return [1, 2].toLocaleString() != new ot2([1, 2]).toLocaleString();
      }) || !n3(function() {
        On2.toLocaleString.call([1, 2]);
      })), Rt2, { toLocaleString: er2 }), R3[Rt2] = $o2 ? Xi2 : wc2, $o2 || c3(On2, le2, wc2);
    };
  } else
    e28.exports = function() {
    };
});
oa$2("Int8", 1, function(e28) {
  return function(t3, n3, r3) {
    return e28(this, t3, n3, r3);
  };
}), oa$2("Uint8", 1, function(e28) {
  return function(t3, n3, r3) {
    return e28(this, t3, n3, r3);
  };
}), oa$2("Uint8", 1, function(e28) {
  return function(t3, n3, r3) {
    return e28(this, t3, n3, r3);
  };
}, true), oa$2("Int16", 2, function(e28) {
  return function(t3, n3, r3) {
    return e28(this, t3, n3, r3);
  };
}), oa$2("Uint16", 2, function(e28) {
  return function(t3, n3, r3) {
    return e28(this, t3, n3, r3);
  };
}), oa$2("Int32", 4, function(e28) {
  return function(t3, n3, r3) {
    return e28(this, t3, n3, r3);
  };
}), oa$2("Uint32", 4, function(e28) {
  return function(t3, n3, r3) {
    return e28(this, t3, n3, r3);
  };
}), oa$2("Float32", 4, function(e28) {
  return function(t3, n3, r3) {
    return e28(this, t3, n3, r3);
  };
}), oa$2("Float64", 8, function(e28) {
  return function(t3, n3, r3) {
    return e28(this, t3, n3, r3);
  };
});
var ad$1 = (Re$3.Reflect || {}).apply, c4 = Function.apply;
H$b(H$b.S + H$b.F * !pt$3(function() {
  ad$1(function() {
  });
}), "Reflect", { apply: function(e28, t3, n3) {
  var r3 = oi$1(e28), i = Ct$2(n3);
  return ad$1 ? ad$1(r3, t3, i) : c4.call(r3, t3, i);
} });
var O0 = (Re$3.Reflect || {}).construct, Bv = pt$3(function() {
  function e28() {
  }
  return !(O0(function() {
  }, [], e28) instanceof e28);
}), Ov = !pt$3(function() {
  O0(function() {
  });
});
H$b(H$b.S + H$b.F * (Bv || Ov), "Reflect", { construct: function(e28, t3) {
  oi$1(e28), Ct$2(t3);
  var n3 = arguments.length < 3 ? e28 : oi$1(arguments[2]);
  if (Ov && !Bv)
    return O0(e28, t3, n3);
  if (e28 == n3) {
    switch (t3.length) {
      case 0:
        return new e28();
      case 1:
        return new e28(t3[0]);
      case 2:
        return new e28(t3[0], t3[1]);
      case 3:
        return new e28(t3[0], t3[1], t3[2]);
      case 4:
        return new e28(t3[0], t3[1], t3[2], t3[3]);
    }
    var r3 = [null];
    return r3.push.apply(r3, t3), new (gE.apply(e28, r3))();
  }
  var i = n3.prototype, a3 = Ei$1(ht$3(i) ? i : Object.prototype), s3 = Function.apply.call(e28, a3, t3);
  return ht$3(s3) ? s3 : a3;
} }), H$b(H$b.S + H$b.F * pt$3(function() {
  Reflect.defineProperty(En$1.f({}, 1, { value: 1 }), 1, { value: 2 });
}), "Reflect", { defineProperty: function(e28, t3, n3) {
  Ct$2(e28), t3 = Gi$1(t3, true), Ct$2(n3);
  try {
    return En$1.f(e28, t3, n3), true;
  } catch {
    return false;
  }
} });
var l4 = ui$1.f;
H$b(H$b.S, "Reflect", { deleteProperty: function(e28, t3) {
  var n3 = l4(Ct$2(e28), t3);
  return !(n3 && !n3.configurable) && delete e28[t3];
} });
var Lv = function(e28) {
  this._t = Ct$2(e28), this._i = 0;
  var t3, n3 = this._k = [];
  for (t3 in e28)
    n3.push(t3);
};
SE(Lv, "Object", function() {
  var e28, t3 = this._k;
  do
    if (this._i >= t3.length)
      return { value: void 0, done: true };
  while (!((e28 = t3[this._i++]) in this._t));
  return { value: e28, done: false };
}), H$b(H$b.S, "Reflect", { enumerate: function(e28) {
  return new Lv(e28);
} }), H$b(H$b.S, "Reflect", { get: function e6(t3, n3) {
  var r3, i, a3 = arguments.length < 3 ? t3 : arguments[2];
  return Ct$2(t3) === a3 ? t3[n3] : (r3 = ui$1.f(t3, n3)) ? At$3(r3, "value") ? r3.value : r3.get !== void 0 ? r3.get.call(a3) : void 0 : ht$3(i = No$2(t3)) ? e6(i, n3, a3) : void 0;
} }), H$b(H$b.S, "Reflect", { getOwnPropertyDescriptor: function(e28, t3) {
  return ui$1.f(Ct$2(e28), t3);
} }), H$b(H$b.S, "Reflect", { getPrototypeOf: function(e28) {
  return No$2(Ct$2(e28));
} }), H$b(H$b.S, "Reflect", { has: function(e28, t3) {
  return t3 in e28;
} });
var Nv = Object.isExtensible;
H$b(H$b.S, "Reflect", { isExtensible: function(e28) {
  return Ct$2(e28), !Nv || Nv(e28);
} });
var jv = Re$3.Reflect, UE = jv && jv.ownKeys || function(e28) {
  var t3 = qo$1.f(Ct$2(e28)), n3 = Uo$1.f;
  return n3 ? t3.concat(n3(e28)) : t3;
};
H$b(H$b.S, "Reflect", { ownKeys: UE });
var Rv = Object.preventExtensions;
H$b(H$b.S, "Reflect", { preventExtensions: function(e28) {
  Ct$2(e28);
  try {
    return Rv && Rv(e28), true;
  } catch {
    return false;
  }
} }), H$b(H$b.S, "Reflect", { set: function e8(t3, n3, r3) {
  var i, a3, s3 = arguments.length < 4 ? t3 : arguments[3], o3 = ui$1.f(Ct$2(t3), n3);
  if (!o3) {
    if (ht$3(a3 = No$2(t3)))
      return e8(a3, n3, r3, s3);
    o3 = $i$1(0);
  }
  if (At$3(o3, "value")) {
    if (o3.writable === false || !ht$3(s3))
      return false;
    if (i = ui$1.f(s3, n3)) {
      if (i.get || i.set || i.writable === false)
        return false;
      i.value = r3, En$1.f(s3, n3, i);
    } else
      En$1.f(s3, n3, $i$1(0, r3));
    return true;
  }
  return o3.set !== void 0 && (o3.set.call(s3, r3), true);
} }), Qu$1 && H$b(H$b.S, "Reflect", { setPrototypeOf: function(e28, t3) {
  Qu$1.check(e28, t3);
  try {
    return Qu$1.set(e28, t3), true;
  } catch {
    return false;
  }
} });
var p4 = nf(true);
H$b(H$b.P, "Array", { includes: function(e28) {
  return p4(this, e28, arguments.length > 1 ? arguments[1] : void 0);
} }), Da$2("includes");
hn$1.Array.includes;
var f4 = Ut$2("isConcatSpreadable"), h4 = function e9(t3, n3, r3, i, a3, s3, o3, u3) {
  for (var c3, f3, p3 = a3, d3 = 0, m3 = !!o3 && In$1(o3, u3, 3); d3 < i; ) {
    if (d3 in r3) {
      if (c3 = m3 ? m3(r3[d3], d3, n3) : r3[d3], f3 = false, ht$3(c3) && (f3 = (f3 = c3[f4]) !== void 0 ? !!f3 : ic$2(c3)), f3 && s3 > 0)
        p3 = e9(t3, n3, c3, sn$1(c3.length), p3, s3 - 1) - 1;
      else {
        if (p3 >= 9007199254740991)
          throw TypeError();
        t3[p3] = c3;
      }
      p3++;
    }
    d3++;
  }
  return p3;
};
H$b(H$b.P, "Array", { flatMap: function(e28) {
  var t3, n3, r3 = Zn$1(this);
  return oi$1(e28), t3 = sn$1(r3.length), n3 = FE(r3, 0), h4(n3, r3, r3, t3, 0, 1, e28, arguments[1]), n3;
} }), Da$2("flatMap");
hn$1.Array.flatMap;
var qE = function(e28, t3, n3, r3) {
  var i = String(Ta$2(e28)), a3 = i.length, s3 = n3 === void 0 ? " " : String(n3), o3 = sn$1(t3);
  if (o3 <= a3 || s3 == "")
    return i;
  var u3 = o3 - a3, c3 = oc$2.call(s3, Math.ceil(u3 / s3.length));
  return c3.length > u3 && (c3 = c3.slice(0, u3)), r3 ? c3 + i : i + c3;
}, d4 = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(uf);
H$b(H$b.P + H$b.F * d4, "String", { padStart: function(e28) {
  return qE(this, e28, arguments.length > 1 ? arguments[1] : void 0, true);
} });
hn$1.String.padStart;
var m4 = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(uf);
H$b(H$b.P + H$b.F * m4, "String", { padEnd: function(e28) {
  return qE(this, e28, arguments.length > 1 ? arguments[1] : void 0, false);
} });
hn$1.String.padEnd;
Qs$1("trimLeft", function(e28) {
  return function() {
    return e28(this, 1);
  };
}, "trimStart");
hn$1.String.trimLeft;
Qs$1("trimRight", function(e28) {
  return function() {
    return e28(this, 2);
  };
}, "trimEnd");
hn$1.String.trimRight;
oE("asyncIterator");
y0.f("asyncIterator");
H$b(H$b.S, "Object", { getOwnPropertyDescriptors: function(e28) {
  for (var t3, n3, r3 = lr$1(e28), i = ui$1.f, a3 = UE(r3), s3 = {}, o3 = 0; a3.length > o3; )
    (n3 = i(r3, t3 = a3[o3++])) !== void 0 && ip(s3, t3, n3);
  return s3;
} });
hn$1.Object.getOwnPropertyDescriptors;
var g4 = vc$2.f, WE = function(e28) {
  return function(t3) {
    for (var n3, r3 = lr$1(t3), i = no$1(r3), a3 = i.length, s3 = 0, o3 = []; a3 > s3; )
      n3 = i[s3++], rn$1 && !g4.call(r3, n3) || o3.push(e28 ? [n3, r3[n3]] : r3[n3]);
    return o3;
  };
}, y4 = WE(false);
H$b(H$b.S, "Object", { values: function(e28) {
  return y4(e28);
} });
hn$1.Object.values;
var v4$2 = WE(true);
H$b(H$b.S, "Object", { entries: function(e28) {
  return v4$2(e28);
} });
hn$1.Object.entries;
H$b(H$b.P + H$b.R, "Promise", { finally: function(e28) {
  var t3 = Ec$2(this, hn$1.Promise || Re$3.Promise), n3 = typeof e28 == "function";
  return this.then(n3 ? function(r3) {
    return Am(t3, e28()).then(function() {
      return r3;
    });
  } : e28, n3 ? function(r3) {
    return Am(t3, e28()).then(function() {
      throw r3;
    });
  } : e28);
} });
hn$1.Promise.finally;
var x4 = [].slice, b4 = /MSIE .\./.test(uf), Mv = function(e28) {
  return function(t3, n3) {
    var r3 = arguments.length > 2, i = !!r3 && x4.call(arguments, 2);
    return e28(r3 ? function() {
      (typeof t3 == "function" ? t3 : Function(t3)).apply(this, i);
    } : t3, n3);
  };
};
H$b(H$b.G + H$b.B + H$b.F * b4, { setTimeout: Mv(Re$3.setTimeout), setInterval: Mv(Re$3.setInterval) }), H$b(H$b.G + H$b.B, { setImmediate: Tp.set, clearImmediate: Tp.clear });
for (var Vv = Ut$2("iterator"), Uv = Ut$2("toStringTag"), qv = Aa$2.Array, Wv = { CSSRuleList: true, CSSStyleDeclaration: false, CSSValueList: false, ClientRectList: false, DOMRectList: false, DOMStringList: false, DOMTokenList: true, DataTransferItemList: false, FileList: false, HTMLAllCollection: false, HTMLCollection: false, HTMLFormElement: false, HTMLSelectElement: false, MediaList: true, MimeTypeArray: false, NamedNodeMap: false, NodeList: true, PaintRequestList: false, Plugin: false, PluginArray: false, SVGLengthList: false, SVGNumberList: false, SVGPathSegList: false, SVGPointList: false, SVGStringList: false, SVGTransformList: false, SourceBufferList: false, StyleSheetList: true, TextTrackCueList: false, TextTrackList: false, TouchList: false }, $v = no$1(Wv), od$1 = 0; od$1 < $v.length; od$1++) {
  var _l, Tl = $v[od$1], E4 = Wv[Tl], Gv = Re$3[Tl], xo$1 = Gv && Gv.prototype;
  if (xo$1 && (xo$1[Vv] || Pn$1(xo$1, Vv, qv), xo$1[Uv] || Pn$1(xo$1, Uv, Tl), Aa$2[Tl] = qv, E4))
    for (_l in Sm)
      xo$1[_l] || Er$1(xo$1, _l, Sm[_l], true);
}
gt$3(function(e28) {
  var t3 = function(n3) {
    var r3, i = Object.prototype, a3 = i.hasOwnProperty, s3 = typeof Symbol == "function" ? Symbol : {}, o3 = s3.iterator || "@@iterator", u3 = s3.asyncIterator || "@@asyncIterator", c3 = s3.toStringTag || "@@toStringTag";
    function f3(q3, J3, X3, ce2) {
      var A3 = J3 && J3.prototype instanceof x3 ? J3 : x3, M3 = Object.create(A3.prototype), ne2 = new K3(ce2 || []);
      return M3._invoke = function(de2, he2, j3) {
        var ie2 = d3;
        return function(fe2, ge2) {
          if (ie2 === y3)
            throw new Error("Generator is already running");
          if (ie2 === v3) {
            if (fe2 === "throw")
              throw ge2;
            return R3();
          }
          for (j3.method = fe2, j3.arg = ge2; ; ) {
            var Fe2 = j3.delegate;
            if (Fe2) {
              var Pe2 = I3(Fe2, j3);
              if (Pe2) {
                if (Pe2 === b3)
                  continue;
                return Pe2;
              }
            }
            if (j3.method === "next")
              j3.sent = j3._sent = j3.arg;
            else if (j3.method === "throw") {
              if (ie2 === d3)
                throw ie2 = v3, j3.arg;
              j3.dispatchException(j3.arg);
            } else
              j3.method === "return" && j3.abrupt("return", j3.arg);
            ie2 = y3;
            var _3 = p3(de2, he2, j3);
            if (_3.type === "normal") {
              if (ie2 = j3.done ? v3 : m3, _3.arg === b3)
                continue;
              return { value: _3.arg, done: j3.done };
            }
            _3.type === "throw" && (ie2 = v3, j3.method = "throw", j3.arg = _3.arg);
          }
        };
      }(q3, X3, ne2), M3;
    }
    function p3(q3, J3, X3) {
      try {
        return { type: "normal", arg: q3.call(J3, X3) };
      } catch (ce2) {
        return { type: "throw", arg: ce2 };
      }
    }
    n3.wrap = f3;
    var d3 = "suspendedStart", m3 = "suspendedYield", y3 = "executing", v3 = "completed", b3 = {};
    function x3() {
    }
    function C3() {
    }
    function k3() {
    }
    var F3 = {};
    F3[o3] = function() {
      return this;
    };
    var B3 = Object.getPrototypeOf, O3 = B3 && B3(B3(W3([])));
    O3 && O3 !== i && a3.call(O3, o3) && (F3 = O3);
    var S3 = k3.prototype = x3.prototype = Object.create(F3);
    function w3(q3) {
      ["next", "throw", "return"].forEach(function(J3) {
        q3[J3] = function(X3) {
          return this._invoke(J3, X3);
        };
      });
    }
    function D3(q3) {
      var J3;
      this._invoke = function(X3, ce2) {
        function A3() {
          return new Promise(function(M3, ne2) {
            (function de2(he2, j3, ie2, fe2) {
              var ge2 = p3(q3[he2], q3, j3);
              if (ge2.type !== "throw") {
                var Fe2 = ge2.arg, Pe2 = Fe2.value;
                return Pe2 && xe$3(Pe2) === "object" && a3.call(Pe2, "__await") ? Promise.resolve(Pe2.__await).then(function(_3) {
                  de2("next", _3, ie2, fe2);
                }, function(_3) {
                  de2("throw", _3, ie2, fe2);
                }) : Promise.resolve(Pe2).then(function(_3) {
                  Fe2.value = _3, ie2(Fe2);
                }, function(_3) {
                  return de2("throw", _3, ie2, fe2);
                });
              }
              fe2(ge2.arg);
            })(X3, ce2, M3, ne2);
          });
        }
        return J3 = J3 ? J3.then(A3, A3) : A3();
      };
    }
    function I3(q3, J3) {
      var X3 = q3.iterator[J3.method];
      if (X3 === r3) {
        if (J3.delegate = null, J3.method === "throw") {
          if (q3.iterator.return && (J3.method = "return", J3.arg = r3, I3(q3, J3), J3.method === "throw"))
            return b3;
          J3.method = "throw", J3.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return b3;
      }
      var ce2 = p3(X3, q3.iterator, J3.arg);
      if (ce2.type === "throw")
        return J3.method = "throw", J3.arg = ce2.arg, J3.delegate = null, b3;
      var A3 = ce2.arg;
      return A3 ? A3.done ? (J3[q3.resultName] = A3.value, J3.next = q3.nextLoc, J3.method !== "return" && (J3.method = "next", J3.arg = r3), J3.delegate = null, b3) : A3 : (J3.method = "throw", J3.arg = new TypeError("iterator result is not an object"), J3.delegate = null, b3);
    }
    function L3(q3) {
      var J3 = { tryLoc: q3[0] };
      1 in q3 && (J3.catchLoc = q3[1]), 2 in q3 && (J3.finallyLoc = q3[2], J3.afterLoc = q3[3]), this.tryEntries.push(J3);
    }
    function V10(q3) {
      var J3 = q3.completion || {};
      J3.type = "normal", delete J3.arg, q3.completion = J3;
    }
    function K3(q3) {
      this.tryEntries = [{ tryLoc: "root" }], q3.forEach(L3, this), this.reset(true);
    }
    function W3(q3) {
      if (q3) {
        var J3 = q3[o3];
        if (J3)
          return J3.call(q3);
        if (typeof q3.next == "function")
          return q3;
        if (!isNaN(q3.length)) {
          var X3 = -1, ce2 = function A3() {
            for (; ++X3 < q3.length; )
              if (a3.call(q3, X3))
                return A3.value = q3[X3], A3.done = false, A3;
            return A3.value = r3, A3.done = true, A3;
          };
          return ce2.next = ce2;
        }
      }
      return { next: R3 };
    }
    function R3() {
      return { value: r3, done: true };
    }
    return C3.prototype = S3.constructor = k3, k3.constructor = C3, k3[c3] = C3.displayName = "GeneratorFunction", n3.isGeneratorFunction = function(q3) {
      var J3 = typeof q3 == "function" && q3.constructor;
      return !!J3 && (J3 === C3 || (J3.displayName || J3.name) === "GeneratorFunction");
    }, n3.mark = function(q3) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(q3, k3) : (q3.__proto__ = k3, c3 in q3 || (q3[c3] = "GeneratorFunction")), q3.prototype = Object.create(S3), q3;
    }, n3.awrap = function(q3) {
      return { __await: q3 };
    }, w3(D3.prototype), D3.prototype[u3] = function() {
      return this;
    }, n3.AsyncIterator = D3, n3.async = function(q3, J3, X3, ce2) {
      var A3 = new D3(f3(q3, J3, X3, ce2));
      return n3.isGeneratorFunction(J3) ? A3 : A3.next().then(function(M3) {
        return M3.done ? M3.value : A3.next();
      });
    }, w3(S3), S3[c3] = "Generator", S3[o3] = function() {
      return this;
    }, S3.toString = function() {
      return "[object Generator]";
    }, n3.keys = function(q3) {
      var J3 = [];
      for (var X3 in q3)
        J3.push(X3);
      return J3.reverse(), function ce2() {
        for (; J3.length; ) {
          var A3 = J3.pop();
          if (A3 in q3)
            return ce2.value = A3, ce2.done = false, ce2;
        }
        return ce2.done = true, ce2;
      };
    }, n3.values = W3, K3.prototype = { constructor: K3, reset: function(q3) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = r3, this.done = false, this.delegate = null, this.method = "next", this.arg = r3, this.tryEntries.forEach(V10), !q3)
        for (var J3 in this)
          J3.charAt(0) === "t" && a3.call(this, J3) && !isNaN(+J3.slice(1)) && (this[J3] = r3);
    }, stop: function() {
      this.done = true;
      var q3 = this.tryEntries[0].completion;
      if (q3.type === "throw")
        throw q3.arg;
      return this.rval;
    }, dispatchException: function(q3) {
      if (this.done)
        throw q3;
      var J3 = this;
      function X3(he2, j3) {
        return M3.type = "throw", M3.arg = q3, J3.next = he2, j3 && (J3.method = "next", J3.arg = r3), !!j3;
      }
      for (var ce2 = this.tryEntries.length - 1; ce2 >= 0; --ce2) {
        var A3 = this.tryEntries[ce2], M3 = A3.completion;
        if (A3.tryLoc === "root")
          return X3("end");
        if (A3.tryLoc <= this.prev) {
          var ne2 = a3.call(A3, "catchLoc"), de2 = a3.call(A3, "finallyLoc");
          if (ne2 && de2) {
            if (this.prev < A3.catchLoc)
              return X3(A3.catchLoc, true);
            if (this.prev < A3.finallyLoc)
              return X3(A3.finallyLoc);
          } else if (ne2) {
            if (this.prev < A3.catchLoc)
              return X3(A3.catchLoc, true);
          } else {
            if (!de2)
              throw new Error("try statement without catch or finally");
            if (this.prev < A3.finallyLoc)
              return X3(A3.finallyLoc);
          }
        }
      }
    }, abrupt: function(q3, J3) {
      for (var X3 = this.tryEntries.length - 1; X3 >= 0; --X3) {
        var ce2 = this.tryEntries[X3];
        if (ce2.tryLoc <= this.prev && a3.call(ce2, "finallyLoc") && this.prev < ce2.finallyLoc) {
          var A3 = ce2;
          break;
        }
      }
      A3 && (q3 === "break" || q3 === "continue") && A3.tryLoc <= J3 && J3 <= A3.finallyLoc && (A3 = null);
      var M3 = A3 ? A3.completion : {};
      return M3.type = q3, M3.arg = J3, A3 ? (this.method = "next", this.next = A3.finallyLoc, b3) : this.complete(M3);
    }, complete: function(q3, J3) {
      if (q3.type === "throw")
        throw q3.arg;
      return q3.type === "break" || q3.type === "continue" ? this.next = q3.arg : q3.type === "return" ? (this.rval = this.arg = q3.arg, this.method = "return", this.next = "end") : q3.type === "normal" && J3 && (this.next = J3), b3;
    }, finish: function(q3) {
      for (var J3 = this.tryEntries.length - 1; J3 >= 0; --J3) {
        var X3 = this.tryEntries[J3];
        if (X3.finallyLoc === q3)
          return this.complete(X3.completion, X3.afterLoc), V10(X3), b3;
      }
    }, catch: function(q3) {
      for (var J3 = this.tryEntries.length - 1; J3 >= 0; --J3) {
        var X3 = this.tryEntries[J3];
        if (X3.tryLoc === q3) {
          var ce2 = X3.completion;
          if (ce2.type === "throw") {
            var A3 = ce2.arg;
            V10(X3);
          }
          return A3;
        }
      }
      throw new Error("illegal catch attempt");
    }, delegateYield: function(q3, J3, X3) {
      return this.delegate = { iterator: W3(q3), resultName: J3, nextLoc: X3 }, this.method === "next" && (this.arg = r3), b3;
    } }, n3;
  }(e28.exports);
  try {
    regeneratorRuntime = t3;
  } catch {
    Function("r", "regeneratorRuntime = r")(t3);
  }
});
var ks$1 = gt$3(function(e28) {
  var t3 = e28.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
  typeof __g == "number" && (__g = t3);
}), Zu$1 = gt$3(function(e28) {
  var t3 = e28.exports = { version: "2.6.10" };
  typeof __e == "number" && (__e = t3);
}), zv = (Zu$1.version, function(e28, t3, n3) {
  if (function(r3) {
    if (typeof r3 != "function")
      throw TypeError(r3 + " is not a function!");
  }(e28), t3 === void 0)
    return e28;
  switch (n3) {
    case 1:
      return function(r3) {
        return e28.call(t3, r3);
      };
    case 2:
      return function(r3, i) {
        return e28.call(t3, r3, i);
      };
    case 3:
      return function(r3, i, a3) {
        return e28.call(t3, r3, i, a3);
      };
  }
  return function() {
    return e28.apply(t3, arguments);
  };
}), Io$1 = function(e28) {
  return xe$3(e28) === "object" ? e28 !== null : typeof e28 == "function";
}, Hv = function(e28) {
  if (!Io$1(e28))
    throw TypeError(e28 + " is not an object!");
  return e28;
}, $E = function(e28) {
  try {
    return !!e28();
  } catch {
    return true;
  }
}, L0 = !$E(function() {
  return Object.defineProperty({}, "a", { get: function() {
    return 7;
  } }).a != 7;
}), _m = ks$1.document, C4 = Io$1(_m) && Io$1(_m.createElement), S4 = !L0 && !$E(function() {
  return Object.defineProperty((e28 = "div", C4 ? _m.createElement(e28) : {}), "a", { get: function() {
    return 7;
  } }).a != 7;
  var e28;
}), k4 = Object.defineProperty, D4 = { f: L0 ? Object.defineProperty : function(e28, t3, n3) {
  if (Hv(e28), t3 = function(r3, i) {
    if (!Io$1(r3))
      return r3;
    var a3, s3;
    if (i && typeof (a3 = r3.toString) == "function" && !Io$1(s3 = a3.call(r3)) || typeof (a3 = r3.valueOf) == "function" && !Io$1(s3 = a3.call(r3)) || !i && typeof (a3 = r3.toString) == "function" && !Io$1(s3 = a3.call(r3)))
      return s3;
    throw TypeError("Can't convert object to primitive value");
  }(t3, true), Hv(n3), S4)
    try {
      return k4(e28, t3, n3);
    } catch {
    }
  if ("get" in n3 || "set" in n3)
    throw TypeError("Accessors not supported!");
  return "value" in n3 && (e28[t3] = n3.value), e28;
} }, F4 = L0 ? function(e28, t3, n3) {
  return D4.f(e28, t3, function(r3, i) {
    return { enumerable: !(1 & r3), configurable: !(2 & r3), writable: !(4 & r3), value: i };
  }(1, n3));
} : function(e28, t3, n3) {
  return e28[t3] = n3, e28;
}, w4 = {}.hasOwnProperty, A4 = function(e28, t3) {
  return w4.call(e28, t3);
}, ji$1 = function e10(t3, n3, r3) {
  var i, a3, s3, o3 = t3 & e10.F, u3 = t3 & e10.G, c3 = t3 & e10.S, f3 = t3 & e10.P, p3 = t3 & e10.B, d3 = t3 & e10.W, m3 = u3 ? Zu$1 : Zu$1[n3] || (Zu$1[n3] = {}), y3 = m3.prototype, v3 = u3 ? ks$1 : c3 ? ks$1[n3] : (ks$1[n3] || {}).prototype;
  for (i in u3 && (r3 = n3), r3)
    (a3 = !o3 && v3 && v3[i] !== void 0) && A4(m3, i) || (s3 = a3 ? v3[i] : r3[i], m3[i] = u3 && typeof v3[i] != "function" ? r3[i] : p3 && a3 ? zv(s3, ks$1) : d3 && v3[i] == s3 ? function(b3) {
      var x3 = function(C3, k3, F3) {
        if (this instanceof b3) {
          switch (arguments.length) {
            case 0:
              return new b3();
            case 1:
              return new b3(C3);
            case 2:
              return new b3(C3, k3);
          }
          return new b3(C3, k3, F3);
        }
        return b3.apply(this, arguments);
      };
      return x3.prototype = b3.prototype, x3;
    }(s3) : f3 && typeof s3 == "function" ? zv(Function.call, s3) : s3, f3 && ((m3.virtual || (m3.virtual = {}))[i] = s3, t3 & e10.R && y3 && !y3[i] && F4(y3, i, s3)));
};
ji$1.F = 1, ji$1.G = 2, ji$1.S = 4, ji$1.P = 8, ji$1.B = 16, ji$1.W = 32, ji$1.U = 64, ji$1.R = 128;
ji$1(ji$1.G, { global: ks$1 });
var _4 = Zu$1.global;
function GE(e28, t3) {
  for (var n3 = 0, r3 = e28.length - 1; r3 >= 0; r3--) {
    var i = e28[r3];
    i === "." ? e28.splice(r3, 1) : i === ".." ? (e28.splice(r3, 1), n3++) : n3 && (e28.splice(r3, 1), n3--);
  }
  if (t3)
    for (; n3--; n3)
      e28.unshift("..");
  return e28;
}
Z2(gt$3(function(e28) {
  var t3, n3 = (t3 = _4) && t3.__esModule ? t3 : { default: t3 };
  n3.default._babelPolyfill && typeof console < "u" && console.warn && console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended and may have consequences if different versions of the polyfills are applied sequentially. If you do need to load the polyfill more than once, use @babel/polyfill/noConflict instead to bypass the warning."), n3.default._babelPolyfill = true;
}));
var T4 = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/, sd$1 = function(e28) {
  return T4.exec(e28).slice(1);
};
function ud$1() {
  for (var e28 = "", t3 = false, n3 = arguments.length - 1; n3 >= -1 && !t3; n3--) {
    var r3 = n3 >= 0 ? arguments[n3] : "/";
    if (typeof r3 != "string")
      throw new TypeError("Arguments to path.resolve must be strings");
    r3 && (e28 = r3 + "/" + e28, t3 = r3.charAt(0) === "/");
  }
  return (t3 ? "/" : "") + (e28 = GE(N0(e28.split("/"), function(i) {
    return !!i;
  }), !t3).join("/")) || ".";
}
function Kv(e28) {
  var t3 = zE(e28), n3 = I4(e28, -1) === "/";
  return (e28 = GE(N0(e28.split("/"), function(r3) {
    return !!r3;
  }), !t3).join("/")) || t3 || (e28 = "."), e28 && n3 && (e28 += "/"), (t3 ? "/" : "") + e28;
}
function zE(e28) {
  return e28.charAt(0) === "/";
}
var P4 = { extname: function(e28) {
  return sd$1(e28)[3];
}, basename: function(e28, t3) {
  var n3 = sd$1(e28)[2];
  return t3 && n3.substr(-1 * t3.length) === t3 && (n3 = n3.substr(0, n3.length - t3.length)), n3;
}, dirname: function(e28) {
  var t3 = sd$1(e28), n3 = t3[0], r3 = t3[1];
  return n3 || r3 ? (r3 && (r3 = r3.substr(0, r3.length - 1)), n3 + r3) : ".";
}, sep: "/", delimiter: ":", relative: function(e28, t3) {
  function n3(c3) {
    for (var f3 = 0; f3 < c3.length && c3[f3] === ""; f3++)
      ;
    for (var p3 = c3.length - 1; p3 >= 0 && c3[p3] === ""; p3--)
      ;
    return f3 > p3 ? [] : c3.slice(f3, p3 - f3 + 1);
  }
  e28 = ud$1(e28).substr(1), t3 = ud$1(t3).substr(1);
  for (var r3 = n3(e28.split("/")), i = n3(t3.split("/")), a3 = Math.min(r3.length, i.length), s3 = a3, o3 = 0; o3 < a3; o3++)
    if (r3[o3] !== i[o3]) {
      s3 = o3;
      break;
    }
  var u3 = [];
  for (o3 = s3; o3 < r3.length; o3++)
    u3.push("..");
  return (u3 = u3.concat(i.slice(s3))).join("/");
}, join: function() {
  return Kv(N0(Array.prototype.slice.call(arguments, 0), function(e28, t3) {
    if (typeof e28 != "string")
      throw new TypeError("Arguments to path.join must be strings");
    return e28;
  }).join("/"));
}, isAbsolute: zE, normalize: Kv, resolve: ud$1 };
function N0(e28, t3) {
  if (e28.filter)
    return e28.filter(t3);
  for (var n3 = [], r3 = 0; r3 < e28.length; r3++)
    t3(e28[r3], r3, e28) && n3.push(e28[r3]);
  return n3;
}
var I4 = "ab".substr(-1) === "b" ? function(e28, t3, n3) {
  return e28.substr(t3, n3);
} : function(e28, t3, n3) {
  return t3 < 0 && (t3 = e28.length + t3), e28.substr(t3, n3);
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function Mu$1(e28) {
  return e28 != null && (!!e28._isBuffer || Jv(e28) || function(t3) {
    return typeof t3.readFloatLE == "function" && typeof t3.slice == "function" && Jv(t3.slice(0, 0));
  }(e28));
}
function Jv(e28) {
  return !!e28.constructor && typeof e28.constructor.isBuffer == "function" && e28.constructor.isBuffer(e28);
}
var HE = typeof Object.create == "function" ? function(e28, t3) {
  e28.super_ = t3, e28.prototype = Object.create(t3.prototype, { constructor: { value: e28, enumerable: false, writable: true, configurable: true } });
} : function(e28, t3) {
  e28.super_ = t3;
  var n3 = function() {
  };
  n3.prototype = t3.prototype, e28.prototype = new n3(), e28.prototype.constructor = e28;
}, B4 = /%[sdj%]/g;
function cd$1(e28) {
  if (!Bp(e28)) {
    for (var t3 = [], n3 = 0; n3 < arguments.length; n3++)
      t3.push(Wi$1(arguments[n3]));
    return t3.join(" ");
  }
  n3 = 1;
  for (var r3 = arguments, i = r3.length, a3 = String(e28).replace(B4, function(o3) {
    if (o3 === "%%")
      return "%";
    if (n3 >= i)
      return o3;
    switch (o3) {
      case "%s":
        return String(r3[n3++]);
      case "%d":
        return Number(r3[n3++]);
      case "%j":
        try {
          return JSON.stringify(r3[n3++]);
        } catch {
          return "[Circular]";
        }
      default:
        return o3;
    }
  }), s3 = r3[n3]; n3 < i; s3 = r3[++n3])
    lf(s3) || !Ys$1(s3) ? a3 += " " + s3 : a3 += " " + Wi$1(s3);
  return a3;
}
var ld$1, Pl = {};
function Wi$1(e28, t3) {
  var n3 = { seen: [], stylize: L4 };
  return arguments.length >= 3 && (n3.depth = arguments[2]), arguments.length >= 4 && (n3.colors = arguments[3]), j0(t3) ? n3.showHidden = t3 : t3 && QE(n3, t3), ba$2(n3.showHidden) && (n3.showHidden = false), ba$2(n3.depth) && (n3.depth = 2), ba$2(n3.colors) && (n3.colors = false), ba$2(n3.customInspect) && (n3.customInspect = true), n3.colors && (n3.stylize = O4), Ip(n3, e28, n3.depth);
}
function O4(e28, t3) {
  var n3 = Wi$1.styles[t3];
  return n3 ? "[" + Wi$1.colors[n3][0] + "m" + e28 + "[" + Wi$1.colors[n3][1] + "m" : e28;
}
function L4(e28, t3) {
  return e28;
}
function Ip(e28, t3, n3) {
  if (e28.customInspect && t3 && _s$1(t3.inspect) && t3.inspect !== Wi$1 && (!t3.constructor || t3.constructor.prototype !== t3)) {
    var r3 = t3.inspect(n3, e28);
    return Bp(r3) || (r3 = Ip(e28, r3, n3)), r3;
  }
  var i = function(d3, m3) {
    if (ba$2(m3))
      return d3.stylize("undefined", "undefined");
    if (Bp(m3)) {
      var y3 = "'" + JSON.stringify(m3).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return d3.stylize(y3, "string");
    }
    if (JE(m3))
      return d3.stylize("" + m3, "number");
    if (j0(m3))
      return d3.stylize("" + m3, "boolean");
    if (lf(m3))
      return d3.stylize("null", "null");
  }(e28, t3);
  if (i)
    return i;
  var a3 = Object.keys(t3), s3 = function(d3) {
    var m3 = {};
    return d3.forEach(function(y3, v3) {
      m3[y3] = true;
    }), m3;
  }(a3);
  if (e28.showHidden && (a3 = Object.getOwnPropertyNames(t3)), ec$2(t3) && (a3.indexOf("message") >= 0 || a3.indexOf("description") >= 0))
    return pd$1(t3);
  if (a3.length === 0) {
    if (_s$1(t3)) {
      var o3 = t3.name ? ": " + t3.name : "";
      return e28.stylize("[Function" + o3 + "]", "special");
    }
    if (As$1(t3))
      return e28.stylize(RegExp.prototype.toString.call(t3), "regexp");
    if (cc$2(t3))
      return e28.stylize(Date.prototype.toString.call(t3), "date");
    if (ec$2(t3))
      return pd$1(t3);
  }
  var u3, c3 = "", f3 = false, p3 = ["{", "}"];
  return KE(t3) && (f3 = true, p3 = ["[", "]"]), _s$1(t3) && (c3 = " [Function" + (t3.name ? ": " + t3.name : "") + "]"), As$1(t3) && (c3 = " " + RegExp.prototype.toString.call(t3)), cc$2(t3) && (c3 = " " + Date.prototype.toUTCString.call(t3)), ec$2(t3) && (c3 = " " + pd$1(t3)), a3.length !== 0 || f3 && t3.length != 0 ? n3 < 0 ? As$1(t3) ? e28.stylize(RegExp.prototype.toString.call(t3), "regexp") : e28.stylize("[Object]", "special") : (e28.seen.push(t3), u3 = f3 ? function(d3, m3, y3, v3, b3) {
    for (var x3 = [], C3 = 0, k3 = m3.length; C3 < k3; ++C3)
      XE(m3, String(C3)) ? x3.push(fd$1(d3, m3, y3, v3, String(C3), true)) : x3.push("");
    return b3.forEach(function(F3) {
      F3.match(/^\d+$/) || x3.push(fd$1(d3, m3, y3, v3, F3, true));
    }), x3;
  }(e28, t3, n3, s3, a3) : a3.map(function(d3) {
    return fd$1(e28, t3, n3, s3, d3, f3);
  }), e28.seen.pop(), function(d3, m3, y3) {
    return d3.reduce(function(v3, b3) {
      return b3.indexOf(`
`), v3 + b3.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0) > 60 ? y3[0] + (m3 === "" ? "" : m3 + `
 `) + " " + d3.join(`,
  `) + " " + y3[1] : y3[0] + m3 + " " + d3.join(", ") + " " + y3[1];
  }(u3, c3, p3)) : p3[0] + c3 + p3[1];
}
function pd$1(e28) {
  return "[" + Error.prototype.toString.call(e28) + "]";
}
function fd$1(e28, t3, n3, r3, i, a3) {
  var s3, o3, u3;
  if ((u3 = Object.getOwnPropertyDescriptor(t3, i) || { value: t3[i] }).get ? o3 = u3.set ? e28.stylize("[Getter/Setter]", "special") : e28.stylize("[Getter]", "special") : u3.set && (o3 = e28.stylize("[Setter]", "special")), XE(r3, i) || (s3 = "[" + i + "]"), o3 || (e28.seen.indexOf(u3.value) < 0 ? (o3 = lf(n3) ? Ip(e28, u3.value, null) : Ip(e28, u3.value, n3 - 1)).indexOf(`
`) > -1 && (o3 = a3 ? o3.split(`
`).map(function(c3) {
    return "  " + c3;
  }).join(`
`).substr(2) : `
` + o3.split(`
`).map(function(c3) {
    return "   " + c3;
  }).join(`
`)) : o3 = e28.stylize("[Circular]", "special")), ba$2(s3)) {
    if (a3 && i.match(/^\d+$/))
      return o3;
    (s3 = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (s3 = s3.substr(1, s3.length - 2), s3 = e28.stylize(s3, "name")) : (s3 = s3.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), s3 = e28.stylize(s3, "string"));
  }
  return s3 + ": " + o3;
}
function KE(e28) {
  return Array.isArray(e28);
}
function j0(e28) {
  return typeof e28 == "boolean";
}
function lf(e28) {
  return e28 === null;
}
function JE(e28) {
  return typeof e28 == "number";
}
function Bp(e28) {
  return typeof e28 == "string";
}
function ba$2(e28) {
  return e28 === void 0;
}
function As$1(e28) {
  return Ys$1(e28) && R0(e28) === "[object RegExp]";
}
function Ys$1(e28) {
  return xe$3(e28) === "object" && e28 !== null;
}
function cc$2(e28) {
  return Ys$1(e28) && R0(e28) === "[object Date]";
}
function ec$2(e28) {
  return Ys$1(e28) && (R0(e28) === "[object Error]" || e28 instanceof Error);
}
function _s$1(e28) {
  return typeof e28 == "function";
}
function Tm(e28) {
  return e28 === null || typeof e28 == "boolean" || typeof e28 == "number" || typeof e28 == "string" || xe$3(e28) === "symbol" || e28 === void 0;
}
function R0(e28) {
  return Object.prototype.toString.call(e28);
}
function hd$1(e28) {
  return e28 < 10 ? "0" + e28.toString(10) : e28.toString(10);
}
Wi$1.colors = { bold: [1, 22], italic: [3, 23], underline: [4, 24], inverse: [7, 27], white: [37, 39], grey: [90, 39], black: [30, 39], blue: [34, 39], cyan: [36, 39], green: [32, 39], magenta: [35, 39], red: [31, 39], yellow: [33, 39] }, Wi$1.styles = { special: "cyan", number: "yellow", boolean: "yellow", undefined: "grey", null: "bold", string: "green", date: "magenta", regexp: "red" };
var N4 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function QE(e28, t3) {
  if (!t3 || !Ys$1(t3))
    return e28;
  for (var n3 = Object.keys(t3), r3 = n3.length; r3--; )
    e28[n3[r3]] = t3[n3[r3]];
  return e28;
}
function XE(e28, t3) {
  return Object.prototype.hasOwnProperty.call(e28, t3);
}
var j4 = { inherits: HE, _extend: QE, log: function() {
  console.log("%s - %s", function() {
    var e28 = /* @__PURE__ */ new Date(), t3 = [hd$1(e28.getHours()), hd$1(e28.getMinutes()), hd$1(e28.getSeconds())].join(":");
    return [e28.getDate(), N4[e28.getMonth()], t3].join(" ");
  }(), cd$1.apply(null, arguments));
}, isBuffer: function(e28) {
  return Buffer.isBuffer(e28);
}, isPrimitive: Tm, isFunction: _s$1, isError: ec$2, isDate: cc$2, isObject: Ys$1, isRegExp: As$1, isUndefined: ba$2, isSymbol: function(e28) {
  return xe$3(e28) === "symbol";
}, isString: Bp, isNumber: JE, isNullOrUndefined: function(e28) {
  return e28 == null;
}, isNull: lf, isBoolean: j0, isArray: KE, inspect: Wi$1, deprecate: function e11(t3, n3) {
  if (ba$2(global.process))
    return function() {
      return e11(t3, n3).apply(this, arguments);
    };
  var r3 = false;
  return function() {
    return r3 || (console.error(n3), r3 = true), t3.apply(this, arguments);
  };
}, format: cd$1, debuglog: function(e28) {
  return ba$2(ld$1) && (ld$1 = ""), e28 = e28.toUpperCase(), !Pl[e28] && (new RegExp("\\b" + e28 + "\\b", "i").test(ld$1) ? Pl[e28] = function() {
    var t3 = cd$1.apply(null, arguments);
    console.error("%s %d: %s", e28, 0, t3);
  } : Pl[e28] = function() {
  }), Pl[e28];
} };
function Qv(e28, t3) {
  if (e28 === t3)
    return 0;
  for (var n3 = e28.length, r3 = t3.length, i = 0, a3 = Math.min(n3, r3); i < a3; ++i)
    if (e28[i] !== t3[i]) {
      n3 = e28[i], r3 = t3[i];
      break;
    }
  return n3 < r3 ? -1 : r3 < n3 ? 1 : 0;
}
var dd$1, R4 = Object.prototype.hasOwnProperty, Xv = Object.keys || function(e28) {
  var t3 = [];
  for (var n3 in e28)
    R4.call(e28, n3) && t3.push(n3);
  return t3;
}, Yv = Array.prototype.slice;
function YE() {
  return dd$1 !== void 0 ? dd$1 : dd$1 = function() {
  }.name === "foo";
}
function Zv(e28) {
  return Object.prototype.toString.call(e28);
}
function ex(e28) {
  return !Mu$1(e28) && typeof global.ArrayBuffer == "function" && (typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e28) : !!e28 && (e28 instanceof DataView || !!(e28.buffer && e28.buffer instanceof ArrayBuffer)));
}
function xn$2(e28, t3) {
  e28 || yr$1(e28, true, t3, "==", M0);
}
var M4 = /\s*function\s+([^\(\s]*)\s*/;
function ZE(e28) {
  if (_s$1(e28)) {
    if (YE())
      return e28.name;
    var t3 = e28.toString().match(M4);
    return t3 && t3[1];
  }
}
function Pm(e28) {
  this.name = "AssertionError", this.actual = e28.actual, this.expected = e28.expected, this.operator = e28.operator, e28.message ? (this.message = e28.message, this.generatedMessage = false) : (this.message = function(o3) {
    return tx(nx(o3.actual), 128) + " " + o3.operator + " " + tx(nx(o3.expected), 128);
  }(this), this.generatedMessage = true);
  var t3 = e28.stackStartFunction || yr$1;
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, t3);
  else {
    var n3 = new Error();
    if (n3.stack) {
      var r3 = n3.stack, i = ZE(t3), a3 = r3.indexOf(`
` + i);
      if (a3 >= 0) {
        var s3 = r3.indexOf(`
`, a3 + 1);
        r3 = r3.substring(s3 + 1);
      }
      this.stack = r3;
    }
  }
}
function tx(e28, t3) {
  return typeof e28 == "string" ? e28.length < t3 ? e28 : e28.slice(0, t3) : e28;
}
function nx(e28) {
  if (YE() || !_s$1(e28))
    return Wi$1(e28);
  var t3 = ZE(e28);
  return "[Function" + (t3 ? ": " + t3 : "") + "]";
}
function yr$1(e28, t3, n3, r3, i) {
  throw new Pm({ message: n3, actual: e28, expected: t3, operator: r3, stackStartFunction: i });
}
function M0(e28, t3) {
  e28 || yr$1(e28, true, t3, "==", M0);
}
function Ds$1(e28, t3, n3, r3) {
  if (e28 === t3)
    return true;
  if (Mu$1(e28) && Mu$1(t3))
    return Qv(e28, t3) === 0;
  if (cc$2(e28) && cc$2(t3))
    return e28.getTime() === t3.getTime();
  if (As$1(e28) && As$1(t3))
    return e28.source === t3.source && e28.global === t3.global && e28.multiline === t3.multiline && e28.lastIndex === t3.lastIndex && e28.ignoreCase === t3.ignoreCase;
  if (e28 !== null && xe$3(e28) === "object" || t3 !== null && xe$3(t3) === "object") {
    if (ex(e28) && ex(t3) && Zv(e28) === Zv(t3) && !(e28 instanceof Float32Array || e28 instanceof Float64Array))
      return Qv(new Uint8Array(e28.buffer), new Uint8Array(t3.buffer)) === 0;
    if (Mu$1(e28) !== Mu$1(t3))
      return false;
    var i = (r3 = r3 || { actual: [], expected: [] }).actual.indexOf(e28);
    return i !== -1 && i === r3.expected.indexOf(t3) || (r3.actual.push(e28), r3.expected.push(t3), function(a3, s3, o3, u3) {
      if (a3 == null || s3 == null)
        return false;
      if (Tm(a3) || Tm(s3))
        return a3 === s3;
      if (o3 && Object.getPrototypeOf(a3) !== Object.getPrototypeOf(s3))
        return false;
      var c3 = rx(a3), f3 = rx(s3);
      if (c3 && !f3 || !c3 && f3)
        return false;
      if (c3)
        return a3 = Yv.call(a3), s3 = Yv.call(s3), Ds$1(a3, s3, o3);
      var p3, d3, m3 = Xv(a3), y3 = Xv(s3);
      if (m3.length !== y3.length)
        return false;
      for (m3.sort(), y3.sort(), d3 = m3.length - 1; d3 >= 0; d3--)
        if (m3[d3] !== y3[d3])
          return false;
      for (d3 = m3.length - 1; d3 >= 0; d3--)
        if (p3 = m3[d3], !Ds$1(a3[p3], s3[p3], o3, u3))
          return false;
      return true;
    }(e28, t3, n3, r3));
  }
  return n3 ? e28 === t3 : e28 == t3;
}
function rx(e28) {
  return Object.prototype.toString.call(e28) == "[object Arguments]";
}
function ix(e28, t3) {
  if (!e28 || !t3)
    return false;
  if (Object.prototype.toString.call(t3) == "[object RegExp]")
    return t3.test(e28);
  try {
    if (e28 instanceof t3)
      return true;
  } catch {
  }
  return !Error.isPrototypeOf(t3) && t3.call({}, e28) === true;
}
function ax(e28, t3, n3, r3) {
  var i;
  if (typeof t3 != "function")
    throw new TypeError('"block" argument must be a function');
  typeof n3 == "string" && (r3 = n3, n3 = null), i = function(o3) {
    var u3;
    try {
      o3();
    } catch (c3) {
      u3 = c3;
    }
    return u3;
  }(t3), r3 = (n3 && n3.name ? " (" + n3.name + ")." : ".") + (r3 ? " " + r3 : "."), e28 && !i && yr$1(i, n3, "Missing expected exception" + r3);
  var a3 = typeof r3 == "string", s3 = !e28 && i && !n3;
  if ((!e28 && ec$2(i) && a3 && ix(i, n3) || s3) && yr$1(i, n3, "Got unwanted exception" + r3), e28 && i && n3 && !ix(i, n3) || !e28 && i)
    throw i;
}
xn$2.AssertionError = Pm, HE(Pm, Error), xn$2.fail = yr$1, xn$2.ok = M0, xn$2.equal = function e12(t3, n3, r3) {
  t3 != n3 && yr$1(t3, n3, r3, "==", e12);
}, xn$2.notEqual = function e13(t3, n3, r3) {
  t3 == n3 && yr$1(t3, n3, r3, "!=", e13);
}, xn$2.deepEqual = function e14(t3, n3, r3) {
  Ds$1(t3, n3, false) || yr$1(t3, n3, r3, "deepEqual", e14);
}, xn$2.deepStrictEqual = function e15(t3, n3, r3) {
  Ds$1(t3, n3, true) || yr$1(t3, n3, r3, "deepStrictEqual", e15);
}, xn$2.notDeepEqual = function e16(t3, n3, r3) {
  Ds$1(t3, n3, false) && yr$1(t3, n3, r3, "notDeepEqual", e16);
}, xn$2.notDeepStrictEqual = function e17(t3, n3, r3) {
  Ds$1(t3, n3, true) && yr$1(t3, n3, r3, "notDeepStrictEqual", e17);
}, xn$2.strictEqual = function e18(t3, n3, r3) {
  t3 !== n3 && yr$1(t3, n3, r3, "===", e18);
}, xn$2.notStrictEqual = function e19(t3, n3, r3) {
  t3 === n3 && yr$1(t3, n3, r3, "!==", e19);
}, xn$2.throws = function(e28, t3, n3) {
  ax(true, e28, t3, n3);
}, xn$2.doesNotThrow = function(e28, t3, n3) {
  ax(false, e28, t3, n3);
}, xn$2.ifError = function(e28) {
  if (e28)
    throw e28;
};
var eC = "ECMAScript JS AST traversal functions", tC = "https://github.com/estools/estraverse", nC = "estraverse.js", rC = { node: ">=4.0" }, iC = [{ name: "Yusuke Suzuki", email: "utatane.tea@gmail.com", web: "http://github.com/Constellation" }], aC = { type: "git", url: "http://github.com/estools/estraverse.git" }, oC = { "babel-preset-env": "^1.6.1", "babel-register": "^6.3.13", chai: "^2.1.1", espree: "^1.11.0", gulp: "^3.8.10", "gulp-bump": "^0.2.2", "gulp-filter": "^2.0.0", "gulp-git": "^1.0.1", "gulp-tag-version": "^1.3.0", jshint: "^2.5.6", mocha: "^2.1.0" }, sC = { test: "npm run-script lint && npm run-script unit-test", lint: "jshint estraverse.js", "unit-test": "mocha --compilers js:babel-register" }, V4$1 = { name: "estraverse", description: eC, homepage: tC, main: nC, version: "4.3.0", engines: rC, maintainers: iC, repository: aC, devDependencies: oC, license: "BSD-2-Clause", scripts: sC }, U4 = Cr$1(Object.freeze({ __proto__: null, name: "estraverse", description: eC, homepage: tC, main: nC, version: "4.3.0", engines: rC, maintainers: iC, repository: aC, devDependencies: oC, license: "BSD-2-Clause", scripts: sC, default: V4$1 })), Cc$2 = gt$3(function(e28, t3) {
  (function n3(r3) {
    var i, a3, s3, o3, u3, c3;
    function f3(C3) {
      var k3, F3, B3 = {};
      for (k3 in C3)
        C3.hasOwnProperty(k3) && (xe$3(F3 = C3[k3]) === "object" && F3 !== null ? B3[k3] = f3(F3) : B3[k3] = F3);
      return B3;
    }
    function p3(C3, k3) {
      this.parent = C3, this.key = k3;
    }
    function d3(C3, k3, F3, B3) {
      this.node = C3, this.path = k3, this.wrap = F3, this.ref = B3;
    }
    function m3() {
    }
    function y3(C3) {
      return C3 != null && xe$3(C3) === "object" && typeof C3.type == "string";
    }
    function v3(C3, k3) {
      return (C3 === i.ObjectExpression || C3 === i.ObjectPattern) && k3 === "properties";
    }
    function b3(C3, k3) {
      return new m3().traverse(C3, k3);
    }
    function x3(C3, k3) {
      var F3;
      return F3 = function(B3, O3) {
        var S3, w3, D3, I3;
        for (w3 = B3.length, D3 = 0; w3; )
          O3(B3[I3 = D3 + (S3 = w3 >>> 1)]) ? w3 = S3 : (D3 = I3 + 1, w3 -= S3 + 1);
        return D3;
      }(k3, function(B3) {
        return B3.range[0] > C3.range[0];
      }), C3.extendedRange = [C3.range[0], C3.range[1]], F3 !== k3.length && (C3.extendedRange[1] = k3[F3].range[0]), (F3 -= 1) >= 0 && (C3.extendedRange[0] = k3[F3].range[1]), C3;
    }
    return i = { AssignmentExpression: "AssignmentExpression", AssignmentPattern: "AssignmentPattern", ArrayExpression: "ArrayExpression", ArrayPattern: "ArrayPattern", ArrowFunctionExpression: "ArrowFunctionExpression", AwaitExpression: "AwaitExpression", BlockStatement: "BlockStatement", BinaryExpression: "BinaryExpression", BreakStatement: "BreakStatement", CallExpression: "CallExpression", CatchClause: "CatchClause", ClassBody: "ClassBody", ClassDeclaration: "ClassDeclaration", ClassExpression: "ClassExpression", ComprehensionBlock: "ComprehensionBlock", ComprehensionExpression: "ComprehensionExpression", ConditionalExpression: "ConditionalExpression", ContinueStatement: "ContinueStatement", DebuggerStatement: "DebuggerStatement", DirectiveStatement: "DirectiveStatement", DoWhileStatement: "DoWhileStatement", EmptyStatement: "EmptyStatement", ExportAllDeclaration: "ExportAllDeclaration", ExportDefaultDeclaration: "ExportDefaultDeclaration", ExportNamedDeclaration: "ExportNamedDeclaration", ExportSpecifier: "ExportSpecifier", ExpressionStatement: "ExpressionStatement", ForStatement: "ForStatement", ForInStatement: "ForInStatement", ForOfStatement: "ForOfStatement", FunctionDeclaration: "FunctionDeclaration", FunctionExpression: "FunctionExpression", GeneratorExpression: "GeneratorExpression", Identifier: "Identifier", IfStatement: "IfStatement", ImportExpression: "ImportExpression", ImportDeclaration: "ImportDeclaration", ImportDefaultSpecifier: "ImportDefaultSpecifier", ImportNamespaceSpecifier: "ImportNamespaceSpecifier", ImportSpecifier: "ImportSpecifier", Literal: "Literal", LabeledStatement: "LabeledStatement", LogicalExpression: "LogicalExpression", MemberExpression: "MemberExpression", MetaProperty: "MetaProperty", MethodDefinition: "MethodDefinition", ModuleSpecifier: "ModuleSpecifier", NewExpression: "NewExpression", ObjectExpression: "ObjectExpression", ObjectPattern: "ObjectPattern", Program: "Program", Property: "Property", RestElement: "RestElement", ReturnStatement: "ReturnStatement", SequenceExpression: "SequenceExpression", SpreadElement: "SpreadElement", Super: "Super", SwitchStatement: "SwitchStatement", SwitchCase: "SwitchCase", TaggedTemplateExpression: "TaggedTemplateExpression", TemplateElement: "TemplateElement", TemplateLiteral: "TemplateLiteral", ThisExpression: "ThisExpression", ThrowStatement: "ThrowStatement", TryStatement: "TryStatement", UnaryExpression: "UnaryExpression", UpdateExpression: "UpdateExpression", VariableDeclaration: "VariableDeclaration", VariableDeclarator: "VariableDeclarator", WhileStatement: "WhileStatement", WithStatement: "WithStatement", YieldExpression: "YieldExpression" }, s3 = { AssignmentExpression: ["left", "right"], AssignmentPattern: ["left", "right"], ArrayExpression: ["elements"], ArrayPattern: ["elements"], ArrowFunctionExpression: ["params", "body"], AwaitExpression: ["argument"], BlockStatement: ["body"], BinaryExpression: ["left", "right"], BreakStatement: ["label"], CallExpression: ["callee", "arguments"], CatchClause: ["param", "body"], ClassBody: ["body"], ClassDeclaration: ["id", "superClass", "body"], ClassExpression: ["id", "superClass", "body"], ComprehensionBlock: ["left", "right"], ComprehensionExpression: ["blocks", "filter", "body"], ConditionalExpression: ["test", "consequent", "alternate"], ContinueStatement: ["label"], DebuggerStatement: [], DirectiveStatement: [], DoWhileStatement: ["body", "test"], EmptyStatement: [], ExportAllDeclaration: ["source"], ExportDefaultDeclaration: ["declaration"], ExportNamedDeclaration: ["declaration", "specifiers", "source"], ExportSpecifier: ["exported", "local"], ExpressionStatement: ["expression"], ForStatement: ["init", "test", "update", "body"], ForInStatement: ["left", "right", "body"], ForOfStatement: ["left", "right", "body"], FunctionDeclaration: ["id", "params", "body"], FunctionExpression: ["id", "params", "body"], GeneratorExpression: ["blocks", "filter", "body"], Identifier: [], IfStatement: ["test", "consequent", "alternate"], ImportExpression: ["source"], ImportDeclaration: ["specifiers", "source"], ImportDefaultSpecifier: ["local"], ImportNamespaceSpecifier: ["local"], ImportSpecifier: ["imported", "local"], Literal: [], LabeledStatement: ["label", "body"], LogicalExpression: ["left", "right"], MemberExpression: ["object", "property"], MetaProperty: ["meta", "property"], MethodDefinition: ["key", "value"], ModuleSpecifier: [], NewExpression: ["callee", "arguments"], ObjectExpression: ["properties"], ObjectPattern: ["properties"], Program: ["body"], Property: ["key", "value"], RestElement: ["argument"], ReturnStatement: ["argument"], SequenceExpression: ["expressions"], SpreadElement: ["argument"], Super: [], SwitchStatement: ["discriminant", "cases"], SwitchCase: ["test", "consequent"], TaggedTemplateExpression: ["tag", "quasi"], TemplateElement: [], TemplateLiteral: ["quasis", "expressions"], ThisExpression: [], ThrowStatement: ["argument"], TryStatement: ["block", "handler", "finalizer"], UnaryExpression: ["argument"], UpdateExpression: ["argument"], VariableDeclaration: ["declarations"], VariableDeclarator: ["id", "init"], WhileStatement: ["test", "body"], WithStatement: ["object", "body"], YieldExpression: ["argument"] }, a3 = { Break: o3 = {}, Skip: u3 = {}, Remove: c3 = {} }, p3.prototype.replace = function(C3) {
      this.parent[this.key] = C3;
    }, p3.prototype.remove = function() {
      return Array.isArray(this.parent) ? (this.parent.splice(this.key, 1), true) : (this.replace(null), false);
    }, m3.prototype.path = function() {
      var C3, k3, F3, B3, O3;
      function S3(w3, D3) {
        if (Array.isArray(D3))
          for (F3 = 0, B3 = D3.length; F3 < B3; ++F3)
            w3.push(D3[F3]);
        else
          w3.push(D3);
      }
      if (!this.__current.path)
        return null;
      for (O3 = [], C3 = 2, k3 = this.__leavelist.length; C3 < k3; ++C3)
        S3(O3, this.__leavelist[C3].path);
      return S3(O3, this.__current.path), O3;
    }, m3.prototype.type = function() {
      return this.current().type || this.__current.wrap;
    }, m3.prototype.parents = function() {
      var C3, k3, F3;
      for (F3 = [], C3 = 1, k3 = this.__leavelist.length; C3 < k3; ++C3)
        F3.push(this.__leavelist[C3].node);
      return F3;
    }, m3.prototype.current = function() {
      return this.__current.node;
    }, m3.prototype.__execute = function(C3, k3) {
      var F3, B3;
      return B3 = void 0, F3 = this.__current, this.__current = k3, this.__state = null, C3 && (B3 = C3.call(this, k3.node, this.__leavelist[this.__leavelist.length - 1].node)), this.__current = F3, B3;
    }, m3.prototype.notify = function(C3) {
      this.__state = C3;
    }, m3.prototype.skip = function() {
      this.notify(u3);
    }, m3.prototype.break = function() {
      this.notify(o3);
    }, m3.prototype.remove = function() {
      this.notify(c3);
    }, m3.prototype.__initialize = function(C3, k3) {
      this.visitor = k3, this.root = C3, this.__worklist = [], this.__leavelist = [], this.__current = null, this.__state = null, this.__fallback = null, k3.fallback === "iteration" ? this.__fallback = Object.keys : typeof k3.fallback == "function" && (this.__fallback = k3.fallback), this.__keys = s3, k3.keys && (this.__keys = Object.assign(Object.create(this.__keys), k3.keys));
    }, m3.prototype.traverse = function(C3, k3) {
      var F3, B3, O3, S3, w3, D3, I3, L3, V10, K3, W3, R3;
      for (this.__initialize(C3, k3), R3 = {}, F3 = this.__worklist, B3 = this.__leavelist, F3.push(new d3(C3, null, null, null)), B3.push(new d3(null, null, null, null)); F3.length; )
        if ((O3 = F3.pop()) !== R3) {
          if (O3.node) {
            if (D3 = this.__execute(k3.enter, O3), this.__state === o3 || D3 === o3)
              return;
            if (F3.push(R3), B3.push(O3), this.__state === u3 || D3 === u3)
              continue;
            if (w3 = (S3 = O3.node).type || O3.wrap, !(K3 = this.__keys[w3])) {
              if (!this.__fallback)
                throw new Error("Unknown node type " + w3 + ".");
              K3 = this.__fallback(S3);
            }
            for (L3 = K3.length; (L3 -= 1) >= 0; )
              if (W3 = S3[I3 = K3[L3]])
                if (Array.isArray(W3)) {
                  for (V10 = W3.length; (V10 -= 1) >= 0; )
                    if (W3[V10]) {
                      if (v3(w3, K3[L3]))
                        O3 = new d3(W3[V10], [I3, V10], "Property", null);
                      else {
                        if (!y3(W3[V10]))
                          continue;
                        O3 = new d3(W3[V10], [I3, V10], null, null);
                      }
                      F3.push(O3);
                    }
                } else
                  y3(W3) && F3.push(new d3(W3, I3, null, null));
          }
        } else if (O3 = B3.pop(), D3 = this.__execute(k3.leave, O3), this.__state === o3 || D3 === o3)
          return;
    }, m3.prototype.replace = function(C3, k3) {
      var F3, B3, O3, S3, w3, D3, I3, L3, V10, K3, W3, R3, q3;
      function J3(X3) {
        var ce2, A3, M3, ne2;
        if (X3.ref.remove()) {
          for (A3 = X3.ref.key, ne2 = X3.ref.parent, ce2 = F3.length; ce2--; )
            if ((M3 = F3[ce2]).ref && M3.ref.parent === ne2) {
              if (M3.ref.key < A3)
                break;
              --M3.ref.key;
            }
        }
      }
      for (this.__initialize(C3, k3), W3 = {}, F3 = this.__worklist, B3 = this.__leavelist, D3 = new d3(C3, null, null, new p3(R3 = { root: C3 }, "root")), F3.push(D3), B3.push(D3); F3.length; )
        if ((D3 = F3.pop()) !== W3) {
          if ((w3 = this.__execute(k3.enter, D3)) !== void 0 && w3 !== o3 && w3 !== u3 && w3 !== c3 && (D3.ref.replace(w3), D3.node = w3), this.__state !== c3 && w3 !== c3 || (J3(D3), D3.node = null), this.__state === o3 || w3 === o3)
            return R3.root;
          if ((O3 = D3.node) && (F3.push(W3), B3.push(D3), this.__state !== u3 && w3 !== u3)) {
            if (S3 = O3.type || D3.wrap, !(V10 = this.__keys[S3])) {
              if (!this.__fallback)
                throw new Error("Unknown node type " + S3 + ".");
              V10 = this.__fallback(O3);
            }
            for (I3 = V10.length; (I3 -= 1) >= 0; )
              if (K3 = O3[q3 = V10[I3]])
                if (Array.isArray(K3)) {
                  for (L3 = K3.length; (L3 -= 1) >= 0; )
                    if (K3[L3]) {
                      if (v3(S3, V10[I3]))
                        D3 = new d3(K3[L3], [q3, L3], "Property", new p3(K3, L3));
                      else {
                        if (!y3(K3[L3]))
                          continue;
                        D3 = new d3(K3[L3], [q3, L3], null, new p3(K3, L3));
                      }
                      F3.push(D3);
                    }
                } else
                  y3(K3) && F3.push(new d3(K3, q3, null, new p3(O3, q3)));
          }
        } else if (D3 = B3.pop(), (w3 = this.__execute(k3.leave, D3)) !== void 0 && w3 !== o3 && w3 !== u3 && w3 !== c3 && D3.ref.replace(w3), this.__state !== c3 && w3 !== c3 || J3(D3), this.__state === o3 || w3 === o3)
          return R3.root;
      return R3.root;
    }, r3.version = U4.version, r3.Syntax = i, r3.traverse = b3, r3.replace = function(C3, k3) {
      return new m3().replace(C3, k3);
    }, r3.attachComments = function(C3, k3, F3) {
      var B3, O3, S3, w3, D3 = [];
      if (!C3.range)
        throw new Error("attachComments needs range information");
      if (!F3.length) {
        if (k3.length) {
          for (S3 = 0, O3 = k3.length; S3 < O3; S3 += 1)
            (B3 = f3(k3[S3])).extendedRange = [0, C3.range[0]], D3.push(B3);
          C3.leadingComments = D3;
        }
        return C3;
      }
      for (S3 = 0, O3 = k3.length; S3 < O3; S3 += 1)
        D3.push(x3(f3(k3[S3]), F3));
      return w3 = 0, b3(C3, { enter: function(I3) {
        for (var L3; w3 < D3.length && !((L3 = D3[w3]).extendedRange[1] > I3.range[0]); )
          L3.extendedRange[1] === I3.range[0] ? (I3.leadingComments || (I3.leadingComments = []), I3.leadingComments.push(L3), D3.splice(w3, 1)) : w3 += 1;
        return w3 === D3.length ? a3.Break : D3[w3].extendedRange[0] > I3.range[1] ? a3.Skip : void 0;
      } }), w3 = 0, b3(C3, { leave: function(I3) {
        for (var L3; w3 < D3.length && (L3 = D3[w3], !(I3.range[1] < L3.extendedRange[0])); )
          I3.range[1] === L3.extendedRange[0] ? (I3.trailingComments || (I3.trailingComments = []), I3.trailingComments.push(L3), D3.splice(w3, 1)) : w3 += 1;
        return w3 === D3.length ? a3.Break : D3[w3].extendedRange[0] > I3.range[1] ? a3.Skip : void 0;
      } }), C3;
    }, r3.VisitorKeys = s3, r3.VisitorOption = a3, r3.Controller = m3, r3.cloneEnvironment = function() {
      return n3({});
    }, r3;
  })(t3);
}), op = function() {
  function e28(t3, n3, r3, i, a3, s3, o3) {
    We$1(this, e28), this.identifier = t3, this.from = n3, this.tainted = false, this.resolved = null, this.flag = r3, this.isWrite() && (this.writeExpr = i, this.partial = s3, this.init = o3), this.__maybeImplicitGlobal = a3;
  }
  return Xe$1(e28, [{ key: "isStatic", value: function() {
    return !this.tainted && this.resolved && this.resolved.scope.isStatic();
  } }, { key: "isWrite", value: function() {
    return !!(this.flag & e28.WRITE);
  } }, { key: "isRead", value: function() {
    return !!(this.flag & e28.READ);
  } }, { key: "isReadOnly", value: function() {
    return this.flag === e28.READ;
  } }, { key: "isWriteOnly", value: function() {
    return this.flag === e28.WRITE;
  } }, { key: "isReadWrite", value: function() {
    return this.flag === e28.RW;
  } }]), e28;
}();
op.READ = 1, op.WRITE = 2, op.RW = 3;
var Ri$1 = op, Ha$2 = function e20(t3, n3) {
  We$1(this, e20), this.name = t3, this.identifiers = [], this.references = [], this.defs = [], this.tainted = false, this.stack = true, this.scope = n3;
};
Ha$2.CatchClause = "CatchClause", Ha$2.Parameter = "Parameter", Ha$2.FunctionName = "FunctionName", Ha$2.ClassName = "ClassName", Ha$2.Variable = "Variable", Ha$2.ImportBinding = "ImportBinding", Ha$2.ImplicitGlobalVariable = "ImplicitGlobalVariable";
var jr$2 = Ha$2, ox = function e21(t3, n3, r3, i, a3, s3) {
  We$1(this, e21), this.type = t3, this.name = n3, this.node = r3, this.parent = i, this.index = a3, this.kind = s3;
}, V0 = { ParameterDefinition: function(e28) {
  function t3(n3, r3, i, a3) {
    var s3;
    return We$1(this, t3), (s3 = Gt$3(this, rt$2(t3).call(this, jr$2.Parameter, n3, r3, null, i, null))).rest = a3, s3;
  }
  return $t$3(t3, ox), t3;
}(), Definition: ox }, ti$1 = Cc$2.Syntax, sx = V0.Definition;
function q4(e28) {
  return e28.type === jr$2.ClassName || e28.type === jr$2.Variable && e28.parent.kind !== "var";
}
var gi$1 = function() {
  function e28(t3, n3, r3, i, a3) {
    We$1(this, e28), this.type = n3, this.set = /* @__PURE__ */ new Map(), this.taints = /* @__PURE__ */ new Map(), this.dynamic = this.type === "global" || this.type === "with", this.block = i, this.through = [], this.variables = [], this.references = [], this.variableScope = this.type === "global" || this.type === "function" || this.type === "module" ? this : r3.variableScope, this.functionExpressionScope = false, this.directCallToEvalScope = false, this.thisFound = false, this.__left = [], this.upper = r3, this.isStrict = function(s3, o3, u3, c3) {
      var f3;
      if (s3.upper && s3.upper.isStrict || u3 || s3.type === "class" || s3.type === "module")
        return true;
      if (s3.type === "block" || s3.type === "switch")
        return false;
      if (s3.type === "function") {
        if (o3.type === ti$1.ArrowFunctionExpression && o3.body.type !== ti$1.BlockStatement || !(f3 = o3.type === ti$1.Program ? o3 : o3.body))
          return false;
      } else {
        if (s3.type !== "global")
          return false;
        f3 = o3;
      }
      if (c3)
        for (var p3 = 0, d3 = f3.body.length; p3 < d3; ++p3) {
          var m3 = f3.body[p3];
          if (m3.type !== ti$1.DirectiveStatement)
            break;
          if (m3.raw === '"use strict"' || m3.raw === "'use strict'")
            return true;
        }
      else
        for (var y3 = 0, v3 = f3.body.length; y3 < v3; ++y3) {
          var b3 = f3.body[y3];
          if (b3.type !== ti$1.ExpressionStatement)
            break;
          var x3 = b3.expression;
          if (x3.type !== ti$1.Literal || typeof x3.value != "string")
            break;
          if (x3.raw !== null && x3.raw !== void 0) {
            if (x3.raw === '"use strict"' || x3.raw === "'use strict'")
              return true;
          } else if (x3.value === "use strict")
            return true;
        }
      return false;
    }(this, i, a3, t3.__useDirective()), this.childScopes = [], this.upper && this.upper.childScopes.push(this), this.__declaredVariables = t3.__declaredVariables, function(s3, o3) {
      s3.scopes.push(o3);
      var u3 = s3.__nodeToScope.get(o3.block);
      u3 ? u3.push(o3) : s3.__nodeToScope.set(o3.block, [o3]);
    }(t3, this);
  }
  return Xe$1(e28, [{ key: "__shouldStaticallyClose", value: function(t3) {
    return !this.dynamic || t3.__isOptimistic();
  } }, { key: "__shouldStaticallyCloseForGlobal", value: function(t3) {
    var n3 = t3.identifier.name;
    if (!this.set.has(n3))
      return false;
    var r3 = this.set.get(n3).defs;
    return r3.length > 0 && r3.every(q4);
  } }, { key: "__staticCloseRef", value: function(t3) {
    this.__resolve(t3) || this.__delegateToUpperScope(t3);
  } }, { key: "__dynamicCloseRef", value: function(t3) {
    var n3 = this;
    do
      n3.through.push(t3), n3 = n3.upper;
    while (n3);
  } }, { key: "__globalCloseRef", value: function(t3) {
    this.__shouldStaticallyCloseForGlobal(t3) ? this.__staticCloseRef(t3) : this.__dynamicCloseRef(t3);
  } }, { key: "__close", value: function(t3) {
    var n3;
    n3 = this.__shouldStaticallyClose(t3) ? this.__staticCloseRef : this.type !== "global" ? this.__dynamicCloseRef : this.__globalCloseRef;
    for (var r3 = 0, i = this.__left.length; r3 < i; ++r3) {
      var a3 = this.__left[r3];
      n3.call(this, a3);
    }
    return this.__left = null, this.upper;
  } }, { key: "__isValidResolution", value: function(t3, n3) {
    return true;
  } }, { key: "__resolve", value: function(t3) {
    var n3 = t3.identifier.name;
    if (!this.set.has(n3))
      return false;
    var r3 = this.set.get(n3);
    return !!this.__isValidResolution(t3, r3) && (r3.references.push(t3), r3.stack = r3.stack && t3.from.variableScope === this.variableScope, t3.tainted && (r3.tainted = true, this.taints.set(r3.name, true)), t3.resolved = r3, true);
  } }, { key: "__delegateToUpperScope", value: function(t3) {
    this.upper && this.upper.__left.push(t3), this.through.push(t3);
  } }, { key: "__addDeclaredVariablesOfNode", value: function(t3, n3) {
    if (n3 != null) {
      var r3 = this.__declaredVariables.get(n3);
      r3 == null && (r3 = [], this.__declaredVariables.set(n3, r3)), r3.indexOf(t3) === -1 && r3.push(t3);
    }
  } }, { key: "__defineGeneric", value: function(t3, n3, r3, i, a3) {
    var s3;
    (s3 = n3.get(t3)) || (s3 = new jr$2(t3, this), n3.set(t3, s3), r3.push(s3)), a3 && (s3.defs.push(a3), this.__addDeclaredVariablesOfNode(s3, a3.node), this.__addDeclaredVariablesOfNode(s3, a3.parent)), i && s3.identifiers.push(i);
  } }, { key: "__define", value: function(t3, n3) {
    t3 && t3.type === ti$1.Identifier && this.__defineGeneric(t3.name, this.set, this.variables, t3, n3);
  } }, { key: "__referencing", value: function(t3, n3, r3, i, a3, s3) {
    if (t3 && t3.type === ti$1.Identifier && t3.name !== "super") {
      var o3 = new Ri$1(t3, this, n3 || Ri$1.READ, r3, i, !!a3, !!s3);
      this.references.push(o3), this.__left.push(o3);
    }
  } }, { key: "__detectEval", value: function() {
    var t3 = this;
    this.directCallToEvalScope = true;
    do
      t3.dynamic = true, t3 = t3.upper;
    while (t3);
  } }, { key: "__detectThis", value: function() {
    this.thisFound = true;
  } }, { key: "__isClosed", value: function() {
    return this.__left === null;
  } }, { key: "resolve", value: function(t3) {
    var n3, r3, i;
    for (xn$2(this.__isClosed(), "Scope should be closed."), xn$2(t3.type === ti$1.Identifier, "Target should be identifier."), r3 = 0, i = this.references.length; r3 < i; ++r3)
      if ((n3 = this.references[r3]).identifier === t3)
        return n3;
    return null;
  } }, { key: "isStatic", value: function() {
    return !this.dynamic;
  } }, { key: "isArgumentsMaterialized", value: function() {
    return true;
  } }, { key: "isThisMaterialized", value: function() {
    return true;
  } }, { key: "isUsedName", value: function(t3) {
    if (this.set.has(t3))
      return true;
    for (var n3 = 0, r3 = this.through.length; n3 < r3; ++n3)
      if (this.through[n3].identifier.name === t3)
        return true;
    return false;
  } }]), e28;
}(), ki$1 = { Scope: gi$1, GlobalScope: function(e28) {
  function t3(n3, r3) {
    var i;
    return We$1(this, t3), (i = Gt$3(this, rt$2(t3).call(this, n3, "global", null, r3, false))).implicit = { set: /* @__PURE__ */ new Map(), variables: [], left: [] }, i;
  }
  return $t$3(t3, gi$1), Xe$1(t3, [{ key: "__close", value: function(n3) {
    for (var r3 = [], i = 0, a3 = this.__left.length; i < a3; ++i) {
      var s3 = this.__left[i];
      s3.__maybeImplicitGlobal && !this.set.has(s3.identifier.name) && r3.push(s3.__maybeImplicitGlobal);
    }
    for (var o3 = 0, u3 = r3.length; o3 < u3; ++o3) {
      var c3 = r3[o3];
      this.__defineImplicit(c3.pattern, new sx(jr$2.ImplicitGlobalVariable, c3.pattern, c3.node, null, null, null));
    }
    return this.implicit.left = this.__left, Yn$2(rt$2(t3.prototype), "__close", this).call(this, n3);
  } }, { key: "__defineImplicit", value: function(n3, r3) {
    n3 && n3.type === ti$1.Identifier && this.__defineGeneric(n3.name, this.implicit.set, this.implicit.variables, n3, r3);
  } }]), t3;
}(), ModuleScope: function(e28) {
  function t3(n3, r3, i) {
    return We$1(this, t3), Gt$3(this, rt$2(t3).call(this, n3, "module", r3, i, false));
  }
  return $t$3(t3, gi$1), t3;
}(), FunctionExpressionNameScope: function(e28) {
  function t3(n3, r3, i) {
    var a3;
    return We$1(this, t3), (a3 = Gt$3(this, rt$2(t3).call(this, n3, "function-expression-name", r3, i, false))).__define(i.id, new sx(jr$2.FunctionName, i.id, i, null, null, null)), a3.functionExpressionScope = true, a3;
  }
  return $t$3(t3, gi$1), t3;
}(), CatchScope: function(e28) {
  function t3(n3, r3, i) {
    return We$1(this, t3), Gt$3(this, rt$2(t3).call(this, n3, "catch", r3, i, false));
  }
  return $t$3(t3, gi$1), t3;
}(), WithScope: function(e28) {
  function t3(n3, r3, i) {
    return We$1(this, t3), Gt$3(this, rt$2(t3).call(this, n3, "with", r3, i, false));
  }
  return $t$3(t3, gi$1), Xe$1(t3, [{ key: "__close", value: function(n3) {
    if (this.__shouldStaticallyClose(n3))
      return Yn$2(rt$2(t3.prototype), "__close", this).call(this, n3);
    for (var r3 = 0, i = this.__left.length; r3 < i; ++r3) {
      var a3 = this.__left[r3];
      a3.tainted = true, this.__delegateToUpperScope(a3);
    }
    return this.__left = null, this.upper;
  } }]), t3;
}(), BlockScope: function(e28) {
  function t3(n3, r3, i) {
    return We$1(this, t3), Gt$3(this, rt$2(t3).call(this, n3, "block", r3, i, false));
  }
  return $t$3(t3, gi$1), t3;
}(), SwitchScope: function(e28) {
  function t3(n3, r3, i) {
    return We$1(this, t3), Gt$3(this, rt$2(t3).call(this, n3, "switch", r3, i, false));
  }
  return $t$3(t3, gi$1), t3;
}(), FunctionScope: function(e28) {
  function t3(n3, r3, i, a3) {
    var s3;
    return We$1(this, t3), (s3 = Gt$3(this, rt$2(t3).call(this, n3, "function", r3, i, a3))).block.type !== ti$1.ArrowFunctionExpression && s3.__defineArguments(), s3;
  }
  return $t$3(t3, gi$1), Xe$1(t3, [{ key: "isArgumentsMaterialized", value: function() {
    if (this.block.type === ti$1.ArrowFunctionExpression)
      return false;
    if (!this.isStatic())
      return true;
    var n3 = this.set.get("arguments");
    return xn$2(n3, "Always have arguments variable."), n3.tainted || n3.references.length !== 0;
  } }, { key: "isThisMaterialized", value: function() {
    return !this.isStatic() || this.thisFound;
  } }, { key: "__defineArguments", value: function() {
    this.__defineGeneric("arguments", this.set, this.variables, null, null), this.taints.set("arguments", true);
  } }, { key: "__isValidResolution", value: function(n3, r3) {
    if (this.block.type === "Program")
      return true;
    var i = this.block.body.range[0];
    return !(r3.scope === this && n3.identifier.range[0] < i && r3.defs.every(function(a3) {
      return a3.name.range[0] >= i;
    }));
  } }]), t3;
}(), ForScope: function(e28) {
  function t3(n3, r3, i) {
    return We$1(this, t3), Gt$3(this, rt$2(t3).call(this, n3, "for", r3, i, false));
  }
  return $t$3(t3, gi$1), t3;
}(), ClassScope: function(e28) {
  function t3(n3, r3, i) {
    return We$1(this, t3), Gt$3(this, rt$2(t3).call(this, n3, "class", r3, i, false));
  }
  return $t$3(t3, gi$1), t3;
}() }, ux = ki$1.GlobalScope, W4 = ki$1.CatchScope, $4 = ki$1.WithScope, G4 = ki$1.ModuleScope, z4 = ki$1.ClassScope, H4 = ki$1.SwitchScope, K4 = ki$1.FunctionScope, J4 = ki$1.ForScope, Q4 = ki$1.FunctionExpressionNameScope, X4 = ki$1.BlockScope, cx = function() {
  function e28(t3) {
    We$1(this, e28), this.scopes = [], this.globalScope = null, this.__nodeToScope = /* @__PURE__ */ new WeakMap(), this.__currentScope = null, this.__options = t3, this.__declaredVariables = /* @__PURE__ */ new WeakMap();
  }
  return Xe$1(e28, [{ key: "__useDirective", value: function() {
    return this.__options.directive;
  } }, { key: "__isOptimistic", value: function() {
    return this.__options.optimistic;
  } }, { key: "__ignoreEval", value: function() {
    return this.__options.ignoreEval;
  } }, { key: "__isNodejsScope", value: function() {
    return this.__options.nodejsScope;
  } }, { key: "isModule", value: function() {
    return this.__options.sourceType === "module";
  } }, { key: "isImpliedStrict", value: function() {
    return this.__options.impliedStrict;
  } }, { key: "isStrictModeSupported", value: function() {
    return this.__options.ecmaVersion >= 5;
  } }, { key: "__get", value: function(t3) {
    return this.__nodeToScope.get(t3);
  } }, { key: "getDeclaredVariables", value: function(t3) {
    return this.__declaredVariables.get(t3) || [];
  } }, { key: "acquire", value: function(t3, n3) {
    function r3(f3) {
      return f3.type !== "function" || !f3.functionExpressionScope;
    }
    var i = this.__get(t3);
    if (!i || i.length === 0)
      return null;
    if (i.length === 1)
      return i[0];
    if (n3)
      for (var a3 = i.length - 1; a3 >= 0; --a3) {
        var s3 = i[a3];
        if (r3(s3))
          return s3;
      }
    else
      for (var o3 = 0, u3 = i.length; o3 < u3; ++o3) {
        var c3 = i[o3];
        if (r3(c3))
          return c3;
      }
    return null;
  } }, { key: "acquireAll", value: function(t3) {
    return this.__get(t3);
  } }, { key: "release", value: function(t3, n3) {
    var r3 = this.__get(t3);
    if (r3 && r3.length) {
      var i = r3[0].upper;
      return i ? this.acquire(i.block, n3) : null;
    }
    return null;
  } }, { key: "attach", value: function() {
  } }, { key: "detach", value: function() {
  } }, { key: "__nestScope", value: function(t3) {
    return t3 instanceof ux && (xn$2(this.__currentScope === null), this.globalScope = t3), this.__currentScope = t3, t3;
  } }, { key: "__nestGlobalScope", value: function(t3) {
    return this.__nestScope(new ux(this, t3));
  } }, { key: "__nestBlockScope", value: function(t3) {
    return this.__nestScope(new X4(this, this.__currentScope, t3));
  } }, { key: "__nestFunctionScope", value: function(t3, n3) {
    return this.__nestScope(new K4(this, this.__currentScope, t3, n3));
  } }, { key: "__nestForScope", value: function(t3) {
    return this.__nestScope(new J4(this, this.__currentScope, t3));
  } }, { key: "__nestCatchScope", value: function(t3) {
    return this.__nestScope(new W4(this, this.__currentScope, t3));
  } }, { key: "__nestWithScope", value: function(t3) {
    return this.__nestScope(new $4(this, this.__currentScope, t3));
  } }, { key: "__nestClassScope", value: function(t3) {
    return this.__nestScope(new z4(this, this.__currentScope, t3));
  } }, { key: "__nestSwitchScope", value: function(t3) {
    return this.__nestScope(new H4(this, this.__currentScope, t3));
  } }, { key: "__nestModuleScope", value: function(t3) {
    return this.__nestScope(new G4(this, this.__currentScope, t3));
  } }, { key: "__nestFunctionExpressionNameScope", value: function(t3) {
    return this.__nestScope(new Q4(this, this.__currentScope, t3));
  } }, { key: "__isES6", value: function() {
    return this.__options.ecmaVersion >= 6;
  } }]), e28;
}(), uC = "https://github.com/estools/esrecurse", cC = { node: ">=4.0" }, lC = [{ name: "Yusuke Suzuki", email: "utatane.tea@gmail.com", web: "https://github.com/Constellation" }], pC = { type: "git", url: "https://github.com/estools/esrecurse.git" }, fC = { estraverse: "^4.1.0" }, hC = { "babel-cli": "^6.24.1", "babel-eslint": "^7.2.3", "babel-preset-es2015": "^6.24.1", "babel-register": "^6.24.1", chai: "^4.0.2", esprima: "^4.0.0", gulp: "^3.9.0", "gulp-bump": "^2.7.0", "gulp-eslint": "^4.0.0", "gulp-filter": "^5.0.0", "gulp-git": "^2.4.1", "gulp-mocha": "^4.3.1", "gulp-tag-version": "^1.2.1", jsdoc: "^3.3.0-alpha10", minimist: "^1.1.0" }, dC = { test: "gulp travis", "unit-test": "gulp test", lint: "gulp lint" }, mC = { presets: ["es2015"] }, Y4 = { name: "esrecurse", description: "ECMAScript AST recursive visitor", homepage: uC, main: "esrecurse.js", version: "4.2.1", engines: cC, maintainers: lC, repository: pC, dependencies: fC, devDependencies: hC, license: "BSD-2-Clause", scripts: dC, babel: mC }, Z4 = Cr$1(Object.freeze({ __proto__: null, name: "esrecurse", description: "ECMAScript AST recursive visitor", homepage: uC, main: "esrecurse.js", version: "4.2.1", engines: cC, maintainers: lC, repository: pC, dependencies: fC, devDependencies: hC, license: "BSD-2-Clause", scripts: dC, babel: mC, default: Y4 })), Ts$1 = gt$3(function(e28, t3) {
  (function() {
    var n3 = Cc$2;
    function r3(s3) {
      return s3 != null && xe$3(s3) === "object" && typeof s3.type == "string";
    }
    function i(s3, o3) {
      return (s3 === n3.Syntax.ObjectExpression || s3 === n3.Syntax.ObjectPattern) && o3 === "properties";
    }
    function a3(s3, o3) {
      o3 = o3 || {}, this.__visitor = s3 || this, this.__childVisitorKeys = o3.childVisitorKeys ? Object.assign({}, n3.VisitorKeys, o3.childVisitorKeys) : n3.VisitorKeys, o3.fallback === "iteration" ? this.__fallback = Object.keys : typeof o3.fallback == "function" && (this.__fallback = o3.fallback);
    }
    a3.prototype.visitChildren = function(s3) {
      var o3, u3, c3, f3, p3, d3, m3;
      if (s3 != null) {
        if (o3 = s3.type || n3.Syntax.Property, !(u3 = this.__childVisitorKeys[o3])) {
          if (!this.__fallback)
            throw new Error("Unknown node type " + o3 + ".");
          u3 = this.__fallback(s3);
        }
        for (c3 = 0, f3 = u3.length; c3 < f3; ++c3)
          if (m3 = s3[u3[c3]])
            if (Array.isArray(m3))
              for (p3 = 0, d3 = m3.length; p3 < d3; ++p3)
                m3[p3] && (r3(m3[p3]) || i(o3, u3[c3])) && this.visit(m3[p3]);
            else
              r3(m3) && this.visit(m3);
      }
    }, a3.prototype.visit = function(s3) {
      var o3;
      s3 != null && (o3 = s3.type || n3.Syntax.Property, this.__visitor[o3] ? this.__visitor[o3].call(this, s3) : this.visitChildren(s3));
    }, t3.version = Z4.version, t3.Visitor = a3, t3.visit = function(s3, o3, u3) {
      new a3(o3, u3).visit(s3);
    };
  })();
}), ls$1 = (Ts$1.version, Ts$1.Visitor, Ts$1.visit, Cc$2.Syntax), md$1 = function(e28) {
  function t3(n3, r3, i) {
    var a3;
    return We$1(this, t3), (a3 = Gt$3(this, rt$2(t3).call(this, null, n3))).rootPattern = r3, a3.callback = i, a3.assignments = [], a3.rightHandNodes = [], a3.restElements = [], a3;
  }
  return $t$3(t3, Ts$1.Visitor), Xe$1(t3, null, [{ key: "isPattern", value: function(n3) {
    var r3 = n3.type;
    return r3 === ls$1.Identifier || r3 === ls$1.ObjectPattern || r3 === ls$1.ArrayPattern || r3 === ls$1.SpreadElement || r3 === ls$1.RestElement || r3 === ls$1.AssignmentPattern;
  } }]), Xe$1(t3, [{ key: "Identifier", value: function(n3) {
    var r3, i = (r3 = this.restElements)[r3.length - 1] || null;
    this.callback(n3, { topLevel: n3 === this.rootPattern, rest: i != null && i.argument === n3, assignments: this.assignments });
  } }, { key: "Property", value: function(n3) {
    n3.computed && this.rightHandNodes.push(n3.key), this.visit(n3.value);
  } }, { key: "ArrayPattern", value: function(n3) {
    for (var r3 = 0, i = n3.elements.length; r3 < i; ++r3) {
      var a3 = n3.elements[r3];
      this.visit(a3);
    }
  } }, { key: "AssignmentPattern", value: function(n3) {
    this.assignments.push(n3), this.visit(n3.left), this.rightHandNodes.push(n3.right), this.assignments.pop();
  } }, { key: "RestElement", value: function(n3) {
    this.restElements.push(n3), this.visit(n3.argument), this.restElements.pop();
  } }, { key: "MemberExpression", value: function(n3) {
    n3.computed && this.rightHandNodes.push(n3.property), this.rightHandNodes.push(n3.object);
  } }, { key: "SpreadElement", value: function(n3) {
    this.visit(n3.argument);
  } }, { key: "ArrayExpression", value: function(n3) {
    n3.elements.forEach(this.visit, this);
  } }, { key: "AssignmentExpression", value: function(n3) {
    this.assignments.push(n3), this.visit(n3.left), this.rightHandNodes.push(n3.right), this.assignments.pop();
  } }, { key: "CallExpression", value: function(n3) {
    var r3 = this;
    n3.arguments.forEach(function(i) {
      r3.rightHandNodes.push(i);
    }), this.visit(n3.callee);
  } }]), t3;
}(), sa$2 = Cc$2.Syntax, lx = V0.ParameterDefinition, ds$1 = V0.Definition, e92 = function(e28) {
  function t3(n3, r3) {
    var i;
    return We$1(this, t3), (i = Gt$3(this, rt$2(t3).call(this, null, r3.options))).declaration = n3, i.referencer = r3, i;
  }
  return $t$3(t3, Ts$1.Visitor), Xe$1(t3, [{ key: "visitImport", value: function(n3, r3) {
    var i = this;
    this.referencer.visitPattern(n3, function(a3) {
      i.referencer.currentScope().__define(a3, new ds$1(jr$2.ImportBinding, a3, r3, i.declaration, null, null));
    });
  } }, { key: "ImportNamespaceSpecifier", value: function(n3) {
    var r3 = n3.local || n3.id;
    r3 && this.visitImport(r3, n3);
  } }, { key: "ImportDefaultSpecifier", value: function(n3) {
    var r3 = n3.local || n3.id;
    this.visitImport(r3, n3);
  } }, { key: "ImportSpecifier", value: function(n3) {
    var r3 = n3.local || n3.id;
    n3.name ? this.visitImport(n3.name, n3) : this.visitImport(r3, n3);
  } }]), t3;
}(), t9 = function(e28) {
  function t3(n3, r3) {
    var i;
    return We$1(this, t3), (i = Gt$3(this, rt$2(t3).call(this, null, n3))).options = n3, i.scopeManager = r3, i.parent = null, i.isInnerMethodDefinition = false, i;
  }
  return $t$3(t3, Ts$1.Visitor), Xe$1(t3, [{ key: "currentScope", value: function() {
    return this.scopeManager.__currentScope;
  } }, { key: "close", value: function(n3) {
    for (; this.currentScope() && n3 === this.currentScope().block; )
      this.scopeManager.__currentScope = this.currentScope().__close(this.scopeManager);
  } }, { key: "pushInnerMethodDefinition", value: function(n3) {
    var r3 = this.isInnerMethodDefinition;
    return this.isInnerMethodDefinition = n3, r3;
  } }, { key: "popInnerMethodDefinition", value: function(n3) {
    this.isInnerMethodDefinition = n3;
  } }, { key: "referencingDefaultValue", value: function(n3, r3, i, a3) {
    var s3 = this.currentScope();
    r3.forEach(function(o3) {
      s3.__referencing(n3, Ri$1.WRITE, o3.right, i, n3 !== o3.left, a3);
    });
  } }, { key: "visitPattern", value: function(n3, r3, i) {
    var a3 = r3, s3 = i;
    typeof r3 == "function" && (s3 = r3, a3 = { processRightHandNodes: false }), function(o3, u3, c3, f3) {
      var p3 = new md$1(o3, u3, f3);
      p3.visit(u3), c3 != null && p3.rightHandNodes.forEach(c3.visit, c3);
    }(this.options, n3, a3.processRightHandNodes ? this : null, s3);
  } }, { key: "visitFunction", value: function(n3) {
    var r3, i, a3 = this;
    n3.type === sa$2.FunctionDeclaration && this.currentScope().__define(n3.id, new ds$1(jr$2.FunctionName, n3.id, n3, null, null, null)), n3.type === sa$2.FunctionExpression && n3.id && this.scopeManager.__nestFunctionExpressionNameScope(n3), this.scopeManager.__nestFunctionScope(n3, this.isInnerMethodDefinition);
    var s3 = this;
    function o3(u3, c3) {
      s3.currentScope().__define(u3, new lx(u3, n3, r3, c3.rest)), s3.referencingDefaultValue(u3, c3.assignments, null, true);
    }
    for (r3 = 0, i = n3.params.length; r3 < i; ++r3)
      this.visitPattern(n3.params[r3], { processRightHandNodes: true }, o3);
    n3.rest && this.visitPattern({ type: "RestElement", argument: n3.rest }, function(u3) {
      a3.currentScope().__define(u3, new lx(u3, n3, n3.params.length, true));
    }), n3.body && (n3.body.type === sa$2.BlockStatement ? this.visitChildren(n3.body) : this.visit(n3.body)), this.close(n3);
  } }, { key: "visitClass", value: function(n3) {
    n3.type === sa$2.ClassDeclaration && this.currentScope().__define(n3.id, new ds$1(jr$2.ClassName, n3.id, n3, null, null, null)), this.visit(n3.superClass), this.scopeManager.__nestClassScope(n3), n3.id && this.currentScope().__define(n3.id, new ds$1(jr$2.ClassName, n3.id, n3)), this.visit(n3.body), this.close(n3);
  } }, { key: "visitProperty", value: function(n3) {
    var r3;
    n3.computed && this.visit(n3.key);
    var i = n3.type === sa$2.MethodDefinition;
    i && (r3 = this.pushInnerMethodDefinition(true)), this.visit(n3.value), i && this.popInnerMethodDefinition(r3);
  } }, { key: "visitForIn", value: function(n3) {
    var r3 = this;
    n3.left.type === sa$2.VariableDeclaration && n3.left.kind !== "var" && this.scopeManager.__nestForScope(n3), n3.left.type === sa$2.VariableDeclaration ? (this.visit(n3.left), this.visitPattern(n3.left.declarations[0].id, function(i) {
      r3.currentScope().__referencing(i, Ri$1.WRITE, n3.right, null, true, true);
    })) : this.visitPattern(n3.left, { processRightHandNodes: true }, function(i, a3) {
      var s3 = null;
      r3.currentScope().isStrict || (s3 = { pattern: i, node: n3 }), r3.referencingDefaultValue(i, a3.assignments, s3, false), r3.currentScope().__referencing(i, Ri$1.WRITE, n3.right, s3, true, false);
    }), this.visit(n3.right), this.visit(n3.body), this.close(n3);
  } }, { key: "visitVariableDeclaration", value: function(n3, r3, i, a3) {
    var s3 = this, o3 = i.declarations[a3], u3 = o3.init;
    this.visitPattern(o3.id, { processRightHandNodes: true }, function(c3, f3) {
      n3.__define(c3, new ds$1(r3, c3, o3, i, a3, i.kind)), s3.referencingDefaultValue(c3, f3.assignments, null, true), u3 && s3.currentScope().__referencing(c3, Ri$1.WRITE, u3, null, !f3.topLevel, true);
    });
  } }, { key: "AssignmentExpression", value: function(n3) {
    var r3 = this;
    md$1.isPattern(n3.left) ? n3.operator === "=" ? this.visitPattern(n3.left, { processRightHandNodes: true }, function(i, a3) {
      var s3 = null;
      r3.currentScope().isStrict || (s3 = { pattern: i, node: n3 }), r3.referencingDefaultValue(i, a3.assignments, s3, false), r3.currentScope().__referencing(i, Ri$1.WRITE, n3.right, s3, !a3.topLevel, false);
    }) : this.currentScope().__referencing(n3.left, Ri$1.RW, n3.right) : this.visit(n3.left), this.visit(n3.right);
  } }, { key: "CatchClause", value: function(n3) {
    var r3 = this;
    this.scopeManager.__nestCatchScope(n3), this.visitPattern(n3.param, { processRightHandNodes: true }, function(i, a3) {
      r3.currentScope().__define(i, new ds$1(jr$2.CatchClause, n3.param, n3, null, null, null)), r3.referencingDefaultValue(i, a3.assignments, null, true);
    }), this.visit(n3.body), this.close(n3);
  } }, { key: "Program", value: function(n3) {
    this.scopeManager.__nestGlobalScope(n3), this.scopeManager.__isNodejsScope() && (this.currentScope().isStrict = false, this.scopeManager.__nestFunctionScope(n3, false)), this.scopeManager.__isES6() && this.scopeManager.isModule() && this.scopeManager.__nestModuleScope(n3), this.scopeManager.isStrictModeSupported() && this.scopeManager.isImpliedStrict() && (this.currentScope().isStrict = true), this.visitChildren(n3), this.close(n3);
  } }, { key: "Identifier", value: function(n3) {
    this.currentScope().__referencing(n3);
  } }, { key: "UpdateExpression", value: function(n3) {
    md$1.isPattern(n3.argument) ? this.currentScope().__referencing(n3.argument, Ri$1.RW, null) : this.visitChildren(n3);
  } }, { key: "MemberExpression", value: function(n3) {
    this.visit(n3.object), n3.computed && this.visit(n3.property);
  } }, { key: "Property", value: function(n3) {
    this.visitProperty(n3);
  } }, { key: "MethodDefinition", value: function(n3) {
    this.visitProperty(n3);
  } }, { key: "BreakStatement", value: function() {
  } }, { key: "ContinueStatement", value: function() {
  } }, { key: "LabeledStatement", value: function(n3) {
    this.visit(n3.body);
  } }, { key: "ForStatement", value: function(n3) {
    n3.init && n3.init.type === sa$2.VariableDeclaration && n3.init.kind !== "var" && this.scopeManager.__nestForScope(n3), this.visitChildren(n3), this.close(n3);
  } }, { key: "ClassExpression", value: function(n3) {
    this.visitClass(n3);
  } }, { key: "ClassDeclaration", value: function(n3) {
    this.visitClass(n3);
  } }, { key: "CallExpression", value: function(n3) {
    this.scopeManager.__ignoreEval() || n3.callee.type !== sa$2.Identifier || n3.callee.name !== "eval" || this.currentScope().variableScope.__detectEval(), this.visitChildren(n3);
  } }, { key: "BlockStatement", value: function(n3) {
    this.scopeManager.__isES6() && this.scopeManager.__nestBlockScope(n3), this.visitChildren(n3), this.close(n3);
  } }, { key: "ThisExpression", value: function() {
    this.currentScope().variableScope.__detectThis();
  } }, { key: "WithStatement", value: function(n3) {
    this.visit(n3.object), this.scopeManager.__nestWithScope(n3), this.visit(n3.body), this.close(n3);
  } }, { key: "VariableDeclaration", value: function(n3) {
    for (var r3 = n3.kind === "var" ? this.currentScope().variableScope : this.currentScope(), i = 0, a3 = n3.declarations.length; i < a3; ++i) {
      var s3 = n3.declarations[i];
      this.visitVariableDeclaration(r3, jr$2.Variable, n3, i), s3.init && this.visit(s3.init);
    }
  } }, { key: "SwitchStatement", value: function(n3) {
    this.visit(n3.discriminant), this.scopeManager.__isES6() && this.scopeManager.__nestSwitchScope(n3);
    for (var r3 = 0, i = n3.cases.length; r3 < i; ++r3)
      this.visit(n3.cases[r3]);
    this.close(n3);
  } }, { key: "FunctionDeclaration", value: function(n3) {
    this.visitFunction(n3);
  } }, { key: "FunctionExpression", value: function(n3) {
    this.visitFunction(n3);
  } }, { key: "ForOfStatement", value: function(n3) {
    this.visitForIn(n3);
  } }, { key: "ForInStatement", value: function(n3) {
    this.visitForIn(n3);
  } }, { key: "ArrowFunctionExpression", value: function(n3) {
    this.visitFunction(n3);
  } }, { key: "ImportDeclaration", value: function(n3) {
    xn$2(this.scopeManager.__isES6() && this.scopeManager.isModule(), "ImportDeclaration should appear when the mode is ES6 and in the module context."), new e92(n3, this).visit(n3);
  } }, { key: "visitExportDeclaration", value: function(n3) {
    n3.source || (n3.declaration ? this.visit(n3.declaration) : this.visitChildren(n3));
  } }, { key: "ExportDeclaration", value: function(n3) {
    this.visitExportDeclaration(n3);
  } }, { key: "ExportNamedDeclaration", value: function(n3) {
    this.visitExportDeclaration(n3);
  } }, { key: "ExportSpecifier", value: function(n3) {
    var r3 = n3.id || n3.local;
    this.visit(r3);
  } }, { key: "MetaProperty", value: function() {
  } }]), t3;
}(), gC = "http://github.com/eslint/eslint-scope", yC = { node: ">=8.0.0" }, vC = { url: "https://github.com/eslint/eslint-scope/issues" }, xC = { test: "node Makefile.js test", lint: "node Makefile.js lint", "generate-release": "eslint-generate-release", "generate-alpharelease": "eslint-generate-prerelease alpha", "generate-betarelease": "eslint-generate-prerelease beta", "generate-rcrelease": "eslint-generate-prerelease rc", "publish-release": "eslint-publish-release" }, bC = ["LICENSE", "README.md", "lib"], EC = { esrecurse: "^4.1.0", estraverse: "^4.1.1" }, CC = { "@typescript-eslint/parser": "^1.11.0", chai: "^4.2.0", eslint: "^6.0.1", "eslint-config-eslint": "^5.0.1", "eslint-plugin-node": "^9.1.0", "eslint-release": "^1.0.0", espree: "^6.0.0", istanbul: "^0.4.5", mocha: "^6.1.4", "npm-license": "^0.3.3", shelljs: "^0.8.3", typescript: "^3.5.2" }, n9 = { name: "eslint-scope", description: "ECMAScript scope analyzer for ESLint", homepage: gC, main: "lib/index.js", version: "5.0.0", engines: yC, repository: "eslint/eslint-scope", bugs: vC, license: "BSD-2-Clause", scripts: xC, files: bC, dependencies: EC, devDependencies: CC }, r9 = Cr$1(Object.freeze({ __proto__: null, name: "eslint-scope", description: "ECMAScript scope analyzer for ESLint", homepage: gC, main: "lib/index.js", version: "5.0.0", engines: yC, repository: "eslint/eslint-scope", bugs: vC, license: "BSD-2-Clause", scripts: xC, files: bC, dependencies: EC, devDependencies: CC, default: n9 })), i9 = ki$1.Scope, a9 = { version: r9.version, Reference: Ri$1, Variable: jr$2, Scope: i9, ScopeManager: cx, analyze: function(e28, t3) {
  var n3 = function i(a3, s3) {
    function o3(f3) {
      return xe$3(f3) === "object" && f3 instanceof Object && !(f3 instanceof Array) && !(f3 instanceof RegExp);
    }
    for (var u3 in s3)
      if (Object.prototype.hasOwnProperty.call(s3, u3)) {
        var c3 = s3[u3];
        o3(c3) ? o3(a3[u3]) ? i(a3[u3], c3) : a3[u3] = i({}, c3) : a3[u3] = c3;
      }
    return a3;
  }({ optimistic: false, directive: false, nodejsScope: false, impliedStrict: false, sourceType: "script", ecmaVersion: 5, childVisitorKeys: null, fallback: "iteration" }, t3), r3 = new cx(n3);
  return new t9(n3, r3).visit(e28), xn$2(r3.__currentScope === null, "currentScope should be null."), r3;
} }, SC = ["left", "right"], kC = ["left", "right"], DC = ["elements"], FC = ["elements"], wC = ["params", "body"], AC = ["argument"], _C = ["body"], TC = ["left", "right"], PC = ["label"], IC = ["callee", "arguments"], BC = ["param", "body"], OC = ["body"], LC = ["id", "superClass", "body"], NC = ["id", "superClass", "body"], jC = ["test", "consequent", "alternate"], RC = ["label"], MC = [], VC = ["body", "test"], UC = [], qC = ["source"], WC = ["declaration"], $C = ["declaration", "specifiers", "source"], GC = ["exported", "local"], zC = ["expression"], HC = ["argument"], KC = ["argument"], JC = ["init", "test", "update", "body"], QC = ["left", "right", "body"], XC = ["left", "right", "body"], YC = ["id", "params", "body"], ZC = ["id", "params", "body"], eS = [], tS = ["test", "consequent", "alternate"], nS = ["specifiers", "source"], rS = ["local"], iS = ["source"], aS = ["local"], oS = ["imported", "local"], sS = ["name", "value"], uS = ["name"], cS = ["openingElement", "children", "closingElement"], lS = [], pS = ["expression"], fS = [], hS = ["object", "property"], dS = ["namespace", "name"], mS = ["name", "attributes"], gS = ["argument"], yS = [], vS = ["openingFragment", "children", "closingFragment"], xS = [], bS = ["label", "body"], ES = ["left", "right"], CS = ["object", "property"], SS = ["meta", "property"], kS = ["key", "value"], DS = ["callee", "arguments"], FS = ["properties"], wS = ["properties"], AS = ["body"], _S = ["key", "value"], TS = ["argument"], PS = ["argument"], IS = ["expressions"], BS = ["argument"], OS = [], LS = ["discriminant", "cases"], NS = ["test", "consequent"], jS = ["tag", "quasi"], RS = [], MS = ["quasis", "expressions"], VS = [], US = ["argument"], qS = ["block", "handler", "finalizer"], WS = ["argument"], $S = ["argument"], GS = ["declarations"], zS = ["id", "init"], HS = ["test", "body"], KS = ["object", "body"], JS = ["argument"], o9 = { AssignmentExpression: SC, AssignmentPattern: kC, ArrayExpression: DC, ArrayPattern: FC, ArrowFunctionExpression: wC, AwaitExpression: AC, BlockStatement: _C, BinaryExpression: TC, BreakStatement: PC, CallExpression: IC, CatchClause: BC, ClassBody: OC, ClassDeclaration: LC, ClassExpression: NC, ConditionalExpression: jC, ContinueStatement: RC, DebuggerStatement: MC, DoWhileStatement: VC, EmptyStatement: UC, ExportAllDeclaration: qC, ExportDefaultDeclaration: WC, ExportNamedDeclaration: $C, ExportSpecifier: GC, ExpressionStatement: zC, ExperimentalRestProperty: HC, ExperimentalSpreadProperty: KC, ForStatement: JC, ForInStatement: QC, ForOfStatement: XC, FunctionDeclaration: YC, FunctionExpression: ZC, Identifier: eS, IfStatement: tS, ImportDeclaration: nS, ImportDefaultSpecifier: rS, ImportExpression: iS, ImportNamespaceSpecifier: aS, ImportSpecifier: oS, JSXAttribute: sS, JSXClosingElement: uS, JSXElement: cS, JSXEmptyExpression: lS, JSXExpressionContainer: pS, JSXIdentifier: fS, JSXMemberExpression: hS, JSXNamespacedName: dS, JSXOpeningElement: mS, JSXSpreadAttribute: gS, JSXText: yS, JSXFragment: vS, Literal: xS, LabeledStatement: bS, LogicalExpression: ES, MemberExpression: CS, MetaProperty: SS, MethodDefinition: kS, NewExpression: DS, ObjectExpression: FS, ObjectPattern: wS, Program: AS, Property: _S, RestElement: TS, ReturnStatement: PS, SequenceExpression: IS, SpreadElement: BS, Super: OS, SwitchStatement: LS, SwitchCase: NS, TaggedTemplateExpression: jS, TemplateElement: RS, TemplateLiteral: MS, ThisExpression: VS, ThrowStatement: US, TryStatement: qS, UnaryExpression: WS, UpdateExpression: $S, VariableDeclaration: GS, VariableDeclarator: zS, WhileStatement: HS, WithStatement: KS, YieldExpression: JS }, lc$2 = Cr$1(Object.freeze({ __proto__: null, AssignmentExpression: SC, AssignmentPattern: kC, ArrayExpression: DC, ArrayPattern: FC, ArrowFunctionExpression: wC, AwaitExpression: AC, BlockStatement: _C, BinaryExpression: TC, BreakStatement: PC, CallExpression: IC, CatchClause: BC, ClassBody: OC, ClassDeclaration: LC, ClassExpression: NC, ConditionalExpression: jC, ContinueStatement: RC, DebuggerStatement: MC, DoWhileStatement: VC, EmptyStatement: UC, ExportAllDeclaration: qC, ExportDefaultDeclaration: WC, ExportNamedDeclaration: $C, ExportSpecifier: GC, ExpressionStatement: zC, ExperimentalRestProperty: HC, ExperimentalSpreadProperty: KC, ForStatement: JC, ForInStatement: QC, ForOfStatement: XC, FunctionDeclaration: YC, FunctionExpression: ZC, Identifier: eS, IfStatement: tS, ImportDeclaration: nS, ImportDefaultSpecifier: rS, ImportExpression: iS, ImportNamespaceSpecifier: aS, ImportSpecifier: oS, JSXAttribute: sS, JSXClosingElement: uS, JSXElement: cS, JSXEmptyExpression: lS, JSXExpressionContainer: pS, JSXIdentifier: fS, JSXMemberExpression: hS, JSXNamespacedName: dS, JSXOpeningElement: mS, JSXSpreadAttribute: gS, JSXText: yS, JSXFragment: vS, Literal: xS, LabeledStatement: bS, LogicalExpression: ES, MemberExpression: CS, MetaProperty: SS, MethodDefinition: kS, NewExpression: DS, ObjectExpression: FS, ObjectPattern: wS, Program: AS, Property: _S, RestElement: TS, ReturnStatement: PS, SequenceExpression: IS, SpreadElement: BS, Super: OS, SwitchStatement: LS, SwitchCase: NS, TaggedTemplateExpression: jS, TemplateElement: RS, TemplateLiteral: MS, ThisExpression: VS, ThrowStatement: US, TryStatement: qS, UnaryExpression: WS, UpdateExpression: $S, VariableDeclaration: GS, VariableDeclarator: zS, WhileStatement: HS, WithStatement: KS, YieldExpression: JS, default: o9 })), s9 = Object.freeze(Object.keys(lc$2)), gd$1 = true, px = false, fx = void 0;
try {
  for (var hx, yd$1 = s9[Symbol.iterator](); !(gd$1 = (hx = yd$1.next()).done); gd$1 = true) {
    var u9 = hx.value;
    Object.freeze(lc$2[u9]);
  }
} catch (e28) {
  px = true, fx = e28;
} finally {
  try {
    gd$1 || yd$1.return == null || yd$1.return();
  } finally {
    if (px)
      throw fx;
  }
}
Object.freeze(lc$2);
var c9 = /* @__PURE__ */ new Set(["parent", "leadingComments", "trailingComments"]);
function l9(e28) {
  return !c9.has(e28) && e28[0] !== "_";
}
var pf = Object.freeze({ KEYS: lc$2, getKeys: function(e28) {
  return Object.keys(e28).filter(l9);
}, unionWith: function(e28) {
  for (var t3 = Object.assign({}, lc$2), n3 = 0, r3 = Object.keys(e28); n3 < r3.length; n3++) {
    var i = r3[n3];
    if (t3.hasOwnProperty(i)) {
      var a3 = new Set(e28[i]), s3 = true, o3 = false, u3 = void 0;
      try {
        for (var c3, f3 = t3[i][Symbol.iterator](); !(s3 = (c3 = f3.next()).done); s3 = true) {
          var p3 = c3.value;
          a3.add(p3);
        }
      } catch (d3) {
        o3 = true, u3 = d3;
      } finally {
        try {
          s3 || f3.return == null || f3.return();
        } finally {
          if (o3)
            throw u3;
        }
      }
      t3[i] = Object.freeze(Array.from(a3));
    } else
      t3[i] = Object.freeze(Array.from(e28[i]));
  }
  return Object.freeze(t3);
} }), vd$1 = { 3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile", 5: "class enum extends super const export import", 6: "enum", strict: "implements interface let package private protected public static yield", strictBind: "eval arguments" }, xd$1 = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", p9 = { 5: xd$1, "5module": xd$1 + " export import", 6: xd$1 + " const class extends export import super" }, f9 = /^in(stanceof)?$/, U0 = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7BF\uA7C2-\uA7C6\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB67\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", QS = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F", h9 = new RegExp("[" + U0 + "]"), d9 = new RegExp("[" + U0 + QS + "]");
U0 = QS = null;
var XS = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 157, 310, 10, 21, 11, 7, 153, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 477, 28, 11, 0, 9, 21, 155, 22, 13, 52, 76, 44, 33, 24, 27, 35, 30, 0, 12, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 0, 33, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 230, 43, 117, 63, 32, 0, 161, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 35, 56, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 270, 921, 103, 110, 18, 195, 2749, 1070, 4050, 582, 8634, 568, 8, 30, 114, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 754, 9486, 286, 50, 2, 18, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 2357, 44, 11, 6, 17, 0, 370, 43, 1301, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42710, 42, 4148, 12, 221, 3, 5761, 15, 7472, 3104, 541], m9 = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 525, 10, 176, 2, 54, 14, 32, 9, 16, 3, 46, 10, 54, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 4, 9, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 232, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 19306, 9, 135, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 19723, 1, 5319, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 262, 6, 10, 9, 419, 13, 1495, 6, 110, 6, 6, 9, 792487, 239];
function Im(e28, t3) {
  for (var n3 = 65536, r3 = 0; r3 < t3.length; r3 += 2) {
    if ((n3 += t3[r3]) > e28)
      return false;
    if ((n3 += t3[r3 + 1]) >= e28)
      return true;
  }
}
function Ea$2(e28, t3) {
  return e28 < 65 ? e28 === 36 : e28 < 91 || (e28 < 97 ? e28 === 95 : e28 < 123 || (e28 <= 65535 ? e28 >= 170 && h9.test(String.fromCharCode(e28)) : t3 !== false && Im(e28, XS)));
}
function Mo$1(e28, t3) {
  return e28 < 48 ? e28 === 36 : e28 < 58 || !(e28 < 65) && (e28 < 91 || (e28 < 97 ? e28 === 95 : e28 < 123 || (e28 <= 65535 ? e28 >= 170 && d9.test(String.fromCharCode(e28)) : t3 !== false && (Im(e28, XS) || Im(e28, m9)))));
}
var Ot$2 = function(e28, t3) {
  t3 === void 0 && (t3 = {}), this.label = e28, this.keyword = t3.keyword, this.beforeExpr = !!t3.beforeExpr, this.startsExpr = !!t3.startsExpr, this.isLoop = !!t3.isLoop, this.isAssign = !!t3.isAssign, this.prefix = !!t3.prefix, this.postfix = !!t3.postfix, this.binop = t3.binop || null, this.updateContext = null;
};
function yi$1(e28, t3) {
  return new Ot$2(e28, { beforeExpr: true, binop: t3 });
}
var Jr$1 = { beforeExpr: true }, Pr$1 = { startsExpr: true }, ff = {};
function kt$2(e28, t3) {
  return t3 === void 0 && (t3 = {}), t3.keyword = e28, ff[e28] = new Ot$2(e28, t3);
}
var $$6 = { num: new Ot$2("num", Pr$1), regexp: new Ot$2("regexp", Pr$1), string: new Ot$2("string", Pr$1), name: new Ot$2("name", Pr$1), eof: new Ot$2("eof"), bracketL: new Ot$2("[", { beforeExpr: true, startsExpr: true }), bracketR: new Ot$2("]"), braceL: new Ot$2("{", { beforeExpr: true, startsExpr: true }), braceR: new Ot$2("}"), parenL: new Ot$2("(", { beforeExpr: true, startsExpr: true }), parenR: new Ot$2(")"), comma: new Ot$2(",", Jr$1), semi: new Ot$2(";", Jr$1), colon: new Ot$2(":", Jr$1), dot: new Ot$2("."), question: new Ot$2("?", Jr$1), arrow: new Ot$2("=>", Jr$1), template: new Ot$2("template"), invalidTemplate: new Ot$2("invalidTemplate"), ellipsis: new Ot$2("...", Jr$1), backQuote: new Ot$2("`", Pr$1), dollarBraceL: new Ot$2("${", { beforeExpr: true, startsExpr: true }), eq: new Ot$2("=", { beforeExpr: true, isAssign: true }), assign: new Ot$2("_=", { beforeExpr: true, isAssign: true }), incDec: new Ot$2("++/--", { prefix: true, postfix: true, startsExpr: true }), prefix: new Ot$2("!/~", { beforeExpr: true, prefix: true, startsExpr: true }), logicalOR: yi$1("||", 1), logicalAND: yi$1("&&", 2), bitwiseOR: yi$1("|", 3), bitwiseXOR: yi$1("^", 4), bitwiseAND: yi$1("&", 5), equality: yi$1("==/!=/===/!==", 6), relational: yi$1("</>/<=/>=", 7), bitShift: yi$1("<</>>/>>>", 8), plusMin: new Ot$2("+/-", { beforeExpr: true, binop: 9, prefix: true, startsExpr: true }), modulo: yi$1("%", 10), star: yi$1("*", 10), slash: yi$1("/", 10), starstar: new Ot$2("**", { beforeExpr: true }), _break: kt$2("break"), _case: kt$2("case", Jr$1), _catch: kt$2("catch"), _continue: kt$2("continue"), _debugger: kt$2("debugger"), _default: kt$2("default", Jr$1), _do: kt$2("do", { isLoop: true, beforeExpr: true }), _else: kt$2("else", Jr$1), _finally: kt$2("finally"), _for: kt$2("for", { isLoop: true }), _function: kt$2("function", Pr$1), _if: kt$2("if"), _return: kt$2("return", Jr$1), _switch: kt$2("switch"), _throw: kt$2("throw", Jr$1), _try: kt$2("try"), _var: kt$2("var"), _const: kt$2("const"), _while: kt$2("while", { isLoop: true }), _with: kt$2("with"), _new: kt$2("new", { beforeExpr: true, startsExpr: true }), _this: kt$2("this", Pr$1), _super: kt$2("super", Pr$1), _class: kt$2("class", Pr$1), _extends: kt$2("extends", Jr$1), _export: kt$2("export"), _import: kt$2("import", Pr$1), _null: kt$2("null", Pr$1), _true: kt$2("true", Pr$1), _false: kt$2("false", Pr$1), _in: kt$2("in", { beforeExpr: true, binop: 7 }), _instanceof: kt$2("instanceof", { beforeExpr: true, binop: 7 }), _typeof: kt$2("typeof", { beforeExpr: true, prefix: true, startsExpr: true }), _void: kt$2("void", { beforeExpr: true, prefix: true, startsExpr: true }), _delete: kt$2("delete", { beforeExpr: true, prefix: true, startsExpr: true }) }, ci$1 = /\r\n?|\n|\u2028|\u2029/, qs$1 = new RegExp(ci$1.source, "g");
function Ws$1(e28, t3) {
  return e28 === 10 || e28 === 13 || !t3 && (e28 === 8232 || e28 === 8233);
}
var q0 = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Mi$1 = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, YS = Object.prototype, g9 = YS.hasOwnProperty, y9 = YS.toString;
function hf(e28, t3) {
  return g9.call(e28, t3);
}
var dx = Array.isArray || function(e28) {
  return y9.call(e28) === "[object Array]";
};
function Bo$1(e28) {
  return new RegExp("^(?:" + e28.replace(/ /g, "|") + ")$");
}
var $s$1 = function(e28, t3) {
  this.line = e28, this.column = t3;
};
$s$1.prototype.offset = function(e28) {
  return new $s$1(this.line, this.column + e28);
};
var Sc$2 = function(e28, t3, n3) {
  this.start = t3, this.end = n3, e28.sourceFile !== null && (this.source = e28.sourceFile);
};
function W0(e28, t3) {
  for (var n3 = 1, r3 = 0; ; ) {
    qs$1.lastIndex = r3;
    var i = qs$1.exec(e28);
    if (!(i && i.index < t3))
      return new $s$1(n3, t3 - r3);
    ++n3, r3 = i.index + i[0].length;
  }
}
var Op = { ecmaVersion: 10, sourceType: "script", onInsertedSemicolon: null, onTrailingComma: null, allowReserved: null, allowReturnOutsideFunction: false, allowImportExportEverywhere: false, allowAwaitOutsideFunction: false, allowHashBang: false, locations: false, onToken: null, onComment: null, ranges: false, program: null, sourceFile: null, directSourceFile: null, preserveParens: false };
function v9(e28) {
  var t3 = {};
  for (var n3 in Op)
    t3[n3] = e28 && hf(e28, n3) ? e28[n3] : Op[n3];
  if (t3.ecmaVersion >= 2015 && (t3.ecmaVersion -= 2009), t3.allowReserved == null && (t3.allowReserved = t3.ecmaVersion < 5), dx(t3.onToken)) {
    var r3 = t3.onToken;
    t3.onToken = function(i) {
      return r3.push(i);
    };
  }
  return dx(t3.onComment) && (t3.onComment = function(i, a3) {
    return function(s3, o3, u3, c3, f3, p3) {
      var d3 = { type: s3 ? "Block" : "Line", value: o3, start: u3, end: c3 };
      i.locations && (d3.loc = new Sc$2(this, f3, p3)), i.ranges && (d3.range = [u3, c3]), a3.push(d3);
    };
  }(t3, t3.onComment)), t3;
}
var pc$2 = 2, bd$1 = 1 | pc$2, ZS = 4, ek = 8;
function Bm(e28, t3) {
  return pc$2 | (e28 ? ZS : 0) | (t3 ? ek : 0);
}
var pn$1 = function(e28, t3, n3) {
  this.options = e28 = v9(e28), this.sourceFile = e28.sourceFile, this.keywords = Bo$1(p9[e28.ecmaVersion >= 6 ? 6 : e28.sourceType === "module" ? "5module" : 5]);
  var r3 = "";
  if (e28.allowReserved !== true) {
    for (var i = e28.ecmaVersion; !(r3 = vd$1[i]); i--)
      ;
    e28.sourceType === "module" && (r3 += " await");
  }
  this.reservedWords = Bo$1(r3);
  var a3 = (r3 ? r3 + " " : "") + vd$1.strict;
  this.reservedWordsStrict = Bo$1(a3), this.reservedWordsStrictBind = Bo$1(a3 + " " + vd$1.strictBind), this.input = String(t3), this.containsEsc = false, n3 ? (this.pos = n3, this.lineStart = this.input.lastIndexOf(`
`, n3 - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(ci$1).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = $$6.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = true, this.inModule = e28.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = {}, this.pos === 0 && e28.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(1), this.regexpState = null;
}, bo$2 = { inFunction: { configurable: true }, inGenerator: { configurable: true }, inAsync: { configurable: true }, allowSuper: { configurable: true }, allowDirectSuper: { configurable: true }, treatFunctionsAsVar: { configurable: true } };
pn$1.prototype.parse = function() {
  var e28 = this.options.program || this.startNode();
  return this.nextToken(), this.parseTopLevel(e28);
}, bo$2.inFunction.get = function() {
  return (this.currentVarScope().flags & pc$2) > 0;
}, bo$2.inGenerator.get = function() {
  return (this.currentVarScope().flags & ek) > 0;
}, bo$2.inAsync.get = function() {
  return (this.currentVarScope().flags & ZS) > 0;
}, bo$2.allowSuper.get = function() {
  return (64 & this.currentThisScope().flags) > 0;
}, bo$2.allowDirectSuper.get = function() {
  return (128 & this.currentThisScope().flags) > 0;
}, bo$2.treatFunctionsAsVar.get = function() {
  return this.treatFunctionsAsVarInScope(this.currentScope());
}, pn$1.prototype.inNonArrowFunction = function() {
  return (this.currentThisScope().flags & pc$2) > 0;
}, pn$1.extend = function() {
  for (var e28 = [], t3 = arguments.length; t3--; )
    e28[t3] = arguments[t3];
  for (var n3 = this, r3 = 0; r3 < e28.length; r3++)
    n3 = e28[r3](n3);
  return n3;
}, pn$1.parse = function(e28, t3) {
  return new this(t3, e28).parse();
}, pn$1.parseExpressionAt = function(e28, t3, n3) {
  var r3 = new this(n3, e28, t3);
  return r3.nextToken(), r3.parseExpression();
}, pn$1.tokenizer = function(e28, t3) {
  return new this(t3, e28);
}, Object.defineProperties(pn$1.prototype, bo$2);
var ar$1 = pn$1.prototype, x9 = /^(?:'((?:\\.|[^'])*?)'|"((?:\\.|[^"])*?)")/;
function Vu$1() {
  this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
}
ar$1.strictDirective = function(e28) {
  for (; ; ) {
    Mi$1.lastIndex = e28, e28 += Mi$1.exec(this.input)[0].length;
    var t3 = x9.exec(this.input.slice(e28));
    if (!t3)
      return false;
    if ((t3[1] || t3[2]) === "use strict")
      return true;
    e28 += t3[0].length, Mi$1.lastIndex = e28, e28 += Mi$1.exec(this.input)[0].length, this.input[e28] === ";" && e28++;
  }
}, ar$1.eat = function(e28) {
  return this.type === e28 && (this.next(), true);
}, ar$1.isContextual = function(e28) {
  return this.type === $$6.name && this.value === e28 && !this.containsEsc;
}, ar$1.eatContextual = function(e28) {
  return !!this.isContextual(e28) && (this.next(), true);
}, ar$1.expectContextual = function(e28) {
  this.eatContextual(e28) || this.unexpected();
}, ar$1.canInsertSemicolon = function() {
  return this.type === $$6.eof || this.type === $$6.braceR || ci$1.test(this.input.slice(this.lastTokEnd, this.start));
}, ar$1.insertSemicolon = function() {
  if (this.canInsertSemicolon())
    return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), true;
}, ar$1.semicolon = function() {
  this.eat($$6.semi) || this.insertSemicolon() || this.unexpected();
}, ar$1.afterTrailingComma = function(e28, t3) {
  if (this.type === e28)
    return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), t3 || this.next(), true;
}, ar$1.expect = function(e28) {
  this.eat(e28) || this.unexpected();
}, ar$1.unexpected = function(e28) {
  this.raise(e28 != null ? e28 : this.start, "Unexpected token");
}, ar$1.checkPatternErrors = function(e28, t3) {
  if (e28) {
    e28.trailingComma > -1 && this.raiseRecoverable(e28.trailingComma, "Comma is not permitted after the rest element");
    var n3 = t3 ? e28.parenthesizedAssign : e28.parenthesizedBind;
    n3 > -1 && this.raiseRecoverable(n3, "Parenthesized pattern");
  }
}, ar$1.checkExpressionErrors = function(e28, t3) {
  if (!e28)
    return false;
  var n3 = e28.shorthandAssign, r3 = e28.doubleProto;
  if (!t3)
    return n3 >= 0 || r3 >= 0;
  n3 >= 0 && this.raise(n3, "Shorthand property assignments are valid only in destructuring patterns"), r3 >= 0 && this.raiseRecoverable(r3, "Redefinition of __proto__ property");
}, ar$1.checkYieldAwaitInDefaultParams = function() {
  this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
}, ar$1.isSimpleAssignTarget = function(e28) {
  return e28.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(e28.expression) : e28.type === "Identifier" || e28.type === "MemberExpression";
};
var ct$2 = pn$1.prototype;
ct$2.parseTopLevel = function(e28) {
  var t3 = {};
  for (e28.body || (e28.body = []); this.type !== $$6.eof; ) {
    var n3 = this.parseStatement(null, true, t3);
    e28.body.push(n3);
  }
  if (this.inModule)
    for (var r3 = 0, i = Object.keys(this.undefinedExports); r3 < i.length; r3 += 1) {
      var a3 = i[r3];
      this.raiseRecoverable(this.undefinedExports[a3].start, "Export '" + a3 + "' is not defined");
    }
  return this.adaptDirectivePrologue(e28.body), this.next(), e28.sourceType = this.options.sourceType, this.finishNode(e28, "Program");
};
var Om = { kind: "loop" }, b9 = { kind: "switch" };
ct$2.isLet = function(e28) {
  if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
    return false;
  Mi$1.lastIndex = this.pos;
  var t3 = Mi$1.exec(this.input), n3 = this.pos + t3[0].length, r3 = this.input.charCodeAt(n3);
  if (r3 === 91)
    return true;
  if (e28)
    return false;
  if (r3 === 123)
    return true;
  if (Ea$2(r3, true)) {
    for (var i = n3 + 1; Mo$1(this.input.charCodeAt(i), true); )
      ++i;
    var a3 = this.input.slice(n3, i);
    if (!f9.test(a3))
      return true;
  }
  return false;
}, ct$2.isAsyncFunction = function() {
  if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
    return false;
  Mi$1.lastIndex = this.pos;
  var e28 = Mi$1.exec(this.input), t3 = this.pos + e28[0].length;
  return !(ci$1.test(this.input.slice(this.pos, t3)) || this.input.slice(t3, t3 + 8) !== "function" || t3 + 8 !== this.input.length && Mo$1(this.input.charAt(t3 + 8)));
}, ct$2.parseStatement = function(e28, t3, n3) {
  var r3, i = this.type, a3 = this.startNode();
  switch (this.isLet(e28) && (i = $$6._var, r3 = "let"), i) {
    case $$6._break:
    case $$6._continue:
      return this.parseBreakContinueStatement(a3, i.keyword);
    case $$6._debugger:
      return this.parseDebuggerStatement(a3);
    case $$6._do:
      return this.parseDoStatement(a3);
    case $$6._for:
      return this.parseForStatement(a3);
    case $$6._function:
      return e28 && (this.strict || e28 !== "if" && e28 !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(a3, false, !e28);
    case $$6._class:
      return e28 && this.unexpected(), this.parseClass(a3, true);
    case $$6._if:
      return this.parseIfStatement(a3);
    case $$6._return:
      return this.parseReturnStatement(a3);
    case $$6._switch:
      return this.parseSwitchStatement(a3);
    case $$6._throw:
      return this.parseThrowStatement(a3);
    case $$6._try:
      return this.parseTryStatement(a3);
    case $$6._const:
    case $$6._var:
      return r3 = r3 || this.value, e28 && r3 !== "var" && this.unexpected(), this.parseVarStatement(a3, r3);
    case $$6._while:
      return this.parseWhileStatement(a3);
    case $$6._with:
      return this.parseWithStatement(a3);
    case $$6.braceL:
      return this.parseBlock(true, a3);
    case $$6.semi:
      return this.parseEmptyStatement(a3);
    case $$6._export:
    case $$6._import:
      if (this.options.ecmaVersion > 10 && i === $$6._import) {
        Mi$1.lastIndex = this.pos;
        var s3 = Mi$1.exec(this.input), o3 = this.pos + s3[0].length;
        if (this.input.charCodeAt(o3) === 40)
          return this.parseExpressionStatement(a3, this.parseExpression());
      }
      return this.options.allowImportExportEverywhere || (t3 || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), i === $$6._import ? this.parseImport(a3) : this.parseExport(a3, n3);
    default:
      if (this.isAsyncFunction())
        return e28 && this.unexpected(), this.next(), this.parseFunctionStatement(a3, true, !e28);
      var u3 = this.value, c3 = this.parseExpression();
      return i === $$6.name && c3.type === "Identifier" && this.eat($$6.colon) ? this.parseLabeledStatement(a3, u3, c3, e28) : this.parseExpressionStatement(a3, c3);
  }
}, ct$2.parseBreakContinueStatement = function(e28, t3) {
  var n3 = t3 === "break";
  this.next(), this.eat($$6.semi) || this.insertSemicolon() ? e28.label = null : this.type !== $$6.name ? this.unexpected() : (e28.label = this.parseIdent(), this.semicolon());
  for (var r3 = 0; r3 < this.labels.length; ++r3) {
    var i = this.labels[r3];
    if ((e28.label == null || i.name === e28.label.name) && (i.kind != null && (n3 || i.kind === "loop") || e28.label && n3))
      break;
  }
  return r3 === this.labels.length && this.raise(e28.start, "Unsyntactic " + t3), this.finishNode(e28, n3 ? "BreakStatement" : "ContinueStatement");
}, ct$2.parseDebuggerStatement = function(e28) {
  return this.next(), this.semicolon(), this.finishNode(e28, "DebuggerStatement");
}, ct$2.parseDoStatement = function(e28) {
  return this.next(), this.labels.push(Om), e28.body = this.parseStatement("do"), this.labels.pop(), this.expect($$6._while), e28.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat($$6.semi) : this.semicolon(), this.finishNode(e28, "DoWhileStatement");
}, ct$2.parseForStatement = function(e28) {
  this.next();
  var t3 = this.options.ecmaVersion >= 9 && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction) && this.eatContextual("await") ? this.lastTokStart : -1;
  if (this.labels.push(Om), this.enterScope(0), this.expect($$6.parenL), this.type === $$6.semi)
    return t3 > -1 && this.unexpected(t3), this.parseFor(e28, null);
  var n3 = this.isLet();
  if (this.type === $$6._var || this.type === $$6._const || n3) {
    var r3 = this.startNode(), i = n3 ? "let" : this.value;
    return this.next(), this.parseVar(r3, true, i), this.finishNode(r3, "VariableDeclaration"), (this.type === $$6._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && r3.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === $$6._in ? t3 > -1 && this.unexpected(t3) : e28.await = t3 > -1), this.parseForIn(e28, r3)) : (t3 > -1 && this.unexpected(t3), this.parseFor(e28, r3));
  }
  var a3 = new Vu$1(), s3 = this.parseExpression(true, a3);
  return this.type === $$6._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? (this.options.ecmaVersion >= 9 && (this.type === $$6._in ? t3 > -1 && this.unexpected(t3) : e28.await = t3 > -1), this.toAssignable(s3, false, a3), this.checkLVal(s3), this.parseForIn(e28, s3)) : (this.checkExpressionErrors(a3, true), t3 > -1 && this.unexpected(t3), this.parseFor(e28, s3));
}, ct$2.parseFunctionStatement = function(e28, t3, n3) {
  return this.next(), this.parseFunction(e28, Uu$1 | (n3 ? 0 : Lm), false, t3);
}, ct$2.parseIfStatement = function(e28) {
  return this.next(), e28.test = this.parseParenExpression(), e28.consequent = this.parseStatement("if"), e28.alternate = this.eat($$6._else) ? this.parseStatement("if") : null, this.finishNode(e28, "IfStatement");
}, ct$2.parseReturnStatement = function(e28) {
  return this.inFunction || this.options.allowReturnOutsideFunction || this.raise(this.start, "'return' outside of function"), this.next(), this.eat($$6.semi) || this.insertSemicolon() ? e28.argument = null : (e28.argument = this.parseExpression(), this.semicolon()), this.finishNode(e28, "ReturnStatement");
}, ct$2.parseSwitchStatement = function(e28) {
  var t3;
  this.next(), e28.discriminant = this.parseParenExpression(), e28.cases = [], this.expect($$6.braceL), this.labels.push(b9), this.enterScope(0);
  for (var n3 = false; this.type !== $$6.braceR; )
    if (this.type === $$6._case || this.type === $$6._default) {
      var r3 = this.type === $$6._case;
      t3 && this.finishNode(t3, "SwitchCase"), e28.cases.push(t3 = this.startNode()), t3.consequent = [], this.next(), r3 ? t3.test = this.parseExpression() : (n3 && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), n3 = true, t3.test = null), this.expect($$6.colon);
    } else
      t3 || this.unexpected(), t3.consequent.push(this.parseStatement(null));
  return this.exitScope(), t3 && this.finishNode(t3, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(e28, "SwitchStatement");
}, ct$2.parseThrowStatement = function(e28) {
  return this.next(), ci$1.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), e28.argument = this.parseExpression(), this.semicolon(), this.finishNode(e28, "ThrowStatement");
};
var E9 = [];
ct$2.parseTryStatement = function(e28) {
  if (this.next(), e28.block = this.parseBlock(), e28.handler = null, this.type === $$6._catch) {
    var t3 = this.startNode();
    if (this.next(), this.eat($$6.parenL)) {
      t3.param = this.parseBindingAtom();
      var n3 = t3.param.type === "Identifier";
      this.enterScope(n3 ? 32 : 0), this.checkLVal(t3.param, n3 ? 4 : 2), this.expect($$6.parenR);
    } else
      this.options.ecmaVersion < 10 && this.unexpected(), t3.param = null, this.enterScope(0);
    t3.body = this.parseBlock(false), this.exitScope(), e28.handler = this.finishNode(t3, "CatchClause");
  }
  return e28.finalizer = this.eat($$6._finally) ? this.parseBlock() : null, e28.handler || e28.finalizer || this.raise(e28.start, "Missing catch or finally clause"), this.finishNode(e28, "TryStatement");
}, ct$2.parseVarStatement = function(e28, t3) {
  return this.next(), this.parseVar(e28, false, t3), this.semicolon(), this.finishNode(e28, "VariableDeclaration");
}, ct$2.parseWhileStatement = function(e28) {
  return this.next(), e28.test = this.parseParenExpression(), this.labels.push(Om), e28.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(e28, "WhileStatement");
}, ct$2.parseWithStatement = function(e28) {
  return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), e28.object = this.parseParenExpression(), e28.body = this.parseStatement("with"), this.finishNode(e28, "WithStatement");
}, ct$2.parseEmptyStatement = function(e28) {
  return this.next(), this.finishNode(e28, "EmptyStatement");
}, ct$2.parseLabeledStatement = function(e28, t3, n3, r3) {
  for (var i = 0, a3 = this.labels; i < a3.length; i += 1)
    a3[i].name === t3 && this.raise(n3.start, "Label '" + t3 + "' is already declared");
  for (var s3 = this.type.isLoop ? "loop" : this.type === $$6._switch ? "switch" : null, o3 = this.labels.length - 1; o3 >= 0; o3--) {
    var u3 = this.labels[o3];
    if (u3.statementStart !== e28.start)
      break;
    u3.statementStart = this.start, u3.kind = s3;
  }
  return this.labels.push({ name: t3, kind: s3, statementStart: this.start }), e28.body = this.parseStatement(r3 ? r3.indexOf("label") === -1 ? r3 + "label" : r3 : "label"), this.labels.pop(), e28.label = n3, this.finishNode(e28, "LabeledStatement");
}, ct$2.parseExpressionStatement = function(e28, t3) {
  return e28.expression = t3, this.semicolon(), this.finishNode(e28, "ExpressionStatement");
}, ct$2.parseBlock = function(e28, t3) {
  for (e28 === void 0 && (e28 = true), t3 === void 0 && (t3 = this.startNode()), t3.body = [], this.expect($$6.braceL), e28 && this.enterScope(0); !this.eat($$6.braceR); ) {
    var n3 = this.parseStatement(null);
    t3.body.push(n3);
  }
  return e28 && this.exitScope(), this.finishNode(t3, "BlockStatement");
}, ct$2.parseFor = function(e28, t3) {
  return e28.init = t3, this.expect($$6.semi), e28.test = this.type === $$6.semi ? null : this.parseExpression(), this.expect($$6.semi), e28.update = this.type === $$6.parenR ? null : this.parseExpression(), this.expect($$6.parenR), e28.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e28, "ForStatement");
}, ct$2.parseForIn = function(e28, t3) {
  var n3 = this.type === $$6._in;
  return this.next(), t3.type === "VariableDeclaration" && t3.declarations[0].init != null && (!n3 || this.options.ecmaVersion < 8 || this.strict || t3.kind !== "var" || t3.declarations[0].id.type !== "Identifier") ? this.raise(t3.start, (n3 ? "for-in" : "for-of") + " loop variable declaration may not have an initializer") : t3.type === "AssignmentPattern" && this.raise(t3.start, "Invalid left-hand side in for-loop"), e28.left = t3, e28.right = n3 ? this.parseExpression() : this.parseMaybeAssign(), this.expect($$6.parenR), e28.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e28, n3 ? "ForInStatement" : "ForOfStatement");
}, ct$2.parseVar = function(e28, t3, n3) {
  for (e28.declarations = [], e28.kind = n3; ; ) {
    var r3 = this.startNode();
    if (this.parseVarId(r3, n3), this.eat($$6.eq) ? r3.init = this.parseMaybeAssign(t3) : n3 !== "const" || this.type === $$6._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? r3.id.type === "Identifier" || t3 && (this.type === $$6._in || this.isContextual("of")) ? r3.init = null : this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : this.unexpected(), e28.declarations.push(this.finishNode(r3, "VariableDeclarator")), !this.eat($$6.comma))
      break;
  }
  return e28;
}, ct$2.parseVarId = function(e28, t3) {
  e28.id = this.parseBindingAtom(), this.checkLVal(e28.id, t3 === "var" ? 1 : 2, false);
};
var Uu$1 = 1, Lm = 2;
ct$2.parseFunction = function(e28, t3, n3, r3) {
  this.initFunction(e28), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !r3) && (this.type === $$6.star && t3 & Lm && this.unexpected(), e28.generator = this.eat($$6.star)), this.options.ecmaVersion >= 8 && (e28.async = !!r3), t3 & Uu$1 && (e28.id = 4 & t3 && this.type !== $$6.name ? null : this.parseIdent(), !e28.id || t3 & Lm || this.checkLVal(e28.id, this.strict || e28.generator || e28.async ? this.treatFunctionsAsVar ? 1 : 2 : 3));
  var i = this.yieldPos, a3 = this.awaitPos, s3 = this.awaitIdentPos;
  return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(Bm(e28.async, e28.generator)), t3 & Uu$1 || (e28.id = this.type === $$6.name ? this.parseIdent() : null), this.parseFunctionParams(e28), this.parseFunctionBody(e28, n3, false), this.yieldPos = i, this.awaitPos = a3, this.awaitIdentPos = s3, this.finishNode(e28, t3 & Uu$1 ? "FunctionDeclaration" : "FunctionExpression");
}, ct$2.parseFunctionParams = function(e28) {
  this.expect($$6.parenL), e28.params = this.parseBindingList($$6.parenR, false, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
}, ct$2.parseClass = function(e28, t3) {
  this.next();
  var n3 = this.strict;
  this.strict = true, this.parseClassId(e28, t3), this.parseClassSuper(e28);
  var r3 = this.startNode(), i = false;
  for (r3.body = [], this.expect($$6.braceL); !this.eat($$6.braceR); ) {
    var a3 = this.parseClassElement(e28.superClass !== null);
    a3 && (r3.body.push(a3), a3.type === "MethodDefinition" && a3.kind === "constructor" && (i && this.raise(a3.start, "Duplicate constructor in the same class"), i = true));
  }
  return e28.body = this.finishNode(r3, "ClassBody"), this.strict = n3, this.finishNode(e28, t3 ? "ClassDeclaration" : "ClassExpression");
}, ct$2.parseClassElement = function(e28) {
  var t3 = this;
  if (this.eat($$6.semi))
    return null;
  var n3 = this.startNode(), r3 = function(u3, c3) {
    c3 === void 0 && (c3 = false);
    var f3 = t3.start, p3 = t3.startLoc;
    return !!t3.eatContextual(u3) && (!(t3.type === $$6.parenL || c3 && t3.canInsertSemicolon()) || (n3.key && t3.unexpected(), n3.computed = false, n3.key = t3.startNodeAt(f3, p3), n3.key.name = u3, t3.finishNode(n3.key, "Identifier"), false));
  };
  n3.kind = "method", n3.static = r3("static");
  var i = this.eat($$6.star), a3 = false;
  i || (this.options.ecmaVersion >= 8 && r3("async", true) ? (a3 = true, i = this.options.ecmaVersion >= 9 && this.eat($$6.star)) : r3("get") ? n3.kind = "get" : r3("set") && (n3.kind = "set")), n3.key || this.parsePropertyName(n3);
  var s3 = n3.key, o3 = false;
  return n3.computed || n3.static || !(s3.type === "Identifier" && s3.name === "constructor" || s3.type === "Literal" && s3.value === "constructor") ? n3.static && s3.type === "Identifier" && s3.name === "prototype" && this.raise(s3.start, "Classes may not have a static property named prototype") : (n3.kind !== "method" && this.raise(s3.start, "Constructor can't have get/set modifier"), i && this.raise(s3.start, "Constructor can't be a generator"), a3 && this.raise(s3.start, "Constructor can't be an async method"), n3.kind = "constructor", o3 = e28), this.parseClassMethod(n3, i, a3, o3), n3.kind === "get" && n3.value.params.length !== 0 && this.raiseRecoverable(n3.value.start, "getter should have no params"), n3.kind === "set" && n3.value.params.length !== 1 && this.raiseRecoverable(n3.value.start, "setter should have exactly one param"), n3.kind === "set" && n3.value.params[0].type === "RestElement" && this.raiseRecoverable(n3.value.params[0].start, "Setter cannot use rest params"), n3;
}, ct$2.parseClassMethod = function(e28, t3, n3, r3) {
  return e28.value = this.parseMethod(t3, n3, r3), this.finishNode(e28, "MethodDefinition");
}, ct$2.parseClassId = function(e28, t3) {
  this.type === $$6.name ? (e28.id = this.parseIdent(), t3 && this.checkLVal(e28.id, 2, false)) : (t3 === true && this.unexpected(), e28.id = null);
}, ct$2.parseClassSuper = function(e28) {
  e28.superClass = this.eat($$6._extends) ? this.parseExprSubscripts() : null;
}, ct$2.parseExport = function(e28, t3) {
  if (this.next(), this.eat($$6.star))
    return this.expectContextual("from"), this.type !== $$6.string && this.unexpected(), e28.source = this.parseExprAtom(), this.semicolon(), this.finishNode(e28, "ExportAllDeclaration");
  if (this.eat($$6._default)) {
    var n3;
    if (this.checkExport(t3, "default", this.lastTokStart), this.type === $$6._function || (n3 = this.isAsyncFunction())) {
      var r3 = this.startNode();
      this.next(), n3 && this.next(), e28.declaration = this.parseFunction(r3, 4 | Uu$1, false, n3);
    } else if (this.type === $$6._class) {
      var i = this.startNode();
      e28.declaration = this.parseClass(i, "nullableID");
    } else
      e28.declaration = this.parseMaybeAssign(), this.semicolon();
    return this.finishNode(e28, "ExportDefaultDeclaration");
  }
  if (this.shouldParseExportStatement())
    e28.declaration = this.parseStatement(null), e28.declaration.type === "VariableDeclaration" ? this.checkVariableExport(t3, e28.declaration.declarations) : this.checkExport(t3, e28.declaration.id.name, e28.declaration.id.start), e28.specifiers = [], e28.source = null;
  else {
    if (e28.declaration = null, e28.specifiers = this.parseExportSpecifiers(t3), this.eatContextual("from"))
      this.type !== $$6.string && this.unexpected(), e28.source = this.parseExprAtom();
    else {
      for (var a3 = 0, s3 = e28.specifiers; a3 < s3.length; a3 += 1) {
        var o3 = s3[a3];
        this.checkUnreserved(o3.local), this.checkLocalExport(o3.local);
      }
      e28.source = null;
    }
    this.semicolon();
  }
  return this.finishNode(e28, "ExportNamedDeclaration");
}, ct$2.checkExport = function(e28, t3, n3) {
  e28 && (hf(e28, t3) && this.raiseRecoverable(n3, "Duplicate export '" + t3 + "'"), e28[t3] = true);
}, ct$2.checkPatternExport = function(e28, t3) {
  var n3 = t3.type;
  if (n3 === "Identifier")
    this.checkExport(e28, t3.name, t3.start);
  else if (n3 === "ObjectPattern")
    for (var r3 = 0, i = t3.properties; r3 < i.length; r3 += 1) {
      var a3 = i[r3];
      this.checkPatternExport(e28, a3);
    }
  else if (n3 === "ArrayPattern")
    for (var s3 = 0, o3 = t3.elements; s3 < o3.length; s3 += 1) {
      var u3 = o3[s3];
      u3 && this.checkPatternExport(e28, u3);
    }
  else
    n3 === "Property" ? this.checkPatternExport(e28, t3.value) : n3 === "AssignmentPattern" ? this.checkPatternExport(e28, t3.left) : n3 === "RestElement" ? this.checkPatternExport(e28, t3.argument) : n3 === "ParenthesizedExpression" && this.checkPatternExport(e28, t3.expression);
}, ct$2.checkVariableExport = function(e28, t3) {
  if (e28)
    for (var n3 = 0, r3 = t3; n3 < r3.length; n3 += 1) {
      var i = r3[n3];
      this.checkPatternExport(e28, i.id);
    }
}, ct$2.shouldParseExportStatement = function() {
  return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
}, ct$2.parseExportSpecifiers = function(e28) {
  var t3 = [], n3 = true;
  for (this.expect($$6.braceL); !this.eat($$6.braceR); ) {
    if (n3)
      n3 = false;
    else if (this.expect($$6.comma), this.afterTrailingComma($$6.braceR))
      break;
    var r3 = this.startNode();
    r3.local = this.parseIdent(true), r3.exported = this.eatContextual("as") ? this.parseIdent(true) : r3.local, this.checkExport(e28, r3.exported.name, r3.exported.start), t3.push(this.finishNode(r3, "ExportSpecifier"));
  }
  return t3;
}, ct$2.parseImport = function(e28) {
  return this.next(), this.type === $$6.string ? (e28.specifiers = E9, e28.source = this.parseExprAtom()) : (e28.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), e28.source = this.type === $$6.string ? this.parseExprAtom() : this.unexpected()), this.semicolon(), this.finishNode(e28, "ImportDeclaration");
}, ct$2.parseImportSpecifiers = function() {
  var e28 = [], t3 = true;
  if (this.type === $$6.name) {
    var n3 = this.startNode();
    if (n3.local = this.parseIdent(), this.checkLVal(n3.local, 2), e28.push(this.finishNode(n3, "ImportDefaultSpecifier")), !this.eat($$6.comma))
      return e28;
  }
  if (this.type === $$6.star) {
    var r3 = this.startNode();
    return this.next(), this.expectContextual("as"), r3.local = this.parseIdent(), this.checkLVal(r3.local, 2), e28.push(this.finishNode(r3, "ImportNamespaceSpecifier")), e28;
  }
  for (this.expect($$6.braceL); !this.eat($$6.braceR); ) {
    if (t3)
      t3 = false;
    else if (this.expect($$6.comma), this.afterTrailingComma($$6.braceR))
      break;
    var i = this.startNode();
    i.imported = this.parseIdent(true), this.eatContextual("as") ? i.local = this.parseIdent() : (this.checkUnreserved(i.imported), i.local = i.imported), this.checkLVal(i.local, 2), e28.push(this.finishNode(i, "ImportSpecifier"));
  }
  return e28;
}, ct$2.adaptDirectivePrologue = function(e28) {
  for (var t3 = 0; t3 < e28.length && this.isDirectiveCandidate(e28[t3]); ++t3)
    e28[t3].directive = e28[t3].expression.raw.slice(1, -1);
}, ct$2.isDirectiveCandidate = function(e28) {
  return e28.type === "ExpressionStatement" && e28.expression.type === "Literal" && typeof e28.expression.value == "string" && (this.input[e28.start] === '"' || this.input[e28.start] === "'");
};
var ua$2 = pn$1.prototype;
ua$2.toAssignable = function(e28, t3, n3) {
  if (this.options.ecmaVersion >= 6 && e28)
    switch (e28.type) {
      case "Identifier":
        this.inAsync && e28.name === "await" && this.raise(e28.start, "Cannot use 'await' as identifier inside an async function");
        break;
      case "ObjectPattern":
      case "ArrayPattern":
      case "RestElement":
        break;
      case "ObjectExpression":
        e28.type = "ObjectPattern", n3 && this.checkPatternErrors(n3, true);
        for (var r3 = 0, i = e28.properties; r3 < i.length; r3 += 1) {
          var a3 = i[r3];
          this.toAssignable(a3, t3), a3.type !== "RestElement" || a3.argument.type !== "ArrayPattern" && a3.argument.type !== "ObjectPattern" || this.raise(a3.argument.start, "Unexpected token");
        }
        break;
      case "Property":
        e28.kind !== "init" && this.raise(e28.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(e28.value, t3);
        break;
      case "ArrayExpression":
        e28.type = "ArrayPattern", n3 && this.checkPatternErrors(n3, true), this.toAssignableList(e28.elements, t3);
        break;
      case "SpreadElement":
        e28.type = "RestElement", this.toAssignable(e28.argument, t3), e28.argument.type === "AssignmentPattern" && this.raise(e28.argument.start, "Rest elements cannot have a default value");
        break;
      case "AssignmentExpression":
        e28.operator !== "=" && this.raise(e28.left.end, "Only '=' operator can be used for specifying default value."), e28.type = "AssignmentPattern", delete e28.operator, this.toAssignable(e28.left, t3);
      case "AssignmentPattern":
        break;
      case "ParenthesizedExpression":
        this.toAssignable(e28.expression, t3, n3);
        break;
      case "MemberExpression":
        if (!t3)
          break;
      default:
        this.raise(e28.start, "Assigning to rvalue");
    }
  else
    n3 && this.checkPatternErrors(n3, true);
  return e28;
}, ua$2.toAssignableList = function(e28, t3) {
  for (var n3 = e28.length, r3 = 0; r3 < n3; r3++) {
    var i = e28[r3];
    i && this.toAssignable(i, t3);
  }
  if (n3) {
    var a3 = e28[n3 - 1];
    this.options.ecmaVersion === 6 && t3 && a3 && a3.type === "RestElement" && a3.argument.type !== "Identifier" && this.unexpected(a3.argument.start);
  }
  return e28;
}, ua$2.parseSpread = function(e28) {
  var t3 = this.startNode();
  return this.next(), t3.argument = this.parseMaybeAssign(false, e28), this.finishNode(t3, "SpreadElement");
}, ua$2.parseRestBinding = function() {
  var e28 = this.startNode();
  return this.next(), this.options.ecmaVersion === 6 && this.type !== $$6.name && this.unexpected(), e28.argument = this.parseBindingAtom(), this.finishNode(e28, "RestElement");
}, ua$2.parseBindingAtom = function() {
  if (this.options.ecmaVersion >= 6)
    switch (this.type) {
      case $$6.bracketL:
        var e28 = this.startNode();
        return this.next(), e28.elements = this.parseBindingList($$6.bracketR, true, true), this.finishNode(e28, "ArrayPattern");
      case $$6.braceL:
        return this.parseObj(true);
    }
  return this.parseIdent();
}, ua$2.parseBindingList = function(e28, t3, n3) {
  for (var r3 = [], i = true; !this.eat(e28); )
    if (i ? i = false : this.expect($$6.comma), t3 && this.type === $$6.comma)
      r3.push(null);
    else {
      if (n3 && this.afterTrailingComma(e28))
        break;
      if (this.type === $$6.ellipsis) {
        var a3 = this.parseRestBinding();
        this.parseBindingListItem(a3), r3.push(a3), this.type === $$6.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.expect(e28);
        break;
      }
      var s3 = this.parseMaybeDefault(this.start, this.startLoc);
      this.parseBindingListItem(s3), r3.push(s3);
    }
  return r3;
}, ua$2.parseBindingListItem = function(e28) {
  return e28;
}, ua$2.parseMaybeDefault = function(e28, t3, n3) {
  if (n3 = n3 || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat($$6.eq))
    return n3;
  var r3 = this.startNodeAt(e28, t3);
  return r3.left = n3, r3.right = this.parseMaybeAssign(), this.finishNode(r3, "AssignmentPattern");
}, ua$2.checkLVal = function(e28, t3, n3) {
  switch (t3 === void 0 && (t3 = 0), e28.type) {
    case "Identifier":
      t3 === 2 && e28.name === "let" && this.raiseRecoverable(e28.start, "let is disallowed as a lexically bound name"), this.strict && this.reservedWordsStrictBind.test(e28.name) && this.raiseRecoverable(e28.start, (t3 ? "Binding " : "Assigning to ") + e28.name + " in strict mode"), n3 && (hf(n3, e28.name) && this.raiseRecoverable(e28.start, "Argument name clash"), n3[e28.name] = true), t3 !== 0 && t3 !== 5 && this.declareName(e28.name, t3, e28.start);
      break;
    case "MemberExpression":
      t3 && this.raiseRecoverable(e28.start, "Binding member expression");
      break;
    case "ObjectPattern":
      for (var r3 = 0, i = e28.properties; r3 < i.length; r3 += 1) {
        var a3 = i[r3];
        this.checkLVal(a3, t3, n3);
      }
      break;
    case "Property":
      this.checkLVal(e28.value, t3, n3);
      break;
    case "ArrayPattern":
      for (var s3 = 0, o3 = e28.elements; s3 < o3.length; s3 += 1) {
        var u3 = o3[s3];
        u3 && this.checkLVal(u3, t3, n3);
      }
      break;
    case "AssignmentPattern":
      this.checkLVal(e28.left, t3, n3);
      break;
    case "RestElement":
      this.checkLVal(e28.argument, t3, n3);
      break;
    case "ParenthesizedExpression":
      this.checkLVal(e28.expression, t3, n3);
      break;
    default:
      this.raise(e28.start, (t3 ? "Binding" : "Assigning to") + " rvalue");
  }
};
var xt$2 = pn$1.prototype;
xt$2.checkPropClash = function(e28, t3, n3) {
  if (!(this.options.ecmaVersion >= 9 && e28.type === "SpreadElement" || this.options.ecmaVersion >= 6 && (e28.computed || e28.method || e28.shorthand))) {
    var r3, i = e28.key;
    switch (i.type) {
      case "Identifier":
        r3 = i.name;
        break;
      case "Literal":
        r3 = String(i.value);
        break;
      default:
        return;
    }
    var a3 = e28.kind;
    if (this.options.ecmaVersion >= 6)
      r3 === "__proto__" && a3 === "init" && (t3.proto && (n3 && n3.doubleProto < 0 ? n3.doubleProto = i.start : this.raiseRecoverable(i.start, "Redefinition of __proto__ property")), t3.proto = true);
    else {
      var s3 = t3[r3 = "$" + r3];
      s3 ? (a3 === "init" ? this.strict && s3.init || s3.get || s3.set : s3.init || s3[a3]) && this.raiseRecoverable(i.start, "Redefinition of property") : s3 = t3[r3] = { init: false, get: false, set: false }, s3[a3] = true;
    }
  }
}, xt$2.parseExpression = function(e28, t3) {
  var n3 = this.start, r3 = this.startLoc, i = this.parseMaybeAssign(e28, t3);
  if (this.type === $$6.comma) {
    var a3 = this.startNodeAt(n3, r3);
    for (a3.expressions = [i]; this.eat($$6.comma); )
      a3.expressions.push(this.parseMaybeAssign(e28, t3));
    return this.finishNode(a3, "SequenceExpression");
  }
  return i;
}, xt$2.parseMaybeAssign = function(e28, t3, n3) {
  if (this.isContextual("yield")) {
    if (this.inGenerator)
      return this.parseYield(e28);
    this.exprAllowed = false;
  }
  var r3 = false, i = -1, a3 = -1, s3 = -1;
  t3 ? (i = t3.parenthesizedAssign, a3 = t3.trailingComma, s3 = t3.shorthandAssign, t3.parenthesizedAssign = t3.trailingComma = t3.shorthandAssign = -1) : (t3 = new Vu$1(), r3 = true);
  var o3 = this.start, u3 = this.startLoc;
  this.type !== $$6.parenL && this.type !== $$6.name || (this.potentialArrowAt = this.start);
  var c3 = this.parseMaybeConditional(e28, t3);
  if (n3 && (c3 = n3.call(this, c3, o3, u3)), this.type.isAssign) {
    var f3 = this.startNodeAt(o3, u3);
    return f3.operator = this.value, f3.left = this.type === $$6.eq ? this.toAssignable(c3, false, t3) : c3, r3 || Vu$1.call(t3), t3.shorthandAssign = -1, this.checkLVal(c3), this.next(), f3.right = this.parseMaybeAssign(e28), this.finishNode(f3, "AssignmentExpression");
  }
  return r3 && this.checkExpressionErrors(t3, true), i > -1 && (t3.parenthesizedAssign = i), a3 > -1 && (t3.trailingComma = a3), s3 > -1 && (t3.shorthandAssign = s3), c3;
}, xt$2.parseMaybeConditional = function(e28, t3) {
  var n3 = this.start, r3 = this.startLoc, i = this.parseExprOps(e28, t3);
  if (this.checkExpressionErrors(t3))
    return i;
  if (this.eat($$6.question)) {
    var a3 = this.startNodeAt(n3, r3);
    return a3.test = i, a3.consequent = this.parseMaybeAssign(), this.expect($$6.colon), a3.alternate = this.parseMaybeAssign(e28), this.finishNode(a3, "ConditionalExpression");
  }
  return i;
}, xt$2.parseExprOps = function(e28, t3) {
  var n3 = this.start, r3 = this.startLoc, i = this.parseMaybeUnary(t3, false);
  return this.checkExpressionErrors(t3) || i.start === n3 && i.type === "ArrowFunctionExpression" ? i : this.parseExprOp(i, n3, r3, -1, e28);
}, xt$2.parseExprOp = function(e28, t3, n3, r3, i) {
  var a3 = this.type.binop;
  if (a3 != null && (!i || this.type !== $$6._in) && a3 > r3) {
    var s3 = this.type === $$6.logicalOR || this.type === $$6.logicalAND, o3 = this.value;
    this.next();
    var u3 = this.start, c3 = this.startLoc, f3 = this.parseExprOp(this.parseMaybeUnary(null, false), u3, c3, a3, i), p3 = this.buildBinary(t3, n3, e28, f3, o3, s3);
    return this.parseExprOp(p3, t3, n3, r3, i);
  }
  return e28;
}, xt$2.buildBinary = function(e28, t3, n3, r3, i, a3) {
  var s3 = this.startNodeAt(e28, t3);
  return s3.left = n3, s3.operator = i, s3.right = r3, this.finishNode(s3, a3 ? "LogicalExpression" : "BinaryExpression");
}, xt$2.parseMaybeUnary = function(e28, t3) {
  var n3, r3 = this.start, i = this.startLoc;
  if (this.isContextual("await") && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction))
    n3 = this.parseAwait(), t3 = true;
  else if (this.type.prefix) {
    var a3 = this.startNode(), s3 = this.type === $$6.incDec;
    a3.operator = this.value, a3.prefix = true, this.next(), a3.argument = this.parseMaybeUnary(null, true), this.checkExpressionErrors(e28, true), s3 ? this.checkLVal(a3.argument) : this.strict && a3.operator === "delete" && a3.argument.type === "Identifier" ? this.raiseRecoverable(a3.start, "Deleting local variable in strict mode") : t3 = true, n3 = this.finishNode(a3, s3 ? "UpdateExpression" : "UnaryExpression");
  } else {
    if (n3 = this.parseExprSubscripts(e28), this.checkExpressionErrors(e28))
      return n3;
    for (; this.type.postfix && !this.canInsertSemicolon(); ) {
      var o3 = this.startNodeAt(r3, i);
      o3.operator = this.value, o3.prefix = false, o3.argument = n3, this.checkLVal(n3), this.next(), n3 = this.finishNode(o3, "UpdateExpression");
    }
  }
  return !t3 && this.eat($$6.starstar) ? this.buildBinary(r3, i, n3, this.parseMaybeUnary(null, false), "**", false) : n3;
}, xt$2.parseExprSubscripts = function(e28) {
  var t3 = this.start, n3 = this.startLoc, r3 = this.parseExprAtom(e28), i = r3.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")";
  if (this.checkExpressionErrors(e28) || i)
    return r3;
  var a3 = this.parseSubscripts(r3, t3, n3);
  return e28 && a3.type === "MemberExpression" && (e28.parenthesizedAssign >= a3.start && (e28.parenthesizedAssign = -1), e28.parenthesizedBind >= a3.start && (e28.parenthesizedBind = -1)), a3;
}, xt$2.parseSubscripts = function(e28, t3, n3, r3) {
  for (var i = this.options.ecmaVersion >= 8 && e28.type === "Identifier" && e28.name === "async" && this.lastTokEnd === e28.end && !this.canInsertSemicolon() && this.input.slice(e28.start, e28.end) === "async"; ; ) {
    var a3 = this.parseSubscript(e28, t3, n3, r3, i);
    if (a3 === e28 || a3.type === "ArrowFunctionExpression")
      return a3;
    e28 = a3;
  }
}, xt$2.parseSubscript = function(e28, t3, n3, r3, i) {
  var a3 = this.eat($$6.bracketL);
  if (a3 || this.eat($$6.dot)) {
    var s3 = this.startNodeAt(t3, n3);
    s3.object = e28, s3.property = a3 ? this.parseExpression() : this.parseIdent(this.options.allowReserved !== "never"), s3.computed = !!a3, a3 && this.expect($$6.bracketR), e28 = this.finishNode(s3, "MemberExpression");
  } else if (!r3 && this.eat($$6.parenL)) {
    var o3 = new Vu$1(), u3 = this.yieldPos, c3 = this.awaitPos, f3 = this.awaitIdentPos;
    this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
    var p3 = this.parseExprList($$6.parenR, this.options.ecmaVersion >= 8, false, o3);
    if (i && !this.canInsertSemicolon() && this.eat($$6.arrow))
      return this.checkPatternErrors(o3, false), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = u3, this.awaitPos = c3, this.awaitIdentPos = f3, this.parseArrowExpression(this.startNodeAt(t3, n3), p3, true);
    this.checkExpressionErrors(o3, true), this.yieldPos = u3 || this.yieldPos, this.awaitPos = c3 || this.awaitPos, this.awaitIdentPos = f3 || this.awaitIdentPos;
    var d3 = this.startNodeAt(t3, n3);
    d3.callee = e28, d3.arguments = p3, e28 = this.finishNode(d3, "CallExpression");
  } else if (this.type === $$6.backQuote) {
    var m3 = this.startNodeAt(t3, n3);
    m3.tag = e28, m3.quasi = this.parseTemplate({ isTagged: true }), e28 = this.finishNode(m3, "TaggedTemplateExpression");
  }
  return e28;
}, xt$2.parseExprAtom = function(e28) {
  this.type === $$6.slash && this.readRegexp();
  var t3, n3 = this.potentialArrowAt === this.start;
  switch (this.type) {
    case $$6._super:
      return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), t3 = this.startNode(), this.next(), this.type !== $$6.parenL || this.allowDirectSuper || this.raise(t3.start, "super() call outside constructor of a subclass"), this.type !== $$6.dot && this.type !== $$6.bracketL && this.type !== $$6.parenL && this.unexpected(), this.finishNode(t3, "Super");
    case $$6._this:
      return t3 = this.startNode(), this.next(), this.finishNode(t3, "ThisExpression");
    case $$6.name:
      var r3 = this.start, i = this.startLoc, a3 = this.containsEsc, s3 = this.parseIdent(false);
      if (this.options.ecmaVersion >= 8 && !a3 && s3.name === "async" && !this.canInsertSemicolon() && this.eat($$6._function))
        return this.parseFunction(this.startNodeAt(r3, i), 0, false, true);
      if (n3 && !this.canInsertSemicolon()) {
        if (this.eat($$6.arrow))
          return this.parseArrowExpression(this.startNodeAt(r3, i), [s3], false);
        if (this.options.ecmaVersion >= 8 && s3.name === "async" && this.type === $$6.name && !a3)
          return s3 = this.parseIdent(false), !this.canInsertSemicolon() && this.eat($$6.arrow) || this.unexpected(), this.parseArrowExpression(this.startNodeAt(r3, i), [s3], true);
      }
      return s3;
    case $$6.regexp:
      var o3 = this.value;
      return (t3 = this.parseLiteral(o3.value)).regex = { pattern: o3.pattern, flags: o3.flags }, t3;
    case $$6.num:
    case $$6.string:
      return this.parseLiteral(this.value);
    case $$6._null:
    case $$6._true:
    case $$6._false:
      return (t3 = this.startNode()).value = this.type === $$6._null ? null : this.type === $$6._true, t3.raw = this.type.keyword, this.next(), this.finishNode(t3, "Literal");
    case $$6.parenL:
      var u3 = this.start, c3 = this.parseParenAndDistinguishExpression(n3);
      return e28 && (e28.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(c3) && (e28.parenthesizedAssign = u3), e28.parenthesizedBind < 0 && (e28.parenthesizedBind = u3)), c3;
    case $$6.bracketL:
      return t3 = this.startNode(), this.next(), t3.elements = this.parseExprList($$6.bracketR, true, true, e28), this.finishNode(t3, "ArrayExpression");
    case $$6.braceL:
      return this.parseObj(false, e28);
    case $$6._function:
      return t3 = this.startNode(), this.next(), this.parseFunction(t3, 0);
    case $$6._class:
      return this.parseClass(this.startNode(), false);
    case $$6._new:
      return this.parseNew();
    case $$6.backQuote:
      return this.parseTemplate();
    case $$6._import:
      return this.options.ecmaVersion >= 11 ? this.parseExprImport() : this.unexpected();
    default:
      this.unexpected();
  }
}, xt$2.parseExprImport = function() {
  var e28 = this.startNode();
  switch (this.next(), this.type) {
    case $$6.parenL:
      return this.parseDynamicImport(e28);
    default:
      this.unexpected();
  }
}, xt$2.parseDynamicImport = function(e28) {
  if (this.next(), e28.source = this.parseMaybeAssign(), !this.eat($$6.parenR)) {
    var t3 = this.start;
    this.eat($$6.comma) && this.eat($$6.parenR) ? this.raiseRecoverable(t3, "Trailing comma is not allowed in import()") : this.unexpected(t3);
  }
  return this.finishNode(e28, "ImportExpression");
}, xt$2.parseLiteral = function(e28) {
  var t3 = this.startNode();
  return t3.value = e28, t3.raw = this.input.slice(this.start, this.end), t3.raw.charCodeAt(t3.raw.length - 1) === 110 && (t3.bigint = t3.raw.slice(0, -1)), this.next(), this.finishNode(t3, "Literal");
}, xt$2.parseParenExpression = function() {
  this.expect($$6.parenL);
  var e28 = this.parseExpression();
  return this.expect($$6.parenR), e28;
}, xt$2.parseParenAndDistinguishExpression = function(e28) {
  var t3, n3 = this.start, r3 = this.startLoc, i = this.options.ecmaVersion >= 8;
  if (this.options.ecmaVersion >= 6) {
    this.next();
    var a3, s3 = this.start, o3 = this.startLoc, u3 = [], c3 = true, f3 = false, p3 = new Vu$1(), d3 = this.yieldPos, m3 = this.awaitPos;
    for (this.yieldPos = 0, this.awaitPos = 0; this.type !== $$6.parenR; ) {
      if (c3 ? c3 = false : this.expect($$6.comma), i && this.afterTrailingComma($$6.parenR, true)) {
        f3 = true;
        break;
      }
      if (this.type === $$6.ellipsis) {
        a3 = this.start, u3.push(this.parseParenItem(this.parseRestBinding())), this.type === $$6.comma && this.raise(this.start, "Comma is not permitted after the rest element");
        break;
      }
      u3.push(this.parseMaybeAssign(false, p3, this.parseParenItem));
    }
    var y3 = this.start, v3 = this.startLoc;
    if (this.expect($$6.parenR), e28 && !this.canInsertSemicolon() && this.eat($$6.arrow))
      return this.checkPatternErrors(p3, false), this.checkYieldAwaitInDefaultParams(), this.yieldPos = d3, this.awaitPos = m3, this.parseParenArrowList(n3, r3, u3);
    u3.length && !f3 || this.unexpected(this.lastTokStart), a3 && this.unexpected(a3), this.checkExpressionErrors(p3, true), this.yieldPos = d3 || this.yieldPos, this.awaitPos = m3 || this.awaitPos, u3.length > 1 ? ((t3 = this.startNodeAt(s3, o3)).expressions = u3, this.finishNodeAt(t3, "SequenceExpression", y3, v3)) : t3 = u3[0];
  } else
    t3 = this.parseParenExpression();
  if (this.options.preserveParens) {
    var b3 = this.startNodeAt(n3, r3);
    return b3.expression = t3, this.finishNode(b3, "ParenthesizedExpression");
  }
  return t3;
}, xt$2.parseParenItem = function(e28) {
  return e28;
}, xt$2.parseParenArrowList = function(e28, t3, n3) {
  return this.parseArrowExpression(this.startNodeAt(e28, t3), n3);
};
var C9 = [];
xt$2.parseNew = function() {
  var e28 = this.startNode(), t3 = this.parseIdent(true);
  if (this.options.ecmaVersion >= 6 && this.eat($$6.dot)) {
    e28.meta = t3;
    var n3 = this.containsEsc;
    return e28.property = this.parseIdent(true), (e28.property.name !== "target" || n3) && this.raiseRecoverable(e28.property.start, "The only valid meta property for new is new.target"), this.inNonArrowFunction() || this.raiseRecoverable(e28.start, "new.target can only be used in functions"), this.finishNode(e28, "MetaProperty");
  }
  var r3 = this.start, i = this.startLoc, a3 = this.type === $$6._import;
  return e28.callee = this.parseSubscripts(this.parseExprAtom(), r3, i, true), a3 && e28.callee.type === "ImportExpression" && this.raise(r3, "Cannot use new with import()"), this.eat($$6.parenL) ? e28.arguments = this.parseExprList($$6.parenR, this.options.ecmaVersion >= 8, false) : e28.arguments = C9, this.finishNode(e28, "NewExpression");
}, xt$2.parseTemplateElement = function(e28) {
  var t3 = e28.isTagged, n3 = this.startNode();
  return this.type === $$6.invalidTemplate ? (t3 || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), n3.value = { raw: this.value, cooked: null }) : n3.value = { raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`), cooked: this.value }, this.next(), n3.tail = this.type === $$6.backQuote, this.finishNode(n3, "TemplateElement");
}, xt$2.parseTemplate = function(e28) {
  e28 === void 0 && (e28 = {});
  var t3 = e28.isTagged;
  t3 === void 0 && (t3 = false);
  var n3 = this.startNode();
  this.next(), n3.expressions = [];
  var r3 = this.parseTemplateElement({ isTagged: t3 });
  for (n3.quasis = [r3]; !r3.tail; )
    this.type === $$6.eof && this.raise(this.pos, "Unterminated template literal"), this.expect($$6.dollarBraceL), n3.expressions.push(this.parseExpression()), this.expect($$6.braceR), n3.quasis.push(r3 = this.parseTemplateElement({ isTagged: t3 }));
  return this.next(), this.finishNode(n3, "TemplateLiteral");
}, xt$2.isAsyncProp = function(e28) {
  return !e28.computed && e28.key.type === "Identifier" && e28.key.name === "async" && (this.type === $$6.name || this.type === $$6.num || this.type === $$6.string || this.type === $$6.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === $$6.star) && !ci$1.test(this.input.slice(this.lastTokEnd, this.start));
}, xt$2.parseObj = function(e28, t3) {
  var n3 = this.startNode(), r3 = true, i = {};
  for (n3.properties = [], this.next(); !this.eat($$6.braceR); ) {
    if (r3)
      r3 = false;
    else if (this.expect($$6.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma($$6.braceR))
      break;
    var a3 = this.parseProperty(e28, t3);
    e28 || this.checkPropClash(a3, i, t3), n3.properties.push(a3);
  }
  return this.finishNode(n3, e28 ? "ObjectPattern" : "ObjectExpression");
}, xt$2.parseProperty = function(e28, t3) {
  var n3, r3, i, a3, s3 = this.startNode();
  if (this.options.ecmaVersion >= 9 && this.eat($$6.ellipsis))
    return e28 ? (s3.argument = this.parseIdent(false), this.type === $$6.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.finishNode(s3, "RestElement")) : (this.type === $$6.parenL && t3 && (t3.parenthesizedAssign < 0 && (t3.parenthesizedAssign = this.start), t3.parenthesizedBind < 0 && (t3.parenthesizedBind = this.start)), s3.argument = this.parseMaybeAssign(false, t3), this.type === $$6.comma && t3 && t3.trailingComma < 0 && (t3.trailingComma = this.start), this.finishNode(s3, "SpreadElement"));
  this.options.ecmaVersion >= 6 && (s3.method = false, s3.shorthand = false, (e28 || t3) && (i = this.start, a3 = this.startLoc), e28 || (n3 = this.eat($$6.star)));
  var o3 = this.containsEsc;
  return this.parsePropertyName(s3), !e28 && !o3 && this.options.ecmaVersion >= 8 && !n3 && this.isAsyncProp(s3) ? (r3 = true, n3 = this.options.ecmaVersion >= 9 && this.eat($$6.star), this.parsePropertyName(s3, t3)) : r3 = false, this.parsePropertyValue(s3, e28, n3, r3, i, a3, t3, o3), this.finishNode(s3, "Property");
}, xt$2.parsePropertyValue = function(e28, t3, n3, r3, i, a3, s3, o3) {
  if ((n3 || r3) && this.type === $$6.colon && this.unexpected(), this.eat($$6.colon))
    e28.value = t3 ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(false, s3), e28.kind = "init";
  else if (this.options.ecmaVersion >= 6 && this.type === $$6.parenL)
    t3 && this.unexpected(), e28.kind = "init", e28.method = true, e28.value = this.parseMethod(n3, r3);
  else if (t3 || o3 || !(this.options.ecmaVersion >= 5) || e28.computed || e28.key.type !== "Identifier" || e28.key.name !== "get" && e28.key.name !== "set" || this.type === $$6.comma || this.type === $$6.braceR)
    this.options.ecmaVersion >= 6 && !e28.computed && e28.key.type === "Identifier" ? ((n3 || r3) && this.unexpected(), this.checkUnreserved(e28.key), e28.key.name !== "await" || this.awaitIdentPos || (this.awaitIdentPos = i), e28.kind = "init", t3 ? e28.value = this.parseMaybeDefault(i, a3, e28.key) : this.type === $$6.eq && s3 ? (s3.shorthandAssign < 0 && (s3.shorthandAssign = this.start), e28.value = this.parseMaybeDefault(i, a3, e28.key)) : e28.value = e28.key, e28.shorthand = true) : this.unexpected();
  else {
    (n3 || r3) && this.unexpected(), e28.kind = e28.key.name, this.parsePropertyName(e28), e28.value = this.parseMethod(false);
    var u3 = e28.kind === "get" ? 0 : 1;
    if (e28.value.params.length !== u3) {
      var c3 = e28.value.start;
      e28.kind === "get" ? this.raiseRecoverable(c3, "getter should have no params") : this.raiseRecoverable(c3, "setter should have exactly one param");
    } else
      e28.kind === "set" && e28.value.params[0].type === "RestElement" && this.raiseRecoverable(e28.value.params[0].start, "Setter cannot use rest params");
  }
}, xt$2.parsePropertyName = function(e28) {
  if (this.options.ecmaVersion >= 6) {
    if (this.eat($$6.bracketL))
      return e28.computed = true, e28.key = this.parseMaybeAssign(), this.expect($$6.bracketR), e28.key;
    e28.computed = false;
  }
  return e28.key = this.type === $$6.num || this.type === $$6.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
}, xt$2.initFunction = function(e28) {
  e28.id = null, this.options.ecmaVersion >= 6 && (e28.generator = e28.expression = false), this.options.ecmaVersion >= 8 && (e28.async = false);
}, xt$2.parseMethod = function(e28, t3, n3) {
  var r3 = this.startNode(), i = this.yieldPos, a3 = this.awaitPos, s3 = this.awaitIdentPos;
  return this.initFunction(r3), this.options.ecmaVersion >= 6 && (r3.generator = e28), this.options.ecmaVersion >= 8 && (r3.async = !!t3), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(64 | Bm(t3, r3.generator) | (n3 ? 128 : 0)), this.expect($$6.parenL), r3.params = this.parseBindingList($$6.parenR, false, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(r3, false, true), this.yieldPos = i, this.awaitPos = a3, this.awaitIdentPos = s3, this.finishNode(r3, "FunctionExpression");
}, xt$2.parseArrowExpression = function(e28, t3, n3) {
  var r3 = this.yieldPos, i = this.awaitPos, a3 = this.awaitIdentPos;
  return this.enterScope(16 | Bm(n3, false)), this.initFunction(e28), this.options.ecmaVersion >= 8 && (e28.async = !!n3), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, e28.params = this.toAssignableList(t3, true), this.parseFunctionBody(e28, true, false), this.yieldPos = r3, this.awaitPos = i, this.awaitIdentPos = a3, this.finishNode(e28, "ArrowFunctionExpression");
}, xt$2.parseFunctionBody = function(e28, t3, n3) {
  var r3 = t3 && this.type !== $$6.braceL, i = this.strict, a3 = false;
  if (r3)
    e28.body = this.parseMaybeAssign(), e28.expression = true, this.checkParams(e28, false);
  else {
    var s3 = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(e28.params);
    i && !s3 || (a3 = this.strictDirective(this.end)) && s3 && this.raiseRecoverable(e28.start, "Illegal 'use strict' directive in function with non-simple parameter list");
    var o3 = this.labels;
    this.labels = [], a3 && (this.strict = true), this.checkParams(e28, !i && !a3 && !t3 && !n3 && this.isSimpleParamList(e28.params)), e28.body = this.parseBlock(false), e28.expression = false, this.adaptDirectivePrologue(e28.body.body), this.labels = o3;
  }
  this.exitScope(), this.strict && e28.id && this.checkLVal(e28.id, 5), this.strict = i;
}, xt$2.isSimpleParamList = function(e28) {
  for (var t3 = 0, n3 = e28; t3 < n3.length; t3 += 1)
    if (n3[t3].type !== "Identifier")
      return false;
  return true;
}, xt$2.checkParams = function(e28, t3) {
  for (var n3 = {}, r3 = 0, i = e28.params; r3 < i.length; r3 += 1) {
    var a3 = i[r3];
    this.checkLVal(a3, 1, t3 ? null : n3);
  }
}, xt$2.parseExprList = function(e28, t3, n3, r3) {
  for (var i = [], a3 = true; !this.eat(e28); ) {
    if (a3)
      a3 = false;
    else if (this.expect($$6.comma), t3 && this.afterTrailingComma(e28))
      break;
    var s3 = void 0;
    n3 && this.type === $$6.comma ? s3 = null : this.type === $$6.ellipsis ? (s3 = this.parseSpread(r3), r3 && this.type === $$6.comma && r3.trailingComma < 0 && (r3.trailingComma = this.start)) : s3 = this.parseMaybeAssign(false, r3), i.push(s3);
  }
  return i;
}, xt$2.checkUnreserved = function(e28) {
  var t3 = e28.start, n3 = e28.end, r3 = e28.name;
  this.inGenerator && r3 === "yield" && this.raiseRecoverable(t3, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && r3 === "await" && this.raiseRecoverable(t3, "Cannot use 'await' as identifier inside an async function"), this.keywords.test(r3) && this.raise(t3, "Unexpected keyword '" + r3 + "'"), this.options.ecmaVersion < 6 && this.input.slice(t3, n3).indexOf("\\") !== -1 || (this.strict ? this.reservedWordsStrict : this.reservedWords).test(r3) && (this.inAsync || r3 !== "await" || this.raiseRecoverable(t3, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(t3, "The keyword '" + r3 + "' is reserved"));
}, xt$2.parseIdent = function(e28, t3) {
  var n3 = this.startNode();
  return this.type === $$6.name ? n3.name = this.value : this.type.keyword ? (n3.name = this.type.keyword, n3.name !== "class" && n3.name !== "function" || this.lastTokEnd === this.lastTokStart + 1 && this.input.charCodeAt(this.lastTokStart) === 46 || this.context.pop()) : this.unexpected(), this.next(), this.finishNode(n3, "Identifier"), e28 || (this.checkUnreserved(n3), n3.name !== "await" || this.awaitIdentPos || (this.awaitIdentPos = n3.start)), n3;
}, xt$2.parseYield = function(e28) {
  this.yieldPos || (this.yieldPos = this.start);
  var t3 = this.startNode();
  return this.next(), this.type === $$6.semi || this.canInsertSemicolon() || this.type !== $$6.star && !this.type.startsExpr ? (t3.delegate = false, t3.argument = null) : (t3.delegate = this.eat($$6.star), t3.argument = this.parseMaybeAssign(e28)), this.finishNode(t3, "YieldExpression");
}, xt$2.parseAwait = function() {
  this.awaitPos || (this.awaitPos = this.start);
  var e28 = this.startNode();
  return this.next(), e28.argument = this.parseMaybeUnary(null, true), this.finishNode(e28, "AwaitExpression");
};
var Il = pn$1.prototype;
Il.raise = function(e28, t3) {
  var n3 = W0(this.input, e28);
  t3 += " (" + n3.line + ":" + n3.column + ")";
  var r3 = new SyntaxError(t3);
  throw r3.pos = e28, r3.loc = n3, r3.raisedAt = this.pos, r3;
}, Il.raiseRecoverable = Il.raise, Il.curPosition = function() {
  if (this.options.locations)
    return new $s$1(this.curLine, this.pos - this.lineStart);
};
var qa$2 = pn$1.prototype, S9 = function(e28) {
  this.flags = e28, this.var = [], this.lexical = [], this.functions = [];
};
qa$2.enterScope = function(e28) {
  this.scopeStack.push(new S9(e28));
}, qa$2.exitScope = function() {
  this.scopeStack.pop();
}, qa$2.treatFunctionsAsVarInScope = function(e28) {
  return e28.flags & pc$2 || !this.inModule && 1 & e28.flags;
}, qa$2.declareName = function(e28, t3, n3) {
  var r3 = false;
  if (t3 === 2) {
    var i = this.currentScope();
    r3 = i.lexical.indexOf(e28) > -1 || i.functions.indexOf(e28) > -1 || i.var.indexOf(e28) > -1, i.lexical.push(e28), this.inModule && 1 & i.flags && delete this.undefinedExports[e28];
  } else if (t3 === 4)
    this.currentScope().lexical.push(e28);
  else if (t3 === 3) {
    var a3 = this.currentScope();
    r3 = this.treatFunctionsAsVar ? a3.lexical.indexOf(e28) > -1 : a3.lexical.indexOf(e28) > -1 || a3.var.indexOf(e28) > -1, a3.functions.push(e28);
  } else
    for (var s3 = this.scopeStack.length - 1; s3 >= 0; --s3) {
      var o3 = this.scopeStack[s3];
      if (o3.lexical.indexOf(e28) > -1 && !(32 & o3.flags && o3.lexical[0] === e28) || !this.treatFunctionsAsVarInScope(o3) && o3.functions.indexOf(e28) > -1) {
        r3 = true;
        break;
      }
      if (o3.var.push(e28), this.inModule && 1 & o3.flags && delete this.undefinedExports[e28], o3.flags & bd$1)
        break;
    }
  r3 && this.raiseRecoverable(n3, "Identifier '" + e28 + "' has already been declared");
}, qa$2.checkLocalExport = function(e28) {
  this.scopeStack[0].lexical.indexOf(e28.name) === -1 && this.scopeStack[0].var.indexOf(e28.name) === -1 && (this.undefinedExports[e28.name] = e28);
}, qa$2.currentScope = function() {
  return this.scopeStack[this.scopeStack.length - 1];
}, qa$2.currentVarScope = function() {
  for (var e28 = this.scopeStack.length - 1; ; e28--) {
    var t3 = this.scopeStack[e28];
    if (t3.flags & bd$1)
      return t3;
  }
}, qa$2.currentThisScope = function() {
  for (var e28 = this.scopeStack.length - 1; ; e28--) {
    var t3 = this.scopeStack[e28];
    if (t3.flags & bd$1 && !(16 & t3.flags))
      return t3;
  }
};
var Lp = function(e28, t3, n3) {
  this.type = "", this.start = t3, this.end = 0, e28.options.locations && (this.loc = new Sc$2(e28, n3)), e28.options.directSourceFile && (this.sourceFile = e28.options.directSourceFile), e28.options.ranges && (this.range = [t3, 0]);
}, Bl = pn$1.prototype;
function mx(e28, t3, n3, r3) {
  return e28.type = t3, e28.end = n3, this.options.locations && (e28.loc.end = r3), this.options.ranges && (e28.range[1] = n3), e28;
}
Bl.startNode = function() {
  return new Lp(this, this.start, this.startLoc);
}, Bl.startNodeAt = function(e28, t3) {
  return new Lp(this, e28, t3);
}, Bl.finishNode = function(e28, t3) {
  return mx.call(this, e28, t3, this.lastTokEnd, this.lastTokEndLoc);
}, Bl.finishNodeAt = function(e28, t3, n3, r3) {
  return mx.call(this, e28, t3, n3, r3);
};
var Zr$1 = function(e28, t3, n3, r3, i) {
  this.token = e28, this.isExpr = !!t3, this.preserveSpace = !!n3, this.override = r3, this.generator = !!i;
}, gn$1 = { b_stat: new Zr$1("{", false), b_expr: new Zr$1("{", true), b_tmpl: new Zr$1("${", false), p_stat: new Zr$1("(", false), p_expr: new Zr$1("(", true), q_tmpl: new Zr$1("`", true, true, function(e28) {
  return e28.tryReadTemplateToken();
}), f_stat: new Zr$1("function", false), f_expr: new Zr$1("function", true), f_expr_gen: new Zr$1("function", true, false, null, true), f_gen: new Zr$1("function", false, false, null, true) }, Ol = pn$1.prototype;
Ol.initialContext = function() {
  return [gn$1.b_stat];
}, Ol.braceIsBlock = function(e28) {
  var t3 = this.curContext();
  return t3 === gn$1.f_expr || t3 === gn$1.f_stat || (e28 !== $$6.colon || t3 !== gn$1.b_stat && t3 !== gn$1.b_expr ? e28 === $$6._return || e28 === $$6.name && this.exprAllowed ? ci$1.test(this.input.slice(this.lastTokEnd, this.start)) : e28 === $$6._else || e28 === $$6.semi || e28 === $$6.eof || e28 === $$6.parenR || e28 === $$6.arrow || (e28 === $$6.braceL ? t3 === gn$1.b_stat : e28 !== $$6._var && e28 !== $$6._const && e28 !== $$6.name && !this.exprAllowed) : !t3.isExpr);
}, Ol.inGeneratorContext = function() {
  for (var e28 = this.context.length - 1; e28 >= 1; e28--) {
    var t3 = this.context[e28];
    if (t3.token === "function")
      return t3.generator;
  }
  return false;
}, Ol.updateContext = function(e28) {
  var t3, n3 = this.type;
  n3.keyword && e28 === $$6.dot ? this.exprAllowed = false : (t3 = n3.updateContext) ? t3.call(this, e28) : this.exprAllowed = n3.beforeExpr;
}, $$6.parenR.updateContext = $$6.braceR.updateContext = function() {
  if (this.context.length !== 1) {
    var e28 = this.context.pop();
    e28 === gn$1.b_stat && this.curContext().token === "function" && (e28 = this.context.pop()), this.exprAllowed = !e28.isExpr;
  } else
    this.exprAllowed = true;
}, $$6.braceL.updateContext = function(e28) {
  this.context.push(this.braceIsBlock(e28) ? gn$1.b_stat : gn$1.b_expr), this.exprAllowed = true;
}, $$6.dollarBraceL.updateContext = function() {
  this.context.push(gn$1.b_tmpl), this.exprAllowed = true;
}, $$6.parenL.updateContext = function(e28) {
  var t3 = e28 === $$6._if || e28 === $$6._for || e28 === $$6._with || e28 === $$6._while;
  this.context.push(t3 ? gn$1.p_stat : gn$1.p_expr), this.exprAllowed = true;
}, $$6.incDec.updateContext = function() {
}, $$6._function.updateContext = $$6._class.updateContext = function(e28) {
  !e28.beforeExpr || e28 === $$6.semi || e28 === $$6._else || e28 === $$6._return && ci$1.test(this.input.slice(this.lastTokEnd, this.start)) || (e28 === $$6.colon || e28 === $$6.braceL) && this.curContext() === gn$1.b_stat ? this.context.push(gn$1.f_stat) : this.context.push(gn$1.f_expr), this.exprAllowed = false;
}, $$6.backQuote.updateContext = function() {
  this.curContext() === gn$1.q_tmpl ? this.context.pop() : this.context.push(gn$1.q_tmpl), this.exprAllowed = false;
}, $$6.star.updateContext = function(e28) {
  if (e28 === $$6._function) {
    var t3 = this.context.length - 1;
    this.context[t3] === gn$1.f_expr ? this.context[t3] = gn$1.f_expr_gen : this.context[t3] = gn$1.f_gen;
  }
  this.exprAllowed = true;
}, $$6.name.updateContext = function(e28) {
  var t3 = false;
  this.options.ecmaVersion >= 6 && e28 !== $$6.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (t3 = true), this.exprAllowed = t3;
};
var tk = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", k9 = tk + " Extended_Pictographic", D9 = { 9: tk, 10: k9, 11: "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS Extended_Pictographic" }, gx = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", nk = "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", F9 = nk + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", w9 = { 9: nk, 10: F9, 11: "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho" }, rk = {};
function Ed$1(e28) {
  var t3 = rk[e28] = { binary: Bo$1(D9[e28] + " " + gx), nonBinary: { General_Category: Bo$1(gx), Script: Bo$1(w9[e28]) } };
  t3.nonBinary.Script_Extensions = t3.nonBinary.Script, t3.nonBinary.gc = t3.nonBinary.General_Category, t3.nonBinary.sc = t3.nonBinary.Script, t3.nonBinary.scx = t3.nonBinary.Script_Extensions;
}
Ed$1(9), Ed$1(10), Ed$1(11);
var He$1 = pn$1.prototype, ha$2 = function(e28) {
  this.parser = e28, this.validFlags = "gim" + (e28.options.ecmaVersion >= 6 ? "uy" : "") + (e28.options.ecmaVersion >= 9 ? "s" : ""), this.unicodeProperties = rk[e28.options.ecmaVersion >= 11 ? 11 : e28.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = false, this.switchN = false, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = false, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = [], this.backReferenceNames = [];
};
function Ll(e28) {
  return e28 <= 65535 ? String.fromCharCode(e28) : (e28 -= 65536, String.fromCharCode(55296 + (e28 >> 10), 56320 + (1023 & e28)));
}
function yx(e28) {
  return e28 === 36 || e28 >= 40 && e28 <= 43 || e28 === 46 || e28 === 63 || e28 >= 91 && e28 <= 94 || e28 >= 123 && e28 <= 125;
}
function ik(e28) {
  return e28 >= 65 && e28 <= 90 || e28 >= 97 && e28 <= 122;
}
function ak(e28) {
  return ik(e28) || e28 === 95;
}
function A9(e28) {
  return ak(e28) || sp(e28);
}
function sp(e28) {
  return e28 >= 48 && e28 <= 57;
}
function vx(e28) {
  return e28 >= 48 && e28 <= 57 || e28 >= 65 && e28 <= 70 || e28 >= 97 && e28 <= 102;
}
function xx(e28) {
  return e28 >= 65 && e28 <= 70 ? e28 - 65 + 10 : e28 >= 97 && e28 <= 102 ? e28 - 97 + 10 : e28 - 48;
}
function bx(e28) {
  return e28 >= 48 && e28 <= 55;
}
ha$2.prototype.reset = function(e28, t3, n3) {
  var r3 = n3.indexOf("u") !== -1;
  this.start = 0 | e28, this.source = t3 + "", this.flags = n3, this.switchU = r3 && this.parser.options.ecmaVersion >= 6, this.switchN = r3 && this.parser.options.ecmaVersion >= 9;
}, ha$2.prototype.raise = function(e28) {
  this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + e28);
}, ha$2.prototype.at = function(e28) {
  var t3 = this.source, n3 = t3.length;
  if (e28 >= n3)
    return -1;
  var r3 = t3.charCodeAt(e28);
  return !this.switchU || r3 <= 55295 || r3 >= 57344 || e28 + 1 >= n3 ? r3 : (r3 << 10) + t3.charCodeAt(e28 + 1) - 56613888;
}, ha$2.prototype.nextIndex = function(e28) {
  var t3 = this.source, n3 = t3.length;
  if (e28 >= n3)
    return n3;
  var r3 = t3.charCodeAt(e28);
  return !this.switchU || r3 <= 55295 || r3 >= 57344 || e28 + 1 >= n3 ? e28 + 1 : e28 + 2;
}, ha$2.prototype.current = function() {
  return this.at(this.pos);
}, ha$2.prototype.lookahead = function() {
  return this.at(this.nextIndex(this.pos));
}, ha$2.prototype.advance = function() {
  this.pos = this.nextIndex(this.pos);
}, ha$2.prototype.eat = function(e28) {
  return this.current() === e28 && (this.advance(), true);
}, He$1.validateRegExpFlags = function(e28) {
  for (var t3 = e28.validFlags, n3 = e28.flags, r3 = 0; r3 < n3.length; r3++) {
    var i = n3.charAt(r3);
    t3.indexOf(i) === -1 && this.raise(e28.start, "Invalid regular expression flag"), n3.indexOf(i, r3 + 1) > -1 && this.raise(e28.start, "Duplicate regular expression flag");
  }
}, He$1.validateRegExpPattern = function(e28) {
  this.regexp_pattern(e28), !e28.switchN && this.options.ecmaVersion >= 9 && e28.groupNames.length > 0 && (e28.switchN = true, this.regexp_pattern(e28));
}, He$1.regexp_pattern = function(e28) {
  e28.pos = 0, e28.lastIntValue = 0, e28.lastStringValue = "", e28.lastAssertionIsQuantifiable = false, e28.numCapturingParens = 0, e28.maxBackReference = 0, e28.groupNames.length = 0, e28.backReferenceNames.length = 0, this.regexp_disjunction(e28), e28.pos !== e28.source.length && (e28.eat(41) && e28.raise("Unmatched ')'"), (e28.eat(93) || e28.eat(125)) && e28.raise("Lone quantifier brackets")), e28.maxBackReference > e28.numCapturingParens && e28.raise("Invalid escape");
  for (var t3 = 0, n3 = e28.backReferenceNames; t3 < n3.length; t3 += 1) {
    var r3 = n3[t3];
    e28.groupNames.indexOf(r3) === -1 && e28.raise("Invalid named capture referenced");
  }
}, He$1.regexp_disjunction = function(e28) {
  for (this.regexp_alternative(e28); e28.eat(124); )
    this.regexp_alternative(e28);
  this.regexp_eatQuantifier(e28, true) && e28.raise("Nothing to repeat"), e28.eat(123) && e28.raise("Lone quantifier brackets");
}, He$1.regexp_alternative = function(e28) {
  for (; e28.pos < e28.source.length && this.regexp_eatTerm(e28); )
    ;
}, He$1.regexp_eatTerm = function(e28) {
  return this.regexp_eatAssertion(e28) ? (e28.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(e28) && e28.switchU && e28.raise("Invalid quantifier"), true) : !(e28.switchU ? !this.regexp_eatAtom(e28) : !this.regexp_eatExtendedAtom(e28)) && (this.regexp_eatQuantifier(e28), true);
}, He$1.regexp_eatAssertion = function(e28) {
  var t3 = e28.pos;
  if (e28.lastAssertionIsQuantifiable = false, e28.eat(94) || e28.eat(36))
    return true;
  if (e28.eat(92)) {
    if (e28.eat(66) || e28.eat(98))
      return true;
    e28.pos = t3;
  }
  if (e28.eat(40) && e28.eat(63)) {
    var n3 = false;
    if (this.options.ecmaVersion >= 9 && (n3 = e28.eat(60)), e28.eat(61) || e28.eat(33))
      return this.regexp_disjunction(e28), e28.eat(41) || e28.raise("Unterminated group"), e28.lastAssertionIsQuantifiable = !n3, true;
  }
  return e28.pos = t3, false;
}, He$1.regexp_eatQuantifier = function(e28, t3) {
  return t3 === void 0 && (t3 = false), !!this.regexp_eatQuantifierPrefix(e28, t3) && (e28.eat(63), true);
}, He$1.regexp_eatQuantifierPrefix = function(e28, t3) {
  return e28.eat(42) || e28.eat(43) || e28.eat(63) || this.regexp_eatBracedQuantifier(e28, t3);
}, He$1.regexp_eatBracedQuantifier = function(e28, t3) {
  var n3 = e28.pos;
  if (e28.eat(123)) {
    var r3 = 0, i = -1;
    if (this.regexp_eatDecimalDigits(e28) && (r3 = e28.lastIntValue, e28.eat(44) && this.regexp_eatDecimalDigits(e28) && (i = e28.lastIntValue), e28.eat(125)))
      return i !== -1 && i < r3 && !t3 && e28.raise("numbers out of order in {} quantifier"), true;
    e28.switchU && !t3 && e28.raise("Incomplete quantifier"), e28.pos = n3;
  }
  return false;
}, He$1.regexp_eatAtom = function(e28) {
  return this.regexp_eatPatternCharacters(e28) || e28.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e28) || this.regexp_eatCharacterClass(e28) || this.regexp_eatUncapturingGroup(e28) || this.regexp_eatCapturingGroup(e28);
}, He$1.regexp_eatReverseSolidusAtomEscape = function(e28) {
  var t3 = e28.pos;
  if (e28.eat(92)) {
    if (this.regexp_eatAtomEscape(e28))
      return true;
    e28.pos = t3;
  }
  return false;
}, He$1.regexp_eatUncapturingGroup = function(e28) {
  var t3 = e28.pos;
  if (e28.eat(40)) {
    if (e28.eat(63) && e28.eat(58)) {
      if (this.regexp_disjunction(e28), e28.eat(41))
        return true;
      e28.raise("Unterminated group");
    }
    e28.pos = t3;
  }
  return false;
}, He$1.regexp_eatCapturingGroup = function(e28) {
  if (e28.eat(40)) {
    if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(e28) : e28.current() === 63 && e28.raise("Invalid group"), this.regexp_disjunction(e28), e28.eat(41))
      return e28.numCapturingParens += 1, true;
    e28.raise("Unterminated group");
  }
  return false;
}, He$1.regexp_eatExtendedAtom = function(e28) {
  return e28.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e28) || this.regexp_eatCharacterClass(e28) || this.regexp_eatUncapturingGroup(e28) || this.regexp_eatCapturingGroup(e28) || this.regexp_eatInvalidBracedQuantifier(e28) || this.regexp_eatExtendedPatternCharacter(e28);
}, He$1.regexp_eatInvalidBracedQuantifier = function(e28) {
  return this.regexp_eatBracedQuantifier(e28, true) && e28.raise("Nothing to repeat"), false;
}, He$1.regexp_eatSyntaxCharacter = function(e28) {
  var t3 = e28.current();
  return !!yx(t3) && (e28.lastIntValue = t3, e28.advance(), true);
}, He$1.regexp_eatPatternCharacters = function(e28) {
  for (var t3 = e28.pos, n3 = 0; (n3 = e28.current()) !== -1 && !yx(n3); )
    e28.advance();
  return e28.pos !== t3;
}, He$1.regexp_eatExtendedPatternCharacter = function(e28) {
  var t3 = e28.current();
  return !(t3 === -1 || t3 === 36 || t3 >= 40 && t3 <= 43 || t3 === 46 || t3 === 63 || t3 === 91 || t3 === 94 || t3 === 124) && (e28.advance(), true);
}, He$1.regexp_groupSpecifier = function(e28) {
  if (e28.eat(63)) {
    if (this.regexp_eatGroupName(e28))
      return e28.groupNames.indexOf(e28.lastStringValue) !== -1 && e28.raise("Duplicate capture group name"), void e28.groupNames.push(e28.lastStringValue);
    e28.raise("Invalid group");
  }
}, He$1.regexp_eatGroupName = function(e28) {
  if (e28.lastStringValue = "", e28.eat(60)) {
    if (this.regexp_eatRegExpIdentifierName(e28) && e28.eat(62))
      return true;
    e28.raise("Invalid capture group name");
  }
  return false;
}, He$1.regexp_eatRegExpIdentifierName = function(e28) {
  if (e28.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(e28)) {
    for (e28.lastStringValue += Ll(e28.lastIntValue); this.regexp_eatRegExpIdentifierPart(e28); )
      e28.lastStringValue += Ll(e28.lastIntValue);
    return true;
  }
  return false;
}, He$1.regexp_eatRegExpIdentifierStart = function(e28) {
  var t3 = e28.pos, n3 = e28.current();
  return e28.advance(), n3 === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e28) && (n3 = e28.lastIntValue), function(r3) {
    return Ea$2(r3, true) || r3 === 36 || r3 === 95;
  }(n3) ? (e28.lastIntValue = n3, true) : (e28.pos = t3, false);
}, He$1.regexp_eatRegExpIdentifierPart = function(e28) {
  var t3 = e28.pos, n3 = e28.current();
  return e28.advance(), n3 === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e28) && (n3 = e28.lastIntValue), function(r3) {
    return Mo$1(r3, true) || r3 === 36 || r3 === 95 || r3 === 8204 || r3 === 8205;
  }(n3) ? (e28.lastIntValue = n3, true) : (e28.pos = t3, false);
}, He$1.regexp_eatAtomEscape = function(e28) {
  return !!(this.regexp_eatBackReference(e28) || this.regexp_eatCharacterClassEscape(e28) || this.regexp_eatCharacterEscape(e28) || e28.switchN && this.regexp_eatKGroupName(e28)) || (e28.switchU && (e28.current() === 99 && e28.raise("Invalid unicode escape"), e28.raise("Invalid escape")), false);
}, He$1.regexp_eatBackReference = function(e28) {
  var t3 = e28.pos;
  if (this.regexp_eatDecimalEscape(e28)) {
    var n3 = e28.lastIntValue;
    if (e28.switchU)
      return n3 > e28.maxBackReference && (e28.maxBackReference = n3), true;
    if (n3 <= e28.numCapturingParens)
      return true;
    e28.pos = t3;
  }
  return false;
}, He$1.regexp_eatKGroupName = function(e28) {
  if (e28.eat(107)) {
    if (this.regexp_eatGroupName(e28))
      return e28.backReferenceNames.push(e28.lastStringValue), true;
    e28.raise("Invalid named reference");
  }
  return false;
}, He$1.regexp_eatCharacterEscape = function(e28) {
  return this.regexp_eatControlEscape(e28) || this.regexp_eatCControlLetter(e28) || this.regexp_eatZero(e28) || this.regexp_eatHexEscapeSequence(e28) || this.regexp_eatRegExpUnicodeEscapeSequence(e28) || !e28.switchU && this.regexp_eatLegacyOctalEscapeSequence(e28) || this.regexp_eatIdentityEscape(e28);
}, He$1.regexp_eatCControlLetter = function(e28) {
  var t3 = e28.pos;
  if (e28.eat(99)) {
    if (this.regexp_eatControlLetter(e28))
      return true;
    e28.pos = t3;
  }
  return false;
}, He$1.regexp_eatZero = function(e28) {
  return e28.current() === 48 && !sp(e28.lookahead()) && (e28.lastIntValue = 0, e28.advance(), true);
}, He$1.regexp_eatControlEscape = function(e28) {
  var t3 = e28.current();
  return t3 === 116 ? (e28.lastIntValue = 9, e28.advance(), true) : t3 === 110 ? (e28.lastIntValue = 10, e28.advance(), true) : t3 === 118 ? (e28.lastIntValue = 11, e28.advance(), true) : t3 === 102 ? (e28.lastIntValue = 12, e28.advance(), true) : t3 === 114 && (e28.lastIntValue = 13, e28.advance(), true);
}, He$1.regexp_eatControlLetter = function(e28) {
  var t3 = e28.current();
  return !!ik(t3) && (e28.lastIntValue = t3 % 32, e28.advance(), true);
}, He$1.regexp_eatRegExpUnicodeEscapeSequence = function(e28) {
  var t3, n3 = e28.pos;
  if (e28.eat(117)) {
    if (this.regexp_eatFixedHexDigits(e28, 4)) {
      var r3 = e28.lastIntValue;
      if (e28.switchU && r3 >= 55296 && r3 <= 56319) {
        var i = e28.pos;
        if (e28.eat(92) && e28.eat(117) && this.regexp_eatFixedHexDigits(e28, 4)) {
          var a3 = e28.lastIntValue;
          if (a3 >= 56320 && a3 <= 57343)
            return e28.lastIntValue = 1024 * (r3 - 55296) + (a3 - 56320) + 65536, true;
        }
        e28.pos = i, e28.lastIntValue = r3;
      }
      return true;
    }
    if (e28.switchU && e28.eat(123) && this.regexp_eatHexDigits(e28) && e28.eat(125) && (t3 = e28.lastIntValue) >= 0 && t3 <= 1114111)
      return true;
    e28.switchU && e28.raise("Invalid unicode escape"), e28.pos = n3;
  }
  return false;
}, He$1.regexp_eatIdentityEscape = function(e28) {
  if (e28.switchU)
    return !!this.regexp_eatSyntaxCharacter(e28) || !!e28.eat(47) && (e28.lastIntValue = 47, true);
  var t3 = e28.current();
  return !(t3 === 99 || e28.switchN && t3 === 107) && (e28.lastIntValue = t3, e28.advance(), true);
}, He$1.regexp_eatDecimalEscape = function(e28) {
  e28.lastIntValue = 0;
  var t3 = e28.current();
  if (t3 >= 49 && t3 <= 57) {
    do
      e28.lastIntValue = 10 * e28.lastIntValue + (t3 - 48), e28.advance();
    while ((t3 = e28.current()) >= 48 && t3 <= 57);
    return true;
  }
  return false;
}, He$1.regexp_eatCharacterClassEscape = function(e28) {
  var t3 = e28.current();
  if (function(n3) {
    return n3 === 100 || n3 === 68 || n3 === 115 || n3 === 83 || n3 === 119 || n3 === 87;
  }(t3))
    return e28.lastIntValue = -1, e28.advance(), true;
  if (e28.switchU && this.options.ecmaVersion >= 9 && (t3 === 80 || t3 === 112)) {
    if (e28.lastIntValue = -1, e28.advance(), e28.eat(123) && this.regexp_eatUnicodePropertyValueExpression(e28) && e28.eat(125))
      return true;
    e28.raise("Invalid property name");
  }
  return false;
}, He$1.regexp_eatUnicodePropertyValueExpression = function(e28) {
  var t3 = e28.pos;
  if (this.regexp_eatUnicodePropertyName(e28) && e28.eat(61)) {
    var n3 = e28.lastStringValue;
    if (this.regexp_eatUnicodePropertyValue(e28)) {
      var r3 = e28.lastStringValue;
      return this.regexp_validateUnicodePropertyNameAndValue(e28, n3, r3), true;
    }
  }
  if (e28.pos = t3, this.regexp_eatLoneUnicodePropertyNameOrValue(e28)) {
    var i = e28.lastStringValue;
    return this.regexp_validateUnicodePropertyNameOrValue(e28, i), true;
  }
  return false;
}, He$1.regexp_validateUnicodePropertyNameAndValue = function(e28, t3, n3) {
  hf(e28.unicodeProperties.nonBinary, t3) || e28.raise("Invalid property name"), e28.unicodeProperties.nonBinary[t3].test(n3) || e28.raise("Invalid property value");
}, He$1.regexp_validateUnicodePropertyNameOrValue = function(e28, t3) {
  e28.unicodeProperties.binary.test(t3) || e28.raise("Invalid property name");
}, He$1.regexp_eatUnicodePropertyName = function(e28) {
  var t3 = 0;
  for (e28.lastStringValue = ""; ak(t3 = e28.current()); )
    e28.lastStringValue += Ll(t3), e28.advance();
  return e28.lastStringValue !== "";
}, He$1.regexp_eatUnicodePropertyValue = function(e28) {
  var t3 = 0;
  for (e28.lastStringValue = ""; A9(t3 = e28.current()); )
    e28.lastStringValue += Ll(t3), e28.advance();
  return e28.lastStringValue !== "";
}, He$1.regexp_eatLoneUnicodePropertyNameOrValue = function(e28) {
  return this.regexp_eatUnicodePropertyValue(e28);
}, He$1.regexp_eatCharacterClass = function(e28) {
  if (e28.eat(91)) {
    if (e28.eat(94), this.regexp_classRanges(e28), e28.eat(93))
      return true;
    e28.raise("Unterminated character class");
  }
  return false;
}, He$1.regexp_classRanges = function(e28) {
  for (; this.regexp_eatClassAtom(e28); ) {
    var t3 = e28.lastIntValue;
    if (e28.eat(45) && this.regexp_eatClassAtom(e28)) {
      var n3 = e28.lastIntValue;
      !e28.switchU || t3 !== -1 && n3 !== -1 || e28.raise("Invalid character class"), t3 !== -1 && n3 !== -1 && t3 > n3 && e28.raise("Range out of order in character class");
    }
  }
}, He$1.regexp_eatClassAtom = function(e28) {
  var t3 = e28.pos;
  if (e28.eat(92)) {
    if (this.regexp_eatClassEscape(e28))
      return true;
    if (e28.switchU) {
      var n3 = e28.current();
      (n3 === 99 || bx(n3)) && e28.raise("Invalid class escape"), e28.raise("Invalid escape");
    }
    e28.pos = t3;
  }
  var r3 = e28.current();
  return r3 !== 93 && (e28.lastIntValue = r3, e28.advance(), true);
}, He$1.regexp_eatClassEscape = function(e28) {
  var t3 = e28.pos;
  if (e28.eat(98))
    return e28.lastIntValue = 8, true;
  if (e28.switchU && e28.eat(45))
    return e28.lastIntValue = 45, true;
  if (!e28.switchU && e28.eat(99)) {
    if (this.regexp_eatClassControlLetter(e28))
      return true;
    e28.pos = t3;
  }
  return this.regexp_eatCharacterClassEscape(e28) || this.regexp_eatCharacterEscape(e28);
}, He$1.regexp_eatClassControlLetter = function(e28) {
  var t3 = e28.current();
  return !(!sp(t3) && t3 !== 95) && (e28.lastIntValue = t3 % 32, e28.advance(), true);
}, He$1.regexp_eatHexEscapeSequence = function(e28) {
  var t3 = e28.pos;
  if (e28.eat(120)) {
    if (this.regexp_eatFixedHexDigits(e28, 2))
      return true;
    e28.switchU && e28.raise("Invalid escape"), e28.pos = t3;
  }
  return false;
}, He$1.regexp_eatDecimalDigits = function(e28) {
  var t3 = e28.pos, n3 = 0;
  for (e28.lastIntValue = 0; sp(n3 = e28.current()); )
    e28.lastIntValue = 10 * e28.lastIntValue + (n3 - 48), e28.advance();
  return e28.pos !== t3;
}, He$1.regexp_eatHexDigits = function(e28) {
  var t3 = e28.pos, n3 = 0;
  for (e28.lastIntValue = 0; vx(n3 = e28.current()); )
    e28.lastIntValue = 16 * e28.lastIntValue + xx(n3), e28.advance();
  return e28.pos !== t3;
}, He$1.regexp_eatLegacyOctalEscapeSequence = function(e28) {
  if (this.regexp_eatOctalDigit(e28)) {
    var t3 = e28.lastIntValue;
    if (this.regexp_eatOctalDigit(e28)) {
      var n3 = e28.lastIntValue;
      t3 <= 3 && this.regexp_eatOctalDigit(e28) ? e28.lastIntValue = 64 * t3 + 8 * n3 + e28.lastIntValue : e28.lastIntValue = 8 * t3 + n3;
    } else
      e28.lastIntValue = t3;
    return true;
  }
  return false;
}, He$1.regexp_eatOctalDigit = function(e28) {
  var t3 = e28.current();
  return bx(t3) ? (e28.lastIntValue = t3 - 48, e28.advance(), true) : (e28.lastIntValue = 0, false);
}, He$1.regexp_eatFixedHexDigits = function(e28, t3) {
  var n3 = e28.pos;
  e28.lastIntValue = 0;
  for (var r3 = 0; r3 < t3; ++r3) {
    var i = e28.current();
    if (!vx(i))
      return e28.pos = n3, false;
    e28.lastIntValue = 16 * e28.lastIntValue + xx(i), e28.advance();
  }
  return true;
};
var Np = function(e28) {
  this.type = e28.type, this.value = e28.value, this.start = e28.start, this.end = e28.end, e28.options.locations && (this.loc = new Sc$2(e28, e28.startLoc, e28.endLoc)), e28.options.ranges && (this.range = [e28.start, e28.end]);
}, Ft$1 = pn$1.prototype;
function Nm(e28) {
  return e28 <= 65535 ? String.fromCharCode(e28) : (e28 -= 65536, String.fromCharCode(55296 + (e28 >> 10), 56320 + (1023 & e28)));
}
Ft$1.next = function() {
  this.options.onToken && this.options.onToken(new Np(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
}, Ft$1.getToken = function() {
  return this.next(), new Np(this);
}, typeof Symbol < "u" && (Ft$1[Symbol.iterator] = function() {
  var e28 = this;
  return { next: function() {
    var t3 = e28.getToken();
    return { done: t3.type === $$6.eof, value: t3 };
  } };
}), Ft$1.curContext = function() {
  return this.context[this.context.length - 1];
}, Ft$1.nextToken = function() {
  var e28 = this.curContext();
  return e28 && e28.preserveSpace || this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length ? this.finishToken($$6.eof) : e28.override ? e28.override(this) : void this.readToken(this.fullCharCodeAtPos());
}, Ft$1.readToken = function(e28) {
  return Ea$2(e28, this.options.ecmaVersion >= 6) || e28 === 92 ? this.readWord() : this.getTokenFromCode(e28);
}, Ft$1.fullCharCodeAtPos = function() {
  var e28 = this.input.charCodeAt(this.pos);
  return e28 <= 55295 || e28 >= 57344 ? e28 : (e28 << 10) + this.input.charCodeAt(this.pos + 1) - 56613888;
}, Ft$1.skipBlockComment = function() {
  var e28, t3 = this.options.onComment && this.curPosition(), n3 = this.pos, r3 = this.input.indexOf("*/", this.pos += 2);
  if (r3 === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = r3 + 2, this.options.locations)
    for (qs$1.lastIndex = n3; (e28 = qs$1.exec(this.input)) && e28.index < this.pos; )
      ++this.curLine, this.lineStart = e28.index + e28[0].length;
  this.options.onComment && this.options.onComment(true, this.input.slice(n3 + 2, r3), n3, this.pos, t3, this.curPosition());
}, Ft$1.skipLineComment = function(e28) {
  for (var t3 = this.pos, n3 = this.options.onComment && this.curPosition(), r3 = this.input.charCodeAt(this.pos += e28); this.pos < this.input.length && !Ws$1(r3); )
    r3 = this.input.charCodeAt(++this.pos);
  this.options.onComment && this.options.onComment(false, this.input.slice(t3 + e28, this.pos), t3, this.pos, n3, this.curPosition());
}, Ft$1.skipSpace = function() {
  e:
    for (; this.pos < this.input.length; ) {
      var e28 = this.input.charCodeAt(this.pos);
      switch (e28) {
        case 32:
        case 160:
          ++this.pos;
          break;
        case 13:
          this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
        case 10:
        case 8232:
        case 8233:
          ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
          break;
        case 47:
          switch (this.input.charCodeAt(this.pos + 1)) {
            case 42:
              this.skipBlockComment();
              break;
            case 47:
              this.skipLineComment(2);
              break;
            default:
              break e;
          }
          break;
        default:
          if (!(e28 > 8 && e28 < 14 || e28 >= 5760 && q0.test(String.fromCharCode(e28))))
            break e;
          ++this.pos;
      }
    }
}, Ft$1.finishToken = function(e28, t3) {
  this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
  var n3 = this.type;
  this.type = e28, this.value = t3, this.updateContext(n3);
}, Ft$1.readToken_dot = function() {
  var e28 = this.input.charCodeAt(this.pos + 1);
  if (e28 >= 48 && e28 <= 57)
    return this.readNumber(true);
  var t3 = this.input.charCodeAt(this.pos + 2);
  return this.options.ecmaVersion >= 6 && e28 === 46 && t3 === 46 ? (this.pos += 3, this.finishToken($$6.ellipsis)) : (++this.pos, this.finishToken($$6.dot));
}, Ft$1.readToken_slash = function() {
  var e28 = this.input.charCodeAt(this.pos + 1);
  return this.exprAllowed ? (++this.pos, this.readRegexp()) : e28 === 61 ? this.finishOp($$6.assign, 2) : this.finishOp($$6.slash, 1);
}, Ft$1.readToken_mult_modulo_exp = function(e28) {
  var t3 = this.input.charCodeAt(this.pos + 1), n3 = 1, r3 = e28 === 42 ? $$6.star : $$6.modulo;
  return this.options.ecmaVersion >= 7 && e28 === 42 && t3 === 42 && (++n3, r3 = $$6.starstar, t3 = this.input.charCodeAt(this.pos + 2)), t3 === 61 ? this.finishOp($$6.assign, n3 + 1) : this.finishOp(r3, n3);
}, Ft$1.readToken_pipe_amp = function(e28) {
  var t3 = this.input.charCodeAt(this.pos + 1);
  return t3 === e28 ? this.finishOp(e28 === 124 ? $$6.logicalOR : $$6.logicalAND, 2) : t3 === 61 ? this.finishOp($$6.assign, 2) : this.finishOp(e28 === 124 ? $$6.bitwiseOR : $$6.bitwiseAND, 1);
}, Ft$1.readToken_caret = function() {
  return this.input.charCodeAt(this.pos + 1) === 61 ? this.finishOp($$6.assign, 2) : this.finishOp($$6.bitwiseXOR, 1);
}, Ft$1.readToken_plus_min = function(e28) {
  var t3 = this.input.charCodeAt(this.pos + 1);
  return t3 === e28 ? t3 !== 45 || this.inModule || this.input.charCodeAt(this.pos + 2) !== 62 || this.lastTokEnd !== 0 && !ci$1.test(this.input.slice(this.lastTokEnd, this.pos)) ? this.finishOp($$6.incDec, 2) : (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : t3 === 61 ? this.finishOp($$6.assign, 2) : this.finishOp($$6.plusMin, 1);
}, Ft$1.readToken_lt_gt = function(e28) {
  var t3 = this.input.charCodeAt(this.pos + 1), n3 = 1;
  return t3 === e28 ? (n3 = e28 === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + n3) === 61 ? this.finishOp($$6.assign, n3 + 1) : this.finishOp($$6.bitShift, n3)) : t3 !== 33 || e28 !== 60 || this.inModule || this.input.charCodeAt(this.pos + 2) !== 45 || this.input.charCodeAt(this.pos + 3) !== 45 ? (t3 === 61 && (n3 = 2), this.finishOp($$6.relational, n3)) : (this.skipLineComment(4), this.skipSpace(), this.nextToken());
}, Ft$1.readToken_eq_excl = function(e28) {
  var t3 = this.input.charCodeAt(this.pos + 1);
  return t3 === 61 ? this.finishOp($$6.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : e28 === 61 && t3 === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken($$6.arrow)) : this.finishOp(e28 === 61 ? $$6.eq : $$6.prefix, 1);
}, Ft$1.getTokenFromCode = function(e28) {
  switch (e28) {
    case 46:
      return this.readToken_dot();
    case 40:
      return ++this.pos, this.finishToken($$6.parenL);
    case 41:
      return ++this.pos, this.finishToken($$6.parenR);
    case 59:
      return ++this.pos, this.finishToken($$6.semi);
    case 44:
      return ++this.pos, this.finishToken($$6.comma);
    case 91:
      return ++this.pos, this.finishToken($$6.bracketL);
    case 93:
      return ++this.pos, this.finishToken($$6.bracketR);
    case 123:
      return ++this.pos, this.finishToken($$6.braceL);
    case 125:
      return ++this.pos, this.finishToken($$6.braceR);
    case 58:
      return ++this.pos, this.finishToken($$6.colon);
    case 63:
      return ++this.pos, this.finishToken($$6.question);
    case 96:
      if (this.options.ecmaVersion < 6)
        break;
      return ++this.pos, this.finishToken($$6.backQuote);
    case 48:
      var t3 = this.input.charCodeAt(this.pos + 1);
      if (t3 === 120 || t3 === 88)
        return this.readRadixNumber(16);
      if (this.options.ecmaVersion >= 6) {
        if (t3 === 111 || t3 === 79)
          return this.readRadixNumber(8);
        if (t3 === 98 || t3 === 66)
          return this.readRadixNumber(2);
      }
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return this.readNumber(false);
    case 34:
    case 39:
      return this.readString(e28);
    case 47:
      return this.readToken_slash();
    case 37:
    case 42:
      return this.readToken_mult_modulo_exp(e28);
    case 124:
    case 38:
      return this.readToken_pipe_amp(e28);
    case 94:
      return this.readToken_caret();
    case 43:
    case 45:
      return this.readToken_plus_min(e28);
    case 60:
    case 62:
      return this.readToken_lt_gt(e28);
    case 61:
    case 33:
      return this.readToken_eq_excl(e28);
    case 126:
      return this.finishOp($$6.prefix, 1);
  }
  this.raise(this.pos, "Unexpected character '" + Nm(e28) + "'");
}, Ft$1.finishOp = function(e28, t3) {
  var n3 = this.input.slice(this.pos, this.pos + t3);
  return this.pos += t3, this.finishToken(e28, n3);
}, Ft$1.readRegexp = function() {
  for (var e28, t3, n3 = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(n3, "Unterminated regular expression");
    var r3 = this.input.charAt(this.pos);
    if (ci$1.test(r3) && this.raise(n3, "Unterminated regular expression"), e28)
      e28 = false;
    else {
      if (r3 === "[")
        t3 = true;
      else if (r3 === "]" && t3)
        t3 = false;
      else if (r3 === "/" && !t3)
        break;
      e28 = r3 === "\\";
    }
    ++this.pos;
  }
  var i = this.input.slice(n3, this.pos);
  ++this.pos;
  var a3 = this.pos, s3 = this.readWord1();
  this.containsEsc && this.unexpected(a3);
  var o3 = this.regexpState || (this.regexpState = new ha$2(this));
  o3.reset(n3, i, s3), this.validateRegExpFlags(o3), this.validateRegExpPattern(o3);
  var u3 = null;
  try {
    u3 = new RegExp(i, s3);
  } catch {
  }
  return this.finishToken($$6.regexp, { pattern: i, flags: s3, value: u3 });
}, Ft$1.readInt = function(e28, t3) {
  for (var n3 = this.pos, r3 = 0, i = 0, a3 = t3 != null ? t3 : 1 / 0; i < a3; ++i) {
    var s3 = this.input.charCodeAt(this.pos), o3 = void 0;
    if ((o3 = s3 >= 97 ? s3 - 97 + 10 : s3 >= 65 ? s3 - 65 + 10 : s3 >= 48 && s3 <= 57 ? s3 - 48 : 1 / 0) >= e28)
      break;
    ++this.pos, r3 = r3 * e28 + o3;
  }
  return this.pos === n3 || t3 != null && this.pos - n3 !== t3 ? null : r3;
}, Ft$1.readRadixNumber = function(e28) {
  var t3 = this.pos;
  this.pos += 2;
  var n3 = this.readInt(e28);
  return n3 == null && this.raise(this.start + 2, "Expected number in radix " + e28), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (n3 = typeof BigInt < "u" ? BigInt(this.input.slice(t3, this.pos)) : null, ++this.pos) : Ea$2(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken($$6.num, n3);
}, Ft$1.readNumber = function(e28) {
  var t3 = this.pos;
  e28 || this.readInt(10) !== null || this.raise(t3, "Invalid number");
  var n3 = this.pos - t3 >= 2 && this.input.charCodeAt(t3) === 48;
  n3 && this.strict && this.raise(t3, "Invalid number"), n3 && /[89]/.test(this.input.slice(t3, this.pos)) && (n3 = false);
  var r3 = this.input.charCodeAt(this.pos);
  if (!n3 && !e28 && this.options.ecmaVersion >= 11 && r3 === 110) {
    var i = this.input.slice(t3, this.pos), a3 = typeof BigInt < "u" ? BigInt(i) : null;
    return ++this.pos, Ea$2(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken($$6.num, a3);
  }
  r3 !== 46 || n3 || (++this.pos, this.readInt(10), r3 = this.input.charCodeAt(this.pos)), r3 !== 69 && r3 !== 101 || n3 || ((r3 = this.input.charCodeAt(++this.pos)) !== 43 && r3 !== 45 || ++this.pos, this.readInt(10) === null && this.raise(t3, "Invalid number")), Ea$2(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
  var s3 = this.input.slice(t3, this.pos), o3 = n3 ? parseInt(s3, 8) : parseFloat(s3);
  return this.finishToken($$6.num, o3);
}, Ft$1.readCodePoint = function() {
  var e28;
  if (this.input.charCodeAt(this.pos) === 123) {
    this.options.ecmaVersion < 6 && this.unexpected();
    var t3 = ++this.pos;
    e28 = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, e28 > 1114111 && this.invalidStringToken(t3, "Code point out of bounds");
  } else
    e28 = this.readHexChar(4);
  return e28;
}, Ft$1.readString = function(e28) {
  for (var t3 = "", n3 = ++this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
    var r3 = this.input.charCodeAt(this.pos);
    if (r3 === e28)
      break;
    r3 === 92 ? (t3 += this.input.slice(n3, this.pos), t3 += this.readEscapedChar(false), n3 = this.pos) : (Ws$1(r3, this.options.ecmaVersion >= 10) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
  }
  return t3 += this.input.slice(n3, this.pos++), this.finishToken($$6.string, t3);
};
var Ex = {};
Ft$1.tryReadTemplateToken = function() {
  this.inTemplateElement = true;
  try {
    this.readTmplToken();
  } catch (e28) {
    if (e28 !== Ex)
      throw e28;
    this.readInvalidTemplateToken();
  }
  this.inTemplateElement = false;
}, Ft$1.invalidStringToken = function(e28, t3) {
  if (this.inTemplateElement && this.options.ecmaVersion >= 9)
    throw Ex;
  this.raise(e28, t3);
}, Ft$1.readTmplToken = function() {
  for (var e28 = "", t3 = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
    var n3 = this.input.charCodeAt(this.pos);
    if (n3 === 96 || n3 === 36 && this.input.charCodeAt(this.pos + 1) === 123)
      return this.pos !== this.start || this.type !== $$6.template && this.type !== $$6.invalidTemplate ? (e28 += this.input.slice(t3, this.pos), this.finishToken($$6.template, e28)) : n3 === 36 ? (this.pos += 2, this.finishToken($$6.dollarBraceL)) : (++this.pos, this.finishToken($$6.backQuote));
    if (n3 === 92)
      e28 += this.input.slice(t3, this.pos), e28 += this.readEscapedChar(true), t3 = this.pos;
    else if (Ws$1(n3)) {
      switch (e28 += this.input.slice(t3, this.pos), ++this.pos, n3) {
        case 13:
          this.input.charCodeAt(this.pos) === 10 && ++this.pos;
        case 10:
          e28 += `
`;
          break;
        default:
          e28 += String.fromCharCode(n3);
      }
      this.options.locations && (++this.curLine, this.lineStart = this.pos), t3 = this.pos;
    } else
      ++this.pos;
  }
}, Ft$1.readInvalidTemplateToken = function() {
  for (; this.pos < this.input.length; this.pos++)
    switch (this.input[this.pos]) {
      case "\\":
        ++this.pos;
        break;
      case "$":
        if (this.input[this.pos + 1] !== "{")
          break;
      case "`":
        return this.finishToken($$6.invalidTemplate, this.input.slice(this.start, this.pos));
    }
  this.raise(this.start, "Unterminated template");
}, Ft$1.readEscapedChar = function(e28) {
  var t3 = this.input.charCodeAt(++this.pos);
  switch (++this.pos, t3) {
    case 110:
      return `
`;
    case 114:
      return "\r";
    case 120:
      return String.fromCharCode(this.readHexChar(2));
    case 117:
      return Nm(this.readCodePoint());
    case 116:
      return "	";
    case 98:
      return "\b";
    case 118:
      return "\v";
    case 102:
      return "\f";
    case 13:
      this.input.charCodeAt(this.pos) === 10 && ++this.pos;
    case 10:
      return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
    default:
      if (t3 >= 48 && t3 <= 55) {
        var n3 = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], r3 = parseInt(n3, 8);
        return r3 > 255 && (n3 = n3.slice(0, -1), r3 = parseInt(n3, 8)), this.pos += n3.length - 1, t3 = this.input.charCodeAt(this.pos), n3 === "0" && t3 !== 56 && t3 !== 57 || !this.strict && !e28 || this.invalidStringToken(this.pos - 1 - n3.length, e28 ? "Octal literal in template string" : "Octal literal in strict mode"), String.fromCharCode(r3);
      }
      return Ws$1(t3) ? "" : String.fromCharCode(t3);
  }
}, Ft$1.readHexChar = function(e28) {
  var t3 = this.pos, n3 = this.readInt(16, e28);
  return n3 === null && this.invalidStringToken(t3, "Bad character escape sequence"), n3;
}, Ft$1.readWord1 = function() {
  this.containsEsc = false;
  for (var e28 = "", t3 = true, n3 = this.pos, r3 = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
    var i = this.fullCharCodeAtPos();
    if (Mo$1(i, r3))
      this.pos += i <= 65535 ? 1 : 2;
    else {
      if (i !== 92)
        break;
      this.containsEsc = true, e28 += this.input.slice(n3, this.pos);
      var a3 = this.pos;
      this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
      var s3 = this.readCodePoint();
      (t3 ? Ea$2 : Mo$1)(s3, r3) || this.invalidStringToken(a3, "Invalid Unicode escape"), e28 += Nm(s3), n3 = this.pos;
    }
    t3 = false;
  }
  return e28 + this.input.slice(n3, this.pos);
}, Ft$1.readWord = function() {
  var e28 = this.readWord1(), t3 = $$6.name;
  return this.keywords.test(e28) && (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + e28), t3 = ff[e28]), this.finishToken(t3, e28);
};
pn$1.acorn = { Parser: pn$1, version: "7.1.0", defaultOptions: Op, Position: $s$1, SourceLocation: Sc$2, getLineInfo: W0, Node: Lp, TokenType: Ot$2, tokTypes: $$6, keywordTypes: ff, TokContext: Zr$1, tokContexts: gn$1, isIdentifierChar: Mo$1, isIdentifierStart: Ea$2, Token: Np, isNewLine: Ws$1, lineBreak: ci$1, lineBreakG: qs$1, nonASCIIwhitespace: q0 };
var _9 = Object.freeze({ __proto__: null, Node: Lp, Parser: pn$1, Position: $s$1, SourceLocation: Sc$2, TokContext: Zr$1, Token: Np, TokenType: Ot$2, defaultOptions: Op, getLineInfo: W0, isIdentifierChar: Mo$1, isIdentifierStart: Ea$2, isNewLine: Ws$1, keywordTypes: ff, lineBreak: ci$1, lineBreakG: qs$1, nonASCIIwhitespace: q0, parse: function(e28, t3) {
  return pn$1.parse(e28, t3);
}, parseExpressionAt: function(e28, t3, n3) {
  return pn$1.parseExpressionAt(e28, t3, n3);
}, tokContexts: gn$1, tokTypes: $$6, tokenizer: function(e28, t3) {
  return pn$1.tokenizer(e28, t3);
}, version: "7.1.0" }), T9 = { quot: '"', amp: "&", apos: "'", lt: "<", gt: ">", nbsp: "\xA0", iexcl: "\xA1", cent: "\xA2", pound: "\xA3", curren: "\xA4", yen: "\xA5", brvbar: "\xA6", sect: "\xA7", uml: "\xA8", copy: "\xA9", ordf: "\xAA", laquo: "\xAB", not: "\xAC", shy: "\xAD", reg: "\xAE", macr: "\xAF", deg: "\xB0", plusmn: "\xB1", sup2: "\xB2", sup3: "\xB3", acute: "\xB4", micro: "\xB5", para: "\xB6", middot: "\xB7", cedil: "\xB8", sup1: "\xB9", ordm: "\xBA", raquo: "\xBB", frac14: "\xBC", frac12: "\xBD", frac34: "\xBE", iquest: "\xBF", Agrave: "\xC0", Aacute: "\xC1", Acirc: "\xC2", Atilde: "\xC3", Auml: "\xC4", Aring: "\xC5", AElig: "\xC6", Ccedil: "\xC7", Egrave: "\xC8", Eacute: "\xC9", Ecirc: "\xCA", Euml: "\xCB", Igrave: "\xCC", Iacute: "\xCD", Icirc: "\xCE", Iuml: "\xCF", ETH: "\xD0", Ntilde: "\xD1", Ograve: "\xD2", Oacute: "\xD3", Ocirc: "\xD4", Otilde: "\xD5", Ouml: "\xD6", times: "\xD7", Oslash: "\xD8", Ugrave: "\xD9", Uacute: "\xDA", Ucirc: "\xDB", Uuml: "\xDC", Yacute: "\xDD", THORN: "\xDE", szlig: "\xDF", agrave: "\xE0", aacute: "\xE1", acirc: "\xE2", atilde: "\xE3", auml: "\xE4", aring: "\xE5", aelig: "\xE6", ccedil: "\xE7", egrave: "\xE8", eacute: "\xE9", ecirc: "\xEA", euml: "\xEB", igrave: "\xEC", iacute: "\xED", icirc: "\xEE", iuml: "\xEF", eth: "\xF0", ntilde: "\xF1", ograve: "\xF2", oacute: "\xF3", ocirc: "\xF4", otilde: "\xF5", ouml: "\xF6", divide: "\xF7", oslash: "\xF8", ugrave: "\xF9", uacute: "\xFA", ucirc: "\xFB", uuml: "\xFC", yacute: "\xFD", thorn: "\xFE", yuml: "\xFF", OElig: "\u0152", oelig: "\u0153", Scaron: "\u0160", scaron: "\u0161", Yuml: "\u0178", fnof: "\u0192", circ: "\u02C6", tilde: "\u02DC", Alpha: "\u0391", Beta: "\u0392", Gamma: "\u0393", Delta: "\u0394", Epsilon: "\u0395", Zeta: "\u0396", Eta: "\u0397", Theta: "\u0398", Iota: "\u0399", Kappa: "\u039A", Lambda: "\u039B", Mu: "\u039C", Nu: "\u039D", Xi: "\u039E", Omicron: "\u039F", Pi: "\u03A0", Rho: "\u03A1", Sigma: "\u03A3", Tau: "\u03A4", Upsilon: "\u03A5", Phi: "\u03A6", Chi: "\u03A7", Psi: "\u03A8", Omega: "\u03A9", alpha: "\u03B1", beta: "\u03B2", gamma: "\u03B3", delta: "\u03B4", epsilon: "\u03B5", zeta: "\u03B6", eta: "\u03B7", theta: "\u03B8", iota: "\u03B9", kappa: "\u03BA", lambda: "\u03BB", mu: "\u03BC", nu: "\u03BD", xi: "\u03BE", omicron: "\u03BF", pi: "\u03C0", rho: "\u03C1", sigmaf: "\u03C2", sigma: "\u03C3", tau: "\u03C4", upsilon: "\u03C5", phi: "\u03C6", chi: "\u03C7", psi: "\u03C8", omega: "\u03C9", thetasym: "\u03D1", upsih: "\u03D2", piv: "\u03D6", ensp: "\u2002", emsp: "\u2003", thinsp: "\u2009", zwnj: "\u200C", zwj: "\u200D", lrm: "\u200E", rlm: "\u200F", ndash: "\u2013", mdash: "\u2014", lsquo: "\u2018", rsquo: "\u2019", sbquo: "\u201A", ldquo: "\u201C", rdquo: "\u201D", bdquo: "\u201E", dagger: "\u2020", Dagger: "\u2021", bull: "\u2022", hellip: "\u2026", permil: "\u2030", prime: "\u2032", Prime: "\u2033", lsaquo: "\u2039", rsaquo: "\u203A", oline: "\u203E", frasl: "\u2044", euro: "\u20AC", image: "\u2111", weierp: "\u2118", real: "\u211C", trade: "\u2122", alefsym: "\u2135", larr: "\u2190", uarr: "\u2191", rarr: "\u2192", darr: "\u2193", harr: "\u2194", crarr: "\u21B5", lArr: "\u21D0", uArr: "\u21D1", rArr: "\u21D2", dArr: "\u21D3", hArr: "\u21D4", forall: "\u2200", part: "\u2202", exist: "\u2203", empty: "\u2205", nabla: "\u2207", isin: "\u2208", notin: "\u2209", ni: "\u220B", prod: "\u220F", sum: "\u2211", minus: "\u2212", lowast: "\u2217", radic: "\u221A", prop: "\u221D", infin: "\u221E", ang: "\u2220", and: "\u2227", or: "\u2228", cap: "\u2229", cup: "\u222A", int: "\u222B", there4: "\u2234", sim: "\u223C", cong: "\u2245", asymp: "\u2248", ne: "\u2260", equiv: "\u2261", le: "\u2264", ge: "\u2265", sub: "\u2282", sup: "\u2283", nsub: "\u2284", sube: "\u2286", supe: "\u2287", oplus: "\u2295", otimes: "\u2297", perp: "\u22A5", sdot: "\u22C5", lceil: "\u2308", rceil: "\u2309", lfloor: "\u230A", rfloor: "\u230B", lang: "\u2329", rang: "\u232A", loz: "\u25CA", spades: "\u2660", clubs: "\u2663", hearts: "\u2665", diams: "\u2666" }, Cd$1 = { 3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile", 5: "class enum extends super const export import", 6: "enum", strict: "implements interface let package private protected public static yield", strictBind: "eval arguments" }, Sd = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", P9 = { 5: Sd, "5module": Sd + " export import", 6: Sd + " const class extends export import super" }, I9 = /^in(stanceof)?$/, $0 = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7BF\uA7C2-\uA7C6\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB67\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", ok = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F", B9 = new RegExp("[" + $0 + "]"), O9 = new RegExp("[" + $0 + ok + "]");
$0 = ok = null;
var sk = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 157, 310, 10, 21, 11, 7, 153, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 477, 28, 11, 0, 9, 21, 155, 22, 13, 52, 76, 44, 33, 24, 27, 35, 30, 0, 12, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 0, 33, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 230, 43, 117, 63, 32, 0, 161, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 35, 56, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 270, 921, 103, 110, 18, 195, 2749, 1070, 4050, 582, 8634, 568, 8, 30, 114, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 754, 9486, 286, 50, 2, 18, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 2357, 44, 11, 6, 17, 0, 370, 43, 1301, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42710, 42, 4148, 12, 221, 3, 5761, 15, 7472, 3104, 541], L9 = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 525, 10, 176, 2, 54, 14, 32, 9, 16, 3, 46, 10, 54, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 4, 9, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 232, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 19306, 9, 135, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 19723, 1, 5319, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 262, 6, 10, 9, 419, 13, 1495, 6, 110, 6, 6, 9, 792487, 239];
function jm(e28, t3) {
  for (var n3 = 65536, r3 = 0; r3 < t3.length; r3 += 2) {
    if ((n3 += t3[r3]) > e28)
      return false;
    if ((n3 += t3[r3 + 1]) >= e28)
      return true;
  }
}
function Ca$2(e28, t3) {
  return e28 < 65 ? e28 === 36 : e28 < 91 || (e28 < 97 ? e28 === 95 : e28 < 123 || (e28 <= 65535 ? e28 >= 170 && B9.test(String.fromCharCode(e28)) : t3 !== false && jm(e28, sk)));
}
function Vo$1(e28, t3) {
  return e28 < 48 ? e28 === 36 : e28 < 58 || !(e28 < 65) && (e28 < 91 || (e28 < 97 ? e28 === 95 : e28 < 123 || (e28 <= 65535 ? e28 >= 170 && O9.test(String.fromCharCode(e28)) : t3 !== false && (jm(e28, sk) || jm(e28, L9)))));
}
var Lt$1 = function(e28, t3) {
  t3 === void 0 && (t3 = {}), this.label = e28, this.keyword = t3.keyword, this.beforeExpr = !!t3.beforeExpr, this.startsExpr = !!t3.startsExpr, this.isLoop = !!t3.isLoop, this.isAssign = !!t3.isAssign, this.prefix = !!t3.prefix, this.postfix = !!t3.postfix, this.binop = t3.binop || null, this.updateContext = null;
};
function vi$1(e28, t3) {
  return new Lt$1(e28, { beforeExpr: true, binop: t3 });
}
var Qr$1 = { beforeExpr: true }, Ir$1 = { startsExpr: true }, df = {};
function Dt$2(e28, t3) {
  return t3 === void 0 && (t3 = {}), t3.keyword = e28, df[e28] = new Lt$1(e28, t3);
}
var G$8 = { num: new Lt$1("num", Ir$1), regexp: new Lt$1("regexp", Ir$1), string: new Lt$1("string", Ir$1), name: new Lt$1("name", Ir$1), eof: new Lt$1("eof"), bracketL: new Lt$1("[", { beforeExpr: true, startsExpr: true }), bracketR: new Lt$1("]"), braceL: new Lt$1("{", { beforeExpr: true, startsExpr: true }), braceR: new Lt$1("}"), parenL: new Lt$1("(", { beforeExpr: true, startsExpr: true }), parenR: new Lt$1(")"), comma: new Lt$1(",", Qr$1), semi: new Lt$1(";", Qr$1), colon: new Lt$1(":", Qr$1), dot: new Lt$1("."), question: new Lt$1("?", Qr$1), arrow: new Lt$1("=>", Qr$1), template: new Lt$1("template"), invalidTemplate: new Lt$1("invalidTemplate"), ellipsis: new Lt$1("...", Qr$1), backQuote: new Lt$1("`", Ir$1), dollarBraceL: new Lt$1("${", { beforeExpr: true, startsExpr: true }), eq: new Lt$1("=", { beforeExpr: true, isAssign: true }), assign: new Lt$1("_=", { beforeExpr: true, isAssign: true }), incDec: new Lt$1("++/--", { prefix: true, postfix: true, startsExpr: true }), prefix: new Lt$1("!/~", { beforeExpr: true, prefix: true, startsExpr: true }), logicalOR: vi$1("||", 1), logicalAND: vi$1("&&", 2), bitwiseOR: vi$1("|", 3), bitwiseXOR: vi$1("^", 4), bitwiseAND: vi$1("&", 5), equality: vi$1("==/!=/===/!==", 6), relational: vi$1("</>/<=/>=", 7), bitShift: vi$1("<</>>/>>>", 8), plusMin: new Lt$1("+/-", { beforeExpr: true, binop: 9, prefix: true, startsExpr: true }), modulo: vi$1("%", 10), star: vi$1("*", 10), slash: vi$1("/", 10), starstar: new Lt$1("**", { beforeExpr: true }), _break: Dt$2("break"), _case: Dt$2("case", Qr$1), _catch: Dt$2("catch"), _continue: Dt$2("continue"), _debugger: Dt$2("debugger"), _default: Dt$2("default", Qr$1), _do: Dt$2("do", { isLoop: true, beforeExpr: true }), _else: Dt$2("else", Qr$1), _finally: Dt$2("finally"), _for: Dt$2("for", { isLoop: true }), _function: Dt$2("function", Ir$1), _if: Dt$2("if"), _return: Dt$2("return", Qr$1), _switch: Dt$2("switch"), _throw: Dt$2("throw", Qr$1), _try: Dt$2("try"), _var: Dt$2("var"), _const: Dt$2("const"), _while: Dt$2("while", { isLoop: true }), _with: Dt$2("with"), _new: Dt$2("new", { beforeExpr: true, startsExpr: true }), _this: Dt$2("this", Ir$1), _super: Dt$2("super", Ir$1), _class: Dt$2("class", Ir$1), _extends: Dt$2("extends", Qr$1), _export: Dt$2("export"), _import: Dt$2("import", Ir$1), _null: Dt$2("null", Ir$1), _true: Dt$2("true", Ir$1), _false: Dt$2("false", Ir$1), _in: Dt$2("in", { beforeExpr: true, binop: 7 }), _instanceof: Dt$2("instanceof", { beforeExpr: true, binop: 7 }), _typeof: Dt$2("typeof", { beforeExpr: true, prefix: true, startsExpr: true }), _void: Dt$2("void", { beforeExpr: true, prefix: true, startsExpr: true }), _delete: Dt$2("delete", { beforeExpr: true, prefix: true, startsExpr: true }) }, li$1 = /\r\n?|\n|\u2028|\u2029/, Gs$1 = new RegExp(li$1.source, "g");
function zs$1(e28, t3) {
  return e28 === 10 || e28 === 13 || !t3 && (e28 === 8232 || e28 === 8233);
}
var G0 = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Vi$1 = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, uk = Object.prototype, N9 = uk.hasOwnProperty, j9 = uk.toString;
function mf(e28, t3) {
  return N9.call(e28, t3);
}
var Cx = Array.isArray || function(e28) {
  return j9.call(e28) === "[object Array]";
};
function Oo$1(e28) {
  return new RegExp("^(?:" + e28.replace(/ /g, "|") + ")$");
}
var Hs$1 = function(e28, t3) {
  this.line = e28, this.column = t3;
};
Hs$1.prototype.offset = function(e28) {
  return new Hs$1(this.line, this.column + e28);
};
var kc$2 = function(e28, t3, n3) {
  this.start = t3, this.end = n3, e28.sourceFile !== null && (this.source = e28.sourceFile);
};
function z0(e28, t3) {
  for (var n3 = 1, r3 = 0; ; ) {
    Gs$1.lastIndex = r3;
    var i = Gs$1.exec(e28);
    if (!(i && i.index < t3))
      return new Hs$1(n3, t3 - r3);
    ++n3, r3 = i.index + i[0].length;
  }
}
var jp = { ecmaVersion: 9, sourceType: "script", onInsertedSemicolon: null, onTrailingComma: null, allowReserved: null, allowReturnOutsideFunction: false, allowImportExportEverywhere: false, allowAwaitOutsideFunction: false, allowHashBang: false, locations: false, onToken: null, onComment: null, ranges: false, program: null, sourceFile: null, directSourceFile: null, preserveParens: false };
function R9(e28) {
  var t3 = {};
  for (var n3 in jp)
    t3[n3] = e28 && mf(e28, n3) ? e28[n3] : jp[n3];
  if (t3.ecmaVersion >= 2015 && (t3.ecmaVersion -= 2009), t3.allowReserved == null && (t3.allowReserved = t3.ecmaVersion < 5), Cx(t3.onToken)) {
    var r3 = t3.onToken;
    t3.onToken = function(i) {
      return r3.push(i);
    };
  }
  return Cx(t3.onComment) && (t3.onComment = function(i, a3) {
    return function(s3, o3, u3, c3, f3, p3) {
      var d3 = { type: s3 ? "Block" : "Line", value: o3, start: u3, end: c3 };
      i.locations && (d3.loc = new kc$2(this, f3, p3)), i.ranges && (d3.range = [u3, c3]), a3.push(d3);
    };
  }(t3, t3.onComment)), t3;
}
var fc$2 = 2, kd$1 = 1 | fc$2, ck = 4, lk = 8;
function Rm(e28, t3) {
  return fc$2 | (e28 ? ck : 0) | (t3 ? lk : 0);
}
var fn$1 = function(e28, t3, n3) {
  this.options = e28 = R9(e28), this.sourceFile = e28.sourceFile, this.keywords = Oo$1(P9[e28.ecmaVersion >= 6 ? 6 : e28.sourceType === "module" ? "5module" : 5]);
  var r3 = "";
  if (e28.allowReserved !== true) {
    for (var i = e28.ecmaVersion; !(r3 = Cd$1[i]); i--)
      ;
    e28.sourceType === "module" && (r3 += " await");
  }
  this.reservedWords = Oo$1(r3);
  var a3 = (r3 ? r3 + " " : "") + Cd$1.strict;
  this.reservedWordsStrict = Oo$1(a3), this.reservedWordsStrictBind = Oo$1(a3 + " " + Cd$1.strictBind), this.input = String(t3), this.containsEsc = false, n3 ? (this.pos = n3, this.lineStart = this.input.lastIndexOf(`
`, n3 - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(li$1).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = G$8.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = true, this.inModule = e28.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = {}, this.pos === 0 && e28.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(1), this.regexpState = null;
}, Eo$1 = { inFunction: { configurable: true }, inGenerator: { configurable: true }, inAsync: { configurable: true }, allowSuper: { configurable: true }, allowDirectSuper: { configurable: true }, treatFunctionsAsVar: { configurable: true } };
fn$1.prototype.parse = function() {
  var e28 = this.options.program || this.startNode();
  return this.nextToken(), this.parseTopLevel(e28);
}, Eo$1.inFunction.get = function() {
  return (this.currentVarScope().flags & fc$2) > 0;
}, Eo$1.inGenerator.get = function() {
  return (this.currentVarScope().flags & lk) > 0;
}, Eo$1.inAsync.get = function() {
  return (this.currentVarScope().flags & ck) > 0;
}, Eo$1.allowSuper.get = function() {
  return (64 & this.currentThisScope().flags) > 0;
}, Eo$1.allowDirectSuper.get = function() {
  return (128 & this.currentThisScope().flags) > 0;
}, Eo$1.treatFunctionsAsVar.get = function() {
  return this.treatFunctionsAsVarInScope(this.currentScope());
}, fn$1.prototype.inNonArrowFunction = function() {
  return (this.currentThisScope().flags & fc$2) > 0;
}, fn$1.extend = function() {
  for (var e28 = [], t3 = arguments.length; t3--; )
    e28[t3] = arguments[t3];
  for (var n3 = this, r3 = 0; r3 < e28.length; r3++)
    n3 = e28[r3](n3);
  return n3;
}, fn$1.parse = function(e28, t3) {
  return new this(t3, e28).parse();
}, fn$1.parseExpressionAt = function(e28, t3, n3) {
  var r3 = new this(n3, e28, t3);
  return r3.nextToken(), r3.parseExpression();
}, fn$1.tokenizer = function(e28, t3) {
  return new this(t3, e28);
}, Object.defineProperties(fn$1.prototype, Eo$1);
var or$1 = fn$1.prototype, M9 = /^(?:'((?:\\.|[^'])*?)'|"((?:\\.|[^"])*?)")/;
function qu$1() {
  this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
}
or$1.strictDirective = function(e28) {
  for (; ; ) {
    Vi$1.lastIndex = e28, e28 += Vi$1.exec(this.input)[0].length;
    var t3 = M9.exec(this.input.slice(e28));
    if (!t3)
      return false;
    if ((t3[1] || t3[2]) === "use strict")
      return true;
    e28 += t3[0].length, Vi$1.lastIndex = e28, e28 += Vi$1.exec(this.input)[0].length, this.input[e28] === ";" && e28++;
  }
}, or$1.eat = function(e28) {
  return this.type === e28 && (this.next(), true);
}, or$1.isContextual = function(e28) {
  return this.type === G$8.name && this.value === e28 && !this.containsEsc;
}, or$1.eatContextual = function(e28) {
  return !!this.isContextual(e28) && (this.next(), true);
}, or$1.expectContextual = function(e28) {
  this.eatContextual(e28) || this.unexpected();
}, or$1.canInsertSemicolon = function() {
  return this.type === G$8.eof || this.type === G$8.braceR || li$1.test(this.input.slice(this.lastTokEnd, this.start));
}, or$1.insertSemicolon = function() {
  if (this.canInsertSemicolon())
    return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), true;
}, or$1.semicolon = function() {
  this.eat(G$8.semi) || this.insertSemicolon() || this.unexpected();
}, or$1.afterTrailingComma = function(e28, t3) {
  if (this.type === e28)
    return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), t3 || this.next(), true;
}, or$1.expect = function(e28) {
  this.eat(e28) || this.unexpected();
}, or$1.unexpected = function(e28) {
  this.raise(e28 != null ? e28 : this.start, "Unexpected token");
}, or$1.checkPatternErrors = function(e28, t3) {
  if (e28) {
    e28.trailingComma > -1 && this.raiseRecoverable(e28.trailingComma, "Comma is not permitted after the rest element");
    var n3 = t3 ? e28.parenthesizedAssign : e28.parenthesizedBind;
    n3 > -1 && this.raiseRecoverable(n3, "Parenthesized pattern");
  }
}, or$1.checkExpressionErrors = function(e28, t3) {
  if (!e28)
    return false;
  var n3 = e28.shorthandAssign, r3 = e28.doubleProto;
  if (!t3)
    return n3 >= 0 || r3 >= 0;
  n3 >= 0 && this.raise(n3, "Shorthand property assignments are valid only in destructuring patterns"), r3 >= 0 && this.raiseRecoverable(r3, "Redefinition of __proto__ property");
}, or$1.checkYieldAwaitInDefaultParams = function() {
  this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
}, or$1.isSimpleAssignTarget = function(e28) {
  return e28.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(e28.expression) : e28.type === "Identifier" || e28.type === "MemberExpression";
};
var lt$3 = fn$1.prototype;
lt$3.parseTopLevel = function(e28) {
  var t3 = {};
  for (e28.body || (e28.body = []); this.type !== G$8.eof; ) {
    var n3 = this.parseStatement(null, true, t3);
    e28.body.push(n3);
  }
  if (this.inModule)
    for (var r3 = 0, i = Object.keys(this.undefinedExports); r3 < i.length; r3 += 1) {
      var a3 = i[r3];
      this.raiseRecoverable(this.undefinedExports[a3].start, "Export '" + a3 + "' is not defined");
    }
  return this.adaptDirectivePrologue(e28.body), this.next(), e28.sourceType = this.options.sourceType, this.finishNode(e28, "Program");
};
var Mm = { kind: "loop" }, V9 = { kind: "switch" };
lt$3.isLet = function(e28) {
  if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
    return false;
  Vi$1.lastIndex = this.pos;
  var t3 = Vi$1.exec(this.input), n3 = this.pos + t3[0].length, r3 = this.input.charCodeAt(n3);
  if (r3 === 91)
    return true;
  if (e28)
    return false;
  if (r3 === 123)
    return true;
  if (Ca$2(r3, true)) {
    for (var i = n3 + 1; Vo$1(this.input.charCodeAt(i), true); )
      ++i;
    var a3 = this.input.slice(n3, i);
    if (!I9.test(a3))
      return true;
  }
  return false;
}, lt$3.isAsyncFunction = function() {
  if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
    return false;
  Vi$1.lastIndex = this.pos;
  var e28 = Vi$1.exec(this.input), t3 = this.pos + e28[0].length;
  return !(li$1.test(this.input.slice(this.pos, t3)) || this.input.slice(t3, t3 + 8) !== "function" || t3 + 8 !== this.input.length && Vo$1(this.input.charAt(t3 + 8)));
}, lt$3.parseStatement = function(e28, t3, n3) {
  var r3, i = this.type, a3 = this.startNode();
  switch (this.isLet(e28) && (i = G$8._var, r3 = "let"), i) {
    case G$8._break:
    case G$8._continue:
      return this.parseBreakContinueStatement(a3, i.keyword);
    case G$8._debugger:
      return this.parseDebuggerStatement(a3);
    case G$8._do:
      return this.parseDoStatement(a3);
    case G$8._for:
      return this.parseForStatement(a3);
    case G$8._function:
      return e28 && (this.strict || e28 !== "if" && e28 !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(a3, false, !e28);
    case G$8._class:
      return e28 && this.unexpected(), this.parseClass(a3, true);
    case G$8._if:
      return this.parseIfStatement(a3);
    case G$8._return:
      return this.parseReturnStatement(a3);
    case G$8._switch:
      return this.parseSwitchStatement(a3);
    case G$8._throw:
      return this.parseThrowStatement(a3);
    case G$8._try:
      return this.parseTryStatement(a3);
    case G$8._const:
    case G$8._var:
      return r3 = r3 || this.value, e28 && r3 !== "var" && this.unexpected(), this.parseVarStatement(a3, r3);
    case G$8._while:
      return this.parseWhileStatement(a3);
    case G$8._with:
      return this.parseWithStatement(a3);
    case G$8.braceL:
      return this.parseBlock(true, a3);
    case G$8.semi:
      return this.parseEmptyStatement(a3);
    case G$8._export:
    case G$8._import:
      if (this.options.ecmaVersion > 10 && i === G$8._import) {
        Vi$1.lastIndex = this.pos;
        var s3 = Vi$1.exec(this.input), o3 = this.pos + s3[0].length;
        if (this.input.charCodeAt(o3) === 40)
          return this.parseExpressionStatement(a3, this.parseExpression());
      }
      return this.options.allowImportExportEverywhere || (t3 || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), i === G$8._import ? this.parseImport(a3) : this.parseExport(a3, n3);
    default:
      if (this.isAsyncFunction())
        return e28 && this.unexpected(), this.next(), this.parseFunctionStatement(a3, true, !e28);
      var u3 = this.value, c3 = this.parseExpression();
      return i === G$8.name && c3.type === "Identifier" && this.eat(G$8.colon) ? this.parseLabeledStatement(a3, u3, c3, e28) : this.parseExpressionStatement(a3, c3);
  }
}, lt$3.parseBreakContinueStatement = function(e28, t3) {
  var n3 = t3 === "break";
  this.next(), this.eat(G$8.semi) || this.insertSemicolon() ? e28.label = null : this.type !== G$8.name ? this.unexpected() : (e28.label = this.parseIdent(), this.semicolon());
  for (var r3 = 0; r3 < this.labels.length; ++r3) {
    var i = this.labels[r3];
    if ((e28.label == null || i.name === e28.label.name) && (i.kind != null && (n3 || i.kind === "loop") || e28.label && n3))
      break;
  }
  return r3 === this.labels.length && this.raise(e28.start, "Unsyntactic " + t3), this.finishNode(e28, n3 ? "BreakStatement" : "ContinueStatement");
}, lt$3.parseDebuggerStatement = function(e28) {
  return this.next(), this.semicolon(), this.finishNode(e28, "DebuggerStatement");
}, lt$3.parseDoStatement = function(e28) {
  return this.next(), this.labels.push(Mm), e28.body = this.parseStatement("do"), this.labels.pop(), this.expect(G$8._while), e28.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(G$8.semi) : this.semicolon(), this.finishNode(e28, "DoWhileStatement");
}, lt$3.parseForStatement = function(e28) {
  this.next();
  var t3 = this.options.ecmaVersion >= 9 && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction) && this.eatContextual("await") ? this.lastTokStart : -1;
  if (this.labels.push(Mm), this.enterScope(0), this.expect(G$8.parenL), this.type === G$8.semi)
    return t3 > -1 && this.unexpected(t3), this.parseFor(e28, null);
  var n3 = this.isLet();
  if (this.type === G$8._var || this.type === G$8._const || n3) {
    var r3 = this.startNode(), i = n3 ? "let" : this.value;
    return this.next(), this.parseVar(r3, true, i), this.finishNode(r3, "VariableDeclaration"), (this.type === G$8._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && r3.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === G$8._in ? t3 > -1 && this.unexpected(t3) : e28.await = t3 > -1), this.parseForIn(e28, r3)) : (t3 > -1 && this.unexpected(t3), this.parseFor(e28, r3));
  }
  var a3 = new qu$1(), s3 = this.parseExpression(true, a3);
  return this.type === G$8._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? (this.options.ecmaVersion >= 9 && (this.type === G$8._in ? t3 > -1 && this.unexpected(t3) : e28.await = t3 > -1), this.toAssignable(s3, false, a3), this.checkLVal(s3), this.parseForIn(e28, s3)) : (this.checkExpressionErrors(a3, true), t3 > -1 && this.unexpected(t3), this.parseFor(e28, s3));
}, lt$3.parseFunctionStatement = function(e28, t3, n3) {
  return this.next(), this.parseFunction(e28, Wu$1 | (n3 ? 0 : Vm), false, t3);
}, lt$3.parseIfStatement = function(e28) {
  return this.next(), e28.test = this.parseParenExpression(), e28.consequent = this.parseStatement("if"), e28.alternate = this.eat(G$8._else) ? this.parseStatement("if") : null, this.finishNode(e28, "IfStatement");
}, lt$3.parseReturnStatement = function(e28) {
  return this.inFunction || this.options.allowReturnOutsideFunction || this.raise(this.start, "'return' outside of function"), this.next(), this.eat(G$8.semi) || this.insertSemicolon() ? e28.argument = null : (e28.argument = this.parseExpression(), this.semicolon()), this.finishNode(e28, "ReturnStatement");
}, lt$3.parseSwitchStatement = function(e28) {
  var t3;
  this.next(), e28.discriminant = this.parseParenExpression(), e28.cases = [], this.expect(G$8.braceL), this.labels.push(V9), this.enterScope(0);
  for (var n3 = false; this.type !== G$8.braceR; )
    if (this.type === G$8._case || this.type === G$8._default) {
      var r3 = this.type === G$8._case;
      t3 && this.finishNode(t3, "SwitchCase"), e28.cases.push(t3 = this.startNode()), t3.consequent = [], this.next(), r3 ? t3.test = this.parseExpression() : (n3 && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), n3 = true, t3.test = null), this.expect(G$8.colon);
    } else
      t3 || this.unexpected(), t3.consequent.push(this.parseStatement(null));
  return this.exitScope(), t3 && this.finishNode(t3, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(e28, "SwitchStatement");
}, lt$3.parseThrowStatement = function(e28) {
  return this.next(), li$1.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), e28.argument = this.parseExpression(), this.semicolon(), this.finishNode(e28, "ThrowStatement");
};
var U9 = [];
lt$3.parseTryStatement = function(e28) {
  if (this.next(), e28.block = this.parseBlock(), e28.handler = null, this.type === G$8._catch) {
    var t3 = this.startNode();
    if (this.next(), this.eat(G$8.parenL)) {
      t3.param = this.parseBindingAtom();
      var n3 = t3.param.type === "Identifier";
      this.enterScope(n3 ? 32 : 0), this.checkLVal(t3.param, n3 ? 4 : 2), this.expect(G$8.parenR);
    } else
      this.options.ecmaVersion < 10 && this.unexpected(), t3.param = null, this.enterScope(0);
    t3.body = this.parseBlock(false), this.exitScope(), e28.handler = this.finishNode(t3, "CatchClause");
  }
  return e28.finalizer = this.eat(G$8._finally) ? this.parseBlock() : null, e28.handler || e28.finalizer || this.raise(e28.start, "Missing catch or finally clause"), this.finishNode(e28, "TryStatement");
}, lt$3.parseVarStatement = function(e28, t3) {
  return this.next(), this.parseVar(e28, false, t3), this.semicolon(), this.finishNode(e28, "VariableDeclaration");
}, lt$3.parseWhileStatement = function(e28) {
  return this.next(), e28.test = this.parseParenExpression(), this.labels.push(Mm), e28.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(e28, "WhileStatement");
}, lt$3.parseWithStatement = function(e28) {
  return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), e28.object = this.parseParenExpression(), e28.body = this.parseStatement("with"), this.finishNode(e28, "WithStatement");
}, lt$3.parseEmptyStatement = function(e28) {
  return this.next(), this.finishNode(e28, "EmptyStatement");
}, lt$3.parseLabeledStatement = function(e28, t3, n3, r3) {
  for (var i = 0, a3 = this.labels; i < a3.length; i += 1)
    a3[i].name === t3 && this.raise(n3.start, "Label '" + t3 + "' is already declared");
  for (var s3 = this.type.isLoop ? "loop" : this.type === G$8._switch ? "switch" : null, o3 = this.labels.length - 1; o3 >= 0; o3--) {
    var u3 = this.labels[o3];
    if (u3.statementStart !== e28.start)
      break;
    u3.statementStart = this.start, u3.kind = s3;
  }
  return this.labels.push({ name: t3, kind: s3, statementStart: this.start }), e28.body = this.parseStatement(r3 ? r3.indexOf("label") === -1 ? r3 + "label" : r3 : "label"), this.labels.pop(), e28.label = n3, this.finishNode(e28, "LabeledStatement");
}, lt$3.parseExpressionStatement = function(e28, t3) {
  return e28.expression = t3, this.semicolon(), this.finishNode(e28, "ExpressionStatement");
}, lt$3.parseBlock = function(e28, t3) {
  for (e28 === void 0 && (e28 = true), t3 === void 0 && (t3 = this.startNode()), t3.body = [], this.expect(G$8.braceL), e28 && this.enterScope(0); !this.eat(G$8.braceR); ) {
    var n3 = this.parseStatement(null);
    t3.body.push(n3);
  }
  return e28 && this.exitScope(), this.finishNode(t3, "BlockStatement");
}, lt$3.parseFor = function(e28, t3) {
  return e28.init = t3, this.expect(G$8.semi), e28.test = this.type === G$8.semi ? null : this.parseExpression(), this.expect(G$8.semi), e28.update = this.type === G$8.parenR ? null : this.parseExpression(), this.expect(G$8.parenR), e28.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e28, "ForStatement");
}, lt$3.parseForIn = function(e28, t3) {
  var n3 = this.type === G$8._in;
  return this.next(), t3.type === "VariableDeclaration" && t3.declarations[0].init != null && (!n3 || this.options.ecmaVersion < 8 || this.strict || t3.kind !== "var" || t3.declarations[0].id.type !== "Identifier") ? this.raise(t3.start, (n3 ? "for-in" : "for-of") + " loop variable declaration may not have an initializer") : t3.type === "AssignmentPattern" && this.raise(t3.start, "Invalid left-hand side in for-loop"), e28.left = t3, e28.right = n3 ? this.parseExpression() : this.parseMaybeAssign(), this.expect(G$8.parenR), e28.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e28, n3 ? "ForInStatement" : "ForOfStatement");
}, lt$3.parseVar = function(e28, t3, n3) {
  for (e28.declarations = [], e28.kind = n3; ; ) {
    var r3 = this.startNode();
    if (this.parseVarId(r3, n3), this.eat(G$8.eq) ? r3.init = this.parseMaybeAssign(t3) : n3 !== "const" || this.type === G$8._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? r3.id.type === "Identifier" || t3 && (this.type === G$8._in || this.isContextual("of")) ? r3.init = null : this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : this.unexpected(), e28.declarations.push(this.finishNode(r3, "VariableDeclarator")), !this.eat(G$8.comma))
      break;
  }
  return e28;
}, lt$3.parseVarId = function(e28, t3) {
  e28.id = this.parseBindingAtom(), this.checkLVal(e28.id, t3 === "var" ? 1 : 2, false);
};
var Wu$1 = 1, Vm = 2;
lt$3.parseFunction = function(e28, t3, n3, r3) {
  this.initFunction(e28), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !r3) && (this.type === G$8.star && t3 & Vm && this.unexpected(), e28.generator = this.eat(G$8.star)), this.options.ecmaVersion >= 8 && (e28.async = !!r3), t3 & Wu$1 && (e28.id = 4 & t3 && this.type !== G$8.name ? null : this.parseIdent(), !e28.id || t3 & Vm || this.checkLVal(e28.id, this.strict || e28.generator || e28.async ? this.treatFunctionsAsVar ? 1 : 2 : 3));
  var i = this.yieldPos, a3 = this.awaitPos, s3 = this.awaitIdentPos;
  return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(Rm(e28.async, e28.generator)), t3 & Wu$1 || (e28.id = this.type === G$8.name ? this.parseIdent() : null), this.parseFunctionParams(e28), this.parseFunctionBody(e28, n3, false), this.yieldPos = i, this.awaitPos = a3, this.awaitIdentPos = s3, this.finishNode(e28, t3 & Wu$1 ? "FunctionDeclaration" : "FunctionExpression");
}, lt$3.parseFunctionParams = function(e28) {
  this.expect(G$8.parenL), e28.params = this.parseBindingList(G$8.parenR, false, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
}, lt$3.parseClass = function(e28, t3) {
  this.next();
  var n3 = this.strict;
  this.strict = true, this.parseClassId(e28, t3), this.parseClassSuper(e28);
  var r3 = this.startNode(), i = false;
  for (r3.body = [], this.expect(G$8.braceL); !this.eat(G$8.braceR); ) {
    var a3 = this.parseClassElement(e28.superClass !== null);
    a3 && (r3.body.push(a3), a3.type === "MethodDefinition" && a3.kind === "constructor" && (i && this.raise(a3.start, "Duplicate constructor in the same class"), i = true));
  }
  return e28.body = this.finishNode(r3, "ClassBody"), this.strict = n3, this.finishNode(e28, t3 ? "ClassDeclaration" : "ClassExpression");
}, lt$3.parseClassElement = function(e28) {
  var t3 = this;
  if (this.eat(G$8.semi))
    return null;
  var n3 = this.startNode(), r3 = function(u3, c3) {
    c3 === void 0 && (c3 = false);
    var f3 = t3.start, p3 = t3.startLoc;
    return !!t3.eatContextual(u3) && (!(t3.type === G$8.parenL || c3 && t3.canInsertSemicolon()) || (n3.key && t3.unexpected(), n3.computed = false, n3.key = t3.startNodeAt(f3, p3), n3.key.name = u3, t3.finishNode(n3.key, "Identifier"), false));
  };
  n3.kind = "method", n3.static = r3("static");
  var i = this.eat(G$8.star), a3 = false;
  i || (this.options.ecmaVersion >= 8 && r3("async", true) ? (a3 = true, i = this.options.ecmaVersion >= 9 && this.eat(G$8.star)) : r3("get") ? n3.kind = "get" : r3("set") && (n3.kind = "set")), n3.key || this.parsePropertyName(n3);
  var s3 = n3.key, o3 = false;
  return n3.computed || n3.static || !(s3.type === "Identifier" && s3.name === "constructor" || s3.type === "Literal" && s3.value === "constructor") ? n3.static && s3.type === "Identifier" && s3.name === "prototype" && this.raise(s3.start, "Classes may not have a static property named prototype") : (n3.kind !== "method" && this.raise(s3.start, "Constructor can't have get/set modifier"), i && this.raise(s3.start, "Constructor can't be a generator"), a3 && this.raise(s3.start, "Constructor can't be an async method"), n3.kind = "constructor", o3 = e28), this.parseClassMethod(n3, i, a3, o3), n3.kind === "get" && n3.value.params.length !== 0 && this.raiseRecoverable(n3.value.start, "getter should have no params"), n3.kind === "set" && n3.value.params.length !== 1 && this.raiseRecoverable(n3.value.start, "setter should have exactly one param"), n3.kind === "set" && n3.value.params[0].type === "RestElement" && this.raiseRecoverable(n3.value.params[0].start, "Setter cannot use rest params"), n3;
}, lt$3.parseClassMethod = function(e28, t3, n3, r3) {
  return e28.value = this.parseMethod(t3, n3, r3), this.finishNode(e28, "MethodDefinition");
}, lt$3.parseClassId = function(e28, t3) {
  this.type === G$8.name ? (e28.id = this.parseIdent(), t3 && this.checkLVal(e28.id, 2, false)) : (t3 === true && this.unexpected(), e28.id = null);
}, lt$3.parseClassSuper = function(e28) {
  e28.superClass = this.eat(G$8._extends) ? this.parseExprSubscripts() : null;
}, lt$3.parseExport = function(e28, t3) {
  if (this.next(), this.eat(G$8.star))
    return this.expectContextual("from"), this.type !== G$8.string && this.unexpected(), e28.source = this.parseExprAtom(), this.semicolon(), this.finishNode(e28, "ExportAllDeclaration");
  if (this.eat(G$8._default)) {
    var n3;
    if (this.checkExport(t3, "default", this.lastTokStart), this.type === G$8._function || (n3 = this.isAsyncFunction())) {
      var r3 = this.startNode();
      this.next(), n3 && this.next(), e28.declaration = this.parseFunction(r3, 4 | Wu$1, false, n3);
    } else if (this.type === G$8._class) {
      var i = this.startNode();
      e28.declaration = this.parseClass(i, "nullableID");
    } else
      e28.declaration = this.parseMaybeAssign(), this.semicolon();
    return this.finishNode(e28, "ExportDefaultDeclaration");
  }
  if (this.shouldParseExportStatement())
    e28.declaration = this.parseStatement(null), e28.declaration.type === "VariableDeclaration" ? this.checkVariableExport(t3, e28.declaration.declarations) : this.checkExport(t3, e28.declaration.id.name, e28.declaration.id.start), e28.specifiers = [], e28.source = null;
  else {
    if (e28.declaration = null, e28.specifiers = this.parseExportSpecifiers(t3), this.eatContextual("from"))
      this.type !== G$8.string && this.unexpected(), e28.source = this.parseExprAtom();
    else {
      for (var a3 = 0, s3 = e28.specifiers; a3 < s3.length; a3 += 1) {
        var o3 = s3[a3];
        this.checkUnreserved(o3.local), this.checkLocalExport(o3.local);
      }
      e28.source = null;
    }
    this.semicolon();
  }
  return this.finishNode(e28, "ExportNamedDeclaration");
}, lt$3.checkExport = function(e28, t3, n3) {
  e28 && (mf(e28, t3) && this.raiseRecoverable(n3, "Duplicate export '" + t3 + "'"), e28[t3] = true);
}, lt$3.checkPatternExport = function(e28, t3) {
  var n3 = t3.type;
  if (n3 === "Identifier")
    this.checkExport(e28, t3.name, t3.start);
  else if (n3 === "ObjectPattern")
    for (var r3 = 0, i = t3.properties; r3 < i.length; r3 += 1) {
      var a3 = i[r3];
      this.checkPatternExport(e28, a3);
    }
  else if (n3 === "ArrayPattern")
    for (var s3 = 0, o3 = t3.elements; s3 < o3.length; s3 += 1) {
      var u3 = o3[s3];
      u3 && this.checkPatternExport(e28, u3);
    }
  else
    n3 === "Property" ? this.checkPatternExport(e28, t3.value) : n3 === "AssignmentPattern" ? this.checkPatternExport(e28, t3.left) : n3 === "RestElement" ? this.checkPatternExport(e28, t3.argument) : n3 === "ParenthesizedExpression" && this.checkPatternExport(e28, t3.expression);
}, lt$3.checkVariableExport = function(e28, t3) {
  if (e28)
    for (var n3 = 0, r3 = t3; n3 < r3.length; n3 += 1) {
      var i = r3[n3];
      this.checkPatternExport(e28, i.id);
    }
}, lt$3.shouldParseExportStatement = function() {
  return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
}, lt$3.parseExportSpecifiers = function(e28) {
  var t3 = [], n3 = true;
  for (this.expect(G$8.braceL); !this.eat(G$8.braceR); ) {
    if (n3)
      n3 = false;
    else if (this.expect(G$8.comma), this.afterTrailingComma(G$8.braceR))
      break;
    var r3 = this.startNode();
    r3.local = this.parseIdent(true), r3.exported = this.eatContextual("as") ? this.parseIdent(true) : r3.local, this.checkExport(e28, r3.exported.name, r3.exported.start), t3.push(this.finishNode(r3, "ExportSpecifier"));
  }
  return t3;
}, lt$3.parseImport = function(e28) {
  return this.next(), this.type === G$8.string ? (e28.specifiers = U9, e28.source = this.parseExprAtom()) : (e28.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), e28.source = this.type === G$8.string ? this.parseExprAtom() : this.unexpected()), this.semicolon(), this.finishNode(e28, "ImportDeclaration");
}, lt$3.parseImportSpecifiers = function() {
  var e28 = [], t3 = true;
  if (this.type === G$8.name) {
    var n3 = this.startNode();
    if (n3.local = this.parseIdent(), this.checkLVal(n3.local, 2), e28.push(this.finishNode(n3, "ImportDefaultSpecifier")), !this.eat(G$8.comma))
      return e28;
  }
  if (this.type === G$8.star) {
    var r3 = this.startNode();
    return this.next(), this.expectContextual("as"), r3.local = this.parseIdent(), this.checkLVal(r3.local, 2), e28.push(this.finishNode(r3, "ImportNamespaceSpecifier")), e28;
  }
  for (this.expect(G$8.braceL); !this.eat(G$8.braceR); ) {
    if (t3)
      t3 = false;
    else if (this.expect(G$8.comma), this.afterTrailingComma(G$8.braceR))
      break;
    var i = this.startNode();
    i.imported = this.parseIdent(true), this.eatContextual("as") ? i.local = this.parseIdent() : (this.checkUnreserved(i.imported), i.local = i.imported), this.checkLVal(i.local, 2), e28.push(this.finishNode(i, "ImportSpecifier"));
  }
  return e28;
}, lt$3.adaptDirectivePrologue = function(e28) {
  for (var t3 = 0; t3 < e28.length && this.isDirectiveCandidate(e28[t3]); ++t3)
    e28[t3].directive = e28[t3].expression.raw.slice(1, -1);
}, lt$3.isDirectiveCandidate = function(e28) {
  return e28.type === "ExpressionStatement" && e28.expression.type === "Literal" && typeof e28.expression.value == "string" && (this.input[e28.start] === '"' || this.input[e28.start] === "'");
};
var ca$2 = fn$1.prototype;
ca$2.toAssignable = function(e28, t3, n3) {
  if (this.options.ecmaVersion >= 6 && e28)
    switch (e28.type) {
      case "Identifier":
        this.inAsync && e28.name === "await" && this.raise(e28.start, "Cannot use 'await' as identifier inside an async function");
        break;
      case "ObjectPattern":
      case "ArrayPattern":
      case "RestElement":
        break;
      case "ObjectExpression":
        e28.type = "ObjectPattern", n3 && this.checkPatternErrors(n3, true);
        for (var r3 = 0, i = e28.properties; r3 < i.length; r3 += 1) {
          var a3 = i[r3];
          this.toAssignable(a3, t3), a3.type !== "RestElement" || a3.argument.type !== "ArrayPattern" && a3.argument.type !== "ObjectPattern" || this.raise(a3.argument.start, "Unexpected token");
        }
        break;
      case "Property":
        e28.kind !== "init" && this.raise(e28.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(e28.value, t3);
        break;
      case "ArrayExpression":
        e28.type = "ArrayPattern", n3 && this.checkPatternErrors(n3, true), this.toAssignableList(e28.elements, t3);
        break;
      case "SpreadElement":
        e28.type = "RestElement", this.toAssignable(e28.argument, t3), e28.argument.type === "AssignmentPattern" && this.raise(e28.argument.start, "Rest elements cannot have a default value");
        break;
      case "AssignmentExpression":
        e28.operator !== "=" && this.raise(e28.left.end, "Only '=' operator can be used for specifying default value."), e28.type = "AssignmentPattern", delete e28.operator, this.toAssignable(e28.left, t3);
      case "AssignmentPattern":
        break;
      case "ParenthesizedExpression":
        this.toAssignable(e28.expression, t3, n3);
        break;
      case "MemberExpression":
        if (!t3)
          break;
      default:
        this.raise(e28.start, "Assigning to rvalue");
    }
  else
    n3 && this.checkPatternErrors(n3, true);
  return e28;
}, ca$2.toAssignableList = function(e28, t3) {
  for (var n3 = e28.length, r3 = 0; r3 < n3; r3++) {
    var i = e28[r3];
    i && this.toAssignable(i, t3);
  }
  if (n3) {
    var a3 = e28[n3 - 1];
    this.options.ecmaVersion === 6 && t3 && a3 && a3.type === "RestElement" && a3.argument.type !== "Identifier" && this.unexpected(a3.argument.start);
  }
  return e28;
}, ca$2.parseSpread = function(e28) {
  var t3 = this.startNode();
  return this.next(), t3.argument = this.parseMaybeAssign(false, e28), this.finishNode(t3, "SpreadElement");
}, ca$2.parseRestBinding = function() {
  var e28 = this.startNode();
  return this.next(), this.options.ecmaVersion === 6 && this.type !== G$8.name && this.unexpected(), e28.argument = this.parseBindingAtom(), this.finishNode(e28, "RestElement");
}, ca$2.parseBindingAtom = function() {
  if (this.options.ecmaVersion >= 6)
    switch (this.type) {
      case G$8.bracketL:
        var e28 = this.startNode();
        return this.next(), e28.elements = this.parseBindingList(G$8.bracketR, true, true), this.finishNode(e28, "ArrayPattern");
      case G$8.braceL:
        return this.parseObj(true);
    }
  return this.parseIdent();
}, ca$2.parseBindingList = function(e28, t3, n3) {
  for (var r3 = [], i = true; !this.eat(e28); )
    if (i ? i = false : this.expect(G$8.comma), t3 && this.type === G$8.comma)
      r3.push(null);
    else {
      if (n3 && this.afterTrailingComma(e28))
        break;
      if (this.type === G$8.ellipsis) {
        var a3 = this.parseRestBinding();
        this.parseBindingListItem(a3), r3.push(a3), this.type === G$8.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.expect(e28);
        break;
      }
      var s3 = this.parseMaybeDefault(this.start, this.startLoc);
      this.parseBindingListItem(s3), r3.push(s3);
    }
  return r3;
}, ca$2.parseBindingListItem = function(e28) {
  return e28;
}, ca$2.parseMaybeDefault = function(e28, t3, n3) {
  if (n3 = n3 || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(G$8.eq))
    return n3;
  var r3 = this.startNodeAt(e28, t3);
  return r3.left = n3, r3.right = this.parseMaybeAssign(), this.finishNode(r3, "AssignmentPattern");
}, ca$2.checkLVal = function(e28, t3, n3) {
  switch (t3 === void 0 && (t3 = 0), e28.type) {
    case "Identifier":
      t3 === 2 && e28.name === "let" && this.raiseRecoverable(e28.start, "let is disallowed as a lexically bound name"), this.strict && this.reservedWordsStrictBind.test(e28.name) && this.raiseRecoverable(e28.start, (t3 ? "Binding " : "Assigning to ") + e28.name + " in strict mode"), n3 && (mf(n3, e28.name) && this.raiseRecoverable(e28.start, "Argument name clash"), n3[e28.name] = true), t3 !== 0 && t3 !== 5 && this.declareName(e28.name, t3, e28.start);
      break;
    case "MemberExpression":
      t3 && this.raiseRecoverable(e28.start, "Binding member expression");
      break;
    case "ObjectPattern":
      for (var r3 = 0, i = e28.properties; r3 < i.length; r3 += 1) {
        var a3 = i[r3];
        this.checkLVal(a3, t3, n3);
      }
      break;
    case "Property":
      this.checkLVal(e28.value, t3, n3);
      break;
    case "ArrayPattern":
      for (var s3 = 0, o3 = e28.elements; s3 < o3.length; s3 += 1) {
        var u3 = o3[s3];
        u3 && this.checkLVal(u3, t3, n3);
      }
      break;
    case "AssignmentPattern":
      this.checkLVal(e28.left, t3, n3);
      break;
    case "RestElement":
      this.checkLVal(e28.argument, t3, n3);
      break;
    case "ParenthesizedExpression":
      this.checkLVal(e28.expression, t3, n3);
      break;
    default:
      this.raise(e28.start, (t3 ? "Binding" : "Assigning to") + " rvalue");
  }
};
var Et$2 = fn$1.prototype;
Et$2.checkPropClash = function(e28, t3, n3) {
  if (!(this.options.ecmaVersion >= 9 && e28.type === "SpreadElement" || this.options.ecmaVersion >= 6 && (e28.computed || e28.method || e28.shorthand))) {
    var r3, i = e28.key;
    switch (i.type) {
      case "Identifier":
        r3 = i.name;
        break;
      case "Literal":
        r3 = String(i.value);
        break;
      default:
        return;
    }
    var a3 = e28.kind;
    if (this.options.ecmaVersion >= 6)
      r3 === "__proto__" && a3 === "init" && (t3.proto && (n3 && n3.doubleProto < 0 ? n3.doubleProto = i.start : this.raiseRecoverable(i.start, "Redefinition of __proto__ property")), t3.proto = true);
    else {
      var s3 = t3[r3 = "$" + r3];
      s3 ? (a3 === "init" ? this.strict && s3.init || s3.get || s3.set : s3.init || s3[a3]) && this.raiseRecoverable(i.start, "Redefinition of property") : s3 = t3[r3] = { init: false, get: false, set: false }, s3[a3] = true;
    }
  }
}, Et$2.parseExpression = function(e28, t3) {
  var n3 = this.start, r3 = this.startLoc, i = this.parseMaybeAssign(e28, t3);
  if (this.type === G$8.comma) {
    var a3 = this.startNodeAt(n3, r3);
    for (a3.expressions = [i]; this.eat(G$8.comma); )
      a3.expressions.push(this.parseMaybeAssign(e28, t3));
    return this.finishNode(a3, "SequenceExpression");
  }
  return i;
}, Et$2.parseMaybeAssign = function(e28, t3, n3) {
  if (this.isContextual("yield")) {
    if (this.inGenerator)
      return this.parseYield(e28);
    this.exprAllowed = false;
  }
  var r3 = false, i = -1, a3 = -1, s3 = -1;
  t3 ? (i = t3.parenthesizedAssign, a3 = t3.trailingComma, s3 = t3.shorthandAssign, t3.parenthesizedAssign = t3.trailingComma = t3.shorthandAssign = -1) : (t3 = new qu$1(), r3 = true);
  var o3 = this.start, u3 = this.startLoc;
  this.type !== G$8.parenL && this.type !== G$8.name || (this.potentialArrowAt = this.start);
  var c3 = this.parseMaybeConditional(e28, t3);
  if (n3 && (c3 = n3.call(this, c3, o3, u3)), this.type.isAssign) {
    var f3 = this.startNodeAt(o3, u3);
    return f3.operator = this.value, f3.left = this.type === G$8.eq ? this.toAssignable(c3, false, t3) : c3, r3 || qu$1.call(t3), t3.shorthandAssign = -1, this.checkLVal(c3), this.next(), f3.right = this.parseMaybeAssign(e28), this.finishNode(f3, "AssignmentExpression");
  }
  return r3 && this.checkExpressionErrors(t3, true), i > -1 && (t3.parenthesizedAssign = i), a3 > -1 && (t3.trailingComma = a3), s3 > -1 && (t3.shorthandAssign = s3), c3;
}, Et$2.parseMaybeConditional = function(e28, t3) {
  var n3 = this.start, r3 = this.startLoc, i = this.parseExprOps(e28, t3);
  if (this.checkExpressionErrors(t3))
    return i;
  if (this.eat(G$8.question)) {
    var a3 = this.startNodeAt(n3, r3);
    return a3.test = i, a3.consequent = this.parseMaybeAssign(), this.expect(G$8.colon), a3.alternate = this.parseMaybeAssign(e28), this.finishNode(a3, "ConditionalExpression");
  }
  return i;
}, Et$2.parseExprOps = function(e28, t3) {
  var n3 = this.start, r3 = this.startLoc, i = this.parseMaybeUnary(t3, false);
  return this.checkExpressionErrors(t3) || i.start === n3 && i.type === "ArrowFunctionExpression" ? i : this.parseExprOp(i, n3, r3, -1, e28);
}, Et$2.parseExprOp = function(e28, t3, n3, r3, i) {
  var a3 = this.type.binop;
  if (a3 != null && (!i || this.type !== G$8._in) && a3 > r3) {
    var s3 = this.type === G$8.logicalOR || this.type === G$8.logicalAND, o3 = this.value;
    this.next();
    var u3 = this.start, c3 = this.startLoc, f3 = this.parseExprOp(this.parseMaybeUnary(null, false), u3, c3, a3, i), p3 = this.buildBinary(t3, n3, e28, f3, o3, s3);
    return this.parseExprOp(p3, t3, n3, r3, i);
  }
  return e28;
}, Et$2.buildBinary = function(e28, t3, n3, r3, i, a3) {
  var s3 = this.startNodeAt(e28, t3);
  return s3.left = n3, s3.operator = i, s3.right = r3, this.finishNode(s3, a3 ? "LogicalExpression" : "BinaryExpression");
}, Et$2.parseMaybeUnary = function(e28, t3) {
  var n3, r3 = this.start, i = this.startLoc;
  if (this.isContextual("await") && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction))
    n3 = this.parseAwait(), t3 = true;
  else if (this.type.prefix) {
    var a3 = this.startNode(), s3 = this.type === G$8.incDec;
    a3.operator = this.value, a3.prefix = true, this.next(), a3.argument = this.parseMaybeUnary(null, true), this.checkExpressionErrors(e28, true), s3 ? this.checkLVal(a3.argument) : this.strict && a3.operator === "delete" && a3.argument.type === "Identifier" ? this.raiseRecoverable(a3.start, "Deleting local variable in strict mode") : t3 = true, n3 = this.finishNode(a3, s3 ? "UpdateExpression" : "UnaryExpression");
  } else {
    if (n3 = this.parseExprSubscripts(e28), this.checkExpressionErrors(e28))
      return n3;
    for (; this.type.postfix && !this.canInsertSemicolon(); ) {
      var o3 = this.startNodeAt(r3, i);
      o3.operator = this.value, o3.prefix = false, o3.argument = n3, this.checkLVal(n3), this.next(), n3 = this.finishNode(o3, "UpdateExpression");
    }
  }
  return !t3 && this.eat(G$8.starstar) ? this.buildBinary(r3, i, n3, this.parseMaybeUnary(null, false), "**", false) : n3;
}, Et$2.parseExprSubscripts = function(e28) {
  var t3 = this.start, n3 = this.startLoc, r3 = this.parseExprAtom(e28), i = r3.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")";
  if (this.checkExpressionErrors(e28) || i)
    return r3;
  var a3 = this.parseSubscripts(r3, t3, n3);
  return e28 && a3.type === "MemberExpression" && (e28.parenthesizedAssign >= a3.start && (e28.parenthesizedAssign = -1), e28.parenthesizedBind >= a3.start && (e28.parenthesizedBind = -1)), a3;
}, Et$2.parseSubscripts = function(e28, t3, n3, r3) {
  for (var i = this.options.ecmaVersion >= 8 && e28.type === "Identifier" && e28.name === "async" && this.lastTokEnd === e28.end && !this.canInsertSemicolon() && this.input.slice(e28.start, e28.end) === "async"; ; ) {
    var a3 = this.parseSubscript(e28, t3, n3, r3, i);
    if (a3 === e28 || a3.type === "ArrowFunctionExpression")
      return a3;
    e28 = a3;
  }
}, Et$2.parseSubscript = function(e28, t3, n3, r3, i) {
  var a3 = this.eat(G$8.bracketL);
  if (a3 || this.eat(G$8.dot)) {
    var s3 = this.startNodeAt(t3, n3);
    s3.object = e28, s3.property = a3 ? this.parseExpression() : this.parseIdent(this.options.allowReserved !== "never"), s3.computed = !!a3, a3 && this.expect(G$8.bracketR), e28 = this.finishNode(s3, "MemberExpression");
  } else if (!r3 && this.eat(G$8.parenL)) {
    var o3 = new qu$1(), u3 = this.yieldPos, c3 = this.awaitPos, f3 = this.awaitIdentPos;
    this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
    var p3 = this.parseExprList(G$8.parenR, this.options.ecmaVersion >= 8 && e28.type !== "Import", false, o3);
    if (i && !this.canInsertSemicolon() && this.eat(G$8.arrow))
      return this.checkPatternErrors(o3, false), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = u3, this.awaitPos = c3, this.awaitIdentPos = f3, this.parseArrowExpression(this.startNodeAt(t3, n3), p3, true);
    this.checkExpressionErrors(o3, true), this.yieldPos = u3 || this.yieldPos, this.awaitPos = c3 || this.awaitPos, this.awaitIdentPos = f3 || this.awaitIdentPos;
    var d3 = this.startNodeAt(t3, n3);
    if (d3.callee = e28, d3.arguments = p3, d3.callee.type === "Import") {
      d3.arguments.length !== 1 && this.raise(d3.start, "import() requires exactly one argument");
      var m3 = d3.arguments[0];
      m3 && m3.type === "SpreadElement" && this.raise(m3.start, "... is not allowed in import()");
    }
    e28 = this.finishNode(d3, "CallExpression");
  } else if (this.type === G$8.backQuote) {
    var y3 = this.startNodeAt(t3, n3);
    y3.tag = e28, y3.quasi = this.parseTemplate({ isTagged: true }), e28 = this.finishNode(y3, "TaggedTemplateExpression");
  }
  return e28;
}, Et$2.parseExprAtom = function(e28) {
  this.type === G$8.slash && this.readRegexp();
  var t3, n3 = this.potentialArrowAt === this.start;
  switch (this.type) {
    case G$8._super:
      return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), t3 = this.startNode(), this.next(), this.type !== G$8.parenL || this.allowDirectSuper || this.raise(t3.start, "super() call outside constructor of a subclass"), this.type !== G$8.dot && this.type !== G$8.bracketL && this.type !== G$8.parenL && this.unexpected(), this.finishNode(t3, "Super");
    case G$8._this:
      return t3 = this.startNode(), this.next(), this.finishNode(t3, "ThisExpression");
    case G$8.name:
      var r3 = this.start, i = this.startLoc, a3 = this.containsEsc, s3 = this.parseIdent(false);
      if (this.options.ecmaVersion >= 8 && !a3 && s3.name === "async" && !this.canInsertSemicolon() && this.eat(G$8._function))
        return this.parseFunction(this.startNodeAt(r3, i), 0, false, true);
      if (n3 && !this.canInsertSemicolon()) {
        if (this.eat(G$8.arrow))
          return this.parseArrowExpression(this.startNodeAt(r3, i), [s3], false);
        if (this.options.ecmaVersion >= 8 && s3.name === "async" && this.type === G$8.name && !a3)
          return s3 = this.parseIdent(false), !this.canInsertSemicolon() && this.eat(G$8.arrow) || this.unexpected(), this.parseArrowExpression(this.startNodeAt(r3, i), [s3], true);
      }
      return s3;
    case G$8.regexp:
      var o3 = this.value;
      return (t3 = this.parseLiteral(o3.value)).regex = { pattern: o3.pattern, flags: o3.flags }, t3;
    case G$8.num:
    case G$8.string:
      return this.parseLiteral(this.value);
    case G$8._null:
    case G$8._true:
    case G$8._false:
      return (t3 = this.startNode()).value = this.type === G$8._null ? null : this.type === G$8._true, t3.raw = this.type.keyword, this.next(), this.finishNode(t3, "Literal");
    case G$8.parenL:
      var u3 = this.start, c3 = this.parseParenAndDistinguishExpression(n3);
      return e28 && (e28.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(c3) && (e28.parenthesizedAssign = u3), e28.parenthesizedBind < 0 && (e28.parenthesizedBind = u3)), c3;
    case G$8.bracketL:
      return t3 = this.startNode(), this.next(), t3.elements = this.parseExprList(G$8.bracketR, true, true, e28), this.finishNode(t3, "ArrayExpression");
    case G$8.braceL:
      return this.parseObj(false, e28);
    case G$8._function:
      return t3 = this.startNode(), this.next(), this.parseFunction(t3, 0);
    case G$8._class:
      return this.parseClass(this.startNode(), false);
    case G$8._new:
      return this.parseNew();
    case G$8.backQuote:
      return this.parseTemplate();
    case G$8._import:
      return this.options.ecmaVersion > 10 ? this.parseDynamicImport() : this.unexpected();
    default:
      this.unexpected();
  }
}, Et$2.parseDynamicImport = function() {
  var e28 = this.startNode();
  return this.next(), this.type !== G$8.parenL && this.unexpected(), this.finishNode(e28, "Import");
}, Et$2.parseLiteral = function(e28) {
  var t3 = this.startNode();
  return t3.value = e28, t3.raw = this.input.slice(this.start, this.end), t3.raw.charCodeAt(t3.raw.length - 1) === 110 && (t3.bigint = t3.raw.slice(0, -1)), this.next(), this.finishNode(t3, "Literal");
}, Et$2.parseParenExpression = function() {
  this.expect(G$8.parenL);
  var e28 = this.parseExpression();
  return this.expect(G$8.parenR), e28;
}, Et$2.parseParenAndDistinguishExpression = function(e28) {
  var t3, n3 = this.start, r3 = this.startLoc, i = this.options.ecmaVersion >= 8;
  if (this.options.ecmaVersion >= 6) {
    this.next();
    var a3, s3 = this.start, o3 = this.startLoc, u3 = [], c3 = true, f3 = false, p3 = new qu$1(), d3 = this.yieldPos, m3 = this.awaitPos;
    for (this.yieldPos = 0, this.awaitPos = 0; this.type !== G$8.parenR; ) {
      if (c3 ? c3 = false : this.expect(G$8.comma), i && this.afterTrailingComma(G$8.parenR, true)) {
        f3 = true;
        break;
      }
      if (this.type === G$8.ellipsis) {
        a3 = this.start, u3.push(this.parseParenItem(this.parseRestBinding())), this.type === G$8.comma && this.raise(this.start, "Comma is not permitted after the rest element");
        break;
      }
      u3.push(this.parseMaybeAssign(false, p3, this.parseParenItem));
    }
    var y3 = this.start, v3 = this.startLoc;
    if (this.expect(G$8.parenR), e28 && !this.canInsertSemicolon() && this.eat(G$8.arrow))
      return this.checkPatternErrors(p3, false), this.checkYieldAwaitInDefaultParams(), this.yieldPos = d3, this.awaitPos = m3, this.parseParenArrowList(n3, r3, u3);
    u3.length && !f3 || this.unexpected(this.lastTokStart), a3 && this.unexpected(a3), this.checkExpressionErrors(p3, true), this.yieldPos = d3 || this.yieldPos, this.awaitPos = m3 || this.awaitPos, u3.length > 1 ? ((t3 = this.startNodeAt(s3, o3)).expressions = u3, this.finishNodeAt(t3, "SequenceExpression", y3, v3)) : t3 = u3[0];
  } else
    t3 = this.parseParenExpression();
  if (this.options.preserveParens) {
    var b3 = this.startNodeAt(n3, r3);
    return b3.expression = t3, this.finishNode(b3, "ParenthesizedExpression");
  }
  return t3;
}, Et$2.parseParenItem = function(e28) {
  return e28;
}, Et$2.parseParenArrowList = function(e28, t3, n3) {
  return this.parseArrowExpression(this.startNodeAt(e28, t3), n3);
};
var q9 = [];
Et$2.parseNew = function() {
  var e28 = this.startNode(), t3 = this.parseIdent(true);
  if (this.options.ecmaVersion >= 6 && this.eat(G$8.dot)) {
    e28.meta = t3;
    var n3 = this.containsEsc;
    return e28.property = this.parseIdent(true), (e28.property.name !== "target" || n3) && this.raiseRecoverable(e28.property.start, "The only valid meta property for new is new.target"), this.inNonArrowFunction() || this.raiseRecoverable(e28.start, "new.target can only be used in functions"), this.finishNode(e28, "MetaProperty");
  }
  var r3 = this.start, i = this.startLoc;
  return e28.callee = this.parseSubscripts(this.parseExprAtom(), r3, i, true), this.options.ecmaVersion > 10 && e28.callee.type === "Import" && this.raise(e28.callee.start, "Cannot use new with import(...)"), this.eat(G$8.parenL) ? e28.arguments = this.parseExprList(G$8.parenR, this.options.ecmaVersion >= 8 && e28.callee.type !== "Import", false) : e28.arguments = q9, this.finishNode(e28, "NewExpression");
}, Et$2.parseTemplateElement = function(e28) {
  var t3 = e28.isTagged, n3 = this.startNode();
  return this.type === G$8.invalidTemplate ? (t3 || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), n3.value = { raw: this.value, cooked: null }) : n3.value = { raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`), cooked: this.value }, this.next(), n3.tail = this.type === G$8.backQuote, this.finishNode(n3, "TemplateElement");
}, Et$2.parseTemplate = function(e28) {
  e28 === void 0 && (e28 = {});
  var t3 = e28.isTagged;
  t3 === void 0 && (t3 = false);
  var n3 = this.startNode();
  this.next(), n3.expressions = [];
  var r3 = this.parseTemplateElement({ isTagged: t3 });
  for (n3.quasis = [r3]; !r3.tail; )
    this.type === G$8.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(G$8.dollarBraceL), n3.expressions.push(this.parseExpression()), this.expect(G$8.braceR), n3.quasis.push(r3 = this.parseTemplateElement({ isTagged: t3 }));
  return this.next(), this.finishNode(n3, "TemplateLiteral");
}, Et$2.isAsyncProp = function(e28) {
  return !e28.computed && e28.key.type === "Identifier" && e28.key.name === "async" && (this.type === G$8.name || this.type === G$8.num || this.type === G$8.string || this.type === G$8.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === G$8.star) && !li$1.test(this.input.slice(this.lastTokEnd, this.start));
}, Et$2.parseObj = function(e28, t3) {
  var n3 = this.startNode(), r3 = true, i = {};
  for (n3.properties = [], this.next(); !this.eat(G$8.braceR); ) {
    if (r3)
      r3 = false;
    else if (this.expect(G$8.comma), this.afterTrailingComma(G$8.braceR))
      break;
    var a3 = this.parseProperty(e28, t3);
    e28 || this.checkPropClash(a3, i, t3), n3.properties.push(a3);
  }
  return this.finishNode(n3, e28 ? "ObjectPattern" : "ObjectExpression");
}, Et$2.parseProperty = function(e28, t3) {
  var n3, r3, i, a3, s3 = this.startNode();
  if (this.options.ecmaVersion >= 9 && this.eat(G$8.ellipsis))
    return e28 ? (s3.argument = this.parseIdent(false), this.type === G$8.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.finishNode(s3, "RestElement")) : (this.type === G$8.parenL && t3 && (t3.parenthesizedAssign < 0 && (t3.parenthesizedAssign = this.start), t3.parenthesizedBind < 0 && (t3.parenthesizedBind = this.start)), s3.argument = this.parseMaybeAssign(false, t3), this.type === G$8.comma && t3 && t3.trailingComma < 0 && (t3.trailingComma = this.start), this.finishNode(s3, "SpreadElement"));
  this.options.ecmaVersion >= 6 && (s3.method = false, s3.shorthand = false, (e28 || t3) && (i = this.start, a3 = this.startLoc), e28 || (n3 = this.eat(G$8.star)));
  var o3 = this.containsEsc;
  return this.parsePropertyName(s3), !e28 && !o3 && this.options.ecmaVersion >= 8 && !n3 && this.isAsyncProp(s3) ? (r3 = true, n3 = this.options.ecmaVersion >= 9 && this.eat(G$8.star), this.parsePropertyName(s3, t3)) : r3 = false, this.parsePropertyValue(s3, e28, n3, r3, i, a3, t3, o3), this.finishNode(s3, "Property");
}, Et$2.parsePropertyValue = function(e28, t3, n3, r3, i, a3, s3, o3) {
  if ((n3 || r3) && this.type === G$8.colon && this.unexpected(), this.eat(G$8.colon))
    e28.value = t3 ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(false, s3), e28.kind = "init";
  else if (this.options.ecmaVersion >= 6 && this.type === G$8.parenL)
    t3 && this.unexpected(), e28.kind = "init", e28.method = true, e28.value = this.parseMethod(n3, r3);
  else if (t3 || o3 || !(this.options.ecmaVersion >= 5) || e28.computed || e28.key.type !== "Identifier" || e28.key.name !== "get" && e28.key.name !== "set" || this.type === G$8.comma || this.type === G$8.braceR)
    this.options.ecmaVersion >= 6 && !e28.computed && e28.key.type === "Identifier" ? ((n3 || r3) && this.unexpected(), this.checkUnreserved(e28.key), e28.key.name !== "await" || this.awaitIdentPos || (this.awaitIdentPos = i), e28.kind = "init", t3 ? e28.value = this.parseMaybeDefault(i, a3, e28.key) : this.type === G$8.eq && s3 ? (s3.shorthandAssign < 0 && (s3.shorthandAssign = this.start), e28.value = this.parseMaybeDefault(i, a3, e28.key)) : e28.value = e28.key, e28.shorthand = true) : this.unexpected();
  else {
    (n3 || r3) && this.unexpected(), e28.kind = e28.key.name, this.parsePropertyName(e28), e28.value = this.parseMethod(false);
    var u3 = e28.kind === "get" ? 0 : 1;
    if (e28.value.params.length !== u3) {
      var c3 = e28.value.start;
      e28.kind === "get" ? this.raiseRecoverable(c3, "getter should have no params") : this.raiseRecoverable(c3, "setter should have exactly one param");
    } else
      e28.kind === "set" && e28.value.params[0].type === "RestElement" && this.raiseRecoverable(e28.value.params[0].start, "Setter cannot use rest params");
  }
}, Et$2.parsePropertyName = function(e28) {
  if (this.options.ecmaVersion >= 6) {
    if (this.eat(G$8.bracketL))
      return e28.computed = true, e28.key = this.parseMaybeAssign(), this.expect(G$8.bracketR), e28.key;
    e28.computed = false;
  }
  return e28.key = this.type === G$8.num || this.type === G$8.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
}, Et$2.initFunction = function(e28) {
  e28.id = null, this.options.ecmaVersion >= 6 && (e28.generator = e28.expression = false), this.options.ecmaVersion >= 8 && (e28.async = false);
}, Et$2.parseMethod = function(e28, t3, n3) {
  var r3 = this.startNode(), i = this.yieldPos, a3 = this.awaitPos, s3 = this.awaitIdentPos;
  return this.initFunction(r3), this.options.ecmaVersion >= 6 && (r3.generator = e28), this.options.ecmaVersion >= 8 && (r3.async = !!t3), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(64 | Rm(t3, r3.generator) | (n3 ? 128 : 0)), this.expect(G$8.parenL), r3.params = this.parseBindingList(G$8.parenR, false, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(r3, false, true), this.yieldPos = i, this.awaitPos = a3, this.awaitIdentPos = s3, this.finishNode(r3, "FunctionExpression");
}, Et$2.parseArrowExpression = function(e28, t3, n3) {
  var r3 = this.yieldPos, i = this.awaitPos, a3 = this.awaitIdentPos;
  return this.enterScope(16 | Rm(n3, false)), this.initFunction(e28), this.options.ecmaVersion >= 8 && (e28.async = !!n3), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, e28.params = this.toAssignableList(t3, true), this.parseFunctionBody(e28, true, false), this.yieldPos = r3, this.awaitPos = i, this.awaitIdentPos = a3, this.finishNode(e28, "ArrowFunctionExpression");
}, Et$2.parseFunctionBody = function(e28, t3, n3) {
  var r3 = t3 && this.type !== G$8.braceL, i = this.strict, a3 = false;
  if (r3)
    e28.body = this.parseMaybeAssign(), e28.expression = true, this.checkParams(e28, false);
  else {
    var s3 = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(e28.params);
    i && !s3 || (a3 = this.strictDirective(this.end)) && s3 && this.raiseRecoverable(e28.start, "Illegal 'use strict' directive in function with non-simple parameter list");
    var o3 = this.labels;
    this.labels = [], a3 && (this.strict = true), this.checkParams(e28, !i && !a3 && !t3 && !n3 && this.isSimpleParamList(e28.params)), e28.body = this.parseBlock(false), e28.expression = false, this.adaptDirectivePrologue(e28.body.body), this.labels = o3;
  }
  this.exitScope(), this.strict && e28.id && this.checkLVal(e28.id, 5), this.strict = i;
}, Et$2.isSimpleParamList = function(e28) {
  for (var t3 = 0, n3 = e28; t3 < n3.length; t3 += 1)
    if (n3[t3].type !== "Identifier")
      return false;
  return true;
}, Et$2.checkParams = function(e28, t3) {
  for (var n3 = {}, r3 = 0, i = e28.params; r3 < i.length; r3 += 1) {
    var a3 = i[r3];
    this.checkLVal(a3, 1, t3 ? null : n3);
  }
}, Et$2.parseExprList = function(e28, t3, n3, r3) {
  for (var i = [], a3 = true; !this.eat(e28); ) {
    if (a3)
      a3 = false;
    else if (this.expect(G$8.comma), t3 && this.afterTrailingComma(e28))
      break;
    var s3 = void 0;
    n3 && this.type === G$8.comma ? s3 = null : this.type === G$8.ellipsis ? (s3 = this.parseSpread(r3), r3 && this.type === G$8.comma && r3.trailingComma < 0 && (r3.trailingComma = this.start)) : s3 = this.parseMaybeAssign(false, r3), i.push(s3);
  }
  return i;
}, Et$2.checkUnreserved = function(e28) {
  var t3 = e28.start, n3 = e28.end, r3 = e28.name;
  this.inGenerator && r3 === "yield" && this.raiseRecoverable(t3, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && r3 === "await" && this.raiseRecoverable(t3, "Cannot use 'await' as identifier inside an async function"), this.keywords.test(r3) && this.raise(t3, "Unexpected keyword '" + r3 + "'"), this.options.ecmaVersion < 6 && this.input.slice(t3, n3).indexOf("\\") !== -1 || (this.strict ? this.reservedWordsStrict : this.reservedWords).test(r3) && (this.inAsync || r3 !== "await" || this.raiseRecoverable(t3, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(t3, "The keyword '" + r3 + "' is reserved"));
}, Et$2.parseIdent = function(e28, t3) {
  var n3 = this.startNode();
  return this.type === G$8.name ? n3.name = this.value : this.type.keyword ? (n3.name = this.type.keyword, n3.name !== "class" && n3.name !== "function" || this.lastTokEnd === this.lastTokStart + 1 && this.input.charCodeAt(this.lastTokStart) === 46 || this.context.pop()) : this.unexpected(), this.next(), this.finishNode(n3, "Identifier"), e28 || (this.checkUnreserved(n3), n3.name !== "await" || this.awaitIdentPos || (this.awaitIdentPos = n3.start)), n3;
}, Et$2.parseYield = function(e28) {
  this.yieldPos || (this.yieldPos = this.start);
  var t3 = this.startNode();
  return this.next(), this.type === G$8.semi || this.canInsertSemicolon() || this.type !== G$8.star && !this.type.startsExpr ? (t3.delegate = false, t3.argument = null) : (t3.delegate = this.eat(G$8.star), t3.argument = this.parseMaybeAssign(e28)), this.finishNode(t3, "YieldExpression");
}, Et$2.parseAwait = function() {
  this.awaitPos || (this.awaitPos = this.start);
  var e28 = this.startNode();
  return this.next(), e28.argument = this.parseMaybeUnary(null, true), this.finishNode(e28, "AwaitExpression");
};
var Nl = fn$1.prototype;
Nl.raise = function(e28, t3) {
  var n3 = z0(this.input, e28);
  t3 += " (" + n3.line + ":" + n3.column + ")";
  var r3 = new SyntaxError(t3);
  throw r3.pos = e28, r3.loc = n3, r3.raisedAt = this.pos, r3;
}, Nl.raiseRecoverable = Nl.raise, Nl.curPosition = function() {
  if (this.options.locations)
    return new Hs$1(this.curLine, this.pos - this.lineStart);
};
var Wa$3 = fn$1.prototype, W9 = function(e28) {
  this.flags = e28, this.var = [], this.lexical = [], this.functions = [];
};
Wa$3.enterScope = function(e28) {
  this.scopeStack.push(new W9(e28));
}, Wa$3.exitScope = function() {
  this.scopeStack.pop();
}, Wa$3.treatFunctionsAsVarInScope = function(e28) {
  return e28.flags & fc$2 || !this.inModule && 1 & e28.flags;
}, Wa$3.declareName = function(e28, t3, n3) {
  var r3 = false;
  if (t3 === 2) {
    var i = this.currentScope();
    r3 = i.lexical.indexOf(e28) > -1 || i.functions.indexOf(e28) > -1 || i.var.indexOf(e28) > -1, i.lexical.push(e28), this.inModule && 1 & i.flags && delete this.undefinedExports[e28];
  } else if (t3 === 4)
    this.currentScope().lexical.push(e28);
  else if (t3 === 3) {
    var a3 = this.currentScope();
    r3 = this.treatFunctionsAsVar ? a3.lexical.indexOf(e28) > -1 : a3.lexical.indexOf(e28) > -1 || a3.var.indexOf(e28) > -1, a3.functions.push(e28);
  } else
    for (var s3 = this.scopeStack.length - 1; s3 >= 0; --s3) {
      var o3 = this.scopeStack[s3];
      if (o3.lexical.indexOf(e28) > -1 && !(32 & o3.flags && o3.lexical[0] === e28) || !this.treatFunctionsAsVarInScope(o3) && o3.functions.indexOf(e28) > -1) {
        r3 = true;
        break;
      }
      if (o3.var.push(e28), this.inModule && 1 & o3.flags && delete this.undefinedExports[e28], o3.flags & kd$1)
        break;
    }
  r3 && this.raiseRecoverable(n3, "Identifier '" + e28 + "' has already been declared");
}, Wa$3.checkLocalExport = function(e28) {
  this.scopeStack[0].lexical.indexOf(e28.name) === -1 && this.scopeStack[0].var.indexOf(e28.name) === -1 && (this.undefinedExports[e28.name] = e28);
}, Wa$3.currentScope = function() {
  return this.scopeStack[this.scopeStack.length - 1];
}, Wa$3.currentVarScope = function() {
  for (var e28 = this.scopeStack.length - 1; ; e28--) {
    var t3 = this.scopeStack[e28];
    if (t3.flags & kd$1)
      return t3;
  }
}, Wa$3.currentThisScope = function() {
  for (var e28 = this.scopeStack.length - 1; ; e28--) {
    var t3 = this.scopeStack[e28];
    if (t3.flags & kd$1 && !(16 & t3.flags))
      return t3;
  }
};
var Rp = function(e28, t3, n3) {
  this.type = "", this.start = t3, this.end = 0, e28.options.locations && (this.loc = new kc$2(e28, n3)), e28.options.directSourceFile && (this.sourceFile = e28.options.directSourceFile), e28.options.ranges && (this.range = [t3, 0]);
}, jl = fn$1.prototype;
function Sx(e28, t3, n3, r3) {
  return e28.type = t3, e28.end = n3, this.options.locations && (e28.loc.end = r3), this.options.ranges && (e28.range[1] = n3), e28;
}
jl.startNode = function() {
  return new Rp(this, this.start, this.startLoc);
}, jl.startNodeAt = function(e28, t3) {
  return new Rp(this, e28, t3);
}, jl.finishNode = function(e28, t3) {
  return Sx.call(this, e28, t3, this.lastTokEnd, this.lastTokEndLoc);
}, jl.finishNodeAt = function(e28, t3, n3, r3) {
  return Sx.call(this, e28, t3, n3, r3);
};
var ei$1 = function(e28, t3, n3, r3, i) {
  this.token = e28, this.isExpr = !!t3, this.preserveSpace = !!n3, this.override = r3, this.generator = !!i;
}, yn$1 = { b_stat: new ei$1("{", false), b_expr: new ei$1("{", true), b_tmpl: new ei$1("${", false), p_stat: new ei$1("(", false), p_expr: new ei$1("(", true), q_tmpl: new ei$1("`", true, true, function(e28) {
  return e28.tryReadTemplateToken();
}), f_stat: new ei$1("function", false), f_expr: new ei$1("function", true), f_expr_gen: new ei$1("function", true, false, null, true), f_gen: new ei$1("function", false, false, null, true) }, Rl = fn$1.prototype;
Rl.initialContext = function() {
  return [yn$1.b_stat];
}, Rl.braceIsBlock = function(e28) {
  var t3 = this.curContext();
  return t3 === yn$1.f_expr || t3 === yn$1.f_stat || (e28 !== G$8.colon || t3 !== yn$1.b_stat && t3 !== yn$1.b_expr ? e28 === G$8._return || e28 === G$8.name && this.exprAllowed ? li$1.test(this.input.slice(this.lastTokEnd, this.start)) : e28 === G$8._else || e28 === G$8.semi || e28 === G$8.eof || e28 === G$8.parenR || e28 === G$8.arrow || (e28 === G$8.braceL ? t3 === yn$1.b_stat : e28 !== G$8._var && e28 !== G$8._const && e28 !== G$8.name && !this.exprAllowed) : !t3.isExpr);
}, Rl.inGeneratorContext = function() {
  for (var e28 = this.context.length - 1; e28 >= 1; e28--) {
    var t3 = this.context[e28];
    if (t3.token === "function")
      return t3.generator;
  }
  return false;
}, Rl.updateContext = function(e28) {
  var t3, n3 = this.type;
  n3.keyword && e28 === G$8.dot ? this.exprAllowed = false : (t3 = n3.updateContext) ? t3.call(this, e28) : this.exprAllowed = n3.beforeExpr;
}, G$8.parenR.updateContext = G$8.braceR.updateContext = function() {
  if (this.context.length !== 1) {
    var e28 = this.context.pop();
    e28 === yn$1.b_stat && this.curContext().token === "function" && (e28 = this.context.pop()), this.exprAllowed = !e28.isExpr;
  } else
    this.exprAllowed = true;
}, G$8.braceL.updateContext = function(e28) {
  this.context.push(this.braceIsBlock(e28) ? yn$1.b_stat : yn$1.b_expr), this.exprAllowed = true;
}, G$8.dollarBraceL.updateContext = function() {
  this.context.push(yn$1.b_tmpl), this.exprAllowed = true;
}, G$8.parenL.updateContext = function(e28) {
  var t3 = e28 === G$8._if || e28 === G$8._for || e28 === G$8._with || e28 === G$8._while;
  this.context.push(t3 ? yn$1.p_stat : yn$1.p_expr), this.exprAllowed = true;
}, G$8.incDec.updateContext = function() {
}, G$8._function.updateContext = G$8._class.updateContext = function(e28) {
  !e28.beforeExpr || e28 === G$8.semi || e28 === G$8._else || e28 === G$8._return && li$1.test(this.input.slice(this.lastTokEnd, this.start)) || (e28 === G$8.colon || e28 === G$8.braceL) && this.curContext() === yn$1.b_stat ? this.context.push(yn$1.f_stat) : this.context.push(yn$1.f_expr), this.exprAllowed = false;
}, G$8.backQuote.updateContext = function() {
  this.curContext() === yn$1.q_tmpl ? this.context.pop() : this.context.push(yn$1.q_tmpl), this.exprAllowed = false;
}, G$8.star.updateContext = function(e28) {
  if (e28 === G$8._function) {
    var t3 = this.context.length - 1;
    this.context[t3] === yn$1.f_expr ? this.context[t3] = yn$1.f_expr_gen : this.context[t3] = yn$1.f_gen;
  }
  this.exprAllowed = true;
}, G$8.name.updateContext = function(e28) {
  var t3 = false;
  this.options.ecmaVersion >= 6 && e28 !== G$8.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (t3 = true), this.exprAllowed = t3;
};
var pk = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", $9 = pk + " Extended_Pictographic", G9 = { 9: pk, 10: $9, 11: "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS Extended_Pictographic" }, kx = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", fk = "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", z9 = fk + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", H9 = { 9: fk, 10: z9, 11: "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho" }, hk = {};
function Dd$1(e28) {
  var t3 = hk[e28] = { binary: Oo$1(G9[e28] + " " + kx), nonBinary: { General_Category: Oo$1(kx), Script: Oo$1(H9[e28]) } };
  t3.nonBinary.Script_Extensions = t3.nonBinary.Script, t3.nonBinary.gc = t3.nonBinary.General_Category, t3.nonBinary.sc = t3.nonBinary.Script, t3.nonBinary.scx = t3.nonBinary.Script_Extensions;
}
Dd$1(9), Dd$1(10), Dd$1(11);
var Ke$1 = fn$1.prototype, da$3 = function(e28) {
  this.parser = e28, this.validFlags = "gim" + (e28.options.ecmaVersion >= 6 ? "uy" : "") + (e28.options.ecmaVersion >= 9 ? "s" : ""), this.unicodeProperties = hk[e28.options.ecmaVersion >= 11 ? 11 : e28.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = false, this.switchN = false, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = false, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = [], this.backReferenceNames = [];
};
function Ml(e28) {
  return e28 <= 65535 ? String.fromCharCode(e28) : (e28 -= 65536, String.fromCharCode(55296 + (e28 >> 10), 56320 + (1023 & e28)));
}
function Dx(e28) {
  return e28 === 36 || e28 >= 40 && e28 <= 43 || e28 === 46 || e28 === 63 || e28 >= 91 && e28 <= 94 || e28 >= 123 && e28 <= 125;
}
function dk(e28) {
  return e28 >= 65 && e28 <= 90 || e28 >= 97 && e28 <= 122;
}
function mk(e28) {
  return dk(e28) || e28 === 95;
}
function K9(e28) {
  return mk(e28) || up(e28);
}
function up(e28) {
  return e28 >= 48 && e28 <= 57;
}
function Fx(e28) {
  return e28 >= 48 && e28 <= 57 || e28 >= 65 && e28 <= 70 || e28 >= 97 && e28 <= 102;
}
function wx(e28) {
  return e28 >= 65 && e28 <= 70 ? e28 - 65 + 10 : e28 >= 97 && e28 <= 102 ? e28 - 97 + 10 : e28 - 48;
}
function Ax(e28) {
  return e28 >= 48 && e28 <= 55;
}
da$3.prototype.reset = function(e28, t3, n3) {
  var r3 = n3.indexOf("u") !== -1;
  this.start = 0 | e28, this.source = t3 + "", this.flags = n3, this.switchU = r3 && this.parser.options.ecmaVersion >= 6, this.switchN = r3 && this.parser.options.ecmaVersion >= 9;
}, da$3.prototype.raise = function(e28) {
  this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + e28);
}, da$3.prototype.at = function(e28) {
  var t3 = this.source, n3 = t3.length;
  if (e28 >= n3)
    return -1;
  var r3 = t3.charCodeAt(e28);
  return !this.switchU || r3 <= 55295 || r3 >= 57344 || e28 + 1 >= n3 ? r3 : (r3 << 10) + t3.charCodeAt(e28 + 1) - 56613888;
}, da$3.prototype.nextIndex = function(e28) {
  var t3 = this.source, n3 = t3.length;
  if (e28 >= n3)
    return n3;
  var r3 = t3.charCodeAt(e28);
  return !this.switchU || r3 <= 55295 || r3 >= 57344 || e28 + 1 >= n3 ? e28 + 1 : e28 + 2;
}, da$3.prototype.current = function() {
  return this.at(this.pos);
}, da$3.prototype.lookahead = function() {
  return this.at(this.nextIndex(this.pos));
}, da$3.prototype.advance = function() {
  this.pos = this.nextIndex(this.pos);
}, da$3.prototype.eat = function(e28) {
  return this.current() === e28 && (this.advance(), true);
}, Ke$1.validateRegExpFlags = function(e28) {
  for (var t3 = e28.validFlags, n3 = e28.flags, r3 = 0; r3 < n3.length; r3++) {
    var i = n3.charAt(r3);
    t3.indexOf(i) === -1 && this.raise(e28.start, "Invalid regular expression flag"), n3.indexOf(i, r3 + 1) > -1 && this.raise(e28.start, "Duplicate regular expression flag");
  }
}, Ke$1.validateRegExpPattern = function(e28) {
  this.regexp_pattern(e28), !e28.switchN && this.options.ecmaVersion >= 9 && e28.groupNames.length > 0 && (e28.switchN = true, this.regexp_pattern(e28));
}, Ke$1.regexp_pattern = function(e28) {
  e28.pos = 0, e28.lastIntValue = 0, e28.lastStringValue = "", e28.lastAssertionIsQuantifiable = false, e28.numCapturingParens = 0, e28.maxBackReference = 0, e28.groupNames.length = 0, e28.backReferenceNames.length = 0, this.regexp_disjunction(e28), e28.pos !== e28.source.length && (e28.eat(41) && e28.raise("Unmatched ')'"), (e28.eat(93) || e28.eat(125)) && e28.raise("Lone quantifier brackets")), e28.maxBackReference > e28.numCapturingParens && e28.raise("Invalid escape");
  for (var t3 = 0, n3 = e28.backReferenceNames; t3 < n3.length; t3 += 1) {
    var r3 = n3[t3];
    e28.groupNames.indexOf(r3) === -1 && e28.raise("Invalid named capture referenced");
  }
}, Ke$1.regexp_disjunction = function(e28) {
  for (this.regexp_alternative(e28); e28.eat(124); )
    this.regexp_alternative(e28);
  this.regexp_eatQuantifier(e28, true) && e28.raise("Nothing to repeat"), e28.eat(123) && e28.raise("Lone quantifier brackets");
}, Ke$1.regexp_alternative = function(e28) {
  for (; e28.pos < e28.source.length && this.regexp_eatTerm(e28); )
    ;
}, Ke$1.regexp_eatTerm = function(e28) {
  return this.regexp_eatAssertion(e28) ? (e28.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(e28) && e28.switchU && e28.raise("Invalid quantifier"), true) : !(e28.switchU ? !this.regexp_eatAtom(e28) : !this.regexp_eatExtendedAtom(e28)) && (this.regexp_eatQuantifier(e28), true);
}, Ke$1.regexp_eatAssertion = function(e28) {
  var t3 = e28.pos;
  if (e28.lastAssertionIsQuantifiable = false, e28.eat(94) || e28.eat(36))
    return true;
  if (e28.eat(92)) {
    if (e28.eat(66) || e28.eat(98))
      return true;
    e28.pos = t3;
  }
  if (e28.eat(40) && e28.eat(63)) {
    var n3 = false;
    if (this.options.ecmaVersion >= 9 && (n3 = e28.eat(60)), e28.eat(61) || e28.eat(33))
      return this.regexp_disjunction(e28), e28.eat(41) || e28.raise("Unterminated group"), e28.lastAssertionIsQuantifiable = !n3, true;
  }
  return e28.pos = t3, false;
}, Ke$1.regexp_eatQuantifier = function(e28, t3) {
  return t3 === void 0 && (t3 = false), !!this.regexp_eatQuantifierPrefix(e28, t3) && (e28.eat(63), true);
}, Ke$1.regexp_eatQuantifierPrefix = function(e28, t3) {
  return e28.eat(42) || e28.eat(43) || e28.eat(63) || this.regexp_eatBracedQuantifier(e28, t3);
}, Ke$1.regexp_eatBracedQuantifier = function(e28, t3) {
  var n3 = e28.pos;
  if (e28.eat(123)) {
    var r3 = 0, i = -1;
    if (this.regexp_eatDecimalDigits(e28) && (r3 = e28.lastIntValue, e28.eat(44) && this.regexp_eatDecimalDigits(e28) && (i = e28.lastIntValue), e28.eat(125)))
      return i !== -1 && i < r3 && !t3 && e28.raise("numbers out of order in {} quantifier"), true;
    e28.switchU && !t3 && e28.raise("Incomplete quantifier"), e28.pos = n3;
  }
  return false;
}, Ke$1.regexp_eatAtom = function(e28) {
  return this.regexp_eatPatternCharacters(e28) || e28.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e28) || this.regexp_eatCharacterClass(e28) || this.regexp_eatUncapturingGroup(e28) || this.regexp_eatCapturingGroup(e28);
}, Ke$1.regexp_eatReverseSolidusAtomEscape = function(e28) {
  var t3 = e28.pos;
  if (e28.eat(92)) {
    if (this.regexp_eatAtomEscape(e28))
      return true;
    e28.pos = t3;
  }
  return false;
}, Ke$1.regexp_eatUncapturingGroup = function(e28) {
  var t3 = e28.pos;
  if (e28.eat(40)) {
    if (e28.eat(63) && e28.eat(58)) {
      if (this.regexp_disjunction(e28), e28.eat(41))
        return true;
      e28.raise("Unterminated group");
    }
    e28.pos = t3;
  }
  return false;
}, Ke$1.regexp_eatCapturingGroup = function(e28) {
  if (e28.eat(40)) {
    if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(e28) : e28.current() === 63 && e28.raise("Invalid group"), this.regexp_disjunction(e28), e28.eat(41))
      return e28.numCapturingParens += 1, true;
    e28.raise("Unterminated group");
  }
  return false;
}, Ke$1.regexp_eatExtendedAtom = function(e28) {
  return e28.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e28) || this.regexp_eatCharacterClass(e28) || this.regexp_eatUncapturingGroup(e28) || this.regexp_eatCapturingGroup(e28) || this.regexp_eatInvalidBracedQuantifier(e28) || this.regexp_eatExtendedPatternCharacter(e28);
}, Ke$1.regexp_eatInvalidBracedQuantifier = function(e28) {
  return this.regexp_eatBracedQuantifier(e28, true) && e28.raise("Nothing to repeat"), false;
}, Ke$1.regexp_eatSyntaxCharacter = function(e28) {
  var t3 = e28.current();
  return !!Dx(t3) && (e28.lastIntValue = t3, e28.advance(), true);
}, Ke$1.regexp_eatPatternCharacters = function(e28) {
  for (var t3 = e28.pos, n3 = 0; (n3 = e28.current()) !== -1 && !Dx(n3); )
    e28.advance();
  return e28.pos !== t3;
}, Ke$1.regexp_eatExtendedPatternCharacter = function(e28) {
  var t3 = e28.current();
  return !(t3 === -1 || t3 === 36 || t3 >= 40 && t3 <= 43 || t3 === 46 || t3 === 63 || t3 === 91 || t3 === 94 || t3 === 124) && (e28.advance(), true);
}, Ke$1.regexp_groupSpecifier = function(e28) {
  if (e28.eat(63)) {
    if (this.regexp_eatGroupName(e28))
      return e28.groupNames.indexOf(e28.lastStringValue) !== -1 && e28.raise("Duplicate capture group name"), void e28.groupNames.push(e28.lastStringValue);
    e28.raise("Invalid group");
  }
}, Ke$1.regexp_eatGroupName = function(e28) {
  if (e28.lastStringValue = "", e28.eat(60)) {
    if (this.regexp_eatRegExpIdentifierName(e28) && e28.eat(62))
      return true;
    e28.raise("Invalid capture group name");
  }
  return false;
}, Ke$1.regexp_eatRegExpIdentifierName = function(e28) {
  if (e28.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(e28)) {
    for (e28.lastStringValue += Ml(e28.lastIntValue); this.regexp_eatRegExpIdentifierPart(e28); )
      e28.lastStringValue += Ml(e28.lastIntValue);
    return true;
  }
  return false;
}, Ke$1.regexp_eatRegExpIdentifierStart = function(e28) {
  var t3 = e28.pos, n3 = e28.current();
  return e28.advance(), n3 === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e28) && (n3 = e28.lastIntValue), function(r3) {
    return Ca$2(r3, true) || r3 === 36 || r3 === 95;
  }(n3) ? (e28.lastIntValue = n3, true) : (e28.pos = t3, false);
}, Ke$1.regexp_eatRegExpIdentifierPart = function(e28) {
  var t3 = e28.pos, n3 = e28.current();
  return e28.advance(), n3 === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e28) && (n3 = e28.lastIntValue), function(r3) {
    return Vo$1(r3, true) || r3 === 36 || r3 === 95 || r3 === 8204 || r3 === 8205;
  }(n3) ? (e28.lastIntValue = n3, true) : (e28.pos = t3, false);
}, Ke$1.regexp_eatAtomEscape = function(e28) {
  return !!(this.regexp_eatBackReference(e28) || this.regexp_eatCharacterClassEscape(e28) || this.regexp_eatCharacterEscape(e28) || e28.switchN && this.regexp_eatKGroupName(e28)) || (e28.switchU && (e28.current() === 99 && e28.raise("Invalid unicode escape"), e28.raise("Invalid escape")), false);
}, Ke$1.regexp_eatBackReference = function(e28) {
  var t3 = e28.pos;
  if (this.regexp_eatDecimalEscape(e28)) {
    var n3 = e28.lastIntValue;
    if (e28.switchU)
      return n3 > e28.maxBackReference && (e28.maxBackReference = n3), true;
    if (n3 <= e28.numCapturingParens)
      return true;
    e28.pos = t3;
  }
  return false;
}, Ke$1.regexp_eatKGroupName = function(e28) {
  if (e28.eat(107)) {
    if (this.regexp_eatGroupName(e28))
      return e28.backReferenceNames.push(e28.lastStringValue), true;
    e28.raise("Invalid named reference");
  }
  return false;
}, Ke$1.regexp_eatCharacterEscape = function(e28) {
  return this.regexp_eatControlEscape(e28) || this.regexp_eatCControlLetter(e28) || this.regexp_eatZero(e28) || this.regexp_eatHexEscapeSequence(e28) || this.regexp_eatRegExpUnicodeEscapeSequence(e28) || !e28.switchU && this.regexp_eatLegacyOctalEscapeSequence(e28) || this.regexp_eatIdentityEscape(e28);
}, Ke$1.regexp_eatCControlLetter = function(e28) {
  var t3 = e28.pos;
  if (e28.eat(99)) {
    if (this.regexp_eatControlLetter(e28))
      return true;
    e28.pos = t3;
  }
  return false;
}, Ke$1.regexp_eatZero = function(e28) {
  return e28.current() === 48 && !up(e28.lookahead()) && (e28.lastIntValue = 0, e28.advance(), true);
}, Ke$1.regexp_eatControlEscape = function(e28) {
  var t3 = e28.current();
  return t3 === 116 ? (e28.lastIntValue = 9, e28.advance(), true) : t3 === 110 ? (e28.lastIntValue = 10, e28.advance(), true) : t3 === 118 ? (e28.lastIntValue = 11, e28.advance(), true) : t3 === 102 ? (e28.lastIntValue = 12, e28.advance(), true) : t3 === 114 && (e28.lastIntValue = 13, e28.advance(), true);
}, Ke$1.regexp_eatControlLetter = function(e28) {
  var t3 = e28.current();
  return !!dk(t3) && (e28.lastIntValue = t3 % 32, e28.advance(), true);
}, Ke$1.regexp_eatRegExpUnicodeEscapeSequence = function(e28) {
  var t3, n3 = e28.pos;
  if (e28.eat(117)) {
    if (this.regexp_eatFixedHexDigits(e28, 4)) {
      var r3 = e28.lastIntValue;
      if (e28.switchU && r3 >= 55296 && r3 <= 56319) {
        var i = e28.pos;
        if (e28.eat(92) && e28.eat(117) && this.regexp_eatFixedHexDigits(e28, 4)) {
          var a3 = e28.lastIntValue;
          if (a3 >= 56320 && a3 <= 57343)
            return e28.lastIntValue = 1024 * (r3 - 55296) + (a3 - 56320) + 65536, true;
        }
        e28.pos = i, e28.lastIntValue = r3;
      }
      return true;
    }
    if (e28.switchU && e28.eat(123) && this.regexp_eatHexDigits(e28) && e28.eat(125) && (t3 = e28.lastIntValue) >= 0 && t3 <= 1114111)
      return true;
    e28.switchU && e28.raise("Invalid unicode escape"), e28.pos = n3;
  }
  return false;
}, Ke$1.regexp_eatIdentityEscape = function(e28) {
  if (e28.switchU)
    return !!this.regexp_eatSyntaxCharacter(e28) || !!e28.eat(47) && (e28.lastIntValue = 47, true);
  var t3 = e28.current();
  return !(t3 === 99 || e28.switchN && t3 === 107) && (e28.lastIntValue = t3, e28.advance(), true);
}, Ke$1.regexp_eatDecimalEscape = function(e28) {
  e28.lastIntValue = 0;
  var t3 = e28.current();
  if (t3 >= 49 && t3 <= 57) {
    do
      e28.lastIntValue = 10 * e28.lastIntValue + (t3 - 48), e28.advance();
    while ((t3 = e28.current()) >= 48 && t3 <= 57);
    return true;
  }
  return false;
}, Ke$1.regexp_eatCharacterClassEscape = function(e28) {
  var t3 = e28.current();
  if (function(n3) {
    return n3 === 100 || n3 === 68 || n3 === 115 || n3 === 83 || n3 === 119 || n3 === 87;
  }(t3))
    return e28.lastIntValue = -1, e28.advance(), true;
  if (e28.switchU && this.options.ecmaVersion >= 9 && (t3 === 80 || t3 === 112)) {
    if (e28.lastIntValue = -1, e28.advance(), e28.eat(123) && this.regexp_eatUnicodePropertyValueExpression(e28) && e28.eat(125))
      return true;
    e28.raise("Invalid property name");
  }
  return false;
}, Ke$1.regexp_eatUnicodePropertyValueExpression = function(e28) {
  var t3 = e28.pos;
  if (this.regexp_eatUnicodePropertyName(e28) && e28.eat(61)) {
    var n3 = e28.lastStringValue;
    if (this.regexp_eatUnicodePropertyValue(e28)) {
      var r3 = e28.lastStringValue;
      return this.regexp_validateUnicodePropertyNameAndValue(e28, n3, r3), true;
    }
  }
  if (e28.pos = t3, this.regexp_eatLoneUnicodePropertyNameOrValue(e28)) {
    var i = e28.lastStringValue;
    return this.regexp_validateUnicodePropertyNameOrValue(e28, i), true;
  }
  return false;
}, Ke$1.regexp_validateUnicodePropertyNameAndValue = function(e28, t3, n3) {
  mf(e28.unicodeProperties.nonBinary, t3) || e28.raise("Invalid property name"), e28.unicodeProperties.nonBinary[t3].test(n3) || e28.raise("Invalid property value");
}, Ke$1.regexp_validateUnicodePropertyNameOrValue = function(e28, t3) {
  e28.unicodeProperties.binary.test(t3) || e28.raise("Invalid property name");
}, Ke$1.regexp_eatUnicodePropertyName = function(e28) {
  var t3 = 0;
  for (e28.lastStringValue = ""; mk(t3 = e28.current()); )
    e28.lastStringValue += Ml(t3), e28.advance();
  return e28.lastStringValue !== "";
}, Ke$1.regexp_eatUnicodePropertyValue = function(e28) {
  var t3 = 0;
  for (e28.lastStringValue = ""; K9(t3 = e28.current()); )
    e28.lastStringValue += Ml(t3), e28.advance();
  return e28.lastStringValue !== "";
}, Ke$1.regexp_eatLoneUnicodePropertyNameOrValue = function(e28) {
  return this.regexp_eatUnicodePropertyValue(e28);
}, Ke$1.regexp_eatCharacterClass = function(e28) {
  if (e28.eat(91)) {
    if (e28.eat(94), this.regexp_classRanges(e28), e28.eat(93))
      return true;
    e28.raise("Unterminated character class");
  }
  return false;
}, Ke$1.regexp_classRanges = function(e28) {
  for (; this.regexp_eatClassAtom(e28); ) {
    var t3 = e28.lastIntValue;
    if (e28.eat(45) && this.regexp_eatClassAtom(e28)) {
      var n3 = e28.lastIntValue;
      !e28.switchU || t3 !== -1 && n3 !== -1 || e28.raise("Invalid character class"), t3 !== -1 && n3 !== -1 && t3 > n3 && e28.raise("Range out of order in character class");
    }
  }
}, Ke$1.regexp_eatClassAtom = function(e28) {
  var t3 = e28.pos;
  if (e28.eat(92)) {
    if (this.regexp_eatClassEscape(e28))
      return true;
    if (e28.switchU) {
      var n3 = e28.current();
      (n3 === 99 || Ax(n3)) && e28.raise("Invalid class escape"), e28.raise("Invalid escape");
    }
    e28.pos = t3;
  }
  var r3 = e28.current();
  return r3 !== 93 && (e28.lastIntValue = r3, e28.advance(), true);
}, Ke$1.regexp_eatClassEscape = function(e28) {
  var t3 = e28.pos;
  if (e28.eat(98))
    return e28.lastIntValue = 8, true;
  if (e28.switchU && e28.eat(45))
    return e28.lastIntValue = 45, true;
  if (!e28.switchU && e28.eat(99)) {
    if (this.regexp_eatClassControlLetter(e28))
      return true;
    e28.pos = t3;
  }
  return this.regexp_eatCharacterClassEscape(e28) || this.regexp_eatCharacterEscape(e28);
}, Ke$1.regexp_eatClassControlLetter = function(e28) {
  var t3 = e28.current();
  return !(!up(t3) && t3 !== 95) && (e28.lastIntValue = t3 % 32, e28.advance(), true);
}, Ke$1.regexp_eatHexEscapeSequence = function(e28) {
  var t3 = e28.pos;
  if (e28.eat(120)) {
    if (this.regexp_eatFixedHexDigits(e28, 2))
      return true;
    e28.switchU && e28.raise("Invalid escape"), e28.pos = t3;
  }
  return false;
}, Ke$1.regexp_eatDecimalDigits = function(e28) {
  var t3 = e28.pos, n3 = 0;
  for (e28.lastIntValue = 0; up(n3 = e28.current()); )
    e28.lastIntValue = 10 * e28.lastIntValue + (n3 - 48), e28.advance();
  return e28.pos !== t3;
}, Ke$1.regexp_eatHexDigits = function(e28) {
  var t3 = e28.pos, n3 = 0;
  for (e28.lastIntValue = 0; Fx(n3 = e28.current()); )
    e28.lastIntValue = 16 * e28.lastIntValue + wx(n3), e28.advance();
  return e28.pos !== t3;
}, Ke$1.regexp_eatLegacyOctalEscapeSequence = function(e28) {
  if (this.regexp_eatOctalDigit(e28)) {
    var t3 = e28.lastIntValue;
    if (this.regexp_eatOctalDigit(e28)) {
      var n3 = e28.lastIntValue;
      t3 <= 3 && this.regexp_eatOctalDigit(e28) ? e28.lastIntValue = 64 * t3 + 8 * n3 + e28.lastIntValue : e28.lastIntValue = 8 * t3 + n3;
    } else
      e28.lastIntValue = t3;
    return true;
  }
  return false;
}, Ke$1.regexp_eatOctalDigit = function(e28) {
  var t3 = e28.current();
  return Ax(t3) ? (e28.lastIntValue = t3 - 48, e28.advance(), true) : (e28.lastIntValue = 0, false);
}, Ke$1.regexp_eatFixedHexDigits = function(e28, t3) {
  var n3 = e28.pos;
  e28.lastIntValue = 0;
  for (var r3 = 0; r3 < t3; ++r3) {
    var i = e28.current();
    if (!Fx(i))
      return e28.pos = n3, false;
    e28.lastIntValue = 16 * e28.lastIntValue + wx(i), e28.advance();
  }
  return true;
};
var Mp = function(e28) {
  this.type = e28.type, this.value = e28.value, this.start = e28.start, this.end = e28.end, e28.options.locations && (this.loc = new kc$2(e28, e28.startLoc, e28.endLoc)), e28.options.ranges && (this.range = [e28.start, e28.end]);
}, wt$3 = fn$1.prototype;
function Um(e28) {
  return e28 <= 65535 ? String.fromCharCode(e28) : (e28 -= 65536, String.fromCharCode(55296 + (e28 >> 10), 56320 + (1023 & e28)));
}
wt$3.next = function() {
  this.options.onToken && this.options.onToken(new Mp(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
}, wt$3.getToken = function() {
  return this.next(), new Mp(this);
}, typeof Symbol < "u" && (wt$3[Symbol.iterator] = function() {
  var e28 = this;
  return { next: function() {
    var t3 = e28.getToken();
    return { done: t3.type === G$8.eof, value: t3 };
  } };
}), wt$3.curContext = function() {
  return this.context[this.context.length - 1];
}, wt$3.nextToken = function() {
  var e28 = this.curContext();
  return e28 && e28.preserveSpace || this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length ? this.finishToken(G$8.eof) : e28.override ? e28.override(this) : void this.readToken(this.fullCharCodeAtPos());
}, wt$3.readToken = function(e28) {
  return Ca$2(e28, this.options.ecmaVersion >= 6) || e28 === 92 ? this.readWord() : this.getTokenFromCode(e28);
}, wt$3.fullCharCodeAtPos = function() {
  var e28 = this.input.charCodeAt(this.pos);
  return e28 <= 55295 || e28 >= 57344 ? e28 : (e28 << 10) + this.input.charCodeAt(this.pos + 1) - 56613888;
}, wt$3.skipBlockComment = function() {
  var e28, t3 = this.options.onComment && this.curPosition(), n3 = this.pos, r3 = this.input.indexOf("*/", this.pos += 2);
  if (r3 === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = r3 + 2, this.options.locations)
    for (Gs$1.lastIndex = n3; (e28 = Gs$1.exec(this.input)) && e28.index < this.pos; )
      ++this.curLine, this.lineStart = e28.index + e28[0].length;
  this.options.onComment && this.options.onComment(true, this.input.slice(n3 + 2, r3), n3, this.pos, t3, this.curPosition());
}, wt$3.skipLineComment = function(e28) {
  for (var t3 = this.pos, n3 = this.options.onComment && this.curPosition(), r3 = this.input.charCodeAt(this.pos += e28); this.pos < this.input.length && !zs$1(r3); )
    r3 = this.input.charCodeAt(++this.pos);
  this.options.onComment && this.options.onComment(false, this.input.slice(t3 + e28, this.pos), t3, this.pos, n3, this.curPosition());
}, wt$3.skipSpace = function() {
  e:
    for (; this.pos < this.input.length; ) {
      var e28 = this.input.charCodeAt(this.pos);
      switch (e28) {
        case 32:
        case 160:
          ++this.pos;
          break;
        case 13:
          this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
        case 10:
        case 8232:
        case 8233:
          ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
          break;
        case 47:
          switch (this.input.charCodeAt(this.pos + 1)) {
            case 42:
              this.skipBlockComment();
              break;
            case 47:
              this.skipLineComment(2);
              break;
            default:
              break e;
          }
          break;
        default:
          if (!(e28 > 8 && e28 < 14 || e28 >= 5760 && G0.test(String.fromCharCode(e28))))
            break e;
          ++this.pos;
      }
    }
}, wt$3.finishToken = function(e28, t3) {
  this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
  var n3 = this.type;
  this.type = e28, this.value = t3, this.updateContext(n3);
}, wt$3.readToken_dot = function() {
  var e28 = this.input.charCodeAt(this.pos + 1);
  if (e28 >= 48 && e28 <= 57)
    return this.readNumber(true);
  var t3 = this.input.charCodeAt(this.pos + 2);
  return this.options.ecmaVersion >= 6 && e28 === 46 && t3 === 46 ? (this.pos += 3, this.finishToken(G$8.ellipsis)) : (++this.pos, this.finishToken(G$8.dot));
}, wt$3.readToken_slash = function() {
  var e28 = this.input.charCodeAt(this.pos + 1);
  return this.exprAllowed ? (++this.pos, this.readRegexp()) : e28 === 61 ? this.finishOp(G$8.assign, 2) : this.finishOp(G$8.slash, 1);
}, wt$3.readToken_mult_modulo_exp = function(e28) {
  var t3 = this.input.charCodeAt(this.pos + 1), n3 = 1, r3 = e28 === 42 ? G$8.star : G$8.modulo;
  return this.options.ecmaVersion >= 7 && e28 === 42 && t3 === 42 && (++n3, r3 = G$8.starstar, t3 = this.input.charCodeAt(this.pos + 2)), t3 === 61 ? this.finishOp(G$8.assign, n3 + 1) : this.finishOp(r3, n3);
}, wt$3.readToken_pipe_amp = function(e28) {
  var t3 = this.input.charCodeAt(this.pos + 1);
  return t3 === e28 ? this.finishOp(e28 === 124 ? G$8.logicalOR : G$8.logicalAND, 2) : t3 === 61 ? this.finishOp(G$8.assign, 2) : this.finishOp(e28 === 124 ? G$8.bitwiseOR : G$8.bitwiseAND, 1);
}, wt$3.readToken_caret = function() {
  return this.input.charCodeAt(this.pos + 1) === 61 ? this.finishOp(G$8.assign, 2) : this.finishOp(G$8.bitwiseXOR, 1);
}, wt$3.readToken_plus_min = function(e28) {
  var t3 = this.input.charCodeAt(this.pos + 1);
  return t3 === e28 ? t3 !== 45 || this.inModule || this.input.charCodeAt(this.pos + 2) !== 62 || this.lastTokEnd !== 0 && !li$1.test(this.input.slice(this.lastTokEnd, this.pos)) ? this.finishOp(G$8.incDec, 2) : (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : t3 === 61 ? this.finishOp(G$8.assign, 2) : this.finishOp(G$8.plusMin, 1);
}, wt$3.readToken_lt_gt = function(e28) {
  var t3 = this.input.charCodeAt(this.pos + 1), n3 = 1;
  return t3 === e28 ? (n3 = e28 === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + n3) === 61 ? this.finishOp(G$8.assign, n3 + 1) : this.finishOp(G$8.bitShift, n3)) : t3 !== 33 || e28 !== 60 || this.inModule || this.input.charCodeAt(this.pos + 2) !== 45 || this.input.charCodeAt(this.pos + 3) !== 45 ? (t3 === 61 && (n3 = 2), this.finishOp(G$8.relational, n3)) : (this.skipLineComment(4), this.skipSpace(), this.nextToken());
}, wt$3.readToken_eq_excl = function(e28) {
  var t3 = this.input.charCodeAt(this.pos + 1);
  return t3 === 61 ? this.finishOp(G$8.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : e28 === 61 && t3 === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(G$8.arrow)) : this.finishOp(e28 === 61 ? G$8.eq : G$8.prefix, 1);
}, wt$3.getTokenFromCode = function(e28) {
  switch (e28) {
    case 46:
      return this.readToken_dot();
    case 40:
      return ++this.pos, this.finishToken(G$8.parenL);
    case 41:
      return ++this.pos, this.finishToken(G$8.parenR);
    case 59:
      return ++this.pos, this.finishToken(G$8.semi);
    case 44:
      return ++this.pos, this.finishToken(G$8.comma);
    case 91:
      return ++this.pos, this.finishToken(G$8.bracketL);
    case 93:
      return ++this.pos, this.finishToken(G$8.bracketR);
    case 123:
      return ++this.pos, this.finishToken(G$8.braceL);
    case 125:
      return ++this.pos, this.finishToken(G$8.braceR);
    case 58:
      return ++this.pos, this.finishToken(G$8.colon);
    case 63:
      return ++this.pos, this.finishToken(G$8.question);
    case 96:
      if (this.options.ecmaVersion < 6)
        break;
      return ++this.pos, this.finishToken(G$8.backQuote);
    case 48:
      var t3 = this.input.charCodeAt(this.pos + 1);
      if (t3 === 120 || t3 === 88)
        return this.readRadixNumber(16);
      if (this.options.ecmaVersion >= 6) {
        if (t3 === 111 || t3 === 79)
          return this.readRadixNumber(8);
        if (t3 === 98 || t3 === 66)
          return this.readRadixNumber(2);
      }
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return this.readNumber(false);
    case 34:
    case 39:
      return this.readString(e28);
    case 47:
      return this.readToken_slash();
    case 37:
    case 42:
      return this.readToken_mult_modulo_exp(e28);
    case 124:
    case 38:
      return this.readToken_pipe_amp(e28);
    case 94:
      return this.readToken_caret();
    case 43:
    case 45:
      return this.readToken_plus_min(e28);
    case 60:
    case 62:
      return this.readToken_lt_gt(e28);
    case 61:
    case 33:
      return this.readToken_eq_excl(e28);
    case 126:
      return this.finishOp(G$8.prefix, 1);
  }
  this.raise(this.pos, "Unexpected character '" + Um(e28) + "'");
}, wt$3.finishOp = function(e28, t3) {
  var n3 = this.input.slice(this.pos, this.pos + t3);
  return this.pos += t3, this.finishToken(e28, n3);
}, wt$3.readRegexp = function() {
  for (var e28, t3, n3 = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(n3, "Unterminated regular expression");
    var r3 = this.input.charAt(this.pos);
    if (li$1.test(r3) && this.raise(n3, "Unterminated regular expression"), e28)
      e28 = false;
    else {
      if (r3 === "[")
        t3 = true;
      else if (r3 === "]" && t3)
        t3 = false;
      else if (r3 === "/" && !t3)
        break;
      e28 = r3 === "\\";
    }
    ++this.pos;
  }
  var i = this.input.slice(n3, this.pos);
  ++this.pos;
  var a3 = this.pos, s3 = this.readWord1();
  this.containsEsc && this.unexpected(a3);
  var o3 = this.regexpState || (this.regexpState = new da$3(this));
  o3.reset(n3, i, s3), this.validateRegExpFlags(o3), this.validateRegExpPattern(o3);
  var u3 = null;
  try {
    u3 = new RegExp(i, s3);
  } catch {
  }
  return this.finishToken(G$8.regexp, { pattern: i, flags: s3, value: u3 });
}, wt$3.readInt = function(e28, t3) {
  for (var n3 = this.pos, r3 = 0, i = 0, a3 = t3 != null ? t3 : 1 / 0; i < a3; ++i) {
    var s3 = this.input.charCodeAt(this.pos), o3 = void 0;
    if ((o3 = s3 >= 97 ? s3 - 97 + 10 : s3 >= 65 ? s3 - 65 + 10 : s3 >= 48 && s3 <= 57 ? s3 - 48 : 1 / 0) >= e28)
      break;
    ++this.pos, r3 = r3 * e28 + o3;
  }
  return this.pos === n3 || t3 != null && this.pos - n3 !== t3 ? null : r3;
}, wt$3.readRadixNumber = function(e28) {
  var t3 = this.pos;
  this.pos += 2;
  var n3 = this.readInt(e28);
  return n3 == null && this.raise(this.start + 2, "Expected number in radix " + e28), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (n3 = typeof BigInt < "u" ? BigInt(this.input.slice(t3, this.pos)) : null, ++this.pos) : Ca$2(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(G$8.num, n3);
}, wt$3.readNumber = function(e28) {
  var t3 = this.pos;
  e28 || this.readInt(10) !== null || this.raise(t3, "Invalid number");
  var n3 = this.pos - t3 >= 2 && this.input.charCodeAt(t3) === 48;
  n3 && this.strict && this.raise(t3, "Invalid number"), n3 && /[89]/.test(this.input.slice(t3, this.pos)) && (n3 = false);
  var r3 = this.input.charCodeAt(this.pos);
  if (!n3 && !e28 && this.options.ecmaVersion >= 11 && r3 === 110) {
    var i = this.input.slice(t3, this.pos), a3 = typeof BigInt < "u" ? BigInt(i) : null;
    return ++this.pos, Ca$2(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(G$8.num, a3);
  }
  r3 !== 46 || n3 || (++this.pos, this.readInt(10), r3 = this.input.charCodeAt(this.pos)), r3 !== 69 && r3 !== 101 || n3 || ((r3 = this.input.charCodeAt(++this.pos)) !== 43 && r3 !== 45 || ++this.pos, this.readInt(10) === null && this.raise(t3, "Invalid number")), Ca$2(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
  var s3 = this.input.slice(t3, this.pos), o3 = n3 ? parseInt(s3, 8) : parseFloat(s3);
  return this.finishToken(G$8.num, o3);
}, wt$3.readCodePoint = function() {
  var e28;
  if (this.input.charCodeAt(this.pos) === 123) {
    this.options.ecmaVersion < 6 && this.unexpected();
    var t3 = ++this.pos;
    e28 = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, e28 > 1114111 && this.invalidStringToken(t3, "Code point out of bounds");
  } else
    e28 = this.readHexChar(4);
  return e28;
}, wt$3.readString = function(e28) {
  for (var t3 = "", n3 = ++this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
    var r3 = this.input.charCodeAt(this.pos);
    if (r3 === e28)
      break;
    r3 === 92 ? (t3 += this.input.slice(n3, this.pos), t3 += this.readEscapedChar(false), n3 = this.pos) : (zs$1(r3, this.options.ecmaVersion >= 10) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
  }
  return t3 += this.input.slice(n3, this.pos++), this.finishToken(G$8.string, t3);
};
var _x = {};
wt$3.tryReadTemplateToken = function() {
  this.inTemplateElement = true;
  try {
    this.readTmplToken();
  } catch (e28) {
    if (e28 !== _x)
      throw e28;
    this.readInvalidTemplateToken();
  }
  this.inTemplateElement = false;
}, wt$3.invalidStringToken = function(e28, t3) {
  if (this.inTemplateElement && this.options.ecmaVersion >= 9)
    throw _x;
  this.raise(e28, t3);
}, wt$3.readTmplToken = function() {
  for (var e28 = "", t3 = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
    var n3 = this.input.charCodeAt(this.pos);
    if (n3 === 96 || n3 === 36 && this.input.charCodeAt(this.pos + 1) === 123)
      return this.pos !== this.start || this.type !== G$8.template && this.type !== G$8.invalidTemplate ? (e28 += this.input.slice(t3, this.pos), this.finishToken(G$8.template, e28)) : n3 === 36 ? (this.pos += 2, this.finishToken(G$8.dollarBraceL)) : (++this.pos, this.finishToken(G$8.backQuote));
    if (n3 === 92)
      e28 += this.input.slice(t3, this.pos), e28 += this.readEscapedChar(true), t3 = this.pos;
    else if (zs$1(n3)) {
      switch (e28 += this.input.slice(t3, this.pos), ++this.pos, n3) {
        case 13:
          this.input.charCodeAt(this.pos) === 10 && ++this.pos;
        case 10:
          e28 += `
`;
          break;
        default:
          e28 += String.fromCharCode(n3);
      }
      this.options.locations && (++this.curLine, this.lineStart = this.pos), t3 = this.pos;
    } else
      ++this.pos;
  }
}, wt$3.readInvalidTemplateToken = function() {
  for (; this.pos < this.input.length; this.pos++)
    switch (this.input[this.pos]) {
      case "\\":
        ++this.pos;
        break;
      case "$":
        if (this.input[this.pos + 1] !== "{")
          break;
      case "`":
        return this.finishToken(G$8.invalidTemplate, this.input.slice(this.start, this.pos));
    }
  this.raise(this.start, "Unterminated template");
}, wt$3.readEscapedChar = function(e28) {
  var t3 = this.input.charCodeAt(++this.pos);
  switch (++this.pos, t3) {
    case 110:
      return `
`;
    case 114:
      return "\r";
    case 120:
      return String.fromCharCode(this.readHexChar(2));
    case 117:
      return Um(this.readCodePoint());
    case 116:
      return "	";
    case 98:
      return "\b";
    case 118:
      return "\v";
    case 102:
      return "\f";
    case 13:
      this.input.charCodeAt(this.pos) === 10 && ++this.pos;
    case 10:
      return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
    default:
      if (t3 >= 48 && t3 <= 55) {
        var n3 = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], r3 = parseInt(n3, 8);
        return r3 > 255 && (n3 = n3.slice(0, -1), r3 = parseInt(n3, 8)), this.pos += n3.length - 1, t3 = this.input.charCodeAt(this.pos), n3 === "0" && t3 !== 56 && t3 !== 57 || !this.strict && !e28 || this.invalidStringToken(this.pos - 1 - n3.length, e28 ? "Octal literal in template string" : "Octal literal in strict mode"), String.fromCharCode(r3);
      }
      return zs$1(t3) ? "" : String.fromCharCode(t3);
  }
}, wt$3.readHexChar = function(e28) {
  var t3 = this.pos, n3 = this.readInt(16, e28);
  return n3 === null && this.invalidStringToken(t3, "Bad character escape sequence"), n3;
}, wt$3.readWord1 = function() {
  this.containsEsc = false;
  for (var e28 = "", t3 = true, n3 = this.pos, r3 = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
    var i = this.fullCharCodeAtPos();
    if (Vo$1(i, r3))
      this.pos += i <= 65535 ? 1 : 2;
    else {
      if (i !== 92)
        break;
      this.containsEsc = true, e28 += this.input.slice(n3, this.pos);
      var a3 = this.pos;
      this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
      var s3 = this.readCodePoint();
      (t3 ? Ca$2 : Vo$1)(s3, r3) || this.invalidStringToken(a3, "Invalid Unicode escape"), e28 += Um(s3), n3 = this.pos;
    }
    t3 = false;
  }
  return e28 + this.input.slice(n3, this.pos);
}, wt$3.readWord = function() {
  var e28 = this.readWord1(), t3 = G$8.name;
  return this.keywords.test(e28) && (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + e28), t3 = df[e28]), this.finishToken(t3, e28);
};
fn$1.acorn = { Parser: fn$1, version: "6.4.0", defaultOptions: jp, Position: Hs$1, SourceLocation: kc$2, getLineInfo: z0, Node: Rp, TokenType: Lt$1, tokTypes: G$8, keywordTypes: df, TokContext: ei$1, tokContexts: yn$1, isIdentifierChar: Vo$1, isIdentifierStart: Ca$2, Token: Mp, isNewLine: zs$1, lineBreak: li$1, lineBreakG: Gs$1, nonASCIIwhitespace: G0 };
var Tx = Cr$1(Object.freeze({ __proto__: null, Node: Rp, Parser: fn$1, Position: Hs$1, SourceLocation: kc$2, TokContext: ei$1, Token: Mp, TokenType: Lt$1, defaultOptions: jp, getLineInfo: z0, isIdentifierChar: Vo$1, isIdentifierStart: Ca$2, isNewLine: zs$1, keywordTypes: df, lineBreak: li$1, lineBreakG: Gs$1, nonASCIIwhitespace: G0, parse: function(e28, t3) {
  return fn$1.parse(e28, t3);
}, parseExpressionAt: function(e28, t3, n3) {
  return fn$1.parseExpressionAt(e28, t3, n3);
}, tokContexts: yn$1, tokTypes: G$8, tokenizer: function(e28, t3) {
  return fn$1.tokenizer(e28, t3);
}, version: "6.4.0" })), J9 = gt$3(function(e28) {
  var t3 = /^[\da-fA-F]+$/, n3 = /^\d+$/, r3 = /* @__PURE__ */ new WeakMap();
  function i(s3) {
    s3 = s3.Parser.acorn || s3;
    var o3 = r3.get(s3);
    if (!o3) {
      var u3 = s3.tokTypes, c3 = s3.TokContext, f3 = s3.TokenType, p3 = new c3("<tag", false), d3 = new c3("</tag", false), m3 = new c3("<tag>...</tag>", true, true), y3 = { tc_oTag: p3, tc_cTag: d3, tc_expr: m3 }, v3 = { jsxName: new f3("jsxName"), jsxText: new f3("jsxText", { beforeExpr: true }), jsxTagStart: new f3("jsxTagStart"), jsxTagEnd: new f3("jsxTagEnd") };
      v3.jsxTagStart.updateContext = function() {
        this.context.push(m3), this.context.push(p3), this.exprAllowed = false;
      }, v3.jsxTagEnd.updateContext = function(b3) {
        var x3 = this.context.pop();
        x3 === p3 && b3 === u3.slash || x3 === d3 ? (this.context.pop(), this.exprAllowed = this.curContext() === m3) : this.exprAllowed = true;
      }, o3 = { tokContexts: y3, tokTypes: v3 }, r3.set(s3, o3);
    }
    return o3;
  }
  function a3(s3) {
    return s3 && (s3.type === "JSXIdentifier" ? s3.name : s3.type === "JSXNamespacedName" ? s3.namespace.name + ":" + s3.name.name : s3.type === "JSXMemberExpression" ? a3(s3.object) + "." + a3(s3.property) : void 0);
  }
  e28.exports = function(s3) {
    return s3 = s3 || {}, function(o3) {
      return function(u3, c3) {
        var f3 = c3.acorn || Tx, p3 = i(f3), d3 = f3.tokTypes, m3 = p3.tokTypes, y3 = f3.tokContexts, v3 = p3.tokContexts.tc_oTag, b3 = p3.tokContexts.tc_cTag, x3 = p3.tokContexts.tc_expr, C3 = f3.isNewLine, k3 = f3.isIdentifierStart, F3 = f3.isIdentifierChar;
        return function(B3) {
          function O3() {
            return We$1(this, O3), Gt$3(this, rt$2(O3).apply(this, arguments));
          }
          return $t$3(O3, B3), Xe$1(O3, [{ key: "jsx_readToken", value: function() {
            for (var S3 = "", w3 = this.pos; ; ) {
              this.pos >= this.input.length && this.raise(this.start, "Unterminated JSX contents");
              var D3 = this.input.charCodeAt(this.pos);
              switch (D3) {
                case 60:
                case 123:
                  return this.pos === this.start ? D3 === 60 && this.exprAllowed ? (++this.pos, this.finishToken(m3.jsxTagStart)) : this.getTokenFromCode(D3) : (S3 += this.input.slice(w3, this.pos), this.finishToken(m3.jsxText, S3));
                case 38:
                  S3 += this.input.slice(w3, this.pos), S3 += this.jsx_readEntity(), w3 = this.pos;
                  break;
                default:
                  C3(D3) ? (S3 += this.input.slice(w3, this.pos), S3 += this.jsx_readNewLine(true), w3 = this.pos) : ++this.pos;
              }
            }
          } }, { key: "jsx_readNewLine", value: function(S3) {
            var w3, D3 = this.input.charCodeAt(this.pos);
            return ++this.pos, D3 === 13 && this.input.charCodeAt(this.pos) === 10 ? (++this.pos, w3 = S3 ? `
` : `\r
`) : w3 = String.fromCharCode(D3), this.options.locations && (++this.curLine, this.lineStart = this.pos), w3;
          } }, { key: "jsx_readString", value: function(S3) {
            for (var w3 = "", D3 = ++this.pos; ; ) {
              this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
              var I3 = this.input.charCodeAt(this.pos);
              if (I3 === S3)
                break;
              I3 === 38 ? (w3 += this.input.slice(D3, this.pos), w3 += this.jsx_readEntity(), D3 = this.pos) : C3(I3) ? (w3 += this.input.slice(D3, this.pos), w3 += this.jsx_readNewLine(false), D3 = this.pos) : ++this.pos;
            }
            return w3 += this.input.slice(D3, this.pos++), this.finishToken(d3.string, w3);
          } }, { key: "jsx_readEntity", value: function() {
            var S3, w3 = "", D3 = 0, I3 = this.input[this.pos];
            I3 !== "&" && this.raise(this.pos, "Entity must start with an ampersand");
            for (var L3 = ++this.pos; this.pos < this.input.length && D3++ < 10; ) {
              if ((I3 = this.input[this.pos++]) === ";") {
                w3[0] === "#" ? w3[1] === "x" ? (w3 = w3.substr(2), t3.test(w3) && (S3 = String.fromCharCode(parseInt(w3, 16)))) : (w3 = w3.substr(1), n3.test(w3) && (S3 = String.fromCharCode(parseInt(w3, 10)))) : S3 = T9[w3];
                break;
              }
              w3 += I3;
            }
            return S3 || (this.pos = L3, "&");
          } }, { key: "jsx_readWord", value: function() {
            var S3, w3 = this.pos;
            do
              S3 = this.input.charCodeAt(++this.pos);
            while (F3(S3) || S3 === 45);
            return this.finishToken(m3.jsxName, this.input.slice(w3, this.pos));
          } }, { key: "jsx_parseIdentifier", value: function() {
            var S3 = this.startNode();
            return this.type === m3.jsxName ? S3.name = this.value : this.type.keyword ? S3.name = this.type.keyword : this.unexpected(), this.next(), this.finishNode(S3, "JSXIdentifier");
          } }, { key: "jsx_parseNamespacedName", value: function() {
            var S3 = this.start, w3 = this.startLoc, D3 = this.jsx_parseIdentifier();
            if (!u3.allowNamespaces || !this.eat(d3.colon))
              return D3;
            var I3 = this.startNodeAt(S3, w3);
            return I3.namespace = D3, I3.name = this.jsx_parseIdentifier(), this.finishNode(I3, "JSXNamespacedName");
          } }, { key: "jsx_parseElementName", value: function() {
            if (this.type === m3.jsxTagEnd)
              return "";
            var S3 = this.start, w3 = this.startLoc, D3 = this.jsx_parseNamespacedName();
            for (this.type !== d3.dot || D3.type !== "JSXNamespacedName" || u3.allowNamespacedObjects || this.unexpected(); this.eat(d3.dot); ) {
              var I3 = this.startNodeAt(S3, w3);
              I3.object = D3, I3.property = this.jsx_parseIdentifier(), D3 = this.finishNode(I3, "JSXMemberExpression");
            }
            return D3;
          } }, { key: "jsx_parseAttributeValue", value: function() {
            switch (this.type) {
              case d3.braceL:
                var S3 = this.jsx_parseExpressionContainer();
                return S3.expression.type === "JSXEmptyExpression" && this.raise(S3.start, "JSX attributes must only be assigned a non-empty expression"), S3;
              case m3.jsxTagStart:
              case d3.string:
                return this.parseExprAtom();
              default:
                this.raise(this.start, "JSX value should be either an expression or a quoted JSX text");
            }
          } }, { key: "jsx_parseEmptyExpression", value: function() {
            var S3 = this.startNodeAt(this.lastTokEnd, this.lastTokEndLoc);
            return this.finishNodeAt(S3, "JSXEmptyExpression", this.start, this.startLoc);
          } }, { key: "jsx_parseExpressionContainer", value: function() {
            var S3 = this.startNode();
            return this.next(), S3.expression = this.type === d3.braceR ? this.jsx_parseEmptyExpression() : this.parseExpression(), this.expect(d3.braceR), this.finishNode(S3, "JSXExpressionContainer");
          } }, { key: "jsx_parseAttribute", value: function() {
            var S3 = this.startNode();
            return this.eat(d3.braceL) ? (this.expect(d3.ellipsis), S3.argument = this.parseMaybeAssign(), this.expect(d3.braceR), this.finishNode(S3, "JSXSpreadAttribute")) : (S3.name = this.jsx_parseNamespacedName(), S3.value = this.eat(d3.eq) ? this.jsx_parseAttributeValue() : null, this.finishNode(S3, "JSXAttribute"));
          } }, { key: "jsx_parseOpeningElementAt", value: function(S3, w3) {
            var D3 = this.startNodeAt(S3, w3);
            D3.attributes = [];
            var I3 = this.jsx_parseElementName();
            for (I3 && (D3.name = I3); this.type !== d3.slash && this.type !== m3.jsxTagEnd; )
              D3.attributes.push(this.jsx_parseAttribute());
            return D3.selfClosing = this.eat(d3.slash), this.expect(m3.jsxTagEnd), this.finishNode(D3, I3 ? "JSXOpeningElement" : "JSXOpeningFragment");
          } }, { key: "jsx_parseClosingElementAt", value: function(S3, w3) {
            var D3 = this.startNodeAt(S3, w3), I3 = this.jsx_parseElementName();
            return I3 && (D3.name = I3), this.expect(m3.jsxTagEnd), this.finishNode(D3, I3 ? "JSXClosingElement" : "JSXClosingFragment");
          } }, { key: "jsx_parseElementAt", value: function(S3, w3) {
            var D3 = this.startNodeAt(S3, w3), I3 = [], L3 = this.jsx_parseOpeningElementAt(S3, w3), V10 = null;
            if (!L3.selfClosing) {
              e:
                for (; ; )
                  switch (this.type) {
                    case m3.jsxTagStart:
                      if (S3 = this.start, w3 = this.startLoc, this.next(), this.eat(d3.slash)) {
                        V10 = this.jsx_parseClosingElementAt(S3, w3);
                        break e;
                      }
                      I3.push(this.jsx_parseElementAt(S3, w3));
                      break;
                    case m3.jsxText:
                      I3.push(this.parseExprAtom());
                      break;
                    case d3.braceL:
                      I3.push(this.jsx_parseExpressionContainer());
                      break;
                    default:
                      this.unexpected();
                  }
              a3(V10.name) !== a3(L3.name) && this.raise(V10.start, "Expected corresponding JSX closing tag for <" + a3(L3.name) + ">");
            }
            var K3 = L3.name ? "Element" : "Fragment";
            return D3["opening" + K3] = L3, D3["closing" + K3] = V10, D3.children = I3, this.type === d3.relational && this.value === "<" && this.raise(this.start, "Adjacent JSX elements must be wrapped in an enclosing tag"), this.finishNode(D3, "JSX" + K3);
          } }, { key: "jsx_parseText", value: function(S3) {
            var w3 = this.parseLiteral(S3);
            return w3.type = "JSXText", w3;
          } }, { key: "jsx_parseElement", value: function() {
            var S3 = this.start, w3 = this.startLoc;
            return this.next(), this.jsx_parseElementAt(S3, w3);
          } }, { key: "parseExprAtom", value: function(S3) {
            return this.type === m3.jsxText ? this.jsx_parseText(this.value) : this.type === m3.jsxTagStart ? this.jsx_parseElement() : Yn$2(rt$2(O3.prototype), "parseExprAtom", this).call(this, S3);
          } }, { key: "readToken", value: function(S3) {
            var w3 = this.curContext();
            if (w3 === x3)
              return this.jsx_readToken();
            if (w3 === v3 || w3 === b3) {
              if (k3(S3))
                return this.jsx_readWord();
              if (S3 == 62)
                return ++this.pos, this.finishToken(m3.jsxTagEnd);
              if ((S3 === 34 || S3 === 39) && w3 == v3)
                return this.jsx_readString(S3);
            }
            return S3 === 60 && this.exprAllowed && this.input.charCodeAt(this.pos + 1) !== 33 ? (++this.pos, this.finishToken(m3.jsxTagStart)) : Yn$2(rt$2(O3.prototype), "readToken", this).call(this, S3);
          } }, { key: "updateContext", value: function(S3) {
            if (this.type == d3.braceL) {
              var w3 = this.curContext();
              w3 == v3 ? this.context.push(y3.b_expr) : w3 == x3 ? this.context.push(y3.b_tmpl) : Yn$2(rt$2(O3.prototype), "updateContext", this).call(this, S3), this.exprAllowed = true;
            } else {
              if (this.type !== d3.slash || S3 !== m3.jsxTagStart)
                return Yn$2(rt$2(O3.prototype), "updateContext", this).call(this, S3);
              this.context.length -= 2, this.context.push(b3), this.exprAllowed = false;
            }
          } }], [{ key: "acornJsx", get: function() {
            return p3;
          } }]), O3;
        }(c3);
      }({ allowNamespaces: s3.allowNamespaces !== false, allowNamespacedObjects: !!s3.allowNamespacedObjects }, o3);
    };
  }, Object.defineProperty(e28.exports, "tokTypes", { get: function() {
    return i(Tx).tokTypes;
  }, configurable: true, enumerable: true });
}), Fd$1 = { AssignmentExpression: "AssignmentExpression", AssignmentPattern: "AssignmentPattern", ArrayExpression: "ArrayExpression", ArrayPattern: "ArrayPattern", ArrowFunctionExpression: "ArrowFunctionExpression", AwaitExpression: "AwaitExpression", BlockStatement: "BlockStatement", BinaryExpression: "BinaryExpression", BreakStatement: "BreakStatement", CallExpression: "CallExpression", CatchClause: "CatchClause", ClassBody: "ClassBody", ClassDeclaration: "ClassDeclaration", ClassExpression: "ClassExpression", ConditionalExpression: "ConditionalExpression", ContinueStatement: "ContinueStatement", DoWhileStatement: "DoWhileStatement", DebuggerStatement: "DebuggerStatement", EmptyStatement: "EmptyStatement", ExpressionStatement: "ExpressionStatement", ForStatement: "ForStatement", ForInStatement: "ForInStatement", ForOfStatement: "ForOfStatement", FunctionDeclaration: "FunctionDeclaration", FunctionExpression: "FunctionExpression", Identifier: "Identifier", IfStatement: "IfStatement", Literal: "Literal", LabeledStatement: "LabeledStatement", LogicalExpression: "LogicalExpression", MemberExpression: "MemberExpression", MetaProperty: "MetaProperty", MethodDefinition: "MethodDefinition", NewExpression: "NewExpression", ObjectExpression: "ObjectExpression", ObjectPattern: "ObjectPattern", Program: "Program", Property: "Property", RestElement: "RestElement", ReturnStatement: "ReturnStatement", SequenceExpression: "SequenceExpression", SpreadElement: "SpreadElement", Super: "Super", SwitchCase: "SwitchCase", SwitchStatement: "SwitchStatement", TaggedTemplateExpression: "TaggedTemplateExpression", TemplateElement: "TemplateElement", TemplateLiteral: "TemplateLiteral", ThisExpression: "ThisExpression", ThrowStatement: "ThrowStatement", TryStatement: "TryStatement", UnaryExpression: "UnaryExpression", UpdateExpression: "UpdateExpression", VariableDeclaration: "VariableDeclaration", VariableDeclarator: "VariableDeclarator", WhileStatement: "WhileStatement", WithStatement: "WithStatement", YieldExpression: "YieldExpression", JSXIdentifier: "JSXIdentifier", JSXNamespacedName: "JSXNamespacedName", JSXMemberExpression: "JSXMemberExpression", JSXEmptyExpression: "JSXEmptyExpression", JSXExpressionContainer: "JSXExpressionContainer", JSXElement: "JSXElement", JSXClosingElement: "JSXClosingElement", JSXOpeningElement: "JSXOpeningElement", JSXAttribute: "JSXAttribute", JSXSpreadAttribute: "JSXSpreadAttribute", JSXText: "JSXText", ExportDefaultDeclaration: "ExportDefaultDeclaration", ExportNamedDeclaration: "ExportNamedDeclaration", ExportAllDeclaration: "ExportAllDeclaration", ExportSpecifier: "ExportSpecifier", ImportDeclaration: "ImportDeclaration", ImportSpecifier: "ImportSpecifier", ImportDefaultSpecifier: "ImportDefaultSpecifier", ImportNamespaceSpecifier: "ImportNamespaceSpecifier" }, mr$1 = { Boolean: "Boolean", EOF: "<end>", Identifier: "Identifier", Keyword: "Keyword", Null: "Null", Numeric: "Numeric", Punctuator: "Punctuator", String: "String", RegularExpression: "RegularExpression", Template: "Template", JSXIdentifier: "JSXIdentifier", JSXText: "JSXText" };
function qm(e28, t3) {
  this._acornTokTypes = e28, this._tokens = [], this._curlyBrace = null, this._code = t3;
}
qm.prototype = { constructor: qm, translate: function(e28, t3) {
  var n3 = e28.type, r3 = this._acornTokTypes;
  if (n3 === r3.name)
    e28.type = mr$1.Identifier, e28.value === "static" && (e28.type = mr$1.Keyword), t3.ecmaVersion > 5 && (e28.value === "yield" || e28.value === "let") && (e28.type = mr$1.Keyword);
  else if (n3 === r3.semi || n3 === r3.comma || n3 === r3.parenL || n3 === r3.parenR || n3 === r3.braceL || n3 === r3.braceR || n3 === r3.dot || n3 === r3.bracketL || n3 === r3.colon || n3 === r3.question || n3 === r3.bracketR || n3 === r3.ellipsis || n3 === r3.arrow || n3 === r3.jsxTagStart || n3 === r3.incDec || n3 === r3.starstar || n3 === r3.jsxTagEnd || n3 === r3.prefix || n3.binop && !n3.keyword || n3.isAssign)
    e28.type = mr$1.Punctuator, e28.value = this._code.slice(e28.start, e28.end);
  else if (n3 === r3.jsxName)
    e28.type = mr$1.JSXIdentifier;
  else if (n3.label === "jsxText" || n3 === r3.jsxAttrValueToken)
    e28.type = mr$1.JSXText;
  else if (n3.keyword)
    n3.keyword === "true" || n3.keyword === "false" ? e28.type = mr$1.Boolean : n3.keyword === "null" ? e28.type = mr$1.Null : e28.type = mr$1.Keyword;
  else if (n3 === r3.num)
    e28.type = mr$1.Numeric, e28.value = this._code.slice(e28.start, e28.end);
  else if (n3 === r3.string)
    t3.jsxAttrValueToken ? (t3.jsxAttrValueToken = false, e28.type = mr$1.JSXText) : e28.type = mr$1.String, e28.value = this._code.slice(e28.start, e28.end);
  else if (n3 === r3.regexp) {
    e28.type = mr$1.RegularExpression;
    var i = e28.value;
    e28.regex = { flags: i.flags, pattern: i.pattern }, e28.value = "/".concat(i.pattern, "/").concat(i.flags);
  }
  return e28;
}, onToken: function(e28, t3) {
  var n3 = this, r3 = this._acornTokTypes, i = t3.tokens, a3 = this._tokens;
  function s3() {
    i.push(function(o3, u3) {
      var c3 = o3[0], f3 = o3[o3.length - 1], p3 = { type: mr$1.Template, value: u3.slice(c3.start, f3.end) };
      return c3.loc && (p3.loc = { start: c3.loc.start, end: f3.loc.end }), c3.range && (p3.start = c3.range[0], p3.end = f3.range[1], p3.range = [p3.start, p3.end]), p3;
    }(n3._tokens, n3._code)), n3._tokens = [];
  }
  if (e28.type !== r3.eof) {
    if (e28.type === r3.backQuote)
      return this._curlyBrace && (i.push(this.translate(this._curlyBrace, t3)), this._curlyBrace = null), a3.push(e28), void (a3.length > 1 && s3());
    if (e28.type === r3.dollarBraceL)
      return a3.push(e28), void s3();
    if (e28.type === r3.braceR)
      return this._curlyBrace && i.push(this.translate(this._curlyBrace, t3)), void (this._curlyBrace = e28);
    if (e28.type === r3.template || e28.type === r3.invalidTemplate)
      return this._curlyBrace && (a3.push(this._curlyBrace), this._curlyBrace = null), void a3.push(e28);
    this._curlyBrace && (i.push(this.translate(this._curlyBrace, t3)), this._curlyBrace = null), i.push(this.translate(e28, t3));
  } else
    this._curlyBrace && i.push(this.translate(this._curlyBrace, t3));
} };
var Q9 = qm, X9 = 5, la$1 = Symbol("espree's internal state"), wd$1 = Symbol("espree's esprimaFinishNode");
function Y9(e28) {
  var t3 = function() {
    var a3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : X9;
    if (typeof a3 != "number")
      throw new Error("ecmaVersion must be a number. Received value of type ".concat(xe$3(a3), " instead."));
    var s3 = a3;
    switch (s3 >= 2015 && (s3 -= 2009), s3) {
      case 3:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
        return s3;
    }
    throw new Error("Invalid ecmaVersion.");
  }(e28.ecmaVersion), n3 = function() {
    var a3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "script";
    if (a3 === "script" || a3 === "module")
      return a3;
    throw new Error("Invalid sourceType.");
  }(e28.sourceType), r3 = e28.range === true, i = e28.loc === true;
  if (n3 === "module" && t3 < 6)
    throw new Error("sourceType 'module' is not supported when ecmaVersion < 2015. Consider adding `{ ecmaVersion: 2015 }` to the parser options.");
  return Object.assign({}, e28, { ecmaVersion: t3, sourceType: n3, ranges: r3, locations: i });
}
var Px = function() {
  return function(e28) {
    var t3 = Object.assign({}, e28.acorn.tokTypes);
    return e28.acornJsx && Object.assign(t3, e28.acornJsx.tokTypes), function(n3) {
      function r3(i, a3) {
        var s3;
        We$1(this, r3), xe$3(i) === "object" && i !== null || (i = {}), typeof a3 == "string" || a3 instanceof String || (a3 = String(a3));
        var o3 = Y9(i), u3 = o3.ecmaFeatures || {}, c3 = o3.tokens === true ? new Q9(t3, a3) : null;
        return (s3 = Gt$3(this, rt$2(r3).call(this, { ecmaVersion: o3.ecmaVersion, sourceType: o3.sourceType, ranges: o3.ranges, locations: o3.locations, allowReturnOutsideFunction: !!u3.globalReturn, onToken: function(f3) {
          c3 && c3.onToken(f3, s3[la$1]), f3.type !== t3.eof && (s3[la$1].lastToken = f3);
        }, onComment: function(f3, p3, d3, m3, y3, v3) {
          if (s3[la$1].comments) {
            var b3 = function(x3, C3, k3, F3, B3, O3) {
              var S3 = { type: x3 ? "Block" : "Line", value: C3 };
              return typeof k3 == "number" && (S3.start = k3, S3.end = F3, S3.range = [k3, F3]), xe$3(B3) === "object" && (S3.loc = { start: B3, end: O3 }), S3;
            }(f3, p3, d3, m3, y3, v3);
            s3[la$1].comments.push(b3);
          }
        } }, a3)))[la$1] = { tokens: c3 ? [] : null, comments: o3.comment === true ? [] : null, impliedStrict: u3.impliedStrict === true && s3.options.ecmaVersion >= 5, ecmaVersion: s3.options.ecmaVersion, jsxAttrValueToken: false, lastToken: null }, s3;
      }
      return $t$3(r3, n3), Xe$1(r3, [{ key: "tokenize", value: function() {
        do
          this.next();
        while (this.type !== t3.eof);
        this.next();
        var i = this[la$1], a3 = i.tokens;
        return i.comments && (a3.comments = i.comments), a3;
      } }, { key: "finishNode", value: function() {
        for (var i, a3 = arguments.length, s3 = new Array(a3), o3 = 0; o3 < a3; o3++)
          s3[o3] = arguments[o3];
        var u3 = (i = Yn$2(rt$2(r3.prototype), "finishNode", this)).call.apply(i, [this].concat(s3));
        return this[wd$1](u3);
      } }, { key: "finishNodeAt", value: function() {
        for (var i, a3 = arguments.length, s3 = new Array(a3), o3 = 0; o3 < a3; o3++)
          s3[o3] = arguments[o3];
        var u3 = (i = Yn$2(rt$2(r3.prototype), "finishNodeAt", this)).call.apply(i, [this].concat(s3));
        return this[wd$1](u3);
      } }, { key: "parse", value: function() {
        var i = this[la$1], a3 = Yn$2(rt$2(r3.prototype), "parse", this).call(this);
        return a3.sourceType = this.options.sourceType, i.comments && (a3.comments = i.comments), i.tokens && (a3.tokens = i.tokens), a3.range && (a3.range[0] = a3.body.length ? a3.body[0].range[0] : a3.range[0], a3.range[1] = i.lastToken ? i.lastToken.range[1] : a3.range[1]), a3.loc && (a3.loc.start = a3.body.length ? a3.body[0].loc.start : a3.loc.start, a3.loc.end = i.lastToken ? i.lastToken.loc.end : a3.loc.end), a3;
      } }, { key: "parseTopLevel", value: function(i) {
        return this[la$1].impliedStrict && (this.strict = true), Yn$2(rt$2(r3.prototype), "parseTopLevel", this).call(this, i);
      } }, { key: "raise", value: function(i, a3) {
        var s3 = e28.acorn.getLineInfo(this.input, i), o3 = new SyntaxError(a3);
        throw o3.index = i, o3.lineNumber = s3.line, o3.column = s3.column + 1, o3;
      } }, { key: "raiseRecoverable", value: function(i, a3) {
        this.raise(i, a3);
      } }, { key: "unexpected", value: function(i) {
        var a3 = "Unexpected token";
        if (i != null) {
          if (this.pos = i, this.options.locations)
            for (; this.pos < this.lineStart; )
              this.lineStart = this.input.lastIndexOf(`
`, this.lineStart - 2) + 1, --this.curLine;
          this.nextToken();
        }
        this.end > this.start && (a3 += " ".concat(this.input.slice(this.start, this.end))), this.raise(this.start, a3);
      } }, { key: "jsx_readString", value: function(i) {
        var a3 = Yn$2(rt$2(r3.prototype), "jsx_readString", this).call(this, i);
        return this.type === t3.string && (this[la$1].jsxAttrValueToken = true), a3;
      } }, { key: wd$1, value: function(i) {
        if (i.type === "TemplateElement") {
          var a3 = this.input.slice(i.end, i.end + 2) === "${";
          i.range && (i.range[0]--, i.range[1] += a3 ? 2 : 1), i.loc && (i.loc.start.column--, i.loc.end.column += a3 ? 2 : 1);
        }
        return i.type.indexOf("Function") > -1 && !i.generator && (i.generator = false), i;
      } }]), r3;
    }(e28);
  };
}, gk = "An Esprima-compatible JavaScript parser built on Acorn", yk = "Nicholas C. Zakas <nicholas+npm@nczconsulting.com>", vk = "https://github.com/eslint/espree", xk = ["lib", "espree.js"], bk = { node: ">=6.0.0" }, Ek = { url: "http://github.com/eslint/espree.git" }, Ck = { acorn: "^7.1.0", "acorn-jsx": "^5.1.0", "eslint-visitor-keys": "^1.1.0" }, Sk = { browserify: "^16.5.0", chai: "^4.2.0", eslint: "^6.0.1", "eslint-config-eslint": "^5.0.1", "eslint-plugin-node": "^9.1.0", "eslint-release": "^1.0.0", esprima: "latest", "esprima-fb": "^8001.2001.0-dev-harmony-fb", "json-diff": "^0.5.4", leche: "^2.3.0", mocha: "^6.2.0", nyc: "^14.1.1", regenerate: "^1.4.0", shelljs: "^0.3.0", "shelljs-nodecli": "^0.1.1", "unicode-6.3.0": "^0.7.5" }, kk = ["ast", "ecmascript", "javascript", "parser", "syntax", "acorn"], Dk = { "generate-regex": "node tools/generate-identifier-regex.js", test: "npm run-script lint && node Makefile.js test", lint: "node Makefile.js lint", browserify: "node Makefile.js browserify", "generate-release": "eslint-generate-release", "generate-alpharelease": "eslint-generate-prerelease alpha", "generate-betarelease": "eslint-generate-prerelease beta", "generate-rcrelease": "eslint-generate-prerelease rc", "publish-release": "eslint-publish-release" }, Z9 = { name: "espree", description: gk, author: yk, homepage: vk, main: "espree.js", version: "6.1.2", files: xk, engines: bk, repository: "eslint/espree", bugs: Ek, license: "BSD-2-Clause", dependencies: Ck, devDependencies: Sk, keywords: kk, scripts: Dk }, e82 = Object.freeze({ __proto__: null, name: "espree", description: gk, author: yk, homepage: vk, main: "espree.js", version: "6.1.2", files: xk, engines: bk, repository: "eslint/espree", bugs: Ek, license: "BSD-2-Clause", dependencies: Ck, devDependencies: Sk, keywords: kk, scripts: Dk, default: Z9 }), Ix = Cr$1(_9), t8 = Cr$1(e82), Bx = { _regular: null, _jsx: null, get regular() {
  return this._regular === null && (this._regular = Ix.Parser.extend(Px())), this._regular;
}, get jsx() {
  return this._jsx === null && (this._jsx = Ix.Parser.extend(J9(), Px())), this._jsx;
}, get: function(e28) {
  return e28 && e28.ecmaFeatures && e28.ecmaFeatures.jsx ? this.jsx : this.regular;
} }, n8 = { version: t8.version, tokenize: function(e28, t3) {
  var n3 = Bx.get(t3);
  return t3 && t3.tokens === true || (t3 = Object.assign({}, t3, { tokens: true })), new n3(t3, e28).tokenize();
}, parse: function(e28, t3) {
  return new (Bx.get(t3))(t3, e28).parse();
}, Syntax: function() {
  var e28, t3 = {};
  for (e28 in typeof Object.create == "function" && (t3 = /* @__PURE__ */ Object.create(null)), Fd$1)
    Object.hasOwnProperty.call(Fd$1, e28) && (t3[e28] = Fd$1[e28]);
  return typeof Object.freeze == "function" && Object.freeze(t3), t3;
}(), VisitorKeys: pf.KEYS }, r8 = gt$3(function(e28, t3) {
  (function() {
    var n3, r3 = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a3 = "Expected a function", s3 = "__lodash_hash_undefined__", o3 = 500, u3 = "__lodash_placeholder__", c3 = 1, f3 = 2, p3 = 4, d3 = 1, m3 = 2, y3 = 1, v3 = 2, b3 = 4, x3 = 8, C3 = 16, k3 = 32, F3 = 64, B3 = 128, O3 = 256, S3 = 512, w3 = 30, D3 = "...", I3 = 800, L3 = 16, V10 = 1, K3 = 2, W3 = 1 / 0, R3 = 9007199254740991, q3 = 17976931348623157e292, J3 = NaN, X3 = 4294967295, ce2 = X3 - 1, A3 = X3 >>> 1, M3 = [["ary", B3], ["bind", y3], ["bindKey", v3], ["curry", x3], ["curryRight", C3], ["flip", S3], ["partial", k3], ["partialRight", F3], ["rearg", O3]], ne2 = "[object Arguments]", de2 = "[object Array]", he2 = "[object AsyncFunction]", j3 = "[object Boolean]", ie2 = "[object Date]", fe2 = "[object DOMException]", ge2 = "[object Error]", Fe2 = "[object Function]", Pe2 = "[object GeneratorFunction]", _3 = "[object Map]", Q3 = "[object Number]", Y3 = "[object Null]", ae2 = "[object Object]", ue2 = "[object Proxy]", De2 = "[object RegExp]", Ee2 = "[object Set]", _e2 = "[object String]", Oe2 = "[object Symbol]", Ye2 = "[object Undefined]", _t2 = "[object WeakMap]", Kt2 = "[object WeakSet]", Jt2 = "[object ArrayBuffer]", zt2 = "[object DataView]", wn2 = "[object Float32Array]", Z3 = "[object Float64Array]", ee2 = "[object Int8Array]", oe2 = "[object Int16Array]", le2 = "[object Int32Array]", we2 = "[object Uint8Array]", Me2 = "[object Uint8ClampedArray]", Ve2 = "[object Uint16Array]", $e2 = "[object Uint32Array]", yt2 = /\b__p \+= '';/g, ze2 = /\b(__p \+=) '' \+/g, vt2 = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Nt2 = /&(?:amp|lt|gt|quot|#39);/g, Qt2 = /[&<>"']/g, bt2 = RegExp(Nt2.source), at2 = RegExp(Qt2.source), jt2 = /<%-([\s\S]+?)%>/g, dn2 = /<%([\s\S]+?)%>/g, Rn2 = /<%=([\s\S]+?)%>/g, qn2 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Sr2 = /^\w*$/, pi2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Bn2 = /[\\^$.*+?()[\]{}|]/g, er2 = RegExp(Bn2.source), fi2 = /^\s+|\s+$/g, kr2 = /^\s+/, oo2 = /\s+$/, Fi2 = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, so2 = /\{\n\/\* \[wrapped with (.+)\] \*/, Hi2 = /,? & /, Ki2 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Wn2 = /\\(\\)?/g, Ie2 = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, je2 = /\w*$/, Ze2 = /^[-+]0x[0-9a-f]+$/i, an2 = /^0b[01]+$/i, Rt2 = /^\[object .+?Constructor\]$/, wi2 = /^0o[0-7]+$/i, Wo2 = /^(?:0|[1-9]\d*)$/, ot2 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Mn2 = /($^)/, Ji2 = /['\n\r\u2028\u2029\\]/g, uo2 = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff", Qi2 = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", On2 = "[\\ud800-\\udfff]", Fc2 = "[" + Qi2 + "]", Xi2 = "[" + uo2 + "]", $o2 = "\\d+", wc2 = "[\\u2700-\\u27bf]", $n2 = "[a-z\\xdf-\\xf6\\xf8-\\xff]", Ht2 = "[^\\ud800-\\udfff" + Qi2 + $o2 + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]", Dr2 = "\\ud83c[\\udffb-\\udfff]", Vr2 = "[^\\ud800-\\udfff]", Gn2 = "(?:\\ud83c[\\udde6-\\uddff]){2}", zn2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", tr2 = "[A-Z\\xc0-\\xd6\\xd8-\\xde]", tu2 = "(?:" + $n2 + "|" + Ht2 + ")", Ac2 = "(?:" + tr2 + "|" + Ht2 + ")", co2 = "(?:" + Xi2 + "|" + Dr2 + ")?", Go2 = "[\\ufe0e\\ufe0f]?" + co2 + ("(?:\\u200d(?:" + [Vr2, Gn2, zn2].join("|") + ")[\\ufe0e\\ufe0f]?" + co2 + ")*"), JA = "(?:" + [wc2, Gn2, zn2].join("|") + ")" + Go2, QA = "(?:" + [Vr2 + Xi2 + "?", Xi2, Gn2, zn2, On2].join("|") + ")", XA = RegExp("['\u2019]", "g"), YA = RegExp(Xi2, "g"), Df = RegExp(Dr2 + "(?=" + Dr2 + ")|" + QA + Go2, "g"), ZA = RegExp([tr2 + "?" + $n2 + "+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=" + [Fc2, tr2, "$"].join("|") + ")", Ac2 + "+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=" + [Fc2, tr2 + tu2, "$"].join("|") + ")", tr2 + "?" + tu2 + "+(?:['\u2019](?:d|ll|m|re|s|t|ve))?", tr2 + "+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $o2, JA].join("|"), "g"), e32 = RegExp("[\\u200d\\ud800-\\udfff" + uo2 + "\\ufe0e\\ufe0f]"), t32 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, n32 = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"], r32 = -1, Zt2 = {};
    Zt2[wn2] = Zt2[Z3] = Zt2[ee2] = Zt2[oe2] = Zt2[le2] = Zt2[we2] = Zt2[Me2] = Zt2[Ve2] = Zt2[$e2] = true, Zt2[ne2] = Zt2[de2] = Zt2[Jt2] = Zt2[j3] = Zt2[zt2] = Zt2[ie2] = Zt2[ge2] = Zt2[Fe2] = Zt2[_3] = Zt2[Q3] = Zt2[ae2] = Zt2[De2] = Zt2[Ee2] = Zt2[_e2] = Zt2[_t2] = false;
    var Xt2 = {};
    Xt2[ne2] = Xt2[de2] = Xt2[Jt2] = Xt2[zt2] = Xt2[j3] = Xt2[ie2] = Xt2[wn2] = Xt2[Z3] = Xt2[ee2] = Xt2[oe2] = Xt2[le2] = Xt2[_3] = Xt2[Q3] = Xt2[ae2] = Xt2[De2] = Xt2[Ee2] = Xt2[_e2] = Xt2[Oe2] = Xt2[we2] = Xt2[Me2] = Xt2[Ve2] = Xt2[$e2] = true, Xt2[ge2] = Xt2[Fe2] = Xt2[_t2] = false;
    var i3 = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" }, a32 = parseFloat, o32 = parseInt, cg = xe$3(ni$1) == "object" && ni$1 && ni$1.Object === Object && ni$1, s32 = (typeof self > "u" ? "undefined" : xe$3(self)) == "object" && self && self.Object === Object && self, Vn2 = cg || s32 || Function("return this")(), Ff = t3 && !t3.nodeType && t3, lo2 = Ff && e28 && !e28.nodeType && e28, lg = lo2 && lo2.exports === Ff, wf = lg && cg.process, Ur2 = function() {
      try {
        var pe2 = lo2 && lo2.require && lo2.require("util").types;
        return pe2 || wf && wf.binding && wf.binding("util");
      } catch {
      }
    }(), pg = Ur2 && Ur2.isArrayBuffer, fg = Ur2 && Ur2.isDate, hg = Ur2 && Ur2.isMap, dg = Ur2 && Ur2.isRegExp, mg = Ur2 && Ur2.isSet, gg = Ur2 && Ur2.isTypedArray;
    function Fr2(pe2, ke2, Ce2) {
      switch (Ce2.length) {
        case 0:
          return pe2.call(ke2);
        case 1:
          return pe2.call(ke2, Ce2[0]);
        case 2:
          return pe2.call(ke2, Ce2[0], Ce2[1]);
        case 3:
          return pe2.call(ke2, Ce2[0], Ce2[1], Ce2[2]);
      }
      return pe2.apply(ke2, Ce2);
    }
    function u32(pe2, ke2, Ce2, Ne2) {
      for (var it2 = -1, Pt2 = pe2 == null ? 0 : pe2.length; ++it2 < Pt2; ) {
        var An2 = pe2[it2];
        ke2(Ne2, An2, Ce2(An2), pe2);
      }
      return Ne2;
    }
    function qr2(pe2, ke2) {
      for (var Ce2 = -1, Ne2 = pe2 == null ? 0 : pe2.length; ++Ce2 < Ne2 && ke2(pe2[Ce2], Ce2, pe2) !== false; )
        ;
      return pe2;
    }
    function c32(pe2, ke2) {
      for (var Ce2 = pe2 == null ? 0 : pe2.length; Ce2-- && ke2(pe2[Ce2], Ce2, pe2) !== false; )
        ;
      return pe2;
    }
    function yg(pe2, ke2) {
      for (var Ce2 = -1, Ne2 = pe2 == null ? 0 : pe2.length; ++Ce2 < Ne2; )
        if (!ke2(pe2[Ce2], Ce2, pe2))
          return false;
      return true;
    }
    function Pa2(pe2, ke2) {
      for (var Ce2 = -1, Ne2 = pe2 == null ? 0 : pe2.length, it2 = 0, Pt2 = []; ++Ce2 < Ne2; ) {
        var An2 = pe2[Ce2];
        ke2(An2, Ce2, pe2) && (Pt2[it2++] = An2);
      }
      return Pt2;
    }
    function _c2(pe2, ke2) {
      return !!(pe2 != null && pe2.length) && zo2(pe2, ke2, 0) > -1;
    }
    function Af(pe2, ke2, Ce2) {
      for (var Ne2 = -1, it2 = pe2 == null ? 0 : pe2.length; ++Ne2 < it2; )
        if (Ce2(ke2, pe2[Ne2]))
          return true;
      return false;
    }
    function un2(pe2, ke2) {
      for (var Ce2 = -1, Ne2 = pe2 == null ? 0 : pe2.length, it2 = Array(Ne2); ++Ce2 < Ne2; )
        it2[Ce2] = ke2(pe2[Ce2], Ce2, pe2);
      return it2;
    }
    function Ia2(pe2, ke2) {
      for (var Ce2 = -1, Ne2 = ke2.length, it2 = pe2.length; ++Ce2 < Ne2; )
        pe2[it2 + Ce2] = ke2[Ce2];
      return pe2;
    }
    function _f(pe2, ke2, Ce2, Ne2) {
      var it2 = -1, Pt2 = pe2 == null ? 0 : pe2.length;
      for (Ne2 && Pt2 && (Ce2 = pe2[++it2]); ++it2 < Pt2; )
        Ce2 = ke2(Ce2, pe2[it2], it2, pe2);
      return Ce2;
    }
    function l3(pe2, ke2, Ce2, Ne2) {
      var it2 = pe2 == null ? 0 : pe2.length;
      for (Ne2 && it2 && (Ce2 = pe2[--it2]); it2--; )
        Ce2 = ke2(Ce2, pe2[it2], it2, pe2);
      return Ce2;
    }
    function Tf(pe2, ke2) {
      for (var Ce2 = -1, Ne2 = pe2 == null ? 0 : pe2.length; ++Ce2 < Ne2; )
        if (ke2(pe2[Ce2], Ce2, pe2))
          return true;
      return false;
    }
    var p32 = Pf("length");
    function vg(pe2, ke2, Ce2) {
      var Ne2;
      return Ce2(pe2, function(it2, Pt2, An2) {
        if (ke2(it2, Pt2, An2))
          return Ne2 = Pt2, false;
      }), Ne2;
    }
    function Tc2(pe2, ke2, Ce2, Ne2) {
      for (var it2 = pe2.length, Pt2 = Ce2 + (Ne2 ? 1 : -1); Ne2 ? Pt2-- : ++Pt2 < it2; )
        if (ke2(pe2[Pt2], Pt2, pe2))
          return Pt2;
      return -1;
    }
    function zo2(pe2, ke2, Ce2) {
      return ke2 == ke2 ? function(Ne2, it2, Pt2) {
        for (var An2 = Pt2 - 1, Ai2 = Ne2.length; ++An2 < Ai2; )
          if (Ne2[An2] === it2)
            return An2;
        return -1;
      }(pe2, ke2, Ce2) : Tc2(pe2, xg, Ce2);
    }
    function f32(pe2, ke2, Ce2, Ne2) {
      for (var it2 = Ce2 - 1, Pt2 = pe2.length; ++it2 < Pt2; )
        if (Ne2(pe2[it2], ke2))
          return it2;
      return -1;
    }
    function xg(pe2) {
      return pe2 != pe2;
    }
    function bg(pe2, ke2) {
      var Ce2 = pe2 == null ? 0 : pe2.length;
      return Ce2 ? Bf(pe2, ke2) / Ce2 : J3;
    }
    function Pf(pe2) {
      return function(ke2) {
        return ke2 == null ? n3 : ke2[pe2];
      };
    }
    function If(pe2) {
      return function(ke2) {
        return pe2 == null ? n3 : pe2[ke2];
      };
    }
    function Eg(pe2, ke2, Ce2, Ne2, it2) {
      return it2(pe2, function(Pt2, An2, Ai2) {
        Ce2 = Ne2 ? (Ne2 = false, Pt2) : ke2(Ce2, Pt2, An2, Ai2);
      }), Ce2;
    }
    function Bf(pe2, ke2) {
      for (var Ce2, Ne2 = -1, it2 = pe2.length; ++Ne2 < it2; ) {
        var Pt2 = ke2(pe2[Ne2]);
        Pt2 !== n3 && (Ce2 = Ce2 === n3 ? Pt2 : Ce2 + Pt2);
      }
      return Ce2;
    }
    function Of(pe2, ke2) {
      for (var Ce2 = -1, Ne2 = Array(pe2); ++Ce2 < pe2; )
        Ne2[Ce2] = ke2(Ce2);
      return Ne2;
    }
    function wr2(pe2) {
      return function(ke2) {
        return pe2(ke2);
      };
    }
    function Lf(pe2, ke2) {
      return un2(ke2, function(Ce2) {
        return pe2[Ce2];
      });
    }
    function nu2(pe2, ke2) {
      return pe2.has(ke2);
    }
    function Cg(pe2, ke2) {
      for (var Ce2 = -1, Ne2 = pe2.length; ++Ce2 < Ne2 && zo2(ke2, pe2[Ce2], 0) > -1; )
        ;
      return Ce2;
    }
    function Sg(pe2, ke2) {
      for (var Ce2 = pe2.length; Ce2-- && zo2(ke2, pe2[Ce2], 0) > -1; )
        ;
      return Ce2;
    }
    var h3 = If({ \u00C0: "A", \u00C1: "A", \u00C2: "A", \u00C3: "A", \u00C4: "A", \u00C5: "A", \u00E0: "a", \u00E1: "a", \u00E2: "a", \u00E3: "a", \u00E4: "a", \u00E5: "a", \u00C7: "C", \u00E7: "c", \u00D0: "D", \u00F0: "d", \u00C8: "E", \u00C9: "E", \u00CA: "E", \u00CB: "E", \u00E8: "e", \u00E9: "e", \u00EA: "e", \u00EB: "e", \u00CC: "I", \u00CD: "I", \u00CE: "I", \u00CF: "I", \u00EC: "i", \u00ED: "i", \u00EE: "i", \u00EF: "i", \u00D1: "N", \u00F1: "n", \u00D2: "O", \u00D3: "O", \u00D4: "O", \u00D5: "O", \u00D6: "O", \u00D8: "O", \u00F2: "o", \u00F3: "o", \u00F4: "o", \u00F5: "o", \u00F6: "o", \u00F8: "o", \u00D9: "U", \u00DA: "U", \u00DB: "U", \u00DC: "U", \u00F9: "u", \u00FA: "u", \u00FB: "u", \u00FC: "u", \u00DD: "Y", \u00FD: "y", \u00FF: "y", \u00C6: "Ae", \u00E6: "ae", \u00DE: "Th", \u00FE: "th", \u00DF: "ss", \u0100: "A", \u0102: "A", \u0104: "A", \u0101: "a", \u0103: "a", \u0105: "a", \u0106: "C", \u0108: "C", \u010A: "C", \u010C: "C", \u0107: "c", \u0109: "c", \u010B: "c", \u010D: "c", \u010E: "D", \u0110: "D", \u010F: "d", \u0111: "d", \u0112: "E", \u0114: "E", \u0116: "E", \u0118: "E", \u011A: "E", \u0113: "e", \u0115: "e", \u0117: "e", \u0119: "e", \u011B: "e", \u011C: "G", \u011E: "G", \u0120: "G", \u0122: "G", \u011D: "g", \u011F: "g", \u0121: "g", \u0123: "g", \u0124: "H", \u0126: "H", \u0125: "h", \u0127: "h", \u0128: "I", \u012A: "I", \u012C: "I", \u012E: "I", \u0130: "I", \u0129: "i", \u012B: "i", \u012D: "i", \u012F: "i", \u0131: "i", \u0134: "J", \u0135: "j", \u0136: "K", \u0137: "k", \u0138: "k", \u0139: "L", \u013B: "L", \u013D: "L", \u013F: "L", \u0141: "L", \u013A: "l", \u013C: "l", \u013E: "l", \u0140: "l", \u0142: "l", \u0143: "N", \u0145: "N", \u0147: "N", \u014A: "N", \u0144: "n", \u0146: "n", \u0148: "n", \u014B: "n", \u014C: "O", \u014E: "O", \u0150: "O", \u014D: "o", \u014F: "o", \u0151: "o", \u0154: "R", \u0156: "R", \u0158: "R", \u0155: "r", \u0157: "r", \u0159: "r", \u015A: "S", \u015C: "S", \u015E: "S", \u0160: "S", \u015B: "s", \u015D: "s", \u015F: "s", \u0161: "s", \u0162: "T", \u0164: "T", \u0166: "T", \u0163: "t", \u0165: "t", \u0167: "t", \u0168: "U", \u016A: "U", \u016C: "U", \u016E: "U", \u0170: "U", \u0172: "U", \u0169: "u", \u016B: "u", \u016D: "u", \u016F: "u", \u0171: "u", \u0173: "u", \u0174: "W", \u0175: "w", \u0176: "Y", \u0177: "y", \u0178: "Y", \u0179: "Z", \u017B: "Z", \u017D: "Z", \u017A: "z", \u017C: "z", \u017E: "z", \u0132: "IJ", \u0133: "ij", \u0152: "Oe", \u0153: "oe", \u0149: "'n", \u017F: "s" }), d32 = If({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" });
    function m32(pe2) {
      return "\\" + i3[pe2];
    }
    function Ho2(pe2) {
      return e32.test(pe2);
    }
    function Nf(pe2) {
      var ke2 = -1, Ce2 = Array(pe2.size);
      return pe2.forEach(function(Ne2, it2) {
        Ce2[++ke2] = [it2, Ne2];
      }), Ce2;
    }
    function kg(pe2, ke2) {
      return function(Ce2) {
        return pe2(ke2(Ce2));
      };
    }
    function Ba2(pe2, ke2) {
      for (var Ce2 = -1, Ne2 = pe2.length, it2 = 0, Pt2 = []; ++Ce2 < Ne2; ) {
        var An2 = pe2[Ce2];
        An2 !== ke2 && An2 !== u3 || (pe2[Ce2] = u3, Pt2[it2++] = Ce2);
      }
      return Pt2;
    }
    function Pc2(pe2) {
      var ke2 = -1, Ce2 = Array(pe2.size);
      return pe2.forEach(function(Ne2) {
        Ce2[++ke2] = Ne2;
      }), Ce2;
    }
    function g3(pe2) {
      var ke2 = -1, Ce2 = Array(pe2.size);
      return pe2.forEach(function(Ne2) {
        Ce2[++ke2] = [Ne2, Ne2];
      }), Ce2;
    }
    function Ko2(pe2) {
      return Ho2(pe2) ? function(ke2) {
        for (var Ce2 = Df.lastIndex = 0; Df.test(ke2); )
          ++Ce2;
        return Ce2;
      }(pe2) : p32(pe2);
    }
    function hi2(pe2) {
      return Ho2(pe2) ? function(ke2) {
        return ke2.match(Df) || [];
      }(pe2) : function(ke2) {
        return ke2.split("");
      }(pe2);
    }
    var y32 = If({ "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }), Jo2 = function pe2(ke2) {
      var Ce2, Ne2 = (ke2 = ke2 == null ? Vn2 : Jo2.defaults(Vn2.Object(), ke2, Jo2.pick(Vn2, n32))).Array, it2 = ke2.Date, Pt2 = ke2.Error, An2 = ke2.Function, Ai2 = ke2.Math, en2 = ke2.Object, jf = ke2.RegExp, v32 = ke2.String, Wr2 = ke2.TypeError, Ic2 = Ne2.prototype, x32 = An2.prototype, Qo2 = en2.prototype, Bc2 = ke2["__core-js_shared__"], Oc2 = x32.toString, qt2 = Qo2.hasOwnProperty, b32 = 0, Dg = (Ce2 = /[^.]+$/.exec(Bc2 && Bc2.keys && Bc2.keys.IE_PROTO || "")) ? "Symbol(src)_1." + Ce2 : "", Lc2 = Qo2.toString, E3 = Oc2.call(en2), C32 = Vn2._, S32 = jf("^" + Oc2.call(qt2).replace(Bn2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Nc2 = lg ? ke2.Buffer : n3, Oa2 = ke2.Symbol, jc2 = ke2.Uint8Array, Fg = Nc2 ? Nc2.allocUnsafe : n3, Rc2 = kg(en2.getPrototypeOf, en2), wg = en2.create, Ag = Qo2.propertyIsEnumerable, Mc2 = Ic2.splice, _g = Oa2 ? Oa2.isConcatSpreadable : n3, ru2 = Oa2 ? Oa2.iterator : n3, po2 = Oa2 ? Oa2.toStringTag : n3, Vc2 = function() {
        try {
          var h10 = go2(en2, "defineProperty");
          return h10({}, "", {}), h10;
        } catch {
        }
      }(), k32 = ke2.clearTimeout !== Vn2.clearTimeout && ke2.clearTimeout, D32 = it2 && it2.now !== Vn2.Date.now && it2.now, F32 = ke2.setTimeout !== Vn2.setTimeout && ke2.setTimeout, Uc2 = Ai2.ceil, qc2 = Ai2.floor, Rf = en2.getOwnPropertySymbols, w32 = Nc2 ? Nc2.isBuffer : n3, Tg = ke2.isFinite, A32 = Ic2.join, _32 = kg(en2.keys, en2), _n2 = Ai2.max, Hn2 = Ai2.min, T3 = it2.now, P3 = ke2.parseInt, Pg = Ai2.random, I32 = Ic2.reverse, Mf = go2(ke2, "DataView"), iu2 = go2(ke2, "Map"), Vf = go2(ke2, "Promise"), Xo2 = go2(ke2, "Set"), au2 = go2(ke2, "WeakMap"), ou2 = go2(en2, "create"), Wc2 = au2 && new au2(), Yo2 = {}, B32 = yo2(Mf), O32 = yo2(iu2), L32 = yo2(Vf), N3 = yo2(Xo2), j32 = yo2(au2), $c2 = Oa2 ? Oa2.prototype : n3, su2 = $c2 ? $c2.valueOf : n3, Ig = $c2 ? $c2.toString : n3;
      function U3(h10) {
        if (mn2(h10) && !st2(h10) && !(h10 instanceof St2)) {
          if (h10 instanceof $r2)
            return h10;
          if (qt2.call(h10, "__wrapped__"))
            return B1(h10);
        }
        return new $r2(h10);
      }
      var Zo2 = function() {
        function h10() {
        }
        return function(g10) {
          if (!cn2(g10))
            return {};
          if (wg)
            return wg(g10);
          h10.prototype = g10;
          var E4 = new h10();
          return h10.prototype = n3, E4;
        };
      }();
      function Gc2() {
      }
      function $r2(h10, g10) {
        this.__wrapped__ = h10, this.__actions__ = [], this.__chain__ = !!g10, this.__index__ = 0, this.__values__ = n3;
      }
      function St2(h10) {
        this.__wrapped__ = h10, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = false, this.__iteratees__ = [], this.__takeCount__ = X3, this.__views__ = [];
      }
      function fo2(h10) {
        var g10 = -1, E4 = h10 == null ? 0 : h10.length;
        for (this.clear(); ++g10 < E4; ) {
          var T10 = h10[g10];
          this.set(T10[0], T10[1]);
        }
      }
      function Yi2(h10) {
        var g10 = -1, E4 = h10 == null ? 0 : h10.length;
        for (this.clear(); ++g10 < E4; ) {
          var T10 = h10[g10];
          this.set(T10[0], T10[1]);
        }
      }
      function Zi2(h10) {
        var g10 = -1, E4 = h10 == null ? 0 : h10.length;
        for (this.clear(); ++g10 < E4; ) {
          var T10 = h10[g10];
          this.set(T10[0], T10[1]);
        }
      }
      function ho2(h10) {
        var g10 = -1, E4 = h10 == null ? 0 : h10.length;
        for (this.__data__ = new Zi2(); ++g10 < E4; )
          this.add(h10[g10]);
      }
      function di2(h10) {
        var g10 = this.__data__ = new Yi2(h10);
        this.size = g10.size;
      }
      function Bg(h10, g10) {
        var E4 = st2(h10), T10 = !E4 && vo2(h10), N10 = !E4 && !T10 && Ma2(h10), z10 = !E4 && !T10 && !N10 && is2(h10), te2 = E4 || T10 || N10 || z10, re2 = te2 ? Of(h10.length, v32) : [], se2 = re2.length;
        for (var be2 in h10)
          !g10 && !qt2.call(h10, be2) || te2 && (be2 == "length" || N10 && (be2 == "offset" || be2 == "parent") || z10 && (be2 == "buffer" || be2 == "byteLength" || be2 == "byteOffset") || ra2(be2, se2)) || re2.push(be2);
        return re2;
      }
      function Og(h10) {
        var g10 = h10.length;
        return g10 ? h10[Xf(0, g10 - 1)] : n3;
      }
      function R32(h10, g10) {
        return al(pr2(h10), mo2(g10, 0, h10.length));
      }
      function M32(h10) {
        return al(pr2(h10));
      }
      function Uf(h10, g10, E4) {
        (E4 === n3 || mi2(h10[g10], E4)) && (E4 !== n3 || g10 in h10) || ea2(h10, g10, E4);
      }
      function uu2(h10, g10, E4) {
        var T10 = h10[g10];
        qt2.call(h10, g10) && mi2(T10, E4) && (E4 !== n3 || g10 in h10) || ea2(h10, g10, E4);
      }
      function zc2(h10, g10) {
        for (var E4 = h10.length; E4--; )
          if (mi2(h10[E4][0], g10))
            return E4;
        return -1;
      }
      function V32(h10, g10, E4, T10) {
        return La2(h10, function(N10, z10, te2) {
          g10(T10, N10, E4(N10), te2);
        }), T10;
      }
      function Lg(h10, g10) {
        return h10 && Ti2(g10, Ln2(g10), h10);
      }
      function ea2(h10, g10, E4) {
        g10 == "__proto__" && Vc2 ? Vc2(h10, g10, { configurable: true, enumerable: true, value: E4, writable: true }) : h10[g10] = E4;
      }
      function qf(h10, g10) {
        for (var E4 = -1, T10 = g10.length, N10 = Ne2(T10), z10 = h10 == null; ++E4 < T10; )
          N10[E4] = z10 ? n3 : Ch(h10, g10[E4]);
        return N10;
      }
      function mo2(h10, g10, E4) {
        return h10 == h10 && (E4 !== n3 && (h10 = h10 <= E4 ? h10 : E4), g10 !== n3 && (h10 = h10 >= g10 ? h10 : g10)), h10;
      }
      function Gr2(h10, g10, E4, T10, N10, z10) {
        var te2, re2 = g10 & c3, se2 = g10 & f3, be2 = g10 & p3;
        if (E4 && (te2 = N10 ? E4(h10, T10, N10, z10) : E4(h10)), te2 !== n3)
          return te2;
        if (!cn2(h10))
          return h10;
        var ve2 = st2(h10);
        if (ve2) {
          if (te2 = function(Se2) {
            var Te2 = Se2.length, et2 = new Se2.constructor(Te2);
            return Te2 && typeof Se2[0] == "string" && qt2.call(Se2, "index") && (et2.index = Se2.index, et2.input = Se2.input), et2;
          }(h10), !re2)
            return pr2(h10, te2);
        } else {
          var Ae2 = Kn2(h10), Ue2 = Ae2 == Fe2 || Ae2 == Pe2;
          if (Ma2(h10))
            return a1(h10, re2);
          if (Ae2 == ae2 || Ae2 == ne2 || Ue2 && !N10) {
            if (te2 = se2 || Ue2 ? {} : k1(h10), !re2)
              return se2 ? function(Se2, Te2) {
                return Ti2(Se2, C1(Se2), Te2);
              }(h10, function(Se2, Te2) {
                return Se2 && Ti2(Te2, hr2(Te2), Se2);
              }(te2, h10)) : function(Se2, Te2) {
                return Ti2(Se2, ph(Se2), Te2);
              }(h10, Lg(te2, h10));
          } else {
            if (!Xt2[Ae2])
              return N10 ? h10 : {};
            te2 = function(Se2, Te2, et2) {
              var Le2 = Se2.constructor;
              switch (Te2) {
                case Jt2:
                  return ih(Se2);
                case j3:
                case ie2:
                  return new Le2(+Se2);
                case zt2:
                  return function(nt2, Bt2) {
                    var Ge2 = Bt2 ? ih(nt2.buffer) : nt2.buffer;
                    return new nt2.constructor(Ge2, nt2.byteOffset, nt2.byteLength);
                  }(Se2, et2);
                case wn2:
                case Z3:
                case ee2:
                case oe2:
                case le2:
                case we2:
                case Me2:
                case Ve2:
                case $e2:
                  return o1(Se2, et2);
                case _3:
                  return new Le2();
                case Q3:
                case _e2:
                  return new Le2(Se2);
                case De2:
                  return function(nt2) {
                    var Bt2 = new nt2.constructor(nt2.source, je2.exec(nt2));
                    return Bt2.lastIndex = nt2.lastIndex, Bt2;
                  }(Se2);
                case Ee2:
                  return new Le2();
                case Oe2:
                  return ut2 = Se2, su2 ? en2(su2.call(ut2)) : {};
              }
              var ut2;
            }(h10, Ae2, re2);
          }
        }
        z10 || (z10 = new di2());
        var qe2 = z10.get(h10);
        if (qe2)
          return qe2;
        z10.set(h10, te2), X1(h10) ? h10.forEach(function(Se2) {
          te2.add(Gr2(Se2, g10, E4, Se2, h10, z10));
        }) : J1(h10) && h10.forEach(function(Se2, Te2) {
          te2.set(Te2, Gr2(Se2, g10, E4, Te2, h10, z10));
        });
        var Qe2 = ve2 ? n3 : (be2 ? se2 ? uh : sh : se2 ? hr2 : Ln2)(h10);
        return qr2(Qe2 || h10, function(Se2, Te2) {
          Qe2 && (Se2 = h10[Te2 = Se2]), uu2(te2, Te2, Gr2(Se2, g10, E4, Te2, h10, z10));
        }), te2;
      }
      function Ng(h10, g10, E4) {
        var T10 = E4.length;
        if (h10 == null)
          return !T10;
        for (h10 = en2(h10); T10--; ) {
          var N10 = E4[T10], z10 = g10[N10], te2 = h10[N10];
          if (te2 === n3 && !(N10 in h10) || !z10(te2))
            return false;
        }
        return true;
      }
      function jg(h10, g10, E4) {
        if (typeof h10 != "function")
          throw new Wr2(a3);
        return mu2(function() {
          h10.apply(n3, E4);
        }, g10);
      }
      function cu2(h10, g10, E4, T10) {
        var N10 = -1, z10 = _c2, te2 = true, re2 = h10.length, se2 = [], be2 = g10.length;
        if (!re2)
          return se2;
        E4 && (g10 = un2(g10, wr2(E4))), T10 ? (z10 = Af, te2 = false) : g10.length >= r3 && (z10 = nu2, te2 = false, g10 = new ho2(g10));
        e:
          for (; ++N10 < re2; ) {
            var ve2 = h10[N10], Ae2 = E4 == null ? ve2 : E4(ve2);
            if (ve2 = T10 || ve2 !== 0 ? ve2 : 0, te2 && Ae2 == Ae2) {
              for (var Ue2 = be2; Ue2--; )
                if (g10[Ue2] === Ae2)
                  continue e;
              se2.push(ve2);
            } else
              z10(g10, Ae2, T10) || se2.push(ve2);
          }
        return se2;
      }
      U3.templateSettings = { escape: jt2, evaluate: dn2, interpolate: Rn2, variable: "", imports: { _: U3 } }, U3.prototype = Gc2.prototype, U3.prototype.constructor = U3, $r2.prototype = Zo2(Gc2.prototype), $r2.prototype.constructor = $r2, St2.prototype = Zo2(Gc2.prototype), St2.prototype.constructor = St2, fo2.prototype.clear = function() {
        this.__data__ = ou2 ? ou2(null) : {}, this.size = 0;
      }, fo2.prototype.delete = function(h10) {
        var g10 = this.has(h10) && delete this.__data__[h10];
        return this.size -= g10 ? 1 : 0, g10;
      }, fo2.prototype.get = function(h10) {
        var g10 = this.__data__;
        if (ou2) {
          var E4 = g10[h10];
          return E4 === s3 ? n3 : E4;
        }
        return qt2.call(g10, h10) ? g10[h10] : n3;
      }, fo2.prototype.has = function(h10) {
        var g10 = this.__data__;
        return ou2 ? g10[h10] !== n3 : qt2.call(g10, h10);
      }, fo2.prototype.set = function(h10, g10) {
        var E4 = this.__data__;
        return this.size += this.has(h10) ? 0 : 1, E4[h10] = ou2 && g10 === n3 ? s3 : g10, this;
      }, Yi2.prototype.clear = function() {
        this.__data__ = [], this.size = 0;
      }, Yi2.prototype.delete = function(h10) {
        var g10 = this.__data__, E4 = zc2(g10, h10);
        return !(E4 < 0) && (E4 == g10.length - 1 ? g10.pop() : Mc2.call(g10, E4, 1), --this.size, true);
      }, Yi2.prototype.get = function(h10) {
        var g10 = this.__data__, E4 = zc2(g10, h10);
        return E4 < 0 ? n3 : g10[E4][1];
      }, Yi2.prototype.has = function(h10) {
        return zc2(this.__data__, h10) > -1;
      }, Yi2.prototype.set = function(h10, g10) {
        var E4 = this.__data__, T10 = zc2(E4, h10);
        return T10 < 0 ? (++this.size, E4.push([h10, g10])) : E4[T10][1] = g10, this;
      }, Zi2.prototype.clear = function() {
        this.size = 0, this.__data__ = { hash: new fo2(), map: new (iu2 || Yi2)(), string: new fo2() };
      }, Zi2.prototype.delete = function(h10) {
        var g10 = il(this, h10).delete(h10);
        return this.size -= g10 ? 1 : 0, g10;
      }, Zi2.prototype.get = function(h10) {
        return il(this, h10).get(h10);
      }, Zi2.prototype.has = function(h10) {
        return il(this, h10).has(h10);
      }, Zi2.prototype.set = function(h10, g10) {
        var E4 = il(this, h10), T10 = E4.size;
        return E4.set(h10, g10), this.size += E4.size == T10 ? 0 : 1, this;
      }, ho2.prototype.add = ho2.prototype.push = function(h10) {
        return this.__data__.set(h10, s3), this;
      }, ho2.prototype.has = function(h10) {
        return this.__data__.has(h10);
      }, di2.prototype.clear = function() {
        this.__data__ = new Yi2(), this.size = 0;
      }, di2.prototype.delete = function(h10) {
        var g10 = this.__data__, E4 = g10.delete(h10);
        return this.size = g10.size, E4;
      }, di2.prototype.get = function(h10) {
        return this.__data__.get(h10);
      }, di2.prototype.has = function(h10) {
        return this.__data__.has(h10);
      }, di2.prototype.set = function(h10, g10) {
        var E4 = this.__data__;
        if (E4 instanceof Yi2) {
          var T10 = E4.__data__;
          if (!iu2 || T10.length < r3 - 1)
            return T10.push([h10, g10]), this.size = ++E4.size, this;
          E4 = this.__data__ = new Zi2(T10);
        }
        return E4.set(h10, g10), this.size = E4.size, this;
      };
      var La2 = l1(_i2), Rg = l1($f, true);
      function U32(h10, g10) {
        var E4 = true;
        return La2(h10, function(T10, N10, z10) {
          return E4 = !!g10(T10, N10, z10);
        }), E4;
      }
      function Hc2(h10, g10, E4) {
        for (var T10 = -1, N10 = h10.length; ++T10 < N10; ) {
          var z10 = h10[T10], te2 = g10(z10);
          if (te2 != null && (re2 === n3 ? te2 == te2 && !_r2(te2) : E4(te2, re2)))
            var re2 = te2, se2 = z10;
        }
        return se2;
      }
      function Mg(h10, g10) {
        var E4 = [];
        return La2(h10, function(T10, N10, z10) {
          g10(T10, N10, z10) && E4.push(T10);
        }), E4;
      }
      function Un2(h10, g10, E4, T10, N10) {
        var z10 = -1, te2 = h10.length;
        for (E4 || (E4 = Z32), N10 || (N10 = []); ++z10 < te2; ) {
          var re2 = h10[z10];
          g10 > 0 && E4(re2) ? g10 > 1 ? Un2(re2, g10 - 1, E4, T10, N10) : Ia2(N10, re2) : T10 || (N10[N10.length] = re2);
        }
        return N10;
      }
      var Wf = p1(), Vg = p1(true);
      function _i2(h10, g10) {
        return h10 && Wf(h10, g10, Ln2);
      }
      function $f(h10, g10) {
        return h10 && Vg(h10, g10, Ln2);
      }
      function Kc2(h10, g10) {
        return Pa2(g10, function(E4) {
          return ia2(h10[E4]);
        });
      }
      function es2(h10, g10) {
        for (var E4 = 0, T10 = (g10 = ja2(g10, h10)).length; h10 != null && E4 < T10; )
          h10 = h10[Pi2(g10[E4++])];
        return E4 && E4 == T10 ? h10 : n3;
      }
      function Ug(h10, g10, E4) {
        var T10 = g10(h10);
        return st2(h10) ? T10 : Ia2(T10, E4(h10));
      }
      function nr2(h10) {
        return h10 == null ? h10 === n3 ? Ye2 : Y3 : po2 && po2 in en2(h10) ? function(g10) {
          var E4 = qt2.call(g10, po2), T10 = g10[po2];
          try {
            g10[po2] = n3;
            var N10 = true;
          } catch {
          }
          var z10 = Lc2.call(g10);
          return N10 && (E4 ? g10[po2] = T10 : delete g10[po2]), z10;
        }(h10) : function(g10) {
          return Lc2.call(g10);
        }(h10);
      }
      function Gf(h10, g10) {
        return h10 > g10;
      }
      function q32(h10, g10) {
        return h10 != null && qt2.call(h10, g10);
      }
      function W32(h10, g10) {
        return h10 != null && g10 in en2(h10);
      }
      function zf(h10, g10, E4) {
        for (var T10 = E4 ? Af : _c2, N10 = h10[0].length, z10 = h10.length, te2 = z10, re2 = Ne2(z10), se2 = 1 / 0, be2 = []; te2--; ) {
          var ve2 = h10[te2];
          te2 && g10 && (ve2 = un2(ve2, wr2(g10))), se2 = Hn2(ve2.length, se2), re2[te2] = !E4 && (g10 || N10 >= 120 && ve2.length >= 120) ? new ho2(te2 && ve2) : n3;
        }
        ve2 = h10[0];
        var Ae2 = -1, Ue2 = re2[0];
        e:
          for (; ++Ae2 < N10 && be2.length < se2; ) {
            var qe2 = ve2[Ae2], Qe2 = g10 ? g10(qe2) : qe2;
            if (qe2 = E4 || qe2 !== 0 ? qe2 : 0, !(Ue2 ? nu2(Ue2, Qe2) : T10(be2, Qe2, E4))) {
              for (te2 = z10; --te2; ) {
                var Se2 = re2[te2];
                if (!(Se2 ? nu2(Se2, Qe2) : T10(h10[te2], Qe2, E4)))
                  continue e;
              }
              Ue2 && Ue2.push(Qe2), be2.push(qe2);
            }
          }
        return be2;
      }
      function lu2(h10, g10, E4) {
        var T10 = (h10 = A1(h10, g10 = ja2(g10, h10))) == null ? h10 : h10[Pi2(Hr2(g10))];
        return T10 == null ? n3 : Fr2(T10, h10, E4);
      }
      function qg(h10) {
        return mn2(h10) && nr2(h10) == ne2;
      }
      function pu2(h10, g10, E4, T10, N10) {
        return h10 === g10 || (h10 == null || g10 == null || !mn2(h10) && !mn2(g10) ? h10 != h10 && g10 != g10 : function(z10, te2, re2, se2, be2, ve2) {
          var Ae2 = st2(z10), Ue2 = st2(te2), qe2 = Ae2 ? de2 : Kn2(z10), Qe2 = Ue2 ? de2 : Kn2(te2), Se2 = (qe2 = qe2 == ne2 ? ae2 : qe2) == ae2, Te2 = (Qe2 = Qe2 == ne2 ? ae2 : Qe2) == ae2, et2 = qe2 == Qe2;
          if (et2 && Ma2(z10)) {
            if (!Ma2(te2))
              return false;
            Ae2 = true, Se2 = false;
          }
          if (et2 && !Se2)
            return ve2 || (ve2 = new di2()), Ae2 || is2(z10) ? E1(z10, te2, re2, se2, be2, ve2) : function(Ge2, tt2, Tn2, Sn2, ir2, tn2, Jn2) {
              switch (Tn2) {
                case zt2:
                  if (Ge2.byteLength != tt2.byteLength || Ge2.byteOffset != tt2.byteOffset)
                    return false;
                  Ge2 = Ge2.buffer, tt2 = tt2.buffer;
                case Jt2:
                  return !(Ge2.byteLength != tt2.byteLength || !tn2(new jc2(Ge2), new jc2(tt2)));
                case j3:
                case ie2:
                case Q3:
                  return mi2(+Ge2, +tt2);
                case ge2:
                  return Ge2.name == tt2.name && Ge2.message == tt2.message;
                case De2:
                case _e2:
                  return Ge2 == tt2 + "";
                case _3:
                  var Ii2 = Nf;
                case Ee2:
                  var Va2 = Sn2 & d3;
                  if (Ii2 || (Ii2 = Pc2), Ge2.size != tt2.size && !Va2)
                    return false;
                  var dl = Jn2.get(Ge2);
                  if (dl)
                    return dl == tt2;
                  Sn2 |= m3, Jn2.set(Ge2, tt2);
                  var os2 = E1(Ii2(Ge2), Ii2(tt2), Sn2, ir2, tn2, Jn2);
                  return Jn2.delete(Ge2), os2;
                case Oe2:
                  if (su2)
                    return su2.call(Ge2) == su2.call(tt2);
              }
              return false;
            }(z10, te2, qe2, re2, se2, be2, ve2);
          if (!(re2 & d3)) {
            var Le2 = Se2 && qt2.call(z10, "__wrapped__"), ut2 = Te2 && qt2.call(te2, "__wrapped__");
            if (Le2 || ut2) {
              var nt2 = Le2 ? z10.value() : z10, Bt2 = ut2 ? te2.value() : te2;
              return ve2 || (ve2 = new di2()), be2(nt2, Bt2, re2, se2, ve2);
            }
          }
          return et2 ? (ve2 || (ve2 = new di2()), function(Ge2, tt2, Tn2, Sn2, ir2, tn2) {
            var Jn2 = Tn2 & d3, Ii2 = sh(Ge2), Va2 = Ii2.length, dl = sh(tt2).length;
            if (Va2 != dl && !Jn2)
              return false;
            for (var os2 = Va2; os2--; ) {
              var Ua2 = Ii2[os2];
              if (!(Jn2 ? Ua2 in tt2 : qt2.call(tt2, Ua2)))
                return false;
            }
            var py = tn2.get(Ge2);
            if (py && tn2.get(tt2))
              return py == tt2;
            var ml = true;
            tn2.set(Ge2, tt2), tn2.set(tt2, Ge2);
            for (var Ih = Jn2; ++os2 < Va2; ) {
              Ua2 = Ii2[os2];
              var gl = Ge2[Ua2], yl = tt2[Ua2];
              if (Sn2)
                var fy = Jn2 ? Sn2(yl, gl, Ua2, tt2, Ge2, tn2) : Sn2(gl, yl, Ua2, Ge2, tt2, tn2);
              if (!(fy === n3 ? gl === yl || ir2(gl, yl, Tn2, Sn2, tn2) : fy)) {
                ml = false;
                break;
              }
              Ih || (Ih = Ua2 == "constructor");
            }
            if (ml && !Ih) {
              var vl = Ge2.constructor, xl = tt2.constructor;
              vl != xl && "constructor" in Ge2 && "constructor" in tt2 && !(typeof vl == "function" && vl instanceof vl && typeof xl == "function" && xl instanceof xl) && (ml = false);
            }
            return tn2.delete(Ge2), tn2.delete(tt2), ml;
          }(z10, te2, re2, se2, be2, ve2)) : false;
        }(h10, g10, E4, T10, pu2, N10));
      }
      function Hf(h10, g10, E4, T10) {
        var N10 = E4.length, z10 = N10, te2 = !T10;
        if (h10 == null)
          return !z10;
        for (h10 = en2(h10); N10--; ) {
          var re2 = E4[N10];
          if (te2 && re2[2] ? re2[1] !== h10[re2[0]] : !(re2[0] in h10))
            return false;
        }
        for (; ++N10 < z10; ) {
          var se2 = (re2 = E4[N10])[0], be2 = h10[se2], ve2 = re2[1];
          if (te2 && re2[2]) {
            if (be2 === n3 && !(se2 in h10))
              return false;
          } else {
            var Ae2 = new di2();
            if (T10)
              var Ue2 = T10(be2, ve2, se2, h10, g10, Ae2);
            if (!(Ue2 === n3 ? pu2(ve2, be2, d3 | m3, T10, Ae2) : Ue2))
              return false;
          }
        }
        return true;
      }
      function Wg(h10) {
        return !(!cn2(h10) || (g10 = h10, Dg && Dg in g10)) && (ia2(h10) ? S32 : Rt2).test(yo2(h10));
        var g10;
      }
      function $g(h10) {
        return typeof h10 == "function" ? h10 : h10 == null ? dr2 : xe$3(h10) == "object" ? st2(h10) ? Hg(h10[0], h10[1]) : zg(h10) : ly(h10);
      }
      function Kf(h10) {
        if (!du2(h10))
          return _32(h10);
        var g10 = [];
        for (var E4 in en2(h10))
          qt2.call(h10, E4) && E4 != "constructor" && g10.push(E4);
        return g10;
      }
      function $3(h10) {
        if (!cn2(h10))
          return function(N10) {
            var z10 = [];
            if (N10 != null)
              for (var te2 in en2(N10))
                z10.push(te2);
            return z10;
          }(h10);
        var g10 = du2(h10), E4 = [];
        for (var T10 in h10)
          (T10 != "constructor" || !g10 && qt2.call(h10, T10)) && E4.push(T10);
        return E4;
      }
      function Jf(h10, g10) {
        return h10 < g10;
      }
      function Gg(h10, g10) {
        var E4 = -1, T10 = fr2(h10) ? Ne2(h10.length) : [];
        return La2(h10, function(N10, z10, te2) {
          T10[++E4] = g10(N10, z10, te2);
        }), T10;
      }
      function zg(h10) {
        var g10 = lh(h10);
        return g10.length == 1 && g10[0][2] ? F1(g10[0][0], g10[0][1]) : function(E4) {
          return E4 === h10 || Hf(E4, h10, g10);
        };
      }
      function Hg(h10, g10) {
        return fh(h10) && D1(g10) ? F1(Pi2(h10), g10) : function(E4) {
          var T10 = Ch(E4, h10);
          return T10 === n3 && T10 === g10 ? Sh(E4, h10) : pu2(g10, T10, d3 | m3);
        };
      }
      function Jc2(h10, g10, E4, T10, N10) {
        h10 !== g10 && Wf(g10, function(z10, te2) {
          if (N10 || (N10 = new di2()), cn2(z10))
            (function(se2, be2, ve2, Ae2, Ue2, qe2, Qe2) {
              var Se2 = dh(se2, ve2), Te2 = dh(be2, ve2), et2 = Qe2.get(Te2);
              if (et2)
                return void Uf(se2, ve2, et2);
              var Le2 = qe2 ? qe2(Se2, Te2, ve2 + "", se2, be2, Qe2) : n3, ut2 = Le2 === n3;
              if (ut2) {
                var nt2 = st2(Te2), Bt2 = !nt2 && Ma2(Te2), Ge2 = !nt2 && !Bt2 && is2(Te2);
                Le2 = Te2, nt2 || Bt2 || Ge2 ? st2(Se2) ? Le2 = Se2 : Cn2(Se2) ? Le2 = pr2(Se2) : Bt2 ? (ut2 = false, Le2 = a1(Te2, true)) : Ge2 ? (ut2 = false, Le2 = o1(Te2, true)) : Le2 = [] : gu2(Te2) || vo2(Te2) ? (Le2 = Se2, vo2(Se2) ? Le2 = ey(Se2) : cn2(Se2) && !ia2(Se2) || (Le2 = k1(Te2))) : ut2 = false;
              }
              ut2 && (Qe2.set(Te2, Le2), Ue2(Le2, Te2, Ae2, qe2, Qe2), Qe2.delete(Te2)), Uf(se2, ve2, Le2);
            })(h10, g10, te2, E4, Jc2, T10, N10);
          else {
            var re2 = T10 ? T10(dh(h10, te2), z10, te2 + "", h10, g10, N10) : n3;
            re2 === n3 && (re2 = z10), Uf(h10, te2, re2);
          }
        }, hr2);
      }
      function Kg(h10, g10) {
        var E4 = h10.length;
        if (E4)
          return ra2(g10 += g10 < 0 ? E4 : 0, E4) ? h10[g10] : n3;
      }
      function Jg(h10, g10, E4) {
        var T10 = -1;
        return g10 = un2(g10.length ? g10 : [dr2], wr2(Je2())), function(N10, z10) {
          var te2 = N10.length;
          for (N10.sort(z10); te2--; )
            N10[te2] = N10[te2].value;
          return N10;
        }(Gg(h10, function(N10, z10, te2) {
          return { criteria: un2(g10, function(re2) {
            return re2(N10);
          }), index: ++T10, value: N10 };
        }), function(N10, z10) {
          return function(te2, re2, se2) {
            for (var be2 = -1, ve2 = te2.criteria, Ae2 = re2.criteria, Ue2 = ve2.length, qe2 = se2.length; ++be2 < Ue2; ) {
              var Qe2 = s1(ve2[be2], Ae2[be2]);
              if (Qe2) {
                if (be2 >= qe2)
                  return Qe2;
                var Se2 = se2[be2];
                return Qe2 * (Se2 == "desc" ? -1 : 1);
              }
            }
            return te2.index - re2.index;
          }(N10, z10, E4);
        });
      }
      function Qg(h10, g10, E4) {
        for (var T10 = -1, N10 = g10.length, z10 = {}; ++T10 < N10; ) {
          var te2 = g10[T10], re2 = es2(h10, te2);
          E4(re2, te2) && fu2(z10, ja2(te2, h10), re2);
        }
        return z10;
      }
      function Qf(h10, g10, E4, T10) {
        var N10 = T10 ? f32 : zo2, z10 = -1, te2 = g10.length, re2 = h10;
        for (h10 === g10 && (g10 = pr2(g10)), E4 && (re2 = un2(h10, wr2(E4))); ++z10 < te2; )
          for (var se2 = 0, be2 = g10[z10], ve2 = E4 ? E4(be2) : be2; (se2 = N10(re2, ve2, se2, T10)) > -1; )
            re2 !== h10 && Mc2.call(re2, se2, 1), Mc2.call(h10, se2, 1);
        return h10;
      }
      function Xg(h10, g10) {
        for (var E4 = h10 ? g10.length : 0, T10 = E4 - 1; E4--; ) {
          var N10 = g10[E4];
          if (E4 == T10 || N10 !== z10) {
            var z10 = N10;
            ra2(N10) ? Mc2.call(h10, N10, 1) : eh(h10, N10);
          }
        }
        return h10;
      }
      function Xf(h10, g10) {
        return h10 + qc2(Pg() * (g10 - h10 + 1));
      }
      function Yf(h10, g10) {
        var E4 = "";
        if (!h10 || g10 < 1 || g10 > R3)
          return E4;
        do
          g10 % 2 && (E4 += h10), (g10 = qc2(g10 / 2)) && (h10 += h10);
        while (g10);
        return E4;
      }
      function mt2(h10, g10) {
        return mh(w1(h10, g10, dr2), h10 + "");
      }
      function G3(h10) {
        return Og(as2(h10));
      }
      function z3(h10, g10) {
        var E4 = as2(h10);
        return al(E4, mo2(g10, 0, E4.length));
      }
      function fu2(h10, g10, E4, T10) {
        if (!cn2(h10))
          return h10;
        for (var N10 = -1, z10 = (g10 = ja2(g10, h10)).length, te2 = z10 - 1, re2 = h10; re2 != null && ++N10 < z10; ) {
          var se2 = Pi2(g10[N10]), be2 = E4;
          if (N10 != te2) {
            var ve2 = re2[se2];
            (be2 = T10 ? T10(ve2, se2, re2) : n3) === n3 && (be2 = cn2(ve2) ? ve2 : ra2(g10[N10 + 1]) ? [] : {});
          }
          uu2(re2, se2, be2), re2 = re2[se2];
        }
        return h10;
      }
      var Yg = Wc2 ? function(h10, g10) {
        return Wc2.set(h10, g10), h10;
      } : dr2, H3 = Vc2 ? function(h10, g10) {
        return Vc2(h10, "toString", { configurable: true, enumerable: false, value: Dh(g10), writable: true });
      } : dr2;
      function K32(h10) {
        return al(as2(h10));
      }
      function zr2(h10, g10, E4) {
        var T10 = -1, N10 = h10.length;
        g10 < 0 && (g10 = -g10 > N10 ? 0 : N10 + g10), (E4 = E4 > N10 ? N10 : E4) < 0 && (E4 += N10), N10 = g10 > E4 ? 0 : E4 - g10 >>> 0, g10 >>>= 0;
        for (var z10 = Ne2(N10); ++T10 < N10; )
          z10[T10] = h10[T10 + g10];
        return z10;
      }
      function J32(h10, g10) {
        var E4;
        return La2(h10, function(T10, N10, z10) {
          return !(E4 = g10(T10, N10, z10));
        }), !!E4;
      }
      function Qc2(h10, g10, E4) {
        var T10 = 0, N10 = h10 == null ? T10 : h10.length;
        if (typeof g10 == "number" && g10 == g10 && N10 <= A3) {
          for (; T10 < N10; ) {
            var z10 = T10 + N10 >>> 1, te2 = h10[z10];
            te2 !== null && !_r2(te2) && (E4 ? te2 <= g10 : te2 < g10) ? T10 = z10 + 1 : N10 = z10;
          }
          return N10;
        }
        return Zf(h10, g10, dr2, E4);
      }
      function Zf(h10, g10, E4, T10) {
        g10 = E4(g10);
        for (var N10 = 0, z10 = h10 == null ? 0 : h10.length, te2 = g10 != g10, re2 = g10 === null, se2 = _r2(g10), be2 = g10 === n3; N10 < z10; ) {
          var ve2 = qc2((N10 + z10) / 2), Ae2 = E4(h10[ve2]), Ue2 = Ae2 !== n3, qe2 = Ae2 === null, Qe2 = Ae2 == Ae2, Se2 = _r2(Ae2);
          if (te2)
            var Te2 = T10 || Qe2;
          else
            Te2 = be2 ? Qe2 && (T10 || Ue2) : re2 ? Qe2 && Ue2 && (T10 || !qe2) : se2 ? Qe2 && Ue2 && !qe2 && (T10 || !Se2) : !qe2 && !Se2 && (T10 ? Ae2 <= g10 : Ae2 < g10);
          Te2 ? N10 = ve2 + 1 : z10 = ve2;
        }
        return Hn2(z10, ce2);
      }
      function Zg(h10, g10) {
        for (var E4 = -1, T10 = h10.length, N10 = 0, z10 = []; ++E4 < T10; ) {
          var te2 = h10[E4], re2 = g10 ? g10(te2) : te2;
          if (!E4 || !mi2(re2, se2)) {
            var se2 = re2;
            z10[N10++] = te2 === 0 ? 0 : te2;
          }
        }
        return z10;
      }
      function e1(h10) {
        return typeof h10 == "number" ? h10 : _r2(h10) ? J3 : +h10;
      }
      function Ar2(h10) {
        if (typeof h10 == "string")
          return h10;
        if (st2(h10))
          return un2(h10, Ar2) + "";
        if (_r2(h10))
          return Ig ? Ig.call(h10) : "";
        var g10 = h10 + "";
        return g10 == "0" && 1 / h10 == -W3 ? "-0" : g10;
      }
      function Na2(h10, g10, E4) {
        var T10 = -1, N10 = _c2, z10 = h10.length, te2 = true, re2 = [], se2 = re2;
        if (E4)
          te2 = false, N10 = Af;
        else if (z10 >= r3) {
          var be2 = g10 ? null : X32(h10);
          if (be2)
            return Pc2(be2);
          te2 = false, N10 = nu2, se2 = new ho2();
        } else
          se2 = g10 ? [] : re2;
        e:
          for (; ++T10 < z10; ) {
            var ve2 = h10[T10], Ae2 = g10 ? g10(ve2) : ve2;
            if (ve2 = E4 || ve2 !== 0 ? ve2 : 0, te2 && Ae2 == Ae2) {
              for (var Ue2 = se2.length; Ue2--; )
                if (se2[Ue2] === Ae2)
                  continue e;
              g10 && se2.push(Ae2), re2.push(ve2);
            } else
              N10(se2, Ae2, E4) || (se2 !== re2 && se2.push(Ae2), re2.push(ve2));
          }
        return re2;
      }
      function eh(h10, g10) {
        return (h10 = A1(h10, g10 = ja2(g10, h10))) == null || delete h10[Pi2(Hr2(g10))];
      }
      function t1(h10, g10, E4, T10) {
        return fu2(h10, g10, E4(es2(h10, g10)), T10);
      }
      function Xc2(h10, g10, E4, T10) {
        for (var N10 = h10.length, z10 = T10 ? N10 : -1; (T10 ? z10-- : ++z10 < N10) && g10(h10[z10], z10, h10); )
          ;
        return E4 ? zr2(h10, T10 ? 0 : z10, T10 ? z10 + 1 : N10) : zr2(h10, T10 ? z10 + 1 : 0, T10 ? N10 : z10);
      }
      function n1(h10, g10) {
        var E4 = h10;
        return E4 instanceof St2 && (E4 = E4.value()), _f(g10, function(T10, N10) {
          return N10.func.apply(N10.thisArg, Ia2([T10], N10.args));
        }, E4);
      }
      function th(h10, g10, E4) {
        var T10 = h10.length;
        if (T10 < 2)
          return T10 ? Na2(h10[0]) : [];
        for (var N10 = -1, z10 = Ne2(T10); ++N10 < T10; )
          for (var te2 = h10[N10], re2 = -1; ++re2 < T10; )
            re2 != N10 && (z10[N10] = cu2(z10[N10] || te2, h10[re2], g10, E4));
        return Na2(Un2(z10, 1), g10, E4);
      }
      function r1(h10, g10, E4) {
        for (var T10 = -1, N10 = h10.length, z10 = g10.length, te2 = {}; ++T10 < N10; ) {
          var re2 = T10 < z10 ? g10[T10] : n3;
          E4(te2, h10[T10], re2);
        }
        return te2;
      }
      function nh(h10) {
        return Cn2(h10) ? h10 : [];
      }
      function rh(h10) {
        return typeof h10 == "function" ? h10 : dr2;
      }
      function ja2(h10, g10) {
        return st2(h10) ? h10 : fh(h10, g10) ? [h10] : I1(Vt2(h10));
      }
      var Q32 = mt2;
      function Ra2(h10, g10, E4) {
        var T10 = h10.length;
        return E4 = E4 === n3 ? T10 : E4, !g10 && E4 >= T10 ? h10 : zr2(h10, g10, E4);
      }
      var i1 = k32 || function(h10) {
        return Vn2.clearTimeout(h10);
      };
      function a1(h10, g10) {
        if (g10)
          return h10.slice();
        var E4 = h10.length, T10 = Fg ? Fg(E4) : new h10.constructor(E4);
        return h10.copy(T10), T10;
      }
      function ih(h10) {
        var g10 = new h10.constructor(h10.byteLength);
        return new jc2(g10).set(new jc2(h10)), g10;
      }
      function o1(h10, g10) {
        var E4 = g10 ? ih(h10.buffer) : h10.buffer;
        return new h10.constructor(E4, h10.byteOffset, h10.length);
      }
      function s1(h10, g10) {
        if (h10 !== g10) {
          var E4 = h10 !== n3, T10 = h10 === null, N10 = h10 == h10, z10 = _r2(h10), te2 = g10 !== n3, re2 = g10 === null, se2 = g10 == g10, be2 = _r2(g10);
          if (!re2 && !be2 && !z10 && h10 > g10 || z10 && te2 && se2 && !re2 && !be2 || T10 && te2 && se2 || !E4 && se2 || !N10)
            return 1;
          if (!T10 && !z10 && !be2 && h10 < g10 || be2 && E4 && N10 && !T10 && !z10 || re2 && E4 && N10 || !te2 && N10 || !se2)
            return -1;
        }
        return 0;
      }
      function u1(h10, g10, E4, T10) {
        for (var N10 = -1, z10 = h10.length, te2 = E4.length, re2 = -1, se2 = g10.length, be2 = _n2(z10 - te2, 0), ve2 = Ne2(se2 + be2), Ae2 = !T10; ++re2 < se2; )
          ve2[re2] = g10[re2];
        for (; ++N10 < te2; )
          (Ae2 || N10 < z10) && (ve2[E4[N10]] = h10[N10]);
        for (; be2--; )
          ve2[re2++] = h10[N10++];
        return ve2;
      }
      function c1(h10, g10, E4, T10) {
        for (var N10 = -1, z10 = h10.length, te2 = -1, re2 = E4.length, se2 = -1, be2 = g10.length, ve2 = _n2(z10 - re2, 0), Ae2 = Ne2(ve2 + be2), Ue2 = !T10; ++N10 < ve2; )
          Ae2[N10] = h10[N10];
        for (var qe2 = N10; ++se2 < be2; )
          Ae2[qe2 + se2] = g10[se2];
        for (; ++te2 < re2; )
          (Ue2 || N10 < z10) && (Ae2[qe2 + E4[te2]] = h10[N10++]);
        return Ae2;
      }
      function pr2(h10, g10) {
        var E4 = -1, T10 = h10.length;
        for (g10 || (g10 = Ne2(T10)); ++E4 < T10; )
          g10[E4] = h10[E4];
        return g10;
      }
      function Ti2(h10, g10, E4, T10) {
        var N10 = !E4;
        E4 || (E4 = {});
        for (var z10 = -1, te2 = g10.length; ++z10 < te2; ) {
          var re2 = g10[z10], se2 = T10 ? T10(E4[re2], h10[re2], re2, E4, h10) : n3;
          se2 === n3 && (se2 = h10[re2]), N10 ? ea2(E4, re2, se2) : uu2(E4, re2, se2);
        }
        return E4;
      }
      function Yc2(h10, g10) {
        return function(E4, T10) {
          var N10 = st2(E4) ? u32 : V32, z10 = g10 ? g10() : {};
          return N10(E4, h10, Je2(T10, 2), z10);
        };
      }
      function ts2(h10) {
        return mt2(function(g10, E4) {
          var T10 = -1, N10 = E4.length, z10 = N10 > 1 ? E4[N10 - 1] : n3, te2 = N10 > 2 ? E4[2] : n3;
          for (z10 = h10.length > 3 && typeof z10 == "function" ? (N10--, z10) : n3, te2 && rr2(E4[0], E4[1], te2) && (z10 = N10 < 3 ? n3 : z10, N10 = 1), g10 = en2(g10); ++T10 < N10; ) {
            var re2 = E4[T10];
            re2 && h10(g10, re2, T10, z10);
          }
          return g10;
        });
      }
      function l1(h10, g10) {
        return function(E4, T10) {
          if (E4 == null)
            return E4;
          if (!fr2(E4))
            return h10(E4, T10);
          for (var N10 = E4.length, z10 = g10 ? N10 : -1, te2 = en2(E4); (g10 ? z10-- : ++z10 < N10) && T10(te2[z10], z10, te2) !== false; )
            ;
          return E4;
        };
      }
      function p1(h10) {
        return function(g10, E4, T10) {
          for (var N10 = -1, z10 = en2(g10), te2 = T10(g10), re2 = te2.length; re2--; ) {
            var se2 = te2[h10 ? re2 : ++N10];
            if (E4(z10[se2], se2, z10) === false)
              break;
          }
          return g10;
        };
      }
      function f1(h10) {
        return function(g10) {
          var E4 = Ho2(g10 = Vt2(g10)) ? hi2(g10) : n3, T10 = E4 ? E4[0] : g10.charAt(0), N10 = E4 ? Ra2(E4, 1).join("") : g10.slice(1);
          return T10[h10]() + N10;
        };
      }
      function ns2(h10) {
        return function(g10) {
          return _f(uy(sy(g10).replace(XA, "")), h10, "");
        };
      }
      function hu2(h10) {
        return function() {
          var g10 = arguments;
          switch (g10.length) {
            case 0:
              return new h10();
            case 1:
              return new h10(g10[0]);
            case 2:
              return new h10(g10[0], g10[1]);
            case 3:
              return new h10(g10[0], g10[1], g10[2]);
            case 4:
              return new h10(g10[0], g10[1], g10[2], g10[3]);
            case 5:
              return new h10(g10[0], g10[1], g10[2], g10[3], g10[4]);
            case 6:
              return new h10(g10[0], g10[1], g10[2], g10[3], g10[4], g10[5]);
            case 7:
              return new h10(g10[0], g10[1], g10[2], g10[3], g10[4], g10[5], g10[6]);
          }
          var E4 = Zo2(h10.prototype), T10 = h10.apply(E4, g10);
          return cn2(T10) ? T10 : E4;
        };
      }
      function h1(h10) {
        return function(g10, E4, T10) {
          var N10 = en2(g10);
          if (!fr2(g10)) {
            var z10 = Je2(E4, 3);
            g10 = Ln2(g10), E4 = function(re2) {
              return z10(N10[re2], re2, N10);
            };
          }
          var te2 = h10(g10, E4, T10);
          return te2 > -1 ? N10[z10 ? g10[te2] : te2] : n3;
        };
      }
      function d1(h10) {
        return na2(function(g10) {
          var E4 = g10.length, T10 = E4, N10 = $r2.prototype.thru;
          for (h10 && g10.reverse(); T10--; ) {
            var z10 = g10[T10];
            if (typeof z10 != "function")
              throw new Wr2(a3);
            if (N10 && !te2 && rl(z10) == "wrapper")
              var te2 = new $r2([], true);
          }
          for (T10 = te2 ? T10 : E4; ++T10 < E4; ) {
            var re2 = rl(z10 = g10[T10]), se2 = re2 == "wrapper" ? ch(z10) : n3;
            te2 = se2 && hh(se2[0]) && se2[1] == (B3 | x3 | k3 | O3) && !se2[4].length && se2[9] == 1 ? te2[rl(se2[0])].apply(te2, se2[3]) : z10.length == 1 && hh(z10) ? te2[re2]() : te2.thru(z10);
          }
          return function() {
            var be2 = arguments, ve2 = be2[0];
            if (te2 && be2.length == 1 && st2(ve2))
              return te2.plant(ve2).value();
            for (var Ae2 = 0, Ue2 = E4 ? g10[Ae2].apply(this, be2) : ve2; ++Ae2 < E4; )
              Ue2 = g10[Ae2].call(this, Ue2);
            return Ue2;
          };
        });
      }
      function Zc2(h10, g10, E4, T10, N10, z10, te2, re2, se2, be2) {
        var ve2 = g10 & B3, Ae2 = g10 & y3, Ue2 = g10 & v3, qe2 = g10 & (x3 | C3), Qe2 = g10 & S3, Se2 = Ue2 ? n3 : hu2(h10);
        return function Te2() {
          for (var et2 = arguments.length, Le2 = Ne2(et2), ut2 = et2; ut2--; )
            Le2[ut2] = arguments[ut2];
          if (qe2)
            var nt2 = rs2(Te2), Bt2 = function(Sn2, ir2) {
              for (var tn2 = Sn2.length, Jn2 = 0; tn2--; )
                Sn2[tn2] === ir2 && ++Jn2;
              return Jn2;
            }(Le2, nt2);
          if (T10 && (Le2 = u1(Le2, T10, N10, qe2)), z10 && (Le2 = c1(Le2, z10, te2, qe2)), et2 -= Bt2, qe2 && et2 < be2) {
            var Ge2 = Ba2(Le2, nt2);
            return y1(h10, g10, Zc2, Te2.placeholder, E4, Le2, Ge2, re2, se2, be2 - et2);
          }
          var tt2 = Ae2 ? E4 : this, Tn2 = Ue2 ? tt2[h10] : h10;
          return et2 = Le2.length, re2 ? Le2 = function(Sn2, ir2) {
            for (var tn2 = Sn2.length, Jn2 = Hn2(ir2.length, tn2), Ii2 = pr2(Sn2); Jn2--; ) {
              var Va2 = ir2[Jn2];
              Sn2[Jn2] = ra2(Va2, tn2) ? Ii2[Va2] : n3;
            }
            return Sn2;
          }(Le2, re2) : Qe2 && et2 > 1 && Le2.reverse(), ve2 && se2 < et2 && (Le2.length = se2), this && this !== Vn2 && this instanceof Te2 && (Tn2 = Se2 || hu2(Tn2)), Tn2.apply(tt2, Le2);
        };
      }
      function m1(h10, g10) {
        return function(E4, T10) {
          return function(N10, z10, te2, re2) {
            return _i2(N10, function(se2, be2, ve2) {
              z10(re2, te2(se2), be2, ve2);
            }), re2;
          }(E4, h10, g10(T10), {});
        };
      }
      function el(h10, g10) {
        return function(E4, T10) {
          var N10;
          if (E4 === n3 && T10 === n3)
            return g10;
          if (E4 !== n3 && (N10 = E4), T10 !== n3) {
            if (N10 === n3)
              return T10;
            typeof E4 == "string" || typeof T10 == "string" ? (E4 = Ar2(E4), T10 = Ar2(T10)) : (E4 = e1(E4), T10 = e1(T10)), N10 = h10(E4, T10);
          }
          return N10;
        };
      }
      function ah(h10) {
        return na2(function(g10) {
          return g10 = un2(g10, wr2(Je2())), mt2(function(E4) {
            var T10 = this;
            return h10(g10, function(N10) {
              return Fr2(N10, T10, E4);
            });
          });
        });
      }
      function tl(h10, g10) {
        var E4 = (g10 = g10 === n3 ? " " : Ar2(g10)).length;
        if (E4 < 2)
          return E4 ? Yf(g10, h10) : g10;
        var T10 = Yf(g10, Uc2(h10 / Ko2(g10)));
        return Ho2(g10) ? Ra2(hi2(T10), 0, h10).join("") : T10.slice(0, h10);
      }
      function g1(h10) {
        return function(g10, E4, T10) {
          return T10 && typeof T10 != "number" && rr2(g10, E4, T10) && (E4 = T10 = n3), g10 = aa2(g10), E4 === n3 ? (E4 = g10, g10 = 0) : E4 = aa2(E4), function(N10, z10, te2, re2) {
            for (var se2 = -1, be2 = _n2(Uc2((z10 - N10) / (te2 || 1)), 0), ve2 = Ne2(be2); be2--; )
              ve2[re2 ? be2 : ++se2] = N10, N10 += te2;
            return ve2;
          }(g10, E4, T10 = T10 === n3 ? g10 < E4 ? 1 : -1 : aa2(T10), h10);
        };
      }
      function nl(h10) {
        return function(g10, E4) {
          return typeof g10 == "string" && typeof E4 == "string" || (g10 = Kr2(g10), E4 = Kr2(E4)), h10(g10, E4);
        };
      }
      function y1(h10, g10, E4, T10, N10, z10, te2, re2, se2, be2) {
        var ve2 = g10 & x3;
        g10 |= ve2 ? k3 : F3, (g10 &= ~(ve2 ? F3 : k3)) & b3 || (g10 &= ~(y3 | v3));
        var Ae2 = [h10, g10, N10, ve2 ? z10 : n3, ve2 ? te2 : n3, ve2 ? n3 : z10, ve2 ? n3 : te2, re2, se2, be2], Ue2 = E4.apply(n3, Ae2);
        return hh(h10) && _1(Ue2, Ae2), Ue2.placeholder = T10, T1(Ue2, h10, g10);
      }
      function oh(h10) {
        var g10 = Ai2[h10];
        return function(E4, T10) {
          if (E4 = Kr2(E4), (T10 = T10 == null ? 0 : Hn2(ft2(T10), 292)) && Tg(E4)) {
            var N10 = (Vt2(E4) + "e").split("e");
            return +((N10 = (Vt2(g10(N10[0] + "e" + (+N10[1] + T10))) + "e").split("e"))[0] + "e" + (+N10[1] - T10));
          }
          return g10(E4);
        };
      }
      var X32 = Xo2 && 1 / Pc2(new Xo2([, -0]))[1] == W3 ? function(h10) {
        return new Xo2(h10);
      } : Ah;
      function v12(h10) {
        return function(g10) {
          var E4 = Kn2(g10);
          return E4 == _3 ? Nf(g10) : E4 == Ee2 ? g3(g10) : function(T10, N10) {
            return un2(N10, function(z10) {
              return [z10, T10[z10]];
            });
          }(g10, h10(g10));
        };
      }
      function ta2(h10, g10, E4, T10, N10, z10, te2, re2) {
        var se2 = g10 & v3;
        if (!se2 && typeof h10 != "function")
          throw new Wr2(a3);
        var be2 = T10 ? T10.length : 0;
        if (be2 || (g10 &= ~(k3 | F3), T10 = N10 = n3), te2 = te2 === n3 ? te2 : _n2(ft2(te2), 0), re2 = re2 === n3 ? re2 : ft2(re2), be2 -= N10 ? N10.length : 0, g10 & F3) {
          var ve2 = T10, Ae2 = N10;
          T10 = N10 = n3;
        }
        var Ue2 = se2 ? n3 : ch(h10), qe2 = [h10, g10, E4, T10, N10, ve2, Ae2, z10, te2, re2];
        if (Ue2 && function(Se2, Te2) {
          var et2 = Se2[1], Le2 = Te2[1], ut2 = et2 | Le2, nt2 = ut2 < (y3 | v3 | B3), Bt2 = Le2 == B3 && et2 == x3 || Le2 == B3 && et2 == O3 && Se2[7].length <= Te2[8] || Le2 == (B3 | O3) && Te2[7].length <= Te2[8] && et2 == x3;
          if (!nt2 && !Bt2)
            return Se2;
          Le2 & y3 && (Se2[2] = Te2[2], ut2 |= et2 & y3 ? 0 : b3);
          var Ge2 = Te2[3];
          if (Ge2) {
            var tt2 = Se2[3];
            Se2[3] = tt2 ? u1(tt2, Ge2, Te2[4]) : Ge2, Se2[4] = tt2 ? Ba2(Se2[3], u3) : Te2[4];
          }
          (Ge2 = Te2[5]) && (tt2 = Se2[5], Se2[5] = tt2 ? c1(tt2, Ge2, Te2[6]) : Ge2, Se2[6] = tt2 ? Ba2(Se2[5], u3) : Te2[6]), (Ge2 = Te2[7]) && (Se2[7] = Ge2), Le2 & B3 && (Se2[8] = Se2[8] == null ? Te2[8] : Hn2(Se2[8], Te2[8])), Se2[9] == null && (Se2[9] = Te2[9]), Se2[0] = Te2[0], Se2[1] = ut2;
        }(qe2, Ue2), h10 = qe2[0], g10 = qe2[1], E4 = qe2[2], T10 = qe2[3], N10 = qe2[4], !(re2 = qe2[9] = qe2[9] === n3 ? se2 ? 0 : h10.length : _n2(qe2[9] - be2, 0)) && g10 & (x3 | C3) && (g10 &= ~(x3 | C3)), g10 && g10 != y3)
          Qe2 = g10 == x3 || g10 == C3 ? function(Se2, Te2, et2) {
            var Le2 = hu2(Se2);
            return function ut2() {
              for (var nt2 = arguments.length, Bt2 = Ne2(nt2), Ge2 = nt2, tt2 = rs2(ut2); Ge2--; )
                Bt2[Ge2] = arguments[Ge2];
              var Tn2 = nt2 < 3 && Bt2[0] !== tt2 && Bt2[nt2 - 1] !== tt2 ? [] : Ba2(Bt2, tt2);
              return (nt2 -= Tn2.length) < et2 ? y1(Se2, Te2, Zc2, ut2.placeholder, n3, Bt2, Tn2, n3, n3, et2 - nt2) : Fr2(this && this !== Vn2 && this instanceof ut2 ? Le2 : Se2, this, Bt2);
            };
          }(h10, g10, re2) : g10 != k3 && g10 != (y3 | k3) || N10.length ? Zc2.apply(n3, qe2) : function(Se2, Te2, et2, Le2) {
            var ut2 = Te2 & y3, nt2 = hu2(Se2);
            return function Bt2() {
              for (var Ge2 = -1, tt2 = arguments.length, Tn2 = -1, Sn2 = Le2.length, ir2 = Ne2(Sn2 + tt2), tn2 = this && this !== Vn2 && this instanceof Bt2 ? nt2 : Se2; ++Tn2 < Sn2; )
                ir2[Tn2] = Le2[Tn2];
              for (; tt2--; )
                ir2[Tn2++] = arguments[++Ge2];
              return Fr2(tn2, ut2 ? et2 : this, ir2);
            };
          }(h10, g10, E4, T10);
        else
          var Qe2 = function(Se2, Te2, et2) {
            var Le2 = Te2 & y3, ut2 = hu2(Se2);
            return function nt2() {
              return (this && this !== Vn2 && this instanceof nt2 ? ut2 : Se2).apply(Le2 ? et2 : this, arguments);
            };
          }(h10, g10, E4);
        return T1((Ue2 ? Yg : _1)(Qe2, qe2), h10, g10);
      }
      function x1(h10, g10, E4, T10) {
        return h10 === n3 || mi2(h10, Qo2[E4]) && !qt2.call(T10, E4) ? g10 : h10;
      }
      function b1(h10, g10, E4, T10, N10, z10) {
        return cn2(h10) && cn2(g10) && (z10.set(g10, h10), Jc2(h10, g10, n3, b1, z10), z10.delete(g10)), h10;
      }
      function Y32(h10) {
        return gu2(h10) ? n3 : h10;
      }
      function E1(h10, g10, E4, T10, N10, z10) {
        var te2 = E4 & d3, re2 = h10.length, se2 = g10.length;
        if (re2 != se2 && !(te2 && se2 > re2))
          return false;
        var be2 = z10.get(h10);
        if (be2 && z10.get(g10))
          return be2 == g10;
        var ve2 = -1, Ae2 = true, Ue2 = E4 & m3 ? new ho2() : n3;
        for (z10.set(h10, g10), z10.set(g10, h10); ++ve2 < re2; ) {
          var qe2 = h10[ve2], Qe2 = g10[ve2];
          if (T10)
            var Se2 = te2 ? T10(Qe2, qe2, ve2, g10, h10, z10) : T10(qe2, Qe2, ve2, h10, g10, z10);
          if (Se2 !== n3) {
            if (Se2)
              continue;
            Ae2 = false;
            break;
          }
          if (Ue2) {
            if (!Tf(g10, function(Te2, et2) {
              if (!nu2(Ue2, et2) && (qe2 === Te2 || N10(qe2, Te2, E4, T10, z10)))
                return Ue2.push(et2);
            })) {
              Ae2 = false;
              break;
            }
          } else if (qe2 !== Qe2 && !N10(qe2, Qe2, E4, T10, z10)) {
            Ae2 = false;
            break;
          }
        }
        return z10.delete(h10), z10.delete(g10), Ae2;
      }
      function na2(h10) {
        return mh(w1(h10, n3, N1), h10 + "");
      }
      function sh(h10) {
        return Ug(h10, Ln2, ph);
      }
      function uh(h10) {
        return Ug(h10, hr2, C1);
      }
      var ch = Wc2 ? function(h10) {
        return Wc2.get(h10);
      } : Ah;
      function rl(h10) {
        for (var g10 = h10.name + "", E4 = Yo2[g10], T10 = qt2.call(Yo2, g10) ? E4.length : 0; T10--; ) {
          var N10 = E4[T10], z10 = N10.func;
          if (z10 == null || z10 == h10)
            return N10.name;
        }
        return g10;
      }
      function rs2(h10) {
        return (qt2.call(U3, "placeholder") ? U3 : h10).placeholder;
      }
      function Je2() {
        var h10 = U3.iteratee || Fh;
        return h10 = h10 === Fh ? $g : h10, arguments.length ? h10(arguments[0], arguments[1]) : h10;
      }
      function il(h10, g10) {
        var E4 = h10.__data__;
        return function(T10) {
          var N10 = xe$3(T10);
          return N10 == "string" || N10 == "number" || N10 == "symbol" || N10 == "boolean" ? T10 !== "__proto__" : T10 === null;
        }(g10) ? E4[typeof g10 == "string" ? "string" : "hash"] : E4.map;
      }
      function lh(h10) {
        for (var g10 = Ln2(h10), E4 = g10.length; E4--; ) {
          var T10 = g10[E4], N10 = h10[T10];
          g10[E4] = [T10, N10, D1(N10)];
        }
        return g10;
      }
      function go2(h10, g10) {
        var E4 = function(T10, N10) {
          return T10 == null ? n3 : T10[N10];
        }(h10, g10);
        return Wg(E4) ? E4 : n3;
      }
      var ph = Rf ? function(h10) {
        return h10 == null ? [] : (h10 = en2(h10), Pa2(Rf(h10), function(g10) {
          return Ag.call(h10, g10);
        }));
      } : _h, C1 = Rf ? function(h10) {
        for (var g10 = []; h10; )
          Ia2(g10, ph(h10)), h10 = Rc2(h10);
        return g10;
      } : _h, Kn2 = nr2;
      function S1(h10, g10, E4) {
        for (var T10 = -1, N10 = (g10 = ja2(g10, h10)).length, z10 = false; ++T10 < N10; ) {
          var te2 = Pi2(g10[T10]);
          if (!(z10 = h10 != null && E4(h10, te2)))
            break;
          h10 = h10[te2];
        }
        return z10 || ++T10 != N10 ? z10 : !!(N10 = h10 == null ? 0 : h10.length) && pl2(N10) && ra2(te2, N10) && (st2(h10) || vo2(h10));
      }
      function k1(h10) {
        return typeof h10.constructor != "function" || du2(h10) ? {} : Zo2(Rc2(h10));
      }
      function Z32(h10) {
        return st2(h10) || vo2(h10) || !!(_g && h10 && h10[_g]);
      }
      function ra2(h10, g10) {
        var E4 = xe$3(h10);
        return !!(g10 = g10 != null ? g10 : R3) && (E4 == "number" || E4 != "symbol" && Wo2.test(h10)) && h10 > -1 && h10 % 1 == 0 && h10 < g10;
      }
      function rr2(h10, g10, E4) {
        if (!cn2(E4))
          return false;
        var T10 = xe$3(g10);
        return !!(T10 == "number" ? fr2(E4) && ra2(g10, E4.length) : T10 == "string" && g10 in E4) && mi2(E4[g10], h10);
      }
      function fh(h10, g10) {
        if (st2(h10))
          return false;
        var E4 = xe$3(h10);
        return !(E4 != "number" && E4 != "symbol" && E4 != "boolean" && h10 != null && !_r2(h10)) || Sr2.test(h10) || !qn2.test(h10) || g10 != null && h10 in en2(g10);
      }
      function hh(h10) {
        var g10 = rl(h10), E4 = U3[g10];
        if (typeof E4 != "function" || !(g10 in St2.prototype))
          return false;
        if (h10 === E4)
          return true;
        var T10 = ch(E4);
        return !!T10 && h10 === T10[0];
      }
      (Mf && Kn2(new Mf(new ArrayBuffer(1))) != zt2 || iu2 && Kn2(new iu2()) != _3 || Vf && Kn2(Vf.resolve()) != "[object Promise]" || Xo2 && Kn2(new Xo2()) != Ee2 || au2 && Kn2(new au2()) != _t2) && (Kn2 = function(h10) {
        var g10 = nr2(h10), E4 = g10 == ae2 ? h10.constructor : n3, T10 = E4 ? yo2(E4) : "";
        if (T10)
          switch (T10) {
            case B32:
              return zt2;
            case O32:
              return _3;
            case L32:
              return "[object Promise]";
            case N3:
              return Ee2;
            case j32:
              return _t2;
          }
        return g10;
      });
      var e_ = Bc2 ? ia2 : Th;
      function du2(h10) {
        var g10 = h10 && h10.constructor;
        return h10 === (typeof g10 == "function" && g10.prototype || Qo2);
      }
      function D1(h10) {
        return h10 == h10 && !cn2(h10);
      }
      function F1(h10, g10) {
        return function(E4) {
          return E4 != null && E4[h10] === g10 && (g10 !== n3 || h10 in en2(E4));
        };
      }
      function w1(h10, g10, E4) {
        return g10 = _n2(g10 === n3 ? h10.length - 1 : g10, 0), function() {
          for (var T10 = arguments, N10 = -1, z10 = _n2(T10.length - g10, 0), te2 = Ne2(z10); ++N10 < z10; )
            te2[N10] = T10[g10 + N10];
          N10 = -1;
          for (var re2 = Ne2(g10 + 1); ++N10 < g10; )
            re2[N10] = T10[N10];
          return re2[g10] = E4(te2), Fr2(h10, this, re2);
        };
      }
      function A1(h10, g10) {
        return g10.length < 2 ? h10 : es2(h10, zr2(g10, 0, -1));
      }
      function dh(h10, g10) {
        if ((g10 !== "constructor" || typeof h10[g10] != "function") && g10 != "__proto__")
          return h10[g10];
      }
      var _1 = P1(Yg), mu2 = F32 || function(h10, g10) {
        return Vn2.setTimeout(h10, g10);
      }, mh = P1(H3);
      function T1(h10, g10, E4) {
        var T10 = g10 + "";
        return mh(h10, function(N10, z10) {
          var te2 = z10.length;
          if (!te2)
            return N10;
          var re2 = te2 - 1;
          return z10[re2] = (te2 > 1 ? "& " : "") + z10[re2], z10 = z10.join(te2 > 2 ? ", " : " "), N10.replace(Fi2, `{
/* [wrapped with ` + z10 + `] */
`);
        }(T10, function(N10, z10) {
          return qr2(M3, function(te2) {
            var re2 = "_." + te2[0];
            z10 & te2[1] && !_c2(N10, re2) && N10.push(re2);
          }), N10.sort();
        }(function(N10) {
          var z10 = N10.match(so2);
          return z10 ? z10[1].split(Hi2) : [];
        }(T10), E4)));
      }
      function P1(h10) {
        var g10 = 0, E4 = 0;
        return function() {
          var T10 = T3(), N10 = L3 - (T10 - E4);
          if (E4 = T10, N10 > 0) {
            if (++g10 >= I3)
              return arguments[0];
          } else
            g10 = 0;
          return h10.apply(n3, arguments);
        };
      }
      function al(h10, g10) {
        var E4 = -1, T10 = h10.length, N10 = T10 - 1;
        for (g10 = g10 === n3 ? T10 : g10; ++E4 < g10; ) {
          var z10 = Xf(E4, N10), te2 = h10[z10];
          h10[z10] = h10[E4], h10[E4] = te2;
        }
        return h10.length = g10, h10;
      }
      var I1 = function(h10) {
        var g10 = cl(h10, function(T10) {
          return E4.size === o3 && E4.clear(), T10;
        }), E4 = g10.cache;
        return g10;
      }(function(h10) {
        var g10 = [];
        return h10.charCodeAt(0) === 46 && g10.push(""), h10.replace(pi2, function(E4, T10, N10, z10) {
          g10.push(N10 ? z10.replace(Wn2, "$1") : T10 || E4);
        }), g10;
      });
      function Pi2(h10) {
        if (typeof h10 == "string" || _r2(h10))
          return h10;
        var g10 = h10 + "";
        return g10 == "0" && 1 / h10 == -W3 ? "-0" : g10;
      }
      function yo2(h10) {
        if (h10 != null) {
          try {
            return Oc2.call(h10);
          } catch {
          }
          try {
            return h10 + "";
          } catch {
          }
        }
        return "";
      }
      function B1(h10) {
        if (h10 instanceof St2)
          return h10.clone();
        var g10 = new $r2(h10.__wrapped__, h10.__chain__);
        return g10.__actions__ = pr2(h10.__actions__), g10.__index__ = h10.__index__, g10.__values__ = h10.__values__, g10;
      }
      var t_ = mt2(function(h10, g10) {
        return Cn2(h10) ? cu2(h10, Un2(g10, 1, Cn2, true)) : [];
      }), n_ = mt2(function(h10, g10) {
        var E4 = Hr2(g10);
        return Cn2(E4) && (E4 = n3), Cn2(h10) ? cu2(h10, Un2(g10, 1, Cn2, true), Je2(E4, 2)) : [];
      }), r_ = mt2(function(h10, g10) {
        var E4 = Hr2(g10);
        return Cn2(E4) && (E4 = n3), Cn2(h10) ? cu2(h10, Un2(g10, 1, Cn2, true), n3, E4) : [];
      });
      function O1(h10, g10, E4) {
        var T10 = h10 == null ? 0 : h10.length;
        if (!T10)
          return -1;
        var N10 = E4 == null ? 0 : ft2(E4);
        return N10 < 0 && (N10 = _n2(T10 + N10, 0)), Tc2(h10, Je2(g10, 3), N10);
      }
      function L1(h10, g10, E4) {
        var T10 = h10 == null ? 0 : h10.length;
        if (!T10)
          return -1;
        var N10 = T10 - 1;
        return E4 !== n3 && (N10 = ft2(E4), N10 = E4 < 0 ? _n2(T10 + N10, 0) : Hn2(N10, T10 - 1)), Tc2(h10, Je2(g10, 3), N10, true);
      }
      function N1(h10) {
        return h10 != null && h10.length ? Un2(h10, 1) : [];
      }
      function j1(h10) {
        return h10 && h10.length ? h10[0] : n3;
      }
      var i_ = mt2(function(h10) {
        var g10 = un2(h10, nh);
        return g10.length && g10[0] === h10[0] ? zf(g10) : [];
      }), a_ = mt2(function(h10) {
        var g10 = Hr2(h10), E4 = un2(h10, nh);
        return g10 === Hr2(E4) ? g10 = n3 : E4.pop(), E4.length && E4[0] === h10[0] ? zf(E4, Je2(g10, 2)) : [];
      }), o_ = mt2(function(h10) {
        var g10 = Hr2(h10), E4 = un2(h10, nh);
        return (g10 = typeof g10 == "function" ? g10 : n3) && E4.pop(), E4.length && E4[0] === h10[0] ? zf(E4, n3, g10) : [];
      });
      function Hr2(h10) {
        var g10 = h10 == null ? 0 : h10.length;
        return g10 ? h10[g10 - 1] : n3;
      }
      var s_ = mt2(R1);
      function R1(h10, g10) {
        return h10 && h10.length && g10 && g10.length ? Qf(h10, g10) : h10;
      }
      var u_ = na2(function(h10, g10) {
        var E4 = h10 == null ? 0 : h10.length, T10 = qf(h10, g10);
        return Xg(h10, un2(g10, function(N10) {
          return ra2(N10, E4) ? +N10 : N10;
        }).sort(s1)), T10;
      });
      function gh(h10) {
        return h10 == null ? h10 : I32.call(h10);
      }
      var c_ = mt2(function(h10) {
        return Na2(Un2(h10, 1, Cn2, true));
      }), l_ = mt2(function(h10) {
        var g10 = Hr2(h10);
        return Cn2(g10) && (g10 = n3), Na2(Un2(h10, 1, Cn2, true), Je2(g10, 2));
      }), p_ = mt2(function(h10) {
        var g10 = Hr2(h10);
        return g10 = typeof g10 == "function" ? g10 : n3, Na2(Un2(h10, 1, Cn2, true), n3, g10);
      });
      function yh(h10) {
        if (!h10 || !h10.length)
          return [];
        var g10 = 0;
        return h10 = Pa2(h10, function(E4) {
          if (Cn2(E4))
            return g10 = _n2(E4.length, g10), true;
        }), Of(g10, function(E4) {
          return un2(h10, Pf(E4));
        });
      }
      function M1(h10, g10) {
        if (!h10 || !h10.length)
          return [];
        var E4 = yh(h10);
        return g10 == null ? E4 : un2(E4, function(T10) {
          return Fr2(g10, n3, T10);
        });
      }
      var f_ = mt2(function(h10, g10) {
        return Cn2(h10) ? cu2(h10, g10) : [];
      }), h_ = mt2(function(h10) {
        return th(Pa2(h10, Cn2));
      }), d_ = mt2(function(h10) {
        var g10 = Hr2(h10);
        return Cn2(g10) && (g10 = n3), th(Pa2(h10, Cn2), Je2(g10, 2));
      }), m_ = mt2(function(h10) {
        var g10 = Hr2(h10);
        return g10 = typeof g10 == "function" ? g10 : n3, th(Pa2(h10, Cn2), n3, g10);
      }), g_ = mt2(yh), y_ = mt2(function(h10) {
        var g10 = h10.length, E4 = g10 > 1 ? h10[g10 - 1] : n3;
        return E4 = typeof E4 == "function" ? (h10.pop(), E4) : n3, M1(h10, E4);
      });
      function V1(h10) {
        var g10 = U3(h10);
        return g10.__chain__ = true, g10;
      }
      function ol(h10, g10) {
        return g10(h10);
      }
      var v_ = na2(function(h10) {
        var g10 = h10.length, E4 = g10 ? h10[0] : 0, T10 = this.__wrapped__, N10 = function(z10) {
          return qf(z10, h10);
        };
        return !(g10 > 1 || this.__actions__.length) && T10 instanceof St2 && ra2(E4) ? ((T10 = T10.slice(E4, +E4 + (g10 ? 1 : 0))).__actions__.push({ func: ol, args: [N10], thisArg: n3 }), new $r2(T10, this.__chain__).thru(function(z10) {
          return g10 && !z10.length && z10.push(n3), z10;
        })) : this.thru(N10);
      }), x_ = Yc2(function(h10, g10, E4) {
        qt2.call(h10, E4) ? ++h10[E4] : ea2(h10, E4, 1);
      }), b_ = h1(O1), E_ = h1(L1);
      function U1(h10, g10) {
        return (st2(h10) ? qr2 : La2)(h10, Je2(g10, 3));
      }
      function q1(h10, g10) {
        return (st2(h10) ? c32 : Rg)(h10, Je2(g10, 3));
      }
      var C_ = Yc2(function(h10, g10, E4) {
        qt2.call(h10, E4) ? h10[E4].push(g10) : ea2(h10, E4, [g10]);
      }), S_ = mt2(function(h10, g10, E4) {
        var T10 = -1, N10 = typeof g10 == "function", z10 = fr2(h10) ? Ne2(h10.length) : [];
        return La2(h10, function(te2) {
          z10[++T10] = N10 ? Fr2(g10, te2, E4) : lu2(te2, g10, E4);
        }), z10;
      }), k_ = Yc2(function(h10, g10, E4) {
        ea2(h10, E4, g10);
      });
      function sl(h10, g10) {
        return (st2(h10) ? un2 : Gg)(h10, Je2(g10, 3));
      }
      var D_ = Yc2(function(h10, g10, E4) {
        h10[E4 ? 0 : 1].push(g10);
      }, function() {
        return [[], []];
      }), F_ = mt2(function(h10, g10) {
        if (h10 == null)
          return [];
        var E4 = g10.length;
        return E4 > 1 && rr2(h10, g10[0], g10[1]) ? g10 = [] : E4 > 2 && rr2(g10[0], g10[1], g10[2]) && (g10 = [g10[0]]), Jg(h10, Un2(g10, 1), []);
      }), ul = D32 || function() {
        return Vn2.Date.now();
      };
      function W1(h10, g10, E4) {
        return g10 = E4 ? n3 : g10, g10 = h10 && g10 == null ? h10.length : g10, ta2(h10, B3, n3, n3, n3, n3, g10);
      }
      function $1(h10, g10) {
        var E4;
        if (typeof g10 != "function")
          throw new Wr2(a3);
        return h10 = ft2(h10), function() {
          return --h10 > 0 && (E4 = g10.apply(this, arguments)), h10 <= 1 && (g10 = n3), E4;
        };
      }
      var vh = mt2(function(h10, g10, E4) {
        var T10 = y3;
        if (E4.length) {
          var N10 = Ba2(E4, rs2(vh));
          T10 |= k3;
        }
        return ta2(h10, T10, g10, E4, N10);
      }), G1 = mt2(function(h10, g10, E4) {
        var T10 = y3 | v3;
        if (E4.length) {
          var N10 = Ba2(E4, rs2(G1));
          T10 |= k3;
        }
        return ta2(g10, T10, h10, E4, N10);
      });
      function z1(h10, g10, E4) {
        var T10, N10, z10, te2, re2, se2, be2 = 0, ve2 = false, Ae2 = false, Ue2 = true;
        if (typeof h10 != "function")
          throw new Wr2(a3);
        function qe2(Le2) {
          var ut2 = T10, nt2 = N10;
          return T10 = N10 = n3, be2 = Le2, te2 = h10.apply(nt2, ut2);
        }
        function Qe2(Le2) {
          var ut2 = Le2 - se2;
          return se2 === n3 || ut2 >= g10 || ut2 < 0 || Ae2 && Le2 - be2 >= z10;
        }
        function Se2() {
          var Le2 = ul();
          if (Qe2(Le2))
            return Te2(Le2);
          re2 = mu2(Se2, function(ut2) {
            var nt2 = g10 - (ut2 - se2);
            return Ae2 ? Hn2(nt2, z10 - (ut2 - be2)) : nt2;
          }(Le2));
        }
        function Te2(Le2) {
          return re2 = n3, Ue2 && T10 ? qe2(Le2) : (T10 = N10 = n3, te2);
        }
        function et2() {
          var Le2 = ul(), ut2 = Qe2(Le2);
          if (T10 = arguments, N10 = this, se2 = Le2, ut2) {
            if (re2 === n3)
              return function(nt2) {
                return be2 = nt2, re2 = mu2(Se2, g10), ve2 ? qe2(nt2) : te2;
              }(se2);
            if (Ae2)
              return i1(re2), re2 = mu2(Se2, g10), qe2(se2);
          }
          return re2 === n3 && (re2 = mu2(Se2, g10)), te2;
        }
        return g10 = Kr2(g10) || 0, cn2(E4) && (ve2 = !!E4.leading, z10 = (Ae2 = "maxWait" in E4) ? _n2(Kr2(E4.maxWait) || 0, g10) : z10, Ue2 = "trailing" in E4 ? !!E4.trailing : Ue2), et2.cancel = function() {
          re2 !== n3 && i1(re2), be2 = 0, T10 = se2 = N10 = re2 = n3;
        }, et2.flush = function() {
          return re2 === n3 ? te2 : Te2(ul());
        }, et2;
      }
      var w_ = mt2(function(h10, g10) {
        return jg(h10, 1, g10);
      }), A_ = mt2(function(h10, g10, E4) {
        return jg(h10, Kr2(g10) || 0, E4);
      });
      function cl(h10, g10) {
        if (typeof h10 != "function" || g10 != null && typeof g10 != "function")
          throw new Wr2(a3);
        var E4 = function T10() {
          var N10 = arguments, z10 = g10 ? g10.apply(this, N10) : N10[0], te2 = T10.cache;
          if (te2.has(z10))
            return te2.get(z10);
          var re2 = h10.apply(this, N10);
          return T10.cache = te2.set(z10, re2) || te2, re2;
        };
        return E4.cache = new (cl.Cache || Zi2)(), E4;
      }
      function ll(h10) {
        if (typeof h10 != "function")
          throw new Wr2(a3);
        return function() {
          var g10 = arguments;
          switch (g10.length) {
            case 0:
              return !h10.call(this);
            case 1:
              return !h10.call(this, g10[0]);
            case 2:
              return !h10.call(this, g10[0], g10[1]);
            case 3:
              return !h10.call(this, g10[0], g10[1], g10[2]);
          }
          return !h10.apply(this, g10);
        };
      }
      cl.Cache = Zi2;
      var __ = Q32(function(h10, g10) {
        var E4 = (g10 = g10.length == 1 && st2(g10[0]) ? un2(g10[0], wr2(Je2())) : un2(Un2(g10, 1), wr2(Je2()))).length;
        return mt2(function(T10) {
          for (var N10 = -1, z10 = Hn2(T10.length, E4); ++N10 < z10; )
            T10[N10] = g10[N10].call(this, T10[N10]);
          return Fr2(h10, this, T10);
        });
      }), xh = mt2(function(h10, g10) {
        var E4 = Ba2(g10, rs2(xh));
        return ta2(h10, k3, n3, g10, E4);
      }), H1 = mt2(function(h10, g10) {
        var E4 = Ba2(g10, rs2(H1));
        return ta2(h10, F3, n3, g10, E4);
      }), T_ = na2(function(h10, g10) {
        return ta2(h10, O3, n3, n3, n3, g10);
      });
      function mi2(h10, g10) {
        return h10 === g10 || h10 != h10 && g10 != g10;
      }
      var P_ = nl(Gf), I_ = nl(function(h10, g10) {
        return h10 >= g10;
      }), vo2 = qg(function() {
        return arguments;
      }()) ? qg : function(h10) {
        return mn2(h10) && qt2.call(h10, "callee") && !Ag.call(h10, "callee");
      }, st2 = Ne2.isArray, B_ = pg ? wr2(pg) : function(h10) {
        return mn2(h10) && nr2(h10) == Jt2;
      };
      function fr2(h10) {
        return h10 != null && pl2(h10.length) && !ia2(h10);
      }
      function Cn2(h10) {
        return mn2(h10) && fr2(h10);
      }
      var Ma2 = w32 || Th, O_ = fg ? wr2(fg) : function(h10) {
        return mn2(h10) && nr2(h10) == ie2;
      };
      function bh(h10) {
        if (!mn2(h10))
          return false;
        var g10 = nr2(h10);
        return g10 == ge2 || g10 == fe2 || typeof h10.message == "string" && typeof h10.name == "string" && !gu2(h10);
      }
      function ia2(h10) {
        if (!cn2(h10))
          return false;
        var g10 = nr2(h10);
        return g10 == Fe2 || g10 == Pe2 || g10 == he2 || g10 == ue2;
      }
      function K1(h10) {
        return typeof h10 == "number" && h10 == ft2(h10);
      }
      function pl2(h10) {
        return typeof h10 == "number" && h10 > -1 && h10 % 1 == 0 && h10 <= R3;
      }
      function cn2(h10) {
        var g10 = xe$3(h10);
        return h10 != null && (g10 == "object" || g10 == "function");
      }
      function mn2(h10) {
        return h10 != null && xe$3(h10) == "object";
      }
      var J1 = hg ? wr2(hg) : function(h10) {
        return mn2(h10) && Kn2(h10) == _3;
      };
      function Q1(h10) {
        return typeof h10 == "number" || mn2(h10) && nr2(h10) == Q3;
      }
      function gu2(h10) {
        if (!mn2(h10) || nr2(h10) != ae2)
          return false;
        var g10 = Rc2(h10);
        if (g10 === null)
          return true;
        var E4 = qt2.call(g10, "constructor") && g10.constructor;
        return typeof E4 == "function" && E4 instanceof E4 && Oc2.call(E4) == E3;
      }
      var Eh = dg ? wr2(dg) : function(h10) {
        return mn2(h10) && nr2(h10) == De2;
      }, X1 = mg ? wr2(mg) : function(h10) {
        return mn2(h10) && Kn2(h10) == Ee2;
      };
      function fl2(h10) {
        return typeof h10 == "string" || !st2(h10) && mn2(h10) && nr2(h10) == _e2;
      }
      function _r2(h10) {
        return xe$3(h10) == "symbol" || mn2(h10) && nr2(h10) == Oe2;
      }
      var is2 = gg ? wr2(gg) : function(h10) {
        return mn2(h10) && pl2(h10.length) && !!Zt2[nr2(h10)];
      }, L_ = nl(Jf), N_ = nl(function(h10, g10) {
        return h10 <= g10;
      });
      function Y1(h10) {
        if (!h10)
          return [];
        if (fr2(h10))
          return fl2(h10) ? hi2(h10) : pr2(h10);
        if (ru2 && h10[ru2])
          return function(E4) {
            for (var T10, N10 = []; !(T10 = E4.next()).done; )
              N10.push(T10.value);
            return N10;
          }(h10[ru2]());
        var g10 = Kn2(h10);
        return (g10 == _3 ? Nf : g10 == Ee2 ? Pc2 : as2)(h10);
      }
      function aa2(h10) {
        return h10 ? (h10 = Kr2(h10)) === W3 || h10 === -W3 ? (h10 < 0 ? -1 : 1) * q3 : h10 == h10 ? h10 : 0 : h10 === 0 ? h10 : 0;
      }
      function ft2(h10) {
        var g10 = aa2(h10), E4 = g10 % 1;
        return g10 == g10 ? E4 ? g10 - E4 : g10 : 0;
      }
      function Z1(h10) {
        return h10 ? mo2(ft2(h10), 0, X3) : 0;
      }
      function Kr2(h10) {
        if (typeof h10 == "number")
          return h10;
        if (_r2(h10))
          return J3;
        if (cn2(h10)) {
          var g10 = typeof h10.valueOf == "function" ? h10.valueOf() : h10;
          h10 = cn2(g10) ? g10 + "" : g10;
        }
        if (typeof h10 != "string")
          return h10 === 0 ? h10 : +h10;
        h10 = h10.replace(fi2, "");
        var E4 = an2.test(h10);
        return E4 || wi2.test(h10) ? o32(h10.slice(2), E4 ? 2 : 8) : Ze2.test(h10) ? J3 : +h10;
      }
      function ey(h10) {
        return Ti2(h10, hr2(h10));
      }
      function Vt2(h10) {
        return h10 == null ? "" : Ar2(h10);
      }
      var j_ = ts2(function(h10, g10) {
        if (du2(g10) || fr2(g10))
          Ti2(g10, Ln2(g10), h10);
        else
          for (var E4 in g10)
            qt2.call(g10, E4) && uu2(h10, E4, g10[E4]);
      }), ty = ts2(function(h10, g10) {
        Ti2(g10, hr2(g10), h10);
      }), hl = ts2(function(h10, g10, E4, T10) {
        Ti2(g10, hr2(g10), h10, T10);
      }), R_ = ts2(function(h10, g10, E4, T10) {
        Ti2(g10, Ln2(g10), h10, T10);
      }), M_ = na2(qf), V_ = mt2(function(h10, g10) {
        h10 = en2(h10);
        var E4 = -1, T10 = g10.length, N10 = T10 > 2 ? g10[2] : n3;
        for (N10 && rr2(g10[0], g10[1], N10) && (T10 = 1); ++E4 < T10; )
          for (var z10 = g10[E4], te2 = hr2(z10), re2 = -1, se2 = te2.length; ++re2 < se2; ) {
            var be2 = te2[re2], ve2 = h10[be2];
            (ve2 === n3 || mi2(ve2, Qo2[be2]) && !qt2.call(h10, be2)) && (h10[be2] = z10[be2]);
          }
        return h10;
      }), U_ = mt2(function(h10) {
        return h10.push(n3, b1), Fr2(ny, n3, h10);
      });
      function Ch(h10, g10, E4) {
        var T10 = h10 == null ? n3 : es2(h10, g10);
        return T10 === n3 ? E4 : T10;
      }
      function Sh(h10, g10) {
        return h10 != null && S1(h10, g10, W32);
      }
      var q_ = m1(function(h10, g10, E4) {
        g10 != null && typeof g10.toString != "function" && (g10 = Lc2.call(g10)), h10[g10] = E4;
      }, Dh(dr2)), W_ = m1(function(h10, g10, E4) {
        g10 != null && typeof g10.toString != "function" && (g10 = Lc2.call(g10)), qt2.call(h10, g10) ? h10[g10].push(E4) : h10[g10] = [E4];
      }, Je2), $_ = mt2(lu2);
      function Ln2(h10) {
        return fr2(h10) ? Bg(h10) : Kf(h10);
      }
      function hr2(h10) {
        return fr2(h10) ? Bg(h10, true) : $3(h10);
      }
      var G_ = ts2(function(h10, g10, E4) {
        Jc2(h10, g10, E4);
      }), ny = ts2(function(h10, g10, E4, T10) {
        Jc2(h10, g10, E4, T10);
      }), z_ = na2(function(h10, g10) {
        var E4 = {};
        if (h10 == null)
          return E4;
        var T10 = false;
        g10 = un2(g10, function(z10) {
          return z10 = ja2(z10, h10), T10 || (T10 = z10.length > 1), z10;
        }), Ti2(h10, uh(h10), E4), T10 && (E4 = Gr2(E4, c3 | f3 | p3, Y32));
        for (var N10 = g10.length; N10--; )
          eh(E4, g10[N10]);
        return E4;
      }), H_ = na2(function(h10, g10) {
        return h10 == null ? {} : function(E4, T10) {
          return Qg(E4, T10, function(N10, z10) {
            return Sh(E4, z10);
          });
        }(h10, g10);
      });
      function ry(h10, g10) {
        if (h10 == null)
          return {};
        var E4 = un2(uh(h10), function(T10) {
          return [T10];
        });
        return g10 = Je2(g10), Qg(h10, E4, function(T10, N10) {
          return g10(T10, N10[0]);
        });
      }
      var iy = v12(Ln2), ay = v12(hr2);
      function as2(h10) {
        return h10 == null ? [] : Lf(h10, Ln2(h10));
      }
      var K_ = ns2(function(h10, g10, E4) {
        return g10 = g10.toLowerCase(), h10 + (E4 ? oy(g10) : g10);
      });
      function oy(h10) {
        return kh(Vt2(h10).toLowerCase());
      }
      function sy(h10) {
        return (h10 = Vt2(h10)) && h10.replace(ot2, h3).replace(YA, "");
      }
      var J_ = ns2(function(h10, g10, E4) {
        return h10 + (E4 ? "-" : "") + g10.toLowerCase();
      }), Q_ = ns2(function(h10, g10, E4) {
        return h10 + (E4 ? " " : "") + g10.toLowerCase();
      }), X_ = f1("toLowerCase"), Y_ = ns2(function(h10, g10, E4) {
        return h10 + (E4 ? "_" : "") + g10.toLowerCase();
      }), Z_ = ns2(function(h10, g10, E4) {
        return h10 + (E4 ? " " : "") + kh(g10);
      }), e62 = ns2(function(h10, g10, E4) {
        return h10 + (E4 ? " " : "") + g10.toUpperCase();
      }), kh = f1("toUpperCase");
      function uy(h10, g10, E4) {
        return h10 = Vt2(h10), (g10 = E4 ? n3 : g10) === n3 ? function(T10) {
          return t32.test(T10);
        }(h10) ? function(T10) {
          return T10.match(ZA) || [];
        }(h10) : function(T10) {
          return T10.match(Ki2) || [];
        }(h10) : h10.match(g10) || [];
      }
      var cy = mt2(function(h10, g10) {
        try {
          return Fr2(h10, n3, g10);
        } catch (E4) {
          return bh(E4) ? E4 : new Pt2(E4);
        }
      }), t6 = na2(function(h10, g10) {
        return qr2(g10, function(E4) {
          E4 = Pi2(E4), ea2(h10, E4, vh(h10[E4], h10));
        }), h10;
      });
      function Dh(h10) {
        return function() {
          return h10;
        };
      }
      var n6 = d1(), r6 = d1(true);
      function dr2(h10) {
        return h10;
      }
      function Fh(h10) {
        return $g(typeof h10 == "function" ? h10 : Gr2(h10, c3));
      }
      var i6 = mt2(function(h10, g10) {
        return function(E4) {
          return lu2(E4, h10, g10);
        };
      }), a6 = mt2(function(h10, g10) {
        return function(E4) {
          return lu2(h10, E4, g10);
        };
      });
      function wh(h10, g10, E4) {
        var T10 = Ln2(g10), N10 = Kc2(g10, T10);
        E4 != null || cn2(g10) && (N10.length || !T10.length) || (E4 = g10, g10 = h10, h10 = this, N10 = Kc2(g10, Ln2(g10)));
        var z10 = !(cn2(E4) && "chain" in E4 && !E4.chain), te2 = ia2(h10);
        return qr2(N10, function(re2) {
          var se2 = g10[re2];
          h10[re2] = se2, te2 && (h10.prototype[re2] = function() {
            var be2 = this.__chain__;
            if (z10 || be2) {
              var ve2 = h10(this.__wrapped__), Ae2 = ve2.__actions__ = pr2(this.__actions__);
              return Ae2.push({ func: se2, args: arguments, thisArg: h10 }), ve2.__chain__ = be2, ve2;
            }
            return se2.apply(h10, Ia2([this.value()], arguments));
          });
        }), h10;
      }
      function Ah() {
      }
      var o6 = ah(un2), s6 = ah(yg), u6 = ah(Tf);
      function ly(h10) {
        return fh(h10) ? Pf(Pi2(h10)) : function(g10) {
          return function(E4) {
            return es2(E4, g10);
          };
        }(h10);
      }
      var c6 = g1(), l6 = g1(true);
      function _h() {
        return [];
      }
      function Th() {
        return false;
      }
      var p6 = el(function(h10, g10) {
        return h10 + g10;
      }, 0), f6 = oh("ceil"), h6 = el(function(h10, g10) {
        return h10 / g10;
      }, 1), d6 = oh("floor"), Ph, m6 = el(function(h10, g10) {
        return h10 * g10;
      }, 1), g6 = oh("round"), y6 = el(function(h10, g10) {
        return h10 - g10;
      }, 0);
      return U3.after = function(h10, g10) {
        if (typeof g10 != "function")
          throw new Wr2(a3);
        return h10 = ft2(h10), function() {
          if (--h10 < 1)
            return g10.apply(this, arguments);
        };
      }, U3.ary = W1, U3.assign = j_, U3.assignIn = ty, U3.assignInWith = hl, U3.assignWith = R_, U3.at = M_, U3.before = $1, U3.bind = vh, U3.bindAll = t6, U3.bindKey = G1, U3.castArray = function() {
        if (!arguments.length)
          return [];
        var h10 = arguments[0];
        return st2(h10) ? h10 : [h10];
      }, U3.chain = V1, U3.chunk = function(h10, g10, E4) {
        g10 = (E4 ? rr2(h10, g10, E4) : g10 === n3) ? 1 : _n2(ft2(g10), 0);
        var T10 = h10 == null ? 0 : h10.length;
        if (!T10 || g10 < 1)
          return [];
        for (var N10 = 0, z10 = 0, te2 = Ne2(Uc2(T10 / g10)); N10 < T10; )
          te2[z10++] = zr2(h10, N10, N10 += g10);
        return te2;
      }, U3.compact = function(h10) {
        for (var g10 = -1, E4 = h10 == null ? 0 : h10.length, T10 = 0, N10 = []; ++g10 < E4; ) {
          var z10 = h10[g10];
          z10 && (N10[T10++] = z10);
        }
        return N10;
      }, U3.concat = function() {
        var h10 = arguments.length;
        if (!h10)
          return [];
        for (var g10 = Ne2(h10 - 1), E4 = arguments[0], T10 = h10; T10--; )
          g10[T10 - 1] = arguments[T10];
        return Ia2(st2(E4) ? pr2(E4) : [E4], Un2(g10, 1));
      }, U3.cond = function(h10) {
        var g10 = h10 == null ? 0 : h10.length, E4 = Je2();
        return h10 = g10 ? un2(h10, function(T10) {
          if (typeof T10[1] != "function")
            throw new Wr2(a3);
          return [E4(T10[0]), T10[1]];
        }) : [], mt2(function(T10) {
          for (var N10 = -1; ++N10 < g10; ) {
            var z10 = h10[N10];
            if (Fr2(z10[0], this, T10))
              return Fr2(z10[1], this, T10);
          }
        });
      }, U3.conforms = function(h10) {
        return function(g10) {
          var E4 = Ln2(g10);
          return function(T10) {
            return Ng(T10, g10, E4);
          };
        }(Gr2(h10, c3));
      }, U3.constant = Dh, U3.countBy = x_, U3.create = function(h10, g10) {
        var E4 = Zo2(h10);
        return g10 == null ? E4 : Lg(E4, g10);
      }, U3.curry = function h10(g10, E4, T10) {
        var N10 = ta2(g10, x3, n3, n3, n3, n3, n3, E4 = T10 ? n3 : E4);
        return N10.placeholder = h10.placeholder, N10;
      }, U3.curryRight = function h10(g10, E4, T10) {
        var N10 = ta2(g10, C3, n3, n3, n3, n3, n3, E4 = T10 ? n3 : E4);
        return N10.placeholder = h10.placeholder, N10;
      }, U3.debounce = z1, U3.defaults = V_, U3.defaultsDeep = U_, U3.defer = w_, U3.delay = A_, U3.difference = t_, U3.differenceBy = n_, U3.differenceWith = r_, U3.drop = function(h10, g10, E4) {
        var T10 = h10 == null ? 0 : h10.length;
        return T10 ? zr2(h10, (g10 = E4 || g10 === n3 ? 1 : ft2(g10)) < 0 ? 0 : g10, T10) : [];
      }, U3.dropRight = function(h10, g10, E4) {
        var T10 = h10 == null ? 0 : h10.length;
        return T10 ? zr2(h10, 0, (g10 = T10 - (g10 = E4 || g10 === n3 ? 1 : ft2(g10))) < 0 ? 0 : g10) : [];
      }, U3.dropRightWhile = function(h10, g10) {
        return h10 && h10.length ? Xc2(h10, Je2(g10, 3), true, true) : [];
      }, U3.dropWhile = function(h10, g10) {
        return h10 && h10.length ? Xc2(h10, Je2(g10, 3), true) : [];
      }, U3.fill = function(h10, g10, E4, T10) {
        var N10 = h10 == null ? 0 : h10.length;
        return N10 ? (E4 && typeof E4 != "number" && rr2(h10, g10, E4) && (E4 = 0, T10 = N10), function(z10, te2, re2, se2) {
          var be2 = z10.length;
          for ((re2 = ft2(re2)) < 0 && (re2 = -re2 > be2 ? 0 : be2 + re2), (se2 = se2 === n3 || se2 > be2 ? be2 : ft2(se2)) < 0 && (se2 += be2), se2 = re2 > se2 ? 0 : Z1(se2); re2 < se2; )
            z10[re2++] = te2;
          return z10;
        }(h10, g10, E4, T10)) : [];
      }, U3.filter = function(h10, g10) {
        return (st2(h10) ? Pa2 : Mg)(h10, Je2(g10, 3));
      }, U3.flatMap = function(h10, g10) {
        return Un2(sl(h10, g10), 1);
      }, U3.flatMapDeep = function(h10, g10) {
        return Un2(sl(h10, g10), W3);
      }, U3.flatMapDepth = function(h10, g10, E4) {
        return E4 = E4 === n3 ? 1 : ft2(E4), Un2(sl(h10, g10), E4);
      }, U3.flatten = N1, U3.flattenDeep = function(h10) {
        return h10 != null && h10.length ? Un2(h10, W3) : [];
      }, U3.flattenDepth = function(h10, g10) {
        return h10 != null && h10.length ? Un2(h10, g10 = g10 === n3 ? 1 : ft2(g10)) : [];
      }, U3.flip = function(h10) {
        return ta2(h10, S3);
      }, U3.flow = n6, U3.flowRight = r6, U3.fromPairs = function(h10) {
        for (var g10 = -1, E4 = h10 == null ? 0 : h10.length, T10 = {}; ++g10 < E4; ) {
          var N10 = h10[g10];
          T10[N10[0]] = N10[1];
        }
        return T10;
      }, U3.functions = function(h10) {
        return h10 == null ? [] : Kc2(h10, Ln2(h10));
      }, U3.functionsIn = function(h10) {
        return h10 == null ? [] : Kc2(h10, hr2(h10));
      }, U3.groupBy = C_, U3.initial = function(h10) {
        return h10 != null && h10.length ? zr2(h10, 0, -1) : [];
      }, U3.intersection = i_, U3.intersectionBy = a_, U3.intersectionWith = o_, U3.invert = q_, U3.invertBy = W_, U3.invokeMap = S_, U3.iteratee = Fh, U3.keyBy = k_, U3.keys = Ln2, U3.keysIn = hr2, U3.map = sl, U3.mapKeys = function(h10, g10) {
        var E4 = {};
        return g10 = Je2(g10, 3), _i2(h10, function(T10, N10, z10) {
          ea2(E4, g10(T10, N10, z10), T10);
        }), E4;
      }, U3.mapValues = function(h10, g10) {
        var E4 = {};
        return g10 = Je2(g10, 3), _i2(h10, function(T10, N10, z10) {
          ea2(E4, N10, g10(T10, N10, z10));
        }), E4;
      }, U3.matches = function(h10) {
        return zg(Gr2(h10, c3));
      }, U3.matchesProperty = function(h10, g10) {
        return Hg(h10, Gr2(g10, c3));
      }, U3.memoize = cl, U3.merge = G_, U3.mergeWith = ny, U3.method = i6, U3.methodOf = a6, U3.mixin = wh, U3.negate = ll, U3.nthArg = function(h10) {
        return h10 = ft2(h10), mt2(function(g10) {
          return Kg(g10, h10);
        });
      }, U3.omit = z_, U3.omitBy = function(h10, g10) {
        return ry(h10, ll(Je2(g10)));
      }, U3.once = function(h10) {
        return $1(2, h10);
      }, U3.orderBy = function(h10, g10, E4, T10) {
        return h10 == null ? [] : (st2(g10) || (g10 = g10 == null ? [] : [g10]), st2(E4 = T10 ? n3 : E4) || (E4 = E4 == null ? [] : [E4]), Jg(h10, g10, E4));
      }, U3.over = o6, U3.overArgs = __, U3.overEvery = s6, U3.overSome = u6, U3.partial = xh, U3.partialRight = H1, U3.partition = D_, U3.pick = H_, U3.pickBy = ry, U3.property = ly, U3.propertyOf = function(h10) {
        return function(g10) {
          return h10 == null ? n3 : es2(h10, g10);
        };
      }, U3.pull = s_, U3.pullAll = R1, U3.pullAllBy = function(h10, g10, E4) {
        return h10 && h10.length && g10 && g10.length ? Qf(h10, g10, Je2(E4, 2)) : h10;
      }, U3.pullAllWith = function(h10, g10, E4) {
        return h10 && h10.length && g10 && g10.length ? Qf(h10, g10, n3, E4) : h10;
      }, U3.pullAt = u_, U3.range = c6, U3.rangeRight = l6, U3.rearg = T_, U3.reject = function(h10, g10) {
        return (st2(h10) ? Pa2 : Mg)(h10, ll(Je2(g10, 3)));
      }, U3.remove = function(h10, g10) {
        var E4 = [];
        if (!h10 || !h10.length)
          return E4;
        var T10 = -1, N10 = [], z10 = h10.length;
        for (g10 = Je2(g10, 3); ++T10 < z10; ) {
          var te2 = h10[T10];
          g10(te2, T10, h10) && (E4.push(te2), N10.push(T10));
        }
        return Xg(h10, N10), E4;
      }, U3.rest = function(h10, g10) {
        if (typeof h10 != "function")
          throw new Wr2(a3);
        return mt2(h10, g10 = g10 === n3 ? g10 : ft2(g10));
      }, U3.reverse = gh, U3.sampleSize = function(h10, g10, E4) {
        return g10 = (E4 ? rr2(h10, g10, E4) : g10 === n3) ? 1 : ft2(g10), (st2(h10) ? R32 : z3)(h10, g10);
      }, U3.set = function(h10, g10, E4) {
        return h10 == null ? h10 : fu2(h10, g10, E4);
      }, U3.setWith = function(h10, g10, E4, T10) {
        return T10 = typeof T10 == "function" ? T10 : n3, h10 == null ? h10 : fu2(h10, g10, E4, T10);
      }, U3.shuffle = function(h10) {
        return (st2(h10) ? M32 : K32)(h10);
      }, U3.slice = function(h10, g10, E4) {
        var T10 = h10 == null ? 0 : h10.length;
        return T10 ? (E4 && typeof E4 != "number" && rr2(h10, g10, E4) ? (g10 = 0, E4 = T10) : (g10 = g10 == null ? 0 : ft2(g10), E4 = E4 === n3 ? T10 : ft2(E4)), zr2(h10, g10, E4)) : [];
      }, U3.sortBy = F_, U3.sortedUniq = function(h10) {
        return h10 && h10.length ? Zg(h10) : [];
      }, U3.sortedUniqBy = function(h10, g10) {
        return h10 && h10.length ? Zg(h10, Je2(g10, 2)) : [];
      }, U3.split = function(h10, g10, E4) {
        return E4 && typeof E4 != "number" && rr2(h10, g10, E4) && (g10 = E4 = n3), (E4 = E4 === n3 ? X3 : E4 >>> 0) ? (h10 = Vt2(h10)) && (typeof g10 == "string" || g10 != null && !Eh(g10)) && !(g10 = Ar2(g10)) && Ho2(h10) ? Ra2(hi2(h10), 0, E4) : h10.split(g10, E4) : [];
      }, U3.spread = function(h10, g10) {
        if (typeof h10 != "function")
          throw new Wr2(a3);
        return g10 = g10 == null ? 0 : _n2(ft2(g10), 0), mt2(function(E4) {
          var T10 = E4[g10], N10 = Ra2(E4, 0, g10);
          return T10 && Ia2(N10, T10), Fr2(h10, this, N10);
        });
      }, U3.tail = function(h10) {
        var g10 = h10 == null ? 0 : h10.length;
        return g10 ? zr2(h10, 1, g10) : [];
      }, U3.take = function(h10, g10, E4) {
        return h10 && h10.length ? zr2(h10, 0, (g10 = E4 || g10 === n3 ? 1 : ft2(g10)) < 0 ? 0 : g10) : [];
      }, U3.takeRight = function(h10, g10, E4) {
        var T10 = h10 == null ? 0 : h10.length;
        return T10 ? zr2(h10, (g10 = T10 - (g10 = E4 || g10 === n3 ? 1 : ft2(g10))) < 0 ? 0 : g10, T10) : [];
      }, U3.takeRightWhile = function(h10, g10) {
        return h10 && h10.length ? Xc2(h10, Je2(g10, 3), false, true) : [];
      }, U3.takeWhile = function(h10, g10) {
        return h10 && h10.length ? Xc2(h10, Je2(g10, 3)) : [];
      }, U3.tap = function(h10, g10) {
        return g10(h10), h10;
      }, U3.throttle = function(h10, g10, E4) {
        var T10 = true, N10 = true;
        if (typeof h10 != "function")
          throw new Wr2(a3);
        return cn2(E4) && (T10 = "leading" in E4 ? !!E4.leading : T10, N10 = "trailing" in E4 ? !!E4.trailing : N10), z1(h10, g10, { leading: T10, maxWait: g10, trailing: N10 });
      }, U3.thru = ol, U3.toArray = Y1, U3.toPairs = iy, U3.toPairsIn = ay, U3.toPath = function(h10) {
        return st2(h10) ? un2(h10, Pi2) : _r2(h10) ? [h10] : pr2(I1(Vt2(h10)));
      }, U3.toPlainObject = ey, U3.transform = function(h10, g10, E4) {
        var T10 = st2(h10), N10 = T10 || Ma2(h10) || is2(h10);
        if (g10 = Je2(g10, 4), E4 == null) {
          var z10 = h10 && h10.constructor;
          E4 = N10 ? T10 ? new z10() : [] : cn2(h10) && ia2(z10) ? Zo2(Rc2(h10)) : {};
        }
        return (N10 ? qr2 : _i2)(h10, function(te2, re2, se2) {
          return g10(E4, te2, re2, se2);
        }), E4;
      }, U3.unary = function(h10) {
        return W1(h10, 1);
      }, U3.union = c_, U3.unionBy = l_, U3.unionWith = p_, U3.uniq = function(h10) {
        return h10 && h10.length ? Na2(h10) : [];
      }, U3.uniqBy = function(h10, g10) {
        return h10 && h10.length ? Na2(h10, Je2(g10, 2)) : [];
      }, U3.uniqWith = function(h10, g10) {
        return g10 = typeof g10 == "function" ? g10 : n3, h10 && h10.length ? Na2(h10, n3, g10) : [];
      }, U3.unset = function(h10, g10) {
        return h10 == null || eh(h10, g10);
      }, U3.unzip = yh, U3.unzipWith = M1, U3.update = function(h10, g10, E4) {
        return h10 == null ? h10 : t1(h10, g10, rh(E4));
      }, U3.updateWith = function(h10, g10, E4, T10) {
        return T10 = typeof T10 == "function" ? T10 : n3, h10 == null ? h10 : t1(h10, g10, rh(E4), T10);
      }, U3.values = as2, U3.valuesIn = function(h10) {
        return h10 == null ? [] : Lf(h10, hr2(h10));
      }, U3.without = f_, U3.words = uy, U3.wrap = function(h10, g10) {
        return xh(rh(g10), h10);
      }, U3.xor = h_, U3.xorBy = d_, U3.xorWith = m_, U3.zip = g_, U3.zipObject = function(h10, g10) {
        return r1(h10 || [], g10 || [], uu2);
      }, U3.zipObjectDeep = function(h10, g10) {
        return r1(h10 || [], g10 || [], fu2);
      }, U3.zipWith = y_, U3.entries = iy, U3.entriesIn = ay, U3.extend = ty, U3.extendWith = hl, wh(U3, U3), U3.add = p6, U3.attempt = cy, U3.camelCase = K_, U3.capitalize = oy, U3.ceil = f6, U3.clamp = function(h10, g10, E4) {
        return E4 === n3 && (E4 = g10, g10 = n3), E4 !== n3 && (E4 = (E4 = Kr2(E4)) == E4 ? E4 : 0), g10 !== n3 && (g10 = (g10 = Kr2(g10)) == g10 ? g10 : 0), mo2(Kr2(h10), g10, E4);
      }, U3.clone = function(h10) {
        return Gr2(h10, p3);
      }, U3.cloneDeep = function(h10) {
        return Gr2(h10, c3 | p3);
      }, U3.cloneDeepWith = function(h10, g10) {
        return Gr2(h10, c3 | p3, g10 = typeof g10 == "function" ? g10 : n3);
      }, U3.cloneWith = function(h10, g10) {
        return Gr2(h10, p3, g10 = typeof g10 == "function" ? g10 : n3);
      }, U3.conformsTo = function(h10, g10) {
        return g10 == null || Ng(h10, g10, Ln2(g10));
      }, U3.deburr = sy, U3.defaultTo = function(h10, g10) {
        return h10 == null || h10 != h10 ? g10 : h10;
      }, U3.divide = h6, U3.endsWith = function(h10, g10, E4) {
        h10 = Vt2(h10), g10 = Ar2(g10);
        var T10 = h10.length, N10 = E4 = E4 === n3 ? T10 : mo2(ft2(E4), 0, T10);
        return (E4 -= g10.length) >= 0 && h10.slice(E4, N10) == g10;
      }, U3.eq = mi2, U3.escape = function(h10) {
        return (h10 = Vt2(h10)) && at2.test(h10) ? h10.replace(Qt2, d32) : h10;
      }, U3.escapeRegExp = function(h10) {
        return (h10 = Vt2(h10)) && er2.test(h10) ? h10.replace(Bn2, "\\$&") : h10;
      }, U3.every = function(h10, g10, E4) {
        var T10 = st2(h10) ? yg : U32;
        return E4 && rr2(h10, g10, E4) && (g10 = n3), T10(h10, Je2(g10, 3));
      }, U3.find = b_, U3.findIndex = O1, U3.findKey = function(h10, g10) {
        return vg(h10, Je2(g10, 3), _i2);
      }, U3.findLast = E_, U3.findLastIndex = L1, U3.findLastKey = function(h10, g10) {
        return vg(h10, Je2(g10, 3), $f);
      }, U3.floor = d6, U3.forEach = U1, U3.forEachRight = q1, U3.forIn = function(h10, g10) {
        return h10 == null ? h10 : Wf(h10, Je2(g10, 3), hr2);
      }, U3.forInRight = function(h10, g10) {
        return h10 == null ? h10 : Vg(h10, Je2(g10, 3), hr2);
      }, U3.forOwn = function(h10, g10) {
        return h10 && _i2(h10, Je2(g10, 3));
      }, U3.forOwnRight = function(h10, g10) {
        return h10 && $f(h10, Je2(g10, 3));
      }, U3.get = Ch, U3.gt = P_, U3.gte = I_, U3.has = function(h10, g10) {
        return h10 != null && S1(h10, g10, q32);
      }, U3.hasIn = Sh, U3.head = j1, U3.identity = dr2, U3.includes = function(h10, g10, E4, T10) {
        h10 = fr2(h10) ? h10 : as2(h10), E4 = E4 && !T10 ? ft2(E4) : 0;
        var N10 = h10.length;
        return E4 < 0 && (E4 = _n2(N10 + E4, 0)), fl2(h10) ? E4 <= N10 && h10.indexOf(g10, E4) > -1 : !!N10 && zo2(h10, g10, E4) > -1;
      }, U3.indexOf = function(h10, g10, E4) {
        var T10 = h10 == null ? 0 : h10.length;
        if (!T10)
          return -1;
        var N10 = E4 == null ? 0 : ft2(E4);
        return N10 < 0 && (N10 = _n2(T10 + N10, 0)), zo2(h10, g10, N10);
      }, U3.inRange = function(h10, g10, E4) {
        return g10 = aa2(g10), E4 === n3 ? (E4 = g10, g10 = 0) : E4 = aa2(E4), function(T10, N10, z10) {
          return T10 >= Hn2(N10, z10) && T10 < _n2(N10, z10);
        }(h10 = Kr2(h10), g10, E4);
      }, U3.invoke = $_, U3.isArguments = vo2, U3.isArray = st2, U3.isArrayBuffer = B_, U3.isArrayLike = fr2, U3.isArrayLikeObject = Cn2, U3.isBoolean = function(h10) {
        return h10 === true || h10 === false || mn2(h10) && nr2(h10) == j3;
      }, U3.isBuffer = Ma2, U3.isDate = O_, U3.isElement = function(h10) {
        return mn2(h10) && h10.nodeType === 1 && !gu2(h10);
      }, U3.isEmpty = function(h10) {
        if (h10 == null)
          return true;
        if (fr2(h10) && (st2(h10) || typeof h10 == "string" || typeof h10.splice == "function" || Ma2(h10) || is2(h10) || vo2(h10)))
          return !h10.length;
        var g10 = Kn2(h10);
        if (g10 == _3 || g10 == Ee2)
          return !h10.size;
        if (du2(h10))
          return !Kf(h10).length;
        for (var E4 in h10)
          if (qt2.call(h10, E4))
            return false;
        return true;
      }, U3.isEqual = function(h10, g10) {
        return pu2(h10, g10);
      }, U3.isEqualWith = function(h10, g10, E4) {
        var T10 = (E4 = typeof E4 == "function" ? E4 : n3) ? E4(h10, g10) : n3;
        return T10 === n3 ? pu2(h10, g10, n3, E4) : !!T10;
      }, U3.isError = bh, U3.isFinite = function(h10) {
        return typeof h10 == "number" && Tg(h10);
      }, U3.isFunction = ia2, U3.isInteger = K1, U3.isLength = pl2, U3.isMap = J1, U3.isMatch = function(h10, g10) {
        return h10 === g10 || Hf(h10, g10, lh(g10));
      }, U3.isMatchWith = function(h10, g10, E4) {
        return E4 = typeof E4 == "function" ? E4 : n3, Hf(h10, g10, lh(g10), E4);
      }, U3.isNaN = function(h10) {
        return Q1(h10) && h10 != +h10;
      }, U3.isNative = function(h10) {
        if (e_(h10))
          throw new Pt2(i);
        return Wg(h10);
      }, U3.isNil = function(h10) {
        return h10 == null;
      }, U3.isNull = function(h10) {
        return h10 === null;
      }, U3.isNumber = Q1, U3.isObject = cn2, U3.isObjectLike = mn2, U3.isPlainObject = gu2, U3.isRegExp = Eh, U3.isSafeInteger = function(h10) {
        return K1(h10) && h10 >= -R3 && h10 <= R3;
      }, U3.isSet = X1, U3.isString = fl2, U3.isSymbol = _r2, U3.isTypedArray = is2, U3.isUndefined = function(h10) {
        return h10 === n3;
      }, U3.isWeakMap = function(h10) {
        return mn2(h10) && Kn2(h10) == _t2;
      }, U3.isWeakSet = function(h10) {
        return mn2(h10) && nr2(h10) == Kt2;
      }, U3.join = function(h10, g10) {
        return h10 == null ? "" : A32.call(h10, g10);
      }, U3.kebabCase = J_, U3.last = Hr2, U3.lastIndexOf = function(h10, g10, E4) {
        var T10 = h10 == null ? 0 : h10.length;
        if (!T10)
          return -1;
        var N10 = T10;
        return E4 !== n3 && (N10 = (N10 = ft2(E4)) < 0 ? _n2(T10 + N10, 0) : Hn2(N10, T10 - 1)), g10 == g10 ? function(z10, te2, re2) {
          for (var se2 = re2 + 1; se2--; )
            if (z10[se2] === te2)
              return se2;
          return se2;
        }(h10, g10, N10) : Tc2(h10, xg, N10, true);
      }, U3.lowerCase = Q_, U3.lowerFirst = X_, U3.lt = L_, U3.lte = N_, U3.max = function(h10) {
        return h10 && h10.length ? Hc2(h10, dr2, Gf) : n3;
      }, U3.maxBy = function(h10, g10) {
        return h10 && h10.length ? Hc2(h10, Je2(g10, 2), Gf) : n3;
      }, U3.mean = function(h10) {
        return bg(h10, dr2);
      }, U3.meanBy = function(h10, g10) {
        return bg(h10, Je2(g10, 2));
      }, U3.min = function(h10) {
        return h10 && h10.length ? Hc2(h10, dr2, Jf) : n3;
      }, U3.minBy = function(h10, g10) {
        return h10 && h10.length ? Hc2(h10, Je2(g10, 2), Jf) : n3;
      }, U3.stubArray = _h, U3.stubFalse = Th, U3.stubObject = function() {
        return {};
      }, U3.stubString = function() {
        return "";
      }, U3.stubTrue = function() {
        return true;
      }, U3.multiply = m6, U3.nth = function(h10, g10) {
        return h10 && h10.length ? Kg(h10, ft2(g10)) : n3;
      }, U3.noConflict = function() {
        return Vn2._ === this && (Vn2._ = C32), this;
      }, U3.noop = Ah, U3.now = ul, U3.pad = function(h10, g10, E4) {
        h10 = Vt2(h10);
        var T10 = (g10 = ft2(g10)) ? Ko2(h10) : 0;
        if (!g10 || T10 >= g10)
          return h10;
        var N10 = (g10 - T10) / 2;
        return tl(qc2(N10), E4) + h10 + tl(Uc2(N10), E4);
      }, U3.padEnd = function(h10, g10, E4) {
        h10 = Vt2(h10);
        var T10 = (g10 = ft2(g10)) ? Ko2(h10) : 0;
        return g10 && T10 < g10 ? h10 + tl(g10 - T10, E4) : h10;
      }, U3.padStart = function(h10, g10, E4) {
        h10 = Vt2(h10);
        var T10 = (g10 = ft2(g10)) ? Ko2(h10) : 0;
        return g10 && T10 < g10 ? tl(g10 - T10, E4) + h10 : h10;
      }, U3.parseInt = function(h10, g10, E4) {
        return E4 || g10 == null ? g10 = 0 : g10 && (g10 = +g10), P3(Vt2(h10).replace(kr2, ""), g10 || 0);
      }, U3.random = function(h10, g10, E4) {
        if (E4 && typeof E4 != "boolean" && rr2(h10, g10, E4) && (g10 = E4 = n3), E4 === n3 && (typeof g10 == "boolean" ? (E4 = g10, g10 = n3) : typeof h10 == "boolean" && (E4 = h10, h10 = n3)), h10 === n3 && g10 === n3 ? (h10 = 0, g10 = 1) : (h10 = aa2(h10), g10 === n3 ? (g10 = h10, h10 = 0) : g10 = aa2(g10)), h10 > g10) {
          var T10 = h10;
          h10 = g10, g10 = T10;
        }
        if (E4 || h10 % 1 || g10 % 1) {
          var N10 = Pg();
          return Hn2(h10 + N10 * (g10 - h10 + a32("1e-" + ((N10 + "").length - 1))), g10);
        }
        return Xf(h10, g10);
      }, U3.reduce = function(h10, g10, E4) {
        var T10 = st2(h10) ? _f : Eg, N10 = arguments.length < 3;
        return T10(h10, Je2(g10, 4), E4, N10, La2);
      }, U3.reduceRight = function(h10, g10, E4) {
        var T10 = st2(h10) ? l3 : Eg, N10 = arguments.length < 3;
        return T10(h10, Je2(g10, 4), E4, N10, Rg);
      }, U3.repeat = function(h10, g10, E4) {
        return g10 = (E4 ? rr2(h10, g10, E4) : g10 === n3) ? 1 : ft2(g10), Yf(Vt2(h10), g10);
      }, U3.replace = function() {
        var h10 = arguments, g10 = Vt2(h10[0]);
        return h10.length < 3 ? g10 : g10.replace(h10[1], h10[2]);
      }, U3.result = function(h10, g10, E4) {
        var T10 = -1, N10 = (g10 = ja2(g10, h10)).length;
        for (N10 || (N10 = 1, h10 = n3); ++T10 < N10; ) {
          var z10 = h10 == null ? n3 : h10[Pi2(g10[T10])];
          z10 === n3 && (T10 = N10, z10 = E4), h10 = ia2(z10) ? z10.call(h10) : z10;
        }
        return h10;
      }, U3.round = g6, U3.runInContext = pe2, U3.sample = function(h10) {
        return (st2(h10) ? Og : G3)(h10);
      }, U3.size = function(h10) {
        if (h10 == null)
          return 0;
        if (fr2(h10))
          return fl2(h10) ? Ko2(h10) : h10.length;
        var g10 = Kn2(h10);
        return g10 == _3 || g10 == Ee2 ? h10.size : Kf(h10).length;
      }, U3.snakeCase = Y_, U3.some = function(h10, g10, E4) {
        var T10 = st2(h10) ? Tf : J32;
        return E4 && rr2(h10, g10, E4) && (g10 = n3), T10(h10, Je2(g10, 3));
      }, U3.sortedIndex = function(h10, g10) {
        return Qc2(h10, g10);
      }, U3.sortedIndexBy = function(h10, g10, E4) {
        return Zf(h10, g10, Je2(E4, 2));
      }, U3.sortedIndexOf = function(h10, g10) {
        var E4 = h10 == null ? 0 : h10.length;
        if (E4) {
          var T10 = Qc2(h10, g10);
          if (T10 < E4 && mi2(h10[T10], g10))
            return T10;
        }
        return -1;
      }, U3.sortedLastIndex = function(h10, g10) {
        return Qc2(h10, g10, true);
      }, U3.sortedLastIndexBy = function(h10, g10, E4) {
        return Zf(h10, g10, Je2(E4, 2), true);
      }, U3.sortedLastIndexOf = function(h10, g10) {
        if (h10 != null && h10.length) {
          var E4 = Qc2(h10, g10, true) - 1;
          if (mi2(h10[E4], g10))
            return E4;
        }
        return -1;
      }, U3.startCase = Z_, U3.startsWith = function(h10, g10, E4) {
        return h10 = Vt2(h10), E4 = E4 == null ? 0 : mo2(ft2(E4), 0, h10.length), g10 = Ar2(g10), h10.slice(E4, E4 + g10.length) == g10;
      }, U3.subtract = y6, U3.sum = function(h10) {
        return h10 && h10.length ? Bf(h10, dr2) : 0;
      }, U3.sumBy = function(h10, g10) {
        return h10 && h10.length ? Bf(h10, Je2(g10, 2)) : 0;
      }, U3.template = function(h10, g10, E4) {
        var T10 = U3.templateSettings;
        E4 && rr2(h10, g10, E4) && (g10 = n3), h10 = Vt2(h10), g10 = hl({}, g10, T10, x1);
        var N10, z10, te2 = hl({}, g10.imports, T10.imports, x1), re2 = Ln2(te2), se2 = Lf(te2, re2), be2 = 0, ve2 = g10.interpolate || Mn2, Ae2 = "__p += '", Ue2 = jf((g10.escape || Mn2).source + "|" + ve2.source + "|" + (ve2 === Rn2 ? Ie2 : Mn2).source + "|" + (g10.evaluate || Mn2).source + "|$", "g"), qe2 = "//# sourceURL=" + (qt2.call(g10, "sourceURL") ? (g10.sourceURL + "").replace(/[\r\n]/g, " ") : "lodash.templateSources[" + ++r32 + "]") + `
`;
        h10.replace(Ue2, function(Te2, et2, Le2, ut2, nt2, Bt2) {
          return Le2 || (Le2 = ut2), Ae2 += h10.slice(be2, Bt2).replace(Ji2, m32), et2 && (N10 = true, Ae2 += `' +
__e(` + et2 + `) +
'`), nt2 && (z10 = true, Ae2 += `';
` + nt2 + `;
__p += '`), Le2 && (Ae2 += `' +
((__t = (` + Le2 + `)) == null ? '' : __t) +
'`), be2 = Bt2 + Te2.length, Te2;
        }), Ae2 += `';
`;
        var Qe2 = qt2.call(g10, "variable") && g10.variable;
        Qe2 || (Ae2 = `with (obj) {
` + Ae2 + `
}
`), Ae2 = (z10 ? Ae2.replace(yt2, "") : Ae2).replace(ze2, "$1").replace(vt2, "$1;"), Ae2 = "function(" + (Qe2 || "obj") + `) {
` + (Qe2 ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (N10 ? ", __e = _.escape" : "") + (z10 ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ae2 + `return __p
}`;
        var Se2 = cy(function() {
          return An2(re2, qe2 + "return " + Ae2).apply(n3, se2);
        });
        if (Se2.source = Ae2, bh(Se2))
          throw Se2;
        return Se2;
      }, U3.times = function(h10, g10) {
        if ((h10 = ft2(h10)) < 1 || h10 > R3)
          return [];
        var E4 = X3, T10 = Hn2(h10, X3);
        g10 = Je2(g10), h10 -= X3;
        for (var N10 = Of(T10, g10); ++E4 < h10; )
          g10(E4);
        return N10;
      }, U3.toFinite = aa2, U3.toInteger = ft2, U3.toLength = Z1, U3.toLower = function(h10) {
        return Vt2(h10).toLowerCase();
      }, U3.toNumber = Kr2, U3.toSafeInteger = function(h10) {
        return h10 ? mo2(ft2(h10), -R3, R3) : h10 === 0 ? h10 : 0;
      }, U3.toString = Vt2, U3.toUpper = function(h10) {
        return Vt2(h10).toUpperCase();
      }, U3.trim = function(h10, g10, E4) {
        if ((h10 = Vt2(h10)) && (E4 || g10 === n3))
          return h10.replace(fi2, "");
        if (!h10 || !(g10 = Ar2(g10)))
          return h10;
        var T10 = hi2(h10), N10 = hi2(g10);
        return Ra2(T10, Cg(T10, N10), Sg(T10, N10) + 1).join("");
      }, U3.trimEnd = function(h10, g10, E4) {
        if ((h10 = Vt2(h10)) && (E4 || g10 === n3))
          return h10.replace(oo2, "");
        if (!h10 || !(g10 = Ar2(g10)))
          return h10;
        var T10 = hi2(h10);
        return Ra2(T10, 0, Sg(T10, hi2(g10)) + 1).join("");
      }, U3.trimStart = function(h10, g10, E4) {
        if ((h10 = Vt2(h10)) && (E4 || g10 === n3))
          return h10.replace(kr2, "");
        if (!h10 || !(g10 = Ar2(g10)))
          return h10;
        var T10 = hi2(h10);
        return Ra2(T10, Cg(T10, hi2(g10))).join("");
      }, U3.truncate = function(h10, g10) {
        var E4 = w3, T10 = D3;
        if (cn2(g10)) {
          var N10 = "separator" in g10 ? g10.separator : N10;
          E4 = "length" in g10 ? ft2(g10.length) : E4, T10 = "omission" in g10 ? Ar2(g10.omission) : T10;
        }
        var z10 = (h10 = Vt2(h10)).length;
        if (Ho2(h10)) {
          var te2 = hi2(h10);
          z10 = te2.length;
        }
        if (E4 >= z10)
          return h10;
        var re2 = E4 - Ko2(T10);
        if (re2 < 1)
          return T10;
        var se2 = te2 ? Ra2(te2, 0, re2).join("") : h10.slice(0, re2);
        if (N10 === n3)
          return se2 + T10;
        if (te2 && (re2 += se2.length - re2), Eh(N10)) {
          if (h10.slice(re2).search(N10)) {
            var be2, ve2 = se2;
            for (N10.global || (N10 = jf(N10.source, Vt2(je2.exec(N10)) + "g")), N10.lastIndex = 0; be2 = N10.exec(ve2); )
              var Ae2 = be2.index;
            se2 = se2.slice(0, Ae2 === n3 ? re2 : Ae2);
          }
        } else if (h10.indexOf(Ar2(N10), re2) != re2) {
          var Ue2 = se2.lastIndexOf(N10);
          Ue2 > -1 && (se2 = se2.slice(0, Ue2));
        }
        return se2 + T10;
      }, U3.unescape = function(h10) {
        return (h10 = Vt2(h10)) && bt2.test(h10) ? h10.replace(Nt2, y32) : h10;
      }, U3.uniqueId = function(h10) {
        var g10 = ++b32;
        return Vt2(h10) + g10;
      }, U3.upperCase = e62, U3.upperFirst = kh, U3.each = U1, U3.eachRight = q1, U3.first = j1, wh(U3, (Ph = {}, _i2(U3, function(h10, g10) {
        qt2.call(U3.prototype, g10) || (Ph[g10] = h10);
      }), Ph), { chain: false }), U3.VERSION = "4.17.15", qr2(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(h10) {
        U3[h10].placeholder = U3;
      }), qr2(["drop", "take"], function(h10, g10) {
        St2.prototype[h10] = function(E4) {
          E4 = E4 === n3 ? 1 : _n2(ft2(E4), 0);
          var T10 = this.__filtered__ && !g10 ? new St2(this) : this.clone();
          return T10.__filtered__ ? T10.__takeCount__ = Hn2(E4, T10.__takeCount__) : T10.__views__.push({ size: Hn2(E4, X3), type: h10 + (T10.__dir__ < 0 ? "Right" : "") }), T10;
        }, St2.prototype[h10 + "Right"] = function(E4) {
          return this.reverse()[h10](E4).reverse();
        };
      }), qr2(["filter", "map", "takeWhile"], function(h10, g10) {
        var E4 = g10 + 1, T10 = E4 == V10 || E4 == 3;
        St2.prototype[h10] = function(N10) {
          var z10 = this.clone();
          return z10.__iteratees__.push({ iteratee: Je2(N10, 3), type: E4 }), z10.__filtered__ = z10.__filtered__ || T10, z10;
        };
      }), qr2(["head", "last"], function(h10, g10) {
        var E4 = "take" + (g10 ? "Right" : "");
        St2.prototype[h10] = function() {
          return this[E4](1).value()[0];
        };
      }), qr2(["initial", "tail"], function(h10, g10) {
        var E4 = "drop" + (g10 ? "" : "Right");
        St2.prototype[h10] = function() {
          return this.__filtered__ ? new St2(this) : this[E4](1);
        };
      }), St2.prototype.compact = function() {
        return this.filter(dr2);
      }, St2.prototype.find = function(h10) {
        return this.filter(h10).head();
      }, St2.prototype.findLast = function(h10) {
        return this.reverse().find(h10);
      }, St2.prototype.invokeMap = mt2(function(h10, g10) {
        return typeof h10 == "function" ? new St2(this) : this.map(function(E4) {
          return lu2(E4, h10, g10);
        });
      }), St2.prototype.reject = function(h10) {
        return this.filter(ll(Je2(h10)));
      }, St2.prototype.slice = function(h10, g10) {
        h10 = ft2(h10);
        var E4 = this;
        return E4.__filtered__ && (h10 > 0 || g10 < 0) ? new St2(E4) : (h10 < 0 ? E4 = E4.takeRight(-h10) : h10 && (E4 = E4.drop(h10)), g10 !== n3 && (E4 = (g10 = ft2(g10)) < 0 ? E4.dropRight(-g10) : E4.take(g10 - h10)), E4);
      }, St2.prototype.takeRightWhile = function(h10) {
        return this.reverse().takeWhile(h10).reverse();
      }, St2.prototype.toArray = function() {
        return this.take(X3);
      }, _i2(St2.prototype, function(h10, g10) {
        var E4 = /^(?:filter|find|map|reject)|While$/.test(g10), T10 = /^(?:head|last)$/.test(g10), N10 = U3[T10 ? "take" + (g10 == "last" ? "Right" : "") : g10], z10 = T10 || /^find/.test(g10);
        N10 && (U3.prototype[g10] = function() {
          var te2 = this.__wrapped__, re2 = T10 ? [1] : arguments, se2 = te2 instanceof St2, be2 = re2[0], ve2 = se2 || st2(te2), Ae2 = function(et2) {
            var Le2 = N10.apply(U3, Ia2([et2], re2));
            return T10 && Ue2 ? Le2[0] : Le2;
          };
          ve2 && E4 && typeof be2 == "function" && be2.length != 1 && (se2 = ve2 = false);
          var Ue2 = this.__chain__, qe2 = !!this.__actions__.length, Qe2 = z10 && !Ue2, Se2 = se2 && !qe2;
          if (!z10 && ve2) {
            te2 = Se2 ? te2 : new St2(this);
            var Te2 = h10.apply(te2, re2);
            return Te2.__actions__.push({ func: ol, args: [Ae2], thisArg: n3 }), new $r2(Te2, Ue2);
          }
          return Qe2 && Se2 ? h10.apply(this, re2) : (Te2 = this.thru(Ae2), Qe2 ? T10 ? Te2.value()[0] : Te2.value() : Te2);
        });
      }), qr2(["pop", "push", "shift", "sort", "splice", "unshift"], function(h10) {
        var g10 = Ic2[h10], E4 = /^(?:push|sort|unshift)$/.test(h10) ? "tap" : "thru", T10 = /^(?:pop|shift)$/.test(h10);
        U3.prototype[h10] = function() {
          var N10 = arguments;
          if (T10 && !this.__chain__) {
            var z10 = this.value();
            return g10.apply(st2(z10) ? z10 : [], N10);
          }
          return this[E4](function(te2) {
            return g10.apply(st2(te2) ? te2 : [], N10);
          });
        };
      }), _i2(St2.prototype, function(h10, g10) {
        var E4 = U3[g10];
        if (E4) {
          var T10 = E4.name + "";
          qt2.call(Yo2, T10) || (Yo2[T10] = []), Yo2[T10].push({ name: g10, func: E4 });
        }
      }), Yo2[Zc2(n3, v3).name] = [{ name: "wrapper", func: n3 }], St2.prototype.clone = function() {
        var h10 = new St2(this.__wrapped__);
        return h10.__actions__ = pr2(this.__actions__), h10.__dir__ = this.__dir__, h10.__filtered__ = this.__filtered__, h10.__iteratees__ = pr2(this.__iteratees__), h10.__takeCount__ = this.__takeCount__, h10.__views__ = pr2(this.__views__), h10;
      }, St2.prototype.reverse = function() {
        if (this.__filtered__) {
          var h10 = new St2(this);
          h10.__dir__ = -1, h10.__filtered__ = true;
        } else
          (h10 = this.clone()).__dir__ *= -1;
        return h10;
      }, St2.prototype.value = function() {
        var h10 = this.__wrapped__.value(), g10 = this.__dir__, E4 = st2(h10), T10 = g10 < 0, N10 = E4 ? h10.length : 0, z10 = function(Bt2, Ge2, tt2) {
          for (var Tn2 = -1, Sn2 = tt2.length; ++Tn2 < Sn2; ) {
            var ir2 = tt2[Tn2], tn2 = ir2.size;
            switch (ir2.type) {
              case "drop":
                Bt2 += tn2;
                break;
              case "dropRight":
                Ge2 -= tn2;
                break;
              case "take":
                Ge2 = Hn2(Ge2, Bt2 + tn2);
                break;
              case "takeRight":
                Bt2 = _n2(Bt2, Ge2 - tn2);
            }
          }
          return { start: Bt2, end: Ge2 };
        }(0, N10, this.__views__), te2 = z10.start, re2 = z10.end, se2 = re2 - te2, be2 = T10 ? re2 : te2 - 1, ve2 = this.__iteratees__, Ae2 = ve2.length, Ue2 = 0, qe2 = Hn2(se2, this.__takeCount__);
        if (!E4 || !T10 && N10 == se2 && qe2 == se2)
          return n1(h10, this.__actions__);
        var Qe2 = [];
        e:
          for (; se2-- && Ue2 < qe2; ) {
            for (var Se2 = -1, Te2 = h10[be2 += g10]; ++Se2 < Ae2; ) {
              var et2 = ve2[Se2], Le2 = et2.iteratee, ut2 = et2.type, nt2 = Le2(Te2);
              if (ut2 == K3)
                Te2 = nt2;
              else if (!nt2) {
                if (ut2 == V10)
                  continue e;
                break e;
              }
            }
            Qe2[Ue2++] = Te2;
          }
        return Qe2;
      }, U3.prototype.at = v_, U3.prototype.chain = function() {
        return V1(this);
      }, U3.prototype.commit = function() {
        return new $r2(this.value(), this.__chain__);
      }, U3.prototype.next = function() {
        this.__values__ === n3 && (this.__values__ = Y1(this.value()));
        var h10 = this.__index__ >= this.__values__.length;
        return { done: h10, value: h10 ? n3 : this.__values__[this.__index__++] };
      }, U3.prototype.plant = function(h10) {
        for (var g10, E4 = this; E4 instanceof Gc2; ) {
          var T10 = B1(E4);
          T10.__index__ = 0, T10.__values__ = n3, g10 ? N10.__wrapped__ = T10 : g10 = T10;
          var N10 = T10;
          E4 = E4.__wrapped__;
        }
        return N10.__wrapped__ = h10, g10;
      }, U3.prototype.reverse = function() {
        var h10 = this.__wrapped__;
        if (h10 instanceof St2) {
          var g10 = h10;
          return this.__actions__.length && (g10 = new St2(this)), (g10 = g10.reverse()).__actions__.push({ func: ol, args: [gh], thisArg: n3 }), new $r2(g10, this.__chain__);
        }
        return this.thru(gh);
      }, U3.prototype.toJSON = U3.prototype.valueOf = U3.prototype.value = function() {
        return n1(this.__wrapped__, this.__actions__);
      }, U3.prototype.first = U3.prototype.head, ru2 && (U3.prototype[ru2] = function() {
        return this;
      }), U3;
    }();
    lo2 ? ((lo2.exports = Jo2)._ = Jo2, Ff._ = Jo2) : Vn2._ = Jo2;
  }).call(ni$1);
}), Fk = { Array: false, ArrayBuffer: false, Atomics: false, BigInt: false, BigInt64Array: false, BigUint64Array: false, Boolean: false, constructor: false, DataView: false, Date: false, decodeURI: false, decodeURIComponent: false, encodeURI: false, encodeURIComponent: false, Error: false, escape: false, eval: false, EvalError: false, Float32Array: false, Float64Array: false, Function: false, globalThis: false, hasOwnProperty: false, Infinity: false, Int16Array: false, Int32Array: false, Int8Array: false, isFinite: false, isNaN: false, isPrototypeOf: false, JSON: false, Map: false, Math: false, NaN: false, Number: false, Object: false, parseFloat: false, parseInt: false, Promise: false, propertyIsEnumerable: false, Proxy: false, RangeError: false, ReferenceError: false, Reflect: false, RegExp: false, Set: false, SharedArrayBuffer: false, String: false, Symbol: false, SyntaxError: false, toLocaleString: false, toString: false, TypeError: false, Uint16Array: false, Uint32Array: false, Uint8Array: false, Uint8ClampedArray: false, undefined: false, unescape: false, URIError: false, valueOf: false, WeakMap: false, WeakSet: false }, wk = { Array: false, Boolean: false, constructor: false, Date: false, decodeURI: false, decodeURIComponent: false, encodeURI: false, encodeURIComponent: false, Error: false, escape: false, eval: false, EvalError: false, Function: false, hasOwnProperty: false, Infinity: false, isFinite: false, isNaN: false, isPrototypeOf: false, JSON: false, Math: false, NaN: false, Number: false, Object: false, parseFloat: false, parseInt: false, propertyIsEnumerable: false, RangeError: false, ReferenceError: false, RegExp: false, String: false, SyntaxError: false, toLocaleString: false, toString: false, TypeError: false, undefined: false, unescape: false, URIError: false, valueOf: false }, Ak = { Array: false, ArrayBuffer: false, Boolean: false, constructor: false, DataView: false, Date: false, decodeURI: false, decodeURIComponent: false, encodeURI: false, encodeURIComponent: false, Error: false, escape: false, eval: false, EvalError: false, Float32Array: false, Float64Array: false, Function: false, hasOwnProperty: false, Infinity: false, Int16Array: false, Int32Array: false, Int8Array: false, isFinite: false, isNaN: false, isPrototypeOf: false, JSON: false, Map: false, Math: false, NaN: false, Number: false, Object: false, parseFloat: false, parseInt: false, Promise: false, propertyIsEnumerable: false, Proxy: false, RangeError: false, ReferenceError: false, Reflect: false, RegExp: false, Set: false, String: false, Symbol: false, SyntaxError: false, toLocaleString: false, toString: false, TypeError: false, Uint16Array: false, Uint32Array: false, Uint8Array: false, Uint8ClampedArray: false, undefined: false, unescape: false, URIError: false, valueOf: false, WeakMap: false, WeakSet: false }, _k = { Array: false, ArrayBuffer: false, Atomics: false, Boolean: false, constructor: false, DataView: false, Date: false, decodeURI: false, decodeURIComponent: false, encodeURI: false, encodeURIComponent: false, Error: false, escape: false, eval: false, EvalError: false, Float32Array: false, Float64Array: false, Function: false, hasOwnProperty: false, Infinity: false, Int16Array: false, Int32Array: false, Int8Array: false, isFinite: false, isNaN: false, isPrototypeOf: false, JSON: false, Map: false, Math: false, NaN: false, Number: false, Object: false, parseFloat: false, parseInt: false, Promise: false, propertyIsEnumerable: false, Proxy: false, RangeError: false, ReferenceError: false, Reflect: false, RegExp: false, Set: false, SharedArrayBuffer: false, String: false, Symbol: false, SyntaxError: false, toLocaleString: false, toString: false, TypeError: false, Uint16Array: false, Uint32Array: false, Uint8Array: false, Uint8ClampedArray: false, undefined: false, unescape: false, URIError: false, valueOf: false, WeakMap: false, WeakSet: false }, Tk = { AbortController: false, AbortSignal: false, addEventListener: false, alert: false, AnalyserNode: false, Animation: false, AnimationEffectReadOnly: false, AnimationEffectTiming: false, AnimationEffectTimingReadOnly: false, AnimationEvent: false, AnimationPlaybackEvent: false, AnimationTimeline: false, applicationCache: false, ApplicationCache: false, ApplicationCacheErrorEvent: false, atob: false, Attr: false, Audio: false, AudioBuffer: false, AudioBufferSourceNode: false, AudioContext: false, AudioDestinationNode: false, AudioListener: false, AudioNode: false, AudioParam: false, AudioProcessingEvent: false, AudioScheduledSourceNode: false, "AudioWorkletGlobalScope ": false, AudioWorkletNode: false, AudioWorkletProcessor: false, BarProp: false, BaseAudioContext: false, BatteryManager: false, BeforeUnloadEvent: false, BiquadFilterNode: false, Blob: false, BlobEvent: false, blur: false, BroadcastChannel: false, btoa: false, BudgetService: false, ByteLengthQueuingStrategy: false, Cache: false, caches: false, CacheStorage: false, cancelAnimationFrame: false, cancelIdleCallback: false, CanvasCaptureMediaStreamTrack: false, CanvasGradient: false, CanvasPattern: false, CanvasRenderingContext2D: false, ChannelMergerNode: false, ChannelSplitterNode: false, CharacterData: false, clearInterval: false, clearTimeout: false, clientInformation: false, ClipboardEvent: false, close: false, closed: false, CloseEvent: false, Comment: false, CompositionEvent: false, confirm: false, console: false, ConstantSourceNode: false, ConvolverNode: false, CountQueuingStrategy: false, createImageBitmap: false, Credential: false, CredentialsContainer: false, crypto: false, Crypto: false, CryptoKey: false, CSS: false, CSSConditionRule: false, CSSFontFaceRule: false, CSSGroupingRule: false, CSSImportRule: false, CSSKeyframeRule: false, CSSKeyframesRule: false, CSSMediaRule: false, CSSNamespaceRule: false, CSSPageRule: false, CSSRule: false, CSSRuleList: false, CSSStyleDeclaration: false, CSSStyleRule: false, CSSStyleSheet: false, CSSSupportsRule: false, CustomElementRegistry: false, customElements: false, CustomEvent: false, DataTransfer: false, DataTransferItem: false, DataTransferItemList: false, defaultstatus: false, defaultStatus: false, DelayNode: false, DeviceMotionEvent: false, DeviceOrientationEvent: false, devicePixelRatio: false, dispatchEvent: false, document: false, Document: false, DocumentFragment: false, DocumentType: false, DOMError: false, DOMException: false, DOMImplementation: false, DOMMatrix: false, DOMMatrixReadOnly: false, DOMParser: false, DOMPoint: false, DOMPointReadOnly: false, DOMQuad: false, DOMRect: false, DOMRectReadOnly: false, DOMStringList: false, DOMStringMap: false, DOMTokenList: false, DragEvent: false, DynamicsCompressorNode: false, Element: false, ErrorEvent: false, event: false, Event: false, EventSource: false, EventTarget: false, external: false, fetch: false, File: false, FileList: false, FileReader: false, find: false, focus: false, FocusEvent: false, FontFace: false, FontFaceSetLoadEvent: false, FormData: false, frameElement: false, frames: false, GainNode: false, Gamepad: false, GamepadButton: false, GamepadEvent: false, getComputedStyle: false, getSelection: false, HashChangeEvent: false, Headers: false, history: false, History: false, HTMLAllCollection: false, HTMLAnchorElement: false, HTMLAreaElement: false, HTMLAudioElement: false, HTMLBaseElement: false, HTMLBodyElement: false, HTMLBRElement: false, HTMLButtonElement: false, HTMLCanvasElement: false, HTMLCollection: false, HTMLContentElement: false, HTMLDataElement: false, HTMLDataListElement: false, HTMLDetailsElement: false, HTMLDialogElement: false, HTMLDirectoryElement: false, HTMLDivElement: false, HTMLDListElement: false, HTMLDocument: false, HTMLElement: false, HTMLEmbedElement: false, HTMLFieldSetElement: false, HTMLFontElement: false, HTMLFormControlsCollection: false, HTMLFormElement: false, HTMLFrameElement: false, HTMLFrameSetElement: false, HTMLHeadElement: false, HTMLHeadingElement: false, HTMLHRElement: false, HTMLHtmlElement: false, HTMLIFrameElement: false, HTMLImageElement: false, HTMLInputElement: false, HTMLLabelElement: false, HTMLLegendElement: false, HTMLLIElement: false, HTMLLinkElement: false, HTMLMapElement: false, HTMLMarqueeElement: false, HTMLMediaElement: false, HTMLMenuElement: false, HTMLMetaElement: false, HTMLMeterElement: false, HTMLModElement: false, HTMLObjectElement: false, HTMLOListElement: false, HTMLOptGroupElement: false, HTMLOptionElement: false, HTMLOptionsCollection: false, HTMLOutputElement: false, HTMLParagraphElement: false, HTMLParamElement: false, HTMLPictureElement: false, HTMLPreElement: false, HTMLProgressElement: false, HTMLQuoteElement: false, HTMLScriptElement: false, HTMLSelectElement: false, HTMLShadowElement: false, HTMLSlotElement: false, HTMLSourceElement: false, HTMLSpanElement: false, HTMLStyleElement: false, HTMLTableCaptionElement: false, HTMLTableCellElement: false, HTMLTableColElement: false, HTMLTableElement: false, HTMLTableRowElement: false, HTMLTableSectionElement: false, HTMLTemplateElement: false, HTMLTextAreaElement: false, HTMLTimeElement: false, HTMLTitleElement: false, HTMLTrackElement: false, HTMLUListElement: false, HTMLUnknownElement: false, HTMLVideoElement: false, IDBCursor: false, IDBCursorWithValue: false, IDBDatabase: false, IDBFactory: false, IDBIndex: false, IDBKeyRange: false, IDBObjectStore: false, IDBOpenDBRequest: false, IDBRequest: false, IDBTransaction: false, IDBVersionChangeEvent: false, IdleDeadline: false, IIRFilterNode: false, Image: false, ImageBitmap: false, ImageBitmapRenderingContext: false, ImageCapture: false, ImageData: false, indexedDB: false, innerHeight: false, innerWidth: false, InputEvent: false, IntersectionObserver: false, IntersectionObserverEntry: false, Intl: false, isSecureContext: false, KeyboardEvent: false, KeyframeEffect: false, KeyframeEffectReadOnly: false, length: false, localStorage: false, location: true, Location: false, locationbar: false, matchMedia: false, MediaDeviceInfo: false, MediaDevices: false, MediaElementAudioSourceNode: false, MediaEncryptedEvent: false, MediaError: false, MediaKeyMessageEvent: false, MediaKeySession: false, MediaKeyStatusMap: false, MediaKeySystemAccess: false, MediaList: false, MediaQueryList: false, MediaQueryListEvent: false, MediaRecorder: false, MediaSettingsRange: false, MediaSource: false, MediaStream: false, MediaStreamAudioDestinationNode: false, MediaStreamAudioSourceNode: false, MediaStreamEvent: false, MediaStreamTrack: false, MediaStreamTrackEvent: false, menubar: false, MessageChannel: false, MessageEvent: false, MessagePort: false, MIDIAccess: false, MIDIConnectionEvent: false, MIDIInput: false, MIDIInputMap: false, MIDIMessageEvent: false, MIDIOutput: false, MIDIOutputMap: false, MIDIPort: false, MimeType: false, MimeTypeArray: false, MouseEvent: false, moveBy: false, moveTo: false, MutationEvent: false, MutationObserver: false, MutationRecord: false, name: false, NamedNodeMap: false, NavigationPreloadManager: false, navigator: false, Navigator: false, NetworkInformation: false, Node: false, NodeFilter: false, NodeIterator: false, NodeList: false, Notification: false, OfflineAudioCompletionEvent: false, OfflineAudioContext: false, offscreenBuffering: false, OffscreenCanvas: true, onabort: true, onafterprint: true, onanimationend: true, onanimationiteration: true, onanimationstart: true, onappinstalled: true, onauxclick: true, onbeforeinstallprompt: true, onbeforeprint: true, onbeforeunload: true, onblur: true, oncancel: true, oncanplay: true, oncanplaythrough: true, onchange: true, onclick: true, onclose: true, oncontextmenu: true, oncuechange: true, ondblclick: true, ondevicemotion: true, ondeviceorientation: true, ondeviceorientationabsolute: true, ondrag: true, ondragend: true, ondragenter: true, ondragleave: true, ondragover: true, ondragstart: true, ondrop: true, ondurationchange: true, onemptied: true, onended: true, onerror: true, onfocus: true, ongotpointercapture: true, onhashchange: true, oninput: true, oninvalid: true, onkeydown: true, onkeypress: true, onkeyup: true, onlanguagechange: true, onload: true, onloadeddata: true, onloadedmetadata: true, onloadstart: true, onlostpointercapture: true, onmessage: true, onmessageerror: true, onmousedown: true, onmouseenter: true, onmouseleave: true, onmousemove: true, onmouseout: true, onmouseover: true, onmouseup: true, onmousewheel: true, onoffline: true, ononline: true, onpagehide: true, onpageshow: true, onpause: true, onplay: true, onplaying: true, onpointercancel: true, onpointerdown: true, onpointerenter: true, onpointerleave: true, onpointermove: true, onpointerout: true, onpointerover: true, onpointerup: true, onpopstate: true, onprogress: true, onratechange: true, onrejectionhandled: true, onreset: true, onresize: true, onscroll: true, onsearch: true, onseeked: true, onseeking: true, onselect: true, onstalled: true, onstorage: true, onsubmit: true, onsuspend: true, ontimeupdate: true, ontoggle: true, ontransitionend: true, onunhandledrejection: true, onunload: true, onvolumechange: true, onwaiting: true, onwheel: true, open: false, openDatabase: false, opener: false, Option: false, origin: false, OscillatorNode: false, outerHeight: false, outerWidth: false, PageTransitionEvent: false, pageXOffset: false, pageYOffset: false, PannerNode: false, parent: false, Path2D: false, PaymentAddress: false, PaymentRequest: false, PaymentRequestUpdateEvent: false, PaymentResponse: false, performance: false, Performance: false, PerformanceEntry: false, PerformanceLongTaskTiming: false, PerformanceMark: false, PerformanceMeasure: false, PerformanceNavigation: false, PerformanceNavigationTiming: false, PerformanceObserver: false, PerformanceObserverEntryList: false, PerformancePaintTiming: false, PerformanceResourceTiming: false, PerformanceTiming: false, PeriodicWave: false, Permissions: false, PermissionStatus: false, personalbar: false, PhotoCapabilities: false, Plugin: false, PluginArray: false, PointerEvent: false, PopStateEvent: false, postMessage: false, Presentation: false, PresentationAvailability: false, PresentationConnection: false, PresentationConnectionAvailableEvent: false, PresentationConnectionCloseEvent: false, PresentationConnectionList: false, PresentationReceiver: false, PresentationRequest: false, print: false, ProcessingInstruction: false, ProgressEvent: false, PromiseRejectionEvent: false, prompt: false, PushManager: false, PushSubscription: false, PushSubscriptionOptions: false, queueMicrotask: false, RadioNodeList: false, Range: false, ReadableStream: false, registerProcessor: false, RemotePlayback: false, removeEventListener: false, Request: false, requestAnimationFrame: false, requestIdleCallback: false, resizeBy: false, ResizeObserver: false, ResizeObserverEntry: false, resizeTo: false, Response: false, RTCCertificate: false, RTCDataChannel: false, RTCDataChannelEvent: false, RTCDtlsTransport: false, RTCIceCandidate: false, RTCIceGatherer: false, RTCIceTransport: false, RTCPeerConnection: false, RTCPeerConnectionIceEvent: false, RTCRtpContributingSource: false, RTCRtpReceiver: false, RTCRtpSender: false, RTCSctpTransport: false, RTCSessionDescription: false, RTCStatsReport: false, RTCTrackEvent: false, screen: false, Screen: false, screenLeft: false, ScreenOrientation: false, screenTop: false, screenX: false, screenY: false, ScriptProcessorNode: false, scroll: false, scrollbars: false, scrollBy: false, scrollTo: false, scrollX: false, scrollY: false, SecurityPolicyViolationEvent: false, Selection: false, self: false, ServiceWorker: false, ServiceWorkerContainer: false, ServiceWorkerRegistration: false, sessionStorage: false, setInterval: false, setTimeout: false, ShadowRoot: false, SharedWorker: false, SourceBuffer: false, SourceBufferList: false, speechSynthesis: false, SpeechSynthesisEvent: false, SpeechSynthesisUtterance: false, StaticRange: false, status: false, statusbar: false, StereoPannerNode: false, stop: false, Storage: false, StorageEvent: false, StorageManager: false, styleMedia: false, StyleSheet: false, StyleSheetList: false, SubtleCrypto: false, SVGAElement: false, SVGAngle: false, SVGAnimatedAngle: false, SVGAnimatedBoolean: false, SVGAnimatedEnumeration: false, SVGAnimatedInteger: false, SVGAnimatedLength: false, SVGAnimatedLengthList: false, SVGAnimatedNumber: false, SVGAnimatedNumberList: false, SVGAnimatedPreserveAspectRatio: false, SVGAnimatedRect: false, SVGAnimatedString: false, SVGAnimatedTransformList: false, SVGAnimateElement: false, SVGAnimateMotionElement: false, SVGAnimateTransformElement: false, SVGAnimationElement: false, SVGCircleElement: false, SVGClipPathElement: false, SVGComponentTransferFunctionElement: false, SVGDefsElement: false, SVGDescElement: false, SVGDiscardElement: false, SVGElement: false, SVGEllipseElement: false, SVGFEBlendElement: false, SVGFEColorMatrixElement: false, SVGFEComponentTransferElement: false, SVGFECompositeElement: false, SVGFEConvolveMatrixElement: false, SVGFEDiffuseLightingElement: false, SVGFEDisplacementMapElement: false, SVGFEDistantLightElement: false, SVGFEDropShadowElement: false, SVGFEFloodElement: false, SVGFEFuncAElement: false, SVGFEFuncBElement: false, SVGFEFuncGElement: false, SVGFEFuncRElement: false, SVGFEGaussianBlurElement: false, SVGFEImageElement: false, SVGFEMergeElement: false, SVGFEMergeNodeElement: false, SVGFEMorphologyElement: false, SVGFEOffsetElement: false, SVGFEPointLightElement: false, SVGFESpecularLightingElement: false, SVGFESpotLightElement: false, SVGFETileElement: false, SVGFETurbulenceElement: false, SVGFilterElement: false, SVGForeignObjectElement: false, SVGGElement: false, SVGGeometryElement: false, SVGGradientElement: false, SVGGraphicsElement: false, SVGImageElement: false, SVGLength: false, SVGLengthList: false, SVGLinearGradientElement: false, SVGLineElement: false, SVGMarkerElement: false, SVGMaskElement: false, SVGMatrix: false, SVGMetadataElement: false, SVGMPathElement: false, SVGNumber: false, SVGNumberList: false, SVGPathElement: false, SVGPatternElement: false, SVGPoint: false, SVGPointList: false, SVGPolygonElement: false, SVGPolylineElement: false, SVGPreserveAspectRatio: false, SVGRadialGradientElement: false, SVGRect: false, SVGRectElement: false, SVGScriptElement: false, SVGSetElement: false, SVGStopElement: false, SVGStringList: false, SVGStyleElement: false, SVGSVGElement: false, SVGSwitchElement: false, SVGSymbolElement: false, SVGTextContentElement: false, SVGTextElement: false, SVGTextPathElement: false, SVGTextPositioningElement: false, SVGTitleElement: false, SVGTransform: false, SVGTransformList: false, SVGTSpanElement: false, SVGUnitTypes: false, SVGUseElement: false, SVGViewElement: false, TaskAttributionTiming: false, Text: false, TextDecoder: false, TextEncoder: false, TextEvent: false, TextMetrics: false, TextTrack: false, TextTrackCue: false, TextTrackCueList: false, TextTrackList: false, TimeRanges: false, toolbar: false, top: false, Touch: false, TouchEvent: false, TouchList: false, TrackEvent: false, TransitionEvent: false, TreeWalker: false, UIEvent: false, URL: false, URLSearchParams: false, ValidityState: false, visualViewport: false, VisualViewport: false, VTTCue: false, WaveShaperNode: false, WebAssembly: false, WebGL2RenderingContext: false, WebGLActiveInfo: false, WebGLBuffer: false, WebGLContextEvent: false, WebGLFramebuffer: false, WebGLProgram: false, WebGLQuery: false, WebGLRenderbuffer: false, WebGLRenderingContext: false, WebGLSampler: false, WebGLShader: false, WebGLShaderPrecisionFormat: false, WebGLSync: false, WebGLTexture: false, WebGLTransformFeedback: false, WebGLUniformLocation: false, WebGLVertexArrayObject: false, WebSocket: false, WheelEvent: false, window: false, Window: false, Worker: false, WritableStream: false, XMLDocument: false, XMLHttpRequest: false, XMLHttpRequestEventTarget: false, XMLHttpRequestUpload: false, XMLSerializer: false, XPathEvaluator: false, XPathExpression: false, XPathResult: false, XSLTProcessor: false }, Pk = { addEventListener: false, applicationCache: false, atob: false, Blob: false, BroadcastChannel: false, btoa: false, Cache: false, caches: false, clearInterval: false, clearTimeout: false, close: true, console: false, fetch: false, FileReaderSync: false, FormData: false, Headers: false, IDBCursor: false, IDBCursorWithValue: false, IDBDatabase: false, IDBFactory: false, IDBIndex: false, IDBKeyRange: false, IDBObjectStore: false, IDBOpenDBRequest: false, IDBRequest: false, IDBTransaction: false, IDBVersionChangeEvent: false, ImageData: false, importScripts: true, indexedDB: false, location: false, MessageChannel: false, MessagePort: false, name: false, navigator: false, Notification: false, onclose: true, onconnect: true, onerror: true, onlanguagechange: true, onmessage: true, onoffline: true, ononline: true, onrejectionhandled: true, onunhandledrejection: true, performance: false, Performance: false, PerformanceEntry: false, PerformanceMark: false, PerformanceMeasure: false, PerformanceNavigation: false, PerformanceResourceTiming: false, PerformanceTiming: false, postMessage: true, Promise: false, queueMicrotask: false, removeEventListener: false, Request: false, Response: false, self: true, ServiceWorkerRegistration: false, setInterval: false, setTimeout: false, TextDecoder: false, TextEncoder: false, URL: false, URLSearchParams: false, WebSocket: false, Worker: false, WorkerGlobalScope: false, XMLHttpRequest: false }, Ik = { __dirname: false, __filename: false, Buffer: false, clearImmediate: false, clearInterval: false, clearTimeout: false, console: false, exports: true, global: false, Intl: false, module: false, process: false, queueMicrotask: false, require: false, setImmediate: false, setInterval: false, setTimeout: false, TextDecoder: false, TextEncoder: false, URL: false, URLSearchParams: false }, Bk = { exports: true, global: false, module: false, require: false }, Ok = { define: false, require: false }, Lk = { after: false, afterEach: false, before: false, beforeEach: false, context: false, describe: false, it: false, mocha: false, run: false, setup: false, specify: false, suite: false, suiteSetup: false, suiteTeardown: false, teardown: false, test: false, xcontext: false, xdescribe: false, xit: false, xspecify: false }, Nk = { afterAll: false, afterEach: false, beforeAll: false, beforeEach: false, describe: false, expect: false, expectAsync: false, fail: false, fdescribe: false, fit: false, it: false, jasmine: false, pending: false, runs: false, spyOn: false, spyOnAllFunctions: false, spyOnProperty: false, waits: false, waitsFor: false, xdescribe: false, xit: false }, jk = { afterAll: false, afterEach: false, beforeAll: false, beforeEach: false, describe: false, expect: false, fdescribe: false, fit: false, it: false, jest: false, pit: false, require: false, test: false, xdescribe: false, xit: false, xtest: false }, Rk = { asyncTest: false, deepEqual: false, equal: false, expect: false, module: false, notDeepEqual: false, notEqual: false, notOk: false, notPropEqual: false, notStrictEqual: false, ok: false, propEqual: false, QUnit: false, raises: false, start: false, stop: false, strictEqual: false, test: false, throws: false }, Mk = { console: true, exports: true, phantom: true, require: true, WebPage: true }, Vk = { emit: false, exports: false, getRow: false, log: false, module: false, provides: false, require: false, respond: false, send: false, start: false, sum: false }, Uk = { defineClass: false, deserialize: false, gc: false, help: false, importClass: false, importPackage: false, java: false, load: false, loadClass: false, Packages: false, print: false, quit: false, readFile: false, readUrl: false, runCommand: false, seal: false, serialize: false, spawn: false, sync: false, toint32: false, version: false }, qk = { __DIR__: false, __FILE__: false, __LINE__: false, com: false, edu: false, exit: false, java: false, Java: false, javafx: false, JavaImporter: false, javax: false, JSAdapter: false, load: false, loadWithNewGlobal: false, org: false, Packages: false, print: false, quit: false }, Wk = { ActiveXObject: true, CollectGarbage: true, Debug: true, Enumerator: true, GetObject: true, RuntimeObject: true, ScriptEngine: true, ScriptEngineBuildVersion: true, ScriptEngineMajorVersion: true, ScriptEngineMinorVersion: true, VBArray: true, WScript: true, WSH: true, XDomainRequest: true }, $k = { $: false, jQuery: false }, Gk = { YAHOO: false, YAHOO_config: false, YUI: false, YUI_config: false }, zk = { cat: false, cd: false, chmod: false, config: false, cp: false, dirs: false, echo: false, env: false, error: false, exec: false, exit: false, find: false, grep: false, ln: false, ls: false, mkdir: false, mv: false, popd: false, pushd: false, pwd: false, rm: false, sed: false, set: false, target: false, tempdir: false, test: false, touch: false, which: false }, Hk = { $: false, $$: false, $A: false, $break: false, $continue: false, $F: false, $H: false, $R: false, $w: false, Abstract: false, Ajax: false, Autocompleter: false, Builder: false, Class: false, Control: false, Draggable: false, Draggables: false, Droppables: false, Effect: false, Element: false, Enumerable: false, Event: false, Field: false, Form: false, Hash: false, Insertion: false, ObjectRange: false, PeriodicalExecuter: false, Position: false, Prototype: false, Scriptaculous: false, Selector: false, Sortable: false, SortableObserver: false, Sound: false, Template: false, Toggle: false, Try: false }, Kk = { _: false, $: false, Accounts: false, AccountsClient: false, AccountsCommon: false, AccountsServer: false, App: false, Assets: false, Blaze: false, check: false, Cordova: false, DDP: false, DDPRateLimiter: false, DDPServer: false, Deps: false, EJSON: false, Email: false, HTTP: false, Log: false, Match: false, Meteor: false, Mongo: false, MongoInternals: false, Npm: false, Package: false, Plugin: false, process: false, Random: false, ReactiveDict: false, ReactiveVar: false, Router: false, ServiceConfiguration: false, Session: false, share: false, Spacebars: false, Template: false, Tinytest: false, Tracker: false, UI: false, Utils: false, WebApp: false, WebAppInternals: false }, Jk = { _isWindows: false, _rand: false, BulkWriteResult: false, cat: false, cd: false, connect: false, db: false, getHostName: false, getMemInfo: false, hostname: false, ISODate: false, listFiles: false, load: false, ls: false, md5sumFile: false, mkdir: false, Mongo: false, NumberInt: false, NumberLong: false, ObjectId: false, PlanCache: false, print: false, printjson: false, pwd: false, quit: false, removeFile: false, rs: false, sh: false, UUID: false, version: false, WriteResult: false }, Qk = { $: false, Application: false, Automation: false, console: false, delay: false, Library: false, ObjC: false, ObjectSpecifier: false, Path: false, Progress: false, Ref: false }, Xk = { addEventListener: false, applicationCache: false, atob: false, Blob: false, BroadcastChannel: false, btoa: false, Cache: false, caches: false, CacheStorage: false, clearInterval: false, clearTimeout: false, Client: false, clients: false, Clients: false, close: true, console: false, ExtendableEvent: false, ExtendableMessageEvent: false, fetch: false, FetchEvent: false, FileReaderSync: false, FormData: false, Headers: false, IDBCursor: false, IDBCursorWithValue: false, IDBDatabase: false, IDBFactory: false, IDBIndex: false, IDBKeyRange: false, IDBObjectStore: false, IDBOpenDBRequest: false, IDBRequest: false, IDBTransaction: false, IDBVersionChangeEvent: false, ImageData: false, importScripts: false, indexedDB: false, location: false, MessageChannel: false, MessagePort: false, name: false, navigator: false, Notification: false, onclose: true, onconnect: true, onerror: true, onfetch: true, oninstall: true, onlanguagechange: true, onmessage: true, onmessageerror: true, onnotificationclick: true, onnotificationclose: true, onoffline: true, ononline: true, onpush: true, onpushsubscriptionchange: true, onrejectionhandled: true, onsync: true, onunhandledrejection: true, performance: false, Performance: false, PerformanceEntry: false, PerformanceMark: false, PerformanceMeasure: false, PerformanceNavigation: false, PerformanceResourceTiming: false, PerformanceTiming: false, postMessage: true, Promise: false, queueMicrotask: false, registration: false, removeEventListener: false, Request: false, Response: false, self: false, ServiceWorker: false, ServiceWorkerContainer: false, ServiceWorkerGlobalScope: false, ServiceWorkerMessageEvent: false, ServiceWorkerRegistration: false, setInterval: false, setTimeout: false, skipWaiting: false, TextDecoder: false, TextEncoder: false, URL: false, URLSearchParams: false, WebSocket: false, WindowClient: false, Worker: false, WorkerGlobalScope: false, XMLHttpRequest: false }, Yk = { advanceClock: false, fakeClearInterval: false, fakeClearTimeout: false, fakeSetInterval: false, fakeSetTimeout: false, resetTimeouts: false, waitsForPromise: false }, Zk = { andThen: false, click: false, currentPath: false, currentRouteName: false, currentURL: false, fillIn: false, find: false, findAll: false, findWithAssert: false, keyEvent: false, pauseTest: false, resumeTest: false, triggerEvent: false, visit: false, wait: false }, eD = { $: false, $$: false, browser: false, by: false, By: false, DartObject: false, element: false, protractor: false }, tD = { browser: false, chrome: false, opr: false }, nD = { cloneInto: false, createObjectIn: false, exportFunction: false, GM: false, GM_addStyle: false, GM_deleteValue: false, GM_getResourceText: false, GM_getResourceURL: false, GM_getValue: false, GM_info: false, GM_listValues: false, GM_log: false, GM_openInTab: false, GM_registerMenuCommand: false, GM_setClipboard: false, GM_setValue: false, GM_xmlhttpRequest: false, unsafeWindow: false }, rD = { $: false, $_: false, $$: false, $0: false, $1: false, $2: false, $3: false, $4: false, $x: false, chrome: false, clear: false, copy: false, debug: false, dir: false, dirxml: false, getEventListeners: false, inspect: false, keys: false, monitor: false, monitorEvents: false, profile: false, profileEnd: false, queryObjects: false, table: false, undebug: false, unmonitor: false, unmonitorEvents: false, values: false }, i8 = { builtin: Fk, es5: wk, es2015: Ak, es2017: _k, browser: Tk, worker: Pk, node: Ik, commonjs: Bk, amd: Ok, mocha: Lk, jasmine: Nk, jest: jk, qunit: Rk, phantomjs: Mk, couch: Vk, rhino: Uk, nashorn: qk, wsh: Wk, jquery: $k, yui: Gk, shelljs: zk, prototypejs: Hk, meteor: Kk, mongo: Jk, applescript: Qk, serviceworker: Xk, atomtest: Yk, embertest: Zk, protractor: eD, "shared-node-browser": { clearInterval: false, clearTimeout: false, console: false, setInterval: false, setTimeout: false, URL: false, URLSearchParams: false }, webextensions: tD, greasemonkey: nD, devtools: rD }, a8 = Cr$1(Object.freeze({ __proto__: null, builtin: Fk, es5: wk, es2015: Ak, es2017: _k, browser: Tk, worker: Pk, node: Ik, commonjs: Bk, amd: Ok, mocha: Lk, jasmine: Nk, jest: jk, qunit: Rk, phantomjs: Mk, couch: Vk, rhino: Uk, nashorn: qk, wsh: Wk, jquery: $k, yui: Gk, shelljs: zk, prototypejs: Hk, meteor: Kk, mongo: Jk, applescript: Qk, serviceworker: Xk, atomtest: Yk, embertest: Zk, protractor: eD, webextensions: tD, greasemonkey: nD, devtools: rD, default: i8 })), ms$1 = 1e3, gs$1 = 60 * ms$1, ys$1 = 60 * gs$1, To$1 = 24 * ys$1, o8 = 7 * To$1, s8 = 365.25 * To$1, u8 = function(e28, t3) {
  t3 = t3 || {};
  var n3 = xe$3(e28);
  if (n3 === "string" && e28.length > 0)
    return function(r3) {
      if (!((r3 = String(r3)).length > 100)) {
        var i = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(r3);
        if (i) {
          var a3 = parseFloat(i[1]);
          switch ((i[2] || "ms").toLowerCase()) {
            case "years":
            case "year":
            case "yrs":
            case "yr":
            case "y":
              return a3 * s8;
            case "weeks":
            case "week":
            case "w":
              return a3 * o8;
            case "days":
            case "day":
            case "d":
              return a3 * To$1;
            case "hours":
            case "hour":
            case "hrs":
            case "hr":
            case "h":
              return a3 * ys$1;
            case "minutes":
            case "minute":
            case "mins":
            case "min":
            case "m":
              return a3 * gs$1;
            case "seconds":
            case "second":
            case "secs":
            case "sec":
            case "s":
              return a3 * ms$1;
            case "milliseconds":
            case "millisecond":
            case "msecs":
            case "msec":
            case "ms":
              return a3;
            default:
              return;
          }
        }
      }
    }(e28);
  if (n3 === "number" && isFinite(e28))
    return t3.long ? function(r3) {
      var i = Math.abs(r3);
      return i >= To$1 ? Vl(r3, i, To$1, "day") : i >= ys$1 ? Vl(r3, i, ys$1, "hour") : i >= gs$1 ? Vl(r3, i, gs$1, "minute") : i >= ms$1 ? Vl(r3, i, ms$1, "second") : r3 + " ms";
    }(e28) : function(r3) {
      var i = Math.abs(r3);
      return i >= To$1 ? Math.round(r3 / To$1) + "d" : i >= ys$1 ? Math.round(r3 / ys$1) + "h" : i >= gs$1 ? Math.round(r3 / gs$1) + "m" : i >= ms$1 ? Math.round(r3 / ms$1) + "s" : r3 + "ms";
    }(e28);
  throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(e28));
};
function Vl(e28, t3, n3, r3) {
  var i = t3 >= 1.5 * n3;
  return Math.round(e28 / n3) + " " + r3 + (i ? "s" : "");
}
var c8 = function(e28) {
  function t3(s3) {
    for (var o3 = 0, u3 = 0; u3 < s3.length; u3++)
      o3 = (o3 << 5) - o3 + s3.charCodeAt(u3), o3 |= 0;
    return n3.colors[Math.abs(o3) % n3.colors.length];
  }
  function n3(s3) {
    var o3;
    function u3() {
      for (var c3 = arguments.length, f3 = new Array(c3), p3 = 0; p3 < c3; p3++)
        f3[p3] = arguments[p3];
      if (u3.enabled) {
        var d3 = u3, m3 = Number(/* @__PURE__ */ new Date()), y3 = m3 - (o3 || m3);
        d3.diff = y3, d3.prev = o3, d3.curr = m3, o3 = m3, f3[0] = n3.coerce(f3[0]), typeof f3[0] != "string" && f3.unshift("%O");
        var v3 = 0;
        f3[0] = f3[0].replace(/%([a-zA-Z%])/g, function(b3, x3) {
          if (b3 === "%%")
            return b3;
          v3++;
          var C3 = n3.formatters[x3];
          if (typeof C3 == "function") {
            var k3 = f3[v3];
            b3 = C3.call(d3, k3), f3.splice(v3, 1), v3--;
          }
          return b3;
        }), n3.formatArgs.call(d3, f3), (d3.log || n3.log).apply(d3, f3);
      }
    }
    return u3.namespace = s3, u3.enabled = n3.enabled(s3), u3.useColors = n3.useColors(), u3.color = t3(s3), u3.destroy = r3, u3.extend = i, typeof n3.init == "function" && n3.init(u3), n3.instances.push(u3), u3;
  }
  function r3() {
    var s3 = n3.instances.indexOf(this);
    return s3 !== -1 && (n3.instances.splice(s3, 1), true);
  }
  function i(s3, o3) {
    var u3 = n3(this.namespace + (o3 === void 0 ? ":" : o3) + s3);
    return u3.log = this.log, u3;
  }
  function a3(s3) {
    return s3.toString().substring(2, s3.toString().length - 2).replace(/\.\*\?$/, "*");
  }
  return n3.debug = n3, n3.default = n3, n3.coerce = function(s3) {
    return s3 instanceof Error ? s3.stack || s3.message : s3;
  }, n3.disable = function() {
    var s3 = [].concat(Mt$2(n3.names.map(a3)), Mt$2(n3.skips.map(a3).map(function(o3) {
      return "-" + o3;
    }))).join(",");
    return n3.enable(""), s3;
  }, n3.enable = function(s3) {
    var o3;
    n3.save(s3), n3.names = [], n3.skips = [];
    var u3 = (typeof s3 == "string" ? s3 : "").split(/[\s,]+/), c3 = u3.length;
    for (o3 = 0; o3 < c3; o3++)
      u3[o3] && ((s3 = u3[o3].replace(/\*/g, ".*?"))[0] === "-" ? n3.skips.push(new RegExp("^" + s3.substr(1) + "$")) : n3.names.push(new RegExp("^" + s3 + "$")));
    for (o3 = 0; o3 < n3.instances.length; o3++) {
      var f3 = n3.instances[o3];
      f3.enabled = n3.enabled(f3.namespace);
    }
  }, n3.enabled = function(s3) {
    if (s3[s3.length - 1] === "*")
      return true;
    var o3, u3;
    for (o3 = 0, u3 = n3.skips.length; o3 < u3; o3++)
      if (n3.skips[o3].test(s3))
        return false;
    for (o3 = 0, u3 = n3.names.length; o3 < u3; o3++)
      if (n3.names[o3].test(s3))
        return true;
    return false;
  }, n3.humanize = u8, Object.keys(e28).forEach(function(s3) {
    n3[s3] = e28[s3];
  }), n3.instances = [], n3.names = [], n3.skips = [], n3.formatters = {}, n3.selectColor = t3, n3.enable(n3.load()), n3;
}, Ka$3 = gt$3(function(e28, t3) {
  t3.log = function() {
    var n3;
    return (typeof console > "u" ? "undefined" : xe$3(console)) === "object" && console.log && (n3 = console).log.apply(n3, arguments);
  }, t3.formatArgs = function(n3) {
    if (n3[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + n3[0] + (this.useColors ? "%c " : " ") + "+" + e28.exports.humanize(this.diff), !!this.useColors) {
      var r3 = "color: " + this.color;
      n3.splice(1, 0, r3, "color: inherit");
      var i = 0, a3 = 0;
      n3[0].replace(/%[a-zA-Z%]/g, function(s3) {
        s3 !== "%%" && (i++, s3 === "%c" && (a3 = i));
      }), n3.splice(a3, 0, r3);
    }
  }, t3.save = function(n3) {
    try {
      n3 ? t3.storage.setItem("debug", n3) : t3.storage.removeItem("debug");
    } catch {
    }
  }, t3.load = function() {
    var n3;
    try {
      n3 = t3.storage.getItem("debug");
    } catch {
    }
    return !n3 && typeof process < "u" && "env" in process && (n3 = {}.DEBUG), n3;
  }, t3.useColors = function() {
    return typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? true : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? false : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }, t3.storage = function() {
    try {
      return localStorage;
    } catch {
    }
  }(), t3.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], e28.exports = c8(t3), e28.exports.formatters.j = function(n3) {
    try {
      return JSON.stringify(n3);
    } catch (r3) {
      return "[UnexpectedJSONParseError]: " + r3.message;
    }
  };
});
Ka$3.log, Ka$3.formatArgs, Ka$3.save, Ka$3.load, Ka$3.useColors, Ka$3.storage, Ka$3.colors;
function H0(e28, t3) {
  var n3 = t3.range[0], r3 = e28, i = false;
  do {
    i = false;
    var a3 = true, s3 = false, o3 = void 0;
    try {
      for (var u3, c3 = r3.childScopes[Symbol.iterator](); !(a3 = (u3 = c3.next()).done); a3 = true) {
        var f3 = u3.value, p3 = f3.block.range;
        if (p3[0] <= n3 && n3 < p3[1]) {
          r3 = f3, i = true;
          break;
        }
      }
    } catch (d3) {
      s3 = true, o3 = d3;
    } finally {
      try {
        a3 || c3.return == null || c3.return();
      } finally {
        if (s3)
          throw o3;
      }
    }
  } while (i);
  return r3;
}
function Ps$1(e28, t3) {
  var n3 = "", r3 = e28;
  for (typeof t3 == "string" ? n3 = t3 : (n3 = t3.name, r3 = H0(r3, t3)); r3 != null; ) {
    var i = r3.set.get(n3);
    if (i != null)
      return i;
    r3 = r3.upper;
  }
  return null;
}
function l8(e28) {
  return !this(e28);
}
function Di$1(e28) {
  return l8.bind(e28);
}
function gf(e28) {
  return e28.value === "=>" && e28.type === "Punctuator";
}
function K0(e28) {
  return e28.value === "," && e28.type === "Punctuator";
}
function J0(e28) {
  return e28.value === ";" && e28.type === "Punctuator";
}
function Q0(e28) {
  return e28.value === ":" && e28.type === "Punctuator";
}
function ro$1(e28) {
  return e28.value === "(" && e28.type === "Punctuator";
}
function yf(e28) {
  return e28.value === ")" && e28.type === "Punctuator";
}
function X0(e28) {
  return e28.value === "[" && e28.type === "Punctuator";
}
function Y0(e28) {
  return e28.value === "]" && e28.type === "Punctuator";
}
function Z0(e28) {
  return e28.value === "{" && e28.type === "Punctuator";
}
function eg(e28) {
  return e28.value === "}" && e28.type === "Punctuator";
}
function tg(e28) {
  return e28.type === "Line" || e28.type === "Block" || e28.type === "Shebang";
}
var iD = Di$1(gf), aD = Di$1(K0), oD = Di$1(J0), sD = Di$1(Q0), uD = Di$1(ro$1), cD = Di$1(yf), lD = Di$1(X0), pD = Di$1(Y0), fD = Di$1(Z0), hD = Di$1(eg), dD = Di$1(tg);
function Ox(e28, t3) {
  return e28.id ? t3.getTokenAfter(e28.id, ro$1) : t3.getFirstToken(e28, ro$1);
}
function mD(e28, t3) {
  var n3 = e28.parent, r3 = null, i = null;
  if (e28.type === "ArrowFunctionExpression") {
    var a3 = t3.getTokenBefore(e28.body, gf);
    r3 = a3.loc.start, i = a3.loc.end;
  } else
    n3.type === "Property" || n3.type === "MethodDefinition" ? (r3 = n3.loc.start, i = Ox(e28, t3).loc.start) : (r3 = e28.loc.start, i = Ox(e28, t3).loc.start);
  return { start: Object.assign({}, r3), end: Object.assign({}, i) };
}
var Lx = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {}, p8 = Object.freeze(/* @__PURE__ */ new Set(["Array", "ArrayBuffer", "BigInt", "BigInt64Array", "BigUint64Array", "Boolean", "DataView", "Date", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "escape", "Float32Array", "Float64Array", "Function", "Infinity", "Int16Array", "Int32Array", "Int8Array", "isFinite", "isNaN", "isPrototypeOf", "JSON", "Map", "Math", "NaN", "Number", "Object", "parseFloat", "parseInt", "Promise", "Proxy", "Reflect", "RegExp", "Set", "String", "Symbol", "Uint16Array", "Uint32Array", "Uint8Array", "Uint8ClampedArray", "undefined", "unescape", "WeakMap", "WeakSet"])), Ad$1 = new Set([Array.isArray, typeof BigInt == "function" ? BigInt : void 0, Boolean, Date, Date.parse, decodeURI, decodeURIComponent, encodeURI, encodeURIComponent, escape, isFinite, isNaN, isPrototypeOf].concat(Mt$2(Object.getOwnPropertyNames(Math).map(function(e28) {
  return Math[e28];
}).filter(function(e28) {
  return typeof e28 == "function";
})), [Number, Number.isFinite, Number.isNaN, Number.parseFloat, Number.parseInt, Object, Object.entries, Object.is, Object.isExtensible, Object.isFrozen, Object.isSealed, Object.keys, Object.values, parseFloat, parseInt, RegExp, String, String.fromCharCode, String.fromCodePoint, String.raw, Symbol, Symbol.for, Symbol.keyFor, unescape]).filter(function(e28) {
  return typeof e28 == "function";
})), Nx = /* @__PURE__ */ new Set([Object.freeze, Object.preventExtensions, Object.seal]);
function f8(e28, t3) {
  var n3 = function(r3, i) {
    for (var a3 = r3; (xe$3(a3) === "object" || typeof a3 == "function") && a3 !== null; ) {
      var s3 = Object.getOwnPropertyDescriptor(a3, i);
      if (s3)
        return s3;
      a3 = Object.getPrototypeOf(a3);
    }
    return null;
  }(e28, t3);
  return n3 != null && n3.get != null;
}
function Fu$1(e28, t3) {
  for (var n3 = [], r3 = 0; r3 < e28.length; ++r3) {
    var i = e28[r3];
    if (i == null)
      n3.length = r3 + 1;
    else if (i.type === "SpreadElement") {
      var a3 = nn$1(i.argument, t3);
      if (a3 == null)
        return null;
      n3.push.apply(n3, Mt$2(a3.value));
    } else {
      var s3 = nn$1(i, t3);
      if (s3 == null)
        return null;
      n3.push(s3.value);
    }
  }
  return n3;
}
var jx = Object.freeze({ ArrayExpression: function(e28, t3) {
  var n3 = Fu$1(e28.elements, t3);
  return n3 != null ? { value: n3 } : null;
}, AssignmentExpression: function(e28, t3) {
  return e28.operator === "=" ? nn$1(e28.right, t3) : null;
}, BinaryExpression: function(e28, t3) {
  if (e28.operator === "in" || e28.operator === "instanceof")
    return null;
  var n3 = nn$1(e28.left, t3), r3 = nn$1(e28.right, t3);
  if (n3 != null && r3 != null)
    switch (e28.operator) {
      case "==":
        return { value: n3.value == r3.value };
      case "!=":
        return { value: n3.value != r3.value };
      case "===":
        return { value: n3.value === r3.value };
      case "!==":
        return { value: n3.value !== r3.value };
      case "<":
        return { value: n3.value < r3.value };
      case "<=":
        return { value: n3.value <= r3.value };
      case ">":
        return { value: n3.value > r3.value };
      case ">=":
        return { value: n3.value >= r3.value };
      case "<<":
        return { value: n3.value << r3.value };
      case ">>":
        return { value: n3.value >> r3.value };
      case ">>>":
        return { value: n3.value >>> r3.value };
      case "+":
        return { value: n3.value + r3.value };
      case "-":
        return { value: n3.value - r3.value };
      case "*":
        return { value: n3.value * r3.value };
      case "/":
        return { value: n3.value / r3.value };
      case "%":
        return { value: n3.value % r3.value };
      case "**":
        return { value: Math.pow(n3.value, r3.value) };
      case "|":
        return { value: n3.value | r3.value };
      case "^":
        return { value: n3.value ^ r3.value };
      case "&":
        return { value: n3.value & r3.value };
    }
  return null;
}, CallExpression: function(e28, t3) {
  var n3 = e28.callee, r3 = Fu$1(e28.arguments, t3);
  if (r3 != null)
    if (n3.type === "MemberExpression") {
      var i = nn$1(n3.object, t3), a3 = n3.computed ? nn$1(n3.property, t3) : { value: n3.property.name };
      if (i != null && a3 != null) {
        var s3 = i.value, o3 = a3.value;
        if (Ad$1.has(s3[o3]))
          return { value: s3[o3].apply(s3, Mt$2(r3)) };
        if (Nx.has(s3[o3]))
          return { value: r3[0] };
      }
    } else {
      var u3 = nn$1(n3, t3);
      if (u3 != null) {
        var c3 = u3.value;
        if (Ad$1.has(c3))
          return { value: c3.apply(void 0, Mt$2(r3)) };
        if (Nx.has(c3))
          return { value: r3[0] };
      }
    }
  return null;
}, ConditionalExpression: function(e28, t3) {
  var n3 = nn$1(e28.test, t3);
  return n3 != null ? n3.value ? nn$1(e28.consequent, t3) : nn$1(e28.alternate, t3) : null;
}, ExpressionStatement: function(e28, t3) {
  return nn$1(e28.expression, t3);
}, Identifier: function(e28, t3) {
  if (t3 != null) {
    var n3 = Ps$1(t3, e28);
    if (n3 != null && n3.defs.length === 0 && p8.has(n3.name) && n3.name in Lx)
      return { value: Lx[n3.name] };
    if (n3 != null && n3.defs.length === 1) {
      var r3 = n3.defs[0];
      if (r3.parent && r3.parent.kind === "const" && r3.node.id.type === "Identifier")
        return nn$1(r3.node.init, t3);
    }
  }
  return null;
}, Literal: function(e28) {
  return e28.regex == null && e28.bigint == null || e28.value != null ? { value: e28.value } : null;
}, LogicalExpression: function(e28, t3) {
  var n3 = nn$1(e28.left, t3);
  if (n3 != null) {
    if (e28.operator === "||" && n3.value || e28.operator === "&&" && !n3.value)
      return n3;
    var r3 = nn$1(e28.right, t3);
    if (r3 != null)
      return r3;
  }
  return null;
}, MemberExpression: function(e28, t3) {
  var n3 = nn$1(e28.object, t3), r3 = e28.computed ? nn$1(e28.property, t3) : { value: e28.property.name };
  return n3 == null || r3 == null || f8(n3.value, r3.value) ? null : { value: n3.value[r3.value] };
}, NewExpression: function(e28, t3) {
  var n3 = nn$1(e28.callee, t3), r3 = Fu$1(e28.arguments, t3);
  if (n3 != null && r3 != null) {
    var i = n3.value;
    if (Ad$1.has(i))
      return { value: g0(i, Mt$2(r3)) };
  }
  return null;
}, ObjectExpression: function(e28, t3) {
  var n3 = {}, r3 = true, i = false, a3 = void 0;
  try {
    for (var s3, o3 = e28.properties[Symbol.iterator](); !(r3 = (s3 = o3.next()).done); r3 = true) {
      var u3 = s3.value;
      if (u3.type === "Property") {
        if (u3.kind !== "init")
          return null;
        var c3 = u3.computed ? nn$1(u3.key, t3) : { value: u3.key.name }, f3 = nn$1(u3.value, t3);
        if (c3 == null || f3 == null)
          return null;
        n3[c3.value] = f3.value;
      } else {
        if (u3.type !== "SpreadElement" && u3.type !== "ExperimentalSpreadProperty")
          return null;
        var p3 = nn$1(u3.argument, t3);
        if (p3 == null)
          return null;
        Object.assign(n3, p3.value);
      }
    }
  } catch (d3) {
    i = true, a3 = d3;
  } finally {
    try {
      r3 || o3.return == null || o3.return();
    } finally {
      if (i)
        throw a3;
    }
  }
  return { value: n3 };
}, SequenceExpression: function(e28, t3) {
  return nn$1(e28.expressions[e28.expressions.length - 1], t3);
}, TaggedTemplateExpression: function(e28, t3) {
  var n3 = nn$1(e28.tag, t3), r3 = Fu$1(e28.quasi.expressions, t3);
  if (n3 != null && r3 != null) {
    var i = n3.value, a3 = e28.quasi.quasis.map(function(s3) {
      return s3.value.cooked;
    });
    if (a3.raw = e28.quasi.quasis.map(function(s3) {
      return s3.value.raw;
    }), i === String.raw)
      return { value: i.apply(void 0, [a3].concat(Mt$2(r3))) };
  }
  return null;
}, TemplateLiteral: function(e28, t3) {
  var n3 = Fu$1(e28.expressions, t3);
  if (n3 != null) {
    for (var r3 = e28.quasis[0].value.cooked, i = 0; i < n3.length; ++i)
      r3 += n3[i], r3 += e28.quasis[i + 1].value.cooked;
    return { value: r3 };
  }
  return null;
}, UnaryExpression: function(e28, t3) {
  if (e28.operator === "delete")
    return null;
  if (e28.operator === "void")
    return { value: void 0 };
  var n3 = nn$1(e28.argument, t3);
  if (n3 != null)
    switch (e28.operator) {
      case "-":
        return { value: -n3.value };
      case "+":
        return { value: +n3.value };
      case "!":
        return { value: !n3.value };
      case "~":
        return { value: ~n3.value };
      case "typeof":
        return { value: xe$3(n3.value) };
    }
  return null;
} });
function nn$1(e28, t3) {
  return e28 != null && Object.hasOwnProperty.call(jx, e28.type) ? jx[e28.type](e28, t3) : null;
}
function ng(e28) {
  var t3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  try {
    return nn$1(e28, t3);
  } catch {
    return null;
  }
}
function hc$2(e28) {
  var t3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (e28 && e28.type === "Literal" && e28.value === null) {
    if (e28.regex)
      return "/".concat(e28.regex.pattern, "/").concat(e28.regex.flags);
    if (e28.bigint)
      return e28.bigint;
  }
  var n3 = ng(e28, t3);
  return n3 && String(n3.value);
}
function dc$2(e28, t3) {
  switch (e28.type) {
    case "MemberExpression":
      return e28.computed ? hc$2(e28.property, t3) : e28.property.name;
    case "Property":
    case "MethodDefinition":
      return e28.computed ? hc$2(e28.key, t3) : e28.key.type === "Literal" ? String(e28.key.value) : e28.key.name;
  }
  return null;
}
function gD(e28) {
  var t3 = e28.parent, n3 = [];
  if (t3.type === "MethodDefinition" && t3.static && n3.push("static"), e28.async && n3.push("async"), e28.generator && n3.push("generator"), e28.type === "ArrowFunctionExpression")
    n3.push("arrow", "function");
  else if (t3.type === "Property" || t3.type === "MethodDefinition") {
    if (t3.kind === "constructor")
      return "constructor";
    t3.kind === "get" ? n3.push("getter") : t3.kind === "set" ? n3.push("setter") : n3.push("method");
  } else
    n3.push("function");
  if (e28.id)
    n3.push("'".concat(e28.id.name, "'"));
  else {
    var r3 = dc$2(t3);
    r3 && n3.push("'".concat(r3, "'"));
  }
  return n3.join(" ");
}
var h8 = Object.freeze(/* @__PURE__ */ new Set(["==", "!=", "<", "<=", ">", ">=", "<<", ">>", ">>>", "+", "-", "*", "/", "%", "|", "^", "&", "in"])), d8 = Object.freeze(/* @__PURE__ */ new Set(["-", "+", "!", "~"])), m8 = Object.freeze(Object.assign(/* @__PURE__ */ Object.create(null), { $visit: function(e28, t3, n3) {
  var r3 = e28.type;
  return typeof this[r3] == "function" ? this[r3](e28, t3, n3) : this.$visitChildren(e28, t3, n3);
}, $visitChildren: function(e28, t3, n3) {
  var r3 = e28.type, i = true, a3 = false, s3 = void 0;
  try {
    for (var o3, u3 = (n3[r3] || pf.getKeys(e28))[Symbol.iterator](); !(i = (o3 = u3.next()).done); i = true) {
      var c3 = e28[o3.value];
      if (Array.isArray(c3)) {
        var f3 = true, p3 = false, d3 = void 0;
        try {
          for (var m3, y3 = c3[Symbol.iterator](); !(f3 = (m3 = y3.next()).done); f3 = true) {
            var v3 = m3.value;
            if (v3 && this.$visit(v3, t3, n3))
              return true;
          }
        } catch (b3) {
          p3 = true, d3 = b3;
        } finally {
          try {
            f3 || y3.return == null || y3.return();
          } finally {
            if (p3)
              throw d3;
          }
        }
      } else if (c3 && this.$visit(c3, t3, n3))
        return true;
    }
  } catch (b3) {
    a3 = true, s3 = b3;
  } finally {
    try {
      i || u3.return == null || u3.return();
    } finally {
      if (a3)
        throw s3;
    }
  }
  return false;
}, ArrowFunctionExpression: function() {
  return false;
}, AssignmentExpression: function() {
  return true;
}, AwaitExpression: function() {
  return true;
}, BinaryExpression: function(e28, t3, n3) {
  return !(!t3.considerImplicitTypeConversion || !h8.has(e28.operator) || e28.left.type === "Literal" && e28.right.type === "Literal") || this.$visitChildren(e28, t3, n3);
}, CallExpression: function() {
  return true;
}, FunctionExpression: function() {
  return false;
}, ImportExpression: function() {
  return true;
}, MemberExpression: function(e28, t3, n3) {
  return !!t3.considerGetters || !(!t3.considerImplicitTypeConversion || !e28.computed || e28.property.type === "Literal") || this.$visitChildren(e28, t3, n3);
}, MethodDefinition: function(e28, t3, n3) {
  return !(!t3.considerImplicitTypeConversion || !e28.computed || e28.key.type === "Literal") || this.$visitChildren(e28, t3, n3);
}, NewExpression: function() {
  return true;
}, Property: function(e28, t3, n3) {
  return !(!t3.considerImplicitTypeConversion || !e28.computed || e28.key.type === "Literal") || this.$visitChildren(e28, t3, n3);
}, UnaryExpression: function(e28, t3, n3) {
  return e28.operator === "delete" || !(!t3.considerImplicitTypeConversion || !d8.has(e28.operator) || e28.argument.type === "Literal") || this.$visitChildren(e28, t3, n3);
}, UpdateExpression: function() {
  return true;
}, YieldExpression: function() {
  return true;
} }));
function yD(e28, t3) {
  var n3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r3 = n3.considerGetters, i = r3 !== void 0 && r3, a3 = n3.considerImplicitTypeConversion, s3 = a3 !== void 0 && a3;
  return m8.$visit(e28, { considerGetters: i, considerImplicitTypeConversion: s3 }, t3.visitorKeys || pf.KEYS);
}
function g8(e28, t3) {
  var n3 = e28.parent;
  switch (n3.type) {
    case "CallExpression":
    case "NewExpression":
      return n3.arguments.length === 1 && n3.arguments[0] === e28 ? t3.getTokenAfter(n3.callee, ro$1) : null;
    case "DoWhileStatement":
      return n3.test === e28 ? t3.getTokenAfter(n3.body, ro$1) : null;
    case "IfStatement":
    case "WhileStatement":
      return n3.test === e28 ? t3.getFirstToken(n3, 1) : null;
    case "ImportExpression":
      return n3.source === e28 ? t3.getFirstToken(n3, 1) : null;
    case "SwitchStatement":
      return n3.discriminant === e28 ? t3.getFirstToken(n3, 1) : null;
    case "WithStatement":
      return n3.object === e28 ? t3.getFirstToken(n3, 1) : null;
    default:
      return null;
  }
}
function vD(e28, t3, n3) {
  var r3, i, a3, s3, o3;
  if (typeof e28 == "number") {
    if (i = t3, a3 = n3, !((r3 = 0 | e28) >= 1))
      throw new TypeError("'times' should be a positive integer.");
  } else
    r3 = 1, i = e28, a3 = t3;
  if (i == null)
    return false;
  s3 = o3 = i;
  do
    s3 = a3.getTokenBefore(s3), o3 = a3.getTokenAfter(o3);
  while (s3 != null && o3 != null && ro$1(s3) && yf(o3) && s3 !== g8(i, a3) && --r3 > 0);
  return r3 === 0;
}
var y8 = /\$(?:[\$&'`]|[1-9][0-9]?)/g, Rx = /* @__PURE__ */ new WeakMap();
function v8(e28, t3) {
  for (var n3 = false, r3 = t3 - 1; r3 >= 0 && e28.charCodeAt(r3) === 92; --r3)
    n3 = !n3;
  return n3;
}
var xD = function() {
  function e28(t3) {
    var n3 = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).escaped, r3 = n3 !== void 0 && n3;
    if (We$1(this, e28), !(t3 instanceof RegExp))
      throw new TypeError("'pattern' should be a RegExp instance.");
    if (!t3.flags.includes("g"))
      throw new Error("'pattern' should contains 'g' flag.");
    Rx.set(this, { pattern: new RegExp(t3.source, t3.flags), escaped: !!r3 });
  }
  return Xe$1(e28, [{ key: "execAll", value: regeneratorRuntime.mark(function t3(n3) {
    var r3, i, a3, s3, o3;
    return regeneratorRuntime.wrap(function(u3) {
      for (; ; )
        switch (u3.prev = u3.next) {
          case 0:
            r3 = Rx.get(this), i = r3.pattern, a3 = r3.escaped, s3 = null, o3 = 0, i.lastIndex = 0;
          case 4:
            if ((s3 = i.exec(n3)) == null) {
              u3.next = 12;
              break;
            }
            if (!a3 && v8(n3, s3.index)) {
              u3.next = 10;
              break;
            }
            return o3 = i.lastIndex, u3.next = 9, s3;
          case 9:
            i.lastIndex = o3;
          case 10:
            u3.next = 4;
            break;
          case 12:
          case "end":
            return u3.stop();
        }
    }, t3, this);
  }) }, { key: "test", value: function(t3) {
    return !this.execAll(t3).next().done;
  } }, { key: Symbol.replace, value: function(t3, n3) {
    return typeof n3 == "function" ? function(r3, i, a3) {
      var s3 = [], o3 = 0, u3 = true, c3 = false, f3 = void 0;
      try {
        for (var p3, d3 = r3.execAll(i)[Symbol.iterator](); !(u3 = (p3 = d3.next()).done); u3 = true) {
          var m3 = p3.value;
          s3.push(i.slice(o3, m3.index)), s3.push(String(a3.apply(void 0, Mt$2(m3).concat([m3.index, m3.input])))), o3 = m3.index + m3[0].length;
        }
      } catch (y3) {
        c3 = true, f3 = y3;
      } finally {
        try {
          u3 || d3.return == null || d3.return();
        } finally {
          if (c3)
            throw f3;
        }
      }
      return s3.push(i.slice(o3)), s3.join("");
    }(this, String(t3), n3) : function(r3, i, a3) {
      var s3 = [], o3 = 0, u3 = null;
      function c3(v3) {
        switch (v3) {
          case "$$":
            return "$";
          case "$&":
            return u3[0];
          case "$`":
            return i.slice(0, u3.index);
          case "$'":
            return i.slice(u3.index + u3[0].length);
          default:
            var b3 = v3.slice(1);
            return b3 in u3 ? u3[b3] : v3;
        }
      }
      var f3 = true, p3 = false, d3 = void 0;
      try {
        for (var m3, y3 = r3.execAll(i)[Symbol.iterator](); !(f3 = (m3 = y3.next()).done); f3 = true)
          u3 = m3.value, s3.push(i.slice(o3, u3.index)), s3.push(a3.replace(y8, c3)), o3 = u3.index + u3[0].length;
      } catch (v3) {
        p3 = true, d3 = v3;
      } finally {
        try {
          f3 || y3.return == null || y3.return();
        } finally {
          if (p3)
            throw d3;
        }
      }
      return s3.push(i.slice(o3)), s3.join("");
    }(this, String(t3), String(n3));
  } }]), e28;
}(), x8 = /^(?:Import|Export(?:All|Default|Named))Declaration$/, Co$1 = Function.call.bind(Object.hasOwnProperty), Wt$2 = Symbol("read"), Lo$1 = Symbol("call"), Is$1 = Symbol("construct"), vf = Symbol("esm"), b8 = { require: Fn$1({}, Lo$1, true) };
function Mx(e28) {
  return e28 == null || e28.defs.length !== 0 || e28.references.some(function(t3) {
    return t3.isWrite();
  });
}
function E8(e28) {
  var t3 = e28.parent;
  switch (t3 && t3.type) {
    case "ConditionalExpression":
      return t3.consequent === e28 || t3.alternate === e28;
    case "LogicalExpression":
      return true;
    case "SequenceExpression":
      return t3.expressions[t3.expressions.length - 1] === e28;
    default:
      return false;
  }
}
var Fs$1 = function() {
  function e28(t3) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = n3.mode, i = r3 === void 0 ? "strict" : r3, a3 = n3.globalObjectNames, s3 = a3 === void 0 ? ["global", "self", "window"] : a3;
    We$1(this, e28), this.variableStack = [], this.globalScope = t3, this.mode = i, this.globalObjectNames = s3.slice(0);
  }
  return Xe$1(e28, [{ key: "iterateGlobalReferences", value: regeneratorRuntime.mark(function t3(n3) {
    var r3, i, a3, s3, o3, u3, c3, f3, p3, d3, m3, y3, v3, b3;
    return regeneratorRuntime.wrap(function(x3) {
      for (; ; )
        switch (x3.prev = x3.next) {
          case 0:
            r3 = 0, i = Object.keys(n3);
          case 1:
            if (!(r3 < i.length)) {
              x3.next = 12;
              break;
            }
            if (a3 = i[r3], s3 = n3[a3], o3 = [a3], !Mx(u3 = this.globalScope.set.get(a3))) {
              x3.next = 8;
              break;
            }
            return x3.abrupt("continue", 9);
          case 8:
            return x3.delegateYield(this._iterateVariableReferences(u3, o3, s3, true), "t0", 9);
          case 9:
            r3++, x3.next = 1;
            break;
          case 12:
            c3 = true, f3 = false, p3 = void 0, x3.prev = 15, d3 = this.globalObjectNames[Symbol.iterator]();
          case 17:
            if (c3 = (m3 = d3.next()).done) {
              x3.next = 27;
              break;
            }
            if (y3 = m3.value, v3 = [], !Mx(b3 = this.globalScope.set.get(y3))) {
              x3.next = 23;
              break;
            }
            return x3.abrupt("continue", 24);
          case 23:
            return x3.delegateYield(this._iterateVariableReferences(b3, v3, n3, false), "t1", 24);
          case 24:
            c3 = true, x3.next = 17;
            break;
          case 27:
            x3.next = 33;
            break;
          case 29:
            x3.prev = 29, x3.t2 = x3.catch(15), f3 = true, p3 = x3.t2;
          case 33:
            x3.prev = 33, x3.prev = 34, c3 || d3.return == null || d3.return();
          case 36:
            if (x3.prev = 36, !f3) {
              x3.next = 39;
              break;
            }
            throw p3;
          case 39:
            return x3.finish(36);
          case 40:
            return x3.finish(33);
          case 41:
          case "end":
            return x3.stop();
        }
    }, t3, this, [[15, 29, 33, 41], [34, , 36, 40]]);
  }) }, { key: "iterateCjsReferences", value: regeneratorRuntime.mark(function t3(n3) {
    var r3, i, a3, s3, o3, u3, c3, f3, p3;
    return regeneratorRuntime.wrap(function(d3) {
      for (; ; )
        switch (d3.prev = d3.next) {
          case 0:
            r3 = true, i = false, a3 = void 0, d3.prev = 3, s3 = this.iterateGlobalReferences(b8)[Symbol.iterator]();
          case 5:
            if (r3 = (o3 = s3.next()).done) {
              d3.next = 19;
              break;
            }
            if (u3 = o3.value.node, (c3 = hc$2(u3.arguments[0])) != null && Co$1(n3, c3)) {
              d3.next = 10;
              break;
            }
            return d3.abrupt("continue", 16);
          case 10:
            if (f3 = n3[c3], p3 = [c3], !f3[Wt$2]) {
              d3.next = 15;
              break;
            }
            return d3.next = 15, { node: u3, path: p3, type: Wt$2, info: f3[Wt$2] };
          case 15:
            return d3.delegateYield(this._iteratePropertyReferences(u3, p3, f3), "t0", 16);
          case 16:
            r3 = true, d3.next = 5;
            break;
          case 19:
            d3.next = 25;
            break;
          case 21:
            d3.prev = 21, d3.t1 = d3.catch(3), i = true, a3 = d3.t1;
          case 25:
            d3.prev = 25, d3.prev = 26, r3 || s3.return == null || s3.return();
          case 28:
            if (d3.prev = 28, !i) {
              d3.next = 31;
              break;
            }
            throw a3;
          case 31:
            return d3.finish(28);
          case 32:
            return d3.finish(25);
          case 33:
          case "end":
            return d3.stop();
        }
    }, t3, this, [[3, 21, 25, 33], [26, , 28, 32]]);
  }) }, { key: "iterateEsmReferences", value: regeneratorRuntime.mark(function t3(n3) {
    var r3, i, a3, s3, o3, u3, c3, f3, p3, d3, m3, y3, v3, b3, x3, C3, k3, F3, B3, O3, S3, w3, D3, I3, L3, V10, K3, W3;
    return regeneratorRuntime.wrap(function(R3) {
      for (; ; )
        switch (R3.prev = R3.next) {
          case 0:
            r3 = this.globalScope.block, i = true, a3 = false, s3 = void 0, R3.prev = 4, o3 = r3.body[Symbol.iterator]();
          case 6:
            if (i = (u3 = o3.next()).done) {
              R3.next = 92;
              break;
            }
            if (c3 = u3.value, x8.test(c3.type) && c3.source != null) {
              R3.next = 10;
              break;
            }
            return R3.abrupt("continue", 89);
          case 10:
            if (f3 = c3.source.value, Co$1(n3, f3)) {
              R3.next = 13;
              break;
            }
            return R3.abrupt("continue", 89);
          case 13:
            if (p3 = n3[f3], d3 = [f3], !p3[Wt$2]) {
              R3.next = 18;
              break;
            }
            return R3.next = 18, { node: c3, path: d3, type: Wt$2, info: p3[Wt$2] };
          case 18:
            if (c3.type !== "ExportAllDeclaration") {
              R3.next = 31;
              break;
            }
            m3 = 0, y3 = Object.keys(p3);
          case 20:
            if (!(m3 < y3.length)) {
              R3.next = 29;
              break;
            }
            if (v3 = y3[m3], !(b3 = p3[v3])[Wt$2]) {
              R3.next = 26;
              break;
            }
            return R3.next = 26, { node: c3, path: d3.concat(v3), type: Wt$2, info: b3[Wt$2] };
          case 26:
            m3++, R3.next = 20;
            break;
          case 29:
            R3.next = 89;
            break;
          case 31:
            x3 = true, C3 = false, k3 = void 0, R3.prev = 34, F3 = c3.specifiers[Symbol.iterator]();
          case 36:
            if (x3 = (B3 = F3.next()).done) {
              R3.next = 75;
              break;
            }
            if (O3 = B3.value, S3 = Co$1(p3, vf), w3 = this._iterateImportReferences(O3, d3, S3 ? p3 : this.mode === "legacy" ? Object.assign({ default: p3 }, p3) : { default: p3 }), !S3) {
              R3.next = 44;
              break;
            }
            return R3.delegateYield(w3, "t0", 42);
          case 42:
            R3.next = 72;
            break;
          case 44:
            D3 = true, I3 = false, L3 = void 0, R3.prev = 47, V10 = w3[Symbol.iterator]();
          case 49:
            if (D3 = (K3 = V10.next()).done) {
              R3.next = 58;
              break;
            }
            if ((W3 = K3.value).path = W3.path.filter(C8), !(W3.path.length >= 2 || W3.type !== Wt$2)) {
              R3.next = 55;
              break;
            }
            return R3.next = 55, W3;
          case 55:
            D3 = true, R3.next = 49;
            break;
          case 58:
            R3.next = 64;
            break;
          case 60:
            R3.prev = 60, R3.t1 = R3.catch(47), I3 = true, L3 = R3.t1;
          case 64:
            R3.prev = 64, R3.prev = 65, D3 || V10.return == null || V10.return();
          case 67:
            if (R3.prev = 67, !I3) {
              R3.next = 70;
              break;
            }
            throw L3;
          case 70:
            return R3.finish(67);
          case 71:
            return R3.finish(64);
          case 72:
            x3 = true, R3.next = 36;
            break;
          case 75:
            R3.next = 81;
            break;
          case 77:
            R3.prev = 77, R3.t2 = R3.catch(34), C3 = true, k3 = R3.t2;
          case 81:
            R3.prev = 81, R3.prev = 82, x3 || F3.return == null || F3.return();
          case 84:
            if (R3.prev = 84, !C3) {
              R3.next = 87;
              break;
            }
            throw k3;
          case 87:
            return R3.finish(84);
          case 88:
            return R3.finish(81);
          case 89:
            i = true, R3.next = 6;
            break;
          case 92:
            R3.next = 98;
            break;
          case 94:
            R3.prev = 94, R3.t3 = R3.catch(4), a3 = true, s3 = R3.t3;
          case 98:
            R3.prev = 98, R3.prev = 99, i || o3.return == null || o3.return();
          case 101:
            if (R3.prev = 101, !a3) {
              R3.next = 104;
              break;
            }
            throw s3;
          case 104:
            return R3.finish(101);
          case 105:
            return R3.finish(98);
          case 106:
          case "end":
            return R3.stop();
        }
    }, t3, this, [[4, 94, 98, 106], [34, 77, 81, 89], [47, 60, 64, 72], [65, , 67, 71], [82, , 84, 88], [99, , 101, 105]]);
  }) }, { key: "_iterateVariableReferences", value: regeneratorRuntime.mark(function t3(n3, r3, i, a3) {
    var s3, o3, u3, c3, f3, p3, d3;
    return regeneratorRuntime.wrap(function(m3) {
      for (; ; )
        switch (m3.prev = m3.next) {
          case 0:
            if (!this.variableStack.includes(n3)) {
              m3.next = 2;
              break;
            }
            return m3.abrupt("return");
          case 2:
            this.variableStack.push(n3), m3.prev = 3, s3 = true, o3 = false, u3 = void 0, m3.prev = 7, c3 = n3.references[Symbol.iterator]();
          case 9:
            if (s3 = (f3 = c3.next()).done) {
              m3.next = 21;
              break;
            }
            if ((p3 = f3.value).isRead()) {
              m3.next = 13;
              break;
            }
            return m3.abrupt("continue", 18);
          case 13:
            if (d3 = p3.identifier, !a3 || !i[Wt$2]) {
              m3.next = 17;
              break;
            }
            return m3.next = 17, { node: d3, path: r3, type: Wt$2, info: i[Wt$2] };
          case 17:
            return m3.delegateYield(this._iteratePropertyReferences(d3, r3, i), "t0", 18);
          case 18:
            s3 = true, m3.next = 9;
            break;
          case 21:
            m3.next = 27;
            break;
          case 23:
            m3.prev = 23, m3.t1 = m3.catch(7), o3 = true, u3 = m3.t1;
          case 27:
            m3.prev = 27, m3.prev = 28, s3 || c3.return == null || c3.return();
          case 30:
            if (m3.prev = 30, !o3) {
              m3.next = 33;
              break;
            }
            throw u3;
          case 33:
            return m3.finish(30);
          case 34:
            return m3.finish(27);
          case 35:
            return m3.prev = 35, this.variableStack.pop(), m3.finish(35);
          case 38:
          case "end":
            return m3.stop();
        }
    }, t3, this, [[3, , 35, 38], [7, 23, 27, 35], [28, , 30, 34]]);
  }) }, { key: "_iteratePropertyReferences", value: regeneratorRuntime.mark(function t3(n3, r3, i) {
    var a3, s3, o3, u3;
    return regeneratorRuntime.wrap(function(c3) {
      for (; ; )
        switch (c3.prev = c3.next) {
          case 0:
            for (a3 = n3; E8(a3); )
              a3 = a3.parent;
            if ((s3 = a3.parent).type !== "MemberExpression") {
              c3.next = 15;
              break;
            }
            if (s3.object !== a3) {
              c3.next = 14;
              break;
            }
            if ((o3 = dc$2(s3)) != null && Co$1(i, o3)) {
              c3.next = 8;
              break;
            }
            return c3.abrupt("return");
          case 8:
            if (r3 = r3.concat(o3), !(u3 = i[o3])[Wt$2]) {
              c3.next = 13;
              break;
            }
            return c3.next = 13, { node: s3, path: r3, type: Wt$2, info: u3[Wt$2] };
          case 13:
            return c3.delegateYield(this._iteratePropertyReferences(s3, r3, u3), "t0", 14);
          case 14:
            return c3.abrupt("return");
          case 15:
            if (s3.type !== "CallExpression") {
              c3.next = 20;
              break;
            }
            if (s3.callee !== a3 || !i[Lo$1]) {
              c3.next = 19;
              break;
            }
            return c3.next = 19, { node: s3, path: r3, type: Lo$1, info: i[Lo$1] };
          case 19:
            return c3.abrupt("return");
          case 20:
            if (s3.type !== "NewExpression") {
              c3.next = 25;
              break;
            }
            if (s3.callee !== a3 || !i[Is$1]) {
              c3.next = 24;
              break;
            }
            return c3.next = 24, { node: s3, path: r3, type: Is$1, info: i[Is$1] };
          case 24:
            return c3.abrupt("return");
          case 25:
            if (s3.type !== "AssignmentExpression") {
              c3.next = 30;
              break;
            }
            if (s3.right !== a3) {
              c3.next = 29;
              break;
            }
            return c3.delegateYield(this._iterateLhsReferences(s3.left, r3, i), "t1", 28);
          case 28:
            return c3.delegateYield(this._iteratePropertyReferences(s3, r3, i), "t2", 29);
          case 29:
            return c3.abrupt("return");
          case 30:
            if (s3.type !== "AssignmentPattern") {
              c3.next = 34;
              break;
            }
            if (s3.right !== a3) {
              c3.next = 33;
              break;
            }
            return c3.delegateYield(this._iterateLhsReferences(s3.left, r3, i), "t3", 33);
          case 33:
            return c3.abrupt("return");
          case 34:
            if (s3.type !== "VariableDeclarator") {
              c3.next = 37;
              break;
            }
            if (s3.init !== a3) {
              c3.next = 37;
              break;
            }
            return c3.delegateYield(this._iterateLhsReferences(s3.id, r3, i), "t4", 37);
          case 37:
          case "end":
            return c3.stop();
        }
    }, t3, this);
  }) }, { key: "_iterateLhsReferences", value: regeneratorRuntime.mark(function t3(n3, r3, i) {
    var a3, s3, o3, u3, c3, f3, p3, d3, m3, y3;
    return regeneratorRuntime.wrap(function(v3) {
      for (; ; )
        switch (v3.prev = v3.next) {
          case 0:
            if (n3.type !== "Identifier") {
              v3.next = 5;
              break;
            }
            if ((a3 = Ps$1(this.globalScope, n3)) == null) {
              v3.next = 4;
              break;
            }
            return v3.delegateYield(this._iterateVariableReferences(a3, r3, i, false), "t0", 4);
          case 4:
            return v3.abrupt("return");
          case 5:
            if (n3.type !== "ObjectPattern") {
              v3.next = 40;
              break;
            }
            s3 = true, o3 = false, u3 = void 0, v3.prev = 9, c3 = n3.properties[Symbol.iterator]();
          case 11:
            if (s3 = (f3 = c3.next()).done) {
              v3.next = 25;
              break;
            }
            if (p3 = f3.value, (d3 = dc$2(p3)) != null && Co$1(i, d3)) {
              v3.next = 16;
              break;
            }
            return v3.abrupt("continue", 22);
          case 16:
            if (m3 = r3.concat(d3), !(y3 = i[d3])[Wt$2]) {
              v3.next = 21;
              break;
            }
            return v3.next = 21, { node: p3, path: m3, type: Wt$2, info: y3[Wt$2] };
          case 21:
            return v3.delegateYield(this._iterateLhsReferences(p3.value, m3, y3), "t1", 22);
          case 22:
            s3 = true, v3.next = 11;
            break;
          case 25:
            v3.next = 31;
            break;
          case 27:
            v3.prev = 27, v3.t2 = v3.catch(9), o3 = true, u3 = v3.t2;
          case 31:
            v3.prev = 31, v3.prev = 32, s3 || c3.return == null || c3.return();
          case 34:
            if (v3.prev = 34, !o3) {
              v3.next = 37;
              break;
            }
            throw u3;
          case 37:
            return v3.finish(34);
          case 38:
            return v3.finish(31);
          case 39:
            return v3.abrupt("return");
          case 40:
            if (n3.type !== "AssignmentPattern") {
              v3.next = 42;
              break;
            }
            return v3.delegateYield(this._iterateLhsReferences(n3.left, r3, i), "t3", 42);
          case 42:
          case "end":
            return v3.stop();
        }
    }, t3, this, [[9, 27, 31, 39], [32, , 34, 38]]);
  }) }, { key: "_iterateImportReferences", value: regeneratorRuntime.mark(function t3(n3, r3, i) {
    var a3, s3, o3, u3, c3;
    return regeneratorRuntime.wrap(function(f3) {
      for (; ; )
        switch (f3.prev = f3.next) {
          case 0:
            if ((a3 = n3.type) !== "ImportSpecifier" && a3 !== "ImportDefaultSpecifier") {
              f3.next = 12;
              break;
            }
            if (s3 = a3 === "ImportDefaultSpecifier" ? "default" : n3.imported.name, Co$1(i, s3)) {
              f3.next = 5;
              break;
            }
            return f3.abrupt("return");
          case 5:
            if (r3 = r3.concat(s3), !(o3 = i[s3])[Wt$2]) {
              f3.next = 10;
              break;
            }
            return f3.next = 10, { node: n3, path: r3, type: Wt$2, info: o3[Wt$2] };
          case 10:
            return f3.delegateYield(this._iterateVariableReferences(Ps$1(this.globalScope, n3.local), r3, o3, false), "t0", 11);
          case 11:
            return f3.abrupt("return");
          case 12:
            if (a3 !== "ImportNamespaceSpecifier") {
              f3.next = 15;
              break;
            }
            return f3.delegateYield(this._iterateVariableReferences(Ps$1(this.globalScope, n3.local), r3, i, false), "t1", 14);
          case 14:
            return f3.abrupt("return");
          case 15:
            if (a3 !== "ExportSpecifier") {
              f3.next = 24;
              break;
            }
            if (u3 = n3.local.name, Co$1(i, u3)) {
              f3.next = 19;
              break;
            }
            return f3.abrupt("return");
          case 19:
            if (r3 = r3.concat(u3), !(c3 = i[u3])[Wt$2]) {
              f3.next = 24;
              break;
            }
            return f3.next = 24, { node: n3, path: r3, type: Wt$2, info: c3[Wt$2] };
          case 24:
          case "end":
            return f3.stop();
        }
    }, t3, this);
  }) }]), e28;
}();
function C8(e28, t3) {
  return !(t3 === 1 && e28 === "default");
}
Fs$1.READ = Wt$2, Fs$1.CALL = Lo$1, Fs$1.CONSTRUCT = Is$1, Fs$1.ESM = vf;
var S8 = { CALL: Lo$1, CONSTRUCT: Is$1, ESM: vf, findVariable: Ps$1, getFunctionHeadLocation: mD, getFunctionNameWithKind: gD, getInnermostScope: H0, getPropertyName: dc$2, getStaticValue: ng, getStringIfConstant: hc$2, hasSideEffect: yD, isArrowToken: gf, isClosingBraceToken: eg, isClosingBracketToken: Y0, isClosingParenToken: yf, isColonToken: Q0, isCommaToken: K0, isCommentToken: tg, isNotArrowToken: iD, isNotClosingBraceToken: hD, isNotClosingBracketToken: pD, isNotClosingParenToken: cD, isNotColonToken: sD, isNotCommaToken: aD, isNotCommentToken: dD, isNotOpeningBraceToken: fD, isNotOpeningBracketToken: lD, isNotOpeningParenToken: uD, isNotSemicolonToken: oD, isOpeningBraceToken: Z0, isOpeningBracketToken: X0, isOpeningParenToken: ro$1, isParenthesized: vD, isSemicolonToken: J0, PatternMatcher: xD, READ: Wt$2, ReferenceTracker: Fs$1 }, k8 = Cr$1(Object.freeze({ __proto__: null, default: S8, CALL: Lo$1, CONSTRUCT: Is$1, ESM: vf, PatternMatcher: xD, READ: Wt$2, ReferenceTracker: Fs$1, findVariable: Ps$1, getFunctionHeadLocation: mD, getFunctionNameWithKind: gD, getInnermostScope: H0, getPropertyName: dc$2, getStaticValue: ng, getStringIfConstant: hc$2, hasSideEffect: yD, isArrowToken: gf, isClosingBraceToken: eg, isClosingBracketToken: Y0, isClosingParenToken: yf, isColonToken: Q0, isCommaToken: K0, isCommentToken: tg, isNotArrowToken: iD, isNotClosingBraceToken: hD, isNotClosingBracketToken: pD, isNotClosingParenToken: cD, isNotColonToken: sD, isNotCommaToken: aD, isNotCommentToken: dD, isNotOpeningBraceToken: fD, isNotOpeningBracketToken: lD, isNotOpeningParenToken: uD, isNotSemicolonToken: oD, isOpeningBraceToken: Z0, isOpeningBracketToken: X0, isOpeningParenToken: ro$1, isParenthesized: vD, isSemicolonToken: J0 })), ye$4 = gt$3(function(e28, t3) {
  function n3(y3) {
    return y3 && xe$3(y3) == "object" && "default" in y3 ? y3.default : y3;
  }
  var r3 = n3(pf), i = n3(n8), a3 = n3(r8), s3 = n3(a8), o3 = n3(Ka$3), u3 = n3(k8), c3 = /\r\n|[\n\r\u2028\u2029]/, f3 = { breakableTypePattern: /^(?:(?:Do)?While|For(?:In|Of)?|Switch)Statement$/, lineBreakPattern: c3, createGlobalLinebreakMatcher: function() {
    return new RegExp(c3.source, "gu");
  }, shebangPattern: /^#!((?:[\0-\t\x0B\f\x0E-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)/ }, p3 = o3("eslint:traverser");
  function d3() {
  }
  var m3 = function() {
    function y3() {
      We$1(this, y3), this._current = null, this._parents = [], this._skipped = false, this._broken = false, this._visitorKeys = null, this._enter = null, this._leave = null;
    }
    return Xe$1(y3, [{ key: "current", value: function() {
      return this._current;
    } }, { key: "parents", value: function() {
      return this._parents.slice(0);
    } }, { key: "break", value: function() {
      this._broken = true;
    } }, { key: "skip", value: function() {
      this._skipped = true;
    } }, { key: "traverse", value: function(v3, b3) {
      this._current = null, this._parents = [], this._skipped = false, this._broken = false, this._visitorKeys = b3.visitorKeys || r3.KEYS, this._enter = b3.enter || d3, this._leave = b3.leave || d3, this._traverse(v3, null);
    } }, { key: "_traverse", value: function(v3, b3) {
      if (function(B3) {
        return B3 !== null && xe$3(B3) == "object" && typeof B3.type == "string";
      }(v3)) {
        if (this._current = v3, this._skipped = false, this._enter(v3, b3), !this._skipped && !this._broken) {
          var x3 = function(B3, O3) {
            var S3 = B3[O3.type];
            return S3 || (S3 = r3.getKeys(O3), p3('Unknown node type "%s": Estimated visitor keys %j', O3.type, S3)), S3;
          }(this._visitorKeys, v3);
          if (1 <= x3.length) {
            this._parents.push(v3);
            for (var C3 = 0; C3 < x3.length && !this._broken; ++C3) {
              var k3 = v3[x3[C3]];
              if (Array.isArray(k3))
                for (var F3 = 0; F3 < k3.length && !this._broken; ++F3)
                  this._traverse(k3[F3], v3);
              else
                this._traverse(k3, v3);
            }
            this._parents.pop();
          }
        }
        this._broken || this._leave(v3, b3), this._current = b3;
      }
    } }], [{ key: "getKeys", value: function(v3) {
      return r3.getKeys(v3);
    } }, { key: "traverse", value: function(v3, b3) {
      new y3().traverse(v3, b3);
    } }, { key: "DEFAULT_VISITOR_KEYS", get: function() {
      return r3.KEYS;
    } }]), y3;
  }();
  t3.Traverser = m3, t3.createCommonjsModule = function(y3, v3) {
    return y3(v3 = { exports: {} }, v3.exports), v3.exports;
  }, t3.espree = i, t3.evk = r3, t3.getCjsExportFromNamespace = function(y3) {
    return y3 && y3.default || y3;
  }, t3.globals = s3, t3.lodash = a3, t3.require$$0 = u3, t3.require$$0$1 = f3, t3.require$$1 = o3;
}), Zs$1 = (ye$4.Traverser, ye$4.createCommonjsModule, ye$4.espree, ye$4.evk, ye$4.getCjsExportFromNamespace, ye$4.globals, ye$4.lodash, ye$4.require$$0, ye$4.require$$0$1, ye$4.require$$1, gt$3(function(e28, t3) {
  /** @license URI.js v4.2.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */
  (function(n3) {
    function r3() {
      for (var Z3 = arguments.length, ee2 = Array(Z3), oe2 = 0; oe2 < Z3; oe2++)
        ee2[oe2] = arguments[oe2];
      if (ee2.length > 1) {
        ee2[0] = ee2[0].slice(0, -1);
        for (var le2 = ee2.length - 1, we2 = 1; we2 < le2; ++we2)
          ee2[we2] = ee2[we2].slice(1, -1);
        return ee2[le2] = ee2[le2].slice(1), ee2.join("");
      }
      return ee2[0];
    }
    function i(Z3) {
      return "(?:" + Z3 + ")";
    }
    function a3(Z3) {
      return Z3 === void 0 ? "undefined" : Z3 === null ? "null" : Object.prototype.toString.call(Z3).split(" ").pop().split("]").shift().toLowerCase();
    }
    function s3(Z3) {
      return Z3.toUpperCase();
    }
    function o3(Z3) {
      var ee2 = r3("[0-9]", "[A-Fa-f]"), oe2 = i(i("%[EFef]" + ee2 + "%" + ee2 + ee2 + "%" + ee2 + ee2) + "|" + i("%[89A-Fa-f]" + ee2 + "%" + ee2 + ee2) + "|" + i("%" + ee2 + ee2)), le2 = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", we2 = r3("[\\:\\/\\?\\#\\[\\]\\@]", le2), Me2 = Z3 ? "[\\uE000-\\uF8FF]" : "[]", Ve2 = r3("[A-Za-z]", "[0-9]", "[\\-\\.\\_\\~]", Z3 ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]"), $e2 = (i("[A-Za-z]" + r3("[A-Za-z]", "[0-9]", "[\\+\\-\\.]") + "*"), i(i(oe2 + "|" + r3(Ve2, le2, "[\\:]")) + "*"), i(i("25[0-5]") + "|" + i("2[0-4][0-9]") + "|" + i("1[0-9][0-9]") + "|" + i("0?[1-9][0-9]") + "|0?0?[0-9]")), yt2 = i($e2 + "\\." + $e2 + "\\." + $e2 + "\\." + $e2), ze2 = i(ee2 + "{1,4}"), vt2 = i(i(ze2 + "\\:" + ze2) + "|" + yt2), Nt2 = i(i(ze2 + "\\:") + "{6}" + vt2), Qt2 = i("\\:\\:" + i(ze2 + "\\:") + "{5}" + vt2), bt2 = i(i(ze2) + "?\\:\\:" + i(ze2 + "\\:") + "{4}" + vt2), at2 = i(i(i(ze2 + "\\:") + "{0,1}" + ze2) + "?\\:\\:" + i(ze2 + "\\:") + "{3}" + vt2), jt2 = i(i(i(ze2 + "\\:") + "{0,2}" + ze2) + "?\\:\\:" + i(ze2 + "\\:") + "{2}" + vt2), dn2 = i(i(i(ze2 + "\\:") + "{0,3}" + ze2) + "?\\:\\:" + ze2 + "\\:" + vt2), Rn2 = i(i(i(ze2 + "\\:") + "{0,4}" + ze2) + "?\\:\\:" + vt2), qn2 = i(i(i(ze2 + "\\:") + "{0,5}" + ze2) + "?\\:\\:" + ze2), Sr2 = i(i(i(ze2 + "\\:") + "{0,6}" + ze2) + "?\\:\\:"), pi2 = i([Nt2, Qt2, bt2, at2, jt2, dn2, Rn2, qn2, Sr2].join("|")), Bn2 = i(i(Ve2 + "|" + oe2) + "+"), er2 = (i("[vV]" + ee2 + "+\\." + r3(Ve2, le2, "[\\:]") + "+"), i(i(oe2 + "|" + r3(Ve2, le2)) + "*"), i(oe2 + "|" + r3(Ve2, le2, "[\\:\\@]")));
      return i(i(oe2 + "|" + r3(Ve2, le2, "[\\@]")) + "+"), i(i(er2 + "|" + r3("[\\/\\?]", Me2)) + "*"), { NOT_SCHEME: new RegExp(r3("[^]", "[A-Za-z]", "[0-9]", "[\\+\\-\\.]"), "g"), NOT_USERINFO: new RegExp(r3("[^\\%\\:]", Ve2, le2), "g"), NOT_HOST: new RegExp(r3("[^\\%\\[\\]\\:]", Ve2, le2), "g"), NOT_PATH: new RegExp(r3("[^\\%\\/\\:\\@]", Ve2, le2), "g"), NOT_PATH_NOSCHEME: new RegExp(r3("[^\\%\\/\\@]", Ve2, le2), "g"), NOT_QUERY: new RegExp(r3("[^\\%]", Ve2, le2, "[\\:\\@\\/\\?]", Me2), "g"), NOT_FRAGMENT: new RegExp(r3("[^\\%]", Ve2, le2, "[\\:\\@\\/\\?]"), "g"), ESCAPE: new RegExp(r3("[^]", Ve2, le2), "g"), UNRESERVED: new RegExp(Ve2, "g"), OTHER_CHARS: new RegExp(r3("[^\\%]", Ve2, we2), "g"), PCT_ENCODED: new RegExp(oe2, "g"), IPV4ADDRESS: new RegExp("^(" + yt2 + ")$"), IPV6ADDRESS: new RegExp("^\\[?(" + pi2 + ")" + i(i("\\%25|\\%(?!" + ee2 + "{2})") + "(" + Bn2 + ")") + "?\\]?$") };
    }
    var u3 = o3(false), c3 = o3(true), f3 = function(Z3, ee2) {
      if (Array.isArray(Z3))
        return Z3;
      if (Symbol.iterator in Object(Z3))
        return function(oe2, le2) {
          var we2 = [], Me2 = true, Ve2 = false, $e2 = void 0;
          try {
            for (var yt2, ze2 = oe2[Symbol.iterator](); !(Me2 = (yt2 = ze2.next()).done) && (we2.push(yt2.value), !le2 || we2.length !== le2); Me2 = true)
              ;
          } catch (vt2) {
            Ve2 = true, $e2 = vt2;
          } finally {
            try {
              !Me2 && ze2.return && ze2.return();
            } finally {
              if (Ve2)
                throw $e2;
            }
          }
          return we2;
        }(Z3, ee2);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }, p3 = 2147483647, d3 = /^xn--/, m3 = /[^\0-\x7E]/, y3 = /[\x2E\u3002\uFF0E\uFF61]/g, v3 = { overflow: "Overflow: input needs wider integers to process", "not-basic": "Illegal input >= 0x80 (not a basic code point)", "invalid-input": "Invalid input" }, b3 = Math.floor, x3 = String.fromCharCode;
    function C3(Z3) {
      throw new RangeError(v3[Z3]);
    }
    function k3(Z3, ee2) {
      var oe2 = Z3.split("@"), le2 = "";
      oe2.length > 1 && (le2 = oe2[0] + "@", Z3 = oe2[1]);
      var we2 = function(Me2, Ve2) {
        for (var $e2 = [], yt2 = Me2.length; yt2--; )
          $e2[yt2] = Ve2(Me2[yt2]);
        return $e2;
      }((Z3 = Z3.replace(y3, ".")).split("."), ee2).join(".");
      return le2 + we2;
    }
    function F3(Z3) {
      for (var ee2 = [], oe2 = 0, le2 = Z3.length; oe2 < le2; ) {
        var we2 = Z3.charCodeAt(oe2++);
        if (we2 >= 55296 && we2 <= 56319 && oe2 < le2) {
          var Me2 = Z3.charCodeAt(oe2++);
          (64512 & Me2) == 56320 ? ee2.push(((1023 & we2) << 10) + (1023 & Me2) + 65536) : (ee2.push(we2), oe2--);
        } else
          ee2.push(we2);
      }
      return ee2;
    }
    var B3 = function(Z3, ee2) {
      return Z3 + 22 + 75 * (Z3 < 26) - ((ee2 != 0) << 5);
    }, O3 = function(Z3, ee2, oe2) {
      var le2 = 0;
      for (Z3 = oe2 ? b3(Z3 / 700) : Z3 >> 1, Z3 += b3(Z3 / ee2); Z3 > 455; le2 += 36)
        Z3 = b3(Z3 / 35);
      return b3(le2 + 36 * Z3 / (Z3 + 38));
    }, S3 = function(Z3) {
      var ee2, oe2 = [], le2 = Z3.length, we2 = 0, Me2 = 128, Ve2 = 72, $e2 = Z3.lastIndexOf("-");
      $e2 < 0 && ($e2 = 0);
      for (var yt2 = 0; yt2 < $e2; ++yt2)
        Z3.charCodeAt(yt2) >= 128 && C3("not-basic"), oe2.push(Z3.charCodeAt(yt2));
      for (var ze2 = $e2 > 0 ? $e2 + 1 : 0; ze2 < le2; ) {
        for (var vt2 = we2, Nt2 = 1, Qt2 = 36; ; Qt2 += 36) {
          ze2 >= le2 && C3("invalid-input");
          var bt2 = (ee2 = Z3.charCodeAt(ze2++)) - 48 < 10 ? ee2 - 22 : ee2 - 65 < 26 ? ee2 - 65 : ee2 - 97 < 26 ? ee2 - 97 : 36;
          (bt2 >= 36 || bt2 > b3((p3 - we2) / Nt2)) && C3("overflow"), we2 += bt2 * Nt2;
          var at2 = Qt2 <= Ve2 ? 1 : Qt2 >= Ve2 + 26 ? 26 : Qt2 - Ve2;
          if (bt2 < at2)
            break;
          var jt2 = 36 - at2;
          Nt2 > b3(p3 / jt2) && C3("overflow"), Nt2 *= jt2;
        }
        var dn2 = oe2.length + 1;
        Ve2 = O3(we2 - vt2, dn2, vt2 == 0), b3(we2 / dn2) > p3 - Me2 && C3("overflow"), Me2 += b3(we2 / dn2), we2 %= dn2, oe2.splice(we2++, 0, Me2);
      }
      return String.fromCodePoint.apply(String, oe2);
    }, w3 = function(Z3) {
      var ee2 = [], oe2 = (Z3 = F3(Z3)).length, le2 = 128, we2 = 0, Me2 = 72, Ve2 = true, $e2 = false, yt2 = void 0;
      try {
        for (var ze2, vt2 = Z3[Symbol.iterator](); !(Ve2 = (ze2 = vt2.next()).done); Ve2 = true) {
          var Nt2 = ze2.value;
          Nt2 < 128 && ee2.push(x3(Nt2));
        }
      } catch (Ze2) {
        $e2 = true, yt2 = Ze2;
      } finally {
        try {
          !Ve2 && vt2.return && vt2.return();
        } finally {
          if ($e2)
            throw yt2;
        }
      }
      var Qt2 = ee2.length, bt2 = Qt2;
      for (Qt2 && ee2.push("-"); bt2 < oe2; ) {
        var at2 = p3, jt2 = true, dn2 = false, Rn2 = void 0;
        try {
          for (var qn2, Sr2 = Z3[Symbol.iterator](); !(jt2 = (qn2 = Sr2.next()).done); jt2 = true) {
            var pi2 = qn2.value;
            pi2 >= le2 && pi2 < at2 && (at2 = pi2);
          }
        } catch (Ze2) {
          dn2 = true, Rn2 = Ze2;
        } finally {
          try {
            !jt2 && Sr2.return && Sr2.return();
          } finally {
            if (dn2)
              throw Rn2;
          }
        }
        var Bn2 = bt2 + 1;
        at2 - le2 > b3((p3 - we2) / Bn2) && C3("overflow"), we2 += (at2 - le2) * Bn2, le2 = at2;
        var er2 = true, fi2 = false, kr2 = void 0;
        try {
          for (var oo2, Fi2 = Z3[Symbol.iterator](); !(er2 = (oo2 = Fi2.next()).done); er2 = true) {
            var so2 = oo2.value;
            if (so2 < le2 && ++we2 > p3 && C3("overflow"), so2 == le2) {
              for (var Hi2 = we2, Ki2 = 36; ; Ki2 += 36) {
                var Wn2 = Ki2 <= Me2 ? 1 : Ki2 >= Me2 + 26 ? 26 : Ki2 - Me2;
                if (Hi2 < Wn2)
                  break;
                var Ie2 = Hi2 - Wn2, je2 = 36 - Wn2;
                ee2.push(x3(B3(Wn2 + Ie2 % je2, 0))), Hi2 = b3(Ie2 / je2);
              }
              ee2.push(x3(B3(Hi2, 0))), Me2 = O3(we2, Bn2, bt2 == Qt2), we2 = 0, ++bt2;
            }
          }
        } catch (Ze2) {
          fi2 = true, kr2 = Ze2;
        } finally {
          try {
            !er2 && Fi2.return && Fi2.return();
          } finally {
            if (fi2)
              throw kr2;
          }
        }
        ++we2, ++le2;
      }
      return ee2.join("");
    }, D3 = { version: "2.1.0", ucs2: { decode: F3, encode: function(Z3) {
      return String.fromCodePoint.apply(String, function(ee2) {
        if (Array.isArray(ee2)) {
          for (var oe2 = 0, le2 = Array(ee2.length); oe2 < ee2.length; oe2++)
            le2[oe2] = ee2[oe2];
          return le2;
        }
        return Array.from(ee2);
      }(Z3));
    } }, decode: S3, encode: w3, toASCII: function(Z3) {
      return k3(Z3, function(ee2) {
        return m3.test(ee2) ? "xn--" + w3(ee2) : ee2;
      });
    }, toUnicode: function(Z3) {
      return k3(Z3, function(ee2) {
        return d3.test(ee2) ? S3(ee2.slice(4).toLowerCase()) : ee2;
      });
    } }, I3 = {};
    function L3(Z3) {
      var ee2 = Z3.charCodeAt(0);
      return ee2 < 16 ? "%0" + ee2.toString(16).toUpperCase() : ee2 < 128 ? "%" + ee2.toString(16).toUpperCase() : ee2 < 2048 ? "%" + (ee2 >> 6 | 192).toString(16).toUpperCase() + "%" + (63 & ee2 | 128).toString(16).toUpperCase() : "%" + (ee2 >> 12 | 224).toString(16).toUpperCase() + "%" + (ee2 >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (63 & ee2 | 128).toString(16).toUpperCase();
    }
    function V10(Z3) {
      for (var ee2 = "", oe2 = 0, le2 = Z3.length; oe2 < le2; ) {
        var we2 = parseInt(Z3.substr(oe2 + 1, 2), 16);
        if (we2 < 128)
          ee2 += String.fromCharCode(we2), oe2 += 3;
        else if (we2 >= 194 && we2 < 224) {
          if (le2 - oe2 >= 6) {
            var Me2 = parseInt(Z3.substr(oe2 + 4, 2), 16);
            ee2 += String.fromCharCode((31 & we2) << 6 | 63 & Me2);
          } else
            ee2 += Z3.substr(oe2, 6);
          oe2 += 6;
        } else if (we2 >= 224) {
          if (le2 - oe2 >= 9) {
            var Ve2 = parseInt(Z3.substr(oe2 + 4, 2), 16), $e2 = parseInt(Z3.substr(oe2 + 7, 2), 16);
            ee2 += String.fromCharCode((15 & we2) << 12 | (63 & Ve2) << 6 | 63 & $e2);
          } else
            ee2 += Z3.substr(oe2, 9);
          oe2 += 9;
        } else
          ee2 += Z3.substr(oe2, 3), oe2 += 3;
      }
      return ee2;
    }
    function K3(Z3, ee2) {
      function oe2(le2) {
        var we2 = V10(le2);
        return we2.match(ee2.UNRESERVED) ? we2 : le2;
      }
      return Z3.scheme && (Z3.scheme = String(Z3.scheme).replace(ee2.PCT_ENCODED, oe2).toLowerCase().replace(ee2.NOT_SCHEME, "")), Z3.userinfo !== void 0 && (Z3.userinfo = String(Z3.userinfo).replace(ee2.PCT_ENCODED, oe2).replace(ee2.NOT_USERINFO, L3).replace(ee2.PCT_ENCODED, s3)), Z3.host !== void 0 && (Z3.host = String(Z3.host).replace(ee2.PCT_ENCODED, oe2).toLowerCase().replace(ee2.NOT_HOST, L3).replace(ee2.PCT_ENCODED, s3)), Z3.path !== void 0 && (Z3.path = String(Z3.path).replace(ee2.PCT_ENCODED, oe2).replace(Z3.scheme ? ee2.NOT_PATH : ee2.NOT_PATH_NOSCHEME, L3).replace(ee2.PCT_ENCODED, s3)), Z3.query !== void 0 && (Z3.query = String(Z3.query).replace(ee2.PCT_ENCODED, oe2).replace(ee2.NOT_QUERY, L3).replace(ee2.PCT_ENCODED, s3)), Z3.fragment !== void 0 && (Z3.fragment = String(Z3.fragment).replace(ee2.PCT_ENCODED, oe2).replace(ee2.NOT_FRAGMENT, L3).replace(ee2.PCT_ENCODED, s3)), Z3;
    }
    function W3(Z3) {
      return Z3.replace(/^0*(.*)/, "$1") || "0";
    }
    function R3(Z3, ee2) {
      var oe2 = Z3.match(ee2.IPV4ADDRESS) || [], le2 = f3(oe2, 2)[1];
      return le2 ? le2.split(".").map(W3).join(".") : Z3;
    }
    function q3(Z3, ee2) {
      var oe2 = Z3.match(ee2.IPV6ADDRESS) || [], le2 = f3(oe2, 3), we2 = le2[1], Me2 = le2[2];
      if (we2) {
        for (var Ve2 = we2.toLowerCase().split("::").reverse(), $e2 = f3(Ve2, 2), yt2 = $e2[0], ze2 = $e2[1], vt2 = ze2 ? ze2.split(":").map(W3) : [], Nt2 = yt2.split(":").map(W3), Qt2 = ee2.IPV4ADDRESS.test(Nt2[Nt2.length - 1]), bt2 = Qt2 ? 7 : 8, at2 = Nt2.length - bt2, jt2 = Array(bt2), dn2 = 0; dn2 < bt2; ++dn2)
          jt2[dn2] = vt2[dn2] || Nt2[at2 + dn2] || "";
        Qt2 && (jt2[bt2 - 1] = R3(jt2[bt2 - 1], ee2));
        var Rn2 = jt2.reduce(function(Bn2, er2, fi2) {
          if (!er2 || er2 === "0") {
            var kr2 = Bn2[Bn2.length - 1];
            kr2 && kr2.index + kr2.length === fi2 ? kr2.length++ : Bn2.push({ index: fi2, length: 1 });
          }
          return Bn2;
        }, []).sort(function(Bn2, er2) {
          return er2.length - Bn2.length;
        })[0], qn2 = void 0;
        if (Rn2 && Rn2.length > 1) {
          var Sr2 = jt2.slice(0, Rn2.index), pi2 = jt2.slice(Rn2.index + Rn2.length);
          qn2 = Sr2.join(":") + "::" + pi2.join(":");
        } else
          qn2 = jt2.join(":");
        return Me2 && (qn2 += "%" + Me2), qn2;
      }
      return Z3;
    }
    var J3 = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i, X3 = "".match(/(){0}/)[1] === void 0;
    function ce2(Z3) {
      var ee2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, oe2 = {}, le2 = ee2.iri !== false ? c3 : u3;
      ee2.reference === "suffix" && (Z3 = (ee2.scheme ? ee2.scheme + ":" : "") + "//" + Z3);
      var we2 = Z3.match(J3);
      if (we2) {
        X3 ? (oe2.scheme = we2[1], oe2.userinfo = we2[3], oe2.host = we2[4], oe2.port = parseInt(we2[5], 10), oe2.path = we2[6] || "", oe2.query = we2[7], oe2.fragment = we2[8], isNaN(oe2.port) && (oe2.port = we2[5])) : (oe2.scheme = we2[1] || void 0, oe2.userinfo = Z3.indexOf("@") !== -1 ? we2[3] : void 0, oe2.host = Z3.indexOf("//") !== -1 ? we2[4] : void 0, oe2.port = parseInt(we2[5], 10), oe2.path = we2[6] || "", oe2.query = Z3.indexOf("?") !== -1 ? we2[7] : void 0, oe2.fragment = Z3.indexOf("#") !== -1 ? we2[8] : void 0, isNaN(oe2.port) && (oe2.port = Z3.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? we2[4] : void 0)), oe2.host && (oe2.host = q3(R3(oe2.host, le2), le2)), oe2.scheme !== void 0 || oe2.userinfo !== void 0 || oe2.host !== void 0 || oe2.port !== void 0 || oe2.path || oe2.query !== void 0 ? oe2.scheme === void 0 ? oe2.reference = "relative" : oe2.fragment === void 0 ? oe2.reference = "absolute" : oe2.reference = "uri" : oe2.reference = "same-document", ee2.reference && ee2.reference !== "suffix" && ee2.reference !== oe2.reference && (oe2.error = oe2.error || "URI is not a " + ee2.reference + " reference.");
        var Me2 = I3[(ee2.scheme || oe2.scheme || "").toLowerCase()];
        if (ee2.unicodeSupport || Me2 && Me2.unicodeSupport)
          K3(oe2, le2);
        else {
          if (oe2.host && (ee2.domainHost || Me2 && Me2.domainHost))
            try {
              oe2.host = D3.toASCII(oe2.host.replace(le2.PCT_ENCODED, V10).toLowerCase());
            } catch (Ve2) {
              oe2.error = oe2.error || "Host's domain name can not be converted to ASCII via punycode: " + Ve2;
            }
          K3(oe2, u3);
        }
        Me2 && Me2.parse && Me2.parse(oe2, ee2);
      } else
        oe2.error = oe2.error || "URI can not be parsed.";
      return oe2;
    }
    var A3 = /^\.\.?\//, M3 = /^\/\.(\/|$)/, ne2 = /^\/\.\.(\/|$)/, de2 = /^\/?(?:.|\n)*?(?=\/|$)/;
    function he2(Z3) {
      for (var ee2 = []; Z3.length; )
        if (Z3.match(A3))
          Z3 = Z3.replace(A3, "");
        else if (Z3.match(M3))
          Z3 = Z3.replace(M3, "/");
        else if (Z3.match(ne2))
          Z3 = Z3.replace(ne2, "/"), ee2.pop();
        else if (Z3 === "." || Z3 === "..")
          Z3 = "";
        else {
          var oe2 = Z3.match(de2);
          if (!oe2)
            throw new Error("Unexpected dot segment condition");
          var le2 = oe2[0];
          Z3 = Z3.slice(le2.length), ee2.push(le2);
        }
      return ee2.join("");
    }
    function j3(Z3) {
      var ee2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, oe2 = ee2.iri ? c3 : u3, le2 = [], we2 = I3[(ee2.scheme || Z3.scheme || "").toLowerCase()];
      if (we2 && we2.serialize && we2.serialize(Z3, ee2), Z3.host && !oe2.IPV6ADDRESS.test(Z3.host)) {
        if (ee2.domainHost || we2 && we2.domainHost)
          try {
            Z3.host = ee2.iri ? D3.toUnicode(Z3.host) : D3.toASCII(Z3.host.replace(oe2.PCT_ENCODED, V10).toLowerCase());
          } catch ($e2) {
            Z3.error = Z3.error || "Host's domain name can not be converted to " + (ee2.iri ? "Unicode" : "ASCII") + " via punycode: " + $e2;
          }
      }
      K3(Z3, oe2), ee2.reference !== "suffix" && Z3.scheme && (le2.push(Z3.scheme), le2.push(":"));
      var Me2 = function($e2, yt2) {
        var ze2 = yt2.iri !== false ? c3 : u3, vt2 = [];
        return $e2.userinfo !== void 0 && (vt2.push($e2.userinfo), vt2.push("@")), $e2.host !== void 0 && vt2.push(q3(R3(String($e2.host), ze2), ze2).replace(ze2.IPV6ADDRESS, function(Nt2, Qt2, bt2) {
          return "[" + Qt2 + (bt2 ? "%25" + bt2 : "") + "]";
        })), typeof $e2.port == "number" && (vt2.push(":"), vt2.push($e2.port.toString(10))), vt2.length ? vt2.join("") : void 0;
      }(Z3, ee2);
      if (Me2 !== void 0 && (ee2.reference !== "suffix" && le2.push("//"), le2.push(Me2), Z3.path && Z3.path.charAt(0) !== "/" && le2.push("/")), Z3.path !== void 0) {
        var Ve2 = Z3.path;
        ee2.absolutePath || we2 && we2.absolutePath || (Ve2 = he2(Ve2)), Me2 === void 0 && (Ve2 = Ve2.replace(/^\/\//, "/%2F")), le2.push(Ve2);
      }
      return Z3.query !== void 0 && (le2.push("?"), le2.push(Z3.query)), Z3.fragment !== void 0 && (le2.push("#"), le2.push(Z3.fragment)), le2.join("");
    }
    function ie2(Z3, ee2) {
      var oe2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, le2 = {};
      return arguments[3] || (Z3 = ce2(j3(Z3, oe2), oe2), ee2 = ce2(j3(ee2, oe2), oe2)), !(oe2 = oe2 || {}).tolerant && ee2.scheme ? (le2.scheme = ee2.scheme, le2.userinfo = ee2.userinfo, le2.host = ee2.host, le2.port = ee2.port, le2.path = he2(ee2.path || ""), le2.query = ee2.query) : (ee2.userinfo !== void 0 || ee2.host !== void 0 || ee2.port !== void 0 ? (le2.userinfo = ee2.userinfo, le2.host = ee2.host, le2.port = ee2.port, le2.path = he2(ee2.path || ""), le2.query = ee2.query) : (ee2.path ? (ee2.path.charAt(0) === "/" ? le2.path = he2(ee2.path) : (Z3.userinfo === void 0 && Z3.host === void 0 && Z3.port === void 0 || Z3.path ? Z3.path ? le2.path = Z3.path.slice(0, Z3.path.lastIndexOf("/") + 1) + ee2.path : le2.path = ee2.path : le2.path = "/" + ee2.path, le2.path = he2(le2.path)), le2.query = ee2.query) : (le2.path = Z3.path, ee2.query !== void 0 ? le2.query = ee2.query : le2.query = Z3.query), le2.userinfo = Z3.userinfo, le2.host = Z3.host, le2.port = Z3.port), le2.scheme = Z3.scheme), le2.fragment = ee2.fragment, le2;
    }
    function fe2(Z3, ee2) {
      return Z3 && Z3.toString().replace(ee2 && ee2.iri ? c3.PCT_ENCODED : u3.PCT_ENCODED, V10);
    }
    var ge2 = { scheme: "http", domainHost: true, parse: function(Z3, ee2) {
      return Z3.host || (Z3.error = Z3.error || "HTTP URIs must have a host."), Z3;
    }, serialize: function(Z3, ee2) {
      return Z3.port !== (String(Z3.scheme).toLowerCase() !== "https" ? 80 : 443) && Z3.port !== "" || (Z3.port = void 0), Z3.path || (Z3.path = "/"), Z3;
    } }, Fe2 = { scheme: "https", domainHost: ge2.domainHost, parse: ge2.parse, serialize: ge2.serialize }, Pe2 = {}, _3 = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]", Q3 = "[0-9A-Fa-f]", Y3 = i(i("%[EFef][0-9A-Fa-f]%" + Q3 + Q3 + "%" + Q3 + Q3) + "|" + i("%[89A-Fa-f][0-9A-Fa-f]%" + Q3 + Q3) + "|" + i("%" + Q3 + Q3)), ae2 = r3("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", '[\\"\\\\]'), ue2 = new RegExp(_3, "g"), De2 = new RegExp(Y3, "g"), Ee2 = new RegExp(r3("[^]", "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]", "[\\.]", '[\\"]', ae2), "g"), _e2 = new RegExp(r3("[^]", _3, "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]"), "g"), Oe2 = _e2;
    function Ye2(Z3) {
      var ee2 = V10(Z3);
      return ee2.match(ue2) ? ee2 : Z3;
    }
    var _t2 = { scheme: "mailto", parse: function(Z3, ee2) {
      var oe2 = Z3, le2 = oe2.to = oe2.path ? oe2.path.split(",") : [];
      if (oe2.path = void 0, oe2.query) {
        for (var we2 = false, Me2 = {}, Ve2 = oe2.query.split("&"), $e2 = 0, yt2 = Ve2.length; $e2 < yt2; ++$e2) {
          var ze2 = Ve2[$e2].split("=");
          switch (ze2[0]) {
            case "to":
              for (var vt2 = ze2[1].split(","), Nt2 = 0, Qt2 = vt2.length; Nt2 < Qt2; ++Nt2)
                le2.push(vt2[Nt2]);
              break;
            case "subject":
              oe2.subject = fe2(ze2[1], ee2);
              break;
            case "body":
              oe2.body = fe2(ze2[1], ee2);
              break;
            default:
              we2 = true, Me2[fe2(ze2[0], ee2)] = fe2(ze2[1], ee2);
          }
        }
        we2 && (oe2.headers = Me2);
      }
      oe2.query = void 0;
      for (var bt2 = 0, at2 = le2.length; bt2 < at2; ++bt2) {
        var jt2 = le2[bt2].split("@");
        if (jt2[0] = fe2(jt2[0]), ee2.unicodeSupport)
          jt2[1] = fe2(jt2[1], ee2).toLowerCase();
        else
          try {
            jt2[1] = D3.toASCII(fe2(jt2[1], ee2).toLowerCase());
          } catch (dn2) {
            oe2.error = oe2.error || "Email address's domain name can not be converted to ASCII via punycode: " + dn2;
          }
        le2[bt2] = jt2.join("@");
      }
      return oe2;
    }, serialize: function(Z3, ee2) {
      var oe2, le2 = Z3, we2 = (oe2 = Z3.to) != null ? oe2 instanceof Array ? oe2 : typeof oe2.length != "number" || oe2.split || oe2.setInterval || oe2.call ? [oe2] : Array.prototype.slice.call(oe2) : [];
      if (we2) {
        for (var Me2 = 0, Ve2 = we2.length; Me2 < Ve2; ++Me2) {
          var $e2 = String(we2[Me2]), yt2 = $e2.lastIndexOf("@"), ze2 = $e2.slice(0, yt2).replace(De2, Ye2).replace(De2, s3).replace(Ee2, L3), vt2 = $e2.slice(yt2 + 1);
          try {
            vt2 = ee2.iri ? D3.toUnicode(vt2) : D3.toASCII(fe2(vt2, ee2).toLowerCase());
          } catch (at2) {
            le2.error = le2.error || "Email address's domain name can not be converted to " + (ee2.iri ? "Unicode" : "ASCII") + " via punycode: " + at2;
          }
          we2[Me2] = ze2 + "@" + vt2;
        }
        le2.path = we2.join(",");
      }
      var Nt2 = Z3.headers = Z3.headers || {};
      Z3.subject && (Nt2.subject = Z3.subject), Z3.body && (Nt2.body = Z3.body);
      var Qt2 = [];
      for (var bt2 in Nt2)
        Nt2[bt2] !== Pe2[bt2] && Qt2.push(bt2.replace(De2, Ye2).replace(De2, s3).replace(_e2, L3) + "=" + Nt2[bt2].replace(De2, Ye2).replace(De2, s3).replace(Oe2, L3));
      return Qt2.length && (le2.query = Qt2.join("&")), le2;
    } }, Kt2 = /^([^\:]+)\:(.*)/, Jt2 = { scheme: "urn", parse: function(Z3, ee2) {
      var oe2 = Z3.path && Z3.path.match(Kt2), le2 = Z3;
      if (oe2) {
        var we2 = ee2.scheme || le2.scheme || "urn", Me2 = oe2[1].toLowerCase(), Ve2 = oe2[2], $e2 = we2 + ":" + (ee2.nid || Me2), yt2 = I3[$e2];
        le2.nid = Me2, le2.nss = Ve2, le2.path = void 0, yt2 && (le2 = yt2.parse(le2, ee2));
      } else
        le2.error = le2.error || "URN can not be parsed.";
      return le2;
    }, serialize: function(Z3, ee2) {
      var oe2 = ee2.scheme || Z3.scheme || "urn", le2 = Z3.nid, we2 = oe2 + ":" + (ee2.nid || le2), Me2 = I3[we2];
      Me2 && (Z3 = Me2.serialize(Z3, ee2));
      var Ve2 = Z3, $e2 = Z3.nss;
      return Ve2.path = (le2 || ee2.nid) + ":" + $e2, Ve2;
    } }, zt2 = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/, wn2 = { scheme: "urn:uuid", parse: function(Z3, ee2) {
      var oe2 = Z3;
      return oe2.uuid = oe2.nss, oe2.nss = void 0, ee2.tolerant || oe2.uuid && oe2.uuid.match(zt2) || (oe2.error = oe2.error || "UUID is not valid."), oe2;
    }, serialize: function(Z3, ee2) {
      var oe2 = Z3;
      return oe2.nss = (Z3.uuid || "").toLowerCase(), oe2;
    } };
    I3[ge2.scheme] = ge2, I3[Fe2.scheme] = Fe2, I3[_t2.scheme] = _t2, I3[Jt2.scheme] = Jt2, I3[wn2.scheme] = wn2, n3.SCHEMES = I3, n3.pctEncChar = L3, n3.pctDecChars = V10, n3.parse = ce2, n3.removeDotSegments = he2, n3.serialize = j3, n3.resolveComponents = ie2, n3.resolve = function(Z3, ee2, oe2) {
      var le2 = function(we2, Me2) {
        var Ve2 = we2;
        if (Me2)
          for (var $e2 in Me2)
            Ve2[$e2] = Me2[$e2];
        return Ve2;
      }({ scheme: "null" }, oe2);
      return j3(ie2(ce2(Z3, le2), ce2(ee2, le2), le2, true), le2);
    }, n3.normalize = function(Z3, ee2) {
      return typeof Z3 == "string" ? Z3 = j3(ce2(Z3, ee2), ee2) : a3(Z3) === "object" && (Z3 = ce2(j3(Z3, ee2), ee2)), Z3;
    }, n3.equal = function(Z3, ee2, oe2) {
      return typeof Z3 == "string" ? Z3 = j3(ce2(Z3, oe2), oe2) : a3(Z3) === "object" && (Z3 = j3(Z3, oe2)), typeof ee2 == "string" ? ee2 = j3(ce2(ee2, oe2), oe2) : a3(ee2) === "object" && (ee2 = j3(ee2, oe2)), Z3 === ee2;
    }, n3.escapeComponent = function(Z3, ee2) {
      return Z3 && Z3.toString().replace(ee2 && ee2.iri ? c3.ESCAPE : u3.ESCAPE, L3);
    }, n3.unescapeComponent = fe2, Object.defineProperty(n3, "__esModule", { value: true });
  })(t3);
}));
Z2(Zs$1);
var Vx = Array.isArray, Ux = Object.keys, D8 = Object.prototype.hasOwnProperty, Vp = function e22(t3, n3) {
  if (t3 === n3)
    return true;
  if (t3 && n3 && xe$3(t3) == "object" && xe$3(n3) == "object") {
    var r3, i, a3, s3 = Vx(t3), o3 = Vx(n3);
    if (s3 && o3) {
      if ((i = t3.length) != n3.length)
        return false;
      for (r3 = i; r3-- != 0; )
        if (!e22(t3[r3], n3[r3]))
          return false;
      return true;
    }
    if (s3 != o3)
      return false;
    var u3 = t3 instanceof Date, c3 = n3 instanceof Date;
    if (u3 != c3)
      return false;
    if (u3 && c3)
      return t3.getTime() == n3.getTime();
    var f3 = t3 instanceof RegExp, p3 = n3 instanceof RegExp;
    if (f3 != p3)
      return false;
    if (f3 && p3)
      return t3.toString() == n3.toString();
    var d3 = Ux(t3);
    if ((i = d3.length) !== Ux(n3).length)
      return false;
    for (r3 = i; r3-- != 0; )
      if (!D8.call(n3, d3[r3]))
        return false;
    for (r3 = i; r3-- != 0; )
      if (!e22(t3[a3 = d3[r3]], n3[a3]))
        return false;
    return true;
  }
  return t3 != t3 && n3 != n3;
}, Mr$1 = { copy: function(e28, t3) {
  for (var n3 in t3 = t3 || {}, e28)
    t3[n3] = e28[n3];
  return t3;
}, checkDataType: _d, checkDataTypes: function(e28, t3) {
  switch (e28.length) {
    case 1:
      return _d(e28[0], t3, true);
    default:
      var n3 = "", r3 = Wm(e28);
      for (var i in r3.array && r3.object && (n3 = r3.null ? "(" : "(!" + t3 + " || ", n3 += "typeof " + t3 + ' !== "object")', delete r3.null, delete r3.array, delete r3.object), r3.number && delete r3.integer, r3)
        n3 += (n3 ? " && " : "") + _d(i, t3, true);
      return n3;
  }
}, coerceToTypes: function(e28, t3) {
  if (Array.isArray(t3)) {
    for (var n3 = [], r3 = 0; r3 < t3.length; r3++) {
      var i = t3[r3];
      (qx[i] || e28 === "array" && i === "array") && (n3[n3.length] = i);
    }
    if (n3.length)
      return n3;
  } else {
    if (qx[t3])
      return [t3];
    if (e28 === "array" && t3 === "array")
      return ["array"];
  }
}, toHash: Wm, getProperty: Td, escapeQuotes: rg, equal: Vp, ucs2length: function(e28) {
  for (var t3, n3 = 0, r3 = e28.length, i = 0; i < r3; )
    n3++, (t3 = e28.charCodeAt(i++)) >= 55296 && t3 <= 56319 && i < r3 && (64512 & (t3 = e28.charCodeAt(i))) == 56320 && i++;
  return n3;
}, varOccurences: function(e28, t3) {
  t3 += "[^0-9]";
  var n3 = e28.match(new RegExp(t3, "g"));
  return n3 ? n3.length : 0;
}, varReplace: function(e28, t3, n3) {
  return t3 += "([^0-9])", n3 = n3.replace(/\$/g, "$$$$"), e28.replace(new RegExp(t3, "g"), n3 + "$1");
}, cleanUpCode: function(e28) {
  return e28.replace(A8, "").replace(_8, "").replace(T8, "if (!($1))");
}, finalCleanUpCode: function(e28, t3) {
  var n3 = e28.match(P8);
  return n3 && n3.length == 2 && (e28 = t3 ? e28.replace(B8, "").replace(N8, j8) : e28.replace(I8, "").replace(O8, L8)), (n3 = e28.match(R8)) && n3.length === 3 ? e28.replace(M8, "") : e28;
}, schemaHasRules: function(e28, t3) {
  if (typeof e28 == "boolean")
    return !e28;
  for (var n3 in e28)
    if (t3[n3])
      return true;
}, schemaHasRulesExcept: function(e28, t3, n3) {
  if (typeof e28 == "boolean")
    return !e28 && n3 != "not";
  for (var r3 in e28)
    if (r3 != n3 && t3[r3])
      return true;
}, schemaUnknownRules: function(e28, t3) {
  if (typeof e28 != "boolean") {
    for (var n3 in e28)
      if (!t3[n3])
        return n3;
  }
}, toQuotedString: Wx, getPathExpr: function(e28, t3, n3, r3) {
  return $x(e28, n3 ? "'/' + " + t3 + (r3 ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : r3 ? "'[' + " + t3 + " + ']'" : "'[\\'' + " + t3 + " + '\\']'");
}, getPath: function(e28, t3, n3) {
  var r3 = Wx(n3 ? "/" + Pd$1(t3) : Td(t3));
  return $x(e28, r3);
}, getData: function(e28, t3, n3) {
  var r3, i, a3, s3;
  if (e28 === "")
    return "rootData";
  if (e28[0] == "/") {
    if (!V8.test(e28))
      throw new Error("Invalid JSON-pointer: " + e28);
    i = e28, a3 = "rootData";
  } else {
    if (!(s3 = e28.match(U8)))
      throw new Error("Invalid JSON-pointer: " + e28);
    if (r3 = +s3[1], (i = s3[2]) == "#") {
      if (r3 >= t3)
        throw new Error("Cannot access property/index " + r3 + " levels up, current level is " + t3);
      return n3[t3 - r3];
    }
    if (r3 > t3)
      throw new Error("Cannot access data " + r3 + " levels up, current level is " + t3);
    if (a3 = "data" + (t3 - r3 || ""), !i)
      return a3;
  }
  for (var o3 = a3, u3 = i.split("/"), c3 = 0; c3 < u3.length; c3++) {
    var f3 = u3[c3];
    f3 && (a3 += Td(Id$1(f3)), o3 += " && " + a3);
  }
  return o3;
}, unescapeFragment: function(e28) {
  return Id$1(decodeURIComponent(e28));
}, unescapeJsonPointer: Id$1, escapeFragment: function(e28) {
  return encodeURIComponent(Pd$1(e28));
}, escapeJsonPointer: Pd$1 };
function _d(e28, t3, n3) {
  var r3 = n3 ? " !== " : " === ", i = n3 ? " || " : " && ", a3 = n3 ? "!" : "", s3 = n3 ? "" : "!";
  switch (e28) {
    case "null":
      return t3 + r3 + "null";
    case "array":
      return a3 + "Array.isArray(" + t3 + ")";
    case "object":
      return "(" + a3 + t3 + i + "typeof " + t3 + r3 + '"object"' + i + s3 + "Array.isArray(" + t3 + "))";
    case "integer":
      return "(typeof " + t3 + r3 + '"number"' + i + s3 + "(" + t3 + " % 1)" + i + t3 + r3 + t3 + ")";
    default:
      return "typeof " + t3 + r3 + '"' + e28 + '"';
  }
}
var qx = Wm(["string", "number", "integer", "boolean", "null"]);
function Wm(e28) {
  for (var t3 = {}, n3 = 0; n3 < e28.length; n3++)
    t3[e28[n3]] = true;
  return t3;
}
var F8 = /^[a-z$_][a-z$_0-9]*$/i, w8 = /'|\\/g;
function Td(e28) {
  return typeof e28 == "number" ? "[" + e28 + "]" : F8.test(e28) ? "." + e28 : "['" + rg(e28) + "']";
}
function rg(e28) {
  return e28.replace(w8, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
}
var A8 = /else\s*{\s*}/g, _8 = /if\s*\([^)]+\)\s*\{\s*\}(?!\s*else)/g, T8 = /if\s*\(([^)]+)\)\s*\{\s*\}\s*else(?!\s*if)/g, P8 = /[^v.]errors/g, I8 = /var errors = 0;|var vErrors = null;|validate.errors = vErrors;/g, B8 = /var errors = 0;|var vErrors = null;/g, O8 = "return errors === 0;", L8 = "validate.errors = null; return true;", N8 = /if \(errors === 0\) return data;\s*else throw new ValidationError\(vErrors\);/, j8 = "return data;", R8 = /[^A-Za-z_$]rootData[^A-Za-z0-9_$]/g, M8 = /if \(rootData === undefined\) rootData = data;/;
function Wx(e28) {
  return "'" + rg(e28) + "'";
}
var V8 = /^\/(?:[^~]|~0|~1)*$/, U8 = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function $x(e28, t3) {
  return e28 == '""' ? t3 : (e28 + " + " + t3).replace(/' \+ '/g, "");
}
function Pd$1(e28) {
  return e28.replace(/~/g, "~0").replace(/\//g, "~1");
}
function Id$1(e28) {
  return e28.replace(/~1/g, "/").replace(/~0/g, "~");
}
var Ks$1 = function(e28) {
  Mr$1.copy(e28, this);
}, q8 = gt$3(function(e28) {
  var t3 = e28.exports = function(n3, r3, i) {
    typeof r3 == "function" && (i = r3, r3 = {}), function a3(s3, o3, u3, c3, f3, p3, d3, m3, y3, v3) {
      if (c3 && xe$3(c3) == "object" && !Array.isArray(c3)) {
        for (var b3 in o3(c3, f3, p3, d3, m3, y3, v3), c3) {
          var x3 = c3[b3];
          if (Array.isArray(x3)) {
            if (b3 in t3.arrayKeywords)
              for (var C3 = 0; C3 < x3.length; C3++)
                a3(s3, o3, u3, x3[C3], f3 + "/" + b3 + "/" + C3, p3, f3, b3, c3, C3);
          } else if (b3 in t3.propsKeywords) {
            if (x3 && xe$3(x3) == "object")
              for (var k3 in x3)
                a3(s3, o3, u3, x3[k3], f3 + "/" + b3 + "/" + k3.replace(/~/g, "~0").replace(/\//g, "~1"), p3, f3, b3, c3, k3);
          } else
            (b3 in t3.keywords || s3.allKeys && !(b3 in t3.skipKeywords)) && a3(s3, o3, u3, x3, f3 + "/" + b3, p3, f3, b3, c3);
        }
        u3(c3, f3, p3, d3, m3, y3, v3);
      }
    }(r3, typeof (i = r3.cb || i) == "function" ? i : i.pre || function() {
    }, i.post || function() {
    }, n3, "", n3);
  };
  t3.keywords = { additionalItems: true, items: true, contains: true, additionalProperties: true, propertyNames: true, not: true }, t3.arrayKeywords = { items: true, allOf: true, anyOf: true, oneOf: true }, t3.propsKeywords = { definitions: true, properties: true, patternProperties: true, dependencies: true }, t3.skipKeywords = { default: true, enum: true, const: true, required: true, maximum: true, minimum: true, exclusiveMaximum: true, exclusiveMinimum: true, multipleOf: true, maxLength: true, minLength: true, pattern: true, format: true, maxItems: true, minItems: true, uniqueItems: true, maxProperties: true, minProperties: true };
}), xr$1 = Ja$3;
function Ja$3(e28, t3, n3) {
  var r3 = this._refs[n3];
  if (typeof r3 == "string") {
    if (!this._refs[r3])
      return Ja$3.call(this, e28, t3, r3);
    r3 = this._refs[r3];
  }
  if ((r3 = r3 || this._schemas[n3]) instanceof Ks$1)
    return $m(r3.schema, this._opts.inlineRefs) ? r3.schema : r3.validate || this._compile(r3);
  var i, a3, s3, o3 = xf.call(this, t3, n3);
  return o3 && (i = o3.schema, t3 = o3.root, s3 = o3.baseId), i instanceof Ks$1 ? a3 = i.validate || e28.call(this, i.schema, t3, void 0, s3) : i !== void 0 && (a3 = $m(i, this._opts.inlineRefs) ? i : e28.call(this, i, t3, void 0, s3)), a3;
}
function xf(e28, t3) {
  var n3 = Zs$1.parse(t3), r3 = ED(n3), i = Up(this._getId(e28.schema));
  if (Object.keys(e28.schema).length === 0 || r3 !== i) {
    var a3 = Za$2(r3), s3 = this._refs[a3];
    if (typeof s3 == "string")
      return W8.call(this, e28, s3, n3);
    if (s3 instanceof Ks$1)
      s3.validate || this._compile(s3), e28 = s3;
    else {
      if (!((s3 = this._schemas[a3]) instanceof Ks$1))
        return;
      if (s3.validate || this._compile(s3), a3 == Za$2(t3))
        return { schema: s3, root: e28, baseId: i };
      e28 = s3;
    }
    if (!e28.schema)
      return;
    i = Up(this._getId(e28.schema));
  }
  return bD.call(this, n3, i, e28.schema, e28);
}
function W8(e28, t3, n3) {
  var r3 = xf.call(this, e28, t3);
  if (r3) {
    var i = r3.schema, a3 = r3.baseId;
    e28 = r3.root;
    var s3 = this._getId(i);
    return s3 && (a3 = qp(a3, s3)), bD.call(this, n3, a3, i, e28);
  }
}
Ja$3.normalizeId = Za$2, Ja$3.fullPath = Up, Ja$3.url = qp, Ja$3.ids = function(e28) {
  var t3 = Za$2(this._getId(e28)), n3 = { "": t3 }, r3 = { "": Up(t3, false) }, i = {}, a3 = this;
  return q8(e28, { allKeys: true }, function(s3, o3, u3, c3, f3, p3, d3) {
    if (o3 !== "") {
      var m3 = a3._getId(s3), y3 = n3[c3], v3 = r3[c3] + "/" + f3;
      if (d3 !== void 0 && (v3 += "/" + (typeof d3 == "number" ? d3 : Mr$1.escapeFragment(d3))), typeof m3 == "string") {
        m3 = y3 = Za$2(y3 ? Zs$1.resolve(y3, m3) : m3);
        var b3 = a3._refs[m3];
        if (typeof b3 == "string" && (b3 = a3._refs[b3]), b3 && b3.schema) {
          if (!Vp(s3, b3.schema))
            throw new Error('id "' + m3 + '" resolves to more than one schema');
        } else if (m3 != Za$2(v3))
          if (m3[0] == "#") {
            if (i[m3] && !Vp(s3, i[m3]))
              throw new Error('id "' + m3 + '" resolves to more than one schema');
            i[m3] = s3;
          } else
            a3._refs[m3] = v3;
      }
      n3[o3] = y3, r3[o3] = v3;
    }
  }), i;
}, Ja$3.inlineRef = $m, Ja$3.schema = xf;
var $8 = Mr$1.toHash(["properties", "patternProperties", "enum", "dependencies", "definitions"]);
function bD(e28, t3, n3, r3) {
  if (e28.fragment = e28.fragment || "", e28.fragment.slice(0, 1) == "/") {
    for (var i = e28.fragment.split("/"), a3 = 1; a3 < i.length; a3++) {
      var s3 = i[a3];
      if (s3) {
        if ((n3 = n3[s3 = Mr$1.unescapeFragment(s3)]) === void 0)
          break;
        var o3;
        if (!$8[s3] && ((o3 = this._getId(n3)) && (t3 = qp(t3, o3)), n3.$ref)) {
          var u3 = qp(t3, n3.$ref), c3 = xf.call(this, r3, u3);
          c3 && (n3 = c3.schema, r3 = c3.root, t3 = c3.baseId);
        }
      }
    }
    return n3 !== void 0 && n3 !== r3.schema ? { schema: n3, root: r3, baseId: t3 } : void 0;
  }
}
var G8 = Mr$1.toHash(["type", "format", "pattern", "maxLength", "minLength", "maxProperties", "minProperties", "maxItems", "minItems", "maximum", "minimum", "uniqueItems", "multipleOf", "required", "enum"]);
function $m(e28, t3) {
  return t3 !== false && (t3 === void 0 || t3 === true ? function n3(r3) {
    var i;
    if (Array.isArray(r3)) {
      for (var a3 = 0; a3 < r3.length; a3++)
        if (xe$3(i = r3[a3]) == "object" && !n3(i))
          return false;
    } else
      for (var s3 in r3)
        if (s3 == "$ref" || xe$3(i = r3[s3]) == "object" && !n3(i))
          return false;
    return true;
  }(e28) : t3 ? function n3(r3) {
    var i, a3 = 0;
    if (Array.isArray(r3)) {
      for (var s3 = 0; s3 < r3.length; s3++)
        if (xe$3(i = r3[s3]) == "object" && (a3 += n3(i)), a3 == 1 / 0)
          return 1 / 0;
    } else
      for (var o3 in r3) {
        if (o3 == "$ref")
          return 1 / 0;
        if (G8[o3])
          a3++;
        else if (xe$3(i = r3[o3]) == "object" && (a3 += n3(i) + 1), a3 == 1 / 0)
          return 1 / 0;
      }
    return a3;
  }(e28) <= t3 : void 0);
}
function Up(e28, t3) {
  return t3 !== false && (e28 = Za$2(e28)), ED(Zs$1.parse(e28));
}
function ED(e28) {
  return Zs$1.serialize(e28).split("#")[0] + "#";
}
var z8 = /#\/?$/;
function Za$2(e28) {
  return e28 ? e28.replace(z8, "") : "";
}
function qp(e28, t3) {
  return t3 = Za$2(t3), Zs$1.resolve(e28, t3);
}
var mc$2 = { Validation: Gx(function(e28) {
  this.message = "validation failed", this.errors = e28, this.ajv = this.validation = true;
}), MissingRef: Gx(ig) };
function ig(e28, t3, n3) {
  this.message = n3 || ig.message(e28, t3), this.missingRef = xr$1.url(e28, t3), this.missingSchema = xr$1.normalizeId(xr$1.fullPath(this.missingRef));
}
function Gx(e28) {
  return e28.prototype = Object.create(Error.prototype), e28.prototype.constructor = e28, e28;
}
ig.message = function(e28, t3) {
  return "can't resolve reference " + t3 + " from id " + e28;
};
var CD = function(e28, t3) {
  t3 || (t3 = {}), typeof t3 == "function" && (t3 = { cmp: t3 });
  var n3 = typeof t3.cycles == "boolean" && t3.cycles, r3 = t3.cmp && function(a3) {
    return function(s3) {
      return function(o3, u3) {
        var c3 = { key: o3, value: s3[o3] }, f3 = { key: u3, value: s3[u3] };
        return a3(c3, f3);
      };
    };
  }(t3.cmp), i = [];
  return function a3(s3) {
    if (s3 && s3.toJSON && typeof s3.toJSON == "function" && (s3 = s3.toJSON()), s3 !== void 0) {
      if (typeof s3 == "number")
        return isFinite(s3) ? "" + s3 : "null";
      if (xe$3(s3) !== "object")
        return JSON.stringify(s3);
      var o3, u3;
      if (Array.isArray(s3)) {
        for (u3 = "[", o3 = 0; o3 < s3.length; o3++)
          o3 && (u3 += ","), u3 += a3(s3[o3]) || "null";
        return u3 + "]";
      }
      if (s3 === null)
        return "null";
      if (i.indexOf(s3) !== -1) {
        if (n3)
          return JSON.stringify("__cycle__");
        throw new TypeError("Converting circular structure to JSON");
      }
      var c3 = i.push(s3) - 1, f3 = Object.keys(s3).sort(r3 && r3(s3));
      for (u3 = "", o3 = 0; o3 < f3.length; o3++) {
        var p3 = f3[o3], d3 = a3(s3[p3]);
        d3 && (u3 && (u3 += ","), u3 += JSON.stringify(p3) + ":" + d3);
      }
      return i.splice(c3, 1), "{" + u3 + "}";
    }
  }(e28);
}, Gm = function(e28, t3, n3) {
  var r3 = "", i = e28.schema.$async === true, a3 = e28.util.schemaHasRulesExcept(e28.schema, e28.RULES.all, "$ref"), s3 = e28.self._getId(e28.schema);
  if (e28.opts.strictKeywords) {
    var o3 = e28.util.schemaUnknownRules(e28.schema, e28.RULES.keywords);
    if (o3) {
      var u3 = "unknown keyword: " + o3;
      if (e28.opts.strictKeywords !== "log")
        throw new Error(u3);
      e28.logger.warn(u3);
    }
  }
  if (e28.isTop && (r3 += " var validate = ", i && (e28.async = true, r3 += "async "), r3 += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ", s3 && (e28.opts.sourceCode || e28.opts.processCode) && (r3 += " /*# sourceURL=" + s3 + " */ ")), typeof e28.schema == "boolean" || !a3 && !e28.schema.$ref) {
    var c3 = e28.level, f3 = e28.dataLevel, p3 = e28.schema["false schema"], d3 = e28.schemaPath + e28.util.getProperty("false schema"), m3 = e28.errSchemaPath + "/false schema", y3 = !e28.opts.allErrors, v3 = "data" + (f3 || ""), b3 = "valid" + c3;
    if (e28.schema === false) {
      e28.isTop ? y3 = true : r3 += " var " + b3 + " = false; ", (ue2 = ue2 || []).push(r3), r3 = "", e28.createErrors !== false ? (r3 += " { keyword: 'false schema' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(m3) + " , params: {} ", e28.opts.messages !== false && (r3 += " , message: 'boolean schema is false' "), e28.opts.verbose && (r3 += " , schema: false , parentSchema: validate.schema" + e28.schemaPath + " , data: " + v3 + " "), r3 += " } ") : r3 += " {} ";
      var x3 = r3;
      r3 = ue2.pop(), !e28.compositeRule && y3 ? e28.async ? r3 += " throw new ValidationError([" + x3 + "]); " : r3 += " validate.errors = [" + x3 + "]; return false; " : r3 += " var err = " + x3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    } else
      e28.isTop ? r3 += i ? " return data; " : " validate.errors = null; return true; " : r3 += " var " + b3 + " = true; ";
    return e28.isTop && (r3 += " }; return validate; "), r3;
  }
  if (e28.isTop) {
    var C3 = e28.isTop;
    if (c3 = e28.level = 0, f3 = e28.dataLevel = 0, v3 = "data", e28.rootId = e28.resolve.fullPath(e28.self._getId(e28.root.schema)), e28.baseId = e28.baseId || e28.rootId, delete e28.isTop, e28.dataPathArr = [void 0], e28.schema.default !== void 0 && e28.opts.useDefaults && e28.opts.strictDefaults) {
      var k3 = "default is ignored in the schema root";
      if (e28.opts.strictDefaults !== "log")
        throw new Error(k3);
      e28.logger.warn(k3);
    }
    r3 += " var vErrors = null; ", r3 += " var errors = 0;     ", r3 += " if (rootData === undefined) rootData = data; ";
  } else {
    if (c3 = e28.level, v3 = "data" + ((f3 = e28.dataLevel) || ""), s3 && (e28.baseId = e28.resolve.url(e28.baseId, s3)), i && !e28.async)
      throw new Error("async schema in sync schema");
    r3 += " var errs_" + c3 + " = errors;";
  }
  b3 = "valid" + c3, y3 = !e28.opts.allErrors;
  var F3 = "", B3 = "", O3 = e28.schema.type, S3 = Array.isArray(O3);
  if (O3 && e28.opts.nullable && e28.schema.nullable === true && (S3 ? O3.indexOf("null") == -1 && (O3 = O3.concat("null")) : O3 != "null" && (O3 = [O3, "null"], S3 = true)), S3 && O3.length == 1 && (O3 = O3[0], S3 = false), e28.schema.$ref && a3) {
    if (e28.opts.extendRefs == "fail")
      throw new Error('$ref: validation keywords used in schema at path "' + e28.errSchemaPath + '" (see option extendRefs)');
    e28.opts.extendRefs !== true && (a3 = false, e28.logger.warn('$ref: keywords ignored in schema at path "' + e28.errSchemaPath + '"'));
  }
  if (e28.schema.$comment && e28.opts.$comment && (r3 += " " + e28.RULES.all.$comment.code(e28, "$comment")), O3) {
    if (e28.opts.coerceTypes)
      var w3 = e28.util.coerceToTypes(e28.opts.coerceTypes, O3);
    var D3 = e28.RULES.types[O3];
    if (w3 || S3 || D3 === true || D3 && !De2(D3)) {
      d3 = e28.schemaPath + ".type", m3 = e28.errSchemaPath + "/type", d3 = e28.schemaPath + ".type", m3 = e28.errSchemaPath + "/type";
      var I3 = S3 ? "checkDataTypes" : "checkDataType";
      if (r3 += " if (" + e28.util[I3](O3, v3, true) + ") { ", w3) {
        var L3 = "dataType" + c3, V10 = "coerced" + c3;
        r3 += " var " + L3 + " = typeof " + v3 + "; ", e28.opts.coerceTypes == "array" && (r3 += " if (" + L3 + " == 'object' && Array.isArray(" + v3 + ")) " + L3 + " = 'array'; "), r3 += " var " + V10 + " = undefined; ";
        var K3 = "", W3 = w3;
        if (W3)
          for (var R3, q3 = -1, J3 = W3.length - 1; q3 < J3; )
            R3 = W3[q3 += 1], q3 && (r3 += " if (" + V10 + " === undefined) { ", K3 += "}"), e28.opts.coerceTypes == "array" && R3 != "array" && (r3 += " if (" + L3 + " == 'array' && " + v3 + ".length == 1) { " + V10 + " = " + v3 + " = " + v3 + "[0]; " + L3 + " = typeof " + v3 + ";  } "), R3 == "string" ? r3 += " if (" + L3 + " == 'number' || " + L3 + " == 'boolean') " + V10 + " = '' + " + v3 + "; else if (" + v3 + " === null) " + V10 + " = ''; " : R3 == "number" || R3 == "integer" ? (r3 += " if (" + L3 + " == 'boolean' || " + v3 + " === null || (" + L3 + " == 'string' && " + v3 + " && " + v3 + " == +" + v3 + " ", R3 == "integer" && (r3 += " && !(" + v3 + " % 1)"), r3 += ")) " + V10 + " = +" + v3 + "; ") : R3 == "boolean" ? r3 += " if (" + v3 + " === 'false' || " + v3 + " === 0 || " + v3 + " === null) " + V10 + " = false; else if (" + v3 + " === 'true' || " + v3 + " === 1) " + V10 + " = true; " : R3 == "null" ? r3 += " if (" + v3 + " === '' || " + v3 + " === 0 || " + v3 + " === false) " + V10 + " = null; " : e28.opts.coerceTypes == "array" && R3 == "array" && (r3 += " if (" + L3 + " == 'string' || " + L3 + " == 'number' || " + L3 + " == 'boolean' || " + v3 + " == null) " + V10 + " = [" + v3 + "]; ");
        r3 += " " + K3 + " if (" + V10 + " === undefined) {   ", (ue2 = ue2 || []).push(r3), r3 = "", e28.createErrors !== false ? (r3 += " { keyword: 'type' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(m3) + " , params: { type: '", r3 += S3 ? "" + O3.join(",") : "" + O3, r3 += "' } ", e28.opts.messages !== false && (r3 += " , message: 'should be ", r3 += S3 ? "" + O3.join(",") : "" + O3, r3 += "' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + d3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + v3 + " "), r3 += " } ") : r3 += " {} ", x3 = r3, r3 = ue2.pop(), !e28.compositeRule && y3 ? e28.async ? r3 += " throw new ValidationError([" + x3 + "]); " : r3 += " validate.errors = [" + x3 + "]; return false; " : r3 += " var err = " + x3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r3 += " } else {  ";
        var X3 = f3 ? "data" + (f3 - 1 || "") : "parentData";
        r3 += " " + v3 + " = " + V10 + "; ", f3 || (r3 += "if (" + X3 + " !== undefined)"), r3 += " " + X3 + "[" + (f3 ? e28.dataPathArr[f3] : "parentDataProperty") + "] = " + V10 + "; } ";
      } else
        (ue2 = ue2 || []).push(r3), r3 = "", e28.createErrors !== false ? (r3 += " { keyword: 'type' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(m3) + " , params: { type: '", r3 += S3 ? "" + O3.join(",") : "" + O3, r3 += "' } ", e28.opts.messages !== false && (r3 += " , message: 'should be ", r3 += S3 ? "" + O3.join(",") : "" + O3, r3 += "' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + d3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + v3 + " "), r3 += " } ") : r3 += " {} ", x3 = r3, r3 = ue2.pop(), !e28.compositeRule && y3 ? e28.async ? r3 += " throw new ValidationError([" + x3 + "]); " : r3 += " validate.errors = [" + x3 + "]; return false; " : r3 += " var err = " + x3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      r3 += " } ";
    }
  }
  if (e28.schema.$ref && !a3)
    r3 += " " + e28.RULES.all.$ref.code(e28, "$ref") + " ", y3 && (r3 += " } if (errors === ", r3 += C3 ? "0" : "errs_" + c3, r3 += ") { ", B3 += "}");
  else {
    var ce2 = e28.RULES;
    if (ce2) {
      for (var A3 = -1, M3 = ce2.length - 1; A3 < M3; )
        if (De2(D3 = ce2[A3 += 1])) {
          if (D3.type && (r3 += " if (" + e28.util.checkDataType(D3.type, v3) + ") { "), e28.opts.useDefaults) {
            if (D3.type == "object" && e28.schema.properties) {
              p3 = e28.schema.properties;
              var ne2 = Object.keys(p3);
              if (ne2) {
                for (var de2, he2 = -1, j3 = ne2.length - 1; he2 < j3; )
                  if ((ge2 = p3[de2 = ne2[he2 += 1]]).default !== void 0) {
                    var ie2 = v3 + e28.util.getProperty(de2);
                    if (e28.compositeRule) {
                      if (e28.opts.strictDefaults) {
                        if (k3 = "default is ignored for: " + ie2, e28.opts.strictDefaults !== "log")
                          throw new Error(k3);
                        e28.logger.warn(k3);
                      }
                    } else
                      r3 += " if (" + ie2 + " === undefined ", e28.opts.useDefaults == "empty" && (r3 += " || " + ie2 + " === null || " + ie2 + " === '' "), r3 += " ) " + ie2 + " = ", e28.opts.useDefaults == "shared" ? r3 += " " + e28.useDefault(ge2.default) + " " : r3 += " " + JSON.stringify(ge2.default) + " ", r3 += "; ";
                  }
              }
            } else if (D3.type == "array" && Array.isArray(e28.schema.items)) {
              var fe2 = e28.schema.items;
              if (fe2) {
                q3 = -1;
                for (var ge2, Fe2 = fe2.length - 1; q3 < Fe2; )
                  if ((ge2 = fe2[q3 += 1]).default !== void 0)
                    if (ie2 = v3 + "[" + q3 + "]", e28.compositeRule) {
                      if (e28.opts.strictDefaults) {
                        if (k3 = "default is ignored for: " + ie2, e28.opts.strictDefaults !== "log")
                          throw new Error(k3);
                        e28.logger.warn(k3);
                      }
                    } else
                      r3 += " if (" + ie2 + " === undefined ", e28.opts.useDefaults == "empty" && (r3 += " || " + ie2 + " === null || " + ie2 + " === '' "), r3 += " ) " + ie2 + " = ", e28.opts.useDefaults == "shared" ? r3 += " " + e28.useDefault(ge2.default) + " " : r3 += " " + JSON.stringify(ge2.default) + " ", r3 += "; ";
              }
            }
          }
          var Pe2 = D3.rules;
          if (Pe2) {
            for (var _3, Q3 = -1, Y3 = Pe2.length - 1; Q3 < Y3; )
              if (Ee2(_3 = Pe2[Q3 += 1])) {
                var ae2 = _3.code(e28, _3.keyword, D3.type);
                ae2 && (r3 += " " + ae2 + " ", y3 && (F3 += "}"));
              }
          }
          if (y3 && (r3 += " " + F3 + " ", F3 = ""), D3.type && (r3 += " } ", O3 && O3 === D3.type && !w3)) {
            r3 += " else { ";
            var ue2;
            d3 = e28.schemaPath + ".type", m3 = e28.errSchemaPath + "/type", (ue2 = ue2 || []).push(r3), r3 = "", e28.createErrors !== false ? (r3 += " { keyword: 'type' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(m3) + " , params: { type: '", r3 += S3 ? "" + O3.join(",") : "" + O3, r3 += "' } ", e28.opts.messages !== false && (r3 += " , message: 'should be ", r3 += S3 ? "" + O3.join(",") : "" + O3, r3 += "' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + d3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + v3 + " "), r3 += " } ") : r3 += " {} ", x3 = r3, r3 = ue2.pop(), !e28.compositeRule && y3 ? e28.async ? r3 += " throw new ValidationError([" + x3 + "]); " : r3 += " validate.errors = [" + x3 + "]; return false; " : r3 += " var err = " + x3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r3 += " } ";
          }
          y3 && (r3 += " if (errors === ", r3 += C3 ? "0" : "errs_" + c3, r3 += ") { ", B3 += "}");
        }
    }
  }
  function De2(_e2) {
    for (var Oe2 = _e2.rules, Ye2 = 0; Ye2 < Oe2.length; Ye2++)
      if (Ee2(Oe2[Ye2]))
        return true;
  }
  function Ee2(_e2) {
    return e28.schema[_e2.keyword] !== void 0 || _e2.implements && function(Oe2) {
      for (var Ye2 = Oe2.implements, _t2 = 0; _t2 < Ye2.length; _t2++)
        if (e28.schema[Ye2[_t2]] !== void 0)
          return true;
    }(_e2);
  }
  return y3 && (r3 += " " + B3 + " "), C3 ? (i ? (r3 += " if (errors === 0) return data;           ", r3 += " else throw new ValidationError(vErrors); ") : (r3 += " validate.errors = vErrors; ", r3 += " return errors === 0;       "), r3 += " }; return validate;") : r3 += " var " + b3 + " = errors === errs_" + c3 + ";", r3 = e28.util.cleanUpCode(r3), C3 && (r3 = e28.util.finalCleanUpCode(r3, i)), r3;
}, H8 = Mr$1.ucs2length, K8 = mc$2.Validation, zx = function e23(t3, n3, r3, i) {
  var a3 = this, s3 = this._opts, o3 = [void 0], u3 = {}, c3 = [], f3 = {}, p3 = [], d3 = {}, m3 = [];
  n3 = n3 || { schema: t3, refVal: o3, refs: u3 };
  var y3 = J8.call(this, t3, n3, i), v3 = this._compilations[y3.index];
  if (y3.compiling)
    return v3.callValidate = function L3() {
      var V10 = v3.validate, K3 = V10.apply(this, arguments);
      return L3.errors = V10.errors, K3;
    };
  var b3 = this._formats, x3 = this.RULES;
  try {
    var C3 = F3(t3, n3, r3, i);
    v3.validate = C3;
    var k3 = v3.callValidate;
    return k3 && (k3.schema = C3.schema, k3.errors = null, k3.refs = C3.refs, k3.refVal = C3.refVal, k3.root = C3.root, k3.$async = C3.$async, s3.sourceCode && (k3.source = C3.source)), C3;
  } finally {
    Q8.call(this, t3, n3, i);
  }
  function F3(L3, V10, K3, W3) {
    var R3 = !V10 || V10 && V10.schema == L3;
    if (V10.schema != n3.schema)
      return e23.call(a3, L3, V10, K3, W3);
    var q3, J3 = L3.$async === true, X3 = Gm({ isTop: true, schema: L3, isRoot: R3, baseId: W3, root: V10, schemaPath: "", errSchemaPath: "#", errorPath: '""', MissingRefError: mc$2.MissingRef, RULES: x3, validate: Gm, util: Mr$1, resolve: xr$1, resolveRef: B3, usePattern: w3, useDefault: D3, useCustomRule: I3, opts: s3, formats: b3, logger: a3.logger, self: a3 });
    X3 = Ul(o3, Z8) + Ul(c3, X8) + Ul(p3, Y8) + Ul(m3, eT) + X3, s3.processCode && (X3 = s3.processCode(X3));
    try {
      q3 = new Function("self", "RULES", "formats", "root", "refVal", "defaults", "customRules", "equal", "ucs2length", "ValidationError", X3)(a3, x3, b3, n3, o3, p3, m3, Vp, H8, K8), o3[0] = q3;
    } catch (ce2) {
      throw a3.logger.error("Error compiling schema, function code:", X3), ce2;
    }
    return q3.schema = L3, q3.errors = null, q3.refs = u3, q3.refVal = o3, q3.root = R3 ? q3 : V10, J3 && (q3.$async = true), s3.sourceCode === true && (q3.source = { code: X3, patterns: c3, defaults: p3 }), q3;
  }
  function B3(L3, V10, K3) {
    V10 = xr$1.url(L3, V10);
    var W3, R3, q3 = u3[V10];
    if (q3 !== void 0)
      return S3(W3 = o3[q3], R3 = "refVal[" + q3 + "]");
    if (!K3 && n3.refs) {
      var J3 = n3.refs[V10];
      if (J3 !== void 0)
        return S3(W3 = n3.refVal[J3], R3 = O3(V10, W3));
    }
    R3 = O3(V10);
    var X3 = xr$1.call(a3, F3, n3, V10);
    if (X3 === void 0) {
      var ce2 = r3 && r3[V10];
      ce2 && (X3 = xr$1.inlineRef(ce2, s3.inlineRefs) ? ce2 : e23.call(a3, ce2, n3, r3, L3));
    }
    if (X3 !== void 0)
      return function(A3, M3) {
        var ne2 = u3[A3];
        o3[ne2] = M3;
      }(V10, X3), S3(X3, R3);
    (function(A3) {
      delete u3[A3];
    })(V10);
  }
  function O3(L3, V10) {
    var K3 = o3.length;
    return o3[K3] = V10, u3[L3] = K3, "refVal" + K3;
  }
  function S3(L3, V10) {
    return xe$3(L3) == "object" || typeof L3 == "boolean" ? { code: V10, schema: L3, inline: true } : { code: V10, $async: L3 && !!L3.$async };
  }
  function w3(L3) {
    var V10 = f3[L3];
    return V10 === void 0 && (V10 = f3[L3] = c3.length, c3[V10] = L3), "pattern" + V10;
  }
  function D3(L3) {
    switch (xe$3(L3)) {
      case "boolean":
      case "number":
        return "" + L3;
      case "string":
        return Mr$1.toQuotedString(L3);
      case "object":
        if (L3 === null)
          return "null";
        var V10 = CD(L3), K3 = d3[V10];
        return K3 === void 0 && (K3 = d3[V10] = p3.length, p3[K3] = L3), "default" + K3;
    }
  }
  function I3(L3, V10, K3, W3) {
    if (a3._opts.validateSchema !== false) {
      var R3 = L3.definition.dependencies;
      if (R3 && !R3.every(function(de2) {
        return Object.prototype.hasOwnProperty.call(K3, de2);
      }))
        throw new Error("parent schema must have all required keywords: " + R3.join(","));
      var q3 = L3.definition.validateSchema;
      if (q3 && !q3(V10)) {
        var J3 = "keyword schema is invalid: " + a3.errorsText(q3.errors);
        if (a3._opts.validateSchema != "log")
          throw new Error(J3);
        a3.logger.error(J3);
      }
    }
    var X3, ce2 = L3.definition.compile, A3 = L3.definition.inline, M3 = L3.definition.macro;
    if (ce2)
      X3 = ce2.call(a3, V10, K3, W3);
    else if (M3)
      X3 = M3.call(a3, V10, K3, W3), s3.validateSchema !== false && a3.validateSchema(X3, true);
    else if (A3)
      X3 = A3.call(a3, W3, L3.keyword, V10, K3);
    else if (!(X3 = L3.definition.validate))
      return;
    if (X3 === void 0)
      throw new Error('custom keyword "' + L3.keyword + '"failed to compile');
    var ne2 = m3.length;
    return m3[ne2] = X3, { code: "customRule" + ne2, validate: X3 };
  }
};
function J8(e28, t3, n3) {
  var r3 = SD.call(this, e28, t3, n3);
  return r3 >= 0 ? { index: r3, compiling: true } : (r3 = this._compilations.length, this._compilations[r3] = { schema: e28, root: t3, baseId: n3 }, { index: r3, compiling: false });
}
function Q8(e28, t3, n3) {
  var r3 = SD.call(this, e28, t3, n3);
  r3 >= 0 && this._compilations.splice(r3, 1);
}
function SD(e28, t3, n3) {
  for (var r3 = 0; r3 < this._compilations.length; r3++) {
    var i = this._compilations[r3];
    if (i.schema == e28 && i.root == t3 && i.baseId == n3)
      return r3;
  }
  return -1;
}
function X8(e28, t3) {
  return "var pattern" + e28 + " = new RegExp(" + Mr$1.toQuotedString(t3[e28]) + ");";
}
function Y8(e28) {
  return "var default" + e28 + " = defaults[" + e28 + "];";
}
function Z8(e28, t3) {
  return t3[e28] === void 0 ? "" : "var refVal" + e28 + " = refVal[" + e28 + "];";
}
function eT(e28) {
  return "var customRule" + e28 + " = customRules[" + e28 + "];";
}
function Ul(e28, t3) {
  if (!e28.length)
    return "";
  for (var n3 = "", r3 = 0; r3 < e28.length; r3++)
    n3 += t3(r3, e28);
  return n3;
}
var tT = gt$3(function(e28) {
  var t3 = e28.exports = function() {
    this._cache = {};
  };
  t3.prototype.put = function(n3, r3) {
    this._cache[n3] = r3;
  }, t3.prototype.get = function(n3) {
    return this._cache[n3];
  }, t3.prototype.del = function(n3) {
    delete this._cache[n3];
  }, t3.prototype.clear = function() {
    this._cache = {};
  };
}), nT = /^(\d\d\d\d)-(\d\d)-(\d\d)$/, rT = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], iT = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d:\d\d)?$/i, Hx = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*$/i, aT = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i, Kx = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i, Jx = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i, Qx = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i, Xx = /^(?:\/(?:[^~/]|~0|~1)*)*$/, Yx = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i, Zx = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/, oT = Wp;
function Wp(e28) {
  return e28 = e28 == "full" ? "full" : "fast", Mr$1.copy(Wp[e28]);
}
function eb$1(e28) {
  var t3 = e28.match(nT);
  if (!t3)
    return false;
  var n3 = +t3[1], r3 = +t3[2], i = +t3[3];
  return r3 >= 1 && r3 <= 12 && i >= 1 && i <= (r3 == 2 && function(a3) {
    return a3 % 4 == 0 && (a3 % 100 != 0 || a3 % 400 == 0);
  }(n3) ? 29 : rT[r3]);
}
function tb$1(e28, t3) {
  var n3 = e28.match(iT);
  if (!n3)
    return false;
  var r3 = n3[1], i = n3[2], a3 = n3[3], s3 = n3[5];
  return (r3 <= 23 && i <= 59 && a3 <= 59 || r3 == 23 && i == 59 && a3 == 60) && (!t3 || s3);
}
Wp.fast = { date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/, time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d:\d\d)?$/i, "date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d:\d\d)$/i, uri: /^(?:[a-z][a-z0-9+-.]*:)(?:\/?\/)?[^\s]*$/i, "uri-reference": /^(?:(?:[a-z][a-z0-9+-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i, "uri-template": Kx, url: Jx, email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i, hostname: Hx, ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/, ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i, regex: nb$1, uuid: Qx, "json-pointer": Xx, "json-pointer-uri-fragment": Yx, "relative-json-pointer": Zx }, Wp.full = { date: eb$1, time: tb$1, "date-time": function(e28) {
  var t3 = e28.split(sT);
  return t3.length == 2 && eb$1(t3[0]) && tb$1(t3[1], true);
}, uri: function(e28) {
  return uT.test(e28) && aT.test(e28);
}, "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i, "uri-template": Kx, url: Jx, email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i, hostname: function(e28) {
  return e28.length <= 255 && Hx.test(e28);
}, ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/, ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i, regex: nb$1, uuid: Qx, "json-pointer": Xx, "json-pointer-uri-fragment": Yx, "relative-json-pointer": Zx };
var sT = /t|\s/i, uT = /\/|:/, cT = /[^\\]\\Z/;
function nb$1(e28) {
  if (cT.test(e28))
    return false;
  try {
    return new RegExp(e28), true;
  } catch {
    return false;
  }
}
var rb = function(e28, t3, n3) {
  var r3, i = " ", a3 = e28.level, s3 = e28.dataLevel, o3 = e28.schema[t3], u3 = e28.schemaPath + e28.util.getProperty(t3), c3 = e28.errSchemaPath + "/" + t3, f3 = !e28.opts.allErrors, p3 = "data" + (s3 || ""), d3 = e28.opts.$data && o3 && o3.$data;
  d3 ? (i += " var schema" + a3 + " = " + e28.util.getData(o3.$data, s3, e28.dataPathArr) + "; ", r3 = "schema" + a3) : r3 = o3;
  var m3 = t3 == "maximum", y3 = m3 ? "exclusiveMaximum" : "exclusiveMinimum", v3 = e28.schema[y3], b3 = e28.opts.$data && v3 && v3.$data, x3 = m3 ? "<" : ">", C3 = m3 ? ">" : "<", k3 = void 0;
  if (b3) {
    var F3 = e28.util.getData(v3.$data, s3, e28.dataPathArr), B3 = "exclusive" + a3, O3 = "exclType" + a3, S3 = "exclIsNumber" + a3, w3 = "' + " + (L3 = "op" + a3) + " + '";
    i += " var schemaExcl" + a3 + " = " + F3 + "; ", i += " var " + B3 + "; var " + O3 + " = typeof " + (F3 = "schemaExcl" + a3) + "; if (" + O3 + " != 'boolean' && " + O3 + " != 'undefined' && " + O3 + " != 'number') { ";
    var D3;
    k3 = y3, (D3 = D3 || []).push(i), i = "", e28.createErrors !== false ? (i += " { keyword: '" + (k3 || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(c3) + " , params: {} ", e28.opts.messages !== false && (i += " , message: '" + y3 + " should be boolean' "), e28.opts.verbose && (i += " , schema: validate.schema" + u3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + p3 + " "), i += " } ") : i += " {} ";
    var I3 = i;
    i = D3.pop(), !e28.compositeRule && f3 ? e28.async ? i += " throw new ValidationError([" + I3 + "]); " : i += " validate.errors = [" + I3 + "]; return false; " : i += " var err = " + I3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " } else if ( ", d3 && (i += " (" + r3 + " !== undefined && typeof " + r3 + " != 'number') || "), i += " " + O3 + " == 'number' ? ( (" + B3 + " = " + r3 + " === undefined || " + F3 + " " + x3 + "= " + r3 + ") ? " + p3 + " " + C3 + "= " + F3 + " : " + p3 + " " + C3 + " " + r3 + " ) : ( (" + B3 + " = " + F3 + " === true) ? " + p3 + " " + C3 + "= " + r3 + " : " + p3 + " " + C3 + " " + r3 + " ) || " + p3 + " !== " + p3 + ") { var op" + a3 + " = " + B3 + " ? '" + x3 + "' : '" + x3 + "='; ", o3 === void 0 && (k3 = y3, c3 = e28.errSchemaPath + "/" + y3, r3 = F3, d3 = b3);
  } else if (w3 = x3, (S3 = typeof v3 == "number") && d3) {
    var L3 = "'" + w3 + "'";
    i += " if ( ", d3 && (i += " (" + r3 + " !== undefined && typeof " + r3 + " != 'number') || "), i += " ( " + r3 + " === undefined || " + v3 + " " + x3 + "= " + r3 + " ? " + p3 + " " + C3 + "= " + v3 + " : " + p3 + " " + C3 + " " + r3 + " ) || " + p3 + " !== " + p3 + ") { ";
  } else
    S3 && o3 === void 0 ? (B3 = true, k3 = y3, c3 = e28.errSchemaPath + "/" + y3, r3 = v3, C3 += "=") : (S3 && (r3 = Math[m3 ? "min" : "max"](v3, o3)), v3 === (!S3 || r3) ? (B3 = true, k3 = y3, c3 = e28.errSchemaPath + "/" + y3, C3 += "=") : (B3 = false, w3 += "=")), L3 = "'" + w3 + "'", i += " if ( ", d3 && (i += " (" + r3 + " !== undefined && typeof " + r3 + " != 'number') || "), i += " " + p3 + " " + C3 + " " + r3 + " || " + p3 + " !== " + p3 + ") { ";
  return k3 = k3 || t3, (D3 = D3 || []).push(i), i = "", e28.createErrors !== false ? (i += " { keyword: '" + (k3 || "_limit") + "' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(c3) + " , params: { comparison: " + L3 + ", limit: " + r3 + ", exclusive: " + B3 + " } ", e28.opts.messages !== false && (i += " , message: 'should be " + w3 + " ", i += d3 ? "' + " + r3 : r3 + "'"), e28.opts.verbose && (i += " , schema:  ", i += d3 ? "validate.schema" + u3 : "" + o3, i += "         , parentSchema: validate.schema" + e28.schemaPath + " , data: " + p3 + " "), i += " } ") : i += " {} ", I3 = i, i = D3.pop(), !e28.compositeRule && f3 ? e28.async ? i += " throw new ValidationError([" + I3 + "]); " : i += " validate.errors = [" + I3 + "]; return false; " : i += " var err = " + I3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " } ", f3 && (i += " else { "), i;
}, ib$1 = function(e28, t3, n3) {
  var r3, i = " ", a3 = e28.level, s3 = e28.dataLevel, o3 = e28.schema[t3], u3 = e28.schemaPath + e28.util.getProperty(t3), c3 = e28.errSchemaPath + "/" + t3, f3 = !e28.opts.allErrors, p3 = "data" + (s3 || ""), d3 = e28.opts.$data && o3 && o3.$data;
  d3 ? (i += " var schema" + a3 + " = " + e28.util.getData(o3.$data, s3, e28.dataPathArr) + "; ", r3 = "schema" + a3) : r3 = o3, i += "if ( ", d3 && (i += " (" + r3 + " !== undefined && typeof " + r3 + " != 'number') || "), i += " " + p3 + ".length " + (t3 == "maxItems" ? ">" : "<") + " " + r3 + ") { ";
  var m3 = t3, y3 = y3 || [];
  y3.push(i), i = "", e28.createErrors !== false ? (i += " { keyword: '" + (m3 || "_limitItems") + "' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(c3) + " , params: { limit: " + r3 + " } ", e28.opts.messages !== false && (i += " , message: 'should NOT have ", i += t3 == "maxItems" ? "more" : "fewer", i += " than ", i += d3 ? "' + " + r3 + " + '" : "" + o3, i += " items' "), e28.opts.verbose && (i += " , schema:  ", i += d3 ? "validate.schema" + u3 : "" + o3, i += "         , parentSchema: validate.schema" + e28.schemaPath + " , data: " + p3 + " "), i += " } ") : i += " {} ";
  var v3 = i;
  return i = y3.pop(), !e28.compositeRule && f3 ? e28.async ? i += " throw new ValidationError([" + v3 + "]); " : i += " validate.errors = [" + v3 + "]; return false; " : i += " var err = " + v3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += "} ", f3 && (i += " else { "), i;
}, ab$1 = function(e28, t3, n3) {
  var r3, i = " ", a3 = e28.level, s3 = e28.dataLevel, o3 = e28.schema[t3], u3 = e28.schemaPath + e28.util.getProperty(t3), c3 = e28.errSchemaPath + "/" + t3, f3 = !e28.opts.allErrors, p3 = "data" + (s3 || ""), d3 = e28.opts.$data && o3 && o3.$data;
  d3 ? (i += " var schema" + a3 + " = " + e28.util.getData(o3.$data, s3, e28.dataPathArr) + "; ", r3 = "schema" + a3) : r3 = o3;
  var m3 = t3 == "maxLength" ? ">" : "<";
  i += "if ( ", d3 && (i += " (" + r3 + " !== undefined && typeof " + r3 + " != 'number') || "), e28.opts.unicode === false ? i += " " + p3 + ".length " : i += " ucs2length(" + p3 + ") ", i += " " + m3 + " " + r3 + ") { ";
  var y3 = t3, v3 = v3 || [];
  v3.push(i), i = "", e28.createErrors !== false ? (i += " { keyword: '" + (y3 || "_limitLength") + "' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(c3) + " , params: { limit: " + r3 + " } ", e28.opts.messages !== false && (i += " , message: 'should NOT be ", i += t3 == "maxLength" ? "longer" : "shorter", i += " than ", i += d3 ? "' + " + r3 + " + '" : "" + o3, i += " characters' "), e28.opts.verbose && (i += " , schema:  ", i += d3 ? "validate.schema" + u3 : "" + o3, i += "         , parentSchema: validate.schema" + e28.schemaPath + " , data: " + p3 + " "), i += " } ") : i += " {} ";
  var b3 = i;
  return i = v3.pop(), !e28.compositeRule && f3 ? e28.async ? i += " throw new ValidationError([" + b3 + "]); " : i += " validate.errors = [" + b3 + "]; return false; " : i += " var err = " + b3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += "} ", f3 && (i += " else { "), i;
}, ob$1 = function(e28, t3, n3) {
  var r3, i = " ", a3 = e28.level, s3 = e28.dataLevel, o3 = e28.schema[t3], u3 = e28.schemaPath + e28.util.getProperty(t3), c3 = e28.errSchemaPath + "/" + t3, f3 = !e28.opts.allErrors, p3 = "data" + (s3 || ""), d3 = e28.opts.$data && o3 && o3.$data;
  d3 ? (i += " var schema" + a3 + " = " + e28.util.getData(o3.$data, s3, e28.dataPathArr) + "; ", r3 = "schema" + a3) : r3 = o3, i += "if ( ", d3 && (i += " (" + r3 + " !== undefined && typeof " + r3 + " != 'number') || "), i += " Object.keys(" + p3 + ").length " + (t3 == "maxProperties" ? ">" : "<") + " " + r3 + ") { ";
  var m3 = t3, y3 = y3 || [];
  y3.push(i), i = "", e28.createErrors !== false ? (i += " { keyword: '" + (m3 || "_limitProperties") + "' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(c3) + " , params: { limit: " + r3 + " } ", e28.opts.messages !== false && (i += " , message: 'should NOT have ", i += t3 == "maxProperties" ? "more" : "fewer", i += " than ", i += d3 ? "' + " + r3 + " + '" : "" + o3, i += " properties' "), e28.opts.verbose && (i += " , schema:  ", i += d3 ? "validate.schema" + u3 : "" + o3, i += "         , parentSchema: validate.schema" + e28.schemaPath + " , data: " + p3 + " "), i += " } ") : i += " {} ";
  var v3 = i;
  return i = y3.pop(), !e28.compositeRule && f3 ? e28.async ? i += " throw new ValidationError([" + v3 + "]); " : i += " validate.errors = [" + v3 + "]; return false; " : i += " var err = " + v3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += "} ", f3 && (i += " else { "), i;
}, sb$1 = { $ref: function(e28, t3, n3) {
  var r3, i, a3 = " ", s3 = e28.level, o3 = e28.dataLevel, u3 = e28.schema[t3], c3 = e28.errSchemaPath + "/" + t3, f3 = !e28.opts.allErrors, p3 = "data" + (o3 || ""), d3 = "valid" + s3;
  if (u3 == "#" || u3 == "#/")
    e28.isRoot ? (r3 = e28.async, i = "validate") : (r3 = e28.root.schema.$async === true, i = "root.refVal[0]");
  else {
    var m3 = e28.resolveRef(e28.baseId, u3, e28.isRoot);
    if (m3 === void 0) {
      var y3 = e28.MissingRefError.message(e28.baseId, u3);
      if (e28.opts.missingRefs == "fail") {
        e28.logger.error(y3), (C3 = C3 || []).push(a3), a3 = "", e28.createErrors !== false ? (a3 += " { keyword: '$ref' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(c3) + " , params: { ref: '" + e28.util.escapeQuotes(u3) + "' } ", e28.opts.messages !== false && (a3 += " , message: 'can\\'t resolve reference " + e28.util.escapeQuotes(u3) + "' "), e28.opts.verbose && (a3 += " , schema: " + e28.util.toQuotedString(u3) + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + p3 + " "), a3 += " } ") : a3 += " {} ";
        var v3 = a3;
        a3 = C3.pop(), !e28.compositeRule && f3 ? e28.async ? a3 += " throw new ValidationError([" + v3 + "]); " : a3 += " validate.errors = [" + v3 + "]; return false; " : a3 += " var err = " + v3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", f3 && (a3 += " if (false) { ");
      } else {
        if (e28.opts.missingRefs != "ignore")
          throw new e28.MissingRefError(e28.baseId, u3, y3);
        e28.logger.warn(y3), f3 && (a3 += " if (true) { ");
      }
    } else if (m3.inline) {
      var b3 = e28.util.copy(e28);
      b3.level++;
      var x3 = "valid" + b3.level;
      b3.schema = m3.schema, b3.schemaPath = "", b3.errSchemaPath = u3, a3 += " " + e28.validate(b3).replace(/validate\.schema/g, m3.code) + " ", f3 && (a3 += " if (" + x3 + ") { ");
    } else
      r3 = m3.$async === true || e28.async && m3.$async !== false, i = m3.code;
  }
  if (i) {
    var C3;
    (C3 = C3 || []).push(a3), a3 = "", e28.opts.passContext ? a3 += " " + i + ".call(this, " : a3 += " " + i + "( ", a3 += " " + p3 + ", (dataPath || '')", e28.errorPath != '""' && (a3 += " + " + e28.errorPath);
    var k3 = a3 += " , " + (o3 ? "data" + (o3 - 1 || "") : "parentData") + " , " + (o3 ? e28.dataPathArr[o3] : "parentDataProperty") + ", rootData)  ";
    if (a3 = C3.pop(), r3) {
      if (!e28.async)
        throw new Error("async schema referenced by sync schema");
      f3 && (a3 += " var " + d3 + "; "), a3 += " try { await " + k3 + "; ", f3 && (a3 += " " + d3 + " = true; "), a3 += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ", f3 && (a3 += " " + d3 + " = false; "), a3 += " } ", f3 && (a3 += " if (" + d3 + ") { ");
    } else
      a3 += " if (!" + k3 + ") { if (vErrors === null) vErrors = " + i + ".errors; else vErrors = vErrors.concat(" + i + ".errors); errors = vErrors.length; } ", f3 && (a3 += " else { ");
  }
  return a3;
}, allOf: function(e28, t3, n3) {
  var r3 = " ", i = e28.schema[t3], a3 = e28.schemaPath + e28.util.getProperty(t3), s3 = e28.errSchemaPath + "/" + t3, o3 = !e28.opts.allErrors, u3 = e28.util.copy(e28), c3 = "";
  u3.level++;
  var f3 = "valid" + u3.level, p3 = u3.baseId, d3 = true, m3 = i;
  if (m3)
    for (var y3, v3 = -1, b3 = m3.length - 1; v3 < b3; )
      y3 = m3[v3 += 1], (e28.opts.strictKeywords ? xe$3(y3) == "object" && Object.keys(y3).length > 0 : e28.util.schemaHasRules(y3, e28.RULES.all)) && (d3 = false, u3.schema = y3, u3.schemaPath = a3 + "[" + v3 + "]", u3.errSchemaPath = s3 + "/" + v3, r3 += "  " + e28.validate(u3) + " ", u3.baseId = p3, o3 && (r3 += " if (" + f3 + ") { ", c3 += "}"));
  return o3 && (r3 += d3 ? " if (true) { " : " " + c3.slice(0, -1) + " "), r3 = e28.util.cleanUpCode(r3);
}, anyOf: function(e28, t3, n3) {
  var r3 = " ", i = e28.level, a3 = e28.dataLevel, s3 = e28.schema[t3], o3 = e28.schemaPath + e28.util.getProperty(t3), u3 = e28.errSchemaPath + "/" + t3, c3 = !e28.opts.allErrors, f3 = "data" + (a3 || ""), p3 = "valid" + i, d3 = "errs__" + i, m3 = e28.util.copy(e28), y3 = "";
  m3.level++;
  var v3 = "valid" + m3.level;
  if (s3.every(function(O3) {
    return e28.opts.strictKeywords ? xe$3(O3) == "object" && Object.keys(O3).length > 0 : e28.util.schemaHasRules(O3, e28.RULES.all);
  })) {
    var b3 = m3.baseId;
    r3 += " var " + d3 + " = errors; var " + p3 + " = false;  ";
    var x3 = e28.compositeRule;
    e28.compositeRule = m3.compositeRule = true;
    var C3 = s3;
    if (C3)
      for (var k3, F3 = -1, B3 = C3.length - 1; F3 < B3; )
        k3 = C3[F3 += 1], m3.schema = k3, m3.schemaPath = o3 + "[" + F3 + "]", m3.errSchemaPath = u3 + "/" + F3, r3 += "  " + e28.validate(m3) + " ", m3.baseId = b3, r3 += " " + p3 + " = " + p3 + " || " + v3 + "; if (!" + p3 + ") { ", y3 += "}";
    e28.compositeRule = m3.compositeRule = x3, r3 += " " + y3 + " if (!" + p3 + ") {   var err =   ", e28.createErrors !== false ? (r3 += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: {} ", e28.opts.messages !== false && (r3 += " , message: 'should match some schema in anyOf' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ", r3 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e28.compositeRule && c3 && (e28.async ? r3 += " throw new ValidationError(vErrors); " : r3 += " validate.errors = vErrors; return false; "), r3 += " } else {  errors = " + d3 + "; if (vErrors !== null) { if (" + d3 + ") vErrors.length = " + d3 + "; else vErrors = null; } ", e28.opts.allErrors && (r3 += " } "), r3 = e28.util.cleanUpCode(r3);
  } else
    c3 && (r3 += " if (true) { ");
  return r3;
}, $comment: function(e28, t3, n3) {
  var r3 = " ", i = e28.schema[t3], a3 = e28.errSchemaPath + "/" + t3, s3 = (e28.opts.allErrors, e28.util.toQuotedString(i));
  return e28.opts.$comment === true ? r3 += " console.log(" + s3 + ");" : typeof e28.opts.$comment == "function" && (r3 += " self._opts.$comment(" + s3 + ", " + e28.util.toQuotedString(a3) + ", validate.root.schema);"), r3;
}, const: function(e28, t3, n3) {
  var r3 = " ", i = e28.level, a3 = e28.dataLevel, s3 = e28.schema[t3], o3 = e28.schemaPath + e28.util.getProperty(t3), u3 = e28.errSchemaPath + "/" + t3, c3 = !e28.opts.allErrors, f3 = "data" + (a3 || ""), p3 = "valid" + i, d3 = e28.opts.$data && s3 && s3.$data;
  d3 && (r3 += " var schema" + i + " = " + e28.util.getData(s3.$data, a3, e28.dataPathArr) + "; "), d3 || (r3 += " var schema" + i + " = validate.schema" + o3 + ";"), r3 += "var " + p3 + " = equal(" + f3 + ", schema" + i + "); if (!" + p3 + ") {   ";
  var m3 = m3 || [];
  m3.push(r3), r3 = "", e28.createErrors !== false ? (r3 += " { keyword: 'const' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { allowedValue: schema" + i + " } ", e28.opts.messages !== false && (r3 += " , message: 'should be equal to constant' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ";
  var y3 = r3;
  return r3 = m3.pop(), !e28.compositeRule && c3 ? e28.async ? r3 += " throw new ValidationError([" + y3 + "]); " : r3 += " validate.errors = [" + y3 + "]; return false; " : r3 += " var err = " + y3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r3 += " }", c3 && (r3 += " else { "), r3;
}, contains: function(e28, t3, n3) {
  var r3 = " ", i = e28.level, a3 = e28.dataLevel, s3 = e28.schema[t3], o3 = e28.schemaPath + e28.util.getProperty(t3), u3 = e28.errSchemaPath + "/" + t3, c3 = !e28.opts.allErrors, f3 = "data" + (a3 || ""), p3 = "valid" + i, d3 = "errs__" + i, m3 = e28.util.copy(e28);
  m3.level++;
  var y3 = "valid" + m3.level, v3 = "i" + i, b3 = m3.dataLevel = e28.dataLevel + 1, x3 = "data" + b3, C3 = e28.baseId, k3 = e28.opts.strictKeywords ? xe$3(s3) == "object" && Object.keys(s3).length > 0 : e28.util.schemaHasRules(s3, e28.RULES.all);
  if (r3 += "var " + d3 + " = errors;var " + p3 + ";", k3) {
    var F3 = e28.compositeRule;
    e28.compositeRule = m3.compositeRule = true, m3.schema = s3, m3.schemaPath = o3, m3.errSchemaPath = u3, r3 += " var " + y3 + " = false; for (var " + v3 + " = 0; " + v3 + " < " + f3 + ".length; " + v3 + "++) { ", m3.errorPath = e28.util.getPathExpr(e28.errorPath, v3, e28.opts.jsonPointers, true);
    var B3 = f3 + "[" + v3 + "]";
    m3.dataPathArr[b3] = v3;
    var O3 = e28.validate(m3);
    m3.baseId = C3, e28.util.varOccurences(O3, x3) < 2 ? r3 += " " + e28.util.varReplace(O3, x3, B3) + " " : r3 += " var " + x3 + " = " + B3 + "; " + O3 + " ", r3 += " if (" + y3 + ") break; }  ", e28.compositeRule = m3.compositeRule = F3, r3 += "  if (!" + y3 + ") {";
  } else
    r3 += " if (" + f3 + ".length == 0) {";
  var S3 = S3 || [];
  S3.push(r3), r3 = "", e28.createErrors !== false ? (r3 += " { keyword: 'contains' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: {} ", e28.opts.messages !== false && (r3 += " , message: 'should contain a valid item' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ";
  var w3 = r3;
  return r3 = S3.pop(), !e28.compositeRule && c3 ? e28.async ? r3 += " throw new ValidationError([" + w3 + "]); " : r3 += " validate.errors = [" + w3 + "]; return false; " : r3 += " var err = " + w3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r3 += " } else { ", k3 && (r3 += "  errors = " + d3 + "; if (vErrors !== null) { if (" + d3 + ") vErrors.length = " + d3 + "; else vErrors = null; } "), e28.opts.allErrors && (r3 += " } "), r3 = e28.util.cleanUpCode(r3);
}, dependencies: function(e28, t3, n3) {
  var r3 = " ", i = e28.level, a3 = e28.dataLevel, s3 = e28.schema[t3], o3 = e28.schemaPath + e28.util.getProperty(t3), u3 = e28.errSchemaPath + "/" + t3, c3 = !e28.opts.allErrors, f3 = "data" + (a3 || ""), p3 = "errs__" + i, d3 = e28.util.copy(e28), m3 = "";
  d3.level++;
  var y3 = "valid" + d3.level, v3 = {}, b3 = {}, x3 = e28.opts.ownProperties;
  for (B3 in s3) {
    var C3 = s3[B3], k3 = Array.isArray(C3) ? b3 : v3;
    k3[B3] = C3;
  }
  r3 += "var " + p3 + " = errors;";
  var F3 = e28.errorPath;
  for (var B3 in r3 += "var missing" + i + ";", b3)
    if ((k3 = b3[B3]).length) {
      if (r3 += " if ( " + f3 + e28.util.getProperty(B3) + " !== undefined ", x3 && (r3 += " && Object.prototype.hasOwnProperty.call(" + f3 + ", '" + e28.util.escapeQuotes(B3) + "') "), c3) {
        r3 += " && ( ";
        var O3 = k3;
        if (O3)
          for (var S3 = -1, w3 = O3.length - 1; S3 < w3; )
            W3 = O3[S3 += 1], S3 && (r3 += " || "), r3 += " ( ( " + (X3 = f3 + (J3 = e28.util.getProperty(W3))) + " === undefined ", x3 && (r3 += " || ! Object.prototype.hasOwnProperty.call(" + f3 + ", '" + e28.util.escapeQuotes(W3) + "') "), r3 += ") && (missing" + i + " = " + e28.util.toQuotedString(e28.opts.jsonPointers ? W3 : J3) + ") ) ";
        r3 += ")) {  ";
        var D3 = "missing" + i, I3 = "' + " + D3 + " + '";
        e28.opts._errorDataPathProperty && (e28.errorPath = e28.opts.jsonPointers ? e28.util.getPathExpr(F3, D3, true) : F3 + " + " + D3);
        var L3 = L3 || [];
        L3.push(r3), r3 = "", e28.createErrors !== false ? (r3 += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { property: '" + e28.util.escapeQuotes(B3) + "', missingProperty: '" + I3 + "', depsCount: " + k3.length + ", deps: '" + e28.util.escapeQuotes(k3.length == 1 ? k3[0] : k3.join(", ")) + "' } ", e28.opts.messages !== false && (r3 += " , message: 'should have ", k3.length == 1 ? r3 += "property " + e28.util.escapeQuotes(k3[0]) : r3 += "properties " + e28.util.escapeQuotes(k3.join(", ")), r3 += " when property " + e28.util.escapeQuotes(B3) + " is present' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ";
        var V10 = r3;
        r3 = L3.pop(), !e28.compositeRule && c3 ? e28.async ? r3 += " throw new ValidationError([" + V10 + "]); " : r3 += " validate.errors = [" + V10 + "]; return false; " : r3 += " var err = " + V10 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      } else {
        r3 += " ) { ";
        var K3 = k3;
        if (K3)
          for (var W3, R3 = -1, q3 = K3.length - 1; R3 < q3; ) {
            W3 = K3[R3 += 1];
            var J3 = e28.util.getProperty(W3), X3 = (I3 = e28.util.escapeQuotes(W3), f3 + J3);
            e28.opts._errorDataPathProperty && (e28.errorPath = e28.util.getPath(F3, W3, e28.opts.jsonPointers)), r3 += " if ( " + X3 + " === undefined ", x3 && (r3 += " || ! Object.prototype.hasOwnProperty.call(" + f3 + ", '" + e28.util.escapeQuotes(W3) + "') "), r3 += ") {  var err =   ", e28.createErrors !== false ? (r3 += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { property: '" + e28.util.escapeQuotes(B3) + "', missingProperty: '" + I3 + "', depsCount: " + k3.length + ", deps: '" + e28.util.escapeQuotes(k3.length == 1 ? k3[0] : k3.join(", ")) + "' } ", e28.opts.messages !== false && (r3 += " , message: 'should have ", k3.length == 1 ? r3 += "property " + e28.util.escapeQuotes(k3[0]) : r3 += "properties " + e28.util.escapeQuotes(k3.join(", ")), r3 += " when property " + e28.util.escapeQuotes(B3) + " is present' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ", r3 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
          }
      }
      r3 += " }   ", c3 && (m3 += "}", r3 += " else { ");
    }
  e28.errorPath = F3;
  var ce2 = d3.baseId;
  for (var B3 in v3)
    C3 = v3[B3], (e28.opts.strictKeywords ? xe$3(C3) == "object" && Object.keys(C3).length > 0 : e28.util.schemaHasRules(C3, e28.RULES.all)) && (r3 += " " + y3 + " = true; if ( " + f3 + e28.util.getProperty(B3) + " !== undefined ", x3 && (r3 += " && Object.prototype.hasOwnProperty.call(" + f3 + ", '" + e28.util.escapeQuotes(B3) + "') "), r3 += ") { ", d3.schema = C3, d3.schemaPath = o3 + e28.util.getProperty(B3), d3.errSchemaPath = u3 + "/" + e28.util.escapeFragment(B3), r3 += "  " + e28.validate(d3) + " ", d3.baseId = ce2, r3 += " }  ", c3 && (r3 += " if (" + y3 + ") { ", m3 += "}"));
  return c3 && (r3 += "   " + m3 + " if (" + p3 + " == errors) {"), r3 = e28.util.cleanUpCode(r3);
}, enum: function(e28, t3, n3) {
  var r3 = " ", i = e28.level, a3 = e28.dataLevel, s3 = e28.schema[t3], o3 = e28.schemaPath + e28.util.getProperty(t3), u3 = e28.errSchemaPath + "/" + t3, c3 = !e28.opts.allErrors, f3 = "data" + (a3 || ""), p3 = "valid" + i, d3 = e28.opts.$data && s3 && s3.$data;
  d3 && (r3 += " var schema" + i + " = " + e28.util.getData(s3.$data, a3, e28.dataPathArr) + "; ");
  var m3 = "i" + i, y3 = "schema" + i;
  d3 || (r3 += " var " + y3 + " = validate.schema" + o3 + ";"), r3 += "var " + p3 + ";", d3 && (r3 += " if (schema" + i + " === undefined) " + p3 + " = true; else if (!Array.isArray(schema" + i + ")) " + p3 + " = false; else {"), r3 += p3 + " = false;for (var " + m3 + "=0; " + m3 + "<" + y3 + ".length; " + m3 + "++) if (equal(" + f3 + ", " + y3 + "[" + m3 + "])) { " + p3 + " = true; break; }", d3 && (r3 += "  }  "), r3 += " if (!" + p3 + ") {   ";
  var v3 = v3 || [];
  v3.push(r3), r3 = "", e28.createErrors !== false ? (r3 += " { keyword: 'enum' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { allowedValues: schema" + i + " } ", e28.opts.messages !== false && (r3 += " , message: 'should be equal to one of the allowed values' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ";
  var b3 = r3;
  return r3 = v3.pop(), !e28.compositeRule && c3 ? e28.async ? r3 += " throw new ValidationError([" + b3 + "]); " : r3 += " validate.errors = [" + b3 + "]; return false; " : r3 += " var err = " + b3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r3 += " }", c3 && (r3 += " else { "), r3;
}, format: function(e28, t3, n3) {
  var r3 = " ", i = e28.level, a3 = e28.dataLevel, s3 = e28.schema[t3], o3 = e28.schemaPath + e28.util.getProperty(t3), u3 = e28.errSchemaPath + "/" + t3, c3 = !e28.opts.allErrors, f3 = "data" + (a3 || "");
  if (e28.opts.format === false)
    return c3 && (r3 += " if (true) { "), r3;
  var p3, d3 = e28.opts.$data && s3 && s3.$data;
  d3 ? (r3 += " var schema" + i + " = " + e28.util.getData(s3.$data, a3, e28.dataPathArr) + "; ", p3 = "schema" + i) : p3 = s3;
  var m3 = e28.opts.unknownFormats, y3 = Array.isArray(m3);
  if (d3)
    r3 += " var " + (v3 = "format" + i) + " = formats[" + p3 + "]; var " + (b3 = "isObject" + i) + " = typeof " + v3 + " == 'object' && !(" + v3 + " instanceof RegExp) && " + v3 + ".validate; var " + (x3 = "formatType" + i) + " = " + b3 + " && " + v3 + ".type || 'string'; if (" + b3 + ") { ", e28.async && (r3 += " var async" + i + " = " + v3 + ".async; "), r3 += " " + v3 + " = " + v3 + ".validate; } if (  ", d3 && (r3 += " (" + p3 + " !== undefined && typeof " + p3 + " != 'string') || "), r3 += " (", m3 != "ignore" && (r3 += " (" + p3 + " && !" + v3 + " ", y3 && (r3 += " && self._opts.unknownFormats.indexOf(" + p3 + ") == -1 "), r3 += ") || "), r3 += " (" + v3 + " && " + x3 + " == '" + n3 + "' && !(typeof " + v3 + " == 'function' ? ", e28.async ? r3 += " (async" + i + " ? await " + v3 + "(" + f3 + ") : " + v3 + "(" + f3 + ")) " : r3 += " " + v3 + "(" + f3 + ") ", r3 += " : " + v3 + ".test(" + f3 + "))))) {";
  else {
    var v3;
    if (!(v3 = e28.formats[s3])) {
      if (m3 == "ignore")
        return e28.logger.warn('unknown format "' + s3 + '" ignored in schema at path "' + e28.errSchemaPath + '"'), c3 && (r3 += " if (true) { "), r3;
      if (y3 && m3.indexOf(s3) >= 0)
        return c3 && (r3 += " if (true) { "), r3;
      throw new Error('unknown format "' + s3 + '" is used in schema at path "' + e28.errSchemaPath + '"');
    }
    var b3, x3 = (b3 = xe$3(v3) == "object" && !(v3 instanceof RegExp) && v3.validate) && v3.type || "string";
    if (b3) {
      var C3 = v3.async === true;
      v3 = v3.validate;
    }
    if (x3 != n3)
      return c3 && (r3 += " if (true) { "), r3;
    if (C3) {
      if (!e28.async)
        throw new Error("async format in sync schema");
      r3 += " if (!(await " + (k3 = "formats" + e28.util.getProperty(s3) + ".validate") + "(" + f3 + "))) { ";
    } else {
      r3 += " if (! ";
      var k3 = "formats" + e28.util.getProperty(s3);
      b3 && (k3 += ".validate"), r3 += typeof v3 == "function" ? " " + k3 + "(" + f3 + ") " : " " + k3 + ".test(" + f3 + ") ", r3 += ") { ";
    }
  }
  var F3 = F3 || [];
  F3.push(r3), r3 = "", e28.createErrors !== false ? (r3 += " { keyword: 'format' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { format:  ", r3 += d3 ? "" + p3 : "" + e28.util.toQuotedString(s3), r3 += "  } ", e28.opts.messages !== false && (r3 += ` , message: 'should match format "`, r3 += d3 ? "' + " + p3 + " + '" : "" + e28.util.escapeQuotes(s3), r3 += `"' `), e28.opts.verbose && (r3 += " , schema:  ", r3 += d3 ? "validate.schema" + o3 : "" + e28.util.toQuotedString(s3), r3 += "         , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ";
  var B3 = r3;
  return r3 = F3.pop(), !e28.compositeRule && c3 ? e28.async ? r3 += " throw new ValidationError([" + B3 + "]); " : r3 += " validate.errors = [" + B3 + "]; return false; " : r3 += " var err = " + B3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r3 += " } ", c3 && (r3 += " else { "), r3;
}, if: function(e28, t3, n3) {
  var r3 = " ", i = e28.level, a3 = e28.dataLevel, s3 = e28.schema[t3], o3 = e28.schemaPath + e28.util.getProperty(t3), u3 = e28.errSchemaPath + "/" + t3, c3 = !e28.opts.allErrors, f3 = "data" + (a3 || ""), p3 = "valid" + i, d3 = "errs__" + i, m3 = e28.util.copy(e28);
  m3.level++;
  var y3 = "valid" + m3.level, v3 = e28.schema.then, b3 = e28.schema.else, x3 = v3 !== void 0 && (e28.opts.strictKeywords ? xe$3(v3) == "object" && Object.keys(v3).length > 0 : e28.util.schemaHasRules(v3, e28.RULES.all)), C3 = b3 !== void 0 && (e28.opts.strictKeywords ? xe$3(b3) == "object" && Object.keys(b3).length > 0 : e28.util.schemaHasRules(b3, e28.RULES.all)), k3 = m3.baseId;
  if (x3 || C3) {
    var F3;
    m3.createErrors = false, m3.schema = s3, m3.schemaPath = o3, m3.errSchemaPath = u3, r3 += " var " + d3 + " = errors; var " + p3 + " = true;  ";
    var B3 = e28.compositeRule;
    e28.compositeRule = m3.compositeRule = true, r3 += "  " + e28.validate(m3) + " ", m3.baseId = k3, m3.createErrors = true, r3 += "  errors = " + d3 + "; if (vErrors !== null) { if (" + d3 + ") vErrors.length = " + d3 + "; else vErrors = null; }  ", e28.compositeRule = m3.compositeRule = B3, x3 ? (r3 += " if (" + y3 + ") {  ", m3.schema = e28.schema.then, m3.schemaPath = e28.schemaPath + ".then", m3.errSchemaPath = e28.errSchemaPath + "/then", r3 += "  " + e28.validate(m3) + " ", m3.baseId = k3, r3 += " " + p3 + " = " + y3 + "; ", x3 && C3 ? r3 += " var " + (F3 = "ifClause" + i) + " = 'then'; " : F3 = "'then'", r3 += " } ", C3 && (r3 += " else { ")) : r3 += " if (!" + y3 + ") { ", C3 && (m3.schema = e28.schema.else, m3.schemaPath = e28.schemaPath + ".else", m3.errSchemaPath = e28.errSchemaPath + "/else", r3 += "  " + e28.validate(m3) + " ", m3.baseId = k3, r3 += " " + p3 + " = " + y3 + "; ", x3 && C3 ? r3 += " var " + (F3 = "ifClause" + i) + " = 'else'; " : F3 = "'else'", r3 += " } "), r3 += " if (!" + p3 + ") {   var err =   ", e28.createErrors !== false ? (r3 += " { keyword: 'if' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { failingKeyword: " + F3 + " } ", e28.opts.messages !== false && (r3 += ` , message: 'should match "' + ` + F3 + ` + '" schema' `), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ", r3 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e28.compositeRule && c3 && (e28.async ? r3 += " throw new ValidationError(vErrors); " : r3 += " validate.errors = vErrors; return false; "), r3 += " }   ", c3 && (r3 += " else { "), r3 = e28.util.cleanUpCode(r3);
  } else
    c3 && (r3 += " if (true) { ");
  return r3;
}, items: function(e28, t3, n3) {
  var r3 = " ", i = e28.level, a3 = e28.dataLevel, s3 = e28.schema[t3], o3 = e28.schemaPath + e28.util.getProperty(t3), u3 = e28.errSchemaPath + "/" + t3, c3 = !e28.opts.allErrors, f3 = "data" + (a3 || ""), p3 = "valid" + i, d3 = "errs__" + i, m3 = e28.util.copy(e28), y3 = "";
  m3.level++;
  var v3 = "valid" + m3.level, b3 = "i" + i, x3 = m3.dataLevel = e28.dataLevel + 1, C3 = "data" + x3, k3 = e28.baseId;
  if (r3 += "var " + d3 + " = errors;var " + p3 + ";", Array.isArray(s3)) {
    var F3 = e28.schema.additionalItems;
    if (F3 === false) {
      r3 += " " + p3 + " = " + f3 + ".length <= " + s3.length + "; ";
      var B3 = u3;
      u3 = e28.errSchemaPath + "/additionalItems", r3 += "  if (!" + p3 + ") {   ";
      var O3 = O3 || [];
      O3.push(r3), r3 = "", e28.createErrors !== false ? (r3 += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { limit: " + s3.length + " } ", e28.opts.messages !== false && (r3 += " , message: 'should NOT have more than " + s3.length + " items' "), e28.opts.verbose && (r3 += " , schema: false , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ";
      var S3 = r3;
      r3 = O3.pop(), !e28.compositeRule && c3 ? e28.async ? r3 += " throw new ValidationError([" + S3 + "]); " : r3 += " validate.errors = [" + S3 + "]; return false; " : r3 += " var err = " + S3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r3 += " } ", u3 = B3, c3 && (y3 += "}", r3 += " else { ");
    }
    var w3 = s3;
    if (w3) {
      for (var D3, I3 = -1, L3 = w3.length - 1; I3 < L3; )
        if (D3 = w3[I3 += 1], e28.opts.strictKeywords ? xe$3(D3) == "object" && Object.keys(D3).length > 0 : e28.util.schemaHasRules(D3, e28.RULES.all)) {
          r3 += " " + v3 + " = true; if (" + f3 + ".length > " + I3 + ") { ";
          var V10 = f3 + "[" + I3 + "]";
          m3.schema = D3, m3.schemaPath = o3 + "[" + I3 + "]", m3.errSchemaPath = u3 + "/" + I3, m3.errorPath = e28.util.getPathExpr(e28.errorPath, I3, e28.opts.jsonPointers, true), m3.dataPathArr[x3] = I3;
          var K3 = e28.validate(m3);
          m3.baseId = k3, e28.util.varOccurences(K3, C3) < 2 ? r3 += " " + e28.util.varReplace(K3, C3, V10) + " " : r3 += " var " + C3 + " = " + V10 + "; " + K3 + " ", r3 += " }  ", c3 && (r3 += " if (" + v3 + ") { ", y3 += "}");
        }
    }
    xe$3(F3) == "object" && (e28.opts.strictKeywords ? xe$3(F3) == "object" && Object.keys(F3).length > 0 : e28.util.schemaHasRules(F3, e28.RULES.all)) && (m3.schema = F3, m3.schemaPath = e28.schemaPath + ".additionalItems", m3.errSchemaPath = e28.errSchemaPath + "/additionalItems", r3 += " " + v3 + " = true; if (" + f3 + ".length > " + s3.length + ") {  for (var " + b3 + " = " + s3.length + "; " + b3 + " < " + f3 + ".length; " + b3 + "++) { ", m3.errorPath = e28.util.getPathExpr(e28.errorPath, b3, e28.opts.jsonPointers, true), V10 = f3 + "[" + b3 + "]", m3.dataPathArr[x3] = b3, K3 = e28.validate(m3), m3.baseId = k3, e28.util.varOccurences(K3, C3) < 2 ? r3 += " " + e28.util.varReplace(K3, C3, V10) + " " : r3 += " var " + C3 + " = " + V10 + "; " + K3 + " ", c3 && (r3 += " if (!" + v3 + ") break; "), r3 += " } }  ", c3 && (r3 += " if (" + v3 + ") { ", y3 += "}"));
  } else
    (e28.opts.strictKeywords ? xe$3(s3) == "object" && Object.keys(s3).length > 0 : e28.util.schemaHasRules(s3, e28.RULES.all)) && (m3.schema = s3, m3.schemaPath = o3, m3.errSchemaPath = u3, r3 += "  for (var " + b3 + " = 0; " + b3 + " < " + f3 + ".length; " + b3 + "++) { ", m3.errorPath = e28.util.getPathExpr(e28.errorPath, b3, e28.opts.jsonPointers, true), V10 = f3 + "[" + b3 + "]", m3.dataPathArr[x3] = b3, K3 = e28.validate(m3), m3.baseId = k3, e28.util.varOccurences(K3, C3) < 2 ? r3 += " " + e28.util.varReplace(K3, C3, V10) + " " : r3 += " var " + C3 + " = " + V10 + "; " + K3 + " ", c3 && (r3 += " if (!" + v3 + ") break; "), r3 += " }");
  return c3 && (r3 += " " + y3 + " if (" + d3 + " == errors) {"), r3 = e28.util.cleanUpCode(r3);
}, maximum: rb, minimum: rb, maxItems: ib$1, minItems: ib$1, maxLength: ab$1, minLength: ab$1, maxProperties: ob$1, minProperties: ob$1, multipleOf: function(e28, t3, n3) {
  var r3, i = " ", a3 = e28.level, s3 = e28.dataLevel, o3 = e28.schema[t3], u3 = e28.schemaPath + e28.util.getProperty(t3), c3 = e28.errSchemaPath + "/" + t3, f3 = !e28.opts.allErrors, p3 = "data" + (s3 || ""), d3 = e28.opts.$data && o3 && o3.$data;
  d3 ? (i += " var schema" + a3 + " = " + e28.util.getData(o3.$data, s3, e28.dataPathArr) + "; ", r3 = "schema" + a3) : r3 = o3, i += "var division" + a3 + ";if (", d3 && (i += " " + r3 + " !== undefined && ( typeof " + r3 + " != 'number' || "), i += " (division" + a3 + " = " + p3 + " / " + r3 + ", ", e28.opts.multipleOfPrecision ? i += " Math.abs(Math.round(division" + a3 + ") - division" + a3 + ") > 1e-" + e28.opts.multipleOfPrecision + " " : i += " division" + a3 + " !== parseInt(division" + a3 + ") ", i += " ) ", d3 && (i += "  )  "), i += " ) {   ";
  var m3 = m3 || [];
  m3.push(i), i = "", e28.createErrors !== false ? (i += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(c3) + " , params: { multipleOf: " + r3 + " } ", e28.opts.messages !== false && (i += " , message: 'should be multiple of ", i += d3 ? "' + " + r3 : r3 + "'"), e28.opts.verbose && (i += " , schema:  ", i += d3 ? "validate.schema" + u3 : "" + o3, i += "         , parentSchema: validate.schema" + e28.schemaPath + " , data: " + p3 + " "), i += " } ") : i += " {} ";
  var y3 = i;
  return i = m3.pop(), !e28.compositeRule && f3 ? e28.async ? i += " throw new ValidationError([" + y3 + "]); " : i += " validate.errors = [" + y3 + "]; return false; " : i += " var err = " + y3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += "} ", f3 && (i += " else { "), i;
}, not: function(e28, t3, n3) {
  var r3 = " ", i = e28.level, a3 = e28.dataLevel, s3 = e28.schema[t3], o3 = e28.schemaPath + e28.util.getProperty(t3), u3 = e28.errSchemaPath + "/" + t3, c3 = !e28.opts.allErrors, f3 = "data" + (a3 || ""), p3 = "errs__" + i, d3 = e28.util.copy(e28);
  d3.level++;
  var m3 = "valid" + d3.level;
  if (e28.opts.strictKeywords ? xe$3(s3) == "object" && Object.keys(s3).length > 0 : e28.util.schemaHasRules(s3, e28.RULES.all)) {
    d3.schema = s3, d3.schemaPath = o3, d3.errSchemaPath = u3, r3 += " var " + p3 + " = errors;  ";
    var y3, v3 = e28.compositeRule;
    e28.compositeRule = d3.compositeRule = true, d3.createErrors = false, d3.opts.allErrors && (y3 = d3.opts.allErrors, d3.opts.allErrors = false), r3 += " " + e28.validate(d3) + " ", d3.createErrors = true, y3 && (d3.opts.allErrors = y3), e28.compositeRule = d3.compositeRule = v3, r3 += " if (" + m3 + ") {   ";
    var b3 = b3 || [];
    b3.push(r3), r3 = "", e28.createErrors !== false ? (r3 += " { keyword: 'not' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: {} ", e28.opts.messages !== false && (r3 += " , message: 'should NOT be valid' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ";
    var x3 = r3;
    r3 = b3.pop(), !e28.compositeRule && c3 ? e28.async ? r3 += " throw new ValidationError([" + x3 + "]); " : r3 += " validate.errors = [" + x3 + "]; return false; " : r3 += " var err = " + x3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r3 += " } else {  errors = " + p3 + "; if (vErrors !== null) { if (" + p3 + ") vErrors.length = " + p3 + "; else vErrors = null; } ", e28.opts.allErrors && (r3 += " } ");
  } else
    r3 += "  var err =   ", e28.createErrors !== false ? (r3 += " { keyword: 'not' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: {} ", e28.opts.messages !== false && (r3 += " , message: 'should NOT be valid' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ", r3 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c3 && (r3 += " if (false) { ");
  return r3;
}, oneOf: function(e28, t3, n3) {
  var r3 = " ", i = e28.level, a3 = e28.dataLevel, s3 = e28.schema[t3], o3 = e28.schemaPath + e28.util.getProperty(t3), u3 = e28.errSchemaPath + "/" + t3, c3 = !e28.opts.allErrors, f3 = "data" + (a3 || ""), p3 = "valid" + i, d3 = "errs__" + i, m3 = e28.util.copy(e28), y3 = "";
  m3.level++;
  var v3 = "valid" + m3.level, b3 = m3.baseId, x3 = "prevValid" + i, C3 = "passingSchemas" + i;
  r3 += "var " + d3 + " = errors , " + x3 + " = false , " + p3 + " = false , " + C3 + " = null; ";
  var k3 = e28.compositeRule;
  e28.compositeRule = m3.compositeRule = true;
  var F3 = s3;
  if (F3)
    for (var B3, O3 = -1, S3 = F3.length - 1; O3 < S3; )
      B3 = F3[O3 += 1], (e28.opts.strictKeywords ? xe$3(B3) == "object" && Object.keys(B3).length > 0 : e28.util.schemaHasRules(B3, e28.RULES.all)) ? (m3.schema = B3, m3.schemaPath = o3 + "[" + O3 + "]", m3.errSchemaPath = u3 + "/" + O3, r3 += "  " + e28.validate(m3) + " ", m3.baseId = b3) : r3 += " var " + v3 + " = true; ", O3 && (r3 += " if (" + v3 + " && " + x3 + ") { " + p3 + " = false; " + C3 + " = [" + C3 + ", " + O3 + "]; } else { ", y3 += "}"), r3 += " if (" + v3 + ") { " + p3 + " = " + x3 + " = true; " + C3 + " = " + O3 + "; }";
  return e28.compositeRule = m3.compositeRule = k3, r3 += y3 + "if (!" + p3 + ") {   var err =   ", e28.createErrors !== false ? (r3 += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { passingSchemas: " + C3 + " } ", e28.opts.messages !== false && (r3 += " , message: 'should match exactly one schema in oneOf' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ", r3 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e28.compositeRule && c3 && (e28.async ? r3 += " throw new ValidationError(vErrors); " : r3 += " validate.errors = vErrors; return false; "), r3 += "} else {  errors = " + d3 + "; if (vErrors !== null) { if (" + d3 + ") vErrors.length = " + d3 + "; else vErrors = null; }", e28.opts.allErrors && (r3 += " } "), r3;
}, pattern: function(e28, t3, n3) {
  var r3, i = " ", a3 = e28.level, s3 = e28.dataLevel, o3 = e28.schema[t3], u3 = e28.schemaPath + e28.util.getProperty(t3), c3 = e28.errSchemaPath + "/" + t3, f3 = !e28.opts.allErrors, p3 = "data" + (s3 || ""), d3 = e28.opts.$data && o3 && o3.$data;
  d3 ? (i += " var schema" + a3 + " = " + e28.util.getData(o3.$data, s3, e28.dataPathArr) + "; ", r3 = "schema" + a3) : r3 = o3, i += "if ( ", d3 && (i += " (" + r3 + " !== undefined && typeof " + r3 + " != 'string') || "), i += " !" + (d3 ? "(new RegExp(" + r3 + "))" : e28.usePattern(o3)) + ".test(" + p3 + ") ) {   ";
  var m3 = m3 || [];
  m3.push(i), i = "", e28.createErrors !== false ? (i += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(c3) + " , params: { pattern:  ", i += d3 ? "" + r3 : "" + e28.util.toQuotedString(o3), i += "  } ", e28.opts.messages !== false && (i += ` , message: 'should match pattern "`, i += d3 ? "' + " + r3 + " + '" : "" + e28.util.escapeQuotes(o3), i += `"' `), e28.opts.verbose && (i += " , schema:  ", i += d3 ? "validate.schema" + u3 : "" + e28.util.toQuotedString(o3), i += "         , parentSchema: validate.schema" + e28.schemaPath + " , data: " + p3 + " "), i += " } ") : i += " {} ";
  var y3 = i;
  return i = m3.pop(), !e28.compositeRule && f3 ? e28.async ? i += " throw new ValidationError([" + y3 + "]); " : i += " validate.errors = [" + y3 + "]; return false; " : i += " var err = " + y3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += "} ", f3 && (i += " else { "), i;
}, properties: function(e28, t3, n3) {
  var r3 = " ", i = e28.level, a3 = e28.dataLevel, s3 = e28.schema[t3], o3 = e28.schemaPath + e28.util.getProperty(t3), u3 = e28.errSchemaPath + "/" + t3, c3 = !e28.opts.allErrors, f3 = "data" + (a3 || ""), p3 = "errs__" + i, d3 = e28.util.copy(e28), m3 = "";
  d3.level++;
  var y3 = "valid" + d3.level, v3 = "key" + i, b3 = "idx" + i, x3 = d3.dataLevel = e28.dataLevel + 1, C3 = "data" + x3, k3 = "dataProperties" + i, F3 = Object.keys(s3 || {}), B3 = e28.schema.patternProperties || {}, O3 = Object.keys(B3), S3 = e28.schema.additionalProperties, w3 = F3.length || O3.length, D3 = S3 === false, I3 = xe$3(S3) == "object" && Object.keys(S3).length, L3 = e28.opts.removeAdditional, V10 = D3 || I3 || L3, K3 = e28.opts.ownProperties, W3 = e28.baseId, R3 = e28.schema.required;
  if (R3 && (!e28.opts.$data || !R3.$data) && R3.length < e28.opts.loopRequired)
    var q3 = e28.util.toHash(R3);
  if (r3 += "var " + p3 + " = errors;var " + y3 + " = true;", K3 && (r3 += " var " + k3 + " = undefined;"), V10) {
    if (r3 += K3 ? " " + k3 + " = " + k3 + " || Object.keys(" + f3 + "); for (var " + b3 + "=0; " + b3 + "<" + k3 + ".length; " + b3 + "++) { var " + v3 + " = " + k3 + "[" + b3 + "]; " : " for (var " + v3 + " in " + f3 + ") { ", w3) {
      if (r3 += " var isAdditional" + i + " = !(false ", F3.length)
        if (F3.length > 8)
          r3 += " || validate.schema" + o3 + ".hasOwnProperty(" + v3 + ") ";
        else {
          var J3 = F3;
          if (J3)
            for (var X3 = -1, ce2 = J3.length - 1; X3 < ce2; )
              Q3 = J3[X3 += 1], r3 += " || " + v3 + " == " + e28.util.toQuotedString(Q3) + " ";
        }
      if (O3.length) {
        var A3 = O3;
        if (A3)
          for (var M3 = -1, ne2 = A3.length - 1; M3 < ne2; )
            Kt2 = A3[M3 += 1], r3 += " || " + e28.usePattern(Kt2) + ".test(" + v3 + ") ";
      }
      r3 += " ); if (isAdditional" + i + ") { ";
    }
    if (L3 == "all")
      r3 += " delete " + f3 + "[" + v3 + "]; ";
    else {
      var de2 = e28.errorPath, he2 = "' + " + v3 + " + '";
      if (e28.opts._errorDataPathProperty && (e28.errorPath = e28.util.getPathExpr(e28.errorPath, v3, e28.opts.jsonPointers)), D3)
        if (L3)
          r3 += " delete " + f3 + "[" + v3 + "]; ";
        else {
          r3 += " " + y3 + " = false; ";
          var j3 = u3;
          u3 = e28.errSchemaPath + "/additionalProperties", (Oe2 = Oe2 || []).push(r3), r3 = "", e28.createErrors !== false ? (r3 += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { additionalProperty: '" + he2 + "' } ", e28.opts.messages !== false && (r3 += " , message: '", e28.opts._errorDataPathProperty ? r3 += "is an invalid additional property" : r3 += "should NOT have additional properties", r3 += "' "), e28.opts.verbose && (r3 += " , schema: false , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ";
          var ie2 = r3;
          r3 = Oe2.pop(), !e28.compositeRule && c3 ? e28.async ? r3 += " throw new ValidationError([" + ie2 + "]); " : r3 += " validate.errors = [" + ie2 + "]; return false; " : r3 += " var err = " + ie2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", u3 = j3, c3 && (r3 += " break; ");
        }
      else if (I3)
        if (L3 == "failing") {
          r3 += " var " + p3 + " = errors;  ";
          var fe2 = e28.compositeRule;
          e28.compositeRule = d3.compositeRule = true, d3.schema = S3, d3.schemaPath = e28.schemaPath + ".additionalProperties", d3.errSchemaPath = e28.errSchemaPath + "/additionalProperties", d3.errorPath = e28.opts._errorDataPathProperty ? e28.errorPath : e28.util.getPathExpr(e28.errorPath, v3, e28.opts.jsonPointers);
          var ge2 = f3 + "[" + v3 + "]";
          d3.dataPathArr[x3] = v3;
          var Fe2 = e28.validate(d3);
          d3.baseId = W3, e28.util.varOccurences(Fe2, C3) < 2 ? r3 += " " + e28.util.varReplace(Fe2, C3, ge2) + " " : r3 += " var " + C3 + " = " + ge2 + "; " + Fe2 + " ", r3 += " if (!" + y3 + ") { errors = " + p3 + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + f3 + "[" + v3 + "]; }  ", e28.compositeRule = d3.compositeRule = fe2;
        } else
          d3.schema = S3, d3.schemaPath = e28.schemaPath + ".additionalProperties", d3.errSchemaPath = e28.errSchemaPath + "/additionalProperties", d3.errorPath = e28.opts._errorDataPathProperty ? e28.errorPath : e28.util.getPathExpr(e28.errorPath, v3, e28.opts.jsonPointers), ge2 = f3 + "[" + v3 + "]", d3.dataPathArr[x3] = v3, Fe2 = e28.validate(d3), d3.baseId = W3, e28.util.varOccurences(Fe2, C3) < 2 ? r3 += " " + e28.util.varReplace(Fe2, C3, ge2) + " " : r3 += " var " + C3 + " = " + ge2 + "; " + Fe2 + " ", c3 && (r3 += " if (!" + y3 + ") break; ");
      e28.errorPath = de2;
    }
    w3 && (r3 += " } "), r3 += " }  ", c3 && (r3 += " if (" + y3 + ") { ", m3 += "}");
  }
  var Pe2 = e28.opts.useDefaults && !e28.compositeRule;
  if (F3.length) {
    var _3 = F3;
    if (_3)
      for (var Q3, Y3 = -1, ae2 = _3.length - 1; Y3 < ae2; ) {
        var ue2 = s3[Q3 = _3[Y3 += 1]];
        if (e28.opts.strictKeywords ? xe$3(ue2) == "object" && Object.keys(ue2).length > 0 : e28.util.schemaHasRules(ue2, e28.RULES.all)) {
          var De2 = e28.util.getProperty(Q3), Ee2 = (ge2 = f3 + De2, Pe2 && ue2.default !== void 0);
          if (d3.schema = ue2, d3.schemaPath = o3 + De2, d3.errSchemaPath = u3 + "/" + e28.util.escapeFragment(Q3), d3.errorPath = e28.util.getPath(e28.errorPath, Q3, e28.opts.jsonPointers), d3.dataPathArr[x3] = e28.util.toQuotedString(Q3), Fe2 = e28.validate(d3), d3.baseId = W3, e28.util.varOccurences(Fe2, C3) < 2) {
            Fe2 = e28.util.varReplace(Fe2, C3, ge2);
            var _e2 = ge2;
          } else
            _e2 = C3, r3 += " var " + C3 + " = " + ge2 + "; ";
          if (Ee2)
            r3 += " " + Fe2 + " ";
          else {
            if (q3 && q3[Q3]) {
              r3 += " if ( " + _e2 + " === undefined ", K3 && (r3 += " || ! Object.prototype.hasOwnProperty.call(" + f3 + ", '" + e28.util.escapeQuotes(Q3) + "') "), r3 += ") { " + y3 + " = false; ", de2 = e28.errorPath, j3 = u3;
              var Oe2, Ye2 = e28.util.escapeQuotes(Q3);
              e28.opts._errorDataPathProperty && (e28.errorPath = e28.util.getPath(de2, Q3, e28.opts.jsonPointers)), u3 = e28.errSchemaPath + "/required", (Oe2 = Oe2 || []).push(r3), r3 = "", e28.createErrors !== false ? (r3 += " { keyword: 'required' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { missingProperty: '" + Ye2 + "' } ", e28.opts.messages !== false && (r3 += " , message: '", e28.opts._errorDataPathProperty ? r3 += "is a required property" : r3 += "should have required property \\'" + Ye2 + "\\'", r3 += "' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ", ie2 = r3, r3 = Oe2.pop(), !e28.compositeRule && c3 ? e28.async ? r3 += " throw new ValidationError([" + ie2 + "]); " : r3 += " validate.errors = [" + ie2 + "]; return false; " : r3 += " var err = " + ie2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", u3 = j3, e28.errorPath = de2, r3 += " } else { ";
            } else
              c3 ? (r3 += " if ( " + _e2 + " === undefined ", K3 && (r3 += " || ! Object.prototype.hasOwnProperty.call(" + f3 + ", '" + e28.util.escapeQuotes(Q3) + "') "), r3 += ") { " + y3 + " = true; } else { ") : (r3 += " if (" + _e2 + " !== undefined ", K3 && (r3 += " &&   Object.prototype.hasOwnProperty.call(" + f3 + ", '" + e28.util.escapeQuotes(Q3) + "') "), r3 += " ) { ");
            r3 += " " + Fe2 + " } ";
          }
        }
        c3 && (r3 += " if (" + y3 + ") { ", m3 += "}");
      }
  }
  if (O3.length) {
    var _t2 = O3;
    if (_t2)
      for (var Kt2, Jt2 = -1, zt2 = _t2.length - 1; Jt2 < zt2; )
        ue2 = B3[Kt2 = _t2[Jt2 += 1]], (e28.opts.strictKeywords ? xe$3(ue2) == "object" && Object.keys(ue2).length > 0 : e28.util.schemaHasRules(ue2, e28.RULES.all)) && (d3.schema = ue2, d3.schemaPath = e28.schemaPath + ".patternProperties" + e28.util.getProperty(Kt2), d3.errSchemaPath = e28.errSchemaPath + "/patternProperties/" + e28.util.escapeFragment(Kt2), r3 += K3 ? " " + k3 + " = " + k3 + " || Object.keys(" + f3 + "); for (var " + b3 + "=0; " + b3 + "<" + k3 + ".length; " + b3 + "++) { var " + v3 + " = " + k3 + "[" + b3 + "]; " : " for (var " + v3 + " in " + f3 + ") { ", r3 += " if (" + e28.usePattern(Kt2) + ".test(" + v3 + ")) { ", d3.errorPath = e28.util.getPathExpr(e28.errorPath, v3, e28.opts.jsonPointers), ge2 = f3 + "[" + v3 + "]", d3.dataPathArr[x3] = v3, Fe2 = e28.validate(d3), d3.baseId = W3, e28.util.varOccurences(Fe2, C3) < 2 ? r3 += " " + e28.util.varReplace(Fe2, C3, ge2) + " " : r3 += " var " + C3 + " = " + ge2 + "; " + Fe2 + " ", c3 && (r3 += " if (!" + y3 + ") break; "), r3 += " } ", c3 && (r3 += " else " + y3 + " = true; "), r3 += " }  ", c3 && (r3 += " if (" + y3 + ") { ", m3 += "}"));
  }
  return c3 && (r3 += " " + m3 + " if (" + p3 + " == errors) {"), r3 = e28.util.cleanUpCode(r3);
}, propertyNames: function(e28, t3, n3) {
  var r3 = " ", i = e28.level, a3 = e28.dataLevel, s3 = e28.schema[t3], o3 = e28.schemaPath + e28.util.getProperty(t3), u3 = e28.errSchemaPath + "/" + t3, c3 = !e28.opts.allErrors, f3 = "data" + (a3 || ""), p3 = "errs__" + i, d3 = e28.util.copy(e28);
  d3.level++;
  var m3 = "valid" + d3.level;
  if (r3 += "var " + p3 + " = errors;", e28.opts.strictKeywords ? xe$3(s3) == "object" && Object.keys(s3).length > 0 : e28.util.schemaHasRules(s3, e28.RULES.all)) {
    d3.schema = s3, d3.schemaPath = o3, d3.errSchemaPath = u3;
    var y3 = "key" + i, v3 = "idx" + i, b3 = "i" + i, x3 = "' + " + y3 + " + '", C3 = "data" + (d3.dataLevel = e28.dataLevel + 1), k3 = "dataProperties" + i, F3 = e28.opts.ownProperties, B3 = e28.baseId;
    F3 && (r3 += " var " + k3 + " = undefined; "), r3 += F3 ? " " + k3 + " = " + k3 + " || Object.keys(" + f3 + "); for (var " + v3 + "=0; " + v3 + "<" + k3 + ".length; " + v3 + "++) { var " + y3 + " = " + k3 + "[" + v3 + "]; " : " for (var " + y3 + " in " + f3 + ") { ", r3 += " var startErrs" + i + " = errors; ";
    var O3 = y3, S3 = e28.compositeRule;
    e28.compositeRule = d3.compositeRule = true;
    var w3 = e28.validate(d3);
    d3.baseId = B3, e28.util.varOccurences(w3, C3) < 2 ? r3 += " " + e28.util.varReplace(w3, C3, O3) + " " : r3 += " var " + C3 + " = " + O3 + "; " + w3 + " ", e28.compositeRule = d3.compositeRule = S3, r3 += " if (!" + m3 + ") { for (var " + b3 + "=startErrs" + i + "; " + b3 + "<errors; " + b3 + "++) { vErrors[" + b3 + "].propertyName = " + y3 + "; }   var err =   ", e28.createErrors !== false ? (r3 += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { propertyName: '" + x3 + "' } ", e28.opts.messages !== false && (r3 += " , message: 'property name \\'" + x3 + "\\' is invalid' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ", r3 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e28.compositeRule && c3 && (e28.async ? r3 += " throw new ValidationError(vErrors); " : r3 += " validate.errors = vErrors; return false; "), c3 && (r3 += " break; "), r3 += " } }";
  }
  return c3 && (r3 += "  if (" + p3 + " == errors) {"), r3 = e28.util.cleanUpCode(r3);
}, required: function(e28, t3, n3) {
  var r3 = " ", i = e28.level, a3 = e28.dataLevel, s3 = e28.schema[t3], o3 = e28.schemaPath + e28.util.getProperty(t3), u3 = e28.errSchemaPath + "/" + t3, c3 = !e28.opts.allErrors, f3 = "data" + (a3 || ""), p3 = "valid" + i, d3 = e28.opts.$data && s3 && s3.$data;
  d3 && (r3 += " var schema" + i + " = " + e28.util.getData(s3.$data, a3, e28.dataPathArr) + "; ");
  var m3 = "schema" + i;
  if (!d3)
    if (s3.length < e28.opts.loopRequired && e28.schema.properties && Object.keys(e28.schema.properties).length) {
      var y3 = [], v3 = s3;
      if (v3)
        for (var b3, x3 = -1, C3 = v3.length - 1; x3 < C3; ) {
          b3 = v3[x3 += 1];
          var k3 = e28.schema.properties[b3];
          k3 && (e28.opts.strictKeywords ? xe$3(k3) == "object" && Object.keys(k3).length > 0 : e28.util.schemaHasRules(k3, e28.RULES.all)) || (y3[y3.length] = b3);
        }
    } else
      y3 = s3;
  if (d3 || y3.length) {
    var F3 = e28.errorPath, B3 = d3 || y3.length >= e28.opts.loopRequired, O3 = e28.opts.ownProperties;
    if (c3)
      if (r3 += " var missing" + i + "; ", B3) {
        d3 || (r3 += " var " + m3 + " = validate.schema" + o3 + "; ");
        var S3 = "' + " + (K3 = "schema" + i + "[" + (I3 = "i" + i) + "]") + " + '";
        e28.opts._errorDataPathProperty && (e28.errorPath = e28.util.getPathExpr(F3, K3, e28.opts.jsonPointers)), r3 += " var " + p3 + " = true; ", d3 && (r3 += " if (schema" + i + " === undefined) " + p3 + " = true; else if (!Array.isArray(schema" + i + ")) " + p3 + " = false; else {"), r3 += " for (var " + I3 + " = 0; " + I3 + " < " + m3 + ".length; " + I3 + "++) { " + p3 + " = " + f3 + "[" + m3 + "[" + I3 + "]] !== undefined ", O3 && (r3 += " &&   Object.prototype.hasOwnProperty.call(" + f3 + ", " + m3 + "[" + I3 + "]) "), r3 += "; if (!" + p3 + ") break; } ", d3 && (r3 += "  }  "), r3 += "  if (!" + p3 + ") {   ", (V10 = V10 || []).push(r3), r3 = "", e28.createErrors !== false ? (r3 += " { keyword: 'required' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { missingProperty: '" + S3 + "' } ", e28.opts.messages !== false && (r3 += " , message: '", e28.opts._errorDataPathProperty ? r3 += "is a required property" : r3 += "should have required property \\'" + S3 + "\\'", r3 += "' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ";
        var w3 = r3;
        r3 = V10.pop(), !e28.compositeRule && c3 ? e28.async ? r3 += " throw new ValidationError([" + w3 + "]); " : r3 += " validate.errors = [" + w3 + "]; return false; " : r3 += " var err = " + w3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r3 += " } else { ";
      } else {
        r3 += " if ( ";
        var D3 = y3;
        if (D3)
          for (var I3 = -1, L3 = D3.length - 1; I3 < L3; )
            R3 = D3[I3 += 1], I3 && (r3 += " || "), r3 += " ( ( " + (ce2 = f3 + (X3 = e28.util.getProperty(R3))) + " === undefined ", O3 && (r3 += " || ! Object.prototype.hasOwnProperty.call(" + f3 + ", '" + e28.util.escapeQuotes(R3) + "') "), r3 += ") && (missing" + i + " = " + e28.util.toQuotedString(e28.opts.jsonPointers ? R3 : X3) + ") ) ";
        r3 += ") {  ";
        var V10;
        S3 = "' + " + (K3 = "missing" + i) + " + '", e28.opts._errorDataPathProperty && (e28.errorPath = e28.opts.jsonPointers ? e28.util.getPathExpr(F3, K3, true) : F3 + " + " + K3), (V10 = V10 || []).push(r3), r3 = "", e28.createErrors !== false ? (r3 += " { keyword: 'required' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { missingProperty: '" + S3 + "' } ", e28.opts.messages !== false && (r3 += " , message: '", e28.opts._errorDataPathProperty ? r3 += "is a required property" : r3 += "should have required property \\'" + S3 + "\\'", r3 += "' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ", w3 = r3, r3 = V10.pop(), !e28.compositeRule && c3 ? e28.async ? r3 += " throw new ValidationError([" + w3 + "]); " : r3 += " validate.errors = [" + w3 + "]; return false; " : r3 += " var err = " + w3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r3 += " } else { ";
      }
    else if (B3) {
      d3 || (r3 += " var " + m3 + " = validate.schema" + o3 + "; ");
      var K3;
      S3 = "' + " + (K3 = "schema" + i + "[" + (I3 = "i" + i) + "]") + " + '", e28.opts._errorDataPathProperty && (e28.errorPath = e28.util.getPathExpr(F3, K3, e28.opts.jsonPointers)), d3 && (r3 += " if (" + m3 + " && !Array.isArray(" + m3 + ")) {  var err =   ", e28.createErrors !== false ? (r3 += " { keyword: 'required' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { missingProperty: '" + S3 + "' } ", e28.opts.messages !== false && (r3 += " , message: '", e28.opts._errorDataPathProperty ? r3 += "is a required property" : r3 += "should have required property \\'" + S3 + "\\'", r3 += "' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ", r3 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + m3 + " !== undefined) { "), r3 += " for (var " + I3 + " = 0; " + I3 + " < " + m3 + ".length; " + I3 + "++) { if (" + f3 + "[" + m3 + "[" + I3 + "]] === undefined ", O3 && (r3 += " || ! Object.prototype.hasOwnProperty.call(" + f3 + ", " + m3 + "[" + I3 + "]) "), r3 += ") {  var err =   ", e28.createErrors !== false ? (r3 += " { keyword: 'required' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { missingProperty: '" + S3 + "' } ", e28.opts.messages !== false && (r3 += " , message: '", e28.opts._errorDataPathProperty ? r3 += "is a required property" : r3 += "should have required property \\'" + S3 + "\\'", r3 += "' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ", r3 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ", d3 && (r3 += "  }  ");
    } else {
      var W3 = y3;
      if (W3)
        for (var R3, q3 = -1, J3 = W3.length - 1; q3 < J3; ) {
          R3 = W3[q3 += 1];
          var X3 = e28.util.getProperty(R3), ce2 = (S3 = e28.util.escapeQuotes(R3), f3 + X3);
          e28.opts._errorDataPathProperty && (e28.errorPath = e28.util.getPath(F3, R3, e28.opts.jsonPointers)), r3 += " if ( " + ce2 + " === undefined ", O3 && (r3 += " || ! Object.prototype.hasOwnProperty.call(" + f3 + ", '" + e28.util.escapeQuotes(R3) + "') "), r3 += ") {  var err =   ", e28.createErrors !== false ? (r3 += " { keyword: 'required' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(u3) + " , params: { missingProperty: '" + S3 + "' } ", e28.opts.messages !== false && (r3 += " , message: '", e28.opts._errorDataPathProperty ? r3 += "is a required property" : r3 += "should have required property \\'" + S3 + "\\'", r3 += "' "), e28.opts.verbose && (r3 += " , schema: validate.schema" + o3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + f3 + " "), r3 += " } ") : r3 += " {} ", r3 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
        }
    }
    e28.errorPath = F3;
  } else
    c3 && (r3 += " if (true) {");
  return r3;
}, uniqueItems: function(e28, t3, n3) {
  var r3, i = " ", a3 = e28.level, s3 = e28.dataLevel, o3 = e28.schema[t3], u3 = e28.schemaPath + e28.util.getProperty(t3), c3 = e28.errSchemaPath + "/" + t3, f3 = !e28.opts.allErrors, p3 = "data" + (s3 || ""), d3 = "valid" + a3, m3 = e28.opts.$data && o3 && o3.$data;
  if (m3 ? (i += " var schema" + a3 + " = " + e28.util.getData(o3.$data, s3, e28.dataPathArr) + "; ", r3 = "schema" + a3) : r3 = o3, (o3 || m3) && e28.opts.uniqueItems !== false) {
    m3 && (i += " var " + d3 + "; if (" + r3 + " === false || " + r3 + " === undefined) " + d3 + " = true; else if (typeof " + r3 + " != 'boolean') " + d3 + " = false; else { "), i += " var i = " + p3 + ".length , " + d3 + " = true , j; if (i > 1) { ";
    var y3 = e28.schema.items && e28.schema.items.type, v3 = Array.isArray(y3);
    if (!y3 || y3 == "object" || y3 == "array" || v3 && (y3.indexOf("object") >= 0 || y3.indexOf("array") >= 0))
      i += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + p3 + "[i], " + p3 + "[j])) { " + d3 + " = false; break outer; } } } ";
    else {
      i += " var itemIndices = {}, item; for (;i--;) { var item = " + p3 + "[i]; ";
      var b3 = "checkDataType" + (v3 ? "s" : "");
      i += " if (" + e28.util[b3](y3, "item", true) + ") continue; ", v3 && (i += ` if (typeof item == 'string') item = '"' + item; `), i += " if (typeof itemIndices[item] == 'number') { " + d3 + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ";
    }
    i += " } ", m3 && (i += "  }  "), i += " if (!" + d3 + ") {   ";
    var x3 = x3 || [];
    x3.push(i), i = "", e28.createErrors !== false ? (i += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(c3) + " , params: { i: i, j: j } ", e28.opts.messages !== false && (i += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' "), e28.opts.verbose && (i += " , schema:  ", i += m3 ? "validate.schema" + u3 : "" + o3, i += "         , parentSchema: validate.schema" + e28.schemaPath + " , data: " + p3 + " "), i += " } ") : i += " {} ";
    var C3 = i;
    i = x3.pop(), !e28.compositeRule && f3 ? e28.async ? i += " throw new ValidationError([" + C3 + "]); " : i += " validate.errors = [" + C3 + "]; return false; " : i += " var err = " + C3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " } ", f3 && (i += " else { ");
  } else
    f3 && (i += " if (true) { ");
  return i;
}, validate: Gm }, Bd$1 = Mr$1.toHash, lT = function() {
  var e28 = [{ type: "number", rules: [{ maximum: ["exclusiveMaximum"] }, { minimum: ["exclusiveMinimum"] }, "multipleOf", "format"] }, { type: "string", rules: ["maxLength", "minLength", "pattern", "format"] }, { type: "array", rules: ["maxItems", "minItems", "items", "contains", "uniqueItems"] }, { type: "object", rules: ["maxProperties", "minProperties", "required", "dependencies", "propertyNames", { properties: ["additionalProperties", "patternProperties"] }] }, { rules: ["$ref", "const", "enum", "not", "anyOf", "oneOf", "allOf", "if"] }], t3 = ["type", "$comment"];
  return e28.all = Bd$1(t3), e28.types = Bd$1(["number", "integer", "string", "array", "object", "boolean", "null"]), e28.forEach(function(n3) {
    n3.rules = n3.rules.map(function(r3) {
      var i;
      if (xe$3(r3) == "object") {
        var a3 = Object.keys(r3)[0];
        i = r3[a3], r3 = a3, i.forEach(function(s3) {
          t3.push(s3), e28.all[s3] = true;
        });
      }
      return t3.push(r3), e28.all[r3] = { keyword: r3, code: sb$1[r3], implements: i };
    }), e28.all.$comment = { keyword: "$comment", code: sb$1.$comment }, n3.type && (e28.types[n3.type] = n3);
  }), e28.keywords = Bd$1(t3.concat(["$schema", "$id", "id", "$data", "$async", "title", "description", "default", "definitions", "examples", "readOnly", "writeOnly", "contentMediaType", "contentEncoding", "additionalItems", "then", "else"])), e28.custom = {}, e28;
}, ub$1 = ["multipleOf", "maximum", "exclusiveMaximum", "minimum", "exclusiveMinimum", "maxLength", "minLength", "pattern", "additionalItems", "maxItems", "minItems", "uniqueItems", "maxProperties", "minProperties", "required", "additionalProperties", "enum", "format", "const"], kD = function(e28, t3) {
  for (var n3 = 0; n3 < t3.length; n3++) {
    e28 = JSON.parse(JSON.stringify(e28));
    var r3, i = t3[n3].split("/"), a3 = e28;
    for (r3 = 1; r3 < i.length; r3++)
      a3 = a3[i[r3]];
    for (r3 = 0; r3 < ub$1.length; r3++) {
      var s3 = ub$1[r3], o3 = a3[s3];
      o3 && (a3[s3] = { anyOf: [o3, { $ref: "https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/data.json#" }] });
    }
  }
  return e28;
}, pT = mc$2.MissingRef, fT = function e24(t3, n3, r3) {
  var i = this;
  if (typeof this._opts.loadSchema != "function")
    throw new Error("options.loadSchema should be a function");
  typeof n3 == "function" && (r3 = n3, n3 = void 0);
  var a3 = s3(t3).then(function() {
    var o3 = i._addSchema(t3, void 0, n3);
    return o3.validate || function u3(c3) {
      try {
        return i._compile(c3);
      } catch (f3) {
        if (f3 instanceof pT)
          return function(p3) {
            var d3 = p3.missingSchema;
            if (v3(d3))
              throw new Error("Schema " + d3 + " is loaded but " + p3.missingRef + " cannot be resolved");
            var m3 = i._loadingSchemas[d3];
            return m3 || (m3 = i._loadingSchemas[d3] = i._opts.loadSchema(d3)).then(y3, y3), m3.then(function(b3) {
              if (!v3(d3))
                return s3(b3).then(function() {
                  v3(d3) || i.addSchema(b3, d3, void 0, n3);
                });
            }).then(function() {
              return u3(c3);
            });
            function y3() {
              delete i._loadingSchemas[d3];
            }
            function v3(b3) {
              return i._refs[b3] || i._schemas[b3];
            }
          }(f3);
        throw f3;
      }
    }(o3);
  });
  return r3 && a3.then(function(o3) {
    r3(null, o3);
  }, r3), a3;
  function s3(o3) {
    var u3 = o3.$schema;
    return u3 && !i.getSchema(u3) ? e24.call(i, { $ref: u3 }, true) : Promise.resolve();
  }
}, hT = function(e28, t3, n3) {
  var r3, i, a3 = " ", s3 = e28.level, o3 = e28.dataLevel, u3 = e28.schema[t3], c3 = e28.schemaPath + e28.util.getProperty(t3), f3 = e28.errSchemaPath + "/" + t3, p3 = !e28.opts.allErrors, d3 = "data" + (o3 || ""), m3 = "valid" + s3, y3 = "errs__" + s3, v3 = e28.opts.$data && u3 && u3.$data;
  v3 ? (a3 += " var schema" + s3 + " = " + e28.util.getData(u3.$data, o3, e28.dataPathArr) + "; ", i = "schema" + s3) : i = u3;
  var b3, x3, C3, k3, F3, B3 = "definition" + s3, O3 = this.definition, S3 = "";
  if (v3 && O3.$data) {
    F3 = "keywordValidate" + s3;
    var w3 = O3.validateSchema;
    a3 += " var " + B3 + " = RULES.custom['" + t3 + "'].definition; var " + F3 + " = " + B3 + ".validate;";
  } else {
    if (!(k3 = e28.useCustomRule(this, u3, e28.schema, e28)))
      return;
    i = "validate.schema" + c3, F3 = k3.code, b3 = O3.compile, x3 = O3.inline, C3 = O3.macro;
  }
  var D3 = F3 + ".errors", I3 = "i" + s3, L3 = "ruleErr" + s3, V10 = O3.async;
  if (V10 && !e28.async)
    throw new Error("async keyword in sync schema");
  if (x3 || C3 || (a3 += D3 + " = null;"), a3 += "var " + y3 + " = errors;var " + m3 + ";", v3 && O3.$data && (S3 += "}", a3 += " if (" + i + " === undefined) { " + m3 + " = true; } else { ", w3 && (S3 += "}", a3 += " " + m3 + " = " + B3 + ".validateSchema(" + i + "); if (" + m3 + ") { ")), x3)
    O3.statements ? a3 += " " + k3.validate + " " : a3 += " " + m3 + " = " + k3.validate + "; ";
  else if (C3) {
    var K3 = e28.util.copy(e28);
    S3 = "", K3.level++;
    var W3 = "valid" + K3.level;
    K3.schema = k3.validate, K3.schemaPath = "";
    var R3 = e28.compositeRule;
    e28.compositeRule = K3.compositeRule = true;
    var q3 = e28.validate(K3).replace(/validate\.schema/g, F3);
    e28.compositeRule = K3.compositeRule = R3, a3 += " " + q3;
  } else {
    (A3 = A3 || []).push(a3), a3 = "", a3 += "  " + F3 + ".call( ", e28.opts.passContext ? a3 += "this" : a3 += "self", b3 || O3.schema === false ? a3 += " , " + d3 + " " : a3 += " , " + i + " , " + d3 + " , validate.schema" + e28.schemaPath + " ", a3 += " , (dataPath || '')", e28.errorPath != '""' && (a3 += " + " + e28.errorPath);
    var J3 = o3 ? "data" + (o3 - 1 || "") : "parentData", X3 = o3 ? e28.dataPathArr[o3] : "parentDataProperty", ce2 = a3 += " , " + J3 + " , " + X3 + " , rootData )  ";
    a3 = A3.pop(), O3.errors === false ? (a3 += " " + m3 + " = ", V10 && (a3 += "await "), a3 += ce2 + "; ") : a3 += V10 ? " var " + (D3 = "customErrors" + s3) + " = null; try { " + m3 + " = await " + ce2 + "; } catch (e) { " + m3 + " = false; if (e instanceof ValidationError) " + D3 + " = e.errors; else throw e; } " : " " + D3 + " = null; " + m3 + " = " + ce2 + "; ";
  }
  if (O3.modifying && (a3 += " if (" + J3 + ") " + d3 + " = " + J3 + "[" + X3 + "];"), a3 += "" + S3, O3.valid)
    p3 && (a3 += " if (true) { ");
  else {
    var A3;
    a3 += " if ( ", O3.valid === void 0 ? (a3 += " !", a3 += C3 ? "" + W3 : "" + m3) : a3 += " " + !O3.valid + " ", a3 += ") { ", r3 = this.keyword, (A3 = A3 || []).push(a3), a3 = "", (A3 = A3 || []).push(a3), a3 = "", e28.createErrors !== false ? (a3 += " { keyword: '" + (r3 || "custom") + "' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(f3) + " , params: { keyword: '" + this.keyword + "' } ", e28.opts.messages !== false && (a3 += ` , message: 'should pass "` + this.keyword + `" keyword validation' `), e28.opts.verbose && (a3 += " , schema: validate.schema" + c3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + d3 + " "), a3 += " } ") : a3 += " {} ";
    var M3 = a3;
    a3 = A3.pop(), !e28.compositeRule && p3 ? e28.async ? a3 += " throw new ValidationError([" + M3 + "]); " : a3 += " validate.errors = [" + M3 + "]; return false; " : a3 += " var err = " + M3 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    var ne2 = a3;
    a3 = A3.pop(), x3 ? O3.errors ? O3.errors != "full" && (a3 += "  for (var " + I3 + "=" + y3 + "; " + I3 + "<errors; " + I3 + "++) { var " + L3 + " = vErrors[" + I3 + "]; if (" + L3 + ".dataPath === undefined) " + L3 + ".dataPath = (dataPath || '') + " + e28.errorPath + "; if (" + L3 + ".schemaPath === undefined) { " + L3 + '.schemaPath = "' + f3 + '"; } ', e28.opts.verbose && (a3 += " " + L3 + ".schema = " + i + "; " + L3 + ".data = " + d3 + "; "), a3 += " } ") : O3.errors === false ? a3 += " " + ne2 + " " : (a3 += " if (" + y3 + " == errors) { " + ne2 + " } else {  for (var " + I3 + "=" + y3 + "; " + I3 + "<errors; " + I3 + "++) { var " + L3 + " = vErrors[" + I3 + "]; if (" + L3 + ".dataPath === undefined) " + L3 + ".dataPath = (dataPath || '') + " + e28.errorPath + "; if (" + L3 + ".schemaPath === undefined) { " + L3 + '.schemaPath = "' + f3 + '"; } ', e28.opts.verbose && (a3 += " " + L3 + ".schema = " + i + "; " + L3 + ".data = " + d3 + "; "), a3 += " } } ") : C3 ? (a3 += "   var err =   ", e28.createErrors !== false ? (a3 += " { keyword: '" + (r3 || "custom") + "' , dataPath: (dataPath || '') + " + e28.errorPath + " , schemaPath: " + e28.util.toQuotedString(f3) + " , params: { keyword: '" + this.keyword + "' } ", e28.opts.messages !== false && (a3 += ` , message: 'should pass "` + this.keyword + `" keyword validation' `), e28.opts.verbose && (a3 += " , schema: validate.schema" + c3 + " , parentSchema: validate.schema" + e28.schemaPath + " , data: " + d3 + " "), a3 += " } ") : a3 += " {} ", a3 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e28.compositeRule && p3 && (e28.async ? a3 += " throw new ValidationError(vErrors); " : a3 += " validate.errors = vErrors; return false; ")) : O3.errors === false ? a3 += " " + ne2 + " " : (a3 += " if (Array.isArray(" + D3 + ")) { if (vErrors === null) vErrors = " + D3 + "; else vErrors = vErrors.concat(" + D3 + "); errors = vErrors.length;  for (var " + I3 + "=" + y3 + "; " + I3 + "<errors; " + I3 + "++) { var " + L3 + " = vErrors[" + I3 + "]; if (" + L3 + ".dataPath === undefined) " + L3 + ".dataPath = (dataPath || '') + " + e28.errorPath + ";  " + L3 + '.schemaPath = "' + f3 + '";  ', e28.opts.verbose && (a3 += " " + L3 + ".schema = " + i + "; " + L3 + ".data = " + d3 + "; "), a3 += " } } else { " + ne2 + " } "), a3 += " } ", p3 && (a3 += " else { ");
  }
  return a3;
}, DD = "http://json-schema.org/draft-07/schema#", FD = "http://json-schema.org/draft-07/schema#", wD = "Core schema meta-schema", AD = { schemaArray: { type: "array", minItems: 1, items: { $ref: "#" } }, nonNegativeInteger: { type: "integer", minimum: 0 }, nonNegativeIntegerDefault0: { allOf: [{ $ref: "#/definitions/nonNegativeInteger" }, { default: 0 }] }, simpleTypes: { enum: ["array", "boolean", "integer", "null", "number", "object", "string"] }, stringArray: { type: "array", items: { type: "string" }, uniqueItems: true, default: [] } }, _D = ["object", "boolean"], TD = { $id: { type: "string", format: "uri-reference" }, $schema: { type: "string", format: "uri" }, $ref: { type: "string", format: "uri-reference" }, $comment: { type: "string" }, title: { type: "string" }, description: { type: "string" }, default: true, readOnly: { type: "boolean", default: false }, examples: { type: "array", items: true }, multipleOf: { type: "number", exclusiveMinimum: 0 }, maximum: { type: "number" }, exclusiveMaximum: { type: "number" }, minimum: { type: "number" }, exclusiveMinimum: { type: "number" }, maxLength: { $ref: "#/definitions/nonNegativeInteger" }, minLength: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, pattern: { type: "string", format: "regex" }, additionalItems: { $ref: "#" }, items: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/schemaArray" }], default: true }, maxItems: { $ref: "#/definitions/nonNegativeInteger" }, minItems: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, uniqueItems: { type: "boolean", default: false }, contains: { $ref: "#" }, maxProperties: { $ref: "#/definitions/nonNegativeInteger" }, minProperties: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, required: { $ref: "#/definitions/stringArray" }, additionalProperties: { $ref: "#" }, definitions: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, properties: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, patternProperties: { type: "object", additionalProperties: { $ref: "#" }, propertyNames: { format: "regex" }, default: {} }, dependencies: { type: "object", additionalProperties: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/stringArray" }] } }, propertyNames: { $ref: "#" }, const: true, enum: { type: "array", items: true, minItems: 1, uniqueItems: true }, type: { anyOf: [{ $ref: "#/definitions/simpleTypes" }, { type: "array", items: { $ref: "#/definitions/simpleTypes" }, minItems: 1, uniqueItems: true }] }, format: { type: "string" }, contentMediaType: { type: "string" }, contentEncoding: { type: "string" }, if: { $ref: "#" }, then: { $ref: "#" }, else: { $ref: "#" }, allOf: { $ref: "#/definitions/schemaArray" }, anyOf: { $ref: "#/definitions/schemaArray" }, oneOf: { $ref: "#/definitions/schemaArray" }, not: { $ref: "#" } }, dT = { $schema: DD, $id: FD, title: wD, definitions: AD, type: _D, properties: TD, default: true }, zm = Cr$1(Object.freeze({ __proto__: null, $schema: DD, $id: FD, title: wD, definitions: AD, type: _D, properties: TD, default: dT })), mT = { $id: "https://github.com/epoberezkin/ajv/blob/master/lib/definition_schema.js", definitions: { simpleTypes: zm.definitions.simpleTypes }, type: "object", dependencies: { schema: ["validate"], $data: ["validate"], statements: ["inline"], valid: { not: { required: ["macro"] } } }, properties: { type: zm.properties.type, schema: { type: "boolean" }, statements: { type: "boolean" }, dependencies: { type: "array", items: { type: "string" } }, metaSchema: { type: "object" }, modifying: { type: "boolean" }, valid: { type: "boolean" }, $data: { type: "boolean" }, async: { type: "boolean" }, errors: { anyOf: [{ type: "boolean" }, { const: "full" }] } } }, gT = /^[a-z_$][a-z0-9_$-]*$/i, yT = function(e28, t3) {
  var n3 = this.RULES;
  if (n3.keywords[e28])
    throw new Error("Keyword " + e28 + " is already defined");
  if (!gT.test(e28))
    throw new Error("Keyword " + e28 + " is not a valid identifier");
  if (t3) {
    this.validateKeyword(t3, true);
    var r3 = t3.type;
    if (Array.isArray(r3))
      for (var i = 0; i < r3.length; i++)
        s3(e28, r3[i], t3);
    else
      s3(e28, r3, t3);
    var a3 = t3.metaSchema;
    a3 && (t3.$data && this._opts.$data && (a3 = { anyOf: [a3, { $ref: "https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/data.json#" }] }), t3.validateSchema = this.compile(a3, true));
  }
  function s3(o3, u3, c3) {
    for (var f3, p3 = 0; p3 < n3.length; p3++) {
      var d3 = n3[p3];
      if (d3.type == u3) {
        f3 = d3;
        break;
      }
    }
    f3 || (f3 = { type: u3, rules: [] }, n3.push(f3));
    var m3 = { keyword: o3, definition: c3, custom: true, code: hT, implements: c3.implements };
    f3.rules.push(m3), n3.custom[o3] = m3;
  }
  return n3.keywords[e28] = n3.all[e28] = true, this;
}, vT = function(e28) {
  var t3 = this.RULES.custom[e28];
  return t3 ? t3.definition : this.RULES.keywords[e28] || false;
}, xT = function(e28) {
  var t3 = this.RULES;
  delete t3.keywords[e28], delete t3.all[e28], delete t3.custom[e28];
  for (var n3 = 0; n3 < t3.length; n3++)
    for (var r3 = t3[n3].rules, i = 0; i < r3.length; i++)
      if (r3[i].keyword == e28) {
        r3.splice(i, 1);
        break;
      }
  return this;
}, bT = function e25(t3, n3) {
  e25.errors = null;
  var r3 = this._validateKeyword = this._validateKeyword || this.compile(mT, true);
  if (r3(t3))
    return true;
  if (e25.errors = r3.errors, n3)
    throw new Error("custom keyword definition is invalid: " + this.errorsText(r3.errors));
  return false;
}, PD = "http://json-schema.org/draft-07/schema#", ID = "https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/data.json#", BD = "Meta-schema for $data reference (JSON Schema extension proposal)", OD = ["$data"], LD = { $data: { type: "string", anyOf: [{ format: "relative-json-pointer" }, { format: "json-pointer" }] } }, ET = { $schema: PD, $id: ID, description: BD, type: "object", required: OD, properties: LD, additionalProperties: false }, CT = Cr$1(Object.freeze({ __proto__: null, $schema: PD, $id: ID, description: BD, type: "object", required: OD, properties: LD, additionalProperties: false, default: ET })), ST = vn$1;
vn$1.prototype.validate = function(e28, t3) {
  var n3;
  if (typeof e28 == "string") {
    if (!(n3 = this.getSchema(e28)))
      throw new Error('no schema with key or ref "' + e28 + '"');
  } else {
    var r3 = this._addSchema(e28);
    n3 = r3.validate || this._compile(r3);
  }
  var i = n3(t3);
  return n3.$async !== true && (this.errors = n3.errors), i;
}, vn$1.prototype.compile = function(e28, t3) {
  var n3 = this._addSchema(e28, void 0, t3);
  return n3.validate || this._compile(n3);
}, vn$1.prototype.addSchema = function(e28, t3, n3, r3) {
  if (Array.isArray(e28)) {
    for (var i = 0; i < e28.length; i++)
      this.addSchema(e28[i], void 0, n3, r3);
    return this;
  }
  var a3 = this._getId(e28);
  if (a3 !== void 0 && typeof a3 != "string")
    throw new Error("schema id must be string");
  return pb$1(this, t3 = xr$1.normalizeId(t3 || a3)), this._schemas[t3] = this._addSchema(e28, n3, r3, true), this;
}, vn$1.prototype.addMetaSchema = function(e28, t3, n3) {
  return this.addSchema(e28, t3, n3, true), this;
}, vn$1.prototype.validateSchema = function(e28, t3) {
  var n3 = e28.$schema;
  if (n3 !== void 0 && typeof n3 != "string")
    throw new Error("$schema must be a string");
  if (!(n3 = n3 || this._opts.defaultMeta || function(a3) {
    var s3 = a3._opts.meta;
    return a3._opts.defaultMeta = xe$3(s3) == "object" ? a3._getId(s3) || s3 : a3.getSchema($p) ? $p : void 0, a3._opts.defaultMeta;
  }(this)))
    return this.logger.warn("meta-schema not available"), this.errors = null, true;
  var r3 = this.validate(n3, e28);
  if (!r3 && t3) {
    var i = "schema is invalid: " + this.errorsText();
    if (this._opts.validateSchema != "log")
      throw new Error(i);
    this.logger.error(i);
  }
  return r3;
}, vn$1.prototype.getSchema = function(e28) {
  var t3 = lb$1(this, e28);
  switch (xe$3(t3)) {
    case "object":
      return t3.validate || this._compile(t3);
    case "string":
      return this.getSchema(t3);
    case "undefined":
      return function(n3, r3) {
        var i = xr$1.schema.call(n3, { schema: {} }, r3);
        if (i) {
          var a3 = i.schema, s3 = i.root, o3 = i.baseId, u3 = zx.call(n3, a3, s3, void 0, o3);
          return n3._fragments[r3] = new Ks$1({ ref: r3, fragment: true, schema: a3, root: s3, baseId: o3, validate: u3 }), u3;
        }
      }(this, e28);
  }
}, vn$1.prototype.removeSchema = function(e28) {
  if (e28 instanceof RegExp)
    return ql(this, this._schemas, e28), ql(this, this._refs, e28), this;
  switch (xe$3(e28)) {
    case "undefined":
      return ql(this, this._schemas), ql(this, this._refs), this._cache.clear(), this;
    case "string":
      var t3 = lb$1(this, e28);
      return t3 && this._cache.del(t3.cacheKey), delete this._schemas[e28], delete this._refs[e28], this;
    case "object":
      var n3 = this._opts.serialize, r3 = n3 ? n3(e28) : e28;
      this._cache.del(r3);
      var i = this._getId(e28);
      i && (i = xr$1.normalizeId(i), delete this._schemas[i], delete this._refs[i]);
  }
  return this;
}, vn$1.prototype.addFormat = function(e28, t3) {
  return typeof t3 == "string" && (t3 = new RegExp(t3)), this._formats[e28] = t3, this;
}, vn$1.prototype.errorsText = function(e28, t3) {
  if (!(e28 = e28 || this.errors))
    return "No errors";
  for (var n3 = (t3 = t3 || {}).separator === void 0 ? ", " : t3.separator, r3 = t3.dataVar === void 0 ? "data" : t3.dataVar, i = "", a3 = 0; a3 < e28.length; a3++) {
    var s3 = e28[a3];
    s3 && (i += r3 + s3.dataPath + " " + s3.message + n3);
  }
  return i.slice(0, -n3.length);
}, vn$1.prototype._addSchema = function(e28, t3, n3, r3) {
  if (xe$3(e28) != "object" && typeof e28 != "boolean")
    throw new Error("schema should be object or boolean");
  var i = this._opts.serialize, a3 = i ? i(e28) : e28, s3 = this._cache.get(a3);
  if (s3)
    return s3;
  r3 = r3 || this._opts.addUsedSchema !== false;
  var o3 = xr$1.normalizeId(this._getId(e28));
  o3 && r3 && pb$1(this, o3);
  var u3, c3 = this._opts.validateSchema !== false && !t3;
  c3 && !(u3 = o3 && o3 == xr$1.normalizeId(e28.$schema)) && this.validateSchema(e28, true);
  var f3 = xr$1.ids.call(this, e28), p3 = new Ks$1({ id: o3, schema: e28, localRefs: f3, cacheKey: a3, meta: n3 });
  return o3[0] != "#" && r3 && (this._refs[o3] = p3), this._cache.put(a3, p3), c3 && u3 && this.validateSchema(e28, true), p3;
}, vn$1.prototype._compile = function(e28, t3) {
  if (e28.compiling)
    return e28.validate = i, i.schema = e28.schema, i.errors = null, i.root = t3 || i, e28.schema.$async === true && (i.$async = true), i;
  var n3, r3;
  e28.compiling = true, e28.meta && (n3 = this._opts, this._opts = this._metaOpts);
  try {
    r3 = zx.call(this, e28.schema, t3, e28.localRefs);
  } catch (a3) {
    throw delete e28.validate, a3;
  } finally {
    e28.compiling = false, e28.meta && (this._opts = n3);
  }
  return e28.validate = r3, e28.refs = r3.refs, e28.refVal = r3.refVal, e28.root = r3.root, r3;
  function i() {
    var a3 = e28.validate, s3 = a3.apply(this, arguments);
    return i.errors = a3.errors, s3;
  }
}, vn$1.prototype.compileAsync = fT, vn$1.prototype.addKeyword = yT, vn$1.prototype.getKeyword = vT, vn$1.prototype.removeKeyword = xT, vn$1.prototype.validateKeyword = bT, vn$1.ValidationError = mc$2.Validation, vn$1.MissingRefError = mc$2.MissingRef, vn$1.$dataMetaSchema = kD;
var $p = "http://json-schema.org/draft-07/schema", cb$1 = ["removeAdditional", "useDefaults", "coerceTypes", "strictDefaults"], kT = ["/properties"];
function vn$1(e28) {
  if (!(this instanceof vn$1))
    return new vn$1(e28);
  e28 = this._opts = Mr$1.copy(e28) || {}, function(t3) {
    var n3 = t3._opts.logger;
    if (n3 === false)
      t3.logger = { log: Od$1, warn: Od$1, error: Od$1 };
    else {
      if (n3 === void 0 && (n3 = console), !(xe$3(n3) == "object" && n3.log && n3.warn && n3.error))
        throw new Error("logger must implement log, warn and error methods");
      t3.logger = n3;
    }
  }(this), this._schemas = {}, this._refs = {}, this._fragments = {}, this._formats = oT(e28.format), this._cache = e28.cache || new tT(), this._loadingSchemas = {}, this._compilations = [], this.RULES = lT(), this._getId = function(t3) {
    switch (t3.schemaId) {
      case "auto":
        return wT;
      case "id":
        return DT;
      default:
        return FT;
    }
  }(e28), e28.loopRequired = e28.loopRequired || 1 / 0, e28.errorDataPath == "property" && (e28._errorDataPathProperty = true), e28.serialize === void 0 && (e28.serialize = CD), this._metaOpts = function(t3) {
    for (var n3 = Mr$1.copy(t3._opts), r3 = 0; r3 < cb$1.length; r3++)
      delete n3[cb$1[r3]];
    return n3;
  }(this), e28.formats && function(t3) {
    for (var n3 in t3._opts.formats) {
      var r3 = t3._opts.formats[n3];
      t3.addFormat(n3, r3);
    }
  }(this), function(t3) {
    var n3;
    if (t3._opts.$data && (n3 = CT, t3.addMetaSchema(n3, n3.$id, true)), t3._opts.meta !== false) {
      var r3 = zm;
      t3._opts.$data && (r3 = kD(r3, kT)), t3.addMetaSchema(r3, $p, true), t3._refs["http://json-schema.org/schema"] = $p;
    }
  }(this), xe$3(e28.meta) == "object" && this.addMetaSchema(e28.meta), e28.nullable && this.addKeyword("nullable", { metaSchema: { type: "boolean" } }), function(t3) {
    var n3 = t3._opts.schemas;
    if (n3)
      if (Array.isArray(n3))
        t3.addSchema(n3);
      else
        for (var r3 in n3)
          t3.addSchema(n3[r3], r3);
  }(this);
}
function lb$1(e28, t3) {
  return t3 = xr$1.normalizeId(t3), e28._schemas[t3] || e28._refs[t3] || e28._fragments[t3];
}
function ql(e28, t3, n3) {
  for (var r3 in t3) {
    var i = t3[r3];
    i.meta || n3 && !n3.test(r3) || (e28._cache.del(i.cacheKey), delete t3[r3]);
  }
}
function DT(e28) {
  return e28.$id && this.logger.warn("schema $id ignored", e28.$id), e28.id;
}
function FT(e28) {
  return e28.id && this.logger.warn("schema id ignored", e28.id), e28.$id;
}
function wT(e28) {
  if (e28.$id && e28.id && e28.$id != e28.id)
    throw new Error("schema $id is different from id");
  return e28.$id || e28.id;
}
function pb$1(e28, t3) {
  if (e28._schemas[t3] || e28._refs[t3])
    throw new Error('schema with key or id "' + t3 + '" already exists');
}
function Od$1() {
}
var ND, jD = "http://json-schema.org/draft-04/schema#", RD = "http://json-schema.org/draft-04/schema#", MD = { schemaArray: { type: "array", minItems: 1, items: { $ref: "#" } }, positiveInteger: { type: "integer", minimum: 0 }, positiveIntegerDefault0: { allOf: [{ $ref: "#/definitions/positiveInteger" }, { default: 0 }] }, simpleTypes: { enum: ["array", "boolean", "integer", "null", "number", "object", "string"] }, stringArray: { type: "array", items: { type: "string" }, minItems: 1, uniqueItems: true } }, VD = { id: { type: "string" }, $schema: { type: "string" }, title: { type: "string" }, description: { type: "string" }, default: {}, multipleOf: { type: "number", minimum: 0, exclusiveMinimum: true }, maximum: { type: "number" }, exclusiveMaximum: { type: "boolean", default: false }, minimum: { type: "number" }, exclusiveMinimum: { type: "boolean", default: false }, maxLength: { $ref: "#/definitions/positiveInteger" }, minLength: { $ref: "#/definitions/positiveIntegerDefault0" }, pattern: { type: "string", format: "regex" }, additionalItems: { anyOf: [{ type: "boolean" }, { $ref: "#" }], default: {} }, items: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/schemaArray" }], default: {} }, maxItems: { $ref: "#/definitions/positiveInteger" }, minItems: { $ref: "#/definitions/positiveIntegerDefault0" }, uniqueItems: { type: "boolean", default: false }, maxProperties: { $ref: "#/definitions/positiveInteger" }, minProperties: { $ref: "#/definitions/positiveIntegerDefault0" }, required: { $ref: "#/definitions/stringArray" }, additionalProperties: { anyOf: [{ type: "boolean" }, { $ref: "#" }], default: {} }, definitions: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, properties: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, patternProperties: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, dependencies: { type: "object", additionalProperties: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/stringArray" }] } }, enum: { type: "array", minItems: 1, uniqueItems: true }, type: { anyOf: [{ $ref: "#/definitions/simpleTypes" }, { type: "array", items: { $ref: "#/definitions/simpleTypes" }, minItems: 1, uniqueItems: true }] }, format: { type: "string" }, allOf: { $ref: "#/definitions/schemaArray" }, anyOf: { $ref: "#/definitions/schemaArray" }, oneOf: { $ref: "#/definitions/schemaArray" }, not: { $ref: "#" } }, UD = { exclusiveMaximum: ["maximum"], exclusiveMinimum: ["minimum"] }, AT = { id: jD, $schema: RD, description: "Core schema meta-schema", definitions: MD, type: "object", properties: VD, dependencies: UD, default: {} }, _T = Object.freeze({ __proto__: null, id: jD, $schema: RD, description: "Core schema meta-schema", definitions: MD, type: "object", properties: VD, dependencies: UD, default: AT }), TT = [].slice, PT = {}.toString;
ND = cp(function(e28, t3) {
  return e28.apply(null, t3);
});
var IT = { curry: function(e28) {
  return cp(e28);
}, flip: cp(function(e28, t3, n3) {
  return e28(n3, t3);
}), fix: function(e28) {
  return function(t3) {
    return function() {
      return e28(t3(t3)).apply(null, arguments);
    };
  }(function(t3) {
    return function() {
      return e28(t3(t3)).apply(null, arguments);
    };
  });
}, apply: ND, over: cp(function(e28, t3, n3, r3) {
  return e28(t3(n3), t3(r3));
}), memoize: function(e28) {
  var t3;
  return t3 = {}, function() {
    var n3, r3, i;
    return n3 = TT.call(arguments), r3 = function() {
      var a3, s3, o3, u3 = [];
      for (a3 = 0, o3 = (s3 = n3).length; a3 < o3; ++a3)
        i = s3[a3], u3.push(i + PT.call(i).slice(8, -1));
      return u3;
    }().join(""), t3[r3] = r3 in t3 ? t3[r3] : e28.apply(null, n3);
  };
} };
function cp(e28, t3) {
  var n3;
  return function r3(i) {
    return e28.length > 1 ? function() {
      var a3 = i ? i.concat() : [];
      return n3 = t3 && n3 || this, a3.push.apply(a3, arguments) < e28.length && arguments.length ? r3.call(n3, a3) : e28.apply(n3, a3);
    } : e28;
  }();
}
var qD, WD, $D, GD, zD, HD, KD, JD, QD, XD, YD, ZD, eF, tF, nF, rF, Hm, iF, aF, oF, Km, sF, uF, cF, lF, Jm, pF, fF, hF, dF, mF, gF, yF, vF, xF, bF, EF, CF, SF, kF, DF, FF, wF, AF, _F, TF, $u$1, PF, IF, BF, OF, LF, NF, Qm, Xm, jF, Ym, Zm, e0, RF, MF, VF, UF, qF, WF, $F, GF, zF, HF, BT = {}.toString, wu$1 = [].slice;
qD = dt$3(function(e28, t3) {
  var n3, r3;
  for (n3 = 0, r3 = t3.length; n3 < r3; ++n3)
    e28(t3[n3]);
  return t3;
}), WD = dt$3(function(e28, t3) {
  var n3, r3, i, a3 = [];
  for (n3 = 0, r3 = t3.length; n3 < r3; ++n3)
    i = t3[n3], a3.push(e28(i));
  return a3;
}), $D = function(e28) {
  var t3, n3, r3, i = [];
  for (t3 = 0, n3 = e28.length; t3 < n3; ++t3)
    (r3 = e28[t3]) && i.push(r3);
  return i;
}, GD = dt$3(function(e28, t3) {
  var n3, r3, i, a3 = [];
  for (n3 = 0, r3 = t3.length; n3 < r3; ++n3)
    e28(i = t3[n3]) && a3.push(i);
  return a3;
}), zD = dt$3(function(e28, t3) {
  var n3, r3, i, a3 = [];
  for (n3 = 0, r3 = t3.length; n3 < r3; ++n3)
    e28(i = t3[n3]) || a3.push(i);
  return a3;
}), HD = dt$3(function(e28, t3) {
  var n3, r3, i, a3, s3;
  for (n3 = [], r3 = [], i = 0, a3 = t3.length; i < a3; ++i)
    (e28(s3 = t3[i]) ? n3 : r3).push(s3);
  return [n3, r3];
}), KD = dt$3(function(e28, t3) {
  var n3, r3, i;
  for (n3 = 0, r3 = t3.length; n3 < r3; ++n3)
    if (e28(i = t3[n3]))
      return i;
}), JD = QD = function(e28) {
  return e28[0];
}, XD = function(e28) {
  if (e28.length)
    return e28.slice(1);
}, YD = function(e28) {
  return e28[e28.length - 1];
}, ZD = function(e28) {
  if (e28.length)
    return e28.slice(0, -1);
}, eF = function(e28) {
  return !e28.length;
}, tF = function(e28) {
  return e28.concat().reverse();
}, nF = function(e28) {
  var t3, n3, r3, i;
  for (t3 = [], n3 = 0, r3 = e28.length; n3 < r3; ++n3)
    Au$1(i = e28[n3], t3) || t3.push(i);
  return t3;
}, rF = dt$3(function(e28, t3) {
  var n3, r3, i, a3, s3, o3 = [];
  for (n3 = [], r3 = 0, i = t3.length; r3 < i; ++r3)
    Au$1(s3 = e28(a3 = t3[r3]), n3) || (n3.push(s3), o3.push(a3));
  return o3;
}), Hm = iF = dt$3(function(e28, t3, n3) {
  var r3, i;
  for (r3 = 0, i = n3.length; r3 < i; ++r3)
    t3 = e28(t3, n3[r3]);
  return t3;
}), aF = oF = dt$3(function(e28, t3) {
  return Hm(e28, t3[0], t3.slice(1));
}), Km = dt$3(function(e28, t3, n3) {
  var r3;
  for (r3 = n3.length - 1; r3 >= 0; --r3)
    t3 = e28(n3[r3], t3);
  return t3;
}), sF = dt$3(function(e28, t3) {
  return Km(e28, t3[t3.length - 1], t3.slice(0, -1));
}), uF = dt$3(function(e28, t3) {
  var n3, r3, i;
  for (n3 = [], r3 = t3; (i = e28(r3)) != null; )
    n3.push(i[0]), r3 = i[1];
  return n3;
}), cF = function(e28) {
  return [].concat.apply([], e28);
}, lF = dt$3(function(e28, t3) {
  var n3;
  return [].concat.apply([], function() {
    var r3, i, a3, s3 = [];
    for (r3 = 0, a3 = (i = t3).length; r3 < a3; ++r3)
      n3 = i[r3], s3.push(e28(n3));
    return s3;
  }());
}), Jm = function(e28) {
  var t3;
  return [].concat.apply([], function() {
    var n3, r3, i, a3 = [];
    for (n3 = 0, i = (r3 = e28).length; n3 < i; ++n3)
      t3 = r3[n3], BT.call(t3).slice(8, -1) === "Array" ? a3.push(Jm(t3)) : a3.push(t3);
    return a3;
  }());
}, pF = function(e28) {
  var t3, n3, r3, i, a3, s3, o3;
  t3 = wu$1.call(arguments, 1), n3 = [];
  e:
    for (r3 = 0, i = e28.length; r3 < i; ++r3) {
      for (a3 = e28[r3], s3 = 0, o3 = t3.length; s3 < o3; ++s3)
        if (Au$1(a3, t3[s3]))
          continue e;
      n3.push(a3);
    }
  return n3;
}, fF = function(e28) {
  var t3, n3, r3, i, a3, s3, o3;
  t3 = wu$1.call(arguments, 1), n3 = [];
  e:
    for (r3 = 0, i = e28.length; r3 < i; ++r3) {
      for (a3 = e28[r3], s3 = 0, o3 = t3.length; s3 < o3; ++s3)
        if (!Au$1(a3, t3[s3]))
          continue e;
      n3.push(a3);
    }
  return n3;
}, hF = function() {
  var e28, t3, n3, r3, i, a3, s3, o3;
  for (t3 = [], n3 = 0, r3 = (e28 = wu$1.call(arguments)).length; n3 < r3; ++n3)
    for (a3 = 0, s3 = (i = e28[n3]).length; a3 < s3; ++a3)
      Au$1(o3 = i[a3], t3) || t3.push(o3);
  return t3;
}, dF = dt$3(function(e28, t3) {
  var n3, r3, i, a3;
  for (n3 = {}, r3 = 0, i = t3.length; r3 < i; ++r3)
    (a3 = e28(t3[r3])) in n3 ? n3[a3] += 1 : n3[a3] = 1;
  return n3;
}), mF = dt$3(function(e28, t3) {
  var n3, r3, i, a3, s3;
  for (n3 = {}, r3 = 0, i = t3.length; r3 < i; ++r3)
    (s3 = e28(a3 = t3[r3])) in n3 ? n3[s3].push(a3) : n3[s3] = [a3];
  return n3;
}), gF = function(e28) {
  var t3, n3;
  for (t3 = 0, n3 = e28.length; t3 < n3; ++t3)
    if (!e28[t3])
      return false;
  return true;
}, yF = function(e28) {
  var t3, n3;
  for (t3 = 0, n3 = e28.length; t3 < n3; ++t3)
    if (e28[t3])
      return true;
  return false;
}, vF = dt$3(function(e28, t3) {
  var n3, r3;
  for (n3 = 0, r3 = t3.length; n3 < r3; ++n3)
    if (e28(t3[n3]))
      return true;
  return false;
}), xF = dt$3(function(e28, t3) {
  var n3, r3;
  for (n3 = 0, r3 = t3.length; n3 < r3; ++n3)
    if (!e28(t3[n3]))
      return false;
  return true;
}), bF = function(e28) {
  return e28.concat().sort(function(t3, n3) {
    return t3 > n3 ? 1 : t3 < n3 ? -1 : 0;
  });
}, EF = dt$3(function(e28, t3) {
  return t3.concat().sort(e28);
}), CF = dt$3(function(e28, t3) {
  return t3.concat().sort(function(n3, r3) {
    return e28(n3) > e28(r3) ? 1 : e28(n3) < e28(r3) ? -1 : 0;
  });
}), SF = function(e28) {
  var t3, n3, r3;
  for (t3 = 0, n3 = 0, r3 = e28.length; n3 < r3; ++n3)
    t3 += e28[n3];
  return t3;
}, kF = function(e28) {
  var t3, n3, r3;
  for (t3 = 1, n3 = 0, r3 = e28.length; n3 < r3; ++n3)
    t3 *= e28[n3];
  return t3;
}, DF = FF = function(e28) {
  var t3, n3, r3;
  for (t3 = 0, n3 = 0, r3 = e28.length; n3 < r3; ++n3)
    t3 += e28[n3];
  return t3 / e28.length;
}, wF = function(e28) {
  var t3, n3, r3, i, a3;
  for (t3 = e28[0], n3 = 0, i = (r3 = e28.slice(1)).length; n3 < i; ++n3)
    (a3 = r3[n3]) > t3 && (t3 = a3);
  return t3;
}, AF = function(e28) {
  var t3, n3, r3, i, a3;
  for (t3 = e28[0], n3 = 0, i = (r3 = e28.slice(1)).length; n3 < i; ++n3)
    (a3 = r3[n3]) < t3 && (t3 = a3);
  return t3;
}, _F = dt$3(function(e28, t3) {
  var n3, r3, i, a3, s3;
  for (n3 = t3[0], r3 = 0, a3 = (i = t3.slice(1)).length; r3 < a3; ++r3)
    e28(s3 = i[r3]) > e28(n3) && (n3 = s3);
  return n3;
}), TF = dt$3(function(e28, t3) {
  var n3, r3, i, a3, s3;
  for (n3 = t3[0], r3 = 0, a3 = (i = t3.slice(1)).length; r3 < a3; ++r3)
    e28(s3 = i[r3]) < e28(n3) && (n3 = s3);
  return n3;
}), $u$1 = PF = dt$3(function(e28, t3, n3) {
  var r3, i;
  return r3 = t3, [t3].concat(function() {
    var a3, s3, o3, u3 = [];
    for (a3 = 0, o3 = (s3 = n3).length; a3 < o3; ++a3)
      i = s3[a3], u3.push(r3 = e28(r3, i));
    return u3;
  }());
}), IF = BF = dt$3(function(e28, t3) {
  if (t3.length)
    return $u$1(e28, t3[0], t3.slice(1));
}), OF = dt$3(function(e28, t3, n3) {
  return n3 = n3.concat().reverse(), $u$1(e28, t3, n3).reverse();
}), LF = dt$3(function(e28, t3) {
  if (t3.length)
    return t3 = t3.concat().reverse(), $u$1(e28, t3[0], t3.slice(1)).reverse();
}), NF = dt$3(function(e28, t3, n3) {
  return n3.slice(e28, t3);
}), Qm = dt$3(function(e28, t3) {
  return e28 <= 0 ? t3.slice(0, 0) : t3.slice(0, e28);
}), Xm = dt$3(function(e28, t3) {
  return e28 <= 0 ? t3 : t3.slice(e28);
}), jF = dt$3(function(e28, t3) {
  return [Qm(e28, t3), Xm(e28, t3)];
}), Ym = dt$3(function(e28, t3) {
  var n3, r3;
  if (!(n3 = t3.length))
    return t3;
  for (r3 = 0; r3 < n3 && e28(t3[r3]); )
    r3 += 1;
  return t3.slice(0, r3);
}), Zm = dt$3(function(e28, t3) {
  var n3, r3;
  if (!(n3 = t3.length))
    return t3;
  for (r3 = 0; r3 < n3 && e28(t3[r3]); )
    r3 += 1;
  return t3.slice(r3);
}), e0 = dt$3(function(e28, t3) {
  return [Ym(e28, t3), Zm(e28, t3)];
}), RF = dt$3(function(e28, t3) {
  return e0(function() {
    var n3 = arguments;
    return function() {
      var r3, i;
      for (i = n3[0].apply(this, arguments), r3 = 1; r3 < n3.length; ++r3)
        i = n3[r3](i);
      return i;
    };
  }(e28, LT), t3);
}), MF = dt$3(function(e28, t3) {
  var n3, r3, i, a3, s3, o3;
  for (n3 = [], r3 = t3.length, i = 0, a3 = e28.length; i < a3 && (s3 = i, o3 = e28[i], s3 !== r3); ++i)
    n3.push([o3, t3[s3]]);
  return n3;
}), VF = dt$3(function(e28, t3, n3) {
  var r3, i, a3, s3, o3, u3;
  for (r3 = [], i = n3.length, a3 = 0, s3 = t3.length; a3 < s3 && (o3 = a3, u3 = t3[a3], o3 !== i); ++a3)
    r3.push(e28(u3, n3[o3]));
  return r3;
}), UF = function() {
  var e28, t3, n3, r3, i, a3, s3, o3, u3, c3 = [];
  for (t3 = void 0, n3 = 0, r3 = (e28 = wu$1.call(arguments)).length; n3 < r3; ++n3)
    t3 <= (a3 = (i = e28[n3]).length) || (t3 = a3);
  for (n3 = 0; n3 < t3; ++n3) {
    for (s3 = n3, o3 = [], u3 = 0, r3 = e28.length; u3 < r3; ++u3)
      i = e28[u3], o3.push(i[s3]);
    c3.push(o3);
  }
  return c3;
}, qF = function(e28) {
  var t3, n3, r3, i, a3, s3, o3, u3 = [];
  for (n3 = void 0, r3 = 0, i = (t3 = wu$1.call(arguments, 1)).length; r3 < i; ++r3)
    n3 <= (s3 = (a3 = t3[r3]).length) || (n3 = s3);
  for (r3 = 0; r3 < n3; ++r3)
    o3 = r3, u3.push(e28.apply(null, c3()));
  return u3;
  function c3() {
    var f3, p3, d3, m3 = [];
    for (f3 = 0, d3 = (p3 = t3).length; f3 < d3; ++f3)
      a3 = p3[f3], m3.push(a3[o3]);
    return m3;
  }
}, WF = dt$3(function(e28, t3) {
  return e28 < 0 ? t3[t3.length + e28] : t3[e28];
}), $F = dt$3(function(e28, t3) {
  var n3, r3, i;
  for (n3 = 0, r3 = t3.length; n3 < r3; ++n3)
    if (i = n3, t3[n3] === e28)
      return i;
}), GF = dt$3(function(e28, t3) {
  var n3, r3, i, a3 = [];
  for (n3 = 0, r3 = t3.length; n3 < r3; ++n3)
    i = n3, t3[n3] === e28 && a3.push(i);
  return a3;
}), zF = dt$3(function(e28, t3) {
  var n3, r3, i;
  for (n3 = 0, r3 = t3.length; n3 < r3; ++n3)
    if (i = n3, e28(t3[n3]))
      return i;
}), HF = dt$3(function(e28, t3) {
  var n3, r3, i, a3 = [];
  for (n3 = 0, r3 = t3.length; n3 < r3; ++n3)
    i = n3, e28(t3[n3]) && a3.push(i);
  return a3;
});
var KF, OT = { each: qD, map: WD, filter: GD, compact: $D, reject: zD, partition: HD, find: KD, head: JD, first: QD, tail: XD, last: YD, initial: ZD, empty: eF, reverse: tF, difference: pF, intersection: fF, union: hF, countBy: dF, groupBy: mF, fold: Hm, fold1: aF, foldl: iF, foldl1: oF, foldr: Km, foldr1: sF, unfoldr: uF, andList: gF, orList: yF, any: vF, all: xF, unique: nF, uniqueBy: rF, sort: bF, sortWith: EF, sortBy: CF, sum: SF, product: kF, mean: DF, average: FF, concat: cF, concatMap: lF, flatten: Jm, maximum: wF, minimum: AF, maximumBy: _F, minimumBy: TF, scan: $u$1, scan1: IF, scanl: PF, scanl1: BF, scanr: OF, scanr1: LF, slice: NF, take: Qm, drop: Xm, splitAt: jF, takeWhile: Ym, dropWhile: Zm, span: e0, breakList: RF, zip: MF, zipWith: VF, zipAll: UF, zipAllWith: qF, at: WF, elemIndex: $F, elemIndices: GF, findIndex: zF, findIndices: HF };
function dt$3(e28, t3) {
  var n3;
  return function r3(i) {
    return e28.length > 1 ? function() {
      var a3 = i ? i.concat() : [];
      return n3 = t3 && n3 || this, a3.push.apply(a3, arguments) < e28.length && arguments.length ? r3.call(n3, a3) : e28.apply(n3, a3);
    } : e28;
  }();
}
function Au$1(e28, t3) {
  for (var n3 = -1, r3 = t3.length >>> 0; ++n3 < r3; )
    if (e28 === t3[n3])
      return true;
  return false;
}
function LT(e28) {
  return !e28;
}
KF = function(e28) {
  var t3, n3, r3 = {};
  for (t3 in e28)
    (n3 = e28[t3]) && (r3[t3] = n3);
  return r3;
};
var NT = { values: function(e28) {
  var t3, n3, r3 = [];
  for (t3 in e28)
    n3 = e28[t3], r3.push(n3);
  return r3;
}, keys: function(e28) {
  var t3, n3 = [];
  for (t3 in e28)
    n3.push(t3);
  return n3;
}, pairsToObj: function(e28) {
  var t3, n3, r3, i = {};
  for (t3 = 0, n3 = e28.length; t3 < n3; ++t3)
    i[(r3 = e28[t3])[0]] = r3[1];
  return i;
}, objToPairs: function(e28) {
  var t3, n3, r3 = [];
  for (t3 in e28)
    n3 = e28[t3], r3.push([t3, n3]);
  return r3;
}, listsToObj: So$2(function(e28, t3) {
  var n3, r3, i, a3 = {};
  for (n3 = 0, r3 = e28.length; n3 < r3; ++n3)
    i = n3, a3[e28[n3]] = t3[i];
  return a3;
}), objToLists: function(e28) {
  var t3, n3, r3, i;
  for (r3 in t3 = [], n3 = [], e28)
    i = e28[r3], t3.push(r3), n3.push(i);
  return [t3, n3];
}, empty: function(e28) {
  var t3;
  for (t3 in e28)
    return false;
  return true;
}, each: So$2(function(e28, t3) {
  var n3;
  for (n3 in t3)
    e28(t3[n3]);
  return t3;
}), map: So$2(function(e28, t3) {
  var n3, r3, i = {};
  for (n3 in t3)
    r3 = t3[n3], i[n3] = e28(r3);
  return i;
}), filter: So$2(function(e28, t3) {
  var n3, r3, i = {};
  for (n3 in t3)
    e28(r3 = t3[n3]) && (i[n3] = r3);
  return i;
}), compact: KF, reject: So$2(function(e28, t3) {
  var n3, r3, i = {};
  for (n3 in t3)
    e28(r3 = t3[n3]) || (i[n3] = r3);
  return i;
}), partition: So$2(function(e28, t3) {
  var n3, r3, i, a3;
  for (i in n3 = {}, r3 = {}, t3)
    (e28(a3 = t3[i]) ? n3 : r3)[i] = a3;
  return [n3, r3];
}), find: So$2(function(e28, t3) {
  var n3, r3;
  for (n3 in t3)
    if (e28(r3 = t3[n3]))
      return r3;
}) };
function So$2(e28, t3) {
  var n3;
  return function r3(i) {
    return e28.length > 1 ? function() {
      var a3 = i ? i.concat() : [];
      return n3 = t3 && n3 || this, a3.push.apply(a3, arguments) < e28.length && arguments.length ? r3.call(n3, a3) : e28.apply(n3, a3);
    } : e28;
  }();
}
var JF, QF, XF, YF, ZF, ew, tw, nw, rw, iw, aw, ow, sw, uw, cw, lw, pw, fw, hw, dw, mw, gw, yw, vw, xw, bw, Ew, Cw, Sw, kw, t0, Dw, jT = { split: Ld$1(function(e28, t3) {
  return t3.split(e28);
}), join: Ld$1(function(e28, t3) {
  return t3.join(e28);
}), lines: function(e28) {
  return e28.length ? e28.split(`
`) : [];
}, unlines: function(e28) {
  return e28.join(`
`);
}, words: function(e28) {
  return e28.length ? e28.split(/[ ]+/) : [];
}, unwords: function(e28) {
  return e28.join(" ");
}, chars: function(e28) {
  return e28.split("");
}, unchars: function(e28) {
  return e28.join("");
}, reverse: function(e28) {
  return e28.split("").reverse().join("");
}, repeat: Ld$1(function(e28, t3) {
  var n3, r3;
  for (n3 = "", r3 = 0; r3 < e28; ++r3)
    n3 += t3;
  return n3;
}), capitalize: function(e28) {
  return e28.charAt(0).toUpperCase() + e28.slice(1);
}, camelize: function(e28) {
  return e28.replace(/[-_]+(.)?/g, function(t3, n3) {
    return (n3 != null ? n3 : "").toUpperCase();
  });
}, dasherize: function(e28) {
  return e28.replace(/([^-A-Z])([A-Z]+)/g, function(t3, n3, r3) {
    return n3 + "-" + (r3.length > 1 ? r3 : r3.toLowerCase());
  }).replace(/^([A-Z]+)/, function(t3, n3) {
    return n3.length > 1 ? n3 + "-" : n3.toLowerCase();
  });
} };
function Ld$1(e28, t3) {
  var n3;
  return function r3(i) {
    return e28.length > 1 ? function() {
      var a3 = i ? i.concat() : [];
      return n3 = t3 && n3 || this, a3.push.apply(a3, arguments) < e28.length && arguments.length ? r3.call(n3, a3) : e28.apply(n3, a3);
    } : e28;
  }();
}
function Bi$1(e28, t3) {
  var n3;
  return function r3(i) {
    return e28.length > 1 ? function() {
      var a3 = i ? i.concat() : [];
      return n3 = t3 && n3 || this, a3.push.apply(a3, arguments) < e28.length && arguments.length ? r3.call(n3, a3) : e28.apply(n3, a3);
    } : e28;
  }();
}
JF = Bi$1(function(e28, t3) {
  return e28 > t3 ? e28 : t3;
}), QF = Bi$1(function(e28, t3) {
  return e28 < t3 ? e28 : t3;
}), XF = function(e28) {
  return -e28;
}, YF = Math.abs, ZF = function(e28) {
  return e28 < 0 ? -1 : e28 > 0 ? 1 : 0;
}, ew = Bi$1(function(e28, t3) {
  return ~~(e28 / t3);
}), tw = Bi$1(function(e28, t3) {
  return e28 % t3;
}), nw = Bi$1(function(e28, t3) {
  return Math.floor(e28 / t3);
}), rw = Bi$1(function(e28, t3) {
  var n3;
  return (e28 % (n3 = t3) + n3) % n3;
}), iw = function(e28) {
  return 1 / e28;
}, ow = 2 * (aw = Math.PI), sw = Math.exp, uw = Math.sqrt, cw = Math.log, lw = Bi$1(function(e28, t3) {
  return Math.pow(e28, t3);
}), pw = Math.sin, fw = Math.tan, hw = Math.cos, dw = Math.asin, mw = Math.acos, gw = Math.atan, yw = Bi$1(function(e28, t3) {
  return Math.atan2(e28, t3);
}), vw = function(e28) {
  return ~~e28;
}, xw = Math.round, bw = Math.ceil, Ew = Math.floor, Cw = function(e28) {
  return e28 != e28;
}, Sw = function(e28) {
  return e28 % 2 == 0;
}, kw = function(e28) {
  return e28 % 2 != 0;
}, t0 = Bi$1(function(e28, t3) {
  var n3;
  for (e28 = Math.abs(e28), t3 = Math.abs(t3); t3 !== 0; )
    n3 = e28 % t3, e28 = t3, t3 = n3;
  return e28;
}), Dw = Bi$1(function(e28, t3) {
  return Math.abs(Math.floor(e28 / t0(e28, t3) * t3));
});
var ko$1, Be$2, $a$2, ln$1, Tt$2, fb, hb$1, db$1, me$5, RT = {}.toString;
ko$1 = IT, Be$2 = OT, $a$2 = NT, ln$1 = jT, Tt$2 = { max: JF, min: QF, negate: XF, abs: YF, signum: ZF, quot: ew, rem: tw, div: nw, mod: rw, recip: iw, pi: aw, tau: ow, exp: sw, sqrt: uw, ln: cw, pow: lw, sin: pw, tan: fw, cos: hw, acos: mw, asin: dw, atan: gw, atan2: yw, truncate: vw, round: xw, ceiling: bw, floor: Ew, isItNaN: Cw, even: Sw, odd: kw, gcd: t0, lcm: Dw }, fb = function(e28) {
  return e28;
}, hb$1 = mb$1(function(e28, t3) {
  return RT.call(t3).slice(8, -1) === e28;
}), db$1 = mb$1(function(e28, t3) {
  var n3, r3 = [];
  for (n3 = 0; n3 < e28; ++n3)
    r3.push(t3);
  return r3;
}), ln$1.empty = Be$2.empty, ln$1.slice = Be$2.slice, ln$1.take = Be$2.take, ln$1.drop = Be$2.drop, ln$1.splitAt = Be$2.splitAt, ln$1.takeWhile = Be$2.takeWhile, ln$1.dropWhile = Be$2.dropWhile, ln$1.span = Be$2.span, ln$1.breakStr = Be$2.breakList, (me$5 = { Func: ko$1, List: Be$2, Obj: $a$2, Str: ln$1, Num: Tt$2, id: fb, isType: hb$1, replicate: db$1 }).each = Be$2.each, me$5.map = Be$2.map, me$5.filter = Be$2.filter, me$5.compact = Be$2.compact, me$5.reject = Be$2.reject, me$5.partition = Be$2.partition, me$5.find = Be$2.find, me$5.head = Be$2.head, me$5.first = Be$2.first, me$5.tail = Be$2.tail, me$5.last = Be$2.last, me$5.initial = Be$2.initial, me$5.empty = Be$2.empty, me$5.reverse = Be$2.reverse, me$5.difference = Be$2.difference, me$5.intersection = Be$2.intersection, me$5.union = Be$2.union, me$5.countBy = Be$2.countBy, me$5.groupBy = Be$2.groupBy, me$5.fold = Be$2.fold, me$5.foldl = Be$2.foldl, me$5.fold1 = Be$2.fold1, me$5.foldl1 = Be$2.foldl1, me$5.foldr = Be$2.foldr, me$5.foldr1 = Be$2.foldr1, me$5.unfoldr = Be$2.unfoldr, me$5.andList = Be$2.andList, me$5.orList = Be$2.orList, me$5.any = Be$2.any, me$5.all = Be$2.all, me$5.unique = Be$2.unique, me$5.uniqueBy = Be$2.uniqueBy, me$5.sort = Be$2.sort, me$5.sortWith = Be$2.sortWith, me$5.sortBy = Be$2.sortBy, me$5.sum = Be$2.sum, me$5.product = Be$2.product, me$5.mean = Be$2.mean, me$5.average = Be$2.average, me$5.concat = Be$2.concat, me$5.concatMap = Be$2.concatMap, me$5.flatten = Be$2.flatten, me$5.maximum = Be$2.maximum, me$5.minimum = Be$2.minimum, me$5.maximumBy = Be$2.maximumBy, me$5.minimumBy = Be$2.minimumBy, me$5.scan = Be$2.scan, me$5.scanl = Be$2.scanl, me$5.scan1 = Be$2.scan1, me$5.scanl1 = Be$2.scanl1, me$5.scanr = Be$2.scanr, me$5.scanr1 = Be$2.scanr1, me$5.slice = Be$2.slice, me$5.take = Be$2.take, me$5.drop = Be$2.drop, me$5.splitAt = Be$2.splitAt, me$5.takeWhile = Be$2.takeWhile, me$5.dropWhile = Be$2.dropWhile, me$5.span = Be$2.span, me$5.breakList = Be$2.breakList, me$5.zip = Be$2.zip, me$5.zipWith = Be$2.zipWith, me$5.zipAll = Be$2.zipAll, me$5.zipAllWith = Be$2.zipAllWith, me$5.at = Be$2.at, me$5.elemIndex = Be$2.elemIndex, me$5.elemIndices = Be$2.elemIndices, me$5.findIndex = Be$2.findIndex, me$5.findIndices = Be$2.findIndices, me$5.apply = ko$1.apply, me$5.curry = ko$1.curry, me$5.flip = ko$1.flip, me$5.fix = ko$1.fix, me$5.over = ko$1.over, me$5.split = ln$1.split, me$5.join = ln$1.join, me$5.lines = ln$1.lines, me$5.unlines = ln$1.unlines, me$5.words = ln$1.words, me$5.unwords = ln$1.unwords, me$5.chars = ln$1.chars, me$5.unchars = ln$1.unchars, me$5.repeat = ln$1.repeat, me$5.capitalize = ln$1.capitalize, me$5.camelize = ln$1.camelize, me$5.dasherize = ln$1.dasherize, me$5.values = $a$2.values, me$5.keys = $a$2.keys, me$5.pairsToObj = $a$2.pairsToObj, me$5.objToPairs = $a$2.objToPairs, me$5.listsToObj = $a$2.listsToObj, me$5.objToLists = $a$2.objToLists, me$5.max = Tt$2.max, me$5.min = Tt$2.min, me$5.negate = Tt$2.negate, me$5.abs = Tt$2.abs, me$5.signum = Tt$2.signum, me$5.quot = Tt$2.quot, me$5.rem = Tt$2.rem, me$5.div = Tt$2.div, me$5.mod = Tt$2.mod, me$5.recip = Tt$2.recip, me$5.pi = Tt$2.pi, me$5.tau = Tt$2.tau, me$5.exp = Tt$2.exp, me$5.sqrt = Tt$2.sqrt, me$5.ln = Tt$2.ln, me$5.pow = Tt$2.pow, me$5.sin = Tt$2.sin, me$5.tan = Tt$2.tan, me$5.cos = Tt$2.cos, me$5.acos = Tt$2.acos, me$5.asin = Tt$2.asin, me$5.atan = Tt$2.atan, me$5.atan2 = Tt$2.atan2, me$5.truncate = Tt$2.truncate, me$5.round = Tt$2.round, me$5.ceiling = Tt$2.ceiling, me$5.floor = Tt$2.floor, me$5.isItNaN = Tt$2.isItNaN, me$5.even = Tt$2.even, me$5.odd = Tt$2.odd, me$5.gcd = Tt$2.gcd, me$5.lcm = Tt$2.lcm, me$5.VERSION = "1.1.2";
var Fw = me$5;
function mb$1(e28, t3) {
  var n3;
  return function r3(i) {
    return e28.length > 1 ? function() {
      var a3 = i ? i.concat() : [];
      return n3 = t3 && n3 || this, a3.push.apply(a3, arguments) < e28.length && arguments.length ? r3.call(n3, a3) : e28.apply(n3, a3);
    } : e28;
  }();
}
var MT = gt$3(function(e28) {
  (function() {
    var t3, n3, r3;
    function i(m3, y3) {
      if (m3[0] === y3)
        return m3.shift();
      throw new Error("Expected '" + y3 + "', but got '" + m3[0] + "' instead in " + JSON.stringify(m3) + ".");
    }
    function a3(m3, y3) {
      if (m3[0] === y3)
        return m3.shift();
    }
    function s3(m3, y3, v3) {
      var b3, x3, C3, k3;
      for (b3 = y3[0], x3 = y3[1], v3 && i(m3, b3), C3 = [], k3 = "," + (v3 ? x3 : ""); m3.length && v3 && m3[0] !== x3; )
        C3.push(p3(m3, k3)), a3(m3, ",");
      return v3 && i(m3, x3), C3;
    }
    function o3(m3, y3) {
      return s3(m3, ["[", "]"], y3);
    }
    function u3(m3, y3) {
      return s3(m3, ["(", ")"], y3);
    }
    function c3(m3, y3) {
      var v3, b3, x3;
      for (y3 && i(m3, "{"), v3 = {}, b3 = "," + (y3 ? "}" : ""); m3.length && (!y3 || m3[0] !== "}"); )
        x3 = f3(m3, ":"), i(m3, ":"), v3[x3] = p3(m3, b3), a3(m3, ",");
      return y3 && i(m3, "}"), v3;
    }
    function f3(m3, y3) {
      var v3;
      for (y3 == null && (y3 = ""), v3 = ""; m3.length && y3.indexOf(m3[0]) === -1; )
        v3 += m3.shift();
      return v3;
    }
    function p3(m3, y3) {
      switch (m3[0]) {
        case "[":
          return o3(m3, true);
        case "(":
          return u3(m3, true);
        case "{":
          return c3(m3, true);
        default:
          return f3(m3, y3);
      }
    }
    function d3(m3) {
      return !m3;
    }
    t3 = Fw.reject, n3 = /\[\]\(\)}{:,/.source, r3 = RegExp(`("(?:\\\\"|[^"])*")|('(?:\\\\'|[^'])*')|(/(?:\\\\/|[^/])*/[a-zA-Z]*)|(#.*#)|([` + n3 + "])|([^\\s" + n3 + "](?:\\s*[^\\s" + n3 + "]+)*)|\\s*"), e28.exports = function(m3, y3, v3) {
      var b3;
      if (v3 == null && (v3 = {}), !v3.explicit && m3.length === 1 && m3[0].type === "String")
        return "'" + y3.replace(/\\'/g, "\\\\'") + "'";
      if (!(b3 = function(x3, C3, k3) {
        var F3, B3, O3, S3, w3, D3, I3, L3;
        return B3 = (F3 = C3[0]).type, O3 = F3.structure, S3 = x3.concat(), k3.explicit || C3.length !== 1 || (B3 || !O3) && B3 !== "Array" && B3 !== "Object" ? D3 = p3(x3) : (w3 = O3 === "array" || B3 === "Array" ? o3(x3, x3[0] === "[") : O3 === "tuple" ? u3(x3, x3[0] === "(") : c3(x3, x3[0] === "{"), D3 = x3.length ? p3(O3 === "array" || B3 === "Array" ? ((I3 = S3).unshift("["), I3.push("]"), I3) : ((L3 = S3).unshift("("), L3.push(")"), L3)) : w3), D3;
      }(t3(d3, y3.split(r3)), m3, v3)))
        throw new Error("Error parsing '" + y3 + "'.");
      return b3;
    };
  }).call(ni$1);
}), VT = gt$3(function(e28) {
  (function() {
    var t3, n3;
    function r3(p3) {
      var d3;
      if ((d3 = p3[0]) == null)
        throw new Error("Unexpected end of input.");
      return d3;
    }
    function i(p3) {
      var d3;
      if (d3 = r3(p3), !t3.test(d3))
        throw new Error("Expected text, got '" + d3 + "' instead.");
      return p3.shift();
    }
    function a3(p3, d3) {
      var m3;
      if ((m3 = r3(p3)) !== d3)
        throw new Error("Expected '" + d3 + "', got '" + m3 + "' instead.");
      return p3.shift();
    }
    function s3(p3, d3) {
      return p3[0] === d3 ? p3.shift() : null;
    }
    function o3(p3) {
      var d3;
      return d3 = i(p3), a3(p3, ":"), [d3, f3(p3)];
    }
    function u3(p3) {
      switch (p3[0]) {
        case "[":
          return function(d3) {
            var m3;
            if (a3(d3, "["), r3(d3) === "]")
              throw new Error("Must specify type of Array - eg. [Type], got [] instead.");
            return m3 = f3(d3), a3(d3, "]"), { structure: "array", of: m3 };
          }(p3);
        case "(":
          return function(d3) {
            var m3;
            if (m3 = [], a3(d3, "("), r3(d3) === ")")
              throw new Error("Tuple must be of at least length 1 - eg. (Type), got () instead.");
            for (; m3.push(f3(d3)), s3(d3, ","), r3(d3) !== ")"; )
              ;
            return a3(d3, ")"), { structure: "tuple", of: m3 };
          }(p3);
        case "{":
          return function(d3) {
            var m3, y3, v3, b3, x3;
            for (m3 = {}, a3(d3, "{"), y3 = false; ; ) {
              if (s3(d3, "...")) {
                y3 = true;
                break;
              }
              if (b3 = (v3 = o3(d3))[0], x3 = v3[1], m3[b3] = x3, s3(d3, ","), r3(d3) === "}")
                break;
            }
            return a3(d3, "}"), { structure: "fields", of: m3, subset: y3 };
          }(p3);
      }
    }
    function c3(p3) {
      var d3, m3, y3, v3;
      if ((m3 = (d3 = r3(p3)) === "*") || t3.test(d3))
        return y3 = m3 ? a3(p3, "*") : i(p3), (v3 = u3(p3)) ? (v3.type = y3, v3) : { type: y3 };
      if (!(v3 = u3(p3)))
        throw new Error("Unexpected character: " + d3);
      return v3;
    }
    function f3(p3) {
      var d3, m3, y3, v3, b3;
      if (r3(p3) === "::")
        throw new Error("No comment before comment separator '::' found.");
      for ((d3 = p3[1]) != null && d3 === "::" && (p3.shift(), p3.shift()), m3 = [], y3 = {}, r3(p3) === "Maybe" && (p3.shift(), m3 = [{ type: "Undefined" }, { type: "Null" }], y3 = { Undefined: true, Null: true }); y3[b3 = (v3 = c3(p3)).type] || m3.push(v3), y3[b3] = true, s3(p3, "|"); )
        ;
      return m3;
    }
    t3 = /[\$\w]+/, n3 = RegExp("\\.\\.\\.|::|->|" + t3.source + "|\\S", "g"), e28.exports = function(p3) {
      var d3;
      if (!p3.length)
        throw new Error("No type specified.");
      if (function(m3, y3) {
        for (var v3 = -1, b3 = y3.length >>> 0; ++v3 < b3; )
          if (m3 === y3[v3])
            return true;
        return false;
      }("->", d3 = p3.match(n3) || []))
        throw new Error("Function types are not supported. To validate that something is a function, you may use 'Function'.");
      try {
        return f3(d3);
      } catch (m3) {
        throw new Error(m3.message + " - Remaining tokens: " + JSON.stringify(d3) + " - Initial input: '" + p3 + "'");
      }
    };
  }).call(ni$1);
}), UT = gt$3(function(e28) {
  (function() {
    var t3, n3, r3, i, a3, s3, o3, u3 = {}.toString;
    function c3(d3, m3) {
      if (!(d3 instanceof Object))
        return false;
      switch (m3.structure) {
        case "fields":
          return function(y3, v3) {
            var b3, x3, C3, k3, F3, B3, O3;
            for (C3 in b3 = {}, x3 = 0, y3)
              b3[C3] = true, x3++;
            for (F3 in k3 = 0, B3 = v3.of) {
              if (O3 = B3[F3], !p3(y3[F3], O3))
                return false;
              b3[F3] && k3++;
            }
            return v3.subset || x3 === k3;
          }(d3, m3);
        case "array":
          return function(y3, v3) {
            return r3(function(b3) {
              return p3(b3, v3.of);
            }, y3);
          }(d3, m3);
        case "tuple":
          return function(y3, v3) {
            var b3, x3, C3, k3, F3;
            for (b3 = 0, x3 = 0, k3 = (C3 = v3.of).length; x3 < k3; ++x3) {
              if (F3 = C3[x3], !p3(y3[b3], F3))
                return false;
              b3++;
            }
            return y3.length <= b3;
          }(d3, m3);
      }
    }
    function f3(d3, m3) {
      var y3, v3, b3, x3;
      if (y3 = m3.type, v3 = m3.structure, y3)
        return y3 === "*" || ((b3 = o3[y3] || a3[y3]) ? b3.typeOf === u3.call(d3).slice(8, -1) && b3.validate(d3) : y3 === u3.call(d3).slice(8, -1) && (!v3 || c3(d3, m3)));
      if (v3)
        return (!(x3 = s3[v3]) || x3 === u3.call(d3).slice(8, -1)) && c3(d3, m3);
      throw new Error("No type defined. Input: " + d3 + ".");
    }
    function p3(d3, m3) {
      if (u3.call(m3).slice(8, -1) !== "Array")
        throw new Error("Types must be in an array. Input: " + d3 + ".");
      return n3(function(y3) {
        return f3(d3, y3);
      }, m3);
    }
    n3 = (t3 = Fw).any, r3 = t3.all, i = t3.isItNaN, a3 = { Number: { typeOf: "Number", validate: function(d3) {
      return !i(d3);
    } }, NaN: { typeOf: "Number", validate: i }, Int: { typeOf: "Number", validate: function(d3) {
      return !i(d3) && d3 % 1 == 0;
    } }, Float: { typeOf: "Number", validate: function(d3) {
      return !i(d3);
    } }, Date: { typeOf: "Date", validate: function(d3) {
      return !i(d3.getTime());
    } } }, s3 = { array: "Array", tuple: "Array" }, e28.exports = function(d3, m3, y3) {
      return y3 == null && (y3 = {}), o3 = y3.customTypes || {}, p3(m3, d3);
    };
  }).call(ni$1);
}), vs$1 = gt$3(function(e28) {
  (function() {
    var t3, n3, r3;
    t3 = VT, n3 = UT, r3 = function(i, a3, s3) {
      return n3(t3(i), a3, s3);
    }, e28.exports = { VERSION: "0.3.2", typeCheck: r3, parsedTypeCheck: n3, parseType: t3 };
  }).call(ni$1);
}), qT = (vs$1.VERSION, vs$1.typeCheck, vs$1.parsedTypeCheck, vs$1.parseType, gt$3(function(e28) {
  (function() {
    var t3, n3, r3 = {}.toString;
    function i(u3, c3, f3) {
      var p3, d3;
      return r3.call(u3).slice(8, -1) !== "Array" ? { type: "Nothing" } : (p3 = c3.of, { type: "Just", value: function() {
        var m3, y3, v3, b3 = [];
        for (m3 = 0, v3 = (y3 = u3).length; m3 < v3; ++m3)
          d3 = y3[m3], b3.push(o3(d3, p3, f3));
        return b3;
      }() });
    }
    function a3(u3, c3, f3) {
      var p3, d3, m3;
      return r3.call(u3).slice(8, -1) !== "Object" ? { type: "Nothing" } : (p3 = c3.of, { type: "Just", value: function() {
        var y3, v3 = {};
        for (d3 in y3 = u3)
          m3 = y3[d3], v3[o3(d3, [{ type: "String" }], f3)] = o3(m3, p3[d3] || [{ type: "*" }], f3);
        return v3;
      }() });
    }
    function s3(u3, c3, f3) {
      var p3, d3, m3, y3;
      if (p3 = c3.type, d3 = c3.structure, p3) {
        if (!(m3 = ((y3 = f3.customTypes[p3]) != null ? y3.cast : void 0) || n3[p3]))
          throw new Error("Type not defined: " + p3 + ".");
        return m3(u3, f3, o3);
      }
      switch (d3) {
        case "array":
          return i(u3, c3, f3);
        case "tuple":
          return function(v3, b3, x3) {
            var C3, k3, F3, B3, O3, S3, w3;
            if (r3.call(v3).slice(8, -1) !== "Array")
              return { type: "Nothing" };
            for (C3 = [], k3 = 0, F3 = 0, O3 = (B3 = b3.of).length; F3 < O3; ++F3)
              S3 = B3[F3], w3 = o3(v3[k3], S3, x3), r3.call(w3).slice(8, -1) !== "Undefined" && C3.push(w3), k3++;
            return v3.length <= k3 ? { type: "Just", value: C3 } : { type: "Nothing" };
          }(u3, c3, f3);
        case "fields":
          return a3(u3, c3, f3);
      }
    }
    function o3(u3, c3, f3) {
      var p3, d3, m3, y3, v3, b3;
      for (p3 = 0, d3 = c3.length; p3 < d3; ++p3)
        if (v3 = (y3 = s3(u3, m3 = c3[p3], f3)).type, b3 = y3.value, v3 !== "Nothing" && t3([m3], b3, { customTypes: f3.customTypes }))
          return b3;
      throw new Error("Value " + JSON.stringify(u3) + " does not type check against " + JSON.stringify(c3) + ".");
    }
    t3 = vs$1.parsedTypeCheck, n3 = { "*": function(u3, c3) {
      switch (r3.call(u3).slice(8, -1)) {
        case "Array":
          return s3(u3, { type: "Array" }, c3);
        case "Object":
          return s3(u3, { type: "Object" }, c3);
        default:
          return { type: "Just", value: o3(u3, [{ type: "Undefined" }, { type: "Null" }, { type: "NaN" }, { type: "Boolean" }, { type: "Number" }, { type: "Date" }, { type: "RegExp" }, { type: "Array" }, { type: "Object" }, { type: "String" }], (c3.explicit = true, c3)) };
      }
    }, Undefined: function(u3) {
      return u3 === "undefined" || u3 === void 0 ? { type: "Just", value: void 0 } : { type: "Nothing" };
    }, Null: function(u3) {
      return u3 === "null" ? { type: "Just", value: null } : { type: "Nothing" };
    }, NaN: function(u3) {
      function c3(f3) {
        return u3.apply(this, arguments);
      }
      return c3.toString = function() {
        return u3.toString();
      }, c3;
    }(function(u3) {
      return u3 === "NaN" ? { type: "Just", value: NaN } : { type: "Nothing" };
    }), Boolean: function(u3) {
      return u3 === "true" ? { type: "Just", value: true } : u3 === "false" ? { type: "Just", value: false } : { type: "Nothing" };
    }, Number: function(u3) {
      return { type: "Just", value: +u3 };
    }, Int: function(u3) {
      return { type: "Just", value: +u3 };
    }, Float: function(u3) {
      return { type: "Just", value: +u3 };
    }, Date: function(u3) {
      function c3(f3, p3) {
        return u3.apply(this, arguments);
      }
      return c3.toString = function() {
        return u3.toString();
      }, c3;
    }(function(u3, c3) {
      var f3;
      return (f3 = /^\#([\s\S]*)\#$/.exec(u3)) ? { type: "Just", value: new Date(+f3[1] || f3[1]) } : c3.explicit ? { type: "Nothing" } : { type: "Just", value: new Date(+u3 || u3) };
    }), RegExp: function(u3) {
      function c3(f3, p3) {
        return u3.apply(this, arguments);
      }
      return c3.toString = function() {
        return u3.toString();
      }, c3;
    }(function(u3, c3) {
      var f3;
      return (f3 = /^\/([\s\S]*)\/([gimy]*)$/.exec(u3)) ? { type: "Just", value: new RegExp(f3[1], f3[2]) } : c3.explicit ? { type: "Nothing" } : { type: "Just", value: new RegExp(u3) };
    }), Array: function(u3, c3) {
      return i(u3, { of: [{ type: "*" }] }, c3);
    }, Object: function(u3, c3) {
      return a3(u3, { of: {} }, c3);
    }, String: function(u3) {
      var c3;
      return r3.call(u3).slice(8, -1) !== "String" ? { type: "Nothing" } : (c3 = u3.match(/^'([\s\S]*)'$/)) ? { type: "Just", value: c3[1].replace(/\\'/g, "'") } : (c3 = u3.match(/^"([\s\S]*)"$/)) ? { type: "Just", value: c3[1].replace(/\\"/g, '"') } : { type: "Just", value: u3 };
    } }, e28.exports = o3;
  }).call(ni$1);
})), lp$1 = gt$3(function(e28) {
  (function() {
    var t3, n3, r3, i, a3;
    t3 = MT, n3 = qT, r3 = vs$1.parseType, i = function(s3, o3, u3) {
      return u3 == null && (u3 = {}), u3.explicit == null && (u3.explicit = false), u3.customTypes == null && (u3.customTypes = {}), n3(t3(s3, o3, u3), s3, u3);
    }, a3 = function(s3, o3, u3) {
      return i(r3(s3), o3, u3);
    }, e28.exports = { VERSION: "0.3.0", parse: a3, parsedTypeParse: i };
  }).call(ni$1);
}), WT = (lp$1.VERSION, lp$1.parse, lp$1.parsedTypeParse, gt$3(function(e28) {
  var t3 = function() {
    function n3(i) {
      return '"' + i.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\x08/g, "\\b").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\f/g, "\\f").replace(/\r/g, "\\r").replace(/[\x00-\x07\x0B\x0E-\x1F\x80-\uFFFF]/g, escape) + '"';
    }
    var r3 = { parse: function(i, a3) {
      var s3 = { start: function() {
        var _3, Q3, Y3, ae2, ue2, De2 = "start@" + o3, Ee2 = f3[De2];
        if (Ee2)
          return o3 = Ee2.nextPos, Ee2.result;
        ae2 = o3, ue2 = o3, (_3 = d3()) !== null && (Q3 = v3()) !== null && (Y3 = d3()) !== null ? _3 = [_3, Q3, Y3] : (_3 = null, o3 = ue2), _3 !== null && (_e2 = _3[1], _3 = _e2.length === 1 ? _e2[0] : { type: "matches", selectors: _e2 });
        var _e2;
        return _3 === null && (o3 = ae2), _3 === null && (ae2 = o3, (_3 = d3()) !== null && (_3 = void 0), _3 === null && (o3 = ae2)), f3[De2] = { nextPos: o3, result: _3 }, _3;
      }, _: d3, identifierName: m3, binaryOp: y3, selectors: v3, selector: b3, sequence: x3, atom: C3, wildcard: k3, identifier: F3, attr: B3, attrOps: O3, attrEqOps: S3, attrName: w3, attrValue: D3, string: I3, number: L3, path: V10, type: K3, regex: W3, field: R3, negation: q3, matches: J3, has: X3, firstChild: ce2, lastChild: A3, nthChild: M3, nthLastChild: ne2, class: de2 };
      if (a3 !== void 0) {
        if (s3[a3] === void 0)
          throw new Error("Invalid rule name: " + n3(a3) + ".");
      } else
        a3 = "start";
      var o3 = 0, u3 = 0, c3 = [], f3 = {};
      function p3(_3) {
        o3 < u3 || (o3 > u3 && (u3 = o3, c3 = []), c3.push(_3));
      }
      function d3() {
        var _3, Q3, Y3 = "_@" + o3, ae2 = f3[Y3];
        if (ae2)
          return o3 = ae2.nextPos, ae2.result;
        for (_3 = [], i.charCodeAt(o3) === 32 ? (Q3 = " ", o3++) : (Q3 = null, p3('" "')); Q3 !== null; )
          _3.push(Q3), i.charCodeAt(o3) === 32 ? (Q3 = " ", o3++) : (Q3 = null, p3('" "'));
        return f3[Y3] = { nextPos: o3, result: _3 }, _3;
      }
      function m3() {
        var _3, Q3, Y3, ae2 = "identifierName@" + o3, ue2 = f3[ae2];
        if (ue2)
          return o3 = ue2.nextPos, ue2.result;
        if (Y3 = o3, /^[^ [\],():#!=><~+.]/.test(i.charAt(o3)) ? (Q3 = i.charAt(o3), o3++) : (Q3 = null, p3("[^ [\\],():#!=><~+.]")), Q3 !== null)
          for (_3 = []; Q3 !== null; )
            _3.push(Q3), /^[^ [\],():#!=><~+.]/.test(i.charAt(o3)) ? (Q3 = i.charAt(o3), o3++) : (Q3 = null, p3("[^ [\\],():#!=><~+.]"));
        else
          _3 = null;
        return _3 !== null && (_3 = function(De2, Ee2) {
          return Ee2.join("");
        }(0, _3)), _3 === null && (o3 = Y3), f3[ae2] = { nextPos: o3, result: _3 }, _3;
      }
      function y3() {
        var _3, Q3, Y3, ae2, ue2, De2 = "binaryOp@" + o3, Ee2 = f3[De2];
        return Ee2 ? (o3 = Ee2.nextPos, Ee2.result) : (ae2 = o3, ue2 = o3, (_3 = d3()) !== null ? (i.charCodeAt(o3) === 62 ? (Q3 = ">", o3++) : (Q3 = null, p3('">"')), Q3 !== null && (Y3 = d3()) !== null ? _3 = [_3, Q3, Y3] : (_3 = null, o3 = ue2)) : (_3 = null, o3 = ue2), _3 !== null && (_3 = "child"), _3 === null && (o3 = ae2), _3 === null && (ae2 = o3, ue2 = o3, (_3 = d3()) !== null ? (i.charCodeAt(o3) === 126 ? (Q3 = "~", o3++) : (Q3 = null, p3('"~"')), Q3 !== null && (Y3 = d3()) !== null ? _3 = [_3, Q3, Y3] : (_3 = null, o3 = ue2)) : (_3 = null, o3 = ue2), _3 !== null && (_3 = "sibling"), _3 === null && (o3 = ae2), _3 === null && (ae2 = o3, ue2 = o3, (_3 = d3()) !== null ? (i.charCodeAt(o3) === 43 ? (Q3 = "+", o3++) : (Q3 = null, p3('"+"')), Q3 !== null && (Y3 = d3()) !== null ? _3 = [_3, Q3, Y3] : (_3 = null, o3 = ue2)) : (_3 = null, o3 = ue2), _3 !== null && (_3 = "adjacent"), _3 === null && (o3 = ae2), _3 === null && (ae2 = o3, ue2 = o3, i.charCodeAt(o3) === 32 ? (_3 = " ", o3++) : (_3 = null, p3('" "')), _3 !== null && (Q3 = d3()) !== null ? _3 = [_3, Q3] : (_3 = null, o3 = ue2), _3 !== null && (_3 = "descendant"), _3 === null && (o3 = ae2)))), f3[De2] = { nextPos: o3, result: _3 }, _3);
      }
      function v3() {
        var _3, Q3, Y3, ae2, ue2, De2, Ee2, _e2, Oe2, Ye2 = "selectors@" + o3, _t2 = f3[Ye2];
        if (_t2)
          return o3 = _t2.nextPos, _t2.result;
        if (Ee2 = o3, _e2 = o3, (_3 = b3()) !== null) {
          for (Q3 = [], Oe2 = o3, (Y3 = d3()) !== null ? (i.charCodeAt(o3) === 44 ? (ae2 = ",", o3++) : (ae2 = null, p3('","')), ae2 !== null && (ue2 = d3()) !== null && (De2 = b3()) !== null ? Y3 = [Y3, ae2, ue2, De2] : (Y3 = null, o3 = Oe2)) : (Y3 = null, o3 = Oe2); Y3 !== null; )
            Q3.push(Y3), Oe2 = o3, (Y3 = d3()) !== null ? (i.charCodeAt(o3) === 44 ? (ae2 = ",", o3++) : (ae2 = null, p3('","')), ae2 !== null && (ue2 = d3()) !== null && (De2 = b3()) !== null ? Y3 = [Y3, ae2, ue2, De2] : (Y3 = null, o3 = Oe2)) : (Y3 = null, o3 = Oe2);
          Q3 !== null ? _3 = [_3, Q3] : (_3 = null, o3 = _e2);
        } else
          _3 = null, o3 = _e2;
        return _3 !== null && (_3 = function(Kt2, Jt2, zt2) {
          return [Jt2].concat(zt2.map(function(wn2) {
            return wn2[3];
          }));
        }(0, _3[0], _3[1])), _3 === null && (o3 = Ee2), f3[Ye2] = { nextPos: o3, result: _3 }, _3;
      }
      function b3() {
        var _3, Q3, Y3, ae2, ue2, De2, Ee2, _e2, Oe2 = "selector@" + o3, Ye2 = f3[Oe2];
        if (Ye2)
          return o3 = Ye2.nextPos, Ye2.result;
        if (ue2 = o3, De2 = o3, (_3 = x3()) !== null) {
          for (Q3 = [], Ee2 = o3, (Y3 = y3()) !== null && (ae2 = x3()) !== null ? Y3 = [Y3, ae2] : (Y3 = null, o3 = Ee2); Y3 !== null; )
            Q3.push(Y3), Ee2 = o3, (Y3 = y3()) !== null && (ae2 = x3()) !== null ? Y3 = [Y3, ae2] : (Y3 = null, o3 = Ee2);
          Q3 !== null ? _3 = [_3, Q3] : (_3 = null, o3 = De2);
        } else
          _3 = null, o3 = De2;
        return _3 !== null && (_e2 = _3[0], _3 = _3[1].reduce(function(_t2, Kt2) {
          return { type: Kt2[0], left: _t2, right: Kt2[1] };
        }, _e2)), _3 === null && (o3 = ue2), f3[Oe2] = { nextPos: o3, result: _3 }, _3;
      }
      function x3() {
        var _3, Q3, Y3, ae2, ue2, De2, Ee2, _e2, Oe2 = "sequence@" + o3, Ye2 = f3[Oe2];
        if (Ye2)
          return o3 = Ye2.nextPos, Ye2.result;
        if (ae2 = o3, ue2 = o3, i.charCodeAt(o3) === 33 ? (_3 = "!", o3++) : (_3 = null, p3('"!"')), (_3 = _3 !== null ? _3 : "") !== null) {
          if ((Y3 = C3()) !== null)
            for (Q3 = []; Y3 !== null; )
              Q3.push(Y3), Y3 = C3();
          else
            Q3 = null;
          Q3 !== null ? _3 = [_3, Q3] : (_3 = null, o3 = ue2);
        } else
          _3 = null, o3 = ue2;
        return _3 !== null && (De2 = _3[0], Ee2 = _3[1], _e2 = Ee2.length === 1 ? Ee2[0] : { type: "compound", selectors: Ee2 }, De2 && (_e2.subject = true), _3 = _e2), _3 === null && (o3 = ae2), f3[Oe2] = { nextPos: o3, result: _3 }, _3;
      }
      function C3() {
        var _3, Q3 = "atom@" + o3, Y3 = f3[Q3];
        return Y3 ? (o3 = Y3.nextPos, Y3.result) : ((_3 = k3()) === null && (_3 = F3()) === null && (_3 = B3()) === null && (_3 = R3()) === null && (_3 = q3()) === null && (_3 = J3()) === null && (_3 = X3()) === null && (_3 = ce2()) === null && (_3 = A3()) === null && (_3 = M3()) === null && (_3 = ne2()) === null && (_3 = de2()), f3[Q3] = { nextPos: o3, result: _3 }, _3);
      }
      function k3() {
        var _3, Q3, Y3 = "wildcard@" + o3, ae2 = f3[Y3];
        return ae2 ? (o3 = ae2.nextPos, ae2.result) : (Q3 = o3, i.charCodeAt(o3) === 42 ? (_3 = "*", o3++) : (_3 = null, p3('"*"')), _3 !== null && (_3 = { type: "wildcard", value: _3 }), _3 === null && (o3 = Q3), f3[Y3] = { nextPos: o3, result: _3 }, _3);
      }
      function F3() {
        var _3, Q3, Y3, ae2, ue2 = "identifier@" + o3, De2 = f3[ue2];
        return De2 ? (o3 = De2.nextPos, De2.result) : (Y3 = o3, ae2 = o3, i.charCodeAt(o3) === 35 ? (_3 = "#", o3++) : (_3 = null, p3('"#"')), (_3 = _3 !== null ? _3 : "") !== null && (Q3 = m3()) !== null ? _3 = [_3, Q3] : (_3 = null, o3 = ae2), _3 !== null && (_3 = function(Ee2, _e2) {
          return { type: "identifier", value: _e2 };
        }(0, _3[1])), _3 === null && (o3 = Y3), f3[ue2] = { nextPos: o3, result: _3 }, _3);
      }
      function B3() {
        var _3, Q3, Y3, ae2, ue2, De2, Ee2, _e2 = "attr@" + o3, Oe2 = f3[_e2];
        return Oe2 ? (o3 = Oe2.nextPos, Oe2.result) : (De2 = o3, Ee2 = o3, i.charCodeAt(o3) === 91 ? (_3 = "[", o3++) : (_3 = null, p3('"["')), _3 !== null && (Q3 = d3()) !== null && (Y3 = D3()) !== null && (ae2 = d3()) !== null ? (i.charCodeAt(o3) === 93 ? (ue2 = "]", o3++) : (ue2 = null, p3('"]"')), ue2 !== null ? _3 = [_3, Q3, Y3, ae2, ue2] : (_3 = null, o3 = Ee2)) : (_3 = null, o3 = Ee2), _3 !== null && (_3 = _3[2]), _3 === null && (o3 = De2), f3[_e2] = { nextPos: o3, result: _3 }, _3);
      }
      function O3() {
        var _3, Q3, Y3, ae2, ue2 = "attrOps@" + o3, De2 = f3[ue2];
        return De2 ? (o3 = De2.nextPos, De2.result) : (Y3 = o3, ae2 = o3, /^[><!]/.test(i.charAt(o3)) ? (_3 = i.charAt(o3), o3++) : (_3 = null, p3("[><!]")), (_3 = _3 !== null ? _3 : "") !== null ? (i.charCodeAt(o3) === 61 ? (Q3 = "=", o3++) : (Q3 = null, p3('"="')), Q3 !== null ? _3 = [_3, Q3] : (_3 = null, o3 = ae2)) : (_3 = null, o3 = ae2), _3 !== null && (_3 = _3[0] + "="), _3 === null && (o3 = Y3), _3 === null && (/^[><]/.test(i.charAt(o3)) ? (_3 = i.charAt(o3), o3++) : (_3 = null, p3("[><]"))), f3[ue2] = { nextPos: o3, result: _3 }, _3);
      }
      function S3() {
        var _3, Q3, Y3, ae2, ue2 = "attrEqOps@" + o3, De2 = f3[ue2];
        return De2 ? (o3 = De2.nextPos, De2.result) : (Y3 = o3, ae2 = o3, i.charCodeAt(o3) === 33 ? (_3 = "!", o3++) : (_3 = null, p3('"!"')), (_3 = _3 !== null ? _3 : "") !== null ? (i.charCodeAt(o3) === 61 ? (Q3 = "=", o3++) : (Q3 = null, p3('"="')), Q3 !== null ? _3 = [_3, Q3] : (_3 = null, o3 = ae2)) : (_3 = null, o3 = ae2), _3 !== null && (_3 = _3[0] + "="), _3 === null && (o3 = Y3), f3[ue2] = { nextPos: o3, result: _3 }, _3);
      }
      function w3() {
        var _3, Q3, Y3, ae2 = "attrName@" + o3, ue2 = f3[ae2];
        if (ue2)
          return o3 = ue2.nextPos, ue2.result;
        if (Y3 = o3, (Q3 = m3()) === null && (i.charCodeAt(o3) === 46 ? (Q3 = ".", o3++) : (Q3 = null, p3('"."'))), Q3 !== null)
          for (_3 = []; Q3 !== null; )
            _3.push(Q3), (Q3 = m3()) === null && (i.charCodeAt(o3) === 46 ? (Q3 = ".", o3++) : (Q3 = null, p3('"."')));
        else
          _3 = null;
        return _3 !== null && (_3 = function(De2, Ee2) {
          return Ee2.join("");
        }(0, _3)), _3 === null && (o3 = Y3), f3[ae2] = { nextPos: o3, result: _3 }, _3;
      }
      function D3() {
        var _3, Q3, Y3, ae2, ue2, De2, Ee2, _e2 = "attrValue@" + o3, Oe2 = f3[_e2];
        return Oe2 ? (o3 = Oe2.nextPos, Oe2.result) : (De2 = o3, Ee2 = o3, (_3 = w3()) !== null && (Q3 = d3()) !== null && (Y3 = S3()) !== null && (ae2 = d3()) !== null ? ((ue2 = K3()) === null && (ue2 = W3()), ue2 !== null ? _3 = [_3, Q3, Y3, ae2, ue2] : (_3 = null, o3 = Ee2)) : (_3 = null, o3 = Ee2), _3 !== null && (_3 = function(Ye2, _t2, Kt2, Jt2) {
          return { type: "attribute", name: _t2, operator: Kt2, value: Jt2 };
        }(0, _3[0], _3[2], _3[4])), _3 === null && (o3 = De2), _3 === null && (De2 = o3, Ee2 = o3, (_3 = w3()) !== null && (Q3 = d3()) !== null && (Y3 = O3()) !== null && (ae2 = d3()) !== null ? ((ue2 = I3()) === null && (ue2 = L3()) === null && (ue2 = V10()), ue2 !== null ? _3 = [_3, Q3, Y3, ae2, ue2] : (_3 = null, o3 = Ee2)) : (_3 = null, o3 = Ee2), _3 !== null && (_3 = function(Ye2, _t2, Kt2, Jt2) {
          return { type: "attribute", name: _t2, operator: Kt2, value: Jt2 };
        }(0, _3[0], _3[2], _3[4])), _3 === null && (o3 = De2), _3 === null && (De2 = o3, (_3 = w3()) !== null && (_3 = function(Ye2, _t2) {
          return { type: "attribute", name: _t2 };
        }(0, _3)), _3 === null && (o3 = De2))), f3[_e2] = { nextPos: o3, result: _3 }, _3);
      }
      function I3() {
        var _3, Q3, Y3, ae2, ue2, De2, Ee2, _e2, Oe2, Ye2, _t2 = "string@" + o3, Kt2 = f3[_t2];
        if (Kt2)
          return o3 = Kt2.nextPos, Kt2.result;
        if (ue2 = o3, De2 = o3, i.charCodeAt(o3) === 34 ? (_3 = '"', o3++) : (_3 = null, p3('"\\""')), _3 !== null) {
          for (Q3 = [], /^[^\\"]/.test(i.charAt(o3)) ? (Y3 = i.charAt(o3), o3++) : (Y3 = null, p3('[^\\\\"]')), Y3 === null && (Ee2 = o3, _e2 = o3, i.charCodeAt(o3) === 92 ? (Y3 = "\\", o3++) : (Y3 = null, p3('"\\\\"')), Y3 !== null ? (i.length > o3 ? (ae2 = i.charAt(o3), o3++) : (ae2 = null, p3("any character")), ae2 !== null ? Y3 = [Y3, ae2] : (Y3 = null, o3 = _e2)) : (Y3 = null, o3 = _e2), Y3 !== null && (Oe2 = Y3[0], Ye2 = Y3[1], Y3 = Oe2 + Ye2), Y3 === null && (o3 = Ee2)); Y3 !== null; )
            Q3.push(Y3), /^[^\\"]/.test(i.charAt(o3)) ? (Y3 = i.charAt(o3), o3++) : (Y3 = null, p3('[^\\\\"]')), Y3 === null && (Ee2 = o3, _e2 = o3, i.charCodeAt(o3) === 92 ? (Y3 = "\\", o3++) : (Y3 = null, p3('"\\\\"')), Y3 !== null ? (i.length > o3 ? (ae2 = i.charAt(o3), o3++) : (ae2 = null, p3("any character")), ae2 !== null ? Y3 = [Y3, ae2] : (Y3 = null, o3 = _e2)) : (Y3 = null, o3 = _e2), Y3 !== null && (Y3 = function(Jt2, zt2, wn2) {
              return zt2 + wn2;
            }(0, Y3[0], Y3[1])), Y3 === null && (o3 = Ee2));
          Q3 !== null ? (i.charCodeAt(o3) === 34 ? (Y3 = '"', o3++) : (Y3 = null, p3('"\\""')), Y3 !== null ? _3 = [_3, Q3, Y3] : (_3 = null, o3 = De2)) : (_3 = null, o3 = De2);
        } else
          _3 = null, o3 = De2;
        if (_3 !== null && (_3 = function(Jt2, zt2) {
          return { type: "literal", value: ie2(zt2.join("")) };
        }(0, _3[1])), _3 === null && (o3 = ue2), _3 === null) {
          if (ue2 = o3, De2 = o3, i.charCodeAt(o3) === 39 ? (_3 = "'", o3++) : (_3 = null, p3(`"'"`)), _3 !== null) {
            for (Q3 = [], /^[^\\']/.test(i.charAt(o3)) ? (Y3 = i.charAt(o3), o3++) : (Y3 = null, p3("[^\\\\']")), Y3 === null && (Ee2 = o3, _e2 = o3, i.charCodeAt(o3) === 92 ? (Y3 = "\\", o3++) : (Y3 = null, p3('"\\\\"')), Y3 !== null ? (i.length > o3 ? (ae2 = i.charAt(o3), o3++) : (ae2 = null, p3("any character")), ae2 !== null ? Y3 = [Y3, ae2] : (Y3 = null, o3 = _e2)) : (Y3 = null, o3 = _e2), Y3 !== null && (Y3 = function(Jt2, zt2, wn2) {
              return zt2 + wn2;
            }(0, Y3[0], Y3[1])), Y3 === null && (o3 = Ee2)); Y3 !== null; )
              Q3.push(Y3), /^[^\\']/.test(i.charAt(o3)) ? (Y3 = i.charAt(o3), o3++) : (Y3 = null, p3("[^\\\\']")), Y3 === null && (Ee2 = o3, _e2 = o3, i.charCodeAt(o3) === 92 ? (Y3 = "\\", o3++) : (Y3 = null, p3('"\\\\"')), Y3 !== null ? (i.length > o3 ? (ae2 = i.charAt(o3), o3++) : (ae2 = null, p3("any character")), ae2 !== null ? Y3 = [Y3, ae2] : (Y3 = null, o3 = _e2)) : (Y3 = null, o3 = _e2), Y3 !== null && (Y3 = function(Jt2, zt2, wn2) {
                return zt2 + wn2;
              }(0, Y3[0], Y3[1])), Y3 === null && (o3 = Ee2));
            Q3 !== null ? (i.charCodeAt(o3) === 39 ? (Y3 = "'", o3++) : (Y3 = null, p3(`"'"`)), Y3 !== null ? _3 = [_3, Q3, Y3] : (_3 = null, o3 = De2)) : (_3 = null, o3 = De2);
          } else
            _3 = null, o3 = De2;
          _3 !== null && (_3 = function(Jt2, zt2) {
            return { type: "literal", value: ie2(zt2.join("")) };
          }(0, _3[1])), _3 === null && (o3 = ue2);
        }
        return f3[_t2] = { nextPos: o3, result: _3 }, _3;
      }
      function L3() {
        var _3, Q3, Y3, ae2, ue2, De2, Ee2, _e2, Oe2 = "number@" + o3, Ye2 = f3[Oe2];
        if (Ye2)
          return o3 = Ye2.nextPos, Ye2.result;
        for (ae2 = o3, ue2 = o3, De2 = o3, _3 = [], /^[0-9]/.test(i.charAt(o3)) ? (Q3 = i.charAt(o3), o3++) : (Q3 = null, p3("[0-9]")); Q3 !== null; )
          _3.push(Q3), /^[0-9]/.test(i.charAt(o3)) ? (Q3 = i.charAt(o3), o3++) : (Q3 = null, p3("[0-9]"));
        if (_3 !== null ? (i.charCodeAt(o3) === 46 ? (Q3 = ".", o3++) : (Q3 = null, p3('"."')), Q3 !== null ? _3 = [_3, Q3] : (_3 = null, o3 = De2)) : (_3 = null, o3 = De2), (_3 = _3 !== null ? _3 : "") !== null) {
          if (/^[0-9]/.test(i.charAt(o3)) ? (Y3 = i.charAt(o3), o3++) : (Y3 = null, p3("[0-9]")), Y3 !== null)
            for (Q3 = []; Y3 !== null; )
              Q3.push(Y3), /^[0-9]/.test(i.charAt(o3)) ? (Y3 = i.charAt(o3), o3++) : (Y3 = null, p3("[0-9]"));
          else
            Q3 = null;
          Q3 !== null ? _3 = [_3, Q3] : (_3 = null, o3 = ue2);
        } else
          _3 = null, o3 = ue2;
        return _3 !== null && (Ee2 = _3[0], _e2 = _3[1], _3 = { type: "literal", value: parseFloat((Ee2 ? Ee2.join("") : "") + _e2.join("")) }), _3 === null && (o3 = ae2), f3[Oe2] = { nextPos: o3, result: _3 }, _3;
      }
      function V10() {
        var _3, Q3, Y3 = "path@" + o3, ae2 = f3[Y3];
        return ae2 ? (o3 = ae2.nextPos, ae2.result) : (Q3 = o3, (_3 = m3()) !== null && (_3 = function(ue2, De2) {
          return { type: "literal", value: De2 };
        }(0, _3)), _3 === null && (o3 = Q3), f3[Y3] = { nextPos: o3, result: _3 }, _3);
      }
      function K3() {
        var _3, Q3, Y3, ae2, ue2, De2, Ee2, _e2 = "type@" + o3, Oe2 = f3[_e2];
        if (Oe2)
          return o3 = Oe2.nextPos, Oe2.result;
        if (De2 = o3, Ee2 = o3, i.substr(o3, 5) === "type(" ? (_3 = "type(", o3 += 5) : (_3 = null, p3('"type("')), _3 !== null)
          if ((Q3 = d3()) !== null) {
            if (/^[^ )]/.test(i.charAt(o3)) ? (ae2 = i.charAt(o3), o3++) : (ae2 = null, p3("[^ )]")), ae2 !== null)
              for (Y3 = []; ae2 !== null; )
                Y3.push(ae2), /^[^ )]/.test(i.charAt(o3)) ? (ae2 = i.charAt(o3), o3++) : (ae2 = null, p3("[^ )]"));
            else
              Y3 = null;
            Y3 !== null && (ae2 = d3()) !== null ? (i.charCodeAt(o3) === 41 ? (ue2 = ")", o3++) : (ue2 = null, p3('")"')), ue2 !== null ? _3 = [_3, Q3, Y3, ae2, ue2] : (_3 = null, o3 = Ee2)) : (_3 = null, o3 = Ee2);
          } else
            _3 = null, o3 = Ee2;
        else
          _3 = null, o3 = Ee2;
        return _3 !== null && (_3 = { type: "type", value: _3[2].join("") }), _3 === null && (o3 = De2), f3[_e2] = { nextPos: o3, result: _3 }, _3;
      }
      function W3() {
        var _3, Q3, Y3, ae2, ue2, De2 = "regex@" + o3, Ee2 = f3[De2];
        if (Ee2)
          return o3 = Ee2.nextPos, Ee2.result;
        if (ae2 = o3, ue2 = o3, i.charCodeAt(o3) === 47 ? (_3 = "/", o3++) : (_3 = null, p3('"/"')), _3 !== null) {
          if (/^[^\/]/.test(i.charAt(o3)) ? (Y3 = i.charAt(o3), o3++) : (Y3 = null, p3("[^\\/]")), Y3 !== null)
            for (Q3 = []; Y3 !== null; )
              Q3.push(Y3), /^[^\/]/.test(i.charAt(o3)) ? (Y3 = i.charAt(o3), o3++) : (Y3 = null, p3("[^\\/]"));
          else
            Q3 = null;
          Q3 !== null ? (i.charCodeAt(o3) === 47 ? (Y3 = "/", o3++) : (Y3 = null, p3('"/"')), Y3 !== null ? _3 = [_3, Q3, Y3] : (_3 = null, o3 = ue2)) : (_3 = null, o3 = ue2);
        } else
          _3 = null, o3 = ue2;
        return _3 !== null && (_3 = function(_e2, Oe2) {
          return { type: "regexp", value: new RegExp(Oe2.join("")) };
        }(0, _3[1])), _3 === null && (o3 = ae2), f3[De2] = { nextPos: o3, result: _3 }, _3;
      }
      function R3() {
        var _3, Q3, Y3, ae2, ue2, De2, Ee2, _e2, Oe2 = "field@" + o3, Ye2 = f3[Oe2];
        if (Ye2)
          return o3 = Ye2.nextPos, Ye2.result;
        if (De2 = o3, Ee2 = o3, i.charCodeAt(o3) === 46 ? (_3 = ".", o3++) : (_3 = null, p3('"."')), _3 !== null)
          if ((Q3 = m3()) !== null) {
            for (Y3 = [], _e2 = o3, i.charCodeAt(o3) === 46 ? (ae2 = ".", o3++) : (ae2 = null, p3('"."')), ae2 !== null && (ue2 = m3()) !== null ? ae2 = [ae2, ue2] : (ae2 = null, o3 = _e2); ae2 !== null; )
              Y3.push(ae2), _e2 = o3, i.charCodeAt(o3) === 46 ? (ae2 = ".", o3++) : (ae2 = null, p3('"."')), ae2 !== null && (ue2 = m3()) !== null ? ae2 = [ae2, ue2] : (ae2 = null, o3 = _e2);
            Y3 !== null ? _3 = [_3, Q3, Y3] : (_3 = null, o3 = Ee2);
          } else
            _3 = null, o3 = Ee2;
        else
          _3 = null, o3 = Ee2;
        return _3 !== null && (_3 = function(_t2, Kt2, Jt2) {
          return { type: "field", name: Jt2.reduce(function(zt2, wn2) {
            return zt2 + wn2[0] + wn2[1];
          }, Kt2) };
        }(0, _3[1], _3[2])), _3 === null && (o3 = De2), f3[Oe2] = { nextPos: o3, result: _3 }, _3;
      }
      function q3() {
        var _3, Q3, Y3, ae2, ue2, De2, Ee2, _e2 = "negation@" + o3, Oe2 = f3[_e2];
        return Oe2 ? (o3 = Oe2.nextPos, Oe2.result) : (De2 = o3, Ee2 = o3, i.substr(o3, 5) === ":not(" ? (_3 = ":not(", o3 += 5) : (_3 = null, p3('":not("')), _3 !== null && (Q3 = d3()) !== null && (Y3 = v3()) !== null && (ae2 = d3()) !== null ? (i.charCodeAt(o3) === 41 ? (ue2 = ")", o3++) : (ue2 = null, p3('")"')), ue2 !== null ? _3 = [_3, Q3, Y3, ae2, ue2] : (_3 = null, o3 = Ee2)) : (_3 = null, o3 = Ee2), _3 !== null && (_3 = { type: "not", selectors: _3[2] }), _3 === null && (o3 = De2), f3[_e2] = { nextPos: o3, result: _3 }, _3);
      }
      function J3() {
        var _3, Q3, Y3, ae2, ue2, De2, Ee2, _e2 = "matches@" + o3, Oe2 = f3[_e2];
        return Oe2 ? (o3 = Oe2.nextPos, Oe2.result) : (De2 = o3, Ee2 = o3, i.substr(o3, 9) === ":matches(" ? (_3 = ":matches(", o3 += 9) : (_3 = null, p3('":matches("')), _3 !== null && (Q3 = d3()) !== null && (Y3 = v3()) !== null && (ae2 = d3()) !== null ? (i.charCodeAt(o3) === 41 ? (ue2 = ")", o3++) : (ue2 = null, p3('")"')), ue2 !== null ? _3 = [_3, Q3, Y3, ae2, ue2] : (_3 = null, o3 = Ee2)) : (_3 = null, o3 = Ee2), _3 !== null && (_3 = { type: "matches", selectors: _3[2] }), _3 === null && (o3 = De2), f3[_e2] = { nextPos: o3, result: _3 }, _3);
      }
      function X3() {
        var _3, Q3, Y3, ae2, ue2, De2, Ee2, _e2 = "has@" + o3, Oe2 = f3[_e2];
        return Oe2 ? (o3 = Oe2.nextPos, Oe2.result) : (De2 = o3, Ee2 = o3, i.substr(o3, 5) === ":has(" ? (_3 = ":has(", o3 += 5) : (_3 = null, p3('":has("')), _3 !== null && (Q3 = d3()) !== null && (Y3 = v3()) !== null && (ae2 = d3()) !== null ? (i.charCodeAt(o3) === 41 ? (ue2 = ")", o3++) : (ue2 = null, p3('")"')), ue2 !== null ? _3 = [_3, Q3, Y3, ae2, ue2] : (_3 = null, o3 = Ee2)) : (_3 = null, o3 = Ee2), _3 !== null && (_3 = { type: "has", selectors: _3[2] }), _3 === null && (o3 = De2), f3[_e2] = { nextPos: o3, result: _3 }, _3);
      }
      function ce2() {
        var _3, Q3, Y3 = "firstChild@" + o3, ae2 = f3[Y3];
        return ae2 ? (o3 = ae2.nextPos, ae2.result) : (Q3 = o3, i.substr(o3, 12) === ":first-child" ? (_3 = ":first-child", o3 += 12) : (_3 = null, p3('":first-child"')), _3 !== null && (_3 = he2(1)), _3 === null && (o3 = Q3), f3[Y3] = { nextPos: o3, result: _3 }, _3);
      }
      function A3() {
        var _3, Q3, Y3 = "lastChild@" + o3, ae2 = f3[Y3];
        return ae2 ? (o3 = ae2.nextPos, ae2.result) : (Q3 = o3, i.substr(o3, 11) === ":last-child" ? (_3 = ":last-child", o3 += 11) : (_3 = null, p3('":last-child"')), _3 !== null && (_3 = j3(1)), _3 === null && (o3 = Q3), f3[Y3] = { nextPos: o3, result: _3 }, _3);
      }
      function M3() {
        var _3, Q3, Y3, ae2, ue2, De2, Ee2, _e2, Oe2 = "nthChild@" + o3, Ye2 = f3[Oe2];
        if (Ye2)
          return o3 = Ye2.nextPos, Ye2.result;
        if (De2 = o3, Ee2 = o3, i.substr(o3, 11) === ":nth-child(" ? (_3 = ":nth-child(", o3 += 11) : (_3 = null, p3('":nth-child("')), _3 !== null)
          if ((Q3 = d3()) !== null) {
            if (/^[0-9]/.test(i.charAt(o3)) ? (ae2 = i.charAt(o3), o3++) : (ae2 = null, p3("[0-9]")), ae2 !== null)
              for (Y3 = []; ae2 !== null; )
                Y3.push(ae2), /^[0-9]/.test(i.charAt(o3)) ? (ae2 = i.charAt(o3), o3++) : (ae2 = null, p3("[0-9]"));
            else
              Y3 = null;
            Y3 !== null && (ae2 = d3()) !== null ? (i.charCodeAt(o3) === 41 ? (ue2 = ")", o3++) : (ue2 = null, p3('")"')), ue2 !== null ? _3 = [_3, Q3, Y3, ae2, ue2] : (_3 = null, o3 = Ee2)) : (_3 = null, o3 = Ee2);
          } else
            _3 = null, o3 = Ee2;
        else
          _3 = null, o3 = Ee2;
        return _3 !== null && (_e2 = _3[2], _3 = he2(parseInt(_e2.join(""), 10))), _3 === null && (o3 = De2), f3[Oe2] = { nextPos: o3, result: _3 }, _3;
      }
      function ne2() {
        var _3, Q3, Y3, ae2, ue2, De2, Ee2, _e2, Oe2 = "nthLastChild@" + o3, Ye2 = f3[Oe2];
        if (Ye2)
          return o3 = Ye2.nextPos, Ye2.result;
        if (De2 = o3, Ee2 = o3, i.substr(o3, 16) === ":nth-last-child(" ? (_3 = ":nth-last-child(", o3 += 16) : (_3 = null, p3('":nth-last-child("')), _3 !== null)
          if ((Q3 = d3()) !== null) {
            if (/^[0-9]/.test(i.charAt(o3)) ? (ae2 = i.charAt(o3), o3++) : (ae2 = null, p3("[0-9]")), ae2 !== null)
              for (Y3 = []; ae2 !== null; )
                Y3.push(ae2), /^[0-9]/.test(i.charAt(o3)) ? (ae2 = i.charAt(o3), o3++) : (ae2 = null, p3("[0-9]"));
            else
              Y3 = null;
            Y3 !== null && (ae2 = d3()) !== null ? (i.charCodeAt(o3) === 41 ? (ue2 = ")", o3++) : (ue2 = null, p3('")"')), ue2 !== null ? _3 = [_3, Q3, Y3, ae2, ue2] : (_3 = null, o3 = Ee2)) : (_3 = null, o3 = Ee2);
          } else
            _3 = null, o3 = Ee2;
        else
          _3 = null, o3 = Ee2;
        return _3 !== null && (_e2 = _3[2], _3 = j3(parseInt(_e2.join(""), 10))), _3 === null && (o3 = De2), f3[Oe2] = { nextPos: o3, result: _3 }, _3;
      }
      function de2() {
        var _3, Q3, Y3, ae2, ue2 = "class@" + o3, De2 = f3[ue2];
        return De2 ? (o3 = De2.nextPos, De2.result) : (Y3 = o3, ae2 = o3, i.charCodeAt(o3) === 58 ? (_3 = ":", o3++) : (_3 = null, p3('":"')), _3 !== null ? (i.substr(o3, 9).toLowerCase() === "statement" ? (Q3 = i.substr(o3, 9), o3 += 9) : (Q3 = null, p3('"statement"')), Q3 === null && (i.substr(o3, 10).toLowerCase() === "expression" ? (Q3 = i.substr(o3, 10), o3 += 10) : (Q3 = null, p3('"expression"')), Q3 === null && (i.substr(o3, 11).toLowerCase() === "declaration" ? (Q3 = i.substr(o3, 11), o3 += 11) : (Q3 = null, p3('"declaration"')), Q3 === null && (i.substr(o3, 8).toLowerCase() === "function" ? (Q3 = i.substr(o3, 8), o3 += 8) : (Q3 = null, p3('"function"')), Q3 === null && (i.substr(o3, 7).toLowerCase() === "pattern" ? (Q3 = i.substr(o3, 7), o3 += 7) : (Q3 = null, p3('"pattern"')))))), Q3 !== null ? _3 = [_3, Q3] : (_3 = null, o3 = ae2)) : (_3 = null, o3 = ae2), _3 !== null && (_3 = { type: "class", name: _3[1] }), _3 === null && (o3 = Y3), f3[ue2] = { nextPos: o3, result: _3 }, _3);
      }
      function he2(_3) {
        return { type: "nth-child", index: { type: "literal", value: _3 } };
      }
      function j3(_3) {
        return { type: "nth-last-child", index: { type: "literal", value: _3 } };
      }
      function ie2(_3) {
        return _3.replace(/\\(.)/g, function(Q3, Y3) {
          switch (Y3) {
            case "a":
              return "a";
            case "b":
              return "\b";
            case "f":
              return "\f";
            case "n":
              return `
`;
            case "r":
              return "\r";
            case "t":
              return "	";
            case "v":
              return "\v";
            default:
              return Y3;
          }
        });
      }
      var fe2 = s3[a3]();
      if (fe2 === null || o3 !== i.length) {
        var ge2 = Math.max(o3, u3), Fe2 = ge2 < i.length ? i.charAt(ge2) : null, Pe2 = function() {
          for (var _3 = 1, Q3 = 1, Y3 = false, ae2 = 0; ae2 < Math.max(o3, u3); ae2++) {
            var ue2 = i.charAt(ae2);
            ue2 === `
` ? (Y3 || _3++, Q3 = 1, Y3 = false) : ue2 === "\r" || ue2 === "\u2028" || ue2 === "\u2029" ? (_3++, Q3 = 1, Y3 = true) : (Q3++, Y3 = false);
          }
          return { line: _3, column: Q3 };
        }();
        throw new this.SyntaxError(function(_3) {
          _3.sort();
          for (var Q3 = null, Y3 = [], ae2 = 0; ae2 < _3.length; ae2++)
            _3[ae2] !== Q3 && (Y3.push(_3[ae2]), Q3 = _3[ae2]);
          return Y3;
        }(c3), Fe2, ge2, Pe2.line, Pe2.column);
      }
      return fe2;
    }, toSource: function() {
      return this._source;
    }, SyntaxError: function(i, a3, s3, o3, u3) {
      this.name = "SyntaxError", this.expected = i, this.found = a3, this.message = function(c3, f3) {
        var p3;
        switch (c3.length) {
          case 0:
            p3 = "end of input";
            break;
          case 1:
            p3 = c3[0];
            break;
          default:
            p3 = c3.slice(0, c3.length - 1).join(", ") + " or " + c3[c3.length - 1];
        }
        return "Expected " + p3 + " but " + (f3 ? n3(f3) : "end of input") + " found.";
      }(i, a3), this.offset = s3, this.line = o3, this.column = u3;
    } };
    return r3.SyntaxError.prototype = Error.prototype, r3;
  }();
  e28.exports ? e28.exports = t3 : ni$1.esquery = t3;
})), $T = gt$3(function(e28) {
  (function() {
    var t3 = Cc$2, n3 = WT, r3 = Array.isArray || function(o3) {
      return {}.toString.call(o3) === "[object Array]";
    }, i = {}, a3 = {};
    function s3() {
      function o3(v3, b3, x3) {
        var C3, k3, F3;
        if (x3.length === 0)
          return v3 === b3;
        if (b3 == null)
          return false;
        if (C3 = b3[x3[0]], k3 = x3.slice(1), r3(C3)) {
          for (F3 = 0, l = C3.length; F3 < l; ++F3)
            if (o3(v3, C3[F3], k3))
              return true;
          return false;
        }
        return o3(v3, C3, k3);
      }
      function u3(v3, b3, x3) {
        var C3, k3, F3, B3;
        if (!b3)
          return true;
        if (!v3)
          return false;
        switch (x3 || (x3 = []), b3.type) {
          case "wildcard":
            return true;
          case "identifier":
            return b3.value.toLowerCase() === v3.type.toLowerCase();
          case "field":
            return o3(v3, x3[(C3 = b3.name.split(".")).length - 1], C3);
          case "matches":
            for (k3 = 0, F3 = b3.selectors.length; k3 < F3; ++k3)
              if (u3(v3, b3.selectors[k3], x3))
                return true;
            return false;
          case "compound":
            for (k3 = 0, F3 = b3.selectors.length; k3 < F3; ++k3)
              if (!u3(v3, b3.selectors[k3], x3))
                return false;
            return true;
          case "not":
            for (k3 = 0, F3 = b3.selectors.length; k3 < F3; ++k3)
              if (u3(v3, b3.selectors[k3], x3))
                return false;
            return true;
          case "has":
            var O3, S3 = [];
            for (k3 = 0, F3 = b3.selectors.length; k3 < F3; ++k3)
              O3 = [], t3.traverse(v3, { enter: function(w3, D3) {
                D3 != null && O3.unshift(D3), u3(w3, b3.selectors[k3], O3) && S3.push(w3);
              }, leave: function() {
                O3.shift();
              } });
            return S3.length !== 0;
          case "child":
            return !!u3(v3, b3.right, x3) && u3(x3[0], b3.left, x3.slice(1));
          case "descendant":
            if (u3(v3, b3.right, x3)) {
              for (k3 = 0, F3 = x3.length; k3 < F3; ++k3)
                if (u3(x3[k3], b3.left, x3.slice(k3 + 1)))
                  return true;
            }
            return false;
          case "attribute":
            switch (B3 = function(w3, D3) {
              var I3, L3 = D3.split(".");
              for (I3 = 0; I3 < L3.length; I3++) {
                if (w3 == null)
                  return w3;
                w3 = w3[L3[I3]];
              }
              return w3;
            }(v3, b3.name), b3.operator) {
              case null:
              case void 0:
                return B3 != null;
              case "=":
                switch (b3.value.type) {
                  case "regexp":
                    return typeof B3 == "string" && b3.value.value.test(B3);
                  case "literal":
                    return "" + b3.value.value == "" + B3;
                  case "type":
                    return b3.value.value === xe$3(B3);
                }
              case "!=":
                switch (b3.value.type) {
                  case "regexp":
                    return !b3.value.value.test(B3);
                  case "literal":
                    return "" + b3.value.value != "" + B3;
                  case "type":
                    return b3.value.value !== xe$3(B3);
                }
              case "<=":
                return B3 <= b3.value.value;
              case "<":
                return B3 < b3.value.value;
              case ">":
                return B3 > b3.value.value;
              case ">=":
                return B3 >= b3.value.value;
            }
          case "sibling":
            return u3(v3, b3.right, x3) && c3(v3, b3.left, x3, i) || b3.left.subject && u3(v3, b3.left, x3) && c3(v3, b3.right, x3, a3);
          case "adjacent":
            return u3(v3, b3.right, x3) && f3(v3, b3.left, x3, i) || b3.right.subject && u3(v3, b3.left, x3) && f3(v3, b3.right, x3, a3);
          case "nth-child":
            return u3(v3, b3.right, x3) && p3(v3, x3, function(w3) {
              return b3.index.value - 1;
            });
          case "nth-last-child":
            return u3(v3, b3.right, x3) && p3(v3, x3, function(w3) {
              return w3 - b3.index.value;
            });
          case "class":
            if (!v3.type)
              return false;
            switch (b3.name.toLowerCase()) {
              case "statement":
                if (v3.type.slice(-9) === "Statement")
                  return true;
              case "declaration":
                return v3.type.slice(-11) === "Declaration";
              case "pattern":
                if (v3.type.slice(-7) === "Pattern")
                  return true;
              case "expression":
                return v3.type.slice(-10) === "Expression" || v3.type.slice(-7) === "Literal" || v3.type === "Identifier" && (x3.length === 0 || x3[0].type !== "MetaProperty") || v3.type === "MetaProperty";
              case "function":
                return v3.type.slice(0, 8) === "Function" || v3.type === "ArrowFunctionExpression";
            }
            throw new Error("Unknown class name: " + b3.name);
        }
        throw new Error("Unknown selector type: " + b3.type);
      }
      function c3(v3, b3, x3, C3) {
        var k3, F3, B3, O3, S3, w3, D3, I3, L3 = x3[0];
        if (!L3)
          return false;
        for (O3 = 0, S3 = (B3 = t3.VisitorKeys[L3.type]).length; O3 < S3; ++O3)
          if (k3 = L3[B3[O3]], r3(k3)) {
            if ((F3 = k3.indexOf(v3)) < 0)
              continue;
            for (C3 === i ? (D3 = 0, I3 = F3) : (D3 = F3 + 1, I3 = k3.length), w3 = D3; w3 < I3; ++w3)
              if (u3(k3[w3], b3, x3))
                return true;
          }
        return false;
      }
      function f3(v3, b3, x3, C3) {
        var k3, F3, B3, O3, S3, w3 = x3[0];
        if (!w3)
          return false;
        for (B3 = 0, O3 = (F3 = t3.VisitorKeys[w3.type]).length; B3 < O3; ++B3)
          if (k3 = w3[F3[B3]], r3(k3)) {
            if ((S3 = k3.indexOf(v3)) < 0)
              continue;
            if (C3 === i && S3 > 0 && u3(k3[S3 - 1], b3, x3) || C3 === a3 && S3 < k3.length - 1 && u3(k3[S3 + 1], b3, x3))
              return true;
          }
        return false;
      }
      function p3(v3, b3, x3) {
        var C3, k3, F3, B3, O3, S3 = b3[0];
        if (!S3)
          return false;
        for (F3 = 0, B3 = (k3 = t3.VisitorKeys[S3.type]).length; F3 < B3; ++F3)
          if (C3 = S3[k3[F3]], r3(C3) && (O3 = C3.indexOf(v3)) >= 0 && O3 === x3(C3.length))
            return true;
        return false;
      }
      function d3(v3, b3) {
        var x3, C3, k3, F3, B3, O3 = [], S3 = [];
        return b3 && (x3 = function w3(D3, I3) {
          var L3, V10;
          if (D3 == null || xe$3(D3) != "object")
            return [];
          for (V10 in I3 == null && (I3 = D3), L3 = D3.subject ? [I3] : [], D3)
            ({}).hasOwnProperty.call(D3, V10) && [].push.apply(L3, w3(D3[V10], V10 === "left" ? D3[V10] : I3));
          return L3;
        }(b3), t3.traverse(v3, { enter: function(w3, D3) {
          if (D3 != null && O3.unshift(D3), u3(w3, b3, O3))
            if (x3.length)
              for (C3 = 0, k3 = x3.length; C3 < k3; ++C3)
                for (u3(w3, x3[C3], O3) && S3.push(w3), F3 = 0, B3 = O3.length; F3 < B3; ++F3)
                  u3(O3[F3], x3[C3], O3.slice(F3 + 1)) && S3.push(O3[F3]);
            else
              S3.push(w3);
        }, leave: function() {
          O3.shift();
        } })), S3;
      }
      function m3(v3) {
        return n3.parse(v3);
      }
      function y3(v3, b3) {
        return d3(v3, m3(b3));
      }
      return y3.parse = m3, y3.match = d3, y3.matches = u3, y3.query = y3;
    }
    e28.exports ? e28.exports = s3() : this.esquery = s3();
  })();
}), GT = Cr$1(_T);
function io$1(e28) {
  return e28 && xe$3(e28) == "object" && "default" in e28 ? e28.default : e28;
}
var Bs$1 = io$1(P4), ww = io$1(a9), zT = io$1(j4), HT = io$1(ST), gb$1 = io$1(GT), Rr$1 = io$1(xn$2), KT = io$1(lp$1), Aw = io$1($T), Nd$1, Wl = function(e28, t3) {
  for (var n3 = {}, r3 = 0, i = Object.entries(e28); r3 < i.length; r3++) {
    var a3 = bn$1(i[r3], 2), s3 = a3[0], o3 = a3[1];
    Object.hasOwnProperty.call(t3, s3) || (n3[s3] = o3);
  }
  return n3;
}(ye$4.globals.es2015, ye$4.globals.es5), yb$1 = { Atomics: false, SharedArrayBuffer: false }, _w = new Map(Object.entries({ builtin: { globals: ye$4.globals.es5 }, es6: { globals: Wl, parserOptions: { ecmaVersion: 6 } }, es2015: { globals: Wl, parserOptions: { ecmaVersion: 6 } }, es2017: { globals: Sa$2({}, Wl, {}, yb$1), parserOptions: { ecmaVersion: 8 } }, es2020: { globals: Sa$2({}, Wl, {}, yb$1, {}, { BigInt: false, BigInt64Array: false, BigUint64Array: false }), parserOptions: { ecmaVersion: 11 } }, browser: { globals: ye$4.globals.browser }, node: { globals: ye$4.globals.node, parserOptions: { ecmaFeatures: { globalReturn: true } } }, "shared-node-browser": { globals: ye$4.globals["shared-node-browser"] }, worker: { globals: ye$4.globals.worker }, serviceworker: { globals: ye$4.globals.serviceworker }, commonjs: { globals: ye$4.globals.commonjs, parserOptions: { ecmaFeatures: { globalReturn: true } } }, amd: { globals: ye$4.globals.amd }, mocha: { globals: ye$4.globals.mocha }, jasmine: { globals: ye$4.globals.jasmine }, jest: { globals: ye$4.globals.jest }, phantomjs: { globals: ye$4.globals.phantomjs }, jquery: { globals: ye$4.globals.jquery }, qunit: { globals: ye$4.globals.qunit }, prototypejs: { globals: ye$4.globals.prototypejs }, shelljs: { globals: ye$4.globals.shelljs }, meteor: { globals: ye$4.globals.meteor }, mongo: { globals: ye$4.globals.mongo }, protractor: { globals: ye$4.globals.protractor }, applescript: { globals: ye$4.globals.applescript }, nashorn: { globals: ye$4.globals.nashorn }, atomtest: { globals: ye$4.globals.atomtest }, embertest: { globals: ye$4.globals.embertest }, webextensions: { globals: ye$4.globals.webextensions }, greasemonkey: { globals: ye$4.globals.greasemonkey } })), Tw = "eslint@6.7.1", Pw = "sha512-UWzBS79pNcsDSxgxbdjkmzn/B6BhsXMfUaOHnNwyE8nD+Q6pyT96ow2MccVayUTV4yMid4qLhMiQaywctRkBLA==", Iw = {}, Bw = { type: "range", registry: true, raw: "eslint@^6.0.0", name: "eslint", escapedName: "eslint", rawSpec: "^6.0.0", saveSpec: null, fetchSpec: "^6.0.0" }, Ow = ["#DEV:/"], Lw = "https://registry.npmjs.org/eslint/-/eslint-6.7.1.tgz", Nw = "269ccccec3ef60ab32358a44d147ac209154b919", jw = "/home/runner/work/eslint4b/eslint4b", Rw = { name: "Nicholas C. Zakas", email: "nicholas+npm@nczconsulting.com" }, Mw = { eslint: "./bin/eslint.js" }, Vw = { url: "https://github.com/eslint/eslint/issues/" }, Uw = { "@babel/code-frame": "^7.0.0", ajv: "^6.10.0", chalk: "^2.1.0", "cross-spawn": "^6.0.5", debug: "^4.0.1", doctrine: "^3.0.0", "eslint-scope": "^5.0.0", "eslint-utils": "^1.4.3", "eslint-visitor-keys": "^1.1.0", espree: "^6.1.2", esquery: "^1.0.1", esutils: "^2.0.2", "file-entry-cache": "^5.0.1", "functional-red-black-tree": "^1.0.1", "glob-parent": "^5.0.0", globals: "^12.1.0", ignore: "^4.0.6", "import-fresh": "^3.0.0", imurmurhash: "^0.1.4", inquirer: "^7.0.0", "is-glob": "^4.0.0", "js-yaml": "^3.13.1", "json-stable-stringify-without-jsonify": "^1.0.1", levn: "^0.3.0", lodash: "^4.17.14", minimatch: "^3.0.4", mkdirp: "^0.5.1", "natural-compare": "^1.4.0", optionator: "^0.8.3", progress: "^2.0.0", regexpp: "^2.0.1", semver: "^6.1.2", "strip-ansi": "^5.2.0", "strip-json-comments": "^3.0.1", table: "^5.2.3", "text-table": "^0.2.0", "v8-compile-cache": "^2.0.3" }, qw = "An AST-based pattern checker for JavaScript.", Ww = { "@babel/core": "^7.4.3", "@babel/preset-env": "^7.4.3", acorn: "^7.1.0", "babel-loader": "^8.0.5", chai: "^4.0.1", cheerio: "^0.22.0", "common-tags": "^1.8.0", "core-js": "^3.1.3", dateformat: "^3.0.3", ejs: "^2.6.1", eslint: "file:.", "eslint-config-eslint": "file:packages/eslint-config-eslint", "eslint-plugin-eslint-plugin": "^2.0.1", "eslint-plugin-internal-rules": "file:tools/internal-rules", "eslint-plugin-jsdoc": "^15.9.5", "eslint-plugin-node": "^9.0.0", "eslint-release": "^1.2.0", eslump: "^2.0.0", esprima: "^4.0.1", glob: "^7.1.3", jsdoc: "^3.5.5", karma: "^4.0.1", "karma-chrome-launcher": "^2.2.0", "karma-mocha": "^1.3.0", "karma-mocha-reporter": "^2.2.3", "karma-webpack": "^4.0.0-rc.6", leche: "^2.2.3", "lint-staged": "^8.1.5", "load-perf": "^0.2.0", markdownlint: "^0.15.0", "markdownlint-cli": "^0.17.0", "metro-memory-fs": "^0.54.1", mocha: "^6.1.2", "mocha-junit-reporter": "^1.23.0", "npm-license": "^0.3.3", nyc: "^14.1.1", proxyquire: "^2.0.1", puppeteer: "^1.18.0", recast: "^0.18.1", "regenerator-runtime": "^0.13.2", shelljs: "^0.8.2", sinon: "^7.3.2", temp: "^0.9.0", webpack: "^4.35.0", "webpack-cli": "^3.3.5", yorkie: "^2.0.0" }, $w = { node: "^8.10.0 || ^10.13.0 || >=11.10.1" }, Gw = ["LICENSE", "README.md", "bin", "conf", "lib", "messages"], zw = "https://opencollective.com/eslint", Hw = { "pre-commit": "lint-staged" }, Kw = ["ast", "lint", "javascript", "ecmascript", "espree"], Jw = { type: "git", url: "git+https://github.com/eslint/eslint.git" }, Qw = { docs: "node Makefile.js docs", fix: "node Makefile.js lint -- fix", fuzz: "node Makefile.js fuzz", "generate-alpharelease": "node Makefile.js generatePrerelease -- alpha", "generate-betarelease": "node Makefile.js generatePrerelease -- beta", "generate-rcrelease": "node Makefile.js generatePrerelease -- rc", "generate-release": "node Makefile.js generateRelease", gensite: "node Makefile.js gensite", lint: "node Makefile.js lint", perf: "node Makefile.js perf", "publish-release": "node Makefile.js publishRelease", test: "node Makefile.js test", "test:cli": "mocha", webpack: "node Makefile.js webpack" }, JT = { _from: "eslint@^6.0.0", _id: Tw, _inBundle: false, _integrity: Pw, _location: "/eslint", _phantomChildren: Iw, _requested: Bw, _requiredBy: Ow, _resolved: Lw, _shasum: Nw, _spec: "eslint@^6.0.0", _where: jw, author: Rw, bin: Mw, bugs: Vw, bundleDependencies: false, dependencies: Uw, deprecated: false, description: qw, devDependencies: Ww, engines: $w, files: Gw, funding: zw, gitHooks: Hw, homepage: "https://eslint.org", keywords: Kw, license: "MIT", "lint-staged": { "*.js": ["eslint --fix", "git add"], "*.md": "markdownlint" }, main: "./lib/api.js", name: "eslint", repository: Jw, scripts: Qw, version: "6.7.1" }, QT = Object.freeze({ __proto__: null, _from: "eslint@^6.0.0", _id: Tw, _inBundle: false, _integrity: Pw, _location: "/eslint", _phantomChildren: Iw, _requested: Bw, _requiredBy: Ow, _resolved: Lw, _shasum: Nw, _spec: "eslint@^6.0.0", _where: jw, author: Rw, bin: Mw, bugs: Vw, bundleDependencies: false, dependencies: Uw, deprecated: false, description: qw, devDependencies: Ww, engines: $w, files: Gw, funding: zw, gitHooks: Hw, homepage: "https://eslint.org", keywords: Kw, license: "MIT", main: "./lib/api.js", name: "eslint", repository: Jw, scripts: Qw, version: "6.7.1", default: JT }), bi$1 = ye$4.createCommonjsModule(function(e28) {
  var t3 = ["off", "warn", "error"], n3 = t3.reduce(function(i, a3, s3) {
    return i[a3] = s3, i;
  }, {}), r3 = [0, 1, 2, "off", "warn", "error"];
  e28.exports = { getRuleSeverity: function(i) {
    var a3 = Array.isArray(i) ? i[0] : i;
    return a3 === 0 || a3 === 1 || a3 === 2 ? a3 : typeof a3 == "string" && n3[a3.toLowerCase()] || 0;
  }, normalizeToStrings: function(i) {
    i.rules && Object.keys(i.rules).forEach(function(a3) {
      var s3 = i.rules[a3];
      typeof s3 == "number" ? i.rules[a3] = t3[s3] || t3[0] : Array.isArray(s3) && typeof s3[0] == "number" && (s3[0] = t3[s3[0]] || t3[0]);
    });
  }, isErrorSeverity: function(i) {
    return e28.exports.getRuleSeverity(i) === 2;
  }, isValidSeverity: function(i) {
    var a3 = Array.isArray(i) ? i[0] : i;
    return typeof a3 == "string" && (a3 = a3.toLowerCase()), r3.indexOf(a3) !== -1;
  }, isEverySeverityValid: function(i) {
    var a3 = this;
    return Object.keys(i).every(function(s3) {
      return a3.isValidSeverity(i[s3]);
    });
  }, normalizeConfigGlobal: function(i) {
    switch (i) {
      case "off":
        return "off";
      case true:
      case "true":
      case "writeable":
      case "writable":
        return "writable";
      case null:
      case false:
      case "false":
      case "readable":
      case "readonly":
        return "readonly";
      default:
        throw new Error("'".concat(i, "' is not a valid configuration for a global (use 'readonly', 'writable', or 'off')"));
    }
  } };
}), vb$1 = (bi$1.getRuleSeverity, bi$1.normalizeToStrings, bi$1.isErrorSeverity, bi$1.isValidSeverity, bi$1.isEverySeverityValid, bi$1.normalizeConfigGlobal, { env: { type: "object" }, extends: { $ref: "#/definitions/stringOrStrings" }, globals: { type: "object" }, overrides: { type: "array", items: { $ref: "#/definitions/overrideConfig" }, additionalItems: false }, parser: { type: ["string", "null"] }, parserOptions: { type: "object" }, plugins: { type: "array" }, processor: { type: "string" }, rules: { type: "object" }, settings: { type: "object" }, noInlineConfig: { type: "boolean" }, reportUnusedDisableDirectives: { type: "boolean" }, ecmaFeatures: { type: "object" } }), XT = { definitions: { stringOrStrings: { oneOf: [{ type: "string" }, { type: "array", items: { type: "string" }, additionalItems: false }] }, stringOrStringsRequired: { oneOf: [{ type: "string" }, { type: "array", items: { type: "string" }, additionalItems: false, minItems: 1 }] }, objectConfig: { type: "object", properties: Sa$2({ root: { type: "boolean" }, ignorePatterns: { $ref: "#/definitions/stringOrStrings" } }, vb$1), additionalProperties: false }, overrideConfig: { type: "object", properties: Sa$2({ excludedFiles: { $ref: "#/definitions/stringOrStrings" }, files: { $ref: "#/definitions/stringOrStringsRequired" } }, vb$1), required: ["files"], additionalProperties: false } }, $ref: "#/definitions/objectConfig" }, pp = /* @__PURE__ */ new Map(), Xw = function() {
  var e28 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t3 = new HT(Sa$2({ meta: false, useDefaults: true, validateSchema: false, missingRefs: "ignore", verbose: true, schemaId: "auto" }, e28));
  return t3.addMetaSchema(gb$1), t3._opts.defaultMeta = gb$1.id, t3;
}(), jd$1 = /* @__PURE__ */ new WeakMap(), Yw = Function.prototype, YT = { ESLINT_LEGACY_ECMAFEATURES: "The 'ecmaFeatures' config file property is deprecated, and has no effect." }, ZT = { error: 2, warn: 1, off: 0 };
function Zw(e28) {
  if (!e28)
    return null;
  var t3 = e28.schema || e28.meta && e28.meta.schema;
  return Array.isArray(t3) ? t3.length ? { type: "array", items: t3, minItems: 0, maxItems: t3.length } : { type: "array", minItems: 0, maxItems: 0 } : t3 || null;
}
function eA(e28, t3, n3) {
  var r3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  try {
    (function(a3) {
      var s3 = Array.isArray(a3) ? a3[0] : a3, o3 = typeof s3 == "string" ? ZT[s3.toLowerCase()] : s3;
      if (o3 === 0 || o3 === 1 || o3 === 2)
        return o3;
      throw new Error("	Severity should be one of the following: 0 = off, 1 = warn, 2 = error (you passed '".concat(zT.inspect(s3).replace(/'/g, '"').replace(/\n/g, ""), `').
`));
    })(n3) !== 0 && function(a3, s3) {
      if (!jd$1.has(a3)) {
        var o3 = Zw(a3);
        o3 && jd$1.set(a3, Xw.compile(o3));
      }
      var u3 = jd$1.get(a3);
      if (u3 && (u3(s3), u3.errors))
        throw new Error(u3.errors.map(function(c3) {
          return "	Value ".concat(JSON.stringify(c3.data), " ").concat(c3.message, `.
`);
        }).join(""));
    }(e28, Array.isArray(n3) ? n3.slice(1) : []);
  } catch (a3) {
    var i = 'Configuration for rule "'.concat(t3, `" is invalid:
`).concat(a3.message);
    throw typeof r3 == "string" ? new Error("".concat(r3, `:
	`).concat(i)) : new Error(i);
  }
}
function Rd(e28, t3) {
  var n3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Yw;
  e28 && Object.keys(e28).forEach(function(r3) {
    if (!(n3(r3) || _w.get(r3)))
      throw new Error("".concat(t3, `:
	Environment key "`).concat(r3, `" is unknown
`));
  });
}
function Md$1(e28, t3) {
  var n3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Yw;
  e28 && Object.keys(e28).forEach(function(r3) {
    eA(n3(r3) || pp.get(r3) || null, r3, e28[r3], t3);
  });
}
function Vd(e28) {
  var t3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  e28 && Object.entries(e28).forEach(function(n3) {
    var r3 = bn$1(n3, 2), i = r3[0], a3 = r3[1];
    try {
      bi$1.normalizeConfigGlobal(a3);
    } catch (s3) {
      throw new Error("ESLint configuration of global '".concat(i, "' in ").concat(t3, ` is invalid:
`).concat(s3.message));
    }
  });
}
function eP(e28, t3, n3) {
  if (e28 && !n3(e28))
    throw new Error("ESLint configuration of processor in '".concat(t3, "' is invalid: '").concat(e28, "' was not found."));
}
var tP = ye$4.lodash.memoize(function(e28, t3) {
  var n3 = Bs$1.relative(process.cwd(), e28), r3 = YT[t3];
  process.emitWarning("".concat(r3, ' (found in "').concat(n3, '")'), "DeprecationWarning", t3);
});
function xb$1(e28) {
  var t3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!(Nd$1 = Nd$1 || Xw.compile(XT))(e28))
    throw new Error("ESLint configuration in ".concat(t3, ` is invalid:
`).concat(function(n3) {
      return n3.map(function(r3) {
        if (r3.keyword === "additionalProperties") {
          var i = r3.dataPath.length ? "".concat(r3.dataPath.slice(1), ".").concat(r3.params.additionalProperty) : r3.params.additionalProperty;
          return 'Unexpected top-level property "'.concat(i, '"');
        }
        if (r3.keyword === "type") {
          var a3 = r3.dataPath.slice(1), s3 = Array.isArray(r3.schema) ? r3.schema.join("/") : r3.schema, o3 = JSON.stringify(r3.data);
          return 'Property "'.concat(a3, '" is the wrong type (expected ').concat(s3, " but got `").concat(o3, "`)");
        }
        var u3 = r3.dataPath[0] === "." ? r3.dataPath.slice(1) : r3.dataPath;
        return '"'.concat(u3, '" ').concat(r3.message, ". Value: ").concat(JSON.stringify(r3.data));
      }).map(function(r3) {
        return "	- ".concat(r3, `.
`);
      }).join("");
    }(Nd$1.errors)));
  Object.hasOwnProperty.call(e28, "ecmaFeatures") && tP(t3, "ESLINT_LEGACY_ECMAFEATURES");
}
var bb$1 = /* @__PURE__ */ new WeakSet(), nP = { getRuleOptionsSchema: Zw, validate: function(e28, t3, n3, r3) {
  xb$1(e28, t3), Md$1(e28.rules, t3, n3), Rd(e28.env, t3, r3), Vd(e28.globals, t3);
  var i = true, a3 = false, s3 = void 0;
  try {
    for (var o3, u3 = (e28.overrides || [])[Symbol.iterator](); !(i = (o3 = u3.next()).done); i = true) {
      var c3 = o3.value;
      Md$1(c3.rules, t3, n3), Rd(c3.env, t3, r3), Vd(e28.globals, t3);
    }
  } catch (f3) {
    a3 = true, s3 = f3;
  } finally {
    try {
      i || u3.return == null || u3.return();
    } finally {
      if (a3)
        throw s3;
    }
  }
}, validateConfigArray: function(e28) {
  var t3 = Map.prototype.get.bind(e28.pluginEnvironments), n3 = Map.prototype.get.bind(e28.pluginProcessors), r3 = Map.prototype.get.bind(e28.pluginRules), i = true, a3 = false, s3 = void 0;
  try {
    for (var o3, u3 = e28[Symbol.iterator](); !(i = (o3 = u3.next()).done); i = true) {
      var c3 = o3.value;
      bb$1.has(c3) || (bb$1.add(c3), Rd(c3.env, c3.name, t3), Vd(c3.globals, c3.name), eP(c3.processor, c3.name, n3), Md$1(c3.rules, c3.name, r3));
    }
  } catch (f3) {
    a3 = true, s3 = f3;
  } finally {
    try {
      i || u3.return == null || u3.return();
    } finally {
      if (a3)
        throw s3;
    }
  }
}, validateConfigSchema: xb$1, validateRuleOptions: eA }, Dc$2 = function() {
  function e28() {
    We$1(this, e28), this.current = null;
  }
  return Xe$1(e28, [{ key: "getOneToken", value: function() {
    return this.moveNext() ? this.current : null;
  } }, { key: "getAllTokens", value: function() {
    for (var t3 = []; this.moveNext(); )
      t3.push(this.current);
    return t3;
  } }, { key: "moveNext", value: function() {
    throw new Error("Not implemented.");
  } }]), e28;
}();
function rP(e28) {
  return e28.range[0];
}
var _a$6 = { search: function(e28, t3) {
  return ye$4.lodash.sortedIndexBy(e28, { range: [t3] }, rP);
}, getFirstIndex: function(e28, t3, n3) {
  if (n3 in t3)
    return t3[n3];
  if (n3 - 1 in t3) {
    var r3 = t3[n3 - 1], i = 0 <= r3 && r3 < e28.length ? e28[r3] : null;
    return i && i.range[0] >= n3 ? r3 : r3 + 1;
  }
  return 0;
}, getLastIndex: function(e28, t3, n3) {
  if (n3 in t3)
    return t3[n3] - 1;
  if (n3 - 1 in t3) {
    var r3 = t3[n3 - 1], i = 0 <= r3 && r3 < e28.length ? e28[r3] : null;
    return i && i.range[1] > n3 ? r3 - 1 : r3;
  }
  return e28.length - 1;
} }, iP = function(e28) {
  function t3(n3, r3, i, a3, s3) {
    var o3;
    return We$1(this, t3), (o3 = Gt$3(this, rt$2(t3).call(this))).tokens = n3, o3.comments = r3, o3.tokenIndex = _a$6.getLastIndex(n3, i, s3), o3.commentIndex = _a$6.search(r3, s3) - 1, o3.border = a3, o3;
  }
  return $t$3(t3, Dc$2), Xe$1(t3, [{ key: "moveNext", value: function() {
    var n3 = 0 <= this.tokenIndex ? this.tokens[this.tokenIndex] : null, r3 = 0 <= this.commentIndex ? this.comments[this.commentIndex] : null;
    return n3 && (!r3 || n3.range[1] > r3.range[1]) ? (this.current = n3, this.tokenIndex -= 1) : r3 ? (this.current = r3, this.commentIndex -= 1) : this.current = null, !!this.current && (this.border === -1 || this.current.range[0] >= this.border);
  } }]), t3;
}(), aP = function(e28) {
  function t3(n3, r3, i, a3, s3) {
    var o3;
    return We$1(this, t3), (o3 = Gt$3(this, rt$2(t3).call(this))).tokens = n3, o3.index = _a$6.getLastIndex(n3, i, s3), o3.indexEnd = _a$6.getFirstIndex(n3, i, a3), o3;
  }
  return $t$3(t3, Dc$2), Xe$1(t3, [{ key: "moveNext", value: function() {
    return this.index >= this.indexEnd && (this.current = this.tokens[this.index], this.index -= 1, true);
  } }, { key: "getOneToken", value: function() {
    return this.index >= this.indexEnd ? this.tokens[this.index] : null;
  } }]), t3;
}(), ag = function(e28) {
  function t3(n3) {
    var r3;
    return We$1(this, t3), (r3 = Gt$3(this, rt$2(t3).call(this))).cursor = n3, r3;
  }
  return $t$3(t3, Dc$2), Xe$1(t3, [{ key: "moveNext", value: function() {
    var n3 = this.cursor.moveNext();
    return this.current = this.cursor.current, n3;
  } }]), t3;
}(), oP = function(e28) {
  function t3(n3, r3) {
    var i;
    return We$1(this, t3), (i = Gt$3(this, rt$2(t3).call(this, n3))).predicate = r3, i;
  }
  return $t$3(t3, ag), Xe$1(t3, [{ key: "moveNext", value: function() {
    for (var n3 = this.predicate; Yn$2(rt$2(t3.prototype), "moveNext", this).call(this); )
      if (n3(this.current))
        return true;
    return false;
  } }]), t3;
}(), sP = function(e28) {
  function t3(n3, r3, i, a3, s3) {
    var o3;
    return We$1(this, t3), (o3 = Gt$3(this, rt$2(t3).call(this))).tokens = n3, o3.comments = r3, o3.tokenIndex = _a$6.getFirstIndex(n3, i, a3), o3.commentIndex = _a$6.search(r3, a3), o3.border = s3, o3;
  }
  return $t$3(t3, Dc$2), Xe$1(t3, [{ key: "moveNext", value: function() {
    var n3 = this.tokenIndex < this.tokens.length ? this.tokens[this.tokenIndex] : null, r3 = this.commentIndex < this.comments.length ? this.comments[this.commentIndex] : null;
    return n3 && (!r3 || n3.range[0] < r3.range[0]) ? (this.current = n3, this.tokenIndex += 1) : r3 ? (this.current = r3, this.commentIndex += 1) : this.current = null, !!this.current && (this.border === -1 || this.current.range[1] <= this.border);
  } }]), t3;
}(), og = function(e28) {
  function t3(n3, r3, i, a3, s3) {
    var o3;
    return We$1(this, t3), (o3 = Gt$3(this, rt$2(t3).call(this))).tokens = n3, o3.index = _a$6.getFirstIndex(n3, i, a3), o3.indexEnd = _a$6.getLastIndex(n3, i, s3), o3;
  }
  return $t$3(t3, Dc$2), Xe$1(t3, [{ key: "moveNext", value: function() {
    return this.index <= this.indexEnd && (this.current = this.tokens[this.index], this.index += 1, true);
  } }, { key: "getOneToken", value: function() {
    return this.index <= this.indexEnd ? this.tokens[this.index] : null;
  } }, { key: "getAllTokens", value: function() {
    return this.tokens.slice(this.index, this.indexEnd + 1);
  } }]), t3;
}(), uP = function(e28) {
  function t3(n3, r3) {
    var i;
    return We$1(this, t3), (i = Gt$3(this, rt$2(t3).call(this, n3))).count = r3, i;
  }
  return $t$3(t3, ag), Xe$1(t3, [{ key: "moveNext", value: function() {
    return 0 < this.count && (this.count -= 1, Yn$2(rt$2(t3.prototype), "moveNext", this).call(this));
  } }]), t3;
}(), cP = function(e28) {
  function t3(n3, r3) {
    var i;
    return We$1(this, t3), (i = Gt$3(this, rt$2(t3).call(this, n3))).count = r3, i;
  }
  return $t$3(t3, ag), Xe$1(t3, [{ key: "moveNext", value: function() {
    for (; 0 < this.count; )
      if (this.count -= 1, !Yn$2(rt$2(t3.prototype), "moveNext", this).call(this))
        return false;
    return Yn$2(rt$2(t3.prototype), "moveNext", this).call(this);
  } }]), t3;
}(), Eb$1 = function() {
  function e28(t3, n3) {
    We$1(this, e28), this.TokenCursor = t3, this.TokenCommentCursor = n3;
  }
  return Xe$1(e28, [{ key: "createBaseCursor", value: function(t3, n3, r3, i, a3, s3) {
    return new (s3 ? this.TokenCommentCursor : this.TokenCursor)(t3, n3, r3, i, a3);
  } }, { key: "createCursor", value: function(t3, n3, r3, i, a3, s3, o3, u3, c3) {
    var f3 = this.createBaseCursor(t3, n3, r3, i, a3, s3);
    return o3 && (f3 = new oP(f3, o3)), 1 <= u3 && (f3 = new cP(f3, u3)), 0 <= c3 && (f3 = new uP(f3, c3)), f3;
  } }]), e28;
}(), Qn$1 = { forward: new Eb$1(og, sP), backward: new Eb$1(aP, iP) }, lP = function(e28) {
  function t3(n3, r3, i, a3, s3, o3, u3) {
    var c3;
    return We$1(this, t3), (c3 = Gt$3(this, rt$2(t3).call(this, n3, r3, i, a3, s3))).index = Math.max(0, c3.index - o3), c3.indexEnd = Math.min(n3.length - 1, c3.indexEnd + u3), c3;
  }
  return $t$3(t3, og), t3;
}(), tA = ye$4.require$$0.isCommentToken, Nn$1 = Symbol("tokens"), kn$1 = Symbol("comments"), jn$1 = Symbol("indexMap");
function ps$1(e28, t3, n3, r3, i, a3, s3) {
  var o3 = false, u3 = 0, c3 = null;
  return typeof s3 == "number" ? u3 = 0 | s3 : typeof s3 == "function" ? c3 = s3 : s3 && (o3 = !!s3.includeComments, u3 = 0 | s3.skip, c3 = s3.filter || null), Rr$1(0 <= u3, "options.skip should be zero or a positive integer."), Rr$1(!c3 || typeof c3 == "function", "options.filter should be a function."), e28.createCursor(t3, n3, r3, i, a3, o3, c3, u3, -1);
}
function ma$3(e28, t3, n3, r3, i, a3, s3) {
  var o3 = false, u3 = 0, c3 = false, f3 = null;
  return typeof s3 == "number" ? (u3 = 0 | s3, c3 = true) : typeof s3 == "function" ? f3 = s3 : s3 && (o3 = !!s3.includeComments, u3 = 0 | s3.count, c3 = typeof s3.count == "number", f3 = s3.filter || null), Rr$1(0 <= u3, "options.count should be zero or a positive integer."), Rr$1(!f3 || typeof f3 == "function", "options.filter should be a function."), e28.createCursor(t3, n3, r3, i, a3, o3, f3, 0, c3 ? u3 : -1);
}
function Cb$1(e28, t3, n3, r3, i, a3, s3) {
  return a3 === void 0 && s3 === void 0 ? new og(e28, t3, n3, r3, i) : typeof a3 == "number" || a3 === void 0 ? new lP(e28, t3, n3, r3, i, 0 | a3, 0 | s3) : ma$3(Qn$1.forward, e28, t3, n3, r3, i, a3);
}
function Sb$1(e28) {
  for (var t3 = [], n3 = e28.getOneToken(); n3 && tA(n3); )
    t3.push(n3), n3 = e28.getOneToken();
  return t3;
}
var pP = function() {
  function e28(t3, n3) {
    We$1(this, e28), this[Nn$1] = t3, this[kn$1] = n3, this[jn$1] = function(r3, i) {
      for (var a3 = Number.MAX_SAFE_INTEGER, s3 = /* @__PURE__ */ Object.create(null), o3 = 0, u3 = 0, c3 = 0, f3 = null; o3 < r3.length || u3 < i.length; ) {
        for (c3 = u3 < i.length ? i[u3].range[0] : a3; o3 < r3.length && (f3 = r3[o3].range)[0] < c3; )
          s3[f3[0]] = o3, s3[f3[1] - 1] = o3, o3 += 1;
        for (c3 = o3 < r3.length ? r3[o3].range[0] : a3; u3 < i.length && (f3 = i[u3].range)[0] < c3; )
          s3[f3[0]] = o3, s3[f3[1] - 1] = o3, u3 += 1;
      }
      return s3;
    }(t3, n3);
  }
  return Xe$1(e28, [{ key: "getTokenByRangeStart", value: function(t3, n3) {
    var r3 = n3 && n3.includeComments, i = Qn$1.forward.createBaseCursor(this[Nn$1], this[kn$1], this[jn$1], t3, -1, r3).getOneToken();
    return i && i.range[0] === t3 ? i : null;
  } }, { key: "getFirstToken", value: function(t3, n3) {
    return ps$1(Qn$1.forward, this[Nn$1], this[kn$1], this[jn$1], t3.range[0], t3.range[1], n3).getOneToken();
  } }, { key: "getLastToken", value: function(t3, n3) {
    return ps$1(Qn$1.backward, this[Nn$1], this[kn$1], this[jn$1], t3.range[0], t3.range[1], n3).getOneToken();
  } }, { key: "getTokenBefore", value: function(t3, n3) {
    return ps$1(Qn$1.backward, this[Nn$1], this[kn$1], this[jn$1], -1, t3.range[0], n3).getOneToken();
  } }, { key: "getTokenAfter", value: function(t3, n3) {
    return ps$1(Qn$1.forward, this[Nn$1], this[kn$1], this[jn$1], t3.range[1], -1, n3).getOneToken();
  } }, { key: "getFirstTokenBetween", value: function(t3, n3, r3) {
    return ps$1(Qn$1.forward, this[Nn$1], this[kn$1], this[jn$1], t3.range[1], n3.range[0], r3).getOneToken();
  } }, { key: "getLastTokenBetween", value: function(t3, n3, r3) {
    return ps$1(Qn$1.backward, this[Nn$1], this[kn$1], this[jn$1], t3.range[1], n3.range[0], r3).getOneToken();
  } }, { key: "getTokenOrCommentBefore", value: function(t3, n3) {
    return this.getTokenBefore(t3, { includeComments: true, skip: n3 });
  } }, { key: "getTokenOrCommentAfter", value: function(t3, n3) {
    return this.getTokenAfter(t3, { includeComments: true, skip: n3 });
  } }, { key: "getFirstTokens", value: function(t3, n3) {
    return ma$3(Qn$1.forward, this[Nn$1], this[kn$1], this[jn$1], t3.range[0], t3.range[1], n3).getAllTokens();
  } }, { key: "getLastTokens", value: function(t3, n3) {
    return ma$3(Qn$1.backward, this[Nn$1], this[kn$1], this[jn$1], t3.range[0], t3.range[1], n3).getAllTokens().reverse();
  } }, { key: "getTokensBefore", value: function(t3, n3) {
    return ma$3(Qn$1.backward, this[Nn$1], this[kn$1], this[jn$1], -1, t3.range[0], n3).getAllTokens().reverse();
  } }, { key: "getTokensAfter", value: function(t3, n3) {
    return ma$3(Qn$1.forward, this[Nn$1], this[kn$1], this[jn$1], t3.range[1], -1, n3).getAllTokens();
  } }, { key: "getFirstTokensBetween", value: function(t3, n3, r3) {
    return ma$3(Qn$1.forward, this[Nn$1], this[kn$1], this[jn$1], t3.range[1], n3.range[0], r3).getAllTokens();
  } }, { key: "getLastTokensBetween", value: function(t3, n3, r3) {
    return ma$3(Qn$1.backward, this[Nn$1], this[kn$1], this[jn$1], t3.range[1], n3.range[0], r3).getAllTokens().reverse();
  } }, { key: "getTokens", value: function(t3, n3, r3) {
    return Cb$1(this[Nn$1], this[kn$1], this[jn$1], t3.range[0], t3.range[1], n3, r3).getAllTokens();
  } }, { key: "getTokensBetween", value: function(t3, n3, r3) {
    return Cb$1(this[Nn$1], this[kn$1], this[jn$1], t3.range[1], n3.range[0], r3, r3).getAllTokens();
  } }, { key: "commentsExistBetween", value: function(t3, n3) {
    var r3 = _a$6.search(this[kn$1], t3.range[1]);
    return r3 < this[kn$1].length && this[kn$1][r3].range[1] <= n3.range[0];
  } }, { key: "getCommentsBefore", value: function(t3) {
    return Sb$1(ma$3(Qn$1.backward, this[Nn$1], this[kn$1], this[jn$1], -1, t3.range[0], { includeComments: true })).reverse();
  } }, { key: "getCommentsAfter", value: function(t3) {
    return Sb$1(ma$3(Qn$1.forward, this[Nn$1], this[kn$1], this[jn$1], t3.range[1], -1, { includeComments: true }));
  } }, { key: "getCommentsInside", value: function(t3) {
    return this.getTokens(t3, { includeComments: true, filter: tA });
  } }]), e28;
}(), $l = ye$4.require$$0.isCommentToken, fP = { SourceCode: function(e28) {
  function t3(n3, r3) {
    var i, a3, s3, o3, u3, c3;
    We$1(this, t3), typeof n3 == "string" ? (a3 = n3, s3 = r3) : xe$3(n3) == "object" && n3 !== null && (a3 = n3.text, s3 = n3.ast, o3 = n3.parserServices, u3 = n3.scopeManager, c3 = n3.visitorKeys), function(m3) {
      if (!m3.tokens)
        throw new Error("AST is missing the tokens array.");
      if (!m3.comments)
        throw new Error("AST is missing the comments array.");
      if (!m3.loc)
        throw new Error("AST is missing location information.");
      if (!m3.range)
        throw new Error("AST is missing range information");
    }(s3), (i = Gt$3(this, rt$2(t3).call(this, s3.tokens, s3.comments))).hasBOM = a3.charCodeAt(0) === 65279, i.text = i.hasBOM ? a3.slice(1) : a3, i.ast = s3, i.parserServices = o3 || {}, i.scopeManager = u3 || null, i.visitorKeys = c3 || ye$4.Traverser.DEFAULT_VISITOR_KEYS;
    var f3 = i.text.match(ye$4.require$$0$1.shebangPattern);
    f3 && s3.comments.length && s3.comments[0].value === f3[1] && (s3.comments[0].type = "Shebang"), i.tokensAndComments = function(m3, y3) {
      for (var v3 = [], b3 = 0, x3 = 0; b3 < m3.length || x3 < y3.length; )
        x3 >= y3.length || b3 < m3.length && m3[b3].range[0] < y3[x3].range[0] ? v3.push(m3[b3++]) : v3.push(y3[x3++]);
      return v3;
    }(s3.tokens, s3.comments), i.lines = [], i.lineStartIndices = [0];
    for (var p3, d3 = ye$4.require$$0$1.createGlobalLinebreakMatcher(); p3 = d3.exec(i.text); )
      i.lines.push(i.text.slice(i.lineStartIndices[i.lineStartIndices.length - 1], p3.index)), i.lineStartIndices.push(p3.index + p3[0].length);
    return i.lines.push(i.text.slice(i.lineStartIndices[i.lineStartIndices.length - 1])), i._commentCache = /* @__PURE__ */ new WeakMap(), Object.freeze(tE(i)), Object.freeze(i.lines), i;
  }
  return $t$3(t3, pP), Xe$1(t3, [{ key: "getText", value: function(n3, r3, i) {
    return n3 ? this.text.slice(Math.max(n3.range[0] - (r3 || 0), 0), n3.range[1] + (i || 0)) : this.text;
  } }, { key: "getLines", value: function() {
    return this.lines;
  } }, { key: "getAllComments", value: function() {
    return this.ast.comments;
  } }, { key: "getComments", value: function(n3) {
    if (this._commentCache.has(n3))
      return this._commentCache.get(n3);
    var r3 = { leading: [], trailing: [] };
    if (n3.type === "Program")
      n3.body.length === 0 && (r3.leading = n3.comments);
    else {
      ((n3.type === "BlockStatement" || n3.type === "ClassBody") && n3.body.length === 0 || n3.type === "ObjectExpression" && n3.properties.length === 0 || n3.type === "ArrayExpression" && n3.elements.length === 0 || n3.type === "SwitchStatement" && n3.cases.length === 0) && (r3.trailing = this.getTokens(n3, { includeComments: true, filter: $l }));
      for (var i = this.getTokenBefore(n3, { includeComments: true }); i && $l(i) && !(n3.parent && i.start < n3.parent.start); )
        r3.leading.push(i), i = this.getTokenBefore(i, { includeComments: true });
      for (r3.leading.reverse(), i = this.getTokenAfter(n3, { includeComments: true }); i && $l(i) && !(n3.parent && i.end > n3.parent.end); )
        r3.trailing.push(i), i = this.getTokenAfter(i, { includeComments: true });
    }
    return this._commentCache.set(n3, r3), r3;
  } }, { key: "getJSDocComment", value: function(n3) {
    var r3 = this, i = function(s3) {
      var o3 = r3.getTokenBefore(s3, { includeComments: true });
      return o3 && $l(o3) && o3.type === "Block" && o3.value.charAt(0) === "*" && 1 >= s3.loc.start.line - o3.loc.end.line ? o3 : null;
    }, a3 = n3.parent;
    switch (n3.type) {
      case "ClassDeclaration":
      case "FunctionDeclaration":
        return i(function(s3) {
          return s3.type === "ExportDefaultDeclaration" || s3.type === "ExportNamedDeclaration" || s3.type === "ExportAllDeclaration" || s3.type === "ExportSpecifier";
        }(a3) ? a3 : n3);
      case "ClassExpression":
        return i(a3.parent);
      case "ArrowFunctionExpression":
      case "FunctionExpression":
        if (a3.type !== "CallExpression" && a3.type !== "NewExpression") {
          for (; !this.getCommentsBefore(a3).length && !/Function/.test(a3.type) && a3.type !== "MethodDefinition" && a3.type !== "Property" && (a3 = a3.parent); )
            ;
          if (a3 && a3.type !== "FunctionDeclaration" && a3.type !== "Program")
            return i(a3);
        }
        return i(n3);
      default:
        return null;
    }
  } }, { key: "getNodeByRangeIndex", value: function(n3) {
    var r3 = null;
    return ye$4.Traverser.traverse(this.ast, { visitorKeys: this.visitorKeys, enter: function(i) {
      i.range[0] <= n3 && n3 < i.range[1] ? r3 = i : this.skip();
    }, leave: function(i) {
      i === r3 && this.break();
    } }), r3;
  } }, { key: "isSpaceBetween", value: function(n3, r3) {
    if (function(p3, d3) {
      return p3.range[0] <= d3.range[0] && p3.range[1] >= d3.range[0] || d3.range[0] <= p3.range[0] && d3.range[1] >= p3.range[0];
    }(n3, r3))
      return false;
    for (var i = bn$1(n3.range[1] <= r3.range[0] ? [n3, r3] : [r3, n3], 2), a3 = i[0], s3 = i[1], o3 = this.getLastToken(a3) || a3, u3 = this.getFirstToken(s3) || s3, c3 = o3; c3 !== u3; ) {
      var f3 = this.getTokenAfter(c3, { includeComments: true });
      if (c3.range[1] !== f3.range[0])
        return true;
      c3 = f3;
    }
    return false;
  } }, { key: "isSpaceBetweenTokens", value: function() {
    return this.isSpaceBetween.apply(this, arguments);
  } }, { key: "getLocFromIndex", value: function(n3) {
    if (typeof n3 != "number")
      throw new TypeError("Expected `index` to be a number.");
    if (0 > n3 || n3 > this.text.length)
      throw new RangeError("Index out of range (requested index ".concat(n3, ", but source text has length ").concat(this.text.length, ")."));
    if (n3 === this.text.length)
      return { line: this.lines.length, column: this.lines[this.lines.length - 1].length };
    var r3 = ye$4.lodash.sortedLastIndex(this.lineStartIndices, n3);
    return { line: r3, column: n3 - this.lineStartIndices[r3 - 1] };
  } }, { key: "getIndexFromLoc", value: function(n3) {
    if (xe$3(n3) != "object" || typeof n3.line != "number" || typeof n3.column != "number")
      throw new TypeError("Expected `loc` to be an object with numeric `line` and `column` properties.");
    if (0 >= n3.line)
      throw new RangeError("Line number out of range (line ".concat(n3.line, " requested). Line numbers should be 1-based."));
    if (n3.line > this.lineStartIndices.length)
      throw new RangeError("Line number out of range (line ".concat(n3.line, " requested, but only ").concat(this.lineStartIndices.length, " lines present)."));
    var r3 = this.lineStartIndices[n3.line - 1], i = n3.line === this.lineStartIndices.length ? this.text.length : this.lineStartIndices[n3.line], a3 = r3 + n3.column;
    if (n3.line === this.lineStartIndices.length && a3 > i || n3.line < this.lineStartIndices.length && a3 >= i)
      throw new RangeError("Column number out of range (column ".concat(n3.column, " requested, but the length of line ").concat(n3.line, " is ").concat(i - r3, ")."));
    return a3;
  } }], [{ key: "splitLines", value: function(n3) {
    return n3.split(ye$4.require$$0$1.createGlobalLinebreakMatcher());
  } }]), t3;
}() }, Ga$2 = ye$4.require$$1("eslint:code-path");
function hP(e28) {
  return e28.id + (e28.reachable ? "" : "!");
}
var ii$1 = { enabled: Ga$2.enabled, dump: Ga$2, dumpState: Ga$2.enabled ? function(e28, t3, n3) {
  for (var r3 = 0; r3 < t3.currentSegments.length; ++r3) {
    var i = t3.currentSegments[r3].internal;
    n3 ? i.exitNodes.push(e28) : i.nodes.push(e28);
  }
  Ga$2(["".concat(t3.currentSegments.map(hP).join(","), ")"), "".concat(e28.type).concat(n3 ? ":exit" : "")].join(" "));
} : Ga$2, dumpDot: Ga$2.enabled ? function(e28) {
  var t3 = `
digraph {
node[shape=box,style="rounded,filled",fillcolor=white];
initial[label="",shape=circle,style=filled,fillcolor=black,width=0.25,height=0.25];
`;
  0 < e28.returnedSegments.length && (t3 += `final[label="",shape=doublecircle,style=filled,fillcolor=black,width=0.25,height=0.25];
`), 0 < e28.thrownSegments.length && (t3 += `thrown[label="\u2718",shape=circle,width=0.3,height=0.3,fixedsize];
`);
  var n3 = /* @__PURE__ */ Object.create(null), r3 = this.makeDotArrows(e28, n3);
  for (var i in n3) {
    var a3 = n3[i];
    t3 += "".concat(i, "["), t3 += a3.reachable ? 'label="' : 'style="rounded,dashed,filled",fillcolor="#FF9800",label="<<unreachable>>\\n', t3 += 0 < a3.internal.nodes.length || 0 < a3.internal.exitNodes.length ? [].concat(a3.internal.nodes.map(function(s3) {
      switch (s3.type) {
        case "Identifier":
          return "".concat(s3.type, " (").concat(s3.name, ")");
        case "Literal":
          return "".concat(s3.type, " (").concat(s3.value, ")");
        default:
          return s3.type;
      }
    }), a3.internal.exitNodes.map(function(s3) {
      switch (s3.type) {
        case "Identifier":
          return "".concat(s3.type, ":exit (").concat(s3.name, ")");
        case "Literal":
          return "".concat(s3.type, ":exit (").concat(s3.value, ")");
        default:
          return "".concat(s3.type, ":exit");
      }
    })).join("\\n") : "????", t3 += `"];
`;
  }
  t3 += "".concat(r3, `
`), Ga$2("DOT", t3 += "}");
} : Ga$2, makeDotArrows: function(e28, t3) {
  for (var n3 = [[e28.initialSegment, 0]], r3 = t3 || /* @__PURE__ */ Object.create(null), i = e28.initialSegment.id, a3 = "initial->".concat(e28.initialSegment.id); 0 < n3.length; ) {
    var s3 = n3.pop(), o3 = s3[0], u3 = s3[1];
    if (!r3[o3.id] || u3 !== 0) {
      r3[o3.id] = o3;
      var c3 = o3.allNextSegments[u3];
      c3 && (a3 += i === o3.id ? "->".concat(c3.id) : `;
`.concat(o3.id, "->").concat(c3.id), i = c3.id, n3.unshift([o3, 1 + u3]), n3.push([c3, 0]));
    }
  }
  return e28.returnedSegments.forEach(function(f3) {
    a3 += i === f3.id ? "->final" : `;
`.concat(f3.id, "->final"), i = null;
  }), e28.thrownSegments.forEach(function(f3) {
    a3 += i === f3.id ? "->thrown" : `;
`.concat(f3.id, "->thrown"), i = null;
  }), "".concat(a3, ";");
} };
function Ud(e28) {
  return e28.reachable;
}
var qi$2 = function() {
  function e28(t3, n3, r3) {
    We$1(this, e28), this.id = t3, this.nextSegments = [], this.prevSegments = n3.filter(Ud), this.allNextSegments = [], this.allPrevSegments = n3, this.reachable = r3, Object.defineProperty(this, "internal", { value: { used: false, loopedPrevSegments: [] } }), ii$1.enabled && (this.internal.nodes = [], this.internal.exitNodes = []);
  }
  return Xe$1(e28, [{ key: "isLoopedPrevSegment", value: function(t3) {
    return this.internal.loopedPrevSegments.indexOf(t3) !== -1;
  } }], [{ key: "newRoot", value: function(t3) {
    return new e28(t3, [], true);
  } }, { key: "newNext", value: function(t3, n3) {
    return new e28(t3, e28.flattenUnusedSegments(n3), n3.some(Ud));
  } }, { key: "newUnreachable", value: function(t3, n3) {
    var r3 = new e28(t3, e28.flattenUnusedSegments(n3), false);
    return e28.markUsed(r3), r3;
  } }, { key: "newDisconnected", value: function(t3, n3) {
    return new e28(t3, [], n3.some(Ud));
  } }, { key: "markUsed", value: function(t3) {
    var n3;
    if (!t3.internal.used)
      if (t3.internal.used = true, t3.reachable)
        for (n3 = 0; n3 < t3.allPrevSegments.length; ++n3) {
          var r3 = t3.allPrevSegments[n3];
          r3.allNextSegments.push(t3), r3.nextSegments.push(t3);
        }
      else
        for (n3 = 0; n3 < t3.allPrevSegments.length; ++n3)
          t3.allPrevSegments[n3].allNextSegments.push(t3);
  } }, { key: "markPrevSegmentAsLooped", value: function(t3, n3) {
    t3.internal.loopedPrevSegments.push(n3);
  } }, { key: "flattenUnusedSegments", value: function(t3) {
    for (var n3 = /* @__PURE__ */ Object.create(null), r3 = [], i = 0; i < t3.length; ++i) {
      var a3 = t3[i];
      if (!n3[a3.id])
        if (a3.internal.used)
          n3[a3.id] = true, r3.push(a3);
        else
          for (var s3 = 0; s3 < a3.allPrevSegments.length; ++s3) {
            var o3 = a3.allPrevSegments[s3];
            n3[o3.id] || (n3[o3.id] = true, r3.push(o3));
          }
    }
    return r3;
  } }]), e28;
}();
function dP(e28) {
  return e28.reachable;
}
function qd$1(e28, t3, n3, r3) {
  for (var i = e28.segmentsList, a3 = 0 <= t3 ? t3 : i.length + t3, s3 = 0 <= n3 ? n3 : i.length + n3, o3 = [], u3 = 0; u3 < e28.count; ++u3) {
    for (var c3 = [], f3 = a3; f3 <= s3; ++f3)
      c3.push(i[f3][u3]);
    o3.push(r3(e28.idGenerator.next(), c3));
  }
  return o3;
}
function kb$1(e28, t3) {
  for (var n3 = t3; n3.length > e28.count; ) {
    for (var r3 = [], i = 0, a3 = 0 | n3.length / 2; i < a3; ++i)
      r3.push(qi$2.newNext(e28.idGenerator.next(), [n3[i], n3[i + a3]]));
    n3 = r3;
  }
  return n3;
}
var Xr$1 = function() {
  function e28(t3, n3, r3) {
    We$1(this, e28), this.idGenerator = t3, this.upper = n3, this.count = r3, this.segmentsList = [];
  }
  return Xe$1(e28, [{ key: "makeNext", value: function(t3, n3) {
    return qd$1(this, t3, n3, qi$2.newNext);
  } }, { key: "makeUnreachable", value: function(t3, n3) {
    return qd$1(this, t3, n3, qi$2.newUnreachable);
  } }, { key: "makeDisconnected", value: function(t3, n3) {
    return qd$1(this, t3, n3, qi$2.newDisconnected);
  } }, { key: "add", value: function(t3) {
    Rr$1(t3.length >= this.count, "".concat(t3.length, " >= ").concat(this.count)), this.segmentsList.push(kb$1(this, t3));
  } }, { key: "replaceHead", value: function(t3) {
    Rr$1(t3.length >= this.count, "".concat(t3.length, " >= ").concat(this.count)), this.segmentsList.splice(-1, 1, kb$1(this, t3));
  } }, { key: "addAll", value: function(t3) {
    Rr$1(t3.count === this.count);
    for (var n3 = t3.segmentsList, r3 = 0; r3 < n3.length; ++r3)
      this.segmentsList.push(n3[r3]);
  } }, { key: "clear", value: function() {
    this.segmentsList = [];
  } }, { key: "head", get: function() {
    var t3 = this.segmentsList;
    return t3.length === 0 ? [] : t3[t3.length - 1];
  } }, { key: "empty", get: function() {
    return this.segmentsList.length === 0;
  } }, { key: "reachable", get: function() {
    var t3 = this.head;
    return 0 < t3.length && t3.some(dP);
  } }], [{ key: "newRoot", value: function(t3) {
    var n3 = new e28(t3, null, 1);
    return n3.add([qi$2.newRoot(t3.next())]), n3;
  } }, { key: "newEmpty", value: function(t3, n3) {
    return new e28(t3.idGenerator, t3, (n3 ? 2 : 1) * t3.count);
  } }]), e28;
}();
function Db$1(e28, t3, n3, r3) {
  for (var i = 0; i < r3.length; ++i) {
    var a3 = r3[i];
    e28.push(a3), t3.indexOf(a3) === -1 && n3.push(a3);
  }
}
function Fb$1(e28) {
  for (var t3 = e28.tryContext; t3; ) {
    if (t3.hasFinalizer && t3.position !== "finally")
      return t3;
    t3 = t3.upper;
  }
  return e28;
}
function Wd(e28) {
  for (var t3 = e28.tryContext; t3; ) {
    if (t3.position === "try" || t3.hasFinalizer && t3.position === "catch")
      return t3;
    t3 = t3.upper;
  }
  return e28;
}
function Gl(e28, t3) {
  e28.splice(e28.indexOf(t3), 1);
}
function Do$1(e28, t3, n3) {
  for (var r3 = qi$2.flattenUnusedSegments(t3), i = qi$2.flattenUnusedSegments(n3), a3 = Math.min(r3.length, i.length), s3 = 0; s3 < a3; ++s3) {
    var o3 = r3[s3], u3 = i[s3];
    u3.reachable && o3.nextSegments.push(u3), o3.reachable && u3.prevSegments.push(o3), o3.allNextSegments.push(u3), u3.allPrevSegments.push(o3), 2 <= u3.allPrevSegments.length && qi$2.markPrevSegmentAsLooped(u3, o3), e28.notifyLooped(o3, u3);
  }
}
function wb$1(e28, t3, n3) {
  t3.processed || (t3.trueForkContext.add(n3), t3.falseForkContext.add(n3)), e28.test !== true && e28.brokenForkContext.addAll(t3.falseForkContext), e28.endOfTestSegments = t3.trueForkContext.makeNext(0, -1);
}
var mP = function() {
  function e28(t3, n3) {
    We$1(this, e28), this.idGenerator = t3, this.notifyLooped = n3, this.forkContext = Xr$1.newRoot(t3), this.choiceContext = null, this.switchContext = null, this.tryContext = null, this.loopContext = null, this.breakContext = null, this.currentSegments = [], this.initialSegment = this.forkContext.head[0];
    var r3 = this.finalSegments = [], i = this.returnedForkContext = [], a3 = this.thrownForkContext = [];
    i.add = Db$1.bind(null, i, a3, r3), a3.add = Db$1.bind(null, a3, i, r3);
  }
  return Xe$1(e28, [{ key: "pushForkContext", value: function(t3) {
    return this.forkContext = Xr$1.newEmpty(this.forkContext, t3), this.forkContext;
  } }, { key: "popForkContext", value: function() {
    var t3 = this.forkContext;
    return this.forkContext = t3.upper, this.forkContext.replaceHead(t3.makeNext(0, -1)), t3;
  } }, { key: "forkPath", value: function() {
    this.forkContext.add(this.parentForkContext.makeNext(-1, -1));
  } }, { key: "forkBypassPath", value: function() {
    this.forkContext.add(this.parentForkContext.head);
  } }, { key: "pushChoiceContext", value: function(t3, n3) {
    this.choiceContext = { upper: this.choiceContext, kind: t3, isForkingAsResult: n3, trueForkContext: Xr$1.newEmpty(this.forkContext), falseForkContext: Xr$1.newEmpty(this.forkContext), processed: false };
  } }, { key: "popChoiceContext", value: function() {
    var t3 = this.choiceContext;
    this.choiceContext = t3.upper;
    var n3 = this.forkContext, r3 = n3.head;
    switch (t3.kind) {
      case "&&":
      case "||":
        if (t3.processed || (t3.trueForkContext.add(r3), t3.falseForkContext.add(r3)), t3.isForkingAsResult) {
          var i = this.choiceContext;
          return i.trueForkContext.addAll(t3.trueForkContext), i.falseForkContext.addAll(t3.falseForkContext), i.processed = true, t3;
        }
        break;
      case "test":
        t3.processed ? (t3.falseForkContext.clear(), t3.falseForkContext.add(r3)) : (t3.trueForkContext.clear(), t3.trueForkContext.add(r3));
        break;
      case "loop":
        return t3;
      default:
        throw new Error("unreachable");
    }
    var a3 = t3.trueForkContext;
    return a3.addAll(t3.falseForkContext), n3.replaceHead(a3.makeNext(0, -1)), t3;
  } }, { key: "makeLogicalRight", value: function() {
    var t3 = this.choiceContext, n3 = this.forkContext;
    if (t3.processed) {
      var r3 = t3.kind === "&&" ? t3.trueForkContext : t3.falseForkContext;
      n3.replaceHead(r3.makeNext(0, -1)), r3.clear(), t3.processed = false;
    } else
      t3.kind === "&&" ? t3.falseForkContext.add(n3.head) : t3.trueForkContext.add(n3.head), n3.replaceHead(n3.makeNext(-1, -1));
  } }, { key: "makeIfConsequent", value: function() {
    var t3 = this.choiceContext, n3 = this.forkContext;
    t3.processed || (t3.trueForkContext.add(n3.head), t3.falseForkContext.add(n3.head)), t3.processed = false, n3.replaceHead(t3.trueForkContext.makeNext(0, -1));
  } }, { key: "makeIfAlternate", value: function() {
    var t3 = this.choiceContext, n3 = this.forkContext;
    t3.trueForkContext.clear(), t3.trueForkContext.add(n3.head), t3.processed = true, n3.replaceHead(t3.falseForkContext.makeNext(0, -1));
  } }, { key: "pushSwitchContext", value: function(t3, n3) {
    this.switchContext = { upper: this.switchContext, hasCase: t3, defaultSegments: null, defaultBodySegments: null, foundDefault: false, lastIsDefault: false, countForks: 0 }, this.pushBreakContext(true, n3);
  } }, { key: "popSwitchContext", value: function() {
    var t3 = this.switchContext;
    this.switchContext = t3.upper;
    var n3 = this.forkContext, r3 = this.popBreakContext().brokenForkContext;
    if (t3.countForks !== 0) {
      var i = n3.head;
      this.forkBypassPath();
      var a3 = n3.head;
      r3.add(i), t3.lastIsDefault || (t3.defaultBodySegments ? (function(o3, u3) {
        for (var c3 = 0; c3 < o3.length; ++c3) {
          var f3 = o3[c3], p3 = u3[c3];
          Gl(f3.nextSegments, p3), Gl(f3.allNextSegments, p3), Gl(p3.prevSegments, f3), Gl(p3.allPrevSegments, f3);
        }
      }(t3.defaultSegments, t3.defaultBodySegments), Do$1(this, a3, t3.defaultBodySegments)) : r3.add(a3));
      for (var s3 = 0; s3 < t3.countForks; ++s3)
        this.forkContext = this.forkContext.upper;
      this.forkContext.replaceHead(r3.makeNext(0, -1));
    } else
      r3.empty || (r3.add(n3.makeNext(-1, -1)), n3.replaceHead(r3.makeNext(0, -1)));
  } }, { key: "makeSwitchCaseBody", value: function(t3, n3) {
    var r3 = this.switchContext;
    if (r3.hasCase) {
      var i = this.forkContext, a3 = this.pushForkContext();
      a3.add(i.makeNext(0, -1)), n3 ? (r3.defaultSegments = i.head, t3 ? r3.foundDefault = true : r3.defaultBodySegments = a3.head) : !t3 && r3.foundDefault && (r3.foundDefault = false, r3.defaultBodySegments = a3.head), r3.lastIsDefault = n3, r3.countForks += 1;
    }
  } }, { key: "pushTryContext", value: function(t3) {
    this.tryContext = { upper: this.tryContext, position: "try", hasFinalizer: t3, returnedForkContext: t3 ? Xr$1.newEmpty(this.forkContext) : null, thrownForkContext: Xr$1.newEmpty(this.forkContext), lastOfTryIsReachable: false, lastOfCatchIsReachable: false };
  } }, { key: "popTryContext", value: function() {
    var t3 = this.tryContext;
    if (this.tryContext = t3.upper, t3.position !== "catch") {
      var n3 = t3.returnedForkContext, r3 = t3.thrownForkContext;
      if (!n3.empty || !r3.empty) {
        var i = this.forkContext.head;
        this.forkContext = this.forkContext.upper;
        var a3 = i.slice(0, 0 | i.length / 2), s3 = i.slice(0 | i.length / 2);
        n3.empty || Fb$1(this).returnedForkContext.add(s3), r3.empty || Wd(this).thrownForkContext.add(s3), this.forkContext.replaceHead(a3), t3.lastOfTryIsReachable || t3.lastOfCatchIsReachable || this.forkContext.makeUnreachable();
      }
    } else
      this.popForkContext();
  } }, { key: "makeCatchBlock", value: function() {
    var t3 = this.tryContext, n3 = this.forkContext, r3 = t3.thrownForkContext;
    t3.position = "catch", t3.thrownForkContext = Xr$1.newEmpty(n3), t3.lastOfTryIsReachable = n3.reachable, r3.add(n3.head);
    var i = r3.makeNext(0, -1);
    this.pushForkContext(), this.forkBypassPath(), this.forkContext.add(i);
  } }, { key: "makeFinallyBlock", value: function() {
    var t3 = this.tryContext, n3 = this.forkContext, r3 = t3.returnedForkContext, i = t3.thrownForkContext, a3 = n3.head;
    if (t3.position === "catch" ? (this.popForkContext(), n3 = this.forkContext, t3.lastOfCatchIsReachable = n3.reachable) : t3.lastOfTryIsReachable = n3.reachable, t3.position = "finally", !r3.empty || !i.empty) {
      for (var s3 = n3.makeNext(-1, -1), o3 = 0; o3 < n3.count; ++o3) {
        for (var u3 = [a3[o3]], c3 = 0; c3 < r3.segmentsList.length; ++c3)
          u3.push(r3.segmentsList[c3][o3]);
        for (var f3 = 0; f3 < i.segmentsList.length; ++f3)
          u3.push(i.segmentsList[f3][o3]);
        s3.push(qi$2.newNext(this.idGenerator.next(), u3));
      }
      this.pushForkContext(true), this.forkContext.add(s3);
    }
  } }, { key: "makeFirstThrowablePathInTryBlock", value: function() {
    var t3 = this.forkContext;
    if (t3.reachable) {
      var n3 = Wd(this);
      n3 !== this && n3.position === "try" && n3.thrownForkContext.empty && (n3.thrownForkContext.add(t3.head), t3.replaceHead(t3.makeNext(-1, -1)));
    }
  } }, { key: "pushLoopContext", value: function(t3, n3) {
    var r3 = this.forkContext, i = this.pushBreakContext(true, n3);
    switch (t3) {
      case "WhileStatement":
        this.pushChoiceContext("loop", false), this.loopContext = { upper: this.loopContext, type: t3, label: n3, test: void 0, continueDestSegments: null, brokenForkContext: i.brokenForkContext };
        break;
      case "DoWhileStatement":
        this.pushChoiceContext("loop", false), this.loopContext = { upper: this.loopContext, type: t3, label: n3, test: void 0, entrySegments: null, continueForkContext: Xr$1.newEmpty(r3), brokenForkContext: i.brokenForkContext };
        break;
      case "ForStatement":
        this.pushChoiceContext("loop", false), this.loopContext = { upper: this.loopContext, type: t3, label: n3, test: void 0, endOfInitSegments: null, testSegments: null, endOfTestSegments: null, updateSegments: null, endOfUpdateSegments: null, continueDestSegments: null, brokenForkContext: i.brokenForkContext };
        break;
      case "ForInStatement":
      case "ForOfStatement":
        this.loopContext = { upper: this.loopContext, type: t3, label: n3, prevSegments: null, leftSegments: null, endOfLeftSegments: null, continueDestSegments: null, brokenForkContext: i.brokenForkContext };
        break;
      default:
        throw new Error('unknown type: "'.concat(t3, '"'));
    }
  } }, { key: "popLoopContext", value: function() {
    var t3 = this.loopContext;
    this.loopContext = t3.upper;
    var n3 = this.forkContext, r3 = this.popBreakContext().brokenForkContext;
    switch (t3.type) {
      case "WhileStatement":
      case "ForStatement":
        this.popChoiceContext(), Do$1(this, n3.head, t3.continueDestSegments);
        break;
      case "DoWhileStatement":
        var i = this.popChoiceContext();
        i.processed || (i.trueForkContext.add(n3.head), i.falseForkContext.add(n3.head)), t3.test !== true && r3.addAll(i.falseForkContext);
        for (var a3 = i.trueForkContext.segmentsList, s3 = 0; s3 < a3.length; ++s3)
          Do$1(this, a3[s3], t3.entrySegments);
        break;
      case "ForInStatement":
      case "ForOfStatement":
        r3.add(n3.head), Do$1(this, n3.head, t3.leftSegments);
        break;
      default:
        throw new Error("unreachable");
    }
    r3.empty ? n3.replaceHead(n3.makeUnreachable(-1, -1)) : n3.replaceHead(r3.makeNext(0, -1));
  } }, { key: "makeWhileTest", value: function(t3) {
    var n3 = this.loopContext, r3 = this.forkContext, i = r3.makeNext(0, -1);
    n3.test = t3, n3.continueDestSegments = i, r3.replaceHead(i);
  } }, { key: "makeWhileBody", value: function() {
    var t3 = this.loopContext, n3 = this.choiceContext, r3 = this.forkContext;
    n3.processed || (n3.trueForkContext.add(r3.head), n3.falseForkContext.add(r3.head)), t3.test !== true && t3.brokenForkContext.addAll(n3.falseForkContext), r3.replaceHead(n3.trueForkContext.makeNext(0, -1));
  } }, { key: "makeDoWhileBody", value: function() {
    var t3 = this.loopContext, n3 = this.forkContext, r3 = n3.makeNext(-1, -1);
    t3.entrySegments = r3, n3.replaceHead(r3);
  } }, { key: "makeDoWhileTest", value: function(t3) {
    var n3 = this.loopContext, r3 = this.forkContext;
    if (n3.test = t3, !n3.continueForkContext.empty) {
      n3.continueForkContext.add(r3.head);
      var i = n3.continueForkContext.makeNext(0, -1);
      r3.replaceHead(i);
    }
  } }, { key: "makeForTest", value: function(t3) {
    var n3 = this.loopContext, r3 = this.forkContext, i = r3.head, a3 = r3.makeNext(-1, -1);
    n3.test = t3, n3.endOfInitSegments = i, n3.continueDestSegments = n3.testSegments = a3, r3.replaceHead(a3);
  } }, { key: "makeForUpdate", value: function() {
    var t3 = this.loopContext, n3 = this.choiceContext, r3 = this.forkContext;
    t3.testSegments ? wb$1(t3, n3, r3.head) : t3.endOfInitSegments = r3.head;
    var i = r3.makeDisconnected(-1, -1);
    t3.continueDestSegments = t3.updateSegments = i, r3.replaceHead(i);
  } }, { key: "makeForBody", value: function() {
    var t3 = this.loopContext, n3 = this.choiceContext, r3 = this.forkContext;
    t3.updateSegments ? (t3.endOfUpdateSegments = r3.head, t3.testSegments && Do$1(this, t3.endOfUpdateSegments, t3.testSegments)) : t3.testSegments ? wb$1(t3, n3, r3.head) : t3.endOfInitSegments = r3.head;
    var i = t3.endOfTestSegments;
    if (!i) {
      var a3 = Xr$1.newEmpty(r3);
      a3.add(t3.endOfInitSegments), t3.endOfUpdateSegments && a3.add(t3.endOfUpdateSegments), i = a3.makeNext(0, -1);
    }
    t3.continueDestSegments = t3.continueDestSegments || i, r3.replaceHead(i);
  } }, { key: "makeForInOfLeft", value: function() {
    var t3 = this.loopContext, n3 = this.forkContext, r3 = n3.makeDisconnected(-1, -1);
    t3.prevSegments = n3.head, t3.leftSegments = t3.continueDestSegments = r3, n3.replaceHead(r3);
  } }, { key: "makeForInOfRight", value: function() {
    var t3 = this.loopContext, n3 = this.forkContext, r3 = Xr$1.newEmpty(n3);
    r3.add(t3.prevSegments);
    var i = r3.makeNext(-1, -1);
    t3.endOfLeftSegments = n3.head, n3.replaceHead(i);
  } }, { key: "makeForInOfBody", value: function() {
    var t3 = this.loopContext, n3 = this.forkContext, r3 = Xr$1.newEmpty(n3);
    r3.add(t3.endOfLeftSegments);
    var i = r3.makeNext(-1, -1);
    Do$1(this, n3.head, t3.leftSegments), t3.brokenForkContext.add(n3.head), n3.replaceHead(i);
  } }, { key: "pushBreakContext", value: function(t3, n3) {
    return this.breakContext = { upper: this.breakContext, breakable: t3, label: n3, brokenForkContext: Xr$1.newEmpty(this.forkContext) }, this.breakContext;
  } }, { key: "popBreakContext", value: function() {
    var t3 = this.breakContext, n3 = this.forkContext;
    if (this.breakContext = t3.upper, !t3.breakable) {
      var r3 = t3.brokenForkContext;
      r3.empty || (r3.add(n3.head), n3.replaceHead(r3.makeNext(0, -1)));
    }
    return t3;
  } }, { key: "makeBreak", value: function(t3) {
    var n3 = this.forkContext;
    if (n3.reachable) {
      var r3 = function(i, a3) {
        for (var s3 = i.breakContext; s3; ) {
          if (a3 ? s3.label === a3 : s3.breakable)
            return s3;
          s3 = s3.upper;
        }
        return null;
      }(this, t3);
      r3 && r3.brokenForkContext.add(n3.head), n3.replaceHead(n3.makeUnreachable(-1, -1));
    }
  } }, { key: "makeContinue", value: function(t3) {
    var n3 = this.forkContext;
    if (n3.reachable) {
      var r3 = function(i, a3) {
        if (!a3)
          return i.loopContext;
        for (var s3 = i.loopContext; s3; ) {
          if (s3.label === a3)
            return s3;
          s3 = s3.upper;
        }
        return null;
      }(this, t3);
      r3 && (r3.continueDestSegments ? (Do$1(this, n3.head, r3.continueDestSegments), (r3.type === "ForInStatement" || r3.type === "ForOfStatement") && r3.brokenForkContext.add(n3.head)) : r3.continueForkContext.add(n3.head)), n3.replaceHead(n3.makeUnreachable(-1, -1));
    }
  } }, { key: "makeReturn", value: function() {
    var t3 = this.forkContext;
    t3.reachable && (Fb$1(this).returnedForkContext.add(t3.head), t3.replaceHead(t3.makeUnreachable(-1, -1)));
  } }, { key: "makeThrow", value: function() {
    var t3 = this.forkContext;
    t3.reachable && (Wd(this).thrownForkContext.add(t3.head), t3.replaceHead(t3.makeUnreachable(-1, -1)));
  } }, { key: "makeFinal", value: function() {
    var t3 = this.currentSegments;
    0 < t3.length && t3[0].reachable && this.returnedForkContext.add(t3);
  } }, { key: "headSegments", get: function() {
    return this.forkContext.head;
  } }, { key: "parentForkContext", get: function() {
    var t3 = this.forkContext;
    return t3 && t3.upper;
  } }]), e28;
}(), nA = function() {
  function e28(t3) {
    We$1(this, e28), this.prefix = t3 + "", this.n = 0;
  }
  return Xe$1(e28, [{ key: "next", value: function() {
    return this.n = 0 | 1 + this.n, 0 > this.n && (this.n = 1), this.prefix + this.n;
  } }]), e28;
}(), Fa$2 = function() {
  function e28(t3, n3, r3) {
    We$1(this, e28), this.id = t3, this.upper = n3, this.childCodePaths = [], Object.defineProperty(this, "internal", { value: new mP(new nA("".concat(t3, "_")), r3) }), n3 && n3.childCodePaths.push(this);
  }
  return Xe$1(e28, [{ key: "traverseSegments", value: function(t3, n3) {
    function r3(x3) {
      return d3[x3.id] || p3.isLoopedPrevSegment(x3);
    }
    var i, a3;
    typeof t3 == "function" ? (a3 = t3, i = {}) : (i = t3 || {}, a3 = n3);
    for (var s3 = i.first || this.internal.initialSegment, o3 = i.last, u3 = null, c3 = 0, f3 = 0, p3 = null, d3 = /* @__PURE__ */ Object.create(null), m3 = [[s3, 0]], y3 = null, v3 = false, b3 = { skip: function() {
      1 >= m3.length ? v3 = true : y3 = m3[m3.length - 2][0];
    }, break: function() {
      v3 = true;
    } }; 0 < m3.length; ) {
      if (u3 = m3[m3.length - 1], p3 = u3[0], (c3 = u3[1]) === 0) {
        if (d3[p3.id]) {
          m3.pop();
          continue;
        }
        if (p3 !== s3 && 0 < p3.prevSegments.length && !p3.prevSegments.every(r3)) {
          m3.pop();
          continue;
        }
        if (y3 && p3.prevSegments.indexOf(y3) !== -1 && (y3 = null), d3[p3.id] = true, !y3 && (a3.call(this, p3, b3), p3 === o3 && b3.skip(), v3))
          break;
      }
      c3 < (f3 = p3.nextSegments.length - 1) ? (u3[1] += 1, m3.push([p3.nextSegments[c3], 0])) : c3 === f3 ? (u3[0] = p3.nextSegments[c3], u3[1] = 0) : m3.pop();
    }
  } }, { key: "initialSegment", get: function() {
    return this.internal.initialSegment;
  } }, { key: "finalSegments", get: function() {
    return this.internal.finalSegments;
  } }, { key: "returnedSegments", get: function() {
    return this.internal.returnedForkContext;
  } }, { key: "thrownSegments", get: function() {
    return this.internal.thrownForkContext;
  } }, { key: "currentSegments", get: function() {
    return this.internal.currentSegments;
  } }], [{ key: "getState", value: function(t3) {
    return t3.internal;
  } }]), e28;
}(), rA = ye$4.require$$0$1.breakableTypePattern;
function gP(e28) {
  return !!e28.test;
}
function Gp(e28) {
  return e28 === "&&" || e28 === "||";
}
function Ab$1(e28) {
  return e28.parent.type === "LabeledStatement" ? e28.parent.label.name : null;
}
function $d(e28) {
  return e28.type === "Literal" ? !!e28.value : void 0;
}
function Po$1(e28, t3) {
  var n3, r3, i, a3 = e28.codePath, s3 = Fa$2.getState(a3), o3 = s3.currentSegments, u3 = s3.headSegments, c3 = Math.max(o3.length, u3.length);
  for (n3 = 0; n3 < c3; ++n3)
    (r3 = o3[n3]) !== (i = u3[n3]) && r3 && (ii$1.dump("onCodePathSegmentEnd ".concat(r3.id)), r3.reachable && e28.emitter.emit("onCodePathSegmentEnd", r3, t3));
  for (s3.currentSegments = u3, n3 = 0; n3 < c3; ++n3)
    (r3 = o3[n3]) !== (i = u3[n3]) && i && (ii$1.dump("onCodePathSegmentStart ".concat(i.id)), qi$2.markUsed(i), i.reachable && e28.emitter.emit("onCodePathSegmentStart", i, t3));
}
function yP(e28, t3) {
  var n3 = e28.codePath, r3 = n3 && Fa$2.getState(n3), i = t3.parent;
  switch (t3.type) {
    case "Program":
    case "FunctionDeclaration":
    case "FunctionExpression":
    case "ArrowFunctionExpression":
      n3 && (Po$1(e28, t3), ii$1.dumpState(t3, r3, false)), n3 = e28.codePath = new Fa$2(e28.idGenerator.next(), n3, e28.onLooped), r3 = Fa$2.getState(n3), ii$1.dump("onCodePathStart ".concat(n3.id)), e28.emitter.emit("onCodePathStart", n3, t3);
      break;
    case "LogicalExpression":
      Gp(t3.operator) && r3.pushChoiceContext(t3.operator, function(a3) {
        var s3 = a3.parent;
        switch (s3.type) {
          case "ConditionalExpression":
          case "IfStatement":
          case "WhileStatement":
          case "DoWhileStatement":
          case "ForStatement":
            return s3.test === a3;
          case "LogicalExpression":
            return Gp(s3.operator);
          default:
            return false;
        }
      }(t3));
      break;
    case "ConditionalExpression":
    case "IfStatement":
      r3.pushChoiceContext("test", false);
      break;
    case "SwitchStatement":
      r3.pushSwitchContext(t3.cases.some(gP), Ab$1(t3));
      break;
    case "TryStatement":
      r3.pushTryContext(!!t3.finalizer);
      break;
    case "SwitchCase":
      i.discriminant !== t3 && i.cases[0] !== t3 && r3.forkPath();
      break;
    case "WhileStatement":
    case "DoWhileStatement":
    case "ForStatement":
    case "ForInStatement":
    case "ForOfStatement":
      r3.pushLoopContext(t3.type, Ab$1(t3));
      break;
    case "LabeledStatement":
      rA.test(t3.body.type) || r3.pushBreakContext(false, t3.label.name);
  }
  Po$1(e28, t3), ii$1.dumpState(t3, r3, false);
}
function vP(e28, t3) {
  switch (t3.type) {
    case "Program":
    case "FunctionDeclaration":
    case "FunctionExpression":
    case "ArrowFunctionExpression":
      var n3 = e28.codePath;
      Fa$2.getState(n3).makeFinal(), function(r3, i) {
        for (var a3 = Fa$2.getState(r3.codePath), s3 = a3.currentSegments, o3 = 0; o3 < s3.length; ++o3) {
          var u3 = s3[o3];
          ii$1.dump("onCodePathSegmentEnd ".concat(u3.id)), u3.reachable && r3.emitter.emit("onCodePathSegmentEnd", u3, i);
        }
        a3.currentSegments = [];
      }(e28, t3), ii$1.dump("onCodePathEnd ".concat(n3.id)), e28.emitter.emit("onCodePathEnd", n3, t3), ii$1.dumpDot(n3), (n3 = e28.codePath = e28.codePath.upper) && ii$1.dumpState(t3, Fa$2.getState(n3), true);
  }
}
var xP = function() {
  function e28(t3) {
    We$1(this, e28), this.original = t3, this.emitter = t3.emitter, this.codePath = null, this.idGenerator = new nA("s"), this.currentNode = null, this.onLooped = this.onLooped.bind(this);
  }
  return Xe$1(e28, [{ key: "enterNode", value: function(t3) {
    this.currentNode = t3, t3.parent && function(n3, r3) {
      var i = n3.codePath, a3 = Fa$2.getState(i), s3 = r3.parent;
      switch (s3.type) {
        case "LogicalExpression":
          s3.right === r3 && Gp(s3.operator) && a3.makeLogicalRight();
          break;
        case "ConditionalExpression":
        case "IfStatement":
          s3.consequent === r3 ? a3.makeIfConsequent() : s3.alternate === r3 && a3.makeIfAlternate();
          break;
        case "SwitchCase":
          s3.consequent[0] === r3 && a3.makeSwitchCaseBody(false, !s3.test);
          break;
        case "TryStatement":
          s3.handler === r3 ? a3.makeCatchBlock() : s3.finalizer === r3 && a3.makeFinallyBlock();
          break;
        case "WhileStatement":
          s3.test === r3 ? a3.makeWhileTest($d(r3)) : (Rr$1(s3.body === r3), a3.makeWhileBody());
          break;
        case "DoWhileStatement":
          s3.body === r3 ? a3.makeDoWhileBody() : (Rr$1(s3.test === r3), a3.makeDoWhileTest($d(r3)));
          break;
        case "ForStatement":
          s3.test === r3 ? a3.makeForTest($d(r3)) : s3.update === r3 ? a3.makeForUpdate() : s3.body === r3 && a3.makeForBody();
          break;
        case "ForInStatement":
        case "ForOfStatement":
          s3.left === r3 ? a3.makeForInOfLeft() : s3.right === r3 ? a3.makeForInOfRight() : (Rr$1(s3.body === r3), a3.makeForInOfBody());
          break;
        case "AssignmentPattern":
          s3.right === r3 && (a3.pushForkContext(), a3.forkBypassPath(), a3.forkPath());
      }
    }(this, t3), yP(this, t3), this.original.enterNode(t3), this.currentNode = null;
  } }, { key: "leaveNode", value: function(t3) {
    this.currentNode = t3, function(n3, r3) {
      var i = n3.codePath, a3 = Fa$2.getState(i), s3 = false;
      switch (r3.type) {
        case "IfStatement":
        case "ConditionalExpression":
          a3.popChoiceContext();
          break;
        case "LogicalExpression":
          Gp(r3.operator) && a3.popChoiceContext();
          break;
        case "SwitchStatement":
          a3.popSwitchContext();
          break;
        case "SwitchCase":
          r3.consequent.length === 0 && a3.makeSwitchCaseBody(true, !r3.test), a3.forkContext.reachable && (s3 = true);
          break;
        case "TryStatement":
          a3.popTryContext();
          break;
        case "BreakStatement":
          Po$1(n3, r3), a3.makeBreak(r3.label && r3.label.name), s3 = true;
          break;
        case "ContinueStatement":
          Po$1(n3, r3), a3.makeContinue(r3.label && r3.label.name), s3 = true;
          break;
        case "ReturnStatement":
          Po$1(n3, r3), a3.makeReturn(), s3 = true;
          break;
        case "ThrowStatement":
          Po$1(n3, r3), a3.makeThrow(), s3 = true;
          break;
        case "Identifier":
          (function(o3) {
            var u3 = o3.parent;
            switch (u3.type) {
              case "LabeledStatement":
              case "BreakStatement":
              case "ContinueStatement":
              case "ArrayPattern":
              case "RestElement":
              case "ImportSpecifier":
              case "ImportDefaultSpecifier":
              case "ImportNamespaceSpecifier":
              case "CatchClause":
                return false;
              case "FunctionDeclaration":
              case "FunctionExpression":
              case "ArrowFunctionExpression":
              case "ClassDeclaration":
              case "ClassExpression":
              case "VariableDeclarator":
                return u3.id !== o3;
              case "Property":
              case "MethodDefinition":
                return u3.key !== o3 || u3.computed || u3.shorthand;
              case "AssignmentPattern":
                return u3.key !== o3;
              default:
                return true;
            }
          })(r3) && (a3.makeFirstThrowablePathInTryBlock(), s3 = true);
          break;
        case "CallExpression":
        case "ImportExpression":
        case "MemberExpression":
        case "NewExpression":
          a3.makeFirstThrowablePathInTryBlock();
          break;
        case "WhileStatement":
        case "DoWhileStatement":
        case "ForStatement":
        case "ForInStatement":
        case "ForOfStatement":
          a3.popLoopContext();
          break;
        case "AssignmentPattern":
          a3.popForkContext();
          break;
        case "LabeledStatement":
          rA.test(r3.body.type) || a3.popBreakContext();
      }
      s3 || Po$1(n3, r3), ii$1.dumpState(r3, a3, true);
    }(this, t3), this.original.leaveNode(t3), vP(this, t3), this.currentNode = null;
  } }, { key: "onLooped", value: function(t3, n3) {
    t3.reachable && n3.reachable && (ii$1.dump("onCodePathSegmentLoop ".concat(t3.id, " -> ").concat(n3.id)), this.emitter.emit("onCodePathSegmentLoop", t3, n3, this.currentNode));
  } }]), e28;
}();
function fp(e28, t3) {
  return e28.line - t3.line || e28.column - t3.column;
}
function _b(e28) {
  var t3 = [], n3 = 0, r3 = null, i = /* @__PURE__ */ new Map(), a3 = /* @__PURE__ */ new Set(), s3 = /* @__PURE__ */ new Set(), o3 = true, u3 = false, c3 = void 0;
  try {
    for (var f3, p3 = e28.problems[Symbol.iterator](); !(o3 = (f3 = p3.next()).done); o3 = true) {
      for (var d3 = f3.value; n3 < e28.directives.length && 0 >= fp(e28.directives[n3], d3); ) {
        var m3 = e28.directives[n3++];
        switch (m3.type) {
          case "disable":
            m3.ruleId === null ? (r3 = m3, i.clear(), a3.clear()) : (r3 && a3.delete(m3.ruleId), i.set(m3.ruleId, m3));
            break;
          case "enable":
            m3.ruleId === null ? (r3 = null, i.clear()) : (r3 && a3.add(m3.ruleId), i.delete(m3.ruleId));
        }
      }
      i.has(d3.ruleId) ? s3.add(i.get(d3.ruleId)) : r3 && !a3.has(d3.ruleId) ? s3.add(r3) : t3.push(d3);
    }
  } catch (y3) {
    u3 = true, c3 = y3;
  } finally {
    try {
      o3 || p3.return == null || p3.return();
    } finally {
      if (u3)
        throw c3;
    }
  }
  return { problems: t3, unusedDisableDirectives: e28.directives.filter(function(y3) {
    return y3.type === "disable" && !s3.has(y3);
  }).map(function(y3) {
    return { ruleId: null, message: y3.ruleId ? "Unused eslint-disable directive (no problems were reported from '".concat(y3.ruleId, "').") : "Unused eslint-disable directive (no problems were reported).", line: y3.unprocessedDirective.line, column: y3.unprocessedDirective.column, severity: e28.reportUnusedDisableDirectives === "warn" ? 1 : 2, nodeType: null };
  }) };
}
var _u$1 = ye$4.require$$1("eslint:config-comment-parser"), bP = function() {
  function e28() {
    We$1(this, e28);
  }
  return Xe$1(e28, [{ key: "parseStringConfig", value: function(t3, n3) {
    _u$1("Parsing String config");
    var r3 = {};
    return t3.replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*([,:])[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*/g, "$1").split(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]|,+/).forEach(function(i) {
      if (i) {
        var a3 = bn$1(i.split(":"), 2), s3 = a3[0], o3 = a3[1], u3 = o3 === void 0 ? null : o3;
        r3[s3] = { value: u3, comment: n3 };
      }
    }), r3;
  } }, { key: "parseJsonConfig", value: function(t3, n3) {
    _u$1("Parsing JSON config");
    var r3 = {};
    try {
      if (r3 = KT.parse("Object", t3) || {}, bi$1.isEverySeverityValid(r3))
        return { success: true, config: r3 };
    } catch {
      _u$1("Levn parsing failed; falling back to manual parsing.");
    }
    r3 = {};
    var i = t3.replace(/([\x2D\/-9A-Za-z]+):/g, '"$1":').replace(/(\]|[0-9])[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+(?=")/, "$1,");
    try {
      r3 = JSON.parse("{".concat(i, "}"));
    } catch (a3) {
      return _u$1("Manual parsing failed."), { success: false, error: { ruleId: null, fatal: true, severity: 2, message: "Failed to parse JSON from '".concat(i, "': ").concat(a3.message), line: n3.start.line, column: n3.start.column + 1 } };
    }
    return { success: true, config: r3 };
  } }, { key: "parseListConfig", value: function(t3) {
    _u$1("Parsing list config");
    var n3 = {};
    return t3.replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*,[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*/g, ",").split(/,+/).forEach(function(r3) {
      var i = r3.trim();
      i && (n3[i] = true);
    }), n3;
  } }]), e28;
}();
function hp(e28) {
  switch (e28.type) {
    case "identifier":
      return [e28.value];
    case "matches":
      var t3, n3 = e28.selectors.map(hp);
      return n3.every(Boolean) ? (t3 = ye$4.lodash).union.apply(t3, Mt$2(n3)) : null;
    case "compound":
      var r3, i = e28.selectors.map(hp).filter(function(a3) {
        return a3;
      });
      return i.length ? (r3 = ye$4.lodash).intersection.apply(r3, Mt$2(i)) : null;
    case "child":
    case "descendant":
    case "sibling":
    case "adjacent":
      return hp(e28.right);
    default:
      return null;
  }
}
function dp(e28) {
  switch (e28.type) {
    case "child":
    case "descendant":
    case "sibling":
    case "adjacent":
      return dp(e28.left) + dp(e28.right);
    case "compound":
    case "not":
    case "matches":
      return e28.selectors.reduce(function(t3, n3) {
        return t3 + dp(n3);
      }, 0);
    case "attribute":
    case "field":
    case "nth-child":
    case "nth-last-child":
      return 1;
    default:
      return 0;
  }
}
function mp(e28) {
  switch (e28.type) {
    case "child":
    case "descendant":
    case "sibling":
    case "adjacent":
      return mp(e28.left) + mp(e28.right);
    case "compound":
    case "not":
    case "matches":
      return e28.selectors.reduce(function(t3, n3) {
        return t3 + mp(n3);
      }, 0);
    case "identifier":
      return 1;
    default:
      return 0;
  }
}
function Tu$1(e28, t3) {
  return e28.attributeCount - t3.attributeCount || e28.identifierCount - t3.identifierCount || (e28.rawSelector <= t3.rawSelector ? -1 : 1);
}
var EP = ye$4.lodash.memoize(function(e28) {
  var t3 = function(n3) {
    try {
      return Aw.parse(n3.replace(/:exit$/, ""));
    } catch (r3) {
      throw typeof r3.offset == "number" ? new SyntaxError('Syntax error in selector "'.concat(n3, '" at position ').concat(r3.offset, ": ").concat(r3.message)) : r3;
    }
  }(e28);
  return { rawSelector: e28, isExit: e28.endsWith(":exit"), parsedSelector: t3, listenerTypes: hp(t3), attributeCount: dp(t3), identifierCount: mp(t3) };
}), CP = function() {
  function e28(t3) {
    var n3 = this;
    We$1(this, e28), this.emitter = t3, this.currentAncestry = [], this.enterSelectorsByNodeType = /* @__PURE__ */ new Map(), this.exitSelectorsByNodeType = /* @__PURE__ */ new Map(), this.anyTypeEnterSelectors = [], this.anyTypeExitSelectors = [], t3.eventNames().forEach(function(r3) {
      var i = EP(r3);
      if (i.listenerTypes) {
        var a3 = i.isExit ? n3.exitSelectorsByNodeType : n3.enterSelectorsByNodeType;
        i.listenerTypes.forEach(function(s3) {
          a3.has(s3) || a3.set(s3, []), a3.get(s3).push(i);
        });
      } else
        (i.isExit ? n3.anyTypeExitSelectors : n3.anyTypeEnterSelectors).push(i);
    }), this.anyTypeEnterSelectors.sort(Tu$1), this.anyTypeExitSelectors.sort(Tu$1), this.enterSelectorsByNodeType.forEach(function(r3) {
      return r3.sort(Tu$1);
    }), this.exitSelectorsByNodeType.forEach(function(r3) {
      return r3.sort(Tu$1);
    });
  }
  return Xe$1(e28, [{ key: "applySelector", value: function(t3, n3) {
    Aw.matches(t3, n3.parsedSelector, this.currentAncestry) && this.emitter.emit(n3.rawSelector, t3);
  } }, { key: "applySelectors", value: function(t3, n3) {
    for (var r3 = (n3 ? this.exitSelectorsByNodeType : this.enterSelectorsByNodeType).get(t3.type) || [], i = n3 ? this.anyTypeExitSelectors : this.anyTypeEnterSelectors, a3 = 0, s3 = 0; a3 < r3.length || s3 < i.length; )
      a3 >= r3.length || s3 < i.length && 0 > Tu$1(i[s3], r3[a3]) ? this.applySelector(t3, i[s3++]) : this.applySelector(t3, r3[a3++]);
  } }, { key: "enterNode", value: function(t3) {
    t3.parent && this.currentAncestry.unshift(t3.parent), this.applySelectors(t3, false);
  } }, { key: "leaveNode", value: function(t3) {
    this.applySelectors(t3, true), this.currentAncestry.shift();
  } }]), e28;
}();
function Tb$1(e28, t3) {
  return { range: [e28, e28], text: t3 };
}
var SP = Object.freeze({ insertTextAfter: function(e28, t3) {
  return this.insertTextAfterRange(e28.range, t3);
}, insertTextAfterRange: function(e28, t3) {
  return Tb$1(e28[1], t3);
}, insertTextBefore: function(e28, t3) {
  return this.insertTextBeforeRange(e28.range, t3);
}, insertTextBeforeRange: function(e28, t3) {
  return Tb$1(e28[0], t3);
}, replaceText: function(e28, t3) {
  return this.replaceTextRange(e28.range, t3);
}, replaceTextRange: function(e28, t3) {
  return { range: e28, text: t3 };
}, remove: function(e28) {
  return this.removeRange(e28.range);
}, removeRange: function(e28) {
  return { range: e28, text: "" };
} }), sg = function(e28, t3) {
  return t3 ? e28.replace(/\{\{((?:[\0-z\|~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?)\}\}/g, function(n3, r3) {
    var i = r3.trim();
    return i in t3 ? t3[i] : n3;
  }) : e28;
};
function kP() {
  return arguments.length === 1 ? Object.assign({}, arguments.length <= 0 ? void 0 : arguments[0]) : typeof (arguments.length <= 1 ? void 0 : arguments[1]) == "string" ? { node: arguments.length <= 0 ? void 0 : arguments[0], message: arguments.length <= 1 ? void 0 : arguments[1], data: arguments.length <= 2 ? void 0 : arguments[2], fix: arguments.length <= 3 ? void 0 : arguments[3] } : { node: arguments.length <= 0 ? void 0 : arguments[0], loc: arguments.length <= 1 ? void 0 : arguments[1], message: arguments.length <= 2 ? void 0 : arguments[2], data: arguments.length <= 3 ? void 0 : arguments[3], fix: arguments.length <= 4 ? void 0 : arguments[4] };
}
function DP(e28) {
  e28.node ? Rr$1(xe$3(e28.node) == "object", "Node must be an object") : Rr$1(e28.loc, "Node must be provided when reporting error if location is not provided");
}
function FP(e28) {
  return e28.loc ? e28.loc.start ? e28.loc : { start: e28.loc, end: null } : e28.node.loc;
}
function wP(e28, t3) {
  return e28.range[0] - t3.range[0] || e28.range[1] - t3.range[1];
}
function iA(e28, t3) {
  if (typeof e28.fix != "function")
    return null;
  var n3 = e28.fix(SP);
  return n3 && Symbol.iterator in n3 ? function(r3, i) {
    var a3 = Math.max;
    if (r3.length === 0)
      return null;
    if (r3.length === 1)
      return r3[0];
    r3.sort(wP);
    var s3 = i.text, o3 = r3[0].range[0], u3 = r3[r3.length - 1].range[1], c3 = "", f3 = Number.MIN_SAFE_INTEGER, p3 = true, d3 = false, m3 = void 0;
    try {
      for (var y3, v3 = r3[Symbol.iterator](); !(p3 = (y3 = v3.next()).done); p3 = true) {
        var b3 = y3.value;
        Rr$1(b3.range[0] >= f3, "Fix objects must not be overlapped in a report."), 0 <= b3.range[0] && (c3 += s3.slice(a3(0, o3, f3), b3.range[0])), c3 += b3.text, f3 = b3.range[1];
      }
    } catch (x3) {
      d3 = true, m3 = x3;
    } finally {
      try {
        p3 || v3.return == null || v3.return();
      } finally {
        if (d3)
          throw m3;
      }
    }
    return { range: [o3, u3], text: c3 += s3.slice(a3(0, o3, f3), u3) };
  }(Array.from(n3), t3) : n3;
}
function AP(e28, t3, n3) {
  return e28.suggest && Array.isArray(e28.suggest) ? e28.suggest.map(function(r3) {
    var i = r3.desc || n3[r3.messageId];
    return Sa$2({}, r3, { desc: sg(i, r3.data), fix: iA(r3, t3) });
  }) : [];
}
function _P(e28) {
  var t3 = { ruleId: e28.ruleId, severity: e28.severity, message: e28.message, line: e28.loc.start.line, column: e28.loc.start.column + 1, nodeType: e28.node && e28.node.type || null };
  return e28.messageId && (t3.messageId = e28.messageId), e28.loc.end && (t3.endLine = e28.loc.end.line, t3.endColumn = e28.loc.end.column + 1), e28.fix && (t3.fix = e28.fix), e28.suggestions && 0 < e28.suggestions.length && (t3.suggestions = e28.suggestions), t3;
}
function TP(e28, t3) {
  e28 && Array.isArray(e28) && e28.forEach(function(n3) {
    if (n3.messageId) {
      var r3 = n3.messageId;
      if (!t3)
        throw new TypeError("context.report() called with a suggest option with a messageId '".concat(r3, "', but no messages were present in the rule metadata."));
      if (!t3[r3])
        throw new TypeError("context.report() called with a suggest option with a messageId '".concat(r3, "' which is not present in the 'messages' config: ").concat(JSON.stringify(t3, null, 2)));
      if (n3.desc)
        throw new TypeError("context.report() called with a suggest option that defines both a 'messageId' and an 'desc'. Please only pass one.");
    } else if (!n3.desc)
      throw new TypeError("context.report() called with a suggest option that doesn't have either a `desc` or `messageId`");
    if (typeof n3.fix != "function")
      throw new TypeError("context.report() called with a suggest option without a fix function. See: ".concat(n3));
  });
}
var PP = function(e28) {
  return function() {
    var t3, n3 = kP.apply(void 0, arguments), r3 = e28.messageIds;
    if (DP(n3), n3.messageId) {
      if (!r3)
        throw new TypeError("context.report() called with a messageId, but no messages were present in the rule metadata.");
      var i = n3.messageId;
      if (n3.message)
        throw new TypeError("context.report() called with a message and a messageId. Please only pass one.");
      if (!r3 || !Object.prototype.hasOwnProperty.call(r3, i))
        throw new TypeError("context.report() called with a messageId of '".concat(i, "' which is not present in the 'messages' config: ").concat(JSON.stringify(r3, null, 2)));
      t3 = r3[i];
    } else {
      if (!n3.message)
        throw new TypeError("Missing `message` property in report() call; add a message that describes the linting problem.");
      t3 = n3.message;
    }
    return TP(n3.suggest, r3), _P({ ruleId: e28.ruleId, severity: e28.severity, node: n3.node, message: sg(t3, n3.data), messageId: n3.messageId, loc: FP(n3), fix: e28.disableFixes ? null : iA(n3, e28.sourceCode), suggestions: e28.disableFixes ? [] : AP(n3, e28.sourceCode, r3) });
  };
}, IP = function() {
  function e28() {
    We$1(this, e28), this._rules = /* @__PURE__ */ Object.create(null);
  }
  return Xe$1(e28, [{ key: "define", value: function(t3, n3) {
    this._rules[t3] = function(r3) {
      return typeof r3 == "function" ? Object.assign({ create: r3 }, r3) : r3;
    }(n3);
  } }, { key: "get", value: function(t3) {
    return typeof this._rules[t3] == "string" && this.define(t3, null), this._rules[t3] ? this._rules[t3] : pp.has(t3) ? pp.get(t3) : null;
  } }, { key: Symbol.iterator, value: regeneratorRuntime.mark(function t3() {
    var n3, r3, i;
    return regeneratorRuntime.wrap(function(a3) {
      for (; ; )
        switch (a3.prev = a3.next) {
          case 0:
            return a3.delegateYield(pp, "t0", 1);
          case 1:
            n3 = 0, r3 = Object.keys(this._rules);
          case 2:
            if (!(n3 < r3.length)) {
              a3.next = 9;
              break;
            }
            return i = r3[n3], a3.next = 6, [i, this.get(i)];
          case 6:
            n3++, a3.next = 2;
            break;
          case 9:
          case "end":
            return a3.stop();
        }
    }, t3, this);
  }) }]), e28;
}(), BP = function() {
  var e28 = /* @__PURE__ */ Object.create(null);
  return Object.freeze({ on: function(t3, n3) {
    t3 in e28 ? e28[t3].push(n3) : e28[t3] = [n3];
  }, emit: function(t3) {
    for (var n3 = arguments.length, r3 = new Array(n3 > 1 ? n3 - 1 : 0), i = 1; i < n3; i++)
      r3[i - 1] = arguments[i];
    t3 in e28 && e28[t3].forEach(function(a3) {
      return a3.apply(void 0, r3);
    });
  }, eventNames: function() {
    return Object.keys(e28);
  } });
}, zl = ye$4.require$$1("eslint:source-code-fixer"), Gd$1 = "\uFEFF";
function OP(e28, t3) {
  return e28.fix.range[0] - t3.fix.range[0] || e28.fix.range[1] - t3.fix.range[1];
}
function LP(e28, t3) {
  return e28.line - t3.line || e28.column - t3.column;
}
function aA() {
  Object.freeze(this);
}
aA.applyFixes = function(e28, t3, n3) {
  function r3(C3) {
    var k3 = C3.fix, F3 = k3.range[0], B3 = k3.range[1];
    return c3 >= F3 || F3 > B3 ? (a3.push(C3), false) : ((0 > F3 && 0 <= B3 || F3 === 0 && k3.text.startsWith(Gd$1)) && (f3 = ""), f3 += u3.slice(i(0, c3), i(0, F3)), f3 += k3.text, c3 = B3, true);
  }
  var i = Math.max;
  if (zl("Applying fixes"), n3 === false)
    return zl("shouldFix parameter was false, not attempting fixes"), { fixed: false, messages: t3, output: e28 };
  var a3 = [], s3 = [], o3 = e28.startsWith(Gd$1) ? Gd$1 : "", u3 = o3 ? e28.slice(1) : e28, c3 = Number.NEGATIVE_INFINITY, f3 = o3;
  if (t3.forEach(function(C3) {
    Object.prototype.hasOwnProperty.call(C3, "fix") ? s3.push(C3) : a3.push(C3);
  }), s3.length) {
    zl("Found fixes to apply");
    var p3 = false, d3 = true, m3 = false, y3 = void 0;
    try {
      for (var v3, b3 = s3.sort(OP)[Symbol.iterator](); !(d3 = (v3 = b3.next()).done); d3 = true) {
        var x3 = v3.value;
        typeof n3 != "function" || n3(x3) ? (r3(x3), p3 = true) : a3.push(x3);
      }
    } catch (C3) {
      m3 = true, y3 = C3;
    } finally {
      try {
        d3 || b3.return == null || b3.return();
      } finally {
        if (m3)
          throw y3;
      }
    }
    return f3 += u3.slice(i(0, c3)), { fixed: p3, messages: a3.sort(LP), output: f3 };
  }
  return zl("No fixes to apply"), { fixed: false, messages: t3, output: o3 + u3 };
};
var Pb$1 = aA, oA = { "generator-star": ["generator-star-spacing"], "global-strict": ["strict"], "no-arrow-condition": ["no-confusing-arrow", "no-constant-condition"], "no-comma-dangle": ["comma-dangle"], "no-empty-class": ["no-empty-character-class"], "no-empty-label": ["no-labels"], "no-extra-strict": ["strict"], "no-reserved-keys": ["quote-props"], "no-space-before-semi": ["semi-spacing"], "no-wrap-func": ["no-extra-parens"], "space-after-function-name": ["space-before-function-paren"], "space-after-keywords": ["keyword-spacing"], "space-before-function-parentheses": ["space-before-function-paren"], "space-before-keywords": ["keyword-spacing"], "space-in-brackets": ["object-curly-spacing", "array-bracket-spacing", "computed-property-spacing"], "space-return-throw-case": ["keyword-spacing"], "space-unary-word-ops": ["space-unary-ops"], "spaced-line-comment": ["spaced-comment"] }, NP = { rules: oA }, jP = Object.freeze({ __proto__: null, rules: oA, default: NP }), Ib$1 = ye$4.getCjsExportFromNamespace(QT), Bb$1 = ye$4.getCjsExportFromNamespace(jP), Ob$1 = fP.SourceCode, sr$2 = ye$4.require$$1("eslint:linter"), Gu$1 = new bP(), RP = { start: { line: 1, column: 0 }, end: { line: 1, column: 1 } };
function Fo$1(e28) {
  var t3 = e28.ruleId, n3 = t3 === void 0 ? null : t3, r3 = e28.loc, i = r3 === void 0 ? RP : r3, a3 = e28.message, s3 = a3 === void 0 ? function(c3) {
    return Object.prototype.hasOwnProperty.call(Bb$1.rules, c3) ? "Rule '".concat(c3, "' was removed and replaced by: ").concat(Bb$1.rules[c3].join(", ")) : "Definition for rule '".concat(c3, "' was not found.");
  }(e28.ruleId) : a3, o3 = e28.severity, u3 = o3 === void 0 ? 2 : o3;
  return { ruleId: n3, message: s3, line: i.start.line, column: i.start.column + 1, endLine: i.end.line, endColumn: i.end.column + 1, severity: u3, nodeType: null };
}
function MP(e28, t3, n3, r3) {
  var i = {}, a3 = /* @__PURE__ */ Object.create(null), s3 = {}, o3 = [], u3 = [];
  return t3.comments.filter(function(c3) {
    return c3.type !== "Shebang";
  }).forEach(function(c3) {
    var f3 = c3.value.trim(), p3 = /^(eslint(?:\x2Denv|\x2Denable|\x2Ddisable(?:(?:\x2Dnext)?\x2Dline)?)?|exported|globals?)(?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]|$)/.exec(f3);
    if (p3) {
      var d3 = p3[1], m3 = /^eslint\x2Ddisable\x2D(next\x2D)?line$/.test(d3);
      if (c3.type !== "Line" || m3) {
        if (r3) {
          var y3 = c3.type === "Block" ? "/*".concat(d3, "*/") : "//".concat(d3);
          return void o3.push(Fo$1({ ruleId: null, message: "'".concat(y3, "' has no effect because you have 'noInlineConfig' setting in ").concat(r3, "."), loc: c3.loc, severity: 1 }));
        }
        if (m3 && c3.loc.start.line !== c3.loc.end.line)
          return void o3.push(Fo$1({ ruleId: null, message: "".concat(d3, " comment should not span multiple lines."), loc: c3.loc }));
        var v3 = f3.slice(p3.index + d3.length);
        switch (d3) {
          case "eslint-disable":
          case "eslint-enable":
          case "eslint-disable-next-line":
          case "eslint-disable-line":
            var b3 = function(I3) {
              var L3 = I3.type, V10 = I3.loc, K3 = I3.value, W3 = I3.ruleMapper, R3 = Object.keys(Gu$1.parseListConfig(K3)), q3 = R3.length ? R3 : [null], J3 = { directives: [], directiveProblems: [] }, X3 = true, ce2 = false, A3 = void 0;
              try {
                for (var M3, ne2 = q3[Symbol.iterator](); !(X3 = (M3 = ne2.next()).done); X3 = true) {
                  var de2 = M3.value;
                  de2 === null || W3(de2) !== null ? J3.directives.push({ type: L3, line: V10.start.line, column: V10.start.column + 1, ruleId: de2 }) : J3.directiveProblems.push(Fo$1({ ruleId: de2, loc: V10 }));
                }
              } catch (he2) {
                ce2 = true, A3 = he2;
              } finally {
                try {
                  X3 || ne2.return == null || ne2.return();
                } finally {
                  if (ce2)
                    throw A3;
                }
              }
              return J3;
            }({ type: d3.slice(7), loc: c3.loc, value: v3, ruleMapper: n3 }), x3 = b3.directives, C3 = b3.directiveProblems;
            u3.push.apply(u3, Mt$2(x3)), o3.push.apply(o3, Mt$2(C3));
            break;
          case "exported":
            Object.assign(s3, Gu$1.parseStringConfig(v3, c3));
            break;
          case "globals":
          case "global":
            for (var k3 = 0, F3 = Object.entries(Gu$1.parseStringConfig(v3, c3)); k3 < F3.length; k3++) {
              var B3 = bn$1(F3[k3], 2), O3 = B3[0], S3 = B3[1].value, w3 = void 0;
              try {
                w3 = bi$1.normalizeConfigGlobal(S3);
              } catch (I3) {
                o3.push(Fo$1({ ruleId: null, loc: c3.loc, message: I3.message }));
                continue;
              }
              a3[O3] ? (a3[O3].comments.push(c3), a3[O3].value = w3) : a3[O3] = { comments: [c3], value: w3 };
            }
            break;
          case "eslint":
            var D3 = Gu$1.parseJsonConfig(v3, c3.loc);
            D3.success ? Object.keys(D3.config).forEach(function(I3) {
              var L3 = n3(I3), V10 = D3.config[I3];
              if (L3 !== null) {
                try {
                  nP.validateRuleOptions(L3, I3, V10);
                } catch (K3) {
                  return void o3.push(Fo$1({ ruleId: I3, message: K3.message, loc: c3.loc }));
                }
                i[I3] = V10;
              } else
                o3.push(Fo$1({ ruleId: I3, loc: c3.loc }));
            }) : o3.push(D3.error);
        }
      }
    }
  }), { configuredRules: i, enabledGlobals: a3, exportedVariables: s3, problems: o3, disableDirectives: u3 };
}
var Lb$1 = /\/\*[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*eslint\x2Denv[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?)\*\//g;
function Nb$1(e28) {
  var t3 = e28.split(Bs$1.sep), n3 = t3.lastIndexOf("<text>");
  return n3 === -1 ? e28 : t3.slice(n3).join(Bs$1.sep);
}
function VP(e28) {
  return Array.isArray(e28) ? e28.slice(1) : [];
}
function jb$1(e28, t3, n3) {
  var r3 = t3.ecmaFeatures || {}, i = t3.ecmaVersion || 5;
  return ww.analyze(e28, { ignoreEval: true, nodejsScope: r3.globalReturn, impliedStrict: r3.impliedStrict, ecmaVersion: i, sourceType: t3.sourceType || "script", childVisitorKeys: n3 || ye$4.evk.KEYS, fallback: ye$4.Traverser.getKeys });
}
function Rb$1(e28, t3) {
  for (var n3 = t3.type !== "Program", r3 = t3; r3; r3 = r3.parent) {
    var i = e28.acquire(r3, n3);
    if (i)
      return i.type === "function-expression-name" ? i.childScopes[0] : i;
  }
  return e28.scopes[0];
}
var Mb$1 = { getSource: "getText", getSourceLines: "getLines", getAllComments: "getAllComments", getNodeByRangeIndex: "getNodeByRangeIndex", getComments: "getComments", getCommentsBefore: "getCommentsBefore", getCommentsAfter: "getCommentsAfter", getCommentsInside: "getCommentsInside", getJSDocComment: "getJSDocComment", getFirstToken: "getFirstToken", getFirstTokens: "getFirstTokens", getLastToken: "getLastToken", getLastTokens: "getLastTokens", getTokenAfter: "getTokenAfter", getTokenBefore: "getTokenBefore", getTokenByRangeStart: "getTokenByRangeStart", getTokens: "getTokens", getTokensAfter: "getTokensAfter", getTokensBefore: "getTokensBefore", getTokensBetween: "getTokensBetween" }, UP = Object.freeze(Object.keys(Mb$1).reduce(function(e28, t3) {
  return Object.assign(e28, Fn$1({}, t3, function() {
    var n3;
    return (n3 = this.getSourceCode())[Mb$1[t3]].apply(n3, arguments);
  }));
}, {}));
function qP(e28, t3, n3, r3, i, a3, s3, o3, u3) {
  var c3 = BP(), f3 = [], p3 = e28.ast;
  ye$4.Traverser.traverse(e28.ast, { enter: function(v3, b3) {
    v3.parent = b3, f3.push({ isEntering: true, node: v3 });
  }, leave: function(v3) {
    f3.push({ isEntering: false, node: v3 });
  }, visitorKeys: e28.visitorKeys });
  var d3 = Object.freeze(Object.assign(Object.create(UP), { getAncestors: function() {
    return function(v3) {
      for (var b3 = [], x3 = v3.parent; x3; x3 = x3.parent)
        b3.push(x3);
      return b3.reverse();
    }(p3);
  }, getDeclaredVariables: e28.scopeManager.getDeclaredVariables.bind(e28.scopeManager), getCwd: function() {
    return u3;
  }, getFilename: function() {
    return s3;
  }, getScope: function() {
    return Rb$1(e28.scopeManager, p3);
  }, getSourceCode: function() {
    return e28;
  }, markVariableAsUsed: function(v3) {
    return function(b3, x3, C3, k3) {
      for (var F3 = C3.ecmaFeatures && C3.ecmaFeatures.globalReturn || C3.sourceType === "module", B3 = Rb$1(b3, x3), O3 = B3.type === "global" && F3 ? B3.childScopes[0] : B3; O3; O3 = O3.upper) {
        var S3 = O3.variables.find(function(w3) {
          return w3.name === k3;
        });
        if (S3)
          return S3.eslintUsed = true, true;
      }
      return false;
    }(e28.scopeManager, p3, r3, v3);
  }, parserOptions: r3, parserPath: i, parserServices: e28.parserServices, settings: a3 })), m3 = [];
  Object.keys(t3).forEach(function(v3) {
    var b3 = bi$1.getRuleSeverity(t3[v3]);
    if (b3 !== 0) {
      var x3 = n3(v3);
      if (x3 !== null) {
        var C3 = x3.meta && x3.meta.messages, k3 = null, F3 = Object.freeze(Object.assign(Object.create(d3), { id: v3, options: VP(t3[v3]), report: function() {
          k3 === null && (k3 = PP({ ruleId: v3, severity: b3, sourceCode: e28, messageIds: C3, disableFixes: o3 }));
          var O3 = k3.apply(void 0, arguments);
          if (O3.fix && x3.meta && !x3.meta.fixable)
            throw new Error("Fixable rules should export a `meta.fixable` property.");
          m3.push(O3);
        } })), B3 = function(O3, S3) {
          try {
            return O3.create(S3);
          } catch (w3) {
            throw w3.message = "Error while loading rule '".concat(S3.id, "': ").concat(w3.message), w3;
          }
        }(x3, F3);
        Object.keys(B3).forEach(function(O3) {
          c3.on(O3, B3[O3]);
        });
      } else
        m3.push(Fo$1({ ruleId: v3 }));
    }
  });
  var y3 = new xP(new CP(c3));
  return f3.forEach(function(v3) {
    p3 = v3.node;
    try {
      v3.isEntering ? y3.enterNode(p3) : y3.leaveNode(p3);
    } catch (b3) {
      throw b3.currentNode = p3, b3;
    }
  }), m3;
}
function Vb$1(e28, t3) {
  return e28.lastConfigArray && e28.lastConfigArray.pluginRules.get(t3) || e28.ruleMap.get(t3);
}
function WP(e28) {
  return e28 || ((typeof process > "u" ? "undefined" : xe$3(process)) == "object" ? process.cwd() : void 0);
}
var za$2 = /* @__PURE__ */ new WeakMap(), $P = { linter_1: { Linter: { Linter: function() {
  function e28() {
    var t3 = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).cwd;
    We$1(this, e28), za$2.set(this, { cwd: WP(t3), lastConfigArray: null, lastSourceCode: null, parserMap: /* @__PURE__ */ new Map([["espree", ye$4.espree]]), ruleMap: new IP() }), this.version = Ib$1.version;
  }
  return Xe$1(e28, [{ key: "_verifyWithoutProcessors", value: function(t3, n3, r3) {
    var i, a3 = za$2.get(this), s3 = n3 || {}, o3 = function(O3, S3) {
      var w3 = S3.noInlineConfig === true, D3 = O3.allowInlineConfig === false, I3 = S3.configNameOfNoInlineConfig ? " (".concat(S3.configNameOfNoInlineConfig, ")") : "", L3 = O3.reportUnusedDisableDirectives;
      return typeof L3 == "boolean" && (L3 = L3 ? "error" : "off"), typeof L3 != "string" && (L3 = S3.reportUnusedDisableDirectives ? "warn" : "off"), { filename: Nb$1(O3.filename || "<input>"), allowInlineConfig: !D3, warnInlineConfig: w3 && !D3 ? "your config".concat(I3) : null, reportUnusedDisableDirectives: L3, disableFixes: !!O3.disableFixes };
    }(r3, s3);
    typeof t3 == "string" ? (a3.lastSourceCode = null, i = t3) : (a3.lastSourceCode = t3, i = t3.text);
    var u3 = "espree", c3 = ye$4.espree;
    if (xe$3(s3.parser) == "object" && s3.parser !== null)
      u3 = s3.parser.filePath, c3 = s3.parser.definition;
    else if (typeof s3.parser == "string") {
      if (!a3.parserMap.has(s3.parser))
        return [{ ruleId: null, fatal: true, severity: 2, message: "Configured parser '".concat(s3.parser, "' was not found."), line: 0, column: 0 }];
      u3 = s3.parser, c3 = a3.parserMap.get(s3.parser);
    }
    var f3 = o3.allowInlineConfig && !o3.warnInlineConfig ? function(O3) {
      var S3, w3;
      for (Lb$1.lastIndex = 0; S3 = Lb$1.exec(O3); )
        w3 = Object.assign(w3 || {}, Gu$1.parseListConfig(S3[1]));
      return w3;
    }(i) : {}, p3 = Object.assign({ builtin: true }, s3.env, f3), d3 = Object.keys(p3).filter(function(O3) {
      return p3[O3];
    }).map(function(O3) {
      return function(S3, w3) {
        return S3.lastConfigArray && S3.lastConfigArray.pluginEnvironments.get(w3) || _w.get(w3) || null;
      }(a3, O3);
    }).filter(function(O3) {
      return O3;
    }), m3 = function(O3, S3, w3) {
      var D3 = w3.filter(function(L3) {
        return L3.parserOptions;
      }).reduce(function(L3, V10) {
        return ye$4.lodash.merge(L3, V10.parserOptions);
      }, {}), I3 = ye$4.lodash.merge(D3, S3 || {});
      return I3.sourceType === "module" && (I3.ecmaFeatures = Object.assign({}, I3.ecmaFeatures, { globalReturn: false })), I3.ecmaVersion = function(L3) {
        return 2015 <= L3 ? L3 - 2009 : L3;
      }(I3.ecmaVersion), I3;
    }(0, s3.parserOptions || {}, d3), y3 = function(O3, S3) {
      return Object.assign.apply(Object, [{}].concat(Mt$2(S3.filter(function(w3) {
        return w3.globals;
      }).map(function(w3) {
        return w3.globals;
      })), [O3]));
    }(s3.globals || {}, d3), v3 = s3.settings || {};
    if (a3.lastSourceCode)
      a3.lastSourceCode.scopeManager || (a3.lastSourceCode = new Ob$1({ text: a3.lastSourceCode.text, ast: a3.lastSourceCode.ast, parserServices: a3.lastSourceCode.parserServices, visitorKeys: a3.lastSourceCode.visitorKeys, scopeManager: jb$1(a3.lastSourceCode.ast, m3) }));
    else {
      var b3 = function(O3, S3, w3, D3) {
        var I3 = function(X3) {
          return X3.charCodeAt(0) === 65279 ? X3.slice(1) : X3;
        }(O3).replace(ye$4.require$$0$1.shebangPattern, function(X3, ce2) {
          return "//".concat(ce2);
        }), L3 = Object.assign({}, w3, { loc: true, range: true, raw: true, tokens: true, comment: true, eslintVisitorKeys: true, eslintScopeManager: true, filePath: D3 });
        try {
          var V10 = typeof S3.parseForESLint == "function" ? S3.parseForESLint(I3, L3) : { ast: S3.parse(I3, L3) }, K3 = V10.ast, W3 = V10.services || {}, R3 = V10.visitorKeys || ye$4.evk.KEYS, q3 = V10.scopeManager || jb$1(K3, L3, R3);
          return { success: true, sourceCode: new Ob$1({ text: O3, ast: K3, parserServices: W3, scopeManager: q3, visitorKeys: R3 }) };
        } catch (X3) {
          var J3 = "Parsing error: ".concat(X3.message.replace(/^line [0-9]+:/i, "").trim());
          return sr$2(`%s
%s`, J3, X3.stack), { success: false, error: { ruleId: null, fatal: true, severity: 2, message: J3, line: X3.lineNumber, column: X3.column } };
        }
      }(i, c3, m3, o3.filename);
      if (!b3.success)
        return [b3.error];
      a3.lastSourceCode = b3.sourceCode;
    }
    var x3 = a3.lastSourceCode, C3 = o3.allowInlineConfig ? MP(o3.filename, x3.ast, function(O3) {
      return Vb$1(a3, O3);
    }, o3.warnInlineConfig) : { configuredRules: {}, enabledGlobals: {}, exportedVariables: {}, problems: [], disableDirectives: [] };
    (function(O3, S3, w3) {
      var D3 = w3.exportedVariables, I3 = w3.enabledGlobals, L3 = true, V10 = false, K3 = void 0;
      try {
        for (var W3, R3 = new Set([].concat(Mt$2(Object.keys(S3)), Mt$2(Object.keys(I3))))[Symbol.iterator](); !(L3 = (W3 = R3.next()).done); L3 = true) {
          var q3 = W3.value, J3 = S3[q3] === void 0 ? void 0 : bi$1.normalizeConfigGlobal(S3[q3]), X3 = I3[q3] && I3[q3].value || J3, ce2 = I3[q3] && I3[q3].comments;
          if (X3 !== "off") {
            var A3 = O3.set.get(q3);
            A3 || (A3 = new ww.Variable(q3, O3), O3.variables.push(A3), O3.set.set(q3, A3)), A3.eslintImplicitGlobalSetting = J3, A3.eslintExplicitGlobal = ce2 !== void 0, A3.eslintExplicitGlobalComments = ce2, A3.writeable = X3 === "writable";
          }
        }
      } catch (M3) {
        V10 = true, K3 = M3;
      } finally {
        try {
          L3 || R3.return == null || R3.return();
        } finally {
          if (V10)
            throw K3;
        }
      }
      Object.keys(D3).forEach(function(M3) {
        var ne2 = O3.set.get(M3);
        ne2 && (ne2.eslintUsed = true);
      }), O3.through = O3.through.filter(function(M3) {
        var ne2 = M3.identifier.name, de2 = O3.set.get(ne2);
        return !de2 || (M3.resolved = de2, de2.references.push(M3), false);
      });
    })(x3.scopeManager.scopes[0], y3, { exportedVariables: C3.exportedVariables, enabledGlobals: C3.enabledGlobals });
    var k3, F3 = Object.assign({}, s3.rules, C3.configuredRules);
    try {
      k3 = qP(x3, F3, function(O3) {
        return Vb$1(a3, O3);
      }, m3, u3, v3, o3.filename, o3.disableFixes, a3.cwd);
    } catch (O3) {
      if (O3.message += `
Occurred while linting `.concat(o3.filename), sr$2("An error occurred while traversing"), sr$2("Filename:", o3.filename), O3.currentNode) {
        var B3 = O3.currentNode.loc.start.line;
        sr$2("Line:", B3), O3.message += ":".concat(B3);
      }
      throw sr$2("Parser Options:", m3), sr$2("Parser Path:", u3), sr$2("Settings:", v3), O3;
    }
    return function(O3) {
      var S3 = O3.directives, w3 = O3.problems, D3 = O3.reportUnusedDisableDirectives, I3 = D3 === void 0 ? "off" : D3, L3 = S3.filter(function(R3) {
        return R3.type === "disable" || R3.type === "enable";
      }).map(function(R3) {
        return Object.assign({}, R3, { unprocessedDirective: R3 });
      }).sort(fp), V10 = ye$4.lodash.flatMap(S3, function(R3) {
        switch (R3.type) {
          case "disable":
          case "enable":
            return [];
          case "disable-line":
            return [{ type: "disable", line: R3.line, column: 1, ruleId: R3.ruleId, unprocessedDirective: R3 }, { type: "enable", line: R3.line + 1, column: 0, ruleId: R3.ruleId, unprocessedDirective: R3 }];
          case "disable-next-line":
            return [{ type: "disable", line: R3.line + 1, column: 1, ruleId: R3.ruleId, unprocessedDirective: R3 }, { type: "enable", line: R3.line + 2, column: 0, ruleId: R3.ruleId, unprocessedDirective: R3 }];
          default:
            throw new TypeError("Unrecognized directive type '".concat(R3.type, "'"));
        }
      }).sort(fp), K3 = _b({ problems: w3, directives: L3, reportUnusedDisableDirectives: I3 }), W3 = _b({ problems: K3.problems, directives: V10, reportUnusedDisableDirectives: I3 });
      return I3 === "off" ? W3.problems : W3.problems.concat(K3.unusedDisableDirectives).concat(W3.unusedDisableDirectives).sort(fp);
    }({ directives: C3.disableDirectives, problems: k3.concat(C3.problems).sort(function(O3, S3) {
      return O3.line - S3.line || O3.column - S3.column;
    }), reportUnusedDisableDirectives: o3.reportUnusedDisableDirectives });
  } }, { key: "verify", value: function(t3, n3, r3) {
    sr$2("Verify");
    var i = typeof r3 == "string" ? { filename: r3 } : r3 || {};
    return n3 && typeof n3.extractConfig == "function" ? this._verifyWithConfigArray(t3, n3, i) : i.preprocess || i.postprocess ? this._verifyWithProcessor(t3, n3, i) : this._verifyWithoutProcessors(t3, n3, i);
  } }, { key: "_verifyWithConfigArray", value: function(t3, n3, r3) {
    sr$2("With ConfigArray: %s", r3.filename), za$2.get(this).lastConfigArray = n3;
    var i = n3.extractConfig(r3.filename), a3 = i.processor && n3.pluginProcessors.get(i.processor);
    if (a3) {
      sr$2("Apply the processor: %o", i.processor);
      var s3 = a3.preprocess, o3 = a3.postprocess, u3 = a3.supportsAutofix, c3 = r3.disableFixes || !u3;
      return this._verifyWithProcessor(t3, i, Sa$2({}, r3, { disableFixes: c3, postprocess: o3, preprocess: s3 }), n3);
    }
    return this._verifyWithoutProcessors(t3, i, r3);
  } }, { key: "_verifyWithProcessor", value: function(t3, n3, r3, i) {
    var a3 = this, s3 = r3.filename || "<input>", o3 = Nb$1(s3), u3 = function(m3) {
      return xe$3(m3) == "object" ? (m3.hasBOM ? "\uFEFF" : "") + m3.text : m3 + "";
    }(t3), c3 = r3.preprocess || function(m3) {
      return [m3];
    }, f3 = r3.postprocess || ye$4.lodash.flatten, p3 = r3.filterCodeBlock || function(m3) {
      return m3.endsWith(".js");
    }, d3 = Bs$1.extname(s3);
    return f3(c3(u3, o3).map(function(m3, y3) {
      if (sr$2("A code block was found: %o", m3.filename || "(unnamed)"), typeof m3 == "string")
        return a3._verifyWithoutProcessors(m3, n3, r3);
      var v3 = m3.text, b3 = Bs$1.join(s3, "".concat(y3, "_").concat(m3.filename));
      return p3(b3, v3) ? i && Bs$1.extname(b3) !== d3 ? (sr$2("Resolving configuration again because the file extension was changed."), a3._verifyWithConfigArray(v3, i, Sa$2({}, r3, { filename: b3 }))) : a3._verifyWithoutProcessors(v3, n3, Sa$2({}, r3, { filename: b3 })) : (sr$2("This code block was skipped."), []);
    }), o3);
  } }, { key: "getSourceCode", value: function() {
    return za$2.get(this).lastSourceCode;
  } }, { key: "defineRule", value: function(t3, n3) {
    za$2.get(this).ruleMap.define(t3, n3);
  } }, { key: "defineRules", value: function(t3) {
    var n3 = this;
    Object.getOwnPropertyNames(t3).forEach(function(r3) {
      n3.defineRule(r3, t3[r3]);
    });
  } }, { key: "getRules", value: function() {
    var t3 = za$2.get(this), n3 = t3.lastConfigArray, r3 = t3.ruleMap;
    return new Map(regeneratorRuntime.mark(function i() {
      return regeneratorRuntime.wrap(function(a3) {
        for (; ; )
          switch (a3.prev = a3.next) {
            case 0:
              return a3.delegateYield(r3, "t0", 1);
            case 1:
              if (a3.t1 = n3, !a3.t1) {
                a3.next = 4;
                break;
              }
              return a3.delegateYield(n3.pluginRules, "t2", 4);
            case 4:
            case "end":
              return a3.stop();
          }
      }, i);
    })());
  } }, { key: "defineParser", value: function(t3, n3) {
    za$2.get(this).parserMap.set(t3, n3);
  } }, { key: "verifyAndFix", value: function(t3, n3, r3) {
    var i, a3 = [], s3 = false, o3 = 0, u3 = t3, c3 = r3 && r3.filename || "".concat(t3.slice(0, 10), "..."), f3 = !(r3 && r3.fix !== void 0) || r3.fix;
    do {
      if (o3++, sr$2("Linting code for ".concat(c3, " (pass ").concat(o3, ")")), a3 = this.verify(u3, n3, r3), sr$2("Generating fixed text for ".concat(c3, " (pass ").concat(o3, ")")), i = Pb$1.applyFixes(u3, a3, f3), a3.length === 1 && a3[0].fatal)
        break;
      s3 = s3 || i.fixed, u3 = i.output;
    } while (i.fixed && o3 < 10);
    return i.fixed && (i.messages = this.verify(u3, n3, r3)), i.fixed = s3, i.output = u3, i;
  } }], [{ key: "version", get: function() {
    return Ib$1.version;
  } }]), e28;
}(), getLinterInternalSlots: function(e28) {
  return za$2.get(e28);
} }.Linter, SourceCodeFixer: Pb$1, interpolate: sg }.Linter }, wo$1 = gt$3(function(e28) {
  (function() {
    function t3(r3) {
      if (r3 == null)
        return false;
      switch (r3.type) {
        case "BlockStatement":
        case "BreakStatement":
        case "ContinueStatement":
        case "DebuggerStatement":
        case "DoWhileStatement":
        case "EmptyStatement":
        case "ExpressionStatement":
        case "ForInStatement":
        case "ForStatement":
        case "IfStatement":
        case "LabeledStatement":
        case "ReturnStatement":
        case "SwitchStatement":
        case "ThrowStatement":
        case "TryStatement":
        case "VariableDeclaration":
        case "WhileStatement":
        case "WithStatement":
          return true;
      }
      return false;
    }
    function n3(r3) {
      switch (r3.type) {
        case "IfStatement":
          return r3.alternate != null ? r3.alternate : r3.consequent;
        case "LabeledStatement":
        case "ForStatement":
        case "ForInStatement":
        case "WhileStatement":
        case "WithStatement":
          return r3.body;
      }
      return null;
    }
    e28.exports = { isExpression: function(r3) {
      if (r3 == null)
        return false;
      switch (r3.type) {
        case "ArrayExpression":
        case "AssignmentExpression":
        case "BinaryExpression":
        case "CallExpression":
        case "ConditionalExpression":
        case "FunctionExpression":
        case "Identifier":
        case "Literal":
        case "LogicalExpression":
        case "MemberExpression":
        case "NewExpression":
        case "ObjectExpression":
        case "SequenceExpression":
        case "ThisExpression":
        case "UnaryExpression":
        case "UpdateExpression":
          return true;
      }
      return false;
    }, isStatement: t3, isIterationStatement: function(r3) {
      if (r3 == null)
        return false;
      switch (r3.type) {
        case "DoWhileStatement":
        case "ForInStatement":
        case "ForStatement":
        case "WhileStatement":
          return true;
      }
      return false;
    }, isSourceElement: function(r3) {
      return t3(r3) || r3 != null && r3.type === "FunctionDeclaration";
    }, isProblematicIfStatement: function(r3) {
      var i;
      if (r3.type !== "IfStatement" || r3.alternate == null)
        return false;
      i = r3.consequent;
      do {
        if (i.type === "IfStatement" && i.alternate == null)
          return true;
        i = n3(i);
      } while (i);
      return false;
    }, trailingStatement: n3 };
  })();
}), xi$1 = (wo$1.isExpression, wo$1.isStatement, wo$1.isIterationStatement, wo$1.isSourceElement, wo$1.isProblematicIfStatement, wo$1.trailingStatement, gt$3(function(e28) {
  (function() {
    var t3, n3, r3, i, a3, s3;
    function o3(u3) {
      return u3 <= 65535 ? String.fromCharCode(u3) : String.fromCharCode(Math.floor((u3 - 65536) / 1024) + 55296) + String.fromCharCode((u3 - 65536) % 1024 + 56320);
    }
    for (n3 = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/, NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/ }, t3 = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/, NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/ }, r3 = [5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279], i = new Array(128), s3 = 0; s3 < 128; ++s3)
      i[s3] = s3 >= 97 && s3 <= 122 || s3 >= 65 && s3 <= 90 || s3 === 36 || s3 === 95;
    for (a3 = new Array(128), s3 = 0; s3 < 128; ++s3)
      a3[s3] = s3 >= 97 && s3 <= 122 || s3 >= 65 && s3 <= 90 || s3 >= 48 && s3 <= 57 || s3 === 36 || s3 === 95;
    e28.exports = { isDecimalDigit: function(u3) {
      return 48 <= u3 && u3 <= 57;
    }, isHexDigit: function(u3) {
      return 48 <= u3 && u3 <= 57 || 97 <= u3 && u3 <= 102 || 65 <= u3 && u3 <= 70;
    }, isOctalDigit: function(u3) {
      return u3 >= 48 && u3 <= 55;
    }, isWhiteSpace: function(u3) {
      return u3 === 32 || u3 === 9 || u3 === 11 || u3 === 12 || u3 === 160 || u3 >= 5760 && r3.indexOf(u3) >= 0;
    }, isLineTerminator: function(u3) {
      return u3 === 10 || u3 === 13 || u3 === 8232 || u3 === 8233;
    }, isIdentifierStartES5: function(u3) {
      return u3 < 128 ? i[u3] : n3.NonAsciiIdentifierStart.test(o3(u3));
    }, isIdentifierPartES5: function(u3) {
      return u3 < 128 ? a3[u3] : n3.NonAsciiIdentifierPart.test(o3(u3));
    }, isIdentifierStartES6: function(u3) {
      return u3 < 128 ? i[u3] : t3.NonAsciiIdentifierStart.test(o3(u3));
    }, isIdentifierPartES6: function(u3) {
      return u3 < 128 ? a3[u3] : t3.NonAsciiIdentifierPart.test(o3(u3));
    } };
  })();
})), Oi$1 = (xi$1.isDecimalDigit, xi$1.isHexDigit, xi$1.isOctalDigit, xi$1.isWhiteSpace, xi$1.isLineTerminator, xi$1.isIdentifierStartES5, xi$1.isIdentifierPartES5, xi$1.isIdentifierStartES6, xi$1.isIdentifierPartES6, gt$3(function(e28) {
  (function() {
    var t3 = xi$1;
    function n3(u3, c3) {
      return !(!c3 && u3 === "yield") && r3(u3, c3);
    }
    function r3(u3, c3) {
      if (c3 && function(f3) {
        switch (f3) {
          case "implements":
          case "interface":
          case "package":
          case "private":
          case "protected":
          case "public":
          case "static":
          case "let":
            return true;
          default:
            return false;
        }
      }(u3))
        return true;
      switch (u3.length) {
        case 2:
          return u3 === "if" || u3 === "in" || u3 === "do";
        case 3:
          return u3 === "var" || u3 === "for" || u3 === "new" || u3 === "try";
        case 4:
          return u3 === "this" || u3 === "else" || u3 === "case" || u3 === "void" || u3 === "with" || u3 === "enum";
        case 5:
          return u3 === "while" || u3 === "break" || u3 === "catch" || u3 === "throw" || u3 === "const" || u3 === "yield" || u3 === "class" || u3 === "super";
        case 6:
          return u3 === "return" || u3 === "typeof" || u3 === "delete" || u3 === "switch" || u3 === "export" || u3 === "import";
        case 7:
          return u3 === "default" || u3 === "finally" || u3 === "extends";
        case 8:
          return u3 === "function" || u3 === "continue" || u3 === "debugger";
        case 10:
          return u3 === "instanceof";
        default:
          return false;
      }
    }
    function i(u3, c3) {
      return u3 === "null" || u3 === "true" || u3 === "false" || n3(u3, c3);
    }
    function a3(u3, c3) {
      return u3 === "null" || u3 === "true" || u3 === "false" || r3(u3, c3);
    }
    function s3(u3) {
      var c3, f3, p3;
      if (u3.length === 0 || (p3 = u3.charCodeAt(0), !t3.isIdentifierStartES5(p3)))
        return false;
      for (c3 = 1, f3 = u3.length; c3 < f3; ++c3)
        if (p3 = u3.charCodeAt(c3), !t3.isIdentifierPartES5(p3))
          return false;
      return true;
    }
    function o3(u3) {
      var c3, f3, p3, d3, m3;
      if (u3.length === 0)
        return false;
      for (m3 = t3.isIdentifierStartES6, c3 = 0, f3 = u3.length; c3 < f3; ++c3) {
        if (55296 <= (p3 = u3.charCodeAt(c3)) && p3 <= 56319) {
          if (++c3 >= f3 || !(56320 <= (d3 = u3.charCodeAt(c3)) && d3 <= 57343))
            return false;
          p3 = 1024 * (p3 - 55296) + (d3 - 56320) + 65536;
        }
        if (!m3(p3))
          return false;
        m3 = t3.isIdentifierPartES6;
      }
      return true;
    }
    e28.exports = { isKeywordES5: n3, isKeywordES6: r3, isReservedWordES5: i, isReservedWordES6: a3, isRestrictedWord: function(u3) {
      return u3 === "eval" || u3 === "arguments";
    }, isIdentifierNameES5: s3, isIdentifierNameES6: o3, isIdentifierES5: function(u3, c3) {
      return s3(u3) && !i(u3, c3);
    }, isIdentifierES6: function(u3, c3) {
      return o3(u3) && !a3(u3, c3);
    } };
  })();
})), Os$1 = (Oi$1.isKeywordES5, Oi$1.isKeywordES6, Oi$1.isReservedWordES5, Oi$1.isReservedWordES6, Oi$1.isRestrictedWord, Oi$1.isIdentifierNameES5, Oi$1.isIdentifierNameES6, Oi$1.isIdentifierES5, Oi$1.isIdentifierES6, gt$3(function(e28, t3) {
  t3.ast = wo$1, t3.code = xi$1, t3.keyword = Oi$1;
})), GP = (Os$1.ast, Os$1.code, Os$1.keyword, function(e28) {
  return new Qa$2(e28 || zP, null);
}), Yt$2 = 0, It$2 = 1;
function Lr$2(e28, t3, n3, r3, i, a3) {
  this._color = e28, this.key = t3, this.value = n3, this.left = r3, this.right = i, this._count = a3;
}
function Li$1(e28) {
  return new Lr$2(e28._color, e28.key, e28.value, e28.left, e28.right, e28._count);
}
function eo$1(e28, t3) {
  return new Lr$2(e28, t3.key, t3.value, t3.left, t3.right, t3._count);
}
function on$1(e28) {
  e28._count = 1 + (e28.left ? e28.left._count : 0) + (e28.right ? e28.right._count : 0);
}
function Qa$2(e28, t3) {
  this._compare = e28, this.root = t3;
}
var ur$1 = Qa$2.prototype;
function n0(e28, t3) {
  var n3;
  return t3.left && (n3 = n0(e28, t3.left)) ? n3 : (n3 = e28(t3.key, t3.value)) || (t3.right ? n0(e28, t3.right) : void 0);
}
function r0(e28, t3, n3, r3) {
  if (t3(e28, r3.key) <= 0) {
    var i;
    if (r3.left && (i = r0(e28, t3, n3, r3.left)) || (i = n3(r3.key, r3.value)))
      return i;
  }
  if (r3.right)
    return r0(e28, t3, n3, r3.right);
}
function i0(e28, t3, n3, r3, i) {
  var a3, s3 = n3(e28, i.key), o3 = n3(t3, i.key);
  if (s3 <= 0 && (i.left && (a3 = i0(e28, t3, n3, r3, i.left)) || o3 > 0 && (a3 = r3(i.key, i.value))))
    return a3;
  if (o3 > 0 && i.right)
    return i0(e28, t3, n3, r3, i.right);
}
function Or$1(e28, t3) {
  this.tree = e28, this._stack = t3;
}
Object.defineProperty(ur$1, "keys", { get: function() {
  var e28 = [];
  return this.forEach(function(t3, n3) {
    e28.push(t3);
  }), e28;
} }), Object.defineProperty(ur$1, "values", { get: function() {
  var e28 = [];
  return this.forEach(function(t3, n3) {
    e28.push(n3);
  }), e28;
} }), Object.defineProperty(ur$1, "length", { get: function() {
  return this.root ? this.root._count : 0;
} }), ur$1.insert = function(e28, t3) {
  for (var n3 = this._compare, r3 = this.root, i = [], a3 = []; r3; ) {
    var s3 = n3(e28, r3.key);
    i.push(r3), a3.push(s3), r3 = s3 <= 0 ? r3.left : r3.right;
  }
  i.push(new Lr$2(Yt$2, e28, t3, null, null, 1));
  for (var o3 = i.length - 2; o3 >= 0; --o3)
    r3 = i[o3], a3[o3] <= 0 ? i[o3] = new Lr$2(r3._color, r3.key, r3.value, i[o3 + 1], r3.right, r3._count + 1) : i[o3] = new Lr$2(r3._color, r3.key, r3.value, r3.left, i[o3 + 1], r3._count + 1);
  for (o3 = i.length - 1; o3 > 1; --o3) {
    var u3 = i[o3 - 1];
    if (r3 = i[o3], u3._color === It$2 || r3._color === It$2)
      break;
    var c3 = i[o3 - 2];
    if (c3.left === u3)
      if (u3.left === r3) {
        if (!(f3 = c3.right) || f3._color !== Yt$2) {
          c3._color = Yt$2, c3.left = u3.right, u3._color = It$2, u3.right = c3, i[o3 - 2] = u3, i[o3 - 1] = r3, on$1(c3), on$1(u3), o3 >= 3 && ((p3 = i[o3 - 3]).left === c3 ? p3.left = u3 : p3.right = u3);
          break;
        }
        u3._color = It$2, c3.right = eo$1(It$2, f3), c3._color = Yt$2, o3 -= 1;
      } else {
        if (!(f3 = c3.right) || f3._color !== Yt$2) {
          u3.right = r3.left, c3._color = Yt$2, c3.left = r3.right, r3._color = It$2, r3.left = u3, r3.right = c3, i[o3 - 2] = r3, i[o3 - 1] = u3, on$1(c3), on$1(u3), on$1(r3), o3 >= 3 && ((p3 = i[o3 - 3]).left === c3 ? p3.left = r3 : p3.right = r3);
          break;
        }
        u3._color = It$2, c3.right = eo$1(It$2, f3), c3._color = Yt$2, o3 -= 1;
      }
    else if (u3.right === r3) {
      if (!(f3 = c3.left) || f3._color !== Yt$2) {
        c3._color = Yt$2, c3.right = u3.left, u3._color = It$2, u3.left = c3, i[o3 - 2] = u3, i[o3 - 1] = r3, on$1(c3), on$1(u3), o3 >= 3 && ((p3 = i[o3 - 3]).right === c3 ? p3.right = u3 : p3.left = u3);
        break;
      }
      u3._color = It$2, c3.left = eo$1(It$2, f3), c3._color = Yt$2, o3 -= 1;
    } else {
      var f3;
      if (!(f3 = c3.left) || f3._color !== Yt$2) {
        var p3;
        u3.left = r3.right, c3._color = Yt$2, c3.right = r3.left, r3._color = It$2, r3.right = u3, r3.left = c3, i[o3 - 2] = r3, i[o3 - 1] = u3, on$1(c3), on$1(u3), on$1(r3), o3 >= 3 && ((p3 = i[o3 - 3]).right === c3 ? p3.right = r3 : p3.left = r3);
        break;
      }
      u3._color = It$2, c3.left = eo$1(It$2, f3), c3._color = Yt$2, o3 -= 1;
    }
  }
  return i[0]._color = It$2, new Qa$2(n3, i[0]);
}, ur$1.forEach = function(e28, t3, n3) {
  if (this.root)
    switch (arguments.length) {
      case 1:
        return n0(e28, this.root);
      case 2:
        return r0(t3, this._compare, e28, this.root);
      case 3:
        return this._compare(t3, n3) >= 0 ? void 0 : i0(t3, n3, this._compare, e28, this.root);
    }
}, Object.defineProperty(ur$1, "begin", { get: function() {
  for (var e28 = [], t3 = this.root; t3; )
    e28.push(t3), t3 = t3.left;
  return new Or$1(this, e28);
} }), Object.defineProperty(ur$1, "end", { get: function() {
  for (var e28 = [], t3 = this.root; t3; )
    e28.push(t3), t3 = t3.right;
  return new Or$1(this, e28);
} }), ur$1.at = function(e28) {
  if (e28 < 0)
    return new Or$1(this, []);
  for (var t3 = this.root, n3 = []; ; ) {
    if (n3.push(t3), t3.left) {
      if (e28 < t3.left._count) {
        t3 = t3.left;
        continue;
      }
      e28 -= t3.left._count;
    }
    if (!e28)
      return new Or$1(this, n3);
    if (e28 -= 1, !t3.right || e28 >= t3.right._count)
      break;
    t3 = t3.right;
  }
  return new Or$1(this, []);
}, ur$1.ge = function(e28) {
  for (var t3 = this._compare, n3 = this.root, r3 = [], i = 0; n3; ) {
    var a3 = t3(e28, n3.key);
    r3.push(n3), a3 <= 0 && (i = r3.length), n3 = a3 <= 0 ? n3.left : n3.right;
  }
  return r3.length = i, new Or$1(this, r3);
}, ur$1.gt = function(e28) {
  for (var t3 = this._compare, n3 = this.root, r3 = [], i = 0; n3; ) {
    var a3 = t3(e28, n3.key);
    r3.push(n3), a3 < 0 && (i = r3.length), n3 = a3 < 0 ? n3.left : n3.right;
  }
  return r3.length = i, new Or$1(this, r3);
}, ur$1.lt = function(e28) {
  for (var t3 = this._compare, n3 = this.root, r3 = [], i = 0; n3; ) {
    var a3 = t3(e28, n3.key);
    r3.push(n3), a3 > 0 && (i = r3.length), n3 = a3 <= 0 ? n3.left : n3.right;
  }
  return r3.length = i, new Or$1(this, r3);
}, ur$1.le = function(e28) {
  for (var t3 = this._compare, n3 = this.root, r3 = [], i = 0; n3; ) {
    var a3 = t3(e28, n3.key);
    r3.push(n3), a3 >= 0 && (i = r3.length), n3 = a3 < 0 ? n3.left : n3.right;
  }
  return r3.length = i, new Or$1(this, r3);
}, ur$1.find = function(e28) {
  for (var t3 = this._compare, n3 = this.root, r3 = []; n3; ) {
    var i = t3(e28, n3.key);
    if (r3.push(n3), i === 0)
      return new Or$1(this, r3);
    n3 = i <= 0 ? n3.left : n3.right;
  }
  return new Or$1(this, []);
}, ur$1.remove = function(e28) {
  var t3 = this.find(e28);
  return t3 ? t3.remove() : this;
}, ur$1.get = function(e28) {
  for (var t3 = this._compare, n3 = this.root; n3; ) {
    var r3 = t3(e28, n3.key);
    if (r3 === 0)
      return n3.value;
    n3 = r3 <= 0 ? n3.left : n3.right;
  }
};
var Yr$1 = Or$1.prototype;
function Ub$1(e28, t3) {
  e28.key = t3.key, e28.value = t3.value, e28.left = t3.left, e28.right = t3.right, e28._color = t3._color, e28._count = t3._count;
}
function zP(e28, t3) {
  return e28 < t3 ? -1 : e28 > t3 ? 1 : 0;
}
Object.defineProperty(Yr$1, "valid", { get: function() {
  return this._stack.length > 0;
} }), Object.defineProperty(Yr$1, "node", { get: function() {
  return this._stack.length > 0 ? this._stack[this._stack.length - 1] : null;
}, enumerable: true }), Yr$1.clone = function() {
  return new Or$1(this.tree, this._stack.slice());
}, Yr$1.remove = function() {
  var e28 = this._stack;
  if (e28.length === 0)
    return this.tree;
  var t3 = new Array(e28.length), n3 = e28[e28.length - 1];
  t3[t3.length - 1] = new Lr$2(n3._color, n3.key, n3.value, n3.left, n3.right, n3._count);
  for (var r3 = e28.length - 2; r3 >= 0; --r3)
    (n3 = e28[r3]).left === e28[r3 + 1] ? t3[r3] = new Lr$2(n3._color, n3.key, n3.value, t3[r3 + 1], n3.right, n3._count) : t3[r3] = new Lr$2(n3._color, n3.key, n3.value, n3.left, t3[r3 + 1], n3._count);
  if ((n3 = t3[t3.length - 1]).left && n3.right) {
    var i = t3.length;
    for (n3 = n3.left; n3.right; )
      t3.push(n3), n3 = n3.right;
    var a3 = t3[i - 1];
    for (t3.push(new Lr$2(n3._color, a3.key, a3.value, n3.left, n3.right, n3._count)), t3[i - 1].key = n3.key, t3[i - 1].value = n3.value, r3 = t3.length - 2; r3 >= i; --r3)
      n3 = t3[r3], t3[r3] = new Lr$2(n3._color, n3.key, n3.value, n3.left, t3[r3 + 1], n3._count);
    t3[i - 1].left = t3[i];
  }
  if ((n3 = t3[t3.length - 1])._color === Yt$2) {
    var s3 = t3[t3.length - 2];
    for (s3.left === n3 ? s3.left = null : s3.right === n3 && (s3.right = null), t3.pop(), r3 = 0; r3 < t3.length; ++r3)
      t3[r3]._count--;
    return new Qa$2(this.tree._compare, t3[0]);
  }
  if (n3.left || n3.right) {
    for (n3.left ? Ub$1(n3, n3.left) : n3.right && Ub$1(n3, n3.right), n3._color = It$2, r3 = 0; r3 < t3.length - 1; ++r3)
      t3[r3]._count--;
    return new Qa$2(this.tree._compare, t3[0]);
  }
  if (t3.length === 1)
    return new Qa$2(this.tree._compare, null);
  for (r3 = 0; r3 < t3.length; ++r3)
    t3[r3]._count--;
  var o3 = t3[t3.length - 2];
  return function(u3) {
    for (var c3, f3, p3, d3, m3 = u3.length - 1; m3 >= 0; --m3) {
      if (c3 = u3[m3], m3 === 0)
        return void (c3._color = It$2);
      if ((f3 = u3[m3 - 1]).left === c3) {
        if ((p3 = f3.right).right && p3.right._color === Yt$2)
          return d3 = (p3 = f3.right = Li$1(p3)).right = Li$1(p3.right), f3.right = p3.left, p3.left = f3, p3.right = d3, p3._color = f3._color, c3._color = It$2, f3._color = It$2, d3._color = It$2, on$1(f3), on$1(p3), m3 > 1 && ((y3 = u3[m3 - 2]).left === f3 ? y3.left = p3 : y3.right = p3), void (u3[m3 - 1] = p3);
        if (p3.left && p3.left._color === Yt$2)
          return d3 = (p3 = f3.right = Li$1(p3)).left = Li$1(p3.left), f3.right = d3.left, p3.left = d3.right, d3.left = f3, d3.right = p3, d3._color = f3._color, f3._color = It$2, p3._color = It$2, c3._color = It$2, on$1(f3), on$1(p3), on$1(d3), m3 > 1 && ((y3 = u3[m3 - 2]).left === f3 ? y3.left = d3 : y3.right = d3), void (u3[m3 - 1] = d3);
        if (p3._color === It$2) {
          if (f3._color === Yt$2)
            return f3._color = It$2, void (f3.right = eo$1(Yt$2, p3));
          f3.right = eo$1(Yt$2, p3);
          continue;
        }
        p3 = Li$1(p3), f3.right = p3.left, p3.left = f3, p3._color = f3._color, f3._color = Yt$2, on$1(f3), on$1(p3), m3 > 1 && ((y3 = u3[m3 - 2]).left === f3 ? y3.left = p3 : y3.right = p3), u3[m3 - 1] = p3, u3[m3] = f3, m3 + 1 < u3.length ? u3[m3 + 1] = c3 : u3.push(c3), m3 += 2;
      } else {
        if ((p3 = f3.left).left && p3.left._color === Yt$2)
          return d3 = (p3 = f3.left = Li$1(p3)).left = Li$1(p3.left), f3.left = p3.right, p3.right = f3, p3.left = d3, p3._color = f3._color, c3._color = It$2, f3._color = It$2, d3._color = It$2, on$1(f3), on$1(p3), m3 > 1 && ((y3 = u3[m3 - 2]).right === f3 ? y3.right = p3 : y3.left = p3), void (u3[m3 - 1] = p3);
        if (p3.right && p3.right._color === Yt$2)
          return d3 = (p3 = f3.left = Li$1(p3)).right = Li$1(p3.right), f3.left = d3.right, p3.right = d3.left, d3.right = f3, d3.left = p3, d3._color = f3._color, f3._color = It$2, p3._color = It$2, c3._color = It$2, on$1(f3), on$1(p3), on$1(d3), m3 > 1 && ((y3 = u3[m3 - 2]).right === f3 ? y3.right = d3 : y3.left = d3), void (u3[m3 - 1] = d3);
        if (p3._color === It$2) {
          if (f3._color === Yt$2)
            return f3._color = It$2, void (f3.left = eo$1(Yt$2, p3));
          f3.left = eo$1(Yt$2, p3);
          continue;
        }
        var y3;
        p3 = Li$1(p3), f3.left = p3.right, p3.right = f3, p3._color = f3._color, f3._color = Yt$2, on$1(f3), on$1(p3), m3 > 1 && ((y3 = u3[m3 - 2]).right === f3 ? y3.right = p3 : y3.left = p3), u3[m3 - 1] = p3, u3[m3] = f3, m3 + 1 < u3.length ? u3[m3 + 1] = c3 : u3.push(c3), m3 += 2;
      }
    }
  }(t3), o3.left === n3 ? o3.left = null : o3.right = null, new Qa$2(this.tree._compare, t3[0]);
}, Object.defineProperty(Yr$1, "key", { get: function() {
  if (this._stack.length > 0)
    return this._stack[this._stack.length - 1].key;
}, enumerable: true }), Object.defineProperty(Yr$1, "value", { get: function() {
  if (this._stack.length > 0)
    return this._stack[this._stack.length - 1].value;
}, enumerable: true }), Object.defineProperty(Yr$1, "index", { get: function() {
  var e28 = 0, t3 = this._stack;
  if (t3.length === 0) {
    var n3 = this.tree.root;
    return n3 ? n3._count : 0;
  }
  t3[t3.length - 1].left && (e28 = t3[t3.length - 1].left._count);
  for (var r3 = t3.length - 2; r3 >= 0; --r3)
    t3[r3 + 1] === t3[r3].right && (++e28, t3[r3].left && (e28 += t3[r3].left._count));
  return e28;
}, enumerable: true }), Yr$1.next = function() {
  var e28 = this._stack;
  if (e28.length !== 0) {
    var t3 = e28[e28.length - 1];
    if (t3.right)
      for (t3 = t3.right; t3; )
        e28.push(t3), t3 = t3.left;
    else
      for (e28.pop(); e28.length > 0 && e28[e28.length - 1].right === t3; )
        t3 = e28[e28.length - 1], e28.pop();
  }
}, Object.defineProperty(Yr$1, "hasNext", { get: function() {
  var e28 = this._stack;
  if (e28.length === 0)
    return false;
  if (e28[e28.length - 1].right)
    return true;
  for (var t3 = e28.length - 1; t3 > 0; --t3)
    if (e28[t3 - 1].left === e28[t3])
      return true;
  return false;
} }), Yr$1.update = function(e28) {
  var t3 = this._stack;
  if (t3.length === 0)
    throw new Error("Can't update empty node!");
  var n3 = new Array(t3.length), r3 = t3[t3.length - 1];
  n3[n3.length - 1] = new Lr$2(r3._color, r3.key, e28, r3.left, r3.right, r3._count);
  for (var i = t3.length - 2; i >= 0; --i)
    (r3 = t3[i]).left === t3[i + 1] ? n3[i] = new Lr$2(r3._color, r3.key, r3.value, n3[i + 1], r3.right, r3._count) : n3[i] = new Lr$2(r3._color, r3.key, r3.value, r3.left, n3[i + 1], r3._count);
  return new Qa$2(this.tree._compare, n3[0]);
}, Yr$1.prev = function() {
  var e28 = this._stack;
  if (e28.length !== 0) {
    var t3 = e28[e28.length - 1];
    if (t3.left)
      for (t3 = t3.left; t3; )
        e28.push(t3), t3 = t3.right;
    else
      for (e28.pop(); e28.length > 0 && e28[e28.length - 1].left === t3; )
        t3 = e28[e28.length - 1], e28.pop();
  }
}, Object.defineProperty(Yr$1, "hasPrev", { get: function() {
  var e28 = this._stack;
  if (e28.length === 0)
    return false;
  if (e28[e28.length - 1].left)
    return true;
  for (var t3 = e28.length - 1; t3 > 0; --t3)
    if (e28[t3 - 1].right === e28[t3])
      return true;
  return false;
} });
var HP = Object.freeze({});
function qb$1(e28) {
  return !(e28 < 48) && (e28 < 58 || !(e28 < 65) && (e28 < 91 || e28 === 95 || !(e28 < 97) && (e28 < 123 || sA(e28) || function(t3) {
    return t3 < 7376 ? t3 < 3458 ? t3 < 2691 ? t3 < 2363 ? t3 < 1770 ? t3 < 1479 ? t3 === 183 || !(t3 < 768) && (t3 < 880 || t3 === 903 || !(t3 < 1155) && (t3 < 1160 || !(t3 < 1425) && (t3 < 1470 || t3 === 1471 || !(t3 < 1473) && (t3 < 1475 || !(t3 < 1476) && t3 < 1478)))) : t3 === 1479 || !(t3 < 1552) && (t3 < 1563 || !(t3 < 1611) && (t3 < 1632 || !(t3 < 1632) && (t3 < 1642 || t3 === 1648 || !(t3 < 1750) && (t3 < 1757 || !(t3 < 1759) && (t3 < 1765 || !(t3 < 1767) && t3 < 1769))))) : t3 < 2070 ? !(t3 < 1770) && (t3 < 1774 || !(t3 < 1776) && (t3 < 1786 || t3 === 1809 || !(t3 < 1840) && (t3 < 1867 || !(t3 < 1958) && (t3 < 1969 || !(t3 < 1984) && (t3 < 1994 || !(t3 < 2027) && (t3 < 2036 || t3 === 2045)))))) : t3 < 2074 || !(t3 < 2075) && (t3 < 2084 || !(t3 < 2085) && (t3 < 2088 || !(t3 < 2089) && (t3 < 2094 || !(t3 < 2137) && (t3 < 2140 || !(t3 < 2259) && (t3 < 2274 || !(t3 < 2275) && (t3 < 2307 || t3 === 2307 || t3 === 2362)))))) : t3 < 2509 ? t3 < 2402 ? t3 === 2363 || t3 === 2364 || !(t3 < 2366) && (t3 < 2369 || !(t3 < 2369) && (t3 < 2377 || !(t3 < 2377) && (t3 < 2381 || t3 === 2381 || !(t3 < 2382) && (t3 < 2384 || !(t3 < 2385) && t3 < 2392)))) : t3 < 2404 || !(t3 < 2406) && (t3 < 2416 || t3 === 2433 || !(t3 < 2434) && (t3 < 2436 || t3 === 2492 || !(t3 < 2494) && (t3 < 2497 || !(t3 < 2497) && (t3 < 2501 || !(t3 < 2503) && (t3 < 2505 || !(t3 < 2507) && t3 < 2509))))) : t3 < 2622 ? t3 === 2509 || t3 === 2519 || !(t3 < 2530) && (t3 < 2532 || !(t3 < 2534) && (t3 < 2544 || t3 === 2558 || !(t3 < 2561) && (t3 < 2563 || t3 === 2563 || t3 === 2620))) : t3 < 2625 || !(t3 < 2625) && (t3 < 2627 || !(t3 < 2631) && (t3 < 2633 || !(t3 < 2635) && (t3 < 2638 || t3 === 2641 || !(t3 < 2662) && (t3 < 2672 || !(t3 < 2672) && (t3 < 2674 || t3 === 2677 || !(t3 < 2689) && t3 < 2691))))) : t3 < 3072 ? t3 < 2881 ? t3 < 2786 ? t3 === 2691 || t3 === 2748 || !(t3 < 2750) && (t3 < 2753 || !(t3 < 2753) && (t3 < 2758 || !(t3 < 2759) && (t3 < 2761 || t3 === 2761 || !(t3 < 2763) && (t3 < 2765 || t3 === 2765)))) : t3 < 2788 || !(t3 < 2790) && (t3 < 2800 || !(t3 < 2810) && (t3 < 2816 || t3 === 2817 || !(t3 < 2818) && (t3 < 2820 || t3 === 2876 || t3 === 2878 || t3 === 2879 || t3 === 2880))) : t3 < 2946 ? !(t3 < 2881) && (t3 < 2885 || !(t3 < 2887) && (t3 < 2889 || !(t3 < 2891) && (t3 < 2893 || t3 === 2893 || t3 === 2902 || t3 === 2903 || !(t3 < 2914) && (t3 < 2916 || !(t3 < 2918) && t3 < 2928)))) : t3 === 2946 || !(t3 < 3006) && (t3 < 3008 || t3 === 3008 || !(t3 < 3009) && (t3 < 3011 || !(t3 < 3014) && (t3 < 3017 || !(t3 < 3018) && (t3 < 3021 || t3 === 3021 || t3 === 3031 || !(t3 < 3046) && t3 < 3056)))) : t3 < 3271 ? t3 < 3170 ? t3 === 3072 || !(t3 < 3073) && (t3 < 3076 || t3 === 3076 || !(t3 < 3134) && (t3 < 3137 || !(t3 < 3137) && (t3 < 3141 || !(t3 < 3142) && (t3 < 3145 || !(t3 < 3146) && (t3 < 3150 || !(t3 < 3157) && t3 < 3159))))) : t3 < 3172 || !(t3 < 3174) && (t3 < 3184 || t3 === 3201 || !(t3 < 3202) && (t3 < 3204 || t3 === 3260 || t3 === 3262 || t3 === 3263 || !(t3 < 3264) && (t3 < 3269 || t3 === 3270))) : t3 < 3387 ? !(t3 < 3271) && (t3 < 3273 || !(t3 < 3274) && (t3 < 3276 || !(t3 < 3276) && (t3 < 3278 || !(t3 < 3285) && (t3 < 3287 || !(t3 < 3298) && (t3 < 3300 || !(t3 < 3302) && (t3 < 3312 || !(t3 < 3328) && (t3 < 3330 || !(t3 < 3330) && t3 < 3332))))))) : t3 < 3389 || !(t3 < 3390) && (t3 < 3393 || !(t3 < 3393) && (t3 < 3397 || !(t3 < 3398) && (t3 < 3401 || !(t3 < 3402) && (t3 < 3405 || t3 === 3405 || t3 === 3415 || !(t3 < 3426) && (t3 < 3428 || !(t3 < 3430) && t3 < 3440))))) : t3 < 6112 ? t3 < 4152 ? t3 < 3864 ? t3 < 3633 ? !(t3 < 3458) && (t3 < 3460 || t3 === 3530 || !(t3 < 3535) && (t3 < 3538 || !(t3 < 3538) && (t3 < 3541 || t3 === 3542 || !(t3 < 3544) && (t3 < 3552 || !(t3 < 3558) && (t3 < 3568 || !(t3 < 3570) && t3 < 3572))))) : t3 === 3633 || !(t3 < 3636) && (t3 < 3643 || !(t3 < 3655) && (t3 < 3663 || !(t3 < 3664) && (t3 < 3674 || t3 === 3761 || !(t3 < 3764) && (t3 < 3770 || !(t3 < 3771) && (t3 < 3773 || !(t3 < 3784) && (t3 < 3790 || !(t3 < 3792) && t3 < 3802)))))) : t3 < 3968 ? !(t3 < 3864) && (t3 < 3866 || !(t3 < 3872) && (t3 < 3882 || t3 === 3893 || t3 === 3895 || t3 === 3897 || !(t3 < 3902) && (t3 < 3904 || !(t3 < 3953) && (t3 < 3967 || t3 === 3967)))) : t3 < 3973 || !(t3 < 3974) && (t3 < 3976 || !(t3 < 3981) && (t3 < 3992 || !(t3 < 3993) && (t3 < 4029 || t3 === 4038 || !(t3 < 4139) && (t3 < 4141 || !(t3 < 4141) && (t3 < 4145 || t3 === 4145 || !(t3 < 4146) && t3 < 4152))))) : t3 < 4240 ? t3 < 4194 ? t3 === 4152 || !(t3 < 4153) && (t3 < 4155 || !(t3 < 4155) && (t3 < 4157 || !(t3 < 4157) && (t3 < 4159 || !(t3 < 4160) && (t3 < 4170 || !(t3 < 4182) && (t3 < 4184 || !(t3 < 4184) && (t3 < 4186 || !(t3 < 4190) && t3 < 4193)))))) : t3 < 4197 || !(t3 < 4199) && (t3 < 4206 || !(t3 < 4209) && (t3 < 4213 || t3 === 4226 || !(t3 < 4227) && (t3 < 4229 || !(t3 < 4229) && (t3 < 4231 || !(t3 < 4231) && (t3 < 4237 || t3 === 4237 || t3 === 4239))))) : t3 < 6002 ? !(t3 < 4240) && (t3 < 4250 || !(t3 < 4250) && (t3 < 4253 || t3 === 4253 || !(t3 < 4957) && (t3 < 4960 || !(t3 < 4969) && (t3 < 4978 || !(t3 < 5906) && (t3 < 5909 || !(t3 < 5938) && (t3 < 5941 || !(t3 < 5970) && t3 < 5972)))))) : t3 < 6004 || !(t3 < 6068) && (t3 < 6070 || t3 === 6070 || !(t3 < 6071) && (t3 < 6078 || !(t3 < 6078) && (t3 < 6086 || t3 === 6086 || !(t3 < 6087) && (t3 < 6089 || !(t3 < 6089) && (t3 < 6100 || t3 === 6109))))) : t3 < 6916 ? t3 < 6683 ? t3 < 6448 ? !(t3 < 6112) && (t3 < 6122 || !(t3 < 6155) && (t3 < 6158 || !(t3 < 6160) && (t3 < 6170 || t3 === 6313 || !(t3 < 6432) && (t3 < 6435 || !(t3 < 6435) && (t3 < 6439 || !(t3 < 6439) && (t3 < 6441 || !(t3 < 6441) && t3 < 6444)))))) : t3 < 6450 || t3 === 6450 || !(t3 < 6451) && (t3 < 6457 || !(t3 < 6457) && (t3 < 6460 || !(t3 < 6470) && (t3 < 6480 || !(t3 < 6608) && (t3 < 6618 || t3 === 6618 || !(t3 < 6679) && (t3 < 6681 || !(t3 < 6681) && t3 < 6683))))) : t3 < 6755 ? t3 === 6683 || t3 === 6741 || t3 === 6742 || t3 === 6743 || !(t3 < 6744) && (t3 < 6751 || t3 === 6752 || t3 === 6753 || t3 === 6754) : t3 < 6757 || !(t3 < 6757) && (t3 < 6765 || !(t3 < 6765) && (t3 < 6771 || !(t3 < 6771) && (t3 < 6781 || t3 === 6783 || !(t3 < 6784) && (t3 < 6794 || !(t3 < 6800) && (t3 < 6810 || !(t3 < 6832) && (t3 < 6846 || !(t3 < 6912) && t3 < 6916)))))) : t3 < 7082 ? t3 < 6979 ? t3 === 6916 || t3 === 6964 || t3 === 6965 || !(t3 < 6966) && (t3 < 6971 || t3 === 6971 || t3 === 6972 || !(t3 < 6973) && (t3 < 6978 || t3 === 6978)) : t3 < 6981 || !(t3 < 6992) && (t3 < 7002 || !(t3 < 7019) && (t3 < 7028 || !(t3 < 7040) && (t3 < 7042 || t3 === 7042 || t3 === 7073 || !(t3 < 7074) && (t3 < 7078 || !(t3 < 7078) && (t3 < 7080 || !(t3 < 7080) && t3 < 7082))))) : t3 < 7150 ? t3 === 7082 || !(t3 < 7083) && (t3 < 7086 || !(t3 < 7088) && (t3 < 7098 || t3 === 7142 || t3 === 7143 || !(t3 < 7144) && (t3 < 7146 || !(t3 < 7146) && (t3 < 7149 || t3 === 7149)))) : t3 === 7150 || !(t3 < 7151) && (t3 < 7154 || !(t3 < 7154) && (t3 < 7156 || !(t3 < 7204) && (t3 < 7212 || !(t3 < 7212) && (t3 < 7220 || !(t3 < 7220) && (t3 < 7222 || !(t3 < 7222) && (t3 < 7224 || !(t3 < 7232) && (t3 < 7242 || !(t3 < 7248) && t3 < 7258))))))) : t3 < 70206 ? t3 < 43703 ? t3 < 43188 ? t3 < 11647 ? t3 < 7416 ? !(t3 < 7376) && (t3 < 7379 || !(t3 < 7380) && (t3 < 7393 || t3 === 7393 || !(t3 < 7394) && (t3 < 7401 || t3 === 7405 || !(t3 < 7410) && (t3 < 7412 || t3 === 7412 || t3 === 7415)))) : t3 < 7418 || !(t3 < 7616) && (t3 < 7674 || !(t3 < 7675) && (t3 < 7680 || !(t3 < 8255) && (t3 < 8257 || t3 === 8276 || !(t3 < 8400) && (t3 < 8413 || t3 === 8417 || !(t3 < 8421) && (t3 < 8433 || !(t3 < 11503) && t3 < 11506))))) : t3 < 42654 ? t3 === 11647 || !(t3 < 11744) && (t3 < 11776 || !(t3 < 12330) && (t3 < 12334 || !(t3 < 12334) && (t3 < 12336 || !(t3 < 12441) && (t3 < 12443 || !(t3 < 42528) && (t3 < 42538 || t3 === 42607 || !(t3 < 42612) && t3 < 42622))))) : t3 < 42656 || !(t3 < 42736) && (t3 < 42738 || t3 === 43010 || t3 === 43014 || t3 === 43019 || !(t3 < 43043) && (t3 < 43045 || !(t3 < 43045) && (t3 < 43047 || t3 === 43047 || !(t3 < 43136) && t3 < 43138))) : t3 < 43472 ? t3 < 43346 ? !(t3 < 43188) && (t3 < 43204 || !(t3 < 43204) && (t3 < 43206 || !(t3 < 43216) && (t3 < 43226 || !(t3 < 43232) && (t3 < 43250 || t3 === 43263 || !(t3 < 43264) && (t3 < 43274 || !(t3 < 43302) && (t3 < 43310 || !(t3 < 43335) && t3 < 43346)))))) : t3 < 43348 || !(t3 < 43392) && (t3 < 43395 || t3 === 43395 || t3 === 43443 || !(t3 < 43444) && (t3 < 43446 || !(t3 < 43446) && (t3 < 43450 || !(t3 < 43450) && (t3 < 43452 || t3 === 43452 || !(t3 < 43453) && t3 < 43457)))) : t3 < 43587 ? !(t3 < 43472) && (t3 < 43482 || t3 === 43493 || !(t3 < 43504) && (t3 < 43514 || !(t3 < 43561) && (t3 < 43567 || !(t3 < 43567) && (t3 < 43569 || !(t3 < 43569) && (t3 < 43571 || !(t3 < 43571) && (t3 < 43573 || !(t3 < 43573) && t3 < 43575)))))) : t3 === 43587 || t3 === 43596 || t3 === 43597 || !(t3 < 43600) && (t3 < 43610 || t3 === 43643 || t3 === 43644 || t3 === 43645 || t3 === 43696 || !(t3 < 43698) && t3 < 43701) : t3 < 68912 ? t3 < 65024 ? t3 < 44003 ? !(t3 < 43703) && (t3 < 43705 || !(t3 < 43710) && (t3 < 43712 || t3 === 43713 || t3 === 43755 || !(t3 < 43756) && (t3 < 43758 || !(t3 < 43758) && (t3 < 43760 || t3 === 43765 || t3 === 43766)))) : t3 < 44005 || t3 === 44005 || !(t3 < 44006) && (t3 < 44008 || t3 === 44008 || !(t3 < 44009) && (t3 < 44011 || t3 === 44012 || t3 === 44013 || !(t3 < 44016) && (t3 < 44026 || t3 === 64286))) : t3 < 66422 ? !(t3 < 65024) && (t3 < 65040 || !(t3 < 65056) && (t3 < 65072 || !(t3 < 65075) && (t3 < 65077 || !(t3 < 65101) && (t3 < 65104 || !(t3 < 65296) && (t3 < 65306 || t3 === 65343 || t3 === 66045 || t3 === 66272))))) : t3 < 66427 || !(t3 < 66720) && (t3 < 66730 || !(t3 < 68097) && (t3 < 68100 || !(t3 < 68101) && (t3 < 68103 || !(t3 < 68108) && (t3 < 68112 || !(t3 < 68152) && (t3 < 68155 || t3 === 68159 || !(t3 < 68325) && (t3 < 68327 || !(t3 < 68900) && t3 < 68904)))))) : t3 < 69933 ? t3 < 69762 ? !(t3 < 68912) && (t3 < 68922 || !(t3 < 69446) && (t3 < 69457 || t3 === 69632 || t3 === 69633 || t3 === 69634 || !(t3 < 69688) && (t3 < 69703 || !(t3 < 69734) && (t3 < 69744 || !(t3 < 69759) && t3 < 69762)))) : t3 === 69762 || !(t3 < 69808) && (t3 < 69811 || !(t3 < 69811) && (t3 < 69815 || !(t3 < 69815) && (t3 < 69817 || !(t3 < 69817) && (t3 < 69819 || !(t3 < 69872) && (t3 < 69882 || !(t3 < 69888) && (t3 < 69891 || !(t3 < 69927) && (t3 < 69932 || t3 === 69932))))))) : t3 < 70079 ? !(t3 < 69933) && (t3 < 69941 || !(t3 < 69942) && (t3 < 69952 || !(t3 < 69957) && (t3 < 69959 || t3 === 70003 || !(t3 < 70016) && (t3 < 70018 || t3 === 70018 || !(t3 < 70067) && (t3 < 70070 || !(t3 < 70070) && t3 < 70079))))) : t3 < 70081 || !(t3 < 70089) && (t3 < 70093 || !(t3 < 70096) && (t3 < 70106 || !(t3 < 70188) && (t3 < 70191 || !(t3 < 70191) && (t3 < 70194 || !(t3 < 70194) && (t3 < 70196 || t3 === 70196 || t3 === 70197 || !(t3 < 70198) && t3 < 70200))))) : t3 < 72243 ? t3 < 71087 ? t3 < 70709 ? t3 < 70462 ? t3 === 70206 || t3 === 70367 || !(t3 < 70368) && (t3 < 70371 || !(t3 < 70371) && (t3 < 70379 || !(t3 < 70384) && (t3 < 70394 || !(t3 < 70400) && (t3 < 70402 || !(t3 < 70402) && (t3 < 70404 || !(t3 < 70459) && t3 < 70461))))) : t3 < 70464 || t3 === 70464 || !(t3 < 70465) && (t3 < 70469 || !(t3 < 70471) && (t3 < 70473 || !(t3 < 70475) && (t3 < 70478 || t3 === 70487 || !(t3 < 70498) && (t3 < 70500 || !(t3 < 70502) && (t3 < 70509 || !(t3 < 70512) && t3 < 70517))))) : t3 < 70832 ? !(t3 < 70709) && (t3 < 70712 || !(t3 < 70712) && (t3 < 70720 || !(t3 < 70720) && (t3 < 70722 || !(t3 < 70722) && (t3 < 70725 || t3 === 70725 || t3 === 70726 || !(t3 < 70736) && (t3 < 70746 || t3 === 70750))))) : t3 < 70835 || !(t3 < 70835) && (t3 < 70841 || t3 === 70841 || t3 === 70842 || !(t3 < 70843) && (t3 < 70847 || !(t3 < 70847) && (t3 < 70849 || t3 === 70849 || !(t3 < 70850) && (t3 < 70852 || !(t3 < 70864) && t3 < 70874)))) : t3 < 71342 ? t3 < 71219 ? !(t3 < 71087) && (t3 < 71090 || !(t3 < 71090) && (t3 < 71094 || !(t3 < 71096) && (t3 < 71100 || !(t3 < 71100) && (t3 < 71102 || t3 === 71102 || !(t3 < 71103) && (t3 < 71105 || !(t3 < 71132) && (t3 < 71134 || !(t3 < 71216) && t3 < 71219)))))) : t3 < 71227 || !(t3 < 71227) && (t3 < 71229 || t3 === 71229 || t3 === 71230 || !(t3 < 71231) && (t3 < 71233 || !(t3 < 71248) && (t3 < 71258 || t3 === 71339 || t3 === 71340 || t3 === 71341))) : t3 < 71462 ? !(t3 < 71342) && (t3 < 71344 || !(t3 < 71344) && (t3 < 71350 || t3 === 71350 || t3 === 71351 || !(t3 < 71360) && (t3 < 71370 || !(t3 < 71453) && (t3 < 71456 || !(t3 < 71456) && (t3 < 71458 || !(t3 < 71458) && t3 < 71462))))) : t3 === 71462 || !(t3 < 71463) && (t3 < 71468 || !(t3 < 71472) && (t3 < 71482 || !(t3 < 71724) && (t3 < 71727 || !(t3 < 71727) && (t3 < 71736 || t3 === 71736 || !(t3 < 71737) && (t3 < 71739 || !(t3 < 71904) && (t3 < 71914 || !(t3 < 72193) && t3 < 72203)))))) : t3 < 73111 ? t3 < 72873 ? t3 < 72343 ? !(t3 < 72243) && (t3 < 72249 || t3 === 72249 || !(t3 < 72251) && (t3 < 72255 || t3 === 72263 || !(t3 < 72273) && (t3 < 72279 || !(t3 < 72279) && (t3 < 72281 || !(t3 < 72281) && (t3 < 72284 || !(t3 < 72330) && t3 < 72343))))) : t3 === 72343 || !(t3 < 72344) && (t3 < 72346 || t3 === 72751 || !(t3 < 72752) && (t3 < 72759 || !(t3 < 72760) && (t3 < 72766 || t3 === 72766 || t3 === 72767 || !(t3 < 72784) && (t3 < 72794 || !(t3 < 72850) && t3 < 72872)))) : t3 < 73020 ? t3 === 72873 || !(t3 < 72874) && (t3 < 72881 || t3 === 72881 || !(t3 < 72882) && (t3 < 72884 || t3 === 72884 || !(t3 < 72885) && (t3 < 72887 || !(t3 < 73009) && (t3 < 73015 || t3 === 73018)))) : t3 < 73022 || !(t3 < 73023) && (t3 < 73030 || t3 === 73031 || !(t3 < 73040) && (t3 < 73050 || !(t3 < 73098) && (t3 < 73103 || !(t3 < 73104) && (t3 < 73106 || !(t3 < 73107) && (t3 < 73109 || t3 === 73109 || t3 === 73110))))) : t3 < 119362 ? t3 < 94033 ? t3 === 73111 || !(t3 < 73120) && (t3 < 73130 || !(t3 < 73459) && (t3 < 73461 || !(t3 < 73461) && (t3 < 73463 || !(t3 < 92768) && (t3 < 92778 || !(t3 < 92912) && (t3 < 92917 || !(t3 < 92976) && (t3 < 92983 || !(t3 < 93008) && t3 < 93018)))))) : t3 < 94079 || !(t3 < 94095) && (t3 < 94099 || !(t3 < 113821) && (t3 < 113823 || !(t3 < 119141) && (t3 < 119143 || !(t3 < 119143) && (t3 < 119146 || !(t3 < 119149) && (t3 < 119155 || !(t3 < 119163) && (t3 < 119171 || !(t3 < 119173) && (t3 < 119180 || !(t3 < 119210) && t3 < 119214))))))) : t3 < 122880 ? !(t3 < 119362) && (t3 < 119365 || !(t3 < 120782) && (t3 < 120832 || !(t3 < 121344) && (t3 < 121399 || !(t3 < 121403) && (t3 < 121453 || t3 === 121461 || t3 === 121476 || !(t3 < 121499) && (t3 < 121504 || !(t3 < 121505) && t3 < 121520))))) : t3 < 122887 || !(t3 < 122888) && (t3 < 122905 || !(t3 < 122907) && (t3 < 122914 || !(t3 < 122915) && (t3 < 122917 || !(t3 < 122918) && (t3 < 122923 || !(t3 < 125136) && (t3 < 125143 || !(t3 < 125252) && (t3 < 125259 || !(t3 < 125264) && (t3 < 125274 || !(t3 < 917760) && t3 < 918e3)))))));
  }(e28))));
}
function sA(e28) {
  return e28 < 12449 ? e28 < 3776 ? e28 < 2613 ? e28 < 1765 ? e28 < 890 ? e28 < 660 ? e28 < 248 ? e28 === 170 || e28 === 181 || e28 === 186 || !(e28 < 192) && (e28 < 215 || !(e28 < 216) && e28 < 247) : e28 < 443 || e28 === 443 || !(e28 < 444) && (e28 < 448 || !(e28 < 448) && (e28 < 452 || !(e28 < 452) && e28 < 660)) : e28 < 748 ? e28 === 660 || !(e28 < 661) && (e28 < 688 || !(e28 < 688) && (e28 < 706 || !(e28 < 710) && (e28 < 722 || !(e28 < 736) && e28 < 741))) : e28 === 748 || e28 === 750 || !(e28 < 880) && (e28 < 884 || e28 === 884 || !(e28 < 886) && e28 < 888) : e28 < 1329 ? e28 < 908 ? e28 === 890 || !(e28 < 891) && (e28 < 894 || e28 === 895 || e28 === 902 || !(e28 < 904) && e28 < 907) : e28 === 908 || !(e28 < 910) && (e28 < 930 || !(e28 < 931) && (e28 < 1014 || !(e28 < 1015) && (e28 < 1154 || !(e28 < 1162) && e28 < 1328))) : e28 < 1568 ? !(e28 < 1329) && (e28 < 1367 || e28 === 1369 || !(e28 < 1376) && (e28 < 1417 || !(e28 < 1488) && (e28 < 1515 || !(e28 < 1519) && e28 < 1523))) : e28 < 1600 || e28 === 1600 || !(e28 < 1601) && (e28 < 1611 || !(e28 < 1646) && (e28 < 1648 || !(e28 < 1649) && (e28 < 1748 || e28 === 1749))) : e28 < 2384 ? e28 < 2042 ? e28 < 1810 ? !(e28 < 1765) && (e28 < 1767 || !(e28 < 1774) && (e28 < 1776 || !(e28 < 1786) && (e28 < 1789 || e28 === 1791 || e28 === 1808))) : e28 < 1840 || !(e28 < 1869) && (e28 < 1958 || e28 === 1969 || !(e28 < 1994) && (e28 < 2027 || !(e28 < 2036) && e28 < 2038)) : e28 < 2112 ? e28 === 2042 || !(e28 < 2048) && (e28 < 2070 || e28 === 2074 || e28 === 2084 || e28 === 2088) : e28 < 2137 || !(e28 < 2144) && (e28 < 2155 || !(e28 < 2208) && (e28 < 2229 || !(e28 < 2230) && (e28 < 2238 || !(e28 < 2308) && (e28 < 2362 || e28 === 2365)))) : e28 < 2493 ? e28 < 2447 ? e28 === 2384 || !(e28 < 2392) && (e28 < 2402 || e28 === 2417 || !(e28 < 2418) && (e28 < 2433 || !(e28 < 2437) && e28 < 2445)) : e28 < 2449 || !(e28 < 2451) && (e28 < 2473 || !(e28 < 2474) && (e28 < 2481 || e28 === 2482 || !(e28 < 2486) && e28 < 2490)) : e28 < 2556 ? e28 === 2493 || e28 === 2510 || !(e28 < 2524) && (e28 < 2526 || !(e28 < 2527) && (e28 < 2530 || !(e28 < 2544) && e28 < 2546)) : e28 === 2556 || !(e28 < 2565) && (e28 < 2571 || !(e28 < 2575) && (e28 < 2577 || !(e28 < 2579) && (e28 < 2601 || !(e28 < 2602) && (e28 < 2609 || !(e28 < 2610) && e28 < 2612)))) : e28 < 3168 ? e28 < 2877 ? e28 < 2741 ? e28 < 2693 ? !(e28 < 2613) && (e28 < 2615 || !(e28 < 2616) && (e28 < 2618 || !(e28 < 2649) && (e28 < 2653 || e28 === 2654 || !(e28 < 2674) && e28 < 2677))) : e28 < 2702 || !(e28 < 2703) && (e28 < 2706 || !(e28 < 2707) && (e28 < 2729 || !(e28 < 2730) && (e28 < 2737 || !(e28 < 2738) && e28 < 2740))) : e28 < 2821 ? !(e28 < 2741) && (e28 < 2746 || e28 === 2749 || e28 === 2768 || !(e28 < 2784) && (e28 < 2786 || e28 === 2809)) : e28 < 2829 || !(e28 < 2831) && (e28 < 2833 || !(e28 < 2835) && (e28 < 2857 || !(e28 < 2858) && (e28 < 2865 || !(e28 < 2866) && (e28 < 2868 || !(e28 < 2869) && e28 < 2874)))) : e28 < 2974 ? e28 < 2949 ? e28 === 2877 || !(e28 < 2908) && (e28 < 2910 || !(e28 < 2911) && (e28 < 2914 || e28 === 2929 || e28 === 2947)) : e28 < 2955 || !(e28 < 2958) && (e28 < 2961 || !(e28 < 2962) && (e28 < 2966 || !(e28 < 2969) && (e28 < 2971 || e28 === 2972))) : e28 < 3077 ? !(e28 < 2974) && (e28 < 2976 || !(e28 < 2979) && (e28 < 2981 || !(e28 < 2984) && (e28 < 2987 || !(e28 < 2990) && (e28 < 3002 || e28 === 3024)))) : e28 < 3085 || !(e28 < 3086) && (e28 < 3089 || !(e28 < 3090) && (e28 < 3113 || !(e28 < 3114) && (e28 < 3130 || e28 === 3133 || !(e28 < 3160) && e28 < 3163))) : e28 < 3507 ? e28 < 3313 ? e28 < 3242 ? !(e28 < 3168) && (e28 < 3170 || e28 === 3200 || !(e28 < 3205) && (e28 < 3213 || !(e28 < 3214) && (e28 < 3217 || !(e28 < 3218) && e28 < 3241))) : e28 < 3252 || !(e28 < 3253) && (e28 < 3258 || e28 === 3261 || e28 === 3294 || !(e28 < 3296) && e28 < 3298) : e28 < 3406 ? !(e28 < 3313) && (e28 < 3315 || !(e28 < 3333) && (e28 < 3341 || !(e28 < 3342) && (e28 < 3345 || !(e28 < 3346) && (e28 < 3387 || e28 === 3389)))) : e28 === 3406 || !(e28 < 3412) && (e28 < 3415 || !(e28 < 3423) && (e28 < 3426 || !(e28 < 3450) && (e28 < 3456 || !(e28 < 3461) && (e28 < 3479 || !(e28 < 3482) && e28 < 3506)))) : e28 < 3722 ? e28 < 3648 ? !(e28 < 3507) && (e28 < 3516 || e28 === 3517 || !(e28 < 3520) && (e28 < 3527 || !(e28 < 3585) && (e28 < 3633 || !(e28 < 3634) && e28 < 3636))) : e28 < 3654 || e28 === 3654 || !(e28 < 3713) && (e28 < 3715 || e28 === 3716 || !(e28 < 3719) && e28 < 3721) : e28 < 3749 ? e28 === 3722 || e28 === 3725 || !(e28 < 3732) && (e28 < 3736 || !(e28 < 3737) && (e28 < 3744 || !(e28 < 3745) && e28 < 3748)) : e28 === 3749 || e28 === 3751 || !(e28 < 3754) && (e28 < 3756 || !(e28 < 3757) && (e28 < 3761 || !(e28 < 3762) && (e28 < 3764 || e28 === 3773))) : e28 < 7401 ? e28 < 5743 ? e28 < 4349 ? e28 < 4186 ? e28 < 3913 ? !(e28 < 3776) && (e28 < 3781 || e28 === 3782 || !(e28 < 3804) && (e28 < 3808 || e28 === 3840 || !(e28 < 3904) && e28 < 3912)) : e28 < 3949 || !(e28 < 3976) && (e28 < 3981 || !(e28 < 4096) && (e28 < 4139 || e28 === 4159 || !(e28 < 4176) && e28 < 4182)) : e28 < 4238 ? !(e28 < 4186) && (e28 < 4190 || e28 === 4193 || !(e28 < 4197) && (e28 < 4199 || !(e28 < 4206) && (e28 < 4209 || !(e28 < 4213) && e28 < 4226))) : e28 === 4238 || !(e28 < 4256) && (e28 < 4294 || e28 === 4295 || e28 === 4301 || !(e28 < 4304) && (e28 < 4347 || e28 === 4348)) : e28 < 4792 ? e28 < 4698 ? !(e28 < 4349) && (e28 < 4352 || !(e28 < 4352) && (e28 < 4681 || !(e28 < 4682) && (e28 < 4686 || !(e28 < 4688) && (e28 < 4695 || e28 === 4696)))) : e28 < 4702 || !(e28 < 4704) && (e28 < 4745 || !(e28 < 4746) && (e28 < 4750 || !(e28 < 4752) && (e28 < 4785 || !(e28 < 4786) && e28 < 4790))) : e28 < 4882 ? !(e28 < 4792) && (e28 < 4799 || e28 === 4800 || !(e28 < 4802) && (e28 < 4806 || !(e28 < 4808) && (e28 < 4823 || !(e28 < 4824) && e28 < 4881))) : e28 < 4886 || !(e28 < 4888) && (e28 < 4955 || !(e28 < 4992) && (e28 < 5008 || !(e28 < 5024) && (e28 < 5110 || !(e28 < 5112) && (e28 < 5118 || !(e28 < 5121) && e28 < 5741)))) : e28 < 6320 ? e28 < 5998 ? e28 < 5888 ? !(e28 < 5743) && (e28 < 5760 || !(e28 < 5761) && (e28 < 5787 || !(e28 < 5792) && (e28 < 5867 || !(e28 < 5870) && (e28 < 5873 || !(e28 < 5873) && e28 < 5881)))) : e28 < 5901 || !(e28 < 5902) && (e28 < 5906 || !(e28 < 5920) && (e28 < 5938 || !(e28 < 5952) && (e28 < 5970 || !(e28 < 5984) && e28 < 5997))) : e28 < 6211 ? !(e28 < 5998) && (e28 < 6001 || !(e28 < 6016) && (e28 < 6068 || e28 === 6103 || e28 === 6108 || !(e28 < 6176) && e28 < 6211)) : e28 === 6211 || !(e28 < 6212) && (e28 < 6265 || !(e28 < 6272) && (e28 < 6277 || !(e28 < 6277) && (e28 < 6279 || !(e28 < 6279) && (e28 < 6313 || e28 === 6314)))) : e28 < 6981 ? e28 < 6576 ? !(e28 < 6320) && (e28 < 6390 || !(e28 < 6400) && (e28 < 6431 || !(e28 < 6480) && (e28 < 6510 || !(e28 < 6512) && (e28 < 6517 || !(e28 < 6528) && e28 < 6572)))) : e28 < 6602 || !(e28 < 6656) && (e28 < 6679 || !(e28 < 6688) && (e28 < 6741 || e28 === 6823 || !(e28 < 6917) && e28 < 6964)) : e28 < 7245 ? !(e28 < 6981) && (e28 < 6988 || !(e28 < 7043) && (e28 < 7073 || !(e28 < 7086) && (e28 < 7088 || !(e28 < 7098) && (e28 < 7142 || !(e28 < 7168) && e28 < 7204)))) : e28 < 7248 || !(e28 < 7258) && (e28 < 7288 || !(e28 < 7288) && (e28 < 7294 || !(e28 < 7296) && (e28 < 7305 || !(e28 < 7312) && (e28 < 7355 || !(e28 < 7357) && e28 < 7360)))) : e28 < 8495 ? e28 < 8130 ? e28 < 7960 ? e28 < 7531 ? !(e28 < 7401) && (e28 < 7405 || !(e28 < 7406) && (e28 < 7410 || !(e28 < 7413) && (e28 < 7415 || !(e28 < 7424) && (e28 < 7468 || !(e28 < 7468) && e28 < 7531)))) : e28 < 7544 || e28 === 7544 || !(e28 < 7545) && (e28 < 7579 || !(e28 < 7579) && (e28 < 7616 || !(e28 < 7680) && e28 < 7958)) : e28 < 8027 ? !(e28 < 7960) && (e28 < 7966 || !(e28 < 7968) && (e28 < 8006 || !(e28 < 8008) && (e28 < 8014 || !(e28 < 8016) && (e28 < 8024 || e28 === 8025)))) : e28 === 8027 || e28 === 8029 || !(e28 < 8031) && (e28 < 8062 || !(e28 < 8064) && (e28 < 8117 || !(e28 < 8118) && (e28 < 8125 || e28 === 8126))) : e28 < 8450 ? e28 < 8178 ? !(e28 < 8130) && (e28 < 8133 || !(e28 < 8134) && (e28 < 8141 || !(e28 < 8144) && (e28 < 8148 || !(e28 < 8150) && (e28 < 8156 || !(e28 < 8160) && e28 < 8173)))) : e28 < 8181 || !(e28 < 8182) && (e28 < 8189 || e28 === 8305 || e28 === 8319 || !(e28 < 8336) && e28 < 8349) : e28 < 8473 ? e28 === 8450 || e28 === 8455 || !(e28 < 8458) && (e28 < 8468 || e28 === 8469 || e28 === 8472) : e28 < 8478 || e28 === 8484 || e28 === 8486 || e28 === 8488 || !(e28 < 8490) && (e28 < 8494 || e28 === 8494) : e28 < 11648 ? e28 < 11312 ? e28 < 8526 ? !(e28 < 8495) && (e28 < 8501 || !(e28 < 8501) && (e28 < 8505 || e28 === 8505 || !(e28 < 8508) && (e28 < 8512 || !(e28 < 8517) && e28 < 8522))) : e28 === 8526 || !(e28 < 8544) && (e28 < 8579 || !(e28 < 8579) && (e28 < 8581 || !(e28 < 8581) && (e28 < 8585 || !(e28 < 11264) && e28 < 11311))) : e28 < 11506 ? !(e28 < 11312) && (e28 < 11359 || !(e28 < 11360) && (e28 < 11388 || !(e28 < 11388) && (e28 < 11390 || !(e28 < 11390) && (e28 < 11493 || !(e28 < 11499) && e28 < 11503)))) : e28 < 11508 || !(e28 < 11520) && (e28 < 11558 || e28 === 11559 || e28 === 11565 || !(e28 < 11568) && (e28 < 11624 || e28 === 11631)) : e28 < 12294 ? e28 < 11712 ? !(e28 < 11648) && (e28 < 11671 || !(e28 < 11680) && (e28 < 11687 || !(e28 < 11688) && (e28 < 11695 || !(e28 < 11696) && (e28 < 11703 || !(e28 < 11704) && e28 < 11711)))) : e28 < 11719 || !(e28 < 11720) && (e28 < 11727 || !(e28 < 11728) && (e28 < 11735 || !(e28 < 11736) && (e28 < 11743 || e28 === 12293))) : e28 < 12347 ? e28 === 12294 || e28 === 12295 || !(e28 < 12321) && (e28 < 12330 || !(e28 < 12337) && (e28 < 12342 || !(e28 < 12344) && e28 < 12347)) : e28 === 12347 || e28 === 12348 || !(e28 < 12353) && (e28 < 12439 || !(e28 < 12443) && (e28 < 12445 || !(e28 < 12445) && (e28 < 12447 || e28 === 12447))) : e28 < 68448 ? e28 < 55216 ? e28 < 43138 ? e28 < 42623 ? e28 < 40981 ? e28 < 12704 ? !(e28 < 12449) && (e28 < 12539 || !(e28 < 12540) && (e28 < 12543 || e28 === 12543 || !(e28 < 12549) && (e28 < 12592 || !(e28 < 12593) && e28 < 12687))) : e28 < 12731 || !(e28 < 12784) && (e28 < 12800 || !(e28 < 13312) && (e28 < 19894 || !(e28 < 19968) && (e28 < 40944 || !(e28 < 40960) && e28 < 40981))) : e28 < 42508 ? e28 === 40981 || !(e28 < 40982) && (e28 < 42125 || !(e28 < 42192) && (e28 < 42232 || !(e28 < 42232) && (e28 < 42238 || !(e28 < 42240) && e28 < 42508))) : e28 === 42508 || !(e28 < 42512) && (e28 < 42528 || !(e28 < 42538) && (e28 < 42540 || !(e28 < 42560) && (e28 < 42606 || e28 === 42606))) : e28 < 42891 ? e28 < 42775 ? e28 === 42623 || !(e28 < 42624) && (e28 < 42652 || !(e28 < 42652) && (e28 < 42654 || !(e28 < 42656) && (e28 < 42726 || !(e28 < 42726) && e28 < 42736))) : e28 < 42784 || !(e28 < 42786) && (e28 < 42864 || e28 === 42864 || !(e28 < 42865) && (e28 < 42888 || e28 === 42888)) : e28 < 43002 ? !(e28 < 42891) && (e28 < 42895 || e28 === 42895 || !(e28 < 42896) && (e28 < 42938 || e28 === 42999 || !(e28 < 43e3) && e28 < 43002)) : e28 === 43002 || !(e28 < 43003) && (e28 < 43010 || !(e28 < 43011) && (e28 < 43014 || !(e28 < 43015) && (e28 < 43019 || !(e28 < 43020) && (e28 < 43043 || !(e28 < 43072) && e28 < 43124)))) : e28 < 43697 ? e28 < 43494 ? e28 < 43312 ? !(e28 < 43138) && (e28 < 43188 || !(e28 < 43250) && (e28 < 43256 || e28 === 43259 || !(e28 < 43261) && (e28 < 43263 || !(e28 < 43274) && e28 < 43302))) : e28 < 43335 || !(e28 < 43360) && (e28 < 43389 || !(e28 < 43396) && (e28 < 43443 || e28 === 43471 || !(e28 < 43488) && e28 < 43493)) : e28 < 43588 ? e28 === 43494 || !(e28 < 43495) && (e28 < 43504 || !(e28 < 43514) && (e28 < 43519 || !(e28 < 43520) && (e28 < 43561 || !(e28 < 43584) && e28 < 43587))) : e28 < 43596 || !(e28 < 43616) && (e28 < 43632 || e28 === 43632 || !(e28 < 43633) && (e28 < 43639 || e28 === 43642 || !(e28 < 43646) && e28 < 43696)) : e28 < 43777 ? e28 < 43739 ? e28 === 43697 || !(e28 < 43701) && (e28 < 43703 || !(e28 < 43705) && (e28 < 43710 || e28 === 43712 || e28 === 43714)) : e28 < 43741 || e28 === 43741 || !(e28 < 43744) && (e28 < 43755 || e28 === 43762 || !(e28 < 43763) && e28 < 43765) : e28 < 43824 ? !(e28 < 43777) && (e28 < 43783 || !(e28 < 43785) && (e28 < 43791 || !(e28 < 43793) && (e28 < 43799 || !(e28 < 43808) && (e28 < 43815 || !(e28 < 43816) && e28 < 43823)))) : e28 < 43867 || !(e28 < 43868) && (e28 < 43872 || !(e28 < 43872) && (e28 < 43878 || !(e28 < 43888) && (e28 < 43968 || !(e28 < 43968) && (e28 < 44003 || !(e28 < 44032) && e28 < 55204)))) : e28 < 66349 ? e28 < 65345 ? e28 < 64318 ? e28 < 64275 ? !(e28 < 55216) && (e28 < 55239 || !(e28 < 55243) && (e28 < 55292 || !(e28 < 63744) && (e28 < 64110 || !(e28 < 64112) && (e28 < 64218 || !(e28 < 64256) && e28 < 64263)))) : e28 < 64280 || e28 === 64285 || !(e28 < 64287) && (e28 < 64297 || !(e28 < 64298) && (e28 < 64311 || !(e28 < 64312) && e28 < 64317)) : e28 < 64848 ? e28 === 64318 || !(e28 < 64320) && (e28 < 64322 || !(e28 < 64323) && (e28 < 64325 || !(e28 < 64326) && (e28 < 64434 || !(e28 < 64467) && e28 < 64830))) : e28 < 64912 || !(e28 < 64914) && (e28 < 64968 || !(e28 < 65008) && (e28 < 65020 || !(e28 < 65136) && (e28 < 65141 || !(e28 < 65142) && (e28 < 65277 || !(e28 < 65313) && e28 < 65339)))) : e28 < 65536 ? e28 < 65440 ? !(e28 < 65345) && (e28 < 65371 || !(e28 < 65382) && (e28 < 65392 || e28 === 65392 || !(e28 < 65393) && (e28 < 65438 || !(e28 < 65438) && e28 < 65440))) : e28 < 65471 || !(e28 < 65474) && (e28 < 65480 || !(e28 < 65482) && (e28 < 65488 || !(e28 < 65490) && (e28 < 65496 || !(e28 < 65498) && e28 < 65501))) : e28 < 65616 ? !(e28 < 65536) && (e28 < 65548 || !(e28 < 65549) && (e28 < 65575 || !(e28 < 65576) && (e28 < 65595 || !(e28 < 65596) && (e28 < 65598 || !(e28 < 65599) && e28 < 65614)))) : e28 < 65630 || !(e28 < 65664) && (e28 < 65787 || !(e28 < 65856) && (e28 < 65909 || !(e28 < 66176) && (e28 < 66205 || !(e28 < 66208) && (e28 < 66257 || !(e28 < 66304) && e28 < 66336)))) : e28 < 67639 ? e28 < 66640 ? e28 < 66432 ? !(e28 < 66349) && (e28 < 66369 || e28 === 66369 || !(e28 < 66370) && (e28 < 66378 || e28 === 66378 || !(e28 < 66384) && e28 < 66422)) : e28 < 66462 || !(e28 < 66464) && (e28 < 66500 || !(e28 < 66504) && (e28 < 66512 || !(e28 < 66513) && (e28 < 66518 || !(e28 < 66560) && e28 < 66640))) : e28 < 67072 ? !(e28 < 66640) && (e28 < 66718 || !(e28 < 66736) && (e28 < 66772 || !(e28 < 66776) && (e28 < 66812 || !(e28 < 66816) && (e28 < 66856 || !(e28 < 66864) && e28 < 66916)))) : e28 < 67383 || !(e28 < 67392) && (e28 < 67414 || !(e28 < 67424) && (e28 < 67432 || !(e28 < 67584) && (e28 < 67590 || e28 === 67592 || !(e28 < 67594) && e28 < 67638))) : e28 < 68030 ? e28 < 67808 ? !(e28 < 67639) && (e28 < 67641 || e28 === 67644 || !(e28 < 67647) && (e28 < 67670 || !(e28 < 67680) && (e28 < 67703 || !(e28 < 67712) && e28 < 67743))) : e28 < 67827 || !(e28 < 67828) && (e28 < 67830 || !(e28 < 67840) && (e28 < 67862 || !(e28 < 67872) && (e28 < 67898 || !(e28 < 67968) && e28 < 68024))) : e28 < 68192 ? !(e28 < 68030) && (e28 < 68032 || e28 === 68096 || !(e28 < 68112) && (e28 < 68116 || !(e28 < 68117) && (e28 < 68120 || !(e28 < 68121) && e28 < 68150))) : e28 < 68221 || !(e28 < 68224) && (e28 < 68253 || !(e28 < 68288) && (e28 < 68296 || !(e28 < 68297) && (e28 < 68325 || !(e28 < 68352) && (e28 < 68406 || !(e28 < 68416) && e28 < 68438)))) : e28 < 93760 ? e28 < 71040 ? e28 < 70163 ? e28 < 69763 ? e28 < 68864 ? !(e28 < 68448) && (e28 < 68467 || !(e28 < 68480) && (e28 < 68498 || !(e28 < 68608) && (e28 < 68681 || !(e28 < 68736) && (e28 < 68787 || !(e28 < 68800) && e28 < 68851)))) : e28 < 68900 || !(e28 < 69376) && (e28 < 69405 || e28 === 69415 || !(e28 < 69424) && (e28 < 69446 || !(e28 < 69635) && e28 < 69688)) : e28 < 70006 ? !(e28 < 69763) && (e28 < 69808 || !(e28 < 69840) && (e28 < 69865 || !(e28 < 69891) && (e28 < 69927 || e28 === 69956 || !(e28 < 69968) && e28 < 70003))) : e28 === 70006 || !(e28 < 70019) && (e28 < 70067 || !(e28 < 70081) && (e28 < 70085 || e28 === 70106 || e28 === 70108 || !(e28 < 70144) && e28 < 70162)) : e28 < 70442 ? e28 < 70303 ? !(e28 < 70163) && (e28 < 70188 || !(e28 < 70272) && (e28 < 70279 || e28 === 70280 || !(e28 < 70282) && (e28 < 70286 || !(e28 < 70287) && e28 < 70302))) : e28 < 70313 || !(e28 < 70320) && (e28 < 70367 || !(e28 < 70405) && (e28 < 70413 || !(e28 < 70415) && (e28 < 70417 || !(e28 < 70419) && e28 < 70441))) : e28 < 70493 ? !(e28 < 70442) && (e28 < 70449 || !(e28 < 70450) && (e28 < 70452 || !(e28 < 70453) && (e28 < 70458 || e28 === 70461 || e28 === 70480))) : e28 < 70498 || !(e28 < 70656) && (e28 < 70709 || !(e28 < 70727) && (e28 < 70731 || !(e28 < 70784) && (e28 < 70832 || !(e28 < 70852) && (e28 < 70854 || e28 === 70855)))) : e28 < 72960 ? e28 < 72203 ? e28 < 71424 ? !(e28 < 71040) && (e28 < 71087 || !(e28 < 71128) && (e28 < 71132 || !(e28 < 71168) && (e28 < 71216 || e28 === 71236 || !(e28 < 71296) && e28 < 71339))) : e28 < 71451 || !(e28 < 71680) && (e28 < 71724 || !(e28 < 71840) && (e28 < 71904 || e28 === 71935 || e28 === 72192)) : e28 < 72349 ? !(e28 < 72203) && (e28 < 72243 || e28 === 72250 || e28 === 72272 || !(e28 < 72284) && (e28 < 72324 || !(e28 < 72326) && e28 < 72330)) : e28 === 72349 || !(e28 < 72384) && (e28 < 72441 || !(e28 < 72704) && (e28 < 72713 || !(e28 < 72714) && (e28 < 72751 || e28 === 72768 || !(e28 < 72818) && e28 < 72848))) : e28 < 74752 ? e28 < 73063 ? !(e28 < 72960) && (e28 < 72967 || !(e28 < 72968) && (e28 < 72970 || !(e28 < 72971) && (e28 < 73009 || e28 === 73030 || !(e28 < 73056) && e28 < 73062))) : e28 < 73065 || !(e28 < 73066) && (e28 < 73098 || e28 === 73112 || !(e28 < 73440) && (e28 < 73459 || !(e28 < 73728) && e28 < 74650)) : e28 < 92736 ? !(e28 < 74752) && (e28 < 74863 || !(e28 < 74880) && (e28 < 75076 || !(e28 < 77824) && (e28 < 78895 || !(e28 < 82944) && (e28 < 83527 || !(e28 < 92160) && e28 < 92729)))) : e28 < 92767 || !(e28 < 92880) && (e28 < 92910 || !(e28 < 92928) && (e28 < 92976 || !(e28 < 92992) && (e28 < 92996 || !(e28 < 93027) && (e28 < 93048 || !(e28 < 93053) && e28 < 93072)))) : e28 < 120772 ? e28 < 119997 ? e28 < 113776 ? e28 < 94208 ? !(e28 < 93760) && (e28 < 93824 || !(e28 < 93952) && (e28 < 94021 || e28 === 94032 || !(e28 < 94099) && (e28 < 94112 || !(e28 < 94176) && e28 < 94178))) : e28 < 100338 || !(e28 < 100352) && (e28 < 101107 || !(e28 < 110592) && (e28 < 110879 || !(e28 < 110960) && (e28 < 111356 || !(e28 < 113664) && e28 < 113771))) : e28 < 119966 ? !(e28 < 113776) && (e28 < 113789 || !(e28 < 113792) && (e28 < 113801 || !(e28 < 113808) && (e28 < 113818 || !(e28 < 119808) && (e28 < 119893 || !(e28 < 119894) && e28 < 119965)))) : e28 < 119968 || e28 === 119970 || !(e28 < 119973) && (e28 < 119975 || !(e28 < 119977) && (e28 < 119981 || !(e28 < 119982) && (e28 < 119994 || e28 === 119995))) : e28 < 120146 ? e28 < 120094 ? !(e28 < 119997) && (e28 < 120004 || !(e28 < 120005) && (e28 < 120070 || !(e28 < 120071) && (e28 < 120075 || !(e28 < 120077) && (e28 < 120085 || !(e28 < 120086) && e28 < 120093)))) : e28 < 120122 || !(e28 < 120123) && (e28 < 120127 || !(e28 < 120128) && (e28 < 120133 || e28 === 120134 || !(e28 < 120138) && e28 < 120145)) : e28 < 120598 ? !(e28 < 120146) && (e28 < 120486 || !(e28 < 120488) && (e28 < 120513 || !(e28 < 120514) && (e28 < 120539 || !(e28 < 120540) && (e28 < 120571 || !(e28 < 120572) && e28 < 120597)))) : e28 < 120629 || !(e28 < 120630) && (e28 < 120655 || !(e28 < 120656) && (e28 < 120687 || !(e28 < 120688) && (e28 < 120713 || !(e28 < 120714) && (e28 < 120745 || !(e28 < 120746) && e28 < 120771)))) : e28 < 126555 ? e28 < 126521 ? e28 < 126497 ? !(e28 < 120772) && (e28 < 120780 || !(e28 < 124928) && (e28 < 125125 || !(e28 < 125184) && (e28 < 125252 || !(e28 < 126464) && (e28 < 126468 || !(e28 < 126469) && e28 < 126496)))) : e28 < 126499 || e28 === 126500 || e28 === 126503 || !(e28 < 126505) && (e28 < 126515 || !(e28 < 126516) && e28 < 126520) : e28 < 126539 ? e28 === 126521 || e28 === 126523 || e28 === 126530 || e28 === 126535 || e28 === 126537 : e28 === 126539 || !(e28 < 126541) && (e28 < 126544 || !(e28 < 126545) && (e28 < 126547 || e28 === 126548 || e28 === 126551 || e28 === 126553)) : e28 < 126592 ? e28 < 126567 ? e28 === 126555 || e28 === 126557 || e28 === 126559 || !(e28 < 126561) && (e28 < 126563 || e28 === 126564) : e28 < 126571 || !(e28 < 126572) && (e28 < 126579 || !(e28 < 126580) && (e28 < 126584 || !(e28 < 126585) && (e28 < 126589 || e28 === 126590))) : e28 < 131072 ? !(e28 < 126592) && (e28 < 126602 || !(e28 < 126603) && (e28 < 126620 || !(e28 < 126625) && (e28 < 126628 || !(e28 < 126629) && (e28 < 126634 || !(e28 < 126635) && e28 < 126652)))) : e28 < 173783 || !(e28 < 173824) && (e28 < 177973 || !(e28 < 177984) && (e28 < 178206 || !(e28 < 178208) && (e28 < 183970 || !(e28 < 183984) && (e28 < 191457 || !(e28 < 194560) && e28 < 195102))));
}
var va$3 = { $LONE: /* @__PURE__ */ new Set(["ASCII", "ASCII_Hex_Digit", "AHex", "Alphabetic", "Alpha", "Any", "Assigned", "Bidi_Control", "Bidi_C", "Bidi_Mirrored", "Bidi_M", "Case_Ignorable", "CI", "Cased", "Changes_When_Casefolded", "CWCF", "Changes_When_Casemapped", "CWCM", "Changes_When_Lowercased", "CWL", "Changes_When_NFKC_Casefolded", "CWKCF", "Changes_When_Titlecased", "CWT", "Changes_When_Uppercased", "CWU", "Dash", "Default_Ignorable_Code_Point", "DI", "Deprecated", "Dep", "Diacritic", "Dia", "Emoji", "Emoji_Component", "Emoji_Modifier", "Emoji_Modifier_Base", "Emoji_Presentation", "Extender", "Ext", "Grapheme_Base", "Gr_Base", "Grapheme_Extend", "Gr_Ext", "Hex_Digit", "Hex", "IDS_Binary_Operator", "IDSB", "IDS_Trinary_Operator", "IDST", "ID_Continue", "IDC", "ID_Start", "IDS", "Ideographic", "Ideo", "Join_Control", "Join_C", "Logical_Order_Exception", "LOE", "Lowercase", "Lower", "Math", "Noncharacter_Code_Point", "NChar", "Pattern_Syntax", "Pat_Syn", "Pattern_White_Space", "Pat_WS", "Quotation_Mark", "QMark", "Radical", "Regional_Indicator", "RI", "Sentence_Terminal", "STerm", "Soft_Dotted", "SD", "Terminal_Punctuation", "Term", "Unified_Ideograph", "UIdeo", "Uppercase", "Upper", "Variation_Selector", "VS", "White_Space", "space", "XID_Continue", "XIDC", "XID_Start", "XIDS"]), General_Category: /* @__PURE__ */ new Set(["Cased_Letter", "LC", "Close_Punctuation", "Pe", "Connector_Punctuation", "Pc", "Control", "Cc", "cntrl", "Currency_Symbol", "Sc", "Dash_Punctuation", "Pd", "Decimal_Number", "Nd", "digit", "Enclosing_Mark", "Me", "Final_Punctuation", "Pf", "Format", "Cf", "Initial_Punctuation", "Pi", "Letter", "L", "Letter_Number", "Nl", "Line_Separator", "Zl", "Lowercase_Letter", "Ll", "Mark", "M", "Combining_Mark", "Math_Symbol", "Sm", "Modifier_Letter", "Lm", "Modifier_Symbol", "Sk", "Nonspacing_Mark", "Mn", "Number", "N", "Open_Punctuation", "Ps", "Other", "C", "Other_Letter", "Lo", "Other_Number", "No", "Other_Punctuation", "Po", "Other_Symbol", "So", "Paragraph_Separator", "Zp", "Private_Use", "Co", "Punctuation", "P", "punct", "Separator", "Z", "Space_Separator", "Zs", "Spacing_Mark", "Mc", "Surrogate", "Cs", "Symbol", "S", "Titlecase_Letter", "Lt", "Unassigned", "Cn", "Uppercase_Letter", "Lu"]), Script: /* @__PURE__ */ new Set(["Adlam", "Adlm", "Ahom", "Anatolian_Hieroglyphs", "Hluw", "Arabic", "Arab", "Armenian", "Armn", "Avestan", "Avst", "Balinese", "Bali", "Bamum", "Bamu", "Bassa_Vah", "Bass", "Batak", "Batk", "Bengali", "Beng", "Bhaiksuki", "Bhks", "Bopomofo", "Bopo", "Brahmi", "Brah", "Braille", "Brai", "Buginese", "Bugi", "Buhid", "Buhd", "Canadian_Aboriginal", "Cans", "Carian", "Cari", "Caucasian_Albanian", "Aghb", "Chakma", "Cakm", "Cham", "Cherokee", "Cher", "Common", "Zyyy", "Coptic", "Copt", "Qaac", "Cuneiform", "Xsux", "Cypriot", "Cprt", "Cyrillic", "Cyrl", "Deseret", "Dsrt", "Devanagari", "Deva", "Duployan", "Dupl", "Egyptian_Hieroglyphs", "Egyp", "Elbasan", "Elba", "Ethiopic", "Ethi", "Georgian", "Geor", "Glagolitic", "Glag", "Gothic", "Goth", "Grantha", "Gran", "Greek", "Grek", "Gujarati", "Gujr", "Gurmukhi", "Guru", "Han", "Hani", "Hangul", "Hang", "Hanunoo", "Hano", "Hatran", "Hatr", "Hebrew", "Hebr", "Hiragana", "Hira", "Imperial_Aramaic", "Armi", "Inherited", "Zinh", "Qaai", "Inscriptional_Pahlavi", "Phli", "Inscriptional_Parthian", "Prti", "Javanese", "Java", "Kaithi", "Kthi", "Kannada", "Knda", "Katakana", "Kana", "Kayah_Li", "Kali", "Kharoshthi", "Khar", "Khmer", "Khmr", "Khojki", "Khoj", "Khudawadi", "Sind", "Lao", "Laoo", "Latin", "Latn", "Lepcha", "Lepc", "Limbu", "Limb", "Linear_A", "Lina", "Linear_B", "Linb", "Lisu", "Lycian", "Lyci", "Lydian", "Lydi", "Mahajani", "Mahj", "Malayalam", "Mlym", "Mandaic", "Mand", "Manichaean", "Mani", "Marchen", "Marc", "Masaram_Gondi", "Gonm", "Meetei_Mayek", "Mtei", "Mende_Kikakui", "Mend", "Meroitic_Cursive", "Merc", "Meroitic_Hieroglyphs", "Mero", "Miao", "Plrd", "Modi", "Mongolian", "Mong", "Mro", "Mroo", "Multani", "Mult", "Myanmar", "Mymr", "Nabataean", "Nbat", "New_Tai_Lue", "Talu", "Newa", "Nko", "Nkoo", "Nushu", "Nshu", "Ogham", "Ogam", "Ol_Chiki", "Olck", "Old_Hungarian", "Hung", "Old_Italic", "Ital", "Old_North_Arabian", "Narb", "Old_Permic", "Perm", "Old_Persian", "Xpeo", "Old_South_Arabian", "Sarb", "Old_Turkic", "Orkh", "Oriya", "Orya", "Osage", "Osge", "Osmanya", "Osma", "Pahawh_Hmong", "Hmng", "Palmyrene", "Palm", "Pau_Cin_Hau", "Pauc", "Phags_Pa", "Phag", "Phoenician", "Phnx", "Psalter_Pahlavi", "Phlp", "Rejang", "Rjng", "Runic", "Runr", "Samaritan", "Samr", "Saurashtra", "Saur", "Sharada", "Shrd", "Shavian", "Shaw", "Siddham", "Sidd", "SignWriting", "Sgnw", "Sinhala", "Sinh", "Sora_Sompeng", "Sora", "Soyombo", "Soyo", "Sundanese", "Sund", "Syloti_Nagri", "Sylo", "Syriac", "Syrc", "Tagalog", "Tglg", "Tagbanwa", "Tagb", "Tai_Le", "Tale", "Tai_Tham", "Lana", "Tai_Viet", "Tavt", "Takri", "Takr", "Tamil", "Taml", "Tangut", "Tang", "Telugu", "Telu", "Thaana", "Thaa", "Thai", "Tibetan", "Tibt", "Tifinagh", "Tfng", "Tirhuta", "Tirh", "Ugaritic", "Ugar", "Vai", "Vaii", "Warang_Citi", "Wara", "Yi", "Yiii", "Zanabazar_Square", "Zanb"]) };
va$3.gc = va$3.General_Category, va$3.sc = va$3.Script_Extensions = va$3.scx = va$3.Script;
var uA = 10, cA = 13, tc$1 = 36, xs$1 = 40, bs$1 = 41, gp = 42, a0 = 43, o0 = 46, Xa$2 = 48, KP = 55, zp = 57, ga$1 = 63, Hp = 65, lA = 70, JP = 90, Kp = 95, Jp = 97, ug = 102, QP = 122, zu$1 = 91, gr$1 = 92, Es$1 = 93, yp = 94, Hu$1 = 123, s0 = 124, Ku$1 = 125, XP = 8204, YP = 8205, ZP = 8232, eI = 8233, tI = 0, nI = 1114111;
function pA(e28) {
  return e28 >= Hp && e28 <= JP || e28 >= Jp && e28 <= QP;
}
function Hl(e28) {
  return e28 >= Xa$2 && e28 <= zp;
}
function Wb$1(e28) {
  return e28 >= Xa$2 && e28 <= zp || e28 >= Hp && e28 <= lA || e28 >= Jp && e28 <= ug;
}
function rI(e28) {
  return e28 === uA || e28 === cA || e28 === ZP || e28 === eI;
}
function zd$1(e28) {
  return e28 >= Jp && e28 <= ug ? e28 - Jp + 10 : e28 >= Hp && e28 <= lA ? e28 - Hp + 10 : e28 - Xa$2;
}
var $b$1 = { at: function(e28, t3, n3) {
  return n3 < t3 ? e28.charCodeAt(n3) : -1;
}, width: function(e28) {
  return 1;
} }, iI = { at: function(e28, t3, n3) {
  return n3 < t3 ? e28.codePointAt(n3) : -1;
}, width: function(e28) {
  return e28 > 65535 ? 2 : 1;
} }, aI = function() {
  function e28() {
    We$1(this, e28), this._impl = $b$1, this._s = "", this._i = 0, this._end = 0, this._cp1 = -1, this._w1 = 1, this._cp2 = -1, this._w2 = 1, this._cp3 = -1, this._w3 = 1, this._cp4 = -1;
  }
  return Xe$1(e28, [{ key: "reset", value: function(t3, n3, r3, i) {
    this._impl = i ? iI : $b$1, this._s = t3, this._end = r3, this.rewind(n3);
  } }, { key: "rewind", value: function(t3) {
    var n3 = this._impl;
    this._i = t3, this._cp1 = n3.at(this._s, this._end, t3), this._w1 = n3.width(this._cp1), this._cp2 = n3.at(this._s, this._end, t3 + this._w1), this._w2 = n3.width(this._cp2), this._cp3 = n3.at(this._s, this._end, t3 + this._w1 + this._w2), this._w3 = n3.width(this._cp3), this._cp4 = n3.at(this._s, this._end, t3 + this._w1 + this._w2 + this._w3);
  } }, { key: "advance", value: function() {
    if (this._cp1 !== -1) {
      var t3 = this._impl;
      this._i += this._w1, this._cp1 = this._cp2, this._w1 = this._w2, this._cp2 = this._cp3, this._w2 = t3.width(this._cp2), this._cp3 = this._cp4, this._w3 = t3.width(this._cp3), this._cp4 = t3.at(this._s, this._end, this._i + this._w1 + this._w2 + this._w3);
    }
  } }, { key: "eat", value: function(t3) {
    return this._cp1 === t3 && (this.advance(), true);
  } }, { key: "eat2", value: function(t3, n3) {
    return this._cp1 === t3 && this._cp2 === n3 && (this.advance(), this.advance(), true);
  } }, { key: "eat3", value: function(t3, n3, r3) {
    return this._cp1 === t3 && this._cp2 === n3 && this._cp3 === r3 && (this.advance(), this.advance(), this.advance(), true);
  } }, { key: "source", get: function() {
    return this._s;
  } }, { key: "index", get: function() {
    return this._i;
  } }, { key: "currentCodePoint", get: function() {
    return this._cp1;
  } }, { key: "nextCodePoint", get: function() {
    return this._cp2;
  } }, { key: "nextCodePoint2", get: function() {
    return this._cp3;
  } }, { key: "nextCodePoint3", get: function() {
    return this._cp4;
  } }]), e28;
}(), oI = function(e28) {
  function t3(n3, r3, i, a3) {
    var s3;
    return We$1(this, t3), n3 && (n3[0] !== "/" && (n3 = "/".concat(n3, "/").concat(r3 ? "u" : "")), n3 = ": ".concat(n3)), (s3 = Gt$3(this, rt$2(t3).call(this, "Invalid regular expression".concat(n3, ": ").concat(a3)))).index = i, s3;
  }
  return $t$3(t3, eE(SyntaxError)), t3;
}();
function Gb$1(e28) {
  return e28 === yp || e28 === tc$1 || e28 === gr$1 || e28 === o0 || e28 === gp || e28 === a0 || e28 === ga$1 || e28 === xs$1 || e28 === bs$1 || e28 === zu$1 || e28 === Es$1 || e28 === Hu$1 || e28 === Ku$1 || e28 === s0;
}
function sI(e28) {
  return function(t3) {
    return !(t3 < 65) && (t3 < 91 || !(t3 < 97) && (t3 < 123 || sA(t3)));
  }(e28) || e28 === tc$1 || e28 === Kp;
}
function zb$1(e28) {
  return pA(e28) || e28 === Kp;
}
function Hb$1(e28, t3) {
  return va$3.hasOwnProperty(e28) && va$3[e28].has(t3);
}
var u0 = function() {
  function e28(t3) {
    We$1(this, e28), this._reader = new aI(), this._uFlag = false, this._nFlag = false, this._lastIntValue = 0, this._lastMinValue = 0, this._lastMaxValue = 0, this._lastStrValue = "", this._lastKeyValue = "", this._lastValValue = "", this._lastAssertionIsQuantifiable = false, this._numCapturingParens = 0, this._groupNames = /* @__PURE__ */ new Set(), this._backreferenceNames = /* @__PURE__ */ new Set(), this._options = t3 || {};
  }
  return Xe$1(e28, [{ key: "validateLiteral", value: function(t3) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t3.length;
    if (this._uFlag = this._nFlag = false, this.reset(t3, n3, r3), this.onLiteralEnter(n3), this.eat(47) && this.eatRegExpBody() && this.eat(47)) {
      var i = this.index, a3 = t3.indexOf("u", i) !== -1;
      this.validateFlags(t3, i, r3), this.validatePattern(t3, n3 + 1, i - 1, a3);
    } else if (n3 >= r3)
      this.raise("Empty");
    else {
      var s3 = String.fromCodePoint(this.currentCodePoint);
      this.raise("Unexpected character '".concat(s3, "'"));
    }
    this.onLiteralLeave(n3, r3);
  } }, { key: "validateFlags", value: function(t3) {
    for (var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t3.length, i = /* @__PURE__ */ new Set(), a3 = false, s3 = false, o3 = false, u3 = false, c3 = false, f3 = false, p3 = n3; p3 < r3; ++p3) {
      var d3 = t3.charCodeAt(p3);
      i.has(d3) && this.raise("Duplicated flag '".concat(t3[p3], "'")), i.add(d3), d3 === 103 ? a3 = true : d3 === 105 ? s3 = true : d3 === 109 ? o3 = true : d3 === 117 && this.ecmaVersion >= 2015 ? c3 = true : d3 === 121 && this.ecmaVersion >= 2015 ? u3 = true : d3 === 115 && this.ecmaVersion >= 2018 ? f3 = true : this.raise("Invalid flag '".concat(t3[p3], "'"));
    }
    this.onFlags(n3, r3, a3, s3, o3, c3, u3, f3);
  } }, { key: "validatePattern", value: function(t3) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t3.length, i = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
    this._uFlag = i && this.ecmaVersion >= 2015, this._nFlag = i && this.ecmaVersion >= 2018, this.reset(t3, n3, r3), this.pattern(), !this._nFlag && this.ecmaVersion >= 2018 && this._groupNames.size > 0 && (this._nFlag = true, this.rewind(n3), this.pattern());
  } }, { key: "onLiteralEnter", value: function(t3) {
    this._options.onLiteralEnter && this._options.onLiteralEnter(t3);
  } }, { key: "onLiteralLeave", value: function(t3, n3) {
    this._options.onLiteralLeave && this._options.onLiteralLeave(t3, n3);
  } }, { key: "onFlags", value: function(t3, n3, r3, i, a3, s3, o3, u3) {
    this._options.onFlags && this._options.onFlags(t3, n3, r3, i, a3, s3, o3, u3);
  } }, { key: "onPatternEnter", value: function(t3) {
    this._options.onPatternEnter && this._options.onPatternEnter(t3);
  } }, { key: "onPatternLeave", value: function(t3, n3) {
    this._options.onPatternLeave && this._options.onPatternLeave(t3, n3);
  } }, { key: "onDisjunctionEnter", value: function(t3) {
    this._options.onDisjunctionEnter && this._options.onDisjunctionEnter(t3);
  } }, { key: "onDisjunctionLeave", value: function(t3, n3) {
    this._options.onDisjunctionLeave && this._options.onDisjunctionLeave(t3, n3);
  } }, { key: "onAlternativeEnter", value: function(t3, n3) {
    this._options.onAlternativeEnter && this._options.onAlternativeEnter(t3, n3);
  } }, { key: "onAlternativeLeave", value: function(t3, n3, r3) {
    this._options.onAlternativeLeave && this._options.onAlternativeLeave(t3, n3, r3);
  } }, { key: "onGroupEnter", value: function(t3) {
    this._options.onGroupEnter && this._options.onGroupEnter(t3);
  } }, { key: "onGroupLeave", value: function(t3, n3) {
    this._options.onGroupLeave && this._options.onGroupLeave(t3, n3);
  } }, { key: "onCapturingGroupEnter", value: function(t3, n3) {
    this._options.onCapturingGroupEnter && this._options.onCapturingGroupEnter(t3, n3);
  } }, { key: "onCapturingGroupLeave", value: function(t3, n3, r3) {
    this._options.onCapturingGroupLeave && this._options.onCapturingGroupLeave(t3, n3, r3);
  } }, { key: "onQuantifier", value: function(t3, n3, r3, i, a3) {
    this._options.onQuantifier && this._options.onQuantifier(t3, n3, r3, i, a3);
  } }, { key: "onLookaroundAssertionEnter", value: function(t3, n3, r3) {
    this._options.onLookaroundAssertionEnter && this._options.onLookaroundAssertionEnter(t3, n3, r3);
  } }, { key: "onLookaroundAssertionLeave", value: function(t3, n3, r3, i) {
    this._options.onLookaroundAssertionLeave && this._options.onLookaroundAssertionLeave(t3, n3, r3, i);
  } }, { key: "onEdgeAssertion", value: function(t3, n3, r3) {
    this._options.onEdgeAssertion && this._options.onEdgeAssertion(t3, n3, r3);
  } }, { key: "onWordBoundaryAssertion", value: function(t3, n3, r3, i) {
    this._options.onWordBoundaryAssertion && this._options.onWordBoundaryAssertion(t3, n3, r3, i);
  } }, { key: "onAnyCharacterSet", value: function(t3, n3, r3) {
    this._options.onAnyCharacterSet && this._options.onAnyCharacterSet(t3, n3, r3);
  } }, { key: "onEscapeCharacterSet", value: function(t3, n3, r3, i) {
    this._options.onEscapeCharacterSet && this._options.onEscapeCharacterSet(t3, n3, r3, i);
  } }, { key: "onUnicodePropertyCharacterSet", value: function(t3, n3, r3, i, a3, s3) {
    this._options.onUnicodePropertyCharacterSet && this._options.onUnicodePropertyCharacterSet(t3, n3, r3, i, a3, s3);
  } }, { key: "onCharacter", value: function(t3, n3, r3) {
    this._options.onCharacter && this._options.onCharacter(t3, n3, r3);
  } }, { key: "onBackreference", value: function(t3, n3, r3) {
    this._options.onBackreference && this._options.onBackreference(t3, n3, r3);
  } }, { key: "onCharacterClassEnter", value: function(t3, n3) {
    this._options.onCharacterClassEnter && this._options.onCharacterClassEnter(t3, n3);
  } }, { key: "onCharacterClassLeave", value: function(t3, n3, r3) {
    this._options.onCharacterClassLeave && this._options.onCharacterClassLeave(t3, n3, r3);
  } }, { key: "onCharacterClassRange", value: function(t3, n3, r3, i) {
    this._options.onCharacterClassRange && this._options.onCharacterClassRange(t3, n3, r3, i);
  } }, { key: "reset", value: function(t3, n3, r3) {
    this._reader.reset(t3, n3, r3, this._uFlag);
  } }, { key: "rewind", value: function(t3) {
    this._reader.rewind(t3);
  } }, { key: "advance", value: function() {
    this._reader.advance();
  } }, { key: "eat", value: function(t3) {
    return this._reader.eat(t3);
  } }, { key: "eat2", value: function(t3, n3) {
    return this._reader.eat2(t3, n3);
  } }, { key: "eat3", value: function(t3, n3, r3) {
    return this._reader.eat3(t3, n3, r3);
  } }, { key: "raise", value: function(t3) {
    throw new oI(this.source, this._uFlag, this.index, t3);
  } }, { key: "eatRegExpBody", value: function() {
    for (var t3 = this.index, n3 = false, r3 = false; ; ) {
      var i = this.currentCodePoint;
      if (i === -1 || rI(i)) {
        var a3 = n3 ? "character class" : "regular expression";
        this.raise("Unterminated ".concat(a3));
      }
      if (r3)
        r3 = false;
      else if (i === gr$1)
        r3 = true;
      else if (i === zu$1)
        n3 = true;
      else if (i === Es$1)
        n3 = false;
      else if (i === 47 && !n3 || i === gp && this.index === t3)
        break;
      this.advance();
    }
    return this.index !== t3;
  } }, { key: "pattern", value: function() {
    var t3 = this.index;
    this._numCapturingParens = this.countCapturingParens(), this._groupNames.clear(), this._backreferenceNames.clear(), this.onPatternEnter(t3), this.disjunction();
    var n3 = this.currentCodePoint;
    if (this.currentCodePoint !== -1) {
      n3 === bs$1 && this.raise("Unmatched ')'"), n3 === gr$1 && this.raise("\\ at end of pattern"), n3 !== Es$1 && n3 !== Ku$1 || this.raise("Lone quantifier brackets");
      var r3 = String.fromCodePoint(n3);
      this.raise("Unexpected character '".concat(r3, "'"));
    }
    var i = true, a3 = false, s3 = void 0;
    try {
      for (var o3, u3 = this._backreferenceNames[Symbol.iterator](); !(i = (o3 = u3.next()).done); i = true) {
        var c3 = o3.value;
        this._groupNames.has(c3) || this.raise("Invalid named capture referenced");
      }
    } catch (f3) {
      a3 = true, s3 = f3;
    } finally {
      try {
        i || u3.return == null || u3.return();
      } finally {
        if (a3)
          throw s3;
      }
    }
    this.onPatternLeave(t3, this.index);
  } }, { key: "countCapturingParens", value: function() {
    for (var t3 = this.index, n3 = false, r3 = false, i = 0, a3 = 0; (a3 = this.currentCodePoint) !== -1; )
      r3 ? r3 = false : a3 === gr$1 ? r3 = true : a3 === zu$1 ? n3 = true : a3 === Es$1 ? n3 = false : a3 !== xs$1 || n3 || this.nextCodePoint === ga$1 && (this.nextCodePoint2 !== 60 || this.nextCodePoint3 === 61 || this.nextCodePoint3 === 33) || (i += 1), this.advance();
    return this.rewind(t3), i;
  } }, { key: "disjunction", value: function() {
    var t3 = this.index, n3 = 0;
    for (this.onDisjunctionEnter(t3), this.alternative(n3++); this.eat(s0); )
      this.alternative(n3++);
    this.eatQuantifier(true) && this.raise("Nothing to repeat"), this.eat(Hu$1) && this.raise("Lone quantifier brackets"), this.onDisjunctionLeave(t3, this.index);
  } }, { key: "alternative", value: function(t3) {
    var n3 = this.index;
    for (this.onAlternativeEnter(n3, t3); this.currentCodePoint !== -1 && this.eatTerm(); )
      ;
    this.onAlternativeLeave(n3, this.index, t3);
  } }, { key: "eatTerm", value: function() {
    return this.eatAssertion() ? (this._lastAssertionIsQuantifiable && this.eatQuantifier(), true) : !(this.strict ? !this.eatAtom() : !this.eatExtendedAtom()) && (this.eatQuantifier(), true);
  } }, { key: "eatAssertion", value: function() {
    var t3 = this.index;
    if (this._lastAssertionIsQuantifiable = false, this.eat(yp))
      return this.onEdgeAssertion(t3, this.index, "start"), true;
    if (this.eat(tc$1))
      return this.onEdgeAssertion(t3, this.index, "end"), true;
    if (this.eat2(gr$1, 66))
      return this.onWordBoundaryAssertion(t3, this.index, "word", true), true;
    if (this.eat2(gr$1, 98))
      return this.onWordBoundaryAssertion(t3, this.index, "word", false), true;
    if (this.eat2(xs$1, ga$1)) {
      var n3 = this.ecmaVersion >= 2018 && this.eat(60), r3 = false;
      if (this.eat(61) || (r3 = this.eat(33))) {
        var i = n3 ? "lookbehind" : "lookahead";
        return this.onLookaroundAssertionEnter(t3, i, r3), this.disjunction(), this.eat(bs$1) || this.raise("Unterminated group"), this._lastAssertionIsQuantifiable = !n3 && !this.strict, this.onLookaroundAssertionLeave(t3, this.index, i, r3), true;
      }
      this.rewind(t3);
    }
    return false;
  } }, { key: "eatQuantifier", value: function() {
    var t3 = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], n3 = this.index, r3 = 0, i = 0, a3 = false;
    if (this.eat(gp))
      r3 = 0, i = Number.POSITIVE_INFINITY;
    else if (this.eat(a0))
      r3 = 1, i = Number.POSITIVE_INFINITY;
    else if (this.eat(ga$1))
      r3 = 0, i = 1;
    else {
      if (!this.eatBracedQuantifier(t3))
        return false;
      r3 = this._lastMinValue, i = this._lastMaxValue;
    }
    return a3 = !this.eat(ga$1), t3 || this.onQuantifier(n3, this.index, r3, i, a3), true;
  } }, { key: "eatBracedQuantifier", value: function(t3) {
    var n3 = this.index;
    if (this.eat(Hu$1)) {
      if (this._lastMinValue = 0, this._lastMaxValue = Number.POSITIVE_INFINITY, this.eatDecimalDigits() && (this._lastMinValue = this._lastMaxValue = this._lastIntValue, this.eat(44) && (this._lastMaxValue = this.eatDecimalDigits() ? this._lastIntValue : Number.POSITIVE_INFINITY), this.eat(Ku$1)))
        return !t3 && this._lastMaxValue < this._lastMinValue && this.raise("numbers out of order in {} quantifier"), true;
      !t3 && this.strict && this.raise("Incomplete quantifier"), this.rewind(n3);
    }
    return false;
  } }, { key: "eatAtom", value: function() {
    return this.eatPatternCharacter() || this.eatDot() || this.eatReverseSolidusAtomEscape() || this.eatCharacterClass() || this.eatUncapturingGroup() || this.eatCapturingGroup();
  } }, { key: "eatDot", value: function() {
    return !!this.eat(o0) && (this.onAnyCharacterSet(this.index - 1, this.index, "any"), true);
  } }, { key: "eatReverseSolidusAtomEscape", value: function() {
    var t3 = this.index;
    if (this.eat(gr$1)) {
      if (this.eatAtomEscape())
        return true;
      this.rewind(t3);
    }
    return false;
  } }, { key: "eatUncapturingGroup", value: function() {
    var t3 = this.index;
    return !!this.eat3(xs$1, ga$1, 58) && (this.onGroupEnter(t3), this.disjunction(), this.eat(bs$1) || this.raise("Unterminated group"), this.onGroupLeave(t3, this.index), true);
  } }, { key: "eatCapturingGroup", value: function() {
    var t3 = this.index;
    if (this.eat(xs$1)) {
      this._lastStrValue = "", this.ecmaVersion >= 2018 ? this.groupSpecifier() : this.currentCodePoint === ga$1 && this.raise("Invalid group");
      var n3 = this._lastStrValue || null;
      return this.onCapturingGroupEnter(t3, n3), this.disjunction(), this.eat(bs$1) || this.raise("Unterminated group"), this.onCapturingGroupLeave(t3, this.index, n3), true;
    }
    return false;
  } }, { key: "eatExtendedAtom", value: function() {
    return this.eatDot() || this.eatReverseSolidusAtomEscape() || this.eatReverseSolidusFollowedByC() || this.eatCharacterClass() || this.eatUncapturingGroup() || this.eatCapturingGroup() || this.eatInvalidBracedQuantifier() || this.eatExtendedPatternCharacter();
  } }, { key: "eatReverseSolidusFollowedByC", value: function() {
    return this.currentCodePoint === gr$1 && this.nextCodePoint === 99 && (this._lastIntValue = this.currentCodePoint, this.advance(), this.onCharacter(this.index - 1, this.index, gr$1), true);
  } }, { key: "eatInvalidBracedQuantifier", value: function() {
    return this.eatBracedQuantifier(true) && this.raise("Nothing to repeat"), false;
  } }, { key: "eatSyntaxCharacter", value: function() {
    return !!Gb$1(this.currentCodePoint) && (this._lastIntValue = this.currentCodePoint, this.advance(), true);
  } }, { key: "eatPatternCharacter", value: function() {
    var t3 = this.index, n3 = this.currentCodePoint;
    return n3 !== -1 && !Gb$1(n3) && (this.advance(), this.onCharacter(t3, this.index, n3), true);
  } }, { key: "eatExtendedPatternCharacter", value: function() {
    var t3 = this.index, n3 = this.currentCodePoint;
    return n3 !== -1 && n3 !== yp && n3 !== tc$1 && n3 !== gr$1 && n3 !== o0 && n3 !== gp && n3 !== a0 && n3 !== ga$1 && n3 !== xs$1 && n3 !== bs$1 && n3 !== zu$1 && n3 !== s0 && (this.advance(), this.onCharacter(t3, this.index, n3), true);
  } }, { key: "groupSpecifier", value: function() {
    if (this._lastStrValue = "", this.eat(ga$1)) {
      if (this.eatGroupName()) {
        if (!this._groupNames.has(this._lastStrValue))
          return void this._groupNames.add(this._lastStrValue);
        this.raise("Duplicate capture group name");
      }
      this.raise("Invalid group");
    }
  } }, { key: "eatGroupName", value: function() {
    if (this._lastStrValue = "", this.eat(60)) {
      if (this.eatRegExpIdentifierName() && this.eat(62))
        return true;
      this.raise("Invalid capture group name");
    }
    return false;
  } }, { key: "eatRegExpIdentifierName", value: function() {
    if (this._lastStrValue = "", this.eatRegExpIdentifierStart()) {
      for (this._lastStrValue += String.fromCodePoint(this._lastIntValue); this.eatRegExpIdentifierPart(); )
        this._lastStrValue += String.fromCodePoint(this._lastIntValue);
      return true;
    }
    return false;
  } }, { key: "eatRegExpIdentifierStart", value: function() {
    var t3 = this.index, n3 = this.currentCodePoint;
    return this.advance(), n3 === gr$1 && this.eatRegExpUnicodeEscapeSequence() && (n3 = this._lastIntValue), sI(n3) ? (this._lastIntValue = n3, true) : (this.index !== t3 && this.rewind(t3), false);
  } }, { key: "eatRegExpIdentifierPart", value: function() {
    var t3 = this.index, n3 = this.currentCodePoint;
    return this.advance(), n3 === gr$1 && this.eatRegExpUnicodeEscapeSequence() && (n3 = this._lastIntValue), function(r3) {
      return qb$1(r3) || r3 === tc$1 || r3 === Kp || r3 === XP || r3 === YP;
    }(n3) ? (this._lastIntValue = n3, true) : (this.index !== t3 && this.rewind(t3), false);
  } }, { key: "eatAtomEscape", value: function() {
    return !!(this.eatBackreference() || this.eatCharacterClassEscape() || this.eatCharacterEscape() || this._nFlag && this.eatKGroupName()) || ((this.strict || this._uFlag) && this.raise("Invalid escape"), false);
  } }, { key: "eatBackreference", value: function() {
    var t3 = this.index;
    if (this.eatDecimalEscape()) {
      var n3 = this._lastIntValue;
      if (n3 <= this._numCapturingParens)
        return this.onBackreference(t3 - 1, this.index, n3), true;
      this.strict && this.raise("Invalid escape"), this.rewind(t3);
    }
    return false;
  } }, { key: "eatKGroupName", value: function() {
    var t3 = this.index;
    if (this.eat(107)) {
      if (this.eatGroupName()) {
        var n3 = this._lastStrValue;
        return this._backreferenceNames.add(n3), this.onBackreference(t3 - 1, this.index, n3), true;
      }
      this.raise("Invalid named reference");
    }
    return false;
  } }, { key: "eatCharacterEscape", value: function() {
    var t3 = this.index;
    return !!(this.eatControlEscape() || this.eatCControlLetter() || this.eatZero() || this.eatHexEscapeSequence() || this.eatRegExpUnicodeEscapeSequence() || !this.strict && this.eatLegacyOctalEscapeSequence() || this.eatIdentityEscape()) && (this.onCharacter(t3 - 1, this.index, this._lastIntValue), true);
  } }, { key: "eatCControlLetter", value: function() {
    var t3 = this.index;
    if (this.eat(99)) {
      if (this.eatControlLetter())
        return true;
      this.rewind(t3);
    }
    return false;
  } }, { key: "eatZero", value: function() {
    return this.currentCodePoint === Xa$2 && !Hl(this.nextCodePoint) && (this._lastIntValue = 0, this.advance(), true);
  } }, { key: "eatControlEscape", value: function() {
    return this.eat(116) ? (this._lastIntValue = 9, true) : this.eat(110) ? (this._lastIntValue = uA, true) : this.eat(118) ? (this._lastIntValue = 11, true) : this.eat(ug) ? (this._lastIntValue = 12, true) : !!this.eat(114) && (this._lastIntValue = cA, true);
  } }, { key: "eatControlLetter", value: function() {
    var t3 = this.currentCodePoint;
    return !!pA(t3) && (this.advance(), this._lastIntValue = t3 % 32, true);
  } }, { key: "eatRegExpUnicodeEscapeSequence", value: function() {
    var t3 = this.index;
    if (this.eat(117)) {
      if (this.eatFixedHexDigits(4)) {
        var n3 = this._lastIntValue;
        if (this._uFlag && n3 >= 55296 && n3 <= 56319) {
          var r3 = this.index;
          if (this.eat(gr$1) && this.eat(117) && this.eatFixedHexDigits(4)) {
            var i = this._lastIntValue;
            if (i >= 56320 && i <= 57343)
              return this._lastIntValue = 1024 * (n3 - 55296) + (i - 56320) + 65536, true;
          }
          this.rewind(r3), this._lastIntValue = n3;
        }
        return true;
      }
      if (this._uFlag && this.eat(Hu$1) && this.eatHexDigits() && this.eat(Ku$1) && function(a3) {
        return a3 >= tI && a3 <= nI;
      }(this._lastIntValue))
        return true;
      (this.strict || this._uFlag) && this.raise("Invalid unicode escape"), this.rewind(t3);
    }
    return false;
  } }, { key: "eatIdentityEscape", value: function() {
    return this._uFlag ? !!this.eatSyntaxCharacter() || !!this.eat(47) && (this._lastIntValue = 47, true) : !!this.isValidIdentityEscape(this.currentCodePoint) && (this._lastIntValue = this.currentCodePoint, this.advance(), true);
  } }, { key: "isValidIdentityEscape", value: function(t3) {
    return t3 !== -1 && (this.strict ? !qb$1(t3) : t3 !== 99 && (!this._nFlag || t3 !== 107));
  } }, { key: "eatDecimalEscape", value: function() {
    this._lastIntValue = 0;
    var t3 = this.currentCodePoint;
    if (t3 >= 49 && t3 <= zp) {
      do
        this._lastIntValue = 10 * this._lastIntValue + (t3 - Xa$2), this.advance();
      while ((t3 = this.currentCodePoint) >= Xa$2 && t3 <= zp);
      return true;
    }
    return false;
  } }, { key: "eatCharacterClassEscape", value: function() {
    var t3 = this.index;
    if (this.eat(100))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(t3 - 1, this.index, "digit", false), true;
    if (this.eat(68))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(t3 - 1, this.index, "digit", true), true;
    if (this.eat(115))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(t3 - 1, this.index, "space", false), true;
    if (this.eat(83))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(t3 - 1, this.index, "space", true), true;
    if (this.eat(119))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(t3 - 1, this.index, "word", false), true;
    if (this.eat(87))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(t3 - 1, this.index, "word", true), true;
    var n3 = false;
    if (this._uFlag && this.ecmaVersion >= 2018 && (this.eat(112) || (n3 = this.eat(80)))) {
      if (this._lastIntValue = -1, this.eat(Hu$1) && this.eatUnicodePropertyValueExpression() && this.eat(Ku$1))
        return this.onUnicodePropertyCharacterSet(t3 - 1, this.index, "property", this._lastKeyValue, this._lastValValue || null, n3), true;
      this.raise("Invalid property name");
    }
    return false;
  } }, { key: "eatUnicodePropertyValueExpression", value: function() {
    var t3 = this.index;
    if (this.eatUnicodePropertyName() && this.eat(61) && (this._lastKeyValue = this._lastStrValue, this.eatUnicodePropertyValue())) {
      if (this._lastValValue = this._lastStrValue, Hb$1(this._lastKeyValue, this._lastValValue))
        return true;
      this.raise("Invalid property name");
    }
    if (this.rewind(t3), this.eatLoneUnicodePropertyNameOrValue()) {
      var n3 = this._lastStrValue;
      if (Hb$1("General_Category", n3))
        return this._lastKeyValue = "General_Category", this._lastValValue = n3, true;
      if (function(r3) {
        return va$3.$LONE.has(r3);
      }(n3))
        return this._lastKeyValue = n3, this._lastValValue = "", true;
      this.raise("Invalid property name");
    }
    return false;
  } }, { key: "eatUnicodePropertyName", value: function() {
    for (this._lastStrValue = ""; zb$1(this.currentCodePoint); )
      this._lastStrValue += String.fromCodePoint(this.currentCodePoint), this.advance();
    return this._lastStrValue !== "";
  } }, { key: "eatUnicodePropertyValue", value: function() {
    for (this._lastStrValue = ""; zb$1(t3 = this.currentCodePoint) || Hl(t3); )
      this._lastStrValue += String.fromCodePoint(this.currentCodePoint), this.advance();
    var t3;
    return this._lastStrValue !== "";
  } }, { key: "eatLoneUnicodePropertyNameOrValue", value: function() {
    return this.eatUnicodePropertyValue();
  } }, { key: "eatCharacterClass", value: function() {
    var t3 = this.index;
    if (this.eat(zu$1)) {
      var n3 = this.eat(yp);
      return this.onCharacterClassEnter(t3, n3), this.classRanges(), this.eat(Es$1) || this.raise("Unterminated character class"), this.onCharacterClassLeave(t3, this.index, n3), true;
    }
    return false;
  } }, { key: "classRanges", value: function() {
    for (var t3 = this.index; this.eatClassAtom(); ) {
      var n3 = this._lastIntValue, r3 = this.index;
      if (this.eat(45) && (this.onCharacter(r3, this.index, 45), this.eatClassAtom())) {
        var i = this._lastIntValue;
        n3 === -1 || i === -1 ? this.strict && this.raise("Invalid character class") : n3 > i ? this.raise("Range out of order in character class") : this.onCharacterClassRange(t3, this.index, n3, i);
      }
      t3 = this.index;
    }
  } }, { key: "eatClassAtom", value: function() {
    var t3 = this.index;
    if (this.eat(gr$1)) {
      if (this.eatClassEscape())
        return true;
      this._uFlag && this.raise("Invalid escape"), this.rewind(t3);
    }
    var n3 = this.currentCodePoint;
    return n3 !== -1 && n3 !== Es$1 && (this.advance(), this._lastIntValue = n3, this.onCharacter(t3, this.index, n3), true);
  } }, { key: "eatClassEscape", value: function() {
    var t3 = this.index;
    if (this.eat(98))
      return this._lastIntValue = 8, this.onCharacter(t3 - 1, this.index, 8), true;
    if (this._uFlag && this.eat(45))
      return this._lastIntValue = 45, this.onCharacter(t3 - 1, this.index, 45), true;
    if (!this._uFlag && this.eat(99)) {
      if (this.eatClassControlLetter())
        return this.onCharacter(t3 - 1, this.index, this._lastIntValue), true;
      this.rewind(t3);
    }
    return this.eatCharacterClassEscape() || this.eatCharacterEscape();
  } }, { key: "eatClassControlLetter", value: function() {
    var t3 = this.currentCodePoint;
    return !(!Hl(t3) && t3 !== Kp) && (this.advance(), this._lastIntValue = t3 % 32, true);
  } }, { key: "eatHexEscapeSequence", value: function() {
    var t3 = this.index;
    if (this.eat(120)) {
      if (this.eatFixedHexDigits(2))
        return true;
      this._uFlag && this.raise("Invalid escape"), this.rewind(t3);
    }
    return false;
  } }, { key: "eatDecimalDigits", value: function() {
    var t3 = this.index;
    for (this._lastIntValue = 0; Hl(this.currentCodePoint); )
      this._lastIntValue = 10 * this._lastIntValue + zd$1(this.currentCodePoint), this.advance();
    return this.index !== t3;
  } }, { key: "eatHexDigits", value: function() {
    var t3 = this.index;
    for (this._lastIntValue = 0; Wb$1(this.currentCodePoint); )
      this._lastIntValue = 16 * this._lastIntValue + zd$1(this.currentCodePoint), this.advance();
    return this.index !== t3;
  } }, { key: "eatLegacyOctalEscapeSequence", value: function() {
    if (this.eatOctalDigit()) {
      var t3 = this._lastIntValue;
      if (this.eatOctalDigit()) {
        var n3 = this._lastIntValue;
        t3 <= 3 && this.eatOctalDigit() ? this._lastIntValue = 64 * t3 + 8 * n3 + this._lastIntValue : this._lastIntValue = 8 * t3 + n3;
      } else
        this._lastIntValue = t3;
      return true;
    }
    return false;
  } }, { key: "eatOctalDigit", value: function() {
    var t3 = this.currentCodePoint;
    return function(n3) {
      return n3 >= Xa$2 && n3 <= KP;
    }(t3) ? (this.advance(), this._lastIntValue = t3 - Xa$2, true) : (this._lastIntValue = 0, false);
  } }, { key: "eatFixedHexDigits", value: function(t3) {
    var n3 = this.index;
    this._lastIntValue = 0;
    for (var r3 = 0; r3 < t3; ++r3) {
      var i = this.currentCodePoint;
      if (!Wb$1(i))
        return this.rewind(n3), false;
      this._lastIntValue = 16 * this._lastIntValue + zd$1(i), this.advance();
    }
    return true;
  } }, { key: "strict", get: function() {
    return !!(this._options.strict || this._uFlag);
  } }, { key: "ecmaVersion", get: function() {
    return this._options.ecmaVersion || 2018;
  } }, { key: "source", get: function() {
    return this._reader.source;
  } }, { key: "index", get: function() {
    return this._reader.index;
  } }, { key: "currentCodePoint", get: function() {
    return this._reader.currentCodePoint;
  } }, { key: "nextCodePoint", get: function() {
    return this._reader.nextCodePoint;
  } }, { key: "nextCodePoint2", get: function() {
    return this._reader.nextCodePoint2;
  } }, { key: "nextCodePoint3", get: function() {
    return this._reader.nextCodePoint3;
  } }]), e28;
}(), uI = {}, cI = {}, lI = {}, pI = function() {
  function e28(t3) {
    We$1(this, e28), this._node = uI, this._flags = cI, this._backreferences = [], this._capturingGroups = [], this.source = "", this.strict = !!(t3 && t3.strict), this.ecmaVersion = t3 && t3.ecmaVersion || 2018;
  }
  return Xe$1(e28, [{ key: "onFlags", value: function(t3, n3, r3, i, a3, s3, o3, u3) {
    this._flags = { type: "Flags", parent: null, start: t3, end: n3, raw: this.source.slice(t3, n3), global: r3, ignoreCase: i, multiline: a3, unicode: s3, sticky: o3, dotAll: u3 };
  } }, { key: "onPatternEnter", value: function(t3) {
    this._node = { type: "Pattern", parent: null, start: t3, end: t3, raw: "", alternatives: [] }, this._backreferences.length = 0, this._capturingGroups.length = 0;
  } }, { key: "onPatternLeave", value: function(t3, n3) {
    var r3 = this;
    this._node.end = n3, this._node.raw = this.source.slice(t3, n3);
    var i = true, a3 = false, s3 = void 0;
    try {
      for (var o3, u3 = function() {
        var f3 = o3.value, p3 = f3.ref, d3 = typeof p3 == "number" ? r3._capturingGroups[p3 - 1] : r3._capturingGroups.find(function(m3) {
          return m3.name === p3;
        });
        f3.resolved = d3, d3.references.push(f3);
      }, c3 = this._backreferences[Symbol.iterator](); !(i = (o3 = c3.next()).done); i = true)
        u3();
    } catch (f3) {
      a3 = true, s3 = f3;
    } finally {
      try {
        i || c3.return == null || c3.return();
      } finally {
        if (a3)
          throw s3;
      }
    }
  } }, { key: "onAlternativeEnter", value: function(t3) {
    var n3 = this._node;
    if (n3.type !== "Assertion" && n3.type !== "CapturingGroup" && n3.type !== "Group" && n3.type !== "Pattern")
      throw new Error("UnknownError");
    this._node = { type: "Alternative", parent: n3, start: t3, end: t3, raw: "", elements: [] }, n3.alternatives.push(this._node);
  } }, { key: "onAlternativeLeave", value: function(t3, n3) {
    var r3 = this._node;
    if (r3.type !== "Alternative")
      throw new Error("UnknownError");
    r3.end = n3, r3.raw = this.source.slice(t3, n3), this._node = r3.parent;
  } }, { key: "onGroupEnter", value: function(t3) {
    var n3 = this._node;
    if (n3.type !== "Alternative")
      throw new Error("UnknownError");
    this._node = { type: "Group", parent: n3, start: t3, end: t3, raw: "", alternatives: [] }, n3.elements.push(this._node);
  } }, { key: "onGroupLeave", value: function(t3, n3) {
    var r3 = this._node;
    if (r3.type !== "Group" || r3.parent.type !== "Alternative")
      throw new Error("UnknownError");
    r3.end = n3, r3.raw = this.source.slice(t3, n3), this._node = r3.parent;
  } }, { key: "onCapturingGroupEnter", value: function(t3, n3) {
    var r3 = this._node;
    if (r3.type !== "Alternative")
      throw new Error("UnknownError");
    this._node = { type: "CapturingGroup", parent: r3, start: t3, end: t3, raw: "", name: n3, alternatives: [], references: [] }, r3.elements.push(this._node), this._capturingGroups.push(this._node);
  } }, { key: "onCapturingGroupLeave", value: function(t3, n3) {
    var r3 = this._node;
    if (r3.type !== "CapturingGroup" || r3.parent.type !== "Alternative")
      throw new Error("UnknownError");
    r3.end = n3, r3.raw = this.source.slice(t3, n3), this._node = r3.parent;
  } }, { key: "onQuantifier", value: function(t3, n3, r3, i, a3) {
    var s3 = this._node;
    if (s3.type !== "Alternative")
      throw new Error("UnknownError");
    var o3 = s3.elements.pop();
    if (o3 == null || o3.type === "Quantifier" || o3.type === "Assertion" && o3.kind !== "lookahead")
      throw new Error("UnknownError");
    var u3 = { type: "Quantifier", parent: s3, start: o3.start, end: n3, raw: this.source.slice(o3.start, n3), min: r3, max: i, greedy: a3, element: o3 };
    s3.elements.push(u3), o3.parent = u3;
  } }, { key: "onLookaroundAssertionEnter", value: function(t3, n3, r3) {
    var i = this._node;
    if (i.type !== "Alternative")
      throw new Error("UnknownError");
    this._node = { type: "Assertion", parent: i, start: t3, end: t3, raw: "", kind: n3, negate: r3, alternatives: [] }, i.elements.push(this._node);
  } }, { key: "onLookaroundAssertionLeave", value: function(t3, n3) {
    var r3 = this._node;
    if (r3.type !== "Assertion" || r3.parent.type !== "Alternative")
      throw new Error("UnknownError");
    r3.end = n3, r3.raw = this.source.slice(t3, n3), this._node = r3.parent;
  } }, { key: "onEdgeAssertion", value: function(t3, n3, r3) {
    var i = this._node;
    if (i.type !== "Alternative")
      throw new Error("UnknownError");
    i.elements.push({ type: "Assertion", parent: i, start: t3, end: n3, raw: this.source.slice(t3, n3), kind: r3 });
  } }, { key: "onWordBoundaryAssertion", value: function(t3, n3, r3, i) {
    var a3 = this._node;
    if (a3.type !== "Alternative")
      throw new Error("UnknownError");
    a3.elements.push({ type: "Assertion", parent: a3, start: t3, end: n3, raw: this.source.slice(t3, n3), kind: r3, negate: i });
  } }, { key: "onAnyCharacterSet", value: function(t3, n3, r3) {
    var i = this._node;
    if (i.type !== "Alternative")
      throw new Error("UnknownError");
    i.elements.push({ type: "CharacterSet", parent: i, start: t3, end: n3, raw: this.source.slice(t3, n3), kind: r3 });
  } }, { key: "onEscapeCharacterSet", value: function(t3, n3, r3, i) {
    var a3 = this._node;
    if (a3.type !== "Alternative" && a3.type !== "CharacterClass")
      throw new Error("UnknownError");
    a3.elements.push({ type: "CharacterSet", parent: a3, start: t3, end: n3, raw: this.source.slice(t3, n3), kind: r3, negate: i });
  } }, { key: "onUnicodePropertyCharacterSet", value: function(t3, n3, r3, i, a3, s3) {
    var o3 = this._node;
    if (o3.type !== "Alternative" && o3.type !== "CharacterClass")
      throw new Error("UnknownError");
    o3.elements.push({ type: "CharacterSet", parent: o3, start: t3, end: n3, raw: this.source.slice(t3, n3), kind: r3, key: i, value: a3, negate: s3 });
  } }, { key: "onCharacter", value: function(t3, n3, r3) {
    var i = this._node;
    if (i.type !== "Alternative" && i.type !== "CharacterClass")
      throw new Error("UnknownError");
    i.elements.push({ type: "Character", parent: i, start: t3, end: n3, raw: this.source.slice(t3, n3), value: r3 });
  } }, { key: "onBackreference", value: function(t3, n3, r3) {
    var i = this._node;
    if (i.type !== "Alternative")
      throw new Error("UnknownError");
    var a3 = { type: "Backreference", parent: i, start: t3, end: n3, raw: this.source.slice(t3, n3), ref: r3, resolved: lI };
    i.elements.push(a3), this._backreferences.push(a3);
  } }, { key: "onCharacterClassEnter", value: function(t3, n3) {
    var r3 = this._node;
    if (r3.type !== "Alternative")
      throw new Error("UnknownError");
    this._node = { type: "CharacterClass", parent: r3, start: t3, end: t3, raw: "", negate: n3, elements: [] }, r3.elements.push(this._node);
  } }, { key: "onCharacterClassLeave", value: function(t3, n3) {
    var r3 = this._node;
    if (r3.type !== "CharacterClass" || r3.parent.type !== "Alternative")
      throw new Error("UnknownError");
    r3.end = n3, r3.raw = this.source.slice(t3, n3), this._node = r3.parent;
  } }, { key: "onCharacterClassRange", value: function(t3, n3) {
    var r3 = this._node;
    if (r3.type !== "CharacterClass")
      throw new Error("UnknownError");
    var i = r3.elements, a3 = i.pop(), s3 = i.pop(), o3 = i.pop();
    if (!o3 || !a3 || !s3 || o3.type !== "Character" || a3.type !== "Character" || s3.type !== "Character" || s3.value !== 45)
      throw new Error("UnknownError");
    var u3 = { type: "CharacterClassRange", parent: r3, start: t3, end: n3, raw: this.source.slice(t3, n3), min: o3, max: a3 };
    o3.parent = u3, a3.parent = u3, i.push(u3);
  } }, { key: "pattern", get: function() {
    if (this._node.type !== "Pattern")
      throw new Error("UnknownError");
    return this._node;
  } }, { key: "flags", get: function() {
    if (this._flags.type !== "Flags")
      throw new Error("UnknownError");
    return this._flags;
  } }]), e28;
}(), Kb$1 = function() {
  function e28(t3) {
    We$1(this, e28), this._state = new pI(t3), this._validator = new u0(this._state);
  }
  return Xe$1(e28, [{ key: "parseLiteral", value: function(t3) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t3.length;
    this._state.source = t3, this._validator.validateLiteral(t3, n3, r3);
    var i = this._state.pattern, a3 = this._state.flags, s3 = { type: "RegExpLiteral", parent: null, start: n3, end: r3, raw: t3, pattern: i, flags: a3 };
    return i.parent = s3, a3.parent = s3, s3;
  } }, { key: "parseFlags", value: function(t3) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t3.length;
    return this._state.source = t3, this._validator.validateFlags(t3, n3, r3), this._state.flags;
  } }, { key: "parsePattern", value: function(t3) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t3.length, i = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
    return this._state.source = t3, this._validator.validatePattern(t3, n3, r3, i), this._state.pattern;
  } }]), e28;
}(), fI = function() {
  function e28(t3) {
    We$1(this, e28), this._handlers = t3;
  }
  return Xe$1(e28, [{ key: "visit", value: function(t3) {
    switch (t3.type) {
      case "Alternative":
        this.visitAlternative(t3);
        break;
      case "Assertion":
        this.visitAssertion(t3);
        break;
      case "Backreference":
        this.visitBackreference(t3);
        break;
      case "CapturingGroup":
        this.visitCapturingGroup(t3);
        break;
      case "Character":
        this.visitCharacter(t3);
        break;
      case "CharacterClass":
        this.visitCharacterClass(t3);
        break;
      case "CharacterClassRange":
        this.visitCharacterClassRange(t3);
        break;
      case "CharacterSet":
        this.visitCharacterSet(t3);
        break;
      case "Flags":
        this.visitFlags(t3);
        break;
      case "Group":
        this.visitGroup(t3);
        break;
      case "Pattern":
        this.visitPattern(t3);
        break;
      case "Quantifier":
        this.visitQuantifier(t3);
        break;
      case "RegExpLiteral":
        this.visitRegExpLiteral(t3);
        break;
      default:
        throw new Error("Unknown type: ".concat(t3.type));
    }
  } }, { key: "visitAlternative", value: function(t3) {
    this._handlers.onAlternativeEnter && this._handlers.onAlternativeEnter(t3), t3.elements.forEach(this.visit, this), this._handlers.onAlternativeLeave && this._handlers.onAlternativeLeave(t3);
  } }, { key: "visitAssertion", value: function(t3) {
    this._handlers.onAssertionEnter && this._handlers.onAssertionEnter(t3), t3.kind !== "lookahead" && t3.kind !== "lookbehind" || t3.alternatives.forEach(this.visit, this), this._handlers.onAssertionLeave && this._handlers.onAssertionLeave(t3);
  } }, { key: "visitBackreference", value: function(t3) {
    this._handlers.onBackreferenceEnter && this._handlers.onBackreferenceEnter(t3), this._handlers.onBackreferenceLeave && this._handlers.onBackreferenceLeave(t3);
  } }, { key: "visitCapturingGroup", value: function(t3) {
    this._handlers.onCapturingGroupEnter && this._handlers.onCapturingGroupEnter(t3), t3.alternatives.forEach(this.visit, this), this._handlers.onCapturingGroupLeave && this._handlers.onCapturingGroupLeave(t3);
  } }, { key: "visitCharacter", value: function(t3) {
    this._handlers.onCharacterEnter && this._handlers.onCharacterEnter(t3), this._handlers.onCharacterLeave && this._handlers.onCharacterLeave(t3);
  } }, { key: "visitCharacterClass", value: function(t3) {
    this._handlers.onCharacterClassEnter && this._handlers.onCharacterClassEnter(t3), t3.elements.forEach(this.visit, this), this._handlers.onCharacterClassLeave && this._handlers.onCharacterClassLeave(t3);
  } }, { key: "visitCharacterClassRange", value: function(t3) {
    this._handlers.onCharacterClassRangeEnter && this._handlers.onCharacterClassRangeEnter(t3), this.visitCharacter(t3.min), this.visitCharacter(t3.max), this._handlers.onCharacterClassRangeLeave && this._handlers.onCharacterClassRangeLeave(t3);
  } }, { key: "visitCharacterSet", value: function(t3) {
    this._handlers.onCharacterSetEnter && this._handlers.onCharacterSetEnter(t3), this._handlers.onCharacterSetLeave && this._handlers.onCharacterSetLeave(t3);
  } }, { key: "visitFlags", value: function(t3) {
    this._handlers.onFlagsEnter && this._handlers.onFlagsEnter(t3), this._handlers.onFlagsLeave && this._handlers.onFlagsLeave(t3);
  } }, { key: "visitGroup", value: function(t3) {
    this._handlers.onGroupEnter && this._handlers.onGroupEnter(t3), t3.alternatives.forEach(this.visit, this), this._handlers.onGroupLeave && this._handlers.onGroupLeave(t3);
  } }, { key: "visitPattern", value: function(t3) {
    this._handlers.onPatternEnter && this._handlers.onPatternEnter(t3), t3.alternatives.forEach(this.visit, this), this._handlers.onPatternLeave && this._handlers.onPatternLeave(t3);
  } }, { key: "visitQuantifier", value: function(t3) {
    this._handlers.onQuantifierEnter && this._handlers.onQuantifierEnter(t3), this.visit(t3.element), this._handlers.onQuantifierLeave && this._handlers.onQuantifierLeave(t3);
  } }, { key: "visitRegExpLiteral", value: function(t3) {
    this._handlers.onRegExpLiteralEnter && this._handlers.onRegExpLiteralEnter(t3), this.visitPattern(t3.pattern), this.visitFlags(t3.flags), this._handlers.onRegExpLiteralLeave && this._handlers.onRegExpLiteralLeave(t3);
  } }]), e28;
}(), hI = Object.freeze({ __proto__: null, AST: HP, RegExpParser: Kb$1, RegExpValidator: u0, parseRegExpLiteral: function(e28, t3) {
  return new Kb$1(t3).parseLiteral(String(e28));
}, validateRegExpLiteral: function(e28, t3) {
  return new u0(t3).validateLiteral(e28);
}, visitRegExpAST: function(e28, t3) {
  new fI(t3).visit(e28);
} });
function Jb$1(e28) {
  return Array.isArray(e28) ? e28 : [e28];
}
var dI = /^\s+$/, mI = /^\\!/, gI = /^\\#/, Qb$1 = typeof Symbol < "u" ? Symbol.for("node-ignore") : "node-ignore", yI = function(e28, t3, n3) {
  return Object.defineProperty(e28, t3, { value: n3 });
}, vI = /([0-z])-([0-z])/g, fA = [[/\\?\s+$/, function(e28) {
  return e28.indexOf("\\") === 0 ? " " : "";
}], [/\\\s/g, function() {
  return " ";
}], [/[\\^$.|*+(){]/g, function(e28) {
  return "\\".concat(e28);
}], [/\[([^\]/]*)($|\])/g, function(e28, t3, n3) {
  return n3 === "]" ? "[".concat(t3.replace(vI, function(r3, i, a3) {
    return i.charCodeAt(0) <= a3.charCodeAt(0) ? r3 : "";
  }), "]") : "\\".concat(e28);
}], [/(?!\\)\?/g, function() {
  return "[^/]";
}], [/^\//, function() {
  return "^";
}], [/\//g, function() {
  return "\\/";
}], [/^\^*\\\*\\\*\\\//, function() {
  return "^(?:.*\\/)?";
}]], hA = [[/^(?=[^^])/, function() {
  return /\/(?!$)/.test(this) ? "^" : "(?:^|\\/)";
}], [/\\\/\\\*\\\*(?=\\\/|$)/g, function(e28, t3, n3) {
  return t3 + 6 < n3.length ? "(?:\\/[^\\/]+)*" : "\\/.+";
}], [/(^|[^\\]+)\\\*(?=.+)/g, function(e28, t3) {
  return "".concat(t3, "[^\\/]*");
}], [/(\^|\\\/)?\\\*$/, function(e28, t3) {
  var n3 = t3 ? "".concat(t3, "[^/]+") : "[^/]*";
  return "".concat(n3, "(?=$|\\/$)");
}], [/\\\\\\/g, function() {
  return "\\";
}]], xI = [].concat(fA, [[/(?:[^*/])$/, function(e28) {
  return "".concat(e28, "(?=$|\\/)");
}]], hA), bI = [].concat(fA, [[/(?:[^*])$/, function(e28) {
  return "".concat(e28, "(?=$|\\/$)");
}]], hA), Xb$1 = /* @__PURE__ */ Object.create(null), EI = function(e28, t3) {
  var n3 = e28, r3 = false;
  return e28.indexOf("!") === 0 && (r3 = true, e28 = e28.substr(1)), { origin: n3, pattern: e28 = e28.replace(mI, "!").replace(gI, "#"), negative: r3, regex: function(i, a3, s3) {
    var o3 = Xb$1[i];
    if (o3)
      return o3;
    var u3 = (a3 ? bI : xI).reduce(function(c3, f3) {
      return c3.replace(f3[0], f3[1].bind(i));
    }, i);
    return Xb$1[i] = s3 ? new RegExp(u3, "i") : new RegExp(u3);
  }(e28, r3, t3) };
}, c0 = function() {
  function e28() {
    var t3 = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).ignorecase, n3 = t3 === void 0 || t3;
    We$1(this, e28), this._rules = [], this._ignorecase = n3, yI(this, Qb$1, true), this._initCache();
  }
  return Xe$1(e28, [{ key: "_initCache", value: function() {
    this._cache = /* @__PURE__ */ Object.create(null);
  } }, { key: "add", value: function(t3) {
    return this._added = false, typeof t3 == "string" && (t3 = t3.split(/\r?\n/g)), Jb$1(t3).forEach(this._addPattern, this), this._added && this._initCache(), this;
  } }, { key: "addPattern", value: function(t3) {
    return this.add(t3);
  } }, { key: "_addPattern", value: function(t3) {
    if (t3 && t3[Qb$1])
      return this._rules = this._rules.concat(t3._rules), void (this._added = true);
    if (function(r3) {
      return r3 && typeof r3 == "string" && !dI.test(r3) && r3.indexOf("#") !== 0;
    }(t3)) {
      var n3 = EI(t3, this._ignorecase);
      this._added = true, this._rules.push(n3);
    }
  } }, { key: "filter", value: function(t3) {
    var n3 = this;
    return Jb$1(t3).filter(function(r3) {
      return n3._filter(r3);
    });
  } }, { key: "createFilter", value: function() {
    var t3 = this;
    return function(n3) {
      return t3._filter(n3);
    };
  } }, { key: "ignores", value: function(t3) {
    return !this._filter(t3);
  } }, { key: "_filter", value: function(t3, n3) {
    return !!t3 && (t3 in this._cache ? this._cache[t3] : (n3 || (n3 = t3.split("/")), n3.pop(), this._cache[t3] = n3.length ? this._filter(n3.join("/") + "/", n3) && this._test(t3) : this._test(t3)));
  } }, { key: "_test", value: function(t3) {
    var n3 = 0;
    return this._rules.forEach(function(r3) {
      n3 ^ r3.negative || (n3 = r3.negative ^ r3.regex.test(t3));
    }), !n3;
  } }]), e28;
}();
if (typeof process < "u" && (process.env && {}.IGNORE_TEST_WIN32 || process.platform === "win32")) {
  var CI = c0.prototype._filter;
  c0.prototype._filter = function(e28, t3) {
    var n3;
    return e28 = /^\\\\\?\\/.test(n3 = e28) || /[^\x00-\x80]+/.test(n3) ? n3 : n3.replace(/\\/g, "/"), CI.call(this, e28, t3);
  };
}
var SI = gt$3(function(e28) {
  /*
     * @version    1.4.0
     * @date       2015-10-26
     * @stability  3 - Stable
     * @author     Lauri Rooden (https://github.com/litejs/natural-compare-lite)
     * @license    MIT License
     */
  var t3 = function(n3, r3) {
    var i, a3, s3 = 1, o3 = 0, u3 = 0, c3 = String.alphabet;
    function f3(p3, d3, m3) {
      if (m3) {
        for (i = d3; (m3 = f3(p3, i)) < 76 && m3 > 65; )
          ++i;
        return +p3.slice(d3 - 1, i);
      }
      return (m3 = c3 && c3.indexOf(p3.charAt(d3))) > -1 ? m3 + 76 : (m3 = p3.charCodeAt(d3) || 0) < 45 || m3 > 127 ? m3 : m3 < 46 ? 65 : m3 < 48 ? m3 - 1 : m3 < 58 ? m3 + 18 : m3 < 65 ? m3 - 11 : m3 < 91 ? m3 + 11 : m3 < 97 ? m3 - 37 : m3 < 123 ? m3 + 5 : m3 - 63;
    }
    if ((n3 += "") != (r3 += "")) {
      for (; s3; )
        if (a3 = f3(n3, o3++), s3 = f3(r3, u3++), a3 < 76 && s3 < 76 && a3 > 66 && s3 > 66 && (a3 = f3(n3, o3, o3), s3 = f3(r3, u3, o3 = i), u3 = i), a3 != s3)
          return a3 < s3 ? -1 : 1;
    }
    return 0;
  };
  try {
    e28.exports = t3;
  } catch {
    String.naturalCompare = t3;
  }
}), dA = "https://github.com/eslint/doctrine", mA = { node: ">=6.0.0" }, gA = { lib: "./lib" }, yA = ["lib"], vA = [{ name: "Nicholas C. Zakas", email: "nicholas+npm@nczconsulting.com", web: "https://www.nczonline.net" }, { name: "Yusuke Suzuki", email: "utatane.tea@gmail.com", web: "https://github.com/Constellation" }], xA = { coveralls: "^3.0.1", dateformat: "^1.0.11", eslint: "^1.10.3", "eslint-release": "^1.0.0", linefix: "^0.1.1", mocha: "^3.4.2", "npm-license": "^0.3.1", nyc: "^10.3.2", semver: "^5.0.3", shelljs: "^0.5.3", "shelljs-nodecli": "^0.1.1", should: "^5.0.1" }, bA = { pretest: "npm run lint", test: "nyc mocha", coveralls: "nyc report --reporter=text-lcov | coveralls", lint: "eslint lib/", "generate-release": "eslint-generate-release", "generate-alpharelease": "eslint-generate-prerelease alpha", "generate-betarelease": "eslint-generate-prerelease beta", "generate-rcrelease": "eslint-generate-prerelease rc", "publish-release": "eslint-publish-release" }, EA = { esutils: "^2.0.2" }, kI = { name: "doctrine", description: "JSDoc parser", homepage: dA, main: "lib/doctrine.js", version: "3.0.0", engines: mA, directories: gA, files: yA, maintainers: vA, repository: "eslint/doctrine", devDependencies: xA, license: "Apache-2.0", scripts: bA, dependencies: EA }, DI = Cr$1(Object.freeze({ __proto__: null, name: "doctrine", description: "JSDoc parser", homepage: dA, main: "lib/doctrine.js", version: "3.0.0", engines: mA, directories: gA, files: yA, maintainers: vA, repository: "eslint/doctrine", devDependencies: xA, license: "Apache-2.0", scripts: bA, dependencies: EA, default: kI })), Cs$1 = gt$3(function(e28, t3) {
  (function() {
    var n3, r3;
    function i(a3) {
      this.name = "DoctrineError", this.message = a3;
    }
    n3 = DI.version, t3.VERSION = n3, i.prototype = ((r3 = function() {
    }).prototype = Error.prototype, new r3()), i.prototype.constructor = i, t3.DoctrineError = i, t3.throwError = function(a3) {
      throw new i(a3);
    }, t3.assert = xn$2;
  })();
}), Pu$1 = (Cs$1.VERSION, Cs$1.DoctrineError, Cs$1.throwError, Cs$1.assert, gt$3(function(e28, t3) {
  (function() {
    var n3, r3, i, a3, s3, o3, u3, c3, f3, p3, d3, m3;
    function y3(W3) {
      return "><(){}[],:*|?!=".indexOf(String.fromCharCode(W3)) === -1 && !f3.code.isWhiteSpace(W3) && !f3.code.isLineTerminator(W3);
    }
    function v3(W3, R3, q3, J3) {
      this._previous = W3, this._index = R3, this._token = q3, this._value = J3;
    }
    function b3(W3, R3) {
      return m3 && (W3.range = [R3[0] + d3, R3[1] + d3]), W3;
    }
    function x3() {
      var W3 = i.charAt(s3);
      return s3 += 1, W3;
    }
    function C3(W3) {
      var R3, q3, J3, X3 = 0;
      for (q3 = W3 === "u" ? 4 : 2, R3 = 0; R3 < q3; ++R3) {
        if (!(s3 < a3 && f3.code.isHexDigit(i.charCodeAt(s3))))
          return "";
        J3 = x3(), X3 = 16 * X3 + "0123456789abcdef".indexOf(J3.toLowerCase());
      }
      return String.fromCharCode(X3);
    }
    function k3() {
      var W3, R3;
      if (W3 = "", (R3 = i.charCodeAt(s3)) !== 46) {
        if (W3 = x3(), R3 = i.charCodeAt(s3), W3 === "0") {
          if (R3 === 120 || R3 === 88) {
            for (W3 += x3(); s3 < a3 && (R3 = i.charCodeAt(s3), f3.code.isHexDigit(R3)); )
              W3 += x3();
            return W3.length <= 2 && p3.throwError("unexpected token"), s3 < a3 && (R3 = i.charCodeAt(s3), f3.code.isIdentifierStartES5(R3) && p3.throwError("unexpected token")), c3 = parseInt(W3, 16), r3.NUMBER;
          }
          if (f3.code.isOctalDigit(R3)) {
            for (W3 += x3(); s3 < a3 && (R3 = i.charCodeAt(s3), f3.code.isOctalDigit(R3)); )
              W3 += x3();
            return s3 < a3 && (R3 = i.charCodeAt(s3), (f3.code.isIdentifierStartES5(R3) || f3.code.isDecimalDigit(R3)) && p3.throwError("unexpected token")), c3 = parseInt(W3, 8), r3.NUMBER;
          }
          f3.code.isDecimalDigit(R3) && p3.throwError("unexpected token");
        }
        for (; s3 < a3 && (R3 = i.charCodeAt(s3), f3.code.isDecimalDigit(R3)); )
          W3 += x3();
      }
      if (R3 === 46)
        for (W3 += x3(); s3 < a3 && (R3 = i.charCodeAt(s3), f3.code.isDecimalDigit(R3)); )
          W3 += x3();
      if (R3 === 101 || R3 === 69)
        if (W3 += x3(), (R3 = i.charCodeAt(s3)) !== 43 && R3 !== 45 || (W3 += x3()), R3 = i.charCodeAt(s3), f3.code.isDecimalDigit(R3))
          for (W3 += x3(); s3 < a3 && (R3 = i.charCodeAt(s3), f3.code.isDecimalDigit(R3)); )
            W3 += x3();
        else
          p3.throwError("unexpected token");
      return s3 < a3 && (R3 = i.charCodeAt(s3), f3.code.isIdentifierStartES5(R3) && p3.throwError("unexpected token")), c3 = parseFloat(W3), r3.NUMBER;
    }
    function F3() {
      var W3;
      for (o3 = s3; s3 < a3 && f3.code.isWhiteSpace(i.charCodeAt(s3)); )
        x3();
      if (s3 >= a3)
        return u3 = r3.EOF;
      switch (W3 = i.charCodeAt(s3)) {
        case 39:
        case 34:
          return u3 = function() {
            var R3, q3, J3, X3, ce2, A3 = "";
            for (R3 = i.charAt(s3), ++s3; s3 < a3; ) {
              if ((q3 = x3()) === R3) {
                R3 = "";
                break;
              }
              if (q3 === "\\")
                if (q3 = x3(), f3.code.isLineTerminator(q3.charCodeAt(0)))
                  q3 === "\r" && i.charCodeAt(s3) === 10 && ++s3;
                else
                  switch (q3) {
                    case "n":
                      A3 += `
`;
                      break;
                    case "r":
                      A3 += "\r";
                      break;
                    case "t":
                      A3 += "	";
                      break;
                    case "u":
                    case "x":
                      ce2 = s3, (X3 = C3(q3)) ? A3 += X3 : (s3 = ce2, A3 += q3);
                      break;
                    case "b":
                      A3 += "\b";
                      break;
                    case "f":
                      A3 += "\f";
                      break;
                    case "v":
                      A3 += "\v";
                      break;
                    default:
                      f3.code.isOctalDigit(q3.charCodeAt(0)) ? (J3 = "01234567".indexOf(q3), s3 < a3 && f3.code.isOctalDigit(i.charCodeAt(s3)) && (J3 = 8 * J3 + "01234567".indexOf(x3()), "0123".indexOf(q3) >= 0 && s3 < a3 && f3.code.isOctalDigit(i.charCodeAt(s3)) && (J3 = 8 * J3 + "01234567".indexOf(x3()))), A3 += String.fromCharCode(J3)) : A3 += q3;
                  }
              else {
                if (f3.code.isLineTerminator(q3.charCodeAt(0)))
                  break;
                A3 += q3;
              }
            }
            return R3 !== "" && p3.throwError("unexpected quote"), c3 = A3, r3.STRING;
          }();
        case 58:
          return x3(), u3 = r3.COLON;
        case 44:
          return x3(), u3 = r3.COMMA;
        case 40:
          return x3(), u3 = r3.LPAREN;
        case 41:
          return x3(), u3 = r3.RPAREN;
        case 91:
          return x3(), u3 = r3.LBRACK;
        case 93:
          return x3(), u3 = r3.RBRACK;
        case 123:
          return x3(), u3 = r3.LBRACE;
        case 125:
          return x3(), u3 = r3.RBRACE;
        case 46:
          if (s3 + 1 < a3) {
            if ((W3 = i.charCodeAt(s3 + 1)) === 60)
              return x3(), x3(), u3 = r3.DOT_LT;
            if (W3 === 46 && s3 + 2 < a3 && i.charCodeAt(s3 + 2) === 46)
              return x3(), x3(), x3(), u3 = r3.REST;
            if (f3.code.isDecimalDigit(W3))
              return u3 = k3();
          }
          return u3 = r3.ILLEGAL;
        case 60:
          return x3(), u3 = r3.LT;
        case 62:
          return x3(), u3 = r3.GT;
        case 42:
          return x3(), u3 = r3.STAR;
        case 124:
          return x3(), u3 = r3.PIPE;
        case 63:
          return x3(), u3 = r3.QUESTION;
        case 33:
          return x3(), u3 = r3.BANG;
        case 61:
          return x3(), u3 = r3.EQUAL;
        case 45:
          return u3 = k3();
        default:
          return f3.code.isDecimalDigit(W3) ? u3 = k3() : (p3.assert(y3(W3)), u3 = function() {
            for (c3 = x3(); s3 < a3 && y3(i.charCodeAt(s3)); ) {
              if (i.charCodeAt(s3) === 46) {
                if (s3 + 1 >= a3)
                  return r3.ILLEGAL;
                if (i.charCodeAt(s3 + 1) === 60)
                  break;
              }
              c3 += x3();
            }
            return r3.NAME;
          }());
      }
    }
    function B3(W3, R3) {
      p3.assert(u3 === W3, R3 || "consumed token not matched"), F3();
    }
    function O3(W3, R3) {
      u3 !== W3 && p3.throwError(R3 || "unexpected token"), F3();
    }
    function S3() {
      var W3, R3, q3 = o3;
      return R3 = c3, W3 = u3 === r3.NAME || u3 === r3.STRING ? (F3(), R3) : u3 === r3.NUMBER ? (B3(r3.NUMBER), String(R3)) : void p3.throwError("unexpected token"), u3 === r3.COLON ? (B3(r3.COLON), b3({ type: n3.FieldType, key: W3, value: V10() }, [q3, o3])) : b3({ type: n3.FieldType, key: W3, value: null }, [q3, o3]);
    }
    function w3() {
      var W3, R3, q3 = s3 - c3.length;
      return W3 = function() {
        var J3 = c3, X3 = s3 - J3.length;
        return O3(r3.NAME), u3 !== r3.COLON || J3 !== "module" && J3 !== "external" && J3 !== "event" || (B3(r3.COLON), J3 += ":" + c3, O3(r3.NAME)), b3({ type: n3.NameExpression, name: J3 }, [X3, o3]);
      }(), u3 === r3.DOT_LT || u3 === r3.LT ? (F3(), R3 = function() {
        var J3 = [];
        for (J3.push(K3()); u3 === r3.COMMA; )
          B3(r3.COMMA), J3.push(K3());
        return J3;
      }(), O3(r3.GT), b3({ type: n3.TypeApplication, expression: W3, applications: R3 }, [q3, o3])) : W3;
    }
    function D3() {
      for (var W3, R3, q3, J3 = [], X3 = false, ce2 = false, A3 = s3 - 3; u3 !== r3.RPAREN; )
        u3 === r3.REST && (B3(r3.REST), ce2 = true), R3 = o3, (W3 = V10()).type === n3.NameExpression && u3 === r3.COLON && (q3 = o3 - W3.name.length, B3(r3.COLON), W3 = b3({ type: n3.ParameterType, name: W3.name, expression: V10() }, [q3, o3])), u3 === r3.EQUAL ? (B3(r3.EQUAL), W3 = b3({ type: n3.OptionalType, expression: W3 }, [R3, o3]), X3 = true) : X3 && p3.throwError("unexpected token"), ce2 && (W3 = b3({ type: n3.RestType, expression: W3 }, [A3, o3])), J3.push(W3), u3 !== r3.RPAREN && O3(r3.COMMA);
      return J3;
    }
    function I3() {
      var W3, R3, q3, J3, X3, ce2 = s3 - c3.length;
      return p3.assert(u3 === r3.NAME && c3 === "function", "FunctionType should start with 'function'"), B3(r3.NAME), O3(r3.LPAREN), W3 = false, q3 = [], R3 = null, u3 !== r3.RPAREN && (u3 !== r3.NAME || c3 !== "this" && c3 !== "new" ? q3 = D3() : (W3 = c3 === "new", B3(r3.NAME), O3(r3.COLON), R3 = w3(), u3 === r3.COMMA && (B3(r3.COMMA), q3 = D3()))), O3(r3.RPAREN), J3 = null, u3 === r3.COLON && (B3(r3.COLON, "ResultType should start with :"), J3 = u3 === r3.NAME && c3 === "void" ? (B3(r3.NAME), { type: n3.VoidLiteral }) : V10()), X3 = b3({ type: n3.FunctionType, params: q3, result: J3 }, [ce2, o3]), R3 && (X3.this = R3, W3 && (X3.new = true)), X3;
    }
    function L3() {
      var W3, R3;
      switch (u3) {
        case r3.STAR:
          return B3(r3.STAR), b3({ type: n3.AllLiteral }, [o3 - 1, o3]);
        case r3.LPAREN:
          return function() {
            var q3, J3 = s3 - 1;
            if (B3(r3.LPAREN, "UnionType should start with ("), q3 = [], u3 !== r3.RPAREN)
              for (; q3.push(V10()), u3 !== r3.RPAREN; )
                O3(r3.PIPE);
            return B3(r3.RPAREN, "UnionType should end with )"), b3({ type: n3.UnionType, elements: q3 }, [J3, o3]);
          }();
        case r3.LBRACK:
          return function() {
            var q3, J3, X3 = s3 - 1;
            for (B3(r3.LBRACK, "ArrayType should start with ["), q3 = []; u3 !== r3.RBRACK; ) {
              if (u3 === r3.REST) {
                J3 = s3 - 3, B3(r3.REST), q3.push(b3({ type: n3.RestType, expression: V10() }, [J3, o3]));
                break;
              }
              q3.push(V10()), u3 !== r3.RBRACK && O3(r3.COMMA);
            }
            return O3(r3.RBRACK), b3({ type: n3.ArrayType, elements: q3 }, [X3, o3]);
          }();
        case r3.LBRACE:
          return function() {
            var q3, J3, X3 = s3 - 1;
            if (B3(r3.LBRACE, "RecordType should start with {"), q3 = [], u3 === r3.COMMA)
              B3(r3.COMMA);
            else
              for (; u3 !== r3.RBRACE; )
                q3.push(S3()), u3 !== r3.RBRACE && O3(r3.COMMA);
            return J3 = s3, O3(r3.RBRACE), b3({ type: n3.RecordType, fields: q3 }, [X3, J3]);
          }();
        case r3.NAME:
          if (R3 = s3 - c3.length, c3 === "null")
            return B3(r3.NAME), b3({ type: n3.NullLiteral }, [R3, o3]);
          if (c3 === "undefined")
            return B3(r3.NAME), b3({ type: n3.UndefinedLiteral }, [R3, o3]);
          if (c3 === "true" || c3 === "false")
            return B3(r3.NAME), b3({ type: n3.BooleanLiteralType, value: c3 === "true" }, [R3, o3]);
          if (W3 = v3.save(), c3 === "function")
            try {
              return I3();
            } catch {
              W3.restore();
            }
          return w3();
        case r3.STRING:
          return F3(), b3({ type: n3.StringLiteralType, value: c3 }, [o3 - c3.length - 2, o3]);
        case r3.NUMBER:
          return F3(), b3({ type: n3.NumericLiteralType, value: c3 }, [o3 - String(c3).length, o3]);
        default:
          p3.throwError("unexpected token");
      }
    }
    function V10() {
      var W3, R3;
      return u3 === r3.QUESTION ? (R3 = s3 - 1, B3(r3.QUESTION), u3 === r3.COMMA || u3 === r3.EQUAL || u3 === r3.RBRACE || u3 === r3.RPAREN || u3 === r3.PIPE || u3 === r3.EOF || u3 === r3.RBRACK || u3 === r3.GT ? b3({ type: n3.NullableLiteral }, [R3, o3]) : b3({ type: n3.NullableType, expression: L3(), prefix: true }, [R3, o3])) : u3 === r3.BANG ? (R3 = s3 - 1, B3(r3.BANG), b3({ type: n3.NonNullableType, expression: L3(), prefix: true }, [R3, o3])) : (R3 = o3, W3 = L3(), u3 === r3.BANG ? (B3(r3.BANG), b3({ type: n3.NonNullableType, expression: W3, prefix: false }, [R3, o3])) : u3 === r3.QUESTION ? (B3(r3.QUESTION), b3({ type: n3.NullableType, expression: W3, prefix: false }, [R3, o3])) : u3 === r3.LBRACK ? (B3(r3.LBRACK), O3(r3.RBRACK, "expected an array-style type declaration (" + c3 + "[])"), b3({ type: n3.TypeApplication, expression: b3({ type: n3.NameExpression, name: "Array" }, [R3, o3]), applications: [W3] }, [R3, o3])) : W3);
    }
    function K3() {
      var W3, R3;
      if (W3 = V10(), u3 !== r3.PIPE)
        return W3;
      for (R3 = [W3], B3(r3.PIPE); R3.push(V10()), u3 === r3.PIPE; )
        B3(r3.PIPE);
      return b3({ type: n3.UnionType, elements: R3 }, [0, s3]);
    }
    f3 = Os$1, p3 = Cs$1, n3 = { NullableLiteral: "NullableLiteral", AllLiteral: "AllLiteral", NullLiteral: "NullLiteral", UndefinedLiteral: "UndefinedLiteral", VoidLiteral: "VoidLiteral", UnionType: "UnionType", ArrayType: "ArrayType", RecordType: "RecordType", FieldType: "FieldType", FunctionType: "FunctionType", ParameterType: "ParameterType", RestType: "RestType", NonNullableType: "NonNullableType", OptionalType: "OptionalType", NullableType: "NullableType", NameExpression: "NameExpression", TypeApplication: "TypeApplication", StringLiteralType: "StringLiteralType", NumericLiteralType: "NumericLiteralType", BooleanLiteralType: "BooleanLiteralType" }, r3 = { ILLEGAL: 0, DOT_LT: 1, REST: 2, LT: 3, GT: 4, LPAREN: 5, RPAREN: 6, LBRACE: 7, RBRACE: 8, LBRACK: 9, RBRACK: 10, COMMA: 11, COLON: 12, STAR: 13, PIPE: 14, QUESTION: 15, BANG: 16, EQUAL: 17, NAME: 18, STRING: 19, NUMBER: 20, EOF: 21 }, v3.prototype.restore = function() {
      o3 = this._previous, s3 = this._index, u3 = this._token, c3 = this._value;
    }, v3.save = function() {
      return new v3(o3, s3, u3, c3);
    }, t3.parseType = function(W3, R3) {
      var q3;
      return a3 = (i = W3).length, s3 = 0, o3 = 0, m3 = R3 && R3.range, d3 = R3 && R3.startIndex || 0, F3(), q3 = K3(), R3 && R3.midstream ? { expression: q3, index: o3 } : (u3 !== r3.EOF && p3.throwError("not reach to EOF"), q3);
    }, t3.parseParamType = function(W3, R3) {
      var q3;
      return a3 = (i = W3).length, s3 = 0, o3 = 0, m3 = R3 && R3.range, d3 = R3 && R3.startIndex || 0, F3(), q3 = function() {
        var J3;
        return u3 === r3.REST ? (B3(r3.REST), b3({ type: n3.RestType, expression: K3() }, [0, s3])) : (J3 = K3(), u3 === r3.EQUAL ? (B3(r3.EQUAL), b3({ type: n3.OptionalType, expression: J3 }, [0, s3])) : J3);
      }(), R3 && R3.midstream ? { expression: q3, index: o3 } : (u3 !== r3.EOF && p3.throwError("not reach to EOF"), q3);
    }, t3.stringify = function(W3, R3) {
      return R3 == null && (R3 = {}), function q3(J3, X3, ce2) {
        var A3, M3, ne2;
        switch (J3.type) {
          case n3.NullableLiteral:
            A3 = "?";
            break;
          case n3.AllLiteral:
            A3 = "*";
            break;
          case n3.NullLiteral:
            A3 = "null";
            break;
          case n3.UndefinedLiteral:
            A3 = "undefined";
            break;
          case n3.VoidLiteral:
            A3 = "void";
            break;
          case n3.UnionType:
            for (A3 = ce2 ? "" : "(", M3 = 0, ne2 = J3.elements.length; M3 < ne2; ++M3)
              A3 += q3(J3.elements[M3], X3), M3 + 1 !== ne2 && (A3 += X3 ? "|" : " | ");
            ce2 || (A3 += ")");
            break;
          case n3.ArrayType:
            for (A3 = "[", M3 = 0, ne2 = J3.elements.length; M3 < ne2; ++M3)
              A3 += q3(J3.elements[M3], X3), M3 + 1 !== ne2 && (A3 += X3 ? "," : ", ");
            A3 += "]";
            break;
          case n3.RecordType:
            for (A3 = "{", M3 = 0, ne2 = J3.fields.length; M3 < ne2; ++M3)
              A3 += q3(J3.fields[M3], X3), M3 + 1 !== ne2 && (A3 += X3 ? "," : ", ");
            A3 += "}";
            break;
          case n3.FieldType:
            A3 = J3.value ? J3.key + (X3 ? ":" : ": ") + q3(J3.value, X3) : J3.key;
            break;
          case n3.FunctionType:
            for (A3 = X3 ? "function(" : "function (", J3.this && (J3.new ? A3 += X3 ? "new:" : "new: " : A3 += X3 ? "this:" : "this: ", A3 += q3(J3.this, X3), J3.params.length !== 0 && (A3 += X3 ? "," : ", ")), M3 = 0, ne2 = J3.params.length; M3 < ne2; ++M3)
              A3 += q3(J3.params[M3], X3), M3 + 1 !== ne2 && (A3 += X3 ? "," : ", ");
            A3 += ")", J3.result && (A3 += (X3 ? ":" : ": ") + q3(J3.result, X3));
            break;
          case n3.ParameterType:
            A3 = J3.name + (X3 ? ":" : ": ") + q3(J3.expression, X3);
            break;
          case n3.RestType:
            A3 = "...", J3.expression && (A3 += q3(J3.expression, X3));
            break;
          case n3.NonNullableType:
            A3 = J3.prefix ? "!" + q3(J3.expression, X3) : q3(J3.expression, X3) + "!";
            break;
          case n3.OptionalType:
            A3 = q3(J3.expression, X3) + "=";
            break;
          case n3.NullableType:
            A3 = J3.prefix ? "?" + q3(J3.expression, X3) : q3(J3.expression, X3) + "?";
            break;
          case n3.NameExpression:
            A3 = J3.name;
            break;
          case n3.TypeApplication:
            for (A3 = q3(J3.expression, X3) + ".<", M3 = 0, ne2 = J3.applications.length; M3 < ne2; ++M3)
              A3 += q3(J3.applications[M3], X3), M3 + 1 !== ne2 && (A3 += X3 ? "," : ", ");
            A3 += ">";
            break;
          case n3.StringLiteralType:
            A3 = '"' + J3.value + '"';
            break;
          case n3.NumericLiteralType:
          case n3.BooleanLiteralType:
            A3 = String(J3.value);
            break;
          default:
            p3.throwError("Unknown type " + J3.type);
        }
        return A3;
      }(W3, R3.compact, R3.topLevel);
    }, t3.Syntax = n3;
  })();
})), ya$1 = (Pu$1.parseType, Pu$1.parseParamType, Pu$1.stringify, Pu$1.Syntax, gt$3(function(e28, t3) {
  (function() {
    var n3, r3, i, a3, s3, o3;
    function u3(C3, k3, F3) {
      return C3.slice(k3, F3);
    }
    function c3(C3) {
      return C3 === "param" || C3 === "argument" || C3 === "arg";
    }
    function f3(C3) {
      return C3 === "return" || C3 === "returns";
    }
    function p3(C3) {
      return C3 === "property" || C3 === "prop";
    }
    function d3(C3) {
      return c3(C3) || p3(C3) || C3 === "alias" || C3 === "this" || C3 === "mixes" || C3 === "requires";
    }
    function m3(C3) {
      return p3(C3) || c3(C3);
    }
    function y3(C3) {
      return c3(C3) || f3(C3) || C3 === "define" || C3 === "enum" || C3 === "implements" || C3 === "this" || C3 === "type" || C3 === "typedef" || p3(C3);
    }
    a3 = Os$1, n3 = Pu$1, r3 = Cs$1, o3 = Object.prototype.hasOwnProperty, s3 = function(C3, k3) {
      return o3.call(C3, k3);
    };
    var v3 = "[ \\f\\t\\v\\u00a0\\u1680\\u180e\\u2000-\\u200a\\u202f\\u205f\\u3000\\ufeff]", b3 = "(" + v3 + "*(?:\\*" + v3 + `?)?)(.+|[\r
\u2028\u2029])`;
    function x3(C3) {
      return C3.replace(/^\/\*\*?/, "").replace(/\*\/$/, "").replace(new RegExp(b3, "g"), "$2").replace(/\s*$/, "");
    }
    (function(C3) {
      var k3, F3, B3, O3, S3, w3, D3, I3, L3;
      function V10() {
        var A3 = S3.charCodeAt(F3);
        return F3 += 1, !a3.code.isLineTerminator(A3) || A3 === 13 && S3.charCodeAt(F3) === 10 || (B3 += 1), String.fromCharCode(A3);
      }
      function K3(A3, M3, ne2) {
        for (var de2, he2, j3, ie2, fe2 = false; F3 < M3; ) {
          if (de2 = S3.charCodeAt(F3), !a3.code.isWhiteSpace(de2)) {
            if (de2 === 123) {
              V10();
              break;
            }
            fe2 = true;
            break;
          }
          V10();
        }
        if (fe2)
          return null;
        for (he2 = 1, j3 = ""; F3 < M3; )
          if (de2 = S3.charCodeAt(F3), a3.code.isLineTerminator(de2))
            V10();
          else {
            if (de2 === 125) {
              if ((he2 -= 1) === 0) {
                V10();
                break;
              }
            } else
              de2 === 123 && (he2 += 1);
            j3 === "" && (ie2 = F3), j3 += V10();
          }
        return he2 !== 0 ? r3.throwError("Braces are not balanced") : m3(A3) ? n3.parseParamType(j3, { startIndex: J3(ie2), range: ne2 }) : n3.parseType(j3, { startIndex: J3(ie2), range: ne2 });
      }
      function W3(A3) {
        var M3;
        if (!a3.code.isIdentifierStartES5(S3.charCodeAt(F3)) && !S3[F3].match(/[0-9]/))
          return null;
        for (M3 = V10(); F3 < A3 && a3.code.isIdentifierPartES5(S3.charCodeAt(F3)); )
          M3 += V10();
        return M3;
      }
      function R3(A3) {
        for (; F3 < A3 && (a3.code.isWhiteSpace(S3.charCodeAt(F3)) || a3.code.isLineTerminator(S3.charCodeAt(F3))); )
          V10();
      }
      function q3(A3, M3, ne2) {
        var de2, he2, j3 = "";
        if (R3(A3), F3 >= A3)
          return null;
        if (S3.charCodeAt(F3) === 91) {
          if (!M3)
            return null;
          de2 = true, j3 = V10();
        }
        if (j3 += W3(A3), ne2)
          for (S3.charCodeAt(F3) !== 58 || j3 !== "module" && j3 !== "external" && j3 !== "event" || (j3 += V10(), j3 += W3(A3)), S3.charCodeAt(F3) === 91 && S3.charCodeAt(F3 + 1) === 93 && (j3 += V10(), j3 += V10()); S3.charCodeAt(F3) === 46 || S3.charCodeAt(F3) === 47 || S3.charCodeAt(F3) === 35 || S3.charCodeAt(F3) === 45 || S3.charCodeAt(F3) === 126; )
            j3 += V10(), j3 += W3(A3);
        if (de2) {
          if (R3(A3), S3.charCodeAt(F3) === 61) {
            var ie2;
            j3 += V10(), R3(A3);
            for (var fe2 = 1; F3 < A3; ) {
              if (ie2 = S3.charCodeAt(F3), a3.code.isWhiteSpace(ie2) && (he2 || (R3(A3), ie2 = S3.charCodeAt(F3))), ie2 === 39 && (he2 ? he2 === "'" && (he2 = "") : he2 = "'"), ie2 === 34 && (he2 ? he2 === '"' && (he2 = "") : he2 = '"'), ie2 === 91)
                fe2++;
              else if (ie2 === 93 && --fe2 == 0)
                break;
              j3 += V10();
            }
          }
          if (R3(A3), F3 >= A3 || S3.charCodeAt(F3) !== 93)
            return null;
          j3 += V10();
        }
        return j3;
      }
      function J3(A3) {
        return S3 === w3 ? A3 : function(M3, ne2) {
          for (var de2, he2 = M3.replace(/^\/\*\*?/, ""), j3 = 0, ie2 = new RegExp(b3, "g"); de2 = ie2.exec(he2); )
            if (j3 += de2[1].length, de2.index + de2[0].length > ne2 + j3)
              return ne2 + j3 + M3.length - he2.length;
          return M3.replace(/\*\/$/, "").replace(/\s*$/, "").length;
        }(w3, A3);
      }
      function X3(A3, M3) {
        this._options = A3, this._title = M3.toLowerCase(), this._tag = { title: M3, description: null }, this._options.lineNumbers && (this._tag.lineNumber = B3), this._first = F3 - M3.length - 1, this._last = 0, this._extra = {};
      }
      function ce2(A3) {
        var M3, ne2;
        if (!function() {
          for (; F3 < O3 && S3.charCodeAt(F3) !== 64; )
            V10();
          return !(F3 >= O3) && (r3.assert(S3.charCodeAt(F3) === 64), true);
        }())
          return null;
        for (ne2 = (M3 = new X3(A3, function() {
          var de2, he2 = "";
          for (V10(); F3 < O3 && ((de2 = S3.charCodeAt(F3)) >= 97 && de2 <= 122 || de2 >= 65 && de2 <= 90 || de2 >= 48 && de2 <= 57); )
            he2 += V10();
          return he2;
        }())).parse(); F3 < M3._last; )
          V10();
        return ne2;
      }
      X3.prototype.addError = function(A3) {
        var M3 = Array.prototype.slice.call(arguments, 1), ne2 = A3.replace(/%(\d)/g, function(de2, he2) {
          return r3.assert(he2 < M3.length, "Message reference must be in range"), M3[he2];
        });
        return this._tag.errors || (this._tag.errors = []), L3 && r3.throwError(ne2), this._tag.errors.push(ne2), D3;
      }, X3.prototype.parseType = function() {
        if (y3(this._title))
          try {
            if (this._tag.type = K3(this._title, this._last, this._options.range), !(this._tag.type || c3(this._title) || f3(this._title) || this.addError("Missing or invalid tag type")))
              return false;
          } catch (A3) {
            if (this._tag.type = null, !this.addError(A3.message))
              return false;
          }
        else if (function(A3) {
          return y3(A3) || A3 === "throws" || A3 === "const" || A3 === "constant" || A3 === "namespace" || A3 === "member" || A3 === "var" || A3 === "module" || A3 === "constructor" || A3 === "class" || A3 === "extends" || A3 === "augments" || A3 === "public" || A3 === "private" || A3 === "protected";
        }(this._title))
          try {
            this._tag.type = K3(this._title, this._last, this._options.range);
          } catch {
          }
        return true;
      }, X3.prototype._parseNamePath = function(A3) {
        var M3;
        return !!((M3 = q3(this._last, I3 && m3(this._title), true)) || A3 || this.addError("Missing or invalid tag name")) && (this._tag.name = M3, true);
      }, X3.prototype.parseNamePath = function() {
        return this._parseNamePath(false);
      }, X3.prototype.parseNamePathOptional = function() {
        return this._parseNamePath(true);
      }, X3.prototype.parseName = function() {
        var A3, M3;
        if (function(ne2) {
          return d3(ne2) || ne2 === "const" || ne2 === "constant";
        }(this._title))
          if (this._tag.name = q3(this._last, I3 && m3(this._title), function(ne2) {
            return p3(ne2) || c3(ne2);
          }(this._title)), this._tag.name)
            (M3 = this._tag.name).charAt(0) === "[" && M3.charAt(M3.length - 1) === "]" && ((A3 = M3.substring(1, M3.length - 1).split("=")).length > 1 && (this._tag.default = A3.slice(1).join("=")), this._tag.name = A3[0], this._tag.type && this._tag.type.type !== "OptionalType" && (this._tag.type = { type: "OptionalType", expression: this._tag.type }));
          else {
            if (!d3(this._title))
              return true;
            if (c3(this._title) && this._tag.type && this._tag.type.name)
              this._extra.name = this._tag.type, this._tag.name = this._tag.type.name, this._tag.type = null;
            else if (!this.addError("Missing or invalid tag name"))
              return false;
          }
        return true;
      }, X3.prototype.parseDescription = function() {
        var A3 = u3(S3, F3, this._last).trim();
        return A3 && (/^-\s+/.test(A3) && (A3 = A3.substring(2)), this._tag.description = A3), true;
      }, X3.prototype.parseCaption = function() {
        var A3 = u3(S3, F3, this._last).trim(), M3 = A3.indexOf("<caption>"), ne2 = A3.indexOf("</caption>");
        return M3 >= 0 && ne2 >= 0 ? (this._tag.caption = A3.substring(M3 + 9, ne2).trim(), this._tag.description = A3.substring(ne2 + 10).trim()) : this._tag.description = A3, true;
      }, X3.prototype.parseKind = function() {
        var A3, M3;
        return M3 = { class: true, constant: true, event: true, external: true, file: true, function: true, member: true, mixin: true, module: true, namespace: true, typedef: true }, A3 = u3(S3, F3, this._last).trim(), this._tag.kind = A3, !(!s3(M3, A3) && !this.addError("Invalid kind name '%0'", A3));
      }, X3.prototype.parseAccess = function() {
        var A3;
        return A3 = u3(S3, F3, this._last).trim(), this._tag.access = A3, !(A3 !== "private" && A3 !== "protected" && A3 !== "public" && !this.addError("Invalid access name '%0'", A3));
      }, X3.prototype.parseThis = function() {
        var A3 = u3(S3, F3, this._last).trim();
        return A3 && A3.charAt(0) === "{" ? this.parseType() && this._tag.type.type === "NameExpression" || this._tag.type.type === "UnionType" ? (this._tag.name = this._tag.type.name, true) : this.addError("Invalid name for this") : this.parseNamePath();
      }, X3.prototype.parseVariation = function() {
        var A3, M3;
        return M3 = u3(S3, F3, this._last).trim(), A3 = parseFloat(M3, 10), this._tag.variation = A3, !(isNaN(A3) && !this.addError("Invalid variation '%0'", M3));
      }, X3.prototype.ensureEnd = function() {
        var A3 = u3(S3, F3, this._last).trim();
        return !(A3 && !this.addError("Unknown content '%0'", A3));
      }, X3.prototype.epilogue = function() {
        var A3;
        return A3 = this._tag.description, !(m3(this._title) && !this._tag.type && A3 && A3.charAt(0) === "[" && (this._tag.type = this._extra.name, this._tag.name || (this._tag.name = void 0), !I3 && !this.addError("Missing or invalid tag name")));
      }, k3 = { access: ["parseAccess"], alias: ["parseNamePath", "ensureEnd"], augments: ["parseType", "parseNamePathOptional", "ensureEnd"], constructor: ["parseType", "parseNamePathOptional", "ensureEnd"], class: ["parseType", "parseNamePathOptional", "ensureEnd"], extends: ["parseType", "parseNamePathOptional", "ensureEnd"], example: ["parseCaption"], deprecated: ["parseDescription"], global: ["ensureEnd"], inner: ["ensureEnd"], instance: ["ensureEnd"], kind: ["parseKind"], mixes: ["parseNamePath", "ensureEnd"], mixin: ["parseNamePathOptional", "ensureEnd"], member: ["parseType", "parseNamePathOptional", "ensureEnd"], method: ["parseNamePathOptional", "ensureEnd"], module: ["parseType", "parseNamePathOptional", "ensureEnd"], func: ["parseNamePathOptional", "ensureEnd"], function: ["parseNamePathOptional", "ensureEnd"], var: ["parseType", "parseNamePathOptional", "ensureEnd"], name: ["parseNamePath", "ensureEnd"], namespace: ["parseType", "parseNamePathOptional", "ensureEnd"], private: ["parseType", "parseDescription"], protected: ["parseType", "parseDescription"], public: ["parseType", "parseDescription"], readonly: ["ensureEnd"], requires: ["parseNamePath", "ensureEnd"], since: ["parseDescription"], static: ["ensureEnd"], summary: ["parseDescription"], this: ["parseThis", "ensureEnd"], todo: ["parseDescription"], typedef: ["parseType", "parseNamePathOptional"], variation: ["parseVariation"], version: ["parseDescription"] }, X3.prototype.parse = function() {
        var A3, M3, ne2;
        if (!this._title && !this.addError("Missing or invalid title"))
          return null;
        for (this._last = function() {
          var de2, he2, j3 = F3;
          for (he2 = false; j3 < O3; ) {
            if (de2 = S3.charCodeAt(j3), !a3.code.isLineTerminator(de2) || de2 === 13 && S3.charCodeAt(j3 + 1) === 10) {
              if (he2) {
                if (de2 === 64)
                  break;
                a3.code.isWhiteSpace(de2) || (he2 = false);
              }
            } else
              he2 = true;
            j3 += 1;
          }
          return j3;
        }(this._title), this._options.range && (this._tag.range = [this._first, S3.slice(0, this._last).replace(/\s*$/, "").length].map(J3)), A3 = 0, M3 = (ne2 = s3(k3, this._title) ? k3[this._title] : ["parseType", "parseName", "parseDescription", "epilogue"]).length; A3 < M3; ++A3)
          if (!this[ne2[A3]]())
            return null;
        return this._tag;
      }, C3.parse = function(A3, M3) {
        var ne2, de2, he2, j3, ie2, fe2 = [];
        if (M3 === void 0 && (M3 = {}), S3 = typeof M3.unwrap == "boolean" && M3.unwrap ? x3(A3) : A3, w3 = A3, M3.tags)
          if (Array.isArray(M3.tags))
            for (he2 = {}, j3 = 0, ie2 = M3.tags.length; j3 < ie2; j3++)
              typeof M3.tags[j3] == "string" ? he2[M3.tags[j3]] = true : r3.throwError('Invalid "tags" parameter: ' + M3.tags);
          else
            r3.throwError('Invalid "tags" parameter: ' + M3.tags);
        for (O3 = S3.length, F3 = 0, B3 = 0, D3 = M3.recoverable, I3 = M3.sloppy, L3 = M3.strict, de2 = function(ge2) {
          var Fe2, Pe2, _3 = "";
          for (Pe2 = true; F3 < O3 && (Fe2 = S3.charCodeAt(F3), !Pe2 || Fe2 !== 64); )
            a3.code.isLineTerminator(Fe2) ? Pe2 = true : Pe2 && !a3.code.isWhiteSpace(Fe2) && (Pe2 = false), _3 += V10();
          return ge2 ? _3 : _3.trim();
        }(M3.preserveWhitespace); ne2 = ce2(M3); )
          he2 && !he2.hasOwnProperty(ne2.title) || fe2.push(ne2);
        return { description: de2, tags: fe2 };
      };
    })(i = {}), t3.version = r3.VERSION, t3.parse = i.parse, t3.parseType = n3.parseType, t3.parseParamType = n3.parseParamType, t3.unwrapComment = x3, t3.Syntax = function(C3) {
      var k3, F3 = {};
      for (k3 in C3)
        C3.hasOwnProperty(k3) && (F3[k3] = C3[k3]);
      return F3;
    }(n3.Syntax), t3.Error = r3.DoctrineError, t3.type = { Syntax: t3.Syntax, parseType: n3.parseType, parseParamType: n3.parseParamType, stringify: n3.stringify };
  })();
})), FI = (ya$1.version, ya$1.parse, ya$1.parseType, ya$1.parseParamType, ya$1.unwrapComment, ya$1.Syntax, ya$1.Error, ya$1.type, Cr$1(hI)), wI = regeneratorRuntime.mark(AA);
function eu$1(e28) {
  return e28 && xe$3(e28) == "object" && "default" in e28 ? e28.default : e28;
}
var l0 = eu$1(Os$1), AI = eu$1(GP), ao$1 = eu$1(FI), CA = eu$1(function(e28) {
  return new c0(e28);
}), Yb$1 = eu$1(SI), _I = eu$1(ya$1), P$s = ye$4.createCommonjsModule(function(e28) {
  function t3(j3, ie2, fe2) {
    var ge2 = j3.identifier, Fe2 = ie2 === 0 || fe2[ie2 - 1].identifier !== ge2;
    return ge2 && j3.init === false && j3.isWrite() && Fe2;
  }
  function n3(j3) {
    return j3[0] !== j3[0].toLocaleLowerCase();
  }
  function r3(j3) {
    return j3.id && n3(j3.id.name);
  }
  function i(j3) {
    for (var ie2 = j3; ie2; ie2 = ie2.parent)
      if (R3.test(ie2.type))
        return ie2;
    return null;
  }
  function a3(j3) {
    return !(!j3 || !R3.test(j3.type));
  }
  function s3(j3) {
    return !(!j3 || !q3.test(j3.type));
  }
  function o3(j3) {
    return e28.exports.isNullLiteral(j3) || j3.type === "Identifier" && j3.name === "undefined" || j3.type === "UnaryExpression" && j3.operator === "void";
  }
  function u3(j3) {
    return j3.parent.type === "CallExpression" && j3.parent.callee === j3;
  }
  function c3(j3) {
    return j3.type === "MemberExpression" && j3.object.type === "Identifier" && j3.object.name === "Reflect" && j3.property.type === "Identifier" && j3.property.name === "apply" && j3.computed === false;
  }
  function f3(j3) {
    return j3.type === "MemberExpression" && j3.object.type === "Identifier" && J3.test(j3.object.name) && j3.property.type === "Identifier" && j3.property.name === "from" && j3.computed === false;
  }
  function p3(j3) {
    for (var ie2 = j3; ie2.type === "MemberExpression" && !ie2.computed; ie2 = ie2.property)
      if (ie2.property.type === "Identifier")
        return X3.test(ie2.property.name);
    return false;
  }
  function d3(j3) {
    return function(ie2) {
      return !j3(ie2);
    };
  }
  function m3(j3, ie2) {
    var fe2 = ie2.getJSDocComment(j3);
    return !(!fe2 || !A3.test(fe2.value)) || ie2.getCommentsBefore(j3).some(function(ge2) {
      return A3.test(ge2.value);
    });
  }
  function y3(j3) {
    return j3.value === "=>" && j3.type === "Punctuator";
  }
  function v3(j3) {
    return j3.value === "," && j3.type === "Punctuator";
  }
  function b3(j3) {
    return j3.value === "." && j3.type === "Punctuator";
  }
  function x3(j3) {
    return j3.value === ";" && j3.type === "Punctuator";
  }
  function C3(j3) {
    return j3.value === ":" && j3.type === "Punctuator";
  }
  function k3(j3) {
    return j3.value === "(" && j3.type === "Punctuator";
  }
  function F3(j3) {
    return j3.value === ")" && j3.type === "Punctuator";
  }
  function B3(j3) {
    return j3.value === "[" && j3.type === "Punctuator";
  }
  function O3(j3) {
    return j3.value === "]" && j3.type === "Punctuator";
  }
  function S3(j3) {
    return j3.value === "{" && j3.type === "Punctuator";
  }
  function w3(j3) {
    return j3.value === "}" && j3.type === "Punctuator";
  }
  function D3(j3, ie2) {
    return j3.id ? ie2.getTokenAfter(j3.id, k3) : ie2.getFirstToken(j3, k3);
  }
  var I3 = ye$4.require$$0$1, L3 = I3.breakableTypePattern, V10 = I3.createGlobalLinebreakMatcher, K3 = I3.lineBreakPattern, W3 = I3.shebangPattern, R3 = /^(?:Function(?:Declaration|Expression)|ArrowFunctionExpression)$/, q3 = /^(?:DoWhile|For|ForIn|ForOf|While)Statement$/, J3 = /Array$/, X3 = /^(?:every|filter|find|findIndex|forEach|map|some)$/, ce2 = /^(?:bind|call|apply)$/, A3 = /^[\t-\r \*\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*@this/m, M3 = /* @__PURE__ */ new Set([`\r
`, "\r", `
`, "\u2028", "\u2029"]), ne2 = /* @__PURE__ */ new Set(["Program", "BlockStatement", "SwitchCase"]), de2 = /^(0|[1-9][0-9]*)$/, he2 = /^(?:(?:[\0-\[\]-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\(?:[\0-\/8-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\0(?![0-9]))*\\(?:[1-7]|0[0-9])/;
  e28.exports = { COMMENTS_IGNORE_PATTERN: /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:eslint|jshint[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+|jslint[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+|istanbul[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+|globals?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+|exported[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+|jscs)/, LINEBREAKS: M3, LINEBREAK_MATCHER: K3, SHEBANG_MATCHER: W3, STATEMENT_LIST_PARENTS: ne2, isTokenOnSameLine: function(j3, ie2) {
    return j3.loc.end.line === ie2.loc.start.line;
  }, isNullOrUndefined: o3, isCallee: u3, isES5Constructor: r3, getUpperFunction: i, isFunction: a3, isLoop: s3, isInLoop: function(j3) {
    for (var ie2 = j3; ie2 && !a3(ie2); ie2 = ie2.parent)
      if (s3(ie2))
        return true;
    return false;
  }, isArrayFromMethod: f3, isParenthesised: function(j3, ie2) {
    var fe2 = j3.getTokenBefore(ie2), ge2 = j3.getTokenAfter(ie2);
    return !(!fe2 || !ge2) && fe2.value === "(" && fe2.range[1] <= ie2.range[0] && ge2.value === ")" && ge2.range[0] >= ie2.range[1];
  }, createGlobalLinebreakMatcher: V10, equalTokens: function(j3, ie2, fe2) {
    var ge2 = fe2.getTokens(j3), Fe2 = fe2.getTokens(ie2);
    if (ge2.length !== Fe2.length)
      return false;
    for (var Pe2 = 0; Pe2 < ge2.length; ++Pe2)
      if (ge2[Pe2].type !== Fe2[Pe2].type || ge2[Pe2].value !== Fe2[Pe2].value)
        return false;
    return true;
  }, isArrowToken: y3, isClosingBraceToken: w3, isClosingBracketToken: O3, isClosingParenToken: F3, isColonToken: C3, isCommaToken: v3, isCommentToken: function(j3) {
    return j3.type === "Line" || j3.type === "Block" || j3.type === "Shebang";
  }, isDotToken: b3, isKeywordToken: function(j3) {
    return j3.type === "Keyword";
  }, isNotClosingBraceToken: d3(w3), isNotClosingBracketToken: d3(O3), isNotClosingParenToken: d3(F3), isNotColonToken: d3(C3), isNotCommaToken: d3(v3), isNotDotToken: d3(b3), isNotOpeningBraceToken: d3(S3), isNotOpeningBracketToken: d3(B3), isNotOpeningParenToken: d3(k3), isNotSemicolonToken: d3(x3), isOpeningBraceToken: S3, isOpeningBracketToken: B3, isOpeningParenToken: k3, isSemicolonToken: x3, isStringLiteral: function(j3) {
    return j3.type === "Literal" && typeof j3.value == "string" || j3.type === "TemplateLiteral";
  }, isBreakableStatement: function(j3) {
    return L3.test(j3.type);
  }, getModifyingReferences: function(j3) {
    return j3.filter(t3);
  }, isSurroundedBy: function(j3, ie2) {
    return j3[0] === ie2 && j3[j3.length - 1] === ie2;
  }, isDirectiveComment: function(j3) {
    var ie2 = j3.value.trim();
    return j3.type === "Line" && ie2.indexOf("eslint-") === 0 || j3.type === "Block" && (ie2.indexOf("global ") === 0 || ie2.indexOf("eslint ") === 0 || ie2.indexOf("eslint-") === 0);
  }, getTrailingStatement: l0.ast.trailingStatement, getVariableByName: function(j3, ie2) {
    for (var fe2 = j3; fe2; ) {
      var ge2 = fe2.set.get(ie2);
      if (ge2)
        return ge2;
      fe2 = fe2.upper;
    }
    return null;
  }, isDefaultThisBinding: function(j3, ie2) {
    var fe2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, ge2 = fe2.capIsConstructor, Fe2 = ge2 === void 0 || ge2;
    if (Fe2 && r3(j3) || m3(j3, ie2))
      return false;
    for (var Pe2 = j3.id === null, _3 = j3; _3; ) {
      var Q3 = _3.parent;
      switch (Q3.type) {
        case "LogicalExpression":
        case "ConditionalExpression":
          _3 = Q3;
          break;
        case "ReturnStatement":
          var Y3 = i(Q3);
          if (Y3 === null || !u3(Y3))
            return true;
          _3 = Y3.parent;
          break;
        case "ArrowFunctionExpression":
          if (_3 !== Q3.body || !u3(Q3))
            return true;
          _3 = Q3.parent;
          break;
        case "Property":
        case "MethodDefinition":
          return Q3.value !== _3;
        case "AssignmentExpression":
        case "AssignmentPattern":
          return Q3.left.type !== "MemberExpression" && !(Fe2 && Pe2 && Q3.left.type === "Identifier" && n3(Q3.left.name));
        case "VariableDeclarator":
          return !(Fe2 && Pe2 && Q3.init === _3 && Q3.id.type === "Identifier" && n3(Q3.id.name));
        case "MemberExpression":
          return Q3.object !== _3 || Q3.property.type !== "Identifier" || !ce2.test(Q3.property.name) || !u3(Q3) || Q3.parent.arguments.length === 0 || o3(Q3.parent.arguments[0]);
        case "CallExpression":
          return c3(Q3.callee) ? Q3.arguments.length !== 3 || Q3.arguments[0] !== _3 || o3(Q3.arguments[1]) : f3(Q3.callee) ? Q3.arguments.length !== 3 || Q3.arguments[1] !== _3 || o3(Q3.arguments[2]) : !p3(Q3.callee) || Q3.arguments.length !== 2 || Q3.arguments[0] !== _3 || o3(Q3.arguments[1]);
        default:
          return true;
      }
    }
    return true;
  }, getPrecedence: function(j3) {
    switch (j3.type) {
      case "SequenceExpression":
        return 0;
      case "AssignmentExpression":
      case "ArrowFunctionExpression":
      case "YieldExpression":
        return 1;
      case "ConditionalExpression":
        return 3;
      case "LogicalExpression":
        switch (j3.operator) {
          case "||":
            return 4;
          case "&&":
            return 5;
        }
      case "BinaryExpression":
        switch (j3.operator) {
          case "|":
            return 6;
          case "^":
            return 7;
          case "&":
            return 8;
          case "==":
          case "!=":
          case "===":
          case "!==":
            return 9;
          case "<":
          case "<=":
          case ">":
          case ">=":
          case "in":
          case "instanceof":
            return 10;
          case "<<":
          case ">>":
          case ">>>":
            return 11;
          case "+":
          case "-":
            return 12;
          case "*":
          case "/":
          case "%":
            return 13;
          case "**":
            return 15;
        }
      case "UnaryExpression":
      case "AwaitExpression":
        return 16;
      case "UpdateExpression":
        return 17;
      case "CallExpression":
      case "ImportExpression":
        return 18;
      case "NewExpression":
        return 19;
      default:
        return 20;
    }
  }, isEmptyBlock: function(j3) {
    return !(!j3 || j3.type !== "BlockStatement" || j3.body.length !== 0);
  }, isEmptyFunction: function(j3) {
    return a3(j3) && e28.exports.isEmptyBlock(j3.body);
  }, getStaticPropertyName: function(j3) {
    var ie2;
    switch (j3 && j3.type) {
      case "Property":
      case "MethodDefinition":
        ie2 = j3.key;
        break;
      case "MemberExpression":
        ie2 = j3.property;
    }
    switch (ie2 && ie2.type) {
      case "Literal":
        return ie2.value + "";
      case "TemplateLiteral":
        if (ie2.expressions.length === 0 && ie2.quasis.length === 1)
          return ie2.quasis[0].value.cooked;
        break;
      case "Identifier":
        if (!j3.computed)
          return ie2.name;
    }
    return null;
  }, getDirectivePrologue: function(j3) {
    var ie2 = [];
    if (j3.type === "Program" || j3.type === "FunctionDeclaration" || j3.type === "FunctionExpression" || j3.type === "ArrowFunctionExpression" && j3.body.type === "BlockStatement") {
      var fe2 = j3.type === "Program" ? j3.body : j3.body.body, ge2 = true, Fe2 = false, Pe2 = void 0;
      try {
        for (var _3, Q3 = fe2[Symbol.iterator](); !(ge2 = (_3 = Q3.next()).done); ge2 = true) {
          var Y3 = _3.value;
          if (Y3.type !== "ExpressionStatement" || Y3.expression.type !== "Literal")
            break;
          ie2.push(Y3);
        }
      } catch (ae2) {
        Fe2 = true, Pe2 = ae2;
      } finally {
        try {
          ge2 || Q3.return == null || Q3.return();
        } finally {
          if (Fe2)
            throw Pe2;
        }
      }
    }
    return ie2;
  }, isDecimalInteger: function(j3) {
    return j3.type === "Literal" && typeof j3.value == "number" && de2.test(j3.raw);
  }, isDecimalIntegerNumericToken: function(j3) {
    return j3.type === "Numeric" && de2.test(j3.value);
  }, getFunctionNameWithKind: function(j3) {
    var ie2 = j3.parent, fe2 = [];
    if (ie2.type === "MethodDefinition" && ie2.static && fe2.push("static"), j3.async && fe2.push("async"), j3.generator && fe2.push("generator"), j3.type === "ArrowFunctionExpression")
      fe2.push("arrow", "function");
    else if (ie2.type === "Property" || ie2.type === "MethodDefinition") {
      if (ie2.kind === "constructor")
        return "constructor";
      ie2.kind === "get" ? fe2.push("getter") : ie2.kind === "set" ? fe2.push("setter") : fe2.push("method");
    } else
      fe2.push("function");
    if (j3.id)
      fe2.push("'".concat(j3.id.name, "'"));
    else {
      var ge2 = e28.exports.getStaticPropertyName(ie2);
      ge2 !== null && fe2.push("'".concat(ge2, "'"));
    }
    return fe2.join(" ");
  }, getFunctionHeadLoc: function(j3, ie2) {
    var fe2 = j3.parent, ge2 = null, Fe2 = null;
    if (j3.type === "ArrowFunctionExpression") {
      var Pe2 = ie2.getTokenBefore(j3.body, y3);
      ge2 = Pe2.loc.start, Fe2 = Pe2.loc.end;
    } else
      fe2.type === "Property" || fe2.type === "MethodDefinition" ? (ge2 = fe2.loc.start, Fe2 = D3(j3, ie2).loc.start) : (ge2 = j3.loc.start, Fe2 = D3(j3, ie2).loc.start);
    return { start: Object.assign({}, ge2), end: Object.assign({}, Fe2) };
  }, getNextLocation: function(j3, ie2) {
    var fe2 = j3.getIndexFromLoc(ie2);
    return fe2 + 1 > j3.text.length ? null : j3.getLocFromIndex(fe2 + 1);
  }, getParenthesisedText: function(j3, ie2) {
    for (var fe2 = j3.getFirstToken(ie2), ge2 = j3.getLastToken(ie2); j3.getTokenBefore(fe2) && j3.getTokenBefore(fe2).type === "Punctuator" && j3.getTokenBefore(fe2).value === "(" && j3.getTokenAfter(ge2) && j3.getTokenAfter(ge2).type === "Punctuator" && j3.getTokenAfter(ge2).value === ")"; )
      fe2 = j3.getTokenBefore(fe2), ge2 = j3.getTokenAfter(ge2);
    return j3.getText().slice(fe2.range[0], ge2.range[1]);
  }, couldBeError: function(j3) {
    switch (j3.type) {
      case "Identifier":
      case "CallExpression":
      case "NewExpression":
      case "MemberExpression":
      case "TaggedTemplateExpression":
      case "YieldExpression":
      case "AwaitExpression":
        return true;
      case "AssignmentExpression":
        return e28.exports.couldBeError(j3.right);
      case "SequenceExpression":
        var ie2 = j3.expressions;
        return ie2.length !== 0 && e28.exports.couldBeError(ie2[ie2.length - 1]);
      case "LogicalExpression":
        return e28.exports.couldBeError(j3.left) || e28.exports.couldBeError(j3.right);
      case "ConditionalExpression":
        return e28.exports.couldBeError(j3.consequent) || e28.exports.couldBeError(j3.alternate);
      default:
        return false;
    }
  }, isNullLiteral: function(j3) {
    return j3.type === "Literal" && j3.value === null && !j3.regex && !j3.bigint;
  }, canTokensBeAdjacent: function(j3, ie2) {
    var fe2;
    if (typeof j3 == "string") {
      var ge2 = ye$4.espree.tokenize(j3, { ecmaVersion: 2015 });
      fe2 = ge2[ge2.length - 1];
    } else
      fe2 = j3;
    var Fe2 = typeof ie2 == "string" ? ye$4.espree.tokenize(ie2, { ecmaVersion: 2015 })[0] : ie2;
    if (fe2.type === "Punctuator" || Fe2.type === "Punctuator") {
      if (fe2.type === "Punctuator" && Fe2.type === "Punctuator") {
        var Pe2 = /* @__PURE__ */ new Set(["+", "++"]), _3 = /* @__PURE__ */ new Set(["-", "--"]);
        return !(Pe2.has(fe2.value) && Pe2.has(Fe2.value) || _3.has(fe2.value) && _3.has(Fe2.value));
      }
      return true;
    }
    return fe2.type === "String" || Fe2.type === "String" || fe2.type === "Template" || Fe2.type === "Template" || !(fe2.type === "Numeric" || Fe2.type !== "Numeric" || !Fe2.value.startsWith("."));
  }, getNameLocationInGlobalDirectiveComment: function(j3, ie2, fe2) {
    var ge2 = new RegExp("[\\s,]".concat(ye$4.lodash.escapeRegExp(fe2), "(?:$|[\\s,:])"), "gu");
    ge2.lastIndex = ie2.value.indexOf("global") + 6;
    var Fe2 = ge2.exec(ie2.value);
    return j3.getLocFromIndex(ie2.range[0] + 2 + (Fe2 ? Fe2.index + 1 : 0));
  }, hasOctalEscapeSequence: function(j3) {
    return he2.test(j3);
  } };
});
P$s.COMMENTS_IGNORE_PATTERN, P$s.LINEBREAKS, P$s.LINEBREAK_MATCHER, P$s.SHEBANG_MATCHER, P$s.STATEMENT_LIST_PARENTS, P$s.isTokenOnSameLine, P$s.isNullOrUndefined, P$s.isCallee, P$s.isES5Constructor, P$s.getUpperFunction, P$s.isFunction, P$s.isLoop, P$s.isInLoop, P$s.isArrayFromMethod, P$s.isParenthesised, P$s.createGlobalLinebreakMatcher, P$s.equalTokens, P$s.isArrowToken, P$s.isClosingBraceToken, P$s.isClosingBracketToken, P$s.isClosingParenToken, P$s.isColonToken, P$s.isCommaToken, P$s.isCommentToken, P$s.isDotToken, P$s.isKeywordToken, P$s.isNotClosingBraceToken, P$s.isNotClosingBracketToken, P$s.isNotClosingParenToken, P$s.isNotColonToken, P$s.isNotCommaToken, P$s.isNotDotToken, P$s.isNotOpeningBraceToken, P$s.isNotOpeningBracketToken, P$s.isNotOpeningParenToken, P$s.isNotSemicolonToken, P$s.isOpeningBraceToken, P$s.isOpeningBracketToken, P$s.isOpeningParenToken, P$s.isSemicolonToken, P$s.isStringLiteral, P$s.isBreakableStatement, P$s.getModifyingReferences, P$s.isSurroundedBy, P$s.isDirectiveComment, P$s.getTrailingStatement, P$s.getVariableByName, P$s.isDefaultThisBinding, P$s.getPrecedence, P$s.isEmptyBlock, P$s.isEmptyFunction, P$s.getStaticPropertyName, P$s.getDirectivePrologue, P$s.isDecimalInteger, P$s.isDecimalIntegerNumericToken, P$s.getFunctionNameWithKind, P$s.getFunctionHeadLoc, P$s.getNextLocation, P$s.getParenthesisedText, P$s.couldBeError, P$s.isNullLiteral, P$s.canTokensBeAdjacent, P$s.getNameLocationInGlobalDirectiveComment, P$s.hasOctalEscapeSequence;
function TI(e28) {
  return e28.kind === "get" || e28.kind === "set";
}
function Zb$1(e28, t3) {
  return e28.type === "Identifier" && e28.name === t3;
}
function Kl(e28, t3, n3, r3) {
  var i = e28.parent;
  return i.type === "CallExpression" && i.callee.type === "MemberExpression" && i.callee.computed === false && Zb$1(i.callee.object, n3) && Zb$1(i.callee.property, r3) && i.arguments[t3] === e28;
}
var PI = { meta: { type: "suggestion", docs: { description: "enforce getter and setter pairs in objects and classes", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/accessor-pairs" }, schema: [{ type: "object", properties: { getWithoutSet: { type: "boolean", default: false }, setWithoutGet: { type: "boolean", default: true }, enforceForClassMembers: { type: "boolean", default: false } }, additionalProperties: false }], messages: { missingGetterInPropertyDescriptor: "Getter is not present in property descriptor.", missingSetterInPropertyDescriptor: "Setter is not present in property descriptor.", missingGetterInObjectLiteral: "Getter is not present for {{ name }}.", missingSetterInObjectLiteral: "Setter is not present for {{ name }}.", missingGetterInClass: "Getter is not present for class {{ name }}.", missingSetterInClass: "Setter is not present for class {{ name }}." } }, create: function(e28) {
  function t3(d3, m3) {
    d3.type === "Property" ? e28.report({ node: d3, messageId: "".concat(m3, "InObjectLiteral"), loc: P$s.getFunctionHeadLoc(d3.value, f3), data: { name: P$s.getFunctionNameWithKind(d3.value) } }) : d3.type === "MethodDefinition" ? e28.report({ node: d3, messageId: "".concat(m3, "InClass"), loc: P$s.getFunctionHeadLoc(d3.value, f3), data: { name: P$s.getFunctionNameWithKind(d3.value) } }) : e28.report({ node: d3, messageId: "".concat(m3, "InPropertyDescriptor") });
  }
  function n3(d3, m3) {
    var y3 = true, v3 = false, b3 = void 0;
    try {
      for (var x3, C3 = d3[Symbol.iterator](); !(y3 = (x3 = C3.next()).done); y3 = true)
        t3(x3.value, m3);
    } catch (k3) {
      v3 = true, b3 = k3;
    } finally {
      try {
        y3 || C3.return == null || C3.return();
      } finally {
        if (v3)
          throw b3;
      }
    }
  }
  function r3(d3) {
    var m3 = P$s.getStaticPropertyName(d3);
    return { key: m3 === null ? f3.getTokens(d3.key) : m3, getters: d3.kind === "get" ? [d3] : [], setters: d3.kind === "set" ? [d3] : [] };
  }
  function i(d3, m3) {
    var y3, v3, b3 = d3.find(function(x3) {
      return function(C3, k3) {
        return typeof C3 == "string" && typeof k3 == "string" ? C3 == k3 : !(!Array.isArray(C3) || !Array.isArray(k3)) && function(F3, B3) {
          if (F3.length !== B3.length)
            return false;
          for (var O3 = 0; O3 < F3.length; O3++) {
            var S3 = F3[O3], w3 = B3[O3];
            if (S3.type !== w3.type || S3.value !== w3.value)
              return false;
          }
          return true;
        }(C3, k3);
      }(x3.key, m3.key);
    });
    return b3 ? ((y3 = b3.getters).push.apply(y3, Mt$2(m3.getters)), (v3 = b3.setters).push.apply(v3, Mt$2(m3.setters))) : d3.push(m3), d3;
  }
  function a3(d3) {
    var m3 = d3.filter(TI).map(r3).reduce(i, []), y3 = true, v3 = false, b3 = void 0;
    try {
      for (var x3, C3 = m3[Symbol.iterator](); !(y3 = (x3 = C3.next()).done); y3 = true) {
        var k3 = x3.value, F3 = k3.getters, B3 = k3.setters;
        u3 && B3.length && !F3.length && n3(B3, "missingGetter"), o3 && F3.length && !B3.length && n3(F3, "missingSetter");
      }
    } catch (O3) {
      v3 = true, b3 = O3;
    } finally {
      try {
        y3 || C3.return == null || C3.return();
      } finally {
        if (v3)
          throw b3;
      }
    }
  }
  var s3 = e28.options[0] || {}, o3 = s3.getWithoutSet === true, u3 = s3.setWithoutGet !== false, c3 = s3.enforceForClassMembers === true, f3 = e28.getSourceCode(), p3 = {};
  return (u3 || o3) && (p3.ObjectExpression = function(d3) {
    (function(m3) {
      a3(m3.properties.filter(function(y3) {
        return y3.type === "Property";
      }));
    })(d3), function(m3) {
      if (Kl(m3, 2, "Object", "defineProperty") || Kl(m3, 2, "Reflect", "defineProperty"))
        return true;
      var y3 = m3.parent.parent;
      return y3.type === "ObjectExpression" && (Kl(y3, 1, "Object", "create") || Kl(y3, 1, "Object", "defineProperties"));
    }(d3) && function(m3) {
      var y3 = m3.properties.filter(function(x3) {
        return x3.type === "Property" && x3.kind === "init" && !x3.computed;
      }).map(function(x3) {
        return x3.key.name;
      }), v3 = y3.includes("get"), b3 = y3.includes("set");
      u3 && b3 && !v3 && t3(m3, "missingGetter"), o3 && v3 && !b3 && t3(m3, "missingSetter");
    }(d3);
  }, c3 && (p3.ClassBody = function(d3) {
    var m3 = d3.body.filter(function(y3) {
      return y3.type === "MethodDefinition";
    });
    a3(m3.filter(function(y3) {
      return y3.static;
    })), a3(m3.filter(function(y3) {
      return !y3.static;
    }));
  })), p3;
} }, II = { meta: { type: "layout", docs: { description: "enforce linebreaks after opening and before closing array brackets", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/array-bracket-newline" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never", "consistent"] }, { type: "object", properties: { multiline: { type: "boolean" }, minItems: { type: ["integer", "null"], minimum: 0 } }, additionalProperties: false }] }], messages: { unexpectedOpeningLinebreak: "There should be no linebreak after '['.", unexpectedClosingLinebreak: "There should be no linebreak before ']'.", missingOpeningLinebreak: "A linebreak is required after '['.", missingClosingLinebreak: "A linebreak is required before ']'." } }, create: function(e28) {
  function t3(a3) {
    var s3 = function(o3) {
      var u3 = false, c3 = false, f3 = 0;
      return o3 ? o3 === "consistent" ? (u3 = true, f3 = r3) : o3 === "always" || o3.minItems === 0 ? f3 = 0 : o3 === "never" ? f3 = r3 : (c3 = !!o3.multiline, f3 = o3.minItems || r3) : (u3 = false, c3 = true, f3 = r3), { consistent: u3, multiline: c3, minItems: f3 };
    }(a3);
    return { ArrayExpression: s3, ArrayPattern: s3 };
  }
  function n3(a3) {
    var s3 = a3.elements, o3 = t3(e28.options[0])[a3.type], u3 = i.getFirstToken(a3), c3 = i.getLastToken(a3), f3 = i.getTokenAfter(u3, { includeComments: true }), p3 = i.getTokenBefore(c3, { includeComments: true }), d3 = i.getTokenAfter(u3), m3 = i.getTokenBefore(c3);
    s3.length >= o3.minItems || o3.multiline && 0 < s3.length && f3.loc.start.line !== p3.loc.end.line || s3.length === 0 && f3.type === "Block" && f3.loc.start.line !== p3.loc.end.line && f3 === p3 || o3.consistent && u3.loc.end.line !== d3.loc.start.line ? (P$s.isTokenOnSameLine(u3, d3) && function(y3, v3) {
      e28.report({ node: y3, loc: v3.loc, messageId: "missingOpeningLinebreak", fix: function(b3) {
        return b3.insertTextAfter(v3, `
`);
      } });
    }(a3, u3), P$s.isTokenOnSameLine(m3, c3) && function(y3, v3) {
      e28.report({ node: y3, loc: v3.loc, messageId: "missingClosingLinebreak", fix: function(b3) {
        return b3.insertTextBefore(v3, `
`);
      } });
    }(a3, c3)) : (!P$s.isTokenOnSameLine(u3, d3) && function(y3, v3) {
      e28.report({ node: y3, loc: v3.loc, messageId: "unexpectedOpeningLinebreak", fix: function(b3) {
        var x3 = i.getTokenAfter(v3, { includeComments: true });
        return P$s.isCommentToken(x3) ? null : b3.removeRange([v3.range[1], x3.range[0]]);
      } });
    }(a3, u3), !P$s.isTokenOnSameLine(m3, c3) && function(y3, v3) {
      e28.report({ node: y3, loc: v3.loc, messageId: "unexpectedClosingLinebreak", fix: function(b3) {
        var x3 = i.getTokenBefore(v3, { includeComments: true });
        return P$s.isCommentToken(x3) ? null : b3.removeRange([x3.range[1], v3.range[0]]);
      } });
    }(a3, c3));
  }
  var r3 = Number.POSITIVE_INFINITY, i = e28.getSourceCode();
  return { ArrayPattern: n3, ArrayExpression: n3 };
} }, BI = { meta: { type: "layout", docs: { description: "enforce consistent spacing inside array brackets", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/array-bracket-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { singleValue: { type: "boolean" }, objectsInArrays: { type: "boolean" }, arraysInArrays: { type: "boolean" } }, additionalProperties: false }], messages: { unexpectedSpaceAfter: "There should be no space after '{{tokenValue}}'.", unexpectedSpaceBefore: "There should be no space before '{{tokenValue}}'.", missingSpaceAfter: "A space is required after '{{tokenValue}}'.", missingSpaceBefore: "A space is required before '{{tokenValue}}'." } }, create: function(e28) {
  function t3(d3) {
    return !!e28.options[1] && e28.options[1][d3] === !c3;
  }
  function n3(d3, m3) {
    e28.report({ node: d3, loc: m3.loc.start, messageId: "unexpectedSpaceAfter", data: { tokenValue: m3.value }, fix: function(y3) {
      var v3 = f3.getTokenAfter(m3);
      return y3.removeRange([m3.range[1], v3.range[0]]);
    } });
  }
  function r3(d3, m3) {
    e28.report({ node: d3, loc: m3.loc.start, messageId: "unexpectedSpaceBefore", data: { tokenValue: m3.value }, fix: function(y3) {
      var v3 = f3.getTokenBefore(m3);
      return y3.removeRange([v3.range[1], m3.range[0]]);
    } });
  }
  function i(d3, m3) {
    e28.report({ node: d3, loc: m3.loc.start, messageId: "missingSpaceAfter", data: { tokenValue: m3.value }, fix: function(y3) {
      return y3.insertTextAfter(m3, " ");
    } });
  }
  function a3(d3, m3) {
    e28.report({ node: d3, loc: m3.loc.start, messageId: "missingSpaceBefore", data: { tokenValue: m3.value }, fix: function(y3) {
      return y3.insertTextBefore(m3, " ");
    } });
  }
  function s3(d3) {
    return d3 && (d3.type === "ObjectExpression" || d3.type === "ObjectPattern");
  }
  function o3(d3) {
    return d3 && (d3.type === "ArrayExpression" || d3.type === "ArrayPattern");
  }
  function u3(d3) {
    if (!p3.spaced || d3.elements.length !== 0) {
      var m3 = f3.getFirstToken(d3), y3 = f3.getFirstToken(d3, 1), v3 = d3.typeAnnotation ? f3.getTokenBefore(d3.typeAnnotation) : f3.getLastToken(d3), b3 = f3.getTokenBefore(v3), x3 = d3.elements[0], C3 = d3.elements[d3.elements.length - 1], k3 = p3.objectsInArraysException && s3(x3) || p3.arraysInArraysException && o3(x3) || p3.singleElementException && d3.elements.length === 1 ? !p3.spaced : p3.spaced, F3 = p3.objectsInArraysException && s3(C3) || p3.arraysInArraysException && o3(C3) || p3.singleElementException && d3.elements.length === 1 ? !p3.spaced : p3.spaced;
      P$s.isTokenOnSameLine(m3, y3) && (k3 && !f3.isSpaceBetweenTokens(m3, y3) && i(d3, m3), !k3 && f3.isSpaceBetweenTokens(m3, y3) && n3(d3, m3)), m3 !== b3 && P$s.isTokenOnSameLine(b3, v3) && (F3 && !f3.isSpaceBetweenTokens(b3, v3) && a3(d3, v3), !F3 && f3.isSpaceBetweenTokens(b3, v3) && r3(d3, v3));
    }
  }
  var c3 = e28.options[0] === "always", f3 = e28.getSourceCode(), p3 = { spaced: c3, singleElementException: t3("singleValue"), objectsInArraysException: t3("objectsInArrays"), arraysInArraysException: t3("arraysInArrays") };
  return { ArrayPattern: u3, ArrayExpression: u3 };
} }, OI = /^(?:Arrow)?FunctionExpression$/, LI = /^(?:every|filter|find(?:Index)?|map|reduce(?:Right)?|some|sort)$/;
function NI(e28) {
  return e28.reachable;
}
function jI(e28, t3) {
  return e28.type === "ArrowFunctionExpression" ? t3.getTokenBefore(e28.body) : e28.id || e28;
}
function RI(e28) {
  return e28.type === "MemberExpression" && LI.test(P$s.getStaticPropertyName(e28) || "");
}
function MI(e28) {
  for (var t3 = e28; t3; ) {
    var n3 = t3.parent;
    switch (n3.type) {
      case "LogicalExpression":
      case "ConditionalExpression":
        t3 = n3;
        break;
      case "ReturnStatement":
        var r3 = P$s.getUpperFunction(n3);
        if (r3 === null || !P$s.isCallee(r3))
          return false;
        t3 = r3.parent;
        break;
      case "CallExpression":
        return P$s.isArrayFromMethod(n3.callee) ? 2 <= n3.arguments.length && n3.arguments[1] === t3 : !!RI(n3.callee) && 1 <= n3.arguments.length && n3.arguments[0] === t3;
      default:
        return false;
    }
  }
  return false;
}
var VI = { meta: { type: "problem", docs: { description: "enforce `return` statements in callbacks of array methods", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/array-callback-return" }, schema: [{ type: "object", properties: { allowImplicit: { type: "boolean", default: false } }, additionalProperties: false }], messages: { expectedAtEnd: "Expected to return a value at the end of {{name}}.", expectedInside: "Expected to return a value in {{name}}.", expectedReturnValue: "{{name}} expected a return value." } }, create: function(e28) {
  function t3(i) {
    r3.shouldCheck && r3.codePath.currentSegments.some(NI) && e28.report({ node: i, loc: jI(i, e28.getSourceCode()).loc.start, messageId: r3.hasReturn ? "expectedAtEnd" : "expectedInside", data: { name: P$s.getFunctionNameWithKind(r3.node) } });
  }
  var n3 = e28.options[0] || { allowImplicit: false }, r3 = { upper: null, codePath: null, hasReturn: false, shouldCheck: false, node: null };
  return { onCodePathStart: function(i, a3) {
    r3 = { upper: r3, codePath: i, hasReturn: false, shouldCheck: OI.test(a3.type) && a3.body.type === "BlockStatement" && MI(a3) && !a3.async && !a3.generator, node: a3 };
  }, onCodePathEnd: function() {
    r3 = r3.upper;
  }, ReturnStatement: function(i) {
    r3.shouldCheck && (r3.hasReturn = true, !n3.allowImplicit && !i.argument && e28.report({ node: i, messageId: "expectedReturnValue", data: { name: ye$4.lodash.upperFirst(P$s.getFunctionNameWithKind(r3.node)) } }));
  }, "FunctionExpression:exit": t3, "ArrowFunctionExpression:exit": t3 };
} }, UI = { meta: { type: "layout", docs: { description: "enforce line breaks after each array element", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/array-element-newline" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never", "consistent"] }, { type: "object", properties: { multiline: { type: "boolean" }, minItems: { type: ["integer", "null"], minimum: 0 } }, additionalProperties: false }] }], messages: { unexpectedLineBreak: "There should be no linebreak here.", missingLineBreak: "There should be a linebreak after this element." } }, create: function(e28) {
  function t3(o3) {
    var u3 = function(c3) {
      var f3, p3 = false, d3 = false, m3 = c3 || "always";
      return m3 && m3 !== "always" && m3.minItems !== 0 ? m3 === "never" ? f3 = a3 : m3 === "consistent" ? (p3 = true, f3 = a3) : (d3 = !!m3.multiline, f3 = m3.minItems || a3) : f3 = 0, { consistent: p3, multiline: d3, minItems: f3 };
    }(o3);
    return { ArrayExpression: u3, ArrayPattern: u3 };
  }
  function n3(o3) {
    var u3 = s3.getTokenBefore(o3, { includeComments: true });
    e28.report({ loc: { start: u3.loc.end, end: o3.loc.start }, messageId: "unexpectedLineBreak", fix: function(c3) {
      if (P$s.isCommentToken(u3))
        return null;
      if (!P$s.isTokenOnSameLine(u3, o3))
        return c3.replaceTextRange([u3.range[1], o3.range[0]], " ");
      var f3 = s3.getTokenBefore(u3, { includeComments: true });
      return P$s.isCommentToken(f3) ? null : c3.replaceTextRange([f3.range[1], u3.range[0]], "");
    } });
  }
  function r3(o3) {
    var u3 = s3.getTokenBefore(o3, { includeComments: true });
    e28.report({ loc: { start: u3.loc.end, end: o3.loc.start }, messageId: "missingLineBreak", fix: function(c3) {
      return c3.replaceTextRange([u3.range[1], o3.range[0]], `
`);
    } });
  }
  function i(o3) {
    var u3 = o3.elements, c3 = t3(e28.options[0])[o3.type], f3 = false;
    c3.multiline && (f3 = u3.filter(function(m3) {
      return m3 !== null;
    }).some(function(m3) {
      return m3.loc.start.line !== m3.loc.end.line;
    }));
    var p3 = o3.elements.map(function(m3, y3) {
      var v3 = u3[y3 - 1];
      if (y3 === 0 || m3 === null || v3 === null)
        return false;
      var b3 = s3.getFirstTokenBetween(v3, m3, P$s.isCommaToken), x3 = s3.getTokenBefore(b3), C3 = s3.getTokenAfter(b3);
      return !P$s.isTokenOnSameLine(x3, C3);
    }).filter(function(m3) {
      return m3 === true;
    }).length, d3 = u3.length >= c3.minItems || c3.multiline && f3 || c3.consistent && 0 < p3 && p3 < o3.elements.length;
    u3.forEach(function(m3, y3) {
      var v3 = u3[y3 - 1];
      if (y3 !== 0 && m3 !== null && v3 !== null) {
        var b3 = s3.getFirstTokenBetween(v3, m3, P$s.isCommaToken), x3 = s3.getTokenBefore(b3), C3 = s3.getTokenAfter(b3);
        d3 ? P$s.isTokenOnSameLine(x3, C3) && r3(C3) : !P$s.isTokenOnSameLine(x3, C3) && n3(C3);
      }
    });
  }
  var a3 = Number.POSITIVE_INFINITY, s3 = e28.getSourceCode();
  return { ArrayPattern: i, ArrayExpression: i };
} }, qI = { meta: { type: "suggestion", docs: { description: "require braces around arrow function bodies", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/arrow-body-style" }, schema: { anyOf: [{ type: "array", items: [{ enum: ["always", "never"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["as-needed"] }, { type: "object", properties: { requireReturnForObjectLiteral: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }] }, fixable: "code", messages: { unexpectedOtherBlock: "Unexpected block statement surrounding arrow body.", unexpectedEmptyBlock: "Unexpected block statement surrounding arrow body; put a value of `undefined` immediately after the `=>`.", unexpectedObjectBlock: "Unexpected block statement surrounding arrow body; parenthesize the returned value and move it immediately after the `=>`.", unexpectedSingleBlock: "Unexpected block statement surrounding arrow body; move the returned value immediately after the `=>`.", expectedBlock: "Expected block statement surrounding arrow body." } }, create: function(e28) {
  var t3 = e28.options, n3 = t3[0] === "always", r3 = !t3[0] || t3[0] === "as-needed", i = t3[0] === "never", a3 = t3[1] && t3[1].requireReturnForObjectLiteral, s3 = e28.getSourceCode();
  return { "ArrowFunctionExpression:exit": function(o3) {
    var u3 = o3.body;
    if (u3.type === "BlockStatement") {
      var c3, f3 = u3.body;
      if (f3.length !== 1 && !i || r3 && a3 && f3[0].type === "ReturnStatement" && f3[0].argument && f3[0].argument.type === "ObjectExpression")
        return;
      (i || r3 && f3[0].type === "ReturnStatement") && (c3 = f3.length === 0 ? "unexpectedEmptyBlock" : 1 < f3.length ? "unexpectedOtherBlock" : f3[0].argument === null ? "unexpectedSingleBlock" : P$s.isOpeningBraceToken(s3.getFirstToken(f3[0], { skip: 1 })) ? "unexpectedObjectBlock" : "unexpectedSingleBlock", e28.report({ node: o3, loc: u3.loc.start, messageId: c3, fix: function(p3) {
        var d3 = [];
        if (f3.length !== 1 || f3[0].type !== "ReturnStatement" || !f3[0].argument || function(x3) {
          return x3 && x3.type === "Punctuator" && /^[\(\+\x2D\/\[`]/.test(x3.value);
        }(s3.getTokenAfter(u3)))
          return d3;
        var m3 = s3.getFirstToken(u3), y3 = s3.getLastToken(u3), v3 = s3.getFirstToken(f3[0], 1), b3 = s3.getLastToken(f3[0]);
        return s3.commentsExistBetween(m3, v3) || s3.commentsExistBetween(b3, y3) ? d3.push(p3.remove(m3), p3.remove(y3), p3.remove(s3.getTokenAfter(m3))) : d3.push(p3.removeRange([m3.range[0], v3.range[0]]), p3.removeRange([b3.range[1], y3.range[1]])), (P$s.isOpeningBraceToken(v3) || f3[0].argument.type === "SequenceExpression") && d3.push(p3.insertTextBefore(v3, "("), p3.insertTextAfter(b3, ")")), P$s.isSemicolonToken(b3) && d3.push(p3.remove(b3)), d3;
      } }));
    } else
      (n3 || r3 && a3 && u3.type === "ObjectExpression") && e28.report({ node: o3, loc: u3.loc.start, messageId: "expectedBlock", fix: function(p3) {
        var d3 = [], m3 = s3.getTokenBefore(u3, P$s.isArrowToken), y3 = s3.getTokenAfter(m3), v3 = s3.getLastToken(o3), b3 = P$s.isOpeningParenToken(y3) && P$s.isOpeningBraceToken(s3.getTokenAfter(y3));
        return d3.push(p3.insertTextBefore(y3, "{return "), p3.insertTextAfter(v3, "}")), b3 && d3.push(p3.remove(y3), p3.remove(function(x3) {
          for (var C3 = s3.getNodeByRangeIndex(x3.range[1]); !P$s.isParenthesised(s3, C3); )
            C3 = C3.parent;
          return s3.getTokenAfter(C3);
        }(y3))), d3;
      } });
  } };
} };
function Jl(e28) {
  return { start: e28.params[0].loc.start, end: e28.params[e28.params.length - 1].loc.end };
}
var WI = { meta: { type: "layout", docs: { description: "require parentheses around arrow function arguments", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/arrow-parens" }, fixable: "code", schema: [{ enum: ["always", "as-needed"] }, { type: "object", properties: { requireForBlockBody: { type: "boolean", default: false } }, additionalProperties: false }], messages: { unexpectedParens: "Unexpected parentheses around single function argument.", expectedParens: "Expected parentheses around arrow function argument.", unexpectedParensInline: "Unexpected parentheses around single function argument having a body with no curly braces.", expectedParensBlock: "Expected parentheses around arrow function argument having a body with curly braces." } }, create: function(e28) {
  var t3 = e28.options[0] === "as-needed", n3 = t3 && e28.options[1] && e28.options[1].requireForBlockBody === true, r3 = e28.getSourceCode();
  return { ArrowFunctionExpression: function(i) {
    function a3(u3) {
      var c3 = r3.getTokenAfter(o3), f3 = r3.getTokenAfter(c3, P$s.isClosingParenToken), p3 = s3 ? r3.getTokenBefore(o3) : null, d3 = p3 && p3.range[1] === o3.range[0];
      return u3.replaceTextRange([o3.range[0], f3.range[1]], "".concat(d3 ? " " : "").concat(c3.value));
    }
    var s3 = i.async, o3 = r3.getFirstToken(i, s3 ? 1 : 0);
    !n3 || i.params.length !== 1 || i.params[0].type !== "Identifier" || i.params[0].typeAnnotation || i.body.type === "BlockStatement" || i.returnType ? n3 && i.body.type === "BlockStatement" ? P$s.isOpeningParenToken(o3) || e28.report({ node: i, messageId: "expectedParensBlock", loc: Jl(i), fix: function(u3) {
      return u3.replaceText(o3, "(".concat(o3.value, ")"));
    } }) : !t3 || i.params.length !== 1 || i.params[0].type !== "Identifier" || i.params[0].typeAnnotation || i.returnType ? o3.type === "Identifier" && r3.getTokenAfter(o3).value !== ")" && e28.report({ node: i, messageId: "expectedParens", loc: Jl(i), fix: function(u3) {
      return u3.replaceText(o3, "(".concat(o3.value, ")"));
    } }) : P$s.isOpeningParenToken(o3) && e28.report({ node: i, messageId: "unexpectedParens", loc: Jl(i), fix: a3 }) : P$s.isOpeningParenToken(o3) && e28.report({ node: i, messageId: "unexpectedParensInline", loc: Jl(i), fix: a3 });
  } };
} }, $I = { meta: { type: "layout", docs: { description: "enforce consistent spacing before and after the arrow in arrow functions", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/arrow-spacing" }, fixable: "whitespace", schema: [{ type: "object", properties: { before: { type: "boolean", default: true }, after: { type: "boolean", default: true } }, additionalProperties: false }], messages: { expectedBefore: "Missing space before =>.", unexpectedBefore: "Unexpected space before =>.", expectedAfter: "Missing space after =>.", unexpectedAfter: "Unexpected space after =>." } }, create: function(e28) {
  function t3(i) {
    var a3 = r3.getTokenBefore(i.body, P$s.isArrowToken);
    return { before: r3.getTokenBefore(a3), arrow: a3, after: r3.getTokenAfter(a3) };
  }
  var n3 = Object.assign({}, e28.options[0]);
  n3.before = n3.before !== false, n3.after = n3.after !== false;
  var r3 = e28.getSourceCode();
  return { ArrowFunctionExpression: function(i) {
    var a3 = t3(i), s3 = function(o3) {
      return { before: o3.arrow.range[0] - o3.before.range[1], after: o3.after.range[0] - o3.arrow.range[1] };
    }(a3);
    n3.before ? s3.before === 0 && e28.report({ node: a3.before, messageId: "expectedBefore", fix: function(o3) {
      return o3.insertTextBefore(a3.arrow, " ");
    } }) : 0 < s3.before && e28.report({ node: a3.before, messageId: "unexpectedBefore", fix: function(o3) {
      return o3.removeRange([a3.before.range[1], a3.arrow.range[0]]);
    } }), n3.after ? s3.after === 0 && e28.report({ node: a3.after, messageId: "expectedAfter", fix: function(o3) {
      return o3.insertTextAfter(a3.arrow, " ");
    } }) : 0 < s3.after && e28.report({ node: a3.after, messageId: "unexpectedAfter", fix: function(o3) {
      return o3.removeRange([a3.arrow.range[1], a3.after.range[0]]);
    } });
  } };
} }, GI = { meta: { type: "layout", docs: { description: "disallow or enforce spaces inside of blocks after opening block and before closing block", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/block-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }], messages: { missing: "Requires a space {{location}} '{{token}}'.", extra: "Unexpected space(s) {{location}} '{{token}}'." } }, create: function(e28) {
  function t3(s3, o3) {
    return !P$s.isTokenOnSameLine(s3, o3) || a3.isSpaceBetweenTokens(s3, o3) === r3;
  }
  function n3(s3) {
    var o3 = function(p3) {
      return p3.type === "SwitchStatement" ? 0 < p3.cases.length ? a3.getTokenBefore(p3.cases[0]) : a3.getLastToken(p3, 1) : a3.getFirstToken(p3);
    }(s3), u3 = a3.getLastToken(s3), c3 = a3.getTokenAfter(o3, { includeComments: true }), f3 = a3.getTokenBefore(u3, { includeComments: true });
    o3.type === "Punctuator" && o3.value === "{" && u3.type === "Punctuator" && u3.value === "}" && c3 !== u3 && (r3 || c3.type !== "Line") && (!t3(o3, c3) && e28.report({ node: s3, loc: o3.loc.start, messageId: i, data: { location: "after", token: o3.value }, fix: function(p3) {
      return r3 ? p3.insertTextBefore(c3, " ") : p3.removeRange([o3.range[1], c3.range[0]]);
    } }), !t3(f3, u3) && e28.report({ node: s3, loc: u3.loc.start, messageId: i, data: { location: "before", token: u3.value }, fix: function(p3) {
      return r3 ? p3.insertTextAfter(f3, " ") : p3.removeRange([f3.range[1], u3.range[0]]);
    } }));
  }
  var r3 = e28.options[0] !== "never", i = r3 ? "missing" : "extra", a3 = e28.getSourceCode();
  return { BlockStatement: n3, SwitchStatement: n3 };
} }, zI = { meta: { type: "layout", docs: { description: "enforce consistent brace style for blocks", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/brace-style" }, schema: [{ enum: ["1tbs", "stroustrup", "allman"] }, { type: "object", properties: { allowSingleLine: { type: "boolean", default: false } }, additionalProperties: false }], fixable: "whitespace", messages: { nextLineOpen: "Opening curly brace does not appear on the same line as controlling statement.", sameLineOpen: "Opening curly brace appears on the same line as controlling statement.", blockSameLine: "Statement inside of curly braces should be on next line.", nextLineClose: "Closing curly brace does not appear on the same line as the subsequent block.", singleLineClose: "Closing curly brace should be on the same line as opening curly brace or on the line after the previous block.", sameLineClose: "Closing curly brace appears on the same line as the subsequent block." } }, create: function(e28) {
  function t3(o3, u3) {
    var c3 = [o3.range[1], u3.range[0]];
    return s3.text.slice(c3[0], c3[1]).trim() ? null : function(f3) {
      return f3.replaceTextRange(c3, " ");
    };
  }
  function n3(o3, u3) {
    var c3 = s3.getTokenBefore(o3), f3 = s3.getTokenAfter(o3), p3 = s3.getTokenBefore(u3), d3 = a3.allowSingleLine && P$s.isTokenOnSameLine(o3, u3);
    i === "allman" || P$s.isTokenOnSameLine(c3, o3) || e28.report({ node: o3, messageId: "nextLineOpen", fix: t3(c3, o3) }), i === "allman" && P$s.isTokenOnSameLine(c3, o3) && !d3 && e28.report({ node: o3, messageId: "sameLineOpen", fix: function(m3) {
      return m3.insertTextBefore(o3, `
`);
    } }), P$s.isTokenOnSameLine(o3, f3) && f3 !== u3 && !d3 && e28.report({ node: o3, messageId: "blockSameLine", fix: function(m3) {
      return m3.insertTextAfter(o3, `
`);
    } }), p3 !== o3 && !d3 && P$s.isTokenOnSameLine(p3, u3) && e28.report({ node: u3, messageId: "singleLineClose", fix: function(m3) {
      return m3.insertTextBefore(u3, `
`);
    } });
  }
  function r3(o3) {
    var u3 = s3.getTokenAfter(o3);
    i !== "1tbs" || P$s.isTokenOnSameLine(o3, u3) || e28.report({ node: o3, messageId: "nextLineClose", fix: t3(o3, u3) }), i !== "1tbs" && P$s.isTokenOnSameLine(o3, u3) && e28.report({ node: o3, messageId: "sameLineClose", fix: function(c3) {
      return c3.insertTextAfter(o3, `
`);
    } });
  }
  var i = e28.options[0] || "1tbs", a3 = e28.options[1] || {}, s3 = e28.getSourceCode();
  return { BlockStatement: function(o3) {
    P$s.STATEMENT_LIST_PARENTS.has(o3.parent.type) || n3(s3.getFirstToken(o3), s3.getLastToken(o3));
  }, ClassBody: function(o3) {
    n3(s3.getFirstToken(o3), s3.getLastToken(o3));
  }, SwitchStatement: function(o3) {
    var u3 = s3.getLastToken(o3);
    n3(s3.getTokenBefore(o3.cases.length ? o3.cases[0] : u3), u3);
  }, IfStatement: function(o3) {
    o3.consequent.type === "BlockStatement" && o3.alternate && r3(s3.getLastToken(o3.consequent));
  }, TryStatement: function(o3) {
    r3(s3.getLastToken(o3.block)), o3.handler && o3.finalizer && r3(s3.getLastToken(o3.handler.body));
  } };
} }, HI = { meta: { type: "suggestion", docs: { description: "enforce camelcase naming convention", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/camelcase" }, schema: [{ type: "object", properties: { ignoreDestructuring: { type: "boolean", default: false }, ignoreImports: { type: "boolean", default: false }, properties: { enum: ["always", "never"] }, allow: { type: "array", items: [{ type: "string" }], minItems: 0, uniqueItems: true } }, additionalProperties: false }], messages: { notCamelCase: "Identifier '{{name}}' is not in camel case." } }, create: function(e28) {
  function t3(p3) {
    return p3.includes("_") && p3 !== p3.toUpperCase();
  }
  function n3(p3) {
    return u3.some(function(d3) {
      return p3 === d3 || p3.match(new RegExp(d3, "u"));
    });
  }
  function r3(p3) {
    c3.includes(p3) || (c3.push(p3), e28.report({ node: p3, messageId: "notCamelCase", data: { name: p3.name } }));
  }
  var i = e28.options[0] || {}, a3 = i.properties || "", s3 = i.ignoreDestructuring, o3 = i.ignoreImports, u3 = i.allow || [];
  a3 !== "always" && a3 !== "never" && (a3 = "always");
  var c3 = [], f3 = /* @__PURE__ */ new Set(["CallExpression", "NewExpression"]);
  return { Identifier: function(p3) {
    var d3 = p3.name, m3 = t3(d3.replace(/^_+|_+$/g, "")), y3 = p3.parent.type === "MemberExpression" ? p3.parent.parent : p3.parent;
    if (!n3(d3))
      if (p3.parent.type === "MemberExpression") {
        if (a3 === "never")
          return;
        (p3.parent.object.type === "Identifier" && p3.parent.object.name === p3.name && m3 || y3.type === "AssignmentExpression" && m3 && (y3.right.type !== "MemberExpression" || y3.left.type === "MemberExpression" && y3.left.property.name === p3.name)) && r3(p3);
      } else if (p3.parent.type === "Property" || p3.parent.type === "AssignmentPattern") {
        if (p3.parent.parent && p3.parent.parent.type === "ObjectPattern") {
          p3.parent.shorthand && p3.parent.value.left && m3 && r3(p3);
          var v3 = p3.parent.key.name === p3.parent.value.name;
          if (t3(d3) && p3.parent.computed && r3(p3), p3.parent.key === p3 && p3.parent.value !== p3)
            return;
          p3.parent.value.name && m3 && (!v3 || !s3) && r3(p3);
        }
        if (a3 === "never" || s3 && function(b3) {
          for (var x3 = b3; x3; ) {
            var C3 = x3.parent;
            if (C3 && C3.type === "Property" && C3.computed && C3.key === x3)
              return false;
            if (x3.type === "ObjectPattern")
              return true;
            x3 = C3;
          }
          return false;
        }(p3))
          return;
        !m3 || f3.has(y3.type) || p3.parent.right === p3 || r3(p3);
      } else if (["ImportSpecifier", "ImportNamespaceSpecifier", "ImportDefaultSpecifier"].includes(p3.parent.type)) {
        if (p3.parent.type === "ImportSpecifier" && o3)
          return;
        p3.parent.local && p3.parent.local.name === p3.name && m3 && r3(p3);
      } else
        m3 && !f3.has(y3.type) && r3(p3);
  } };
} }, e26 = /[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B2\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|(?:\uD800(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF])|(?:\uD801(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67])|(?:\uD802(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91])|(?:\uD803(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC48])|(?:\uD804(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDE00-\uDE11\uDE13-\uDE2B\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF5D-\uDF61])|(?:\uD805(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDE00-\uDE2F\uDE44\uDE80-\uDEAA])|(?:\uD806(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8])|(?:\uD808(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDF98])|(?:[\uD80C\uD840-\uD868\uD86A-\uD86C](?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|(?:\uD80D(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC2E])|(?:\uD81A(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F])|(?:\uD81B(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDF00-\uDF44\uDF50\uDF93-\uDF9F])|(?:\uD82C(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00\uDC01])|(?:\uD82F(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99])|(?:\uD835(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB])|(?:\uD83A(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDCC4])|(?:\uD83B(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB])|(?:\uD869(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDED6\uDF00-\uDFFF])|(?:\uD86D(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDF34\uDF40-\uDFFF])|(?:\uD86E(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC1D])|(?:\uD87E(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDE1D])/, KI = P$s.COMMENTS_IGNORE_PATTERN, JI = /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]/g, QI = /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:[\0-\x08\x0E-\x1F!"\$-\.0-9;->@-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+:\/\/(?:[\0-"\$->@-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, Hd$1 = { type: "object", properties: { ignorePattern: { type: "string" }, ignoreInlineComments: { type: "boolean" }, ignoreConsecutiveComments: { type: "boolean" } }, additionalProperties: false }, XI = { ignorePattern: "", ignoreInlineComments: false, ignoreConsecutiveComments: false };
function t2(e28, t3) {
  return Object.assign({}, XI, e28[t3] || e28);
}
var YI = { meta: { type: "suggestion", docs: { description: "enforce or disallow capitalization of the first letter of a comment", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/capitalized-comments" }, fixable: "code", schema: [{ enum: ["always", "never"] }, { oneOf: [Hd$1, { type: "object", properties: { line: Hd$1, block: Hd$1 }, additionalProperties: false }] }], messages: { unexpectedLowercaseComment: "Comments should not begin with a lowercase character.", unexpectedUppercaseComment: "Comments should not begin with an uppercase character." } }, create: function(e28) {
  function t3(u3) {
    var c3 = o3.getTokenBefore(u3, { includeComments: true }), f3 = o3.getTokenAfter(u3, { includeComments: true });
    return !(!c3 || !f3 || u3.loc.start.line !== c3.loc.end.line || u3.loc.end.line !== f3.loc.start.line);
  }
  function n3(u3) {
    var c3 = o3.getTokenBefore(u3, { includeComments: true });
    return !(!c3 || ["Block", "Line"].indexOf(c3.type) === -1);
  }
  function r3(u3, c3) {
    if (KI.test(u3.value))
      return true;
    var f3 = u3.value.replace(/\*/g, "");
    if (c3.ignorePatternRegExp && c3.ignorePatternRegExp.test(f3) || c3.ignoreInlineComments && t3(u3) || c3.ignoreConsecutiveComments && n3(u3) || QI.test(f3))
      return true;
    var p3 = f3.replace(JI, "");
    if (p3.length === 0)
      return true;
    var d3 = p3[0];
    if (!e26.test(d3))
      return true;
    var m3 = d3 !== d3.toLocaleLowerCase(), y3 = d3 !== d3.toLocaleUpperCase();
    return !(a3 === "always" && y3 || a3 === "never" && m3);
  }
  function i(u3) {
    var c3 = s3[u3.type];
    if (!r3(u3, c3)) {
      var f3 = a3 === "always" ? "unexpectedLowercaseComment" : "unexpectedUppercaseComment";
      e28.report({ node: null, loc: u3.loc, messageId: f3, fix: function(p3) {
        var d3 = u3.value.match(e26);
        return p3.replaceTextRange([u3.range[0] + d3.index + 2, u3.range[0] + d3.index + 3], a3 === "always" ? d3[0].toLocaleUpperCase() : d3[0].toLocaleLowerCase());
      } });
    }
  }
  var a3 = e28.options[0] || "always", s3 = function() {
    var u3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return { Line: t2(u3, "line"), Block: t2(u3, "block") };
  }(e28.options[1]), o3 = e28.getSourceCode();
  return function(u3) {
    Object.keys(u3).forEach(function(c3) {
      var f3 = u3[c3].ignorePattern;
      if (f3) {
        var p3 = RegExp("^\\s*(?:".concat(f3, ")"), "u");
        u3[c3].ignorePatternRegExp = p3;
      }
    });
  }(s3), { Program: function() {
    o3.getAllComments().filter(function(u3) {
      return u3.type !== "Shebang";
    }).forEach(i);
  } };
} }, ZI = { meta: { type: "suggestion", docs: { description: "enforce that class methods utilize `this`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/class-methods-use-this" }, schema: [{ type: "object", properties: { exceptMethods: { type: "array", items: { type: "string" } } }, additionalProperties: false }], messages: { missingThis: "Expected 'this' to be used by class {{name}}." } }, create: function(e28) {
  function t3() {
    o3.push(false);
  }
  function n3(u3) {
    return function(c3) {
      return !c3.static && c3.kind !== "constructor" && c3.type === "MethodDefinition";
    }(u3) && (u3.computed || !s3.has(u3.key.name));
  }
  function r3(u3) {
    var c3 = o3.pop();
    n3(u3.parent) && !c3 && e28.report({ node: u3, messageId: "missingThis", data: { name: P$s.getFunctionNameWithKind(u3) } });
  }
  function i() {
    o3.length && (o3[o3.length - 1] = true);
  }
  var a3 = Object.assign({}, e28.options[0]), s3 = new Set(a3.exceptMethods || []), o3 = [];
  return { FunctionDeclaration: t3, "FunctionDeclaration:exit": r3, FunctionExpression: t3, "FunctionExpression:exit": r3, ThisExpression: i, Super: i };
} }, fs$1 = Object.freeze({ arrays: "never", objects: "never", imports: "never", exports: "never", functions: "never" }), e52 = { meta: { type: "layout", docs: { description: "require or disallow trailing commas", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/comma-dangle" }, fixable: "code", schema: { definitions: { value: { enum: ["always-multiline", "always", "never", "only-multiline"] }, valueWithIgnore: { enum: ["always-multiline", "always", "ignore", "never", "only-multiline"] } }, type: "array", items: [{ oneOf: [{ $ref: "#/definitions/value" }, { type: "object", properties: { arrays: { $ref: "#/definitions/valueWithIgnore" }, objects: { $ref: "#/definitions/valueWithIgnore" }, imports: { $ref: "#/definitions/valueWithIgnore" }, exports: { $ref: "#/definitions/valueWithIgnore" }, functions: { $ref: "#/definitions/valueWithIgnore" } }, additionalProperties: false }] }] }, messages: { unexpected: "Unexpected trailing comma.", missing: "Missing trailing comma." } }, create: function(e28) {
  function t3(c3) {
    switch (c3.type) {
      case "ObjectExpression":
      case "ObjectPattern":
        return ye$4.lodash.last(c3.properties);
      case "ArrayExpression":
      case "ArrayPattern":
        return ye$4.lodash.last(c3.elements);
      case "ImportDeclaration":
      case "ExportNamedDeclaration":
        return ye$4.lodash.last(c3.specifiers);
      case "FunctionDeclaration":
      case "FunctionExpression":
      case "ArrowFunctionExpression":
        return ye$4.lodash.last(c3.params);
      case "CallExpression":
      case "NewExpression":
        return ye$4.lodash.last(c3.arguments);
      default:
        return null;
    }
  }
  function n3(c3, f3) {
    switch (c3.type) {
      case "ObjectExpression":
      case "ArrayExpression":
      case "CallExpression":
      case "NewExpression":
        return o3.getLastToken(c3, 1);
      default:
        var p3 = o3.getTokenAfter(f3);
        return P$s.isCommaToken(p3) ? p3 : o3.getLastToken(f3);
    }
  }
  function r3(c3) {
    var f3 = t3(c3);
    if (!f3)
      return false;
    var p3 = n3(c3, f3);
    return o3.getTokenAfter(p3).loc.end.line !== p3.loc.end.line;
  }
  function i(c3) {
    var f3 = t3(c3);
    if (f3 && (c3.type !== "ImportDeclaration" || f3.type === "ImportSpecifier")) {
      var p3 = n3(c3, f3);
      P$s.isCommaToken(p3) && e28.report({ node: f3, loc: p3.loc, messageId: "unexpected", fix: function(d3) {
        return d3.remove(p3);
      } });
    }
  }
  function a3(c3) {
    var f3 = t3(c3);
    if (f3 && (c3.type !== "ImportDeclaration" || f3.type === "ImportSpecifier"))
      if (function(d3) {
        return d3.type !== "RestElement" && d3.type !== "RestProperty" && d3.type !== "ExperimentalRestProperty";
      }(f3)) {
        var p3 = n3(c3, f3);
        p3.value !== "," && e28.report({ node: f3, loc: { start: p3.loc.end, end: P$s.getNextLocation(o3, p3.loc.end) }, messageId: "missing", fix: function(d3) {
          return d3.insertTextAfter(p3, ",");
        } });
      } else
        i(c3);
  }
  var s3 = function(c3, f3) {
    return typeof c3 == "string" ? { arrays: c3, objects: c3, imports: c3, exports: c3, functions: !f3 || 8 > f3 ? "ignore" : c3 } : xe$3(c3) == "object" && c3 !== null ? { arrays: c3.arrays || fs$1.arrays, objects: c3.objects || fs$1.objects, imports: c3.imports || fs$1.imports, exports: c3.exports || fs$1.exports, functions: c3.functions || fs$1.functions } : fs$1;
  }(e28.options[0], e28.parserOptions.ecmaVersion), o3 = e28.getSourceCode(), u3 = { always: a3, "always-multiline": function(c3) {
    r3(c3) ? a3(c3) : i(c3);
  }, "only-multiline": function(c3) {
    r3(c3) || i(c3);
  }, never: i, ignore: ye$4.lodash.noop };
  return { ObjectExpression: u3[s3.objects], ObjectPattern: u3[s3.objects], ArrayExpression: u3[s3.arrays], ArrayPattern: u3[s3.arrays], ImportDeclaration: u3[s3.imports], ExportNamedDeclaration: u3[s3.exports], FunctionDeclaration: u3[s3.functions], FunctionExpression: u3[s3.functions], ArrowFunctionExpression: u3[s3.functions], CallExpression: u3[s3.functions], NewExpression: u3[s3.functions] };
} }, t5 = { meta: { type: "layout", docs: { description: "enforce consistent spacing before and after commas", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/comma-spacing" }, fixable: "whitespace", schema: [{ type: "object", properties: { before: { type: "boolean", default: false }, after: { type: "boolean", default: true } }, additionalProperties: false }], messages: { missing: "A space is required {{loc}} ','.", unexpected: "There should be no space {{loc}} ','." } }, create: function(e28) {
  function t3(u3, c3, f3) {
    e28.report({ node: u3, fix: function(p3) {
      return s3[c3] ? c3 === "before" ? p3.insertTextBefore(u3, " ") : p3.insertTextAfter(u3, " ") : (c3 === "before" ? (d3 = f3.range[1], m3 = u3.range[0]) : (d3 = u3.range[1], m3 = f3.range[0]), p3.replaceTextRange([d3, m3], ""));
      var d3, m3;
    }, messageId: s3[c3] ? "missing" : "unexpected", data: { loc: c3 } });
  }
  function n3(u3, c3) {
    u3.left && P$s.isTokenOnSameLine(u3.left, u3.comma) && s3.before !== i.isSpaceBetweenTokens(u3.left, u3.comma) && t3(c3, "before", u3.left), u3.right && P$s.isClosingParenToken(u3.right) || u3.right && !s3.after && u3.right.type === "Line" || u3.right && P$s.isTokenOnSameLine(u3.comma, u3.right) && s3.after !== i.isSpaceBetweenTokens(u3.comma, u3.right) && t3(c3, "after", u3.right);
  }
  function r3(u3) {
    var c3 = i.getFirstToken(u3);
    u3.elements.forEach(function(f3) {
      var p3;
      f3 === null ? (p3 = i.getTokenAfter(c3), P$s.isCommaToken(p3) && o3.push(p3)) : p3 = i.getTokenAfter(f3), c3 = p3;
    });
  }
  var i = e28.getSourceCode(), a3 = i.tokensAndComments, s3 = { before: !!e28.options[0] && e28.options[0].before, after: !e28.options[0] || e28.options[0].after }, o3 = [];
  return { "Program:exit": function() {
    a3.forEach(function(u3, c3) {
      if (P$s.isCommaToken(u3) && (!u3 || u3.type !== "JSXText")) {
        var f3 = a3[c3 - 1], p3 = a3[c3 + 1];
        n3({ comma: u3, left: P$s.isCommaToken(f3) || -1 < o3.indexOf(u3) ? null : f3, right: P$s.isCommaToken(p3) ? null : p3 }, u3);
      }
    });
  }, ArrayExpression: r3, ArrayPattern: r3 };
} }, n5 = { meta: { type: "layout", docs: { description: "enforce consistent comma style", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/comma-style" }, fixable: "code", schema: [{ enum: ["first", "last"] }, { type: "object", properties: { exceptions: { type: "object", additionalProperties: { type: "boolean" } } }, additionalProperties: false }], messages: { unexpectedLineBeforeAndAfterComma: "Bad line breaking before and after ','.", expectedCommaFirst: "',' should be placed first.", expectedCommaLast: "',' should be placed last." } }, create: function(e28) {
  function t3(f3, p3, d3, m3) {
    var y3 = a3.text.slice(p3.range[1], d3.range[0]) + a3.text.slice(d3.range[1], m3.range[0]), v3 = [p3.range[1], m3.range[0]];
    return function(b3) {
      return b3.replaceTextRange(v3, function(x3, C3) {
        return x3 === "between" ? ",".concat(C3.replace(P$s.LINEBREAK_MATCHER, "")) : x3 === "first" ? "".concat(C3, ",") : x3 === "last" ? ",".concat(C3) : "";
      }(f3, y3));
    };
  }
  function n3(f3, p3, d3, m3) {
    if (!(P$s.isTokenOnSameLine(p3, d3) && P$s.isTokenOnSameLine(f3, p3)))
      if (P$s.isTokenOnSameLine(p3, d3) || P$s.isTokenOnSameLine(f3, p3))
        i !== "first" || P$s.isTokenOnSameLine(p3, d3) ? i === "last" && P$s.isTokenOnSameLine(p3, d3) && e28.report({ node: m3, loc: { line: p3.loc.end.line, column: p3.loc.end.column }, messageId: "expectedCommaLast", fix: t3(i, f3, p3, d3) }) : e28.report({ node: m3, messageId: "expectedCommaFirst", fix: t3(i, f3, p3, d3) });
      else {
        var y3 = a3.getCommentsAfter(p3)[0], v3 = y3 && y3.type === "Block" && P$s.isTokenOnSameLine(p3, y3) ? i : "between";
        e28.report({ node: m3, loc: { line: p3.loc.end.line, column: p3.loc.start.column }, messageId: "unexpectedLineBeforeAndAfterComma", fix: t3(v3, f3, p3, d3) });
      }
  }
  function r3(f3, p3) {
    var d3 = f3[p3], m3 = f3.type === "ArrayExpression" || f3.type === "ArrayPattern";
    if (1 < d3.length || m3) {
      var y3 = a3.getFirstToken(f3);
      if (d3.forEach(function(x3) {
        var C3 = x3 ? a3.getTokenBefore(x3) : y3, k3 = x3 ? a3.getFirstToken(x3) : a3.getTokenAfter(C3);
        if (P$s.isCommaToken(C3) && n3(y3, C3, k3, x3 || k3), x3) {
          var F3 = a3.getTokenAfter(x3, P$s.isNotClosingParenToken);
          y3 = F3 ? a3.getTokenBefore(F3) : a3.ast.tokens[a3.ast.tokens.length - 1];
        }
      }), m3) {
        var v3 = a3.getLastToken(f3), b3 = a3.getTokenBefore(v3);
        P$s.isCommaToken(b3) && n3(a3.getTokenBefore(b3), b3, v3, v3);
      }
    }
  }
  var i = e28.options[0] || "last", a3 = e28.getSourceCode(), s3 = { ArrayPattern: true, ArrowFunctionExpression: true, CallExpression: true, FunctionDeclaration: true, FunctionExpression: true, ImportDeclaration: true, ObjectPattern: true, NewExpression: true };
  if (e28.options.length === 2 && Object.prototype.hasOwnProperty.call(e28.options[1], "exceptions"))
    for (var o3 = Object.keys(e28.options[1].exceptions), u3 = 0; u3 < o3.length; u3++)
      s3[o3[u3]] = e28.options[1].exceptions[o3[u3]];
  var c3 = {};
  return s3.VariableDeclaration || (c3.VariableDeclaration = function(f3) {
    r3(f3, "declarations");
  }), s3.ObjectExpression || (c3.ObjectExpression = function(f3) {
    r3(f3, "properties");
  }), s3.ObjectPattern || (c3.ObjectPattern = function(f3) {
    r3(f3, "properties");
  }), s3.ArrayExpression || (c3.ArrayExpression = function(f3) {
    r3(f3, "elements");
  }), s3.ArrayPattern || (c3.ArrayPattern = function(f3) {
    r3(f3, "elements");
  }), s3.FunctionDeclaration || (c3.FunctionDeclaration = function(f3) {
    r3(f3, "params");
  }), s3.FunctionExpression || (c3.FunctionExpression = function(f3) {
    r3(f3, "params");
  }), s3.ArrowFunctionExpression || (c3.ArrowFunctionExpression = function(f3) {
    r3(f3, "params");
  }), s3.CallExpression || (c3.CallExpression = function(f3) {
    r3(f3, "arguments");
  }), s3.ImportDeclaration || (c3.ImportDeclaration = function(f3) {
    r3(f3, "specifiers");
  }), s3.NewExpression || (c3.NewExpression = function(f3) {
    r3(f3, "arguments");
  }), c3;
} }, r5 = { meta: { type: "suggestion", docs: { description: "enforce a maximum cyclomatic complexity allowed in a program", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/complexity" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { maximum: { type: "integer", minimum: 0 }, max: { type: "integer", minimum: 0 } }, additionalProperties: false }] }], messages: { complex: "{{name}} has a complexity of {{complexity}}. Maximum allowed is {{max}}." } }, create: function(e28) {
  function t3() {
    s3.push(1);
  }
  function n3(o3) {
    var u3 = ye$4.lodash.upperFirst(P$s.getFunctionNameWithKind(o3)), c3 = s3.pop();
    c3 > a3 && e28.report({ node: o3, messageId: "complex", data: { name: u3, complexity: c3, max: a3 } });
  }
  function r3() {
    s3.length && s3[s3.length - 1]++;
  }
  var i = e28.options[0], a3 = 20;
  xe$3(i) == "object" && (Object.prototype.hasOwnProperty.call(i, "maximum") || Object.prototype.hasOwnProperty.call(i, "max")) ? a3 = i.maximum || i.max : typeof i == "number" && (a3 = i);
  var s3 = [];
  return { FunctionDeclaration: t3, FunctionExpression: t3, ArrowFunctionExpression: t3, "FunctionDeclaration:exit": n3, "FunctionExpression:exit": n3, "ArrowFunctionExpression:exit": n3, CatchClause: r3, ConditionalExpression: r3, LogicalExpression: r3, ForStatement: r3, ForInStatement: r3, ForOfStatement: r3, IfStatement: r3, SwitchCase: function(o3) {
    o3.test && r3();
  }, WhileStatement: r3, DoWhileStatement: r3 };
} }, i5 = { meta: { type: "layout", docs: { description: "enforce consistent spacing inside computed property brackets", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/computed-property-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { enforceForClassMembers: { type: "boolean", default: false } }, additionalProperties: false }], messages: { unexpectedSpaceBefore: "There should be no space before '{{tokenValue}}'.", unexpectedSpaceAfter: "There should be no space after '{{tokenValue}}'.", missingSpaceBefore: "A space is required before '{{tokenValue}}'.", missingSpaceAfter: "A space is required after '{{tokenValue}}'." } }, create: function(e28) {
  function t3(f3, p3, d3) {
    e28.report({ node: f3, loc: p3.loc.start, messageId: "unexpectedSpaceAfter", data: { tokenValue: p3.value }, fix: function(m3) {
      return m3.removeRange([p3.range[1], d3.range[0]]);
    } });
  }
  function n3(f3, p3, d3) {
    e28.report({ node: f3, loc: p3.loc.start, messageId: "unexpectedSpaceBefore", data: { tokenValue: p3.value }, fix: function(m3) {
      return m3.removeRange([d3.range[1], p3.range[0]]);
    } });
  }
  function r3(f3, p3) {
    e28.report({ node: f3, loc: p3.loc.start, messageId: "missingSpaceAfter", data: { tokenValue: p3.value }, fix: function(d3) {
      return d3.insertTextAfter(p3, " ");
    } });
  }
  function i(f3, p3) {
    e28.report({ node: f3, loc: p3.loc.start, messageId: "missingSpaceBefore", data: { tokenValue: p3.value }, fix: function(d3) {
      return d3.insertTextBefore(p3, " ");
    } });
  }
  function a3(f3) {
    return function(p3) {
      if (p3.computed) {
        var d3 = p3[f3], m3 = s3.getTokenBefore(d3, P$s.isOpeningBracketToken), y3 = s3.getTokenAfter(m3, { includeComments: true }), v3 = s3.getTokenAfter(d3, P$s.isClosingBracketToken), b3 = s3.getTokenBefore(v3, { includeComments: true });
        P$s.isTokenOnSameLine(m3, y3) && (o3 ? !s3.isSpaceBetweenTokens(m3, y3) && P$s.isTokenOnSameLine(m3, y3) && r3(p3, m3) : s3.isSpaceBetweenTokens(m3, y3) && t3(p3, m3, y3)), P$s.isTokenOnSameLine(b3, v3) && (o3 ? !s3.isSpaceBetweenTokens(b3, v3) && P$s.isTokenOnSameLine(b3, v3) && i(p3, v3) : s3.isSpaceBetweenTokens(b3, v3) && n3(p3, v3, b3));
      }
    };
  }
  var s3 = e28.getSourceCode(), o3 = e28.options[0] === "always", u3 = e28.options[1] && e28.options[1].enforceForClassMembers, c3 = { Property: a3("key"), MemberExpression: a3("property") };
  return u3 && (c3.MethodDefinition = a3("key")), c3;
} };
function a5(e28) {
  return !e28.reachable;
}
var o5 = { meta: { type: "suggestion", docs: { description: "require `return` statements to either always or never specify values", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/consistent-return" }, schema: [{ type: "object", properties: { treatUndefinedAsUnspecified: { type: "boolean", default: false } }, additionalProperties: false }], messages: { missingReturn: "Expected to return a value at the end of {{name}}.", missingReturnValue: "{{name}} expected a return value.", unexpectedReturnValue: "{{name}} expected no return value." } }, create: function(e28) {
  function t3(i) {
    var a3, s3;
    !r3.hasReturnValue || r3.codePath.currentSegments.every(a5) || P$s.isES5Constructor(i) || function(o3) {
      return o3.type === "FunctionExpression" && o3.parent && o3.parent.type === "MethodDefinition" && o3.parent.kind === "constructor";
    }(i) || (i.type === "Program" ? (a3 = { line: 1, column: 0 }, s3 = "program") : a3 = i.type === "ArrowFunctionExpression" ? e28.getSourceCode().getTokenBefore(i.body, P$s.isArrowToken).loc.start : i.parent.type === "MethodDefinition" || i.parent.type === "Property" && i.parent.method ? i.parent.key.loc.start : (i.id || i).loc.start, !s3 && (s3 = P$s.getFunctionNameWithKind(i)), e28.report({ node: i, loc: a3, messageId: "missingReturn", data: { name: s3 } }));
  }
  var n3 = (e28.options[0] || {}).treatUndefinedAsUnspecified === true, r3 = null;
  return { onCodePathStart: function(i, a3) {
    r3 = { upper: r3, codePath: i, hasReturn: false, hasReturnValue: false, messageId: "", node: a3 };
  }, onCodePathEnd: function() {
    r3 = r3.upper;
  }, ReturnStatement: function(i) {
    var a3 = i.argument, s3 = !!a3;
    n3 && s3 && (s3 = !function(o3, u3) {
      return o3.type === "Identifier" && o3.name === u3;
    }(a3, "undefined") && a3.operator !== "void"), r3.hasReturn ? r3.hasReturnValue !== s3 && e28.report({ node: i, messageId: r3.messageId, data: r3.data }) : (r3.hasReturn = true, r3.hasReturnValue = s3, r3.messageId = s3 ? "missingReturnValue" : "unexpectedReturnValue", r3.data = { name: r3.node.type === "Program" ? "Program" : ye$4.lodash.upperFirst(P$s.getFunctionNameWithKind(r3.node)) });
  }, "Program:exit": t3, "FunctionDeclaration:exit": t3, "FunctionExpression:exit": t3, "ArrowFunctionExpression:exit": t3 };
} };
function s5(e28) {
  return e28.reachable;
}
function Ao$1(e28) {
  if (!e28)
    return false;
  switch (e28.type) {
    case "ClassExpression":
    case "FunctionExpression":
    case "ThisExpression":
    case "MemberExpression":
    case "CallExpression":
    case "NewExpression":
    case "YieldExpression":
    case "TaggedTemplateExpression":
    case "MetaProperty":
      return true;
    case "Identifier":
      return e28.name !== "undefined";
    case "AssignmentExpression":
      return Ao$1(e28.right);
    case "LogicalExpression":
      return Ao$1(e28.left) || Ao$1(e28.right);
    case "ConditionalExpression":
      return Ao$1(e28.alternate) || Ao$1(e28.consequent);
    case "SequenceExpression":
      return Ao$1(e28.expressions[e28.expressions.length - 1]);
    default:
      return false;
  }
}
var u5 = { meta: { type: "problem", docs: { description: "require `super()` calls in constructors", category: "ECMAScript 6", recommended: true, url: "https://eslint.org/docs/rules/constructor-super" }, schema: [], messages: { missingSome: "Lacked a call of 'super()' in some code paths.", missingAll: "Expected to call 'super()'.", duplicate: "Unexpected duplicate 'super()'.", badSuper: "Unexpected 'super()' because 'super' is not a constructor.", unexpected: "Unexpected 'super()'." } }, create: function(e28) {
  function t3(a3) {
    return a3.reachable && i[a3.id].calledInSomePaths;
  }
  function n3(a3) {
    return !(a3.nextSegments.length !== 1 || !a3.nextSegments[0].isLoopedPrevSegment(a3)) || a3.reachable && i[a3.id].calledInEveryPaths;
  }
  var r3 = null, i = /* @__PURE__ */ Object.create(null);
  return { onCodePathStart: function(a3, s3) {
    if (function(u3) {
      return u3.type === "FunctionExpression" && u3.parent.type === "MethodDefinition" && u3.parent.kind === "constructor";
    }(s3)) {
      var o3 = s3.parent.parent.parent.superClass;
      r3 = { upper: r3, isConstructor: true, hasExtends: !!o3, superIsConstructor: Ao$1(o3), codePath: a3 };
    } else
      r3 = { upper: r3, isConstructor: false, hasExtends: false, superIsConstructor: false, codePath: a3 };
  }, onCodePathEnd: function(a3, s3) {
    var o3 = r3.hasExtends;
    if (r3 = r3.upper, o3) {
      var u3 = a3.returnedSegments, c3 = u3.every(n3), f3 = u3.some(t3);
      c3 || e28.report({ messageId: f3 ? "missingSome" : "missingAll", node: s3.parent });
    }
  }, onCodePathSegmentStart: function(a3) {
    if (r3 && r3.isConstructor && r3.hasExtends) {
      var s3 = i[a3.id] = { calledInSomePaths: false, calledInEveryPaths: false, validNodes: [] }, o3 = a3.prevSegments;
      0 < o3.length && (s3.calledInSomePaths = o3.some(t3), s3.calledInEveryPaths = o3.every(n3));
    }
  }, onCodePathSegmentLoop: function(a3, s3) {
    if (r3 && r3.isConstructor && r3.hasExtends) {
      var o3 = 2 <= s3.prevSegments.length;
      r3.codePath.traverseSegments({ first: s3, last: a3 }, function(u3) {
        var c3 = i[u3.id], f3 = u3.prevSegments;
        if (c3.calledInSomePaths = f3.some(t3), c3.calledInEveryPaths = f3.every(n3), c3.calledInSomePaths || o3) {
          var p3 = c3.validNodes;
          c3.validNodes = [];
          for (var d3 = 0; d3 < p3.length; ++d3) {
            var m3 = p3[d3];
            e28.report({ messageId: "duplicate", node: m3 });
          }
        }
      });
    }
  }, "CallExpression:exit": function(a3) {
    if (r3 && r3.isConstructor && a3.callee.type === "Super")
      if (r3.hasExtends) {
        for (var s3 = r3.codePath.currentSegments, o3 = false, u3 = null, c3 = 0; c3 < s3.length; ++c3) {
          var f3 = s3[c3];
          f3.reachable && (u3 = i[f3.id], o3 = o3 || u3.calledInSomePaths, u3.calledInSomePaths = u3.calledInEveryPaths = true);
        }
        u3 && (o3 ? e28.report({ messageId: "duplicate", node: a3 }) : r3.superIsConstructor ? u3.validNodes.push(a3) : e28.report({ messageId: "badSuper", node: a3 }));
      } else
        r3.codePath.currentSegments.some(s5) && e28.report({ messageId: "unexpected", node: a3 });
  }, ReturnStatement: function(a3) {
    if (r3 && r3.isConstructor && r3.hasExtends && a3.argument)
      for (var s3 = r3.codePath.currentSegments, o3 = 0; o3 < s3.length; ++o3) {
        var u3 = s3[o3];
        if (u3.reachable) {
          var c3 = i[u3.id];
          c3.calledInSomePaths = c3.calledInEveryPaths = true;
        }
      }
  }, "Program:exit": function() {
    i = /* @__PURE__ */ Object.create(null);
  } };
} }, c5 = { meta: { type: "suggestion", docs: { description: "enforce consistent brace style for all control statements", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/curly" }, schema: { anyOf: [{ type: "array", items: [{ enum: ["all"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["multi", "multi-line", "multi-or-nest"] }, { enum: ["consistent"] }], minItems: 0, maxItems: 2 }] }, fixable: "code", messages: { missingCurlyAfter: "Expected { after '{{name}}'.", missingCurlyAfterCondition: "Expected { after '{{name}}' condition.", unexpectedCurlyAfter: "Unnecessary { after '{{name}}'.", unexpectedCurlyAfterCondition: "Unnecessary { after '{{name}}' condition." } }, create: function(e28) {
  function t3(p3) {
    if (p3.type === "EmptyStatement")
      return true;
    var d3 = f3.getFirstToken(p3), m3 = f3.getLastToken(p3), y3 = P$s.isSemicolonToken(m3) ? f3.getTokenBefore(m3) : m3;
    return d3.loc.start.line === y3.loc.end.line;
  }
  function n3(p3) {
    return p3.type === "VariableDeclaration" ? p3.kind === "const" || p3.kind === "let" : p3.type === "FunctionDeclaration" || p3.type === "ClassDeclaration";
  }
  function r3(p3) {
    return p3.value === "else" && p3.type === "Keyword";
  }
  function i(p3) {
    return p3.alternate && f3.getFirstTokenBetween(p3.consequent, p3.alternate, r3);
  }
  function a3(p3, d3, m3, y3) {
    var v3 = d3.type === "BlockStatement", b3 = null;
    if (p3.type === "IfStatement" && p3.consequent === d3 && function(C3) {
      if (C3.alternate && C3.consequent.type === "BlockStatement") {
        if (2 <= C3.consequent.body.length)
          return true;
        for (var k3 = C3.consequent.body[0]; k3; k3 = P$s.getTrailingStatement(k3))
          if (k3.type === "IfStatement" && !k3.alternate)
            return true;
      }
      return false;
    }(p3))
      b3 = true;
    else if (s3)
      v3 && d3.body.length === 1 && !n3(d3.body[0]) && (b3 = false);
    else if (o3)
      (function(C3) {
        var k3 = f3.getTokenBefore(C3), F3 = f3.getLastToken(C3), B3 = P$s.isSemicolonToken(F3) ? f3.getTokenBefore(F3) : F3;
        return k3.loc.start.line === B3.loc.end.line;
      })(d3) || (b3 = true);
    else if (u3)
      if (v3 && d3.body.length === 1 && t3(d3.body[0])) {
        var x3 = f3.getCommentsBefore(d3.body[0]);
        b3 = !!n3(d3.body[0]) || 0 < x3.length;
      } else
        t3(d3) || (b3 = true);
    else
      b3 = true;
    return { actual: v3, expected: b3, check: function() {
      this.expected !== null && this.expected !== this.actual && (this.expected ? e28.report({ node: p3, loc: (m3 === "else" ? i(p3) : p3).loc.start, messageId: y3 && y3.condition ? "missingCurlyAfterCondition" : "missingCurlyAfter", data: { name: m3 }, fix: function(C3) {
        return C3.replaceText(d3, "{".concat(f3.getText(d3), "}"));
      } }) : e28.report({ node: p3, loc: (m3 === "else" ? i(p3) : p3).loc.start, messageId: y3 && y3.condition ? "unexpectedCurlyAfterCondition" : "unexpectedCurlyAfter", data: { name: m3 }, fix: function(C3) {
        var k3 = p3.type === "DoWhileStatement" && f3.getTokenBefore(d3).range[1] === d3.range[0] && !P$s.canTokensBeAdjacent("do", f3.getFirstToken(d3, { skip: 1 })), F3 = f3.getFirstToken(d3), B3 = f3.getLastToken(d3), O3 = f3.getTokenBefore(B3);
        if (function(w3) {
          var D3 = f3.getTokenBefore(w3), I3 = f3.getTokenAfter(w3), L3 = f3.getNodeByRangeIndex(D3.range[0]);
          return !(P$s.isSemicolonToken(D3) || !I3 || L3.type === "BlockStatement" && L3.parent.type !== "FunctionExpression" && L3.parent.type !== "ArrowFunctionExpression" || D3.loc.end.line !== I3.loc.start.line && !/^[\(\+\x2D\/\[`]/.test(I3.value) && (D3.type !== "Punctuator" || D3.value !== "++" && D3.value !== "--"));
        }(B3))
          return null;
        var S3 = f3.getText().slice(F3.range[1], O3.range[0]) + f3.getText(O3) + f3.getText().slice(O3.range[1], B3.range[0]);
        return C3.replaceText(d3, (k3 ? " " : "") + S3);
      } }));
    } };
  }
  var s3 = e28.options[0] === "multi", o3 = e28.options[0] === "multi-line", u3 = e28.options[0] === "multi-or-nest", c3 = e28.options[1] === "consistent", f3 = e28.getSourceCode();
  return { IfStatement: function(p3) {
    p3.parent.type !== "IfStatement" && function(d3) {
      for (var m3 = [], y3 = d3; y3; y3 = y3.alternate)
        if (m3.push(a3(y3, y3.consequent, "if", { condition: true })), y3.alternate && y3.alternate.type !== "IfStatement") {
          m3.push(a3(y3, y3.alternate, "else"));
          break;
        }
      if (c3) {
        var v3 = m3.some(function(b3) {
          return b3.expected === null ? b3.actual : b3.expected;
        });
        m3.forEach(function(b3) {
          b3.expected = v3;
        });
      }
      return m3;
    }(p3).forEach(function(d3) {
      d3.check();
    });
  }, WhileStatement: function(p3) {
    a3(p3, p3.body, "while", { condition: true }).check();
  }, DoWhileStatement: function(p3) {
    a3(p3, p3.body, "do").check();
  }, ForStatement: function(p3) {
    a3(p3, p3.body, "for", { condition: true }).check();
  }, ForInStatement: function(p3) {
    a3(p3, p3.body, "for-in").check();
  }, ForOfStatement: function(p3) {
    a3(p3, p3.body, "for-of").check();
  } };
} }, l5 = /^no default$/i, p5 = { meta: { type: "suggestion", docs: { description: "require `default` cases in `switch` statements", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/default-case" }, schema: [{ type: "object", properties: { commentPattern: { type: "string" } }, additionalProperties: false }], messages: { missingDefaultCase: "Expected a default case." } }, create: function(e28) {
  function t3(a3) {
    return a3[a3.length - 1];
  }
  var n3 = e28.options[0] || {}, r3 = n3.commentPattern ? new RegExp(n3.commentPattern, "u") : l5, i = e28.getSourceCode();
  return { SwitchStatement: function(a3) {
    if (a3.cases.length && !a3.cases.some(function(c3) {
      return c3.test === null;
    })) {
      var s3, o3 = t3(a3.cases), u3 = i.getCommentsAfter(o3);
      u3.length && (s3 = t3(u3)), s3 && r3.test(s3.value.trim()) || e28.report({ node: a3, messageId: "missingDefaultCase" });
    }
  } };
} }, f5 = { meta: { type: "layout", docs: { description: "enforce consistent newlines before and after dots", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/dot-location" }, schema: [{ enum: ["object", "property"] }], fixable: "code", messages: { expectedDotAfterObject: "Expected dot to be on same line as object.", expectedDotBeforeProperty: "Expected dot to be on same line as property." } }, create: function(e28) {
  function t3(a3) {
    var s3 = a3.property, o3 = i.getTokenBefore(s3), u3 = i.getTokenBefore(o3), c3 = i.getText().slice(u3.range[1], o3.range[0]), f3 = i.getText().slice(o3.range[1], s3.range[0]);
    if (r3) {
      if (!P$s.isTokenOnSameLine(u3, o3)) {
        var p3 = P$s.isDecimalIntegerNumericToken(u3) ? " " : "";
        e28.report({ node: a3, loc: o3.loc, messageId: "expectedDotAfterObject", fix: function(d3) {
          return d3.replaceTextRange([u3.range[1], s3.range[0]], "".concat(p3, ".").concat(c3).concat(f3));
        } });
      }
    } else
      P$s.isTokenOnSameLine(o3, s3) || e28.report({ node: a3, loc: o3.loc, messageId: "expectedDotBeforeProperty", fix: function(d3) {
        return d3.replaceTextRange([u3.range[1], s3.range[0]], "".concat(c3).concat(f3, "."));
      } });
  }
  var n3 = e28.options[0], r3 = n3 === "object" || !n3, i = e28.getSourceCode();
  return { MemberExpression: function(a3) {
    a3.computed || t3(a3);
  } };
} }, Qp = ["abstract", "boolean", "break", "byte", "case", "catch", "char", "class", "const", "continue", "debugger", "default", "delete", "do", "double", "else", "enum", "export", "extends", "false", "final", "finally", "float", "for", "function", "goto", "if", "implements", "import", "in", "instanceof", "int", "interface", "long", "native", "new", "null", "package", "private", "protected", "public", "return", "short", "static", "super", "switch", "synchronized", "this", "throw", "throws", "transient", "true", "try", "typeof", "var", "void", "volatile", "while", "with"], h5 = /^[\$A-Z_a-z][\$0-9A-Z_a-z]*$/, d5 = /* @__PURE__ */ new Set(["string", "boolean"]), m5 = { meta: { type: "suggestion", docs: { description: "enforce dot notation whenever possible", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/dot-notation" }, schema: [{ type: "object", properties: { allowKeywords: { type: "boolean", default: true }, allowPattern: { type: "string", default: "" } }, additionalProperties: false }], fixable: "code", messages: { useDot: "[{{key}}] is better written in dot notation.", useBrackets: ".{{key}} is a syntax error." } }, create: function(e28) {
  function t3(s3, o3) {
    if (h5.test(o3) && (i || Qp.indexOf(o3 + "") === -1) && (!n3 || !n3.test(o3))) {
      var u3 = s3.property.type === "Literal" ? JSON.stringify(o3) : "`".concat(o3, "`");
      e28.report({ node: s3.property, messageId: "useDot", data: { key: u3 }, fix: function(c3) {
        var f3 = a3.getTokenAfter(s3.object, P$s.isOpeningBracketToken), p3 = a3.getLastToken(s3);
        if (a3.getFirstTokenBetween(f3, p3, { includeComments: true, filter: P$s.isCommentToken }))
          return null;
        var d3 = a3.getTokenAfter(p3), m3 = d3 && p3.range[1] === d3.range[0] && !P$s.canTokensBeAdjacent(o3 + "", d3), y3 = P$s.isDecimalInteger(s3.object) ? " " : "", v3 = m3 ? " " : "";
        return c3.replaceTextRange([f3.range[0], p3.range[1]], "".concat(y3, ".").concat(o3).concat(v3));
      } });
    }
  }
  var n3, r3 = e28.options[0] || {}, i = r3.allowKeywords === void 0 || r3.allowKeywords, a3 = e28.getSourceCode();
  return r3.allowPattern && (n3 = new RegExp(r3.allowPattern, "u")), { MemberExpression: function(s3) {
    s3.computed && s3.property.type === "Literal" && (d5.has(xe$3(s3.property.value)) || P$s.isNullLiteral(s3.property)) && t3(s3, s3.property.value), s3.computed && s3.property.type === "TemplateLiteral" && s3.property.expressions.length === 0 && t3(s3, s3.property.quasis[0].value.cooked), i || s3.computed || Qp.indexOf(s3.property.name + "") === -1 || e28.report({ node: s3.property, messageId: "useBrackets", data: { key: s3.property.name }, fix: function(o3) {
      var u3 = a3.getTokenBefore(s3.property), c3 = a3.text.slice(u3.range[1], s3.property.range[0]);
      return c3.trim() || s3.object.type === "Identifier" && s3.object.name === "let" ? null : o3.replaceTextRange([u3.range[0], s3.property.range[1]], "[".concat(c3, '"').concat(s3.property.name, '"]'));
    } });
  } };
} }, g5 = { meta: { type: "layout", docs: { description: "require or disallow newline at the end of files", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/eol-last" }, fixable: "whitespace", schema: [{ enum: ["always", "never", "unix", "windows"] }], messages: { missing: "Newline required at end of file but not found.", unexpected: "Newline not allowed at end of file." } }, create: function(e28) {
  return { Program: function(t3) {
    var n3 = e28.getSourceCode(), r3 = n3.getText(), i = { column: ye$4.lodash.last(n3.lines).length, line: n3.lines.length }, a3 = ye$4.lodash.endsWith(r3, `
`);
    if (r3.length) {
      var s3 = e28.options[0] || "always", o3 = false;
      s3 === "unix" && (s3 = "always"), s3 === "windows" && (s3 = "always", o3 = true), s3 !== "always" || a3 ? s3 === "never" && a3 && e28.report({ node: t3, loc: i, messageId: "unexpected", fix: function(u3) {
        var c3 = /(?:\r?\n)+$/.exec(n3.text).index, f3 = n3.text.length;
        return u3.replaceTextRange([c3, f3], "");
      } }) : e28.report({ node: t3, loc: i, messageId: "missing", fix: function(u3) {
        return u3.insertTextAfterRange([0, r3.length], o3 ? "\r".concat(`
`) : `
`);
      } });
    }
  } };
} }, y5 = { meta: { type: "suggestion", docs: { description: "require the use of `===` and `!==`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/eqeqeq" }, schema: { anyOf: [{ type: "array", items: [{ enum: ["always"] }, { type: "object", properties: { null: { enum: ["always", "never", "ignore"] } }, additionalProperties: false }], additionalItems: false }, { type: "array", items: [{ enum: ["smart", "allow-null"] }], additionalItems: false }] }, fixable: "code", messages: { unexpected: "Expected '{{expectedOperator}}' and instead saw '{{actualOperator}}'." } }, create: function(e28) {
  function t3(c3) {
    return c3.type === "UnaryExpression" && c3.operator === "typeof";
  }
  function n3(c3) {
    return t3(c3.left) || t3(c3.right);
  }
  function r3(c3) {
    return c3.left.type === "Literal" && c3.right.type === "Literal" && xe$3(c3.left.value) == xe$3(c3.right.value);
  }
  function i(c3, f3) {
    var p3 = o3.getFirstTokenBetween(c3.left, c3.right, function(d3) {
      return d3.value === c3.operator;
    });
    e28.report({ node: c3, loc: p3.loc, messageId: "unexpected", data: { expectedOperator: f3, actualOperator: c3.operator }, fix: function(d3) {
      return n3(c3) || r3(c3) ? d3.replaceText(p3, f3) : null;
    } });
  }
  var a3 = e28.options[0] || "always", s3 = e28.options[1] || {}, o3 = e28.getSourceCode(), u3 = a3 === "always" ? s3.null || "always" : "ignore";
  return { BinaryExpression: function(c3) {
    var f3 = function(p3) {
      return P$s.isNullLiteral(p3.right) || P$s.isNullLiteral(p3.left);
    }(c3);
    return c3.operator !== "==" && c3.operator !== "!=" ? void (u3 === "never" && f3 && i(c3, c3.operator.slice(0, -1))) : void (a3 === "smart" && (n3(c3) || r3(c3) || f3) || u3 !== "always" && f3 || i(c3, "".concat(c3.operator, "=")));
  } };
} }, v5 = { meta: { type: "layout", docs: { description: "require or disallow spacing between function identifiers and their invocations", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/func-call-spacing" }, fixable: "whitespace", schema: { anyOf: [{ type: "array", items: [{ enum: ["never"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["always"] }, { type: "object", properties: { allowNewlines: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }] }, messages: { unexpected: "Unexpected newline between function name and paren.", missing: "Missing space between function name and paren." } }, create: function(e28) {
  function t3(s3, o3, u3) {
    var c3 = a3.slice(o3.range[1], u3.range[0]).replace(/\/\*(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\*\//g, ""), f3 = /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]/.test(c3), p3 = f3 && P$s.LINEBREAK_MATCHER.test(c3);
    n3 && f3 ? e28.report({ node: s3, loc: o3.loc.start, messageId: "unexpected", fix: function(d3) {
      return p3 ? null : d3.removeRange([o3.range[1], u3.range[0]]);
    } }) : n3 || f3 ? !n3 && !r3 && p3 && e28.report({ node: s3, loc: o3.loc.start, messageId: "unexpected", fix: function(d3) {
      return d3.replaceTextRange([o3.range[1], u3.range[0]], " ");
    } }) : e28.report({ node: s3, loc: o3.loc.start, messageId: "missing", fix: function(d3) {
      return d3.insertTextBefore(u3, " ");
    } });
  }
  var n3 = e28.options[0] !== "always", r3 = !n3 && e28.options[1] && e28.options[1].allowNewlines, i = e28.getSourceCode(), a3 = i.getText();
  return { "CallExpression, NewExpression": function(s3) {
    var o3 = i.getLastToken(s3), u3 = i.getLastToken(s3.callee), c3 = i.getFirstTokenBetween(u3, o3, P$s.isOpeningParenToken), f3 = c3 && i.getTokenBefore(c3);
    c3 && c3.range[1] < s3.range[1] && t3(s3, f3, c3);
  }, ImportExpression: function(s3) {
    var o3 = i.getFirstToken(s3);
    t3(s3, o3, i.getTokenAfter(o3));
  } };
} };
function n2(e28, t3) {
  return 6 <= t3 ? l0.keyword.isIdentifierES6(e28) : l0.keyword.isIdentifierES5(e28);
}
var r2 = { type: "object", properties: { considerPropertyDescriptor: { type: "boolean" }, includeCommonJSModuleExports: { type: "boolean" } }, additionalProperties: false }, x5 = { meta: { type: "suggestion", docs: { description: "require function names to match the name of the variable or property to which they are assigned", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/func-name-matching" }, schema: { anyOf: [{ type: "array", additionalItems: false, items: [{ enum: ["always", "never"] }, r2] }, { type: "array", additionalItems: false, items: [r2] }] }, messages: { matchProperty: "Function name `{{funcName}}` should match property name `{{name}}`.", matchVariable: "Function name `{{funcName}}` should match variable name `{{name}}`.", notMatchProperty: "Function name `{{funcName}}` should not match property name `{{name}}`.", notMatchVariable: "Function name `{{funcName}}` should not match variable name `{{name}}`." } }, create: function(e28) {
  function t3(f3, p3, d3) {
    return !!d3 && d3.type === "CallExpression" && d3.callee.type === "MemberExpression" && d3.callee.object.name === f3 && d3.callee.property.name === p3;
  }
  function n3(f3, p3) {
    return s3 === "always" && f3 !== p3 || s3 === "never" && f3 === p3;
  }
  function r3(f3, p3, d3, m3) {
    var y3;
    y3 = s3 === "always" && m3 ? "matchProperty" : s3 === "always" ? "matchVariable" : m3 ? "notMatchProperty" : "notMatchVariable", e28.report({ node: f3, messageId: y3, data: { name: p3, funcName: d3 } });
  }
  function i(f3) {
    return f3.type === "Literal" && typeof f3.value == "string";
  }
  var a3 = (xe$3(e28.options[0]) == "object" ? e28.options[0] : e28.options[1]) || {}, s3 = typeof e28.options[0] == "string" ? e28.options[0] : "always", o3 = a3.considerPropertyDescriptor, u3 = a3.includeCommonJSModuleExports, c3 = e28.parserOptions && e28.parserOptions.ecmaVersion ? e28.parserOptions.ecmaVersion : 5;
  return { VariableDeclarator: function(f3) {
    !f3.init || f3.init.type !== "FunctionExpression" || f3.id.type !== "Identifier" || f3.init.id && n3(f3.id.name, f3.init.id.name) && r3(f3, f3.id.name, f3.init.id.name, false);
  }, AssignmentExpression: function(f3) {
    if (!(f3.right.type !== "FunctionExpression" || f3.left.computed && f3.left.property.type !== "Literal" || !u3 && function(m3) {
      return m3.type === "MemberExpression" && m3.object.type === "Identifier" && m3.object.name === "module" && (m3.property.type === "Identifier" && m3.property.name === "exports" || m3.property.type === "Literal" && m3.property.value === "exports");
    }(f3.left) || f3.left.type !== "Identifier" && f3.left.type !== "MemberExpression")) {
      var p3 = f3.left.type === "MemberExpression", d3 = p3 ? P$s.getStaticPropertyName(f3.left) : f3.left.name;
      f3.right.id && n2(d3) && n3(d3, f3.right.id.name) && r3(f3, d3, f3.right.id.name, p3);
    }
  }, Property: function(f3) {
    if (f3.value.type === "FunctionExpression" && f3.value.id && (!f3.computed || i(f3.key))) {
      if (f3.key.type === "Identifier") {
        var p3 = f3.value.id.name, d3 = f3.key.name;
        if (o3 && d3 === "value")
          if (t3("Object", "defineProperty", f3.parent.parent) || t3("Reflect", "defineProperty", f3.parent.parent)) {
            var m3 = f3.parent.parent.arguments[1];
            i(m3) && n3(m3.value, p3) && r3(f3, m3.value, p3, true);
          } else
            t3("Object", "defineProperties", f3.parent.parent.parent.parent) || t3("Object", "create", f3.parent.parent.parent.parent) ? (d3 = f3.parent.parent.key.name, !f3.parent.parent.computed && n3(d3, p3) && r3(f3, d3, p3, true)) : n3(d3, p3) && r3(f3, d3, p3, true);
        else
          n3(d3, p3) && r3(f3, d3, p3, true);
        return;
      }
      i(f3.key) && n2(f3.key.value, c3) && n3(f3.key.value, f3.value.id.name) && r3(f3, f3.key.value, f3.value.id.name, true);
    }
  } };
} }, b5 = { meta: { type: "suggestion", docs: { description: "require or disallow named `function` expressions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/func-names" }, schema: { definitions: { value: { enum: ["always", "as-needed", "never"] } }, items: [{ $ref: "#/definitions/value" }, { type: "object", properties: { generators: { $ref: "#/definitions/value" } }, additionalProperties: false }] }, messages: { unnamed: "Unexpected unnamed {{name}}.", named: "Unexpected named {{name}}." } }, create: function(e28) {
  function t3(a3) {
    var s3 = a3.parent;
    return s3.type === "MethodDefinition" || s3.type === "Property" && (s3.method || s3.kind === "get" || s3.kind === "set");
  }
  function n3(a3) {
    e28.report({ node: a3, messageId: "unnamed", loc: P$s.getFunctionHeadLoc(a3, i), data: { name: P$s.getFunctionNameWithKind(a3) } });
  }
  function r3(a3) {
    e28.report({ node: a3, messageId: "named", loc: P$s.getFunctionHeadLoc(a3, i), data: { name: P$s.getFunctionNameWithKind(a3) } });
  }
  var i = e28.getSourceCode();
  return { "FunctionExpression:exit": function(a3) {
    var s3 = e28.getDeclaredVariables(a3)[0];
    if (!(function(c3) {
      return c3 && c3.defs[0].type === "FunctionName";
    }(s3) && 0 < s3.references.length)) {
      var o3 = !(!a3.id || !a3.id.name), u3 = function(c3) {
        return c3.generator && 1 < e28.options.length && e28.options[1].generators ? e28.options[1].generators : e28.options[0] || "always";
      }(a3);
      u3 === "never" ? o3 && r3(a3) : u3 === "as-needed" ? !o3 && !function(c3) {
        var f3 = c3.parent;
        return t3(c3) || f3.type === "VariableDeclarator" && f3.id.type === "Identifier" && f3.init === c3 || f3.type === "Property" && f3.value === c3 || f3.type === "AssignmentExpression" && f3.left.type === "Identifier" && f3.right === c3 || f3.type === "ExportDefaultDeclaration" && f3.declaration === c3 || f3.type === "AssignmentPattern" && f3.right === c3;
      }(a3) && n3(a3) : !o3 && !t3(a3) && n3(a3);
    }
  } };
} }, E5 = { meta: { type: "layout", docs: { description: "enforce consistent line breaks inside function parentheses", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/function-paren-newline" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never", "consistent", "multiline", "multiline-arguments"] }, { type: "object", properties: { minItems: { type: "integer", minimum: 0 } }, additionalProperties: false }] }], messages: { expectedBefore: "Expected newline before ')'.", expectedAfter: "Expected newline after '('.", expectedBetween: "Expected newline between arguments/params.", unexpectedBefore: "Unexpected newline before ')'.", unexpectedAfter: "Unexpected newline after '('." } }, create: function(e28) {
  function t3(p3, d3) {
    return c3 && p3.length === 1 ? d3 : u3 || c3 ? p3.some(function(m3, y3) {
      return y3 !== p3.length - 1 && m3.loc.end.line !== p3[y3 + 1].loc.start.line;
    }) : f3 ? d3 : p3.length >= a3;
  }
  function n3(p3, d3) {
    var m3 = p3.leftParen, y3 = p3.rightParen, v3 = s3.getTokenAfter(m3), b3 = s3.getTokenBefore(y3), x3 = !P$s.isTokenOnSameLine(m3, v3), C3 = !P$s.isTokenOnSameLine(b3, y3), k3 = t3(d3, x3);
    x3 && !k3 ? e28.report({ node: m3, messageId: "unexpectedAfter", fix: function(F3) {
      return s3.getText().slice(m3.range[1], v3.range[0]).trim() ? null : F3.removeRange([m3.range[1], v3.range[0]]);
    } }) : !x3 && k3 && e28.report({ node: m3, messageId: "expectedAfter", fix: function(F3) {
      return F3.insertTextAfter(m3, `
`);
    } }), C3 && !k3 ? e28.report({ node: y3, messageId: "unexpectedBefore", fix: function(F3) {
      return s3.getText().slice(b3.range[1], y3.range[0]).trim() ? null : F3.removeRange([b3.range[1], y3.range[0]]);
    } }) : !C3 && k3 && e28.report({ node: y3, messageId: "expectedBefore", fix: function(F3) {
      return F3.insertTextBefore(y3, `
`);
    } });
  }
  function r3(p3, d3) {
    for (var m3 = p3.leftParen, y3 = s3.getTokenAfter(m3), v3 = !P$s.isTokenOnSameLine(m3, y3), b3 = t3(d3, v3), x3 = function(k3) {
      var F3 = d3[k3], B3 = d3[k3 + 1];
      F3.loc.end.line === B3.loc.start.line && b3 && e28.report({ node: F3, messageId: "expectedBetween", fix: function(O3) {
        return O3.insertTextBefore(B3, `
`);
      } });
    }, C3 = 0; C3 <= d3.length - 2; C3++)
      x3(C3);
  }
  function i(p3) {
    switch (p3.type) {
      case "NewExpression":
        if (!(p3.arguments.length || P$s.isOpeningParenToken(s3.getLastToken(p3, { skip: 1 })) && P$s.isClosingParenToken(s3.getLastToken(p3))))
          return null;
      case "CallExpression":
        return { leftParen: s3.getTokenAfter(p3.callee, P$s.isOpeningParenToken), rightParen: s3.getLastToken(p3) };
      case "FunctionDeclaration":
      case "FunctionExpression":
        var d3 = s3.getFirstToken(p3, P$s.isOpeningParenToken);
        return { leftParen: d3, rightParen: p3.params.length ? s3.getTokenAfter(p3.params[p3.params.length - 1], P$s.isClosingParenToken) : s3.getTokenAfter(d3) };
      case "ArrowFunctionExpression":
        var m3 = s3.getFirstToken(p3);
        return P$s.isOpeningParenToken(m3) ? { leftParen: m3, rightParen: s3.getTokenBefore(p3.body, P$s.isClosingParenToken) } : null;
      case "ImportExpression":
        return { leftParen: s3.getFirstToken(p3, 1), rightParen: s3.getLastToken(p3) };
      default:
        throw new TypeError("unexpected node with type ".concat(p3.type));
    }
  }
  var a3, s3 = e28.getSourceCode(), o3 = e28.options[0] || "multiline", u3 = o3 === "multiline", c3 = o3 === "multiline-arguments", f3 = o3 === "consistent";
  return a3 = xe$3(o3) == "object" ? o3.minItems : o3 === "always" ? 0 : o3 === "never" ? 1 / 0 : null, Fn$1({}, ["ArrowFunctionExpression", "CallExpression", "FunctionDeclaration", "FunctionExpression", "ImportExpression", "NewExpression"], function(p3) {
    var d3, m3 = i(p3);
    d3 = p3.type === "ImportExpression" ? [p3.source] : P$s.isFunction(p3) ? p3.params : p3.arguments, m3 && (n3(m3, d3), c3 && r3(m3, d3));
  });
} }, Kd$1 = { oneOf: [{ enum: ["before", "after", "both", "neither"] }, { type: "object", properties: { before: { type: "boolean" }, after: { type: "boolean" } }, additionalProperties: false }] }, C5 = { meta: { type: "layout", docs: { description: "enforce consistent spacing around `*` operators in generator functions", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/generator-star-spacing" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["before", "after", "both", "neither"] }, { type: "object", properties: { before: { type: "boolean" }, after: { type: "boolean" }, named: Kd$1, anonymous: Kd$1, method: Kd$1 }, additionalProperties: false }] }], messages: { missingBefore: "Missing space before *.", missingAfter: "Missing space after *.", unexpectedBefore: "Unexpected space before *.", unexpectedAfter: "Unexpected space after *." } }, create: function(e28) {
  function t3(c3, f3) {
    return c3 ? typeof c3 == "string" ? s3[c3] : Object.assign({}, f3, c3) : f3;
  }
  function n3(c3) {
    return c3.value === "*" && c3.type === "Punctuator";
  }
  function r3(c3) {
    return u3.getFirstToken(c3.parent.method || c3.parent.type === "MethodDefinition" ? c3.parent : c3, n3);
  }
  function i(c3, f3, p3, d3) {
    if (!!(d3.range[0] - p3.range[1]) !== o3[c3][f3]) {
      var m3 = p3.value === "*", y3 = o3[c3][f3], v3 = m3 ? p3 : d3, b3 = "".concat(y3 ? "missing" : "unexpected").concat(function(x3) {
        return x3[0].toUpperCase() + x3.slice(1);
      }(f3));
      e28.report({ node: v3, messageId: b3, fix: function(x3) {
        return y3 ? m3 ? x3.insertTextAfter(v3, " ") : x3.insertTextBefore(v3, " ") : x3.removeRange([p3.range[1], d3.range[0]]);
      } });
    }
  }
  function a3(c3) {
    if (c3.generator) {
      var f3 = r3(c3), p3 = u3.getTokenBefore(f3), d3 = u3.getTokenAfter(f3), m3 = "named";
      c3.parent.type === "MethodDefinition" || c3.parent.type === "Property" && c3.parent.method ? m3 = "method" : !c3.id && (m3 = "anonymous"), m3 == "method" && f3 === u3.getFirstToken(c3.parent) || i(m3, "before", p3, f3), i(m3, "after", f3, d3);
    }
  }
  var s3 = { before: { before: true, after: false }, after: { before: false, after: true }, both: { before: true, after: true }, neither: { before: false, after: false } }, o3 = function(c3) {
    var f3 = t3(c3, s3.before);
    return { named: t3(c3.named, f3), anonymous: t3(c3.anonymous, f3), method: t3(c3.method, f3) };
  }(e28.options[0] || {}), u3 = e28.getSourceCode();
  return { FunctionDeclaration: a3, FunctionExpression: a3 };
} }, S5 = /^(?:Arrow)?FunctionExpression$/;
function k5(e28) {
  return e28.reachable;
}
function D5(e28) {
  return e28.id || e28;
}
var F5 = { meta: { type: "problem", docs: { description: "enforce `return` statements in getters", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/getter-return" }, fixable: null, schema: [{ type: "object", properties: { allowImplicit: { type: "boolean", default: false } }, additionalProperties: false }], messages: { expected: "Expected to return a value in {{name}}.", expectedAlways: "Expected {{name}} to always return a value." } }, create: function(e28) {
  function t3(a3) {
    i.shouldCheck && i.codePath.currentSegments.some(k5) && e28.report({ node: a3, loc: D5(a3).loc.start, messageId: i.hasReturn ? "expectedAlways" : "expected", data: { name: P$s.getFunctionNameWithKind(i.node) } });
  }
  function n3(a3) {
    var s3 = a3.parent;
    return !!(S5.test(a3.type) && a3.body.type === "BlockStatement" && (s3.kind === "get" || s3.type === "Property" && P$s.getStaticPropertyName(s3) === "get" && s3.parent.type === "ObjectExpression" && (s3.parent.parent.type === "CallExpression" && P$s.getStaticPropertyName(s3.parent.parent.callee) === "defineProperty" || s3.parent.parent.type === "Property" && s3.parent.parent.parent.type === "ObjectExpression" && s3.parent.parent.parent.parent.type === "CallExpression" && P$s.getStaticPropertyName(s3.parent.parent.parent.parent.callee) === "defineProperties")));
  }
  var r3 = e28.options[0] || { allowImplicit: false }, i = { upper: null, codePath: null, hasReturn: false, shouldCheck: false, node: null };
  return { onCodePathStart: function(a3, s3) {
    i = { upper: i, codePath: a3, hasReturn: false, shouldCheck: n3(s3), node: s3 };
  }, onCodePathEnd: function() {
    i = i.upper;
  }, ReturnStatement: function(a3) {
    i.shouldCheck && (i.hasReturn = true, !r3.allowImplicit && !a3.argument && e28.report({ node: a3, messageId: "expected", data: { name: P$s.getFunctionNameWithKind(i.node) } }));
  }, "FunctionExpression:exit": t3, "ArrowFunctionExpression:exit": t3 };
} }, w5 = ["AssignmentExpression", "VariableDeclarator", "MemberExpression", "ExpressionStatement", "CallExpression", "ConditionalExpression", "Program", "VariableDeclaration"], A5 = { meta: { type: "suggestion", docs: { description: "require `require()` calls to be placed at top-level module scope", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/global-require" }, schema: [], messages: { unexpected: "Unexpected require()." } }, create: function(e28) {
  return { CallExpression: function(t3) {
    var n3 = e28.getScope();
    t3.callee.name !== "require" || function(r3, i) {
      var a3 = function(s3, o3) {
        var u3 = s3.references.filter(function(c3) {
          return c3.identifier.range[0] === o3.range[0] && c3.identifier.range[1] === o3.range[1];
        });
        return u3.length === 1 ? u3[0] : null;
      }(r3, i);
      return a3 && a3.resolved && 0 < a3.resolved.defs.length;
    }(n3, t3.callee) || e28.getAncestors().every(function(r3) {
      return -1 < w5.indexOf(r3.type);
    }) || e28.report({ node: t3, messageId: "unexpected" });
  } };
} };
function _5(e28) {
  return e28.kind === "get" || e28.kind === "set";
}
var T5 = { meta: { type: "suggestion", docs: { description: "require grouped accessor pairs in object literals and classes", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/grouped-accessor-pairs" }, schema: [{ enum: ["anyOrder", "getBeforeSet", "setBeforeGet"] }], messages: { notGrouped: "Accessor pair {{ formerName }} and {{ latterName }} should be grouped.", invalidOrder: "Expected {{ latterName }} to be before {{ formerName }}." } }, create: function(e28) {
  function t3(o3, u3, c3) {
    e28.report({ node: c3, messageId: o3, loc: P$s.getFunctionHeadLoc(c3.value, s3), data: { formerName: P$s.getFunctionNameWithKind(u3.value), latterName: P$s.getFunctionNameWithKind(c3.value) } });
  }
  function n3(o3) {
    var u3 = P$s.getStaticPropertyName(o3);
    return { key: u3 === null ? s3.getTokens(o3.key) : u3, getters: o3.kind === "get" ? [o3] : [], setters: o3.kind === "set" ? [o3] : [] };
  }
  function r3(o3, u3) {
    var c3, f3, p3 = o3.find(function(d3) {
      return function(m3, y3) {
        return typeof m3 == "string" && typeof y3 == "string" ? m3 == y3 : !(!Array.isArray(m3) || !Array.isArray(y3)) && function(v3, b3) {
          if (v3.length !== b3.length)
            return false;
          for (var x3 = 0; x3 < v3.length; x3++) {
            var C3 = v3[x3], k3 = b3[x3];
            if (C3.type !== k3.type || C3.value !== k3.value)
              return false;
          }
          return true;
        }(m3, y3);
      }(d3.key, u3.key);
    });
    return p3 ? ((c3 = p3.getters).push.apply(c3, Mt$2(u3.getters)), (f3 = p3.setters).push.apply(f3, Mt$2(u3.setters))) : o3.push(u3), o3;
  }
  function i(o3, u3) {
    var c3 = o3.filter(u3).filter(_5).map(n3).reduce(r3, []), f3 = true, p3 = false, d3 = void 0;
    try {
      for (var m3, y3 = c3[Symbol.iterator](); !(f3 = (m3 = y3.next()).done); f3 = true) {
        var v3 = m3.value, b3 = v3.getters, x3 = v3.setters;
        if (b3.length === 1 && x3.length === 1) {
          var C3 = bn$1(b3, 1)[0], k3 = bn$1(x3, 1)[0], F3 = o3.indexOf(C3), B3 = o3.indexOf(k3), O3 = F3 < B3 ? C3 : k3, S3 = F3 < B3 ? k3 : C3;
          1 < Math.abs(F3 - B3) ? t3("notGrouped", O3, S3) : (a3 === "getBeforeSet" && F3 > B3 || a3 === "setBeforeGet" && F3 < B3) && t3("invalidOrder", O3, S3);
        }
      }
    } catch (w3) {
      p3 = true, d3 = w3;
    } finally {
      try {
        f3 || y3.return == null || y3.return();
      } finally {
        if (p3)
          throw d3;
      }
    }
  }
  var a3 = e28.options[0] || "anyOrder", s3 = e28.getSourceCode();
  return { ObjectExpression: function(o3) {
    i(o3.properties, function(u3) {
      return u3.type === "Property";
    });
  }, ClassBody: function(o3) {
    i(o3.body, function(u3) {
      return u3.type === "MethodDefinition" && !u3.static;
    }), i(o3.body, function(u3) {
      return u3.type === "MethodDefinition" && u3.static;
    });
  } };
} }, P5 = { meta: { type: "suggestion", docs: { description: "require error handling in callbacks", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/handle-callback-err" }, schema: [{ type: "string" }], messages: { expected: "Expected error to be handled." } }, create: function(e28) {
  function t3(i) {
    return function(a3) {
      return a3[0] === "^";
    }(r3) ? new RegExp(r3, "u").test(i) : i === r3;
  }
  function n3(i) {
    var a3 = function(s3) {
      return s3.variables.filter(function(o3) {
        return o3.defs[0] && o3.defs[0].type === "Parameter";
      });
    }(e28.getScope())[0];
    a3 && t3(a3.name) && a3.references.length === 0 && e28.report({ node: i, messageId: "expected" });
  }
  var r3 = e28.options[0] || "err";
  return { FunctionDeclaration: n3, FunctionExpression: n3, ArrowFunctionExpression: n3 };
} }, I5 = { meta: { type: "suggestion", docs: { description: "require identifiers to match a specified regular expression", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/id-match" }, schema: [{ type: "string" }, { type: "object", properties: { properties: { type: "boolean", default: false }, onlyDeclarations: { type: "boolean", default: false }, ignoreDestructuring: { type: "boolean", default: false } } }], messages: { notMatch: "Identifier '{{name}}' does not match the pattern '{{pattern}}'." } }, create: function(e28) {
  function t3(y3) {
    return !a3.test(y3);
  }
  function n3(y3, v3) {
    return (!u3 || d3.has(y3.type)) && !p3.has(y3.type) && t3(v3);
  }
  function r3(y3) {
    f3.has(y3) || (e28.report({ node: y3, messageId: "notMatch", data: { name: y3.name, pattern: i } }), f3.set(y3, true));
  }
  var i = e28.options[0] || "^.+$", a3 = new RegExp(i, "u"), s3 = e28.options[1] || {}, o3 = !!s3.properties, u3 = !!s3.onlyDeclarations, c3 = !!s3.ignoreDestructuring, f3 = /* @__PURE__ */ new Map(), p3 = /* @__PURE__ */ new Set(["CallExpression", "NewExpression"]), d3 = /* @__PURE__ */ new Set(["FunctionDeclaration", "VariableDeclarator"]), m3 = /* @__PURE__ */ new Set(["ImportSpecifier", "ImportNamespaceSpecifier", "ImportDefaultSpecifier"]);
  return { Identifier: function(y3) {
    var v3 = y3.name, b3 = y3.parent, x3 = b3.type === "MemberExpression" ? b3.parent : b3;
    if (b3.type === "MemberExpression") {
      if (!o3)
        return;
      b3.object.type === "Identifier" && b3.object.name === v3 || x3.type === "AssignmentExpression" && x3.left.type === "MemberExpression" && x3.left.property.name === y3.name ? t3(v3) && r3(y3) : x3.type === "AssignmentExpression" && x3.right.type !== "MemberExpression" && t3(v3) && r3(y3);
    } else if (b3.type === "Property" || b3.type === "AssignmentPattern") {
      if (b3.parent && b3.parent.type === "ObjectPattern") {
        b3.shorthand && b3.value.left && t3(v3) && r3(y3);
        var C3 = b3.key.name === b3.value.name;
        if (!C3 && b3.key === y3)
          return;
        b3.value.name && t3(v3) && (!C3 || !c3) && r3(y3);
      }
      if (!o3 || c3 && function(k3) {
        for (var F3 = k3.parent; F3; ) {
          if (F3.type === "ObjectPattern")
            return true;
          F3 = F3.parent;
        }
        return false;
      }(y3))
        return;
      b3.right !== y3 && n3(x3, v3) && r3(y3);
    } else
      m3.has(b3.type) ? b3.local && b3.local.name === y3.name && t3(v3) && r3(y3) : n3(x3, v3) && r3(y3);
  } };
} }, B5 = P$s.isCommentToken, O5 = P$s.isNotOpeningParenToken, L5 = { meta: { type: "layout", docs: { description: "enforce the location of arrow function bodies", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/implicit-arrow-linebreak" }, fixable: "whitespace", schema: [{ enum: ["beside", "below"] }], messages: { expected: "Expected a linebreak before this expression.", unexpected: "Expected no linebreak before this expression." } }, create: function(e28) {
  function t3(i) {
    if (i.body.type !== "BlockStatement") {
      var a3 = n3.getTokenBefore(i.body, O5), s3 = n3.getTokenAfter(a3);
      a3.loc.end.line === s3.loc.start.line && r3 === "below" ? e28.report({ node: s3, messageId: "expected", fix: function(o3) {
        return o3.insertTextBefore(s3, `
`);
      } }) : a3.loc.end.line !== s3.loc.start.line && r3 === "beside" && e28.report({ node: s3, messageId: "unexpected", fix: function(o3) {
        return n3.getFirstTokenBetween(a3, s3, { includeComments: true, filter: B5 }) ? null : o3.replaceTextRange([a3.range[1], s3.range[0]], " ");
      } });
    }
  }
  var n3 = e28.getSourceCode(), r3 = e28.options[0] || "beside";
  return { ArrowFunctionExpression: function(i) {
    return t3(i);
  } };
} }, N5 = { meta: { type: "layout", docs: { description: "enforce consistent indentation", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/indent-legacy" }, deprecated: true, replacedBy: ["indent"], fixable: "whitespace", schema: [{ oneOf: [{ enum: ["tab"] }, { type: "integer", minimum: 0 }] }, { type: "object", properties: { SwitchCase: { type: "integer", minimum: 0 }, VariableDeclarator: { oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { var: { type: "integer", minimum: 0 }, let: { type: "integer", minimum: 0 }, const: { type: "integer", minimum: 0 } } }] }, outerIIFEBody: { type: "integer", minimum: 0 }, MemberExpression: { type: "integer", minimum: 0 }, FunctionDeclaration: { type: "object", properties: { parameters: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first"] }] }, body: { type: "integer", minimum: 0 } } }, FunctionExpression: { type: "object", properties: { parameters: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first"] }] }, body: { type: "integer", minimum: 0 } } }, CallExpression: { type: "object", properties: { parameters: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first"] }] } } }, ArrayExpression: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first"] }] }, ObjectExpression: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first"] }] } }, additionalProperties: false }], messages: { expected: "Expected indentation of {{expected}} but found {{actual}}." } }, create: function(e28) {
  function t3(D3, I3, L3) {
    var V10 = "".concat(D3, " ").concat(C3).concat(D3 === 1 ? "" : "s"), K3 = "space".concat(I3 === 1 ? "" : "s"), W3 = "tab".concat(L3 === 1 ? "" : "s");
    return { expected: V10, actual: 0 < I3 && 0 < L3 ? "".concat(I3, " ").concat(K3, " and ").concat(L3, " ").concat(W3) : 0 < I3 ? C3 === "space" ? I3 : "".concat(I3, " ").concat(K3) : 0 < L3 ? C3 === "tab" ? L3 : "".concat(L3, " ").concat(W3) : "0" };
  }
  function n3(D3, I3, L3, V10, K3, W3) {
    if (!L3 || !V10) {
      var R3 = (C3 === "space" ? " " : "	").repeat(I3), q3 = W3 ? [D3.range[1] - D3.loc.end.column, D3.range[1] - D3.loc.end.column + L3 + V10] : [D3.range[0] - D3.loc.start.column, D3.range[0] - D3.loc.start.column + L3 + V10];
      e28.report({ node: D3, loc: K3, messageId: "expected", data: t3(I3, L3, V10), fix: function(J3) {
        return J3.replaceTextRange(q3, R3);
      } });
    }
  }
  function r3(D3, I3) {
    var L3 = I3 ? B3.getLastToken(D3) : B3.getFirstToken(D3), V10 = B3.getText(L3, L3.loc.start.column).split(""), K3 = V10.slice(0, V10.findIndex(function(q3) {
      return q3 !== " " && q3 !== "	";
    })), W3 = K3.filter(function(q3) {
      return q3 === " ";
    }).length, R3 = K3.filter(function(q3) {
      return q3 === "	";
    }).length;
    return { space: W3, tab: R3, goodChar: C3 === "space" ? W3 : R3, badChar: C3 === "space" ? R3 : W3 };
  }
  function i(D3, I3) {
    var L3 = I3 === true ? B3.getLastToken(D3, 1) : B3.getTokenBefore(D3);
    return (I3 === true ? D3.loc.end.line : D3.loc.start.line) !== (L3 ? L3.loc.end.line : -1);
  }
  function a3(D3, I3) {
    var L3 = r3(D3, false);
    D3.type !== "ArrayExpression" && D3.type !== "ObjectExpression" && (L3.goodChar !== I3 || L3.badChar !== 0) && i(D3) && n3(D3, I3, L3.space, L3.tab), D3.type === "IfStatement" && D3.alternate && (a3(B3.getTokenBefore(D3.alternate), I3), i(D3.alternate) || a3(D3.alternate, I3)), D3.type === "TryStatement" && D3.handler && a3(B3.getFirstToken(D3.handler), I3), D3.type === "TryStatement" && D3.finalizer && a3(B3.getTokenBefore(D3.finalizer), I3), D3.type === "DoWhileStatement" && a3(B3.getTokenAfter(D3.body), I3);
  }
  function s3(D3, I3) {
    D3.forEach(function(L3) {
      return a3(L3, I3);
    });
  }
  function o3(D3, I3) {
    var L3 = B3.getLastToken(D3), V10 = r3(L3, true);
    (V10.goodChar !== I3 || V10.badChar !== 0) && i(D3, true) && n3(D3, I3, V10.space, V10.tab, { line: L3.loc.start.line, column: L3.loc.start.column }, true);
  }
  function u3(D3, I3) {
    var L3 = r3(D3, false);
    (L3.goodChar !== I3 || L3.badChar !== 0) && i(D3) && n3(D3, I3, L3.space, L3.tab, { line: D3.loc.start.line, column: D3.loc.start.column });
  }
  function c3(D3, I3, L3) {
    for (var V10 = D3.parent, K3 = new Set(L3 || ["Program"]); V10.type !== I3 && !K3.has(V10.type) && V10.type !== "Program"; )
      V10 = V10.parent;
    return V10.type === I3 ? V10 : null;
  }
  function f3(D3) {
    return c3(D3, "VariableDeclarator");
  }
  function p3(D3, I3) {
    return I3 && I3.parent.loc.start.line === D3.loc.start.line && 1 < I3.parent.declarations.length;
  }
  function d3(D3) {
    var I3 = B3.getLastToken(D3);
    return D3.loc.start.line === I3.loc.end.line;
  }
  function m3(D3) {
    if (!d3(D3)) {
      var I3, L3, V10 = D3.type === "ArrayExpression" ? D3.elements : D3.properties;
      V10 = V10.filter(function(q3) {
        return q3 !== null;
      });
      var K3 = f3(D3);
      if (i(D3)) {
        var W3 = D3.parent;
        if (I3 = r3(W3).goodChar, K3 && K3.loc.start.line === D3.loc.start.line)
          K3 || function(q3) {
            return !(q3.type !== "ArrayExpression" || !q3.elements[0]) && q3.elements[0].loc.start.line === q3.loc.start.line && q3.elements[0].type === "ObjectExpression";
          }(W3) || W3.type === "MemberExpression" || W3.type === "ExpressionStatement" || W3.type === "AssignmentExpression" || W3.type === "Property" || (I3 += k3);
        else if (W3.type !== "VariableDeclarator" || K3 === K3.parent.declarations[0])
          if (W3.type === "VariableDeclarator" && K3.loc.start.line === W3.loc.start.line)
            I3 += k3 * F3.VariableDeclarator[K3.parent.kind];
          else if (W3.type === "ObjectExpression" || W3.type === "ArrayExpression") {
            var R3 = D3.parent.type === "ObjectExpression" ? D3.parent.properties : D3.parent.elements;
            R3[0] && R3[0].loc.start.line === W3.loc.start.line && R3[0].loc.end.line !== W3.loc.start.line || (typeof F3[W3.type] == "number" ? I3 += F3[W3.type] * k3 : I3 = R3[0].loc.start.column);
          } else
            W3.type === "CallExpression" || W3.type === "NewExpression" ? typeof F3.CallExpression.arguments == "number" ? I3 += F3.CallExpression.arguments * k3 : F3.CallExpression.arguments === "first" ? W3.arguments.indexOf(D3) !== -1 && (I3 = W3.arguments[0].loc.start.column) : I3 += k3 : (W3.type === "LogicalExpression" || W3.type === "ArrowFunctionExpression") && (I3 += k3);
        u3(D3, I3);
      } else
        I3 = r3(D3).goodChar;
      L3 = F3[D3.type] === "first" ? V10.length ? V10[0].loc.start.column : 0 : I3 + k3 * F3[D3.type], p3(D3, K3) && (L3 += k3 * F3.VariableDeclarator[K3.parent.kind]), s3(V10, L3), 0 < V10.length && V10[V10.length - 1].loc.end.line === D3.loc.end.line || o3(D3, I3 + (p3(D3, K3) ? F3.VariableDeclarator[K3.parent.kind] * k3 : 0));
    }
  }
  function y3(D3) {
    if (!d3(D3))
      if (!D3.parent || D3.parent.type !== "FunctionExpression" && D3.parent.type !== "FunctionDeclaration" && D3.parent.type !== "ArrowFunctionExpression") {
        var I3, L3;
        L3 = D3.parent && ["IfStatement", "WhileStatement", "ForStatement", "ForInStatement", "ForOfStatement", "DoWhileStatement", "ClassDeclaration", "TryStatement"].indexOf(D3.parent.type) !== -1 && function(V10) {
          return V10.type === "BlockStatement" || V10.type === "ClassBody" || V10.body && V10.body.type === "BlockStatement" || V10.consequent && V10.consequent.type === "BlockStatement";
        }(D3) ? r3(D3.parent).goodChar : D3.parent && D3.parent.type === "CatchClause" ? r3(D3.parent.parent).goodChar : r3(D3).goodChar, 0 < (I3 = D3.type === "IfStatement" && D3.consequent.type !== "BlockStatement" ? [D3.consequent] : Array.isArray(D3.body) ? D3.body : [D3.body]).length && s3(I3, L3 + k3), D3.type === "BlockStatement" && o3(D3, L3);
      } else
        (function(V10) {
          var K3, W3 = V10.parent;
          if (K3 = !W3.parent || W3.parent.type !== "Property" && W3.parent.type !== "ArrayExpression" ? r3(W3).goodChar : r3(W3, false).goodChar, W3.parent.type === "CallExpression") {
            var R3 = W3.parent;
            W3.type !== "FunctionExpression" && W3.type !== "ArrowFunctionExpression" ? R3 && R3.loc.start.line < V10.loc.start.line && (K3 = r3(R3).goodChar) : function(X3) {
              var ce2 = X3.parent;
              return 2 <= ce2.arguments.length && ce2.arguments[1] === X3 && ce2.arguments[0].loc.end.line > ce2.arguments[0].loc.start.line;
            }(W3) && R3.callee.loc.start.line === R3.callee.loc.end.line && !i(W3) && (K3 = r3(R3).goodChar);
          }
          var q3 = k3;
          F3.outerIIFEBody !== null && function(X3) {
            var ce2 = X3.parent, A3 = ce2.parent;
            if (ce2.type !== "CallExpression" || ce2.callee !== X3)
              return false;
            for (; A3.type === "UnaryExpression" && (A3.operator === "!" || A3.operator === "~" || A3.operator === "+" || A3.operator === "-") || A3.type === "AssignmentExpression" || A3.type === "LogicalExpression" || A3.type === "SequenceExpression" || A3.type === "VariableDeclarator"; )
              A3 = A3.parent;
            return (A3.type === "ExpressionStatement" || A3.type === "VariableDeclaration") && A3.parent && A3.parent.type === "Program";
          }(W3) ? q3 = F3.outerIIFEBody * k3 : W3.type === "FunctionExpression" ? q3 = F3.FunctionExpression.body * k3 : W3.type === "FunctionDeclaration" && (q3 = F3.FunctionDeclaration.body * k3), K3 += q3;
          var J3 = f3(V10);
          J3 && p3(V10, J3) && (K3 += k3 * F3.VariableDeclarator[J3.parent.kind]), 0 < V10.body.length && s3(V10.body, K3), o3(V10, K3 - q3);
        })(D3);
  }
  function v3(D3) {
    D3.body.type !== "BlockStatement" && y3(D3);
  }
  function b3(D3, I3) {
    var L3, V10 = D3.type === "SwitchStatement" ? D3 : D3.parent, K3 = I3 === void 0 ? r3(V10).goodChar : I3;
    return w3[V10.loc.start.line] ? w3[V10.loc.start.line] : (L3 = 0 < V10.cases.length && F3.SwitchCase === 0 ? K3 : K3 + k3 * F3.SwitchCase, w3[V10.loc.start.line] = L3, L3);
  }
  var x3 = null, C3 = "space", k3 = 4, F3 = { SwitchCase: 0, VariableDeclarator: { var: 1, let: 1, const: 1 }, outerIIFEBody: null, FunctionDeclaration: { parameters: x3, body: 1 }, FunctionExpression: { parameters: x3, body: 1 }, CallExpression: { arguments: x3 }, ArrayExpression: 1, ObjectExpression: 1 }, B3 = e28.getSourceCode();
  if (e28.options.length && (e28.options[0] === "tab" ? (k3 = 1, C3 = "tab") : typeof e28.options[0] == "number" && (k3 = e28.options[0], C3 = "space"), e28.options[1])) {
    var O3 = e28.options[1];
    F3.SwitchCase = O3.SwitchCase || 0;
    var S3 = O3.VariableDeclarator;
    typeof S3 == "number" ? F3.VariableDeclarator = { var: S3, let: S3, const: S3 } : xe$3(S3) == "object" && Object.assign(F3.VariableDeclarator, S3), typeof O3.outerIIFEBody == "number" && (F3.outerIIFEBody = O3.outerIIFEBody), typeof O3.MemberExpression == "number" && (F3.MemberExpression = O3.MemberExpression), xe$3(O3.FunctionDeclaration) == "object" && Object.assign(F3.FunctionDeclaration, O3.FunctionDeclaration), xe$3(O3.FunctionExpression) == "object" && Object.assign(F3.FunctionExpression, O3.FunctionExpression), xe$3(O3.CallExpression) == "object" && Object.assign(F3.CallExpression, O3.CallExpression), (typeof O3.ArrayExpression == "number" || typeof O3.ArrayExpression == "string") && (F3.ArrayExpression = O3.ArrayExpression), (typeof O3.ObjectExpression == "number" || typeof O3.ObjectExpression == "string") && (F3.ObjectExpression = O3.ObjectExpression);
  }
  var w3 = {};
  return { Program: function(D3) {
    0 < D3.body.length && s3(D3.body, r3(D3).goodChar);
  }, ClassBody: y3, BlockStatement: y3, WhileStatement: v3, ForStatement: v3, ForInStatement: v3, ForOfStatement: v3, DoWhileStatement: v3, IfStatement: function(D3) {
    D3.consequent.type !== "BlockStatement" && D3.consequent.loc.start.line > D3.loc.start.line && y3(D3);
  }, VariableDeclaration: function(D3) {
    D3.declarations[D3.declarations.length - 1].loc.start.line > D3.declarations[0].loc.start.line && function(I3) {
      var L3 = function(q3) {
        return q3.declarations.reduce(function(J3, X3) {
          var ce2 = J3[J3.length - 1];
          return (X3.loc.start.line !== q3.loc.start.line && !ce2 || ce2 && ce2.loc.start.line !== X3.loc.start.line) && J3.push(X3), J3;
        }, []);
      }(I3), V10 = r3(I3).goodChar, K3 = L3[L3.length - 1], W3 = V10 + k3 * F3.VariableDeclarator[I3.kind];
      if (s3(L3, W3), !(B3.getLastToken(I3).loc.end.line <= K3.loc.end.line)) {
        var R3 = B3.getTokenBefore(K3);
        R3.value === "," ? o3(I3, r3(R3).goodChar) : o3(I3, W3 - k3);
      }
    }(D3);
  }, ObjectExpression: function(D3) {
    m3(D3);
  }, ArrayExpression: function(D3) {
    m3(D3);
  }, MemberExpression: function(D3) {
    if (F3.MemberExpression !== void 0 && !d3(D3) && !c3(D3, "VariableDeclarator", ["FunctionExpression", "ArrowFunctionExpression"]) && !c3(D3, "AssignmentExpression", ["FunctionExpression"])) {
      var I3 = r3(D3).goodChar + k3 * F3.MemberExpression, L3 = [D3.property], V10 = B3.getTokenBefore(D3.property);
      V10.type === "Punctuator" && V10.value === "." && L3.push(V10), s3(L3, I3);
    }
  }, SwitchStatement: function(D3) {
    var I3 = r3(D3).goodChar, L3 = b3(D3, I3);
    s3(D3.cases, L3), o3(D3, I3);
  }, SwitchCase: function(D3) {
    if (!d3(D3)) {
      var I3 = b3(D3);
      s3(D3.consequent, I3 + k3);
    }
  }, FunctionDeclaration: function(D3) {
    d3(D3) || (F3.FunctionDeclaration.parameters === "first" && D3.params.length ? s3(D3.params.slice(1), D3.params[0].loc.start.column) : F3.FunctionDeclaration.parameters !== null && s3(D3.params, r3(D3).goodChar + k3 * F3.FunctionDeclaration.parameters));
  }, FunctionExpression: function(D3) {
    d3(D3) || (F3.FunctionExpression.parameters === "first" && D3.params.length ? s3(D3.params.slice(1), D3.params[0].loc.start.column) : F3.FunctionExpression.parameters !== null && s3(D3.params, r3(D3).goodChar + k3 * F3.FunctionExpression.parameters));
  }, ReturnStatement: function(D3) {
    if (!d3(D3)) {
      var I3 = r3(D3).goodChar;
      (function(L3) {
        var V10 = B3.getText(L3).replace(B3.getText(L3.argument), "");
        return /^return[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*?\([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*?\);*?/.test(V10);
      })(D3) ? function(L3, V10) {
        var K3 = B3.getLastToken(L3, P$s.isClosingParenToken);
        if (!B3.getText(K3, K3.loc.start.column).slice(0, -1).trim()) {
          var W3 = r3(K3, true);
          W3.goodChar !== V10 && n3(L3, V10, W3.space, W3.tab, { line: K3.loc.start.line, column: K3.loc.start.column }, true);
        }
      }(D3, I3) : a3(D3, I3);
    }
  }, CallExpression: function(D3) {
    d3(D3) || (F3.CallExpression.arguments === "first" && D3.arguments.length ? s3(D3.arguments.slice(1), D3.arguments[0].loc.start.column) : F3.CallExpression.arguments !== null && s3(D3.arguments, r3(D3).goodChar + k3 * F3.CallExpression.arguments));
  } };
} }, j5 = /* @__PURE__ */ new Set(["AssignmentExpression", "AssignmentPattern", "ArrayExpression", "ArrayPattern", "ArrowFunctionExpression", "AwaitExpression", "BlockStatement", "BinaryExpression", "BreakStatement", "CallExpression", "CatchClause", "ClassBody", "ClassDeclaration", "ClassExpression", "ConditionalExpression", "ContinueStatement", "DoWhileStatement", "DebuggerStatement", "EmptyStatement", "ExperimentalRestProperty", "ExperimentalSpreadProperty", "ExpressionStatement", "ForStatement", "ForInStatement", "ForOfStatement", "FunctionDeclaration", "FunctionExpression", "Identifier", "IfStatement", "Literal", "LabeledStatement", "LogicalExpression", "MemberExpression", "MetaProperty", "MethodDefinition", "NewExpression", "ObjectExpression", "ObjectPattern", "Program", "Property", "RestElement", "ReturnStatement", "SequenceExpression", "SpreadElement", "Super", "SwitchCase", "SwitchStatement", "TaggedTemplateExpression", "TemplateElement", "TemplateLiteral", "ThisExpression", "ThrowStatement", "TryStatement", "UnaryExpression", "UpdateExpression", "VariableDeclaration", "VariableDeclarator", "WhileStatement", "WithStatement", "YieldExpression", "JSXFragment", "JSXOpeningFragment", "JSXClosingFragment", "JSXIdentifier", "JSXNamespacedName", "JSXMemberExpression", "JSXEmptyExpression", "JSXExpressionContainer", "JSXElement", "JSXClosingElement", "JSXOpeningElement", "JSXAttribute", "JSXSpreadAttribute", "JSXText", "ExportDefaultDeclaration", "ExportNamedDeclaration", "ExportAllDeclaration", "ExportSpecifier", "ImportDeclaration", "ImportSpecifier", "ImportDefaultSpecifier", "ImportNamespaceSpecifier", "ImportExpression"]), R5 = function() {
  function e28() {
    We$1(this, e28), this._rbTree = AI();
  }
  return Xe$1(e28, [{ key: "insert", value: function(t3, n3) {
    var r3 = this._rbTree.find(t3);
    this._rbTree = r3.valid ? r3.update(n3) : this._rbTree.insert(t3, n3);
  } }, { key: "findLe", value: function(t3) {
    var n3 = this._rbTree.le(t3);
    return n3 && { key: n3.key, value: n3.value };
  } }, { key: "deleteRange", value: function(t3, n3) {
    if (t3 !== n3)
      for (var r3 = this._rbTree.ge(t3); r3.valid && r3.key < n3; )
        this._rbTree = this._rbTree.remove(r3.key), r3.next();
  } }]), e28;
}(), M5 = function() {
  function e28(t3) {
    We$1(this, e28), this.sourceCode = t3, this.firstTokensByLineNumber = t3.tokensAndComments.reduce(function(n3, r3) {
      return n3.has(r3.loc.start.line) || n3.set(r3.loc.start.line, r3), !n3.has(r3.loc.end.line) && t3.text.slice(r3.range[1] - r3.loc.end.column, r3.range[1]).trim() && n3.set(r3.loc.end.line, r3), n3;
    }, /* @__PURE__ */ new Map());
  }
  return Xe$1(e28, [{ key: "getFirstTokenOfLine", value: function(t3) {
    return this.firstTokensByLineNumber.get(t3.loc.start.line);
  } }, { key: "isFirstTokenOfLine", value: function(t3) {
    return this.getFirstTokenOfLine(t3) === t3;
  } }, { key: "getTokenIndent", value: function(t3) {
    return this.sourceCode.text.slice(t3.range[0] - t3.loc.start.column, t3.range[0]);
  } }]), e28;
}(), V5 = function() {
  function e28(t3, n3, r3) {
    We$1(this, e28), this._tokenInfo = t3, this._indentSize = n3, this._indentType = r3, this._tree = new R5(), this._tree.insert(0, { offset: 0, from: null, force: false }), this._lockedFirstTokens = /* @__PURE__ */ new WeakMap(), this._desiredIndentCache = /* @__PURE__ */ new WeakMap(), this._ignoredTokens = /* @__PURE__ */ new WeakSet();
  }
  return Xe$1(e28, [{ key: "_getOffsetDescriptor", value: function(t3) {
    return this._tree.findLe(t3.range[0]).value;
  } }, { key: "matchOffsetOf", value: function(t3, n3) {
    this._lockedFirstTokens.set(n3, t3);
  } }, { key: "setDesiredOffset", value: function(t3, n3, r3) {
    return this.setDesiredOffsets(t3.range, n3, r3);
  } }, { key: "setDesiredOffsets", value: function(t3, n3, r3, i) {
    var a3 = { offset: r3, from: n3, force: i }, s3 = this._tree.findLe(t3[1]).value, o3 = n3 && n3.range[0] >= t3[0] && n3.range[1] <= t3[1], u3 = o3 && this._getOffsetDescriptor(n3);
    this._tree.deleteRange(t3[0] + 1, t3[1]), this._tree.insert(t3[0], a3), o3 && (this._tree.insert(n3.range[0], u3), this._tree.insert(n3.range[1], a3)), this._tree.insert(t3[1], s3);
  } }, { key: "getDesiredIndent", value: function(t3) {
    if (!this._desiredIndentCache.has(t3))
      if (this._ignoredTokens.has(t3))
        this._desiredIndentCache.set(t3, this._tokenInfo.getTokenIndent(t3));
      else if (this._lockedFirstTokens.has(t3)) {
        var n3 = this._lockedFirstTokens.get(t3);
        this._desiredIndentCache.set(t3, this.getDesiredIndent(this._tokenInfo.getFirstTokenOfLine(n3)) + this._indentType.repeat(n3.loc.start.column - this._tokenInfo.getFirstTokenOfLine(n3).loc.start.column));
      } else {
        var r3 = this._getOffsetDescriptor(t3), i = !r3.from || r3.from.loc.start.line !== t3.loc.start.line || /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*?\n/.test(t3.value) || r3.force ? r3.offset * this._indentSize : 0;
        this._desiredIndentCache.set(t3, (r3.from ? this.getDesiredIndent(r3.from) : "") + this._indentType.repeat(i));
      }
    return this._desiredIndentCache.get(t3);
  } }, { key: "ignoreToken", value: function(t3) {
    this._tokenInfo.isFirstTokenOfLine(t3) && this._ignoredTokens.add(t3);
  } }, { key: "getFirstDependency", value: function(t3) {
    return this._getOffsetDescriptor(t3).from;
  } }]), e28;
}(), Ni$1 = { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first", "off"] }] }, U5 = { meta: { type: "layout", docs: { description: "enforce consistent indentation", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/indent" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["tab"] }, { type: "integer", minimum: 0 }] }, { type: "object", properties: { SwitchCase: { type: "integer", minimum: 0, default: 0 }, VariableDeclarator: { oneOf: [Ni$1, { type: "object", properties: { var: Ni$1, let: Ni$1, const: Ni$1 }, additionalProperties: false }] }, outerIIFEBody: { type: "integer", minimum: 0 }, MemberExpression: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["off"] }] }, FunctionDeclaration: { type: "object", properties: { parameters: Ni$1, body: { type: "integer", minimum: 0 } }, additionalProperties: false }, FunctionExpression: { type: "object", properties: { parameters: Ni$1, body: { type: "integer", minimum: 0 } }, additionalProperties: false }, CallExpression: { type: "object", properties: { arguments: Ni$1 }, additionalProperties: false }, ArrayExpression: Ni$1, ObjectExpression: Ni$1, ImportDeclaration: Ni$1, flatTernaryExpressions: { type: "boolean", default: false }, ignoredNodes: { type: "array", items: { type: "string", not: { pattern: ":exit$" } } }, ignoreComments: { type: "boolean", default: false } }, additionalProperties: false }], messages: { wrongIndentation: "Expected indentation of {{expected}} but found {{actual}}." } }, create: function(e28) {
  function t3(S3, w3, D3) {
    var I3 = "".concat(S3, " ").concat(f3).concat(S3 === 1 ? "" : "s"), L3 = "space".concat(w3 === 1 ? "" : "s"), V10 = "tab".concat(D3 === 1 ? "" : "s");
    return { expected: I3, actual: 0 < w3 ? f3 === "space" ? w3 : "".concat(w3, " ").concat(L3) : 0 < D3 ? f3 === "tab" ? D3 : "".concat(D3, " ").concat(V10) : "0" };
  }
  function n3(S3, w3) {
    var D3 = Array.from(y3.getTokenIndent(S3)), I3 = D3.filter(function(V10) {
      return V10 === " ";
    }).length, L3 = D3.filter(function(V10) {
      return V10 === "	";
    }).length;
    e28.report({ node: S3, messageId: "wrongIndentation", data: t3(w3.length, I3, L3), loc: { start: { line: S3.loc.start.line, column: 0 }, end: { line: S3.loc.start.line, column: S3.loc.start.column } }, fix: function(V10) {
      var K3 = [S3.range[0] - S3.loc.start.column, S3.range[0]];
      return V10.replaceTextRange(K3, w3);
    } });
  }
  function r3(S3, w3) {
    var D3 = y3.getTokenIndent(S3);
    return D3 === w3 || D3.includes(" ") && D3.includes("	");
  }
  function i(S3, w3, D3, I3) {
    function L3(V10) {
      for (var K3 = m3.getTokenBefore(V10); P$s.isOpeningParenToken(K3) && K3 !== w3; )
        K3 = m3.getTokenBefore(K3);
      return m3.getTokenAfter(K3);
    }
    v3.setDesiredOffsets([w3.range[1], D3.range[0]], w3, typeof I3 == "number" ? I3 : 1), v3.setDesiredOffset(D3, w3, 0), I3 === "first" && S3.length && !S3[0] || S3.forEach(function(V10, K3) {
      if (V10 && (I3 === "off" && v3.ignoreToken(L3(V10)), K3 !== 0))
        if (I3 === "first" && y3.isFirstTokenOfLine(L3(V10)))
          v3.matchOffsetOf(L3(S3[0]), L3(V10));
        else {
          var W3 = S3[K3 - 1], R3 = W3 && L3(W3), q3 = W3 && m3.getLastToken(W3);
          W3 && q3.loc.end.line - function(J3) {
            var X3 = J3.match(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/)[0].match(P$s.createGlobalLinebreakMatcher());
            return X3 === null ? 0 : X3.length;
          }(q3.value) > w3.loc.end.line && v3.setDesiredOffsets([W3.range[1], V10.range[1]], R3, 0);
        }
    });
  }
  function a3(S3) {
    if (S3.type !== "BlockStatement") {
      for (var w3 = m3.getTokenBefore(S3, P$s.isNotOpeningParenToken), D3 = m3.getFirstToken(S3), I3 = m3.getLastToken(S3); P$s.isOpeningParenToken(m3.getTokenBefore(D3)) && P$s.isClosingParenToken(m3.getTokenAfter(I3)); )
        D3 = m3.getTokenBefore(D3), I3 = m3.getTokenAfter(I3);
      v3.setDesiredOffsets([D3.range[0], I3.range[1]], w3, 1);
      var L3 = m3.getLastToken(S3);
      S3.type !== "EmptyStatement" && P$s.isSemicolonToken(L3) && v3.setDesiredOffset(L3, w3, 0);
    }
  }
  function s3(S3) {
    var w3 = S3.arguments.length ? m3.getFirstTokenBetween(S3.callee, S3.arguments[0], P$s.isOpeningParenToken) : m3.getLastToken(S3, 1), D3 = m3.getLastToken(S3);
    b3.add(w3), b3.add(D3), v3.setDesiredOffset(w3, m3.getTokenBefore(w3), 0), i(S3.arguments, w3, D3, d3.CallExpression.arguments);
  }
  function o3(S3) {
    var w3 = new Set(m3.getTokens(S3, { includeComments: true }));
    w3.forEach(function(D3) {
      if (!w3.has(v3.getFirstDependency(D3))) {
        var I3 = y3.getFirstTokenOfLine(D3);
        D3 === I3 ? v3.ignoreToken(D3) : v3.setDesiredOffset(D3, I3, 0);
      }
    });
  }
  function u3(S3, w3) {
    var D3 = S3.loc.end.line, I3 = w3.loc.start.line;
    if (D3 === I3 || D3 === I3 - 1)
      return false;
    for (var L3 = D3 + 1; L3 < I3; ++L3)
      if (!y3.firstTokensByLineNumber.has(L3))
        return true;
    return false;
  }
  function c3(S3) {
    B3.add(S3), x3.add(m3.getFirstToken(S3));
  }
  var f3 = "space", p3 = 4, d3 = { SwitchCase: 0, VariableDeclarator: { var: 1, let: 1, const: 1 }, outerIIFEBody: 1, FunctionDeclaration: { parameters: 1, body: 1 }, FunctionExpression: { parameters: 1, body: 1 }, CallExpression: { arguments: 1 }, MemberExpression: 1, ArrayExpression: 1, ObjectExpression: 1, ImportDeclaration: 1, flatTernaryExpressions: false, ignoredNodes: [], ignoreComments: false };
  e28.options.length && (e28.options[0] === "tab" ? (p3 = 1, f3 = "tab") : (p3 = e28.options[0], f3 = "space"), e28.options[1] && (Object.assign(d3, e28.options[1]), (typeof d3.VariableDeclarator == "number" || d3.VariableDeclarator === "first") && (d3.VariableDeclarator = { var: d3.VariableDeclarator, let: d3.VariableDeclarator, const: d3.VariableDeclarator })));
  var m3 = e28.getSourceCode(), y3 = new M5(m3), v3 = new V5(y3, p3, f3 == "space" ? " " : "	"), b3 = /* @__PURE__ */ new WeakSet(), x3 = /* @__PURE__ */ new Set(), C3 = { "ArrayExpression, ArrayPattern": function(S3) {
    var w3 = m3.getFirstToken(S3), D3 = m3.getTokenAfter(ye$4.lodash.findLast(S3.elements) || w3, P$s.isClosingBracketToken);
    i(S3.elements, w3, D3, d3.ArrayExpression);
  }, "ObjectExpression, ObjectPattern": function(S3) {
    var w3 = m3.getFirstToken(S3), D3 = m3.getTokenAfter(S3.properties.length ? S3.properties[S3.properties.length - 1] : w3, P$s.isClosingBraceToken);
    i(S3.properties, w3, D3, d3.ObjectExpression);
  }, ArrowFunctionExpression: function(S3) {
    var w3 = m3.getFirstToken(S3);
    if (P$s.isOpeningParenToken(w3)) {
      var D3 = w3, I3 = m3.getTokenBefore(S3.body, P$s.isClosingParenToken);
      b3.add(D3), b3.add(I3), i(S3.params, D3, I3, d3.FunctionExpression.parameters);
    }
    a3(S3.body);
  }, AssignmentExpression: function(S3) {
    var w3 = m3.getFirstTokenBetween(S3.left, S3.right, function(D3) {
      return D3.value === S3.operator;
    });
    v3.setDesiredOffsets([w3.range[0], S3.range[1]], m3.getLastToken(S3.left), 1), v3.ignoreToken(w3), v3.ignoreToken(m3.getTokenAfter(w3));
  }, "BinaryExpression, LogicalExpression": function(S3) {
    var w3 = m3.getFirstTokenBetween(S3.left, S3.right, function(I3) {
      return I3.value === S3.operator;
    }), D3 = m3.getTokenAfter(w3);
    v3.ignoreToken(w3), v3.ignoreToken(D3), v3.setDesiredOffset(D3, w3, 0);
  }, "BlockStatement, ClassBody": function(S3) {
    var w3;
    w3 = S3.parent && function(D3) {
      if (!D3.parent || D3.parent.type !== "CallExpression" || D3.parent.callee !== D3)
        return false;
      for (var I3 = D3.parent && D3.parent.parent; I3.type === "UnaryExpression" && -1 < ["!", "~", "+", "-"].indexOf(I3.operator) || I3.type === "AssignmentExpression" || I3.type === "LogicalExpression" || I3.type === "SequenceExpression" || I3.type === "VariableDeclarator"; )
        I3 = I3.parent;
      return (I3.type === "ExpressionStatement" || I3.type === "VariableDeclaration") && I3.parent.type === "Program";
    }(S3.parent) ? d3.outerIIFEBody : !S3.parent || S3.parent.type !== "FunctionExpression" && S3.parent.type !== "ArrowFunctionExpression" ? S3.parent && S3.parent.type === "FunctionDeclaration" ? d3.FunctionDeclaration.body : 1 : d3.FunctionExpression.body, P$s.STATEMENT_LIST_PARENTS.has(S3.parent.type) || v3.setDesiredOffset(m3.getFirstToken(S3), m3.getFirstToken(S3.parent), 0), i(S3.body, m3.getFirstToken(S3), m3.getLastToken(S3), w3);
  }, CallExpression: s3, "ClassDeclaration[superClass], ClassExpression[superClass]": function(S3) {
    var w3 = m3.getFirstToken(S3), D3 = m3.getTokenBefore(S3.superClass, P$s.isNotOpeningParenToken);
    v3.setDesiredOffsets([D3.range[0], S3.body.range[0]], w3, 1);
  }, ConditionalExpression: function(S3) {
    var w3 = m3.getFirstToken(S3);
    if (!d3.flatTernaryExpressions || !P$s.isTokenOnSameLine(S3.test, S3.consequent) || function(W3, R3) {
      for (var q3 = R3; q3.parent && !q3.parent.type.endsWith("Statement") && !q3.parent.type.endsWith("Declaration"); )
        q3 = q3.parent;
      return !(q3 = q3.parent) || q3.loc.start.line === W3.loc.start.line;
    }(w3, S3)) {
      var D3 = m3.getFirstTokenBetween(S3.test, S3.consequent, function(W3) {
        return W3.type === "Punctuator" && W3.value === "?";
      }), I3 = m3.getFirstTokenBetween(S3.consequent, S3.alternate, function(W3) {
        return W3.type === "Punctuator" && W3.value === ":";
      }), L3 = m3.getTokenAfter(D3), V10 = m3.getTokenBefore(I3), K3 = m3.getTokenAfter(I3);
      v3.setDesiredOffset(D3, w3, 1), v3.setDesiredOffset(I3, w3, 1), v3.setDesiredOffset(L3, w3, 1), V10.loc.end.line === K3.loc.start.line ? v3.setDesiredOffset(K3, L3, 0) : v3.setDesiredOffset(K3, w3, 1);
    }
  }, "DoWhileStatement, WhileStatement, ForInStatement, ForOfStatement": function(S3) {
    return a3(S3.body);
  }, ExportNamedDeclaration: function(S3) {
    if (S3.declaration === null) {
      var w3 = m3.getLastToken(S3, P$s.isClosingBraceToken);
      i(S3.specifiers, m3.getFirstToken(S3, { skip: 1 }), w3, 1), S3.source && v3.setDesiredOffsets([w3.range[1], S3.range[1]], m3.getFirstToken(S3), 1);
    }
  }, ForStatement: function(S3) {
    var w3 = m3.getFirstToken(S3, 1);
    S3.init && v3.setDesiredOffsets(S3.init.range, w3, 1), S3.test && v3.setDesiredOffsets(S3.test.range, w3, 1), S3.update && v3.setDesiredOffsets(S3.update.range, w3, 1), a3(S3.body);
  }, "FunctionDeclaration, FunctionExpression": function(S3) {
    var w3 = m3.getTokenBefore(S3.body), D3 = m3.getTokenBefore(S3.params.length ? S3.params[0] : w3);
    b3.add(D3), b3.add(w3), i(S3.params, D3, w3, d3[S3.type].parameters);
  }, IfStatement: function(S3) {
    a3(S3.consequent), S3.alternate && S3.alternate.type !== "IfStatement" && a3(S3.alternate);
  }, ImportDeclaration: function(S3) {
    if (S3.specifiers.some(function(W3) {
      return W3.type === "ImportSpecifier";
    })) {
      var w3 = m3.getFirstToken(S3, P$s.isOpeningBraceToken), D3 = m3.getLastToken(S3, P$s.isClosingBraceToken);
      i(S3.specifiers.filter(function(W3) {
        return W3.type === "ImportSpecifier";
      }), w3, D3, d3.ImportDeclaration);
    }
    var I3 = m3.getLastToken(S3, function(W3) {
      return W3.type === "Identifier" && W3.value === "from";
    }), L3 = m3.getLastToken(S3, function(W3) {
      return W3.type === "String";
    }), V10 = m3.getLastToken(S3, function(W3) {
      return W3.type === "Punctuator" && W3.value === ";";
    });
    if (I3) {
      var K3 = V10 && V10.range[1] === L3.range[1] ? S3.range[1] : L3.range[1];
      v3.setDesiredOffsets([I3.range[0], K3], m3.getFirstToken(S3), 1);
    }
  }, ImportExpression: function(S3) {
    var w3 = m3.getFirstToken(S3, 1), D3 = m3.getLastToken(S3);
    b3.add(w3), b3.add(D3), v3.setDesiredOffset(w3, m3.getTokenBefore(w3), 0), i([S3.source], w3, D3, d3.CallExpression.arguments);
  }, "MemberExpression, JSXMemberExpression, MetaProperty": function(S3) {
    var w3 = S3.type === "MetaProperty" ? S3.meta : S3.object, D3 = m3.getFirstTokenBetween(w3, S3.property, P$s.isNotClosingParenToken), I3 = m3.getTokenAfter(D3), L3 = m3.getTokensBetween(w3, S3.property, { filter: P$s.isClosingParenToken }).length, V10 = L3 ? m3.getTokenBefore(w3, { skip: L3 - 1 }) : m3.getFirstToken(w3), K3 = m3.getTokenBefore(D3), W3 = S3.computed ? D3 : I3;
    S3.computed && (v3.setDesiredOffset(m3.getLastToken(S3), D3, 0), v3.setDesiredOffsets(S3.property.range, D3, 1));
    var R3 = K3.loc.end.line === W3.loc.start.line ? K3 : V10;
    typeof d3.MemberExpression == "number" ? (v3.setDesiredOffset(D3, R3, d3.MemberExpression), v3.setDesiredOffset(I3, S3.computed ? D3 : R3, d3.MemberExpression)) : (v3.ignoreToken(D3), v3.ignoreToken(I3), v3.setDesiredOffset(D3, R3, 0), v3.setDesiredOffset(I3, D3, 0));
  }, NewExpression: function(S3) {
    (0 < S3.arguments.length || P$s.isClosingParenToken(m3.getLastToken(S3)) && P$s.isOpeningParenToken(m3.getLastToken(S3, 1))) && s3(S3);
  }, Property: function(S3) {
    if (!S3.shorthand && !S3.method && S3.kind === "init") {
      var w3 = m3.getFirstTokenBetween(S3.key, S3.value, P$s.isColonToken);
      v3.ignoreToken(m3.getTokenAfter(w3));
    }
  }, SwitchStatement: function(S3) {
    var w3 = m3.getTokenAfter(S3.discriminant, P$s.isOpeningBraceToken), D3 = m3.getLastToken(S3);
    v3.setDesiredOffsets([w3.range[1], D3.range[0]], w3, d3.SwitchCase), S3.cases.length && m3.getTokensBetween(S3.cases[S3.cases.length - 1], D3, { includeComments: true, filter: P$s.isCommentToken }).forEach(function(I3) {
      return v3.ignoreToken(I3);
    });
  }, SwitchCase: function(S3) {
    if (S3.consequent.length !== 1 || S3.consequent[0].type !== "BlockStatement") {
      var w3 = m3.getFirstToken(S3), D3 = m3.getTokenAfter(S3);
      v3.setDesiredOffsets([w3.range[1], D3.range[0]], w3, 1);
    }
  }, TemplateLiteral: function(S3) {
    S3.expressions.forEach(function(w3, D3) {
      var I3 = S3.quasis[D3], L3 = S3.quasis[D3 + 1], V10 = I3.loc.start.line === I3.loc.end.line ? m3.getFirstToken(I3) : null;
      v3.setDesiredOffsets([I3.range[1], L3.range[0]], V10, 1), v3.setDesiredOffset(m3.getFirstToken(L3), V10, 0);
    });
  }, VariableDeclaration: function(S3) {
    var w3 = Object.prototype.hasOwnProperty.call(d3.VariableDeclarator, S3.kind) ? d3.VariableDeclarator[S3.kind] : 1, D3 = m3.getFirstToken(S3), I3 = m3.getLastToken(S3);
    if (d3.VariableDeclarator[S3.kind] === "first") {
      if (1 < S3.declarations.length)
        return void i(S3.declarations, D3, I3, "first");
      w3 = 1;
    }
    S3.declarations[S3.declarations.length - 1].loc.start.line > S3.loc.start.line ? v3.setDesiredOffsets(S3.range, D3, w3, true) : v3.setDesiredOffsets(S3.range, D3, w3), P$s.isSemicolonToken(I3) && v3.ignoreToken(I3);
  }, VariableDeclarator: function(S3) {
    if (S3.init) {
      var w3 = m3.getTokenBefore(S3.init, P$s.isNotOpeningParenToken), D3 = m3.getTokenAfter(w3);
      v3.ignoreToken(w3), v3.ignoreToken(D3), v3.setDesiredOffsets([D3.range[0], S3.range[1]], w3, 1), v3.setDesiredOffset(w3, m3.getLastToken(S3.id), 0);
    }
  }, "JSXAttribute[value]": function(S3) {
    var w3 = m3.getFirstTokenBetween(S3.name, S3.value, function(D3) {
      return D3.type === "Punctuator" && D3.value === "=";
    });
    v3.setDesiredOffsets([w3.range[0], S3.value.range[1]], m3.getFirstToken(S3.name), 1);
  }, JSXElement: function(S3) {
    S3.closingElement && i(S3.children, m3.getFirstToken(S3.openingElement), m3.getFirstToken(S3.closingElement), 1);
  }, JSXOpeningElement: function(S3) {
    var w3, D3 = m3.getFirstToken(S3);
    S3.selfClosing ? (w3 = m3.getLastToken(S3, { skip: 1 }), v3.setDesiredOffset(m3.getLastToken(S3), w3, 0)) : w3 = m3.getLastToken(S3), v3.setDesiredOffsets(S3.name.range, m3.getFirstToken(S3)), i(S3.attributes, D3, w3, 1);
  }, JSXClosingElement: function(S3) {
    var w3 = m3.getFirstToken(S3);
    v3.setDesiredOffsets(S3.name.range, w3, 1);
  }, JSXFragment: function(S3) {
    var w3 = m3.getFirstToken(S3.openingFragment), D3 = m3.getFirstToken(S3.closingFragment);
    i(S3.children, w3, D3, 1);
  }, JSXOpeningFragment: function(S3) {
    var w3 = m3.getFirstToken(S3), D3 = m3.getLastToken(S3);
    v3.setDesiredOffsets(S3.range, w3, 1), v3.matchOffsetOf(w3, D3);
  }, JSXClosingFragment: function(S3) {
    var w3 = m3.getFirstToken(S3), D3 = m3.getLastToken(S3, { skip: 1 }), I3 = m3.getLastToken(S3), L3 = P$s.isTokenOnSameLine(D3, I3) ? D3 : I3;
    v3.setDesiredOffsets(S3.range, w3, 1), v3.matchOffsetOf(w3, L3);
  }, JSXExpressionContainer: function(S3) {
    var w3 = m3.getFirstToken(S3), D3 = m3.getLastToken(S3);
    v3.setDesiredOffsets([w3.range[1], D3.range[0]], w3, 1);
  }, JSXSpreadAttribute: function(S3) {
    var w3 = m3.getFirstToken(S3), D3 = m3.getLastToken(S3);
    v3.setDesiredOffsets([w3.range[1], D3.range[0]], w3, 1);
  }, "*": function(S3) {
    var w3 = m3.getFirstToken(S3);
    w3 && !x3.has(w3) && v3.setDesiredOffsets(S3.range, w3, 0);
  } }, k3 = [], F3 = ye$4.lodash.mapValues(C3, function(S3) {
    return function(w3) {
      return k3.push({ listener: S3, node: w3 });
    };
  }), B3 = /* @__PURE__ */ new Set(), O3 = d3.ignoredNodes.reduce(function(S3, w3) {
    return Object.assign(S3, Fn$1({}, w3, c3));
  }, {});
  return Object.assign(F3, O3, { "*:exit": function(S3) {
    j5.has(S3.type) || c3(S3);
  }, "Program:exit": function() {
    d3.ignoreComments && m3.getAllComments().forEach(function(w3) {
      return v3.ignoreToken(w3);
    }), k3.filter(function(w3) {
      return !B3.has(w3.node);
    }).forEach(function(w3) {
      return w3.listener(w3.node);
    }), B3.forEach(o3), function(w3) {
      var D3 = [], I3 = [];
      w3.forEach(function(L3) {
        P$s.isOpeningParenToken(L3) ? D3.push(L3) : P$s.isClosingParenToken(L3) && I3.unshift({ left: D3.pop(), right: L3 });
      }), I3.forEach(function(L3) {
        var V10 = L3.left, K3 = L3.right;
        if (!b3.has(V10) && !b3.has(K3)) {
          var W3 = new Set(m3.getTokensBetween(V10, K3));
          W3.forEach(function(R3) {
            W3.has(v3.getFirstDependency(R3)) || v3.setDesiredOffset(R3, V10, 1);
          });
        }
        v3.setDesiredOffset(K3, V10, 0);
      });
    }(m3.ast.tokens);
    var S3 = m3.ast.comments.reduce(function(w3, D3) {
      var I3 = m3.getTokenBefore(D3, { includeComments: true });
      return w3.set(D3, w3.has(I3) ? w3.get(I3) : I3);
    }, /* @__PURE__ */ new WeakMap());
    m3.lines.forEach(function(w3, D3) {
      var I3 = D3 + 1;
      if (y3.firstTokensByLineNumber.has(I3)) {
        var L3 = y3.firstTokensByLineNumber.get(I3);
        if (L3.loc.start.line === I3) {
          if (P$s.isCommentToken(L3)) {
            var V10 = S3.get(L3), K3 = V10 ? m3.getTokenAfter(V10) : m3.ast.tokens[0], W3 = V10 && !u3(V10, L3), R3 = K3 && !u3(L3, K3);
            if (K3 && P$s.isSemicolonToken(K3) && !P$s.isTokenOnSameLine(L3, K3) && v3.setDesiredOffset(L3, K3, 0), W3 && r3(L3, v3.getDesiredIndent(V10)) || R3 && r3(L3, v3.getDesiredIndent(K3)))
              return;
          }
          r3(L3, v3.getDesiredIndent(L3)) || n3(L3, v3.getDesiredIndent(L3));
        }
      }
    });
  } });
} };
function SA(e28) {
  return e28.type === "ForInStatement" || e28.type === "ForOfStatement" || e28.type === "ForStatement";
}
function q5(e28) {
  var t3 = e28.parent, n3 = t3.parent;
  return SA(n3) ? n3.type === "ForStatement" ? n3.init === t3 : n3.left === t3 : !!e28.init;
}
var W5 = { meta: { type: "suggestion", docs: { description: "require or disallow initialization in variable declarations", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/init-declarations" }, schema: { anyOf: [{ type: "array", items: [{ enum: ["always"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["never"] }, { type: "object", properties: { ignoreForLoopInit: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }] }, messages: { initialized: "Variable '{{idName}}' should be initialized on declaration.", notInitialized: "Variable '{{idName}}' should not be initialized on declaration." } }, create: function(e28) {
  var t3 = e28.options[0] || "always", n3 = e28.options[1] || {};
  return { "VariableDeclaration:exit": function(r3) {
    for (var i = r3.kind, a3 = r3.declarations, s3 = 0; s3 < a3.length; ++s3) {
      var o3 = a3[s3], u3 = o3.id, c3 = q5(o3), f3 = n3.ignoreForLoopInit && SA(r3.parent), p3 = "";
      t3 !== "always" || c3 ? t3 === "never" && i !== "const" && c3 && !f3 && (p3 = "notInitialized") : p3 = "initialized", u3.type === "Identifier" && p3 && e28.report({ node: o3, messageId: p3, data: { idName: u3.name } });
    }
  } };
} }, $5 = { "prefer-double": { quote: '"', description: "singlequote", convert: function(e28) {
  return e28.replace(/'/g, '"');
} }, "prefer-single": { quote: "'", description: "doublequote", convert: function(e28) {
  return e28.replace(/"/g, "'");
} } }, G5 = { meta: { type: "layout", docs: { description: "enforce the consistent use of either double or single quotes in JSX attributes", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/jsx-quotes" }, fixable: "whitespace", schema: [{ enum: ["prefer-single", "prefer-double"] }], messages: { unexpected: "Unexpected usage of {{description}}." } }, create: function(e28) {
  var t3 = e28.options[0] || "prefer-double", n3 = $5[t3];
  return { JSXAttribute: function(r3) {
    var i = r3.value;
    i && P$s.isStringLiteral(i) && !function(a3) {
      return a3.value.indexOf(n3.quote) !== -1 || P$s.isSurroundedBy(a3.raw, n3.quote);
    }(i) && e28.report({ node: i, messageId: "unexpected", data: { description: n3.description }, fix: function(a3) {
      return a3.replaceText(i, n3.convert(i.raw));
    } });
  } };
} };
function Jd$1(e28) {
  return e28[e28.length - 1];
}
function i2(e28) {
  return e28.loc.end.line === e28.loc.start.line;
}
function Iu$1(e28, t3) {
  return e28.mode = t3.mode || "strict", e28.beforeColon = t3.beforeColon === void 0 ? 0 : +t3.beforeColon, e28.afterColon = t3.afterColon === void 0 ? 1 : +t3.afterColon, t3.align !== void 0 && (xe$3(t3.align) == "object" ? e28.align = t3.align : e28.align = { on: t3.align, mode: e28.mode, beforeColon: e28.beforeColon, afterColon: e28.afterColon }), e28;
}
var z5 = { meta: { type: "layout", docs: { description: "enforce consistent spacing between keys and values in object literal properties", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/key-spacing" }, fixable: "whitespace", schema: [{ anyOf: [{ type: "object", properties: { align: { anyOf: [{ enum: ["colon", "value"] }, { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, on: { enum: ["colon", "value"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false }] }, mode: { enum: ["strict", "minimum"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false }, { type: "object", properties: { singleLine: { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false }, multiLine: { type: "object", properties: { align: { anyOf: [{ enum: ["colon", "value"] }, { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, on: { enum: ["colon", "value"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false }] }, mode: { enum: ["strict", "minimum"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false } }, additionalProperties: false }, { type: "object", properties: { singleLine: { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false }, multiLine: { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false }, align: { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, on: { enum: ["colon", "value"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false } }, additionalProperties: false }] }], messages: { extraKey: "Extra space after {{computed}}key '{{key}}'.", extraValue: "Extra space before value for {{computed}}key '{{key}}'.", missingKey: "Missing space after {{computed}}key '{{key}}'.", missingValue: "Missing space before value for {{computed}}key '{{key}}'." } }, create: function(e28) {
  function t3(y3) {
    return !(y3.method || y3.shorthand || y3.kind !== "init" || y3.type !== "Property");
  }
  function n3(y3) {
    var v3 = y3.key;
    return y3.computed ? m3.getText().slice(v3.range[0], v3.range[1]) : y3.key.name || y3.key.value;
  }
  function r3(y3, v3, b3, x3, C3) {
    var k3 = b3.length - x3, F3 = function(R3) {
      return m3.getTokenAfter(R3, P$s.isColonToken);
    }(y3.key), B3 = m3.getTokenBefore(F3, { includeComments: true }), O3 = m3.getTokenAfter(F3, { includeComments: true }), S3 = v3 === "key", w3 = S3 ? B3.loc.start : O3.loc.start, D3 = 0 < k3, I3 = Math.abs(k3), L3 = Array(I3 + 1).join(" ");
    if ((k3 && C3 === "strict" || 0 > k3 && C3 === "minimum" || 0 < k3 && !x3 && C3 === "minimum") && (!x3 || !function(R3) {
      return P$s.LINEBREAK_MATCHER.test(R3);
    }(b3))) {
      var V10, K3;
      D3 ? (K3 = S3 ? [B3.range[1], B3.range[1] + I3] : [O3.range[0] - I3, O3.range[0]], V10 = function(R3) {
        return R3.removeRange(K3);
      }) : V10 = S3 ? function(R3) {
        return R3.insertTextAfter(B3, L3);
      } : function(R3) {
        return R3.insertTextBefore(O3, L3);
      };
      var W3;
      W3 = D3 ? v3 === "key" ? "extraKey" : "extraValue" : v3 === "key" ? "missingKey" : "missingValue", e28.report({ node: y3[v3], loc: w3, messageId: W3, data: { computed: y3.computed ? "computed " : "", key: n3(y3) }, fix: V10 });
    }
  }
  function i(y3) {
    var v3 = m3.getFirstToken(y3);
    return function(b3) {
      var x3 = m3.getTokenAfter(b3, P$s.isColonToken);
      return m3.getTokenBefore(x3);
    }(y3.key).range[1] - v3.range[0];
  }
  function a3(y3) {
    var v3 = /([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*):([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)/.exec(m3.getText().slice(y3.key.range[1], y3.value.range[0]));
    return v3 ? { beforeColon: v3[1], afterColon: v3[2] } : null;
  }
  function s3(y3) {
    return y3.properties.length === 1 ? [y3.properties] : y3.properties.reduce(function(v3, b3) {
      var x3 = Jd$1(v3), C3 = Jd$1(x3);
      return !C3 || function(k3, F3) {
        var B3 = k3.loc.start.line, O3 = F3.loc.start.line;
        if (1 >= O3 - B3)
          return true;
        var S3 = m3.getCommentsBefore(F3);
        if (S3.length && 1 >= S3[0].loc.start.line - B3 && 1 >= O3 - Jd$1(S3).loc.end.line) {
          for (var w3 = 1; w3 < S3.length; w3++)
            if (1 < S3[w3].loc.start.line - S3[w3 - 1].loc.end.line)
              return false;
          return true;
        }
        return false;
      }(C3, b3) ? x3.push(b3) : v3.push([b3]), v3;
    }, [[]]);
  }
  function o3(y3) {
    s3(y3).forEach(function(v3) {
      (function(b3) {
        var x3, C3, k3, F3 = b3.length, B3 = b3.map(i), O3 = d3.on, S3 = Math.max.apply(Math, Mt$2(B3));
        d3 && 1 < F3 ? (x3 = d3.beforeColon, C3 = d3.afterColon, k3 = d3.mode) : (x3 = f3.beforeColon, C3 = f3.afterColon, k3 = d3.mode), S3 += O3 === "colon" ? x3 : C3;
        for (var w3 = 0; w3 < F3; w3++) {
          var D3 = b3[w3], I3 = a3(D3);
          if (I3) {
            var L3 = B3[w3];
            O3 === "value" ? (r3(D3, "key", I3.beforeColon, x3, k3), r3(D3, "value", I3.afterColon, S3 - L3, k3)) : (r3(D3, "key", I3.beforeColon, S3 - L3, k3), r3(D3, "value", I3.afterColon, C3, k3));
          }
        }
      })(v3.filter(t3));
    });
  }
  function u3(y3, v3) {
    var b3 = a3(y3);
    b3 && (r3(y3, "key", b3.beforeColon, v3.beforeColon, v3.mode), r3(y3, "value", b3.afterColon, v3.afterColon, v3.mode));
  }
  var c3 = function(y3, v3) {
    return xe$3(v3.align) == "object" ? (y3.align = Iu$1({}, v3.align), y3.align.on = v3.align.on || "colon", y3.align.mode = v3.align.mode || "strict", y3.multiLine = Iu$1({}, v3.multiLine || v3), y3.singleLine = Iu$1({}, v3.singleLine || v3)) : (y3.multiLine = Iu$1({}, v3.multiLine || v3), y3.singleLine = Iu$1({}, v3.singleLine || v3), y3.multiLine.align && (y3.align = { on: y3.multiLine.align.on, mode: y3.multiLine.align.mode || y3.multiLine.mode, beforeColon: y3.multiLine.align.beforeColon, afterColon: y3.multiLine.align.afterColon })), y3;
  }({}, e28.options[0] || {}), f3 = c3.multiLine, p3 = c3.singleLine, d3 = c3.align || null, m3 = e28.getSourceCode();
  return d3 ? { ObjectExpression: function(y3) {
    i2(y3) ? function(v3) {
      for (var b3 = v3.length, x3 = 0; x3 < b3; x3++)
        u3(v3[x3], p3);
    }(y3.properties.filter(t3)) : o3(y3);
  } } : { Property: function(y3) {
    u3(y3, i2(y3.parent) ? p3 : f3);
  } };
} }, H5 = /^[\)>\]\}]$/, K5 = /^(?:[!\(<\[\{~]|\+\+?|\x2D\x2D?)$/, Qd$1 = /^[\)\*>\]\}]$/, a2 = /^[\*\{]$/, J5 = /\$\{$/, Q5 = /^\}/, Ql = /^(?:JSXElement|RegularExpression|String|Template)$/, Ya$2 = Qp.concat(["as", "async", "await", "from", "get", "let", "of", "set", "yield"]);
function o2(e28) {
  return e28.type === "Template" && J5.test(e28.value);
}
function s2(e28) {
  return e28.type === "Template" && Q5.test(e28.value);
}
(function() {
  Ya$2.sort();
  for (var e28 = 1; e28 < Ya$2.length; ++e28)
    if (Ya$2[e28] === Ya$2[e28 - 1])
      throw new Error("Duplication was found in the keyword list: ".concat(Ya$2[e28]));
})();
var X5 = { meta: { type: "layout", docs: { description: "enforce consistent spacing before and after keywords", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/keyword-spacing" }, fixable: "whitespace", schema: [{ type: "object", properties: { before: { type: "boolean", default: true }, after: { type: "boolean", default: true }, overrides: { type: "object", properties: Ya$2.reduce(function(e28, t3) {
  return e28[t3] = { type: "object", properties: { before: { type: "boolean" }, after: { type: "boolean" } }, additionalProperties: false }, e28;
}, {}), additionalProperties: false } }, additionalProperties: false }], messages: { expectedBefore: 'Expected space(s) before "{{value}}".', expectedAfter: 'Expected space(s) after "{{value}}".', unexpectedBefore: 'Unexpected space(s) before "{{value}}".', unexpectedAfter: 'Unexpected space(s) after "{{value}}".' } }, create: function(e28) {
  function t3(x3, C3) {
    var k3 = v3.getTokenBefore(x3);
    k3 && (Ql.test(k3.type) || C3.test(k3.value)) && !o2(k3) && P$s.isTokenOnSameLine(k3, x3) && !v3.isSpaceBetweenTokens(k3, x3) && e28.report({ loc: x3.loc.start, messageId: "expectedBefore", data: x3, fix: function(F3) {
      return F3.insertTextBefore(x3, " ");
    } });
  }
  function n3(x3, C3) {
    var k3 = v3.getTokenBefore(x3);
    k3 && (Ql.test(k3.type) || C3.test(k3.value)) && !o2(k3) && P$s.isTokenOnSameLine(k3, x3) && v3.isSpaceBetweenTokens(k3, x3) && e28.report({ loc: x3.loc.start, messageId: "unexpectedBefore", data: x3, fix: function(F3) {
      return F3.removeRange([k3.range[1], x3.range[0]]);
    } });
  }
  function r3(x3, C3) {
    var k3 = v3.getTokenAfter(x3);
    k3 && (Ql.test(k3.type) || C3.test(k3.value)) && !s2(k3) && P$s.isTokenOnSameLine(x3, k3) && !v3.isSpaceBetweenTokens(x3, k3) && e28.report({ loc: x3.loc.start, messageId: "expectedAfter", data: x3, fix: function(F3) {
      return F3.insertTextAfter(x3, " ");
    } });
  }
  function i(x3, C3) {
    var k3 = v3.getTokenAfter(x3);
    k3 && (Ql.test(k3.type) || C3.test(k3.value)) && !s2(k3) && P$s.isTokenOnSameLine(x3, k3) && v3.isSpaceBetweenTokens(x3, k3) && e28.report({ loc: x3.loc.start, messageId: "unexpectedAfter", data: x3, fix: function(F3) {
      return F3.removeRange([x3.range[1], k3.range[0]]);
    } });
  }
  function a3(x3, C3) {
    b3[x3.value].before(x3, C3 || H5);
  }
  function s3(x3, C3) {
    b3[x3.value].after(x3, C3 || K5);
  }
  function o3(x3) {
    a3(x3), s3(x3);
  }
  function u3(x3) {
    var C3 = x3 && v3.getFirstToken(x3);
    C3 && C3.type === "Keyword" && o3(C3);
  }
  function c3(x3) {
    var C3 = x3 && v3.getFirstToken(x3);
    C3 && C3.type === "Keyword" && a3(C3);
  }
  function f3(x3) {
    x3 && o3(v3.getTokenBefore(x3, P$s.isKeywordToken));
  }
  function p3(x3) {
    var C3 = x3 && v3.getFirstToken(x3);
    C3 && (C3.type === "Keyword" && C3.value === "function" || C3.value === "async") && a3(C3);
  }
  function d3(x3) {
    u3(x3), f3(x3.superClass);
  }
  function m3(x3) {
    var C3 = v3.getFirstToken(x3);
    if (a3(C3, Qd$1), s3(C3, a2), x3.type === "ExportDefaultDeclaration" && o3(v3.getTokenAfter(C3)), x3.source) {
      var k3 = v3.getTokenBefore(x3.source);
      a3(k3, Qd$1), s3(k3, a2);
    }
  }
  function y3(x3) {
    if (x3.static && u3(x3), x3.kind === "get" || x3.kind === "set" || (x3.method || x3.type === "MethodDefinition") && x3.value.async) {
      var C3 = v3.getTokenBefore(x3.key, function(k3) {
        switch (k3.value) {
          case "get":
          case "set":
          case "async":
            return true;
          default:
            return false;
        }
      });
      if (!C3)
        throw new Error("Failed to find token get, set, or async beside method name");
      o3(C3);
    }
  }
  var v3 = e28.getSourceCode(), b3 = function() {
    for (var x3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, C3 = x3.before !== false, k3 = x3.after !== false, F3 = { before: C3 ? t3 : n3, after: k3 ? r3 : i }, B3 = x3 && x3.overrides || {}, O3 = /* @__PURE__ */ Object.create(null), S3 = 0; S3 < Ya$2.length; ++S3) {
      var w3 = Ya$2[S3], D3 = B3[w3];
      if (D3) {
        var I3 = "before" in D3 ? D3.before : C3, L3 = "after" in D3 ? D3.after : k3;
        O3[w3] = { before: I3 ? t3 : n3, after: L3 ? r3 : i };
      } else
        O3[w3] = F3;
    }
    return O3;
  }(e28.options[0]);
  return { DebuggerStatement: u3, WithStatement: u3, BreakStatement: u3, ContinueStatement: u3, ReturnStatement: u3, ThrowStatement: u3, TryStatement: function(x3) {
    u3(x3), u3(x3.handler), f3(x3.finalizer);
  }, IfStatement: function(x3) {
    u3(x3), f3(x3.alternate);
  }, SwitchStatement: u3, SwitchCase: u3, DoWhileStatement: function(x3) {
    u3(x3), f3(x3.test);
  }, ForInStatement: function(x3) {
    u3(x3), f3(x3.right);
  }, ForOfStatement: function(x3) {
    x3.await ? (a3(v3.getFirstToken(x3, 0)), s3(v3.getFirstToken(x3, 1))) : u3(x3), o3(v3.getTokenBefore(x3.right, P$s.isNotOpeningParenToken));
  }, ForStatement: u3, WhileStatement: u3, ClassDeclaration: d3, ExportNamedDeclaration: m3, ExportDefaultDeclaration: m3, ExportAllDeclaration: m3, FunctionDeclaration: p3, ImportDeclaration: m3, VariableDeclaration: u3, ArrowFunctionExpression: p3, AwaitExpression: function(x3) {
    a3(v3.getFirstToken(x3));
  }, ClassExpression: d3, FunctionExpression: p3, NewExpression: c3, Super: c3, ThisExpression: c3, UnaryExpression: c3, YieldExpression: c3, ImportNamespaceSpecifier: function(x3) {
    a3(v3.getFirstToken(x3, 1), Qd$1);
  }, MethodDefinition: y3, Property: y3 };
} }, Y5 = { meta: { type: "layout", docs: { description: "enforce position of line comments", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/line-comment-position" }, schema: [{ oneOf: [{ enum: ["above", "beside"] }, { type: "object", properties: { position: { enum: ["above", "beside"] }, ignorePattern: { type: "string" }, applyDefaultPatterns: { type: "boolean" }, applyDefaultIgnorePatterns: { type: "boolean" } }, additionalProperties: false }] }], messages: { above: "Expected comment to be above code.", beside: "Expected comment to be beside code." } }, create: function(e28) {
  var t3, n3, r3 = e28.options[0], i = true;
  r3 && typeof r3 != "string" ? (t3 = !r3.position || r3.position === "above", n3 = r3.ignorePattern, i = Object.prototype.hasOwnProperty.call(r3, "applyDefaultIgnorePatterns") ? r3.applyDefaultIgnorePatterns : r3.applyDefaultPatterns !== false) : t3 = !r3 || r3 === "above";
  var a3 = P$s.COMMENTS_IGNORE_PATTERN, s3 = /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*falls?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?through/, o3 = new RegExp(n3, "u"), u3 = e28.getSourceCode();
  return { Program: function() {
    u3.getAllComments().filter(function(c3) {
      return c3.type === "Line";
    }).forEach(function(c3) {
      if (!(i && (a3.test(c3.value) || s3.test(c3.value)) || n3 && o3.test(c3.value))) {
        var f3 = u3.getTokenBefore(c3, { includeComments: true }), p3 = f3 && f3.loc.end.line === c3.loc.start.line;
        t3 ? p3 && e28.report({ node: c3, messageId: "above" }) : !p3 && e28.report({ node: c3, messageId: "beside" });
      }
    });
  } };
} }, Z5 = { meta: { type: "layout", docs: { description: "enforce consistent linebreak style", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/linebreak-style" }, fixable: "whitespace", schema: [{ enum: ["unix", "windows"] }], messages: { expectedLF: "Expected linebreaks to be 'LF' but found 'CRLF'.", expectedCRLF: "Expected linebreaks to be 'CRLF' but found 'LF'." } }, create: function(e28) {
  function t3(r3, i) {
    return function(a3) {
      return a3.replaceTextRange(r3, i);
    };
  }
  var n3 = e28.getSourceCode();
  return { Program: function(r3) {
    for (var i, a3 = (e28.options[0] || "unix") === "unix", s3 = a3 ? `
` : `\r
`, o3 = n3.getText(), u3 = P$s.createGlobalLinebreakMatcher(), c3 = 0; (i = u3.exec(o3)) !== null; )
      if (c3++, i[0] !== s3) {
        var f3 = i.index, p3 = [f3, f3 + i[0].length];
        e28.report({ node: r3, loc: { line: c3, column: n3.lines[c3 - 1].length }, messageId: a3 ? "expectedLF" : "expectedCRLF", fix: t3(p3, s3) });
      }
  } };
} }, eB = { meta: { type: "layout", docs: { description: "require empty lines around comments", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/lines-around-comment" }, fixable: "whitespace", schema: [{ type: "object", properties: { beforeBlockComment: { type: "boolean", default: true }, afterBlockComment: { type: "boolean", default: false }, beforeLineComment: { type: "boolean", default: false }, afterLineComment: { type: "boolean", default: false }, allowBlockStart: { type: "boolean", default: false }, allowBlockEnd: { type: "boolean", default: false }, allowClassStart: { type: "boolean" }, allowClassEnd: { type: "boolean" }, allowObjectStart: { type: "boolean" }, allowObjectEnd: { type: "boolean" }, allowArrayStart: { type: "boolean" }, allowArrayEnd: { type: "boolean" }, ignorePattern: { type: "string" }, applyDefaultIgnorePatterns: { type: "boolean" } }, additionalProperties: false }], messages: { after: "Expected line after comment.", before: "Expected line before comment." } }, create: function(e28) {
  function t3(I3, L3) {
    return I3.type === L3 || I3.body && I3.body.type === L3 || I3.consequent && I3.consequent.type === L3;
  }
  function n3(I3) {
    return k3.getNodeByRangeIndex(I3.range[0]);
  }
  function r3(I3, L3) {
    var V10 = n3(I3);
    return V10 && t3(V10, L3) && I3.loc.start.line - V10.loc.start.line == 1;
  }
  function i(I3, L3) {
    var V10 = n3(I3);
    return V10 && t3(V10, L3) && V10.loc.end.line - I3.loc.end.line == 1;
  }
  function a3(I3) {
    return r3(I3, "ClassBody") || r3(I3, "BlockStatement") || r3(I3, "SwitchCase");
  }
  function s3(I3) {
    return i(I3, "ClassBody") || i(I3, "BlockStatement") || i(I3, "SwitchCase") || i(I3, "SwitchStatement");
  }
  function o3(I3) {
    return r3(I3, "ClassBody");
  }
  function u3(I3) {
    return i(I3, "ClassBody");
  }
  function c3(I3) {
    return r3(I3, "ObjectExpression") || r3(I3, "ObjectPattern");
  }
  function f3(I3) {
    return i(I3, "ObjectExpression") || i(I3, "ObjectPattern");
  }
  function p3(I3) {
    return r3(I3, "ArrayExpression") || r3(I3, "ArrayPattern");
  }
  function d3(I3) {
    return i(I3, "ArrayExpression") || i(I3, "ArrayPattern");
  }
  function m3(I3, L3) {
    if (!(C3 && b3.test(I3.value) || v3 && x3.test(I3.value))) {
      var V10 = L3.after, K3 = L3.before, W3 = I3.loc.start.line - 1, R3 = I3.loc.end.line + 1, q3 = function(Fe2) {
        var Pe2 = Fe2;
        do
          Pe2 = k3.getTokenBefore(Pe2, { includeComments: true });
        while (Pe2 && P$s.isCommentToken(Pe2));
        if (Pe2 && P$s.isTokenOnSameLine(Pe2, Fe2))
          return true;
        Pe2 = Fe2;
        do
          Pe2 = k3.getTokenAfter(Pe2, { includeComments: true });
        while (Pe2 && P$s.isCommentToken(Pe2));
        return !(!Pe2 || !P$s.isTokenOnSameLine(Fe2, Pe2));
      }(I3), J3 = y3.allowBlockStart && a3(I3) && !(y3.allowClassStart === false && o3(I3)), X3 = y3.allowBlockEnd && s3(I3) && !(y3.allowClassEnd === false && u3(I3)), ce2 = y3.allowClassStart && o3(I3), A3 = y3.allowClassEnd && u3(I3), M3 = y3.allowObjectStart && c3(I3), ne2 = y3.allowObjectEnd && f3(I3), de2 = y3.allowArrayStart && p3(I3), he2 = y3.allowArrayEnd && d3(I3);
      if (1 > W3 && (K3 = false), R3 >= B3 && (V10 = false), !q3) {
        var j3 = k3.getTokenBefore(I3, { includeComments: true }), ie2 = k3.getTokenAfter(I3, { includeComments: true });
        if (!(J3 || ce2 || M3 || de2) && K3 && !ye$4.lodash.includes(D3, W3) && (!P$s.isCommentToken(j3) || !P$s.isTokenOnSameLine(j3, I3))) {
          var fe2 = I3.range[0] - I3.loc.start.column, ge2 = [fe2, fe2];
          e28.report({ node: I3, messageId: "before", fix: function(Fe2) {
            return Fe2.insertTextBeforeRange(ge2, `
`);
          } });
        }
        X3 || A3 || ne2 || he2 || !V10 || ye$4.lodash.includes(D3, R3) || P$s.isCommentToken(ie2) && P$s.isTokenOnSameLine(I3, ie2) || e28.report({ node: I3, messageId: "after", fix: function(Fe2) {
          return Fe2.insertTextAfter(I3, `
`);
        } });
      }
    }
  }
  var y3 = Object.assign({}, e28.options[0]), v3 = y3.ignorePattern, b3 = P$s.COMMENTS_IGNORE_PATTERN, x3 = new RegExp(v3, "u"), C3 = y3.applyDefaultIgnorePatterns !== false;
  y3.beforeBlockComment = y3.beforeBlockComment === void 0 || y3.beforeBlockComment;
  var k3 = e28.getSourceCode(), F3 = k3.lines, B3 = F3.length + 1, O3 = k3.getAllComments(), S3 = function(I3) {
    var L3 = [];
    return I3.forEach(function(V10) {
      var K3 = V10.loc.start.line, W3 = V10.loc.end.line;
      L3.push(K3, W3);
    }), L3;
  }(O3), w3 = function(I3) {
    return I3.map(function(L3, V10) {
      return { code: L3.trim(), num: V10 + 1 };
    }).filter(function(L3) {
      return !L3.code;
    }).map(function(L3) {
      return L3.num;
    });
  }(F3), D3 = S3.concat(w3);
  return { Program: function() {
    O3.forEach(function(I3) {
      I3.type === "Line" ? (y3.beforeLineComment || y3.afterLineComment) && m3(I3, { after: y3.afterLineComment, before: y3.beforeLineComment }) : I3.type === "Block" && (y3.beforeBlockComment || y3.afterBlockComment) && m3(I3, { after: y3.afterBlockComment, before: y3.beforeBlockComment });
    });
  } };
} }, tB = { meta: { type: "layout", docs: { description: "require or disallow newlines around directives", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/lines-around-directive" }, schema: [{ oneOf: [{ enum: ["always", "never"] }, { type: "object", properties: { before: { enum: ["always", "never"] }, after: { enum: ["always", "never"] } }, additionalProperties: false, minProperties: 2 }] }], fixable: "whitespace", messages: { expected: 'Expected newline {{location}} "{{value}}" directive.', unexpected: 'Unexpected newline {{location}} "{{value}}" directive.' }, deprecated: true, replacedBy: ["padding-line-between-statements"] }, create: function(e28) {
  function t3(f3) {
    var p3 = s3.getTokenBefore(f3, { includeComments: true }), d3 = p3 ? p3.loc.end.line : 0;
    return 2 <= f3.loc.start.line - d3;
  }
  function n3(f3) {
    var p3 = s3.getLastToken(f3), d3 = s3.getTokenBefore(p3);
    return P$s.isSemicolonToken(p3) && p3.loc.start.line > d3.loc.end.line ? d3 : p3;
  }
  function r3(f3) {
    var p3 = n3(f3);
    return 2 <= s3.getTokenAfter(p3, { includeComments: true }).loc.start.line - p3.loc.end.line;
  }
  function i(f3, p3, d3) {
    e28.report({ node: f3, messageId: d3 ? "expected" : "unexpected", data: { value: f3.expression.value, location: p3 }, fix: function(m3) {
      var y3 = n3(f3);
      return d3 ? p3 === "before" ? m3.insertTextBefore(f3, `
`) : m3.insertTextAfter(y3, `
`) : m3.removeRange(p3 === "before" ? [f3.range[0] - 1, f3.range[0]] : [y3.range[1], y3.range[1] + 1]);
    } });
  }
  function a3(f3) {
    var p3 = P$s.getDirectivePrologue(f3);
    if (p3.length) {
      var d3 = p3[0], m3 = s3.getCommentsBefore(d3);
      m3.length ? (u3 === "always" && !t3(d3) && i(d3, "before", true), u3 === "never" && t3(d3) && i(d3, "before", false)) : f3.type === "Program" && u3 === "never" && !m3.length && t3(d3) && i(d3, "before", false);
      var y3 = p3[p3.length - 1], v3 = f3.type === "Program" ? f3.body : f3.body.body;
      (y3 !== v3[v3.length - 1] || y3.trailingComments) && (c3 === "always" && !r3(y3) && i(y3, "after", true), c3 === "never" && r3(y3) && i(y3, "after", false));
    }
  }
  var s3 = e28.getSourceCode(), o3 = e28.options[0] || "always", u3 = typeof o3 == "string" ? o3 : o3.before, c3 = typeof o3 == "string" ? o3 : o3.after;
  return { Program: a3, FunctionDeclaration: a3, FunctionExpression: a3, ArrowFunctionExpression: a3 };
} }, nB = { meta: { type: "layout", docs: { description: "require or disallow an empty line between class members", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/lines-between-class-members" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { exceptAfterSingleLine: { type: "boolean", default: false } }, additionalProperties: false }], messages: { never: "Unexpected blank line between class members.", always: "Expected blank line between class members." } }, create: function(e28) {
  var t3 = [];
  t3[0] = e28.options[0] || "always", t3[1] = e28.options[1] || { exceptAfterSingleLine: false };
  var n3 = e28.getSourceCode();
  return { ClassBody: function(r3) {
    for (var i = r3.body, a3 = function(o3) {
      var u3 = n3.getFirstToken(i[o3]), c3 = n3.getLastToken(i[o3]), f3 = n3.getFirstToken(i[o3 + 1]), p3 = function(m3, y3) {
        var v3 = n3.getCommentsBefore(y3), b3 = v3.length;
        if (b3 === 0)
          return 1 <= y3.loc.start.line - m3.loc.end.line - 1;
        for (var x3 = 0, C3 = -1, k3 = 0; k3 < b3; k3++)
          x3 += v3[k3].loc.end.line - v3[k3].loc.start.line + 1, C3 === v3[k3].loc.start.line && (x3 -= 1), C3 = v3[k3].loc.end.line;
        return m3.loc.end.line === v3[0].loc.start.line && (x3 -= 1), v3[b3 - 1].loc.end.line === y3.loc.start.line && (x3 -= 1), 1 <= y3.loc.start.line - m3.loc.end.line - 1 - x3;
      }(c3, f3), d3 = !!P$s.isTokenOnSameLine(u3, c3) && t3[1].exceptAfterSingleLine;
      (t3[0] !== "always" || d3 || p3) && (t3[0] !== "never" || !p3) || e28.report({ node: i[o3 + 1], messageId: p3 ? "never" : "always", fix: function(m3) {
        return p3 ? m3.replaceTextRange([c3.range[1], f3.range[0]], `
`) : m3.insertTextAfter(c3, `
`);
      } });
    }, s3 = 0; s3 < i.length - 1; s3++)
      a3(s3);
  } };
} }, rB = { meta: { type: "suggestion", docs: { description: "enforce a maximum depth that blocks can be nested", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-depth" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { maximum: { type: "integer", minimum: 0 }, max: { type: "integer", minimum: 0 } }, additionalProperties: false }] }], messages: { tooDeeply: "Blocks are nested too deeply ({{depth}}). Maximum allowed is {{maxDepth}}." } }, create: function(e28) {
  function t3() {
    a3.push(0);
  }
  function n3() {
    a3.pop();
  }
  function r3(u3) {
    var c3 = ++a3[a3.length - 1];
    c3 > o3 && e28.report({ node: u3, messageId: "tooDeeply", data: { depth: c3, maxDepth: o3 } });
  }
  function i() {
    a3[a3.length - 1]--;
  }
  var a3 = [], s3 = e28.options[0], o3 = 4;
  return xe$3(s3) == "object" && (Object.prototype.hasOwnProperty.call(s3, "maximum") || Object.prototype.hasOwnProperty.call(s3, "max")) && (o3 = s3.maximum || s3.max), typeof s3 == "number" && (o3 = s3), { Program: t3, FunctionDeclaration: t3, FunctionExpression: t3, ArrowFunctionExpression: t3, IfStatement: function(u3) {
    u3.parent.type !== "IfStatement" && r3(u3);
  }, SwitchStatement: r3, TryStatement: r3, DoWhileStatement: r3, WhileStatement: r3, WithStatement: r3, ForStatement: r3, ForInStatement: r3, ForOfStatement: r3, "IfStatement:exit": i, "SwitchStatement:exit": i, "TryStatement:exit": i, "DoWhileStatement:exit": i, "WhileStatement:exit": i, "WithStatement:exit": i, "ForStatement:exit": i, "ForInStatement:exit": i, "ForOfStatement:exit": i, "FunctionDeclaration:exit": n3, "FunctionExpression:exit": n3, "ArrowFunctionExpression:exit": n3, "Program:exit": n3 };
} }, kA = { type: "object", properties: { code: { type: "integer", minimum: 0 }, comments: { type: "integer", minimum: 0 }, tabWidth: { type: "integer", minimum: 0 }, ignorePattern: { type: "string" }, ignoreComments: { type: "boolean" }, ignoreStrings: { type: "boolean" }, ignoreUrls: { type: "boolean" }, ignoreTemplateLiterals: { type: "boolean" }, ignoreRegExpLiterals: { type: "boolean" }, ignoreTrailingComments: { type: "boolean" } }, additionalProperties: false }, u2 = { anyOf: [kA, { type: "integer", minimum: 0 }] }, iB = { meta: { type: "layout", docs: { description: "enforce a maximum line length", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-len" }, schema: [u2, u2, kA], messages: { max: "This line has a length of {{lineLength}}. Maximum allowed is {{maxLength}}.", maxComment: "This line has a comment length of {{lineLength}}. Maximum allowed is {{maxCommentLength}}." } }, create: function(e28) {
  function t3(C3, k3, F3) {
    return F3 && F3.loc.start.line === k3 && k3 <= F3.loc.end.line && (F3.loc.end.line > k3 || F3.loc.end.column === C3.length);
  }
  function n3(C3, k3) {
    return C3.slice(0, k3.loc.start.column).replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+$/, "");
  }
  function r3(C3, k3, F3) {
    Array.isArray(C3[k3]) || (C3[k3] = []), C3[k3].push(F3);
  }
  function i(C3, k3) {
    for (var F3 = k3.loc.start.line; F3 <= k3.loc.end.line; ++F3)
      r3(C3, F3, k3);
    return C3;
  }
  var a3 = /(?:[\0-"\$-\.0-9;->@-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]):\/\/(?:[\0-"\$->@-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, s3 = e28.getSourceCode(), o3 = Object.assign({}, e28.options[e28.options.length - 1]);
  typeof e28.options[0] == "number" && (o3.code = e28.options[0]), typeof e28.options[1] == "number" && (o3.tabWidth = e28.options[1]);
  var u3 = typeof o3.code == "number" ? o3.code : 80, c3 = typeof o3.tabWidth == "number" ? o3.tabWidth : 4, f3 = !!o3.ignoreComments, p3 = !!o3.ignoreStrings, d3 = !!o3.ignoreTemplateLiterals, m3 = !!o3.ignoreRegExpLiterals, y3 = !!o3.ignoreTrailingComments || !!o3.ignoreComments, v3 = !!o3.ignoreUrls, b3 = o3.comments, x3 = o3.ignorePattern || null;
  return x3 && (x3 = new RegExp(x3, "u")), { Program: function(C3) {
    var k3 = s3.lines, F3 = f3 || b3 || y3 ? s3.getAllComments() : [], B3 = 0, O3 = s3.ast.tokens.filter(function(D3) {
      return D3.type === "String" || D3.type === "JSXText" && s3.getNodeByRangeIndex(D3.range[0] - 1).type === "JSXAttribute";
    }).reduce(i, {}), S3 = s3.ast.tokens.filter(function(D3) {
      return D3.type === "Template";
    }).reduce(i, {}), w3 = s3.ast.tokens.filter(function(D3) {
      return D3.type === "RegularExpression";
    }).reduce(i, {});
    k3.forEach(function(D3, I3) {
      var L3, V10 = I3 + 1, K3 = false;
      if (B3 < F3.length) {
        var W3 = null;
        do
          W3 = F3[++B3];
        while (W3 && W3.loc.start.line <= V10);
        if (function(J3, X3, ce2) {
          var A3 = ce2.loc.start, M3 = ce2.loc.end, ne2 = !J3.slice(0, ce2.loc.start.column).trim();
          return ce2 && (A3.line < X3 || A3.line === X3 && ne2) && (M3.line > X3 || M3.line === X3 && M3.column === J3.length);
        }(D3, V10, W3 = F3[--B3]))
          K3 = true, L3 = D3;
        else if (y3 && t3(D3, V10, W3)) {
          L3 = n3(D3, W3);
          for (var R3 = B3; t3(L3, V10, F3[--R3]); )
            L3 = n3(L3, F3[R3]);
        } else
          L3 = D3;
      } else
        L3 = D3;
      if (!(x3 && x3.test(L3) || v3 && a3.test(L3) || p3 && O3[V10] || d3 && S3[V10] || m3 && w3[V10])) {
        var q3 = function(J3, X3) {
          var ce2 = 0;
          return J3.replace(/\t/g, function(A3, M3) {
            ce2 += X3 - (X3 ? (M3 + ce2) % X3 : 0) - 1;
          }), Array.from(J3).length + ce2;
        }(L3, c3);
        K3 && f3 || (K3 && b3 ? q3 > b3 && e28.report({ node: C3, loc: { line: V10, column: 0 }, messageId: "maxComment", data: { lineLength: q3, maxCommentLength: b3 } }) : q3 > u3 && e28.report({ node: C3, loc: { line: V10, column: 0 }, messageId: "max", data: { lineLength: q3, maxLength: u3 } }));
      }
    });
  } };
} }, aB = { meta: { type: "suggestion", docs: { description: "enforce a maximum number of line of code in a function", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-lines-per-function" }, schema: [{ oneOf: [{ type: "object", properties: { max: { type: "integer", minimum: 0 }, skipComments: { type: "boolean" }, skipBlankLines: { type: "boolean" }, IIFEs: { type: "boolean" } }, additionalProperties: false }, { type: "integer", minimum: 1 }] }], messages: { exceed: "{{name}} has too many lines ({{lineCount}}). Maximum allowed is {{maxLines}}." } }, create: function(e28) {
  function t3(p3, d3, m3) {
    var y3 = m3.loc.start, v3 = m3.loc.end, b3 = y3.line === d3 && !p3.slice(0, y3.column).trim(), x3 = v3.line === d3 && !p3.slice(v3.column).trim();
    return m3 && (y3.line < d3 || b3) && (v3.line > d3 || x3);
  }
  function n3(p3) {
    var d3 = function(x3) {
      return !(!x3.parent || x3 !== x3.parent.value || x3.parent.type !== "MethodDefinition" && (x3.parent.type !== "Property" || x3.parent.method !== true && x3.parent.kind !== "get" && x3.parent.kind !== "set"));
    }(p3) ? p3.parent : p3;
    if (c3 || !function(x3) {
      return x3.type === "FunctionExpression" && x3.parent && x3.parent.type === "CallExpression" && x3.parent.callee === x3;
    }(d3)) {
      for (var m3 = 0, y3 = d3.loc.start.line - 1; y3 < d3.loc.end.line; ++y3) {
        var v3 = i[y3];
        o3 && f3.has(y3 + 1) && t3(v3, y3 + 1, f3.get(y3 + 1)) || u3 && v3.match(/^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/) || m3++;
      }
      if (m3 > s3) {
        var b3 = ye$4.lodash.upperFirst(P$s.getFunctionNameWithKind(p3));
        e28.report({ node: d3, messageId: "exceed", data: { name: b3, lineCount: m3, maxLines: s3 } });
      }
    }
  }
  var r3 = e28.getSourceCode(), i = r3.lines, a3 = e28.options[0], s3 = 50, o3 = false, u3 = false, c3 = false;
  xe$3(a3) == "object" ? (s3 = typeof a3.max == "number" ? a3.max : 50, o3 = !!a3.skipComments, u3 = !!a3.skipBlankLines, c3 = !!a3.IIFEs) : typeof a3 == "number" && (s3 = a3);
  var f3 = function(p3) {
    var d3 = /* @__PURE__ */ new Map();
    return p3 && p3.forEach(function(m3) {
      for (var y3 = m3.loc.start.line; y3 <= m3.loc.end.line; y3++)
        d3.set(y3, m3);
    }), d3;
  }(r3.getAllComments());
  return { FunctionDeclaration: n3, FunctionExpression: n3, ArrowFunctionExpression: n3 };
} }, oB = { meta: { type: "suggestion", docs: { description: "enforce a maximum number of lines per file", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-lines" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { max: { type: "integer", minimum: 0 }, skipComments: { type: "boolean" }, skipBlankLines: { type: "boolean" } }, additionalProperties: false }] }], messages: { exceed: "File has too many lines ({{actual}}). Maximum allowed is {{max}}." } }, create: function(e28) {
  function t3(u3) {
    return u3 && (u3.type === "Block" || u3.type === "Line");
  }
  function n3(u3) {
    var c3, f3 = u3.loc.start.line, p3 = u3.loc.end.line;
    c3 = u3;
    do
      c3 = o3.getTokenBefore(c3, { includeComments: true });
    while (t3(c3));
    c3 && P$s.isTokenOnSameLine(c3, u3) && (f3 += 1), c3 = u3;
    do
      c3 = o3.getTokenAfter(c3, { includeComments: true });
    while (t3(c3));
    return c3 && P$s.isTokenOnSameLine(u3, c3) && (p3 -= 1), f3 <= p3 ? ye$4.lodash.range(f3, p3 + 1) : [];
  }
  var r3 = e28.options[0], i = 300;
  xe$3(r3) == "object" && Object.prototype.hasOwnProperty.call(r3, "max") ? i = r3.max : typeof r3 == "number" && (i = r3);
  var a3 = r3 && r3.skipComments, s3 = r3 && r3.skipBlankLines, o3 = e28.getSourceCode();
  return { "Program:exit": function() {
    var u3 = o3.lines.map(function(p3, d3) {
      return { lineNumber: d3 + 1, text: p3 };
    });
    if (s3 && (u3 = u3.filter(function(p3) {
      return p3.text.trim() !== "";
    })), a3) {
      var c3 = o3.getAllComments(), f3 = ye$4.lodash.flatten(c3.map(function(p3) {
        return n3(p3);
      }));
      u3 = u3.filter(function(p3) {
        return !ye$4.lodash.includes(f3, p3.lineNumber);
      });
    }
    u3.length > i && e28.report({ loc: { line: 1, column: 0 }, messageId: "exceed", data: { max: i, actual: u3.length } });
  } };
} }, sB = { meta: { type: "suggestion", docs: { description: "enforce a maximum depth that callbacks can be nested", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-nested-callbacks" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { maximum: { type: "integer", minimum: 0 }, max: { type: "integer", minimum: 0 } }, additionalProperties: false }] }], messages: { exceed: "Too many nested callbacks ({{num}}). Maximum allowed is {{max}}." } }, create: function(e28) {
  function t3(s3) {
    if (s3.parent.type === "CallExpression" && a3.push(s3), a3.length > i) {
      var o3 = { num: a3.length, max: i };
      e28.report({ node: s3, messageId: "exceed", data: o3 });
    }
  }
  function n3() {
    a3.pop();
  }
  var r3 = e28.options[0], i = 10;
  xe$3(r3) == "object" && (Object.prototype.hasOwnProperty.call(r3, "maximum") || Object.prototype.hasOwnProperty.call(r3, "max")) ? i = r3.maximum || r3.max : typeof r3 == "number" && (i = r3);
  var a3 = [];
  return { ArrowFunctionExpression: t3, "ArrowFunctionExpression:exit": n3, FunctionExpression: t3, "FunctionExpression:exit": n3 };
} }, uB = { meta: { type: "suggestion", docs: { description: "enforce a maximum number of parameters in function definitions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-params" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { maximum: { type: "integer", minimum: 0 }, max: { type: "integer", minimum: 0 } }, additionalProperties: false }] }], messages: { exceed: "{{name}} has too many parameters ({{count}}). Maximum allowed is {{max}}." } }, create: function(e28) {
  function t3(a3) {
    a3.params.length > i && e28.report({ loc: P$s.getFunctionHeadLoc(a3, n3), node: a3, messageId: "exceed", data: { name: ye$4.lodash.upperFirst(P$s.getFunctionNameWithKind(a3)), count: a3.params.length, max: i } });
  }
  var n3 = e28.getSourceCode(), r3 = e28.options[0], i = 3;
  return xe$3(r3) == "object" && (Object.prototype.hasOwnProperty.call(r3, "maximum") || Object.prototype.hasOwnProperty.call(r3, "max")) && (i = r3.maximum || r3.max), typeof r3 == "number" && (i = r3), { FunctionDeclaration: t3, ArrowFunctionExpression: t3, FunctionExpression: t3 };
} }, cB = { meta: { type: "layout", docs: { description: "enforce a maximum number of statements allowed per line", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-statements-per-line" }, schema: [{ type: "object", properties: { max: { type: "integer", minimum: 1, default: 1 } }, additionalProperties: false }], messages: { exceed: "This line has {{numberOfStatementsOnThisLine}} {{statements}}. Maximum allowed is {{maxStatementsPerLine}}." } }, create: function(e28) {
  function t3() {
    i && e28.report({ node: i, messageId: "exceed", data: { numberOfStatementsOnThisLine: c3, maxStatementsPerLine: o3, statements: c3 === 1 ? "statement" : "statements" } }), i = null;
  }
  function n3(p3) {
    var d3 = p3.loc.start.line;
    f3.test(p3.parent.type) && p3.parent.alternate !== p3 || (d3 === u3 ? c3 += 1 : (t3(), c3 = 1, u3 = d3), c3 === o3 + 1 && (i = i || p3));
  }
  function r3(p3) {
    var d3 = function(m3) {
      return a3.getLastToken(m3, P$s.isNotSemicolonToken);
    }(p3).loc.end.line;
    d3 !== u3 && (t3(), c3 = 1, u3 = d3);
  }
  var i, a3 = e28.getSourceCode(), s3 = e28.options[0] || {}, o3 = s3.max === void 0 ? 1 : s3.max, u3 = 0, c3 = 0, f3 = /^(?:(?:DoWhile|For|ForIn|ForOf|If|Labeled|While)Statement|Export(?:Default|Named)Declaration)$/;
  return { BreakStatement: n3, ClassDeclaration: n3, ContinueStatement: n3, DebuggerStatement: n3, DoWhileStatement: n3, ExpressionStatement: n3, ForInStatement: n3, ForOfStatement: n3, ForStatement: n3, FunctionDeclaration: n3, IfStatement: n3, ImportDeclaration: n3, LabeledStatement: n3, ReturnStatement: n3, SwitchStatement: n3, ThrowStatement: n3, TryStatement: n3, VariableDeclaration: n3, WhileStatement: n3, WithStatement: n3, ExportNamedDeclaration: n3, ExportDefaultDeclaration: n3, ExportAllDeclaration: n3, "BreakStatement:exit": r3, "ClassDeclaration:exit": r3, "ContinueStatement:exit": r3, "DebuggerStatement:exit": r3, "DoWhileStatement:exit": r3, "ExpressionStatement:exit": r3, "ForInStatement:exit": r3, "ForOfStatement:exit": r3, "ForStatement:exit": r3, "FunctionDeclaration:exit": r3, "IfStatement:exit": r3, "ImportDeclaration:exit": r3, "LabeledStatement:exit": r3, "ReturnStatement:exit": r3, "SwitchStatement:exit": r3, "ThrowStatement:exit": r3, "TryStatement:exit": r3, "VariableDeclaration:exit": r3, "WhileStatement:exit": r3, "WithStatement:exit": r3, "ExportNamedDeclaration:exit": r3, "ExportDefaultDeclaration:exit": r3, "ExportAllDeclaration:exit": r3, "Program:exit": t3 };
} }, lB = { meta: { type: "suggestion", docs: { description: "enforce a maximum number of statements allowed in function blocks", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-statements" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { maximum: { type: "integer", minimum: 0 }, max: { type: "integer", minimum: 0 } }, additionalProperties: false }] }, { type: "object", properties: { ignoreTopLevelFunctions: { type: "boolean" } }, additionalProperties: false }], messages: { exceed: "{{name}} has too many statements ({{count}}). Maximum allowed is {{max}}." } }, create: function(e28) {
  function t3(c3, f3, p3) {
    if (f3 > p3) {
      var d3 = ye$4.lodash.upperFirst(P$s.getFunctionNameWithKind(c3));
      e28.report({ node: c3, messageId: "exceed", data: { name: d3, count: f3, max: p3 } });
    }
  }
  function n3() {
    i.push(0);
  }
  function r3(c3) {
    var f3 = i.pop();
    s3 && i.length === 0 ? o3.push({ node: c3, count: f3 }) : t3(c3, f3, u3);
  }
  var i = [], a3 = e28.options[0], s3 = e28.options[1] && e28.options[1].ignoreTopLevelFunctions || false, o3 = [], u3 = 10;
  return xe$3(a3) == "object" && (Object.prototype.hasOwnProperty.call(a3, "maximum") || Object.prototype.hasOwnProperty.call(a3, "max")) ? u3 = a3.maximum || a3.max : typeof a3 == "number" && (u3 = a3), { FunctionDeclaration: n3, FunctionExpression: n3, ArrowFunctionExpression: n3, BlockStatement: function(c3) {
    i[i.length - 1] += c3.body.length;
  }, "FunctionDeclaration:exit": r3, "FunctionExpression:exit": r3, "ArrowFunctionExpression:exit": r3, "Program:exit": function() {
    o3.length === 1 || o3.forEach(function(c3) {
      var f3 = c3.count;
      t3(c3.node, f3, u3);
    });
  } };
} }, pB = { meta: { type: "suggestion", docs: { description: "enforce a particular style for multiline comments", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/multiline-comment-style" }, fixable: "whitespace", schema: [{ enum: ["starred-block", "separate-lines", "bare-block"] }], messages: { expectedBlock: "Expected a block comment instead of consecutive line comments.", expectedBareBlock: "Expected a block comment without padding stars.", startNewline: "Expected a linebreak after '/*'.", endNewline: "Expected a linebreak before '*/'.", missingStar: "Expected a '*' at the start of this line.", alignment: "Expected this line to be aligned with the start of the comment.", expectedLines: "Expected multiple line comments instead of a block comment." } }, create: function(e28) {
  function t3(c3) {
    var f3 = bn$1(c3, 1)[0];
    if (f3.type !== "Block")
      return false;
    var p3 = f3.value.split(P$s.LINEBREAK_MATCHER);
    return 0 < p3.length && p3.every(function(d3, m3) {
      return (m3 === 0 || m3 === p3.length - 1 ? /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/ : /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*/).test(d3);
    });
  }
  function n3(c3) {
    var f3 = bn$1(c3, 1)[0];
    if (f3.type !== "Block")
      return false;
    var p3 = f3.value.split(P$s.LINEBREAK_MATCHER);
    return /^\*[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/.test(p3[0]) && p3.slice(1, -1).every(function(d3) {
      return /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]* /.test(d3);
    }) && /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/.test(p3[p3.length - 1]);
  }
  function r3(c3) {
    var f3 = bn$1(c3, 1)[0];
    return f3.type === "Line" ? function(p3) {
      var d3 = p3.map(function(m3) {
        return m3.value;
      }).filter(function(m3) {
        return m3.trim().length;
      }).every(function(m3) {
        return m3.startsWith(" ");
      });
      return p3.map(function(m3) {
        var y3 = m3.value;
        return d3 ? y3.replace(/^ /, "") : y3;
      });
    }(c3) : t3(c3) ? function(p3) {
      var d3 = p3.value.split(P$s.LINEBREAK_MATCHER).filter(function(y3, v3, b3) {
        return v3 !== 0 && v3 !== b3.length - 1;
      }).map(function(y3) {
        return y3.replace(/^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, "");
      }), m3 = d3.map(function(y3) {
        return y3.replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*/, "");
      }).filter(function(y3) {
        return y3.trim().length;
      }).every(function(y3) {
        return y3.startsWith(" ");
      });
      return d3.map(function(y3) {
        return y3.replace(m3 ? /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\* ?/ : /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*/, "");
      });
    }(f3) : function(p3) {
      var d3 = p3.value.split(P$s.LINEBREAK_MATCHER).map(function(D3) {
        return D3.replace(/^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, "");
      }), m3 = "".concat(s3.text.slice(p3.range[0] - p3.loc.start.column, p3.range[0]), "   "), y3 = "", v3 = true, b3 = false, x3 = void 0;
      try {
        for (var C3, k3 = d3.entries()[Symbol.iterator](); !(v3 = (C3 = k3.next()).done); v3 = true) {
          var F3 = bn$1(C3.value, 2), B3 = F3[0], O3 = F3[1];
          if (O3.trim().length && B3 !== 0) {
            var S3 = bn$1(O3.match(/^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)/), 2)[1];
            if (S3.length < m3.length) {
              var w3 = m3.slice(S3.length - m3.length);
              w3.length > y3.length && (y3 = w3);
            }
          }
        }
      } catch (D3) {
        b3 = true, x3 = D3;
      } finally {
        try {
          v3 || k3.return == null || k3.return();
        } finally {
          if (b3)
            throw x3;
        }
      }
      return d3.map(function(D3) {
        var I3 = bn$1(D3.match(/^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)/), 3), L3 = I3[1], V10 = I3[2];
        return L3.length > m3.length ? "".concat(L3.slice(m3.length - (y3.length + L3.length))).concat(V10) : L3.length < m3.length ? "".concat(L3.slice(m3.length)).concat(V10) : V10;
      });
    }(f3);
  }
  function i(c3) {
    return s3.text.slice(c3.range[0] - c3.loc.start.column, c3.range[0]);
  }
  function a3(c3, f3) {
    return "/* ".concat(f3.join(`
`.concat(i(c3), "   ")), " */");
  }
  var s3 = e28.getSourceCode(), o3 = e28.options[0] || "starred-block", u3 = { "starred-block": function(c3) {
    var f3 = bn$1(c3, 1)[0], p3 = r3(c3);
    p3.some(function(d3) {
      return d3.includes("*/");
    }) || (1 < c3.length ? e28.report({ loc: { start: f3.loc.start, end: c3[c3.length - 1].loc.end }, messageId: "expectedBlock", fix: function(d3) {
      var m3 = [f3.range[0], c3[c3.length - 1].range[1]];
      return p3.some(function(y3) {
        return y3.startsWith("/");
      }) ? null : d3.replaceTextRange(m3, function(y3, v3) {
        var b3 = i(y3);
        return `/*
`.concat(v3.map(function(x3) {
          return "".concat(b3, " * ").concat(x3);
        }).join(`
`), `
`).concat(b3, " */");
      }(f3, p3));
    } }) : function() {
      var d3 = f3.value.split(P$s.LINEBREAK_MATCHER), m3 = i(f3), y3 = "".concat(m3, " *");
      if (!/^\*?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/.test(d3[0])) {
        var v3 = f3.value.startsWith("*") ? f3.range[0] + 1 : f3.range[0];
        e28.report({ loc: { start: f3.loc.start, end: { line: f3.loc.start.line, column: f3.loc.start.column + 2 } }, messageId: "startNewline", fix: function(C3) {
          return C3.insertTextAfterRange([v3, v3 + 2], `
`.concat(y3));
        } });
      }
      /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/.test(d3[d3.length - 1]) || e28.report({ loc: { start: { line: f3.loc.end.line, column: f3.loc.end.column - 2 }, end: f3.loc.end }, messageId: "endNewline", fix: function(C3) {
        return C3.replaceTextRange([f3.range[1] - 2, f3.range[1]], `
`.concat(y3, "/"));
      } });
      for (var b3 = function(C3) {
        var k3 = s3.lines[C3 - 1], F3 = function(B3) {
          return /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*/.test(B3);
        }(k3) ? "alignment" : "missingStar";
        k3.startsWith(y3) || e28.report({ loc: { start: { line: C3, column: 0 }, end: { line: C3, column: k3.length } }, messageId: F3, fix: function(B3) {
          var O3 = s3.getIndexFromLoc({ line: C3, column: 0 });
          if (F3 === "alignment") {
            var S3 = bn$1(k3.match(/^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*)/) || [], 2)[1], w3 = O3 + (S3 === void 0 ? "" : S3).length;
            return B3.replaceTextRange([O3, w3], y3);
          }
          var D3, I3 = bn$1(k3.match(/^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)/) || [], 2)[1], L3 = I3 === void 0 ? "" : I3, V10 = O3 + L3.length, K3 = true, W3 = false, R3 = void 0;
          try {
            for (var q3, J3 = d3.entries()[Symbol.iterator](); !(K3 = (q3 = J3.next()).done); K3 = true) {
              var X3 = bn$1(q3.value, 2), ce2 = X3[0], A3 = X3[1];
              if (/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+/.test(A3)) {
                var M3 = bn$1(s3.lines[f3.loc.start.line - 1 + ce2].match(/^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:\/?\*)?([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*))/) || [], 3), ne2 = M3[1], de2 = ne2 === void 0 ? "" : ne2, he2 = M3[2], j3 = he2 === void 0 ? "" : he2;
                D3 = "".concat(L3.slice(de2.length)).concat(j3);
                break;
              }
            }
          } catch (ie2) {
            W3 = true, R3 = ie2;
          } finally {
            try {
              K3 || J3.return == null || J3.return();
            } finally {
              if (W3)
                throw R3;
            }
          }
          return B3.replaceTextRange([O3, V10], "".concat(y3).concat(D3));
        } });
      }, x3 = f3.loc.start.line + 1; x3 <= f3.loc.end.line; x3++)
        b3(x3);
    }());
  }, "separate-lines": function(c3) {
    var f3 = bn$1(c3, 1)[0];
    if (f3.type === "Block" && !n3(c3)) {
      var p3 = r3(c3), d3 = s3.getTokenAfter(f3, { includeComments: true });
      d3 && f3.loc.end.line === d3.loc.start.line || e28.report({ loc: { start: f3.loc.start, end: { line: f3.loc.start.line, column: f3.loc.start.column + 2 } }, messageId: "expectedLines", fix: function(m3) {
        return m3.replaceText(f3, function(y3, v3) {
          return v3.map(function(b3) {
            return "// ".concat(b3);
          }).join(`
`.concat(i(y3)));
        }(f3, p3));
      } });
    }
  }, "bare-block": function(c3) {
    if (!n3(c3)) {
      var f3 = bn$1(c3, 1)[0], p3 = r3(c3);
      f3.type === "Line" && 1 < p3.length && !p3.some(function(d3) {
        return d3.includes("*/");
      }) && e28.report({ loc: { start: f3.loc.start, end: c3[c3.length - 1].loc.end }, messageId: "expectedBlock", fix: function(d3) {
        return d3.replaceTextRange([f3.range[0], c3[c3.length - 1].range[1]], a3(f3, p3));
      } }), t3(c3) && e28.report({ loc: { start: f3.loc.start, end: { line: f3.loc.start.line, column: f3.loc.start.column + 2 } }, messageId: "expectedBareBlock", fix: function(d3) {
        return d3.replaceText(f3, a3(f3, p3));
      } });
    }
  } };
  return { Program: function() {
    return s3.getAllComments().filter(function(c3) {
      return c3.type !== "Shebang";
    }).filter(function(c3) {
      return !P$s.COMMENTS_IGNORE_PATTERN.test(c3.value);
    }).filter(function(c3) {
      var f3 = s3.getTokenBefore(c3, { includeComments: true });
      return !f3 || f3.loc.end.line < c3.loc.start.line;
    }).reduce(function(c3, f3, p3, d3) {
      var m3 = s3.getTokenBefore(f3, { includeComments: true });
      return f3.type === "Line" && p3 && d3[p3 - 1].type === "Line" && m3 && m3.loc.end.line === f3.loc.start.line - 1 && m3 === d3[p3 - 1] ? c3[c3.length - 1].push(f3) : c3.push([f3]), c3;
    }, []).filter(function(c3) {
      return c3.length !== 1 || c3[0].loc.start.line !== c3[0].loc.end.line;
    }).forEach(u3[o3]);
  } };
} }, fB = { meta: { type: "layout", docs: { description: "enforce newlines between operands of ternary expressions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/multiline-ternary" }, schema: [{ enum: ["always", "always-multiline", "never"] }], messages: { expectedTestCons: "Expected newline between test and consequent of ternary expression.", expectedConsAlt: "Expected newline between consequent and alternate of ternary expression.", unexpectedTestCons: "Unexpected newline between test and consequent of ternary expression.", unexpectedConsAlt: "Unexpected newline between consequent and alternate of ternary expression." } }, create: function(e28) {
  function t3(r3, i, a3) {
    e28.report({ node: r3, messageId: "".concat(a3 ? "expected" : "unexpected").concat(r3 === i.test ? "TestCons" : "ConsAlt") });
  }
  var n3 = e28.options[0];
  return { ConditionalExpression: function(r3) {
    var i = P$s.isTokenOnSameLine(r3.test, r3.consequent), a3 = P$s.isTokenOnSameLine(r3.consequent, r3.alternate);
    if (n3 === "never")
      i || t3(r3.test, r3, false), a3 || t3(r3.consequent, r3, false);
    else {
      if (n3 === "always-multiline" && r3.loc.start.line === r3.loc.end.line)
        return;
      i && t3(r3.test, r3, true), a3 && t3(r3.consequent, r3, true);
    }
  } };
} }, Xd = ["Array", "Boolean", "Date", "Error", "Function", "Number", "Object", "RegExp", "String", "Symbol", "BigInt"];
function c2(e28, t3, n3) {
  if (Object.prototype.hasOwnProperty.call(e28, t3) && !Array.isArray(e28[t3]))
    throw new TypeError("".concat(t3, ", if provided, must be an Array"));
  return e28[t3] || n3;
}
function l2(e28, t3) {
  return e28[t3] = true, e28;
}
var hB = { meta: { type: "suggestion", docs: { description: "require constructor names to begin with a capital letter", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/new-cap" }, schema: [{ type: "object", properties: { newIsCap: { type: "boolean", default: true }, capIsNew: { type: "boolean", default: true }, newIsCapExceptions: { type: "array", items: { type: "string" } }, newIsCapExceptionPattern: { type: "string" }, capIsNewExceptions: { type: "array", items: { type: "string" } }, capIsNewExceptionPattern: { type: "string" }, properties: { type: "boolean", default: true } }, additionalProperties: false }], messages: { upper: "A function with a name starting with an uppercase letter should only be used as a constructor.", lower: "A constructor name should not start with a lowercase letter." } }, create: function(e28) {
  function t3(m3) {
    var y3 = "";
    if (m3.callee.type === "MemberExpression") {
      var v3 = m3.callee.property;
      v3.type === "Literal" && typeof v3.value == "string" ? y3 = v3.value : v3.type === "Identifier" && !m3.callee.computed && (y3 = v3.name);
    } else
      y3 = m3.callee.name;
    return y3;
  }
  function n3(m3) {
    var y3 = m3.charAt(0), v3 = y3.toLowerCase();
    return v3 === y3.toUpperCase() ? "non-alpha" : y3 === v3 ? "lower" : "upper";
  }
  function r3(m3, y3, v3, b3) {
    var x3 = d3.getText(y3.callee);
    return !(!m3[v3] && !m3[x3]) || !(!b3 || !b3.test(x3)) || (v3 === "UTC" && y3.callee.type === "MemberExpression" ? y3.callee.object.type === "Identifier" && y3.callee.object.name === "Date" : s3 && y3.callee.type === "MemberExpression");
  }
  function i(m3, y3) {
    var v3 = m3.callee;
    v3.type === "MemberExpression" && (v3 = v3.property), e28.report({ node: m3, loc: v3.loc.start, messageId: y3 });
  }
  var a3 = Object.assign({}, e28.options[0]);
  a3.newIsCap = a3.newIsCap !== false, a3.capIsNew = a3.capIsNew !== false;
  var s3 = a3.properties === false, o3 = c2(a3, "newIsCapExceptions", []).reduce(l2, {}), u3 = a3.newIsCapExceptionPattern ? new RegExp(a3.newIsCapExceptionPattern, "u") : null, c3 = function(m3) {
    var y3 = c2(m3, "capIsNewExceptions", Xd);
    return y3 !== Xd && (y3 = y3.concat(Xd)), y3.reduce(l2, {});
  }(a3), f3 = a3.capIsNewExceptionPattern ? new RegExp(a3.capIsNewExceptionPattern, "u") : null, p3 = {}, d3 = e28.getSourceCode();
  return a3.newIsCap && (p3.NewExpression = function(m3) {
    var y3 = t3(m3);
    y3 && (n3(y3) !== "lower" || r3(o3, m3, y3, u3) || i(m3, "lower"));
  }), a3.capIsNew && (p3.CallExpression = function(m3) {
    var y3 = t3(m3);
    y3 && (n3(y3) !== "upper" || r3(c3, m3, y3, f3) || i(m3, "upper"));
  }), p3;
} }, dB = { meta: { type: "layout", docs: { description: "enforce or disallow parentheses when invoking a constructor with no arguments", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/new-parens" }, fixable: "code", schema: { anyOf: [{ type: "array", items: [{ enum: ["always", "never"] }], minItems: 0, maxItems: 1 }] }, messages: { missing: "Missing '()' invoking a constructor.", unnecessary: "Unnecessary '()' invoking a constructor with no arguments." } }, create: function(e28) {
  var t3 = e28.options[0] !== "never", n3 = e28.getSourceCode();
  return { NewExpression: function(r3) {
    if (r3.arguments.length === 0) {
      var i = n3.getLastToken(r3), a3 = i && P$s.isClosingParenToken(i) && P$s.isOpeningParenToken(n3.getTokenBefore(i)) && r3.callee.range[1] < r3.range[1];
      t3 ? !a3 && e28.report({ node: r3, messageId: "missing", fix: function(s3) {
        return s3.insertTextAfter(r3, "()");
      } }) : a3 && e28.report({ node: r3, messageId: "unnecessary", fix: function(s3) {
        return [s3.remove(n3.getTokenBefore(i)), s3.remove(i), s3.insertTextBefore(r3, "("), s3.insertTextAfter(r3, ")")];
      } });
    }
  } };
} }, mB = { meta: { type: "layout", docs: { description: "require or disallow an empty line after variable declarations", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/newline-after-var" }, schema: [{ enum: ["never", "always"] }], fixable: "whitespace", messages: { expected: "Expected blank line after variable declarations.", unexpected: "Unexpected blank line after variable declarations." }, deprecated: true, replacedBy: ["padding-line-between-statements"] }, create: function(e28) {
  function t3(a3) {
    var s3 = i[a3];
    return i[s3 + 1] ? t3(s3 + 1) : s3;
  }
  var n3 = e28.getSourceCode(), r3 = e28.options[0] === "never" ? "never" : "always", i = n3.getAllComments().reduce(function(a3, s3) {
    return a3[s3.loc.start.line] = s3.loc.end.line, a3;
  }, {});
  return { VariableDeclaration: function(a3) {
    var s3 = function(p3) {
      var d3 = n3.getLastToken(p3);
      if (d3.type === "Punctuator" && d3.value === ";") {
        var m3 = n3.getTokenBefore(d3);
        if (m3.loc.end.line !== d3.loc.start.line)
          return m3;
      }
      return d3;
    }(a3), o3 = s3 === n3.getLastToken(a3) ? n3.getTokenAfter(a3) : n3.getLastToken(a3), u3 = s3.loc.end.line + 1;
    if (o3 && !function(p3) {
      return p3 === "ForStatement" || p3 === "ForInStatement" || p3 === "ForOfStatement";
    }(a3.parent.type) && !function(p3) {
      return p3 === "ExportNamedDeclaration" || p3 === "ExportSpecifier" || p3 === "ExportDefaultDeclaration" || p3 === "ExportAllDeclaration";
    }(a3.parent.type) && !(o3.type === "Keyword" && function(p3) {
      return p3 === "var" || p3 === "let" || p3 === "const";
    }(o3.value) || function(p3) {
      var d3 = n3.getTokenAfter(p3);
      return !d3 || d3.type === "Punctuator" && d3.value === "}";
    }(a3))) {
      var c3 = o3.loc.start.line > u3, f3 = i[u3] !== void 0;
      r3 === "never" && c3 && !f3 && e28.report({ node: a3, messageId: "unexpected", data: { identifier: a3.name }, fix: function(p3) {
        var d3 = n3.getText().slice(s3.range[1], o3.range[0]).split(P$s.LINEBREAK_MATCHER);
        return p3.replaceTextRange([s3.range[1], o3.range[0]], "".concat(d3.slice(0, -1).join(""), `
`).concat(d3[d3.length - 1]));
      } }), r3 !== "always" || c3 && (!f3 || function(p3, d3) {
        return p3.loc.start.line > t3(d3) + 1;
      }(o3, u3)) || e28.report({ node: a3, messageId: "expected", data: { identifier: a3.name }, fix: function(p3) {
        return (c3 ? t3(u3) : s3.loc.end.line) === o3.loc.start.line ? p3.insertTextBefore(o3, `

`) : p3.insertTextBeforeRange([o3.range[0] - o3.loc.start.column, o3.range[1]], `
`);
      } });
    }
  } };
} }, gB = { meta: { type: "layout", docs: { description: "require an empty line before `return` statements", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/newline-before-return" }, fixable: "whitespace", schema: [], messages: { expected: "Expected newline before return statement." }, deprecated: true, replacedBy: ["padding-line-between-statements"] }, create: function(e28) {
  function t3(a3, s3) {
    var o3 = i.getTokenBefore(a3);
    return s3.some(function(u3) {
      return o3.value === u3;
    });
  }
  function n3(a3) {
    var s3 = a3.parent.type;
    return a3.parent.body ? Array.isArray(a3.parent.body) ? a3.parent.body[0] === a3 : a3.parent.body === a3 : t3(a3, s3 === "IfStatement" ? ["else", ")"] : s3 === "DoWhileStatement" ? ["do"] : s3 === "SwitchCase" ? [":"] : [")"]);
  }
  function r3(a3) {
    var s3 = a3.loc.start.line, o3 = function(c3) {
      var f3 = i.getTokenBefore(c3);
      return f3 ? f3.loc.end.line : 0;
    }(a3), u3 = function(c3, f3) {
      var p3 = i.getCommentsBefore(c3), d3 = 0;
      return p3.length && p3.forEach(function(m3) {
        d3++, m3.type === "Block" && (d3 += m3.loc.end.line - m3.loc.start.line), m3.loc.start.line === f3 && d3--, m3.loc.end.line === c3.loc.start.line && d3--;
      }), d3;
    }(a3, o3);
    return 1 < s3 - o3 - u3;
  }
  var i = e28.getSourceCode();
  return { ReturnStatement: function(a3) {
    n3(a3) || r3(a3) || e28.report({ node: a3, messageId: "expected", fix: function(s3) {
      if (function(c3) {
        var f3 = i.getCommentsBefore(c3), p3 = f3[f3.length - 1], d3 = i.getTokenBefore(c3);
        return !(f3.length !== 0 && (p3.loc.end.line !== d3.loc.end.line || p3.loc.end.line === c3.loc.start.line));
      }(a3)) {
        var o3 = i.getTokenBefore(a3), u3 = a3.loc.start.line === o3.loc.end.line ? `

` : `
`;
        return s3.insertTextBefore(a3, u3);
      }
      return null;
    } });
  } };
} }, yB = { meta: { type: "layout", docs: { description: "require a newline after each call in a method chain", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/newline-per-chained-call" }, fixable: "whitespace", schema: [{ type: "object", properties: { ignoreChainWithDepth: { type: "integer", minimum: 1, maximum: 10, default: 2 } }, additionalProperties: false }], messages: { expected: "Expected line break before `{{callee}}`." } }, create: function(e28) {
  function t3(i) {
    var a3 = function(u3) {
      return u3.computed ? "[" : ".";
    }(i), s3 = r3.getText(i.property).split(P$s.LINEBREAK_MATCHER), o3 = i.computed && s3.length === 1 ? "]" : "";
    return a3 + s3[0] + o3;
  }
  var n3 = (e28.options[0] || {}).ignoreChainWithDepth || 2, r3 = e28.getSourceCode();
  return { "CallExpression:exit": function(i) {
    if (i.callee && i.callee.type === "MemberExpression") {
      for (var a3 = i.callee, s3 = a3.object, o3 = 1; s3 && s3.callee; )
        o3 += 1, s3 = s3.callee.object;
      o3 > n3 && P$s.isTokenOnSameLine(a3.object, a3.property) && e28.report({ node: a3.property, loc: a3.property.loc.start, messageId: "expected", data: { callee: t3(a3) }, fix: function(u3) {
        var c3 = r3.getTokenAfter(a3.object, P$s.isNotClosingParenToken);
        return u3.insertTextBefore(c3, `
`);
      } });
    }
  } };
} }, vB = P$s.getStaticPropertyName;
function p2(e28) {
  return /^(alert|confirm|prompt)$/.test(e28);
}
function f2(e28, t3) {
  var n3 = function(r3, i) {
    var a3 = r3.references.filter(function(s3) {
      return s3.identifier.range[0] === i.range[0] && s3.identifier.range[1] === i.range[1];
    });
    return a3.length === 1 ? a3[0] : null;
  }(e28, t3);
  return n3 && n3.resolved && 0 < n3.resolved.defs.length;
}
var xB = { meta: { type: "suggestion", docs: { description: "disallow the use of `alert`, `confirm`, and `prompt`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-alert" }, schema: [], messages: { unexpected: "Unexpected {{name}}." } }, create: function(e28) {
  return { CallExpression: function(t3) {
    var n3 = t3.callee, r3 = e28.getScope();
    if (n3.type === "Identifier") {
      var i = n3.name;
      !f2(r3, n3) && p2(n3.name) && e28.report({ node: t3, messageId: "unexpected", data: { name: i } });
    } else if (n3.type === "MemberExpression" && function(s3, o3) {
      return !(s3.type !== "global" || o3.type !== "ThisExpression") || o3.name === "window" && !f2(s3, o3);
    }(r3, n3.object)) {
      var a3 = vB(n3);
      p2(a3) && e28.report({ node: t3, messageId: "unexpected", data: { name: a3 } });
    }
  } };
} };
function bB(e28) {
  var t3 = e28.type;
  return t3 === "FunctionDeclaration" || t3 === "FunctionExpression" || t3 === "ArrowFunctionExpression" || t3 === "ForOfStatement" && e28.await === true;
}
function EB(e28, t3) {
  switch (t3.type) {
    case "ForStatement":
      return e28 === t3.test || e28 === t3.update || e28 === t3.body;
    case "ForOfStatement":
    case "ForInStatement":
      return e28 === t3.body;
    case "WhileStatement":
    case "DoWhileStatement":
      return e28 === t3.test || e28 === t3.body;
    default:
      return false;
  }
}
var CB = { meta: { type: "problem", docs: { description: "disallow `await` inside of loops", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-await-in-loop" }, schema: [], messages: { unexpectedAwait: "Unexpected `await` inside a loop." } }, create: function(e28) {
  function t3(n3) {
    if (n3.type !== "ForOfStatement" || n3.await)
      for (var r3 = n3, i = r3.parent; i && !bB(i); ) {
        if (EB(r3, i))
          return void e28.report({ node: n3, messageId: "unexpectedAwait" });
        r3 = i, i = i.parent;
      }
  }
  return { AwaitExpression: t3, ForOfStatement: t3 };
} }, h2 = ["^", "|", "&", "<<", ">>", ">>>", "^=", "|=", "&=", "<<=", ">>=", ">>>=", "~"], SB = { meta: { type: "suggestion", docs: { description: "disallow bitwise operators", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-bitwise" }, schema: [{ type: "object", properties: { allow: { type: "array", items: { enum: h2 }, uniqueItems: true }, int32Hint: { type: "boolean", default: false } }, additionalProperties: false }], messages: { unexpected: "Unexpected use of '{{operator}}'." } }, create: function(e28) {
  function t3(s3) {
    e28.report({ node: s3, messageId: "unexpected", data: { operator: s3.operator } });
  }
  function n3(s3) {
    !function(o3) {
      return h2.indexOf(o3.operator) !== -1;
    }(s3) || function(o3) {
      return i.indexOf(o3.operator) !== -1;
    }(s3) || function(o3) {
      return a3 && o3.operator === "|" && o3.right && o3.right.type === "Literal" && o3.right.value === 0;
    }(s3) || t3(s3);
  }
  var r3 = e28.options[0] || {}, i = r3.allow || [], a3 = r3.int32Hint === true;
  return { AssignmentExpression: n3, BinaryExpression: n3, UnaryExpression: n3 };
} }, kB = { meta: { type: "suggestion", docs: { description: "disallow `catch` clause parameters from shadowing variables in the outer scope", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/no-catch-shadow" }, replacedBy: ["no-shadow"], deprecated: true, schema: [], messages: { mutable: "Value of '{{name}}' may be overwritten in IE 8 and earlier." } }, create: function(e28) {
  return { "CatchClause[param!=null]": function(t3) {
    var n3 = e28.getScope();
    n3.block === t3 && (n3 = n3.upper), function(r3, i) {
      return P$s.getVariableByName(r3, i) !== null;
    }(n3, t3.param.name) && e28.report({ node: t3, messageId: "mutable", data: { name: t3.param.name } });
  } };
} }, DB$1 = { meta: { type: "problem", docs: { description: "disallow reassigning class members", category: "ECMAScript 6", recommended: true, url: "https://eslint.org/docs/rules/no-class-assign" }, schema: [], messages: { class: "'{{name}}' is a class." } }, create: function(e28) {
  function t3(r3) {
    P$s.getModifyingReferences(r3.references).forEach(function(i) {
      e28.report({ node: i.identifier, messageId: "class", data: { name: i.identifier.name } });
    });
  }
  function n3(r3) {
    e28.getDeclaredVariables(r3).forEach(t3);
  }
  return { ClassDeclaration: n3, ClassExpression: n3 };
} }, FB = { meta: { type: "problem", docs: { description: "disallow comparing against -0", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-compare-neg-zero" }, fixable: null, schema: [], messages: { unexpected: "Do not use the '{{operator}}' operator to compare against -0." } }, create: function(e28) {
  function t3(r3) {
    return r3.type === "UnaryExpression" && r3.operator === "-" && r3.argument.type === "Literal" && r3.argument.value === 0;
  }
  var n3 = /* @__PURE__ */ new Set([">", ">=", "<", "<=", "==", "===", "!=", "!=="]);
  return { BinaryExpression: function(r3) {
    n3.has(r3.operator) && (t3(r3.left) || t3(r3.right)) && e28.report({ node: r3, messageId: "unexpected", data: { operator: r3.operator } });
  } };
} }, wB = /* @__PURE__ */ new Set(["IfStatement", "WhileStatement", "DoWhileStatement", "ForStatement", "ConditionalExpression"]), AB = { DoWhileStatement: "a 'do...while' statement", ForStatement: "a 'for' statement", IfStatement: "an 'if' statement", WhileStatement: "a 'while' statement" }, _B = { meta: { type: "problem", docs: { description: "disallow assignment operators in conditional expressions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-cond-assign" }, schema: [{ enum: ["except-parens", "always"] }], messages: { unexpected: "Unexpected assignment within {{type}}.", missing: "Expected a conditional expression and instead saw an assignment." } }, create: function(e28) {
  function t3(s3) {
    return s3.parent && wB.has(s3.parent.type) && s3 === s3.parent.test;
  }
  function n3(s3) {
    var o3 = s3;
    do
      if (t3(o3))
        return o3.parent;
    while ((o3 = o3.parent) && !P$s.isFunction(o3));
    return null;
  }
  function r3(s3) {
    s3.test && s3.test.type === "AssignmentExpression" && (s3.type === "ForStatement" ? !P$s.isParenthesised(a3, s3.test) : !function(o3) {
      var u3 = a3.getTokenBefore(o3, 1), c3 = a3.getTokenAfter(o3, 1);
      return P$s.isParenthesised(a3, o3) && u3 && P$s.isOpeningParenToken(u3) && u3.range[1] <= o3.range[0] && P$s.isClosingParenToken(c3) && c3.range[0] >= o3.range[1];
    }(s3.test)) && e28.report({ node: s3.test, messageId: "missing" });
  }
  var i = e28.options[0] || "except-parens", a3 = e28.getSourceCode();
  return i === "always" ? { AssignmentExpression: function(s3) {
    var o3 = n3(s3);
    o3 && e28.report({ node: s3, messageId: "unexpected", data: { type: AB[o3.type] || o3.type } });
  } } : { DoWhileStatement: r3, ForStatement: r3, IfStatement: r3, WhileStatement: r3, ConditionalExpression: r3 };
} }, TB = { meta: { type: "suggestion", docs: { description: "disallow arrow functions where they could be confused with comparisons", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/no-confusing-arrow" }, fixable: "code", schema: [{ type: "object", properties: { allowParens: { type: "boolean", default: true } }, additionalProperties: false }], messages: { confusing: "Arrow function used ambiguously with a conditional expression." } }, create: function(e28) {
  var t3 = e28.options[0] || {}, n3 = t3.allowParens || t3.allowParens === void 0, r3 = e28.getSourceCode();
  return { ArrowFunctionExpression: function(i) {
    var a3 = i.body;
    (function(s3) {
      return s3 && s3.type === "ConditionalExpression";
    })(a3) && (!n3 || !P$s.isParenthesised(r3, a3)) && e28.report({ node: i, messageId: "confusing", fix: function(s3) {
      return n3 && s3.replaceText(i.body, "(".concat(r3.getText(i.body), ")"));
    } });
  } };
} }, PB = { meta: { type: "suggestion", docs: { description: "disallow the use of `console`", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-console" }, schema: [{ type: "object", properties: { allow: { type: "array", items: { type: "string" }, minItems: 1, uniqueItems: true } }, additionalProperties: false }], messages: { unexpected: "Unexpected console statement." } }, create: function(e28) {
  function t3(a3) {
    var s3 = a3.identifier;
    return s3 && s3.name === "console";
  }
  function n3(a3) {
    var s3 = a3.identifier, o3 = s3.parent;
    return o3.type === "MemberExpression" && o3.object === s3 && !function(u3) {
      var c3 = P$s.getStaticPropertyName(u3);
      return c3 && i.indexOf(c3) !== -1;
    }(o3);
  }
  function r3(a3) {
    var s3 = a3.identifier.parent;
    e28.report({ node: s3, loc: s3.loc, messageId: "unexpected" });
  }
  var i = (e28.options[0] || {}).allow || [];
  return { "Program:exit": function() {
    var a3 = e28.getScope(), s3 = P$s.getVariableByName(a3, "console"), o3 = s3 && 0 < s3.defs.length, u3 = s3 ? s3.references : a3.through.filter(t3);
    o3 || u3.filter(n3).forEach(r3);
  } };
} }, IB = { meta: { type: "problem", docs: { description: "disallow reassigning `const` variables", category: "ECMAScript 6", recommended: true, url: "https://eslint.org/docs/rules/no-const-assign" }, schema: [], messages: { const: "'{{name}}' is constant." } }, create: function(e28) {
  function t3(n3) {
    P$s.getModifyingReferences(n3.references).forEach(function(r3) {
      e28.report({ node: r3.identifier, messageId: "const", data: { name: r3.identifier.name } });
    });
  }
  return { VariableDeclaration: function(n3) {
    n3.kind === "const" && e28.getDeclaredVariables(n3).forEach(t3);
  } };
} }, BB = ["===", "!==", "==", "!="], OB = [">", "<", ">=", "<=", "in", "instanceof"], LB = { meta: { type: "problem", docs: { description: "disallow constant expressions in conditions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-constant-condition" }, schema: [{ type: "object", properties: { checkLoops: { type: "boolean", default: true } }, additionalProperties: false }], messages: { unexpected: "Unexpected constant condition." } }, create: function(e28) {
  function t3(p3, d3) {
    switch (p3.type) {
      case "Literal":
        return d3 === "||" && p3.value === true || d3 === "&&" && p3.value === false;
      case "UnaryExpression":
        return d3 === "&&" && p3.operator === "void";
      case "LogicalExpression":
        return t3(p3.left, p3.operator) || t3(p3.right, p3.operator);
    }
    return false;
  }
  function n3(p3, d3) {
    switch (p3.type) {
      case "Literal":
      case "ArrowFunctionExpression":
      case "FunctionExpression":
      case "ObjectExpression":
      case "ArrayExpression":
        return true;
      case "UnaryExpression":
        return p3.operator === "void" || p3.operator === "typeof" && d3 || n3(p3.argument, true);
      case "BinaryExpression":
        return n3(p3.left, false) && n3(p3.right, false) && p3.operator !== "in";
      case "LogicalExpression":
        var m3 = n3(p3.left, d3), y3 = n3(p3.right, d3), v3 = m3 && t3(p3.left, p3.operator), b3 = y3 && t3(p3.right, p3.operator);
        return m3 && y3 || p3.operator === "||" && y3 && p3.right.value && (!p3.parent || p3.parent.type !== "BinaryExpression" || !(BB.includes(p3.parent.operator) || OB.includes(p3.parent.operator))) || v3 || b3;
      case "AssignmentExpression":
        return p3.operator === "=" && n3(p3.right, d3);
      case "SequenceExpression":
        return n3(p3.expressions[p3.expressions.length - 1], d3);
    }
    return false;
  }
  function r3(p3) {
    f3.has(p3) && (f3.delete(p3), e28.report({ node: p3.test, messageId: "unexpected" }));
  }
  function i(p3) {
    p3.test && n3(p3.test, true) && e28.report({ node: p3.test, messageId: "unexpected" });
  }
  function a3() {
    c3.push(f3), f3 = /* @__PURE__ */ new Set();
  }
  function s3() {
    f3 = c3.pop();
  }
  function o3(p3) {
    u3 && function(d3) {
      d3.test && n3(d3.test, true) && f3.add(d3);
    }(p3);
  }
  var u3 = (e28.options[0] || {}).checkLoops !== false, c3 = [], f3 = /* @__PURE__ */ new Set();
  return { ConditionalExpression: i, IfStatement: i, WhileStatement: o3, "WhileStatement:exit": r3, DoWhileStatement: o3, "DoWhileStatement:exit": r3, ForStatement: o3, "ForStatement > .test": function(p3) {
    return o3(p3.parent);
  }, "ForStatement:exit": r3, FunctionDeclaration: a3, "FunctionDeclaration:exit": s3, FunctionExpression: a3, "FunctionExpression:exit": s3, YieldExpression: function() {
    return f3.clear();
  } };
} }, NB = ao$1.RegExpValidator, jB = new (function() {
  function e28() {
    We$1(this, e28), this.ecmaVersion = 2018, this._source = "", this._controlChars = [], this._validator = new NB(this);
  }
  return Xe$1(e28, [{ key: "onPatternEnter", value: function() {
    this._controlChars = [];
  } }, { key: "onCharacter", value: function(t3, n3, r3) {
    0 <= r3 && 31 >= r3 && (this._source.codePointAt(t3) === r3 || this._source.slice(t3, n3).startsWith("\\x") || this._source.slice(t3, n3).startsWith("\\u")) && this._controlChars.push("\\x".concat("0".concat(r3.toString(16)).slice(-2)));
  } }, { key: "collectControlChars", value: function(t3) {
    try {
      this._source = t3, this._validator.validatePattern(t3);
    } catch {
    }
    return this._controlChars;
  } }]), e28;
}())(), RB = { meta: { type: "problem", docs: { description: "disallow control characters in regular expressions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-control-regex" }, schema: [], messages: { unexpected: "Unexpected control character(s) in regular expression: {{controlChars}}." } }, create: function(e28) {
  return { Literal: function(t3) {
    var n3 = function(i) {
      return i.regex ? i.regex.pattern : typeof i.value != "string" || i.parent.type !== "NewExpression" && i.parent.type !== "CallExpression" || i.parent.callee.type !== "Identifier" || i.parent.callee.name !== "RegExp" || i.parent.arguments[0] !== i ? null : i.value;
    }(t3);
    if (n3) {
      var r3 = jB.collectControlChars(n3);
      0 < r3.length && e28.report({ node: t3, messageId: "unexpected", data: { controlChars: r3.join(", ") } });
    }
  } };
} }, MB = { meta: { type: "problem", docs: { description: "disallow duplicate class members", category: "ECMAScript 6", recommended: true, url: "https://eslint.org/docs/rules/no-dupe-class-members" }, schema: [], messages: { unexpected: "Duplicate name '{{name}}'." } }, create: function(e28) {
  function t3(r3, i) {
    var a3 = n3[n3.length - 1], s3 = "$".concat(r3);
    return a3[s3] || (a3[s3] = { nonStatic: { init: false, get: false, set: false }, static: { init: false, get: false, set: false } }), a3[s3][i ? "static" : "nonStatic"];
  }
  var n3 = [];
  return { Program: function() {
    n3 = [];
  }, ClassBody: function() {
    n3.push(/* @__PURE__ */ Object.create(null));
  }, "ClassBody:exit": function() {
    n3.pop();
  }, MethodDefinition: function(r3) {
    if (!r3.computed) {
      var i = function(o3) {
        switch (o3.type) {
          case "Identifier":
            return o3.name;
          case "Literal":
            return o3.value + "";
          default:
            return "";
        }
      }(r3.key), a3 = t3(i, r3.static), s3 = false;
      r3.kind === "get" ? (s3 = a3.init || a3.get, a3.get = true) : r3.kind === "set" ? (s3 = a3.init || a3.set, a3.set = true) : (s3 = a3.init || a3.get || a3.set, a3.init = true), s3 && e28.report({ node: r3, messageId: "unexpected", data: { name: i } });
    }
  } };
} };
function VB(e28, t3, n3) {
  return t3.every(function(r3) {
    return n3.some(function(i) {
      return e28(r3, i);
    });
  });
}
function Xp(e28, t3) {
  return t3.type === "LogicalExpression" && t3.operator === e28 ? [].concat(Mt$2(Xp(e28, t3.left)), Mt$2(Xp(e28, t3.right))) : [t3];
}
var d2 = Xp.bind(null, "||"), Yd = Xp.bind(null, "&&"), UB = { meta: { type: "problem", docs: { description: "disallow duplicate conditions in if-else-if chains", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-dupe-else-if" }, schema: [], messages: { unexpected: "This branch can never execute. Its condition is a duplicate or covered by previous conditions in the if-else-if chain." } }, create: function(e28) {
  var t3 = e28.getSourceCode(), n3 = VB.bind(null, function r3(i, a3) {
    return i.type === a3.type && (i.type !== "LogicalExpression" || i.operator !== "||" && i.operator !== "&&" || i.operator !== a3.operator ? P$s.equalTokens(i, a3, t3) : r3(i.left, a3.left) && r3(i.right, a3.right) || r3(i.left, a3.right) && r3(i.right, a3.left));
  });
  return { IfStatement: function(r3) {
    for (var i = r3.test, a3 = i.type === "LogicalExpression" && i.operator === "&&" ? [i].concat(Mt$2(Yd(i))) : [i], s3 = function(c3, f3) {
      c3 = c3.parent;
      var p3 = d2(c3.test).map(Yd);
      if ((f3 = f3.map(function(d3) {
        return d3.filter(function(m3) {
          return !p3.some(function(y3) {
            return n3(y3, m3);
          });
        });
      })).some(function(d3) {
        return d3.length === 0;
      }))
        return e28.report({ node: i, messageId: "unexpected" }), o3 = c3, u3 = f3, "break";
      o3 = c3, u3 = f3;
    }, o3 = r3, u3 = a3.map(function(c3) {
      return d2(c3).map(Yd);
    }); o3.parent && o3.parent.type === "IfStatement" && o3.parent.alternate === o3 && s3(o3, u3) !== "break"; )
      ;
  } };
} }, m2 = /^(?:init|get)$/, g2 = /^(?:init|set)$/, qB = function() {
  function e28(t3, n3) {
    We$1(this, e28), this.upper = t3, this.node = n3, this.properties = /* @__PURE__ */ new Map();
  }
  return Xe$1(e28, [{ key: "getPropertyInfo", value: function(t3) {
    var n3 = P$s.getStaticPropertyName(t3);
    return this.properties.has(n3) || this.properties.set(n3, { get: false, set: false }), this.properties.get(n3);
  } }, { key: "isPropertyDefined", value: function(t3) {
    var n3 = this.getPropertyInfo(t3);
    return m2.test(t3.kind) && n3.get || g2.test(t3.kind) && n3.set;
  } }, { key: "defineProperty", value: function(t3) {
    var n3 = this.getPropertyInfo(t3);
    m2.test(t3.kind) && (n3.get = true), g2.test(t3.kind) && (n3.set = true);
  } }]), e28;
}(), WB = { meta: { type: "problem", docs: { description: "disallow duplicate keys in object literals", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-dupe-keys" }, schema: [], messages: { unexpected: "Duplicate key '{{name}}'." } }, create: function(e28) {
  var t3 = null;
  return { ObjectExpression: function(n3) {
    t3 = new qB(t3, n3);
  }, "ObjectExpression:exit": function() {
    t3 = t3.upper;
  }, Property: function(n3) {
    var r3 = P$s.getStaticPropertyName(n3);
    n3.parent.type !== "ObjectExpression" || r3 === null || (t3.isPropertyDefined(n3) && e28.report({ node: t3.node, loc: n3.key.loc, messageId: "unexpected", data: { name: r3 } }), t3.defineProperty(n3));
  } };
} }, $B = { meta: { type: "problem", docs: { description: "disallow duplicate case labels", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-duplicate-case" }, schema: [], messages: { unexpected: "Duplicate case label." } }, create: function(e28) {
  var t3 = e28.getSourceCode();
  return { SwitchStatement: function(n3) {
    var r3 = /* @__PURE__ */ new Set(), i = true, a3 = false, s3 = void 0;
    try {
      for (var o3, u3 = n3.cases[Symbol.iterator](); !(i = (o3 = u3.next()).done); i = true) {
        var c3 = o3.value;
        if (c3.test) {
          var f3 = t3.getText(c3.test);
          r3.has(f3) ? e28.report({ node: c3, messageId: "unexpected" }) : r3.add(f3);
        }
      }
    } catch (p3) {
      a3 = true, s3 = p3;
    } finally {
      try {
        i || u3.return == null || u3.return();
      } finally {
        if (a3)
          throw s3;
      }
    }
  } };
} };
function DA(e28) {
  return e28 && e28.source && e28.source.value ? e28.source.value.trim() : "";
}
function Yp(e28, t3, n3, r3, i) {
  r3.indexOf(n3) !== -1 && e28.report({ node: t3, messageId: i, data: { module: n3 } });
}
function GB(e28, t3, n3, r3) {
  return function(i) {
    var a3 = DA(i);
    a3 && (Yp(e28, i, a3, n3, "import"), t3 && Yp(e28, i, a3, r3, "importAs"), n3.push(a3));
  };
}
function y2(e28, t3, n3) {
  return function(r3) {
    var i = DA(r3);
    i && (Yp(e28, r3, i, n3, "export"), Yp(e28, r3, i, t3, "exportAs"), n3.push(i));
  };
}
var zB = { meta: { type: "problem", docs: { description: "disallow duplicate module imports", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/no-duplicate-imports" }, schema: [{ type: "object", properties: { includeExports: { type: "boolean", default: false } }, additionalProperties: false }], messages: { import: "'{{module}}' import is duplicated.", importAs: "'{{module}}' import is duplicated as export.", export: "'{{module}}' export is duplicated.", exportAs: "'{{module}}' export is duplicated as import." } }, create: function(e28) {
  var t3 = (e28.options[0] || {}).includeExports, n3 = [], r3 = [], i = { ImportDeclaration: GB(e28, t3, n3, r3) };
  return t3 && (i.ExportNamedDeclaration = y2(e28, n3, r3), i.ExportAllDeclaration = y2(e28, n3, r3)), i;
} }, bf = function() {
  function e28(t3, n3) {
    We$1(this, e28), this.fixer = t3, this.sourceCode = n3, this.retainedRange = null;
  }
  return Xe$1(e28, [{ key: "retainRange", value: function(t3) {
    return this.retainedRange = t3, this;
  } }, { key: "retainEnclosingFunction", value: function(t3) {
    var n3 = P$s.getUpperFunction(t3);
    return this.retainRange(n3 ? n3.range : this.sourceCode.ast.range);
  } }, { key: "retainSurroundingTokens", value: function(t3) {
    var n3 = this.sourceCode.getTokenBefore(t3) || t3, r3 = this.sourceCode.getTokenAfter(t3) || t3;
    return this.retainRange([n3.range[0], r3.range[1]]);
  } }, { key: "replaceTextRange", value: function(t3, n3) {
    var r3;
    return r3 = this.retainedRange ? [Math.min(this.retainedRange[0], t3[0]), Math.max(this.retainedRange[1], t3[1])] : t3, this.fixer.replaceTextRange(r3, this.sourceCode.text.slice(r3[0], t3[0]) + n3 + this.sourceCode.text.slice(t3[1], r3[1]));
  } }, { key: "remove", value: function(t3) {
    return this.replaceTextRange(t3.range, "");
  } }]), e28;
}(), HB = { meta: { type: "suggestion", docs: { description: "disallow `else` blocks after `return` statements in `if` statements", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-else-return" }, schema: [{ type: "object", properties: { allowElseIf: { type: "boolean", default: true } }, additionalProperties: false }], fixable: "code", messages: { unexpected: "Unnecessary 'else' after 'return'." } }, create: function(e28) {
  function t3(o3, u3) {
    if (o3.type === "FunctionDeclaration")
      return false;
    if (o3.type !== "BlockStatement")
      return true;
    var c3 = u3.childScopes.find(function(f3) {
      return f3.block === o3;
    });
    return !c3 || function(f3, p3) {
      if (f3.length === 0)
        return true;
      var d3 = p3.variableScope;
      if (p3.variables.filter(function(y3) {
        return 0 < y3.defs.length;
      }).some(function(y3) {
        var v3 = y3.name;
        return f3.includes(v3);
      }) || p3 !== d3 && p3.upper.type === "catch" && p3.upper.variables.some(function(y3) {
        var v3 = y3.name;
        return f3.includes(v3);
      }) || p3.variables.filter(function(y3) {
        var v3 = y3.defs, b3 = y3.references;
        return v3.length === 0 && 0 < b3.length;
      }).some(function(y3) {
        var v3 = y3.name;
        return f3.includes(v3);
      }) || p3.through.some(function(y3) {
        return f3.includes(y3.identifier.name);
      }))
        return false;
      if (p3 !== d3) {
        var m3 = p3.block.range;
        if (d3.variables.filter(function(y3) {
          var v3 = y3.name;
          return f3.includes(v3);
        }).some(function(y3) {
          return y3.defs.some(function(v3) {
            var b3 = v3.node.range;
            return m3[0] <= b3[0] && b3[1] <= m3[1];
          });
        }))
          return false;
      }
      return true;
    }(c3.variables.map(function(f3) {
      return f3.name;
    }), u3);
  }
  function n3(o3) {
    var u3 = e28.getScope();
    e28.report({ node: o3, messageId: "unexpected", fix: function(c3) {
      if (!t3(o3, u3))
        return null;
      var f3, p3, d3 = e28.getSourceCode(), m3 = d3.getFirstToken(o3), y3 = d3.getTokenBefore(m3), v3 = d3.getText(o3), b3 = d3.getTokenBefore(y3);
      p3 = m3.type === "Punctuator" && m3.value === "{" ? d3.getTokenAfter(m3) : m3;
      var x3 = o3.parent.consequent.type !== "BlockStatement" && b3.value !== ";", C3 = /^[\(\+\x2D\/\[`]/.test(p3.value);
      if (x3 && C3)
        return null;
      var k3 = d3.getLastToken(o3), F3 = d3.getTokenBefore(k3);
      if (F3.value !== ";") {
        var B3 = d3.getTokenAfter(k3), O3 = B3 && /^[\(\+\x2D\/\[`]/.test(B3.value), S3 = B3 && B3.loc.start.line === F3.loc.start.line;
        if (O3 || S3 && B3.value !== "}")
          return null;
      }
      return f3 = m3.type === "Punctuator" && m3.value === "{" ? v3.slice(1, -1) : v3, new bf(c3, d3).retainEnclosingFunction(o3).replaceTextRange([y3.range[0], o3.range[1]], f3);
    } });
  }
  function r3(o3) {
    return o3.type === "ReturnStatement";
  }
  function i(o3) {
    if (o3.type === "BlockStatement") {
      var u3 = o3.body, c3 = u3[u3.length - 1];
      return c3 && r3(c3);
    }
    return r3(o3);
  }
  function a3(o3) {
    return r3(o3) || function(u3) {
      return u3.type === "IfStatement" && function(c3) {
        return c3.alternate && c3.consequent;
      }(u3) && i(u3.alternate) && i(u3.consequent);
    }(o3);
  }
  function s3(o3) {
    return o3.type === "BlockStatement" ? o3.body.some(a3) : a3(o3);
  }
  return { "IfStatement:exit": e28.options[0] && e28.options[0].allowElseIf === false ? function(o3) {
    var u3 = o3.parent;
    if (P$s.STATEMENT_LIST_PARENTS.has(u3.type)) {
      var c3 = o3.alternate;
      c3 && s3(o3.consequent) && n3(c3);
    }
  } : function(o3) {
    var u3 = o3.parent;
    if (P$s.STATEMENT_LIST_PARENTS.has(u3.type)) {
      for (var c3, f3 = [], p3 = o3; p3.type === "IfStatement"; p3 = p3.alternate) {
        if (!p3.alternate)
          return;
        f3.push(p3.consequent), c3 = p3.alternate;
      }
      f3.every(s3) && n3(c3);
    }
  } };
} }, KB = /^\/((?:[\0-Z\]-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\[((?:[\0-\[\^-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))+\])*\/[gimsuy]*$/, JB = { meta: { type: "problem", docs: { description: "disallow empty character classes in regular expressions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-empty-character-class" }, schema: [], messages: { unexpected: "Empty class." } }, create: function(e28) {
  var t3 = e28.getSourceCode();
  return { Literal: function(n3) {
    var r3 = t3.getFirstToken(n3);
    r3.type !== "RegularExpression" || KB.test(r3.value) || e28.report({ node: n3, messageId: "unexpected" });
  } };
} }, QB = { meta: { type: "suggestion", docs: { description: "disallow empty functions", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-empty-function" }, schema: [{ type: "object", properties: { allow: { type: "array", items: { enum: Object.freeze(["functions", "arrowFunctions", "generatorFunctions", "methods", "generatorMethods", "getters", "setters", "constructors"]) }, uniqueItems: true } }, additionalProperties: false }], messages: { unexpected: "Unexpected empty {{name}}." } }, create: function(e28) {
  function t3(i) {
    var a3 = function(u3) {
      var c3 = u3.parent, f3 = "";
      if (u3.type === "ArrowFunctionExpression")
        return "arrowFunctions";
      if (c3.type === "Property") {
        if (c3.kind === "get")
          return "getters";
        if (c3.kind === "set")
          return "setters";
        f3 = c3.method ? "methods" : "functions";
      } else if (c3.type === "MethodDefinition") {
        if (c3.kind === "get")
          return "getters";
        if (c3.kind === "set")
          return "setters";
        if (c3.kind === "constructor")
          return "constructors";
        f3 = "methods";
      } else
        f3 = "functions";
      var p3 = "";
      if (u3.generator)
        p3 = "generator";
      else {
        if (!u3.async)
          return f3;
        p3 = "async";
      }
      return p3 + f3[0].toUpperCase() + f3.slice(1);
    }(i), s3 = P$s.getFunctionNameWithKind(i), o3 = r3.getTokens(i.body, { includeComments: true, filter: P$s.isCommentToken });
    n3.indexOf(a3) === -1 && i.body.type === "BlockStatement" && i.body.body.length === 0 && o3.length === 0 && e28.report({ node: i, loc: i.body.loc.start, messageId: "unexpected", data: { name: s3 } });
  }
  var n3 = (e28.options[0] || {}).allow || [], r3 = e28.getSourceCode();
  return { ArrowFunctionExpression: t3, FunctionDeclaration: t3, FunctionExpression: t3 };
} }, XB = { meta: { type: "suggestion", docs: { description: "disallow empty block statements", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-empty" }, schema: [{ type: "object", properties: { allowEmptyCatch: { type: "boolean", default: false } }, additionalProperties: false }], messages: { unexpected: "Empty {{type}} statement." } }, create: function(e28) {
  var t3 = (e28.options[0] || {}).allowEmptyCatch || false, n3 = e28.getSourceCode();
  return { BlockStatement: function(r3) {
    r3.body.length !== 0 || P$s.isFunction(r3.parent) || t3 && r3.parent.type === "CatchClause" || 0 < n3.getCommentsInside(r3).length || e28.report({ node: r3, messageId: "unexpected", data: { type: "block" } });
  }, SwitchStatement: function(r3) {
    (r3.cases === void 0 || r3.cases.length === 0) && e28.report({ node: r3, messageId: "unexpected", data: { type: "switch" } });
  } };
} }, v2 = Object.freeze(["global", "window"]);
function p0(e28, t3) {
  return e28.type === "Identifier" && e28.name === t3;
}
function YB(e28, t3) {
  switch (e28.type) {
    case "Literal":
      return e28.value === t3;
    case "TemplateLiteral":
      return e28.expressions.length === 0 && e28.quasis[0].value.cooked === t3;
    default:
      return false;
  }
}
function Zd(e28, t3) {
  return e28.type === "MemberExpression" && (e28.computed ? YB : p0)(e28.property, t3);
}
var ZB = { meta: { type: "suggestion", docs: { description: "disallow the use of `eval()`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-eval" }, schema: [{ type: "object", properties: { allowIndirect: { type: "boolean", default: false } }, additionalProperties: false }], messages: { unexpected: "eval can be harmful." } }, create: function(e28) {
  function t3(o3) {
    var u3 = e28.getScope().isStrict;
    s3 = { upper: s3, node: o3, strict: u3, defaultThis: false, initialized: u3 };
  }
  function n3() {
    s3 = s3.upper;
  }
  function r3(o3) {
    var u3 = o3.parent, c3 = o3.type === "MemberExpression" ? o3.property : o3, f3 = u3.type === "CallExpression" && u3.callee === o3 ? u3 : o3;
    e28.report({ node: f3, loc: c3.loc.start, messageId: "unexpected" });
  }
  var i = !(!e28.options[0] || !e28.options[0].allowIndirect), a3 = e28.getSourceCode(), s3 = null;
  return i ? { "CallExpression:exit": function(o3) {
    var u3 = o3.callee;
    p0(u3, "eval") && r3(u3);
  } } : { "CallExpression:exit": function(o3) {
    var u3 = o3.callee;
    p0(u3, "eval") && r3(u3);
  }, Program: function(o3) {
    var u3 = e28.getScope(), c3 = e28.parserOptions.ecmaFeatures || {}, f3 = u3.isStrict || o3.sourceType === "module" || c3.globalReturn && u3.childScopes[0].isStrict;
    s3 = { upper: null, node: o3, strict: f3, defaultThis: true, initialized: true };
  }, "Program:exit": function() {
    var o3 = e28.getScope();
    n3(), function(u3) {
      var c3 = P$s.getVariableByName(u3, "eval");
      if (c3)
        for (var f3 = c3.references, p3 = 0; p3 < f3.length; ++p3) {
          var d3 = f3[p3].identifier;
          d3.name !== "eval" || P$s.isCallee(d3) || r3(d3);
        }
    }(o3), function(u3) {
      for (var c3 = 0; c3 < v2.length; ++c3) {
        var f3 = v2[c3], p3 = P$s.getVariableByName(u3, f3);
        if (p3)
          for (var d3 = p3.references, m3 = 0; m3 < d3.length; ++m3) {
            for (var y3 = d3[m3].identifier.parent; Zd(y3, f3); )
              y3 = y3.parent;
            Zd(y3, "eval") && r3(y3);
          }
      }
    }(o3);
  }, FunctionDeclaration: t3, "FunctionDeclaration:exit": n3, FunctionExpression: t3, "FunctionExpression:exit": n3, ArrowFunctionExpression: t3, "ArrowFunctionExpression:exit": n3, ThisExpression: function(o3) {
    Zd(o3.parent, "eval") && (!s3.initialized && (s3.initialized = true, s3.defaultThis = P$s.isDefaultThisBinding(s3.node, a3)), !s3.strict && s3.defaultThis && r3(o3.parent));
  } };
} }, eO = { meta: { type: "problem", docs: { description: "disallow reassigning exceptions in `catch` clauses", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-ex-assign" }, schema: [], messages: { unexpected: "Do not assign to the exception parameter." } }, create: function(e28) {
  function t3(n3) {
    P$s.getModifyingReferences(n3.references).forEach(function(r3) {
      e28.report({ node: r3.identifier, messageId: "unexpected" });
    });
  }
  return { CatchClause: function(n3) {
    e28.getDeclaredVariables(n3).forEach(t3);
  } };
} }, tO = /* @__PURE__ */ new Set(["defineProperty", "defineProperties"]), nO = { meta: { type: "suggestion", docs: { description: "disallow extending native types", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-extend-native" }, schema: [{ type: "object", properties: { exceptions: { type: "array", items: { type: "string" }, uniqueItems: true } }, additionalProperties: false }], messages: { unexpected: "{{builtin}} prototype is read only, properties should not be added." } }, create: function(e28) {
  function t3(o3, u3) {
    e28.report({ node: o3, messageId: "unexpected", data: { builtin: u3 } });
  }
  function n3(o3) {
    return !(!o3 || !o3.parent || o3.parent.type !== "MemberExpression" || o3.parent.object !== o3 || P$s.getStaticPropertyName(o3.parent) !== "prototype");
  }
  function r3(o3) {
    (function(u3) {
      return !(!n3(u3) || u3.parent.parent.type !== "MemberExpression" || u3.parent.parent.parent.type !== "AssignmentExpression" || u3.parent.parent.parent.left !== u3.parent.parent);
    })(o3) ? t3(o3.parent.parent.parent, o3.name) : function(u3) {
      return !(!n3(u3) || u3.parent.parent.type !== "CallExpression" || u3.parent.parent.arguments[0] !== u3.parent || u3.parent.parent.callee.type !== "MemberExpression" || u3.parent.parent.callee.object.type !== "Identifier" || u3.parent.parent.callee.object.name !== "Object" || u3.parent.parent.callee.property.type !== "Identifier" || !tO.has(u3.parent.parent.callee.property.name));
    }(o3) && t3(o3.parent.parent, o3.name);
  }
  var i = e28.options[0] || {}, a3 = new Set(i.exceptions || []), s3 = new Set(Object.keys(ye$4.globals.builtin).filter(function(o3) {
    return o3[0].toUpperCase() === o3[0];
  }).filter(function(o3) {
    return !a3.has(o3);
  }));
  return { "Program:exit": function() {
    var o3 = e28.getScope();
    s3.forEach(function(u3) {
      var c3 = o3.set.get(u3);
      c3 && c3.references && c3.references.map(function(f3) {
        return f3.identifier;
      }).forEach(r3);
    });
  } };
} }, rO = /* @__PURE__ */ new Set(["Literal", "Identifier", "ThisExpression", "FunctionExpression"]), iO = { meta: { type: "suggestion", docs: { description: "disallow unnecessary calls to `.bind()`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-extra-bind" }, schema: [], fixable: "code", messages: { unexpected: "The function binding is unnecessary." } }, create: function(e28) {
  function t3(o3) {
    e28.report({ node: o3.parent.parent, messageId: "unexpected", loc: o3.parent.property.loc.start, fix: function(u3) {
      if (o3.parent.parent.arguments.length && !function(p3) {
        return rO.has(p3.type);
      }(o3.parent.parent.arguments[0]))
        return null;
      var c3 = a3.getFirstTokenBetween(o3.parent.object, o3.parent.property, P$s.isNotClosingParenToken), f3 = a3.getLastToken(o3.parent.parent);
      return a3.commentsExistBetween(c3, f3) ? null : u3.removeRange([c3.range[0], o3.parent.parent.range[1]]);
    } });
  }
  function n3(o3) {
    var u3 = o3.parent, c3 = u3.parent;
    return c3 && c3.type === "CallExpression" && c3.callee === u3 && c3.arguments.length === 1 && c3.arguments[0].type !== "SpreadElement" && u3.type === "MemberExpression" && u3.object === o3 && P$s.getStaticPropertyName(u3) === "bind";
  }
  function r3(o3) {
    s3 = { isBound: n3(o3), thisFound: false, upper: s3 };
  }
  function i(o3) {
    s3.isBound && !s3.thisFound && t3(o3), s3 = s3.upper;
  }
  var a3 = e28.getSourceCode(), s3 = null;
  return { "ArrowFunctionExpression:exit": function(o3) {
    n3(o3) && t3(o3);
  }, FunctionDeclaration: r3, "FunctionDeclaration:exit": i, FunctionExpression: r3, "FunctionExpression:exit": i, ThisExpression: function() {
    s3 && (s3.thisFound = true);
  } };
} }, aO = { meta: { type: "suggestion", docs: { description: "disallow unnecessary boolean casts", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-extra-boolean-cast" }, schema: [], fixable: "code", messages: { unexpectedCall: "Redundant Boolean call.", unexpectedNegation: "Redundant double negation." } }, create: function(e28) {
  function t3(a3, s3) {
    return i.indexOf(s3.type) !== -1 && a3 === s3.test || s3.type === "UnaryExpression" && s3.operator === "!";
  }
  function n3(a3) {
    return !!r3.getCommentsInside(a3).length;
  }
  var r3 = e28.getSourceCode(), i = ["IfStatement", "DoWhileStatement", "WhileStatement", "ConditionalExpression", "ForStatement"];
  return { UnaryExpression: function(a3) {
    var s3 = e28.getAncestors(), o3 = s3.pop(), u3 = s3.pop();
    a3.operator !== "!" || o3.type !== "UnaryExpression" || o3.operator !== "!" || (t3(o3, u3) || (u3.type === "CallExpression" || u3.type === "NewExpression") && u3.callee.type === "Identifier" && u3.callee.name === "Boolean") && e28.report({ node: o3, messageId: "unexpectedNegation", fix: function(c3) {
      if (n3(o3))
        return null;
      var f3 = "", p3 = r3.getTokenBefore(o3), d3 = r3.getFirstToken(a3.argument);
      return p3 && p3.range[1] === o3.range[0] && !P$s.canTokensBeAdjacent(p3, d3) && (f3 = " "), c3.replaceText(o3, f3 + r3.getText(a3.argument));
    } });
  }, CallExpression: function(a3) {
    var s3 = a3.parent;
    a3.callee.type !== "Identifier" || a3.callee.name !== "Boolean" || t3(a3, s3) && e28.report({ node: a3, messageId: "unexpectedCall", fix: function(o3) {
      if (!a3.arguments.length) {
        if (s3.type === "UnaryExpression" && s3.operator === "!") {
          if (n3(s3))
            return null;
          var u3 = "", c3 = r3.getTokenBefore(s3);
          return c3 && c3.range[1] === s3.range[0] && !P$s.canTokensBeAdjacent(c3, "true") && (u3 = " "), o3.replaceText(s3, u3 + "true");
        }
        return n3(a3) ? null : o3.replaceText(a3, "false");
      }
      if (1 < a3.arguments.length || a3.arguments[0].type === "SpreadElement" || n3(a3))
        return null;
      var f3 = a3.arguments[0];
      return P$s.getPrecedence(f3) < P$s.getPrecedence(a3.parent) ? o3.replaceText(a3, "(".concat(r3.getText(f3), ")")) : o3.replaceText(a3, r3.getText(f3));
    } });
  } };
} }, oO = { meta: { type: "suggestion", docs: { description: "disallow unnecessary labels", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-extra-label" }, schema: [], fixable: "code", messages: { unexpected: "This label '{{name}}' is unnecessary." } }, create: function(e28) {
  function t3(s3) {
    a3 = { label: s3.parent.type === "LabeledStatement" ? s3.parent.label : null, breakable: true, upper: a3 };
  }
  function n3() {
    a3 = a3.upper;
  }
  function r3(s3) {
    if (s3.label) {
      for (var o3 = s3.label, u3 = a3; u3 !== null; u3 = u3.upper)
        if (u3.breakable || u3.label && u3.label.name === o3.name)
          return void (u3.breakable && u3.label && u3.label.name === o3.name && e28.report({ node: o3, messageId: "unexpected", data: o3, fix: function(c3) {
            var f3 = i.getFirstToken(s3);
            return i.commentsExistBetween(f3, o3) ? null : c3.removeRange([f3.range[1], o3.range[1]]);
          } }));
    }
  }
  var i = e28.getSourceCode(), a3 = null;
  return { WhileStatement: t3, "WhileStatement:exit": n3, DoWhileStatement: t3, "DoWhileStatement:exit": n3, ForStatement: t3, "ForStatement:exit": n3, ForInStatement: t3, "ForInStatement:exit": n3, ForOfStatement: t3, "ForOfStatement:exit": n3, SwitchStatement: t3, "SwitchStatement:exit": n3, LabeledStatement: function(s3) {
    P$s.isBreakableStatement(s3.body) || (a3 = { label: s3.label, breakable: false, upper: a3 });
  }, "LabeledStatement:exit": function(s3) {
    P$s.isBreakableStatement(s3.body) || (a3 = a3.upper);
  }, BreakStatement: r3, ContinueStatement: r3 };
} }, x2 = ye$4.require$$0.isParenthesized, sO = { meta: { type: "layout", docs: { description: "disallow unnecessary parentheses", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-extra-parens" }, fixable: "code", schema: { anyOf: [{ type: "array", items: [{ enum: ["functions"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["all"] }, { type: "object", properties: { conditionalAssign: { type: "boolean" }, nestedBinaryExpressions: { type: "boolean" }, returnAssign: { type: "boolean" }, ignoreJSX: { enum: ["none", "all", "single-line", "multi-line"] }, enforceForArrowConditionals: { type: "boolean" }, enforceForSequenceExpressions: { type: "boolean" }, enforceForNewInMemberExpressions: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }] }, messages: { unexpected: "Unnecessary parentheses around expression." } }, create: function(e28) {
  function t3(A3) {
    if (A3.type === "JSXElement" || A3.type === "JSXFragment") {
      var M3 = A3.loc.start.line === A3.loc.end.line;
      switch (W3) {
        case "all":
          return false;
        case "multi-line":
          return M3;
        case "single-line":
          return !M3;
      }
    }
    return !(A3.type === "SequenceExpression" && q3) && (I3 || A3.type === "FunctionExpression" || A3.type === "ArrowFunctionExpression");
  }
  function n3(A3) {
    return x2(1, A3, S3);
  }
  function r3(A3) {
    return x2(2, A3, S3);
  }
  function i(A3) {
    return t3(A3) && n3(A3);
  }
  function a3(A3) {
    return t3(A3) && r3(A3);
  }
  function s3(A3) {
    return L3 && A3.test.type === "AssignmentExpression";
  }
  function o3(A3) {
    var M3 = S3.getLastToken(A3), ne2 = S3.getTokenBefore(M3);
    return 0 < A3.arguments.length || P$s.isOpeningParenToken(ne2) && P$s.isClosingParenToken(M3) && A3.callee.range[1] < A3.range[1];
  }
  function u3(A3) {
    return !(A3.type !== "AssignmentExpression" && (A3.type !== "ConditionalExpression" || A3.consequent.type !== "AssignmentExpression" && A3.alternate.type !== "AssignmentExpression") && !(A3.left && A3.left.type === "AssignmentExpression" || A3.right && A3.right.type === "AssignmentExpression"));
  }
  function c3(A3) {
    return !(!K3 || !function(M3) {
      for (var ne2 = M3; ne2; ne2 = ne2.parent)
        if (ne2.type === "ReturnStatement" || ne2.type === "ArrowFunctionExpression" && ne2.body.type !== "BlockStatement")
          return true;
      return false;
    }(A3)) && (A3.type === "ReturnStatement" ? A3.argument && u3(A3.argument) : A3.type === "ArrowFunctionExpression" && A3.body.type !== "BlockStatement" ? u3(A3.body) : u3(A3));
  }
  function f3(A3, M3) {
    return A3.loc.end.line === M3.loc.start.line ? i(M3) : a3(M3);
  }
  function p3(A3) {
    return A3.type === "CallExpression" && A3.callee.type === "FunctionExpression";
  }
  function d3(A3) {
    function M3() {
      e28.report({ node: A3, loc: ne2.loc, messageId: "unexpected", fix: function(he2) {
        var j3 = S3.text.slice(ne2.range[1], de2.range[0]);
        return he2.replaceTextRange([ne2.range[0], de2.range[1]], (function(ie2) {
          var fe2 = S3.getTokenBefore(ie2), ge2 = S3.getTokenBefore(ie2, 1), Fe2 = S3.getFirstToken(ie2);
          return ge2 && ge2.range[1] === fe2.range[0] && fe2.range[1] === Fe2.range[0] && !P$s.canTokensBeAdjacent(ge2, Fe2);
        }(A3) ? " " : "") + j3 + (function(ie2) {
          var fe2 = S3.getTokensAfter(ie2, { count: 2 }), ge2 = fe2[0], Fe2 = fe2[1], Pe2 = S3.getLastToken(ie2);
          return ge2 && Fe2 && !S3.isSpaceBetweenTokens(ge2, Fe2) && !P$s.canTokensBeAdjacent(Pe2, Fe2);
        }(A3) ? " " : ""));
      } });
    }
    var ne2 = S3.getTokenBefore(A3), de2 = S3.getTokenAfter(A3);
    if (!(!r3(A3) && (w3.has(S3.getFirstToken(A3)) || p3(A3) && !n3(A3.callee))))
      return O3 ? void O3.reports.push({ node: A3, finishReport: M3 }) : void M3();
  }
  function m3(A3) {
    A3.type === "UnaryExpression" && A3.argument.type === "BinaryExpression" && A3.argument.operator === "**" || i(A3.argument) && D3(A3.argument) >= D3(A3) && d3(A3.argument);
  }
  function y3(A3) {
    var M3 = A3.callee;
    if (i(M3) && D3(M3) >= D3(A3)) {
      var ne2 = M3.type === "NewExpression" && !o3(M3);
      !a3(M3) && (p3(A3) || ne2 || M3.type === "MemberExpression" && function(de2) {
        for (var he2 = de2.object, j3 = de2.object.type; j3 === "MemberExpression"; )
          j3 = (he2 = he2.object).type;
        return j3 === "CallExpression";
      }(M3)) || d3(A3.callee);
    }
    A3.arguments.filter(function(de2) {
      return i(de2) && D3(de2) >= X3;
    }).forEach(d3);
  }
  function v3(A3) {
    var M3 = D3(A3), ne2 = D3(A3.left), de2 = D3(A3.right), he2 = A3.operator === "**", j3 = V10 && (A3.left.type === "BinaryExpression" || A3.left.type === "LogicalExpression") || A3.left.type === "UnaryExpression" && he2, ie2 = V10 && (A3.right.type === "BinaryExpression" || A3.right.type === "LogicalExpression");
    !j3 && i(A3.left) && (ne2 > M3 || ne2 === M3 && !he2) && d3(A3.left), !ie2 && i(A3.right) && (de2 > M3 || de2 === M3 && he2) && d3(A3.right);
  }
  function b3(A3) {
    A3.superClass && (D3(A3.superClass) > ce2 ? i(A3.superClass) : a3(A3.superClass)) && d3(A3.superClass);
  }
  function x3(A3) {
    (D3(A3.argument) >= X3 ? i(A3.argument) : a3(A3.argument)) && d3(A3.argument);
  }
  function C3(A3) {
    var M3 = n3(A3) ? S3.getTokenBefore(A3) : S3.getFirstToken(A3), ne2 = S3.getTokenAfter(M3, P$s.isNotOpeningParenToken), de2 = ne2 ? S3.getTokenAfter(ne2) : null, he2 = ne2 ? S3.getTokenAfter(ne2, P$s.isNotClosingParenToken) : null;
    P$s.isOpeningParenToken(M3) && (P$s.isOpeningBraceToken(ne2) || ne2.type === "Keyword" && (ne2.value === "function" || ne2.value === "class" || ne2.value === "let" && he2 && (P$s.isOpeningBracketToken(he2) || he2.type === "Identifier")) || ne2 && ne2.type === "Identifier" && ne2.value === "async" && de2 && de2.type === "Keyword" && de2.value === "function") && w3.add(ne2), i(A3) && d3(A3);
  }
  function k3(A3, M3) {
    return function(ne2, de2) {
      for (var he2 = [ne2], j3 = ne2; j3 !== de2; ) {
        if ((j3 = j3.parent) === null)
          throw new Error("Nodes are not in the ancestor-descendant relationship.");
        he2.push(j3);
      }
      return he2;
    }(M3, A3).reverse();
  }
  function F3(A3, M3) {
    switch (A3.type) {
      case "ArrayExpression":
      case "ArrayPattern":
      case "BlockStatement":
      case "ObjectExpression":
      case "ObjectPattern":
      case "TemplateLiteral":
        return true;
      case "ArrowFunctionExpression":
      case "FunctionExpression":
        return A3.params.includes(M3);
      case "CallExpression":
      case "NewExpression":
        return A3.arguments.includes(M3);
      case "MemberExpression":
        return A3.computed && A3.property === M3;
      case "ConditionalExpression":
        return A3.consequent === M3;
      default:
        return false;
    }
  }
  function B3(A3) {
    return O3.reports.some(function(M3) {
      return M3.node === A3;
    });
  }
  var O3, S3 = e28.getSourceCode(), w3 = /* @__PURE__ */ new WeakSet(), D3 = P$s.getPrecedence, I3 = e28.options[0] !== "functions", L3 = I3 && e28.options[1] && e28.options[1].conditionalAssign === false, V10 = I3 && e28.options[1] && e28.options[1].nestedBinaryExpressions === false, K3 = I3 && e28.options[1] && e28.options[1].returnAssign === false, W3 = I3 && e28.options[1] && e28.options[1].ignoreJSX, R3 = I3 && e28.options[1] && e28.options[1].enforceForArrowConditionals === false, q3 = I3 && e28.options[1] && e28.options[1].enforceForSequenceExpressions === false, J3 = I3 && e28.options[1] && e28.options[1].enforceForNewInMemberExpressions === false, X3 = D3({ type: "AssignmentExpression" }), ce2 = D3({ type: "UpdateExpression" });
  return { ArrayExpression: function(A3) {
    A3.elements.filter(function(M3) {
      return M3 && i(M3) && D3(M3) >= X3;
    }).forEach(d3);
  }, ArrowFunctionExpression: function(A3) {
    if (!c3(A3) && (A3.body.type !== "ConditionalExpression" || !R3 || r3(A3.body)) && A3.body.type !== "BlockStatement") {
      var M3 = S3.getFirstToken(A3.body, P$s.isNotOpeningParenToken), ne2 = S3.getTokenBefore(M3);
      P$s.isOpeningParenToken(ne2) && P$s.isOpeningBraceToken(M3) && w3.add(M3), i(A3.body) && D3(A3.body) >= X3 && d3(A3.body);
    }
  }, AssignmentExpression: function(A3) {
    c3(A3) || i(A3.right) && D3(A3.right) >= D3(A3) && d3(A3.right);
  }, BinaryExpression: function(A3) {
    O3 && A3.operator === "in" && O3.inExpressionNodes.push(A3), v3(A3);
  }, CallExpression: y3, ClassBody: function(A3) {
    A3.body.filter(function(M3) {
      return M3.type === "MethodDefinition" && M3.computed && M3.key && i(M3.key) && D3(M3.key) >= X3;
    }).forEach(function(M3) {
      return d3(M3.key);
    });
  }, ConditionalExpression: function(A3) {
    c3(A3) || (i(A3.test) && D3(A3.test) >= D3({ type: "LogicalExpression", operator: "||" }) && d3(A3.test), i(A3.consequent) && D3(A3.consequent) >= X3 && d3(A3.consequent), i(A3.alternate) && D3(A3.alternate) >= X3 && d3(A3.alternate));
  }, DoWhileStatement: function(A3) {
    i(A3.test) && !s3(A3) && d3(A3.test);
  }, ExportDefaultDeclaration: function(A3) {
    return C3(A3.declaration);
  }, ExpressionStatement: function(A3) {
    return C3(A3.expression);
  }, "ForInStatement, ForOfStatement": function(A3) {
    if (A3.left.type !== "VariableDeclarator") {
      var M3 = S3.getFirstToken(A3.left, P$s.isNotOpeningParenToken);
      M3.value === "let" && (M3.range[1] === A3.left.range[1] || P$s.isOpeningBracketToken(S3.getTokenAfter(M3, P$s.isNotClosingParenToken))) && w3.add(M3);
    }
    (A3.type !== "ForOfStatement" || A3.right.type !== "SequenceExpression") && i(A3.right) && d3(A3.right), i(A3.left) && d3(A3.left);
  }, ForStatement: function(A3) {
    A3.test && i(A3.test) && !s3(A3) && d3(A3.test), A3.update && i(A3.update) && d3(A3.update), A3.init && (O3 = { upper: O3, inExpressionNodes: [], reports: [] }, i(A3.init) && d3(A3.init));
  }, "ForStatement > *.init:exit": function(A3) {
    O3.reports.length && O3.inExpressionNodes.forEach(function(M3) {
      for (var ne2, de2 = k3(A3, M3), he2 = 0; he2 < de2.length; he2++) {
        var j3 = de2[he2];
        if (he2 < de2.length - 1 && F3(j3, de2[he2 + 1]))
          return;
        if (n3(j3)) {
          if (!B3(j3) || r3(j3))
            return;
          ne2 || (ne2 = j3);
        }
      }
      (function(ie2) {
        O3.reports = O3.reports.filter(function(fe2) {
          return fe2.node !== ie2;
        });
      })(ne2);
    }), function() {
      var M3, ne2, de2 = O3, he2 = de2.upper, j3 = de2.inExpressionNodes, ie2 = de2.reports;
      he2 ? ((M3 = he2.inExpressionNodes).push.apply(M3, Mt$2(j3)), (ne2 = he2.reports).push.apply(ne2, Mt$2(ie2))) : ie2.forEach(function(fe2) {
        return (0, fe2.finishReport)();
      }), O3 = he2;
    }();
  }, IfStatement: function(A3) {
    i(A3.test) && !s3(A3) && d3(A3.test);
  }, ImportExpression: function(A3) {
    var M3 = A3.source;
    M3.type === "SequenceExpression" ? a3(M3) && d3(M3) : i(M3) && d3(M3);
  }, LogicalExpression: v3, MemberExpression: function(A3) {
    var M3 = i(A3.object);
    M3 && D3(A3.object) >= D3(A3) && (A3.computed || !(P$s.isDecimalInteger(A3.object) || A3.object.type === "Literal" && A3.object.regex)) && d3(A3.object), M3 && A3.object.type === "CallExpression" && A3.parent.type !== "NewExpression" && d3(A3.object), M3 && !J3 && A3.object.type === "NewExpression" && o3(A3.object) && d3(A3.object), A3.computed && i(A3.property) && d3(A3.property);
  }, NewExpression: y3, ObjectExpression: function(A3) {
    A3.properties.filter(function(M3) {
      var ne2 = M3.value;
      return ne2 && i(ne2) && D3(ne2) >= X3;
    }).forEach(function(M3) {
      return d3(M3.value);
    });
  }, Property: function(A3) {
    if (A3.computed) {
      var M3 = A3.key;
      M3 && i(M3) && D3(M3) >= X3 && d3(M3);
    }
  }, ReturnStatement: function(A3) {
    var M3 = S3.getFirstToken(A3);
    c3(A3) || A3.argument && f3(M3, A3.argument) && (A3.argument.type !== "Literal" || !A3.argument.regex) && d3(A3.argument);
  }, SequenceExpression: function(A3) {
    A3.expressions.filter(function(M3) {
      return i(M3) && D3(M3) >= D3(A3);
    }).forEach(d3);
  }, SwitchCase: function(A3) {
    A3.test && i(A3.test) && d3(A3.test);
  }, SwitchStatement: function(A3) {
    i(A3.discriminant) && d3(A3.discriminant);
  }, ThrowStatement: function(A3) {
    f3(S3.getFirstToken(A3), A3.argument) && d3(A3.argument);
  }, UnaryExpression: m3, UpdateExpression: m3, AwaitExpression: m3, VariableDeclarator: function(A3) {
    A3.init && i(A3.init) && D3(A3.init) >= X3 && (A3.init.type !== "Literal" || !A3.init.regex) && d3(A3.init);
  }, WhileStatement: function(A3) {
    i(A3.test) && !s3(A3) && d3(A3.test);
  }, WithStatement: function(A3) {
    i(A3.object) && d3(A3.object);
  }, YieldExpression: function(A3) {
    if (A3.argument) {
      var M3 = S3.getFirstToken(A3);
      (D3(A3.argument) >= D3(A3) && f3(M3, A3.argument) || a3(A3.argument)) && d3(A3.argument);
    }
  }, ClassDeclaration: b3, ClassExpression: b3, SpreadElement: x3, SpreadProperty: x3, ExperimentalSpreadProperty: x3, TemplateLiteral: function(A3) {
    A3.expressions.filter(function(M3) {
      return M3 && i(M3);
    }).forEach(d3);
  }, AssignmentPattern: function(A3) {
    var M3 = A3.right;
    M3 && i(M3) && D3(M3) >= X3 && d3(M3);
  } };
} }, uO = { meta: { type: "suggestion", docs: { description: "disallow unnecessary semicolons", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-extra-semi" }, fixable: "code", schema: [], messages: { unexpected: "Unnecessary semicolon." } }, create: function(e28) {
  function t3(i) {
    e28.report({ node: i, messageId: "unexpected", fix: function(a3) {
      return new bf(a3, e28.getSourceCode()).retainSurroundingTokens(i).remove(i);
    } });
  }
  function n3(i) {
    for (var a3 = i; a3.type === "Punctuator" && !P$s.isClosingBraceToken(a3); a3 = r3.getTokenAfter(a3))
      P$s.isSemicolonToken(a3) && t3(a3);
  }
  var r3 = e28.getSourceCode();
  return { EmptyStatement: function(i) {
    var a3 = i.parent;
    ["ForStatement", "ForInStatement", "ForOfStatement", "WhileStatement", "DoWhileStatement", "IfStatement", "LabeledStatement", "WithStatement"].indexOf(a3.type) === -1 && t3(i);
  }, ClassBody: function(i) {
    n3(r3.getFirstToken(i, 1));
  }, MethodDefinition: function(i) {
    n3(r3.getTokenAfter(i));
  } };
} }, cO = /fall[s\u017F]?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?through/i;
function lO(e28) {
  return e28.reachable;
}
var pO = { meta: { type: "problem", docs: { description: "disallow fallthrough of `case` statements", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-fallthrough" }, schema: [{ type: "object", properties: { commentPattern: { type: "string", default: "" } }, additionalProperties: false }], messages: { case: "Expected a 'break' statement before 'case'.", default: "Expected a 'break' statement before 'default'." } }, create: function(e28) {
  var t3, n3 = e28.options[0] || {}, r3 = null, i = e28.getSourceCode(), a3 = null;
  return t3 = n3.commentPattern ? new RegExp(n3.commentPattern, "u") : cO, { onCodePathStart: function(s3) {
    r3 = s3;
  }, onCodePathEnd: function() {
    r3 = r3.upper;
  }, SwitchCase: function(s3) {
    a3 && !function(o3, u3, c3) {
      var f3 = u3.getSourceCode(), p3 = ye$4.lodash.last(f3.getCommentsBefore(o3));
      return !(!p3 || !c3.test(p3.value));
    }(s3, e28, t3) && e28.report({ messageId: s3.test ? "case" : "default", node: s3 }), a3 = null;
  }, "SwitchCase:exit": function(s3) {
    var o3 = i.getTokenAfter(s3);
    r3.currentSegments.some(lO) && (0 < s3.consequent.length || function(u3, c3) {
      return c3.loc.start.line > u3.loc.end.line + 1;
    }(s3, o3)) && ye$4.lodash.last(s3.parent.cases) !== s3 && (a3 = s3);
  } };
} }, fO = { meta: { type: "suggestion", docs: { description: "disallow leading or trailing decimal points in numeric literals", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-floating-decimal" }, schema: [], fixable: "code", messages: { leading: "A leading decimal point can be confused with a dot.", trailing: "A trailing decimal point can be confused with a dot." } }, create: function(e28) {
  var t3 = e28.getSourceCode();
  return { Literal: function(n3) {
    typeof n3.value == "number" && (n3.raw.startsWith(".") && e28.report({ node: n3, messageId: "leading", fix: function(r3) {
      var i = t3.getTokenBefore(n3), a3 = i && i.range[1] === n3.range[0] && !P$s.canTokensBeAdjacent(i, "0".concat(n3.raw));
      return r3.insertTextBefore(n3, a3 ? " 0" : "0");
    } }), n3.raw.indexOf(".") === n3.raw.length - 1 && e28.report({ node: n3, messageId: "trailing", fix: function(r3) {
      return r3.insertTextAfter(n3, "0");
    } }));
  } };
} }, hO = { meta: { type: "problem", docs: { description: "disallow reassigning `function` declarations", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-func-assign" }, schema: [] }, create: function(e28) {
  function t3(i) {
    P$s.getModifyingReferences(i).forEach(function(a3) {
      e28.report({ node: a3.identifier, message: "'{{name}}' is a function.", data: { name: a3.identifier.name } });
    });
  }
  function n3(i) {
    i.defs[0].type === "FunctionName" && t3(i.references);
  }
  function r3(i) {
    e28.getDeclaredVariables(i).forEach(n3);
  }
  return { FunctionDeclaration: r3, FunctionExpression: r3 };
} }, dO = /^(?:i|lastI)ndexOf$/;
function em(e28) {
  return e28.type === "Literal" && typeof e28.value == "number" || e28.type === "CallExpression" && (e28.callee.name === "Number" || e28.callee.name === "parseInt" || e28.callee.name === "parseFloat");
}
function vp(e28) {
  return P$s.isStringLiteral(e28) && (e28.value === "" || e28.type === "TemplateLiteral" && e28.quasis.length === 1 && e28.quasis[0].value.cooked === "");
}
function b2(e28) {
  return vp(e28.left) ? e28.right : e28.left;
}
var mO = { meta: { type: "suggestion", docs: { description: "disallow shorthand type conversions", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-implicit-coercion" }, fixable: "code", schema: [{ type: "object", properties: { boolean: { type: "boolean", default: true }, number: { type: "boolean", default: true }, string: { type: "boolean", default: true }, allow: { type: "array", items: { enum: ["~", "!!", "+", "*"] }, uniqueItems: true } }, additionalProperties: false }] }, create: function(e28) {
  function t3(i, a3, s3) {
    e28.report({ node: i, message: "use `{{recommendation}}` instead.", data: { recommendation: a3 }, fix: function(o3) {
      if (!s3)
        return null;
      var u3 = r3.getTokenBefore(i);
      return u3 && u3.range[1] === i.range[0] && !P$s.canTokensBeAdjacent(u3, a3) ? o3.replaceText(i, " ".concat(a3)) : o3.replaceText(i, a3);
    } });
  }
  var n3 = function(i) {
    return { boolean: !("boolean" in i) || i.boolean, number: !("number" in i) || i.number, string: !("string" in i) || i.string, allow: i.allow || [] };
  }(e28.options[0] || {}), r3 = e28.getSourceCode();
  return { UnaryExpression: function(i) {
    0 <= n3.allow.indexOf("!!") || !n3.boolean || !function(a3) {
      return a3.operator === "!" && a3.argument.type === "UnaryExpression" && a3.argument.operator === "!";
    }(i) || t3(i, "Boolean(".concat(r3.getText(i.argument.argument), ")"), true), 0 <= n3.allow.indexOf("~") || !n3.boolean || !function(a3) {
      return a3.operator === "~" && a3.argument.type === "CallExpression" && a3.argument.callee.type === "MemberExpression" && a3.argument.callee.property.type === "Identifier" && dO.test(a3.argument.callee.property.name);
    }(i) || t3(i, "".concat(r3.getText(i.argument), " !== -1"), false), 0 <= n3.allow.indexOf("+") || !n3.number || i.operator !== "+" || em(i.argument) || t3(i, "Number(".concat(r3.getText(i.argument), ")"), true);
  }, "BinaryExpression:exit": function(i) {
    var a3 = 0 <= n3.allow.indexOf("*"), s3 = !a3 && n3.number && function(o3) {
      return o3.operator === "*" && (o3.left.type === "Literal" && o3.left.value === 1 || o3.right.type === "Literal" && o3.right.value === 1);
    }(i) && function(o3) {
      var u3 = o3.left, c3 = o3.right;
      return c3.type === "BinaryExpression" || em(c3) ? u3.type === "BinaryExpression" || em(u3) ? null : u3 : c3;
    }(i);
    s3 && t3(i, "Number(".concat(r3.getText(s3), ")"), true), !(a3 = 0 <= n3.allow.indexOf("+")) && n3.string && function(o3) {
      return o3.operator === "+" && (vp(o3.left) && !P$s.isStringLiteral(o3.right) || vp(o3.right) && !P$s.isStringLiteral(o3.left));
    }(i) && t3(i, "String(".concat(r3.getText(b2(i)), ")"), true);
  }, AssignmentExpression: function(i) {
    if (!(0 <= n3.allow.indexOf("+")) && n3.string && function(s3) {
      return s3.operator === "+=" && vp(s3.right);
    }(i)) {
      var a3 = r3.getText(b2(i));
      t3(i, "".concat(a3, " = String(").concat(a3, ")"), true);
    }
  } };
} }, FA = ye$4.require$$0, gO = FA.findVariable, yO = FA.getPropertyName, E2 = { Object: /* @__PURE__ */ new Set(["assign", "defineProperties", "defineProperty", "freeze", "setPrototypeOf"]), Reflect: /* @__PURE__ */ new Set(["defineProperty", "deleteProperty", "set", "setPrototypeOf"]) };
function vO(e28, t3) {
  var n3 = e28.parent;
  return n3.type === "MemberExpression" && n3.object === e28 && (function(r3) {
    var i = r3.parent;
    return i.type === "AssignmentExpression" && i.left === r3 || i.type === "ArrayPattern" || i.type === "Property" && i.value === r3 && i.parent.type === "ObjectPattern" || i.type === "RestElement" || i.type === "AssignmentPattern" && i.left === r3;
  }(n3) || function(r3) {
    var i = r3.parent;
    return i.type === "UpdateExpression" && i.argument === r3 || i.type === "UnaryExpression" && i.operator === "delete" && i.argument === r3;
  }(n3) || function(r3) {
    var i = r3.parent;
    return i.type === "ForInStatement" && i.left === r3 || i.type === "ForOfStatement" && i.left === r3;
  }(n3)) || function(r3, i) {
    var a3 = r3.parent;
    if (a3.type === "CallExpression" && a3.arguments[0] === r3 && a3.callee.type === "MemberExpression" && a3.callee.object.type === "Identifier") {
      var s3 = a3.callee, o3 = s3.object;
      if (Object.keys(E2).includes(o3.name)) {
        var u3 = gO(i, o3);
        return u3 !== null && u3.scope.type === "global" && E2[o3.name].has(yO(s3, i));
      }
    }
    return false;
  }(e28, t3);
}
function C2(e28) {
  for (var t3 = e28.parent; t3 && t3.type !== "AssignmentExpression" && t3.type !== "UpdateExpression" && t3.type !== "UnaryExpression" && t3.type !== "CallExpression" && t3.type !== "ForInStatement" && t3.type !== "ForOfStatement"; )
    t3 = t3.parent;
  return t3 || e28;
}
var xO = { meta: { type: "problem", docs: { description: "disallow assigning to imported bindings", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-import-assign" }, schema: [], messages: { readonly: "'{{name}}' is read-only.", readonlyMember: "The members of '{{name}}' are read-only." } }, create: function(e28) {
  return { ImportDeclaration: function(t3) {
    var n3 = e28.getScope(), r3 = true, i = false, a3 = void 0;
    try {
      for (var s3, o3 = e28.getDeclaredVariables(t3)[Symbol.iterator](); !(r3 = (s3 = o3.next()).done); r3 = true) {
        var u3 = s3.value, c3 = u3.defs.some(function(C3) {
          return C3.node.type === "ImportNamespaceSpecifier";
        }), f3 = null, p3 = true, d3 = false, m3 = void 0;
        try {
          for (var y3, v3 = u3.references[Symbol.iterator](); !(p3 = (y3 = v3.next()).done); p3 = true) {
            var b3 = y3.value, x3 = b3.identifier;
            x3 !== f3 && (f3 = x3, b3.isWrite() ? e28.report({ node: C2(x3), messageId: "readonly", data: { name: x3.name } }) : c3 && vO(x3, n3) && e28.report({ node: C2(x3), messageId: "readonlyMember", data: { name: x3.name } }));
          }
        } catch (C3) {
          d3 = true, m3 = C3;
        } finally {
          try {
            p3 || v3.return == null || v3.return();
          } finally {
            if (d3)
              throw m3;
          }
        }
      }
    } catch (C3) {
      i = true, a3 = C3;
    } finally {
      try {
        r3 || o3.return == null || o3.return();
      } finally {
        if (i)
          throw a3;
      }
    }
  } };
} }, bO = { meta: { type: "suggestion", docs: { description: "disallow inline comments after code", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-inline-comments" }, schema: [] }, create: function(e28) {
  function t3(r3) {
    var i = n3.lines[r3.loc.start.line - 1] + "", a3 = n3.lines[r3.loc.end.line - 1] + "", s3 = i.slice(0, r3.loc.start.column).trim(), o3 = a3.slice(r3.loc.end.column).trim(), u3 = !s3, c3 = !o3;
    if (!u3 || !c3) {
      if ((u3 || s3 === "{") && (c3 || o3 === "}")) {
        var f3 = n3.getNodeByRangeIndex(r3.range[0]);
        if (f3 && f3.type === "JSXEmptyExpression")
          return;
      }
      P$s.isDirectiveComment(r3) || e28.report({ node: r3, message: "Unexpected comment inline with code." });
    }
  }
  var n3 = e28.getSourceCode();
  return { Program: function() {
    n3.getAllComments().filter(function(r3) {
      return r3.type !== "Shebang";
    }).forEach(t3);
  } };
} }, S2 = new ao$1.RegExpValidator({ ecmaVersion: 2018 }), EO = /[gimsuy]/g, k2 = void 0, CO = { meta: { type: "problem", docs: { description: "disallow invalid regular expression strings in `RegExp` constructors", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-invalid-regexp" }, schema: [{ type: "object", properties: { allowConstructorFlags: { type: "array", items: { type: "string" } } }, additionalProperties: false }] }, create: function(e28) {
  function t3(s3) {
    return s3 && s3.type === "Literal" && typeof s3.value == "string";
  }
  function n3(s3, o3) {
    try {
      return S2.validatePattern(s3, k2, k2, o3), null;
    } catch (u3) {
      return u3.message;
    }
  }
  var r3 = e28.options[0], i = null;
  if (r3 && r3.allowConstructorFlags) {
    var a3 = r3.allowConstructorFlags.join("").replace(EO, "");
    a3 && (i = new RegExp("[".concat(a3, "]"), "giu"));
  }
  return { "CallExpression, NewExpression": function(s3) {
    if (s3.callee.type === "Identifier" && s3.callee.name === "RegExp" && t3(s3.arguments[0])) {
      var o3 = s3.arguments[0].value, u3 = t3(s3.arguments[1]) ? s3.arguments[1].value : "";
      i && (u3 = u3.replace(i, ""));
      var c3 = function(f3) {
        try {
          return S2.validateFlags(f3), null;
        } catch {
          return "Invalid flags supplied to RegExp constructor '".concat(f3, "'");
        }
      }(u3) || (u3 ? n3(o3, u3.indexOf("u") !== -1) : n3(o3, true) && n3(o3, false));
      c3 && e28.report({ node: s3, message: "{{message}}.", data: { message: c3 } });
    }
  } };
} }, SO = { meta: { type: "suggestion", docs: { description: "disallow `this` keywords outside of classes or class-like objects", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-invalid-this" }, schema: [{ type: "object", properties: { capIsConstructor: { type: "boolean", default: true } }, additionalProperties: false }] }, create: function(e28) {
  function t3(s3) {
    i.push({ init: !e28.getScope().isStrict, node: s3, valid: true });
  }
  function n3() {
    i.pop();
  }
  var r3 = (e28.options[0] || {}).capIsConstructor !== false, i = [], a3 = e28.getSourceCode();
  return i.getCurrent = function() {
    var s3 = this[this.length - 1];
    return s3.init || (s3.init = true, s3.valid = !P$s.isDefaultThisBinding(s3.node, a3, { capIsConstructor: r3 })), s3;
  }, { Program: function(s3) {
    var o3 = e28.getScope(), u3 = e28.parserOptions.ecmaFeatures || {};
    i.push({ init: true, node: s3, valid: !(o3.isStrict || s3.sourceType === "module" || u3.globalReturn && o3.childScopes[0].isStrict) });
  }, "Program:exit": function() {
    i.pop();
  }, FunctionDeclaration: t3, "FunctionDeclaration:exit": n3, FunctionExpression: t3, "FunctionExpression:exit": n3, ThisExpression: function(s3) {
    var o3 = i.getCurrent();
    o3 && !o3.valid && e28.report({ node: s3, message: "Unexpected 'this'." });
  } };
} }, Xl = /[\x0B\f\x85\xA0\u1680\u180E\u2000-\u200B\u2028\u2029\u202F\u205F\u3000\uFEFF]/, kO = /[\x0B\f\x85\xA0\u1680\u180E\u2000-\u200B\u202F\u205F\u3000\uFEFF]+/gm, DO = /[\u2028\u2029]/gm, FO = P$s.createGlobalLinebreakMatcher(), wO = { meta: { type: "problem", docs: { description: "disallow irregular whitespace", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-irregular-whitespace" }, schema: [{ type: "object", properties: { skipComments: { type: "boolean", default: false }, skipStrings: { type: "boolean", default: true }, skipTemplates: { type: "boolean", default: false }, skipRegExps: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e28) {
  function t3(y3) {
    var v3 = y3.loc.start, b3 = y3.loc.end;
    a3 = a3.filter(function(x3) {
      var C3 = x3.loc;
      return !(C3.line >= v3.line && C3.line <= b3.line && C3.column >= v3.column && (C3.column <= b3.column || C3.line < b3.line));
    });
  }
  function n3(y3) {
    var v3 = u3 && typeof y3.value == "string", b3 = c3 && !!y3.regex;
    (v3 || b3) && Xl.test(y3.raw) && t3(y3);
  }
  function r3(y3) {
    Xl.test(y3.value) && t3(y3);
  }
  function i() {
  }
  var a3 = [], s3 = e28.options[0] || {}, o3 = !!s3.skipComments, u3 = s3.skipStrings !== false, c3 = !!s3.skipRegExps, f3 = !!s3.skipTemplates, p3 = e28.getSourceCode(), d3 = p3.getAllComments(), m3 = {};
  return Xl.test(p3.getText()) ? (m3.Program = function(y3) {
    (function(v3) {
      p3.lines.forEach(function(b3, x3) {
        for (var C3; (C3 = kO.exec(b3)) !== null; ) {
          var k3 = { line: x3 + 1, column: C3.index };
          a3.push({ node: v3, message: "Irregular whitespace not allowed.", loc: k3 });
        }
      });
    })(y3), function(v3) {
      for (var b3, x3 = p3.getText(), C3 = p3.lines, k3 = x3.match(FO), F3 = -1; (b3 = DO.exec(x3)) !== null; ) {
        var B3 = k3.indexOf(b3[0], F3 + 1) || 0, O3 = { line: B3 + 1, column: C3[B3].length };
        a3.push({ node: v3, message: "Irregular whitespace not allowed.", loc: O3 }), F3 = B3;
      }
    }(y3);
  }, m3.Identifier = n3, m3.Literal = n3, m3.TemplateElement = f3 ? function(y3) {
    typeof y3.value.raw == "string" && Xl.test(y3.value.raw) && t3(y3);
  } : i, m3["Program:exit"] = function() {
    o3 && d3.forEach(r3), a3.forEach(function(y3) {
      return e28.report(y3);
    });
  }) : m3.Program = i, m3;
} }, AO = { meta: { type: "suggestion", docs: { description: "disallow labels that share a name with a variable", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/no-label-var" }, schema: [] }, create: function(e28) {
  return { LabeledStatement: function(t3) {
    (function(n3, r3) {
      return P$s.getVariableByName(n3, r3) !== null;
    })(e28.getScope(), t3.label.name) && e28.report({ node: t3, message: "Found identifier with same name as label." });
  } };
} }, _O = { meta: { type: "suggestion", docs: { description: "disallow labeled statements", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-labels" }, schema: [{ type: "object", properties: { allowLoop: { type: "boolean", default: false }, allowSwitch: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e28) {
  function t3(u3) {
    return P$s.isLoop(u3) ? "loop" : u3.type === "SwitchStatement" ? "switch" : "other";
  }
  function n3(u3) {
    return u3 === "loop" ? a3 : u3 == "switch" && s3;
  }
  function r3(u3) {
    for (var c3 = o3; c3; ) {
      if (c3.label === u3)
        return c3.kind;
      c3 = c3.upper;
    }
    return "other";
  }
  var i = e28.options[0], a3 = i && i.allowLoop, s3 = i && i.allowSwitch, o3 = null;
  return { LabeledStatement: function(u3) {
    o3 = { label: u3.label.name, kind: t3(u3.body), upper: o3 };
  }, "LabeledStatement:exit": function(u3) {
    n3(o3.kind) || e28.report({ node: u3, message: "Unexpected labeled statement." }), o3 = o3.upper;
  }, BreakStatement: function(u3) {
    u3.label && !n3(r3(u3.label.name)) && e28.report({ node: u3, message: "Unexpected label in break statement." });
  }, ContinueStatement: function(u3) {
    u3.label && !n3(r3(u3.label.name)) && e28.report({ node: u3, message: "Unexpected label in continue statement." });
  } };
} };
function wA(e28) {
  for (var t3 = e28; t3.parent; t3 = t3.parent) {
    var n3 = t3.parent;
    switch (n3.type) {
      case "WhileStatement":
      case "DoWhileStatement":
        return n3;
      case "ForStatement":
        if (n3.init !== t3)
          return n3;
        break;
      case "ForInStatement":
      case "ForOfStatement":
        if (n3.right !== t3)
          return n3;
        break;
      case "ArrowFunctionExpression":
      case "FunctionExpression":
      case "FunctionDeclaration":
        return null;
    }
  }
  return null;
}
function TO(e28, t3) {
  var n3 = t3.resolved, r3 = n3 && n3.defs[0], i = r3 && r3.parent, a3 = i && i.type === "VariableDeclaration" ? i.kind : "";
  if (a3 === "const" || a3 === "let" && i.range[0] > e28.range[0] && i.range[1] < e28.range[1])
    return true;
  var s3 = function(o3, u3) {
    for (var c3 = u3 ? u3.range[1] : 0, f3 = o3, p3 = o3; p3 && p3.range[0] >= c3; )
      f3 = p3, p3 = wA(p3);
    return f3;
  }(e28, a3 === "let" ? i : null).range[0];
  return !!n3 && n3.references.every(function(o3) {
    var u3 = o3.identifier;
    return !o3.isWrite() || n3.scope.variableScope === o3.from.variableScope && u3.range[0] < s3;
  });
}
var PO = { meta: { type: "suggestion", docs: { description: "disallow function declarations that contain unsafe references inside loop statements", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-loop-func" }, schema: [], messages: { unsafeRefs: "Function declared in a loop contains unsafe references to variable(s) {{ varNames }}." } }, create: function(e28) {
  function t3(n3) {
    var r3 = wA(n3);
    if (r3) {
      var i = e28.getScope().through.filter(function(a3) {
        return !TO(r3, a3);
      }).map(function(a3) {
        return a3.identifier.name;
      });
      0 < i.length && e28.report({ node: n3, messageId: "unsafeRefs", data: { varNames: "'".concat(i.join("', '"), "'") } });
    }
  }
  return { ArrowFunctionExpression: t3, FunctionExpression: t3, FunctionDeclaration: t3 };
} }, IO = /* @__PURE__ */ new Set([768, 769, 770, 771, 772, 773, 774, 775, 776, 777, 778, 779, 780, 781, 782, 783, 784, 785, 786, 787, 788, 789, 790, 791, 792, 793, 794, 795, 796, 797, 798, 799, 800, 801, 802, 803, 804, 805, 806, 807, 808, 809, 810, 811, 812, 813, 814, 815, 816, 817, 818, 819, 820, 821, 822, 823, 824, 825, 826, 827, 828, 829, 830, 831, 832, 833, 834, 835, 836, 837, 838, 839, 840, 841, 842, 843, 844, 845, 846, 847, 848, 849, 850, 851, 852, 853, 854, 855, 856, 857, 858, 859, 860, 861, 862, 863, 864, 865, 866, 867, 868, 869, 870, 871, 872, 873, 874, 875, 876, 877, 878, 879, 1155, 1156, 1157, 1158, 1159, 1160, 1161, 1425, 1426, 1427, 1428, 1429, 1430, 1431, 1432, 1433, 1434, 1435, 1436, 1437, 1438, 1439, 1440, 1441, 1442, 1443, 1444, 1445, 1446, 1447, 1448, 1449, 1450, 1451, 1452, 1453, 1454, 1455, 1456, 1457, 1458, 1459, 1460, 1461, 1462, 1463, 1464, 1465, 1466, 1467, 1468, 1469, 1471, 1473, 1474, 1476, 1477, 1479, 1552, 1553, 1554, 1555, 1556, 1557, 1558, 1559, 1560, 1561, 1562, 1611, 1612, 1613, 1614, 1615, 1616, 1617, 1618, 1619, 1620, 1621, 1622, 1623, 1624, 1625, 1626, 1627, 1628, 1629, 1630, 1631, 1648, 1750, 1751, 1752, 1753, 1754, 1755, 1756, 1759, 1760, 1761, 1762, 1763, 1764, 1767, 1768, 1770, 1771, 1772, 1773, 1809, 1840, 1841, 1842, 1843, 1844, 1845, 1846, 1847, 1848, 1849, 1850, 1851, 1852, 1853, 1854, 1855, 1856, 1857, 1858, 1859, 1860, 1861, 1862, 1863, 1864, 1865, 1866, 1958, 1959, 1960, 1961, 1962, 1963, 1964, 1965, 1966, 1967, 1968, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035, 2070, 2071, 2072, 2073, 2075, 2076, 2077, 2078, 2079, 2080, 2081, 2082, 2083, 2085, 2086, 2087, 2089, 2090, 2091, 2092, 2093, 2137, 2138, 2139, 2260, 2261, 2262, 2263, 2264, 2265, 2266, 2267, 2268, 2269, 2270, 2271, 2272, 2273, 2275, 2276, 2277, 2278, 2279, 2280, 2281, 2282, 2283, 2284, 2285, 2286, 2287, 2288, 2289, 2290, 2291, 2292, 2293, 2294, 2295, 2296, 2297, 2298, 2299, 2300, 2301, 2302, 2303, 2304, 2305, 2306, 2307, 2362, 2363, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2385, 2386, 2387, 2388, 2389, 2390, 2391, 2402, 2403, 2433, 2434, 2435, 2492, 2494, 2495, 2496, 2497, 2498, 2499, 2500, 2503, 2504, 2507, 2508, 2509, 2519, 2530, 2531, 2561, 2562, 2563, 2620, 2622, 2623, 2624, 2625, 2626, 2631, 2632, 2635, 2636, 2637, 2641, 2672, 2673, 2677, 2689, 2690, 2691, 2748, 2750, 2751, 2752, 2753, 2754, 2755, 2756, 2757, 2759, 2760, 2761, 2763, 2764, 2765, 2786, 2787, 2810, 2811, 2812, 2813, 2814, 2815, 2817, 2818, 2819, 2876, 2878, 2879, 2880, 2881, 2882, 2883, 2884, 2887, 2888, 2891, 2892, 2893, 2902, 2903, 2914, 2915, 2946, 3006, 3007, 3008, 3009, 3010, 3014, 3015, 3016, 3018, 3019, 3020, 3021, 3031, 3072, 3073, 3074, 3075, 3134, 3135, 3136, 3137, 3138, 3139, 3140, 3142, 3143, 3144, 3146, 3147, 3148, 3149, 3157, 3158, 3170, 3171, 3201, 3202, 3203, 3260, 3262, 3263, 3264, 3265, 3266, 3267, 3268, 3270, 3271, 3272, 3274, 3275, 3276, 3277, 3285, 3286, 3298, 3299, 3328, 3329, 3330, 3331, 3387, 3388, 3390, 3391, 3392, 3393, 3394, 3395, 3396, 3398, 3399, 3400, 3402, 3403, 3404, 3405, 3415, 3426, 3427, 3458, 3459, 3530, 3535, 3536, 3537, 3538, 3539, 3540, 3542, 3544, 3545, 3546, 3547, 3548, 3549, 3550, 3551, 3570, 3571, 3633, 3636, 3637, 3638, 3639, 3640, 3641, 3642, 3655, 3656, 3657, 3658, 3659, 3660, 3661, 3662, 3761, 3764, 3765, 3766, 3767, 3768, 3769, 3771, 3772, 3784, 3785, 3786, 3787, 3788, 3789, 3864, 3865, 3893, 3895, 3897, 3902, 3903, 3953, 3954, 3955, 3956, 3957, 3958, 3959, 3960, 3961, 3962, 3963, 3964, 3965, 3966, 3967, 3968, 3969, 3970, 3971, 3972, 3974, 3975, 3981, 3982, 3983, 3984, 3985, 3986, 3987, 3988, 3989, 3990, 3991, 3993, 3994, 3995, 3996, 3997, 3998, 3999, 4e3, 4001, 4002, 4003, 4004, 4005, 4006, 4007, 4008, 4009, 4010, 4011, 4012, 4013, 4014, 4015, 4016, 4017, 4018, 4019, 4020, 4021, 4022, 4023, 4024, 4025, 4026, 4027, 4028, 4038, 4139, 4140, 4141, 4142, 4143, 4144, 4145, 4146, 4147, 4148, 4149, 4150, 4151, 4152, 4153, 4154, 4155, 4156, 4157, 4158, 4182, 4183, 4184, 4185, 4190, 4191, 4192, 4194, 4195, 4196, 4199, 4200, 4201, 4202, 4203, 4204, 4205, 4209, 4210, 4211, 4212, 4226, 4227, 4228, 4229, 4230, 4231, 4232, 4233, 4234, 4235, 4236, 4237, 4239, 4250, 4251, 4252, 4253, 4957, 4958, 4959, 5906, 5907, 5908, 5938, 5939, 5940, 5970, 5971, 6002, 6003, 6068, 6069, 6070, 6071, 6072, 6073, 6074, 6075, 6076, 6077, 6078, 6079, 6080, 6081, 6082, 6083, 6084, 6085, 6086, 6087, 6088, 6089, 6090, 6091, 6092, 6093, 6094, 6095, 6096, 6097, 6098, 6099, 6109, 6155, 6156, 6157, 6277, 6278, 6313, 6432, 6433, 6434, 6435, 6436, 6437, 6438, 6439, 6440, 6441, 6442, 6443, 6448, 6449, 6450, 6451, 6452, 6453, 6454, 6455, 6456, 6457, 6458, 6459, 6679, 6680, 6681, 6682, 6683, 6741, 6742, 6743, 6744, 6745, 6746, 6747, 6748, 6749, 6750, 6752, 6753, 6754, 6755, 6756, 6757, 6758, 6759, 6760, 6761, 6762, 6763, 6764, 6765, 6766, 6767, 6768, 6769, 6770, 6771, 6772, 6773, 6774, 6775, 6776, 6777, 6778, 6779, 6780, 6783, 6832, 6833, 6834, 6835, 6836, 6837, 6838, 6839, 6840, 6841, 6842, 6843, 6844, 6845, 6846, 6912, 6913, 6914, 6915, 6916, 6964, 6965, 6966, 6967, 6968, 6969, 6970, 6971, 6972, 6973, 6974, 6975, 6976, 6977, 6978, 6979, 6980, 7019, 7020, 7021, 7022, 7023, 7024, 7025, 7026, 7027, 7040, 7041, 7042, 7073, 7074, 7075, 7076, 7077, 7078, 7079, 7080, 7081, 7082, 7083, 7084, 7085, 7142, 7143, 7144, 7145, 7146, 7147, 7148, 7149, 7150, 7151, 7152, 7153, 7154, 7155, 7204, 7205, 7206, 7207, 7208, 7209, 7210, 7211, 7212, 7213, 7214, 7215, 7216, 7217, 7218, 7219, 7220, 7221, 7222, 7223, 7376, 7377, 7378, 7380, 7381, 7382, 7383, 7384, 7385, 7386, 7387, 7388, 7389, 7390, 7391, 7392, 7393, 7394, 7395, 7396, 7397, 7398, 7399, 7400, 7405, 7410, 7411, 7412, 7415, 7416, 7417, 7616, 7617, 7618, 7619, 7620, 7621, 7622, 7623, 7624, 7625, 7626, 7627, 7628, 7629, 7630, 7631, 7632, 7633, 7634, 7635, 7636, 7637, 7638, 7639, 7640, 7641, 7642, 7643, 7644, 7645, 7646, 7647, 7648, 7649, 7650, 7651, 7652, 7653, 7654, 7655, 7656, 7657, 7658, 7659, 7660, 7661, 7662, 7663, 7664, 7665, 7666, 7667, 7668, 7669, 7670, 7671, 7672, 7673, 7675, 7676, 7677, 7678, 7679, 8400, 8401, 8402, 8403, 8404, 8405, 8406, 8407, 8408, 8409, 8410, 8411, 8412, 8413, 8414, 8415, 8416, 8417, 8418, 8419, 8420, 8421, 8422, 8423, 8424, 8425, 8426, 8427, 8428, 8429, 8430, 8431, 8432, 11503, 11504, 11505, 11647, 11744, 11745, 11746, 11747, 11748, 11749, 11750, 11751, 11752, 11753, 11754, 11755, 11756, 11757, 11758, 11759, 11760, 11761, 11762, 11763, 11764, 11765, 11766, 11767, 11768, 11769, 11770, 11771, 11772, 11773, 11774, 11775, 12330, 12331, 12332, 12333, 12334, 12335, 12441, 12442, 42607, 42608, 42609, 42610, 42612, 42613, 42614, 42615, 42616, 42617, 42618, 42619, 42620, 42621, 42654, 42655, 42736, 42737, 43010, 43014, 43019, 43043, 43044, 43045, 43046, 43047, 43136, 43137, 43188, 43189, 43190, 43191, 43192, 43193, 43194, 43195, 43196, 43197, 43198, 43199, 43200, 43201, 43202, 43203, 43204, 43205, 43232, 43233, 43234, 43235, 43236, 43237, 43238, 43239, 43240, 43241, 43242, 43243, 43244, 43245, 43246, 43247, 43248, 43249, 43302, 43303, 43304, 43305, 43306, 43307, 43308, 43309, 43335, 43336, 43337, 43338, 43339, 43340, 43341, 43342, 43343, 43344, 43345, 43346, 43347, 43392, 43393, 43394, 43395, 43443, 43444, 43445, 43446, 43447, 43448, 43449, 43450, 43451, 43452, 43453, 43454, 43455, 43456, 43493, 43561, 43562, 43563, 43564, 43565, 43566, 43567, 43568, 43569, 43570, 43571, 43572, 43573, 43574, 43587, 43596, 43597, 43643, 43644, 43645, 43696, 43698, 43699, 43700, 43703, 43704, 43710, 43711, 43713, 43755, 43756, 43757, 43758, 43759, 43765, 43766, 44003, 44004, 44005, 44006, 44007, 44008, 44009, 44010, 44012, 44013, 64286, 65024, 65025, 65026, 65027, 65028, 65029, 65030, 65031, 65032, 65033, 65034, 65035, 65036, 65037, 65038, 65039, 65056, 65057, 65058, 65059, 65060, 65061, 65062, 65063, 65064, 65065, 65066, 65067, 65068, 65069, 65070, 65071, 66045, 66272, 66422, 66423, 66424, 66425, 66426, 68097, 68098, 68099, 68101, 68102, 68108, 68109, 68110, 68111, 68152, 68153, 68154, 68159, 68325, 68326, 69632, 69633, 69634, 69688, 69689, 69690, 69691, 69692, 69693, 69694, 69695, 69696, 69697, 69698, 69699, 69700, 69701, 69702, 69759, 69760, 69761, 69762, 69808, 69809, 69810, 69811, 69812, 69813, 69814, 69815, 69816, 69817, 69818, 69888, 69889, 69890, 69927, 69928, 69929, 69930, 69931, 69932, 69933, 69934, 69935, 69936, 69937, 69938, 69939, 69940, 70003, 70016, 70017, 70018, 70067, 70068, 70069, 70070, 70071, 70072, 70073, 70074, 70075, 70076, 70077, 70078, 70079, 70080, 70090, 70091, 70092, 70188, 70189, 70190, 70191, 70192, 70193, 70194, 70195, 70196, 70197, 70198, 70199, 70206, 70367, 70368, 70369, 70370, 70371, 70372, 70373, 70374, 70375, 70376, 70377, 70378, 70400, 70401, 70402, 70403, 70460, 70462, 70463, 70464, 70465, 70466, 70467, 70468, 70471, 70472, 70475, 70476, 70477, 70487, 70498, 70499, 70502, 70503, 70504, 70505, 70506, 70507, 70508, 70512, 70513, 70514, 70515, 70516, 70709, 70710, 70711, 70712, 70713, 70714, 70715, 70716, 70717, 70718, 70719, 70720, 70721, 70722, 70723, 70724, 70725, 70726, 70832, 70833, 70834, 70835, 70836, 70837, 70838, 70839, 70840, 70841, 70842, 70843, 70844, 70845, 70846, 70847, 70848, 70849, 70850, 70851, 71087, 71088, 71089, 71090, 71091, 71092, 71093, 71096, 71097, 71098, 71099, 71100, 71101, 71102, 71103, 71104, 71132, 71133, 71216, 71217, 71218, 71219, 71220, 71221, 71222, 71223, 71224, 71225, 71226, 71227, 71228, 71229, 71230, 71231, 71232, 71339, 71340, 71341, 71342, 71343, 71344, 71345, 71346, 71347, 71348, 71349, 71350, 71351, 71453, 71454, 71455, 71456, 71457, 71458, 71459, 71460, 71461, 71462, 71463, 71464, 71465, 71466, 71467, 72193, 72194, 72195, 72196, 72197, 72198, 72199, 72200, 72201, 72202, 72243, 72244, 72245, 72246, 72247, 72248, 72249, 72251, 72252, 72253, 72254, 72263, 72273, 72274, 72275, 72276, 72277, 72278, 72279, 72280, 72281, 72282, 72283, 72330, 72331, 72332, 72333, 72334, 72335, 72336, 72337, 72338, 72339, 72340, 72341, 72342, 72343, 72344, 72345, 72751, 72752, 72753, 72754, 72755, 72756, 72757, 72758, 72760, 72761, 72762, 72763, 72764, 72765, 72766, 72767, 72850, 72851, 72852, 72853, 72854, 72855, 72856, 72857, 72858, 72859, 72860, 72861, 72862, 72863, 72864, 72865, 72866, 72867, 72868, 72869, 72870, 72871, 72873, 72874, 72875, 72876, 72877, 72878, 72879, 72880, 72881, 72882, 72883, 72884, 72885, 72886, 73009, 73010, 73011, 73012, 73013, 73014, 73018, 73020, 73021, 73023, 73024, 73025, 73026, 73027, 73028, 73029, 73031, 92912, 92913, 92914, 92915, 92916, 92976, 92977, 92978, 92979, 92980, 92981, 92982, 94033, 94034, 94035, 94036, 94037, 94038, 94039, 94040, 94041, 94042, 94043, 94044, 94045, 94046, 94047, 94048, 94049, 94050, 94051, 94052, 94053, 94054, 94055, 94056, 94057, 94058, 94059, 94060, 94061, 94062, 94063, 94064, 94065, 94066, 94067, 94068, 94069, 94070, 94071, 94072, 94073, 94074, 94075, 94076, 94077, 94078, 94095, 94096, 94097, 94098, 113821, 113822, 119141, 119142, 119143, 119144, 119145, 119149, 119150, 119151, 119152, 119153, 119154, 119163, 119164, 119165, 119166, 119167, 119168, 119169, 119170, 119173, 119174, 119175, 119176, 119177, 119178, 119179, 119210, 119211, 119212, 119213, 119362, 119363, 119364, 121344, 121345, 121346, 121347, 121348, 121349, 121350, 121351, 121352, 121353, 121354, 121355, 121356, 121357, 121358, 121359, 121360, 121361, 121362, 121363, 121364, 121365, 121366, 121367, 121368, 121369, 121370, 121371, 121372, 121373, 121374, 121375, 121376, 121377, 121378, 121379, 121380, 121381, 121382, 121383, 121384, 121385, 121386, 121387, 121388, 121389, 121390, 121391, 121392, 121393, 121394, 121395, 121396, 121397, 121398, 121403, 121404, 121405, 121406, 121407, 121408, 121409, 121410, 121411, 121412, 121413, 121414, 121415, 121416, 121417, 121418, 121419, 121420, 121421, 121422, 121423, 121424, 121425, 121426, 121427, 121428, 121429, 121430, 121431, 121432, 121433, 121434, 121435, 121436, 121437, 121438, 121439, 121440, 121441, 121442, 121443, 121444, 121445, 121446, 121447, 121448, 121449, 121450, 121451, 121452, 121461, 121476, 121499, 121500, 121501, 121502, 121503, 121505, 121506, 121507, 121508, 121509, 121510, 121511, 121512, 121513, 121514, 121515, 121516, 121517, 121518, 121519, 122880, 122881, 122882, 122883, 122884, 122885, 122886, 122888, 122889, 122890, 122891, 122892, 122893, 122894, 122895, 122896, 122897, 122898, 122899, 122900, 122901, 122902, 122903, 122904, 122907, 122908, 122909, 122910, 122911, 122912, 122913, 122915, 122916, 122918, 122919, 122920, 122921, 122922, 125136, 125137, 125138, 125139, 125140, 125141, 125142, 125252, 125253, 125254, 125255, 125256, 125257, 125258, 917760, 917761, 917762, 917763, 917764, 917765, 917766, 917767, 917768, 917769, 917770, 917771, 917772, 917773, 917774, 917775, 917776, 917777, 917778, 917779, 917780, 917781, 917782, 917783, 917784, 917785, 917786, 917787, 917788, 917789, 917790, 917791, 917792, 917793, 917794, 917795, 917796, 917797, 917798, 917799, 917800, 917801, 917802, 917803, 917804, 917805, 917806, 917807, 917808, 917809, 917810, 917811, 917812, 917813, 917814, 917815, 917816, 917817, 917818, 917819, 917820, 917821, 917822, 917823, 917824, 917825, 917826, 917827, 917828, 917829, 917830, 917831, 917832, 917833, 917834, 917835, 917836, 917837, 917838, 917839, 917840, 917841, 917842, 917843, 917844, 917845, 917846, 917847, 917848, 917849, 917850, 917851, 917852, 917853, 917854, 917855, 917856, 917857, 917858, 917859, 917860, 917861, 917862, 917863, 917864, 917865, 917866, 917867, 917868, 917869, 917870, 917871, 917872, 917873, 917874, 917875, 917876, 917877, 917878, 917879, 917880, 917881, 917882, 917883, 917884, 917885, 917886, 917887, 917888, 917889, 917890, 917891, 917892, 917893, 917894, 917895, 917896, 917897, 917898, 917899, 917900, 917901, 917902, 917903, 917904, 917905, 917906, 917907, 917908, 917909, 917910, 917911, 917912, 917913, 917914, 917915, 917916, 917917, 917918, 917919, 917920, 917921, 917922, 917923, 917924, 917925, 917926, 917927, 917928, 917929, 917930, 917931, 917932, 917933, 917934, 917935, 917936, 917937, 917938, 917939, 917940, 917941, 917942, 917943, 917944, 917945, 917946, 917947, 917948, 917949, 917950, 917951, 917952, 917953, 917954, 917955, 917956, 917957, 917958, 917959, 917960, 917961, 917962, 917963, 917964, 917965, 917966, 917967, 917968, 917969, 917970, 917971, 917972, 917973, 917974, 917975, 917976, 917977, 917978, 917979, 917980, 917981, 917982, 917983, 917984, 917985, 917986, 917987, 917988, 917989, 917990, 917991, 917992, 917993, 917994, 917995, 917996, 917997, 917998, 917999]), BO = function(e28) {
  return IO.has(e28);
}, OO = function(e28) {
  return 127995 <= e28 && 127999 >= e28;
}, LO = function(e28) {
  return 127462 <= e28 && 127487 >= e28;
}, NO = function(e28, t3) {
  return 55296 <= e28 && 56320 > e28 && 56320 <= t3 && 57344 > t3;
}, Ef = ye$4.require$$0, jO = Ef.CALL, RO = Ef.CONSTRUCT, MO = Ef.ReferenceTracker, D2 = Ef.getStringIfConstant, VO = ao$1.RegExpParser, UO = ao$1.visitRegExpAST, F2 = BO, w2 = OO, A2 = LO, qO = NO;
function AA(e28) {
  var t3, n3, r3, i, a3, s3, o3;
  return regeneratorRuntime.wrap(function(u3) {
    for (; ; )
      switch (u3.prev = u3.next) {
        case 0:
          t3 = [], n3 = true, r3 = false, i = void 0, u3.prev = 4, a3 = e28[Symbol.iterator]();
        case 6:
          if (n3 = (s3 = a3.next()).done) {
            u3.next = 26;
            break;
          }
          o3 = s3.value, u3.t0 = o3.type, u3.next = u3.t0 === "Character" ? 11 : u3.t0 === "CharacterClassRange" ? 13 : u3.t0 === "CharacterSet" ? 18 : 23;
          break;
        case 11:
          return t3.push(o3.value), u3.abrupt("break", 23);
        case 13:
          return t3.push(o3.min.value), u3.next = 16, t3;
        case 16:
          return t3 = [o3.max.value], u3.abrupt("break", 23);
        case 18:
          if (u3.t1 = 0 < t3.length, !u3.t1) {
            u3.next = 23;
            break;
          }
          return u3.next = 22, t3;
        case 22:
          t3 = [];
        case 23:
          n3 = true, u3.next = 6;
          break;
        case 26:
          u3.next = 32;
          break;
        case 28:
          u3.prev = 28, u3.t2 = u3.catch(4), r3 = true, i = u3.t2;
        case 32:
          u3.prev = 32, u3.prev = 33, n3 || a3.return == null || a3.return();
        case 35:
          if (u3.prev = 35, !r3) {
            u3.next = 38;
            break;
          }
          throw i;
        case 38:
          return u3.finish(35);
        case 39:
          return u3.finish(32);
        case 40:
          if (u3.t3 = 0 < t3.length, !u3.t3) {
            u3.next = 44;
            break;
          }
          return u3.next = 44, t3;
        case 44:
        case "end":
          return u3.stop();
      }
  }, wI, null, [[4, 28, 32, 40], [33, , 35, 39]]);
}
var _A = { surrogatePairWithoutUFlag: function(e28) {
  return e28.some(function(t3, n3) {
    return n3 !== 0 && qO(e28[n3 - 1], t3);
  });
}, combiningClass: function(e28) {
  return e28.some(function(t3, n3) {
    return n3 !== 0 && F2(t3) && !F2(e28[n3 - 1]);
  });
}, emojiModifier: function(e28) {
  return e28.some(function(t3, n3) {
    return n3 !== 0 && w2(t3) && !w2(e28[n3 - 1]);
  });
}, regionalIndicatorSymbol: function(e28) {
  return e28.some(function(t3, n3) {
    return n3 !== 0 && A2(t3) && A2(e28[n3 - 1]);
  });
}, zwj: function(e28) {
  var t3 = e28.length - 1;
  return e28.some(function(n3, r3) {
    return r3 !== 0 && r3 !== t3 && n3 === 8205 && e28[r3 - 1] !== 8205 && e28[r3 + 1] !== 8205;
  });
} }, _2 = Object.keys(_A), WO = { meta: { type: "problem", docs: { description: "disallow characters which are made with multiple code points in character class syntax", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-misleading-character-class" }, schema: [], messages: { surrogatePairWithoutUFlag: "Unexpected surrogate pair in character class. Use 'u' flag.", combiningClass: "Unexpected combined character in character class.", emojiModifier: "Unexpected modified Emoji in character class.", regionalIndicatorSymbol: "Unexpected national flag in character class.", zwj: "Unexpected joined character sequence in character class." } }, create: function(e28) {
  function t3(r3, i, a3) {
    var s3, o3 = { surrogatePairWithoutUFlag: false, combiningClass: false, variationSelector: false, emojiModifier: false, regionalIndicatorSymbol: false, zwj: false };
    try {
      s3 = n3.parsePattern(i, 0, i.length, a3.includes("u"));
    } catch {
      return;
    }
    UO(s3, { onCharacterClassEnter: function(y3) {
      var v3 = true, b3 = false, x3 = void 0;
      try {
        for (var C3, k3 = AA(y3.elements)[Symbol.iterator](); !(v3 = (C3 = k3.next()).done); v3 = true) {
          var F3 = C3.value, B3 = true, O3 = false, S3 = void 0;
          try {
            for (var w3, D3 = _2[Symbol.iterator](); !(B3 = (w3 = D3.next()).done); B3 = true) {
              var I3 = w3.value;
              o3[I3] = o3[I3] || _A[I3](F3);
            }
          } catch (L3) {
            O3 = true, S3 = L3;
          } finally {
            try {
              B3 || D3.return == null || D3.return();
            } finally {
              if (O3)
                throw S3;
            }
          }
        }
      } catch (L3) {
        b3 = true, x3 = L3;
      } finally {
        try {
          v3 || k3.return == null || k3.return();
        } finally {
          if (b3)
            throw x3;
        }
      }
    } });
    var u3 = true, c3 = false, f3 = void 0;
    try {
      for (var p3, d3 = _2[Symbol.iterator](); !(u3 = (p3 = d3.next()).done); u3 = true) {
        var m3 = p3.value;
        o3[m3] && e28.report({ node: r3, messageId: m3 });
      }
    } catch (y3) {
      c3 = true, f3 = y3;
    } finally {
      try {
        u3 || d3.return == null || d3.return();
      } finally {
        if (c3)
          throw f3;
      }
    }
  }
  var n3 = new VO();
  return { "Literal[regex]": function(r3) {
    t3(r3, r3.regex.pattern, r3.regex.flags);
  }, Program: function() {
    var r3 = e28.getScope(), i = new MO(r3), a3 = true, s3 = false, o3 = void 0;
    try {
      for (var u3, c3 = i.iterateGlobalReferences({ RegExp: (f3 = {}, Fn$1(f3, jO, true), Fn$1(f3, RO, true), f3) })[Symbol.iterator](); !(a3 = (u3 = c3.next()).done); a3 = true) {
        var f3, p3 = u3.value.node, d3 = bn$1(p3.arguments, 2), m3 = d3[0], y3 = d3[1], v3 = D2(m3, r3), b3 = D2(y3, r3);
        typeof v3 == "string" && t3(p3, v3, b3 || "");
      }
    } catch (x3) {
      s3 = true, o3 = x3;
    } finally {
      try {
        a3 || c3.return == null || c3.return();
      } finally {
        if (s3)
          throw o3;
      }
    }
  } };
} }, TA = ["+", "-", "*", "/", "%", "**"], PA = ["&", "|", "^", "~", "<<", ">>", ">>>"], IA = ["==", "!=", "===", "!==", ">", ">=", "<", "<="], BA = ["&&", "||"], OA = ["in", "instanceof"], $O = [].concat(TA, PA, IA, BA, OA, ["?:"]), GO = [TA, PA, IA, BA, OA], T2 = /^(?:Binary|Logical|Conditional)Expression$/;
function tm(e28) {
  return e28.type === "ConditionalExpression" ? e28.test : e28.left;
}
var zO = { meta: { type: "suggestion", docs: { description: "disallow mixed binary operators", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-mixed-operators" }, schema: [{ type: "object", properties: { groups: { type: "array", items: { type: "array", items: { enum: $O }, minItems: 2, uniqueItems: true }, uniqueItems: true }, allowSamePrecedence: { type: "boolean", default: true } }, additionalProperties: false }] }, create: function(e28) {
  function t3(o3) {
    var u3 = o3, c3 = o3.parent;
    return !function(f3, p3, d3) {
      return f3.some(function(m3) {
        return m3.indexOf(p3) !== -1 && m3.indexOf(d3) !== -1;
      });
    }(s3.groups, u3.operator, c3.type === "ConditionalExpression" ? "?:" : c3.operator) || s3.allowSamePrecedence && P$s.getPrecedence(u3) === P$s.getPrecedence(c3);
  }
  function n3(o3) {
    return a3.getTokenAfter(tm(o3), P$s.isNotClosingParenToken);
  }
  function r3(o3) {
    var u3 = o3.parent, c3 = tm(u3) === o3 ? o3 : u3, f3 = tm(u3) === o3 ? u3 : o3, p3 = "Unexpected mix of '{{leftOperator}}' and '{{rightOperator}}'.", d3 = { leftOperator: c3.operator || "?:", rightOperator: f3.operator || "?:" };
    e28.report({ node: c3, loc: n3(c3).loc, message: p3, data: d3 }), e28.report({ node: f3, loc: n3(f3).loc, message: p3, data: d3 });
  }
  function i(o3) {
    T2.test(o3.parent.type) && (o3.parent.type === "ConditionalExpression" && !t3(o3) && function(u3) {
      return !P$s.isParenthesised(a3, u3) && !P$s.isParenthesised(a3, u3.test);
    }(o3.parent) || T2.test(o3.parent.type) && function(u3) {
      return u3.operator !== u3.parent.operator && !P$s.isParenthesised(a3, u3);
    }(o3) && !t3(o3)) && r3(o3);
  }
  var a3 = e28.getSourceCode(), s3 = function() {
    var o3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return { groups: o3.groups && 0 < o3.groups.length ? o3.groups : GO, allowSamePrecedence: o3.allowSamePrecedence !== false };
  }(e28.options[0]);
  return { BinaryExpression: i, LogicalExpression: i };
} }, HO = { meta: { type: "suggestion", docs: { description: "disallow `require` calls to be mixed with regular variable declarations", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-mixed-requires" }, schema: [{ oneOf: [{ type: "boolean" }, { type: "object", properties: { grouping: { type: "boolean" }, allowCall: { type: "boolean" } }, additionalProperties: false }] }] }, create: function(e28) {
  function t3(d3) {
    return d3 ? d3.type === "CallExpression" && d3.callee.type === "Identifier" && d3.callee.name === "require" ? "require" : s3 && d3.type === "CallExpression" && d3.callee.type === "CallExpression" ? t3(d3.callee) : d3.type === "MemberExpression" ? t3(d3.object) : "other" : "uninitialized";
  }
  function n3(d3) {
    var m3 = {};
    return d3.forEach(function(y3) {
      var v3 = t3(y3.init);
      m3[v3] = true;
    }), !(!m3[u3] || !m3[c3] && !m3[f3]);
  }
  function r3(d3) {
    var m3 = {};
    return d3.forEach(function(y3) {
      t3(y3.init) === u3 && (m3[function v3(b3) {
        if (b3.type === "MemberExpression")
          return v3(b3.object);
        if (b3.arguments.length === 0)
          return p3;
        var x3 = b3.arguments[0];
        return x3.type !== "Literal" || typeof x3.value != "string" ? "computed" : o3.indexOf(x3.value) === -1 ? /^\.{0,2}\//.test(x3.value) ? "file" : "module" : "core";
      }(y3.init)] = true);
    }), 1 >= Object.keys(m3).length;
  }
  var i = e28.options[0], a3 = false, s3 = false;
  xe$3(i) == "object" ? (a3 = i.grouping, s3 = i.allowCall) : a3 = !!i;
  var o3 = ["assert", "buffer", "child_process", "cluster", "crypto", "dgram", "dns", "domain", "events", "fs", "http", "https", "net", "os", "path", "punycode", "querystring", "readline", "repl", "smalloc", "stream", "string_decoder", "tls", "tty", "url", "util", "v8", "vm", "zlib"], u3 = "require", c3 = "uninitialized", f3 = "other", p3 = "computed";
  return { VariableDeclaration: function(d3) {
    n3(d3.declarations) ? e28.report({ node: d3, message: "Do not mix 'require' and other declarations." }) : a3 && !r3(d3.declarations) && e28.report({ node: d3, message: "Do not mix core, module, file and computed requires." });
  } };
} }, KO = { meta: { type: "layout", docs: { description: "disallow multiple spaces", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-multi-spaces" }, fixable: "whitespace", schema: [{ type: "object", properties: { exceptions: { type: "object", patternProperties: { "^([A-Z][a-z]*)+$": { type: "boolean" } }, additionalProperties: false }, ignoreEOLComments: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e28) {
  function t3(o3) {
    var u3 = o3.value.split(`
`), c3 = u3[0], f3 = "".concat(c3.slice(0, 12), "...");
    return u3.length === 1 && 12 >= c3.length ? c3 : f3;
  }
  var n3 = e28.getSourceCode(), r3 = e28.options[0] || {}, i = r3.ignoreEOLComments, a3 = Object.assign({ Property: true }, r3.exceptions), s3 = 0 < Object.keys(a3).filter(function(o3) {
    return a3[o3];
  }).length;
  return { Program: function() {
    n3.tokensAndComments.forEach(function(o3, u3, c3) {
      if (u3 !== c3.length - 1) {
        var f3 = c3[u3 + 1];
        if (n3.text.slice(o3.range[1], f3.range[0]).includes("  ") && !(o3.loc.end.line < f3.loc.start.line) && !(i && P$s.isCommentToken(f3) && (u3 === c3.length - 2 || f3.loc.end.line < c3[u3 + 2].loc.start.line))) {
          if (s3) {
            var p3 = n3.getNodeByRangeIndex(f3.range[0] - 1);
            if (p3 && a3[p3.type])
              return;
          }
          var d3;
          d3 = f3.type === "Block" ? "/*".concat(t3(f3), "*/") : f3.type === "Line" ? "//".concat(t3(f3)) : f3.value, e28.report({ node: f3, loc: { start: o3.loc.end, end: f3.loc.start }, message: "Multiple spaces found before '{{displayValue}}'.", data: { displayValue: d3 }, fix: function(m3) {
            return m3.replaceTextRange([o3.range[1], f3.range[0]], " ");
          } });
        }
      }
    });
  } };
} }, JO = { meta: { type: "suggestion", docs: { description: "disallow multiline strings", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-multi-str" }, schema: [] }, create: function(e28) {
  return { Literal: function(t3) {
    P$s.LINEBREAK_MATCHER.test(t3.raw) && !function(n3) {
      return n3.type.indexOf("JSX") === 0;
    }(t3.parent) && e28.report({ node: t3, message: "Multiline support is limited to browsers supporting ES5 only." });
  } };
} }, QO = { meta: { type: "layout", docs: { description: "disallow multiple empty lines", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-multiple-empty-lines" }, fixable: "whitespace", schema: [{ type: "object", properties: { max: { type: "integer", minimum: 0 }, maxEOF: { type: "integer", minimum: 0 }, maxBOF: { type: "integer", minimum: 0 } }, required: ["max"], additionalProperties: false }] }, create: function(e28) {
  var t3 = 2, n3 = t3, r3 = t3;
  e28.options.length && (t3 = e28.options[0].max, n3 = e28.options[0].maxEOF === void 0 ? t3 : e28.options[0].maxEOF, r3 = e28.options[0].maxBOF === void 0 ? t3 : e28.options[0].maxBOF);
  var i = e28.getSourceCode(), a3 = i.lines[i.lines.length - 1] === "" ? i.lines.slice(0, -1) : i.lines, s3 = /* @__PURE__ */ new Set();
  return { TemplateLiteral: function(o3) {
    o3.quasis.forEach(function(u3) {
      for (var c3 = u3.loc.start.line; c3 < u3.loc.end.line; c3++)
        s3.add(c3);
    });
  }, "Program:exit": function(o3) {
    return a3.reduce(function(u3, c3, f3) {
      return (c3.trim() || s3.has(f3 + 1)) && u3.push(f3 + 1), u3;
    }, []).concat(a3.length + 1).reduce(function(u3, c3) {
      var f3, p3;
      return u3 === 0 ? (f3 = "Too many blank lines at the beginning of file. Max of {{max}} allowed.", p3 = r3) : c3 === a3.length + 1 ? (f3 = "Too many blank lines at the end of file. Max of {{max}} allowed.", p3 = n3) : (f3 = "More than {{max}} blank {{pluralizedLines}} not allowed.", p3 = t3), c3 - u3 - 1 > p3 && e28.report({ node: o3, loc: { start: { line: u3 + 1, column: 0 }, end: { line: c3, column: 0 } }, message: f3, data: { max: p3, pluralizedLines: p3 === 1 ? "line" : "lines" }, fix: function(d3) {
        var m3 = i.getIndexFromLoc({ line: u3 + 1, column: 0 }), y3 = c3 - p3, v3 = y3 <= a3.length ? i.getIndexFromLoc({ line: y3, column: 0 }) : i.text.length;
        return d3.removeRange([m3, v3]);
      } }), c3;
    }, 0);
  } };
} }, LA = ye$4.require$$0, XO = LA.CALL, YO = LA.ReferenceTracker, ZO = ["Atomics", "JSON", "Math", "Reflect"], eL = { meta: { type: "problem", docs: { description: "disallow calling global object properties as functions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-obj-calls" }, schema: [], messages: { unexpectedCall: "'{{name}}' is not a function." } }, create: function(e28) {
  return { Program: function() {
    var t3 = e28.getScope(), n3 = new YO(t3), r3 = {}, i = true, a3 = false, s3 = void 0;
    try {
      for (var o3, u3 = ZO[Symbol.iterator](); !(i = (o3 = u3.next()).done); i = true)
        r3[o3.value] = Fn$1({}, XO, true);
    } catch (v3) {
      a3 = true, s3 = v3;
    } finally {
      try {
        i || u3.return == null || u3.return();
      } finally {
        if (a3)
          throw s3;
      }
    }
    var c3 = true, f3 = false, p3 = void 0;
    try {
      for (var d3, m3 = n3.iterateGlobalReferences(r3)[Symbol.iterator](); !(c3 = (d3 = m3.next()).done); c3 = true) {
        var y3 = d3.value.node;
        e28.report({ node: y3, messageId: "unexpectedCall", data: { name: y3.callee.name } });
      }
    } catch (v3) {
      f3 = true, p3 = v3;
    } finally {
      try {
        c3 || m3.return == null || m3.return();
      } finally {
        if (f3)
          throw p3;
      }
    }
  } };
} }, tL = /(?:Statement|Declaration|Function(?:Expression)?|Program)$/, nL = { meta: { type: "suggestion", docs: { description: "disallow reassigning `function` parameters", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-param-reassign" }, schema: [{ oneOf: [{ type: "object", properties: { props: { enum: [false] } }, additionalProperties: false }, { type: "object", properties: { props: { enum: [true] }, ignorePropertyModificationsFor: { type: "array", items: { type: "string" }, uniqueItems: true }, ignorePropertyModificationsForRegex: { type: "array", items: { type: "string" }, uniqueItems: true } }, additionalProperties: false }] }] }, create: function(e28) {
  function t3(u3) {
    return s3.includes(u3) || o3.some(function(c3) {
      return new RegExp(c3, "u").test(u3);
    });
  }
  function n3(u3, c3, f3) {
    var p3 = u3.identifier;
    p3 && !u3.init && (c3 === 0 || f3[c3 - 1].identifier !== p3) && (u3.isWrite() ? e28.report({ node: p3, message: "Assignment to function parameter '{{name}}'.", data: { name: p3.name } }) : a3 && function(d3) {
      for (var m3 = d3.identifier, y3 = m3.parent; y3 && (!tL.test(y3.type) || y3.type === "ForInStatement" || y3.type === "ForOfStatement"); ) {
        switch (y3.type) {
          case "AssignmentExpression":
            return y3.left === m3;
          case "UpdateExpression":
            return true;
          case "UnaryExpression":
            if (y3.operator === "delete")
              return true;
            break;
          case "ForInStatement":
          case "ForOfStatement":
            return y3.left === m3;
          case "CallExpression":
            if (y3.callee !== m3)
              return false;
            break;
          case "MemberExpression":
            if (y3.property === m3)
              return false;
            break;
          case "Property":
            if (y3.key === m3)
              return false;
            break;
          case "ConditionalExpression":
            if (y3.test === m3)
              return false;
        }
        y3 = (m3 = y3).parent;
      }
      return false;
    }(u3) && !t3(p3.name) && e28.report({ node: p3, message: "Assignment to property of function parameter '{{name}}'.", data: { name: p3.name } }));
  }
  function r3(u3) {
    u3.defs[0].type === "Parameter" && u3.references.forEach(n3);
  }
  function i(u3) {
    e28.getDeclaredVariables(u3).forEach(r3);
  }
  var a3 = e28.options[0] && e28.options[0].props, s3 = e28.options[0] && e28.options[0].ignorePropertyModificationsFor || [], o3 = e28.options[0] && e28.options[0].ignorePropertyModificationsForRegex || [];
  return { "FunctionDeclaration:exit": i, "FunctionExpression:exit": i, "ArrowFunctionExpression:exit": i };
} }, rL = { meta: { type: "suggestion", docs: { description: "disallow the unary operators `++` and `--`", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-plusplus" }, schema: [{ type: "object", properties: { allowForLoopAfterthoughts: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e28) {
  var t3 = e28.options[0], n3 = false;
  return xe$3(t3) == "object" && (n3 = t3.allowForLoopAfterthoughts === true), { UpdateExpression: function(r3) {
    n3 && r3.parent.type === "ForStatement" || e28.report({ node: r3, message: "Unary operator '{{operator}}' used.", data: { operator: r3.operator } });
  } };
} }, iL = { meta: { type: "suggestion", docs: { description: "disallow variable redeclaration", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-redeclare" }, messages: { redeclared: "'{{id}}' is already defined.", redeclaredAsBuiltin: "'{{id}}' is already defined as a built-in global variable.", redeclaredBySyntax: "'{{id}}' is already defined by a variable declaration." }, schema: [{ type: "object", properties: { builtinGlobals: { type: "boolean", default: true } }, additionalProperties: false }] }, create: function(e28) {
  var t3 = regeneratorRuntime.mark(n3);
  function n3(o3) {
    var u3, c3, f3, p3, d3, m3, y3, v3, b3, x3, C3, k3;
    return regeneratorRuntime.wrap(function(F3) {
      for (; ; )
        switch (F3.prev = F3.next) {
          case 0:
            if (F3.t0 = a3.builtinGlobals && (o3.eslintImplicitGlobalSetting === "readonly" || o3.eslintImplicitGlobalSetting === "writable"), !F3.t0) {
              F3.next = 4;
              break;
            }
            return F3.next = 4, { type: "builtin" };
          case 4:
            u3 = true, c3 = false, f3 = void 0, F3.prev = 7, p3 = o3.identifiers[Symbol.iterator]();
          case 9:
            if (u3 = (d3 = p3.next()).done) {
              F3.next = 16;
              break;
            }
            return m3 = d3.value, F3.next = 13, { type: "syntax", node: m3, loc: m3.loc };
          case 13:
            u3 = true, F3.next = 9;
            break;
          case 16:
            F3.next = 22;
            break;
          case 18:
            F3.prev = 18, F3.t1 = F3.catch(7), c3 = true, f3 = F3.t1;
          case 22:
            F3.prev = 22, F3.prev = 23, u3 || p3.return == null || p3.return();
          case 25:
            if (F3.prev = 25, !c3) {
              F3.next = 28;
              break;
            }
            throw f3;
          case 28:
            return F3.finish(25);
          case 29:
            return F3.finish(22);
          case 30:
            if (!o3.eslintExplicitGlobalComments) {
              F3.next = 57;
              break;
            }
            y3 = true, v3 = false, b3 = void 0, F3.prev = 34, x3 = o3.eslintExplicitGlobalComments[Symbol.iterator]();
          case 36:
            if (y3 = (C3 = x3.next()).done) {
              F3.next = 43;
              break;
            }
            return k3 = C3.value, F3.next = 40, { type: "comment", node: k3, loc: P$s.getNameLocationInGlobalDirectiveComment(s3, k3, o3.name) };
          case 40:
            y3 = true, F3.next = 36;
            break;
          case 43:
            F3.next = 49;
            break;
          case 45:
            F3.prev = 45, F3.t2 = F3.catch(34), v3 = true, b3 = F3.t2;
          case 49:
            F3.prev = 49, F3.prev = 50, y3 || x3.return == null || x3.return();
          case 52:
            if (F3.prev = 52, !v3) {
              F3.next = 55;
              break;
            }
            throw b3;
          case 55:
            return F3.finish(52);
          case 56:
            return F3.finish(49);
          case 57:
          case "end":
            return F3.stop();
        }
    }, t3, null, [[7, 18, 22, 30], [23, , 25, 29], [34, 45, 49, 57], [50, , 52, 56]]);
  }
  function r3(o3) {
    var u3, c3 = true, f3 = false, p3 = void 0;
    try {
      for (var d3, m3 = o3.variables[Symbol.iterator](); !(c3 = (d3 = m3.next()).done); c3 = true) {
        var y3 = d3.value, v3 = n3(y3), b3 = nE(u3 = v3) || rE(u3) || iE(), x3 = b3[0], C3 = b3.slice(1);
        if (C3.length !== 0) {
          var k3 = x3.type === "builtin" ? "redeclaredAsBuiltin" : "redeclaredBySyntax", F3 = { id: y3.name }, B3 = true, O3 = false, S3 = void 0;
          try {
            for (var w3, D3 = C3[Symbol.iterator](); !(B3 = (w3 = D3.next()).done); B3 = true) {
              var I3 = w3.value, L3 = I3.type, V10 = I3.node, K3 = I3.loc, W3 = L3 === x3.type ? "redeclared" : k3;
              e28.report({ node: V10, loc: K3, messageId: W3, data: F3 });
            }
          } catch (R3) {
            O3 = true, S3 = R3;
          } finally {
            try {
              B3 || D3.return == null || D3.return();
            } finally {
              if (O3)
                throw S3;
            }
          }
        }
      }
    } catch (R3) {
      f3 = true, p3 = R3;
    } finally {
      try {
        c3 || m3.return == null || m3.return();
      } finally {
        if (f3)
          throw p3;
      }
    }
  }
  function i(o3) {
    var u3 = e28.getScope();
    u3.block === o3 && r3(u3);
  }
  var a3 = { builtinGlobals: !(e28.options.length !== 0 && !e28.options[0].builtinGlobals) }, s3 = e28.getSourceCode();
  return { Program: function() {
    var o3 = e28.getScope();
    r3(o3), o3.type === "global" && o3.childScopes[0] && o3.block === o3.childScopes[0].block && r3(o3.childScopes[0]);
  }, FunctionDeclaration: i, FunctionExpression: i, ArrowFunctionExpression: i, BlockStatement: i, ForStatement: i, ForInStatement: i, ForOfStatement: i, SwitchStatement: i };
} }, aL = new ao$1.RegExpParser(), oL = / {2}/;
function P2(e28) {
  return e28 && e28.type === "Literal" && typeof e28.value == "string";
}
var sL = { meta: { type: "suggestion", docs: { description: "disallow multiple spaces in regular expressions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-regex-spaces" }, schema: [], fixable: "code" }, create: function(e28) {
  function t3(r3, i, a3, s3, o3) {
    if (oL.test(a3)) {
      var u3, c3 = [];
      try {
        u3 = aL.parsePattern(i, 0, i.length, o3.includes("u"));
      } catch {
        return;
      }
      ao$1.visitRegExpAST(u3, { onCharacterClassEnter: function(y3) {
        c3.push(y3);
      } });
      for (var f3, p3 = /( {2,})(?: [\*\+\?\{]|(?:[\0-\),->@-z\|-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|$)/g, d3 = function(y3) {
        var v3 = y3[1].length, b3 = y3.index;
        if (c3.every(function(x3) {
          var C3 = x3.start, k3 = x3.end;
          return b3 < C3 || k3 <= b3;
        }))
          return { v: void e28.report({ node: r3, message: "Spaces are hard to count. Use {{{length}}}.", data: { length: v3 }, fix: function(x3) {
            return i === a3 ? x3.replaceTextRange([s3 + b3, s3 + b3 + v3], " {".concat(v3, "}")) : null;
          } }) };
      }; f3 = p3.exec(i); ) {
        var m3 = d3(f3);
        if (xe$3(m3) === "object")
          return m3.v;
      }
    }
  }
  function n3(r3) {
    var i = e28.getScope(), a3 = P$s.getVariableByName(i, "RegExp"), s3 = a3 && 0 < a3.defs.length, o3 = r3.arguments[0], u3 = r3.arguments[1];
    r3.callee.type === "Identifier" && r3.callee.name === "RegExp" && P2(o3) && !s3 && t3(r3, o3.value, o3.raw.slice(1, -1), o3.range[0] + 1, P2(u3) ? u3.value : "");
  }
  return { Literal: function(r3) {
    if (r3.regex) {
      var i = r3.regex.pattern, a3 = r3.raw.slice(1, r3.raw.lastIndexOf("/"));
      t3(r3, i, a3, r3.range[0] + 1, r3.regex.flags);
    }
  }, CallExpression: n3, NewExpression: n3 };
} }, uL = "Unexpected use of '{{name}}'.", cL = "Unexpected use of '{{name}}'. {{customMessage}}", lL = { meta: { type: "suggestion", docs: { description: "disallow specified global variables", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/no-restricted-globals" }, schema: { type: "array", items: { oneOf: [{ type: "string" }, { type: "object", properties: { name: { type: "string" }, message: { type: "string" } }, required: ["name"], additionalProperties: false }] }, uniqueItems: true, minItems: 0 } }, create: function(e28) {
  function t3(i) {
    var a3 = i.identifier.name, s3 = r3[a3], o3 = s3 ? cL : uL;
    e28.report({ node: i.identifier, message: o3, data: { name: a3, customMessage: s3 } });
  }
  function n3(i) {
    return Object.prototype.hasOwnProperty.call(r3, i);
  }
  if (e28.options.length === 0)
    return {};
  var r3 = e28.options.reduce(function(i, a3) {
    return typeof a3 == "string" ? i[a3] = null : i[a3.name] = a3.message, i;
  }, {});
  return { Program: function() {
    var i = e28.getScope();
    i.variables.forEach(function(a3) {
      !a3.defs.length && n3(a3.name) && a3.references.forEach(t3);
    }), i.through.forEach(function(a3) {
      n3(a3.identifier.name) && t3(a3);
    });
  } };
} }, I2 = { type: "array", items: { anyOf: [{ type: "string" }, { type: "object", properties: { name: { type: "string" }, message: { type: "string", minLength: 1 }, importNames: { type: "array", items: { type: "string" } } }, additionalProperties: false, required: ["name"] }] }, uniqueItems: true }, pL = { meta: { type: "suggestion", docs: { description: "disallow specified modules when loaded by `import`", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/no-restricted-imports" }, messages: { path: "'{{importSource}}' import is restricted from being used.", pathWithCustomMessage: "'{{importSource}}' import is restricted from being used. {{customMessage}}", patterns: "'{{importSource}}' import is restricted from being used by a pattern.", everything: "* import is invalid because '{{importNames}}' from '{{importSource}}' is restricted.", everythingWithCustomMessage: "* import is invalid because '{{importNames}}' from '{{importSource}}' is restricted. {{customMessage}}" }, schema: { anyOf: [I2, { type: "array", items: { type: "object", properties: { paths: I2, patterns: { type: "array", items: { type: "string" }, uniqueItems: true } }, additionalProperties: false }, additionalItems: false }] } }, create: function(e28) {
  function t3(m3) {
    var y3 = m3.source.value.trim(), v3 = p3[y3] && p3[y3].message;
    e28.report({ node: m3, messageId: v3 ? "pathWithCustomMessage" : "path", data: { importSource: y3, customMessage: v3 } });
  }
  function n3(m3) {
    var y3 = m3.source.value.trim();
    e28.report({ node: m3, messageId: "patterns", data: { importSource: y3 } });
  }
  function r3(m3, y3) {
    var v3 = p3[m3].importNames, b3 = p3[m3] && p3[m3].message;
    e28.report({ node: y3, messageId: b3 ? "everythingWithCustomMessage" : "everything", data: { importSource: m3, importNames: v3, customMessage: b3 } });
  }
  function i(m3, y3) {
    return Object.prototype.hasOwnProperty.call(p3, m3) && p3[m3].importNames && function(v3) {
      return v3.has("*");
    }(y3);
  }
  function a3(m3, y3) {
    var v3 = false;
    return Object.prototype.hasOwnProperty.call(p3, m3) && (v3 = !p3[m3].importNames || function(b3, x3) {
      return x3.some(function(C3) {
        return b3.has(C3);
      });
    }(y3, p3[m3].importNames)), v3;
  }
  function s3(m3) {
    var y3 = m3.source.value.trim(), v3 = m3.specifiers ? m3.specifiers.reduce(function(b3, x3) {
      return x3.type === "ImportDefaultSpecifier" ? b3.add("default") : x3.type === "ImportNamespaceSpecifier" ? b3.add("*") : x3.imported ? b3.add(x3.imported.name) : x3.local && b3.add(x3.local.name), b3;
    }, /* @__PURE__ */ new Set()) : /* @__PURE__ */ new Set();
    i(y3, v3) && r3(y3, m3), a3(y3, v3) && t3(m3), function(b3) {
      return 0 < f3.length && d3.ignores(b3);
    }(y3) && n3(m3);
  }
  var o3 = Array.isArray(e28.options) ? e28.options : [], u3 = xe$3(o3[0]) == "object" && (Object.prototype.hasOwnProperty.call(o3[0], "paths") || Object.prototype.hasOwnProperty.call(o3[0], "patterns")), c3 = (u3 ? o3[0].paths : e28.options) || [], f3 = (u3 ? o3[0].patterns : []) || [], p3 = c3.reduce(function(m3, y3) {
    return typeof y3 == "string" ? m3[y3] = { message: null } : m3[y3.name] = { message: y3.message, importNames: y3.importNames }, m3;
  }, {});
  if (Object.keys(c3).length === 0 && f3.length === 0)
    return {};
  var d3 = CA().add(f3);
  return { ImportDeclaration: s3, ExportNamedDeclaration: function(m3) {
    m3.source && s3(m3);
  }, ExportAllDeclaration: s3 };
} }, fL = "'{{moduleName}}' module is restricted from being used.", hL = "'{{moduleName}}' module is restricted from being used. {{customMessage}}", B2 = { type: "array", items: { anyOf: [{ type: "string" }, { type: "object", properties: { name: { type: "string" }, message: { type: "string", minLength: 1 } }, additionalProperties: false, required: ["name"] }] }, uniqueItems: true }, dL = { meta: { type: "suggestion", docs: { description: "disallow specified modules when loaded by `require`", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-restricted-modules" }, schema: { anyOf: [B2, { type: "array", items: { type: "object", properties: { paths: B2, patterns: { type: "array", items: { type: "string" }, uniqueItems: true } }, additionalProperties: false }, additionalItems: false }] } }, create: function(e28) {
  var t3 = Array.isArray(e28.options) ? e28.options : [], n3 = xe$3(t3[0]) == "object" && (Object.prototype.hasOwnProperty.call(t3[0], "paths") || Object.prototype.hasOwnProperty.call(t3[0], "patterns")), r3 = (n3 ? t3[0].paths : e28.options) || [], i = (n3 ? t3[0].patterns : []) || [], a3 = r3.reduce(function(o3, u3) {
    return typeof u3 == "string" ? o3[u3] = null : o3[u3.name] = u3.message, o3;
  }, {});
  if (Object.keys(r3).length === 0 && i.length === 0)
    return {};
  var s3 = CA().add(i);
  return { CallExpression: function(o3) {
    if (function(c3) {
      return c3.callee.type === "Identifier" && c3.callee.name === "require";
    }(o3) && o3.arguments.length && function(c3) {
      return c3 && c3.type === "Literal" && typeof c3.value == "string";
    }(o3.arguments[0])) {
      var u3 = o3.arguments[0].value.trim();
      (function(c3) {
        return Object.prototype.hasOwnProperty.call(a3, c3);
      })(u3) && function(c3) {
        var f3 = c3.arguments[0].value.trim(), p3 = a3[f3], d3 = p3 ? hL : fL;
        e28.report({ node: c3, message: d3, data: { moduleName: f3, customMessage: p3 } });
      }(o3), 0 < i.length && s3.ignores(u3) && e28.report({ node: o3, message: "'{{moduleName}}' module is restricted from being used by a pattern.", data: { moduleName: u3 } });
    }
  } };
} }, mL = { meta: { type: "suggestion", docs: { description: "disallow certain properties on certain objects", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-restricted-properties" }, schema: { type: "array", items: { anyOf: [{ type: "object", properties: { object: { type: "string" }, property: { type: "string" }, message: { type: "string" } }, additionalProperties: false, required: ["object"] }, { type: "object", properties: { object: { type: "string" }, property: { type: "string" }, message: { type: "string" } }, additionalProperties: false, required: ["property"] }] }, uniqueItems: true } }, create: function(e28) {
  function t3(o3, u3, c3) {
    if (c3 !== null) {
      var f3 = i.get(u3), p3 = f3 ? f3.get(c3) : a3.get(u3), d3 = s3.get(c3);
      if (p3) {
        var m3 = p3.message ? " ".concat(p3.message) : "";
        e28.report({ node: o3, message: "'{{objectName}}.{{propertyName}}' is restricted from being used.{{message}}", data: { objectName: u3, propertyName: c3, message: m3 } });
      } else if (d3) {
        var y3 = d3.message ? " ".concat(d3.message) : "";
        e28.report({ node: o3, message: "'{{propertyName}}' is restricted from being used.{{message}}", data: { propertyName: c3, message: y3 } });
      }
    }
  }
  function n3(o3) {
    if (o3.right.type === "Identifier") {
      var u3 = o3.right.name;
      o3.left.type === "ObjectPattern" && o3.left.properties.forEach(function(c3) {
        t3(o3.left, u3, P$s.getStaticPropertyName(c3));
      });
    }
  }
  var r3 = e28.options;
  if (r3.length === 0)
    return {};
  var i = /* @__PURE__ */ new Map(), a3 = /* @__PURE__ */ new Map(), s3 = /* @__PURE__ */ new Map();
  return r3.forEach(function(o3) {
    var u3 = o3.object, c3 = o3.property;
    u3 === void 0 ? s3.set(c3, { message: o3.message }) : c3 === void 0 ? a3.set(u3, { message: o3.message }) : (!i.has(u3) && i.set(u3, /* @__PURE__ */ new Map()), i.get(u3).set(c3, { message: o3.message }));
  }), { MemberExpression: function(o3) {
    t3(o3, o3.object && o3.object.name, P$s.getStaticPropertyName(o3));
  }, VariableDeclarator: function(o3) {
    if (o3.init && o3.init.type === "Identifier") {
      var u3 = o3.init.name;
      o3.id.type === "ObjectPattern" && o3.id.properties.forEach(function(c3) {
        t3(o3.id, u3, P$s.getStaticPropertyName(c3));
      });
    }
  }, AssignmentExpression: n3, AssignmentPattern: n3 };
} }, gL = { meta: { type: "suggestion", docs: { description: "disallow specified syntax", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-restricted-syntax" }, schema: { type: "array", items: { oneOf: [{ type: "string" }, { type: "object", properties: { selector: { type: "string" }, message: { type: "string" } }, required: ["selector"], additionalProperties: false }] }, uniqueItems: true, minItems: 0 } }, create: function(e28) {
  return e28.options.reduce(function(t3, n3) {
    var r3 = typeof n3 == "string", i = !r3 && !!n3.message, a3 = r3 ? n3 : n3.selector, s3 = i ? n3.message : "Using '{{selector}}' is not allowed.";
    return Object.assign(t3, Fn$1({}, a3, function(o3) {
      e28.report({ node: o3, message: s3, data: i ? {} : { selector: a3 } });
    }));
  }, {});
} }, yL = /^(?:[A-Za-z]+?Statement|ArrowFunctionExpression|FunctionExpression|ClassExpression)$/, vL = { meta: { type: "suggestion", docs: { description: "disallow assignment operators in `return` statements", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-return-assign" }, schema: [{ enum: ["except-parens", "always"] }] }, create: function(e28) {
  var t3 = (e28.options[0] || "except-parens") !== "except-parens", n3 = e28.getSourceCode();
  return { AssignmentExpression: function(r3) {
    if (t3 || !P$s.isParenthesised(n3, r3)) {
      for (var i = r3, a3 = i.parent; a3 && !yL.test(a3.type); )
        i = a3, a3 = a3.parent;
      a3 && a3.type === "ReturnStatement" ? e28.report({ node: a3, message: "Return statement should not contain assignment." }) : a3 && a3.type === "ArrowFunctionExpression" && a3.body === i && e28.report({ node: a3, message: "Arrow function should not return assignment." });
    }
  } };
} }, xL = "Redundant use of `await` on a return value.", bL = { meta: { type: "suggestion", docs: { description: "disallow unnecessary `return await`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-return-await" }, fixable: null, schema: [] }, create: function(e28) {
  function t3(r3) {
    e28.report({ node: e28.getSourceCode().getFirstToken(r3), loc: r3.loc, message: xL });
  }
  function n3(r3) {
    for (var i = r3; !P$s.isFunction(i) && i.type !== "Program"; ) {
      if (i.parent.type === "TryStatement" && (i === i.parent.block || i === i.parent.handler && i.parent.finalizer))
        return true;
      i = i.parent;
    }
    return false;
  }
  return { AwaitExpression: function(r3) {
    (function i(a3) {
      return a3.parent.type === "ArrowFunctionExpression" || (a3.parent.type === "ReturnStatement" ? !n3(a3.parent) : a3.parent.type !== "ConditionalExpression" || a3 !== a3.parent.consequent && a3 !== a3.parent.alternate ? (a3.parent.type === "LogicalExpression" && a3 === a3.parent.right || !(a3.parent.type !== "SequenceExpression" || a3 !== a3.parent.expressions[a3.parent.expressions.length - 1])) && i(a3.parent) : i(a3.parent));
    })(r3) && !n3(r3) && t3(r3);
  } };
} }, EL = /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+/g;
function NA(e28, t3) {
  if (!function(i, a3) {
    if (i.property.type === "Identifier" && i.property.type === a3.property.type && i.property.name === a3.property.name && i.computed === a3.computed)
      return true;
    var s3 = P$s.getStaticPropertyName(i), o3 = P$s.getStaticPropertyName(a3);
    return s3 !== null && s3 === o3;
  }(e28, t3))
    return false;
  var n3 = e28.object, r3 = t3.object;
  return n3.type === r3.type && (n3.type === "MemberExpression" ? NA(n3, r3) : n3.type === "ThisExpression" || n3.type === "Identifier" && n3.name === r3.name);
}
var CL = { meta: { type: "problem", docs: { description: "disallow assignments where both sides are exactly the same", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-self-assign" }, schema: [{ type: "object", properties: { props: { type: "boolean", default: true } }, additionalProperties: false }] }, create: function(e28) {
  function t3(s3) {
    e28.report({ node: s3, message: "'{{name}}' is assigned to itself.", data: { name: n3.getText(s3).replace(EL, "") } });
  }
  var n3 = e28.getSourceCode(), r3 = bn$1(e28.options, 1)[0], i = (r3 = r3 === void 0 ? {} : r3).props, a3 = i === void 0 || i;
  return { AssignmentExpression: function(s3) {
    s3.operator === "=" && function o3(u3, c3, f3, p3) {
      if (u3 && c3)
        if (u3.type === "Identifier" && c3.type === "Identifier" && u3.name === c3.name)
          p3(c3);
        else if (u3.type === "ArrayPattern" && c3.type === "ArrayExpression")
          for (var d3 = Math.min(u3.elements.length, c3.elements.length), m3 = 0; m3 < d3; ++m3) {
            var y3 = u3.elements[m3], v3 = c3.elements[m3];
            if (y3 && y3.type === "RestElement" && m3 < c3.elements.length - 1 || (o3(y3, v3, f3, p3), v3 && v3.type === "SpreadElement"))
              break;
          }
        else if (u3.type === "RestElement" && c3.type === "SpreadElement")
          o3(u3.argument, c3.argument, f3, p3);
        else if (u3.type === "ObjectPattern" && c3.type === "ObjectExpression" && 1 <= c3.properties.length) {
          for (var b3 = 0, x3 = c3.properties.length - 1; 0 <= x3; --x3) {
            var C3 = c3.properties[x3].type;
            if (C3 === "SpreadElement" || C3 === "ExperimentalSpreadProperty") {
              b3 = x3 + 1;
              break;
            }
          }
          for (var k3 = 0; k3 < u3.properties.length; ++k3)
            for (var F3 = b3; F3 < c3.properties.length; ++F3)
              o3(u3.properties[k3], c3.properties[F3], f3, p3);
        } else if (u3.type !== "Property" || c3.type !== "Property" || c3.kind !== "init" || c3.method)
          f3 && u3.type === "MemberExpression" && c3.type === "MemberExpression" && NA(u3, c3) && p3(c3);
        else {
          var B3 = P$s.getStaticPropertyName(u3);
          B3 !== null && B3 === P$s.getStaticPropertyName(c3) && o3(u3.value, c3.value, f3, p3);
        }
    }(s3.left, s3.right, a3, t3);
  } };
} }, SL = { meta: { type: "problem", docs: { description: "disallow comparisons where both sides are exactly the same", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-self-compare" }, schema: [] }, create: function(e28) {
  function t3(r3, i) {
    var a3 = n3.getTokens(r3), s3 = n3.getTokens(i);
    return a3.length === s3.length && a3.every(function(o3, u3) {
      return o3.type === s3[u3].type && o3.value === s3[u3].value;
    });
  }
  var n3 = e28.getSourceCode();
  return { BinaryExpression: function(r3) {
    (/* @__PURE__ */ new Set(["===", "==", "!==", "!=", ">", "<", ">=", "<="])).has(r3.operator) && t3(r3.left, r3.right) && e28.report({ node: r3, message: "Comparing to itself is potentially pointless." });
  } };
} }, kL = { meta: { type: "suggestion", docs: { description: "disallow comma operators", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-sequences" }, schema: [] }, create: function(e28) {
  function t3(a3) {
    return a3.parent && i[a3.parent.type] && a3 === a3.parent[i[a3.parent.type]];
  }
  function n3(a3) {
    return P$s.isParenthesised(r3, a3);
  }
  var r3 = e28.getSourceCode(), i = { DoWhileStatement: "test", IfStatement: "test", SwitchStatement: "discriminant", WhileStatement: "test", WithStatement: "object", ArrowFunctionExpression: "body" };
  return { SequenceExpression: function(a3) {
    if (a3.parent.type !== "ForStatement" || a3 !== a3.parent.init && a3 !== a3.parent.update) {
      if (t3(a3)) {
        if (function(o3) {
          var u3 = r3.getTokenBefore(o3, 1), c3 = r3.getTokenAfter(o3, 1);
          return n3(o3) && u3 && c3 && P$s.isOpeningParenToken(u3) && u3.range[1] <= o3.range[0] && P$s.isClosingParenToken(c3) && c3.range[0] >= o3.range[1];
        }(a3))
          return;
      } else if (n3(a3))
        return;
      var s3 = r3.getTokenAfter(a3.expressions[0], P$s.isCommaToken);
      e28.report({ node: a3, loc: s3.loc, message: "Unexpected use of comma operator." });
    }
  } };
} }, DL = ye$4.require$$0.findVariable;
function Yl(e28, t3, n3, r3, i) {
  var a3 = e28.parent;
  return a3.type === "CallExpression" && a3.arguments[i] === e28 && a3.callee.type === "MemberExpression" && P$s.getStaticPropertyName(a3.callee) === r3 && a3.callee.object.type === "Identifier" && a3.callee.object.name === n3 && function(s3, o3) {
    var u3 = DL(o3, s3);
    return u3 !== null && u3.scope.type === "global" && u3.defs.length === 0;
  }(a3.callee.object, t3);
}
function FL(e28, t3) {
  var n3 = e28.parent;
  return !(n3.kind !== "set" || n3.value !== e28) || !(n3.type !== "Property" || n3.value !== e28 || P$s.getStaticPropertyName(n3) !== "set" || n3.parent.type !== "ObjectExpression" || !function(r3, i) {
    if (Yl(r3, i, "Object", "defineProperty", 2) || Yl(r3, i, "Reflect", "defineProperty", 2))
      return true;
    var a3 = r3.parent;
    if (a3.type === "Property" && a3.value === r3) {
      var s3 = a3.parent;
      if (s3.type === "ObjectExpression" && (Yl(s3, i, "Object", "create", 1) || Yl(s3, i, "Object", "defineProperties", 1)))
        return true;
    }
    return false;
  }(n3.parent, t3));
}
var wL = { meta: { type: "problem", docs: { description: "disallow returning values from setters", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-setter-return" }, schema: [], messages: { returnsValue: "Setter cannot return a value." } }, create: function(e28) {
  function t3(a3) {
    var s3 = function(o3) {
      var u3 = o3.upper;
      return u3.type === "function-expression-name" ? u3.upper : u3;
    }(e28.getScope());
    i = { upper: i, isSetter: FL(a3, s3) };
  }
  function n3() {
    i = i.upper;
  }
  function r3(a3) {
    e28.report({ node: a3, messageId: "returnsValue" });
  }
  var i = null;
  return { FunctionDeclaration: t3, FunctionExpression: t3, ArrowFunctionExpression: function(a3) {
    t3(a3), i.isSetter && a3.expression && r3(a3.body);
  }, "FunctionDeclaration:exit": n3, "FunctionExpression:exit": n3, "ArrowFunctionExpression:exit": n3, ReturnStatement: function(a3) {
    i && i.isSetter && a3.argument && r3(a3);
  } };
} };
function AL(e28) {
  return e28.name === "undefined" && e28.references.every(function(t3) {
    return !t3.isWrite();
  }) && e28.defs.every(function(t3) {
    return t3.node.type === "VariableDeclarator" && t3.node.init === null;
  });
}
var _L = { meta: { type: "suggestion", docs: { description: "disallow identifiers from shadowing restricted names", category: "Variables", recommended: true, url: "https://eslint.org/docs/rules/no-shadow-restricted-names" }, schema: [] }, create: function(e28) {
  var t3 = /* @__PURE__ */ new Set(["undefined", "NaN", "Infinity", "arguments", "eval"]);
  return { "VariableDeclaration, :function, CatchClause": function(n3) {
    var r3 = true, i = false, a3 = void 0;
    try {
      for (var s3, o3 = e28.getDeclaredVariables(n3)[Symbol.iterator](); !(r3 = (s3 = o3.next()).done); r3 = true) {
        var u3 = s3.value;
        0 < u3.defs.length && t3.has(u3.name) && !AL(u3) && e28.report({ node: u3.defs[0].name, message: "Shadowing of global property '{{idName}}'.", data: { idName: u3.name } });
      }
    } catch (c3) {
      i = true, a3 = c3;
    } finally {
      try {
        r3 || o3.return == null || o3.return();
      } finally {
        if (i)
          throw a3;
      }
    }
  } };
} }, TL = { meta: { type: "suggestion", docs: { description: "disallow variable declarations from shadowing variables declared in the outer scope", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/no-shadow" }, schema: [{ type: "object", properties: { builtinGlobals: { type: "boolean", default: false }, hoist: { enum: ["all", "functions", "never"], default: "functions" }, allow: { type: "array", items: { type: "string" } } }, additionalProperties: false }] }, create: function(e28) {
  function t3(u3) {
    return o3.allow.indexOf(u3.name) !== -1;
  }
  function n3(u3) {
    var c3 = u3.scope.block;
    return c3.type === "ClassDeclaration" && c3.id === u3.identifiers[0];
  }
  function r3(u3, c3) {
    var f3 = c3.scope, p3 = c3.defs[0], d3 = p3 && p3.parent && p3.parent.range, m3 = u3.scope, y3 = u3.defs[0], v3 = y3 && y3.name.range;
    return d3 && v3 && d3[0] < v3[0] && v3[1] < d3[1] && (y3.type === "FunctionName" && y3.node.type === "FunctionExpression" || y3.node.type === "ClassExpression") && f3 === m3.upper;
  }
  function i(u3) {
    var c3 = u3.defs[0];
    return c3 && c3.name.range;
  }
  function a3(u3, c3) {
    var f3 = c3.defs[0], p3 = i(u3), d3 = i(c3);
    return p3 && d3 && p3[1] < d3[0] && (o3.hoist !== "functions" || !f3 || f3.node.type !== "FunctionDeclaration");
  }
  function s3(u3) {
    for (var c3 = u3.variables, f3 = 0; f3 < c3.length; ++f3) {
      var p3 = c3[f3];
      if (p3.identifiers.length !== 0 && !n3(p3) && !t3(p3)) {
        var d3 = P$s.getVariableByName(u3.upper, p3.name);
        d3 && (0 < d3.identifiers.length || o3.builtinGlobals && "writeable" in d3) && !r3(p3, d3) && (o3.hoist === "all" || !a3(p3, d3)) && e28.report({ node: p3.identifiers[0], message: "'{{name}}' is already declared in the upper scope.", data: p3 });
      }
    }
  }
  var o3 = { builtinGlobals: e28.options[0] && e28.options[0].builtinGlobals, hoist: e28.options[0] && e28.options[0].hoist || "functions", allow: e28.options[0] && e28.options[0].allow || [] };
  return { "Program:exit": function() {
    for (var u3 = e28.getScope().childScopes.slice(); u3.length; ) {
      var c3 = u3.pop();
      u3.push.apply(u3, Mt$2(c3.childScopes)), s3(c3);
    }
  } };
} }, PL = { meta: { type: "suggestion", docs: { description: "disallow synchronous methods", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-sync" }, schema: [{ type: "object", properties: { allowAtRootLevel: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e28) {
  return Fn$1({}, e28.options[0] && e28.options[0].allowAtRootLevel ? ":function MemberExpression[property.name=/.*Sync$/]" : "MemberExpression[property.name=/.*Sync$/]", function(t3) {
    e28.report({ node: t3, message: "Unexpected sync method: '{{propertyName}}'.", data: { propertyName: t3.property.name } });
  });
} }, IL = /\t+/g, BL = /(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, OL = { meta: { type: "layout", docs: { description: "disallow all tabs", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-tabs" }, schema: [{ type: "object", properties: { allowIndentationTabs: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e28) {
  var t3 = e28.getSourceCode(), n3 = e28.options && e28.options[0] && e28.options[0].allowIndentationTabs;
  return { Program: function(r3) {
    t3.getLines().forEach(function(i, a3) {
      for (var s3; (s3 = IL.exec(i)) !== null; )
        (!n3 || BL.test(i.slice(0, s3.index))) && e28.report({ node: r3, loc: { start: { line: a3 + 1, column: s3.index }, end: { line: a3 + 1, column: s3.index + s3[0].length } }, message: "Unexpected tab character." });
    });
  } };
} }, LL = { meta: { type: "problem", docs: { description: "disallow `this`/`super` before calling `super()` in constructors", category: "ECMAScript 6", recommended: true, url: "https://eslint.org/docs/rules/no-this-before-super" }, schema: [] }, create: function(e28) {
  function t3(o3) {
    return !o3.reachable || s3[o3.id].superCalled;
  }
  function n3() {
    return !!(a3 && a3.isConstructor && a3.hasExtends);
  }
  function r3() {
    return n3() && !a3.codePath.currentSegments.every(t3);
  }
  function i(o3) {
    for (var u3 = a3.codePath.currentSegments, c3 = 0; c3 < u3.length; ++c3) {
      var f3 = u3[c3];
      f3.reachable && s3[f3.id].invalidNodes.push(o3);
    }
  }
  var a3 = null, s3 = /* @__PURE__ */ Object.create(null);
  return { onCodePathStart: function(o3, u3) {
    if (function(f3) {
      return f3.type === "FunctionExpression" && f3.parent.type === "MethodDefinition" && f3.parent.kind === "constructor";
    }(u3)) {
      var c3 = u3.parent.parent.parent;
      a3 = { upper: a3, isConstructor: true, hasExtends: !(!c3.superClass || P$s.isNullOrUndefined(c3.superClass)), codePath: o3 };
    } else
      a3 = { upper: a3, isConstructor: false, hasExtends: false, codePath: o3 };
  }, onCodePathEnd: function(o3) {
    var u3 = a3.hasExtends;
    a3 = a3.upper, u3 && o3.traverseSegments(function(c3, f3) {
      for (var p3 = s3[c3.id], d3 = 0; d3 < p3.invalidNodes.length; ++d3) {
        var m3 = p3.invalidNodes[d3];
        e28.report({ message: "'{{kind}}' is not allowed before 'super()'.", node: m3, data: { kind: m3.type === "Super" ? "super" : "this" } });
      }
      p3.superCalled && f3.skip();
    });
  }, onCodePathSegmentStart: function(o3) {
    n3() && (s3[o3.id] = { superCalled: 0 < o3.prevSegments.length && o3.prevSegments.every(t3), invalidNodes: [] });
  }, onCodePathSegmentLoop: function(o3, u3) {
    n3() && a3.codePath.traverseSegments({ first: u3, last: o3 }, function(c3, f3) {
      var p3 = s3[c3.id];
      p3.superCalled ? (p3.invalidNodes = [], f3.skip()) : 0 < c3.prevSegments.length && c3.prevSegments.every(t3) && (p3.superCalled = true, p3.invalidNodes = []);
    });
  }, ThisExpression: function(o3) {
    r3() && i(o3);
  }, Super: function(o3) {
    !P$s.isCallee(o3) && r3() && i(o3);
  }, "CallExpression:exit": function(o3) {
    o3.callee.type === "Super" && r3() && function() {
      for (var u3 = a3.codePath.currentSegments, c3 = 0; c3 < u3.length; ++c3) {
        var f3 = u3[c3];
        f3.reachable && (s3[f3.id].superCalled = true);
      }
    }();
  }, "Program:exit": function() {
    s3 = /* @__PURE__ */ Object.create(null);
  } };
} }, NL = { meta: { type: "suggestion", docs: { description: "disallow throwing literals as exceptions", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-throw-literal" }, schema: [], messages: { object: "Expected an error object to be thrown.", undef: "Do not throw undefined." } }, create: function(e28) {
  return { ThrowStatement: function(t3) {
    P$s.couldBeError(t3.argument) ? t3.argument.type === "Identifier" && t3.argument.name === "undefined" && e28.report({ node: t3, messageId: "undef" }) : e28.report({ node: t3, messageId: "object" });
  } };
} }, jL = { meta: { type: "layout", docs: { description: "disallow trailing whitespace at the end of lines", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-trailing-spaces" }, fixable: "whitespace", schema: [{ type: "object", properties: { skipBlankLines: { type: "boolean", default: false }, ignoreComments: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e28) {
  function t3(o3, u3, c3) {
    e28.report({ node: o3, loc: u3, message: "Trailing spaces not allowed.", fix: function(f3) {
      return f3.removeRange(c3);
    } });
  }
  var n3 = e28.getSourceCode(), r3 = "[ 	\xA0\u2000-\u200B\u3000]", i = e28.options[0] || {}, a3 = i.skipBlankLines || false, s3 = i.ignoreComments || false;
  return { Program: function(o3) {
    for (var u3 = new RegExp("".concat(r3, "+$"), "u"), c3 = new RegExp("^".concat(r3, "*$"), "u"), f3 = n3.lines, p3 = n3.getText().match(P$s.createGlobalLinebreakMatcher()), d3 = function(D3) {
      var I3 = /* @__PURE__ */ new Set();
      return D3.forEach(function(L3) {
        for (var V10 = L3.type === "Block" ? L3.loc.end.line - 1 : L3.loc.end.line, K3 = L3.loc.start.line; K3 <= V10; K3++)
          I3.add(K3);
      }), I3;
    }(n3.getAllComments()), m3 = 0, y3 = [], v3 = 0, b3 = f3.length; v3 < b3; v3++) {
      var x3 = v3 + 1, C3 = p3 && p3[v3] ? p3[v3].length : 1, k3 = f3[v3].length + C3, F3 = u3.exec(f3[v3]);
      if (F3) {
        var B3 = { start: { line: x3, column: F3.index }, end: { line: x3, column: k3 - C3 } }, O3 = m3 + B3.start.column, S3 = m3 + B3.end.column, w3 = n3.getNodeByRangeIndex(O3);
        if (w3 && w3.type === "TemplateElement" && O3 > w3.parent.range[0] && S3 < w3.parent.range[1]) {
          m3 += k3;
          continue;
        }
        if (a3 && c3.test(f3[v3])) {
          m3 += k3;
          continue;
        }
        y3 = [O3, S3], s3 && d3.has(x3) || t3(o3, B3, y3);
      }
      m3 += k3;
    }
  } };
} }, RL = { meta: { type: "suggestion", docs: { description: "disallow initializing variables to `undefined`", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/no-undef-init" }, schema: [], fixable: "code" }, create: function(e28) {
  var t3 = e28.getSourceCode();
  return { VariableDeclarator: function(n3) {
    var r3 = t3.getText(n3.id), i = n3.init && n3.init.name, a3 = e28.getScope(), s3 = P$s.getVariableByName(a3, "undefined"), o3 = s3 && 0 < s3.defs.length, u3 = t3.getLastToken(n3);
    i !== "undefined" || n3.parent.kind === "const" || o3 || e28.report({ node: n3, message: "It's not necessary to initialize '{{name}}' to undefined.", data: { name: r3 }, fix: function(c3) {
      return n3.parent.kind === "var" || n3.id.type === "ArrayPattern" || n3.id.type === "ObjectPattern" || t3.commentsExistBetween(n3.id, u3) ? null : c3.removeRange([n3.id.range[1], n3.range[1]]);
    } });
  } };
} }, ML = { meta: { type: "problem", docs: { description: "disallow the use of undeclared variables unless mentioned in `/*global */` comments", category: "Variables", recommended: true, url: "https://eslint.org/docs/rules/no-undef" }, schema: [{ type: "object", properties: { typeof: { type: "boolean", default: false } }, additionalProperties: false }], messages: { undef: "'{{name}}' is not defined." } }, create: function(e28) {
  var t3 = e28.options[0], n3 = t3 && t3.typeof === true || false;
  return { "Program:exit": function() {
    e28.getScope().through.forEach(function(r3) {
      var i = r3.identifier;
      !n3 && function(a3) {
        var s3 = a3.parent;
        return s3.type === "UnaryExpression" && s3.operator === "typeof";
      }(i) || e28.report({ node: i, messageId: "undef", data: i });
    });
  } };
} }, VL = { meta: { type: "suggestion", docs: { description: "disallow the use of `undefined` as an identifier", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/no-undefined" }, schema: [] }, create: function(e28) {
  function t3(r3) {
    e28.report({ node: r3, message: "Unexpected use of undefined." });
  }
  function n3(r3) {
    var i = r3.set.get("undefined");
    if (i) {
      var a3 = i.references, s3 = i.defs;
      a3.filter(function(o3) {
        return !o3.init;
      }).forEach(function(o3) {
        return t3(o3.identifier);
      }), s3.forEach(function(o3) {
        return t3(o3.name);
      });
    }
  }
  return { "Program:exit": function() {
    for (var r3 = [e28.getScope()]; r3.length; ) {
      var i = r3.pop();
      r3.push.apply(r3, Mt$2(i.childScopes)), n3(i);
    }
  } };
} }, UL = { meta: { type: "problem", docs: { description: "disallow confusing multiline expressions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-unexpected-multiline" }, schema: [], messages: { function: "Unexpected newline between function and ( of function call.", property: "Unexpected newline between object and [ of property access.", taggedTemplate: "Unexpected newline between template tag and template literal.", division: "Unexpected newline between numerator and division operator." } }, create: function(e28) {
  function t3(i, a3) {
    var s3 = r3.getTokenAfter(i, P$s.isNotClosingParenToken), o3 = r3.getTokenBefore(s3);
    s3.loc.start.line !== o3.loc.end.line && e28.report({ node: i, loc: s3.loc.start, messageId: a3, data: { char: s3.value } });
  }
  var n3 = /^[gimsuy]+$/, r3 = e28.getSourceCode();
  return { MemberExpression: function(i) {
    i.computed && t3(i.object, "property");
  }, TaggedTemplateExpression: function(i) {
    i.tag.loc.end.line === i.quasi.loc.start.line || e28.report({ node: i, loc: i.loc.start, messageId: "taggedTemplate" });
  }, CallExpression: function(i) {
    i.arguments.length === 0 || t3(i.callee, "function");
  }, "BinaryExpression[operator='/'] > BinaryExpression[operator='/'].left": function(i) {
    var a3 = r3.getTokenAfter(i, function(o3) {
      return o3.value === "/";
    }), s3 = r3.getTokenAfter(a3);
    s3.type === "Identifier" && n3.test(s3.value) && a3.range[1] === s3.range[0] && t3(i.left, "division");
  } };
} }, qL = /(?:(?:Call|Class|Function|Member|New|Yield)Expression|Statement|Declaration)$/, WL = /^(?:DoWhile|For|While)Statement$/, $L = /^(?:BinaryExpression|ConditionalExpression)$/, GL = /^(?:ArrowFunction|Class|Function)Expression$/, zL = /^(?:Call|Member|New|TaggedTemplate|Yield)Expression$/;
function HL(e28) {
  if (e28.init) {
    var t3 = e28.resolved && e28.resolved.defs[0];
    if (!t3 || t3.type !== "Variable" || t3.parent.kind !== "var")
      return false;
  }
  return e28.isWrite();
}
function KL(e28) {
  return !e28.modified;
}
function JL(e28) {
  return !(e28.modified || e28.group);
}
function Zl(e28, t3) {
  var n3 = e28.range, r3 = t3.identifier.range;
  return n3[0] <= r3[0] && r3[1] <= n3[1];
}
var QL = { WhileStatement: Zl, DoWhileStatement: Zl, ForStatement: function(e28, t3) {
  return Zl(e28, t3) && !(e28.init && Zl(e28.init, t3));
} };
function XL(e28) {
  for (var t3 = e28.identifier; t3; ) {
    if (t3.type === "FunctionDeclaration")
      return t3.id ? t3 : null;
    t3 = t3.parent;
  }
  return null;
}
var YL = { meta: { type: "problem", docs: { description: "disallow unmodified loop conditions", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-unmodified-loop-condition" }, schema: [] }, create: function(e28) {
  function t3(u3) {
    var c3 = u3.reference.identifier;
    e28.report({ node: c3, message: "'{{name}}' is not modified in this loop.", data: c3 });
  }
  function n3(u3) {
    u3.every(KL) && u3.forEach(t3);
  }
  function r3(u3) {
    var c3 = false;
    return ye$4.Traverser.traverse(u3, { visitorKeys: s3.visitorKeys, enter: function(f3) {
      zL.test(f3.type) ? (c3 = true, this.break()) : GL.test(f3.type) && this.skip();
    } }), c3;
  }
  function i(u3) {
    if (u3.init)
      return null;
    for (var c3 = null, f3 = u3.identifier, p3 = f3.parent; p3; ) {
      if (qL.test(p3.type)) {
        if (WL.test(p3.type) && p3.test === f3)
          return { reference: u3, group: c3, isInLoop: QL[p3.type].bind(null, p3), modified: false };
        break;
      }
      if ($L.test(p3.type)) {
        if (r3(p3))
          break;
        c3 = p3;
      }
      f3 = p3, p3 = p3.parent;
    }
    return null;
  }
  function a3(u3) {
    var c3 = u3.references.map(i).filter(Boolean);
    if (c3.length !== 0) {
      (function(p3) {
        for (var d3 = 0; d3 < p3.length; ++d3) {
          var m3 = p3[d3];
          if (m3.group) {
            var y3 = o3.get(m3.group);
            y3 || (y3 = [], o3.set(m3.group, y3)), y3.push(m3);
          }
        }
      })(c3);
      var f3 = u3.references.filter(HL);
      0 < f3.length && function(p3, d3) {
        for (var m3 = 0; m3 < p3.length; ++m3)
          for (var y3 = p3[m3], v3 = 0; !y3.modified && v3 < d3.length; ++v3) {
            var b3 = d3[v3], x3 = void 0, C3 = void 0, k3 = y3.isInLoop(b3) || !!((x3 = XL(b3)) && (C3 = P$s.getVariableByName(b3.from.upper, x3.id.name)) && C3.references.some(y3.isInLoop));
            y3.modified = k3;
          }
      }(c3, f3), c3.filter(JL).forEach(t3);
    }
  }
  var s3 = e28.getSourceCode(), o3 = null;
  return { "Program:exit": function() {
    var u3, c3 = [e28.getScope()];
    for (o3 = /* @__PURE__ */ new Map(); u3 = c3.pop(); )
      c3.push.apply(c3, Mt$2(u3.childScopes)), u3.variables.forEach(a3);
    o3.forEach(n3), o3 = null;
  } };
} }, ZL = /* @__PURE__ */ new Set(["==", "===", "!=", "!==", ">", ">=", "<", "<=", "in", "instanceof"]), O2 = { "==": "!=", "!=": "==", "===": "!==", "!==": "===" }, eN = P$s.getPrecedence({ type: "LogicalExpression", operator: "||" }), tN = { meta: { type: "suggestion", docs: { description: "disallow ternary operators when simpler alternatives exist", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-unneeded-ternary" }, schema: [{ type: "object", properties: { defaultAssignment: { type: "boolean", default: true } }, additionalProperties: false }], fixable: "code" }, create: function(e28) {
  function t3(a3) {
    return a3.type === "Literal" && typeof a3.value == "boolean";
  }
  function n3(a3) {
    if (a3.type === "BinaryExpression" && Object.prototype.hasOwnProperty.call(O2, a3.operator)) {
      var s3 = i.getFirstTokenBetween(a3.left, a3.right, function(u3) {
        return u3.value === a3.operator;
      }), o3 = i.getText();
      return o3.slice(a3.range[0], s3.range[0]) + O2[a3.operator] + o3.slice(s3.range[1], a3.range[1]);
    }
    return P$s.getPrecedence(a3) < P$s.getPrecedence({ type: "UnaryExpression" }) ? "!(".concat(P$s.getParenthesisedText(i, a3), ")") : "!".concat(P$s.getParenthesisedText(i, a3));
  }
  var r3 = (e28.options[0] || {}).defaultAssignment !== false, i = e28.getSourceCode();
  return { ConditionalExpression: function(a3) {
    t3(a3.alternate) && t3(a3.consequent) ? e28.report({ node: a3, loc: a3.consequent.loc.start, message: "Unnecessary use of boolean literals in conditional expression.", fix: function(s3) {
      return a3.consequent.value === a3.alternate.value ? a3.test.type === "Identifier" ? s3.replaceText(a3, a3.consequent.value.toString()) : null : a3.alternate.value ? s3.replaceText(a3, n3(a3.test)) : s3.replaceText(a3, function(o3) {
        return o3.type === "BinaryExpression" && ZL.has(o3.operator) || o3.type === "UnaryExpression" && o3.operator === "!";
      }(a3.test) ? P$s.getParenthesisedText(i, a3.test) : "!".concat(n3(a3.test)));
    } }) : !r3 && function(s3) {
      return s3.test.type === "Identifier" && s3.consequent.type === "Identifier" && s3.test.name === s3.consequent.name;
    }(a3) && e28.report({ node: a3, loc: a3.consequent.loc.start, message: "Unnecessary use of conditional expression for default assignment.", fix: function(s3) {
      var o3 = P$s.getPrecedence(a3.alternate) < eN && !P$s.isParenthesised(i, a3.alternate) ? "(".concat(i.getText(a3.alternate), ")") : P$s.getParenthesisedText(i, a3.alternate), u3 = P$s.getParenthesisedText(i, a3.test);
      return s3.replaceText(a3, "".concat(u3, " || ").concat(o3));
    } });
  } };
} };
function nN(e28) {
  return !!e28.init;
}
function rN(e28) {
  return !e28.reachable;
}
var iN = function() {
  function e28(t3) {
    We$1(this, e28), this.sourceCode = t3, this.startNode = null, this.endNode = null;
  }
  return Xe$1(e28, [{ key: "contains", value: function(t3) {
    return t3.range[0] >= this.startNode.range[0] && t3.range[1] <= this.endNode.range[1];
  } }, { key: "isConsecutive", value: function(t3) {
    return this.contains(this.sourceCode.getTokenBefore(t3));
  } }, { key: "merge", value: function(t3) {
    this.endNode = t3;
  } }, { key: "reset", value: function(t3) {
    this.startNode = this.endNode = t3;
  } }, { key: "location", get: function() {
    return { start: this.startNode.loc.start, end: this.endNode.loc.end };
  } }, { key: "isEmpty", get: function() {
    return !(this.startNode && this.endNode);
  } }]), e28;
}(), aN = { meta: { type: "problem", docs: { description: "disallow unreachable code after `return`, `throw`, `continue`, and `break` statements", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-unreachable" }, schema: [] }, create: function(e28) {
  function t3(i) {
    var a3 = null;
    if (i && n3.currentSegments.every(rN)) {
      if (r3.isEmpty)
        return void r3.reset(i);
      if (r3.contains(i))
        return;
      if (r3.isConsecutive(i))
        return void r3.merge(i);
      a3 = i;
    }
    r3.isEmpty || e28.report({ message: "Unreachable code.", loc: r3.location, node: r3.startNode }), r3.reset(a3);
  }
  var n3 = null, r3 = new iN(e28.getSourceCode());
  return { onCodePathStart: function(i) {
    n3 = i;
  }, onCodePathEnd: function() {
    n3 = n3.upper;
  }, BlockStatement: t3, BreakStatement: t3, ClassDeclaration: t3, ContinueStatement: t3, DebuggerStatement: t3, DoWhileStatement: t3, ExpressionStatement: t3, ForInStatement: t3, ForOfStatement: t3, ForStatement: t3, IfStatement: t3, ImportDeclaration: t3, LabeledStatement: t3, ReturnStatement: t3, SwitchStatement: t3, ThrowStatement: t3, TryStatement: t3, VariableDeclaration: function(i) {
    (i.kind !== "var" || i.declarations.some(nN)) && t3(i);
  }, WhileStatement: t3, WithStatement: t3, ExportNamedDeclaration: t3, ExportDefaultDeclaration: t3, ExportAllDeclaration: t3, "Program:exit": function() {
    t3();
  } };
} }, oN = /^(?:Program|(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression)$/, sN = /^(?:Program|(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression|DoWhileStatement|WhileStatement|ForOfStatement|ForInStatement|ForStatement|SwitchStatement)$/, uN = /^(?:Program|(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression|DoWhileStatement|WhileStatement|ForOfStatement|ForInStatement|ForStatement)$/, cN = { meta: { type: "problem", docs: { description: "disallow control flow statements in `finally` blocks", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-unsafe-finally" }, schema: [] }, create: function(e28) {
  function t3(i) {
    return i.parent.type === "TryStatement" && i.parent.finalizer === i;
  }
  function n3(i, a3) {
    var s3, o3 = false;
    s3 = i.type !== "BreakStatement" || i.label ? i.type === "ContinueStatement" ? uN : oN : sN;
    for (var u3 = i; u3 && !s3.test(u3.type); u3 = u3.parent)
      if (u3.parent.label && a3 && u3.parent.label.name === a3.name && (o3 = true), t3(u3))
        return !(a3 && o3);
    return false;
  }
  function r3(i) {
    n3(i, i.label) && e28.report({ message: "Unsafe usage of {{nodeType}}.", data: { nodeType: i.type }, node: i, line: i.loc.line, column: i.loc.column });
  }
  return { ReturnStatement: r3, ThrowStatement: r3, BreakStatement: r3, ContinueStatement: r3 };
} }, lN = { meta: { type: "problem", docs: { description: "disallow negating the left operand of relational operators", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-unsafe-negation" }, schema: [{ type: "object", properties: { enforceForOrderingRelations: { type: "boolean", default: false } }, additionalProperties: false }], fixable: null, messages: { unexpected: "Unexpected negating the left operand of '{{operator}}' operator." } }, create: function(e28) {
  var t3 = e28.getSourceCode(), n3 = (e28.options[0] || {}).enforceForOrderingRelations === true;
  return { BinaryExpression: function(r3) {
    var i = n3 && function(a3) {
      return a3 === "<" || a3 === ">" || a3 === ">=" || a3 === "<=";
    }(r3.operator);
    (function(a3) {
      return a3 === "in" || a3 === "instanceof";
    }(r3.operator) || i) && function(a3) {
      return a3.type === "UnaryExpression" && a3.operator === "!";
    }(r3.left) && !P$s.isParenthesised(t3, r3.left) && e28.report({ node: r3, loc: r3.left.loc, messageId: "unexpected", data: { operator: r3.operator } });
  } };
} }, pN = { meta: { type: "problem", docs: { description: "disallow unused variables", category: "Variables", recommended: true, url: "https://eslint.org/docs/rules/no-unused-vars" }, schema: [{ oneOf: [{ enum: ["all", "local"] }, { type: "object", properties: { vars: { enum: ["all", "local"] }, varsIgnorePattern: { type: "string" }, args: { enum: ["all", "after-used", "none"] }, ignoreRestSiblings: { type: "boolean" }, argsIgnorePattern: { type: "string" }, caughtErrors: { enum: ["all", "none"] }, caughtErrorsIgnorePattern: { type: "string" } } }] }] }, create: function(e28) {
  function t3(v3) {
    var b3, x3, C3 = v3.defs && v3.defs[0] && v3.defs[0].type;
    C3 === "CatchClause" && d3.caughtErrorsIgnorePattern ? (b3 = "args", x3 = d3.caughtErrorsIgnorePattern.toString()) : C3 === "Parameter" && d3.argsIgnorePattern ? (b3 = "args", x3 = d3.argsIgnorePattern.toString()) : C3 !== "Parameter" && d3.varsIgnorePattern && (b3 = "vars", x3 = d3.varsIgnorePattern.toString());
    var k3 = b3 ? " Allowed unused ".concat(b3, " must match ").concat(x3, ".") : "";
    return "'{{name}}' is defined but never used.".concat(k3);
  }
  function n3() {
    var v3 = d3.varsIgnorePattern ? " Allowed unused vars must match ".concat(d3.varsIgnorePattern.toString(), ".") : "";
    return "'{{name}}' is assigned a value but never used.".concat(v3);
  }
  function r3(v3) {
    var b3 = v3.defs[0];
    if (b3) {
      var x3 = b3.node;
      if (x3.type === "VariableDeclarator")
        x3 = x3.parent;
      else if (b3.type === "Parameter")
        return false;
      return x3.parent.type.indexOf("Export") === 0;
    }
    return false;
  }
  function i(v3) {
    return !!d3.ignoreRestSiblings && v3.defs.some(function(b3) {
      var x3 = b3.name.parent, C3 = x3.parent;
      return x3.type === "Property" && C3.type === "ObjectPattern" && p3.test(C3.properties[C3.properties.length - 1].type);
    });
  }
  function a3(v3, b3) {
    return v3.range[0] >= b3.range[0] && v3.range[1] <= b3.range[1];
  }
  function s3(v3, b3) {
    var x3 = P$s.getUpperFunction(v3);
    return x3 && a3(x3, b3) && function(C3, k3) {
      for (var F3 = C3, B3 = C3.parent; B3 && a3(B3, k3); ) {
        switch (B3.type) {
          case "SequenceExpression":
            if (B3.expressions[B3.expressions.length - 1] !== F3)
              return false;
            break;
          case "CallExpression":
          case "NewExpression":
            return B3.callee !== F3;
          case "AssignmentExpression":
          case "TaggedTemplateExpression":
          case "YieldExpression":
            return true;
          default:
            if (y3.test(B3.type))
              return true;
        }
        F3 = B3, B3 = B3.parent;
      }
      return false;
    }(x3, b3);
  }
  function o3(v3) {
    var b3 = function(k3) {
      var F3 = [];
      return k3.defs.forEach(function(B3) {
        var O3 = B3.type, S3 = B3.node;
        O3 === "FunctionName" && F3.push(S3), O3 === "Variable" && S3.init && (S3.init.type === "FunctionExpression" || S3.init.type === "ArrowFunctionExpression") && F3.push(S3.init);
      }), F3;
    }(v3), x3 = 0 < b3.length, C3 = null;
    return v3.references.some(function(k3) {
      if (function(B3) {
        var O3 = B3.identifier.parent;
        return O3.type === "VariableDeclarator" && (O3 = O3.parent.parent), O3.type === "ForInStatement" && !!(O3 = O3.body.type === "BlockStatement" ? O3.body.body[0] : O3.body) && O3.type === "ReturnStatement";
      }(k3))
        return true;
      var F3 = function(B3, O3) {
        var S3 = B3.identifier, w3 = S3.parent, D3 = w3.parent;
        return B3.isRead() && (w3.type === "AssignmentExpression" && D3.type === "ExpressionStatement" && w3.left === S3 || w3.type === "UpdateExpression" && D3.type === "ExpressionStatement" || O3 && a3(S3, O3) && !s3(S3, O3));
      }(k3, C3);
      return C3 = function(B3, O3) {
        var S3 = B3.identifier, w3 = S3.parent, D3 = w3.parent, I3 = B3.from.variableScope !== B3.resolved.scope.variableScope || P$s.isInLoop(S3);
        return O3 && a3(S3, O3) ? O3 : w3.type !== "AssignmentExpression" || D3.type !== "ExpressionStatement" || S3 !== w3.left || I3 ? null : w3.right;
      }(k3, C3), function(B3) {
        return B3.isRead();
      }(k3) && !F3 && !(x3 && function(B3, O3) {
        for (var S3 = B3.from; S3; ) {
          if (0 <= O3.indexOf(S3.block))
            return true;
          S3 = S3.upper;
        }
        return false;
      }(k3, b3));
    });
  }
  function u3(v3) {
    var b3 = v3.defs[0], x3 = e28.getDeclaredVariables(b3.node);
    return !x3.slice(x3.indexOf(v3) + 1).some(function(C3) {
      return 0 < C3.references.length || C3.eslintUsed;
    });
  }
  function c3(v3, b3) {
    var x3, C3, k3 = v3.variables, F3 = v3.childScopes;
    if (v3.type !== "global" || d3.vars === "all")
      for (x3 = 0, C3 = k3.length; x3 < C3; ++x3) {
        var B3 = k3[x3];
        if ((v3.type !== "class" || v3.block.id !== B3.identifiers[0]) && !(v3.functionExpressionScope || B3.eslintUsed || v3.type === "function" && B3.name === "arguments" && B3.identifiers.length === 0)) {
          var O3 = B3.defs[0];
          if (O3) {
            var S3 = O3.type;
            if (S3 === "CatchClause" && (d3.caughtErrors === "none" || d3.caughtErrorsIgnorePattern && d3.caughtErrorsIgnorePattern.test(O3.name.name)))
              continue;
            if (S3 === "Parameter") {
              if ((O3.node.parent.type === "Property" || O3.node.parent.type === "MethodDefinition") && O3.node.parent.kind === "set" || d3.args === "none" || d3.argsIgnorePattern && d3.argsIgnorePattern.test(O3.name.name) || d3.args === "after-used" && P$s.isFunction(O3.name.parent) && !u3(B3))
                continue;
            } else if (d3.varsIgnorePattern && d3.varsIgnorePattern.test(O3.name.name))
              continue;
          }
          o3(B3) || r3(B3) || i(B3) || b3.push(B3);
        }
      }
    for (x3 = 0, C3 = F3.length; x3 < C3; ++x3)
      c3(F3[x3], b3);
    return b3;
  }
  var f3 = e28.getSourceCode(), p3 = /^(?:RestElement|(?:Experimental)?RestProperty)$/, d3 = { vars: "all", args: "after-used", ignoreRestSiblings: false, caughtErrors: "none" }, m3 = e28.options[0];
  m3 && (typeof m3 == "string" ? d3.vars = m3 : (d3.vars = m3.vars || d3.vars, d3.args = m3.args || d3.args, d3.ignoreRestSiblings = m3.ignoreRestSiblings || d3.ignoreRestSiblings, d3.caughtErrors = m3.caughtErrors || d3.caughtErrors, m3.varsIgnorePattern && (d3.varsIgnorePattern = new RegExp(m3.varsIgnorePattern, "u")), m3.argsIgnorePattern && (d3.argsIgnorePattern = new RegExp(m3.argsIgnorePattern, "u")), m3.caughtErrorsIgnorePattern && (d3.caughtErrorsIgnorePattern = new RegExp(m3.caughtErrorsIgnorePattern, "u"))));
  var y3 = /(?:Statement|Declaration)$/;
  return { "Program:exit": function(v3) {
    for (var b3 = c3(e28.getScope(), []), x3 = 0, C3 = b3.length; x3 < C3; ++x3) {
      var k3 = b3[x3];
      if (0 < k3.defs.length)
        e28.report({ node: k3.identifiers[0], message: k3.references.some(function(B3) {
          return B3.isWrite();
        }) ? n3() : t3(k3), data: k3 });
      else if (k3.eslintExplicitGlobalComments) {
        var F3 = k3.eslintExplicitGlobalComments[0];
        e28.report({ node: v3, loc: P$s.getNameLocationInGlobalDirectiveComment(f3, F3, k3.name), message: t3(k3), data: k3 });
      }
    }
  } };
} }, fN = /^(?:(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression|CatchClause|ImportDeclaration|ExportNamedDeclaration)$/, hN = /^For(?:In|Of)Statement$/;
function nm(e28, t3) {
  return e28 && e28.range[0] <= t3 && t3 <= e28.range[1];
}
var dN = { meta: { type: "problem", docs: { description: "disallow the use of variables before they are defined", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/no-use-before-define" }, schema: [{ oneOf: [{ enum: ["nofunc"] }, { type: "object", properties: { functions: { type: "boolean" }, classes: { type: "boolean" }, variables: { type: "boolean" } }, additionalProperties: false }] }] }, create: function(e28) {
  function t3(i, a3) {
    return function(s3) {
      return s3.defs[0].type === "FunctionName";
    }(i) ? r3.functions : function(s3, o3) {
      return s3.defs[0].type === "ClassName" && s3.scope.variableScope !== o3.from.variableScope;
    }(i, a3) ? r3.classes : !function(s3, o3) {
      return s3.defs[0].type === "Variable" && s3.scope.variableScope !== o3.from.variableScope;
    }(i, a3) || r3.variables;
  }
  function n3(i) {
    i.references.forEach(function(a3) {
      var s3 = a3.resolved;
      !a3.init && s3 && s3.identifiers.length !== 0 && (!(s3.identifiers[0].range[1] < a3.identifier.range[1]) || function(o3, u3) {
        if (o3.scope !== u3.from)
          return false;
        for (var c3 = o3.identifiers[0].parent, f3 = u3.identifier.range[1]; c3; ) {
          if (c3.type === "VariableDeclarator") {
            if (nm(c3.init, f3) || hN.test(c3.parent.parent.type) && nm(c3.parent.parent.right, f3))
              return true;
            break;
          }
          if (c3.type === "AssignmentPattern") {
            if (nm(c3.right, f3))
              return true;
          } else if (fN.test(c3.type))
            break;
          c3 = c3.parent;
        }
        return false;
      }(s3, a3)) && t3(s3, a3) && e28.report({ node: a3.identifier, message: "'{{name}}' was used before it was defined.", data: a3.identifier });
    }), i.childScopes.forEach(n3);
  }
  var r3 = function(i) {
    var a3 = true, s3 = true, o3 = true;
    return typeof i == "string" ? a3 = i != "nofunc" : xe$3(i) == "object" && i !== null && (a3 = i.functions !== false, s3 = i.classes !== false, o3 = i.variables !== false), { functions: a3, classes: s3, variables: o3 };
  }(e28.options[0]);
  return { Program: function() {
    n3(e28.getScope());
  } };
} }, mN = { meta: { type: "suggestion", docs: { description: "disallow unnecessary calls to `.call()` and `.apply()`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-useless-call" }, schema: [] }, create: function(e28) {
  var t3 = e28.getSourceCode();
  return { CallExpression: function(n3) {
    if (function(i) {
      return i.callee.type === "MemberExpression" && i.callee.property.type === "Identifier" && i.callee.computed === false && (i.callee.property.name === "call" && 1 <= i.arguments.length || i.callee.property.name === "apply" && i.arguments.length === 2 && i.arguments[1].type === "ArrayExpression");
    }(n3)) {
      var r3 = n3.callee.object;
      (function(i, a3, s3) {
        return i ? P$s.equalTokens(i, a3, s3) : P$s.isNullOrUndefined(a3);
      })(r3.type === "MemberExpression" ? r3.object : null, n3.arguments[0], t3) && e28.report({ node: n3, message: "unnecessary '.{{name}}()'.", data: { name: n3.callee.property.name } });
    }
  } };
} }, gN = "Unnecessarily computed property [{{property}}] found.", yN = { meta: { type: "suggestion", docs: { description: "disallow unnecessary computed property keys in objects and classes", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/no-useless-computed-key" }, schema: [{ type: "object", properties: { enforceForClassMembers: { type: "boolean", default: false } }, additionalProperties: false }], fixable: "code" }, create: function(e28) {
  function t3(r3) {
    if (r3.computed) {
      var i, a3 = r3.key, s3 = xe$3(a3.value);
      i = r3.type === "MethodDefinition" ? r3.static ? "prototype" : "constructor" : "__proto__", a3.type === "Literal" && (s3 === "string" || s3 === "number") && a3.value !== i && e28.report({ node: r3, message: gN, data: { property: n3.getText(a3) }, fix: function(o3) {
        var u3 = n3.getFirstToken(r3, P$s.isOpeningBracketToken), c3 = n3.getFirstTokenBetween(r3.key, r3.value, P$s.isClosingBracketToken), f3 = n3.getTokensBetween(u3, c3, 1);
        if (f3.slice(0, -1).some(function(m3, y3) {
          return n3.getText().slice(m3.range[1], f3[y3 + 1].range[0]).trim();
        }))
          return null;
        var p3 = n3.getTokenBefore(u3), d3 = (p3.range[1] === u3.range[0] && !P$s.canTokensBeAdjacent(p3, n3.getFirstToken(a3)) ? " " : "") + a3.raw;
        return o3.replaceTextRange([u3.range[0], c3.range[1]], d3);
      } });
    }
  }
  var n3 = e28.getSourceCode();
  return { Property: t3, MethodDefinition: e28.options[0] && e28.options[0].enforceForClassMembers ? t3 : ye$4.lodash.noop };
} };
function L2(e28) {
  return e28.type === "BinaryExpression" && e28.operator === "+";
}
function vN(e28) {
  return e28.value === "+" && e28.type === "Punctuator";
}
var xN = { meta: { type: "suggestion", docs: { description: "disallow unnecessary concatenation of literals or template literals", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-useless-concat" }, schema: [] }, create: function(e28) {
  var t3 = e28.getSourceCode();
  return { BinaryExpression: function(n3) {
    if (n3.operator === "+") {
      var r3 = function(s3) {
        for (var o3 = s3.left; L2(o3); )
          o3 = o3.right;
        return o3;
      }(n3), i = function(s3) {
        for (var o3 = s3.right; L2(o3); )
          o3 = o3.left;
        return o3;
      }(n3);
      if (P$s.isStringLiteral(r3) && P$s.isStringLiteral(i) && P$s.isTokenOnSameLine(r3, i)) {
        var a3 = t3.getFirstTokenBetween(r3, i, vN);
        e28.report({ node: n3, loc: a3.loc.start, message: "Unexpected string concatenation of literals." });
      }
    }
  } };
} };
function bN(e28) {
  return e28.type === "Identifier" || e28.type === "RestElement";
}
function N2(e28, t3) {
  return e28.type === "Identifier" && t3.type === "Identifier" && e28.name === t3.name;
}
function EN(e28, t3) {
  return N2(e28, t3) || function(n3, r3) {
    return n3.type === "RestElement" && r3.type === "SpreadElement" && N2(n3.argument, r3.argument);
  }(e28, t3);
}
function CN(e28, t3) {
  return function(n3) {
    return n3.length === 1 && n3[0].type === "ExpressionStatement" && n3[0].expression.type === "CallExpression" && n3[0].expression.callee.type === "Super";
  }(e28) && t3.every(bN) && (function(n3) {
    return n3.length === 1 && n3[0].type === "SpreadElement" && n3[0].argument.type === "Identifier" && n3[0].argument.name === "arguments";
  }(e28[0].expression.arguments) || function(n3, r3) {
    if (n3.length !== r3.length)
      return false;
    for (var i = 0; i < n3.length; ++i)
      if (!EN(n3[i], r3[i]))
        return false;
    return true;
  }(t3, e28[0].expression.arguments));
}
var SN = { meta: { type: "suggestion", docs: { description: "disallow unnecessary constructors", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/no-useless-constructor" }, schema: [] }, create: function(e28) {
  return { MethodDefinition: function(t3) {
    if (t3.kind === "constructor") {
      var n3 = t3.value.body.body, r3 = t3.value.params;
      (t3.parent.parent.superClass ? CN(n3, r3) : n3.length === 0) && e28.report({ node: t3, message: "Useless constructor." });
    }
  } };
} };
function jA(e28, t3) {
  return new Set(regeneratorRuntime.mark(function n3() {
    return regeneratorRuntime.wrap(function(r3) {
      for (; ; )
        switch (r3.prev = r3.next) {
          case 0:
            return r3.delegateYield(e28, "t0", 1);
          case 1:
            return r3.delegateYield(t3, "t1", 2);
          case 2:
          case "end":
            return r3.stop();
        }
    }, n3);
  })());
}
var kN = jA(new Set("\\nrvtbfux"), P$s.LINEBREAKS), RA = new Set("\\bcdDfnpPrsStvwWxu0123456789]"), DN = jA(RA, new Set("^/.$*+?[{}|()Bk")), FN = { meta: { type: "suggestion", docs: { description: "disallow unnecessary escape characters", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-useless-escape", suggestion: true }, messages: { unnecessaryEscape: "Unnecessary escape character: \\{{character}}.", removeEscape: "Remove the `\\`. This maintains the current functionality.", escapeBackslash: "Replace the `\\` with `\\\\` to include the actual backslash character." }, schema: [] }, create: function(e28) {
  function t3(a3, s3, o3) {
    var u3 = i.getLocFromIndex(i.getIndexFromLoc(a3.loc.start) + s3), c3 = i.getIndexFromLoc(a3.loc.start) + s3, f3 = [c3, c3 + 1];
    e28.report({ node: a3, loc: { start: u3, end: { line: u3.line, column: u3.column + 1 } }, messageId: "unnecessaryEscape", data: { character: o3 }, suggest: [{ messageId: "removeEscape", fix: function(p3) {
      return p3.removeRange(f3);
    } }, { messageId: "escapeBackslash", fix: function(p3) {
      return p3.insertTextBeforeRange(f3, "\\");
    } }] });
  }
  function n3(a3, s3) {
    var o3, u3 = a3.type === "TemplateElement", c3 = s3[0][1], f3 = !kN.has(c3);
    u3 ? (o3 = c3 === "`", c3 === "$" ? f3 = s3.input[s3.index + 2] !== "{" : c3 === "{" && (f3 = s3.input[s3.index - 1] !== "$")) : o3 = c3 === a3.raw[0], f3 && !o3 && t3(a3, s3.index + 1, s3[0].slice(1));
  }
  function r3(a3) {
    var s3 = a3.type === "TemplateElement";
    if (!(s3 && a3.parent && a3.parent.parent && a3.parent.parent.type === "TaggedTemplateExpression" && a3.parent === a3.parent.parent.quasi))
      if (typeof a3.value == "string" || s3) {
        if (a3.parent.type === "JSXAttribute" || a3.parent.type === "JSXElement" || a3.parent.type === "JSXFragment")
          return;
        for (var o3, u3 = s3 ? a3.value.raw : a3.raw.slice(1, -1), c3 = /\\(?:[\0-\/:-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g; o3 = c3.exec(u3); )
          n3(a3, o3);
      } else
        a3.regex && function(f3) {
          var p3 = [];
          return f3.split("").reduce(function(d3, m3, y3) {
            if (!d3.escapeNextChar) {
              if (m3 === "\\")
                return Object.assign(d3, { escapeNextChar: true });
              if (m3 === "[" && !d3.inCharClass)
                return Object.assign(d3, { inCharClass: true, startingCharClass: true });
              if (m3 === "]" && d3.inCharClass)
                return p3.length && p3[p3.length - 1].inCharClass && (p3[p3.length - 1].endsCharClass = true), Object.assign(d3, { inCharClass: false, startingCharClass: false });
            }
            return p3.push({ text: m3, index: y3, escaped: d3.escapeNextChar, inCharClass: d3.inCharClass, startsCharClass: d3.startingCharClass, endsCharClass: false }), Object.assign(d3, { escapeNextChar: false, startingCharClass: false });
          }, { escapeNextChar: false, inCharClass: false, startingCharClass: false }), p3;
        }(a3.regex.pattern).filter(function(f3) {
          return f3.text !== "-" || !f3.inCharClass || f3.startsCharClass || f3.endsCharClass;
        }).filter(function(f3) {
          return !(f3.text === "^" && f3.startsCharClass);
        }).filter(function(f3) {
          return f3.escaped;
        }).filter(function(f3) {
          return !(f3.inCharClass ? RA : DN).has(f3.text);
        }).forEach(function(f3) {
          return t3(a3, f3.index, f3.text);
        });
  }
  var i = e28.getSourceCode();
  return { Literal: r3, TemplateElement: r3 };
} }, wN = { meta: { type: "suggestion", docs: { description: "disallow renaming import, export, and destructured assignments to the same name", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/no-useless-rename" }, fixable: "code", schema: [{ type: "object", properties: { ignoreDestructuring: { type: "boolean", default: false }, ignoreImport: { type: "boolean", default: false }, ignoreExport: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e28) {
  function t3(o3, u3, c3, f3) {
    var p3 = u3.type === "Identifier" ? u3.name : u3.value;
    return e28.report({ node: o3, message: "{{type}} {{name}} unnecessarily renamed.", data: { name: p3, type: f3 }, fix: function(d3) {
      if (n3.commentsExistBetween(u3, c3))
        return null;
      var m3 = c3.type === "AssignmentPattern" ? n3.getText(c3) : p3;
      return d3.replaceTextRange([u3.range[0], c3.range[1]], m3);
    } });
  }
  var n3 = e28.getSourceCode(), r3 = e28.options[0] || {}, i = r3.ignoreDestructuring === true, a3 = r3.ignoreImport === true, s3 = r3.ignoreExport === true;
  return { ObjectPattern: function(o3) {
    if (!i) {
      var u3 = true, c3 = false, f3 = void 0;
      try {
        for (var p3, d3 = o3.properties[Symbol.iterator](); !(u3 = (p3 = d3.next()).done); u3 = true) {
          var m3 = p3.value;
          m3.type !== "ExperimentalRestProperty" && !m3.shorthand && m3.type !== "RestElement" && !m3.computed && (m3.key.type === "Identifier" && m3.key.name || m3.key.type === "Literal" && m3.key.value) === (m3.value.type === "AssignmentPattern" ? m3.value.left.name : m3.value.name) && t3(m3, m3.key, m3.value, "Destructuring assignment");
        }
      } catch (y3) {
        c3 = true, f3 = y3;
      } finally {
        try {
          u3 || d3.return == null || d3.return();
        } finally {
          if (c3)
            throw f3;
        }
      }
    }
  }, ImportSpecifier: function(o3) {
    a3 || o3.imported.name === o3.local.name && o3.imported.range[0] !== o3.local.range[0] && t3(o3, o3.imported, o3.local, "Import");
  }, ExportSpecifier: function(o3) {
    s3 || o3.local.name === o3.exported.name && o3.local.range[0] !== o3.exported.range[0] && t3(o3, o3.local, o3.exported, "Export");
  } };
} };
function AN(e28, t3) {
  var n3 = e28.indexOf(t3);
  n3 !== -1 && e28.splice(n3, 1);
}
var _N = { meta: { type: "suggestion", docs: { description: "disallow redundant return statements", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-useless-return" }, fixable: "code", schema: [] }, create: function(e28) {
  function t3(c3) {
    var f3 = a3.get(c3);
    return !f3 || f3.returned;
  }
  function n3(c3, f3, p3) {
    var d3 = p3 || /* @__PURE__ */ new WeakSet(), m3 = true, y3 = false, v3 = void 0;
    try {
      for (var b3, x3 = f3[Symbol.iterator](); !(m3 = (b3 = x3.next()).done); m3 = true) {
        var C3 = b3.value;
        C3.reachable ? c3.push.apply(c3, Mt$2(a3.get(C3).uselessReturns)) : d3.has(C3) || (d3.add(C3), n3(c3, C3.allPrevSegments.filter(t3), d3));
      }
    } catch (k3) {
      y3 = true, v3 = k3;
    } finally {
      try {
        m3 || x3.return == null || x3.return();
      } finally {
        if (y3)
          throw v3;
      }
    }
    return c3;
  }
  function r3(c3) {
    if (!c3.reachable)
      return s3.add(c3), void c3.allPrevSegments.filter(t3).filter(function(x3) {
        return !s3.has(x3);
      }).forEach(r3);
    var f3 = a3.get(c3), p3 = true, d3 = false, m3 = void 0;
    try {
      for (var y3, v3 = f3.uselessReturns[Symbol.iterator](); !(p3 = (y3 = v3.next()).done); p3 = true) {
        var b3 = y3.value;
        AN(u3.uselessReturns, b3);
      }
    } catch (x3) {
      d3 = true, m3 = x3;
    } finally {
      try {
        p3 || v3.return == null || v3.return();
      } finally {
        if (d3)
          throw m3;
      }
    }
    f3.uselessReturns = [];
  }
  function i() {
    u3.codePath.currentSegments.forEach(r3);
  }
  var a3 = /* @__PURE__ */ new WeakMap(), s3 = /* @__PURE__ */ new WeakSet(), o3 = e28.getSourceCode(), u3 = null;
  return { onCodePathStart: function(c3) {
    u3 = { upper: u3, uselessReturns: [], codePath: c3 };
  }, onCodePathEnd: function() {
    var c3 = true, f3 = false, p3 = void 0;
    try {
      for (var d3, m3 = function() {
        var v3 = d3.value;
        e28.report({ node: v3, loc: v3.loc, message: "Unnecessary return statement.", fix: function(b3) {
          return function(x3) {
            return P$s.STATEMENT_LIST_PARENTS.has(x3.parent.type);
          }(v3) && !o3.getCommentsInside(v3).length ? new bf(b3, o3).retainEnclosingFunction(v3).remove(v3) : null;
        } });
      }, y3 = u3.uselessReturns[Symbol.iterator](); !(c3 = (d3 = y3.next()).done); c3 = true)
        m3();
    } catch (v3) {
      f3 = true, p3 = v3;
    } finally {
      try {
        c3 || y3.return == null || y3.return();
      } finally {
        if (f3)
          throw p3;
      }
    }
    u3 = u3.upper;
  }, onCodePathSegmentStart: function(c3) {
    var f3 = { uselessReturns: n3([], c3.allPrevSegments), returned: false };
    a3.set(c3, f3);
  }, ReturnStatement: function(c3) {
    if (c3.argument && i(), !(c3.argument || P$s.isInLoop(c3) || function(x3) {
      for (var C3 = x3; C3 && C3.parent && !P$s.isFunction(C3); C3 = C3.parent)
        if (C3.parent.type === "TryStatement" && C3.parent.finalizer === C3)
          return true;
      return false;
    }(c3)) && u3.codePath.currentSegments.some(function(x3) {
      return x3.reachable;
    })) {
      var f3 = true, p3 = false, d3 = void 0;
      try {
        for (var m3, y3 = u3.codePath.currentSegments[Symbol.iterator](); !(f3 = (m3 = y3.next()).done); f3 = true) {
          var v3 = m3.value, b3 = a3.get(v3);
          b3 && (b3.uselessReturns.push(c3), b3.returned = true);
        }
      } catch (x3) {
        p3 = true, d3 = x3;
      } finally {
        try {
          f3 || y3.return == null || y3.return();
        } finally {
          if (p3)
            throw d3;
        }
      }
      u3.uselessReturns.push(c3);
    }
  }, ClassDeclaration: i, ContinueStatement: i, DebuggerStatement: i, DoWhileStatement: i, EmptyStatement: i, ExpressionStatement: i, ForInStatement: i, ForOfStatement: i, ForStatement: i, IfStatement: i, ImportDeclaration: i, LabeledStatement: i, SwitchStatement: i, ThrowStatement: i, TryStatement: i, VariableDeclaration: i, WhileStatement: i, WithStatement: i, ExportNamedDeclaration: i, ExportDefaultDeclaration: i, ExportAllDeclaration: i };
} };
function TN(e28) {
  return !!e28.scope && e28.scope.type === "global";
}
function j2(e28) {
  for (var t3 = e28; t3.type !== "function" && t3.type !== "global"; )
    t3 = t3.upper;
  return t3;
}
function PN(e28) {
  var t3 = j2(e28.scope);
  return e28.references.some(function(n3) {
    return j2(n3.from) !== t3;
  });
}
function R2(e28) {
  return (e28.parent.type === "ForOfStatement" || e28.parent.type === "ForInStatement") && e28 === e28.parent.left;
}
var IN = /^(?:Program|BlockStatement|SwitchStatement|ForStatement|ForInStatement|ForOfStatement)$/;
function BN(e28) {
  return 2 <= e28.defs.length;
}
function ON(e28) {
  return e28.name === "let";
}
var LN = { meta: { type: "suggestion", docs: { description: "require `let` or `const` instead of `var`", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/no-var" }, schema: [], fixable: "code" }, create: function(e28) {
  function t3(a3) {
    return !!a3.init && e28.getDeclaredVariables(a3).some(function(s3) {
      var o3 = s3.range[0], u3 = s3.range[1];
      return function(c3) {
        var f3 = c3.defs[0].name, p3 = f3.range[0], d3 = f3.parent.type === "AssignmentPattern" ? f3.parent.right : null, m3 = d3 && d3.range[0], y3 = d3 && d3.range[1];
        return c3.references.some(function(v3) {
          var b3 = v3.identifier.range[0], x3 = v3.identifier.range[1];
          return !v3.init && (b3 < p3 || d3 !== null && b3 >= m3 && x3 <= y3 || b3 >= o3 && x3 <= u3);
        });
      };
    }(a3.init));
  }
  function n3(a3) {
    var s3 = e28.getDeclaredVariables(a3), o3 = function(u3) {
      for (var c3 = u3; c3; c3 = c3.parent)
        if (IN.test(c3.type))
          return c3;
      return null;
    }(a3);
    return a3.parent.type === "SwitchCase" || a3.declarations.some(t3) || s3.some(TN) || s3.some(BN) || s3.some(function(u3) {
      function c3(f3) {
        var p3 = u3.range, d3 = f3.identifier.range;
        return d3[0] < p3[0] || d3[1] > p3[1];
      }
      return function(f3) {
        return f3.references.some(c3);
      };
    }(o3)) || s3.some(ON) || P$s.isInLoop(a3) && (s3.some(PN) || !R2(a3) && !function(u3) {
      return u3.declarations.every(function(c3) {
        return c3.init !== null;
      });
    }(a3)) ? false : !!(R2(a3) || a3.parent.type === "ForStatement" && a3.parent.init === a3 || P$s.STATEMENT_LIST_PARENTS.has(a3.parent.type));
  }
  function r3(a3) {
    e28.report({ node: a3, message: "Unexpected var, use let or const instead.", fix: function(s3) {
      var o3 = i.getFirstToken(a3, { filter: function(u3) {
        return u3.value === "var";
      } });
      return n3(a3) ? s3.replaceText(o3, "let") : null;
    } });
  }
  var i = e28.getSourceCode();
  return { "VariableDeclaration:exit": function(a3) {
    a3.kind === "var" && r3(a3);
  } };
} }, NN = ye$4.lodash.escapeRegExp, jN = { meta: { type: "suggestion", docs: { description: "disallow specified warning terms in comments", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-warning-comments" }, schema: [{ type: "object", properties: { terms: { type: "array", items: { type: "string" } }, location: { enum: ["start", "anywhere"] } }, additionalProperties: false }] }, create: function(e28) {
  function t3(u3) {
    P$s.isDirectiveComment(u3) && s3.test(u3.value) || function(c3) {
      var f3 = [];
      return o3.forEach(function(p3, d3) {
        p3.test(c3) && f3.push(i[d3]);
      }), f3;
    }(u3.value).forEach(function(c3) {
      e28.report({ node: u3, message: "Unexpected '{{matchedTerm}}' comment.", data: { matchedTerm: c3 } });
    });
  }
  var n3 = e28.getSourceCode(), r3 = e28.options[0] || {}, i = r3.terms || ["todo", "fixme", "xxx"], a3 = r3.location || "start", s3 = /\bno\x2Dwarning\x2Dcomments\b/, o3 = i.map(function(u3) {
    var c3, f3 = NN(u3), p3 = "\\b", d3 = /[0-9A-Z_a-z]$/.test(u3) ? "\\b" : "";
    return c3 = a3 === "start" ? "^\\s*" : /^[0-9A-Z_a-z]/.test(u3) ? p3 : "", a3 === "start" ? new RegExp(c3 + f3 + d3, "iu") : new RegExp(c3 + f3 + d3 + "|".concat(p3) + u3 + p3, "iu");
  });
  return { Program: function() {
    n3.getAllComments().filter(function(u3) {
      return u3.type !== "Shebang";
    }).forEach(t3);
  } };
} }, RN = { meta: { type: "layout", docs: { description: "disallow whitespace before properties", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-whitespace-before-property" }, fixable: "whitespace", schema: [] }, create: function(e28) {
  function t3(r3, i, a3) {
    var s3 = r3.computed ? "" : ".";
    e28.report({ node: r3, message: "Unexpected whitespace before property {{propName}}.", data: { propName: n3.getText(r3.property) }, fix: function(o3) {
      return !r3.computed && P$s.isDecimalInteger(r3.object) ? null : o3.replaceTextRange([i.range[1], a3.range[0]], s3);
    } });
  }
  var n3 = e28.getSourceCode();
  return { MemberExpression: function(r3) {
    var i, a3;
    P$s.isTokenOnSameLine(r3.object, r3.property) && (r3.computed ? (i = n3.getTokenBefore(r3.property, P$s.isOpeningBracketToken), a3 = n3.getTokenBefore(i)) : (i = n3.getFirstToken(r3.property), a3 = n3.getTokenBefore(i, 1)), n3.isSpaceBetweenTokens(a3, i) && t3(r3, a3, i));
  } };
} }, hs$1 = { enum: ["beside", "below", "any"] }, MN = { meta: { type: "layout", docs: { description: "enforce the location of single-line statements", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/nonblock-statement-body-position" }, fixable: "whitespace", schema: [hs$1, { properties: { overrides: { properties: { if: hs$1, else: hs$1, while: hs$1, do: hs$1, for: hs$1 }, additionalProperties: false } }, additionalProperties: false }] }, create: function(e28) {
  function t3(r3, i) {
    var a3 = function(o3) {
      return e28.options[1] && e28.options[1].overrides && e28.options[1].overrides[o3] || e28.options[0] || "beside";
    }(i);
    if (r3.type !== "BlockStatement" && a3 !== "any") {
      var s3 = n3.getTokenBefore(r3);
      s3.loc.end.line === r3.loc.start.line && a3 === "below" ? e28.report({ node: r3, message: "Expected a linebreak before this statement.", fix: function(o3) {
        return o3.insertTextBefore(r3, `
`);
      } }) : s3.loc.end.line !== r3.loc.start.line && a3 === "beside" && e28.report({ node: r3, message: "Expected no linebreak before this statement.", fix: function(o3) {
        return n3.getText().slice(s3.range[1], r3.range[0]).trim() ? null : o3.replaceTextRange([s3.range[1], r3.range[0]], " ");
      } });
    }
  }
  var n3 = e28.getSourceCode();
  return { IfStatement: function(r3) {
    t3(r3.consequent, "if"), r3.alternate && r3.alternate.type !== "IfStatement" && t3(r3.alternate, "else");
  }, WhileStatement: function(r3) {
    return t3(r3.body, "while");
  }, DoWhileStatement: function(r3) {
    return t3(r3.body, "do");
  }, ForStatement: function(r3) {
    return t3(r3.body, "for");
  }, ForInStatement: function(r3) {
    return t3(r3.body, "for");
  }, ForOfStatement: function(r3) {
    return t3(r3.body, "for");
  } };
} }, Bu$1 = { oneOf: [{ enum: ["always", "never"] }, { type: "object", properties: { multiline: { type: "boolean" }, minProperties: { type: "integer", minimum: 0 }, consistent: { type: "boolean" } }, additionalProperties: false, minProperties: 1 }] };
function Ou$1(e28) {
  var t3 = Number.POSITIVE_INFINITY, n3 = false, r3 = t3, i = false;
  return e28 ? e28 === "always" ? r3 = 0 : e28 === "never" ? r3 = t3 : (n3 = !!e28.multiline, r3 = e28.minProperties || t3, i = !!e28.consistent) : i = true, { multiline: n3, minProperties: r3, consistent: i };
}
var VN = { meta: { type: "layout", docs: { description: "enforce consistent line breaks inside braces", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/object-curly-newline" }, fixable: "whitespace", schema: [{ oneOf: [Bu$1, { type: "object", properties: { ObjectExpression: Bu$1, ObjectPattern: Bu$1, ImportDeclaration: Bu$1, ExportDeclaration: Bu$1 }, additionalProperties: false, minProperties: 1 }] }] }, create: function(e28) {
  function t3(i) {
    var a3 = r3[i.type];
    if ((i.type !== "ImportDeclaration" || i.specifiers.some(function(b3) {
      return b3.type === "ImportSpecifier";
    })) && (i.type !== "ExportNamedDeclaration" || i.specifiers.some(function(b3) {
      return b3.type === "ExportSpecifier";
    }))) {
      var s3 = n3.getFirstToken(i, function(b3) {
        return b3.value === "{";
      }), o3 = i.typeAnnotation ? n3.getTokenBefore(i.typeAnnotation) : n3.getLastToken(i, function(b3) {
        return b3.value === "}";
      }), u3 = n3.getTokenAfter(s3, { includeComments: true }), c3 = n3.getTokenBefore(o3, { includeComments: true }), f3 = function(b3, x3, C3, k3) {
        var F3;
        return (F3 = b3.type === "ObjectExpression" || b3.type === "ObjectPattern" ? b3.properties : b3.specifiers.filter(function(B3) {
          return B3.type === "ImportSpecifier" || B3.type === "ExportSpecifier";
        })).length >= x3.minProperties || x3.multiline && 0 < F3.length && C3.loc.start.line !== k3.loc.end.line;
      }(i, a3, u3, c3), p3 = P$s.isCommentToken(u3), d3 = P$s.isCommentToken(c3);
      if (u3 = n3.getTokenAfter(s3), c3 = n3.getTokenBefore(o3), f3)
        P$s.isTokenOnSameLine(s3, u3) && e28.report({ message: "Expected a line break after this opening brace.", node: i, loc: s3.loc.start, fix: function(b3) {
          return p3 ? null : b3.insertTextAfter(s3, `
`);
        } }), P$s.isTokenOnSameLine(c3, o3) && e28.report({ message: "Expected a line break before this closing brace.", node: i, loc: o3.loc.start, fix: function(b3) {
          return d3 ? null : b3.insertTextBefore(o3, `
`);
        } });
      else {
        var m3 = a3.consistent, y3 = !P$s.isTokenOnSameLine(s3, u3), v3 = !P$s.isTokenOnSameLine(c3, o3);
        (!m3 && y3 || m3 && y3 && !v3) && e28.report({ message: "Unexpected line break after this opening brace.", node: i, loc: s3.loc.start, fix: function(b3) {
          return p3 ? null : b3.removeRange([s3.range[1], u3.range[0]]);
        } }), (!m3 && v3 || m3 && !y3 && v3) && e28.report({ message: "Unexpected line break before this closing brace.", node: i, loc: o3.loc.start, fix: function(b3) {
          return d3 ? null : b3.removeRange([c3.range[1], o3.range[0]]);
        } });
      }
    }
  }
  var n3 = e28.getSourceCode(), r3 = function(i) {
    var a3 = ye$4.lodash.overSome([ye$4.lodash.isPlainObject, ye$4.lodash.isString]);
    if (ye$4.lodash.isPlainObject(i) && ye$4.lodash.some(i, a3))
      return { ObjectExpression: Ou$1(i.ObjectExpression), ObjectPattern: Ou$1(i.ObjectPattern), ImportDeclaration: Ou$1(i.ImportDeclaration), ExportNamedDeclaration: Ou$1(i.ExportDeclaration) };
    var s3 = Ou$1(i);
    return { ObjectExpression: s3, ObjectPattern: s3, ImportDeclaration: s3, ExportNamedDeclaration: s3 };
  }(e28.options[0]);
  return { ObjectExpression: t3, ObjectPattern: t3, ImportDeclaration: t3, ExportNamedDeclaration: t3 };
} }, UN = { meta: { type: "layout", docs: { description: "enforce consistent spacing inside braces", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/object-curly-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { arraysInObjects: { type: "boolean" }, objectsInObjects: { type: "boolean" } }, additionalProperties: false }] }, create: function(e28) {
  function t3(p3) {
    return !!e28.options[1] && e28.options[1][p3] === !u3;
  }
  function n3(p3, d3) {
    var m3 = e28.getSourceCode().getTokenAfter(d3, { includeComments: true });
    e28.report({ node: p3, loc: { start: d3.loc.end, end: m3.loc.start }, message: "There should be no space after '{{token}}'.", data: { token: d3.value }, fix: function(y3) {
      return y3.removeRange([d3.range[1], m3.range[0]]);
    } });
  }
  function r3(p3, d3) {
    var m3 = e28.getSourceCode().getTokenBefore(d3, { includeComments: true });
    e28.report({ node: p3, loc: { start: m3.loc.end, end: d3.loc.start }, message: "There should be no space before '{{token}}'.", data: { token: d3.value }, fix: function(y3) {
      return y3.removeRange([m3.range[1], d3.range[0]]);
    } });
  }
  function i(p3, d3) {
    e28.report({ node: p3, loc: d3.loc, message: "A space is required after '{{token}}'.", data: { token: d3.value }, fix: function(m3) {
      return m3.insertTextAfter(d3, " ");
    } });
  }
  function a3(p3, d3) {
    e28.report({ node: p3, loc: d3.loc, message: "A space is required before '{{token}}'.", data: { token: d3.value }, fix: function(m3) {
      return m3.insertTextBefore(d3, " ");
    } });
  }
  function s3(p3, d3, m3, y3, v3) {
    if (P$s.isTokenOnSameLine(d3, m3)) {
      var b3 = c3.isSpaceBetweenTokens(d3, m3);
      f3.spaced && !b3 && i(p3, d3), !f3.spaced && b3 && m3.type !== "Line" && n3(p3, d3);
    }
    if (P$s.isTokenOnSameLine(y3, v3)) {
      var x3 = (f3.arraysInObjectsException && P$s.isClosingBracketToken(y3) || f3.objectsInObjectsException && P$s.isClosingBraceToken(y3)) && c3.getNodeByRangeIndex(y3.range[0]).type, C3 = f3.arraysInObjectsException && x3 === "ArrayExpression" || f3.objectsInObjectsException && (x3 === "ObjectExpression" || x3 === "ObjectPattern") ? !f3.spaced : f3.spaced, k3 = c3.isSpaceBetweenTokens(y3, v3);
      C3 && !k3 && a3(p3, v3), !C3 && k3 && r3(p3, v3);
    }
  }
  function o3(p3) {
    if (p3.properties.length !== 0) {
      var d3 = c3.getFirstToken(p3), m3 = function(y3) {
        var v3 = y3.properties[y3.properties.length - 1];
        return c3.getTokenAfter(v3, P$s.isClosingBraceToken);
      }(p3);
      s3(p3, d3, c3.getTokenAfter(d3, { includeComments: true }), c3.getTokenBefore(m3, { includeComments: true }), m3);
    }
  }
  var u3 = e28.options[0] === "always", c3 = e28.getSourceCode(), f3 = { spaced: u3, arraysInObjectsException: t3("arraysInObjects"), objectsInObjectsException: t3("objectsInObjects") };
  return { ObjectPattern: o3, ObjectExpression: o3, ImportDeclaration: function(p3) {
    if (p3.specifiers.length !== 0) {
      var d3 = p3.specifiers[0], m3 = p3.specifiers[p3.specifiers.length - 1];
      if (m3.type === "ImportSpecifier") {
        d3.type !== "ImportSpecifier" && (d3 = p3.specifiers[1]);
        var y3 = c3.getTokenBefore(d3), v3 = c3.getTokenAfter(m3, P$s.isNotCommaToken);
        s3(p3, y3, c3.getTokenAfter(y3, { includeComments: true }), c3.getTokenBefore(v3, { includeComments: true }), v3);
      }
    }
  }, ExportNamedDeclaration: function(p3) {
    if (p3.specifiers.length !== 0) {
      var d3 = p3.specifiers[0], m3 = p3.specifiers[p3.specifiers.length - 1], y3 = c3.getTokenBefore(d3), v3 = c3.getTokenAfter(m3, P$s.isNotCommaToken);
      s3(p3, y3, c3.getTokenAfter(y3, { includeComments: true }), c3.getTokenBefore(v3, { includeComments: true }), v3);
    }
  } };
} }, rm = "always", qN = "never", WN = "methods", $N = "properties", GN = "consistent", zN = "consistent-as-needed", HN = { meta: { type: "suggestion", docs: { description: "require or disallow method and property shorthand syntax for object literals", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/object-shorthand" }, fixable: "code", schema: { anyOf: [{ type: "array", items: [{ enum: ["always", "methods", "properties", "never", "consistent", "consistent-as-needed"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["always", "methods", "properties"] }, { type: "object", properties: { avoidQuotes: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }, { type: "array", items: [{ enum: ["always", "methods"] }, { type: "object", properties: { ignoreConstructors: { type: "boolean" }, avoidQuotes: { type: "boolean" }, avoidExplicitReturnArrows: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }] } }, create: function(e28) {
  function t3(w3) {
    return w3.kind !== "set" && w3.kind !== "get" && w3.type !== "SpreadElement" && w3.type !== "SpreadProperty" && w3.type !== "ExperimentalSpreadProperty";
  }
  function n3(w3) {
    return w3.type === "Literal" && typeof w3.value == "string";
  }
  function r3(w3) {
    return w3.shorthand || w3.method;
  }
  function i(w3) {
    var D3 = w3.value;
    return D3.type === "FunctionExpression" ? !D3.id : D3.type === "Identifier" && P$s.getStaticPropertyName(w3) === D3.name;
  }
  function a3(w3, D3) {
    var I3 = w3.properties.filter(t3);
    if (0 < I3.length) {
      var L3 = I3.filter(r3);
      L3.length !== I3.length && (0 < L3.length ? e28.report({ node: w3, message: "Unexpected mix of shorthand and non-shorthand properties." }) : D3 && I3.every(i) && e28.report({ node: w3, message: "Expected shorthand for all properties." }));
    }
  }
  function s3() {
    B3.unshift(/* @__PURE__ */ new Set()), e28.getScope().variables.filter(function(w3) {
      return w3.name === "arguments";
    }).forEach(function(w3) {
      w3.references.map(function(D3) {
        return D3.identifier;
      }).forEach(function(D3) {
        return S3.add(D3);
      });
    });
  }
  function o3() {
    B3.shift();
  }
  function u3() {
    B3[0].forEach(function(w3) {
      return O3.add(w3);
    });
  }
  var c3 = e28.options[0] || rm, f3 = c3 === WN || c3 === rm, p3 = c3 === $N || c3 === rm, d3 = c3 === qN, m3 = c3 === GN, y3 = c3 === zN, v3 = e28.options[1] || {}, b3 = v3.ignoreConstructors, x3 = v3.avoidQuotes, C3 = !!v3.avoidExplicitReturnArrows, k3 = e28.getSourceCode(), F3 = /(?:[\0-#%-\/:-\^`-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, B3 = [], O3 = /* @__PURE__ */ new WeakSet(), S3 = /* @__PURE__ */ new WeakSet();
  return { Program: s3, FunctionDeclaration: s3, FunctionExpression: s3, "Program:exit": o3, "FunctionDeclaration:exit": o3, "FunctionExpression:exit": o3, ArrowFunctionExpression: function(w3) {
    B3[0].add(w3);
  }, "ArrowFunctionExpression:exit": function(w3) {
    B3[0].delete(w3);
  }, ThisExpression: u3, Super: u3, MetaProperty: function(w3) {
    w3.meta.name === "new" && w3.property.name === "target" && u3();
  }, Identifier: function(w3) {
    S3.has(w3) && u3();
  }, ObjectExpression: function(w3) {
    m3 ? a3(w3, false) : y3 && a3(w3, true);
  }, "Property:exit": function(w3) {
    var D3 = w3.method || w3.shorthand;
    if (w3.parent.type !== "ObjectPattern" && w3.kind !== "get" && w3.kind !== "set" && (!w3.computed || w3.value.type === "FunctionExpression" || w3.value.type === "ArrowFunctionExpression"))
      if (D3)
        if (w3.method && (d3 || x3 && n3(w3.key))) {
          var I3 = d3 ? "Expected longform method syntax." : "Expected longform method syntax for string literal keys.";
          e28.report({ node: w3, message: I3, fix: function(L3) {
            return function(V10, K3) {
              var W3 = K3.computed ? k3.getTokens(K3).find(function(X3) {
                return X3.value === "[";
              }) : k3.getFirstToken(K3.key), R3 = K3.computed ? k3.getTokensBetween(K3.key, K3.value).find(function(X3) {
                return X3.value === "]";
              }) : k3.getLastToken(K3.key), q3 = k3.text.slice(W3.range[0], R3.range[1]), J3 = "function";
              return K3.value.async && (J3 = "async ".concat(J3)), K3.value.generator && (J3 = "".concat(J3, "*")), V10.replaceTextRange([K3.range[0], R3.range[1]], "".concat(q3, ": ").concat(J3));
            }(L3, w3);
          } });
        } else
          d3 && e28.report({ node: w3, message: "Expected longform property syntax.", fix: function(L3) {
            return L3.insertTextAfter(w3.key, ": ".concat(w3.key.name));
          } });
      else if (!f3 || w3.value.id || w3.value.type !== "FunctionExpression" && w3.value.type !== "ArrowFunctionExpression") {
        if (w3.value.type === "Identifier" && w3.key.name === w3.value.name && p3)
          e28.report({ node: w3, message: "Expected property shorthand.", fix: function(L3) {
            return L3.replaceText(w3, w3.value.name);
          } });
        else if (w3.value.type === "Identifier" && w3.key.type === "Literal" && w3.key.value === w3.value.name && p3) {
          if (x3)
            return;
          e28.report({ node: w3, message: "Expected property shorthand.", fix: function(L3) {
            return L3.replaceText(w3, w3.value.name);
          } });
        }
      } else {
        if (b3 && w3.key.type === "Identifier" && function(L3) {
          var V10 = F3.exec(L3);
          if (!V10)
            return false;
          var K3 = L3.charAt(V10.index);
          return K3 === K3.toUpperCase();
        }(w3.key.name) || x3 && n3(w3.key))
          return;
        (w3.value.type === "FunctionExpression" || w3.value.type === "ArrowFunctionExpression" && w3.value.body.type === "BlockStatement" && C3 && !O3.has(w3.value)) && e28.report({ node: w3, message: "Expected method shorthand.", fix: function(L3) {
          return function(V10, K3) {
            var W3 = K3.computed ? k3.getFirstToken(K3, P$s.isOpeningBracketToken) : k3.getFirstToken(K3.key), R3 = K3.computed ? k3.getFirstTokenBetween(K3.key, K3.value, P$s.isClosingBracketToken) : k3.getLastToken(K3.key), q3 = k3.text.slice(W3.range[0], R3.range[1]), J3 = "";
            if (k3.commentsExistBetween(R3, K3.value))
              return null;
            K3.value.async && (J3 += "async "), K3.value.generator && (J3 += "*");
            var X3 = [W3.range[0], K3.range[1]], ce2 = J3 + q3;
            if (K3.value.type === "FunctionExpression") {
              var A3 = k3.getTokens(K3.value).find(function(Q3) {
                return Q3.type === "Keyword" && Q3.value === "function";
              }), M3 = K3.value.generator ? k3.getTokenAfter(A3) : A3;
              return V10.replaceTextRange(X3, ce2 + k3.text.slice(M3.range[1], K3.value.range[1]));
            }
            var ne2, de2 = k3.getTokenBefore(K3.value.body, P$s.isArrowToken), he2 = k3.text.slice(de2.range[1], K3.value.range[1]), j3 = false;
            if (ne2 = K3.value.params.length === 0 ? k3.getFirstToken(K3.value, P$s.isOpeningParenToken) : k3.getTokenBefore(K3.value.params[0]), K3.value.params.length === 1) {
              var ie2 = P$s.isOpeningParenToken(ne2), fe2 = ne2.range[0] < K3.range[0];
              j3 = !ie2 || fe2;
            }
            var ge2 = j3 ? K3.value.params[0].range[0] : ne2.range[0], Fe2 = k3.getTokenBefore(de2).range[1], Pe2 = k3.text.slice(ge2, Fe2), _3 = j3 ? "(".concat(Pe2, ")") : Pe2;
            return V10.replaceTextRange(X3, ce2 + _3 + he2);
          }(L3, w3);
        } });
      }
  } };
} }, KN = { meta: { type: "suggestion", docs: { description: "enforce variables to be declared either together or separately in functions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/one-var" }, fixable: "code", schema: [{ oneOf: [{ enum: ["always", "never", "consecutive"] }, { type: "object", properties: { separateRequires: { type: "boolean" }, var: { enum: ["always", "never", "consecutive"] }, let: { enum: ["always", "never", "consecutive"] }, const: { enum: ["always", "never", "consecutive"] } }, additionalProperties: false }, { type: "object", properties: { initialized: { enum: ["always", "never", "consecutive"] }, uninitialized: { enum: ["always", "never", "consecutive"] } }, additionalProperties: false }] }] }, create: function(e28) {
  function t3() {
    x3.push({ let: { initialized: false, uninitialized: false }, const: { initialized: false, uninitialized: false } });
  }
  function n3() {
    b3.push({ initialized: false, uninitialized: false }), t3();
  }
  function r3() {
    x3.pop();
  }
  function i() {
    b3.pop(), r3();
  }
  function a3(C3) {
    return C3.init && C3.init.type === "CallExpression" && C3.init.callee.name === "require";
  }
  function s3(C3) {
    for (var k3 = { uninitialized: 0, initialized: 0 }, F3 = 0; F3 < C3.length; F3++)
      C3[F3].init === null ? k3.uninitialized++ : k3.initialized++;
    return k3;
  }
  function o3(C3, k3) {
    var F3 = s3(k3), B3 = y3[C3] || {}, O3 = function(w3) {
      var D3;
      return w3 === "var" ? D3 = b3[b3.length - 1] : w3 === "let" ? D3 = x3[x3.length - 1].let : w3 == "const" && (D3 = x3[x3.length - 1].const), D3;
    }(C3), S3 = k3.some(a3);
    return !(B3.uninitialized === f3 && B3.initialized === f3 && (O3.uninitialized || O3.initialized) && !S3 || 0 < F3.uninitialized && B3.uninitialized === f3 && O3.uninitialized || 0 < F3.initialized && B3.initialized === f3 && O3.initialized && !S3 || O3.required && S3 || (function(w3, D3, I3) {
      for (var L3 = 0; L3 < D3.length; L3++)
        D3[L3].init === null ? y3[w3] && y3[w3].uninitialized === f3 && (I3.uninitialized = true) : y3[w3] && y3[w3].initialized === f3 && (y3.separateRequires && a3(D3[L3]) ? I3.required = true : I3.initialized = true);
    }(C3, k3, O3), 0));
  }
  function u3(C3) {
    var k3 = C3[0], F3 = Array.isArray(k3.parent.parent.body) ? k3.parent.parent.body : [], B3 = F3.findIndex(function(S3) {
      return S3.range[0] === k3.parent.range[0];
    }), O3 = F3[B3 - 1];
    return function(S3) {
      var w3 = v3.getTokenBefore(k3), D3 = v3.getTokenBefore(w3), I3 = [];
      return O3 && O3.kind === v3.getText(w3) && (D3.value === ";" ? I3.push(S3.replaceText(D3, ",")) : I3.push(S3.insertTextAfter(D3, ",")), I3.push(S3.replaceText(w3, ""))), I3;
    };
  }
  function c3(C3) {
    return function(k3) {
      return C3.declarations.map(function(F3) {
        var B3 = v3.getTokenAfter(F3);
        if (B3 === null)
          return null;
        var O3 = v3.getTokenAfter(B3, { includeComments: true });
        if (B3.value !== ",")
          return null;
        if (O3.range[0] === B3.range[1])
          return k3.replaceText(B3, "; ".concat(C3.kind, " "));
        if (O3.loc.start.line > B3.loc.end.line || O3.type === "Line" || O3.type === "Block") {
          for (var S3 = O3; S3.type === "Line" || S3.type === "Block"; )
            S3 = v3.getTokenAfter(S3, { includeComments: true });
          return k3.replaceTextRange([B3.range[0], S3.range[0]], ";".concat(v3.text.slice(B3.range[1], S3.range[0])).concat(C3.kind, " "));
        }
        return k3.replaceText(B3, "; ".concat(C3.kind));
      }).filter(function(F3) {
        return F3;
      });
    };
  }
  var f3 = "always", p3 = "never", d3 = "consecutive", m3 = e28.options[0] || "always", y3 = {};
  typeof m3 == "string" ? (y3.var = { uninitialized: m3, initialized: m3 }, y3.let = { uninitialized: m3, initialized: m3 }, y3.const = { uninitialized: m3, initialized: m3 }) : xe$3(m3) == "object" && (y3.separateRequires = !!m3.separateRequires, y3.var = { uninitialized: m3.var, initialized: m3.var }, y3.let = { uninitialized: m3.let, initialized: m3.let }, y3.const = { uninitialized: m3.const, initialized: m3.const }, Object.prototype.hasOwnProperty.call(m3, "uninitialized") && (y3.var.uninitialized = m3.uninitialized, y3.let.uninitialized = m3.uninitialized, y3.const.uninitialized = m3.uninitialized), Object.prototype.hasOwnProperty.call(m3, "initialized") && (y3.var.initialized = m3.initialized, y3.let.initialized = m3.initialized, y3.const.initialized = m3.initialized));
  var v3 = e28.getSourceCode(), b3 = [], x3 = [];
  return { Program: n3, FunctionDeclaration: n3, FunctionExpression: n3, ArrowFunctionExpression: n3, BlockStatement: t3, ForStatement: t3, ForInStatement: t3, ForOfStatement: t3, SwitchStatement: t3, VariableDeclaration: function(C3) {
    var k3 = C3.parent, F3 = C3.kind;
    if (y3[F3]) {
      var B3 = C3.declarations, O3 = s3(B3), S3 = B3.some(a3) && !B3.every(a3);
      y3[F3].initialized === f3 && y3.separateRequires && S3 && e28.report({ node: C3, message: "Split requires to be separated into a single block." });
      var w3 = k3.body && 0 < k3.body.length && k3.body.indexOf(C3) || 0;
      if (0 < w3) {
        var D3 = k3.body[w3 - 1], I3 = D3.type === "VariableDeclaration", L3 = B3.concat(D3.declarations || []);
        if (I3 && D3.kind === F3 && (!L3.some(a3) || L3.every(a3))) {
          var V10 = s3(D3.declarations);
          y3[F3].initialized === d3 && y3[F3].uninitialized === d3 ? e28.report({ node: C3, message: "Combine this with the previous '{{type}}' statement.", data: { type: F3 }, fix: u3(B3) }) : y3[F3].initialized === d3 && 0 < O3.initialized && 0 < V10.initialized ? e28.report({ node: C3, message: "Combine this with the previous '{{type}}' statement with initialized variables.", data: { type: F3 }, fix: u3(B3) }) : y3[F3].uninitialized === d3 && 0 < O3.uninitialized && 0 < V10.uninitialized && e28.report({ node: C3, message: "Combine this with the previous '{{type}}' statement with uninitialized variables.", data: { type: F3 }, fix: u3(B3) });
        }
      }
      if (!o3(F3, B3)) {
        if (y3[F3].initialized === f3 && y3[F3].uninitialized === f3)
          e28.report({ node: C3, message: "Combine this with the previous '{{type}}' statement.", data: { type: F3 }, fix: u3(B3) });
        else if (y3[F3].initialized === f3 && 0 < O3.initialized && e28.report({ node: C3, message: "Combine this with the previous '{{type}}' statement with initialized variables.", data: { type: F3 }, fix: u3(B3) }), y3[F3].uninitialized === f3 && 0 < O3.uninitialized) {
          if (C3.parent.left === C3 && (C3.parent.type === "ForInStatement" || C3.parent.type === "ForOfStatement"))
            return;
          e28.report({ node: C3, message: "Combine this with the previous '{{type}}' statement with uninitialized variables.", data: { type: F3 }, fix: u3(B3) });
        }
      }
      (k3.type !== "ForStatement" || k3.init !== C3) && 1 < O3.uninitialized + O3.initialized && (y3[F3].initialized === p3 && y3[F3].uninitialized === p3 ? e28.report({ node: C3, message: "Split '{{type}}' declarations into multiple statements.", data: { type: F3 }, fix: c3(C3) }) : y3[F3].initialized === p3 && 0 < O3.initialized ? e28.report({ node: C3, message: "Split initialized '{{type}}' declarations into multiple statements.", data: { type: F3 }, fix: c3(C3) }) : y3[F3].uninitialized === p3 && 0 < O3.uninitialized && e28.report({ node: C3, message: "Split uninitialized '{{type}}' declarations into multiple statements.", data: { type: F3 }, fix: c3(C3) }));
    }
  }, "ForStatement:exit": r3, "ForOfStatement:exit": r3, "ForInStatement:exit": r3, "SwitchStatement:exit": r3, "BlockStatement:exit": r3, "Program:exit": i, "FunctionDeclaration:exit": i, "FunctionExpression:exit": i, "ArrowFunctionExpression:exit": i };
} };
function M2(e28) {
  return 0 <= ["*", "&", "^", "|"].indexOf(e28);
}
function Zp(e28, t3) {
  if (e28.type !== t3.type)
    return false;
  switch (e28.type) {
    case "Identifier":
      return e28.name === t3.name;
    case "Literal":
      return e28.value === t3.value;
    case "MemberExpression":
      return Zp(e28.object, t3.object) && Zp(e28.property, t3.property);
    case "ThisExpression":
      return true;
    default:
      return false;
  }
}
function V2(e28) {
  return e28.type === "Identifier" || e28.type === "MemberExpression" && (e28.object.type === "Identifier" || e28.object.type === "ThisExpression") && (!e28.computed || e28.property.type === "Literal");
}
var JN = { meta: { type: "suggestion", docs: { description: "require or disallow assignment operator shorthand where possible", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/operator-assignment" }, schema: [{ enum: ["always", "never"] }], fixable: "code", messages: { replaced: "Assignment can be replaced with operator assignment.", unexpected: "Unexpected operator assignment shorthand." } }, create: function(e28) {
  function t3(r3) {
    return n3.getFirstTokenBetween(r3.left, r3.right, function(i) {
      return i.value === r3.operator;
    });
  }
  var n3 = e28.getSourceCode();
  return { AssignmentExpression: e28.options[0] === "never" ? function(r3) {
    r3.operator !== "=" && e28.report({ node: r3, messageId: "unexpected", fix: function(i) {
      if (V2(r3.left)) {
        var a3, s3 = n3.getFirstToken(r3), o3 = t3(r3), u3 = n3.getText().slice(r3.range[0], o3.range[0]), c3 = r3.operator.slice(0, -1);
        if (n3.commentsExistBetween(s3, o3))
          return null;
        if (P$s.getPrecedence(r3.right) <= P$s.getPrecedence({ type: "BinaryExpression", operator: c3 }) && !P$s.isParenthesised(n3, r3.right))
          a3 = "".concat(n3.text.slice(o3.range[1], r3.right.range[0]), "(").concat(n3.getText(r3.right), ")");
        else {
          var f3 = n3.getFirstToken(r3.right), p3 = "";
          o3.range[1] !== f3.range[0] || P$s.canTokensBeAdjacent(c3, f3) || (p3 = " "), a3 = "".concat(p3).concat(n3.text.slice(o3.range[1], r3.range[1]));
        }
        return i.replaceText(r3, "".concat(u3, "= ").concat(u3).concat(c3).concat(a3));
      }
      return null;
    } });
  } : function(r3) {
    if (r3.operator === "=" && r3.right.type === "BinaryExpression") {
      var i = r3.left, a3 = r3.right, s3 = a3.operator;
      (M2(s3) || function(o3) {
        return 0 <= ["+", "-", "/", "%", "<<", ">>", ">>>", "**"].indexOf(o3);
      }(s3)) && (Zp(i, a3.left) ? e28.report({ node: r3, messageId: "replaced", fix: function(o3) {
        if (V2(i)) {
          var u3 = t3(r3), c3 = t3(a3), f3 = n3.getText().slice(r3.range[0], u3.range[0]), p3 = n3.getText().slice(c3.range[1], r3.right.range[1]);
          return n3.commentsExistBetween(u3, c3) ? null : o3.replaceText(r3, "".concat(f3).concat(a3.operator, "=").concat(p3));
        }
        return null;
      } }) : Zp(i, a3.right) && M2(s3) && e28.report({ node: r3, messageId: "replaced" }));
    }
  } };
} }, QN = { meta: { type: "layout", docs: { description: "enforce consistent linebreak style for operators", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/operator-linebreak" }, schema: [{ enum: ["after", "before", "none", null] }, { type: "object", properties: { overrides: { type: "object", properties: { anyOf: { type: "string", enum: ["after", "before", "none", "ignore"] } } } }, additionalProperties: false }], fixable: "code" }, create: function(e28) {
  function t3(u3, c3) {
    var f3 = o3.getTokenAfter(c3, P$s.isNotClosingParenToken), p3 = o3.getTokenBefore(f3), d3 = o3.getTokenAfter(f3), m3 = f3.value, y3 = s3[m3], v3 = y3 || i, b3 = function(x3, C3) {
      return function(k3) {
        var F3, B3, O3 = o3.getTokenBefore(x3), S3 = o3.getTokenAfter(x3), w3 = o3.text.slice(O3.range[1], x3.range[0]), D3 = o3.text.slice(x3.range[1], S3.range[0]);
        if (!P$s.isTokenOnSameLine(O3, x3) != !P$s.isTokenOnSameLine(x3, S3) && C3 !== "none") {
          if (o3.getTokenBefore(x3, { includeComments: true }) !== O3 && o3.getTokenAfter(x3, { includeComments: true }) !== S3)
            return null;
          F3 = D3, B3 = w3;
        } else {
          var I3 = P$s.createGlobalLinebreakMatcher();
          if (F3 = C3 === "before" || w3.trim() ? w3 : w3.replace(I3, ""), B3 = C3 === "after" || D3.trim() ? D3 : D3.replace(I3, ""), F3 === w3 && B3 === D3)
            return null;
        }
        return B3 === "" && S3.type === "Punctuator" && "+-".includes(x3.value) && S3.value === x3.value && (B3 += " "), k3.replaceTextRange([O3.range[1], S3.range[0]], F3 + x3.value + B3);
      };
    }(f3, v3);
    P$s.isTokenOnSameLine(p3, f3) && P$s.isTokenOnSameLine(f3, d3) || (y3 === "ignore" || P$s.isTokenOnSameLine(p3, f3) || P$s.isTokenOnSameLine(f3, d3) ? v3 === "before" && P$s.isTokenOnSameLine(p3, f3) ? e28.report({ node: u3, loc: { line: f3.loc.end.line, column: f3.loc.end.column }, message: "'{{operator}}' should be placed at the beginning of the line.", data: { operator: m3 }, fix: b3 }) : v3 === "after" && P$s.isTokenOnSameLine(f3, d3) ? e28.report({ node: u3, loc: { line: f3.loc.end.line, column: f3.loc.end.column }, message: "'{{operator}}' should be placed at the end of the line.", data: { operator: m3 }, fix: b3 }) : v3 === "none" && e28.report({ node: u3, loc: { line: f3.loc.end.line, column: f3.loc.end.column }, message: "There should be no line break before or after '{{operator}}'.", data: { operator: m3 }, fix: b3 }) : e28.report({ node: u3, loc: { line: f3.loc.end.line, column: f3.loc.end.column }, message: "Bad line breaking before and after '{{operator}}'.", data: { operator: m3 }, fix: b3 }));
  }
  function n3(u3) {
    t3(u3, u3.left);
  }
  var r3 = !e28.options[0], i = e28.options[0] || "after", a3 = e28.options[1] || {}, s3 = a3.overrides ? Object.assign({}, a3.overrides) : {};
  r3 && !s3["?"] && (s3["?"] = "before"), r3 && !s3[":"] && (s3[":"] = "before");
  var o3 = e28.getSourceCode();
  return { BinaryExpression: n3, LogicalExpression: n3, AssignmentExpression: n3, VariableDeclarator: function(u3) {
    u3.init && t3(u3, u3.id);
  }, ConditionalExpression: function(u3) {
    t3(u3, u3.test), t3(u3, u3.consequent);
  } };
} }, XN = { meta: { type: "layout", docs: { description: "require or disallow padding within blocks", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/padded-blocks" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never"] }, { type: "object", properties: { blocks: { enum: ["always", "never"] }, switches: { enum: ["always", "never"] }, classes: { enum: ["always", "never"] } }, additionalProperties: false, minProperties: 1 }] }, { type: "object", properties: { allowSingleLineBlocks: { type: "boolean" } } }] }, create: function(e28) {
  function t3(y3) {
    return y3.type === "Line" || y3.type === "Block";
  }
  function n3(y3, v3) {
    return 2 <= v3.loc.start.line - y3.loc.end.line;
  }
  function r3(y3) {
    var v3, b3 = y3;
    do
      v3 = b3, b3 = d3.getTokenAfter(b3, { includeComments: true });
    while (t3(b3) && b3.loc.start.line === v3.loc.end.line);
    return b3;
  }
  function i(y3) {
    var v3, b3 = y3;
    do
      v3 = b3, b3 = d3.getTokenBefore(b3, { includeComments: true });
    while (t3(b3) && b3.loc.end.line === v3.loc.start.line);
    return b3;
  }
  function a3(y3) {
    var v3 = r3(function(B3) {
      return B3.type === "SwitchStatement" ? d3.getTokenBefore(B3.cases[0]) : d3.getFirstToken(B3);
    }(y3)), b3 = d3.getTokenBefore(v3, { includeComments: true }), x3 = i(d3.getLastToken(y3)), C3 = d3.getTokenAfter(x3, { includeComments: true }), k3 = n3(b3, v3), F3 = n3(x3, C3);
    s3.allowSingleLineBlocks && P$s.isTokenOnSameLine(b3, C3) || (function(B3) {
      switch (B3.type) {
        case "BlockStatement":
          return s3.blocks;
        case "SwitchStatement":
          return s3.switches;
        case "ClassBody":
          return s3.classes;
        default:
          throw new Error("unreachable");
      }
    }(y3) ? (!k3 && e28.report({ node: y3, loc: { line: b3.loc.start.line, column: b3.loc.start.column }, fix: function(B3) {
      return B3.insertTextAfter(b3, `
`);
    }, message: f3 }), !F3 && e28.report({ node: y3, loc: { line: C3.loc.end.line, column: C3.loc.end.column - 1 }, fix: function(B3) {
      return B3.insertTextBefore(C3, `
`);
    }, message: f3 })) : (k3 && e28.report({ node: y3, loc: { line: b3.loc.start.line, column: b3.loc.start.column }, fix: function(B3) {
      return B3.replaceTextRange([b3.range[1], v3.range[0] - v3.loc.start.column], `
`);
    }, message: p3 }), F3 && e28.report({ node: y3, loc: { line: C3.loc.end.line, column: C3.loc.end.column - 1 }, message: p3, fix: function(B3) {
      return B3.replaceTextRange([x3.range[1], C3.range[0] - C3.loc.start.column], `
`);
    } })));
  }
  var s3 = {}, o3 = e28.options[0] || "always", u3 = e28.options[1] || {};
  if (typeof o3 == "string") {
    var c3 = o3 === "always";
    s3.blocks = c3, s3.switches = c3, s3.classes = c3;
  } else
    Object.prototype.hasOwnProperty.call(o3, "blocks") && (s3.blocks = o3.blocks === "always"), Object.prototype.hasOwnProperty.call(o3, "switches") && (s3.switches = o3.switches === "always"), Object.prototype.hasOwnProperty.call(o3, "classes") && (s3.classes = o3.classes === "always");
  Object.prototype.hasOwnProperty.call(u3, "allowSingleLineBlocks") && (s3.allowSingleLineBlocks = u3.allowSingleLineBlocks === true);
  var f3 = "Block must be padded by blank lines.", p3 = "Block must not be padded by blank lines.", d3 = e28.getSourceCode(), m3 = {};
  return Object.prototype.hasOwnProperty.call(s3, "switches") && (m3.SwitchStatement = function(y3) {
    y3.cases.length === 0 || a3(y3);
  }), Object.prototype.hasOwnProperty.call(s3, "blocks") && (m3.BlockStatement = function(y3) {
    y3.body.length === 0 || a3(y3);
  }), Object.prototype.hasOwnProperty.call(s3, "classes") && (m3.ClassBody = function(y3) {
    y3.body.length === 0 || a3(y3);
  }), m3;
} }, YN = ("[".concat(Array.from(P$s.LINEBREAKS).join(""), "]"), /^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*?)[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*;?)$/), ZN = /^(?:module[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\.[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)?exports(?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\.|[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\[|$)/, ej = /^require\(/;
function Dn$1(e28) {
  return { test: function(t3, n3) {
    return n3.getFirstToken(t3).value === e28;
  } };
}
function im(e28) {
  return { test: function(t3, n3) {
    return t3.loc.start.line === t3.loc.end.line && n3.getFirstToken(t3).value === e28;
  } };
}
function am(e28) {
  return { test: function(t3, n3) {
    return t3.loc.start.line !== t3.loc.end.line && n3.getFirstToken(t3).value === e28;
  } };
}
function om(e28) {
  return { test: function(t3) {
    return t3.type === e28;
  } };
}
function MA(e28) {
  if (e28.type === "ExpressionStatement") {
    var t3 = e28.expression;
    return t3.type === "UnaryExpression" && (t3 = t3.argument), t3.type === "CallExpression" && P$s.isFunction(t3.callee);
  }
  return false;
}
function U2(e28, t3) {
  if (t3.type === "DoWhileStatement" && t3.body.type === "BlockStatement" || MA(t3))
    return true;
  var n3 = e28.getLastToken(t3, P$s.isNotSemicolonToken), r3 = n3 && P$s.isClosingBraceToken(n3) ? e28.getNodeByRangeIndex(n3.range[0]) : null;
  return !!r3 && (r3.type === "BlockStatement" || r3.type === "SwitchStatement");
}
function q2(e28, t3) {
  return e28.type === "ExpressionStatement" && (e28.parent.type === "Program" || e28.parent.type === "BlockStatement" && P$s.isFunction(e28.parent.parent)) && e28.expression.type === "Literal" && typeof e28.expression.value == "string" && !P$s.isParenthesised(t3, e28.expression);
}
function sm(e28, t3) {
  if (q2(e28, t3)) {
    var n3 = true, r3 = false, i = void 0;
    try {
      for (var a3, s3 = e28.parent.body[Symbol.iterator](); !(n3 = (a3 = s3.next()).done); n3 = true) {
        var o3 = a3.value;
        if (o3 === e28)
          break;
        if (!q2(o3, t3))
          return false;
      }
    } catch (u3) {
      r3 = true, i = u3;
    } finally {
      try {
        n3 || s3.return == null || s3.return();
      } finally {
        if (r3)
          throw i;
      }
    }
    return true;
  }
  return false;
}
function VA(e28, t3) {
  var n3 = e28.getLastToken(t3), r3 = e28.getTokenBefore(n3), i = e28.getTokenAfter(n3);
  return r3 && i && r3.range[0] >= t3.range[0] && P$s.isSemicolonToken(n3) && n3.loc.start.line !== r3.loc.end.line && n3.loc.end.line === i.loc.start.line ? r3 : n3;
}
function tj(e28, t3, n3) {
  return t3 + n3;
}
var um = { any: { verify: function() {
} }, never: { verify: function(e28, t3, n3, r3) {
  r3.length === 0 || e28.report({ node: n3, message: "Unexpected blank line before this statement.", fix: function(i) {
    if (2 <= r3.length)
      return null;
    var a3 = r3[0][0], s3 = r3[0][1], o3 = a3.range[1], u3 = s3.range[0], c3 = e28.getSourceCode().text.slice(o3, u3).replace(YN, tj);
    return i.replaceTextRange([o3, u3], c3);
  } });
} }, always: { verify: function(e28, t3, n3, r3) {
  0 < r3.length || e28.report({ node: n3, message: "Expected blank line before this statement.", fix: function(i) {
    var a3 = e28.getSourceCode(), s3 = VA(a3, t3), o3 = a3.getFirstTokenBetween(s3, n3, { includeComments: true, filter: function(c3) {
      return !P$s.isTokenOnSameLine(s3, c3) || (s3 = c3, false);
    } }) || n3, u3 = P$s.isTokenOnSameLine(s3, o3) ? `

` : `
`;
    return i.insertTextAfter(s3, u3);
  } });
} } }, cm = { "*": { test: function() {
  return true;
} }, "block-like": { test: function(e28, t3) {
  return U2(t3, e28);
} }, "cjs-export": { test: function(e28, t3) {
  return e28.type === "ExpressionStatement" && e28.expression.type === "AssignmentExpression" && ZN.test(t3.getText(e28.expression.left));
} }, "cjs-import": { test: function(e28, t3) {
  return e28.type === "VariableDeclaration" && 0 < e28.declarations.length && !!e28.declarations[0].init && ej.test(t3.getText(e28.declarations[0].init));
} }, directive: { test: sm }, expression: { test: function(e28, t3) {
  return e28.type === "ExpressionStatement" && !sm(e28, t3);
} }, iife: { test: MA }, "multiline-block-like": { test: function(e28, t3) {
  return e28.loc.start.line !== e28.loc.end.line && U2(t3, e28);
} }, "multiline-expression": { test: function(e28, t3) {
  return e28.loc.start.line !== e28.loc.end.line && e28.type === "ExpressionStatement" && !sm(e28, t3);
} }, "multiline-const": am("const"), "multiline-let": am("let"), "multiline-var": am("var"), "singleline-const": im("const"), "singleline-let": im("let"), "singleline-var": im("var"), block: om("BlockStatement"), empty: om("EmptyStatement"), function: om("FunctionDeclaration"), break: Dn$1("break"), case: Dn$1("case"), class: Dn$1("class"), const: Dn$1("const"), continue: Dn$1("continue"), debugger: Dn$1("debugger"), default: Dn$1("default"), do: Dn$1("do"), export: Dn$1("export"), for: Dn$1("for"), if: Dn$1("if"), import: Dn$1("import"), let: Dn$1("let"), return: Dn$1("return"), switch: Dn$1("switch"), throw: Dn$1("throw"), try: Dn$1("try"), var: Dn$1("var"), while: Dn$1("while"), with: Dn$1("with") }, nj = { meta: { type: "layout", docs: { description: "require or disallow padding lines between statements", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/padding-line-between-statements" }, fixable: "whitespace", schema: { definitions: { paddingType: { enum: Object.keys(um) }, statementType: { anyOf: [{ enum: Object.keys(cm) }, { type: "array", items: { enum: Object.keys(cm) }, minItems: 1, uniqueItems: true, additionalItems: false }] } }, type: "array", items: { type: "object", properties: { blankLine: { $ref: "#/definitions/paddingType" }, prev: { $ref: "#/definitions/statementType" }, next: { $ref: "#/definitions/statementType" } }, additionalProperties: false, required: ["blankLine", "prev", "next"] }, additionalItems: false } }, create: function(e28) {
  function t3() {
    u3 = { upper: u3, prevNode: null };
  }
  function n3() {
    u3 = u3.upper;
  }
  function r3(c3, f3) {
    for (var p3 = c3; p3.type === "LabeledStatement"; )
      p3 = p3.body;
    return Array.isArray(f3) ? f3.some(r3.bind(null, p3)) : cm[f3].test(p3, s3);
  }
  function i(c3, f3) {
    for (var p3 = o3.length - 1; 0 <= p3; --p3) {
      var d3 = o3[p3];
      if (r3(c3, d3.prev) && r3(f3, d3.next))
        return um[d3.blankLine];
    }
    return um.any;
  }
  function a3(c3) {
    var f3 = c3.parent.type;
    if (P$s.STATEMENT_LIST_PARENTS.has(f3) || f3 === "SwitchStatement") {
      var p3 = u3.prevNode;
      if (p3) {
        var d3 = i(p3, c3), m3 = function(y3, v3) {
          var b3 = [], x3 = VA(s3, y3);
          if (2 <= v3.loc.start.line - x3.loc.end.line)
            do {
              var C3 = s3.getTokenAfter(x3, { includeComments: true });
              2 <= C3.loc.start.line - x3.loc.end.line && b3.push([x3, C3]), x3 = C3;
            } while (x3.range[0] < v3.range[0]);
          return b3;
        }(p3, c3);
        d3.verify(e28, p3, c3, m3);
      }
      u3.prevNode = c3;
    }
  }
  var s3 = e28.getSourceCode(), o3 = e28.options || [], u3 = null;
  return { Program: t3, BlockStatement: t3, SwitchStatement: t3, "Program:exit": n3, "BlockStatement:exit": n3, "SwitchStatement:exit": n3, ":statement": a3, SwitchCase: function(c3) {
    a3(c3), t3();
  }, "SwitchCase:exit": n3 };
} }, rj = { meta: { type: "suggestion", docs: { description: "require using arrow functions for callbacks", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-arrow-callback" }, schema: [{ type: "object", properties: { allowNamedFunctions: { type: "boolean", default: false }, allowUnboundThis: { type: "boolean", default: true } }, additionalProperties: false }], fixable: "code" }, create: function(e28) {
  function t3() {
    o3.push({ this: false, super: false, meta: false });
  }
  function n3() {
    return o3.pop();
  }
  var r3 = e28.options[0] || {}, i = r3.allowUnboundThis !== false, a3 = r3.allowNamedFunctions, s3 = e28.getSourceCode(), o3 = [];
  return { Program: function() {
    o3 = [];
  }, ThisExpression: function() {
    var u3 = o3[o3.length - 1];
    u3 && (u3.this = true);
  }, Super: function() {
    var u3 = o3[o3.length - 1];
    u3 && (u3.super = true);
  }, MetaProperty: function(u3) {
    var c3 = o3[o3.length - 1];
    c3 && function(f3, p3, d3) {
      return f3.meta.name === p3 && f3.property.name === d3;
    }(u3, "new", "target") && (c3.meta = true);
  }, FunctionDeclaration: t3, "FunctionDeclaration:exit": n3, FunctionExpression: t3, "FunctionExpression:exit": function(u3) {
    var c3 = n3();
    if (!(a3 && u3.id && u3.id.name || u3.generator)) {
      var f3 = e28.getDeclaredVariables(u3)[0];
      if (!(function(m3) {
        return m3 && m3.defs[0].type === "FunctionName";
      }(f3) && 0 < f3.references.length)) {
        var p3 = function(m3) {
          for (var y3 = m3.variables, v3 = 0; v3 < y3.length; ++v3) {
            var b3 = y3[v3];
            if (b3.name === "arguments")
              return b3.identifiers.length === 0 ? b3 : null;
          }
          return null;
        }(e28.getScope());
        if (!(p3 && 0 < p3.references.length)) {
          var d3 = function(m3) {
            for (var y3 = { isCallback: false, isLexicalThis: false }, v3 = m3, b3 = m3.parent; v3; ) {
              switch (b3.type) {
                case "LogicalExpression":
                case "ConditionalExpression":
                  break;
                case "MemberExpression":
                  if (b3.object !== v3 || b3.property.computed || b3.property.type !== "Identifier" || b3.property.name !== "bind" || b3.parent.type !== "CallExpression" || b3.parent.callee !== b3)
                    return y3;
                  y3.isLexicalThis = b3.parent.arguments.length === 1 && b3.parent.arguments[0].type === "ThisExpression", b3 = b3.parent;
                  break;
                case "CallExpression":
                case "NewExpression":
                  return b3.callee !== v3 && (y3.isCallback = true), y3;
                default:
                  return y3;
              }
              v3 = b3, b3 = b3.parent;
            }
            throw new Error("unreachable");
          }(u3);
          !d3.isCallback || i && c3.this && !d3.isLexicalThis || c3.super || c3.meta || e28.report({ node: u3, message: "Unexpected function expression.", fix: function(m3) {
            if (!d3.isLexicalThis && c3.this || function(B3) {
              return B3.every(function(O3) {
                return O3.type === "Identifier";
              }) && B3.length !== new Set(B3.map(function(O3) {
                return O3.name;
              })).size;
            }(u3.params))
              return null;
            var y3 = u3.params.length ? s3.getTokenBefore(u3.params[0]) : s3.getTokenBefore(u3.body, 1), v3 = s3.getTokenBefore(u3.body), b3 = u3.async ? "async " : "", x3 = s3.text.slice(y3.range[0], v3.range[1]), C3 = "".concat(b3).concat(x3, " => ").concat(s3.getText(u3.body)), k3 = d3.isLexicalThis ? u3.parent.parent : u3, F3 = k3.parent.type !== "CallExpression" && k3.parent.type !== "ConditionalExpression" ? "(".concat(C3, ")") : C3;
            return m3.replaceText(k3, F3);
          } });
        }
      }
    }
  } };
} }, UA = /^(?:(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?Pattern|RestElement|SpreadProperty|ExperimentalRestProperty|Property)$/, ij = /^(?:Program|BlockStatement|SwitchCase)$/, aj = /^(?:VariableDeclarator|AssignmentExpression)$/;
function W2(e28, t3) {
  if (t3.through.find(function(r3) {
    return r3.resolved && r3.resolved.name === e28;
  }))
    return true;
  var n3 = P$s.getVariableByName(t3, e28);
  return n3 !== null && n3.defs.some(function(r3) {
    return r3.type === "Parameter";
  });
}
function qA(e28) {
  if (!e28.isWrite())
    return null;
  for (var t3 = e28.identifier.parent; UA.test(t3.type); )
    t3 = t3.parent;
  return aj.test(t3.type) ? t3 : null;
}
function nc$2(e28) {
  switch (e28.type) {
    case "ObjectPattern":
      return e28.properties.some(function(t3) {
        return !!t3 && nc$2(t3.argument || t3.value);
      });
    case "ArrayPattern":
      return e28.elements.some(function(t3) {
        return !!t3 && nc$2(t3);
      });
    case "AssignmentPattern":
      return nc$2(e28.left);
    case "MemberExpression":
      return true;
  }
  return false;
}
function oj(e28, t3) {
  if (e28.eslintUsed && e28.scope.type === "global")
    return null;
  for (var n3 = null, r3 = false, i = e28.references, a3 = 0; a3 < i.length; ++a3) {
    var s3 = i[a3];
    if (s3.isWrite()) {
      if (n3 !== null && n3.identifier !== s3.identifier)
        return null;
      var o3 = qA(s3);
      if (o3 !== null && o3.left !== void 0) {
        var u3 = o3.left, c3 = false, f3 = false;
        if (u3.type === "ObjectPattern" ? (c3 = u3.properties.filter(function(p3) {
          return p3.value;
        }).map(function(p3) {
          return p3.value.name;
        }).some(function(p3) {
          return W2(p3, e28.scope);
        }), f3 = nc$2(u3)) : u3.type === "ArrayPattern" && (c3 = u3.elements.map(function(p3) {
          return p3 && p3.name;
        }).some(function(p3) {
          return W2(p3, e28.scope);
        }), f3 = nc$2(u3)), c3 || f3)
          return null;
      }
      n3 = s3;
    } else if (s3.isRead() && n3 === null) {
      if (t3)
        return null;
      r3 = true;
    }
  }
  return n3 !== null && n3.from === e28.scope && function(p3) {
    for (var d3 = p3.parent; UA.test(d3.type); )
      d3 = d3.parent;
    return d3.type === "VariableDeclarator" || d3.type === "AssignmentExpression" && d3.parent.type === "ExpressionStatement" && ij.test(d3.parent.parent.type);
  }(n3.identifier) ? r3 ? e28.defs[0].name : n3.identifier : null;
}
var sj = { meta: { type: "suggestion", docs: { description: "require `const` declarations for variables that are never reassigned after declared", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-const" }, fixable: "code", schema: [{ type: "object", properties: { destructuring: { enum: ["any", "all"], default: "any" }, ignoreReadBeforeAssign: { type: "boolean", default: false } }, additionalProperties: false }], messages: { useConst: "'{{name}}' is never reassigned. Use 'const' instead." } }, create: function(e28) {
  function t3(f3) {
    var p3 = f3.filter(Boolean);
    if (f3.length && (i || p3.length === f3.length)) {
      var d3 = function x3(C3, k3, F3) {
        return !C3 || F3(C3) ? null : C3.type === k3 ? C3 : x3(C3.parent, k3, F3);
      }(f3[0], "VariableDeclaration", function(x3) {
        return x3.type.endsWith("Statement");
      }), m3 = d3 === null;
      if (!m3 && 0 < d3.declarations.length) {
        var y3 = d3.declarations[0];
        if (y3.init) {
          var v3 = y3.init.parent;
          v3.type === "VariableDeclarator" && (v3.id.name !== c3 && (c3 = v3.id.name, o3 = 0), v3.id.type === "ObjectPattern" && v3.init.name !== c3 && (c3 = v3.init.name, o3 = 0), v3.id !== u3 && (u3 = v3.id, o3 = 0));
        }
      }
      var b3 = d3 && (d3.parent.type === "ForInStatement" || d3.parent.type === "ForOfStatement" || d3.declarations.every(function(x3) {
        return x3.init;
      })) && p3.length === f3.length;
      !m3 && d3.declarations && d3.declarations.length !== 1 && d3 && d3.declarations && 1 <= d3.declarations.length && (o3 += p3.length, b3 = b3 && o3 === d3.declarations.length), p3.forEach(function(x3) {
        e28.report({ node: x3, messageId: "useConst", data: x3, fix: b3 ? function(C3) {
          return C3.replaceText(r3.getFirstToken(d3, function(k3) {
            return k3.value === d3.kind;
          }), "const");
        } : null });
      });
    }
  }
  var n3 = e28.options[0] || {}, r3 = e28.getSourceCode(), i = n3.destructuring !== "all", a3 = n3.ignoreReadBeforeAssign === true, s3 = [], o3 = 0, u3 = null, c3 = "";
  return { "Program:exit": function() {
    (function(f3, p3) {
      for (var d3 = /* @__PURE__ */ new Map(), m3 = 0; m3 < f3.length; ++m3)
        for (var y3 = f3[m3], v3 = y3.references, b3 = oj(y3, p3), x3 = null, C3 = 0; C3 < v3.length; ++C3) {
          var k3 = v3[C3], F3 = k3.identifier;
          if (F3 !== x3) {
            x3 = F3;
            var B3 = qA(k3);
            B3 && (d3.has(B3) ? d3.get(B3).push(b3) : d3.set(B3, [b3]));
          }
        }
      return d3;
    })(s3, a3).forEach(t3);
  }, VariableDeclaration: function(f3) {
    f3.kind !== "let" || function(p3) {
      return p3.parent.type === "ForStatement" && p3.parent.init === p3;
    }(f3) || s3.push.apply(s3, Mt$2(e28.getDeclaredVariables(f3)));
  } };
} }, uj = { meta: { type: "suggestion", docs: { description: "require destructuring from arrays and/or objects", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-destructuring" }, fixable: "code", schema: [{ oneOf: [{ type: "object", properties: { VariableDeclarator: { type: "object", properties: { array: { type: "boolean" }, object: { type: "boolean" } }, additionalProperties: false }, AssignmentExpression: { type: "object", properties: { array: { type: "boolean" }, object: { type: "boolean" } }, additionalProperties: false } }, additionalProperties: false }, { type: "object", properties: { array: { type: "boolean" }, object: { type: "boolean" } }, additionalProperties: false }] }, { type: "object", properties: { enforceForRenamedProperties: { type: "boolean" } }, additionalProperties: false }] }, create: function(e28) {
  function t3(u3, c3) {
    return o3 && o3[u3] && o3[u3][c3];
  }
  function n3(u3, c3, f3) {
    e28.report({ node: u3, message: "Use {{type}} destructuring.", data: { type: c3 }, fix: f3 });
  }
  function r3(u3, c3) {
    var f3 = c3.init, p3 = e28.getSourceCode();
    return u3.replaceText(c3, "{".concat(f3.property.name, "} = ").concat(p3.getText(f3.object)));
  }
  function i(u3, c3, f3) {
    if (c3.type === "MemberExpression" && c3.object.type !== "Super") {
      if (function(m3) {
        return Number.isInteger(m3.property.value);
      }(c3))
        return void (t3(f3.type, "array") && n3(f3, "array", null));
      var p3 = function(m3) {
        return m3.type === "VariableDeclarator" && m3.id.type === "Identifier" && m3.init.type === "MemberExpression" && m3.id.name === m3.init.property.name;
      }(f3) ? function(m3) {
        return r3(m3, f3);
      } : null;
      if (t3(f3.type, "object") && s3)
        return void n3(f3, "object", p3);
      if (t3(f3.type, "object")) {
        var d3 = c3.property;
        (d3.type !== "Literal" || u3.name !== d3.value) && (d3.type !== "Identifier" || u3.name !== d3.name || c3.computed) || n3(f3, "object", p3);
      }
    }
  }
  var a3 = e28.options[0], s3 = e28.options[1] && e28.options[1].enforceForRenamedProperties, o3 = { VariableDeclarator: { array: true, object: true }, AssignmentExpression: { array: true, object: true } };
  return a3 && (o3 = a3.array !== void 0 || a3.object !== void 0 ? { VariableDeclarator: a3, AssignmentExpression: a3 } : a3), { VariableDeclarator: function(u3) {
    u3.init && u3.init.type === "MemberExpression" && i(u3.id, u3.init, u3);
  }, AssignmentExpression: function(u3) {
    u3.operator === "=" && i(u3.left, u3.right, u3);
  } };
} }, WA = ye$4.require$$0, cj = WA.CALL, lj = WA.ReferenceTracker, lm = P$s.getPrecedence({ type: "BinaryExpression", operator: "**" });
function pm(e28, t3) {
  return t3 ? "(".concat(e28, ")") : e28;
}
var pj = { meta: { type: "suggestion", docs: { description: "disallow the use of `Math.pow` in favor of the `**` operator", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/prefer-exponentiation-operator" }, schema: [], fixable: "code", messages: { useExponentiation: "Use the '**' operator instead of 'Math.pow'." } }, create: function(e28) {
  function t3(r3) {
    e28.report({ node: r3, messageId: "useExponentiation", fix: function(i) {
      if (r3.arguments.length !== 2 || r3.arguments.some(function(B3) {
        return B3.type === "SpreadElement";
      }) || 0 < n3.getCommentsInside(r3).length)
        return null;
      var a3 = r3.arguments[0], s3 = r3.arguments[1], o3 = n3.getText(a3), u3 = n3.getText(s3), c3 = function(B3) {
        return P$s.getPrecedence(B3) <= lm || B3.type === "UnaryExpression";
      }(a3), f3 = function(B3) {
        return P$s.getPrecedence(B3) < lm;
      }(s3), p3 = function(B3, O3) {
        var S3 = B3.parent;
        return (S3.type === "ClassDeclaration" || S3.type.endsWith("Expression") && P$s.getPrecedence(S3) >= lm && (S3.type !== "BinaryExpression" || S3.operator !== "**" || S3.right !== B3) && !((S3.type === "CallExpression" || S3.type === "NewExpression") && S3.arguments.includes(B3)) && !(S3.type === "MemberExpression" && S3.computed && S3.property === B3) && S3.type !== "ArrayExpression") && !P$s.isParenthesised(O3, B3);
      }(r3, n3), d3 = "", m3 = "";
      if (!p3) {
        if (!c3) {
          var y3 = n3.getFirstToken(a3), v3 = n3.getTokenBefore(r3);
          v3 && v3.range[1] === r3.range[0] && !P$s.canTokensBeAdjacent(v3, y3) && (d3 = " ");
        }
        if (!f3) {
          var b3 = n3.getLastToken(s3), x3 = n3.getTokenAfter(r3);
          x3 && r3.range[1] === x3.range[0] && !P$s.canTokensBeAdjacent(b3, x3) && (m3 = " ");
        }
      }
      var C3 = pm(o3, c3), k3 = pm(u3, f3), F3 = pm("".concat(C3, "**").concat(k3), p3);
      return i.replaceText(r3, "".concat(d3).concat(F3).concat(m3));
    } });
  }
  var n3 = e28.getSourceCode();
  return { Program: function() {
    var r3 = e28.getScope(), i = new lj(r3), a3 = { Math: { pow: Fn$1({}, cj, true) } }, s3 = true, o3 = false, u3 = void 0;
    try {
      for (var c3, f3 = i.iterateGlobalReferences(a3)[Symbol.iterator](); !(s3 = (c3 = f3.next()).done); s3 = true)
        t3(c3.value.node);
    } catch (p3) {
      o3 = true, u3 = p3;
    } finally {
      try {
        s3 || f3.return == null || f3.return();
      } finally {
        if (o3)
          throw u3;
      }
    }
  } };
} }, Cf = ye$4.require$$0, fj = Cf.CALL, hj = Cf.CONSTRUCT, dj = Cf.ReferenceTracker, $2 = Cf.getStringIfConstant, mj = new ao$1.RegExpParser(), gj = { meta: { type: "suggestion", docs: { description: "enforce using named capture group in regular expression", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/prefer-named-capture-group" }, schema: [], messages: { required: "Capture group '{{group}}' should be converted to a named or non-capturing group." } }, create: function(e28) {
  function t3(n3, r3, i) {
    var a3;
    try {
      a3 = mj.parsePattern(n3, 0, n3.length, i);
    } catch {
      return;
    }
    ao$1.visitRegExpAST(a3, { onCapturingGroupEnter: function(s3) {
      s3.name || e28.report({ node: r3, messageId: "required", data: { group: s3.raw } });
    } });
  }
  return { Literal: function(n3) {
    n3.regex && t3(n3.regex.pattern, n3, n3.regex.flags.includes("u"));
  }, Program: function() {
    var n3, r3 = e28.getScope(), i = new dj(r3), a3 = { RegExp: (n3 = {}, Fn$1(n3, fj, true), Fn$1(n3, hj, true), n3) }, s3 = true, o3 = false, u3 = void 0;
    try {
      for (var c3, f3 = i.iterateGlobalReferences(a3)[Symbol.iterator](); !(s3 = (c3 = f3.next()).done); s3 = true) {
        var p3 = c3.value.node, d3 = $2(p3.arguments[0]), m3 = $2(p3.arguments[1]);
        d3 && t3(d3, p3, m3 && m3.includes("u"));
      }
    } catch (y3) {
      o3 = true, u3 = y3;
    } finally {
      try {
        s3 || f3.return == null || f3.return();
      } finally {
        if (o3)
          throw u3;
      }
    }
  } };
} }, yj = { meta: { type: "suggestion", docs: { description: "disallow `parseInt()` and `Number.parseInt()` in favor of binary, octal, and hexadecimal literals", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-numeric-literals" }, schema: [], fixable: "code" }, create: function(e28) {
  var t3 = e28.getSourceCode(), n3 = { 2: "binary", 8: "octal", 16: "hexadecimal" }, r3 = { 2: "0b", 8: "0o", 16: "0x" };
  return { CallExpression: function(i) {
    if (i.arguments.length === 2) {
      var a3 = n3[i.arguments[1].value];
      (function(s3) {
        switch (s3.type) {
          case "Identifier":
            return s3.name === "parseInt";
          case "MemberExpression":
            return s3.object.type === "Identifier" && s3.object.name === "Number" && s3.property.type === "Identifier" && s3.property.name === "parseInt";
        }
        return false;
      })(i.callee) && a3 && i.arguments[0].type === "Literal" && e28.report({ node: i, message: "Use {{radixName}} literals instead of {{functionName}}().", data: { radixName: a3, functionName: t3.getText(i.callee) }, fix: function(s3) {
        if (t3.getCommentsInside(i).length)
          return null;
        var o3 = "".concat(r3[i.arguments[1].value]).concat(i.arguments[0].value);
        if (+o3 !== parseInt(i.arguments[0].value, i.arguments[1].value))
          return null;
        var u3 = t3.getTokenBefore(i), c3 = t3.getTokenAfter(i), f3 = "", p3 = "";
        return u3 && u3.range[1] === i.range[0] && !P$s.canTokensBeAdjacent(u3, o3) && (f3 = " "), c3 && i.range[1] === c3.range[0] && !P$s.canTokensBeAdjacent(o3, c3) && (p3 = " "), s3.replaceText(i, "".concat(f3).concat(o3).concat(p3));
      } });
    }
  } };
} }, $A = ye$4.require$$0, vj = $A.CALL, xj = $A.ReferenceTracker, G2 = P$s.isCommaToken, GA = P$s.isOpeningParenToken, bj = P$s.isClosingParenToken, f0 = P$s.isParenthesised, zA = /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]/;
function Ej(e28) {
  return e28.arguments.some(function(t3) {
    return t3.type === "SpreadElement";
  });
}
function Cj(e28, t3) {
  var n3 = e28.parent;
  switch (n3.type) {
    case "VariableDeclarator":
    case "ArrayExpression":
    case "ReturnStatement":
    case "CallExpression":
    case "Property":
      return false;
    case "AssignmentExpression":
      return n3.left === e28 && !f0(t3, e28);
    default:
      return !f0(t3, e28);
  }
}
function Sj(e28, t3) {
  switch (e28.type) {
    case "AssignmentExpression":
    case "ArrowFunctionExpression":
    case "ConditionalExpression":
      return !f0(t3, e28);
    default:
      return false;
  }
}
function kj(e28, t3, n3) {
  for (var r3 = [n3.getFirstToken(e28), n3.getLastToken(e28)], i = n3.getTokenBefore(e28), a3 = n3.getTokenAfter(e28); i && a3 && i.range[0] > t3.range[0] && GA(i) && bj(a3); )
    r3.push(i, a3), i = n3.getTokenBefore(i), a3 = n3.getTokenAfter(a3);
  return r3.sort(function(s3, o3) {
    return s3.range[0] - o3.range[0];
  });
}
function Dj(e28, t3) {
  var n3 = t3.text, r3 = e28.range[0], i = t3.getTokenBefore(e28, { includeComments: true });
  if (i && i.type === "Line")
    return r3;
  for (; zA.test(n3[r3 - 1] || ""); )
    r3 -= 1;
  return r3;
}
function Fj(e28, t3) {
  for (var n3 = t3.text, r3 = e28.range[1]; zA.test(n3[r3] || ""); )
    r3 += 1;
  return r3;
}
function wj(e28, t3) {
  return regeneratorRuntime.mark(function n3(r3) {
    var i, a3, s3, o3, u3, c3, f3, p3, d3, m3, y3, v3, b3, x3, C3, k3, F3, B3, O3, S3, w3;
    return regeneratorRuntime.wrap(function(D3) {
      for (; ; )
        switch (D3.prev = D3.next) {
          case 0:
            return i = t3.getTokenAfter(e28.callee, GA), a3 = t3.getLastToken(e28), D3.next = 3, r3.remove(e28.callee);
          case 3:
            if (!Cj(e28, t3)) {
              D3.next = 10;
              break;
            }
            return D3.next = 6, r3.replaceText(i, "({");
          case 6:
            return D3.next = 8, r3.replaceText(a3, "})");
          case 8:
            D3.next = 14;
            break;
          case 10:
            return D3.next = 12, r3.replaceText(i, "{");
          case 12:
            return D3.next = 14, r3.replaceText(a3, "}");
          case 14:
            s3 = true, o3 = false, u3 = void 0, D3.prev = 17, c3 = e28.arguments[Symbol.iterator]();
          case 19:
            if (s3 = (f3 = c3.next()).done) {
              D3.next = 73;
              break;
            }
            if (p3 = f3.value, d3 = kj(p3, i, t3), m3 = d3.shift(), y3 = d3.pop(), p3.type !== "ObjectExpression") {
              D3.next = 61;
              break;
            }
            v3 = t3.getLastToken(p3, 1), b3 = t3.getTokenAfter(y3), x3 = true, C3 = false, k3 = void 0, D3.prev = 27, F3 = d3[Symbol.iterator]();
          case 29:
            if (x3 = (B3 = F3.next()).done) {
              D3.next = 36;
              break;
            }
            return O3 = B3.value, D3.next = 33, r3.remove(O3);
          case 33:
            x3 = true, D3.next = 29;
            break;
          case 36:
            D3.next = 42;
            break;
          case 38:
            D3.prev = 38, D3.t0 = D3.catch(27), C3 = true, k3 = D3.t0;
          case 42:
            D3.prev = 42, D3.prev = 43, x3 || F3.return == null || F3.return();
          case 45:
            if (D3.prev = 45, !C3) {
              D3.next = 48;
              break;
            }
            throw k3;
          case 48:
            return D3.finish(45);
          case 49:
            return D3.finish(42);
          case 50:
            return S3 = [m3.range[0], Fj(m3, t3)], w3 = [Math.max(Dj(y3, t3), S3[1]), y3.range[1]], D3.next = 53, r3.removeRange(S3);
          case 53:
            return D3.next = 55, r3.removeRange(w3);
          case 55:
            if (D3.t1 = (p3.properties.length === 0 || G2(v3)) && G2(b3), !D3.t1) {
              D3.next = 59;
              break;
            }
            return D3.next = 59, r3.remove(b3);
          case 59:
            D3.next = 70;
            break;
          case 61:
            if (!Sj(p3, t3)) {
              D3.next = 68;
              break;
            }
            return D3.next = 64, r3.insertTextBefore(m3, "...(");
          case 64:
            return D3.next = 66, r3.insertTextAfter(y3, ")");
          case 66:
            D3.next = 70;
            break;
          case 68:
            return D3.next = 70, r3.insertTextBefore(m3, "...");
          case 70:
            s3 = true, D3.next = 19;
            break;
          case 73:
            D3.next = 79;
            break;
          case 75:
            D3.prev = 75, D3.t2 = D3.catch(17), o3 = true, u3 = D3.t2;
          case 79:
            D3.prev = 79, D3.prev = 80, s3 || c3.return == null || c3.return();
          case 82:
            if (D3.prev = 82, !o3) {
              D3.next = 85;
              break;
            }
            throw u3;
          case 85:
            return D3.finish(82);
          case 86:
            return D3.finish(79);
          case 87:
          case "end":
            return D3.stop();
        }
    }, n3, null, [[17, 75, 79, 87], [27, 38, 42, 50], [43, , 45, 49], [80, , 82, 86]]);
  });
}
var Aj = { meta: { type: "suggestion", docs: { description: "disallow using Object.assign with an object literal as the first argument and prefer the use of object spread instead.", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/prefer-object-spread" }, schema: [], fixable: "code", messages: { useSpreadMessage: "Use an object spread instead of `Object.assign` eg: `{ ...foo }`.", useLiteralMessage: "Use an object literal instead of `Object.assign`. eg: `{ foo: bar }`." } }, create: function(e28) {
  var t3 = e28.getSourceCode();
  return { Program: function() {
    var n3 = e28.getScope(), r3 = new xj(n3), i = { Object: { assign: Fn$1({}, vj, true) } }, a3 = true, s3 = false, o3 = void 0;
    try {
      for (var u3, c3 = r3.iterateGlobalReferences(i)[Symbol.iterator](); !(a3 = (u3 = c3.next()).done); a3 = true) {
        var f3 = u3.value.node;
        if (1 <= f3.arguments.length && f3.arguments[0].type === "ObjectExpression" && !Ej(f3)) {
          var p3 = f3.arguments.length === 1 ? "useLiteralMessage" : "useSpreadMessage", d3 = wj(f3, t3);
          e28.report({ node: f3, messageId: p3, fix: d3 });
        }
      }
    } catch (m3) {
      s3 = true, o3 = m3;
    } finally {
      try {
        a3 || c3.return == null || c3.return();
      } finally {
        if (s3)
          throw o3;
      }
    }
  } };
} }, _j = { meta: { type: "suggestion", docs: { description: "require using Error objects as Promise rejection reasons", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/prefer-promise-reject-errors" }, fixable: null, schema: [{ type: "object", properties: { allowEmptyReject: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e28) {
  function t3(r3) {
    (r3.arguments.length || !n3) && (r3.arguments.length && P$s.couldBeError(r3.arguments[0]) && (r3.arguments[0].type !== "Identifier" || r3.arguments[0].name !== "undefined") || e28.report({ node: r3, message: "Expected the Promise rejection reason to be an Error." }));
  }
  var n3 = e28.options.length && e28.options[0].allowEmptyReject;
  return { CallExpression: function(r3) {
    (function(i) {
      return i.callee.type === "MemberExpression" && i.callee.object.type === "Identifier" && i.callee.object.name === "Promise" && i.callee.property.type === "Identifier" && i.callee.property.name === "reject";
    })(r3) && t3(r3);
  }, "NewExpression:exit": function(r3) {
    r3.callee.type === "Identifier" && r3.callee.name === "Promise" && r3.arguments.length && P$s.isFunction(r3.arguments[0]) && 1 < r3.arguments[0].params.length && r3.arguments[0].params[1].type === "Identifier" && e28.getDeclaredVariables(r3.arguments[0]).find(function(i) {
      return i.name === r3.arguments[0].params[1].name;
    }).references.filter(function(i) {
      return i.isRead();
    }).filter(function(i) {
      return i.identifier.parent.type === "CallExpression" && i.identifier === i.identifier.parent.callee;
    }).forEach(function(i) {
      return t3(i.identifier.parent);
    });
  } };
} }, Tj = { meta: { type: "suggestion", docs: { description: "require `Reflect` methods where applicable", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-reflect" }, deprecated: true, replacedBy: [], schema: [{ type: "object", properties: { exceptions: { type: "array", items: { enum: ["apply", "call", "delete", "defineProperty", "getOwnPropertyDescriptor", "getPrototypeOf", "setPrototypeOf", "isExtensible", "getOwnPropertyNames", "preventExtensions"] }, uniqueItems: true } }, additionalProperties: false }] }, create: function(e28) {
  function t3(a3, s3, o3) {
    e28.report({ node: a3, message: "Avoid using {{existing}}, instead use {{substitute}}.", data: { existing: s3, substitute: o3 } });
  }
  var n3 = { apply: "Function.prototype.apply", call: "Function.prototype.call", defineProperty: "Object.defineProperty", getOwnPropertyDescriptor: "Object.getOwnPropertyDescriptor", getPrototypeOf: "Object.getPrototypeOf", setPrototypeOf: "Object.setPrototypeOf", isExtensible: "Object.isExtensible", getOwnPropertyNames: "Object.getOwnPropertyNames", preventExtensions: "Object.preventExtensions" }, r3 = { apply: "Reflect.apply", call: "Reflect.apply", defineProperty: "Reflect.defineProperty", getOwnPropertyDescriptor: "Reflect.getOwnPropertyDescriptor", getPrototypeOf: "Reflect.getPrototypeOf", setPrototypeOf: "Reflect.setPrototypeOf", isExtensible: "Reflect.isExtensible", getOwnPropertyNames: "Reflect.getOwnPropertyNames", preventExtensions: "Reflect.preventExtensions" }, i = (e28.options[0] || {}).exceptions || [];
  return { CallExpression: function(a3) {
    var s3 = (a3.callee.property || {}).name, o3 = (a3.callee.object || {}).name === "Reflect", u3 = Object.prototype.hasOwnProperty.call(r3, s3), c3 = i.indexOf(s3) !== -1;
    !u3 || o3 || c3 || t3(a3, n3[s3], r3[s3]);
  }, UnaryExpression: function(a3) {
    var s3 = a3.operator === "delete", o3 = a3.argument.type === "Identifier", u3 = i.indexOf("delete") !== -1;
    !s3 || o3 || u3 || t3(a3, "the delete keyword", "Reflect.deleteProperty");
  } };
} }, Sf = ye$4.require$$0, Pj = Sf.CALL, Ij = Sf.CONSTRUCT, Bj = Sf.ReferenceTracker, Oj = Sf.findVariable;
function z2(e28) {
  return e28.type === "TemplateLiteral" && e28.expressions.length === 0;
}
var Lj = { meta: { type: "suggestion", docs: { description: "disallow use of the `RegExp` constructor in favor of regular expression literals", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/prefer-regex-literals" }, schema: [], messages: { unexpectedRegExp: "Use a regular expression literal instead of the 'RegExp' constructor." } }, create: function(e28) {
  function t3(r3) {
    var i = e28.getScope(), a3 = Oj(i, r3);
    return a3 !== null && a3.scope.type === "global" && a3.defs.length === 0;
  }
  function n3(r3) {
    return function(i) {
      return i.type === "Literal" && typeof i.value == "string";
    }(r3) || z2(r3) || function(i) {
      return i.type === "TaggedTemplateExpression" && i.tag.type === "MemberExpression" && i.tag.object.type === "Identifier" && i.tag.object.name === "String" && t3(i.tag.object) && P$s.getStaticPropertyName(i.tag) === "raw" && z2(i.quasi);
    }(r3);
  }
  return { Program: function() {
    var r3, i = e28.getScope(), a3 = new Bj(i), s3 = { RegExp: (r3 = {}, Fn$1(r3, Pj, true), Fn$1(r3, Ij, true), r3) }, o3 = true, u3 = false, c3 = void 0;
    try {
      for (var f3, p3 = a3.iterateGlobalReferences(s3)[Symbol.iterator](); !(o3 = (f3 = p3.next()).done); o3 = true) {
        var d3 = f3.value.node, m3 = d3.arguments;
        (m3.length === 1 || m3.length === 2) && m3.every(n3) && e28.report({ node: d3, messageId: "unexpectedRegExp" });
      }
    } catch (y3) {
      u3 = true, c3 = y3;
    } finally {
      try {
        o3 || p3.return == null || p3.return();
      } finally {
        if (u3)
          throw c3;
      }
    }
  } };
} };
function Nj(e28) {
  var t3 = e28.identifier, n3 = t3.parent;
  return n3.type !== "MemberExpression" || n3.object !== t3 || n3.computed;
}
var jj = { meta: { type: "suggestion", docs: { description: "require rest parameters instead of `arguments`", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-rest-params" }, schema: [] }, create: function(e28) {
  function t3(r3) {
    e28.report({ node: r3.identifier, loc: r3.identifier.loc, message: "Use the rest parameters instead of 'arguments'." });
  }
  function n3() {
    var r3 = function(i) {
      for (var a3 = i.variables, s3 = 0; s3 < a3.length; ++s3) {
        var o3 = a3[s3];
        if (o3.name === "arguments")
          return o3.identifiers.length === 0 ? o3 : null;
      }
      return null;
    }(e28.getScope());
    r3 && r3.references.filter(Nj).forEach(t3);
  }
  return { "FunctionDeclaration:exit": n3, "FunctionExpression:exit": n3 };
} }, Rj = { meta: { type: "suggestion", docs: { description: "require spread operators instead of `.apply()`", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-spread" }, schema: [], fixable: null }, create: function(e28) {
  var t3 = e28.getSourceCode();
  return { CallExpression: function(n3) {
    if (function(i) {
      return i.callee.type === "MemberExpression" && i.callee.property.type === "Identifier" && i.callee.property.name === "apply" && i.callee.computed === false && i.arguments.length === 2 && i.arguments[1].type !== "ArrayExpression" && i.arguments[1].type !== "SpreadElement";
    }(n3)) {
      var r3 = n3.callee.object;
      (function(i, a3, s3) {
        return i ? P$s.equalTokens(i, a3, s3) : P$s.isNullOrUndefined(a3);
      })(r3.type === "MemberExpression" ? r3.object : null, n3.arguments[0], t3) && e28.report({ node: n3, message: "Use the spread operator instead of '.apply()'." });
    }
  } };
} };
function Ls$1(e28) {
  return e28.type === "BinaryExpression" && e28.operator === "+";
}
function H2(e28) {
  for (var t3 = e28; Ls$1(t3.parent); )
    t3 = t3.parent;
  return t3;
}
function h0(e28) {
  return Ls$1(e28) ? h0(e28.left) || h0(e28.right) : function(t3) {
    return t3.type === "Literal" && typeof t3.value == "string" && P$s.hasOctalEscapeSequence(t3.raw);
  }(e28);
}
function ef(e28) {
  return Ls$1(e28) ? ef(e28.right) || ef(e28.left) : !P$s.isStringLiteral(e28);
}
function d0(e28) {
  return e28.type === "BinaryExpression" ? d0(e28.left) : e28.type === "TemplateLiteral" ? e28.expressions.length && e28.quasis.length && e28.quasis[0].range[0] === e28.quasis[0].range[1] : e28.type !== "Literal" || typeof e28.value != "string";
}
var Mj = { meta: { type: "suggestion", docs: { description: "require template literals instead of string concatenation", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-template" }, schema: [], fixable: "code" }, create: function(e28) {
  function t3(s3, o3) {
    var u3 = [s3].concat(i.getTokensBetween(s3, o3)).concat(o3), c3 = i.getText();
    return u3.slice(0, -1).reduce(function(f3, p3, d3) {
      return f3 + c3.slice(p3.range[1], u3[d3 + 1].range[0]);
    }, "");
  }
  function n3(s3, o3, u3) {
    if (s3.type === "Literal" && typeof s3.value == "string")
      return "`".concat(s3.raw.slice(1, -1).replace(/\\*(\$\{|`)/g, function(y3) {
        return y3.lastIndexOf("\\") % 2 ? "\\".concat(y3) : y3;
      }).replace(new RegExp("\\\\".concat(s3.raw[0]), "gu"), s3.raw[0]), "`");
    if (s3.type === "TemplateLiteral")
      return i.getText(s3);
    if (Ls$1(s3) && function y3(v3) {
      return Ls$1(v3) ? y3(v3.right) || y3(v3.left) : P$s.isStringLiteral(v3);
    }(s3) && ef(s3)) {
      var c3 = i.getFirstTokenBetween(s3.left, s3.right, function(y3) {
        return y3.value === "+";
      }), f3 = t3(s3.left, c3), p3 = t3(c3, s3.right), d3 = function(y3) {
        return y3.type === "BinaryExpression" ? d0(y3.right) : y3.type === "TemplateLiteral" ? y3.expressions.length && y3.quasis.length && y3.quasis[y3.quasis.length - 1].range[0] === y3.quasis[y3.quasis.length - 1].range[1] : y3.type !== "Literal" || typeof y3.value != "string";
      }(s3.left), m3 = d0(s3.right);
      return d3 ? n3(s3.left, o3, f3 + p3).slice(0, -1) + n3(s3.right, null, u3).slice(1) : m3 ? n3(s3.left, o3, null).slice(0, -1) + n3(s3.right, f3 + p3, u3).slice(1) : "".concat(n3(s3.left, o3, null)).concat(f3, "+").concat(p3).concat(n3(s3.right, u3, null));
    }
    return "`${".concat(o3 || "").concat(i.getText(s3)).concat(u3 || "", "}`");
  }
  function r3(s3) {
    if (P$s.isStringLiteral(s3) && Ls$1(s3.parent)) {
      var o3 = H2(s3.parent);
      a3[o3.range[0]] || (a3[o3.range[0]] = true, ef(o3) && e28.report({ node: o3, message: "Unexpected string concatenation.", fix: function(u3) {
        return function(c3, f3) {
          var p3 = H2(f3.parent);
          return h0(p3) ? null : c3.replaceText(p3, n3(p3, null, null));
        }(u3, s3);
      } }));
    }
  }
  var i = e28.getSourceCode(), a3 = /* @__PURE__ */ Object.create(null);
  return { Program: function() {
    a3 = /* @__PURE__ */ Object.create(null);
  }, Literal: r3, TemplateLiteral: r3 };
} }, Vj = { meta: { type: "suggestion", docs: { description: "require quotes around object literal property names", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/quote-props" }, schema: { anyOf: [{ type: "array", items: [{ enum: ["always", "as-needed", "consistent", "consistent-as-needed"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["always", "as-needed", "consistent", "consistent-as-needed"] }, { type: "object", properties: { keywords: { type: "boolean" }, unnecessary: { type: "boolean" }, numbers: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }] }, fixable: "code" }, create: function(e28) {
  function t3(x3) {
    return 0 <= Qp.indexOf(x3);
  }
  function n3(x3, C3, k3) {
    return C3.length === 1 && C3[0].start === 0 && C3[0].end === x3.length && (0 <= ["Identifier", "Keyword", "Null", "Boolean"].indexOf(C3[0].type) || C3[0].type === "Numeric" && !k3 && +C3[0].value + "" === C3[0].value);
  }
  function r3(x3) {
    return x3.type === "Identifier" ? x3.name : x3.value;
  }
  function i(x3) {
    return x3.type === "Literal" && typeof x3.value == "string" ? b3.getText(x3) : '"'.concat(x3.type === "Identifier" ? x3.name : x3.value, '"');
  }
  function a3(x3) {
    var C3 = x3.key;
    if (!(x3.method || x3.computed || x3.shorthand))
      if (C3.type === "Literal" && typeof C3.value == "string") {
        var k3;
        try {
          k3 = ye$4.espree.tokenize(C3.value);
        } catch {
          return;
        }
        if (k3.length !== 1 || t3(k3[0].value) && c3)
          return;
        f3 && n3(C3.value, k3, p3) && e28.report({ node: x3, message: d3, data: { property: C3.value }, fix: function(F3) {
          return F3.replaceText(C3, r3(C3));
        } });
      } else
        c3 && C3.type === "Identifier" && t3(C3.name) ? e28.report({ node: x3, message: v3, data: { property: C3.name }, fix: function(F3) {
          return F3.replaceText(C3, i(C3));
        } }) : p3 && C3.type === "Literal" && typeof C3.value == "number" && e28.report({ node: x3, message: y3, data: { property: C3.value }, fix: function(F3) {
          return F3.replaceText(C3, i(C3));
        } });
  }
  function s3(x3) {
    var C3 = x3.key;
    x3.method || x3.computed || x3.shorthand || C3.type === "Literal" && typeof C3.value == "string" || e28.report({ node: x3, message: m3, data: { property: C3.name || C3.value }, fix: function(k3) {
      return k3.replaceText(C3, i(C3));
    } });
  }
  function o3(x3, C3) {
    var k3 = [], F3 = [], B3 = null, O3 = false;
    x3.properties.forEach(function(S3) {
      var w3 = S3.key;
      if (w3 && !S3.method && !S3.computed && !S3.shorthand) {
        if (w3.type !== "Literal" || typeof w3.value != "string")
          c3 && C3 && w3.type === "Identifier" && t3(w3.name) ? (F3.push(S3), O3 = true, B3 = w3.name) : F3.push(S3);
        else if (k3.push(S3), C3) {
          var D3;
          try {
            D3 = ye$4.espree.tokenize(w3.value);
          } catch {
            return void (O3 = true);
          }
          O3 = O3 || !n3(w3.value, D3) || c3 && t3(D3[0].value);
        }
      }
    }), C3 && k3.length && !O3 ? k3.forEach(function(S3) {
      e28.report({ node: S3, message: "Properties shouldn't be quoted as all quotes are redundant.", fix: function(w3) {
        return w3.replaceText(S3.key, r3(S3.key));
      } });
    }) : F3.length && B3 ? F3.forEach(function(S3) {
      e28.report({ node: S3, message: "Properties should be quoted as '{{property}}' is a reserved word.", data: { property: B3 }, fix: function(w3) {
        return w3.replaceText(S3.key, i(S3.key));
      } });
    }) : k3.length && F3.length && F3.forEach(function(S3) {
      e28.report({ node: S3, message: "Inconsistently quoted property '{{key}}' found.", data: { key: S3.key.name || S3.key.value }, fix: function(w3) {
        return w3.replaceText(S3.key, i(S3.key));
      } });
    });
  }
  var u3 = e28.options[0], c3 = e28.options[1] && e28.options[1].keywords, f3 = !e28.options[1] || e28.options[1].unnecessary !== false, p3 = e28.options[1] && e28.options[1].numbers, d3 = "Unnecessarily quoted property '{{property}}' found.", m3 = "Unquoted property '{{property}}' found.", y3 = "Unquoted number literal '{{property}}' used as key.", v3 = "Unquoted reserved word '{{property}}' used as key.", b3 = e28.getSourceCode();
  return { Property: function(x3) {
    u3 !== "always" && u3 || s3(x3), u3 === "as-needed" && a3(x3);
  }, ObjectExpression: function(x3) {
    u3 === "consistent" && o3(x3, false), u3 === "consistent-as-needed" && o3(x3, true);
  } };
} }, xp = { double: { quote: '"', alternateQuote: "'", description: "doublequote" }, single: { quote: "'", alternateQuote: '"', description: "singlequote" }, backtick: { quote: "`", alternateQuote: '"', description: "backtick" } }, Uj = /(^|(?:[\0-\[\]-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))(\\\\)*[]/;
xp.double.convert = xp.single.convert = xp.backtick.convert = function(e28) {
  var t3 = this.quote, n3 = e28[0];
  return t3 === n3 ? e28 : t3 + e28.slice(1, -1).replace(/\\(\$\{|\r\n?|\n|(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))|["'`]|\$\{|(\r\n?|\n)/g, function(r3, i, a3) {
    return i === n3 || n3 === "`" && i === "${" ? i : r3 === t3 || t3 === "`" && r3 === "${" ? "\\".concat(r3) : a3 && n3 === "`" ? "\\n" : r3;
  }) + t3;
};
var qj = { meta: { type: "layout", docs: { description: "enforce the consistent use of either backticks, double, or single quotes", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/quotes" }, fixable: "code", schema: [{ enum: ["single", "double", "backtick"] }, { anyOf: [{ enum: ["avoid-escape"] }, { type: "object", properties: { avoidEscape: { type: "boolean" }, allowTemplateLiterals: { type: "boolean" } }, additionalProperties: false }] }] }, create: function(e28) {
  function t3(f3) {
    return f3.type === "ExpressionStatement" && f3.expression.type === "Literal" && typeof f3.expression.value == "string";
  }
  function n3(f3) {
    var p3 = f3.parent.parent;
    if (p3.type !== "Program" && (p3.type !== "BlockStatement" || !P$s.isFunction(p3.parent)))
      return false;
    for (var d3 = 0; d3 < p3.body.length; ++d3) {
      var m3 = p3.body[d3];
      if (m3 === f3.parent)
        return true;
      if (!t3(m3))
        break;
    }
    return false;
  }
  function r3(f3) {
    var p3 = f3.parent;
    switch (p3.type) {
      case "ExpressionStatement":
        return n3(f3);
      case "Property":
      case "MethodDefinition":
        return p3.key === f3 && !p3.computed;
      case "ImportDeclaration":
      case "ExportNamedDeclaration":
      case "ExportAllDeclaration":
        return p3.source === f3;
      default:
        return false;
    }
  }
  var i = e28.options[0], a3 = xp[i || "double"], s3 = e28.options[1], o3 = s3 && s3.allowTemplateLiterals === true, u3 = e28.getSourceCode(), c3 = s3 && s3.avoidEscape === true;
  return s3 === "avoid-escape" && (c3 = true), { Literal: function(f3) {
    var p3 = f3.value, d3 = f3.raw;
    if (a3 && typeof p3 == "string") {
      var m3 = i === "backtick" && r3(f3) || function(y3) {
        return y3.parent.type === "JSXAttribute" || y3.parent.type === "JSXElement" || y3.parent.type === "JSXFragment";
      }(f3) || P$s.isSurroundedBy(d3, a3.quote);
      !m3 && c3 && (m3 = P$s.isSurroundedBy(d3, a3.alternateQuote) && 0 <= d3.indexOf(a3.quote)), m3 || e28.report({ node: f3, message: "Strings must use {{description}}.", data: { description: a3.description }, fix: function(y3) {
        return i === "backtick" && P$s.hasOctalEscapeSequence(d3) ? null : y3.replaceText(f3, a3.convert(f3.raw));
      } });
    }
  }, TemplateLiteral: function(f3) {
    o3 || i === "backtick" || function(p3) {
      return p3.parent.type === "TaggedTemplateExpression" && p3 === p3.parent.quasi || 0 < p3.expressions.length || !!(1 <= p3.quasis.length && Uj.test(p3.quasis[0].value.raw));
    }(f3) || e28.report({ node: f3, message: "Strings must use {{description}}.", data: { description: a3.description }, fix: function(p3) {
      return n3(f3) ? null : p3.replaceText(f3, a3.convert(u3.getText(f3)));
    } });
  } };
} }, K2 = "always", Wj = "as-needed";
function J2(e28) {
  return 1 <= e28.defs.length;
}
var $j = { meta: { type: "suggestion", docs: { description: "enforce the consistent use of the radix argument when using `parseInt()`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/radix" }, schema: [{ enum: ["always", "as-needed"] }] }, create: function(e28) {
  function t3(r3) {
    var i = r3.arguments;
    switch (i.length) {
      case 0:
        e28.report({ node: r3, message: "Missing parameters." });
        break;
      case 1:
        n3 === K2 && e28.report({ node: r3, message: "Missing radix parameter." });
        break;
      default:
        n3 === Wj && function(a3) {
          return a3.type === "Literal" && a3.value === 10;
        }(i[1]) ? e28.report({ node: r3, message: "Redundant radix parameter." }) : !function(a3) {
          return !(a3.type === "Literal" && typeof a3.value != "number" || a3.type === "Identifier" && a3.name === "undefined");
        }(i[1]) && e28.report({ node: r3, message: "Invalid radix parameter." });
    }
  }
  var n3 = e28.options[0] || K2;
  return { "Program:exit": function() {
    var r3, i = e28.getScope();
    J2(r3 = P$s.getVariableByName(i, "parseInt")) || r3.references.forEach(function(a3) {
      var s3 = a3.identifier;
      P$s.isCallee(s3) && t3(s3.parent);
    }), J2(r3 = P$s.getVariableByName(i, "Number")) || r3.references.forEach(function(a3) {
      var s3 = a3.identifier.parent;
      (function(o3) {
        return o3.type === "MemberExpression" && !o3.computed && o3.property.type === "Identifier" && o3.property.name === "parseInt";
      })(s3) && P$s.isCallee(s3) && t3(s3.parent);
    });
  } };
} };
function HA(e28) {
  var t3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /* @__PURE__ */ new Map(), n3 = true, r3 = false, i = void 0;
  try {
    for (var a3, s3 = e28.references[Symbol.iterator](); !(n3 = (a3 = s3.next()).done); n3 = true) {
      var o3 = a3.value;
      t3.set(o3.identifier, o3);
    }
  } catch (y3) {
    r3 = true, i = y3;
  } finally {
    try {
      n3 || s3.return == null || s3.return();
    } finally {
      if (r3)
        throw i;
    }
  }
  var u3 = true, c3 = false, f3 = void 0;
  try {
    for (var p3, d3 = e28.childScopes[Symbol.iterator](); !(u3 = (p3 = d3.next()).done); u3 = true) {
      var m3 = p3.value;
      m3.type !== "function" && HA(m3, t3);
    }
  } catch (y3) {
    c3 = true, f3 = y3;
  } finally {
    try {
      u3 || d3.return == null || d3.return();
    } finally {
      if (c3)
        throw f3;
    }
  }
  return t3;
}
var Gj = function() {
  function e28() {
    We$1(this, e28), this.info = /* @__PURE__ */ new WeakMap();
  }
  return Xe$1(e28, [{ key: "initialize", value: function(t3) {
    var n3 = /* @__PURE__ */ new Set(), r3 = /* @__PURE__ */ new Set(), i = true, a3 = false, s3 = void 0;
    try {
      for (var o3, u3 = t3.prevSegments[Symbol.iterator](); !(i = (o3 = u3.next()).done); i = true) {
        var c3 = o3.value, f3 = this.info.get(c3);
        f3 && (f3.outdatedReadVariableNames.forEach(Set.prototype.add, n3), f3.freshReadVariableNames.forEach(Set.prototype.add, r3));
      }
    } catch (p3) {
      a3 = true, s3 = p3;
    } finally {
      try {
        i || u3.return == null || u3.return();
      } finally {
        if (a3)
          throw s3;
      }
    }
    this.info.set(t3, { outdatedReadVariableNames: n3, freshReadVariableNames: r3 });
  } }, { key: "markAsRead", value: function(t3, n3) {
    var r3 = true, i = false, a3 = void 0;
    try {
      for (var s3, o3 = t3[Symbol.iterator](); !(r3 = (s3 = o3.next()).done); r3 = true) {
        var u3 = s3.value, c3 = this.info.get(u3);
        c3 && c3.freshReadVariableNames.add(n3);
      }
    } catch (f3) {
      i = true, a3 = f3;
    } finally {
      try {
        r3 || o3.return == null || o3.return();
      } finally {
        if (i)
          throw a3;
      }
    }
  } }, { key: "makeOutdated", value: function(t3) {
    var n3 = true, r3 = false, i = void 0;
    try {
      for (var a3, s3 = t3[Symbol.iterator](); !(n3 = (a3 = s3.next()).done); n3 = true) {
        var o3 = a3.value, u3 = this.info.get(o3);
        u3 && (u3.freshReadVariableNames.forEach(Set.prototype.add, u3.outdatedReadVariableNames), u3.freshReadVariableNames.clear());
      }
    } catch (c3) {
      r3 = true, i = c3;
    } finally {
      try {
        n3 || s3.return == null || s3.return();
      } finally {
        if (r3)
          throw i;
      }
    }
  } }, { key: "isOutdated", value: function(t3, n3) {
    var r3 = true, i = false, a3 = void 0;
    try {
      for (var s3, o3 = t3[Symbol.iterator](); !(r3 = (s3 = o3.next()).done); r3 = true) {
        var u3 = s3.value, c3 = this.info.get(u3);
        if (c3 && c3.outdatedReadVariableNames.has(n3))
          return true;
      }
    } catch (f3) {
      i = true, a3 = f3;
    } finally {
      try {
        r3 || o3.return == null || o3.return();
      } finally {
        if (i)
          throw a3;
      }
    }
    return false;
  } }]), e28;
}(), zj = { meta: { type: "problem", docs: { description: "disallow assignments that can lead to race conditions due to usage of `await` or `yield`", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/require-atomic-updates" }, fixable: null, schema: [], messages: { nonAtomicUpdate: "Possible race condition: `{{value}}` might be reassigned based on an outdated value of `{{value}}`." } }, create: function(e28) {
  var t3 = e28.getSourceCode(), n3 = /* @__PURE__ */ new Map(), r3 = new Gj(), i = null;
  return { onCodePathStart: function(a3) {
    var s3 = e28.getScope(), o3 = s3.type === "function" && (s3.block.async || s3.block.generator);
    i = { upper: i, codePath: a3, referenceMap: o3 ? HA(s3) : null };
  }, onCodePathEnd: function() {
    i = i.upper;
  }, onCodePathSegmentStart: function(a3) {
    r3.initialize(a3);
  }, Identifier: function(a3) {
    var s3 = i, o3 = s3.codePath, u3 = s3.referenceMap, c3 = u3 && u3.get(a3);
    if (c3) {
      var f3 = c3.identifier.name, p3 = c3.resolved, d3 = function(v3) {
        if (v3.writeExpr)
          return v3.writeExpr;
        for (var b3 = v3.identifier; b3; ) {
          var x3 = b3.parent.type;
          if (x3 === "AssignmentExpression" && b3.parent.left === b3)
            return b3.parent.right;
          if (x3 !== "MemberExpression" || b3.parent.object !== b3)
            break;
          b3 = b3.parent;
        }
        return null;
      }(c3), m3 = c3.identifier.parent.type === "MemberExpression";
      if (c3.isRead() && !(d3 && d3.parent.operator === "=") && r3.markAsRead(o3.currentSegments, f3), d3 && d3.parent.right === d3 && !function(v3, b3) {
        if (!v3 || b3 && v3.defs.some(function(C3) {
          return C3.type === "Parameter";
        }))
          return false;
        var x3 = v3.scope.variableScope;
        return v3.references.every(function(C3) {
          return C3.from.variableScope === x3;
        });
      }(p3, m3)) {
        var y3 = n3.get(d3);
        y3 || (y3 = [], n3.set(d3, y3)), y3.push(c3);
      }
    }
  }, ":expression:exit": function(a3) {
    var s3 = i, o3 = s3.codePath;
    if (s3.referenceMap) {
      (a3.type === "AwaitExpression" || a3.type === "YieldExpression") && r3.makeOutdated(o3.currentSegments);
      var u3 = n3.get(a3);
      if (u3) {
        n3.delete(a3);
        var c3 = true, f3 = false, p3 = void 0;
        try {
          for (var d3, m3 = u3[Symbol.iterator](); !(c3 = (d3 = m3.next()).done); c3 = true) {
            var y3 = d3.value.identifier.name;
            r3.isOutdated(o3.currentSegments, y3) && e28.report({ node: a3.parent, messageId: "nonAtomicUpdate", data: { value: t3.getText(a3.parent.left) } });
          }
        } catch (v3) {
          f3 = true, p3 = v3;
        } finally {
          try {
            c3 || m3.return == null || m3.return();
          } finally {
            if (f3)
              throw p3;
          }
        }
      }
    }
  } };
} };
function Hj(e28) {
  return e28[0].toUpperCase() + e28.slice(1);
}
var Kj = { meta: { type: "suggestion", docs: { description: "disallow async functions which have no `await` expression", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/require-await" }, schema: [] }, create: function(e28) {
  function t3() {
    i = { upper: i, hasAwait: false };
  }
  function n3(a3) {
    !a3.async || i.hasAwait || P$s.isEmptyFunction(a3) || e28.report({ node: a3, loc: P$s.getFunctionHeadLoc(a3, r3), message: "{{name}} has no 'await' expression.", data: { name: Hj(P$s.getFunctionNameWithKind(a3)) } }), i = i.upper;
  }
  var r3 = e28.getSourceCode(), i = null;
  return { FunctionDeclaration: t3, FunctionExpression: t3, ArrowFunctionExpression: t3, "FunctionDeclaration:exit": n3, "FunctionExpression:exit": n3, "ArrowFunctionExpression:exit": n3, AwaitExpression: function() {
    i && (i.hasAwait = true);
  }, ForOfStatement: function(a3) {
    !i || a3.await && (i.hasAwait = true);
  } };
} }, Jj = { meta: { type: "suggestion", docs: { description: "require JSDoc comments", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/require-jsdoc" }, schema: [{ type: "object", properties: { require: { type: "object", properties: { ClassDeclaration: { type: "boolean", default: false }, MethodDefinition: { type: "boolean", default: false }, FunctionDeclaration: { type: "boolean", default: true }, ArrowFunctionExpression: { type: "boolean", default: false }, FunctionExpression: { type: "boolean", default: false } }, additionalProperties: false, default: {} } }, additionalProperties: false }], deprecated: true, replacedBy: [] }, create: function(e28) {
  function t3(a3) {
    e28.report({ node: a3, message: "Missing JSDoc comment." });
  }
  function n3(a3) {
    r3.getJSDocComment(a3) || t3(a3);
  }
  var r3 = e28.getSourceCode(), i = Object.assign({ FunctionDeclaration: true, MethodDefinition: false, ClassDeclaration: false, ArrowFunctionExpression: false, FunctionExpression: false }, e28.options[0] && e28.options[0].require);
  return { FunctionDeclaration: function(a3) {
    i.FunctionDeclaration && n3(a3);
  }, FunctionExpression: function(a3) {
    (i.MethodDefinition && a3.parent.type === "MethodDefinition" || i.FunctionExpression && (a3.parent.type === "VariableDeclarator" || a3.parent.type === "Property" && a3 === a3.parent.value)) && n3(a3);
  }, ClassDeclaration: function(a3) {
    i.ClassDeclaration && n3(a3);
  }, ArrowFunctionExpression: function(a3) {
    i.ArrowFunctionExpression && a3.parent.type === "VariableDeclarator" && n3(a3);
  } };
} }, kf = ye$4.require$$0, Qj = kf.CALL, Xj = kf.CONSTRUCT, Yj = kf.ReferenceTracker, Zj = kf.getStringIfConstant, eR = { meta: { type: "suggestion", docs: { description: "enforce the use of `u` flag on RegExp", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/require-unicode-regexp" }, messages: { requireUFlag: "Use the 'u' flag." }, schema: [] }, create: function(e28) {
  return { "Literal[regex]": function(t3) {
    (t3.regex.flags || "").includes("u") || e28.report({ node: t3, messageId: "requireUFlag" });
  }, Program: function() {
    var t3, n3 = e28.getScope(), r3 = new Yj(n3), i = { RegExp: (t3 = {}, Fn$1(t3, Qj, true), Fn$1(t3, Xj, true), t3) }, a3 = true, s3 = false, o3 = void 0;
    try {
      for (var u3, c3 = r3.iterateGlobalReferences(i)[Symbol.iterator](); !(a3 = (u3 = c3.next()).done); a3 = true) {
        var f3 = u3.value.node, p3 = f3.arguments[1], d3 = Zj(p3, n3);
        p3 && (typeof d3 != "string" || d3.includes("u")) || e28.report({ node: f3, messageId: "requireUFlag" });
      }
    } catch (m3) {
      s3 = true, o3 = m3;
    } finally {
      try {
        a3 || c3.return == null || c3.return();
      } finally {
        if (s3)
          throw o3;
      }
    }
  } };
} }, tR = { meta: { type: "layout", docs: { description: "enforce consistent spacing before and after semicolons", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/semi-spacing" }, fixable: "whitespace", schema: [{ type: "object", properties: { before: { type: "boolean", default: false }, after: { type: "boolean", default: true } }, additionalProperties: false }] }, create: function(e28) {
  function t3(o3, u3) {
    if (P$s.isSemicolonToken(o3)) {
      var c3 = o3.loc.start;
      (function(f3) {
        var p3 = i.getTokenBefore(f3);
        return p3 && P$s.isTokenOnSameLine(p3, f3) && i.isSpaceBetweenTokens(p3, f3);
      })(o3) ? !a3 && e28.report({ node: u3, loc: c3, message: "Unexpected whitespace before semicolon.", fix: function(f3) {
        var p3 = i.getTokenBefore(o3);
        return f3.removeRange([p3.range[1], o3.range[0]]);
      } }) : a3 && e28.report({ node: u3, loc: c3, message: "Missing whitespace before semicolon.", fix: function(f3) {
        return f3.insertTextBefore(o3, " ");
      } }), function(f3) {
        var p3 = i.getTokenBefore(f3);
        return !(p3 && P$s.isTokenOnSameLine(f3, p3));
      }(o3) || function(f3) {
        var p3 = i.getTokenAfter(f3);
        return !(p3 && P$s.isTokenOnSameLine(f3, p3));
      }(o3) || function(f3) {
        var p3 = i.getTokenAfter(f3);
        return p3 && P$s.isClosingBraceToken(p3) || P$s.isClosingParenToken(p3);
      }(o3) || (function(f3) {
        var p3 = i.getTokenAfter(f3);
        return p3 && P$s.isTokenOnSameLine(f3, p3) && i.isSpaceBetweenTokens(f3, p3);
      }(o3) ? !s3 && e28.report({ node: u3, loc: c3, message: "Unexpected whitespace after semicolon.", fix: function(f3) {
        var p3 = i.getTokenAfter(o3);
        return f3.removeRange([o3.range[1], p3.range[0]]);
      } }) : s3 && e28.report({ node: u3, loc: c3, message: "Missing whitespace after semicolon.", fix: function(f3) {
        return f3.insertTextAfter(o3, " ");
      } }));
    }
  }
  function n3(o3) {
    t3(i.getLastToken(o3), o3);
  }
  var r3 = e28.options[0], i = e28.getSourceCode(), a3 = false, s3 = true;
  return xe$3(r3) == "object" && (a3 = r3.before, s3 = r3.after), { VariableDeclaration: n3, ExpressionStatement: n3, BreakStatement: n3, ContinueStatement: n3, DebuggerStatement: n3, ReturnStatement: n3, ThrowStatement: n3, ImportDeclaration: n3, ExportNamedDeclaration: n3, ExportAllDeclaration: n3, ExportDefaultDeclaration: n3, ForStatement: function(o3) {
    o3.init && t3(i.getTokenAfter(o3.init), o3), o3.test && t3(i.getTokenAfter(o3.test), o3);
  } };
} }, nR = ":matches(".concat("BreakStatement,ContinueStatement,DebuggerStatement,DoWhileStatement,ExportAllDeclaration,ExportDefaultDeclaration,ExportNamedDeclaration,ExpressionStatement,ImportDeclaration,ReturnStatement,ThrowStatement,VariableDeclaration", ")"), Ju$1 = { asc: function(e28, t3) {
  return e28 <= t3;
}, ascI: function(e28, t3) {
  return e28.toLowerCase() <= t3.toLowerCase();
}, ascN: function(e28, t3) {
  return 0 >= Yb$1(e28, t3);
}, ascIN: function(e28, t3) {
  return 0 >= Yb$1(e28.toLowerCase(), t3.toLowerCase());
}, desc: function(e28, t3) {
  return Ju$1.asc(t3, e28);
}, descI: function(e28, t3) {
  return Ju$1.ascI(t3, e28);
}, descN: function(e28, t3) {
  return Ju$1.ascN(t3, e28);
}, descIN: function(e28, t3) {
  return Ju$1.ascIN(t3, e28);
} };
function gc$2(e28) {
  return "(?:".concat(ye$4.lodash.escapeRegExp(e28), ")");
}
function Q2(e28) {
  return "".concat(gc$2(e28), "+");
}
function KA(e28) {
  var t3 = "";
  return e28.length === 0 ? t3 += "\\s" : (t3 += "(?:\\s|", e28.length === 1 ? t3 += Q2(e28[0]) : (t3 += "(?:", t3 += e28.map(Q2).join("|"), t3 += ")"), t3 += "(?:$|[".concat(Array.from(P$s.LINEBREAKS).join(""), "]))")), t3;
}
function rR(e28, t3) {
  var n3 = "^";
  return e28.length === 1 ? n3 += gc$2(e28[0]) : (n3 += "(?:", n3 += e28.map(gc$2).join("|"), n3 += ")"), n3 += "?", n3 += KA(t3), new RegExp(n3, "u");
}
function iR(e28) {
  var t3 = "^(".concat(e28.map(gc$2).join("|"), ")?[ 	]+");
  return new RegExp(t3, "u");
}
function X2(e28) {
  for (var t3 = [], n3 = 0; n3 < e28.length; n3++) {
    var r3 = e28[n3];
    if (r3.type !== "ExpressionStatement" || r3.expression.type !== "Literal" || r3.expression.value !== "use strict")
      break;
    t3[n3] = r3;
  }
  return t3;
}
function aR(e28) {
  return e28.type === "Identifier";
}
function fm(e28) {
  return e28.every(aR);
}
var oR = /\$\{$/, sR = /^\}/;
function Lu$1(e28) {
  return !!e28 && e28.type === "Identifier" && e28.name === "NaN";
}
function Y2(e28) {
  return 0 <= ["<", "<="].indexOf(e28);
}
function m0(e28) {
  return e28.type === "UnaryExpression" && e28.operator === "-" && e28.prefix && e28.argument.type === "Literal" && typeof e28.argument.value == "number";
}
function ep(e28, t3) {
  return e28.type === "Literal" ? e28 : m0(e28) ? { type: "Literal", value: -e28.argument.value, raw: "-".concat(e28.argument.value) } : t3 ? { type: "Literal", value: t3, raw: t3 + "" } : null;
}
function rc$2(e28, t3) {
  if (e28.type !== t3.type)
    return false;
  switch (e28.type) {
    case "Identifier":
      return e28.name === t3.name;
    case "Literal":
      return e28.value === t3.value;
    case "MemberExpression":
      var n3 = P$s.getStaticPropertyName(e28);
      return n3 === null ? e28.computed === t3.computed && rc$2(e28.object, t3.object) && rc$2(e28.property, t3.property) : rc$2(e28.object, t3.object) && n3 === P$s.getStaticPropertyName(t3);
    case "ThisExpression":
      return true;
    default:
      return false;
  }
}
var uR = { "accessor-pairs": PI, "array-bracket-newline": II, "array-bracket-spacing": BI, "array-callback-return": VI, "array-element-newline": UI, "arrow-body-style": qI, "arrow-parens": WI, "arrow-spacing": $I, "block-scoped-var": { meta: { type: "suggestion", docs: { description: "enforce the use of variables within the scope they are defined", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/block-scoped-var" }, schema: [], messages: { outOfScope: "'{{name}}' used outside of binding context." } }, create: function(e28) {
  function t3(a3) {
    i.push(a3.range);
  }
  function n3() {
    i.pop();
  }
  function r3(a3) {
    var s3 = a3.identifier;
    e28.report({ node: s3, messageId: "outOfScope", data: { name: s3.name } });
  }
  var i = [];
  return { Program: function(a3) {
    i = [a3.range];
  }, BlockStatement: t3, "BlockStatement:exit": n3, ForStatement: t3, "ForStatement:exit": n3, ForInStatement: t3, "ForInStatement:exit": n3, ForOfStatement: t3, "ForOfStatement:exit": n3, SwitchStatement: t3, "SwitchStatement:exit": n3, CatchClause: t3, "CatchClause:exit": n3, VariableDeclaration: function(a3) {
    function s3(f3) {
      var p3 = f3.identifier.range;
      return p3[0] < o3[0] || p3[1] > o3[1];
    }
    if (a3.kind === "var")
      for (var o3 = i[i.length - 1], u3 = e28.getDeclaredVariables(a3), c3 = 0; c3 < u3.length; ++c3)
        u3[c3].references.filter(s3).forEach(r3);
  } };
} }, "block-spacing": GI, "brace-style": zI, "callback-return": { meta: { type: "suggestion", docs: { description: "require `return` statements after callbacks", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/callback-return" }, schema: [{ type: "array", items: { type: "string" } }], messages: { missingReturn: "Expected return with your callback function." } }, create: function(e28) {
  function t3(s3, o3) {
    return s3.parent ? o3.indexOf(s3.parent.type) === -1 ? t3(s3.parent, o3) : s3.parent : null;
  }
  function n3(s3) {
    return function o3(u3) {
      if (u3.type === "Identifier")
        return true;
      if (u3.type === "MemberExpression") {
        if (u3.object.type === "Identifier")
          return true;
        if (u3.object.type === "MemberExpression")
          return o3(u3.object);
      }
      return false;
    }(s3.callee) && -1 < i.indexOf(a3.getText(s3.callee));
  }
  function r3(s3, o3) {
    return !(!o3 || o3.type !== "ExpressionStatement" || o3.expression !== s3 && (o3.expression.type !== "BinaryExpression" && o3.expression.type !== "LogicalExpression" || o3.expression.right !== s3));
  }
  var i = e28.options[0] || ["callback", "cb", "next"], a3 = e28.getSourceCode();
  return { CallExpression: function(s3) {
    if (n3(s3)) {
      var o3 = t3(s3, ["BlockStatement", "ReturnStatement", "ArrowFunctionExpression"]) || {};
      if (o3.type !== "ReturnStatement" && o3.type !== "ArrowFunctionExpression") {
        if (o3.type === "BlockStatement") {
          var u3 = o3.body[o3.body.length - 1];
          if (r3(s3, u3)) {
            var c3 = o3.parent.type;
            if (c3 === "FunctionExpression" || c3 === "FunctionDeclaration" || c3 === "ArrowFunctionExpression")
              return;
          }
          if (u3.type === "ReturnStatement" && r3(s3, o3.body[o3.body.length - 2]))
            return;
        }
        t3(s3, ["FunctionDeclaration", "FunctionExpression", "ArrowFunctionExpression"]) && e28.report({ node: s3, messageId: "missingReturn" });
      }
    }
  } };
} }, camelcase: HI, "capitalized-comments": YI, "class-methods-use-this": ZI, "comma-dangle": e52, "comma-spacing": t5, "comma-style": n5, complexity: r5, "computed-property-spacing": i5, "consistent-return": o5, "consistent-this": { meta: { type: "suggestion", docs: { description: "enforce consistent naming when capturing the current execution context", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/consistent-this" }, schema: { type: "array", items: { type: "string", minLength: 1 }, uniqueItems: true }, messages: { aliasNotAssignedToThis: "Designated alias '{{name}}' is not assigned to 'this'.", unexpectedAlias: "Unexpected alias '{{name}}' for 'this'." } }, create: function(e28) {
  function t3(s3, o3) {
    e28.report({ node: s3, messageId: "aliasNotAssignedToThis", data: { name: o3 } });
  }
  function n3(s3, o3, u3) {
    var c3 = u3.type === "ThisExpression";
    a3.indexOf(o3) === -1 ? c3 && e28.report({ node: s3, messageId: "unexpectedAlias", data: { name: o3 } }) : (!c3 || s3.operator && s3.operator !== "=") && t3(s3, o3);
  }
  function r3(s3, o3) {
    var u3 = o3.set.get(s3);
    u3 && !u3.defs.some(function(c3) {
      return c3.node.type === "VariableDeclarator" && c3.node.init !== null;
    }) && (u3.references.some(function(c3) {
      var f3 = c3.writeExpr;
      return c3.from === o3 && f3 && f3.type === "ThisExpression" && f3.parent.operator === "=";
    }) || u3.defs.map(function(c3) {
      return c3.node;
    }).forEach(function(c3) {
      t3(c3, s3);
    }));
  }
  function i() {
    var s3 = e28.getScope();
    a3.forEach(function(o3) {
      r3(o3, s3);
    });
  }
  var a3 = [];
  return e28.options.length === 0 ? a3.push("that") : a3 = e28.options, { "Program:exit": i, "FunctionExpression:exit": i, "FunctionDeclaration:exit": i, VariableDeclarator: function(s3) {
    var o3 = s3.id, u3 = o3.type === "ArrayPattern" || o3.type === "ObjectPattern";
    s3.init === null || u3 || n3(s3, o3.name, s3.init);
  }, AssignmentExpression: function(s3) {
    s3.left.type === "Identifier" && n3(s3, s3.left.name, s3.right);
  } };
} }, "constructor-super": u5, curly: c5, "default-case": p5, "default-param-last": { meta: { type: "suggestion", docs: { description: "enforce default parameters to be last", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/default-param-last" }, schema: [], messages: { shouldBeLast: "Default parameters should be last." } }, create: function(e28) {
  function t3(n3) {
    for (var r3 = false, i = n3.params.length - 1; 0 <= i; i -= 1) {
      var a3 = n3.params[i];
      a3.type === "AssignmentPattern" || a3.type === "RestElement" ? r3 && a3.type === "AssignmentPattern" && e28.report({ node: a3, messageId: "shouldBeLast" }) : r3 = true;
    }
  }
  return { FunctionDeclaration: t3, FunctionExpression: t3, ArrowFunctionExpression: t3 };
} }, "dot-location": f5, "dot-notation": m5, "eol-last": g5, eqeqeq: y5, "for-direction": { meta: { type: "problem", docs: { description: 'enforce "for" loop update clause moving the counter in the right direction.', category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/for-direction" }, fixable: null, schema: [], messages: { incorrectDirection: "The update clause in this loop moves the variable in the wrong direction." } }, create: function(e28) {
  function t3(r3) {
    e28.report({ node: r3, messageId: "incorrectDirection" });
  }
  function n3(r3, i) {
    if (r3.right.type === "UnaryExpression") {
      if (r3.right.operator === "-")
        return -i;
    } else if (r3.right.type === "Identifier")
      return 0;
    return i;
  }
  return { ForStatement: function(r3) {
    if (r3.test && r3.test.type === "BinaryExpression" && r3.test.left.type === "Identifier" && r3.update) {
      var i, a3 = r3.test.left.name, s3 = r3.test.operator, o3 = r3.update;
      if (s3 === "<" || s3 === "<=")
        i = -1;
      else {
        if (s3 !== ">" && s3 !== ">=")
          return;
        i = 1;
      }
      o3.type === "UpdateExpression" ? function(u3, c3) {
        if (u3.argument.type === "Identifier" && u3.argument.name === c3) {
          if (u3.operator === "++")
            return 1;
          if (u3.operator === "--")
            return -1;
        }
        return 0;
      }(o3, a3) === i && t3(r3) : o3.type === "AssignmentExpression" && function(u3, c3) {
        if (u3.left.name === c3) {
          if (u3.operator === "+=")
            return n3(u3, 1);
          if (u3.operator === "-=")
            return n3(u3, -1);
        }
        return 0;
      }(o3, a3) === i && t3(r3);
    }
  } };
} }, "func-call-spacing": v5, "func-name-matching": x5, "func-names": b5, "func-style": { meta: { type: "suggestion", docs: { description: "enforce the consistent use of either `function` declarations or expressions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/func-style" }, schema: [{ enum: ["declaration", "expression"] }, { type: "object", properties: { allowArrowFunctions: { type: "boolean", default: false } }, additionalProperties: false }], messages: { expression: "Expected a function expression.", declaration: "Expected a function declaration." } }, create: function(e28) {
  var t3 = e28.options[0], n3 = e28.options[1] && e28.options[1].allowArrowFunctions, r3 = t3 === "declaration", i = [], a3 = { FunctionDeclaration: function(s3) {
    i.push(false), r3 || s3.parent.type === "ExportDefaultDeclaration" || e28.report({ node: s3, messageId: "expression" });
  }, "FunctionDeclaration:exit": function() {
    i.pop();
  }, FunctionExpression: function(s3) {
    i.push(false), r3 && s3.parent.type === "VariableDeclarator" && e28.report({ node: s3.parent, messageId: "declaration" });
  }, "FunctionExpression:exit": function() {
    i.pop();
  }, ThisExpression: function() {
    0 < i.length && (i[i.length - 1] = true);
  } };
  return n3 || (a3.ArrowFunctionExpression = function() {
    i.push(false);
  }, a3["ArrowFunctionExpression:exit"] = function(s3) {
    var o3 = i.pop();
    r3 && !o3 && s3.parent.type === "VariableDeclarator" && e28.report({ node: s3.parent, messageId: "declaration" });
  }), a3;
} }, "function-call-argument-newline": { meta: { type: "layout", docs: { description: "enforce line breaks between arguments of a function call", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/function-call-argument-newline" }, fixable: "whitespace", schema: [{ enum: ["always", "never", "consistent"] }], messages: { unexpectedLineBreak: "There should be no line break here.", missingLineBreak: "There should be a line break after this argument." } }, create: function(e28) {
  function t3(a3, s3) {
    for (var o3 = 1; o3 < a3.arguments.length; o3++) {
      var u3 = r3.getLastToken(a3.arguments[o3 - 1]), c3 = r3.getFirstToken(a3.arguments[o3]);
      if (s3.check(u3, c3)) {
        var f3 = r3.getTokenBefore(c3, { includeComments: true }), p3 = f3.type === "Line";
        e28.report({ node: a3, loc: { start: f3.loc.end, end: c3.loc.start }, messageId: s3.messageId, fix: p3 ? null : s3.createFix(c3, f3) });
      }
    }
  }
  function n3(a3) {
    if (!(2 > a3.arguments.length)) {
      var s3 = e28.options[0] || "always";
      if (s3 === "never")
        t3(a3, i.unexpected);
      else if (s3 === "always")
        t3(a3, i.missing);
      else if (s3 === "consistent") {
        var o3 = r3.getLastToken(a3.arguments[0]), u3 = r3.getFirstToken(a3.arguments[1]);
        o3.loc.end.line === u3.loc.start.line ? t3(a3, i.unexpected) : t3(a3, i.missing);
      }
    }
  }
  var r3 = e28.getSourceCode(), i = { unexpected: { messageId: "unexpectedLineBreak", check: function(a3, s3) {
    return a3.loc.end.line !== s3.loc.start.line;
  }, createFix: function(a3, s3) {
    return function(o3) {
      return o3.replaceTextRange([s3.range[1], a3.range[0]], " ");
    };
  } }, missing: { messageId: "missingLineBreak", check: function(a3, s3) {
    return a3.loc.end.line === s3.loc.start.line;
  }, createFix: function(a3, s3) {
    return function(o3) {
      return o3.replaceTextRange([s3.range[1], a3.range[0]], `
`);
    };
  } } };
  return { CallExpression: n3, NewExpression: n3 };
} }, "function-paren-newline": E5, "generator-star-spacing": C5, "getter-return": F5, "global-require": A5, "grouped-accessor-pairs": T5, "guard-for-in": { meta: { type: "suggestion", docs: { description: "require `for-in` loops to include an `if` statement", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/guard-for-in" }, schema: [], messages: { wrap: "The body of a for-in should be wrapped in an if statement to filter unwanted properties from the prototype." } }, create: function(e28) {
  return { ForInStatement: function(t3) {
    var n3 = t3.body;
    if (!(n3.type === "EmptyStatement" || n3.type === "IfStatement" || n3.type === "BlockStatement" && n3.body.length === 0 || n3.type === "BlockStatement" && n3.body.length === 1 && n3.body[0].type === "IfStatement")) {
      if (n3.type === "BlockStatement" && 1 <= n3.body.length && n3.body[0].type === "IfStatement") {
        var r3 = n3.body[0];
        if (r3.consequent.type === "ContinueStatement" || r3.consequent.type === "BlockStatement" && r3.consequent.body.length === 1 && r3.consequent.body[0].type === "ContinueStatement")
          return;
      }
      e28.report({ node: t3, messageId: "wrap" });
    }
  } };
} }, "handle-callback-err": P5, "id-blacklist": { meta: { type: "suggestion", docs: { description: "disallow specified identifiers", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/id-blacklist" }, schema: { type: "array", items: { type: "string" }, uniqueItems: true }, messages: { blacklisted: "Identifier '{{name}}' is blacklisted." } }, create: function(e28) {
  function t3(a3) {
    return i.indexOf(a3) !== -1;
  }
  function n3(a3, s3) {
    return a3.type !== "CallExpression" && a3.type !== "NewExpression" && t3(s3);
  }
  function r3(a3) {
    e28.report({ node: a3, messageId: "blacklisted", data: { name: a3.name } });
  }
  var i = e28.options;
  return { Identifier: function(a3) {
    var s3 = a3.name, o3 = a3.parent.type === "MemberExpression" ? a3.parent.parent : a3.parent;
    a3.parent.type === "MemberExpression" ? a3.parent.object.type === "Identifier" && a3.parent.object.name === a3.name ? t3(s3) && r3(a3) : o3.type === "AssignmentExpression" && (o3.right.type !== "MemberExpression" || o3.left.type === "MemberExpression" && o3.left.property.name === a3.name) && t3(s3) && r3(a3) : (a3.parent.type, n3(o3, s3) && r3(a3));
  } };
} }, "id-length": { meta: { type: "suggestion", docs: { description: "enforce minimum and maximum identifier lengths", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/id-length" }, schema: [{ type: "object", properties: { min: { type: "integer", default: 2 }, max: { type: "integer" }, exceptions: { type: "array", uniqueItems: true, items: { type: "string" } }, properties: { enum: ["always", "never"] } }, additionalProperties: false }], messages: { tooShort: "Identifier name '{{name}}' is too short (< {{min}}).", tooLong: "Identifier name '{{name}}' is too long (> {{max}})." } }, create: function(e28) {
  var t3 = e28.options[0] || {}, n3 = t3.min === void 0 ? 2 : t3.min, r3 = t3.max === void 0 ? 1 / 0 : t3.max, i = t3.properties !== "never", a3 = (t3.exceptions ? t3.exceptions : []).reduce(function(o3, u3) {
    return o3[u3] = true, o3;
  }, {}), s3 = { MemberExpression: i && function(o3) {
    return !o3.computed && (o3.parent.left === o3 && o3.parent.type === "AssignmentExpression" || o3.parent.type === "Property" && o3.parent.value === o3 && o3.parent.parent.type === "ObjectPattern" && o3.parent.parent.parent.left === o3.parent.parent);
  }, AssignmentPattern: function(o3, u3) {
    return o3.left === u3;
  }, VariableDeclarator: function(o3, u3) {
    return o3.id === u3;
  }, Property: i && function(o3, u3) {
    return o3.key === u3;
  }, ImportDefaultSpecifier: true, RestElement: true, FunctionExpression: true, ArrowFunctionExpression: true, ClassDeclaration: true, FunctionDeclaration: true, MethodDefinition: true, CatchClause: true };
  return { Identifier: function(o3) {
    var u3 = o3.name, c3 = o3.parent, f3 = u3.length < n3, p3 = u3.length > r3;
    if ((f3 || p3) && !a3[u3]) {
      var d3 = s3[c3.type];
      d3 && (d3 === true || d3(c3, o3)) && e28.report({ node: o3, messageId: f3 ? "tooShort" : "tooLong", data: { name: u3, min: n3, max: r3 } });
    }
  } };
} }, "id-match": I5, "implicit-arrow-linebreak": L5, "indent-legacy": N5, indent: U5, "init-declarations": W5, "jsx-quotes": G5, "key-spacing": z5, "keyword-spacing": X5, "line-comment-position": Y5, "linebreak-style": Z5, "lines-around-comment": eB, "lines-around-directive": tB, "lines-between-class-members": nB, "max-classes-per-file": { meta: { type: "suggestion", docs: { description: "enforce a maximum number of classes per file", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/max-classes-per-file" }, schema: [{ type: "integer", minimum: 1 }], messages: { maximumExceeded: "File has too many classes ({{ classCount }}). Maximum allowed is {{ max }}." } }, create: function(e28) {
  var t3 = e28.options[0] || 1, n3 = 0;
  return { Program: function() {
    n3 = 0;
  }, "Program:exit": function(r3) {
    n3 > t3 && e28.report({ node: r3, messageId: "maximumExceeded", data: { classCount: n3, max: t3 } });
  }, "ClassDeclaration, ClassExpression": function() {
    n3++;
  } };
} }, "max-depth": rB, "max-len": iB, "max-lines-per-function": aB, "max-lines": oB, "max-nested-callbacks": sB, "max-params": uB, "max-statements-per-line": cB, "max-statements": lB, "multiline-comment-style": pB, "multiline-ternary": fB, "new-cap": hB, "new-parens": dB, "newline-after-var": mB, "newline-before-return": gB, "newline-per-chained-call": yB, "no-alert": xB, "no-array-constructor": { meta: { type: "suggestion", docs: { description: "disallow `Array` constructors", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-array-constructor" }, schema: [], messages: { preferLiteral: "The array literal notation [] is preferable." } }, create: function(e28) {
  function t3(n3) {
    n3.arguments.length !== 1 && n3.callee.type === "Identifier" && n3.callee.name === "Array" && e28.report({ node: n3, messageId: "preferLiteral" });
  }
  return { CallExpression: t3, NewExpression: t3 };
} }, "no-async-promise-executor": { meta: { type: "problem", docs: { description: "disallow using an async function as a Promise executor", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-async-promise-executor" }, fixable: null, schema: [], messages: { async: "Promise executor functions should not be async." } }, create: function(e28) {
  return { "NewExpression[callee.name='Promise'][arguments.0.async=true]": function(t3) {
    e28.report({ node: e28.getSourceCode().getFirstToken(t3.arguments[0], function(n3) {
      return n3.value === "async";
    }), messageId: "async" });
  } };
} }, "no-await-in-loop": CB, "no-bitwise": SB, "no-buffer-constructor": { meta: { type: "problem", docs: { description: "disallow use of the `Buffer()` constructor", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-buffer-constructor" }, schema: [], messages: { deprecated: "{{expr}} is deprecated. Use Buffer.from(), Buffer.alloc(), or Buffer.allocUnsafe() instead." } }, create: function(e28) {
  return { "CallExpression[callee.name='Buffer'], NewExpression[callee.name='Buffer']": function(t3) {
    e28.report({ node: t3, messageId: "deprecated", data: { expr: t3.type === "CallExpression" ? "Buffer()" : "new Buffer()" } });
  } };
} }, "no-caller": { meta: { type: "suggestion", docs: { description: "disallow the use of `arguments.caller` or `arguments.callee`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-caller" }, schema: [], messages: { unexpected: "Avoid arguments.{{prop}}." } }, create: function(e28) {
  return { MemberExpression: function(t3) {
    var n3 = t3.object.name, r3 = t3.property.name;
    n3 === "arguments" && !t3.computed && r3 && r3.match(/^calle[er]$/) && e28.report({ node: t3, messageId: "unexpected", data: { prop: r3 } });
  } };
} }, "no-case-declarations": { meta: { type: "suggestion", docs: { description: "disallow lexical declarations in case clauses", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-case-declarations" }, schema: [], messages: { unexpected: "Unexpected lexical declaration in case block." } }, create: function(e28) {
  function t3(n3) {
    switch (n3.type) {
      case "FunctionDeclaration":
      case "ClassDeclaration":
        return true;
      case "VariableDeclaration":
        return n3.kind !== "var";
      default:
        return false;
    }
  }
  return { SwitchCase: function(n3) {
    for (var r3 = 0; r3 < n3.consequent.length; r3++) {
      var i = n3.consequent[r3];
      t3(i) && e28.report({ node: i, messageId: "unexpected" });
    }
  } };
} }, "no-catch-shadow": kB, "no-class-assign": DB$1, "no-compare-neg-zero": FB, "no-cond-assign": _B, "no-confusing-arrow": TB, "no-console": PB, "no-const-assign": IB, "no-constant-condition": LB, "no-constructor-return": { meta: { type: "problem", docs: { description: "disallow returning value from constructor", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-constructor-return" }, schema: {}, fixable: null, messages: { unexpected: "Unexpected return statement in constructor." } }, create: function(e28) {
  var t3 = [];
  return { onCodePathStart: function(n3, r3) {
    t3.push(r3);
  }, onCodePathEnd: function() {
    t3.pop();
  }, ReturnStatement: function(n3) {
    var r3 = t3[t3.length - 1];
    !r3.parent || r3.parent.type === "MethodDefinition" && r3.parent.kind === "constructor" && (n3.parent.parent === r3 || n3.argument) && e28.report({ node: n3, messageId: "unexpected" });
  } };
} }, "no-continue": { meta: { type: "suggestion", docs: { description: "disallow `continue` statements", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-continue" }, schema: [], messages: { unexpected: "Unexpected use of continue statement." } }, create: function(e28) {
  return { ContinueStatement: function(t3) {
    e28.report({ node: t3, messageId: "unexpected" });
  } };
} }, "no-control-regex": RB, "no-debugger": { meta: { type: "problem", docs: { description: "disallow the use of `debugger`", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-debugger" }, fixable: null, schema: [], messages: { unexpected: "Unexpected 'debugger' statement." } }, create: function(e28) {
  return { DebuggerStatement: function(t3) {
    e28.report({ node: t3, messageId: "unexpected" });
  } };
} }, "no-delete-var": { meta: { type: "suggestion", docs: { description: "disallow deleting variables", category: "Variables", recommended: true, url: "https://eslint.org/docs/rules/no-delete-var" }, schema: [], messages: { unexpected: "Variables should not be deleted." } }, create: function(e28) {
  return { UnaryExpression: function(t3) {
    t3.operator === "delete" && t3.argument.type === "Identifier" && e28.report({ node: t3, messageId: "unexpected" });
  } };
} }, "no-div-regex": { meta: { type: "suggestion", docs: { description: "disallow division operators explicitly at the beginning of regular expressions", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-div-regex" }, fixable: "code", schema: [], messages: { unexpected: "A regular expression literal can be confused with '/='." } }, create: function(e28) {
  var t3 = e28.getSourceCode();
  return { Literal: function(n3) {
    var r3 = t3.getFirstToken(n3);
    r3.type === "RegularExpression" && r3.value[1] === "=" && e28.report({ node: n3, messageId: "unexpected", fix: function(i) {
      return i.replaceTextRange([r3.range[0] + 1, r3.range[0] + 2], "[=]");
    } });
  } };
} }, "no-dupe-args": { meta: { type: "problem", docs: { description: "disallow duplicate arguments in `function` definitions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-dupe-args" }, schema: [], messages: { unexpected: "Duplicate param '{{name}}'." } }, create: function(e28) {
  function t3(r3) {
    return r3.type === "Parameter";
  }
  function n3(r3) {
    for (var i = e28.getDeclaredVariables(r3), a3 = 0; a3 < i.length; ++a3) {
      var s3 = i[a3];
      2 <= s3.defs.filter(t3).length && e28.report({ node: r3, messageId: "unexpected", data: { name: s3.name } });
    }
  }
  return { FunctionDeclaration: n3, FunctionExpression: n3 };
} }, "no-dupe-class-members": MB, "no-dupe-else-if": UB, "no-dupe-keys": WB, "no-duplicate-case": $B, "no-duplicate-imports": zB, "no-else-return": HB, "no-empty-character-class": JB, "no-empty-function": QB, "no-empty-pattern": { meta: { type: "problem", docs: { description: "disallow empty destructuring patterns", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-empty-pattern" }, schema: [], messages: { unexpected: "Unexpected empty {{type}} pattern." } }, create: function(e28) {
  return { ObjectPattern: function(t3) {
    t3.properties.length === 0 && e28.report({ node: t3, messageId: "unexpected", data: { type: "object" } });
  }, ArrayPattern: function(t3) {
    t3.elements.length === 0 && e28.report({ node: t3, messageId: "unexpected", data: { type: "array" } });
  } };
} }, "no-empty": XB, "no-eq-null": { meta: { type: "suggestion", docs: { description: "disallow `null` comparisons without type-checking operators", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-eq-null" }, schema: [], messages: { unexpected: "Use '===' to compare with null." } }, create: function(e28) {
  return { BinaryExpression: function(t3) {
    var n3 = t3.operator === "==" || t3.operator === "!=";
    (t3.right.type === "Literal" && t3.right.raw === "null" && n3 || t3.left.type === "Literal" && t3.left.raw === "null" && n3) && e28.report({ node: t3, messageId: "unexpected" });
  } };
} }, "no-eval": ZB, "no-ex-assign": eO, "no-extend-native": nO, "no-extra-bind": iO, "no-extra-boolean-cast": aO, "no-extra-label": oO, "no-extra-parens": sO, "no-extra-semi": uO, "no-fallthrough": pO, "no-floating-decimal": fO, "no-func-assign": hO, "no-global-assign": { meta: { type: "suggestion", docs: { description: "disallow assignments to native objects or read-only global variables", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-global-assign" }, schema: [{ type: "object", properties: { exceptions: { type: "array", items: { type: "string" }, uniqueItems: true } }, additionalProperties: false }] }, create: function(e28) {
  function t3(a3, s3, o3) {
    var u3 = a3.identifier;
    a3.init === false && a3.isWrite() && (s3 === 0 || o3[s3 - 1].identifier !== u3) && e28.report({ node: u3, message: "Read-only global '{{name}}' should not be modified.", data: u3 });
  }
  function n3(a3) {
    a3.writeable === false && i.indexOf(a3.name) === -1 && a3.references.forEach(t3);
  }
  var r3 = e28.options[0], i = r3 && r3.exceptions || [];
  return { Program: function() {
    e28.getScope().variables.forEach(n3);
  } };
} }, "no-implicit-coercion": mO, "no-implicit-globals": { meta: { type: "suggestion", docs: { description: "disallow declarations in the global scope", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-implicit-globals" }, schema: [{ type: "object", properties: { lexicalBindings: { type: "boolean", default: false } }, additionalProperties: false }], messages: { globalNonLexicalBinding: "Unexpected {{kind}} declaration in the global scope, wrap in an IIFE for a local variable, assign as global property for a global variable.", globalLexicalBinding: "Unexpected {{kind}} declaration in the global scope, wrap in a block or in an IIFE.", globalVariableLeak: "Global variable leak, declare the variable if it is intended to be local.", assignmentToReadonlyGlobal: "Unexpected assignment to read-only global variable.", redeclarationOfReadonlyGlobal: "Unexpected redeclaration of read-only global variable." } }, create: function(e28) {
  function t3(r3, i, a3) {
    e28.report({ node: r3, messageId: i, data: { kind: a3 } });
  }
  var n3 = e28.options[0] && e28.options[0].lexicalBindings === true;
  return { Program: function() {
    var r3 = e28.getScope();
    r3.variables.forEach(function(i) {
      var a3 = i.writeable === false;
      i.writeable === true || i.defs.forEach(function(s3) {
        var o3 = s3.node;
        (s3.type === "FunctionName" || s3.type === "Variable" && s3.parent.kind === "var") && (a3 ? t3(o3, "redeclarationOfReadonlyGlobal") : t3(o3, "globalNonLexicalBinding", s3.type === "FunctionName" ? "function" : "'".concat(s3.parent.kind, "'"))), n3 && (s3.type === "ClassName" || s3.type === "Variable" && (s3.parent.kind === "let" || s3.parent.kind === "const")) && (a3 ? t3(o3, "redeclarationOfReadonlyGlobal") : t3(o3, "globalLexicalBinding", s3.type === "ClassName" ? "class" : "'".concat(s3.parent.kind, "'")));
      });
    }), r3.implicit.variables.forEach(function(i) {
      var a3, s3 = r3.set.get(i.name);
      if (s3) {
        if (s3.writeable)
          return;
        a3 = "assignmentToReadonlyGlobal";
      } else
        a3 = "globalVariableLeak";
      i.defs.forEach(function(o3) {
        t3(o3.node, a3);
      });
    });
  } };
} }, "no-implied-eval": { meta: { type: "suggestion", docs: { description: "disallow the use of `eval()`-like methods", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-implied-eval" }, schema: [] }, create: function(e28) {
  function t3(o3) {
    return o3 ? o3[o3.length - 1] : null;
  }
  function n3(o3) {
    var u3 = o3.callee.type === "MemberExpression";
    return (o3.callee.type === "Identifier" && a3.test(o3.callee.name) || u3 && function(c3) {
      var f3 = c3.object, p3 = c3.property, d3 = a3.test(p3.name) || a3.test(p3.value);
      return f3.name === "window" && d3;
    }(o3.callee)) && o3.arguments.length;
  }
  function r3(o3) {
    return o3.parent === t3(t3(s3)) && (o3.parent.type !== "CallExpression" || o3 === o3.parent.arguments[0]);
  }
  function i(o3) {
    if (r3(o3)) {
      var u3 = s3.pop();
      e28.report({ node: u3[0], message: "Implied eval. Consider passing a function instead of a string." });
    }
  }
  var a3 = /^(setTimeout|setInterval|execScript)$/, s3 = [];
  return { CallExpression: function(o3) {
    n3(o3) && s3.push([o3]);
  }, "CallExpression:exit": function(o3) {
    o3 === t3(t3(s3)) && s3.pop();
  }, BinaryExpression: function(o3) {
    o3.operator === "+" && r3(o3) && t3(s3).push(o3);
  }, "BinaryExpression:exit": function(o3) {
    o3 === t3(t3(s3)) && t3(s3).pop();
  }, Literal: function(o3) {
    typeof o3.value == "string" && i(o3);
  }, TemplateLiteral: function(o3) {
    i(o3);
  } };
} }, "no-import-assign": xO, "no-inline-comments": bO, "no-inner-declarations": { meta: { type: "problem", docs: { description: "disallow variable or `function` declarations in nested blocks", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-inner-declarations" }, schema: [{ enum: ["functions", "both"] }] }, create: function(e28) {
  function t3(n3) {
    var r3 = function() {
      for (var i = e28.getAncestors(), a3 = i.pop(), s3 = 1; a3 && 0 > ["Program", "FunctionDeclaration", "FunctionExpression", "ArrowFunctionExpression"].indexOf(a3.type); )
        s3 += 1, a3 = i.pop();
      return { type: a3.type, distance: s3 };
    }();
    r3.type === "Program" && r3.distance === 1 || r3.distance === 2 || e28.report({ node: n3, message: "Move {{type}} declaration to {{body}} root.", data: { type: n3.type === "FunctionDeclaration" ? "function" : "variable", body: r3.type === "Program" ? "program" : "function body" } });
  }
  return { FunctionDeclaration: t3, VariableDeclaration: function(n3) {
    e28.options[0] === "both" && n3.kind === "var" && t3(n3);
  } };
} }, "no-invalid-regexp": CO, "no-invalid-this": SO, "no-irregular-whitespace": wO, "no-iterator": { meta: { type: "suggestion", docs: { description: "disallow the use of the `__iterator__` property", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-iterator" }, schema: [] }, create: function(e28) {
  return { MemberExpression: function(t3) {
    (t3.property && t3.property.type === "Identifier" && t3.property.name === "__iterator__" && !t3.computed || t3.property.type === "Literal" && t3.property.value === "__iterator__") && e28.report({ node: t3, message: "Reserved name '__iterator__'." });
  } };
} }, "no-label-var": AO, "no-labels": _O, "no-lone-blocks": { meta: { type: "suggestion", docs: { description: "disallow unnecessary nested blocks", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-lone-blocks" }, schema: [] }, create: function(e28) {
  function t3(s3) {
    var o3 = s3.parent.type === "BlockStatement" ? "Nested block is redundant." : "Block is redundant.";
    e28.report({ node: s3, message: o3 });
  }
  function n3(s3) {
    return s3.parent.type === "BlockStatement" || s3.parent.type === "Program" || s3.parent.type === "SwitchCase" && (s3.parent.consequent[0] !== s3 || s3.parent.consequent.length !== 1);
  }
  function r3() {
    if (a3.length !== 0) {
      var s3 = e28.getAncestors().pop();
      a3[a3.length - 1] === s3 && a3.pop();
    }
  }
  var i, a3 = [];
  return i = { BlockStatement: function(s3) {
    n3(s3) && t3(s3);
  } }, 6 <= e28.parserOptions.ecmaVersion && ((i = { BlockStatement: function(s3) {
    n3(s3) && a3.push(s3);
  }, "BlockStatement:exit": function(s3) {
    0 < a3.length && a3[a3.length - 1] === s3 ? (a3.pop(), t3(s3)) : s3.parent.type === "BlockStatement" && s3.parent.body.length === 1 && t3(s3);
  } }).VariableDeclaration = function(s3) {
    (s3.kind === "let" || s3.kind === "const") && r3();
  }, i.FunctionDeclaration = function() {
    e28.getScope().isStrict && r3();
  }, i.ClassDeclaration = r3), i;
} }, "no-lonely-if": { meta: { type: "suggestion", docs: { description: "disallow `if` statements as the only statement in `else` blocks", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-lonely-if" }, schema: [], fixable: "code" }, create: function(e28) {
  var t3 = e28.getSourceCode();
  return { IfStatement: function(n3) {
    var r3 = e28.getAncestors(), i = r3.pop(), a3 = r3.pop();
    i && i.type === "BlockStatement" && i.body.length === 1 && a3 && a3.type === "IfStatement" && i === a3.alternate && e28.report({ node: n3, message: "Unexpected if as the only statement in an else block.", fix: function(s3) {
      var o3 = t3.getFirstToken(i), u3 = t3.getLastToken(i), c3 = t3.getTokenBefore(o3), f3 = t3.getTokenAfter(u3), p3 = t3.getLastToken(n3.consequent), d3 = t3.getText();
      return d3.slice(o3.range[1], n3.range[0]).trim() || d3.slice(n3.range[1], u3.range[0]).trim() || n3.consequent.type !== "BlockStatement" && p3.value !== ";" && f3 && (n3.consequent.loc.end.line === f3.loc.start.line || /^[\(\+\x2D\/\[`]/.test(f3.value) || p3.value === "++" || p3.value === "--") ? null : s3.replaceTextRange([o3.range[0], u3.range[1]], (c3.range[1] === o3.range[0] ? " " : "") + t3.getText(n3));
    } });
  } };
} }, "no-loop-func": PO, "no-magic-numbers": { meta: { type: "suggestion", docs: { description: "disallow magic numbers", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-magic-numbers" }, schema: [{ type: "object", properties: { detectObjects: { type: "boolean", default: false }, enforceConst: { type: "boolean", default: false }, ignore: { type: "array", items: { type: "number" }, uniqueItems: true }, ignoreArrayIndexes: { type: "boolean", default: false } }, additionalProperties: false }], messages: { useConst: "Number constants declarations must use 'const'.", noMagic: "No magic number: {{raw}}." } }, create: function(e28) {
  function t3(u3) {
    return s3.indexOf(u3) !== -1;
  }
  function n3(u3) {
    return u3.type === "MemberExpression" && o3;
  }
  var r3 = e28.options[0] || {}, i = !!r3.detectObjects, a3 = !!r3.enforceConst, s3 = r3.ignore || [], o3 = !!r3.ignoreArrayIndexes;
  return { Literal: function(u3) {
    var c3, f3, p3, d3, m3 = i ? [] : ["ObjectExpression", "Property", "AssignmentExpression"];
    (function(y3) {
      return typeof y3.value == "number";
    })(u3) && (u3.parent.type === "UnaryExpression" && u3.parent.operator === "-" ? (f3 = (c3 = u3.parent).parent, p3 = -u3.value, d3 = "-".concat(u3.raw)) : (c3 = u3, f3 = u3.parent, p3 = u3.value, d3 = u3.raw), t3(p3) || function(y3, v3) {
      return y3.type === "CallExpression" && v3 === y3.arguments[1] && (y3.callee.name === "parseInt" || y3.callee.type === "MemberExpression" && y3.callee.object.name === "Number" && y3.callee.property.name === "parseInt");
    }(f3, c3) || n3(f3) || function(y3) {
      return y3.type.indexOf("JSX") === 0;
    }(f3) || (f3.type === "VariableDeclarator" ? a3 && f3.parent.kind !== "const" && e28.report({ node: c3, messageId: "useConst" }) : (m3.indexOf(f3.type) === -1 || f3.type === "AssignmentExpression" && f3.left.type === "Identifier") && e28.report({ node: c3, messageId: "noMagic", data: { raw: d3 } })));
  } };
} }, "no-misleading-character-class": WO, "no-mixed-operators": zO, "no-mixed-requires": HO, "no-mixed-spaces-and-tabs": { meta: { type: "layout", docs: { description: "disallow mixed spaces and tabs for indentation", category: "Stylistic Issues", recommended: true, url: "https://eslint.org/docs/rules/no-mixed-spaces-and-tabs" }, schema: [{ enum: ["smart-tabs", true, false] }] }, create: function(e28) {
  function t3(s3, o3, u3) {
    return o3 < s3.start.line || o3 === s3.start.line && u3 < s3.start.column;
  }
  function n3(s3, o3, u3) {
    return o3 > s3.end.line || o3 === s3.end.line && u3 > s3.end.column;
  }
  var r3, i = e28.getSourceCode(), a3 = [];
  switch (e28.options[0]) {
    case true:
    case "smart-tabs":
      r3 = true;
      break;
    default:
      r3 = false;
  }
  return { TemplateElement: function(s3) {
    a3.push(s3.loc);
  }, "Program:exit": function(s3) {
    var o3 = /^(?=[\t ]*(\t | \t))/, u3 = i.lines;
    i.getAllComments().forEach(function(c3) {
      a3.push(c3.loc);
    }), a3.sort(function(c3, f3) {
      return t3(c3, f3.start.line, f3.start.column) ? 1 : t3(f3, c3.start.line, f3.start.column) ? -1 : 0;
    }), r3 && (o3 = /^(?=[\t ]* \t)/), u3.forEach(function(c3, f3) {
      var p3 = o3.exec(c3);
      if (p3) {
        for (var d3 = f3 + 1, m3 = p3.index + 1, y3 = 0; y3 < a3.length; y3++)
          if (!t3(a3[y3], d3, m3) && !n3(a3[y3], d3, m3))
            return;
        e28.report({ node: s3, loc: { line: d3, column: m3 }, message: "Mixed spaces and tabs." });
      }
    });
  } };
} }, "no-multi-assign": { meta: { type: "suggestion", docs: { description: "disallow use of chained assignment expressions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-multi-assign" }, schema: [] }, create: function(e28) {
  return { AssignmentExpression: function(t3) {
    ["AssignmentExpression", "VariableDeclarator"].indexOf(t3.parent.type) !== -1 && e28.report({ node: t3, message: "Unexpected chained assignment." });
  } };
} }, "no-multi-spaces": KO, "no-multi-str": JO, "no-multiple-empty-lines": QO, "no-native-reassign": { meta: { type: "suggestion", docs: { description: "disallow assignments to native objects or read-only global variables", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-native-reassign" }, deprecated: true, replacedBy: ["no-global-assign"], schema: [{ type: "object", properties: { exceptions: { type: "array", items: { type: "string" }, uniqueItems: true } }, additionalProperties: false }] }, create: function(e28) {
  function t3(a3, s3, o3) {
    var u3 = a3.identifier;
    a3.init === false && a3.isWrite() && (s3 === 0 || o3[s3 - 1].identifier !== u3) && e28.report({ node: u3, message: "Read-only global '{{name}}' should not be modified.", data: u3 });
  }
  function n3(a3) {
    a3.writeable === false && i.indexOf(a3.name) === -1 && a3.references.forEach(t3);
  }
  var r3 = e28.options[0], i = r3 && r3.exceptions || [];
  return { Program: function() {
    e28.getScope().variables.forEach(n3);
  } };
} }, "no-negated-condition": { meta: { type: "suggestion", docs: { description: "disallow negated conditions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-negated-condition" }, schema: [] }, create: function(e28) {
  function t3(n3) {
    return function(r3) {
      return r3.type === "UnaryExpression" && r3.operator === "!";
    }(n3.test) || function(r3) {
      return r3.type === "BinaryExpression" && (r3.operator === "!=" || r3.operator === "!==");
    }(n3.test);
  }
  return { IfStatement: function(n3) {
    !function(r3) {
      return r3.alternate && r3.alternate.type !== "IfStatement";
    }(n3) || t3(n3) && e28.report({ node: n3, message: "Unexpected negated condition." });
  }, ConditionalExpression: function(n3) {
    t3(n3) && e28.report({ node: n3, message: "Unexpected negated condition." });
  } };
} }, "no-negated-in-lhs": { meta: { type: "problem", docs: { description: "disallow negating the left operand in `in` expressions", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-negated-in-lhs" }, replacedBy: ["no-unsafe-negation"], deprecated: true, schema: [] }, create: function(e28) {
  return { BinaryExpression: function(t3) {
    t3.operator === "in" && t3.left.type === "UnaryExpression" && t3.left.operator === "!" && e28.report({ node: t3, message: "The 'in' expression's left operand is negated." });
  } };
} }, "no-nested-ternary": { meta: { type: "suggestion", docs: { description: "disallow nested ternary expressions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-nested-ternary" }, schema: [] }, create: function(e28) {
  return { ConditionalExpression: function(t3) {
    (t3.alternate.type === "ConditionalExpression" || t3.consequent.type === "ConditionalExpression") && e28.report({ node: t3, message: "Do not nest ternary expressions." });
  } };
} }, "no-new-func": { meta: { type: "suggestion", docs: { description: "disallow `new` operators with the `Function` object", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-new-func" }, schema: [] }, create: function(e28) {
  function t3(n3) {
    e28.report({ node: n3, message: "The Function constructor is eval." });
  }
  return { "NewExpression[callee.name = 'Function']": t3, "CallExpression[callee.name = 'Function']": t3 };
} }, "no-new-object": { meta: { type: "suggestion", docs: { description: "disallow `Object` constructors", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-new-object" }, schema: [] }, create: function(e28) {
  return { NewExpression: function(t3) {
    t3.callee.name === "Object" && e28.report({ node: t3, message: "The object literal notation {} is preferrable." });
  } };
} }, "no-new-require": { meta: { type: "suggestion", docs: { description: "disallow `new` operators with calls to `require`", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-new-require" }, schema: [] }, create: function(e28) {
  return { NewExpression: function(t3) {
    t3.callee.type === "Identifier" && t3.callee.name === "require" && e28.report({ node: t3, message: "Unexpected use of new with require." });
  } };
} }, "no-new-symbol": { meta: { type: "problem", docs: { description: "disallow `new` operators with the `Symbol` object", category: "ECMAScript 6", recommended: true, url: "https://eslint.org/docs/rules/no-new-symbol" }, schema: [] }, create: function(e28) {
  return { "Program:exit": function() {
    var t3 = e28.getScope().set.get("Symbol");
    t3 && t3.defs.length === 0 && t3.references.forEach(function(n3) {
      var r3 = n3.identifier;
      r3.parent && r3.parent.type === "NewExpression" && e28.report({ node: r3, message: "`Symbol` cannot be called as a constructor." });
    });
  } };
} }, "no-new-wrappers": { meta: { type: "suggestion", docs: { description: "disallow `new` operators with the `String`, `Number`, and `Boolean` objects", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-new-wrappers" }, schema: [] }, create: function(e28) {
  return { NewExpression: function(t3) {
    -1 < ["String", "Number", "Boolean", "Math", "JSON"].indexOf(t3.callee.name) && e28.report({ node: t3, message: "Do not use {{fn}} as a constructor.", data: { fn: t3.callee.name } });
  } };
} }, "no-new": { meta: { type: "suggestion", docs: { description: "disallow `new` operators outside of assignments or comparisons", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-new" }, schema: [] }, create: function(e28) {
  return { "ExpressionStatement > NewExpression": function(t3) {
    e28.report({ node: t3.parent, message: "Do not use 'new' for side effects." });
  } };
} }, "no-obj-calls": eL, "no-octal-escape": { meta: { type: "suggestion", docs: { description: "disallow octal escape sequences in string literals", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-octal-escape" }, schema: [], messages: { octalEscapeSequence: "Don't use octal: '\\{{sequence}}'. Use '\\u....' instead." } }, create: function(e28) {
  return { Literal: function(t3) {
    if (typeof t3.value == "string") {
      var n3 = t3.raw.match(/^(?:(?:[\0-\[\]-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\(?:[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))*?\\([0-3][0-7]{1,2}|[4-7][0-7]|0(?=[89])|[1-7])/);
      n3 && e28.report({ node: t3, messageId: "octalEscapeSequence", data: { sequence: n3[1] } });
    }
  } };
} }, "no-octal": { meta: { type: "suggestion", docs: { description: "disallow octal literals", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-octal" }, schema: [] }, create: function(e28) {
  return { Literal: function(t3) {
    typeof t3.value == "number" && /^0[0-9]/.test(t3.raw) && e28.report({ node: t3, message: "Octal literals should not be used." });
  } };
} }, "no-param-reassign": nL, "no-path-concat": { meta: { type: "suggestion", docs: { description: "disallow string concatenation with `__dirname` and `__filename`", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-path-concat" }, schema: [] }, create: function(e28) {
  var t3 = /^__(?:dir|file)name$/;
  return { BinaryExpression: function(n3) {
    var r3 = n3.left, i = n3.right;
    n3.operator === "+" && (r3.type === "Identifier" && t3.test(r3.name) || i.type === "Identifier" && t3.test(i.name)) && e28.report({ node: n3, message: "Use path.join() or path.resolve() instead of + to create paths." });
  } };
} }, "no-plusplus": rL, "no-process-env": { meta: { type: "suggestion", docs: { description: "disallow the use of `process.env`", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-process-env" }, schema: [] }, create: function(e28) {
  return { MemberExpression: function(t3) {
    var n3 = t3.object.name, r3 = t3.property.name;
    n3 === "process" && !t3.computed && r3 && r3 === "env" && e28.report({ node: t3, message: "Unexpected use of process.env." });
  } };
} }, "no-process-exit": { meta: { type: "suggestion", docs: { description: "disallow the use of `process.exit()`", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-process-exit" }, schema: [] }, create: function(e28) {
  return { "CallExpression > MemberExpression.callee[object.name = 'process'][property.name = 'exit']": function(t3) {
    e28.report({ node: t3.parent, message: "Don't use process.exit(); throw an error instead." });
  } };
} }, "no-proto": { meta: { type: "suggestion", docs: { description: "disallow the use of the `__proto__` property", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-proto" }, schema: [] }, create: function(e28) {
  return { MemberExpression: function(t3) {
    (t3.property && t3.property.type === "Identifier" && t3.property.name === "__proto__" && !t3.computed || t3.property.type === "Literal" && t3.property.value === "__proto__") && e28.report({ node: t3, message: "The '__proto__' property is deprecated." });
  } };
} }, "no-prototype-builtins": { meta: { type: "problem", docs: { description: "disallow calling some `Object.prototype` methods directly on objects", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-prototype-builtins" }, schema: [] }, create: function(e28) {
  var t3 = ["hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable"];
  return { CallExpression: function(n3) {
    if (n3.callee.type === "MemberExpression" && !n3.callee.computed) {
      var r3 = n3.callee.property.name;
      -1 < t3.indexOf(r3) && e28.report({ message: "Do not access Object.prototype method '{{prop}}' from target object.", loc: n3.callee.property.loc.start, data: { prop: r3 }, node: n3 });
    }
  } };
} }, "no-redeclare": iL, "no-regex-spaces": sL, "no-restricted-globals": lL, "no-restricted-imports": pL, "no-restricted-modules": dL, "no-restricted-properties": mL, "no-restricted-syntax": gL, "no-return-assign": vL, "no-return-await": bL, "no-script-url": { meta: { type: "suggestion", docs: { description: "disallow `javascript:` urls", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-script-url" }, schema: [] }, create: function(e28) {
  return { Literal: function(t3) {
    t3.value && typeof t3.value == "string" && t3.value.toLowerCase().indexOf("javascript:") === 0 && e28.report({ node: t3, message: "Script URL is a form of eval." });
  } };
} }, "no-self-assign": CL, "no-self-compare": SL, "no-sequences": kL, "no-setter-return": wL, "no-shadow-restricted-names": _L, "no-shadow": TL, "no-spaced-func": { meta: { type: "layout", docs: { description: "disallow spacing between function identifiers and their applications (deprecated)", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-spaced-func" }, deprecated: true, replacedBy: ["func-call-spacing"], fixable: "whitespace", schema: [] }, create: function(e28) {
  function t3(r3) {
    for (var i = n3.getLastToken(r3.callee), a3 = i, s3 = n3.getTokenAfter(i); s3 && s3.range[1] < r3.range[1] && s3.value !== "("; )
      a3 = s3, s3 = n3.getTokenAfter(s3);
    s3 && s3.range[1] < r3.range[1] && n3.isSpaceBetweenTokens(a3, s3) && e28.report({ node: r3, loc: i.loc.start, message: "Unexpected space between function name and paren.", fix: function(o3) {
      return o3.removeRange([a3.range[1], s3.range[0]]);
    } });
  }
  var n3 = e28.getSourceCode();
  return { CallExpression: t3, NewExpression: t3 };
} }, "no-sparse-arrays": { meta: { type: "problem", docs: { description: "disallow sparse arrays", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-sparse-arrays" }, schema: [] }, create: function(e28) {
  return { ArrayExpression: function(t3) {
    -1 < t3.elements.indexOf(null) && e28.report({ node: t3, message: "Unexpected comma in middle of array." });
  } };
} }, "no-sync": PL, "no-tabs": OL, "no-template-curly-in-string": { meta: { type: "problem", docs: { description: "disallow template literal placeholder syntax in regular strings", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-template-curly-in-string" }, schema: [] }, create: function(e28) {
  var t3 = /\$\{(?:[\0-\|~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+\}/;
  return { Literal: function(n3) {
    typeof n3.value == "string" && t3.test(n3.value) && e28.report({ node: n3, message: "Unexpected template string expression." });
  } };
} }, "no-ternary": { meta: { type: "suggestion", docs: { description: "disallow ternary operators", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-ternary" }, schema: [] }, create: function(e28) {
  return { ConditionalExpression: function(t3) {
    e28.report({ node: t3, message: "Ternary operator used." });
  } };
} }, "no-this-before-super": LL, "no-throw-literal": NL, "no-trailing-spaces": jL, "no-undef-init": RL, "no-undef": ML, "no-undefined": VL, "no-underscore-dangle": { meta: { type: "suggestion", docs: { description: "disallow dangling underscores in identifiers", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-underscore-dangle" }, schema: [{ type: "object", properties: { allow: { type: "array", items: { type: "string" } }, allowAfterThis: { type: "boolean", default: false }, allowAfterSuper: { type: "boolean", default: false }, allowAfterThisConstructor: { type: "boolean", default: false }, enforceInMethodNames: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e28) {
  function t3(f3) {
    return a3.some(function(p3) {
      return p3 === f3;
    });
  }
  function n3(f3) {
    var p3 = f3.length;
    return f3 !== "_" && (f3[0] === "_" || f3[p3 - 1] === "_");
  }
  function r3(f3) {
    var p3 = f3.key.name, d3 = f3.type === "MethodDefinition" || f3.type === "Property" && f3.method;
    p3 !== void 0 && c3 && d3 && n3(p3) && e28.report({ node: f3, message: "Unexpected dangling '_' in '{{identifier}}'.", data: { identifier: p3 } });
  }
  var i = e28.options[0] || {}, a3 = i.allow ? i.allow : [], s3 = i.allowAfterThis !== void 0 && i.allowAfterThis, o3 = i.allowAfterSuper !== void 0 && i.allowAfterSuper, u3 = i.allowAfterThisConstructor !== void 0 && i.allowAfterThisConstructor, c3 = i.enforceInMethodNames !== void 0 && i.enforceInMethodNames;
  return { FunctionDeclaration: function(f3) {
    if (f3.id) {
      var p3 = f3.id.name;
      p3 !== void 0 && n3(p3) && !t3(p3) && e28.report({ node: f3, message: "Unexpected dangling '_' in '{{identifier}}'.", data: { identifier: p3 } });
    }
  }, VariableDeclarator: function(f3) {
    var p3 = f3.id.name;
    p3 === void 0 || !n3(p3) || function(d3) {
      return d3 === "_";
    }(p3) || t3(p3) || e28.report({ node: f3, message: "Unexpected dangling '_' in '{{identifier}}'.", data: { identifier: p3 } });
  }, MemberExpression: function(f3) {
    var p3 = f3.property.name, d3 = f3.object.type === "ThisExpression", m3 = f3.object.type === "Super", y3 = function(v3) {
      return v3.object.type === "MemberExpression" && v3.object.property.name === "constructor" && v3.object.object.type === "ThisExpression";
    }(f3);
    p3 === void 0 || !n3(p3) || d3 && s3 || m3 && o3 || y3 && u3 || function(v3) {
      return v3 === "__proto__";
    }(p3) || t3(p3) || e28.report({ node: f3, message: "Unexpected dangling '_' in '{{identifier}}'.", data: { identifier: p3 } });
  }, MethodDefinition: r3, Property: r3 };
} }, "no-unexpected-multiline": UL, "no-unmodified-loop-condition": YL, "no-unneeded-ternary": tN, "no-unreachable": aN, "no-unsafe-finally": cN, "no-unsafe-negation": lN, "no-unused-expressions": { meta: { type: "suggestion", docs: { description: "disallow unused expressions", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-unused-expressions" }, schema: [{ type: "object", properties: { allowShortCircuit: { type: "boolean", default: false }, allowTernary: { type: "boolean", default: false }, allowTaggedTemplates: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e28) {
  function t3(o3) {
    return o3.type === "ExpressionStatement" && o3.expression.type === "Literal" && typeof o3.expression.value == "string";
  }
  function n3(o3) {
    return function(u3, c3) {
      for (var f3 = 0; f3 < c3.length; ++f3)
        if (!u3(c3[f3]))
          return c3.slice(0, f3);
      return c3.slice();
    }(t3, o3.body);
  }
  var r3 = e28.options[0] || {}, i = r3.allowShortCircuit || false, a3 = r3.allowTernary || false, s3 = r3.allowTaggedTemplates || false;
  return { ExpressionStatement: function(o3) {
    (function u3(c3) {
      return a3 && c3.type === "ConditionalExpression" ? u3(c3.consequent) && u3(c3.alternate) : i && c3.type === "LogicalExpression" ? u3(c3.right) : !(!s3 || c3.type !== "TaggedTemplateExpression") || /^(?:Assignment|Call|New|Update|Yield|Await)Expression$/.test(c3.type) || c3.type === "UnaryExpression" && 0 <= ["delete", "void"].indexOf(c3.operator);
    })(o3.expression) || function(u3, c3) {
      var f3 = c3[c3.length - 1], p3 = c3[c3.length - 2];
      return (f3.type === "Program" || f3.type === "BlockStatement" && /Function/.test(p3.type)) && 0 <= n3(f3).indexOf(u3);
    }(o3, e28.getAncestors()) || e28.report({ node: o3, message: "Expected an assignment or function call and instead saw an expression." });
  } };
} }, "no-unused-labels": { meta: { type: "suggestion", docs: { description: "disallow unused labels", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-unused-labels" }, schema: [], fixable: "code", messages: { unused: "'{{name}}:' is defined but never used." } }, create: function(e28) {
  function t3(i) {
    if (i.label)
      for (var a3 = i.label.name, s3 = r3; s3; ) {
        if (s3.label === a3) {
          s3.used = true;
          break;
        }
        s3 = s3.upper;
      }
  }
  var n3 = e28.getSourceCode(), r3 = null;
  return { LabeledStatement: function(i) {
    r3 = { label: i.label.name, used: false, upper: r3 };
  }, "LabeledStatement:exit": function(i) {
    r3.used || e28.report({ node: i.label, messageId: "unused", data: i.label, fix: function(a3) {
      return n3.getTokenAfter(i.label, { includeComments: true }) === n3.getTokenBefore(i.body, { includeComments: true }) ? a3.removeRange([i.range[0], i.body.range[0]]) : null;
    } }), r3 = r3.upper;
  }, BreakStatement: t3, ContinueStatement: t3 };
} }, "no-unused-vars": pN, "no-use-before-define": dN, "no-useless-call": mN, "no-useless-catch": { meta: { type: "suggestion", docs: { description: "disallow unnecessary `catch` clauses", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-useless-catch" }, schema: [] }, create: function(e28) {
  return { CatchClause: function(t3) {
    t3.param && t3.param.type === "Identifier" && t3.body.body.length && t3.body.body[0].type === "ThrowStatement" && t3.body.body[0].argument.type === "Identifier" && t3.body.body[0].argument.name === t3.param.name && (t3.parent.finalizer ? e28.report({ node: t3, message: "Unnecessary catch clause." }) : e28.report({ node: t3.parent, message: "Unnecessary try/catch wrapper." }));
  } };
} }, "no-useless-computed-key": yN, "no-useless-concat": xN, "no-useless-constructor": SN, "no-useless-escape": FN, "no-useless-rename": wN, "no-useless-return": _N, "no-var": LN, "no-void": { meta: { type: "suggestion", docs: { description: "disallow `void` operators", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-void" }, schema: [] }, create: function(e28) {
  return { UnaryExpression: function(t3) {
    t3.operator === "void" && e28.report({ node: t3, message: "Expected 'undefined' and instead saw 'void'." });
  } };
} }, "no-warning-comments": jN, "no-whitespace-before-property": RN, "no-with": { meta: { type: "suggestion", docs: { description: "disallow `with` statements", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-with" }, schema: [] }, create: function(e28) {
  return { WithStatement: function(t3) {
    e28.report({ node: t3, message: "Unexpected use of 'with' statement." });
  } };
} }, "nonblock-statement-body-position": MN, "object-curly-newline": VN, "object-curly-spacing": UN, "object-property-newline": { meta: { type: "layout", docs: { description: "enforce placing object properties on separate lines", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/object-property-newline" }, schema: [{ type: "object", properties: { allowAllPropertiesOnSameLine: { type: "boolean", default: false }, allowMultiplePropertiesPerLine: { type: "boolean", default: false } }, additionalProperties: false }], fixable: "whitespace" }, create: function(e28) {
  var t3 = e28.options[0] && (e28.options[0].allowAllPropertiesOnSameLine || e28.options[0].allowMultiplePropertiesPerLine), n3 = t3 ? "Object properties must go on a new line if they aren't all on the same line." : "Object properties must go on a new line.", r3 = e28.getSourceCode();
  return { ObjectExpression: function(i) {
    if (t3 && 1 < i.properties.length) {
      var a3 = r3.getFirstToken(i.properties[0]), s3 = r3.getLastToken(i.properties[i.properties.length - 1]);
      if (a3.loc.end.line === s3.loc.start.line)
        return;
    }
    for (var o3 = function(c3) {
      var f3 = r3.getLastToken(i.properties[c3 - 1]), p3 = r3.getFirstToken(i.properties[c3]);
      f3.loc.end.line === p3.loc.start.line && e28.report({ node: i, loc: p3.loc.start, message: n3, fix: function(d3) {
        var m3 = [r3.getTokenBefore(p3).range[1], p3.range[0]];
        return r3.text.slice(m3[0], m3[1]).trim() ? null : d3.replaceTextRange(m3, `
`);
      } });
    }, u3 = 1; u3 < i.properties.length; u3++)
      o3(u3);
  } };
} }, "object-shorthand": HN, "one-var-declaration-per-line": { meta: { type: "suggestion", docs: { description: "require or disallow newlines around variable declarations", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/one-var-declaration-per-line" }, schema: [{ enum: ["always", "initializations"] }], fixable: "whitespace" }, create: function(e28) {
  var t3 = e28.options[0] === "always";
  return { VariableDeclaration: function(n3) {
    var r3;
    (function(i) {
      return i === "ForStatement" || i === "ForInStatement" || i === "ForOfStatement";
    })(n3.parent.type) || n3.declarations.forEach(function(i) {
      r3 && r3.loc.end.line === i.loc.start.line && (t3 || r3.init || i.init) && e28.report({ node: n3, message: "Expected variable declaration to be on a new line.", loc: i.loc.start, fix: function(a3) {
        return a3.insertTextBefore(i, `
`);
      } }), r3 = i;
    });
  } };
} }, "one-var": KN, "operator-assignment": JN, "operator-linebreak": QN, "padded-blocks": XN, "padding-line-between-statements": nj, "prefer-arrow-callback": rj, "prefer-const": sj, "prefer-destructuring": uj, "prefer-exponentiation-operator": pj, "prefer-named-capture-group": gj, "prefer-numeric-literals": yj, "prefer-object-spread": Aj, "prefer-promise-reject-errors": _j, "prefer-reflect": Tj, "prefer-regex-literals": Lj, "prefer-rest-params": jj, "prefer-spread": Rj, "prefer-template": Mj, "quote-props": Vj, quotes: qj, radix: $j, "require-atomic-updates": zj, "require-await": Kj, "require-jsdoc": Jj, "require-unicode-regexp": eR, "require-yield": { meta: { type: "suggestion", docs: { description: "require generator functions to contain `yield`", category: "ECMAScript 6", recommended: true, url: "https://eslint.org/docs/rules/require-yield" }, schema: [] }, create: function(e28) {
  function t3(i) {
    i.generator && r3.push(0);
  }
  function n3(i) {
    i.generator && r3.pop() === 0 && 0 < i.body.body.length && e28.report({ node: i, message: "This generator function does not have 'yield'." });
  }
  var r3 = [];
  return { FunctionDeclaration: t3, "FunctionDeclaration:exit": n3, FunctionExpression: t3, "FunctionExpression:exit": n3, YieldExpression: function() {
    0 < r3.length && (r3[r3.length - 1] += 1);
  } };
} }, "rest-spread-spacing": { meta: { type: "layout", docs: { description: "enforce spacing between rest and spread operators and their expressions", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/rest-spread-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }] }, create: function(e28) {
  function t3(i) {
    var a3, s3 = n3.getFirstToken(i), o3 = n3.getTokenAfter(s3), u3 = n3.isSpaceBetweenTokens(s3, o3);
    switch (i.type) {
      case "SpreadElement":
        a3 = "spread", i.parent.type === "ObjectExpression" && (a3 += " property");
        break;
      case "RestElement":
        a3 = "rest", i.parent.type === "ObjectPattern" && (a3 += " property");
        break;
      case "ExperimentalSpreadProperty":
        a3 = "spread property";
        break;
      case "ExperimentalRestProperty":
        a3 = "rest property";
        break;
      default:
        return;
    }
    r3 && !u3 ? e28.report({ node: i, loc: { line: s3.loc.end.line, column: s3.loc.end.column }, message: "Expected whitespace after {{type}} operator.", data: { type: a3 }, fix: function(c3) {
      return c3.replaceTextRange([s3.range[1], o3.range[0]], " ");
    } }) : !r3 && u3 && e28.report({ node: i, loc: { line: s3.loc.end.line, column: s3.loc.end.column }, message: "Unexpected whitespace after {{type}} operator.", data: { type: a3 }, fix: function(c3) {
      return c3.removeRange([s3.range[1], o3.range[0]]);
    } });
  }
  var n3 = e28.getSourceCode(), r3 = e28.options[0] === "always";
  return { SpreadElement: t3, RestElement: t3, ExperimentalSpreadProperty: t3, ExperimentalRestProperty: t3 };
} }, "semi-spacing": tR, "semi-style": { meta: { type: "layout", docs: { description: "enforce location of semicolons", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/semi-style" }, schema: [{ enum: ["last", "first"] }], fixable: "whitespace" }, create: function(e28) {
  var t3;
  function n3(a3, s3) {
    var o3 = r3.getTokenBefore(a3), u3 = r3.getTokenAfter(a3), c3 = !o3 || P$s.isTokenOnSameLine(o3, a3), f3 = !u3 || P$s.isTokenOnSameLine(a3, u3);
    (s3 !== "last" || c3) && (s3 !== "first" || f3) || e28.report({ loc: a3.loc, message: "Expected this semicolon to be at {{pos}}.", data: { pos: s3 === "last" ? "the end of the previous line" : "the beginning of the next line" }, fix: function(p3) {
      if (o3 && u3 && r3.commentsExistBetween(o3, u3))
        return null;
      var d3 = o3 ? o3.range[1] : a3.range[0], m3 = u3 ? u3.range[0] : a3.range[1], y3 = s3 === "last" ? `;
` : `
;`;
      return p3.replaceTextRange([d3, m3], y3);
    } });
  }
  var r3 = e28.getSourceCode(), i = e28.options[0] || "last";
  return Fn$1(t3 = {}, nR, function(a3) {
    if (i !== "first" || !function(o3) {
      var u3 = o3.parent.type;
      if (u3 === "IfStatement" && o3.parent.consequent === o3 && o3.parent.alternate || u3 === "DoWhileStatement")
        return true;
      var c3 = function(f3) {
        var p3 = f3.type;
        return p3 === "BlockStatement" || p3 === "Program" ? f3.body : p3 === "SwitchCase" ? f3.consequent : null;
      }(o3.parent);
      return c3 !== null && c3[c3.length - 1] === o3;
    }(a3)) {
      var s3 = r3.getLastToken(a3);
      P$s.isSemicolonToken(s3) && n3(s3, i);
    }
  }), Fn$1(t3, "ForStatement", function(a3) {
    var s3 = a3.init && r3.getTokenAfter(a3.init, P$s.isSemicolonToken), o3 = a3.test && r3.getTokenAfter(a3.test, P$s.isSemicolonToken);
    s3 && n3(s3, "last"), o3 && n3(o3, "last");
  }), t3;
} }, semi: { meta: { type: "layout", docs: { description: "require or disallow semicolons instead of ASI", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/semi" }, fixable: "code", schema: { anyOf: [{ type: "array", items: [{ enum: ["never"] }, { type: "object", properties: { beforeStatementContinuationChars: { enum: ["always", "any", "never"] } }, additionalProperties: false }], minItems: 0, maxItems: 2 }, { type: "array", items: [{ enum: ["always"] }, { type: "object", properties: { omitLastInOneLineBlock: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }] } }, create: function(e28) {
  function t3(d3, m3) {
    var y3, v3, b3, x3 = p3.getLastToken(d3);
    m3 ? (y3 = "Extra semicolon.", b3 = x3.loc, v3 = function(C3) {
      return new bf(C3, p3).retainSurroundingTokens(x3).remove(x3);
    }) : (y3 = "Missing semicolon.", b3 = { start: x3.loc.end, end: P$s.getNextLocation(p3, x3.loc.end) }, v3 = function(C3) {
      return C3.insertTextAfter(x3, ";");
    }), e28.report({ node: d3, loc: b3, message: y3, fix: v3 });
  }
  function n3(d3) {
    var m3 = d3.type;
    return m3 !== "DoWhileStatement" && m3 !== "BreakStatement" && m3 !== "ContinueStatement" && m3 !== "DebuggerStatement" && m3 !== "ImportDeclaration" && m3 !== "ExportAllDeclaration" && (m3 === "ReturnStatement" ? !!d3.argument : m3 === "ExportNamedDeclaration" ? !!d3.declaration : !function(y3) {
      if (!P$s.isClosingBraceToken(y3))
        return false;
      var v3 = p3.getNodeByRangeIndex(y3.range[0]);
      return v3.type === "BlockStatement" && v3.parent.type === "ArrowFunctionExpression";
    }(p3.getLastToken(d3, 1)));
  }
  function r3(d3) {
    return !!d3 && s3.test(d3.value) && d3.value !== "++" && d3.value !== "--";
  }
  function i(d3) {
    return !(!function(m3) {
      var y3 = p3.getTokenAfter(m3);
      return !y3 || P$s.isClosingBraceToken(y3) || P$s.isSemicolonToken(y3);
    }(p3.getLastToken(d3)) && (function(m3) {
      var y3 = p3.getLastToken(m3, 1), v3 = p3.getTokenAfter(m3);
      return !!v3 && P$s.isTokenOnSameLine(y3, v3);
    }(d3) || (f3 !== "never" || n3(d3)) && r3(p3.getTokenAfter(d3))));
  }
  function a3(d3) {
    var m3 = P$s.isSemicolonToken(p3.getLastToken(d3));
    if (u3)
      m3 && i(d3) ? t3(d3, true) : !m3 && f3 === "always" && r3(p3.getTokenAfter(d3)) && t3(d3);
    else {
      var y3 = c3 && function(v3) {
        var b3 = v3.parent, x3 = p3.getTokenAfter(v3);
        return !(!x3 || x3.value !== "}" || !b3 || b3.type !== "BlockStatement" || b3.loc.start.line !== b3.loc.end.line);
      }(d3);
      m3 && y3 ? t3(d3, true) : !m3 && !y3 && t3(d3);
    }
  }
  var s3 = /^[\(\+\x2D\/\[`]/, o3 = e28.options[1], u3 = e28.options[0] === "never", c3 = !(!o3 || !o3.omitLastInOneLineBlock), f3 = o3 && o3.beforeStatementContinuationChars || "any", p3 = e28.getSourceCode();
  return { VariableDeclaration: function(d3) {
    var m3 = d3.parent;
    m3.type === "ForStatement" && m3.init === d3 || /^For(?:In|Of)Statement/.test(m3.type) && m3.left === d3 || a3(d3);
  }, ExpressionStatement: a3, ReturnStatement: a3, ThrowStatement: a3, DoWhileStatement: a3, DebuggerStatement: a3, BreakStatement: a3, ContinueStatement: a3, ImportDeclaration: a3, ExportAllDeclaration: a3, ExportNamedDeclaration: function(d3) {
    d3.declaration || a3(d3);
  }, ExportDefaultDeclaration: function(d3) {
    /(?:Class|Function)Declaration/.test(d3.declaration.type) || a3(d3);
  } };
} }, "sort-imports": { meta: { type: "suggestion", docs: { description: "enforce sorted import declarations within modules", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/sort-imports" }, schema: [{ type: "object", properties: { ignoreCase: { type: "boolean", default: false }, memberSyntaxSortOrder: { type: "array", items: { enum: ["none", "all", "multiple", "single"] }, uniqueItems: true, minItems: 4, maxItems: 4 }, ignoreDeclarationSort: { type: "boolean", default: false }, ignoreMemberSort: { type: "boolean", default: false } }, additionalProperties: false }], fixable: "code" }, create: function(e28) {
  function t3(f3) {
    return o3.indexOf(function(p3) {
      return p3.specifiers.length === 0 ? "none" : p3.specifiers[0].type === "ImportNamespaceSpecifier" ? "all" : p3.specifiers.length === 1 ? "single" : "multiple";
    }(f3));
  }
  function n3(f3) {
    return f3.specifiers[0] ? f3.specifiers[0].local.name : null;
  }
  var r3 = e28.options[0] || {}, i = r3.ignoreCase || false, a3 = r3.ignoreDeclarationSort || false, s3 = r3.ignoreMemberSort || false, o3 = r3.memberSyntaxSortOrder || ["none", "all", "multiple", "single"], u3 = e28.getSourceCode(), c3 = null;
  return { ImportDeclaration: function(f3) {
    if (!a3) {
      if (c3) {
        var p3 = t3(f3), d3 = t3(c3), m3 = n3(f3), y3 = n3(c3);
        i && (y3 = y3 && y3.toLowerCase(), m3 = m3 && m3.toLowerCase()), p3 === d3 ? y3 && m3 && m3 < y3 && e28.report({ node: f3, message: "Imports should be sorted alphabetically." }) : p3 < d3 && e28.report({ node: f3, message: "Expected '{{syntaxA}}' syntax before '{{syntaxB}}' syntax.", data: { syntaxA: o3[p3], syntaxB: o3[d3] } });
      }
      c3 = f3;
    }
    if (!s3) {
      var v3 = f3.specifiers.filter(function(C3) {
        return C3.type === "ImportSpecifier";
      }), b3 = i ? function(C3) {
        return C3.local.name.toLowerCase();
      } : function(C3) {
        return C3.local.name;
      }, x3 = v3.map(b3).findIndex(function(C3, k3, F3) {
        return F3[k3 - 1] > C3;
      });
      x3 !== -1 && e28.report({ node: v3[x3], message: "Member '{{memberName}}' of the import declaration should be sorted alphabetically.", data: { memberName: v3[x3].local.name }, fix: function(C3) {
        return v3.some(function(k3) {
          return u3.getCommentsBefore(k3).length || u3.getCommentsAfter(k3).length;
        }) ? null : C3.replaceTextRange([v3[0].range[0], v3[v3.length - 1].range[1]], v3.slice().sort(function(k3, F3) {
          return b3(k3) > b3(F3) ? 1 : -1;
        }).reduce(function(k3, F3, B3) {
          var O3 = B3 === v3.length - 1 ? "" : u3.getText().slice(v3[B3].range[1], v3[B3 + 1].range[0]);
          return k3 + u3.getText(F3) + O3;
        }, ""));
      } });
    }
  } };
} }, "sort-keys": { meta: { type: "suggestion", docs: { description: "require object keys to be sorted", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/sort-keys" }, schema: [{ enum: ["asc", "desc"] }, { type: "object", properties: { caseSensitive: { type: "boolean", default: true }, natural: { type: "boolean", default: false }, minKeys: { type: "integer", minimum: 2, default: 2 } }, additionalProperties: false }] }, create: function(e28) {
  var t3 = e28.options[0] || "asc", n3 = e28.options[1], r3 = n3 && n3.caseSensitive === false, i = n3 && n3.natural, a3 = n3 && n3.minKeys, s3 = Ju$1[t3 + (r3 ? "I" : "") + (i ? "N" : "")], o3 = null;
  return { ObjectExpression: function(u3) {
    o3 = { upper: o3, prevName: null, numKeys: u3.properties.length };
  }, "ObjectExpression:exit": function() {
    o3 = o3.upper;
  }, SpreadElement: function(u3) {
    u3.parent.type === "ObjectExpression" && (o3.prevName = null);
  }, Property: function(u3) {
    if (u3.parent.type !== "ObjectPattern") {
      var c3 = o3.prevName, f3 = o3.numKeys, p3 = function(d3) {
        var m3 = P$s.getStaticPropertyName(d3);
        return m3 === null ? d3.key.name || null : m3;
      }(u3);
      p3 !== null && (o3.prevName = p3), c3 === null || p3 === null || f3 < a3 || !s3(c3, p3) && e28.report({ node: u3, loc: u3.key.loc, message: "Expected object keys to be in {{natual}}{{insensitive}}{{order}}ending order. '{{thisName}}' should be before '{{prevName}}'.", data: { thisName: p3, prevName: c3, order: t3, insensitive: r3 ? "insensitive " : "", natual: i ? "natural " : "" } });
    }
  } };
} }, "sort-vars": { meta: { type: "suggestion", docs: { description: "require variables within the same declaration block to be sorted", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/sort-vars" }, schema: [{ type: "object", properties: { ignoreCase: { type: "boolean", default: false } }, additionalProperties: false }], fixable: "code" }, create: function(e28) {
  var t3 = (e28.options[0] || {}).ignoreCase || false, n3 = e28.getSourceCode();
  return { VariableDeclaration: function(r3) {
    var i = r3.declarations.filter(function(u3) {
      return u3.id.type === "Identifier";
    }), a3 = t3 ? function(u3) {
      return u3.id.name.toLowerCase();
    } : function(u3) {
      return u3.id.name;
    }, s3 = i.some(function(u3) {
      return u3.init !== null && u3.init.type !== "Literal";
    }), o3 = false;
    i.slice(1).reduce(function(u3, c3) {
      var f3 = a3(u3);
      return a3(c3) < f3 ? (e28.report({ node: c3, message: "Variables within the same declaration block should be sorted alphabetically.", fix: function(p3) {
        return s3 || o3 ? null : p3.replaceTextRange([i[0].range[0], i[i.length - 1].range[1]], i.slice().sort(function(d3, m3) {
          return a3(d3) > a3(m3) ? 1 : -1;
        }).reduce(function(d3, m3, y3) {
          var v3 = y3 === i.length - 1 ? "" : n3.getText().slice(i[y3].range[1], i[y3 + 1].range[0]);
          return d3 + n3.getText(m3) + v3;
        }, ""));
      } }), o3 = true, u3) : c3;
    }, i[0]);
  } };
} }, "space-before-blocks": { meta: { type: "layout", docs: { description: "enforce consistent spacing before blocks", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/space-before-blocks" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never"] }, { type: "object", properties: { keywords: { enum: ["always", "never", "off"] }, functions: { enum: ["always", "never", "off"] }, classes: { enum: ["always", "never", "off"] } }, additionalProperties: false }] }] }, create: function(e28) {
  function t3(f3) {
    var p3 = r3.getTokenBefore(f3);
    if (p3 && !function(b3) {
      return b3.type === "Punctuator" && b3.value === "=>" || b3.type === "Keyword";
    }(p3) && P$s.isTokenOnSameLine(p3, f3)) {
      var d3, m3, y3 = r3.isSpaceBetweenTokens(p3, f3), v3 = e28.getAncestors().pop();
      v3.type === "FunctionExpression" || v3.type === "FunctionDeclaration" ? (d3 = i, m3 = o3) : f3.type === "ClassBody" ? (d3 = s3, m3 = c3) : (d3 = a3, m3 = u3), d3 && !y3 ? e28.report({ node: f3, message: "Missing space before opening brace.", fix: function(b3) {
        return b3.insertTextBefore(f3, " ");
      } }) : m3 && y3 && e28.report({ node: f3, message: "Unexpected space before opening brace.", fix: function(b3) {
        return b3.removeRange([p3.range[1], f3.range[0]]);
      } });
    }
  }
  var n3 = e28.options[0], r3 = e28.getSourceCode(), i = true, a3 = true, s3 = true, o3 = false, u3 = false, c3 = false;
  return xe$3(n3) == "object" ? (i = n3.functions === "always", a3 = n3.keywords === "always", s3 = n3.classes === "always", o3 = n3.functions === "never", u3 = n3.keywords === "never", c3 = n3.classes === "never") : n3 === "never" && (i = false, a3 = false, s3 = false, o3 = true, u3 = true, c3 = true), { BlockStatement: t3, ClassBody: t3, SwitchStatement: function(f3) {
    var p3 = f3.cases;
    t3(0 < p3.length ? r3.getTokenBefore(p3[0]) : r3.getLastToken(f3, 1));
  } };
} }, "space-before-function-paren": { meta: { type: "layout", docs: { description: "enforce consistent spacing before `function` definition opening parenthesis", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/space-before-function-paren" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never"] }, { type: "object", properties: { anonymous: { enum: ["always", "never", "ignore"] }, named: { enum: ["always", "never", "ignore"] }, asyncArrow: { enum: ["always", "never", "ignore"] } }, additionalProperties: false }] }] }, create: function(e28) {
  function t3(s3) {
    if (s3.type !== "ArrowFunctionExpression") {
      if (function(o3) {
        if (o3.id)
          return true;
        var u3 = o3.parent;
        return u3.type === "MethodDefinition" || u3.type === "Property" && (u3.kind === "get" || u3.kind === "set" || u3.method);
      }(s3))
        return a3.named || i;
      if (!s3.generator)
        return a3.anonymous || i;
    } else if (s3.async && P$s.isOpeningParenToken(r3.getFirstToken(s3, { skip: 1 })))
      return a3.asyncArrow || i;
    return "ignore";
  }
  function n3(s3) {
    var o3 = t3(s3);
    if (o3 !== "ignore") {
      var u3 = r3.getFirstToken(s3, P$s.isOpeningParenToken), c3 = r3.getTokenBefore(u3), f3 = r3.isSpaceBetweenTokens(c3, u3);
      f3 && o3 === "never" ? e28.report({ node: s3, loc: c3.loc.end, message: "Unexpected space before function parentheses.", fix: function(p3) {
        var d3 = r3.getCommentsBefore(u3);
        return d3.some(function(m3) {
          return m3.type === "Line";
        }) ? null : p3.replaceTextRange([c3.range[1], u3.range[0]], d3.reduce(function(m3, y3) {
          return m3 + r3.getText(y3);
        }, ""));
      } }) : !f3 && o3 === "always" && e28.report({ node: s3, loc: c3.loc.end, message: "Missing space before function parentheses.", fix: function(p3) {
        return p3.insertTextAfter(c3, " ");
      } });
    }
  }
  var r3 = e28.getSourceCode(), i = typeof e28.options[0] == "string" ? e28.options[0] : "always", a3 = xe$3(e28.options[0]) == "object" ? e28.options[0] : {};
  return { ArrowFunctionExpression: n3, FunctionDeclaration: n3, FunctionExpression: n3 };
} }, "space-in-parens": { meta: { type: "layout", docs: { description: "enforce consistent spacing inside parentheses", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/space-in-parens" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { exceptions: { type: "array", items: { enum: ["{}", "[]", "()", "empty"] }, uniqueItems: true } }, additionalProperties: false }], messages: { missingOpeningSpace: "There must be a space after this paren.", missingClosingSpace: "There must be a space before this paren.", rejectedOpeningSpace: "There should be no space after this paren.", rejectedClosingSpace: "There should be no space before this paren." } }, create: function(e28) {
  function t3(d3) {
    return o3.openers.includes(d3.value);
  }
  function n3(d3) {
    return o3.closers.includes(d3.value);
  }
  function r3(d3, m3) {
    return !p3.isSpaceBetweenTokens(d3, m3) && (f3.empty || !P$s.isClosingParenToken(m3)) && (u3 ? !t3(m3) : t3(m3));
  }
  function i(d3, m3) {
    return !!P$s.isTokenOnSameLine(d3, m3) && m3.type !== "Line" && !!p3.isSpaceBetweenTokens(d3, m3) && (u3 ? t3(m3) : !t3(m3));
  }
  function a3(d3, m3) {
    return !p3.isSpaceBetweenTokens(d3, m3) && (f3.empty || !P$s.isOpeningParenToken(d3)) && (u3 ? !n3(d3) : n3(d3));
  }
  function s3(d3, m3) {
    return !!P$s.isTokenOnSameLine(d3, m3) && !!p3.isSpaceBetweenTokens(d3, m3) && (u3 ? n3(d3) : !n3(d3));
  }
  var o3, u3 = e28.options[0] === "always", c3 = e28.options[1] && e28.options[1].exceptions || [], f3 = {};
  c3.length && (f3.braceException = c3.includes("{}"), f3.bracketException = c3.includes("[]"), f3.parenException = c3.includes("()"), f3.empty = c3.includes("empty"));
  var p3 = e28.getSourceCode();
  return { Program: function(d3) {
    o3 = function() {
      var y3 = [], v3 = [];
      return f3.braceException && (y3.push("{"), v3.push("}")), f3.bracketException && (y3.push("["), v3.push("]")), f3.parenException && (y3.push("("), v3.push(")")), f3.empty && (y3.push(")"), v3.push("(")), { openers: y3, closers: v3 };
    }();
    var m3 = p3.tokensAndComments;
    m3.forEach(function(y3, v3) {
      var b3 = m3[v3 - 1], x3 = m3[v3 + 1];
      (P$s.isOpeningParenToken(y3) || P$s.isClosingParenToken(y3)) && (y3.value === "(" && r3(y3, x3) && e28.report({ node: d3, loc: y3.loc, messageId: "missingOpeningSpace", fix: function(C3) {
        return C3.insertTextAfter(y3, " ");
      } }), y3.value === "(" && i(y3, x3) && e28.report({ node: d3, loc: { start: y3.loc.end, end: x3.loc.start }, messageId: "rejectedOpeningSpace", fix: function(C3) {
        return C3.removeRange([y3.range[1], x3.range[0]]);
      } }), y3.value === ")" && a3(b3, y3) && e28.report({ node: d3, loc: y3.loc, messageId: "missingClosingSpace", fix: function(C3) {
        return C3.insertTextBefore(y3, " ");
      } }), y3.value === ")" && s3(b3, y3) && e28.report({ node: d3, loc: { start: b3.loc.end, end: y3.loc.start }, messageId: "rejectedClosingSpace", fix: function(C3) {
        return C3.removeRange([b3.range[1], y3.range[0]]);
      } }));
    });
  } };
} }, "space-infix-ops": { meta: { type: "layout", docs: { description: "require spacing around infix operators", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/space-infix-ops" }, fixable: "whitespace", schema: [{ type: "object", properties: { int32Hint: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e28) {
  function t3(s3, o3, u3) {
    var c3 = a3.getFirstTokenBetween(s3, o3, function(d3) {
      return d3.value === u3;
    }), f3 = a3.getTokenBefore(c3), p3 = a3.getTokenAfter(c3);
    return a3.isSpaceBetweenTokens(f3, c3) && a3.isSpaceBetweenTokens(c3, p3) ? null : c3;
  }
  function n3(s3, o3) {
    e28.report({ node: s3, loc: o3.loc, message: "Operator '{{operator}}' must be spaced.", data: { operator: o3.value }, fix: function(u3) {
      var c3 = a3.getTokenBefore(o3), f3 = a3.getTokenAfter(o3), p3 = "";
      return o3.range[0] - c3.range[1] == 0 && (p3 = " "), p3 += o3.value, f3.range[0] - o3.range[1] == 0 && (p3 += " "), u3.replaceText(o3, p3);
    } });
  }
  function r3(s3) {
    var o3 = t3(s3.left.typeAnnotation ? s3.left.typeAnnotation : s3.left, s3.right, s3.operator || "=");
    o3 && (!i || !a3.getText(s3).endsWith("|0")) && n3(s3, o3);
  }
  var i = !!e28.options[0] && e28.options[0].int32Hint === true, a3 = e28.getSourceCode();
  return { AssignmentExpression: r3, AssignmentPattern: r3, BinaryExpression: r3, LogicalExpression: r3, ConditionalExpression: function(s3) {
    var o3 = t3(s3.test, s3.consequent, "?"), u3 = t3(s3.consequent, s3.alternate, ":");
    o3 ? n3(s3, o3) : u3 && n3(s3, u3);
  }, VariableDeclarator: function(s3) {
    var o3 = s3.id.typeAnnotation ? s3.id.typeAnnotation : s3.id, u3 = s3.init;
    if (u3) {
      var c3 = t3(o3, u3, "=");
      c3 && n3(s3, c3);
    }
  } };
} }, "space-unary-ops": { meta: { type: "layout", docs: { description: "enforce consistent spacing before or after unary operators", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/space-unary-ops" }, fixable: "whitespace", schema: [{ type: "object", properties: { words: { type: "boolean", default: true }, nonwords: { type: "boolean", default: false }, overrides: { type: "object", additionalProperties: { type: "boolean" } } }, additionalProperties: false }], messages: { unexpectedBefore: "Unexpected space before unary operator '{{operator}}'.", unexpectedAfter: "Unexpected space after unary operator '{{operator}}'.", unexpectedAfterWord: "Unexpected space after unary word operator '{{word}}'.", wordOperator: "Unary word operator '{{word}}' must be followed by whitespace.", operator: "Unary operator '{{operator}}' must be followed by whitespace.", beforeUnaryExpressions: "Space is required before unary expressions '{{token}}'." } }, create: function(e28) {
  function t3(p3) {
    return c3.overrides && Object.prototype.hasOwnProperty.call(c3.overrides, p3);
  }
  function n3(p3) {
    return c3.overrides[p3];
  }
  function r3(p3, d3, m3, y3) {
    m3.range[0] === d3.range[1] && e28.report({ node: p3, messageId: "wordOperator", data: { word: y3 }, fix: function(v3) {
      return v3.insertTextAfter(d3, " ");
    } });
  }
  function i(p3, d3, m3, y3) {
    P$s.canTokensBeAdjacent(d3, m3) && m3.range[0] > d3.range[1] && e28.report({ node: p3, messageId: "unexpectedAfterWord", data: { word: y3 }, fix: function(v3) {
      return v3.removeRange([d3.range[1], m3.range[0]]);
    } });
  }
  function a3(p3, d3, m3, y3) {
    t3(y3) ? n3(y3) ? r3(p3, d3, m3, y3) : i(p3, d3, m3, y3) : c3.words ? r3(p3, d3, m3, y3) : i(p3, d3, m3, y3);
  }
  function s3(p3, d3, m3) {
    if (p3.prefix) {
      if (function(y3) {
        return y3 && y3.type === "UnaryExpression" && y3.argument.operator === "!" && y3.argument && y3.argument.type === "UnaryExpression" && y3.argument.operator === "!";
      }(p3))
        return;
      d3.range[1] === m3.range[0] && e28.report({ node: p3, messageId: "operator", data: { operator: d3.value }, fix: function(y3) {
        return y3.insertTextAfter(d3, " ");
      } });
    } else
      d3.range[1] === m3.range[0] && e28.report({ node: p3, messageId: "beforeUnaryExpressions", data: { token: m3.value }, fix: function(y3) {
        return y3.insertTextBefore(m3, " ");
      } });
  }
  function o3(p3, d3, m3) {
    p3.prefix ? m3.range[0] > d3.range[1] && e28.report({ node: p3, messageId: "unexpectedAfter", data: { operator: d3.value }, fix: function(y3) {
      return P$s.canTokensBeAdjacent(d3, m3) ? y3.removeRange([d3.range[1], m3.range[0]]) : null;
    } }) : m3.range[0] > d3.range[1] && e28.report({ node: p3, messageId: "unexpectedBefore", data: { operator: m3.value }, fix: function(y3) {
      return y3.removeRange([d3.range[1], m3.range[0]]);
    } });
  }
  function u3(p3) {
    var d3 = p3.type !== "UpdateExpression" || p3.prefix ? f3.getFirstTokens(p3, 2) : f3.getLastTokens(p3, 2), m3 = d3[0], y3 = d3[1];
    if (p3.type !== "NewExpression" && !p3.prefix || m3.type !== "Keyword") {
      var v3 = p3.prefix ? d3[0].value : d3[1].value;
      t3(v3) ? n3(v3) ? s3(p3, m3, y3) : o3(p3, m3, y3) : c3.nonwords ? s3(p3, m3, y3) : o3(p3, m3, y3);
    } else
      a3(p3, m3, y3, m3.value);
  }
  var c3 = e28.options[0] || { words: true, nonwords: false }, f3 = e28.getSourceCode();
  return { UnaryExpression: u3, UpdateExpression: u3, NewExpression: u3, YieldExpression: function(p3) {
    var d3 = f3.getFirstTokens(p3, 3);
    !p3.argument || p3.delegate || a3(p3, d3[0], d3[1], "yield");
  }, AwaitExpression: function(p3) {
    var d3 = f3.getFirstTokens(p3, 3);
    a3(p3, d3[0], d3[1], "await");
  } };
} }, "spaced-comment": { meta: { type: "suggestion", docs: { description: "enforce consistent spacing after the `//` or `/*` in a comment", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/spaced-comment" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { exceptions: { type: "array", items: { type: "string" } }, markers: { type: "array", items: { type: "string" } }, line: { type: "object", properties: { exceptions: { type: "array", items: { type: "string" } }, markers: { type: "array", items: { type: "string" } } }, additionalProperties: false }, block: { type: "object", properties: { exceptions: { type: "array", items: { type: "string" } }, markers: { type: "array", items: { type: "string" } }, balanced: { type: "boolean", default: false } }, additionalProperties: false } }, additionalProperties: false }] }, create: function(e28) {
  function t3(c3, f3, p3, d3) {
    var m3 = c3.type.toLowerCase() === "block" ? "/*" : "//";
    e28.report({ node: c3, fix: function(y3) {
      var v3 = c3.range[0], b3 = v3 + 2;
      return a3 ? (p3 && (b3 += p3[0].length), y3.insertTextAfterRange([v3, b3], " ")) : (b3 += p3[0].length, y3.replaceTextRange([v3, b3], m3 + (p3[1] ? p3[1] : "")));
    }, message: f3, data: { refChar: d3 } });
  }
  function n3(c3, f3, p3) {
    e28.report({ node: c3, fix: function(d3) {
      if (a3)
        return d3.insertTextAfterRange([c3.range[0], c3.range[1] - 2], " ");
      var m3 = c3.range[1] - 2, y3 = m3 - p3[0].length;
      return d3.replaceTextRange([y3, m3], "");
    }, message: f3 });
  }
  function r3(c3) {
    var f3 = c3.type.toLowerCase(), p3 = u3[f3], d3 = f3 === "block" ? "/*" : "//";
    if (c3.value.length !== 0 && !p3.markers.has(c3.value)) {
      var m3 = p3.beginRegex.exec(c3.value), y3 = p3.endRegex.exec(c3.value);
      if (a3) {
        if (!m3) {
          var v3 = p3.captureMarker.exec(c3.value), b3 = v3 ? d3 + v3[0] : d3;
          p3.hasExceptions ? t3(c3, "Expected exception block, space or tab after '{{refChar}}' in comment.", v3, b3) : t3(c3, "Expected space or tab after '{{refChar}}' in comment.", v3, b3);
        }
        o3 && f3 === "block" && !y3 && n3(c3, "Expected space or tab before '*/' in comment.");
      } else
        m3 && (m3[1] ? t3(c3, "Unexpected space or tab after marker ({{refChar}}) in comment.", m3, m3[1]) : t3(c3, "Unexpected space or tab after '{{refChar}}' in comment.", m3, d3)), o3 && f3 === "block" && y3 && n3(c3, "Unexpected space or tab before '*/' in comment.", y3);
    }
  }
  var i = e28.getSourceCode(), a3 = e28.options[0] !== "never", s3 = e28.options[1] || {}, o3 = s3.block && s3.block.balanced, u3 = ["block", "line"].reduce(function(c3, f3) {
    var p3 = function(m3) {
      return m3.indexOf("*") === -1 ? m3.concat("*") : m3;
    }(s3[f3] && s3[f3].markers || s3.markers || []), d3 = s3[f3] && s3[f3].exceptions || s3.exceptions || [];
    return c3[f3] = { beginRegex: a3 ? rR(p3, d3) : iR(p3), endRegex: o3 && a3 ? new RegExp("".concat(KA(d3), "$"), "u") : new RegExp("[ 	]+$", "u"), hasExceptions: 0 < d3.length, captureMarker: new RegExp("^(".concat(p3.map(gc$2).join("|"), ")"), "u"), markers: new Set(p3) }, c3;
  }, {});
  return { Program: function() {
    i.getAllComments().filter(function(c3) {
      return c3.type !== "Shebang";
    }).forEach(r3);
  } };
} }, strict: { meta: { type: "suggestion", docs: { description: "require or disallow strict mode directives", category: "Strict Mode", recommended: false, url: "https://eslint.org/docs/rules/strict" }, schema: [{ enum: ["never", "global", "function", "safe"] }], fixable: "code", messages: { function: "Use the function form of 'use strict'.", global: "Use the global form of 'use strict'.", multiple: "Multiple 'use strict' directives.", never: "Strict mode is not permitted.", unnecessary: "Unnecessary 'use strict' directive.", module: "'use strict' is unnecessary inside of modules.", implied: "'use strict' is unnecessary when implied strict mode is enabled.", unnecessaryInClasses: "'use strict' is unnecessary inside of classes.", nonSimpleParameterList: "'use strict' directive inside a function with non-simple parameter list throws a syntax error since ES2016.", wrap: "Wrap {{name}} in a function with 'use strict' directive." } }, create: function(e28) {
  function t3(y3) {
    return y3 === "multiple" || y3 === "unnecessary" || y3 === "module" || y3 === "implied" || y3 === "unnecessaryInClasses";
  }
  function n3(y3) {
    return function(v3) {
      return v3.remove(y3);
    };
  }
  function r3(y3, v3, b3, x3, C3) {
    y3.slice(v3, b3).forEach(function(k3) {
      e28.report({ node: k3, messageId: x3, fix: C3 ? n3(k3) : null });
    });
  }
  function i(y3, v3, b3) {
    r3(y3, 0, y3.length, v3, b3);
  }
  function a3(y3, v3, b3) {
    r3(y3, 1, y3.length, v3, b3);
  }
  function s3(y3, v3) {
    var b3 = 0 < p3.length, x3 = f3.length === 0 && p3.length === 0, C3 = 0 < f3.length && f3[f3.length - 1], k3 = 0 < v3.length;
    k3 ? (fm(y3.params) ? C3 ? e28.report({ node: v3[0], messageId: "unnecessary", fix: n3(v3[0]) }) : b3 && e28.report({ node: v3[0], messageId: "unnecessaryInClasses", fix: n3(v3[0]) }) : e28.report({ node: v3[0], messageId: "nonSimpleParameterList" }), a3(v3, "multiple", true)) : x3 && (fm(y3.params) ? e28.report({ node: y3, messageId: "function" }) : e28.report({ node: y3, messageId: "wrap", data: { name: P$s.getFunctionNameWithKind(y3) } })), f3.push(C3 || k3);
  }
  function o3() {
    f3.pop();
  }
  function u3(y3) {
    var v3 = y3.body.type === "BlockStatement" ? X2(y3.body.body) : [];
    d3 === "function" ? s3(y3, v3) : 0 < v3.length && (fm(y3.params) ? i(v3, d3, t3(d3)) : (e28.report({ node: v3[0], messageId: "nonSimpleParameterList" }), a3(v3, "multiple", true)));
  }
  var c3 = e28.parserOptions.ecmaFeatures || {}, f3 = [], p3 = [], d3 = e28.options[0] || "safe";
  c3.impliedStrict ? d3 = "implied" : d3 === "safe" && (d3 = c3.globalReturn ? "global" : "function");
  var m3 = { Program: function(y3) {
    var v3 = X2(y3.body);
    y3.sourceType === "module" && (d3 = "module"), d3 === "global" ? (0 < y3.body.length && v3.length === 0 && e28.report({ node: y3, messageId: "global" }), a3(v3, "multiple", true)) : i(v3, d3, t3(d3));
  }, FunctionDeclaration: u3, FunctionExpression: u3, ArrowFunctionExpression: u3 };
  return d3 === "function" && Object.assign(m3, { ClassBody: function() {
    p3.push(true);
  }, "ClassBody:exit": function() {
    p3.pop();
  }, "FunctionDeclaration:exit": o3, "FunctionExpression:exit": o3, "ArrowFunctionExpression:exit": o3 }), m3;
} }, "switch-colon-spacing": { meta: { type: "layout", docs: { description: "enforce spacing around colons of switch statements", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/switch-colon-spacing" }, schema: [{ type: "object", properties: { before: { type: "boolean", default: false }, after: { type: "boolean", default: true } }, additionalProperties: false }], fixable: "whitespace", messages: { expectedBefore: "Expected space(s) before this colon.", expectedAfter: "Expected space(s) after this colon.", unexpectedBefore: "Unexpected space(s) before this colon.", unexpectedAfter: "Unexpected space(s) after this colon." } }, create: function(e28) {
  function t3(o3, u3, c3) {
    return P$s.isClosingBraceToken(u3) || !P$s.isTokenOnSameLine(o3, u3) || r3.isSpaceBetweenTokens(o3, u3) === c3;
  }
  function n3(o3, u3, c3, f3) {
    return function(p3, d3) {
      return r3.getFirstTokenBetween(p3, d3, { includeComments: true, filter: P$s.isCommentToken }) !== null;
    }(u3, c3) ? null : f3 ? o3.insertTextAfter(u3, " ") : o3.removeRange([u3.range[1], c3.range[0]]);
  }
  var r3 = e28.getSourceCode(), i = e28.options[0] || {}, a3 = i.before === true, s3 = i.after !== false;
  return { SwitchCase: function(o3) {
    var u3 = function(p3) {
      return p3.test ? r3.getTokenAfter(p3.test, P$s.isColonToken) : r3.getFirstToken(p3, 1);
    }(o3), c3 = r3.getTokenBefore(u3), f3 = r3.getTokenAfter(u3);
    t3(c3, u3, a3) || e28.report({ node: o3, loc: u3.loc, messageId: a3 ? "expectedBefore" : "unexpectedBefore", fix: function(p3) {
      return n3(p3, c3, u3, a3);
    } }), t3(u3, f3, s3) || e28.report({ node: o3, loc: u3.loc, messageId: s3 ? "expectedAfter" : "unexpectedAfter", fix: function(p3) {
      return n3(p3, u3, f3, s3);
    } });
  } };
} }, "symbol-description": { meta: { type: "suggestion", docs: { description: "require symbol descriptions", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/symbol-description" }, fixable: null, schema: [], messages: { expected: "Expected Symbol to have a description." } }, create: function(e28) {
  function t3(n3) {
    n3.arguments.length === 0 && e28.report({ node: n3, messageId: "expected" });
  }
  return { "Program:exit": function() {
    var n3 = e28.getScope(), r3 = P$s.getVariableByName(n3, "Symbol");
    r3 && r3.defs.length === 0 && r3.references.forEach(function(i) {
      var a3 = i.identifier;
      P$s.isCallee(a3) && t3(a3.parent);
    });
  } };
} }, "template-curly-spacing": { meta: { type: "layout", docs: { description: "require or disallow spacing around embedded expressions of template strings", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/template-curly-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }], messages: { expectedBefore: "Expected space(s) before '}'.", expectedAfter: "Expected space(s) after '${'.", unexpectedBefore: "Unexpected space(s) before '}'.", unexpectedAfter: "Unexpected space(s) after '${'." } }, create: function(e28) {
  function t3(s3) {
    var o3 = r3.getTokenBefore(s3);
    o3 && sR.test(s3.value) && P$s.isTokenOnSameLine(o3, s3) && r3.isSpaceBetweenTokens(o3, s3) !== i && e28.report({ loc: s3.loc.start, messageId: "".concat(a3, "Before"), fix: function(u3) {
      return i ? u3.insertTextBefore(s3, " ") : u3.removeRange([o3.range[1], s3.range[0]]);
    } });
  }
  function n3(s3) {
    var o3 = r3.getTokenAfter(s3);
    o3 && oR.test(s3.value) && P$s.isTokenOnSameLine(s3, o3) && r3.isSpaceBetweenTokens(s3, o3) !== i && e28.report({ loc: { line: s3.loc.end.line, column: s3.loc.end.column - 2 }, messageId: "".concat(a3, "After"), fix: function(u3) {
      return i ? u3.insertTextAfter(s3, " ") : u3.removeRange([s3.range[1], o3.range[0]]);
    } });
  }
  var r3 = e28.getSourceCode(), i = e28.options[0] === "always", a3 = i ? "expected" : "unexpected";
  return { TemplateElement: function(s3) {
    var o3 = r3.getFirstToken(s3);
    t3(o3), n3(o3);
  } };
} }, "template-tag-spacing": { meta: { type: "layout", docs: { description: "require or disallow spacing between template tags and their literals", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/template-tag-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }], messages: { unexpected: "Unexpected space between template tag and template literal.", missing: "Missing space between template tag and template literal." } }, create: function(e28) {
  var t3 = e28.options[0] !== "always", n3 = e28.getSourceCode();
  return { TaggedTemplateExpression: function(r3) {
    var i = n3.getTokenBefore(r3.quasi), a3 = n3.getFirstToken(r3.quasi), s3 = n3.isSpaceBetweenTokens(i, a3);
    t3 && s3 ? e28.report({ node: r3, loc: i.loc.start, messageId: "unexpected", fix: function(o3) {
      var u3 = n3.getCommentsBefore(r3.quasi);
      return u3.some(function(c3) {
        return c3.type === "Line";
      }) ? null : o3.replaceTextRange([i.range[1], a3.range[0]], u3.reduce(function(c3, f3) {
        return c3 + n3.getText(f3);
      }, ""));
    } }) : !t3 && !s3 && e28.report({ node: r3, loc: i.loc.start, messageId: "missing", fix: function(o3) {
      return o3.insertTextAfter(i, " ");
    } });
  } };
} }, "unicode-bom": { meta: { type: "layout", docs: { description: "require or disallow Unicode byte order mark (BOM)", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/unicode-bom" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }], messages: { expected: "Expected Unicode BOM (Byte Order Mark).", unexpected: "Unexpected Unicode BOM (Byte Order Mark)." } }, create: function(e28) {
  return { Program: function(t3) {
    var n3 = e28.getSourceCode(), r3 = { column: 0, line: 1 }, i = e28.options[0] || "never";
    n3.hasBOM || i !== "always" ? n3.hasBOM && i === "never" && e28.report({ node: t3, loc: r3, messageId: "unexpected", fix: function(a3) {
      return a3.removeRange([-1, 0]);
    } }) : e28.report({ node: t3, loc: r3, messageId: "expected", fix: function(a3) {
      return a3.insertTextBeforeRange([0, 1], "\uFEFF");
    } });
  } };
} }, "use-isnan": { meta: { type: "problem", docs: { description: "require calls to `isNaN()` when checking for `NaN`", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/use-isnan" }, schema: [{ type: "object", properties: { enforceForSwitchCase: { type: "boolean", default: false }, enforceForIndexOf: { type: "boolean", default: false } }, additionalProperties: false }], messages: { comparisonWithNaN: "Use the isNaN function to compare with NaN.", switchNaN: "'switch(NaN)' can never match a case clause. Use Number.isNaN instead of the switch.", caseNaN: "'case NaN' can never match. Use Number.isNaN before the switch.", indexOfNaN: "Array prototype method '{{ methodName }}' cannot find NaN." } }, create: function(e28) {
  var t3 = e28.options[0] && e28.options[0].enforceForSwitchCase, n3 = e28.options[0] && e28.options[0].enforceForIndexOf, r3 = { BinaryExpression: function(i) {
    /^(?:[<>]|[!=]=)=?$/.test(i.operator) && (Lu$1(i.left) || Lu$1(i.right)) && e28.report({ node: i, messageId: "comparisonWithNaN" });
  } };
  return t3 && (r3.SwitchStatement = function(i) {
    Lu$1(i.discriminant) && e28.report({ node: i, messageId: "switchNaN" });
    var a3 = true, s3 = false, o3 = void 0;
    try {
      for (var u3, c3 = i.cases[Symbol.iterator](); !(a3 = (u3 = c3.next()).done); a3 = true) {
        var f3 = u3.value;
        Lu$1(f3.test) && e28.report({ node: f3, messageId: "caseNaN" });
      }
    } catch (p3) {
      s3 = true, o3 = p3;
    } finally {
      try {
        a3 || c3.return == null || c3.return();
      } finally {
        if (s3)
          throw o3;
      }
    }
  }), n3 && (r3.CallExpression = function(i) {
    var a3 = i.callee;
    if (a3.type === "MemberExpression") {
      var s3 = P$s.getStaticPropertyName(a3);
      (s3 === "indexOf" || s3 === "lastIndexOf") && i.arguments.length === 1 && Lu$1(i.arguments[0]) && e28.report({ node: i, messageId: "indexOfNaN", data: { methodName: s3 } });
    }
  }), r3;
} }, "valid-jsdoc": { meta: { type: "suggestion", docs: { description: "enforce valid JSDoc comments", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/valid-jsdoc" }, schema: [{ type: "object", properties: { prefer: { type: "object", additionalProperties: { type: "string" } }, preferType: { type: "object", additionalProperties: { type: "string" } }, requireReturn: { type: "boolean", default: true }, requireParamDescription: { type: "boolean", default: true }, requireReturnDescription: { type: "boolean", default: true }, matchDescription: { type: "string" }, requireReturnType: { type: "boolean", default: true }, requireParamType: { type: "boolean", default: true } }, additionalProperties: false }], fixable: "code", messages: { unexpectedTag: "Unexpected @{{title}} tag; function has no return statement.", expected: "Expected JSDoc for '{{name}}' but found '{{jsdocName}}'.", use: "Use @{{name}} instead.", useType: "Use '{{expectedTypeName}}' instead of '{{currentTypeName}}'.", syntaxError: "JSDoc syntax error.", missingBrace: "JSDoc type missing brace.", missingParamDesc: "Missing JSDoc parameter description for '{{name}}'.", missingParamType: "Missing JSDoc parameter type for '{{name}}'.", missingReturnType: "Missing JSDoc return type.", missingReturnDesc: "Missing JSDoc return description.", missingReturn: "Missing JSDoc @{{returns}} for function.", missingParam: "Missing JSDoc for parameter '{{name}}'.", duplicateParam: "Duplicate JSDoc parameter '{{name}}'.", unsatisfiedDesc: "JSDoc description does not satisfy the regex pattern." }, deprecated: true, replacedBy: [] }, create: function(e28) {
  function t3(k3) {
    return k3.type === "ClassExpression" || k3.type === "ClassDeclaration";
  }
  function n3(k3) {
    C3.push({ returnPresent: k3.type === "ArrowFunctionExpression" && k3.body.type !== "BlockStatement" || t3(k3) || k3.async });
  }
  function r3(k3) {
    return k3.type === null || k3.type.name === "void" || k3.type.type === "UndefinedLiteral";
  }
  function i(k3) {
    var F3;
    return k3.name ? F3 = k3 : k3.expression && (F3 = k3.expression), { currentType: F3, expectedTypeName: F3 && b3[F3.name] };
  }
  function a3(k3, F3) {
    return { start: f3.getLocFromIndex(k3.range[0] + 2 + F3.range[0]), end: f3.getLocFromIndex(k3.range[0] + 2 + F3.range[1]) };
  }
  function s3(k3, F3) {
    if (F3 && function(S3) {
      return S3 !== "UndefinedLiteral" && S3 !== "NullLiteral" && S3 !== "NullableLiteral" && S3 !== "FunctionType" && S3 !== "AllLiteral";
    }(F3.type)) {
      var B3 = [], O3 = [];
      switch (F3.type) {
        case "TypeApplication":
          O3 = F3.applications[0].type === "UnionType" ? F3.applications[0].elements : F3.applications, B3.push(i(F3));
          break;
        case "RecordType":
          O3 = F3.fields;
          break;
        case "UnionType":
        case "ArrayType":
          O3 = F3.elements;
          break;
        case "FieldType":
          F3.value && B3.push(i(F3.value));
          break;
        default:
          B3.push(i(F3));
      }
      O3.forEach(s3.bind(null, k3)), B3.forEach(function(S3) {
        S3.expectedTypeName && S3.expectedTypeName !== S3.currentType.name && e28.report({ node: k3, messageId: "useType", loc: a3(k3, S3.currentType), data: { currentTypeName: S3.currentType.name, expectedTypeName: S3.expectedTypeName }, fix: function(w3) {
          return w3.replaceTextRange(S3.currentType.range.map(function(D3) {
            return k3.range[0] + 2 + D3;
          }), S3.expectedTypeName);
        } });
      });
    }
  }
  function o3(k3) {
    var F3, B3 = f3.getJSDocComment(k3), O3 = C3.pop(), S3 = /* @__PURE__ */ Object.create(null), w3 = [], D3 = false, I3 = false, L3 = false, V10 = false, K3 = false;
    if (B3) {
      var W3;
      try {
        W3 = _I.parse(B3.value, { strict: true, unwrap: true, sloppy: true, range: true });
      } catch (q3) {
        return void (/brace[s\u017F]/i.test(q3.message) ? e28.report({ node: B3, messageId: "missingBrace" }) : e28.report({ node: B3, messageId: "syntaxError" }));
      }
      W3.tags.forEach(function(q3) {
        switch (q3.title.toLowerCase()) {
          case "param":
          case "arg":
          case "argument":
            w3.push(q3);
            break;
          case "return":
          case "returns":
            D3 = true, F3 = q3;
            break;
          case "constructor":
          case "class":
            I3 = true;
            break;
          case "override":
          case "inheritdoc":
            V10 = true;
            break;
          case "abstract":
          case "virtual":
            K3 = true;
            break;
          case "interface":
            L3 = true;
        }
        if (Object.prototype.hasOwnProperty.call(c3, q3.title) && q3.title !== c3[q3.title]) {
          var J3 = a3(B3, q3);
          e28.report({ node: B3, messageId: "use", loc: { start: J3.start, end: { line: J3.start.line, column: J3.start.column + "@".concat(q3.title).length } }, data: { name: c3[q3.title] }, fix: function(X3) {
            return X3.replaceTextRange([B3.range[0] + q3.range[0] + 3, B3.range[0] + q3.range[0] + q3.title.length + 3], c3[q3.title]);
          } });
        }
        x3 && q3.type && s3(B3, q3.type);
      }), w3.forEach(function(q3) {
        v3 && !q3.type && e28.report({ node: B3, messageId: "missingParamType", loc: a3(B3, q3), data: { name: q3.name } }), !q3.description && d3 && e28.report({ node: B3, messageId: "missingParamDesc", loc: a3(B3, q3), data: { name: q3.name } }), S3[q3.name] ? e28.report({ node: B3, messageId: "duplicateParam", loc: a3(B3, q3), data: { name: q3.name } }) : q3.name.indexOf(".") === -1 && (S3[q3.name] = q3);
      }), D3 && (p3 || O3.returnPresent || F3.type !== null && r3(F3) || K3 ? (y3 && !F3.type && e28.report({ node: B3, messageId: "missingReturnType" }), !r3(F3) && !F3.description && m3 && e28.report({ node: B3, messageId: "missingReturnDesc" })) : e28.report({ node: B3, messageId: "unexpectedTag", loc: a3(B3, F3), data: { title: F3.title } })), V10 || D3 || I3 || L3 || k3.parent.kind === "get" || k3.parent.kind === "constructor" || k3.parent.kind === "set" || t3(k3) || !p3 && (!O3.returnPresent || k3.async) || e28.report({ node: B3, messageId: "missingReturn", data: { returns: c3.returns || "returns" } });
      var R3 = Object.keys(S3);
      k3.params && k3.params.forEach(function(q3, J3) {
        var X3 = q3.type === "AssignmentPattern" ? q3.left : q3;
        if (X3.type === "Identifier") {
          var ce2 = X3.name;
          R3[J3] && ce2 !== R3[J3] ? e28.report({ node: B3, messageId: "expected", loc: a3(B3, S3[R3[J3]]), data: { name: ce2, jsdocName: R3[J3] } }) : !S3[ce2] && !V10 && e28.report({ node: B3, messageId: "missingParam", data: { name: ce2 } });
        }
      }), u3.matchDescription && (new RegExp(u3.matchDescription, "u").test(W3.description) || e28.report({ node: B3, messageId: "unsatisfiedDesc" }));
    }
  }
  var u3 = e28.options[0] || {}, c3 = u3.prefer || {}, f3 = e28.getSourceCode(), p3 = u3.requireReturn !== false, d3 = u3.requireParamDescription !== false, m3 = u3.requireReturnDescription !== false, y3 = u3.requireReturnType !== false, v3 = u3.requireParamType !== false, b3 = u3.preferType || {}, x3 = Object.keys(b3).length !== 0, C3 = [];
  return { ArrowFunctionExpression: n3, FunctionExpression: n3, FunctionDeclaration: n3, ClassExpression: n3, ClassDeclaration: n3, "ArrowFunctionExpression:exit": o3, "FunctionExpression:exit": o3, "FunctionDeclaration:exit": o3, "ClassExpression:exit": o3, "ClassDeclaration:exit": o3, ReturnStatement: function(k3) {
    var F3 = C3[C3.length - 1];
    F3 && k3.argument !== null && (F3.returnPresent = true);
  } };
} }, "valid-typeof": { meta: { type: "problem", docs: { description: "enforce comparing `typeof` expressions against valid strings", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/valid-typeof" }, schema: [{ type: "object", properties: { requireStringLiterals: { type: "boolean", default: false } }, additionalProperties: false }], messages: { invalidValue: "Invalid typeof comparison value.", notString: "Typeof comparisons should be to string literals." } }, create: function(e28) {
  function t3(a3) {
    return a3.type === "UnaryExpression" && a3.operator === "typeof";
  }
  var n3 = ["symbol", "undefined", "object", "boolean", "number", "string", "function", "bigint"], r3 = ["==", "===", "!=", "!=="], i = e28.options[0] && e28.options[0].requireStringLiterals;
  return { UnaryExpression: function(a3) {
    if (t3(a3)) {
      var s3 = e28.getAncestors().pop();
      if (s3.type === "BinaryExpression" && r3.indexOf(s3.operator) !== -1) {
        var o3 = s3.left === a3 ? s3.right : s3.left;
        if (o3.type === "Literal" || o3.type === "TemplateLiteral" && !o3.expressions.length) {
          var u3 = o3.type === "Literal" ? o3.value : o3.quasis[0].value.cooked;
          n3.indexOf(u3) === -1 && e28.report({ node: o3, messageId: "invalidValue" });
        } else
          i && !t3(o3) && e28.report({ node: o3, messageId: "notString" });
      }
    }
  } };
} }, "vars-on-top": { meta: { type: "suggestion", docs: { description: "require `var` declarations be placed at the top of their containing scope", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/vars-on-top" }, schema: [], messages: { top: "All 'var' declarations must be at the top of the function scope." } }, create: function(e28) {
  function t3(o3) {
    return o3.type === "ExpressionStatement" && o3.expression.type === "Literal" && typeof o3.expression.value == "string";
  }
  function n3(o3) {
    return o3.type === "ImportDeclaration" || o3.type === "ImportSpecifier" || o3.type === "ImportDefaultSpecifier" || o3.type === "ImportNamespaceSpecifier";
  }
  function r3(o3) {
    return o3.type === "VariableDeclaration" || o3.type === "ExportNamedDeclaration" && o3.declaration && o3.declaration.type === "VariableDeclaration";
  }
  function i(o3, u3) {
    for (var c3 = u3.length, f3 = 0; f3 < c3 && (t3(u3[f3]) || n3(u3[f3])); ++f3)
      ;
    for (; f3 < c3; ++f3) {
      if (!r3(u3[f3]))
        return false;
      if (u3[f3] === o3)
        return true;
    }
    return false;
  }
  function a3(o3, u3) {
    i(o3, u3.body) || e28.report({ node: o3, messageId: "top" });
  }
  function s3(o3, u3, c3) {
    /Function/.test(c3.type) && u3.type === "BlockStatement" && i(o3, u3.body) || e28.report({ node: o3, messageId: "top" });
  }
  return { "VariableDeclaration[kind='var']": function(o3) {
    o3.parent.type === "ExportNamedDeclaration" ? a3(o3.parent, o3.parent.parent) : o3.parent.type === "Program" ? a3(o3, o3.parent) : s3(o3, o3.parent, o3.parent.parent);
  } };
} }, "wrap-iife": { meta: { type: "layout", docs: { description: "require parentheses around immediate `function` invocations", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/wrap-iife" }, schema: [{ enum: ["outside", "inside", "any"] }, { type: "object", properties: { functionPrototypeMethods: { type: "boolean", default: false } }, additionalProperties: false }], fixable: "code", messages: { wrapInvocation: "Wrap an immediate function invocation in parentheses.", wrapExpression: "Wrap only the function expression in parens.", moveInvocation: "Move the invocation into the parens that contain the function." } }, create: function(e28) {
  function t3(s3) {
    return P$s.isParenthesised(a3, s3);
  }
  function n3(s3) {
    var o3 = s3.callee;
    return o3.type === "FunctionExpression" ? o3 : !i || o3.type !== "MemberExpression" || o3.object.type !== "FunctionExpression" || P$s.getStaticPropertyName(o3) !== "call" && P$s.getStaticPropertyName(o3) !== "apply" ? null : o3.object;
  }
  var r3 = e28.options[0] || "outside", i = e28.options[1] && e28.options[1].functionPrototypeMethods, a3 = e28.getSourceCode();
  return { CallExpression: function(s3) {
    var o3 = n3(s3);
    if (o3) {
      var u3 = t3(s3), c3 = t3(o3);
      u3 || c3 ? r3 !== "inside" || c3 ? r3 === "outside" && !u3 && e28.report({ node: s3, messageId: "moveInvocation", fix: function(f3) {
        var p3 = a3.getTokenAfter(o3);
        return f3.replaceTextRange([p3.range[0], s3.range[1]], "".concat(a3.getText().slice(p3.range[1], s3.range[1]), ")"));
      } }) : e28.report({ node: s3, messageId: "wrapExpression", fix: function(f3) {
        var p3 = a3.getTokenAfter(s3);
        return f3.replaceTextRange([o3.range[1], p3.range[1]], ")".concat(a3.getText().slice(o3.range[1], p3.range[0])));
      } }) : e28.report({ node: s3, messageId: "wrapInvocation", fix: function(f3) {
        var p3 = r3 === "inside" ? o3 : s3;
        return f3.replaceText(p3, "(".concat(a3.getText(p3), ")"));
      } });
    }
  } };
} }, "wrap-regex": { meta: { type: "layout", docs: { description: "require parenthesis around regex literals", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/wrap-regex" }, schema: [], fixable: "code", messages: { requireParens: "Wrap the regexp literal in parens to disambiguate the slash." } }, create: function(e28) {
  var t3 = e28.getSourceCode();
  return { Literal: function(n3) {
    if (t3.getFirstToken(n3).type === "RegularExpression") {
      var r3 = t3.getTokenBefore(n3), i = t3.getTokenAfter(n3), a3 = e28.getAncestors(), s3 = a3[a3.length - 1];
      s3.type !== "MemberExpression" || s3.object !== n3 || r3 && r3.value === "(" && i && i.value === ")" || e28.report({ node: n3, messageId: "requireParens", fix: function(o3) {
        return o3.replaceText(n3, "(".concat(t3.getText(n3), ")"));
      } });
    }
  } };
} }, "yield-star-spacing": { meta: { type: "layout", docs: { description: "require or disallow spacing around the `*` in `yield*` expressions", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/yield-star-spacing" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["before", "after", "both", "neither"] }, { type: "object", properties: { before: { type: "boolean" }, after: { type: "boolean" } }, additionalProperties: false }] }], messages: { missingBefore: "Missing space before *.", missingAfter: "Missing space after *.", unexpectedBefore: "Unexpected space before *.", unexpectedAfter: "Unexpected space after *." } }, create: function(e28) {
  function t3(i, a3, s3) {
    if (n3.isSpaceBetweenTokens(a3, s3) !== r3[i]) {
      var o3, u3 = a3.value === "*", c3 = r3[i], f3 = u3 ? a3 : s3;
      o3 = c3 ? i === "before" ? "missingBefore" : "missingAfter" : i === "before" ? "unexpectedBefore" : "unexpectedAfter", e28.report({ node: f3, messageId: o3, fix: function(p3) {
        return c3 ? u3 ? p3.insertTextAfter(f3, " ") : p3.insertTextBefore(f3, " ") : p3.removeRange([a3.range[1], s3.range[0]]);
      } });
    }
  }
  var n3 = e28.getSourceCode(), r3 = function(i) {
    return i && typeof i != "string" ? i : { before: { before: true, after: false }, after: { before: false, after: true }, both: { before: true, after: true }, neither: { before: false, after: false } }[i || "after"];
  }(e28.options[0]);
  return { YieldExpression: function(i) {
    if (i.delegate) {
      var a3 = n3.getFirstTokens(i, 3), s3 = a3[0], o3 = a3[1], u3 = a3[2];
      t3("before", s3, o3), t3("after", o3, u3);
    }
  } };
} }, yoda: { meta: { type: "suggestion", docs: { description: 'require or disallow "Yoda" conditions', category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/yoda" }, schema: [{ enum: ["always", "never"] }, { type: "object", properties: { exceptRange: { type: "boolean", default: false }, onlyEquality: { type: "boolean", default: false } }, additionalProperties: false }], fixable: "code", messages: { expected: "Expected literal to be on the {{expectedSide}} side of {{operator}}." } }, create: function(e28) {
  function t3(u3) {
    var c3 = u3.left, f3 = u3.right;
    return u3.type === "LogicalExpression" && c3.type === "BinaryExpression" && f3.type === "BinaryExpression" && Y2(c3.operator) && Y2(f3.operator) && (function() {
      var p3, d3;
      return u3.operator === "&&" && (p3 = ep(c3.left)) && (d3 = ep(f3.right, Number.POSITIVE_INFINITY)) && p3.value <= d3.value && rc$2(c3.right, f3.left);
    }() || function() {
      var p3, d3;
      return u3.operator === "||" && (p3 = ep(c3.right, Number.NEGATIVE_INFINITY)) && (d3 = ep(f3.left)) && p3.value <= d3.value && rc$2(c3.left, f3.right);
    }()) && P$s.isParenthesised(s3, u3);
  }
  function n3(u3) {
    var c3 = s3.getTokenBefore(u3), f3 = s3.getFirstTokenBetween(u3.left, u3.right, function(x3) {
      return x3.value === u3.operator;
    }), p3 = s3.getText().slice(s3.getTokenBefore(f3).range[1], f3.range[0]), d3 = s3.getText().slice(f3.range[1], s3.getTokenAfter(f3).range[0]), m3 = s3.getText().slice(u3.range[0], s3.getTokenBefore(f3).range[1]), y3 = s3.getTokenAfter(f3), v3 = s3.getText().slice(y3.range[0], u3.range[1]), b3 = "";
    return c3 && c3.range[1] === u3.range[0] && !P$s.canTokensBeAdjacent(c3, y3) && (b3 = " "), b3 + v3 + p3 + o3[f3.value] + d3 + m3;
  }
  var r3 = e28.options[0] === "always", i = e28.options[1] && e28.options[1].exceptRange, a3 = e28.options[1] && e28.options[1].onlyEquality, s3 = e28.getSourceCode(), o3 = { "===": "===", "!==": "!==", "==": "==", "!=": "!=", "<": ">", ">": "<", "<=": ">=", ">=": "<=" };
  return { BinaryExpression: function(u3) {
    var c3 = r3 ? u3.left : u3.right, f3 = r3 ? u3.right : u3.left;
    f3.type !== "Literal" && !m0(f3) || c3.type === "Literal" || m0(c3) || !function(p3) {
      return /^(==|===)$/.test(p3);
    }(u3.operator) && a3 || !function(p3) {
      return /^(==|===|!=|!==|<|>|<=|>=)$/.test(p3);
    }(u3.operator) || i && t3(e28.getAncestors().pop()) || e28.report({ node: u3, messageId: "expected", data: { operator: u3.operator, expectedSide: r3 ? "left" : "right" }, fix: function(p3) {
      return p3.replaceText(u3, n3(u3));
    } });
  } };
} } }, cR = function(e28) {
  function t3() {
    var n3;
    return We$1(this, t3), (n3 = Gt$3(this, rt$2(t3).call(this))).defineRules(uR), n3;
  }
  return $t$3(t3, $P.linter_1), t3;
}();
var o$R = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function l$Y(e28) {
  return e28 && e28.__esModule && Object.prototype.hasOwnProperty.call(e28, "default") ? e28.default : e28;
}
var e$X = { exports: {} };
(function(Zr2, To2) {
  (function(k3) {
    Zr2.exports = k3();
  })(function() {
    var k3 = (w3, d3) => () => (d3 || w3((d3 = { exports: {} }).exports, d3), d3.exports), Te2 = k3((w3, d3) => {
      var u3 = function(m3) {
        return m3 && m3.Math == Math && m3;
      };
      d3.exports = u3(typeof globalThis == "object" && globalThis) || u3(typeof window == "object" && window) || u3(typeof self == "object" && self) || u3(typeof o$R == "object" && o$R) || function() {
        return this;
      }() || Function("return this")();
    }), Ee2 = k3((w3, d3) => {
      d3.exports = function(u3) {
        try {
          return !!u3();
        } catch {
          return true;
        }
      };
    }), Le2 = k3((w3, d3) => {
      var u3 = Ee2();
      d3.exports = !u3(function() {
        return Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1] != 7;
      });
    }), Rt2 = k3((w3, d3) => {
      var u3 = Ee2();
      d3.exports = !u3(function() {
        var m3 = function() {
        }.bind();
        return typeof m3 != "function" || m3.hasOwnProperty("prototype");
      });
    }), Ut2 = k3((w3, d3) => {
      var u3 = Rt2(), m3 = Function.prototype.call;
      d3.exports = u3 ? m3.bind(m3) : function() {
        return m3.apply(m3, arguments);
      };
    }), ei2 = k3((w3) => {
      var d3 = {}.propertyIsEnumerable, u3 = Object.getOwnPropertyDescriptor, m3 = u3 && !d3.call({ 1: 2 }, 1);
      w3.f = m3 ? function(c3) {
        var x3 = u3(this, c3);
        return !!x3 && x3.enumerable;
      } : d3;
    }), bs2 = k3((w3, d3) => {
      d3.exports = function(u3, m3) {
        return { enumerable: !(u3 & 1), configurable: !(u3 & 2), writable: !(u3 & 4), value: m3 };
      };
    }), Ce2 = k3((w3, d3) => {
      var u3 = Rt2(), m3 = Function.prototype, c3 = m3.call, x3 = u3 && m3.bind.bind(c3, c3);
      d3.exports = u3 ? x3 : function(b3) {
        return function() {
          return c3.apply(b3, arguments);
        };
      };
    }), ct2 = k3((w3, d3) => {
      var u3 = Ce2(), m3 = u3({}.toString), c3 = u3("".slice);
      d3.exports = function(x3) {
        return c3(m3(x3), 8, -1);
      };
    }), ti2 = k3((w3, d3) => {
      var u3 = Ce2(), m3 = Ee2(), c3 = ct2(), x3 = Object, b3 = u3("".split);
      d3.exports = m3(function() {
        return !x3("z").propertyIsEnumerable(0);
      }) ? function(P3) {
        return c3(P3) == "String" ? b3(P3, "") : x3(P3);
      } : x3;
    }), Ts2 = k3((w3, d3) => {
      d3.exports = function(u3) {
        return u3 == null;
      };
    }), Es2 = k3((w3, d3) => {
      var u3 = Ts2(), m3 = TypeError;
      d3.exports = function(c3) {
        if (u3(c3))
          throw m3("Can't call method on " + c3);
        return c3;
      };
    }), _t2 = k3((w3, d3) => {
      var u3 = ti2(), m3 = Es2();
      d3.exports = function(c3) {
        return u3(m3(c3));
      };
    }), Cs2 = k3((w3, d3) => {
      var u3 = typeof document == "object" && document.all, m3 = typeof u3 > "u" && u3 !== void 0;
      d3.exports = { all: u3, IS_HTMLDDA: m3 };
    }), Pe2 = k3((w3, d3) => {
      var u3 = Cs2(), m3 = u3.all;
      d3.exports = u3.IS_HTMLDDA ? function(c3) {
        return typeof c3 == "function" || c3 === m3;
      } : function(c3) {
        return typeof c3 == "function";
      };
    }), qe2 = k3((w3, d3) => {
      var u3 = Pe2(), m3 = Cs2(), c3 = m3.all;
      d3.exports = m3.IS_HTMLDDA ? function(x3) {
        return typeof x3 == "object" ? x3 !== null : u3(x3) || x3 === c3;
      } : function(x3) {
        return typeof x3 == "object" ? x3 !== null : u3(x3);
      };
    }), dt2 = k3((w3, d3) => {
      var u3 = Te2(), m3 = Pe2(), c3 = function(x3) {
        return m3(x3) ? x3 : void 0;
      };
      d3.exports = function(x3, b3) {
        return arguments.length < 2 ? c3(u3[x3]) : u3[x3] && u3[x3][b3];
      };
    }), si2 = k3((w3, d3) => {
      var u3 = Ce2();
      d3.exports = u3({}.isPrototypeOf);
    }), ri2 = k3((w3, d3) => {
      var u3 = dt2();
      d3.exports = u3("navigator", "userAgent") || "";
    }), ii2 = k3((w3, d3) => {
      var u3 = Te2(), m3 = ri2(), c3 = u3.process, x3 = u3.Deno, b3 = c3 && c3.versions || x3 && x3.version, P3 = b3 && b3.v8, D3, v3;
      P3 && (D3 = P3.split("."), v3 = D3[0] > 0 && D3[0] < 4 ? 1 : +(D3[0] + D3[1])), !v3 && m3 && (D3 = m3.match(/Edge\/(\d+)/), (!D3 || D3[1] >= 74) && (D3 = m3.match(/Chrome\/(\d+)/), D3 && (v3 = +D3[1]))), d3.exports = v3;
    }), vs2 = k3((w3, d3) => {
      var u3 = ii2(), m3 = Ee2();
      d3.exports = !!Object.getOwnPropertySymbols && !m3(function() {
        var c3 = Symbol();
        return !String(c3) || !(Object(c3) instanceof Symbol) || !Symbol.sham && u3 && u3 < 41;
      });
    }), Ss2 = k3((w3, d3) => {
      var u3 = vs2();
      d3.exports = u3 && !Symbol.sham && typeof Symbol.iterator == "symbol";
    }), ws2 = k3((w3, d3) => {
      var u3 = dt2(), m3 = Pe2(), c3 = si2(), x3 = Ss2(), b3 = Object;
      d3.exports = x3 ? function(P3) {
        return typeof P3 == "symbol";
      } : function(P3) {
        var D3 = u3("Symbol");
        return m3(D3) && c3(D3.prototype, b3(P3));
      };
    }), ai2 = k3((w3, d3) => {
      var u3 = String;
      d3.exports = function(m3) {
        try {
          return u3(m3);
        } catch {
          return "Object";
        }
      };
    }), zt2 = k3((w3, d3) => {
      var u3 = Pe2(), m3 = ai2(), c3 = TypeError;
      d3.exports = function(x3) {
        if (u3(x3))
          return x3;
        throw c3(m3(x3) + " is not a function");
      };
    }), ni2 = k3((w3, d3) => {
      var u3 = zt2(), m3 = Ts2();
      d3.exports = function(c3, x3) {
        var b3 = c3[x3];
        return m3(b3) ? void 0 : u3(b3);
      };
    }), oi2 = k3((w3, d3) => {
      var u3 = Ut2(), m3 = Pe2(), c3 = qe2(), x3 = TypeError;
      d3.exports = function(b3, P3) {
        var D3, v3;
        if (P3 === "string" && m3(D3 = b3.toString) && !c3(v3 = u3(D3, b3)) || m3(D3 = b3.valueOf) && !c3(v3 = u3(D3, b3)) || P3 !== "string" && m3(D3 = b3.toString) && !c3(v3 = u3(D3, b3)))
          return v3;
        throw x3("Can't convert object to primitive value");
      };
    }), hi2 = k3((w3, d3) => {
      d3.exports = false;
    }), Ht2 = k3((w3, d3) => {
      var u3 = Te2(), m3 = Object.defineProperty;
      d3.exports = function(c3, x3) {
        try {
          m3(u3, c3, { value: x3, configurable: true, writable: true });
        } catch {
          u3[c3] = x3;
        }
        return x3;
      };
    }), $t2 = k3((w3, d3) => {
      var u3 = Te2(), m3 = Ht2(), c3 = "__core-js_shared__", x3 = u3[c3] || m3(c3, {});
      d3.exports = x3;
    }), Is2 = k3((w3, d3) => {
      var u3 = hi2(), m3 = $t2();
      (d3.exports = function(c3, x3) {
        return m3[c3] || (m3[c3] = x3 !== void 0 ? x3 : {});
      })("versions", []).push({ version: "3.26.1", mode: u3 ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE", source: "https://github.com/zloirock/core-js" });
    }), Ns2 = k3((w3, d3) => {
      var u3 = Es2(), m3 = Object;
      d3.exports = function(c3) {
        return m3(u3(c3));
      };
    }), Ue2 = k3((w3, d3) => {
      var u3 = Ce2(), m3 = Ns2(), c3 = u3({}.hasOwnProperty);
      d3.exports = Object.hasOwn || function(x3, b3) {
        return c3(m3(x3), b3);
      };
    }), ks2 = k3((w3, d3) => {
      var u3 = Ce2(), m3 = 0, c3 = Math.random(), x3 = u3(1 .toString);
      d3.exports = function(b3) {
        return "Symbol(" + (b3 === void 0 ? "" : b3) + ")_" + x3(++m3 + c3, 36);
      };
    }), mt2 = k3((w3, d3) => {
      var u3 = Te2(), m3 = Is2(), c3 = Ue2(), x3 = ks2(), b3 = vs2(), P3 = Ss2(), D3 = m3("wks"), v3 = u3.Symbol, M3 = v3 && v3.for, S3 = P3 ? v3 : v3 && v3.withoutSetter || x3;
      d3.exports = function(U3) {
        if (!c3(D3, U3) || !(b3 || typeof D3[U3] == "string")) {
          var _3 = "Symbol." + U3;
          b3 && c3(v3, U3) ? D3[U3] = v3[U3] : P3 && M3 ? D3[U3] = M3(_3) : D3[U3] = S3(_3);
        }
        return D3[U3];
      };
    }), li2 = k3((w3, d3) => {
      var u3 = Ut2(), m3 = qe2(), c3 = ws2(), x3 = ni2(), b3 = oi2(), P3 = mt2(), D3 = TypeError, v3 = P3("toPrimitive");
      d3.exports = function(M3, S3) {
        if (!m3(M3) || c3(M3))
          return M3;
        var U3 = x3(M3, v3), _3;
        if (U3) {
          if (S3 === void 0 && (S3 = "default"), _3 = u3(U3, M3, S3), !m3(_3) || c3(_3))
            return _3;
          throw D3("Can't convert object to primitive value");
        }
        return S3 === void 0 && (S3 = "number"), b3(M3, S3);
      };
    }), Ds2 = k3((w3, d3) => {
      var u3 = li2(), m3 = ws2();
      d3.exports = function(c3) {
        var x3 = u3(c3, "string");
        return m3(x3) ? x3 : x3 + "";
      };
    }), pi2 = k3((w3, d3) => {
      var u3 = Te2(), m3 = qe2(), c3 = u3.document, x3 = m3(c3) && m3(c3.createElement);
      d3.exports = function(b3) {
        return x3 ? c3.createElement(b3) : {};
      };
    }), Fs2 = k3((w3, d3) => {
      var u3 = Le2(), m3 = Ee2(), c3 = pi2();
      d3.exports = !u3 && !m3(function() {
        return Object.defineProperty(c3("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }), Ls2 = k3((w3) => {
      var d3 = Le2(), u3 = Ut2(), m3 = ei2(), c3 = bs2(), x3 = _t2(), b3 = Ds2(), P3 = Ue2(), D3 = Fs2(), v3 = Object.getOwnPropertyDescriptor;
      w3.f = d3 ? v3 : function(M3, S3) {
        if (M3 = x3(M3), S3 = b3(S3), D3)
          try {
            return v3(M3, S3);
          } catch {
          }
        if (P3(M3, S3))
          return c3(!u3(m3.f, M3, S3), M3[S3]);
      };
    }), ui2 = k3((w3, d3) => {
      var u3 = Le2(), m3 = Ee2();
      d3.exports = u3 && m3(function() {
        return Object.defineProperty(function() {
        }, "prototype", { value: 42, writable: false }).prototype != 42;
      });
    }), Vt2 = k3((w3, d3) => {
      var u3 = qe2(), m3 = String, c3 = TypeError;
      d3.exports = function(x3) {
        if (u3(x3))
          return x3;
        throw c3(m3(x3) + " is not an object");
      };
    }), ft2 = k3((w3) => {
      var d3 = Le2(), u3 = Fs2(), m3 = ui2(), c3 = Vt2(), x3 = Ds2(), b3 = TypeError, P3 = Object.defineProperty, D3 = Object.getOwnPropertyDescriptor, v3 = "enumerable", M3 = "configurable", S3 = "writable";
      w3.f = d3 ? m3 ? function(U3, _3, J3) {
        if (c3(U3), _3 = x3(_3), c3(J3), typeof U3 == "function" && _3 === "prototype" && "value" in J3 && S3 in J3 && !J3[S3]) {
          var K3 = D3(U3, _3);
          K3 && K3[S3] && (U3[_3] = J3.value, J3 = { configurable: M3 in J3 ? J3[M3] : K3[M3], enumerable: v3 in J3 ? J3[v3] : K3[v3], writable: false });
        }
        return P3(U3, _3, J3);
      } : P3 : function(U3, _3, J3) {
        if (c3(U3), _3 = x3(_3), c3(J3), u3)
          try {
            return P3(U3, _3, J3);
          } catch {
          }
        if ("get" in J3 || "set" in J3)
          throw b3("Accessors not supported");
        return "value" in J3 && (U3[_3] = J3.value), U3;
      };
    }), Bs2 = k3((w3, d3) => {
      var u3 = Le2(), m3 = ft2(), c3 = bs2();
      d3.exports = u3 ? function(x3, b3, P3) {
        return m3.f(x3, b3, c3(1, P3));
      } : function(x3, b3, P3) {
        return x3[b3] = P3, x3;
      };
    }), ci2 = k3((w3, d3) => {
      var u3 = Le2(), m3 = Ue2(), c3 = Function.prototype, x3 = u3 && Object.getOwnPropertyDescriptor, b3 = m3(c3, "name"), P3 = b3 && function() {
      }.name === "something", D3 = b3 && (!u3 || u3 && x3(c3, "name").configurable);
      d3.exports = { EXISTS: b3, PROPER: P3, CONFIGURABLE: D3 };
    }), Ms2 = k3((w3, d3) => {
      var u3 = Ce2(), m3 = Pe2(), c3 = $t2(), x3 = u3(Function.toString);
      m3(c3.inspectSource) || (c3.inspectSource = function(b3) {
        return x3(b3);
      }), d3.exports = c3.inspectSource;
    }), di2 = k3((w3, d3) => {
      var u3 = Te2(), m3 = Pe2(), c3 = u3.WeakMap;
      d3.exports = m3(c3) && /native code/.test(String(c3));
    }), mi2 = k3((w3, d3) => {
      var u3 = Is2(), m3 = ks2(), c3 = u3("keys");
      d3.exports = function(x3) {
        return c3[x3] || (c3[x3] = m3(x3));
      };
    }), Os2 = k3((w3, d3) => {
      d3.exports = {};
    }), fi2 = k3((w3, d3) => {
      var u3 = di2(), m3 = Te2(), c3 = qe2(), x3 = Bs2(), b3 = Ue2(), P3 = $t2(), D3 = mi2(), v3 = Os2(), M3 = "Object already initialized", S3 = m3.TypeError, U3 = m3.WeakMap, _3, J3, K3, q3 = function(ne2) {
        return K3(ne2) ? J3(ne2) : _3(ne2, {});
      }, ie2 = function(ne2) {
        return function(ye2) {
          var st2;
          if (!c3(ye2) || (st2 = J3(ye2)).type !== ne2)
            throw S3("Incompatible receiver, " + ne2 + " required");
          return st2;
        };
      };
      u3 || P3.state ? (ae2 = P3.state || (P3.state = new U3()), ae2.get = ae2.get, ae2.has = ae2.has, ae2.set = ae2.set, _3 = function(ne2, ye2) {
        if (ae2.has(ne2))
          throw S3(M3);
        return ye2.facade = ne2, ae2.set(ne2, ye2), ye2;
      }, J3 = function(ne2) {
        return ae2.get(ne2) || {};
      }, K3 = function(ne2) {
        return ae2.has(ne2);
      }) : (ue2 = D3("state"), v3[ue2] = true, _3 = function(ne2, ye2) {
        if (b3(ne2, ue2))
          throw S3(M3);
        return ye2.facade = ne2, x3(ne2, ue2, ye2), ye2;
      }, J3 = function(ne2) {
        return b3(ne2, ue2) ? ne2[ue2] : {};
      }, K3 = function(ne2) {
        return b3(ne2, ue2);
      });
      var ae2, ue2;
      d3.exports = { set: _3, get: J3, has: K3, enforce: q3, getterFor: ie2 };
    }), js2 = k3((w3, d3) => {
      var u3 = Ee2(), m3 = Pe2(), c3 = Ue2(), x3 = Le2(), b3 = ci2().CONFIGURABLE, P3 = Ms2(), D3 = fi2(), v3 = D3.enforce, M3 = D3.get, S3 = Object.defineProperty, U3 = x3 && !u3(function() {
        return S3(function() {
        }, "length", { value: 8 }).length !== 8;
      }), _3 = String(String).split("String"), J3 = d3.exports = function(K3, q3, ie2) {
        String(q3).slice(0, 7) === "Symbol(" && (q3 = "[" + String(q3).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), ie2 && ie2.getter && (q3 = "get " + q3), ie2 && ie2.setter && (q3 = "set " + q3), (!c3(K3, "name") || b3 && K3.name !== q3) && (x3 ? S3(K3, "name", { value: q3, configurable: true }) : K3.name = q3), U3 && ie2 && c3(ie2, "arity") && K3.length !== ie2.arity && S3(K3, "length", { value: ie2.arity });
        try {
          ie2 && c3(ie2, "constructor") && ie2.constructor ? x3 && S3(K3, "prototype", { writable: false }) : K3.prototype && (K3.prototype = void 0);
        } catch {
        }
        var ae2 = v3(K3);
        return c3(ae2, "source") || (ae2.source = _3.join(typeof q3 == "string" ? q3 : "")), K3;
      };
      Function.prototype.toString = J3(function() {
        return m3(this) && M3(this).source || P3(this);
      }, "toString");
    }), yi2 = k3((w3, d3) => {
      var u3 = Pe2(), m3 = ft2(), c3 = js2(), x3 = Ht2();
      d3.exports = function(b3, P3, D3, v3) {
        v3 || (v3 = {});
        var M3 = v3.enumerable, S3 = v3.name !== void 0 ? v3.name : P3;
        if (u3(D3) && c3(D3, S3, v3), v3.global)
          M3 ? b3[P3] = D3 : x3(P3, D3);
        else {
          try {
            v3.unsafe ? b3[P3] && (M3 = true) : delete b3[P3];
          } catch {
          }
          M3 ? b3[P3] = D3 : m3.f(b3, P3, { value: D3, enumerable: false, configurable: !v3.nonConfigurable, writable: !v3.nonWritable });
        }
        return b3;
      };
    }), xi2 = k3((w3, d3) => {
      var u3 = Math.ceil, m3 = Math.floor;
      d3.exports = Math.trunc || function(c3) {
        var x3 = +c3;
        return (x3 > 0 ? m3 : u3)(x3);
      };
    }), Rs2 = k3((w3, d3) => {
      var u3 = xi2();
      d3.exports = function(m3) {
        var c3 = +m3;
        return c3 !== c3 || c3 === 0 ? 0 : u3(c3);
      };
    }), gi2 = k3((w3, d3) => {
      var u3 = Rs2(), m3 = Math.max, c3 = Math.min;
      d3.exports = function(x3, b3) {
        var P3 = u3(x3);
        return P3 < 0 ? m3(P3 + b3, 0) : c3(P3, b3);
      };
    }), Pi2 = k3((w3, d3) => {
      var u3 = Rs2(), m3 = Math.min;
      d3.exports = function(c3) {
        return c3 > 0 ? m3(u3(c3), 9007199254740991) : 0;
      };
    }), qt2 = k3((w3, d3) => {
      var u3 = Pi2();
      d3.exports = function(m3) {
        return u3(m3.length);
      };
    }), Ai2 = k3((w3, d3) => {
      var u3 = _t2(), m3 = gi2(), c3 = qt2(), x3 = function(b3) {
        return function(P3, D3, v3) {
          var M3 = u3(P3), S3 = c3(M3), U3 = m3(v3, S3), _3;
          if (b3 && D3 != D3) {
            for (; S3 > U3; )
              if (_3 = M3[U3++], _3 != _3)
                return true;
          } else
            for (; S3 > U3; U3++)
              if ((b3 || U3 in M3) && M3[U3] === D3)
                return b3 || U3 || 0;
          return !b3 && -1;
        };
      };
      d3.exports = { includes: x3(true), indexOf: x3(false) };
    }), bi2 = k3((w3, d3) => {
      var u3 = Ce2(), m3 = Ue2(), c3 = _t2(), x3 = Ai2().indexOf, b3 = Os2(), P3 = u3([].push);
      d3.exports = function(D3, v3) {
        var M3 = c3(D3), S3 = 0, U3 = [], _3;
        for (_3 in M3)
          !m3(b3, _3) && m3(M3, _3) && P3(U3, _3);
        for (; v3.length > S3; )
          m3(M3, _3 = v3[S3++]) && (~x3(U3, _3) || P3(U3, _3));
        return U3;
      };
    }), Ti2 = k3((w3, d3) => {
      d3.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    }), Ei2 = k3((w3) => {
      var d3 = bi2(), u3 = Ti2(), m3 = u3.concat("length", "prototype");
      w3.f = Object.getOwnPropertyNames || function(c3) {
        return d3(c3, m3);
      };
    }), Ci2 = k3((w3) => {
      w3.f = Object.getOwnPropertySymbols;
    }), vi2 = k3((w3, d3) => {
      var u3 = dt2(), m3 = Ce2(), c3 = Ei2(), x3 = Ci2(), b3 = Vt2(), P3 = m3([].concat);
      d3.exports = u3("Reflect", "ownKeys") || function(D3) {
        var v3 = c3.f(b3(D3)), M3 = x3.f;
        return M3 ? P3(v3, M3(D3)) : v3;
      };
    }), Si2 = k3((w3, d3) => {
      var u3 = Ue2(), m3 = vi2(), c3 = Ls2(), x3 = ft2();
      d3.exports = function(b3, P3, D3) {
        for (var v3 = m3(P3), M3 = x3.f, S3 = c3.f, U3 = 0; U3 < v3.length; U3++) {
          var _3 = v3[U3];
          !u3(b3, _3) && !(D3 && u3(D3, _3)) && M3(b3, _3, S3(P3, _3));
        }
      };
    }), wi2 = k3((w3, d3) => {
      var u3 = Ee2(), m3 = Pe2(), c3 = /#|\.prototype\./, x3 = function(M3, S3) {
        var U3 = P3[b3(M3)];
        return U3 == v3 ? true : U3 == D3 ? false : m3(S3) ? u3(S3) : !!S3;
      }, b3 = x3.normalize = function(M3) {
        return String(M3).replace(c3, ".").toLowerCase();
      }, P3 = x3.data = {}, D3 = x3.NATIVE = "N", v3 = x3.POLYFILL = "P";
      d3.exports = x3;
    }), Us2 = k3((w3, d3) => {
      var u3 = Te2(), m3 = Ls2().f, c3 = Bs2(), x3 = yi2(), b3 = Ht2(), P3 = Si2(), D3 = wi2();
      d3.exports = function(v3, M3) {
        var S3 = v3.target, U3 = v3.global, _3 = v3.stat, J3, K3, q3, ie2, ae2, ue2;
        if (U3 ? K3 = u3 : _3 ? K3 = u3[S3] || b3(S3, {}) : K3 = (u3[S3] || {}).prototype, K3)
          for (q3 in M3) {
            if (ae2 = M3[q3], v3.dontCallGetSet ? (ue2 = m3(K3, q3), ie2 = ue2 && ue2.value) : ie2 = K3[q3], J3 = D3(U3 ? q3 : S3 + (_3 ? "." : "#") + q3, v3.forced), !J3 && ie2 !== void 0) {
              if (typeof ae2 == typeof ie2)
                continue;
              P3(ae2, ie2);
            }
            (v3.sham || ie2 && ie2.sham) && c3(ae2, "sham", true), x3(K3, q3, ae2, v3);
          }
      };
    }), Ii2 = k3(() => {
      var w3 = Us2(), d3 = Te2();
      w3({ global: true, forced: d3.globalThis !== d3 }, { globalThis: d3 });
    }), Ni2 = k3(() => {
      Ii2();
    }), ki2 = k3((w3, d3) => {
      var u3 = js2(), m3 = ft2();
      d3.exports = function(c3, x3, b3) {
        return b3.get && u3(b3.get, x3, { getter: true }), b3.set && u3(b3.set, x3, { setter: true }), m3.f(c3, x3, b3);
      };
    }), Di2 = k3((w3, d3) => {
      var u3 = Vt2();
      d3.exports = function() {
        var m3 = u3(this), c3 = "";
        return m3.hasIndices && (c3 += "d"), m3.global && (c3 += "g"), m3.ignoreCase && (c3 += "i"), m3.multiline && (c3 += "m"), m3.dotAll && (c3 += "s"), m3.unicode && (c3 += "u"), m3.unicodeSets && (c3 += "v"), m3.sticky && (c3 += "y"), c3;
      };
    }), Fi2 = k3(() => {
      var w3 = Te2(), d3 = Le2(), u3 = ki2(), m3 = Di2(), c3 = Ee2(), x3 = w3.RegExp, b3 = x3.prototype, P3 = d3 && c3(function() {
        var D3 = true;
        try {
          x3(".", "d");
        } catch {
          D3 = false;
        }
        var v3 = {}, M3 = "", S3 = D3 ? "dgimsy" : "gimsy", U3 = function(q3, ie2) {
          Object.defineProperty(v3, q3, { get: function() {
            return M3 += ie2, true;
          } });
        }, _3 = { dotAll: "s", global: "g", ignoreCase: "i", multiline: "m", sticky: "y" };
        D3 && (_3.hasIndices = "d");
        for (var J3 in _3)
          U3(J3, _3[J3]);
        var K3 = Object.getOwnPropertyDescriptor(b3, "flags").get.call(v3);
        return K3 !== S3 || M3 !== S3;
      });
      P3 && u3(b3, "flags", { configurable: true, get: m3 });
    }), _s2 = k3((w3, d3) => {
      var u3 = ct2();
      d3.exports = Array.isArray || function(m3) {
        return u3(m3) == "Array";
      };
    }), Li2 = k3((w3, d3) => {
      var u3 = TypeError, m3 = 9007199254740991;
      d3.exports = function(c3) {
        if (c3 > m3)
          throw u3("Maximum allowed index exceeded");
        return c3;
      };
    }), Bi2 = k3((w3, d3) => {
      var u3 = ct2(), m3 = Ce2();
      d3.exports = function(c3) {
        if (u3(c3) === "Function")
          return m3(c3);
      };
    }), Mi2 = k3((w3, d3) => {
      var u3 = Bi2(), m3 = zt2(), c3 = Rt2(), x3 = u3(u3.bind);
      d3.exports = function(b3, P3) {
        return m3(b3), P3 === void 0 ? b3 : c3 ? x3(b3, P3) : function() {
          return b3.apply(P3, arguments);
        };
      };
    }), Oi2 = k3((w3, d3) => {
      var u3 = _s2(), m3 = qt2(), c3 = Li2(), x3 = Mi2(), b3 = function(P3, D3, v3, M3, S3, U3, _3, J3) {
        for (var K3 = S3, q3 = 0, ie2 = _3 ? x3(_3, J3) : false, ae2, ue2; q3 < M3; )
          q3 in v3 && (ae2 = ie2 ? ie2(v3[q3], q3, D3) : v3[q3], U3 > 0 && u3(ae2) ? (ue2 = m3(ae2), K3 = b3(P3, D3, ae2, ue2, K3, U3 - 1) - 1) : (c3(K3 + 1), P3[K3] = ae2), K3++), q3++;
        return K3;
      };
      d3.exports = b3;
    }), ji2 = k3((w3, d3) => {
      var u3 = mt2(), m3 = u3("toStringTag"), c3 = {};
      c3[m3] = "z", d3.exports = String(c3) === "[object z]";
    }), Ri2 = k3((w3, d3) => {
      var u3 = ji2(), m3 = Pe2(), c3 = ct2(), x3 = mt2(), b3 = x3("toStringTag"), P3 = Object, D3 = c3(function() {
        return arguments;
      }()) == "Arguments", v3 = function(M3, S3) {
        try {
          return M3[S3];
        } catch {
        }
      };
      d3.exports = u3 ? c3 : function(M3) {
        var S3, U3, _3;
        return M3 === void 0 ? "Undefined" : M3 === null ? "Null" : typeof (U3 = v3(S3 = P3(M3), b3)) == "string" ? U3 : D3 ? c3(S3) : (_3 = c3(S3)) == "Object" && m3(S3.callee) ? "Arguments" : _3;
      };
    }), Ui2 = k3((w3, d3) => {
      var u3 = Ce2(), m3 = Ee2(), c3 = Pe2(), x3 = Ri2(), b3 = dt2(), P3 = Ms2(), D3 = function() {
      }, v3 = [], M3 = b3("Reflect", "construct"), S3 = /^\s*(?:class|function)\b/, U3 = u3(S3.exec), _3 = !S3.exec(D3), J3 = function(q3) {
        if (!c3(q3))
          return false;
        try {
          return M3(D3, v3, q3), true;
        } catch {
          return false;
        }
      }, K3 = function(q3) {
        if (!c3(q3))
          return false;
        switch (x3(q3)) {
          case "AsyncFunction":
          case "GeneratorFunction":
          case "AsyncGeneratorFunction":
            return false;
        }
        try {
          return _3 || !!U3(S3, P3(q3));
        } catch {
          return true;
        }
      };
      K3.sham = true, d3.exports = !M3 || m3(function() {
        var q3;
        return J3(J3.call) || !J3(Object) || !J3(function() {
          q3 = true;
        }) || q3;
      }) ? K3 : J3;
    }), _i2 = k3((w3, d3) => {
      var u3 = _s2(), m3 = Ui2(), c3 = qe2(), x3 = mt2(), b3 = x3("species"), P3 = Array;
      d3.exports = function(D3) {
        var v3;
        return u3(D3) && (v3 = D3.constructor, m3(v3) && (v3 === P3 || u3(v3.prototype)) ? v3 = void 0 : c3(v3) && (v3 = v3[b3], v3 === null && (v3 = void 0))), v3 === void 0 ? P3 : v3;
      };
    }), zi2 = k3((w3, d3) => {
      var u3 = _i2();
      d3.exports = function(m3, c3) {
        return new (u3(m3))(c3 === 0 ? 0 : c3);
      };
    }), Hi2 = k3(() => {
      var w3 = Us2(), d3 = Oi2(), u3 = zt2(), m3 = Ns2(), c3 = qt2(), x3 = zi2();
      w3({ target: "Array", proto: true }, { flatMap: function(b3) {
        var P3 = m3(this), D3 = c3(P3), v3;
        return u3(b3), v3 = x3(P3, 0), v3.length = d3(v3, P3, P3, D3, 0, 1, b3, arguments.length > 1 ? arguments[1] : void 0), v3;
      } });
    }), $i2 = k3((w3, d3) => {
      Ni2(), Fi2(), Hi2();
      var u3 = Object.defineProperty, m3 = Object.getOwnPropertyDescriptor, c3 = Object.getOwnPropertyNames, x3 = Object.prototype.hasOwnProperty, b3 = (L3, N3) => function() {
        return L3 && (N3 = (0, L3[c3(L3)[0]])(L3 = 0)), N3;
      }, P3 = (L3, N3) => function() {
        return N3 || (0, L3[c3(L3)[0]])((N3 = { exports: {} }).exports, N3), N3.exports;
      }, D3 = (L3, N3) => {
        for (var I3 in N3)
          u3(L3, I3, { get: N3[I3], enumerable: true });
      }, v3 = (L3, N3, I3, A3) => {
        if (N3 && typeof N3 == "object" || typeof N3 == "function")
          for (let g3 of c3(N3))
            !x3.call(L3, g3) && g3 !== I3 && u3(L3, g3, { get: () => N3[g3], enumerable: !(A3 = m3(N3, g3)) || A3.enumerable });
        return L3;
      }, M3 = (L3) => v3(u3({}, "__esModule", { value: true }), L3), S3 = b3({ "<define:process>"() {
      } }), U3 = P3({ "src/utils/try-combinations.js"(L3, N3) {
        S3();
        function I3() {
          let A3;
          for (var g3 = arguments.length, E3 = new Array(g3), y3 = 0; y3 < g3; y3++)
            E3[y3] = arguments[y3];
          for (let [O3, V10] of E3.entries())
            try {
              return { result: V10() };
            } catch (X3) {
              O3 === 0 && (A3 = X3);
            }
          return { error: A3 };
        }
        N3.exports = I3;
      } }), _3 = P3({ "src/language-js/utils/get-shebang.js"(L3, N3) {
        S3();
        function I3(A3) {
          if (!A3.startsWith("#!"))
            return "";
          let g3 = A3.indexOf(`
`);
          return g3 === -1 ? A3 : A3.slice(0, g3);
        }
        N3.exports = I3;
      } }), J3 = P3({ "src/utils/text/skip-inline-comment.js"(L3, N3) {
        S3();
        function I3(A3, g3) {
          if (g3 === false)
            return false;
          if (A3.charAt(g3) === "/" && A3.charAt(g3 + 1) === "*") {
            for (let E3 = g3 + 2; E3 < A3.length; ++E3)
              if (A3.charAt(E3) === "*" && A3.charAt(E3 + 1) === "/")
                return E3 + 2;
          }
          return g3;
        }
        N3.exports = I3;
      } }), K3 = P3({ "src/utils/text/skip-newline.js"(L3, N3) {
        S3();
        function I3(A3, g3, E3) {
          let y3 = E3 && E3.backwards;
          if (g3 === false)
            return false;
          let O3 = A3.charAt(g3);
          if (y3) {
            if (A3.charAt(g3 - 1) === "\r" && O3 === `
`)
              return g3 - 2;
            if (O3 === `
` || O3 === "\r" || O3 === "\u2028" || O3 === "\u2029")
              return g3 - 1;
          } else {
            if (O3 === "\r" && A3.charAt(g3 + 1) === `
`)
              return g3 + 2;
            if (O3 === `
` || O3 === "\r" || O3 === "\u2028" || O3 === "\u2029")
              return g3 + 1;
          }
          return g3;
        }
        N3.exports = I3;
      } }), q3 = P3({ "src/utils/text/skip.js"(L3, N3) {
        S3();
        function I3(O3) {
          return (V10, X3, Q3) => {
            let z3 = Q3 && Q3.backwards;
            if (X3 === false)
              return false;
            let { length: W3 } = V10, C3 = X3;
            for (; C3 >= 0 && C3 < W3; ) {
              let Z3 = V10.charAt(C3);
              if (O3 instanceof RegExp) {
                if (!O3.test(Z3))
                  return C3;
              } else if (!O3.includes(Z3))
                return C3;
              z3 ? C3-- : C3++;
            }
            return C3 === -1 || C3 === W3 ? C3 : false;
          };
        }
        var A3 = I3(/\s/), g3 = I3(" 	"), E3 = I3(",; 	"), y3 = I3(/[^\n\r]/);
        N3.exports = { skipWhitespace: A3, skipSpaces: g3, skipToLineEnd: E3, skipEverythingButNewLine: y3 };
      } }), ie2 = P3({ "src/utils/text/skip-trailing-comment.js"(L3, N3) {
        S3();
        var { skipEverythingButNewLine: I3 } = q3();
        function A3(g3, E3) {
          return E3 === false ? false : g3.charAt(E3) === "/" && g3.charAt(E3 + 1) === "/" ? I3(g3, E3) : E3;
        }
        N3.exports = A3;
      } }), ae2 = P3({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(L3, N3) {
        S3();
        var I3 = J3(), A3 = K3(), g3 = ie2(), { skipSpaces: E3 } = q3();
        function y3(O3, V10) {
          let X3 = null, Q3 = V10;
          for (; Q3 !== X3; )
            X3 = Q3, Q3 = E3(O3, Q3), Q3 = I3(O3, Q3), Q3 = g3(O3, Q3), Q3 = A3(O3, Q3);
          return Q3;
        }
        N3.exports = y3;
      } }), ue2 = {};
      D3(ue2, { EOL: () => Jt2, arch: () => Vi2, cpus: () => Vs2, default: () => Xs2, endianness: () => ne2, freemem: () => Hs2, getNetworkInterfaces: () => Js2, hostname: () => ye2, loadavg: () => st2, networkInterfaces: () => Ws2, platform: () => qi2, release: () => Ks2, tmpDir: () => Kt2, tmpdir: () => Wt2, totalmem: () => $s2, type: () => qs2, uptime: () => zs2 });
      function ne2() {
        if (typeof yt2 > "u") {
          var L3 = new ArrayBuffer(2), N3 = new Uint8Array(L3), I3 = new Uint16Array(L3);
          if (N3[0] = 1, N3[1] = 2, I3[0] === 258)
            yt2 = "BE";
          else if (I3[0] === 513)
            yt2 = "LE";
          else
            throw new Error("unable to figure out endianess");
        }
        return yt2;
      }
      function ye2() {
        return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
      }
      function st2() {
        return [];
      }
      function zs2() {
        return 0;
      }
      function Hs2() {
        return Number.MAX_VALUE;
      }
      function $s2() {
        return Number.MAX_VALUE;
      }
      function Vs2() {
        return [];
      }
      function qs2() {
        return "Browser";
      }
      function Ks2() {
        return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
      }
      function Ws2() {
      }
      function Js2() {
      }
      function Vi2() {
        return "javascript";
      }
      function qi2() {
        return "browser";
      }
      function Kt2() {
        return "/tmp";
      }
      var yt2, Wt2, Jt2, Xs2, Ki2 = b3({ "node-modules-polyfills:os"() {
        S3(), Wt2 = Kt2, Jt2 = `
`, Xs2 = { EOL: Jt2, tmpdir: Wt2, tmpDir: Kt2, networkInterfaces: Ws2, getNetworkInterfaces: Js2, release: Ks2, type: qs2, cpus: Vs2, totalmem: $s2, freemem: Hs2, uptime: zs2, loadavg: st2, hostname: ye2, endianness: ne2 };
      } }), Wi2 = P3({ "node-modules-polyfills-commonjs:os"(L3, N3) {
        S3();
        var I3 = (Ki2(), M3(ue2));
        if (I3 && I3.default) {
          N3.exports = I3.default;
          for (let A3 in I3)
            N3.exports[A3] = I3[A3];
        } else
          I3 && (N3.exports = I3);
      } }), Ji2 = P3({ "node_modules/detect-newline/index.js"(L3, N3) {
        S3();
        var I3 = (A3) => {
          if (typeof A3 != "string")
            throw new TypeError("Expected a string");
          let g3 = A3.match(/(?:\r?\n)/g) || [];
          if (g3.length === 0)
            return;
          let E3 = g3.filter((O3) => O3 === `\r
`).length, y3 = g3.length - E3;
          return E3 > y3 ? `\r
` : `
`;
        };
        N3.exports = I3, N3.exports.graceful = (A3) => typeof A3 == "string" && I3(A3) || `
`;
      } }), Xi2 = P3({ "node_modules/jest-docblock/build/index.js"(L3) {
        S3(), Object.defineProperty(L3, "__esModule", { value: true }), L3.extract = C3, L3.parse = le2, L3.parseWithComments = H3, L3.print = Y3, L3.strip = Z3;
        function N3() {
          let ee2 = Wi2();
          return N3 = function() {
            return ee2;
          }, ee2;
        }
        function I3() {
          let ee2 = A3(Ji2());
          return I3 = function() {
            return ee2;
          }, ee2;
        }
        function A3(ee2) {
          return ee2 && ee2.__esModule ? ee2 : { default: ee2 };
        }
        var g3 = /\*\/$/, E3 = /^\/\*\*?/, y3 = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, O3 = /(^|\s+)\/\/([^\r\n]*)/g, V10 = /^(\r?\n)+/, X3 = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, Q3 = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, z3 = /(\r?\n|^) *\* ?/g, W3 = [];
        function C3(ee2) {
          let pe2 = ee2.match(y3);
          return pe2 ? pe2[0].trimLeft() : "";
        }
        function Z3(ee2) {
          let pe2 = ee2.match(y3);
          return pe2 && pe2[0] ? ee2.substring(pe2[0].length) : ee2;
        }
        function le2(ee2) {
          return H3(ee2).pragmas;
        }
        function H3(ee2) {
          let pe2 = (0, I3().default)(ee2) || N3().EOL;
          ee2 = ee2.replace(E3, "").replace(g3, "").replace(z3, "$1");
          let xe2 = "";
          for (; xe2 !== ee2; )
            xe2 = ee2, ee2 = ee2.replace(X3, `${pe2}$1 $2${pe2}`);
          ee2 = ee2.replace(V10, "").trimRight();
          let F3 = /* @__PURE__ */ Object.create(null), G3 = ee2.replace(Q3, "").replace(V10, "").trimRight(), ge2;
          for (; ge2 = Q3.exec(ee2); ) {
            let te2 = ge2[2].replace(O3, "");
            typeof F3[ge2[1]] == "string" || Array.isArray(F3[ge2[1]]) ? F3[ge2[1]] = W3.concat(F3[ge2[1]], te2) : F3[ge2[1]] = te2;
          }
          return { comments: G3, pragmas: F3 };
        }
        function Y3(ee2) {
          let { comments: pe2 = "", pragmas: xe2 = {} } = ee2, F3 = (0, I3().default)(pe2) || N3().EOL, G3 = "/**", ge2 = " *", te2 = " */", we2 = Object.keys(xe2), Ae2 = we2.map((be2) => he2(be2, xe2[be2])).reduce((be2, rt2) => be2.concat(rt2), []).map((be2) => `${ge2} ${be2}${F3}`).join("");
          if (!pe2) {
            if (we2.length === 0)
              return "";
            if (we2.length === 1 && !Array.isArray(xe2[we2[0]])) {
              let be2 = xe2[we2[0]];
              return `${G3} ${he2(we2[0], be2)[0]}${te2}`;
            }
          }
          let xt2 = pe2.split(F3).map((be2) => `${ge2} ${be2}`).join(F3) + F3;
          return G3 + F3 + (pe2 ? xt2 : "") + (pe2 && we2.length ? ge2 + F3 : "") + Ae2 + te2;
        }
        function he2(ee2, pe2) {
          return W3.concat(pe2).map((xe2) => `@${ee2} ${xe2}`.trim());
        }
      } }), Gi2 = P3({ "src/common/end-of-line.js"(L3, N3) {
        S3();
        function I3(y3) {
          let O3 = y3.indexOf("\r");
          return O3 >= 0 ? y3.charAt(O3 + 1) === `
` ? "crlf" : "cr" : "lf";
        }
        function A3(y3) {
          switch (y3) {
            case "cr":
              return "\r";
            case "crlf":
              return `\r
`;
            default:
              return `
`;
          }
        }
        function g3(y3, O3) {
          let V10;
          switch (O3) {
            case `
`:
              V10 = /\n/g;
              break;
            case "\r":
              V10 = /\r/g;
              break;
            case `\r
`:
              V10 = /\r\n/g;
              break;
            default:
              throw new Error(`Unexpected "eol" ${JSON.stringify(O3)}.`);
          }
          let X3 = y3.match(V10);
          return X3 ? X3.length : 0;
        }
        function E3(y3) {
          return y3.replace(/\r\n?/g, `
`);
        }
        N3.exports = { guessEndOfLine: I3, convertEndOfLineToChars: A3, countEndOfLineChars: g3, normalizeEndOfLine: E3 };
      } }), Yi2 = P3({ "src/language-js/pragma.js"(L3, N3) {
        S3();
        var { parseWithComments: I3, strip: A3, extract: g3, print: E3 } = Xi2(), { normalizeEndOfLine: y3 } = Gi2(), O3 = _3();
        function V10(z3) {
          let W3 = O3(z3);
          W3 && (z3 = z3.slice(W3.length + 1));
          let C3 = g3(z3), { pragmas: Z3, comments: le2 } = I3(C3);
          return { shebang: W3, text: z3, pragmas: Z3, comments: le2 };
        }
        function X3(z3) {
          let W3 = Object.keys(V10(z3).pragmas);
          return W3.includes("prettier") || W3.includes("format");
        }
        function Q3(z3) {
          let { shebang: W3, text: C3, pragmas: Z3, comments: le2 } = V10(z3), H3 = A3(C3), Y3 = E3({ pragmas: Object.assign({ format: "" }, Z3), comments: le2.trimStart() });
          return (W3 ? `${W3}
` : "") + y3(Y3) + (H3.startsWith(`
`) ? `
` : `

`) + H3;
        }
        N3.exports = { hasPragma: X3, insertPragma: Q3 };
      } }), Gs2 = P3({ "src/utils/is-non-empty-array.js"(L3, N3) {
        S3();
        function I3(A3) {
          return Array.isArray(A3) && A3.length > 0;
        }
        N3.exports = I3;
      } }), Ys2 = P3({ "src/language-js/loc.js"(L3, N3) {
        S3();
        var I3 = Gs2();
        function A3(V10) {
          var X3, Q3;
          let z3 = V10.range ? V10.range[0] : V10.start, W3 = (X3 = (Q3 = V10.declaration) === null || Q3 === void 0 ? void 0 : Q3.decorators) !== null && X3 !== void 0 ? X3 : V10.decorators;
          return I3(W3) ? Math.min(A3(W3[0]), z3) : z3;
        }
        function g3(V10) {
          return V10.range ? V10.range[1] : V10.end;
        }
        function E3(V10, X3) {
          let Q3 = A3(V10);
          return Number.isInteger(Q3) && Q3 === A3(X3);
        }
        function y3(V10, X3) {
          let Q3 = g3(V10);
          return Number.isInteger(Q3) && Q3 === g3(X3);
        }
        function O3(V10, X3) {
          return E3(V10, X3) && y3(V10, X3);
        }
        N3.exports = { locStart: A3, locEnd: g3, hasSameLocStart: E3, hasSameLoc: O3 };
      } }), Qs2 = P3({ "src/language-js/parse/utils/create-parser.js"(L3, N3) {
        S3();
        var { hasPragma: I3 } = Yi2(), { locStart: A3, locEnd: g3 } = Ys2();
        function E3(y3) {
          return y3 = typeof y3 == "function" ? { parse: y3 } : y3, Object.assign({ astFormat: "estree", hasPragma: I3, locStart: A3, locEnd: g3 }, y3);
        }
        N3.exports = E3;
      } }), Xt2 = P3({ "src/common/parser-create-error.js"(L3, N3) {
        S3();
        function I3(A3, g3) {
          let E3 = new SyntaxError(A3 + " (" + g3.start.line + ":" + g3.start.column + ")");
          return E3.loc = g3, E3;
        }
        N3.exports = I3;
      } }), Zs2 = P3({ "src/language-js/parse/utils/create-babel-parse-error.js"(L3, N3) {
        S3();
        var I3 = Xt2();
        function A3(g3) {
          let { message: E3, loc: y3 } = g3;
          return I3(E3.replace(/ \(.*\)/, ""), { start: { line: y3 ? y3.line : 0, column: y3 ? y3.column + 1 : 0 } });
        }
        N3.exports = A3;
      } }), Qi2 = P3({ "src/language-js/utils/is-ts-keyword-type.js"(L3, N3) {
        S3();
        function I3(A3) {
          let { type: g3 } = A3;
          return g3.startsWith("TS") && g3.endsWith("Keyword");
        }
        N3.exports = I3;
      } }), Zi2 = P3({ "src/language-js/utils/is-block-comment.js"(L3, N3) {
        S3();
        var I3 = /* @__PURE__ */ new Set(["Block", "CommentBlock", "MultiLine"]), A3 = (g3) => I3.has(g3 == null ? void 0 : g3.type);
        N3.exports = A3;
      } }), ea2 = P3({ "src/language-js/utils/is-type-cast-comment.js"(L3, N3) {
        S3();
        var I3 = Zi2();
        function A3(g3) {
          return I3(g3) && g3.value[0] === "*" && /@(?:type|satisfies)\b/.test(g3.value);
        }
        N3.exports = A3;
      } }), ta2 = P3({ "src/utils/get-last.js"(L3, N3) {
        S3();
        var I3 = (A3) => A3[A3.length - 1];
        N3.exports = I3;
      } }), sa2 = P3({ "src/language-js/parse/postprocess/visit-node.js"(L3, N3) {
        S3();
        function I3(A3, g3) {
          if (Array.isArray(A3)) {
            for (let E3 = 0; E3 < A3.length; E3++)
              A3[E3] = I3(A3[E3], g3);
            return A3;
          }
          if (A3 && typeof A3 == "object" && typeof A3.type == "string") {
            let E3 = Object.keys(A3);
            for (let y3 = 0; y3 < E3.length; y3++)
              A3[E3[y3]] = I3(A3[E3[y3]], g3);
            return g3(A3) || A3;
          }
          return A3;
        }
        N3.exports = I3;
      } }), ra2 = P3({ "src/language-js/parse/postprocess/throw-syntax-error.js"(L3, N3) {
        S3();
        var I3 = Xt2();
        function A3(g3, E3) {
          let { start: y3, end: O3 } = g3.loc;
          throw I3(E3, { start: { line: y3.line, column: y3.column + 1 }, end: { line: O3.line, column: O3.column + 1 } });
        }
        N3.exports = A3;
      } }), ia2 = P3({ "src/language-js/parse/postprocess/index.js"(L3, N3) {
        S3();
        var { locStart: I3, locEnd: A3 } = Ys2(), g3 = Qi2(), E3 = ea2(), y3 = ta2(), O3 = sa2(), V10 = ra2();
        function X3(C3, Z3) {
          if (Z3.parser !== "typescript" && Z3.parser !== "flow" && Z3.parser !== "acorn" && Z3.parser !== "espree" && Z3.parser !== "meriyah") {
            let H3 = /* @__PURE__ */ new Set();
            C3 = O3(C3, (Y3) => {
              Y3.leadingComments && Y3.leadingComments.some(E3) && H3.add(I3(Y3));
            }), C3 = O3(C3, (Y3) => {
              if (Y3.type === "ParenthesizedExpression") {
                let { expression: he2 } = Y3;
                if (he2.type === "TypeCastExpression")
                  return he2.range = Y3.range, he2;
                let ee2 = I3(Y3);
                if (!H3.has(ee2))
                  return he2.extra = Object.assign(Object.assign({}, he2.extra), {}, { parenthesized: true }), he2;
              }
            });
          }
          return C3 = O3(C3, (H3) => {
            switch (H3.type) {
              case "ChainExpression":
                return Q3(H3.expression);
              case "LogicalExpression": {
                if (z3(H3))
                  return W3(H3);
                break;
              }
              case "VariableDeclaration": {
                let Y3 = y3(H3.declarations);
                Y3 && Y3.init && le2(H3, Y3);
                break;
              }
              case "TSParenthesizedType":
                return g3(H3.typeAnnotation) || H3.typeAnnotation.type === "TSThisType" || (H3.typeAnnotation.range = [I3(H3), A3(H3)]), H3.typeAnnotation;
              case "TSTypeParameter":
                if (typeof H3.name == "string") {
                  let Y3 = I3(H3);
                  H3.name = { type: "Identifier", name: H3.name, range: [Y3, Y3 + H3.name.length] };
                }
                break;
              case "ObjectExpression":
                if (Z3.parser === "typescript") {
                  let Y3 = H3.properties.find((he2) => he2.type === "Property" && he2.value.type === "TSEmptyBodyFunctionExpression");
                  Y3 && V10(Y3.value, "Unexpected token.");
                }
                break;
              case "SequenceExpression": {
                let Y3 = y3(H3.expressions);
                H3.range = [I3(H3), Math.min(A3(Y3), A3(H3))];
                break;
              }
              case "TopicReference":
                Z3.__isUsingHackPipeline = true;
                break;
              case "ExportAllDeclaration": {
                let { exported: Y3 } = H3;
                if (Z3.parser === "meriyah" && Y3 && Y3.type === "Identifier") {
                  let he2 = Z3.originalText.slice(I3(Y3), A3(Y3));
                  (he2.startsWith('"') || he2.startsWith("'")) && (H3.exported = Object.assign(Object.assign({}, H3.exported), {}, { type: "Literal", value: H3.exported.name, raw: he2 }));
                }
                break;
              }
              case "PropertyDefinition":
                if (Z3.parser === "meriyah" && H3.static && !H3.computed && !H3.key) {
                  let Y3 = "static", he2 = I3(H3);
                  Object.assign(H3, { static: false, key: { type: "Identifier", name: Y3, range: [he2, he2 + Y3.length] } });
                }
                break;
            }
          }), C3;
          function le2(H3, Y3) {
            Z3.originalText[A3(Y3)] !== ";" && (H3.range = [I3(H3), A3(Y3)]);
          }
        }
        function Q3(C3) {
          switch (C3.type) {
            case "CallExpression":
              C3.type = "OptionalCallExpression", C3.callee = Q3(C3.callee);
              break;
            case "MemberExpression":
              C3.type = "OptionalMemberExpression", C3.object = Q3(C3.object);
              break;
            case "TSNonNullExpression":
              C3.expression = Q3(C3.expression);
              break;
          }
          return C3;
        }
        function z3(C3) {
          return C3.type === "LogicalExpression" && C3.right.type === "LogicalExpression" && C3.operator === C3.right.operator;
        }
        function W3(C3) {
          return z3(C3) ? W3({ type: "LogicalExpression", operator: C3.operator, left: W3({ type: "LogicalExpression", operator: C3.operator, left: C3.left, right: C3.right.left, range: [I3(C3.left), A3(C3.right.left)] }), right: C3.right.right, range: [I3(C3), A3(C3)] }) : C3;
        }
        N3.exports = X3;
      } }), er2 = P3({ "node_modules/@babel/parser/lib/index.js"(L3) {
        S3(), Object.defineProperty(L3, "__esModule", { value: true });
        var N3 = { sourceType: "script", sourceFilename: void 0, startColumn: 0, startLine: 1, allowAwaitOutsideFunction: false, allowReturnOutsideFunction: false, allowNewTargetOutsideFunction: false, allowImportExportEverywhere: false, allowSuperOutsideMethod: false, allowUndeclaredExports: false, plugins: [], strictMode: null, ranges: false, tokens: false, createParenthesizedExpressions: false, errorRecovery: false, attachComment: true, annexB: true };
        function I3(t3) {
          if (t3 && t3.annexB != null && t3.annexB !== false)
            throw new Error("The `annexB` option can only be set to `false`.");
          let e28 = {};
          for (let s3 of Object.keys(N3))
            e28[s3] = t3 && t3[s3] != null ? t3[s3] : N3[s3];
          return e28;
        }
        var A3 = class {
          constructor(t3, e28) {
            this.token = void 0, this.preserveSpace = void 0, this.token = t3, this.preserveSpace = !!e28;
          }
        }, g3 = { brace: new A3("{"), j_oTag: new A3("<tag"), j_cTag: new A3("</tag"), j_expr: new A3("<tag>...</tag>", true) };
        g3.template = new A3("`", true);
        var E3 = true, y3 = true, O3 = true, V10 = true, X3 = true, Q3 = true, z3 = class {
          constructor(t3) {
            let e28 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            this.label = void 0, this.keyword = void 0, this.beforeExpr = void 0, this.startsExpr = void 0, this.rightAssociative = void 0, this.isLoop = void 0, this.isAssign = void 0, this.prefix = void 0, this.postfix = void 0, this.binop = void 0, this.label = t3, this.keyword = e28.keyword, this.beforeExpr = !!e28.beforeExpr, this.startsExpr = !!e28.startsExpr, this.rightAssociative = !!e28.rightAssociative, this.isLoop = !!e28.isLoop, this.isAssign = !!e28.isAssign, this.prefix = !!e28.prefix, this.postfix = !!e28.postfix, this.binop = e28.binop != null ? e28.binop : null, this.updateContext = null;
          }
        }, W3 = /* @__PURE__ */ new Map();
        function C3(t3) {
          let e28 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          e28.keyword = t3;
          let s3 = F3(t3, e28);
          return W3.set(t3, s3), s3;
        }
        function Z3(t3, e28) {
          return F3(t3, { beforeExpr: E3, binop: e28 });
        }
        var le2 = -1, H3 = [], Y3 = [], he2 = [], ee2 = [], pe2 = [], xe2 = [];
        function F3(t3) {
          let e28 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          var s3, r3, i, a3;
          return ++le2, Y3.push(t3), he2.push((s3 = e28.binop) != null ? s3 : -1), ee2.push((r3 = e28.beforeExpr) != null ? r3 : false), pe2.push((i = e28.startsExpr) != null ? i : false), xe2.push((a3 = e28.prefix) != null ? a3 : false), H3.push(new z3(t3, e28)), le2;
        }
        function G3(t3) {
          let e28 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          var s3, r3, i, a3;
          return ++le2, W3.set(t3, le2), Y3.push(t3), he2.push((s3 = e28.binop) != null ? s3 : -1), ee2.push((r3 = e28.beforeExpr) != null ? r3 : false), pe2.push((i = e28.startsExpr) != null ? i : false), xe2.push((a3 = e28.prefix) != null ? a3 : false), H3.push(new z3("name", e28)), le2;
        }
        var ge2 = { bracketL: F3("[", { beforeExpr: E3, startsExpr: y3 }), bracketHashL: F3("#[", { beforeExpr: E3, startsExpr: y3 }), bracketBarL: F3("[|", { beforeExpr: E3, startsExpr: y3 }), bracketR: F3("]"), bracketBarR: F3("|]"), braceL: F3("{", { beforeExpr: E3, startsExpr: y3 }), braceBarL: F3("{|", { beforeExpr: E3, startsExpr: y3 }), braceHashL: F3("#{", { beforeExpr: E3, startsExpr: y3 }), braceR: F3("}"), braceBarR: F3("|}"), parenL: F3("(", { beforeExpr: E3, startsExpr: y3 }), parenR: F3(")"), comma: F3(",", { beforeExpr: E3 }), semi: F3(";", { beforeExpr: E3 }), colon: F3(":", { beforeExpr: E3 }), doubleColon: F3("::", { beforeExpr: E3 }), dot: F3("."), question: F3("?", { beforeExpr: E3 }), questionDot: F3("?."), arrow: F3("=>", { beforeExpr: E3 }), template: F3("template"), ellipsis: F3("...", { beforeExpr: E3 }), backQuote: F3("`", { startsExpr: y3 }), dollarBraceL: F3("${", { beforeExpr: E3, startsExpr: y3 }), templateTail: F3("...`", { startsExpr: y3 }), templateNonTail: F3("...${", { beforeExpr: E3, startsExpr: y3 }), at: F3("@"), hash: F3("#", { startsExpr: y3 }), interpreterDirective: F3("#!..."), eq: F3("=", { beforeExpr: E3, isAssign: V10 }), assign: F3("_=", { beforeExpr: E3, isAssign: V10 }), slashAssign: F3("_=", { beforeExpr: E3, isAssign: V10 }), xorAssign: F3("_=", { beforeExpr: E3, isAssign: V10 }), moduloAssign: F3("_=", { beforeExpr: E3, isAssign: V10 }), incDec: F3("++/--", { prefix: X3, postfix: Q3, startsExpr: y3 }), bang: F3("!", { beforeExpr: E3, prefix: X3, startsExpr: y3 }), tilde: F3("~", { beforeExpr: E3, prefix: X3, startsExpr: y3 }), doubleCaret: F3("^^", { startsExpr: y3 }), doubleAt: F3("@@", { startsExpr: y3 }), pipeline: Z3("|>", 0), nullishCoalescing: Z3("??", 1), logicalOR: Z3("||", 1), logicalAND: Z3("&&", 2), bitwiseOR: Z3("|", 3), bitwiseXOR: Z3("^", 4), bitwiseAND: Z3("&", 5), equality: Z3("==/!=/===/!==", 6), lt: Z3("</>/<=/>=", 7), gt: Z3("</>/<=/>=", 7), relational: Z3("</>/<=/>=", 7), bitShift: Z3("<</>>/>>>", 8), bitShiftL: Z3("<</>>/>>>", 8), bitShiftR: Z3("<</>>/>>>", 8), plusMin: F3("+/-", { beforeExpr: E3, binop: 9, prefix: X3, startsExpr: y3 }), modulo: F3("%", { binop: 10, startsExpr: y3 }), star: F3("*", { binop: 10 }), slash: Z3("/", 10), exponent: F3("**", { beforeExpr: E3, binop: 11, rightAssociative: true }), _in: C3("in", { beforeExpr: E3, binop: 7 }), _instanceof: C3("instanceof", { beforeExpr: E3, binop: 7 }), _break: C3("break"), _case: C3("case", { beforeExpr: E3 }), _catch: C3("catch"), _continue: C3("continue"), _debugger: C3("debugger"), _default: C3("default", { beforeExpr: E3 }), _else: C3("else", { beforeExpr: E3 }), _finally: C3("finally"), _function: C3("function", { startsExpr: y3 }), _if: C3("if"), _return: C3("return", { beforeExpr: E3 }), _switch: C3("switch"), _throw: C3("throw", { beforeExpr: E3, prefix: X3, startsExpr: y3 }), _try: C3("try"), _var: C3("var"), _const: C3("const"), _with: C3("with"), _new: C3("new", { beforeExpr: E3, startsExpr: y3 }), _this: C3("this", { startsExpr: y3 }), _super: C3("super", { startsExpr: y3 }), _class: C3("class", { startsExpr: y3 }), _extends: C3("extends", { beforeExpr: E3 }), _export: C3("export"), _import: C3("import", { startsExpr: y3 }), _null: C3("null", { startsExpr: y3 }), _true: C3("true", { startsExpr: y3 }), _false: C3("false", { startsExpr: y3 }), _typeof: C3("typeof", { beforeExpr: E3, prefix: X3, startsExpr: y3 }), _void: C3("void", { beforeExpr: E3, prefix: X3, startsExpr: y3 }), _delete: C3("delete", { beforeExpr: E3, prefix: X3, startsExpr: y3 }), _do: C3("do", { isLoop: O3, beforeExpr: E3 }), _for: C3("for", { isLoop: O3 }), _while: C3("while", { isLoop: O3 }), _as: G3("as", { startsExpr: y3 }), _assert: G3("assert", { startsExpr: y3 }), _async: G3("async", { startsExpr: y3 }), _await: G3("await", { startsExpr: y3 }), _from: G3("from", { startsExpr: y3 }), _get: G3("get", { startsExpr: y3 }), _let: G3("let", { startsExpr: y3 }), _meta: G3("meta", { startsExpr: y3 }), _of: G3("of", { startsExpr: y3 }), _sent: G3("sent", { startsExpr: y3 }), _set: G3("set", { startsExpr: y3 }), _static: G3("static", { startsExpr: y3 }), _using: G3("using", { startsExpr: y3 }), _yield: G3("yield", { startsExpr: y3 }), _asserts: G3("asserts", { startsExpr: y3 }), _checks: G3("checks", { startsExpr: y3 }), _exports: G3("exports", { startsExpr: y3 }), _global: G3("global", { startsExpr: y3 }), _implements: G3("implements", { startsExpr: y3 }), _intrinsic: G3("intrinsic", { startsExpr: y3 }), _infer: G3("infer", { startsExpr: y3 }), _is: G3("is", { startsExpr: y3 }), _mixins: G3("mixins", { startsExpr: y3 }), _proto: G3("proto", { startsExpr: y3 }), _require: G3("require", { startsExpr: y3 }), _satisfies: G3("satisfies", { startsExpr: y3 }), _keyof: G3("keyof", { startsExpr: y3 }), _readonly: G3("readonly", { startsExpr: y3 }), _unique: G3("unique", { startsExpr: y3 }), _abstract: G3("abstract", { startsExpr: y3 }), _declare: G3("declare", { startsExpr: y3 }), _enum: G3("enum", { startsExpr: y3 }), _module: G3("module", { startsExpr: y3 }), _namespace: G3("namespace", { startsExpr: y3 }), _interface: G3("interface", { startsExpr: y3 }), _type: G3("type", { startsExpr: y3 }), _opaque: G3("opaque", { startsExpr: y3 }), name: F3("name", { startsExpr: y3 }), string: F3("string", { startsExpr: y3 }), num: F3("num", { startsExpr: y3 }), bigint: F3("bigint", { startsExpr: y3 }), decimal: F3("decimal", { startsExpr: y3 }), regexp: F3("regexp", { startsExpr: y3 }), privateName: F3("#name", { startsExpr: y3 }), eof: F3("eof"), jsxName: F3("jsxName"), jsxText: F3("jsxText", { beforeExpr: true }), jsxTagStart: F3("jsxTagStart", { startsExpr: true }), jsxTagEnd: F3("jsxTagEnd"), placeholder: F3("%%", { startsExpr: true }) };
        function te2(t3) {
          return t3 >= 93 && t3 <= 130;
        }
        function we2(t3) {
          return t3 <= 92;
        }
        function Ae2(t3) {
          return t3 >= 58 && t3 <= 130;
        }
        function xt2(t3) {
          return t3 >= 58 && t3 <= 134;
        }
        function be2(t3) {
          return ee2[t3];
        }
        function rt2(t3) {
          return pe2[t3];
        }
        function Ca2(t3) {
          return t3 >= 29 && t3 <= 33;
        }
        function or2(t3) {
          return t3 >= 127 && t3 <= 129;
        }
        function va2(t3) {
          return t3 >= 90 && t3 <= 92;
        }
        function Gt2(t3) {
          return t3 >= 58 && t3 <= 92;
        }
        function Sa2(t3) {
          return t3 >= 39 && t3 <= 59;
        }
        function wa2(t3) {
          return t3 === 34;
        }
        function Ia2(t3) {
          return xe2[t3];
        }
        function Na2(t3) {
          return t3 >= 119 && t3 <= 121;
        }
        function ka2(t3) {
          return t3 >= 122 && t3 <= 128;
        }
        function Be2(t3) {
          return Y3[t3];
        }
        function gt2(t3) {
          return he2[t3];
        }
        function Da2(t3) {
          return t3 === 57;
        }
        function Pt2(t3) {
          return t3 >= 24 && t3 <= 25;
        }
        function Ie2(t3) {
          return H3[t3];
        }
        H3[8].updateContext = (t3) => {
          t3.pop();
        }, H3[5].updateContext = H3[7].updateContext = H3[23].updateContext = (t3) => {
          t3.push(g3.brace);
        }, H3[22].updateContext = (t3) => {
          t3[t3.length - 1] === g3.template ? t3.pop() : t3.push(g3.template);
        }, H3[140].updateContext = (t3) => {
          t3.push(g3.j_expr, g3.j_oTag);
        };
        function At2(t3, e28) {
          if (t3 == null)
            return {};
          var s3 = {}, r3 = Object.keys(t3), i, a3;
          for (a3 = 0; a3 < r3.length; a3++)
            i = r3[a3], !(e28.indexOf(i) >= 0) && (s3[i] = t3[i]);
          return s3;
        }
        var Me2 = class {
          constructor(t3, e28, s3) {
            this.line = void 0, this.column = void 0, this.index = void 0, this.line = t3, this.column = e28, this.index = s3;
          }
        }, bt2 = class {
          constructor(t3, e28) {
            this.start = void 0, this.end = void 0, this.filename = void 0, this.identifierName = void 0, this.start = t3, this.end = e28;
          }
        };
        function fe2(t3, e28) {
          let { line: s3, column: r3, index: i } = t3;
          return new Me2(s3, r3 + e28, i + e28);
        }
        var Yt2 = { SyntaxError: "BABEL_PARSER_SYNTAX_ERROR", SourceTypeModuleError: "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED" }, Fa2 = function(t3) {
          let e28 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t3.length - 1;
          return { get() {
            return t3.reduce((s3, r3) => s3[r3], this);
          }, set(s3) {
            t3.reduce((r3, i, a3) => a3 === e28 ? r3[i] = s3 : r3[i], this);
          } };
        }, La2 = (t3, e28, s3) => Object.keys(s3).map((r3) => [r3, s3[r3]]).filter((r3) => {
          let [, i] = r3;
          return !!i;
        }).map((r3) => {
          let [i, a3] = r3;
          return [i, typeof a3 == "function" ? { value: a3, enumerable: false } : typeof a3.reflect == "string" ? Object.assign({}, a3, Fa2(a3.reflect.split("."))) : a3];
        }).reduce((r3, i) => {
          let [a3, n3] = i;
          return Object.defineProperty(r3, a3, Object.assign({ configurable: true }, n3));
        }, Object.assign(new t3(), e28)), Ba2 = { ImportMetaOutsideModule: { message: `import.meta may appear only with 'sourceType: "module"'`, code: Yt2.SourceTypeModuleError }, ImportOutsideModule: { message: `'import' and 'export' may appear only with 'sourceType: "module"'`, code: Yt2.SourceTypeModuleError } }, hr2 = { ArrayPattern: "array destructuring pattern", AssignmentExpression: "assignment expression", AssignmentPattern: "assignment expression", ArrowFunctionExpression: "arrow function expression", ConditionalExpression: "conditional expression", CatchClause: "catch clause", ForOfStatement: "for-of statement", ForInStatement: "for-in statement", ForStatement: "for-loop", FormalParameters: "function parameter list", Identifier: "identifier", ImportSpecifier: "import specifier", ImportDefaultSpecifier: "import default specifier", ImportNamespaceSpecifier: "import namespace specifier", ObjectPattern: "object destructuring pattern", ParenthesizedExpression: "parenthesized expression", RestElement: "rest element", UpdateExpression: { true: "prefix operation", false: "postfix operation" }, VariableDeclarator: "variable declaration", YieldExpression: "yield expression" }, Qt2 = (t3) => {
          let { type: e28, prefix: s3 } = t3;
          return e28 === "UpdateExpression" ? hr2.UpdateExpression[String(s3)] : hr2[e28];
        }, Ma2 = { AccessorIsGenerator: (t3) => {
          let { kind: e28 } = t3;
          return `A ${e28}ter cannot be a generator.`;
        }, ArgumentsInClass: "'arguments' is only allowed in functions and class methods.", AsyncFunctionInSingleStatementContext: "Async functions can only be declared at the top level or inside a block.", AwaitBindingIdentifier: "Can not use 'await' as identifier inside an async function.", AwaitBindingIdentifierInStaticBlock: "Can not use 'await' as identifier inside a static block.", AwaitExpressionFormalParameter: "'await' is not allowed in async function parameters.", AwaitInUsingBinding: "'await' is not allowed to be used as a name in 'using' declarations.", AwaitNotInAsyncContext: "'await' is only allowed within async functions and at the top levels of modules.", AwaitNotInAsyncFunction: "'await' is only allowed within async functions.", BadGetterArity: "A 'get' accessor must not have any formal parameters.", BadSetterArity: "A 'set' accessor must have exactly one formal parameter.", BadSetterRestParameter: "A 'set' accessor function argument must not be a rest parameter.", ConstructorClassField: "Classes may not have a field named 'constructor'.", ConstructorClassPrivateField: "Classes may not have a private field named '#constructor'.", ConstructorIsAccessor: "Class constructor may not be an accessor.", ConstructorIsAsync: "Constructor can't be an async function.", ConstructorIsGenerator: "Constructor can't be a generator.", DeclarationMissingInitializer: (t3) => {
          let { kind: e28 } = t3;
          return `Missing initializer in ${e28} declaration.`;
        }, DecoratorArgumentsOutsideParentheses: "Decorator arguments must be moved inside parentheses: use '@(decorator(args))' instead of '@(decorator)(args)'.", DecoratorBeforeExport: "Decorators must be placed *before* the 'export' keyword. Remove the 'decoratorsBeforeExport: true' option to use the 'export @decorator class {}' syntax.", DecoratorsBeforeAfterExport: "Decorators can be placed *either* before or after the 'export' keyword, but not in both locations at the same time.", DecoratorConstructor: "Decorators can't be used with a constructor. Did you mean '@dec class { ... }'?", DecoratorExportClass: "Decorators must be placed *after* the 'export' keyword. Remove the 'decoratorsBeforeExport: false' option to use the '@decorator export class {}' syntax.", DecoratorSemicolon: "Decorators must not be followed by a semicolon.", DecoratorStaticBlock: "Decorators can't be used with a static block.", DeletePrivateField: "Deleting a private field is not allowed.", DestructureNamedImport: "ES2015 named imports do not destructure. Use another statement for destructuring after the import.", DuplicateConstructor: "Duplicate constructor in the same class.", DuplicateDefaultExport: "Only one default export allowed per module.", DuplicateExport: (t3) => {
          let { exportName: e28 } = t3;
          return `\`${e28}\` has already been exported. Exported identifiers must be unique.`;
        }, DuplicateProto: "Redefinition of __proto__ property.", DuplicateRegExpFlags: "Duplicate regular expression flag.", ElementAfterRest: "Rest element must be last element.", EscapedCharNotAnIdentifier: "Invalid Unicode escape.", ExportBindingIsString: (t3) => {
          let { localName: e28, exportName: s3 } = t3;
          return `A string literal cannot be used as an exported binding without \`from\`.
- Did you mean \`export { '${e28}' as '${s3}' } from 'some-module'\`?`;
        }, ExportDefaultFromAsIdentifier: "'from' is not allowed as an identifier after 'export default'.", ForInOfLoopInitializer: (t3) => {
          let { type: e28 } = t3;
          return `'${e28 === "ForInStatement" ? "for-in" : "for-of"}' loop variable declaration may not have an initializer.`;
        }, ForInUsing: "For-in loop may not start with 'using' declaration.", ForOfAsync: "The left-hand side of a for-of loop may not be 'async'.", ForOfLet: "The left-hand side of a for-of loop may not start with 'let'.", GeneratorInSingleStatementContext: "Generators can only be declared at the top level or inside a block.", IllegalBreakContinue: (t3) => {
          let { type: e28 } = t3;
          return `Unsyntactic ${e28 === "BreakStatement" ? "break" : "continue"}.`;
        }, IllegalLanguageModeDirective: "Illegal 'use strict' directive in function with non-simple parameter list.", IllegalReturn: "'return' outside of function.", ImportBindingIsString: (t3) => {
          let { importName: e28 } = t3;
          return `A string literal cannot be used as an imported binding.
- Did you mean \`import { "${e28}" as foo }\`?`;
        }, ImportCallArgumentTrailingComma: "Trailing comma is disallowed inside import(...) arguments.", ImportCallArity: (t3) => {
          let { maxArgumentCount: e28 } = t3;
          return `\`import()\` requires exactly ${e28 === 1 ? "one argument" : "one or two arguments"}.`;
        }, ImportCallNotNewExpression: "Cannot use new with import(...).", ImportCallSpreadArgument: "`...` is not allowed in `import()`.", ImportJSONBindingNotDefault: "A JSON module can only be imported with `default`.", ImportReflectionHasAssertion: "`import module x` cannot have assertions.", ImportReflectionNotBinding: 'Only `import module x from "./module"` is valid.', IncompatibleRegExpUVFlags: "The 'u' and 'v' regular expression flags cannot be enabled at the same time.", InvalidBigIntLiteral: "Invalid BigIntLiteral.", InvalidCodePoint: "Code point out of bounds.", InvalidCoverInitializedName: "Invalid shorthand property initializer.", InvalidDecimal: "Invalid decimal.", InvalidDigit: (t3) => {
          let { radix: e28 } = t3;
          return `Expected number in radix ${e28}.`;
        }, InvalidEscapeSequence: "Bad character escape sequence.", InvalidEscapeSequenceTemplate: "Invalid escape sequence in template.", InvalidEscapedReservedWord: (t3) => {
          let { reservedWord: e28 } = t3;
          return `Escape sequence in keyword ${e28}.`;
        }, InvalidIdentifier: (t3) => {
          let { identifierName: e28 } = t3;
          return `Invalid identifier ${e28}.`;
        }, InvalidLhs: (t3) => {
          let { ancestor: e28 } = t3;
          return `Invalid left-hand side in ${Qt2(e28)}.`;
        }, InvalidLhsBinding: (t3) => {
          let { ancestor: e28 } = t3;
          return `Binding invalid left-hand side in ${Qt2(e28)}.`;
        }, InvalidNumber: "Invalid number.", InvalidOrMissingExponent: "Floating-point numbers require a valid exponent after the 'e'.", InvalidOrUnexpectedToken: (t3) => {
          let { unexpected: e28 } = t3;
          return `Unexpected character '${e28}'.`;
        }, InvalidParenthesizedAssignment: "Invalid parenthesized assignment pattern.", InvalidPrivateFieldResolution: (t3) => {
          let { identifierName: e28 } = t3;
          return `Private name #${e28} is not defined.`;
        }, InvalidPropertyBindingPattern: "Binding member expression.", InvalidRecordProperty: "Only properties and spread elements are allowed in record definitions.", InvalidRestAssignmentPattern: "Invalid rest operator's argument.", LabelRedeclaration: (t3) => {
          let { labelName: e28 } = t3;
          return `Label '${e28}' is already declared.`;
        }, LetInLexicalBinding: "'let' is not allowed to be used as a name in 'let' or 'const' declarations.", LineTerminatorBeforeArrow: "No line break is allowed before '=>'.", MalformedRegExpFlags: "Invalid regular expression flag.", MissingClassName: "A class name is required.", MissingEqInAssignment: "Only '=' operator can be used for specifying default value.", MissingSemicolon: "Missing semicolon.", MissingPlugin: (t3) => {
          let { missingPlugin: e28 } = t3;
          return `This experimental syntax requires enabling the parser plugin: ${e28.map((s3) => JSON.stringify(s3)).join(", ")}.`;
        }, MissingOneOfPlugins: (t3) => {
          let { missingPlugin: e28 } = t3;
          return `This experimental syntax requires enabling one of the following parser plugin(s): ${e28.map((s3) => JSON.stringify(s3)).join(", ")}.`;
        }, MissingUnicodeEscape: "Expecting Unicode escape sequence \\uXXXX.", MixingCoalesceWithLogical: "Nullish coalescing operator(??) requires parens when mixing with logical operators.", ModuleAttributeDifferentFromType: "The only accepted module attribute is `type`.", ModuleAttributeInvalidValue: "Only string literals are allowed as module attribute values.", ModuleAttributesWithDuplicateKeys: (t3) => {
          let { key: e28 } = t3;
          return `Duplicate key "${e28}" is not allowed in module attributes.`;
        }, ModuleExportNameHasLoneSurrogate: (t3) => {
          let { surrogateCharCode: e28 } = t3;
          return `An export name cannot include a lone surrogate, found '\\u${e28.toString(16)}'.`;
        }, ModuleExportUndefined: (t3) => {
          let { localName: e28 } = t3;
          return `Export '${e28}' is not defined.`;
        }, MultipleDefaultsInSwitch: "Multiple default clauses.", NewlineAfterThrow: "Illegal newline after throw.", NoCatchOrFinally: "Missing catch or finally clause.", NumberIdentifier: "Identifier directly after number.", NumericSeparatorInEscapeSequence: "Numeric separators are not allowed inside unicode escape sequences or hex escape sequences.", ObsoleteAwaitStar: "'await*' has been removed from the async functions proposal. Use Promise.all() instead.", OptionalChainingNoNew: "Constructors in/after an Optional Chain are not allowed.", OptionalChainingNoTemplate: "Tagged Template Literals are not allowed in optionalChain.", OverrideOnConstructor: "'override' modifier cannot appear on a constructor declaration.", ParamDupe: "Argument name clash.", PatternHasAccessor: "Object pattern can't contain getter or setter.", PatternHasMethod: "Object pattern can't contain methods.", PrivateInExpectedIn: (t3) => {
          let { identifierName: e28 } = t3;
          return `Private names are only allowed in property accesses (\`obj.#${e28}\`) or in \`in\` expressions (\`#${e28} in obj\`).`;
        }, PrivateNameRedeclaration: (t3) => {
          let { identifierName: e28 } = t3;
          return `Duplicate private name #${e28}.`;
        }, RecordExpressionBarIncorrectEndSyntaxType: "Record expressions ending with '|}' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", RecordExpressionBarIncorrectStartSyntaxType: "Record expressions starting with '{|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", RecordExpressionHashIncorrectStartSyntaxType: "Record expressions starting with '#{' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.", RecordNoProto: "'__proto__' is not allowed in Record expressions.", RestTrailingComma: "Unexpected trailing comma after rest element.", SloppyFunction: "In non-strict mode code, functions can only be declared at top level or inside a block.", SloppyFunctionAnnexB: "In non-strict mode code, functions can only be declared at top level, inside a block, or as the body of an if statement.", StaticPrototype: "Classes may not have static property named prototype.", SuperNotAllowed: "`super()` is only valid inside a class constructor of a subclass. Maybe a typo in the method name ('constructor') or not extending another class?", SuperPrivateField: "Private fields can't be accessed on super.", TrailingDecorator: "Decorators must be attached to a class element.", TupleExpressionBarIncorrectEndSyntaxType: "Tuple expressions ending with '|]' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", TupleExpressionBarIncorrectStartSyntaxType: "Tuple expressions starting with '[|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", TupleExpressionHashIncorrectStartSyntaxType: "Tuple expressions starting with '#[' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.", UnexpectedArgumentPlaceholder: "Unexpected argument placeholder.", UnexpectedAwaitAfterPipelineBody: 'Unexpected "await" after pipeline body; await must have parentheses in minimal proposal.', UnexpectedDigitAfterHash: "Unexpected digit after hash token.", UnexpectedImportExport: "'import' and 'export' may only appear at the top level.", UnexpectedKeyword: (t3) => {
          let { keyword: e28 } = t3;
          return `Unexpected keyword '${e28}'.`;
        }, UnexpectedLeadingDecorator: "Leading decorators must be attached to a class declaration.", UnexpectedLexicalDeclaration: "Lexical declaration cannot appear in a single-statement context.", UnexpectedNewTarget: "`new.target` can only be used in functions or class properties.", UnexpectedNumericSeparator: "A numeric separator is only allowed between two digits.", UnexpectedPrivateField: "Unexpected private name.", UnexpectedReservedWord: (t3) => {
          let { reservedWord: e28 } = t3;
          return `Unexpected reserved word '${e28}'.`;
        }, UnexpectedSuper: "'super' is only allowed in object methods and classes.", UnexpectedToken: (t3) => {
          let { expected: e28, unexpected: s3 } = t3;
          return `Unexpected token${s3 ? ` '${s3}'.` : ""}${e28 ? `, expected "${e28}"` : ""}`;
        }, UnexpectedTokenUnaryExponentiation: "Illegal expression. Wrap left hand side or entire exponentiation in parentheses.", UnexpectedUsingDeclaration: "Using declaration cannot appear in the top level when source type is `script`.", UnsupportedBind: "Binding should be performed on object property.", UnsupportedDecoratorExport: "A decorated export must export a class declaration.", UnsupportedDefaultExport: "Only expressions, functions or classes are allowed as the `default` export.", UnsupportedImport: "`import` can only be used in `import()` or `import.meta`.", UnsupportedMetaProperty: (t3) => {
          let { target: e28, onlyValidPropertyName: s3 } = t3;
          return `The only valid meta property for ${e28} is ${e28}.${s3}.`;
        }, UnsupportedParameterDecorator: "Decorators cannot be used to decorate parameters.", UnsupportedPropertyDecorator: "Decorators cannot be used to decorate object literal properties.", UnsupportedSuper: "'super' can only be used with function calls (i.e. super()) or in property accesses (i.e. super.prop or super[prop]).", UnterminatedComment: "Unterminated comment.", UnterminatedRegExp: "Unterminated regular expression.", UnterminatedString: "Unterminated string constant.", UnterminatedTemplate: "Unterminated template.", UsingDeclarationHasBindingPattern: "Using declaration cannot have destructuring patterns.", VarRedeclaration: (t3) => {
          let { identifierName: e28 } = t3;
          return `Identifier '${e28}' has already been declared.`;
        }, YieldBindingIdentifier: "Can not use 'yield' as identifier inside a generator.", YieldInParameter: "Yield expression is not allowed in formal parameters.", ZeroDigitNumericSeparator: "Numeric separator can not be used after leading 0." }, Oa2 = { StrictDelete: "Deleting local variable in strict mode.", StrictEvalArguments: (t3) => {
          let { referenceName: e28 } = t3;
          return `Assigning to '${e28}' in strict mode.`;
        }, StrictEvalArgumentsBinding: (t3) => {
          let { bindingName: e28 } = t3;
          return `Binding '${e28}' in strict mode.`;
        }, StrictFunction: "In strict mode code, functions can only be declared at top level or inside a block.", StrictNumericEscape: "The only valid numeric escape in strict mode is '\\0'.", StrictOctalLiteral: "Legacy octal literals are not allowed in strict mode.", StrictWith: "'with' in strict mode." }, ja2 = /* @__PURE__ */ new Set(["ArrowFunctionExpression", "AssignmentExpression", "ConditionalExpression", "YieldExpression"]), Ra2 = { PipeBodyIsTighter: "Unexpected yield after pipeline body; any yield expression acting as Hack-style pipe body must be parenthesized due to its loose operator precedence.", PipeTopicRequiresHackPipes: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.', PipeTopicUnbound: "Topic reference is unbound; it must be inside a pipe body.", PipeTopicUnconfiguredToken: (t3) => {
          let { token: e28 } = t3;
          return `Invalid topic token ${e28}. In order to use ${e28} as a topic reference, the pipelineOperator plugin must be configured with { "proposal": "hack", "topicToken": "${e28}" }.`;
        }, PipeTopicUnused: "Hack-style pipe body does not contain a topic reference; Hack-style pipes must use topic at least once.", PipeUnparenthesizedBody: (t3) => {
          let { type: e28 } = t3;
          return `Hack-style pipe body cannot be an unparenthesized ${Qt2({ type: e28 })}; please wrap it in parentheses.`;
        }, PipelineBodyNoArrow: 'Unexpected arrow "=>" after pipeline body; arrow function in pipeline body must be parenthesized.', PipelineBodySequenceExpression: "Pipeline body may not be a comma-separated sequence expression.", PipelineHeadSequenceExpression: "Pipeline head should not be a comma-separated sequence expression.", PipelineTopicUnused: "Pipeline is in topic style but does not use topic reference.", PrimaryTopicNotAllowed: "Topic reference was used in a lexical context without topic binding.", PrimaryTopicRequiresSmartPipeline: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.' }, Ua2 = ["toMessage"], _a2 = ["message"];
        function za2(t3) {
          let { toMessage: e28 } = t3, s3 = At2(t3, Ua2);
          return function r3(i) {
            let { loc: a3, details: n3 } = i;
            return La2(SyntaxError, Object.assign({}, s3, { loc: a3 }), { clone() {
              let o3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, h3 = o3.loc || {};
              return r3({ loc: new Me2("line" in h3 ? h3.line : this.loc.line, "column" in h3 ? h3.column : this.loc.column, "index" in h3 ? h3.index : this.loc.index), details: Object.assign({}, this.details, o3.details) });
            }, details: { value: n3, enumerable: false }, message: { get() {
              return `${e28(this.details)} (${this.loc.line}:${this.loc.column})`;
            }, set(o3) {
              Object.defineProperty(this, "message", { value: o3 });
            } }, pos: { reflect: "loc.index", enumerable: true }, missingPlugin: "missingPlugin" in n3 && { reflect: "details.missingPlugin", enumerable: true } });
          };
        }
        function Ne2(t3, e28) {
          if (Array.isArray(t3))
            return (r3) => Ne2(r3, t3[0]);
          let s3 = {};
          for (let r3 of Object.keys(t3)) {
            let i = t3[r3], a3 = typeof i == "string" ? { message: () => i } : typeof i == "function" ? { message: i } : i, { message: n3 } = a3, o3 = At2(a3, _a2), h3 = typeof n3 == "string" ? () => n3 : n3;
            s3[r3] = za2(Object.assign({ code: Yt2.SyntaxError, reasonCode: r3, toMessage: h3 }, e28 ? { syntaxPlugin: e28 } : {}, o3));
          }
          return s3;
        }
        var p3 = Object.assign({}, Ne2(Ba2), Ne2(Ma2), Ne2(Oa2), Ne2`pipelineOperator`(Ra2)), { defineProperty: Ha2 } = Object, lr2 = (t3, e28) => Ha2(t3, e28, { enumerable: false, value: t3[e28] });
        function it2(t3) {
          return t3.loc.start && lr2(t3.loc.start, "index"), t3.loc.end && lr2(t3.loc.end, "index"), t3;
        }
        var $a2 = (t3) => class extends t3 {
          parse() {
            let e28 = it2(super.parse());
            return this.options.tokens && (e28.tokens = e28.tokens.map(it2)), e28;
          }
          parseRegExpLiteral(e28) {
            let { pattern: s3, flags: r3 } = e28, i = null;
            try {
              i = new RegExp(s3, r3);
            } catch {
            }
            let a3 = this.estreeParseLiteral(i);
            return a3.regex = { pattern: s3, flags: r3 }, a3;
          }
          parseBigIntLiteral(e28) {
            let s3;
            try {
              s3 = BigInt(e28);
            } catch {
              s3 = null;
            }
            let r3 = this.estreeParseLiteral(s3);
            return r3.bigint = String(r3.value || e28), r3;
          }
          parseDecimalLiteral(e28) {
            let s3 = this.estreeParseLiteral(null);
            return s3.decimal = String(s3.value || e28), s3;
          }
          estreeParseLiteral(e28) {
            return this.parseLiteral(e28, "Literal");
          }
          parseStringLiteral(e28) {
            return this.estreeParseLiteral(e28);
          }
          parseNumericLiteral(e28) {
            return this.estreeParseLiteral(e28);
          }
          parseNullLiteral() {
            return this.estreeParseLiteral(null);
          }
          parseBooleanLiteral(e28) {
            return this.estreeParseLiteral(e28);
          }
          directiveToStmt(e28) {
            let s3 = e28.value;
            delete e28.value, s3.type = "Literal", s3.raw = s3.extra.raw, s3.value = s3.extra.expressionValue;
            let r3 = e28;
            return r3.type = "ExpressionStatement", r3.expression = s3, r3.directive = s3.extra.rawValue, delete s3.extra, r3;
          }
          initFunction(e28, s3) {
            super.initFunction(e28, s3), e28.expression = false;
          }
          checkDeclaration(e28) {
            e28 != null && this.isObjectProperty(e28) ? this.checkDeclaration(e28.value) : super.checkDeclaration(e28);
          }
          getObjectOrClassMethodParams(e28) {
            return e28.value.params;
          }
          isValidDirective(e28) {
            var s3;
            return e28.type === "ExpressionStatement" && e28.expression.type === "Literal" && typeof e28.expression.value == "string" && !((s3 = e28.expression.extra) != null && s3.parenthesized);
          }
          parseBlockBody(e28, s3, r3, i, a3) {
            super.parseBlockBody(e28, s3, r3, i, a3);
            let n3 = e28.directives.map((o3) => this.directiveToStmt(o3));
            e28.body = n3.concat(e28.body), delete e28.directives;
          }
          pushClassMethod(e28, s3, r3, i, a3, n3) {
            this.parseMethod(s3, r3, i, a3, n3, "ClassMethod", true), s3.typeParameters && (s3.value.typeParameters = s3.typeParameters, delete s3.typeParameters), e28.body.push(s3);
          }
          parsePrivateName() {
            let e28 = super.parsePrivateName();
            return this.getPluginOption("estree", "classFeatures") ? this.convertPrivateNameToPrivateIdentifier(e28) : e28;
          }
          convertPrivateNameToPrivateIdentifier(e28) {
            let s3 = super.getPrivateNameSV(e28);
            return e28 = e28, delete e28.id, e28.name = s3, e28.type = "PrivateIdentifier", e28;
          }
          isPrivateName(e28) {
            return this.getPluginOption("estree", "classFeatures") ? e28.type === "PrivateIdentifier" : super.isPrivateName(e28);
          }
          getPrivateNameSV(e28) {
            return this.getPluginOption("estree", "classFeatures") ? e28.name : super.getPrivateNameSV(e28);
          }
          parseLiteral(e28, s3) {
            let r3 = super.parseLiteral(e28, s3);
            return r3.raw = r3.extra.raw, delete r3.extra, r3;
          }
          parseFunctionBody(e28, s3) {
            let r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            super.parseFunctionBody(e28, s3, r3), e28.expression = e28.body.type !== "BlockStatement";
          }
          parseMethod(e28, s3, r3, i, a3, n3) {
            let o3 = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, h3 = this.startNode();
            return h3.kind = e28.kind, h3 = super.parseMethod(h3, s3, r3, i, a3, n3, o3), h3.type = "FunctionExpression", delete h3.kind, e28.value = h3, n3 === "ClassPrivateMethod" && (e28.computed = false), this.finishNode(e28, "MethodDefinition");
          }
          parseClassProperty() {
            let e28 = super.parseClassProperty(...arguments);
            return this.getPluginOption("estree", "classFeatures") && (e28.type = "PropertyDefinition"), e28;
          }
          parseClassPrivateProperty() {
            let e28 = super.parseClassPrivateProperty(...arguments);
            return this.getPluginOption("estree", "classFeatures") && (e28.type = "PropertyDefinition", e28.computed = false), e28;
          }
          parseObjectMethod(e28, s3, r3, i, a3) {
            let n3 = super.parseObjectMethod(e28, s3, r3, i, a3);
            return n3 && (n3.type = "Property", n3.kind === "method" && (n3.kind = "init"), n3.shorthand = false), n3;
          }
          parseObjectProperty(e28, s3, r3, i) {
            let a3 = super.parseObjectProperty(e28, s3, r3, i);
            return a3 && (a3.kind = "init", a3.type = "Property"), a3;
          }
          isValidLVal(e28, s3, r3) {
            return e28 === "Property" ? "value" : super.isValidLVal(e28, s3, r3);
          }
          isAssignable(e28, s3) {
            return e28 != null && this.isObjectProperty(e28) ? this.isAssignable(e28.value, s3) : super.isAssignable(e28, s3);
          }
          toAssignable(e28) {
            let s3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            if (e28 != null && this.isObjectProperty(e28)) {
              let { key: r3, value: i } = e28;
              this.isPrivateName(r3) && this.classScope.usePrivateName(this.getPrivateNameSV(r3), r3.loc.start), this.toAssignable(i, s3);
            } else
              super.toAssignable(e28, s3);
          }
          toAssignableObjectExpressionProp(e28, s3, r3) {
            e28.kind === "get" || e28.kind === "set" ? this.raise(p3.PatternHasAccessor, { at: e28.key }) : e28.method ? this.raise(p3.PatternHasMethod, { at: e28.key }) : super.toAssignableObjectExpressionProp(e28, s3, r3);
          }
          finishCallExpression(e28, s3) {
            let r3 = super.finishCallExpression(e28, s3);
            if (r3.callee.type === "Import") {
              if (r3.type = "ImportExpression", r3.source = r3.arguments[0], this.hasPlugin("importAssertions")) {
                var i;
                r3.attributes = (i = r3.arguments[1]) != null ? i : null;
              }
              delete r3.arguments, delete r3.callee;
            }
            return r3;
          }
          toReferencedArguments(e28) {
            e28.type !== "ImportExpression" && super.toReferencedArguments(e28);
          }
          parseExport(e28, s3) {
            let r3 = this.state.lastTokStartLoc, i = super.parseExport(e28, s3);
            switch (i.type) {
              case "ExportAllDeclaration":
                i.exported = null;
                break;
              case "ExportNamedDeclaration":
                i.specifiers.length === 1 && i.specifiers[0].type === "ExportNamespaceSpecifier" && (i.type = "ExportAllDeclaration", i.exported = i.specifiers[0].exported, delete i.specifiers);
              case "ExportDefaultDeclaration":
                {
                  var a3;
                  let { declaration: n3 } = i;
                  (n3 == null ? void 0 : n3.type) === "ClassDeclaration" && ((a3 = n3.decorators) == null ? void 0 : a3.length) > 0 && n3.start === i.start && this.resetStartLocation(i, r3);
                }
                break;
            }
            return i;
          }
          parseSubscript(e28, s3, r3, i) {
            let a3 = super.parseSubscript(e28, s3, r3, i);
            if (i.optionalChainMember) {
              if ((a3.type === "OptionalMemberExpression" || a3.type === "OptionalCallExpression") && (a3.type = a3.type.substring(8)), i.stop) {
                let n3 = this.startNodeAtNode(a3);
                return n3.expression = a3, this.finishNode(n3, "ChainExpression");
              }
            } else
              (a3.type === "MemberExpression" || a3.type === "CallExpression") && (a3.optional = false);
            return a3;
          }
          hasPropertyAsPrivateName(e28) {
            return e28.type === "ChainExpression" && (e28 = e28.expression), super.hasPropertyAsPrivateName(e28);
          }
          isObjectProperty(e28) {
            return e28.type === "Property" && e28.kind === "init" && !e28.method;
          }
          isObjectMethod(e28) {
            return e28.method || e28.kind === "get" || e28.kind === "set";
          }
          finishNodeAt(e28, s3, r3) {
            return it2(super.finishNodeAt(e28, s3, r3));
          }
          resetStartLocation(e28, s3) {
            super.resetStartLocation(e28, s3), it2(e28);
          }
          resetEndLocation(e28) {
            let s3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.lastTokEndLoc;
            super.resetEndLocation(e28, s3), it2(e28);
          }
        }, Zt2 = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", pr2 = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F", Va2 = new RegExp("[" + Zt2 + "]"), qa2 = new RegExp("[" + Zt2 + pr2 + "]");
        Zt2 = pr2 = null;
        var ur2 = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 4026, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 757, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938, 6, 4191], Ka2 = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 81, 2, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 9, 5351, 0, 7, 14, 13835, 9, 87, 9, 39, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 983, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
        function es2(t3, e28) {
          let s3 = 65536;
          for (let r3 = 0, i = e28.length; r3 < i; r3 += 2) {
            if (s3 += e28[r3], s3 > t3)
              return false;
            if (s3 += e28[r3 + 1], s3 >= t3)
              return true;
          }
          return false;
        }
        function ke2(t3) {
          return t3 < 65 ? t3 === 36 : t3 <= 90 ? true : t3 < 97 ? t3 === 95 : t3 <= 122 ? true : t3 <= 65535 ? t3 >= 170 && Va2.test(String.fromCharCode(t3)) : es2(t3, ur2);
        }
        function Je2(t3) {
          return t3 < 48 ? t3 === 36 : t3 < 58 ? true : t3 < 65 ? false : t3 <= 90 ? true : t3 < 97 ? t3 === 95 : t3 <= 122 ? true : t3 <= 65535 ? t3 >= 170 && qa2.test(String.fromCharCode(t3)) : es2(t3, ur2) || es2(t3, Ka2);
        }
        var ts2 = { keyword: ["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"], strict: ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"], strictBind: ["eval", "arguments"] }, Wa2 = new Set(ts2.keyword), Ja2 = new Set(ts2.strict), Xa2 = new Set(ts2.strictBind);
        function cr2(t3, e28) {
          return e28 && t3 === "await" || t3 === "enum";
        }
        function dr2(t3, e28) {
          return cr2(t3, e28) || Ja2.has(t3);
        }
        function mr2(t3) {
          return Xa2.has(t3);
        }
        function fr2(t3, e28) {
          return dr2(t3, e28) || mr2(t3);
        }
        function Ga2(t3) {
          return Wa2.has(t3);
        }
        function Ya2(t3, e28, s3) {
          return t3 === 64 && e28 === 64 && ke2(s3);
        }
        var Qa2 = /* @__PURE__ */ new Set(["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete", "implements", "interface", "let", "package", "private", "protected", "public", "static", "yield", "eval", "arguments", "enum", "await"]);
        function Za2(t3) {
          return Qa2.has(t3);
        }
        var Xe2 = 0, Ge2 = 1, De2 = 2, ss2 = 4, yr2 = 8, Tt2 = 16, xr2 = 32, _e2 = 64, Et2 = 128, Ye2 = 256, Ct2 = Ge2 | De2 | Et2 | Ye2, Se2 = 1, ze2 = 2, gr2 = 4, He2 = 8, vt2 = 16, Pr2 = 64, St2 = 128, rs2 = 256, is2 = 512, as2 = 1024, ns2 = 2048, at2 = 4096, wt2 = 8192, Ar2 = Se2 | ze2 | He2 | St2 | wt2, Qe2 = Se2 | 0 | He2 | wt2, en2 = Se2 | 0 | He2 | 0, It2 = Se2 | 0 | gr2 | 0, br2 = Se2 | 0 | vt2 | 0, tn2 = 0 | ze2 | 0 | St2, sn2 = 0 | ze2 | 0 | 0, Tr2 = Se2 | ze2 | He2 | rs2 | wt2, Er2 = 0 | as2, Oe2 = 0 | Pr2, rn2 = Se2 | 0 | 0 | Pr2, an2 = Tr2 | is2, nn2 = 0 | as2, Cr2 = 0 | ze2 | 0 | at2, on2 = ns2, Nt2 = 4, os2 = 2, hs2 = 1, ls2 = os2 | hs2, hn2 = os2 | Nt2, ln2 = hs2 | Nt2, pn2 = os2, un2 = hs2, ps2 = 0, us2 = class {
          constructor(t3) {
            this.var = /* @__PURE__ */ new Set(), this.lexical = /* @__PURE__ */ new Set(), this.functions = /* @__PURE__ */ new Set(), this.flags = t3;
          }
        }, cs2 = class {
          constructor(t3, e28) {
            this.parser = void 0, this.scopeStack = [], this.inModule = void 0, this.undefinedExports = /* @__PURE__ */ new Map(), this.parser = t3, this.inModule = e28;
          }
          get inTopLevel() {
            return (this.currentScope().flags & Ge2) > 0;
          }
          get inFunction() {
            return (this.currentVarScopeFlags() & De2) > 0;
          }
          get allowSuper() {
            return (this.currentThisScopeFlags() & Tt2) > 0;
          }
          get allowDirectSuper() {
            return (this.currentThisScopeFlags() & xr2) > 0;
          }
          get inClass() {
            return (this.currentThisScopeFlags() & _e2) > 0;
          }
          get inClassAndNotInNonArrowFunction() {
            let t3 = this.currentThisScopeFlags();
            return (t3 & _e2) > 0 && (t3 & De2) === 0;
          }
          get inStaticBlock() {
            for (let t3 = this.scopeStack.length - 1; ; t3--) {
              let { flags: e28 } = this.scopeStack[t3];
              if (e28 & Et2)
                return true;
              if (e28 & (Ct2 | _e2))
                return false;
            }
          }
          get inNonArrowFunction() {
            return (this.currentThisScopeFlags() & De2) > 0;
          }
          get treatFunctionsAsVar() {
            return this.treatFunctionsAsVarInScope(this.currentScope());
          }
          createScope(t3) {
            return new us2(t3);
          }
          enter(t3) {
            this.scopeStack.push(this.createScope(t3));
          }
          exit() {
            return this.scopeStack.pop().flags;
          }
          treatFunctionsAsVarInScope(t3) {
            return !!(t3.flags & (De2 | Et2) || !this.parser.inModule && t3.flags & Ge2);
          }
          declareName(t3, e28, s3) {
            let r3 = this.currentScope();
            if (e28 & He2 || e28 & vt2)
              this.checkRedeclarationInScope(r3, t3, e28, s3), e28 & vt2 ? r3.functions.add(t3) : r3.lexical.add(t3), e28 & He2 && this.maybeExportDefined(r3, t3);
            else if (e28 & gr2)
              for (let i = this.scopeStack.length - 1; i >= 0 && (r3 = this.scopeStack[i], this.checkRedeclarationInScope(r3, t3, e28, s3), r3.var.add(t3), this.maybeExportDefined(r3, t3), !(r3.flags & Ct2)); --i)
                ;
            this.parser.inModule && r3.flags & Ge2 && this.undefinedExports.delete(t3);
          }
          maybeExportDefined(t3, e28) {
            this.parser.inModule && t3.flags & Ge2 && this.undefinedExports.delete(e28);
          }
          checkRedeclarationInScope(t3, e28, s3, r3) {
            this.isRedeclaredInScope(t3, e28, s3) && this.parser.raise(p3.VarRedeclaration, { at: r3, identifierName: e28 });
          }
          isRedeclaredInScope(t3, e28, s3) {
            return s3 & Se2 ? s3 & He2 ? t3.lexical.has(e28) || t3.functions.has(e28) || t3.var.has(e28) : s3 & vt2 ? t3.lexical.has(e28) || !this.treatFunctionsAsVarInScope(t3) && t3.var.has(e28) : t3.lexical.has(e28) && !(t3.flags & yr2 && t3.lexical.values().next().value === e28) || !this.treatFunctionsAsVarInScope(t3) && t3.functions.has(e28) : false;
          }
          checkLocalExport(t3) {
            let { name: e28 } = t3, s3 = this.scopeStack[0];
            !s3.lexical.has(e28) && !s3.var.has(e28) && !s3.functions.has(e28) && this.undefinedExports.set(e28, t3.loc.start);
          }
          currentScope() {
            return this.scopeStack[this.scopeStack.length - 1];
          }
          currentVarScopeFlags() {
            for (let t3 = this.scopeStack.length - 1; ; t3--) {
              let { flags: e28 } = this.scopeStack[t3];
              if (e28 & Ct2)
                return e28;
            }
          }
          currentThisScopeFlags() {
            for (let t3 = this.scopeStack.length - 1; ; t3--) {
              let { flags: e28 } = this.scopeStack[t3];
              if (e28 & (Ct2 | _e2) && !(e28 & ss2))
                return e28;
            }
          }
        }, cn2 = class extends us2 {
          constructor() {
            super(...arguments), this.declareFunctions = /* @__PURE__ */ new Set();
          }
        }, dn2 = class extends cs2 {
          createScope(t3) {
            return new cn2(t3);
          }
          declareName(t3, e28, s3) {
            let r3 = this.currentScope();
            if (e28 & ns2) {
              this.checkRedeclarationInScope(r3, t3, e28, s3), this.maybeExportDefined(r3, t3), r3.declareFunctions.add(t3);
              return;
            }
            super.declareName(t3, e28, s3);
          }
          isRedeclaredInScope(t3, e28, s3) {
            return super.isRedeclaredInScope(t3, e28, s3) ? true : s3 & ns2 ? !t3.declareFunctions.has(e28) && (t3.lexical.has(e28) || t3.functions.has(e28)) : false;
          }
          checkLocalExport(t3) {
            this.scopeStack[0].declareFunctions.has(t3.name) || super.checkLocalExport(t3);
          }
        }, mn2 = class {
          constructor() {
            this.sawUnambiguousESM = false, this.ambiguousScriptDifferentAst = false;
          }
          hasPlugin(t3) {
            if (typeof t3 == "string")
              return this.plugins.has(t3);
            {
              let [e28, s3] = t3;
              if (!this.hasPlugin(e28))
                return false;
              let r3 = this.plugins.get(e28);
              for (let i of Object.keys(s3))
                if ((r3 == null ? void 0 : r3[i]) !== s3[i])
                  return false;
              return true;
            }
          }
          getPluginOption(t3, e28) {
            var s3;
            return (s3 = this.plugins.get(t3)) == null ? void 0 : s3[e28];
          }
        };
        function vr2(t3, e28) {
          t3.trailingComments === void 0 ? t3.trailingComments = e28 : t3.trailingComments.unshift(...e28);
        }
        function fn2(t3, e28) {
          t3.leadingComments === void 0 ? t3.leadingComments = e28 : t3.leadingComments.unshift(...e28);
        }
        function nt2(t3, e28) {
          t3.innerComments === void 0 ? t3.innerComments = e28 : t3.innerComments.unshift(...e28);
        }
        function ot2(t3, e28, s3) {
          let r3 = null, i = e28.length;
          for (; r3 === null && i > 0; )
            r3 = e28[--i];
          r3 === null || r3.start > s3.start ? nt2(t3, s3.comments) : vr2(r3, s3.comments);
        }
        var yn2 = class extends mn2 {
          addComment(t3) {
            this.filename && (t3.loc.filename = this.filename), this.state.comments.push(t3);
          }
          processComment(t3) {
            let { commentStack: e28 } = this.state, s3 = e28.length;
            if (s3 === 0)
              return;
            let r3 = s3 - 1, i = e28[r3];
            i.start === t3.end && (i.leadingNode = t3, r3--);
            let { start: a3 } = t3;
            for (; r3 >= 0; r3--) {
              let n3 = e28[r3], o3 = n3.end;
              if (o3 > a3)
                n3.containingNode = t3, this.finalizeComment(n3), e28.splice(r3, 1);
              else {
                o3 === a3 && (n3.trailingNode = t3);
                break;
              }
            }
          }
          finalizeComment(t3) {
            let { comments: e28 } = t3;
            if (t3.leadingNode !== null || t3.trailingNode !== null)
              t3.leadingNode !== null && vr2(t3.leadingNode, e28), t3.trailingNode !== null && fn2(t3.trailingNode, e28);
            else {
              let { containingNode: s3, start: r3 } = t3;
              if (this.input.charCodeAt(r3 - 1) === 44)
                switch (s3.type) {
                  case "ObjectExpression":
                  case "ObjectPattern":
                  case "RecordExpression":
                    ot2(s3, s3.properties, t3);
                    break;
                  case "CallExpression":
                  case "OptionalCallExpression":
                    ot2(s3, s3.arguments, t3);
                    break;
                  case "FunctionDeclaration":
                  case "FunctionExpression":
                  case "ArrowFunctionExpression":
                  case "ObjectMethod":
                  case "ClassMethod":
                  case "ClassPrivateMethod":
                    ot2(s3, s3.params, t3);
                    break;
                  case "ArrayExpression":
                  case "ArrayPattern":
                  case "TupleExpression":
                    ot2(s3, s3.elements, t3);
                    break;
                  case "ExportNamedDeclaration":
                  case "ImportDeclaration":
                    ot2(s3, s3.specifiers, t3);
                    break;
                  default:
                    nt2(s3, e28);
                }
              else
                nt2(s3, e28);
            }
          }
          finalizeRemainingComments() {
            let { commentStack: t3 } = this.state;
            for (let e28 = t3.length - 1; e28 >= 0; e28--)
              this.finalizeComment(t3[e28]);
            this.state.commentStack = [];
          }
          resetPreviousNodeTrailingComments(t3) {
            let { commentStack: e28 } = this.state, { length: s3 } = e28;
            if (s3 === 0)
              return;
            let r3 = e28[s3 - 1];
            r3.leadingNode === t3 && (r3.leadingNode = null);
          }
          takeSurroundingComments(t3, e28, s3) {
            let { commentStack: r3 } = this.state, i = r3.length;
            if (i === 0)
              return;
            let a3 = i - 1;
            for (; a3 >= 0; a3--) {
              let n3 = r3[a3], o3 = n3.end;
              if (n3.start === s3)
                n3.leadingNode = t3;
              else if (o3 === e28)
                n3.trailingNode = t3;
              else if (o3 < e28)
                break;
            }
          }
        }, ds2 = /\r\n?|[\n\u2028\u2029]/, kt2 = new RegExp(ds2.source, "g");
        function ht2(t3) {
          switch (t3) {
            case 10:
            case 13:
            case 8232:
            case 8233:
              return true;
            default:
              return false;
          }
        }
        var ms2 = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, xn2 = /(?:[^\S\n\r\u2028\u2029]|\/\/.*|\/\*.*?\*\/)*/y, Sr2 = new RegExp("(?=(" + xn2.source + "))\\1" + /(?=[\n\r\u2028\u2029]|\/\*(?!.*?\*\/)|$)/.source, "y");
        function gn2(t3) {
          switch (t3) {
            case 9:
            case 11:
            case 12:
            case 32:
            case 160:
            case 5760:
            case 8192:
            case 8193:
            case 8194:
            case 8195:
            case 8196:
            case 8197:
            case 8198:
            case 8199:
            case 8200:
            case 8201:
            case 8202:
            case 8239:
            case 8287:
            case 12288:
            case 65279:
              return true;
            default:
              return false;
          }
        }
        var wr2 = class {
          constructor() {
            this.strict = void 0, this.curLine = void 0, this.lineStart = void 0, this.startLoc = void 0, this.endLoc = void 0, this.errors = [], this.potentialArrowAt = -1, this.noArrowAt = [], this.noArrowParamsConversionAt = [], this.maybeInArrowParameters = false, this.inType = false, this.noAnonFunctionType = false, this.hasFlowComment = false, this.isAmbientContext = false, this.inAbstractClass = false, this.inDisallowConditionalTypesContext = false, this.topicContext = { maxNumOfResolvableTopics: 0, maxTopicIndex: null }, this.soloAwait = false, this.inFSharpPipelineDirectBody = false, this.labels = [], this.comments = [], this.commentStack = [], this.pos = 0, this.type = 137, this.value = null, this.start = 0, this.end = 0, this.lastTokEndLoc = null, this.lastTokStartLoc = null, this.lastTokStart = 0, this.context = [g3.brace], this.canStartJSXElement = true, this.containsEsc = false, this.firstInvalidTemplateEscapePos = null, this.strictErrors = /* @__PURE__ */ new Map(), this.tokensLength = 0;
          }
          init(t3) {
            let { strictMode: e28, sourceType: s3, startLine: r3, startColumn: i } = t3;
            this.strict = e28 === false ? false : e28 === true ? true : s3 === "module", this.curLine = r3, this.lineStart = -i, this.startLoc = this.endLoc = new Me2(r3, i, 0);
          }
          curPosition() {
            return new Me2(this.curLine, this.pos - this.lineStart, this.pos);
          }
          clone(t3) {
            let e28 = new wr2(), s3 = Object.keys(this);
            for (let r3 = 0, i = s3.length; r3 < i; r3++) {
              let a3 = s3[r3], n3 = this[a3];
              !t3 && Array.isArray(n3) && (n3 = n3.slice()), e28[a3] = n3;
            }
            return e28;
          }
        }, Pn2 = function(t3) {
          return t3 >= 48 && t3 <= 57;
        }, Ir2 = { decBinOct: /* @__PURE__ */ new Set([46, 66, 69, 79, 95, 98, 101, 111]), hex: /* @__PURE__ */ new Set([46, 88, 95, 120]) }, Dt2 = { bin: (t3) => t3 === 48 || t3 === 49, oct: (t3) => t3 >= 48 && t3 <= 55, dec: (t3) => t3 >= 48 && t3 <= 57, hex: (t3) => t3 >= 48 && t3 <= 57 || t3 >= 65 && t3 <= 70 || t3 >= 97 && t3 <= 102 };
        function Nr2(t3, e28, s3, r3, i, a3) {
          let n3 = s3, o3 = r3, h3 = i, l3 = "", f3 = null, T3 = s3, { length: R3 } = e28;
          for (; ; ) {
            if (s3 >= R3) {
              a3.unterminated(n3, o3, h3), l3 += e28.slice(T3, s3);
              break;
            }
            let B3 = e28.charCodeAt(s3);
            if (An2(t3, B3, e28, s3)) {
              l3 += e28.slice(T3, s3);
              break;
            }
            if (B3 === 92) {
              l3 += e28.slice(T3, s3);
              let se2 = bn2(e28, s3, r3, i, t3 === "template", a3);
              se2.ch === null && !f3 ? f3 = { pos: s3, lineStart: r3, curLine: i } : l3 += se2.ch, { pos: s3, lineStart: r3, curLine: i } = se2, T3 = s3;
            } else
              B3 === 8232 || B3 === 8233 ? (++s3, ++i, r3 = s3) : B3 === 10 || B3 === 13 ? t3 === "template" ? (l3 += e28.slice(T3, s3) + `
`, ++s3, B3 === 13 && e28.charCodeAt(s3) === 10 && ++s3, ++i, T3 = r3 = s3) : a3.unterminated(n3, o3, h3) : ++s3;
          }
          return { pos: s3, str: l3, firstInvalidLoc: f3, lineStart: r3, curLine: i, containsInvalid: !!f3 };
        }
        function An2(t3, e28, s3, r3) {
          return t3 === "template" ? e28 === 96 || e28 === 36 && s3.charCodeAt(r3 + 1) === 123 : e28 === (t3 === "double" ? 34 : 39);
        }
        function bn2(t3, e28, s3, r3, i, a3) {
          let n3 = !i;
          e28++;
          let o3 = (l3) => ({ pos: e28, ch: l3, lineStart: s3, curLine: r3 }), h3 = t3.charCodeAt(e28++);
          switch (h3) {
            case 110:
              return o3(`
`);
            case 114:
              return o3("\r");
            case 120: {
              let l3;
              return { code: l3, pos: e28 } = fs2(t3, e28, s3, r3, 2, false, n3, a3), o3(l3 === null ? null : String.fromCharCode(l3));
            }
            case 117: {
              let l3;
              return { code: l3, pos: e28 } = Dr2(t3, e28, s3, r3, n3, a3), o3(l3 === null ? null : String.fromCodePoint(l3));
            }
            case 116:
              return o3("	");
            case 98:
              return o3("\b");
            case 118:
              return o3("\v");
            case 102:
              return o3("\f");
            case 13:
              t3.charCodeAt(e28) === 10 && ++e28;
            case 10:
              s3 = e28, ++r3;
            case 8232:
            case 8233:
              return o3("");
            case 56:
            case 57:
              if (i)
                return o3(null);
              a3.strictNumericEscape(e28 - 1, s3, r3);
            default:
              if (h3 >= 48 && h3 <= 55) {
                let l3 = e28 - 1, f3 = t3.slice(l3, e28 + 2).match(/^[0-7]+/)[0], T3 = parseInt(f3, 8);
                T3 > 255 && (f3 = f3.slice(0, -1), T3 = parseInt(f3, 8)), e28 += f3.length - 1;
                let R3 = t3.charCodeAt(e28);
                if (f3 !== "0" || R3 === 56 || R3 === 57) {
                  if (i)
                    return o3(null);
                  a3.strictNumericEscape(l3, s3, r3);
                }
                return o3(String.fromCharCode(T3));
              }
              return o3(String.fromCharCode(h3));
          }
        }
        function fs2(t3, e28, s3, r3, i, a3, n3, o3) {
          let h3 = e28, l3;
          return { n: l3, pos: e28 } = kr2(t3, e28, s3, r3, 16, i, a3, false, o3, !n3), l3 === null && (n3 ? o3.invalidEscapeSequence(h3, s3, r3) : e28 = h3 - 1), { code: l3, pos: e28 };
        }
        function kr2(t3, e28, s3, r3, i, a3, n3, o3, h3, l3) {
          let f3 = e28, T3 = i === 16 ? Ir2.hex : Ir2.decBinOct, R3 = i === 16 ? Dt2.hex : i === 10 ? Dt2.dec : i === 8 ? Dt2.oct : Dt2.bin, B3 = false, se2 = 0;
          for (let re2 = 0, ce2 = a3 != null ? a3 : 1 / 0; re2 < ce2; ++re2) {
            let de2 = t3.charCodeAt(e28), oe2;
            if (de2 === 95 && o3 !== "bail") {
              let jt2 = t3.charCodeAt(e28 - 1), ut2 = t3.charCodeAt(e28 + 1);
              if (o3) {
                if (Number.isNaN(ut2) || !R3(ut2) || T3.has(jt2) || T3.has(ut2)) {
                  if (l3)
                    return { n: null, pos: e28 };
                  h3.unexpectedNumericSeparator(e28, s3, r3);
                }
              } else {
                if (l3)
                  return { n: null, pos: e28 };
                h3.numericSeparatorInEscapeSequence(e28, s3, r3);
              }
              ++e28;
              continue;
            }
            if (de2 >= 97 ? oe2 = de2 - 97 + 10 : de2 >= 65 ? oe2 = de2 - 65 + 10 : Pn2(de2) ? oe2 = de2 - 48 : oe2 = 1 / 0, oe2 >= i) {
              if (oe2 <= 9 && l3)
                return { n: null, pos: e28 };
              if (oe2 <= 9 && h3.invalidDigit(e28, s3, r3, i))
                oe2 = 0;
              else if (n3)
                oe2 = 0, B3 = true;
              else
                break;
            }
            ++e28, se2 = se2 * i + oe2;
          }
          return e28 === f3 || a3 != null && e28 - f3 !== a3 || B3 ? { n: null, pos: e28 } : { n: se2, pos: e28 };
        }
        function Dr2(t3, e28, s3, r3, i, a3) {
          let n3 = t3.charCodeAt(e28), o3;
          if (n3 === 123) {
            if (++e28, { code: o3, pos: e28 } = fs2(t3, e28, s3, r3, t3.indexOf("}", e28) - e28, true, i, a3), ++e28, o3 !== null && o3 > 1114111)
              if (i)
                a3.invalidCodePoint(e28, s3, r3);
              else
                return { code: null, pos: e28 };
          } else
            ({ code: o3, pos: e28 } = fs2(t3, e28, s3, r3, 4, false, i, a3));
          return { code: o3, pos: e28 };
        }
        var Tn2 = ["at"], En2 = ["at"];
        function lt2(t3, e28, s3) {
          return new Me2(s3, t3 - e28, t3);
        }
        var Cn2 = /* @__PURE__ */ new Set([103, 109, 115, 105, 121, 117, 100, 118]), je2 = class {
          constructor(t3) {
            this.type = t3.type, this.value = t3.value, this.start = t3.start, this.end = t3.end, this.loc = new bt2(t3.startLoc, t3.endLoc);
          }
        }, vn2 = class extends yn2 {
          constructor(t3, e28) {
            super(), this.isLookahead = void 0, this.tokens = [], this.errorHandlers_readInt = { invalidDigit: (s3, r3, i, a3) => this.options.errorRecovery ? (this.raise(p3.InvalidDigit, { at: lt2(s3, r3, i), radix: a3 }), true) : false, numericSeparatorInEscapeSequence: this.errorBuilder(p3.NumericSeparatorInEscapeSequence), unexpectedNumericSeparator: this.errorBuilder(p3.UnexpectedNumericSeparator) }, this.errorHandlers_readCodePoint = Object.assign({}, this.errorHandlers_readInt, { invalidEscapeSequence: this.errorBuilder(p3.InvalidEscapeSequence), invalidCodePoint: this.errorBuilder(p3.InvalidCodePoint) }), this.errorHandlers_readStringContents_string = Object.assign({}, this.errorHandlers_readCodePoint, { strictNumericEscape: (s3, r3, i) => {
              this.recordStrictModeErrors(p3.StrictNumericEscape, { at: lt2(s3, r3, i) });
            }, unterminated: (s3, r3, i) => {
              throw this.raise(p3.UnterminatedString, { at: lt2(s3 - 1, r3, i) });
            } }), this.errorHandlers_readStringContents_template = Object.assign({}, this.errorHandlers_readCodePoint, { strictNumericEscape: this.errorBuilder(p3.StrictNumericEscape), unterminated: (s3, r3, i) => {
              throw this.raise(p3.UnterminatedTemplate, { at: lt2(s3, r3, i) });
            } }), this.state = new wr2(), this.state.init(t3), this.input = e28, this.length = e28.length, this.isLookahead = false;
          }
          pushToken(t3) {
            this.tokens.length = this.state.tokensLength, this.tokens.push(t3), ++this.state.tokensLength;
          }
          next() {
            this.checkKeywordEscapes(), this.options.tokens && this.pushToken(new je2(this.state)), this.state.lastTokStart = this.state.start, this.state.lastTokEndLoc = this.state.endLoc, this.state.lastTokStartLoc = this.state.startLoc, this.nextToken();
          }
          eat(t3) {
            return this.match(t3) ? (this.next(), true) : false;
          }
          match(t3) {
            return this.state.type === t3;
          }
          createLookaheadState(t3) {
            return { pos: t3.pos, value: null, type: t3.type, start: t3.start, end: t3.end, context: [this.curContext()], inType: t3.inType, startLoc: t3.startLoc, lastTokEndLoc: t3.lastTokEndLoc, curLine: t3.curLine, lineStart: t3.lineStart, curPosition: t3.curPosition };
          }
          lookahead() {
            let t3 = this.state;
            this.state = this.createLookaheadState(t3), this.isLookahead = true, this.nextToken(), this.isLookahead = false;
            let e28 = this.state;
            return this.state = t3, e28;
          }
          nextTokenStart() {
            return this.nextTokenStartSince(this.state.pos);
          }
          nextTokenStartSince(t3) {
            return ms2.lastIndex = t3, ms2.test(this.input) ? ms2.lastIndex : t3;
          }
          lookaheadCharCode() {
            return this.input.charCodeAt(this.nextTokenStart());
          }
          codePointAtPos(t3) {
            let e28 = this.input.charCodeAt(t3);
            if ((e28 & 64512) === 55296 && ++t3 < this.input.length) {
              let s3 = this.input.charCodeAt(t3);
              (s3 & 64512) === 56320 && (e28 = 65536 + ((e28 & 1023) << 10) + (s3 & 1023));
            }
            return e28;
          }
          setStrict(t3) {
            this.state.strict = t3, t3 && (this.state.strictErrors.forEach((e28) => {
              let [s3, r3] = e28;
              return this.raise(s3, { at: r3 });
            }), this.state.strictErrors.clear());
          }
          curContext() {
            return this.state.context[this.state.context.length - 1];
          }
          nextToken() {
            if (this.skipSpace(), this.state.start = this.state.pos, this.isLookahead || (this.state.startLoc = this.state.curPosition()), this.state.pos >= this.length) {
              this.finishToken(137);
              return;
            }
            this.getTokenFromCode(this.codePointAtPos(this.state.pos));
          }
          skipBlockComment(t3) {
            let e28;
            this.isLookahead || (e28 = this.state.curPosition());
            let s3 = this.state.pos, r3 = this.input.indexOf(t3, s3 + 2);
            if (r3 === -1)
              throw this.raise(p3.UnterminatedComment, { at: this.state.curPosition() });
            for (this.state.pos = r3 + t3.length, kt2.lastIndex = s3 + 2; kt2.test(this.input) && kt2.lastIndex <= r3; )
              ++this.state.curLine, this.state.lineStart = kt2.lastIndex;
            if (this.isLookahead)
              return;
            let i = { type: "CommentBlock", value: this.input.slice(s3 + 2, r3), start: s3, end: r3 + t3.length, loc: new bt2(e28, this.state.curPosition()) };
            return this.options.tokens && this.pushToken(i), i;
          }
          skipLineComment(t3) {
            let e28 = this.state.pos, s3;
            this.isLookahead || (s3 = this.state.curPosition());
            let r3 = this.input.charCodeAt(this.state.pos += t3);
            if (this.state.pos < this.length)
              for (; !ht2(r3) && ++this.state.pos < this.length; )
                r3 = this.input.charCodeAt(this.state.pos);
            if (this.isLookahead)
              return;
            let i = this.state.pos, a3 = { type: "CommentLine", value: this.input.slice(e28 + t3, i), start: e28, end: i, loc: new bt2(s3, this.state.curPosition()) };
            return this.options.tokens && this.pushToken(a3), a3;
          }
          skipSpace() {
            let t3 = this.state.pos, e28 = [];
            e:
              for (; this.state.pos < this.length; ) {
                let s3 = this.input.charCodeAt(this.state.pos);
                switch (s3) {
                  case 32:
                  case 160:
                  case 9:
                    ++this.state.pos;
                    break;
                  case 13:
                    this.input.charCodeAt(this.state.pos + 1) === 10 && ++this.state.pos;
                  case 10:
                  case 8232:
                  case 8233:
                    ++this.state.pos, ++this.state.curLine, this.state.lineStart = this.state.pos;
                    break;
                  case 47:
                    switch (this.input.charCodeAt(this.state.pos + 1)) {
                      case 42: {
                        let r3 = this.skipBlockComment("*/");
                        r3 !== void 0 && (this.addComment(r3), this.options.attachComment && e28.push(r3));
                        break;
                      }
                      case 47: {
                        let r3 = this.skipLineComment(2);
                        r3 !== void 0 && (this.addComment(r3), this.options.attachComment && e28.push(r3));
                        break;
                      }
                      default:
                        break e;
                    }
                    break;
                  default:
                    if (gn2(s3))
                      ++this.state.pos;
                    else if (s3 === 45 && !this.inModule && this.options.annexB) {
                      let r3 = this.state.pos;
                      if (this.input.charCodeAt(r3 + 1) === 45 && this.input.charCodeAt(r3 + 2) === 62 && (t3 === 0 || this.state.lineStart > t3)) {
                        let i = this.skipLineComment(3);
                        i !== void 0 && (this.addComment(i), this.options.attachComment && e28.push(i));
                      } else
                        break e;
                    } else if (s3 === 60 && !this.inModule && this.options.annexB) {
                      let r3 = this.state.pos;
                      if (this.input.charCodeAt(r3 + 1) === 33 && this.input.charCodeAt(r3 + 2) === 45 && this.input.charCodeAt(r3 + 3) === 45) {
                        let i = this.skipLineComment(4);
                        i !== void 0 && (this.addComment(i), this.options.attachComment && e28.push(i));
                      } else
                        break e;
                    } else
                      break e;
                }
              }
            if (e28.length > 0) {
              let s3 = this.state.pos, r3 = { start: t3, end: s3, comments: e28, leadingNode: null, trailingNode: null, containingNode: null };
              this.state.commentStack.push(r3);
            }
          }
          finishToken(t3, e28) {
            this.state.end = this.state.pos, this.state.endLoc = this.state.curPosition();
            let s3 = this.state.type;
            this.state.type = t3, this.state.value = e28, this.isLookahead || this.updateContext(s3);
          }
          replaceToken(t3) {
            this.state.type = t3, this.updateContext();
          }
          readToken_numberSign() {
            if (this.state.pos === 0 && this.readToken_interpreter())
              return;
            let t3 = this.state.pos + 1, e28 = this.codePointAtPos(t3);
            if (e28 >= 48 && e28 <= 57)
              throw this.raise(p3.UnexpectedDigitAfterHash, { at: this.state.curPosition() });
            if (e28 === 123 || e28 === 91 && this.hasPlugin("recordAndTuple")) {
              if (this.expectPlugin("recordAndTuple"), this.getPluginOption("recordAndTuple", "syntaxType") === "bar")
                throw this.raise(e28 === 123 ? p3.RecordExpressionHashIncorrectStartSyntaxType : p3.TupleExpressionHashIncorrectStartSyntaxType, { at: this.state.curPosition() });
              this.state.pos += 2, e28 === 123 ? this.finishToken(7) : this.finishToken(1);
            } else
              ke2(e28) ? (++this.state.pos, this.finishToken(136, this.readWord1(e28))) : e28 === 92 ? (++this.state.pos, this.finishToken(136, this.readWord1())) : this.finishOp(27, 1);
          }
          readToken_dot() {
            let t3 = this.input.charCodeAt(this.state.pos + 1);
            if (t3 >= 48 && t3 <= 57) {
              this.readNumber(true);
              return;
            }
            t3 === 46 && this.input.charCodeAt(this.state.pos + 2) === 46 ? (this.state.pos += 3, this.finishToken(21)) : (++this.state.pos, this.finishToken(16));
          }
          readToken_slash() {
            this.input.charCodeAt(this.state.pos + 1) === 61 ? this.finishOp(31, 2) : this.finishOp(56, 1);
          }
          readToken_interpreter() {
            if (this.state.pos !== 0 || this.length < 2)
              return false;
            let t3 = this.input.charCodeAt(this.state.pos + 1);
            if (t3 !== 33)
              return false;
            let e28 = this.state.pos;
            for (this.state.pos += 1; !ht2(t3) && ++this.state.pos < this.length; )
              t3 = this.input.charCodeAt(this.state.pos);
            let s3 = this.input.slice(e28 + 2, this.state.pos);
            return this.finishToken(28, s3), true;
          }
          readToken_mult_modulo(t3) {
            let e28 = t3 === 42 ? 55 : 54, s3 = 1, r3 = this.input.charCodeAt(this.state.pos + 1);
            t3 === 42 && r3 === 42 && (s3++, r3 = this.input.charCodeAt(this.state.pos + 2), e28 = 57), r3 === 61 && !this.state.inType && (s3++, e28 = t3 === 37 ? 33 : 30), this.finishOp(e28, s3);
          }
          readToken_pipe_amp(t3) {
            let e28 = this.input.charCodeAt(this.state.pos + 1);
            if (e28 === t3) {
              this.input.charCodeAt(this.state.pos + 2) === 61 ? this.finishOp(30, 3) : this.finishOp(t3 === 124 ? 41 : 42, 2);
              return;
            }
            if (t3 === 124) {
              if (e28 === 62) {
                this.finishOp(39, 2);
                return;
              }
              if (this.hasPlugin("recordAndTuple") && e28 === 125) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                  throw this.raise(p3.RecordExpressionBarIncorrectEndSyntaxType, { at: this.state.curPosition() });
                this.state.pos += 2, this.finishToken(9);
                return;
              }
              if (this.hasPlugin("recordAndTuple") && e28 === 93) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                  throw this.raise(p3.TupleExpressionBarIncorrectEndSyntaxType, { at: this.state.curPosition() });
                this.state.pos += 2, this.finishToken(4);
                return;
              }
            }
            if (e28 === 61) {
              this.finishOp(30, 2);
              return;
            }
            this.finishOp(t3 === 124 ? 43 : 45, 1);
          }
          readToken_caret() {
            let t3 = this.input.charCodeAt(this.state.pos + 1);
            t3 === 61 && !this.state.inType ? this.finishOp(32, 2) : t3 === 94 && this.hasPlugin(["pipelineOperator", { proposal: "hack", topicToken: "^^" }]) ? (this.finishOp(37, 2), this.input.codePointAt(this.state.pos) === 94 && this.unexpected()) : this.finishOp(44, 1);
          }
          readToken_atSign() {
            this.input.charCodeAt(this.state.pos + 1) === 64 && this.hasPlugin(["pipelineOperator", { proposal: "hack", topicToken: "@@" }]) ? this.finishOp(38, 2) : this.finishOp(26, 1);
          }
          readToken_plus_min(t3) {
            let e28 = this.input.charCodeAt(this.state.pos + 1);
            if (e28 === t3) {
              this.finishOp(34, 2);
              return;
            }
            e28 === 61 ? this.finishOp(30, 2) : this.finishOp(53, 1);
          }
          readToken_lt() {
            let { pos: t3 } = this.state, e28 = this.input.charCodeAt(t3 + 1);
            if (e28 === 60) {
              if (this.input.charCodeAt(t3 + 2) === 61) {
                this.finishOp(30, 3);
                return;
              }
              this.finishOp(51, 2);
              return;
            }
            if (e28 === 61) {
              this.finishOp(49, 2);
              return;
            }
            this.finishOp(47, 1);
          }
          readToken_gt() {
            let { pos: t3 } = this.state, e28 = this.input.charCodeAt(t3 + 1);
            if (e28 === 62) {
              let s3 = this.input.charCodeAt(t3 + 2) === 62 ? 3 : 2;
              if (this.input.charCodeAt(t3 + s3) === 61) {
                this.finishOp(30, s3 + 1);
                return;
              }
              this.finishOp(52, s3);
              return;
            }
            if (e28 === 61) {
              this.finishOp(49, 2);
              return;
            }
            this.finishOp(48, 1);
          }
          readToken_eq_excl(t3) {
            let e28 = this.input.charCodeAt(this.state.pos + 1);
            if (e28 === 61) {
              this.finishOp(46, this.input.charCodeAt(this.state.pos + 2) === 61 ? 3 : 2);
              return;
            }
            if (t3 === 61 && e28 === 62) {
              this.state.pos += 2, this.finishToken(19);
              return;
            }
            this.finishOp(t3 === 61 ? 29 : 35, 1);
          }
          readToken_question() {
            let t3 = this.input.charCodeAt(this.state.pos + 1), e28 = this.input.charCodeAt(this.state.pos + 2);
            t3 === 63 ? e28 === 61 ? this.finishOp(30, 3) : this.finishOp(40, 2) : t3 === 46 && !(e28 >= 48 && e28 <= 57) ? (this.state.pos += 2, this.finishToken(18)) : (++this.state.pos, this.finishToken(17));
          }
          getTokenFromCode(t3) {
            switch (t3) {
              case 46:
                this.readToken_dot();
                return;
              case 40:
                ++this.state.pos, this.finishToken(10);
                return;
              case 41:
                ++this.state.pos, this.finishToken(11);
                return;
              case 59:
                ++this.state.pos, this.finishToken(13);
                return;
              case 44:
                ++this.state.pos, this.finishToken(12);
                return;
              case 91:
                if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                  if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                    throw this.raise(p3.TupleExpressionBarIncorrectStartSyntaxType, { at: this.state.curPosition() });
                  this.state.pos += 2, this.finishToken(2);
                } else
                  ++this.state.pos, this.finishToken(0);
                return;
              case 93:
                ++this.state.pos, this.finishToken(3);
                return;
              case 123:
                if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                  if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                    throw this.raise(p3.RecordExpressionBarIncorrectStartSyntaxType, { at: this.state.curPosition() });
                  this.state.pos += 2, this.finishToken(6);
                } else
                  ++this.state.pos, this.finishToken(5);
                return;
              case 125:
                ++this.state.pos, this.finishToken(8);
                return;
              case 58:
                this.hasPlugin("functionBind") && this.input.charCodeAt(this.state.pos + 1) === 58 ? this.finishOp(15, 2) : (++this.state.pos, this.finishToken(14));
                return;
              case 63:
                this.readToken_question();
                return;
              case 96:
                this.readTemplateToken();
                return;
              case 48: {
                let e28 = this.input.charCodeAt(this.state.pos + 1);
                if (e28 === 120 || e28 === 88) {
                  this.readRadixNumber(16);
                  return;
                }
                if (e28 === 111 || e28 === 79) {
                  this.readRadixNumber(8);
                  return;
                }
                if (e28 === 98 || e28 === 66) {
                  this.readRadixNumber(2);
                  return;
                }
              }
              case 49:
              case 50:
              case 51:
              case 52:
              case 53:
              case 54:
              case 55:
              case 56:
              case 57:
                this.readNumber(false);
                return;
              case 34:
              case 39:
                this.readString(t3);
                return;
              case 47:
                this.readToken_slash();
                return;
              case 37:
              case 42:
                this.readToken_mult_modulo(t3);
                return;
              case 124:
              case 38:
                this.readToken_pipe_amp(t3);
                return;
              case 94:
                this.readToken_caret();
                return;
              case 43:
              case 45:
                this.readToken_plus_min(t3);
                return;
              case 60:
                this.readToken_lt();
                return;
              case 62:
                this.readToken_gt();
                return;
              case 61:
              case 33:
                this.readToken_eq_excl(t3);
                return;
              case 126:
                this.finishOp(36, 1);
                return;
              case 64:
                this.readToken_atSign();
                return;
              case 35:
                this.readToken_numberSign();
                return;
              case 92:
                this.readWord();
                return;
              default:
                if (ke2(t3)) {
                  this.readWord(t3);
                  return;
                }
            }
            throw this.raise(p3.InvalidOrUnexpectedToken, { at: this.state.curPosition(), unexpected: String.fromCodePoint(t3) });
          }
          finishOp(t3, e28) {
            let s3 = this.input.slice(this.state.pos, this.state.pos + e28);
            this.state.pos += e28, this.finishToken(t3, s3);
          }
          readRegexp() {
            let t3 = this.state.startLoc, e28 = this.state.start + 1, s3, r3, { pos: i } = this.state;
            for (; ; ++i) {
              if (i >= this.length)
                throw this.raise(p3.UnterminatedRegExp, { at: fe2(t3, 1) });
              let h3 = this.input.charCodeAt(i);
              if (ht2(h3))
                throw this.raise(p3.UnterminatedRegExp, { at: fe2(t3, 1) });
              if (s3)
                s3 = false;
              else {
                if (h3 === 91)
                  r3 = true;
                else if (h3 === 93 && r3)
                  r3 = false;
                else if (h3 === 47 && !r3)
                  break;
                s3 = h3 === 92;
              }
            }
            let a3 = this.input.slice(e28, i);
            ++i;
            let n3 = "", o3 = () => fe2(t3, i + 2 - e28);
            for (; i < this.length; ) {
              let h3 = this.codePointAtPos(i), l3 = String.fromCharCode(h3);
              if (Cn2.has(h3))
                h3 === 118 ? (this.expectPlugin("regexpUnicodeSets", o3()), n3.includes("u") && this.raise(p3.IncompatibleRegExpUVFlags, { at: o3() })) : h3 === 117 && n3.includes("v") && this.raise(p3.IncompatibleRegExpUVFlags, { at: o3() }), n3.includes(l3) && this.raise(p3.DuplicateRegExpFlags, { at: o3() });
              else if (Je2(h3) || h3 === 92)
                this.raise(p3.MalformedRegExpFlags, { at: o3() });
              else
                break;
              ++i, n3 += l3;
            }
            this.state.pos = i, this.finishToken(135, { pattern: a3, flags: n3 });
          }
          readInt(t3, e28) {
            let s3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, r3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, { n: i, pos: a3 } = kr2(this.input, this.state.pos, this.state.lineStart, this.state.curLine, t3, e28, s3, r3, this.errorHandlers_readInt, false);
            return this.state.pos = a3, i;
          }
          readRadixNumber(t3) {
            let e28 = this.state.curPosition(), s3 = false;
            this.state.pos += 2;
            let r3 = this.readInt(t3);
            r3 == null && this.raise(p3.InvalidDigit, { at: fe2(e28, 2), radix: t3 });
            let i = this.input.charCodeAt(this.state.pos);
            if (i === 110)
              ++this.state.pos, s3 = true;
            else if (i === 109)
              throw this.raise(p3.InvalidDecimal, { at: e28 });
            if (ke2(this.codePointAtPos(this.state.pos)))
              throw this.raise(p3.NumberIdentifier, { at: this.state.curPosition() });
            if (s3) {
              let a3 = this.input.slice(e28.index, this.state.pos).replace(/[_n]/g, "");
              this.finishToken(133, a3);
              return;
            }
            this.finishToken(132, r3);
          }
          readNumber(t3) {
            let e28 = this.state.pos, s3 = this.state.curPosition(), r3 = false, i = false, a3 = false, n3 = false, o3 = false;
            !t3 && this.readInt(10) === null && this.raise(p3.InvalidNumber, { at: this.state.curPosition() });
            let h3 = this.state.pos - e28 >= 2 && this.input.charCodeAt(e28) === 48;
            if (h3) {
              let R3 = this.input.slice(e28, this.state.pos);
              if (this.recordStrictModeErrors(p3.StrictOctalLiteral, { at: s3 }), !this.state.strict) {
                let B3 = R3.indexOf("_");
                B3 > 0 && this.raise(p3.ZeroDigitNumericSeparator, { at: fe2(s3, B3) });
              }
              o3 = h3 && !/[89]/.test(R3);
            }
            let l3 = this.input.charCodeAt(this.state.pos);
            if (l3 === 46 && !o3 && (++this.state.pos, this.readInt(10), r3 = true, l3 = this.input.charCodeAt(this.state.pos)), (l3 === 69 || l3 === 101) && !o3 && (l3 = this.input.charCodeAt(++this.state.pos), (l3 === 43 || l3 === 45) && ++this.state.pos, this.readInt(10) === null && this.raise(p3.InvalidOrMissingExponent, { at: s3 }), r3 = true, n3 = true, l3 = this.input.charCodeAt(this.state.pos)), l3 === 110 && ((r3 || h3) && this.raise(p3.InvalidBigIntLiteral, { at: s3 }), ++this.state.pos, i = true), l3 === 109 && (this.expectPlugin("decimal", this.state.curPosition()), (n3 || h3) && this.raise(p3.InvalidDecimal, { at: s3 }), ++this.state.pos, a3 = true), ke2(this.codePointAtPos(this.state.pos)))
              throw this.raise(p3.NumberIdentifier, { at: this.state.curPosition() });
            let f3 = this.input.slice(e28, this.state.pos).replace(/[_mn]/g, "");
            if (i) {
              this.finishToken(133, f3);
              return;
            }
            if (a3) {
              this.finishToken(134, f3);
              return;
            }
            let T3 = o3 ? parseInt(f3, 8) : parseFloat(f3);
            this.finishToken(132, T3);
          }
          readCodePoint(t3) {
            let { code: e28, pos: s3 } = Dr2(this.input, this.state.pos, this.state.lineStart, this.state.curLine, t3, this.errorHandlers_readCodePoint);
            return this.state.pos = s3, e28;
          }
          readString(t3) {
            let { str: e28, pos: s3, curLine: r3, lineStart: i } = Nr2(t3 === 34 ? "double" : "single", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_string);
            this.state.pos = s3 + 1, this.state.lineStart = i, this.state.curLine = r3, this.finishToken(131, e28);
          }
          readTemplateContinuation() {
            this.match(8) || this.unexpected(null, 8), this.state.pos--, this.readTemplateToken();
          }
          readTemplateToken() {
            let t3 = this.input[this.state.pos], { str: e28, firstInvalidLoc: s3, pos: r3, curLine: i, lineStart: a3 } = Nr2("template", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_template);
            this.state.pos = r3 + 1, this.state.lineStart = a3, this.state.curLine = i, s3 && (this.state.firstInvalidTemplateEscapePos = new Me2(s3.curLine, s3.pos - s3.lineStart, s3.pos)), this.input.codePointAt(r3) === 96 ? this.finishToken(24, s3 ? null : t3 + e28 + "`") : (this.state.pos++, this.finishToken(25, s3 ? null : t3 + e28 + "${"));
          }
          recordStrictModeErrors(t3, e28) {
            let { at: s3 } = e28, r3 = s3.index;
            this.state.strict && !this.state.strictErrors.has(r3) ? this.raise(t3, { at: s3 }) : this.state.strictErrors.set(r3, [t3, s3]);
          }
          readWord1(t3) {
            this.state.containsEsc = false;
            let e28 = "", s3 = this.state.pos, r3 = this.state.pos;
            for (t3 !== void 0 && (this.state.pos += t3 <= 65535 ? 1 : 2); this.state.pos < this.length; ) {
              let i = this.codePointAtPos(this.state.pos);
              if (Je2(i))
                this.state.pos += i <= 65535 ? 1 : 2;
              else if (i === 92) {
                this.state.containsEsc = true, e28 += this.input.slice(r3, this.state.pos);
                let a3 = this.state.curPosition(), n3 = this.state.pos === s3 ? ke2 : Je2;
                if (this.input.charCodeAt(++this.state.pos) !== 117) {
                  this.raise(p3.MissingUnicodeEscape, { at: this.state.curPosition() }), r3 = this.state.pos - 1;
                  continue;
                }
                ++this.state.pos;
                let o3 = this.readCodePoint(true);
                o3 !== null && (n3(o3) || this.raise(p3.EscapedCharNotAnIdentifier, { at: a3 }), e28 += String.fromCodePoint(o3)), r3 = this.state.pos;
              } else
                break;
            }
            return e28 + this.input.slice(r3, this.state.pos);
          }
          readWord(t3) {
            let e28 = this.readWord1(t3), s3 = W3.get(e28);
            s3 !== void 0 ? this.finishToken(s3, Be2(s3)) : this.finishToken(130, e28);
          }
          checkKeywordEscapes() {
            let { type: t3 } = this.state;
            Gt2(t3) && this.state.containsEsc && this.raise(p3.InvalidEscapedReservedWord, { at: this.state.startLoc, reservedWord: Be2(t3) });
          }
          raise(t3, e28) {
            let { at: s3 } = e28, r3 = At2(e28, Tn2), i = s3 instanceof Me2 ? s3 : s3.loc.start, a3 = t3({ loc: i, details: r3 });
            if (!this.options.errorRecovery)
              throw a3;
            return this.isLookahead || this.state.errors.push(a3), a3;
          }
          raiseOverwrite(t3, e28) {
            let { at: s3 } = e28, r3 = At2(e28, En2), i = s3 instanceof Me2 ? s3 : s3.loc.start, a3 = i.index, n3 = this.state.errors;
            for (let o3 = n3.length - 1; o3 >= 0; o3--) {
              let h3 = n3[o3];
              if (h3.loc.index === a3)
                return n3[o3] = t3({ loc: i, details: r3 });
              if (h3.loc.index < a3)
                break;
            }
            return this.raise(t3, e28);
          }
          updateContext(t3) {
          }
          unexpected(t3, e28) {
            throw this.raise(p3.UnexpectedToken, { expected: e28 ? Be2(e28) : null, at: t3 != null ? t3 : this.state.startLoc });
          }
          expectPlugin(t3, e28) {
            if (this.hasPlugin(t3))
              return true;
            throw this.raise(p3.MissingPlugin, { at: e28 != null ? e28 : this.state.startLoc, missingPlugin: [t3] });
          }
          expectOnePlugin(t3) {
            if (!t3.some((e28) => this.hasPlugin(e28)))
              throw this.raise(p3.MissingOneOfPlugins, { at: this.state.startLoc, missingPlugin: t3 });
          }
          errorBuilder(t3) {
            return (e28, s3, r3) => {
              this.raise(t3, { at: lt2(e28, s3, r3) });
            };
          }
        }, Sn2 = class {
          constructor() {
            this.privateNames = /* @__PURE__ */ new Set(), this.loneAccessors = /* @__PURE__ */ new Map(), this.undefinedPrivateNames = /* @__PURE__ */ new Map();
          }
        }, wn2 = class {
          constructor(t3) {
            this.parser = void 0, this.stack = [], this.undefinedPrivateNames = /* @__PURE__ */ new Map(), this.parser = t3;
          }
          current() {
            return this.stack[this.stack.length - 1];
          }
          enter() {
            this.stack.push(new Sn2());
          }
          exit() {
            let t3 = this.stack.pop(), e28 = this.current();
            for (let [s3, r3] of Array.from(t3.undefinedPrivateNames))
              e28 ? e28.undefinedPrivateNames.has(s3) || e28.undefinedPrivateNames.set(s3, r3) : this.parser.raise(p3.InvalidPrivateFieldResolution, { at: r3, identifierName: s3 });
          }
          declarePrivateName(t3, e28, s3) {
            let { privateNames: r3, loneAccessors: i, undefinedPrivateNames: a3 } = this.current(), n3 = r3.has(t3);
            if (e28 & ls2) {
              let o3 = n3 && i.get(t3);
              if (o3) {
                let h3 = o3 & Nt2, l3 = e28 & Nt2, f3 = o3 & ls2, T3 = e28 & ls2;
                n3 = f3 === T3 || h3 !== l3, n3 || i.delete(t3);
              } else
                n3 || i.set(t3, e28);
            }
            n3 && this.parser.raise(p3.PrivateNameRedeclaration, { at: s3, identifierName: t3 }), r3.add(t3), a3.delete(t3);
          }
          usePrivateName(t3, e28) {
            let s3;
            for (s3 of this.stack)
              if (s3.privateNames.has(t3))
                return;
            s3 ? s3.undefinedPrivateNames.set(t3, e28) : this.parser.raise(p3.InvalidPrivateFieldResolution, { at: e28, identifierName: t3 });
          }
        }, In2 = 0, Fr2 = 1, ys2 = 2, Lr2 = 3, Ft2 = class {
          constructor() {
            let t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : In2;
            this.type = void 0, this.type = t3;
          }
          canBeArrowParameterDeclaration() {
            return this.type === ys2 || this.type === Fr2;
          }
          isCertainlyParameterDeclaration() {
            return this.type === Lr2;
          }
        }, Br2 = class extends Ft2 {
          constructor(t3) {
            super(t3), this.declarationErrors = /* @__PURE__ */ new Map();
          }
          recordDeclarationError(t3, e28) {
            let { at: s3 } = e28, r3 = s3.index;
            this.declarationErrors.set(r3, [t3, s3]);
          }
          clearDeclarationError(t3) {
            this.declarationErrors.delete(t3);
          }
          iterateErrors(t3) {
            this.declarationErrors.forEach(t3);
          }
        }, Nn2 = class {
          constructor(t3) {
            this.parser = void 0, this.stack = [new Ft2()], this.parser = t3;
          }
          enter(t3) {
            this.stack.push(t3);
          }
          exit() {
            this.stack.pop();
          }
          recordParameterInitializerError(t3, e28) {
            let { at: s3 } = e28, r3 = { at: s3.loc.start }, { stack: i } = this, a3 = i.length - 1, n3 = i[a3];
            for (; !n3.isCertainlyParameterDeclaration(); ) {
              if (n3.canBeArrowParameterDeclaration())
                n3.recordDeclarationError(t3, r3);
              else
                return;
              n3 = i[--a3];
            }
            this.parser.raise(t3, r3);
          }
          recordArrowParameterBindingError(t3, e28) {
            let { at: s3 } = e28, { stack: r3 } = this, i = r3[r3.length - 1], a3 = { at: s3.loc.start };
            if (i.isCertainlyParameterDeclaration())
              this.parser.raise(t3, a3);
            else if (i.canBeArrowParameterDeclaration())
              i.recordDeclarationError(t3, a3);
            else
              return;
          }
          recordAsyncArrowParametersError(t3) {
            let { at: e28 } = t3, { stack: s3 } = this, r3 = s3.length - 1, i = s3[r3];
            for (; i.canBeArrowParameterDeclaration(); )
              i.type === ys2 && i.recordDeclarationError(p3.AwaitBindingIdentifier, { at: e28 }), i = s3[--r3];
          }
          validateAsPattern() {
            let { stack: t3 } = this, e28 = t3[t3.length - 1];
            e28.canBeArrowParameterDeclaration() && e28.iterateErrors((s3) => {
              let [r3, i] = s3;
              this.parser.raise(r3, { at: i });
              let a3 = t3.length - 2, n3 = t3[a3];
              for (; n3.canBeArrowParameterDeclaration(); )
                n3.clearDeclarationError(i.index), n3 = t3[--a3];
            });
          }
        };
        function kn2() {
          return new Ft2(Lr2);
        }
        function Dn2() {
          return new Br2(Fr2);
        }
        function Fn2() {
          return new Br2(ys2);
        }
        function Mr2() {
          return new Ft2();
        }
        var Ze2 = 0, Or2 = 1, Lt2 = 2, jr2 = 4, et2 = 8, Ln2 = class {
          constructor() {
            this.stacks = [];
          }
          enter(t3) {
            this.stacks.push(t3);
          }
          exit() {
            this.stacks.pop();
          }
          currentFlags() {
            return this.stacks[this.stacks.length - 1];
          }
          get hasAwait() {
            return (this.currentFlags() & Lt2) > 0;
          }
          get hasYield() {
            return (this.currentFlags() & Or2) > 0;
          }
          get hasReturn() {
            return (this.currentFlags() & jr2) > 0;
          }
          get hasIn() {
            return (this.currentFlags() & et2) > 0;
          }
        };
        function Bt2(t3, e28) {
          return (t3 ? Lt2 : 0) | (e28 ? Or2 : 0);
        }
        var Bn2 = class extends vn2 {
          addExtra(t3, e28, s3) {
            let r3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
            if (!t3)
              return;
            let i = t3.extra = t3.extra || {};
            r3 ? i[e28] = s3 : Object.defineProperty(i, e28, { enumerable: r3, value: s3 });
          }
          isContextual(t3) {
            return this.state.type === t3 && !this.state.containsEsc;
          }
          isUnparsedContextual(t3, e28) {
            let s3 = t3 + e28.length;
            if (this.input.slice(t3, s3) === e28) {
              let r3 = this.input.charCodeAt(s3);
              return !(Je2(r3) || (r3 & 64512) === 55296);
            }
            return false;
          }
          isLookaheadContextual(t3) {
            let e28 = this.nextTokenStart();
            return this.isUnparsedContextual(e28, t3);
          }
          eatContextual(t3) {
            return this.isContextual(t3) ? (this.next(), true) : false;
          }
          expectContextual(t3, e28) {
            if (!this.eatContextual(t3)) {
              if (e28 != null)
                throw this.raise(e28, { at: this.state.startLoc });
              this.unexpected(null, t3);
            }
          }
          canInsertSemicolon() {
            return this.match(137) || this.match(8) || this.hasPrecedingLineBreak();
          }
          hasPrecedingLineBreak() {
            return ds2.test(this.input.slice(this.state.lastTokEndLoc.index, this.state.start));
          }
          hasFollowingLineBreak() {
            return Sr2.lastIndex = this.state.end, Sr2.test(this.input);
          }
          isLineTerminator() {
            return this.eat(13) || this.canInsertSemicolon();
          }
          semicolon() {
            (!(arguments.length > 0 && arguments[0] !== void 0) || arguments[0] ? this.isLineTerminator() : this.eat(13)) || this.raise(p3.MissingSemicolon, { at: this.state.lastTokEndLoc });
          }
          expect(t3, e28) {
            this.eat(t3) || this.unexpected(e28, t3);
          }
          tryParse(t3) {
            let e28 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.clone(), s3 = { node: null };
            try {
              let r3 = t3(function() {
                let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                throw s3.node = i, s3;
              });
              if (this.state.errors.length > e28.errors.length) {
                let i = this.state;
                return this.state = e28, this.state.tokensLength = i.tokensLength, { node: r3, error: i.errors[e28.errors.length], thrown: false, aborted: false, failState: i };
              }
              return { node: r3, error: null, thrown: false, aborted: false, failState: null };
            } catch (r3) {
              let i = this.state;
              if (this.state = e28, r3 instanceof SyntaxError)
                return { node: null, error: r3, thrown: true, aborted: false, failState: i };
              if (r3 === s3)
                return { node: s3.node, error: null, thrown: false, aborted: true, failState: i };
              throw r3;
            }
          }
          checkExpressionErrors(t3, e28) {
            if (!t3)
              return false;
            let { shorthandAssignLoc: s3, doubleProtoLoc: r3, privateKeyLoc: i, optionalParametersLoc: a3 } = t3, n3 = !!s3 || !!r3 || !!a3 || !!i;
            if (!e28)
              return n3;
            s3 != null && this.raise(p3.InvalidCoverInitializedName, { at: s3 }), r3 != null && this.raise(p3.DuplicateProto, { at: r3 }), i != null && this.raise(p3.UnexpectedPrivateField, { at: i }), a3 != null && this.unexpected(a3);
          }
          isLiteralPropertyName() {
            return xt2(this.state.type);
          }
          isPrivateName(t3) {
            return t3.type === "PrivateName";
          }
          getPrivateNameSV(t3) {
            return t3.id.name;
          }
          hasPropertyAsPrivateName(t3) {
            return (t3.type === "MemberExpression" || t3.type === "OptionalMemberExpression") && this.isPrivateName(t3.property);
          }
          isObjectProperty(t3) {
            return t3.type === "ObjectProperty";
          }
          isObjectMethod(t3) {
            return t3.type === "ObjectMethod";
          }
          initializeScopes() {
            let t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options.sourceType === "module", e28 = this.state.labels;
            this.state.labels = [];
            let s3 = this.exportedIdentifiers;
            this.exportedIdentifiers = /* @__PURE__ */ new Set();
            let r3 = this.inModule;
            this.inModule = t3;
            let i = this.scope, a3 = this.getScopeHandler();
            this.scope = new a3(this, t3);
            let n3 = this.prodParam;
            this.prodParam = new Ln2();
            let o3 = this.classScope;
            this.classScope = new wn2(this);
            let h3 = this.expressionScope;
            return this.expressionScope = new Nn2(this), () => {
              this.state.labels = e28, this.exportedIdentifiers = s3, this.inModule = r3, this.scope = i, this.prodParam = n3, this.classScope = o3, this.expressionScope = h3;
            };
          }
          enterInitialScopes() {
            let t3 = Ze2;
            this.inModule && (t3 |= Lt2), this.scope.enter(Ge2), this.prodParam.enter(t3);
          }
          checkDestructuringPrivate(t3) {
            let { privateKeyLoc: e28 } = t3;
            e28 !== null && this.expectPlugin("destructuringPrivate", e28);
          }
        }, Mt2 = class {
          constructor() {
            this.shorthandAssignLoc = null, this.doubleProtoLoc = null, this.privateKeyLoc = null, this.optionalParametersLoc = null;
          }
        }, Ot2 = class {
          constructor(t3, e28, s3) {
            this.type = "", this.start = e28, this.end = 0, this.loc = new bt2(s3), t3 != null && t3.options.ranges && (this.range = [e28, 0]), t3 != null && t3.filename && (this.loc.filename = t3.filename);
          }
        }, xs2 = Ot2.prototype;
        xs2.__clone = function() {
          let t3 = new Ot2(void 0, this.start, this.loc.start), e28 = Object.keys(this);
          for (let s3 = 0, r3 = e28.length; s3 < r3; s3++) {
            let i = e28[s3];
            i !== "leadingComments" && i !== "trailingComments" && i !== "innerComments" && (t3[i] = this[i]);
          }
          return t3;
        };
        function Mn2(t3) {
          return Fe2(t3);
        }
        function Fe2(t3) {
          let { type: e28, start: s3, end: r3, loc: i, range: a3, extra: n3, name: o3 } = t3, h3 = Object.create(xs2);
          return h3.type = e28, h3.start = s3, h3.end = r3, h3.loc = i, h3.range = a3, h3.extra = n3, h3.name = o3, e28 === "Placeholder" && (h3.expectedNode = t3.expectedNode), h3;
        }
        function On2(t3) {
          let { type: e28, start: s3, end: r3, loc: i, range: a3, extra: n3 } = t3;
          if (e28 === "Placeholder")
            return Mn2(t3);
          let o3 = Object.create(xs2);
          return o3.type = e28, o3.start = s3, o3.end = r3, o3.loc = i, o3.range = a3, t3.raw !== void 0 ? o3.raw = t3.raw : o3.extra = n3, o3.value = t3.value, o3;
        }
        var jn2 = class extends Bn2 {
          startNode() {
            return new Ot2(this, this.state.start, this.state.startLoc);
          }
          startNodeAt(t3) {
            return new Ot2(this, t3.index, t3);
          }
          startNodeAtNode(t3) {
            return this.startNodeAt(t3.loc.start);
          }
          finishNode(t3, e28) {
            return this.finishNodeAt(t3, e28, this.state.lastTokEndLoc);
          }
          finishNodeAt(t3, e28, s3) {
            return t3.type = e28, t3.end = s3.index, t3.loc.end = s3, this.options.ranges && (t3.range[1] = s3.index), this.options.attachComment && this.processComment(t3), t3;
          }
          resetStartLocation(t3, e28) {
            t3.start = e28.index, t3.loc.start = e28, this.options.ranges && (t3.range[0] = e28.index);
          }
          resetEndLocation(t3) {
            let e28 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.lastTokEndLoc;
            t3.end = e28.index, t3.loc.end = e28, this.options.ranges && (t3.range[1] = e28.index);
          }
          resetStartLocationFromNode(t3, e28) {
            this.resetStartLocation(t3, e28.loc.start);
          }
        }, Rn2 = /* @__PURE__ */ new Set(["_", "any", "bool", "boolean", "empty", "extends", "false", "interface", "mixed", "null", "number", "static", "string", "true", "typeof", "void"]), $3 = Ne2`flow`({ AmbiguousConditionalArrow: "Ambiguous expression: wrap the arrow functions in parentheses to disambiguate.", AmbiguousDeclareModuleKind: "Found both `declare module.exports` and `declare export` in the same module. Modules can only have 1 since they are either an ES module or they are a CommonJS module.", AssignReservedType: (t3) => {
          let { reservedType: e28 } = t3;
          return `Cannot overwrite reserved type ${e28}.`;
        }, DeclareClassElement: "The `declare` modifier can only appear on class fields.", DeclareClassFieldInitializer: "Initializers are not allowed in fields with the `declare` modifier.", DuplicateDeclareModuleExports: "Duplicate `declare module.exports` statement.", EnumBooleanMemberNotInitialized: (t3) => {
          let { memberName: e28, enumName: s3 } = t3;
          return `Boolean enum members need to be initialized. Use either \`${e28} = true,\` or \`${e28} = false,\` in enum \`${s3}\`.`;
        }, EnumDuplicateMemberName: (t3) => {
          let { memberName: e28, enumName: s3 } = t3;
          return `Enum member names need to be unique, but the name \`${e28}\` has already been used before in enum \`${s3}\`.`;
        }, EnumInconsistentMemberValues: (t3) => {
          let { enumName: e28 } = t3;
          return `Enum \`${e28}\` has inconsistent member initializers. Either use no initializers, or consistently use literals (either booleans, numbers, or strings) for all member initializers.`;
        }, EnumInvalidExplicitType: (t3) => {
          let { invalidEnumType: e28, enumName: s3 } = t3;
          return `Enum type \`${e28}\` is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${s3}\`.`;
        }, EnumInvalidExplicitTypeUnknownSupplied: (t3) => {
          let { enumName: e28 } = t3;
          return `Supplied enum type is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${e28}\`.`;
        }, EnumInvalidMemberInitializerPrimaryType: (t3) => {
          let { enumName: e28, memberName: s3, explicitType: r3 } = t3;
          return `Enum \`${e28}\` has type \`${r3}\`, so the initializer of \`${s3}\` needs to be a ${r3} literal.`;
        }, EnumInvalidMemberInitializerSymbolType: (t3) => {
          let { enumName: e28, memberName: s3 } = t3;
          return `Symbol enum members cannot be initialized. Use \`${s3},\` in enum \`${e28}\`.`;
        }, EnumInvalidMemberInitializerUnknownType: (t3) => {
          let { enumName: e28, memberName: s3 } = t3;
          return `The enum member initializer for \`${s3}\` needs to be a literal (either a boolean, number, or string) in enum \`${e28}\`.`;
        }, EnumInvalidMemberName: (t3) => {
          let { enumName: e28, memberName: s3, suggestion: r3 } = t3;
          return `Enum member names cannot start with lowercase 'a' through 'z'. Instead of using \`${s3}\`, consider using \`${r3}\`, in enum \`${e28}\`.`;
        }, EnumNumberMemberNotInitialized: (t3) => {
          let { enumName: e28, memberName: s3 } = t3;
          return `Number enum members need to be initialized, e.g. \`${s3} = 1\` in enum \`${e28}\`.`;
        }, EnumStringMemberInconsistentlyInitailized: (t3) => {
          let { enumName: e28 } = t3;
          return `String enum members need to consistently either all use initializers, or use no initializers, in enum \`${e28}\`.`;
        }, GetterMayNotHaveThisParam: "A getter cannot have a `this` parameter.", ImportReflectionHasImportType: "An `import module` declaration can not use `type` or `typeof` keyword.", ImportTypeShorthandOnlyInPureImport: "The `type` and `typeof` keywords on named imports can only be used on regular `import` statements. It cannot be used with `import type` or `import typeof` statements.", InexactInsideExact: "Explicit inexact syntax cannot appear inside an explicit exact object type.", InexactInsideNonObject: "Explicit inexact syntax cannot appear in class or interface definitions.", InexactVariance: "Explicit inexact syntax cannot have variance.", InvalidNonTypeImportInDeclareModule: "Imports within a `declare module` body must always be `import type` or `import typeof`.", MissingTypeParamDefault: "Type parameter declaration needs a default, since a preceding type parameter declaration has a default.", NestedDeclareModule: "`declare module` cannot be used inside another `declare module`.", NestedFlowComment: "Cannot have a flow comment inside another flow comment.", PatternIsOptional: Object.assign({ message: "A binding pattern parameter cannot be optional in an implementation signature." }, { reasonCode: "OptionalBindingPattern" }), SetterMayNotHaveThisParam: "A setter cannot have a `this` parameter.", SpreadVariance: "Spread properties cannot have variance.", ThisParamAnnotationRequired: "A type annotation is required for the `this` parameter.", ThisParamBannedInConstructor: "Constructors cannot have a `this` parameter; constructors don't bind `this` like other functions.", ThisParamMayNotBeOptional: "The `this` parameter cannot be optional.", ThisParamMustBeFirst: "The `this` parameter must be the first function parameter.", ThisParamNoDefault: "The `this` parameter may not have a default value.", TypeBeforeInitializer: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.", TypeCastInPattern: "The type cast expression is expected to be wrapped with parenthesis.", UnexpectedExplicitInexactInObject: "Explicit inexact syntax must appear at the end of an inexact object.", UnexpectedReservedType: (t3) => {
          let { reservedType: e28 } = t3;
          return `Unexpected reserved type ${e28}.`;
        }, UnexpectedReservedUnderscore: "`_` is only allowed as a type argument to call or new.", UnexpectedSpaceBetweenModuloChecks: "Spaces between `%` and `checks` are not allowed here.", UnexpectedSpreadType: "Spread operator cannot appear in class or interface definitions.", UnexpectedSubtractionOperand: 'Unexpected token, expected "number" or "bigint".', UnexpectedTokenAfterTypeParameter: "Expected an arrow function after this type parameter declaration.", UnexpectedTypeParameterBeforeAsyncArrowFunction: "Type parameters must come after the async keyword, e.g. instead of `<T> async () => {}`, use `async <T>() => {}`.", UnsupportedDeclareExportKind: (t3) => {
          let { unsupportedExportKind: e28, suggestion: s3 } = t3;
          return `\`declare export ${e28}\` is not supported. Use \`${s3}\` instead.`;
        }, UnsupportedStatementInDeclareModule: "Only declares and type imports are allowed inside declare module.", UnterminatedFlowComment: "Unterminated flow-comment." });
        function Un2(t3) {
          return t3.type === "DeclareExportAllDeclaration" || t3.type === "DeclareExportDeclaration" && (!t3.declaration || t3.declaration.type !== "TypeAlias" && t3.declaration.type !== "InterfaceDeclaration");
        }
        function gs2(t3) {
          return t3.importKind === "type" || t3.importKind === "typeof";
        }
        function Rr2(t3) {
          return Ae2(t3) && t3 !== 97;
        }
        var _n2 = { const: "declare export var", let: "declare export var", type: "export type", interface: "export interface" };
        function zn2(t3, e28) {
          let s3 = [], r3 = [];
          for (let i = 0; i < t3.length; i++)
            (e28(t3[i], i, t3) ? s3 : r3).push(t3[i]);
          return [s3, r3];
        }
        var Hn2 = /\*?\s*@((?:no)?flow)\b/, $n2 = (t3) => class extends t3 {
          constructor() {
            super(...arguments), this.flowPragma = void 0;
          }
          getScopeHandler() {
            return dn2;
          }
          shouldParseTypes() {
            return this.getPluginOption("flow", "all") || this.flowPragma === "flow";
          }
          shouldParseEnums() {
            return !!this.getPluginOption("flow", "enums");
          }
          finishToken(e28, s3) {
            e28 !== 131 && e28 !== 13 && e28 !== 28 && this.flowPragma === void 0 && (this.flowPragma = null), super.finishToken(e28, s3);
          }
          addComment(e28) {
            if (this.flowPragma === void 0) {
              let s3 = Hn2.exec(e28.value);
              if (s3)
                if (s3[1] === "flow")
                  this.flowPragma = "flow";
                else if (s3[1] === "noflow")
                  this.flowPragma = "noflow";
                else
                  throw new Error("Unexpected flow pragma");
            }
            super.addComment(e28);
          }
          flowParseTypeInitialiser(e28) {
            let s3 = this.state.inType;
            this.state.inType = true, this.expect(e28 || 14);
            let r3 = this.flowParseType();
            return this.state.inType = s3, r3;
          }
          flowParsePredicate() {
            let e28 = this.startNode(), s3 = this.state.startLoc;
            return this.next(), this.expectContextual(108), this.state.lastTokStart > s3.index + 1 && this.raise($3.UnexpectedSpaceBetweenModuloChecks, { at: s3 }), this.eat(10) ? (e28.value = super.parseExpression(), this.expect(11), this.finishNode(e28, "DeclaredPredicate")) : this.finishNode(e28, "InferredPredicate");
          }
          flowParseTypeAndPredicateInitialiser() {
            let e28 = this.state.inType;
            this.state.inType = true, this.expect(14);
            let s3 = null, r3 = null;
            return this.match(54) ? (this.state.inType = e28, r3 = this.flowParsePredicate()) : (s3 = this.flowParseType(), this.state.inType = e28, this.match(54) && (r3 = this.flowParsePredicate())), [s3, r3];
          }
          flowParseDeclareClass(e28) {
            return this.next(), this.flowParseInterfaceish(e28, true), this.finishNode(e28, "DeclareClass");
          }
          flowParseDeclareFunction(e28) {
            this.next();
            let s3 = e28.id = this.parseIdentifier(), r3 = this.startNode(), i = this.startNode();
            this.match(47) ? r3.typeParameters = this.flowParseTypeParameterDeclaration() : r3.typeParameters = null, this.expect(10);
            let a3 = this.flowParseFunctionTypeParams();
            return r3.params = a3.params, r3.rest = a3.rest, r3.this = a3._this, this.expect(11), [r3.returnType, e28.predicate] = this.flowParseTypeAndPredicateInitialiser(), i.typeAnnotation = this.finishNode(r3, "FunctionTypeAnnotation"), s3.typeAnnotation = this.finishNode(i, "TypeAnnotation"), this.resetEndLocation(s3), this.semicolon(), this.scope.declareName(e28.id.name, on2, e28.id.loc.start), this.finishNode(e28, "DeclareFunction");
          }
          flowParseDeclare(e28, s3) {
            if (this.match(80))
              return this.flowParseDeclareClass(e28);
            if (this.match(68))
              return this.flowParseDeclareFunction(e28);
            if (this.match(74))
              return this.flowParseDeclareVariable(e28);
            if (this.eatContextual(125))
              return this.match(16) ? this.flowParseDeclareModuleExports(e28) : (s3 && this.raise($3.NestedDeclareModule, { at: this.state.lastTokStartLoc }), this.flowParseDeclareModule(e28));
            if (this.isContextual(128))
              return this.flowParseDeclareTypeAlias(e28);
            if (this.isContextual(129))
              return this.flowParseDeclareOpaqueType(e28);
            if (this.isContextual(127))
              return this.flowParseDeclareInterface(e28);
            if (this.match(82))
              return this.flowParseDeclareExportDeclaration(e28, s3);
            this.unexpected();
          }
          flowParseDeclareVariable(e28) {
            return this.next(), e28.id = this.flowParseTypeAnnotatableIdentifier(true), this.scope.declareName(e28.id.name, It2, e28.id.loc.start), this.semicolon(), this.finishNode(e28, "DeclareVariable");
          }
          flowParseDeclareModule(e28) {
            this.scope.enter(Xe2), this.match(131) ? e28.id = super.parseExprAtom() : e28.id = this.parseIdentifier();
            let s3 = e28.body = this.startNode(), r3 = s3.body = [];
            for (this.expect(5); !this.match(8); ) {
              let n3 = this.startNode();
              this.match(83) ? (this.next(), !this.isContextual(128) && !this.match(87) && this.raise($3.InvalidNonTypeImportInDeclareModule, { at: this.state.lastTokStartLoc }), super.parseImport(n3)) : (this.expectContextual(123, $3.UnsupportedStatementInDeclareModule), n3 = this.flowParseDeclare(n3, true)), r3.push(n3);
            }
            this.scope.exit(), this.expect(8), this.finishNode(s3, "BlockStatement");
            let i = null, a3 = false;
            return r3.forEach((n3) => {
              Un2(n3) ? (i === "CommonJS" && this.raise($3.AmbiguousDeclareModuleKind, { at: n3 }), i = "ES") : n3.type === "DeclareModuleExports" && (a3 && this.raise($3.DuplicateDeclareModuleExports, { at: n3 }), i === "ES" && this.raise($3.AmbiguousDeclareModuleKind, { at: n3 }), i = "CommonJS", a3 = true);
            }), e28.kind = i || "CommonJS", this.finishNode(e28, "DeclareModule");
          }
          flowParseDeclareExportDeclaration(e28, s3) {
            if (this.expect(82), this.eat(65))
              return this.match(68) || this.match(80) ? e28.declaration = this.flowParseDeclare(this.startNode()) : (e28.declaration = this.flowParseType(), this.semicolon()), e28.default = true, this.finishNode(e28, "DeclareExportDeclaration");
            if (this.match(75) || this.isLet() || (this.isContextual(128) || this.isContextual(127)) && !s3) {
              let r3 = this.state.value;
              throw this.raise($3.UnsupportedDeclareExportKind, { at: this.state.startLoc, unsupportedExportKind: r3, suggestion: _n2[r3] });
            }
            if (this.match(74) || this.match(68) || this.match(80) || this.isContextual(129))
              return e28.declaration = this.flowParseDeclare(this.startNode()), e28.default = false, this.finishNode(e28, "DeclareExportDeclaration");
            if (this.match(55) || this.match(5) || this.isContextual(127) || this.isContextual(128) || this.isContextual(129))
              return e28 = this.parseExport(e28, null), e28.type === "ExportNamedDeclaration" && (e28.type = "ExportDeclaration", e28.default = false, delete e28.exportKind), e28.type = "Declare" + e28.type, e28;
            this.unexpected();
          }
          flowParseDeclareModuleExports(e28) {
            return this.next(), this.expectContextual(109), e28.typeAnnotation = this.flowParseTypeAnnotation(), this.semicolon(), this.finishNode(e28, "DeclareModuleExports");
          }
          flowParseDeclareTypeAlias(e28) {
            this.next();
            let s3 = this.flowParseTypeAlias(e28);
            return s3.type = "DeclareTypeAlias", s3;
          }
          flowParseDeclareOpaqueType(e28) {
            this.next();
            let s3 = this.flowParseOpaqueType(e28, true);
            return s3.type = "DeclareOpaqueType", s3;
          }
          flowParseDeclareInterface(e28) {
            return this.next(), this.flowParseInterfaceish(e28, false), this.finishNode(e28, "DeclareInterface");
          }
          flowParseInterfaceish(e28, s3) {
            if (e28.id = this.flowParseRestrictedIdentifier(!s3, true), this.scope.declareName(e28.id.name, s3 ? br2 : Qe2, e28.id.loc.start), this.match(47) ? e28.typeParameters = this.flowParseTypeParameterDeclaration() : e28.typeParameters = null, e28.extends = [], e28.implements = [], e28.mixins = [], this.eat(81))
              do
                e28.extends.push(this.flowParseInterfaceExtends());
              while (!s3 && this.eat(12));
            if (s3) {
              if (this.eatContextual(115))
                do
                  e28.mixins.push(this.flowParseInterfaceExtends());
                while (this.eat(12));
              if (this.eatContextual(111))
                do
                  e28.implements.push(this.flowParseInterfaceExtends());
                while (this.eat(12));
            }
            e28.body = this.flowParseObjectType({ allowStatic: s3, allowExact: false, allowSpread: false, allowProto: s3, allowInexact: false });
          }
          flowParseInterfaceExtends() {
            let e28 = this.startNode();
            return e28.id = this.flowParseQualifiedTypeIdentifier(), this.match(47) ? e28.typeParameters = this.flowParseTypeParameterInstantiation() : e28.typeParameters = null, this.finishNode(e28, "InterfaceExtends");
          }
          flowParseInterface(e28) {
            return this.flowParseInterfaceish(e28, false), this.finishNode(e28, "InterfaceDeclaration");
          }
          checkNotUnderscore(e28) {
            e28 === "_" && this.raise($3.UnexpectedReservedUnderscore, { at: this.state.startLoc });
          }
          checkReservedType(e28, s3, r3) {
            Rn2.has(e28) && this.raise(r3 ? $3.AssignReservedType : $3.UnexpectedReservedType, { at: s3, reservedType: e28 });
          }
          flowParseRestrictedIdentifier(e28, s3) {
            return this.checkReservedType(this.state.value, this.state.startLoc, s3), this.parseIdentifier(e28);
          }
          flowParseTypeAlias(e28) {
            return e28.id = this.flowParseRestrictedIdentifier(false, true), this.scope.declareName(e28.id.name, Qe2, e28.id.loc.start), this.match(47) ? e28.typeParameters = this.flowParseTypeParameterDeclaration() : e28.typeParameters = null, e28.right = this.flowParseTypeInitialiser(29), this.semicolon(), this.finishNode(e28, "TypeAlias");
          }
          flowParseOpaqueType(e28, s3) {
            return this.expectContextual(128), e28.id = this.flowParseRestrictedIdentifier(true, true), this.scope.declareName(e28.id.name, Qe2, e28.id.loc.start), this.match(47) ? e28.typeParameters = this.flowParseTypeParameterDeclaration() : e28.typeParameters = null, e28.supertype = null, this.match(14) && (e28.supertype = this.flowParseTypeInitialiser(14)), e28.impltype = null, s3 || (e28.impltype = this.flowParseTypeInitialiser(29)), this.semicolon(), this.finishNode(e28, "OpaqueType");
          }
          flowParseTypeParameter() {
            let e28 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, s3 = this.state.startLoc, r3 = this.startNode(), i = this.flowParseVariance(), a3 = this.flowParseTypeAnnotatableIdentifier();
            return r3.name = a3.name, r3.variance = i, r3.bound = a3.typeAnnotation, this.match(29) ? (this.eat(29), r3.default = this.flowParseType()) : e28 && this.raise($3.MissingTypeParamDefault, { at: s3 }), this.finishNode(r3, "TypeParameter");
          }
          flowParseTypeParameterDeclaration() {
            let e28 = this.state.inType, s3 = this.startNode();
            s3.params = [], this.state.inType = true, this.match(47) || this.match(140) ? this.next() : this.unexpected();
            let r3 = false;
            do {
              let i = this.flowParseTypeParameter(r3);
              s3.params.push(i), i.default && (r3 = true), this.match(48) || this.expect(12);
            } while (!this.match(48));
            return this.expect(48), this.state.inType = e28, this.finishNode(s3, "TypeParameterDeclaration");
          }
          flowParseTypeParameterInstantiation() {
            let e28 = this.startNode(), s3 = this.state.inType;
            e28.params = [], this.state.inType = true, this.expect(47);
            let r3 = this.state.noAnonFunctionType;
            for (this.state.noAnonFunctionType = false; !this.match(48); )
              e28.params.push(this.flowParseType()), this.match(48) || this.expect(12);
            return this.state.noAnonFunctionType = r3, this.expect(48), this.state.inType = s3, this.finishNode(e28, "TypeParameterInstantiation");
          }
          flowParseTypeParameterInstantiationCallOrNew() {
            let e28 = this.startNode(), s3 = this.state.inType;
            for (e28.params = [], this.state.inType = true, this.expect(47); !this.match(48); )
              e28.params.push(this.flowParseTypeOrImplicitInstantiation()), this.match(48) || this.expect(12);
            return this.expect(48), this.state.inType = s3, this.finishNode(e28, "TypeParameterInstantiation");
          }
          flowParseInterfaceType() {
            let e28 = this.startNode();
            if (this.expectContextual(127), e28.extends = [], this.eat(81))
              do
                e28.extends.push(this.flowParseInterfaceExtends());
              while (this.eat(12));
            return e28.body = this.flowParseObjectType({ allowStatic: false, allowExact: false, allowSpread: false, allowProto: false, allowInexact: false }), this.finishNode(e28, "InterfaceTypeAnnotation");
          }
          flowParseObjectPropertyKey() {
            return this.match(132) || this.match(131) ? super.parseExprAtom() : this.parseIdentifier(true);
          }
          flowParseObjectTypeIndexer(e28, s3, r3) {
            return e28.static = s3, this.lookahead().type === 14 ? (e28.id = this.flowParseObjectPropertyKey(), e28.key = this.flowParseTypeInitialiser()) : (e28.id = null, e28.key = this.flowParseType()), this.expect(3), e28.value = this.flowParseTypeInitialiser(), e28.variance = r3, this.finishNode(e28, "ObjectTypeIndexer");
          }
          flowParseObjectTypeInternalSlot(e28, s3) {
            return e28.static = s3, e28.id = this.flowParseObjectPropertyKey(), this.expect(3), this.expect(3), this.match(47) || this.match(10) ? (e28.method = true, e28.optional = false, e28.value = this.flowParseObjectTypeMethodish(this.startNodeAt(e28.loc.start))) : (e28.method = false, this.eat(17) && (e28.optional = true), e28.value = this.flowParseTypeInitialiser()), this.finishNode(e28, "ObjectTypeInternalSlot");
          }
          flowParseObjectTypeMethodish(e28) {
            for (e28.params = [], e28.rest = null, e28.typeParameters = null, e28.this = null, this.match(47) && (e28.typeParameters = this.flowParseTypeParameterDeclaration()), this.expect(10), this.match(78) && (e28.this = this.flowParseFunctionTypeParam(true), e28.this.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21); )
              e28.params.push(this.flowParseFunctionTypeParam(false)), this.match(11) || this.expect(12);
            return this.eat(21) && (e28.rest = this.flowParseFunctionTypeParam(false)), this.expect(11), e28.returnType = this.flowParseTypeInitialiser(), this.finishNode(e28, "FunctionTypeAnnotation");
          }
          flowParseObjectTypeCallProperty(e28, s3) {
            let r3 = this.startNode();
            return e28.static = s3, e28.value = this.flowParseObjectTypeMethodish(r3), this.finishNode(e28, "ObjectTypeCallProperty");
          }
          flowParseObjectType(e28) {
            let { allowStatic: s3, allowExact: r3, allowSpread: i, allowProto: a3, allowInexact: n3 } = e28, o3 = this.state.inType;
            this.state.inType = true;
            let h3 = this.startNode();
            h3.callProperties = [], h3.properties = [], h3.indexers = [], h3.internalSlots = [];
            let l3, f3, T3 = false;
            for (r3 && this.match(6) ? (this.expect(6), l3 = 9, f3 = true) : (this.expect(5), l3 = 8, f3 = false), h3.exact = f3; !this.match(l3); ) {
              let B3 = false, se2 = null, re2 = null, ce2 = this.startNode();
              if (a3 && this.isContextual(116)) {
                let oe2 = this.lookahead();
                oe2.type !== 14 && oe2.type !== 17 && (this.next(), se2 = this.state.startLoc, s3 = false);
              }
              if (s3 && this.isContextual(104)) {
                let oe2 = this.lookahead();
                oe2.type !== 14 && oe2.type !== 17 && (this.next(), B3 = true);
              }
              let de2 = this.flowParseVariance();
              if (this.eat(0))
                se2 != null && this.unexpected(se2), this.eat(0) ? (de2 && this.unexpected(de2.loc.start), h3.internalSlots.push(this.flowParseObjectTypeInternalSlot(ce2, B3))) : h3.indexers.push(this.flowParseObjectTypeIndexer(ce2, B3, de2));
              else if (this.match(10) || this.match(47))
                se2 != null && this.unexpected(se2), de2 && this.unexpected(de2.loc.start), h3.callProperties.push(this.flowParseObjectTypeCallProperty(ce2, B3));
              else {
                let oe2 = "init";
                if (this.isContextual(98) || this.isContextual(103)) {
                  let ut2 = this.lookahead();
                  xt2(ut2.type) && (oe2 = this.state.value, this.next());
                }
                let jt2 = this.flowParseObjectTypeProperty(ce2, B3, se2, de2, oe2, i, n3 != null ? n3 : !f3);
                jt2 === null ? (T3 = true, re2 = this.state.lastTokStartLoc) : h3.properties.push(jt2);
              }
              this.flowObjectTypeSemicolon(), re2 && !this.match(8) && !this.match(9) && this.raise($3.UnexpectedExplicitInexactInObject, { at: re2 });
            }
            this.expect(l3), i && (h3.inexact = T3);
            let R3 = this.finishNode(h3, "ObjectTypeAnnotation");
            return this.state.inType = o3, R3;
          }
          flowParseObjectTypeProperty(e28, s3, r3, i, a3, n3, o3) {
            if (this.eat(21))
              return this.match(12) || this.match(13) || this.match(8) || this.match(9) ? (n3 ? o3 || this.raise($3.InexactInsideExact, { at: this.state.lastTokStartLoc }) : this.raise($3.InexactInsideNonObject, { at: this.state.lastTokStartLoc }), i && this.raise($3.InexactVariance, { at: i }), null) : (n3 || this.raise($3.UnexpectedSpreadType, { at: this.state.lastTokStartLoc }), r3 != null && this.unexpected(r3), i && this.raise($3.SpreadVariance, { at: i }), e28.argument = this.flowParseType(), this.finishNode(e28, "ObjectTypeSpreadProperty"));
            {
              e28.key = this.flowParseObjectPropertyKey(), e28.static = s3, e28.proto = r3 != null, e28.kind = a3;
              let h3 = false;
              return this.match(47) || this.match(10) ? (e28.method = true, r3 != null && this.unexpected(r3), i && this.unexpected(i.loc.start), e28.value = this.flowParseObjectTypeMethodish(this.startNodeAt(e28.loc.start)), (a3 === "get" || a3 === "set") && this.flowCheckGetterSetterParams(e28), !n3 && e28.key.name === "constructor" && e28.value.this && this.raise($3.ThisParamBannedInConstructor, { at: e28.value.this })) : (a3 !== "init" && this.unexpected(), e28.method = false, this.eat(17) && (h3 = true), e28.value = this.flowParseTypeInitialiser(), e28.variance = i), e28.optional = h3, this.finishNode(e28, "ObjectTypeProperty");
            }
          }
          flowCheckGetterSetterParams(e28) {
            let s3 = e28.kind === "get" ? 0 : 1, r3 = e28.value.params.length + (e28.value.rest ? 1 : 0);
            e28.value.this && this.raise(e28.kind === "get" ? $3.GetterMayNotHaveThisParam : $3.SetterMayNotHaveThisParam, { at: e28.value.this }), r3 !== s3 && this.raise(e28.kind === "get" ? p3.BadGetterArity : p3.BadSetterArity, { at: e28 }), e28.kind === "set" && e28.value.rest && this.raise(p3.BadSetterRestParameter, { at: e28 });
          }
          flowObjectTypeSemicolon() {
            !this.eat(13) && !this.eat(12) && !this.match(8) && !this.match(9) && this.unexpected();
          }
          flowParseQualifiedTypeIdentifier(e28, s3) {
            e28 != null || (e28 = this.state.startLoc);
            let r3 = s3 || this.flowParseRestrictedIdentifier(true);
            for (; this.eat(16); ) {
              let i = this.startNodeAt(e28);
              i.qualification = r3, i.id = this.flowParseRestrictedIdentifier(true), r3 = this.finishNode(i, "QualifiedTypeIdentifier");
            }
            return r3;
          }
          flowParseGenericType(e28, s3) {
            let r3 = this.startNodeAt(e28);
            return r3.typeParameters = null, r3.id = this.flowParseQualifiedTypeIdentifier(e28, s3), this.match(47) && (r3.typeParameters = this.flowParseTypeParameterInstantiation()), this.finishNode(r3, "GenericTypeAnnotation");
          }
          flowParseTypeofType() {
            let e28 = this.startNode();
            return this.expect(87), e28.argument = this.flowParsePrimaryType(), this.finishNode(e28, "TypeofTypeAnnotation");
          }
          flowParseTupleType() {
            let e28 = this.startNode();
            for (e28.types = [], this.expect(0); this.state.pos < this.length && !this.match(3) && (e28.types.push(this.flowParseType()), !this.match(3)); )
              this.expect(12);
            return this.expect(3), this.finishNode(e28, "TupleTypeAnnotation");
          }
          flowParseFunctionTypeParam(e28) {
            let s3 = null, r3 = false, i = null, a3 = this.startNode(), n3 = this.lookahead(), o3 = this.state.type === 78;
            return n3.type === 14 || n3.type === 17 ? (o3 && !e28 && this.raise($3.ThisParamMustBeFirst, { at: a3 }), s3 = this.parseIdentifier(o3), this.eat(17) && (r3 = true, o3 && this.raise($3.ThisParamMayNotBeOptional, { at: a3 })), i = this.flowParseTypeInitialiser()) : i = this.flowParseType(), a3.name = s3, a3.optional = r3, a3.typeAnnotation = i, this.finishNode(a3, "FunctionTypeParam");
          }
          reinterpretTypeAsFunctionTypeParam(e28) {
            let s3 = this.startNodeAt(e28.loc.start);
            return s3.name = null, s3.optional = false, s3.typeAnnotation = e28, this.finishNode(s3, "FunctionTypeParam");
          }
          flowParseFunctionTypeParams() {
            let e28 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], s3 = null, r3 = null;
            for (this.match(78) && (r3 = this.flowParseFunctionTypeParam(true), r3.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21); )
              e28.push(this.flowParseFunctionTypeParam(false)), this.match(11) || this.expect(12);
            return this.eat(21) && (s3 = this.flowParseFunctionTypeParam(false)), { params: e28, rest: s3, _this: r3 };
          }
          flowIdentToTypeAnnotation(e28, s3, r3) {
            switch (r3.name) {
              case "any":
                return this.finishNode(s3, "AnyTypeAnnotation");
              case "bool":
              case "boolean":
                return this.finishNode(s3, "BooleanTypeAnnotation");
              case "mixed":
                return this.finishNode(s3, "MixedTypeAnnotation");
              case "empty":
                return this.finishNode(s3, "EmptyTypeAnnotation");
              case "number":
                return this.finishNode(s3, "NumberTypeAnnotation");
              case "string":
                return this.finishNode(s3, "StringTypeAnnotation");
              case "symbol":
                return this.finishNode(s3, "SymbolTypeAnnotation");
              default:
                return this.checkNotUnderscore(r3.name), this.flowParseGenericType(e28, r3);
            }
          }
          flowParsePrimaryType() {
            let e28 = this.state.startLoc, s3 = this.startNode(), r3, i, a3 = false, n3 = this.state.noAnonFunctionType;
            switch (this.state.type) {
              case 5:
                return this.flowParseObjectType({ allowStatic: false, allowExact: false, allowSpread: true, allowProto: false, allowInexact: true });
              case 6:
                return this.flowParseObjectType({ allowStatic: false, allowExact: true, allowSpread: true, allowProto: false, allowInexact: false });
              case 0:
                return this.state.noAnonFunctionType = false, i = this.flowParseTupleType(), this.state.noAnonFunctionType = n3, i;
              case 47:
                return s3.typeParameters = this.flowParseTypeParameterDeclaration(), this.expect(10), r3 = this.flowParseFunctionTypeParams(), s3.params = r3.params, s3.rest = r3.rest, s3.this = r3._this, this.expect(11), this.expect(19), s3.returnType = this.flowParseType(), this.finishNode(s3, "FunctionTypeAnnotation");
              case 10:
                if (this.next(), !this.match(11) && !this.match(21))
                  if (te2(this.state.type) || this.match(78)) {
                    let o3 = this.lookahead().type;
                    a3 = o3 !== 17 && o3 !== 14;
                  } else
                    a3 = true;
                if (a3) {
                  if (this.state.noAnonFunctionType = false, i = this.flowParseType(), this.state.noAnonFunctionType = n3, this.state.noAnonFunctionType || !(this.match(12) || this.match(11) && this.lookahead().type === 19))
                    return this.expect(11), i;
                  this.eat(12);
                }
                return i ? r3 = this.flowParseFunctionTypeParams([this.reinterpretTypeAsFunctionTypeParam(i)]) : r3 = this.flowParseFunctionTypeParams(), s3.params = r3.params, s3.rest = r3.rest, s3.this = r3._this, this.expect(11), this.expect(19), s3.returnType = this.flowParseType(), s3.typeParameters = null, this.finishNode(s3, "FunctionTypeAnnotation");
              case 131:
                return this.parseLiteral(this.state.value, "StringLiteralTypeAnnotation");
              case 85:
              case 86:
                return s3.value = this.match(85), this.next(), this.finishNode(s3, "BooleanLiteralTypeAnnotation");
              case 53:
                if (this.state.value === "-") {
                  if (this.next(), this.match(132))
                    return this.parseLiteralAtNode(-this.state.value, "NumberLiteralTypeAnnotation", s3);
                  if (this.match(133))
                    return this.parseLiteralAtNode(-this.state.value, "BigIntLiteralTypeAnnotation", s3);
                  throw this.raise($3.UnexpectedSubtractionOperand, { at: this.state.startLoc });
                }
                this.unexpected();
                return;
              case 132:
                return this.parseLiteral(this.state.value, "NumberLiteralTypeAnnotation");
              case 133:
                return this.parseLiteral(this.state.value, "BigIntLiteralTypeAnnotation");
              case 88:
                return this.next(), this.finishNode(s3, "VoidTypeAnnotation");
              case 84:
                return this.next(), this.finishNode(s3, "NullLiteralTypeAnnotation");
              case 78:
                return this.next(), this.finishNode(s3, "ThisTypeAnnotation");
              case 55:
                return this.next(), this.finishNode(s3, "ExistsTypeAnnotation");
              case 87:
                return this.flowParseTypeofType();
              default:
                if (Gt2(this.state.type)) {
                  let o3 = Be2(this.state.type);
                  return this.next(), super.createIdentifier(s3, o3);
                } else if (te2(this.state.type))
                  return this.isContextual(127) ? this.flowParseInterfaceType() : this.flowIdentToTypeAnnotation(e28, s3, this.parseIdentifier());
            }
            this.unexpected();
          }
          flowParsePostfixType() {
            let e28 = this.state.startLoc, s3 = this.flowParsePrimaryType(), r3 = false;
            for (; (this.match(0) || this.match(18)) && !this.canInsertSemicolon(); ) {
              let i = this.startNodeAt(e28), a3 = this.eat(18);
              r3 = r3 || a3, this.expect(0), !a3 && this.match(3) ? (i.elementType = s3, this.next(), s3 = this.finishNode(i, "ArrayTypeAnnotation")) : (i.objectType = s3, i.indexType = this.flowParseType(), this.expect(3), r3 ? (i.optional = a3, s3 = this.finishNode(i, "OptionalIndexedAccessType")) : s3 = this.finishNode(i, "IndexedAccessType"));
            }
            return s3;
          }
          flowParsePrefixType() {
            let e28 = this.startNode();
            return this.eat(17) ? (e28.typeAnnotation = this.flowParsePrefixType(), this.finishNode(e28, "NullableTypeAnnotation")) : this.flowParsePostfixType();
          }
          flowParseAnonFunctionWithoutParens() {
            let e28 = this.flowParsePrefixType();
            if (!this.state.noAnonFunctionType && this.eat(19)) {
              let s3 = this.startNodeAt(e28.loc.start);
              return s3.params = [this.reinterpretTypeAsFunctionTypeParam(e28)], s3.rest = null, s3.this = null, s3.returnType = this.flowParseType(), s3.typeParameters = null, this.finishNode(s3, "FunctionTypeAnnotation");
            }
            return e28;
          }
          flowParseIntersectionType() {
            let e28 = this.startNode();
            this.eat(45);
            let s3 = this.flowParseAnonFunctionWithoutParens();
            for (e28.types = [s3]; this.eat(45); )
              e28.types.push(this.flowParseAnonFunctionWithoutParens());
            return e28.types.length === 1 ? s3 : this.finishNode(e28, "IntersectionTypeAnnotation");
          }
          flowParseUnionType() {
            let e28 = this.startNode();
            this.eat(43);
            let s3 = this.flowParseIntersectionType();
            for (e28.types = [s3]; this.eat(43); )
              e28.types.push(this.flowParseIntersectionType());
            return e28.types.length === 1 ? s3 : this.finishNode(e28, "UnionTypeAnnotation");
          }
          flowParseType() {
            let e28 = this.state.inType;
            this.state.inType = true;
            let s3 = this.flowParseUnionType();
            return this.state.inType = e28, s3;
          }
          flowParseTypeOrImplicitInstantiation() {
            if (this.state.type === 130 && this.state.value === "_") {
              let e28 = this.state.startLoc, s3 = this.parseIdentifier();
              return this.flowParseGenericType(e28, s3);
            } else
              return this.flowParseType();
          }
          flowParseTypeAnnotation() {
            let e28 = this.startNode();
            return e28.typeAnnotation = this.flowParseTypeInitialiser(), this.finishNode(e28, "TypeAnnotation");
          }
          flowParseTypeAnnotatableIdentifier(e28) {
            let s3 = e28 ? this.parseIdentifier() : this.flowParseRestrictedIdentifier();
            return this.match(14) && (s3.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(s3)), s3;
          }
          typeCastToParameter(e28) {
            return e28.expression.typeAnnotation = e28.typeAnnotation, this.resetEndLocation(e28.expression, e28.typeAnnotation.loc.end), e28.expression;
          }
          flowParseVariance() {
            let e28 = null;
            return this.match(53) ? (e28 = this.startNode(), this.state.value === "+" ? e28.kind = "plus" : e28.kind = "minus", this.next(), this.finishNode(e28, "Variance")) : e28;
          }
          parseFunctionBody(e28, s3) {
            let r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            if (s3) {
              this.forwardNoArrowParamsConversionAt(e28, () => super.parseFunctionBody(e28, true, r3));
              return;
            }
            super.parseFunctionBody(e28, false, r3);
          }
          parseFunctionBodyAndFinish(e28, s3) {
            let r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            if (this.match(14)) {
              let i = this.startNode();
              [i.typeAnnotation, e28.predicate] = this.flowParseTypeAndPredicateInitialiser(), e28.returnType = i.typeAnnotation ? this.finishNode(i, "TypeAnnotation") : null;
            }
            return super.parseFunctionBodyAndFinish(e28, s3, r3);
          }
          parseStatementLike(e28) {
            if (this.state.strict && this.isContextual(127)) {
              let r3 = this.lookahead();
              if (Ae2(r3.type)) {
                let i = this.startNode();
                return this.next(), this.flowParseInterface(i);
              }
            } else if (this.shouldParseEnums() && this.isContextual(124)) {
              let r3 = this.startNode();
              return this.next(), this.flowParseEnumDeclaration(r3);
            }
            let s3 = super.parseStatementLike(e28);
            return this.flowPragma === void 0 && !this.isValidDirective(s3) && (this.flowPragma = null), s3;
          }
          parseExpressionStatement(e28, s3, r3) {
            if (s3.type === "Identifier") {
              if (s3.name === "declare") {
                if (this.match(80) || te2(this.state.type) || this.match(68) || this.match(74) || this.match(82))
                  return this.flowParseDeclare(e28);
              } else if (te2(this.state.type)) {
                if (s3.name === "interface")
                  return this.flowParseInterface(e28);
                if (s3.name === "type")
                  return this.flowParseTypeAlias(e28);
                if (s3.name === "opaque")
                  return this.flowParseOpaqueType(e28, false);
              }
            }
            return super.parseExpressionStatement(e28, s3, r3);
          }
          shouldParseExportDeclaration() {
            let { type: e28 } = this.state;
            return or2(e28) || this.shouldParseEnums() && e28 === 124 ? !this.state.containsEsc : super.shouldParseExportDeclaration();
          }
          isExportDefaultSpecifier() {
            let { type: e28 } = this.state;
            return or2(e28) || this.shouldParseEnums() && e28 === 124 ? this.state.containsEsc : super.isExportDefaultSpecifier();
          }
          parseExportDefaultExpression() {
            if (this.shouldParseEnums() && this.isContextual(124)) {
              let e28 = this.startNode();
              return this.next(), this.flowParseEnumDeclaration(e28);
            }
            return super.parseExportDefaultExpression();
          }
          parseConditional(e28, s3, r3) {
            if (!this.match(17))
              return e28;
            if (this.state.maybeInArrowParameters) {
              let T3 = this.lookaheadCharCode();
              if (T3 === 44 || T3 === 61 || T3 === 58 || T3 === 41)
                return this.setOptionalParametersError(r3), e28;
            }
            this.expect(17);
            let i = this.state.clone(), a3 = this.state.noArrowAt, n3 = this.startNodeAt(s3), { consequent: o3, failed: h3 } = this.tryParseConditionalConsequent(), [l3, f3] = this.getArrowLikeExpressions(o3);
            if (h3 || f3.length > 0) {
              let T3 = [...a3];
              if (f3.length > 0) {
                this.state = i, this.state.noArrowAt = T3;
                for (let R3 = 0; R3 < f3.length; R3++)
                  T3.push(f3[R3].start);
                ({ consequent: o3, failed: h3 } = this.tryParseConditionalConsequent()), [l3, f3] = this.getArrowLikeExpressions(o3);
              }
              h3 && l3.length > 1 && this.raise($3.AmbiguousConditionalArrow, { at: i.startLoc }), h3 && l3.length === 1 && (this.state = i, T3.push(l3[0].start), this.state.noArrowAt = T3, { consequent: o3, failed: h3 } = this.tryParseConditionalConsequent());
            }
            return this.getArrowLikeExpressions(o3, true), this.state.noArrowAt = a3, this.expect(14), n3.test = e28, n3.consequent = o3, n3.alternate = this.forwardNoArrowParamsConversionAt(n3, () => this.parseMaybeAssign(void 0, void 0)), this.finishNode(n3, "ConditionalExpression");
          }
          tryParseConditionalConsequent() {
            this.state.noArrowParamsConversionAt.push(this.state.start);
            let e28 = this.parseMaybeAssignAllowIn(), s3 = !this.match(14);
            return this.state.noArrowParamsConversionAt.pop(), { consequent: e28, failed: s3 };
          }
          getArrowLikeExpressions(e28, s3) {
            let r3 = [e28], i = [];
            for (; r3.length !== 0; ) {
              let a3 = r3.pop();
              a3.type === "ArrowFunctionExpression" ? (a3.typeParameters || !a3.returnType ? this.finishArrowValidation(a3) : i.push(a3), r3.push(a3.body)) : a3.type === "ConditionalExpression" && (r3.push(a3.consequent), r3.push(a3.alternate));
            }
            return s3 ? (i.forEach((a3) => this.finishArrowValidation(a3)), [i, []]) : zn2(i, (a3) => a3.params.every((n3) => this.isAssignable(n3, true)));
          }
          finishArrowValidation(e28) {
            var s3;
            this.toAssignableList(e28.params, (s3 = e28.extra) == null ? void 0 : s3.trailingCommaLoc, false), this.scope.enter(De2 | ss2), super.checkParams(e28, false, true), this.scope.exit();
          }
          forwardNoArrowParamsConversionAt(e28, s3) {
            let r3;
            return this.state.noArrowParamsConversionAt.indexOf(e28.start) !== -1 ? (this.state.noArrowParamsConversionAt.push(this.state.start), r3 = s3(), this.state.noArrowParamsConversionAt.pop()) : r3 = s3(), r3;
          }
          parseParenItem(e28, s3) {
            if (e28 = super.parseParenItem(e28, s3), this.eat(17) && (e28.optional = true, this.resetEndLocation(e28)), this.match(14)) {
              let r3 = this.startNodeAt(s3);
              return r3.expression = e28, r3.typeAnnotation = this.flowParseTypeAnnotation(), this.finishNode(r3, "TypeCastExpression");
            }
            return e28;
          }
          assertModuleNodeAllowed(e28) {
            e28.type === "ImportDeclaration" && (e28.importKind === "type" || e28.importKind === "typeof") || e28.type === "ExportNamedDeclaration" && e28.exportKind === "type" || e28.type === "ExportAllDeclaration" && e28.exportKind === "type" || super.assertModuleNodeAllowed(e28);
          }
          parseExport(e28, s3) {
            let r3 = super.parseExport(e28, s3);
            return (r3.type === "ExportNamedDeclaration" || r3.type === "ExportAllDeclaration") && (r3.exportKind = r3.exportKind || "value"), r3;
          }
          parseExportDeclaration(e28) {
            if (this.isContextual(128)) {
              e28.exportKind = "type";
              let s3 = this.startNode();
              return this.next(), this.match(5) ? (e28.specifiers = this.parseExportSpecifiers(true), super.parseExportFrom(e28), null) : this.flowParseTypeAlias(s3);
            } else if (this.isContextual(129)) {
              e28.exportKind = "type";
              let s3 = this.startNode();
              return this.next(), this.flowParseOpaqueType(s3, false);
            } else if (this.isContextual(127)) {
              e28.exportKind = "type";
              let s3 = this.startNode();
              return this.next(), this.flowParseInterface(s3);
            } else if (this.shouldParseEnums() && this.isContextual(124)) {
              e28.exportKind = "value";
              let s3 = this.startNode();
              return this.next(), this.flowParseEnumDeclaration(s3);
            } else
              return super.parseExportDeclaration(e28);
          }
          eatExportStar(e28) {
            return super.eatExportStar(e28) ? true : this.isContextual(128) && this.lookahead().type === 55 ? (e28.exportKind = "type", this.next(), this.next(), true) : false;
          }
          maybeParseExportNamespaceSpecifier(e28) {
            let { startLoc: s3 } = this.state, r3 = super.maybeParseExportNamespaceSpecifier(e28);
            return r3 && e28.exportKind === "type" && this.unexpected(s3), r3;
          }
          parseClassId(e28, s3, r3) {
            super.parseClassId(e28, s3, r3), this.match(47) && (e28.typeParameters = this.flowParseTypeParameterDeclaration());
          }
          parseClassMember(e28, s3, r3) {
            let { startLoc: i } = this.state;
            if (this.isContextual(123)) {
              if (super.parseClassMemberFromModifier(e28, s3))
                return;
              s3.declare = true;
            }
            super.parseClassMember(e28, s3, r3), s3.declare && (s3.type !== "ClassProperty" && s3.type !== "ClassPrivateProperty" && s3.type !== "PropertyDefinition" ? this.raise($3.DeclareClassElement, { at: i }) : s3.value && this.raise($3.DeclareClassFieldInitializer, { at: s3.value }));
          }
          isIterator(e28) {
            return e28 === "iterator" || e28 === "asyncIterator";
          }
          readIterator() {
            let e28 = super.readWord1(), s3 = "@@" + e28;
            (!this.isIterator(e28) || !this.state.inType) && this.raise(p3.InvalidIdentifier, { at: this.state.curPosition(), identifierName: s3 }), this.finishToken(130, s3);
          }
          getTokenFromCode(e28) {
            let s3 = this.input.charCodeAt(this.state.pos + 1);
            e28 === 123 && s3 === 124 ? this.finishOp(6, 2) : this.state.inType && (e28 === 62 || e28 === 60) ? this.finishOp(e28 === 62 ? 48 : 47, 1) : this.state.inType && e28 === 63 ? s3 === 46 ? this.finishOp(18, 2) : this.finishOp(17, 1) : Ya2(e28, s3, this.input.charCodeAt(this.state.pos + 2)) ? (this.state.pos += 2, this.readIterator()) : super.getTokenFromCode(e28);
          }
          isAssignable(e28, s3) {
            return e28.type === "TypeCastExpression" ? this.isAssignable(e28.expression, s3) : super.isAssignable(e28, s3);
          }
          toAssignable(e28) {
            let s3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            !s3 && e28.type === "AssignmentExpression" && e28.left.type === "TypeCastExpression" && (e28.left = this.typeCastToParameter(e28.left)), super.toAssignable(e28, s3);
          }
          toAssignableList(e28, s3, r3) {
            for (let i = 0; i < e28.length; i++) {
              let a3 = e28[i];
              (a3 == null ? void 0 : a3.type) === "TypeCastExpression" && (e28[i] = this.typeCastToParameter(a3));
            }
            super.toAssignableList(e28, s3, r3);
          }
          toReferencedList(e28, s3) {
            for (let i = 0; i < e28.length; i++) {
              var r3;
              let a3 = e28[i];
              a3 && a3.type === "TypeCastExpression" && !((r3 = a3.extra) != null && r3.parenthesized) && (e28.length > 1 || !s3) && this.raise($3.TypeCastInPattern, { at: a3.typeAnnotation });
            }
            return e28;
          }
          parseArrayLike(e28, s3, r3, i) {
            let a3 = super.parseArrayLike(e28, s3, r3, i);
            return s3 && !this.state.maybeInArrowParameters && this.toReferencedList(a3.elements), a3;
          }
          isValidLVal(e28, s3, r3) {
            return e28 === "TypeCastExpression" || super.isValidLVal(e28, s3, r3);
          }
          parseClassProperty(e28) {
            return this.match(14) && (e28.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassProperty(e28);
          }
          parseClassPrivateProperty(e28) {
            return this.match(14) && (e28.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassPrivateProperty(e28);
          }
          isClassMethod() {
            return this.match(47) || super.isClassMethod();
          }
          isClassProperty() {
            return this.match(14) || super.isClassProperty();
          }
          isNonstaticConstructor(e28) {
            return !this.match(14) && super.isNonstaticConstructor(e28);
          }
          pushClassMethod(e28, s3, r3, i, a3, n3) {
            if (s3.variance && this.unexpected(s3.variance.loc.start), delete s3.variance, this.match(47) && (s3.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassMethod(e28, s3, r3, i, a3, n3), s3.params && a3) {
              let o3 = s3.params;
              o3.length > 0 && this.isThisParam(o3[0]) && this.raise($3.ThisParamBannedInConstructor, { at: s3 });
            } else if (s3.type === "MethodDefinition" && a3 && s3.value.params) {
              let o3 = s3.value.params;
              o3.length > 0 && this.isThisParam(o3[0]) && this.raise($3.ThisParamBannedInConstructor, { at: s3 });
            }
          }
          pushClassPrivateMethod(e28, s3, r3, i) {
            s3.variance && this.unexpected(s3.variance.loc.start), delete s3.variance, this.match(47) && (s3.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassPrivateMethod(e28, s3, r3, i);
          }
          parseClassSuper(e28) {
            if (super.parseClassSuper(e28), e28.superClass && this.match(47) && (e28.superTypeParameters = this.flowParseTypeParameterInstantiation()), this.isContextual(111)) {
              this.next();
              let s3 = e28.implements = [];
              do {
                let r3 = this.startNode();
                r3.id = this.flowParseRestrictedIdentifier(true), this.match(47) ? r3.typeParameters = this.flowParseTypeParameterInstantiation() : r3.typeParameters = null, s3.push(this.finishNode(r3, "ClassImplements"));
              } while (this.eat(12));
            }
          }
          checkGetterSetterParams(e28) {
            super.checkGetterSetterParams(e28);
            let s3 = this.getObjectOrClassMethodParams(e28);
            if (s3.length > 0) {
              let r3 = s3[0];
              this.isThisParam(r3) && e28.kind === "get" ? this.raise($3.GetterMayNotHaveThisParam, { at: r3 }) : this.isThisParam(r3) && this.raise($3.SetterMayNotHaveThisParam, { at: r3 });
            }
          }
          parsePropertyNamePrefixOperator(e28) {
            e28.variance = this.flowParseVariance();
          }
          parseObjPropValue(e28, s3, r3, i, a3, n3, o3) {
            e28.variance && this.unexpected(e28.variance.loc.start), delete e28.variance;
            let h3;
            this.match(47) && !n3 && (h3 = this.flowParseTypeParameterDeclaration(), this.match(10) || this.unexpected());
            let l3 = super.parseObjPropValue(e28, s3, r3, i, a3, n3, o3);
            return h3 && ((l3.value || l3).typeParameters = h3), l3;
          }
          parseAssignableListItemTypes(e28) {
            return this.eat(17) && (e28.type !== "Identifier" && this.raise($3.PatternIsOptional, { at: e28 }), this.isThisParam(e28) && this.raise($3.ThisParamMayNotBeOptional, { at: e28 }), e28.optional = true), this.match(14) ? e28.typeAnnotation = this.flowParseTypeAnnotation() : this.isThisParam(e28) && this.raise($3.ThisParamAnnotationRequired, { at: e28 }), this.match(29) && this.isThisParam(e28) && this.raise($3.ThisParamNoDefault, { at: e28 }), this.resetEndLocation(e28), e28;
          }
          parseMaybeDefault(e28, s3) {
            let r3 = super.parseMaybeDefault(e28, s3);
            return r3.type === "AssignmentPattern" && r3.typeAnnotation && r3.right.start < r3.typeAnnotation.start && this.raise($3.TypeBeforeInitializer, { at: r3.typeAnnotation }), r3;
          }
          shouldParseDefaultImport(e28) {
            return gs2(e28) ? Rr2(this.state.type) : super.shouldParseDefaultImport(e28);
          }
          checkImportReflection(e28) {
            super.checkImportReflection(e28), e28.module && e28.importKind !== "value" && this.raise($3.ImportReflectionHasImportType, { at: e28.specifiers[0].loc.start });
          }
          parseImportSpecifierLocal(e28, s3, r3) {
            s3.local = gs2(e28) ? this.flowParseRestrictedIdentifier(true, true) : this.parseIdentifier(), e28.specifiers.push(this.finishImportSpecifier(s3, r3));
          }
          maybeParseDefaultImportSpecifier(e28) {
            e28.importKind = "value";
            let s3 = null;
            if (this.match(87) ? s3 = "typeof" : this.isContextual(128) && (s3 = "type"), s3) {
              let r3 = this.lookahead(), { type: i } = r3;
              s3 === "type" && i === 55 && this.unexpected(null, r3.type), (Rr2(i) || i === 5 || i === 55) && (this.next(), e28.importKind = s3);
            }
            return super.maybeParseDefaultImportSpecifier(e28);
          }
          parseImportSpecifier(e28, s3, r3, i, a3) {
            let n3 = e28.imported, o3 = null;
            n3.type === "Identifier" && (n3.name === "type" ? o3 = "type" : n3.name === "typeof" && (o3 = "typeof"));
            let h3 = false;
            if (this.isContextual(93) && !this.isLookaheadContextual("as")) {
              let f3 = this.parseIdentifier(true);
              o3 !== null && !Ae2(this.state.type) ? (e28.imported = f3, e28.importKind = o3, e28.local = Fe2(f3)) : (e28.imported = n3, e28.importKind = null, e28.local = this.parseIdentifier());
            } else {
              if (o3 !== null && Ae2(this.state.type))
                e28.imported = this.parseIdentifier(true), e28.importKind = o3;
              else {
                if (s3)
                  throw this.raise(p3.ImportBindingIsString, { at: e28, importName: n3.value });
                e28.imported = n3, e28.importKind = null;
              }
              this.eatContextual(93) ? e28.local = this.parseIdentifier() : (h3 = true, e28.local = Fe2(e28.imported));
            }
            let l3 = gs2(e28);
            return r3 && l3 && this.raise($3.ImportTypeShorthandOnlyInPureImport, { at: e28 }), (r3 || l3) && this.checkReservedType(e28.local.name, e28.local.loc.start, true), h3 && !r3 && !l3 && this.checkReservedWord(e28.local.name, e28.loc.start, true, true), this.finishImportSpecifier(e28, "ImportSpecifier");
          }
          parseBindingAtom() {
            switch (this.state.type) {
              case 78:
                return this.parseIdentifier(true);
              default:
                return super.parseBindingAtom();
            }
          }
          parseFunctionParams(e28, s3) {
            let r3 = e28.kind;
            r3 !== "get" && r3 !== "set" && this.match(47) && (e28.typeParameters = this.flowParseTypeParameterDeclaration()), super.parseFunctionParams(e28, s3);
          }
          parseVarId(e28, s3) {
            super.parseVarId(e28, s3), this.match(14) && (e28.id.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(e28.id));
          }
          parseAsyncArrowFromCallExpression(e28, s3) {
            if (this.match(14)) {
              let r3 = this.state.noAnonFunctionType;
              this.state.noAnonFunctionType = true, e28.returnType = this.flowParseTypeAnnotation(), this.state.noAnonFunctionType = r3;
            }
            return super.parseAsyncArrowFromCallExpression(e28, s3);
          }
          shouldParseAsyncArrow() {
            return this.match(14) || super.shouldParseAsyncArrow();
          }
          parseMaybeAssign(e28, s3) {
            var r3;
            let i = null, a3;
            if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
              if (i = this.state.clone(), a3 = this.tryParse(() => super.parseMaybeAssign(e28, s3), i), !a3.error)
                return a3.node;
              let { context: h3 } = this.state, l3 = h3[h3.length - 1];
              (l3 === g3.j_oTag || l3 === g3.j_expr) && h3.pop();
            }
            if ((r3 = a3) != null && r3.error || this.match(47)) {
              var n3, o3;
              i = i || this.state.clone();
              let h3, l3 = this.tryParse((T3) => {
                var R3;
                h3 = this.flowParseTypeParameterDeclaration();
                let B3 = this.forwardNoArrowParamsConversionAt(h3, () => {
                  let re2 = super.parseMaybeAssign(e28, s3);
                  return this.resetStartLocationFromNode(re2, h3), re2;
                });
                (R3 = B3.extra) != null && R3.parenthesized && T3();
                let se2 = this.maybeUnwrapTypeCastExpression(B3);
                return se2.type !== "ArrowFunctionExpression" && T3(), se2.typeParameters = h3, this.resetStartLocationFromNode(se2, h3), B3;
              }, i), f3 = null;
              if (l3.node && this.maybeUnwrapTypeCastExpression(l3.node).type === "ArrowFunctionExpression") {
                if (!l3.error && !l3.aborted)
                  return l3.node.async && this.raise($3.UnexpectedTypeParameterBeforeAsyncArrowFunction, { at: h3 }), l3.node;
                f3 = l3.node;
              }
              if ((n3 = a3) != null && n3.node)
                return this.state = a3.failState, a3.node;
              if (f3)
                return this.state = l3.failState, f3;
              throw (o3 = a3) != null && o3.thrown ? a3.error : l3.thrown ? l3.error : this.raise($3.UnexpectedTokenAfterTypeParameter, { at: h3 });
            }
            return super.parseMaybeAssign(e28, s3);
          }
          parseArrow(e28) {
            if (this.match(14)) {
              let s3 = this.tryParse(() => {
                let r3 = this.state.noAnonFunctionType;
                this.state.noAnonFunctionType = true;
                let i = this.startNode();
                return [i.typeAnnotation, e28.predicate] = this.flowParseTypeAndPredicateInitialiser(), this.state.noAnonFunctionType = r3, this.canInsertSemicolon() && this.unexpected(), this.match(19) || this.unexpected(), i;
              });
              if (s3.thrown)
                return null;
              s3.error && (this.state = s3.failState), e28.returnType = s3.node.typeAnnotation ? this.finishNode(s3.node, "TypeAnnotation") : null;
            }
            return super.parseArrow(e28);
          }
          shouldParseArrow(e28) {
            return this.match(14) || super.shouldParseArrow(e28);
          }
          setArrowFunctionParameters(e28, s3) {
            this.state.noArrowParamsConversionAt.indexOf(e28.start) !== -1 ? e28.params = s3 : super.setArrowFunctionParameters(e28, s3);
          }
          checkParams(e28, s3, r3) {
            let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
            if (!(r3 && this.state.noArrowParamsConversionAt.indexOf(e28.start) !== -1)) {
              for (let a3 = 0; a3 < e28.params.length; a3++)
                this.isThisParam(e28.params[a3]) && a3 > 0 && this.raise($3.ThisParamMustBeFirst, { at: e28.params[a3] });
              super.checkParams(e28, s3, r3, i);
            }
          }
          parseParenAndDistinguishExpression(e28) {
            return super.parseParenAndDistinguishExpression(e28 && this.state.noArrowAt.indexOf(this.state.start) === -1);
          }
          parseSubscripts(e28, s3, r3) {
            if (e28.type === "Identifier" && e28.name === "async" && this.state.noArrowAt.indexOf(s3.index) !== -1) {
              this.next();
              let i = this.startNodeAt(s3);
              i.callee = e28, i.arguments = super.parseCallExpressionArguments(11, false), e28 = this.finishNode(i, "CallExpression");
            } else if (e28.type === "Identifier" && e28.name === "async" && this.match(47)) {
              let i = this.state.clone(), a3 = this.tryParse((o3) => this.parseAsyncArrowWithTypeParameters(s3) || o3(), i);
              if (!a3.error && !a3.aborted)
                return a3.node;
              let n3 = this.tryParse(() => super.parseSubscripts(e28, s3, r3), i);
              if (n3.node && !n3.error)
                return n3.node;
              if (a3.node)
                return this.state = a3.failState, a3.node;
              if (n3.node)
                return this.state = n3.failState, n3.node;
              throw a3.error || n3.error;
            }
            return super.parseSubscripts(e28, s3, r3);
          }
          parseSubscript(e28, s3, r3, i) {
            if (this.match(18) && this.isLookaheadToken_lt()) {
              if (i.optionalChainMember = true, r3)
                return i.stop = true, e28;
              this.next();
              let a3 = this.startNodeAt(s3);
              return a3.callee = e28, a3.typeArguments = this.flowParseTypeParameterInstantiation(), this.expect(10), a3.arguments = this.parseCallExpressionArguments(11, false), a3.optional = true, this.finishCallExpression(a3, true);
            } else if (!r3 && this.shouldParseTypes() && this.match(47)) {
              let a3 = this.startNodeAt(s3);
              a3.callee = e28;
              let n3 = this.tryParse(() => (a3.typeArguments = this.flowParseTypeParameterInstantiationCallOrNew(), this.expect(10), a3.arguments = super.parseCallExpressionArguments(11, false), i.optionalChainMember && (a3.optional = false), this.finishCallExpression(a3, i.optionalChainMember)));
              if (n3.node)
                return n3.error && (this.state = n3.failState), n3.node;
            }
            return super.parseSubscript(e28, s3, r3, i);
          }
          parseNewCallee(e28) {
            super.parseNewCallee(e28);
            let s3 = null;
            this.shouldParseTypes() && this.match(47) && (s3 = this.tryParse(() => this.flowParseTypeParameterInstantiationCallOrNew()).node), e28.typeArguments = s3;
          }
          parseAsyncArrowWithTypeParameters(e28) {
            let s3 = this.startNodeAt(e28);
            if (this.parseFunctionParams(s3, false), !!this.parseArrow(s3))
              return super.parseArrowExpression(s3, void 0, true);
          }
          readToken_mult_modulo(e28) {
            let s3 = this.input.charCodeAt(this.state.pos + 1);
            if (e28 === 42 && s3 === 47 && this.state.hasFlowComment) {
              this.state.hasFlowComment = false, this.state.pos += 2, this.nextToken();
              return;
            }
            super.readToken_mult_modulo(e28);
          }
          readToken_pipe_amp(e28) {
            let s3 = this.input.charCodeAt(this.state.pos + 1);
            if (e28 === 124 && s3 === 125) {
              this.finishOp(9, 2);
              return;
            }
            super.readToken_pipe_amp(e28);
          }
          parseTopLevel(e28, s3) {
            let r3 = super.parseTopLevel(e28, s3);
            return this.state.hasFlowComment && this.raise($3.UnterminatedFlowComment, { at: this.state.curPosition() }), r3;
          }
          skipBlockComment() {
            if (this.hasPlugin("flowComments") && this.skipFlowComment()) {
              if (this.state.hasFlowComment)
                throw this.raise($3.NestedFlowComment, { at: this.state.startLoc });
              this.hasFlowCommentCompletion();
              let e28 = this.skipFlowComment();
              e28 && (this.state.pos += e28, this.state.hasFlowComment = true);
              return;
            }
            return super.skipBlockComment(this.state.hasFlowComment ? "*-/" : "*/");
          }
          skipFlowComment() {
            let { pos: e28 } = this.state, s3 = 2;
            for (; [32, 9].includes(this.input.charCodeAt(e28 + s3)); )
              s3++;
            let r3 = this.input.charCodeAt(s3 + e28), i = this.input.charCodeAt(s3 + e28 + 1);
            return r3 === 58 && i === 58 ? s3 + 2 : this.input.slice(s3 + e28, s3 + e28 + 12) === "flow-include" ? s3 + 12 : r3 === 58 && i !== 58 ? s3 : false;
          }
          hasFlowCommentCompletion() {
            if (this.input.indexOf("*/", this.state.pos) === -1)
              throw this.raise(p3.UnterminatedComment, { at: this.state.curPosition() });
          }
          flowEnumErrorBooleanMemberNotInitialized(e28, s3) {
            let { enumName: r3, memberName: i } = s3;
            this.raise($3.EnumBooleanMemberNotInitialized, { at: e28, memberName: i, enumName: r3 });
          }
          flowEnumErrorInvalidMemberInitializer(e28, s3) {
            return this.raise(s3.explicitType ? s3.explicitType === "symbol" ? $3.EnumInvalidMemberInitializerSymbolType : $3.EnumInvalidMemberInitializerPrimaryType : $3.EnumInvalidMemberInitializerUnknownType, Object.assign({ at: e28 }, s3));
          }
          flowEnumErrorNumberMemberNotInitialized(e28, s3) {
            let { enumName: r3, memberName: i } = s3;
            this.raise($3.EnumNumberMemberNotInitialized, { at: e28, enumName: r3, memberName: i });
          }
          flowEnumErrorStringMemberInconsistentlyInitailized(e28, s3) {
            let { enumName: r3 } = s3;
            this.raise($3.EnumStringMemberInconsistentlyInitailized, { at: e28, enumName: r3 });
          }
          flowEnumMemberInit() {
            let e28 = this.state.startLoc, s3 = () => this.match(12) || this.match(8);
            switch (this.state.type) {
              case 132: {
                let r3 = this.parseNumericLiteral(this.state.value);
                return s3() ? { type: "number", loc: r3.loc.start, value: r3 } : { type: "invalid", loc: e28 };
              }
              case 131: {
                let r3 = this.parseStringLiteral(this.state.value);
                return s3() ? { type: "string", loc: r3.loc.start, value: r3 } : { type: "invalid", loc: e28 };
              }
              case 85:
              case 86: {
                let r3 = this.parseBooleanLiteral(this.match(85));
                return s3() ? { type: "boolean", loc: r3.loc.start, value: r3 } : { type: "invalid", loc: e28 };
              }
              default:
                return { type: "invalid", loc: e28 };
            }
          }
          flowEnumMemberRaw() {
            let e28 = this.state.startLoc, s3 = this.parseIdentifier(true), r3 = this.eat(29) ? this.flowEnumMemberInit() : { type: "none", loc: e28 };
            return { id: s3, init: r3 };
          }
          flowEnumCheckExplicitTypeMismatch(e28, s3, r3) {
            let { explicitType: i } = s3;
            i !== null && i !== r3 && this.flowEnumErrorInvalidMemberInitializer(e28, s3);
          }
          flowEnumMembers(e28) {
            let { enumName: s3, explicitType: r3 } = e28, i = /* @__PURE__ */ new Set(), a3 = { booleanMembers: [], numberMembers: [], stringMembers: [], defaultedMembers: [] }, n3 = false;
            for (; !this.match(8); ) {
              if (this.eat(21)) {
                n3 = true;
                break;
              }
              let o3 = this.startNode(), { id: h3, init: l3 } = this.flowEnumMemberRaw(), f3 = h3.name;
              if (f3 === "")
                continue;
              /^[a-z]/.test(f3) && this.raise($3.EnumInvalidMemberName, { at: h3, memberName: f3, suggestion: f3[0].toUpperCase() + f3.slice(1), enumName: s3 }), i.has(f3) && this.raise($3.EnumDuplicateMemberName, { at: h3, memberName: f3, enumName: s3 }), i.add(f3);
              let T3 = { enumName: s3, explicitType: r3, memberName: f3 };
              switch (o3.id = h3, l3.type) {
                case "boolean": {
                  this.flowEnumCheckExplicitTypeMismatch(l3.loc, T3, "boolean"), o3.init = l3.value, a3.booleanMembers.push(this.finishNode(o3, "EnumBooleanMember"));
                  break;
                }
                case "number": {
                  this.flowEnumCheckExplicitTypeMismatch(l3.loc, T3, "number"), o3.init = l3.value, a3.numberMembers.push(this.finishNode(o3, "EnumNumberMember"));
                  break;
                }
                case "string": {
                  this.flowEnumCheckExplicitTypeMismatch(l3.loc, T3, "string"), o3.init = l3.value, a3.stringMembers.push(this.finishNode(o3, "EnumStringMember"));
                  break;
                }
                case "invalid":
                  throw this.flowEnumErrorInvalidMemberInitializer(l3.loc, T3);
                case "none":
                  switch (r3) {
                    case "boolean":
                      this.flowEnumErrorBooleanMemberNotInitialized(l3.loc, T3);
                      break;
                    case "number":
                      this.flowEnumErrorNumberMemberNotInitialized(l3.loc, T3);
                      break;
                    default:
                      a3.defaultedMembers.push(this.finishNode(o3, "EnumDefaultedMember"));
                  }
              }
              this.match(8) || this.expect(12);
            }
            return { members: a3, hasUnknownMembers: n3 };
          }
          flowEnumStringMembers(e28, s3, r3) {
            let { enumName: i } = r3;
            if (e28.length === 0)
              return s3;
            if (s3.length === 0)
              return e28;
            if (s3.length > e28.length) {
              for (let a3 of e28)
                this.flowEnumErrorStringMemberInconsistentlyInitailized(a3, { enumName: i });
              return s3;
            } else {
              for (let a3 of s3)
                this.flowEnumErrorStringMemberInconsistentlyInitailized(a3, { enumName: i });
              return e28;
            }
          }
          flowEnumParseExplicitType(e28) {
            let { enumName: s3 } = e28;
            if (!this.eatContextual(101))
              return null;
            if (!te2(this.state.type))
              throw this.raise($3.EnumInvalidExplicitTypeUnknownSupplied, { at: this.state.startLoc, enumName: s3 });
            let { value: r3 } = this.state;
            return this.next(), r3 !== "boolean" && r3 !== "number" && r3 !== "string" && r3 !== "symbol" && this.raise($3.EnumInvalidExplicitType, { at: this.state.startLoc, enumName: s3, invalidEnumType: r3 }), r3;
          }
          flowEnumBody(e28, s3) {
            let r3 = s3.name, i = s3.loc.start, a3 = this.flowEnumParseExplicitType({ enumName: r3 });
            this.expect(5);
            let { members: n3, hasUnknownMembers: o3 } = this.flowEnumMembers({ enumName: r3, explicitType: a3 });
            switch (e28.hasUnknownMembers = o3, a3) {
              case "boolean":
                return e28.explicitType = true, e28.members = n3.booleanMembers, this.expect(8), this.finishNode(e28, "EnumBooleanBody");
              case "number":
                return e28.explicitType = true, e28.members = n3.numberMembers, this.expect(8), this.finishNode(e28, "EnumNumberBody");
              case "string":
                return e28.explicitType = true, e28.members = this.flowEnumStringMembers(n3.stringMembers, n3.defaultedMembers, { enumName: r3 }), this.expect(8), this.finishNode(e28, "EnumStringBody");
              case "symbol":
                return e28.members = n3.defaultedMembers, this.expect(8), this.finishNode(e28, "EnumSymbolBody");
              default: {
                let h3 = () => (e28.members = [], this.expect(8), this.finishNode(e28, "EnumStringBody"));
                e28.explicitType = false;
                let l3 = n3.booleanMembers.length, f3 = n3.numberMembers.length, T3 = n3.stringMembers.length, R3 = n3.defaultedMembers.length;
                if (!l3 && !f3 && !T3 && !R3)
                  return h3();
                if (!l3 && !f3)
                  return e28.members = this.flowEnumStringMembers(n3.stringMembers, n3.defaultedMembers, { enumName: r3 }), this.expect(8), this.finishNode(e28, "EnumStringBody");
                if (!f3 && !T3 && l3 >= R3) {
                  for (let B3 of n3.defaultedMembers)
                    this.flowEnumErrorBooleanMemberNotInitialized(B3.loc.start, { enumName: r3, memberName: B3.id.name });
                  return e28.members = n3.booleanMembers, this.expect(8), this.finishNode(e28, "EnumBooleanBody");
                } else if (!l3 && !T3 && f3 >= R3) {
                  for (let B3 of n3.defaultedMembers)
                    this.flowEnumErrorNumberMemberNotInitialized(B3.loc.start, { enumName: r3, memberName: B3.id.name });
                  return e28.members = n3.numberMembers, this.expect(8), this.finishNode(e28, "EnumNumberBody");
                } else
                  return this.raise($3.EnumInconsistentMemberValues, { at: i, enumName: r3 }), h3();
              }
            }
          }
          flowParseEnumDeclaration(e28) {
            let s3 = this.parseIdentifier();
            return e28.id = s3, e28.body = this.flowEnumBody(this.startNode(), s3), this.finishNode(e28, "EnumDeclaration");
          }
          isLookaheadToken_lt() {
            let e28 = this.nextTokenStart();
            if (this.input.charCodeAt(e28) === 60) {
              let s3 = this.input.charCodeAt(e28 + 1);
              return s3 !== 60 && s3 !== 61;
            }
            return false;
          }
          maybeUnwrapTypeCastExpression(e28) {
            return e28.type === "TypeCastExpression" ? e28.expression : e28;
          }
        }, Vn2 = { __proto__: null, quot: '"', amp: "&", apos: "'", lt: "<", gt: ">", nbsp: "\xA0", iexcl: "\xA1", cent: "\xA2", pound: "\xA3", curren: "\xA4", yen: "\xA5", brvbar: "\xA6", sect: "\xA7", uml: "\xA8", copy: "\xA9", ordf: "\xAA", laquo: "\xAB", not: "\xAC", shy: "\xAD", reg: "\xAE", macr: "\xAF", deg: "\xB0", plusmn: "\xB1", sup2: "\xB2", sup3: "\xB3", acute: "\xB4", micro: "\xB5", para: "\xB6", middot: "\xB7", cedil: "\xB8", sup1: "\xB9", ordm: "\xBA", raquo: "\xBB", frac14: "\xBC", frac12: "\xBD", frac34: "\xBE", iquest: "\xBF", Agrave: "\xC0", Aacute: "\xC1", Acirc: "\xC2", Atilde: "\xC3", Auml: "\xC4", Aring: "\xC5", AElig: "\xC6", Ccedil: "\xC7", Egrave: "\xC8", Eacute: "\xC9", Ecirc: "\xCA", Euml: "\xCB", Igrave: "\xCC", Iacute: "\xCD", Icirc: "\xCE", Iuml: "\xCF", ETH: "\xD0", Ntilde: "\xD1", Ograve: "\xD2", Oacute: "\xD3", Ocirc: "\xD4", Otilde: "\xD5", Ouml: "\xD6", times: "\xD7", Oslash: "\xD8", Ugrave: "\xD9", Uacute: "\xDA", Ucirc: "\xDB", Uuml: "\xDC", Yacute: "\xDD", THORN: "\xDE", szlig: "\xDF", agrave: "\xE0", aacute: "\xE1", acirc: "\xE2", atilde: "\xE3", auml: "\xE4", aring: "\xE5", aelig: "\xE6", ccedil: "\xE7", egrave: "\xE8", eacute: "\xE9", ecirc: "\xEA", euml: "\xEB", igrave: "\xEC", iacute: "\xED", icirc: "\xEE", iuml: "\xEF", eth: "\xF0", ntilde: "\xF1", ograve: "\xF2", oacute: "\xF3", ocirc: "\xF4", otilde: "\xF5", ouml: "\xF6", divide: "\xF7", oslash: "\xF8", ugrave: "\xF9", uacute: "\xFA", ucirc: "\xFB", uuml: "\xFC", yacute: "\xFD", thorn: "\xFE", yuml: "\xFF", OElig: "\u0152", oelig: "\u0153", Scaron: "\u0160", scaron: "\u0161", Yuml: "\u0178", fnof: "\u0192", circ: "\u02C6", tilde: "\u02DC", Alpha: "\u0391", Beta: "\u0392", Gamma: "\u0393", Delta: "\u0394", Epsilon: "\u0395", Zeta: "\u0396", Eta: "\u0397", Theta: "\u0398", Iota: "\u0399", Kappa: "\u039A", Lambda: "\u039B", Mu: "\u039C", Nu: "\u039D", Xi: "\u039E", Omicron: "\u039F", Pi: "\u03A0", Rho: "\u03A1", Sigma: "\u03A3", Tau: "\u03A4", Upsilon: "\u03A5", Phi: "\u03A6", Chi: "\u03A7", Psi: "\u03A8", Omega: "\u03A9", alpha: "\u03B1", beta: "\u03B2", gamma: "\u03B3", delta: "\u03B4", epsilon: "\u03B5", zeta: "\u03B6", eta: "\u03B7", theta: "\u03B8", iota: "\u03B9", kappa: "\u03BA", lambda: "\u03BB", mu: "\u03BC", nu: "\u03BD", xi: "\u03BE", omicron: "\u03BF", pi: "\u03C0", rho: "\u03C1", sigmaf: "\u03C2", sigma: "\u03C3", tau: "\u03C4", upsilon: "\u03C5", phi: "\u03C6", chi: "\u03C7", psi: "\u03C8", omega: "\u03C9", thetasym: "\u03D1", upsih: "\u03D2", piv: "\u03D6", ensp: "\u2002", emsp: "\u2003", thinsp: "\u2009", zwnj: "\u200C", zwj: "\u200D", lrm: "\u200E", rlm: "\u200F", ndash: "\u2013", mdash: "\u2014", lsquo: "\u2018", rsquo: "\u2019", sbquo: "\u201A", ldquo: "\u201C", rdquo: "\u201D", bdquo: "\u201E", dagger: "\u2020", Dagger: "\u2021", bull: "\u2022", hellip: "\u2026", permil: "\u2030", prime: "\u2032", Prime: "\u2033", lsaquo: "\u2039", rsaquo: "\u203A", oline: "\u203E", frasl: "\u2044", euro: "\u20AC", image: "\u2111", weierp: "\u2118", real: "\u211C", trade: "\u2122", alefsym: "\u2135", larr: "\u2190", uarr: "\u2191", rarr: "\u2192", darr: "\u2193", harr: "\u2194", crarr: "\u21B5", lArr: "\u21D0", uArr: "\u21D1", rArr: "\u21D2", dArr: "\u21D3", hArr: "\u21D4", forall: "\u2200", part: "\u2202", exist: "\u2203", empty: "\u2205", nabla: "\u2207", isin: "\u2208", notin: "\u2209", ni: "\u220B", prod: "\u220F", sum: "\u2211", minus: "\u2212", lowast: "\u2217", radic: "\u221A", prop: "\u221D", infin: "\u221E", ang: "\u2220", and: "\u2227", or: "\u2228", cap: "\u2229", cup: "\u222A", int: "\u222B", there4: "\u2234", sim: "\u223C", cong: "\u2245", asymp: "\u2248", ne: "\u2260", equiv: "\u2261", le: "\u2264", ge: "\u2265", sub: "\u2282", sup: "\u2283", nsub: "\u2284", sube: "\u2286", supe: "\u2287", oplus: "\u2295", otimes: "\u2297", perp: "\u22A5", sdot: "\u22C5", lceil: "\u2308", rceil: "\u2309", lfloor: "\u230A", rfloor: "\u230B", lang: "\u2329", rang: "\u232A", loz: "\u25CA", spades: "\u2660", clubs: "\u2663", hearts: "\u2665", diams: "\u2666" }, $e2 = Ne2`jsx`({ AttributeIsEmpty: "JSX attributes must only be assigned a non-empty expression.", MissingClosingTagElement: (t3) => {
          let { openingTagName: e28 } = t3;
          return `Expected corresponding JSX closing tag for <${e28}>.`;
        }, MissingClosingTagFragment: "Expected corresponding JSX closing tag for <>.", UnexpectedSequenceExpression: "Sequence expressions cannot be directly nested inside JSX. Did you mean to wrap it in parentheses (...)?", UnexpectedToken: (t3) => {
          let { unexpected: e28, HTMLEntity: s3 } = t3;
          return `Unexpected token \`${e28}\`. Did you mean \`${s3}\` or \`{'${e28}'}\`?`;
        }, UnsupportedJsxValue: "JSX value should be either an expression or a quoted JSX text.", UnterminatedJsxContent: "Unterminated JSX contents.", UnwrappedAdjacentJSXElements: "Adjacent JSX elements must be wrapped in an enclosing tag. Did you want a JSX fragment <>...</>?" });
        function Re2(t3) {
          return t3 ? t3.type === "JSXOpeningFragment" || t3.type === "JSXClosingFragment" : false;
        }
        function tt2(t3) {
          if (t3.type === "JSXIdentifier")
            return t3.name;
          if (t3.type === "JSXNamespacedName")
            return t3.namespace.name + ":" + t3.name.name;
          if (t3.type === "JSXMemberExpression")
            return tt2(t3.object) + "." + tt2(t3.property);
          throw new Error("Node had unexpected type: " + t3.type);
        }
        var qn2 = (t3) => class extends t3 {
          jsxReadToken() {
            let e28 = "", s3 = this.state.pos;
            for (; ; ) {
              if (this.state.pos >= this.length)
                throw this.raise($e2.UnterminatedJsxContent, { at: this.state.startLoc });
              let r3 = this.input.charCodeAt(this.state.pos);
              switch (r3) {
                case 60:
                case 123:
                  if (this.state.pos === this.state.start) {
                    r3 === 60 && this.state.canStartJSXElement ? (++this.state.pos, this.finishToken(140)) : super.getTokenFromCode(r3);
                    return;
                  }
                  e28 += this.input.slice(s3, this.state.pos), this.finishToken(139, e28);
                  return;
                case 38:
                  e28 += this.input.slice(s3, this.state.pos), e28 += this.jsxReadEntity(), s3 = this.state.pos;
                  break;
                case 62:
                case 125:
                default:
                  ht2(r3) ? (e28 += this.input.slice(s3, this.state.pos), e28 += this.jsxReadNewLine(true), s3 = this.state.pos) : ++this.state.pos;
              }
            }
          }
          jsxReadNewLine(e28) {
            let s3 = this.input.charCodeAt(this.state.pos), r3;
            return ++this.state.pos, s3 === 13 && this.input.charCodeAt(this.state.pos) === 10 ? (++this.state.pos, r3 = e28 ? `
` : `\r
`) : r3 = String.fromCharCode(s3), ++this.state.curLine, this.state.lineStart = this.state.pos, r3;
          }
          jsxReadString(e28) {
            let s3 = "", r3 = ++this.state.pos;
            for (; ; ) {
              if (this.state.pos >= this.length)
                throw this.raise(p3.UnterminatedString, { at: this.state.startLoc });
              let i = this.input.charCodeAt(this.state.pos);
              if (i === e28)
                break;
              i === 38 ? (s3 += this.input.slice(r3, this.state.pos), s3 += this.jsxReadEntity(), r3 = this.state.pos) : ht2(i) ? (s3 += this.input.slice(r3, this.state.pos), s3 += this.jsxReadNewLine(false), r3 = this.state.pos) : ++this.state.pos;
            }
            s3 += this.input.slice(r3, this.state.pos++), this.finishToken(131, s3);
          }
          jsxReadEntity() {
            let e28 = ++this.state.pos;
            if (this.codePointAtPos(this.state.pos) === 35) {
              ++this.state.pos;
              let s3 = 10;
              this.codePointAtPos(this.state.pos) === 120 && (s3 = 16, ++this.state.pos);
              let r3 = this.readInt(s3, void 0, false, "bail");
              if (r3 !== null && this.codePointAtPos(this.state.pos) === 59)
                return ++this.state.pos, String.fromCodePoint(r3);
            } else {
              let s3 = 0, r3 = false;
              for (; s3++ < 10 && this.state.pos < this.length && !(r3 = this.codePointAtPos(this.state.pos) == 59); )
                ++this.state.pos;
              if (r3) {
                let i = this.input.slice(e28, this.state.pos), a3 = Vn2[i];
                if (++this.state.pos, a3)
                  return a3;
              }
            }
            return this.state.pos = e28, "&";
          }
          jsxReadWord() {
            let e28, s3 = this.state.pos;
            do
              e28 = this.input.charCodeAt(++this.state.pos);
            while (Je2(e28) || e28 === 45);
            this.finishToken(138, this.input.slice(s3, this.state.pos));
          }
          jsxParseIdentifier() {
            let e28 = this.startNode();
            return this.match(138) ? e28.name = this.state.value : Gt2(this.state.type) ? e28.name = Be2(this.state.type) : this.unexpected(), this.next(), this.finishNode(e28, "JSXIdentifier");
          }
          jsxParseNamespacedName() {
            let e28 = this.state.startLoc, s3 = this.jsxParseIdentifier();
            if (!this.eat(14))
              return s3;
            let r3 = this.startNodeAt(e28);
            return r3.namespace = s3, r3.name = this.jsxParseIdentifier(), this.finishNode(r3, "JSXNamespacedName");
          }
          jsxParseElementName() {
            let e28 = this.state.startLoc, s3 = this.jsxParseNamespacedName();
            if (s3.type === "JSXNamespacedName")
              return s3;
            for (; this.eat(16); ) {
              let r3 = this.startNodeAt(e28);
              r3.object = s3, r3.property = this.jsxParseIdentifier(), s3 = this.finishNode(r3, "JSXMemberExpression");
            }
            return s3;
          }
          jsxParseAttributeValue() {
            let e28;
            switch (this.state.type) {
              case 5:
                return e28 = this.startNode(), this.setContext(g3.brace), this.next(), e28 = this.jsxParseExpressionContainer(e28, g3.j_oTag), e28.expression.type === "JSXEmptyExpression" && this.raise($e2.AttributeIsEmpty, { at: e28 }), e28;
              case 140:
              case 131:
                return this.parseExprAtom();
              default:
                throw this.raise($e2.UnsupportedJsxValue, { at: this.state.startLoc });
            }
          }
          jsxParseEmptyExpression() {
            let e28 = this.startNodeAt(this.state.lastTokEndLoc);
            return this.finishNodeAt(e28, "JSXEmptyExpression", this.state.startLoc);
          }
          jsxParseSpreadChild(e28) {
            return this.next(), e28.expression = this.parseExpression(), this.setContext(g3.j_expr), this.state.canStartJSXElement = true, this.expect(8), this.finishNode(e28, "JSXSpreadChild");
          }
          jsxParseExpressionContainer(e28, s3) {
            if (this.match(8))
              e28.expression = this.jsxParseEmptyExpression();
            else {
              let r3 = this.parseExpression();
              e28.expression = r3;
            }
            return this.setContext(s3), this.state.canStartJSXElement = true, this.expect(8), this.finishNode(e28, "JSXExpressionContainer");
          }
          jsxParseAttribute() {
            let e28 = this.startNode();
            return this.match(5) ? (this.setContext(g3.brace), this.next(), this.expect(21), e28.argument = this.parseMaybeAssignAllowIn(), this.setContext(g3.j_oTag), this.state.canStartJSXElement = true, this.expect(8), this.finishNode(e28, "JSXSpreadAttribute")) : (e28.name = this.jsxParseNamespacedName(), e28.value = this.eat(29) ? this.jsxParseAttributeValue() : null, this.finishNode(e28, "JSXAttribute"));
          }
          jsxParseOpeningElementAt(e28) {
            let s3 = this.startNodeAt(e28);
            return this.eat(141) ? this.finishNode(s3, "JSXOpeningFragment") : (s3.name = this.jsxParseElementName(), this.jsxParseOpeningElementAfterName(s3));
          }
          jsxParseOpeningElementAfterName(e28) {
            let s3 = [];
            for (; !this.match(56) && !this.match(141); )
              s3.push(this.jsxParseAttribute());
            return e28.attributes = s3, e28.selfClosing = this.eat(56), this.expect(141), this.finishNode(e28, "JSXOpeningElement");
          }
          jsxParseClosingElementAt(e28) {
            let s3 = this.startNodeAt(e28);
            return this.eat(141) ? this.finishNode(s3, "JSXClosingFragment") : (s3.name = this.jsxParseElementName(), this.expect(141), this.finishNode(s3, "JSXClosingElement"));
          }
          jsxParseElementAt(e28) {
            let s3 = this.startNodeAt(e28), r3 = [], i = this.jsxParseOpeningElementAt(e28), a3 = null;
            if (!i.selfClosing) {
              e:
                for (; ; )
                  switch (this.state.type) {
                    case 140:
                      if (e28 = this.state.startLoc, this.next(), this.eat(56)) {
                        a3 = this.jsxParseClosingElementAt(e28);
                        break e;
                      }
                      r3.push(this.jsxParseElementAt(e28));
                      break;
                    case 139:
                      r3.push(this.parseExprAtom());
                      break;
                    case 5: {
                      let n3 = this.startNode();
                      this.setContext(g3.brace), this.next(), this.match(21) ? r3.push(this.jsxParseSpreadChild(n3)) : r3.push(this.jsxParseExpressionContainer(n3, g3.j_expr));
                      break;
                    }
                    default:
                      this.unexpected();
                  }
              Re2(i) && !Re2(a3) && a3 !== null ? this.raise($e2.MissingClosingTagFragment, { at: a3 }) : !Re2(i) && Re2(a3) ? this.raise($e2.MissingClosingTagElement, { at: a3, openingTagName: tt2(i.name) }) : !Re2(i) && !Re2(a3) && tt2(a3.name) !== tt2(i.name) && this.raise($e2.MissingClosingTagElement, { at: a3, openingTagName: tt2(i.name) });
            }
            if (Re2(i) ? (s3.openingFragment = i, s3.closingFragment = a3) : (s3.openingElement = i, s3.closingElement = a3), s3.children = r3, this.match(47))
              throw this.raise($e2.UnwrappedAdjacentJSXElements, { at: this.state.startLoc });
            return Re2(i) ? this.finishNode(s3, "JSXFragment") : this.finishNode(s3, "JSXElement");
          }
          jsxParseElement() {
            let e28 = this.state.startLoc;
            return this.next(), this.jsxParseElementAt(e28);
          }
          setContext(e28) {
            let { context: s3 } = this.state;
            s3[s3.length - 1] = e28;
          }
          parseExprAtom(e28) {
            return this.match(139) ? this.parseLiteral(this.state.value, "JSXText") : this.match(140) ? this.jsxParseElement() : this.match(47) && this.input.charCodeAt(this.state.pos) !== 33 ? (this.replaceToken(140), this.jsxParseElement()) : super.parseExprAtom(e28);
          }
          skipSpace() {
            this.curContext().preserveSpace || super.skipSpace();
          }
          getTokenFromCode(e28) {
            let s3 = this.curContext();
            if (s3 === g3.j_expr) {
              this.jsxReadToken();
              return;
            }
            if (s3 === g3.j_oTag || s3 === g3.j_cTag) {
              if (ke2(e28)) {
                this.jsxReadWord();
                return;
              }
              if (e28 === 62) {
                ++this.state.pos, this.finishToken(141);
                return;
              }
              if ((e28 === 34 || e28 === 39) && s3 === g3.j_oTag) {
                this.jsxReadString(e28);
                return;
              }
            }
            if (e28 === 60 && this.state.canStartJSXElement && this.input.charCodeAt(this.state.pos + 1) !== 33) {
              ++this.state.pos, this.finishToken(140);
              return;
            }
            super.getTokenFromCode(e28);
          }
          updateContext(e28) {
            let { context: s3, type: r3 } = this.state;
            if (r3 === 56 && e28 === 140)
              s3.splice(-2, 2, g3.j_cTag), this.state.canStartJSXElement = false;
            else if (r3 === 140)
              s3.push(g3.j_oTag);
            else if (r3 === 141) {
              let i = s3[s3.length - 1];
              i === g3.j_oTag && e28 === 56 || i === g3.j_cTag ? (s3.pop(), this.state.canStartJSXElement = s3[s3.length - 1] === g3.j_expr) : (this.setContext(g3.j_expr), this.state.canStartJSXElement = true);
            } else
              this.state.canStartJSXElement = be2(r3);
          }
        }, Kn2 = class extends us2 {
          constructor() {
            super(...arguments), this.types = /* @__PURE__ */ new Set(), this.enums = /* @__PURE__ */ new Set(), this.constEnums = /* @__PURE__ */ new Set(), this.classes = /* @__PURE__ */ new Set(), this.exportOnlyBindings = /* @__PURE__ */ new Set();
          }
        }, Wn2 = class extends cs2 {
          constructor() {
            super(...arguments), this.importsStack = [];
          }
          createScope(t3) {
            return this.importsStack.push(/* @__PURE__ */ new Set()), new Kn2(t3);
          }
          enter(t3) {
            t3 == Ye2 && this.importsStack.push(/* @__PURE__ */ new Set()), super.enter(t3);
          }
          exit() {
            let t3 = super.exit();
            return t3 == Ye2 && this.importsStack.pop(), t3;
          }
          hasImport(t3, e28) {
            let s3 = this.importsStack.length;
            if (this.importsStack[s3 - 1].has(t3))
              return true;
            if (!e28 && s3 > 1) {
              for (let r3 = 0; r3 < s3 - 1; r3++)
                if (this.importsStack[r3].has(t3))
                  return true;
            }
            return false;
          }
          declareName(t3, e28, s3) {
            if (e28 & at2) {
              this.hasImport(t3, true) && this.parser.raise(p3.VarRedeclaration, { at: s3, identifierName: t3 }), this.importsStack[this.importsStack.length - 1].add(t3);
              return;
            }
            let r3 = this.currentScope();
            if (e28 & as2) {
              this.maybeExportDefined(r3, t3), r3.exportOnlyBindings.add(t3);
              return;
            }
            super.declareName(t3, e28, s3), e28 & ze2 && (e28 & Se2 || (this.checkRedeclarationInScope(r3, t3, e28, s3), this.maybeExportDefined(r3, t3)), r3.types.add(t3)), e28 & rs2 && r3.enums.add(t3), e28 & is2 && r3.constEnums.add(t3), e28 & St2 && r3.classes.add(t3);
          }
          isRedeclaredInScope(t3, e28, s3) {
            if (t3.enums.has(e28)) {
              if (s3 & rs2) {
                let r3 = !!(s3 & is2), i = t3.constEnums.has(e28);
                return r3 !== i;
              }
              return true;
            }
            return s3 & St2 && t3.classes.has(e28) ? t3.lexical.has(e28) ? !!(s3 & Se2) : false : s3 & ze2 && t3.types.has(e28) ? true : super.isRedeclaredInScope(t3, e28, s3);
          }
          checkLocalExport(t3) {
            let { name: e28 } = t3;
            if (this.hasImport(e28))
              return;
            let s3 = this.scopeStack.length;
            for (let r3 = s3 - 1; r3 >= 0; r3--) {
              let i = this.scopeStack[r3];
              if (i.types.has(e28) || i.exportOnlyBindings.has(e28))
                return;
            }
            super.checkLocalExport(t3);
          }
        }, Jn2 = (t3, e28) => Object.hasOwnProperty.call(t3, e28) && t3[e28], Ur2 = (t3) => t3.type === "ParenthesizedExpression" ? Ur2(t3.expression) : t3, Xn2 = class extends jn2 {
          toAssignable(t3) {
            let e28 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var s3, r3;
            let i;
            switch ((t3.type === "ParenthesizedExpression" || (s3 = t3.extra) != null && s3.parenthesized) && (i = Ur2(t3), e28 ? i.type === "Identifier" ? this.expressionScope.recordArrowParameterBindingError(p3.InvalidParenthesizedAssignment, { at: t3 }) : i.type !== "MemberExpression" && this.raise(p3.InvalidParenthesizedAssignment, { at: t3 }) : this.raise(p3.InvalidParenthesizedAssignment, { at: t3 })), t3.type) {
              case "Identifier":
              case "ObjectPattern":
              case "ArrayPattern":
              case "AssignmentPattern":
              case "RestElement":
                break;
              case "ObjectExpression":
                t3.type = "ObjectPattern";
                for (let n3 = 0, o3 = t3.properties.length, h3 = o3 - 1; n3 < o3; n3++) {
                  var a3;
                  let l3 = t3.properties[n3], f3 = n3 === h3;
                  this.toAssignableObjectExpressionProp(l3, f3, e28), f3 && l3.type === "RestElement" && (a3 = t3.extra) != null && a3.trailingCommaLoc && this.raise(p3.RestTrailingComma, { at: t3.extra.trailingCommaLoc });
                }
                break;
              case "ObjectProperty": {
                let { key: n3, value: o3 } = t3;
                this.isPrivateName(n3) && this.classScope.usePrivateName(this.getPrivateNameSV(n3), n3.loc.start), this.toAssignable(o3, e28);
                break;
              }
              case "SpreadElement":
                throw new Error("Internal @babel/parser error (this is a bug, please report it). SpreadElement should be converted by .toAssignable's caller.");
              case "ArrayExpression":
                t3.type = "ArrayPattern", this.toAssignableList(t3.elements, (r3 = t3.extra) == null ? void 0 : r3.trailingCommaLoc, e28);
                break;
              case "AssignmentExpression":
                t3.operator !== "=" && this.raise(p3.MissingEqInAssignment, { at: t3.left.loc.end }), t3.type = "AssignmentPattern", delete t3.operator, this.toAssignable(t3.left, e28);
                break;
              case "ParenthesizedExpression":
                this.toAssignable(i, e28);
                break;
            }
          }
          toAssignableObjectExpressionProp(t3, e28, s3) {
            if (t3.type === "ObjectMethod")
              this.raise(t3.kind === "get" || t3.kind === "set" ? p3.PatternHasAccessor : p3.PatternHasMethod, { at: t3.key });
            else if (t3.type === "SpreadElement") {
              t3.type = "RestElement";
              let r3 = t3.argument;
              this.checkToRestConversion(r3, false), this.toAssignable(r3, s3), e28 || this.raise(p3.RestTrailingComma, { at: t3 });
            } else
              this.toAssignable(t3, s3);
          }
          toAssignableList(t3, e28, s3) {
            let r3 = t3.length - 1;
            for (let i = 0; i <= r3; i++) {
              let a3 = t3[i];
              if (a3) {
                if (a3.type === "SpreadElement") {
                  a3.type = "RestElement";
                  let n3 = a3.argument;
                  this.checkToRestConversion(n3, true), this.toAssignable(n3, s3);
                } else
                  this.toAssignable(a3, s3);
                a3.type === "RestElement" && (i < r3 ? this.raise(p3.RestTrailingComma, { at: a3 }) : e28 && this.raise(p3.RestTrailingComma, { at: e28 }));
              }
            }
          }
          isAssignable(t3, e28) {
            switch (t3.type) {
              case "Identifier":
              case "ObjectPattern":
              case "ArrayPattern":
              case "AssignmentPattern":
              case "RestElement":
                return true;
              case "ObjectExpression": {
                let s3 = t3.properties.length - 1;
                return t3.properties.every((r3, i) => r3.type !== "ObjectMethod" && (i === s3 || r3.type !== "SpreadElement") && this.isAssignable(r3));
              }
              case "ObjectProperty":
                return this.isAssignable(t3.value);
              case "SpreadElement":
                return this.isAssignable(t3.argument);
              case "ArrayExpression":
                return t3.elements.every((s3) => s3 === null || this.isAssignable(s3));
              case "AssignmentExpression":
                return t3.operator === "=";
              case "ParenthesizedExpression":
                return this.isAssignable(t3.expression);
              case "MemberExpression":
              case "OptionalMemberExpression":
                return !e28;
              default:
                return false;
            }
          }
          toReferencedList(t3, e28) {
            return t3;
          }
          toReferencedListDeep(t3, e28) {
            this.toReferencedList(t3, e28);
            for (let s3 of t3)
              (s3 == null ? void 0 : s3.type) === "ArrayExpression" && this.toReferencedListDeep(s3.elements);
          }
          parseSpread(t3) {
            let e28 = this.startNode();
            return this.next(), e28.argument = this.parseMaybeAssignAllowIn(t3, void 0), this.finishNode(e28, "SpreadElement");
          }
          parseRestBinding() {
            let t3 = this.startNode();
            return this.next(), t3.argument = this.parseBindingAtom(), this.finishNode(t3, "RestElement");
          }
          parseBindingAtom() {
            switch (this.state.type) {
              case 0: {
                let t3 = this.startNode();
                return this.next(), t3.elements = this.parseBindingList(3, 93, 1), this.finishNode(t3, "ArrayPattern");
              }
              case 5:
                return this.parseObjectLike(8, true);
            }
            return this.parseIdentifier();
          }
          parseBindingList(t3, e28, s3) {
            let r3 = s3 & 1, i = [], a3 = true;
            for (; !this.eat(t3); )
              if (a3 ? a3 = false : this.expect(12), r3 && this.match(12))
                i.push(null);
              else {
                if (this.eat(t3))
                  break;
                if (this.match(21)) {
                  if (i.push(this.parseAssignableListItemTypes(this.parseRestBinding(), s3)), !this.checkCommaAfterRest(e28)) {
                    this.expect(t3);
                    break;
                  }
                } else {
                  let n3 = [];
                  for (this.match(26) && this.hasPlugin("decorators") && this.raise(p3.UnsupportedParameterDecorator, { at: this.state.startLoc }); this.match(26); )
                    n3.push(this.parseDecorator());
                  i.push(this.parseAssignableListItem(s3, n3));
                }
              }
            return i;
          }
          parseBindingRestProperty(t3) {
            return this.next(), t3.argument = this.parseIdentifier(), this.checkCommaAfterRest(125), this.finishNode(t3, "RestElement");
          }
          parseBindingProperty() {
            let t3 = this.startNode(), { type: e28, startLoc: s3 } = this.state;
            return e28 === 21 ? this.parseBindingRestProperty(t3) : (e28 === 136 ? (this.expectPlugin("destructuringPrivate", s3), this.classScope.usePrivateName(this.state.value, s3), t3.key = this.parsePrivateName()) : this.parsePropertyName(t3), t3.method = false, this.parseObjPropValue(t3, s3, false, false, true, false));
          }
          parseAssignableListItem(t3, e28) {
            let s3 = this.parseMaybeDefault();
            this.parseAssignableListItemTypes(s3, t3);
            let r3 = this.parseMaybeDefault(s3.loc.start, s3);
            return e28.length && (s3.decorators = e28), r3;
          }
          parseAssignableListItemTypes(t3, e28) {
            return t3;
          }
          parseMaybeDefault(t3, e28) {
            var s3;
            if (t3 != null || (t3 = this.state.startLoc), e28 = (s3 = e28) != null ? s3 : this.parseBindingAtom(), !this.eat(29))
              return e28;
            let r3 = this.startNodeAt(t3);
            return r3.left = e28, r3.right = this.parseMaybeAssignAllowIn(), this.finishNode(r3, "AssignmentPattern");
          }
          isValidLVal(t3, e28, s3) {
            return Jn2({ AssignmentPattern: "left", RestElement: "argument", ObjectProperty: "value", ParenthesizedExpression: "expression", ArrayPattern: "elements", ObjectPattern: "properties" }, t3);
          }
          checkLVal(t3, e28) {
            let { in: s3, binding: r3 = Oe2, checkClashes: i = false, strictModeChanged: a3 = false, hasParenthesizedAncestor: n3 = false } = e28;
            var o3;
            let h3 = t3.type;
            if (this.isObjectMethod(t3))
              return;
            if (h3 === "MemberExpression") {
              r3 !== Oe2 && this.raise(p3.InvalidPropertyBindingPattern, { at: t3 });
              return;
            }
            if (h3 === "Identifier") {
              this.checkIdentifier(t3, r3, a3);
              let { name: B3 } = t3;
              i && (i.has(B3) ? this.raise(p3.ParamDupe, { at: t3 }) : i.add(B3));
              return;
            }
            let l3 = this.isValidLVal(h3, !(n3 || (o3 = t3.extra) != null && o3.parenthesized) && s3.type === "AssignmentExpression", r3);
            if (l3 === true)
              return;
            if (l3 === false) {
              let B3 = r3 === Oe2 ? p3.InvalidLhs : p3.InvalidLhsBinding;
              this.raise(B3, { at: t3, ancestor: s3 });
              return;
            }
            let [f3, T3] = Array.isArray(l3) ? l3 : [l3, h3 === "ParenthesizedExpression"], R3 = h3 === "ArrayPattern" || h3 === "ObjectPattern" || h3 === "ParenthesizedExpression" ? { type: h3 } : s3;
            for (let B3 of [].concat(t3[f3]))
              B3 && this.checkLVal(B3, { in: R3, binding: r3, checkClashes: i, strictModeChanged: a3, hasParenthesizedAncestor: T3 });
          }
          checkIdentifier(t3, e28) {
            let s3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            this.state.strict && (s3 ? fr2(t3.name, this.inModule) : mr2(t3.name)) && (e28 === Oe2 ? this.raise(p3.StrictEvalArguments, { at: t3, referenceName: t3.name }) : this.raise(p3.StrictEvalArgumentsBinding, { at: t3, bindingName: t3.name })), e28 & wt2 && t3.name === "let" && this.raise(p3.LetInLexicalBinding, { at: t3 }), e28 & Oe2 || this.declareNameFromIdentifier(t3, e28);
          }
          declareNameFromIdentifier(t3, e28) {
            this.scope.declareName(t3.name, e28, t3.loc.start);
          }
          checkToRestConversion(t3, e28) {
            switch (t3.type) {
              case "ParenthesizedExpression":
                this.checkToRestConversion(t3.expression, e28);
                break;
              case "Identifier":
              case "MemberExpression":
                break;
              case "ArrayExpression":
              case "ObjectExpression":
                if (e28)
                  break;
              default:
                this.raise(p3.InvalidRestAssignmentPattern, { at: t3 });
            }
          }
          checkCommaAfterRest(t3) {
            return this.match(12) ? (this.raise(this.lookaheadCharCode() === t3 ? p3.RestTrailingComma : p3.ElementAfterRest, { at: this.state.startLoc }), true) : false;
          }
        }, Gn2 = (t3, e28) => Object.hasOwnProperty.call(t3, e28) && t3[e28];
        function Yn2(t3) {
          if (t3 == null)
            throw new Error(`Unexpected ${t3} value.`);
          return t3;
        }
        function _r2(t3) {
          if (!t3)
            throw new Error("Assert fail");
        }
        var j3 = Ne2`typescript`({ AbstractMethodHasImplementation: (t3) => {
          let { methodName: e28 } = t3;
          return `Method '${e28}' cannot have an implementation because it is marked abstract.`;
        }, AbstractPropertyHasInitializer: (t3) => {
          let { propertyName: e28 } = t3;
          return `Property '${e28}' cannot have an initializer because it is marked abstract.`;
        }, AccesorCannotDeclareThisParameter: "'get' and 'set' accessors cannot declare 'this' parameters.", AccesorCannotHaveTypeParameters: "An accessor cannot have type parameters.", AccessorCannotBeOptional: "An 'accessor' property cannot be declared optional.", ClassMethodHasDeclare: "Class methods cannot have the 'declare' modifier.", ClassMethodHasReadonly: "Class methods cannot have the 'readonly' modifier.", ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference: "A 'const' initializer in an ambient context must be a string or numeric literal or literal enum reference.", ConstructorHasTypeParameters: "Type parameters cannot appear on a constructor declaration.", DeclareAccessor: (t3) => {
          let { kind: e28 } = t3;
          return `'declare' is not allowed in ${e28}ters.`;
        }, DeclareClassFieldHasInitializer: "Initializers are not allowed in ambient contexts.", DeclareFunctionHasImplementation: "An implementation cannot be declared in ambient contexts.", DuplicateAccessibilityModifier: (t3) => "Accessibility modifier already seen.", DuplicateModifier: (t3) => {
          let { modifier: e28 } = t3;
          return `Duplicate modifier: '${e28}'.`;
        }, EmptyHeritageClauseType: (t3) => {
          let { token: e28 } = t3;
          return `'${e28}' list cannot be empty.`;
        }, EmptyTypeArguments: "Type argument list cannot be empty.", EmptyTypeParameters: "Type parameter list cannot be empty.", ExpectedAmbientAfterExportDeclare: "'export declare' must be followed by an ambient declaration.", ImportAliasHasImportType: "An import alias can not use 'import type'.", ImportReflectionHasImportType: "An `import module` declaration can not use `type` modifier", IncompatibleModifiers: (t3) => {
          let { modifiers: e28 } = t3;
          return `'${e28[0]}' modifier cannot be used with '${e28[1]}' modifier.`;
        }, IndexSignatureHasAbstract: "Index signatures cannot have the 'abstract' modifier.", IndexSignatureHasAccessibility: (t3) => {
          let { modifier: e28 } = t3;
          return `Index signatures cannot have an accessibility modifier ('${e28}').`;
        }, IndexSignatureHasDeclare: "Index signatures cannot have the 'declare' modifier.", IndexSignatureHasOverride: "'override' modifier cannot appear on an index signature.", IndexSignatureHasStatic: "Index signatures cannot have the 'static' modifier.", InitializerNotAllowedInAmbientContext: "Initializers are not allowed in ambient contexts.", InvalidModifierOnTypeMember: (t3) => {
          let { modifier: e28 } = t3;
          return `'${e28}' modifier cannot appear on a type member.`;
        }, InvalidModifierOnTypeParameter: (t3) => {
          let { modifier: e28 } = t3;
          return `'${e28}' modifier cannot appear on a type parameter.`;
        }, InvalidModifierOnTypeParameterPositions: (t3) => {
          let { modifier: e28 } = t3;
          return `'${e28}' modifier can only appear on a type parameter of a class, interface or type alias.`;
        }, InvalidModifiersOrder: (t3) => {
          let { orderedModifiers: e28 } = t3;
          return `'${e28[0]}' modifier must precede '${e28[1]}' modifier.`;
        }, InvalidPropertyAccessAfterInstantiationExpression: "Invalid property access after an instantiation expression. You can either wrap the instantiation expression in parentheses, or delete the type arguments.", InvalidTupleMemberLabel: "Tuple members must be labeled with a simple identifier.", MissingInterfaceName: "'interface' declarations must be followed by an identifier.", MixedLabeledAndUnlabeledElements: "Tuple members must all have names or all not have names.", NonAbstractClassHasAbstractMethod: "Abstract methods can only appear within an abstract class.", NonClassMethodPropertyHasAbstractModifer: "'abstract' modifier can only appear on a class, method, or property declaration.", OptionalTypeBeforeRequired: "A required element cannot follow an optional element.", OverrideNotInSubClass: "This member cannot have an 'override' modifier because its containing class does not extend another class.", PatternIsOptional: "A binding pattern parameter cannot be optional in an implementation signature.", PrivateElementHasAbstract: "Private elements cannot have the 'abstract' modifier.", PrivateElementHasAccessibility: (t3) => {
          let { modifier: e28 } = t3;
          return `Private elements cannot have an accessibility modifier ('${e28}').`;
        }, ReadonlyForMethodSignature: "'readonly' modifier can only appear on a property declaration or index signature.", ReservedArrowTypeParam: "This syntax is reserved in files with the .mts or .cts extension. Add a trailing comma, as in `<T,>() => ...`.", ReservedTypeAssertion: "This syntax is reserved in files with the .mts or .cts extension. Use an `as` expression instead.", SetAccesorCannotHaveOptionalParameter: "A 'set' accessor cannot have an optional parameter.", SetAccesorCannotHaveRestParameter: "A 'set' accessor cannot have rest parameter.", SetAccesorCannotHaveReturnType: "A 'set' accessor cannot have a return type annotation.", SingleTypeParameterWithoutTrailingComma: (t3) => {
          let { typeParameterName: e28 } = t3;
          return `Single type parameter ${e28} should have a trailing comma. Example usage: <${e28},>.`;
        }, StaticBlockCannotHaveModifier: "Static class blocks cannot have any modifier.", TupleOptionalAfterType: "A labeled tuple optional element must be declared using a question mark after the name and before the colon (`name?: type`), rather than after the type (`name: type?`).", TypeAnnotationAfterAssign: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.", TypeImportCannotSpecifyDefaultAndNamed: "A type-only import can specify a default import or named bindings, but not both.", TypeModifierIsUsedInTypeExports: "The 'type' modifier cannot be used on a named export when 'export type' is used on its export statement.", TypeModifierIsUsedInTypeImports: "The 'type' modifier cannot be used on a named import when 'import type' is used on its import statement.", UnexpectedParameterModifier: "A parameter property is only allowed in a constructor implementation.", UnexpectedReadonly: "'readonly' type modifier is only permitted on array and tuple literal types.", UnexpectedTypeAnnotation: "Did not expect a type annotation here.", UnexpectedTypeCastInParameter: "Unexpected type cast in parameter position.", UnsupportedImportTypeArgument: "Argument in a type import must be a string literal.", UnsupportedParameterPropertyKind: "A parameter property may not be declared using a binding pattern.", UnsupportedSignatureParameterKind: (t3) => {
          let { type: e28 } = t3;
          return `Name in a signature must be an Identifier, ObjectPattern or ArrayPattern, instead got ${e28}.`;
        } });
        function Qn2(t3) {
          switch (t3) {
            case "any":
              return "TSAnyKeyword";
            case "boolean":
              return "TSBooleanKeyword";
            case "bigint":
              return "TSBigIntKeyword";
            case "never":
              return "TSNeverKeyword";
            case "number":
              return "TSNumberKeyword";
            case "object":
              return "TSObjectKeyword";
            case "string":
              return "TSStringKeyword";
            case "symbol":
              return "TSSymbolKeyword";
            case "undefined":
              return "TSUndefinedKeyword";
            case "unknown":
              return "TSUnknownKeyword";
            default:
              return;
          }
        }
        function zr2(t3) {
          return t3 === "private" || t3 === "public" || t3 === "protected";
        }
        function Zn2(t3) {
          return t3 === "in" || t3 === "out";
        }
        var eo2 = (t3) => class extends t3 {
          constructor() {
            super(...arguments), this.tsParseInOutModifiers = this.tsParseModifiers.bind(this, { allowedModifiers: ["in", "out"], disallowedModifiers: ["const", "public", "private", "protected", "readonly", "declare", "abstract", "override"], errorTemplate: j3.InvalidModifierOnTypeParameter }), this.tsParseConstModifier = this.tsParseModifiers.bind(this, { allowedModifiers: ["const"], disallowedModifiers: ["in", "out"], errorTemplate: j3.InvalidModifierOnTypeParameterPositions }), this.tsParseInOutConstModifiers = this.tsParseModifiers.bind(this, { allowedModifiers: ["in", "out", "const"], disallowedModifiers: ["public", "private", "protected", "readonly", "declare", "abstract", "override"], errorTemplate: j3.InvalidModifierOnTypeParameter });
          }
          getScopeHandler() {
            return Wn2;
          }
          tsIsIdentifier() {
            return te2(this.state.type);
          }
          tsTokenCanFollowModifier() {
            return (this.match(0) || this.match(5) || this.match(55) || this.match(21) || this.match(136) || this.isLiteralPropertyName()) && !this.hasPrecedingLineBreak();
          }
          tsNextTokenCanFollowModifier() {
            return this.next(), this.tsTokenCanFollowModifier();
          }
          tsParseModifier(e28, s3) {
            if (!te2(this.state.type) && this.state.type !== 58 && this.state.type !== 75)
              return;
            let r3 = this.state.value;
            if (e28.indexOf(r3) !== -1) {
              if (s3 && this.tsIsStartOfStaticBlocks())
                return;
              if (this.tsTryParse(this.tsNextTokenCanFollowModifier.bind(this)))
                return r3;
            }
          }
          tsParseModifiers(e28, s3) {
            let { allowedModifiers: r3, disallowedModifiers: i, stopOnStartOfClassStaticBlock: a3, errorTemplate: n3 = j3.InvalidModifierOnTypeMember } = e28, o3 = (l3, f3, T3, R3) => {
              f3 === T3 && s3[R3] && this.raise(j3.InvalidModifiersOrder, { at: l3, orderedModifiers: [T3, R3] });
            }, h3 = (l3, f3, T3, R3) => {
              (s3[T3] && f3 === R3 || s3[R3] && f3 === T3) && this.raise(j3.IncompatibleModifiers, { at: l3, modifiers: [T3, R3] });
            };
            for (; ; ) {
              let { startLoc: l3 } = this.state, f3 = this.tsParseModifier(r3.concat(i != null ? i : []), a3);
              if (!f3)
                break;
              zr2(f3) ? s3.accessibility ? this.raise(j3.DuplicateAccessibilityModifier, { at: l3, modifier: f3 }) : (o3(l3, f3, f3, "override"), o3(l3, f3, f3, "static"), o3(l3, f3, f3, "readonly"), s3.accessibility = f3) : Zn2(f3) ? (s3[f3] && this.raise(j3.DuplicateModifier, { at: l3, modifier: f3 }), s3[f3] = true, o3(l3, f3, "in", "out")) : (Object.hasOwnProperty.call(s3, f3) ? this.raise(j3.DuplicateModifier, { at: l3, modifier: f3 }) : (o3(l3, f3, "static", "readonly"), o3(l3, f3, "static", "override"), o3(l3, f3, "override", "readonly"), o3(l3, f3, "abstract", "override"), h3(l3, f3, "declare", "override"), h3(l3, f3, "static", "abstract")), s3[f3] = true), i != null && i.includes(f3) && this.raise(n3, { at: l3, modifier: f3 });
            }
          }
          tsIsListTerminator(e28) {
            switch (e28) {
              case "EnumMembers":
              case "TypeMembers":
                return this.match(8);
              case "HeritageClauseElement":
                return this.match(5);
              case "TupleElementTypes":
                return this.match(3);
              case "TypeParametersOrArguments":
                return this.match(48);
            }
          }
          tsParseList(e28, s3) {
            let r3 = [];
            for (; !this.tsIsListTerminator(e28); )
              r3.push(s3());
            return r3;
          }
          tsParseDelimitedList(e28, s3, r3) {
            return Yn2(this.tsParseDelimitedListWorker(e28, s3, true, r3));
          }
          tsParseDelimitedListWorker(e28, s3, r3, i) {
            let a3 = [], n3 = -1;
            for (; !this.tsIsListTerminator(e28); ) {
              n3 = -1;
              let o3 = s3();
              if (o3 == null)
                return;
              if (a3.push(o3), this.eat(12)) {
                n3 = this.state.lastTokStart;
                continue;
              }
              if (this.tsIsListTerminator(e28))
                break;
              r3 && this.expect(12);
              return;
            }
            return i && (i.value = n3), a3;
          }
          tsParseBracketedList(e28, s3, r3, i, a3) {
            i || (r3 ? this.expect(0) : this.expect(47));
            let n3 = this.tsParseDelimitedList(e28, s3, a3);
            return r3 ? this.expect(3) : this.expect(48), n3;
          }
          tsParseImportType() {
            let e28 = this.startNode();
            return this.expect(83), this.expect(10), this.match(131) || this.raise(j3.UnsupportedImportTypeArgument, { at: this.state.startLoc }), e28.argument = super.parseExprAtom(), this.expect(11), this.eat(16) && (e28.qualifier = this.tsParseEntityName()), this.match(47) && (e28.typeParameters = this.tsParseTypeArguments()), this.finishNode(e28, "TSImportType");
          }
          tsParseEntityName() {
            let e28 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, s3 = this.parseIdentifier(e28);
            for (; this.eat(16); ) {
              let r3 = this.startNodeAtNode(s3);
              r3.left = s3, r3.right = this.parseIdentifier(e28), s3 = this.finishNode(r3, "TSQualifiedName");
            }
            return s3;
          }
          tsParseTypeReference() {
            let e28 = this.startNode();
            return e28.typeName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (e28.typeParameters = this.tsParseTypeArguments()), this.finishNode(e28, "TSTypeReference");
          }
          tsParseThisTypePredicate(e28) {
            this.next();
            let s3 = this.startNodeAtNode(e28);
            return s3.parameterName = e28, s3.typeAnnotation = this.tsParseTypeAnnotation(false), s3.asserts = false, this.finishNode(s3, "TSTypePredicate");
          }
          tsParseThisTypeNode() {
            let e28 = this.startNode();
            return this.next(), this.finishNode(e28, "TSThisType");
          }
          tsParseTypeQuery() {
            let e28 = this.startNode();
            return this.expect(87), this.match(83) ? e28.exprName = this.tsParseImportType() : e28.exprName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (e28.typeParameters = this.tsParseTypeArguments()), this.finishNode(e28, "TSTypeQuery");
          }
          tsParseTypeParameter(e28) {
            let s3 = this.startNode();
            return e28(s3), s3.name = this.tsParseTypeParameterName(), s3.constraint = this.tsEatThenParseType(81), s3.default = this.tsEatThenParseType(29), this.finishNode(s3, "TSTypeParameter");
          }
          tsTryParseTypeParameters(e28) {
            if (this.match(47))
              return this.tsParseTypeParameters(e28);
          }
          tsParseTypeParameters(e28) {
            let s3 = this.startNode();
            this.match(47) || this.match(140) ? this.next() : this.unexpected();
            let r3 = { value: -1 };
            return s3.params = this.tsParseBracketedList("TypeParametersOrArguments", this.tsParseTypeParameter.bind(this, e28), false, true, r3), s3.params.length === 0 && this.raise(j3.EmptyTypeParameters, { at: s3 }), r3.value !== -1 && this.addExtra(s3, "trailingComma", r3.value), this.finishNode(s3, "TSTypeParameterDeclaration");
          }
          tsFillSignature(e28, s3) {
            let r3 = e28 === 19, i = "parameters", a3 = "typeAnnotation";
            s3.typeParameters = this.tsTryParseTypeParameters(this.tsParseConstModifier), this.expect(10), s3[i] = this.tsParseBindingListForSignature(), r3 ? s3[a3] = this.tsParseTypeOrTypePredicateAnnotation(e28) : this.match(e28) && (s3[a3] = this.tsParseTypeOrTypePredicateAnnotation(e28));
          }
          tsParseBindingListForSignature() {
            return super.parseBindingList(11, 41, 2).map((e28) => (e28.type !== "Identifier" && e28.type !== "RestElement" && e28.type !== "ObjectPattern" && e28.type !== "ArrayPattern" && this.raise(j3.UnsupportedSignatureParameterKind, { at: e28, type: e28.type }), e28));
          }
          tsParseTypeMemberSemicolon() {
            !this.eat(12) && !this.isLineTerminator() && this.expect(13);
          }
          tsParseSignatureMember(e28, s3) {
            return this.tsFillSignature(14, s3), this.tsParseTypeMemberSemicolon(), this.finishNode(s3, e28);
          }
          tsIsUnambiguouslyIndexSignature() {
            return this.next(), te2(this.state.type) ? (this.next(), this.match(14)) : false;
          }
          tsTryParseIndexSignature(e28) {
            if (!(this.match(0) && this.tsLookAhead(this.tsIsUnambiguouslyIndexSignature.bind(this))))
              return;
            this.expect(0);
            let s3 = this.parseIdentifier();
            s3.typeAnnotation = this.tsParseTypeAnnotation(), this.resetEndLocation(s3), this.expect(3), e28.parameters = [s3];
            let r3 = this.tsTryParseTypeAnnotation();
            return r3 && (e28.typeAnnotation = r3), this.tsParseTypeMemberSemicolon(), this.finishNode(e28, "TSIndexSignature");
          }
          tsParsePropertyOrMethodSignature(e28, s3) {
            this.eat(17) && (e28.optional = true);
            let r3 = e28;
            if (this.match(10) || this.match(47)) {
              s3 && this.raise(j3.ReadonlyForMethodSignature, { at: e28 });
              let i = r3;
              i.kind && this.match(47) && this.raise(j3.AccesorCannotHaveTypeParameters, { at: this.state.curPosition() }), this.tsFillSignature(14, i), this.tsParseTypeMemberSemicolon();
              let a3 = "parameters", n3 = "typeAnnotation";
              if (i.kind === "get")
                i[a3].length > 0 && (this.raise(p3.BadGetterArity, { at: this.state.curPosition() }), this.isThisParam(i[a3][0]) && this.raise(j3.AccesorCannotDeclareThisParameter, { at: this.state.curPosition() }));
              else if (i.kind === "set") {
                if (i[a3].length !== 1)
                  this.raise(p3.BadSetterArity, { at: this.state.curPosition() });
                else {
                  let o3 = i[a3][0];
                  this.isThisParam(o3) && this.raise(j3.AccesorCannotDeclareThisParameter, { at: this.state.curPosition() }), o3.type === "Identifier" && o3.optional && this.raise(j3.SetAccesorCannotHaveOptionalParameter, { at: this.state.curPosition() }), o3.type === "RestElement" && this.raise(j3.SetAccesorCannotHaveRestParameter, { at: this.state.curPosition() });
                }
                i[n3] && this.raise(j3.SetAccesorCannotHaveReturnType, { at: i[n3] });
              } else
                i.kind = "method";
              return this.finishNode(i, "TSMethodSignature");
            } else {
              let i = r3;
              s3 && (i.readonly = true);
              let a3 = this.tsTryParseTypeAnnotation();
              return a3 && (i.typeAnnotation = a3), this.tsParseTypeMemberSemicolon(), this.finishNode(i, "TSPropertySignature");
            }
          }
          tsParseTypeMember() {
            let e28 = this.startNode();
            if (this.match(10) || this.match(47))
              return this.tsParseSignatureMember("TSCallSignatureDeclaration", e28);
            if (this.match(77)) {
              let r3 = this.startNode();
              return this.next(), this.match(10) || this.match(47) ? this.tsParseSignatureMember("TSConstructSignatureDeclaration", e28) : (e28.key = this.createIdentifier(r3, "new"), this.tsParsePropertyOrMethodSignature(e28, false));
            }
            return this.tsParseModifiers({ allowedModifiers: ["readonly"], disallowedModifiers: ["declare", "abstract", "private", "protected", "public", "static", "override"] }, e28), this.tsTryParseIndexSignature(e28) || (super.parsePropertyName(e28), !e28.computed && e28.key.type === "Identifier" && (e28.key.name === "get" || e28.key.name === "set") && this.tsTokenCanFollowModifier() && (e28.kind = e28.key.name, super.parsePropertyName(e28)), this.tsParsePropertyOrMethodSignature(e28, !!e28.readonly));
          }
          tsParseTypeLiteral() {
            let e28 = this.startNode();
            return e28.members = this.tsParseObjectTypeMembers(), this.finishNode(e28, "TSTypeLiteral");
          }
          tsParseObjectTypeMembers() {
            this.expect(5);
            let e28 = this.tsParseList("TypeMembers", this.tsParseTypeMember.bind(this));
            return this.expect(8), e28;
          }
          tsIsStartOfMappedType() {
            return this.next(), this.eat(53) ? this.isContextual(120) : (this.isContextual(120) && this.next(), !this.match(0) || (this.next(), !this.tsIsIdentifier()) ? false : (this.next(), this.match(58)));
          }
          tsParseMappedTypeParameter() {
            let e28 = this.startNode();
            return e28.name = this.tsParseTypeParameterName(), e28.constraint = this.tsExpectThenParseType(58), this.finishNode(e28, "TSTypeParameter");
          }
          tsParseMappedType() {
            let e28 = this.startNode();
            return this.expect(5), this.match(53) ? (e28.readonly = this.state.value, this.next(), this.expectContextual(120)) : this.eatContextual(120) && (e28.readonly = true), this.expect(0), e28.typeParameter = this.tsParseMappedTypeParameter(), e28.nameType = this.eatContextual(93) ? this.tsParseType() : null, this.expect(3), this.match(53) ? (e28.optional = this.state.value, this.next(), this.expect(17)) : this.eat(17) && (e28.optional = true), e28.typeAnnotation = this.tsTryParseType(), this.semicolon(), this.expect(8), this.finishNode(e28, "TSMappedType");
          }
          tsParseTupleType() {
            let e28 = this.startNode();
            e28.elementTypes = this.tsParseBracketedList("TupleElementTypes", this.tsParseTupleElementType.bind(this), true, false);
            let s3 = false, r3 = null;
            return e28.elementTypes.forEach((i) => {
              let { type: a3 } = i;
              s3 && a3 !== "TSRestType" && a3 !== "TSOptionalType" && !(a3 === "TSNamedTupleMember" && i.optional) && this.raise(j3.OptionalTypeBeforeRequired, { at: i }), s3 || (s3 = a3 === "TSNamedTupleMember" && i.optional || a3 === "TSOptionalType");
              let n3 = a3;
              a3 === "TSRestType" && (i = i.typeAnnotation, n3 = i.type);
              let o3 = n3 === "TSNamedTupleMember";
              r3 != null || (r3 = o3), r3 !== o3 && this.raise(j3.MixedLabeledAndUnlabeledElements, { at: i });
            }), this.finishNode(e28, "TSTupleType");
          }
          tsParseTupleElementType() {
            let { startLoc: e28 } = this.state, s3 = this.eat(21), r3, i, a3, n3, o3 = Ae2(this.state.type) ? this.lookaheadCharCode() : null;
            if (o3 === 58)
              r3 = true, a3 = false, i = this.parseIdentifier(true), this.expect(14), n3 = this.tsParseType();
            else if (o3 === 63) {
              a3 = true;
              let h3 = this.state.startLoc, l3 = this.state.value, f3 = this.tsParseNonArrayType();
              this.lookaheadCharCode() === 58 ? (r3 = true, i = this.createIdentifier(this.startNodeAt(h3), l3), this.expect(17), this.expect(14), n3 = this.tsParseType()) : (r3 = false, n3 = f3, this.expect(17));
            } else
              n3 = this.tsParseType(), a3 = this.eat(17), r3 = this.eat(14);
            if (r3) {
              let h3;
              i ? (h3 = this.startNodeAtNode(i), h3.optional = a3, h3.label = i, h3.elementType = n3, this.eat(17) && (h3.optional = true, this.raise(j3.TupleOptionalAfterType, { at: this.state.lastTokStartLoc }))) : (h3 = this.startNodeAtNode(n3), h3.optional = a3, this.raise(j3.InvalidTupleMemberLabel, { at: n3 }), h3.label = n3, h3.elementType = this.tsParseType()), n3 = this.finishNode(h3, "TSNamedTupleMember");
            } else if (a3) {
              let h3 = this.startNodeAtNode(n3);
              h3.typeAnnotation = n3, n3 = this.finishNode(h3, "TSOptionalType");
            }
            if (s3) {
              let h3 = this.startNodeAt(e28);
              h3.typeAnnotation = n3, n3 = this.finishNode(h3, "TSRestType");
            }
            return n3;
          }
          tsParseParenthesizedType() {
            let e28 = this.startNode();
            return this.expect(10), e28.typeAnnotation = this.tsParseType(), this.expect(11), this.finishNode(e28, "TSParenthesizedType");
          }
          tsParseFunctionOrConstructorType(e28, s3) {
            let r3 = this.startNode();
            return e28 === "TSConstructorType" && (r3.abstract = !!s3, s3 && this.next(), this.next()), this.tsInAllowConditionalTypesContext(() => this.tsFillSignature(19, r3)), this.finishNode(r3, e28);
          }
          tsParseLiteralTypeNode() {
            let e28 = this.startNode();
            return e28.literal = (() => {
              switch (this.state.type) {
                case 132:
                case 133:
                case 131:
                case 85:
                case 86:
                  return super.parseExprAtom();
                default:
                  this.unexpected();
              }
            })(), this.finishNode(e28, "TSLiteralType");
          }
          tsParseTemplateLiteralType() {
            let e28 = this.startNode();
            return e28.literal = super.parseTemplate(false), this.finishNode(e28, "TSLiteralType");
          }
          parseTemplateSubstitution() {
            return this.state.inType ? this.tsParseType() : super.parseTemplateSubstitution();
          }
          tsParseThisTypeOrThisTypePredicate() {
            let e28 = this.tsParseThisTypeNode();
            return this.isContextual(114) && !this.hasPrecedingLineBreak() ? this.tsParseThisTypePredicate(e28) : e28;
          }
          tsParseNonArrayType() {
            switch (this.state.type) {
              case 131:
              case 132:
              case 133:
              case 85:
              case 86:
                return this.tsParseLiteralTypeNode();
              case 53:
                if (this.state.value === "-") {
                  let e28 = this.startNode(), s3 = this.lookahead();
                  return s3.type !== 132 && s3.type !== 133 && this.unexpected(), e28.literal = this.parseMaybeUnary(), this.finishNode(e28, "TSLiteralType");
                }
                break;
              case 78:
                return this.tsParseThisTypeOrThisTypePredicate();
              case 87:
                return this.tsParseTypeQuery();
              case 83:
                return this.tsParseImportType();
              case 5:
                return this.tsLookAhead(this.tsIsStartOfMappedType.bind(this)) ? this.tsParseMappedType() : this.tsParseTypeLiteral();
              case 0:
                return this.tsParseTupleType();
              case 10:
                return this.tsParseParenthesizedType();
              case 25:
              case 24:
                return this.tsParseTemplateLiteralType();
              default: {
                let { type: e28 } = this.state;
                if (te2(e28) || e28 === 88 || e28 === 84) {
                  let s3 = e28 === 88 ? "TSVoidKeyword" : e28 === 84 ? "TSNullKeyword" : Qn2(this.state.value);
                  if (s3 !== void 0 && this.lookaheadCharCode() !== 46) {
                    let r3 = this.startNode();
                    return this.next(), this.finishNode(r3, s3);
                  }
                  return this.tsParseTypeReference();
                }
              }
            }
            this.unexpected();
          }
          tsParseArrayTypeOrHigher() {
            let e28 = this.tsParseNonArrayType();
            for (; !this.hasPrecedingLineBreak() && this.eat(0); )
              if (this.match(3)) {
                let s3 = this.startNodeAtNode(e28);
                s3.elementType = e28, this.expect(3), e28 = this.finishNode(s3, "TSArrayType");
              } else {
                let s3 = this.startNodeAtNode(e28);
                s3.objectType = e28, s3.indexType = this.tsParseType(), this.expect(3), e28 = this.finishNode(s3, "TSIndexedAccessType");
              }
            return e28;
          }
          tsParseTypeOperator() {
            let e28 = this.startNode(), s3 = this.state.value;
            return this.next(), e28.operator = s3, e28.typeAnnotation = this.tsParseTypeOperatorOrHigher(), s3 === "readonly" && this.tsCheckTypeAnnotationForReadOnly(e28), this.finishNode(e28, "TSTypeOperator");
          }
          tsCheckTypeAnnotationForReadOnly(e28) {
            switch (e28.typeAnnotation.type) {
              case "TSTupleType":
              case "TSArrayType":
                return;
              default:
                this.raise(j3.UnexpectedReadonly, { at: e28 });
            }
          }
          tsParseInferType() {
            let e28 = this.startNode();
            this.expectContextual(113);
            let s3 = this.startNode();
            return s3.name = this.tsParseTypeParameterName(), s3.constraint = this.tsTryParse(() => this.tsParseConstraintForInferType()), e28.typeParameter = this.finishNode(s3, "TSTypeParameter"), this.finishNode(e28, "TSInferType");
          }
          tsParseConstraintForInferType() {
            if (this.eat(81)) {
              let e28 = this.tsInDisallowConditionalTypesContext(() => this.tsParseType());
              if (this.state.inDisallowConditionalTypesContext || !this.match(17))
                return e28;
            }
          }
          tsParseTypeOperatorOrHigher() {
            return Na2(this.state.type) && !this.state.containsEsc ? this.tsParseTypeOperator() : this.isContextual(113) ? this.tsParseInferType() : this.tsInAllowConditionalTypesContext(() => this.tsParseArrayTypeOrHigher());
          }
          tsParseUnionOrIntersectionType(e28, s3, r3) {
            let i = this.startNode(), a3 = this.eat(r3), n3 = [];
            do
              n3.push(s3());
            while (this.eat(r3));
            return n3.length === 1 && !a3 ? n3[0] : (i.types = n3, this.finishNode(i, e28));
          }
          tsParseIntersectionTypeOrHigher() {
            return this.tsParseUnionOrIntersectionType("TSIntersectionType", this.tsParseTypeOperatorOrHigher.bind(this), 45);
          }
          tsParseUnionTypeOrHigher() {
            return this.tsParseUnionOrIntersectionType("TSUnionType", this.tsParseIntersectionTypeOrHigher.bind(this), 43);
          }
          tsIsStartOfFunctionType() {
            return this.match(47) ? true : this.match(10) && this.tsLookAhead(this.tsIsUnambiguouslyStartOfFunctionType.bind(this));
          }
          tsSkipParameterStart() {
            if (te2(this.state.type) || this.match(78))
              return this.next(), true;
            if (this.match(5)) {
              let { errors: e28 } = this.state, s3 = e28.length;
              try {
                return this.parseObjectLike(8, true), e28.length === s3;
              } catch {
                return false;
              }
            }
            if (this.match(0)) {
              this.next();
              let { errors: e28 } = this.state, s3 = e28.length;
              try {
                return super.parseBindingList(3, 93, 1), e28.length === s3;
              } catch {
                return false;
              }
            }
            return false;
          }
          tsIsUnambiguouslyStartOfFunctionType() {
            return this.next(), !!(this.match(11) || this.match(21) || this.tsSkipParameterStart() && (this.match(14) || this.match(12) || this.match(17) || this.match(29) || this.match(11) && (this.next(), this.match(19))));
          }
          tsParseTypeOrTypePredicateAnnotation(e28) {
            return this.tsInType(() => {
              let s3 = this.startNode();
              this.expect(e28);
              let r3 = this.startNode(), i = !!this.tsTryParse(this.tsParseTypePredicateAsserts.bind(this));
              if (i && this.match(78)) {
                let o3 = this.tsParseThisTypeOrThisTypePredicate();
                return o3.type === "TSThisType" ? (r3.parameterName = o3, r3.asserts = true, r3.typeAnnotation = null, o3 = this.finishNode(r3, "TSTypePredicate")) : (this.resetStartLocationFromNode(o3, r3), o3.asserts = true), s3.typeAnnotation = o3, this.finishNode(s3, "TSTypeAnnotation");
              }
              let a3 = this.tsIsIdentifier() && this.tsTryParse(this.tsParseTypePredicatePrefix.bind(this));
              if (!a3)
                return i ? (r3.parameterName = this.parseIdentifier(), r3.asserts = i, r3.typeAnnotation = null, s3.typeAnnotation = this.finishNode(r3, "TSTypePredicate"), this.finishNode(s3, "TSTypeAnnotation")) : this.tsParseTypeAnnotation(false, s3);
              let n3 = this.tsParseTypeAnnotation(false);
              return r3.parameterName = a3, r3.typeAnnotation = n3, r3.asserts = i, s3.typeAnnotation = this.finishNode(r3, "TSTypePredicate"), this.finishNode(s3, "TSTypeAnnotation");
            });
          }
          tsTryParseTypeOrTypePredicateAnnotation() {
            return this.match(14) ? this.tsParseTypeOrTypePredicateAnnotation(14) : void 0;
          }
          tsTryParseTypeAnnotation() {
            return this.match(14) ? this.tsParseTypeAnnotation() : void 0;
          }
          tsTryParseType() {
            return this.tsEatThenParseType(14);
          }
          tsParseTypePredicatePrefix() {
            let e28 = this.parseIdentifier();
            if (this.isContextual(114) && !this.hasPrecedingLineBreak())
              return this.next(), e28;
          }
          tsParseTypePredicateAsserts() {
            if (this.state.type !== 107)
              return false;
            let e28 = this.state.containsEsc;
            return this.next(), !te2(this.state.type) && !this.match(78) ? false : (e28 && this.raise(p3.InvalidEscapedReservedWord, { at: this.state.lastTokStartLoc, reservedWord: "asserts" }), true);
          }
          tsParseTypeAnnotation() {
            let e28 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, s3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.startNode();
            return this.tsInType(() => {
              e28 && this.expect(14), s3.typeAnnotation = this.tsParseType();
            }), this.finishNode(s3, "TSTypeAnnotation");
          }
          tsParseType() {
            _r2(this.state.inType);
            let e28 = this.tsParseNonConditionalType();
            if (this.state.inDisallowConditionalTypesContext || this.hasPrecedingLineBreak() || !this.eat(81))
              return e28;
            let s3 = this.startNodeAtNode(e28);
            return s3.checkType = e28, s3.extendsType = this.tsInDisallowConditionalTypesContext(() => this.tsParseNonConditionalType()), this.expect(17), s3.trueType = this.tsInAllowConditionalTypesContext(() => this.tsParseType()), this.expect(14), s3.falseType = this.tsInAllowConditionalTypesContext(() => this.tsParseType()), this.finishNode(s3, "TSConditionalType");
          }
          isAbstractConstructorSignature() {
            return this.isContextual(122) && this.lookahead().type === 77;
          }
          tsParseNonConditionalType() {
            return this.tsIsStartOfFunctionType() ? this.tsParseFunctionOrConstructorType("TSFunctionType") : this.match(77) ? this.tsParseFunctionOrConstructorType("TSConstructorType") : this.isAbstractConstructorSignature() ? this.tsParseFunctionOrConstructorType("TSConstructorType", true) : this.tsParseUnionTypeOrHigher();
          }
          tsParseTypeAssertion() {
            this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(j3.ReservedTypeAssertion, { at: this.state.startLoc });
            let e28 = this.startNode();
            return e28.typeAnnotation = this.tsInType(() => (this.next(), this.match(75) ? this.tsParseTypeReference() : this.tsParseType())), this.expect(48), e28.expression = this.parseMaybeUnary(), this.finishNode(e28, "TSTypeAssertion");
          }
          tsParseHeritageClause(e28) {
            let s3 = this.state.startLoc, r3 = this.tsParseDelimitedList("HeritageClauseElement", () => {
              let i = this.startNode();
              return i.expression = this.tsParseEntityName(), this.match(47) && (i.typeParameters = this.tsParseTypeArguments()), this.finishNode(i, "TSExpressionWithTypeArguments");
            });
            return r3.length || this.raise(j3.EmptyHeritageClauseType, { at: s3, token: e28 }), r3;
          }
          tsParseInterfaceDeclaration(e28) {
            let s3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (this.hasFollowingLineBreak())
              return null;
            this.expectContextual(127), s3.declare && (e28.declare = true), te2(this.state.type) ? (e28.id = this.parseIdentifier(), this.checkIdentifier(e28.id, tn2)) : (e28.id = null, this.raise(j3.MissingInterfaceName, { at: this.state.startLoc })), e28.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutConstModifiers), this.eat(81) && (e28.extends = this.tsParseHeritageClause("extends"));
            let r3 = this.startNode();
            return r3.body = this.tsInType(this.tsParseObjectTypeMembers.bind(this)), e28.body = this.finishNode(r3, "TSInterfaceBody"), this.finishNode(e28, "TSInterfaceDeclaration");
          }
          tsParseTypeAliasDeclaration(e28) {
            return e28.id = this.parseIdentifier(), this.checkIdentifier(e28.id, sn2), e28.typeAnnotation = this.tsInType(() => {
              if (e28.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers), this.expect(29), this.isContextual(112) && this.lookahead().type !== 16) {
                let s3 = this.startNode();
                return this.next(), this.finishNode(s3, "TSIntrinsicKeyword");
              }
              return this.tsParseType();
            }), this.semicolon(), this.finishNode(e28, "TSTypeAliasDeclaration");
          }
          tsInNoContext(e28) {
            let s3 = this.state.context;
            this.state.context = [s3[0]];
            try {
              return e28();
            } finally {
              this.state.context = s3;
            }
          }
          tsInType(e28) {
            let s3 = this.state.inType;
            this.state.inType = true;
            try {
              return e28();
            } finally {
              this.state.inType = s3;
            }
          }
          tsInDisallowConditionalTypesContext(e28) {
            let s3 = this.state.inDisallowConditionalTypesContext;
            this.state.inDisallowConditionalTypesContext = true;
            try {
              return e28();
            } finally {
              this.state.inDisallowConditionalTypesContext = s3;
            }
          }
          tsInAllowConditionalTypesContext(e28) {
            let s3 = this.state.inDisallowConditionalTypesContext;
            this.state.inDisallowConditionalTypesContext = false;
            try {
              return e28();
            } finally {
              this.state.inDisallowConditionalTypesContext = s3;
            }
          }
          tsEatThenParseType(e28) {
            return this.match(e28) ? this.tsNextThenParseType() : void 0;
          }
          tsExpectThenParseType(e28) {
            return this.tsDoThenParseType(() => this.expect(e28));
          }
          tsNextThenParseType() {
            return this.tsDoThenParseType(() => this.next());
          }
          tsDoThenParseType(e28) {
            return this.tsInType(() => (e28(), this.tsParseType()));
          }
          tsParseEnumMember() {
            let e28 = this.startNode();
            return e28.id = this.match(131) ? super.parseStringLiteral(this.state.value) : this.parseIdentifier(true), this.eat(29) && (e28.initializer = super.parseMaybeAssignAllowIn()), this.finishNode(e28, "TSEnumMember");
          }
          tsParseEnumDeclaration(e28) {
            let s3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return s3.const && (e28.const = true), s3.declare && (e28.declare = true), this.expectContextual(124), e28.id = this.parseIdentifier(), this.checkIdentifier(e28.id, e28.const ? an2 : Tr2), this.expect(5), e28.members = this.tsParseDelimitedList("EnumMembers", this.tsParseEnumMember.bind(this)), this.expect(8), this.finishNode(e28, "TSEnumDeclaration");
          }
          tsParseModuleBlock() {
            let e28 = this.startNode();
            return this.scope.enter(Xe2), this.expect(5), super.parseBlockOrModuleBlockBody(e28.body = [], void 0, true, 8), this.scope.exit(), this.finishNode(e28, "TSModuleBlock");
          }
          tsParseModuleOrNamespaceDeclaration(e28) {
            let s3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            if (e28.id = this.parseIdentifier(), s3 || this.checkIdentifier(e28.id, nn2), this.eat(16)) {
              let r3 = this.startNode();
              this.tsParseModuleOrNamespaceDeclaration(r3, true), e28.body = r3;
            } else
              this.scope.enter(Ye2), this.prodParam.enter(Ze2), e28.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit();
            return this.finishNode(e28, "TSModuleDeclaration");
          }
          tsParseAmbientExternalModuleDeclaration(e28) {
            return this.isContextual(110) ? (e28.global = true, e28.id = this.parseIdentifier()) : this.match(131) ? e28.id = super.parseStringLiteral(this.state.value) : this.unexpected(), this.match(5) ? (this.scope.enter(Ye2), this.prodParam.enter(Ze2), e28.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit()) : this.semicolon(), this.finishNode(e28, "TSModuleDeclaration");
          }
          tsParseImportEqualsDeclaration(e28, s3) {
            e28.isExport = s3 || false, e28.id = this.parseIdentifier(), this.checkIdentifier(e28.id, at2), this.expect(29);
            let r3 = this.tsParseModuleReference();
            return e28.importKind === "type" && r3.type !== "TSExternalModuleReference" && this.raise(j3.ImportAliasHasImportType, { at: r3 }), e28.moduleReference = r3, this.semicolon(), this.finishNode(e28, "TSImportEqualsDeclaration");
          }
          tsIsExternalModuleReference() {
            return this.isContextual(117) && this.lookaheadCharCode() === 40;
          }
          tsParseModuleReference() {
            return this.tsIsExternalModuleReference() ? this.tsParseExternalModuleReference() : this.tsParseEntityName(false);
          }
          tsParseExternalModuleReference() {
            let e28 = this.startNode();
            return this.expectContextual(117), this.expect(10), this.match(131) || this.unexpected(), e28.expression = super.parseExprAtom(), this.expect(11), this.finishNode(e28, "TSExternalModuleReference");
          }
          tsLookAhead(e28) {
            let s3 = this.state.clone(), r3 = e28();
            return this.state = s3, r3;
          }
          tsTryParseAndCatch(e28) {
            let s3 = this.tryParse((r3) => e28() || r3());
            if (!(s3.aborted || !s3.node))
              return s3.error && (this.state = s3.failState), s3.node;
          }
          tsTryParse(e28) {
            let s3 = this.state.clone(), r3 = e28();
            if (r3 !== void 0 && r3 !== false)
              return r3;
            this.state = s3;
          }
          tsTryParseDeclare(e28) {
            if (this.isLineTerminator())
              return;
            let s3 = this.state.type, r3;
            return this.isContextual(99) && (s3 = 74, r3 = "let"), this.tsInAmbientContext(() => {
              if (s3 === 68)
                return e28.declare = true, super.parseFunctionStatement(e28, false, false);
              if (s3 === 80)
                return e28.declare = true, this.parseClass(e28, true, false);
              if (s3 === 124)
                return this.tsParseEnumDeclaration(e28, { declare: true });
              if (s3 === 110)
                return this.tsParseAmbientExternalModuleDeclaration(e28);
              if (s3 === 75 || s3 === 74)
                return !this.match(75) || !this.isLookaheadContextual("enum") ? (e28.declare = true, this.parseVarStatement(e28, r3 || this.state.value, true)) : (this.expect(75), this.tsParseEnumDeclaration(e28, { const: true, declare: true }));
              if (s3 === 127) {
                let i = this.tsParseInterfaceDeclaration(e28, { declare: true });
                if (i)
                  return i;
              }
              if (te2(s3))
                return this.tsParseDeclaration(e28, this.state.value, true, null);
            });
          }
          tsTryParseExportDeclaration() {
            return this.tsParseDeclaration(this.startNode(), this.state.value, true, null);
          }
          tsParseExpressionStatement(e28, s3, r3) {
            switch (s3.name) {
              case "declare": {
                let i = this.tsTryParseDeclare(e28);
                if (i)
                  return i.declare = true, i;
                break;
              }
              case "global":
                if (this.match(5)) {
                  this.scope.enter(Ye2), this.prodParam.enter(Ze2);
                  let i = e28;
                  return i.global = true, i.id = s3, i.body = this.tsParseModuleBlock(), this.scope.exit(), this.prodParam.exit(), this.finishNode(i, "TSModuleDeclaration");
                }
                break;
              default:
                return this.tsParseDeclaration(e28, s3.name, false, r3);
            }
          }
          tsParseDeclaration(e28, s3, r3, i) {
            switch (s3) {
              case "abstract":
                if (this.tsCheckLineTerminator(r3) && (this.match(80) || te2(this.state.type)))
                  return this.tsParseAbstractDeclaration(e28, i);
                break;
              case "module":
                if (this.tsCheckLineTerminator(r3)) {
                  if (this.match(131))
                    return this.tsParseAmbientExternalModuleDeclaration(e28);
                  if (te2(this.state.type))
                    return this.tsParseModuleOrNamespaceDeclaration(e28);
                }
                break;
              case "namespace":
                if (this.tsCheckLineTerminator(r3) && te2(this.state.type))
                  return this.tsParseModuleOrNamespaceDeclaration(e28);
                break;
              case "type":
                if (this.tsCheckLineTerminator(r3) && te2(this.state.type))
                  return this.tsParseTypeAliasDeclaration(e28);
                break;
            }
          }
          tsCheckLineTerminator(e28) {
            return e28 ? this.hasFollowingLineBreak() ? false : (this.next(), true) : !this.isLineTerminator();
          }
          tsTryParseGenericAsyncArrowFunction(e28) {
            if (!this.match(47))
              return;
            let s3 = this.state.maybeInArrowParameters;
            this.state.maybeInArrowParameters = true;
            let r3 = this.tsTryParseAndCatch(() => {
              let i = this.startNodeAt(e28);
              return i.typeParameters = this.tsParseTypeParameters(this.tsParseConstModifier), super.parseFunctionParams(i), i.returnType = this.tsTryParseTypeOrTypePredicateAnnotation(), this.expect(19), i;
            });
            if (this.state.maybeInArrowParameters = s3, !!r3)
              return super.parseArrowExpression(r3, null, true);
          }
          tsParseTypeArgumentsInExpression() {
            if (this.reScan_lt() === 47)
              return this.tsParseTypeArguments();
          }
          tsParseTypeArguments() {
            let e28 = this.startNode();
            return e28.params = this.tsInType(() => this.tsInNoContext(() => (this.expect(47), this.tsParseDelimitedList("TypeParametersOrArguments", this.tsParseType.bind(this))))), e28.params.length === 0 && this.raise(j3.EmptyTypeArguments, { at: e28 }), this.expect(48), this.finishNode(e28, "TSTypeParameterInstantiation");
          }
          tsIsDeclarationStart() {
            return ka2(this.state.type);
          }
          isExportDefaultSpecifier() {
            return this.tsIsDeclarationStart() ? false : super.isExportDefaultSpecifier();
          }
          parseAssignableListItem(e28, s3) {
            let r3 = this.state.startLoc, i = {};
            this.tsParseModifiers({ allowedModifiers: ["public", "private", "protected", "override", "readonly"] }, i);
            let a3 = i.accessibility, n3 = i.override, o3 = i.readonly;
            !(e28 & 4) && (a3 || o3 || n3) && this.raise(j3.UnexpectedParameterModifier, { at: r3 });
            let h3 = this.parseMaybeDefault();
            this.parseAssignableListItemTypes(h3, e28);
            let l3 = this.parseMaybeDefault(h3.loc.start, h3);
            if (a3 || o3 || n3) {
              let f3 = this.startNodeAt(r3);
              return s3.length && (f3.decorators = s3), a3 && (f3.accessibility = a3), o3 && (f3.readonly = o3), n3 && (f3.override = n3), l3.type !== "Identifier" && l3.type !== "AssignmentPattern" && this.raise(j3.UnsupportedParameterPropertyKind, { at: f3 }), f3.parameter = l3, this.finishNode(f3, "TSParameterProperty");
            }
            return s3.length && (h3.decorators = s3), l3;
          }
          isSimpleParameter(e28) {
            return e28.type === "TSParameterProperty" && super.isSimpleParameter(e28.parameter) || super.isSimpleParameter(e28);
          }
          tsDisallowOptionalPattern(e28) {
            for (let s3 of e28.params)
              s3.type !== "Identifier" && s3.optional && !this.state.isAmbientContext && this.raise(j3.PatternIsOptional, { at: s3 });
          }
          setArrowFunctionParameters(e28, s3, r3) {
            super.setArrowFunctionParameters(e28, s3, r3), this.tsDisallowOptionalPattern(e28);
          }
          parseFunctionBodyAndFinish(e28, s3) {
            let r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            this.match(14) && (e28.returnType = this.tsParseTypeOrTypePredicateAnnotation(14));
            let i = s3 === "FunctionDeclaration" ? "TSDeclareFunction" : s3 === "ClassMethod" || s3 === "ClassPrivateMethod" ? "TSDeclareMethod" : void 0;
            return i && !this.match(5) && this.isLineTerminator() ? this.finishNode(e28, i) : i === "TSDeclareFunction" && this.state.isAmbientContext && (this.raise(j3.DeclareFunctionHasImplementation, { at: e28 }), e28.declare) ? super.parseFunctionBodyAndFinish(e28, i, r3) : (this.tsDisallowOptionalPattern(e28), super.parseFunctionBodyAndFinish(e28, s3, r3));
          }
          registerFunctionStatementId(e28) {
            !e28.body && e28.id ? this.checkIdentifier(e28.id, Er2) : super.registerFunctionStatementId(e28);
          }
          tsCheckForInvalidTypeCasts(e28) {
            e28.forEach((s3) => {
              (s3 == null ? void 0 : s3.type) === "TSTypeCastExpression" && this.raise(j3.UnexpectedTypeAnnotation, { at: s3.typeAnnotation });
            });
          }
          toReferencedList(e28, s3) {
            return this.tsCheckForInvalidTypeCasts(e28), e28;
          }
          parseArrayLike(e28, s3, r3, i) {
            let a3 = super.parseArrayLike(e28, s3, r3, i);
            return a3.type === "ArrayExpression" && this.tsCheckForInvalidTypeCasts(a3.elements), a3;
          }
          parseSubscript(e28, s3, r3, i) {
            if (!this.hasPrecedingLineBreak() && this.match(35)) {
              this.state.canStartJSXElement = false, this.next();
              let n3 = this.startNodeAt(s3);
              return n3.expression = e28, this.finishNode(n3, "TSNonNullExpression");
            }
            let a3 = false;
            if (this.match(18) && this.lookaheadCharCode() === 60) {
              if (r3)
                return i.stop = true, e28;
              i.optionalChainMember = a3 = true, this.next();
            }
            if (this.match(47) || this.match(51)) {
              let n3, o3 = this.tsTryParseAndCatch(() => {
                if (!r3 && this.atPossibleAsyncArrow(e28)) {
                  let T3 = this.tsTryParseGenericAsyncArrowFunction(s3);
                  if (T3)
                    return T3;
                }
                let h3 = this.tsParseTypeArgumentsInExpression();
                if (!h3)
                  return;
                if (a3 && !this.match(10)) {
                  n3 = this.state.curPosition();
                  return;
                }
                if (Pt2(this.state.type)) {
                  let T3 = super.parseTaggedTemplateExpression(e28, s3, i);
                  return T3.typeParameters = h3, T3;
                }
                if (!r3 && this.eat(10)) {
                  let T3 = this.startNodeAt(s3);
                  return T3.callee = e28, T3.arguments = this.parseCallExpressionArguments(11, false), this.tsCheckForInvalidTypeCasts(T3.arguments), T3.typeParameters = h3, i.optionalChainMember && (T3.optional = a3), this.finishCallExpression(T3, i.optionalChainMember);
                }
                let l3 = this.state.type;
                if (l3 === 48 || l3 === 52 || l3 !== 10 && rt2(l3) && !this.hasPrecedingLineBreak())
                  return;
                let f3 = this.startNodeAt(s3);
                return f3.expression = e28, f3.typeParameters = h3, this.finishNode(f3, "TSInstantiationExpression");
              });
              if (n3 && this.unexpected(n3, 10), o3)
                return o3.type === "TSInstantiationExpression" && (this.match(16) || this.match(18) && this.lookaheadCharCode() !== 40) && this.raise(j3.InvalidPropertyAccessAfterInstantiationExpression, { at: this.state.startLoc }), o3;
            }
            return super.parseSubscript(e28, s3, r3, i);
          }
          parseNewCallee(e28) {
            var s3;
            super.parseNewCallee(e28);
            let { callee: r3 } = e28;
            r3.type === "TSInstantiationExpression" && !((s3 = r3.extra) != null && s3.parenthesized) && (e28.typeParameters = r3.typeParameters, e28.callee = r3.expression);
          }
          parseExprOp(e28, s3, r3) {
            let i;
            if (gt2(58) > r3 && !this.hasPrecedingLineBreak() && (this.isContextual(93) || (i = this.isContextual(118)))) {
              let a3 = this.startNodeAt(s3);
              return a3.expression = e28, a3.typeAnnotation = this.tsInType(() => (this.next(), this.match(75) ? (i && this.raise(p3.UnexpectedKeyword, { at: this.state.startLoc, keyword: "const" }), this.tsParseTypeReference()) : this.tsParseType())), this.finishNode(a3, i ? "TSSatisfiesExpression" : "TSAsExpression"), this.reScan_lt_gt(), this.parseExprOp(a3, s3, r3);
            }
            return super.parseExprOp(e28, s3, r3);
          }
          checkReservedWord(e28, s3, r3, i) {
            this.state.isAmbientContext || super.checkReservedWord(e28, s3, r3, i);
          }
          checkImportReflection(e28) {
            super.checkImportReflection(e28), e28.module && e28.importKind !== "value" && this.raise(j3.ImportReflectionHasImportType, { at: e28.specifiers[0].loc.start });
          }
          checkDuplicateExports() {
          }
          parseImport(e28) {
            if (e28.importKind = "value", te2(this.state.type) || this.match(55) || this.match(5)) {
              let r3 = this.lookahead();
              if (this.isContextual(128) && r3.type !== 12 && r3.type !== 97 && r3.type !== 29 && (e28.importKind = "type", this.next(), r3 = this.lookahead()), te2(this.state.type) && r3.type === 29)
                return this.tsParseImportEqualsDeclaration(e28);
            }
            let s3 = super.parseImport(e28);
            return s3.importKind === "type" && s3.specifiers.length > 1 && s3.specifiers[0].type === "ImportDefaultSpecifier" && this.raise(j3.TypeImportCannotSpecifyDefaultAndNamed, { at: s3 }), s3;
          }
          parseExport(e28, s3) {
            if (this.match(83))
              return this.next(), this.isContextual(128) && this.lookaheadCharCode() !== 61 ? (e28.importKind = "type", this.next()) : e28.importKind = "value", this.tsParseImportEqualsDeclaration(e28, true);
            if (this.eat(29)) {
              let r3 = e28;
              return r3.expression = super.parseExpression(), this.semicolon(), this.finishNode(r3, "TSExportAssignment");
            } else if (this.eatContextual(93)) {
              let r3 = e28;
              return this.expectContextual(126), r3.id = this.parseIdentifier(), this.semicolon(), this.finishNode(r3, "TSNamespaceExportDeclaration");
            } else {
              if (e28.exportKind = "value", this.isContextual(128)) {
                let r3 = this.lookaheadCharCode();
                (r3 === 123 || r3 === 42) && (this.next(), e28.exportKind = "type");
              }
              return super.parseExport(e28, s3);
            }
          }
          isAbstractClass() {
            return this.isContextual(122) && this.lookahead().type === 80;
          }
          parseExportDefaultExpression() {
            if (this.isAbstractClass()) {
              let e28 = this.startNode();
              return this.next(), e28.abstract = true, this.parseClass(e28, true, true);
            }
            if (this.match(127)) {
              let e28 = this.tsParseInterfaceDeclaration(this.startNode());
              if (e28)
                return e28;
            }
            return super.parseExportDefaultExpression();
          }
          parseVarStatement(e28, s3) {
            let r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, { isAmbientContext: i } = this.state, a3 = super.parseVarStatement(e28, s3, r3 || i);
            if (!i)
              return a3;
            for (let { id: n3, init: o3 } of a3.declarations)
              o3 && (s3 !== "const" || n3.typeAnnotation ? this.raise(j3.InitializerNotAllowedInAmbientContext, { at: o3 }) : so2(o3, this.hasPlugin("estree")) || this.raise(j3.ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference, { at: o3 }));
            return a3;
          }
          parseStatementContent(e28, s3) {
            if (this.match(75) && this.isLookaheadContextual("enum")) {
              let r3 = this.startNode();
              return this.expect(75), this.tsParseEnumDeclaration(r3, { const: true });
            }
            if (this.isContextual(124))
              return this.tsParseEnumDeclaration(this.startNode());
            if (this.isContextual(127)) {
              let r3 = this.tsParseInterfaceDeclaration(this.startNode());
              if (r3)
                return r3;
            }
            return super.parseStatementContent(e28, s3);
          }
          parseAccessModifier() {
            return this.tsParseModifier(["public", "protected", "private"]);
          }
          tsHasSomeModifiers(e28, s3) {
            return s3.some((r3) => zr2(r3) ? e28.accessibility === r3 : !!e28[r3]);
          }
          tsIsStartOfStaticBlocks() {
            return this.isContextual(104) && this.lookaheadCharCode() === 123;
          }
          parseClassMember(e28, s3, r3) {
            let i = ["declare", "private", "public", "protected", "override", "abstract", "readonly", "static"];
            this.tsParseModifiers({ allowedModifiers: i, disallowedModifiers: ["in", "out"], stopOnStartOfClassStaticBlock: true, errorTemplate: j3.InvalidModifierOnTypeParameterPositions }, s3);
            let a3 = () => {
              this.tsIsStartOfStaticBlocks() ? (this.next(), this.next(), this.tsHasSomeModifiers(s3, i) && this.raise(j3.StaticBlockCannotHaveModifier, { at: this.state.curPosition() }), super.parseClassStaticBlock(e28, s3)) : this.parseClassMemberWithIsStatic(e28, s3, r3, !!s3.static);
            };
            s3.declare ? this.tsInAmbientContext(a3) : a3();
          }
          parseClassMemberWithIsStatic(e28, s3, r3, i) {
            let a3 = this.tsTryParseIndexSignature(s3);
            if (a3) {
              e28.body.push(a3), s3.abstract && this.raise(j3.IndexSignatureHasAbstract, { at: s3 }), s3.accessibility && this.raise(j3.IndexSignatureHasAccessibility, { at: s3, modifier: s3.accessibility }), s3.declare && this.raise(j3.IndexSignatureHasDeclare, { at: s3 }), s3.override && this.raise(j3.IndexSignatureHasOverride, { at: s3 });
              return;
            }
            !this.state.inAbstractClass && s3.abstract && this.raise(j3.NonAbstractClassHasAbstractMethod, { at: s3 }), s3.override && (r3.hadSuperClass || this.raise(j3.OverrideNotInSubClass, { at: s3 })), super.parseClassMemberWithIsStatic(e28, s3, r3, i);
          }
          parsePostMemberNameModifiers(e28) {
            this.eat(17) && (e28.optional = true), e28.readonly && this.match(10) && this.raise(j3.ClassMethodHasReadonly, { at: e28 }), e28.declare && this.match(10) && this.raise(j3.ClassMethodHasDeclare, { at: e28 });
          }
          parseExpressionStatement(e28, s3, r3) {
            return (s3.type === "Identifier" ? this.tsParseExpressionStatement(e28, s3, r3) : void 0) || super.parseExpressionStatement(e28, s3, r3);
          }
          shouldParseExportDeclaration() {
            return this.tsIsDeclarationStart() ? true : super.shouldParseExportDeclaration();
          }
          parseConditional(e28, s3, r3) {
            if (!this.state.maybeInArrowParameters || !this.match(17))
              return super.parseConditional(e28, s3, r3);
            let i = this.tryParse(() => super.parseConditional(e28, s3));
            return i.node ? (i.error && (this.state = i.failState), i.node) : (i.error && super.setOptionalParametersError(r3, i.error), e28);
          }
          parseParenItem(e28, s3) {
            if (e28 = super.parseParenItem(e28, s3), this.eat(17) && (e28.optional = true, this.resetEndLocation(e28)), this.match(14)) {
              let r3 = this.startNodeAt(s3);
              return r3.expression = e28, r3.typeAnnotation = this.tsParseTypeAnnotation(), this.finishNode(r3, "TSTypeCastExpression");
            }
            return e28;
          }
          parseExportDeclaration(e28) {
            if (!this.state.isAmbientContext && this.isContextual(123))
              return this.tsInAmbientContext(() => this.parseExportDeclaration(e28));
            let s3 = this.state.startLoc, r3 = this.eatContextual(123);
            if (r3 && (this.isContextual(123) || !this.shouldParseExportDeclaration()))
              throw this.raise(j3.ExpectedAmbientAfterExportDeclare, { at: this.state.startLoc });
            let i = te2(this.state.type) && this.tsTryParseExportDeclaration() || super.parseExportDeclaration(e28);
            return i ? ((i.type === "TSInterfaceDeclaration" || i.type === "TSTypeAliasDeclaration" || r3) && (e28.exportKind = "type"), r3 && (this.resetStartLocation(i, s3), i.declare = true), i) : null;
          }
          parseClassId(e28, s3, r3, i) {
            if ((!s3 || r3) && this.isContextual(111))
              return;
            super.parseClassId(e28, s3, r3, e28.declare ? Er2 : Ar2);
            let a3 = this.tsTryParseTypeParameters(this.tsParseInOutConstModifiers);
            a3 && (e28.typeParameters = a3);
          }
          parseClassPropertyAnnotation(e28) {
            e28.optional || (this.eat(35) ? e28.definite = true : this.eat(17) && (e28.optional = true));
            let s3 = this.tsTryParseTypeAnnotation();
            s3 && (e28.typeAnnotation = s3);
          }
          parseClassProperty(e28) {
            if (this.parseClassPropertyAnnotation(e28), this.state.isAmbientContext && !(e28.readonly && !e28.typeAnnotation) && this.match(29) && this.raise(j3.DeclareClassFieldHasInitializer, { at: this.state.startLoc }), e28.abstract && this.match(29)) {
              let { key: s3 } = e28;
              this.raise(j3.AbstractPropertyHasInitializer, { at: this.state.startLoc, propertyName: s3.type === "Identifier" && !e28.computed ? s3.name : `[${this.input.slice(s3.start, s3.end)}]` });
            }
            return super.parseClassProperty(e28);
          }
          parseClassPrivateProperty(e28) {
            return e28.abstract && this.raise(j3.PrivateElementHasAbstract, { at: e28 }), e28.accessibility && this.raise(j3.PrivateElementHasAccessibility, { at: e28, modifier: e28.accessibility }), this.parseClassPropertyAnnotation(e28), super.parseClassPrivateProperty(e28);
          }
          parseClassAccessorProperty(e28) {
            return this.parseClassPropertyAnnotation(e28), e28.optional && this.raise(j3.AccessorCannotBeOptional, { at: e28 }), super.parseClassAccessorProperty(e28);
          }
          pushClassMethod(e28, s3, r3, i, a3, n3) {
            let o3 = this.tsTryParseTypeParameters(this.tsParseConstModifier);
            o3 && a3 && this.raise(j3.ConstructorHasTypeParameters, { at: o3 });
            let { declare: h3 = false, kind: l3 } = s3;
            h3 && (l3 === "get" || l3 === "set") && this.raise(j3.DeclareAccessor, { at: s3, kind: l3 }), o3 && (s3.typeParameters = o3), super.pushClassMethod(e28, s3, r3, i, a3, n3);
          }
          pushClassPrivateMethod(e28, s3, r3, i) {
            let a3 = this.tsTryParseTypeParameters(this.tsParseConstModifier);
            a3 && (s3.typeParameters = a3), super.pushClassPrivateMethod(e28, s3, r3, i);
          }
          declareClassPrivateMethodInScope(e28, s3) {
            e28.type !== "TSDeclareMethod" && (e28.type === "MethodDefinition" && !e28.value.body || super.declareClassPrivateMethodInScope(e28, s3));
          }
          parseClassSuper(e28) {
            super.parseClassSuper(e28), e28.superClass && (this.match(47) || this.match(51)) && (e28.superTypeParameters = this.tsParseTypeArgumentsInExpression()), this.eatContextual(111) && (e28.implements = this.tsParseHeritageClause("implements"));
          }
          parseObjPropValue(e28, s3, r3, i, a3, n3, o3) {
            let h3 = this.tsTryParseTypeParameters(this.tsParseConstModifier);
            return h3 && (e28.typeParameters = h3), super.parseObjPropValue(e28, s3, r3, i, a3, n3, o3);
          }
          parseFunctionParams(e28, s3) {
            let r3 = this.tsTryParseTypeParameters(this.tsParseConstModifier);
            r3 && (e28.typeParameters = r3), super.parseFunctionParams(e28, s3);
          }
          parseVarId(e28, s3) {
            super.parseVarId(e28, s3), e28.id.type === "Identifier" && !this.hasPrecedingLineBreak() && this.eat(35) && (e28.definite = true);
            let r3 = this.tsTryParseTypeAnnotation();
            r3 && (e28.id.typeAnnotation = r3, this.resetEndLocation(e28.id));
          }
          parseAsyncArrowFromCallExpression(e28, s3) {
            return this.match(14) && (e28.returnType = this.tsParseTypeAnnotation()), super.parseAsyncArrowFromCallExpression(e28, s3);
          }
          parseMaybeAssign(e28, s3) {
            var r3, i, a3, n3, o3, h3, l3;
            let f3, T3, R3;
            if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
              if (f3 = this.state.clone(), T3 = this.tryParse(() => super.parseMaybeAssign(e28, s3), f3), !T3.error)
                return T3.node;
              let { context: re2 } = this.state, ce2 = re2[re2.length - 1];
              (ce2 === g3.j_oTag || ce2 === g3.j_expr) && re2.pop();
            }
            if (!((r3 = T3) != null && r3.error) && !this.match(47))
              return super.parseMaybeAssign(e28, s3);
            (!f3 || f3 === this.state) && (f3 = this.state.clone());
            let B3, se2 = this.tryParse((re2) => {
              var ce2, de2;
              B3 = this.tsParseTypeParameters(this.tsParseConstModifier);
              let oe2 = super.parseMaybeAssign(e28, s3);
              return (oe2.type !== "ArrowFunctionExpression" || (ce2 = oe2.extra) != null && ce2.parenthesized) && re2(), ((de2 = B3) == null ? void 0 : de2.params.length) !== 0 && this.resetStartLocationFromNode(oe2, B3), oe2.typeParameters = B3, oe2;
            }, f3);
            if (!se2.error && !se2.aborted)
              return B3 && this.reportReservedArrowTypeParam(B3), se2.node;
            if (!T3 && (_r2(!this.hasPlugin("jsx")), R3 = this.tryParse(() => super.parseMaybeAssign(e28, s3), f3), !R3.error))
              return R3.node;
            if ((i = T3) != null && i.node)
              return this.state = T3.failState, T3.node;
            if (se2.node)
              return this.state = se2.failState, B3 && this.reportReservedArrowTypeParam(B3), se2.node;
            if ((a3 = R3) != null && a3.node)
              return this.state = R3.failState, R3.node;
            throw (n3 = T3) != null && n3.thrown ? T3.error : se2.thrown ? se2.error : (o3 = R3) != null && o3.thrown ? R3.error : ((h3 = T3) == null ? void 0 : h3.error) || se2.error || ((l3 = R3) == null ? void 0 : l3.error);
          }
          reportReservedArrowTypeParam(e28) {
            var s3;
            e28.params.length === 1 && !e28.params[0].constraint && !((s3 = e28.extra) != null && s3.trailingComma) && this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(j3.ReservedArrowTypeParam, { at: e28 });
          }
          parseMaybeUnary(e28, s3) {
            return !this.hasPlugin("jsx") && this.match(47) ? this.tsParseTypeAssertion() : super.parseMaybeUnary(e28, s3);
          }
          parseArrow(e28) {
            if (this.match(14)) {
              let s3 = this.tryParse((r3) => {
                let i = this.tsParseTypeOrTypePredicateAnnotation(14);
                return (this.canInsertSemicolon() || !this.match(19)) && r3(), i;
              });
              if (s3.aborted)
                return;
              s3.thrown || (s3.error && (this.state = s3.failState), e28.returnType = s3.node);
            }
            return super.parseArrow(e28);
          }
          parseAssignableListItemTypes(e28, s3) {
            if (!(s3 & 2))
              return e28;
            this.eat(17) && (e28.optional = true);
            let r3 = this.tsTryParseTypeAnnotation();
            return r3 && (e28.typeAnnotation = r3), this.resetEndLocation(e28), e28;
          }
          isAssignable(e28, s3) {
            switch (e28.type) {
              case "TSTypeCastExpression":
                return this.isAssignable(e28.expression, s3);
              case "TSParameterProperty":
                return true;
              default:
                return super.isAssignable(e28, s3);
            }
          }
          toAssignable(e28) {
            let s3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            switch (e28.type) {
              case "ParenthesizedExpression":
                this.toAssignableParenthesizedExpression(e28, s3);
                break;
              case "TSAsExpression":
              case "TSSatisfiesExpression":
              case "TSNonNullExpression":
              case "TSTypeAssertion":
                s3 ? this.expressionScope.recordArrowParameterBindingError(j3.UnexpectedTypeCastInParameter, { at: e28 }) : this.raise(j3.UnexpectedTypeCastInParameter, { at: e28 }), this.toAssignable(e28.expression, s3);
                break;
              case "AssignmentExpression":
                !s3 && e28.left.type === "TSTypeCastExpression" && (e28.left = this.typeCastToParameter(e28.left));
              default:
                super.toAssignable(e28, s3);
            }
          }
          toAssignableParenthesizedExpression(e28, s3) {
            switch (e28.expression.type) {
              case "TSAsExpression":
              case "TSSatisfiesExpression":
              case "TSNonNullExpression":
              case "TSTypeAssertion":
              case "ParenthesizedExpression":
                this.toAssignable(e28.expression, s3);
                break;
              default:
                super.toAssignable(e28, s3);
            }
          }
          checkToRestConversion(e28, s3) {
            switch (e28.type) {
              case "TSAsExpression":
              case "TSSatisfiesExpression":
              case "TSTypeAssertion":
              case "TSNonNullExpression":
                this.checkToRestConversion(e28.expression, false);
                break;
              default:
                super.checkToRestConversion(e28, s3);
            }
          }
          isValidLVal(e28, s3, r3) {
            return Gn2({ TSTypeCastExpression: true, TSParameterProperty: "parameter", TSNonNullExpression: "expression", TSAsExpression: (r3 !== Oe2 || !s3) && ["expression", true], TSSatisfiesExpression: (r3 !== Oe2 || !s3) && ["expression", true], TSTypeAssertion: (r3 !== Oe2 || !s3) && ["expression", true] }, e28) || super.isValidLVal(e28, s3, r3);
          }
          parseBindingAtom() {
            switch (this.state.type) {
              case 78:
                return this.parseIdentifier(true);
              default:
                return super.parseBindingAtom();
            }
          }
          parseMaybeDecoratorArguments(e28) {
            if (this.match(47) || this.match(51)) {
              let s3 = this.tsParseTypeArgumentsInExpression();
              if (this.match(10)) {
                let r3 = super.parseMaybeDecoratorArguments(e28);
                return r3.typeParameters = s3, r3;
              }
              this.unexpected(null, 10);
            }
            return super.parseMaybeDecoratorArguments(e28);
          }
          checkCommaAfterRest(e28) {
            return this.state.isAmbientContext && this.match(12) && this.lookaheadCharCode() === e28 ? (this.next(), false) : super.checkCommaAfterRest(e28);
          }
          isClassMethod() {
            return this.match(47) || super.isClassMethod();
          }
          isClassProperty() {
            return this.match(35) || this.match(14) || super.isClassProperty();
          }
          parseMaybeDefault(e28, s3) {
            let r3 = super.parseMaybeDefault(e28, s3);
            return r3.type === "AssignmentPattern" && r3.typeAnnotation && r3.right.start < r3.typeAnnotation.start && this.raise(j3.TypeAnnotationAfterAssign, { at: r3.typeAnnotation }), r3;
          }
          getTokenFromCode(e28) {
            if (this.state.inType) {
              if (e28 === 62) {
                this.finishOp(48, 1);
                return;
              }
              if (e28 === 60) {
                this.finishOp(47, 1);
                return;
              }
            }
            super.getTokenFromCode(e28);
          }
          reScan_lt_gt() {
            let { type: e28 } = this.state;
            e28 === 47 ? (this.state.pos -= 1, this.readToken_lt()) : e28 === 48 && (this.state.pos -= 1, this.readToken_gt());
          }
          reScan_lt() {
            let { type: e28 } = this.state;
            return e28 === 51 ? (this.state.pos -= 2, this.finishOp(47, 1), 47) : e28;
          }
          toAssignableList(e28, s3, r3) {
            for (let i = 0; i < e28.length; i++) {
              let a3 = e28[i];
              (a3 == null ? void 0 : a3.type) === "TSTypeCastExpression" && (e28[i] = this.typeCastToParameter(a3));
            }
            super.toAssignableList(e28, s3, r3);
          }
          typeCastToParameter(e28) {
            return e28.expression.typeAnnotation = e28.typeAnnotation, this.resetEndLocation(e28.expression, e28.typeAnnotation.loc.end), e28.expression;
          }
          shouldParseArrow(e28) {
            return this.match(14) ? e28.every((s3) => this.isAssignable(s3, true)) : super.shouldParseArrow(e28);
          }
          shouldParseAsyncArrow() {
            return this.match(14) || super.shouldParseAsyncArrow();
          }
          canHaveLeadingDecorator() {
            return super.canHaveLeadingDecorator() || this.isAbstractClass();
          }
          jsxParseOpeningElementAfterName(e28) {
            if (this.match(47) || this.match(51)) {
              let s3 = this.tsTryParseAndCatch(() => this.tsParseTypeArgumentsInExpression());
              s3 && (e28.typeParameters = s3);
            }
            return super.jsxParseOpeningElementAfterName(e28);
          }
          getGetterSetterExpectedParamCount(e28) {
            let s3 = super.getGetterSetterExpectedParamCount(e28), r3 = this.getObjectOrClassMethodParams(e28)[0];
            return r3 && this.isThisParam(r3) ? s3 + 1 : s3;
          }
          parseCatchClauseParam() {
            let e28 = super.parseCatchClauseParam(), s3 = this.tsTryParseTypeAnnotation();
            return s3 && (e28.typeAnnotation = s3, this.resetEndLocation(e28)), e28;
          }
          tsInAmbientContext(e28) {
            let s3 = this.state.isAmbientContext;
            this.state.isAmbientContext = true;
            try {
              return e28();
            } finally {
              this.state.isAmbientContext = s3;
            }
          }
          parseClass(e28, s3, r3) {
            let i = this.state.inAbstractClass;
            this.state.inAbstractClass = !!e28.abstract;
            try {
              return super.parseClass(e28, s3, r3);
            } finally {
              this.state.inAbstractClass = i;
            }
          }
          tsParseAbstractDeclaration(e28, s3) {
            if (this.match(80))
              return e28.abstract = true, this.maybeTakeDecorators(s3, this.parseClass(e28, true, false));
            if (this.isContextual(127)) {
              if (!this.hasFollowingLineBreak())
                return e28.abstract = true, this.raise(j3.NonClassMethodPropertyHasAbstractModifer, { at: e28 }), this.tsParseInterfaceDeclaration(e28);
            } else
              this.unexpected(null, 80);
          }
          parseMethod(e28, s3, r3, i, a3, n3, o3) {
            let h3 = super.parseMethod(e28, s3, r3, i, a3, n3, o3);
            if (h3.abstract && (this.hasPlugin("estree") ? h3.value.body : h3.body)) {
              let { key: l3 } = h3;
              this.raise(j3.AbstractMethodHasImplementation, { at: h3, methodName: l3.type === "Identifier" && !h3.computed ? l3.name : `[${this.input.slice(l3.start, l3.end)}]` });
            }
            return h3;
          }
          tsParseTypeParameterName() {
            return this.parseIdentifier().name;
          }
          shouldParseAsAmbientContext() {
            return !!this.getPluginOption("typescript", "dts");
          }
          parse() {
            return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = true), super.parse();
          }
          getExpression() {
            return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = true), super.getExpression();
          }
          parseExportSpecifier(e28, s3, r3, i) {
            return !s3 && i ? (this.parseTypeOnlyImportExportSpecifier(e28, false, r3), this.finishNode(e28, "ExportSpecifier")) : (e28.exportKind = "value", super.parseExportSpecifier(e28, s3, r3, i));
          }
          parseImportSpecifier(e28, s3, r3, i, a3) {
            return !s3 && i ? (this.parseTypeOnlyImportExportSpecifier(e28, true, r3), this.finishNode(e28, "ImportSpecifier")) : (e28.importKind = "value", super.parseImportSpecifier(e28, s3, r3, i, r3 ? Cr2 : at2));
          }
          parseTypeOnlyImportExportSpecifier(e28, s3, r3) {
            let i = s3 ? "imported" : "local", a3 = s3 ? "local" : "exported", n3 = e28[i], o3, h3 = false, l3 = true, f3 = n3.loc.start;
            if (this.isContextual(93)) {
              let R3 = this.parseIdentifier();
              if (this.isContextual(93)) {
                let B3 = this.parseIdentifier();
                Ae2(this.state.type) ? (h3 = true, n3 = R3, o3 = s3 ? this.parseIdentifier() : this.parseModuleExportName(), l3 = false) : (o3 = B3, l3 = false);
              } else
                Ae2(this.state.type) ? (l3 = false, o3 = s3 ? this.parseIdentifier() : this.parseModuleExportName()) : (h3 = true, n3 = R3);
            } else
              Ae2(this.state.type) && (h3 = true, s3 ? (n3 = this.parseIdentifier(true), this.isContextual(93) || this.checkReservedWord(n3.name, n3.loc.start, true, true)) : n3 = this.parseModuleExportName());
            h3 && r3 && this.raise(s3 ? j3.TypeModifierIsUsedInTypeImports : j3.TypeModifierIsUsedInTypeExports, { at: f3 }), e28[i] = n3, e28[a3] = o3;
            let T3 = s3 ? "importKind" : "exportKind";
            e28[T3] = h3 ? "type" : "value", l3 && this.eatContextual(93) && (e28[a3] = s3 ? this.parseIdentifier() : this.parseModuleExportName()), e28[a3] || (e28[a3] = Fe2(e28[i])), s3 && this.checkIdentifier(e28[a3], h3 ? Cr2 : at2);
          }
        };
        function to2(t3) {
          if (t3.type !== "MemberExpression")
            return false;
          let { computed: e28, property: s3 } = t3;
          return e28 && s3.type !== "StringLiteral" && (s3.type !== "TemplateLiteral" || s3.expressions.length > 0) ? false : $r2(t3.object);
        }
        function so2(t3, e28) {
          var s3;
          let { type: r3 } = t3;
          if ((s3 = t3.extra) != null && s3.parenthesized)
            return false;
          if (e28) {
            if (r3 === "Literal") {
              let { value: i } = t3;
              if (typeof i == "string" || typeof i == "boolean")
                return true;
            }
          } else if (r3 === "StringLiteral" || r3 === "BooleanLiteral")
            return true;
          return !!(Hr2(t3, e28) || ro2(t3, e28) || r3 === "TemplateLiteral" && t3.expressions.length === 0 || to2(t3));
        }
        function Hr2(t3, e28) {
          return e28 ? t3.type === "Literal" && (typeof t3.value == "number" || "bigint" in t3) : t3.type === "NumericLiteral" || t3.type === "BigIntLiteral";
        }
        function ro2(t3, e28) {
          if (t3.type === "UnaryExpression") {
            let { operator: s3, argument: r3 } = t3;
            if (s3 === "-" && Hr2(r3, e28))
              return true;
          }
          return false;
        }
        function $r2(t3) {
          return t3.type === "Identifier" ? true : t3.type !== "MemberExpression" || t3.computed ? false : $r2(t3.object);
        }
        var Vr2 = Ne2`placeholders`({ ClassNameIsRequired: "A class name is required.", UnexpectedSpace: "Unexpected space in placeholder." }), io2 = (t3) => class extends t3 {
          parsePlaceholder(e28) {
            if (this.match(142)) {
              let s3 = this.startNode();
              return this.next(), this.assertNoSpace(), s3.name = super.parseIdentifier(true), this.assertNoSpace(), this.expect(142), this.finishPlaceholder(s3, e28);
            }
          }
          finishPlaceholder(e28, s3) {
            let r3 = !!(e28.expectedNode && e28.type === "Placeholder");
            return e28.expectedNode = s3, r3 ? e28 : this.finishNode(e28, "Placeholder");
          }
          getTokenFromCode(e28) {
            e28 === 37 && this.input.charCodeAt(this.state.pos + 1) === 37 ? this.finishOp(142, 2) : super.getTokenFromCode(e28);
          }
          parseExprAtom(e28) {
            return this.parsePlaceholder("Expression") || super.parseExprAtom(e28);
          }
          parseIdentifier(e28) {
            return this.parsePlaceholder("Identifier") || super.parseIdentifier(e28);
          }
          checkReservedWord(e28, s3, r3, i) {
            e28 !== void 0 && super.checkReservedWord(e28, s3, r3, i);
          }
          parseBindingAtom() {
            return this.parsePlaceholder("Pattern") || super.parseBindingAtom();
          }
          isValidLVal(e28, s3, r3) {
            return e28 === "Placeholder" || super.isValidLVal(e28, s3, r3);
          }
          toAssignable(e28, s3) {
            e28 && e28.type === "Placeholder" && e28.expectedNode === "Expression" ? e28.expectedNode = "Pattern" : super.toAssignable(e28, s3);
          }
          chStartsBindingIdentifier(e28, s3) {
            return !!(super.chStartsBindingIdentifier(e28, s3) || this.lookahead().type === 142);
          }
          verifyBreakContinue(e28, s3) {
            e28.label && e28.label.type === "Placeholder" || super.verifyBreakContinue(e28, s3);
          }
          parseExpressionStatement(e28, s3) {
            if (s3.type !== "Placeholder" || s3.extra && s3.extra.parenthesized)
              return super.parseExpressionStatement(e28, s3);
            if (this.match(14)) {
              let r3 = e28;
              return r3.label = this.finishPlaceholder(s3, "Identifier"), this.next(), r3.body = super.parseStatementOrSloppyAnnexBFunctionDeclaration(), this.finishNode(r3, "LabeledStatement");
            }
            return this.semicolon(), e28.name = s3.name, this.finishPlaceholder(e28, "Statement");
          }
          parseBlock(e28, s3, r3) {
            return this.parsePlaceholder("BlockStatement") || super.parseBlock(e28, s3, r3);
          }
          parseFunctionId(e28) {
            return this.parsePlaceholder("Identifier") || super.parseFunctionId(e28);
          }
          parseClass(e28, s3, r3) {
            let i = s3 ? "ClassDeclaration" : "ClassExpression";
            this.next();
            let a3 = this.state.strict, n3 = this.parsePlaceholder("Identifier");
            if (n3)
              if (this.match(81) || this.match(142) || this.match(5))
                e28.id = n3;
              else {
                if (r3 || !s3)
                  return e28.id = null, e28.body = this.finishPlaceholder(n3, "ClassBody"), this.finishNode(e28, i);
                throw this.raise(Vr2.ClassNameIsRequired, { at: this.state.startLoc });
              }
            else
              this.parseClassId(e28, s3, r3);
            return super.parseClassSuper(e28), e28.body = this.parsePlaceholder("ClassBody") || super.parseClassBody(!!e28.superClass, a3), this.finishNode(e28, i);
          }
          parseExport(e28, s3) {
            let r3 = this.parsePlaceholder("Identifier");
            if (!r3)
              return super.parseExport(e28, s3);
            if (!this.isContextual(97) && !this.match(12))
              return e28.specifiers = [], e28.source = null, e28.declaration = this.finishPlaceholder(r3, "Declaration"), this.finishNode(e28, "ExportNamedDeclaration");
            this.expectPlugin("exportDefaultFrom");
            let i = this.startNode();
            return i.exported = r3, e28.specifiers = [this.finishNode(i, "ExportDefaultSpecifier")], super.parseExport(e28, s3);
          }
          isExportDefaultSpecifier() {
            if (this.match(65)) {
              let e28 = this.nextTokenStart();
              if (this.isUnparsedContextual(e28, "from") && this.input.startsWith(Be2(142), this.nextTokenStartSince(e28 + 4)))
                return true;
            }
            return super.isExportDefaultSpecifier();
          }
          maybeParseExportDefaultSpecifier(e28) {
            return e28.specifiers && e28.specifiers.length > 0 ? true : super.maybeParseExportDefaultSpecifier(e28);
          }
          checkExport(e28) {
            let { specifiers: s3 } = e28;
            s3 != null && s3.length && (e28.specifiers = s3.filter((r3) => r3.exported.type === "Placeholder")), super.checkExport(e28), e28.specifiers = s3;
          }
          parseImport(e28) {
            let s3 = this.parsePlaceholder("Identifier");
            if (!s3)
              return super.parseImport(e28);
            if (e28.specifiers = [], !this.isContextual(97) && !this.match(12))
              return e28.source = this.finishPlaceholder(s3, "StringLiteral"), this.semicolon(), this.finishNode(e28, "ImportDeclaration");
            let r3 = this.startNodeAtNode(s3);
            return r3.local = s3, e28.specifiers.push(this.finishNode(r3, "ImportDefaultSpecifier")), this.eat(12) && (this.maybeParseStarImportSpecifier(e28) || this.parseNamedImportSpecifiers(e28)), this.expectContextual(97), e28.source = this.parseImportSource(), this.semicolon(), this.finishNode(e28, "ImportDeclaration");
          }
          parseImportSource() {
            return this.parsePlaceholder("StringLiteral") || super.parseImportSource();
          }
          assertNoSpace() {
            this.state.start > this.state.lastTokEndLoc.index && this.raise(Vr2.UnexpectedSpace, { at: this.state.lastTokEndLoc });
          }
        }, ao2 = (t3) => class extends t3 {
          parseV8Intrinsic() {
            if (this.match(54)) {
              let e28 = this.state.startLoc, s3 = this.startNode();
              if (this.next(), te2(this.state.type)) {
                let r3 = this.parseIdentifierName(), i = this.createIdentifier(s3, r3);
                if (i.type = "V8IntrinsicIdentifier", this.match(10))
                  return i;
              }
              this.unexpected(e28);
            }
          }
          parseExprAtom(e28) {
            return this.parseV8Intrinsic() || super.parseExprAtom(e28);
          }
        };
        function me2(t3, e28) {
          let [s3, r3] = typeof e28 == "string" ? [e28, {}] : e28, i = Object.keys(r3), a3 = i.length === 0;
          return t3.some((n3) => {
            if (typeof n3 == "string")
              return a3 && n3 === s3;
            {
              let [o3, h3] = n3;
              if (o3 !== s3)
                return false;
              for (let l3 of i)
                if (h3[l3] !== r3[l3])
                  return false;
              return true;
            }
          });
        }
        function Ve2(t3, e28, s3) {
          let r3 = t3.find((i) => Array.isArray(i) ? i[0] === e28 : i === e28);
          return r3 && Array.isArray(r3) && r3.length > 1 ? r3[1][s3] : null;
        }
        var qr2 = ["minimal", "fsharp", "hack", "smart"], Kr2 = ["^^", "@@", "^", "%", "#"], Wr2 = ["hash", "bar"];
        function no2(t3) {
          if (me2(t3, "decorators")) {
            if (me2(t3, "decorators-legacy"))
              throw new Error("Cannot use the decorators and decorators-legacy plugin together");
            let e28 = Ve2(t3, "decorators", "decoratorsBeforeExport");
            if (e28 != null && typeof e28 != "boolean")
              throw new Error("'decoratorsBeforeExport' must be a boolean, if specified.");
            let s3 = Ve2(t3, "decorators", "allowCallParenthesized");
            if (s3 != null && typeof s3 != "boolean")
              throw new Error("'allowCallParenthesized' must be a boolean.");
          }
          if (me2(t3, "flow") && me2(t3, "typescript"))
            throw new Error("Cannot combine flow and typescript plugins.");
          if (me2(t3, "placeholders") && me2(t3, "v8intrinsic"))
            throw new Error("Cannot combine placeholders and v8intrinsic plugins.");
          if (me2(t3, "pipelineOperator")) {
            let e28 = Ve2(t3, "pipelineOperator", "proposal");
            if (!qr2.includes(e28)) {
              let r3 = qr2.map((i) => `"${i}"`).join(", ");
              throw new Error(`"pipelineOperator" requires "proposal" option whose value must be one of: ${r3}.`);
            }
            let s3 = me2(t3, ["recordAndTuple", { syntaxType: "hash" }]);
            if (e28 === "hack") {
              if (me2(t3, "placeholders"))
                throw new Error("Cannot combine placeholders plugin and Hack-style pipes.");
              if (me2(t3, "v8intrinsic"))
                throw new Error("Cannot combine v8intrinsic plugin and Hack-style pipes.");
              let r3 = Ve2(t3, "pipelineOperator", "topicToken");
              if (!Kr2.includes(r3)) {
                let i = Kr2.map((a3) => `"${a3}"`).join(", ");
                throw new Error(`"pipelineOperator" in "proposal": "hack" mode also requires a "topicToken" option whose value must be one of: ${i}.`);
              }
              if (r3 === "#" && s3)
                throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "hack", topicToken: "#" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
            } else if (e28 === "smart" && s3)
              throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "smart" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
          }
          if (me2(t3, "moduleAttributes")) {
            if (me2(t3, "importAssertions"))
              throw new Error("Cannot combine importAssertions and moduleAttributes plugins.");
            if (Ve2(t3, "moduleAttributes", "version") !== "may-2020")
              throw new Error("The 'moduleAttributes' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is 'may-2020'.");
          }
          if (me2(t3, "recordAndTuple") && Ve2(t3, "recordAndTuple", "syntaxType") != null && !Wr2.includes(Ve2(t3, "recordAndTuple", "syntaxType")))
            throw new Error("The 'syntaxType' option of the 'recordAndTuple' plugin must be one of: " + Wr2.map((e28) => `'${e28}'`).join(", "));
          if (me2(t3, "asyncDoExpressions") && !me2(t3, "doExpressions")) {
            let e28 = new Error("'asyncDoExpressions' requires 'doExpressions', please add 'doExpressions' to parser plugins.");
            throw e28.missingPlugins = "doExpressions", e28;
          }
        }
        var Jr2 = { estree: $a2, jsx: qn2, flow: $n2, typescript: eo2, v8intrinsic: ao2, placeholders: io2 }, oo2 = Object.keys(Jr2), ho2 = class extends Xn2 {
          checkProto(t3, e28, s3, r3) {
            if (t3.type === "SpreadElement" || this.isObjectMethod(t3) || t3.computed || t3.shorthand)
              return;
            let i = t3.key;
            if ((i.type === "Identifier" ? i.name : i.value) === "__proto__") {
              if (e28) {
                this.raise(p3.RecordNoProto, { at: i });
                return;
              }
              s3.used && (r3 ? r3.doubleProtoLoc === null && (r3.doubleProtoLoc = i.loc.start) : this.raise(p3.DuplicateProto, { at: i })), s3.used = true;
            }
          }
          shouldExitDescending(t3, e28) {
            return t3.type === "ArrowFunctionExpression" && t3.start === e28;
          }
          getExpression() {
            this.enterInitialScopes(), this.nextToken();
            let t3 = this.parseExpression();
            return this.match(137) || this.unexpected(), this.finalizeRemainingComments(), t3.comments = this.state.comments, t3.errors = this.state.errors, this.options.tokens && (t3.tokens = this.tokens), t3;
          }
          parseExpression(t3, e28) {
            return t3 ? this.disallowInAnd(() => this.parseExpressionBase(e28)) : this.allowInAnd(() => this.parseExpressionBase(e28));
          }
          parseExpressionBase(t3) {
            let e28 = this.state.startLoc, s3 = this.parseMaybeAssign(t3);
            if (this.match(12)) {
              let r3 = this.startNodeAt(e28);
              for (r3.expressions = [s3]; this.eat(12); )
                r3.expressions.push(this.parseMaybeAssign(t3));
              return this.toReferencedList(r3.expressions), this.finishNode(r3, "SequenceExpression");
            }
            return s3;
          }
          parseMaybeAssignDisallowIn(t3, e28) {
            return this.disallowInAnd(() => this.parseMaybeAssign(t3, e28));
          }
          parseMaybeAssignAllowIn(t3, e28) {
            return this.allowInAnd(() => this.parseMaybeAssign(t3, e28));
          }
          setOptionalParametersError(t3, e28) {
            var s3;
            t3.optionalParametersLoc = (s3 = e28 == null ? void 0 : e28.loc) != null ? s3 : this.state.startLoc;
          }
          parseMaybeAssign(t3, e28) {
            let s3 = this.state.startLoc;
            if (this.isContextual(106) && this.prodParam.hasYield) {
              let n3 = this.parseYield();
              return e28 && (n3 = e28.call(this, n3, s3)), n3;
            }
            let r3;
            t3 ? r3 = false : (t3 = new Mt2(), r3 = true);
            let { type: i } = this.state;
            (i === 10 || te2(i)) && (this.state.potentialArrowAt = this.state.start);
            let a3 = this.parseMaybeConditional(t3);
            if (e28 && (a3 = e28.call(this, a3, s3)), Ca2(this.state.type)) {
              let n3 = this.startNodeAt(s3), o3 = this.state.value;
              if (n3.operator = o3, this.match(29)) {
                this.toAssignable(a3, true), n3.left = a3;
                let h3 = s3.index;
                t3.doubleProtoLoc != null && t3.doubleProtoLoc.index >= h3 && (t3.doubleProtoLoc = null), t3.shorthandAssignLoc != null && t3.shorthandAssignLoc.index >= h3 && (t3.shorthandAssignLoc = null), t3.privateKeyLoc != null && t3.privateKeyLoc.index >= h3 && (this.checkDestructuringPrivate(t3), t3.privateKeyLoc = null);
              } else
                n3.left = a3;
              return this.next(), n3.right = this.parseMaybeAssign(), this.checkLVal(a3, { in: this.finishNode(n3, "AssignmentExpression") }), n3;
            } else
              r3 && this.checkExpressionErrors(t3, true);
            return a3;
          }
          parseMaybeConditional(t3) {
            let e28 = this.state.startLoc, s3 = this.state.potentialArrowAt, r3 = this.parseExprOps(t3);
            return this.shouldExitDescending(r3, s3) ? r3 : this.parseConditional(r3, e28, t3);
          }
          parseConditional(t3, e28, s3) {
            if (this.eat(17)) {
              let r3 = this.startNodeAt(e28);
              return r3.test = t3, r3.consequent = this.parseMaybeAssignAllowIn(), this.expect(14), r3.alternate = this.parseMaybeAssign(), this.finishNode(r3, "ConditionalExpression");
            }
            return t3;
          }
          parseMaybeUnaryOrPrivate(t3) {
            return this.match(136) ? this.parsePrivateName() : this.parseMaybeUnary(t3);
          }
          parseExprOps(t3) {
            let e28 = this.state.startLoc, s3 = this.state.potentialArrowAt, r3 = this.parseMaybeUnaryOrPrivate(t3);
            return this.shouldExitDescending(r3, s3) ? r3 : this.parseExprOp(r3, e28, -1);
          }
          parseExprOp(t3, e28, s3) {
            if (this.isPrivateName(t3)) {
              let i = this.getPrivateNameSV(t3);
              (s3 >= gt2(58) || !this.prodParam.hasIn || !this.match(58)) && this.raise(p3.PrivateInExpectedIn, { at: t3, identifierName: i }), this.classScope.usePrivateName(i, t3.loc.start);
            }
            let r3 = this.state.type;
            if (Sa2(r3) && (this.prodParam.hasIn || !this.match(58))) {
              let i = gt2(r3);
              if (i > s3) {
                if (r3 === 39) {
                  if (this.expectPlugin("pipelineOperator"), this.state.inFSharpPipelineDirectBody)
                    return t3;
                  this.checkPipelineAtInfixOperator(t3, e28);
                }
                let a3 = this.startNodeAt(e28);
                a3.left = t3, a3.operator = this.state.value;
                let n3 = r3 === 41 || r3 === 42, o3 = r3 === 40;
                if (o3 && (i = gt2(42)), this.next(), r3 === 39 && this.hasPlugin(["pipelineOperator", { proposal: "minimal" }]) && this.state.type === 96 && this.prodParam.hasAwait)
                  throw this.raise(p3.UnexpectedAwaitAfterPipelineBody, { at: this.state.startLoc });
                a3.right = this.parseExprOpRightExpr(r3, i);
                let h3 = this.finishNode(a3, n3 || o3 ? "LogicalExpression" : "BinaryExpression"), l3 = this.state.type;
                if (o3 && (l3 === 41 || l3 === 42) || n3 && l3 === 40)
                  throw this.raise(p3.MixingCoalesceWithLogical, { at: this.state.startLoc });
                return this.parseExprOp(h3, e28, s3);
              }
            }
            return t3;
          }
          parseExprOpRightExpr(t3, e28) {
            let s3 = this.state.startLoc;
            switch (t3) {
              case 39:
                switch (this.getPluginOption("pipelineOperator", "proposal")) {
                  case "hack":
                    return this.withTopicBindingContext(() => this.parseHackPipeBody());
                  case "smart":
                    return this.withTopicBindingContext(() => {
                      if (this.prodParam.hasYield && this.isContextual(106))
                        throw this.raise(p3.PipeBodyIsTighter, { at: this.state.startLoc });
                      return this.parseSmartPipelineBodyInStyle(this.parseExprOpBaseRightExpr(t3, e28), s3);
                    });
                  case "fsharp":
                    return this.withSoloAwaitPermittingContext(() => this.parseFSharpPipelineBody(e28));
                }
              default:
                return this.parseExprOpBaseRightExpr(t3, e28);
            }
          }
          parseExprOpBaseRightExpr(t3, e28) {
            let s3 = this.state.startLoc;
            return this.parseExprOp(this.parseMaybeUnaryOrPrivate(), s3, Da2(t3) ? e28 - 1 : e28);
          }
          parseHackPipeBody() {
            var t3;
            let { startLoc: e28 } = this.state, s3 = this.parseMaybeAssign();
            return ja2.has(s3.type) && !((t3 = s3.extra) != null && t3.parenthesized) && this.raise(p3.PipeUnparenthesizedBody, { at: e28, type: s3.type }), this.topicReferenceWasUsedInCurrentContext() || this.raise(p3.PipeTopicUnused, { at: e28 }), s3;
          }
          checkExponentialAfterUnary(t3) {
            this.match(57) && this.raise(p3.UnexpectedTokenUnaryExponentiation, { at: t3.argument });
          }
          parseMaybeUnary(t3, e28) {
            let s3 = this.state.startLoc, r3 = this.isContextual(96);
            if (r3 && this.isAwaitAllowed()) {
              this.next();
              let o3 = this.parseAwait(s3);
              return e28 || this.checkExponentialAfterUnary(o3), o3;
            }
            let i = this.match(34), a3 = this.startNode();
            if (Ia2(this.state.type)) {
              a3.operator = this.state.value, a3.prefix = true, this.match(72) && this.expectPlugin("throwExpressions");
              let o3 = this.match(89);
              if (this.next(), a3.argument = this.parseMaybeUnary(null, true), this.checkExpressionErrors(t3, true), this.state.strict && o3) {
                let h3 = a3.argument;
                h3.type === "Identifier" ? this.raise(p3.StrictDelete, { at: a3 }) : this.hasPropertyAsPrivateName(h3) && this.raise(p3.DeletePrivateField, { at: a3 });
              }
              if (!i)
                return e28 || this.checkExponentialAfterUnary(a3), this.finishNode(a3, "UnaryExpression");
            }
            let n3 = this.parseUpdate(a3, i, t3);
            if (r3) {
              let { type: o3 } = this.state;
              if ((this.hasPlugin("v8intrinsic") ? rt2(o3) : rt2(o3) && !this.match(54)) && !this.isAmbiguousAwait())
                return this.raiseOverwrite(p3.AwaitNotInAsyncContext, { at: s3 }), this.parseAwait(s3);
            }
            return n3;
          }
          parseUpdate(t3, e28, s3) {
            if (e28) {
              let a3 = t3;
              return this.checkLVal(a3.argument, { in: this.finishNode(a3, "UpdateExpression") }), t3;
            }
            let r3 = this.state.startLoc, i = this.parseExprSubscripts(s3);
            if (this.checkExpressionErrors(s3, false))
              return i;
            for (; wa2(this.state.type) && !this.canInsertSemicolon(); ) {
              let a3 = this.startNodeAt(r3);
              a3.operator = this.state.value, a3.prefix = false, a3.argument = i, this.next(), this.checkLVal(i, { in: i = this.finishNode(a3, "UpdateExpression") });
            }
            return i;
          }
          parseExprSubscripts(t3) {
            let e28 = this.state.startLoc, s3 = this.state.potentialArrowAt, r3 = this.parseExprAtom(t3);
            return this.shouldExitDescending(r3, s3) ? r3 : this.parseSubscripts(r3, e28);
          }
          parseSubscripts(t3, e28, s3) {
            let r3 = { optionalChainMember: false, maybeAsyncArrow: this.atPossibleAsyncArrow(t3), stop: false };
            do
              t3 = this.parseSubscript(t3, e28, s3, r3), r3.maybeAsyncArrow = false;
            while (!r3.stop);
            return t3;
          }
          parseSubscript(t3, e28, s3, r3) {
            let { type: i } = this.state;
            if (!s3 && i === 15)
              return this.parseBind(t3, e28, s3, r3);
            if (Pt2(i))
              return this.parseTaggedTemplateExpression(t3, e28, r3);
            let a3 = false;
            if (i === 18) {
              if (s3 && (this.raise(p3.OptionalChainingNoNew, { at: this.state.startLoc }), this.lookaheadCharCode() === 40))
                return r3.stop = true, t3;
              r3.optionalChainMember = a3 = true, this.next();
            }
            if (!s3 && this.match(10))
              return this.parseCoverCallAndAsyncArrowHead(t3, e28, r3, a3);
            {
              let n3 = this.eat(0);
              return n3 || a3 || this.eat(16) ? this.parseMember(t3, e28, r3, n3, a3) : (r3.stop = true, t3);
            }
          }
          parseMember(t3, e28, s3, r3, i) {
            let a3 = this.startNodeAt(e28);
            return a3.object = t3, a3.computed = r3, r3 ? (a3.property = this.parseExpression(), this.expect(3)) : this.match(136) ? (t3.type === "Super" && this.raise(p3.SuperPrivateField, { at: e28 }), this.classScope.usePrivateName(this.state.value, this.state.startLoc), a3.property = this.parsePrivateName()) : a3.property = this.parseIdentifier(true), s3.optionalChainMember ? (a3.optional = i, this.finishNode(a3, "OptionalMemberExpression")) : this.finishNode(a3, "MemberExpression");
          }
          parseBind(t3, e28, s3, r3) {
            let i = this.startNodeAt(e28);
            return i.object = t3, this.next(), i.callee = this.parseNoCallExpr(), r3.stop = true, this.parseSubscripts(this.finishNode(i, "BindExpression"), e28, s3);
          }
          parseCoverCallAndAsyncArrowHead(t3, e28, s3, r3) {
            let i = this.state.maybeInArrowParameters, a3 = null;
            this.state.maybeInArrowParameters = true, this.next();
            let n3 = this.startNodeAt(e28);
            n3.callee = t3;
            let { maybeAsyncArrow: o3, optionalChainMember: h3 } = s3;
            o3 && (this.expressionScope.enter(Fn2()), a3 = new Mt2()), h3 && (n3.optional = r3), r3 ? n3.arguments = this.parseCallExpressionArguments(11) : n3.arguments = this.parseCallExpressionArguments(11, t3.type === "Import", t3.type !== "Super", n3, a3);
            let l3 = this.finishCallExpression(n3, h3);
            return o3 && this.shouldParseAsyncArrow() && !r3 ? (s3.stop = true, this.checkDestructuringPrivate(a3), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), l3 = this.parseAsyncArrowFromCallExpression(this.startNodeAt(e28), l3)) : (o3 && (this.checkExpressionErrors(a3, true), this.expressionScope.exit()), this.toReferencedArguments(l3)), this.state.maybeInArrowParameters = i, l3;
          }
          toReferencedArguments(t3, e28) {
            this.toReferencedListDeep(t3.arguments, e28);
          }
          parseTaggedTemplateExpression(t3, e28, s3) {
            let r3 = this.startNodeAt(e28);
            return r3.tag = t3, r3.quasi = this.parseTemplate(true), s3.optionalChainMember && this.raise(p3.OptionalChainingNoTemplate, { at: e28 }), this.finishNode(r3, "TaggedTemplateExpression");
          }
          atPossibleAsyncArrow(t3) {
            return t3.type === "Identifier" && t3.name === "async" && this.state.lastTokEndLoc.index === t3.end && !this.canInsertSemicolon() && t3.end - t3.start === 5 && t3.start === this.state.potentialArrowAt;
          }
          finishCallExpression(t3, e28) {
            if (t3.callee.type === "Import")
              if (t3.arguments.length === 2 && (this.hasPlugin("moduleAttributes") || this.expectPlugin("importAssertions")), t3.arguments.length === 0 || t3.arguments.length > 2)
                this.raise(p3.ImportCallArity, { at: t3, maxArgumentCount: this.hasPlugin("importAssertions") || this.hasPlugin("moduleAttributes") ? 2 : 1 });
              else
                for (let s3 of t3.arguments)
                  s3.type === "SpreadElement" && this.raise(p3.ImportCallSpreadArgument, { at: s3 });
            return this.finishNode(t3, e28 ? "OptionalCallExpression" : "CallExpression");
          }
          parseCallExpressionArguments(t3, e28, s3, r3, i) {
            let a3 = [], n3 = true, o3 = this.state.inFSharpPipelineDirectBody;
            for (this.state.inFSharpPipelineDirectBody = false; !this.eat(t3); ) {
              if (n3)
                n3 = false;
              else if (this.expect(12), this.match(t3)) {
                e28 && !this.hasPlugin("importAssertions") && !this.hasPlugin("moduleAttributes") && this.raise(p3.ImportCallArgumentTrailingComma, { at: this.state.lastTokStartLoc }), r3 && this.addTrailingCommaExtraToNode(r3), this.next();
                break;
              }
              a3.push(this.parseExprListItem(false, i, s3));
            }
            return this.state.inFSharpPipelineDirectBody = o3, a3;
          }
          shouldParseAsyncArrow() {
            return this.match(19) && !this.canInsertSemicolon();
          }
          parseAsyncArrowFromCallExpression(t3, e28) {
            var s3;
            return this.resetPreviousNodeTrailingComments(e28), this.expect(19), this.parseArrowExpression(t3, e28.arguments, true, (s3 = e28.extra) == null ? void 0 : s3.trailingCommaLoc), e28.innerComments && nt2(t3, e28.innerComments), e28.callee.trailingComments && nt2(t3, e28.callee.trailingComments), t3;
          }
          parseNoCallExpr() {
            let t3 = this.state.startLoc;
            return this.parseSubscripts(this.parseExprAtom(), t3, true);
          }
          parseExprAtom(t3) {
            let e28, s3 = null, { type: r3 } = this.state;
            switch (r3) {
              case 79:
                return this.parseSuper();
              case 83:
                return e28 = this.startNode(), this.next(), this.match(16) ? this.parseImportMetaProperty(e28) : (this.match(10) || this.raise(p3.UnsupportedImport, { at: this.state.lastTokStartLoc }), this.finishNode(e28, "Import"));
              case 78:
                return e28 = this.startNode(), this.next(), this.finishNode(e28, "ThisExpression");
              case 90:
                return this.parseDo(this.startNode(), false);
              case 56:
              case 31:
                return this.readRegexp(), this.parseRegExpLiteral(this.state.value);
              case 132:
                return this.parseNumericLiteral(this.state.value);
              case 133:
                return this.parseBigIntLiteral(this.state.value);
              case 134:
                return this.parseDecimalLiteral(this.state.value);
              case 131:
                return this.parseStringLiteral(this.state.value);
              case 84:
                return this.parseNullLiteral();
              case 85:
                return this.parseBooleanLiteral(true);
              case 86:
                return this.parseBooleanLiteral(false);
              case 10: {
                let i = this.state.potentialArrowAt === this.state.start;
                return this.parseParenAndDistinguishExpression(i);
              }
              case 2:
              case 1:
                return this.parseArrayLike(this.state.type === 2 ? 4 : 3, false, true);
              case 0:
                return this.parseArrayLike(3, true, false, t3);
              case 6:
              case 7:
                return this.parseObjectLike(this.state.type === 6 ? 9 : 8, false, true);
              case 5:
                return this.parseObjectLike(8, false, false, t3);
              case 68:
                return this.parseFunctionOrFunctionSent();
              case 26:
                s3 = this.parseDecorators();
              case 80:
                return this.parseClass(this.maybeTakeDecorators(s3, this.startNode()), false);
              case 77:
                return this.parseNewOrNewTarget();
              case 25:
              case 24:
                return this.parseTemplate(false);
              case 15: {
                e28 = this.startNode(), this.next(), e28.object = null;
                let i = e28.callee = this.parseNoCallExpr();
                if (i.type === "MemberExpression")
                  return this.finishNode(e28, "BindExpression");
                throw this.raise(p3.UnsupportedBind, { at: i });
              }
              case 136:
                return this.raise(p3.PrivateInExpectedIn, { at: this.state.startLoc, identifierName: this.state.value }), this.parsePrivateName();
              case 33:
                return this.parseTopicReferenceThenEqualsSign(54, "%");
              case 32:
                return this.parseTopicReferenceThenEqualsSign(44, "^");
              case 37:
              case 38:
                return this.parseTopicReference("hack");
              case 44:
              case 54:
              case 27: {
                let i = this.getPluginOption("pipelineOperator", "proposal");
                if (i)
                  return this.parseTopicReference(i);
                this.unexpected();
                break;
              }
              case 47: {
                let i = this.input.codePointAt(this.nextTokenStart());
                ke2(i) || i === 62 ? this.expectOnePlugin(["jsx", "flow", "typescript"]) : this.unexpected();
                break;
              }
              default:
                if (te2(r3)) {
                  if (this.isContextual(125) && this.lookaheadCharCode() === 123 && !this.hasFollowingLineBreak())
                    return this.parseModuleExpression();
                  let i = this.state.potentialArrowAt === this.state.start, a3 = this.state.containsEsc, n3 = this.parseIdentifier();
                  if (!a3 && n3.name === "async" && !this.canInsertSemicolon()) {
                    let { type: o3 } = this.state;
                    if (o3 === 68)
                      return this.resetPreviousNodeTrailingComments(n3), this.next(), this.parseAsyncFunctionExpression(this.startNodeAtNode(n3));
                    if (te2(o3))
                      return this.lookaheadCharCode() === 61 ? this.parseAsyncArrowUnaryFunction(this.startNodeAtNode(n3)) : n3;
                    if (o3 === 90)
                      return this.resetPreviousNodeTrailingComments(n3), this.parseDo(this.startNodeAtNode(n3), true);
                  }
                  return i && this.match(19) && !this.canInsertSemicolon() ? (this.next(), this.parseArrowExpression(this.startNodeAtNode(n3), [n3], false)) : n3;
                } else
                  this.unexpected();
            }
          }
          parseTopicReferenceThenEqualsSign(t3, e28) {
            let s3 = this.getPluginOption("pipelineOperator", "proposal");
            if (s3)
              return this.state.type = t3, this.state.value = e28, this.state.pos--, this.state.end--, this.state.endLoc = fe2(this.state.endLoc, -1), this.parseTopicReference(s3);
            this.unexpected();
          }
          parseTopicReference(t3) {
            let e28 = this.startNode(), s3 = this.state.startLoc, r3 = this.state.type;
            return this.next(), this.finishTopicReference(e28, s3, t3, r3);
          }
          finishTopicReference(t3, e28, s3, r3) {
            if (this.testTopicReferenceConfiguration(s3, e28, r3)) {
              let i = s3 === "smart" ? "PipelinePrimaryTopicReference" : "TopicReference";
              return this.topicReferenceIsAllowedInCurrentContext() || this.raise(s3 === "smart" ? p3.PrimaryTopicNotAllowed : p3.PipeTopicUnbound, { at: e28 }), this.registerTopicReference(), this.finishNode(t3, i);
            } else
              throw this.raise(p3.PipeTopicUnconfiguredToken, { at: e28, token: Be2(r3) });
          }
          testTopicReferenceConfiguration(t3, e28, s3) {
            switch (t3) {
              case "hack":
                return this.hasPlugin(["pipelineOperator", { topicToken: Be2(s3) }]);
              case "smart":
                return s3 === 27;
              default:
                throw this.raise(p3.PipeTopicRequiresHackPipes, { at: e28 });
            }
          }
          parseAsyncArrowUnaryFunction(t3) {
            this.prodParam.enter(Bt2(true, this.prodParam.hasYield));
            let e28 = [this.parseIdentifier()];
            return this.prodParam.exit(), this.hasPrecedingLineBreak() && this.raise(p3.LineTerminatorBeforeArrow, { at: this.state.curPosition() }), this.expect(19), this.parseArrowExpression(t3, e28, true);
          }
          parseDo(t3, e28) {
            this.expectPlugin("doExpressions"), e28 && this.expectPlugin("asyncDoExpressions"), t3.async = e28, this.next();
            let s3 = this.state.labels;
            return this.state.labels = [], e28 ? (this.prodParam.enter(Lt2), t3.body = this.parseBlock(), this.prodParam.exit()) : t3.body = this.parseBlock(), this.state.labels = s3, this.finishNode(t3, "DoExpression");
          }
          parseSuper() {
            let t3 = this.startNode();
            return this.next(), this.match(10) && !this.scope.allowDirectSuper && !this.options.allowSuperOutsideMethod ? this.raise(p3.SuperNotAllowed, { at: t3 }) : !this.scope.allowSuper && !this.options.allowSuperOutsideMethod && this.raise(p3.UnexpectedSuper, { at: t3 }), !this.match(10) && !this.match(0) && !this.match(16) && this.raise(p3.UnsupportedSuper, { at: t3 }), this.finishNode(t3, "Super");
          }
          parsePrivateName() {
            let t3 = this.startNode(), e28 = this.startNodeAt(fe2(this.state.startLoc, 1)), s3 = this.state.value;
            return this.next(), t3.id = this.createIdentifier(e28, s3), this.finishNode(t3, "PrivateName");
          }
          parseFunctionOrFunctionSent() {
            let t3 = this.startNode();
            if (this.next(), this.prodParam.hasYield && this.match(16)) {
              let e28 = this.createIdentifier(this.startNodeAtNode(t3), "function");
              return this.next(), this.match(102) ? this.expectPlugin("functionSent") : this.hasPlugin("functionSent") || this.unexpected(), this.parseMetaProperty(t3, e28, "sent");
            }
            return this.parseFunction(t3);
          }
          parseMetaProperty(t3, e28, s3) {
            t3.meta = e28;
            let r3 = this.state.containsEsc;
            return t3.property = this.parseIdentifier(true), (t3.property.name !== s3 || r3) && this.raise(p3.UnsupportedMetaProperty, { at: t3.property, target: e28.name, onlyValidPropertyName: s3 }), this.finishNode(t3, "MetaProperty");
          }
          parseImportMetaProperty(t3) {
            let e28 = this.createIdentifier(this.startNodeAtNode(t3), "import");
            return this.next(), this.isContextual(100) && (this.inModule || this.raise(p3.ImportMetaOutsideModule, { at: e28 }), this.sawUnambiguousESM = true), this.parseMetaProperty(t3, e28, "meta");
          }
          parseLiteralAtNode(t3, e28, s3) {
            return this.addExtra(s3, "rawValue", t3), this.addExtra(s3, "raw", this.input.slice(s3.start, this.state.end)), s3.value = t3, this.next(), this.finishNode(s3, e28);
          }
          parseLiteral(t3, e28) {
            let s3 = this.startNode();
            return this.parseLiteralAtNode(t3, e28, s3);
          }
          parseStringLiteral(t3) {
            return this.parseLiteral(t3, "StringLiteral");
          }
          parseNumericLiteral(t3) {
            return this.parseLiteral(t3, "NumericLiteral");
          }
          parseBigIntLiteral(t3) {
            return this.parseLiteral(t3, "BigIntLiteral");
          }
          parseDecimalLiteral(t3) {
            return this.parseLiteral(t3, "DecimalLiteral");
          }
          parseRegExpLiteral(t3) {
            let e28 = this.parseLiteral(t3.value, "RegExpLiteral");
            return e28.pattern = t3.pattern, e28.flags = t3.flags, e28;
          }
          parseBooleanLiteral(t3) {
            let e28 = this.startNode();
            return e28.value = t3, this.next(), this.finishNode(e28, "BooleanLiteral");
          }
          parseNullLiteral() {
            let t3 = this.startNode();
            return this.next(), this.finishNode(t3, "NullLiteral");
          }
          parseParenAndDistinguishExpression(t3) {
            let e28 = this.state.startLoc, s3;
            this.next(), this.expressionScope.enter(Dn2());
            let r3 = this.state.maybeInArrowParameters, i = this.state.inFSharpPipelineDirectBody;
            this.state.maybeInArrowParameters = true, this.state.inFSharpPipelineDirectBody = false;
            let a3 = this.state.startLoc, n3 = [], o3 = new Mt2(), h3 = true, l3, f3;
            for (; !this.match(11); ) {
              if (h3)
                h3 = false;
              else if (this.expect(12, o3.optionalParametersLoc === null ? null : o3.optionalParametersLoc), this.match(11)) {
                f3 = this.state.startLoc;
                break;
              }
              if (this.match(21)) {
                let B3 = this.state.startLoc;
                if (l3 = this.state.startLoc, n3.push(this.parseParenItem(this.parseRestBinding(), B3)), !this.checkCommaAfterRest(41))
                  break;
              } else
                n3.push(this.parseMaybeAssignAllowIn(o3, this.parseParenItem));
            }
            let T3 = this.state.lastTokEndLoc;
            this.expect(11), this.state.maybeInArrowParameters = r3, this.state.inFSharpPipelineDirectBody = i;
            let R3 = this.startNodeAt(e28);
            return t3 && this.shouldParseArrow(n3) && (R3 = this.parseArrow(R3)) ? (this.checkDestructuringPrivate(o3), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), this.parseArrowExpression(R3, n3, false), R3) : (this.expressionScope.exit(), n3.length || this.unexpected(this.state.lastTokStartLoc), f3 && this.unexpected(f3), l3 && this.unexpected(l3), this.checkExpressionErrors(o3, true), this.toReferencedListDeep(n3, true), n3.length > 1 ? (s3 = this.startNodeAt(a3), s3.expressions = n3, this.finishNode(s3, "SequenceExpression"), this.resetEndLocation(s3, T3)) : s3 = n3[0], this.wrapParenthesis(e28, s3));
          }
          wrapParenthesis(t3, e28) {
            if (!this.options.createParenthesizedExpressions)
              return this.addExtra(e28, "parenthesized", true), this.addExtra(e28, "parenStart", t3.index), this.takeSurroundingComments(e28, t3.index, this.state.lastTokEndLoc.index), e28;
            let s3 = this.startNodeAt(t3);
            return s3.expression = e28, this.finishNode(s3, "ParenthesizedExpression");
          }
          shouldParseArrow(t3) {
            return !this.canInsertSemicolon();
          }
          parseArrow(t3) {
            if (this.eat(19))
              return t3;
          }
          parseParenItem(t3, e28) {
            return t3;
          }
          parseNewOrNewTarget() {
            let t3 = this.startNode();
            if (this.next(), this.match(16)) {
              let e28 = this.createIdentifier(this.startNodeAtNode(t3), "new");
              this.next();
              let s3 = this.parseMetaProperty(t3, e28, "target");
              return !this.scope.inNonArrowFunction && !this.scope.inClass && !this.options.allowNewTargetOutsideFunction && this.raise(p3.UnexpectedNewTarget, { at: s3 }), s3;
            }
            return this.parseNew(t3);
          }
          parseNew(t3) {
            if (this.parseNewCallee(t3), this.eat(10)) {
              let e28 = this.parseExprList(11);
              this.toReferencedList(e28), t3.arguments = e28;
            } else
              t3.arguments = [];
            return this.finishNode(t3, "NewExpression");
          }
          parseNewCallee(t3) {
            t3.callee = this.parseNoCallExpr(), t3.callee.type === "Import" && this.raise(p3.ImportCallNotNewExpression, { at: t3.callee });
          }
          parseTemplateElement(t3) {
            let { start: e28, startLoc: s3, end: r3, value: i } = this.state, a3 = e28 + 1, n3 = this.startNodeAt(fe2(s3, 1));
            i === null && (t3 || this.raise(p3.InvalidEscapeSequenceTemplate, { at: fe2(this.state.firstInvalidTemplateEscapePos, 1) }));
            let o3 = this.match(24), h3 = o3 ? -1 : -2, l3 = r3 + h3;
            n3.value = { raw: this.input.slice(a3, l3).replace(/\r\n?/g, `
`), cooked: i === null ? null : i.slice(1, h3) }, n3.tail = o3, this.next();
            let f3 = this.finishNode(n3, "TemplateElement");
            return this.resetEndLocation(f3, fe2(this.state.lastTokEndLoc, h3)), f3;
          }
          parseTemplate(t3) {
            let e28 = this.startNode();
            e28.expressions = [];
            let s3 = this.parseTemplateElement(t3);
            for (e28.quasis = [s3]; !s3.tail; )
              e28.expressions.push(this.parseTemplateSubstitution()), this.readTemplateContinuation(), e28.quasis.push(s3 = this.parseTemplateElement(t3));
            return this.finishNode(e28, "TemplateLiteral");
          }
          parseTemplateSubstitution() {
            return this.parseExpression();
          }
          parseObjectLike(t3, e28, s3, r3) {
            s3 && this.expectPlugin("recordAndTuple");
            let i = this.state.inFSharpPipelineDirectBody;
            this.state.inFSharpPipelineDirectBody = false;
            let a3 = /* @__PURE__ */ Object.create(null), n3 = true, o3 = this.startNode();
            for (o3.properties = [], this.next(); !this.match(t3); ) {
              if (n3)
                n3 = false;
              else if (this.expect(12), this.match(t3)) {
                this.addTrailingCommaExtraToNode(o3);
                break;
              }
              let l3;
              e28 ? l3 = this.parseBindingProperty() : (l3 = this.parsePropertyDefinition(r3), this.checkProto(l3, s3, a3, r3)), s3 && !this.isObjectProperty(l3) && l3.type !== "SpreadElement" && this.raise(p3.InvalidRecordProperty, { at: l3 }), l3.shorthand && this.addExtra(l3, "shorthand", true), o3.properties.push(l3);
            }
            this.next(), this.state.inFSharpPipelineDirectBody = i;
            let h3 = "ObjectExpression";
            return e28 ? h3 = "ObjectPattern" : s3 && (h3 = "RecordExpression"), this.finishNode(o3, h3);
          }
          addTrailingCommaExtraToNode(t3) {
            this.addExtra(t3, "trailingComma", this.state.lastTokStart), this.addExtra(t3, "trailingCommaLoc", this.state.lastTokStartLoc, false);
          }
          maybeAsyncOrAccessorProp(t3) {
            return !t3.computed && t3.key.type === "Identifier" && (this.isLiteralPropertyName() || this.match(0) || this.match(55));
          }
          parsePropertyDefinition(t3) {
            let e28 = [];
            if (this.match(26))
              for (this.hasPlugin("decorators") && this.raise(p3.UnsupportedPropertyDecorator, { at: this.state.startLoc }); this.match(26); )
                e28.push(this.parseDecorator());
            let s3 = this.startNode(), r3 = false, i = false, a3;
            if (this.match(21))
              return e28.length && this.unexpected(), this.parseSpread();
            e28.length && (s3.decorators = e28, e28 = []), s3.method = false, t3 && (a3 = this.state.startLoc);
            let n3 = this.eat(55);
            this.parsePropertyNamePrefixOperator(s3);
            let o3 = this.state.containsEsc, h3 = this.parsePropertyName(s3, t3);
            if (!n3 && !o3 && this.maybeAsyncOrAccessorProp(s3)) {
              let l3 = h3.name;
              l3 === "async" && !this.hasPrecedingLineBreak() && (r3 = true, this.resetPreviousNodeTrailingComments(h3), n3 = this.eat(55), this.parsePropertyName(s3)), (l3 === "get" || l3 === "set") && (i = true, this.resetPreviousNodeTrailingComments(h3), s3.kind = l3, this.match(55) && (n3 = true, this.raise(p3.AccessorIsGenerator, { at: this.state.curPosition(), kind: l3 }), this.next()), this.parsePropertyName(s3));
            }
            return this.parseObjPropValue(s3, a3, n3, r3, false, i, t3);
          }
          getGetterSetterExpectedParamCount(t3) {
            return t3.kind === "get" ? 0 : 1;
          }
          getObjectOrClassMethodParams(t3) {
            return t3.params;
          }
          checkGetterSetterParams(t3) {
            var e28;
            let s3 = this.getGetterSetterExpectedParamCount(t3), r3 = this.getObjectOrClassMethodParams(t3);
            r3.length !== s3 && this.raise(t3.kind === "get" ? p3.BadGetterArity : p3.BadSetterArity, { at: t3 }), t3.kind === "set" && ((e28 = r3[r3.length - 1]) == null ? void 0 : e28.type) === "RestElement" && this.raise(p3.BadSetterRestParameter, { at: t3 });
          }
          parseObjectMethod(t3, e28, s3, r3, i) {
            if (i) {
              let a3 = this.parseMethod(t3, e28, false, false, false, "ObjectMethod");
              return this.checkGetterSetterParams(a3), a3;
            }
            if (s3 || e28 || this.match(10))
              return r3 && this.unexpected(), t3.kind = "method", t3.method = true, this.parseMethod(t3, e28, s3, false, false, "ObjectMethod");
          }
          parseObjectProperty(t3, e28, s3, r3) {
            if (t3.shorthand = false, this.eat(14))
              return t3.value = s3 ? this.parseMaybeDefault(this.state.startLoc) : this.parseMaybeAssignAllowIn(r3), this.finishNode(t3, "ObjectProperty");
            if (!t3.computed && t3.key.type === "Identifier") {
              if (this.checkReservedWord(t3.key.name, t3.key.loc.start, true, false), s3)
                t3.value = this.parseMaybeDefault(e28, Fe2(t3.key));
              else if (this.match(29)) {
                let i = this.state.startLoc;
                r3 != null ? r3.shorthandAssignLoc === null && (r3.shorthandAssignLoc = i) : this.raise(p3.InvalidCoverInitializedName, { at: i }), t3.value = this.parseMaybeDefault(e28, Fe2(t3.key));
              } else
                t3.value = Fe2(t3.key);
              return t3.shorthand = true, this.finishNode(t3, "ObjectProperty");
            }
          }
          parseObjPropValue(t3, e28, s3, r3, i, a3, n3) {
            let o3 = this.parseObjectMethod(t3, s3, r3, i, a3) || this.parseObjectProperty(t3, e28, i, n3);
            return o3 || this.unexpected(), o3;
          }
          parsePropertyName(t3, e28) {
            if (this.eat(0))
              t3.computed = true, t3.key = this.parseMaybeAssignAllowIn(), this.expect(3);
            else {
              let { type: s3, value: r3 } = this.state, i;
              if (Ae2(s3))
                i = this.parseIdentifier(true);
              else
                switch (s3) {
                  case 132:
                    i = this.parseNumericLiteral(r3);
                    break;
                  case 131:
                    i = this.parseStringLiteral(r3);
                    break;
                  case 133:
                    i = this.parseBigIntLiteral(r3);
                    break;
                  case 134:
                    i = this.parseDecimalLiteral(r3);
                    break;
                  case 136: {
                    let a3 = this.state.startLoc;
                    e28 != null ? e28.privateKeyLoc === null && (e28.privateKeyLoc = a3) : this.raise(p3.UnexpectedPrivateField, { at: a3 }), i = this.parsePrivateName();
                    break;
                  }
                  default:
                    this.unexpected();
                }
              t3.key = i, s3 !== 136 && (t3.computed = false);
            }
            return t3.key;
          }
          initFunction(t3, e28) {
            t3.id = null, t3.generator = false, t3.async = e28;
          }
          parseMethod(t3, e28, s3, r3, i, a3) {
            let n3 = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
            this.initFunction(t3, s3), t3.generator = e28, this.scope.enter(De2 | Tt2 | (n3 ? _e2 : 0) | (i ? xr2 : 0)), this.prodParam.enter(Bt2(s3, t3.generator)), this.parseFunctionParams(t3, r3);
            let o3 = this.parseFunctionBodyAndFinish(t3, a3, true);
            return this.prodParam.exit(), this.scope.exit(), o3;
          }
          parseArrayLike(t3, e28, s3, r3) {
            s3 && this.expectPlugin("recordAndTuple");
            let i = this.state.inFSharpPipelineDirectBody;
            this.state.inFSharpPipelineDirectBody = false;
            let a3 = this.startNode();
            return this.next(), a3.elements = this.parseExprList(t3, !s3, r3, a3), this.state.inFSharpPipelineDirectBody = i, this.finishNode(a3, s3 ? "TupleExpression" : "ArrayExpression");
          }
          parseArrowExpression(t3, e28, s3, r3) {
            this.scope.enter(De2 | ss2);
            let i = Bt2(s3, false);
            !this.match(5) && this.prodParam.hasIn && (i |= et2), this.prodParam.enter(i), this.initFunction(t3, s3);
            let a3 = this.state.maybeInArrowParameters;
            return e28 && (this.state.maybeInArrowParameters = true, this.setArrowFunctionParameters(t3, e28, r3)), this.state.maybeInArrowParameters = false, this.parseFunctionBody(t3, true), this.prodParam.exit(), this.scope.exit(), this.state.maybeInArrowParameters = a3, this.finishNode(t3, "ArrowFunctionExpression");
          }
          setArrowFunctionParameters(t3, e28, s3) {
            this.toAssignableList(e28, s3, false), t3.params = e28;
          }
          parseFunctionBodyAndFinish(t3, e28) {
            let s3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            return this.parseFunctionBody(t3, false, s3), this.finishNode(t3, e28);
          }
          parseFunctionBody(t3, e28) {
            let s3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, r3 = e28 && !this.match(5);
            if (this.expressionScope.enter(Mr2()), r3)
              t3.body = this.parseMaybeAssign(), this.checkParams(t3, false, e28, false);
            else {
              let i = this.state.strict, a3 = this.state.labels;
              this.state.labels = [], this.prodParam.enter(this.prodParam.currentFlags() | jr2), t3.body = this.parseBlock(true, false, (n3) => {
                let o3 = !this.isSimpleParamList(t3.params);
                n3 && o3 && this.raise(p3.IllegalLanguageModeDirective, { at: (t3.kind === "method" || t3.kind === "constructor") && t3.key ? t3.key.loc.end : t3 });
                let h3 = !i && this.state.strict;
                this.checkParams(t3, !this.state.strict && !e28 && !s3 && !o3, e28, h3), this.state.strict && t3.id && this.checkIdentifier(t3.id, rn2, h3);
              }), this.prodParam.exit(), this.state.labels = a3;
            }
            this.expressionScope.exit();
          }
          isSimpleParameter(t3) {
            return t3.type === "Identifier";
          }
          isSimpleParamList(t3) {
            for (let e28 = 0, s3 = t3.length; e28 < s3; e28++)
              if (!this.isSimpleParameter(t3[e28]))
                return false;
            return true;
          }
          checkParams(t3, e28, s3) {
            let r3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, i = !e28 && /* @__PURE__ */ new Set(), a3 = { type: "FormalParameters" };
            for (let n3 of t3.params)
              this.checkLVal(n3, { in: a3, binding: It2, checkClashes: i, strictModeChanged: r3 });
          }
          parseExprList(t3, e28, s3, r3) {
            let i = [], a3 = true;
            for (; !this.eat(t3); ) {
              if (a3)
                a3 = false;
              else if (this.expect(12), this.match(t3)) {
                r3 && this.addTrailingCommaExtraToNode(r3), this.next();
                break;
              }
              i.push(this.parseExprListItem(e28, s3));
            }
            return i;
          }
          parseExprListItem(t3, e28, s3) {
            let r3;
            if (this.match(12))
              t3 || this.raise(p3.UnexpectedToken, { at: this.state.curPosition(), unexpected: "," }), r3 = null;
            else if (this.match(21)) {
              let i = this.state.startLoc;
              r3 = this.parseParenItem(this.parseSpread(e28), i);
            } else if (this.match(17)) {
              this.expectPlugin("partialApplication"), s3 || this.raise(p3.UnexpectedArgumentPlaceholder, { at: this.state.startLoc });
              let i = this.startNode();
              this.next(), r3 = this.finishNode(i, "ArgumentPlaceholder");
            } else
              r3 = this.parseMaybeAssignAllowIn(e28, this.parseParenItem);
            return r3;
          }
          parseIdentifier(t3) {
            let e28 = this.startNode(), s3 = this.parseIdentifierName(t3);
            return this.createIdentifier(e28, s3);
          }
          createIdentifier(t3, e28) {
            return t3.name = e28, t3.loc.identifierName = e28, this.finishNode(t3, "Identifier");
          }
          parseIdentifierName(t3) {
            let e28, { startLoc: s3, type: r3 } = this.state;
            Ae2(r3) ? e28 = this.state.value : this.unexpected();
            let i = we2(r3);
            return t3 ? i && this.replaceToken(130) : this.checkReservedWord(e28, s3, i, false), this.next(), e28;
          }
          checkReservedWord(t3, e28, s3, r3) {
            if (!(t3.length > 10 || !Za2(t3))) {
              if (s3 && Ga2(t3)) {
                this.raise(p3.UnexpectedKeyword, { at: e28, keyword: t3 });
                return;
              }
              if ((this.state.strict ? r3 ? fr2 : dr2 : cr2)(t3, this.inModule)) {
                this.raise(p3.UnexpectedReservedWord, { at: e28, reservedWord: t3 });
                return;
              } else if (t3 === "yield") {
                if (this.prodParam.hasYield) {
                  this.raise(p3.YieldBindingIdentifier, { at: e28 });
                  return;
                }
              } else if (t3 === "await") {
                if (this.prodParam.hasAwait) {
                  this.raise(p3.AwaitBindingIdentifier, { at: e28 });
                  return;
                }
                if (this.scope.inStaticBlock) {
                  this.raise(p3.AwaitBindingIdentifierInStaticBlock, { at: e28 });
                  return;
                }
                this.expressionScope.recordAsyncArrowParametersError({ at: e28 });
              } else if (t3 === "arguments" && this.scope.inClassAndNotInNonArrowFunction) {
                this.raise(p3.ArgumentsInClass, { at: e28 });
                return;
              }
            }
          }
          isAwaitAllowed() {
            return !!(this.prodParam.hasAwait || this.options.allowAwaitOutsideFunction && !this.scope.inFunction);
          }
          parseAwait(t3) {
            let e28 = this.startNodeAt(t3);
            return this.expressionScope.recordParameterInitializerError(p3.AwaitExpressionFormalParameter, { at: e28 }), this.eat(55) && this.raise(p3.ObsoleteAwaitStar, { at: e28 }), !this.scope.inFunction && !this.options.allowAwaitOutsideFunction && (this.isAmbiguousAwait() ? this.ambiguousScriptDifferentAst = true : this.sawUnambiguousESM = true), this.state.soloAwait || (e28.argument = this.parseMaybeUnary(null, true)), this.finishNode(e28, "AwaitExpression");
          }
          isAmbiguousAwait() {
            if (this.hasPrecedingLineBreak())
              return true;
            let { type: t3 } = this.state;
            return t3 === 53 || t3 === 10 || t3 === 0 || Pt2(t3) || t3 === 101 && !this.state.containsEsc || t3 === 135 || t3 === 56 || this.hasPlugin("v8intrinsic") && t3 === 54;
          }
          parseYield() {
            let t3 = this.startNode();
            this.expressionScope.recordParameterInitializerError(p3.YieldInParameter, { at: t3 }), this.next();
            let e28 = false, s3 = null;
            if (!this.hasPrecedingLineBreak())
              switch (e28 = this.eat(55), this.state.type) {
                case 13:
                case 137:
                case 8:
                case 11:
                case 3:
                case 9:
                case 14:
                case 12:
                  if (!e28)
                    break;
                default:
                  s3 = this.parseMaybeAssign();
              }
            return t3.delegate = e28, t3.argument = s3, this.finishNode(t3, "YieldExpression");
          }
          checkPipelineAtInfixOperator(t3, e28) {
            this.hasPlugin(["pipelineOperator", { proposal: "smart" }]) && t3.type === "SequenceExpression" && this.raise(p3.PipelineHeadSequenceExpression, { at: e28 });
          }
          parseSmartPipelineBodyInStyle(t3, e28) {
            if (this.isSimpleReference(t3)) {
              let s3 = this.startNodeAt(e28);
              return s3.callee = t3, this.finishNode(s3, "PipelineBareFunction");
            } else {
              let s3 = this.startNodeAt(e28);
              return this.checkSmartPipeTopicBodyEarlyErrors(e28), s3.expression = t3, this.finishNode(s3, "PipelineTopicExpression");
            }
          }
          isSimpleReference(t3) {
            switch (t3.type) {
              case "MemberExpression":
                return !t3.computed && this.isSimpleReference(t3.object);
              case "Identifier":
                return true;
              default:
                return false;
            }
          }
          checkSmartPipeTopicBodyEarlyErrors(t3) {
            if (this.match(19))
              throw this.raise(p3.PipelineBodyNoArrow, { at: this.state.startLoc });
            this.topicReferenceWasUsedInCurrentContext() || this.raise(p3.PipelineTopicUnused, { at: t3 });
          }
          withTopicBindingContext(t3) {
            let e28 = this.state.topicContext;
            this.state.topicContext = { maxNumOfResolvableTopics: 1, maxTopicIndex: null };
            try {
              return t3();
            } finally {
              this.state.topicContext = e28;
            }
          }
          withSmartMixTopicForbiddingContext(t3) {
            if (this.hasPlugin(["pipelineOperator", { proposal: "smart" }])) {
              let e28 = this.state.topicContext;
              this.state.topicContext = { maxNumOfResolvableTopics: 0, maxTopicIndex: null };
              try {
                return t3();
              } finally {
                this.state.topicContext = e28;
              }
            } else
              return t3();
          }
          withSoloAwaitPermittingContext(t3) {
            let e28 = this.state.soloAwait;
            this.state.soloAwait = true;
            try {
              return t3();
            } finally {
              this.state.soloAwait = e28;
            }
          }
          allowInAnd(t3) {
            let e28 = this.prodParam.currentFlags();
            if (et2 & ~e28) {
              this.prodParam.enter(e28 | et2);
              try {
                return t3();
              } finally {
                this.prodParam.exit();
              }
            }
            return t3();
          }
          disallowInAnd(t3) {
            let e28 = this.prodParam.currentFlags();
            if (et2 & e28) {
              this.prodParam.enter(e28 & ~et2);
              try {
                return t3();
              } finally {
                this.prodParam.exit();
              }
            }
            return t3();
          }
          registerTopicReference() {
            this.state.topicContext.maxTopicIndex = 0;
          }
          topicReferenceIsAllowedInCurrentContext() {
            return this.state.topicContext.maxNumOfResolvableTopics >= 1;
          }
          topicReferenceWasUsedInCurrentContext() {
            return this.state.topicContext.maxTopicIndex != null && this.state.topicContext.maxTopicIndex >= 0;
          }
          parseFSharpPipelineBody(t3) {
            let e28 = this.state.startLoc;
            this.state.potentialArrowAt = this.state.start;
            let s3 = this.state.inFSharpPipelineDirectBody;
            this.state.inFSharpPipelineDirectBody = true;
            let r3 = this.parseExprOp(this.parseMaybeUnaryOrPrivate(), e28, t3);
            return this.state.inFSharpPipelineDirectBody = s3, r3;
          }
          parseModuleExpression() {
            this.expectPlugin("moduleBlocks");
            let t3 = this.startNode();
            this.next(), this.match(5) || this.unexpected(null, 5);
            let e28 = this.startNodeAt(this.state.endLoc);
            this.next();
            let s3 = this.initializeScopes(true);
            this.enterInitialScopes();
            try {
              t3.body = this.parseProgram(e28, 8, "module");
            } finally {
              s3();
            }
            return this.finishNode(t3, "ModuleExpression");
          }
          parsePropertyNamePrefixOperator(t3) {
          }
        }, Ps2 = { kind: "loop" }, lo2 = { kind: "switch" }, po2 = /[\uD800-\uDFFF]/u, As2 = /in(?:stanceof)?/y;
        function uo2(t3, e28) {
          for (let s3 = 0; s3 < t3.length; s3++) {
            let r3 = t3[s3], { type: i } = r3;
            if (typeof i == "number") {
              {
                if (i === 136) {
                  let { loc: a3, start: n3, value: o3, end: h3 } = r3, l3 = n3 + 1, f3 = fe2(a3.start, 1);
                  t3.splice(s3, 1, new je2({ type: Ie2(27), value: "#", start: n3, end: l3, startLoc: a3.start, endLoc: f3 }), new je2({ type: Ie2(130), value: o3, start: l3, end: h3, startLoc: f3, endLoc: a3.end })), s3++;
                  continue;
                }
                if (Pt2(i)) {
                  let { loc: a3, start: n3, value: o3, end: h3 } = r3, l3 = n3 + 1, f3 = fe2(a3.start, 1), T3;
                  e28.charCodeAt(n3) === 96 ? T3 = new je2({ type: Ie2(22), value: "`", start: n3, end: l3, startLoc: a3.start, endLoc: f3 }) : T3 = new je2({ type: Ie2(8), value: "}", start: n3, end: l3, startLoc: a3.start, endLoc: f3 });
                  let R3, B3, se2, re2;
                  i === 24 ? (B3 = h3 - 1, se2 = fe2(a3.end, -1), R3 = o3 === null ? null : o3.slice(1, -1), re2 = new je2({ type: Ie2(22), value: "`", start: B3, end: h3, startLoc: se2, endLoc: a3.end })) : (B3 = h3 - 2, se2 = fe2(a3.end, -2), R3 = o3 === null ? null : o3.slice(1, -2), re2 = new je2({ type: Ie2(23), value: "${", start: B3, end: h3, startLoc: se2, endLoc: a3.end })), t3.splice(s3, 1, T3, new je2({ type: Ie2(20), value: R3, start: l3, end: B3, startLoc: f3, endLoc: se2 }), re2), s3 += 2;
                  continue;
                }
              }
              r3.type = Ie2(i);
            }
          }
          return t3;
        }
        var co2 = class extends ho2 {
          parseTopLevel(t3, e28) {
            return t3.program = this.parseProgram(e28), t3.comments = this.state.comments, this.options.tokens && (t3.tokens = uo2(this.tokens, this.input)), this.finishNode(t3, "File");
          }
          parseProgram(t3) {
            let e28 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 137, s3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.options.sourceType;
            if (t3.sourceType = s3, t3.interpreter = this.parseInterpreterDirective(), this.parseBlockBody(t3, true, true, e28), this.inModule && !this.options.allowUndeclaredExports && this.scope.undefinedExports.size > 0)
              for (let [i, a3] of Array.from(this.scope.undefinedExports))
                this.raise(p3.ModuleExportUndefined, { at: a3, localName: i });
            let r3;
            return e28 === 137 ? r3 = this.finishNode(t3, "Program") : r3 = this.finishNodeAt(t3, "Program", fe2(this.state.startLoc, -1)), r3;
          }
          stmtToDirective(t3) {
            let e28 = t3;
            e28.type = "Directive", e28.value = e28.expression, delete e28.expression;
            let s3 = e28.value, r3 = s3.value, i = this.input.slice(s3.start, s3.end), a3 = s3.value = i.slice(1, -1);
            return this.addExtra(s3, "raw", i), this.addExtra(s3, "rawValue", a3), this.addExtra(s3, "expressionValue", r3), s3.type = "DirectiveLiteral", e28;
          }
          parseInterpreterDirective() {
            if (!this.match(28))
              return null;
            let t3 = this.startNode();
            return t3.value = this.state.value, this.next(), this.finishNode(t3, "InterpreterDirective");
          }
          isLet() {
            return this.isContextual(99) ? this.hasFollowingBindingAtom() : false;
          }
          chStartsBindingIdentifier(t3, e28) {
            if (ke2(t3)) {
              if (As2.lastIndex = e28, As2.test(this.input)) {
                let s3 = this.codePointAtPos(As2.lastIndex);
                if (!Je2(s3) && s3 !== 92)
                  return false;
              }
              return true;
            } else
              return t3 === 92;
          }
          chStartsBindingPattern(t3) {
            return t3 === 91 || t3 === 123;
          }
          hasFollowingBindingAtom() {
            let t3 = this.nextTokenStart(), e28 = this.codePointAtPos(t3);
            return this.chStartsBindingPattern(e28) || this.chStartsBindingIdentifier(e28, t3);
          }
          hasFollowingBindingIdentifier() {
            let t3 = this.nextTokenStart(), e28 = this.codePointAtPos(t3);
            return this.chStartsBindingIdentifier(e28, t3);
          }
          startsUsingForOf() {
            let t3 = this.lookahead();
            return t3.type === 101 && !t3.containsEsc ? false : (this.expectPlugin("explicitResourceManagement"), true);
          }
          parseModuleItem() {
            return this.parseStatementLike(15);
          }
          parseStatementListItem() {
            return this.parseStatementLike(6 | (!this.options.annexB || this.state.strict ? 0 : 8));
          }
          parseStatementOrSloppyAnnexBFunctionDeclaration() {
            let t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, e28 = 0;
            return this.options.annexB && !this.state.strict && (e28 |= 4, t3 && (e28 |= 8)), this.parseStatementLike(e28);
          }
          parseStatement() {
            return this.parseStatementLike(0);
          }
          parseStatementLike(t3) {
            let e28 = null;
            return this.match(26) && (e28 = this.parseDecorators(true)), this.parseStatementContent(t3, e28);
          }
          parseStatementContent(t3, e28) {
            let s3 = this.state.type, r3 = this.startNode(), i = !!(t3 & 2), a3 = !!(t3 & 4), n3 = t3 & 1;
            switch (s3) {
              case 60:
                return this.parseBreakContinueStatement(r3, true);
              case 63:
                return this.parseBreakContinueStatement(r3, false);
              case 64:
                return this.parseDebuggerStatement(r3);
              case 90:
                return this.parseDoWhileStatement(r3);
              case 91:
                return this.parseForStatement(r3);
              case 68:
                if (this.lookaheadCharCode() === 46)
                  break;
                return a3 || this.raise(this.state.strict ? p3.StrictFunction : this.options.annexB ? p3.SloppyFunctionAnnexB : p3.SloppyFunction, { at: this.state.startLoc }), this.parseFunctionStatement(r3, false, !i && a3);
              case 80:
                return i || this.unexpected(), this.parseClass(this.maybeTakeDecorators(e28, r3), true);
              case 69:
                return this.parseIfStatement(r3);
              case 70:
                return this.parseReturnStatement(r3);
              case 71:
                return this.parseSwitchStatement(r3);
              case 72:
                return this.parseThrowStatement(r3);
              case 73:
                return this.parseTryStatement(r3);
              case 105:
                if (this.hasFollowingLineBreak() || this.state.containsEsc || !this.hasFollowingBindingIdentifier())
                  break;
                return this.expectPlugin("explicitResourceManagement"), !this.scope.inModule && this.scope.inTopLevel ? this.raise(p3.UnexpectedUsingDeclaration, { at: this.state.startLoc }) : i || this.raise(p3.UnexpectedLexicalDeclaration, { at: this.state.startLoc }), this.parseVarStatement(r3, "using");
              case 99: {
                if (this.state.containsEsc)
                  break;
                let l3 = this.nextTokenStart(), f3 = this.codePointAtPos(l3);
                if (f3 !== 91 && (!i && this.hasFollowingLineBreak() || !this.chStartsBindingIdentifier(f3, l3) && f3 !== 123))
                  break;
              }
              case 75:
                i || this.raise(p3.UnexpectedLexicalDeclaration, { at: this.state.startLoc });
              case 74: {
                let l3 = this.state.value;
                return this.parseVarStatement(r3, l3);
              }
              case 92:
                return this.parseWhileStatement(r3);
              case 76:
                return this.parseWithStatement(r3);
              case 5:
                return this.parseBlock();
              case 13:
                return this.parseEmptyStatement(r3);
              case 83: {
                let l3 = this.lookaheadCharCode();
                if (l3 === 40 || l3 === 46)
                  break;
              }
              case 82: {
                !this.options.allowImportExportEverywhere && !n3 && this.raise(p3.UnexpectedImportExport, { at: this.state.startLoc }), this.next();
                let l3;
                return s3 === 83 ? (l3 = this.parseImport(r3), l3.type === "ImportDeclaration" && (!l3.importKind || l3.importKind === "value") && (this.sawUnambiguousESM = true)) : (l3 = this.parseExport(r3, e28), (l3.type === "ExportNamedDeclaration" && (!l3.exportKind || l3.exportKind === "value") || l3.type === "ExportAllDeclaration" && (!l3.exportKind || l3.exportKind === "value") || l3.type === "ExportDefaultDeclaration") && (this.sawUnambiguousESM = true)), this.assertModuleNodeAllowed(l3), l3;
              }
              default:
                if (this.isAsyncFunction())
                  return i || this.raise(p3.AsyncFunctionInSingleStatementContext, { at: this.state.startLoc }), this.next(), this.parseFunctionStatement(r3, true, !i && a3);
            }
            let o3 = this.state.value, h3 = this.parseExpression();
            return te2(s3) && h3.type === "Identifier" && this.eat(14) ? this.parseLabeledStatement(r3, o3, h3, t3) : this.parseExpressionStatement(r3, h3, e28);
          }
          assertModuleNodeAllowed(t3) {
            !this.options.allowImportExportEverywhere && !this.inModule && this.raise(p3.ImportOutsideModule, { at: t3 });
          }
          decoratorsEnabledBeforeExport() {
            return this.hasPlugin("decorators-legacy") ? true : this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") !== false;
          }
          maybeTakeDecorators(t3, e28, s3) {
            return t3 && (e28.decorators && e28.decorators.length > 0 ? (typeof this.getPluginOption("decorators", "decoratorsBeforeExport") != "boolean" && this.raise(p3.DecoratorsBeforeAfterExport, { at: e28.decorators[0] }), e28.decorators.unshift(...t3)) : e28.decorators = t3, this.resetStartLocationFromNode(e28, t3[0]), s3 && this.resetStartLocationFromNode(s3, e28)), e28;
          }
          canHaveLeadingDecorator() {
            return this.match(80);
          }
          parseDecorators(t3) {
            let e28 = [];
            do
              e28.push(this.parseDecorator());
            while (this.match(26));
            if (this.match(82))
              t3 || this.unexpected(), this.decoratorsEnabledBeforeExport() || this.raise(p3.DecoratorExportClass, { at: this.state.startLoc });
            else if (!this.canHaveLeadingDecorator())
              throw this.raise(p3.UnexpectedLeadingDecorator, { at: this.state.startLoc });
            return e28;
          }
          parseDecorator() {
            this.expectOnePlugin(["decorators", "decorators-legacy"]);
            let t3 = this.startNode();
            if (this.next(), this.hasPlugin("decorators")) {
              let e28 = this.state.startLoc, s3;
              if (this.match(10)) {
                let r3 = this.state.startLoc;
                this.next(), s3 = this.parseExpression(), this.expect(11), s3 = this.wrapParenthesis(r3, s3);
                let i = this.state.startLoc;
                t3.expression = this.parseMaybeDecoratorArguments(s3), this.getPluginOption("decorators", "allowCallParenthesized") === false && t3.expression !== s3 && this.raise(p3.DecoratorArgumentsOutsideParentheses, { at: i });
              } else {
                for (s3 = this.parseIdentifier(false); this.eat(16); ) {
                  let r3 = this.startNodeAt(e28);
                  r3.object = s3, this.match(136) ? (this.classScope.usePrivateName(this.state.value, this.state.startLoc), r3.property = this.parsePrivateName()) : r3.property = this.parseIdentifier(true), r3.computed = false, s3 = this.finishNode(r3, "MemberExpression");
                }
                t3.expression = this.parseMaybeDecoratorArguments(s3);
              }
            } else
              t3.expression = this.parseExprSubscripts();
            return this.finishNode(t3, "Decorator");
          }
          parseMaybeDecoratorArguments(t3) {
            if (this.eat(10)) {
              let e28 = this.startNodeAtNode(t3);
              return e28.callee = t3, e28.arguments = this.parseCallExpressionArguments(11, false), this.toReferencedList(e28.arguments), this.finishNode(e28, "CallExpression");
            }
            return t3;
          }
          parseBreakContinueStatement(t3, e28) {
            return this.next(), this.isLineTerminator() ? t3.label = null : (t3.label = this.parseIdentifier(), this.semicolon()), this.verifyBreakContinue(t3, e28), this.finishNode(t3, e28 ? "BreakStatement" : "ContinueStatement");
          }
          verifyBreakContinue(t3, e28) {
            let s3;
            for (s3 = 0; s3 < this.state.labels.length; ++s3) {
              let r3 = this.state.labels[s3];
              if ((t3.label == null || r3.name === t3.label.name) && (r3.kind != null && (e28 || r3.kind === "loop") || t3.label && e28))
                break;
            }
            if (s3 === this.state.labels.length) {
              let r3 = e28 ? "BreakStatement" : "ContinueStatement";
              this.raise(p3.IllegalBreakContinue, { at: t3, type: r3 });
            }
          }
          parseDebuggerStatement(t3) {
            return this.next(), this.semicolon(), this.finishNode(t3, "DebuggerStatement");
          }
          parseHeaderExpression() {
            this.expect(10);
            let t3 = this.parseExpression();
            return this.expect(11), t3;
          }
          parseDoWhileStatement(t3) {
            return this.next(), this.state.labels.push(Ps2), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.state.labels.pop(), this.expect(92), t3.test = this.parseHeaderExpression(), this.eat(13), this.finishNode(t3, "DoWhileStatement");
          }
          parseForStatement(t3) {
            this.next(), this.state.labels.push(Ps2);
            let e28 = null;
            if (this.isAwaitAllowed() && this.eatContextual(96) && (e28 = this.state.lastTokStartLoc), this.scope.enter(Xe2), this.expect(10), this.match(13))
              return e28 !== null && this.unexpected(e28), this.parseFor(t3, null);
            let s3 = this.isContextual(99), r3 = this.isContextual(105) && !this.hasFollowingLineBreak(), i = s3 && this.hasFollowingBindingAtom() || r3 && this.hasFollowingBindingIdentifier() && this.startsUsingForOf();
            if (this.match(74) || this.match(75) || i) {
              let l3 = this.startNode(), f3 = this.state.value;
              this.next(), this.parseVar(l3, true, f3);
              let T3 = this.finishNode(l3, "VariableDeclaration"), R3 = this.match(58);
              return R3 && r3 && this.raise(p3.ForInUsing, { at: T3 }), (R3 || this.isContextual(101)) && T3.declarations.length === 1 ? this.parseForIn(t3, T3, e28) : (e28 !== null && this.unexpected(e28), this.parseFor(t3, T3));
            }
            let a3 = this.isContextual(95), n3 = new Mt2(), o3 = this.parseExpression(true, n3), h3 = this.isContextual(101);
            if (h3 && (s3 && this.raise(p3.ForOfLet, { at: o3 }), e28 === null && a3 && o3.type === "Identifier" && this.raise(p3.ForOfAsync, { at: o3 })), h3 || this.match(58)) {
              this.checkDestructuringPrivate(n3), this.toAssignable(o3, true);
              let l3 = h3 ? "ForOfStatement" : "ForInStatement";
              return this.checkLVal(o3, { in: { type: l3 } }), this.parseForIn(t3, o3, e28);
            } else
              this.checkExpressionErrors(n3, true);
            return e28 !== null && this.unexpected(e28), this.parseFor(t3, o3);
          }
          parseFunctionStatement(t3, e28, s3) {
            return this.next(), this.parseFunction(t3, 1 | (s3 ? 2 : 0) | (e28 ? 8 : 0));
          }
          parseIfStatement(t3) {
            return this.next(), t3.test = this.parseHeaderExpression(), t3.consequent = this.parseStatementOrSloppyAnnexBFunctionDeclaration(), t3.alternate = this.eat(66) ? this.parseStatementOrSloppyAnnexBFunctionDeclaration() : null, this.finishNode(t3, "IfStatement");
          }
          parseReturnStatement(t3) {
            return !this.prodParam.hasReturn && !this.options.allowReturnOutsideFunction && this.raise(p3.IllegalReturn, { at: this.state.startLoc }), this.next(), this.isLineTerminator() ? t3.argument = null : (t3.argument = this.parseExpression(), this.semicolon()), this.finishNode(t3, "ReturnStatement");
          }
          parseSwitchStatement(t3) {
            this.next(), t3.discriminant = this.parseHeaderExpression();
            let e28 = t3.cases = [];
            this.expect(5), this.state.labels.push(lo2), this.scope.enter(Xe2);
            let s3;
            for (let r3; !this.match(8); )
              if (this.match(61) || this.match(65)) {
                let i = this.match(61);
                s3 && this.finishNode(s3, "SwitchCase"), e28.push(s3 = this.startNode()), s3.consequent = [], this.next(), i ? s3.test = this.parseExpression() : (r3 && this.raise(p3.MultipleDefaultsInSwitch, { at: this.state.lastTokStartLoc }), r3 = true, s3.test = null), this.expect(14);
              } else
                s3 ? s3.consequent.push(this.parseStatementListItem()) : this.unexpected();
            return this.scope.exit(), s3 && this.finishNode(s3, "SwitchCase"), this.next(), this.state.labels.pop(), this.finishNode(t3, "SwitchStatement");
          }
          parseThrowStatement(t3) {
            return this.next(), this.hasPrecedingLineBreak() && this.raise(p3.NewlineAfterThrow, { at: this.state.lastTokEndLoc }), t3.argument = this.parseExpression(), this.semicolon(), this.finishNode(t3, "ThrowStatement");
          }
          parseCatchClauseParam() {
            let t3 = this.parseBindingAtom();
            return this.scope.enter(this.options.annexB && t3.type === "Identifier" ? yr2 : 0), this.checkLVal(t3, { in: { type: "CatchClause" }, binding: en2 }), t3;
          }
          parseTryStatement(t3) {
            if (this.next(), t3.block = this.parseBlock(), t3.handler = null, this.match(62)) {
              let e28 = this.startNode();
              this.next(), this.match(10) ? (this.expect(10), e28.param = this.parseCatchClauseParam(), this.expect(11)) : (e28.param = null, this.scope.enter(Xe2)), e28.body = this.withSmartMixTopicForbiddingContext(() => this.parseBlock(false, false)), this.scope.exit(), t3.handler = this.finishNode(e28, "CatchClause");
            }
            return t3.finalizer = this.eat(67) ? this.parseBlock() : null, !t3.handler && !t3.finalizer && this.raise(p3.NoCatchOrFinally, { at: t3 }), this.finishNode(t3, "TryStatement");
          }
          parseVarStatement(t3, e28) {
            let s3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            return this.next(), this.parseVar(t3, false, e28, s3), this.semicolon(), this.finishNode(t3, "VariableDeclaration");
          }
          parseWhileStatement(t3) {
            return this.next(), t3.test = this.parseHeaderExpression(), this.state.labels.push(Ps2), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.state.labels.pop(), this.finishNode(t3, "WhileStatement");
          }
          parseWithStatement(t3) {
            return this.state.strict && this.raise(p3.StrictWith, { at: this.state.startLoc }), this.next(), t3.object = this.parseHeaderExpression(), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.finishNode(t3, "WithStatement");
          }
          parseEmptyStatement(t3) {
            return this.next(), this.finishNode(t3, "EmptyStatement");
          }
          parseLabeledStatement(t3, e28, s3, r3) {
            for (let a3 of this.state.labels)
              a3.name === e28 && this.raise(p3.LabelRedeclaration, { at: s3, labelName: e28 });
            let i = va2(this.state.type) ? "loop" : this.match(71) ? "switch" : null;
            for (let a3 = this.state.labels.length - 1; a3 >= 0; a3--) {
              let n3 = this.state.labels[a3];
              if (n3.statementStart === t3.start)
                n3.statementStart = this.state.start, n3.kind = i;
              else
                break;
            }
            return this.state.labels.push({ name: e28, kind: i, statementStart: this.state.start }), t3.body = r3 & 8 ? this.parseStatementOrSloppyAnnexBFunctionDeclaration(true) : this.parseStatement(), this.state.labels.pop(), t3.label = s3, this.finishNode(t3, "LabeledStatement");
          }
          parseExpressionStatement(t3, e28, s3) {
            return t3.expression = e28, this.semicolon(), this.finishNode(t3, "ExpressionStatement");
          }
          parseBlock() {
            let t3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, e28 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, s3 = arguments.length > 2 ? arguments[2] : void 0, r3 = this.startNode();
            return t3 && this.state.strictErrors.clear(), this.expect(5), e28 && this.scope.enter(Xe2), this.parseBlockBody(r3, t3, false, 8, s3), e28 && this.scope.exit(), this.finishNode(r3, "BlockStatement");
          }
          isValidDirective(t3) {
            return t3.type === "ExpressionStatement" && t3.expression.type === "StringLiteral" && !t3.expression.extra.parenthesized;
          }
          parseBlockBody(t3, e28, s3, r3, i) {
            let a3 = t3.body = [], n3 = t3.directives = [];
            this.parseBlockOrModuleBlockBody(a3, e28 ? n3 : void 0, s3, r3, i);
          }
          parseBlockOrModuleBlockBody(t3, e28, s3, r3, i) {
            let a3 = this.state.strict, n3 = false, o3 = false;
            for (; !this.match(r3); ) {
              let h3 = s3 ? this.parseModuleItem() : this.parseStatementListItem();
              if (e28 && !o3) {
                if (this.isValidDirective(h3)) {
                  let l3 = this.stmtToDirective(h3);
                  e28.push(l3), !n3 && l3.value.value === "use strict" && (n3 = true, this.setStrict(true));
                  continue;
                }
                o3 = true, this.state.strictErrors.clear();
              }
              t3.push(h3);
            }
            i && i.call(this, n3), a3 || this.setStrict(false), this.next();
          }
          parseFor(t3, e28) {
            return t3.init = e28, this.semicolon(false), t3.test = this.match(13) ? null : this.parseExpression(), this.semicolon(false), t3.update = this.match(11) ? null : this.parseExpression(), this.expect(11), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.scope.exit(), this.state.labels.pop(), this.finishNode(t3, "ForStatement");
          }
          parseForIn(t3, e28, s3) {
            let r3 = this.match(58);
            return this.next(), r3 ? s3 !== null && this.unexpected(s3) : t3.await = s3 !== null, e28.type === "VariableDeclaration" && e28.declarations[0].init != null && (!r3 || !this.options.annexB || this.state.strict || e28.kind !== "var" || e28.declarations[0].id.type !== "Identifier") && this.raise(p3.ForInOfLoopInitializer, { at: e28, type: r3 ? "ForInStatement" : "ForOfStatement" }), e28.type === "AssignmentPattern" && this.raise(p3.InvalidLhs, { at: e28, ancestor: { type: "ForStatement" } }), t3.left = e28, t3.right = r3 ? this.parseExpression() : this.parseMaybeAssignAllowIn(), this.expect(11), t3.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.scope.exit(), this.state.labels.pop(), this.finishNode(t3, r3 ? "ForInStatement" : "ForOfStatement");
          }
          parseVar(t3, e28, s3) {
            let r3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, i = t3.declarations = [];
            for (t3.kind = s3; ; ) {
              let a3 = this.startNode();
              if (this.parseVarId(a3, s3), a3.init = this.eat(29) ? e28 ? this.parseMaybeAssignDisallowIn() : this.parseMaybeAssignAllowIn() : null, a3.init === null && !r3 && (a3.id.type !== "Identifier" && !(e28 && (this.match(58) || this.isContextual(101))) ? this.raise(p3.DeclarationMissingInitializer, { at: this.state.lastTokEndLoc, kind: "destructuring" }) : s3 === "const" && !(this.match(58) || this.isContextual(101)) && this.raise(p3.DeclarationMissingInitializer, { at: this.state.lastTokEndLoc, kind: "const" })), i.push(this.finishNode(a3, "VariableDeclarator")), !this.eat(12))
                break;
            }
            return t3;
          }
          parseVarId(t3, e28) {
            e28 === "using" && !this.inModule && this.match(96) && this.raise(p3.AwaitInUsingBinding, { at: this.state.startLoc });
            let s3 = this.parseBindingAtom();
            this.checkLVal(s3, { in: { type: "VariableDeclarator" }, binding: e28 === "var" ? It2 : Qe2 }), t3.id = s3;
          }
          parseAsyncFunctionExpression(t3) {
            return this.parseFunction(t3, 8);
          }
          parseFunction(t3) {
            let e28 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, s3 = e28 & 2, r3 = !!(e28 & 1), i = r3 && !(e28 & 4), a3 = !!(e28 & 8);
            this.initFunction(t3, a3), this.match(55) && (s3 && this.raise(p3.GeneratorInSingleStatementContext, { at: this.state.startLoc }), this.next(), t3.generator = true), r3 && (t3.id = this.parseFunctionId(i));
            let n3 = this.state.maybeInArrowParameters;
            return this.state.maybeInArrowParameters = false, this.scope.enter(De2), this.prodParam.enter(Bt2(a3, t3.generator)), r3 || (t3.id = this.parseFunctionId()), this.parseFunctionParams(t3, false), this.withSmartMixTopicForbiddingContext(() => {
              this.parseFunctionBodyAndFinish(t3, r3 ? "FunctionDeclaration" : "FunctionExpression");
            }), this.prodParam.exit(), this.scope.exit(), r3 && !s3 && this.registerFunctionStatementId(t3), this.state.maybeInArrowParameters = n3, t3;
          }
          parseFunctionId(t3) {
            return t3 || te2(this.state.type) ? this.parseIdentifier() : null;
          }
          parseFunctionParams(t3, e28) {
            this.expect(10), this.expressionScope.enter(kn2()), t3.params = this.parseBindingList(11, 41, 2 | (e28 ? 4 : 0)), this.expressionScope.exit();
          }
          registerFunctionStatementId(t3) {
            t3.id && this.scope.declareName(t3.id.name, !this.options.annexB || this.state.strict || t3.generator || t3.async ? this.scope.treatFunctionsAsVar ? It2 : Qe2 : br2, t3.id.loc.start);
          }
          parseClass(t3, e28, s3) {
            this.next();
            let r3 = this.state.strict;
            return this.state.strict = true, this.parseClassId(t3, e28, s3), this.parseClassSuper(t3), t3.body = this.parseClassBody(!!t3.superClass, r3), this.finishNode(t3, e28 ? "ClassDeclaration" : "ClassExpression");
          }
          isClassProperty() {
            return this.match(29) || this.match(13) || this.match(8);
          }
          isClassMethod() {
            return this.match(10);
          }
          isNonstaticConstructor(t3) {
            return !t3.computed && !t3.static && (t3.key.name === "constructor" || t3.key.value === "constructor");
          }
          parseClassBody(t3, e28) {
            this.classScope.enter();
            let s3 = { hadConstructor: false, hadSuperClass: t3 }, r3 = [], i = this.startNode();
            if (i.body = [], this.expect(5), this.withSmartMixTopicForbiddingContext(() => {
              for (; !this.match(8); ) {
                if (this.eat(13)) {
                  if (r3.length > 0)
                    throw this.raise(p3.DecoratorSemicolon, { at: this.state.lastTokEndLoc });
                  continue;
                }
                if (this.match(26)) {
                  r3.push(this.parseDecorator());
                  continue;
                }
                let a3 = this.startNode();
                r3.length && (a3.decorators = r3, this.resetStartLocationFromNode(a3, r3[0]), r3 = []), this.parseClassMember(i, a3, s3), a3.kind === "constructor" && a3.decorators && a3.decorators.length > 0 && this.raise(p3.DecoratorConstructor, { at: a3 });
              }
            }), this.state.strict = e28, this.next(), r3.length)
              throw this.raise(p3.TrailingDecorator, { at: this.state.startLoc });
            return this.classScope.exit(), this.finishNode(i, "ClassBody");
          }
          parseClassMemberFromModifier(t3, e28) {
            let s3 = this.parseIdentifier(true);
            if (this.isClassMethod()) {
              let r3 = e28;
              return r3.kind = "method", r3.computed = false, r3.key = s3, r3.static = false, this.pushClassMethod(t3, r3, false, false, false, false), true;
            } else if (this.isClassProperty()) {
              let r3 = e28;
              return r3.computed = false, r3.key = s3, r3.static = false, t3.body.push(this.parseClassProperty(r3)), true;
            }
            return this.resetPreviousNodeTrailingComments(s3), false;
          }
          parseClassMember(t3, e28, s3) {
            let r3 = this.isContextual(104);
            if (r3) {
              if (this.parseClassMemberFromModifier(t3, e28))
                return;
              if (this.eat(5)) {
                this.parseClassStaticBlock(t3, e28);
                return;
              }
            }
            this.parseClassMemberWithIsStatic(t3, e28, s3, r3);
          }
          parseClassMemberWithIsStatic(t3, e28, s3, r3) {
            let i = e28, a3 = e28, n3 = e28, o3 = e28, h3 = e28, l3 = i, f3 = i;
            if (e28.static = r3, this.parsePropertyNamePrefixOperator(e28), this.eat(55)) {
              l3.kind = "method";
              let re2 = this.match(136);
              if (this.parseClassElementName(l3), re2) {
                this.pushClassPrivateMethod(t3, a3, true, false);
                return;
              }
              this.isNonstaticConstructor(i) && this.raise(p3.ConstructorIsGenerator, { at: i.key }), this.pushClassMethod(t3, i, true, false, false, false);
              return;
            }
            let T3 = te2(this.state.type) && !this.state.containsEsc, R3 = this.match(136), B3 = this.parseClassElementName(e28), se2 = this.state.startLoc;
            if (this.parsePostMemberNameModifiers(f3), this.isClassMethod()) {
              if (l3.kind = "method", R3) {
                this.pushClassPrivateMethod(t3, a3, false, false);
                return;
              }
              let re2 = this.isNonstaticConstructor(i), ce2 = false;
              re2 && (i.kind = "constructor", s3.hadConstructor && !this.hasPlugin("typescript") && this.raise(p3.DuplicateConstructor, { at: B3 }), re2 && this.hasPlugin("typescript") && e28.override && this.raise(p3.OverrideOnConstructor, { at: B3 }), s3.hadConstructor = true, ce2 = s3.hadSuperClass), this.pushClassMethod(t3, i, false, false, re2, ce2);
            } else if (this.isClassProperty())
              R3 ? this.pushClassPrivateProperty(t3, o3) : this.pushClassProperty(t3, n3);
            else if (T3 && B3.name === "async" && !this.isLineTerminator()) {
              this.resetPreviousNodeTrailingComments(B3);
              let re2 = this.eat(55);
              f3.optional && this.unexpected(se2), l3.kind = "method";
              let ce2 = this.match(136);
              this.parseClassElementName(l3), this.parsePostMemberNameModifiers(f3), ce2 ? this.pushClassPrivateMethod(t3, a3, re2, true) : (this.isNonstaticConstructor(i) && this.raise(p3.ConstructorIsAsync, { at: i.key }), this.pushClassMethod(t3, i, re2, true, false, false));
            } else if (T3 && (B3.name === "get" || B3.name === "set") && !(this.match(55) && this.isLineTerminator())) {
              this.resetPreviousNodeTrailingComments(B3), l3.kind = B3.name;
              let re2 = this.match(136);
              this.parseClassElementName(i), re2 ? this.pushClassPrivateMethod(t3, a3, false, false) : (this.isNonstaticConstructor(i) && this.raise(p3.ConstructorIsAccessor, { at: i.key }), this.pushClassMethod(t3, i, false, false, false, false)), this.checkGetterSetterParams(i);
            } else if (T3 && B3.name === "accessor" && !this.isLineTerminator()) {
              this.expectPlugin("decoratorAutoAccessors"), this.resetPreviousNodeTrailingComments(B3);
              let re2 = this.match(136);
              this.parseClassElementName(n3), this.pushClassAccessorProperty(t3, h3, re2);
            } else
              this.isLineTerminator() ? R3 ? this.pushClassPrivateProperty(t3, o3) : this.pushClassProperty(t3, n3) : this.unexpected();
          }
          parseClassElementName(t3) {
            let { type: e28, value: s3 } = this.state;
            if ((e28 === 130 || e28 === 131) && t3.static && s3 === "prototype" && this.raise(p3.StaticPrototype, { at: this.state.startLoc }), e28 === 136) {
              s3 === "constructor" && this.raise(p3.ConstructorClassPrivateField, { at: this.state.startLoc });
              let r3 = this.parsePrivateName();
              return t3.key = r3, r3;
            }
            return this.parsePropertyName(t3);
          }
          parseClassStaticBlock(t3, e28) {
            var s3;
            this.scope.enter(_e2 | Et2 | Tt2);
            let r3 = this.state.labels;
            this.state.labels = [], this.prodParam.enter(Ze2);
            let i = e28.body = [];
            this.parseBlockOrModuleBlockBody(i, void 0, false, 8), this.prodParam.exit(), this.scope.exit(), this.state.labels = r3, t3.body.push(this.finishNode(e28, "StaticBlock")), (s3 = e28.decorators) != null && s3.length && this.raise(p3.DecoratorStaticBlock, { at: e28 });
          }
          pushClassProperty(t3, e28) {
            !e28.computed && (e28.key.name === "constructor" || e28.key.value === "constructor") && this.raise(p3.ConstructorClassField, { at: e28.key }), t3.body.push(this.parseClassProperty(e28));
          }
          pushClassPrivateProperty(t3, e28) {
            let s3 = this.parseClassPrivateProperty(e28);
            t3.body.push(s3), this.classScope.declarePrivateName(this.getPrivateNameSV(s3.key), ps2, s3.key.loc.start);
          }
          pushClassAccessorProperty(t3, e28, s3) {
            if (!s3 && !e28.computed) {
              let i = e28.key;
              (i.name === "constructor" || i.value === "constructor") && this.raise(p3.ConstructorClassField, { at: i });
            }
            let r3 = this.parseClassAccessorProperty(e28);
            t3.body.push(r3), s3 && this.classScope.declarePrivateName(this.getPrivateNameSV(r3.key), ps2, r3.key.loc.start);
          }
          pushClassMethod(t3, e28, s3, r3, i, a3) {
            t3.body.push(this.parseMethod(e28, s3, r3, i, a3, "ClassMethod", true));
          }
          pushClassPrivateMethod(t3, e28, s3, r3) {
            let i = this.parseMethod(e28, s3, r3, false, false, "ClassPrivateMethod", true);
            t3.body.push(i);
            let a3 = i.kind === "get" ? i.static ? hn2 : pn2 : i.kind === "set" ? i.static ? ln2 : un2 : ps2;
            this.declareClassPrivateMethodInScope(i, a3);
          }
          declareClassPrivateMethodInScope(t3, e28) {
            this.classScope.declarePrivateName(this.getPrivateNameSV(t3.key), e28, t3.key.loc.start);
          }
          parsePostMemberNameModifiers(t3) {
          }
          parseClassPrivateProperty(t3) {
            return this.parseInitializer(t3), this.semicolon(), this.finishNode(t3, "ClassPrivateProperty");
          }
          parseClassProperty(t3) {
            return this.parseInitializer(t3), this.semicolon(), this.finishNode(t3, "ClassProperty");
          }
          parseClassAccessorProperty(t3) {
            return this.parseInitializer(t3), this.semicolon(), this.finishNode(t3, "ClassAccessorProperty");
          }
          parseInitializer(t3) {
            this.scope.enter(_e2 | Tt2), this.expressionScope.enter(Mr2()), this.prodParam.enter(Ze2), t3.value = this.eat(29) ? this.parseMaybeAssignAllowIn() : null, this.expressionScope.exit(), this.prodParam.exit(), this.scope.exit();
          }
          parseClassId(t3, e28, s3) {
            let r3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Ar2;
            if (te2(this.state.type))
              t3.id = this.parseIdentifier(), e28 && this.declareNameFromIdentifier(t3.id, r3);
            else if (s3 || !e28)
              t3.id = null;
            else
              throw this.raise(p3.MissingClassName, { at: this.state.startLoc });
          }
          parseClassSuper(t3) {
            t3.superClass = this.eat(81) ? this.parseExprSubscripts() : null;
          }
          parseExport(t3, e28) {
            let s3 = this.maybeParseExportDefaultSpecifier(t3), r3 = !s3 || this.eat(12), i = r3 && this.eatExportStar(t3), a3 = i && this.maybeParseExportNamespaceSpecifier(t3), n3 = r3 && (!a3 || this.eat(12)), o3 = s3 || i;
            if (i && !a3) {
              if (s3 && this.unexpected(), e28)
                throw this.raise(p3.UnsupportedDecoratorExport, { at: t3 });
              return this.parseExportFrom(t3, true), this.finishNode(t3, "ExportAllDeclaration");
            }
            let h3 = this.maybeParseExportNamedSpecifiers(t3);
            s3 && r3 && !i && !h3 && this.unexpected(null, 5), a3 && n3 && this.unexpected(null, 97);
            let l3;
            if (o3 || h3) {
              if (l3 = false, e28)
                throw this.raise(p3.UnsupportedDecoratorExport, { at: t3 });
              this.parseExportFrom(t3, o3);
            } else
              l3 = this.maybeParseExportDeclaration(t3);
            if (o3 || h3 || l3) {
              var f3;
              let T3 = t3;
              if (this.checkExport(T3, true, false, !!T3.source), ((f3 = T3.declaration) == null ? void 0 : f3.type) === "ClassDeclaration")
                this.maybeTakeDecorators(e28, T3.declaration, T3);
              else if (e28)
                throw this.raise(p3.UnsupportedDecoratorExport, { at: t3 });
              return this.finishNode(T3, "ExportNamedDeclaration");
            }
            if (this.eat(65)) {
              let T3 = t3, R3 = this.parseExportDefaultExpression();
              if (T3.declaration = R3, R3.type === "ClassDeclaration")
                this.maybeTakeDecorators(e28, R3, T3);
              else if (e28)
                throw this.raise(p3.UnsupportedDecoratorExport, { at: t3 });
              return this.checkExport(T3, true, true), this.finishNode(T3, "ExportDefaultDeclaration");
            }
            this.unexpected(null, 5);
          }
          eatExportStar(t3) {
            return this.eat(55);
          }
          maybeParseExportDefaultSpecifier(t3) {
            if (this.isExportDefaultSpecifier()) {
              this.expectPlugin("exportDefaultFrom");
              let e28 = this.startNode();
              return e28.exported = this.parseIdentifier(true), t3.specifiers = [this.finishNode(e28, "ExportDefaultSpecifier")], true;
            }
            return false;
          }
          maybeParseExportNamespaceSpecifier(t3) {
            if (this.isContextual(93)) {
              t3.specifiers || (t3.specifiers = []);
              let e28 = this.startNodeAt(this.state.lastTokStartLoc);
              return this.next(), e28.exported = this.parseModuleExportName(), t3.specifiers.push(this.finishNode(e28, "ExportNamespaceSpecifier")), true;
            }
            return false;
          }
          maybeParseExportNamedSpecifiers(t3) {
            if (this.match(5)) {
              t3.specifiers || (t3.specifiers = []);
              let e28 = t3.exportKind === "type";
              return t3.specifiers.push(...this.parseExportSpecifiers(e28)), t3.source = null, t3.declaration = null, this.hasPlugin("importAssertions") && (t3.assertions = []), true;
            }
            return false;
          }
          maybeParseExportDeclaration(t3) {
            return this.shouldParseExportDeclaration() ? (t3.specifiers = [], t3.source = null, this.hasPlugin("importAssertions") && (t3.assertions = []), t3.declaration = this.parseExportDeclaration(t3), true) : false;
          }
          isAsyncFunction() {
            if (!this.isContextual(95))
              return false;
            let t3 = this.nextTokenStart();
            return !ds2.test(this.input.slice(this.state.pos, t3)) && this.isUnparsedContextual(t3, "function");
          }
          parseExportDefaultExpression() {
            let t3 = this.startNode();
            if (this.match(68))
              return this.next(), this.parseFunction(t3, 5);
            if (this.isAsyncFunction())
              return this.next(), this.next(), this.parseFunction(t3, 13);
            if (this.match(80))
              return this.parseClass(t3, true, true);
            if (this.match(26))
              return this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") === true && this.raise(p3.DecoratorBeforeExport, { at: this.state.startLoc }), this.parseClass(this.maybeTakeDecorators(this.parseDecorators(false), this.startNode()), true, true);
            if (this.match(75) || this.match(74) || this.isLet())
              throw this.raise(p3.UnsupportedDefaultExport, { at: this.state.startLoc });
            let e28 = this.parseMaybeAssignAllowIn();
            return this.semicolon(), e28;
          }
          parseExportDeclaration(t3) {
            return this.match(80) ? this.parseClass(this.startNode(), true, false) : this.parseStatementListItem();
          }
          isExportDefaultSpecifier() {
            let { type: t3 } = this.state;
            if (te2(t3)) {
              if (t3 === 95 && !this.state.containsEsc || t3 === 99)
                return false;
              if ((t3 === 128 || t3 === 127) && !this.state.containsEsc) {
                let { type: r3 } = this.lookahead();
                if (te2(r3) && r3 !== 97 || r3 === 5)
                  return this.expectOnePlugin(["flow", "typescript"]), false;
              }
            } else if (!this.match(65))
              return false;
            let e28 = this.nextTokenStart(), s3 = this.isUnparsedContextual(e28, "from");
            if (this.input.charCodeAt(e28) === 44 || te2(this.state.type) && s3)
              return true;
            if (this.match(65) && s3) {
              let r3 = this.input.charCodeAt(this.nextTokenStartSince(e28 + 4));
              return r3 === 34 || r3 === 39;
            }
            return false;
          }
          parseExportFrom(t3, e28) {
            if (this.eatContextual(97)) {
              t3.source = this.parseImportSource(), this.checkExport(t3);
              let s3 = this.maybeParseImportAssertions();
              s3 && (t3.assertions = s3, this.checkJSONModuleImport(t3));
            } else
              e28 && this.unexpected();
            this.semicolon();
          }
          shouldParseExportDeclaration() {
            let { type: t3 } = this.state;
            return t3 === 26 && (this.expectOnePlugin(["decorators", "decorators-legacy"]), this.hasPlugin("decorators")) ? (this.getPluginOption("decorators", "decoratorsBeforeExport") === true && this.raise(p3.DecoratorBeforeExport, { at: this.state.startLoc }), true) : t3 === 74 || t3 === 75 || t3 === 68 || t3 === 80 || this.isLet() || this.isAsyncFunction();
          }
          checkExport(t3, e28, s3, r3) {
            if (e28) {
              if (s3) {
                if (this.checkDuplicateExports(t3, "default"), this.hasPlugin("exportDefaultFrom")) {
                  var i;
                  let a3 = t3.declaration;
                  a3.type === "Identifier" && a3.name === "from" && a3.end - a3.start === 4 && !((i = a3.extra) != null && i.parenthesized) && this.raise(p3.ExportDefaultFromAsIdentifier, { at: a3 });
                }
              } else if (t3.specifiers && t3.specifiers.length)
                for (let a3 of t3.specifiers) {
                  let { exported: n3 } = a3, o3 = n3.type === "Identifier" ? n3.name : n3.value;
                  if (this.checkDuplicateExports(a3, o3), !r3 && a3.local) {
                    let { local: h3 } = a3;
                    h3.type !== "Identifier" ? this.raise(p3.ExportBindingIsString, { at: a3, localName: h3.value, exportName: o3 }) : (this.checkReservedWord(h3.name, h3.loc.start, true, false), this.scope.checkLocalExport(h3));
                  }
                }
              else if (t3.declaration) {
                if (t3.declaration.type === "FunctionDeclaration" || t3.declaration.type === "ClassDeclaration") {
                  let a3 = t3.declaration.id;
                  if (!a3)
                    throw new Error("Assertion failure");
                  this.checkDuplicateExports(t3, a3.name);
                } else if (t3.declaration.type === "VariableDeclaration")
                  for (let a3 of t3.declaration.declarations)
                    this.checkDeclaration(a3.id);
              }
            }
          }
          checkDeclaration(t3) {
            if (t3.type === "Identifier")
              this.checkDuplicateExports(t3, t3.name);
            else if (t3.type === "ObjectPattern")
              for (let e28 of t3.properties)
                this.checkDeclaration(e28);
            else if (t3.type === "ArrayPattern")
              for (let e28 of t3.elements)
                e28 && this.checkDeclaration(e28);
            else
              t3.type === "ObjectProperty" ? this.checkDeclaration(t3.value) : t3.type === "RestElement" ? this.checkDeclaration(t3.argument) : t3.type === "AssignmentPattern" && this.checkDeclaration(t3.left);
          }
          checkDuplicateExports(t3, e28) {
            this.exportedIdentifiers.has(e28) && (e28 === "default" ? this.raise(p3.DuplicateDefaultExport, { at: t3 }) : this.raise(p3.DuplicateExport, { at: t3, exportName: e28 })), this.exportedIdentifiers.add(e28);
          }
          parseExportSpecifiers(t3) {
            let e28 = [], s3 = true;
            for (this.expect(5); !this.eat(8); ) {
              if (s3)
                s3 = false;
              else if (this.expect(12), this.eat(8))
                break;
              let r3 = this.isContextual(128), i = this.match(131), a3 = this.startNode();
              a3.local = this.parseModuleExportName(), e28.push(this.parseExportSpecifier(a3, i, t3, r3));
            }
            return e28;
          }
          parseExportSpecifier(t3, e28, s3, r3) {
            return this.eatContextual(93) ? t3.exported = this.parseModuleExportName() : e28 ? t3.exported = On2(t3.local) : t3.exported || (t3.exported = Fe2(t3.local)), this.finishNode(t3, "ExportSpecifier");
          }
          parseModuleExportName() {
            if (this.match(131)) {
              let t3 = this.parseStringLiteral(this.state.value), e28 = t3.value.match(po2);
              return e28 && this.raise(p3.ModuleExportNameHasLoneSurrogate, { at: t3, surrogateCharCode: e28[0].charCodeAt(0) }), t3;
            }
            return this.parseIdentifier(true);
          }
          isJSONModuleImport(t3) {
            return t3.assertions != null ? t3.assertions.some((e28) => {
              let { key: s3, value: r3 } = e28;
              return r3.value === "json" && (s3.type === "Identifier" ? s3.name === "type" : s3.value === "type");
            }) : false;
          }
          checkImportReflection(t3) {
            if (t3.module) {
              var e28;
              (t3.specifiers.length !== 1 || t3.specifiers[0].type !== "ImportDefaultSpecifier") && this.raise(p3.ImportReflectionNotBinding, { at: t3.specifiers[0].loc.start }), ((e28 = t3.assertions) == null ? void 0 : e28.length) > 0 && this.raise(p3.ImportReflectionHasAssertion, { at: t3.specifiers[0].loc.start });
            }
          }
          checkJSONModuleImport(t3) {
            if (this.isJSONModuleImport(t3) && t3.type !== "ExportAllDeclaration") {
              let { specifiers: e28 } = t3;
              if (e28 != null) {
                let s3 = e28.find((r3) => {
                  let i;
                  if (r3.type === "ExportSpecifier" ? i = r3.local : r3.type === "ImportSpecifier" && (i = r3.imported), i !== void 0)
                    return i.type === "Identifier" ? i.name !== "default" : i.value !== "default";
                });
                s3 !== void 0 && this.raise(p3.ImportJSONBindingNotDefault, { at: s3.loc.start });
              }
            }
          }
          parseMaybeImportReflection(t3) {
            let e28 = false;
            if (this.isContextual(125)) {
              let s3 = this.lookahead(), r3 = s3.type;
              te2(r3) ? (r3 !== 97 || this.input.charCodeAt(this.nextTokenStartSince(s3.end)) === 102) && (e28 = true) : r3 !== 12 && (e28 = true);
            }
            e28 ? (this.expectPlugin("importReflection"), this.next(), t3.module = true) : this.hasPlugin("importReflection") && (t3.module = false);
          }
          parseImport(t3) {
            if (t3.specifiers = [], !this.match(131)) {
              this.parseMaybeImportReflection(t3);
              let s3 = !this.maybeParseDefaultImportSpecifier(t3) || this.eat(12), r3 = s3 && this.maybeParseStarImportSpecifier(t3);
              s3 && !r3 && this.parseNamedImportSpecifiers(t3), this.expectContextual(97);
            }
            t3.source = this.parseImportSource();
            let e28 = this.maybeParseImportAssertions();
            if (e28)
              t3.assertions = e28;
            else {
              let s3 = this.maybeParseModuleAttributes();
              s3 && (t3.attributes = s3);
            }
            return this.checkImportReflection(t3), this.checkJSONModuleImport(t3), this.semicolon(), this.finishNode(t3, "ImportDeclaration");
          }
          parseImportSource() {
            return this.match(131) || this.unexpected(), this.parseExprAtom();
          }
          shouldParseDefaultImport(t3) {
            return te2(this.state.type);
          }
          parseImportSpecifierLocal(t3, e28, s3) {
            e28.local = this.parseIdentifier(), t3.specifiers.push(this.finishImportSpecifier(e28, s3));
          }
          finishImportSpecifier(t3, e28) {
            let s3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Qe2;
            return this.checkLVal(t3.local, { in: { type: e28 }, binding: s3 }), this.finishNode(t3, e28);
          }
          parseAssertEntries() {
            let t3 = [], e28 = /* @__PURE__ */ new Set();
            do {
              if (this.match(8))
                break;
              let s3 = this.startNode(), r3 = this.state.value;
              if (e28.has(r3) && this.raise(p3.ModuleAttributesWithDuplicateKeys, { at: this.state.startLoc, key: r3 }), e28.add(r3), this.match(131) ? s3.key = this.parseStringLiteral(r3) : s3.key = this.parseIdentifier(true), this.expect(14), !this.match(131))
                throw this.raise(p3.ModuleAttributeInvalidValue, { at: this.state.startLoc });
              s3.value = this.parseStringLiteral(this.state.value), t3.push(this.finishNode(s3, "ImportAttribute"));
            } while (this.eat(12));
            return t3;
          }
          maybeParseModuleAttributes() {
            if (this.match(76) && !this.hasPrecedingLineBreak())
              this.expectPlugin("moduleAttributes"), this.next();
            else
              return this.hasPlugin("moduleAttributes") ? [] : null;
            let t3 = [], e28 = /* @__PURE__ */ new Set();
            do {
              let s3 = this.startNode();
              if (s3.key = this.parseIdentifier(true), s3.key.name !== "type" && this.raise(p3.ModuleAttributeDifferentFromType, { at: s3.key }), e28.has(s3.key.name) && this.raise(p3.ModuleAttributesWithDuplicateKeys, { at: s3.key, key: s3.key.name }), e28.add(s3.key.name), this.expect(14), !this.match(131))
                throw this.raise(p3.ModuleAttributeInvalidValue, { at: this.state.startLoc });
              s3.value = this.parseStringLiteral(this.state.value), this.finishNode(s3, "ImportAttribute"), t3.push(s3);
            } while (this.eat(12));
            return t3;
          }
          maybeParseImportAssertions() {
            if (this.isContextual(94) && !this.hasPrecedingLineBreak())
              this.expectPlugin("importAssertions"), this.next();
            else
              return this.hasPlugin("importAssertions") ? [] : null;
            this.eat(5);
            let t3 = this.parseAssertEntries();
            return this.eat(8), t3;
          }
          maybeParseDefaultImportSpecifier(t3) {
            return this.shouldParseDefaultImport(t3) ? (this.parseImportSpecifierLocal(t3, this.startNode(), "ImportDefaultSpecifier"), true) : false;
          }
          maybeParseStarImportSpecifier(t3) {
            if (this.match(55)) {
              let e28 = this.startNode();
              return this.next(), this.expectContextual(93), this.parseImportSpecifierLocal(t3, e28, "ImportNamespaceSpecifier"), true;
            }
            return false;
          }
          parseNamedImportSpecifiers(t3) {
            let e28 = true;
            for (this.expect(5); !this.eat(8); ) {
              if (e28)
                e28 = false;
              else {
                if (this.eat(14))
                  throw this.raise(p3.DestructureNamedImport, { at: this.state.startLoc });
                if (this.expect(12), this.eat(8))
                  break;
              }
              let s3 = this.startNode(), r3 = this.match(131), i = this.isContextual(128);
              s3.imported = this.parseModuleExportName();
              let a3 = this.parseImportSpecifier(s3, r3, t3.importKind === "type" || t3.importKind === "typeof", i, void 0);
              t3.specifiers.push(a3);
            }
          }
          parseImportSpecifier(t3, e28, s3, r3, i) {
            if (this.eatContextual(93))
              t3.local = this.parseIdentifier();
            else {
              let { imported: a3 } = t3;
              if (e28)
                throw this.raise(p3.ImportBindingIsString, { at: t3, importName: a3.value });
              this.checkReservedWord(a3.name, t3.loc.start, true, true), t3.local || (t3.local = Fe2(a3));
            }
            return this.finishImportSpecifier(t3, "ImportSpecifier", i);
          }
          isThisParam(t3) {
            return t3.type === "Identifier" && t3.name === "this";
          }
        }, Xr2 = class extends co2 {
          constructor(t3, e28) {
            t3 = I3(t3), super(t3, e28), this.options = t3, this.initializeScopes(), this.plugins = mo2(this.options.plugins), this.filename = t3.sourceFilename;
          }
          getScopeHandler() {
            return cs2;
          }
          parse() {
            this.enterInitialScopes();
            let t3 = this.startNode(), e28 = this.startNode();
            return this.nextToken(), t3.errors = null, this.parseTopLevel(t3, e28), t3.errors = this.state.errors, t3;
          }
        };
        function mo2(t3) {
          let e28 = /* @__PURE__ */ new Map();
          for (let s3 of t3) {
            let [r3, i] = Array.isArray(s3) ? s3 : [s3, {}];
            e28.has(r3) || e28.set(r3, i || {});
          }
          return e28;
        }
        function fo2(t3, e28) {
          var s3;
          if (((s3 = e28) == null ? void 0 : s3.sourceType) === "unambiguous") {
            e28 = Object.assign({}, e28);
            try {
              e28.sourceType = "module";
              let r3 = pt2(e28, t3), i = r3.parse();
              if (r3.sawUnambiguousESM)
                return i;
              if (r3.ambiguousScriptDifferentAst)
                try {
                  return e28.sourceType = "script", pt2(e28, t3).parse();
                } catch {
                }
              else
                i.program.sourceType = "script";
              return i;
            } catch (r3) {
              try {
                return e28.sourceType = "script", pt2(e28, t3).parse();
              } catch {
              }
              throw r3;
            }
          } else
            return pt2(e28, t3).parse();
        }
        function yo2(t3, e28) {
          let s3 = pt2(e28, t3);
          return s3.options.strictMode && (s3.state.strict = true), s3.getExpression();
        }
        function xo2(t3) {
          let e28 = {};
          for (let s3 of Object.keys(t3))
            e28[s3] = Ie2(t3[s3]);
          return e28;
        }
        var go2 = xo2(ge2);
        function pt2(t3, e28) {
          let s3 = Xr2;
          return t3 != null && t3.plugins && (no2(t3.plugins), s3 = Po2(t3.plugins)), new s3(t3, e28);
        }
        var Gr2 = {};
        function Po2(t3) {
          let e28 = oo2.filter((i) => me2(t3, i)), s3 = e28.join("/"), r3 = Gr2[s3];
          if (!r3) {
            r3 = Xr2;
            for (let i of e28)
              r3 = Jr2[i](r3);
            Gr2[s3] = r3;
          }
          return r3;
        }
        L3.parse = fo2, L3.parseExpression = yo2, L3.tokTypes = go2;
      } }), aa2 = P3({ "src/language-js/parse/json.js"(L3, N3) {
        S3();
        var I3 = Gs2(), A3 = Xt2(), g3 = Qs2(), E3 = Zs2();
        function y3() {
          let z3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, { allowComments: W3 = true } = z3;
          return function(C3) {
            let { parseExpression: Z3 } = er2(), le2;
            try {
              le2 = Z3(C3, { tokens: true, ranges: true });
            } catch (H3) {
              throw E3(H3);
            }
            if (!W3 && I3(le2.comments))
              throw O3(le2.comments[0], "Comment");
            return V10(le2), le2;
          };
        }
        function O3(z3, W3) {
          let [C3, Z3] = [z3.loc.start, z3.loc.end].map((le2) => {
            let { line: H3, column: Y3 } = le2;
            return { line: H3, column: Y3 + 1 };
          });
          return A3(`${W3} is not allowed in JSON.`, { start: C3, end: Z3 });
        }
        function V10(z3) {
          switch (z3.type) {
            case "ArrayExpression":
              for (let W3 of z3.elements)
                W3 !== null && V10(W3);
              return;
            case "ObjectExpression":
              for (let W3 of z3.properties)
                V10(W3);
              return;
            case "ObjectProperty":
              if (z3.computed)
                throw O3(z3.key, "Computed key");
              if (z3.shorthand)
                throw O3(z3.key, "Shorthand property");
              z3.key.type !== "Identifier" && V10(z3.key), V10(z3.value);
              return;
            case "UnaryExpression": {
              let { operator: W3, argument: C3 } = z3;
              if (W3 !== "+" && W3 !== "-")
                throw O3(z3, `Operator '${z3.operator}'`);
              if (C3.type === "NumericLiteral" || C3.type === "Identifier" && (C3.name === "Infinity" || C3.name === "NaN"))
                return;
              throw O3(C3, `Operator '${W3}' before '${C3.type}'`);
            }
            case "Identifier":
              if (z3.name !== "Infinity" && z3.name !== "NaN" && z3.name !== "undefined")
                throw O3(z3, `Identifier '${z3.name}'`);
              return;
            case "TemplateLiteral":
              if (I3(z3.expressions))
                throw O3(z3.expressions[0], "'TemplateLiteral' with expression");
              for (let W3 of z3.quasis)
                V10(W3);
              return;
            case "NullLiteral":
            case "BooleanLiteral":
            case "NumericLiteral":
            case "StringLiteral":
            case "TemplateElement":
              return;
            default:
              throw O3(z3, `'${z3.type}'`);
          }
        }
        var X3 = y3(), Q3 = { json: g3({ parse: X3, hasPragma() {
          return true;
        } }), json5: g3(X3), "json-stringify": g3({ parse: y3({ allowComments: false }), astFormat: "estree-json" }) };
        N3.exports = Q3;
      } });
      S3();
      var na2 = U3(), oa2 = _3(), ha2 = ae2(), Ke2 = Qs2(), la2 = Zs2(), pa2 = ia2(), ua2 = aa2(), ca2 = { sourceType: "module", allowImportExportEverywhere: true, allowReturnOutsideFunction: true, allowSuperOutsideMethod: true, allowUndeclaredExports: true, errorRecovery: true, createParenthesizedExpressions: true, plugins: ["doExpressions", "exportDefaultFrom", "functionBind", "functionSent", "throwExpressions", "partialApplication", ["decorators", { decoratorsBeforeExport: false }], "importAssertions", "decimal", "moduleBlocks", "asyncDoExpressions", "regexpUnicodeSets", "destructuringPrivate", "decoratorAutoAccessors"], tokens: true, ranges: true }, da2 = ["recordAndTuple", { syntaxType: "hash" }], tr2 = "v8intrinsic", sr2 = [["pipelineOperator", { proposal: "hack", topicToken: "%" }], ["pipelineOperator", { proposal: "minimal" }], ["pipelineOperator", { proposal: "fsharp" }]], ve2 = function(L3) {
        let N3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ca2;
        return Object.assign(Object.assign({}, N3), {}, { plugins: [...N3.plugins, ...L3] });
      }, ma2 = /@(?:no)?flow\b/;
      function fa2(L3, N3) {
        if (N3.filepath && N3.filepath.endsWith(".js.flow"))
          return true;
        let I3 = oa2(L3);
        I3 && (L3 = L3.slice(I3.length));
        let A3 = ha2(L3, 0);
        return A3 !== false && (L3 = L3.slice(0, A3)), ma2.test(L3);
      }
      function ya2(L3, N3, I3) {
        let A3 = er2()[L3], g3 = A3(N3, I3), E3 = g3.errors.find((y3) => !Ta2.has(y3.reasonCode));
        if (E3)
          throw E3;
        return g3;
      }
      function We2(L3) {
        for (var N3 = arguments.length, I3 = new Array(N3 > 1 ? N3 - 1 : 0), A3 = 1; A3 < N3; A3++)
          I3[A3 - 1] = arguments[A3];
        return function(g3, E3) {
          let y3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          if ((y3.parser === "babel" || y3.parser === "__babel_estree") && fa2(g3, y3))
            return y3.parser = "babel-flow", rr2(g3, E3, y3);
          let O3 = I3;
          y3.__babelSourceType === "script" && (O3 = O3.map((z3) => Object.assign(Object.assign({}, z3), {}, { sourceType: "script" }))), /#[[{]/.test(g3) && (O3 = O3.map((z3) => ve2([da2], z3)));
          let V10 = /%[A-Z]/.test(g3);
          g3.includes("|>") ? O3 = (V10 ? [...sr2, tr2] : sr2).flatMap((z3) => O3.map((W3) => ve2([z3], W3))) : V10 && (O3 = O3.map((z3) => ve2([tr2], z3)));
          let { result: X3, error: Q3 } = na2(...O3.map((z3) => () => ya2(L3, g3, z3)));
          if (!X3)
            throw la2(Q3);
          return y3.originalText = g3, pa2(X3, y3);
        };
      }
      var xa2 = We2("parse", ve2(["jsx", "flow"])), rr2 = We2("parse", ve2(["jsx", ["flow", { all: true, enums: true }]])), ga2 = We2("parse", ve2(["jsx", "typescript"]), ve2(["typescript"])), Pa2 = We2("parse", ve2(["jsx", "flow", "estree"])), Aa2 = We2("parseExpression", ve2(["jsx"])), ba2 = We2("parseExpression", ve2(["typescript"])), Ta2 = /* @__PURE__ */ new Set(["StrictNumericEscape", "StrictWith", "StrictOctalLiteral", "StrictDelete", "StrictEvalArguments", "StrictEvalArgumentsBinding", "StrictFunction", "EmptyTypeArguments", "EmptyTypeParameters", "ConstructorHasTypeParameters", "UnsupportedParameterPropertyKind", "UnexpectedParameterModifier", "MixedLabeledAndUnlabeledElements", "InvalidTupleMemberLabel", "NonClassMethodPropertyHasAbstractModifer", "ReadonlyForMethodSignature", "ClassMethodHasDeclare", "ClassMethodHasReadonly", "InvalidModifierOnTypeMember", "DuplicateAccessibilityModifier", "IndexSignatureHasDeclare", "DecoratorExportClass", "ParamDupe", "InvalidDecimal", "RestTrailingComma", "UnsupportedParameterDecorator", "UnterminatedJsxContent", "UnexpectedReservedWord", "ModuleAttributesWithDuplicateKeys", "LineTerminatorBeforeArrow", "InvalidEscapeSequenceTemplate", "NonAbstractClassHasAbstractMethod", "UnsupportedPropertyDecorator", "OptionalTypeBeforeRequired", "PatternIsOptional", "OptionalBindingPattern", "DeclareClassFieldHasInitializer", "TypeImportCannotSpecifyDefaultAndNamed", "DeclareFunctionHasImplementation", "ConstructorClassField", "VarRedeclaration", "InvalidPrivateFieldResolution", "DuplicateExport"]), ir2 = Ke2(xa2), ar2 = Ke2(ga2), nr2 = Ke2(Aa2), Ea2 = Ke2(ba2);
      d3.exports = { parsers: Object.assign(Object.assign({ babel: ir2, "babel-flow": Ke2(rr2), "babel-ts": ar2 }, ua2), {}, { __js_expression: nr2, __vue_expression: nr2, __vue_ts_expression: Ea2, __vue_event_binding: ir2, __vue_ts_event_binding: ar2, __babel_estree: Ke2(Pa2) }) };
    });
    return $i2();
  });
})(e$X);
var bo$1 = e$X.exports;
const vo$2 = /* @__PURE__ */ l$Y(bo$1);
var r$U = { exports: {} };
(function(Ju2, $r2) {
  (function(P3) {
    Ju2.exports = P3();
  })(function() {
    var P3 = (N3, c3) => () => (c3 || N3((c3 = { exports: {} }).exports, c3), c3.exports), ve2 = P3((N3, c3) => {
      var l3 = function(d3) {
        return d3 && d3.Math == Math && d3;
      };
      c3.exports = l3(typeof globalThis == "object" && globalThis) || l3(typeof window == "object" && window) || l3(typeof self == "object" && self) || l3(typeof o$R == "object" && o$R) || function() {
        return this;
      }() || Function("return this")();
    }), ye2 = P3((N3, c3) => {
      c3.exports = function(l3) {
        try {
          return !!l3();
        } catch {
          return true;
        }
      };
    }), we2 = P3((N3, c3) => {
      var l3 = ye2();
      c3.exports = !l3(function() {
        return Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1] != 7;
      });
    }), eu2 = P3((N3, c3) => {
      var l3 = ye2();
      c3.exports = !l3(function() {
        var d3 = function() {
        }.bind();
        return typeof d3 != "function" || d3.hasOwnProperty("prototype");
      });
    }), Oe2 = P3((N3, c3) => {
      var l3 = eu2(), d3 = Function.prototype.call;
      c3.exports = l3 ? d3.bind(d3) : function() {
        return d3.apply(d3, arguments);
      };
    }), Ku2 = P3((N3) => {
      var c3 = {}.propertyIsEnumerable, l3 = Object.getOwnPropertyDescriptor, d3 = l3 && !c3.call({ 1: 2 }, 1);
      N3.f = d3 ? function(h3) {
        var g3 = l3(this, h3);
        return !!g3 && g3.enumerable;
      } : c3;
    }), uu2 = P3((N3, c3) => {
      c3.exports = function(l3, d3) {
        return { enumerable: !(l3 & 1), configurable: !(l3 & 2), writable: !(l3 & 4), value: d3 };
      };
    }), Te2 = P3((N3, c3) => {
      var l3 = eu2(), d3 = Function.prototype, h3 = d3.call, g3 = l3 && d3.bind.bind(h3, h3);
      c3.exports = l3 ? g3 : function(_3) {
        return function() {
          return h3.apply(_3, arguments);
        };
      };
    }), Ue2 = P3((N3, c3) => {
      var l3 = Te2(), d3 = l3({}.toString), h3 = l3("".slice);
      c3.exports = function(g3) {
        return h3(d3(g3), 8, -1);
      };
    }), Zu2 = P3((N3, c3) => {
      var l3 = Te2(), d3 = ye2(), h3 = Ue2(), g3 = Object, _3 = l3("".split);
      c3.exports = d3(function() {
        return !g3("z").propertyIsEnumerable(0);
      }) ? function(w3) {
        return h3(w3) == "String" ? _3(w3, "") : g3(w3);
      } : g3;
    }), tu2 = P3((N3, c3) => {
      c3.exports = function(l3) {
        return l3 == null;
      };
    }), hu2 = P3((N3, c3) => {
      var l3 = tu2(), d3 = TypeError;
      c3.exports = function(h3) {
        if (l3(h3))
          throw d3("Can't call method on " + h3);
        return h3;
      };
    }), ru2 = P3((N3, c3) => {
      var l3 = Zu2(), d3 = hu2();
      c3.exports = function(h3) {
        return l3(d3(h3));
      };
    }), du2 = P3((N3, c3) => {
      var l3 = typeof document == "object" && document.all, d3 = typeof l3 > "u" && l3 !== void 0;
      c3.exports = { all: l3, IS_HTMLDDA: d3 };
    }), Ee2 = P3((N3, c3) => {
      var l3 = du2(), d3 = l3.all;
      c3.exports = l3.IS_HTMLDDA ? function(h3) {
        return typeof h3 == "function" || h3 === d3;
      } : function(h3) {
        return typeof h3 == "function";
      };
    }), Pe2 = P3((N3, c3) => {
      var l3 = Ee2(), d3 = du2(), h3 = d3.all;
      c3.exports = d3.IS_HTMLDDA ? function(g3) {
        return typeof g3 == "object" ? g3 !== null : l3(g3) || g3 === h3;
      } : function(g3) {
        return typeof g3 == "object" ? g3 !== null : l3(g3);
      };
    }), Ve2 = P3((N3, c3) => {
      var l3 = ve2(), d3 = Ee2(), h3 = function(g3) {
        return d3(g3) ? g3 : void 0;
      };
      c3.exports = function(g3, _3) {
        return arguments.length < 2 ? h3(l3[g3]) : l3[g3] && l3[g3][_3];
      };
    }), Cu2 = P3((N3, c3) => {
      var l3 = Te2();
      c3.exports = l3({}.isPrototypeOf);
    }), et2 = P3((N3, c3) => {
      var l3 = Ve2();
      c3.exports = l3("navigator", "userAgent") || "";
    }), ut2 = P3((N3, c3) => {
      var l3 = ve2(), d3 = et2(), h3 = l3.process, g3 = l3.Deno, _3 = h3 && h3.versions || g3 && g3.version, w3 = _3 && _3.v8, y3, x3;
      w3 && (y3 = w3.split("."), x3 = y3[0] > 0 && y3[0] < 4 ? 1 : +(y3[0] + y3[1])), !x3 && d3 && (y3 = d3.match(/Edge\/(\d+)/), (!y3 || y3[1] >= 74) && (y3 = d3.match(/Chrome\/(\d+)/), y3 && (x3 = +y3[1]))), c3.exports = x3;
    }), Eu2 = P3((N3, c3) => {
      var l3 = ut2(), d3 = ye2();
      c3.exports = !!Object.getOwnPropertySymbols && !d3(function() {
        var h3 = Symbol();
        return !String(h3) || !(Object(h3) instanceof Symbol) || !Symbol.sham && l3 && l3 < 41;
      });
    }), mu2 = P3((N3, c3) => {
      var l3 = Eu2();
      c3.exports = l3 && !Symbol.sham && typeof Symbol.iterator == "symbol";
    }), fu2 = P3((N3, c3) => {
      var l3 = Ve2(), d3 = Ee2(), h3 = Cu2(), g3 = mu2(), _3 = Object;
      c3.exports = g3 ? function(w3) {
        return typeof w3 == "symbol";
      } : function(w3) {
        var y3 = l3("Symbol");
        return d3(y3) && h3(y3.prototype, _3(w3));
      };
    }), nu2 = P3((N3, c3) => {
      var l3 = String;
      c3.exports = function(d3) {
        try {
          return l3(d3);
        } catch {
          return "Object";
        }
      };
    }), Ge2 = P3((N3, c3) => {
      var l3 = Ee2(), d3 = nu2(), h3 = TypeError;
      c3.exports = function(g3) {
        if (l3(g3))
          return g3;
        throw h3(d3(g3) + " is not a function");
      };
    }), su2 = P3((N3, c3) => {
      var l3 = Ge2(), d3 = tu2();
      c3.exports = function(h3, g3) {
        var _3 = h3[g3];
        return d3(_3) ? void 0 : l3(_3);
      };
    }), tt2 = P3((N3, c3) => {
      var l3 = Oe2(), d3 = Ee2(), h3 = Pe2(), g3 = TypeError;
      c3.exports = function(_3, w3) {
        var y3, x3;
        if (w3 === "string" && d3(y3 = _3.toString) && !h3(x3 = l3(y3, _3)) || d3(y3 = _3.valueOf) && !h3(x3 = l3(y3, _3)) || w3 !== "string" && d3(y3 = _3.toString) && !h3(x3 = l3(y3, _3)))
          return x3;
        throw g3("Can't convert object to primitive value");
      };
    }), rt2 = P3((N3, c3) => {
      c3.exports = false;
    }), iu2 = P3((N3, c3) => {
      var l3 = ve2(), d3 = Object.defineProperty;
      c3.exports = function(h3, g3) {
        try {
          d3(l3, h3, { value: g3, configurable: true, writable: true });
        } catch {
          l3[h3] = g3;
        }
        return g3;
      };
    }), au2 = P3((N3, c3) => {
      var l3 = ve2(), d3 = iu2(), h3 = "__core-js_shared__", g3 = l3[h3] || d3(h3, {});
      c3.exports = g3;
    }), gu2 = P3((N3, c3) => {
      var l3 = rt2(), d3 = au2();
      (c3.exports = function(h3, g3) {
        return d3[h3] || (d3[h3] = g3 !== void 0 ? g3 : {});
      })("versions", []).push({ version: "3.26.1", mode: l3 ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE", source: "https://github.com/zloirock/core-js" });
    }), Fu2 = P3((N3, c3) => {
      var l3 = hu2(), d3 = Object;
      c3.exports = function(h3) {
        return d3(l3(h3));
      };
    }), xe2 = P3((N3, c3) => {
      var l3 = Te2(), d3 = Fu2(), h3 = l3({}.hasOwnProperty);
      c3.exports = Object.hasOwn || function(g3, _3) {
        return h3(d3(g3), _3);
      };
    }), Au2 = P3((N3, c3) => {
      var l3 = Te2(), d3 = 0, h3 = Math.random(), g3 = l3(1 .toString);
      c3.exports = function(_3) {
        return "Symbol(" + (_3 === void 0 ? "" : _3) + ")_" + g3(++d3 + h3, 36);
      };
    }), Re2 = P3((N3, c3) => {
      var l3 = ve2(), d3 = gu2(), h3 = xe2(), g3 = Au2(), _3 = Eu2(), w3 = mu2(), y3 = d3("wks"), x3 = l3.Symbol, M3 = x3 && x3.for, q3 = w3 ? x3 : x3 && x3.withoutSetter || g3;
      c3.exports = function(S3) {
        if (!h3(y3, S3) || !(_3 || typeof y3[S3] == "string")) {
          var U3 = "Symbol." + S3;
          _3 && h3(x3, S3) ? y3[S3] = x3[S3] : w3 && M3 ? y3[S3] = M3(U3) : y3[S3] = q3(U3);
        }
        return y3[S3];
      };
    }), nt2 = P3((N3, c3) => {
      var l3 = Oe2(), d3 = Pe2(), h3 = fu2(), g3 = su2(), _3 = tt2(), w3 = Re2(), y3 = TypeError, x3 = w3("toPrimitive");
      c3.exports = function(M3, q3) {
        if (!d3(M3) || h3(M3))
          return M3;
        var S3 = g3(M3, x3), U3;
        if (S3) {
          if (q3 === void 0 && (q3 = "default"), U3 = l3(S3, M3, q3), !d3(U3) || h3(U3))
            return U3;
          throw y3("Can't convert object to primitive value");
        }
        return q3 === void 0 && (q3 = "number"), _3(M3, q3);
      };
    }), ou2 = P3((N3, c3) => {
      var l3 = nt2(), d3 = fu2();
      c3.exports = function(h3) {
        var g3 = l3(h3, "string");
        return d3(g3) ? g3 : g3 + "";
      };
    }), st2 = P3((N3, c3) => {
      var l3 = ve2(), d3 = Pe2(), h3 = l3.document, g3 = d3(h3) && d3(h3.createElement);
      c3.exports = function(_3) {
        return g3 ? h3.createElement(_3) : {};
      };
    }), vu2 = P3((N3, c3) => {
      var l3 = we2(), d3 = ye2(), h3 = st2();
      c3.exports = !l3 && !d3(function() {
        return Object.defineProperty(h3("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }), Tu2 = P3((N3) => {
      var c3 = we2(), l3 = Oe2(), d3 = Ku2(), h3 = uu2(), g3 = ru2(), _3 = ou2(), w3 = xe2(), y3 = vu2(), x3 = Object.getOwnPropertyDescriptor;
      N3.f = c3 ? x3 : function(M3, q3) {
        if (M3 = g3(M3), q3 = _3(q3), y3)
          try {
            return x3(M3, q3);
          } catch {
          }
        if (w3(M3, q3))
          return h3(!l3(d3.f, M3, q3), M3[q3]);
      };
    }), it2 = P3((N3, c3) => {
      var l3 = we2(), d3 = ye2();
      c3.exports = l3 && d3(function() {
        return Object.defineProperty(function() {
        }, "prototype", { value: 42, writable: false }).prototype != 42;
      });
    }), Le2 = P3((N3, c3) => {
      var l3 = Pe2(), d3 = String, h3 = TypeError;
      c3.exports = function(g3) {
        if (l3(g3))
          return g3;
        throw h3(d3(g3) + " is not an object");
      };
    }), Xe2 = P3((N3) => {
      var c3 = we2(), l3 = vu2(), d3 = it2(), h3 = Le2(), g3 = ou2(), _3 = TypeError, w3 = Object.defineProperty, y3 = Object.getOwnPropertyDescriptor, x3 = "enumerable", M3 = "configurable", q3 = "writable";
      N3.f = c3 ? d3 ? function(S3, U3, J3) {
        if (h3(S3), U3 = g3(U3), h3(J3), typeof S3 == "function" && U3 === "prototype" && "value" in J3 && q3 in J3 && !J3[q3]) {
          var H3 = y3(S3, U3);
          H3 && H3[q3] && (S3[U3] = J3.value, J3 = { configurable: M3 in J3 ? J3[M3] : H3[M3], enumerable: x3 in J3 ? J3[x3] : H3[x3], writable: false });
        }
        return w3(S3, U3, J3);
      } : w3 : function(S3, U3, J3) {
        if (h3(S3), U3 = g3(U3), h3(J3), l3)
          try {
            return w3(S3, U3, J3);
          } catch {
          }
        if ("get" in J3 || "set" in J3)
          throw _3("Accessors not supported");
        return "value" in J3 && (S3[U3] = J3.value), S3;
      };
    }), _u2 = P3((N3, c3) => {
      var l3 = we2(), d3 = Xe2(), h3 = uu2();
      c3.exports = l3 ? function(g3, _3, w3) {
        return d3.f(g3, _3, h3(1, w3));
      } : function(g3, _3, w3) {
        return g3[_3] = w3, g3;
      };
    }), at2 = P3((N3, c3) => {
      var l3 = we2(), d3 = xe2(), h3 = Function.prototype, g3 = l3 && Object.getOwnPropertyDescriptor, _3 = d3(h3, "name"), w3 = _3 && function() {
      }.name === "something", y3 = _3 && (!l3 || l3 && g3(h3, "name").configurable);
      c3.exports = { EXISTS: _3, PROPER: w3, CONFIGURABLE: y3 };
    }), Su2 = P3((N3, c3) => {
      var l3 = Te2(), d3 = Ee2(), h3 = au2(), g3 = l3(Function.toString);
      d3(h3.inspectSource) || (h3.inspectSource = function(_3) {
        return g3(_3);
      }), c3.exports = h3.inspectSource;
    }), ot2 = P3((N3, c3) => {
      var l3 = ve2(), d3 = Ee2(), h3 = l3.WeakMap;
      c3.exports = d3(h3) && /native code/.test(String(h3));
    }), Dt2 = P3((N3, c3) => {
      var l3 = gu2(), d3 = Au2(), h3 = l3("keys");
      c3.exports = function(g3) {
        return h3[g3] || (h3[g3] = d3(g3));
      };
    }), yu2 = P3((N3, c3) => {
      c3.exports = {};
    }), lt2 = P3((N3, c3) => {
      var l3 = ot2(), d3 = ve2(), h3 = Pe2(), g3 = _u2(), _3 = xe2(), w3 = au2(), y3 = Dt2(), x3 = yu2(), M3 = "Object already initialized", q3 = d3.TypeError, S3 = d3.WeakMap, U3, J3, H3, Y3 = function(ne2) {
        return H3(ne2) ? J3(ne2) : U3(ne2, {});
      }, Z3 = function(ne2) {
        return function(ce2) {
          var Ne2;
          if (!h3(ce2) || (Ne2 = J3(ce2)).type !== ne2)
            throw q3("Incompatible receiver, " + ne2 + " required");
          return Ne2;
        };
      };
      l3 || w3.state ? (R3 = w3.state || (w3.state = new S3()), R3.get = R3.get, R3.has = R3.has, R3.set = R3.set, U3 = function(ne2, ce2) {
        if (R3.has(ne2))
          throw q3(M3);
        return ce2.facade = ne2, R3.set(ne2, ce2), ce2;
      }, J3 = function(ne2) {
        return R3.get(ne2) || {};
      }, H3 = function(ne2) {
        return R3.has(ne2);
      }) : (De2 = y3("state"), x3[De2] = true, U3 = function(ne2, ce2) {
        if (_3(ne2, De2))
          throw q3(M3);
        return ce2.facade = ne2, g3(ne2, De2, ce2), ce2;
      }, J3 = function(ne2) {
        return _3(ne2, De2) ? ne2[De2] : {};
      }, H3 = function(ne2) {
        return _3(ne2, De2);
      });
      var R3, De2;
      c3.exports = { set: U3, get: J3, has: H3, enforce: Y3, getterFor: Z3 };
    }), ct2 = P3((N3, c3) => {
      var l3 = ye2(), d3 = Ee2(), h3 = xe2(), g3 = we2(), _3 = at2().CONFIGURABLE, w3 = Su2(), y3 = lt2(), x3 = y3.enforce, M3 = y3.get, q3 = Object.defineProperty, S3 = g3 && !l3(function() {
        return q3(function() {
        }, "length", { value: 8 }).length !== 8;
      }), U3 = String(String).split("String"), J3 = c3.exports = function(H3, Y3, Z3) {
        String(Y3).slice(0, 7) === "Symbol(" && (Y3 = "[" + String(Y3).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), Z3 && Z3.getter && (Y3 = "get " + Y3), Z3 && Z3.setter && (Y3 = "set " + Y3), (!h3(H3, "name") || _3 && H3.name !== Y3) && (g3 ? q3(H3, "name", { value: Y3, configurable: true }) : H3.name = Y3), S3 && Z3 && h3(Z3, "arity") && H3.length !== Z3.arity && q3(H3, "length", { value: Z3.arity });
        try {
          Z3 && h3(Z3, "constructor") && Z3.constructor ? g3 && q3(H3, "prototype", { writable: false }) : H3.prototype && (H3.prototype = void 0);
        } catch {
        }
        var R3 = x3(H3);
        return h3(R3, "source") || (R3.source = U3.join(typeof Y3 == "string" ? Y3 : "")), H3;
      };
      Function.prototype.toString = J3(function() {
        return d3(this) && M3(this).source || w3(this);
      }, "toString");
    }), pt2 = P3((N3, c3) => {
      var l3 = Ee2(), d3 = Xe2(), h3 = ct2(), g3 = iu2();
      c3.exports = function(_3, w3, y3, x3) {
        x3 || (x3 = {});
        var M3 = x3.enumerable, q3 = x3.name !== void 0 ? x3.name : w3;
        if (l3(y3) && h3(y3, q3, x3), x3.global)
          M3 ? _3[w3] = y3 : g3(w3, y3);
        else {
          try {
            x3.unsafe ? _3[w3] && (M3 = true) : delete _3[w3];
          } catch {
          }
          M3 ? _3[w3] = y3 : d3.f(_3, w3, { value: y3, enumerable: false, configurable: !x3.nonConfigurable, writable: !x3.nonWritable });
        }
        return _3;
      };
    }), ht2 = P3((N3, c3) => {
      var l3 = Math.ceil, d3 = Math.floor;
      c3.exports = Math.trunc || function(h3) {
        var g3 = +h3;
        return (g3 > 0 ? d3 : l3)(g3);
      };
    }), Bu2 = P3((N3, c3) => {
      var l3 = ht2();
      c3.exports = function(d3) {
        var h3 = +d3;
        return h3 !== h3 || h3 === 0 ? 0 : l3(h3);
      };
    }), dt2 = P3((N3, c3) => {
      var l3 = Bu2(), d3 = Math.max, h3 = Math.min;
      c3.exports = function(g3, _3) {
        var w3 = l3(g3);
        return w3 < 0 ? d3(w3 + _3, 0) : h3(w3, _3);
      };
    }), Ct2 = P3((N3, c3) => {
      var l3 = Bu2(), d3 = Math.min;
      c3.exports = function(h3) {
        return h3 > 0 ? d3(l3(h3), 9007199254740991) : 0;
      };
    }), He2 = P3((N3, c3) => {
      var l3 = Ct2();
      c3.exports = function(d3) {
        return l3(d3.length);
      };
    }), Et2 = P3((N3, c3) => {
      var l3 = ru2(), d3 = dt2(), h3 = He2(), g3 = function(_3) {
        return function(w3, y3, x3) {
          var M3 = l3(w3), q3 = h3(M3), S3 = d3(x3, q3), U3;
          if (_3 && y3 != y3) {
            for (; q3 > S3; )
              if (U3 = M3[S3++], U3 != U3)
                return true;
          } else
            for (; q3 > S3; S3++)
              if ((_3 || S3 in M3) && M3[S3] === y3)
                return _3 || S3 || 0;
          return !_3 && -1;
        };
      };
      c3.exports = { includes: g3(true), indexOf: g3(false) };
    }), mt2 = P3((N3, c3) => {
      var l3 = Te2(), d3 = xe2(), h3 = ru2(), g3 = Et2().indexOf, _3 = yu2(), w3 = l3([].push);
      c3.exports = function(y3, x3) {
        var M3 = h3(y3), q3 = 0, S3 = [], U3;
        for (U3 in M3)
          !d3(_3, U3) && d3(M3, U3) && w3(S3, U3);
        for (; x3.length > q3; )
          d3(M3, U3 = x3[q3++]) && (~g3(S3, U3) || w3(S3, U3));
        return S3;
      };
    }), ft2 = P3((N3, c3) => {
      c3.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    }), gt2 = P3((N3) => {
      var c3 = mt2(), l3 = ft2(), d3 = l3.concat("length", "prototype");
      N3.f = Object.getOwnPropertyNames || function(h3) {
        return c3(h3, d3);
      };
    }), Ft2 = P3((N3) => {
      N3.f = Object.getOwnPropertySymbols;
    }), At2 = P3((N3, c3) => {
      var l3 = Ve2(), d3 = Te2(), h3 = gt2(), g3 = Ft2(), _3 = Le2(), w3 = d3([].concat);
      c3.exports = l3("Reflect", "ownKeys") || function(y3) {
        var x3 = h3.f(_3(y3)), M3 = g3.f;
        return M3 ? w3(x3, M3(y3)) : x3;
      };
    }), vt2 = P3((N3, c3) => {
      var l3 = xe2(), d3 = At2(), h3 = Tu2(), g3 = Xe2();
      c3.exports = function(_3, w3, y3) {
        for (var x3 = d3(w3), M3 = g3.f, q3 = h3.f, S3 = 0; S3 < x3.length; S3++) {
          var U3 = x3[S3];
          !l3(_3, U3) && !(y3 && l3(y3, U3)) && M3(_3, U3, q3(w3, U3));
        }
      };
    }), Tt2 = P3((N3, c3) => {
      var l3 = ye2(), d3 = Ee2(), h3 = /#|\.prototype\./, g3 = function(M3, q3) {
        var S3 = w3[_3(M3)];
        return S3 == x3 ? true : S3 == y3 ? false : d3(q3) ? l3(q3) : !!q3;
      }, _3 = g3.normalize = function(M3) {
        return String(M3).replace(h3, ".").toLowerCase();
      }, w3 = g3.data = {}, y3 = g3.NATIVE = "N", x3 = g3.POLYFILL = "P";
      c3.exports = g3;
    }), Du2 = P3((N3, c3) => {
      var l3 = ve2(), d3 = Tu2().f, h3 = _u2(), g3 = pt2(), _3 = iu2(), w3 = vt2(), y3 = Tt2();
      c3.exports = function(x3, M3) {
        var q3 = x3.target, S3 = x3.global, U3 = x3.stat, J3, H3, Y3, Z3, R3, De2;
        if (S3 ? H3 = l3 : U3 ? H3 = l3[q3] || _3(q3, {}) : H3 = (l3[q3] || {}).prototype, H3)
          for (Y3 in M3) {
            if (R3 = M3[Y3], x3.dontCallGetSet ? (De2 = d3(H3, Y3), Z3 = De2 && De2.value) : Z3 = H3[Y3], J3 = y3(S3 ? Y3 : q3 + (U3 ? "." : "#") + Y3, x3.forced), !J3 && Z3 !== void 0) {
              if (typeof R3 == typeof Z3)
                continue;
              w3(R3, Z3);
            }
            (x3.sham || Z3 && Z3.sham) && h3(R3, "sham", true), g3(H3, Y3, R3, x3);
          }
      };
    }), _t2 = P3(() => {
      var N3 = Du2(), c3 = ve2();
      N3({ global: true, forced: c3.globalThis !== c3 }, { globalThis: c3 });
    }), St2 = P3(() => {
      _t2();
    }), bu2 = P3((N3, c3) => {
      var l3 = Ue2();
      c3.exports = Array.isArray || function(d3) {
        return l3(d3) == "Array";
      };
    }), yt2 = P3((N3, c3) => {
      var l3 = TypeError, d3 = 9007199254740991;
      c3.exports = function(h3) {
        if (h3 > d3)
          throw l3("Maximum allowed index exceeded");
        return h3;
      };
    }), Bt2 = P3((N3, c3) => {
      var l3 = Ue2(), d3 = Te2();
      c3.exports = function(h3) {
        if (l3(h3) === "Function")
          return d3(h3);
      };
    }), wu2 = P3((N3, c3) => {
      var l3 = Bt2(), d3 = Ge2(), h3 = eu2(), g3 = l3(l3.bind);
      c3.exports = function(_3, w3) {
        return d3(_3), w3 === void 0 ? _3 : h3 ? g3(_3, w3) : function() {
          return _3.apply(w3, arguments);
        };
      };
    }), bt2 = P3((N3, c3) => {
      var l3 = bu2(), d3 = He2(), h3 = yt2(), g3 = wu2(), _3 = function(w3, y3, x3, M3, q3, S3, U3, J3) {
        for (var H3 = q3, Y3 = 0, Z3 = U3 ? g3(U3, J3) : false, R3, De2; Y3 < M3; )
          Y3 in x3 && (R3 = Z3 ? Z3(x3[Y3], Y3, y3) : x3[Y3], S3 > 0 && l3(R3) ? (De2 = d3(R3), H3 = _3(w3, y3, R3, De2, H3, S3 - 1) - 1) : (h3(H3 + 1), w3[H3] = R3), H3++), Y3++;
        return H3;
      };
      c3.exports = _3;
    }), wt2 = P3((N3, c3) => {
      var l3 = Re2(), d3 = l3("toStringTag"), h3 = {};
      h3[d3] = "z", c3.exports = String(h3) === "[object z]";
    }), xu2 = P3((N3, c3) => {
      var l3 = wt2(), d3 = Ee2(), h3 = Ue2(), g3 = Re2(), _3 = g3("toStringTag"), w3 = Object, y3 = h3(function() {
        return arguments;
      }()) == "Arguments", x3 = function(M3, q3) {
        try {
          return M3[q3];
        } catch {
        }
      };
      c3.exports = l3 ? h3 : function(M3) {
        var q3, S3, U3;
        return M3 === void 0 ? "Undefined" : M3 === null ? "Null" : typeof (S3 = x3(q3 = w3(M3), _3)) == "string" ? S3 : y3 ? h3(q3) : (U3 = h3(q3)) == "Object" && d3(q3.callee) ? "Arguments" : U3;
      };
    }), xt2 = P3((N3, c3) => {
      var l3 = Te2(), d3 = ye2(), h3 = Ee2(), g3 = xu2(), _3 = Ve2(), w3 = Su2(), y3 = function() {
      }, x3 = [], M3 = _3("Reflect", "construct"), q3 = /^\s*(?:class|function)\b/, S3 = l3(q3.exec), U3 = !q3.exec(y3), J3 = function(Y3) {
        if (!h3(Y3))
          return false;
        try {
          return M3(y3, x3, Y3), true;
        } catch {
          return false;
        }
      }, H3 = function(Y3) {
        if (!h3(Y3))
          return false;
        switch (g3(Y3)) {
          case "AsyncFunction":
          case "GeneratorFunction":
          case "AsyncGeneratorFunction":
            return false;
        }
        try {
          return U3 || !!S3(q3, w3(Y3));
        } catch {
          return true;
        }
      };
      H3.sham = true, c3.exports = !M3 || d3(function() {
        var Y3;
        return J3(J3.call) || !J3(Object) || !J3(function() {
          Y3 = true;
        }) || Y3;
      }) ? H3 : J3;
    }), Nt2 = P3((N3, c3) => {
      var l3 = bu2(), d3 = xt2(), h3 = Pe2(), g3 = Re2(), _3 = g3("species"), w3 = Array;
      c3.exports = function(y3) {
        var x3;
        return l3(y3) && (x3 = y3.constructor, d3(x3) && (x3 === w3 || l3(x3.prototype)) ? x3 = void 0 : h3(x3) && (x3 = x3[_3], x3 === null && (x3 = void 0))), x3 === void 0 ? w3 : x3;
      };
    }), kt2 = P3((N3, c3) => {
      var l3 = Nt2();
      c3.exports = function(d3, h3) {
        return new (l3(d3))(h3 === 0 ? 0 : h3);
      };
    }), Ot2 = P3(() => {
      var N3 = Du2(), c3 = bt2(), l3 = Ge2(), d3 = Fu2(), h3 = He2(), g3 = kt2();
      N3({ target: "Array", proto: true }, { flatMap: function(_3) {
        var w3 = d3(this), y3 = h3(w3), x3;
        return l3(_3), x3 = g3(w3, 0), x3.length = c3(x3, w3, w3, y3, 0, 1, _3, arguments.length > 1 ? arguments[1] : void 0), x3;
      } });
    }), Nu2 = P3((N3, c3) => {
      c3.exports = {};
    }), Pt2 = P3((N3, c3) => {
      var l3 = Re2(), d3 = Nu2(), h3 = l3("iterator"), g3 = Array.prototype;
      c3.exports = function(_3) {
        return _3 !== void 0 && (d3.Array === _3 || g3[h3] === _3);
      };
    }), ku2 = P3((N3, c3) => {
      var l3 = xu2(), d3 = su2(), h3 = tu2(), g3 = Nu2(), _3 = Re2(), w3 = _3("iterator");
      c3.exports = function(y3) {
        if (!h3(y3))
          return d3(y3, w3) || d3(y3, "@@iterator") || g3[l3(y3)];
      };
    }), Rt2 = P3((N3, c3) => {
      var l3 = Oe2(), d3 = Ge2(), h3 = Le2(), g3 = nu2(), _3 = ku2(), w3 = TypeError;
      c3.exports = function(y3, x3) {
        var M3 = arguments.length < 2 ? _3(y3) : x3;
        if (d3(M3))
          return h3(l3(M3, y3));
        throw w3(g3(y3) + " is not iterable");
      };
    }), It2 = P3((N3, c3) => {
      var l3 = Oe2(), d3 = Le2(), h3 = su2();
      c3.exports = function(g3, _3, w3) {
        var y3, x3;
        d3(g3);
        try {
          if (y3 = h3(g3, "return"), !y3) {
            if (_3 === "throw")
              throw w3;
            return w3;
          }
          y3 = l3(y3, g3);
        } catch (M3) {
          x3 = true, y3 = M3;
        }
        if (_3 === "throw")
          throw w3;
        if (x3)
          throw y3;
        return d3(y3), w3;
      };
    }), Lt2 = P3((N3, c3) => {
      var l3 = wu2(), d3 = Oe2(), h3 = Le2(), g3 = nu2(), _3 = Pt2(), w3 = He2(), y3 = Cu2(), x3 = Rt2(), M3 = ku2(), q3 = It2(), S3 = TypeError, U3 = function(H3, Y3) {
        this.stopped = H3, this.result = Y3;
      }, J3 = U3.prototype;
      c3.exports = function(H3, Y3, Z3) {
        var R3 = Z3 && Z3.that, De2 = !!(Z3 && Z3.AS_ENTRIES), ne2 = !!(Z3 && Z3.IS_RECORD), ce2 = !!(Z3 && Z3.IS_ITERATOR), Ne2 = !!(Z3 && Z3.INTERRUPTED), _e2 = l3(Y3, R3), Se2, ke2, Ie2, $e2, me2, ze2, qe2, Me2 = function(pe2) {
          return Se2 && q3(Se2, "normal", pe2), new U3(true, pe2);
        }, We2 = function(pe2) {
          return De2 ? (h3(pe2), Ne2 ? _e2(pe2[0], pe2[1], Me2) : _e2(pe2[0], pe2[1])) : Ne2 ? _e2(pe2, Me2) : _e2(pe2);
        };
        if (ne2)
          Se2 = H3.iterator;
        else if (ce2)
          Se2 = H3;
        else {
          if (ke2 = M3(H3), !ke2)
            throw S3(g3(H3) + " is not iterable");
          if (_3(ke2)) {
            for (Ie2 = 0, $e2 = w3(H3); $e2 > Ie2; Ie2++)
              if (me2 = We2(H3[Ie2]), me2 && y3(J3, me2))
                return me2;
            return new U3(false);
          }
          Se2 = x3(H3, ke2);
        }
        for (ze2 = ne2 ? H3.next : Se2.next; !(qe2 = d3(ze2, Se2)).done; ) {
          try {
            me2 = We2(qe2.value);
          } catch (pe2) {
            q3(Se2, "throw", pe2);
          }
          if (typeof me2 == "object" && me2 && y3(J3, me2))
            return me2;
        }
        return new U3(false);
      };
    }), $t2 = P3((N3, c3) => {
      var l3 = ou2(), d3 = Xe2(), h3 = uu2();
      c3.exports = function(g3, _3, w3) {
        var y3 = l3(_3);
        y3 in g3 ? d3.f(g3, y3, h3(0, w3)) : g3[y3] = w3;
      };
    }), qt2 = P3(() => {
      var N3 = Du2(), c3 = Lt2(), l3 = $t2();
      N3({ target: "Object", stat: true }, { fromEntries: function(d3) {
        var h3 = {};
        return c3(d3, function(g3, _3) {
          l3(h3, g3, _3);
        }, { AS_ENTRIES: true }), h3;
      } });
    }), Mt2 = P3((N3, c3) => {
      var l3 = ["cliName", "cliCategory", "cliDescription"];
      function d3(e28, t3) {
        if (e28 == null)
          return {};
        var a3 = h3(e28, t3), o3, p3;
        if (Object.getOwnPropertySymbols) {
          var r3 = Object.getOwnPropertySymbols(e28);
          for (p3 = 0; p3 < r3.length; p3++)
            o3 = r3[p3], !(t3.indexOf(o3) >= 0) && Object.prototype.propertyIsEnumerable.call(e28, o3) && (a3[o3] = e28[o3]);
        }
        return a3;
      }
      function h3(e28, t3) {
        if (e28 == null)
          return {};
        var a3 = {}, o3 = Object.keys(e28), p3, r3;
        for (r3 = 0; r3 < o3.length; r3++)
          p3 = o3[r3], !(t3.indexOf(p3) >= 0) && (a3[p3] = e28[p3]);
        return a3;
      }
      St2(), Ot2(), qt2();
      var g3 = Object.create, _3 = Object.defineProperty, w3 = Object.getOwnPropertyDescriptor, y3 = Object.getOwnPropertyNames, x3 = Object.getPrototypeOf, M3 = Object.prototype.hasOwnProperty, q3 = (e28, t3) => function() {
        return e28 && (t3 = (0, e28[y3(e28)[0]])(e28 = 0)), t3;
      }, S3 = (e28, t3) => function() {
        return t3 || (0, e28[y3(e28)[0]])((t3 = { exports: {} }).exports, t3), t3.exports;
      }, U3 = (e28, t3) => {
        for (var a3 in t3)
          _3(e28, a3, { get: t3[a3], enumerable: true });
      }, J3 = (e28, t3, a3, o3) => {
        if (t3 && typeof t3 == "object" || typeof t3 == "function")
          for (let p3 of y3(t3))
            !M3.call(e28, p3) && p3 !== a3 && _3(e28, p3, { get: () => t3[p3], enumerable: !(o3 = w3(t3, p3)) || o3.enumerable });
        return e28;
      }, H3 = (e28, t3, a3) => (a3 = e28 != null ? g3(x3(e28)) : {}, J3(t3 || !e28 || !e28.__esModule ? _3(a3, "default", { value: e28, enumerable: true }) : a3, e28)), Y3 = (e28) => J3(_3({}, "__esModule", { value: true }), e28), Z3, R3 = q3({ "<define:process>"() {
        Z3 = { env: {}, argv: [] };
      } }), De2 = S3({ "node_modules/angular-html-parser/lib/compiler/src/chars.js"(e28) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true }), e28.$EOF = 0, e28.$BSPACE = 8, e28.$TAB = 9, e28.$LF = 10, e28.$VTAB = 11, e28.$FF = 12, e28.$CR = 13, e28.$SPACE = 32, e28.$BANG = 33, e28.$DQ = 34, e28.$HASH = 35, e28.$$ = 36, e28.$PERCENT = 37, e28.$AMPERSAND = 38, e28.$SQ = 39, e28.$LPAREN = 40, e28.$RPAREN = 41, e28.$STAR = 42, e28.$PLUS = 43, e28.$COMMA = 44, e28.$MINUS = 45, e28.$PERIOD = 46, e28.$SLASH = 47, e28.$COLON = 58, e28.$SEMICOLON = 59, e28.$LT = 60, e28.$EQ = 61, e28.$GT = 62, e28.$QUESTION = 63, e28.$0 = 48, e28.$7 = 55, e28.$9 = 57, e28.$A = 65, e28.$E = 69, e28.$F = 70, e28.$X = 88, e28.$Z = 90, e28.$LBRACKET = 91, e28.$BACKSLASH = 92, e28.$RBRACKET = 93, e28.$CARET = 94, e28.$_ = 95, e28.$a = 97, e28.$b = 98, e28.$e = 101, e28.$f = 102, e28.$n = 110, e28.$r = 114, e28.$t = 116, e28.$u = 117, e28.$v = 118, e28.$x = 120, e28.$z = 122, e28.$LBRACE = 123, e28.$BAR = 124, e28.$RBRACE = 125, e28.$NBSP = 160, e28.$PIPE = 124, e28.$TILDA = 126, e28.$AT = 64, e28.$BT = 96;
        function t3(m3) {
          return m3 >= e28.$TAB && m3 <= e28.$SPACE || m3 == e28.$NBSP;
        }
        e28.isWhitespace = t3;
        function a3(m3) {
          return e28.$0 <= m3 && m3 <= e28.$9;
        }
        e28.isDigit = a3;
        function o3(m3) {
          return m3 >= e28.$a && m3 <= e28.$z || m3 >= e28.$A && m3 <= e28.$Z;
        }
        e28.isAsciiLetter = o3;
        function p3(m3) {
          return m3 >= e28.$a && m3 <= e28.$f || m3 >= e28.$A && m3 <= e28.$F || a3(m3);
        }
        e28.isAsciiHexDigit = p3;
        function r3(m3) {
          return m3 === e28.$LF || m3 === e28.$CR;
        }
        e28.isNewLine = r3;
        function i(m3) {
          return e28.$0 <= m3 && m3 <= e28.$7;
        }
        e28.isOctalDigit = i;
      } }), ne2 = S3({ "node_modules/angular-html-parser/lib/compiler/src/aot/static_symbol.js"(e28) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true });
        var t3 = class {
          constructor(o3, p3, r3) {
            this.filePath = o3, this.name = p3, this.members = r3;
          }
          assertNoMembers() {
            if (this.members.length)
              throw new Error(`Illegal state: symbol without members expected, but got ${JSON.stringify(this)}.`);
          }
        };
        e28.StaticSymbol = t3;
        var a3 = class {
          constructor() {
            this.cache = /* @__PURE__ */ new Map();
          }
          get(o3, p3, r3) {
            r3 = r3 || [];
            let i = r3.length ? `.${r3.join(".")}` : "", m3 = `"${o3}".${p3}${i}`, f3 = this.cache.get(m3);
            return f3 || (f3 = new t3(o3, p3, r3), this.cache.set(m3, f3)), f3;
          }
        };
        e28.StaticSymbolCache = a3;
      } }), ce2 = S3({ "node_modules/angular-html-parser/lib/compiler/src/util.js"(e28) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true });
        var t3 = /-+([a-z0-9])/g;
        function a3(n3) {
          return n3.replace(t3, function() {
            for (var A3 = arguments.length, C3 = new Array(A3), b3 = 0; b3 < A3; b3++)
              C3[b3] = arguments[b3];
            return C3[1].toUpperCase();
          });
        }
        e28.dashCaseToCamelCase = a3;
        function o3(n3, A3) {
          return r3(n3, ":", A3);
        }
        e28.splitAtColon = o3;
        function p3(n3, A3) {
          return r3(n3, ".", A3);
        }
        e28.splitAtPeriod = p3;
        function r3(n3, A3, C3) {
          let b3 = n3.indexOf(A3);
          return b3 == -1 ? C3 : [n3.slice(0, b3).trim(), n3.slice(b3 + 1).trim()];
        }
        function i(n3, A3, C3) {
          return Array.isArray(n3) ? A3.visitArray(n3, C3) : O3(n3) ? A3.visitStringMap(n3, C3) : n3 == null || typeof n3 == "string" || typeof n3 == "number" || typeof n3 == "boolean" ? A3.visitPrimitive(n3, C3) : A3.visitOther(n3, C3);
        }
        e28.visitValue = i;
        function m3(n3) {
          return n3 != null;
        }
        e28.isDefined = m3;
        function f3(n3) {
          return n3 === void 0 ? null : n3;
        }
        e28.noUndefined = f3;
        var L3 = class {
          visitArray(n3, A3) {
            return n3.map((C3) => i(C3, this, A3));
          }
          visitStringMap(n3, A3) {
            let C3 = {};
            return Object.keys(n3).forEach((b3) => {
              C3[b3] = i(n3[b3], this, A3);
            }), C3;
          }
          visitPrimitive(n3, A3) {
            return n3;
          }
          visitOther(n3, A3) {
            return n3;
          }
        };
        e28.ValueTransformer = L3, e28.SyncAsync = { assertSync: (n3) => {
          if (B3(n3))
            throw new Error("Illegal state: value cannot be a promise");
          return n3;
        }, then: (n3, A3) => B3(n3) ? n3.then(A3) : A3(n3), all: (n3) => n3.some(B3) ? Promise.all(n3) : n3 };
        function s3(n3) {
          throw new Error(`Internal Error: ${n3}`);
        }
        e28.error = s3;
        function D3(n3, A3) {
          let C3 = Error(n3);
          return C3[E3] = true, A3 && (C3[v3] = A3), C3;
        }
        e28.syntaxError = D3;
        var E3 = "ngSyntaxError", v3 = "ngParseErrors";
        function F3(n3) {
          return n3[E3];
        }
        e28.isSyntaxError = F3;
        function T3(n3) {
          return n3[v3] || [];
        }
        e28.getParseErrors = T3;
        function $3(n3) {
          return n3.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
        }
        e28.escapeRegExp = $3;
        var X3 = Object.getPrototypeOf({});
        function O3(n3) {
          return typeof n3 == "object" && n3 !== null && Object.getPrototypeOf(n3) === X3;
        }
        function G3(n3) {
          let A3 = "";
          for (let C3 = 0; C3 < n3.length; C3++) {
            let b3 = n3.charCodeAt(C3);
            if (b3 >= 55296 && b3 <= 56319 && n3.length > C3 + 1) {
              let K3 = n3.charCodeAt(C3 + 1);
              K3 >= 56320 && K3 <= 57343 && (C3++, b3 = (b3 - 55296 << 10) + K3 - 56320 + 65536);
            }
            b3 <= 127 ? A3 += String.fromCharCode(b3) : b3 <= 2047 ? A3 += String.fromCharCode(b3 >> 6 & 31 | 192, b3 & 63 | 128) : b3 <= 65535 ? A3 += String.fromCharCode(b3 >> 12 | 224, b3 >> 6 & 63 | 128, b3 & 63 | 128) : b3 <= 2097151 && (A3 += String.fromCharCode(b3 >> 18 & 7 | 240, b3 >> 12 & 63 | 128, b3 >> 6 & 63 | 128, b3 & 63 | 128));
          }
          return A3;
        }
        e28.utf8Encode = G3;
        function W3(n3) {
          if (typeof n3 == "string")
            return n3;
          if (n3 instanceof Array)
            return "[" + n3.map(W3).join(", ") + "]";
          if (n3 == null)
            return "" + n3;
          if (n3.overriddenName)
            return `${n3.overriddenName}`;
          if (n3.name)
            return `${n3.name}`;
          if (!n3.toString)
            return "object";
          let A3 = n3.toString();
          if (A3 == null)
            return "" + A3;
          let C3 = A3.indexOf(`
`);
          return C3 === -1 ? A3 : A3.substring(0, C3);
        }
        e28.stringify = W3;
        function se2(n3) {
          return typeof n3 == "function" && n3.hasOwnProperty("__forward_ref__") ? n3() : n3;
        }
        e28.resolveForwardRef = se2;
        function B3(n3) {
          return !!n3 && typeof n3.then == "function";
        }
        e28.isPromise = B3;
        var z3 = class {
          constructor(n3) {
            this.full = n3;
            let A3 = n3.split(".");
            this.major = A3[0], this.minor = A3[1], this.patch = A3.slice(2).join(".");
          }
        };
        e28.Version = z3;
        var Q3 = typeof window < "u" && window, ee2 = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, re2 = typeof globalThis < "u" && globalThis, u3 = re2 || Q3 || ee2;
        e28.global = u3;
      } }), Ne2 = S3({ "node_modules/angular-html-parser/lib/compiler/src/compile_metadata.js"(e28) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true });
        var t3 = ne2(), a3 = ce2(), o3 = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
        function p3(C3) {
          return C3.replace(/\W/g, "_");
        }
        e28.sanitizeIdentifier = p3;
        var r3 = 0;
        function i(C3) {
          if (!C3 || !C3.reference)
            return null;
          let b3 = C3.reference;
          if (b3 instanceof t3.StaticSymbol)
            return b3.name;
          if (b3.__anonymousType)
            return b3.__anonymousType;
          let K3 = a3.stringify(b3);
          return K3.indexOf("(") >= 0 ? (K3 = `anonymous_${r3++}`, b3.__anonymousType = K3) : K3 = p3(K3), K3;
        }
        e28.identifierName = i;
        function m3(C3) {
          let b3 = C3.reference;
          return b3 instanceof t3.StaticSymbol ? b3.filePath : `./${a3.stringify(b3)}`;
        }
        e28.identifierModuleUrl = m3;
        function f3(C3, b3) {
          return `View_${i({ reference: C3 })}_${b3}`;
        }
        e28.viewClassName = f3;
        function L3(C3) {
          return `RenderType_${i({ reference: C3 })}`;
        }
        e28.rendererTypeName = L3;
        function s3(C3) {
          return `HostView_${i({ reference: C3 })}`;
        }
        e28.hostViewClassName = s3;
        function D3(C3) {
          return `${i({ reference: C3 })}NgFactory`;
        }
        e28.componentFactoryName = D3;
        var E3;
        (function(C3) {
          C3[C3.Pipe = 0] = "Pipe", C3[C3.Directive = 1] = "Directive", C3[C3.NgModule = 2] = "NgModule", C3[C3.Injectable = 3] = "Injectable";
        })(E3 = e28.CompileSummaryKind || (e28.CompileSummaryKind = {}));
        function v3(C3) {
          return C3.value != null ? p3(C3.value) : i(C3.identifier);
        }
        e28.tokenName = v3;
        function F3(C3) {
          return C3.identifier != null ? C3.identifier.reference : C3.value;
        }
        e28.tokenReference = F3;
        var T3 = class {
          constructor() {
            let { moduleUrl: C3, styles: b3, styleUrls: K3 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            this.moduleUrl = C3 || null, this.styles = B3(b3), this.styleUrls = B3(K3);
          }
        };
        e28.CompileStylesheetMetadata = T3;
        var $3 = class {
          constructor(C3) {
            let { encapsulation: b3, template: K3, templateUrl: te2, htmlAst: le2, styles: oe2, styleUrls: he2, externalStylesheets: de2, animations: fe2, ngContentSelectors: ge2, interpolation: Fe2, isInline: k3, preserveWhitespaces: I3 } = C3;
            if (this.encapsulation = b3, this.template = K3, this.templateUrl = te2, this.htmlAst = le2, this.styles = B3(oe2), this.styleUrls = B3(he2), this.externalStylesheets = B3(de2), this.animations = fe2 ? Q3(fe2) : [], this.ngContentSelectors = ge2 || [], Fe2 && Fe2.length != 2)
              throw new Error("'interpolation' should have a start and an end symbol.");
            this.interpolation = Fe2, this.isInline = k3, this.preserveWhitespaces = I3;
          }
          toSummary() {
            return { ngContentSelectors: this.ngContentSelectors, encapsulation: this.encapsulation, styles: this.styles, animations: this.animations };
          }
        };
        e28.CompileTemplateMetadata = $3;
        var X3 = class {
          static create(C3) {
            let { isHost: b3, type: K3, isComponent: te2, selector: le2, exportAs: oe2, changeDetection: he2, inputs: de2, outputs: fe2, host: ge2, providers: Fe2, viewProviders: k3, queries: I3, guards: j3, viewQueries: V10, entryComponents: ue2, template: ie2, componentViewType: ae2, rendererType: Ce2, componentFactory: Be2 } = C3, Ke2 = {}, Ze2 = {}, Hu2 = {};
            ge2 != null && Object.keys(ge2).forEach((Ae2) => {
              let be2 = ge2[Ae2], je2 = Ae2.match(o3);
              je2 === null ? Hu2[Ae2] = be2 : je2[1] != null ? Ze2[je2[1]] = be2 : je2[2] != null && (Ke2[je2[2]] = be2);
            });
            let zu2 = {};
            de2 != null && de2.forEach((Ae2) => {
              let be2 = a3.splitAtColon(Ae2, [Ae2, Ae2]);
              zu2[be2[0]] = be2[1];
            });
            let Wu2 = {};
            return fe2 != null && fe2.forEach((Ae2) => {
              let be2 = a3.splitAtColon(Ae2, [Ae2, Ae2]);
              Wu2[be2[0]] = be2[1];
            }), new X3({ isHost: b3, type: K3, isComponent: !!te2, selector: le2, exportAs: oe2, changeDetection: he2, inputs: zu2, outputs: Wu2, hostListeners: Ke2, hostProperties: Ze2, hostAttributes: Hu2, providers: Fe2, viewProviders: k3, queries: I3, guards: j3, viewQueries: V10, entryComponents: ue2, template: ie2, componentViewType: ae2, rendererType: Ce2, componentFactory: Be2 });
          }
          constructor(C3) {
            let { isHost: b3, type: K3, isComponent: te2, selector: le2, exportAs: oe2, changeDetection: he2, inputs: de2, outputs: fe2, hostListeners: ge2, hostProperties: Fe2, hostAttributes: k3, providers: I3, viewProviders: j3, queries: V10, guards: ue2, viewQueries: ie2, entryComponents: ae2, template: Ce2, componentViewType: Be2, rendererType: Ke2, componentFactory: Ze2 } = C3;
            this.isHost = !!b3, this.type = K3, this.isComponent = te2, this.selector = le2, this.exportAs = oe2, this.changeDetection = he2, this.inputs = de2, this.outputs = fe2, this.hostListeners = ge2, this.hostProperties = Fe2, this.hostAttributes = k3, this.providers = B3(I3), this.viewProviders = B3(j3), this.queries = B3(V10), this.guards = ue2, this.viewQueries = B3(ie2), this.entryComponents = B3(ae2), this.template = Ce2, this.componentViewType = Be2, this.rendererType = Ke2, this.componentFactory = Ze2;
          }
          toSummary() {
            return { summaryKind: E3.Directive, type: this.type, isComponent: this.isComponent, selector: this.selector, exportAs: this.exportAs, inputs: this.inputs, outputs: this.outputs, hostListeners: this.hostListeners, hostProperties: this.hostProperties, hostAttributes: this.hostAttributes, providers: this.providers, viewProviders: this.viewProviders, queries: this.queries, guards: this.guards, viewQueries: this.viewQueries, entryComponents: this.entryComponents, changeDetection: this.changeDetection, template: this.template && this.template.toSummary(), componentViewType: this.componentViewType, rendererType: this.rendererType, componentFactory: this.componentFactory };
          }
        };
        e28.CompileDirectiveMetadata = X3;
        var O3 = class {
          constructor(C3) {
            let { type: b3, name: K3, pure: te2 } = C3;
            this.type = b3, this.name = K3, this.pure = !!te2;
          }
          toSummary() {
            return { summaryKind: E3.Pipe, type: this.type, name: this.name, pure: this.pure };
          }
        };
        e28.CompilePipeMetadata = O3;
        var G3 = class {
        };
        e28.CompileShallowModuleMetadata = G3;
        var W3 = class {
          constructor(C3) {
            let { type: b3, providers: K3, declaredDirectives: te2, exportedDirectives: le2, declaredPipes: oe2, exportedPipes: he2, entryComponents: de2, bootstrapComponents: fe2, importedModules: ge2, exportedModules: Fe2, schemas: k3, transitiveModule: I3, id: j3 } = C3;
            this.type = b3 || null, this.declaredDirectives = B3(te2), this.exportedDirectives = B3(le2), this.declaredPipes = B3(oe2), this.exportedPipes = B3(he2), this.providers = B3(K3), this.entryComponents = B3(de2), this.bootstrapComponents = B3(fe2), this.importedModules = B3(ge2), this.exportedModules = B3(Fe2), this.schemas = B3(k3), this.id = j3 || null, this.transitiveModule = I3 || null;
          }
          toSummary() {
            let C3 = this.transitiveModule;
            return { summaryKind: E3.NgModule, type: this.type, entryComponents: C3.entryComponents, providers: C3.providers, modules: C3.modules, exportedDirectives: C3.exportedDirectives, exportedPipes: C3.exportedPipes };
          }
        };
        e28.CompileNgModuleMetadata = W3;
        var se2 = class {
          constructor() {
            this.directivesSet = /* @__PURE__ */ new Set(), this.directives = [], this.exportedDirectivesSet = /* @__PURE__ */ new Set(), this.exportedDirectives = [], this.pipesSet = /* @__PURE__ */ new Set(), this.pipes = [], this.exportedPipesSet = /* @__PURE__ */ new Set(), this.exportedPipes = [], this.modulesSet = /* @__PURE__ */ new Set(), this.modules = [], this.entryComponentsSet = /* @__PURE__ */ new Set(), this.entryComponents = [], this.providers = [];
          }
          addProvider(C3, b3) {
            this.providers.push({ provider: C3, module: b3 });
          }
          addDirective(C3) {
            this.directivesSet.has(C3.reference) || (this.directivesSet.add(C3.reference), this.directives.push(C3));
          }
          addExportedDirective(C3) {
            this.exportedDirectivesSet.has(C3.reference) || (this.exportedDirectivesSet.add(C3.reference), this.exportedDirectives.push(C3));
          }
          addPipe(C3) {
            this.pipesSet.has(C3.reference) || (this.pipesSet.add(C3.reference), this.pipes.push(C3));
          }
          addExportedPipe(C3) {
            this.exportedPipesSet.has(C3.reference) || (this.exportedPipesSet.add(C3.reference), this.exportedPipes.push(C3));
          }
          addModule(C3) {
            this.modulesSet.has(C3.reference) || (this.modulesSet.add(C3.reference), this.modules.push(C3));
          }
          addEntryComponent(C3) {
            this.entryComponentsSet.has(C3.componentType) || (this.entryComponentsSet.add(C3.componentType), this.entryComponents.push(C3));
          }
        };
        e28.TransitiveCompileNgModuleMetadata = se2;
        function B3(C3) {
          return C3 || [];
        }
        var z3 = class {
          constructor(C3, b3) {
            let { useClass: K3, useValue: te2, useExisting: le2, useFactory: oe2, deps: he2, multi: de2 } = b3;
            this.token = C3, this.useClass = K3 || null, this.useValue = te2, this.useExisting = le2, this.useFactory = oe2 || null, this.dependencies = he2 || null, this.multi = !!de2;
          }
        };
        e28.ProviderMeta = z3;
        function Q3(C3) {
          return C3.reduce((b3, K3) => {
            let te2 = Array.isArray(K3) ? Q3(K3) : K3;
            return b3.concat(te2);
          }, []);
        }
        e28.flatten = Q3;
        function ee2(C3) {
          return C3.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, "ng:///");
        }
        function re2(C3, b3, K3) {
          let te2;
          return K3.isInline ? b3.type.reference instanceof t3.StaticSymbol ? te2 = `${b3.type.reference.filePath}.${b3.type.reference.name}.html` : te2 = `${i(C3)}/${i(b3.type)}.html` : te2 = K3.templateUrl, b3.type.reference instanceof t3.StaticSymbol ? te2 : ee2(te2);
        }
        e28.templateSourceUrl = re2;
        function u3(C3, b3) {
          let K3 = C3.moduleUrl.split(/\/\\/g), te2 = K3[K3.length - 1];
          return ee2(`css/${b3}${te2}.ngstyle.js`);
        }
        e28.sharedStylesheetJitUrl = u3;
        function n3(C3) {
          return ee2(`${i(C3.type)}/module.ngfactory.js`);
        }
        e28.ngModuleJitUrl = n3;
        function A3(C3, b3) {
          return ee2(`${i(C3)}/${i(b3.type)}.ngfactory.js`);
        }
        e28.templateJitUrl = A3;
      } }), _e2 = S3({ "node_modules/angular-html-parser/lib/compiler/src/parse_util.js"(e28) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true });
        var t3 = De2(), a3 = Ne2(), o3 = class {
          constructor(s3, D3, E3, v3) {
            this.file = s3, this.offset = D3, this.line = E3, this.col = v3;
          }
          toString() {
            return this.offset != null ? `${this.file.url}@${this.line}:${this.col}` : this.file.url;
          }
          moveBy(s3) {
            let D3 = this.file.content, E3 = D3.length, v3 = this.offset, F3 = this.line, T3 = this.col;
            for (; v3 > 0 && s3 < 0; )
              if (v3--, s3++, D3.charCodeAt(v3) == t3.$LF) {
                F3--;
                let $3 = D3.substr(0, v3 - 1).lastIndexOf(String.fromCharCode(t3.$LF));
                T3 = $3 > 0 ? v3 - $3 : v3;
              } else
                T3--;
            for (; v3 < E3 && s3 > 0; ) {
              let $3 = D3.charCodeAt(v3);
              v3++, s3--, $3 == t3.$LF ? (F3++, T3 = 0) : T3++;
            }
            return new o3(this.file, v3, F3, T3);
          }
          getContext(s3, D3) {
            let E3 = this.file.content, v3 = this.offset;
            if (v3 != null) {
              v3 > E3.length - 1 && (v3 = E3.length - 1);
              let F3 = v3, T3 = 0, $3 = 0;
              for (; T3 < s3 && v3 > 0 && (v3--, T3++, !(E3[v3] == `
` && ++$3 == D3)); )
                ;
              for (T3 = 0, $3 = 0; T3 < s3 && F3 < E3.length - 1 && (F3++, T3++, !(E3[F3] == `
` && ++$3 == D3)); )
                ;
              return { before: E3.substring(v3, this.offset), after: E3.substring(this.offset, F3 + 1) };
            }
            return null;
          }
        };
        e28.ParseLocation = o3;
        var p3 = class {
          constructor(s3, D3) {
            this.content = s3, this.url = D3;
          }
        };
        e28.ParseSourceFile = p3;
        var r3 = class {
          constructor(s3, D3) {
            let E3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            this.start = s3, this.end = D3, this.details = E3;
          }
          toString() {
            return this.start.file.content.substring(this.start.offset, this.end.offset);
          }
        };
        e28.ParseSourceSpan = r3, e28.EMPTY_PARSE_LOCATION = new o3(new p3("", ""), 0, 0, 0), e28.EMPTY_SOURCE_SPAN = new r3(e28.EMPTY_PARSE_LOCATION, e28.EMPTY_PARSE_LOCATION);
        var i;
        (function(s3) {
          s3[s3.WARNING = 0] = "WARNING", s3[s3.ERROR = 1] = "ERROR";
        })(i = e28.ParseErrorLevel || (e28.ParseErrorLevel = {}));
        var m3 = class {
          constructor(s3, D3) {
            let E3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : i.ERROR;
            this.span = s3, this.msg = D3, this.level = E3;
          }
          contextualMessage() {
            let s3 = this.span.start.getContext(100, 3);
            return s3 ? `${this.msg} ("${s3.before}[${i[this.level]} ->]${s3.after}")` : this.msg;
          }
          toString() {
            let s3 = this.span.details ? `, ${this.span.details}` : "";
            return `${this.contextualMessage()}: ${this.span.start}${s3}`;
          }
        };
        e28.ParseError = m3;
        function f3(s3, D3) {
          let E3 = a3.identifierModuleUrl(D3), v3 = E3 != null ? `in ${s3} ${a3.identifierName(D3)} in ${E3}` : `in ${s3} ${a3.identifierName(D3)}`, F3 = new p3("", v3);
          return new r3(new o3(F3, -1, -1, -1), new o3(F3, -1, -1, -1));
        }
        e28.typeSourceSpan = f3;
        function L3(s3, D3, E3) {
          let v3 = `in ${s3} ${D3} in ${E3}`, F3 = new p3("", v3);
          return new r3(new o3(F3, -1, -1, -1), new o3(F3, -1, -1, -1));
        }
        e28.r3JitTypeSourceSpan = L3;
      } }), Se2 = S3({ "src/utils/front-matter/parse.js"(e28, t3) {
        R3();
        var a3 = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
        function o3(p3) {
          let r3 = p3.match(a3);
          if (!r3)
            return { content: p3 };
          let { startDelimiter: i, language: m3, value: f3 = "", endDelimiter: L3 } = r3.groups, s3 = m3.trim() || "yaml";
          if (i === "+++" && (s3 = "toml"), s3 !== "yaml" && i !== L3)
            return { content: p3 };
          let [D3] = r3;
          return { frontMatter: { type: "front-matter", lang: s3, value: f3, startDelimiter: i, endDelimiter: L3, raw: D3.replace(/\n$/, "") }, content: D3.replace(/[^\n]/g, " ") + p3.slice(D3.length) };
        }
        t3.exports = o3;
      } }), ke2 = S3({ "src/utils/get-last.js"(e28, t3) {
        R3();
        var a3 = (o3) => o3[o3.length - 1];
        t3.exports = a3;
      } }), Ie2 = S3({ "src/common/parser-create-error.js"(e28, t3) {
        R3();
        function a3(o3, p3) {
          let r3 = new SyntaxError(o3 + " (" + p3.start.line + ":" + p3.start.column + ")");
          return r3.loc = p3, r3;
        }
        t3.exports = a3;
      } }), $e2 = {};
      U3($e2, { default: () => me2 });
      function me2(e28) {
        if (typeof e28 != "string")
          throw new TypeError("Expected a string");
        return e28.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
      }
      var ze2 = q3({ "node_modules/escape-string-regexp/index.js"() {
        R3();
      } }), qe2 = S3({ "node_modules/semver/internal/debug.js"(e28, t3) {
        R3();
        var a3 = typeof Z3 == "object" && Z3.env && Z3.env.NODE_DEBUG && /\bsemver\b/i.test(Z3.env.NODE_DEBUG) ? function() {
          for (var o3 = arguments.length, p3 = new Array(o3), r3 = 0; r3 < o3; r3++)
            p3[r3] = arguments[r3];
          return console.error("SEMVER", ...p3);
        } : () => {
        };
        t3.exports = a3;
      } }), Me2 = S3({ "node_modules/semver/internal/constants.js"(e28, t3) {
        R3();
        var a3 = "2.0.0", o3 = 256, p3 = Number.MAX_SAFE_INTEGER || 9007199254740991, r3 = 16;
        t3.exports = { SEMVER_SPEC_VERSION: a3, MAX_LENGTH: o3, MAX_SAFE_INTEGER: p3, MAX_SAFE_COMPONENT_LENGTH: r3 };
      } }), We2 = S3({ "node_modules/semver/internal/re.js"(e28, t3) {
        R3();
        var { MAX_SAFE_COMPONENT_LENGTH: a3 } = Me2(), o3 = qe2();
        e28 = t3.exports = {};
        var p3 = e28.re = [], r3 = e28.src = [], i = e28.t = {}, m3 = 0, f3 = (L3, s3, D3) => {
          let E3 = m3++;
          o3(L3, E3, s3), i[L3] = E3, r3[E3] = s3, p3[E3] = new RegExp(s3, D3 ? "g" : void 0);
        };
        f3("NUMERICIDENTIFIER", "0|[1-9]\\d*"), f3("NUMERICIDENTIFIERLOOSE", "[0-9]+"), f3("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), f3("MAINVERSION", `(${r3[i.NUMERICIDENTIFIER]})\\.(${r3[i.NUMERICIDENTIFIER]})\\.(${r3[i.NUMERICIDENTIFIER]})`), f3("MAINVERSIONLOOSE", `(${r3[i.NUMERICIDENTIFIERLOOSE]})\\.(${r3[i.NUMERICIDENTIFIERLOOSE]})\\.(${r3[i.NUMERICIDENTIFIERLOOSE]})`), f3("PRERELEASEIDENTIFIER", `(?:${r3[i.NUMERICIDENTIFIER]}|${r3[i.NONNUMERICIDENTIFIER]})`), f3("PRERELEASEIDENTIFIERLOOSE", `(?:${r3[i.NUMERICIDENTIFIERLOOSE]}|${r3[i.NONNUMERICIDENTIFIER]})`), f3("PRERELEASE", `(?:-(${r3[i.PRERELEASEIDENTIFIER]}(?:\\.${r3[i.PRERELEASEIDENTIFIER]})*))`), f3("PRERELEASELOOSE", `(?:-?(${r3[i.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${r3[i.PRERELEASEIDENTIFIERLOOSE]})*))`), f3("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), f3("BUILD", `(?:\\+(${r3[i.BUILDIDENTIFIER]}(?:\\.${r3[i.BUILDIDENTIFIER]})*))`), f3("FULLPLAIN", `v?${r3[i.MAINVERSION]}${r3[i.PRERELEASE]}?${r3[i.BUILD]}?`), f3("FULL", `^${r3[i.FULLPLAIN]}$`), f3("LOOSEPLAIN", `[v=\\s]*${r3[i.MAINVERSIONLOOSE]}${r3[i.PRERELEASELOOSE]}?${r3[i.BUILD]}?`), f3("LOOSE", `^${r3[i.LOOSEPLAIN]}$`), f3("GTLT", "((?:<|>)?=?)"), f3("XRANGEIDENTIFIERLOOSE", `${r3[i.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), f3("XRANGEIDENTIFIER", `${r3[i.NUMERICIDENTIFIER]}|x|X|\\*`), f3("XRANGEPLAIN", `[v=\\s]*(${r3[i.XRANGEIDENTIFIER]})(?:\\.(${r3[i.XRANGEIDENTIFIER]})(?:\\.(${r3[i.XRANGEIDENTIFIER]})(?:${r3[i.PRERELEASE]})?${r3[i.BUILD]}?)?)?`), f3("XRANGEPLAINLOOSE", `[v=\\s]*(${r3[i.XRANGEIDENTIFIERLOOSE]})(?:\\.(${r3[i.XRANGEIDENTIFIERLOOSE]})(?:\\.(${r3[i.XRANGEIDENTIFIERLOOSE]})(?:${r3[i.PRERELEASELOOSE]})?${r3[i.BUILD]}?)?)?`), f3("XRANGE", `^${r3[i.GTLT]}\\s*${r3[i.XRANGEPLAIN]}$`), f3("XRANGELOOSE", `^${r3[i.GTLT]}\\s*${r3[i.XRANGEPLAINLOOSE]}$`), f3("COERCE", `(^|[^\\d])(\\d{1,${a3}})(?:\\.(\\d{1,${a3}}))?(?:\\.(\\d{1,${a3}}))?(?:$|[^\\d])`), f3("COERCERTL", r3[i.COERCE], true), f3("LONETILDE", "(?:~>?)"), f3("TILDETRIM", `(\\s*)${r3[i.LONETILDE]}\\s+`, true), e28.tildeTrimReplace = "$1~", f3("TILDE", `^${r3[i.LONETILDE]}${r3[i.XRANGEPLAIN]}$`), f3("TILDELOOSE", `^${r3[i.LONETILDE]}${r3[i.XRANGEPLAINLOOSE]}$`), f3("LONECARET", "(?:\\^)"), f3("CARETTRIM", `(\\s*)${r3[i.LONECARET]}\\s+`, true), e28.caretTrimReplace = "$1^", f3("CARET", `^${r3[i.LONECARET]}${r3[i.XRANGEPLAIN]}$`), f3("CARETLOOSE", `^${r3[i.LONECARET]}${r3[i.XRANGEPLAINLOOSE]}$`), f3("COMPARATORLOOSE", `^${r3[i.GTLT]}\\s*(${r3[i.LOOSEPLAIN]})$|^$`), f3("COMPARATOR", `^${r3[i.GTLT]}\\s*(${r3[i.FULLPLAIN]})$|^$`), f3("COMPARATORTRIM", `(\\s*)${r3[i.GTLT]}\\s*(${r3[i.LOOSEPLAIN]}|${r3[i.XRANGEPLAIN]})`, true), e28.comparatorTrimReplace = "$1$2$3", f3("HYPHENRANGE", `^\\s*(${r3[i.XRANGEPLAIN]})\\s+-\\s+(${r3[i.XRANGEPLAIN]})\\s*$`), f3("HYPHENRANGELOOSE", `^\\s*(${r3[i.XRANGEPLAINLOOSE]})\\s+-\\s+(${r3[i.XRANGEPLAINLOOSE]})\\s*$`), f3("STAR", "(<|>)?=?\\s*\\*"), f3("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), f3("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
      } }), pe2 = S3({ "node_modules/semver/internal/parse-options.js"(e28, t3) {
        R3();
        var a3 = ["includePrerelease", "loose", "rtl"], o3 = (p3) => p3 ? typeof p3 != "object" ? { loose: true } : a3.filter((r3) => p3[r3]).reduce((r3, i) => (r3[i] = true, r3), {}) : {};
        t3.exports = o3;
      } }), jt2 = S3({ "node_modules/semver/internal/identifiers.js"(e28, t3) {
        R3();
        var a3 = /^[0-9]+$/, o3 = (r3, i) => {
          let m3 = a3.test(r3), f3 = a3.test(i);
          return m3 && f3 && (r3 = +r3, i = +i), r3 === i ? 0 : m3 && !f3 ? -1 : f3 && !m3 ? 1 : r3 < i ? -1 : 1;
        }, p3 = (r3, i) => o3(i, r3);
        t3.exports = { compareIdentifiers: o3, rcompareIdentifiers: p3 };
      } }), Ut2 = S3({ "node_modules/semver/classes/semver.js"(e28, t3) {
        R3();
        var a3 = qe2(), { MAX_LENGTH: o3, MAX_SAFE_INTEGER: p3 } = Me2(), { re: r3, t: i } = We2(), m3 = pe2(), { compareIdentifiers: f3 } = jt2(), L3 = class {
          constructor(s3, D3) {
            if (D3 = m3(D3), s3 instanceof L3) {
              if (s3.loose === !!D3.loose && s3.includePrerelease === !!D3.includePrerelease)
                return s3;
              s3 = s3.version;
            } else if (typeof s3 != "string")
              throw new TypeError(`Invalid Version: ${s3}`);
            if (s3.length > o3)
              throw new TypeError(`version is longer than ${o3} characters`);
            a3("SemVer", s3, D3), this.options = D3, this.loose = !!D3.loose, this.includePrerelease = !!D3.includePrerelease;
            let E3 = s3.trim().match(D3.loose ? r3[i.LOOSE] : r3[i.FULL]);
            if (!E3)
              throw new TypeError(`Invalid Version: ${s3}`);
            if (this.raw = s3, this.major = +E3[1], this.minor = +E3[2], this.patch = +E3[3], this.major > p3 || this.major < 0)
              throw new TypeError("Invalid major version");
            if (this.minor > p3 || this.minor < 0)
              throw new TypeError("Invalid minor version");
            if (this.patch > p3 || this.patch < 0)
              throw new TypeError("Invalid patch version");
            E3[4] ? this.prerelease = E3[4].split(".").map((v3) => {
              if (/^[0-9]+$/.test(v3)) {
                let F3 = +v3;
                if (F3 >= 0 && F3 < p3)
                  return F3;
              }
              return v3;
            }) : this.prerelease = [], this.build = E3[5] ? E3[5].split(".") : [], this.format();
          }
          format() {
            return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
          }
          toString() {
            return this.version;
          }
          compare(s3) {
            if (a3("SemVer.compare", this.version, this.options, s3), !(s3 instanceof L3)) {
              if (typeof s3 == "string" && s3 === this.version)
                return 0;
              s3 = new L3(s3, this.options);
            }
            return s3.version === this.version ? 0 : this.compareMain(s3) || this.comparePre(s3);
          }
          compareMain(s3) {
            return s3 instanceof L3 || (s3 = new L3(s3, this.options)), f3(this.major, s3.major) || f3(this.minor, s3.minor) || f3(this.patch, s3.patch);
          }
          comparePre(s3) {
            if (s3 instanceof L3 || (s3 = new L3(s3, this.options)), this.prerelease.length && !s3.prerelease.length)
              return -1;
            if (!this.prerelease.length && s3.prerelease.length)
              return 1;
            if (!this.prerelease.length && !s3.prerelease.length)
              return 0;
            let D3 = 0;
            do {
              let E3 = this.prerelease[D3], v3 = s3.prerelease[D3];
              if (a3("prerelease compare", D3, E3, v3), E3 === void 0 && v3 === void 0)
                return 0;
              if (v3 === void 0)
                return 1;
              if (E3 === void 0)
                return -1;
              if (E3 !== v3)
                return f3(E3, v3);
            } while (++D3);
          }
          compareBuild(s3) {
            s3 instanceof L3 || (s3 = new L3(s3, this.options));
            let D3 = 0;
            do {
              let E3 = this.build[D3], v3 = s3.build[D3];
              if (a3("prerelease compare", D3, E3, v3), E3 === void 0 && v3 === void 0)
                return 0;
              if (v3 === void 0)
                return 1;
              if (E3 === void 0)
                return -1;
              if (E3 !== v3)
                return f3(E3, v3);
            } while (++D3);
          }
          inc(s3, D3) {
            switch (s3) {
              case "premajor":
                this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", D3);
                break;
              case "preminor":
                this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", D3);
                break;
              case "prepatch":
                this.prerelease.length = 0, this.inc("patch", D3), this.inc("pre", D3);
                break;
              case "prerelease":
                this.prerelease.length === 0 && this.inc("patch", D3), this.inc("pre", D3);
                break;
              case "major":
                (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                break;
              case "minor":
                (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
                break;
              case "patch":
                this.prerelease.length === 0 && this.patch++, this.prerelease = [];
                break;
              case "pre":
                if (this.prerelease.length === 0)
                  this.prerelease = [0];
                else {
                  let E3 = this.prerelease.length;
                  for (; --E3 >= 0; )
                    typeof this.prerelease[E3] == "number" && (this.prerelease[E3]++, E3 = -2);
                  E3 === -1 && this.prerelease.push(0);
                }
                D3 && (f3(this.prerelease[0], D3) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [D3, 0]) : this.prerelease = [D3, 0]);
                break;
              default:
                throw new Error(`invalid increment argument: ${s3}`);
            }
            return this.format(), this.raw = this.version, this;
          }
        };
        t3.exports = L3;
      } }), lu2 = S3({ "node_modules/semver/functions/compare.js"(e28, t3) {
        R3();
        var a3 = Ut2(), o3 = (p3, r3, i) => new a3(p3, i).compare(new a3(r3, i));
        t3.exports = o3;
      } }), Vt2 = S3({ "node_modules/semver/functions/lt.js"(e28, t3) {
        R3();
        var a3 = lu2(), o3 = (p3, r3, i) => a3(p3, r3, i) < 0;
        t3.exports = o3;
      } }), Gt2 = S3({ "node_modules/semver/functions/gte.js"(e28, t3) {
        R3();
        var a3 = lu2(), o3 = (p3, r3, i) => a3(p3, r3, i) >= 0;
        t3.exports = o3;
      } }), Xt2 = S3({ "src/utils/arrayify.js"(e28, t3) {
        R3(), t3.exports = (a3, o3) => Object.entries(a3).map((p3) => {
          let [r3, i] = p3;
          return Object.assign({ [o3]: r3 }, i);
        });
      } }), Ht2 = S3({ "package.json"(e28, t3) {
        t3.exports = { version: "2.8.8" };
      } }), zt2 = S3({ "node_modules/outdent/lib/index.js"(e28, t3) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true }), e28.outdent = void 0;
        function a3() {
          for (var O3 = [], G3 = 0; G3 < arguments.length; G3++)
            O3[G3] = arguments[G3];
        }
        function o3() {
          return typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : p3();
        }
        function p3() {
          return { add: a3, delete: a3, get: a3, set: a3, has: function(O3) {
            return false;
          } };
        }
        var r3 = Object.prototype.hasOwnProperty, i = function(O3, G3) {
          return r3.call(O3, G3);
        };
        function m3(O3, G3) {
          for (var W3 in G3)
            i(G3, W3) && (O3[W3] = G3[W3]);
          return O3;
        }
        var f3 = /^[ \t]*(?:\r\n|\r|\n)/, L3 = /(?:\r\n|\r|\n)[ \t]*$/, s3 = /^(?:[\r\n]|$)/, D3 = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/, E3 = /^[ \t]*[\r\n][ \t\r\n]*$/;
        function v3(O3, G3, W3) {
          var se2 = 0, B3 = O3[0].match(D3);
          B3 && (se2 = B3[1].length);
          var z3 = "(\\r\\n|\\r|\\n).{0," + se2 + "}", Q3 = new RegExp(z3, "g");
          G3 && (O3 = O3.slice(1));
          var ee2 = W3.newline, re2 = W3.trimLeadingNewline, u3 = W3.trimTrailingNewline, n3 = typeof ee2 == "string", A3 = O3.length, C3 = O3.map(function(b3, K3) {
            return b3 = b3.replace(Q3, "$1"), K3 === 0 && re2 && (b3 = b3.replace(f3, "")), K3 === A3 - 1 && u3 && (b3 = b3.replace(L3, "")), n3 && (b3 = b3.replace(/\r\n|\n|\r/g, function(te2) {
              return ee2;
            })), b3;
          });
          return C3;
        }
        function F3(O3, G3) {
          for (var W3 = "", se2 = 0, B3 = O3.length; se2 < B3; se2++)
            W3 += O3[se2], se2 < B3 - 1 && (W3 += G3[se2]);
          return W3;
        }
        function T3(O3) {
          return i(O3, "raw") && i(O3, "length");
        }
        function $3(O3) {
          var G3 = o3(), W3 = o3();
          function se2(z3) {
            for (var Q3 = [], ee2 = 1; ee2 < arguments.length; ee2++)
              Q3[ee2 - 1] = arguments[ee2];
            if (T3(z3)) {
              var re2 = z3, u3 = (Q3[0] === se2 || Q3[0] === X3) && E3.test(re2[0]) && s3.test(re2[1]), n3 = u3 ? W3 : G3, A3 = n3.get(re2);
              if (A3 || (A3 = v3(re2, u3, O3), n3.set(re2, A3)), Q3.length === 0)
                return A3[0];
              var C3 = F3(A3, u3 ? Q3.slice(1) : Q3);
              return C3;
            } else
              return $3(m3(m3({}, O3), z3 || {}));
          }
          var B3 = m3(se2, { string: function(z3) {
            return v3([z3], false, O3)[0];
          } });
          return B3;
        }
        var X3 = $3({ trimLeadingNewline: true, trimTrailingNewline: true });
        if (e28.outdent = X3, e28.default = X3, typeof t3 < "u")
          try {
            t3.exports = X3, Object.defineProperty(X3, "__esModule", { value: true }), X3.default = X3, X3.outdent = X3;
          } catch {
          }
      } }), Wt2 = S3({ "src/main/core-options.js"(e28, t3) {
        R3();
        var { outdent: a3 } = zt2(), o3 = "Config", p3 = "Editor", r3 = "Format", i = "Other", m3 = "Output", f3 = "Global", L3 = "Special", s3 = { cursorOffset: { since: "1.4.0", category: L3, type: "int", default: -1, range: { start: -1, end: Number.POSITIVE_INFINITY, step: 1 }, description: a3`
      Print (to stderr) where a cursor at the given position would move to after formatting.
      This option cannot be used with --range-start and --range-end.
    `, cliCategory: p3 }, endOfLine: { since: "1.15.0", category: f3, type: "choice", default: [{ since: "1.15.0", value: "auto" }, { since: "2.0.0", value: "lf" }], description: "Which end of line characters to apply.", choices: [{ value: "lf", description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos" }, { value: "crlf", description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows" }, { value: "cr", description: "Carriage Return character only (\\r), used very rarely" }, { value: "auto", description: a3`
          Maintain existing
          (mixed values within one file are normalised by looking at what's used after the first line)
        ` }] }, filepath: { since: "1.4.0", category: L3, type: "path", description: "Specify the input filepath. This will be used to do parser inference.", cliName: "stdin-filepath", cliCategory: i, cliDescription: "Path to the file to pretend that stdin comes from." }, insertPragma: { since: "1.8.0", category: L3, type: "boolean", default: false, description: "Insert @format pragma into file's first docblock comment.", cliCategory: i }, parser: { since: "0.0.10", category: f3, type: "choice", default: [{ since: "0.0.10", value: "babylon" }, { since: "1.13.0", value: void 0 }], description: "Which parser to use.", exception: (D3) => typeof D3 == "string" || typeof D3 == "function", choices: [{ value: "flow", description: "Flow" }, { value: "babel", since: "1.16.0", description: "JavaScript" }, { value: "babel-flow", since: "1.16.0", description: "Flow" }, { value: "babel-ts", since: "2.0.0", description: "TypeScript" }, { value: "typescript", since: "1.4.0", description: "TypeScript" }, { value: "acorn", since: "2.6.0", description: "JavaScript" }, { value: "espree", since: "2.2.0", description: "JavaScript" }, { value: "meriyah", since: "2.2.0", description: "JavaScript" }, { value: "css", since: "1.7.1", description: "CSS" }, { value: "less", since: "1.7.1", description: "Less" }, { value: "scss", since: "1.7.1", description: "SCSS" }, { value: "json", since: "1.5.0", description: "JSON" }, { value: "json5", since: "1.13.0", description: "JSON5" }, { value: "json-stringify", since: "1.13.0", description: "JSON.stringify" }, { value: "graphql", since: "1.5.0", description: "GraphQL" }, { value: "markdown", since: "1.8.0", description: "Markdown" }, { value: "mdx", since: "1.15.0", description: "MDX" }, { value: "vue", since: "1.10.0", description: "Vue" }, { value: "yaml", since: "1.14.0", description: "YAML" }, { value: "glimmer", since: "2.3.0", description: "Ember / Handlebars" }, { value: "html", since: "1.15.0", description: "HTML" }, { value: "angular", since: "1.15.0", description: "Angular" }, { value: "lwc", since: "1.17.0", description: "Lightning Web Components" }] }, plugins: { since: "1.10.0", type: "path", array: true, default: [{ value: [] }], category: f3, description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.", exception: (D3) => typeof D3 == "string" || typeof D3 == "object", cliName: "plugin", cliCategory: o3 }, pluginSearchDirs: { since: "1.13.0", type: "path", array: true, default: [{ value: [] }], category: f3, description: a3`
      Custom directory that contains prettier plugins in node_modules subdirectory.
      Overrides default behavior when plugins are searched relatively to the location of Prettier.
      Multiple values are accepted.
    `, exception: (D3) => typeof D3 == "string" || typeof D3 == "object", cliName: "plugin-search-dir", cliCategory: o3 }, printWidth: { since: "0.0.0", category: f3, type: "int", default: 80, description: "The line length where Prettier will try wrap.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, rangeEnd: { since: "1.4.0", category: L3, type: "int", default: Number.POSITIVE_INFINITY, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: a3`
      Format code ending at a given character offset (exclusive).
      The range will extend forwards to the end of the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: p3 }, rangeStart: { since: "1.4.0", category: L3, type: "int", default: 0, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: a3`
      Format code starting at a given character offset.
      The range will extend backwards to the start of the first line containing the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: p3 }, requirePragma: { since: "1.7.0", category: L3, type: "boolean", default: false, description: a3`
      Require either '@prettier' or '@format' to be present in the file's first docblock comment
      in order for it to be formatted.
    `, cliCategory: i }, tabWidth: { type: "int", category: f3, default: 2, description: "Number of spaces per indentation level.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, useTabs: { since: "1.0.0", category: f3, type: "boolean", default: false, description: "Indent with tabs instead of spaces." }, embeddedLanguageFormatting: { since: "2.1.0", category: f3, type: "choice", default: [{ since: "2.1.0", value: "auto" }], description: "Control how Prettier formats quoted code embedded in the file.", choices: [{ value: "auto", description: "Format embedded code if Prettier can automatically identify it." }, { value: "off", description: "Never automatically format embedded code." }] } };
        t3.exports = { CATEGORY_CONFIG: o3, CATEGORY_EDITOR: p3, CATEGORY_FORMAT: r3, CATEGORY_OTHER: i, CATEGORY_OUTPUT: m3, CATEGORY_GLOBAL: f3, CATEGORY_SPECIAL: L3, options: s3 };
      } }), Qt2 = S3({ "src/main/support.js"(e28, t3) {
        R3();
        var a3 = { compare: lu2(), lt: Vt2(), gte: Gt2() }, o3 = Xt2(), p3 = Ht2().version, r3 = Wt2().options;
        function i() {
          let { plugins: f3 = [], showUnreleased: L3 = false, showDeprecated: s3 = false, showInternal: D3 = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, E3 = p3.split("-", 1)[0], v3 = f3.flatMap((O3) => O3.languages || []).filter(T3), F3 = o3(Object.assign({}, ...f3.map((O3) => {
            let { options: G3 } = O3;
            return G3;
          }), r3), "name").filter((O3) => T3(O3) && $3(O3)).sort((O3, G3) => O3.name === G3.name ? 0 : O3.name < G3.name ? -1 : 1).map(X3).map((O3) => {
            O3 = Object.assign({}, O3), Array.isArray(O3.default) && (O3.default = O3.default.length === 1 ? O3.default[0].value : O3.default.filter(T3).sort((W3, se2) => a3.compare(se2.since, W3.since))[0].value), Array.isArray(O3.choices) && (O3.choices = O3.choices.filter((W3) => T3(W3) && $3(W3)), O3.name === "parser" && m3(O3, v3, f3));
            let G3 = Object.fromEntries(f3.filter((W3) => W3.defaultOptions && W3.defaultOptions[O3.name] !== void 0).map((W3) => [W3.name, W3.defaultOptions[O3.name]]));
            return Object.assign(Object.assign({}, O3), {}, { pluginDefaults: G3 });
          });
          return { languages: v3, options: F3 };
          function T3(O3) {
            return L3 || !("since" in O3) || O3.since && a3.gte(E3, O3.since);
          }
          function $3(O3) {
            return s3 || !("deprecated" in O3) || O3.deprecated && a3.lt(E3, O3.deprecated);
          }
          function X3(O3) {
            return D3 ? O3 : d3(O3, l3);
          }
        }
        function m3(f3, L3, s3) {
          let D3 = new Set(f3.choices.map((E3) => E3.value));
          for (let E3 of L3)
            if (E3.parsers) {
              for (let v3 of E3.parsers)
                if (!D3.has(v3)) {
                  D3.add(v3);
                  let F3 = s3.find(($3) => $3.parsers && $3.parsers[v3]), T3 = E3.name;
                  F3 && F3.name && (T3 += ` (plugin: ${F3.name})`), f3.choices.push({ value: v3, description: T3 });
                }
            }
        }
        t3.exports = { getSupportInfo: i };
      } }), Yt2 = S3({ "src/utils/is-non-empty-array.js"(e28, t3) {
        R3();
        function a3(o3) {
          return Array.isArray(o3) && o3.length > 0;
        }
        t3.exports = a3;
      } });
      function Jt2() {
        let { onlyFirst: e28 = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t3 = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
        return new RegExp(t3, e28 ? void 0 : "g");
      }
      var Kt2 = q3({ "node_modules/strip-ansi/node_modules/ansi-regex/index.js"() {
        R3();
      } });
      function Zt2(e28) {
        if (typeof e28 != "string")
          throw new TypeError(`Expected a \`string\`, got \`${typeof e28}\``);
        return e28.replace(Jt2(), "");
      }
      var er2 = q3({ "node_modules/strip-ansi/index.js"() {
        R3(), Kt2();
      } });
      function ur2(e28) {
        return Number.isInteger(e28) ? e28 >= 4352 && (e28 <= 4447 || e28 === 9001 || e28 === 9002 || 11904 <= e28 && e28 <= 12871 && e28 !== 12351 || 12880 <= e28 && e28 <= 19903 || 19968 <= e28 && e28 <= 42182 || 43360 <= e28 && e28 <= 43388 || 44032 <= e28 && e28 <= 55203 || 63744 <= e28 && e28 <= 64255 || 65040 <= e28 && e28 <= 65049 || 65072 <= e28 && e28 <= 65131 || 65281 <= e28 && e28 <= 65376 || 65504 <= e28 && e28 <= 65510 || 110592 <= e28 && e28 <= 110593 || 127488 <= e28 && e28 <= 127569 || 131072 <= e28 && e28 <= 262141) : false;
      }
      var tr2 = q3({ "node_modules/is-fullwidth-code-point/index.js"() {
        R3();
      } }), rr2 = S3({ "node_modules/emoji-regex/index.js"(e28, t3) {
        R3(), t3.exports = function() {
          return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
        };
      } }), Ou2 = {};
      U3(Ou2, { default: () => nr2 });
      function nr2(e28) {
        if (typeof e28 != "string" || e28.length === 0 || (e28 = Zt2(e28), e28.length === 0))
          return 0;
        e28 = e28.replace((0, Pu2.default)(), "  ");
        let t3 = 0;
        for (let a3 = 0; a3 < e28.length; a3++) {
          let o3 = e28.codePointAt(a3);
          o3 <= 31 || o3 >= 127 && o3 <= 159 || o3 >= 768 && o3 <= 879 || (o3 > 65535 && a3++, t3 += ur2(o3) ? 2 : 1);
        }
        return t3;
      }
      var Pu2, sr2 = q3({ "node_modules/string-width/index.js"() {
        R3(), er2(), tr2(), Pu2 = H3(rr2());
      } }), ir2 = S3({ "src/utils/get-string-width.js"(e28, t3) {
        R3();
        var a3 = (sr2(), Y3(Ou2)).default, o3 = /[^\x20-\x7F]/;
        function p3(r3) {
          return r3 ? o3.test(r3) ? a3(r3) : r3.length : 0;
        }
        t3.exports = p3;
      } }), cu2 = S3({ "src/utils/text/skip.js"(e28, t3) {
        R3();
        function a3(m3) {
          return (f3, L3, s3) => {
            let D3 = s3 && s3.backwards;
            if (L3 === false)
              return false;
            let { length: E3 } = f3, v3 = L3;
            for (; v3 >= 0 && v3 < E3; ) {
              let F3 = f3.charAt(v3);
              if (m3 instanceof RegExp) {
                if (!m3.test(F3))
                  return v3;
              } else if (!m3.includes(F3))
                return v3;
              D3 ? v3-- : v3++;
            }
            return v3 === -1 || v3 === E3 ? v3 : false;
          };
        }
        var o3 = a3(/\s/), p3 = a3(" 	"), r3 = a3(",; 	"), i = a3(/[^\n\r]/);
        t3.exports = { skipWhitespace: o3, skipSpaces: p3, skipToLineEnd: r3, skipEverythingButNewLine: i };
      } }), Ru2 = S3({ "src/utils/text/skip-inline-comment.js"(e28, t3) {
        R3();
        function a3(o3, p3) {
          if (p3 === false)
            return false;
          if (o3.charAt(p3) === "/" && o3.charAt(p3 + 1) === "*") {
            for (let r3 = p3 + 2; r3 < o3.length; ++r3)
              if (o3.charAt(r3) === "*" && o3.charAt(r3 + 1) === "/")
                return r3 + 2;
          }
          return p3;
        }
        t3.exports = a3;
      } }), Iu2 = S3({ "src/utils/text/skip-trailing-comment.js"(e28, t3) {
        R3();
        var { skipEverythingButNewLine: a3 } = cu2();
        function o3(p3, r3) {
          return r3 === false ? false : p3.charAt(r3) === "/" && p3.charAt(r3 + 1) === "/" ? a3(p3, r3) : r3;
        }
        t3.exports = o3;
      } }), Lu2 = S3({ "src/utils/text/skip-newline.js"(e28, t3) {
        R3();
        function a3(o3, p3, r3) {
          let i = r3 && r3.backwards;
          if (p3 === false)
            return false;
          let m3 = o3.charAt(p3);
          if (i) {
            if (o3.charAt(p3 - 1) === "\r" && m3 === `
`)
              return p3 - 2;
            if (m3 === `
` || m3 === "\r" || m3 === "\u2028" || m3 === "\u2029")
              return p3 - 1;
          } else {
            if (m3 === "\r" && o3.charAt(p3 + 1) === `
`)
              return p3 + 2;
            if (m3 === `
` || m3 === "\r" || m3 === "\u2028" || m3 === "\u2029")
              return p3 + 1;
          }
          return p3;
        }
        t3.exports = a3;
      } }), ar2 = S3({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(e28, t3) {
        R3();
        var a3 = Ru2(), o3 = Lu2(), p3 = Iu2(), { skipSpaces: r3 } = cu2();
        function i(m3, f3) {
          let L3 = null, s3 = f3;
          for (; s3 !== L3; )
            L3 = s3, s3 = r3(m3, s3), s3 = a3(m3, s3), s3 = p3(m3, s3), s3 = o3(m3, s3);
          return s3;
        }
        t3.exports = i;
      } }), or2 = S3({ "src/common/util.js"(e28, t3) {
        R3();
        var { default: a3 } = (ze2(), Y3($e2)), o3 = ke2(), { getSupportInfo: p3 } = Qt2(), r3 = Yt2(), i = ir2(), { skipWhitespace: m3, skipSpaces: f3, skipToLineEnd: L3, skipEverythingButNewLine: s3 } = cu2(), D3 = Ru2(), E3 = Iu2(), v3 = Lu2(), F3 = ar2(), T3 = (k3) => k3[k3.length - 2];
        function $3(k3) {
          return (I3, j3, V10) => {
            let ue2 = V10 && V10.backwards;
            if (j3 === false)
              return false;
            let { length: ie2 } = I3, ae2 = j3;
            for (; ae2 >= 0 && ae2 < ie2; ) {
              let Ce2 = I3.charAt(ae2);
              if (k3 instanceof RegExp) {
                if (!k3.test(Ce2))
                  return ae2;
              } else if (!k3.includes(Ce2))
                return ae2;
              ue2 ? ae2-- : ae2++;
            }
            return ae2 === -1 || ae2 === ie2 ? ae2 : false;
          };
        }
        function X3(k3, I3) {
          let j3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, V10 = f3(k3, j3.backwards ? I3 - 1 : I3, j3), ue2 = v3(k3, V10, j3);
          return V10 !== ue2;
        }
        function O3(k3, I3, j3) {
          for (let V10 = I3; V10 < j3; ++V10)
            if (k3.charAt(V10) === `
`)
              return true;
          return false;
        }
        function G3(k3, I3, j3) {
          let V10 = j3(I3) - 1;
          V10 = f3(k3, V10, { backwards: true }), V10 = v3(k3, V10, { backwards: true }), V10 = f3(k3, V10, { backwards: true });
          let ue2 = v3(k3, V10, { backwards: true });
          return V10 !== ue2;
        }
        function W3(k3, I3) {
          let j3 = null, V10 = I3;
          for (; V10 !== j3; )
            j3 = V10, V10 = L3(k3, V10), V10 = D3(k3, V10), V10 = f3(k3, V10);
          return V10 = E3(k3, V10), V10 = v3(k3, V10), V10 !== false && X3(k3, V10);
        }
        function se2(k3, I3, j3) {
          return W3(k3, j3(I3));
        }
        function B3(k3, I3, j3) {
          return F3(k3, j3(I3));
        }
        function z3(k3, I3, j3) {
          return k3.charAt(B3(k3, I3, j3));
        }
        function Q3(k3, I3) {
          let j3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return f3(k3, j3.backwards ? I3 - 1 : I3, j3) !== I3;
        }
        function ee2(k3, I3) {
          let j3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, V10 = 0;
          for (let ue2 = j3; ue2 < k3.length; ++ue2)
            k3[ue2] === "	" ? V10 = V10 + I3 - V10 % I3 : V10++;
          return V10;
        }
        function re2(k3, I3) {
          let j3 = k3.lastIndexOf(`
`);
          return j3 === -1 ? 0 : ee2(k3.slice(j3 + 1).match(/^[\t ]*/)[0], I3);
        }
        function u3(k3, I3) {
          let j3 = { quote: '"', regex: /"/g, escaped: "&quot;" }, V10 = { quote: "'", regex: /'/g, escaped: "&apos;" }, ue2 = I3 === "'" ? V10 : j3, ie2 = ue2 === V10 ? j3 : V10, ae2 = ue2;
          if (k3.includes(ue2.quote) || k3.includes(ie2.quote)) {
            let Ce2 = (k3.match(ue2.regex) || []).length, Be2 = (k3.match(ie2.regex) || []).length;
            ae2 = Ce2 > Be2 ? ie2 : ue2;
          }
          return ae2;
        }
        function n3(k3, I3) {
          let j3 = k3.slice(1, -1), V10 = I3.parser === "json" || I3.parser === "json5" && I3.quoteProps === "preserve" && !I3.singleQuote ? '"' : I3.__isInHtmlAttribute ? "'" : u3(j3, I3.singleQuote ? "'" : '"').quote;
          return A3(j3, V10, !(I3.parser === "css" || I3.parser === "less" || I3.parser === "scss" || I3.__embeddedInHtml));
        }
        function A3(k3, I3, j3) {
          let V10 = I3 === '"' ? "'" : '"', ue2 = /\\(.)|(["'])/gs, ie2 = k3.replace(ue2, (ae2, Ce2, Be2) => Ce2 === V10 ? Ce2 : Be2 === I3 ? "\\" + Be2 : Be2 || (j3 && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(Ce2) ? Ce2 : "\\" + Ce2));
          return I3 + ie2 + I3;
        }
        function C3(k3) {
          return k3.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
        }
        function b3(k3, I3) {
          let j3 = k3.match(new RegExp(`(${a3(I3)})+`, "g"));
          return j3 === null ? 0 : j3.reduce((V10, ue2) => Math.max(V10, ue2.length / I3.length), 0);
        }
        function K3(k3, I3) {
          let j3 = k3.match(new RegExp(`(${a3(I3)})+`, "g"));
          if (j3 === null)
            return 0;
          let V10 = /* @__PURE__ */ new Map(), ue2 = 0;
          for (let ie2 of j3) {
            let ae2 = ie2.length / I3.length;
            V10.set(ae2, true), ae2 > ue2 && (ue2 = ae2);
          }
          for (let ie2 = 1; ie2 < ue2; ie2++)
            if (!V10.get(ie2))
              return ie2;
          return ue2 + 1;
        }
        function te2(k3, I3) {
          (k3.comments || (k3.comments = [])).push(I3), I3.printed = false, I3.nodeDescription = Fe2(k3);
        }
        function le2(k3, I3) {
          I3.leading = true, I3.trailing = false, te2(k3, I3);
        }
        function oe2(k3, I3, j3) {
          I3.leading = false, I3.trailing = false, j3 && (I3.marker = j3), te2(k3, I3);
        }
        function he2(k3, I3) {
          I3.leading = false, I3.trailing = true, te2(k3, I3);
        }
        function de2(k3, I3) {
          let { languages: j3 } = p3({ plugins: I3.plugins }), V10 = j3.find((ue2) => {
            let { name: ie2 } = ue2;
            return ie2.toLowerCase() === k3;
          }) || j3.find((ue2) => {
            let { aliases: ie2 } = ue2;
            return Array.isArray(ie2) && ie2.includes(k3);
          }) || j3.find((ue2) => {
            let { extensions: ie2 } = ue2;
            return Array.isArray(ie2) && ie2.includes(`.${k3}`);
          });
          return V10 && V10.parsers[0];
        }
        function fe2(k3) {
          return k3 && k3.type === "front-matter";
        }
        function ge2(k3) {
          let I3 = /* @__PURE__ */ new WeakMap();
          return function(j3) {
            return I3.has(j3) || I3.set(j3, Symbol(k3)), I3.get(j3);
          };
        }
        function Fe2(k3) {
          let I3 = k3.type || k3.kind || "(unknown type)", j3 = String(k3.name || k3.id && (typeof k3.id == "object" ? k3.id.name : k3.id) || k3.key && (typeof k3.key == "object" ? k3.key.name : k3.key) || k3.value && (typeof k3.value == "object" ? "" : String(k3.value)) || k3.operator || "");
          return j3.length > 20 && (j3 = j3.slice(0, 19) + "\u2026"), I3 + (j3 ? " " + j3 : "");
        }
        t3.exports = { inferParserByLanguage: de2, getStringWidth: i, getMaxContinuousCount: b3, getMinNotPresentContinuousCount: K3, getPenultimate: T3, getLast: o3, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: F3, getNextNonSpaceNonCommentCharacterIndex: B3, getNextNonSpaceNonCommentCharacter: z3, skip: $3, skipWhitespace: m3, skipSpaces: f3, skipToLineEnd: L3, skipEverythingButNewLine: s3, skipInlineComment: D3, skipTrailingComment: E3, skipNewline: v3, isNextLineEmptyAfterIndex: W3, isNextLineEmpty: se2, isPreviousLineEmpty: G3, hasNewline: X3, hasNewlineInRange: O3, hasSpaces: Q3, getAlignmentSize: ee2, getIndentSize: re2, getPreferredQuote: u3, printString: n3, printNumber: C3, makeString: A3, addLeadingComment: le2, addDanglingComment: oe2, addTrailingComment: he2, isFrontMatterNode: fe2, isNonEmptyArray: r3, createGroupIdMapper: ge2 };
      } }), Dr2 = S3({ "vendors/html-tag-names.json"(e28, t3) {
        t3.exports = { htmlTagNames: ["a", "abbr", "acronym", "address", "applet", "area", "article", "aside", "audio", "b", "base", "basefont", "bdi", "bdo", "bgsound", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "command", "content", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "embed", "fieldset", "figcaption", "figure", "font", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "image", "img", "input", "ins", "isindex", "kbd", "keygen", "label", "legend", "li", "link", "listing", "main", "map", "mark", "marquee", "math", "menu", "menuitem", "meta", "meter", "multicol", "nav", "nextid", "nobr", "noembed", "noframes", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "plaintext", "pre", "progress", "q", "rb", "rbc", "rp", "rt", "rtc", "ruby", "s", "samp", "script", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "tt", "u", "ul", "var", "video", "wbr", "xmp"] };
      } }), $u2 = S3({ "src/language-html/utils/array-to-map.js"(e28, t3) {
        R3();
        function a3(o3) {
          let p3 = /* @__PURE__ */ Object.create(null);
          for (let r3 of o3)
            p3[r3] = true;
          return p3;
        }
        t3.exports = a3;
      } }), lr2 = S3({ "src/language-html/utils/html-tag-names.js"(e28, t3) {
        R3();
        var { htmlTagNames: a3 } = Dr2(), o3 = $u2(), p3 = o3(a3);
        t3.exports = p3;
      } }), cr2 = S3({ "vendors/html-element-attributes.json"(e28, t3) {
        t3.exports = { htmlElementAttributes: { "*": ["accesskey", "autocapitalize", "autofocus", "class", "contenteditable", "dir", "draggable", "enterkeyhint", "hidden", "id", "inputmode", "is", "itemid", "itemprop", "itemref", "itemscope", "itemtype", "lang", "nonce", "slot", "spellcheck", "style", "tabindex", "title", "translate"], a: ["charset", "coords", "download", "href", "hreflang", "name", "ping", "referrerpolicy", "rel", "rev", "shape", "target", "type"], applet: ["align", "alt", "archive", "code", "codebase", "height", "hspace", "name", "object", "vspace", "width"], area: ["alt", "coords", "download", "href", "hreflang", "nohref", "ping", "referrerpolicy", "rel", "shape", "target", "type"], audio: ["autoplay", "controls", "crossorigin", "loop", "muted", "preload", "src"], base: ["href", "target"], basefont: ["color", "face", "size"], blockquote: ["cite"], body: ["alink", "background", "bgcolor", "link", "text", "vlink"], br: ["clear"], button: ["disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "name", "type", "value"], canvas: ["height", "width"], caption: ["align"], col: ["align", "char", "charoff", "span", "valign", "width"], colgroup: ["align", "char", "charoff", "span", "valign", "width"], data: ["value"], del: ["cite", "datetime"], details: ["open"], dialog: ["open"], dir: ["compact"], div: ["align"], dl: ["compact"], embed: ["height", "src", "type", "width"], fieldset: ["disabled", "form", "name"], font: ["color", "face", "size"], form: ["accept", "accept-charset", "action", "autocomplete", "enctype", "method", "name", "novalidate", "target"], frame: ["frameborder", "longdesc", "marginheight", "marginwidth", "name", "noresize", "scrolling", "src"], frameset: ["cols", "rows"], h1: ["align"], h2: ["align"], h3: ["align"], h4: ["align"], h5: ["align"], h6: ["align"], head: ["profile"], hr: ["align", "noshade", "size", "width"], html: ["manifest", "version"], iframe: ["align", "allow", "allowfullscreen", "allowpaymentrequest", "allowusermedia", "frameborder", "height", "loading", "longdesc", "marginheight", "marginwidth", "name", "referrerpolicy", "sandbox", "scrolling", "src", "srcdoc", "width"], img: ["align", "alt", "border", "crossorigin", "decoding", "height", "hspace", "ismap", "loading", "longdesc", "name", "referrerpolicy", "sizes", "src", "srcset", "usemap", "vspace", "width"], input: ["accept", "align", "alt", "autocomplete", "checked", "dirname", "disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "height", "ismap", "list", "max", "maxlength", "min", "minlength", "multiple", "name", "pattern", "placeholder", "readonly", "required", "size", "src", "step", "type", "usemap", "value", "width"], ins: ["cite", "datetime"], isindex: ["prompt"], label: ["for", "form"], legend: ["align"], li: ["type", "value"], link: ["as", "charset", "color", "crossorigin", "disabled", "href", "hreflang", "imagesizes", "imagesrcset", "integrity", "media", "referrerpolicy", "rel", "rev", "sizes", "target", "type"], map: ["name"], menu: ["compact"], meta: ["charset", "content", "http-equiv", "media", "name", "scheme"], meter: ["high", "low", "max", "min", "optimum", "value"], object: ["align", "archive", "border", "classid", "codebase", "codetype", "data", "declare", "form", "height", "hspace", "name", "standby", "type", "typemustmatch", "usemap", "vspace", "width"], ol: ["compact", "reversed", "start", "type"], optgroup: ["disabled", "label"], option: ["disabled", "label", "selected", "value"], output: ["for", "form", "name"], p: ["align"], param: ["name", "type", "value", "valuetype"], pre: ["width"], progress: ["max", "value"], q: ["cite"], script: ["async", "charset", "crossorigin", "defer", "integrity", "language", "nomodule", "referrerpolicy", "src", "type"], select: ["autocomplete", "disabled", "form", "multiple", "name", "required", "size"], slot: ["name"], source: ["height", "media", "sizes", "src", "srcset", "type", "width"], style: ["media", "type"], table: ["align", "bgcolor", "border", "cellpadding", "cellspacing", "frame", "rules", "summary", "width"], tbody: ["align", "char", "charoff", "valign"], td: ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"], textarea: ["autocomplete", "cols", "dirname", "disabled", "form", "maxlength", "minlength", "name", "placeholder", "readonly", "required", "rows", "wrap"], tfoot: ["align", "char", "charoff", "valign"], th: ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"], thead: ["align", "char", "charoff", "valign"], time: ["datetime"], tr: ["align", "bgcolor", "char", "charoff", "valign"], track: ["default", "kind", "label", "src", "srclang"], ul: ["compact", "type"], video: ["autoplay", "controls", "crossorigin", "height", "loop", "muted", "playsinline", "poster", "preload", "src", "width"] } };
      } }), pr2 = S3({ "src/language-html/utils/map-object.js"(e28, t3) {
        R3();
        function a3(o3, p3) {
          let r3 = /* @__PURE__ */ Object.create(null);
          for (let [i, m3] of Object.entries(o3))
            r3[i] = p3(m3, i);
          return r3;
        }
        t3.exports = a3;
      } }), hr2 = S3({ "src/language-html/utils/html-elements-attributes.js"(e28, t3) {
        R3();
        var { htmlElementAttributes: a3 } = cr2(), o3 = pr2(), p3 = $u2(), r3 = o3(a3, p3);
        t3.exports = r3;
      } }), dr2 = S3({ "src/language-html/utils/is-unknown-namespace.js"(e28, t3) {
        R3();
        function a3(o3) {
          return o3.type === "element" && !o3.hasExplicitNamespace && !["html", "svg"].includes(o3.namespace);
        }
        t3.exports = a3;
      } }), Cr2 = S3({ "src/language-html/pragma.js"(e28, t3) {
        R3();
        function a3(p3) {
          return /^\s*<!--\s*@(?:format|prettier)\s*-->/.test(p3);
        }
        function o3(p3) {
          return `<!-- @format -->

` + p3.replace(/^\s*\n/, "");
        }
        t3.exports = { hasPragma: a3, insertPragma: o3 };
      } }), Er2 = S3({ "src/language-html/ast.js"(e28, t3) {
        R3();
        var a3 = { attrs: true, children: true }, o3 = /* @__PURE__ */ new Set(["parent"]), p3 = class {
          constructor() {
            let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            for (let m3 of /* @__PURE__ */ new Set([...o3, ...Object.keys(i)]))
              this.setProperty(m3, i[m3]);
          }
          setProperty(i, m3) {
            if (this[i] !== m3) {
              if (i in a3 && (m3 = m3.map((f3) => this.createChild(f3))), !o3.has(i)) {
                this[i] = m3;
                return;
              }
              Object.defineProperty(this, i, { value: m3, enumerable: false, configurable: true });
            }
          }
          map(i) {
            let m3;
            for (let f3 in a3) {
              let L3 = this[f3];
              if (L3) {
                let s3 = r3(L3, (D3) => D3.map(i));
                m3 !== L3 && (m3 || (m3 = new p3({ parent: this.parent })), m3.setProperty(f3, s3));
              }
            }
            if (m3)
              for (let f3 in this)
                f3 in a3 || (m3[f3] = this[f3]);
            return i(m3 || this);
          }
          walk(i) {
            for (let m3 in a3) {
              let f3 = this[m3];
              if (f3)
                for (let L3 = 0; L3 < f3.length; L3++)
                  f3[L3].walk(i);
            }
            i(this);
          }
          createChild(i) {
            let m3 = i instanceof p3 ? i.clone() : new p3(i);
            return m3.setProperty("parent", this), m3;
          }
          insertChildBefore(i, m3) {
            this.children.splice(this.children.indexOf(i), 0, this.createChild(m3));
          }
          removeChild(i) {
            this.children.splice(this.children.indexOf(i), 1);
          }
          replaceChild(i, m3) {
            this.children[this.children.indexOf(i)] = this.createChild(m3);
          }
          clone() {
            return new p3(this);
          }
          get firstChild() {
            var i;
            return (i = this.children) === null || i === void 0 ? void 0 : i[0];
          }
          get lastChild() {
            var i;
            return (i = this.children) === null || i === void 0 ? void 0 : i[this.children.length - 1];
          }
          get prev() {
            var i;
            return (i = this.parent) === null || i === void 0 ? void 0 : i.children[this.parent.children.indexOf(this) - 1];
          }
          get next() {
            var i;
            return (i = this.parent) === null || i === void 0 ? void 0 : i.children[this.parent.children.indexOf(this) + 1];
          }
          get rawName() {
            return this.hasExplicitNamespace ? this.fullName : this.name;
          }
          get fullName() {
            return this.namespace ? this.namespace + ":" + this.name : this.name;
          }
          get attrMap() {
            return Object.fromEntries(this.attrs.map((i) => [i.fullName, i.value]));
          }
        };
        function r3(i, m3) {
          let f3 = i.map(m3);
          return f3.some((L3, s3) => L3 !== i[s3]) ? f3 : i;
        }
        t3.exports = { Node: p3 };
      } }), mr2 = S3({ "src/language-html/conditional-comment.js"(e28, t3) {
        R3();
        var { ParseSourceSpan: a3 } = _e2(), o3 = [{ regex: /^(\[if([^\]]*)]>)(.*?)<!\s*\[endif]$/s, parse: r3 }, { regex: /^\[if([^\]]*)]><!$/, parse: i }, { regex: /^<!\s*\[endif]$/, parse: m3 }];
        function p3(f3, L3) {
          if (f3.value)
            for (let { regex: s3, parse: D3 } of o3) {
              let E3 = f3.value.match(s3);
              if (E3)
                return D3(f3, L3, E3);
            }
          return null;
        }
        function r3(f3, L3, s3) {
          let [, D3, E3, v3] = s3, F3 = 4 + D3.length, T3 = f3.sourceSpan.start.moveBy(F3), $3 = T3.moveBy(v3.length), [X3, O3] = (() => {
            try {
              return [true, L3(v3, T3).children];
            } catch {
              return [false, [{ type: "text", value: v3, sourceSpan: new a3(T3, $3) }]];
            }
          })();
          return { type: "ieConditionalComment", complete: X3, children: O3, condition: E3.trim().replace(/\s+/g, " "), sourceSpan: f3.sourceSpan, startSourceSpan: new a3(f3.sourceSpan.start, T3), endSourceSpan: new a3($3, f3.sourceSpan.end) };
        }
        function i(f3, L3, s3) {
          let [, D3] = s3;
          return { type: "ieConditionalStartComment", condition: D3.trim().replace(/\s+/g, " "), sourceSpan: f3.sourceSpan };
        }
        function m3(f3) {
          return { type: "ieConditionalEndComment", sourceSpan: f3.sourceSpan };
        }
        t3.exports = { parseIeConditionalComment: p3 };
      } }), fr2 = S3({ "src/language-html/loc.js"(e28, t3) {
        R3();
        function a3(p3) {
          return p3.sourceSpan.start.offset;
        }
        function o3(p3) {
          return p3.sourceSpan.end.offset;
        }
        t3.exports = { locStart: a3, locEnd: o3 };
      } }), Qe2 = S3({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/tags.js"(e28) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true }), function(m3) {
          m3[m3.RAW_TEXT = 0] = "RAW_TEXT", m3[m3.ESCAPABLE_RAW_TEXT = 1] = "ESCAPABLE_RAW_TEXT", m3[m3.PARSABLE_DATA = 2] = "PARSABLE_DATA";
        }(e28.TagContentType || (e28.TagContentType = {}));
        function t3(m3) {
          if (m3[0] != ":")
            return [null, m3];
          let f3 = m3.indexOf(":", 1);
          if (f3 == -1)
            throw new Error(`Unsupported format "${m3}" expecting ":namespace:name"`);
          return [m3.slice(1, f3), m3.slice(f3 + 1)];
        }
        e28.splitNsName = t3;
        function a3(m3) {
          return t3(m3)[1] === "ng-container";
        }
        e28.isNgContainer = a3;
        function o3(m3) {
          return t3(m3)[1] === "ng-content";
        }
        e28.isNgContent = o3;
        function p3(m3) {
          return t3(m3)[1] === "ng-template";
        }
        e28.isNgTemplate = p3;
        function r3(m3) {
          return m3 === null ? null : t3(m3)[0];
        }
        e28.getNsPrefix = r3;
        function i(m3, f3) {
          return m3 ? `:${m3}:${f3}` : f3;
        }
        e28.mergeNsAndName = i, e28.NAMED_ENTITIES = { Aacute: "\xC1", aacute: "\xE1", Abreve: "\u0102", abreve: "\u0103", ac: "\u223E", acd: "\u223F", acE: "\u223E\u0333", Acirc: "\xC2", acirc: "\xE2", acute: "\xB4", Acy: "\u0410", acy: "\u0430", AElig: "\xC6", aelig: "\xE6", af: "\u2061", Afr: "\u{1D504}", afr: "\u{1D51E}", Agrave: "\xC0", agrave: "\xE0", alefsym: "\u2135", aleph: "\u2135", Alpha: "\u0391", alpha: "\u03B1", Amacr: "\u0100", amacr: "\u0101", amalg: "\u2A3F", AMP: "&", amp: "&", And: "\u2A53", and: "\u2227", andand: "\u2A55", andd: "\u2A5C", andslope: "\u2A58", andv: "\u2A5A", ang: "\u2220", ange: "\u29A4", angle: "\u2220", angmsd: "\u2221", angmsdaa: "\u29A8", angmsdab: "\u29A9", angmsdac: "\u29AA", angmsdad: "\u29AB", angmsdae: "\u29AC", angmsdaf: "\u29AD", angmsdag: "\u29AE", angmsdah: "\u29AF", angrt: "\u221F", angrtvb: "\u22BE", angrtvbd: "\u299D", angsph: "\u2222", angst: "\xC5", angzarr: "\u237C", Aogon: "\u0104", aogon: "\u0105", Aopf: "\u{1D538}", aopf: "\u{1D552}", ap: "\u2248", apacir: "\u2A6F", apE: "\u2A70", ape: "\u224A", apid: "\u224B", apos: "'", ApplyFunction: "\u2061", approx: "\u2248", approxeq: "\u224A", Aring: "\xC5", aring: "\xE5", Ascr: "\u{1D49C}", ascr: "\u{1D4B6}", Assign: "\u2254", ast: "*", asymp: "\u2248", asympeq: "\u224D", Atilde: "\xC3", atilde: "\xE3", Auml: "\xC4", auml: "\xE4", awconint: "\u2233", awint: "\u2A11", backcong: "\u224C", backepsilon: "\u03F6", backprime: "\u2035", backsim: "\u223D", backsimeq: "\u22CD", Backslash: "\u2216", Barv: "\u2AE7", barvee: "\u22BD", Barwed: "\u2306", barwed: "\u2305", barwedge: "\u2305", bbrk: "\u23B5", bbrktbrk: "\u23B6", bcong: "\u224C", Bcy: "\u0411", bcy: "\u0431", bdquo: "\u201E", becaus: "\u2235", Because: "\u2235", because: "\u2235", bemptyv: "\u29B0", bepsi: "\u03F6", bernou: "\u212C", Bernoullis: "\u212C", Beta: "\u0392", beta: "\u03B2", beth: "\u2136", between: "\u226C", Bfr: "\u{1D505}", bfr: "\u{1D51F}", bigcap: "\u22C2", bigcirc: "\u25EF", bigcup: "\u22C3", bigodot: "\u2A00", bigoplus: "\u2A01", bigotimes: "\u2A02", bigsqcup: "\u2A06", bigstar: "\u2605", bigtriangledown: "\u25BD", bigtriangleup: "\u25B3", biguplus: "\u2A04", bigvee: "\u22C1", bigwedge: "\u22C0", bkarow: "\u290D", blacklozenge: "\u29EB", blacksquare: "\u25AA", blacktriangle: "\u25B4", blacktriangledown: "\u25BE", blacktriangleleft: "\u25C2", blacktriangleright: "\u25B8", blank: "\u2423", blk12: "\u2592", blk14: "\u2591", blk34: "\u2593", block: "\u2588", bne: "=\u20E5", bnequiv: "\u2261\u20E5", bNot: "\u2AED", bnot: "\u2310", Bopf: "\u{1D539}", bopf: "\u{1D553}", bot: "\u22A5", bottom: "\u22A5", bowtie: "\u22C8", boxbox: "\u29C9", boxDL: "\u2557", boxDl: "\u2556", boxdL: "\u2555", boxdl: "\u2510", boxDR: "\u2554", boxDr: "\u2553", boxdR: "\u2552", boxdr: "\u250C", boxH: "\u2550", boxh: "\u2500", boxHD: "\u2566", boxHd: "\u2564", boxhD: "\u2565", boxhd: "\u252C", boxHU: "\u2569", boxHu: "\u2567", boxhU: "\u2568", boxhu: "\u2534", boxminus: "\u229F", boxplus: "\u229E", boxtimes: "\u22A0", boxUL: "\u255D", boxUl: "\u255C", boxuL: "\u255B", boxul: "\u2518", boxUR: "\u255A", boxUr: "\u2559", boxuR: "\u2558", boxur: "\u2514", boxV: "\u2551", boxv: "\u2502", boxVH: "\u256C", boxVh: "\u256B", boxvH: "\u256A", boxvh: "\u253C", boxVL: "\u2563", boxVl: "\u2562", boxvL: "\u2561", boxvl: "\u2524", boxVR: "\u2560", boxVr: "\u255F", boxvR: "\u255E", boxvr: "\u251C", bprime: "\u2035", Breve: "\u02D8", breve: "\u02D8", brvbar: "\xA6", Bscr: "\u212C", bscr: "\u{1D4B7}", bsemi: "\u204F", bsim: "\u223D", bsime: "\u22CD", bsol: "\\", bsolb: "\u29C5", bsolhsub: "\u27C8", bull: "\u2022", bullet: "\u2022", bump: "\u224E", bumpE: "\u2AAE", bumpe: "\u224F", Bumpeq: "\u224E", bumpeq: "\u224F", Cacute: "\u0106", cacute: "\u0107", Cap: "\u22D2", cap: "\u2229", capand: "\u2A44", capbrcup: "\u2A49", capcap: "\u2A4B", capcup: "\u2A47", capdot: "\u2A40", CapitalDifferentialD: "\u2145", caps: "\u2229\uFE00", caret: "\u2041", caron: "\u02C7", Cayleys: "\u212D", ccaps: "\u2A4D", Ccaron: "\u010C", ccaron: "\u010D", Ccedil: "\xC7", ccedil: "\xE7", Ccirc: "\u0108", ccirc: "\u0109", Cconint: "\u2230", ccups: "\u2A4C", ccupssm: "\u2A50", Cdot: "\u010A", cdot: "\u010B", cedil: "\xB8", Cedilla: "\xB8", cemptyv: "\u29B2", cent: "\xA2", CenterDot: "\xB7", centerdot: "\xB7", Cfr: "\u212D", cfr: "\u{1D520}", CHcy: "\u0427", chcy: "\u0447", check: "\u2713", checkmark: "\u2713", Chi: "\u03A7", chi: "\u03C7", cir: "\u25CB", circ: "\u02C6", circeq: "\u2257", circlearrowleft: "\u21BA", circlearrowright: "\u21BB", circledast: "\u229B", circledcirc: "\u229A", circleddash: "\u229D", CircleDot: "\u2299", circledR: "\xAE", circledS: "\u24C8", CircleMinus: "\u2296", CirclePlus: "\u2295", CircleTimes: "\u2297", cirE: "\u29C3", cire: "\u2257", cirfnint: "\u2A10", cirmid: "\u2AEF", cirscir: "\u29C2", ClockwiseContourIntegral: "\u2232", CloseCurlyDoubleQuote: "\u201D", CloseCurlyQuote: "\u2019", clubs: "\u2663", clubsuit: "\u2663", Colon: "\u2237", colon: ":", Colone: "\u2A74", colone: "\u2254", coloneq: "\u2254", comma: ",", commat: "@", comp: "\u2201", compfn: "\u2218", complement: "\u2201", complexes: "\u2102", cong: "\u2245", congdot: "\u2A6D", Congruent: "\u2261", Conint: "\u222F", conint: "\u222E", ContourIntegral: "\u222E", Copf: "\u2102", copf: "\u{1D554}", coprod: "\u2210", Coproduct: "\u2210", COPY: "\xA9", copy: "\xA9", copysr: "\u2117", CounterClockwiseContourIntegral: "\u2233", crarr: "\u21B5", Cross: "\u2A2F", cross: "\u2717", Cscr: "\u{1D49E}", cscr: "\u{1D4B8}", csub: "\u2ACF", csube: "\u2AD1", csup: "\u2AD0", csupe: "\u2AD2", ctdot: "\u22EF", cudarrl: "\u2938", cudarrr: "\u2935", cuepr: "\u22DE", cuesc: "\u22DF", cularr: "\u21B6", cularrp: "\u293D", Cup: "\u22D3", cup: "\u222A", cupbrcap: "\u2A48", CupCap: "\u224D", cupcap: "\u2A46", cupcup: "\u2A4A", cupdot: "\u228D", cupor: "\u2A45", cups: "\u222A\uFE00", curarr: "\u21B7", curarrm: "\u293C", curlyeqprec: "\u22DE", curlyeqsucc: "\u22DF", curlyvee: "\u22CE", curlywedge: "\u22CF", curren: "\xA4", curvearrowleft: "\u21B6", curvearrowright: "\u21B7", cuvee: "\u22CE", cuwed: "\u22CF", cwconint: "\u2232", cwint: "\u2231", cylcty: "\u232D", Dagger: "\u2021", dagger: "\u2020", daleth: "\u2138", Darr: "\u21A1", dArr: "\u21D3", darr: "\u2193", dash: "\u2010", Dashv: "\u2AE4", dashv: "\u22A3", dbkarow: "\u290F", dblac: "\u02DD", Dcaron: "\u010E", dcaron: "\u010F", Dcy: "\u0414", dcy: "\u0434", DD: "\u2145", dd: "\u2146", ddagger: "\u2021", ddarr: "\u21CA", DDotrahd: "\u2911", ddotseq: "\u2A77", deg: "\xB0", Del: "\u2207", Delta: "\u0394", delta: "\u03B4", demptyv: "\u29B1", dfisht: "\u297F", Dfr: "\u{1D507}", dfr: "\u{1D521}", dHar: "\u2965", dharl: "\u21C3", dharr: "\u21C2", DiacriticalAcute: "\xB4", DiacriticalDot: "\u02D9", DiacriticalDoubleAcute: "\u02DD", DiacriticalGrave: "`", DiacriticalTilde: "\u02DC", diam: "\u22C4", Diamond: "\u22C4", diamond: "\u22C4", diamondsuit: "\u2666", diams: "\u2666", die: "\xA8", DifferentialD: "\u2146", digamma: "\u03DD", disin: "\u22F2", div: "\xF7", divide: "\xF7", divideontimes: "\u22C7", divonx: "\u22C7", DJcy: "\u0402", djcy: "\u0452", dlcorn: "\u231E", dlcrop: "\u230D", dollar: "$", Dopf: "\u{1D53B}", dopf: "\u{1D555}", Dot: "\xA8", dot: "\u02D9", DotDot: "\u20DC", doteq: "\u2250", doteqdot: "\u2251", DotEqual: "\u2250", dotminus: "\u2238", dotplus: "\u2214", dotsquare: "\u22A1", doublebarwedge: "\u2306", DoubleContourIntegral: "\u222F", DoubleDot: "\xA8", DoubleDownArrow: "\u21D3", DoubleLeftArrow: "\u21D0", DoubleLeftRightArrow: "\u21D4", DoubleLeftTee: "\u2AE4", DoubleLongLeftArrow: "\u27F8", DoubleLongLeftRightArrow: "\u27FA", DoubleLongRightArrow: "\u27F9", DoubleRightArrow: "\u21D2", DoubleRightTee: "\u22A8", DoubleUpArrow: "\u21D1", DoubleUpDownArrow: "\u21D5", DoubleVerticalBar: "\u2225", DownArrow: "\u2193", Downarrow: "\u21D3", downarrow: "\u2193", DownArrowBar: "\u2913", DownArrowUpArrow: "\u21F5", DownBreve: "\u0311", downdownarrows: "\u21CA", downharpoonleft: "\u21C3", downharpoonright: "\u21C2", DownLeftRightVector: "\u2950", DownLeftTeeVector: "\u295E", DownLeftVector: "\u21BD", DownLeftVectorBar: "\u2956", DownRightTeeVector: "\u295F", DownRightVector: "\u21C1", DownRightVectorBar: "\u2957", DownTee: "\u22A4", DownTeeArrow: "\u21A7", drbkarow: "\u2910", drcorn: "\u231F", drcrop: "\u230C", Dscr: "\u{1D49F}", dscr: "\u{1D4B9}", DScy: "\u0405", dscy: "\u0455", dsol: "\u29F6", Dstrok: "\u0110", dstrok: "\u0111", dtdot: "\u22F1", dtri: "\u25BF", dtrif: "\u25BE", duarr: "\u21F5", duhar: "\u296F", dwangle: "\u29A6", DZcy: "\u040F", dzcy: "\u045F", dzigrarr: "\u27FF", Eacute: "\xC9", eacute: "\xE9", easter: "\u2A6E", Ecaron: "\u011A", ecaron: "\u011B", ecir: "\u2256", Ecirc: "\xCA", ecirc: "\xEA", ecolon: "\u2255", Ecy: "\u042D", ecy: "\u044D", eDDot: "\u2A77", Edot: "\u0116", eDot: "\u2251", edot: "\u0117", ee: "\u2147", efDot: "\u2252", Efr: "\u{1D508}", efr: "\u{1D522}", eg: "\u2A9A", Egrave: "\xC8", egrave: "\xE8", egs: "\u2A96", egsdot: "\u2A98", el: "\u2A99", Element: "\u2208", elinters: "\u23E7", ell: "\u2113", els: "\u2A95", elsdot: "\u2A97", Emacr: "\u0112", emacr: "\u0113", empty: "\u2205", emptyset: "\u2205", EmptySmallSquare: "\u25FB", emptyv: "\u2205", EmptyVerySmallSquare: "\u25AB", emsp: "\u2003", emsp13: "\u2004", emsp14: "\u2005", ENG: "\u014A", eng: "\u014B", ensp: "\u2002", Eogon: "\u0118", eogon: "\u0119", Eopf: "\u{1D53C}", eopf: "\u{1D556}", epar: "\u22D5", eparsl: "\u29E3", eplus: "\u2A71", epsi: "\u03B5", Epsilon: "\u0395", epsilon: "\u03B5", epsiv: "\u03F5", eqcirc: "\u2256", eqcolon: "\u2255", eqsim: "\u2242", eqslantgtr: "\u2A96", eqslantless: "\u2A95", Equal: "\u2A75", equals: "=", EqualTilde: "\u2242", equest: "\u225F", Equilibrium: "\u21CC", equiv: "\u2261", equivDD: "\u2A78", eqvparsl: "\u29E5", erarr: "\u2971", erDot: "\u2253", Escr: "\u2130", escr: "\u212F", esdot: "\u2250", Esim: "\u2A73", esim: "\u2242", Eta: "\u0397", eta: "\u03B7", ETH: "\xD0", eth: "\xF0", Euml: "\xCB", euml: "\xEB", euro: "\u20AC", excl: "!", exist: "\u2203", Exists: "\u2203", expectation: "\u2130", ExponentialE: "\u2147", exponentiale: "\u2147", fallingdotseq: "\u2252", Fcy: "\u0424", fcy: "\u0444", female: "\u2640", ffilig: "\uFB03", fflig: "\uFB00", ffllig: "\uFB04", Ffr: "\u{1D509}", ffr: "\u{1D523}", filig: "\uFB01", FilledSmallSquare: "\u25FC", FilledVerySmallSquare: "\u25AA", fjlig: "fj", flat: "\u266D", fllig: "\uFB02", fltns: "\u25B1", fnof: "\u0192", Fopf: "\u{1D53D}", fopf: "\u{1D557}", ForAll: "\u2200", forall: "\u2200", fork: "\u22D4", forkv: "\u2AD9", Fouriertrf: "\u2131", fpartint: "\u2A0D", frac12: "\xBD", frac13: "\u2153", frac14: "\xBC", frac15: "\u2155", frac16: "\u2159", frac18: "\u215B", frac23: "\u2154", frac25: "\u2156", frac34: "\xBE", frac35: "\u2157", frac38: "\u215C", frac45: "\u2158", frac56: "\u215A", frac58: "\u215D", frac78: "\u215E", frasl: "\u2044", frown: "\u2322", Fscr: "\u2131", fscr: "\u{1D4BB}", gacute: "\u01F5", Gamma: "\u0393", gamma: "\u03B3", Gammad: "\u03DC", gammad: "\u03DD", gap: "\u2A86", Gbreve: "\u011E", gbreve: "\u011F", Gcedil: "\u0122", Gcirc: "\u011C", gcirc: "\u011D", Gcy: "\u0413", gcy: "\u0433", Gdot: "\u0120", gdot: "\u0121", gE: "\u2267", ge: "\u2265", gEl: "\u2A8C", gel: "\u22DB", geq: "\u2265", geqq: "\u2267", geqslant: "\u2A7E", ges: "\u2A7E", gescc: "\u2AA9", gesdot: "\u2A80", gesdoto: "\u2A82", gesdotol: "\u2A84", gesl: "\u22DB\uFE00", gesles: "\u2A94", Gfr: "\u{1D50A}", gfr: "\u{1D524}", Gg: "\u22D9", gg: "\u226B", ggg: "\u22D9", gimel: "\u2137", GJcy: "\u0403", gjcy: "\u0453", gl: "\u2277", gla: "\u2AA5", glE: "\u2A92", glj: "\u2AA4", gnap: "\u2A8A", gnapprox: "\u2A8A", gnE: "\u2269", gne: "\u2A88", gneq: "\u2A88", gneqq: "\u2269", gnsim: "\u22E7", Gopf: "\u{1D53E}", gopf: "\u{1D558}", grave: "`", GreaterEqual: "\u2265", GreaterEqualLess: "\u22DB", GreaterFullEqual: "\u2267", GreaterGreater: "\u2AA2", GreaterLess: "\u2277", GreaterSlantEqual: "\u2A7E", GreaterTilde: "\u2273", Gscr: "\u{1D4A2}", gscr: "\u210A", gsim: "\u2273", gsime: "\u2A8E", gsiml: "\u2A90", GT: ">", Gt: "\u226B", gt: ">", gtcc: "\u2AA7", gtcir: "\u2A7A", gtdot: "\u22D7", gtlPar: "\u2995", gtquest: "\u2A7C", gtrapprox: "\u2A86", gtrarr: "\u2978", gtrdot: "\u22D7", gtreqless: "\u22DB", gtreqqless: "\u2A8C", gtrless: "\u2277", gtrsim: "\u2273", gvertneqq: "\u2269\uFE00", gvnE: "\u2269\uFE00", Hacek: "\u02C7", hairsp: "\u200A", half: "\xBD", hamilt: "\u210B", HARDcy: "\u042A", hardcy: "\u044A", hArr: "\u21D4", harr: "\u2194", harrcir: "\u2948", harrw: "\u21AD", Hat: "^", hbar: "\u210F", Hcirc: "\u0124", hcirc: "\u0125", hearts: "\u2665", heartsuit: "\u2665", hellip: "\u2026", hercon: "\u22B9", Hfr: "\u210C", hfr: "\u{1D525}", HilbertSpace: "\u210B", hksearow: "\u2925", hkswarow: "\u2926", hoarr: "\u21FF", homtht: "\u223B", hookleftarrow: "\u21A9", hookrightarrow: "\u21AA", Hopf: "\u210D", hopf: "\u{1D559}", horbar: "\u2015", HorizontalLine: "\u2500", Hscr: "\u210B", hscr: "\u{1D4BD}", hslash: "\u210F", Hstrok: "\u0126", hstrok: "\u0127", HumpDownHump: "\u224E", HumpEqual: "\u224F", hybull: "\u2043", hyphen: "\u2010", Iacute: "\xCD", iacute: "\xED", ic: "\u2063", Icirc: "\xCE", icirc: "\xEE", Icy: "\u0418", icy: "\u0438", Idot: "\u0130", IEcy: "\u0415", iecy: "\u0435", iexcl: "\xA1", iff: "\u21D4", Ifr: "\u2111", ifr: "\u{1D526}", Igrave: "\xCC", igrave: "\xEC", ii: "\u2148", iiiint: "\u2A0C", iiint: "\u222D", iinfin: "\u29DC", iiota: "\u2129", IJlig: "\u0132", ijlig: "\u0133", Im: "\u2111", Imacr: "\u012A", imacr: "\u012B", image: "\u2111", ImaginaryI: "\u2148", imagline: "\u2110", imagpart: "\u2111", imath: "\u0131", imof: "\u22B7", imped: "\u01B5", Implies: "\u21D2", in: "\u2208", incare: "\u2105", infin: "\u221E", infintie: "\u29DD", inodot: "\u0131", Int: "\u222C", int: "\u222B", intcal: "\u22BA", integers: "\u2124", Integral: "\u222B", intercal: "\u22BA", Intersection: "\u22C2", intlarhk: "\u2A17", intprod: "\u2A3C", InvisibleComma: "\u2063", InvisibleTimes: "\u2062", IOcy: "\u0401", iocy: "\u0451", Iogon: "\u012E", iogon: "\u012F", Iopf: "\u{1D540}", iopf: "\u{1D55A}", Iota: "\u0399", iota: "\u03B9", iprod: "\u2A3C", iquest: "\xBF", Iscr: "\u2110", iscr: "\u{1D4BE}", isin: "\u2208", isindot: "\u22F5", isinE: "\u22F9", isins: "\u22F4", isinsv: "\u22F3", isinv: "\u2208", it: "\u2062", Itilde: "\u0128", itilde: "\u0129", Iukcy: "\u0406", iukcy: "\u0456", Iuml: "\xCF", iuml: "\xEF", Jcirc: "\u0134", jcirc: "\u0135", Jcy: "\u0419", jcy: "\u0439", Jfr: "\u{1D50D}", jfr: "\u{1D527}", jmath: "\u0237", Jopf: "\u{1D541}", jopf: "\u{1D55B}", Jscr: "\u{1D4A5}", jscr: "\u{1D4BF}", Jsercy: "\u0408", jsercy: "\u0458", Jukcy: "\u0404", jukcy: "\u0454", Kappa: "\u039A", kappa: "\u03BA", kappav: "\u03F0", Kcedil: "\u0136", kcedil: "\u0137", Kcy: "\u041A", kcy: "\u043A", Kfr: "\u{1D50E}", kfr: "\u{1D528}", kgreen: "\u0138", KHcy: "\u0425", khcy: "\u0445", KJcy: "\u040C", kjcy: "\u045C", Kopf: "\u{1D542}", kopf: "\u{1D55C}", Kscr: "\u{1D4A6}", kscr: "\u{1D4C0}", lAarr: "\u21DA", Lacute: "\u0139", lacute: "\u013A", laemptyv: "\u29B4", lagran: "\u2112", Lambda: "\u039B", lambda: "\u03BB", Lang: "\u27EA", lang: "\u27E8", langd: "\u2991", langle: "\u27E8", lap: "\u2A85", Laplacetrf: "\u2112", laquo: "\xAB", Larr: "\u219E", lArr: "\u21D0", larr: "\u2190", larrb: "\u21E4", larrbfs: "\u291F", larrfs: "\u291D", larrhk: "\u21A9", larrlp: "\u21AB", larrpl: "\u2939", larrsim: "\u2973", larrtl: "\u21A2", lat: "\u2AAB", lAtail: "\u291B", latail: "\u2919", late: "\u2AAD", lates: "\u2AAD\uFE00", lBarr: "\u290E", lbarr: "\u290C", lbbrk: "\u2772", lbrace: "{", lbrack: "[", lbrke: "\u298B", lbrksld: "\u298F", lbrkslu: "\u298D", Lcaron: "\u013D", lcaron: "\u013E", Lcedil: "\u013B", lcedil: "\u013C", lceil: "\u2308", lcub: "{", Lcy: "\u041B", lcy: "\u043B", ldca: "\u2936", ldquo: "\u201C", ldquor: "\u201E", ldrdhar: "\u2967", ldrushar: "\u294B", ldsh: "\u21B2", lE: "\u2266", le: "\u2264", LeftAngleBracket: "\u27E8", LeftArrow: "\u2190", Leftarrow: "\u21D0", leftarrow: "\u2190", LeftArrowBar: "\u21E4", LeftArrowRightArrow: "\u21C6", leftarrowtail: "\u21A2", LeftCeiling: "\u2308", LeftDoubleBracket: "\u27E6", LeftDownTeeVector: "\u2961", LeftDownVector: "\u21C3", LeftDownVectorBar: "\u2959", LeftFloor: "\u230A", leftharpoondown: "\u21BD", leftharpoonup: "\u21BC", leftleftarrows: "\u21C7", LeftRightArrow: "\u2194", Leftrightarrow: "\u21D4", leftrightarrow: "\u2194", leftrightarrows: "\u21C6", leftrightharpoons: "\u21CB", leftrightsquigarrow: "\u21AD", LeftRightVector: "\u294E", LeftTee: "\u22A3", LeftTeeArrow: "\u21A4", LeftTeeVector: "\u295A", leftthreetimes: "\u22CB", LeftTriangle: "\u22B2", LeftTriangleBar: "\u29CF", LeftTriangleEqual: "\u22B4", LeftUpDownVector: "\u2951", LeftUpTeeVector: "\u2960", LeftUpVector: "\u21BF", LeftUpVectorBar: "\u2958", LeftVector: "\u21BC", LeftVectorBar: "\u2952", lEg: "\u2A8B", leg: "\u22DA", leq: "\u2264", leqq: "\u2266", leqslant: "\u2A7D", les: "\u2A7D", lescc: "\u2AA8", lesdot: "\u2A7F", lesdoto: "\u2A81", lesdotor: "\u2A83", lesg: "\u22DA\uFE00", lesges: "\u2A93", lessapprox: "\u2A85", lessdot: "\u22D6", lesseqgtr: "\u22DA", lesseqqgtr: "\u2A8B", LessEqualGreater: "\u22DA", LessFullEqual: "\u2266", LessGreater: "\u2276", lessgtr: "\u2276", LessLess: "\u2AA1", lesssim: "\u2272", LessSlantEqual: "\u2A7D", LessTilde: "\u2272", lfisht: "\u297C", lfloor: "\u230A", Lfr: "\u{1D50F}", lfr: "\u{1D529}", lg: "\u2276", lgE: "\u2A91", lHar: "\u2962", lhard: "\u21BD", lharu: "\u21BC", lharul: "\u296A", lhblk: "\u2584", LJcy: "\u0409", ljcy: "\u0459", Ll: "\u22D8", ll: "\u226A", llarr: "\u21C7", llcorner: "\u231E", Lleftarrow: "\u21DA", llhard: "\u296B", lltri: "\u25FA", Lmidot: "\u013F", lmidot: "\u0140", lmoust: "\u23B0", lmoustache: "\u23B0", lnap: "\u2A89", lnapprox: "\u2A89", lnE: "\u2268", lne: "\u2A87", lneq: "\u2A87", lneqq: "\u2268", lnsim: "\u22E6", loang: "\u27EC", loarr: "\u21FD", lobrk: "\u27E6", LongLeftArrow: "\u27F5", Longleftarrow: "\u27F8", longleftarrow: "\u27F5", LongLeftRightArrow: "\u27F7", Longleftrightarrow: "\u27FA", longleftrightarrow: "\u27F7", longmapsto: "\u27FC", LongRightArrow: "\u27F6", Longrightarrow: "\u27F9", longrightarrow: "\u27F6", looparrowleft: "\u21AB", looparrowright: "\u21AC", lopar: "\u2985", Lopf: "\u{1D543}", lopf: "\u{1D55D}", loplus: "\u2A2D", lotimes: "\u2A34", lowast: "\u2217", lowbar: "_", LowerLeftArrow: "\u2199", LowerRightArrow: "\u2198", loz: "\u25CA", lozenge: "\u25CA", lozf: "\u29EB", lpar: "(", lparlt: "\u2993", lrarr: "\u21C6", lrcorner: "\u231F", lrhar: "\u21CB", lrhard: "\u296D", lrm: "\u200E", lrtri: "\u22BF", lsaquo: "\u2039", Lscr: "\u2112", lscr: "\u{1D4C1}", Lsh: "\u21B0", lsh: "\u21B0", lsim: "\u2272", lsime: "\u2A8D", lsimg: "\u2A8F", lsqb: "[", lsquo: "\u2018", lsquor: "\u201A", Lstrok: "\u0141", lstrok: "\u0142", LT: "<", Lt: "\u226A", lt: "<", ltcc: "\u2AA6", ltcir: "\u2A79", ltdot: "\u22D6", lthree: "\u22CB", ltimes: "\u22C9", ltlarr: "\u2976", ltquest: "\u2A7B", ltri: "\u25C3", ltrie: "\u22B4", ltrif: "\u25C2", ltrPar: "\u2996", lurdshar: "\u294A", luruhar: "\u2966", lvertneqq: "\u2268\uFE00", lvnE: "\u2268\uFE00", macr: "\xAF", male: "\u2642", malt: "\u2720", maltese: "\u2720", Map: "\u2905", map: "\u21A6", mapsto: "\u21A6", mapstodown: "\u21A7", mapstoleft: "\u21A4", mapstoup: "\u21A5", marker: "\u25AE", mcomma: "\u2A29", Mcy: "\u041C", mcy: "\u043C", mdash: "\u2014", mDDot: "\u223A", measuredangle: "\u2221", MediumSpace: "\u205F", Mellintrf: "\u2133", Mfr: "\u{1D510}", mfr: "\u{1D52A}", mho: "\u2127", micro: "\xB5", mid: "\u2223", midast: "*", midcir: "\u2AF0", middot: "\xB7", minus: "\u2212", minusb: "\u229F", minusd: "\u2238", minusdu: "\u2A2A", MinusPlus: "\u2213", mlcp: "\u2ADB", mldr: "\u2026", mnplus: "\u2213", models: "\u22A7", Mopf: "\u{1D544}", mopf: "\u{1D55E}", mp: "\u2213", Mscr: "\u2133", mscr: "\u{1D4C2}", mstpos: "\u223E", Mu: "\u039C", mu: "\u03BC", multimap: "\u22B8", mumap: "\u22B8", nabla: "\u2207", Nacute: "\u0143", nacute: "\u0144", nang: "\u2220\u20D2", nap: "\u2249", napE: "\u2A70\u0338", napid: "\u224B\u0338", napos: "\u0149", napprox: "\u2249", natur: "\u266E", natural: "\u266E", naturals: "\u2115", nbsp: "\xA0", nbump: "\u224E\u0338", nbumpe: "\u224F\u0338", ncap: "\u2A43", Ncaron: "\u0147", ncaron: "\u0148", Ncedil: "\u0145", ncedil: "\u0146", ncong: "\u2247", ncongdot: "\u2A6D\u0338", ncup: "\u2A42", Ncy: "\u041D", ncy: "\u043D", ndash: "\u2013", ne: "\u2260", nearhk: "\u2924", neArr: "\u21D7", nearr: "\u2197", nearrow: "\u2197", nedot: "\u2250\u0338", NegativeMediumSpace: "\u200B", NegativeThickSpace: "\u200B", NegativeThinSpace: "\u200B", NegativeVeryThinSpace: "\u200B", nequiv: "\u2262", nesear: "\u2928", nesim: "\u2242\u0338", NestedGreaterGreater: "\u226B", NestedLessLess: "\u226A", NewLine: `
`, nexist: "\u2204", nexists: "\u2204", Nfr: "\u{1D511}", nfr: "\u{1D52B}", ngE: "\u2267\u0338", nge: "\u2271", ngeq: "\u2271", ngeqq: "\u2267\u0338", ngeqslant: "\u2A7E\u0338", nges: "\u2A7E\u0338", nGg: "\u22D9\u0338", ngsim: "\u2275", nGt: "\u226B\u20D2", ngt: "\u226F", ngtr: "\u226F", nGtv: "\u226B\u0338", nhArr: "\u21CE", nharr: "\u21AE", nhpar: "\u2AF2", ni: "\u220B", nis: "\u22FC", nisd: "\u22FA", niv: "\u220B", NJcy: "\u040A", njcy: "\u045A", nlArr: "\u21CD", nlarr: "\u219A", nldr: "\u2025", nlE: "\u2266\u0338", nle: "\u2270", nLeftarrow: "\u21CD", nleftarrow: "\u219A", nLeftrightarrow: "\u21CE", nleftrightarrow: "\u21AE", nleq: "\u2270", nleqq: "\u2266\u0338", nleqslant: "\u2A7D\u0338", nles: "\u2A7D\u0338", nless: "\u226E", nLl: "\u22D8\u0338", nlsim: "\u2274", nLt: "\u226A\u20D2", nlt: "\u226E", nltri: "\u22EA", nltrie: "\u22EC", nLtv: "\u226A\u0338", nmid: "\u2224", NoBreak: "\u2060", NonBreakingSpace: "\xA0", Nopf: "\u2115", nopf: "\u{1D55F}", Not: "\u2AEC", not: "\xAC", NotCongruent: "\u2262", NotCupCap: "\u226D", NotDoubleVerticalBar: "\u2226", NotElement: "\u2209", NotEqual: "\u2260", NotEqualTilde: "\u2242\u0338", NotExists: "\u2204", NotGreater: "\u226F", NotGreaterEqual: "\u2271", NotGreaterFullEqual: "\u2267\u0338", NotGreaterGreater: "\u226B\u0338", NotGreaterLess: "\u2279", NotGreaterSlantEqual: "\u2A7E\u0338", NotGreaterTilde: "\u2275", NotHumpDownHump: "\u224E\u0338", NotHumpEqual: "\u224F\u0338", notin: "\u2209", notindot: "\u22F5\u0338", notinE: "\u22F9\u0338", notinva: "\u2209", notinvb: "\u22F7", notinvc: "\u22F6", NotLeftTriangle: "\u22EA", NotLeftTriangleBar: "\u29CF\u0338", NotLeftTriangleEqual: "\u22EC", NotLess: "\u226E", NotLessEqual: "\u2270", NotLessGreater: "\u2278", NotLessLess: "\u226A\u0338", NotLessSlantEqual: "\u2A7D\u0338", NotLessTilde: "\u2274", NotNestedGreaterGreater: "\u2AA2\u0338", NotNestedLessLess: "\u2AA1\u0338", notni: "\u220C", notniva: "\u220C", notnivb: "\u22FE", notnivc: "\u22FD", NotPrecedes: "\u2280", NotPrecedesEqual: "\u2AAF\u0338", NotPrecedesSlantEqual: "\u22E0", NotReverseElement: "\u220C", NotRightTriangle: "\u22EB", NotRightTriangleBar: "\u29D0\u0338", NotRightTriangleEqual: "\u22ED", NotSquareSubset: "\u228F\u0338", NotSquareSubsetEqual: "\u22E2", NotSquareSuperset: "\u2290\u0338", NotSquareSupersetEqual: "\u22E3", NotSubset: "\u2282\u20D2", NotSubsetEqual: "\u2288", NotSucceeds: "\u2281", NotSucceedsEqual: "\u2AB0\u0338", NotSucceedsSlantEqual: "\u22E1", NotSucceedsTilde: "\u227F\u0338", NotSuperset: "\u2283\u20D2", NotSupersetEqual: "\u2289", NotTilde: "\u2241", NotTildeEqual: "\u2244", NotTildeFullEqual: "\u2247", NotTildeTilde: "\u2249", NotVerticalBar: "\u2224", npar: "\u2226", nparallel: "\u2226", nparsl: "\u2AFD\u20E5", npart: "\u2202\u0338", npolint: "\u2A14", npr: "\u2280", nprcue: "\u22E0", npre: "\u2AAF\u0338", nprec: "\u2280", npreceq: "\u2AAF\u0338", nrArr: "\u21CF", nrarr: "\u219B", nrarrc: "\u2933\u0338", nrarrw: "\u219D\u0338", nRightarrow: "\u21CF", nrightarrow: "\u219B", nrtri: "\u22EB", nrtrie: "\u22ED", nsc: "\u2281", nsccue: "\u22E1", nsce: "\u2AB0\u0338", Nscr: "\u{1D4A9}", nscr: "\u{1D4C3}", nshortmid: "\u2224", nshortparallel: "\u2226", nsim: "\u2241", nsime: "\u2244", nsimeq: "\u2244", nsmid: "\u2224", nspar: "\u2226", nsqsube: "\u22E2", nsqsupe: "\u22E3", nsub: "\u2284", nsubE: "\u2AC5\u0338", nsube: "\u2288", nsubset: "\u2282\u20D2", nsubseteq: "\u2288", nsubseteqq: "\u2AC5\u0338", nsucc: "\u2281", nsucceq: "\u2AB0\u0338", nsup: "\u2285", nsupE: "\u2AC6\u0338", nsupe: "\u2289", nsupset: "\u2283\u20D2", nsupseteq: "\u2289", nsupseteqq: "\u2AC6\u0338", ntgl: "\u2279", Ntilde: "\xD1", ntilde: "\xF1", ntlg: "\u2278", ntriangleleft: "\u22EA", ntrianglelefteq: "\u22EC", ntriangleright: "\u22EB", ntrianglerighteq: "\u22ED", Nu: "\u039D", nu: "\u03BD", num: "#", numero: "\u2116", numsp: "\u2007", nvap: "\u224D\u20D2", nVDash: "\u22AF", nVdash: "\u22AE", nvDash: "\u22AD", nvdash: "\u22AC", nvge: "\u2265\u20D2", nvgt: ">\u20D2", nvHarr: "\u2904", nvinfin: "\u29DE", nvlArr: "\u2902", nvle: "\u2264\u20D2", nvlt: "<\u20D2", nvltrie: "\u22B4\u20D2", nvrArr: "\u2903", nvrtrie: "\u22B5\u20D2", nvsim: "\u223C\u20D2", nwarhk: "\u2923", nwArr: "\u21D6", nwarr: "\u2196", nwarrow: "\u2196", nwnear: "\u2927", Oacute: "\xD3", oacute: "\xF3", oast: "\u229B", ocir: "\u229A", Ocirc: "\xD4", ocirc: "\xF4", Ocy: "\u041E", ocy: "\u043E", odash: "\u229D", Odblac: "\u0150", odblac: "\u0151", odiv: "\u2A38", odot: "\u2299", odsold: "\u29BC", OElig: "\u0152", oelig: "\u0153", ofcir: "\u29BF", Ofr: "\u{1D512}", ofr: "\u{1D52C}", ogon: "\u02DB", Ograve: "\xD2", ograve: "\xF2", ogt: "\u29C1", ohbar: "\u29B5", ohm: "\u03A9", oint: "\u222E", olarr: "\u21BA", olcir: "\u29BE", olcross: "\u29BB", oline: "\u203E", olt: "\u29C0", Omacr: "\u014C", omacr: "\u014D", Omega: "\u03A9", omega: "\u03C9", Omicron: "\u039F", omicron: "\u03BF", omid: "\u29B6", ominus: "\u2296", Oopf: "\u{1D546}", oopf: "\u{1D560}", opar: "\u29B7", OpenCurlyDoubleQuote: "\u201C", OpenCurlyQuote: "\u2018", operp: "\u29B9", oplus: "\u2295", Or: "\u2A54", or: "\u2228", orarr: "\u21BB", ord: "\u2A5D", order: "\u2134", orderof: "\u2134", ordf: "\xAA", ordm: "\xBA", origof: "\u22B6", oror: "\u2A56", orslope: "\u2A57", orv: "\u2A5B", oS: "\u24C8", Oscr: "\u{1D4AA}", oscr: "\u2134", Oslash: "\xD8", oslash: "\xF8", osol: "\u2298", Otilde: "\xD5", otilde: "\xF5", Otimes: "\u2A37", otimes: "\u2297", otimesas: "\u2A36", Ouml: "\xD6", ouml: "\xF6", ovbar: "\u233D", OverBar: "\u203E", OverBrace: "\u23DE", OverBracket: "\u23B4", OverParenthesis: "\u23DC", par: "\u2225", para: "\xB6", parallel: "\u2225", parsim: "\u2AF3", parsl: "\u2AFD", part: "\u2202", PartialD: "\u2202", Pcy: "\u041F", pcy: "\u043F", percnt: "%", period: ".", permil: "\u2030", perp: "\u22A5", pertenk: "\u2031", Pfr: "\u{1D513}", pfr: "\u{1D52D}", Phi: "\u03A6", phi: "\u03C6", phiv: "\u03D5", phmmat: "\u2133", phone: "\u260E", Pi: "\u03A0", pi: "\u03C0", pitchfork: "\u22D4", piv: "\u03D6", planck: "\u210F", planckh: "\u210E", plankv: "\u210F", plus: "+", plusacir: "\u2A23", plusb: "\u229E", pluscir: "\u2A22", plusdo: "\u2214", plusdu: "\u2A25", pluse: "\u2A72", PlusMinus: "\xB1", plusmn: "\xB1", plussim: "\u2A26", plustwo: "\u2A27", pm: "\xB1", Poincareplane: "\u210C", pointint: "\u2A15", Popf: "\u2119", popf: "\u{1D561}", pound: "\xA3", Pr: "\u2ABB", pr: "\u227A", prap: "\u2AB7", prcue: "\u227C", prE: "\u2AB3", pre: "\u2AAF", prec: "\u227A", precapprox: "\u2AB7", preccurlyeq: "\u227C", Precedes: "\u227A", PrecedesEqual: "\u2AAF", PrecedesSlantEqual: "\u227C", PrecedesTilde: "\u227E", preceq: "\u2AAF", precnapprox: "\u2AB9", precneqq: "\u2AB5", precnsim: "\u22E8", precsim: "\u227E", Prime: "\u2033", prime: "\u2032", primes: "\u2119", prnap: "\u2AB9", prnE: "\u2AB5", prnsim: "\u22E8", prod: "\u220F", Product: "\u220F", profalar: "\u232E", profline: "\u2312", profsurf: "\u2313", prop: "\u221D", Proportion: "\u2237", Proportional: "\u221D", propto: "\u221D", prsim: "\u227E", prurel: "\u22B0", Pscr: "\u{1D4AB}", pscr: "\u{1D4C5}", Psi: "\u03A8", psi: "\u03C8", puncsp: "\u2008", Qfr: "\u{1D514}", qfr: "\u{1D52E}", qint: "\u2A0C", Qopf: "\u211A", qopf: "\u{1D562}", qprime: "\u2057", Qscr: "\u{1D4AC}", qscr: "\u{1D4C6}", quaternions: "\u210D", quatint: "\u2A16", quest: "?", questeq: "\u225F", QUOT: '"', quot: '"', rAarr: "\u21DB", race: "\u223D\u0331", Racute: "\u0154", racute: "\u0155", radic: "\u221A", raemptyv: "\u29B3", Rang: "\u27EB", rang: "\u27E9", rangd: "\u2992", range: "\u29A5", rangle: "\u27E9", raquo: "\xBB", Rarr: "\u21A0", rArr: "\u21D2", rarr: "\u2192", rarrap: "\u2975", rarrb: "\u21E5", rarrbfs: "\u2920", rarrc: "\u2933", rarrfs: "\u291E", rarrhk: "\u21AA", rarrlp: "\u21AC", rarrpl: "\u2945", rarrsim: "\u2974", Rarrtl: "\u2916", rarrtl: "\u21A3", rarrw: "\u219D", rAtail: "\u291C", ratail: "\u291A", ratio: "\u2236", rationals: "\u211A", RBarr: "\u2910", rBarr: "\u290F", rbarr: "\u290D", rbbrk: "\u2773", rbrace: "}", rbrack: "]", rbrke: "\u298C", rbrksld: "\u298E", rbrkslu: "\u2990", Rcaron: "\u0158", rcaron: "\u0159", Rcedil: "\u0156", rcedil: "\u0157", rceil: "\u2309", rcub: "}", Rcy: "\u0420", rcy: "\u0440", rdca: "\u2937", rdldhar: "\u2969", rdquo: "\u201D", rdquor: "\u201D", rdsh: "\u21B3", Re: "\u211C", real: "\u211C", realine: "\u211B", realpart: "\u211C", reals: "\u211D", rect: "\u25AD", REG: "\xAE", reg: "\xAE", ReverseElement: "\u220B", ReverseEquilibrium: "\u21CB", ReverseUpEquilibrium: "\u296F", rfisht: "\u297D", rfloor: "\u230B", Rfr: "\u211C", rfr: "\u{1D52F}", rHar: "\u2964", rhard: "\u21C1", rharu: "\u21C0", rharul: "\u296C", Rho: "\u03A1", rho: "\u03C1", rhov: "\u03F1", RightAngleBracket: "\u27E9", RightArrow: "\u2192", Rightarrow: "\u21D2", rightarrow: "\u2192", RightArrowBar: "\u21E5", RightArrowLeftArrow: "\u21C4", rightarrowtail: "\u21A3", RightCeiling: "\u2309", RightDoubleBracket: "\u27E7", RightDownTeeVector: "\u295D", RightDownVector: "\u21C2", RightDownVectorBar: "\u2955", RightFloor: "\u230B", rightharpoondown: "\u21C1", rightharpoonup: "\u21C0", rightleftarrows: "\u21C4", rightleftharpoons: "\u21CC", rightrightarrows: "\u21C9", rightsquigarrow: "\u219D", RightTee: "\u22A2", RightTeeArrow: "\u21A6", RightTeeVector: "\u295B", rightthreetimes: "\u22CC", RightTriangle: "\u22B3", RightTriangleBar: "\u29D0", RightTriangleEqual: "\u22B5", RightUpDownVector: "\u294F", RightUpTeeVector: "\u295C", RightUpVector: "\u21BE", RightUpVectorBar: "\u2954", RightVector: "\u21C0", RightVectorBar: "\u2953", ring: "\u02DA", risingdotseq: "\u2253", rlarr: "\u21C4", rlhar: "\u21CC", rlm: "\u200F", rmoust: "\u23B1", rmoustache: "\u23B1", rnmid: "\u2AEE", roang: "\u27ED", roarr: "\u21FE", robrk: "\u27E7", ropar: "\u2986", Ropf: "\u211D", ropf: "\u{1D563}", roplus: "\u2A2E", rotimes: "\u2A35", RoundImplies: "\u2970", rpar: ")", rpargt: "\u2994", rppolint: "\u2A12", rrarr: "\u21C9", Rrightarrow: "\u21DB", rsaquo: "\u203A", Rscr: "\u211B", rscr: "\u{1D4C7}", Rsh: "\u21B1", rsh: "\u21B1", rsqb: "]", rsquo: "\u2019", rsquor: "\u2019", rthree: "\u22CC", rtimes: "\u22CA", rtri: "\u25B9", rtrie: "\u22B5", rtrif: "\u25B8", rtriltri: "\u29CE", RuleDelayed: "\u29F4", ruluhar: "\u2968", rx: "\u211E", Sacute: "\u015A", sacute: "\u015B", sbquo: "\u201A", Sc: "\u2ABC", sc: "\u227B", scap: "\u2AB8", Scaron: "\u0160", scaron: "\u0161", sccue: "\u227D", scE: "\u2AB4", sce: "\u2AB0", Scedil: "\u015E", scedil: "\u015F", Scirc: "\u015C", scirc: "\u015D", scnap: "\u2ABA", scnE: "\u2AB6", scnsim: "\u22E9", scpolint: "\u2A13", scsim: "\u227F", Scy: "\u0421", scy: "\u0441", sdot: "\u22C5", sdotb: "\u22A1", sdote: "\u2A66", searhk: "\u2925", seArr: "\u21D8", searr: "\u2198", searrow: "\u2198", sect: "\xA7", semi: ";", seswar: "\u2929", setminus: "\u2216", setmn: "\u2216", sext: "\u2736", Sfr: "\u{1D516}", sfr: "\u{1D530}", sfrown: "\u2322", sharp: "\u266F", SHCHcy: "\u0429", shchcy: "\u0449", SHcy: "\u0428", shcy: "\u0448", ShortDownArrow: "\u2193", ShortLeftArrow: "\u2190", shortmid: "\u2223", shortparallel: "\u2225", ShortRightArrow: "\u2192", ShortUpArrow: "\u2191", shy: "\xAD", Sigma: "\u03A3", sigma: "\u03C3", sigmaf: "\u03C2", sigmav: "\u03C2", sim: "\u223C", simdot: "\u2A6A", sime: "\u2243", simeq: "\u2243", simg: "\u2A9E", simgE: "\u2AA0", siml: "\u2A9D", simlE: "\u2A9F", simne: "\u2246", simplus: "\u2A24", simrarr: "\u2972", slarr: "\u2190", SmallCircle: "\u2218", smallsetminus: "\u2216", smashp: "\u2A33", smeparsl: "\u29E4", smid: "\u2223", smile: "\u2323", smt: "\u2AAA", smte: "\u2AAC", smtes: "\u2AAC\uFE00", SOFTcy: "\u042C", softcy: "\u044C", sol: "/", solb: "\u29C4", solbar: "\u233F", Sopf: "\u{1D54A}", sopf: "\u{1D564}", spades: "\u2660", spadesuit: "\u2660", spar: "\u2225", sqcap: "\u2293", sqcaps: "\u2293\uFE00", sqcup: "\u2294", sqcups: "\u2294\uFE00", Sqrt: "\u221A", sqsub: "\u228F", sqsube: "\u2291", sqsubset: "\u228F", sqsubseteq: "\u2291", sqsup: "\u2290", sqsupe: "\u2292", sqsupset: "\u2290", sqsupseteq: "\u2292", squ: "\u25A1", Square: "\u25A1", square: "\u25A1", SquareIntersection: "\u2293", SquareSubset: "\u228F", SquareSubsetEqual: "\u2291", SquareSuperset: "\u2290", SquareSupersetEqual: "\u2292", SquareUnion: "\u2294", squarf: "\u25AA", squf: "\u25AA", srarr: "\u2192", Sscr: "\u{1D4AE}", sscr: "\u{1D4C8}", ssetmn: "\u2216", ssmile: "\u2323", sstarf: "\u22C6", Star: "\u22C6", star: "\u2606", starf: "\u2605", straightepsilon: "\u03F5", straightphi: "\u03D5", strns: "\xAF", Sub: "\u22D0", sub: "\u2282", subdot: "\u2ABD", subE: "\u2AC5", sube: "\u2286", subedot: "\u2AC3", submult: "\u2AC1", subnE: "\u2ACB", subne: "\u228A", subplus: "\u2ABF", subrarr: "\u2979", Subset: "\u22D0", subset: "\u2282", subseteq: "\u2286", subseteqq: "\u2AC5", SubsetEqual: "\u2286", subsetneq: "\u228A", subsetneqq: "\u2ACB", subsim: "\u2AC7", subsub: "\u2AD5", subsup: "\u2AD3", succ: "\u227B", succapprox: "\u2AB8", succcurlyeq: "\u227D", Succeeds: "\u227B", SucceedsEqual: "\u2AB0", SucceedsSlantEqual: "\u227D", SucceedsTilde: "\u227F", succeq: "\u2AB0", succnapprox: "\u2ABA", succneqq: "\u2AB6", succnsim: "\u22E9", succsim: "\u227F", SuchThat: "\u220B", Sum: "\u2211", sum: "\u2211", sung: "\u266A", Sup: "\u22D1", sup: "\u2283", sup1: "\xB9", sup2: "\xB2", sup3: "\xB3", supdot: "\u2ABE", supdsub: "\u2AD8", supE: "\u2AC6", supe: "\u2287", supedot: "\u2AC4", Superset: "\u2283", SupersetEqual: "\u2287", suphsol: "\u27C9", suphsub: "\u2AD7", suplarr: "\u297B", supmult: "\u2AC2", supnE: "\u2ACC", supne: "\u228B", supplus: "\u2AC0", Supset: "\u22D1", supset: "\u2283", supseteq: "\u2287", supseteqq: "\u2AC6", supsetneq: "\u228B", supsetneqq: "\u2ACC", supsim: "\u2AC8", supsub: "\u2AD4", supsup: "\u2AD6", swarhk: "\u2926", swArr: "\u21D9", swarr: "\u2199", swarrow: "\u2199", swnwar: "\u292A", szlig: "\xDF", Tab: "	", target: "\u2316", Tau: "\u03A4", tau: "\u03C4", tbrk: "\u23B4", Tcaron: "\u0164", tcaron: "\u0165", Tcedil: "\u0162", tcedil: "\u0163", Tcy: "\u0422", tcy: "\u0442", tdot: "\u20DB", telrec: "\u2315", Tfr: "\u{1D517}", tfr: "\u{1D531}", there4: "\u2234", Therefore: "\u2234", therefore: "\u2234", Theta: "\u0398", theta: "\u03B8", thetasym: "\u03D1", thetav: "\u03D1", thickapprox: "\u2248", thicksim: "\u223C", ThickSpace: "\u205F\u200A", thinsp: "\u2009", ThinSpace: "\u2009", thkap: "\u2248", thksim: "\u223C", THORN: "\xDE", thorn: "\xFE", Tilde: "\u223C", tilde: "\u02DC", TildeEqual: "\u2243", TildeFullEqual: "\u2245", TildeTilde: "\u2248", times: "\xD7", timesb: "\u22A0", timesbar: "\u2A31", timesd: "\u2A30", tint: "\u222D", toea: "\u2928", top: "\u22A4", topbot: "\u2336", topcir: "\u2AF1", Topf: "\u{1D54B}", topf: "\u{1D565}", topfork: "\u2ADA", tosa: "\u2929", tprime: "\u2034", TRADE: "\u2122", trade: "\u2122", triangle: "\u25B5", triangledown: "\u25BF", triangleleft: "\u25C3", trianglelefteq: "\u22B4", triangleq: "\u225C", triangleright: "\u25B9", trianglerighteq: "\u22B5", tridot: "\u25EC", trie: "\u225C", triminus: "\u2A3A", TripleDot: "\u20DB", triplus: "\u2A39", trisb: "\u29CD", tritime: "\u2A3B", trpezium: "\u23E2", Tscr: "\u{1D4AF}", tscr: "\u{1D4C9}", TScy: "\u0426", tscy: "\u0446", TSHcy: "\u040B", tshcy: "\u045B", Tstrok: "\u0166", tstrok: "\u0167", twixt: "\u226C", twoheadleftarrow: "\u219E", twoheadrightarrow: "\u21A0", Uacute: "\xDA", uacute: "\xFA", Uarr: "\u219F", uArr: "\u21D1", uarr: "\u2191", Uarrocir: "\u2949", Ubrcy: "\u040E", ubrcy: "\u045E", Ubreve: "\u016C", ubreve: "\u016D", Ucirc: "\xDB", ucirc: "\xFB", Ucy: "\u0423", ucy: "\u0443", udarr: "\u21C5", Udblac: "\u0170", udblac: "\u0171", udhar: "\u296E", ufisht: "\u297E", Ufr: "\u{1D518}", ufr: "\u{1D532}", Ugrave: "\xD9", ugrave: "\xF9", uHar: "\u2963", uharl: "\u21BF", uharr: "\u21BE", uhblk: "\u2580", ulcorn: "\u231C", ulcorner: "\u231C", ulcrop: "\u230F", ultri: "\u25F8", Umacr: "\u016A", umacr: "\u016B", uml: "\xA8", UnderBar: "_", UnderBrace: "\u23DF", UnderBracket: "\u23B5", UnderParenthesis: "\u23DD", Union: "\u22C3", UnionPlus: "\u228E", Uogon: "\u0172", uogon: "\u0173", Uopf: "\u{1D54C}", uopf: "\u{1D566}", UpArrow: "\u2191", Uparrow: "\u21D1", uparrow: "\u2191", UpArrowBar: "\u2912", UpArrowDownArrow: "\u21C5", UpDownArrow: "\u2195", Updownarrow: "\u21D5", updownarrow: "\u2195", UpEquilibrium: "\u296E", upharpoonleft: "\u21BF", upharpoonright: "\u21BE", uplus: "\u228E", UpperLeftArrow: "\u2196", UpperRightArrow: "\u2197", Upsi: "\u03D2", upsi: "\u03C5", upsih: "\u03D2", Upsilon: "\u03A5", upsilon: "\u03C5", UpTee: "\u22A5", UpTeeArrow: "\u21A5", upuparrows: "\u21C8", urcorn: "\u231D", urcorner: "\u231D", urcrop: "\u230E", Uring: "\u016E", uring: "\u016F", urtri: "\u25F9", Uscr: "\u{1D4B0}", uscr: "\u{1D4CA}", utdot: "\u22F0", Utilde: "\u0168", utilde: "\u0169", utri: "\u25B5", utrif: "\u25B4", uuarr: "\u21C8", Uuml: "\xDC", uuml: "\xFC", uwangle: "\u29A7", vangrt: "\u299C", varepsilon: "\u03F5", varkappa: "\u03F0", varnothing: "\u2205", varphi: "\u03D5", varpi: "\u03D6", varpropto: "\u221D", vArr: "\u21D5", varr: "\u2195", varrho: "\u03F1", varsigma: "\u03C2", varsubsetneq: "\u228A\uFE00", varsubsetneqq: "\u2ACB\uFE00", varsupsetneq: "\u228B\uFE00", varsupsetneqq: "\u2ACC\uFE00", vartheta: "\u03D1", vartriangleleft: "\u22B2", vartriangleright: "\u22B3", Vbar: "\u2AEB", vBar: "\u2AE8", vBarv: "\u2AE9", Vcy: "\u0412", vcy: "\u0432", VDash: "\u22AB", Vdash: "\u22A9", vDash: "\u22A8", vdash: "\u22A2", Vdashl: "\u2AE6", Vee: "\u22C1", vee: "\u2228", veebar: "\u22BB", veeeq: "\u225A", vellip: "\u22EE", Verbar: "\u2016", verbar: "|", Vert: "\u2016", vert: "|", VerticalBar: "\u2223", VerticalLine: "|", VerticalSeparator: "\u2758", VerticalTilde: "\u2240", VeryThinSpace: "\u200A", Vfr: "\u{1D519}", vfr: "\u{1D533}", vltri: "\u22B2", vnsub: "\u2282\u20D2", vnsup: "\u2283\u20D2", Vopf: "\u{1D54D}", vopf: "\u{1D567}", vprop: "\u221D", vrtri: "\u22B3", Vscr: "\u{1D4B1}", vscr: "\u{1D4CB}", vsubnE: "\u2ACB\uFE00", vsubne: "\u228A\uFE00", vsupnE: "\u2ACC\uFE00", vsupne: "\u228B\uFE00", Vvdash: "\u22AA", vzigzag: "\u299A", Wcirc: "\u0174", wcirc: "\u0175", wedbar: "\u2A5F", Wedge: "\u22C0", wedge: "\u2227", wedgeq: "\u2259", weierp: "\u2118", Wfr: "\u{1D51A}", wfr: "\u{1D534}", Wopf: "\u{1D54E}", wopf: "\u{1D568}", wp: "\u2118", wr: "\u2240", wreath: "\u2240", Wscr: "\u{1D4B2}", wscr: "\u{1D4CC}", xcap: "\u22C2", xcirc: "\u25EF", xcup: "\u22C3", xdtri: "\u25BD", Xfr: "\u{1D51B}", xfr: "\u{1D535}", xhArr: "\u27FA", xharr: "\u27F7", Xi: "\u039E", xi: "\u03BE", xlArr: "\u27F8", xlarr: "\u27F5", xmap: "\u27FC", xnis: "\u22FB", xodot: "\u2A00", Xopf: "\u{1D54F}", xopf: "\u{1D569}", xoplus: "\u2A01", xotime: "\u2A02", xrArr: "\u27F9", xrarr: "\u27F6", Xscr: "\u{1D4B3}", xscr: "\u{1D4CD}", xsqcup: "\u2A06", xuplus: "\u2A04", xutri: "\u25B3", xvee: "\u22C1", xwedge: "\u22C0", Yacute: "\xDD", yacute: "\xFD", YAcy: "\u042F", yacy: "\u044F", Ycirc: "\u0176", ycirc: "\u0177", Ycy: "\u042B", ycy: "\u044B", yen: "\xA5", Yfr: "\u{1D51C}", yfr: "\u{1D536}", YIcy: "\u0407", yicy: "\u0457", Yopf: "\u{1D550}", yopf: "\u{1D56A}", Yscr: "\u{1D4B4}", yscr: "\u{1D4CE}", YUcy: "\u042E", yucy: "\u044E", Yuml: "\u0178", yuml: "\xFF", Zacute: "\u0179", zacute: "\u017A", Zcaron: "\u017D", zcaron: "\u017E", Zcy: "\u0417", zcy: "\u0437", Zdot: "\u017B", zdot: "\u017C", zeetrf: "\u2128", ZeroWidthSpace: "\u200B", Zeta: "\u0396", zeta: "\u03B6", Zfr: "\u2128", zfr: "\u{1D537}", ZHcy: "\u0416", zhcy: "\u0436", zigrarr: "\u21DD", Zopf: "\u2124", zopf: "\u{1D56B}", Zscr: "\u{1D4B5}", zscr: "\u{1D4CF}", zwj: "\u200D", zwnj: "\u200C" }, e28.NGSP_UNICODE = "\uE500", e28.NAMED_ENTITIES.ngsp = e28.NGSP_UNICODE;
      } }), qu2 = S3({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/html_tags.js"(e28) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true });
        var t3 = Qe2(), a3 = class {
          constructor() {
            let { closedByChildren: i, implicitNamespacePrefix: m3, contentType: f3 = t3.TagContentType.PARSABLE_DATA, closedByParent: L3 = false, isVoid: s3 = false, ignoreFirstLf: D3 = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            this.closedByChildren = {}, this.closedByParent = false, this.canSelfClose = false, i && i.length > 0 && i.forEach((E3) => this.closedByChildren[E3] = true), this.isVoid = s3, this.closedByParent = L3 || s3, this.implicitNamespacePrefix = m3 || null, this.contentType = f3, this.ignoreFirstLf = D3;
          }
          isClosedByChild(i) {
            return this.isVoid || i.toLowerCase() in this.closedByChildren;
          }
        };
        e28.HtmlTagDefinition = a3;
        var o3, p3;
        function r3(i) {
          return p3 || (o3 = new a3(), p3 = { base: new a3({ isVoid: true }), meta: new a3({ isVoid: true }), area: new a3({ isVoid: true }), embed: new a3({ isVoid: true }), link: new a3({ isVoid: true }), img: new a3({ isVoid: true }), input: new a3({ isVoid: true }), param: new a3({ isVoid: true }), hr: new a3({ isVoid: true }), br: new a3({ isVoid: true }), source: new a3({ isVoid: true }), track: new a3({ isVoid: true }), wbr: new a3({ isVoid: true }), p: new a3({ closedByChildren: ["address", "article", "aside", "blockquote", "div", "dl", "fieldset", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "main", "nav", "ol", "p", "pre", "section", "table", "ul"], closedByParent: true }), thead: new a3({ closedByChildren: ["tbody", "tfoot"] }), tbody: new a3({ closedByChildren: ["tbody", "tfoot"], closedByParent: true }), tfoot: new a3({ closedByChildren: ["tbody"], closedByParent: true }), tr: new a3({ closedByChildren: ["tr"], closedByParent: true }), td: new a3({ closedByChildren: ["td", "th"], closedByParent: true }), th: new a3({ closedByChildren: ["td", "th"], closedByParent: true }), col: new a3({ isVoid: true }), svg: new a3({ implicitNamespacePrefix: "svg" }), math: new a3({ implicitNamespacePrefix: "math" }), li: new a3({ closedByChildren: ["li"], closedByParent: true }), dt: new a3({ closedByChildren: ["dt", "dd"] }), dd: new a3({ closedByChildren: ["dt", "dd"], closedByParent: true }), rb: new a3({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: true }), rt: new a3({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: true }), rtc: new a3({ closedByChildren: ["rb", "rtc", "rp"], closedByParent: true }), rp: new a3({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: true }), optgroup: new a3({ closedByChildren: ["optgroup"], closedByParent: true }), option: new a3({ closedByChildren: ["option", "optgroup"], closedByParent: true }), pre: new a3({ ignoreFirstLf: true }), listing: new a3({ ignoreFirstLf: true }), style: new a3({ contentType: t3.TagContentType.RAW_TEXT }), script: new a3({ contentType: t3.TagContentType.RAW_TEXT }), title: new a3({ contentType: t3.TagContentType.ESCAPABLE_RAW_TEXT }), textarea: new a3({ contentType: t3.TagContentType.ESCAPABLE_RAW_TEXT, ignoreFirstLf: true }) }), p3[i] || o3;
        }
        e28.getHtmlTagDefinition = r3;
      } }), gr2 = S3({ "node_modules/angular-html-parser/lib/compiler/src/ast_path.js"(e28) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true });
        var t3 = class {
          constructor(a3) {
            let o3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
            this.path = a3, this.position = o3;
          }
          get empty() {
            return !this.path || !this.path.length;
          }
          get head() {
            return this.path[0];
          }
          get tail() {
            return this.path[this.path.length - 1];
          }
          parentOf(a3) {
            return a3 && this.path[this.path.indexOf(a3) - 1];
          }
          childOf(a3) {
            return this.path[this.path.indexOf(a3) + 1];
          }
          first(a3) {
            for (let o3 = this.path.length - 1; o3 >= 0; o3--) {
              let p3 = this.path[o3];
              if (p3 instanceof a3)
                return p3;
            }
          }
          push(a3) {
            this.path.push(a3);
          }
          pop() {
            return this.path.pop();
          }
        };
        e28.AstPath = t3;
      } }), Mu2 = S3({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/ast.js"(e28) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true });
        var t3 = gr2(), a3 = class {
          constructor(F3, T3, $3) {
            this.value = F3, this.sourceSpan = T3, this.i18n = $3, this.type = "text";
          }
          visit(F3, T3) {
            return F3.visitText(this, T3);
          }
        };
        e28.Text = a3;
        var o3 = class {
          constructor(F3, T3) {
            this.value = F3, this.sourceSpan = T3, this.type = "cdata";
          }
          visit(F3, T3) {
            return F3.visitCdata(this, T3);
          }
        };
        e28.CDATA = o3;
        var p3 = class {
          constructor(F3, T3, $3, X3, O3, G3) {
            this.switchValue = F3, this.type = T3, this.cases = $3, this.sourceSpan = X3, this.switchValueSourceSpan = O3, this.i18n = G3;
          }
          visit(F3, T3) {
            return F3.visitExpansion(this, T3);
          }
        };
        e28.Expansion = p3;
        var r3 = class {
          constructor(F3, T3, $3, X3, O3) {
            this.value = F3, this.expression = T3, this.sourceSpan = $3, this.valueSourceSpan = X3, this.expSourceSpan = O3;
          }
          visit(F3, T3) {
            return F3.visitExpansionCase(this, T3);
          }
        };
        e28.ExpansionCase = r3;
        var i = class {
          constructor(F3, T3, $3) {
            let X3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, O3 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, G3 = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
            this.name = F3, this.value = T3, this.sourceSpan = $3, this.valueSpan = X3, this.nameSpan = O3, this.i18n = G3, this.type = "attribute";
          }
          visit(F3, T3) {
            return F3.visitAttribute(this, T3);
          }
        };
        e28.Attribute = i;
        var m3 = class {
          constructor(F3, T3, $3, X3) {
            let O3 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, G3 = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, W3 = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, se2 = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
            this.name = F3, this.attrs = T3, this.children = $3, this.sourceSpan = X3, this.startSourceSpan = O3, this.endSourceSpan = G3, this.nameSpan = W3, this.i18n = se2, this.type = "element";
          }
          visit(F3, T3) {
            return F3.visitElement(this, T3);
          }
        };
        e28.Element = m3;
        var f3 = class {
          constructor(F3, T3) {
            this.value = F3, this.sourceSpan = T3, this.type = "comment";
          }
          visit(F3, T3) {
            return F3.visitComment(this, T3);
          }
        };
        e28.Comment = f3;
        var L3 = class {
          constructor(F3, T3) {
            this.value = F3, this.sourceSpan = T3, this.type = "docType";
          }
          visit(F3, T3) {
            return F3.visitDocType(this, T3);
          }
        };
        e28.DocType = L3;
        function s3(F3, T3) {
          let $3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, X3 = [], O3 = F3.visit ? (G3) => F3.visit(G3, $3) || G3.visit(F3, $3) : (G3) => G3.visit(F3, $3);
          return T3.forEach((G3) => {
            let W3 = O3(G3);
            W3 && X3.push(W3);
          }), X3;
        }
        e28.visitAll = s3;
        var D3 = class {
          constructor() {
          }
          visitElement(F3, T3) {
            this.visitChildren(T3, ($3) => {
              $3(F3.attrs), $3(F3.children);
            });
          }
          visitAttribute(F3, T3) {
          }
          visitText(F3, T3) {
          }
          visitCdata(F3, T3) {
          }
          visitComment(F3, T3) {
          }
          visitDocType(F3, T3) {
          }
          visitExpansion(F3, T3) {
            return this.visitChildren(T3, ($3) => {
              $3(F3.cases);
            });
          }
          visitExpansionCase(F3, T3) {
          }
          visitChildren(F3, T3) {
            let $3 = [], X3 = this;
            function O3(G3) {
              G3 && $3.push(s3(X3, G3, F3));
            }
            return T3(O3), Array.prototype.concat.apply([], $3);
          }
        };
        e28.RecursiveVisitor = D3;
        function E3(F3) {
          let T3 = F3.sourceSpan.start.offset, $3 = F3.sourceSpan.end.offset;
          return F3 instanceof m3 && (F3.endSourceSpan ? $3 = F3.endSourceSpan.end.offset : F3.children && F3.children.length && ($3 = E3(F3.children[F3.children.length - 1]).end)), { start: T3, end: $3 };
        }
        function v3(F3, T3) {
          let $3 = [], X3 = new class extends D3 {
            visit(O3, G3) {
              let W3 = E3(O3);
              if (W3.start <= T3 && T3 < W3.end)
                $3.push(O3);
              else
                return true;
            }
          }();
          return s3(X3, F3), new t3.AstPath($3, T3);
        }
        e28.findNode = v3;
      } }), Fr2 = S3({ "node_modules/angular-html-parser/lib/compiler/src/assertions.js"(e28) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true });
        function t3(p3, r3) {
          if (r3 != null) {
            if (!Array.isArray(r3))
              throw new Error(`Expected '${p3}' to be an array of strings.`);
            for (let i = 0; i < r3.length; i += 1)
              if (typeof r3[i] != "string")
                throw new Error(`Expected '${p3}' to be an array of strings.`);
          }
        }
        e28.assertArrayOfStrings = t3;
        var a3 = [/^\s*$/, /[<>]/, /^[{}]$/, /&(#|[a-z])/i, /^\/\//];
        function o3(p3, r3) {
          if (r3 != null && !(Array.isArray(r3) && r3.length == 2))
            throw new Error(`Expected '${p3}' to be an array, [start, end].`);
          if (r3 != null) {
            let i = r3[0], m3 = r3[1];
            a3.forEach((f3) => {
              if (f3.test(i) || f3.test(m3))
                throw new Error(`['${i}', '${m3}'] contains unusable interpolation symbol.`);
            });
          }
        }
        e28.assertInterpolationSymbols = o3;
      } }), Ar2 = S3({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/interpolation_config.js"(e28) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true });
        var t3 = Fr2(), a3 = class {
          constructor(o3, p3) {
            this.start = o3, this.end = p3;
          }
          static fromArray(o3) {
            return o3 ? (t3.assertInterpolationSymbols("interpolation", o3), new a3(o3[0], o3[1])) : e28.DEFAULT_INTERPOLATION_CONFIG;
          }
        };
        e28.InterpolationConfig = a3, e28.DEFAULT_INTERPOLATION_CONFIG = new a3("{{", "}}");
      } }), vr2 = S3({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/lexer.js"(e28) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true });
        var t3 = De2(), a3 = _e2(), o3 = Ar2(), p3 = Qe2(), r3;
        (function(u3) {
          u3[u3.TAG_OPEN_START = 0] = "TAG_OPEN_START", u3[u3.TAG_OPEN_END = 1] = "TAG_OPEN_END", u3[u3.TAG_OPEN_END_VOID = 2] = "TAG_OPEN_END_VOID", u3[u3.TAG_CLOSE = 3] = "TAG_CLOSE", u3[u3.TEXT = 4] = "TEXT", u3[u3.ESCAPABLE_RAW_TEXT = 5] = "ESCAPABLE_RAW_TEXT", u3[u3.RAW_TEXT = 6] = "RAW_TEXT", u3[u3.COMMENT_START = 7] = "COMMENT_START", u3[u3.COMMENT_END = 8] = "COMMENT_END", u3[u3.CDATA_START = 9] = "CDATA_START", u3[u3.CDATA_END = 10] = "CDATA_END", u3[u3.ATTR_NAME = 11] = "ATTR_NAME", u3[u3.ATTR_QUOTE = 12] = "ATTR_QUOTE", u3[u3.ATTR_VALUE = 13] = "ATTR_VALUE", u3[u3.DOC_TYPE_START = 14] = "DOC_TYPE_START", u3[u3.DOC_TYPE_END = 15] = "DOC_TYPE_END", u3[u3.EXPANSION_FORM_START = 16] = "EXPANSION_FORM_START", u3[u3.EXPANSION_CASE_VALUE = 17] = "EXPANSION_CASE_VALUE", u3[u3.EXPANSION_CASE_EXP_START = 18] = "EXPANSION_CASE_EXP_START", u3[u3.EXPANSION_CASE_EXP_END = 19] = "EXPANSION_CASE_EXP_END", u3[u3.EXPANSION_FORM_END = 20] = "EXPANSION_FORM_END", u3[u3.EOF = 21] = "EOF";
        })(r3 = e28.TokenType || (e28.TokenType = {}));
        var i = class {
          constructor(u3, n3, A3) {
            this.type = u3, this.parts = n3, this.sourceSpan = A3;
          }
        };
        e28.Token = i;
        var m3 = class extends a3.ParseError {
          constructor(u3, n3, A3) {
            super(A3, u3), this.tokenType = n3;
          }
        };
        e28.TokenError = m3;
        var f3 = class {
          constructor(u3, n3) {
            this.tokens = u3, this.errors = n3;
          }
        };
        e28.TokenizeResult = f3;
        function L3(u3, n3, A3) {
          let C3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
          return new F3(new a3.ParseSourceFile(u3, n3), A3, C3).tokenize();
        }
        e28.tokenize = L3;
        var s3 = /\r\n?/g;
        function D3(u3) {
          return `Unexpected character "${u3 === t3.$EOF ? "EOF" : String.fromCharCode(u3)}"`;
        }
        function E3(u3) {
          return `Unknown entity "${u3}" - use the "&#<decimal>;" or  "&#x<hex>;" syntax`;
        }
        var v3 = class {
          constructor(u3) {
            this.error = u3;
          }
        }, F3 = class {
          constructor(u3, n3, A3) {
            this._getTagContentType = n3, this._currentTokenStart = null, this._currentTokenType = null, this._expansionCaseStack = [], this._inInterpolation = false, this._fullNameStack = [], this.tokens = [], this.errors = [], this._tokenizeIcu = A3.tokenizeExpansionForms || false, this._interpolationConfig = A3.interpolationConfig || o3.DEFAULT_INTERPOLATION_CONFIG, this._leadingTriviaCodePoints = A3.leadingTriviaChars && A3.leadingTriviaChars.map((b3) => b3.codePointAt(0) || 0), this._canSelfClose = A3.canSelfClose || false, this._allowHtmComponentClosingTags = A3.allowHtmComponentClosingTags || false;
            let C3 = A3.range || { endPos: u3.content.length, startPos: 0, startLine: 0, startCol: 0 };
            this._cursor = A3.escapedString ? new ee2(u3, C3) : new Q3(u3, C3);
            try {
              this._cursor.init();
            } catch (b3) {
              this.handleError(b3);
            }
          }
          _processCarriageReturns(u3) {
            return u3.replace(s3, `
`);
          }
          tokenize() {
            for (; this._cursor.peek() !== t3.$EOF; ) {
              let u3 = this._cursor.clone();
              try {
                if (this._attemptCharCode(t3.$LT))
                  if (this._attemptCharCode(t3.$BANG))
                    this._attemptStr("[CDATA[") ? this._consumeCdata(u3) : this._attemptStr("--") ? this._consumeComment(u3) : this._attemptStrCaseInsensitive("doctype") ? this._consumeDocType(u3) : this._consumeBogusComment(u3);
                  else if (this._attemptCharCode(t3.$SLASH))
                    this._consumeTagClose(u3);
                  else {
                    let n3 = this._cursor.clone();
                    this._attemptCharCode(t3.$QUESTION) ? (this._cursor = n3, this._consumeBogusComment(u3)) : this._consumeTagOpen(u3);
                  }
                else
                  this._tokenizeIcu && this._tokenizeExpansionForm() || this._consumeText();
              } catch (n3) {
                this.handleError(n3);
              }
            }
            return this._beginToken(r3.EOF), this._endToken([]), new f3(z3(this.tokens), this.errors);
          }
          _tokenizeExpansionForm() {
            if (this.isExpansionFormStart())
              return this._consumeExpansionFormStart(), true;
            if (W3(this._cursor.peek()) && this._isInExpansionForm())
              return this._consumeExpansionCaseStart(), true;
            if (this._cursor.peek() === t3.$RBRACE) {
              if (this._isInExpansionCase())
                return this._consumeExpansionCaseEnd(), true;
              if (this._isInExpansionForm())
                return this._consumeExpansionFormEnd(), true;
            }
            return false;
          }
          _beginToken(u3) {
            let n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._cursor.clone();
            this._currentTokenStart = n3, this._currentTokenType = u3;
          }
          _endToken(u3) {
            let n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._cursor.clone();
            if (this._currentTokenStart === null)
              throw new m3("Programming error - attempted to end a token when there was no start to the token", this._currentTokenType, this._cursor.getSpan(n3));
            if (this._currentTokenType === null)
              throw new m3("Programming error - attempted to end a token which has no token type", null, this._cursor.getSpan(this._currentTokenStart));
            let A3 = new i(this._currentTokenType, u3, this._cursor.getSpan(this._currentTokenStart, this._leadingTriviaCodePoints));
            return this.tokens.push(A3), this._currentTokenStart = null, this._currentTokenType = null, A3;
          }
          _createError(u3, n3) {
            this._isInExpansionForm() && (u3 += ` (Do you have an unescaped "{" in your template? Use "{{ '{' }}") to escape it.)`);
            let A3 = new m3(u3, this._currentTokenType, n3);
            return this._currentTokenStart = null, this._currentTokenType = null, new v3(A3);
          }
          handleError(u3) {
            if (u3 instanceof re2 && (u3 = this._createError(u3.msg, this._cursor.getSpan(u3.cursor))), u3 instanceof v3)
              this.errors.push(u3.error);
            else
              throw u3;
          }
          _attemptCharCode(u3) {
            return this._cursor.peek() === u3 ? (this._cursor.advance(), true) : false;
          }
          _attemptCharCodeCaseInsensitive(u3) {
            return se2(this._cursor.peek(), u3) ? (this._cursor.advance(), true) : false;
          }
          _requireCharCode(u3) {
            let n3 = this._cursor.clone();
            if (!this._attemptCharCode(u3))
              throw this._createError(D3(this._cursor.peek()), this._cursor.getSpan(n3));
          }
          _attemptStr(u3) {
            let n3 = u3.length;
            if (this._cursor.charsLeft() < n3)
              return false;
            let A3 = this._cursor.clone();
            for (let C3 = 0; C3 < n3; C3++)
              if (!this._attemptCharCode(u3.charCodeAt(C3)))
                return this._cursor = A3, false;
            return true;
          }
          _attemptStrCaseInsensitive(u3) {
            for (let n3 = 0; n3 < u3.length; n3++)
              if (!this._attemptCharCodeCaseInsensitive(u3.charCodeAt(n3)))
                return false;
            return true;
          }
          _requireStr(u3) {
            let n3 = this._cursor.clone();
            if (!this._attemptStr(u3))
              throw this._createError(D3(this._cursor.peek()), this._cursor.getSpan(n3));
          }
          _requireStrCaseInsensitive(u3) {
            let n3 = this._cursor.clone();
            if (!this._attemptStrCaseInsensitive(u3))
              throw this._createError(D3(this._cursor.peek()), this._cursor.getSpan(n3));
          }
          _attemptCharCodeUntilFn(u3) {
            for (; !u3(this._cursor.peek()); )
              this._cursor.advance();
          }
          _requireCharCodeUntilFn(u3, n3) {
            let A3 = this._cursor.clone();
            if (this._attemptCharCodeUntilFn(u3), this._cursor.clone().diff(A3) < n3)
              throw this._createError(D3(this._cursor.peek()), this._cursor.getSpan(A3));
          }
          _attemptUntilChar(u3) {
            for (; this._cursor.peek() !== u3; )
              this._cursor.advance();
          }
          _readChar(u3) {
            if (u3 && this._cursor.peek() === t3.$AMPERSAND)
              return this._decodeEntity();
            {
              let n3 = String.fromCodePoint(this._cursor.peek());
              return this._cursor.advance(), n3;
            }
          }
          _decodeEntity() {
            let u3 = this._cursor.clone();
            if (this._cursor.advance(), this._attemptCharCode(t3.$HASH)) {
              let n3 = this._attemptCharCode(t3.$x) || this._attemptCharCode(t3.$X), A3 = this._cursor.clone();
              if (this._attemptCharCodeUntilFn(O3), this._cursor.peek() != t3.$SEMICOLON)
                throw this._createError(D3(this._cursor.peek()), this._cursor.getSpan());
              let C3 = this._cursor.getChars(A3);
              this._cursor.advance();
              try {
                let b3 = parseInt(C3, n3 ? 16 : 10);
                return String.fromCharCode(b3);
              } catch {
                throw this._createError(E3(this._cursor.getChars(u3)), this._cursor.getSpan());
              }
            } else {
              let n3 = this._cursor.clone();
              if (this._attemptCharCodeUntilFn(G3), this._cursor.peek() != t3.$SEMICOLON)
                return this._cursor = n3, "&";
              let A3 = this._cursor.getChars(n3);
              this._cursor.advance();
              let C3 = p3.NAMED_ENTITIES[A3];
              if (!C3)
                throw this._createError(E3(A3), this._cursor.getSpan(u3));
              return C3;
            }
          }
          _consumeRawText(u3, n3) {
            this._beginToken(u3 ? r3.ESCAPABLE_RAW_TEXT : r3.RAW_TEXT);
            let A3 = [];
            for (; ; ) {
              let C3 = this._cursor.clone(), b3 = n3();
              if (this._cursor = C3, b3)
                break;
              A3.push(this._readChar(u3));
            }
            return this._endToken([this._processCarriageReturns(A3.join(""))]);
          }
          _consumeComment(u3) {
            this._beginToken(r3.COMMENT_START, u3), this._endToken([]), this._consumeRawText(false, () => this._attemptStr("-->")), this._beginToken(r3.COMMENT_END), this._requireStr("-->"), this._endToken([]);
          }
          _consumeBogusComment(u3) {
            this._beginToken(r3.COMMENT_START, u3), this._endToken([]), this._consumeRawText(false, () => this._cursor.peek() === t3.$GT), this._beginToken(r3.COMMENT_END), this._cursor.advance(), this._endToken([]);
          }
          _consumeCdata(u3) {
            this._beginToken(r3.CDATA_START, u3), this._endToken([]), this._consumeRawText(false, () => this._attemptStr("]]>")), this._beginToken(r3.CDATA_END), this._requireStr("]]>"), this._endToken([]);
          }
          _consumeDocType(u3) {
            this._beginToken(r3.DOC_TYPE_START, u3), this._endToken([]), this._consumeRawText(false, () => this._cursor.peek() === t3.$GT), this._beginToken(r3.DOC_TYPE_END), this._cursor.advance(), this._endToken([]);
          }
          _consumePrefixAndName() {
            let u3 = this._cursor.clone(), n3 = "";
            for (; this._cursor.peek() !== t3.$COLON && !X3(this._cursor.peek()); )
              this._cursor.advance();
            let A3;
            this._cursor.peek() === t3.$COLON ? (n3 = this._cursor.getChars(u3), this._cursor.advance(), A3 = this._cursor.clone()) : A3 = u3, this._requireCharCodeUntilFn($3, n3 === "" ? 0 : 1);
            let C3 = this._cursor.getChars(A3);
            return [n3, C3];
          }
          _consumeTagOpen(u3) {
            let n3, A3, C3, b3 = this.tokens.length, K3 = this._cursor.clone(), te2 = [];
            try {
              if (!t3.isAsciiLetter(this._cursor.peek()))
                throw this._createError(D3(this._cursor.peek()), this._cursor.getSpan(u3));
              for (C3 = this._consumeTagOpenStart(u3), A3 = C3.parts[0], n3 = C3.parts[1], this._attemptCharCodeUntilFn(T3); this._cursor.peek() !== t3.$SLASH && this._cursor.peek() !== t3.$GT; ) {
                let [oe2, he2] = this._consumeAttributeName();
                if (this._attemptCharCodeUntilFn(T3), this._attemptCharCode(t3.$EQ)) {
                  this._attemptCharCodeUntilFn(T3);
                  let de2 = this._consumeAttributeValue();
                  te2.push({ prefix: oe2, name: he2, value: de2 });
                } else
                  te2.push({ prefix: oe2, name: he2 });
                this._attemptCharCodeUntilFn(T3);
              }
              this._consumeTagOpenEnd();
            } catch (oe2) {
              if (oe2 instanceof v3) {
                this._cursor = K3, C3 && (this.tokens.length = b3), this._beginToken(r3.TEXT, u3), this._endToken(["<"]);
                return;
              }
              throw oe2;
            }
            if (this._canSelfClose && this.tokens[this.tokens.length - 1].type === r3.TAG_OPEN_END_VOID)
              return;
            let le2 = this._getTagContentType(n3, A3, this._fullNameStack.length > 0, te2);
            this._handleFullNameStackForTagOpen(A3, n3), le2 === p3.TagContentType.RAW_TEXT ? this._consumeRawTextWithTagClose(A3, n3, false) : le2 === p3.TagContentType.ESCAPABLE_RAW_TEXT && this._consumeRawTextWithTagClose(A3, n3, true);
          }
          _consumeRawTextWithTagClose(u3, n3, A3) {
            this._consumeRawText(A3, () => !this._attemptCharCode(t3.$LT) || !this._attemptCharCode(t3.$SLASH) || (this._attemptCharCodeUntilFn(T3), !this._attemptStrCaseInsensitive(u3 ? `${u3}:${n3}` : n3)) ? false : (this._attemptCharCodeUntilFn(T3), this._attemptCharCode(t3.$GT))), this._beginToken(r3.TAG_CLOSE), this._requireCharCodeUntilFn((C3) => C3 === t3.$GT, 3), this._cursor.advance(), this._endToken([u3, n3]), this._handleFullNameStackForTagClose(u3, n3);
          }
          _consumeTagOpenStart(u3) {
            this._beginToken(r3.TAG_OPEN_START, u3);
            let n3 = this._consumePrefixAndName();
            return this._endToken(n3);
          }
          _consumeAttributeName() {
            let u3 = this._cursor.peek();
            if (u3 === t3.$SQ || u3 === t3.$DQ)
              throw this._createError(D3(u3), this._cursor.getSpan());
            this._beginToken(r3.ATTR_NAME);
            let n3 = this._consumePrefixAndName();
            return this._endToken(n3), n3;
          }
          _consumeAttributeValue() {
            let u3;
            if (this._cursor.peek() === t3.$SQ || this._cursor.peek() === t3.$DQ) {
              this._beginToken(r3.ATTR_QUOTE);
              let n3 = this._cursor.peek();
              this._cursor.advance(), this._endToken([String.fromCodePoint(n3)]), this._beginToken(r3.ATTR_VALUE);
              let A3 = [];
              for (; this._cursor.peek() !== n3; )
                A3.push(this._readChar(true));
              u3 = this._processCarriageReturns(A3.join("")), this._endToken([u3]), this._beginToken(r3.ATTR_QUOTE), this._cursor.advance(), this._endToken([String.fromCodePoint(n3)]);
            } else {
              this._beginToken(r3.ATTR_VALUE);
              let n3 = this._cursor.clone();
              this._requireCharCodeUntilFn($3, 1), u3 = this._processCarriageReturns(this._cursor.getChars(n3)), this._endToken([u3]);
            }
            return u3;
          }
          _consumeTagOpenEnd() {
            let u3 = this._attemptCharCode(t3.$SLASH) ? r3.TAG_OPEN_END_VOID : r3.TAG_OPEN_END;
            this._beginToken(u3), this._requireCharCode(t3.$GT), this._endToken([]);
          }
          _consumeTagClose(u3) {
            if (this._beginToken(r3.TAG_CLOSE, u3), this._attemptCharCodeUntilFn(T3), this._allowHtmComponentClosingTags && this._attemptCharCode(t3.$SLASH))
              this._attemptCharCodeUntilFn(T3), this._requireCharCode(t3.$GT), this._endToken([]);
            else {
              let [n3, A3] = this._consumePrefixAndName();
              this._attemptCharCodeUntilFn(T3), this._requireCharCode(t3.$GT), this._endToken([n3, A3]), this._handleFullNameStackForTagClose(n3, A3);
            }
          }
          _consumeExpansionFormStart() {
            this._beginToken(r3.EXPANSION_FORM_START), this._requireCharCode(t3.$LBRACE), this._endToken([]), this._expansionCaseStack.push(r3.EXPANSION_FORM_START), this._beginToken(r3.RAW_TEXT);
            let u3 = this._readUntil(t3.$COMMA);
            this._endToken([u3]), this._requireCharCode(t3.$COMMA), this._attemptCharCodeUntilFn(T3), this._beginToken(r3.RAW_TEXT);
            let n3 = this._readUntil(t3.$COMMA);
            this._endToken([n3]), this._requireCharCode(t3.$COMMA), this._attemptCharCodeUntilFn(T3);
          }
          _consumeExpansionCaseStart() {
            this._beginToken(r3.EXPANSION_CASE_VALUE);
            let u3 = this._readUntil(t3.$LBRACE).trim();
            this._endToken([u3]), this._attemptCharCodeUntilFn(T3), this._beginToken(r3.EXPANSION_CASE_EXP_START), this._requireCharCode(t3.$LBRACE), this._endToken([]), this._attemptCharCodeUntilFn(T3), this._expansionCaseStack.push(r3.EXPANSION_CASE_EXP_START);
          }
          _consumeExpansionCaseEnd() {
            this._beginToken(r3.EXPANSION_CASE_EXP_END), this._requireCharCode(t3.$RBRACE), this._endToken([]), this._attemptCharCodeUntilFn(T3), this._expansionCaseStack.pop();
          }
          _consumeExpansionFormEnd() {
            this._beginToken(r3.EXPANSION_FORM_END), this._requireCharCode(t3.$RBRACE), this._endToken([]), this._expansionCaseStack.pop();
          }
          _consumeText() {
            let u3 = this._cursor.clone();
            this._beginToken(r3.TEXT, u3);
            let n3 = [];
            do
              this._interpolationConfig && this._attemptStr(this._interpolationConfig.start) ? (n3.push(this._interpolationConfig.start), this._inInterpolation = true) : this._interpolationConfig && this._inInterpolation && this._attemptStr(this._interpolationConfig.end) ? (n3.push(this._interpolationConfig.end), this._inInterpolation = false) : n3.push(this._readChar(true));
            while (!this._isTextEnd());
            this._endToken([this._processCarriageReturns(n3.join(""))]);
          }
          _isTextEnd() {
            return !!(this._cursor.peek() === t3.$LT || this._cursor.peek() === t3.$EOF || this._tokenizeIcu && !this._inInterpolation && (this.isExpansionFormStart() || this._cursor.peek() === t3.$RBRACE && this._isInExpansionCase()));
          }
          _readUntil(u3) {
            let n3 = this._cursor.clone();
            return this._attemptUntilChar(u3), this._cursor.getChars(n3);
          }
          _isInExpansionCase() {
            return this._expansionCaseStack.length > 0 && this._expansionCaseStack[this._expansionCaseStack.length - 1] === r3.EXPANSION_CASE_EXP_START;
          }
          _isInExpansionForm() {
            return this._expansionCaseStack.length > 0 && this._expansionCaseStack[this._expansionCaseStack.length - 1] === r3.EXPANSION_FORM_START;
          }
          isExpansionFormStart() {
            if (this._cursor.peek() !== t3.$LBRACE)
              return false;
            if (this._interpolationConfig) {
              let u3 = this._cursor.clone(), n3 = this._attemptStr(this._interpolationConfig.start);
              return this._cursor = u3, !n3;
            }
            return true;
          }
          _handleFullNameStackForTagOpen(u3, n3) {
            let A3 = p3.mergeNsAndName(u3, n3);
            (this._fullNameStack.length === 0 || this._fullNameStack[this._fullNameStack.length - 1] === A3) && this._fullNameStack.push(A3);
          }
          _handleFullNameStackForTagClose(u3, n3) {
            let A3 = p3.mergeNsAndName(u3, n3);
            this._fullNameStack.length !== 0 && this._fullNameStack[this._fullNameStack.length - 1] === A3 && this._fullNameStack.pop();
          }
        };
        function T3(u3) {
          return !t3.isWhitespace(u3) || u3 === t3.$EOF;
        }
        function $3(u3) {
          return t3.isWhitespace(u3) || u3 === t3.$GT || u3 === t3.$SLASH || u3 === t3.$SQ || u3 === t3.$DQ || u3 === t3.$EQ;
        }
        function X3(u3) {
          return (u3 < t3.$a || t3.$z < u3) && (u3 < t3.$A || t3.$Z < u3) && (u3 < t3.$0 || u3 > t3.$9);
        }
        function O3(u3) {
          return u3 == t3.$SEMICOLON || u3 == t3.$EOF || !t3.isAsciiHexDigit(u3);
        }
        function G3(u3) {
          return u3 == t3.$SEMICOLON || u3 == t3.$EOF || !t3.isAsciiLetter(u3);
        }
        function W3(u3) {
          return u3 === t3.$EQ || t3.isAsciiLetter(u3) || t3.isDigit(u3);
        }
        function se2(u3, n3) {
          return B3(u3) == B3(n3);
        }
        function B3(u3) {
          return u3 >= t3.$a && u3 <= t3.$z ? u3 - t3.$a + t3.$A : u3;
        }
        function z3(u3) {
          let n3 = [], A3;
          for (let C3 = 0; C3 < u3.length; C3++) {
            let b3 = u3[C3];
            A3 && A3.type == r3.TEXT && b3.type == r3.TEXT ? (A3.parts[0] += b3.parts[0], A3.sourceSpan.end = b3.sourceSpan.end) : (A3 = b3, n3.push(A3));
          }
          return n3;
        }
        var Q3 = class {
          constructor(u3, n3) {
            if (u3 instanceof Q3)
              this.file = u3.file, this.input = u3.input, this.end = u3.end, this.state = Object.assign({}, u3.state);
            else {
              if (!n3)
                throw new Error("Programming error: the range argument must be provided with a file argument.");
              this.file = u3, this.input = u3.content, this.end = n3.endPos, this.state = { peek: -1, offset: n3.startPos, line: n3.startLine, column: n3.startCol };
            }
          }
          clone() {
            return new Q3(this);
          }
          peek() {
            return this.state.peek;
          }
          charsLeft() {
            return this.end - this.state.offset;
          }
          diff(u3) {
            return this.state.offset - u3.state.offset;
          }
          advance() {
            this.advanceState(this.state);
          }
          init() {
            this.updatePeek(this.state);
          }
          getSpan(u3, n3) {
            if (u3 = u3 || this, n3)
              for (u3 = u3.clone(); this.diff(u3) > 0 && n3.indexOf(u3.peek()) !== -1; )
                u3.advance();
            return new a3.ParseSourceSpan(new a3.ParseLocation(u3.file, u3.state.offset, u3.state.line, u3.state.column), new a3.ParseLocation(this.file, this.state.offset, this.state.line, this.state.column));
          }
          getChars(u3) {
            return this.input.substring(u3.state.offset, this.state.offset);
          }
          charAt(u3) {
            return this.input.charCodeAt(u3);
          }
          advanceState(u3) {
            if (u3.offset >= this.end)
              throw this.state = u3, new re2('Unexpected character "EOF"', this);
            let n3 = this.charAt(u3.offset);
            n3 === t3.$LF ? (u3.line++, u3.column = 0) : t3.isNewLine(n3) || u3.column++, u3.offset++, this.updatePeek(u3);
          }
          updatePeek(u3) {
            u3.peek = u3.offset >= this.end ? t3.$EOF : this.charAt(u3.offset);
          }
        }, ee2 = class extends Q3 {
          constructor(u3, n3) {
            u3 instanceof ee2 ? (super(u3), this.internalState = Object.assign({}, u3.internalState)) : (super(u3, n3), this.internalState = this.state);
          }
          advance() {
            this.state = this.internalState, super.advance(), this.processEscapeSequence();
          }
          init() {
            super.init(), this.processEscapeSequence();
          }
          clone() {
            return new ee2(this);
          }
          getChars(u3) {
            let n3 = u3.clone(), A3 = "";
            for (; n3.internalState.offset < this.internalState.offset; )
              A3 += String.fromCodePoint(n3.peek()), n3.advance();
            return A3;
          }
          processEscapeSequence() {
            let u3 = () => this.internalState.peek;
            if (u3() === t3.$BACKSLASH)
              if (this.internalState = Object.assign({}, this.state), this.advanceState(this.internalState), u3() === t3.$n)
                this.state.peek = t3.$LF;
              else if (u3() === t3.$r)
                this.state.peek = t3.$CR;
              else if (u3() === t3.$v)
                this.state.peek = t3.$VTAB;
              else if (u3() === t3.$t)
                this.state.peek = t3.$TAB;
              else if (u3() === t3.$b)
                this.state.peek = t3.$BSPACE;
              else if (u3() === t3.$f)
                this.state.peek = t3.$FF;
              else if (u3() === t3.$u)
                if (this.advanceState(this.internalState), u3() === t3.$LBRACE) {
                  this.advanceState(this.internalState);
                  let n3 = this.clone(), A3 = 0;
                  for (; u3() !== t3.$RBRACE; )
                    this.advanceState(this.internalState), A3++;
                  this.state.peek = this.decodeHexDigits(n3, A3);
                } else {
                  let n3 = this.clone();
                  this.advanceState(this.internalState), this.advanceState(this.internalState), this.advanceState(this.internalState), this.state.peek = this.decodeHexDigits(n3, 4);
                }
              else if (u3() === t3.$x) {
                this.advanceState(this.internalState);
                let n3 = this.clone();
                this.advanceState(this.internalState), this.state.peek = this.decodeHexDigits(n3, 2);
              } else if (t3.isOctalDigit(u3())) {
                let n3 = "", A3 = 0, C3 = this.clone();
                for (; t3.isOctalDigit(u3()) && A3 < 3; )
                  C3 = this.clone(), n3 += String.fromCodePoint(u3()), this.advanceState(this.internalState), A3++;
                this.state.peek = parseInt(n3, 8), this.internalState = C3.internalState;
              } else
                t3.isNewLine(this.internalState.peek) ? (this.advanceState(this.internalState), this.state = this.internalState) : this.state.peek = this.internalState.peek;
          }
          decodeHexDigits(u3, n3) {
            let A3 = this.input.substr(u3.internalState.offset, n3), C3 = parseInt(A3, 16);
            if (isNaN(C3))
              throw u3.state = u3.internalState, new re2("Invalid hexadecimal escape sequence", u3);
            return C3;
          }
        }, re2 = class {
          constructor(u3, n3) {
            this.msg = u3, this.cursor = n3;
          }
        };
        e28.CursorError = re2;
      } }), ju2 = S3({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/parser.js"(e28) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true });
        var t3 = _e2(), a3 = Mu2(), o3 = vr2(), p3 = Qe2(), r3 = class extends t3.ParseError {
          constructor(s3, D3, E3) {
            super(D3, E3), this.elementName = s3;
          }
          static create(s3, D3, E3) {
            return new r3(s3, D3, E3);
          }
        };
        e28.TreeError = r3;
        var i = class {
          constructor(s3, D3) {
            this.rootNodes = s3, this.errors = D3;
          }
        };
        e28.ParseTreeResult = i;
        var m3 = class {
          constructor(s3) {
            this.getTagDefinition = s3;
          }
          parse(s3, D3, E3) {
            let v3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, F3 = arguments.length > 4 ? arguments[4] : void 0, T3 = (Q3) => function(ee2) {
              for (var re2 = arguments.length, u3 = new Array(re2 > 1 ? re2 - 1 : 0), n3 = 1; n3 < re2; n3++)
                u3[n3 - 1] = arguments[n3];
              return Q3(ee2.toLowerCase(), ...u3);
            }, $3 = v3 ? this.getTagDefinition : T3(this.getTagDefinition), X3 = (Q3) => $3(Q3).contentType, O3 = v3 ? F3 : T3(F3), G3 = F3 ? (Q3, ee2, re2, u3) => {
              let n3 = O3(Q3, ee2, re2, u3);
              return n3 !== void 0 ? n3 : X3(Q3);
            } : X3, W3 = o3.tokenize(s3, D3, G3, E3), se2 = E3 && E3.canSelfClose || false, B3 = E3 && E3.allowHtmComponentClosingTags || false, z3 = new f3(W3.tokens, $3, se2, B3, v3).build();
            return new i(z3.rootNodes, W3.errors.concat(z3.errors));
          }
        };
        e28.Parser = m3;
        var f3 = class {
          constructor(s3, D3, E3, v3, F3) {
            this.tokens = s3, this.getTagDefinition = D3, this.canSelfClose = E3, this.allowHtmComponentClosingTags = v3, this.isTagNameCaseSensitive = F3, this._index = -1, this._rootNodes = [], this._errors = [], this._elementStack = [], this._advance();
          }
          build() {
            for (; this._peek.type !== o3.TokenType.EOF; )
              this._peek.type === o3.TokenType.TAG_OPEN_START ? this._consumeStartTag(this._advance()) : this._peek.type === o3.TokenType.TAG_CLOSE ? (this._closeVoidElement(), this._consumeEndTag(this._advance())) : this._peek.type === o3.TokenType.CDATA_START ? (this._closeVoidElement(), this._consumeCdata(this._advance())) : this._peek.type === o3.TokenType.COMMENT_START ? (this._closeVoidElement(), this._consumeComment(this._advance())) : this._peek.type === o3.TokenType.TEXT || this._peek.type === o3.TokenType.RAW_TEXT || this._peek.type === o3.TokenType.ESCAPABLE_RAW_TEXT ? (this._closeVoidElement(), this._consumeText(this._advance())) : this._peek.type === o3.TokenType.EXPANSION_FORM_START ? this._consumeExpansion(this._advance()) : this._peek.type === o3.TokenType.DOC_TYPE_START ? this._consumeDocType(this._advance()) : this._advance();
            return new i(this._rootNodes, this._errors);
          }
          _advance() {
            let s3 = this._peek;
            return this._index < this.tokens.length - 1 && this._index++, this._peek = this.tokens[this._index], s3;
          }
          _advanceIf(s3) {
            return this._peek.type === s3 ? this._advance() : null;
          }
          _consumeCdata(s3) {
            let D3 = this._advance(), E3 = this._getText(D3), v3 = this._advanceIf(o3.TokenType.CDATA_END);
            this._addToParent(new a3.CDATA(E3, new t3.ParseSourceSpan(s3.sourceSpan.start, (v3 || D3).sourceSpan.end)));
          }
          _consumeComment(s3) {
            let D3 = this._advanceIf(o3.TokenType.RAW_TEXT), E3 = this._advanceIf(o3.TokenType.COMMENT_END), v3 = D3 != null ? D3.parts[0].trim() : null, F3 = new t3.ParseSourceSpan(s3.sourceSpan.start, (E3 || D3 || s3).sourceSpan.end);
            this._addToParent(new a3.Comment(v3, F3));
          }
          _consumeDocType(s3) {
            let D3 = this._advanceIf(o3.TokenType.RAW_TEXT), E3 = this._advanceIf(o3.TokenType.DOC_TYPE_END), v3 = D3 != null ? D3.parts[0].trim() : null, F3 = new t3.ParseSourceSpan(s3.sourceSpan.start, (E3 || D3 || s3).sourceSpan.end);
            this._addToParent(new a3.DocType(v3, F3));
          }
          _consumeExpansion(s3) {
            let D3 = this._advance(), E3 = this._advance(), v3 = [];
            for (; this._peek.type === o3.TokenType.EXPANSION_CASE_VALUE; ) {
              let T3 = this._parseExpansionCase();
              if (!T3)
                return;
              v3.push(T3);
            }
            if (this._peek.type !== o3.TokenType.EXPANSION_FORM_END) {
              this._errors.push(r3.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '}'."));
              return;
            }
            let F3 = new t3.ParseSourceSpan(s3.sourceSpan.start, this._peek.sourceSpan.end);
            this._addToParent(new a3.Expansion(D3.parts[0], E3.parts[0], v3, F3, D3.sourceSpan)), this._advance();
          }
          _parseExpansionCase() {
            let s3 = this._advance();
            if (this._peek.type !== o3.TokenType.EXPANSION_CASE_EXP_START)
              return this._errors.push(r3.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '{'.")), null;
            let D3 = this._advance(), E3 = this._collectExpansionExpTokens(D3);
            if (!E3)
              return null;
            let v3 = this._advance();
            E3.push(new o3.Token(o3.TokenType.EOF, [], v3.sourceSpan));
            let F3 = new f3(E3, this.getTagDefinition, this.canSelfClose, this.allowHtmComponentClosingTags, this.isTagNameCaseSensitive).build();
            if (F3.errors.length > 0)
              return this._errors = this._errors.concat(F3.errors), null;
            let T3 = new t3.ParseSourceSpan(s3.sourceSpan.start, v3.sourceSpan.end), $3 = new t3.ParseSourceSpan(D3.sourceSpan.start, v3.sourceSpan.end);
            return new a3.ExpansionCase(s3.parts[0], F3.rootNodes, T3, s3.sourceSpan, $3);
          }
          _collectExpansionExpTokens(s3) {
            let D3 = [], E3 = [o3.TokenType.EXPANSION_CASE_EXP_START];
            for (; ; ) {
              if ((this._peek.type === o3.TokenType.EXPANSION_FORM_START || this._peek.type === o3.TokenType.EXPANSION_CASE_EXP_START) && E3.push(this._peek.type), this._peek.type === o3.TokenType.EXPANSION_CASE_EXP_END)
                if (L3(E3, o3.TokenType.EXPANSION_CASE_EXP_START)) {
                  if (E3.pop(), E3.length == 0)
                    return D3;
                } else
                  return this._errors.push(r3.create(null, s3.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
              if (this._peek.type === o3.TokenType.EXPANSION_FORM_END)
                if (L3(E3, o3.TokenType.EXPANSION_FORM_START))
                  E3.pop();
                else
                  return this._errors.push(r3.create(null, s3.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
              if (this._peek.type === o3.TokenType.EOF)
                return this._errors.push(r3.create(null, s3.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
              D3.push(this._advance());
            }
          }
          _getText(s3) {
            let D3 = s3.parts[0];
            if (D3.length > 0 && D3[0] == `
`) {
              let E3 = this._getParentElement();
              E3 != null && E3.children.length == 0 && this.getTagDefinition(E3.name).ignoreFirstLf && (D3 = D3.substring(1));
            }
            return D3;
          }
          _consumeText(s3) {
            let D3 = this._getText(s3);
            D3.length > 0 && this._addToParent(new a3.Text(D3, s3.sourceSpan));
          }
          _closeVoidElement() {
            let s3 = this._getParentElement();
            s3 && this.getTagDefinition(s3.name).isVoid && this._elementStack.pop();
          }
          _consumeStartTag(s3) {
            let D3 = s3.parts[0], E3 = s3.parts[1], v3 = [];
            for (; this._peek.type === o3.TokenType.ATTR_NAME; )
              v3.push(this._consumeAttr(this._advance()));
            let F3 = this._getElementFullName(D3, E3, this._getParentElement()), T3 = false;
            if (this._peek.type === o3.TokenType.TAG_OPEN_END_VOID) {
              this._advance(), T3 = true;
              let W3 = this.getTagDefinition(F3);
              this.canSelfClose || W3.canSelfClose || p3.getNsPrefix(F3) !== null || W3.isVoid || this._errors.push(r3.create(F3, s3.sourceSpan, `Only void and foreign elements can be self closed "${s3.parts[1]}"`));
            } else
              this._peek.type === o3.TokenType.TAG_OPEN_END && (this._advance(), T3 = false);
            let $3 = this._peek.sourceSpan.start, X3 = new t3.ParseSourceSpan(s3.sourceSpan.start, $3), O3 = new t3.ParseSourceSpan(s3.sourceSpan.start.moveBy(1), s3.sourceSpan.end), G3 = new a3.Element(F3, v3, [], X3, X3, void 0, O3);
            this._pushElement(G3), T3 && (this._popElement(F3), G3.endSourceSpan = X3);
          }
          _pushElement(s3) {
            let D3 = this._getParentElement();
            D3 && this.getTagDefinition(D3.name).isClosedByChild(s3.name) && this._elementStack.pop(), this._addToParent(s3), this._elementStack.push(s3);
          }
          _consumeEndTag(s3) {
            let D3 = this.allowHtmComponentClosingTags && s3.parts.length === 0 ? null : this._getElementFullName(s3.parts[0], s3.parts[1], this._getParentElement());
            if (this._getParentElement() && (this._getParentElement().endSourceSpan = s3.sourceSpan), D3 && this.getTagDefinition(D3).isVoid)
              this._errors.push(r3.create(D3, s3.sourceSpan, `Void elements do not have end tags "${s3.parts[1]}"`));
            else if (!this._popElement(D3)) {
              let E3 = `Unexpected closing tag "${D3}". It may happen when the tag has already been closed by another tag. For more info see https://www.w3.org/TR/html5/syntax.html#closing-elements-that-have-implied-end-tags`;
              this._errors.push(r3.create(D3, s3.sourceSpan, E3));
            }
          }
          _popElement(s3) {
            for (let D3 = this._elementStack.length - 1; D3 >= 0; D3--) {
              let E3 = this._elementStack[D3];
              if (!s3 || (p3.getNsPrefix(E3.name) ? E3.name == s3 : E3.name.toLowerCase() == s3.toLowerCase()))
                return this._elementStack.splice(D3, this._elementStack.length - D3), true;
              if (!this.getTagDefinition(E3.name).closedByParent)
                return false;
            }
            return false;
          }
          _consumeAttr(s3) {
            let D3 = p3.mergeNsAndName(s3.parts[0], s3.parts[1]), E3 = s3.sourceSpan.end, v3 = "", F3, T3;
            if (this._peek.type === o3.TokenType.ATTR_QUOTE && (T3 = this._advance().sourceSpan.start), this._peek.type === o3.TokenType.ATTR_VALUE) {
              let $3 = this._advance();
              v3 = $3.parts[0], E3 = $3.sourceSpan.end, F3 = $3.sourceSpan;
            }
            return this._peek.type === o3.TokenType.ATTR_QUOTE && (E3 = this._advance().sourceSpan.end, F3 = new t3.ParseSourceSpan(T3, E3)), new a3.Attribute(D3, v3, new t3.ParseSourceSpan(s3.sourceSpan.start, E3), F3, s3.sourceSpan);
          }
          _getParentElement() {
            return this._elementStack.length > 0 ? this._elementStack[this._elementStack.length - 1] : null;
          }
          _getParentElementSkippingContainers() {
            let s3 = null;
            for (let D3 = this._elementStack.length - 1; D3 >= 0; D3--) {
              if (!p3.isNgContainer(this._elementStack[D3].name))
                return { parent: this._elementStack[D3], container: s3 };
              s3 = this._elementStack[D3];
            }
            return { parent: null, container: s3 };
          }
          _addToParent(s3) {
            let D3 = this._getParentElement();
            D3 != null ? D3.children.push(s3) : this._rootNodes.push(s3);
          }
          _insertBeforeContainer(s3, D3, E3) {
            if (!D3)
              this._addToParent(E3), this._elementStack.push(E3);
            else {
              if (s3) {
                let v3 = s3.children.indexOf(D3);
                s3.children[v3] = E3;
              } else
                this._rootNodes.push(E3);
              E3.children.push(D3), this._elementStack.splice(this._elementStack.indexOf(D3), 0, E3);
            }
          }
          _getElementFullName(s3, D3, E3) {
            return s3 === "" && (s3 = this.getTagDefinition(D3).implicitNamespacePrefix || "", s3 === "" && E3 != null && (s3 = p3.getNsPrefix(E3.name))), p3.mergeNsAndName(s3, D3);
          }
        };
        function L3(s3, D3) {
          return s3.length > 0 && s3[s3.length - 1] === D3;
        }
      } }), Tr2 = S3({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/html_parser.js"(e28) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true });
        var t3 = qu2(), a3 = ju2(), o3 = ju2();
        e28.ParseTreeResult = o3.ParseTreeResult, e28.TreeError = o3.TreeError;
        var p3 = class extends a3.Parser {
          constructor() {
            super(t3.getHtmlTagDefinition);
          }
          parse(r3, i, m3) {
            let f3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, L3 = arguments.length > 4 ? arguments[4] : void 0;
            return super.parse(r3, i, m3, f3, L3);
          }
        };
        e28.HtmlParser = p3;
      } }), Uu2 = S3({ "node_modules/angular-html-parser/lib/angular-html-parser/src/index.js"(e28) {
        R3(), Object.defineProperty(e28, "__esModule", { value: true });
        var t3 = Tr2(), a3 = Qe2();
        e28.TagContentType = a3.TagContentType;
        var o3 = null, p3 = () => (o3 || (o3 = new t3.HtmlParser()), o3);
        function r3(i) {
          let m3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { canSelfClose: f3 = false, allowHtmComponentClosingTags: L3 = false, isTagNameCaseSensitive: s3 = false, getTagContentType: D3 } = m3;
          return p3().parse(i, "angular-html-parser", { tokenizeExpansionForms: false, interpolationConfig: void 0, canSelfClose: f3, allowHtmComponentClosingTags: L3 }, s3, D3);
        }
        e28.parse = r3;
      } });
      R3();
      var { ParseSourceSpan: Ye2, ParseLocation: Vu2, ParseSourceFile: _r2 } = _e2(), Sr2 = Se2(), yr2 = ke2(), Br2 = Ie2(), { inferParserByLanguage: br2 } = or2(), wr2 = lr2(), pu2 = hr2(), Gu2 = dr2(), { hasPragma: xr2 } = Cr2(), { Node: Nr2 } = Er2(), { parseIeConditionalComment: kr2 } = mr2(), { locStart: Or2, locEnd: Pr2 } = fr2();
      function Rr2(e28, t3, a3) {
        let { canSelfClose: o3, normalizeTagName: p3, normalizeAttributeName: r3, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: m3, getTagContentType: f3 } = t3, L3 = Uu2(), { RecursiveVisitor: s3, visitAll: D3 } = Mu2(), { ParseSourceSpan: E3 } = _e2(), { getHtmlTagDefinition: v3 } = qu2(), { rootNodes: F3, errors: T3 } = L3.parse(e28, { canSelfClose: o3, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: m3, getTagContentType: f3 });
        if (a3.parser === "vue")
          if (F3.some((B3) => B3.type === "docType" && B3.value === "html" || B3.type === "element" && B3.name.toLowerCase() === "html")) {
            o3 = true, p3 = true, r3 = true, i = true, m3 = false;
            let B3 = L3.parse(e28, { canSelfClose: o3, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: m3 });
            F3 = B3.rootNodes, T3 = B3.errors;
          } else {
            let B3 = (z3) => {
              if (!z3 || z3.type !== "element" || z3.name !== "template")
                return false;
              let Q3 = z3.attrs.find((re2) => re2.name === "lang"), ee2 = Q3 && Q3.value;
              return !ee2 || br2(ee2, a3) === "html";
            };
            if (F3.some(B3)) {
              let z3, Q3 = () => L3.parse(e28, { canSelfClose: o3, allowHtmComponentClosingTags: i, isTagNameCaseSensitive: m3 }), ee2 = () => z3 || (z3 = Q3()), re2 = (u3) => ee2().rootNodes.find((n3) => {
                let { startSourceSpan: A3 } = n3;
                return A3 && A3.start.offset === u3.startSourceSpan.start.offset;
              });
              for (let u3 = 0; u3 < F3.length; u3++) {
                let n3 = F3[u3], { endSourceSpan: A3, startSourceSpan: C3 } = n3;
                if (A3 === null)
                  T3 = ee2().errors, F3[u3] = re2(n3) || n3;
                else if (B3(n3)) {
                  let b3 = ee2(), K3 = C3.end.offset, te2 = A3.start.offset;
                  for (let le2 of b3.errors) {
                    let { offset: oe2 } = le2.span.start;
                    if (K3 < oe2 && oe2 < te2) {
                      T3 = [le2];
                      break;
                    }
                  }
                  F3[u3] = re2(n3) || n3;
                }
              }
            }
          }
        if (T3.length > 0) {
          let { msg: B3, span: { start: z3, end: Q3 } } = T3[0];
          throw Br2(B3, { start: { line: z3.line + 1, column: z3.col + 1 }, end: { line: Q3.line + 1, column: Q3.col + 1 } });
        }
        let $3 = (B3) => {
          let z3 = B3.name.startsWith(":") ? B3.name.slice(1).split(":")[0] : null, Q3 = B3.nameSpan.toString(), ee2 = z3 !== null && Q3.startsWith(`${z3}:`), re2 = ee2 ? Q3.slice(z3.length + 1) : Q3;
          B3.name = re2, B3.namespace = z3, B3.hasExplicitNamespace = ee2;
        }, X3 = (B3) => {
          switch (B3.type) {
            case "element":
              $3(B3);
              for (let z3 of B3.attrs)
                $3(z3), z3.valueSpan ? (z3.value = z3.valueSpan.toString(), /["']/.test(z3.value[0]) && (z3.value = z3.value.slice(1, -1))) : z3.value = null;
              break;
            case "comment":
              B3.value = B3.sourceSpan.toString().slice(4, -3);
              break;
            case "text":
              B3.value = B3.sourceSpan.toString();
              break;
          }
        }, O3 = (B3, z3) => {
          let Q3 = B3.toLowerCase();
          return z3(Q3) ? Q3 : B3;
        }, G3 = (B3) => {
          if (B3.type === "element" && (p3 && (!B3.namespace || B3.namespace === B3.tagDefinition.implicitNamespacePrefix || Gu2(B3)) && (B3.name = O3(B3.name, (z3) => z3 in wr2)), r3)) {
            let z3 = pu2[B3.name] || /* @__PURE__ */ Object.create(null);
            for (let Q3 of B3.attrs)
              Q3.namespace || (Q3.name = O3(Q3.name, (ee2) => B3.name in pu2 && (ee2 in pu2["*"] || ee2 in z3)));
          }
        }, W3 = (B3) => {
          B3.sourceSpan && B3.endSourceSpan && (B3.sourceSpan = new E3(B3.sourceSpan.start, B3.endSourceSpan.end));
        }, se2 = (B3) => {
          if (B3.type === "element") {
            let z3 = v3(m3 ? B3.name : B3.name.toLowerCase());
            !B3.namespace || B3.namespace === z3.implicitNamespacePrefix || Gu2(B3) ? B3.tagDefinition = z3 : B3.tagDefinition = v3("");
          }
        };
        return D3(new class extends s3 {
          visit(B3) {
            X3(B3), se2(B3), G3(B3), W3(B3);
          }
        }(), F3), F3;
      }
      function Xu2(e28, t3, a3) {
        let o3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, { frontMatter: p3, content: r3 } = o3 ? Sr2(e28) : { frontMatter: null, content: e28 }, i = new _r2(e28, t3.filepath), m3 = new Vu2(i, 0, 0, 0), f3 = m3.moveBy(e28.length), L3 = { type: "root", sourceSpan: new Ye2(m3, f3), children: Rr2(r3, a3, t3) };
        if (p3) {
          let E3 = new Vu2(i, 0, 0, 0), v3 = E3.moveBy(p3.raw.length);
          p3.sourceSpan = new Ye2(E3, v3), L3.children.unshift(p3);
        }
        let s3 = new Nr2(L3), D3 = (E3, v3) => {
          let { offset: F3 } = v3, T3 = e28.slice(0, F3).replace(/[^\n\r]/g, " "), $3 = Xu2(T3 + E3, t3, a3, false);
          $3.sourceSpan = new Ye2(v3, yr2($3.children).sourceSpan.end);
          let X3 = $3.children[0];
          return X3.length === F3 ? $3.children.shift() : (X3.sourceSpan = new Ye2(X3.sourceSpan.start.moveBy(F3), X3.sourceSpan.end), X3.value = X3.value.slice(F3)), $3;
        };
        return s3.walk((E3) => {
          if (E3.type === "comment") {
            let v3 = kr2(E3, D3);
            v3 && E3.parent.replaceChild(E3, v3);
          }
        }), s3;
      }
      function Je2() {
        let { name: e28, canSelfClose: t3 = false, normalizeTagName: a3 = false, normalizeAttributeName: o3 = false, allowHtmComponentClosingTags: p3 = false, isTagNameCaseSensitive: r3 = false, getTagContentType: i } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return { parse: (m3, f3, L3) => Xu2(m3, Object.assign({ parser: e28 }, L3), { canSelfClose: t3, normalizeTagName: a3, normalizeAttributeName: o3, allowHtmComponentClosingTags: p3, isTagNameCaseSensitive: r3, getTagContentType: i }), hasPragma: xr2, astFormat: "html", locStart: Or2, locEnd: Pr2 };
      }
      c3.exports = { parsers: { html: Je2({ name: "html", canSelfClose: true, normalizeTagName: true, normalizeAttributeName: true, allowHtmComponentClosingTags: true }), angular: Je2({ name: "angular", canSelfClose: true }), vue: Je2({ name: "vue", canSelfClose: true, isTagNameCaseSensitive: true, getTagContentType: (e28, t3, a3, o3) => {
        if (e28.toLowerCase() !== "html" && !a3 && (e28 !== "template" || o3.some((p3) => {
          let { name: r3, value: i } = p3;
          return r3 === "lang" && i !== "html" && i !== "" && i !== void 0;
        })))
          return Uu2().TagContentType.RAW_TEXT;
      } }), lwc: Je2({ name: "lwc" }) } };
    });
    return Mt2();
  });
})(r$U);
var Lr$1 = r$U.exports;
const jr$1 = /* @__PURE__ */ l$Y(Lr$1);
var s$12 = { exports: {} };
(function(ao2, Li2) {
  (function(q3) {
    ao2.exports = q3();
  })(function() {
    var q3 = (B3, S3) => () => (S3 || B3((S3 = { exports: {} }).exports, S3), S3.exports), Me2 = q3((B3, S3) => {
      var j3 = function(I3) {
        return I3 && I3.Math == Math && I3;
      };
      S3.exports = j3(typeof globalThis == "object" && globalThis) || j3(typeof window == "object" && window) || j3(typeof self == "object" && self) || j3(typeof o$R == "object" && o$R) || function() {
        return this;
      }() || Function("return this")();
    }), We2 = q3((B3, S3) => {
      S3.exports = function(j3) {
        try {
          return !!j3();
        } catch {
          return true;
        }
      };
    }), Ue2 = q3((B3, S3) => {
      var j3 = We2();
      S3.exports = !j3(function() {
        return Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1] != 7;
      });
    }), tr2 = q3((B3, S3) => {
      var j3 = We2();
      S3.exports = !j3(function() {
        var I3 = function() {
        }.bind();
        return typeof I3 != "function" || I3.hasOwnProperty("prototype");
      });
    }), wt2 = q3((B3, S3) => {
      var j3 = tr2(), I3 = Function.prototype.call;
      S3.exports = j3 ? I3.bind(I3) : function() {
        return I3.apply(I3, arguments);
      };
    }), uo2 = q3((B3) => {
      var S3 = {}.propertyIsEnumerable, j3 = Object.getOwnPropertyDescriptor, I3 = j3 && !S3.call({ 1: 2 }, 1);
      B3.f = I3 ? function(M3) {
        var N3 = j3(this, M3);
        return !!N3 && N3.enumerable;
      } : S3;
    }), rr2 = q3((B3, S3) => {
      S3.exports = function(j3, I3) {
        return { enumerable: !(j3 & 1), configurable: !(j3 & 2), writable: !(j3 & 4), value: I3 };
      };
    }), Fe2 = q3((B3, S3) => {
      var j3 = tr2(), I3 = Function.prototype, M3 = I3.call, N3 = j3 && I3.bind.bind(M3, M3);
      S3.exports = j3 ? N3 : function(F3) {
        return function() {
          return M3.apply(F3, arguments);
        };
      };
    }), co2 = q3((B3, S3) => {
      var j3 = Fe2(), I3 = j3({}.toString), M3 = j3("".slice);
      S3.exports = function(N3) {
        return M3(I3(N3), 8, -1);
      };
    }), lo2 = q3((B3, S3) => {
      var j3 = Fe2(), I3 = We2(), M3 = co2(), N3 = Object, F3 = j3("".split);
      S3.exports = I3(function() {
        return !N3("z").propertyIsEnumerable(0);
      }) ? function(O3) {
        return M3(O3) == "String" ? F3(O3, "") : N3(O3);
      } : N3;
    }), nr2 = q3((B3, S3) => {
      S3.exports = function(j3) {
        return j3 == null;
      };
    }), or2 = q3((B3, S3) => {
      var j3 = nr2(), I3 = TypeError;
      S3.exports = function(M3) {
        if (j3(M3))
          throw I3("Can't call method on " + M3);
        return M3;
      };
    }), xt2 = q3((B3, S3) => {
      var j3 = lo2(), I3 = or2();
      S3.exports = function(M3) {
        return j3(I3(M3));
      };
    }), sr2 = q3((B3, S3) => {
      var j3 = typeof document == "object" && document.all, I3 = typeof j3 > "u" && j3 !== void 0;
      S3.exports = { all: j3, IS_HTMLDDA: I3 };
    }), Ie2 = q3((B3, S3) => {
      var j3 = sr2(), I3 = j3.all;
      S3.exports = j3.IS_HTMLDDA ? function(M3) {
        return typeof M3 == "function" || M3 === I3;
      } : function(M3) {
        return typeof M3 == "function";
      };
    }), Xe2 = q3((B3, S3) => {
      var j3 = Ie2(), I3 = sr2(), M3 = I3.all;
      S3.exports = I3.IS_HTMLDDA ? function(N3) {
        return typeof N3 == "object" ? N3 !== null : j3(N3) || N3 === M3;
      } : function(N3) {
        return typeof N3 == "object" ? N3 !== null : j3(N3);
      };
    }), kt2 = q3((B3, S3) => {
      var j3 = Me2(), I3 = Ie2(), M3 = function(N3) {
        return I3(N3) ? N3 : void 0;
      };
      S3.exports = function(N3, F3) {
        return arguments.length < 2 ? M3(j3[N3]) : j3[N3] && j3[N3][F3];
      };
    }), fo2 = q3((B3, S3) => {
      var j3 = Fe2();
      S3.exports = j3({}.isPrototypeOf);
    }), po2 = q3((B3, S3) => {
      var j3 = kt2();
      S3.exports = j3("navigator", "userAgent") || "";
    }), ho2 = q3((B3, S3) => {
      var j3 = Me2(), I3 = po2(), M3 = j3.process, N3 = j3.Deno, F3 = M3 && M3.versions || N3 && N3.version, O3 = F3 && F3.v8, H3, Q3;
      O3 && (H3 = O3.split("."), Q3 = H3[0] > 0 && H3[0] < 4 ? 1 : +(H3[0] + H3[1])), !Q3 && I3 && (H3 = I3.match(/Edge\/(\d+)/), (!H3 || H3[1] >= 74) && (H3 = I3.match(/Chrome\/(\d+)/), H3 && (Q3 = +H3[1]))), S3.exports = Q3;
    }), ir2 = q3((B3, S3) => {
      var j3 = ho2(), I3 = We2();
      S3.exports = !!Object.getOwnPropertySymbols && !I3(function() {
        var M3 = Symbol();
        return !String(M3) || !(Object(M3) instanceof Symbol) || !Symbol.sham && j3 && j3 < 41;
      });
    }), ar2 = q3((B3, S3) => {
      var j3 = ir2();
      S3.exports = j3 && !Symbol.sham && typeof Symbol.iterator == "symbol";
    }), ur2 = q3((B3, S3) => {
      var j3 = kt2(), I3 = Ie2(), M3 = fo2(), N3 = ar2(), F3 = Object;
      S3.exports = N3 ? function(O3) {
        return typeof O3 == "symbol";
      } : function(O3) {
        var H3 = j3("Symbol");
        return I3(H3) && M3(H3.prototype, F3(O3));
      };
    }), mo2 = q3((B3, S3) => {
      var j3 = String;
      S3.exports = function(I3) {
        try {
          return j3(I3);
        } catch {
          return "Object";
        }
      };
    }), vo2 = q3((B3, S3) => {
      var j3 = Ie2(), I3 = mo2(), M3 = TypeError;
      S3.exports = function(N3) {
        if (j3(N3))
          return N3;
        throw M3(I3(N3) + " is not a function");
      };
    }), yo2 = q3((B3, S3) => {
      var j3 = vo2(), I3 = nr2();
      S3.exports = function(M3, N3) {
        var F3 = M3[N3];
        return I3(F3) ? void 0 : j3(F3);
      };
    }), go2 = q3((B3, S3) => {
      var j3 = wt2(), I3 = Ie2(), M3 = Xe2(), N3 = TypeError;
      S3.exports = function(F3, O3) {
        var H3, Q3;
        if (O3 === "string" && I3(H3 = F3.toString) && !M3(Q3 = j3(H3, F3)) || I3(H3 = F3.valueOf) && !M3(Q3 = j3(H3, F3)) || O3 !== "string" && I3(H3 = F3.toString) && !M3(Q3 = j3(H3, F3)))
          return Q3;
        throw N3("Can't convert object to primitive value");
      };
    }), bo2 = q3((B3, S3) => {
      S3.exports = false;
    }), _t2 = q3((B3, S3) => {
      var j3 = Me2(), I3 = Object.defineProperty;
      S3.exports = function(M3, N3) {
        try {
          I3(j3, M3, { value: N3, configurable: true, writable: true });
        } catch {
          j3[M3] = N3;
        }
        return N3;
      };
    }), Ot2 = q3((B3, S3) => {
      var j3 = Me2(), I3 = _t2(), M3 = "__core-js_shared__", N3 = j3[M3] || I3(M3, {});
      S3.exports = N3;
    }), cr2 = q3((B3, S3) => {
      var j3 = bo2(), I3 = Ot2();
      (S3.exports = function(M3, N3) {
        return I3[M3] || (I3[M3] = N3 !== void 0 ? N3 : {});
      })("versions", []).push({ version: "3.26.1", mode: j3 ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE", source: "https://github.com/zloirock/core-js" });
    }), wo2 = q3((B3, S3) => {
      var j3 = or2(), I3 = Object;
      S3.exports = function(M3) {
        return I3(j3(M3));
      };
    }), Le2 = q3((B3, S3) => {
      var j3 = Fe2(), I3 = wo2(), M3 = j3({}.hasOwnProperty);
      S3.exports = Object.hasOwn || function(N3, F3) {
        return M3(I3(N3), F3);
      };
    }), lr2 = q3((B3, S3) => {
      var j3 = Fe2(), I3 = 0, M3 = Math.random(), N3 = j3(1 .toString);
      S3.exports = function(F3) {
        return "Symbol(" + (F3 === void 0 ? "" : F3) + ")_" + N3(++I3 + M3, 36);
      };
    }), xo2 = q3((B3, S3) => {
      var j3 = Me2(), I3 = cr2(), M3 = Le2(), N3 = lr2(), F3 = ir2(), O3 = ar2(), H3 = I3("wks"), Q3 = j3.Symbol, re2 = Q3 && Q3.for, T3 = O3 ? Q3 : Q3 && Q3.withoutSetter || N3;
      S3.exports = function(ne2) {
        if (!M3(H3, ne2) || !(F3 || typeof H3[ne2] == "string")) {
          var se2 = "Symbol." + ne2;
          F3 && M3(Q3, ne2) ? H3[ne2] = Q3[ne2] : O3 && re2 ? H3[ne2] = re2(se2) : H3[ne2] = T3(se2);
        }
        return H3[ne2];
      };
    }), ko2 = q3((B3, S3) => {
      var j3 = wt2(), I3 = Xe2(), M3 = ur2(), N3 = yo2(), F3 = go2(), O3 = xo2(), H3 = TypeError, Q3 = O3("toPrimitive");
      S3.exports = function(re2, T3) {
        if (!I3(re2) || M3(re2))
          return re2;
        var ne2 = N3(re2, Q3), se2;
        if (ne2) {
          if (T3 === void 0 && (T3 = "default"), se2 = j3(ne2, re2, T3), !I3(se2) || M3(se2))
            return se2;
          throw H3("Can't convert object to primitive value");
        }
        return T3 === void 0 && (T3 = "number"), F3(re2, T3);
      };
    }), fr2 = q3((B3, S3) => {
      var j3 = ko2(), I3 = ur2();
      S3.exports = function(M3) {
        var N3 = j3(M3, "string");
        return I3(N3) ? N3 : N3 + "";
      };
    }), _o2 = q3((B3, S3) => {
      var j3 = Me2(), I3 = Xe2(), M3 = j3.document, N3 = I3(M3) && I3(M3.createElement);
      S3.exports = function(F3) {
        return N3 ? M3.createElement(F3) : {};
      };
    }), pr2 = q3((B3, S3) => {
      var j3 = Ue2(), I3 = We2(), M3 = _o2();
      S3.exports = !j3 && !I3(function() {
        return Object.defineProperty(M3("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }), hr2 = q3((B3) => {
      var S3 = Ue2(), j3 = wt2(), I3 = uo2(), M3 = rr2(), N3 = xt2(), F3 = fr2(), O3 = Le2(), H3 = pr2(), Q3 = Object.getOwnPropertyDescriptor;
      B3.f = S3 ? Q3 : function(re2, T3) {
        if (re2 = N3(re2), T3 = F3(T3), H3)
          try {
            return Q3(re2, T3);
          } catch {
          }
        if (O3(re2, T3))
          return M3(!j3(I3.f, re2, T3), re2[T3]);
      };
    }), Oo2 = q3((B3, S3) => {
      var j3 = Ue2(), I3 = We2();
      S3.exports = j3 && I3(function() {
        return Object.defineProperty(function() {
        }, "prototype", { value: 42, writable: false }).prototype != 42;
      });
    }), dr2 = q3((B3, S3) => {
      var j3 = Xe2(), I3 = String, M3 = TypeError;
      S3.exports = function(N3) {
        if (j3(N3))
          return N3;
        throw M3(I3(N3) + " is not an object");
      };
    }), Tt2 = q3((B3) => {
      var S3 = Ue2(), j3 = pr2(), I3 = Oo2(), M3 = dr2(), N3 = fr2(), F3 = TypeError, O3 = Object.defineProperty, H3 = Object.getOwnPropertyDescriptor, Q3 = "enumerable", re2 = "configurable", T3 = "writable";
      B3.f = S3 ? I3 ? function(ne2, se2, ce2) {
        if (M3(ne2), se2 = N3(se2), M3(ce2), typeof ne2 == "function" && se2 === "prototype" && "value" in ce2 && T3 in ce2 && !ce2[T3]) {
          var le2 = H3(ne2, se2);
          le2 && le2[T3] && (ne2[se2] = ce2.value, ce2 = { configurable: re2 in ce2 ? ce2[re2] : le2[re2], enumerable: Q3 in ce2 ? ce2[Q3] : le2[Q3], writable: false });
        }
        return O3(ne2, se2, ce2);
      } : O3 : function(ne2, se2, ce2) {
        if (M3(ne2), se2 = N3(se2), M3(ce2), j3)
          try {
            return O3(ne2, se2, ce2);
          } catch {
          }
        if ("get" in ce2 || "set" in ce2)
          throw F3("Accessors not supported");
        return "value" in ce2 && (ne2[se2] = ce2.value), ne2;
      };
    }), mr2 = q3((B3, S3) => {
      var j3 = Ue2(), I3 = Tt2(), M3 = rr2();
      S3.exports = j3 ? function(N3, F3, O3) {
        return I3.f(N3, F3, M3(1, O3));
      } : function(N3, F3, O3) {
        return N3[F3] = O3, N3;
      };
    }), To2 = q3((B3, S3) => {
      var j3 = Ue2(), I3 = Le2(), M3 = Function.prototype, N3 = j3 && Object.getOwnPropertyDescriptor, F3 = I3(M3, "name"), O3 = F3 && function() {
      }.name === "something", H3 = F3 && (!j3 || j3 && N3(M3, "name").configurable);
      S3.exports = { EXISTS: F3, PROPER: O3, CONFIGURABLE: H3 };
    }), jo2 = q3((B3, S3) => {
      var j3 = Fe2(), I3 = Ie2(), M3 = Ot2(), N3 = j3(Function.toString);
      I3(M3.inspectSource) || (M3.inspectSource = function(F3) {
        return N3(F3);
      }), S3.exports = M3.inspectSource;
    }), Ao2 = q3((B3, S3) => {
      var j3 = Me2(), I3 = Ie2(), M3 = j3.WeakMap;
      S3.exports = I3(M3) && /native code/.test(String(M3));
    }), So2 = q3((B3, S3) => {
      var j3 = cr2(), I3 = lr2(), M3 = j3("keys");
      S3.exports = function(N3) {
        return M3[N3] || (M3[N3] = I3(N3));
      };
    }), vr2 = q3((B3, S3) => {
      S3.exports = {};
    }), Co2 = q3((B3, S3) => {
      var j3 = Ao2(), I3 = Me2(), M3 = Xe2(), N3 = mr2(), F3 = Le2(), O3 = Ot2(), H3 = So2(), Q3 = vr2(), re2 = "Object already initialized", T3 = I3.TypeError, ne2 = I3.WeakMap, se2, ce2, le2, he2 = function(pe2) {
        return le2(pe2) ? ce2(pe2) : se2(pe2, {});
      }, de2 = function(pe2) {
        return function(Se2) {
          var Ze2;
          if (!M3(Se2) || (Ze2 = ce2(Se2)).type !== pe2)
            throw T3("Incompatible receiver, " + pe2 + " required");
          return Ze2;
        };
      };
      j3 || O3.state ? (me2 = O3.state || (O3.state = new ne2()), me2.get = me2.get, me2.has = me2.has, me2.set = me2.set, se2 = function(pe2, Se2) {
        if (me2.has(pe2))
          throw T3(re2);
        return Se2.facade = pe2, me2.set(pe2, Se2), Se2;
      }, ce2 = function(pe2) {
        return me2.get(pe2) || {};
      }, le2 = function(pe2) {
        return me2.has(pe2);
      }) : (je2 = H3("state"), Q3[je2] = true, se2 = function(pe2, Se2) {
        if (F3(pe2, je2))
          throw T3(re2);
        return Se2.facade = pe2, N3(pe2, je2, Se2), Se2;
      }, ce2 = function(pe2) {
        return F3(pe2, je2) ? pe2[je2] : {};
      }, le2 = function(pe2) {
        return F3(pe2, je2);
      });
      var me2, je2;
      S3.exports = { set: se2, get: ce2, has: le2, enforce: he2, getterFor: de2 };
    }), Eo2 = q3((B3, S3) => {
      var j3 = We2(), I3 = Ie2(), M3 = Le2(), N3 = Ue2(), F3 = To2().CONFIGURABLE, O3 = jo2(), H3 = Co2(), Q3 = H3.enforce, re2 = H3.get, T3 = Object.defineProperty, ne2 = N3 && !j3(function() {
        return T3(function() {
        }, "length", { value: 8 }).length !== 8;
      }), se2 = String(String).split("String"), ce2 = S3.exports = function(le2, he2, de2) {
        String(he2).slice(0, 7) === "Symbol(" && (he2 = "[" + String(he2).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), de2 && de2.getter && (he2 = "get " + he2), de2 && de2.setter && (he2 = "set " + he2), (!M3(le2, "name") || F3 && le2.name !== he2) && (N3 ? T3(le2, "name", { value: he2, configurable: true }) : le2.name = he2), ne2 && de2 && M3(de2, "arity") && le2.length !== de2.arity && T3(le2, "length", { value: de2.arity });
        try {
          de2 && M3(de2, "constructor") && de2.constructor ? N3 && T3(le2, "prototype", { writable: false }) : le2.prototype && (le2.prototype = void 0);
        } catch {
        }
        var me2 = Q3(le2);
        return M3(me2, "source") || (me2.source = se2.join(typeof he2 == "string" ? he2 : "")), le2;
      };
      Function.prototype.toString = ce2(function() {
        return I3(this) && re2(this).source || O3(this);
      }, "toString");
    }), Mo2 = q3((B3, S3) => {
      var j3 = Ie2(), I3 = Tt2(), M3 = Eo2(), N3 = _t2();
      S3.exports = function(F3, O3, H3, Q3) {
        Q3 || (Q3 = {});
        var re2 = Q3.enumerable, T3 = Q3.name !== void 0 ? Q3.name : O3;
        if (j3(H3) && M3(H3, T3, Q3), Q3.global)
          re2 ? F3[O3] = H3 : N3(O3, H3);
        else {
          try {
            Q3.unsafe ? F3[O3] && (re2 = true) : delete F3[O3];
          } catch {
          }
          re2 ? F3[O3] = H3 : I3.f(F3, O3, { value: H3, enumerable: false, configurable: !Q3.nonConfigurable, writable: !Q3.nonWritable });
        }
        return F3;
      };
    }), Io2 = q3((B3, S3) => {
      var j3 = Math.ceil, I3 = Math.floor;
      S3.exports = Math.trunc || function(M3) {
        var N3 = +M3;
        return (N3 > 0 ? I3 : j3)(N3);
      };
    }), yr2 = q3((B3, S3) => {
      var j3 = Io2();
      S3.exports = function(I3) {
        var M3 = +I3;
        return M3 !== M3 || M3 === 0 ? 0 : j3(M3);
      };
    }), Po2 = q3((B3, S3) => {
      var j3 = yr2(), I3 = Math.max, M3 = Math.min;
      S3.exports = function(N3, F3) {
        var O3 = j3(N3);
        return O3 < 0 ? I3(O3 + F3, 0) : M3(O3, F3);
      };
    }), No2 = q3((B3, S3) => {
      var j3 = yr2(), I3 = Math.min;
      S3.exports = function(M3) {
        return M3 > 0 ? I3(j3(M3), 9007199254740991) : 0;
      };
    }), Ro2 = q3((B3, S3) => {
      var j3 = No2();
      S3.exports = function(I3) {
        return j3(I3.length);
      };
    }), zo2 = q3((B3, S3) => {
      var j3 = xt2(), I3 = Po2(), M3 = Ro2(), N3 = function(F3) {
        return function(O3, H3, Q3) {
          var re2 = j3(O3), T3 = M3(re2), ne2 = I3(Q3, T3), se2;
          if (F3 && H3 != H3) {
            for (; T3 > ne2; )
              if (se2 = re2[ne2++], se2 != se2)
                return true;
          } else
            for (; T3 > ne2; ne2++)
              if ((F3 || ne2 in re2) && re2[ne2] === H3)
                return F3 || ne2 || 0;
          return !F3 && -1;
        };
      };
      S3.exports = { includes: N3(true), indexOf: N3(false) };
    }), $o2 = q3((B3, S3) => {
      var j3 = Fe2(), I3 = Le2(), M3 = xt2(), N3 = zo2().indexOf, F3 = vr2(), O3 = j3([].push);
      S3.exports = function(H3, Q3) {
        var re2 = M3(H3), T3 = 0, ne2 = [], se2;
        for (se2 in re2)
          !I3(F3, se2) && I3(re2, se2) && O3(ne2, se2);
        for (; Q3.length > T3; )
          I3(re2, se2 = Q3[T3++]) && (~N3(ne2, se2) || O3(ne2, se2));
        return ne2;
      };
    }), Do2 = q3((B3, S3) => {
      S3.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    }), Wo2 = q3((B3) => {
      var S3 = $o2(), j3 = Do2(), I3 = j3.concat("length", "prototype");
      B3.f = Object.getOwnPropertyNames || function(M3) {
        return S3(M3, I3);
      };
    }), Fo2 = q3((B3) => {
      B3.f = Object.getOwnPropertySymbols;
    }), Uo2 = q3((B3, S3) => {
      var j3 = kt2(), I3 = Fe2(), M3 = Wo2(), N3 = Fo2(), F3 = dr2(), O3 = I3([].concat);
      S3.exports = j3("Reflect", "ownKeys") || function(H3) {
        var Q3 = M3.f(F3(H3)), re2 = N3.f;
        return re2 ? O3(Q3, re2(H3)) : Q3;
      };
    }), Lo2 = q3((B3, S3) => {
      var j3 = Le2(), I3 = Uo2(), M3 = hr2(), N3 = Tt2();
      S3.exports = function(F3, O3, H3) {
        for (var Q3 = I3(O3), re2 = N3.f, T3 = M3.f, ne2 = 0; ne2 < Q3.length; ne2++) {
          var se2 = Q3[ne2];
          !j3(F3, se2) && !(H3 && j3(H3, se2)) && re2(F3, se2, T3(O3, se2));
        }
      };
    }), Bo2 = q3((B3, S3) => {
      var j3 = We2(), I3 = Ie2(), M3 = /#|\.prototype\./, N3 = function(re2, T3) {
        var ne2 = O3[F3(re2)];
        return ne2 == Q3 ? true : ne2 == H3 ? false : I3(T3) ? j3(T3) : !!T3;
      }, F3 = N3.normalize = function(re2) {
        return String(re2).replace(M3, ".").toLowerCase();
      }, O3 = N3.data = {}, H3 = N3.NATIVE = "N", Q3 = N3.POLYFILL = "P";
      S3.exports = N3;
    }), Go2 = q3((B3, S3) => {
      var j3 = Me2(), I3 = hr2().f, M3 = mr2(), N3 = Mo2(), F3 = _t2(), O3 = Lo2(), H3 = Bo2();
      S3.exports = function(Q3, re2) {
        var T3 = Q3.target, ne2 = Q3.global, se2 = Q3.stat, ce2, le2, he2, de2, me2, je2;
        if (ne2 ? le2 = j3 : se2 ? le2 = j3[T3] || F3(T3, {}) : le2 = (j3[T3] || {}).prototype, le2)
          for (he2 in re2) {
            if (me2 = re2[he2], Q3.dontCallGetSet ? (je2 = I3(le2, he2), de2 = je2 && je2.value) : de2 = le2[he2], ce2 = H3(ne2 ? he2 : T3 + (se2 ? "." : "#") + he2, Q3.forced), !ce2 && de2 !== void 0) {
              if (typeof me2 == typeof de2)
                continue;
              O3(me2, de2);
            }
            (Q3.sham || de2 && de2.sham) && M3(me2, "sham", true), N3(le2, he2, me2, Q3);
          }
      };
    }), qo2 = q3(() => {
      var B3 = Go2(), S3 = Me2();
      B3({ global: true, forced: S3.globalThis !== S3 }, { globalThis: S3 });
    }), Jo2 = q3(() => {
      qo2();
    }), Ho2 = q3((B3, S3) => {
      Jo2();
      var j3 = Object.defineProperty, I3 = Object.getOwnPropertyDescriptor, M3 = Object.getOwnPropertyNames, N3 = Object.prototype.hasOwnProperty, F3 = (t3, a3) => function() {
        return t3 && (a3 = (0, t3[M3(t3)[0]])(t3 = 0)), a3;
      }, O3 = (t3, a3) => function() {
        return a3 || (0, t3[M3(t3)[0]])((a3 = { exports: {} }).exports, a3), a3.exports;
      }, H3 = (t3, a3) => {
        for (var o3 in a3)
          j3(t3, o3, { get: a3[o3], enumerable: true });
      }, Q3 = (t3, a3, o3, s3) => {
        if (a3 && typeof a3 == "object" || typeof a3 == "function")
          for (let c3 of M3(a3))
            !N3.call(t3, c3) && c3 !== o3 && j3(t3, c3, { get: () => a3[c3], enumerable: !(s3 = I3(a3, c3)) || s3.enumerable });
        return t3;
      }, re2 = (t3) => Q3(j3({}, "__esModule", { value: true }), t3), T3 = F3({ "<define:process>"() {
      } }), ne2 = O3({ "src/common/parser-create-error.js"(t3, a3) {
        T3();
        function o3(s3, c3) {
          let f3 = new SyntaxError(s3 + " (" + c3.start.line + ":" + c3.start.column + ")");
          return f3.loc = c3, f3;
        }
        a3.exports = o3;
      } }), se2 = O3({ "src/utils/get-last.js"(t3, a3) {
        T3();
        var o3 = (s3) => s3[s3.length - 1];
        a3.exports = o3;
      } }), ce2 = O3({ "src/utils/front-matter/parse.js"(t3, a3) {
        T3();
        var o3 = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
        function s3(c3) {
          let f3 = c3.match(o3);
          if (!f3)
            return { content: c3 };
          let { startDelimiter: l3, language: h3, value: u3 = "", endDelimiter: p3 } = f3.groups, r3 = h3.trim() || "yaml";
          if (l3 === "+++" && (r3 = "toml"), r3 !== "yaml" && l3 !== p3)
            return { content: c3 };
          let [e28] = f3;
          return { frontMatter: { type: "front-matter", lang: r3, value: u3, startDelimiter: l3, endDelimiter: p3, raw: e28.replace(/\n$/, "") }, content: e28.replace(/[^\n]/g, " ") + c3.slice(e28.length) };
        }
        a3.exports = s3;
      } }), le2 = {};
      H3(le2, { EOL: () => St2, arch: () => Qo2, cpus: () => Ze2, default: () => kr2, endianness: () => he2, freemem: () => pe2, getNetworkInterfaces: () => xr2, hostname: () => de2, loadavg: () => me2, networkInterfaces: () => wr2, platform: () => Vo2, release: () => br2, tmpDir: () => jt2, tmpdir: () => At2, totalmem: () => Se2, type: () => gr2, uptime: () => je2 });
      function he2() {
        if (typeof ct2 > "u") {
          var t3 = new ArrayBuffer(2), a3 = new Uint8Array(t3), o3 = new Uint16Array(t3);
          if (a3[0] = 1, a3[1] = 2, o3[0] === 258)
            ct2 = "BE";
          else if (o3[0] === 513)
            ct2 = "LE";
          else
            throw new Error("unable to figure out endianess");
        }
        return ct2;
      }
      function de2() {
        return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
      }
      function me2() {
        return [];
      }
      function je2() {
        return 0;
      }
      function pe2() {
        return Number.MAX_VALUE;
      }
      function Se2() {
        return Number.MAX_VALUE;
      }
      function Ze2() {
        return [];
      }
      function gr2() {
        return "Browser";
      }
      function br2() {
        return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
      }
      function wr2() {
      }
      function xr2() {
      }
      function Qo2() {
        return "javascript";
      }
      function Vo2() {
        return "browser";
      }
      function jt2() {
        return "/tmp";
      }
      var ct2, At2, St2, kr2, Yo2 = F3({ "node-modules-polyfills:os"() {
        T3(), At2 = jt2, St2 = `
`, kr2 = { EOL: St2, tmpdir: At2, tmpDir: jt2, networkInterfaces: wr2, getNetworkInterfaces: xr2, release: br2, type: gr2, cpus: Ze2, totalmem: Se2, freemem: pe2, uptime: je2, loadavg: me2, hostname: de2, endianness: he2 };
      } }), Xo2 = O3({ "node-modules-polyfills-commonjs:os"(t3, a3) {
        T3();
        var o3 = (Yo2(), re2(le2));
        if (o3 && o3.default) {
          a3.exports = o3.default;
          for (let s3 in o3)
            a3.exports[s3] = o3[s3];
        } else
          o3 && (a3.exports = o3);
      } }), Zo2 = O3({ "node_modules/detect-newline/index.js"(t3, a3) {
        T3();
        var o3 = (s3) => {
          if (typeof s3 != "string")
            throw new TypeError("Expected a string");
          let c3 = s3.match(/(?:\r?\n)/g) || [];
          if (c3.length === 0)
            return;
          let f3 = c3.filter((h3) => h3 === `\r
`).length, l3 = c3.length - f3;
          return f3 > l3 ? `\r
` : `
`;
        };
        a3.exports = o3, a3.exports.graceful = (s3) => typeof s3 == "string" && o3(s3) || `
`;
      } }), Ko2 = O3({ "node_modules/jest-docblock/build/index.js"(t3) {
        T3(), Object.defineProperty(t3, "__esModule", { value: true }), t3.extract = n3, t3.parse = d3, t3.parseWithComments = g3, t3.print = y3, t3.strip = m3;
        function a3() {
          let b3 = Xo2();
          return a3 = function() {
            return b3;
          }, b3;
        }
        function o3() {
          let b3 = s3(Zo2());
          return o3 = function() {
            return b3;
          }, b3;
        }
        function s3(b3) {
          return b3 && b3.__esModule ? b3 : { default: b3 };
        }
        var c3 = /\*\/$/, f3 = /^\/\*\*?/, l3 = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, h3 = /(^|\s+)\/\/([^\r\n]*)/g, u3 = /^(\r?\n)+/, p3 = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, r3 = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, e28 = /(\r?\n|^) *\* ?/g, i = [];
        function n3(b3) {
          let w3 = b3.match(l3);
          return w3 ? w3[0].trimLeft() : "";
        }
        function m3(b3) {
          let w3 = b3.match(l3);
          return w3 && w3[0] ? b3.substring(w3[0].length) : b3;
        }
        function d3(b3) {
          return g3(b3).pragmas;
        }
        function g3(b3) {
          let w3 = (0, o3().default)(b3) || a3().EOL;
          b3 = b3.replace(f3, "").replace(c3, "").replace(e28, "$1");
          let _3 = "";
          for (; _3 !== b3; )
            _3 = b3, b3 = b3.replace(p3, `${w3}$1 $2${w3}`);
          b3 = b3.replace(u3, "").trimRight();
          let R3 = /* @__PURE__ */ Object.create(null), D3 = b3.replace(r3, "").replace(u3, "").trimRight(), U3;
          for (; U3 = r3.exec(b3); ) {
            let X3 = U3[2].replace(h3, "");
            typeof R3[U3[1]] == "string" || Array.isArray(R3[U3[1]]) ? R3[U3[1]] = i.concat(R3[U3[1]], X3) : R3[U3[1]] = X3;
          }
          return { comments: D3, pragmas: R3 };
        }
        function y3(b3) {
          let { comments: w3 = "", pragmas: _3 = {} } = b3, R3 = (0, o3().default)(w3) || a3().EOL, D3 = "/**", U3 = " *", X3 = " */", Y3 = Object.keys(_3), ee2 = Y3.map((Z3) => v3(Z3, _3[Z3])).reduce((Z3, z3) => Z3.concat(z3), []).map((Z3) => `${U3} ${Z3}${R3}`).join("");
          if (!w3) {
            if (Y3.length === 0)
              return "";
            if (Y3.length === 1 && !Array.isArray(_3[Y3[0]])) {
              let Z3 = _3[Y3[0]];
              return `${D3} ${v3(Y3[0], Z3)[0]}${X3}`;
            }
          }
          let V10 = w3.split(R3).map((Z3) => `${U3} ${Z3}`).join(R3) + R3;
          return D3 + R3 + (w3 ? V10 : "") + (w3 && Y3.length ? U3 + R3 : "") + ee2 + X3;
        }
        function v3(b3, w3) {
          return i.concat(w3).map((_3) => `@${b3} ${_3}`.trim());
        }
      } }), es2 = O3({ "src/common/end-of-line.js"(t3, a3) {
        T3();
        function o3(l3) {
          let h3 = l3.indexOf("\r");
          return h3 >= 0 ? l3.charAt(h3 + 1) === `
` ? "crlf" : "cr" : "lf";
        }
        function s3(l3) {
          switch (l3) {
            case "cr":
              return "\r";
            case "crlf":
              return `\r
`;
            default:
              return `
`;
          }
        }
        function c3(l3, h3) {
          let u3;
          switch (h3) {
            case `
`:
              u3 = /\n/g;
              break;
            case "\r":
              u3 = /\r/g;
              break;
            case `\r
`:
              u3 = /\r\n/g;
              break;
            default:
              throw new Error(`Unexpected "eol" ${JSON.stringify(h3)}.`);
          }
          let p3 = l3.match(u3);
          return p3 ? p3.length : 0;
        }
        function f3(l3) {
          return l3.replace(/\r\n?/g, `
`);
        }
        a3.exports = { guessEndOfLine: o3, convertEndOfLineToChars: s3, countEndOfLineChars: c3, normalizeEndOfLine: f3 };
      } }), ts2 = O3({ "src/language-js/utils/get-shebang.js"(t3, a3) {
        T3();
        function o3(s3) {
          if (!s3.startsWith("#!"))
            return "";
          let c3 = s3.indexOf(`
`);
          return c3 === -1 ? s3 : s3.slice(0, c3);
        }
        a3.exports = o3;
      } }), rs2 = O3({ "src/language-js/pragma.js"(t3, a3) {
        T3();
        var { parseWithComments: o3, strip: s3, extract: c3, print: f3 } = Ko2(), { normalizeEndOfLine: l3 } = es2(), h3 = ts2();
        function u3(e28) {
          let i = h3(e28);
          i && (e28 = e28.slice(i.length + 1));
          let n3 = c3(e28), { pragmas: m3, comments: d3 } = o3(n3);
          return { shebang: i, text: e28, pragmas: m3, comments: d3 };
        }
        function p3(e28) {
          let i = Object.keys(u3(e28).pragmas);
          return i.includes("prettier") || i.includes("format");
        }
        function r3(e28) {
          let { shebang: i, text: n3, pragmas: m3, comments: d3 } = u3(e28), g3 = s3(n3), y3 = f3({ pragmas: Object.assign({ format: "" }, m3), comments: d3.trimStart() });
          return (i ? `${i}
` : "") + l3(y3) + (g3.startsWith(`
`) ? `
` : `

`) + g3;
        }
        a3.exports = { hasPragma: p3, insertPragma: r3 };
      } }), ns2 = O3({ "src/language-css/pragma.js"(t3, a3) {
        T3();
        var o3 = rs2(), s3 = ce2();
        function c3(l3) {
          return o3.hasPragma(s3(l3).content);
        }
        function f3(l3) {
          let { frontMatter: h3, content: u3 } = s3(l3);
          return (h3 ? h3.raw + `

` : "") + o3.insertPragma(u3);
        }
        a3.exports = { hasPragma: c3, insertPragma: f3 };
      } }), os2 = O3({ "src/utils/text/skip.js"(t3, a3) {
        T3();
        function o3(h3) {
          return (u3, p3, r3) => {
            let e28 = r3 && r3.backwards;
            if (p3 === false)
              return false;
            let { length: i } = u3, n3 = p3;
            for (; n3 >= 0 && n3 < i; ) {
              let m3 = u3.charAt(n3);
              if (h3 instanceof RegExp) {
                if (!h3.test(m3))
                  return n3;
              } else if (!h3.includes(m3))
                return n3;
              e28 ? n3-- : n3++;
            }
            return n3 === -1 || n3 === i ? n3 : false;
          };
        }
        var s3 = o3(/\s/), c3 = o3(" 	"), f3 = o3(",; 	"), l3 = o3(/[^\n\r]/);
        a3.exports = { skipWhitespace: s3, skipSpaces: c3, skipToLineEnd: f3, skipEverythingButNewLine: l3 };
      } }), ss2 = O3({ "src/utils/line-column-to-index.js"(t3, a3) {
        T3(), a3.exports = function(o3, s3) {
          let c3 = 0;
          for (let f3 = 0; f3 < o3.line - 1; ++f3)
            c3 = s3.indexOf(`
`, c3) + 1;
          return c3 + o3.column;
        };
      } }), _r2 = O3({ "src/language-css/loc.js"(t3, a3) {
        T3();
        var { skipEverythingButNewLine: o3 } = os2(), s3 = se2(), c3 = ss2();
        function f3(n3, m3) {
          return typeof n3.sourceIndex == "number" ? n3.sourceIndex : n3.source ? c3(n3.source.start, m3) - 1 : null;
        }
        function l3(n3, m3) {
          if (n3.type === "css-comment" && n3.inline)
            return o3(m3, n3.source.startOffset);
          let d3 = n3.nodes && s3(n3.nodes);
          return d3 && n3.source && !n3.source.end && (n3 = d3), n3.source && n3.source.end ? c3(n3.source.end, m3) : null;
        }
        function h3(n3, m3) {
          n3.source && (n3.source.startOffset = f3(n3, m3), n3.source.endOffset = l3(n3, m3));
          for (let d3 in n3) {
            let g3 = n3[d3];
            d3 === "source" || !g3 || typeof g3 != "object" || (g3.type === "value-root" || g3.type === "value-unknown" ? u3(g3, p3(n3), g3.text || g3.value) : h3(g3, m3));
          }
        }
        function u3(n3, m3, d3) {
          n3.source && (n3.source.startOffset = f3(n3, d3) + m3, n3.source.endOffset = l3(n3, d3) + m3);
          for (let g3 in n3) {
            let y3 = n3[g3];
            g3 === "source" || !y3 || typeof y3 != "object" || u3(y3, m3, d3);
          }
        }
        function p3(n3) {
          let m3 = n3.source.startOffset;
          return typeof n3.prop == "string" && (m3 += n3.prop.length), n3.type === "css-atrule" && typeof n3.name == "string" && (m3 += 1 + n3.name.length + n3.raws.afterName.match(/^\s*:?\s*/)[0].length), n3.type !== "css-atrule" && n3.raws && typeof n3.raws.between == "string" && (m3 += n3.raws.between.length), m3;
        }
        function r3(n3) {
          let m3 = "initial", d3 = "initial", g3, y3 = false, v3 = [];
          for (let b3 = 0; b3 < n3.length; b3++) {
            let w3 = n3[b3];
            switch (m3) {
              case "initial":
                if (w3 === "'") {
                  m3 = "single-quotes";
                  continue;
                }
                if (w3 === '"') {
                  m3 = "double-quotes";
                  continue;
                }
                if ((w3 === "u" || w3 === "U") && n3.slice(b3, b3 + 4).toLowerCase() === "url(") {
                  m3 = "url", b3 += 3;
                  continue;
                }
                if (w3 === "*" && n3[b3 - 1] === "/") {
                  m3 = "comment-block";
                  continue;
                }
                if (w3 === "/" && n3[b3 - 1] === "/") {
                  m3 = "comment-inline", g3 = b3 - 1;
                  continue;
                }
                continue;
              case "single-quotes":
                if (w3 === "'" && n3[b3 - 1] !== "\\" && (m3 = d3, d3 = "initial"), w3 === `
` || w3 === "\r")
                  return n3;
                continue;
              case "double-quotes":
                if (w3 === '"' && n3[b3 - 1] !== "\\" && (m3 = d3, d3 = "initial"), w3 === `
` || w3 === "\r")
                  return n3;
                continue;
              case "url":
                if (w3 === ")" && (m3 = "initial"), w3 === `
` || w3 === "\r")
                  return n3;
                if (w3 === "'") {
                  m3 = "single-quotes", d3 = "url";
                  continue;
                }
                if (w3 === '"') {
                  m3 = "double-quotes", d3 = "url";
                  continue;
                }
                continue;
              case "comment-block":
                w3 === "/" && n3[b3 - 1] === "*" && (m3 = "initial");
                continue;
              case "comment-inline":
                (w3 === '"' || w3 === "'" || w3 === "*") && (y3 = true), (w3 === `
` || w3 === "\r") && (y3 && v3.push([g3, b3]), m3 = "initial", y3 = false);
                continue;
            }
          }
          for (let [b3, w3] of v3)
            n3 = n3.slice(0, b3) + n3.slice(b3, w3).replace(/["'*]/g, " ") + n3.slice(w3);
          return n3;
        }
        function e28(n3) {
          return n3.source.startOffset;
        }
        function i(n3) {
          return n3.source.endOffset;
        }
        a3.exports = { locStart: e28, locEnd: i, calculateLoc: h3, replaceQuotesInInlineComments: r3 };
      } }), is2 = O3({ "src/utils/is-non-empty-array.js"(t3, a3) {
        T3();
        function o3(s3) {
          return Array.isArray(s3) && s3.length > 0;
        }
        a3.exports = o3;
      } }), as2 = O3({ "src/language-css/utils/has-scss-interpolation.js"(t3, a3) {
        T3();
        var o3 = is2();
        function s3(c3) {
          if (o3(c3)) {
            for (let f3 = c3.length - 1; f3 > 0; f3--)
              if (c3[f3].type === "word" && c3[f3].value === "{" && c3[f3 - 1].type === "word" && c3[f3 - 1].value.endsWith("#"))
                return true;
          }
          return false;
        }
        a3.exports = s3;
      } }), us2 = O3({ "src/language-css/utils/has-string-or-function.js"(t3, a3) {
        T3();
        function o3(s3) {
          return s3.some((c3) => c3.type === "string" || c3.type === "func");
        }
        a3.exports = o3;
      } }), cs2 = O3({ "src/language-css/utils/is-less-parser.js"(t3, a3) {
        T3();
        function o3(s3) {
          return s3.parser === "css" || s3.parser === "less";
        }
        a3.exports = o3;
      } }), ls2 = O3({ "src/language-css/utils/is-scss.js"(t3, a3) {
        T3();
        function o3(s3, c3) {
          return s3 === "less" || s3 === "scss" ? s3 === "scss" : /(?:\w\s*:\s*[^:}]+|#){|@import[^\n]+(?:url|,)/.test(c3);
        }
        a3.exports = o3;
      } }), fs2 = O3({ "src/language-css/utils/is-scss-nested-property-node.js"(t3, a3) {
        T3();
        function o3(s3) {
          return s3.selector ? s3.selector.replace(/\/\*.*?\*\//, "").replace(/\/\/.*\n/, "").trim().endsWith(":") : false;
        }
        a3.exports = o3;
      } }), ps2 = O3({ "src/language-css/utils/is-scss-variable.js"(t3, a3) {
        T3();
        function o3(s3) {
          return !!((s3 == null ? void 0 : s3.type) === "word" && s3.value.startsWith("$"));
        }
        a3.exports = o3;
      } }), hs2 = O3({ "src/language-css/utils/stringify-node.js"(t3, a3) {
        T3();
        function o3(s3) {
          var c3, f3, l3;
          if (s3.groups) {
            var h3, u3, p3;
            let y3 = ((h3 = s3.open) === null || h3 === void 0 ? void 0 : h3.value) || "", v3 = s3.groups.map((w3) => o3(w3)).join(((u3 = s3.groups[0]) === null || u3 === void 0 ? void 0 : u3.type) === "comma_group" ? "," : ""), b3 = ((p3 = s3.close) === null || p3 === void 0 ? void 0 : p3.value) || "";
            return y3 + v3 + b3;
          }
          let r3 = ((c3 = s3.raws) === null || c3 === void 0 ? void 0 : c3.before) || "", e28 = ((f3 = s3.raws) === null || f3 === void 0 ? void 0 : f3.quote) || "", i = s3.type === "atword" ? "@" : "", n3 = s3.value || "", m3 = s3.unit || "", d3 = s3.group ? o3(s3.group) : "", g3 = ((l3 = s3.raws) === null || l3 === void 0 ? void 0 : l3.after) || "";
          return r3 + e28 + i + n3 + e28 + m3 + d3 + g3;
        }
        a3.exports = o3;
      } }), ds2 = O3({ "src/language-css/utils/is-module-rule-name.js"(t3, a3) {
        T3();
        var o3 = /* @__PURE__ */ new Set(["import", "use", "forward"]);
        function s3(c3) {
          return o3.has(c3);
        }
        a3.exports = s3;
      } }), Pe2 = O3({ "node_modules/postcss-values-parser/lib/node.js"(t3, a3) {
        T3();
        var o3 = function(s3, c3) {
          let f3 = new s3.constructor();
          for (let l3 in s3) {
            if (!s3.hasOwnProperty(l3))
              continue;
            let h3 = s3[l3], u3 = typeof h3;
            l3 === "parent" && u3 === "object" ? c3 && (f3[l3] = c3) : l3 === "source" ? f3[l3] = h3 : h3 instanceof Array ? f3[l3] = h3.map((p3) => o3(p3, f3)) : l3 !== "before" && l3 !== "after" && l3 !== "between" && l3 !== "semicolon" && (u3 === "object" && h3 !== null && (h3 = o3(h3)), f3[l3] = h3);
          }
          return f3;
        };
        a3.exports = class {
          constructor(s3) {
            s3 = s3 || {}, this.raws = { before: "", after: "" };
            for (let c3 in s3)
              this[c3] = s3[c3];
          }
          remove() {
            return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
          }
          toString() {
            return [this.raws.before, String(this.value), this.raws.after].join("");
          }
          clone(s3) {
            s3 = s3 || {};
            let c3 = o3(this);
            for (let f3 in s3)
              c3[f3] = s3[f3];
            return c3;
          }
          cloneBefore(s3) {
            s3 = s3 || {};
            let c3 = this.clone(s3);
            return this.parent.insertBefore(this, c3), c3;
          }
          cloneAfter(s3) {
            s3 = s3 || {};
            let c3 = this.clone(s3);
            return this.parent.insertAfter(this, c3), c3;
          }
          replaceWith() {
            let s3 = Array.prototype.slice.call(arguments);
            if (this.parent) {
              for (let c3 of s3)
                this.parent.insertBefore(this, c3);
              this.remove();
            }
            return this;
          }
          moveTo(s3) {
            return this.cleanRaws(this.root() === s3.root()), this.remove(), s3.append(this), this;
          }
          moveBefore(s3) {
            return this.cleanRaws(this.root() === s3.root()), this.remove(), s3.parent.insertBefore(s3, this), this;
          }
          moveAfter(s3) {
            return this.cleanRaws(this.root() === s3.root()), this.remove(), s3.parent.insertAfter(s3, this), this;
          }
          next() {
            let s3 = this.parent.index(this);
            return this.parent.nodes[s3 + 1];
          }
          prev() {
            let s3 = this.parent.index(this);
            return this.parent.nodes[s3 - 1];
          }
          toJSON() {
            let s3 = {};
            for (let c3 in this) {
              if (!this.hasOwnProperty(c3) || c3 === "parent")
                continue;
              let f3 = this[c3];
              f3 instanceof Array ? s3[c3] = f3.map((l3) => typeof l3 == "object" && l3.toJSON ? l3.toJSON() : l3) : typeof f3 == "object" && f3.toJSON ? s3[c3] = f3.toJSON() : s3[c3] = f3;
            }
            return s3;
          }
          root() {
            let s3 = this;
            for (; s3.parent; )
              s3 = s3.parent;
            return s3;
          }
          cleanRaws(s3) {
            delete this.raws.before, delete this.raws.after, s3 || delete this.raws.between;
          }
          positionInside(s3) {
            let c3 = this.toString(), f3 = this.source.start.column, l3 = this.source.start.line;
            for (let h3 = 0; h3 < s3; h3++)
              c3[h3] === `
` ? (f3 = 1, l3 += 1) : f3 += 1;
            return { line: l3, column: f3 };
          }
          positionBy(s3) {
            let c3 = this.source.start;
            if (Object(s3).index)
              c3 = this.positionInside(s3.index);
            else if (Object(s3).word) {
              let f3 = this.toString().indexOf(s3.word);
              f3 !== -1 && (c3 = this.positionInside(f3));
            }
            return c3;
          }
        };
      } }), Ce2 = O3({ "node_modules/postcss-values-parser/lib/container.js"(t3, a3) {
        T3();
        var o3 = Pe2(), s3 = class extends o3 {
          constructor(c3) {
            super(c3), this.nodes || (this.nodes = []);
          }
          push(c3) {
            return c3.parent = this, this.nodes.push(c3), this;
          }
          each(c3) {
            this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
            let f3 = this.lastEach, l3, h3;
            if (this.indexes[f3] = 0, !!this.nodes) {
              for (; this.indexes[f3] < this.nodes.length && (l3 = this.indexes[f3], h3 = c3(this.nodes[l3], l3), h3 !== false); )
                this.indexes[f3] += 1;
              return delete this.indexes[f3], h3;
            }
          }
          walk(c3) {
            return this.each((f3, l3) => {
              let h3 = c3(f3, l3);
              return h3 !== false && f3.walk && (h3 = f3.walk(c3)), h3;
            });
          }
          walkType(c3, f3) {
            if (!c3 || !f3)
              throw new Error("Parameters {type} and {callback} are required.");
            let l3 = typeof c3 == "function";
            return this.walk((h3, u3) => {
              if (l3 && h3 instanceof c3 || !l3 && h3.type === c3)
                return f3.call(this, h3, u3);
            });
          }
          append(c3) {
            return c3.parent = this, this.nodes.push(c3), this;
          }
          prepend(c3) {
            return c3.parent = this, this.nodes.unshift(c3), this;
          }
          cleanRaws(c3) {
            if (super.cleanRaws(c3), this.nodes)
              for (let f3 of this.nodes)
                f3.cleanRaws(c3);
          }
          insertAfter(c3, f3) {
            let l3 = this.index(c3), h3;
            this.nodes.splice(l3 + 1, 0, f3);
            for (let u3 in this.indexes)
              h3 = this.indexes[u3], l3 <= h3 && (this.indexes[u3] = h3 + this.nodes.length);
            return this;
          }
          insertBefore(c3, f3) {
            let l3 = this.index(c3), h3;
            this.nodes.splice(l3, 0, f3);
            for (let u3 in this.indexes)
              h3 = this.indexes[u3], l3 <= h3 && (this.indexes[u3] = h3 + this.nodes.length);
            return this;
          }
          removeChild(c3) {
            c3 = this.index(c3), this.nodes[c3].parent = void 0, this.nodes.splice(c3, 1);
            let f3;
            for (let l3 in this.indexes)
              f3 = this.indexes[l3], f3 >= c3 && (this.indexes[l3] = f3 - 1);
            return this;
          }
          removeAll() {
            for (let c3 of this.nodes)
              c3.parent = void 0;
            return this.nodes = [], this;
          }
          every(c3) {
            return this.nodes.every(c3);
          }
          some(c3) {
            return this.nodes.some(c3);
          }
          index(c3) {
            return typeof c3 == "number" ? c3 : this.nodes.indexOf(c3);
          }
          get first() {
            if (this.nodes)
              return this.nodes[0];
          }
          get last() {
            if (this.nodes)
              return this.nodes[this.nodes.length - 1];
          }
          toString() {
            let c3 = this.nodes.map(String).join("");
            return this.value && (c3 = this.value + c3), this.raws.before && (c3 = this.raws.before + c3), this.raws.after && (c3 += this.raws.after), c3;
          }
        };
        s3.registerWalker = (c3) => {
          let f3 = "walk" + c3.name;
          f3.lastIndexOf("s") !== f3.length - 1 && (f3 += "s"), !s3.prototype[f3] && (s3.prototype[f3] = function(l3) {
            return this.walkType(c3, l3);
          });
        }, a3.exports = s3;
      } }), ms2 = O3({ "node_modules/postcss-values-parser/lib/root.js"(t3, a3) {
        T3();
        var o3 = Ce2();
        a3.exports = class extends o3 {
          constructor(s3) {
            super(s3), this.type = "root";
          }
        };
      } }), Or2 = O3({ "node_modules/postcss-values-parser/lib/value.js"(t3, a3) {
        T3();
        var o3 = Ce2();
        a3.exports = class extends o3 {
          constructor(s3) {
            super(s3), this.type = "value", this.unbalanced = 0;
          }
        };
      } }), Tr2 = O3({ "node_modules/postcss-values-parser/lib/atword.js"(t3, a3) {
        T3();
        var o3 = Ce2(), s3 = class extends o3 {
          constructor(c3) {
            super(c3), this.type = "atword";
          }
          toString() {
            return this.quoted && this.raws.quote, [this.raws.before, "@", String.prototype.toString.call(this.value), this.raws.after].join("");
          }
        };
        o3.registerWalker(s3), a3.exports = s3;
      } }), jr2 = O3({ "node_modules/postcss-values-parser/lib/colon.js"(t3, a3) {
        T3();
        var o3 = Ce2(), s3 = Pe2(), c3 = class extends s3 {
          constructor(f3) {
            super(f3), this.type = "colon";
          }
        };
        o3.registerWalker(c3), a3.exports = c3;
      } }), Ar2 = O3({ "node_modules/postcss-values-parser/lib/comma.js"(t3, a3) {
        T3();
        var o3 = Ce2(), s3 = Pe2(), c3 = class extends s3 {
          constructor(f3) {
            super(f3), this.type = "comma";
          }
        };
        o3.registerWalker(c3), a3.exports = c3;
      } }), Sr2 = O3({ "node_modules/postcss-values-parser/lib/comment.js"(t3, a3) {
        T3();
        var o3 = Ce2(), s3 = Pe2(), c3 = class extends s3 {
          constructor(f3) {
            super(f3), this.type = "comment", this.inline = Object(f3).inline || false;
          }
          toString() {
            return [this.raws.before, this.inline ? "//" : "/*", String(this.value), this.inline ? "" : "*/", this.raws.after].join("");
          }
        };
        o3.registerWalker(c3), a3.exports = c3;
      } }), Cr2 = O3({ "node_modules/postcss-values-parser/lib/function.js"(t3, a3) {
        T3();
        var o3 = Ce2(), s3 = class extends o3 {
          constructor(c3) {
            super(c3), this.type = "func", this.unbalanced = -1;
          }
        };
        o3.registerWalker(s3), a3.exports = s3;
      } }), Er2 = O3({ "node_modules/postcss-values-parser/lib/number.js"(t3, a3) {
        T3();
        var o3 = Ce2(), s3 = Pe2(), c3 = class extends s3 {
          constructor(f3) {
            super(f3), this.type = "number", this.unit = Object(f3).unit || "";
          }
          toString() {
            return [this.raws.before, String(this.value), this.unit, this.raws.after].join("");
          }
        };
        o3.registerWalker(c3), a3.exports = c3;
      } }), Mr2 = O3({ "node_modules/postcss-values-parser/lib/operator.js"(t3, a3) {
        T3();
        var o3 = Ce2(), s3 = Pe2(), c3 = class extends s3 {
          constructor(f3) {
            super(f3), this.type = "operator";
          }
        };
        o3.registerWalker(c3), a3.exports = c3;
      } }), Ir2 = O3({ "node_modules/postcss-values-parser/lib/paren.js"(t3, a3) {
        T3();
        var o3 = Ce2(), s3 = Pe2(), c3 = class extends s3 {
          constructor(f3) {
            super(f3), this.type = "paren", this.parenType = "";
          }
        };
        o3.registerWalker(c3), a3.exports = c3;
      } }), Pr2 = O3({ "node_modules/postcss-values-parser/lib/string.js"(t3, a3) {
        T3();
        var o3 = Ce2(), s3 = Pe2(), c3 = class extends s3 {
          constructor(f3) {
            super(f3), this.type = "string";
          }
          toString() {
            let f3 = this.quoted ? this.raws.quote : "";
            return [this.raws.before, f3, this.value + "", f3, this.raws.after].join("");
          }
        };
        o3.registerWalker(c3), a3.exports = c3;
      } }), Nr2 = O3({ "node_modules/postcss-values-parser/lib/word.js"(t3, a3) {
        T3();
        var o3 = Ce2(), s3 = Pe2(), c3 = class extends s3 {
          constructor(f3) {
            super(f3), this.type = "word";
          }
        };
        o3.registerWalker(c3), a3.exports = c3;
      } }), Rr2 = O3({ "node_modules/postcss-values-parser/lib/unicode-range.js"(t3, a3) {
        T3();
        var o3 = Ce2(), s3 = Pe2(), c3 = class extends s3 {
          constructor(f3) {
            super(f3), this.type = "unicode-range";
          }
        };
        o3.registerWalker(c3), a3.exports = c3;
      } });
      function zr2() {
        throw new Error("setTimeout has not been defined");
      }
      function $r2() {
        throw new Error("clearTimeout has not been defined");
      }
      function Dr2(t3) {
        if ($e2 === setTimeout)
          return setTimeout(t3, 0);
        if (($e2 === zr2 || !$e2) && setTimeout)
          return $e2 = setTimeout, setTimeout(t3, 0);
        try {
          return $e2(t3, 0);
        } catch {
          try {
            return $e2.call(null, t3, 0);
          } catch {
            return $e2.call(this, t3, 0);
          }
        }
      }
      function vs2(t3) {
        if (De2 === clearTimeout)
          return clearTimeout(t3);
        if ((De2 === $r2 || !De2) && clearTimeout)
          return De2 = clearTimeout, clearTimeout(t3);
        try {
          return De2(t3);
        } catch {
          try {
            return De2.call(null, t3);
          } catch {
            return De2.call(this, t3);
          }
        }
      }
      function ys2() {
        !Ge2 || !qe2 || (Ge2 = false, qe2.length ? Ne2 = qe2.concat(Ne2) : Ke2 = -1, Ne2.length && Wr2());
      }
      function Wr2() {
        if (!Ge2) {
          var t3 = Dr2(ys2);
          Ge2 = true;
          for (var a3 = Ne2.length; a3; ) {
            for (qe2 = Ne2, Ne2 = []; ++Ke2 < a3; )
              qe2 && qe2[Ke2].run();
            Ke2 = -1, a3 = Ne2.length;
          }
          qe2 = null, Ge2 = false, vs2(t3);
        }
      }
      function gs2(t3) {
        var a3 = new Array(arguments.length - 1);
        if (arguments.length > 1)
          for (var o3 = 1; o3 < arguments.length; o3++)
            a3[o3 - 1] = arguments[o3];
        Ne2.push(new Fr2(t3, a3)), Ne2.length === 1 && !Ge2 && Dr2(Wr2);
      }
      function Fr2(t3, a3) {
        this.fun = t3, this.array = a3;
      }
      function Be2() {
      }
      function bs2(t3) {
        throw new Error("process.binding is not supported");
      }
      function ws2() {
        return "/";
      }
      function xs2(t3) {
        throw new Error("process.chdir is not supported");
      }
      function ks2() {
        return 0;
      }
      function _s2(t3) {
        var a3 = nn2.call(Je2) * 1e-3, o3 = Math.floor(a3), s3 = Math.floor(a3 % 1 * 1e9);
        return t3 && (o3 = o3 - t3[0], s3 = s3 - t3[1], s3 < 0 && (o3--, s3 += 1e9)), [o3, s3];
      }
      function Os2() {
        var t3 = /* @__PURE__ */ new Date(), a3 = t3 - on2;
        return a3 / 1e3;
      }
      var $e2, De2, Ne2, Ge2, qe2, Ke2, Ur2, Lr2, Br2, Gr2, qr2, Jr2, Hr2, Qr2, Vr2, Yr2, Xr2, Zr2, Kr2, en2, tn2, rn2, Je2, nn2, on2, sn2, et2, Ts2 = F3({ "node-modules-polyfills:process"() {
        T3(), $e2 = zr2, De2 = $r2, typeof globalThis.setTimeout == "function" && ($e2 = setTimeout), typeof globalThis.clearTimeout == "function" && (De2 = clearTimeout), Ne2 = [], Ge2 = false, Ke2 = -1, Fr2.prototype.run = function() {
          this.fun.apply(null, this.array);
        }, Ur2 = "browser", Lr2 = "browser", Br2 = true, Gr2 = {}, qr2 = [], Jr2 = "", Hr2 = {}, Qr2 = {}, Vr2 = {}, Yr2 = Be2, Xr2 = Be2, Zr2 = Be2, Kr2 = Be2, en2 = Be2, tn2 = Be2, rn2 = Be2, Je2 = globalThis.performance || {}, nn2 = Je2.now || Je2.mozNow || Je2.msNow || Je2.oNow || Je2.webkitNow || function() {
          return (/* @__PURE__ */ new Date()).getTime();
        }, on2 = /* @__PURE__ */ new Date(), sn2 = { nextTick: gs2, title: Ur2, browser: Br2, env: Gr2, argv: qr2, version: Jr2, versions: Hr2, on: Yr2, addListener: Xr2, once: Zr2, off: Kr2, removeListener: en2, removeAllListeners: tn2, emit: rn2, binding: bs2, cwd: ws2, chdir: xs2, umask: ks2, hrtime: _s2, platform: Lr2, release: Qr2, config: Vr2, uptime: Os2 }, et2 = sn2;
      } }), Ct2, Et2, js2 = F3({ "node_modules/rollup-plugin-node-polyfills/polyfills/inherits.js"() {
        T3(), typeof Object.create == "function" ? Ct2 = function(t3, a3) {
          t3.super_ = a3, t3.prototype = Object.create(a3.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } });
        } : Ct2 = function(t3, a3) {
          t3.super_ = a3;
          var o3 = function() {
          };
          o3.prototype = a3.prototype, t3.prototype = new o3(), t3.prototype.constructor = t3;
        }, Et2 = Ct2;
      } }), an2 = {};
      H3(an2, { _extend: () => Dt2, debuglog: () => un2, default: () => yn2, deprecate: () => Mt2, format: () => lt2, inherits: () => Et2, inspect: () => Re2, isArray: () => Nt2, isBoolean: () => pt2, isBuffer: () => pn2, isDate: () => ht2, isError: () => ot2, isFunction: () => st2, isNull: () => tt2, isNullOrUndefined: () => cn2, isNumber: () => Rt2, isObject: () => He2, isPrimitive: () => fn2, isRegExp: () => nt2, isString: () => rt2, isSymbol: () => ln2, isUndefined: () => ze2, log: () => hn2 });
      function lt2(t3) {
        if (!rt2(t3)) {
          for (var a3 = [], o3 = 0; o3 < arguments.length; o3++)
            a3.push(Re2(arguments[o3]));
          return a3.join(" ");
        }
        for (var o3 = 1, s3 = arguments, c3 = s3.length, f3 = String(t3).replace(mn2, function(u3) {
          if (u3 === "%%")
            return "%";
          if (o3 >= c3)
            return u3;
          switch (u3) {
            case "%s":
              return String(s3[o3++]);
            case "%d":
              return Number(s3[o3++]);
            case "%j":
              try {
                return JSON.stringify(s3[o3++]);
              } catch {
                return "[Circular]";
              }
            default:
              return u3;
          }
        }), l3 = s3[o3]; o3 < c3; l3 = s3[++o3])
          tt2(l3) || !He2(l3) ? f3 += " " + l3 : f3 += " " + Re2(l3);
        return f3;
      }
      function Mt2(t3, a3) {
        if (ze2(globalThis.process))
          return function() {
            return Mt2(t3, a3).apply(this, arguments);
          };
        if (et2.noDeprecation === true)
          return t3;
        var o3 = false;
        function s3() {
          if (!o3) {
            if (et2.throwDeprecation)
              throw new Error(a3);
            et2.traceDeprecation ? console.trace(a3) : console.error(a3), o3 = true;
          }
          return t3.apply(this, arguments);
        }
        return s3;
      }
      function un2(t3) {
        if (ze2(Wt2) && (Wt2 = et2.env.NODE_DEBUG || ""), t3 = t3.toUpperCase(), !it2[t3])
          if (new RegExp("\\b" + t3 + "\\b", "i").test(Wt2)) {
            var a3 = 0;
            it2[t3] = function() {
              var o3 = lt2.apply(null, arguments);
              console.error("%s %d: %s", t3, a3, o3);
            };
          } else
            it2[t3] = function() {
            };
        return it2[t3];
      }
      function Re2(t3, a3) {
        var o3 = { seen: [], stylize: Ss2 };
        return arguments.length >= 3 && (o3.depth = arguments[2]), arguments.length >= 4 && (o3.colors = arguments[3]), pt2(a3) ? o3.showHidden = a3 : a3 && Dt2(o3, a3), ze2(o3.showHidden) && (o3.showHidden = false), ze2(o3.depth) && (o3.depth = 2), ze2(o3.colors) && (o3.colors = false), ze2(o3.customInspect) && (o3.customInspect = true), o3.colors && (o3.stylize = As2), ft2(o3, t3, o3.depth);
      }
      function As2(t3, a3) {
        var o3 = Re2.styles[a3];
        return o3 ? "[" + Re2.colors[o3][0] + "m" + t3 + "[" + Re2.colors[o3][1] + "m" : t3;
      }
      function Ss2(t3, a3) {
        return t3;
      }
      function Cs2(t3) {
        var a3 = {};
        return t3.forEach(function(o3, s3) {
          a3[o3] = true;
        }), a3;
      }
      function ft2(t3, a3, o3) {
        if (t3.customInspect && a3 && st2(a3.inspect) && a3.inspect !== Re2 && !(a3.constructor && a3.constructor.prototype === a3)) {
          var s3 = a3.inspect(o3, t3);
          return rt2(s3) || (s3 = ft2(t3, s3, o3)), s3;
        }
        var c3 = Es2(t3, a3);
        if (c3)
          return c3;
        var f3 = Object.keys(a3), l3 = Cs2(f3);
        if (t3.showHidden && (f3 = Object.getOwnPropertyNames(a3)), ot2(a3) && (f3.indexOf("message") >= 0 || f3.indexOf("description") >= 0))
          return It2(a3);
        if (f3.length === 0) {
          if (st2(a3)) {
            var h3 = a3.name ? ": " + a3.name : "";
            return t3.stylize("[Function" + h3 + "]", "special");
          }
          if (nt2(a3))
            return t3.stylize(RegExp.prototype.toString.call(a3), "regexp");
          if (ht2(a3))
            return t3.stylize(Date.prototype.toString.call(a3), "date");
          if (ot2(a3))
            return It2(a3);
        }
        var u3 = "", p3 = false, r3 = ["{", "}"];
        if (Nt2(a3) && (p3 = true, r3 = ["[", "]"]), st2(a3)) {
          var e28 = a3.name ? ": " + a3.name : "";
          u3 = " [Function" + e28 + "]";
        }
        if (nt2(a3) && (u3 = " " + RegExp.prototype.toString.call(a3)), ht2(a3) && (u3 = " " + Date.prototype.toUTCString.call(a3)), ot2(a3) && (u3 = " " + It2(a3)), f3.length === 0 && (!p3 || a3.length == 0))
          return r3[0] + u3 + r3[1];
        if (o3 < 0)
          return nt2(a3) ? t3.stylize(RegExp.prototype.toString.call(a3), "regexp") : t3.stylize("[Object]", "special");
        t3.seen.push(a3);
        var i;
        return p3 ? i = Ms2(t3, a3, o3, l3, f3) : i = f3.map(function(n3) {
          return Pt2(t3, a3, o3, l3, n3, p3);
        }), t3.seen.pop(), Is2(i, u3, r3);
      }
      function Es2(t3, a3) {
        if (ze2(a3))
          return t3.stylize("undefined", "undefined");
        if (rt2(a3)) {
          var o3 = "'" + JSON.stringify(a3).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
          return t3.stylize(o3, "string");
        }
        if (Rt2(a3))
          return t3.stylize("" + a3, "number");
        if (pt2(a3))
          return t3.stylize("" + a3, "boolean");
        if (tt2(a3))
          return t3.stylize("null", "null");
      }
      function It2(t3) {
        return "[" + Error.prototype.toString.call(t3) + "]";
      }
      function Ms2(t3, a3, o3, s3, c3) {
        for (var f3 = [], l3 = 0, h3 = a3.length; l3 < h3; ++l3)
          dn2(a3, String(l3)) ? f3.push(Pt2(t3, a3, o3, s3, String(l3), true)) : f3.push("");
        return c3.forEach(function(u3) {
          u3.match(/^\d+$/) || f3.push(Pt2(t3, a3, o3, s3, u3, true));
        }), f3;
      }
      function Pt2(t3, a3, o3, s3, c3, f3) {
        var l3, h3, u3;
        if (u3 = Object.getOwnPropertyDescriptor(a3, c3) || { value: a3[c3] }, u3.get ? u3.set ? h3 = t3.stylize("[Getter/Setter]", "special") : h3 = t3.stylize("[Getter]", "special") : u3.set && (h3 = t3.stylize("[Setter]", "special")), dn2(s3, c3) || (l3 = "[" + c3 + "]"), h3 || (t3.seen.indexOf(u3.value) < 0 ? (tt2(o3) ? h3 = ft2(t3, u3.value, null) : h3 = ft2(t3, u3.value, o3 - 1), h3.indexOf(`
`) > -1 && (f3 ? h3 = h3.split(`
`).map(function(p3) {
          return "  " + p3;
        }).join(`
`).substr(2) : h3 = `
` + h3.split(`
`).map(function(p3) {
          return "   " + p3;
        }).join(`
`))) : h3 = t3.stylize("[Circular]", "special")), ze2(l3)) {
          if (f3 && c3.match(/^\d+$/))
            return h3;
          l3 = JSON.stringify("" + c3), l3.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (l3 = l3.substr(1, l3.length - 2), l3 = t3.stylize(l3, "name")) : (l3 = l3.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), l3 = t3.stylize(l3, "string"));
        }
        return l3 + ": " + h3;
      }
      function Is2(t3, a3, o3) {
        var s3 = 0, c3 = t3.reduce(function(f3, l3) {
          return s3++, l3.indexOf(`
`) >= 0 && s3++, f3 + l3.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0);
        return c3 > 60 ? o3[0] + (a3 === "" ? "" : a3 + `
 `) + " " + t3.join(`,
  `) + " " + o3[1] : o3[0] + a3 + " " + t3.join(", ") + " " + o3[1];
      }
      function Nt2(t3) {
        return Array.isArray(t3);
      }
      function pt2(t3) {
        return typeof t3 == "boolean";
      }
      function tt2(t3) {
        return t3 === null;
      }
      function cn2(t3) {
        return t3 == null;
      }
      function Rt2(t3) {
        return typeof t3 == "number";
      }
      function rt2(t3) {
        return typeof t3 == "string";
      }
      function ln2(t3) {
        return typeof t3 == "symbol";
      }
      function ze2(t3) {
        return t3 === void 0;
      }
      function nt2(t3) {
        return He2(t3) && zt2(t3) === "[object RegExp]";
      }
      function He2(t3) {
        return typeof t3 == "object" && t3 !== null;
      }
      function ht2(t3) {
        return He2(t3) && zt2(t3) === "[object Date]";
      }
      function ot2(t3) {
        return He2(t3) && (zt2(t3) === "[object Error]" || t3 instanceof Error);
      }
      function st2(t3) {
        return typeof t3 == "function";
      }
      function fn2(t3) {
        return t3 === null || typeof t3 == "boolean" || typeof t3 == "number" || typeof t3 == "string" || typeof t3 == "symbol" || typeof t3 > "u";
      }
      function pn2(t3) {
        return Buffer.isBuffer(t3);
      }
      function zt2(t3) {
        return Object.prototype.toString.call(t3);
      }
      function $t2(t3) {
        return t3 < 10 ? "0" + t3.toString(10) : t3.toString(10);
      }
      function Ps2() {
        var t3 = /* @__PURE__ */ new Date(), a3 = [$t2(t3.getHours()), $t2(t3.getMinutes()), $t2(t3.getSeconds())].join(":");
        return [t3.getDate(), vn2[t3.getMonth()], a3].join(" ");
      }
      function hn2() {
        console.log("%s - %s", Ps2(), lt2.apply(null, arguments));
      }
      function Dt2(t3, a3) {
        if (!a3 || !He2(a3))
          return t3;
        for (var o3 = Object.keys(a3), s3 = o3.length; s3--; )
          t3[o3[s3]] = a3[o3[s3]];
        return t3;
      }
      function dn2(t3, a3) {
        return Object.prototype.hasOwnProperty.call(t3, a3);
      }
      var mn2, it2, Wt2, vn2, yn2, Ns2 = F3({ "node-modules-polyfills:util"() {
        T3(), Ts2(), js2(), mn2 = /%[sdj%]/g, it2 = {}, Re2.colors = { bold: [1, 22], italic: [3, 23], underline: [4, 24], inverse: [7, 27], white: [37, 39], grey: [90, 39], black: [30, 39], blue: [34, 39], cyan: [36, 39], green: [32, 39], magenta: [35, 39], red: [31, 39], yellow: [33, 39] }, Re2.styles = { special: "cyan", number: "yellow", boolean: "yellow", undefined: "grey", null: "bold", string: "green", date: "magenta", regexp: "red" }, vn2 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], yn2 = { inherits: Et2, _extend: Dt2, log: hn2, isBuffer: pn2, isPrimitive: fn2, isFunction: st2, isError: ot2, isDate: ht2, isObject: He2, isRegExp: nt2, isUndefined: ze2, isSymbol: ln2, isString: rt2, isNumber: Rt2, isNullOrUndefined: cn2, isNull: tt2, isBoolean: pt2, isArray: Nt2, inspect: Re2, deprecate: Mt2, format: lt2, debuglog: un2 };
      } }), Rs2 = O3({ "node-modules-polyfills-commonjs:util"(t3, a3) {
        T3();
        var o3 = (Ns2(), re2(an2));
        if (o3 && o3.default) {
          a3.exports = o3.default;
          for (let s3 in o3)
            a3.exports[s3] = o3[s3];
        } else
          o3 && (a3.exports = o3);
      } }), zs2 = O3({ "node_modules/postcss-values-parser/lib/errors/TokenizeError.js"(t3, a3) {
        T3();
        var o3 = class extends Error {
          constructor(s3) {
            super(s3), this.name = this.constructor.name, this.message = s3 || "An error ocurred while tokzenizing.", typeof Error.captureStackTrace == "function" ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error(s3).stack;
          }
        };
        a3.exports = o3;
      } }), $s2 = O3({ "node_modules/postcss-values-parser/lib/tokenize.js"(t3, a3) {
        T3();
        var o3 = "{".charCodeAt(0), s3 = "}".charCodeAt(0), c3 = "(".charCodeAt(0), f3 = ")".charCodeAt(0), l3 = "'".charCodeAt(0), h3 = '"'.charCodeAt(0), u3 = "\\".charCodeAt(0), p3 = "/".charCodeAt(0), r3 = ".".charCodeAt(0), e28 = ",".charCodeAt(0), i = ":".charCodeAt(0), n3 = "*".charCodeAt(0), m3 = "-".charCodeAt(0), d3 = "+".charCodeAt(0), g3 = "#".charCodeAt(0), y3 = `
`.charCodeAt(0), v3 = " ".charCodeAt(0), b3 = "\f".charCodeAt(0), w3 = "	".charCodeAt(0), _3 = "\r".charCodeAt(0), R3 = "@".charCodeAt(0), D3 = "e".charCodeAt(0), U3 = "E".charCodeAt(0), X3 = "0".charCodeAt(0), Y3 = "9".charCodeAt(0), ee2 = "u".charCodeAt(0), V10 = "U".charCodeAt(0), Z3 = /[ \n\t\r\{\(\)'"\\;,/]/g, z3 = /[ \n\t\r\(\)\{\}\*:;@!&'"\+\|~>,\[\]\\]|\/(?=\*)/g, P3 = /[ \n\t\r\(\)\{\}\*:;@!&'"\-\+\|~>,\[\]\\]|\//g, $3 = /^[a-z0-9]/i, E3 = /^[a-f0-9?\-]/i, ve2 = Rs2(), ue2 = zs2();
        a3.exports = function(fe2, ae2) {
          ae2 = ae2 || {};
          let ie2 = [], G3 = fe2.valueOf(), oe2 = G3.length, K3 = -1, te2 = 1, k3 = 0, A3 = 0, C3 = null, W3, x3, J3, L3, we2, ye2, Oe2, Ee2, ke2, ge2, Ae2;
          function xe2(be2) {
            let Te2 = ve2.format("Unclosed %s at line: %d, column: %d, token: %d", be2, te2, k3 - K3, k3);
            throw new ue2(Te2);
          }
          for (; k3 < oe2; ) {
            switch (W3 = G3.charCodeAt(k3), W3 === y3 && (K3 = k3, te2 += 1), W3) {
              case y3:
              case v3:
              case w3:
              case _3:
              case b3:
                x3 = k3;
                do
                  x3 += 1, W3 = G3.charCodeAt(x3), W3 === y3 && (K3 = x3, te2 += 1);
                while (W3 === v3 || W3 === y3 || W3 === w3 || W3 === _3 || W3 === b3);
                ie2.push(["space", G3.slice(k3, x3), te2, k3 - K3, te2, x3 - K3, k3]), k3 = x3 - 1;
                break;
              case i:
                x3 = k3 + 1, ie2.push(["colon", G3.slice(k3, x3), te2, k3 - K3, te2, x3 - K3, k3]), k3 = x3 - 1;
                break;
              case e28:
                x3 = k3 + 1, ie2.push(["comma", G3.slice(k3, x3), te2, k3 - K3, te2, x3 - K3, k3]), k3 = x3 - 1;
                break;
              case o3:
                ie2.push(["{", "{", te2, k3 - K3, te2, x3 - K3, k3]);
                break;
              case s3:
                ie2.push(["}", "}", te2, k3 - K3, te2, x3 - K3, k3]);
                break;
              case c3:
                A3++, C3 = !C3 && A3 === 1 && ie2.length > 0 && ie2[ie2.length - 1][0] === "word" && ie2[ie2.length - 1][1] === "url", ie2.push(["(", "(", te2, k3 - K3, te2, x3 - K3, k3]);
                break;
              case f3:
                A3--, C3 = C3 && A3 > 0, ie2.push([")", ")", te2, k3 - K3, te2, x3 - K3, k3]);
                break;
              case l3:
              case h3:
                J3 = W3 === l3 ? "'" : '"', x3 = k3;
                do
                  for (ke2 = false, x3 = G3.indexOf(J3, x3 + 1), x3 === -1 && xe2("quote"), ge2 = x3; G3.charCodeAt(ge2 - 1) === u3; )
                    ge2 -= 1, ke2 = !ke2;
                while (ke2);
                ie2.push(["string", G3.slice(k3, x3 + 1), te2, k3 - K3, te2, x3 - K3, k3]), k3 = x3;
                break;
              case R3:
                Z3.lastIndex = k3 + 1, Z3.test(G3), Z3.lastIndex === 0 ? x3 = G3.length - 1 : x3 = Z3.lastIndex - 2, ie2.push(["atword", G3.slice(k3, x3 + 1), te2, k3 - K3, te2, x3 - K3, k3]), k3 = x3;
                break;
              case u3:
                x3 = k3, W3 = G3.charCodeAt(x3 + 1), ie2.push(["word", G3.slice(k3, x3 + 1), te2, k3 - K3, te2, x3 - K3, k3]), k3 = x3;
                break;
              case d3:
              case m3:
              case n3:
                if (x3 = k3 + 1, Ae2 = G3.slice(k3 + 1, x3 + 1), G3.slice(k3 - 1, k3), W3 === m3 && Ae2.charCodeAt(0) === m3) {
                  x3++, ie2.push(["word", G3.slice(k3, x3), te2, k3 - K3, te2, x3 - K3, k3]), k3 = x3 - 1;
                  break;
                }
                ie2.push(["operator", G3.slice(k3, x3), te2, k3 - K3, te2, x3 - K3, k3]), k3 = x3 - 1;
                break;
              default:
                if (W3 === p3 && (G3.charCodeAt(k3 + 1) === n3 || ae2.loose && !C3 && G3.charCodeAt(k3 + 1) === p3)) {
                  if (G3.charCodeAt(k3 + 1) === n3)
                    x3 = G3.indexOf("*/", k3 + 2) + 1, x3 === 0 && xe2("comment");
                  else {
                    let be2 = G3.indexOf(`
`, k3 + 2);
                    x3 = be2 !== -1 ? be2 - 1 : oe2;
                  }
                  ye2 = G3.slice(k3, x3 + 1), L3 = ye2.split(`
`), we2 = L3.length - 1, we2 > 0 ? (Oe2 = te2 + we2, Ee2 = x3 - L3[we2].length) : (Oe2 = te2, Ee2 = K3), ie2.push(["comment", ye2, te2, k3 - K3, Oe2, x3 - Ee2, k3]), K3 = Ee2, te2 = Oe2, k3 = x3;
                } else if (W3 === g3 && !$3.test(G3.slice(k3 + 1, k3 + 2)))
                  x3 = k3 + 1, ie2.push(["#", G3.slice(k3, x3), te2, k3 - K3, te2, x3 - K3, k3]), k3 = x3 - 1;
                else if ((W3 === ee2 || W3 === V10) && G3.charCodeAt(k3 + 1) === d3) {
                  x3 = k3 + 2;
                  do
                    x3 += 1, W3 = G3.charCodeAt(x3);
                  while (x3 < oe2 && E3.test(G3.slice(x3, x3 + 1)));
                  ie2.push(["unicoderange", G3.slice(k3, x3), te2, k3 - K3, te2, x3 - K3, k3]), k3 = x3 - 1;
                } else if (W3 === p3)
                  x3 = k3 + 1, ie2.push(["operator", G3.slice(k3, x3), te2, k3 - K3, te2, x3 - K3, k3]), k3 = x3 - 1;
                else {
                  let be2 = z3;
                  if (W3 >= X3 && W3 <= Y3 && (be2 = P3), be2.lastIndex = k3 + 1, be2.test(G3), be2.lastIndex === 0 ? x3 = G3.length - 1 : x3 = be2.lastIndex - 2, be2 === P3 || W3 === r3) {
                    let Te2 = G3.charCodeAt(x3), no2 = G3.charCodeAt(x3 + 1), oo2 = G3.charCodeAt(x3 + 2);
                    (Te2 === D3 || Te2 === U3) && (no2 === m3 || no2 === d3) && oo2 >= X3 && oo2 <= Y3 && (P3.lastIndex = x3 + 2, P3.test(G3), P3.lastIndex === 0 ? x3 = G3.length - 1 : x3 = P3.lastIndex - 2);
                  }
                  ie2.push(["word", G3.slice(k3, x3 + 1), te2, k3 - K3, te2, x3 - K3, k3]), k3 = x3;
                }
                break;
            }
            k3++;
          }
          return ie2;
        };
      } }), gn2 = O3({ "node_modules/flatten/index.js"(t3, a3) {
        T3(), a3.exports = function(o3, s3) {
          if (s3 = typeof s3 == "number" ? s3 : 1 / 0, !s3)
            return Array.isArray(o3) ? o3.map(function(f3) {
              return f3;
            }) : o3;
          return c3(o3, 1);
          function c3(f3, l3) {
            return f3.reduce(function(h3, u3) {
              return Array.isArray(u3) && l3 < s3 ? h3.concat(c3(u3, l3 + 1)) : h3.concat(u3);
            }, []);
          }
        };
      } }), bn2 = O3({ "node_modules/indexes-of/index.js"(t3, a3) {
        T3(), a3.exports = function(o3, s3) {
          for (var c3 = -1, f3 = []; (c3 = o3.indexOf(s3, c3 + 1)) !== -1; )
            f3.push(c3);
          return f3;
        };
      } }), wn2 = O3({ "node_modules/uniq/uniq.js"(t3, a3) {
        T3();
        function o3(f3, l3) {
          for (var h3 = 1, u3 = f3.length, p3 = f3[0], r3 = f3[0], e28 = 1; e28 < u3; ++e28)
            if (r3 = p3, p3 = f3[e28], l3(p3, r3)) {
              if (e28 === h3) {
                h3++;
                continue;
              }
              f3[h3++] = p3;
            }
          return f3.length = h3, f3;
        }
        function s3(f3) {
          for (var l3 = 1, h3 = f3.length, u3 = f3[0], p3 = f3[0], r3 = 1; r3 < h3; ++r3, p3 = u3)
            if (p3 = u3, u3 = f3[r3], u3 !== p3) {
              if (r3 === l3) {
                l3++;
                continue;
              }
              f3[l3++] = u3;
            }
          return f3.length = l3, f3;
        }
        function c3(f3, l3, h3) {
          return f3.length === 0 ? f3 : l3 ? (h3 || f3.sort(l3), o3(f3, l3)) : (h3 || f3.sort(), s3(f3));
        }
        a3.exports = c3;
      } }), Ds2 = O3({ "node_modules/postcss-values-parser/lib/errors/ParserError.js"(t3, a3) {
        T3();
        var o3 = class extends Error {
          constructor(s3) {
            super(s3), this.name = this.constructor.name, this.message = s3 || "An error ocurred while parsing.", typeof Error.captureStackTrace == "function" ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error(s3).stack;
          }
        };
        a3.exports = o3;
      } }), Ws2 = O3({ "node_modules/postcss-values-parser/lib/parser.js"(t3, a3) {
        T3();
        var o3 = ms2(), s3 = Or2(), c3 = Tr2(), f3 = jr2(), l3 = Ar2(), h3 = Sr2(), u3 = Cr2(), p3 = Er2(), r3 = Mr2(), e28 = Ir2(), i = Pr2(), n3 = Nr2(), m3 = Rr2(), d3 = $s2(), g3 = gn2(), y3 = bn2(), v3 = wn2(), b3 = Ds2();
        function w3(_3) {
          return _3.sort((R3, D3) => R3 - D3);
        }
        a3.exports = class {
          constructor(_3, R3) {
            let D3 = { loose: false };
            this.cache = [], this.input = _3, this.options = Object.assign({}, D3, R3), this.position = 0, this.unbalanced = 0, this.root = new o3();
            let U3 = new s3();
            this.root.append(U3), this.current = U3, this.tokens = d3(_3, this.options);
          }
          parse() {
            return this.loop();
          }
          colon() {
            let _3 = this.currToken;
            this.newNode(new f3({ value: _3[1], source: { start: { line: _3[2], column: _3[3] }, end: { line: _3[4], column: _3[5] } }, sourceIndex: _3[6] })), this.position++;
          }
          comma() {
            let _3 = this.currToken;
            this.newNode(new l3({ value: _3[1], source: { start: { line: _3[2], column: _3[3] }, end: { line: _3[4], column: _3[5] } }, sourceIndex: _3[6] })), this.position++;
          }
          comment() {
            let _3 = false, R3 = this.currToken[1].replace(/\/\*|\*\//g, ""), D3;
            this.options.loose && R3.startsWith("//") && (R3 = R3.substring(2), _3 = true), D3 = new h3({ value: R3, inline: _3, source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[4], column: this.currToken[5] } }, sourceIndex: this.currToken[6] }), this.newNode(D3), this.position++;
          }
          error(_3, R3) {
            throw new b3(_3 + ` at line: ${R3[2]}, column ${R3[3]}`);
          }
          loop() {
            for (; this.position < this.tokens.length; )
              this.parseTokens();
            return !this.current.last && this.spaces ? this.current.raws.before += this.spaces : this.spaces && (this.current.last.raws.after += this.spaces), this.spaces = "", this.root;
          }
          operator() {
            let _3 = this.currToken[1], R3;
            if (_3 === "+" || _3 === "-") {
              if (this.options.loose || this.position > 0 && (this.current.type === "func" && this.current.value === "calc" ? this.prevToken[0] !== "space" && this.prevToken[0] !== "(" ? this.error("Syntax Error", this.currToken) : this.nextToken[0] !== "space" && this.nextToken[0] !== "word" ? this.error("Syntax Error", this.currToken) : this.nextToken[0] === "word" && this.current.last.type !== "operator" && this.current.last.value !== "(" && this.error("Syntax Error", this.currToken) : (this.nextToken[0] === "space" || this.nextToken[0] === "operator" || this.prevToken[0] === "operator") && this.error("Syntax Error", this.currToken)), this.options.loose) {
                if ((!this.current.nodes.length || this.current.last && this.current.last.type === "operator") && this.nextToken[0] === "word")
                  return this.word();
              } else if (this.nextToken[0] === "word")
                return this.word();
            }
            return R3 = new r3({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] }), this.position++, this.newNode(R3);
          }
          parseTokens() {
            switch (this.currToken[0]) {
              case "space":
                this.space();
                break;
              case "colon":
                this.colon();
                break;
              case "comma":
                this.comma();
                break;
              case "comment":
                this.comment();
                break;
              case "(":
                this.parenOpen();
                break;
              case ")":
                this.parenClose();
                break;
              case "atword":
              case "word":
                this.word();
                break;
              case "operator":
                this.operator();
                break;
              case "string":
                this.string();
                break;
              case "unicoderange":
                this.unicodeRange();
                break;
              default:
                this.word();
                break;
            }
          }
          parenOpen() {
            let _3 = 1, R3 = this.position + 1, D3 = this.currToken, U3;
            for (; R3 < this.tokens.length && _3; ) {
              let X3 = this.tokens[R3];
              X3[0] === "(" && _3++, X3[0] === ")" && _3--, R3++;
            }
            if (_3 && this.error("Expected closing parenthesis", D3), U3 = this.current.last, U3 && U3.type === "func" && U3.unbalanced < 0 && (U3.unbalanced = 0, this.current = U3), this.current.unbalanced++, this.newNode(new e28({ value: D3[1], source: { start: { line: D3[2], column: D3[3] }, end: { line: D3[4], column: D3[5] } }, sourceIndex: D3[6] })), this.position++, this.current.type === "func" && this.current.unbalanced && this.current.value === "url" && this.currToken[0] !== "string" && this.currToken[0] !== ")" && !this.options.loose) {
              let X3 = this.nextToken, Y3 = this.currToken[1], ee2 = { line: this.currToken[2], column: this.currToken[3] };
              for (; X3 && X3[0] !== ")" && this.current.unbalanced; )
                this.position++, Y3 += this.currToken[1], X3 = this.nextToken;
              this.position !== this.tokens.length - 1 && (this.position++, this.newNode(new n3({ value: Y3, source: { start: ee2, end: { line: this.currToken[4], column: this.currToken[5] } }, sourceIndex: this.currToken[6] })));
            }
          }
          parenClose() {
            let _3 = this.currToken;
            this.newNode(new e28({ value: _3[1], source: { start: { line: _3[2], column: _3[3] }, end: { line: _3[4], column: _3[5] } }, sourceIndex: _3[6] })), this.position++, !(this.position >= this.tokens.length - 1 && !this.current.unbalanced) && (this.current.unbalanced--, this.current.unbalanced < 0 && this.error("Expected opening parenthesis", _3), !this.current.unbalanced && this.cache.length && (this.current = this.cache.pop()));
          }
          space() {
            let _3 = this.currToken;
            this.position === this.tokens.length - 1 || this.nextToken[0] === "," || this.nextToken[0] === ")" ? (this.current.last.raws.after += _3[1], this.position++) : (this.spaces = _3[1], this.position++);
          }
          unicodeRange() {
            let _3 = this.currToken;
            this.newNode(new m3({ value: _3[1], source: { start: { line: _3[2], column: _3[3] }, end: { line: _3[4], column: _3[5] } }, sourceIndex: _3[6] })), this.position++;
          }
          splitWord() {
            let _3 = this.nextToken, R3 = this.currToken[1], D3 = /^[\+\-]?((\d+(\.\d*)?)|(\.\d+))([eE][\+\-]?\d+)?/, U3 = /^(?!\#([a-z0-9]+))[\#\{\}]/gi, X3, Y3;
            if (!U3.test(R3))
              for (; _3 && _3[0] === "word"; ) {
                this.position++;
                let ee2 = this.currToken[1];
                R3 += ee2, _3 = this.nextToken;
              }
            X3 = y3(R3, "@"), Y3 = w3(v3(g3([[0], X3]))), Y3.forEach((ee2, V10) => {
              let Z3 = Y3[V10 + 1] || R3.length, z3 = R3.slice(ee2, Z3), P3;
              if (~X3.indexOf(ee2))
                P3 = new c3({ value: z3.slice(1), source: { start: { line: this.currToken[2], column: this.currToken[3] + ee2 }, end: { line: this.currToken[4], column: this.currToken[3] + (Z3 - 1) } }, sourceIndex: this.currToken[6] + Y3[V10] });
              else if (D3.test(this.currToken[1])) {
                let $3 = z3.replace(D3, "");
                P3 = new p3({ value: z3.replace($3, ""), source: { start: { line: this.currToken[2], column: this.currToken[3] + ee2 }, end: { line: this.currToken[4], column: this.currToken[3] + (Z3 - 1) } }, sourceIndex: this.currToken[6] + Y3[V10], unit: $3 });
              } else
                P3 = new (_3 && _3[0] === "(" ? u3 : n3)({ value: z3, source: { start: { line: this.currToken[2], column: this.currToken[3] + ee2 }, end: { line: this.currToken[4], column: this.currToken[3] + (Z3 - 1) } }, sourceIndex: this.currToken[6] + Y3[V10] }), P3.type === "word" ? (P3.isHex = /^#(.+)/.test(z3), P3.isColor = /^#([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(z3)) : this.cache.push(this.current);
              this.newNode(P3);
            }), this.position++;
          }
          string() {
            let _3 = this.currToken, R3 = this.currToken[1], D3 = /^(\"|\')/, U3 = D3.test(R3), X3 = "", Y3;
            U3 && (X3 = R3.match(D3)[0], R3 = R3.slice(1, R3.length - 1)), Y3 = new i({ value: R3, source: { start: { line: _3[2], column: _3[3] }, end: { line: _3[4], column: _3[5] } }, sourceIndex: _3[6], quoted: U3 }), Y3.raws.quote = X3, this.newNode(Y3), this.position++;
          }
          word() {
            return this.splitWord();
          }
          newNode(_3) {
            return this.spaces && (_3.raws.before += this.spaces, this.spaces = ""), this.current.append(_3);
          }
          get currToken() {
            return this.tokens[this.position];
          }
          get nextToken() {
            return this.tokens[this.position + 1];
          }
          get prevToken() {
            return this.tokens[this.position - 1];
          }
        };
      } }), Fs2 = O3({ "node_modules/postcss-values-parser/lib/index.js"(t3, a3) {
        T3();
        var o3 = Ws2(), s3 = Tr2(), c3 = jr2(), f3 = Ar2(), l3 = Sr2(), h3 = Cr2(), u3 = Er2(), p3 = Mr2(), r3 = Ir2(), e28 = Pr2(), i = Rr2(), n3 = Or2(), m3 = Nr2(), d3 = function(g3, y3) {
          return new o3(g3, y3);
        };
        d3.atword = function(g3) {
          return new s3(g3);
        }, d3.colon = function(g3) {
          return new c3(Object.assign({ value: ":" }, g3));
        }, d3.comma = function(g3) {
          return new f3(Object.assign({ value: "," }, g3));
        }, d3.comment = function(g3) {
          return new l3(g3);
        }, d3.func = function(g3) {
          return new h3(g3);
        }, d3.number = function(g3) {
          return new u3(g3);
        }, d3.operator = function(g3) {
          return new p3(g3);
        }, d3.paren = function(g3) {
          return new r3(Object.assign({ value: "(" }, g3));
        }, d3.string = function(g3) {
          return new e28(Object.assign({ quote: "'" }, g3));
        }, d3.value = function(g3) {
          return new n3(g3);
        }, d3.word = function(g3) {
          return new m3(g3);
        }, d3.unicodeRange = function(g3) {
          return new i(g3);
        }, a3.exports = d3;
      } }), Ye2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/node.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l3) {
          return typeof l3;
        } : function(l3) {
          return l3 && typeof Symbol == "function" && l3.constructor === Symbol && l3 !== Symbol.prototype ? "symbol" : typeof l3;
        };
        function s3(l3, h3) {
          if (!(l3 instanceof h3))
            throw new TypeError("Cannot call a class as a function");
        }
        var c3 = function l3(h3, u3) {
          if ((typeof h3 > "u" ? "undefined" : o3(h3)) !== "object")
            return h3;
          var p3 = new h3.constructor();
          for (var r3 in h3)
            if (h3.hasOwnProperty(r3)) {
              var e28 = h3[r3], i = typeof e28 > "u" ? "undefined" : o3(e28);
              r3 === "parent" && i === "object" ? u3 && (p3[r3] = u3) : e28 instanceof Array ? p3[r3] = e28.map(function(n3) {
                return l3(n3, p3);
              }) : p3[r3] = l3(e28, p3);
            }
          return p3;
        }, f3 = function() {
          function l3() {
            var h3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            s3(this, l3);
            for (var u3 in h3)
              this[u3] = h3[u3];
            var p3 = h3.spaces;
            p3 = p3 === void 0 ? {} : p3;
            var r3 = p3.before, e28 = r3 === void 0 ? "" : r3, i = p3.after, n3 = i === void 0 ? "" : i;
            this.spaces = { before: e28, after: n3 };
          }
          return l3.prototype.remove = function() {
            return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
          }, l3.prototype.replaceWith = function() {
            if (this.parent) {
              for (var h3 in arguments)
                this.parent.insertBefore(this, arguments[h3]);
              this.remove();
            }
            return this;
          }, l3.prototype.next = function() {
            return this.parent.at(this.parent.index(this) + 1);
          }, l3.prototype.prev = function() {
            return this.parent.at(this.parent.index(this) - 1);
          }, l3.prototype.clone = function() {
            var h3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u3 = c3(this);
            for (var p3 in h3)
              u3[p3] = h3[p3];
            return u3;
          }, l3.prototype.toString = function() {
            return [this.spaces.before, String(this.value), this.spaces.after].join("");
          }, l3;
        }();
        t3.default = f3, a3.exports = t3.default;
      } }), _e2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/types.js"(t3) {
        T3(), t3.__esModule = true, t3.TAG = "tag", t3.STRING = "string", t3.SELECTOR = "selector", t3.ROOT = "root", t3.PSEUDO = "pseudo", t3.NESTING = "nesting", t3.ID = "id", t3.COMMENT = "comment", t3.COMBINATOR = "combinator", t3.CLASS = "class", t3.ATTRIBUTE = "attribute", t3.UNIVERSAL = "universal";
      } }), Ft2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/container.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = function() {
          function n3(m3, d3) {
            for (var g3 = 0; g3 < d3.length; g3++) {
              var y3 = d3[g3];
              y3.enumerable = y3.enumerable || false, y3.configurable = true, "value" in y3 && (y3.writable = true), Object.defineProperty(m3, y3.key, y3);
            }
          }
          return function(m3, d3, g3) {
            return d3 && n3(m3.prototype, d3), g3 && n3(m3, g3), m3;
          };
        }(), s3 = Ye2(), c3 = u3(s3), f3 = _e2(), l3 = h3(f3);
        function h3(n3) {
          if (n3 && n3.__esModule)
            return n3;
          var m3 = {};
          if (n3 != null)
            for (var d3 in n3)
              Object.prototype.hasOwnProperty.call(n3, d3) && (m3[d3] = n3[d3]);
          return m3.default = n3, m3;
        }
        function u3(n3) {
          return n3 && n3.__esModule ? n3 : { default: n3 };
        }
        function p3(n3, m3) {
          if (!(n3 instanceof m3))
            throw new TypeError("Cannot call a class as a function");
        }
        function r3(n3, m3) {
          if (!n3)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return m3 && (typeof m3 == "object" || typeof m3 == "function") ? m3 : n3;
        }
        function e28(n3, m3) {
          if (typeof m3 != "function" && m3 !== null)
            throw new TypeError("Super expression must either be null or a function, not " + typeof m3);
          n3.prototype = Object.create(m3 && m3.prototype, { constructor: { value: n3, enumerable: false, writable: true, configurable: true } }), m3 && (Object.setPrototypeOf ? Object.setPrototypeOf(n3, m3) : n3.__proto__ = m3);
        }
        var i = function(n3) {
          e28(m3, n3);
          function m3(d3) {
            p3(this, m3);
            var g3 = r3(this, n3.call(this, d3));
            return g3.nodes || (g3.nodes = []), g3;
          }
          return m3.prototype.append = function(d3) {
            return d3.parent = this, this.nodes.push(d3), this;
          }, m3.prototype.prepend = function(d3) {
            return d3.parent = this, this.nodes.unshift(d3), this;
          }, m3.prototype.at = function(d3) {
            return this.nodes[d3];
          }, m3.prototype.index = function(d3) {
            return typeof d3 == "number" ? d3 : this.nodes.indexOf(d3);
          }, m3.prototype.removeChild = function(d3) {
            d3 = this.index(d3), this.at(d3).parent = void 0, this.nodes.splice(d3, 1);
            var g3 = void 0;
            for (var y3 in this.indexes)
              g3 = this.indexes[y3], g3 >= d3 && (this.indexes[y3] = g3 - 1);
            return this;
          }, m3.prototype.removeAll = function() {
            for (var y3 = this.nodes, d3 = Array.isArray(y3), g3 = 0, y3 = d3 ? y3 : y3[Symbol.iterator](); ; ) {
              var v3;
              if (d3) {
                if (g3 >= y3.length)
                  break;
                v3 = y3[g3++];
              } else {
                if (g3 = y3.next(), g3.done)
                  break;
                v3 = g3.value;
              }
              var b3 = v3;
              b3.parent = void 0;
            }
            return this.nodes = [], this;
          }, m3.prototype.empty = function() {
            return this.removeAll();
          }, m3.prototype.insertAfter = function(d3, g3) {
            var y3 = this.index(d3);
            this.nodes.splice(y3 + 1, 0, g3);
            var v3 = void 0;
            for (var b3 in this.indexes)
              v3 = this.indexes[b3], y3 <= v3 && (this.indexes[b3] = v3 + this.nodes.length);
            return this;
          }, m3.prototype.insertBefore = function(d3, g3) {
            var y3 = this.index(d3);
            this.nodes.splice(y3, 0, g3);
            var v3 = void 0;
            for (var b3 in this.indexes)
              v3 = this.indexes[b3], y3 <= v3 && (this.indexes[b3] = v3 + this.nodes.length);
            return this;
          }, m3.prototype.each = function(d3) {
            this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach++;
            var g3 = this.lastEach;
            if (this.indexes[g3] = 0, !!this.length) {
              for (var y3 = void 0, v3 = void 0; this.indexes[g3] < this.length && (y3 = this.indexes[g3], v3 = d3(this.at(y3), y3), v3 !== false); )
                this.indexes[g3] += 1;
              if (delete this.indexes[g3], v3 === false)
                return false;
            }
          }, m3.prototype.walk = function(d3) {
            return this.each(function(g3, y3) {
              var v3 = d3(g3, y3);
              if (v3 !== false && g3.length && (v3 = g3.walk(d3)), v3 === false)
                return false;
            });
          }, m3.prototype.walkAttributes = function(d3) {
            var g3 = this;
            return this.walk(function(y3) {
              if (y3.type === l3.ATTRIBUTE)
                return d3.call(g3, y3);
            });
          }, m3.prototype.walkClasses = function(d3) {
            var g3 = this;
            return this.walk(function(y3) {
              if (y3.type === l3.CLASS)
                return d3.call(g3, y3);
            });
          }, m3.prototype.walkCombinators = function(d3) {
            var g3 = this;
            return this.walk(function(y3) {
              if (y3.type === l3.COMBINATOR)
                return d3.call(g3, y3);
            });
          }, m3.prototype.walkComments = function(d3) {
            var g3 = this;
            return this.walk(function(y3) {
              if (y3.type === l3.COMMENT)
                return d3.call(g3, y3);
            });
          }, m3.prototype.walkIds = function(d3) {
            var g3 = this;
            return this.walk(function(y3) {
              if (y3.type === l3.ID)
                return d3.call(g3, y3);
            });
          }, m3.prototype.walkNesting = function(d3) {
            var g3 = this;
            return this.walk(function(y3) {
              if (y3.type === l3.NESTING)
                return d3.call(g3, y3);
            });
          }, m3.prototype.walkPseudos = function(d3) {
            var g3 = this;
            return this.walk(function(y3) {
              if (y3.type === l3.PSEUDO)
                return d3.call(g3, y3);
            });
          }, m3.prototype.walkTags = function(d3) {
            var g3 = this;
            return this.walk(function(y3) {
              if (y3.type === l3.TAG)
                return d3.call(g3, y3);
            });
          }, m3.prototype.walkUniversals = function(d3) {
            var g3 = this;
            return this.walk(function(y3) {
              if (y3.type === l3.UNIVERSAL)
                return d3.call(g3, y3);
            });
          }, m3.prototype.split = function(d3) {
            var g3 = this, y3 = [];
            return this.reduce(function(v3, b3, w3) {
              var _3 = d3.call(g3, b3);
              return y3.push(b3), _3 ? (v3.push(y3), y3 = []) : w3 === g3.length - 1 && v3.push(y3), v3;
            }, []);
          }, m3.prototype.map = function(d3) {
            return this.nodes.map(d3);
          }, m3.prototype.reduce = function(d3, g3) {
            return this.nodes.reduce(d3, g3);
          }, m3.prototype.every = function(d3) {
            return this.nodes.every(d3);
          }, m3.prototype.some = function(d3) {
            return this.nodes.some(d3);
          }, m3.prototype.filter = function(d3) {
            return this.nodes.filter(d3);
          }, m3.prototype.sort = function(d3) {
            return this.nodes.sort(d3);
          }, m3.prototype.toString = function() {
            return this.map(String).join("");
          }, o3(m3, [{ key: "first", get: function() {
            return this.at(0);
          } }, { key: "last", get: function() {
            return this.at(this.length - 1);
          } }, { key: "length", get: function() {
            return this.nodes.length;
          } }]), m3;
        }(c3.default);
        t3.default = i, a3.exports = t3.default;
      } }), xn2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/root.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = Ft2(), s3 = f3(o3), c3 = _e2();
        function f3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        function l3(r3, e28) {
          if (!(r3 instanceof e28))
            throw new TypeError("Cannot call a class as a function");
        }
        function h3(r3, e28) {
          if (!r3)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e28 && (typeof e28 == "object" || typeof e28 == "function") ? e28 : r3;
        }
        function u3(r3, e28) {
          if (typeof e28 != "function" && e28 !== null)
            throw new TypeError("Super expression must either be null or a function, not " + typeof e28);
          r3.prototype = Object.create(e28 && e28.prototype, { constructor: { value: r3, enumerable: false, writable: true, configurable: true } }), e28 && (Object.setPrototypeOf ? Object.setPrototypeOf(r3, e28) : r3.__proto__ = e28);
        }
        var p3 = function(r3) {
          u3(e28, r3);
          function e28(i) {
            l3(this, e28);
            var n3 = h3(this, r3.call(this, i));
            return n3.type = c3.ROOT, n3;
          }
          return e28.prototype.toString = function() {
            var i = this.reduce(function(n3, m3) {
              var d3 = String(m3);
              return d3 ? n3 + d3 + "," : "";
            }, "").slice(0, -1);
            return this.trailingComma ? i + "," : i;
          }, e28;
        }(s3.default);
        t3.default = p3, a3.exports = t3.default;
      } }), kn2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/selector.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = Ft2(), s3 = f3(o3), c3 = _e2();
        function f3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        function l3(r3, e28) {
          if (!(r3 instanceof e28))
            throw new TypeError("Cannot call a class as a function");
        }
        function h3(r3, e28) {
          if (!r3)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e28 && (typeof e28 == "object" || typeof e28 == "function") ? e28 : r3;
        }
        function u3(r3, e28) {
          if (typeof e28 != "function" && e28 !== null)
            throw new TypeError("Super expression must either be null or a function, not " + typeof e28);
          r3.prototype = Object.create(e28 && e28.prototype, { constructor: { value: r3, enumerable: false, writable: true, configurable: true } }), e28 && (Object.setPrototypeOf ? Object.setPrototypeOf(r3, e28) : r3.__proto__ = e28);
        }
        var p3 = function(r3) {
          u3(e28, r3);
          function e28(i) {
            l3(this, e28);
            var n3 = h3(this, r3.call(this, i));
            return n3.type = c3.SELECTOR, n3;
          }
          return e28;
        }(s3.default);
        t3.default = p3, a3.exports = t3.default;
      } }), at2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/namespace.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = function() {
          function r3(e28, i) {
            for (var n3 = 0; n3 < i.length; n3++) {
              var m3 = i[n3];
              m3.enumerable = m3.enumerable || false, m3.configurable = true, "value" in m3 && (m3.writable = true), Object.defineProperty(e28, m3.key, m3);
            }
          }
          return function(e28, i, n3) {
            return i && r3(e28.prototype, i), n3 && r3(e28, n3), e28;
          };
        }(), s3 = Ye2(), c3 = f3(s3);
        function f3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        function l3(r3, e28) {
          if (!(r3 instanceof e28))
            throw new TypeError("Cannot call a class as a function");
        }
        function h3(r3, e28) {
          if (!r3)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e28 && (typeof e28 == "object" || typeof e28 == "function") ? e28 : r3;
        }
        function u3(r3, e28) {
          if (typeof e28 != "function" && e28 !== null)
            throw new TypeError("Super expression must either be null or a function, not " + typeof e28);
          r3.prototype = Object.create(e28 && e28.prototype, { constructor: { value: r3, enumerable: false, writable: true, configurable: true } }), e28 && (Object.setPrototypeOf ? Object.setPrototypeOf(r3, e28) : r3.__proto__ = e28);
        }
        var p3 = function(r3) {
          u3(e28, r3);
          function e28() {
            return l3(this, e28), h3(this, r3.apply(this, arguments));
          }
          return e28.prototype.toString = function() {
            return [this.spaces.before, this.ns, String(this.value), this.spaces.after].join("");
          }, o3(e28, [{ key: "ns", get: function() {
            var i = this.namespace;
            return i ? (typeof i == "string" ? i : "") + "|" : "";
          } }]), e28;
        }(c3.default);
        t3.default = p3, a3.exports = t3.default;
      } }), _n2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/className.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = at2(), s3 = f3(o3), c3 = _e2();
        function f3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        function l3(r3, e28) {
          if (!(r3 instanceof e28))
            throw new TypeError("Cannot call a class as a function");
        }
        function h3(r3, e28) {
          if (!r3)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e28 && (typeof e28 == "object" || typeof e28 == "function") ? e28 : r3;
        }
        function u3(r3, e28) {
          if (typeof e28 != "function" && e28 !== null)
            throw new TypeError("Super expression must either be null or a function, not " + typeof e28);
          r3.prototype = Object.create(e28 && e28.prototype, { constructor: { value: r3, enumerable: false, writable: true, configurable: true } }), e28 && (Object.setPrototypeOf ? Object.setPrototypeOf(r3, e28) : r3.__proto__ = e28);
        }
        var p3 = function(r3) {
          u3(e28, r3);
          function e28(i) {
            l3(this, e28);
            var n3 = h3(this, r3.call(this, i));
            return n3.type = c3.CLASS, n3;
          }
          return e28.prototype.toString = function() {
            return [this.spaces.before, this.ns, "." + this.value, this.spaces.after].join("");
          }, e28;
        }(s3.default);
        t3.default = p3, a3.exports = t3.default;
      } }), On2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/comment.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = Ye2(), s3 = f3(o3), c3 = _e2();
        function f3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        function l3(r3, e28) {
          if (!(r3 instanceof e28))
            throw new TypeError("Cannot call a class as a function");
        }
        function h3(r3, e28) {
          if (!r3)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e28 && (typeof e28 == "object" || typeof e28 == "function") ? e28 : r3;
        }
        function u3(r3, e28) {
          if (typeof e28 != "function" && e28 !== null)
            throw new TypeError("Super expression must either be null or a function, not " + typeof e28);
          r3.prototype = Object.create(e28 && e28.prototype, { constructor: { value: r3, enumerable: false, writable: true, configurable: true } }), e28 && (Object.setPrototypeOf ? Object.setPrototypeOf(r3, e28) : r3.__proto__ = e28);
        }
        var p3 = function(r3) {
          u3(e28, r3);
          function e28(i) {
            l3(this, e28);
            var n3 = h3(this, r3.call(this, i));
            return n3.type = c3.COMMENT, n3;
          }
          return e28;
        }(s3.default);
        t3.default = p3, a3.exports = t3.default;
      } }), Tn2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/id.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = at2(), s3 = f3(o3), c3 = _e2();
        function f3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        function l3(r3, e28) {
          if (!(r3 instanceof e28))
            throw new TypeError("Cannot call a class as a function");
        }
        function h3(r3, e28) {
          if (!r3)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e28 && (typeof e28 == "object" || typeof e28 == "function") ? e28 : r3;
        }
        function u3(r3, e28) {
          if (typeof e28 != "function" && e28 !== null)
            throw new TypeError("Super expression must either be null or a function, not " + typeof e28);
          r3.prototype = Object.create(e28 && e28.prototype, { constructor: { value: r3, enumerable: false, writable: true, configurable: true } }), e28 && (Object.setPrototypeOf ? Object.setPrototypeOf(r3, e28) : r3.__proto__ = e28);
        }
        var p3 = function(r3) {
          u3(e28, r3);
          function e28(i) {
            l3(this, e28);
            var n3 = h3(this, r3.call(this, i));
            return n3.type = c3.ID, n3;
          }
          return e28.prototype.toString = function() {
            return [this.spaces.before, this.ns, "#" + this.value, this.spaces.after].join("");
          }, e28;
        }(s3.default);
        t3.default = p3, a3.exports = t3.default;
      } }), jn2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/tag.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = at2(), s3 = f3(o3), c3 = _e2();
        function f3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        function l3(r3, e28) {
          if (!(r3 instanceof e28))
            throw new TypeError("Cannot call a class as a function");
        }
        function h3(r3, e28) {
          if (!r3)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e28 && (typeof e28 == "object" || typeof e28 == "function") ? e28 : r3;
        }
        function u3(r3, e28) {
          if (typeof e28 != "function" && e28 !== null)
            throw new TypeError("Super expression must either be null or a function, not " + typeof e28);
          r3.prototype = Object.create(e28 && e28.prototype, { constructor: { value: r3, enumerable: false, writable: true, configurable: true } }), e28 && (Object.setPrototypeOf ? Object.setPrototypeOf(r3, e28) : r3.__proto__ = e28);
        }
        var p3 = function(r3) {
          u3(e28, r3);
          function e28(i) {
            l3(this, e28);
            var n3 = h3(this, r3.call(this, i));
            return n3.type = c3.TAG, n3;
          }
          return e28;
        }(s3.default);
        t3.default = p3, a3.exports = t3.default;
      } }), An2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/string.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = Ye2(), s3 = f3(o3), c3 = _e2();
        function f3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        function l3(r3, e28) {
          if (!(r3 instanceof e28))
            throw new TypeError("Cannot call a class as a function");
        }
        function h3(r3, e28) {
          if (!r3)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e28 && (typeof e28 == "object" || typeof e28 == "function") ? e28 : r3;
        }
        function u3(r3, e28) {
          if (typeof e28 != "function" && e28 !== null)
            throw new TypeError("Super expression must either be null or a function, not " + typeof e28);
          r3.prototype = Object.create(e28 && e28.prototype, { constructor: { value: r3, enumerable: false, writable: true, configurable: true } }), e28 && (Object.setPrototypeOf ? Object.setPrototypeOf(r3, e28) : r3.__proto__ = e28);
        }
        var p3 = function(r3) {
          u3(e28, r3);
          function e28(i) {
            l3(this, e28);
            var n3 = h3(this, r3.call(this, i));
            return n3.type = c3.STRING, n3;
          }
          return e28;
        }(s3.default);
        t3.default = p3, a3.exports = t3.default;
      } }), Sn2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/pseudo.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = Ft2(), s3 = f3(o3), c3 = _e2();
        function f3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        function l3(r3, e28) {
          if (!(r3 instanceof e28))
            throw new TypeError("Cannot call a class as a function");
        }
        function h3(r3, e28) {
          if (!r3)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e28 && (typeof e28 == "object" || typeof e28 == "function") ? e28 : r3;
        }
        function u3(r3, e28) {
          if (typeof e28 != "function" && e28 !== null)
            throw new TypeError("Super expression must either be null or a function, not " + typeof e28);
          r3.prototype = Object.create(e28 && e28.prototype, { constructor: { value: r3, enumerable: false, writable: true, configurable: true } }), e28 && (Object.setPrototypeOf ? Object.setPrototypeOf(r3, e28) : r3.__proto__ = e28);
        }
        var p3 = function(r3) {
          u3(e28, r3);
          function e28(i) {
            l3(this, e28);
            var n3 = h3(this, r3.call(this, i));
            return n3.type = c3.PSEUDO, n3;
          }
          return e28.prototype.toString = function() {
            var i = this.length ? "(" + this.map(String).join(",") + ")" : "";
            return [this.spaces.before, String(this.value), i, this.spaces.after].join("");
          }, e28;
        }(s3.default);
        t3.default = p3, a3.exports = t3.default;
      } }), Cn2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/attribute.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = at2(), s3 = f3(o3), c3 = _e2();
        function f3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        function l3(r3, e28) {
          if (!(r3 instanceof e28))
            throw new TypeError("Cannot call a class as a function");
        }
        function h3(r3, e28) {
          if (!r3)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e28 && (typeof e28 == "object" || typeof e28 == "function") ? e28 : r3;
        }
        function u3(r3, e28) {
          if (typeof e28 != "function" && e28 !== null)
            throw new TypeError("Super expression must either be null or a function, not " + typeof e28);
          r3.prototype = Object.create(e28 && e28.prototype, { constructor: { value: r3, enumerable: false, writable: true, configurable: true } }), e28 && (Object.setPrototypeOf ? Object.setPrototypeOf(r3, e28) : r3.__proto__ = e28);
        }
        var p3 = function(r3) {
          u3(e28, r3);
          function e28(i) {
            l3(this, e28);
            var n3 = h3(this, r3.call(this, i));
            return n3.type = c3.ATTRIBUTE, n3.raws = {}, n3;
          }
          return e28.prototype.toString = function() {
            var i = [this.spaces.before, "[", this.ns, this.attribute];
            return this.operator && i.push(this.operator), this.value && i.push(this.value), this.raws.insensitive ? i.push(this.raws.insensitive) : this.insensitive && i.push(" i"), i.push("]"), i.concat(this.spaces.after).join("");
          }, e28;
        }(s3.default);
        t3.default = p3, a3.exports = t3.default;
      } }), En2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/universal.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = at2(), s3 = f3(o3), c3 = _e2();
        function f3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        function l3(r3, e28) {
          if (!(r3 instanceof e28))
            throw new TypeError("Cannot call a class as a function");
        }
        function h3(r3, e28) {
          if (!r3)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e28 && (typeof e28 == "object" || typeof e28 == "function") ? e28 : r3;
        }
        function u3(r3, e28) {
          if (typeof e28 != "function" && e28 !== null)
            throw new TypeError("Super expression must either be null or a function, not " + typeof e28);
          r3.prototype = Object.create(e28 && e28.prototype, { constructor: { value: r3, enumerable: false, writable: true, configurable: true } }), e28 && (Object.setPrototypeOf ? Object.setPrototypeOf(r3, e28) : r3.__proto__ = e28);
        }
        var p3 = function(r3) {
          u3(e28, r3);
          function e28(i) {
            l3(this, e28);
            var n3 = h3(this, r3.call(this, i));
            return n3.type = c3.UNIVERSAL, n3.value = "*", n3;
          }
          return e28;
        }(s3.default);
        t3.default = p3, a3.exports = t3.default;
      } }), Mn2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/combinator.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = Ye2(), s3 = f3(o3), c3 = _e2();
        function f3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        function l3(r3, e28) {
          if (!(r3 instanceof e28))
            throw new TypeError("Cannot call a class as a function");
        }
        function h3(r3, e28) {
          if (!r3)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e28 && (typeof e28 == "object" || typeof e28 == "function") ? e28 : r3;
        }
        function u3(r3, e28) {
          if (typeof e28 != "function" && e28 !== null)
            throw new TypeError("Super expression must either be null or a function, not " + typeof e28);
          r3.prototype = Object.create(e28 && e28.prototype, { constructor: { value: r3, enumerable: false, writable: true, configurable: true } }), e28 && (Object.setPrototypeOf ? Object.setPrototypeOf(r3, e28) : r3.__proto__ = e28);
        }
        var p3 = function(r3) {
          u3(e28, r3);
          function e28(i) {
            l3(this, e28);
            var n3 = h3(this, r3.call(this, i));
            return n3.type = c3.COMBINATOR, n3;
          }
          return e28;
        }(s3.default);
        t3.default = p3, a3.exports = t3.default;
      } }), In2 = O3({ "node_modules/postcss-selector-parser/dist/selectors/nesting.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = Ye2(), s3 = f3(o3), c3 = _e2();
        function f3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        function l3(r3, e28) {
          if (!(r3 instanceof e28))
            throw new TypeError("Cannot call a class as a function");
        }
        function h3(r3, e28) {
          if (!r3)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e28 && (typeof e28 == "object" || typeof e28 == "function") ? e28 : r3;
        }
        function u3(r3, e28) {
          if (typeof e28 != "function" && e28 !== null)
            throw new TypeError("Super expression must either be null or a function, not " + typeof e28);
          r3.prototype = Object.create(e28 && e28.prototype, { constructor: { value: r3, enumerable: false, writable: true, configurable: true } }), e28 && (Object.setPrototypeOf ? Object.setPrototypeOf(r3, e28) : r3.__proto__ = e28);
        }
        var p3 = function(r3) {
          u3(e28, r3);
          function e28(i) {
            l3(this, e28);
            var n3 = h3(this, r3.call(this, i));
            return n3.type = c3.NESTING, n3.value = "&", n3;
          }
          return e28;
        }(s3.default);
        t3.default = p3, a3.exports = t3.default;
      } }), Us2 = O3({ "node_modules/postcss-selector-parser/dist/sortAscending.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = o3;
        function o3(s3) {
          return s3.sort(function(c3, f3) {
            return c3 - f3;
          });
        }
        a3.exports = t3.default;
      } }), Ls2 = O3({ "node_modules/postcss-selector-parser/dist/tokenize.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = ee2;
        var o3 = 39, s3 = 34, c3 = 92, f3 = 47, l3 = 10, h3 = 32, u3 = 12, p3 = 9, r3 = 13, e28 = 43, i = 62, n3 = 126, m3 = 124, d3 = 44, g3 = 40, y3 = 41, v3 = 91, b3 = 93, w3 = 59, _3 = 42, R3 = 58, D3 = 38, U3 = 64, X3 = /[ \n\t\r\{\(\)'"\\;/]/g, Y3 = /[ \n\t\r\(\)\*:;@!&'"\+\|~>,\[\]\\]|\/(?=\*)/g;
        function ee2(V10) {
          for (var Z3 = [], z3 = V10.css.valueOf(), P3 = void 0, $3 = void 0, E3 = void 0, ve2 = void 0, ue2 = void 0, fe2 = void 0, ae2 = void 0, ie2 = void 0, G3 = void 0, oe2 = void 0, K3 = void 0, te2 = z3.length, k3 = -1, A3 = 1, C3 = 0, W3 = function(x3, J3) {
            if (V10.safe)
              z3 += J3, $3 = z3.length - 1;
            else
              throw V10.error("Unclosed " + x3, A3, C3 - k3, C3);
          }; C3 < te2; ) {
            switch (P3 = z3.charCodeAt(C3), P3 === l3 && (k3 = C3, A3 += 1), P3) {
              case l3:
              case h3:
              case p3:
              case r3:
              case u3:
                $3 = C3;
                do
                  $3 += 1, P3 = z3.charCodeAt($3), P3 === l3 && (k3 = $3, A3 += 1);
                while (P3 === h3 || P3 === l3 || P3 === p3 || P3 === r3 || P3 === u3);
                Z3.push(["space", z3.slice(C3, $3), A3, C3 - k3, C3]), C3 = $3 - 1;
                break;
              case e28:
              case i:
              case n3:
              case m3:
                $3 = C3;
                do
                  $3 += 1, P3 = z3.charCodeAt($3);
                while (P3 === e28 || P3 === i || P3 === n3 || P3 === m3);
                Z3.push(["combinator", z3.slice(C3, $3), A3, C3 - k3, C3]), C3 = $3 - 1;
                break;
              case _3:
                Z3.push(["*", "*", A3, C3 - k3, C3]);
                break;
              case D3:
                Z3.push(["&", "&", A3, C3 - k3, C3]);
                break;
              case d3:
                Z3.push([",", ",", A3, C3 - k3, C3]);
                break;
              case v3:
                Z3.push(["[", "[", A3, C3 - k3, C3]);
                break;
              case b3:
                Z3.push(["]", "]", A3, C3 - k3, C3]);
                break;
              case R3:
                Z3.push([":", ":", A3, C3 - k3, C3]);
                break;
              case w3:
                Z3.push([";", ";", A3, C3 - k3, C3]);
                break;
              case g3:
                Z3.push(["(", "(", A3, C3 - k3, C3]);
                break;
              case y3:
                Z3.push([")", ")", A3, C3 - k3, C3]);
                break;
              case o3:
              case s3:
                E3 = P3 === o3 ? "'" : '"', $3 = C3;
                do
                  for (oe2 = false, $3 = z3.indexOf(E3, $3 + 1), $3 === -1 && W3("quote", E3), K3 = $3; z3.charCodeAt(K3 - 1) === c3; )
                    K3 -= 1, oe2 = !oe2;
                while (oe2);
                Z3.push(["string", z3.slice(C3, $3 + 1), A3, C3 - k3, A3, $3 - k3, C3]), C3 = $3;
                break;
              case U3:
                X3.lastIndex = C3 + 1, X3.test(z3), X3.lastIndex === 0 ? $3 = z3.length - 1 : $3 = X3.lastIndex - 2, Z3.push(["at-word", z3.slice(C3, $3 + 1), A3, C3 - k3, A3, $3 - k3, C3]), C3 = $3;
                break;
              case c3:
                for ($3 = C3, ae2 = true; z3.charCodeAt($3 + 1) === c3; )
                  $3 += 1, ae2 = !ae2;
                P3 = z3.charCodeAt($3 + 1), ae2 && P3 !== f3 && P3 !== h3 && P3 !== l3 && P3 !== p3 && P3 !== r3 && P3 !== u3 && ($3 += 1), Z3.push(["word", z3.slice(C3, $3 + 1), A3, C3 - k3, A3, $3 - k3, C3]), C3 = $3;
                break;
              default:
                P3 === f3 && z3.charCodeAt(C3 + 1) === _3 ? ($3 = z3.indexOf("*/", C3 + 2) + 1, $3 === 0 && W3("comment", "*/"), fe2 = z3.slice(C3, $3 + 1), ve2 = fe2.split(`
`), ue2 = ve2.length - 1, ue2 > 0 ? (ie2 = A3 + ue2, G3 = $3 - ve2[ue2].length) : (ie2 = A3, G3 = k3), Z3.push(["comment", fe2, A3, C3 - k3, ie2, $3 - G3, C3]), k3 = G3, A3 = ie2, C3 = $3) : (Y3.lastIndex = C3 + 1, Y3.test(z3), Y3.lastIndex === 0 ? $3 = z3.length - 1 : $3 = Y3.lastIndex - 2, Z3.push(["word", z3.slice(C3, $3 + 1), A3, C3 - k3, A3, $3 - k3, C3]), C3 = $3);
                break;
            }
            C3++;
          }
          return Z3;
        }
        a3.exports = t3.default;
      } }), Bs2 = O3({ "node_modules/postcss-selector-parser/dist/parser.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = function() {
          function k3(A3, C3) {
            for (var W3 = 0; W3 < C3.length; W3++) {
              var x3 = C3[W3];
              x3.enumerable = x3.enumerable || false, x3.configurable = true, "value" in x3 && (x3.writable = true), Object.defineProperty(A3, x3.key, x3);
            }
          }
          return function(A3, C3, W3) {
            return C3 && k3(A3.prototype, C3), W3 && k3(A3, W3), A3;
          };
        }(), s3 = gn2(), c3 = oe2(s3), f3 = bn2(), l3 = oe2(f3), h3 = wn2(), u3 = oe2(h3), p3 = xn2(), r3 = oe2(p3), e28 = kn2(), i = oe2(e28), n3 = _n2(), m3 = oe2(n3), d3 = On2(), g3 = oe2(d3), y3 = Tn2(), v3 = oe2(y3), b3 = jn2(), w3 = oe2(b3), _3 = An2(), R3 = oe2(_3), D3 = Sn2(), U3 = oe2(D3), X3 = Cn2(), Y3 = oe2(X3), ee2 = En2(), V10 = oe2(ee2), Z3 = Mn2(), z3 = oe2(Z3), P3 = In2(), $3 = oe2(P3), E3 = Us2(), ve2 = oe2(E3), ue2 = Ls2(), fe2 = oe2(ue2), ae2 = _e2(), ie2 = G3(ae2);
        function G3(k3) {
          if (k3 && k3.__esModule)
            return k3;
          var A3 = {};
          if (k3 != null)
            for (var C3 in k3)
              Object.prototype.hasOwnProperty.call(k3, C3) && (A3[C3] = k3[C3]);
          return A3.default = k3, A3;
        }
        function oe2(k3) {
          return k3 && k3.__esModule ? k3 : { default: k3 };
        }
        function K3(k3, A3) {
          if (!(k3 instanceof A3))
            throw new TypeError("Cannot call a class as a function");
        }
        var te2 = function() {
          function k3(A3) {
            K3(this, k3), this.input = A3, this.lossy = A3.options.lossless === false, this.position = 0, this.root = new r3.default();
            var C3 = new i.default();
            return this.root.append(C3), this.current = C3, this.lossy ? this.tokens = (0, fe2.default)({ safe: A3.safe, css: A3.css.trim() }) : this.tokens = (0, fe2.default)(A3), this.loop();
          }
          return k3.prototype.attribute = function() {
            var A3 = "", C3 = void 0, W3 = this.currToken;
            for (this.position++; this.position < this.tokens.length && this.currToken[0] !== "]"; )
              A3 += this.tokens[this.position][1], this.position++;
            this.position === this.tokens.length && !~A3.indexOf("]") && this.error("Expected a closing square bracket.");
            var x3 = A3.split(/((?:[*~^$|]?=))([^]*)/), J3 = x3[0].split(/(\|)/g), L3 = { operator: x3[1], value: x3[2], source: { start: { line: W3[2], column: W3[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: W3[4] };
            if (J3.length > 1 ? (J3[0] === "" && (J3[0] = true), L3.attribute = this.parseValue(J3[2]), L3.namespace = this.parseNamespace(J3[0])) : L3.attribute = this.parseValue(x3[0]), C3 = new Y3.default(L3), x3[2]) {
              var we2 = x3[2].split(/(\s+i\s*?)$/), ye2 = we2[0].trim();
              C3.value = this.lossy ? ye2 : we2[0], we2[1] && (C3.insensitive = true, this.lossy || (C3.raws.insensitive = we2[1])), C3.quoted = ye2[0] === "'" || ye2[0] === '"', C3.raws.unquoted = C3.quoted ? ye2.slice(1, -1) : ye2;
            }
            this.newNode(C3), this.position++;
          }, k3.prototype.combinator = function() {
            if (this.currToken[1] === "|")
              return this.namespace();
            for (var A3 = new z3.default({ value: "", source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] }); this.position < this.tokens.length && this.currToken && (this.currToken[0] === "space" || this.currToken[0] === "combinator"); )
              this.nextToken && this.nextToken[0] === "combinator" ? (A3.spaces.before = this.parseSpace(this.currToken[1]), A3.source.start.line = this.nextToken[2], A3.source.start.column = this.nextToken[3], A3.source.end.column = this.nextToken[3], A3.source.end.line = this.nextToken[2], A3.sourceIndex = this.nextToken[4]) : this.prevToken && this.prevToken[0] === "combinator" ? A3.spaces.after = this.parseSpace(this.currToken[1]) : this.currToken[0] === "combinator" ? A3.value = this.currToken[1] : this.currToken[0] === "space" && (A3.value = this.parseSpace(this.currToken[1], " ")), this.position++;
            return this.newNode(A3);
          }, k3.prototype.comma = function() {
            if (this.position === this.tokens.length - 1) {
              this.root.trailingComma = true, this.position++;
              return;
            }
            var A3 = new i.default();
            this.current.parent.append(A3), this.current = A3, this.position++;
          }, k3.prototype.comment = function() {
            var A3 = new g3.default({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[4], column: this.currToken[5] } }, sourceIndex: this.currToken[6] });
            this.newNode(A3), this.position++;
          }, k3.prototype.error = function(A3) {
            throw new this.input.error(A3);
          }, k3.prototype.missingBackslash = function() {
            return this.error("Expected a backslash preceding the semicolon.");
          }, k3.prototype.missingParenthesis = function() {
            return this.error("Expected opening parenthesis.");
          }, k3.prototype.missingSquareBracket = function() {
            return this.error("Expected opening square bracket.");
          }, k3.prototype.namespace = function() {
            var A3 = this.prevToken && this.prevToken[1] || true;
            if (this.nextToken[0] === "word")
              return this.position++, this.word(A3);
            if (this.nextToken[0] === "*")
              return this.position++, this.universal(A3);
          }, k3.prototype.nesting = function() {
            this.newNode(new $3.default({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] })), this.position++;
          }, k3.prototype.parentheses = function() {
            var A3 = this.current.last;
            if (A3 && A3.type === ie2.PSEUDO) {
              var C3 = new i.default(), W3 = this.current;
              A3.append(C3), this.current = C3;
              var x3 = 1;
              for (this.position++; this.position < this.tokens.length && x3; )
                this.currToken[0] === "(" && x3++, this.currToken[0] === ")" && x3--, x3 ? this.parse() : (C3.parent.source.end.line = this.currToken[2], C3.parent.source.end.column = this.currToken[3], this.position++);
              x3 && this.error("Expected closing parenthesis."), this.current = W3;
            } else {
              var J3 = 1;
              for (this.position++, A3.value += "("; this.position < this.tokens.length && J3; )
                this.currToken[0] === "(" && J3++, this.currToken[0] === ")" && J3--, A3.value += this.parseParenthesisToken(this.currToken), this.position++;
              J3 && this.error("Expected closing parenthesis.");
            }
          }, k3.prototype.pseudo = function() {
            for (var A3 = this, C3 = "", W3 = this.currToken; this.currToken && this.currToken[0] === ":"; )
              C3 += this.currToken[1], this.position++;
            if (!this.currToken)
              return this.error("Expected pseudo-class or pseudo-element");
            if (this.currToken[0] === "word") {
              var x3 = void 0;
              this.splitWord(false, function(J3, L3) {
                C3 += J3, x3 = new U3.default({ value: C3, source: { start: { line: W3[2], column: W3[3] }, end: { line: A3.currToken[4], column: A3.currToken[5] } }, sourceIndex: W3[4] }), A3.newNode(x3), L3 > 1 && A3.nextToken && A3.nextToken[0] === "(" && A3.error("Misplaced parenthesis.");
              });
            } else
              this.error('Unexpected "' + this.currToken[0] + '" found.');
          }, k3.prototype.space = function() {
            var A3 = this.currToken;
            this.position === 0 || this.prevToken[0] === "," || this.prevToken[0] === "(" ? (this.spaces = this.parseSpace(A3[1]), this.position++) : this.position === this.tokens.length - 1 || this.nextToken[0] === "," || this.nextToken[0] === ")" ? (this.current.last.spaces.after = this.parseSpace(A3[1]), this.position++) : this.combinator();
          }, k3.prototype.string = function() {
            var A3 = this.currToken;
            this.newNode(new R3.default({ value: this.currToken[1], source: { start: { line: A3[2], column: A3[3] }, end: { line: A3[4], column: A3[5] } }, sourceIndex: A3[6] })), this.position++;
          }, k3.prototype.universal = function(A3) {
            var C3 = this.nextToken;
            if (C3 && C3[1] === "|")
              return this.position++, this.namespace();
            this.newNode(new V10.default({ value: this.currToken[1], source: { start: { line: this.currToken[2], column: this.currToken[3] }, end: { line: this.currToken[2], column: this.currToken[3] } }, sourceIndex: this.currToken[4] }), A3), this.position++;
          }, k3.prototype.splitWord = function(A3, C3) {
            for (var W3 = this, x3 = this.nextToken, J3 = this.currToken[1]; x3 && x3[0] === "word"; ) {
              this.position++;
              var L3 = this.currToken[1];
              if (J3 += L3, L3.lastIndexOf("\\") === L3.length - 1) {
                var we2 = this.nextToken;
                we2 && we2[0] === "space" && (J3 += this.parseSpace(we2[1], " "), this.position++);
              }
              x3 = this.nextToken;
            }
            var ye2 = (0, l3.default)(J3, "."), Oe2 = (0, l3.default)(J3, "#"), Ee2 = (0, l3.default)(J3, "#{");
            Ee2.length && (Oe2 = Oe2.filter(function(ge2) {
              return !~Ee2.indexOf(ge2);
            }));
            var ke2 = (0, ve2.default)((0, u3.default)((0, c3.default)([[0], ye2, Oe2])));
            ke2.forEach(function(ge2, Ae2) {
              var xe2 = ke2[Ae2 + 1] || J3.length, be2 = J3.slice(ge2, xe2);
              if (Ae2 === 0 && C3)
                return C3.call(W3, be2, ke2.length);
              var Te2 = void 0;
              ~ye2.indexOf(ge2) ? Te2 = new m3.default({ value: be2.slice(1), source: { start: { line: W3.currToken[2], column: W3.currToken[3] + ge2 }, end: { line: W3.currToken[4], column: W3.currToken[3] + (xe2 - 1) } }, sourceIndex: W3.currToken[6] + ke2[Ae2] }) : ~Oe2.indexOf(ge2) ? Te2 = new v3.default({ value: be2.slice(1), source: { start: { line: W3.currToken[2], column: W3.currToken[3] + ge2 }, end: { line: W3.currToken[4], column: W3.currToken[3] + (xe2 - 1) } }, sourceIndex: W3.currToken[6] + ke2[Ae2] }) : Te2 = new w3.default({ value: be2, source: { start: { line: W3.currToken[2], column: W3.currToken[3] + ge2 }, end: { line: W3.currToken[4], column: W3.currToken[3] + (xe2 - 1) } }, sourceIndex: W3.currToken[6] + ke2[Ae2] }), W3.newNode(Te2, A3);
            }), this.position++;
          }, k3.prototype.word = function(A3) {
            var C3 = this.nextToken;
            return C3 && C3[1] === "|" ? (this.position++, this.namespace()) : this.splitWord(A3);
          }, k3.prototype.loop = function() {
            for (; this.position < this.tokens.length; )
              this.parse(true);
            return this.root;
          }, k3.prototype.parse = function(A3) {
            switch (this.currToken[0]) {
              case "space":
                this.space();
                break;
              case "comment":
                this.comment();
                break;
              case "(":
                this.parentheses();
                break;
              case ")":
                A3 && this.missingParenthesis();
                break;
              case "[":
                this.attribute();
                break;
              case "]":
                this.missingSquareBracket();
                break;
              case "at-word":
              case "word":
                this.word();
                break;
              case ":":
                this.pseudo();
                break;
              case ";":
                this.missingBackslash();
                break;
              case ",":
                this.comma();
                break;
              case "*":
                this.universal();
                break;
              case "&":
                this.nesting();
                break;
              case "combinator":
                this.combinator();
                break;
              case "string":
                this.string();
                break;
            }
          }, k3.prototype.parseNamespace = function(A3) {
            if (this.lossy && typeof A3 == "string") {
              var C3 = A3.trim();
              return C3.length ? C3 : true;
            }
            return A3;
          }, k3.prototype.parseSpace = function(A3, C3) {
            return this.lossy ? C3 || "" : A3;
          }, k3.prototype.parseValue = function(A3) {
            return this.lossy && A3 && typeof A3 == "string" ? A3.trim() : A3;
          }, k3.prototype.parseParenthesisToken = function(A3) {
            return this.lossy ? A3[0] === "space" ? this.parseSpace(A3[1], " ") : this.parseValue(A3[1]) : A3[1];
          }, k3.prototype.newNode = function(A3, C3) {
            return C3 && (A3.namespace = this.parseNamespace(C3)), this.spaces && (A3.spaces.before = this.spaces, this.spaces = ""), this.current.append(A3);
          }, o3(k3, [{ key: "currToken", get: function() {
            return this.tokens[this.position];
          } }, { key: "nextToken", get: function() {
            return this.tokens[this.position + 1];
          } }, { key: "prevToken", get: function() {
            return this.tokens[this.position - 1];
          } }]), k3;
        }();
        t3.default = te2, a3.exports = t3.default;
      } }), Gs2 = O3({ "node_modules/postcss-selector-parser/dist/processor.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = function() {
          function u3(p3, r3) {
            for (var e28 = 0; e28 < r3.length; e28++) {
              var i = r3[e28];
              i.enumerable = i.enumerable || false, i.configurable = true, "value" in i && (i.writable = true), Object.defineProperty(p3, i.key, i);
            }
          }
          return function(p3, r3, e28) {
            return r3 && u3(p3.prototype, r3), e28 && u3(p3, e28), p3;
          };
        }(), s3 = Bs2(), c3 = f3(s3);
        function f3(u3) {
          return u3 && u3.__esModule ? u3 : { default: u3 };
        }
        function l3(u3, p3) {
          if (!(u3 instanceof p3))
            throw new TypeError("Cannot call a class as a function");
        }
        var h3 = function() {
          function u3(p3) {
            return l3(this, u3), this.func = p3 || function() {
            }, this;
          }
          return u3.prototype.process = function(p3) {
            var r3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, e28 = new c3.default({ css: p3, error: function(i) {
              throw new Error(i);
            }, options: r3 });
            return this.res = e28, this.func(e28), this;
          }, o3(u3, [{ key: "result", get: function() {
            return String(this.res);
          } }]), u3;
        }();
        t3.default = h3, a3.exports = t3.default;
      } }), qs2 = O3({ "node_modules/postcss-selector-parser/dist/index.js"(t3, a3) {
        T3(), t3.__esModule = true;
        var o3 = Gs2(), s3 = P3(o3), c3 = Cn2(), f3 = P3(c3), l3 = _n2(), h3 = P3(l3), u3 = Mn2(), p3 = P3(u3), r3 = On2(), e28 = P3(r3), i = Tn2(), n3 = P3(i), m3 = In2(), d3 = P3(m3), g3 = Sn2(), y3 = P3(g3), v3 = xn2(), b3 = P3(v3), w3 = kn2(), _3 = P3(w3), R3 = An2(), D3 = P3(R3), U3 = jn2(), X3 = P3(U3), Y3 = En2(), ee2 = P3(Y3), V10 = _e2(), Z3 = z3(V10);
        function z3(E3) {
          if (E3 && E3.__esModule)
            return E3;
          var ve2 = {};
          if (E3 != null)
            for (var ue2 in E3)
              Object.prototype.hasOwnProperty.call(E3, ue2) && (ve2[ue2] = E3[ue2]);
          return ve2.default = E3, ve2;
        }
        function P3(E3) {
          return E3 && E3.__esModule ? E3 : { default: E3 };
        }
        var $3 = function(E3) {
          return new s3.default(E3);
        };
        $3.attribute = function(E3) {
          return new f3.default(E3);
        }, $3.className = function(E3) {
          return new h3.default(E3);
        }, $3.combinator = function(E3) {
          return new p3.default(E3);
        }, $3.comment = function(E3) {
          return new e28.default(E3);
        }, $3.id = function(E3) {
          return new n3.default(E3);
        }, $3.nesting = function(E3) {
          return new d3.default(E3);
        }, $3.pseudo = function(E3) {
          return new y3.default(E3);
        }, $3.root = function(E3) {
          return new b3.default(E3);
        }, $3.selector = function(E3) {
          return new _3.default(E3);
        }, $3.string = function(E3) {
          return new D3.default(E3);
        }, $3.tag = function(E3) {
          return new X3.default(E3);
        }, $3.universal = function(E3) {
          return new ee2.default(E3);
        }, Object.keys(Z3).forEach(function(E3) {
          E3 !== "__esModule" && ($3[E3] = Z3[E3]);
        }), t3.default = $3, a3.exports = t3.default;
      } }), Pn2 = O3({ "node_modules/postcss-media-query-parser/dist/nodes/Node.js"(t3) {
        T3(), Object.defineProperty(t3, "__esModule", { value: true });
        function a3(o3) {
          this.after = o3.after, this.before = o3.before, this.type = o3.type, this.value = o3.value, this.sourceIndex = o3.sourceIndex;
        }
        t3.default = a3;
      } }), Nn2 = O3({ "node_modules/postcss-media-query-parser/dist/nodes/Container.js"(t3) {
        T3(), Object.defineProperty(t3, "__esModule", { value: true });
        var a3 = Pn2(), o3 = s3(a3);
        function s3(f3) {
          return f3 && f3.__esModule ? f3 : { default: f3 };
        }
        function c3(f3) {
          var l3 = this;
          this.constructor(f3), this.nodes = f3.nodes, this.after === void 0 && (this.after = this.nodes.length > 0 ? this.nodes[this.nodes.length - 1].after : ""), this.before === void 0 && (this.before = this.nodes.length > 0 ? this.nodes[0].before : ""), this.sourceIndex === void 0 && (this.sourceIndex = this.before.length), this.nodes.forEach(function(h3) {
            h3.parent = l3;
          });
        }
        c3.prototype = Object.create(o3.default.prototype), c3.constructor = o3.default, c3.prototype.walk = function(f3, l3) {
          for (var h3 = typeof f3 == "string" || f3 instanceof RegExp, u3 = h3 ? l3 : f3, p3 = typeof f3 == "string" ? new RegExp(f3) : f3, r3 = 0; r3 < this.nodes.length; r3++) {
            var e28 = this.nodes[r3], i = h3 ? p3.test(e28.type) : true;
            if (i && u3 && u3(e28, r3, this.nodes) === false || e28.nodes && e28.walk(f3, l3) === false)
              return false;
          }
          return true;
        }, c3.prototype.each = function() {
          for (var f3 = arguments.length <= 0 || arguments[0] === void 0 ? function() {
          } : arguments[0], l3 = 0; l3 < this.nodes.length; l3++) {
            var h3 = this.nodes[l3];
            if (f3(h3, l3, this.nodes) === false)
              return false;
          }
          return true;
        }, t3.default = c3;
      } }), Js2 = O3({ "node_modules/postcss-media-query-parser/dist/parsers.js"(t3) {
        T3(), Object.defineProperty(t3, "__esModule", { value: true }), t3.parseMediaFeature = l3, t3.parseMediaQuery = h3, t3.parseMediaList = u3;
        var a3 = Pn2(), o3 = f3(a3), s3 = Nn2(), c3 = f3(s3);
        function f3(p3) {
          return p3 && p3.__esModule ? p3 : { default: p3 };
        }
        function l3(p3) {
          var r3 = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1], e28 = [{ mode: "normal", character: null }], i = [], n3 = 0, m3 = "", d3 = null, g3 = null, y3 = r3, v3 = p3;
          p3[0] === "(" && p3[p3.length - 1] === ")" && (v3 = p3.substring(1, p3.length - 1), y3++);
          for (var b3 = 0; b3 < v3.length; b3++) {
            var w3 = v3[b3];
            if ((w3 === "'" || w3 === '"') && (e28[n3].isCalculationEnabled === true ? (e28.push({ mode: "string", isCalculationEnabled: false, character: w3 }), n3++) : e28[n3].mode === "string" && e28[n3].character === w3 && v3[b3 - 1] !== "\\" && (e28.pop(), n3--)), w3 === "{" ? (e28.push({ mode: "interpolation", isCalculationEnabled: true }), n3++) : w3 === "}" && (e28.pop(), n3--), e28[n3].mode === "normal" && w3 === ":") {
              var _3 = v3.substring(b3 + 1);
              g3 = { type: "value", before: /^(\s*)/.exec(_3)[1], after: /(\s*)$/.exec(_3)[1], value: _3.trim() }, g3.sourceIndex = g3.before.length + b3 + 1 + y3, d3 = { type: "colon", sourceIndex: b3 + y3, after: g3.before, value: ":" };
              break;
            }
            m3 += w3;
          }
          return m3 = { type: "media-feature", before: /^(\s*)/.exec(m3)[1], after: /(\s*)$/.exec(m3)[1], value: m3.trim() }, m3.sourceIndex = m3.before.length + y3, i.push(m3), d3 !== null && (d3.before = m3.after, i.push(d3)), g3 !== null && i.push(g3), i;
        }
        function h3(p3) {
          var r3 = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1], e28 = [], i = 0, n3 = false, m3 = void 0;
          function d3() {
            return { before: "", after: "", value: "" };
          }
          m3 = d3();
          for (var g3 = 0; g3 < p3.length; g3++) {
            var y3 = p3[g3];
            n3 ? (m3.value += y3, (y3 === "{" || y3 === "(") && i++, (y3 === ")" || y3 === "}") && i--) : y3.search(/\s/) !== -1 ? m3.before += y3 : (y3 === "(" && (m3.type = "media-feature-expression", i++), m3.value = y3, m3.sourceIndex = r3 + g3, n3 = true), n3 && i === 0 && (y3 === ")" || g3 === p3.length - 1 || p3[g3 + 1].search(/\s/) !== -1) && (["not", "only", "and"].indexOf(m3.value) !== -1 && (m3.type = "keyword"), m3.type === "media-feature-expression" && (m3.nodes = l3(m3.value, m3.sourceIndex)), e28.push(Array.isArray(m3.nodes) ? new c3.default(m3) : new o3.default(m3)), m3 = d3(), n3 = false);
          }
          for (var v3 = 0; v3 < e28.length; v3++)
            if (m3 = e28[v3], v3 > 0 && (e28[v3 - 1].after = m3.before), m3.type === void 0) {
              if (v3 > 0) {
                if (e28[v3 - 1].type === "media-feature-expression") {
                  m3.type = "keyword";
                  continue;
                }
                if (e28[v3 - 1].value === "not" || e28[v3 - 1].value === "only") {
                  m3.type = "media-type";
                  continue;
                }
                if (e28[v3 - 1].value === "and") {
                  m3.type = "media-feature-expression";
                  continue;
                }
                e28[v3 - 1].type === "media-type" && (e28[v3 + 1] ? m3.type = e28[v3 + 1].type === "media-feature-expression" ? "keyword" : "media-feature-expression" : m3.type = "media-feature-expression");
              }
              if (v3 === 0) {
                if (!e28[v3 + 1]) {
                  m3.type = "media-type";
                  continue;
                }
                if (e28[v3 + 1] && (e28[v3 + 1].type === "media-feature-expression" || e28[v3 + 1].type === "keyword")) {
                  m3.type = "media-type";
                  continue;
                }
                if (e28[v3 + 2]) {
                  if (e28[v3 + 2].type === "media-feature-expression") {
                    m3.type = "media-type", e28[v3 + 1].type = "keyword";
                    continue;
                  }
                  if (e28[v3 + 2].type === "keyword") {
                    m3.type = "keyword", e28[v3 + 1].type = "media-type";
                    continue;
                  }
                }
                if (e28[v3 + 3] && e28[v3 + 3].type === "media-feature-expression") {
                  m3.type = "keyword", e28[v3 + 1].type = "media-type", e28[v3 + 2].type = "keyword";
                  continue;
                }
              }
            }
          return e28;
        }
        function u3(p3) {
          var r3 = [], e28 = 0, i = 0, n3 = /^(\s*)url\s*\(/.exec(p3);
          if (n3 !== null) {
            for (var m3 = n3[0].length, d3 = 1; d3 > 0; ) {
              var g3 = p3[m3];
              g3 === "(" && d3++, g3 === ")" && d3--, m3++;
            }
            r3.unshift(new o3.default({ type: "url", value: p3.substring(0, m3).trim(), sourceIndex: n3[1].length, before: n3[1], after: /^(\s*)/.exec(p3.substring(m3))[1] })), e28 = m3;
          }
          for (var y3 = e28; y3 < p3.length; y3++) {
            var v3 = p3[y3];
            if (v3 === "(" && i++, v3 === ")" && i--, i === 0 && v3 === ",") {
              var b3 = p3.substring(e28, y3), w3 = /^(\s*)/.exec(b3)[1];
              r3.push(new c3.default({ type: "media-query", value: b3.trim(), sourceIndex: e28 + w3.length, nodes: h3(b3, e28), before: w3, after: /(\s*)$/.exec(b3)[1] })), e28 = y3 + 1;
            }
          }
          var _3 = p3.substring(e28), R3 = /^(\s*)/.exec(_3)[1];
          return r3.push(new c3.default({ type: "media-query", value: _3.trim(), sourceIndex: e28 + R3.length, nodes: h3(_3, e28), before: R3, after: /(\s*)$/.exec(_3)[1] })), r3;
        }
      } }), Hs2 = O3({ "node_modules/postcss-media-query-parser/dist/index.js"(t3) {
        T3(), Object.defineProperty(t3, "__esModule", { value: true }), t3.default = f3;
        var a3 = Nn2(), o3 = c3(a3), s3 = Js2();
        function c3(l3) {
          return l3 && l3.__esModule ? l3 : { default: l3 };
        }
        function f3(l3) {
          return new o3.default({ nodes: (0, s3.parseMediaList)(l3), type: "media-query-list", value: l3.trim() });
        }
      } }), Rn2 = {};
      H3(Rn2, { basename: () => Fn2, default: () => Bn2, delimiter: () => qt2, dirname: () => Wn2, extname: () => Un2, isAbsolute: () => Lt2, join: () => $n2, normalize: () => Ut2, relative: () => Dn2, resolve: () => dt2, sep: () => Gt2 });
      function zn2(t3, a3) {
        for (var o3 = 0, s3 = t3.length - 1; s3 >= 0; s3--) {
          var c3 = t3[s3];
          c3 === "." ? t3.splice(s3, 1) : c3 === ".." ? (t3.splice(s3, 1), o3++) : o3 && (t3.splice(s3, 1), o3--);
        }
        if (a3)
          for (; o3--; o3)
            t3.unshift("..");
        return t3;
      }
      function dt2() {
        for (var t3 = "", a3 = false, o3 = arguments.length - 1; o3 >= -1 && !a3; o3--) {
          var s3 = o3 >= 0 ? arguments[o3] : "/";
          if (typeof s3 != "string")
            throw new TypeError("Arguments to path.resolve must be strings");
          s3 && (t3 = s3 + "/" + t3, a3 = s3.charAt(0) === "/");
        }
        return t3 = zn2(Bt2(t3.split("/"), function(c3) {
          return !!c3;
        }), !a3).join("/"), (a3 ? "/" : "") + t3 || ".";
      }
      function Ut2(t3) {
        var a3 = Lt2(t3), o3 = Gn2(t3, -1) === "/";
        return t3 = zn2(Bt2(t3.split("/"), function(s3) {
          return !!s3;
        }), !a3).join("/"), !t3 && !a3 && (t3 = "."), t3 && o3 && (t3 += "/"), (a3 ? "/" : "") + t3;
      }
      function Lt2(t3) {
        return t3.charAt(0) === "/";
      }
      function $n2() {
        var t3 = Array.prototype.slice.call(arguments, 0);
        return Ut2(Bt2(t3, function(a3, o3) {
          if (typeof a3 != "string")
            throw new TypeError("Arguments to path.join must be strings");
          return a3;
        }).join("/"));
      }
      function Dn2(t3, a3) {
        t3 = dt2(t3).substr(1), a3 = dt2(a3).substr(1);
        function o3(p3) {
          for (var r3 = 0; r3 < p3.length && p3[r3] === ""; r3++)
            ;
          for (var e28 = p3.length - 1; e28 >= 0 && p3[e28] === ""; e28--)
            ;
          return r3 > e28 ? [] : p3.slice(r3, e28 - r3 + 1);
        }
        for (var s3 = o3(t3.split("/")), c3 = o3(a3.split("/")), f3 = Math.min(s3.length, c3.length), l3 = f3, h3 = 0; h3 < f3; h3++)
          if (s3[h3] !== c3[h3]) {
            l3 = h3;
            break;
          }
        for (var u3 = [], h3 = l3; h3 < s3.length; h3++)
          u3.push("..");
        return u3 = u3.concat(c3.slice(l3)), u3.join("/");
      }
      function Wn2(t3) {
        var a3 = mt2(t3), o3 = a3[0], s3 = a3[1];
        return !o3 && !s3 ? "." : (s3 && (s3 = s3.substr(0, s3.length - 1)), o3 + s3);
      }
      function Fn2(t3, a3) {
        var o3 = mt2(t3)[2];
        return a3 && o3.substr(-1 * a3.length) === a3 && (o3 = o3.substr(0, o3.length - a3.length)), o3;
      }
      function Un2(t3) {
        return mt2(t3)[3];
      }
      function Bt2(t3, a3) {
        if (t3.filter)
          return t3.filter(a3);
        for (var o3 = [], s3 = 0; s3 < t3.length; s3++)
          a3(t3[s3], s3, t3) && o3.push(t3[s3]);
        return o3;
      }
      var Ln2, mt2, Gt2, qt2, Bn2, Gn2, Qs2 = F3({ "node-modules-polyfills:path"() {
        T3(), Ln2 = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/, mt2 = function(t3) {
          return Ln2.exec(t3).slice(1);
        }, Gt2 = "/", qt2 = ":", Bn2 = { extname: Un2, basename: Fn2, dirname: Wn2, sep: Gt2, delimiter: qt2, relative: Dn2, join: $n2, isAbsolute: Lt2, normalize: Ut2, resolve: dt2 }, Gn2 = "ab".substr(-1) === "b" ? function(t3, a3, o3) {
          return t3.substr(a3, o3);
        } : function(t3, a3, o3) {
          return a3 < 0 && (a3 = t3.length + a3), t3.substr(a3, o3);
        };
      } }), Vs2 = O3({ "node-modules-polyfills-commonjs:path"(t3, a3) {
        T3();
        var o3 = (Qs2(), re2(Rn2));
        if (o3 && o3.default) {
          a3.exports = o3.default;
          for (let s3 in o3)
            a3.exports[s3] = o3[s3];
        } else
          o3 && (a3.exports = o3);
      } }), Ys2 = O3({ "node_modules/picocolors/picocolors.browser.js"(t3, a3) {
        T3();
        var o3 = String, s3 = function() {
          return { isColorSupported: false, reset: o3, bold: o3, dim: o3, italic: o3, underline: o3, inverse: o3, hidden: o3, strikethrough: o3, black: o3, red: o3, green: o3, yellow: o3, blue: o3, magenta: o3, cyan: o3, white: o3, gray: o3, bgBlack: o3, bgRed: o3, bgGreen: o3, bgYellow: o3, bgBlue: o3, bgMagenta: o3, bgCyan: o3, bgWhite: o3 };
        };
        a3.exports = s3(), a3.exports.createColors = s3;
      } }), Xs2 = O3({ "(disabled):node_modules/postcss/lib/terminal-highlight"() {
        T3();
      } }), qn2 = O3({ "node_modules/postcss/lib/css-syntax-error.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = c3(Ys2()), s3 = c3(Xs2());
        function c3(d3) {
          return d3 && d3.__esModule ? d3 : { default: d3 };
        }
        function f3(d3) {
          if (d3 === void 0)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return d3;
        }
        function l3(d3, g3) {
          d3.prototype = Object.create(g3.prototype), d3.prototype.constructor = d3, d3.__proto__ = g3;
        }
        function h3(d3) {
          var g3 = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
          return h3 = function(y3) {
            if (y3 === null || !r3(y3))
              return y3;
            if (typeof y3 != "function")
              throw new TypeError("Super expression must either be null or a function");
            if (typeof g3 < "u") {
              if (g3.has(y3))
                return g3.get(y3);
              g3.set(y3, v3);
            }
            function v3() {
              return u3(y3, arguments, i(this).constructor);
            }
            return v3.prototype = Object.create(y3.prototype, { constructor: { value: v3, enumerable: false, writable: true, configurable: true } }), e28(v3, y3);
          }, h3(d3);
        }
        function u3(d3, g3, y3) {
          return p3() ? u3 = Reflect.construct : u3 = function(v3, b3, w3) {
            var _3 = [null];
            _3.push.apply(_3, b3);
            var R3 = Function.bind.apply(v3, _3), D3 = new R3();
            return w3 && e28(D3, w3.prototype), D3;
          }, u3.apply(null, arguments);
        }
        function p3() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
            return false;
          if (typeof Proxy == "function")
            return true;
          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
            })), true;
          } catch {
            return false;
          }
        }
        function r3(d3) {
          return Function.toString.call(d3).indexOf("[native code]") !== -1;
        }
        function e28(d3, g3) {
          return e28 = Object.setPrototypeOf || function(y3, v3) {
            return y3.__proto__ = v3, y3;
          }, e28(d3, g3);
        }
        function i(d3) {
          return i = Object.setPrototypeOf ? Object.getPrototypeOf : function(g3) {
            return g3.__proto__ || Object.getPrototypeOf(g3);
          }, i(d3);
        }
        var n3 = function(d3) {
          l3(g3, d3);
          function g3(v3, b3, w3, _3, R3, D3) {
            var U3;
            return U3 = d3.call(this, v3) || this, U3.name = "CssSyntaxError", U3.reason = v3, R3 && (U3.file = R3), _3 && (U3.source = _3), D3 && (U3.plugin = D3), typeof b3 < "u" && typeof w3 < "u" && (U3.line = b3, U3.column = w3), U3.setMessage(), Error.captureStackTrace && Error.captureStackTrace(f3(U3), g3), U3;
          }
          var y3 = g3.prototype;
          return y3.setMessage = function() {
            this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
          }, y3.showSourceCode = function(v3) {
            var b3 = this;
            if (!this.source)
              return "";
            var w3 = this.source;
            s3.default && (typeof v3 > "u" && (v3 = o3.default.isColorSupported), v3 && (w3 = (0, s3.default)(w3)));
            var _3 = w3.split(/\r?\n/), R3 = Math.max(this.line - 3, 0), D3 = Math.min(this.line + 2, _3.length), U3 = String(D3).length;
            function X3(ee2) {
              return v3 && o3.default.red ? o3.default.red(o3.default.bold(ee2)) : ee2;
            }
            function Y3(ee2) {
              return v3 && o3.default.gray ? o3.default.gray(ee2) : ee2;
            }
            return _3.slice(R3, D3).map(function(ee2, V10) {
              var Z3 = R3 + 1 + V10, z3 = " " + (" " + Z3).slice(-U3) + " | ";
              if (Z3 === b3.line) {
                var P3 = Y3(z3.replace(/\d/g, " ")) + ee2.slice(0, b3.column - 1).replace(/[^\t]/g, " ");
                return X3(">") + Y3(z3) + ee2 + `
 ` + P3 + X3("^");
              }
              return " " + Y3(z3) + ee2;
            }).join(`
`);
          }, y3.toString = function() {
            var v3 = this.showSourceCode();
            return v3 && (v3 = `

` + v3 + `
`), this.name + ": " + this.message + v3;
          }, g3;
        }(h3(Error)), m3 = n3;
        t3.default = m3, a3.exports = t3.default;
      } }), Zs2 = O3({ "node_modules/postcss/lib/previous-map.js"(t3, a3) {
        T3(), a3.exports = class {
        };
      } }), vt2 = O3({ "node_modules/postcss/lib/input.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = f3(Vs2()), s3 = f3(qn2()), c3 = f3(Zs2());
        function f3(e28) {
          return e28 && e28.__esModule ? e28 : { default: e28 };
        }
        function l3(e28, i) {
          for (var n3 = 0; n3 < i.length; n3++) {
            var m3 = i[n3];
            m3.enumerable = m3.enumerable || false, m3.configurable = true, "value" in m3 && (m3.writable = true), Object.defineProperty(e28, m3.key, m3);
          }
        }
        function h3(e28, i, n3) {
          return i && l3(e28.prototype, i), n3 && l3(e28, n3), e28;
        }
        var u3 = 0, p3 = function() {
          function e28(n3, m3) {
            if (m3 === void 0 && (m3 = {}), n3 === null || typeof n3 > "u" || typeof n3 == "object" && !n3.toString)
              throw new Error("PostCSS received " + n3 + " instead of CSS string");
            this.css = n3.toString(), this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE" ? (this.hasBOM = true, this.css = this.css.slice(1)) : this.hasBOM = false, m3.from && (/^\w+:\/\//.test(m3.from) || o3.default.isAbsolute(m3.from) ? this.file = m3.from : this.file = o3.default.resolve(m3.from));
            var d3 = new c3.default(this.css, m3);
            if (d3.text) {
              this.map = d3;
              var g3 = d3.consumer().file;
              !this.file && g3 && (this.file = this.mapResolve(g3));
            }
            this.file || (u3 += 1, this.id = "<input css " + u3 + ">"), this.map && (this.map.file = this.from);
          }
          var i = e28.prototype;
          return i.error = function(n3, m3, d3, g3) {
            g3 === void 0 && (g3 = {});
            var y3, v3 = this.origin(m3, d3);
            return v3 ? y3 = new s3.default(n3, v3.line, v3.column, v3.source, v3.file, g3.plugin) : y3 = new s3.default(n3, m3, d3, this.css, this.file, g3.plugin), y3.input = { line: m3, column: d3, source: this.css }, this.file && (y3.input.file = this.file), y3;
          }, i.origin = function(n3, m3) {
            if (!this.map)
              return false;
            var d3 = this.map.consumer(), g3 = d3.originalPositionFor({ line: n3, column: m3 });
            if (!g3.source)
              return false;
            var y3 = { file: this.mapResolve(g3.source), line: g3.line, column: g3.column }, v3 = d3.sourceContentFor(g3.source);
            return v3 && (y3.source = v3), y3;
          }, i.mapResolve = function(n3) {
            return /^\w+:\/\//.test(n3) ? n3 : o3.default.resolve(this.map.consumer().sourceRoot || ".", n3);
          }, h3(e28, [{ key: "from", get: function() {
            return this.file || this.id;
          } }]), e28;
        }(), r3 = p3;
        t3.default = r3, a3.exports = t3.default;
      } }), yt2 = O3({ "node_modules/postcss/lib/stringifier.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = { colon: ": ", indent: "    ", beforeDecl: `
`, beforeRule: `
`, beforeOpen: " ", beforeClose: `
`, beforeComment: `
`, after: `
`, emptyBody: "", commentLeft: " ", commentRight: " ", semicolon: false };
        function s3(l3) {
          return l3[0].toUpperCase() + l3.slice(1);
        }
        var c3 = function() {
          function l3(u3) {
            this.builder = u3;
          }
          var h3 = l3.prototype;
          return h3.stringify = function(u3, p3) {
            this[u3.type](u3, p3);
          }, h3.root = function(u3) {
            this.body(u3), u3.raws.after && this.builder(u3.raws.after);
          }, h3.comment = function(u3) {
            var p3 = this.raw(u3, "left", "commentLeft"), r3 = this.raw(u3, "right", "commentRight");
            this.builder("/*" + p3 + u3.text + r3 + "*/", u3);
          }, h3.decl = function(u3, p3) {
            var r3 = this.raw(u3, "between", "colon"), e28 = u3.prop + r3 + this.rawValue(u3, "value");
            u3.important && (e28 += u3.raws.important || " !important"), p3 && (e28 += ";"), this.builder(e28, u3);
          }, h3.rule = function(u3) {
            this.block(u3, this.rawValue(u3, "selector")), u3.raws.ownSemicolon && this.builder(u3.raws.ownSemicolon, u3, "end");
          }, h3.atrule = function(u3, p3) {
            var r3 = "@" + u3.name, e28 = u3.params ? this.rawValue(u3, "params") : "";
            if (typeof u3.raws.afterName < "u" ? r3 += u3.raws.afterName : e28 && (r3 += " "), u3.nodes)
              this.block(u3, r3 + e28);
            else {
              var i = (u3.raws.between || "") + (p3 ? ";" : "");
              this.builder(r3 + e28 + i, u3);
            }
          }, h3.body = function(u3) {
            for (var p3 = u3.nodes.length - 1; p3 > 0 && u3.nodes[p3].type === "comment"; )
              p3 -= 1;
            for (var r3 = this.raw(u3, "semicolon"), e28 = 0; e28 < u3.nodes.length; e28++) {
              var i = u3.nodes[e28], n3 = this.raw(i, "before");
              n3 && this.builder(n3), this.stringify(i, p3 !== e28 || r3);
            }
          }, h3.block = function(u3, p3) {
            var r3 = this.raw(u3, "between", "beforeOpen");
            this.builder(p3 + r3 + "{", u3, "start");
            var e28;
            u3.nodes && u3.nodes.length ? (this.body(u3), e28 = this.raw(u3, "after")) : e28 = this.raw(u3, "after", "emptyBody"), e28 && this.builder(e28), this.builder("}", u3, "end");
          }, h3.raw = function(u3, p3, r3) {
            var e28;
            if (r3 || (r3 = p3), p3 && (e28 = u3.raws[p3], typeof e28 < "u"))
              return e28;
            var i = u3.parent;
            if (r3 === "before" && (!i || i.type === "root" && i.first === u3))
              return "";
            if (!i)
              return o3[r3];
            var n3 = u3.root();
            if (n3.rawCache || (n3.rawCache = {}), typeof n3.rawCache[r3] < "u")
              return n3.rawCache[r3];
            if (r3 === "before" || r3 === "after")
              return this.beforeAfter(u3, r3);
            var m3 = "raw" + s3(r3);
            return this[m3] ? e28 = this[m3](n3, u3) : n3.walk(function(d3) {
              if (e28 = d3.raws[p3], typeof e28 < "u")
                return false;
            }), typeof e28 > "u" && (e28 = o3[r3]), n3.rawCache[r3] = e28, e28;
          }, h3.rawSemicolon = function(u3) {
            var p3;
            return u3.walk(function(r3) {
              if (r3.nodes && r3.nodes.length && r3.last.type === "decl" && (p3 = r3.raws.semicolon, typeof p3 < "u"))
                return false;
            }), p3;
          }, h3.rawEmptyBody = function(u3) {
            var p3;
            return u3.walk(function(r3) {
              if (r3.nodes && r3.nodes.length === 0 && (p3 = r3.raws.after, typeof p3 < "u"))
                return false;
            }), p3;
          }, h3.rawIndent = function(u3) {
            if (u3.raws.indent)
              return u3.raws.indent;
            var p3;
            return u3.walk(function(r3) {
              var e28 = r3.parent;
              if (e28 && e28 !== u3 && e28.parent && e28.parent === u3 && typeof r3.raws.before < "u") {
                var i = r3.raws.before.split(`
`);
                return p3 = i[i.length - 1], p3 = p3.replace(/[^\s]/g, ""), false;
              }
            }), p3;
          }, h3.rawBeforeComment = function(u3, p3) {
            var r3;
            return u3.walkComments(function(e28) {
              if (typeof e28.raws.before < "u")
                return r3 = e28.raws.before, r3.indexOf(`
`) !== -1 && (r3 = r3.replace(/[^\n]+$/, "")), false;
            }), typeof r3 > "u" ? r3 = this.raw(p3, null, "beforeDecl") : r3 && (r3 = r3.replace(/[^\s]/g, "")), r3;
          }, h3.rawBeforeDecl = function(u3, p3) {
            var r3;
            return u3.walkDecls(function(e28) {
              if (typeof e28.raws.before < "u")
                return r3 = e28.raws.before, r3.indexOf(`
`) !== -1 && (r3 = r3.replace(/[^\n]+$/, "")), false;
            }), typeof r3 > "u" ? r3 = this.raw(p3, null, "beforeRule") : r3 && (r3 = r3.replace(/[^\s]/g, "")), r3;
          }, h3.rawBeforeRule = function(u3) {
            var p3;
            return u3.walk(function(r3) {
              if (r3.nodes && (r3.parent !== u3 || u3.first !== r3) && typeof r3.raws.before < "u")
                return p3 = r3.raws.before, p3.indexOf(`
`) !== -1 && (p3 = p3.replace(/[^\n]+$/, "")), false;
            }), p3 && (p3 = p3.replace(/[^\s]/g, "")), p3;
          }, h3.rawBeforeClose = function(u3) {
            var p3;
            return u3.walk(function(r3) {
              if (r3.nodes && r3.nodes.length > 0 && typeof r3.raws.after < "u")
                return p3 = r3.raws.after, p3.indexOf(`
`) !== -1 && (p3 = p3.replace(/[^\n]+$/, "")), false;
            }), p3 && (p3 = p3.replace(/[^\s]/g, "")), p3;
          }, h3.rawBeforeOpen = function(u3) {
            var p3;
            return u3.walk(function(r3) {
              if (r3.type !== "decl" && (p3 = r3.raws.between, typeof p3 < "u"))
                return false;
            }), p3;
          }, h3.rawColon = function(u3) {
            var p3;
            return u3.walkDecls(function(r3) {
              if (typeof r3.raws.between < "u")
                return p3 = r3.raws.between.replace(/[^\s:]/g, ""), false;
            }), p3;
          }, h3.beforeAfter = function(u3, p3) {
            var r3;
            u3.type === "decl" ? r3 = this.raw(u3, null, "beforeDecl") : u3.type === "comment" ? r3 = this.raw(u3, null, "beforeComment") : p3 === "before" ? r3 = this.raw(u3, null, "beforeRule") : r3 = this.raw(u3, null, "beforeClose");
            for (var e28 = u3.parent, i = 0; e28 && e28.type !== "root"; )
              i += 1, e28 = e28.parent;
            if (r3.indexOf(`
`) !== -1) {
              var n3 = this.raw(u3, null, "indent");
              if (n3.length)
                for (var m3 = 0; m3 < i; m3++)
                  r3 += n3;
            }
            return r3;
          }, h3.rawValue = function(u3, p3) {
            var r3 = u3[p3], e28 = u3.raws[p3];
            return e28 && e28.value === r3 ? e28.raw : r3;
          }, l3;
        }(), f3 = c3;
        t3.default = f3, a3.exports = t3.default;
      } }), Jn2 = O3({ "node_modules/postcss/lib/stringify.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = s3(yt2());
        function s3(l3) {
          return l3 && l3.__esModule ? l3 : { default: l3 };
        }
        function c3(l3, h3) {
          var u3 = new o3.default(h3);
          u3.stringify(l3);
        }
        var f3 = c3;
        t3.default = f3, a3.exports = t3.default;
      } }), Jt2 = O3({ "node_modules/postcss/lib/node.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = f3(qn2()), s3 = f3(yt2()), c3 = f3(Jn2());
        function f3(p3) {
          return p3 && p3.__esModule ? p3 : { default: p3 };
        }
        function l3(p3, r3) {
          var e28 = new p3.constructor();
          for (var i in p3)
            if (p3.hasOwnProperty(i)) {
              var n3 = p3[i], m3 = typeof n3;
              i === "parent" && m3 === "object" ? r3 && (e28[i] = r3) : i === "source" ? e28[i] = n3 : n3 instanceof Array ? e28[i] = n3.map(function(d3) {
                return l3(d3, e28);
              }) : (m3 === "object" && n3 !== null && (n3 = l3(n3)), e28[i] = n3);
            }
          return e28;
        }
        var h3 = function() {
          function p3(e28) {
            e28 === void 0 && (e28 = {}), this.raws = {};
            for (var i in e28)
              this[i] = e28[i];
          }
          var r3 = p3.prototype;
          return r3.error = function(e28, i) {
            if (i === void 0 && (i = {}), this.source) {
              var n3 = this.positionBy(i);
              return this.source.input.error(e28, n3.line, n3.column, i);
            }
            return new o3.default(e28);
          }, r3.warn = function(e28, i, n3) {
            var m3 = { node: this };
            for (var d3 in n3)
              m3[d3] = n3[d3];
            return e28.warn(i, m3);
          }, r3.remove = function() {
            return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
          }, r3.toString = function(e28) {
            e28 === void 0 && (e28 = c3.default), e28.stringify && (e28 = e28.stringify);
            var i = "";
            return e28(this, function(n3) {
              i += n3;
            }), i;
          }, r3.clone = function(e28) {
            e28 === void 0 && (e28 = {});
            var i = l3(this);
            for (var n3 in e28)
              i[n3] = e28[n3];
            return i;
          }, r3.cloneBefore = function(e28) {
            e28 === void 0 && (e28 = {});
            var i = this.clone(e28);
            return this.parent.insertBefore(this, i), i;
          }, r3.cloneAfter = function(e28) {
            e28 === void 0 && (e28 = {});
            var i = this.clone(e28);
            return this.parent.insertAfter(this, i), i;
          }, r3.replaceWith = function() {
            if (this.parent) {
              for (var e28 = arguments.length, i = new Array(e28), n3 = 0; n3 < e28; n3++)
                i[n3] = arguments[n3];
              for (var m3 = 0, d3 = i; m3 < d3.length; m3++) {
                var g3 = d3[m3];
                this.parent.insertBefore(this, g3);
              }
              this.remove();
            }
            return this;
          }, r3.next = function() {
            if (this.parent) {
              var e28 = this.parent.index(this);
              return this.parent.nodes[e28 + 1];
            }
          }, r3.prev = function() {
            if (this.parent) {
              var e28 = this.parent.index(this);
              return this.parent.nodes[e28 - 1];
            }
          }, r3.before = function(e28) {
            return this.parent.insertBefore(this, e28), this;
          }, r3.after = function(e28) {
            return this.parent.insertAfter(this, e28), this;
          }, r3.toJSON = function() {
            var e28 = {};
            for (var i in this)
              if (this.hasOwnProperty(i) && i !== "parent") {
                var n3 = this[i];
                n3 instanceof Array ? e28[i] = n3.map(function(m3) {
                  return typeof m3 == "object" && m3.toJSON ? m3.toJSON() : m3;
                }) : typeof n3 == "object" && n3.toJSON ? e28[i] = n3.toJSON() : e28[i] = n3;
              }
            return e28;
          }, r3.raw = function(e28, i) {
            var n3 = new s3.default();
            return n3.raw(this, e28, i);
          }, r3.root = function() {
            for (var e28 = this; e28.parent; )
              e28 = e28.parent;
            return e28;
          }, r3.cleanRaws = function(e28) {
            delete this.raws.before, delete this.raws.after, e28 || delete this.raws.between;
          }, r3.positionInside = function(e28) {
            for (var i = this.toString(), n3 = this.source.start.column, m3 = this.source.start.line, d3 = 0; d3 < e28; d3++)
              i[d3] === `
` ? (n3 = 1, m3 += 1) : n3 += 1;
            return { line: m3, column: n3 };
          }, r3.positionBy = function(e28) {
            var i = this.source.start;
            if (e28.index)
              i = this.positionInside(e28.index);
            else if (e28.word) {
              var n3 = this.toString().indexOf(e28.word);
              n3 !== -1 && (i = this.positionInside(n3));
            }
            return i;
          }, p3;
        }(), u3 = h3;
        t3.default = u3, a3.exports = t3.default;
      } }), gt2 = O3({ "node_modules/postcss/lib/comment.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = s3(Jt2());
        function s3(h3) {
          return h3 && h3.__esModule ? h3 : { default: h3 };
        }
        function c3(h3, u3) {
          h3.prototype = Object.create(u3.prototype), h3.prototype.constructor = h3, h3.__proto__ = u3;
        }
        var f3 = function(h3) {
          c3(u3, h3);
          function u3(p3) {
            var r3;
            return r3 = h3.call(this, p3) || this, r3.type = "comment", r3;
          }
          return u3;
        }(o3.default), l3 = f3;
        t3.default = l3, a3.exports = t3.default;
      } }), Hn2 = O3({ "node_modules/postcss/lib/declaration.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = s3(Jt2());
        function s3(h3) {
          return h3 && h3.__esModule ? h3 : { default: h3 };
        }
        function c3(h3, u3) {
          h3.prototype = Object.create(u3.prototype), h3.prototype.constructor = h3, h3.__proto__ = u3;
        }
        var f3 = function(h3) {
          c3(u3, h3);
          function u3(p3) {
            var r3;
            return r3 = h3.call(this, p3) || this, r3.type = "decl", r3;
          }
          return u3;
        }(o3.default), l3 = f3;
        t3.default = l3, a3.exports = t3.default;
      } }), Ht2 = O3({ "node_modules/postcss/lib/tokenize.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = X3;
        var o3 = "'".charCodeAt(0), s3 = '"'.charCodeAt(0), c3 = "\\".charCodeAt(0), f3 = "/".charCodeAt(0), l3 = `
`.charCodeAt(0), h3 = " ".charCodeAt(0), u3 = "\f".charCodeAt(0), p3 = "	".charCodeAt(0), r3 = "\r".charCodeAt(0), e28 = "[".charCodeAt(0), i = "]".charCodeAt(0), n3 = "(".charCodeAt(0), m3 = ")".charCodeAt(0), d3 = "{".charCodeAt(0), g3 = "}".charCodeAt(0), y3 = ";".charCodeAt(0), v3 = "*".charCodeAt(0), b3 = ":".charCodeAt(0), w3 = "@".charCodeAt(0), _3 = /[ \n\t\r\f{}()'"\\;/[\]#]/g, R3 = /[ \n\t\r\f(){}:;@!'"\\\][#]|\/(?=\*)/g, D3 = /.[\\/("'\n]/, U3 = /[a-f0-9]/i;
        function X3(Y3, ee2) {
          ee2 === void 0 && (ee2 = {});
          var V10 = Y3.css.valueOf(), Z3 = ee2.ignoreErrors, z3, P3, $3, E3, ve2, ue2, fe2, ae2, ie2, G3, oe2, K3, te2, k3, A3 = V10.length, C3 = -1, W3 = 1, x3 = 0, J3 = [], L3 = [];
          function we2() {
            return x3;
          }
          function ye2(ge2) {
            throw Y3.error("Unclosed " + ge2, W3, x3 - C3);
          }
          function Oe2() {
            return L3.length === 0 && x3 >= A3;
          }
          function Ee2(ge2) {
            if (L3.length)
              return L3.pop();
            if (!(x3 >= A3)) {
              var Ae2 = ge2 ? ge2.ignoreUnclosed : false;
              switch (z3 = V10.charCodeAt(x3), (z3 === l3 || z3 === u3 || z3 === r3 && V10.charCodeAt(x3 + 1) !== l3) && (C3 = x3, W3 += 1), z3) {
                case l3:
                case h3:
                case p3:
                case r3:
                case u3:
                  P3 = x3;
                  do
                    P3 += 1, z3 = V10.charCodeAt(P3), z3 === l3 && (C3 = P3, W3 += 1);
                  while (z3 === h3 || z3 === l3 || z3 === p3 || z3 === r3 || z3 === u3);
                  k3 = ["space", V10.slice(x3, P3)], x3 = P3 - 1;
                  break;
                case e28:
                case i:
                case d3:
                case g3:
                case b3:
                case y3:
                case m3:
                  var xe2 = String.fromCharCode(z3);
                  k3 = [xe2, xe2, W3, x3 - C3];
                  break;
                case n3:
                  if (K3 = J3.length ? J3.pop()[1] : "", te2 = V10.charCodeAt(x3 + 1), K3 === "url" && te2 !== o3 && te2 !== s3 && te2 !== h3 && te2 !== l3 && te2 !== p3 && te2 !== u3 && te2 !== r3) {
                    P3 = x3;
                    do {
                      if (G3 = false, P3 = V10.indexOf(")", P3 + 1), P3 === -1)
                        if (Z3 || Ae2) {
                          P3 = x3;
                          break;
                        } else
                          ye2("bracket");
                      for (oe2 = P3; V10.charCodeAt(oe2 - 1) === c3; )
                        oe2 -= 1, G3 = !G3;
                    } while (G3);
                    k3 = ["brackets", V10.slice(x3, P3 + 1), W3, x3 - C3, W3, P3 - C3], x3 = P3;
                  } else
                    P3 = V10.indexOf(")", x3 + 1), ue2 = V10.slice(x3, P3 + 1), P3 === -1 || D3.test(ue2) ? k3 = ["(", "(", W3, x3 - C3] : (k3 = ["brackets", ue2, W3, x3 - C3, W3, P3 - C3], x3 = P3);
                  break;
                case o3:
                case s3:
                  $3 = z3 === o3 ? "'" : '"', P3 = x3;
                  do {
                    if (G3 = false, P3 = V10.indexOf($3, P3 + 1), P3 === -1)
                      if (Z3 || Ae2) {
                        P3 = x3 + 1;
                        break;
                      } else
                        ye2("string");
                    for (oe2 = P3; V10.charCodeAt(oe2 - 1) === c3; )
                      oe2 -= 1, G3 = !G3;
                  } while (G3);
                  ue2 = V10.slice(x3, P3 + 1), E3 = ue2.split(`
`), ve2 = E3.length - 1, ve2 > 0 ? (ae2 = W3 + ve2, ie2 = P3 - E3[ve2].length) : (ae2 = W3, ie2 = C3), k3 = ["string", V10.slice(x3, P3 + 1), W3, x3 - C3, ae2, P3 - ie2], C3 = ie2, W3 = ae2, x3 = P3;
                  break;
                case w3:
                  _3.lastIndex = x3 + 1, _3.test(V10), _3.lastIndex === 0 ? P3 = V10.length - 1 : P3 = _3.lastIndex - 2, k3 = ["at-word", V10.slice(x3, P3 + 1), W3, x3 - C3, W3, P3 - C3], x3 = P3;
                  break;
                case c3:
                  for (P3 = x3, fe2 = true; V10.charCodeAt(P3 + 1) === c3; )
                    P3 += 1, fe2 = !fe2;
                  if (z3 = V10.charCodeAt(P3 + 1), fe2 && z3 !== f3 && z3 !== h3 && z3 !== l3 && z3 !== p3 && z3 !== r3 && z3 !== u3 && (P3 += 1, U3.test(V10.charAt(P3)))) {
                    for (; U3.test(V10.charAt(P3 + 1)); )
                      P3 += 1;
                    V10.charCodeAt(P3 + 1) === h3 && (P3 += 1);
                  }
                  k3 = ["word", V10.slice(x3, P3 + 1), W3, x3 - C3, W3, P3 - C3], x3 = P3;
                  break;
                default:
                  z3 === f3 && V10.charCodeAt(x3 + 1) === v3 ? (P3 = V10.indexOf("*/", x3 + 2) + 1, P3 === 0 && (Z3 || Ae2 ? P3 = V10.length : ye2("comment")), ue2 = V10.slice(x3, P3 + 1), E3 = ue2.split(`
`), ve2 = E3.length - 1, ve2 > 0 ? (ae2 = W3 + ve2, ie2 = P3 - E3[ve2].length) : (ae2 = W3, ie2 = C3), k3 = ["comment", ue2, W3, x3 - C3, ae2, P3 - ie2], C3 = ie2, W3 = ae2, x3 = P3) : (R3.lastIndex = x3 + 1, R3.test(V10), R3.lastIndex === 0 ? P3 = V10.length - 1 : P3 = R3.lastIndex - 2, k3 = ["word", V10.slice(x3, P3 + 1), W3, x3 - C3, W3, P3 - C3], J3.push(k3), x3 = P3);
                  break;
              }
              return x3++, k3;
            }
          }
          function ke2(ge2) {
            L3.push(ge2);
          }
          return { back: ke2, nextToken: Ee2, endOfFile: Oe2, position: we2 };
        }
        a3.exports = t3.default;
      } }), Qn2 = O3({ "node_modules/postcss/lib/parse.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = c3(Qt2()), s3 = c3(vt2());
        function c3(h3) {
          return h3 && h3.__esModule ? h3 : { default: h3 };
        }
        function f3(h3, u3) {
          var p3 = new s3.default(h3, u3), r3 = new o3.default(p3);
          try {
            r3.parse();
          } catch (e28) {
            throw e28;
          }
          return r3.root;
        }
        var l3 = f3;
        t3.default = l3, a3.exports = t3.default;
      } }), Ks2 = O3({ "node_modules/postcss/lib/list.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = { split: function(c3, f3, l3) {
          for (var h3 = [], u3 = "", p3 = false, r3 = 0, e28 = false, i = false, n3 = 0; n3 < c3.length; n3++) {
            var m3 = c3[n3];
            e28 ? i ? i = false : m3 === "\\" ? i = true : m3 === e28 && (e28 = false) : m3 === '"' || m3 === "'" ? e28 = m3 : m3 === "(" ? r3 += 1 : m3 === ")" ? r3 > 0 && (r3 -= 1) : r3 === 0 && f3.indexOf(m3) !== -1 && (p3 = true), p3 ? (u3 !== "" && h3.push(u3.trim()), u3 = "", p3 = false) : u3 += m3;
          }
          return (l3 || u3 !== "") && h3.push(u3.trim()), h3;
        }, space: function(c3) {
          var f3 = [" ", `
`, "	"];
          return o3.split(c3, f3);
        }, comma: function(c3) {
          return o3.split(c3, [","], true);
        } }, s3 = o3;
        t3.default = s3, a3.exports = t3.default;
      } }), Vn2 = O3({ "node_modules/postcss/lib/rule.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = c3(bt2()), s3 = c3(Ks2());
        function c3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        function f3(r3, e28) {
          for (var i = 0; i < e28.length; i++) {
            var n3 = e28[i];
            n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(r3, n3.key, n3);
          }
        }
        function l3(r3, e28, i) {
          return e28 && f3(r3.prototype, e28), i && f3(r3, i), r3;
        }
        function h3(r3, e28) {
          r3.prototype = Object.create(e28.prototype), r3.prototype.constructor = r3, r3.__proto__ = e28;
        }
        var u3 = function(r3) {
          h3(e28, r3);
          function e28(i) {
            var n3;
            return n3 = r3.call(this, i) || this, n3.type = "rule", n3.nodes || (n3.nodes = []), n3;
          }
          return l3(e28, [{ key: "selectors", get: function() {
            return s3.default.comma(this.selector);
          }, set: function(i) {
            var n3 = this.selector ? this.selector.match(/,\s*/) : null, m3 = n3 ? n3[0] : "," + this.raw("between", "beforeOpen");
            this.selector = i.join(m3);
          } }]), e28;
        }(o3.default), p3 = u3;
        t3.default = p3, a3.exports = t3.default;
      } }), bt2 = O3({ "node_modules/postcss/lib/container.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = f3(Hn2()), s3 = f3(gt2()), c3 = f3(Jt2());
        function f3(d3) {
          return d3 && d3.__esModule ? d3 : { default: d3 };
        }
        function l3(d3, g3) {
          var y3;
          if (typeof Symbol > "u" || d3[Symbol.iterator] == null) {
            if (Array.isArray(d3) || (y3 = h3(d3)) || g3 && d3 && typeof d3.length == "number") {
              y3 && (d3 = y3);
              var v3 = 0;
              return function() {
                return v3 >= d3.length ? { done: true } : { done: false, value: d3[v3++] };
              };
            }
            throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          return y3 = d3[Symbol.iterator](), y3.next.bind(y3);
        }
        function h3(d3, g3) {
          if (d3) {
            if (typeof d3 == "string")
              return u3(d3, g3);
            var y3 = Object.prototype.toString.call(d3).slice(8, -1);
            if (y3 === "Object" && d3.constructor && (y3 = d3.constructor.name), y3 === "Map" || y3 === "Set")
              return Array.from(d3);
            if (y3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(y3))
              return u3(d3, g3);
          }
        }
        function u3(d3, g3) {
          (g3 == null || g3 > d3.length) && (g3 = d3.length);
          for (var y3 = 0, v3 = new Array(g3); y3 < g3; y3++)
            v3[y3] = d3[y3];
          return v3;
        }
        function p3(d3, g3) {
          for (var y3 = 0; y3 < g3.length; y3++) {
            var v3 = g3[y3];
            v3.enumerable = v3.enumerable || false, v3.configurable = true, "value" in v3 && (v3.writable = true), Object.defineProperty(d3, v3.key, v3);
          }
        }
        function r3(d3, g3, y3) {
          return g3 && p3(d3.prototype, g3), y3 && p3(d3, y3), d3;
        }
        function e28(d3, g3) {
          d3.prototype = Object.create(g3.prototype), d3.prototype.constructor = d3, d3.__proto__ = g3;
        }
        function i(d3) {
          return d3.map(function(g3) {
            return g3.nodes && (g3.nodes = i(g3.nodes)), delete g3.source, g3;
          });
        }
        var n3 = function(d3) {
          e28(g3, d3);
          function g3() {
            return d3.apply(this, arguments) || this;
          }
          var y3 = g3.prototype;
          return y3.push = function(v3) {
            return v3.parent = this, this.nodes.push(v3), this;
          }, y3.each = function(v3) {
            this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
            var b3 = this.lastEach;
            if (this.indexes[b3] = 0, !!this.nodes) {
              for (var w3, _3; this.indexes[b3] < this.nodes.length && (w3 = this.indexes[b3], _3 = v3(this.nodes[w3], w3), _3 !== false); )
                this.indexes[b3] += 1;
              return delete this.indexes[b3], _3;
            }
          }, y3.walk = function(v3) {
            return this.each(function(b3, w3) {
              var _3;
              try {
                _3 = v3(b3, w3);
              } catch (D3) {
                if (D3.postcssNode = b3, D3.stack && b3.source && /\n\s{4}at /.test(D3.stack)) {
                  var R3 = b3.source;
                  D3.stack = D3.stack.replace(/\n\s{4}at /, "$&" + R3.input.from + ":" + R3.start.line + ":" + R3.start.column + "$&");
                }
                throw D3;
              }
              return _3 !== false && b3.walk && (_3 = b3.walk(v3)), _3;
            });
          }, y3.walkDecls = function(v3, b3) {
            return b3 ? v3 instanceof RegExp ? this.walk(function(w3, _3) {
              if (w3.type === "decl" && v3.test(w3.prop))
                return b3(w3, _3);
            }) : this.walk(function(w3, _3) {
              if (w3.type === "decl" && w3.prop === v3)
                return b3(w3, _3);
            }) : (b3 = v3, this.walk(function(w3, _3) {
              if (w3.type === "decl")
                return b3(w3, _3);
            }));
          }, y3.walkRules = function(v3, b3) {
            return b3 ? v3 instanceof RegExp ? this.walk(function(w3, _3) {
              if (w3.type === "rule" && v3.test(w3.selector))
                return b3(w3, _3);
            }) : this.walk(function(w3, _3) {
              if (w3.type === "rule" && w3.selector === v3)
                return b3(w3, _3);
            }) : (b3 = v3, this.walk(function(w3, _3) {
              if (w3.type === "rule")
                return b3(w3, _3);
            }));
          }, y3.walkAtRules = function(v3, b3) {
            return b3 ? v3 instanceof RegExp ? this.walk(function(w3, _3) {
              if (w3.type === "atrule" && v3.test(w3.name))
                return b3(w3, _3);
            }) : this.walk(function(w3, _3) {
              if (w3.type === "atrule" && w3.name === v3)
                return b3(w3, _3);
            }) : (b3 = v3, this.walk(function(w3, _3) {
              if (w3.type === "atrule")
                return b3(w3, _3);
            }));
          }, y3.walkComments = function(v3) {
            return this.walk(function(b3, w3) {
              if (b3.type === "comment")
                return v3(b3, w3);
            });
          }, y3.append = function() {
            for (var v3 = arguments.length, b3 = new Array(v3), w3 = 0; w3 < v3; w3++)
              b3[w3] = arguments[w3];
            for (var _3 = 0, R3 = b3; _3 < R3.length; _3++)
              for (var D3 = R3[_3], U3 = this.normalize(D3, this.last), X3 = l3(U3), Y3; !(Y3 = X3()).done; ) {
                var ee2 = Y3.value;
                this.nodes.push(ee2);
              }
            return this;
          }, y3.prepend = function() {
            for (var v3 = arguments.length, b3 = new Array(v3), w3 = 0; w3 < v3; w3++)
              b3[w3] = arguments[w3];
            b3 = b3.reverse();
            for (var _3 = l3(b3), R3; !(R3 = _3()).done; ) {
              for (var D3 = R3.value, U3 = this.normalize(D3, this.first, "prepend").reverse(), X3 = l3(U3), Y3; !(Y3 = X3()).done; ) {
                var ee2 = Y3.value;
                this.nodes.unshift(ee2);
              }
              for (var V10 in this.indexes)
                this.indexes[V10] = this.indexes[V10] + U3.length;
            }
            return this;
          }, y3.cleanRaws = function(v3) {
            if (d3.prototype.cleanRaws.call(this, v3), this.nodes)
              for (var b3 = l3(this.nodes), w3; !(w3 = b3()).done; ) {
                var _3 = w3.value;
                _3.cleanRaws(v3);
              }
          }, y3.insertBefore = function(v3, b3) {
            v3 = this.index(v3);
            for (var w3 = v3 === 0 ? "prepend" : false, _3 = this.normalize(b3, this.nodes[v3], w3).reverse(), R3 = l3(_3), D3; !(D3 = R3()).done; ) {
              var U3 = D3.value;
              this.nodes.splice(v3, 0, U3);
            }
            var X3;
            for (var Y3 in this.indexes)
              X3 = this.indexes[Y3], v3 <= X3 && (this.indexes[Y3] = X3 + _3.length);
            return this;
          }, y3.insertAfter = function(v3, b3) {
            v3 = this.index(v3);
            for (var w3 = this.normalize(b3, this.nodes[v3]).reverse(), _3 = l3(w3), R3; !(R3 = _3()).done; ) {
              var D3 = R3.value;
              this.nodes.splice(v3 + 1, 0, D3);
            }
            var U3;
            for (var X3 in this.indexes)
              U3 = this.indexes[X3], v3 < U3 && (this.indexes[X3] = U3 + w3.length);
            return this;
          }, y3.removeChild = function(v3) {
            v3 = this.index(v3), this.nodes[v3].parent = void 0, this.nodes.splice(v3, 1);
            var b3;
            for (var w3 in this.indexes)
              b3 = this.indexes[w3], b3 >= v3 && (this.indexes[w3] = b3 - 1);
            return this;
          }, y3.removeAll = function() {
            for (var v3 = l3(this.nodes), b3; !(b3 = v3()).done; ) {
              var w3 = b3.value;
              w3.parent = void 0;
            }
            return this.nodes = [], this;
          }, y3.replaceValues = function(v3, b3, w3) {
            return w3 || (w3 = b3, b3 = {}), this.walkDecls(function(_3) {
              b3.props && b3.props.indexOf(_3.prop) === -1 || b3.fast && _3.value.indexOf(b3.fast) === -1 || (_3.value = _3.value.replace(v3, w3));
            }), this;
          }, y3.every = function(v3) {
            return this.nodes.every(v3);
          }, y3.some = function(v3) {
            return this.nodes.some(v3);
          }, y3.index = function(v3) {
            return typeof v3 == "number" ? v3 : this.nodes.indexOf(v3);
          }, y3.normalize = function(v3, b3) {
            var w3 = this;
            if (typeof v3 == "string") {
              var _3 = Qn2();
              v3 = i(_3(v3).nodes);
            } else if (Array.isArray(v3)) {
              v3 = v3.slice(0);
              for (var R3 = l3(v3), D3; !(D3 = R3()).done; ) {
                var U3 = D3.value;
                U3.parent && U3.parent.removeChild(U3, "ignore");
              }
            } else if (v3.type === "root") {
              v3 = v3.nodes.slice(0);
              for (var X3 = l3(v3), Y3; !(Y3 = X3()).done; ) {
                var ee2 = Y3.value;
                ee2.parent && ee2.parent.removeChild(ee2, "ignore");
              }
            } else if (v3.type)
              v3 = [v3];
            else if (v3.prop) {
              if (typeof v3.value > "u")
                throw new Error("Value field is missed in node creation");
              typeof v3.value != "string" && (v3.value = String(v3.value)), v3 = [new o3.default(v3)];
            } else if (v3.selector) {
              var V10 = Vn2();
              v3 = [new V10(v3)];
            } else if (v3.name) {
              var Z3 = Yn2();
              v3 = [new Z3(v3)];
            } else if (v3.text)
              v3 = [new s3.default(v3)];
            else
              throw new Error("Unknown node type in node creation");
            var z3 = v3.map(function(P3) {
              return P3.parent && P3.parent.removeChild(P3), typeof P3.raws.before > "u" && b3 && typeof b3.raws.before < "u" && (P3.raws.before = b3.raws.before.replace(/[^\s]/g, "")), P3.parent = w3, P3;
            });
            return z3;
          }, r3(g3, [{ key: "first", get: function() {
            if (this.nodes)
              return this.nodes[0];
          } }, { key: "last", get: function() {
            if (this.nodes)
              return this.nodes[this.nodes.length - 1];
          } }]), g3;
        }(c3.default), m3 = n3;
        t3.default = m3, a3.exports = t3.default;
      } }), Yn2 = O3({ "node_modules/postcss/lib/at-rule.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = s3(bt2());
        function s3(h3) {
          return h3 && h3.__esModule ? h3 : { default: h3 };
        }
        function c3(h3, u3) {
          h3.prototype = Object.create(u3.prototype), h3.prototype.constructor = h3, h3.__proto__ = u3;
        }
        var f3 = function(h3) {
          c3(u3, h3);
          function u3(r3) {
            var e28;
            return e28 = h3.call(this, r3) || this, e28.type = "atrule", e28;
          }
          var p3 = u3.prototype;
          return p3.append = function() {
            var r3;
            this.nodes || (this.nodes = []);
            for (var e28 = arguments.length, i = new Array(e28), n3 = 0; n3 < e28; n3++)
              i[n3] = arguments[n3];
            return (r3 = h3.prototype.append).call.apply(r3, [this].concat(i));
          }, p3.prepend = function() {
            var r3;
            this.nodes || (this.nodes = []);
            for (var e28 = arguments.length, i = new Array(e28), n3 = 0; n3 < e28; n3++)
              i[n3] = arguments[n3];
            return (r3 = h3.prototype.prepend).call.apply(r3, [this].concat(i));
          }, u3;
        }(o3.default), l3 = f3;
        t3.default = l3, a3.exports = t3.default;
      } }), ei2 = O3({ "node_modules/postcss/lib/map-generator.js"(t3, a3) {
        T3(), a3.exports = class {
          generate() {
          }
        };
      } }), ti2 = O3({ "node_modules/postcss/lib/warn-once.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = s3;
        var o3 = {};
        function s3(c3) {
          o3[c3] || (o3[c3] = true, typeof console < "u" && console.warn && console.warn(c3));
        }
        a3.exports = t3.default;
      } }), ri2 = O3({ "node_modules/postcss/lib/warning.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = function() {
          function c3(l3, h3) {
            if (h3 === void 0 && (h3 = {}), this.type = "warning", this.text = l3, h3.node && h3.node.source) {
              var u3 = h3.node.positionBy(h3);
              this.line = u3.line, this.column = u3.column;
            }
            for (var p3 in h3)
              this[p3] = h3[p3];
          }
          var f3 = c3.prototype;
          return f3.toString = function() {
            return this.node ? this.node.error(this.text, { plugin: this.plugin, index: this.index, word: this.word }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
          }, c3;
        }(), s3 = o3;
        t3.default = s3, a3.exports = t3.default;
      } }), ni2 = O3({ "node_modules/postcss/lib/result.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = s3(ri2());
        function s3(u3) {
          return u3 && u3.__esModule ? u3 : { default: u3 };
        }
        function c3(u3, p3) {
          for (var r3 = 0; r3 < p3.length; r3++) {
            var e28 = p3[r3];
            e28.enumerable = e28.enumerable || false, e28.configurable = true, "value" in e28 && (e28.writable = true), Object.defineProperty(u3, e28.key, e28);
          }
        }
        function f3(u3, p3, r3) {
          return p3 && c3(u3.prototype, p3), r3 && c3(u3, r3), u3;
        }
        var l3 = function() {
          function u3(r3, e28, i) {
            this.processor = r3, this.messages = [], this.root = e28, this.opts = i, this.css = void 0, this.map = void 0;
          }
          var p3 = u3.prototype;
          return p3.toString = function() {
            return this.css;
          }, p3.warn = function(r3, e28) {
            e28 === void 0 && (e28 = {}), e28.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (e28.plugin = this.lastPlugin.postcssPlugin);
            var i = new o3.default(r3, e28);
            return this.messages.push(i), i;
          }, p3.warnings = function() {
            return this.messages.filter(function(r3) {
              return r3.type === "warning";
            });
          }, f3(u3, [{ key: "content", get: function() {
            return this.css;
          } }]), u3;
        }(), h3 = l3;
        t3.default = h3, a3.exports = t3.default;
      } }), Xn2 = O3({ "node_modules/postcss/lib/lazy-result.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = l3(ei2()), s3 = l3(Jn2());
        l3(ti2());
        var c3 = l3(ni2()), f3 = l3(Qn2());
        function l3(d3) {
          return d3 && d3.__esModule ? d3 : { default: d3 };
        }
        function h3(d3, g3) {
          var y3;
          if (typeof Symbol > "u" || d3[Symbol.iterator] == null) {
            if (Array.isArray(d3) || (y3 = u3(d3)) || g3 && d3 && typeof d3.length == "number") {
              y3 && (d3 = y3);
              var v3 = 0;
              return function() {
                return v3 >= d3.length ? { done: true } : { done: false, value: d3[v3++] };
              };
            }
            throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          return y3 = d3[Symbol.iterator](), y3.next.bind(y3);
        }
        function u3(d3, g3) {
          if (d3) {
            if (typeof d3 == "string")
              return p3(d3, g3);
            var y3 = Object.prototype.toString.call(d3).slice(8, -1);
            if (y3 === "Object" && d3.constructor && (y3 = d3.constructor.name), y3 === "Map" || y3 === "Set")
              return Array.from(d3);
            if (y3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(y3))
              return p3(d3, g3);
          }
        }
        function p3(d3, g3) {
          (g3 == null || g3 > d3.length) && (g3 = d3.length);
          for (var y3 = 0, v3 = new Array(g3); y3 < g3; y3++)
            v3[y3] = d3[y3];
          return v3;
        }
        function r3(d3, g3) {
          for (var y3 = 0; y3 < g3.length; y3++) {
            var v3 = g3[y3];
            v3.enumerable = v3.enumerable || false, v3.configurable = true, "value" in v3 && (v3.writable = true), Object.defineProperty(d3, v3.key, v3);
          }
        }
        function e28(d3, g3, y3) {
          return g3 && r3(d3.prototype, g3), y3 && r3(d3, y3), d3;
        }
        function i(d3) {
          return typeof d3 == "object" && typeof d3.then == "function";
        }
        var n3 = function() {
          function d3(y3, v3, b3) {
            this.stringified = false, this.processed = false;
            var w3;
            if (typeof v3 == "object" && v3 !== null && v3.type === "root")
              w3 = v3;
            else if (v3 instanceof d3 || v3 instanceof c3.default)
              w3 = v3.root, v3.map && (typeof b3.map > "u" && (b3.map = {}), b3.map.inline || (b3.map.inline = false), b3.map.prev = v3.map);
            else {
              var _3 = f3.default;
              b3.syntax && (_3 = b3.syntax.parse), b3.parser && (_3 = b3.parser), _3.parse && (_3 = _3.parse);
              try {
                w3 = _3(v3, b3);
              } catch (R3) {
                this.error = R3;
              }
            }
            this.result = new c3.default(y3, w3, b3);
          }
          var g3 = d3.prototype;
          return g3.warnings = function() {
            return this.sync().warnings();
          }, g3.toString = function() {
            return this.css;
          }, g3.then = function(y3, v3) {
            return this.async().then(y3, v3);
          }, g3.catch = function(y3) {
            return this.async().catch(y3);
          }, g3.finally = function(y3) {
            return this.async().then(y3, y3);
          }, g3.handleError = function(y3, v3) {
            try {
              if (this.error = y3, y3.name === "CssSyntaxError" && !y3.plugin)
                y3.plugin = v3.postcssPlugin, y3.setMessage();
              else if (v3.postcssVersion && false)
                var b3, w3, _3, R3, D3;
            } catch (U3) {
              console && console.error && console.error(U3);
            }
          }, g3.asyncTick = function(y3, v3) {
            var b3 = this;
            if (this.plugin >= this.processor.plugins.length)
              return this.processed = true, y3();
            try {
              var w3 = this.processor.plugins[this.plugin], _3 = this.run(w3);
              this.plugin += 1, i(_3) ? _3.then(function() {
                b3.asyncTick(y3, v3);
              }).catch(function(R3) {
                b3.handleError(R3, w3), b3.processed = true, v3(R3);
              }) : this.asyncTick(y3, v3);
            } catch (R3) {
              this.processed = true, v3(R3);
            }
          }, g3.async = function() {
            var y3 = this;
            return this.processed ? new Promise(function(v3, b3) {
              y3.error ? b3(y3.error) : v3(y3.stringify());
            }) : this.processing ? this.processing : (this.processing = new Promise(function(v3, b3) {
              if (y3.error)
                return b3(y3.error);
              y3.plugin = 0, y3.asyncTick(v3, b3);
            }).then(function() {
              return y3.processed = true, y3.stringify();
            }), this.processing);
          }, g3.sync = function() {
            if (this.processed)
              return this.result;
            if (this.processed = true, this.processing)
              throw new Error("Use process(css).then(cb) to work with async plugins");
            if (this.error)
              throw this.error;
            for (var y3 = h3(this.result.processor.plugins), v3; !(v3 = y3()).done; ) {
              var b3 = v3.value, w3 = this.run(b3);
              if (i(w3))
                throw new Error("Use process(css).then(cb) to work with async plugins");
            }
            return this.result;
          }, g3.run = function(y3) {
            this.result.lastPlugin = y3;
            try {
              return y3(this.result.root, this.result);
            } catch (v3) {
              throw this.handleError(v3, y3), v3;
            }
          }, g3.stringify = function() {
            if (this.stringified)
              return this.result;
            this.stringified = true, this.sync();
            var y3 = this.result.opts, v3 = s3.default;
            y3.syntax && (v3 = y3.syntax.stringify), y3.stringifier && (v3 = y3.stringifier), v3.stringify && (v3 = v3.stringify);
            var b3 = new o3.default(v3, this.result.root, this.result.opts), w3 = b3.generate();
            return this.result.css = w3[0], this.result.map = w3[1], this.result;
          }, e28(d3, [{ key: "processor", get: function() {
            return this.result.processor;
          } }, { key: "opts", get: function() {
            return this.result.opts;
          } }, { key: "css", get: function() {
            return this.stringify().css;
          } }, { key: "content", get: function() {
            return this.stringify().content;
          } }, { key: "map", get: function() {
            return this.stringify().map;
          } }, { key: "root", get: function() {
            return this.sync().root;
          } }, { key: "messages", get: function() {
            return this.sync().messages;
          } }]), d3;
        }(), m3 = n3;
        t3.default = m3, a3.exports = t3.default;
      } }), oi2 = O3({ "node_modules/postcss/lib/processor.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = s3(Xn2());
        function s3(p3) {
          return p3 && p3.__esModule ? p3 : { default: p3 };
        }
        function c3(p3, r3) {
          var e28;
          if (typeof Symbol > "u" || p3[Symbol.iterator] == null) {
            if (Array.isArray(p3) || (e28 = f3(p3)) || r3 && p3 && typeof p3.length == "number") {
              e28 && (p3 = e28);
              var i = 0;
              return function() {
                return i >= p3.length ? { done: true } : { done: false, value: p3[i++] };
              };
            }
            throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          return e28 = p3[Symbol.iterator](), e28.next.bind(e28);
        }
        function f3(p3, r3) {
          if (p3) {
            if (typeof p3 == "string")
              return l3(p3, r3);
            var e28 = Object.prototype.toString.call(p3).slice(8, -1);
            if (e28 === "Object" && p3.constructor && (e28 = p3.constructor.name), e28 === "Map" || e28 === "Set")
              return Array.from(p3);
            if (e28 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e28))
              return l3(p3, r3);
          }
        }
        function l3(p3, r3) {
          (r3 == null || r3 > p3.length) && (r3 = p3.length);
          for (var e28 = 0, i = new Array(r3); e28 < r3; e28++)
            i[e28] = p3[e28];
          return i;
        }
        var h3 = function() {
          function p3(e28) {
            e28 === void 0 && (e28 = []), this.version = "7.0.39", this.plugins = this.normalize(e28);
          }
          var r3 = p3.prototype;
          return r3.use = function(e28) {
            return this.plugins = this.plugins.concat(this.normalize([e28])), this;
          }, r3.process = function(e28) {
            function i(n3) {
              return e28.apply(this, arguments);
            }
            return i.toString = function() {
              return e28.toString();
            }, i;
          }(function(e28, i) {
            return i === void 0 && (i = {}), this.plugins.length === 0 && (i.parser, i.stringifier), new o3.default(this, e28, i);
          }), r3.normalize = function(e28) {
            for (var i = [], n3 = c3(e28), m3; !(m3 = n3()).done; ) {
              var d3 = m3.value;
              if (d3.postcss === true) {
                var g3 = d3();
                throw new Error("PostCSS plugin " + g3.postcssPlugin + ` requires PostCSS 8.
Migration guide for end-users:
https://github.com/postcss/postcss/wiki/PostCSS-8-for-end-users`);
              }
              if (d3.postcss && (d3 = d3.postcss), typeof d3 == "object" && Array.isArray(d3.plugins))
                i = i.concat(d3.plugins);
              else if (typeof d3 == "function")
                i.push(d3);
              else if (!(typeof d3 == "object" && (d3.parse || d3.stringify)))
                throw typeof d3 == "object" && d3.postcssPlugin ? new Error("PostCSS plugin " + d3.postcssPlugin + ` requires PostCSS 8.
Migration guide for end-users:
https://github.com/postcss/postcss/wiki/PostCSS-8-for-end-users`) : new Error(d3 + " is not a PostCSS plugin");
            }
            return i;
          }, p3;
        }(), u3 = h3;
        t3.default = u3, a3.exports = t3.default;
      } }), si2 = O3({ "node_modules/postcss/lib/root.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = s3(bt2());
        function s3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        function c3(r3, e28) {
          var i;
          if (typeof Symbol > "u" || r3[Symbol.iterator] == null) {
            if (Array.isArray(r3) || (i = f3(r3)) || e28 && r3 && typeof r3.length == "number") {
              i && (r3 = i);
              var n3 = 0;
              return function() {
                return n3 >= r3.length ? { done: true } : { done: false, value: r3[n3++] };
              };
            }
            throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          return i = r3[Symbol.iterator](), i.next.bind(i);
        }
        function f3(r3, e28) {
          if (r3) {
            if (typeof r3 == "string")
              return l3(r3, e28);
            var i = Object.prototype.toString.call(r3).slice(8, -1);
            if (i === "Object" && r3.constructor && (i = r3.constructor.name), i === "Map" || i === "Set")
              return Array.from(r3);
            if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
              return l3(r3, e28);
          }
        }
        function l3(r3, e28) {
          (e28 == null || e28 > r3.length) && (e28 = r3.length);
          for (var i = 0, n3 = new Array(e28); i < e28; i++)
            n3[i] = r3[i];
          return n3;
        }
        function h3(r3, e28) {
          r3.prototype = Object.create(e28.prototype), r3.prototype.constructor = r3, r3.__proto__ = e28;
        }
        var u3 = function(r3) {
          h3(e28, r3);
          function e28(n3) {
            var m3;
            return m3 = r3.call(this, n3) || this, m3.type = "root", m3.nodes || (m3.nodes = []), m3;
          }
          var i = e28.prototype;
          return i.removeChild = function(n3, m3) {
            var d3 = this.index(n3);
            return !m3 && d3 === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[d3].raws.before), r3.prototype.removeChild.call(this, n3);
          }, i.normalize = function(n3, m3, d3) {
            var g3 = r3.prototype.normalize.call(this, n3);
            if (m3) {
              if (d3 === "prepend")
                this.nodes.length > 1 ? m3.raws.before = this.nodes[1].raws.before : delete m3.raws.before;
              else if (this.first !== m3)
                for (var y3 = c3(g3), v3; !(v3 = y3()).done; ) {
                  var b3 = v3.value;
                  b3.raws.before = m3.raws.before;
                }
            }
            return g3;
          }, i.toResult = function(n3) {
            n3 === void 0 && (n3 = {});
            var m3 = Xn2(), d3 = oi2(), g3 = new m3(new d3(), this, n3);
            return g3.stringify();
          }, e28;
        }(o3.default), p3 = u3;
        t3.default = p3, a3.exports = t3.default;
      } }), Qt2 = O3({ "node_modules/postcss/lib/parser.js"(t3, a3) {
        T3(), t3.__esModule = true, t3.default = void 0;
        var o3 = u3(Hn2()), s3 = u3(Ht2()), c3 = u3(gt2()), f3 = u3(Yn2()), l3 = u3(si2()), h3 = u3(Vn2());
        function u3(r3) {
          return r3 && r3.__esModule ? r3 : { default: r3 };
        }
        var p3 = function() {
          function r3(i) {
            this.input = i, this.root = new l3.default(), this.current = this.root, this.spaces = "", this.semicolon = false, this.createTokenizer(), this.root.source = { input: i, start: { line: 1, column: 1 } };
          }
          var e28 = r3.prototype;
          return e28.createTokenizer = function() {
            this.tokenizer = (0, s3.default)(this.input);
          }, e28.parse = function() {
            for (var i; !this.tokenizer.endOfFile(); )
              switch (i = this.tokenizer.nextToken(), i[0]) {
                case "space":
                  this.spaces += i[1];
                  break;
                case ";":
                  this.freeSemicolon(i);
                  break;
                case "}":
                  this.end(i);
                  break;
                case "comment":
                  this.comment(i);
                  break;
                case "at-word":
                  this.atrule(i);
                  break;
                case "{":
                  this.emptyRule(i);
                  break;
                default:
                  this.other(i);
                  break;
              }
            this.endFile();
          }, e28.comment = function(i) {
            var n3 = new c3.default();
            this.init(n3, i[2], i[3]), n3.source.end = { line: i[4], column: i[5] };
            var m3 = i[1].slice(2, -2);
            if (/^\s*$/.test(m3))
              n3.text = "", n3.raws.left = m3, n3.raws.right = "";
            else {
              var d3 = m3.match(/^(\s*)([^]*[^\s])(\s*)$/);
              n3.text = d3[2], n3.raws.left = d3[1], n3.raws.right = d3[3];
            }
          }, e28.emptyRule = function(i) {
            var n3 = new h3.default();
            this.init(n3, i[2], i[3]), n3.selector = "", n3.raws.between = "", this.current = n3;
          }, e28.other = function(i) {
            for (var n3 = false, m3 = null, d3 = false, g3 = null, y3 = [], v3 = [], b3 = i; b3; ) {
              if (m3 = b3[0], v3.push(b3), m3 === "(" || m3 === "[")
                g3 || (g3 = b3), y3.push(m3 === "(" ? ")" : "]");
              else if (y3.length === 0)
                if (m3 === ";")
                  if (d3) {
                    this.decl(v3);
                    return;
                  } else
                    break;
                else if (m3 === "{") {
                  this.rule(v3);
                  return;
                } else if (m3 === "}") {
                  this.tokenizer.back(v3.pop()), n3 = true;
                  break;
                } else
                  m3 === ":" && (d3 = true);
              else
                m3 === y3[y3.length - 1] && (y3.pop(), y3.length === 0 && (g3 = null));
              b3 = this.tokenizer.nextToken();
            }
            if (this.tokenizer.endOfFile() && (n3 = true), y3.length > 0 && this.unclosedBracket(g3), n3 && d3) {
              for (; v3.length && (b3 = v3[v3.length - 1][0], !(b3 !== "space" && b3 !== "comment")); )
                this.tokenizer.back(v3.pop());
              this.decl(v3);
            } else
              this.unknownWord(v3);
          }, e28.rule = function(i) {
            i.pop();
            var n3 = new h3.default();
            this.init(n3, i[0][2], i[0][3]), n3.raws.between = this.spacesAndCommentsFromEnd(i), this.raw(n3, "selector", i), this.current = n3;
          }, e28.decl = function(i) {
            var n3 = new o3.default();
            this.init(n3);
            var m3 = i[i.length - 1];
            for (m3[0] === ";" && (this.semicolon = true, i.pop()), m3[4] ? n3.source.end = { line: m3[4], column: m3[5] } : n3.source.end = { line: m3[2], column: m3[3] }; i[0][0] !== "word"; )
              i.length === 1 && this.unknownWord(i), n3.raws.before += i.shift()[1];
            for (n3.source.start = { line: i[0][2], column: i[0][3] }, n3.prop = ""; i.length; ) {
              var d3 = i[0][0];
              if (d3 === ":" || d3 === "space" || d3 === "comment")
                break;
              n3.prop += i.shift()[1];
            }
            n3.raws.between = "";
            for (var g3; i.length; )
              if (g3 = i.shift(), g3[0] === ":") {
                n3.raws.between += g3[1];
                break;
              } else
                g3[0] === "word" && /\w/.test(g3[1]) && this.unknownWord([g3]), n3.raws.between += g3[1];
            (n3.prop[0] === "_" || n3.prop[0] === "*") && (n3.raws.before += n3.prop[0], n3.prop = n3.prop.slice(1)), n3.raws.between += this.spacesAndCommentsFromStart(i), this.precheckMissedSemicolon(i);
            for (var y3 = i.length - 1; y3 > 0; y3--) {
              if (g3 = i[y3], g3[1].toLowerCase() === "!important") {
                n3.important = true;
                var v3 = this.stringFrom(i, y3);
                v3 = this.spacesFromEnd(i) + v3, v3 !== " !important" && (n3.raws.important = v3);
                break;
              } else if (g3[1].toLowerCase() === "important") {
                for (var b3 = i.slice(0), w3 = "", _3 = y3; _3 > 0; _3--) {
                  var R3 = b3[_3][0];
                  if (w3.trim().indexOf("!") === 0 && R3 !== "space")
                    break;
                  w3 = b3.pop()[1] + w3;
                }
                w3.trim().indexOf("!") === 0 && (n3.important = true, n3.raws.important = w3, i = b3);
              }
              if (g3[0] !== "space" && g3[0] !== "comment")
                break;
            }
            this.raw(n3, "value", i), n3.value.indexOf(":") !== -1 && this.checkMissedSemicolon(i);
          }, e28.atrule = function(i) {
            var n3 = new f3.default();
            n3.name = i[1].slice(1), n3.name === "" && this.unnamedAtrule(n3, i), this.init(n3, i[2], i[3]);
            for (var m3, d3, g3 = false, y3 = false, v3 = []; !this.tokenizer.endOfFile(); ) {
              if (i = this.tokenizer.nextToken(), i[0] === ";") {
                n3.source.end = { line: i[2], column: i[3] }, this.semicolon = true;
                break;
              } else if (i[0] === "{") {
                y3 = true;
                break;
              } else if (i[0] === "}") {
                if (v3.length > 0) {
                  for (d3 = v3.length - 1, m3 = v3[d3]; m3 && m3[0] === "space"; )
                    m3 = v3[--d3];
                  m3 && (n3.source.end = { line: m3[4], column: m3[5] });
                }
                this.end(i);
                break;
              } else
                v3.push(i);
              if (this.tokenizer.endOfFile()) {
                g3 = true;
                break;
              }
            }
            n3.raws.between = this.spacesAndCommentsFromEnd(v3), v3.length ? (n3.raws.afterName = this.spacesAndCommentsFromStart(v3), this.raw(n3, "params", v3), g3 && (i = v3[v3.length - 1], n3.source.end = { line: i[4], column: i[5] }, this.spaces = n3.raws.between, n3.raws.between = "")) : (n3.raws.afterName = "", n3.params = ""), y3 && (n3.nodes = [], this.current = n3);
          }, e28.end = function(i) {
            this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = false, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = { line: i[2], column: i[3] }, this.current = this.current.parent) : this.unexpectedClose(i);
          }, e28.endFile = function() {
            this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces;
          }, e28.freeSemicolon = function(i) {
            if (this.spaces += i[1], this.current.nodes) {
              var n3 = this.current.nodes[this.current.nodes.length - 1];
              n3 && n3.type === "rule" && !n3.raws.ownSemicolon && (n3.raws.ownSemicolon = this.spaces, this.spaces = "");
            }
          }, e28.init = function(i, n3, m3) {
            this.current.push(i), i.source = { start: { line: n3, column: m3 }, input: this.input }, i.raws.before = this.spaces, this.spaces = "", i.type !== "comment" && (this.semicolon = false);
          }, e28.raw = function(i, n3, m3) {
            for (var d3, g3, y3 = m3.length, v3 = "", b3 = true, w3, _3, R3 = /^([.|#])?([\w])+/i, D3 = 0; D3 < y3; D3 += 1) {
              if (d3 = m3[D3], g3 = d3[0], g3 === "comment" && i.type === "rule") {
                _3 = m3[D3 - 1], w3 = m3[D3 + 1], _3[0] !== "space" && w3[0] !== "space" && R3.test(_3[1]) && R3.test(w3[1]) ? v3 += d3[1] : b3 = false;
                continue;
              }
              g3 === "comment" || g3 === "space" && D3 === y3 - 1 ? b3 = false : v3 += d3[1];
            }
            if (!b3) {
              var U3 = m3.reduce(function(X3, Y3) {
                return X3 + Y3[1];
              }, "");
              i.raws[n3] = { value: v3, raw: U3 };
            }
            i[n3] = v3;
          }, e28.spacesAndCommentsFromEnd = function(i) {
            for (var n3, m3 = ""; i.length && (n3 = i[i.length - 1][0], !(n3 !== "space" && n3 !== "comment")); )
              m3 = i.pop()[1] + m3;
            return m3;
          }, e28.spacesAndCommentsFromStart = function(i) {
            for (var n3, m3 = ""; i.length && (n3 = i[0][0], !(n3 !== "space" && n3 !== "comment")); )
              m3 += i.shift()[1];
            return m3;
          }, e28.spacesFromEnd = function(i) {
            for (var n3, m3 = ""; i.length && (n3 = i[i.length - 1][0], n3 === "space"); )
              m3 = i.pop()[1] + m3;
            return m3;
          }, e28.stringFrom = function(i, n3) {
            for (var m3 = "", d3 = n3; d3 < i.length; d3++)
              m3 += i[d3][1];
            return i.splice(n3, i.length - n3), m3;
          }, e28.colon = function(i) {
            for (var n3 = 0, m3, d3, g3, y3 = 0; y3 < i.length; y3++) {
              if (m3 = i[y3], d3 = m3[0], d3 === "(" && (n3 += 1), d3 === ")" && (n3 -= 1), n3 === 0 && d3 === ":")
                if (!g3)
                  this.doubleColon(m3);
                else {
                  if (g3[0] === "word" && g3[1] === "progid")
                    continue;
                  return y3;
                }
              g3 = m3;
            }
            return false;
          }, e28.unclosedBracket = function(i) {
            throw this.input.error("Unclosed bracket", i[2], i[3]);
          }, e28.unknownWord = function(i) {
            throw this.input.error("Unknown word", i[0][2], i[0][3]);
          }, e28.unexpectedClose = function(i) {
            throw this.input.error("Unexpected }", i[2], i[3]);
          }, e28.unclosedBlock = function() {
            var i = this.current.source.start;
            throw this.input.error("Unclosed block", i.line, i.column);
          }, e28.doubleColon = function(i) {
            throw this.input.error("Double colon", i[2], i[3]);
          }, e28.unnamedAtrule = function(i, n3) {
            throw this.input.error("At-rule without name", n3[2], n3[3]);
          }, e28.precheckMissedSemicolon = function() {
          }, e28.checkMissedSemicolon = function(i) {
            var n3 = this.colon(i);
            if (n3 !== false) {
              for (var m3 = 0, d3, g3 = n3 - 1; g3 >= 0 && (d3 = i[g3], !(d3[0] !== "space" && (m3 += 1, m3 === 2))); g3--)
                ;
              throw this.input.error("Missed semicolon", d3[2], d3[3]);
            }
          }, r3;
        }();
        t3.default = p3, a3.exports = t3.default;
      } }), ii2 = O3({ "node_modules/postcss-less/lib/nodes/inline-comment.js"(t3, a3) {
        T3();
        var o3 = Ht2(), s3 = vt2();
        a3.exports = { isInlineComment(c3) {
          if (c3[0] === "word" && c3[1].slice(0, 2) === "//") {
            let f3 = c3, l3 = [], h3;
            for (; c3; ) {
              if (/\r?\n/.test(c3[1])) {
                if (/['"].*\r?\n/.test(c3[1])) {
                  l3.push(c3[1].substring(0, c3[1].indexOf(`
`)));
                  let p3 = c3[1].substring(c3[1].indexOf(`
`));
                  p3 += this.input.css.valueOf().substring(this.tokenizer.position()), this.input = new s3(p3), this.tokenizer = o3(this.input);
                } else
                  this.tokenizer.back(c3);
                break;
              }
              l3.push(c3[1]), h3 = c3, c3 = this.tokenizer.nextToken({ ignoreUnclosed: true });
            }
            let u3 = ["comment", l3.join(""), f3[2], f3[3], h3[2], h3[3]];
            return this.inlineComment(u3), true;
          } else if (c3[1] === "/") {
            let f3 = this.tokenizer.nextToken({ ignoreUnclosed: true });
            if (f3[0] === "comment" && /^\/\*/.test(f3[1]))
              return f3[0] = "word", f3[1] = f3[1].slice(1), c3[1] = "//", this.tokenizer.back(f3), a3.exports.isInlineComment.bind(this)(c3);
          }
          return false;
        } };
      } }), ai2 = O3({ "node_modules/postcss-less/lib/nodes/interpolation.js"(t3, a3) {
        T3(), a3.exports = { interpolation(o3) {
          let s3 = o3, c3 = [o3], f3 = ["word", "{", "}"];
          if (o3 = this.tokenizer.nextToken(), s3[1].length > 1 || o3[0] !== "{")
            return this.tokenizer.back(o3), false;
          for (; o3 && f3.includes(o3[0]); )
            c3.push(o3), o3 = this.tokenizer.nextToken();
          let l3 = c3.map((e28) => e28[1]);
          [s3] = c3;
          let h3 = c3.pop(), u3 = [s3[2], s3[3]], p3 = [h3[4] || h3[2], h3[5] || h3[3]], r3 = ["word", l3.join("")].concat(u3, p3);
          return this.tokenizer.back(o3), this.tokenizer.back(r3), true;
        } };
      } }), ui2 = O3({ "node_modules/postcss-less/lib/nodes/mixin.js"(t3, a3) {
        T3();
        var o3 = /^#[0-9a-fA-F]{6}$|^#[0-9a-fA-F]{3}$/, s3 = /\.[0-9]/, c3 = (f3) => {
          let [, l3] = f3, [h3] = l3;
          return (h3 === "." || h3 === "#") && o3.test(l3) === false && s3.test(l3) === false;
        };
        a3.exports = { isMixinToken: c3 };
      } }), ci2 = O3({ "node_modules/postcss-less/lib/nodes/import.js"(t3, a3) {
        T3();
        var o3 = Ht2(), s3 = /^url\((.+)\)/;
        a3.exports = (c3) => {
          let { name: f3, params: l3 = "" } = c3;
          if (f3 === "import" && l3.length) {
            c3.import = true;
            let h3 = o3({ css: l3 });
            for (c3.filename = l3.replace(s3, "$1"); !h3.endOfFile(); ) {
              let [u3, p3] = h3.nextToken();
              if (u3 === "word" && p3 === "url")
                return;
              if (u3 === "brackets") {
                c3.options = p3, c3.filename = l3.replace(p3, "").trim();
                break;
              }
            }
          }
        };
      } }), li2 = O3({ "node_modules/postcss-less/lib/nodes/variable.js"(t3, a3) {
        T3();
        var o3 = /:$/, s3 = /^:(\s+)?/;
        a3.exports = (c3) => {
          let { name: f3, params: l3 = "" } = c3;
          if (c3.name.slice(-1) === ":") {
            if (o3.test(f3)) {
              let [h3] = f3.match(o3);
              c3.name = f3.replace(h3, ""), c3.raws.afterName = h3 + (c3.raws.afterName || ""), c3.variable = true, c3.value = c3.params;
            }
            if (s3.test(l3)) {
              let [h3] = l3.match(s3);
              c3.value = l3.replace(h3, ""), c3.raws.afterName = (c3.raws.afterName || "") + h3, c3.variable = true;
            }
          }
        };
      } }), fi2 = O3({ "node_modules/postcss-less/lib/LessParser.js"(t3, a3) {
        T3();
        var o3 = gt2(), s3 = Qt2(), { isInlineComment: c3 } = ii2(), { interpolation: f3 } = ai2(), { isMixinToken: l3 } = ui2(), h3 = ci2(), u3 = li2(), p3 = /(!\s*important)$/i;
        a3.exports = class extends s3 {
          constructor() {
            super(...arguments), this.lastNode = null;
          }
          atrule(r3) {
            f3.bind(this)(r3) || (super.atrule(r3), h3(this.lastNode), u3(this.lastNode));
          }
          decl() {
            super.decl(...arguments), /extend\(.+\)/i.test(this.lastNode.value) && (this.lastNode.extend = true);
          }
          each(r3) {
            r3[0][1] = ` ${r3[0][1]}`;
            let e28 = r3.findIndex((d3) => d3[0] === "("), i = r3.reverse().find((d3) => d3[0] === ")"), n3 = r3.reverse().indexOf(i), m3 = r3.splice(e28, n3).map((d3) => d3[1]).join("");
            for (let d3 of r3.reverse())
              this.tokenizer.back(d3);
            this.atrule(this.tokenizer.nextToken()), this.lastNode.function = true, this.lastNode.params = m3;
          }
          init(r3, e28, i) {
            super.init(r3, e28, i), this.lastNode = r3;
          }
          inlineComment(r3) {
            let e28 = new o3(), i = r3[1].slice(2);
            if (this.init(e28, r3[2], r3[3]), e28.source.end = { line: r3[4], column: r3[5] }, e28.inline = true, e28.raws.begin = "//", /^\s*$/.test(i))
              e28.text = "", e28.raws.left = i, e28.raws.right = "";
            else {
              let n3 = i.match(/^(\s*)([^]*[^\s])(\s*)$/);
              [, e28.raws.left, e28.text, e28.raws.right] = n3;
            }
          }
          mixin(r3) {
            let [e28] = r3, i = e28[1].slice(0, 1), n3 = r3.findIndex((v3) => v3[0] === "brackets"), m3 = r3.findIndex((v3) => v3[0] === "("), d3 = "";
            if ((n3 < 0 || n3 > 3) && m3 > 0) {
              let v3 = r3.reduce((ee2, V10, Z3) => V10[0] === ")" ? Z3 : ee2), b3 = r3.slice(m3, v3 + m3).map((ee2) => ee2[1]).join(""), [w3] = r3.slice(m3), _3 = [w3[2], w3[3]], [R3] = r3.slice(v3, v3 + 1), D3 = [R3[2], R3[3]], U3 = ["brackets", b3].concat(_3, D3), X3 = r3.slice(0, m3), Y3 = r3.slice(v3 + 1);
              r3 = X3, r3.push(U3), r3 = r3.concat(Y3);
            }
            let g3 = [];
            for (let v3 of r3)
              if ((v3[1] === "!" || g3.length) && g3.push(v3), v3[1] === "important")
                break;
            if (g3.length) {
              let [v3] = g3, b3 = r3.indexOf(v3), w3 = g3[g3.length - 1], _3 = [v3[2], v3[3]], R3 = [w3[4], w3[5]], D3 = ["word", g3.map((U3) => U3[1]).join("")].concat(_3, R3);
              r3.splice(b3, g3.length, D3);
            }
            let y3 = r3.findIndex((v3) => p3.test(v3[1]));
            y3 > 0 && ([, d3] = r3[y3], r3.splice(y3, 1));
            for (let v3 of r3.reverse())
              this.tokenizer.back(v3);
            this.atrule(this.tokenizer.nextToken()), this.lastNode.mixin = true, this.lastNode.raws.identifier = i, d3 && (this.lastNode.important = true, this.lastNode.raws.important = d3);
          }
          other(r3) {
            c3.bind(this)(r3) || super.other(r3);
          }
          rule(r3) {
            let e28 = r3[r3.length - 1], i = r3[r3.length - 2];
            if (i[0] === "at-word" && e28[0] === "{" && (this.tokenizer.back(e28), f3.bind(this)(i))) {
              let n3 = this.tokenizer.nextToken();
              r3 = r3.slice(0, r3.length - 2).concat([n3]);
              for (let m3 of r3.reverse())
                this.tokenizer.back(m3);
              return;
            }
            super.rule(r3), /:extend\(.+\)/i.test(this.lastNode.selector) && (this.lastNode.extend = true);
          }
          unknownWord(r3) {
            let [e28] = r3;
            if (r3[0][1] === "each" && r3[1][0] === "(") {
              this.each(r3);
              return;
            }
            if (l3(e28)) {
              this.mixin(r3);
              return;
            }
            super.unknownWord(r3);
          }
        };
      } }), pi2 = O3({ "node_modules/postcss-less/lib/LessStringifier.js"(t3, a3) {
        T3();
        var o3 = yt2();
        a3.exports = class extends o3 {
          atrule(s3, c3) {
            if (!s3.mixin && !s3.variable && !s3.function) {
              super.atrule(s3, c3);
              return;
            }
            let f3 = `${s3.function ? "" : s3.raws.identifier || "@"}${s3.name}`, l3 = s3.params ? this.rawValue(s3, "params") : "", h3 = s3.raws.important || "";
            if (s3.variable && (l3 = s3.value), typeof s3.raws.afterName < "u" ? f3 += s3.raws.afterName : l3 && (f3 += " "), s3.nodes)
              this.block(s3, f3 + l3 + h3);
            else {
              let u3 = (s3.raws.between || "") + h3 + (c3 ? ";" : "");
              this.builder(f3 + l3 + u3, s3);
            }
          }
          comment(s3) {
            if (s3.inline) {
              let c3 = this.raw(s3, "left", "commentLeft"), f3 = this.raw(s3, "right", "commentRight");
              this.builder(`//${c3}${s3.text}${f3}`, s3);
            } else
              super.comment(s3);
          }
        };
      } }), hi2 = O3({ "node_modules/postcss-less/lib/index.js"(t3, a3) {
        T3();
        var o3 = vt2(), s3 = fi2(), c3 = pi2();
        a3.exports = { parse(f3, l3) {
          let h3 = new o3(f3, l3), u3 = new s3(h3);
          return u3.parse(), u3.root;
        }, stringify(f3, l3) {
          new c3(l3).stringify(f3);
        }, nodeToString(f3) {
          let l3 = "";
          return a3.exports.stringify(f3, (h3) => {
            l3 += h3;
          }), l3;
        } };
      } }), di2 = O3({ "node_modules/postcss-scss/lib/scss-stringifier.js"(t3, a3) {
        T3();
        function o3(f3, l3) {
          f3.prototype = Object.create(l3.prototype), f3.prototype.constructor = f3, f3.__proto__ = l3;
        }
        var s3 = yt2(), c3 = function(f3) {
          o3(l3, f3);
          function l3() {
            return f3.apply(this, arguments) || this;
          }
          var h3 = l3.prototype;
          return h3.comment = function(u3) {
            var p3 = this.raw(u3, "left", "commentLeft"), r3 = this.raw(u3, "right", "commentRight");
            if (u3.raws.inline) {
              var e28 = u3.raws.text || u3.text;
              this.builder("//" + p3 + e28 + r3, u3);
            } else
              this.builder("/*" + p3 + u3.text + r3 + "*/", u3);
          }, h3.decl = function(u3, p3) {
            if (!u3.isNested)
              f3.prototype.decl.call(this, u3, p3);
            else {
              var r3 = this.raw(u3, "between", "colon"), e28 = u3.prop + r3 + this.rawValue(u3, "value");
              u3.important && (e28 += u3.raws.important || " !important"), this.builder(e28 + "{", u3, "start");
              var i;
              u3.nodes && u3.nodes.length ? (this.body(u3), i = this.raw(u3, "after")) : i = this.raw(u3, "after", "emptyBody"), i && this.builder(i), this.builder("}", u3, "end");
            }
          }, h3.rawValue = function(u3, p3) {
            var r3 = u3[p3], e28 = u3.raws[p3];
            return e28 && e28.value === r3 ? e28.scss ? e28.scss : e28.raw : r3;
          }, l3;
        }(s3);
        a3.exports = c3;
      } }), mi2 = O3({ "node_modules/postcss-scss/lib/scss-stringify.js"(t3, a3) {
        T3();
        var o3 = di2();
        a3.exports = function(s3, c3) {
          var f3 = new o3(c3);
          f3.stringify(s3);
        };
      } }), vi2 = O3({ "node_modules/postcss-scss/lib/nested-declaration.js"(t3, a3) {
        T3();
        function o3(f3, l3) {
          f3.prototype = Object.create(l3.prototype), f3.prototype.constructor = f3, f3.__proto__ = l3;
        }
        var s3 = bt2(), c3 = function(f3) {
          o3(l3, f3);
          function l3(h3) {
            var u3;
            return u3 = f3.call(this, h3) || this, u3.type = "decl", u3.isNested = true, u3.nodes || (u3.nodes = []), u3;
          }
          return l3;
        }(s3);
        a3.exports = c3;
      } }), yi2 = O3({ "node_modules/postcss-scss/lib/scss-tokenize.js"(t3, a3) {
        T3();
        var o3 = "'".charCodeAt(0), s3 = '"'.charCodeAt(0), c3 = "\\".charCodeAt(0), f3 = "/".charCodeAt(0), l3 = `
`.charCodeAt(0), h3 = " ".charCodeAt(0), u3 = "\f".charCodeAt(0), p3 = "	".charCodeAt(0), r3 = "\r".charCodeAt(0), e28 = "[".charCodeAt(0), i = "]".charCodeAt(0), n3 = "(".charCodeAt(0), m3 = ")".charCodeAt(0), d3 = "{".charCodeAt(0), g3 = "}".charCodeAt(0), y3 = ";".charCodeAt(0), v3 = "*".charCodeAt(0), b3 = ":".charCodeAt(0), w3 = "@".charCodeAt(0), _3 = ",".charCodeAt(0), R3 = "#".charCodeAt(0), D3 = /[ \n\t\r\f{}()'"\\;/[\]#]/g, U3 = /[ \n\t\r\f(){}:;@!'"\\\][#]|\/(?=\*)/g, X3 = /.[\\/("'\n]/, Y3 = /[a-f0-9]/i, ee2 = /[\r\f\n]/g;
        a3.exports = function(V10, Z3) {
          Z3 === void 0 && (Z3 = {});
          var z3 = V10.css.valueOf(), P3 = Z3.ignoreErrors, $3, E3, ve2, ue2, fe2, ae2, ie2, G3, oe2, K3, te2, k3, A3, C3, W3 = z3.length, x3 = -1, J3 = 1, L3 = 0, we2 = [], ye2 = [];
          function Oe2(xe2) {
            throw V10.error("Unclosed " + xe2, J3, L3 - x3);
          }
          function Ee2() {
            return ye2.length === 0 && L3 >= W3;
          }
          function ke2() {
            for (var xe2 = 1, be2 = false, Te2 = false; xe2 > 0; )
              E3 += 1, z3.length <= E3 && Oe2("interpolation"), $3 = z3.charCodeAt(E3), k3 = z3.charCodeAt(E3 + 1), be2 ? !Te2 && $3 === be2 ? (be2 = false, Te2 = false) : $3 === c3 ? Te2 = !K3 : Te2 && (Te2 = false) : $3 === o3 || $3 === s3 ? be2 = $3 : $3 === g3 ? xe2 -= 1 : $3 === R3 && k3 === d3 && (xe2 += 1);
          }
          function ge2() {
            if (ye2.length)
              return ye2.pop();
            if (!(L3 >= W3)) {
              switch ($3 = z3.charCodeAt(L3), ($3 === l3 || $3 === u3 || $3 === r3 && z3.charCodeAt(L3 + 1) !== l3) && (x3 = L3, J3 += 1), $3) {
                case l3:
                case h3:
                case p3:
                case r3:
                case u3:
                  E3 = L3;
                  do
                    E3 += 1, $3 = z3.charCodeAt(E3), $3 === l3 && (x3 = E3, J3 += 1);
                  while ($3 === h3 || $3 === l3 || $3 === p3 || $3 === r3 || $3 === u3);
                  A3 = ["space", z3.slice(L3, E3)], L3 = E3 - 1;
                  break;
                case e28:
                  A3 = ["[", "[", J3, L3 - x3];
                  break;
                case i:
                  A3 = ["]", "]", J3, L3 - x3];
                  break;
                case d3:
                  A3 = ["{", "{", J3, L3 - x3];
                  break;
                case g3:
                  A3 = ["}", "}", J3, L3 - x3];
                  break;
                case _3:
                  A3 = ["word", ",", J3, L3 - x3, J3, L3 - x3 + 1];
                  break;
                case b3:
                  A3 = [":", ":", J3, L3 - x3];
                  break;
                case y3:
                  A3 = [";", ";", J3, L3 - x3];
                  break;
                case n3:
                  if (te2 = we2.length ? we2.pop()[1] : "", k3 = z3.charCodeAt(L3 + 1), te2 === "url" && k3 !== o3 && k3 !== s3) {
                    for (C3 = 1, K3 = false, E3 = L3 + 1; E3 <= z3.length - 1; ) {
                      if (k3 = z3.charCodeAt(E3), k3 === c3)
                        K3 = !K3;
                      else if (k3 === n3)
                        C3 += 1;
                      else if (k3 === m3 && (C3 -= 1, C3 === 0))
                        break;
                      E3 += 1;
                    }
                    ae2 = z3.slice(L3, E3 + 1), ue2 = ae2.split(`
`), fe2 = ue2.length - 1, fe2 > 0 ? (G3 = J3 + fe2, oe2 = E3 - ue2[fe2].length) : (G3 = J3, oe2 = x3), A3 = ["brackets", ae2, J3, L3 - x3, G3, E3 - oe2], x3 = oe2, J3 = G3, L3 = E3;
                  } else
                    E3 = z3.indexOf(")", L3 + 1), ae2 = z3.slice(L3, E3 + 1), E3 === -1 || X3.test(ae2) ? A3 = ["(", "(", J3, L3 - x3] : (A3 = ["brackets", ae2, J3, L3 - x3, J3, E3 - x3], L3 = E3);
                  break;
                case m3:
                  A3 = [")", ")", J3, L3 - x3];
                  break;
                case o3:
                case s3:
                  for (ve2 = $3, E3 = L3, K3 = false; E3 < W3 && (E3++, E3 === W3 && Oe2("string"), $3 = z3.charCodeAt(E3), k3 = z3.charCodeAt(E3 + 1), !(!K3 && $3 === ve2)); )
                    $3 === c3 ? K3 = !K3 : K3 ? K3 = false : $3 === R3 && k3 === d3 && ke2();
                  ae2 = z3.slice(L3, E3 + 1), ue2 = ae2.split(`
`), fe2 = ue2.length - 1, fe2 > 0 ? (G3 = J3 + fe2, oe2 = E3 - ue2[fe2].length) : (G3 = J3, oe2 = x3), A3 = ["string", z3.slice(L3, E3 + 1), J3, L3 - x3, G3, E3 - oe2], x3 = oe2, J3 = G3, L3 = E3;
                  break;
                case w3:
                  D3.lastIndex = L3 + 1, D3.test(z3), D3.lastIndex === 0 ? E3 = z3.length - 1 : E3 = D3.lastIndex - 2, A3 = ["at-word", z3.slice(L3, E3 + 1), J3, L3 - x3, J3, E3 - x3], L3 = E3;
                  break;
                case c3:
                  for (E3 = L3, ie2 = true; z3.charCodeAt(E3 + 1) === c3; )
                    E3 += 1, ie2 = !ie2;
                  if ($3 = z3.charCodeAt(E3 + 1), ie2 && $3 !== f3 && $3 !== h3 && $3 !== l3 && $3 !== p3 && $3 !== r3 && $3 !== u3 && (E3 += 1, Y3.test(z3.charAt(E3)))) {
                    for (; Y3.test(z3.charAt(E3 + 1)); )
                      E3 += 1;
                    z3.charCodeAt(E3 + 1) === h3 && (E3 += 1);
                  }
                  A3 = ["word", z3.slice(L3, E3 + 1), J3, L3 - x3, J3, E3 - x3], L3 = E3;
                  break;
                default:
                  k3 = z3.charCodeAt(L3 + 1), $3 === R3 && k3 === d3 ? (E3 = L3, ke2(), ae2 = z3.slice(L3, E3 + 1), ue2 = ae2.split(`
`), fe2 = ue2.length - 1, fe2 > 0 ? (G3 = J3 + fe2, oe2 = E3 - ue2[fe2].length) : (G3 = J3, oe2 = x3), A3 = ["word", ae2, J3, L3 - x3, G3, E3 - oe2], x3 = oe2, J3 = G3, L3 = E3) : $3 === f3 && k3 === v3 ? (E3 = z3.indexOf("*/", L3 + 2) + 1, E3 === 0 && (P3 ? E3 = z3.length : Oe2("comment")), ae2 = z3.slice(L3, E3 + 1), ue2 = ae2.split(`
`), fe2 = ue2.length - 1, fe2 > 0 ? (G3 = J3 + fe2, oe2 = E3 - ue2[fe2].length) : (G3 = J3, oe2 = x3), A3 = ["comment", ae2, J3, L3 - x3, G3, E3 - oe2], x3 = oe2, J3 = G3, L3 = E3) : $3 === f3 && k3 === f3 ? (ee2.lastIndex = L3 + 1, ee2.test(z3), ee2.lastIndex === 0 ? E3 = z3.length - 1 : E3 = ee2.lastIndex - 2, ae2 = z3.slice(L3, E3 + 1), A3 = ["comment", ae2, J3, L3 - x3, J3, E3 - x3, "inline"], L3 = E3) : (U3.lastIndex = L3 + 1, U3.test(z3), U3.lastIndex === 0 ? E3 = z3.length - 1 : E3 = U3.lastIndex - 2, A3 = ["word", z3.slice(L3, E3 + 1), J3, L3 - x3, J3, E3 - x3], we2.push(A3), L3 = E3);
                  break;
              }
              return L3++, A3;
            }
          }
          function Ae2(xe2) {
            ye2.push(xe2);
          }
          return { back: Ae2, nextToken: ge2, endOfFile: Ee2 };
        };
      } }), gi2 = O3({ "node_modules/postcss-scss/lib/scss-parser.js"(t3, a3) {
        T3();
        function o3(u3, p3) {
          u3.prototype = Object.create(p3.prototype), u3.prototype.constructor = u3, u3.__proto__ = p3;
        }
        var s3 = gt2(), c3 = Qt2(), f3 = vi2(), l3 = yi2(), h3 = function(u3) {
          o3(p3, u3);
          function p3() {
            return u3.apply(this, arguments) || this;
          }
          var r3 = p3.prototype;
          return r3.createTokenizer = function() {
            this.tokenizer = l3(this.input);
          }, r3.rule = function(e28) {
            for (var i = false, n3 = 0, m3 = "", y3 = e28, d3 = Array.isArray(y3), g3 = 0, y3 = d3 ? y3 : y3[Symbol.iterator](); ; ) {
              var v3;
              if (d3) {
                if (g3 >= y3.length)
                  break;
                v3 = y3[g3++];
              } else {
                if (g3 = y3.next(), g3.done)
                  break;
                v3 = g3.value;
              }
              var b3 = v3;
              if (i)
                b3[0] !== "comment" && b3[0] !== "{" && (m3 += b3[1]);
              else {
                if (b3[0] === "space" && b3[1].indexOf(`
`) !== -1)
                  break;
                b3[0] === "(" ? n3 += 1 : b3[0] === ")" ? n3 -= 1 : n3 === 0 && b3[0] === ":" && (i = true);
              }
            }
            if (!i || m3.trim() === "" || /^[a-zA-Z-:#]/.test(m3))
              u3.prototype.rule.call(this, e28);
            else {
              e28.pop();
              var w3 = new f3();
              this.init(w3);
              var _3 = e28[e28.length - 1];
              for (_3[4] ? w3.source.end = { line: _3[4], column: _3[5] } : w3.source.end = { line: _3[2], column: _3[3] }; e28[0][0] !== "word"; )
                w3.raws.before += e28.shift()[1];
              for (w3.source.start = { line: e28[0][2], column: e28[0][3] }, w3.prop = ""; e28.length; ) {
                var R3 = e28[0][0];
                if (R3 === ":" || R3 === "space" || R3 === "comment")
                  break;
                w3.prop += e28.shift()[1];
              }
              w3.raws.between = "";
              for (var D3; e28.length; )
                if (D3 = e28.shift(), D3[0] === ":") {
                  w3.raws.between += D3[1];
                  break;
                } else
                  w3.raws.between += D3[1];
              (w3.prop[0] === "_" || w3.prop[0] === "*") && (w3.raws.before += w3.prop[0], w3.prop = w3.prop.slice(1)), w3.raws.between += this.spacesAndCommentsFromStart(e28), this.precheckMissedSemicolon(e28);
              for (var U3 = e28.length - 1; U3 > 0; U3--) {
                if (D3 = e28[U3], D3[1] === "!important") {
                  w3.important = true;
                  var X3 = this.stringFrom(e28, U3);
                  X3 = this.spacesFromEnd(e28) + X3, X3 !== " !important" && (w3.raws.important = X3);
                  break;
                } else if (D3[1] === "important") {
                  for (var Y3 = e28.slice(0), ee2 = "", V10 = U3; V10 > 0; V10--) {
                    var Z3 = Y3[V10][0];
                    if (ee2.trim().indexOf("!") === 0 && Z3 !== "space")
                      break;
                    ee2 = Y3.pop()[1] + ee2;
                  }
                  ee2.trim().indexOf("!") === 0 && (w3.important = true, w3.raws.important = ee2, e28 = Y3);
                }
                if (D3[0] !== "space" && D3[0] !== "comment")
                  break;
              }
              this.raw(w3, "value", e28), w3.value.indexOf(":") !== -1 && this.checkMissedSemicolon(e28), this.current = w3;
            }
          }, r3.comment = function(e28) {
            if (e28[6] === "inline") {
              var i = new s3();
              this.init(i, e28[2], e28[3]), i.raws.inline = true, i.source.end = { line: e28[4], column: e28[5] };
              var n3 = e28[1].slice(2);
              if (/^\s*$/.test(n3))
                i.text = "", i.raws.left = n3, i.raws.right = "";
              else {
                var m3 = n3.match(/^(\s*)([^]*[^\s])(\s*)$/), d3 = m3[2].replace(/(\*\/|\/\*)/g, "*//*");
                i.text = d3, i.raws.left = m3[1], i.raws.right = m3[3], i.raws.text = m3[2];
              }
            } else
              u3.prototype.comment.call(this, e28);
          }, r3.raw = function(e28, i, n3) {
            if (u3.prototype.raw.call(this, e28, i, n3), e28.raws[i]) {
              var m3 = e28.raws[i].raw;
              e28.raws[i].raw = n3.reduce(function(d3, g3) {
                if (g3[0] === "comment" && g3[6] === "inline") {
                  var y3 = g3[1].slice(2).replace(/(\*\/|\/\*)/g, "*//*");
                  return d3 + "/*" + y3 + "*/";
                } else
                  return d3 + g3[1];
              }, ""), m3 !== e28.raws[i].raw && (e28.raws[i].scss = m3);
            }
          }, p3;
        }(c3);
        a3.exports = h3;
      } }), bi2 = O3({ "node_modules/postcss-scss/lib/scss-parse.js"(t3, a3) {
        T3();
        var o3 = vt2(), s3 = gi2();
        a3.exports = function(c3, f3) {
          var l3 = new o3(c3, f3), h3 = new s3(l3);
          return h3.parse(), h3.root;
        };
      } }), wi2 = O3({ "node_modules/postcss-scss/lib/scss-syntax.js"(t3, a3) {
        T3();
        var o3 = mi2(), s3 = bi2();
        a3.exports = { parse: s3, stringify: o3 };
      } });
      T3();
      var xi2 = ne2(), Vt2 = se2(), ki2 = ce2(), { hasPragma: _i2 } = ns2(), { locStart: Oi2, locEnd: Ti2 } = _r2(), { calculateLoc: ji2, replaceQuotesInInlineComments: Ai2 } = _r2(), Si2 = as2(), Ci2 = us2(), Yt2 = cs2(), Zn2 = ls2(), Ei2 = fs2(), Mi2 = ps2(), Ii2 = hs2(), Pi2 = ds2(), Ni2 = (t3) => {
        for (; t3.parent; )
          t3 = t3.parent;
        return t3;
      };
      function Ri2(t3, a3) {
        let { nodes: o3 } = t3, s3 = { open: null, close: null, groups: [], type: "paren_group" }, c3 = [s3], f3 = s3, l3 = { groups: [], type: "comma_group" }, h3 = [l3];
        for (let u3 = 0; u3 < o3.length; ++u3) {
          let p3 = o3[u3];
          if (Zn2(a3.parser, p3.value) && p3.type === "number" && p3.unit === ".." && Vt2(p3.value) === "." && (p3.value = p3.value.slice(0, -1), p3.unit = "..."), p3.type === "func" && p3.value === "selector" && (p3.group.groups = [Ve2(Ni2(t3).text.slice(p3.group.open.sourceIndex + 1, p3.group.close.sourceIndex))]), p3.type === "func" && p3.value === "url") {
            let r3 = p3.group && p3.group.groups || [], e28 = [];
            for (let i = 0; i < r3.length; i++) {
              let n3 = r3[i];
              n3.type === "comma_group" ? e28 = [...e28, ...n3.groups] : e28.push(n3);
            }
            if (Si2(e28) || !Ci2(e28) && !Mi2(e28[0])) {
              let i = Ii2({ groups: p3.group.groups });
              p3.group.groups = [i.trim()];
            }
          }
          if (p3.type === "paren" && p3.value === "(")
            s3 = { open: p3, close: null, groups: [], type: "paren_group" }, c3.push(s3), l3 = { groups: [], type: "comma_group" }, h3.push(l3);
          else if (p3.type === "paren" && p3.value === ")") {
            if (l3.groups.length > 0 && s3.groups.push(l3), s3.close = p3, h3.length === 1)
              throw new Error("Unbalanced parenthesis");
            h3.pop(), l3 = Vt2(h3), l3.groups.push(s3), c3.pop(), s3 = Vt2(c3);
          } else
            p3.type === "comma" ? (s3.groups.push(l3), l3 = { groups: [], type: "comma_group" }, h3[h3.length - 1] = l3) : l3.groups.push(p3);
        }
        return l3.groups.length > 0 && s3.groups.push(l3), f3;
      }
      function Xt2(t3) {
        return t3.type === "paren_group" && !t3.open && !t3.close && t3.groups.length === 1 || t3.type === "comma_group" && t3.groups.length === 1 ? Xt2(t3.groups[0]) : t3.type === "paren_group" || t3.type === "comma_group" ? Object.assign(Object.assign({}, t3), {}, { groups: t3.groups.map(Xt2) }) : t3;
      }
      function ut2(t3, a3, o3) {
        if (t3 && typeof t3 == "object") {
          delete t3.parent;
          for (let s3 in t3)
            ut2(t3[s3], a3, o3), s3 === "type" && typeof t3[s3] == "string" && !t3[s3].startsWith(a3) && (!o3 || !o3.test(t3[s3])) && (t3[s3] = a3 + t3[s3]);
        }
        return t3;
      }
      function Kn2(t3) {
        if (t3 && typeof t3 == "object") {
          delete t3.parent;
          for (let a3 in t3)
            Kn2(t3[a3]);
          !Array.isArray(t3) && t3.value && !t3.type && (t3.type = "unknown");
        }
        return t3;
      }
      function eo2(t3, a3) {
        if (t3 && typeof t3 == "object") {
          for (let o3 in t3)
            o3 !== "parent" && (eo2(t3[o3], a3), o3 === "nodes" && (t3.group = Xt2(Ri2(t3, a3)), delete t3[o3]));
          delete t3.parent;
        }
        return t3;
      }
      function Qe2(t3, a3) {
        let o3 = Fs2(), s3 = null;
        try {
          s3 = o3(t3, { loose: true }).parse();
        } catch {
          return { type: "value-unknown", value: t3 };
        }
        s3.text = t3;
        let c3 = eo2(s3, a3);
        return ut2(c3, "value-", /^selector-/);
      }
      function Ve2(t3) {
        if (/\/\/|\/\*/.test(t3))
          return { type: "selector-unknown", value: t3.trim() };
        let a3 = qs2(), o3 = null;
        try {
          a3((s3) => {
            o3 = s3;
          }).process(t3);
        } catch {
          return { type: "selector-unknown", value: t3 };
        }
        return ut2(o3, "selector-");
      }
      function zi2(t3) {
        let a3 = Hs2().default, o3 = null;
        try {
          o3 = a3(t3);
        } catch {
          return { type: "selector-unknown", value: t3 };
        }
        return ut2(Kn2(o3), "media-");
      }
      var $i2 = /(\s*)(!default).*$/, Di2 = /(\s*)(!global).*$/;
      function to2(t3, a3) {
        if (t3 && typeof t3 == "object") {
          delete t3.parent;
          for (let u3 in t3)
            to2(t3[u3], a3);
          if (!t3.type)
            return t3;
          t3.raws || (t3.raws = {});
          let f3 = "";
          if (typeof t3.selector == "string") {
            var o3;
            f3 = t3.raws.selector ? (o3 = t3.raws.selector.scss) !== null && o3 !== void 0 ? o3 : t3.raws.selector.raw : t3.selector, t3.raws.between && t3.raws.between.trim().length > 0 && (f3 += t3.raws.between), t3.raws.selector = f3;
          }
          let l3 = "";
          if (typeof t3.value == "string") {
            var s3;
            l3 = t3.raws.value ? (s3 = t3.raws.value.scss) !== null && s3 !== void 0 ? s3 : t3.raws.value.raw : t3.value, l3 = l3.trim(), t3.raws.value = l3;
          }
          let h3 = "";
          if (typeof t3.params == "string") {
            var c3;
            h3 = t3.raws.params ? (c3 = t3.raws.params.scss) !== null && c3 !== void 0 ? c3 : t3.raws.params.raw : t3.params, t3.raws.afterName && t3.raws.afterName.trim().length > 0 && (h3 = t3.raws.afterName + h3), t3.raws.between && t3.raws.between.trim().length > 0 && (h3 = h3 + t3.raws.between), h3 = h3.trim(), t3.raws.params = h3;
          }
          if (f3.trim().length > 0)
            return f3.startsWith("@") && f3.endsWith(":") ? t3 : t3.mixin ? (t3.selector = Qe2(f3, a3), t3) : (Ei2(t3) && (t3.isSCSSNesterProperty = true), t3.selector = Ve2(f3), t3);
          if (l3.length > 0) {
            let u3 = l3.match($i2);
            u3 && (l3 = l3.slice(0, u3.index), t3.scssDefault = true, u3[0].trim() !== "!default" && (t3.raws.scssDefault = u3[0]));
            let p3 = l3.match(Di2);
            if (p3 && (l3 = l3.slice(0, p3.index), t3.scssGlobal = true, p3[0].trim() !== "!global" && (t3.raws.scssGlobal = p3[0])), l3.startsWith("progid:"))
              return { type: "value-unknown", value: l3 };
            t3.value = Qe2(l3, a3);
          }
          if (Yt2(a3) && t3.type === "css-decl" && l3.startsWith("extend(") && (t3.extend || (t3.extend = t3.raws.between === ":"), t3.extend && !t3.selector && (delete t3.value, t3.selector = Ve2(l3.slice(7, -1)))), t3.type === "css-atrule") {
            if (Yt2(a3)) {
              if (t3.mixin) {
                let u3 = t3.raws.identifier + t3.name + t3.raws.afterName + t3.raws.params;
                return t3.selector = Ve2(u3), delete t3.params, t3;
              }
              if (t3.function)
                return t3;
            }
            if (a3.parser === "css" && t3.name === "custom-selector") {
              let u3 = t3.params.match(/:--\S+\s+/)[0].trim();
              return t3.customSelector = u3, t3.selector = Ve2(t3.params.slice(u3.length).trim()), delete t3.params, t3;
            }
            if (Yt2(a3)) {
              if (t3.name.includes(":") && !t3.params) {
                t3.variable = true;
                let u3 = t3.name.split(":");
                t3.name = u3[0], t3.value = Qe2(u3.slice(1).join(":"), a3);
              }
              if (!["page", "nest", "keyframes"].includes(t3.name) && t3.params && t3.params[0] === ":") {
                t3.variable = true;
                let u3 = t3.params.slice(1);
                u3 && (t3.value = Qe2(u3, a3)), t3.raws.afterName += ":";
              }
              if (t3.variable)
                return delete t3.params, t3.value || delete t3.value, t3;
            }
          }
          if (t3.type === "css-atrule" && h3.length > 0) {
            let { name: u3 } = t3, p3 = t3.name.toLowerCase();
            return u3 === "warn" || u3 === "error" ? (t3.params = { type: "media-unknown", value: h3 }, t3) : u3 === "extend" || u3 === "nest" ? (t3.selector = Ve2(h3), delete t3.params, t3) : u3 === "at-root" ? (/^\(\s*(?:without|with)\s*:.+\)$/s.test(h3) ? t3.params = Qe2(h3, a3) : (t3.selector = Ve2(h3), delete t3.params), t3) : Pi2(p3) ? (t3.import = true, delete t3.filename, t3.params = Qe2(h3, a3), t3) : ["namespace", "supports", "if", "else", "for", "each", "while", "debug", "mixin", "include", "function", "return", "define-mixin", "add-mixin"].includes(u3) ? (h3 = h3.replace(/(\$\S+?)(\s+)?\.{3}/, "$1...$2"), h3 = h3.replace(/^(?!if)(\S+)(\s+)\(/, "$1($2"), t3.value = Qe2(h3, a3), delete t3.params, t3) : ["media", "custom-media"].includes(p3) ? h3.includes("#{") ? { type: "media-unknown", value: h3 } : (t3.params = zi2(h3), t3) : (t3.params = h3, t3);
          }
        }
        return t3;
      }
      function ro2(t3, a3, o3) {
        let s3 = ki2(a3), { frontMatter: c3 } = s3;
        a3 = s3.content;
        let f3;
        try {
          f3 = t3(a3);
        } catch (l3) {
          let { name: h3, reason: u3, line: p3, column: r3 } = l3;
          throw typeof p3 != "number" ? l3 : xi2(`${h3}: ${u3}`, { start: { line: p3, column: r3 } });
        }
        return f3 = to2(ut2(f3, "css-"), o3), ji2(f3, a3), c3 && (c3.source = { startOffset: 0, endOffset: c3.raw.length }, f3.nodes.unshift(c3)), f3;
      }
      function Wi2(t3, a3) {
        let o3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s3 = Zn2(o3.parser, t3) ? [Kt2, Zt2] : [Zt2, Kt2], c3;
        for (let f3 of s3)
          try {
            return f3(t3, a3, o3);
          } catch (l3) {
            c3 = c3 || l3;
          }
        if (c3)
          throw c3;
      }
      function Zt2(t3, a3) {
        let o3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s3 = hi2();
        return ro2((c3) => s3.parse(Ai2(c3)), t3, o3);
      }
      function Kt2(t3, a3) {
        let o3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, { parse: s3 } = wi2();
        return ro2(s3, t3, o3);
      }
      var er2 = { astFormat: "postcss", hasPragma: _i2, locStart: Oi2, locEnd: Ti2 };
      S3.exports = { parsers: { css: Object.assign(Object.assign({}, er2), {}, { parse: Wi2 }), less: Object.assign(Object.assign({}, er2), {}, { parse: Zt2 }), scss: Object.assign(Object.assign({}, er2), {}, { parse: Kt2 }) } };
    });
    return Ho2();
  });
})(s$12);
var Ui$1 = s$12.exports;
const qi$1 = /* @__PURE__ */ l$Y(Ui$1);
var a$14 = { exports: {} };
(function(Hu2, cl) {
  (function(Ie2) {
    Hu2.exports = Ie2();
  })(function() {
    var Ie2 = (Pe2, oe2) => () => (oe2 || Pe2((oe2 = { exports: {} }).exports, oe2), oe2.exports), jt2 = Ie2((Pe2, oe2) => {
      var ue2 = function(ce2) {
        return ce2 && ce2.Math == Math && ce2;
      };
      oe2.exports = ue2(typeof globalThis == "object" && globalThis) || ue2(typeof window == "object" && window) || ue2(typeof self == "object" && self) || ue2(typeof o$R == "object" && o$R) || function() {
        return this;
      }() || Function("return this")();
    }), Lt2 = Ie2((Pe2, oe2) => {
      oe2.exports = function(ue2) {
        try {
          return !!ue2();
        } catch {
          return true;
        }
      };
    }), Mt2 = Ie2((Pe2, oe2) => {
      var ue2 = Lt2();
      oe2.exports = !ue2(function() {
        return Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1] != 7;
      });
    }), Mn2 = Ie2((Pe2, oe2) => {
      var ue2 = Lt2();
      oe2.exports = !ue2(function() {
        var ce2 = function() {
        }.bind();
        return typeof ce2 != "function" || ce2.hasOwnProperty("prototype");
      });
    }), Ut2 = Ie2((Pe2, oe2) => {
      var ue2 = Mn2(), ce2 = Function.prototype.call;
      oe2.exports = ue2 ? ce2.bind(ce2) : function() {
        return ce2.apply(ce2, arguments);
      };
    }), Zu2 = Ie2((Pe2) => {
      var oe2 = {}.propertyIsEnumerable, ue2 = Object.getOwnPropertyDescriptor, ce2 = ue2 && !oe2.call({ 1: 2 }, 1);
      Pe2.f = ce2 ? function(se2) {
        var Ce2 = ue2(this, se2);
        return !!Ce2 && Ce2.enumerable;
      } : oe2;
    }), $n2 = Ie2((Pe2, oe2) => {
      oe2.exports = function(ue2, ce2) {
        return { enumerable: !(ue2 & 1), configurable: !(ue2 & 2), writable: !(ue2 & 4), value: ce2 };
      };
    }), _t2 = Ie2((Pe2, oe2) => {
      var ue2 = Mn2(), ce2 = Function.prototype, se2 = ce2.call, Ce2 = ue2 && ce2.bind.bind(se2, se2);
      oe2.exports = ue2 ? Ce2 : function(be2) {
        return function() {
          return se2.apply(be2, arguments);
        };
      };
    }), gn2 = Ie2((Pe2, oe2) => {
      var ue2 = _t2(), ce2 = ue2({}.toString), se2 = ue2("".slice);
      oe2.exports = function(Ce2) {
        return se2(ce2(Ce2), 8, -1);
      };
    }), ei2 = Ie2((Pe2, oe2) => {
      var ue2 = _t2(), ce2 = Lt2(), se2 = gn2(), Ce2 = Object, be2 = ue2("".split);
      oe2.exports = ce2(function() {
        return !Ce2("z").propertyIsEnumerable(0);
      }) ? function(Ne2) {
        return se2(Ne2) == "String" ? be2(Ne2, "") : Ce2(Ne2);
      } : Ce2;
    }), Rn2 = Ie2((Pe2, oe2) => {
      oe2.exports = function(ue2) {
        return ue2 == null;
      };
    }), Fr2 = Ie2((Pe2, oe2) => {
      var ue2 = Rn2(), ce2 = TypeError;
      oe2.exports = function(se2) {
        if (ue2(se2))
          throw ce2("Can't call method on " + se2);
        return se2;
      };
    }), Vn2 = Ie2((Pe2, oe2) => {
      var ue2 = ei2(), ce2 = Fr2();
      oe2.exports = function(se2) {
        return ue2(ce2(se2));
      };
    }), Ar2 = Ie2((Pe2, oe2) => {
      var ue2 = typeof document == "object" && document.all, ce2 = typeof ue2 > "u" && ue2 !== void 0;
      oe2.exports = { all: ue2, IS_HTMLDDA: ce2 };
    }), kt2 = Ie2((Pe2, oe2) => {
      var ue2 = Ar2(), ce2 = ue2.all;
      oe2.exports = ue2.IS_HTMLDDA ? function(se2) {
        return typeof se2 == "function" || se2 === ce2;
      } : function(se2) {
        return typeof se2 == "function";
      };
    }), Yt2 = Ie2((Pe2, oe2) => {
      var ue2 = kt2(), ce2 = Ar2(), se2 = ce2.all;
      oe2.exports = ce2.IS_HTMLDDA ? function(Ce2) {
        return typeof Ce2 == "object" ? Ce2 !== null : ue2(Ce2) || Ce2 === se2;
      } : function(Ce2) {
        return typeof Ce2 == "object" ? Ce2 !== null : ue2(Ce2);
      };
    }), yn2 = Ie2((Pe2, oe2) => {
      var ue2 = jt2(), ce2 = kt2(), se2 = function(Ce2) {
        return ce2(Ce2) ? Ce2 : void 0;
      };
      oe2.exports = function(Ce2, be2) {
        return arguments.length < 2 ? se2(ue2[Ce2]) : ue2[Ce2] && ue2[Ce2][be2];
      };
    }), vr2 = Ie2((Pe2, oe2) => {
      var ue2 = _t2();
      oe2.exports = ue2({}.isPrototypeOf);
    }), ti2 = Ie2((Pe2, oe2) => {
      var ue2 = yn2();
      oe2.exports = ue2("navigator", "userAgent") || "";
    }), ni2 = Ie2((Pe2, oe2) => {
      var ue2 = jt2(), ce2 = ti2(), se2 = ue2.process, Ce2 = ue2.Deno, be2 = se2 && se2.versions || Ce2 && Ce2.version, Ne2 = be2 && be2.v8, Te2, ke2;
      Ne2 && (Te2 = Ne2.split("."), ke2 = Te2[0] > 0 && Te2[0] < 4 ? 1 : +(Te2[0] + Te2[1])), !ke2 && ce2 && (Te2 = ce2.match(/Edge\/(\d+)/), (!Te2 || Te2[1] >= 74) && (Te2 = ce2.match(/Chrome\/(\d+)/), Te2 && (ke2 = +Te2[1]))), oe2.exports = ke2;
    }), xr2 = Ie2((Pe2, oe2) => {
      var ue2 = ni2(), ce2 = Lt2();
      oe2.exports = !!Object.getOwnPropertySymbols && !ce2(function() {
        var se2 = Symbol();
        return !String(se2) || !(Object(se2) instanceof Symbol) || !Symbol.sham && ue2 && ue2 < 41;
      });
    }), br2 = Ie2((Pe2, oe2) => {
      var ue2 = xr2();
      oe2.exports = ue2 && !Symbol.sham && typeof Symbol.iterator == "symbol";
    }), Sr2 = Ie2((Pe2, oe2) => {
      var ue2 = yn2(), ce2 = kt2(), se2 = vr2(), Ce2 = br2(), be2 = Object;
      oe2.exports = Ce2 ? function(Ne2) {
        return typeof Ne2 == "symbol";
      } : function(Ne2) {
        var Te2 = ue2("Symbol");
        return ce2(Te2) && se2(Te2.prototype, be2(Ne2));
      };
    }), Jn2 = Ie2((Pe2, oe2) => {
      var ue2 = String;
      oe2.exports = function(ce2) {
        try {
          return ue2(ce2);
        } catch {
          return "Object";
        }
      };
    }), hn2 = Ie2((Pe2, oe2) => {
      var ue2 = kt2(), ce2 = Jn2(), se2 = TypeError;
      oe2.exports = function(Ce2) {
        if (ue2(Ce2))
          return Ce2;
        throw se2(ce2(Ce2) + " is not a function");
      };
    }), qn2 = Ie2((Pe2, oe2) => {
      var ue2 = hn2(), ce2 = Rn2();
      oe2.exports = function(se2, Ce2) {
        var be2 = se2[Ce2];
        return ce2(be2) ? void 0 : ue2(be2);
      };
    }), ri2 = Ie2((Pe2, oe2) => {
      var ue2 = Ut2(), ce2 = kt2(), se2 = Yt2(), Ce2 = TypeError;
      oe2.exports = function(be2, Ne2) {
        var Te2, ke2;
        if (Ne2 === "string" && ce2(Te2 = be2.toString) && !se2(ke2 = ue2(Te2, be2)) || ce2(Te2 = be2.valueOf) && !se2(ke2 = ue2(Te2, be2)) || Ne2 !== "string" && ce2(Te2 = be2.toString) && !se2(ke2 = ue2(Te2, be2)))
          return ke2;
        throw Ce2("Can't convert object to primitive value");
      };
    }), ui2 = Ie2((Pe2, oe2) => {
      oe2.exports = false;
    }), Gn2 = Ie2((Pe2, oe2) => {
      var ue2 = jt2(), ce2 = Object.defineProperty;
      oe2.exports = function(se2, Ce2) {
        try {
          ce2(ue2, se2, { value: Ce2, configurable: true, writable: true });
        } catch {
          ue2[se2] = Ce2;
        }
        return Ce2;
      };
    }), Wn2 = Ie2((Pe2, oe2) => {
      var ue2 = jt2(), ce2 = Gn2(), se2 = "__core-js_shared__", Ce2 = ue2[se2] || ce2(se2, {});
      oe2.exports = Ce2;
    }), Tr2 = Ie2((Pe2, oe2) => {
      var ue2 = ui2(), ce2 = Wn2();
      (oe2.exports = function(se2, Ce2) {
        return ce2[se2] || (ce2[se2] = Ce2 !== void 0 ? Ce2 : {});
      })("versions", []).push({ version: "3.26.1", mode: ue2 ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE", source: "https://github.com/zloirock/core-js" });
    }), Xn2 = Ie2((Pe2, oe2) => {
      var ue2 = Fr2(), ce2 = Object;
      oe2.exports = function(se2) {
        return ce2(ue2(se2));
      };
    }), Jt2 = Ie2((Pe2, oe2) => {
      var ue2 = _t2(), ce2 = Xn2(), se2 = ue2({}.hasOwnProperty);
      oe2.exports = Object.hasOwn || function(Ce2, be2) {
        return se2(ce2(Ce2), be2);
      };
    }), Br2 = Ie2((Pe2, oe2) => {
      var ue2 = _t2(), ce2 = 0, se2 = Math.random(), Ce2 = ue2(1 .toString);
      oe2.exports = function(be2) {
        return "Symbol(" + (be2 === void 0 ? "" : be2) + ")_" + Ce2(++ce2 + se2, 36);
      };
    }), zt2 = Ie2((Pe2, oe2) => {
      var ue2 = jt2(), ce2 = Tr2(), se2 = Jt2(), Ce2 = Br2(), be2 = xr2(), Ne2 = br2(), Te2 = ce2("wks"), ke2 = ue2.Symbol, Ve2 = ke2 && ke2.for, We2 = Ne2 ? ke2 : ke2 && ke2.withoutSetter || Ce2;
      oe2.exports = function(Xe2) {
        if (!se2(Te2, Xe2) || !(be2 || typeof Te2[Xe2] == "string")) {
          var Je2 = "Symbol." + Xe2;
          be2 && se2(ke2, Xe2) ? Te2[Xe2] = ke2[Xe2] : Ne2 && Ve2 ? Te2[Xe2] = Ve2(Je2) : Te2[Xe2] = We2(Je2);
        }
        return Te2[Xe2];
      };
    }), ii2 = Ie2((Pe2, oe2) => {
      var ue2 = Ut2(), ce2 = Yt2(), se2 = Sr2(), Ce2 = qn2(), be2 = ri2(), Ne2 = zt2(), Te2 = TypeError, ke2 = Ne2("toPrimitive");
      oe2.exports = function(Ve2, We2) {
        if (!ce2(Ve2) || se2(Ve2))
          return Ve2;
        var Xe2 = Ce2(Ve2, ke2), Je2;
        if (Xe2) {
          if (We2 === void 0 && (We2 = "default"), Je2 = ue2(Xe2, Ve2, We2), !ce2(Je2) || se2(Je2))
            return Je2;
          throw Te2("Can't convert object to primitive value");
        }
        return We2 === void 0 && (We2 = "number"), be2(Ve2, We2);
      };
    }), Un2 = Ie2((Pe2, oe2) => {
      var ue2 = ii2(), ce2 = Sr2();
      oe2.exports = function(se2) {
        var Ce2 = ue2(se2, "string");
        return ce2(Ce2) ? Ce2 : Ce2 + "";
      };
    }), ai2 = Ie2((Pe2, oe2) => {
      var ue2 = jt2(), ce2 = Yt2(), se2 = ue2.document, Ce2 = ce2(se2) && ce2(se2.createElement);
      oe2.exports = function(be2) {
        return Ce2 ? se2.createElement(be2) : {};
      };
    }), wr2 = Ie2((Pe2, oe2) => {
      var ue2 = Mt2(), ce2 = Lt2(), se2 = ai2();
      oe2.exports = !ue2 && !ce2(function() {
        return Object.defineProperty(se2("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    }), Nr2 = Ie2((Pe2) => {
      var oe2 = Mt2(), ue2 = Ut2(), ce2 = Zu2(), se2 = $n2(), Ce2 = Vn2(), be2 = Un2(), Ne2 = Jt2(), Te2 = wr2(), ke2 = Object.getOwnPropertyDescriptor;
      Pe2.f = oe2 ? ke2 : function(Ve2, We2) {
        if (Ve2 = Ce2(Ve2), We2 = be2(We2), Te2)
          try {
            return ke2(Ve2, We2);
          } catch {
          }
        if (Ne2(Ve2, We2))
          return se2(!ue2(ce2.f, Ve2, We2), Ve2[We2]);
      };
    }), si2 = Ie2((Pe2, oe2) => {
      var ue2 = Mt2(), ce2 = Lt2();
      oe2.exports = ue2 && ce2(function() {
        return Object.defineProperty(function() {
        }, "prototype", { value: 42, writable: false }).prototype != 42;
      });
    }), Kt2 = Ie2((Pe2, oe2) => {
      var ue2 = Yt2(), ce2 = String, se2 = TypeError;
      oe2.exports = function(Ce2) {
        if (ue2(Ce2))
          return Ce2;
        throw se2(ce2(Ce2) + " is not an object");
      };
    }), un2 = Ie2((Pe2) => {
      var oe2 = Mt2(), ue2 = wr2(), ce2 = si2(), se2 = Kt2(), Ce2 = Un2(), be2 = TypeError, Ne2 = Object.defineProperty, Te2 = Object.getOwnPropertyDescriptor, ke2 = "enumerable", Ve2 = "configurable", We2 = "writable";
      Pe2.f = oe2 ? ce2 ? function(Xe2, Je2, X3) {
        if (se2(Xe2), Je2 = Ce2(Je2), se2(X3), typeof Xe2 == "function" && Je2 === "prototype" && "value" in X3 && We2 in X3 && !X3[We2]) {
          var Ke2 = Te2(Xe2, Je2);
          Ke2 && Ke2[We2] && (Xe2[Je2] = X3.value, X3 = { configurable: Ve2 in X3 ? X3[Ve2] : Ke2[Ve2], enumerable: ke2 in X3 ? X3[ke2] : Ke2[ke2], writable: false });
        }
        return Ne2(Xe2, Je2, X3);
      } : Ne2 : function(Xe2, Je2, X3) {
        if (se2(Xe2), Je2 = Ce2(Je2), se2(X3), ue2)
          try {
            return Ne2(Xe2, Je2, X3);
          } catch {
          }
        if ("get" in X3 || "set" in X3)
          throw be2("Accessors not supported");
        return "value" in X3 && (Xe2[Je2] = X3.value), Xe2;
      };
    }), kr2 = Ie2((Pe2, oe2) => {
      var ue2 = Mt2(), ce2 = un2(), se2 = $n2();
      oe2.exports = ue2 ? function(Ce2, be2, Ne2) {
        return ce2.f(Ce2, be2, se2(1, Ne2));
      } : function(Ce2, be2, Ne2) {
        return Ce2[be2] = Ne2, Ce2;
      };
    }), oi2 = Ie2((Pe2, oe2) => {
      var ue2 = Mt2(), ce2 = Jt2(), se2 = Function.prototype, Ce2 = ue2 && Object.getOwnPropertyDescriptor, be2 = ce2(se2, "name"), Ne2 = be2 && function() {
      }.name === "something", Te2 = be2 && (!ue2 || ue2 && Ce2(se2, "name").configurable);
      oe2.exports = { EXISTS: be2, PROPER: Ne2, CONFIGURABLE: Te2 };
    }), Pr2 = Ie2((Pe2, oe2) => {
      var ue2 = _t2(), ce2 = kt2(), se2 = Wn2(), Ce2 = ue2(Function.toString);
      ce2(se2.inspectSource) || (se2.inspectSource = function(be2) {
        return Ce2(be2);
      }), oe2.exports = se2.inspectSource;
    }), li2 = Ie2((Pe2, oe2) => {
      var ue2 = jt2(), ce2 = kt2(), se2 = ue2.WeakMap;
      oe2.exports = ce2(se2) && /native code/.test(String(se2));
    }), pi2 = Ie2((Pe2, oe2) => {
      var ue2 = Tr2(), ce2 = Br2(), se2 = ue2("keys");
      oe2.exports = function(Ce2) {
        return se2[Ce2] || (se2[Ce2] = ce2(Ce2));
      };
    }), jr2 = Ie2((Pe2, oe2) => {
      oe2.exports = {};
    }), ci2 = Ie2((Pe2, oe2) => {
      var ue2 = li2(), ce2 = jt2(), se2 = Yt2(), Ce2 = kr2(), be2 = Jt2(), Ne2 = Wn2(), Te2 = pi2(), ke2 = jr2(), Ve2 = "Object already initialized", We2 = ce2.TypeError, Xe2 = ce2.WeakMap, Je2, X3, Ke2, rt2 = function(H3) {
        return Ke2(H3) ? X3(H3) : Je2(H3, {});
      }, pt2 = function(H3) {
        return function(xt2) {
          var qt2;
          if (!se2(xt2) || (qt2 = X3(xt2)).type !== H3)
            throw We2("Incompatible receiver, " + H3 + " required");
          return qt2;
        };
      };
      ue2 || Ne2.state ? (lt2 = Ne2.state || (Ne2.state = new Xe2()), lt2.get = lt2.get, lt2.has = lt2.has, lt2.set = lt2.set, Je2 = function(H3, xt2) {
        if (lt2.has(H3))
          throw We2(Ve2);
        return xt2.facade = H3, lt2.set(H3, xt2), xt2;
      }, X3 = function(H3) {
        return lt2.get(H3) || {};
      }, Ke2 = function(H3) {
        return lt2.has(H3);
      }) : (yt2 = Te2("state"), ke2[yt2] = true, Je2 = function(H3, xt2) {
        if (be2(H3, yt2))
          throw We2(Ve2);
        return xt2.facade = H3, Ce2(H3, yt2, xt2), xt2;
      }, X3 = function(H3) {
        return be2(H3, yt2) ? H3[yt2] : {};
      }, Ke2 = function(H3) {
        return be2(H3, yt2);
      });
      var lt2, yt2;
      oe2.exports = { set: Je2, get: X3, has: Ke2, enforce: rt2, getterFor: pt2 };
    }), Ir2 = Ie2((Pe2, oe2) => {
      var ue2 = Lt2(), ce2 = kt2(), se2 = Jt2(), Ce2 = Mt2(), be2 = oi2().CONFIGURABLE, Ne2 = Pr2(), Te2 = ci2(), ke2 = Te2.enforce, Ve2 = Te2.get, We2 = Object.defineProperty, Xe2 = Ce2 && !ue2(function() {
        return We2(function() {
        }, "length", { value: 8 }).length !== 8;
      }), Je2 = String(String).split("String"), X3 = oe2.exports = function(Ke2, rt2, pt2) {
        String(rt2).slice(0, 7) === "Symbol(" && (rt2 = "[" + String(rt2).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), pt2 && pt2.getter && (rt2 = "get " + rt2), pt2 && pt2.setter && (rt2 = "set " + rt2), (!se2(Ke2, "name") || be2 && Ke2.name !== rt2) && (Ce2 ? We2(Ke2, "name", { value: rt2, configurable: true }) : Ke2.name = rt2), Xe2 && pt2 && se2(pt2, "arity") && Ke2.length !== pt2.arity && We2(Ke2, "length", { value: pt2.arity });
        try {
          pt2 && se2(pt2, "constructor") && pt2.constructor ? Ce2 && We2(Ke2, "prototype", { writable: false }) : Ke2.prototype && (Ke2.prototype = void 0);
        } catch {
        }
        var lt2 = ke2(Ke2);
        return se2(lt2, "source") || (lt2.source = Je2.join(typeof rt2 == "string" ? rt2 : "")), Ke2;
      };
      Function.prototype.toString = X3(function() {
        return ce2(this) && Ve2(this).source || Ne2(this);
      }, "toString");
    }), di2 = Ie2((Pe2, oe2) => {
      var ue2 = kt2(), ce2 = un2(), se2 = Ir2(), Ce2 = Gn2();
      oe2.exports = function(be2, Ne2, Te2, ke2) {
        ke2 || (ke2 = {});
        var Ve2 = ke2.enumerable, We2 = ke2.name !== void 0 ? ke2.name : Ne2;
        if (ue2(Te2) && se2(Te2, We2, ke2), ke2.global)
          Ve2 ? be2[Ne2] = Te2 : Ce2(Ne2, Te2);
        else {
          try {
            ke2.unsafe ? be2[Ne2] && (Ve2 = true) : delete be2[Ne2];
          } catch {
          }
          Ve2 ? be2[Ne2] = Te2 : ce2.f(be2, Ne2, { value: Te2, enumerable: false, configurable: !ke2.nonConfigurable, writable: !ke2.nonWritable });
        }
        return be2;
      };
    }), Di2 = Ie2((Pe2, oe2) => {
      var ue2 = Math.ceil, ce2 = Math.floor;
      oe2.exports = Math.trunc || function(se2) {
        var Ce2 = +se2;
        return (Ce2 > 0 ? ce2 : ue2)(Ce2);
      };
    }), Yn2 = Ie2((Pe2, oe2) => {
      var ue2 = Di2();
      oe2.exports = function(ce2) {
        var se2 = +ce2;
        return se2 !== se2 || se2 === 0 ? 0 : ue2(se2);
      };
    }), fi2 = Ie2((Pe2, oe2) => {
      var ue2 = Yn2(), ce2 = Math.max, se2 = Math.min;
      oe2.exports = function(Ce2, be2) {
        var Ne2 = ue2(Ce2);
        return Ne2 < 0 ? ce2(Ne2 + be2, 0) : se2(Ne2, be2);
      };
    }), mi2 = Ie2((Pe2, oe2) => {
      var ue2 = Yn2(), ce2 = Math.min;
      oe2.exports = function(se2) {
        return se2 > 0 ? ce2(ue2(se2), 9007199254740991) : 0;
      };
    }), an2 = Ie2((Pe2, oe2) => {
      var ue2 = mi2();
      oe2.exports = function(ce2) {
        return ue2(ce2.length);
      };
    }), gi2 = Ie2((Pe2, oe2) => {
      var ue2 = Vn2(), ce2 = fi2(), se2 = an2(), Ce2 = function(be2) {
        return function(Ne2, Te2, ke2) {
          var Ve2 = ue2(Ne2), We2 = se2(Ve2), Xe2 = ce2(ke2, We2), Je2;
          if (be2 && Te2 != Te2) {
            for (; We2 > Xe2; )
              if (Je2 = Ve2[Xe2++], Je2 != Je2)
                return true;
          } else
            for (; We2 > Xe2; Xe2++)
              if ((be2 || Xe2 in Ve2) && Ve2[Xe2] === Te2)
                return be2 || Xe2 || 0;
          return !be2 && -1;
        };
      };
      oe2.exports = { includes: Ce2(true), indexOf: Ce2(false) };
    }), yi2 = Ie2((Pe2, oe2) => {
      var ue2 = _t2(), ce2 = Jt2(), se2 = Vn2(), Ce2 = gi2().indexOf, be2 = jr2(), Ne2 = ue2([].push);
      oe2.exports = function(Te2, ke2) {
        var Ve2 = se2(Te2), We2 = 0, Xe2 = [], Je2;
        for (Je2 in Ve2)
          !ce2(be2, Je2) && ce2(Ve2, Je2) && Ne2(Xe2, Je2);
        for (; ke2.length > We2; )
          ce2(Ve2, Je2 = ke2[We2++]) && (~Ce2(Xe2, Je2) || Ne2(Xe2, Je2));
        return Xe2;
      };
    }), hi2 = Ie2((Pe2, oe2) => {
      oe2.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    }), Ei2 = Ie2((Pe2) => {
      var oe2 = yi2(), ue2 = hi2(), ce2 = ue2.concat("length", "prototype");
      Pe2.f = Object.getOwnPropertyNames || function(se2) {
        return oe2(se2, ce2);
      };
    }), Ci2 = Ie2((Pe2) => {
      Pe2.f = Object.getOwnPropertySymbols;
    }), Fi2 = Ie2((Pe2, oe2) => {
      var ue2 = yn2(), ce2 = _t2(), se2 = Ei2(), Ce2 = Ci2(), be2 = Kt2(), Ne2 = ce2([].concat);
      oe2.exports = ue2("Reflect", "ownKeys") || function(Te2) {
        var ke2 = se2.f(be2(Te2)), Ve2 = Ce2.f;
        return Ve2 ? Ne2(ke2, Ve2(Te2)) : ke2;
      };
    }), Ai2 = Ie2((Pe2, oe2) => {
      var ue2 = Jt2(), ce2 = Fi2(), se2 = Nr2(), Ce2 = un2();
      oe2.exports = function(be2, Ne2, Te2) {
        for (var ke2 = ce2(Ne2), Ve2 = Ce2.f, We2 = se2.f, Xe2 = 0; Xe2 < ke2.length; Xe2++) {
          var Je2 = ke2[Xe2];
          !ue2(be2, Je2) && !(Te2 && ue2(Te2, Je2)) && Ve2(be2, Je2, We2(Ne2, Je2));
        }
      };
    }), vi2 = Ie2((Pe2, oe2) => {
      var ue2 = Lt2(), ce2 = kt2(), se2 = /#|\.prototype\./, Ce2 = function(Ve2, We2) {
        var Xe2 = Ne2[be2(Ve2)];
        return Xe2 == ke2 ? true : Xe2 == Te2 ? false : ce2(We2) ? ue2(We2) : !!We2;
      }, be2 = Ce2.normalize = function(Ve2) {
        return String(Ve2).replace(se2, ".").toLowerCase();
      }, Ne2 = Ce2.data = {}, Te2 = Ce2.NATIVE = "N", ke2 = Ce2.POLYFILL = "P";
      oe2.exports = Ce2;
    }), En2 = Ie2((Pe2, oe2) => {
      var ue2 = jt2(), ce2 = Nr2().f, se2 = kr2(), Ce2 = di2(), be2 = Gn2(), Ne2 = Ai2(), Te2 = vi2();
      oe2.exports = function(ke2, Ve2) {
        var We2 = ke2.target, Xe2 = ke2.global, Je2 = ke2.stat, X3, Ke2, rt2, pt2, lt2, yt2;
        if (Xe2 ? Ke2 = ue2 : Je2 ? Ke2 = ue2[We2] || be2(We2, {}) : Ke2 = (ue2[We2] || {}).prototype, Ke2)
          for (rt2 in Ve2) {
            if (lt2 = Ve2[rt2], ke2.dontCallGetSet ? (yt2 = ce2(Ke2, rt2), pt2 = yt2 && yt2.value) : pt2 = Ke2[rt2], X3 = Te2(Xe2 ? rt2 : We2 + (Je2 ? "." : "#") + rt2, ke2.forced), !X3 && pt2 !== void 0) {
              if (typeof lt2 == typeof pt2)
                continue;
              Ne2(lt2, pt2);
            }
            (ke2.sham || pt2 && pt2.sham) && se2(lt2, "sham", true), Ce2(Ke2, rt2, lt2, ke2);
          }
      };
    }), Lr2 = Ie2((Pe2, oe2) => {
      var ue2 = gn2();
      oe2.exports = Array.isArray || function(ce2) {
        return ue2(ce2) == "Array";
      };
    }), xi2 = Ie2((Pe2, oe2) => {
      var ue2 = TypeError, ce2 = 9007199254740991;
      oe2.exports = function(se2) {
        if (se2 > ce2)
          throw ue2("Maximum allowed index exceeded");
        return se2;
      };
    }), bi2 = Ie2((Pe2, oe2) => {
      var ue2 = gn2(), ce2 = _t2();
      oe2.exports = function(se2) {
        if (ue2(se2) === "Function")
          return ce2(se2);
      };
    }), _r2 = Ie2((Pe2, oe2) => {
      var ue2 = bi2(), ce2 = hn2(), se2 = Mn2(), Ce2 = ue2(ue2.bind);
      oe2.exports = function(be2, Ne2) {
        return ce2(be2), Ne2 === void 0 ? be2 : se2 ? Ce2(be2, Ne2) : function() {
          return be2.apply(Ne2, arguments);
        };
      };
    }), Or2 = Ie2((Pe2, oe2) => {
      var ue2 = Lr2(), ce2 = an2(), se2 = xi2(), Ce2 = _r2(), be2 = function(Ne2, Te2, ke2, Ve2, We2, Xe2, Je2, X3) {
        for (var Ke2 = We2, rt2 = 0, pt2 = Je2 ? Ce2(Je2, X3) : false, lt2, yt2; rt2 < Ve2; )
          rt2 in ke2 && (lt2 = pt2 ? pt2(ke2[rt2], rt2, Te2) : ke2[rt2], Xe2 > 0 && ue2(lt2) ? (yt2 = ce2(lt2), Ke2 = be2(Ne2, Te2, lt2, yt2, Ke2, Xe2 - 1) - 1) : (se2(Ke2 + 1), Ne2[Ke2] = lt2), Ke2++), rt2++;
        return Ke2;
      };
      oe2.exports = be2;
    }), Si2 = Ie2((Pe2, oe2) => {
      var ue2 = zt2(), ce2 = ue2("toStringTag"), se2 = {};
      se2[ce2] = "z", oe2.exports = String(se2) === "[object z]";
    }), Mr2 = Ie2((Pe2, oe2) => {
      var ue2 = Si2(), ce2 = kt2(), se2 = gn2(), Ce2 = zt2(), be2 = Ce2("toStringTag"), Ne2 = Object, Te2 = se2(function() {
        return arguments;
      }()) == "Arguments", ke2 = function(Ve2, We2) {
        try {
          return Ve2[We2];
        } catch {
        }
      };
      oe2.exports = ue2 ? se2 : function(Ve2) {
        var We2, Xe2, Je2;
        return Ve2 === void 0 ? "Undefined" : Ve2 === null ? "Null" : typeof (Xe2 = ke2(We2 = Ne2(Ve2), be2)) == "string" ? Xe2 : Te2 ? se2(We2) : (Je2 = se2(We2)) == "Object" && ce2(We2.callee) ? "Arguments" : Je2;
      };
    }), Ti2 = Ie2((Pe2, oe2) => {
      var ue2 = _t2(), ce2 = Lt2(), se2 = kt2(), Ce2 = Mr2(), be2 = yn2(), Ne2 = Pr2(), Te2 = function() {
      }, ke2 = [], Ve2 = be2("Reflect", "construct"), We2 = /^\s*(?:class|function)\b/, Xe2 = ue2(We2.exec), Je2 = !We2.exec(Te2), X3 = function(rt2) {
        if (!se2(rt2))
          return false;
        try {
          return Ve2(Te2, ke2, rt2), true;
        } catch {
          return false;
        }
      }, Ke2 = function(rt2) {
        if (!se2(rt2))
          return false;
        switch (Ce2(rt2)) {
          case "AsyncFunction":
          case "GeneratorFunction":
          case "AsyncGeneratorFunction":
            return false;
        }
        try {
          return Je2 || !!Xe2(We2, Ne2(rt2));
        } catch {
          return true;
        }
      };
      Ke2.sham = true, oe2.exports = !Ve2 || ce2(function() {
        var rt2;
        return X3(X3.call) || !X3(Object) || !X3(function() {
          rt2 = true;
        }) || rt2;
      }) ? Ke2 : X3;
    }), Bi2 = Ie2((Pe2, oe2) => {
      var ue2 = Lr2(), ce2 = Ti2(), se2 = Yt2(), Ce2 = zt2(), be2 = Ce2("species"), Ne2 = Array;
      oe2.exports = function(Te2) {
        var ke2;
        return ue2(Te2) && (ke2 = Te2.constructor, ce2(ke2) && (ke2 === Ne2 || ue2(ke2.prototype)) ? ke2 = void 0 : se2(ke2) && (ke2 = ke2[be2], ke2 === null && (ke2 = void 0))), ke2 === void 0 ? Ne2 : ke2;
      };
    }), $r2 = Ie2((Pe2, oe2) => {
      var ue2 = Bi2();
      oe2.exports = function(ce2, se2) {
        return new (ue2(ce2))(se2 === 0 ? 0 : se2);
      };
    }), wi2 = Ie2(() => {
      var Pe2 = En2(), oe2 = Or2(), ue2 = hn2(), ce2 = Xn2(), se2 = an2(), Ce2 = $r2();
      Pe2({ target: "Array", proto: true }, { flatMap: function(be2) {
        var Ne2 = ce2(this), Te2 = se2(Ne2), ke2;
        return ue2(be2), ke2 = Ce2(Ne2, 0), ke2.length = oe2(ke2, Ne2, Ne2, Te2, 0, 1, be2, arguments.length > 1 ? arguments[1] : void 0), ke2;
      } });
    }), Rr2 = Ie2((Pe2, oe2) => {
      oe2.exports = {};
    }), Ni2 = Ie2((Pe2, oe2) => {
      var ue2 = zt2(), ce2 = Rr2(), se2 = ue2("iterator"), Ce2 = Array.prototype;
      oe2.exports = function(be2) {
        return be2 !== void 0 && (ce2.Array === be2 || Ce2[se2] === be2);
      };
    }), Vr2 = Ie2((Pe2, oe2) => {
      var ue2 = Mr2(), ce2 = qn2(), se2 = Rn2(), Ce2 = Rr2(), be2 = zt2(), Ne2 = be2("iterator");
      oe2.exports = function(Te2) {
        if (!se2(Te2))
          return ce2(Te2, Ne2) || ce2(Te2, "@@iterator") || Ce2[ue2(Te2)];
      };
    }), ki2 = Ie2((Pe2, oe2) => {
      var ue2 = Ut2(), ce2 = hn2(), se2 = Kt2(), Ce2 = Jn2(), be2 = Vr2(), Ne2 = TypeError;
      oe2.exports = function(Te2, ke2) {
        var Ve2 = arguments.length < 2 ? be2(Te2) : ke2;
        if (ce2(Ve2))
          return se2(ue2(Ve2, Te2));
        throw Ne2(Ce2(Te2) + " is not iterable");
      };
    }), Pi2 = Ie2((Pe2, oe2) => {
      var ue2 = Ut2(), ce2 = Kt2(), se2 = qn2();
      oe2.exports = function(Ce2, be2, Ne2) {
        var Te2, ke2;
        ce2(Ce2);
        try {
          if (Te2 = se2(Ce2, "return"), !Te2) {
            if (be2 === "throw")
              throw Ne2;
            return Ne2;
          }
          Te2 = ue2(Te2, Ce2);
        } catch (Ve2) {
          ke2 = true, Te2 = Ve2;
        }
        if (be2 === "throw")
          throw Ne2;
        if (ke2)
          throw Te2;
        return ce2(Te2), Ne2;
      };
    }), ji2 = Ie2((Pe2, oe2) => {
      var ue2 = _r2(), ce2 = Ut2(), se2 = Kt2(), Ce2 = Jn2(), be2 = Ni2(), Ne2 = an2(), Te2 = vr2(), ke2 = ki2(), Ve2 = Vr2(), We2 = Pi2(), Xe2 = TypeError, Je2 = function(Ke2, rt2) {
        this.stopped = Ke2, this.result = rt2;
      }, X3 = Je2.prototype;
      oe2.exports = function(Ke2, rt2, pt2) {
        var lt2 = pt2 && pt2.that, yt2 = !!(pt2 && pt2.AS_ENTRIES), H3 = !!(pt2 && pt2.IS_RECORD), xt2 = !!(pt2 && pt2.IS_ITERATOR), qt2 = !!(pt2 && pt2.INTERRUPTED), Qt2 = ue2(rt2, lt2), Pt2, $t2, Ct2, Cn2, It2, Fn2, An2, vn2 = function(bt2) {
          return Pt2 && We2(Pt2, "normal", bt2), new Je2(true, bt2);
        }, xn2 = function(bt2) {
          return yt2 ? (se2(bt2), qt2 ? Qt2(bt2[0], bt2[1], vn2) : Qt2(bt2[0], bt2[1])) : qt2 ? Qt2(bt2, vn2) : Qt2(bt2);
        };
        if (H3)
          Pt2 = Ke2.iterator;
        else if (xt2)
          Pt2 = Ke2;
        else {
          if ($t2 = Ve2(Ke2), !$t2)
            throw Xe2(Ce2(Ke2) + " is not iterable");
          if (be2($t2)) {
            for (Ct2 = 0, Cn2 = Ne2(Ke2); Cn2 > Ct2; Ct2++)
              if (It2 = xn2(Ke2[Ct2]), It2 && Te2(X3, It2))
                return It2;
            return new Je2(false);
          }
          Pt2 = ke2(Ke2, $t2);
        }
        for (Fn2 = H3 ? Ke2.next : Pt2.next; !(An2 = ce2(Fn2, Pt2)).done; ) {
          try {
            It2 = xn2(An2.value);
          } catch (bt2) {
            We2(Pt2, "throw", bt2);
          }
          if (typeof It2 == "object" && It2 && Te2(X3, It2))
            return It2;
        }
        return new Je2(false);
      };
    }), Ii2 = Ie2((Pe2, oe2) => {
      var ue2 = Un2(), ce2 = un2(), se2 = $n2();
      oe2.exports = function(Ce2, be2, Ne2) {
        var Te2 = ue2(be2);
        Te2 in Ce2 ? ce2.f(Ce2, Te2, se2(0, Ne2)) : Ce2[Te2] = Ne2;
      };
    }), Li2 = Ie2(() => {
      var Pe2 = En2(), oe2 = ji2(), ue2 = Ii2();
      Pe2({ target: "Object", stat: true }, { fromEntries: function(ce2) {
        var se2 = {};
        return oe2(ce2, function(Ce2, be2) {
          ue2(se2, Ce2, be2);
        }, { AS_ENTRIES: true }), se2;
      } });
    }), _i2 = Ie2((Pe2, oe2) => {
      var ue2 = Ir2(), ce2 = un2();
      oe2.exports = function(se2, Ce2, be2) {
        return be2.get && ue2(be2.get, Ce2, { getter: true }), be2.set && ue2(be2.set, Ce2, { setter: true }), ce2.f(se2, Ce2, be2);
      };
    }), Oi2 = Ie2((Pe2, oe2) => {
      var ue2 = Kt2();
      oe2.exports = function() {
        var ce2 = ue2(this), se2 = "";
        return ce2.hasIndices && (se2 += "d"), ce2.global && (se2 += "g"), ce2.ignoreCase && (se2 += "i"), ce2.multiline && (se2 += "m"), ce2.dotAll && (se2 += "s"), ce2.unicode && (se2 += "u"), ce2.unicodeSets && (se2 += "v"), ce2.sticky && (se2 += "y"), se2;
      };
    }), Mi2 = Ie2(() => {
      var Pe2 = jt2(), oe2 = Mt2(), ue2 = _i2(), ce2 = Oi2(), se2 = Lt2(), Ce2 = Pe2.RegExp, be2 = Ce2.prototype, Ne2 = oe2 && se2(function() {
        var Te2 = true;
        try {
          Ce2(".", "d");
        } catch {
          Te2 = false;
        }
        var ke2 = {}, Ve2 = "", We2 = Te2 ? "dgimsy" : "gimsy", Xe2 = function(rt2, pt2) {
          Object.defineProperty(ke2, rt2, { get: function() {
            return Ve2 += pt2, true;
          } });
        }, Je2 = { dotAll: "s", global: "g", ignoreCase: "i", multiline: "m", sticky: "y" };
        Te2 && (Je2.hasIndices = "d");
        for (var X3 in Je2)
          Xe2(X3, Je2[X3]);
        var Ke2 = Object.getOwnPropertyDescriptor(be2, "flags").get.call(ke2);
        return Ke2 !== We2 || Ve2 !== We2;
      });
      Ne2 && ue2(be2, "flags", { configurable: true, get: ce2 });
    }), $i2 = Ie2(() => {
      var Pe2 = En2(), oe2 = jt2();
      Pe2({ global: true, forced: oe2.globalThis !== oe2 }, { globalThis: oe2 });
    }), Ri2 = Ie2(() => {
      $i2();
    }), Vi2 = Ie2(() => {
      var Pe2 = En2(), oe2 = Or2(), ue2 = Xn2(), ce2 = an2(), se2 = Yn2(), Ce2 = $r2();
      Pe2({ target: "Array", proto: true }, { flat: function() {
        var be2 = arguments.length ? arguments[0] : void 0, Ne2 = ue2(this), Te2 = ce2(Ne2), ke2 = Ce2(Ne2, 0);
        return ke2.length = oe2(ke2, Ne2, Ne2, Te2, 0, be2 === void 0 ? 1 : se2(be2)), ke2;
      } });
    }), Ji2 = Ie2((Pe2, oe2) => {
      var ue2 = ["cliName", "cliCategory", "cliDescription"], ce2 = ["_"], se2 = ["languageId"];
      function Ce2(u3, l3) {
        if (u3 == null)
          return {};
        var t3 = be2(u3, l3), s3, a3;
        if (Object.getOwnPropertySymbols) {
          var e28 = Object.getOwnPropertySymbols(u3);
          for (a3 = 0; a3 < e28.length; a3++)
            s3 = e28[a3], !(l3.indexOf(s3) >= 0) && Object.prototype.propertyIsEnumerable.call(u3, s3) && (t3[s3] = u3[s3]);
        }
        return t3;
      }
      function be2(u3, l3) {
        if (u3 == null)
          return {};
        var t3 = {}, s3 = Object.keys(u3), a3, e28;
        for (e28 = 0; e28 < s3.length; e28++)
          a3 = s3[e28], !(l3.indexOf(a3) >= 0) && (t3[a3] = u3[a3]);
        return t3;
      }
      wi2(), Li2(), Mi2(), Ri2(), Vi2();
      var Ne2 = Object.create, Te2 = Object.defineProperty, ke2 = Object.getOwnPropertyDescriptor, Ve2 = Object.getOwnPropertyNames, We2 = Object.getPrototypeOf, Xe2 = Object.prototype.hasOwnProperty, Je2 = (u3, l3) => function() {
        return u3 && (l3 = (0, u3[Ve2(u3)[0]])(u3 = 0)), l3;
      }, X3 = (u3, l3) => function() {
        return l3 || (0, u3[Ve2(u3)[0]])((l3 = { exports: {} }).exports, l3), l3.exports;
      }, Ke2 = (u3, l3) => {
        for (var t3 in l3)
          Te2(u3, t3, { get: l3[t3], enumerable: true });
      }, rt2 = (u3, l3, t3, s3) => {
        if (l3 && typeof l3 == "object" || typeof l3 == "function")
          for (let a3 of Ve2(l3))
            !Xe2.call(u3, a3) && a3 !== t3 && Te2(u3, a3, { get: () => l3[a3], enumerable: !(s3 = ke2(l3, a3)) || s3.enumerable });
        return u3;
      }, pt2 = (u3, l3, t3) => (t3 = u3 != null ? Ne2(We2(u3)) : {}, rt2(l3 || !u3 || !u3.__esModule ? Te2(t3, "default", { value: u3, enumerable: true }) : t3, u3)), lt2 = (u3) => rt2(Te2({}, "__esModule", { value: true }), u3), yt2, H3 = Je2({ "<define:process>"() {
        yt2 = { env: {}, argv: [] };
      } }), xt2 = X3({ "package.json"(u3, l3) {
        l3.exports = { version: "2.8.8" };
      } }), qt2 = X3({ "node_modules/diff/lib/diff/base.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true }), u3.default = l3;
        function l3() {
        }
        l3.prototype = { diff: function(a3, e28) {
          var n3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r3 = n3.callback;
          typeof n3 == "function" && (r3 = n3, n3 = {}), this.options = n3;
          var o3 = this;
          function c3(A3) {
            return r3 ? (setTimeout(function() {
              r3(void 0, A3);
            }, 0), true) : A3;
          }
          a3 = this.castInput(a3), e28 = this.castInput(e28), a3 = this.removeEmpty(this.tokenize(a3)), e28 = this.removeEmpty(this.tokenize(e28));
          var h3 = e28.length, m3 = a3.length, y3 = 1, p3 = h3 + m3, d3 = [{ newPos: -1, components: [] }], C3 = this.extractCommon(d3[0], e28, a3, 0);
          if (d3[0].newPos + 1 >= h3 && C3 + 1 >= m3)
            return c3([{ value: this.join(e28), count: e28.length }]);
          function w3() {
            for (var A3 = -1 * y3; A3 <= y3; A3 += 2) {
              var N3 = void 0, S3 = d3[A3 - 1], j3 = d3[A3 + 1], k3 = (j3 ? j3.newPos : 0) - A3;
              S3 && (d3[A3 - 1] = void 0);
              var J3 = S3 && S3.newPos + 1 < h3, f3 = j3 && 0 <= k3 && k3 < m3;
              if (!J3 && !f3) {
                d3[A3] = void 0;
                continue;
              }
              if (!J3 || f3 && S3.newPos < j3.newPos ? (N3 = s3(j3), o3.pushComponent(N3.components, void 0, true)) : (N3 = S3, N3.newPos++, o3.pushComponent(N3.components, true, void 0)), k3 = o3.extractCommon(N3, e28, a3, A3), N3.newPos + 1 >= h3 && k3 + 1 >= m3)
                return c3(t3(o3, N3.components, e28, a3, o3.useLongestToken));
              d3[A3] = N3;
            }
            y3++;
          }
          if (r3)
            (function A3() {
              setTimeout(function() {
                if (y3 > p3)
                  return r3();
                w3() || A3();
              }, 0);
            })();
          else
            for (; y3 <= p3; ) {
              var P3 = w3();
              if (P3)
                return P3;
            }
        }, pushComponent: function(a3, e28, n3) {
          var r3 = a3[a3.length - 1];
          r3 && r3.added === e28 && r3.removed === n3 ? a3[a3.length - 1] = { count: r3.count + 1, added: e28, removed: n3 } : a3.push({ count: 1, added: e28, removed: n3 });
        }, extractCommon: function(a3, e28, n3, r3) {
          for (var o3 = e28.length, c3 = n3.length, h3 = a3.newPos, m3 = h3 - r3, y3 = 0; h3 + 1 < o3 && m3 + 1 < c3 && this.equals(e28[h3 + 1], n3[m3 + 1]); )
            h3++, m3++, y3++;
          return y3 && a3.components.push({ count: y3 }), a3.newPos = h3, m3;
        }, equals: function(a3, e28) {
          return this.options.comparator ? this.options.comparator(a3, e28) : a3 === e28 || this.options.ignoreCase && a3.toLowerCase() === e28.toLowerCase();
        }, removeEmpty: function(a3) {
          for (var e28 = [], n3 = 0; n3 < a3.length; n3++)
            a3[n3] && e28.push(a3[n3]);
          return e28;
        }, castInput: function(a3) {
          return a3;
        }, tokenize: function(a3) {
          return a3.split("");
        }, join: function(a3) {
          return a3.join("");
        } };
        function t3(a3, e28, n3, r3, o3) {
          for (var c3 = 0, h3 = e28.length, m3 = 0, y3 = 0; c3 < h3; c3++) {
            var p3 = e28[c3];
            if (p3.removed) {
              if (p3.value = a3.join(r3.slice(y3, y3 + p3.count)), y3 += p3.count, c3 && e28[c3 - 1].added) {
                var d3 = e28[c3 - 1];
                e28[c3 - 1] = e28[c3], e28[c3] = d3;
              }
            } else {
              if (!p3.added && o3) {
                var C3 = n3.slice(m3, m3 + p3.count);
                C3 = C3.map(function(P3, A3) {
                  var N3 = r3[y3 + A3];
                  return N3.length > P3.length ? N3 : P3;
                }), p3.value = a3.join(C3);
              } else
                p3.value = a3.join(n3.slice(m3, m3 + p3.count));
              m3 += p3.count, p3.added || (y3 += p3.count);
            }
          }
          var w3 = e28[h3 - 1];
          return h3 > 1 && typeof w3.value == "string" && (w3.added || w3.removed) && a3.equals("", w3.value) && (e28[h3 - 2].value += w3.value, e28.pop()), e28;
        }
        function s3(a3) {
          return { newPos: a3.newPos, components: a3.components.slice(0) };
        }
      } }), Qt2 = X3({ "node_modules/diff/lib/diff/array.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true }), u3.diffArrays = a3, u3.arrayDiff = void 0;
        var l3 = t3(qt2());
        function t3(e28) {
          return e28 && e28.__esModule ? e28 : { default: e28 };
        }
        var s3 = new l3.default();
        u3.arrayDiff = s3, s3.tokenize = function(e28) {
          return e28.slice();
        }, s3.join = s3.removeEmpty = function(e28) {
          return e28;
        };
        function a3(e28, n3, r3) {
          return s3.diff(e28, n3, r3);
        }
      } }), Pt2 = X3({ "src/document/doc-builders.js"(u3, l3) {
        H3();
        function t3(F3) {
          return { type: "concat", parts: F3 };
        }
        function s3(F3) {
          return { type: "indent", contents: F3 };
        }
        function a3(F3, i) {
          return { type: "align", contents: i, n: F3 };
        }
        function e28(F3) {
          let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          return { type: "group", id: i.id, contents: F3, break: !!i.shouldBreak, expandedStates: i.expandedStates };
        }
        function n3(F3) {
          return a3(Number.NEGATIVE_INFINITY, F3);
        }
        function r3(F3) {
          return a3({ type: "root" }, F3);
        }
        function o3(F3) {
          return a3(-1, F3);
        }
        function c3(F3, i) {
          return e28(F3[0], Object.assign(Object.assign({}, i), {}, { expandedStates: F3 }));
        }
        function h3(F3) {
          return { type: "fill", parts: F3 };
        }
        function m3(F3, i) {
          let g3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return { type: "if-break", breakContents: F3, flatContents: i, groupId: g3.groupId };
        }
        function y3(F3, i) {
          return { type: "indent-if-break", contents: F3, groupId: i.groupId, negate: i.negate };
        }
        function p3(F3) {
          return { type: "line-suffix", contents: F3 };
        }
        var d3 = { type: "line-suffix-boundary" }, C3 = { type: "break-parent" }, w3 = { type: "trim" }, P3 = { type: "line", hard: true }, A3 = { type: "line", hard: true, literal: true }, N3 = { type: "line" }, S3 = { type: "line", soft: true }, j3 = t3([P3, C3]), k3 = t3([A3, C3]), J3 = { type: "cursor", placeholder: Symbol("cursor") };
        function f3(F3, i) {
          let g3 = [];
          for (let E3 = 0; E3 < i.length; E3++)
            E3 !== 0 && g3.push(F3), g3.push(i[E3]);
          return t3(g3);
        }
        function T3(F3, i, g3) {
          let E3 = F3;
          if (i > 0) {
            for (let x3 = 0; x3 < Math.floor(i / g3); ++x3)
              E3 = s3(E3);
            E3 = a3(i % g3, E3), E3 = a3(Number.NEGATIVE_INFINITY, E3);
          }
          return E3;
        }
        function D3(F3, i) {
          return { type: "label", label: F3, contents: i };
        }
        l3.exports = { concat: t3, join: f3, line: N3, softline: S3, hardline: j3, literalline: k3, group: e28, conditionalGroup: c3, fill: h3, lineSuffix: p3, lineSuffixBoundary: d3, cursor: J3, breakParent: C3, ifBreak: m3, trim: w3, indent: s3, indentIfBreak: y3, align: a3, addAlignmentToDoc: T3, markAsRoot: r3, dedentToRoot: n3, dedent: o3, hardlineWithoutBreakParent: P3, literallineWithoutBreakParent: A3, label: D3 };
      } }), $t2 = X3({ "src/common/end-of-line.js"(u3, l3) {
        H3();
        function t3(n3) {
          let r3 = n3.indexOf("\r");
          return r3 >= 0 ? n3.charAt(r3 + 1) === `
` ? "crlf" : "cr" : "lf";
        }
        function s3(n3) {
          switch (n3) {
            case "cr":
              return "\r";
            case "crlf":
              return `\r
`;
            default:
              return `
`;
          }
        }
        function a3(n3, r3) {
          let o3;
          switch (r3) {
            case `
`:
              o3 = /\n/g;
              break;
            case "\r":
              o3 = /\r/g;
              break;
            case `\r
`:
              o3 = /\r\n/g;
              break;
            default:
              throw new Error(`Unexpected "eol" ${JSON.stringify(r3)}.`);
          }
          let c3 = n3.match(o3);
          return c3 ? c3.length : 0;
        }
        function e28(n3) {
          return n3.replace(/\r\n?/g, `
`);
        }
        l3.exports = { guessEndOfLine: t3, convertEndOfLineToChars: s3, countEndOfLineChars: a3, normalizeEndOfLine: e28 };
      } }), Ct2 = X3({ "src/utils/get-last.js"(u3, l3) {
        H3();
        var t3 = (s3) => s3[s3.length - 1];
        l3.exports = t3;
      } });
      function Cn2() {
        let { onlyFirst: u3 = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l3 = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
        return new RegExp(l3, u3 ? void 0 : "g");
      }
      var It2 = Je2({ "node_modules/strip-ansi/node_modules/ansi-regex/index.js"() {
        H3();
      } });
      function Fn2(u3) {
        if (typeof u3 != "string")
          throw new TypeError(`Expected a \`string\`, got \`${typeof u3}\``);
        return u3.replace(Cn2(), "");
      }
      var An2 = Je2({ "node_modules/strip-ansi/index.js"() {
        H3(), It2();
      } });
      function vn2(u3) {
        return Number.isInteger(u3) ? u3 >= 4352 && (u3 <= 4447 || u3 === 9001 || u3 === 9002 || 11904 <= u3 && u3 <= 12871 && u3 !== 12351 || 12880 <= u3 && u3 <= 19903 || 19968 <= u3 && u3 <= 42182 || 43360 <= u3 && u3 <= 43388 || 44032 <= u3 && u3 <= 55203 || 63744 <= u3 && u3 <= 64255 || 65040 <= u3 && u3 <= 65049 || 65072 <= u3 && u3 <= 65131 || 65281 <= u3 && u3 <= 65376 || 65504 <= u3 && u3 <= 65510 || 110592 <= u3 && u3 <= 110593 || 127488 <= u3 && u3 <= 127569 || 131072 <= u3 && u3 <= 262141) : false;
      }
      var xn2 = Je2({ "node_modules/is-fullwidth-code-point/index.js"() {
        H3();
      } }), bt2 = X3({ "node_modules/emoji-regex/index.js"(u3, l3) {
        H3(), l3.exports = function() {
          return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
        };
      } }), Jr2 = {};
      Ke2(Jr2, { default: () => qi2 });
      function qi2(u3) {
        if (typeof u3 != "string" || u3.length === 0 || (u3 = Fn2(u3), u3.length === 0))
          return 0;
        u3 = u3.replace((0, qr2.default)(), "  ");
        let l3 = 0;
        for (let t3 = 0; t3 < u3.length; t3++) {
          let s3 = u3.codePointAt(t3);
          s3 <= 31 || s3 >= 127 && s3 <= 159 || s3 >= 768 && s3 <= 879 || (s3 > 65535 && t3++, l3 += vn2(s3) ? 2 : 1);
        }
        return l3;
      }
      var qr2, Gi2 = Je2({ "node_modules/string-width/index.js"() {
        H3(), An2(), xn2(), qr2 = pt2(bt2());
      } }), Gr2 = X3({ "src/utils/get-string-width.js"(u3, l3) {
        H3();
        var t3 = (Gi2(), lt2(Jr2)).default, s3 = /[^\x20-\x7F]/;
        function a3(e28) {
          return e28 ? s3.test(e28) ? t3(e28) : e28.length : 0;
        }
        l3.exports = a3;
      } }), sn2 = X3({ "src/document/doc-utils.js"(u3, l3) {
        H3();
        var t3 = Ct2(), { literalline: s3, join: a3 } = Pt2(), e28 = (i) => Array.isArray(i) || i && i.type === "concat", n3 = (i) => {
          if (Array.isArray(i))
            return i;
          if (i.type !== "concat" && i.type !== "fill")
            throw new Error("Expect doc type to be `concat` or `fill`.");
          return i.parts;
        }, r3 = {};
        function o3(i, g3, E3, x3) {
          let b3 = [i];
          for (; b3.length > 0; ) {
            let B3 = b3.pop();
            if (B3 === r3) {
              E3(b3.pop());
              continue;
            }
            if (E3 && b3.push(B3, r3), !g3 || g3(B3) !== false)
              if (e28(B3) || B3.type === "fill") {
                let I3 = n3(B3);
                for (let M3 = I3.length, V10 = M3 - 1; V10 >= 0; --V10)
                  b3.push(I3[V10]);
              } else if (B3.type === "if-break")
                B3.flatContents && b3.push(B3.flatContents), B3.breakContents && b3.push(B3.breakContents);
              else if (B3.type === "group" && B3.expandedStates)
                if (x3)
                  for (let I3 = B3.expandedStates.length, M3 = I3 - 1; M3 >= 0; --M3)
                    b3.push(B3.expandedStates[M3]);
                else
                  b3.push(B3.contents);
              else
                B3.contents && b3.push(B3.contents);
          }
        }
        function c3(i, g3) {
          let E3 = /* @__PURE__ */ new Map();
          return x3(i);
          function x3(B3) {
            if (E3.has(B3))
              return E3.get(B3);
            let I3 = b3(B3);
            return E3.set(B3, I3), I3;
          }
          function b3(B3) {
            if (Array.isArray(B3))
              return g3(B3.map(x3));
            if (B3.type === "concat" || B3.type === "fill") {
              let I3 = B3.parts.map(x3);
              return g3(Object.assign(Object.assign({}, B3), {}, { parts: I3 }));
            }
            if (B3.type === "if-break") {
              let I3 = B3.breakContents && x3(B3.breakContents), M3 = B3.flatContents && x3(B3.flatContents);
              return g3(Object.assign(Object.assign({}, B3), {}, { breakContents: I3, flatContents: M3 }));
            }
            if (B3.type === "group" && B3.expandedStates) {
              let I3 = B3.expandedStates.map(x3), M3 = I3[0];
              return g3(Object.assign(Object.assign({}, B3), {}, { contents: M3, expandedStates: I3 }));
            }
            if (B3.contents) {
              let I3 = x3(B3.contents);
              return g3(Object.assign(Object.assign({}, B3), {}, { contents: I3 }));
            }
            return g3(B3);
          }
        }
        function h3(i, g3, E3) {
          let x3 = E3, b3 = false;
          function B3(I3) {
            let M3 = g3(I3);
            if (M3 !== void 0 && (b3 = true, x3 = M3), b3)
              return false;
          }
          return o3(i, B3), x3;
        }
        function m3(i) {
          if (i.type === "group" && i.break || i.type === "line" && i.hard || i.type === "break-parent")
            return true;
        }
        function y3(i) {
          return h3(i, m3, false);
        }
        function p3(i) {
          if (i.length > 0) {
            let g3 = t3(i);
            !g3.expandedStates && !g3.break && (g3.break = "propagated");
          }
          return null;
        }
        function d3(i) {
          let g3 = /* @__PURE__ */ new Set(), E3 = [];
          function x3(B3) {
            if (B3.type === "break-parent" && p3(E3), B3.type === "group") {
              if (E3.push(B3), g3.has(B3))
                return false;
              g3.add(B3);
            }
          }
          function b3(B3) {
            B3.type === "group" && E3.pop().break && p3(E3);
          }
          o3(i, x3, b3, true);
        }
        function C3(i) {
          return i.type === "line" && !i.hard ? i.soft ? "" : " " : i.type === "if-break" ? i.flatContents || "" : i;
        }
        function w3(i) {
          return c3(i, C3);
        }
        var P3 = (i, g3) => i && i.type === "line" && i.hard && g3 && g3.type === "break-parent";
        function A3(i) {
          if (!i)
            return i;
          if (e28(i) || i.type === "fill") {
            let g3 = n3(i);
            for (; g3.length > 1 && P3(...g3.slice(-2)); )
              g3.length -= 2;
            if (g3.length > 0) {
              let E3 = A3(t3(g3));
              g3[g3.length - 1] = E3;
            }
            return Array.isArray(i) ? g3 : Object.assign(Object.assign({}, i), {}, { parts: g3 });
          }
          switch (i.type) {
            case "align":
            case "indent":
            case "indent-if-break":
            case "group":
            case "line-suffix":
            case "label": {
              let g3 = A3(i.contents);
              return Object.assign(Object.assign({}, i), {}, { contents: g3 });
            }
            case "if-break": {
              let g3 = A3(i.breakContents), E3 = A3(i.flatContents);
              return Object.assign(Object.assign({}, i), {}, { breakContents: g3, flatContents: E3 });
            }
          }
          return i;
        }
        function N3(i) {
          return A3(j3(i));
        }
        function S3(i) {
          switch (i.type) {
            case "fill":
              if (i.parts.every((E3) => E3 === ""))
                return "";
              break;
            case "group":
              if (!i.contents && !i.id && !i.break && !i.expandedStates)
                return "";
              if (i.contents.type === "group" && i.contents.id === i.id && i.contents.break === i.break && i.contents.expandedStates === i.expandedStates)
                return i.contents;
              break;
            case "align":
            case "indent":
            case "indent-if-break":
            case "line-suffix":
              if (!i.contents)
                return "";
              break;
            case "if-break":
              if (!i.flatContents && !i.breakContents)
                return "";
              break;
          }
          if (!e28(i))
            return i;
          let g3 = [];
          for (let E3 of n3(i)) {
            if (!E3)
              continue;
            let [x3, ...b3] = e28(E3) ? n3(E3) : [E3];
            typeof x3 == "string" && typeof t3(g3) == "string" ? g3[g3.length - 1] += x3 : g3.push(x3), g3.push(...b3);
          }
          return g3.length === 0 ? "" : g3.length === 1 ? g3[0] : Array.isArray(i) ? g3 : Object.assign(Object.assign({}, i), {}, { parts: g3 });
        }
        function j3(i) {
          return c3(i, (g3) => S3(g3));
        }
        function k3(i) {
          let g3 = [], E3 = i.filter(Boolean);
          for (; E3.length > 0; ) {
            let x3 = E3.shift();
            if (x3) {
              if (e28(x3)) {
                E3.unshift(...n3(x3));
                continue;
              }
              if (g3.length > 0 && typeof t3(g3) == "string" && typeof x3 == "string") {
                g3[g3.length - 1] += x3;
                continue;
              }
              g3.push(x3);
            }
          }
          return g3;
        }
        function J3(i) {
          return c3(i, (g3) => Array.isArray(g3) ? k3(g3) : g3.parts ? Object.assign(Object.assign({}, g3), {}, { parts: k3(g3.parts) }) : g3);
        }
        function f3(i) {
          return c3(i, (g3) => typeof g3 == "string" && g3.includes(`
`) ? T3(g3) : g3);
        }
        function T3(i) {
          let g3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : s3;
          return a3(g3, i.split(`
`)).parts;
        }
        function D3(i) {
          if (i.type === "line")
            return true;
        }
        function F3(i) {
          return h3(i, D3, false);
        }
        l3.exports = { isConcat: e28, getDocParts: n3, willBreak: y3, traverseDoc: o3, findInDoc: h3, mapDoc: c3, propagateBreaks: d3, removeLines: w3, stripTrailingHardline: N3, normalizeParts: k3, normalizeDoc: J3, cleanDoc: j3, replaceTextEndOfLine: T3, replaceEndOfLine: f3, canBreak: F3 };
      } }), Wi2 = X3({ "src/document/doc-printer.js"(u3, l3) {
        H3();
        var { convertEndOfLineToChars: t3 } = $t2(), s3 = Ct2(), a3 = Gr2(), { fill: e28, cursor: n3, indent: r3 } = Pt2(), { isConcat: o3, getDocParts: c3 } = sn2(), h3, m3 = 1, y3 = 2;
        function p3() {
          return { value: "", length: 0, queue: [] };
        }
        function d3(S3, j3) {
          return w3(S3, { type: "indent" }, j3);
        }
        function C3(S3, j3, k3) {
          return j3 === Number.NEGATIVE_INFINITY ? S3.root || p3() : j3 < 0 ? w3(S3, { type: "dedent" }, k3) : j3 ? j3.type === "root" ? Object.assign(Object.assign({}, S3), {}, { root: S3 }) : w3(S3, { type: typeof j3 == "string" ? "stringAlign" : "numberAlign", n: j3 }, k3) : S3;
        }
        function w3(S3, j3, k3) {
          let J3 = j3.type === "dedent" ? S3.queue.slice(0, -1) : [...S3.queue, j3], f3 = "", T3 = 0, D3 = 0, F3 = 0;
          for (let I3 of J3)
            switch (I3.type) {
              case "indent":
                E3(), k3.useTabs ? i(1) : g3(k3.tabWidth);
                break;
              case "stringAlign":
                E3(), f3 += I3.n, T3 += I3.n.length;
                break;
              case "numberAlign":
                D3 += 1, F3 += I3.n;
                break;
              default:
                throw new Error(`Unexpected type '${I3.type}'`);
            }
          return b3(), Object.assign(Object.assign({}, S3), {}, { value: f3, length: T3, queue: J3 });
          function i(I3) {
            f3 += "	".repeat(I3), T3 += k3.tabWidth * I3;
          }
          function g3(I3) {
            f3 += " ".repeat(I3), T3 += I3;
          }
          function E3() {
            k3.useTabs ? x3() : b3();
          }
          function x3() {
            D3 > 0 && i(D3), B3();
          }
          function b3() {
            F3 > 0 && g3(F3), B3();
          }
          function B3() {
            D3 = 0, F3 = 0;
          }
        }
        function P3(S3) {
          if (S3.length === 0)
            return 0;
          let j3 = 0;
          for (; S3.length > 0 && typeof s3(S3) == "string" && /^[\t ]*$/.test(s3(S3)); )
            j3 += S3.pop().length;
          if (S3.length > 0 && typeof s3(S3) == "string") {
            let k3 = s3(S3).replace(/[\t ]*$/, "");
            j3 += s3(S3).length - k3.length, S3[S3.length - 1] = k3;
          }
          return j3;
        }
        function A3(S3, j3, k3, J3, f3) {
          let T3 = j3.length, D3 = [S3], F3 = [];
          for (; k3 >= 0; ) {
            if (D3.length === 0) {
              if (T3 === 0)
                return true;
              D3.push(j3[--T3]);
              continue;
            }
            let { mode: i, doc: g3 } = D3.pop();
            if (typeof g3 == "string")
              F3.push(g3), k3 -= a3(g3);
            else if (o3(g3) || g3.type === "fill") {
              let E3 = c3(g3);
              for (let x3 = E3.length - 1; x3 >= 0; x3--)
                D3.push({ mode: i, doc: E3[x3] });
            } else
              switch (g3.type) {
                case "indent":
                case "align":
                case "indent-if-break":
                case "label":
                  D3.push({ mode: i, doc: g3.contents });
                  break;
                case "trim":
                  k3 += P3(F3);
                  break;
                case "group": {
                  if (f3 && g3.break)
                    return false;
                  let E3 = g3.break ? m3 : i, x3 = g3.expandedStates && E3 === m3 ? s3(g3.expandedStates) : g3.contents;
                  D3.push({ mode: E3, doc: x3 });
                  break;
                }
                case "if-break": {
                  let E3 = (g3.groupId ? h3[g3.groupId] || y3 : i) === m3 ? g3.breakContents : g3.flatContents;
                  E3 && D3.push({ mode: i, doc: E3 });
                  break;
                }
                case "line":
                  if (i === m3 || g3.hard)
                    return true;
                  g3.soft || (F3.push(" "), k3--);
                  break;
                case "line-suffix":
                  J3 = true;
                  break;
                case "line-suffix-boundary":
                  if (J3)
                    return false;
                  break;
              }
          }
          return false;
        }
        function N3(S3, j3) {
          h3 = {};
          let k3 = j3.printWidth, J3 = t3(j3.endOfLine), f3 = 0, T3 = [{ ind: p3(), mode: m3, doc: S3 }], D3 = [], F3 = false, i = [];
          for (; T3.length > 0; ) {
            let { ind: E3, mode: x3, doc: b3 } = T3.pop();
            if (typeof b3 == "string") {
              let B3 = J3 !== `
` ? b3.replace(/\n/g, J3) : b3;
              D3.push(B3), f3 += a3(B3);
            } else if (o3(b3)) {
              let B3 = c3(b3);
              for (let I3 = B3.length - 1; I3 >= 0; I3--)
                T3.push({ ind: E3, mode: x3, doc: B3[I3] });
            } else
              switch (b3.type) {
                case "cursor":
                  D3.push(n3.placeholder);
                  break;
                case "indent":
                  T3.push({ ind: d3(E3, j3), mode: x3, doc: b3.contents });
                  break;
                case "align":
                  T3.push({ ind: C3(E3, b3.n, j3), mode: x3, doc: b3.contents });
                  break;
                case "trim":
                  f3 -= P3(D3);
                  break;
                case "group":
                  switch (x3) {
                    case y3:
                      if (!F3) {
                        T3.push({ ind: E3, mode: b3.break ? m3 : y3, doc: b3.contents });
                        break;
                      }
                    case m3: {
                      F3 = false;
                      let B3 = { ind: E3, mode: y3, doc: b3.contents }, I3 = k3 - f3, M3 = i.length > 0;
                      if (!b3.break && A3(B3, T3, I3, M3))
                        T3.push(B3);
                      else if (b3.expandedStates) {
                        let V10 = s3(b3.expandedStates);
                        if (b3.break) {
                          T3.push({ ind: E3, mode: m3, doc: V10 });
                          break;
                        } else
                          for (let $3 = 1; $3 < b3.expandedStates.length + 1; $3++)
                            if ($3 >= b3.expandedStates.length) {
                              T3.push({ ind: E3, mode: m3, doc: V10 });
                              break;
                            } else {
                              let U3 = b3.expandedStates[$3], L3 = { ind: E3, mode: y3, doc: U3 };
                              if (A3(L3, T3, I3, M3)) {
                                T3.push(L3);
                                break;
                              }
                            }
                      } else
                        T3.push({ ind: E3, mode: m3, doc: b3.contents });
                      break;
                    }
                  }
                  b3.id && (h3[b3.id] = s3(T3).mode);
                  break;
                case "fill": {
                  let B3 = k3 - f3, { parts: I3 } = b3;
                  if (I3.length === 0)
                    break;
                  let [M3, V10] = I3, $3 = { ind: E3, mode: y3, doc: M3 }, U3 = { ind: E3, mode: m3, doc: M3 }, L3 = A3($3, [], B3, i.length > 0, true);
                  if (I3.length === 1) {
                    L3 ? T3.push($3) : T3.push(U3);
                    break;
                  }
                  let ee2 = { ind: E3, mode: y3, doc: V10 }, R3 = { ind: E3, mode: m3, doc: V10 };
                  if (I3.length === 2) {
                    L3 ? T3.push(ee2, $3) : T3.push(R3, U3);
                    break;
                  }
                  I3.splice(0, 2);
                  let O3 = { ind: E3, mode: x3, doc: e28(I3) }, Z3 = I3[0];
                  A3({ ind: E3, mode: y3, doc: [M3, V10, Z3] }, [], B3, i.length > 0, true) ? T3.push(O3, ee2, $3) : L3 ? T3.push(O3, R3, $3) : T3.push(O3, R3, U3);
                  break;
                }
                case "if-break":
                case "indent-if-break": {
                  let B3 = b3.groupId ? h3[b3.groupId] : x3;
                  if (B3 === m3) {
                    let I3 = b3.type === "if-break" ? b3.breakContents : b3.negate ? b3.contents : r3(b3.contents);
                    I3 && T3.push({ ind: E3, mode: x3, doc: I3 });
                  }
                  if (B3 === y3) {
                    let I3 = b3.type === "if-break" ? b3.flatContents : b3.negate ? r3(b3.contents) : b3.contents;
                    I3 && T3.push({ ind: E3, mode: x3, doc: I3 });
                  }
                  break;
                }
                case "line-suffix":
                  i.push({ ind: E3, mode: x3, doc: b3.contents });
                  break;
                case "line-suffix-boundary":
                  i.length > 0 && T3.push({ ind: E3, mode: x3, doc: { type: "line", hard: true } });
                  break;
                case "line":
                  switch (x3) {
                    case y3:
                      if (b3.hard)
                        F3 = true;
                      else {
                        b3.soft || (D3.push(" "), f3 += 1);
                        break;
                      }
                    case m3:
                      if (i.length > 0) {
                        T3.push({ ind: E3, mode: x3, doc: b3 }, ...i.reverse()), i.length = 0;
                        break;
                      }
                      b3.literal ? E3.root ? (D3.push(J3, E3.root.value), f3 = E3.root.length) : (D3.push(J3), f3 = 0) : (f3 -= P3(D3), D3.push(J3 + E3.value), f3 = E3.length);
                      break;
                  }
                  break;
                case "label":
                  T3.push({ ind: E3, mode: x3, doc: b3.contents });
                  break;
              }
            T3.length === 0 && i.length > 0 && (T3.push(...i.reverse()), i.length = 0);
          }
          let g3 = D3.indexOf(n3.placeholder);
          if (g3 !== -1) {
            let E3 = D3.indexOf(n3.placeholder, g3 + 1), x3 = D3.slice(0, g3).join(""), b3 = D3.slice(g3 + 1, E3).join(""), B3 = D3.slice(E3 + 1).join("");
            return { formatted: x3 + b3 + B3, cursorNodeStart: x3.length, cursorNodeText: b3 };
          }
          return { formatted: D3.join("") };
        }
        l3.exports = { printDocToString: N3 };
      } }), Xi2 = X3({ "src/document/doc-debug.js"(u3, l3) {
        H3();
        var { isConcat: t3, getDocParts: s3 } = sn2();
        function a3(n3) {
          if (!n3)
            return "";
          if (t3(n3)) {
            let r3 = [];
            for (let o3 of s3(n3))
              if (t3(o3))
                r3.push(...a3(o3).parts);
              else {
                let c3 = a3(o3);
                c3 !== "" && r3.push(c3);
              }
            return { type: "concat", parts: r3 };
          }
          return n3.type === "if-break" ? Object.assign(Object.assign({}, n3), {}, { breakContents: a3(n3.breakContents), flatContents: a3(n3.flatContents) }) : n3.type === "group" ? Object.assign(Object.assign({}, n3), {}, { contents: a3(n3.contents), expandedStates: n3.expandedStates && n3.expandedStates.map(a3) }) : n3.type === "fill" ? { type: "fill", parts: n3.parts.map(a3) } : n3.contents ? Object.assign(Object.assign({}, n3), {}, { contents: a3(n3.contents) }) : n3;
        }
        function e28(n3) {
          let r3 = /* @__PURE__ */ Object.create(null), o3 = /* @__PURE__ */ new Set();
          return c3(a3(n3));
          function c3(m3, y3, p3) {
            if (typeof m3 == "string")
              return JSON.stringify(m3);
            if (t3(m3)) {
              let d3 = s3(m3).map(c3).filter(Boolean);
              return d3.length === 1 ? d3[0] : `[${d3.join(", ")}]`;
            }
            if (m3.type === "line") {
              let d3 = Array.isArray(p3) && p3[y3 + 1] && p3[y3 + 1].type === "break-parent";
              return m3.literal ? d3 ? "literalline" : "literallineWithoutBreakParent" : m3.hard ? d3 ? "hardline" : "hardlineWithoutBreakParent" : m3.soft ? "softline" : "line";
            }
            if (m3.type === "break-parent")
              return Array.isArray(p3) && p3[y3 - 1] && p3[y3 - 1].type === "line" && p3[y3 - 1].hard ? void 0 : "breakParent";
            if (m3.type === "trim")
              return "trim";
            if (m3.type === "indent")
              return "indent(" + c3(m3.contents) + ")";
            if (m3.type === "align")
              return m3.n === Number.NEGATIVE_INFINITY ? "dedentToRoot(" + c3(m3.contents) + ")" : m3.n < 0 ? "dedent(" + c3(m3.contents) + ")" : m3.n.type === "root" ? "markAsRoot(" + c3(m3.contents) + ")" : "align(" + JSON.stringify(m3.n) + ", " + c3(m3.contents) + ")";
            if (m3.type === "if-break")
              return "ifBreak(" + c3(m3.breakContents) + (m3.flatContents ? ", " + c3(m3.flatContents) : "") + (m3.groupId ? (m3.flatContents ? "" : ', ""') + `, { groupId: ${h3(m3.groupId)} }` : "") + ")";
            if (m3.type === "indent-if-break") {
              let d3 = [];
              m3.negate && d3.push("negate: true"), m3.groupId && d3.push(`groupId: ${h3(m3.groupId)}`);
              let C3 = d3.length > 0 ? `, { ${d3.join(", ")} }` : "";
              return `indentIfBreak(${c3(m3.contents)}${C3})`;
            }
            if (m3.type === "group") {
              let d3 = [];
              m3.break && m3.break !== "propagated" && d3.push("shouldBreak: true"), m3.id && d3.push(`id: ${h3(m3.id)}`);
              let C3 = d3.length > 0 ? `, { ${d3.join(", ")} }` : "";
              return m3.expandedStates ? `conditionalGroup([${m3.expandedStates.map((w3) => c3(w3)).join(",")}]${C3})` : `group(${c3(m3.contents)}${C3})`;
            }
            if (m3.type === "fill")
              return `fill([${m3.parts.map((d3) => c3(d3)).join(", ")}])`;
            if (m3.type === "line-suffix")
              return "lineSuffix(" + c3(m3.contents) + ")";
            if (m3.type === "line-suffix-boundary")
              return "lineSuffixBoundary";
            if (m3.type === "label")
              return `label(${JSON.stringify(m3.label)}, ${c3(m3.contents)})`;
            throw new Error("Unknown doc type " + m3.type);
          }
          function h3(m3) {
            if (typeof m3 != "symbol")
              return JSON.stringify(String(m3));
            if (m3 in r3)
              return r3[m3];
            let y3 = String(m3).slice(7, -1) || "symbol";
            for (let p3 = 0; ; p3++) {
              let d3 = y3 + (p3 > 0 ? ` #${p3}` : "");
              if (!o3.has(d3))
                return o3.add(d3), r3[m3] = `Symbol.for(${JSON.stringify(d3)})`;
            }
          }
        }
        l3.exports = { printDocToDebug: e28 };
      } }), Qe2 = X3({ "src/document/index.js"(u3, l3) {
        H3(), l3.exports = { builders: Pt2(), printer: Wi2(), utils: sn2(), debug: Xi2() };
      } }), Wr2 = {};
      Ke2(Wr2, { default: () => Ui2 });
      function Ui2(u3) {
        if (typeof u3 != "string")
          throw new TypeError("Expected a string");
        return u3.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
      }
      var Yi2 = Je2({ "node_modules/escape-string-regexp/index.js"() {
        H3();
      } }), Xr2 = X3({ "node_modules/semver/internal/debug.js"(u3, l3) {
        H3();
        var t3 = typeof yt2 == "object" && yt2.env && yt2.env.NODE_DEBUG && /\bsemver\b/i.test(yt2.env.NODE_DEBUG) ? function() {
          for (var s3 = arguments.length, a3 = new Array(s3), e28 = 0; e28 < s3; e28++)
            a3[e28] = arguments[e28];
          return console.error("SEMVER", ...a3);
        } : () => {
        };
        l3.exports = t3;
      } }), Ur2 = X3({ "node_modules/semver/internal/constants.js"(u3, l3) {
        H3();
        var t3 = "2.0.0", s3 = 256, a3 = Number.MAX_SAFE_INTEGER || 9007199254740991, e28 = 16;
        l3.exports = { SEMVER_SPEC_VERSION: t3, MAX_LENGTH: s3, MAX_SAFE_INTEGER: a3, MAX_SAFE_COMPONENT_LENGTH: e28 };
      } }), zi2 = X3({ "node_modules/semver/internal/re.js"(u3, l3) {
        H3();
        var { MAX_SAFE_COMPONENT_LENGTH: t3 } = Ur2(), s3 = Xr2();
        u3 = l3.exports = {};
        var a3 = u3.re = [], e28 = u3.src = [], n3 = u3.t = {}, r3 = 0, o3 = (c3, h3, m3) => {
          let y3 = r3++;
          s3(c3, y3, h3), n3[c3] = y3, e28[y3] = h3, a3[y3] = new RegExp(h3, m3 ? "g" : void 0);
        };
        o3("NUMERICIDENTIFIER", "0|[1-9]\\d*"), o3("NUMERICIDENTIFIERLOOSE", "[0-9]+"), o3("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), o3("MAINVERSION", `(${e28[n3.NUMERICIDENTIFIER]})\\.(${e28[n3.NUMERICIDENTIFIER]})\\.(${e28[n3.NUMERICIDENTIFIER]})`), o3("MAINVERSIONLOOSE", `(${e28[n3.NUMERICIDENTIFIERLOOSE]})\\.(${e28[n3.NUMERICIDENTIFIERLOOSE]})\\.(${e28[n3.NUMERICIDENTIFIERLOOSE]})`), o3("PRERELEASEIDENTIFIER", `(?:${e28[n3.NUMERICIDENTIFIER]}|${e28[n3.NONNUMERICIDENTIFIER]})`), o3("PRERELEASEIDENTIFIERLOOSE", `(?:${e28[n3.NUMERICIDENTIFIERLOOSE]}|${e28[n3.NONNUMERICIDENTIFIER]})`), o3("PRERELEASE", `(?:-(${e28[n3.PRERELEASEIDENTIFIER]}(?:\\.${e28[n3.PRERELEASEIDENTIFIER]})*))`), o3("PRERELEASELOOSE", `(?:-?(${e28[n3.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${e28[n3.PRERELEASEIDENTIFIERLOOSE]})*))`), o3("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), o3("BUILD", `(?:\\+(${e28[n3.BUILDIDENTIFIER]}(?:\\.${e28[n3.BUILDIDENTIFIER]})*))`), o3("FULLPLAIN", `v?${e28[n3.MAINVERSION]}${e28[n3.PRERELEASE]}?${e28[n3.BUILD]}?`), o3("FULL", `^${e28[n3.FULLPLAIN]}$`), o3("LOOSEPLAIN", `[v=\\s]*${e28[n3.MAINVERSIONLOOSE]}${e28[n3.PRERELEASELOOSE]}?${e28[n3.BUILD]}?`), o3("LOOSE", `^${e28[n3.LOOSEPLAIN]}$`), o3("GTLT", "((?:<|>)?=?)"), o3("XRANGEIDENTIFIERLOOSE", `${e28[n3.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), o3("XRANGEIDENTIFIER", `${e28[n3.NUMERICIDENTIFIER]}|x|X|\\*`), o3("XRANGEPLAIN", `[v=\\s]*(${e28[n3.XRANGEIDENTIFIER]})(?:\\.(${e28[n3.XRANGEIDENTIFIER]})(?:\\.(${e28[n3.XRANGEIDENTIFIER]})(?:${e28[n3.PRERELEASE]})?${e28[n3.BUILD]}?)?)?`), o3("XRANGEPLAINLOOSE", `[v=\\s]*(${e28[n3.XRANGEIDENTIFIERLOOSE]})(?:\\.(${e28[n3.XRANGEIDENTIFIERLOOSE]})(?:\\.(${e28[n3.XRANGEIDENTIFIERLOOSE]})(?:${e28[n3.PRERELEASELOOSE]})?${e28[n3.BUILD]}?)?)?`), o3("XRANGE", `^${e28[n3.GTLT]}\\s*${e28[n3.XRANGEPLAIN]}$`), o3("XRANGELOOSE", `^${e28[n3.GTLT]}\\s*${e28[n3.XRANGEPLAINLOOSE]}$`), o3("COERCE", `(^|[^\\d])(\\d{1,${t3}})(?:\\.(\\d{1,${t3}}))?(?:\\.(\\d{1,${t3}}))?(?:$|[^\\d])`), o3("COERCERTL", e28[n3.COERCE], true), o3("LONETILDE", "(?:~>?)"), o3("TILDETRIM", `(\\s*)${e28[n3.LONETILDE]}\\s+`, true), u3.tildeTrimReplace = "$1~", o3("TILDE", `^${e28[n3.LONETILDE]}${e28[n3.XRANGEPLAIN]}$`), o3("TILDELOOSE", `^${e28[n3.LONETILDE]}${e28[n3.XRANGEPLAINLOOSE]}$`), o3("LONECARET", "(?:\\^)"), o3("CARETTRIM", `(\\s*)${e28[n3.LONECARET]}\\s+`, true), u3.caretTrimReplace = "$1^", o3("CARET", `^${e28[n3.LONECARET]}${e28[n3.XRANGEPLAIN]}$`), o3("CARETLOOSE", `^${e28[n3.LONECARET]}${e28[n3.XRANGEPLAINLOOSE]}$`), o3("COMPARATORLOOSE", `^${e28[n3.GTLT]}\\s*(${e28[n3.LOOSEPLAIN]})$|^$`), o3("COMPARATOR", `^${e28[n3.GTLT]}\\s*(${e28[n3.FULLPLAIN]})$|^$`), o3("COMPARATORTRIM", `(\\s*)${e28[n3.GTLT]}\\s*(${e28[n3.LOOSEPLAIN]}|${e28[n3.XRANGEPLAIN]})`, true), u3.comparatorTrimReplace = "$1$2$3", o3("HYPHENRANGE", `^\\s*(${e28[n3.XRANGEPLAIN]})\\s+-\\s+(${e28[n3.XRANGEPLAIN]})\\s*$`), o3("HYPHENRANGELOOSE", `^\\s*(${e28[n3.XRANGEPLAINLOOSE]})\\s+-\\s+(${e28[n3.XRANGEPLAINLOOSE]})\\s*$`), o3("STAR", "(<|>)?=?\\s*\\*"), o3("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), o3("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
      } }), Ki2 = X3({ "node_modules/semver/internal/parse-options.js"(u3, l3) {
        H3();
        var t3 = ["includePrerelease", "loose", "rtl"], s3 = (a3) => a3 ? typeof a3 != "object" ? { loose: true } : t3.filter((e28) => a3[e28]).reduce((e28, n3) => (e28[n3] = true, e28), {}) : {};
        l3.exports = s3;
      } }), Qi2 = X3({ "node_modules/semver/internal/identifiers.js"(u3, l3) {
        H3();
        var t3 = /^[0-9]+$/, s3 = (e28, n3) => {
          let r3 = t3.test(e28), o3 = t3.test(n3);
          return r3 && o3 && (e28 = +e28, n3 = +n3), e28 === n3 ? 0 : r3 && !o3 ? -1 : o3 && !r3 ? 1 : e28 < n3 ? -1 : 1;
        }, a3 = (e28, n3) => s3(n3, e28);
        l3.exports = { compareIdentifiers: s3, rcompareIdentifiers: a3 };
      } }), Hi2 = X3({ "node_modules/semver/classes/semver.js"(u3, l3) {
        H3();
        var t3 = Xr2(), { MAX_LENGTH: s3, MAX_SAFE_INTEGER: a3 } = Ur2(), { re: e28, t: n3 } = zi2(), r3 = Ki2(), { compareIdentifiers: o3 } = Qi2(), c3 = class {
          constructor(h3, m3) {
            if (m3 = r3(m3), h3 instanceof c3) {
              if (h3.loose === !!m3.loose && h3.includePrerelease === !!m3.includePrerelease)
                return h3;
              h3 = h3.version;
            } else if (typeof h3 != "string")
              throw new TypeError(`Invalid Version: ${h3}`);
            if (h3.length > s3)
              throw new TypeError(`version is longer than ${s3} characters`);
            t3("SemVer", h3, m3), this.options = m3, this.loose = !!m3.loose, this.includePrerelease = !!m3.includePrerelease;
            let y3 = h3.trim().match(m3.loose ? e28[n3.LOOSE] : e28[n3.FULL]);
            if (!y3)
              throw new TypeError(`Invalid Version: ${h3}`);
            if (this.raw = h3, this.major = +y3[1], this.minor = +y3[2], this.patch = +y3[3], this.major > a3 || this.major < 0)
              throw new TypeError("Invalid major version");
            if (this.minor > a3 || this.minor < 0)
              throw new TypeError("Invalid minor version");
            if (this.patch > a3 || this.patch < 0)
              throw new TypeError("Invalid patch version");
            y3[4] ? this.prerelease = y3[4].split(".").map((p3) => {
              if (/^[0-9]+$/.test(p3)) {
                let d3 = +p3;
                if (d3 >= 0 && d3 < a3)
                  return d3;
              }
              return p3;
            }) : this.prerelease = [], this.build = y3[5] ? y3[5].split(".") : [], this.format();
          }
          format() {
            return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
          }
          toString() {
            return this.version;
          }
          compare(h3) {
            if (t3("SemVer.compare", this.version, this.options, h3), !(h3 instanceof c3)) {
              if (typeof h3 == "string" && h3 === this.version)
                return 0;
              h3 = new c3(h3, this.options);
            }
            return h3.version === this.version ? 0 : this.compareMain(h3) || this.comparePre(h3);
          }
          compareMain(h3) {
            return h3 instanceof c3 || (h3 = new c3(h3, this.options)), o3(this.major, h3.major) || o3(this.minor, h3.minor) || o3(this.patch, h3.patch);
          }
          comparePre(h3) {
            if (h3 instanceof c3 || (h3 = new c3(h3, this.options)), this.prerelease.length && !h3.prerelease.length)
              return -1;
            if (!this.prerelease.length && h3.prerelease.length)
              return 1;
            if (!this.prerelease.length && !h3.prerelease.length)
              return 0;
            let m3 = 0;
            do {
              let y3 = this.prerelease[m3], p3 = h3.prerelease[m3];
              if (t3("prerelease compare", m3, y3, p3), y3 === void 0 && p3 === void 0)
                return 0;
              if (p3 === void 0)
                return 1;
              if (y3 === void 0)
                return -1;
              if (y3 !== p3)
                return o3(y3, p3);
            } while (++m3);
          }
          compareBuild(h3) {
            h3 instanceof c3 || (h3 = new c3(h3, this.options));
            let m3 = 0;
            do {
              let y3 = this.build[m3], p3 = h3.build[m3];
              if (t3("prerelease compare", m3, y3, p3), y3 === void 0 && p3 === void 0)
                return 0;
              if (p3 === void 0)
                return 1;
              if (y3 === void 0)
                return -1;
              if (y3 !== p3)
                return o3(y3, p3);
            } while (++m3);
          }
          inc(h3, m3) {
            switch (h3) {
              case "premajor":
                this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", m3);
                break;
              case "preminor":
                this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", m3);
                break;
              case "prepatch":
                this.prerelease.length = 0, this.inc("patch", m3), this.inc("pre", m3);
                break;
              case "prerelease":
                this.prerelease.length === 0 && this.inc("patch", m3), this.inc("pre", m3);
                break;
              case "major":
                (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                break;
              case "minor":
                (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
                break;
              case "patch":
                this.prerelease.length === 0 && this.patch++, this.prerelease = [];
                break;
              case "pre":
                if (this.prerelease.length === 0)
                  this.prerelease = [0];
                else {
                  let y3 = this.prerelease.length;
                  for (; --y3 >= 0; )
                    typeof this.prerelease[y3] == "number" && (this.prerelease[y3]++, y3 = -2);
                  y3 === -1 && this.prerelease.push(0);
                }
                m3 && (o3(this.prerelease[0], m3) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [m3, 0]) : this.prerelease = [m3, 0]);
                break;
              default:
                throw new Error(`invalid increment argument: ${h3}`);
            }
            return this.format(), this.raw = this.version, this;
          }
        };
        l3.exports = c3;
      } }), zn2 = X3({ "node_modules/semver/functions/compare.js"(u3, l3) {
        H3();
        var t3 = Hi2(), s3 = (a3, e28, n3) => new t3(a3, n3).compare(new t3(e28, n3));
        l3.exports = s3;
      } }), Zi2 = X3({ "node_modules/semver/functions/lt.js"(u3, l3) {
        H3();
        var t3 = zn2(), s3 = (a3, e28, n3) => t3(a3, e28, n3) < 0;
        l3.exports = s3;
      } }), ea2 = X3({ "node_modules/semver/functions/gte.js"(u3, l3) {
        H3();
        var t3 = zn2(), s3 = (a3, e28, n3) => t3(a3, e28, n3) >= 0;
        l3.exports = s3;
      } }), ta2 = X3({ "src/utils/arrayify.js"(u3, l3) {
        H3(), l3.exports = (t3, s3) => Object.entries(t3).map((a3) => {
          let [e28, n3] = a3;
          return Object.assign({ [s3]: e28 }, n3);
        });
      } }), na2 = X3({ "node_modules/outdent/lib/index.js"(u3, l3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true }), u3.outdent = void 0;
        function t3() {
          for (var A3 = [], N3 = 0; N3 < arguments.length; N3++)
            A3[N3] = arguments[N3];
        }
        function s3() {
          return typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : a3();
        }
        function a3() {
          return { add: t3, delete: t3, get: t3, set: t3, has: function(A3) {
            return false;
          } };
        }
        var e28 = Object.prototype.hasOwnProperty, n3 = function(A3, N3) {
          return e28.call(A3, N3);
        };
        function r3(A3, N3) {
          for (var S3 in N3)
            n3(N3, S3) && (A3[S3] = N3[S3]);
          return A3;
        }
        var o3 = /^[ \t]*(?:\r\n|\r|\n)/, c3 = /(?:\r\n|\r|\n)[ \t]*$/, h3 = /^(?:[\r\n]|$)/, m3 = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/, y3 = /^[ \t]*[\r\n][ \t\r\n]*$/;
        function p3(A3, N3, S3) {
          var j3 = 0, k3 = A3[0].match(m3);
          k3 && (j3 = k3[1].length);
          var J3 = "(\\r\\n|\\r|\\n).{0," + j3 + "}", f3 = new RegExp(J3, "g");
          N3 && (A3 = A3.slice(1));
          var T3 = S3.newline, D3 = S3.trimLeadingNewline, F3 = S3.trimTrailingNewline, i = typeof T3 == "string", g3 = A3.length, E3 = A3.map(function(x3, b3) {
            return x3 = x3.replace(f3, "$1"), b3 === 0 && D3 && (x3 = x3.replace(o3, "")), b3 === g3 - 1 && F3 && (x3 = x3.replace(c3, "")), i && (x3 = x3.replace(/\r\n|\n|\r/g, function(B3) {
              return T3;
            })), x3;
          });
          return E3;
        }
        function d3(A3, N3) {
          for (var S3 = "", j3 = 0, k3 = A3.length; j3 < k3; j3++)
            S3 += A3[j3], j3 < k3 - 1 && (S3 += N3[j3]);
          return S3;
        }
        function C3(A3) {
          return n3(A3, "raw") && n3(A3, "length");
        }
        function w3(A3) {
          var N3 = s3(), S3 = s3();
          function j3(J3) {
            for (var f3 = [], T3 = 1; T3 < arguments.length; T3++)
              f3[T3 - 1] = arguments[T3];
            if (C3(J3)) {
              var D3 = J3, F3 = (f3[0] === j3 || f3[0] === P3) && y3.test(D3[0]) && h3.test(D3[1]), i = F3 ? S3 : N3, g3 = i.get(D3);
              if (g3 || (g3 = p3(D3, F3, A3), i.set(D3, g3)), f3.length === 0)
                return g3[0];
              var E3 = d3(g3, F3 ? f3.slice(1) : f3);
              return E3;
            } else
              return w3(r3(r3({}, A3), J3 || {}));
          }
          var k3 = r3(j3, { string: function(J3) {
            return p3([J3], false, A3)[0];
          } });
          return k3;
        }
        var P3 = w3({ trimLeadingNewline: true, trimTrailingNewline: true });
        if (u3.outdent = P3, u3.default = P3, typeof l3 < "u")
          try {
            l3.exports = P3, Object.defineProperty(P3, "__esModule", { value: true }), P3.default = P3, P3.outdent = P3;
          } catch {
          }
      } }), ra2 = X3({ "src/main/core-options.js"(u3, l3) {
        H3();
        var { outdent: t3 } = na2(), s3 = "Config", a3 = "Editor", e28 = "Format", n3 = "Other", r3 = "Output", o3 = "Global", c3 = "Special", h3 = { cursorOffset: { since: "1.4.0", category: c3, type: "int", default: -1, range: { start: -1, end: Number.POSITIVE_INFINITY, step: 1 }, description: t3`
      Print (to stderr) where a cursor at the given position would move to after formatting.
      This option cannot be used with --range-start and --range-end.
    `, cliCategory: a3 }, endOfLine: { since: "1.15.0", category: o3, type: "choice", default: [{ since: "1.15.0", value: "auto" }, { since: "2.0.0", value: "lf" }], description: "Which end of line characters to apply.", choices: [{ value: "lf", description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos" }, { value: "crlf", description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows" }, { value: "cr", description: "Carriage Return character only (\\r), used very rarely" }, { value: "auto", description: t3`
          Maintain existing
          (mixed values within one file are normalised by looking at what's used after the first line)
        ` }] }, filepath: { since: "1.4.0", category: c3, type: "path", description: "Specify the input filepath. This will be used to do parser inference.", cliName: "stdin-filepath", cliCategory: n3, cliDescription: "Path to the file to pretend that stdin comes from." }, insertPragma: { since: "1.8.0", category: c3, type: "boolean", default: false, description: "Insert @format pragma into file's first docblock comment.", cliCategory: n3 }, parser: { since: "0.0.10", category: o3, type: "choice", default: [{ since: "0.0.10", value: "babylon" }, { since: "1.13.0", value: void 0 }], description: "Which parser to use.", exception: (m3) => typeof m3 == "string" || typeof m3 == "function", choices: [{ value: "flow", description: "Flow" }, { value: "babel", since: "1.16.0", description: "JavaScript" }, { value: "babel-flow", since: "1.16.0", description: "Flow" }, { value: "babel-ts", since: "2.0.0", description: "TypeScript" }, { value: "typescript", since: "1.4.0", description: "TypeScript" }, { value: "acorn", since: "2.6.0", description: "JavaScript" }, { value: "espree", since: "2.2.0", description: "JavaScript" }, { value: "meriyah", since: "2.2.0", description: "JavaScript" }, { value: "css", since: "1.7.1", description: "CSS" }, { value: "less", since: "1.7.1", description: "Less" }, { value: "scss", since: "1.7.1", description: "SCSS" }, { value: "json", since: "1.5.0", description: "JSON" }, { value: "json5", since: "1.13.0", description: "JSON5" }, { value: "json-stringify", since: "1.13.0", description: "JSON.stringify" }, { value: "graphql", since: "1.5.0", description: "GraphQL" }, { value: "markdown", since: "1.8.0", description: "Markdown" }, { value: "mdx", since: "1.15.0", description: "MDX" }, { value: "vue", since: "1.10.0", description: "Vue" }, { value: "yaml", since: "1.14.0", description: "YAML" }, { value: "glimmer", since: "2.3.0", description: "Ember / Handlebars" }, { value: "html", since: "1.15.0", description: "HTML" }, { value: "angular", since: "1.15.0", description: "Angular" }, { value: "lwc", since: "1.17.0", description: "Lightning Web Components" }] }, plugins: { since: "1.10.0", type: "path", array: true, default: [{ value: [] }], category: o3, description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.", exception: (m3) => typeof m3 == "string" || typeof m3 == "object", cliName: "plugin", cliCategory: s3 }, pluginSearchDirs: { since: "1.13.0", type: "path", array: true, default: [{ value: [] }], category: o3, description: t3`
      Custom directory that contains prettier plugins in node_modules subdirectory.
      Overrides default behavior when plugins are searched relatively to the location of Prettier.
      Multiple values are accepted.
    `, exception: (m3) => typeof m3 == "string" || typeof m3 == "object", cliName: "plugin-search-dir", cliCategory: s3 }, printWidth: { since: "0.0.0", category: o3, type: "int", default: 80, description: "The line length where Prettier will try wrap.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, rangeEnd: { since: "1.4.0", category: c3, type: "int", default: Number.POSITIVE_INFINITY, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: t3`
      Format code ending at a given character offset (exclusive).
      The range will extend forwards to the end of the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: a3 }, rangeStart: { since: "1.4.0", category: c3, type: "int", default: 0, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: t3`
      Format code starting at a given character offset.
      The range will extend backwards to the start of the first line containing the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: a3 }, requirePragma: { since: "1.7.0", category: c3, type: "boolean", default: false, description: t3`
      Require either '@prettier' or '@format' to be present in the file's first docblock comment
      in order for it to be formatted.
    `, cliCategory: n3 }, tabWidth: { type: "int", category: o3, default: 2, description: "Number of spaces per indentation level.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, useTabs: { since: "1.0.0", category: o3, type: "boolean", default: false, description: "Indent with tabs instead of spaces." }, embeddedLanguageFormatting: { since: "2.1.0", category: o3, type: "choice", default: [{ since: "2.1.0", value: "auto" }], description: "Control how Prettier formats quoted code embedded in the file.", choices: [{ value: "auto", description: "Format embedded code if Prettier can automatically identify it." }, { value: "off", description: "Never automatically format embedded code." }] } };
        l3.exports = { CATEGORY_CONFIG: s3, CATEGORY_EDITOR: a3, CATEGORY_FORMAT: e28, CATEGORY_OTHER: n3, CATEGORY_OUTPUT: r3, CATEGORY_GLOBAL: o3, CATEGORY_SPECIAL: c3, options: h3 };
      } }), Kn2 = X3({ "src/main/support.js"(u3, l3) {
        H3();
        var t3 = { compare: zn2(), lt: Zi2(), gte: ea2() }, s3 = ta2(), a3 = xt2().version, e28 = ra2().options;
        function n3() {
          let { plugins: o3 = [], showUnreleased: c3 = false, showDeprecated: h3 = false, showInternal: m3 = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, y3 = a3.split("-", 1)[0], p3 = o3.flatMap((A3) => A3.languages || []).filter(C3), d3 = s3(Object.assign({}, ...o3.map((A3) => {
            let { options: N3 } = A3;
            return N3;
          }), e28), "name").filter((A3) => C3(A3) && w3(A3)).sort((A3, N3) => A3.name === N3.name ? 0 : A3.name < N3.name ? -1 : 1).map(P3).map((A3) => {
            A3 = Object.assign({}, A3), Array.isArray(A3.default) && (A3.default = A3.default.length === 1 ? A3.default[0].value : A3.default.filter(C3).sort((S3, j3) => t3.compare(j3.since, S3.since))[0].value), Array.isArray(A3.choices) && (A3.choices = A3.choices.filter((S3) => C3(S3) && w3(S3)), A3.name === "parser" && r3(A3, p3, o3));
            let N3 = Object.fromEntries(o3.filter((S3) => S3.defaultOptions && S3.defaultOptions[A3.name] !== void 0).map((S3) => [S3.name, S3.defaultOptions[A3.name]]));
            return Object.assign(Object.assign({}, A3), {}, { pluginDefaults: N3 });
          });
          return { languages: p3, options: d3 };
          function C3(A3) {
            return c3 || !("since" in A3) || A3.since && t3.gte(y3, A3.since);
          }
          function w3(A3) {
            return h3 || !("deprecated" in A3) || A3.deprecated && t3.lt(y3, A3.deprecated);
          }
          function P3(A3) {
            return m3 ? A3 : Ce2(A3, ue2);
          }
        }
        function r3(o3, c3, h3) {
          let m3 = new Set(o3.choices.map((y3) => y3.value));
          for (let y3 of c3)
            if (y3.parsers) {
              for (let p3 of y3.parsers)
                if (!m3.has(p3)) {
                  m3.add(p3);
                  let d3 = h3.find((w3) => w3.parsers && w3.parsers[p3]), C3 = y3.name;
                  d3 && d3.name && (C3 += ` (plugin: ${d3.name})`), o3.choices.push({ value: p3, description: C3 });
                }
            }
        }
        l3.exports = { getSupportInfo: n3 };
      } }), Qn2 = X3({ "src/utils/is-non-empty-array.js"(u3, l3) {
        H3();
        function t3(s3) {
          return Array.isArray(s3) && s3.length > 0;
        }
        l3.exports = t3;
      } }), bn2 = X3({ "src/utils/text/skip.js"(u3, l3) {
        H3();
        function t3(r3) {
          return (o3, c3, h3) => {
            let m3 = h3 && h3.backwards;
            if (c3 === false)
              return false;
            let { length: y3 } = o3, p3 = c3;
            for (; p3 >= 0 && p3 < y3; ) {
              let d3 = o3.charAt(p3);
              if (r3 instanceof RegExp) {
                if (!r3.test(d3))
                  return p3;
              } else if (!r3.includes(d3))
                return p3;
              m3 ? p3-- : p3++;
            }
            return p3 === -1 || p3 === y3 ? p3 : false;
          };
        }
        var s3 = t3(/\s/), a3 = t3(" 	"), e28 = t3(",; 	"), n3 = t3(/[^\n\r]/);
        l3.exports = { skipWhitespace: s3, skipSpaces: a3, skipToLineEnd: e28, skipEverythingButNewLine: n3 };
      } }), Yr2 = X3({ "src/utils/text/skip-inline-comment.js"(u3, l3) {
        H3();
        function t3(s3, a3) {
          if (a3 === false)
            return false;
          if (s3.charAt(a3) === "/" && s3.charAt(a3 + 1) === "*") {
            for (let e28 = a3 + 2; e28 < s3.length; ++e28)
              if (s3.charAt(e28) === "*" && s3.charAt(e28 + 1) === "/")
                return e28 + 2;
          }
          return a3;
        }
        l3.exports = t3;
      } }), zr2 = X3({ "src/utils/text/skip-trailing-comment.js"(u3, l3) {
        H3();
        var { skipEverythingButNewLine: t3 } = bn2();
        function s3(a3, e28) {
          return e28 === false ? false : a3.charAt(e28) === "/" && a3.charAt(e28 + 1) === "/" ? t3(a3, e28) : e28;
        }
        l3.exports = s3;
      } }), Kr2 = X3({ "src/utils/text/skip-newline.js"(u3, l3) {
        H3();
        function t3(s3, a3, e28) {
          let n3 = e28 && e28.backwards;
          if (a3 === false)
            return false;
          let r3 = s3.charAt(a3);
          if (n3) {
            if (s3.charAt(a3 - 1) === "\r" && r3 === `
`)
              return a3 - 2;
            if (r3 === `
` || r3 === "\r" || r3 === "\u2028" || r3 === "\u2029")
              return a3 - 1;
          } else {
            if (r3 === "\r" && s3.charAt(a3 + 1) === `
`)
              return a3 + 2;
            if (r3 === `
` || r3 === "\r" || r3 === "\u2028" || r3 === "\u2029")
              return a3 + 1;
          }
          return a3;
        }
        l3.exports = t3;
      } }), ua2 = X3({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(u3, l3) {
        H3();
        var t3 = Yr2(), s3 = Kr2(), a3 = zr2(), { skipSpaces: e28 } = bn2();
        function n3(r3, o3) {
          let c3 = null, h3 = o3;
          for (; h3 !== c3; )
            c3 = h3, h3 = e28(r3, h3), h3 = t3(r3, h3), h3 = a3(r3, h3), h3 = s3(r3, h3);
          return h3;
        }
        l3.exports = n3;
      } }), at2 = X3({ "src/common/util.js"(u3, l3) {
        H3();
        var { default: t3 } = (Yi2(), lt2(Wr2)), s3 = Ct2(), { getSupportInfo: a3 } = Kn2(), e28 = Qn2(), n3 = Gr2(), { skipWhitespace: r3, skipSpaces: o3, skipToLineEnd: c3, skipEverythingButNewLine: h3 } = bn2(), m3 = Yr2(), y3 = zr2(), p3 = Kr2(), d3 = ua2(), C3 = (R3) => R3[R3.length - 2];
        function w3(R3) {
          return (O3, Z3, ie2) => {
            let te2 = ie2 && ie2.backwards;
            if (Z3 === false)
              return false;
            let { length: ge2 } = O3, q3 = Z3;
            for (; q3 >= 0 && q3 < ge2; ) {
              let z3 = O3.charAt(q3);
              if (R3 instanceof RegExp) {
                if (!R3.test(z3))
                  return q3;
              } else if (!R3.includes(z3))
                return q3;
              te2 ? q3-- : q3++;
            }
            return q3 === -1 || q3 === ge2 ? q3 : false;
          };
        }
        function P3(R3, O3) {
          let Z3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, ie2 = o3(R3, Z3.backwards ? O3 - 1 : O3, Z3), te2 = p3(R3, ie2, Z3);
          return ie2 !== te2;
        }
        function A3(R3, O3, Z3) {
          for (let ie2 = O3; ie2 < Z3; ++ie2)
            if (R3.charAt(ie2) === `
`)
              return true;
          return false;
        }
        function N3(R3, O3, Z3) {
          let ie2 = Z3(O3) - 1;
          ie2 = o3(R3, ie2, { backwards: true }), ie2 = p3(R3, ie2, { backwards: true }), ie2 = o3(R3, ie2, { backwards: true });
          let te2 = p3(R3, ie2, { backwards: true });
          return ie2 !== te2;
        }
        function S3(R3, O3) {
          let Z3 = null, ie2 = O3;
          for (; ie2 !== Z3; )
            Z3 = ie2, ie2 = c3(R3, ie2), ie2 = m3(R3, ie2), ie2 = o3(R3, ie2);
          return ie2 = y3(R3, ie2), ie2 = p3(R3, ie2), ie2 !== false && P3(R3, ie2);
        }
        function j3(R3, O3, Z3) {
          return S3(R3, Z3(O3));
        }
        function k3(R3, O3, Z3) {
          return d3(R3, Z3(O3));
        }
        function J3(R3, O3, Z3) {
          return R3.charAt(k3(R3, O3, Z3));
        }
        function f3(R3, O3) {
          let Z3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return o3(R3, Z3.backwards ? O3 - 1 : O3, Z3) !== O3;
        }
        function T3(R3, O3) {
          let Z3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, ie2 = 0;
          for (let te2 = Z3; te2 < R3.length; ++te2)
            R3[te2] === "	" ? ie2 = ie2 + O3 - ie2 % O3 : ie2++;
          return ie2;
        }
        function D3(R3, O3) {
          let Z3 = R3.lastIndexOf(`
`);
          return Z3 === -1 ? 0 : T3(R3.slice(Z3 + 1).match(/^[\t ]*/)[0], O3);
        }
        function F3(R3, O3) {
          let Z3 = { quote: '"', regex: /"/g, escaped: "&quot;" }, ie2 = { quote: "'", regex: /'/g, escaped: "&apos;" }, te2 = O3 === "'" ? ie2 : Z3, ge2 = te2 === ie2 ? Z3 : ie2, q3 = te2;
          if (R3.includes(te2.quote) || R3.includes(ge2.quote)) {
            let z3 = (R3.match(te2.regex) || []).length, De2 = (R3.match(ge2.regex) || []).length;
            q3 = z3 > De2 ? ge2 : te2;
          }
          return q3;
        }
        function i(R3, O3) {
          let Z3 = R3.slice(1, -1), ie2 = O3.parser === "json" || O3.parser === "json5" && O3.quoteProps === "preserve" && !O3.singleQuote ? '"' : O3.__isInHtmlAttribute ? "'" : F3(Z3, O3.singleQuote ? "'" : '"').quote;
          return g3(Z3, ie2, !(O3.parser === "css" || O3.parser === "less" || O3.parser === "scss" || O3.__embeddedInHtml));
        }
        function g3(R3, O3, Z3) {
          let ie2 = O3 === '"' ? "'" : '"', te2 = /\\(.)|(["'])/gs, ge2 = R3.replace(te2, (q3, z3, De2) => z3 === ie2 ? z3 : De2 === O3 ? "\\" + De2 : De2 || (Z3 && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(z3) ? z3 : "\\" + z3));
          return O3 + ge2 + O3;
        }
        function E3(R3) {
          return R3.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
        }
        function x3(R3, O3) {
          let Z3 = R3.match(new RegExp(`(${t3(O3)})+`, "g"));
          return Z3 === null ? 0 : Z3.reduce((ie2, te2) => Math.max(ie2, te2.length / O3.length), 0);
        }
        function b3(R3, O3) {
          let Z3 = R3.match(new RegExp(`(${t3(O3)})+`, "g"));
          if (Z3 === null)
            return 0;
          let ie2 = /* @__PURE__ */ new Map(), te2 = 0;
          for (let ge2 of Z3) {
            let q3 = ge2.length / O3.length;
            ie2.set(q3, true), q3 > te2 && (te2 = q3);
          }
          for (let ge2 = 1; ge2 < te2; ge2++)
            if (!ie2.get(ge2))
              return ge2;
          return te2 + 1;
        }
        function B3(R3, O3) {
          (R3.comments || (R3.comments = [])).push(O3), O3.printed = false, O3.nodeDescription = ee2(R3);
        }
        function I3(R3, O3) {
          O3.leading = true, O3.trailing = false, B3(R3, O3);
        }
        function M3(R3, O3, Z3) {
          O3.leading = false, O3.trailing = false, Z3 && (O3.marker = Z3), B3(R3, O3);
        }
        function V10(R3, O3) {
          O3.leading = false, O3.trailing = true, B3(R3, O3);
        }
        function $3(R3, O3) {
          let { languages: Z3 } = a3({ plugins: O3.plugins }), ie2 = Z3.find((te2) => {
            let { name: ge2 } = te2;
            return ge2.toLowerCase() === R3;
          }) || Z3.find((te2) => {
            let { aliases: ge2 } = te2;
            return Array.isArray(ge2) && ge2.includes(R3);
          }) || Z3.find((te2) => {
            let { extensions: ge2 } = te2;
            return Array.isArray(ge2) && ge2.includes(`.${R3}`);
          });
          return ie2 && ie2.parsers[0];
        }
        function U3(R3) {
          return R3 && R3.type === "front-matter";
        }
        function L3(R3) {
          let O3 = /* @__PURE__ */ new WeakMap();
          return function(Z3) {
            return O3.has(Z3) || O3.set(Z3, Symbol(R3)), O3.get(Z3);
          };
        }
        function ee2(R3) {
          let O3 = R3.type || R3.kind || "(unknown type)", Z3 = String(R3.name || R3.id && (typeof R3.id == "object" ? R3.id.name : R3.id) || R3.key && (typeof R3.key == "object" ? R3.key.name : R3.key) || R3.value && (typeof R3.value == "object" ? "" : String(R3.value)) || R3.operator || "");
          return Z3.length > 20 && (Z3 = Z3.slice(0, 19) + "\u2026"), O3 + (Z3 ? " " + Z3 : "");
        }
        l3.exports = { inferParserByLanguage: $3, getStringWidth: n3, getMaxContinuousCount: x3, getMinNotPresentContinuousCount: b3, getPenultimate: C3, getLast: s3, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: d3, getNextNonSpaceNonCommentCharacterIndex: k3, getNextNonSpaceNonCommentCharacter: J3, skip: w3, skipWhitespace: r3, skipSpaces: o3, skipToLineEnd: c3, skipEverythingButNewLine: h3, skipInlineComment: m3, skipTrailingComment: y3, skipNewline: p3, isNextLineEmptyAfterIndex: S3, isNextLineEmpty: j3, isPreviousLineEmpty: N3, hasNewline: P3, hasNewlineInRange: A3, hasSpaces: f3, getAlignmentSize: T3, getIndentSize: D3, getPreferredQuote: F3, printString: i, printNumber: E3, makeString: g3, addLeadingComment: I3, addDanglingComment: M3, addTrailingComment: V10, isFrontMatterNode: U3, isNonEmptyArray: e28, createGroupIdMapper: L3 };
      } }), Qr2 = {};
      Ke2(Qr2, { basename: () => nu2, default: () => iu2, delimiter: () => nr2, dirname: () => tu2, extname: () => ru2, isAbsolute: () => Zn2, join: () => Zr2, normalize: () => Hn2, relative: () => eu2, resolve: () => Sn2, sep: () => tr2 });
      function Hr2(u3, l3) {
        for (var t3 = 0, s3 = u3.length - 1; s3 >= 0; s3--) {
          var a3 = u3[s3];
          a3 === "." ? u3.splice(s3, 1) : a3 === ".." ? (u3.splice(s3, 1), t3++) : t3 && (u3.splice(s3, 1), t3--);
        }
        if (l3)
          for (; t3--; t3)
            u3.unshift("..");
        return u3;
      }
      function Sn2() {
        for (var u3 = "", l3 = false, t3 = arguments.length - 1; t3 >= -1 && !l3; t3--) {
          var s3 = t3 >= 0 ? arguments[t3] : "/";
          if (typeof s3 != "string")
            throw new TypeError("Arguments to path.resolve must be strings");
          s3 && (u3 = s3 + "/" + u3, l3 = s3.charAt(0) === "/");
        }
        return u3 = Hr2(er2(u3.split("/"), function(a3) {
          return !!a3;
        }), !l3).join("/"), (l3 ? "/" : "") + u3 || ".";
      }
      function Hn2(u3) {
        var l3 = Zn2(u3), t3 = au2(u3, -1) === "/";
        return u3 = Hr2(er2(u3.split("/"), function(s3) {
          return !!s3;
        }), !l3).join("/"), !u3 && !l3 && (u3 = "."), u3 && t3 && (u3 += "/"), (l3 ? "/" : "") + u3;
      }
      function Zn2(u3) {
        return u3.charAt(0) === "/";
      }
      function Zr2() {
        var u3 = Array.prototype.slice.call(arguments, 0);
        return Hn2(er2(u3, function(l3, t3) {
          if (typeof l3 != "string")
            throw new TypeError("Arguments to path.join must be strings");
          return l3;
        }).join("/"));
      }
      function eu2(u3, l3) {
        u3 = Sn2(u3).substr(1), l3 = Sn2(l3).substr(1);
        function t3(c3) {
          for (var h3 = 0; h3 < c3.length && c3[h3] === ""; h3++)
            ;
          for (var m3 = c3.length - 1; m3 >= 0 && c3[m3] === ""; m3--)
            ;
          return h3 > m3 ? [] : c3.slice(h3, m3 - h3 + 1);
        }
        for (var s3 = t3(u3.split("/")), a3 = t3(l3.split("/")), e28 = Math.min(s3.length, a3.length), n3 = e28, r3 = 0; r3 < e28; r3++)
          if (s3[r3] !== a3[r3]) {
            n3 = r3;
            break;
          }
        for (var o3 = [], r3 = n3; r3 < s3.length; r3++)
          o3.push("..");
        return o3 = o3.concat(a3.slice(n3)), o3.join("/");
      }
      function tu2(u3) {
        var l3 = Tn2(u3), t3 = l3[0], s3 = l3[1];
        return !t3 && !s3 ? "." : (s3 && (s3 = s3.substr(0, s3.length - 1)), t3 + s3);
      }
      function nu2(u3, l3) {
        var t3 = Tn2(u3)[2];
        return l3 && t3.substr(-1 * l3.length) === l3 && (t3 = t3.substr(0, t3.length - l3.length)), t3;
      }
      function ru2(u3) {
        return Tn2(u3)[3];
      }
      function er2(u3, l3) {
        if (u3.filter)
          return u3.filter(l3);
        for (var t3 = [], s3 = 0; s3 < u3.length; s3++)
          l3(u3[s3], s3, u3) && t3.push(u3[s3]);
        return t3;
      }
      var uu2, Tn2, tr2, nr2, iu2, au2, ia2 = Je2({ "node-modules-polyfills:path"() {
        H3(), uu2 = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/, Tn2 = function(u3) {
          return uu2.exec(u3).slice(1);
        }, tr2 = "/", nr2 = ":", iu2 = { extname: ru2, basename: nu2, dirname: tu2, sep: tr2, delimiter: nr2, relative: eu2, join: Zr2, isAbsolute: Zn2, normalize: Hn2, resolve: Sn2 }, au2 = "ab".substr(-1) === "b" ? function(u3, l3, t3) {
          return u3.substr(l3, t3);
        } : function(u3, l3, t3) {
          return l3 < 0 && (l3 = u3.length + l3), u3.substr(l3, t3);
        };
      } }), aa2 = X3({ "node-modules-polyfills-commonjs:path"(u3, l3) {
        H3();
        var t3 = (ia2(), lt2(Qr2));
        if (t3 && t3.default) {
          l3.exports = t3.default;
          for (let s3 in t3)
            l3.exports[s3] = t3[s3];
        } else
          t3 && (l3.exports = t3);
      } }), on2 = X3({ "src/common/errors.js"(u3, l3) {
        H3();
        var t3 = class extends Error {
        }, s3 = class extends Error {
        }, a3 = class extends Error {
        }, e28 = class extends Error {
        };
        l3.exports = { ConfigError: t3, DebugError: s3, UndefinedParserError: a3, ArgExpansionBailout: e28 };
      } }), Ot2 = {};
      Ke2(Ot2, { __assign: () => wn2, __asyncDelegator: () => Ea2, __asyncGenerator: () => ha2, __asyncValues: () => Ca2, __await: () => ln2, __awaiter: () => da2, __classPrivateFieldGet: () => xa2, __classPrivateFieldSet: () => ba2, __createBinding: () => fa2, __decorate: () => la2, __exportStar: () => ma2, __extends: () => sa2, __generator: () => Da2, __importDefault: () => va2, __importStar: () => Aa2, __makeTemplateObject: () => Fa2, __metadata: () => ca2, __param: () => pa2, __read: () => su2, __rest: () => oa2, __spread: () => ga2, __spreadArrays: () => ya2, __values: () => rr2 });
      function sa2(u3, l3) {
        Bn2(u3, l3);
        function t3() {
          this.constructor = u3;
        }
        u3.prototype = l3 === null ? Object.create(l3) : (t3.prototype = l3.prototype, new t3());
      }
      function oa2(u3, l3) {
        var t3 = {};
        for (var s3 in u3)
          Object.prototype.hasOwnProperty.call(u3, s3) && l3.indexOf(s3) < 0 && (t3[s3] = u3[s3]);
        if (u3 != null && typeof Object.getOwnPropertySymbols == "function")
          for (var a3 = 0, s3 = Object.getOwnPropertySymbols(u3); a3 < s3.length; a3++)
            l3.indexOf(s3[a3]) < 0 && Object.prototype.propertyIsEnumerable.call(u3, s3[a3]) && (t3[s3[a3]] = u3[s3[a3]]);
        return t3;
      }
      function la2(u3, l3, t3, s3) {
        var a3 = arguments.length, e28 = a3 < 3 ? l3 : s3 === null ? s3 = Object.getOwnPropertyDescriptor(l3, t3) : s3, n3;
        if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
          e28 = Reflect.decorate(u3, l3, t3, s3);
        else
          for (var r3 = u3.length - 1; r3 >= 0; r3--)
            (n3 = u3[r3]) && (e28 = (a3 < 3 ? n3(e28) : a3 > 3 ? n3(l3, t3, e28) : n3(l3, t3)) || e28);
        return a3 > 3 && e28 && Object.defineProperty(l3, t3, e28), e28;
      }
      function pa2(u3, l3) {
        return function(t3, s3) {
          l3(t3, s3, u3);
        };
      }
      function ca2(u3, l3) {
        if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
          return Reflect.metadata(u3, l3);
      }
      function da2(u3, l3, t3, s3) {
        function a3(e28) {
          return e28 instanceof t3 ? e28 : new t3(function(n3) {
            n3(e28);
          });
        }
        return new (t3 || (t3 = Promise))(function(e28, n3) {
          function r3(h3) {
            try {
              c3(s3.next(h3));
            } catch (m3) {
              n3(m3);
            }
          }
          function o3(h3) {
            try {
              c3(s3.throw(h3));
            } catch (m3) {
              n3(m3);
            }
          }
          function c3(h3) {
            h3.done ? e28(h3.value) : a3(h3.value).then(r3, o3);
          }
          c3((s3 = s3.apply(u3, l3 || [])).next());
        });
      }
      function Da2(u3, l3) {
        var t3 = { label: 0, sent: function() {
          if (e28[0] & 1)
            throw e28[1];
          return e28[1];
        }, trys: [], ops: [] }, s3, a3, e28, n3;
        return n3 = { next: r3(0), throw: r3(1), return: r3(2) }, typeof Symbol == "function" && (n3[Symbol.iterator] = function() {
          return this;
        }), n3;
        function r3(c3) {
          return function(h3) {
            return o3([c3, h3]);
          };
        }
        function o3(c3) {
          if (s3)
            throw new TypeError("Generator is already executing.");
          for (; t3; )
            try {
              if (s3 = 1, a3 && (e28 = c3[0] & 2 ? a3.return : c3[0] ? a3.throw || ((e28 = a3.return) && e28.call(a3), 0) : a3.next) && !(e28 = e28.call(a3, c3[1])).done)
                return e28;
              switch (a3 = 0, e28 && (c3 = [c3[0] & 2, e28.value]), c3[0]) {
                case 0:
                case 1:
                  e28 = c3;
                  break;
                case 4:
                  return t3.label++, { value: c3[1], done: false };
                case 5:
                  t3.label++, a3 = c3[1], c3 = [0];
                  continue;
                case 7:
                  c3 = t3.ops.pop(), t3.trys.pop();
                  continue;
                default:
                  if (e28 = t3.trys, !(e28 = e28.length > 0 && e28[e28.length - 1]) && (c3[0] === 6 || c3[0] === 2)) {
                    t3 = 0;
                    continue;
                  }
                  if (c3[0] === 3 && (!e28 || c3[1] > e28[0] && c3[1] < e28[3])) {
                    t3.label = c3[1];
                    break;
                  }
                  if (c3[0] === 6 && t3.label < e28[1]) {
                    t3.label = e28[1], e28 = c3;
                    break;
                  }
                  if (e28 && t3.label < e28[2]) {
                    t3.label = e28[2], t3.ops.push(c3);
                    break;
                  }
                  e28[2] && t3.ops.pop(), t3.trys.pop();
                  continue;
              }
              c3 = l3.call(u3, t3);
            } catch (h3) {
              c3 = [6, h3], a3 = 0;
            } finally {
              s3 = e28 = 0;
            }
          if (c3[0] & 5)
            throw c3[1];
          return { value: c3[0] ? c3[1] : void 0, done: true };
        }
      }
      function fa2(u3, l3, t3, s3) {
        s3 === void 0 && (s3 = t3), u3[s3] = l3[t3];
      }
      function ma2(u3, l3) {
        for (var t3 in u3)
          t3 !== "default" && !l3.hasOwnProperty(t3) && (l3[t3] = u3[t3]);
      }
      function rr2(u3) {
        var l3 = typeof Symbol == "function" && Symbol.iterator, t3 = l3 && u3[l3], s3 = 0;
        if (t3)
          return t3.call(u3);
        if (u3 && typeof u3.length == "number")
          return { next: function() {
            return u3 && s3 >= u3.length && (u3 = void 0), { value: u3 && u3[s3++], done: !u3 };
          } };
        throw new TypeError(l3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }
      function su2(u3, l3) {
        var t3 = typeof Symbol == "function" && u3[Symbol.iterator];
        if (!t3)
          return u3;
        var s3 = t3.call(u3), a3, e28 = [], n3;
        try {
          for (; (l3 === void 0 || l3-- > 0) && !(a3 = s3.next()).done; )
            e28.push(a3.value);
        } catch (r3) {
          n3 = { error: r3 };
        } finally {
          try {
            a3 && !a3.done && (t3 = s3.return) && t3.call(s3);
          } finally {
            if (n3)
              throw n3.error;
          }
        }
        return e28;
      }
      function ga2() {
        for (var u3 = [], l3 = 0; l3 < arguments.length; l3++)
          u3 = u3.concat(su2(arguments[l3]));
        return u3;
      }
      function ya2() {
        for (var u3 = 0, l3 = 0, t3 = arguments.length; l3 < t3; l3++)
          u3 += arguments[l3].length;
        for (var s3 = Array(u3), a3 = 0, l3 = 0; l3 < t3; l3++)
          for (var e28 = arguments[l3], n3 = 0, r3 = e28.length; n3 < r3; n3++, a3++)
            s3[a3] = e28[n3];
        return s3;
      }
      function ln2(u3) {
        return this instanceof ln2 ? (this.v = u3, this) : new ln2(u3);
      }
      function ha2(u3, l3, t3) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var s3 = t3.apply(u3, l3 || []), a3, e28 = [];
        return a3 = {}, n3("next"), n3("throw"), n3("return"), a3[Symbol.asyncIterator] = function() {
          return this;
        }, a3;
        function n3(y3) {
          s3[y3] && (a3[y3] = function(p3) {
            return new Promise(function(d3, C3) {
              e28.push([y3, p3, d3, C3]) > 1 || r3(y3, p3);
            });
          });
        }
        function r3(y3, p3) {
          try {
            o3(s3[y3](p3));
          } catch (d3) {
            m3(e28[0][3], d3);
          }
        }
        function o3(y3) {
          y3.value instanceof ln2 ? Promise.resolve(y3.value.v).then(c3, h3) : m3(e28[0][2], y3);
        }
        function c3(y3) {
          r3("next", y3);
        }
        function h3(y3) {
          r3("throw", y3);
        }
        function m3(y3, p3) {
          y3(p3), e28.shift(), e28.length && r3(e28[0][0], e28[0][1]);
        }
      }
      function Ea2(u3) {
        var l3, t3;
        return l3 = {}, s3("next"), s3("throw", function(a3) {
          throw a3;
        }), s3("return"), l3[Symbol.iterator] = function() {
          return this;
        }, l3;
        function s3(a3, e28) {
          l3[a3] = u3[a3] ? function(n3) {
            return (t3 = !t3) ? { value: ln2(u3[a3](n3)), done: a3 === "return" } : e28 ? e28(n3) : n3;
          } : e28;
        }
      }
      function Ca2(u3) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var l3 = u3[Symbol.asyncIterator], t3;
        return l3 ? l3.call(u3) : (u3 = typeof rr2 == "function" ? rr2(u3) : u3[Symbol.iterator](), t3 = {}, s3("next"), s3("throw"), s3("return"), t3[Symbol.asyncIterator] = function() {
          return this;
        }, t3);
        function s3(e28) {
          t3[e28] = u3[e28] && function(n3) {
            return new Promise(function(r3, o3) {
              n3 = u3[e28](n3), a3(r3, o3, n3.done, n3.value);
            });
          };
        }
        function a3(e28, n3, r3, o3) {
          Promise.resolve(o3).then(function(c3) {
            e28({ value: c3, done: r3 });
          }, n3);
        }
      }
      function Fa2(u3, l3) {
        return Object.defineProperty ? Object.defineProperty(u3, "raw", { value: l3 }) : u3.raw = l3, u3;
      }
      function Aa2(u3) {
        if (u3 && u3.__esModule)
          return u3;
        var l3 = {};
        if (u3 != null)
          for (var t3 in u3)
            Object.hasOwnProperty.call(u3, t3) && (l3[t3] = u3[t3]);
        return l3.default = u3, l3;
      }
      function va2(u3) {
        return u3 && u3.__esModule ? u3 : { default: u3 };
      }
      function xa2(u3, l3) {
        if (!l3.has(u3))
          throw new TypeError("attempted to get private field on non-instance");
        return l3.get(u3);
      }
      function ba2(u3, l3, t3) {
        if (!l3.has(u3))
          throw new TypeError("attempted to set private field on non-instance");
        return l3.set(u3, t3), t3;
      }
      var Bn2, wn2, Rt2 = Je2({ "node_modules/tslib/tslib.es6.js"() {
        H3(), Bn2 = function(u3, l3) {
          return Bn2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t3, s3) {
            t3.__proto__ = s3;
          } || function(t3, s3) {
            for (var a3 in s3)
              s3.hasOwnProperty(a3) && (t3[a3] = s3[a3]);
          }, Bn2(u3, l3);
        }, wn2 = function() {
          return wn2 = Object.assign || function(u3) {
            for (var l3, t3 = 1, s3 = arguments.length; t3 < s3; t3++) {
              l3 = arguments[t3];
              for (var a3 in l3)
                Object.prototype.hasOwnProperty.call(l3, a3) && (u3[a3] = l3[a3]);
            }
            return u3;
          }, wn2.apply(this, arguments);
        };
      } }), ou2 = X3({ "node_modules/vnopts/lib/descriptors/api.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true }), u3.apiDescriptor = { key: (l3) => /^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(l3) ? l3 : JSON.stringify(l3), value(l3) {
          if (l3 === null || typeof l3 != "object")
            return JSON.stringify(l3);
          if (Array.isArray(l3))
            return `[${l3.map((s3) => u3.apiDescriptor.value(s3)).join(", ")}]`;
          let t3 = Object.keys(l3);
          return t3.length === 0 ? "{}" : `{ ${t3.map((s3) => `${u3.apiDescriptor.key(s3)}: ${u3.apiDescriptor.value(l3[s3])}`).join(", ")} }`;
        }, pair: (l3) => {
          let { key: t3, value: s3 } = l3;
          return u3.apiDescriptor.value({ [t3]: s3 });
        } };
      } }), Sa2 = X3({ "node_modules/vnopts/lib/descriptors/index.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = (Rt2(), lt2(Ot2));
        l3.__exportStar(ou2(), u3);
      } }), Nn2 = X3({ "scripts/build/shims/chalk.cjs"(u3, l3) {
        H3();
        var t3 = (s3) => s3;
        t3.grey = t3, t3.red = t3, t3.bold = t3, t3.yellow = t3, t3.blue = t3, t3.default = t3, l3.exports = t3;
      } }), lu2 = X3({ "node_modules/vnopts/lib/handlers/deprecated/common.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = Nn2();
        u3.commonDeprecatedHandler = (t3, s3, a3) => {
          let { descriptor: e28 } = a3, n3 = [`${l3.default.yellow(typeof t3 == "string" ? e28.key(t3) : e28.pair(t3))} is deprecated`];
          return s3 && n3.push(`we now treat it as ${l3.default.blue(typeof s3 == "string" ? e28.key(s3) : e28.pair(s3))}`), n3.join("; ") + ".";
        };
      } }), Ta2 = X3({ "node_modules/vnopts/lib/handlers/deprecated/index.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = (Rt2(), lt2(Ot2));
        l3.__exportStar(lu2(), u3);
      } }), Ba2 = X3({ "node_modules/vnopts/lib/handlers/invalid/common.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = Nn2();
        u3.commonInvalidHandler = (t3, s3, a3) => [`Invalid ${l3.default.red(a3.descriptor.key(t3))} value.`, `Expected ${l3.default.blue(a3.schemas[t3].expected(a3))},`, `but received ${l3.default.red(a3.descriptor.value(s3))}.`].join(" ");
      } }), pu2 = X3({ "node_modules/vnopts/lib/handlers/invalid/index.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = (Rt2(), lt2(Ot2));
        l3.__exportStar(Ba2(), u3);
      } }), wa2 = X3({ "node_modules/vnopts/node_modules/leven/index.js"(u3, l3) {
        H3();
        var t3 = [], s3 = [];
        l3.exports = function(a3, e28) {
          if (a3 === e28)
            return 0;
          var n3 = a3;
          a3.length > e28.length && (a3 = e28, e28 = n3);
          var r3 = a3.length, o3 = e28.length;
          if (r3 === 0)
            return o3;
          if (o3 === 0)
            return r3;
          for (; r3 > 0 && a3.charCodeAt(~-r3) === e28.charCodeAt(~-o3); )
            r3--, o3--;
          if (r3 === 0)
            return o3;
          for (var c3 = 0; c3 < r3 && a3.charCodeAt(c3) === e28.charCodeAt(c3); )
            c3++;
          if (r3 -= c3, o3 -= c3, r3 === 0)
            return o3;
          for (var h3, m3, y3, p3, d3 = 0, C3 = 0; d3 < r3; )
            s3[c3 + d3] = a3.charCodeAt(c3 + d3), t3[d3] = ++d3;
          for (; C3 < o3; )
            for (h3 = e28.charCodeAt(c3 + C3), y3 = C3++, m3 = C3, d3 = 0; d3 < r3; d3++)
              p3 = h3 === s3[c3 + d3] ? y3 : y3 + 1, y3 = t3[d3], m3 = t3[d3] = y3 > m3 ? p3 > m3 ? m3 + 1 : p3 : p3 > y3 ? y3 + 1 : p3;
          return m3;
        };
      } }), cu2 = X3({ "node_modules/vnopts/lib/handlers/unknown/leven.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = Nn2(), t3 = wa2();
        u3.levenUnknownHandler = (s3, a3, e28) => {
          let { descriptor: n3, logger: r3, schemas: o3 } = e28, c3 = [`Ignored unknown option ${l3.default.yellow(n3.pair({ key: s3, value: a3 }))}.`], h3 = Object.keys(o3).sort().find((m3) => t3(s3, m3) < 3);
          h3 && c3.push(`Did you mean ${l3.default.blue(n3.key(h3))}?`), r3.warn(c3.join(" "));
        };
      } }), Na2 = X3({ "node_modules/vnopts/lib/handlers/unknown/index.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = (Rt2(), lt2(Ot2));
        l3.__exportStar(cu2(), u3);
      } }), ka2 = X3({ "node_modules/vnopts/lib/handlers/index.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = (Rt2(), lt2(Ot2));
        l3.__exportStar(Ta2(), u3), l3.__exportStar(pu2(), u3), l3.__exportStar(Na2(), u3);
      } }), Vt2 = X3({ "node_modules/vnopts/lib/schema.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = ["default", "expected", "validate", "deprecated", "forward", "redirect", "overlap", "preprocess", "postprocess"];
        function t3(e28, n3) {
          let r3 = new e28(n3), o3 = Object.create(r3);
          for (let c3 of l3)
            c3 in n3 && (o3[c3] = a3(n3[c3], r3, s3.prototype[c3].length));
          return o3;
        }
        u3.createSchema = t3;
        var s3 = class {
          constructor(e28) {
            this.name = e28.name;
          }
          static create(e28) {
            return t3(this, e28);
          }
          default(e28) {
          }
          expected(e28) {
            return "nothing";
          }
          validate(e28, n3) {
            return false;
          }
          deprecated(e28, n3) {
            return false;
          }
          forward(e28, n3) {
          }
          redirect(e28, n3) {
          }
          overlap(e28, n3, r3) {
            return e28;
          }
          preprocess(e28, n3) {
            return e28;
          }
          postprocess(e28, n3) {
            return e28;
          }
        };
        u3.Schema = s3;
        function a3(e28, n3, r3) {
          return typeof e28 == "function" ? function() {
            for (var o3 = arguments.length, c3 = new Array(o3), h3 = 0; h3 < o3; h3++)
              c3[h3] = arguments[h3];
            return e28(...c3.slice(0, r3 - 1), n3, ...c3.slice(r3 - 1));
          } : () => e28;
        }
      } }), Pa2 = X3({ "node_modules/vnopts/lib/schemas/alias.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = Vt2(), t3 = class extends l3.Schema {
          constructor(s3) {
            super(s3), this._sourceName = s3.sourceName;
          }
          expected(s3) {
            return s3.schemas[this._sourceName].expected(s3);
          }
          validate(s3, a3) {
            return a3.schemas[this._sourceName].validate(s3, a3);
          }
          redirect(s3, a3) {
            return this._sourceName;
          }
        };
        u3.AliasSchema = t3;
      } }), ja2 = X3({ "node_modules/vnopts/lib/schemas/any.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = Vt2(), t3 = class extends l3.Schema {
          expected() {
            return "anything";
          }
          validate() {
            return true;
          }
        };
        u3.AnySchema = t3;
      } }), Ia2 = X3({ "node_modules/vnopts/lib/schemas/array.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = (Rt2(), lt2(Ot2)), t3 = Vt2(), s3 = class extends t3.Schema {
          constructor(e28) {
            var { valueSchema: n3, name: r3 = n3.name } = e28, o3 = l3.__rest(e28, ["valueSchema", "name"]);
            super(Object.assign({}, o3, { name: r3 })), this._valueSchema = n3;
          }
          expected(e28) {
            return `an array of ${this._valueSchema.expected(e28)}`;
          }
          validate(e28, n3) {
            if (!Array.isArray(e28))
              return false;
            let r3 = [];
            for (let o3 of e28) {
              let c3 = n3.normalizeValidateResult(this._valueSchema.validate(o3, n3), o3);
              c3 !== true && r3.push(c3.value);
            }
            return r3.length === 0 ? true : { value: r3 };
          }
          deprecated(e28, n3) {
            let r3 = [];
            for (let o3 of e28) {
              let c3 = n3.normalizeDeprecatedResult(this._valueSchema.deprecated(o3, n3), o3);
              c3 !== false && r3.push(...c3.map((h3) => {
                let { value: m3 } = h3;
                return { value: [m3] };
              }));
            }
            return r3;
          }
          forward(e28, n3) {
            let r3 = [];
            for (let o3 of e28) {
              let c3 = n3.normalizeForwardResult(this._valueSchema.forward(o3, n3), o3);
              r3.push(...c3.map(a3));
            }
            return r3;
          }
          redirect(e28, n3) {
            let r3 = [], o3 = [];
            for (let c3 of e28) {
              let h3 = n3.normalizeRedirectResult(this._valueSchema.redirect(c3, n3), c3);
              "remain" in h3 && r3.push(h3.remain), o3.push(...h3.redirect.map(a3));
            }
            return r3.length === 0 ? { redirect: o3 } : { redirect: o3, remain: r3 };
          }
          overlap(e28, n3) {
            return e28.concat(n3);
          }
        };
        u3.ArraySchema = s3;
        function a3(e28) {
          let { from: n3, to: r3 } = e28;
          return { from: [n3], to: r3 };
        }
      } }), La2 = X3({ "node_modules/vnopts/lib/schemas/boolean.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = Vt2(), t3 = class extends l3.Schema {
          expected() {
            return "true or false";
          }
          validate(s3) {
            return typeof s3 == "boolean";
          }
        };
        u3.BooleanSchema = t3;
      } }), ur2 = X3({ "node_modules/vnopts/lib/utils.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        function l3(p3, d3) {
          let C3 = /* @__PURE__ */ Object.create(null);
          for (let w3 of p3) {
            let P3 = w3[d3];
            if (C3[P3])
              throw new Error(`Duplicate ${d3} ${JSON.stringify(P3)}`);
            C3[P3] = w3;
          }
          return C3;
        }
        u3.recordFromArray = l3;
        function t3(p3, d3) {
          let C3 = /* @__PURE__ */ new Map();
          for (let w3 of p3) {
            let P3 = w3[d3];
            if (C3.has(P3))
              throw new Error(`Duplicate ${d3} ${JSON.stringify(P3)}`);
            C3.set(P3, w3);
          }
          return C3;
        }
        u3.mapFromArray = t3;
        function s3() {
          let p3 = /* @__PURE__ */ Object.create(null);
          return (d3) => {
            let C3 = JSON.stringify(d3);
            return p3[C3] ? true : (p3[C3] = true, false);
          };
        }
        u3.createAutoChecklist = s3;
        function a3(p3, d3) {
          let C3 = [], w3 = [];
          for (let P3 of p3)
            d3(P3) ? C3.push(P3) : w3.push(P3);
          return [C3, w3];
        }
        u3.partition = a3;
        function e28(p3) {
          return p3 === Math.floor(p3);
        }
        u3.isInt = e28;
        function n3(p3, d3) {
          if (p3 === d3)
            return 0;
          let C3 = typeof p3, w3 = typeof d3, P3 = ["undefined", "object", "boolean", "number", "string"];
          return C3 !== w3 ? P3.indexOf(C3) - P3.indexOf(w3) : C3 !== "string" ? Number(p3) - Number(d3) : p3.localeCompare(d3);
        }
        u3.comparePrimitive = n3;
        function r3(p3) {
          return p3 === void 0 ? {} : p3;
        }
        u3.normalizeDefaultResult = r3;
        function o3(p3, d3) {
          return p3 === true ? true : p3 === false ? { value: d3 } : p3;
        }
        u3.normalizeValidateResult = o3;
        function c3(p3, d3) {
          let C3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
          return p3 === false ? false : p3 === true ? C3 ? true : [{ value: d3 }] : "value" in p3 ? [p3] : p3.length === 0 ? false : p3;
        }
        u3.normalizeDeprecatedResult = c3;
        function h3(p3, d3) {
          return typeof p3 == "string" || "key" in p3 ? { from: d3, to: p3 } : "from" in p3 ? { from: p3.from, to: p3.to } : { from: d3, to: p3.to };
        }
        u3.normalizeTransferResult = h3;
        function m3(p3, d3) {
          return p3 === void 0 ? [] : Array.isArray(p3) ? p3.map((C3) => h3(C3, d3)) : [h3(p3, d3)];
        }
        u3.normalizeForwardResult = m3;
        function y3(p3, d3) {
          let C3 = m3(typeof p3 == "object" && "redirect" in p3 ? p3.redirect : p3, d3);
          return C3.length === 0 ? { remain: d3, redirect: C3 } : typeof p3 == "object" && "remain" in p3 ? { remain: p3.remain, redirect: C3 } : { redirect: C3 };
        }
        u3.normalizeRedirectResult = y3;
      } }), _a2 = X3({ "node_modules/vnopts/lib/schemas/choice.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = Vt2(), t3 = ur2(), s3 = class extends l3.Schema {
          constructor(a3) {
            super(a3), this._choices = t3.mapFromArray(a3.choices.map((e28) => e28 && typeof e28 == "object" ? e28 : { value: e28 }), "value");
          }
          expected(a3) {
            let { descriptor: e28 } = a3, n3 = Array.from(this._choices.keys()).map((c3) => this._choices.get(c3)).filter((c3) => !c3.deprecated).map((c3) => c3.value).sort(t3.comparePrimitive).map(e28.value), r3 = n3.slice(0, -2), o3 = n3.slice(-2);
            return r3.concat(o3.join(" or ")).join(", ");
          }
          validate(a3) {
            return this._choices.has(a3);
          }
          deprecated(a3) {
            let e28 = this._choices.get(a3);
            return e28 && e28.deprecated ? { value: a3 } : false;
          }
          forward(a3) {
            let e28 = this._choices.get(a3);
            return e28 ? e28.forward : void 0;
          }
          redirect(a3) {
            let e28 = this._choices.get(a3);
            return e28 ? e28.redirect : void 0;
          }
        };
        u3.ChoiceSchema = s3;
      } }), du2 = X3({ "node_modules/vnopts/lib/schemas/number.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = Vt2(), t3 = class extends l3.Schema {
          expected() {
            return "a number";
          }
          validate(s3, a3) {
            return typeof s3 == "number";
          }
        };
        u3.NumberSchema = t3;
      } }), Oa2 = X3({ "node_modules/vnopts/lib/schemas/integer.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = ur2(), t3 = du2(), s3 = class extends t3.NumberSchema {
          expected() {
            return "an integer";
          }
          validate(a3, e28) {
            return e28.normalizeValidateResult(super.validate(a3, e28), a3) === true && l3.isInt(a3);
          }
        };
        u3.IntegerSchema = s3;
      } }), Ma2 = X3({ "node_modules/vnopts/lib/schemas/string.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = Vt2(), t3 = class extends l3.Schema {
          expected() {
            return "a string";
          }
          validate(s3) {
            return typeof s3 == "string";
          }
        };
        u3.StringSchema = t3;
      } }), $a2 = X3({ "node_modules/vnopts/lib/schemas/index.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = (Rt2(), lt2(Ot2));
        l3.__exportStar(Pa2(), u3), l3.__exportStar(ja2(), u3), l3.__exportStar(Ia2(), u3), l3.__exportStar(La2(), u3), l3.__exportStar(_a2(), u3), l3.__exportStar(Oa2(), u3), l3.__exportStar(du2(), u3), l3.__exportStar(Ma2(), u3);
      } }), Ra2 = X3({ "node_modules/vnopts/lib/defaults.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = ou2(), t3 = lu2(), s3 = pu2(), a3 = cu2();
        u3.defaultDescriptor = l3.apiDescriptor, u3.defaultUnknownHandler = a3.levenUnknownHandler, u3.defaultInvalidHandler = s3.commonInvalidHandler, u3.defaultDeprecatedHandler = t3.commonDeprecatedHandler;
      } }), Va2 = X3({ "node_modules/vnopts/lib/normalize.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = Ra2(), t3 = ur2();
        u3.normalize = (a3, e28, n3) => new s3(e28, n3).normalize(a3);
        var s3 = class {
          constructor(a3, e28) {
            let { logger: n3 = console, descriptor: r3 = l3.defaultDescriptor, unknown: o3 = l3.defaultUnknownHandler, invalid: c3 = l3.defaultInvalidHandler, deprecated: h3 = l3.defaultDeprecatedHandler } = e28 || {};
            this._utils = { descriptor: r3, logger: n3 || { warn: () => {
            } }, schemas: t3.recordFromArray(a3, "name"), normalizeDefaultResult: t3.normalizeDefaultResult, normalizeDeprecatedResult: t3.normalizeDeprecatedResult, normalizeForwardResult: t3.normalizeForwardResult, normalizeRedirectResult: t3.normalizeRedirectResult, normalizeValidateResult: t3.normalizeValidateResult }, this._unknownHandler = o3, this._invalidHandler = c3, this._deprecatedHandler = h3, this.cleanHistory();
          }
          cleanHistory() {
            this._hasDeprecationWarned = t3.createAutoChecklist();
          }
          normalize(a3) {
            let e28 = {}, n3 = [a3], r3 = () => {
              for (; n3.length !== 0; ) {
                let o3 = n3.shift(), c3 = this._applyNormalization(o3, e28);
                n3.push(...c3);
              }
            };
            r3();
            for (let o3 of Object.keys(this._utils.schemas)) {
              let c3 = this._utils.schemas[o3];
              if (!(o3 in e28)) {
                let h3 = t3.normalizeDefaultResult(c3.default(this._utils));
                "value" in h3 && n3.push({ [o3]: h3.value });
              }
            }
            r3();
            for (let o3 of Object.keys(this._utils.schemas)) {
              let c3 = this._utils.schemas[o3];
              o3 in e28 && (e28[o3] = c3.postprocess(e28[o3], this._utils));
            }
            return e28;
          }
          _applyNormalization(a3, e28) {
            let n3 = [], [r3, o3] = t3.partition(Object.keys(a3), (c3) => c3 in this._utils.schemas);
            for (let c3 of r3) {
              let h3 = this._utils.schemas[c3], m3 = h3.preprocess(a3[c3], this._utils), y3 = t3.normalizeValidateResult(h3.validate(m3, this._utils), m3);
              if (y3 !== true) {
                let { value: w3 } = y3, P3 = this._invalidHandler(c3, w3, this._utils);
                throw typeof P3 == "string" ? new Error(P3) : P3;
              }
              let p3 = (w3) => {
                let { from: P3, to: A3 } = w3;
                n3.push(typeof A3 == "string" ? { [A3]: P3 } : { [A3.key]: A3.value });
              }, d3 = (w3) => {
                let { value: P3, redirectTo: A3 } = w3, N3 = t3.normalizeDeprecatedResult(h3.deprecated(P3, this._utils), m3, true);
                if (N3 !== false)
                  if (N3 === true)
                    this._hasDeprecationWarned(c3) || this._utils.logger.warn(this._deprecatedHandler(c3, A3, this._utils));
                  else
                    for (let { value: S3 } of N3) {
                      let j3 = { key: c3, value: S3 };
                      if (!this._hasDeprecationWarned(j3)) {
                        let k3 = typeof A3 == "string" ? { key: A3, value: S3 } : A3;
                        this._utils.logger.warn(this._deprecatedHandler(j3, k3, this._utils));
                      }
                    }
              };
              t3.normalizeForwardResult(h3.forward(m3, this._utils), m3).forEach(p3);
              let C3 = t3.normalizeRedirectResult(h3.redirect(m3, this._utils), m3);
              if (C3.redirect.forEach(p3), "remain" in C3) {
                let w3 = C3.remain;
                e28[c3] = c3 in e28 ? h3.overlap(e28[c3], w3, this._utils) : w3, d3({ value: w3 });
              }
              for (let { from: w3, to: P3 } of C3.redirect)
                d3({ value: w3, redirectTo: P3 });
            }
            for (let c3 of o3) {
              let h3 = a3[c3], m3 = this._unknownHandler(c3, h3, this._utils);
              if (m3)
                for (let y3 of Object.keys(m3)) {
                  let p3 = { [y3]: m3[y3] };
                  y3 in this._utils.schemas ? n3.push(p3) : Object.assign(e28, p3);
                }
            }
            return n3;
          }
        };
        u3.Normalizer = s3;
      } }), Ja2 = X3({ "node_modules/vnopts/lib/index.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = (Rt2(), lt2(Ot2));
        l3.__exportStar(Sa2(), u3), l3.__exportStar(ka2(), u3), l3.__exportStar($a2(), u3), l3.__exportStar(Va2(), u3), l3.__exportStar(Vt2(), u3);
      } }), qa2 = X3({ "src/main/options-normalizer.js"(u3, l3) {
        H3();
        var t3 = Ja2(), s3 = Ct2(), a3 = { key: (y3) => y3.length === 1 ? `-${y3}` : `--${y3}`, value: (y3) => t3.apiDescriptor.value(y3), pair: (y3) => {
          let { key: p3, value: d3 } = y3;
          return d3 === false ? `--no-${p3}` : d3 === true ? a3.key(p3) : d3 === "" ? `${a3.key(p3)} without an argument` : `${a3.key(p3)}=${d3}`;
        } }, e28 = (y3) => {
          let { colorsModule: p3, levenshteinDistance: d3 } = y3;
          return class extends t3.ChoiceSchema {
            constructor(C3) {
              let { name: w3, flags: P3 } = C3;
              super({ name: w3, choices: P3 }), this._flags = [...P3].sort();
            }
            preprocess(C3, w3) {
              if (typeof C3 == "string" && C3.length > 0 && !this._flags.includes(C3)) {
                let P3 = this._flags.find((A3) => d3(A3, C3) < 3);
                if (P3)
                  return w3.logger.warn([`Unknown flag ${p3.yellow(w3.descriptor.value(C3))},`, `did you mean ${p3.blue(w3.descriptor.value(P3))}?`].join(" ")), P3;
              }
              return C3;
            }
            expected() {
              return "a flag";
            }
          };
        }, n3;
        function r3(y3, p3) {
          let { logger: d3 = false, isCLI: C3 = false, passThrough: w3 = false, colorsModule: P3 = null, levenshteinDistance: A3 = null } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, N3 = w3 ? Array.isArray(w3) ? (T3, D3) => w3.includes(T3) ? { [T3]: D3 } : void 0 : (T3, D3) => ({ [T3]: D3 }) : (T3, D3, F3) => {
            let i = F3.schemas, g3 = Ce2(i, ce2);
            return t3.levenUnknownHandler(T3, D3, Object.assign(Object.assign({}, F3), {}, { schemas: g3 }));
          }, S3 = C3 ? a3 : t3.apiDescriptor, j3 = o3(p3, { isCLI: C3, colorsModule: P3, levenshteinDistance: A3 }), k3 = new t3.Normalizer(j3, { logger: d3, unknown: N3, descriptor: S3 }), J3 = d3 !== false;
          J3 && n3 && (k3._hasDeprecationWarned = n3);
          let f3 = k3.normalize(y3);
          return J3 && (n3 = k3._hasDeprecationWarned), C3 && f3["plugin-search"] === false && (f3["plugin-search-dir"] = false), f3;
        }
        function o3(y3, p3) {
          let { isCLI: d3, colorsModule: C3, levenshteinDistance: w3 } = p3, P3 = [];
          d3 && P3.push(t3.AnySchema.create({ name: "_" }));
          for (let A3 of y3)
            P3.push(c3(A3, { isCLI: d3, optionInfos: y3, colorsModule: C3, levenshteinDistance: w3 })), A3.alias && d3 && P3.push(t3.AliasSchema.create({ name: A3.alias, sourceName: A3.name }));
          return P3;
        }
        function c3(y3, p3) {
          let { isCLI: d3, optionInfos: C3, colorsModule: w3, levenshteinDistance: P3 } = p3, { name: A3 } = y3;
          if (A3 === "plugin-search-dir" || A3 === "pluginSearchDirs")
            return t3.AnySchema.create({ name: A3, preprocess(k3) {
              return k3 === false || (k3 = Array.isArray(k3) ? k3 : [k3]), k3;
            }, validate(k3) {
              return k3 === false ? true : k3.every((J3) => typeof J3 == "string");
            }, expected() {
              return "false or paths to plugin search dir";
            } });
          let N3 = { name: A3 }, S3, j3 = {};
          switch (y3.type) {
            case "int":
              S3 = t3.IntegerSchema, d3 && (N3.preprocess = Number);
              break;
            case "string":
              S3 = t3.StringSchema;
              break;
            case "choice":
              S3 = t3.ChoiceSchema, N3.choices = y3.choices.map((k3) => typeof k3 == "object" && k3.redirect ? Object.assign(Object.assign({}, k3), {}, { redirect: { to: { key: y3.name, value: k3.redirect } } }) : k3);
              break;
            case "boolean":
              S3 = t3.BooleanSchema;
              break;
            case "flag":
              S3 = e28({ colorsModule: w3, levenshteinDistance: P3 }), N3.flags = C3.flatMap((k3) => [k3.alias, k3.description && k3.name, k3.oppositeDescription && `no-${k3.name}`].filter(Boolean));
              break;
            case "path":
              S3 = t3.StringSchema;
              break;
            default:
              throw new Error(`Unexpected type ${y3.type}`);
          }
          if (y3.exception ? N3.validate = (k3, J3, f3) => y3.exception(k3) || J3.validate(k3, f3) : N3.validate = (k3, J3, f3) => k3 === void 0 || J3.validate(k3, f3), y3.redirect && (j3.redirect = (k3) => k3 ? { to: { key: y3.redirect.option, value: y3.redirect.value } } : void 0), y3.deprecated && (j3.deprecated = true), d3 && !y3.array) {
            let k3 = N3.preprocess || ((J3) => J3);
            N3.preprocess = (J3, f3, T3) => f3.preprocess(k3(Array.isArray(J3) ? s3(J3) : J3), T3);
          }
          return y3.array ? t3.ArraySchema.create(Object.assign(Object.assign(Object.assign({}, d3 ? { preprocess: (k3) => Array.isArray(k3) ? k3 : [k3] } : {}), j3), {}, { valueSchema: S3.create(N3) })) : S3.create(Object.assign(Object.assign({}, N3), j3));
        }
        function h3(y3, p3, d3) {
          return r3(y3, p3, d3);
        }
        function m3(y3, p3, d3) {
          return r3(y3, p3, Object.assign({ isCLI: true }, d3));
        }
        l3.exports = { normalizeApiOptions: h3, normalizeCliOptions: m3 };
      } }), vt2 = X3({ "src/language-js/loc.js"(u3, l3) {
        H3();
        var t3 = Qn2();
        function s3(o3) {
          var c3, h3;
          let m3 = o3.range ? o3.range[0] : o3.start, y3 = (c3 = (h3 = o3.declaration) === null || h3 === void 0 ? void 0 : h3.decorators) !== null && c3 !== void 0 ? c3 : o3.decorators;
          return t3(y3) ? Math.min(s3(y3[0]), m3) : m3;
        }
        function a3(o3) {
          return o3.range ? o3.range[1] : o3.end;
        }
        function e28(o3, c3) {
          let h3 = s3(o3);
          return Number.isInteger(h3) && h3 === s3(c3);
        }
        function n3(o3, c3) {
          let h3 = a3(o3);
          return Number.isInteger(h3) && h3 === a3(c3);
        }
        function r3(o3, c3) {
          return e28(o3, c3) && n3(o3, c3);
        }
        l3.exports = { locStart: s3, locEnd: a3, hasSameLocStart: e28, hasSameLoc: r3 };
      } }), Ga2 = X3({ "src/main/load-parser.js"(u3, l3) {
        H3(), l3.exports = () => {
        };
      } }), Wa2 = X3({ "scripts/build/shims/babel-highlight.cjs"(u3, l3) {
        H3();
        var t3 = Nn2(), s3 = { shouldHighlight: () => false, getChalk: () => t3 };
        l3.exports = s3;
      } }), Xa2 = X3({ "node_modules/@babel/code-frame/lib/index.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true }), u3.codeFrameColumns = n3, u3.default = r3;
        var l3 = Wa2(), t3 = false;
        function s3(o3) {
          return { gutter: o3.grey, marker: o3.red.bold, message: o3.red.bold };
        }
        var a3 = /\r\n|[\n\r\u2028\u2029]/;
        function e28(o3, c3, h3) {
          let m3 = Object.assign({ column: 0, line: -1 }, o3.start), y3 = Object.assign({}, m3, o3.end), { linesAbove: p3 = 2, linesBelow: d3 = 3 } = h3 || {}, C3 = m3.line, w3 = m3.column, P3 = y3.line, A3 = y3.column, N3 = Math.max(C3 - (p3 + 1), 0), S3 = Math.min(c3.length, P3 + d3);
          C3 === -1 && (N3 = 0), P3 === -1 && (S3 = c3.length);
          let j3 = P3 - C3, k3 = {};
          if (j3)
            for (let J3 = 0; J3 <= j3; J3++) {
              let f3 = J3 + C3;
              if (!w3)
                k3[f3] = true;
              else if (J3 === 0) {
                let T3 = c3[f3 - 1].length;
                k3[f3] = [w3, T3 - w3 + 1];
              } else if (J3 === j3)
                k3[f3] = [0, A3];
              else {
                let T3 = c3[f3 - J3].length;
                k3[f3] = [0, T3];
              }
            }
          else
            w3 === A3 ? w3 ? k3[C3] = [w3, 0] : k3[C3] = true : k3[C3] = [w3, A3 - w3];
          return { start: N3, end: S3, markerLines: k3 };
        }
        function n3(o3, c3) {
          let h3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, m3 = (h3.highlightCode || h3.forceColor) && (0, l3.shouldHighlight)(h3), y3 = (0, l3.getChalk)(h3), p3 = s3(y3), d3 = (k3, J3) => m3 ? k3(J3) : J3, C3 = o3.split(a3), { start: w3, end: P3, markerLines: A3 } = e28(c3, C3, h3), N3 = c3.start && typeof c3.start.column == "number", S3 = String(P3).length, j3 = (m3 ? (0, l3.default)(o3, h3) : o3).split(a3, P3).slice(w3, P3).map((k3, J3) => {
            let f3 = w3 + 1 + J3, T3 = ` ${` ${f3}`.slice(-S3)} |`, D3 = A3[f3], F3 = !A3[f3 + 1];
            if (D3) {
              let i = "";
              if (Array.isArray(D3)) {
                let g3 = k3.slice(0, Math.max(D3[0] - 1, 0)).replace(/[^\t]/g, " "), E3 = D3[1] || 1;
                i = [`
 `, d3(p3.gutter, T3.replace(/\d/g, " ")), " ", g3, d3(p3.marker, "^").repeat(E3)].join(""), F3 && h3.message && (i += " " + d3(p3.message, h3.message));
              }
              return [d3(p3.marker, ">"), d3(p3.gutter, T3), k3.length > 0 ? ` ${k3}` : "", i].join("");
            } else
              return ` ${d3(p3.gutter, T3)}${k3.length > 0 ? ` ${k3}` : ""}`;
          }).join(`
`);
          return h3.message && !N3 && (j3 = `${" ".repeat(S3 + 1)}${h3.message}
${j3}`), m3 ? y3.reset(j3) : j3;
        }
        function r3(o3, c3, h3) {
          let m3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
          if (!t3) {
            t3 = true;
            let y3 = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
            if (yt2.emitWarning)
              yt2.emitWarning(y3, "DeprecationWarning");
            else {
              let p3 = new Error(y3);
              p3.name = "DeprecationWarning", console.warn(new Error(y3));
            }
          }
          return h3 = Math.max(h3, 0), n3(o3, { start: { column: h3, line: c3 } }, m3);
        }
      } }), ir2 = X3({ "src/main/parser.js"(u3, l3) {
        H3();
        var { ConfigError: t3 } = on2(), s3 = vt2();
        Ga2();
        var { locStart: a3, locEnd: e28 } = s3, n3 = Object.getOwnPropertyNames, r3 = Object.getOwnPropertyDescriptor;
        function o3(m3) {
          let y3 = {};
          for (let p3 of m3.plugins)
            if (p3.parsers)
              for (let d3 of n3(p3.parsers))
                Object.defineProperty(y3, d3, r3(p3.parsers, d3));
          return y3;
        }
        function c3(m3) {
          let y3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : o3(m3);
          if (typeof m3.parser == "function")
            return { parse: m3.parser, astFormat: "estree", locStart: a3, locEnd: e28 };
          if (typeof m3.parser == "string") {
            if (Object.prototype.hasOwnProperty.call(y3, m3.parser))
              return y3[m3.parser];
            throw new t3(`Couldn't resolve parser "${m3.parser}". Parsers must be explicitly added to the standalone bundle.`);
          }
        }
        function h3(m3, y3) {
          let p3 = o3(y3), d3 = Object.defineProperties({}, Object.fromEntries(Object.keys(p3).map((w3) => [w3, { enumerable: true, get() {
            return p3[w3].parse;
          } }]))), C3 = c3(y3, p3);
          try {
            return C3.preprocess && (m3 = C3.preprocess(m3, y3)), { text: m3, ast: C3.parse(m3, d3, y3) };
          } catch (w3) {
            let { loc: P3 } = w3;
            if (P3) {
              let { codeFrameColumns: A3 } = Xa2();
              throw w3.codeFrame = A3(m3, P3, { highlightCode: true }), w3.message += `
` + w3.codeFrame, w3;
            }
            throw w3;
          }
        }
        l3.exports = { parse: h3, resolveParser: c3 };
      } }), Du2 = X3({ "src/main/options.js"(u3, l3) {
        H3();
        var t3 = aa2(), { UndefinedParserError: s3 } = on2(), { getSupportInfo: a3 } = Kn2(), e28 = qa2(), { resolveParser: n3 } = ir2(), r3 = { astFormat: "estree", printer: {}, originalText: void 0, locStart: null, locEnd: null };
        function o3(m3) {
          let y3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, p3 = Object.assign({}, m3), d3 = a3({ plugins: m3.plugins, showUnreleased: true, showDeprecated: true }).options, C3 = Object.assign(Object.assign({}, r3), Object.fromEntries(d3.filter((S3) => S3.default !== void 0).map((S3) => [S3.name, S3.default])));
          if (!p3.parser) {
            if (!p3.filepath)
              (y3.logger || console).warn("No parser and no filepath given, using 'babel' the parser now but this will throw an error in the future. Please specify a parser or a filepath so one can be inferred."), p3.parser = "babel";
            else if (p3.parser = h3(p3.filepath, p3.plugins), !p3.parser)
              throw new s3(`No parser could be inferred for file: ${p3.filepath}`);
          }
          let w3 = n3(e28.normalizeApiOptions(p3, [d3.find((S3) => S3.name === "parser")], { passThrough: true, logger: false }));
          p3.astFormat = w3.astFormat, p3.locEnd = w3.locEnd, p3.locStart = w3.locStart;
          let P3 = c3(p3);
          p3.printer = P3.printers[p3.astFormat];
          let A3 = Object.fromEntries(d3.filter((S3) => S3.pluginDefaults && S3.pluginDefaults[P3.name] !== void 0).map((S3) => [S3.name, S3.pluginDefaults[P3.name]])), N3 = Object.assign(Object.assign({}, C3), A3);
          for (let [S3, j3] of Object.entries(N3))
            (p3[S3] === null || p3[S3] === void 0) && (p3[S3] = j3);
          return p3.parser === "json" && (p3.trailingComma = "none"), e28.normalizeApiOptions(p3, d3, Object.assign({ passThrough: Object.keys(r3) }, y3));
        }
        function c3(m3) {
          let { astFormat: y3 } = m3;
          if (!y3)
            throw new Error("getPlugin() requires astFormat to be set");
          let p3 = m3.plugins.find((d3) => d3.printers && d3.printers[y3]);
          if (!p3)
            throw new Error(`Couldn't find plugin for AST format "${y3}"`);
          return p3;
        }
        function h3(m3, y3) {
          let p3 = t3.basename(m3).toLowerCase(), d3 = a3({ plugins: y3 }).languages.filter((C3) => C3.since !== null).find((C3) => C3.extensions && C3.extensions.some((w3) => p3.endsWith(w3)) || C3.filenames && C3.filenames.some((w3) => w3.toLowerCase() === p3));
          return d3 && d3.parsers[0];
        }
        l3.exports = { normalize: o3, hiddenDefaults: r3, inferParser: h3 };
      } }), Ua2 = X3({ "src/main/massage-ast.js"(u3, l3) {
        H3();
        function t3(s3, a3, e28) {
          if (Array.isArray(s3))
            return s3.map((c3) => t3(c3, a3, e28)).filter(Boolean);
          if (!s3 || typeof s3 != "object")
            return s3;
          let n3 = a3.printer.massageAstNode, r3;
          n3 && n3.ignoredProperties ? r3 = n3.ignoredProperties : r3 = /* @__PURE__ */ new Set();
          let o3 = {};
          for (let [c3, h3] of Object.entries(s3))
            !r3.has(c3) && typeof h3 != "function" && (o3[c3] = t3(h3, a3, s3));
          if (n3) {
            let c3 = n3(s3, o3, e28);
            if (c3 === null)
              return;
            if (c3)
              return c3;
          }
          return o3;
        }
        l3.exports = t3;
      } }), pn2 = X3({ "scripts/build/shims/assert.cjs"(u3, l3) {
        H3();
        var t3 = () => {
        };
        t3.ok = t3, t3.strictEqual = t3, l3.exports = t3;
      } }), ht2 = X3({ "src/main/comments.js"(u3, l3) {
        H3();
        var t3 = pn2(), { builders: { line: s3, hardline: a3, breakParent: e28, indent: n3, lineSuffix: r3, join: o3, cursor: c3 } } = Qe2(), { hasNewline: h3, skipNewline: m3, skipSpaces: y3, isPreviousLineEmpty: p3, addLeadingComment: d3, addDanglingComment: C3, addTrailingComment: w3 } = at2(), P3 = /* @__PURE__ */ new WeakMap();
        function A3(I3, M3, V10) {
          if (!I3)
            return;
          let { printer: $3, locStart: U3, locEnd: L3 } = M3;
          if (V10) {
            if ($3.canAttachComment && $3.canAttachComment(I3)) {
              let R3;
              for (R3 = V10.length - 1; R3 >= 0 && !(U3(V10[R3]) <= U3(I3) && L3(V10[R3]) <= L3(I3)); --R3)
                ;
              V10.splice(R3 + 1, 0, I3);
              return;
            }
          } else if (P3.has(I3))
            return P3.get(I3);
          let ee2 = $3.getCommentChildNodes && $3.getCommentChildNodes(I3, M3) || typeof I3 == "object" && Object.entries(I3).filter((R3) => {
            let [O3] = R3;
            return O3 !== "enclosingNode" && O3 !== "precedingNode" && O3 !== "followingNode" && O3 !== "tokens" && O3 !== "comments" && O3 !== "parent";
          }).map((R3) => {
            let [, O3] = R3;
            return O3;
          });
          if (ee2) {
            V10 || (V10 = [], P3.set(I3, V10));
            for (let R3 of ee2)
              A3(R3, M3, V10);
            return V10;
          }
        }
        function N3(I3, M3, V10, $3) {
          let { locStart: U3, locEnd: L3 } = V10, ee2 = U3(M3), R3 = L3(M3), O3 = A3(I3, V10), Z3, ie2, te2 = 0, ge2 = O3.length;
          for (; te2 < ge2; ) {
            let q3 = te2 + ge2 >> 1, z3 = O3[q3], De2 = U3(z3), fe2 = L3(z3);
            if (De2 <= ee2 && R3 <= fe2)
              return N3(z3, M3, V10, z3);
            if (fe2 <= ee2) {
              Z3 = z3, te2 = q3 + 1;
              continue;
            }
            if (R3 <= De2) {
              ie2 = z3, ge2 = q3;
              continue;
            }
            throw new Error("Comment location overlaps with node location");
          }
          if ($3 && $3.type === "TemplateLiteral") {
            let { quasis: q3 } = $3, z3 = F3(q3, M3, V10);
            Z3 && F3(q3, Z3, V10) !== z3 && (Z3 = null), ie2 && F3(q3, ie2, V10) !== z3 && (ie2 = null);
          }
          return { enclosingNode: $3, precedingNode: Z3, followingNode: ie2 };
        }
        var S3 = () => false;
        function j3(I3, M3, V10, $3) {
          if (!Array.isArray(I3))
            return;
          let U3 = [], { locStart: L3, locEnd: ee2, printer: { handleComments: R3 = {} } } = $3, { avoidAstMutation: O3, ownLine: Z3 = S3, endOfLine: ie2 = S3, remaining: te2 = S3 } = R3, ge2 = I3.map((q3, z3) => Object.assign(Object.assign({}, N3(M3, q3, $3)), {}, { comment: q3, text: V10, options: $3, ast: M3, isLastComment: I3.length - 1 === z3 }));
          for (let [q3, z3] of ge2.entries()) {
            let { comment: De2, precedingNode: fe2, enclosingNode: we2, followingNode: Q3, text: W3, options: ne2, ast: re2, isLastComment: he2 } = z3;
            if (ne2.parser === "json" || ne2.parser === "json5" || ne2.parser === "__js_expression" || ne2.parser === "__vue_expression" || ne2.parser === "__vue_ts_expression") {
              if (L3(De2) - L3(re2) <= 0) {
                d3(re2, De2);
                continue;
              }
              if (ee2(De2) - ee2(re2) >= 0) {
                w3(re2, De2);
                continue;
              }
            }
            let Fe2;
            if (O3 ? Fe2 = [z3] : (De2.enclosingNode = we2, De2.precedingNode = fe2, De2.followingNode = Q3, Fe2 = [De2, W3, ne2, re2, he2]), J3(W3, ne2, ge2, q3))
              De2.placement = "ownLine", Z3(...Fe2) || (Q3 ? d3(Q3, De2) : fe2 ? w3(fe2, De2) : C3(we2 || re2, De2));
            else if (f3(W3, ne2, ge2, q3))
              De2.placement = "endOfLine", ie2(...Fe2) || (fe2 ? w3(fe2, De2) : Q3 ? d3(Q3, De2) : C3(we2 || re2, De2));
            else if (De2.placement = "remaining", !te2(...Fe2))
              if (fe2 && Q3) {
                let ve2 = U3.length;
                ve2 > 0 && U3[ve2 - 1].followingNode !== Q3 && T3(U3, W3, ne2), U3.push(z3);
              } else
                fe2 ? w3(fe2, De2) : Q3 ? d3(Q3, De2) : C3(we2 || re2, De2);
          }
          if (T3(U3, V10, $3), !O3)
            for (let q3 of I3)
              delete q3.precedingNode, delete q3.enclosingNode, delete q3.followingNode;
        }
        var k3 = (I3) => !/[\S\n\u2028\u2029]/.test(I3);
        function J3(I3, M3, V10, $3) {
          let { comment: U3, precedingNode: L3 } = V10[$3], { locStart: ee2, locEnd: R3 } = M3, O3 = ee2(U3);
          if (L3)
            for (let Z3 = $3 - 1; Z3 >= 0; Z3--) {
              let { comment: ie2, precedingNode: te2 } = V10[Z3];
              if (te2 !== L3 || !k3(I3.slice(R3(ie2), O3)))
                break;
              O3 = ee2(ie2);
            }
          return h3(I3, O3, { backwards: true });
        }
        function f3(I3, M3, V10, $3) {
          let { comment: U3, followingNode: L3 } = V10[$3], { locStart: ee2, locEnd: R3 } = M3, O3 = R3(U3);
          if (L3)
            for (let Z3 = $3 + 1; Z3 < V10.length; Z3++) {
              let { comment: ie2, followingNode: te2 } = V10[Z3];
              if (te2 !== L3 || !k3(I3.slice(O3, ee2(ie2))))
                break;
              O3 = R3(ie2);
            }
          return h3(I3, O3);
        }
        function T3(I3, M3, V10) {
          let $3 = I3.length;
          if ($3 === 0)
            return;
          let { precedingNode: U3, followingNode: L3, enclosingNode: ee2 } = I3[0], R3 = V10.printer.getGapRegex && V10.printer.getGapRegex(ee2) || /^[\s(]*$/, O3 = V10.locStart(L3), Z3;
          for (Z3 = $3; Z3 > 0; --Z3) {
            let { comment: ie2, precedingNode: te2, followingNode: ge2 } = I3[Z3 - 1];
            t3.strictEqual(te2, U3), t3.strictEqual(ge2, L3);
            let q3 = M3.slice(V10.locEnd(ie2), O3);
            if (R3.test(q3))
              O3 = V10.locStart(ie2);
            else
              break;
          }
          for (let [ie2, { comment: te2 }] of I3.entries())
            ie2 < Z3 ? w3(U3, te2) : d3(L3, te2);
          for (let ie2 of [U3, L3])
            ie2.comments && ie2.comments.length > 1 && ie2.comments.sort((te2, ge2) => V10.locStart(te2) - V10.locStart(ge2));
          I3.length = 0;
        }
        function D3(I3, M3) {
          let V10 = I3.getValue();
          return V10.printed = true, M3.printer.printComment(I3, M3);
        }
        function F3(I3, M3, V10) {
          let $3 = V10.locStart(M3) - 1;
          for (let U3 = 1; U3 < I3.length; ++U3)
            if ($3 < V10.locStart(I3[U3]))
              return U3 - 1;
          return 0;
        }
        function i(I3, M3) {
          let V10 = I3.getValue(), $3 = [D3(I3, M3)], { printer: U3, originalText: L3, locStart: ee2, locEnd: R3 } = M3;
          if (U3.isBlockComment && U3.isBlockComment(V10)) {
            let Z3 = h3(L3, R3(V10)) ? h3(L3, ee2(V10), { backwards: true }) ? a3 : s3 : " ";
            $3.push(Z3);
          } else
            $3.push(a3);
          let O3 = m3(L3, y3(L3, R3(V10)));
          return O3 !== false && h3(L3, O3) && $3.push(a3), $3;
        }
        function g3(I3, M3) {
          let V10 = I3.getValue(), $3 = D3(I3, M3), { printer: U3, originalText: L3, locStart: ee2 } = M3, R3 = U3.isBlockComment && U3.isBlockComment(V10);
          if (h3(L3, ee2(V10), { backwards: true })) {
            let Z3 = p3(L3, V10, ee2);
            return r3([a3, Z3 ? a3 : "", $3]);
          }
          let O3 = [" ", $3];
          return R3 || (O3 = [r3(O3), e28]), O3;
        }
        function E3(I3, M3, V10, $3) {
          let U3 = [], L3 = I3.getValue();
          return !L3 || !L3.comments || (I3.each(() => {
            let ee2 = I3.getValue();
            !ee2.leading && !ee2.trailing && (!$3 || $3(ee2)) && U3.push(D3(I3, M3));
          }, "comments"), U3.length === 0) ? "" : V10 ? o3(a3, U3) : n3([a3, o3(a3, U3)]);
        }
        function x3(I3, M3, V10) {
          let $3 = I3.getValue();
          if (!$3)
            return {};
          let U3 = $3.comments || [];
          V10 && (U3 = U3.filter((O3) => !V10.has(O3)));
          let L3 = $3 === M3.cursorNode;
          if (U3.length === 0) {
            let O3 = L3 ? c3 : "";
            return { leading: O3, trailing: O3 };
          }
          let ee2 = [], R3 = [];
          return I3.each(() => {
            let O3 = I3.getValue();
            if (V10 && V10.has(O3))
              return;
            let { leading: Z3, trailing: ie2 } = O3;
            Z3 ? ee2.push(i(I3, M3)) : ie2 && R3.push(g3(I3, M3));
          }, "comments"), L3 && (ee2.unshift(c3), R3.push(c3)), { leading: ee2, trailing: R3 };
        }
        function b3(I3, M3, V10, $3) {
          let { leading: U3, trailing: L3 } = x3(I3, V10, $3);
          return !U3 && !L3 ? M3 : [U3, M3, L3];
        }
        function B3(I3) {
          if (I3)
            for (let M3 of I3) {
              if (!M3.printed)
                throw new Error('Comment "' + M3.value.trim() + '" was not printed. Please report this error!');
              delete M3.printed;
            }
        }
        l3.exports = { attach: j3, printComments: b3, printCommentsSeparately: x3, printDanglingComments: E3, getSortedChildNodes: A3, ensureAllCommentsPrinted: B3 };
      } }), Ya2 = X3({ "src/common/ast-path.js"(u3, l3) {
        H3();
        var t3 = Ct2();
        function s3(n3, r3) {
          let o3 = a3(n3.stack, r3);
          return o3 === -1 ? null : n3.stack[o3];
        }
        function a3(n3, r3) {
          for (let o3 = n3.length - 1; o3 >= 0; o3 -= 2) {
            let c3 = n3[o3];
            if (c3 && !Array.isArray(c3) && --r3 < 0)
              return o3;
          }
          return -1;
        }
        var e28 = class {
          constructor(n3) {
            this.stack = [n3];
          }
          getName() {
            let { stack: n3 } = this, { length: r3 } = n3;
            return r3 > 1 ? n3[r3 - 2] : null;
          }
          getValue() {
            return t3(this.stack);
          }
          getNode() {
            let n3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            return s3(this, n3);
          }
          getParentNode() {
            let n3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            return s3(this, n3 + 1);
          }
          call(n3) {
            let { stack: r3 } = this, { length: o3 } = r3, c3 = t3(r3);
            for (var h3 = arguments.length, m3 = new Array(h3 > 1 ? h3 - 1 : 0), y3 = 1; y3 < h3; y3++)
              m3[y3 - 1] = arguments[y3];
            for (let d3 of m3)
              c3 = c3[d3], r3.push(d3, c3);
            let p3 = n3(this);
            return r3.length = o3, p3;
          }
          callParent(n3) {
            let r3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o3 = a3(this.stack, r3 + 1), c3 = this.stack.splice(o3 + 1), h3 = n3(this);
            return this.stack.push(...c3), h3;
          }
          each(n3) {
            let { stack: r3 } = this, { length: o3 } = r3, c3 = t3(r3);
            for (var h3 = arguments.length, m3 = new Array(h3 > 1 ? h3 - 1 : 0), y3 = 1; y3 < h3; y3++)
              m3[y3 - 1] = arguments[y3];
            for (let p3 of m3)
              c3 = c3[p3], r3.push(p3, c3);
            for (let p3 = 0; p3 < c3.length; ++p3)
              r3.push(p3, c3[p3]), n3(this, p3, c3), r3.length -= 2;
            r3.length = o3;
          }
          map(n3) {
            let r3 = [];
            for (var o3 = arguments.length, c3 = new Array(o3 > 1 ? o3 - 1 : 0), h3 = 1; h3 < o3; h3++)
              c3[h3 - 1] = arguments[h3];
            return this.each((m3, y3, p3) => {
              r3[y3] = n3(m3, y3, p3);
            }, ...c3), r3;
          }
          try(n3) {
            let { stack: r3 } = this, o3 = [...r3];
            try {
              return n3();
            } finally {
              r3.length = 0, r3.push(...o3);
            }
          }
          match() {
            let n3 = this.stack.length - 1, r3 = null, o3 = this.stack[n3--];
            for (var c3 = arguments.length, h3 = new Array(c3), m3 = 0; m3 < c3; m3++)
              h3[m3] = arguments[m3];
            for (let y3 of h3) {
              if (o3 === void 0)
                return false;
              let p3 = null;
              if (typeof r3 == "number" && (p3 = r3, r3 = this.stack[n3--], o3 = this.stack[n3--]), y3 && !y3(o3, r3, p3))
                return false;
              r3 = this.stack[n3--], o3 = this.stack[n3--];
            }
            return true;
          }
          findAncestor(n3) {
            let r3 = this.stack.length - 1, o3 = null, c3 = this.stack[r3--];
            for (; c3; ) {
              let h3 = null;
              if (typeof o3 == "number" && (h3 = o3, o3 = this.stack[r3--], c3 = this.stack[r3--]), o3 !== null && n3(c3, o3, h3))
                return c3;
              o3 = this.stack[r3--], c3 = this.stack[r3--];
            }
          }
        };
        l3.exports = e28;
      } }), za2 = X3({ "src/main/multiparser.js"(u3, l3) {
        H3();
        var { utils: { stripTrailingHardline: t3 } } = Qe2(), { normalize: s3 } = Du2(), a3 = ht2();
        function e28(r3, o3, c3, h3) {
          if (c3.printer.embed && c3.embeddedLanguageFormatting === "auto")
            return c3.printer.embed(r3, o3, (m3, y3, p3) => n3(m3, y3, c3, h3, p3), c3);
        }
        function n3(r3, o3, c3, h3) {
          let { stripTrailingHardline: m3 = false } = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, y3 = s3(Object.assign(Object.assign(Object.assign({}, c3), o3), {}, { parentParser: c3.parser, originalText: r3 }), { passThrough: true }), p3 = ir2().parse(r3, y3), { ast: d3 } = p3;
          r3 = p3.text;
          let C3 = d3.comments;
          delete d3.comments, a3.attach(C3, d3, r3, y3), y3[Symbol.for("comments")] = C3 || [], y3[Symbol.for("tokens")] = d3.tokens || [];
          let w3 = h3(d3, y3);
          return a3.ensureAllCommentsPrinted(C3), m3 ? typeof w3 == "string" ? w3.replace(/(?:\r?\n)*$/, "") : t3(w3) : w3;
        }
        l3.exports = { printSubtree: e28 };
      } }), Ka2 = X3({ "src/main/ast-to-doc.js"(u3, l3) {
        H3();
        var t3 = Ya2(), { builders: { hardline: s3, addAlignmentToDoc: a3 }, utils: { propagateBreaks: e28 } } = Qe2(), { printComments: n3 } = ht2(), r3 = za2();
        function o3(m3, y3) {
          let p3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, { printer: d3 } = y3;
          d3.preprocess && (m3 = d3.preprocess(m3, y3));
          let C3 = /* @__PURE__ */ new Map(), w3 = new t3(m3), P3 = A3();
          return p3 > 0 && (P3 = a3([s3, P3], p3, y3.tabWidth)), e28(P3), P3;
          function A3(S3, j3) {
            return S3 === void 0 || S3 === w3 ? N3(j3) : Array.isArray(S3) ? w3.call(() => N3(j3), ...S3) : w3.call(() => N3(j3), S3);
          }
          function N3(S3) {
            let j3 = w3.getValue(), k3 = j3 && typeof j3 == "object" && S3 === void 0;
            if (k3 && C3.has(j3))
              return C3.get(j3);
            let J3 = h3(w3, y3, A3, S3);
            return k3 && C3.set(j3, J3), J3;
          }
        }
        function c3(m3, y3) {
          let { originalText: p3, [Symbol.for("comments")]: d3, locStart: C3, locEnd: w3 } = y3, P3 = C3(m3), A3 = w3(m3), N3 = /* @__PURE__ */ new Set();
          for (let S3 of d3)
            C3(S3) >= P3 && w3(S3) <= A3 && (S3.printed = true, N3.add(S3));
          return { doc: p3.slice(P3, A3), printedComments: N3 };
        }
        function h3(m3, y3, p3, d3) {
          let C3 = m3.getValue(), { printer: w3 } = y3, P3, A3;
          if (w3.hasPrettierIgnore && w3.hasPrettierIgnore(m3))
            ({ doc: P3, printedComments: A3 } = c3(C3, y3));
          else {
            if (C3)
              try {
                P3 = r3.printSubtree(m3, p3, y3, o3);
              } catch (N3) {
                if (globalThis.PRETTIER_DEBUG)
                  throw N3;
              }
            P3 || (P3 = w3.print(m3, y3, p3, d3));
          }
          return (!w3.willPrintOwnComments || !w3.willPrintOwnComments(m3, y3)) && (P3 = n3(m3, P3, y3, A3)), P3;
        }
        l3.exports = o3;
      } }), Qa2 = X3({ "src/main/range-util.js"(u3, l3) {
        H3();
        var t3 = pn2(), s3 = ht2(), a3 = (d3) => {
          let { parser: C3 } = d3;
          return C3 === "json" || C3 === "json5" || C3 === "json-stringify";
        };
        function e28(d3, C3) {
          let w3 = [d3.node, ...d3.parentNodes], P3 = /* @__PURE__ */ new Set([C3.node, ...C3.parentNodes]);
          return w3.find((A3) => h3.has(A3.type) && P3.has(A3));
        }
        function n3(d3) {
          let C3 = d3.length - 1;
          for (; ; ) {
            let w3 = d3[C3];
            if (w3 && (w3.type === "Program" || w3.type === "File"))
              C3--;
            else
              break;
          }
          return d3.slice(0, C3 + 1);
        }
        function r3(d3, C3, w3) {
          let { locStart: P3, locEnd: A3 } = w3, N3 = d3.node, S3 = C3.node;
          if (N3 === S3)
            return { startNode: N3, endNode: S3 };
          let j3 = P3(d3.node);
          for (let J3 of n3(C3.parentNodes))
            if (P3(J3) >= j3)
              S3 = J3;
            else
              break;
          let k3 = A3(C3.node);
          for (let J3 of n3(d3.parentNodes)) {
            if (A3(J3) <= k3)
              N3 = J3;
            else
              break;
            if (N3 === S3)
              break;
          }
          return { startNode: N3, endNode: S3 };
        }
        function o3(d3, C3, w3, P3) {
          let A3 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], N3 = arguments.length > 5 ? arguments[5] : void 0, { locStart: S3, locEnd: j3 } = w3, k3 = S3(d3), J3 = j3(d3);
          if (!(C3 > J3 || C3 < k3 || N3 === "rangeEnd" && C3 === k3 || N3 === "rangeStart" && C3 === J3)) {
            for (let f3 of s3.getSortedChildNodes(d3, w3)) {
              let T3 = o3(f3, C3, w3, P3, [d3, ...A3], N3);
              if (T3)
                return T3;
            }
            if (!P3 || P3(d3, A3[0]))
              return { node: d3, parentNodes: A3 };
          }
        }
        function c3(d3, C3) {
          return C3 !== "DeclareExportDeclaration" && d3 !== "TypeParameterDeclaration" && (d3 === "Directive" || d3 === "TypeAlias" || d3 === "TSExportAssignment" || d3.startsWith("Declare") || d3.startsWith("TSDeclare") || d3.endsWith("Statement") || d3.endsWith("Declaration"));
        }
        var h3 = /* @__PURE__ */ new Set(["ObjectExpression", "ArrayExpression", "StringLiteral", "NumericLiteral", "BooleanLiteral", "NullLiteral", "UnaryExpression", "TemplateLiteral"]), m3 = /* @__PURE__ */ new Set(["OperationDefinition", "FragmentDefinition", "VariableDefinition", "TypeExtensionDefinition", "ObjectTypeDefinition", "FieldDefinition", "DirectiveDefinition", "EnumTypeDefinition", "EnumValueDefinition", "InputValueDefinition", "InputObjectTypeDefinition", "SchemaDefinition", "OperationTypeDefinition", "InterfaceTypeDefinition", "UnionTypeDefinition", "ScalarTypeDefinition"]);
        function y3(d3, C3, w3) {
          if (!C3)
            return false;
          switch (d3.parser) {
            case "flow":
            case "babel":
            case "babel-flow":
            case "babel-ts":
            case "typescript":
            case "acorn":
            case "espree":
            case "meriyah":
            case "__babel_estree":
              return c3(C3.type, w3 && w3.type);
            case "json":
            case "json5":
            case "json-stringify":
              return h3.has(C3.type);
            case "graphql":
              return m3.has(C3.kind);
            case "vue":
              return C3.tag !== "root";
          }
          return false;
        }
        function p3(d3, C3, w3) {
          let { rangeStart: P3, rangeEnd: A3, locStart: N3, locEnd: S3 } = C3;
          t3.ok(A3 > P3);
          let j3 = d3.slice(P3, A3).search(/\S/), k3 = j3 === -1;
          if (!k3)
            for (P3 += j3; A3 > P3 && !/\S/.test(d3[A3 - 1]); --A3)
              ;
          let J3 = o3(w3, P3, C3, (F3, i) => y3(C3, F3, i), [], "rangeStart"), f3 = k3 ? J3 : o3(w3, A3, C3, (F3) => y3(C3, F3), [], "rangeEnd");
          if (!J3 || !f3)
            return { rangeStart: 0, rangeEnd: 0 };
          let T3, D3;
          if (a3(C3)) {
            let F3 = e28(J3, f3);
            T3 = F3, D3 = F3;
          } else
            ({ startNode: T3, endNode: D3 } = r3(J3, f3, C3));
          return { rangeStart: Math.min(N3(T3), N3(D3)), rangeEnd: Math.max(S3(T3), S3(D3)) };
        }
        l3.exports = { calculateRange: p3, findNodeAtOffset: o3 };
      } }), Ha2 = X3({ "src/main/core.js"(u3, l3) {
        H3();
        var { diffArrays: t3 } = Qt2(), { printer: { printDocToString: s3 }, debug: { printDocToDebug: a3 } } = Qe2(), { getAlignmentSize: e28 } = at2(), { guessEndOfLine: n3, convertEndOfLineToChars: r3, countEndOfLineChars: o3, normalizeEndOfLine: c3 } = $t2(), h3 = Du2().normalize, m3 = Ua2(), y3 = ht2(), p3 = ir2(), d3 = Ka2(), C3 = Qa2(), w3 = "\uFEFF", P3 = Symbol("cursor");
        function A3(D3, F3, i) {
          let g3 = F3.comments;
          return g3 && (delete F3.comments, y3.attach(g3, F3, D3, i)), i[Symbol.for("comments")] = g3 || [], i[Symbol.for("tokens")] = F3.tokens || [], i.originalText = D3, g3;
        }
        function N3(D3, F3) {
          let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
          if (!D3 || D3.trim().length === 0)
            return { formatted: "", cursorOffset: -1, comments: [] };
          let { ast: g3, text: E3 } = p3.parse(D3, F3);
          if (F3.cursorOffset >= 0) {
            let I3 = C3.findNodeAtOffset(g3, F3.cursorOffset, F3);
            I3 && I3.node && (F3.cursorNode = I3.node);
          }
          let x3 = A3(E3, g3, F3), b3 = d3(g3, F3, i), B3 = s3(b3, F3);
          if (y3.ensureAllCommentsPrinted(x3), i > 0) {
            let I3 = B3.formatted.trim();
            B3.cursorNodeStart !== void 0 && (B3.cursorNodeStart -= B3.formatted.indexOf(I3)), B3.formatted = I3 + r3(F3.endOfLine);
          }
          if (F3.cursorOffset >= 0) {
            let I3, M3, V10, $3, U3;
            if (F3.cursorNode && B3.cursorNodeText ? (I3 = F3.locStart(F3.cursorNode), M3 = E3.slice(I3, F3.locEnd(F3.cursorNode)), V10 = F3.cursorOffset - I3, $3 = B3.cursorNodeStart, U3 = B3.cursorNodeText) : (I3 = 0, M3 = E3, V10 = F3.cursorOffset, $3 = 0, U3 = B3.formatted), M3 === U3)
              return { formatted: B3.formatted, cursorOffset: $3 + V10, comments: x3 };
            let L3 = [...M3];
            L3.splice(V10, 0, P3);
            let ee2 = [...U3], R3 = t3(L3, ee2), O3 = $3;
            for (let Z3 of R3)
              if (Z3.removed) {
                if (Z3.value.includes(P3))
                  break;
              } else
                O3 += Z3.count;
            return { formatted: B3.formatted, cursorOffset: O3, comments: x3 };
          }
          return { formatted: B3.formatted, cursorOffset: -1, comments: x3 };
        }
        function S3(D3, F3) {
          let { ast: i, text: g3 } = p3.parse(D3, F3), { rangeStart: E3, rangeEnd: x3 } = C3.calculateRange(g3, F3, i), b3 = g3.slice(E3, x3), B3 = Math.min(E3, g3.lastIndexOf(`
`, E3) + 1), I3 = g3.slice(B3, E3).match(/^\s*/)[0], M3 = e28(I3, F3.tabWidth), V10 = N3(b3, Object.assign(Object.assign({}, F3), {}, { rangeStart: 0, rangeEnd: Number.POSITIVE_INFINITY, cursorOffset: F3.cursorOffset > E3 && F3.cursorOffset <= x3 ? F3.cursorOffset - E3 : -1, endOfLine: "lf" }), M3), $3 = V10.formatted.trimEnd(), { cursorOffset: U3 } = F3;
          U3 > x3 ? U3 += $3.length - b3.length : V10.cursorOffset >= 0 && (U3 = V10.cursorOffset + E3);
          let L3 = g3.slice(0, E3) + $3 + g3.slice(x3);
          if (F3.endOfLine !== "lf") {
            let ee2 = r3(F3.endOfLine);
            U3 >= 0 && ee2 === `\r
` && (U3 += o3(L3.slice(0, U3), `
`)), L3 = L3.replace(/\n/g, ee2);
          }
          return { formatted: L3, cursorOffset: U3, comments: V10.comments };
        }
        function j3(D3, F3, i) {
          return typeof F3 != "number" || Number.isNaN(F3) || F3 < 0 || F3 > D3.length ? i : F3;
        }
        function k3(D3, F3) {
          let { cursorOffset: i, rangeStart: g3, rangeEnd: E3 } = F3;
          return i = j3(D3, i, -1), g3 = j3(D3, g3, 0), E3 = j3(D3, E3, D3.length), Object.assign(Object.assign({}, F3), {}, { cursorOffset: i, rangeStart: g3, rangeEnd: E3 });
        }
        function J3(D3, F3) {
          let { cursorOffset: i, rangeStart: g3, rangeEnd: E3, endOfLine: x3 } = k3(D3, F3), b3 = D3.charAt(0) === w3;
          if (b3 && (D3 = D3.slice(1), i--, g3--, E3--), x3 === "auto" && (x3 = n3(D3)), D3.includes("\r")) {
            let B3 = (I3) => o3(D3.slice(0, Math.max(I3, 0)), `\r
`);
            i -= B3(i), g3 -= B3(g3), E3 -= B3(E3), D3 = c3(D3);
          }
          return { hasBOM: b3, text: D3, options: k3(D3, Object.assign(Object.assign({}, F3), {}, { cursorOffset: i, rangeStart: g3, rangeEnd: E3, endOfLine: x3 })) };
        }
        function f3(D3, F3) {
          let i = p3.resolveParser(F3);
          return !i.hasPragma || i.hasPragma(D3);
        }
        function T3(D3, F3) {
          let { hasBOM: i, text: g3, options: E3 } = J3(D3, h3(F3));
          if (E3.rangeStart >= E3.rangeEnd && g3 !== "" || E3.requirePragma && !f3(g3, E3))
            return { formatted: D3, cursorOffset: F3.cursorOffset, comments: [] };
          let x3;
          return E3.rangeStart > 0 || E3.rangeEnd < g3.length ? x3 = S3(g3, E3) : (!E3.requirePragma && E3.insertPragma && E3.printer.insertPragma && !f3(g3, E3) && (g3 = E3.printer.insertPragma(g3)), x3 = N3(g3, E3)), i && (x3.formatted = w3 + x3.formatted, x3.cursorOffset >= 0 && x3.cursorOffset++), x3;
        }
        l3.exports = { formatWithCursor: T3, parse(D3, F3, i) {
          let { text: g3, options: E3 } = J3(D3, h3(F3)), x3 = p3.parse(g3, E3);
          return i && (x3.ast = m3(x3.ast, E3)), x3;
        }, formatAST(D3, F3) {
          F3 = h3(F3);
          let i = d3(D3, F3);
          return s3(i, F3);
        }, formatDoc(D3, F3) {
          return T3(a3(D3), Object.assign(Object.assign({}, F3), {}, { parser: "__js_expression" })).formatted;
        }, printToDoc(D3, F3) {
          F3 = h3(F3);
          let { ast: i, text: g3 } = p3.parse(D3, F3);
          return A3(g3, i, F3), d3(i, F3);
        }, printDocToString(D3, F3) {
          return s3(D3, h3(F3));
        } };
      } }), Za2 = X3({ "src/common/util-shared.js"(u3, l3) {
        H3();
        var { getMaxContinuousCount: t3, getStringWidth: s3, getAlignmentSize: a3, getIndentSize: e28, skip: n3, skipWhitespace: r3, skipSpaces: o3, skipNewline: c3, skipToLineEnd: h3, skipEverythingButNewLine: m3, skipInlineComment: y3, skipTrailingComment: p3, hasNewline: d3, hasNewlineInRange: C3, hasSpaces: w3, isNextLineEmpty: P3, isNextLineEmptyAfterIndex: A3, isPreviousLineEmpty: N3, getNextNonSpaceNonCommentCharacterIndex: S3, makeString: j3, addLeadingComment: k3, addDanglingComment: J3, addTrailingComment: f3 } = at2();
        l3.exports = { getMaxContinuousCount: t3, getStringWidth: s3, getAlignmentSize: a3, getIndentSize: e28, skip: n3, skipWhitespace: r3, skipSpaces: o3, skipNewline: c3, skipToLineEnd: h3, skipEverythingButNewLine: m3, skipInlineComment: y3, skipTrailingComment: p3, hasNewline: d3, hasNewlineInRange: C3, hasSpaces: w3, isNextLineEmpty: P3, isNextLineEmptyAfterIndex: A3, isPreviousLineEmpty: N3, getNextNonSpaceNonCommentCharacterIndex: S3, makeString: j3, addLeadingComment: k3, addDanglingComment: J3, addTrailingComment: f3 };
      } }), Gt2 = X3({ "src/utils/create-language.js"(u3, l3) {
        H3(), l3.exports = function(t3, s3) {
          let { languageId: a3 } = t3, e28 = Ce2(t3, se2);
          return Object.assign(Object.assign({ linguistLanguageId: a3 }, e28), s3(t3));
        };
      } }), es2 = X3({ "node_modules/esutils/lib/ast.js"(u3, l3) {
        H3(), function() {
          function t3(o3) {
            if (o3 == null)
              return false;
            switch (o3.type) {
              case "ArrayExpression":
              case "AssignmentExpression":
              case "BinaryExpression":
              case "CallExpression":
              case "ConditionalExpression":
              case "FunctionExpression":
              case "Identifier":
              case "Literal":
              case "LogicalExpression":
              case "MemberExpression":
              case "NewExpression":
              case "ObjectExpression":
              case "SequenceExpression":
              case "ThisExpression":
              case "UnaryExpression":
              case "UpdateExpression":
                return true;
            }
            return false;
          }
          function s3(o3) {
            if (o3 == null)
              return false;
            switch (o3.type) {
              case "DoWhileStatement":
              case "ForInStatement":
              case "ForStatement":
              case "WhileStatement":
                return true;
            }
            return false;
          }
          function a3(o3) {
            if (o3 == null)
              return false;
            switch (o3.type) {
              case "BlockStatement":
              case "BreakStatement":
              case "ContinueStatement":
              case "DebuggerStatement":
              case "DoWhileStatement":
              case "EmptyStatement":
              case "ExpressionStatement":
              case "ForInStatement":
              case "ForStatement":
              case "IfStatement":
              case "LabeledStatement":
              case "ReturnStatement":
              case "SwitchStatement":
              case "ThrowStatement":
              case "TryStatement":
              case "VariableDeclaration":
              case "WhileStatement":
              case "WithStatement":
                return true;
            }
            return false;
          }
          function e28(o3) {
            return a3(o3) || o3 != null && o3.type === "FunctionDeclaration";
          }
          function n3(o3) {
            switch (o3.type) {
              case "IfStatement":
                return o3.alternate != null ? o3.alternate : o3.consequent;
              case "LabeledStatement":
              case "ForStatement":
              case "ForInStatement":
              case "WhileStatement":
              case "WithStatement":
                return o3.body;
            }
            return null;
          }
          function r3(o3) {
            var c3;
            if (o3.type !== "IfStatement" || o3.alternate == null)
              return false;
            c3 = o3.consequent;
            do {
              if (c3.type === "IfStatement" && c3.alternate == null)
                return true;
              c3 = n3(c3);
            } while (c3);
            return false;
          }
          l3.exports = { isExpression: t3, isStatement: a3, isIterationStatement: s3, isSourceElement: e28, isProblematicIfStatement: r3, trailingStatement: n3 };
        }();
      } }), fu2 = X3({ "node_modules/esutils/lib/code.js"(u3, l3) {
        H3(), function() {
          var t3, s3, a3, e28, n3, r3;
          s3 = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/, NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/ }, t3 = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/, NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/ };
          function o3(A3) {
            return 48 <= A3 && A3 <= 57;
          }
          function c3(A3) {
            return 48 <= A3 && A3 <= 57 || 97 <= A3 && A3 <= 102 || 65 <= A3 && A3 <= 70;
          }
          function h3(A3) {
            return A3 >= 48 && A3 <= 55;
          }
          a3 = [5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279];
          function m3(A3) {
            return A3 === 32 || A3 === 9 || A3 === 11 || A3 === 12 || A3 === 160 || A3 >= 5760 && a3.indexOf(A3) >= 0;
          }
          function y3(A3) {
            return A3 === 10 || A3 === 13 || A3 === 8232 || A3 === 8233;
          }
          function p3(A3) {
            if (A3 <= 65535)
              return String.fromCharCode(A3);
            var N3 = String.fromCharCode(Math.floor((A3 - 65536) / 1024) + 55296), S3 = String.fromCharCode((A3 - 65536) % 1024 + 56320);
            return N3 + S3;
          }
          for (e28 = new Array(128), r3 = 0; r3 < 128; ++r3)
            e28[r3] = r3 >= 97 && r3 <= 122 || r3 >= 65 && r3 <= 90 || r3 === 36 || r3 === 95;
          for (n3 = new Array(128), r3 = 0; r3 < 128; ++r3)
            n3[r3] = r3 >= 97 && r3 <= 122 || r3 >= 65 && r3 <= 90 || r3 >= 48 && r3 <= 57 || r3 === 36 || r3 === 95;
          function d3(A3) {
            return A3 < 128 ? e28[A3] : s3.NonAsciiIdentifierStart.test(p3(A3));
          }
          function C3(A3) {
            return A3 < 128 ? n3[A3] : s3.NonAsciiIdentifierPart.test(p3(A3));
          }
          function w3(A3) {
            return A3 < 128 ? e28[A3] : t3.NonAsciiIdentifierStart.test(p3(A3));
          }
          function P3(A3) {
            return A3 < 128 ? n3[A3] : t3.NonAsciiIdentifierPart.test(p3(A3));
          }
          l3.exports = { isDecimalDigit: o3, isHexDigit: c3, isOctalDigit: h3, isWhiteSpace: m3, isLineTerminator: y3, isIdentifierStartES5: d3, isIdentifierPartES5: C3, isIdentifierStartES6: w3, isIdentifierPartES6: P3 };
        }();
      } }), ts2 = X3({ "node_modules/esutils/lib/keyword.js"(u3, l3) {
        H3(), function() {
          var t3 = fu2();
          function s3(d3) {
            switch (d3) {
              case "implements":
              case "interface":
              case "package":
              case "private":
              case "protected":
              case "public":
              case "static":
              case "let":
                return true;
              default:
                return false;
            }
          }
          function a3(d3, C3) {
            return !C3 && d3 === "yield" ? false : e28(d3, C3);
          }
          function e28(d3, C3) {
            if (C3 && s3(d3))
              return true;
            switch (d3.length) {
              case 2:
                return d3 === "if" || d3 === "in" || d3 === "do";
              case 3:
                return d3 === "var" || d3 === "for" || d3 === "new" || d3 === "try";
              case 4:
                return d3 === "this" || d3 === "else" || d3 === "case" || d3 === "void" || d3 === "with" || d3 === "enum";
              case 5:
                return d3 === "while" || d3 === "break" || d3 === "catch" || d3 === "throw" || d3 === "const" || d3 === "yield" || d3 === "class" || d3 === "super";
              case 6:
                return d3 === "return" || d3 === "typeof" || d3 === "delete" || d3 === "switch" || d3 === "export" || d3 === "import";
              case 7:
                return d3 === "default" || d3 === "finally" || d3 === "extends";
              case 8:
                return d3 === "function" || d3 === "continue" || d3 === "debugger";
              case 10:
                return d3 === "instanceof";
              default:
                return false;
            }
          }
          function n3(d3, C3) {
            return d3 === "null" || d3 === "true" || d3 === "false" || a3(d3, C3);
          }
          function r3(d3, C3) {
            return d3 === "null" || d3 === "true" || d3 === "false" || e28(d3, C3);
          }
          function o3(d3) {
            return d3 === "eval" || d3 === "arguments";
          }
          function c3(d3) {
            var C3, w3, P3;
            if (d3.length === 0 || (P3 = d3.charCodeAt(0), !t3.isIdentifierStartES5(P3)))
              return false;
            for (C3 = 1, w3 = d3.length; C3 < w3; ++C3)
              if (P3 = d3.charCodeAt(C3), !t3.isIdentifierPartES5(P3))
                return false;
            return true;
          }
          function h3(d3, C3) {
            return (d3 - 55296) * 1024 + (C3 - 56320) + 65536;
          }
          function m3(d3) {
            var C3, w3, P3, A3, N3;
            if (d3.length === 0)
              return false;
            for (N3 = t3.isIdentifierStartES6, C3 = 0, w3 = d3.length; C3 < w3; ++C3) {
              if (P3 = d3.charCodeAt(C3), 55296 <= P3 && P3 <= 56319) {
                if (++C3, C3 >= w3 || (A3 = d3.charCodeAt(C3), !(56320 <= A3 && A3 <= 57343)))
                  return false;
                P3 = h3(P3, A3);
              }
              if (!N3(P3))
                return false;
              N3 = t3.isIdentifierPartES6;
            }
            return true;
          }
          function y3(d3, C3) {
            return c3(d3) && !n3(d3, C3);
          }
          function p3(d3, C3) {
            return m3(d3) && !r3(d3, C3);
          }
          l3.exports = { isKeywordES5: a3, isKeywordES6: e28, isReservedWordES5: n3, isReservedWordES6: r3, isRestrictedWord: o3, isIdentifierNameES5: c3, isIdentifierNameES6: m3, isIdentifierES5: y3, isIdentifierES6: p3 };
        }();
      } }), ns2 = X3({ "node_modules/esutils/lib/utils.js"(u3) {
        H3(), function() {
          u3.ast = es2(), u3.code = fu2(), u3.keyword = ts2();
        }();
      } }), Wt2 = X3({ "src/language-js/utils/is-block-comment.js"(u3, l3) {
        H3();
        var t3 = /* @__PURE__ */ new Set(["Block", "CommentBlock", "MultiLine"]), s3 = (a3) => t3.has(a3 == null ? void 0 : a3.type);
        l3.exports = s3;
      } }), rs2 = X3({ "src/language-js/utils/is-node-matches.js"(u3, l3) {
        H3();
        function t3(a3, e28) {
          let n3 = e28.split(".");
          for (let r3 = n3.length - 1; r3 >= 0; r3--) {
            let o3 = n3[r3];
            if (r3 === 0)
              return a3.type === "Identifier" && a3.name === o3;
            if (a3.type !== "MemberExpression" || a3.optional || a3.computed || a3.property.type !== "Identifier" || a3.property.name !== o3)
              return false;
            a3 = a3.object;
          }
        }
        function s3(a3, e28) {
          return e28.some((n3) => t3(a3, n3));
        }
        l3.exports = s3;
      } }), Dt2 = X3({ "src/language-js/utils/index.js"(u3, l3) {
        H3();
        var t3 = ns2().keyword.isIdentifierNameES5, { getLast: s3, hasNewline: a3, skipWhitespace: e28, isNonEmptyArray: n3, isNextLineEmptyAfterIndex: r3, getStringWidth: o3 } = at2(), { locStart: c3, locEnd: h3, hasSameLocStart: m3 } = vt2(), y3 = Wt2(), p3 = rs2(), d3 = "(?:(?=.)\\s)", C3 = new RegExp(`^${d3}*:`), w3 = new RegExp(`^${d3}*::`);
        function P3(_3) {
          var Ee2, qe2;
          return ((Ee2 = _3.extra) === null || Ee2 === void 0 ? void 0 : Ee2.parenthesized) && y3((qe2 = _3.trailingComments) === null || qe2 === void 0 ? void 0 : qe2[0]) && C3.test(_3.trailingComments[0].value);
        }
        function A3(_3) {
          let Ee2 = _3 == null ? void 0 : _3[0];
          return y3(Ee2) && w3.test(Ee2.value);
        }
        function N3(_3, Ee2) {
          if (!_3 || typeof _3 != "object")
            return false;
          if (Array.isArray(_3))
            return _3.some((st2) => N3(st2, Ee2));
          let qe2 = Ee2(_3);
          return typeof qe2 == "boolean" ? qe2 : Object.values(_3).some((st2) => N3(st2, Ee2));
        }
        function S3(_3) {
          return _3.type === "AssignmentExpression" || _3.type === "BinaryExpression" || _3.type === "LogicalExpression" || _3.type === "NGPipeExpression" || _3.type === "ConditionalExpression" || De2(_3) || fe2(_3) || _3.type === "SequenceExpression" || _3.type === "TaggedTemplateExpression" || _3.type === "BindExpression" || _3.type === "UpdateExpression" && !_3.prefix || wt2(_3) || _3.type === "TSNonNullExpression";
        }
        function j3(_3) {
          var Ee2, qe2, st2, ot2, St2, gt2;
          return _3.expressions ? _3.expressions[0] : (Ee2 = (qe2 = (st2 = (ot2 = (St2 = (gt2 = _3.left) !== null && gt2 !== void 0 ? gt2 : _3.test) !== null && St2 !== void 0 ? St2 : _3.callee) !== null && ot2 !== void 0 ? ot2 : _3.object) !== null && st2 !== void 0 ? st2 : _3.tag) !== null && qe2 !== void 0 ? qe2 : _3.argument) !== null && Ee2 !== void 0 ? Ee2 : _3.expression;
        }
        function k3(_3, Ee2) {
          if (Ee2.expressions)
            return ["expressions", 0];
          if (Ee2.left)
            return ["left"];
          if (Ee2.test)
            return ["test"];
          if (Ee2.object)
            return ["object"];
          if (Ee2.callee)
            return ["callee"];
          if (Ee2.tag)
            return ["tag"];
          if (Ee2.argument)
            return ["argument"];
          if (Ee2.expression)
            return ["expression"];
          throw new Error("Unexpected node has no left side.");
        }
        function J3(_3) {
          return _3 = new Set(_3), (Ee2) => _3.has(Ee2 == null ? void 0 : Ee2.type);
        }
        var f3 = J3(["Line", "CommentLine", "SingleLine", "HashbangComment", "HTMLOpen", "HTMLClose"]), T3 = J3(["ExportDefaultDeclaration", "ExportDefaultSpecifier", "DeclareExportDeclaration", "ExportNamedDeclaration", "ExportAllDeclaration"]);
        function D3(_3) {
          let Ee2 = _3.getParentNode();
          return _3.getName() === "declaration" && T3(Ee2) ? Ee2 : null;
        }
        var F3 = J3(["BooleanLiteral", "DirectiveLiteral", "Literal", "NullLiteral", "NumericLiteral", "BigIntLiteral", "DecimalLiteral", "RegExpLiteral", "StringLiteral", "TemplateLiteral", "TSTypeLiteral", "JSXText"]);
        function i(_3) {
          return _3.type === "NumericLiteral" || _3.type === "Literal" && typeof _3.value == "number";
        }
        function g3(_3) {
          return _3.type === "UnaryExpression" && (_3.operator === "+" || _3.operator === "-") && i(_3.argument);
        }
        function E3(_3) {
          return _3.type === "StringLiteral" || _3.type === "Literal" && typeof _3.value == "string";
        }
        var x3 = J3(["ObjectTypeAnnotation", "TSTypeLiteral", "TSMappedType"]), b3 = J3(["FunctionExpression", "ArrowFunctionExpression"]);
        function B3(_3) {
          return _3.type === "FunctionExpression" || _3.type === "ArrowFunctionExpression" && _3.body.type === "BlockStatement";
        }
        function I3(_3) {
          return De2(_3) && _3.callee.type === "Identifier" && ["async", "inject", "fakeAsync", "waitForAsync"].includes(_3.callee.name);
        }
        var M3 = J3(["JSXElement", "JSXFragment"]);
        function V10(_3, Ee2) {
          if (_3.parentParser !== "markdown" && _3.parentParser !== "mdx")
            return false;
          let qe2 = Ee2.getNode();
          if (!qe2.expression || !M3(qe2.expression))
            return false;
          let st2 = Ee2.getParentNode();
          return st2.type === "Program" && st2.body.length === 1;
        }
        function $3(_3) {
          return _3.kind === "get" || _3.kind === "set";
        }
        function U3(_3) {
          return $3(_3) || m3(_3, _3.value);
        }
        function L3(_3) {
          return (_3.type === "ObjectTypeProperty" || _3.type === "ObjectTypeInternalSlot") && _3.value.type === "FunctionTypeAnnotation" && !_3.static && !U3(_3);
        }
        function ee2(_3) {
          return (_3.type === "TypeAnnotation" || _3.type === "TSTypeAnnotation") && _3.typeAnnotation.type === "FunctionTypeAnnotation" && !_3.static && !m3(_3, _3.typeAnnotation);
        }
        var R3 = J3(["BinaryExpression", "LogicalExpression", "NGPipeExpression"]);
        function O3(_3) {
          return fe2(_3) || _3.type === "BindExpression" && !!_3.object;
        }
        var Z3 = /* @__PURE__ */ new Set(["AnyTypeAnnotation", "TSAnyKeyword", "NullLiteralTypeAnnotation", "TSNullKeyword", "ThisTypeAnnotation", "TSThisType", "NumberTypeAnnotation", "TSNumberKeyword", "VoidTypeAnnotation", "TSVoidKeyword", "BooleanTypeAnnotation", "TSBooleanKeyword", "BigIntTypeAnnotation", "TSBigIntKeyword", "SymbolTypeAnnotation", "TSSymbolKeyword", "StringTypeAnnotation", "TSStringKeyword", "BooleanLiteralTypeAnnotation", "StringLiteralTypeAnnotation", "BigIntLiteralTypeAnnotation", "NumberLiteralTypeAnnotation", "TSLiteralType", "TSTemplateLiteralType", "EmptyTypeAnnotation", "MixedTypeAnnotation", "TSNeverKeyword", "TSObjectKeyword", "TSUndefinedKeyword", "TSUnknownKeyword"]);
        function ie2(_3) {
          return _3 ? !!((_3.type === "GenericTypeAnnotation" || _3.type === "TSTypeReference") && !_3.typeParameters || Z3.has(_3.type)) : false;
        }
        function te2(_3) {
          let Ee2 = /^(?:before|after)(?:Each|All)$/;
          return _3.callee.type === "Identifier" && Ee2.test(_3.callee.name) && _3.arguments.length === 1;
        }
        var ge2 = ["it", "it.only", "it.skip", "describe", "describe.only", "describe.skip", "test", "test.only", "test.skip", "test.step", "test.describe", "test.describe.only", "test.describe.parallel", "test.describe.parallel.only", "test.describe.serial", "test.describe.serial.only", "skip", "xit", "xdescribe", "xtest", "fit", "fdescribe", "ftest"];
        function q3(_3) {
          return p3(_3, ge2);
        }
        function z3(_3, Ee2) {
          if (_3.type !== "CallExpression")
            return false;
          if (_3.arguments.length === 1) {
            if (I3(_3) && Ee2 && z3(Ee2))
              return b3(_3.arguments[0]);
            if (te2(_3))
              return I3(_3.arguments[0]);
          } else if ((_3.arguments.length === 2 || _3.arguments.length === 3) && (_3.arguments[0].type === "TemplateLiteral" || E3(_3.arguments[0])) && q3(_3.callee))
            return _3.arguments[2] && !i(_3.arguments[2]) ? false : (_3.arguments.length === 2 ? b3(_3.arguments[1]) : B3(_3.arguments[1]) && xe2(_3.arguments[1]).length <= 1) || I3(_3.arguments[1]);
          return false;
        }
        var De2 = J3(["CallExpression", "OptionalCallExpression"]), fe2 = J3(["MemberExpression", "OptionalMemberExpression"]);
        function we2(_3) {
          let Ee2 = "expressions";
          _3.type === "TSTemplateLiteralType" && (Ee2 = "types");
          let qe2 = _3[Ee2];
          return qe2.length === 0 ? false : qe2.every((st2) => {
            if (Ye2(st2))
              return false;
            if (st2.type === "Identifier" || st2.type === "ThisExpression")
              return true;
            if (fe2(st2)) {
              let ot2 = st2;
              for (; fe2(ot2); )
                if (ot2.property.type !== "Identifier" && ot2.property.type !== "Literal" && ot2.property.type !== "StringLiteral" && ot2.property.type !== "NumericLiteral" || (ot2 = ot2.object, Ye2(ot2)))
                  return false;
              return ot2.type === "Identifier" || ot2.type === "ThisExpression";
            }
            return false;
          });
        }
        function Q3(_3, Ee2) {
          return _3 === "+" || _3 === "-" ? _3 + Ee2 : Ee2;
        }
        function W3(_3, Ee2) {
          let qe2 = c3(Ee2), st2 = e28(_3, h3(Ee2));
          return st2 !== false && _3.slice(qe2, qe2 + 2) === "/*" && _3.slice(st2, st2 + 2) === "*/";
        }
        function ne2(_3, Ee2) {
          return M3(Ee2) ? et2(Ee2) : Ye2(Ee2, Oe2.Leading, (qe2) => a3(_3, h3(qe2)));
        }
        function re2(_3, Ee2) {
          return Ee2.parser !== "json" && E3(_3.key) && le2(_3.key).slice(1, -1) === _3.key.value && (t3(_3.key.value) && !(Ee2.parser === "babel-ts" && _3.type === "ClassProperty" || Ee2.parser === "typescript" && _3.type === "PropertyDefinition") || he2(_3.key.value) && String(Number(_3.key.value)) === _3.key.value && (Ee2.parser === "babel" || Ee2.parser === "acorn" || Ee2.parser === "espree" || Ee2.parser === "meriyah" || Ee2.parser === "__babel_estree"));
        }
        function he2(_3) {
          return /^(?:\d+|\d+\.\d+)$/.test(_3);
        }
        function Fe2(_3, Ee2) {
          let qe2 = /^[fx]?(?:describe|it|test)$/;
          return Ee2.type === "TaggedTemplateExpression" && Ee2.quasi === _3 && Ee2.tag.type === "MemberExpression" && Ee2.tag.property.type === "Identifier" && Ee2.tag.property.name === "each" && (Ee2.tag.object.type === "Identifier" && qe2.test(Ee2.tag.object.name) || Ee2.tag.object.type === "MemberExpression" && Ee2.tag.object.property.type === "Identifier" && (Ee2.tag.object.property.name === "only" || Ee2.tag.object.property.name === "skip") && Ee2.tag.object.object.type === "Identifier" && qe2.test(Ee2.tag.object.object.name));
        }
        function ve2(_3) {
          return _3.quasis.some((Ee2) => Ee2.value.raw.includes(`
`));
        }
        function Re2(_3, Ee2) {
          return (_3.type === "TemplateLiteral" && ve2(_3) || _3.type === "TaggedTemplateExpression" && ve2(_3.quasi)) && !a3(Ee2, c3(_3), { backwards: true });
        }
        function tt2(_3) {
          if (!Ye2(_3))
            return false;
          let Ee2 = s3(pe2(_3, Oe2.Dangling));
          return Ee2 && !y3(Ee2);
        }
        function Ze2(_3) {
          if (_3.length <= 1)
            return false;
          let Ee2 = 0;
          for (let qe2 of _3)
            if (b3(qe2)) {
              if (Ee2 += 1, Ee2 > 1)
                return true;
            } else if (De2(qe2)) {
              for (let st2 of qe2.arguments)
                if (b3(st2))
                  return true;
            }
          return false;
        }
        function $e2(_3) {
          let Ee2 = _3.getValue(), qe2 = _3.getParentNode();
          return De2(Ee2) && De2(qe2) && qe2.callee === Ee2 && Ee2.arguments.length > qe2.arguments.length && qe2.arguments.length > 0;
        }
        function Ge2(_3, Ee2) {
          if (Ee2 >= 2)
            return false;
          let qe2 = (gt2) => Ge2(gt2, Ee2 + 1), st2 = _3.type === "Literal" && "regex" in _3 && _3.regex.pattern || _3.type === "RegExpLiteral" && _3.pattern;
          if (st2 && o3(st2) > 5)
            return false;
          if (_3.type === "Literal" || _3.type === "BigIntLiteral" || _3.type === "DecimalLiteral" || _3.type === "BooleanLiteral" || _3.type === "NullLiteral" || _3.type === "NumericLiteral" || _3.type === "RegExpLiteral" || _3.type === "StringLiteral" || _3.type === "Identifier" || _3.type === "ThisExpression" || _3.type === "Super" || _3.type === "PrivateName" || _3.type === "PrivateIdentifier" || _3.type === "ArgumentPlaceholder" || _3.type === "Import")
            return true;
          if (_3.type === "TemplateLiteral")
            return _3.quasis.every((gt2) => !gt2.value.raw.includes(`
`)) && _3.expressions.every(qe2);
          if (_3.type === "ObjectExpression")
            return _3.properties.every((gt2) => !gt2.computed && (gt2.shorthand || gt2.value && qe2(gt2.value)));
          if (_3.type === "ArrayExpression")
            return _3.elements.every((gt2) => gt2 === null || qe2(gt2));
          if (Ft2(_3))
            return (_3.type === "ImportExpression" || Ge2(_3.callee, Ee2)) && ft2(_3).every(qe2);
          if (fe2(_3))
            return Ge2(_3.object, Ee2) && Ge2(_3.property, Ee2);
          let ot2 = { "!": true, "-": true, "+": true, "~": true };
          if (_3.type === "UnaryExpression" && ot2[_3.operator])
            return Ge2(_3.argument, Ee2);
          let St2 = { "++": true, "--": true };
          return _3.type === "UpdateExpression" && St2[_3.operator] ? Ge2(_3.argument, Ee2) : _3.type === "TSNonNullExpression" ? Ge2(_3.expression, Ee2) : false;
        }
        function le2(_3) {
          var Ee2, qe2;
          return (Ee2 = (qe2 = _3.extra) === null || qe2 === void 0 ? void 0 : qe2.raw) !== null && Ee2 !== void 0 ? Ee2 : _3.raw;
        }
        function G3(_3) {
          return _3;
        }
        function me2(_3) {
          return _3.filepath && /\.tsx$/i.test(_3.filepath);
        }
        function K3(_3) {
          let Ee2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "es5";
          return _3.trailingComma === "es5" && Ee2 === "es5" || _3.trailingComma === "all" && (Ee2 === "all" || Ee2 === "es5");
        }
        function de2(_3, Ee2) {
          switch (_3.type) {
            case "BinaryExpression":
            case "LogicalExpression":
            case "AssignmentExpression":
            case "NGPipeExpression":
              return de2(_3.left, Ee2);
            case "MemberExpression":
            case "OptionalMemberExpression":
              return de2(_3.object, Ee2);
            case "TaggedTemplateExpression":
              return _3.tag.type === "FunctionExpression" ? false : de2(_3.tag, Ee2);
            case "CallExpression":
            case "OptionalCallExpression":
              return _3.callee.type === "FunctionExpression" ? false : de2(_3.callee, Ee2);
            case "ConditionalExpression":
              return de2(_3.test, Ee2);
            case "UpdateExpression":
              return !_3.prefix && de2(_3.argument, Ee2);
            case "BindExpression":
              return _3.object && de2(_3.object, Ee2);
            case "SequenceExpression":
              return de2(_3.expressions[0], Ee2);
            case "TSSatisfiesExpression":
            case "TSAsExpression":
            case "TSNonNullExpression":
              return de2(_3.expression, Ee2);
            default:
              return Ee2(_3);
          }
        }
        var je2 = { "==": true, "!=": true, "===": true, "!==": true }, Be2 = { "*": true, "/": true, "%": true }, ye2 = { ">>": true, ">>>": true, "<<": true };
        function v3(_3, Ee2) {
          return !(ae2(Ee2) !== ae2(_3) || _3 === "**" || je2[_3] && je2[Ee2] || Ee2 === "%" && Be2[_3] || _3 === "%" && Be2[Ee2] || Ee2 !== _3 && Be2[Ee2] && Be2[_3] || ye2[_3] && ye2[Ee2]);
        }
        var Y3 = new Map([["|>"], ["??"], ["||"], ["&&"], ["|"], ["^"], ["&"], ["==", "===", "!=", "!=="], ["<", ">", "<=", ">=", "in", "instanceof"], [">>", "<<", ">>>"], ["+", "-"], ["*", "/", "%"], ["**"]].flatMap((_3, Ee2) => _3.map((qe2) => [qe2, Ee2])));
        function ae2(_3) {
          return Y3.get(_3);
        }
        function Ae2(_3) {
          return !!ye2[_3] || _3 === "|" || _3 === "^" || _3 === "&";
        }
        function Se2(_3) {
          var Ee2;
          if (_3.rest)
            return true;
          let qe2 = xe2(_3);
          return ((Ee2 = s3(qe2)) === null || Ee2 === void 0 ? void 0 : Ee2.type) === "RestElement";
        }
        var Me2 = /* @__PURE__ */ new WeakMap();
        function xe2(_3) {
          if (Me2.has(_3))
            return Me2.get(_3);
          let Ee2 = [];
          return _3.this && Ee2.push(_3.this), Array.isArray(_3.parameters) ? Ee2.push(..._3.parameters) : Array.isArray(_3.params) && Ee2.push(..._3.params), _3.rest && Ee2.push(_3.rest), Me2.set(_3, Ee2), Ee2;
        }
        function mt2(_3, Ee2) {
          let qe2 = _3.getValue(), st2 = 0, ot2 = (St2) => Ee2(St2, st2++);
          qe2.this && _3.call(ot2, "this"), Array.isArray(qe2.parameters) ? _3.each(ot2, "parameters") : Array.isArray(qe2.params) && _3.each(ot2, "params"), qe2.rest && _3.call(ot2, "rest");
        }
        var _e2 = /* @__PURE__ */ new WeakMap();
        function ft2(_3) {
          if (_e2.has(_3))
            return _e2.get(_3);
          let Ee2 = _3.arguments;
          return _3.type === "ImportExpression" && (Ee2 = [_3.source], _3.attributes && Ee2.push(_3.attributes)), _e2.set(_3, Ee2), Ee2;
        }
        function Le2(_3, Ee2) {
          let qe2 = _3.getValue();
          qe2.type === "ImportExpression" ? (_3.call((st2) => Ee2(st2, 0), "source"), qe2.attributes && _3.call((st2) => Ee2(st2, 1), "attributes")) : _3.each(Ee2, "arguments");
        }
        function Ue2(_3) {
          return _3.value.trim() === "prettier-ignore" && !_3.unignore;
        }
        function et2(_3) {
          return _3 && (_3.prettierIgnore || Ye2(_3, Oe2.PrettierIgnore));
        }
        function ct2(_3) {
          let Ee2 = _3.getValue();
          return et2(Ee2);
        }
        var Oe2 = { Leading: 2, Trailing: 4, Dangling: 8, Block: 16, Line: 32, PrettierIgnore: 64, First: 128, Last: 256 }, He2 = (_3, Ee2) => {
          if (typeof _3 == "function" && (Ee2 = _3, _3 = 0), _3 || Ee2)
            return (qe2, st2, ot2) => !(_3 & Oe2.Leading && !qe2.leading || _3 & Oe2.Trailing && !qe2.trailing || _3 & Oe2.Dangling && (qe2.leading || qe2.trailing) || _3 & Oe2.Block && !y3(qe2) || _3 & Oe2.Line && !f3(qe2) || _3 & Oe2.First && st2 !== 0 || _3 & Oe2.Last && st2 !== ot2.length - 1 || _3 & Oe2.PrettierIgnore && !Ue2(qe2) || Ee2 && !Ee2(qe2));
        };
        function Ye2(_3, Ee2, qe2) {
          if (!n3(_3 == null ? void 0 : _3.comments))
            return false;
          let st2 = He2(Ee2, qe2);
          return st2 ? _3.comments.some(st2) : true;
        }
        function pe2(_3, Ee2, qe2) {
          if (!Array.isArray(_3 == null ? void 0 : _3.comments))
            return [];
          let st2 = He2(Ee2, qe2);
          return st2 ? _3.comments.filter(st2) : _3.comments;
        }
        var Bt2 = (_3, Ee2) => {
          let { originalText: qe2 } = Ee2;
          return r3(qe2, h3(_3));
        };
        function Ft2(_3) {
          return De2(_3) || _3.type === "NewExpression" || _3.type === "ImportExpression";
        }
        function ut2(_3) {
          return _3 && (_3.type === "ObjectProperty" || _3.type === "Property" && !_3.method && _3.kind === "init");
        }
        function it2(_3) {
          return !!_3.__isUsingHackPipeline;
        }
        var dt2 = Symbol("ifWithoutBlockAndSameLineComment");
        function wt2(_3) {
          return _3.type === "TSAsExpression" || _3.type === "TSSatisfiesExpression";
        }
        l3.exports = { getFunctionParameters: xe2, iterateFunctionParametersPath: mt2, getCallArguments: ft2, iterateCallArgumentsPath: Le2, hasRestParameter: Se2, getLeftSide: j3, getLeftSidePathName: k3, getParentExportDeclaration: D3, getTypeScriptMappedTypeModifier: Q3, hasFlowAnnotationComment: A3, hasFlowShorthandAnnotationComment: P3, hasLeadingOwnLineComment: ne2, hasNakedLeftSide: S3, hasNode: N3, hasIgnoreComment: ct2, hasNodeIgnoreComment: et2, identity: G3, isBinaryish: R3, isCallLikeExpression: Ft2, isEnabledHackPipeline: it2, isLineComment: f3, isPrettierIgnoreComment: Ue2, isCallExpression: De2, isMemberExpression: fe2, isExportDeclaration: T3, isFlowAnnotationComment: W3, isFunctionCompositionArgs: Ze2, isFunctionNotation: U3, isFunctionOrArrowExpression: b3, isGetterOrSetter: $3, isJestEachTemplateLiteral: Fe2, isJsxNode: M3, isLiteral: F3, isLongCurriedCallExpression: $e2, isSimpleCallArgument: Ge2, isMemberish: O3, isNumericLiteral: i, isSignedNumericLiteral: g3, isObjectProperty: ut2, isObjectType: x3, isObjectTypePropertyAFunction: L3, isSimpleType: ie2, isSimpleNumber: he2, isSimpleTemplateLiteral: we2, isStringLiteral: E3, isStringPropSafeToUnquote: re2, isTemplateOnItsOwnLine: Re2, isTestCall: z3, isTheOnlyJsxElementInMarkdown: V10, isTSXFile: me2, isTypeAnnotationAFunction: ee2, isNextLineEmpty: Bt2, needsHardlineAfterDanglingComment: tt2, rawText: le2, shouldPrintComma: K3, isBitwiseOperator: Ae2, shouldFlatten: v3, startsWithNoLookaheadToken: de2, getPrecedence: ae2, hasComment: Ye2, getComments: pe2, CommentCheckFlags: Oe2, markerForIfWithoutBlockAndSameLineComment: dt2, isTSTypeExpression: wt2 };
      } }), Ht2 = X3({ "src/language-js/print/template-literal.js"(u3, l3) {
        H3();
        var t3 = Ct2(), { getStringWidth: s3, getIndentSize: a3 } = at2(), { builders: { join: e28, hardline: n3, softline: r3, group: o3, indent: c3, align: h3, lineSuffixBoundary: m3, addAlignmentToDoc: y3 }, printer: { printDocToString: p3 }, utils: { mapDoc: d3 } } = Qe2(), { isBinaryish: C3, isJestEachTemplateLiteral: w3, isSimpleTemplateLiteral: P3, hasComment: A3, isMemberExpression: N3, isTSTypeExpression: S3 } = Dt2();
        function j3(F3, i, g3) {
          let E3 = F3.getValue();
          if (E3.type === "TemplateLiteral" && w3(E3, F3.getParentNode())) {
            let M3 = k3(F3, g3, i);
            if (M3)
              return M3;
          }
          let x3 = "expressions";
          E3.type === "TSTemplateLiteralType" && (x3 = "types");
          let b3 = [], B3 = F3.map(i, x3), I3 = P3(E3);
          return I3 && (B3 = B3.map((M3) => p3(M3, Object.assign(Object.assign({}, g3), {}, { printWidth: Number.POSITIVE_INFINITY })).formatted)), b3.push(m3, "`"), F3.each((M3) => {
            let V10 = M3.getName();
            if (b3.push(i()), V10 < B3.length) {
              let { tabWidth: $3 } = g3, U3 = M3.getValue(), L3 = a3(U3.value.raw, $3), ee2 = B3[V10];
              if (!I3) {
                let O3 = E3[x3][V10];
                (A3(O3) || N3(O3) || O3.type === "ConditionalExpression" || O3.type === "SequenceExpression" || S3(O3) || C3(O3)) && (ee2 = [c3([r3, ee2]), r3]);
              }
              let R3 = L3 === 0 && U3.value.raw.endsWith(`
`) ? h3(Number.NEGATIVE_INFINITY, ee2) : y3(ee2, L3, $3);
              b3.push(o3(["${", R3, m3, "}"]));
            }
          }, "quasis"), b3.push("`"), b3;
        }
        function k3(F3, i, g3) {
          let E3 = F3.getNode(), x3 = E3.quasis[0].value.raw.trim().split(/\s*\|\s*/);
          if (x3.length > 1 || x3.some((b3) => b3.length > 0)) {
            i.__inJestEach = true;
            let b3 = F3.map(g3, "expressions");
            i.__inJestEach = false;
            let B3 = [], I3 = b3.map((L3) => "${" + p3(L3, Object.assign(Object.assign({}, i), {}, { printWidth: Number.POSITIVE_INFINITY, endOfLine: "lf" })).formatted + "}"), M3 = [{ hasLineBreak: false, cells: [] }];
            for (let L3 = 1; L3 < E3.quasis.length; L3++) {
              let ee2 = t3(M3), R3 = I3[L3 - 1];
              ee2.cells.push(R3), R3.includes(`
`) && (ee2.hasLineBreak = true), E3.quasis[L3].value.raw.includes(`
`) && M3.push({ hasLineBreak: false, cells: [] });
            }
            let V10 = Math.max(x3.length, ...M3.map((L3) => L3.cells.length)), $3 = Array.from({ length: V10 }).fill(0), U3 = [{ cells: x3 }, ...M3.filter((L3) => L3.cells.length > 0)];
            for (let { cells: L3 } of U3.filter((ee2) => !ee2.hasLineBreak))
              for (let [ee2, R3] of L3.entries())
                $3[ee2] = Math.max($3[ee2], s3(R3));
            return B3.push(m3, "`", c3([n3, e28(n3, U3.map((L3) => e28(" | ", L3.cells.map((ee2, R3) => L3.hasLineBreak ? ee2 : ee2 + " ".repeat($3[R3] - s3(ee2))))))]), n3, "`"), B3;
          }
        }
        function J3(F3, i) {
          let g3 = F3.getValue(), E3 = i();
          return A3(g3) && (E3 = o3([c3([r3, E3]), r3])), ["${", E3, m3, "}"];
        }
        function f3(F3, i) {
          return F3.map((g3) => J3(g3, i), "expressions");
        }
        function T3(F3, i) {
          return d3(F3, (g3) => typeof g3 == "string" ? i ? g3.replace(/(\\*)`/g, "$1$1\\`") : D3(g3) : g3);
        }
        function D3(F3) {
          return F3.replace(/([\\`]|\${)/g, "\\$1");
        }
        l3.exports = { printTemplateLiteral: j3, printTemplateExpressions: f3, escapeTemplateCharacters: T3, uncookTemplateElementValue: D3 };
      } }), us2 = X3({ "src/language-js/embed/markdown.js"(u3, l3) {
        H3();
        var { builders: { indent: t3, softline: s3, literalline: a3, dedentToRoot: e28 } } = Qe2(), { escapeTemplateCharacters: n3 } = Ht2();
        function r3(c3, h3, m3) {
          let y3 = c3.getValue().quasis[0].value.raw.replace(/((?:\\\\)*)\\`/g, (w3, P3) => "\\".repeat(P3.length / 2) + "`"), p3 = o3(y3), d3 = p3 !== "";
          d3 && (y3 = y3.replace(new RegExp(`^${p3}`, "gm"), ""));
          let C3 = n3(m3(y3, { parser: "markdown", __inJsTemplate: true }, { stripTrailingHardline: true }), true);
          return ["`", d3 ? t3([s3, C3]) : [a3, e28(C3)], s3, "`"];
        }
        function o3(c3) {
          let h3 = c3.match(/^([^\S\n]*)\S/m);
          return h3 === null ? "" : h3[1];
        }
        l3.exports = r3;
      } }), is2 = X3({ "src/language-js/embed/css.js"(u3, l3) {
        H3();
        var { isNonEmptyArray: t3 } = at2(), { builders: { indent: s3, hardline: a3, softline: e28 }, utils: { mapDoc: n3, replaceEndOfLine: r3, cleanDoc: o3 } } = Qe2(), { printTemplateExpressions: c3 } = Ht2();
        function h3(p3, d3, C3) {
          let w3 = p3.getValue(), P3 = w3.quasis.map((k3) => k3.value.raw), A3 = 0, N3 = P3.reduce((k3, J3, f3) => f3 === 0 ? J3 : k3 + "@prettier-placeholder-" + A3++ + "-id" + J3, ""), S3 = C3(N3, { parser: "scss" }, { stripTrailingHardline: true }), j3 = c3(p3, d3);
          return m3(S3, w3, j3);
        }
        function m3(p3, d3, C3) {
          if (d3.quasis.length === 1 && !d3.quasis[0].value.raw.trim())
            return "``";
          let w3 = y3(p3, C3);
          if (!w3)
            throw new Error("Couldn't insert all the expressions");
          return ["`", s3([a3, w3]), e28, "`"];
        }
        function y3(p3, d3) {
          if (!t3(d3))
            return p3;
          let C3 = 0, w3 = n3(o3(p3), (P3) => typeof P3 != "string" || !P3.includes("@prettier-placeholder") ? P3 : P3.split(/@prettier-placeholder-(\d+)-id/).map((A3, N3) => N3 % 2 === 0 ? r3(A3) : (C3++, d3[A3])));
          return d3.length === C3 ? w3 : null;
        }
        l3.exports = h3;
      } }), as2 = X3({ "src/language-js/embed/graphql.js"(u3, l3) {
        H3();
        var { builders: { indent: t3, join: s3, hardline: a3 } } = Qe2(), { escapeTemplateCharacters: e28, printTemplateExpressions: n3 } = Ht2();
        function r3(c3, h3, m3) {
          let y3 = c3.getValue(), p3 = y3.quasis.length;
          if (p3 === 1 && y3.quasis[0].value.raw.trim() === "")
            return "``";
          let d3 = n3(c3, h3), C3 = [];
          for (let w3 = 0; w3 < p3; w3++) {
            let P3 = y3.quasis[w3], A3 = w3 === 0, N3 = w3 === p3 - 1, S3 = P3.value.cooked, j3 = S3.split(`
`), k3 = j3.length, J3 = d3[w3], f3 = k3 > 2 && j3[0].trim() === "" && j3[1].trim() === "", T3 = k3 > 2 && j3[k3 - 1].trim() === "" && j3[k3 - 2].trim() === "", D3 = j3.every((i) => /^\s*(?:#[^\n\r]*)?$/.test(i));
            if (!N3 && /#[^\n\r]*$/.test(j3[k3 - 1]))
              return null;
            let F3 = null;
            D3 ? F3 = o3(j3) : F3 = m3(S3, { parser: "graphql" }, { stripTrailingHardline: true }), F3 ? (F3 = e28(F3, false), !A3 && f3 && C3.push(""), C3.push(F3), !N3 && T3 && C3.push("")) : !A3 && !N3 && f3 && C3.push(""), J3 && C3.push(J3);
          }
          return ["`", t3([a3, s3(a3, C3)]), a3, "`"];
        }
        function o3(c3) {
          let h3 = [], m3 = false, y3 = c3.map((p3) => p3.trim());
          for (let [p3, d3] of y3.entries())
            d3 !== "" && (y3[p3 - 1] === "" && m3 ? h3.push([a3, d3]) : h3.push(d3), m3 = true);
          return h3.length === 0 ? null : s3(a3, h3);
        }
        l3.exports = r3;
      } }), ss2 = X3({ "src/language-js/embed/html.js"(u3, l3) {
        H3();
        var { builders: { indent: t3, line: s3, hardline: a3, group: e28 }, utils: { mapDoc: n3 } } = Qe2(), { printTemplateExpressions: r3, uncookTemplateElementValue: o3 } = Ht2(), c3 = 0;
        function h3(m3, y3, p3, d3, C3) {
          let { parser: w3 } = C3, P3 = m3.getValue(), A3 = c3;
          c3 = c3 + 1 >>> 0;
          let N3 = (g3) => `PRETTIER_HTML_PLACEHOLDER_${g3}_${A3}_IN_JS`, S3 = P3.quasis.map((g3, E3, x3) => E3 === x3.length - 1 ? g3.value.cooked : g3.value.cooked + N3(E3)).join(""), j3 = r3(m3, y3);
          if (j3.length === 0 && S3.trim().length === 0)
            return "``";
          let k3 = new RegExp(N3("(\\d+)"), "g"), J3 = 0, f3 = p3(S3, { parser: w3, __onHtmlRoot(g3) {
            J3 = g3.children.length;
          } }, { stripTrailingHardline: true }), T3 = n3(f3, (g3) => {
            if (typeof g3 != "string")
              return g3;
            let E3 = [], x3 = g3.split(k3);
            for (let b3 = 0; b3 < x3.length; b3++) {
              let B3 = x3[b3];
              if (b3 % 2 === 0) {
                B3 && (B3 = o3(B3), d3.__embeddedInHtml && (B3 = B3.replace(/<\/(script)\b/gi, "<\\/$1")), E3.push(B3));
                continue;
              }
              let I3 = Number(B3);
              E3.push(j3[I3]);
            }
            return E3;
          }), D3 = /^\s/.test(S3) ? " " : "", F3 = /\s$/.test(S3) ? " " : "", i = d3.htmlWhitespaceSensitivity === "ignore" ? a3 : D3 && F3 ? s3 : null;
          return e28(i ? ["`", t3([i, e28(T3)]), i, "`"] : ["`", D3, J3 > 1 ? t3(e28(T3)) : e28(T3), F3, "`"]);
        }
        l3.exports = h3;
      } }), os2 = X3({ "src/language-js/embed.js"(u3, l3) {
        H3();
        var { hasComment: t3, CommentCheckFlags: s3, isObjectProperty: a3 } = Dt2(), e28 = us2(), n3 = is2(), r3 = as2(), o3 = ss2();
        function c3(f3) {
          if (y3(f3) || w3(f3) || P3(f3) || p3(f3))
            return "css";
          if (S3(f3))
            return "graphql";
          if (k3(f3))
            return "html";
          if (d3(f3))
            return "angular";
          if (m3(f3))
            return "markdown";
        }
        function h3(f3, T3, D3, F3) {
          let i = f3.getValue();
          if (i.type !== "TemplateLiteral" || J3(i))
            return;
          let g3 = c3(f3);
          if (g3) {
            if (g3 === "markdown")
              return e28(f3, T3, D3);
            if (g3 === "css")
              return n3(f3, T3, D3);
            if (g3 === "graphql")
              return r3(f3, T3, D3);
            if (g3 === "html" || g3 === "angular")
              return o3(f3, T3, D3, F3, { parser: g3 });
          }
        }
        function m3(f3) {
          let T3 = f3.getValue(), D3 = f3.getParentNode();
          return D3 && D3.type === "TaggedTemplateExpression" && T3.quasis.length === 1 && D3.tag.type === "Identifier" && (D3.tag.name === "md" || D3.tag.name === "markdown");
        }
        function y3(f3) {
          let T3 = f3.getValue(), D3 = f3.getParentNode(), F3 = f3.getParentNode(1);
          return F3 && T3.quasis && D3.type === "JSXExpressionContainer" && F3.type === "JSXElement" && F3.openingElement.name.name === "style" && F3.openingElement.attributes.some((i) => i.name.name === "jsx") || D3 && D3.type === "TaggedTemplateExpression" && D3.tag.type === "Identifier" && D3.tag.name === "css" || D3 && D3.type === "TaggedTemplateExpression" && D3.tag.type === "MemberExpression" && D3.tag.object.name === "css" && (D3.tag.property.name === "global" || D3.tag.property.name === "resolve");
        }
        function p3(f3) {
          return f3.match((T3) => T3.type === "TemplateLiteral", (T3, D3) => T3.type === "ArrayExpression" && D3 === "elements", (T3, D3) => a3(T3) && T3.key.type === "Identifier" && T3.key.name === "styles" && D3 === "value", ...C3);
        }
        function d3(f3) {
          return f3.match((T3) => T3.type === "TemplateLiteral", (T3, D3) => a3(T3) && T3.key.type === "Identifier" && T3.key.name === "template" && D3 === "value", ...C3);
        }
        var C3 = [(f3, T3) => f3.type === "ObjectExpression" && T3 === "properties", (f3, T3) => f3.type === "CallExpression" && f3.callee.type === "Identifier" && f3.callee.name === "Component" && T3 === "arguments", (f3, T3) => f3.type === "Decorator" && T3 === "expression"];
        function w3(f3) {
          let T3 = f3.getParentNode();
          if (!T3 || T3.type !== "TaggedTemplateExpression")
            return false;
          let D3 = T3.tag.type === "ParenthesizedExpression" ? T3.tag.expression : T3.tag;
          switch (D3.type) {
            case "MemberExpression":
              return A3(D3.object) || N3(D3);
            case "CallExpression":
              return A3(D3.callee) || D3.callee.type === "MemberExpression" && (D3.callee.object.type === "MemberExpression" && (A3(D3.callee.object.object) || N3(D3.callee.object)) || D3.callee.object.type === "CallExpression" && A3(D3.callee.object.callee));
            case "Identifier":
              return D3.name === "css";
            default:
              return false;
          }
        }
        function P3(f3) {
          let T3 = f3.getParentNode(), D3 = f3.getParentNode(1);
          return D3 && T3.type === "JSXExpressionContainer" && D3.type === "JSXAttribute" && D3.name.type === "JSXIdentifier" && D3.name.name === "css";
        }
        function A3(f3) {
          return f3.type === "Identifier" && f3.name === "styled";
        }
        function N3(f3) {
          return /^[A-Z]/.test(f3.object.name) && f3.property.name === "extend";
        }
        function S3(f3) {
          let T3 = f3.getValue(), D3 = f3.getParentNode();
          return j3(T3, "GraphQL") || D3 && (D3.type === "TaggedTemplateExpression" && (D3.tag.type === "MemberExpression" && D3.tag.object.name === "graphql" && D3.tag.property.name === "experimental" || D3.tag.type === "Identifier" && (D3.tag.name === "gql" || D3.tag.name === "graphql")) || D3.type === "CallExpression" && D3.callee.type === "Identifier" && D3.callee.name === "graphql");
        }
        function j3(f3, T3) {
          return t3(f3, s3.Block | s3.Leading, (D3) => {
            let { value: F3 } = D3;
            return F3 === ` ${T3} `;
          });
        }
        function k3(f3) {
          return j3(f3.getValue(), "HTML") || f3.match((T3) => T3.type === "TemplateLiteral", (T3, D3) => T3.type === "TaggedTemplateExpression" && T3.tag.type === "Identifier" && T3.tag.name === "html" && D3 === "quasi");
        }
        function J3(f3) {
          let { quasis: T3 } = f3;
          return T3.some((D3) => {
            let { value: { cooked: F3 } } = D3;
            return F3 === null;
          });
        }
        l3.exports = h3;
      } }), ls2 = X3({ "src/language-js/clean.js"(u3, l3) {
        H3();
        var t3 = Wt2(), s3 = /* @__PURE__ */ new Set(["range", "raw", "comments", "leadingComments", "trailingComments", "innerComments", "extra", "start", "end", "loc", "flags", "errors", "tokens"]), a3 = (n3) => {
          for (let r3 of n3.quasis)
            delete r3.value;
        };
        function e28(n3, r3, o3) {
          if (n3.type === "Program" && delete r3.sourceType, (n3.type === "BigIntLiteral" || n3.type === "BigIntLiteralTypeAnnotation") && r3.value && (r3.value = r3.value.toLowerCase()), (n3.type === "BigIntLiteral" || n3.type === "Literal") && r3.bigint && (r3.bigint = r3.bigint.toLowerCase()), n3.type === "DecimalLiteral" && (r3.value = Number(r3.value)), n3.type === "Literal" && r3.decimal && (r3.decimal = Number(r3.decimal)), n3.type === "EmptyStatement" || n3.type === "JSXText" || n3.type === "JSXExpressionContainer" && (n3.expression.type === "Literal" || n3.expression.type === "StringLiteral") && n3.expression.value === " ")
            return null;
          if ((n3.type === "Property" || n3.type === "ObjectProperty" || n3.type === "MethodDefinition" || n3.type === "ClassProperty" || n3.type === "ClassMethod" || n3.type === "PropertyDefinition" || n3.type === "TSDeclareMethod" || n3.type === "TSPropertySignature" || n3.type === "ObjectTypeProperty") && typeof n3.key == "object" && n3.key && (n3.key.type === "Literal" || n3.key.type === "NumericLiteral" || n3.key.type === "StringLiteral" || n3.key.type === "Identifier") && delete r3.key, n3.type === "JSXElement" && n3.openingElement.name.name === "style" && n3.openingElement.attributes.some((m3) => m3.name.name === "jsx"))
            for (let { type: m3, expression: y3 } of r3.children)
              m3 === "JSXExpressionContainer" && y3.type === "TemplateLiteral" && a3(y3);
          n3.type === "JSXAttribute" && n3.name.name === "css" && n3.value.type === "JSXExpressionContainer" && n3.value.expression.type === "TemplateLiteral" && a3(r3.value.expression), n3.type === "JSXAttribute" && n3.value && n3.value.type === "Literal" && /["']|&quot;|&apos;/.test(n3.value.value) && (r3.value.value = r3.value.value.replace(/["']|&quot;|&apos;/g, '"'));
          let c3 = n3.expression || n3.callee;
          if (n3.type === "Decorator" && c3.type === "CallExpression" && c3.callee.name === "Component" && c3.arguments.length === 1) {
            let m3 = n3.expression.arguments[0].properties;
            for (let [y3, p3] of r3.expression.arguments[0].properties.entries())
              switch (m3[y3].key.name) {
                case "styles":
                  p3.value.type === "ArrayExpression" && a3(p3.value.elements[0]);
                  break;
                case "template":
                  p3.value.type === "TemplateLiteral" && a3(p3.value);
                  break;
              }
          }
          if (n3.type === "TaggedTemplateExpression" && (n3.tag.type === "MemberExpression" || n3.tag.type === "Identifier" && (n3.tag.name === "gql" || n3.tag.name === "graphql" || n3.tag.name === "css" || n3.tag.name === "md" || n3.tag.name === "markdown" || n3.tag.name === "html") || n3.tag.type === "CallExpression") && a3(r3.quasi), n3.type === "TemplateLiteral") {
            var h3;
            (!((h3 = n3.leadingComments) === null || h3 === void 0) && h3.some((m3) => t3(m3) && ["GraphQL", "HTML"].some((y3) => m3.value === ` ${y3} `)) || o3.type === "CallExpression" && o3.callee.name === "graphql" || !n3.leadingComments) && a3(r3);
          }
          if (n3.type === "InterpreterDirective" && (r3.value = r3.value.trimEnd()), (n3.type === "TSIntersectionType" || n3.type === "TSUnionType") && n3.types.length === 1)
            return r3.types[0];
        }
        e28.ignoredProperties = s3, l3.exports = e28;
      } }), mu2 = {};
      Ke2(mu2, { EOL: () => or2, arch: () => ps2, cpus: () => Au2, default: () => Tu2, endianness: () => gu2, freemem: () => Cu2, getNetworkInterfaces: () => Su2, hostname: () => yu2, loadavg: () => hu2, networkInterfaces: () => bu2, platform: () => cs2, release: () => xu2, tmpDir: () => ar2, tmpdir: () => sr2, totalmem: () => Fu2, type: () => vu2, uptime: () => Eu2 });
      function gu2() {
        if (typeof kn2 > "u") {
          var u3 = new ArrayBuffer(2), l3 = new Uint8Array(u3), t3 = new Uint16Array(u3);
          if (l3[0] = 1, l3[1] = 2, t3[0] === 258)
            kn2 = "BE";
          else if (t3[0] === 513)
            kn2 = "LE";
          else
            throw new Error("unable to figure out endianess");
        }
        return kn2;
      }
      function yu2() {
        return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
      }
      function hu2() {
        return [];
      }
      function Eu2() {
        return 0;
      }
      function Cu2() {
        return Number.MAX_VALUE;
      }
      function Fu2() {
        return Number.MAX_VALUE;
      }
      function Au2() {
        return [];
      }
      function vu2() {
        return "Browser";
      }
      function xu2() {
        return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
      }
      function bu2() {
      }
      function Su2() {
      }
      function ps2() {
        return "javascript";
      }
      function cs2() {
        return "browser";
      }
      function ar2() {
        return "/tmp";
      }
      var kn2, sr2, or2, Tu2, ds2 = Je2({ "node-modules-polyfills:os"() {
        H3(), sr2 = ar2, or2 = `
`, Tu2 = { EOL: or2, tmpdir: sr2, tmpDir: ar2, networkInterfaces: bu2, getNetworkInterfaces: Su2, release: xu2, type: vu2, cpus: Au2, totalmem: Fu2, freemem: Cu2, uptime: Eu2, loadavg: hu2, hostname: yu2, endianness: gu2 };
      } }), Ds2 = X3({ "node-modules-polyfills-commonjs:os"(u3, l3) {
        H3();
        var t3 = (ds2(), lt2(mu2));
        if (t3 && t3.default) {
          l3.exports = t3.default;
          for (let s3 in t3)
            l3.exports[s3] = t3[s3];
        } else
          t3 && (l3.exports = t3);
      } }), fs2 = X3({ "node_modules/detect-newline/index.js"(u3, l3) {
        H3();
        var t3 = (s3) => {
          if (typeof s3 != "string")
            throw new TypeError("Expected a string");
          let a3 = s3.match(/(?:\r?\n)/g) || [];
          if (a3.length === 0)
            return;
          let e28 = a3.filter((r3) => r3 === `\r
`).length, n3 = a3.length - e28;
          return e28 > n3 ? `\r
` : `
`;
        };
        l3.exports = t3, l3.exports.graceful = (s3) => typeof s3 == "string" && t3(s3) || `
`;
      } }), ms2 = X3({ "node_modules/jest-docblock/build/index.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true }), u3.extract = p3, u3.parse = C3, u3.parseWithComments = w3, u3.print = P3, u3.strip = d3;
        function l3() {
          let N3 = Ds2();
          return l3 = function() {
            return N3;
          }, N3;
        }
        function t3() {
          let N3 = s3(fs2());
          return t3 = function() {
            return N3;
          }, N3;
        }
        function s3(N3) {
          return N3 && N3.__esModule ? N3 : { default: N3 };
        }
        var a3 = /\*\/$/, e28 = /^\/\*\*?/, n3 = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, r3 = /(^|\s+)\/\/([^\r\n]*)/g, o3 = /^(\r?\n)+/, c3 = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, h3 = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, m3 = /(\r?\n|^) *\* ?/g, y3 = [];
        function p3(N3) {
          let S3 = N3.match(n3);
          return S3 ? S3[0].trimLeft() : "";
        }
        function d3(N3) {
          let S3 = N3.match(n3);
          return S3 && S3[0] ? N3.substring(S3[0].length) : N3;
        }
        function C3(N3) {
          return w3(N3).pragmas;
        }
        function w3(N3) {
          let S3 = (0, t3().default)(N3) || l3().EOL;
          N3 = N3.replace(e28, "").replace(a3, "").replace(m3, "$1");
          let j3 = "";
          for (; j3 !== N3; )
            j3 = N3, N3 = N3.replace(c3, `${S3}$1 $2${S3}`);
          N3 = N3.replace(o3, "").trimRight();
          let k3 = /* @__PURE__ */ Object.create(null), J3 = N3.replace(h3, "").replace(o3, "").trimRight(), f3;
          for (; f3 = h3.exec(N3); ) {
            let T3 = f3[2].replace(r3, "");
            typeof k3[f3[1]] == "string" || Array.isArray(k3[f3[1]]) ? k3[f3[1]] = y3.concat(k3[f3[1]], T3) : k3[f3[1]] = T3;
          }
          return { comments: J3, pragmas: k3 };
        }
        function P3(N3) {
          let { comments: S3 = "", pragmas: j3 = {} } = N3, k3 = (0, t3().default)(S3) || l3().EOL, J3 = "/**", f3 = " *", T3 = " */", D3 = Object.keys(j3), F3 = D3.map((g3) => A3(g3, j3[g3])).reduce((g3, E3) => g3.concat(E3), []).map((g3) => `${f3} ${g3}${k3}`).join("");
          if (!S3) {
            if (D3.length === 0)
              return "";
            if (D3.length === 1 && !Array.isArray(j3[D3[0]])) {
              let g3 = j3[D3[0]];
              return `${J3} ${A3(D3[0], g3)[0]}${T3}`;
            }
          }
          let i = S3.split(k3).map((g3) => `${f3} ${g3}`).join(k3) + k3;
          return J3 + k3 + (S3 ? i : "") + (S3 && D3.length ? f3 + k3 : "") + F3 + T3;
        }
        function A3(N3, S3) {
          return y3.concat(S3).map((j3) => `@${N3} ${j3}`.trim());
        }
      } }), gs2 = X3({ "src/language-js/utils/get-shebang.js"(u3, l3) {
        H3();
        function t3(s3) {
          if (!s3.startsWith("#!"))
            return "";
          let a3 = s3.indexOf(`
`);
          return a3 === -1 ? s3 : s3.slice(0, a3);
        }
        l3.exports = t3;
      } }), Bu2 = X3({ "src/language-js/pragma.js"(u3, l3) {
        H3();
        var { parseWithComments: t3, strip: s3, extract: a3, print: e28 } = ms2(), { normalizeEndOfLine: n3 } = $t2(), r3 = gs2();
        function o3(m3) {
          let y3 = r3(m3);
          y3 && (m3 = m3.slice(y3.length + 1));
          let p3 = a3(m3), { pragmas: d3, comments: C3 } = t3(p3);
          return { shebang: y3, text: m3, pragmas: d3, comments: C3 };
        }
        function c3(m3) {
          let y3 = Object.keys(o3(m3).pragmas);
          return y3.includes("prettier") || y3.includes("format");
        }
        function h3(m3) {
          let { shebang: y3, text: p3, pragmas: d3, comments: C3 } = o3(m3), w3 = s3(p3), P3 = e28({ pragmas: Object.assign({ format: "" }, d3), comments: C3.trimStart() });
          return (y3 ? `${y3}
` : "") + n3(P3) + (w3.startsWith(`
`) ? `
` : `

`) + w3;
        }
        l3.exports = { hasPragma: c3, insertPragma: h3 };
      } }), ys2 = X3({ "src/language-js/utils/is-type-cast-comment.js"(u3, l3) {
        H3();
        var t3 = Wt2();
        function s3(a3) {
          return t3(a3) && a3.value[0] === "*" && /@(?:type|satisfies)\b/.test(a3.value);
        }
        l3.exports = s3;
      } }), wu2 = X3({ "src/language-js/comments.js"(u3, l3) {
        H3();
        var { getLast: t3, hasNewline: s3, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: a3, getNextNonSpaceNonCommentCharacter: e28, hasNewlineInRange: n3, addLeadingComment: r3, addTrailingComment: o3, addDanglingComment: c3, getNextNonSpaceNonCommentCharacterIndex: h3, isNonEmptyArray: m3 } = at2(), { getFunctionParameters: y3, isPrettierIgnoreComment: p3, isJsxNode: d3, hasFlowShorthandAnnotationComment: C3, hasFlowAnnotationComment: w3, hasIgnoreComment: P3, isCallLikeExpression: A3, getCallArguments: N3, isCallExpression: S3, isMemberExpression: j3, isObjectProperty: k3, isLineComment: J3, getComments: f3, CommentCheckFlags: T3, markerForIfWithoutBlockAndSameLineComment: D3 } = Dt2(), { locStart: F3, locEnd: i } = vt2(), g3 = Wt2(), E3 = ys2();
        function x3(ye2) {
          return [G3, we2, ee2, $3, U3, L3, ie2, ve2, re2, Fe2, Re2, tt2, ge2, Q3, W3].some((v3) => v3(ye2));
        }
        function b3(ye2) {
          return [V10, we2, R3, Re2, $3, U3, L3, ie2, Q3, ne2, he2, Fe2, Ge2, W3, K3].some((v3) => v3(ye2));
        }
        function B3(ye2) {
          return [G3, $3, U3, O3, fe2, ge2, Fe2, De2, z3, me2, W3, le2].some((v3) => v3(ye2));
        }
        function I3(ye2, v3) {
          let Y3 = (ye2.body || ye2.properties).find((ae2) => {
            let { type: Ae2 } = ae2;
            return Ae2 !== "EmptyStatement";
          });
          Y3 ? r3(Y3, v3) : c3(ye2, v3);
        }
        function M3(ye2, v3) {
          ye2.type === "BlockStatement" ? I3(ye2, v3) : r3(ye2, v3);
        }
        function V10(ye2) {
          let { comment: v3, followingNode: Y3 } = ye2;
          return Y3 && E3(v3) ? (r3(Y3, v3), true) : false;
        }
        function $3(ye2) {
          let { comment: v3, precedingNode: Y3, enclosingNode: ae2, followingNode: Ae2, text: Se2 } = ye2;
          if ((ae2 == null ? void 0 : ae2.type) !== "IfStatement" || !Ae2)
            return false;
          if (e28(Se2, v3, i) === ")")
            return o3(Y3, v3), true;
          if (Y3 === ae2.consequent && Ae2 === ae2.alternate) {
            if (Y3.type === "BlockStatement")
              o3(Y3, v3);
            else {
              let Me2 = v3.type === "SingleLine" || v3.loc.start.line === v3.loc.end.line, xe2 = v3.loc.start.line === Y3.loc.start.line;
              Me2 && xe2 ? c3(Y3, v3, D3) : c3(ae2, v3);
            }
            return true;
          }
          return Ae2.type === "BlockStatement" ? (I3(Ae2, v3), true) : Ae2.type === "IfStatement" ? (M3(Ae2.consequent, v3), true) : ae2.consequent === Ae2 ? (r3(Ae2, v3), true) : false;
        }
        function U3(ye2) {
          let { comment: v3, precedingNode: Y3, enclosingNode: ae2, followingNode: Ae2, text: Se2 } = ye2;
          return (ae2 == null ? void 0 : ae2.type) !== "WhileStatement" || !Ae2 ? false : e28(Se2, v3, i) === ")" ? (o3(Y3, v3), true) : Ae2.type === "BlockStatement" ? (I3(Ae2, v3), true) : ae2.body === Ae2 ? (r3(Ae2, v3), true) : false;
        }
        function L3(ye2) {
          let { comment: v3, precedingNode: Y3, enclosingNode: ae2, followingNode: Ae2 } = ye2;
          return (ae2 == null ? void 0 : ae2.type) !== "TryStatement" && (ae2 == null ? void 0 : ae2.type) !== "CatchClause" || !Ae2 ? false : ae2.type === "CatchClause" && Y3 ? (o3(Y3, v3), true) : Ae2.type === "BlockStatement" ? (I3(Ae2, v3), true) : Ae2.type === "TryStatement" ? (M3(Ae2.finalizer, v3), true) : Ae2.type === "CatchClause" ? (M3(Ae2.body, v3), true) : false;
        }
        function ee2(ye2) {
          let { comment: v3, enclosingNode: Y3, followingNode: ae2 } = ye2;
          return j3(Y3) && (ae2 == null ? void 0 : ae2.type) === "Identifier" ? (r3(Y3, v3), true) : false;
        }
        function R3(ye2) {
          let { comment: v3, precedingNode: Y3, enclosingNode: ae2, followingNode: Ae2, text: Se2 } = ye2, Me2 = Y3 && !n3(Se2, i(Y3), F3(v3));
          return (!Y3 || !Me2) && ((ae2 == null ? void 0 : ae2.type) === "ConditionalExpression" || (ae2 == null ? void 0 : ae2.type) === "TSConditionalType") && Ae2 ? (r3(Ae2, v3), true) : false;
        }
        function O3(ye2) {
          let { comment: v3, precedingNode: Y3, enclosingNode: ae2 } = ye2;
          return k3(ae2) && ae2.shorthand && ae2.key === Y3 && ae2.value.type === "AssignmentPattern" ? (o3(ae2.value.left, v3), true) : false;
        }
        var Z3 = /* @__PURE__ */ new Set(["ClassDeclaration", "ClassExpression", "DeclareClass", "DeclareInterface", "InterfaceDeclaration", "TSInterfaceDeclaration"]);
        function ie2(ye2) {
          let { comment: v3, precedingNode: Y3, enclosingNode: ae2, followingNode: Ae2 } = ye2;
          if (Z3.has(ae2 == null ? void 0 : ae2.type)) {
            if (m3(ae2.decorators) && !(Ae2 && Ae2.type === "Decorator"))
              return o3(t3(ae2.decorators), v3), true;
            if (ae2.body && Ae2 === ae2.body)
              return I3(ae2.body, v3), true;
            if (Ae2) {
              if (ae2.superClass && Ae2 === ae2.superClass && Y3 && (Y3 === ae2.id || Y3 === ae2.typeParameters))
                return o3(Y3, v3), true;
              for (let Se2 of ["implements", "extends", "mixins"])
                if (ae2[Se2] && Ae2 === ae2[Se2][0])
                  return Y3 && (Y3 === ae2.id || Y3 === ae2.typeParameters || Y3 === ae2.superClass) ? o3(Y3, v3) : c3(ae2, v3, Se2), true;
            }
          }
          return false;
        }
        var te2 = /* @__PURE__ */ new Set(["ClassMethod", "ClassProperty", "PropertyDefinition", "TSAbstractPropertyDefinition", "TSAbstractMethodDefinition", "TSDeclareMethod", "MethodDefinition", "ClassAccessorProperty", "AccessorProperty", "TSAbstractAccessorProperty"]);
        function ge2(ye2) {
          let { comment: v3, precedingNode: Y3, enclosingNode: ae2, text: Ae2 } = ye2;
          return ae2 && Y3 && e28(Ae2, v3, i) === "(" && (ae2.type === "Property" || ae2.type === "TSDeclareMethod" || ae2.type === "TSAbstractMethodDefinition") && Y3.type === "Identifier" && ae2.key === Y3 && e28(Ae2, Y3, i) !== ":" || (Y3 == null ? void 0 : Y3.type) === "Decorator" && te2.has(ae2 == null ? void 0 : ae2.type) ? (o3(Y3, v3), true) : false;
        }
        var q3 = /* @__PURE__ */ new Set(["FunctionDeclaration", "FunctionExpression", "ClassMethod", "MethodDefinition", "ObjectMethod"]);
        function z3(ye2) {
          let { comment: v3, precedingNode: Y3, enclosingNode: ae2, text: Ae2 } = ye2;
          return e28(Ae2, v3, i) !== "(" ? false : Y3 && q3.has(ae2 == null ? void 0 : ae2.type) ? (o3(Y3, v3), true) : false;
        }
        function De2(ye2) {
          let { comment: v3, enclosingNode: Y3, text: ae2 } = ye2;
          if ((Y3 == null ? void 0 : Y3.type) !== "ArrowFunctionExpression")
            return false;
          let Ae2 = h3(ae2, v3, i);
          return Ae2 !== false && ae2.slice(Ae2, Ae2 + 2) === "=>" ? (c3(Y3, v3), true) : false;
        }
        function fe2(ye2) {
          let { comment: v3, enclosingNode: Y3, text: ae2 } = ye2;
          return e28(ae2, v3, i) !== ")" ? false : Y3 && (de2(Y3) && y3(Y3).length === 0 || A3(Y3) && N3(Y3).length === 0) ? (c3(Y3, v3), true) : ((Y3 == null ? void 0 : Y3.type) === "MethodDefinition" || (Y3 == null ? void 0 : Y3.type) === "TSAbstractMethodDefinition") && y3(Y3.value).length === 0 ? (c3(Y3.value, v3), true) : false;
        }
        function we2(ye2) {
          let { comment: v3, precedingNode: Y3, enclosingNode: ae2, followingNode: Ae2, text: Se2 } = ye2;
          if ((Y3 == null ? void 0 : Y3.type) === "FunctionTypeParam" && (ae2 == null ? void 0 : ae2.type) === "FunctionTypeAnnotation" && (Ae2 == null ? void 0 : Ae2.type) !== "FunctionTypeParam" || ((Y3 == null ? void 0 : Y3.type) === "Identifier" || (Y3 == null ? void 0 : Y3.type) === "AssignmentPattern") && ae2 && de2(ae2) && e28(Se2, v3, i) === ")")
            return o3(Y3, v3), true;
          if ((ae2 == null ? void 0 : ae2.type) === "FunctionDeclaration" && (Ae2 == null ? void 0 : Ae2.type) === "BlockStatement") {
            let Me2 = (() => {
              let xe2 = y3(ae2);
              if (xe2.length > 0)
                return a3(Se2, i(t3(xe2)));
              let mt2 = a3(Se2, i(ae2.id));
              return mt2 !== false && a3(Se2, mt2 + 1);
            })();
            if (F3(v3) > Me2)
              return I3(Ae2, v3), true;
          }
          return false;
        }
        function Q3(ye2) {
          let { comment: v3, enclosingNode: Y3 } = ye2;
          return (Y3 == null ? void 0 : Y3.type) === "LabeledStatement" ? (r3(Y3, v3), true) : false;
        }
        function W3(ye2) {
          let { comment: v3, enclosingNode: Y3 } = ye2;
          return ((Y3 == null ? void 0 : Y3.type) === "ContinueStatement" || (Y3 == null ? void 0 : Y3.type) === "BreakStatement") && !Y3.label ? (o3(Y3, v3), true) : false;
        }
        function ne2(ye2) {
          let { comment: v3, precedingNode: Y3, enclosingNode: ae2 } = ye2;
          return S3(ae2) && Y3 && ae2.callee === Y3 && ae2.arguments.length > 0 ? (r3(ae2.arguments[0], v3), true) : false;
        }
        function re2(ye2) {
          let { comment: v3, precedingNode: Y3, enclosingNode: ae2, followingNode: Ae2 } = ye2;
          return (ae2 == null ? void 0 : ae2.type) === "UnionTypeAnnotation" || (ae2 == null ? void 0 : ae2.type) === "TSUnionType" ? (p3(v3) && (Ae2.prettierIgnore = true, v3.unignore = true), Y3 ? (o3(Y3, v3), true) : false) : (((Ae2 == null ? void 0 : Ae2.type) === "UnionTypeAnnotation" || (Ae2 == null ? void 0 : Ae2.type) === "TSUnionType") && p3(v3) && (Ae2.types[0].prettierIgnore = true, v3.unignore = true), false);
        }
        function he2(ye2) {
          let { comment: v3, enclosingNode: Y3 } = ye2;
          return k3(Y3) ? (r3(Y3, v3), true) : false;
        }
        function Fe2(ye2) {
          let { comment: v3, enclosingNode: Y3, followingNode: ae2, ast: Ae2, isLastComment: Se2 } = ye2;
          return Ae2 && Ae2.body && Ae2.body.length === 0 ? (Se2 ? c3(Ae2, v3) : r3(Ae2, v3), true) : (Y3 == null ? void 0 : Y3.type) === "Program" && (Y3 == null ? void 0 : Y3.body.length) === 0 && !m3(Y3.directives) ? (Se2 ? c3(Y3, v3) : r3(Y3, v3), true) : (ae2 == null ? void 0 : ae2.type) === "Program" && (ae2 == null ? void 0 : ae2.body.length) === 0 && (Y3 == null ? void 0 : Y3.type) === "ModuleExpression" ? (c3(ae2, v3), true) : false;
        }
        function ve2(ye2) {
          let { comment: v3, enclosingNode: Y3 } = ye2;
          return (Y3 == null ? void 0 : Y3.type) === "ForInStatement" || (Y3 == null ? void 0 : Y3.type) === "ForOfStatement" ? (r3(Y3, v3), true) : false;
        }
        function Re2(ye2) {
          let { comment: v3, precedingNode: Y3, enclosingNode: ae2, text: Ae2 } = ye2;
          if ((ae2 == null ? void 0 : ae2.type) === "ImportSpecifier" || (ae2 == null ? void 0 : ae2.type) === "ExportSpecifier")
            return r3(ae2, v3), true;
          let Se2 = (Y3 == null ? void 0 : Y3.type) === "ImportSpecifier" && (ae2 == null ? void 0 : ae2.type) === "ImportDeclaration", Me2 = (Y3 == null ? void 0 : Y3.type) === "ExportSpecifier" && (ae2 == null ? void 0 : ae2.type) === "ExportNamedDeclaration";
          return (Se2 || Me2) && s3(Ae2, i(v3)) ? (o3(Y3, v3), true) : false;
        }
        function tt2(ye2) {
          let { comment: v3, enclosingNode: Y3 } = ye2;
          return (Y3 == null ? void 0 : Y3.type) === "AssignmentPattern" ? (r3(Y3, v3), true) : false;
        }
        var Ze2 = /* @__PURE__ */ new Set(["VariableDeclarator", "AssignmentExpression", "TypeAlias", "TSTypeAliasDeclaration"]), $e2 = /* @__PURE__ */ new Set(["ObjectExpression", "ArrayExpression", "TemplateLiteral", "TaggedTemplateExpression", "ObjectTypeAnnotation", "TSTypeLiteral"]);
        function Ge2(ye2) {
          let { comment: v3, enclosingNode: Y3, followingNode: ae2 } = ye2;
          return Ze2.has(Y3 == null ? void 0 : Y3.type) && ae2 && ($e2.has(ae2.type) || g3(v3)) ? (r3(ae2, v3), true) : false;
        }
        function le2(ye2) {
          let { comment: v3, enclosingNode: Y3, followingNode: ae2, text: Ae2 } = ye2;
          return !ae2 && ((Y3 == null ? void 0 : Y3.type) === "TSMethodSignature" || (Y3 == null ? void 0 : Y3.type) === "TSDeclareFunction" || (Y3 == null ? void 0 : Y3.type) === "TSAbstractMethodDefinition") && e28(Ae2, v3, i) === ";" ? (o3(Y3, v3), true) : false;
        }
        function G3(ye2) {
          let { comment: v3, enclosingNode: Y3, followingNode: ae2 } = ye2;
          if (p3(v3) && (Y3 == null ? void 0 : Y3.type) === "TSMappedType" && (ae2 == null ? void 0 : ae2.type) === "TSTypeParameter" && ae2.constraint)
            return Y3.prettierIgnore = true, v3.unignore = true, true;
        }
        function me2(ye2) {
          let { comment: v3, precedingNode: Y3, enclosingNode: ae2, followingNode: Ae2 } = ye2;
          return (ae2 == null ? void 0 : ae2.type) !== "TSMappedType" ? false : (Ae2 == null ? void 0 : Ae2.type) === "TSTypeParameter" && Ae2.name ? (r3(Ae2.name, v3), true) : (Y3 == null ? void 0 : Y3.type) === "TSTypeParameter" && Y3.constraint ? (o3(Y3.constraint, v3), true) : false;
        }
        function K3(ye2) {
          let { comment: v3, enclosingNode: Y3, followingNode: ae2 } = ye2;
          return !Y3 || Y3.type !== "SwitchCase" || Y3.test || !ae2 || ae2 !== Y3.consequent[0] ? false : (ae2.type === "BlockStatement" && J3(v3) ? I3(ae2, v3) : c3(Y3, v3), true);
        }
        function de2(ye2) {
          return ye2.type === "ArrowFunctionExpression" || ye2.type === "FunctionExpression" || ye2.type === "FunctionDeclaration" || ye2.type === "ObjectMethod" || ye2.type === "ClassMethod" || ye2.type === "TSDeclareFunction" || ye2.type === "TSCallSignatureDeclaration" || ye2.type === "TSConstructSignatureDeclaration" || ye2.type === "TSMethodSignature" || ye2.type === "TSConstructorType" || ye2.type === "TSFunctionType" || ye2.type === "TSDeclareMethod";
        }
        function je2(ye2, v3) {
          if ((v3.parser === "typescript" || v3.parser === "flow" || v3.parser === "acorn" || v3.parser === "espree" || v3.parser === "meriyah" || v3.parser === "__babel_estree") && ye2.type === "MethodDefinition" && ye2.value && ye2.value.type === "FunctionExpression" && y3(ye2.value).length === 0 && !ye2.value.returnType && !m3(ye2.value.typeParameters) && ye2.value.body)
            return [...ye2.decorators || [], ye2.key, ye2.value.body];
        }
        function Be2(ye2) {
          let v3 = ye2.getValue(), Y3 = ye2.getParentNode(), ae2 = (Ae2) => w3(f3(Ae2, T3.Leading)) || w3(f3(Ae2, T3.Trailing));
          return (v3 && (d3(v3) || C3(v3) || S3(Y3) && ae2(v3)) || Y3 && (Y3.type === "JSXSpreadAttribute" || Y3.type === "JSXSpreadChild" || Y3.type === "UnionTypeAnnotation" || Y3.type === "TSUnionType" || (Y3.type === "ClassDeclaration" || Y3.type === "ClassExpression") && Y3.superClass === v3)) && (!P3(ye2) || Y3.type === "UnionTypeAnnotation" || Y3.type === "TSUnionType");
        }
        l3.exports = { handleOwnLineComment: x3, handleEndOfLineComment: b3, handleRemainingComment: B3, getCommentChildNodes: je2, willPrintOwnComments: Be2 };
      } }), Zt2 = X3({ "src/language-js/needs-parens.js"(u3, l3) {
        H3();
        var t3 = Ct2(), s3 = Qn2(), { getFunctionParameters: a3, getLeftSidePathName: e28, hasFlowShorthandAnnotationComment: n3, hasNakedLeftSide: r3, hasNode: o3, isBitwiseOperator: c3, startsWithNoLookaheadToken: h3, shouldFlatten: m3, getPrecedence: y3, isCallExpression: p3, isMemberExpression: d3, isObjectProperty: C3, isTSTypeExpression: w3 } = Dt2();
        function P3(f3, T3) {
          let D3 = f3.getParentNode();
          if (!D3)
            return false;
          let F3 = f3.getName(), i = f3.getNode();
          if (T3.__isInHtmlInterpolation && !T3.bracketSpacing && j3(i) && k3(f3))
            return true;
          if (A3(i))
            return false;
          if (T3.parser !== "flow" && n3(f3.getValue()))
            return true;
          if (i.type === "Identifier") {
            if (i.extra && i.extra.parenthesized && /^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(i.name) || F3 === "left" && (i.name === "async" && !D3.await || i.name === "let") && D3.type === "ForOfStatement")
              return true;
            if (i.name === "let") {
              var g3;
              let x3 = (g3 = f3.findAncestor((b3) => b3.type === "ForOfStatement")) === null || g3 === void 0 ? void 0 : g3.left;
              if (x3 && h3(x3, (b3) => b3 === i))
                return true;
            }
            if (F3 === "object" && i.name === "let" && D3.type === "MemberExpression" && D3.computed && !D3.optional) {
              let x3 = f3.findAncestor((B3) => B3.type === "ExpressionStatement" || B3.type === "ForStatement" || B3.type === "ForInStatement"), b3 = x3 ? x3.type === "ExpressionStatement" ? x3.expression : x3.type === "ForStatement" ? x3.init : x3.left : void 0;
              if (b3 && h3(b3, (B3) => B3 === i))
                return true;
            }
            return false;
          }
          if (i.type === "ObjectExpression" || i.type === "FunctionExpression" || i.type === "ClassExpression" || i.type === "DoExpression") {
            var E3;
            let x3 = (E3 = f3.findAncestor((b3) => b3.type === "ExpressionStatement")) === null || E3 === void 0 ? void 0 : E3.expression;
            if (x3 && h3(x3, (b3) => b3 === i))
              return true;
          }
          switch (D3.type) {
            case "ParenthesizedExpression":
              return false;
            case "ClassDeclaration":
            case "ClassExpression": {
              if (F3 === "superClass" && (i.type === "ArrowFunctionExpression" || i.type === "AssignmentExpression" || i.type === "AwaitExpression" || i.type === "BinaryExpression" || i.type === "ConditionalExpression" || i.type === "LogicalExpression" || i.type === "NewExpression" || i.type === "ObjectExpression" || i.type === "SequenceExpression" || i.type === "TaggedTemplateExpression" || i.type === "UnaryExpression" || i.type === "UpdateExpression" || i.type === "YieldExpression" || i.type === "TSNonNullExpression"))
                return true;
              break;
            }
            case "ExportDefaultDeclaration":
              return J3(f3, T3) || i.type === "SequenceExpression";
            case "Decorator": {
              if (F3 === "expression") {
                if (d3(i) && i.computed)
                  return true;
                let x3 = false, b3 = false, B3 = i;
                for (; B3; )
                  switch (B3.type) {
                    case "MemberExpression":
                      b3 = true, B3 = B3.object;
                      break;
                    case "CallExpression":
                      if (b3 || x3)
                        return T3.parser !== "typescript";
                      x3 = true, B3 = B3.callee;
                      break;
                    case "Identifier":
                      return false;
                    case "TaggedTemplateExpression":
                      return T3.parser !== "typescript";
                    default:
                      return true;
                  }
                return true;
              }
              break;
            }
            case "ArrowFunctionExpression": {
              if (F3 === "body" && i.type !== "SequenceExpression" && h3(i, (x3) => x3.type === "ObjectExpression"))
                return true;
              break;
            }
          }
          switch (i.type) {
            case "UpdateExpression":
              if (D3.type === "UnaryExpression")
                return i.prefix && (i.operator === "++" && D3.operator === "+" || i.operator === "--" && D3.operator === "-");
            case "UnaryExpression":
              switch (D3.type) {
                case "UnaryExpression":
                  return i.operator === D3.operator && (i.operator === "+" || i.operator === "-");
                case "BindExpression":
                  return true;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return F3 === "object";
                case "TaggedTemplateExpression":
                  return true;
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return F3 === "callee";
                case "BinaryExpression":
                  return F3 === "left" && D3.operator === "**";
                case "TSNonNullExpression":
                  return true;
                default:
                  return false;
              }
            case "BinaryExpression": {
              if (D3.type === "UpdateExpression" || i.operator === "in" && N3(f3))
                return true;
              if (i.operator === "|>" && i.extra && i.extra.parenthesized) {
                let x3 = f3.getParentNode(1);
                if (x3.type === "BinaryExpression" && x3.operator === "|>")
                  return true;
              }
            }
            case "TSTypeAssertion":
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "LogicalExpression":
              switch (D3.type) {
                case "TSSatisfiesExpression":
                case "TSAsExpression":
                  return !w3(i);
                case "ConditionalExpression":
                  return w3(i);
                case "CallExpression":
                case "NewExpression":
                case "OptionalCallExpression":
                  return F3 === "callee";
                case "ClassExpression":
                case "ClassDeclaration":
                  return F3 === "superClass";
                case "TSTypeAssertion":
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "JSXSpreadAttribute":
                case "SpreadElement":
                case "SpreadProperty":
                case "BindExpression":
                case "AwaitExpression":
                case "TSNonNullExpression":
                case "UpdateExpression":
                  return true;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return F3 === "object";
                case "AssignmentExpression":
                case "AssignmentPattern":
                  return F3 === "left" && (i.type === "TSTypeAssertion" || w3(i));
                case "LogicalExpression":
                  if (i.type === "LogicalExpression")
                    return D3.operator !== i.operator;
                case "BinaryExpression": {
                  let { operator: x3, type: b3 } = i;
                  if (!x3 && b3 !== "TSTypeAssertion")
                    return true;
                  let B3 = y3(x3), I3 = D3.operator, M3 = y3(I3);
                  return M3 > B3 || F3 === "right" && M3 === B3 || M3 === B3 && !m3(I3, x3) ? true : M3 < B3 && x3 === "%" ? I3 === "+" || I3 === "-" : !!c3(I3);
                }
                default:
                  return false;
              }
            case "SequenceExpression":
              switch (D3.type) {
                case "ReturnStatement":
                  return false;
                case "ForStatement":
                  return false;
                case "ExpressionStatement":
                  return F3 !== "expression";
                case "ArrowFunctionExpression":
                  return F3 !== "body";
                default:
                  return true;
              }
            case "YieldExpression":
              if (D3.type === "UnaryExpression" || D3.type === "AwaitExpression" || w3(D3) || D3.type === "TSNonNullExpression")
                return true;
            case "AwaitExpression":
              switch (D3.type) {
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "LogicalExpression":
                case "SpreadElement":
                case "SpreadProperty":
                case "TSAsExpression":
                case "TSSatisfiesExpression":
                case "TSNonNullExpression":
                case "BindExpression":
                  return true;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return F3 === "object";
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return F3 === "callee";
                case "ConditionalExpression":
                  return F3 === "test";
                case "BinaryExpression":
                  return !(!i.argument && D3.operator === "|>");
                default:
                  return false;
              }
            case "TSConditionalType":
            case "TSFunctionType":
            case "TSConstructorType":
              if (F3 === "extendsType" && D3.type === "TSConditionalType") {
                if (i.type === "TSConditionalType")
                  return true;
                let { typeAnnotation: x3 } = i.returnType || i.typeAnnotation;
                if (x3.type === "TSTypePredicate" && x3.typeAnnotation && (x3 = x3.typeAnnotation.typeAnnotation), x3.type === "TSInferType" && x3.typeParameter.constraint)
                  return true;
              }
              if (F3 === "checkType" && D3.type === "TSConditionalType")
                return true;
            case "TSUnionType":
            case "TSIntersectionType":
              if ((D3.type === "TSUnionType" || D3.type === "TSIntersectionType") && D3.types.length > 1 && (!i.types || i.types.length > 1))
                return true;
            case "TSInferType":
              if (i.type === "TSInferType" && D3.type === "TSRestType")
                return false;
            case "TSTypeOperator":
              return D3.type === "TSArrayType" || D3.type === "TSOptionalType" || D3.type === "TSRestType" || F3 === "objectType" && D3.type === "TSIndexedAccessType" || D3.type === "TSTypeOperator" || D3.type === "TSTypeAnnotation" && f3.getParentNode(1).type.startsWith("TSJSDoc");
            case "TSTypeQuery":
              return F3 === "objectType" && D3.type === "TSIndexedAccessType" || F3 === "elementType" && D3.type === "TSArrayType";
            case "TypeofTypeAnnotation":
              return F3 === "objectType" && (D3.type === "IndexedAccessType" || D3.type === "OptionalIndexedAccessType") || F3 === "elementType" && D3.type === "ArrayTypeAnnotation";
            case "ArrayTypeAnnotation":
              return D3.type === "NullableTypeAnnotation";
            case "IntersectionTypeAnnotation":
            case "UnionTypeAnnotation":
              return D3.type === "ArrayTypeAnnotation" || D3.type === "NullableTypeAnnotation" || D3.type === "IntersectionTypeAnnotation" || D3.type === "UnionTypeAnnotation" || F3 === "objectType" && (D3.type === "IndexedAccessType" || D3.type === "OptionalIndexedAccessType");
            case "NullableTypeAnnotation":
              return D3.type === "ArrayTypeAnnotation" || F3 === "objectType" && (D3.type === "IndexedAccessType" || D3.type === "OptionalIndexedAccessType");
            case "FunctionTypeAnnotation": {
              let x3 = D3.type === "NullableTypeAnnotation" ? f3.getParentNode(1) : D3;
              return x3.type === "UnionTypeAnnotation" || x3.type === "IntersectionTypeAnnotation" || x3.type === "ArrayTypeAnnotation" || F3 === "objectType" && (x3.type === "IndexedAccessType" || x3.type === "OptionalIndexedAccessType") || x3.type === "NullableTypeAnnotation" || D3.type === "FunctionTypeParam" && D3.name === null && a3(i).some((b3) => b3.typeAnnotation && b3.typeAnnotation.type === "NullableTypeAnnotation");
            }
            case "OptionalIndexedAccessType":
              return F3 === "objectType" && D3.type === "IndexedAccessType";
            case "StringLiteral":
            case "NumericLiteral":
            case "Literal":
              if (typeof i.value == "string" && D3.type === "ExpressionStatement" && !D3.directive) {
                let x3 = f3.getParentNode(1);
                return x3.type === "Program" || x3.type === "BlockStatement";
              }
              return F3 === "object" && D3.type === "MemberExpression" && typeof i.value == "number";
            case "AssignmentExpression": {
              let x3 = f3.getParentNode(1);
              return F3 === "body" && D3.type === "ArrowFunctionExpression" ? true : F3 === "key" && (D3.type === "ClassProperty" || D3.type === "PropertyDefinition") && D3.computed || (F3 === "init" || F3 === "update") && D3.type === "ForStatement" ? false : D3.type === "ExpressionStatement" ? i.left.type === "ObjectPattern" : !(F3 === "key" && D3.type === "TSPropertySignature" || D3.type === "AssignmentExpression" || D3.type === "SequenceExpression" && x3 && x3.type === "ForStatement" && (x3.init === D3 || x3.update === D3) || F3 === "value" && D3.type === "Property" && x3 && x3.type === "ObjectPattern" && x3.properties.includes(D3) || D3.type === "NGChainedExpression");
            }
            case "ConditionalExpression":
              switch (D3.type) {
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "SpreadElement":
                case "SpreadProperty":
                case "BinaryExpression":
                case "LogicalExpression":
                case "NGPipeExpression":
                case "ExportDefaultDeclaration":
                case "AwaitExpression":
                case "JSXSpreadAttribute":
                case "TSTypeAssertion":
                case "TypeCastExpression":
                case "TSAsExpression":
                case "TSSatisfiesExpression":
                case "TSNonNullExpression":
                  return true;
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return F3 === "callee";
                case "ConditionalExpression":
                  return F3 === "test";
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return F3 === "object";
                default:
                  return false;
              }
            case "FunctionExpression":
              switch (D3.type) {
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return F3 === "callee";
                case "TaggedTemplateExpression":
                  return true;
                default:
                  return false;
              }
            case "ArrowFunctionExpression":
              switch (D3.type) {
                case "BinaryExpression":
                  return D3.operator !== "|>" || i.extra && i.extra.parenthesized;
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return F3 === "callee";
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return F3 === "object";
                case "TSAsExpression":
                case "TSSatisfiesExpression":
                case "TSNonNullExpression":
                case "BindExpression":
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "LogicalExpression":
                case "AwaitExpression":
                case "TSTypeAssertion":
                  return true;
                case "ConditionalExpression":
                  return F3 === "test";
                default:
                  return false;
              }
            case "ClassExpression":
              if (s3(i.decorators))
                return true;
              switch (D3.type) {
                case "NewExpression":
                  return F3 === "callee";
                default:
                  return false;
              }
            case "OptionalMemberExpression":
            case "OptionalCallExpression": {
              let x3 = f3.getParentNode(1);
              if (F3 === "object" && D3.type === "MemberExpression" || F3 === "callee" && (D3.type === "CallExpression" || D3.type === "NewExpression") || D3.type === "TSNonNullExpression" && x3.type === "MemberExpression" && x3.object === D3)
                return true;
            }
            case "CallExpression":
            case "MemberExpression":
            case "TaggedTemplateExpression":
            case "TSNonNullExpression":
              if (F3 === "callee" && (D3.type === "BindExpression" || D3.type === "NewExpression")) {
                let x3 = i;
                for (; x3; )
                  switch (x3.type) {
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return true;
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                    case "BindExpression":
                      x3 = x3.object;
                      break;
                    case "TaggedTemplateExpression":
                      x3 = x3.tag;
                      break;
                    case "TSNonNullExpression":
                      x3 = x3.expression;
                      break;
                    default:
                      return false;
                  }
              }
              return false;
            case "BindExpression":
              return F3 === "callee" && (D3.type === "BindExpression" || D3.type === "NewExpression") || F3 === "object" && d3(D3);
            case "NGPipeExpression":
              return !(D3.type === "NGRoot" || D3.type === "NGMicrosyntaxExpression" || D3.type === "ObjectProperty" && !(i.extra && i.extra.parenthesized) || D3.type === "ArrayExpression" || p3(D3) && D3.arguments[F3] === i || F3 === "right" && D3.type === "NGPipeExpression" || F3 === "property" && D3.type === "MemberExpression" || D3.type === "AssignmentExpression");
            case "JSXFragment":
            case "JSXElement":
              return F3 === "callee" || F3 === "left" && D3.type === "BinaryExpression" && D3.operator === "<" || D3.type !== "ArrayExpression" && D3.type !== "ArrowFunctionExpression" && D3.type !== "AssignmentExpression" && D3.type !== "AssignmentPattern" && D3.type !== "BinaryExpression" && D3.type !== "NewExpression" && D3.type !== "ConditionalExpression" && D3.type !== "ExpressionStatement" && D3.type !== "JsExpressionRoot" && D3.type !== "JSXAttribute" && D3.type !== "JSXElement" && D3.type !== "JSXExpressionContainer" && D3.type !== "JSXFragment" && D3.type !== "LogicalExpression" && !p3(D3) && !C3(D3) && D3.type !== "ReturnStatement" && D3.type !== "ThrowStatement" && D3.type !== "TypeCastExpression" && D3.type !== "VariableDeclarator" && D3.type !== "YieldExpression";
            case "TypeAnnotation":
              return F3 === "returnType" && D3.type === "ArrowFunctionExpression" && S3(i);
          }
          return false;
        }
        function A3(f3) {
          return f3.type === "BlockStatement" || f3.type === "BreakStatement" || f3.type === "ClassBody" || f3.type === "ClassDeclaration" || f3.type === "ClassMethod" || f3.type === "ClassProperty" || f3.type === "PropertyDefinition" || f3.type === "ClassPrivateProperty" || f3.type === "ContinueStatement" || f3.type === "DebuggerStatement" || f3.type === "DeclareClass" || f3.type === "DeclareExportAllDeclaration" || f3.type === "DeclareExportDeclaration" || f3.type === "DeclareFunction" || f3.type === "DeclareInterface" || f3.type === "DeclareModule" || f3.type === "DeclareModuleExports" || f3.type === "DeclareVariable" || f3.type === "DoWhileStatement" || f3.type === "EnumDeclaration" || f3.type === "ExportAllDeclaration" || f3.type === "ExportDefaultDeclaration" || f3.type === "ExportNamedDeclaration" || f3.type === "ExpressionStatement" || f3.type === "ForInStatement" || f3.type === "ForOfStatement" || f3.type === "ForStatement" || f3.type === "FunctionDeclaration" || f3.type === "IfStatement" || f3.type === "ImportDeclaration" || f3.type === "InterfaceDeclaration" || f3.type === "LabeledStatement" || f3.type === "MethodDefinition" || f3.type === "ReturnStatement" || f3.type === "SwitchStatement" || f3.type === "ThrowStatement" || f3.type === "TryStatement" || f3.type === "TSDeclareFunction" || f3.type === "TSEnumDeclaration" || f3.type === "TSImportEqualsDeclaration" || f3.type === "TSInterfaceDeclaration" || f3.type === "TSModuleDeclaration" || f3.type === "TSNamespaceExportDeclaration" || f3.type === "TypeAlias" || f3.type === "VariableDeclaration" || f3.type === "WhileStatement" || f3.type === "WithStatement";
        }
        function N3(f3) {
          let T3 = 0, D3 = f3.getValue();
          for (; D3; ) {
            let F3 = f3.getParentNode(T3++);
            if (F3 && F3.type === "ForStatement" && F3.init === D3)
              return true;
            D3 = F3;
          }
          return false;
        }
        function S3(f3) {
          return o3(f3, (T3) => T3.type === "ObjectTypeAnnotation" && o3(T3, (D3) => D3.type === "FunctionTypeAnnotation" || void 0) || void 0);
        }
        function j3(f3) {
          switch (f3.type) {
            case "ObjectExpression":
              return true;
            default:
              return false;
          }
        }
        function k3(f3) {
          let T3 = f3.getValue(), D3 = f3.getParentNode(), F3 = f3.getName();
          switch (D3.type) {
            case "NGPipeExpression":
              if (typeof F3 == "number" && D3.arguments[F3] === T3 && D3.arguments.length - 1 === F3)
                return f3.callParent(k3);
              break;
            case "ObjectProperty":
              if (F3 === "value") {
                let i = f3.getParentNode(1);
                return t3(i.properties) === D3;
              }
              break;
            case "BinaryExpression":
            case "LogicalExpression":
              if (F3 === "right")
                return f3.callParent(k3);
              break;
            case "ConditionalExpression":
              if (F3 === "alternate")
                return f3.callParent(k3);
              break;
            case "UnaryExpression":
              if (D3.prefix)
                return f3.callParent(k3);
              break;
          }
          return false;
        }
        function J3(f3, T3) {
          let D3 = f3.getValue(), F3 = f3.getParentNode();
          return D3.type === "FunctionExpression" || D3.type === "ClassExpression" ? F3.type === "ExportDefaultDeclaration" || !P3(f3, T3) : !r3(D3) || F3.type !== "ExportDefaultDeclaration" && P3(f3, T3) ? false : f3.call((i) => J3(i, T3), ...e28(f3, D3));
        }
        l3.exports = P3;
      } }), Nu2 = X3({ "src/language-js/print-preprocess.js"(u3, l3) {
        H3();
        function t3(s3, a3) {
          switch (a3.parser) {
            case "json":
            case "json5":
            case "json-stringify":
            case "__js_expression":
            case "__vue_expression":
            case "__vue_ts_expression":
              return Object.assign(Object.assign({}, s3), {}, { type: a3.parser.startsWith("__") ? "JsExpressionRoot" : "JsonRoot", node: s3, comments: [], rootMarker: a3.rootMarker });
            default:
              return s3;
          }
        }
        l3.exports = t3;
      } }), hs2 = X3({ "src/language-js/print/html-binding.js"(u3, l3) {
        H3();
        var { builders: { join: t3, line: s3, group: a3, softline: e28, indent: n3 } } = Qe2();
        function r3(c3, h3, m3) {
          let y3 = c3.getValue();
          if (h3.__onHtmlBindingRoot && c3.getName() === null && h3.__onHtmlBindingRoot(y3, h3), y3.type === "File") {
            if (h3.__isVueForBindingLeft)
              return c3.call((p3) => {
                let d3 = t3([",", s3], p3.map(m3, "params")), { params: C3 } = p3.getValue();
                return C3.length === 1 ? d3 : ["(", n3([e28, a3(d3)]), e28, ")"];
              }, "program", "body", 0);
            if (h3.__isVueBindings)
              return c3.call((p3) => t3([",", s3], p3.map(m3, "params")), "program", "body", 0);
          }
        }
        function o3(c3) {
          switch (c3.type) {
            case "MemberExpression":
              switch (c3.property.type) {
                case "Identifier":
                case "NumericLiteral":
                case "StringLiteral":
                  return o3(c3.object);
              }
              return false;
            case "Identifier":
              return true;
            default:
              return false;
          }
        }
        l3.exports = { isVueEventBindingExpression: o3, printHtmlBinding: r3 };
      } }), lr2 = X3({ "src/language-js/print/binaryish.js"(u3, l3) {
        H3();
        var { printComments: t3 } = ht2(), { getLast: s3 } = at2(), { builders: { join: a3, line: e28, softline: n3, group: r3, indent: o3, align: c3, indentIfBreak: h3 }, utils: { cleanDoc: m3, getDocParts: y3, isConcat: p3 } } = Qe2(), { hasLeadingOwnLineComment: d3, isBinaryish: C3, isJsxNode: w3, shouldFlatten: P3, hasComment: A3, CommentCheckFlags: N3, isCallExpression: S3, isMemberExpression: j3, isObjectProperty: k3, isEnabledHackPipeline: J3 } = Dt2(), f3 = 0;
        function T3(i, g3, E3) {
          let x3 = i.getValue(), b3 = i.getParentNode(), B3 = i.getParentNode(1), I3 = x3 !== b3.body && (b3.type === "IfStatement" || b3.type === "WhileStatement" || b3.type === "SwitchStatement" || b3.type === "DoWhileStatement"), M3 = J3(g3) && x3.operator === "|>", V10 = D3(i, E3, g3, false, I3);
          if (I3)
            return V10;
          if (M3)
            return r3(V10);
          if (S3(b3) && b3.callee === x3 || b3.type === "UnaryExpression" || j3(b3) && !b3.computed)
            return r3([o3([n3, ...V10]), n3]);
          let $3 = b3.type === "ReturnStatement" || b3.type === "ThrowStatement" || b3.type === "JSXExpressionContainer" && B3.type === "JSXAttribute" || x3.operator !== "|" && b3.type === "JsExpressionRoot" || x3.type !== "NGPipeExpression" && (b3.type === "NGRoot" && g3.parser === "__ng_binding" || b3.type === "NGMicrosyntaxExpression" && B3.type === "NGMicrosyntax" && B3.body.length === 1) || x3 === b3.body && b3.type === "ArrowFunctionExpression" || x3 !== b3.body && b3.type === "ForStatement" || b3.type === "ConditionalExpression" && B3.type !== "ReturnStatement" && B3.type !== "ThrowStatement" && !S3(B3) || b3.type === "TemplateLiteral", U3 = b3.type === "AssignmentExpression" || b3.type === "VariableDeclarator" || b3.type === "ClassProperty" || b3.type === "PropertyDefinition" || b3.type === "TSAbstractPropertyDefinition" || b3.type === "ClassPrivateProperty" || k3(b3), L3 = C3(x3.left) && P3(x3.operator, x3.left.operator);
          if ($3 || F3(x3) && !L3 || !F3(x3) && U3)
            return r3(V10);
          if (V10.length === 0)
            return "";
          let ee2 = w3(x3.right), R3 = V10.findIndex((q3) => typeof q3 != "string" && !Array.isArray(q3) && q3.type === "group"), O3 = V10.slice(0, R3 === -1 ? 1 : R3 + 1), Z3 = V10.slice(O3.length, ee2 ? -1 : void 0), ie2 = Symbol("logicalChain-" + ++f3), te2 = r3([...O3, o3(Z3)], { id: ie2 });
          if (!ee2)
            return te2;
          let ge2 = s3(V10);
          return r3([te2, h3(ge2, { groupId: ie2 })]);
        }
        function D3(i, g3, E3, x3, b3) {
          let B3 = i.getValue();
          if (!C3(B3))
            return [r3(g3())];
          let I3 = [];
          P3(B3.operator, B3.left.operator) ? I3 = i.call((Z3) => D3(Z3, g3, E3, true, b3), "left") : I3.push(r3(g3("left")));
          let M3 = F3(B3), V10 = (B3.operator === "|>" || B3.type === "NGPipeExpression" || B3.operator === "|" && E3.parser === "__vue_expression") && !d3(E3.originalText, B3.right), $3 = B3.type === "NGPipeExpression" ? "|" : B3.operator, U3 = B3.type === "NGPipeExpression" && B3.arguments.length > 0 ? r3(o3([e28, ": ", a3([e28, ": "], i.map(g3, "arguments").map((Z3) => c3(2, r3(Z3))))])) : "", L3;
          if (M3)
            L3 = [$3, " ", g3("right"), U3];
          else {
            let Z3 = J3(E3) && $3 === "|>" ? i.call((ie2) => D3(ie2, g3, E3, true, b3), "right") : g3("right");
            L3 = [V10 ? e28 : "", $3, V10 ? " " : e28, Z3, U3];
          }
          let ee2 = i.getParentNode(), R3 = A3(B3.left, N3.Trailing | N3.Line), O3 = R3 || !(b3 && B3.type === "LogicalExpression") && ee2.type !== B3.type && B3.left.type !== B3.type && B3.right.type !== B3.type;
          if (I3.push(V10 ? "" : " ", O3 ? r3(L3, { shouldBreak: R3 }) : L3), x3 && A3(B3)) {
            let Z3 = m3(t3(i, I3, E3));
            return p3(Z3) || Z3.type === "fill" ? y3(Z3) : [Z3];
          }
          return I3;
        }
        function F3(i) {
          return i.type !== "LogicalExpression" ? false : !!(i.right.type === "ObjectExpression" && i.right.properties.length > 0 || i.right.type === "ArrayExpression" && i.right.elements.length > 0 || w3(i.right));
        }
        l3.exports = { printBinaryishExpression: T3, shouldInlineLogicalExpression: F3 };
      } }), Es2 = X3({ "src/language-js/print/angular.js"(u3, l3) {
        H3();
        var { builders: { join: t3, line: s3, group: a3 } } = Qe2(), { hasNode: e28, hasComment: n3, getComments: r3 } = Dt2(), { printBinaryishExpression: o3 } = lr2();
        function c3(y3, p3, d3) {
          let C3 = y3.getValue();
          if (C3.type.startsWith("NG"))
            switch (C3.type) {
              case "NGRoot":
                return [d3("node"), n3(C3.node) ? " //" + r3(C3.node)[0].value.trimEnd() : ""];
              case "NGPipeExpression":
                return o3(y3, p3, d3);
              case "NGChainedExpression":
                return a3(t3([";", s3], y3.map((w3) => m3(w3) ? d3() : ["(", d3(), ")"], "expressions")));
              case "NGEmptyExpression":
                return "";
              case "NGQuotedExpression":
                return [C3.prefix, ": ", C3.value.trim()];
              case "NGMicrosyntax":
                return y3.map((w3, P3) => [P3 === 0 ? "" : h3(w3.getValue(), P3, C3) ? " " : [";", s3], d3()], "body");
              case "NGMicrosyntaxKey":
                return /^[$_a-z][\w$]*(?:-[$_a-z][\w$])*$/i.test(C3.name) ? C3.name : JSON.stringify(C3.name);
              case "NGMicrosyntaxExpression":
                return [d3("expression"), C3.alias === null ? "" : [" as ", d3("alias")]];
              case "NGMicrosyntaxKeyedExpression": {
                let w3 = y3.getName(), P3 = y3.getParentNode(), A3 = h3(C3, w3, P3) || (w3 === 1 && (C3.key.name === "then" || C3.key.name === "else") || w3 === 2 && C3.key.name === "else" && P3.body[w3 - 1].type === "NGMicrosyntaxKeyedExpression" && P3.body[w3 - 1].key.name === "then") && P3.body[0].type === "NGMicrosyntaxExpression";
                return [d3("key"), A3 ? " " : ": ", d3("expression")];
              }
              case "NGMicrosyntaxLet":
                return ["let ", d3("key"), C3.value === null ? "" : [" = ", d3("value")]];
              case "NGMicrosyntaxAs":
                return [d3("key"), " as ", d3("alias")];
              default:
                throw new Error(`Unknown Angular node type: ${JSON.stringify(C3.type)}.`);
            }
        }
        function h3(y3, p3, d3) {
          return y3.type === "NGMicrosyntaxKeyedExpression" && y3.key.name === "of" && p3 === 1 && d3.body[0].type === "NGMicrosyntaxLet" && d3.body[0].value === null;
        }
        function m3(y3) {
          return e28(y3.getValue(), (p3) => {
            switch (p3.type) {
              case void 0:
                return false;
              case "CallExpression":
              case "OptionalCallExpression":
              case "AssignmentExpression":
                return true;
            }
          });
        }
        l3.exports = { printAngular: c3 };
      } }), Cs2 = X3({ "src/language-js/print/jsx.js"(u3, l3) {
        H3();
        var { printComments: t3, printDanglingComments: s3, printCommentsSeparately: a3 } = ht2(), { builders: { line: e28, hardline: n3, softline: r3, group: o3, indent: c3, conditionalGroup: h3, fill: m3, ifBreak: y3, lineSuffixBoundary: p3, join: d3 }, utils: { willBreak: C3 } } = Qe2(), { getLast: w3, getPreferredQuote: P3 } = at2(), { isJsxNode: A3, rawText: N3, isCallExpression: S3, isStringLiteral: j3, isBinaryish: k3, hasComment: J3, CommentCheckFlags: f3, hasNodeIgnoreComment: T3 } = Dt2(), D3 = Zt2(), { willPrintOwnComments: F3 } = wu2(), i = (W3) => W3 === "" || W3 === e28 || W3 === n3 || W3 === r3;
        function g3(W3, ne2, re2) {
          let he2 = W3.getValue();
          if (he2.type === "JSXElement" && De2(he2))
            return [re2("openingElement"), re2("closingElement")];
          let Fe2 = he2.type === "JSXElement" ? re2("openingElement") : re2("openingFragment"), ve2 = he2.type === "JSXElement" ? re2("closingElement") : re2("closingFragment");
          if (he2.children.length === 1 && he2.children[0].type === "JSXExpressionContainer" && (he2.children[0].expression.type === "TemplateLiteral" || he2.children[0].expression.type === "TaggedTemplateExpression"))
            return [Fe2, ...W3.map(re2, "children"), ve2];
          he2.children = he2.children.map((v3) => we2(v3) ? { type: "JSXText", value: " ", raw: " " } : v3);
          let Re2 = he2.children.some(A3), tt2 = he2.children.filter((v3) => v3.type === "JSXExpressionContainer").length > 1, Ze2 = he2.type === "JSXElement" && he2.openingElement.attributes.length > 1, $e2 = C3(Fe2) || Re2 || Ze2 || tt2, Ge2 = W3.getParentNode().rootMarker === "mdx", le2 = ne2.singleQuote ? "{' '}" : '{" "}', G3 = Ge2 ? " " : y3([le2, r3], " "), me2 = he2.openingElement && he2.openingElement.name && he2.openingElement.name.name === "fbt", K3 = E3(W3, ne2, re2, G3, me2), de2 = he2.children.some((v3) => fe2(v3));
          for (let v3 = K3.length - 2; v3 >= 0; v3--) {
            let Y3 = K3[v3] === "" && K3[v3 + 1] === "", ae2 = K3[v3] === n3 && K3[v3 + 1] === "" && K3[v3 + 2] === n3, Ae2 = (K3[v3] === r3 || K3[v3] === n3) && K3[v3 + 1] === "" && K3[v3 + 2] === G3, Se2 = K3[v3] === G3 && K3[v3 + 1] === "" && (K3[v3 + 2] === r3 || K3[v3 + 2] === n3), Me2 = K3[v3] === G3 && K3[v3 + 1] === "" && K3[v3 + 2] === G3, xe2 = K3[v3] === r3 && K3[v3 + 1] === "" && K3[v3 + 2] === n3 || K3[v3] === n3 && K3[v3 + 1] === "" && K3[v3 + 2] === r3;
            ae2 && de2 || Y3 || Ae2 || Me2 || xe2 ? K3.splice(v3, 2) : Se2 && K3.splice(v3 + 1, 2);
          }
          for (; K3.length > 0 && i(w3(K3)); )
            K3.pop();
          for (; K3.length > 1 && i(K3[0]) && i(K3[1]); )
            K3.shift(), K3.shift();
          let je2 = [];
          for (let [v3, Y3] of K3.entries()) {
            if (Y3 === G3) {
              if (v3 === 1 && K3[v3 - 1] === "") {
                if (K3.length === 2) {
                  je2.push(le2);
                  continue;
                }
                je2.push([le2, n3]);
                continue;
              } else if (v3 === K3.length - 1) {
                je2.push(le2);
                continue;
              } else if (K3[v3 - 1] === "" && K3[v3 - 2] === n3) {
                je2.push(le2);
                continue;
              }
            }
            je2.push(Y3), C3(Y3) && ($e2 = true);
          }
          let Be2 = de2 ? m3(je2) : o3(je2, { shouldBreak: true });
          if (Ge2)
            return Be2;
          let ye2 = o3([Fe2, c3([n3, Be2]), n3, ve2]);
          return $e2 ? ye2 : h3([o3([Fe2, ...K3, ve2]), ye2]);
        }
        function E3(W3, ne2, re2, he2, Fe2) {
          let ve2 = [];
          return W3.each((Re2, tt2, Ze2) => {
            let $e2 = Re2.getValue();
            if ($e2.type === "JSXText") {
              let Ge2 = N3($e2);
              if (fe2($e2)) {
                let le2 = Ge2.split(ge2);
                if (le2[0] === "") {
                  if (ve2.push(""), le2.shift(), /\n/.test(le2[0])) {
                    let me2 = Ze2[tt2 + 1];
                    ve2.push(b3(Fe2, le2[1], $e2, me2));
                  } else
                    ve2.push(he2);
                  le2.shift();
                }
                let G3;
                if (w3(le2) === "" && (le2.pop(), G3 = le2.pop()), le2.length === 0)
                  return;
                for (let [me2, K3] of le2.entries())
                  me2 % 2 === 1 ? ve2.push(e28) : ve2.push(K3);
                if (G3 !== void 0)
                  if (/\n/.test(G3)) {
                    let me2 = Ze2[tt2 + 1];
                    ve2.push(b3(Fe2, w3(ve2), $e2, me2));
                  } else
                    ve2.push(he2);
                else {
                  let me2 = Ze2[tt2 + 1];
                  ve2.push(x3(Fe2, w3(ve2), $e2, me2));
                }
              } else
                /\n/.test(Ge2) ? Ge2.match(/\n/g).length > 1 && ve2.push("", n3) : ve2.push("", he2);
            } else {
              let Ge2 = re2();
              ve2.push(Ge2);
              let le2 = Ze2[tt2 + 1];
              if (le2 && fe2(le2)) {
                let G3 = z3(N3(le2)).split(ge2)[0];
                ve2.push(x3(Fe2, G3, $e2, le2));
              } else
                ve2.push(n3);
            }
          }, "children"), ve2;
        }
        function x3(W3, ne2, re2, he2) {
          return W3 ? "" : re2.type === "JSXElement" && !re2.closingElement || he2 && he2.type === "JSXElement" && !he2.closingElement ? ne2.length === 1 ? r3 : n3 : r3;
        }
        function b3(W3, ne2, re2, he2) {
          return W3 ? n3 : ne2.length === 1 ? re2.type === "JSXElement" && !re2.closingElement || he2 && he2.type === "JSXElement" && !he2.closingElement ? n3 : r3 : n3;
        }
        function B3(W3, ne2, re2) {
          let he2 = W3.getParentNode();
          if (!he2 || { ArrayExpression: true, JSXAttribute: true, JSXElement: true, JSXExpressionContainer: true, JSXFragment: true, ExpressionStatement: true, CallExpression: true, OptionalCallExpression: true, ConditionalExpression: true, JsExpressionRoot: true }[he2.type])
            return ne2;
          let Fe2 = W3.match(void 0, (Re2) => Re2.type === "ArrowFunctionExpression", S3, (Re2) => Re2.type === "JSXExpressionContainer"), ve2 = D3(W3, re2);
          return o3([ve2 ? "" : y3("("), c3([r3, ne2]), r3, ve2 ? "" : y3(")")], { shouldBreak: Fe2 });
        }
        function I3(W3, ne2, re2) {
          let he2 = W3.getValue(), Fe2 = [];
          if (Fe2.push(re2("name")), he2.value) {
            let ve2;
            if (j3(he2.value)) {
              let Re2 = N3(he2.value).slice(1, -1).replace(/&apos;/g, "'").replace(/&quot;/g, '"'), { escaped: tt2, quote: Ze2, regex: $e2 } = P3(Re2, ne2.jsxSingleQuote ? "'" : '"');
              Re2 = Re2.replace($e2, tt2);
              let { leading: Ge2, trailing: le2 } = W3.call(() => a3(W3, ne2), "value");
              ve2 = [Ge2, Ze2, Re2, Ze2, le2];
            } else
              ve2 = re2("value");
            Fe2.push("=", ve2);
          }
          return Fe2;
        }
        function M3(W3, ne2, re2) {
          let he2 = W3.getValue(), Fe2 = (ve2, Re2) => ve2.type === "JSXEmptyExpression" || !J3(ve2) && (ve2.type === "ArrayExpression" || ve2.type === "ObjectExpression" || ve2.type === "ArrowFunctionExpression" || ve2.type === "AwaitExpression" && (Fe2(ve2.argument, ve2) || ve2.argument.type === "JSXElement") || S3(ve2) || ve2.type === "FunctionExpression" || ve2.type === "TemplateLiteral" || ve2.type === "TaggedTemplateExpression" || ve2.type === "DoExpression" || A3(Re2) && (ve2.type === "ConditionalExpression" || k3(ve2)));
          return Fe2(he2.expression, W3.getParentNode(0)) ? o3(["{", re2("expression"), p3, "}"]) : o3(["{", c3([r3, re2("expression")]), r3, p3, "}"]);
        }
        function V10(W3, ne2, re2) {
          let he2 = W3.getValue(), Fe2 = he2.name && J3(he2.name) || he2.typeParameters && J3(he2.typeParameters);
          if (he2.selfClosing && he2.attributes.length === 0 && !Fe2)
            return ["<", re2("name"), re2("typeParameters"), " />"];
          if (he2.attributes && he2.attributes.length === 1 && he2.attributes[0].value && j3(he2.attributes[0].value) && !he2.attributes[0].value.value.includes(`
`) && !Fe2 && !J3(he2.attributes[0]))
            return o3(["<", re2("name"), re2("typeParameters"), " ", ...W3.map(re2, "attributes"), he2.selfClosing ? " />" : ">"]);
          let ve2 = he2.attributes && he2.attributes.some((tt2) => tt2.value && j3(tt2.value) && tt2.value.value.includes(`
`)), Re2 = ne2.singleAttributePerLine && he2.attributes.length > 1 ? n3 : e28;
          return o3(["<", re2("name"), re2("typeParameters"), c3(W3.map(() => [Re2, re2()], "attributes")), ...$3(he2, ne2, Fe2)], { shouldBreak: ve2 });
        }
        function $3(W3, ne2, re2) {
          return W3.selfClosing ? [e28, "/>"] : U3(W3, ne2, re2) ? [">"] : [r3, ">"];
        }
        function U3(W3, ne2, re2) {
          let he2 = W3.attributes.length > 0 && J3(w3(W3.attributes), f3.Trailing);
          return W3.attributes.length === 0 && !re2 || (ne2.bracketSameLine || ne2.jsxBracketSameLine) && (!re2 || W3.attributes.length > 0) && !he2;
        }
        function L3(W3, ne2, re2) {
          let he2 = W3.getValue(), Fe2 = [];
          Fe2.push("</");
          let ve2 = re2("name");
          return J3(he2.name, f3.Leading | f3.Line) ? Fe2.push(c3([n3, ve2]), n3) : J3(he2.name, f3.Leading | f3.Block) ? Fe2.push(" ", ve2) : Fe2.push(ve2), Fe2.push(">"), Fe2;
        }
        function ee2(W3, ne2) {
          let re2 = W3.getValue(), he2 = J3(re2), Fe2 = J3(re2, f3.Line), ve2 = re2.type === "JSXOpeningFragment";
          return [ve2 ? "<" : "</", c3([Fe2 ? n3 : he2 && !ve2 ? " " : "", s3(W3, ne2, true)]), Fe2 ? n3 : "", ">"];
        }
        function R3(W3, ne2, re2) {
          let he2 = t3(W3, g3(W3, ne2, re2), ne2);
          return B3(W3, he2, ne2);
        }
        function O3(W3, ne2) {
          let re2 = W3.getValue(), he2 = J3(re2, f3.Line);
          return [s3(W3, ne2, !he2), he2 ? n3 : ""];
        }
        function Z3(W3, ne2, re2) {
          let he2 = W3.getValue();
          return ["{", W3.call((Fe2) => {
            let ve2 = ["...", re2()], Re2 = Fe2.getValue();
            return !J3(Re2) || !F3(Fe2) ? ve2 : [c3([r3, t3(Fe2, ve2, ne2)]), r3];
          }, he2.type === "JSXSpreadAttribute" ? "argument" : "expression"), "}"];
        }
        function ie2(W3, ne2, re2) {
          let he2 = W3.getValue();
          if (he2.type.startsWith("JSX"))
            switch (he2.type) {
              case "JSXAttribute":
                return I3(W3, ne2, re2);
              case "JSXIdentifier":
                return String(he2.name);
              case "JSXNamespacedName":
                return d3(":", [re2("namespace"), re2("name")]);
              case "JSXMemberExpression":
                return d3(".", [re2("object"), re2("property")]);
              case "JSXSpreadAttribute":
                return Z3(W3, ne2, re2);
              case "JSXSpreadChild":
                return Z3(W3, ne2, re2);
              case "JSXExpressionContainer":
                return M3(W3, ne2, re2);
              case "JSXFragment":
              case "JSXElement":
                return R3(W3, ne2, re2);
              case "JSXOpeningElement":
                return V10(W3, ne2, re2);
              case "JSXClosingElement":
                return L3(W3, ne2, re2);
              case "JSXOpeningFragment":
              case "JSXClosingFragment":
                return ee2(W3, ne2);
              case "JSXEmptyExpression":
                return O3(W3, ne2);
              case "JSXText":
                throw new Error("JSXText should be handled by JSXElement");
              default:
                throw new Error(`Unknown JSX node type: ${JSON.stringify(he2.type)}.`);
            }
        }
        var te2 = ` 
\r	`, ge2 = new RegExp("([" + te2 + "]+)"), q3 = new RegExp("[^" + te2 + "]"), z3 = (W3) => W3.replace(new RegExp("(?:^" + ge2.source + "|" + ge2.source + "$)"), "");
        function De2(W3) {
          if (W3.children.length === 0)
            return true;
          if (W3.children.length > 1)
            return false;
          let ne2 = W3.children[0];
          return ne2.type === "JSXText" && !fe2(ne2);
        }
        function fe2(W3) {
          return W3.type === "JSXText" && (q3.test(N3(W3)) || !/\n/.test(N3(W3)));
        }
        function we2(W3) {
          return W3.type === "JSXExpressionContainer" && j3(W3.expression) && W3.expression.value === " " && !J3(W3.expression);
        }
        function Q3(W3) {
          let ne2 = W3.getValue(), re2 = W3.getParentNode();
          if (!re2 || !ne2 || !A3(ne2) || !A3(re2))
            return false;
          let he2 = re2.children.indexOf(ne2), Fe2 = null;
          for (let ve2 = he2; ve2 > 0; ve2--) {
            let Re2 = re2.children[ve2 - 1];
            if (!(Re2.type === "JSXText" && !fe2(Re2))) {
              Fe2 = Re2;
              break;
            }
          }
          return Fe2 && Fe2.type === "JSXExpressionContainer" && Fe2.expression.type === "JSXEmptyExpression" && T3(Fe2.expression);
        }
        l3.exports = { hasJsxIgnoreComment: Q3, printJsx: ie2 };
      } }), Tt2 = X3({ "src/language-js/print/misc.js"(u3, l3) {
        H3();
        var { isNonEmptyArray: t3 } = at2(), { builders: { indent: s3, join: a3, line: e28 } } = Qe2(), { isFlowAnnotationComment: n3 } = Dt2();
        function r3(w3) {
          let P3 = w3.getValue();
          return !P3.optional || P3.type === "Identifier" && P3 === w3.getParentNode().key ? "" : P3.type === "OptionalCallExpression" || P3.type === "OptionalMemberExpression" && P3.computed ? "?." : "?";
        }
        function o3(w3) {
          return w3.getValue().definite || w3.match(void 0, (P3, A3) => A3 === "id" && P3.type === "VariableDeclarator" && P3.definite) ? "!" : "";
        }
        function c3(w3, P3, A3) {
          let N3 = w3.getValue();
          return N3.typeArguments ? A3("typeArguments") : N3.typeParameters ? A3("typeParameters") : "";
        }
        function h3(w3, P3, A3) {
          let N3 = w3.getValue();
          if (!N3.typeAnnotation)
            return "";
          let S3 = w3.getParentNode(), j3 = S3.type === "DeclareFunction" && S3.id === N3;
          return n3(P3.originalText, N3.typeAnnotation) ? [" /*: ", A3("typeAnnotation"), " */"] : [j3 ? "" : ": ", A3("typeAnnotation")];
        }
        function m3(w3, P3, A3) {
          return ["::", A3("callee")];
        }
        function y3(w3, P3, A3) {
          let N3 = w3.getValue();
          return t3(N3.modifiers) ? [a3(" ", w3.map(A3, "modifiers")), " "] : "";
        }
        function p3(w3, P3, A3) {
          return w3.type === "EmptyStatement" ? ";" : w3.type === "BlockStatement" || A3 ? [" ", P3] : s3([e28, P3]);
        }
        function d3(w3, P3, A3) {
          return ["...", A3("argument"), h3(w3, P3, A3)];
        }
        function C3(w3, P3) {
          let A3 = w3.slice(1, -1);
          if (A3.includes('"') || A3.includes("'"))
            return w3;
          let N3 = P3.singleQuote ? "'" : '"';
          return N3 + A3 + N3;
        }
        l3.exports = { printOptionalToken: r3, printDefiniteToken: o3, printFunctionTypeParameters: c3, printBindExpressionCallee: m3, printTypeScriptModifiers: y3, printTypeAnnotation: h3, printRestSpread: d3, adjustClause: p3, printDirective: C3 };
      } }), cn2 = X3({ "src/language-js/print/array.js"(u3, l3) {
        H3();
        var { printDanglingComments: t3 } = ht2(), { builders: { line: s3, softline: a3, hardline: e28, group: n3, indent: r3, ifBreak: o3, fill: c3 } } = Qe2(), { getLast: h3, hasNewline: m3 } = at2(), { shouldPrintComma: y3, hasComment: p3, CommentCheckFlags: d3, isNextLineEmpty: C3, isNumericLiteral: w3, isSignedNumericLiteral: P3 } = Dt2(), { locStart: A3 } = vt2(), { printOptionalToken: N3, printTypeAnnotation: S3 } = Tt2();
        function j3(T3, D3, F3) {
          let i = T3.getValue(), g3 = [], E3 = i.type === "TupleExpression" ? "#[" : "[", x3 = "]";
          if (i.elements.length === 0)
            p3(i, d3.Dangling) ? g3.push(n3([E3, t3(T3, D3), a3, x3])) : g3.push(E3, x3);
          else {
            let b3 = h3(i.elements), B3 = !(b3 && b3.type === "RestElement"), I3 = b3 === null, M3 = Symbol("array"), V10 = !D3.__inJestEach && i.elements.length > 1 && i.elements.every((L3, ee2, R3) => {
              let O3 = L3 && L3.type;
              if (O3 !== "ArrayExpression" && O3 !== "ObjectExpression")
                return false;
              let Z3 = R3[ee2 + 1];
              if (Z3 && O3 !== Z3.type)
                return false;
              let ie2 = O3 === "ArrayExpression" ? "elements" : "properties";
              return L3[ie2] && L3[ie2].length > 1;
            }), $3 = k3(i, D3), U3 = B3 ? I3 ? "," : y3(D3) ? $3 ? o3(",", "", { groupId: M3 }) : o3(",") : "" : "";
            g3.push(n3([E3, r3([a3, $3 ? f3(T3, D3, F3, U3) : [J3(T3, D3, "elements", F3), U3], t3(T3, D3, true)]), a3, x3], { shouldBreak: V10, id: M3 }));
          }
          return g3.push(N3(T3), S3(T3, D3, F3)), g3;
        }
        function k3(T3, D3) {
          return T3.elements.length > 1 && T3.elements.every((F3) => F3 && (w3(F3) || P3(F3) && !p3(F3.argument)) && !p3(F3, d3.Trailing | d3.Line, (i) => !m3(D3.originalText, A3(i), { backwards: true })));
        }
        function J3(T3, D3, F3, i) {
          let g3 = [], E3 = [];
          return T3.each((x3) => {
            g3.push(E3, n3(i())), E3 = [",", s3], x3.getValue() && C3(x3.getValue(), D3) && E3.push(a3);
          }, F3), g3;
        }
        function f3(T3, D3, F3, i) {
          let g3 = [];
          return T3.each((E3, x3, b3) => {
            let B3 = x3 === b3.length - 1;
            g3.push([F3(), B3 ? i : ","]), B3 || g3.push(C3(E3.getValue(), D3) ? [e28, e28] : p3(b3[x3 + 1], d3.Leading | d3.Line) ? e28 : s3);
          }, "elements"), c3(g3);
        }
        l3.exports = { printArray: j3, printArrayItems: J3, isConciselyPrintedArray: k3 };
      } }), ku2 = X3({ "src/language-js/print/call-arguments.js"(u3, l3) {
        H3();
        var { printDanglingComments: t3 } = ht2(), { getLast: s3, getPenultimate: a3 } = at2(), { getFunctionParameters: e28, hasComment: n3, CommentCheckFlags: r3, isFunctionCompositionArgs: o3, isJsxNode: c3, isLongCurriedCallExpression: h3, shouldPrintComma: m3, getCallArguments: y3, iterateCallArgumentsPath: p3, isNextLineEmpty: d3, isCallExpression: C3, isStringLiteral: w3, isObjectProperty: P3, isTSTypeExpression: A3 } = Dt2(), { builders: { line: N3, hardline: S3, softline: j3, group: k3, indent: J3, conditionalGroup: f3, ifBreak: T3, breakParent: D3 }, utils: { willBreak: F3 } } = Qe2(), { ArgExpansionBailout: i } = on2(), { isConciselyPrintedArray: g3 } = cn2();
        function E3($3, U3, L3) {
          let ee2 = $3.getValue(), R3 = ee2.type === "ImportExpression", O3 = y3(ee2);
          if (O3.length === 0)
            return ["(", t3($3, U3, true), ")"];
          if (I3(O3))
            return ["(", L3(["arguments", 0]), ", ", L3(["arguments", 1]), ")"];
          let Z3 = false, ie2 = false, te2 = O3.length - 1, ge2 = [];
          p3($3, (Q3, W3) => {
            let ne2 = Q3.getNode(), re2 = [L3()];
            W3 === te2 || (d3(ne2, U3) ? (W3 === 0 && (ie2 = true), Z3 = true, re2.push(",", S3, S3)) : re2.push(",", N3)), ge2.push(re2);
          });
          let q3 = !(R3 || ee2.callee && ee2.callee.type === "Import") && m3(U3, "all") ? "," : "";
          function z3() {
            return k3(["(", J3([N3, ...ge2]), q3, N3, ")"], { shouldBreak: true });
          }
          if (Z3 || $3.getParentNode().type !== "Decorator" && o3(O3))
            return z3();
          let De2 = B3(O3), fe2 = b3(O3, U3);
          if (De2 || fe2) {
            if (De2 ? ge2.slice(1).some(F3) : ge2.slice(0, -1).some(F3))
              return z3();
            let Q3 = [];
            try {
              $3.try(() => {
                p3($3, (W3, ne2) => {
                  De2 && ne2 === 0 && (Q3 = [[L3([], { expandFirstArg: true }), ge2.length > 1 ? "," : "", ie2 ? S3 : N3, ie2 ? S3 : ""], ...ge2.slice(1)]), fe2 && ne2 === te2 && (Q3 = [...ge2.slice(0, -1), L3([], { expandLastArg: true })]);
                });
              });
            } catch (W3) {
              if (W3 instanceof i)
                return z3();
              throw W3;
            }
            return [ge2.some(F3) ? D3 : "", f3([["(", ...Q3, ")"], De2 ? ["(", k3(Q3[0], { shouldBreak: true }), ...Q3.slice(1), ")"] : ["(", ...ge2.slice(0, -1), k3(s3(Q3), { shouldBreak: true }), ")"], z3()])];
          }
          let we2 = ["(", J3([j3, ...ge2]), T3(q3), j3, ")"];
          return h3($3) ? we2 : k3(we2, { shouldBreak: ge2.some(F3) || Z3 });
        }
        function x3($3) {
          let U3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
          return $3.type === "ObjectExpression" && ($3.properties.length > 0 || n3($3)) || $3.type === "ArrayExpression" && ($3.elements.length > 0 || n3($3)) || $3.type === "TSTypeAssertion" && x3($3.expression) || A3($3) && x3($3.expression) || $3.type === "FunctionExpression" || $3.type === "ArrowFunctionExpression" && (!$3.returnType || !$3.returnType.typeAnnotation || $3.returnType.typeAnnotation.type !== "TSTypeReference" || M3($3.body)) && ($3.body.type === "BlockStatement" || $3.body.type === "ArrowFunctionExpression" && x3($3.body, true) || $3.body.type === "ObjectExpression" || $3.body.type === "ArrayExpression" || !U3 && (C3($3.body) || $3.body.type === "ConditionalExpression") || c3($3.body)) || $3.type === "DoExpression" || $3.type === "ModuleExpression";
        }
        function b3($3, U3) {
          let L3 = s3($3), ee2 = a3($3);
          return !n3(L3, r3.Leading) && !n3(L3, r3.Trailing) && x3(L3) && (!ee2 || ee2.type !== L3.type) && ($3.length !== 2 || ee2.type !== "ArrowFunctionExpression" || L3.type !== "ArrayExpression") && !($3.length > 1 && L3.type === "ArrayExpression" && g3(L3, U3));
        }
        function B3($3) {
          if ($3.length !== 2)
            return false;
          let [U3, L3] = $3;
          return U3.type === "ModuleExpression" && V10(L3) ? true : !n3(U3) && (U3.type === "FunctionExpression" || U3.type === "ArrowFunctionExpression" && U3.body.type === "BlockStatement") && L3.type !== "FunctionExpression" && L3.type !== "ArrowFunctionExpression" && L3.type !== "ConditionalExpression" && !x3(L3);
        }
        function I3($3) {
          return $3.length === 2 && $3[0].type === "ArrowFunctionExpression" && e28($3[0]).length === 0 && $3[0].body.type === "BlockStatement" && $3[1].type === "ArrayExpression" && !$3.some((U3) => n3(U3));
        }
        function M3($3) {
          return $3.type === "BlockStatement" && ($3.body.some((U3) => U3.type !== "EmptyStatement") || n3($3, r3.Dangling));
        }
        function V10($3) {
          return $3.type === "ObjectExpression" && $3.properties.length === 1 && P3($3.properties[0]) && $3.properties[0].key.type === "Identifier" && $3.properties[0].key.name === "type" && w3($3.properties[0].value) && $3.properties[0].value.value === "module";
        }
        l3.exports = E3;
      } }), Pu2 = X3({ "src/language-js/print/member.js"(u3, l3) {
        H3();
        var { builders: { softline: t3, group: s3, indent: a3, label: e28 } } = Qe2(), { isNumericLiteral: n3, isMemberExpression: r3, isCallExpression: o3 } = Dt2(), { printOptionalToken: c3 } = Tt2();
        function h3(y3, p3, d3) {
          let C3 = y3.getValue(), w3 = y3.getParentNode(), P3, A3 = 0;
          do
            P3 = y3.getParentNode(A3), A3++;
          while (P3 && (r3(P3) || P3.type === "TSNonNullExpression"));
          let N3 = d3("object"), S3 = m3(y3, p3, d3), j3 = P3 && (P3.type === "NewExpression" || P3.type === "BindExpression" || P3.type === "AssignmentExpression" && P3.left.type !== "Identifier") || C3.computed || C3.object.type === "Identifier" && C3.property.type === "Identifier" && !r3(w3) || (w3.type === "AssignmentExpression" || w3.type === "VariableDeclarator") && (o3(C3.object) && C3.object.arguments.length > 0 || C3.object.type === "TSNonNullExpression" && o3(C3.object.expression) && C3.object.expression.arguments.length > 0 || N3.label === "member-chain");
          return e28(N3.label === "member-chain" ? "member-chain" : "member", [N3, j3 ? S3 : s3(a3([t3, S3]))]);
        }
        function m3(y3, p3, d3) {
          let C3 = d3("property"), w3 = y3.getValue(), P3 = c3(y3);
          return w3.computed ? !w3.property || n3(w3.property) ? [P3, "[", C3, "]"] : s3([P3, "[", a3([t3, C3]), t3, "]"]) : [P3, ".", C3];
        }
        l3.exports = { printMemberExpression: h3, printMemberLookup: m3 };
      } }), Fs2 = X3({ "src/language-js/print/member-chain.js"(u3, l3) {
        H3();
        var { printComments: t3 } = ht2(), { getLast: s3, isNextLineEmptyAfterIndex: a3, getNextNonSpaceNonCommentCharacterIndex: e28 } = at2(), n3 = Zt2(), { isCallExpression: r3, isMemberExpression: o3, isFunctionOrArrowExpression: c3, isLongCurriedCallExpression: h3, isMemberish: m3, isNumericLiteral: y3, isSimpleCallArgument: p3, hasComment: d3, CommentCheckFlags: C3, isNextLineEmpty: w3 } = Dt2(), { locEnd: P3 } = vt2(), { builders: { join: A3, hardline: N3, group: S3, indent: j3, conditionalGroup: k3, breakParent: J3, label: f3 }, utils: { willBreak: T3 } } = Qe2(), D3 = ku2(), { printMemberLookup: F3 } = Pu2(), { printOptionalToken: i, printFunctionTypeParameters: g3, printBindExpressionCallee: E3 } = Tt2();
        function x3(b3, B3, I3) {
          let M3 = b3.getParentNode(), V10 = !M3 || M3.type === "ExpressionStatement", $3 = [];
          function U3($e2) {
            let { originalText: Ge2 } = B3, le2 = e28(Ge2, $e2, P3);
            return Ge2.charAt(le2) === ")" ? le2 !== false && a3(Ge2, le2 + 1) : w3($e2, B3);
          }
          function L3($e2) {
            let Ge2 = $e2.getValue();
            r3(Ge2) && (m3(Ge2.callee) || r3(Ge2.callee)) ? ($3.unshift({ node: Ge2, printed: [t3($e2, [i($e2), g3($e2, B3, I3), D3($e2, B3, I3)], B3), U3(Ge2) ? N3 : ""] }), $e2.call((le2) => L3(le2), "callee")) : m3(Ge2) ? ($3.unshift({ node: Ge2, needsParens: n3($e2, B3), printed: t3($e2, o3(Ge2) ? F3($e2, B3, I3) : E3($e2, B3, I3), B3) }), $e2.call((le2) => L3(le2), "object")) : Ge2.type === "TSNonNullExpression" ? ($3.unshift({ node: Ge2, printed: t3($e2, "!", B3) }), $e2.call((le2) => L3(le2), "expression")) : $3.unshift({ node: Ge2, printed: I3() });
          }
          let ee2 = b3.getValue();
          $3.unshift({ node: ee2, printed: [i(b3), g3(b3, B3, I3), D3(b3, B3, I3)] }), ee2.callee && b3.call(($e2) => L3($e2), "callee");
          let R3 = [], O3 = [$3[0]], Z3 = 1;
          for (; Z3 < $3.length && ($3[Z3].node.type === "TSNonNullExpression" || r3($3[Z3].node) || o3($3[Z3].node) && $3[Z3].node.computed && y3($3[Z3].node.property)); ++Z3)
            O3.push($3[Z3]);
          if (!r3($3[0].node))
            for (; Z3 + 1 < $3.length && m3($3[Z3].node) && m3($3[Z3 + 1].node); ++Z3)
              O3.push($3[Z3]);
          R3.push(O3), O3 = [];
          let ie2 = false;
          for (; Z3 < $3.length; ++Z3) {
            if (ie2 && m3($3[Z3].node)) {
              if ($3[Z3].node.computed && y3($3[Z3].node.property)) {
                O3.push($3[Z3]);
                continue;
              }
              R3.push(O3), O3 = [], ie2 = false;
            }
            (r3($3[Z3].node) || $3[Z3].node.type === "ImportExpression") && (ie2 = true), O3.push($3[Z3]), d3($3[Z3].node, C3.Trailing) && (R3.push(O3), O3 = [], ie2 = false);
          }
          O3.length > 0 && R3.push(O3);
          function te2($e2) {
            return /^[A-Z]|^[$_]+$/.test($e2);
          }
          function ge2($e2) {
            return $e2.length <= B3.tabWidth;
          }
          function q3($e2) {
            let Ge2 = $e2[1].length > 0 && $e2[1][0].node.computed;
            if ($e2[0].length === 1) {
              let G3 = $e2[0][0].node;
              return G3.type === "ThisExpression" || G3.type === "Identifier" && (te2(G3.name) || V10 && ge2(G3.name) || Ge2);
            }
            let le2 = s3($e2[0]).node;
            return o3(le2) && le2.property.type === "Identifier" && (te2(le2.property.name) || Ge2);
          }
          let z3 = R3.length >= 2 && !d3(R3[1][0].node) && q3(R3);
          function De2($e2) {
            let Ge2 = $e2.map((le2) => le2.printed);
            return $e2.length > 0 && s3($e2).needsParens ? ["(", ...Ge2, ")"] : Ge2;
          }
          function fe2($e2) {
            return $e2.length === 0 ? "" : j3(S3([N3, A3(N3, $e2.map(De2))]));
          }
          let we2 = R3.map(De2), Q3 = we2, W3 = z3 ? 3 : 2, ne2 = R3.flat(), re2 = ne2.slice(1, -1).some(($e2) => d3($e2.node, C3.Leading)) || ne2.slice(0, -1).some(($e2) => d3($e2.node, C3.Trailing)) || R3[W3] && d3(R3[W3][0].node, C3.Leading);
          if (R3.length <= W3 && !re2)
            return h3(b3) ? Q3 : S3(Q3);
          let he2 = s3(R3[z3 ? 1 : 0]).node, Fe2 = !r3(he2) && U3(he2), ve2 = [De2(R3[0]), z3 ? R3.slice(1, 2).map(De2) : "", Fe2 ? N3 : "", fe2(R3.slice(z3 ? 2 : 1))], Re2 = $3.map(($e2) => {
            let { node: Ge2 } = $e2;
            return Ge2;
          }).filter(r3);
          function tt2() {
            let $e2 = s3(s3(R3)).node, Ge2 = s3(we2);
            return r3($e2) && T3(Ge2) && Re2.slice(0, -1).some((le2) => le2.arguments.some(c3));
          }
          let Ze2;
          return re2 || Re2.length > 2 && Re2.some(($e2) => !$e2.arguments.every((Ge2) => p3(Ge2, 0))) || we2.slice(0, -1).some(T3) || tt2() ? Ze2 = S3(ve2) : Ze2 = [T3(Q3) || Fe2 ? J3 : "", k3([Q3, ve2])], f3("member-chain", Ze2);
        }
        l3.exports = x3;
      } }), ju2 = X3({ "src/language-js/print/call-expression.js"(u3, l3) {
        H3();
        var { builders: { join: t3, group: s3 } } = Qe2(), a3 = Zt2(), { getCallArguments: e28, hasFlowAnnotationComment: n3, isCallExpression: r3, isMemberish: o3, isStringLiteral: c3, isTemplateOnItsOwnLine: h3, isTestCall: m3, iterateCallArgumentsPath: y3 } = Dt2(), p3 = Fs2(), d3 = ku2(), { printOptionalToken: C3, printFunctionTypeParameters: w3 } = Tt2();
        function P3(N3, S3, j3) {
          let k3 = N3.getValue(), J3 = N3.getParentNode(), f3 = k3.type === "NewExpression", T3 = k3.type === "ImportExpression", D3 = C3(N3), F3 = e28(k3);
          if (F3.length > 0 && (!T3 && !f3 && A3(k3, J3) || F3.length === 1 && h3(F3[0], S3.originalText) || !f3 && m3(k3, J3))) {
            let E3 = [];
            return y3(N3, () => {
              E3.push(j3());
            }), [f3 ? "new " : "", j3("callee"), D3, w3(N3, S3, j3), "(", t3(", ", E3), ")"];
          }
          let i = (S3.parser === "babel" || S3.parser === "babel-flow") && k3.callee && k3.callee.type === "Identifier" && n3(k3.callee.trailingComments);
          if (i && (k3.callee.trailingComments[0].printed = true), !T3 && !f3 && o3(k3.callee) && !N3.call((E3) => a3(E3, S3), "callee"))
            return p3(N3, S3, j3);
          let g3 = [f3 ? "new " : "", T3 ? "import" : j3("callee"), D3, i ? `/*:: ${k3.callee.trailingComments[0].value.slice(2).trim()} */` : "", w3(N3, S3, j3), d3(N3, S3, j3)];
          return T3 || r3(k3.callee) ? s3(g3) : g3;
        }
        function A3(N3, S3) {
          if (N3.callee.type !== "Identifier")
            return false;
          if (N3.callee.name === "require")
            return true;
          if (N3.callee.name === "define") {
            let j3 = e28(N3);
            return S3.type === "ExpressionStatement" && (j3.length === 1 || j3.length === 2 && j3[0].type === "ArrayExpression" || j3.length === 3 && c3(j3[0]) && j3[1].type === "ArrayExpression");
          }
          return false;
        }
        l3.exports = { printCallExpression: P3 };
      } }), dn2 = X3({ "src/language-js/print/assignment.js"(u3, l3) {
        H3();
        var { isNonEmptyArray: t3, getStringWidth: s3 } = at2(), { builders: { line: a3, group: e28, indent: n3, indentIfBreak: r3, lineSuffixBoundary: o3 }, utils: { cleanDoc: c3, willBreak: h3, canBreak: m3 } } = Qe2(), { hasLeadingOwnLineComment: y3, isBinaryish: p3, isStringLiteral: d3, isLiteral: C3, isNumericLiteral: w3, isCallExpression: P3, isMemberExpression: A3, getCallArguments: N3, rawText: S3, hasComment: j3, isSignedNumericLiteral: k3, isObjectProperty: J3 } = Dt2(), { shouldInlineLogicalExpression: f3 } = lr2(), { printCallExpression: T3 } = ju2();
        function D3(q3, z3, De2, fe2, we2, Q3) {
          let W3 = g3(q3, z3, De2, fe2, Q3), ne2 = De2(Q3, { assignmentLayout: W3 });
          switch (W3) {
            case "break-after-operator":
              return e28([e28(fe2), we2, e28(n3([a3, ne2]))]);
            case "never-break-after-operator":
              return e28([e28(fe2), we2, " ", ne2]);
            case "fluid": {
              let re2 = Symbol("assignment");
              return e28([e28(fe2), we2, e28(n3(a3), { id: re2 }), o3, r3(ne2, { groupId: re2 })]);
            }
            case "break-lhs":
              return e28([fe2, we2, " ", e28(ne2)]);
            case "chain":
              return [e28(fe2), we2, a3, ne2];
            case "chain-tail":
              return [e28(fe2), we2, n3([a3, ne2])];
            case "chain-tail-arrow-chain":
              return [e28(fe2), we2, ne2];
            case "only-left":
              return fe2;
          }
        }
        function F3(q3, z3, De2) {
          let fe2 = q3.getValue();
          return D3(q3, z3, De2, De2("left"), [" ", fe2.operator], "right");
        }
        function i(q3, z3, De2) {
          return D3(q3, z3, De2, De2("id"), " =", "init");
        }
        function g3(q3, z3, De2, fe2, we2) {
          let Q3 = q3.getValue(), W3 = Q3[we2];
          if (!W3)
            return "only-left";
          let ne2 = !b3(W3);
          if (q3.match(b3, B3, (he2) => !ne2 || he2.type !== "ExpressionStatement" && he2.type !== "VariableDeclaration"))
            return ne2 ? W3.type === "ArrowFunctionExpression" && W3.body.type === "ArrowFunctionExpression" ? "chain-tail-arrow-chain" : "chain-tail" : "chain";
          if (!ne2 && b3(W3.right) || y3(z3.originalText, W3))
            return "break-after-operator";
          if (W3.type === "CallExpression" && W3.callee.name === "require" || z3.parser === "json5" || z3.parser === "json")
            return "never-break-after-operator";
          if (x3(Q3) || I3(Q3) || $3(Q3) || U3(Q3) && m3(fe2))
            return "break-lhs";
          let re2 = ie2(Q3, fe2, z3);
          return q3.call(() => E3(q3, z3, De2, re2), we2) ? "break-after-operator" : re2 || W3.type === "TemplateLiteral" || W3.type === "TaggedTemplateExpression" || W3.type === "BooleanLiteral" || w3(W3) || W3.type === "ClassExpression" ? "never-break-after-operator" : "fluid";
        }
        function E3(q3, z3, De2, fe2) {
          let we2 = q3.getValue();
          if (p3(we2) && !f3(we2))
            return true;
          switch (we2.type) {
            case "StringLiteralTypeAnnotation":
            case "SequenceExpression":
              return true;
            case "ConditionalExpression": {
              let { test: ne2 } = we2;
              return p3(ne2) && !f3(ne2);
            }
            case "ClassExpression":
              return t3(we2.decorators);
          }
          if (fe2)
            return false;
          let Q3 = we2, W3 = [];
          for (; ; )
            if (Q3.type === "UnaryExpression")
              Q3 = Q3.argument, W3.push("argument");
            else if (Q3.type === "TSNonNullExpression")
              Q3 = Q3.expression, W3.push("expression");
            else
              break;
          return !!(d3(Q3) || q3.call(() => R3(q3, z3, De2), ...W3));
        }
        function x3(q3) {
          if (B3(q3)) {
            let z3 = q3.left || q3.id;
            return z3.type === "ObjectPattern" && z3.properties.length > 2 && z3.properties.some((De2) => J3(De2) && (!De2.shorthand || De2.value && De2.value.type === "AssignmentPattern"));
          }
          return false;
        }
        function b3(q3) {
          return q3.type === "AssignmentExpression";
        }
        function B3(q3) {
          return b3(q3) || q3.type === "VariableDeclarator";
        }
        function I3(q3) {
          let z3 = M3(q3);
          if (t3(z3)) {
            let De2 = q3.type === "TSTypeAliasDeclaration" ? "constraint" : "bound";
            if (z3.length > 1 && z3.some((fe2) => fe2[De2] || fe2.default))
              return true;
          }
          return false;
        }
        function M3(q3) {
          return V10(q3) && q3.typeParameters && q3.typeParameters.params ? q3.typeParameters.params : null;
        }
        function V10(q3) {
          return q3.type === "TSTypeAliasDeclaration" || q3.type === "TypeAlias";
        }
        function $3(q3) {
          if (q3.type !== "VariableDeclarator")
            return false;
          let { typeAnnotation: z3 } = q3.id;
          if (!z3 || !z3.typeAnnotation)
            return false;
          let De2 = L3(z3.typeAnnotation);
          return t3(De2) && De2.length > 1 && De2.some((fe2) => t3(L3(fe2)) || fe2.type === "TSConditionalType");
        }
        function U3(q3) {
          return q3.type === "VariableDeclarator" && q3.init && q3.init.type === "ArrowFunctionExpression";
        }
        function L3(q3) {
          return ee2(q3) && q3.typeParameters && q3.typeParameters.params ? q3.typeParameters.params : null;
        }
        function ee2(q3) {
          return q3.type === "TSTypeReference" || q3.type === "GenericTypeAnnotation";
        }
        function R3(q3, z3, De2) {
          let fe2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, we2 = q3.getValue(), Q3 = () => R3(q3, z3, De2, true);
          if (we2.type === "TSNonNullExpression")
            return q3.call(Q3, "expression");
          if (P3(we2)) {
            if (T3(q3, z3, De2).label === "member-chain")
              return false;
            let W3 = N3(we2);
            return !(W3.length === 0 || W3.length === 1 && Z3(W3[0], z3)) || te2(we2, De2) ? false : q3.call(Q3, "callee");
          }
          return A3(we2) ? q3.call(Q3, "object") : fe2 && (we2.type === "Identifier" || we2.type === "ThisExpression");
        }
        var O3 = 0.25;
        function Z3(q3, z3) {
          let { printWidth: De2 } = z3;
          if (j3(q3))
            return false;
          let fe2 = De2 * O3;
          if (q3.type === "ThisExpression" || q3.type === "Identifier" && q3.name.length <= fe2 || k3(q3) && !j3(q3.argument))
            return true;
          let we2 = q3.type === "Literal" && "regex" in q3 && q3.regex.pattern || q3.type === "RegExpLiteral" && q3.pattern;
          return we2 ? we2.length <= fe2 : d3(q3) ? S3(q3).length <= fe2 : q3.type === "TemplateLiteral" ? q3.expressions.length === 0 && q3.quasis[0].value.raw.length <= fe2 && !q3.quasis[0].value.raw.includes(`
`) : C3(q3);
        }
        function ie2(q3, z3, De2) {
          if (!J3(q3))
            return false;
          z3 = c3(z3);
          let fe2 = 3;
          return typeof z3 == "string" && s3(z3) < De2.tabWidth + fe2;
        }
        function te2(q3, z3) {
          let De2 = ge2(q3);
          if (t3(De2)) {
            if (De2.length > 1)
              return true;
            if (De2.length === 1) {
              let we2 = De2[0];
              if (we2.type === "TSUnionType" || we2.type === "UnionTypeAnnotation" || we2.type === "TSIntersectionType" || we2.type === "IntersectionTypeAnnotation" || we2.type === "TSTypeLiteral" || we2.type === "ObjectTypeAnnotation")
                return true;
            }
            let fe2 = q3.typeParameters ? "typeParameters" : "typeArguments";
            if (h3(z3(fe2)))
              return true;
          }
          return false;
        }
        function ge2(q3) {
          return q3.typeParameters && q3.typeParameters.params || q3.typeArguments && q3.typeArguments.params;
        }
        l3.exports = { printVariableDeclarator: i, printAssignmentExpression: F3, printAssignment: D3, isArrowFunctionVariableDeclarator: U3 };
      } }), Pn2 = X3({ "src/language-js/print/function-parameters.js"(u3, l3) {
        H3();
        var { getNextNonSpaceNonCommentCharacter: t3 } = at2(), { printDanglingComments: s3 } = ht2(), { builders: { line: a3, hardline: e28, softline: n3, group: r3, indent: o3, ifBreak: c3 }, utils: { removeLines: h3, willBreak: m3 } } = Qe2(), { getFunctionParameters: y3, iterateFunctionParametersPath: p3, isSimpleType: d3, isTestCall: C3, isTypeAnnotationAFunction: w3, isObjectType: P3, isObjectTypePropertyAFunction: A3, hasRestParameter: N3, shouldPrintComma: S3, hasComment: j3, isNextLineEmpty: k3 } = Dt2(), { locEnd: J3 } = vt2(), { ArgExpansionBailout: f3 } = on2(), { printFunctionTypeParameters: T3 } = Tt2();
        function D3(E3, x3, b3, B3, I3) {
          let M3 = E3.getValue(), V10 = y3(M3), $3 = I3 ? T3(E3, b3, x3) : "";
          if (V10.length === 0)
            return [$3, "(", s3(E3, b3, true, (Z3) => t3(b3.originalText, Z3, J3) === ")"), ")"];
          let U3 = E3.getParentNode(), L3 = C3(U3), ee2 = F3(M3), R3 = [];
          if (p3(E3, (Z3, ie2) => {
            let te2 = ie2 === V10.length - 1;
            te2 && M3.rest && R3.push("..."), R3.push(x3()), !te2 && (R3.push(","), L3 || ee2 ? R3.push(" ") : k3(V10[ie2], b3) ? R3.push(e28, e28) : R3.push(a3));
          }), B3) {
            if (m3($3) || m3(R3))
              throw new f3();
            return r3([h3($3), "(", h3(R3), ")"]);
          }
          let O3 = V10.every((Z3) => !Z3.decorators);
          return ee2 && O3 ? [$3, "(", ...R3, ")"] : L3 ? [$3, "(", ...R3, ")"] : (A3(U3) || w3(U3) || U3.type === "TypeAlias" || U3.type === "UnionTypeAnnotation" || U3.type === "TSUnionType" || U3.type === "IntersectionTypeAnnotation" || U3.type === "FunctionTypeAnnotation" && U3.returnType === M3) && V10.length === 1 && V10[0].name === null && M3.this !== V10[0] && V10[0].typeAnnotation && M3.typeParameters === null && d3(V10[0].typeAnnotation) && !M3.rest ? b3.arrowParens === "always" ? ["(", ...R3, ")"] : R3 : [$3, "(", o3([n3, ...R3]), c3(!N3(M3) && S3(b3, "all") ? "," : ""), n3, ")"];
        }
        function F3(E3) {
          if (!E3)
            return false;
          let x3 = y3(E3);
          if (x3.length !== 1)
            return false;
          let [b3] = x3;
          return !j3(b3) && (b3.type === "ObjectPattern" || b3.type === "ArrayPattern" || b3.type === "Identifier" && b3.typeAnnotation && (b3.typeAnnotation.type === "TypeAnnotation" || b3.typeAnnotation.type === "TSTypeAnnotation") && P3(b3.typeAnnotation.typeAnnotation) || b3.type === "FunctionTypeParam" && P3(b3.typeAnnotation) || b3.type === "AssignmentPattern" && (b3.left.type === "ObjectPattern" || b3.left.type === "ArrayPattern") && (b3.right.type === "Identifier" || b3.right.type === "ObjectExpression" && b3.right.properties.length === 0 || b3.right.type === "ArrayExpression" && b3.right.elements.length === 0));
        }
        function i(E3) {
          let x3;
          return E3.returnType ? (x3 = E3.returnType, x3.typeAnnotation && (x3 = x3.typeAnnotation)) : E3.typeAnnotation && (x3 = E3.typeAnnotation), x3;
        }
        function g3(E3, x3) {
          let b3 = i(E3);
          if (!b3)
            return false;
          let B3 = E3.typeParameters && E3.typeParameters.params;
          if (B3) {
            if (B3.length > 1)
              return false;
            if (B3.length === 1) {
              let I3 = B3[0];
              if (I3.constraint || I3.default)
                return false;
            }
          }
          return y3(E3).length === 1 && (P3(b3) || m3(x3));
        }
        l3.exports = { printFunctionParameters: D3, shouldHugFunctionParameters: F3, shouldGroupFunctionParameters: g3 };
      } }), jn2 = X3({ "src/language-js/print/type-annotation.js"(u3, l3) {
        H3();
        var { printComments: t3, printDanglingComments: s3 } = ht2(), { isNonEmptyArray: a3 } = at2(), { builders: { group: e28, join: n3, line: r3, softline: o3, indent: c3, align: h3, ifBreak: m3 } } = Qe2(), y3 = Zt2(), { locStart: p3 } = vt2(), { isSimpleType: d3, isObjectType: C3, hasLeadingOwnLineComment: w3, isObjectTypePropertyAFunction: P3, shouldPrintComma: A3 } = Dt2(), { printAssignment: N3 } = dn2(), { printFunctionParameters: S3, shouldGroupFunctionParameters: j3 } = Pn2(), { printArrayItems: k3 } = cn2();
        function J3(b3) {
          if (d3(b3) || C3(b3))
            return true;
          if (b3.type === "UnionTypeAnnotation" || b3.type === "TSUnionType") {
            let B3 = b3.types.filter((M3) => M3.type === "VoidTypeAnnotation" || M3.type === "TSVoidKeyword" || M3.type === "NullLiteralTypeAnnotation" || M3.type === "TSNullKeyword").length, I3 = b3.types.some((M3) => M3.type === "ObjectTypeAnnotation" || M3.type === "TSTypeLiteral" || M3.type === "GenericTypeAnnotation" || M3.type === "TSTypeReference");
            if (b3.types.length - 1 === B3 && I3)
              return true;
          }
          return false;
        }
        function f3(b3, B3, I3) {
          let M3 = B3.semi ? ";" : "", V10 = b3.getValue(), $3 = [];
          return $3.push("opaque type ", I3("id"), I3("typeParameters")), V10.supertype && $3.push(": ", I3("supertype")), V10.impltype && $3.push(" = ", I3("impltype")), $3.push(M3), $3;
        }
        function T3(b3, B3, I3) {
          let M3 = B3.semi ? ";" : "", V10 = b3.getValue(), $3 = [];
          V10.declare && $3.push("declare "), $3.push("type ", I3("id"), I3("typeParameters"));
          let U3 = V10.type === "TSTypeAliasDeclaration" ? "typeAnnotation" : "right";
          return [N3(b3, B3, I3, $3, " =", U3), M3];
        }
        function D3(b3, B3, I3) {
          let M3 = b3.getValue(), V10 = b3.map(I3, "types"), $3 = [], U3 = false;
          for (let L3 = 0; L3 < V10.length; ++L3)
            L3 === 0 ? $3.push(V10[L3]) : C3(M3.types[L3 - 1]) && C3(M3.types[L3]) ? $3.push([" & ", U3 ? c3(V10[L3]) : V10[L3]]) : !C3(M3.types[L3 - 1]) && !C3(M3.types[L3]) ? $3.push(c3([" &", r3, V10[L3]])) : (L3 > 1 && (U3 = true), $3.push(" & ", L3 > 1 ? c3(V10[L3]) : V10[L3]));
          return e28($3);
        }
        function F3(b3, B3, I3) {
          let M3 = b3.getValue(), V10 = b3.getParentNode(), $3 = V10.type !== "TypeParameterInstantiation" && V10.type !== "TSTypeParameterInstantiation" && V10.type !== "GenericTypeAnnotation" && V10.type !== "TSTypeReference" && V10.type !== "TSTypeAssertion" && V10.type !== "TupleTypeAnnotation" && V10.type !== "TSTupleType" && !(V10.type === "FunctionTypeParam" && !V10.name && b3.getParentNode(1).this !== V10) && !((V10.type === "TypeAlias" || V10.type === "VariableDeclarator" || V10.type === "TSTypeAliasDeclaration") && w3(B3.originalText, M3)), U3 = J3(M3), L3 = b3.map((O3) => {
            let Z3 = I3();
            return U3 || (Z3 = h3(2, Z3)), t3(O3, Z3, B3);
          }, "types");
          if (U3)
            return n3(" | ", L3);
          let ee2 = $3 && !w3(B3.originalText, M3), R3 = [m3([ee2 ? r3 : "", "| "]), n3([r3, "| "], L3)];
          return y3(b3, B3) ? e28([c3(R3), o3]) : V10.type === "TupleTypeAnnotation" && V10.types.length > 1 || V10.type === "TSTupleType" && V10.elementTypes.length > 1 ? e28([c3([m3(["(", o3]), R3]), o3, m3(")")]) : e28($3 ? c3(R3) : R3);
        }
        function i(b3, B3, I3) {
          let M3 = b3.getValue(), V10 = [], $3 = b3.getParentNode(0), U3 = b3.getParentNode(1), L3 = b3.getParentNode(2), ee2 = M3.type === "TSFunctionType" || !(($3.type === "ObjectTypeProperty" || $3.type === "ObjectTypeInternalSlot") && !$3.variance && !$3.optional && p3($3) === p3(M3) || $3.type === "ObjectTypeCallProperty" || L3 && L3.type === "DeclareFunction"), R3 = ee2 && ($3.type === "TypeAnnotation" || $3.type === "TSTypeAnnotation"), O3 = R3 && ee2 && ($3.type === "TypeAnnotation" || $3.type === "TSTypeAnnotation") && U3.type === "ArrowFunctionExpression";
          P3($3) && (ee2 = true, R3 = true), O3 && V10.push("(");
          let Z3 = S3(b3, I3, B3, false, true), ie2 = M3.returnType || M3.predicate || M3.typeAnnotation ? [ee2 ? " => " : ": ", I3("returnType"), I3("predicate"), I3("typeAnnotation")] : "", te2 = j3(M3, ie2);
          return V10.push(te2 ? e28(Z3) : Z3), ie2 && V10.push(ie2), O3 && V10.push(")"), e28(V10);
        }
        function g3(b3, B3, I3) {
          let M3 = b3.getValue(), V10 = M3.type === "TSTupleType" ? "elementTypes" : "types", $3 = M3[V10], U3 = a3($3), L3 = U3 ? o3 : "";
          return e28(["[", c3([L3, k3(b3, B3, V10, I3)]), m3(U3 && A3(B3, "all") ? "," : ""), s3(b3, B3, true), L3, "]"]);
        }
        function E3(b3, B3, I3) {
          let M3 = b3.getValue(), V10 = M3.type === "OptionalIndexedAccessType" && M3.optional ? "?.[" : "[";
          return [I3("objectType"), V10, I3("indexType"), "]"];
        }
        function x3(b3, B3, I3) {
          let M3 = b3.getValue();
          return [M3.postfix ? "" : I3, B3("typeAnnotation"), M3.postfix ? I3 : ""];
        }
        l3.exports = { printOpaqueType: f3, printTypeAlias: T3, printIntersectionType: D3, printUnionType: F3, printFunctionType: i, printTupleType: g3, printIndexedAccessType: E3, shouldHugType: J3, printJSDocType: x3 };
      } }), In2 = X3({ "src/language-js/print/type-parameters.js"(u3, l3) {
        H3();
        var { printDanglingComments: t3 } = ht2(), { builders: { join: s3, line: a3, hardline: e28, softline: n3, group: r3, indent: o3, ifBreak: c3 } } = Qe2(), { isTestCall: h3, hasComment: m3, CommentCheckFlags: y3, isTSXFile: p3, shouldPrintComma: d3, getFunctionParameters: C3, isObjectType: w3, getTypeScriptMappedTypeModifier: P3 } = Dt2(), { createGroupIdMapper: A3 } = at2(), { shouldHugType: N3 } = jn2(), { isArrowFunctionVariableDeclarator: S3 } = dn2(), j3 = A3("typeParameters");
        function k3(T3, D3, F3, i) {
          let g3 = T3.getValue();
          if (!g3[i])
            return "";
          if (!Array.isArray(g3[i]))
            return F3(i);
          let E3 = T3.getNode(2), x3 = E3 && h3(E3), b3 = T3.match((I3) => !(I3[i].length === 1 && w3(I3[i][0])), void 0, (I3, M3) => M3 === "typeAnnotation", (I3) => I3.type === "Identifier", S3);
          if (g3[i].length === 0 || !b3 && (x3 || g3[i].length === 1 && (g3[i][0].type === "NullableTypeAnnotation" || N3(g3[i][0]))))
            return ["<", s3(", ", T3.map(F3, i)), J3(T3, D3), ">"];
          let B3 = g3.type === "TSTypeParameterInstantiation" ? "" : C3(g3).length === 1 && p3(D3) && !g3[i][0].constraint && T3.getParentNode().type === "ArrowFunctionExpression" ? "," : d3(D3, "all") ? c3(",") : "";
          return r3(["<", o3([n3, s3([",", a3], T3.map(F3, i))]), B3, n3, ">"], { id: j3(g3) });
        }
        function J3(T3, D3) {
          let F3 = T3.getValue();
          if (!m3(F3, y3.Dangling))
            return "";
          let i = !m3(F3, y3.Line), g3 = t3(T3, D3, i);
          return i ? g3 : [g3, e28];
        }
        function f3(T3, D3, F3) {
          let i = T3.getValue(), g3 = [i.type === "TSTypeParameter" && i.const ? "const " : ""], E3 = T3.getParentNode();
          return E3.type === "TSMappedType" ? (E3.readonly && g3.push(P3(E3.readonly, "readonly"), " "), g3.push("[", F3("name")), i.constraint && g3.push(" in ", F3("constraint")), E3.nameType && g3.push(" as ", T3.callParent(() => F3("nameType"))), g3.push("]"), g3) : (i.variance && g3.push(F3("variance")), i.in && g3.push("in "), i.out && g3.push("out "), g3.push(F3("name")), i.bound && g3.push(": ", F3("bound")), i.constraint && g3.push(" extends ", F3("constraint")), i.default && g3.push(" = ", F3("default")), g3);
        }
        l3.exports = { printTypeParameter: f3, printTypeParameters: k3, getTypeParametersGroupId: j3 };
      } }), Dn2 = X3({ "src/language-js/print/property.js"(u3, l3) {
        H3();
        var { printComments: t3 } = ht2(), { printString: s3, printNumber: a3 } = at2(), { isNumericLiteral: e28, isSimpleNumber: n3, isStringLiteral: r3, isStringPropSafeToUnquote: o3, rawText: c3 } = Dt2(), { printAssignment: h3 } = dn2(), m3 = /* @__PURE__ */ new WeakMap();
        function y3(d3, C3, w3) {
          let P3 = d3.getNode();
          if (P3.computed)
            return ["[", w3("key"), "]"];
          let A3 = d3.getParentNode(), { key: N3 } = P3;
          if (C3.quoteProps === "consistent" && !m3.has(A3)) {
            let S3 = (A3.properties || A3.body || A3.members).some((j3) => !j3.computed && j3.key && r3(j3.key) && !o3(j3, C3));
            m3.set(A3, S3);
          }
          if ((N3.type === "Identifier" || e28(N3) && n3(a3(c3(N3))) && String(N3.value) === a3(c3(N3)) && !(C3.parser === "typescript" || C3.parser === "babel-ts")) && (C3.parser === "json" || C3.quoteProps === "consistent" && m3.get(A3))) {
            let S3 = s3(JSON.stringify(N3.type === "Identifier" ? N3.name : N3.value.toString()), C3);
            return d3.call((j3) => t3(j3, S3, C3), "key");
          }
          return o3(P3, C3) && (C3.quoteProps === "as-needed" || C3.quoteProps === "consistent" && !m3.get(A3)) ? d3.call((S3) => t3(S3, /^\d/.test(N3.value) ? a3(N3.value) : N3.value, C3), "key") : w3("key");
        }
        function p3(d3, C3, w3) {
          return d3.getValue().shorthand ? w3("value") : h3(d3, C3, w3, y3(d3, C3, w3), ":", "value");
        }
        l3.exports = { printProperty: p3, printPropertyKey: y3 };
      } }), Ln2 = X3({ "src/language-js/print/function.js"(u3, l3) {
        H3();
        var t3 = pn2(), { printDanglingComments: s3, printCommentsSeparately: a3 } = ht2(), e28 = Ct2(), { getNextNonSpaceNonCommentCharacterIndex: n3 } = at2(), { builders: { line: r3, softline: o3, group: c3, indent: h3, ifBreak: m3, hardline: y3, join: p3, indentIfBreak: d3 }, utils: { removeLines: C3, willBreak: w3 } } = Qe2(), { ArgExpansionBailout: P3 } = on2(), { getFunctionParameters: A3, hasLeadingOwnLineComment: N3, isFlowAnnotationComment: S3, isJsxNode: j3, isTemplateOnItsOwnLine: k3, shouldPrintComma: J3, startsWithNoLookaheadToken: f3, isBinaryish: T3, isLineComment: D3, hasComment: F3, getComments: i, CommentCheckFlags: g3, isCallLikeExpression: E3, isCallExpression: x3, getCallArguments: b3, hasNakedLeftSide: B3, getLeftSide: I3 } = Dt2(), { locEnd: M3 } = vt2(), { printFunctionParameters: V10, shouldGroupFunctionParameters: $3 } = Pn2(), { printPropertyKey: U3 } = Dn2(), { printFunctionTypeParameters: L3 } = Tt2();
        function ee2(W3, ne2, re2, he2) {
          let Fe2 = W3.getValue(), ve2 = false;
          if ((Fe2.type === "FunctionDeclaration" || Fe2.type === "FunctionExpression") && he2 && he2.expandLastArg) {
            let Ge2 = W3.getParentNode();
            x3(Ge2) && b3(Ge2).length > 1 && (ve2 = true);
          }
          let Re2 = [];
          Fe2.type === "TSDeclareFunction" && Fe2.declare && Re2.push("declare "), Fe2.async && Re2.push("async "), Fe2.generator ? Re2.push("function* ") : Re2.push("function "), Fe2.id && Re2.push(ne2("id"));
          let tt2 = V10(W3, ne2, re2, ve2), Ze2 = z3(W3, ne2, re2), $e2 = $3(Fe2, Ze2);
          return Re2.push(L3(W3, re2, ne2), c3([$e2 ? c3(tt2) : tt2, Ze2]), Fe2.body ? " " : "", ne2("body")), re2.semi && (Fe2.declare || !Fe2.body) && Re2.push(";"), Re2;
        }
        function R3(W3, ne2, re2) {
          let he2 = W3.getNode(), { kind: Fe2 } = he2, ve2 = he2.value || he2, Re2 = [];
          return !Fe2 || Fe2 === "init" || Fe2 === "method" || Fe2 === "constructor" ? ve2.async && Re2.push("async ") : (t3.ok(Fe2 === "get" || Fe2 === "set"), Re2.push(Fe2, " ")), ve2.generator && Re2.push("*"), Re2.push(U3(W3, ne2, re2), he2.optional || he2.key.optional ? "?" : ""), he2 === ve2 ? Re2.push(O3(W3, ne2, re2)) : ve2.type === "FunctionExpression" ? Re2.push(W3.call((tt2) => O3(tt2, ne2, re2), "value")) : Re2.push(re2("value")), Re2;
        }
        function O3(W3, ne2, re2) {
          let he2 = W3.getNode(), Fe2 = V10(W3, re2, ne2), ve2 = z3(W3, re2, ne2), Re2 = $3(he2, ve2), tt2 = [L3(W3, ne2, re2), c3([Re2 ? c3(Fe2) : Fe2, ve2])];
          return he2.body ? tt2.push(" ", re2("body")) : tt2.push(ne2.semi ? ";" : ""), tt2;
        }
        function Z3(W3, ne2, re2, he2) {
          let Fe2 = W3.getValue(), ve2 = [];
          if (Fe2.async && ve2.push("async "), q3(W3, ne2))
            ve2.push(re2(["params", 0]));
          else {
            let tt2 = he2 && (he2.expandLastArg || he2.expandFirstArg), Ze2 = z3(W3, re2, ne2);
            if (tt2) {
              if (w3(Ze2))
                throw new P3();
              Ze2 = c3(C3(Ze2));
            }
            ve2.push(c3([V10(W3, re2, ne2, tt2, true), Ze2]));
          }
          let Re2 = s3(W3, ne2, true, (tt2) => {
            let Ze2 = n3(ne2.originalText, tt2, M3);
            return Ze2 !== false && ne2.originalText.slice(Ze2, Ze2 + 2) === "=>";
          });
          return Re2 && ve2.push(" ", Re2), ve2;
        }
        function ie2(W3, ne2, re2, he2, Fe2, ve2) {
          let Re2 = W3.getName(), tt2 = W3.getParentNode(), Ze2 = E3(tt2) && Re2 === "callee", $e2 = !!(ne2 && ne2.assignmentLayout), Ge2 = ve2.body.type !== "BlockStatement" && ve2.body.type !== "ObjectExpression" && ve2.body.type !== "SequenceExpression", le2 = Ze2 && Ge2 || ne2 && ne2.assignmentLayout === "chain-tail-arrow-chain", G3 = Symbol("arrow-chain");
          return ve2.body.type === "SequenceExpression" && (Fe2 = c3(["(", h3([o3, Fe2]), o3, ")"])), c3([c3(h3([Ze2 || $e2 ? o3 : "", c3(p3([" =>", r3], re2), { shouldBreak: he2 })]), { id: G3, shouldBreak: le2 }), " =>", d3(Ge2 ? h3([r3, Fe2]) : [" ", Fe2], { groupId: G3 }), Ze2 ? m3(o3, "", { groupId: G3 }) : ""]);
        }
        function te2(W3, ne2, re2, he2) {
          let Fe2 = W3.getValue(), ve2 = [], Re2 = [], tt2 = false;
          if (function G3() {
            let me2 = Z3(W3, ne2, re2, he2);
            if (ve2.length === 0)
              ve2.push(me2);
            else {
              let { leading: K3, trailing: de2 } = a3(W3, ne2);
              ve2.push([K3, me2]), Re2.unshift(de2);
            }
            tt2 = tt2 || Fe2.returnType && A3(Fe2).length > 0 || Fe2.typeParameters || A3(Fe2).some((K3) => K3.type !== "Identifier"), Fe2.body.type !== "ArrowFunctionExpression" || he2 && he2.expandLastArg ? Re2.unshift(re2("body", he2)) : (Fe2 = Fe2.body, W3.call(G3, "body"));
          }(), ve2.length > 1)
            return ie2(W3, he2, ve2, tt2, Re2, Fe2);
          let Ze2 = ve2;
          if (Ze2.push(" =>"), !N3(ne2.originalText, Fe2.body) && (Fe2.body.type === "ArrayExpression" || Fe2.body.type === "ObjectExpression" || Fe2.body.type === "BlockStatement" || j3(Fe2.body) || k3(Fe2.body, ne2.originalText) || Fe2.body.type === "ArrowFunctionExpression" || Fe2.body.type === "DoExpression"))
            return c3([...Ze2, " ", Re2]);
          if (Fe2.body.type === "SequenceExpression")
            return c3([...Ze2, c3([" (", h3([o3, Re2]), o3, ")"])]);
          let $e2 = (he2 && he2.expandLastArg || W3.getParentNode().type === "JSXExpressionContainer") && !F3(Fe2), Ge2 = he2 && he2.expandLastArg && J3(ne2, "all"), le2 = Fe2.body.type === "ConditionalExpression" && !f3(Fe2.body, (G3) => G3.type === "ObjectExpression");
          return c3([...Ze2, c3([h3([r3, le2 ? m3("", "(") : "", Re2, le2 ? m3("", ")") : ""]), $e2 ? [m3(Ge2 ? "," : ""), o3] : ""])]);
        }
        function ge2(W3) {
          let ne2 = A3(W3);
          return ne2.length === 1 && !W3.typeParameters && !F3(W3, g3.Dangling) && ne2[0].type === "Identifier" && !ne2[0].typeAnnotation && !F3(ne2[0]) && !ne2[0].optional && !W3.predicate && !W3.returnType;
        }
        function q3(W3, ne2) {
          if (ne2.arrowParens === "always")
            return false;
          if (ne2.arrowParens === "avoid") {
            let re2 = W3.getValue();
            return ge2(re2);
          }
          return false;
        }
        function z3(W3, ne2, re2) {
          let he2 = W3.getValue(), Fe2 = ne2("returnType");
          if (he2.returnType && S3(re2.originalText, he2.returnType))
            return [" /*: ", Fe2, " */"];
          let ve2 = [Fe2];
          return he2.returnType && he2.returnType.typeAnnotation && ve2.unshift(": "), he2.predicate && ve2.push(he2.returnType ? " " : ": ", ne2("predicate")), ve2;
        }
        function De2(W3, ne2, re2) {
          let he2 = W3.getValue(), Fe2 = ne2.semi ? ";" : "", ve2 = [];
          he2.argument && (Q3(ne2, he2.argument) ? ve2.push([" (", h3([y3, re2("argument")]), y3, ")"]) : T3(he2.argument) || he2.argument.type === "SequenceExpression" ? ve2.push(c3([m3(" (", " "), h3([o3, re2("argument")]), o3, m3(")")])) : ve2.push(" ", re2("argument")));
          let Re2 = i(he2), tt2 = e28(Re2), Ze2 = tt2 && D3(tt2);
          return Ze2 && ve2.push(Fe2), F3(he2, g3.Dangling) && ve2.push(" ", s3(W3, ne2, true)), Ze2 || ve2.push(Fe2), ve2;
        }
        function fe2(W3, ne2, re2) {
          return ["return", De2(W3, ne2, re2)];
        }
        function we2(W3, ne2, re2) {
          return ["throw", De2(W3, ne2, re2)];
        }
        function Q3(W3, ne2) {
          if (N3(W3.originalText, ne2))
            return true;
          if (B3(ne2)) {
            let re2 = ne2, he2;
            for (; he2 = I3(re2); )
              if (re2 = he2, N3(W3.originalText, re2))
                return true;
          }
          return false;
        }
        l3.exports = { printFunction: ee2, printArrowFunction: te2, printMethod: R3, printReturnStatement: fe2, printThrowStatement: we2, printMethodInternal: O3, shouldPrintParamsWithoutParens: q3 };
      } }), pr2 = X3({ "src/language-js/print/decorators.js"(u3, l3) {
        H3();
        var { isNonEmptyArray: t3, hasNewline: s3 } = at2(), { builders: { line: a3, hardline: e28, join: n3, breakParent: r3, group: o3 } } = Qe2(), { locStart: c3, locEnd: h3 } = vt2(), { getParentExportDeclaration: m3 } = Dt2();
        function y3(P3, A3, N3) {
          let S3 = P3.getValue();
          return o3([n3(a3, P3.map(N3, "decorators")), C3(S3, A3) ? e28 : a3]);
        }
        function p3(P3, A3, N3) {
          return [n3(e28, P3.map(N3, "declaration", "decorators")), e28];
        }
        function d3(P3, A3, N3) {
          let S3 = P3.getValue(), { decorators: j3 } = S3;
          if (!t3(j3) || w3(P3.getParentNode()))
            return;
          let k3 = S3.type === "ClassExpression" || S3.type === "ClassDeclaration" || C3(S3, A3);
          return [m3(P3) ? e28 : k3 ? r3 : "", n3(a3, P3.map(N3, "decorators")), a3];
        }
        function C3(P3, A3) {
          return P3.decorators.some((N3) => s3(A3.originalText, h3(N3)));
        }
        function w3(P3) {
          if (P3.type !== "ExportDefaultDeclaration" && P3.type !== "ExportNamedDeclaration" && P3.type !== "DeclareExportDeclaration")
            return false;
          let A3 = P3.declaration && P3.declaration.decorators;
          return t3(A3) && c3(P3) === c3(A3[0]);
        }
        l3.exports = { printDecorators: d3, printClassMemberDecorators: y3, printDecoratorsBeforeExport: p3, hasDecoratorsBeforeExport: w3 };
      } }), fn2 = X3({ "src/language-js/print/class.js"(u3, l3) {
        H3();
        var { isNonEmptyArray: t3, createGroupIdMapper: s3 } = at2(), { printComments: a3, printDanglingComments: e28 } = ht2(), { builders: { join: n3, line: r3, hardline: o3, softline: c3, group: h3, indent: m3, ifBreak: y3 } } = Qe2(), { hasComment: p3, CommentCheckFlags: d3 } = Dt2(), { getTypeParametersGroupId: C3 } = In2(), { printMethod: w3 } = Ln2(), { printOptionalToken: P3, printTypeAnnotation: A3, printDefiniteToken: N3 } = Tt2(), { printPropertyKey: S3 } = Dn2(), { printAssignment: j3 } = dn2(), { printClassMemberDecorators: k3 } = pr2();
        function J3(b3, B3, I3) {
          let M3 = b3.getValue(), V10 = [];
          M3.declare && V10.push("declare "), M3.abstract && V10.push("abstract "), V10.push("class");
          let $3 = M3.id && p3(M3.id, d3.Trailing) || M3.typeParameters && p3(M3.typeParameters, d3.Trailing) || M3.superClass && p3(M3.superClass) || t3(M3.extends) || t3(M3.mixins) || t3(M3.implements), U3 = [], L3 = [];
          if (M3.id && U3.push(" ", I3("id")), U3.push(I3("typeParameters")), M3.superClass) {
            let ee2 = [g3(b3, B3, I3), I3("superTypeParameters")], R3 = b3.call((O3) => ["extends ", a3(O3, ee2, B3)], "superClass");
            $3 ? L3.push(r3, h3(R3)) : L3.push(" ", R3);
          } else
            L3.push(i(b3, B3, I3, "extends"));
          if (L3.push(i(b3, B3, I3, "mixins"), i(b3, B3, I3, "implements")), $3) {
            let ee2;
            F3(M3) ? ee2 = [...U3, m3(L3)] : ee2 = m3([...U3, L3]), V10.push(h3(ee2, { id: f3(M3) }));
          } else
            V10.push(...U3, ...L3);
          return V10.push(" ", I3("body")), V10;
        }
        var f3 = s3("heritageGroup");
        function T3(b3) {
          return y3(o3, "", { groupId: f3(b3) });
        }
        function D3(b3) {
          return ["superClass", "extends", "mixins", "implements"].filter((B3) => !!b3[B3]).length > 1;
        }
        function F3(b3) {
          return b3.typeParameters && !p3(b3.typeParameters, d3.Trailing | d3.Line) && !D3(b3);
        }
        function i(b3, B3, I3, M3) {
          let V10 = b3.getValue();
          if (!t3(V10[M3]))
            return "";
          let $3 = e28(b3, B3, true, (U3) => {
            let { marker: L3 } = U3;
            return L3 === M3;
          });
          return [F3(V10) ? y3(" ", r3, { groupId: C3(V10.typeParameters) }) : r3, $3, $3 && o3, M3, h3(m3([r3, n3([",", r3], b3.map(I3, M3))]))];
        }
        function g3(b3, B3, I3) {
          let M3 = I3("superClass");
          return b3.getParentNode().type === "AssignmentExpression" ? h3(y3(["(", m3([c3, M3]), c3, ")"], M3)) : M3;
        }
        function E3(b3, B3, I3) {
          let M3 = b3.getValue(), V10 = [];
          return t3(M3.decorators) && V10.push(k3(b3, B3, I3)), M3.accessibility && V10.push(M3.accessibility + " "), M3.readonly && V10.push("readonly "), M3.declare && V10.push("declare "), M3.static && V10.push("static "), (M3.type === "TSAbstractMethodDefinition" || M3.abstract) && V10.push("abstract "), M3.override && V10.push("override "), V10.push(w3(b3, B3, I3)), V10;
        }
        function x3(b3, B3, I3) {
          let M3 = b3.getValue(), V10 = [], $3 = B3.semi ? ";" : "";
          return t3(M3.decorators) && V10.push(k3(b3, B3, I3)), M3.accessibility && V10.push(M3.accessibility + " "), M3.declare && V10.push("declare "), M3.static && V10.push("static "), (M3.type === "TSAbstractPropertyDefinition" || M3.type === "TSAbstractAccessorProperty" || M3.abstract) && V10.push("abstract "), M3.override && V10.push("override "), M3.readonly && V10.push("readonly "), M3.variance && V10.push(I3("variance")), (M3.type === "ClassAccessorProperty" || M3.type === "AccessorProperty" || M3.type === "TSAbstractAccessorProperty") && V10.push("accessor "), V10.push(S3(b3, B3, I3), P3(b3), N3(b3), A3(b3, B3, I3)), [j3(b3, B3, I3, V10, " =", "value"), $3];
        }
        l3.exports = { printClass: J3, printClassMethod: E3, printClassProperty: x3, printHardlineAfterHeritage: T3 };
      } }), Iu2 = X3({ "src/language-js/print/interface.js"(u3, l3) {
        H3();
        var { isNonEmptyArray: t3 } = at2(), { builders: { join: s3, line: a3, group: e28, indent: n3, ifBreak: r3 } } = Qe2(), { hasComment: o3, identity: c3, CommentCheckFlags: h3 } = Dt2(), { getTypeParametersGroupId: m3 } = In2(), { printTypeScriptModifiers: y3 } = Tt2();
        function p3(d3, C3, w3) {
          let P3 = d3.getValue(), A3 = [];
          P3.declare && A3.push("declare "), P3.type === "TSInterfaceDeclaration" && A3.push(P3.abstract ? "abstract " : "", y3(d3, C3, w3)), A3.push("interface");
          let N3 = [], S3 = [];
          P3.type !== "InterfaceTypeAnnotation" && N3.push(" ", w3("id"), w3("typeParameters"));
          let j3 = P3.typeParameters && !o3(P3.typeParameters, h3.Trailing | h3.Line);
          return t3(P3.extends) && S3.push(j3 ? r3(" ", a3, { groupId: m3(P3.typeParameters) }) : a3, "extends ", (P3.extends.length === 1 ? c3 : n3)(s3([",", a3], d3.map(w3, "extends")))), P3.id && o3(P3.id, h3.Trailing) || t3(P3.extends) ? j3 ? A3.push(e28([...N3, n3(S3)])) : A3.push(e28(n3([...N3, ...S3]))) : A3.push(...N3, ...S3), A3.push(" ", w3("body")), e28(A3);
        }
        l3.exports = { printInterface: p3 };
      } }), Lu2 = X3({ "src/language-js/print/module.js"(u3, l3) {
        H3();
        var { isNonEmptyArray: t3 } = at2(), { builders: { softline: s3, group: a3, indent: e28, join: n3, line: r3, ifBreak: o3, hardline: c3 } } = Qe2(), { printDanglingComments: h3 } = ht2(), { hasComment: m3, CommentCheckFlags: y3, shouldPrintComma: p3, needsHardlineAfterDanglingComment: d3, isStringLiteral: C3, rawText: w3 } = Dt2(), { locStart: P3, hasSameLoc: A3 } = vt2(), { hasDecoratorsBeforeExport: N3, printDecoratorsBeforeExport: S3 } = pr2();
        function j3(x3, b3, B3) {
          let I3 = x3.getValue(), M3 = b3.semi ? ";" : "", V10 = [], { importKind: $3 } = I3;
          return V10.push("import"), $3 && $3 !== "value" && V10.push(" ", $3), V10.push(D3(x3, b3, B3), T3(x3, b3, B3), i(x3, b3, B3), M3), V10;
        }
        function k3(x3, b3, B3) {
          let I3 = x3.getValue(), M3 = [];
          N3(I3) && M3.push(S3(x3, b3, B3));
          let { type: V10, exportKind: $3, declaration: U3 } = I3;
          return M3.push("export"), (I3.default || V10 === "ExportDefaultDeclaration") && M3.push(" default"), m3(I3, y3.Dangling) && (M3.push(" ", h3(x3, b3, true)), d3(I3) && M3.push(c3)), U3 ? M3.push(" ", B3("declaration")) : M3.push($3 === "type" ? " type" : "", D3(x3, b3, B3), T3(x3, b3, B3), i(x3, b3, B3)), f3(I3, b3) && M3.push(";"), M3;
        }
        function J3(x3, b3, B3) {
          let I3 = x3.getValue(), M3 = b3.semi ? ";" : "", V10 = [], { exportKind: $3, exported: U3 } = I3;
          return V10.push("export"), $3 === "type" && V10.push(" type"), V10.push(" *"), U3 && V10.push(" as ", B3("exported")), V10.push(T3(x3, b3, B3), i(x3, b3, B3), M3), V10;
        }
        function f3(x3, b3) {
          if (!b3.semi)
            return false;
          let { type: B3, declaration: I3 } = x3, M3 = x3.default || B3 === "ExportDefaultDeclaration";
          if (!I3)
            return true;
          let { type: V10 } = I3;
          return !!(M3 && V10 !== "ClassDeclaration" && V10 !== "FunctionDeclaration" && V10 !== "TSInterfaceDeclaration" && V10 !== "DeclareClass" && V10 !== "DeclareFunction" && V10 !== "TSDeclareFunction" && V10 !== "EnumDeclaration");
        }
        function T3(x3, b3, B3) {
          let I3 = x3.getValue();
          if (!I3.source)
            return "";
          let M3 = [];
          return F3(I3, b3) || M3.push(" from"), M3.push(" ", B3("source")), M3;
        }
        function D3(x3, b3, B3) {
          let I3 = x3.getValue();
          if (F3(I3, b3))
            return "";
          let M3 = [" "];
          if (t3(I3.specifiers)) {
            let V10 = [], $3 = [];
            x3.each(() => {
              let U3 = x3.getValue().type;
              if (U3 === "ExportNamespaceSpecifier" || U3 === "ExportDefaultSpecifier" || U3 === "ImportNamespaceSpecifier" || U3 === "ImportDefaultSpecifier")
                V10.push(B3());
              else if (U3 === "ExportSpecifier" || U3 === "ImportSpecifier")
                $3.push(B3());
              else
                throw new Error(`Unknown specifier type ${JSON.stringify(U3)}`);
            }, "specifiers"), M3.push(n3(", ", V10)), $3.length > 0 && (V10.length > 0 && M3.push(", "), $3.length > 1 || V10.length > 0 || I3.specifiers.some((U3) => m3(U3)) ? M3.push(a3(["{", e28([b3.bracketSpacing ? r3 : s3, n3([",", r3], $3)]), o3(p3(b3) ? "," : ""), b3.bracketSpacing ? r3 : s3, "}"])) : M3.push(["{", b3.bracketSpacing ? " " : "", ...$3, b3.bracketSpacing ? " " : "", "}"]));
          } else
            M3.push("{}");
          return M3;
        }
        function F3(x3, b3) {
          let { type: B3, importKind: I3, source: M3, specifiers: V10 } = x3;
          return B3 !== "ImportDeclaration" || t3(V10) || I3 === "type" ? false : !/{\s*}/.test(b3.originalText.slice(P3(x3), P3(M3)));
        }
        function i(x3, b3, B3) {
          let I3 = x3.getNode();
          return t3(I3.assertions) ? [" assert {", b3.bracketSpacing ? " " : "", n3(", ", x3.map(B3, "assertions")), b3.bracketSpacing ? " " : "", "}"] : "";
        }
        function g3(x3, b3, B3) {
          let I3 = x3.getNode(), { type: M3 } = I3, V10 = [], $3 = M3 === "ImportSpecifier" ? I3.importKind : I3.exportKind;
          $3 && $3 !== "value" && V10.push($3, " ");
          let U3 = M3.startsWith("Import"), L3 = U3 ? "imported" : "local", ee2 = U3 ? "local" : "exported", R3 = I3[L3], O3 = I3[ee2], Z3 = "", ie2 = "";
          return M3 === "ExportNamespaceSpecifier" || M3 === "ImportNamespaceSpecifier" ? Z3 = "*" : R3 && (Z3 = B3(L3)), O3 && !E3(I3) && (ie2 = B3(ee2)), V10.push(Z3, Z3 && ie2 ? " as " : "", ie2), V10;
        }
        function E3(x3) {
          if (x3.type !== "ImportSpecifier" && x3.type !== "ExportSpecifier")
            return false;
          let { local: b3, [x3.type === "ImportSpecifier" ? "imported" : "exported"]: B3 } = x3;
          if (b3.type !== B3.type || !A3(b3, B3))
            return false;
          if (C3(b3))
            return b3.value === B3.value && w3(b3) === w3(B3);
          switch (b3.type) {
            case "Identifier":
              return b3.name === B3.name;
            default:
              return false;
          }
        }
        l3.exports = { printImportDeclaration: j3, printExportDeclaration: k3, printExportAllDeclaration: J3, printModuleSpecifier: g3 };
      } }), cr2 = X3({ "src/language-js/print/object.js"(u3, l3) {
        H3();
        var { printDanglingComments: t3 } = ht2(), { builders: { line: s3, softline: a3, group: e28, indent: n3, ifBreak: r3, hardline: o3 } } = Qe2(), { getLast: c3, hasNewlineInRange: h3, hasNewline: m3, isNonEmptyArray: y3 } = at2(), { shouldPrintComma: p3, hasComment: d3, getComments: C3, CommentCheckFlags: w3, isNextLineEmpty: P3 } = Dt2(), { locStart: A3, locEnd: N3 } = vt2(), { printOptionalToken: S3, printTypeAnnotation: j3 } = Tt2(), { shouldHugFunctionParameters: k3 } = Pn2(), { shouldHugType: J3 } = jn2(), { printHardlineAfterHeritage: f3 } = fn2();
        function T3(D3, F3, i) {
          let g3 = F3.semi ? ";" : "", E3 = D3.getValue(), x3;
          E3.type === "TSTypeLiteral" ? x3 = "members" : E3.type === "TSInterfaceBody" ? x3 = "body" : x3 = "properties";
          let b3 = E3.type === "ObjectTypeAnnotation", B3 = [x3];
          b3 && B3.push("indexers", "callProperties", "internalSlots");
          let I3 = B3.map((q3) => E3[q3][0]).sort((q3, z3) => A3(q3) - A3(z3))[0], M3 = D3.getParentNode(0), V10 = b3 && M3 && (M3.type === "InterfaceDeclaration" || M3.type === "DeclareInterface" || M3.type === "DeclareClass") && D3.getName() === "body", $3 = E3.type === "TSInterfaceBody" || V10 || E3.type === "ObjectPattern" && M3.type !== "FunctionDeclaration" && M3.type !== "FunctionExpression" && M3.type !== "ArrowFunctionExpression" && M3.type !== "ObjectMethod" && M3.type !== "ClassMethod" && M3.type !== "ClassPrivateMethod" && M3.type !== "AssignmentPattern" && M3.type !== "CatchClause" && E3.properties.some((q3) => q3.value && (q3.value.type === "ObjectPattern" || q3.value.type === "ArrayPattern")) || E3.type !== "ObjectPattern" && I3 && h3(F3.originalText, A3(E3), A3(I3)), U3 = V10 ? ";" : E3.type === "TSInterfaceBody" || E3.type === "TSTypeLiteral" ? r3(g3, ";") : ",", L3 = E3.type === "RecordExpression" ? "#{" : E3.exact ? "{|" : "{", ee2 = E3.exact ? "|}" : "}", R3 = [];
          for (let q3 of B3)
            D3.each((z3) => {
              let De2 = z3.getValue();
              R3.push({ node: De2, printed: i(), loc: A3(De2) });
            }, q3);
          B3.length > 1 && R3.sort((q3, z3) => q3.loc - z3.loc);
          let O3 = [], Z3 = R3.map((q3) => {
            let z3 = [...O3, e28(q3.printed)];
            return O3 = [U3, s3], (q3.node.type === "TSPropertySignature" || q3.node.type === "TSMethodSignature" || q3.node.type === "TSConstructSignatureDeclaration") && d3(q3.node, w3.PrettierIgnore) && O3.shift(), P3(q3.node, F3) && O3.push(o3), z3;
          });
          if (E3.inexact) {
            let q3;
            if (d3(E3, w3.Dangling)) {
              let z3 = d3(E3, w3.Line);
              q3 = [t3(D3, F3, true), z3 || m3(F3.originalText, N3(c3(C3(E3)))) ? o3 : s3, "..."];
            } else
              q3 = ["..."];
            Z3.push([...O3, ...q3]);
          }
          let ie2 = c3(E3[x3]), te2 = !(E3.inexact || ie2 && ie2.type === "RestElement" || ie2 && (ie2.type === "TSPropertySignature" || ie2.type === "TSCallSignatureDeclaration" || ie2.type === "TSMethodSignature" || ie2.type === "TSConstructSignatureDeclaration") && d3(ie2, w3.PrettierIgnore)), ge2;
          if (Z3.length === 0) {
            if (!d3(E3, w3.Dangling))
              return [L3, ee2, j3(D3, F3, i)];
            ge2 = e28([L3, t3(D3, F3), a3, ee2, S3(D3), j3(D3, F3, i)]);
          } else
            ge2 = [V10 && y3(E3.properties) ? f3(M3) : "", L3, n3([F3.bracketSpacing ? s3 : a3, ...Z3]), r3(te2 && (U3 !== "," || p3(F3)) ? U3 : ""), F3.bracketSpacing ? s3 : a3, ee2, S3(D3), j3(D3, F3, i)];
          return D3.match((q3) => q3.type === "ObjectPattern" && !q3.decorators, (q3, z3, De2) => k3(q3) && (z3 === "params" || z3 === "parameters" || z3 === "this" || z3 === "rest") && De2 === 0) || D3.match(J3, (q3, z3) => z3 === "typeAnnotation", (q3, z3) => z3 === "typeAnnotation", (q3, z3, De2) => k3(q3) && (z3 === "params" || z3 === "parameters" || z3 === "this" || z3 === "rest") && De2 === 0) || !$3 && D3.match((q3) => q3.type === "ObjectPattern", (q3) => q3.type === "AssignmentExpression" || q3.type === "VariableDeclarator") ? ge2 : e28(ge2, { shouldBreak: $3 });
        }
        l3.exports = { printObject: T3 };
      } }), As2 = X3({ "src/language-js/print/flow.js"(u3, l3) {
        H3();
        var t3 = pn2(), { printDanglingComments: s3 } = ht2(), { printString: a3, printNumber: e28 } = at2(), { builders: { hardline: n3, softline: r3, group: o3, indent: c3 } } = Qe2(), { getParentExportDeclaration: h3, isFunctionNotation: m3, isGetterOrSetter: y3, rawText: p3, shouldPrintComma: d3 } = Dt2(), { locStart: C3, locEnd: w3 } = vt2(), { replaceTextEndOfLine: P3 } = sn2(), { printClass: A3 } = fn2(), { printOpaqueType: N3, printTypeAlias: S3, printIntersectionType: j3, printUnionType: k3, printFunctionType: J3, printTupleType: f3, printIndexedAccessType: T3 } = jn2(), { printInterface: D3 } = Iu2(), { printTypeParameter: F3, printTypeParameters: i } = In2(), { printExportDeclaration: g3, printExportAllDeclaration: E3 } = Lu2(), { printArrayItems: x3 } = cn2(), { printObject: b3 } = cr2(), { printPropertyKey: B3 } = Dn2(), { printOptionalToken: I3, printTypeAnnotation: M3, printRestSpread: V10 } = Tt2();
        function $3(L3, ee2, R3) {
          let O3 = L3.getValue(), Z3 = ee2.semi ? ";" : "", ie2 = [];
          switch (O3.type) {
            case "DeclareClass":
              return U3(L3, A3(L3, ee2, R3));
            case "DeclareFunction":
              return U3(L3, ["function ", R3("id"), O3.predicate ? " " : "", R3("predicate"), Z3]);
            case "DeclareModule":
              return U3(L3, ["module ", R3("id"), " ", R3("body")]);
            case "DeclareModuleExports":
              return U3(L3, ["module.exports", ": ", R3("typeAnnotation"), Z3]);
            case "DeclareVariable":
              return U3(L3, ["var ", R3("id"), Z3]);
            case "DeclareOpaqueType":
              return U3(L3, N3(L3, ee2, R3));
            case "DeclareInterface":
              return U3(L3, D3(L3, ee2, R3));
            case "DeclareTypeAlias":
              return U3(L3, S3(L3, ee2, R3));
            case "DeclareExportDeclaration":
              return U3(L3, g3(L3, ee2, R3));
            case "DeclareExportAllDeclaration":
              return U3(L3, E3(L3, ee2, R3));
            case "OpaqueType":
              return N3(L3, ee2, R3);
            case "TypeAlias":
              return S3(L3, ee2, R3);
            case "IntersectionTypeAnnotation":
              return j3(L3, ee2, R3);
            case "UnionTypeAnnotation":
              return k3(L3, ee2, R3);
            case "FunctionTypeAnnotation":
              return J3(L3, ee2, R3);
            case "TupleTypeAnnotation":
              return f3(L3, ee2, R3);
            case "GenericTypeAnnotation":
              return [R3("id"), i(L3, ee2, R3, "typeParameters")];
            case "IndexedAccessType":
            case "OptionalIndexedAccessType":
              return T3(L3, ee2, R3);
            case "TypeAnnotation":
              return R3("typeAnnotation");
            case "TypeParameter":
              return F3(L3, ee2, R3);
            case "TypeofTypeAnnotation":
              return ["typeof ", R3("argument")];
            case "ExistsTypeAnnotation":
              return "*";
            case "EmptyTypeAnnotation":
              return "empty";
            case "MixedTypeAnnotation":
              return "mixed";
            case "ArrayTypeAnnotation":
              return [R3("elementType"), "[]"];
            case "BooleanLiteralTypeAnnotation":
              return String(O3.value);
            case "EnumDeclaration":
              return ["enum ", R3("id"), " ", R3("body")];
            case "EnumBooleanBody":
            case "EnumNumberBody":
            case "EnumStringBody":
            case "EnumSymbolBody": {
              if (O3.type === "EnumSymbolBody" || O3.explicitType) {
                let te2 = null;
                switch (O3.type) {
                  case "EnumBooleanBody":
                    te2 = "boolean";
                    break;
                  case "EnumNumberBody":
                    te2 = "number";
                    break;
                  case "EnumStringBody":
                    te2 = "string";
                    break;
                  case "EnumSymbolBody":
                    te2 = "symbol";
                    break;
                }
                ie2.push("of ", te2, " ");
              }
              if (O3.members.length === 0 && !O3.hasUnknownMembers)
                ie2.push(o3(["{", s3(L3, ee2), r3, "}"]));
              else {
                let te2 = O3.members.length > 0 ? [n3, x3(L3, ee2, "members", R3), O3.hasUnknownMembers || d3(ee2) ? "," : ""] : [];
                ie2.push(o3(["{", c3([...te2, ...O3.hasUnknownMembers ? [n3, "..."] : []]), s3(L3, ee2, true), n3, "}"]));
              }
              return ie2;
            }
            case "EnumBooleanMember":
            case "EnumNumberMember":
            case "EnumStringMember":
              return [R3("id"), " = ", typeof O3.init == "object" ? R3("init") : String(O3.init)];
            case "EnumDefaultedMember":
              return R3("id");
            case "FunctionTypeParam": {
              let te2 = O3.name ? R3("name") : L3.getParentNode().this === O3 ? "this" : "";
              return [te2, I3(L3), te2 ? ": " : "", R3("typeAnnotation")];
            }
            case "InterfaceDeclaration":
            case "InterfaceTypeAnnotation":
              return D3(L3, ee2, R3);
            case "ClassImplements":
            case "InterfaceExtends":
              return [R3("id"), R3("typeParameters")];
            case "NullableTypeAnnotation":
              return ["?", R3("typeAnnotation")];
            case "Variance": {
              let { kind: te2 } = O3;
              return t3.ok(te2 === "plus" || te2 === "minus"), te2 === "plus" ? "+" : "-";
            }
            case "ObjectTypeCallProperty":
              return O3.static && ie2.push("static "), ie2.push(R3("value")), ie2;
            case "ObjectTypeIndexer":
              return [O3.static ? "static " : "", O3.variance ? R3("variance") : "", "[", R3("id"), O3.id ? ": " : "", R3("key"), "]: ", R3("value")];
            case "ObjectTypeProperty": {
              let te2 = "";
              return O3.proto ? te2 = "proto " : O3.static && (te2 = "static "), [te2, y3(O3) ? O3.kind + " " : "", O3.variance ? R3("variance") : "", B3(L3, ee2, R3), I3(L3), m3(O3) ? "" : ": ", R3("value")];
            }
            case "ObjectTypeAnnotation":
              return b3(L3, ee2, R3);
            case "ObjectTypeInternalSlot":
              return [O3.static ? "static " : "", "[[", R3("id"), "]]", I3(L3), O3.method ? "" : ": ", R3("value")];
            case "ObjectTypeSpreadProperty":
              return V10(L3, ee2, R3);
            case "QualifiedTypeofIdentifier":
            case "QualifiedTypeIdentifier":
              return [R3("qualification"), ".", R3("id")];
            case "StringLiteralTypeAnnotation":
              return P3(a3(p3(O3), ee2));
            case "NumberLiteralTypeAnnotation":
              t3.strictEqual(typeof O3.value, "number");
            case "BigIntLiteralTypeAnnotation":
              return O3.extra ? e28(O3.extra.raw) : e28(O3.raw);
            case "TypeCastExpression":
              return ["(", R3("expression"), M3(L3, ee2, R3), ")"];
            case "TypeParameterDeclaration":
            case "TypeParameterInstantiation": {
              let te2 = i(L3, ee2, R3, "params");
              if (ee2.parser === "flow") {
                let ge2 = C3(O3), q3 = w3(O3), z3 = ee2.originalText.lastIndexOf("/*", ge2), De2 = ee2.originalText.indexOf("*/", q3);
                if (z3 !== -1 && De2 !== -1) {
                  let fe2 = ee2.originalText.slice(z3 + 2, De2).trim();
                  if (fe2.startsWith("::") && !fe2.includes("/*") && !fe2.includes("*/"))
                    return ["/*:: ", te2, " */"];
                }
              }
              return te2;
            }
            case "InferredPredicate":
              return "%checks";
            case "DeclaredPredicate":
              return ["%checks(", R3("value"), ")"];
            case "AnyTypeAnnotation":
              return "any";
            case "BooleanTypeAnnotation":
              return "boolean";
            case "BigIntTypeAnnotation":
              return "bigint";
            case "NullLiteralTypeAnnotation":
              return "null";
            case "NumberTypeAnnotation":
              return "number";
            case "SymbolTypeAnnotation":
              return "symbol";
            case "StringTypeAnnotation":
              return "string";
            case "VoidTypeAnnotation":
              return "void";
            case "ThisTypeAnnotation":
              return "this";
            case "Node":
            case "Printable":
            case "SourceLocation":
            case "Position":
            case "Statement":
            case "Function":
            case "Pattern":
            case "Expression":
            case "Declaration":
            case "Specifier":
            case "NamedSpecifier":
            case "Comment":
            case "MemberTypeAnnotation":
            case "Type":
              throw new Error("unprintable type: " + JSON.stringify(O3.type));
          }
        }
        function U3(L3, ee2) {
          let R3 = h3(L3);
          return R3 ? (t3.strictEqual(R3.type, "DeclareExportDeclaration"), ee2) : ["declare ", ee2];
        }
        l3.exports = { printFlow: $3 };
      } }), vs2 = X3({ "src/language-js/utils/is-ts-keyword-type.js"(u3, l3) {
        H3();
        function t3(s3) {
          let { type: a3 } = s3;
          return a3.startsWith("TS") && a3.endsWith("Keyword");
        }
        l3.exports = t3;
      } }), _u2 = X3({ "src/language-js/print/ternary.js"(u3, l3) {
        H3();
        var { hasNewlineInRange: t3 } = at2(), { isJsxNode: s3, getComments: a3, isCallExpression: e28, isMemberExpression: n3, isTSTypeExpression: r3 } = Dt2(), { locStart: o3, locEnd: c3 } = vt2(), h3 = Wt2(), { builders: { line: m3, softline: y3, group: p3, indent: d3, align: C3, ifBreak: w3, dedent: P3, breakParent: A3 } } = Qe2();
        function N3(f3) {
          let T3 = [f3];
          for (let D3 = 0; D3 < T3.length; D3++) {
            let F3 = T3[D3];
            for (let i of ["test", "consequent", "alternate"]) {
              let g3 = F3[i];
              if (s3(g3))
                return true;
              g3.type === "ConditionalExpression" && T3.push(g3);
            }
          }
          return false;
        }
        function S3(f3, T3, D3) {
          let F3 = f3.getValue(), i = F3.type === "ConditionalExpression", g3 = i ? "alternate" : "falseType", E3 = f3.getParentNode(), x3 = i ? D3("test") : [D3("checkType"), " ", "extends", " ", D3("extendsType")];
          return E3.type === F3.type && E3[g3] === F3 ? C3(2, x3) : x3;
        }
        var j3 = /* @__PURE__ */ new Map([["AssignmentExpression", "right"], ["VariableDeclarator", "init"], ["ReturnStatement", "argument"], ["ThrowStatement", "argument"], ["UnaryExpression", "argument"], ["YieldExpression", "argument"]]);
        function k3(f3) {
          let T3 = f3.getValue();
          if (T3.type !== "ConditionalExpression")
            return false;
          let D3, F3 = T3;
          for (let i = 0; !D3; i++) {
            let g3 = f3.getParentNode(i);
            if (e28(g3) && g3.callee === F3 || n3(g3) && g3.object === F3 || g3.type === "TSNonNullExpression" && g3.expression === F3) {
              F3 = g3;
              continue;
            }
            g3.type === "NewExpression" && g3.callee === F3 || r3(g3) && g3.expression === F3 ? (D3 = f3.getParentNode(i + 1), F3 = g3) : D3 = g3;
          }
          return F3 === T3 ? false : D3[j3.get(D3.type)] === F3;
        }
        function J3(f3, T3, D3) {
          let F3 = f3.getValue(), i = F3.type === "ConditionalExpression", g3 = i ? "consequent" : "trueType", E3 = i ? "alternate" : "falseType", x3 = i ? ["test"] : ["checkType", "extendsType"], b3 = F3[g3], B3 = F3[E3], I3 = [], M3 = false, V10 = f3.getParentNode(), $3 = V10.type === F3.type && x3.some((De2) => V10[De2] === F3), U3 = V10.type === F3.type && !$3, L3, ee2, R3 = 0;
          do
            ee2 = L3 || F3, L3 = f3.getParentNode(R3), R3++;
          while (L3 && L3.type === F3.type && x3.every((De2) => L3[De2] !== ee2));
          let O3 = L3 || V10, Z3 = ee2;
          if (i && (s3(F3[x3[0]]) || s3(b3) || s3(B3) || N3(Z3))) {
            M3 = true, U3 = true;
            let De2 = (we2) => [w3("("), d3([y3, we2]), y3, w3(")")], fe2 = (we2) => we2.type === "NullLiteral" || we2.type === "Literal" && we2.value === null || we2.type === "Identifier" && we2.name === "undefined";
            I3.push(" ? ", fe2(b3) ? D3(g3) : De2(D3(g3)), " : ", B3.type === F3.type || fe2(B3) ? D3(E3) : De2(D3(E3)));
          } else {
            let De2 = [m3, "? ", b3.type === F3.type ? w3("", "(") : "", C3(2, D3(g3)), b3.type === F3.type ? w3("", ")") : "", m3, ": ", B3.type === F3.type ? D3(E3) : C3(2, D3(E3))];
            I3.push(V10.type !== F3.type || V10[E3] === F3 || $3 ? De2 : T3.useTabs ? P3(d3(De2)) : C3(Math.max(0, T3.tabWidth - 2), De2));
          }
          let ie2 = [...x3.map((De2) => a3(F3[De2])), a3(b3), a3(B3)].flat().some((De2) => h3(De2) && t3(T3.originalText, o3(De2), c3(De2))), te2 = (De2) => V10 === O3 ? p3(De2, { shouldBreak: ie2 }) : ie2 ? [De2, A3] : De2, ge2 = !M3 && (n3(V10) || V10.type === "NGPipeExpression" && V10.left === F3) && !V10.computed, q3 = k3(f3), z3 = te2([S3(f3, T3, D3), U3 ? I3 : d3(I3), i && ge2 && !q3 ? y3 : ""]);
          return $3 || q3 ? p3([d3([y3, z3]), y3]) : z3;
        }
        l3.exports = { printTernary: J3 };
      } }), Ou2 = X3({ "src/language-js/print/statement.js"(u3, l3) {
        H3();
        var { builders: { hardline: t3 } } = Qe2(), s3 = Zt2(), { getLeftSidePathName: a3, hasNakedLeftSide: e28, isJsxNode: n3, isTheOnlyJsxElementInMarkdown: r3, hasComment: o3, CommentCheckFlags: c3, isNextLineEmpty: h3 } = Dt2(), { shouldPrintParamsWithoutParens: m3 } = Ln2();
        function y3(S3, j3, k3, J3) {
          let f3 = S3.getValue(), T3 = [], D3 = f3.type === "ClassBody", F3 = p3(f3[J3]);
          return S3.each((i, g3, E3) => {
            let x3 = i.getValue();
            if (x3.type === "EmptyStatement")
              return;
            let b3 = k3();
            !j3.semi && !D3 && !r3(j3, i) && d3(i, j3) ? o3(x3, c3.Leading) ? T3.push(k3([], { needsSemi: true })) : T3.push(";", b3) : T3.push(b3), !j3.semi && D3 && A3(x3) && N3(x3, E3[g3 + 1]) && T3.push(";"), x3 !== F3 && (T3.push(t3), h3(x3, j3) && T3.push(t3));
          }, J3), T3;
        }
        function p3(S3) {
          for (let j3 = S3.length - 1; j3 >= 0; j3--) {
            let k3 = S3[j3];
            if (k3.type !== "EmptyStatement")
              return k3;
          }
        }
        function d3(S3, j3) {
          return S3.getNode().type !== "ExpressionStatement" ? false : S3.call((k3) => C3(k3, j3), "expression");
        }
        function C3(S3, j3) {
          let k3 = S3.getValue();
          switch (k3.type) {
            case "ParenthesizedExpression":
            case "TypeCastExpression":
            case "ArrayExpression":
            case "ArrayPattern":
            case "TemplateLiteral":
            case "TemplateElement":
            case "RegExpLiteral":
              return true;
            case "ArrowFunctionExpression": {
              if (!m3(S3, j3))
                return true;
              break;
            }
            case "UnaryExpression": {
              let { prefix: J3, operator: f3 } = k3;
              if (J3 && (f3 === "+" || f3 === "-"))
                return true;
              break;
            }
            case "BindExpression": {
              if (!k3.object)
                return true;
              break;
            }
            case "Literal": {
              if (k3.regex)
                return true;
              break;
            }
            default:
              if (n3(k3))
                return true;
          }
          return s3(S3, j3) ? true : e28(k3) ? S3.call((J3) => C3(J3, j3), ...a3(S3, k3)) : false;
        }
        function w3(S3, j3, k3) {
          return y3(S3, j3, k3, "body");
        }
        function P3(S3, j3, k3) {
          return y3(S3, j3, k3, "consequent");
        }
        var A3 = (S3) => {
          let { type: j3 } = S3;
          return j3 === "ClassProperty" || j3 === "PropertyDefinition" || j3 === "ClassPrivateProperty" || j3 === "ClassAccessorProperty" || j3 === "AccessorProperty" || j3 === "TSAbstractPropertyDefinition" || j3 === "TSAbstractAccessorProperty";
        };
        function N3(S3, j3) {
          let { type: k3, name: J3 } = S3.key;
          if (!S3.computed && k3 === "Identifier" && (J3 === "static" || J3 === "get" || J3 === "set" || J3 === "accessor") && !S3.value && !S3.typeAnnotation)
            return true;
          if (!j3 || j3.static || j3.accessibility)
            return false;
          if (!j3.computed) {
            let f3 = j3.key && j3.key.name;
            if (f3 === "in" || f3 === "instanceof")
              return true;
          }
          if (A3(j3) && j3.variance && !j3.static && !j3.declare)
            return true;
          switch (j3.type) {
            case "ClassProperty":
            case "PropertyDefinition":
            case "TSAbstractPropertyDefinition":
              return j3.computed;
            case "MethodDefinition":
            case "TSAbstractMethodDefinition":
            case "ClassMethod":
            case "ClassPrivateMethod": {
              if ((j3.value ? j3.value.async : j3.async) || j3.kind === "get" || j3.kind === "set")
                return false;
              let f3 = j3.value ? j3.value.generator : j3.generator;
              return !!(j3.computed || f3);
            }
            case "TSIndexSignature":
              return true;
          }
          return false;
        }
        l3.exports = { printBody: w3, printSwitchCaseConsequent: P3 };
      } }), Mu2 = X3({ "src/language-js/print/block.js"(u3, l3) {
        H3();
        var { printDanglingComments: t3 } = ht2(), { isNonEmptyArray: s3 } = at2(), { builders: { hardline: a3, indent: e28 } } = Qe2(), { hasComment: n3, CommentCheckFlags: r3, isNextLineEmpty: o3 } = Dt2(), { printHardlineAfterHeritage: c3 } = fn2(), { printBody: h3 } = Ou2();
        function m3(p3, d3, C3) {
          let w3 = p3.getValue(), P3 = [];
          if (w3.type === "StaticBlock" && P3.push("static "), w3.type === "ClassBody" && s3(w3.body)) {
            let N3 = p3.getParentNode();
            P3.push(c3(N3));
          }
          P3.push("{");
          let A3 = y3(p3, d3, C3);
          if (A3)
            P3.push(e28([a3, A3]), a3);
          else {
            let N3 = p3.getParentNode(), S3 = p3.getParentNode(1);
            N3.type === "ArrowFunctionExpression" || N3.type === "FunctionExpression" || N3.type === "FunctionDeclaration" || N3.type === "ObjectMethod" || N3.type === "ClassMethod" || N3.type === "ClassPrivateMethod" || N3.type === "ForStatement" || N3.type === "WhileStatement" || N3.type === "DoWhileStatement" || N3.type === "DoExpression" || N3.type === "CatchClause" && !S3.finalizer || N3.type === "TSModuleDeclaration" || N3.type === "TSDeclareFunction" || w3.type === "StaticBlock" || w3.type === "ClassBody" || P3.push(a3);
          }
          return P3.push("}"), P3;
        }
        function y3(p3, d3, C3) {
          let w3 = p3.getValue(), P3 = s3(w3.directives), A3 = w3.body.some((j3) => j3.type !== "EmptyStatement"), N3 = n3(w3, r3.Dangling);
          if (!P3 && !A3 && !N3)
            return "";
          let S3 = [];
          if (P3 && p3.each((j3, k3, J3) => {
            S3.push(C3()), (k3 < J3.length - 1 || A3 || N3) && (S3.push(a3), o3(j3.getValue(), d3) && S3.push(a3));
          }, "directives"), A3 && S3.push(h3(p3, d3, C3)), N3 && S3.push(t3(p3, d3, true)), w3.type === "Program") {
            let j3 = p3.getParentNode();
            (!j3 || j3.type !== "ModuleExpression") && S3.push(a3);
          }
          return S3;
        }
        l3.exports = { printBlock: m3, printBlockBody: y3 };
      } }), xs2 = X3({ "src/language-js/print/typescript.js"(u3, l3) {
        H3();
        var { printDanglingComments: t3 } = ht2(), { hasNewlineInRange: s3 } = at2(), { builders: { join: a3, line: e28, hardline: n3, softline: r3, group: o3, indent: c3, conditionalGroup: h3, ifBreak: m3 } } = Qe2(), { isStringLiteral: y3, getTypeScriptMappedTypeModifier: p3, shouldPrintComma: d3, isCallExpression: C3, isMemberExpression: w3 } = Dt2(), P3 = vs2(), { locStart: A3, locEnd: N3 } = vt2(), { printOptionalToken: S3, printTypeScriptModifiers: j3 } = Tt2(), { printTernary: k3 } = _u2(), { printFunctionParameters: J3, shouldGroupFunctionParameters: f3 } = Pn2(), { printTemplateLiteral: T3 } = Ht2(), { printArrayItems: D3 } = cn2(), { printObject: F3 } = cr2(), { printClassProperty: i, printClassMethod: g3 } = fn2(), { printTypeParameter: E3, printTypeParameters: x3 } = In2(), { printPropertyKey: b3 } = Dn2(), { printFunction: B3, printMethodInternal: I3 } = Ln2(), { printInterface: M3 } = Iu2(), { printBlock: V10 } = Mu2(), { printTypeAlias: $3, printIntersectionType: U3, printUnionType: L3, printFunctionType: ee2, printTupleType: R3, printIndexedAccessType: O3, printJSDocType: Z3 } = jn2();
        function ie2(te2, ge2, q3) {
          let z3 = te2.getValue();
          if (!z3.type.startsWith("TS"))
            return;
          if (P3(z3))
            return z3.type.slice(2, -7).toLowerCase();
          let De2 = ge2.semi ? ";" : "", fe2 = [];
          switch (z3.type) {
            case "TSThisType":
              return "this";
            case "TSTypeAssertion": {
              let we2 = !(z3.expression.type === "ArrayExpression" || z3.expression.type === "ObjectExpression"), Q3 = o3(["<", c3([r3, q3("typeAnnotation")]), r3, ">"]), W3 = [m3("("), c3([r3, q3("expression")]), r3, m3(")")];
              return we2 ? h3([[Q3, q3("expression")], [Q3, o3(W3, { shouldBreak: true })], [Q3, q3("expression")]]) : o3([Q3, q3("expression")]);
            }
            case "TSDeclareFunction":
              return B3(te2, q3, ge2);
            case "TSExportAssignment":
              return ["export = ", q3("expression"), De2];
            case "TSModuleBlock":
              return V10(te2, ge2, q3);
            case "TSInterfaceBody":
            case "TSTypeLiteral":
              return F3(te2, ge2, q3);
            case "TSTypeAliasDeclaration":
              return $3(te2, ge2, q3);
            case "TSQualifiedName":
              return a3(".", [q3("left"), q3("right")]);
            case "TSAbstractMethodDefinition":
            case "TSDeclareMethod":
              return g3(te2, ge2, q3);
            case "TSAbstractAccessorProperty":
            case "TSAbstractPropertyDefinition":
              return i(te2, ge2, q3);
            case "TSInterfaceHeritage":
            case "TSExpressionWithTypeArguments":
              return fe2.push(q3("expression")), z3.typeParameters && fe2.push(q3("typeParameters")), fe2;
            case "TSTemplateLiteralType":
              return T3(te2, q3, ge2);
            case "TSNamedTupleMember":
              return [q3("label"), z3.optional ? "?" : "", ": ", q3("elementType")];
            case "TSRestType":
              return ["...", q3("typeAnnotation")];
            case "TSOptionalType":
              return [q3("typeAnnotation"), "?"];
            case "TSInterfaceDeclaration":
              return M3(te2, ge2, q3);
            case "TSClassImplements":
              return [q3("expression"), q3("typeParameters")];
            case "TSTypeParameterDeclaration":
            case "TSTypeParameterInstantiation":
              return x3(te2, ge2, q3, "params");
            case "TSTypeParameter":
              return E3(te2, ge2, q3);
            case "TSSatisfiesExpression":
            case "TSAsExpression": {
              let we2 = z3.type === "TSAsExpression" ? "as" : "satisfies";
              fe2.push(q3("expression"), ` ${we2} `, q3("typeAnnotation"));
              let Q3 = te2.getParentNode();
              return C3(Q3) && Q3.callee === z3 || w3(Q3) && Q3.object === z3 ? o3([c3([r3, ...fe2]), r3]) : fe2;
            }
            case "TSArrayType":
              return [q3("elementType"), "[]"];
            case "TSPropertySignature":
              return z3.readonly && fe2.push("readonly "), fe2.push(b3(te2, ge2, q3), S3(te2)), z3.typeAnnotation && fe2.push(": ", q3("typeAnnotation")), z3.initializer && fe2.push(" = ", q3("initializer")), fe2;
            case "TSParameterProperty":
              return z3.accessibility && fe2.push(z3.accessibility + " "), z3.export && fe2.push("export "), z3.static && fe2.push("static "), z3.override && fe2.push("override "), z3.readonly && fe2.push("readonly "), fe2.push(q3("parameter")), fe2;
            case "TSTypeQuery":
              return ["typeof ", q3("exprName"), q3("typeParameters")];
            case "TSIndexSignature": {
              let we2 = te2.getParentNode(), Q3 = z3.parameters.length > 1 ? m3(d3(ge2) ? "," : "") : "", W3 = o3([c3([r3, a3([", ", r3], te2.map(q3, "parameters"))]), Q3, r3]);
              return [z3.export ? "export " : "", z3.accessibility ? [z3.accessibility, " "] : "", z3.static ? "static " : "", z3.readonly ? "readonly " : "", z3.declare ? "declare " : "", "[", z3.parameters ? W3 : "", z3.typeAnnotation ? "]: " : "]", z3.typeAnnotation ? q3("typeAnnotation") : "", we2.type === "ClassBody" ? De2 : ""];
            }
            case "TSTypePredicate":
              return [z3.asserts ? "asserts " : "", q3("parameterName"), z3.typeAnnotation ? [" is ", q3("typeAnnotation")] : ""];
            case "TSNonNullExpression":
              return [q3("expression"), "!"];
            case "TSImportType":
              return [z3.isTypeOf ? "typeof " : "", "import(", q3(z3.parameter ? "parameter" : "argument"), ")", z3.qualifier ? [".", q3("qualifier")] : "", x3(te2, ge2, q3, "typeParameters")];
            case "TSLiteralType":
              return q3("literal");
            case "TSIndexedAccessType":
              return O3(te2, ge2, q3);
            case "TSConstructSignatureDeclaration":
            case "TSCallSignatureDeclaration":
            case "TSConstructorType": {
              if (z3.type === "TSConstructorType" && z3.abstract && fe2.push("abstract "), z3.type !== "TSCallSignatureDeclaration" && fe2.push("new "), fe2.push(o3(J3(te2, q3, ge2, false, true))), z3.returnType || z3.typeAnnotation) {
                let we2 = z3.type === "TSConstructorType";
                fe2.push(we2 ? " => " : ": ", q3("returnType"), q3("typeAnnotation"));
              }
              return fe2;
            }
            case "TSTypeOperator":
              return [z3.operator, " ", q3("typeAnnotation")];
            case "TSMappedType": {
              let we2 = s3(ge2.originalText, A3(z3), N3(z3));
              return o3(["{", c3([ge2.bracketSpacing ? e28 : r3, q3("typeParameter"), z3.optional ? p3(z3.optional, "?") : "", z3.typeAnnotation ? ": " : "", q3("typeAnnotation"), m3(De2)]), t3(te2, ge2, true), ge2.bracketSpacing ? e28 : r3, "}"], { shouldBreak: we2 });
            }
            case "TSMethodSignature": {
              let we2 = z3.kind && z3.kind !== "method" ? `${z3.kind} ` : "";
              fe2.push(z3.accessibility ? [z3.accessibility, " "] : "", we2, z3.export ? "export " : "", z3.static ? "static " : "", z3.readonly ? "readonly " : "", z3.abstract ? "abstract " : "", z3.declare ? "declare " : "", z3.computed ? "[" : "", q3("key"), z3.computed ? "]" : "", S3(te2));
              let Q3 = J3(te2, q3, ge2, false, true), W3 = z3.returnType ? "returnType" : "typeAnnotation", ne2 = z3[W3], re2 = ne2 ? q3(W3) : "", he2 = f3(z3, re2);
              return fe2.push(he2 ? o3(Q3) : Q3), ne2 && fe2.push(": ", o3(re2)), o3(fe2);
            }
            case "TSNamespaceExportDeclaration":
              return fe2.push("export as namespace ", q3("id")), ge2.semi && fe2.push(";"), o3(fe2);
            case "TSEnumDeclaration":
              return z3.declare && fe2.push("declare "), z3.modifiers && fe2.push(j3(te2, ge2, q3)), z3.const && fe2.push("const "), fe2.push("enum ", q3("id"), " "), z3.members.length === 0 ? fe2.push(o3(["{", t3(te2, ge2), r3, "}"])) : fe2.push(o3(["{", c3([n3, D3(te2, ge2, "members", q3), d3(ge2, "es5") ? "," : ""]), t3(te2, ge2, true), n3, "}"])), fe2;
            case "TSEnumMember":
              return z3.computed ? fe2.push("[", q3("id"), "]") : fe2.push(q3("id")), z3.initializer && fe2.push(" = ", q3("initializer")), fe2;
            case "TSImportEqualsDeclaration":
              return z3.isExport && fe2.push("export "), fe2.push("import "), z3.importKind && z3.importKind !== "value" && fe2.push(z3.importKind, " "), fe2.push(q3("id"), " = ", q3("moduleReference")), ge2.semi && fe2.push(";"), o3(fe2);
            case "TSExternalModuleReference":
              return ["require(", q3("expression"), ")"];
            case "TSModuleDeclaration": {
              let we2 = te2.getParentNode(), Q3 = y3(z3.id), W3 = we2.type === "TSModuleDeclaration", ne2 = z3.body && z3.body.type === "TSModuleDeclaration";
              if (W3)
                fe2.push(".");
              else {
                z3.declare && fe2.push("declare "), fe2.push(j3(te2, ge2, q3));
                let re2 = ge2.originalText.slice(A3(z3), A3(z3.id));
                z3.id.type === "Identifier" && z3.id.name === "global" && !/namespace|module/.test(re2) || fe2.push(Q3 || /(?:^|\s)module(?:\s|$)/.test(re2) ? "module " : "namespace ");
              }
              return fe2.push(q3("id")), ne2 ? fe2.push(q3("body")) : z3.body ? fe2.push(" ", o3(q3("body"))) : fe2.push(De2), fe2;
            }
            case "TSConditionalType":
              return k3(te2, ge2, q3);
            case "TSInferType":
              return ["infer", " ", q3("typeParameter")];
            case "TSIntersectionType":
              return U3(te2, ge2, q3);
            case "TSUnionType":
              return L3(te2, ge2, q3);
            case "TSFunctionType":
              return ee2(te2, ge2, q3);
            case "TSTupleType":
              return R3(te2, ge2, q3);
            case "TSTypeReference":
              return [q3("typeName"), x3(te2, ge2, q3, "typeParameters")];
            case "TSTypeAnnotation":
              return q3("typeAnnotation");
            case "TSEmptyBodyFunctionExpression":
              return I3(te2, ge2, q3);
            case "TSJSDocAllType":
              return "*";
            case "TSJSDocUnknownType":
              return "?";
            case "TSJSDocNullableType":
              return Z3(te2, q3, "?");
            case "TSJSDocNonNullableType":
              return Z3(te2, q3, "!");
            case "TSInstantiationExpression":
              return [q3("expression"), q3("typeParameters")];
            default:
              throw new Error(`Unknown TypeScript node type: ${JSON.stringify(z3.type)}.`);
          }
        }
        l3.exports = { printTypescript: ie2 };
      } }), bs2 = X3({ "src/language-js/print/comment.js"(u3, l3) {
        H3();
        var { hasNewline: t3 } = at2(), { builders: { join: s3, hardline: a3 }, utils: { replaceTextEndOfLine: e28 } } = Qe2(), { isLineComment: n3 } = Dt2(), { locStart: r3, locEnd: o3 } = vt2(), c3 = Wt2();
        function h3(p3, d3) {
          let C3 = p3.getValue();
          if (n3(C3))
            return d3.originalText.slice(r3(C3), o3(C3)).trimEnd();
          if (c3(C3)) {
            if (m3(C3)) {
              let A3 = y3(C3);
              return C3.trailing && !t3(d3.originalText, r3(C3), { backwards: true }) ? [a3, A3] : A3;
            }
            let w3 = o3(C3), P3 = d3.originalText.slice(w3 - 3, w3) === "*-/";
            return ["/*", e28(C3.value), P3 ? "*-/" : "*/"];
          }
          throw new Error("Not a comment: " + JSON.stringify(C3));
        }
        function m3(p3) {
          let d3 = `*${p3.value}*`.split(`
`);
          return d3.length > 1 && d3.every((C3) => C3.trim()[0] === "*");
        }
        function y3(p3) {
          let d3 = p3.value.split(`
`);
          return ["/*", s3(a3, d3.map((C3, w3) => w3 === 0 ? C3.trimEnd() : " " + (w3 < d3.length - 1 ? C3.trim() : C3.trimStart()))), "*/"];
        }
        l3.exports = { printComment: h3 };
      } }), Ss2 = X3({ "src/language-js/print/literal.js"(u3, l3) {
        H3();
        var { printString: t3, printNumber: s3 } = at2(), { replaceTextEndOfLine: a3 } = sn2(), { printDirective: e28 } = Tt2();
        function n3(h3, m3) {
          let y3 = h3.getNode();
          switch (y3.type) {
            case "RegExpLiteral":
              return c3(y3);
            case "BigIntLiteral":
              return o3(y3.bigint || y3.extra.raw);
            case "NumericLiteral":
              return s3(y3.extra.raw);
            case "StringLiteral":
              return a3(t3(y3.extra.raw, m3));
            case "NullLiteral":
              return "null";
            case "BooleanLiteral":
              return String(y3.value);
            case "DecimalLiteral":
              return s3(y3.value) + "m";
            case "Literal": {
              if (y3.regex)
                return c3(y3.regex);
              if (y3.bigint)
                return o3(y3.raw);
              if (y3.decimal)
                return s3(y3.decimal) + "m";
              let { value: p3 } = y3;
              return typeof p3 == "number" ? s3(y3.raw) : typeof p3 == "string" ? r3(h3) ? e28(y3.raw, m3) : a3(t3(y3.raw, m3)) : String(p3);
            }
          }
        }
        function r3(h3) {
          if (h3.getName() !== "expression")
            return;
          let m3 = h3.getParentNode();
          return m3.type === "ExpressionStatement" && m3.directive;
        }
        function o3(h3) {
          return h3.toLowerCase();
        }
        function c3(h3) {
          let { pattern: m3, flags: y3 } = h3;
          return y3 = [...y3].sort().join(""), `/${m3}/${y3}`;
        }
        l3.exports = { printLiteral: n3 };
      } }), Ts2 = X3({ "src/language-js/printer-estree.js"(u3, l3) {
        H3();
        var { printDanglingComments: t3 } = ht2(), { hasNewline: s3 } = at2(), { builders: { join: a3, line: e28, hardline: n3, softline: r3, group: o3, indent: c3 }, utils: { replaceTextEndOfLine: h3 } } = Qe2(), m3 = os2(), y3 = ls2(), { insertPragma: p3 } = Bu2(), d3 = wu2(), C3 = Zt2(), w3 = Nu2(), { hasFlowShorthandAnnotationComment: P3, hasComment: A3, CommentCheckFlags: N3, isTheOnlyJsxElementInMarkdown: S3, isLineComment: j3, isNextLineEmpty: k3, needsHardlineAfterDanglingComment: J3, hasIgnoreComment: f3, isCallExpression: T3, isMemberExpression: D3, markerForIfWithoutBlockAndSameLineComment: F3 } = Dt2(), { locStart: i, locEnd: g3 } = vt2(), E3 = Wt2(), { printHtmlBinding: x3, isVueEventBindingExpression: b3 } = hs2(), { printAngular: B3 } = Es2(), { printJsx: I3, hasJsxIgnoreComment: M3 } = Cs2(), { printFlow: V10 } = As2(), { printTypescript: $3 } = xs2(), { printOptionalToken: U3, printBindExpressionCallee: L3, printTypeAnnotation: ee2, adjustClause: R3, printRestSpread: O3, printDefiniteToken: Z3, printDirective: ie2 } = Tt2(), { printImportDeclaration: te2, printExportDeclaration: ge2, printExportAllDeclaration: q3, printModuleSpecifier: z3 } = Lu2(), { printTernary: De2 } = _u2(), { printTemplateLiteral: fe2 } = Ht2(), { printArray: we2 } = cn2(), { printObject: Q3 } = cr2(), { printClass: W3, printClassMethod: ne2, printClassProperty: re2 } = fn2(), { printProperty: he2 } = Dn2(), { printFunction: Fe2, printArrowFunction: ve2, printMethod: Re2, printReturnStatement: tt2, printThrowStatement: Ze2 } = Ln2(), { printCallExpression: $e2 } = ju2(), { printVariableDeclarator: Ge2, printAssignmentExpression: le2 } = dn2(), { printBinaryishExpression: G3 } = lr2(), { printSwitchCaseConsequent: me2 } = Ou2(), { printMemberExpression: K3 } = Pu2(), { printBlock: de2, printBlockBody: je2 } = Mu2(), { printComment: Be2 } = bs2(), { printLiteral: ye2 } = Ss2(), { printDecorators: v3 } = pr2();
        function Y3(Se2, Me2, xe2, mt2) {
          let _e2 = ae2(Se2, Me2, xe2, mt2);
          if (!_e2)
            return "";
          let ft2 = Se2.getValue(), { type: Le2 } = ft2;
          if (Le2 === "ClassMethod" || Le2 === "ClassPrivateMethod" || Le2 === "ClassProperty" || Le2 === "ClassAccessorProperty" || Le2 === "AccessorProperty" || Le2 === "TSAbstractAccessorProperty" || Le2 === "PropertyDefinition" || Le2 === "TSAbstractPropertyDefinition" || Le2 === "ClassPrivateProperty" || Le2 === "MethodDefinition" || Le2 === "TSAbstractMethodDefinition" || Le2 === "TSDeclareMethod")
            return _e2;
          let Ue2 = [_e2], et2 = v3(Se2, Me2, xe2), ct2 = ft2.type === "ClassExpression" && et2;
          if (et2 && (Ue2 = [...et2, _e2], !ct2))
            return o3(Ue2);
          if (!C3(Se2, Me2))
            return mt2 && mt2.needsSemi && Ue2.unshift(";"), Ue2.length === 1 && Ue2[0] === _e2 ? _e2 : Ue2;
          if (ct2 && (Ue2 = [c3([e28, ...Ue2])]), Ue2.unshift("("), mt2 && mt2.needsSemi && Ue2.unshift(";"), P3(ft2)) {
            let [Oe2] = ft2.trailingComments;
            Ue2.push(" /*", Oe2.value.trimStart(), "*/"), Oe2.printed = true;
          }
          return ct2 && Ue2.push(e28), Ue2.push(")"), Ue2;
        }
        function ae2(Se2, Me2, xe2, mt2) {
          let _e2 = Se2.getValue(), ft2 = Me2.semi ? ";" : "";
          if (!_e2)
            return "";
          if (typeof _e2 == "string")
            return _e2;
          for (let Ue2 of [ye2, x3, B3, I3, V10, $3]) {
            let et2 = Ue2(Se2, Me2, xe2);
            if (typeof et2 < "u")
              return et2;
          }
          let Le2 = [];
          switch (_e2.type) {
            case "JsExpressionRoot":
              return xe2("node");
            case "JsonRoot":
              return [xe2("node"), n3];
            case "File":
              return _e2.program && _e2.program.interpreter && Le2.push(xe2(["program", "interpreter"])), Le2.push(xe2("program")), Le2;
            case "Program":
              return je2(Se2, Me2, xe2);
            case "EmptyStatement":
              return "";
            case "ExpressionStatement": {
              if (Me2.parser === "__vue_event_binding" || Me2.parser === "__vue_ts_event_binding") {
                let et2 = Se2.getParentNode();
                if (et2.type === "Program" && et2.body.length === 1 && et2.body[0] === _e2)
                  return [xe2("expression"), b3(_e2.expression) ? ";" : ""];
              }
              let Ue2 = t3(Se2, Me2, true, (et2) => {
                let { marker: ct2 } = et2;
                return ct2 === F3;
              });
              return [xe2("expression"), S3(Me2, Se2) ? "" : ft2, Ue2 ? [" ", Ue2] : ""];
            }
            case "ParenthesizedExpression":
              return !A3(_e2.expression) && (_e2.expression.type === "ObjectExpression" || _e2.expression.type === "ArrayExpression") ? ["(", xe2("expression"), ")"] : o3(["(", c3([r3, xe2("expression")]), r3, ")"]);
            case "AssignmentExpression":
              return le2(Se2, Me2, xe2);
            case "VariableDeclarator":
              return Ge2(Se2, Me2, xe2);
            case "BinaryExpression":
            case "LogicalExpression":
              return G3(Se2, Me2, xe2);
            case "AssignmentPattern":
              return [xe2("left"), " = ", xe2("right")];
            case "OptionalMemberExpression":
            case "MemberExpression":
              return K3(Se2, Me2, xe2);
            case "MetaProperty":
              return [xe2("meta"), ".", xe2("property")];
            case "BindExpression":
              return _e2.object && Le2.push(xe2("object")), Le2.push(o3(c3([r3, L3(Se2, Me2, xe2)]))), Le2;
            case "Identifier":
              return [_e2.name, U3(Se2), Z3(Se2), ee2(Se2, Me2, xe2)];
            case "V8IntrinsicIdentifier":
              return ["%", _e2.name];
            case "SpreadElement":
            case "SpreadElementPattern":
            case "SpreadProperty":
            case "SpreadPropertyPattern":
            case "RestElement":
              return O3(Se2, Me2, xe2);
            case "FunctionDeclaration":
            case "FunctionExpression":
              return Fe2(Se2, xe2, Me2, mt2);
            case "ArrowFunctionExpression":
              return ve2(Se2, Me2, xe2, mt2);
            case "YieldExpression":
              return Le2.push("yield"), _e2.delegate && Le2.push("*"), _e2.argument && Le2.push(" ", xe2("argument")), Le2;
            case "AwaitExpression": {
              if (Le2.push("await"), _e2.argument) {
                Le2.push(" ", xe2("argument"));
                let Ue2 = Se2.getParentNode();
                if (T3(Ue2) && Ue2.callee === _e2 || D3(Ue2) && Ue2.object === _e2) {
                  Le2 = [c3([r3, ...Le2]), r3];
                  let et2 = Se2.findAncestor((ct2) => ct2.type === "AwaitExpression" || ct2.type === "BlockStatement");
                  if (!et2 || et2.type !== "AwaitExpression")
                    return o3(Le2);
                }
              }
              return Le2;
            }
            case "ExportDefaultDeclaration":
            case "ExportNamedDeclaration":
              return ge2(Se2, Me2, xe2);
            case "ExportAllDeclaration":
              return q3(Se2, Me2, xe2);
            case "ImportDeclaration":
              return te2(Se2, Me2, xe2);
            case "ImportSpecifier":
            case "ExportSpecifier":
            case "ImportNamespaceSpecifier":
            case "ExportNamespaceSpecifier":
            case "ImportDefaultSpecifier":
            case "ExportDefaultSpecifier":
              return z3(Se2, Me2, xe2);
            case "ImportAttribute":
              return [xe2("key"), ": ", xe2("value")];
            case "Import":
              return "import";
            case "BlockStatement":
            case "StaticBlock":
            case "ClassBody":
              return de2(Se2, Me2, xe2);
            case "ThrowStatement":
              return Ze2(Se2, Me2, xe2);
            case "ReturnStatement":
              return tt2(Se2, Me2, xe2);
            case "NewExpression":
            case "ImportExpression":
            case "OptionalCallExpression":
            case "CallExpression":
              return $e2(Se2, Me2, xe2);
            case "ObjectExpression":
            case "ObjectPattern":
            case "RecordExpression":
              return Q3(Se2, Me2, xe2);
            case "ObjectProperty":
            case "Property":
              return _e2.method || _e2.kind === "get" || _e2.kind === "set" ? Re2(Se2, Me2, xe2) : he2(Se2, Me2, xe2);
            case "ObjectMethod":
              return Re2(Se2, Me2, xe2);
            case "Decorator":
              return ["@", xe2("expression")];
            case "ArrayExpression":
            case "ArrayPattern":
            case "TupleExpression":
              return we2(Se2, Me2, xe2);
            case "SequenceExpression": {
              let Ue2 = Se2.getParentNode(0);
              if (Ue2.type === "ExpressionStatement" || Ue2.type === "ForStatement") {
                let et2 = [];
                return Se2.each((ct2, Oe2) => {
                  Oe2 === 0 ? et2.push(xe2()) : et2.push(",", c3([e28, xe2()]));
                }, "expressions"), o3(et2);
              }
              return o3(a3([",", e28], Se2.map(xe2, "expressions")));
            }
            case "ThisExpression":
              return "this";
            case "Super":
              return "super";
            case "Directive":
              return [xe2("value"), ft2];
            case "DirectiveLiteral":
              return ie2(_e2.extra.raw, Me2);
            case "UnaryExpression":
              return Le2.push(_e2.operator), /[a-z]$/.test(_e2.operator) && Le2.push(" "), A3(_e2.argument) ? Le2.push(o3(["(", c3([r3, xe2("argument")]), r3, ")"])) : Le2.push(xe2("argument")), Le2;
            case "UpdateExpression":
              return Le2.push(xe2("argument"), _e2.operator), _e2.prefix && Le2.reverse(), Le2;
            case "ConditionalExpression":
              return De2(Se2, Me2, xe2);
            case "VariableDeclaration": {
              let Ue2 = Se2.map(xe2, "declarations"), et2 = Se2.getParentNode(), ct2 = et2.type === "ForStatement" || et2.type === "ForInStatement" || et2.type === "ForOfStatement", Oe2 = _e2.declarations.some((Ye2) => Ye2.init), He2;
              return Ue2.length === 1 && !A3(_e2.declarations[0]) ? He2 = Ue2[0] : Ue2.length > 0 && (He2 = c3(Ue2[0])), Le2 = [_e2.declare ? "declare " : "", _e2.kind, He2 ? [" ", He2] : "", c3(Ue2.slice(1).map((Ye2) => [",", Oe2 && !ct2 ? n3 : e28, Ye2]))], ct2 && et2.body !== _e2 || Le2.push(ft2), o3(Le2);
            }
            case "WithStatement":
              return o3(["with (", xe2("object"), ")", R3(_e2.body, xe2("body"))]);
            case "IfStatement": {
              let Ue2 = R3(_e2.consequent, xe2("consequent")), et2 = o3(["if (", o3([c3([r3, xe2("test")]), r3]), ")", Ue2]);
              if (Le2.push(et2), _e2.alternate) {
                let ct2 = A3(_e2.consequent, N3.Trailing | N3.Line) || J3(_e2), Oe2 = _e2.consequent.type === "BlockStatement" && !ct2;
                Le2.push(Oe2 ? " " : n3), A3(_e2, N3.Dangling) && Le2.push(t3(Se2, Me2, true), ct2 ? n3 : " "), Le2.push("else", o3(R3(_e2.alternate, xe2("alternate"), _e2.alternate.type === "IfStatement")));
              }
              return Le2;
            }
            case "ForStatement": {
              let Ue2 = R3(_e2.body, xe2("body")), et2 = t3(Se2, Me2, true), ct2 = et2 ? [et2, r3] : "";
              return !_e2.init && !_e2.test && !_e2.update ? [ct2, o3(["for (;;)", Ue2])] : [ct2, o3(["for (", o3([c3([r3, xe2("init"), ";", e28, xe2("test"), ";", e28, xe2("update")]), r3]), ")", Ue2])];
            }
            case "WhileStatement":
              return o3(["while (", o3([c3([r3, xe2("test")]), r3]), ")", R3(_e2.body, xe2("body"))]);
            case "ForInStatement":
              return o3(["for (", xe2("left"), " in ", xe2("right"), ")", R3(_e2.body, xe2("body"))]);
            case "ForOfStatement":
              return o3(["for", _e2.await ? " await" : "", " (", xe2("left"), " of ", xe2("right"), ")", R3(_e2.body, xe2("body"))]);
            case "DoWhileStatement": {
              let Ue2 = R3(_e2.body, xe2("body"));
              return Le2 = [o3(["do", Ue2])], _e2.body.type === "BlockStatement" ? Le2.push(" ") : Le2.push(n3), Le2.push("while (", o3([c3([r3, xe2("test")]), r3]), ")", ft2), Le2;
            }
            case "DoExpression":
              return [_e2.async ? "async " : "", "do ", xe2("body")];
            case "BreakStatement":
              return Le2.push("break"), _e2.label && Le2.push(" ", xe2("label")), Le2.push(ft2), Le2;
            case "ContinueStatement":
              return Le2.push("continue"), _e2.label && Le2.push(" ", xe2("label")), Le2.push(ft2), Le2;
            case "LabeledStatement":
              return _e2.body.type === "EmptyStatement" ? [xe2("label"), ":;"] : [xe2("label"), ": ", xe2("body")];
            case "TryStatement":
              return ["try ", xe2("block"), _e2.handler ? [" ", xe2("handler")] : "", _e2.finalizer ? [" finally ", xe2("finalizer")] : ""];
            case "CatchClause":
              if (_e2.param) {
                let Ue2 = A3(_e2.param, (ct2) => !E3(ct2) || ct2.leading && s3(Me2.originalText, g3(ct2)) || ct2.trailing && s3(Me2.originalText, i(ct2), { backwards: true })), et2 = xe2("param");
                return ["catch ", Ue2 ? ["(", c3([r3, et2]), r3, ") "] : ["(", et2, ") "], xe2("body")];
              }
              return ["catch ", xe2("body")];
            case "SwitchStatement":
              return [o3(["switch (", c3([r3, xe2("discriminant")]), r3, ")"]), " {", _e2.cases.length > 0 ? c3([n3, a3(n3, Se2.map((Ue2, et2, ct2) => {
                let Oe2 = Ue2.getValue();
                return [xe2(), et2 !== ct2.length - 1 && k3(Oe2, Me2) ? n3 : ""];
              }, "cases"))]) : "", n3, "}"];
            case "SwitchCase": {
              _e2.test ? Le2.push("case ", xe2("test"), ":") : Le2.push("default:"), A3(_e2, N3.Dangling) && Le2.push(" ", t3(Se2, Me2, true));
              let Ue2 = _e2.consequent.filter((et2) => et2.type !== "EmptyStatement");
              if (Ue2.length > 0) {
                let et2 = me2(Se2, Me2, xe2);
                Le2.push(Ue2.length === 1 && Ue2[0].type === "BlockStatement" ? [" ", et2] : c3([n3, et2]));
              }
              return Le2;
            }
            case "DebuggerStatement":
              return ["debugger", ft2];
            case "ClassDeclaration":
            case "ClassExpression":
              return W3(Se2, Me2, xe2);
            case "ClassMethod":
            case "ClassPrivateMethod":
            case "MethodDefinition":
              return ne2(Se2, Me2, xe2);
            case "ClassProperty":
            case "PropertyDefinition":
            case "ClassPrivateProperty":
            case "ClassAccessorProperty":
            case "AccessorProperty":
              return re2(Se2, Me2, xe2);
            case "TemplateElement":
              return h3(_e2.value.raw);
            case "TemplateLiteral":
              return fe2(Se2, xe2, Me2);
            case "TaggedTemplateExpression":
              return [xe2("tag"), xe2("typeParameters"), xe2("quasi")];
            case "PrivateIdentifier":
              return ["#", xe2("name")];
            case "PrivateName":
              return ["#", xe2("id")];
            case "InterpreterDirective":
              return Le2.push("#!", _e2.value, n3), k3(_e2, Me2) && Le2.push(n3), Le2;
            case "TopicReference":
              return "%";
            case "ArgumentPlaceholder":
              return "?";
            case "ModuleExpression": {
              Le2.push("module {");
              let Ue2 = xe2("body");
              return Ue2 && Le2.push(c3([n3, Ue2]), n3), Le2.push("}"), Le2;
            }
            default:
              throw new Error("unknown type: " + JSON.stringify(_e2.type));
          }
        }
        function Ae2(Se2) {
          return Se2.type && !E3(Se2) && !j3(Se2) && Se2.type !== "EmptyStatement" && Se2.type !== "TemplateElement" && Se2.type !== "Import" && Se2.type !== "TSEmptyBodyFunctionExpression";
        }
        l3.exports = { preprocess: w3, print: Y3, embed: m3, insertPragma: p3, massageAstNode: y3, hasPrettierIgnore(Se2) {
          return f3(Se2) || M3(Se2);
        }, willPrintOwnComments: d3.willPrintOwnComments, canAttachComment: Ae2, printComment: Be2, isBlockComment: E3, handleComments: { avoidAstMutation: true, ownLine: d3.handleOwnLineComment, endOfLine: d3.handleEndOfLineComment, remaining: d3.handleRemainingComment }, getCommentChildNodes: d3.getCommentChildNodes };
      } }), Bs2 = X3({ "src/language-js/printer-estree-json.js"(u3, l3) {
        H3();
        var { builders: { hardline: t3, indent: s3, join: a3 } } = Qe2(), e28 = Nu2();
        function n3(h3, m3, y3) {
          let p3 = h3.getValue();
          switch (p3.type) {
            case "JsonRoot":
              return [y3("node"), t3];
            case "ArrayExpression": {
              if (p3.elements.length === 0)
                return "[]";
              let d3 = h3.map(() => h3.getValue() === null ? "null" : y3(), "elements");
              return ["[", s3([t3, a3([",", t3], d3)]), t3, "]"];
            }
            case "ObjectExpression":
              return p3.properties.length === 0 ? "{}" : ["{", s3([t3, a3([",", t3], h3.map(y3, "properties"))]), t3, "}"];
            case "ObjectProperty":
              return [y3("key"), ": ", y3("value")];
            case "UnaryExpression":
              return [p3.operator === "+" ? "" : p3.operator, y3("argument")];
            case "NullLiteral":
              return "null";
            case "BooleanLiteral":
              return p3.value ? "true" : "false";
            case "StringLiteral":
              return JSON.stringify(p3.value);
            case "NumericLiteral":
              return r3(h3) ? JSON.stringify(String(p3.value)) : JSON.stringify(p3.value);
            case "Identifier":
              return r3(h3) ? JSON.stringify(p3.name) : p3.name;
            case "TemplateLiteral":
              return y3(["quasis", 0]);
            case "TemplateElement":
              return JSON.stringify(p3.value.cooked);
            default:
              throw new Error("unknown type: " + JSON.stringify(p3.type));
          }
        }
        function r3(h3) {
          return h3.getName() === "key" && h3.getParentNode().type === "ObjectProperty";
        }
        var o3 = /* @__PURE__ */ new Set(["start", "end", "extra", "loc", "comments", "leadingComments", "trailingComments", "innerComments", "errors", "range", "tokens"]);
        function c3(h3, m3) {
          let { type: y3 } = h3;
          if (y3 === "ObjectProperty") {
            let { key: p3 } = h3;
            p3.type === "Identifier" ? m3.key = { type: "StringLiteral", value: p3.name } : p3.type === "NumericLiteral" && (m3.key = { type: "StringLiteral", value: String(p3.value) });
            return;
          }
          if (y3 === "UnaryExpression" && h3.operator === "+")
            return m3.argument;
          if (y3 === "ArrayExpression") {
            for (let [p3, d3] of h3.elements.entries())
              d3 === null && m3.elements.splice(p3, 0, { type: "NullLiteral" });
            return;
          }
          if (y3 === "TemplateLiteral")
            return { type: "StringLiteral", value: h3.quasis[0].value.cooked };
        }
        c3.ignoredProperties = o3, l3.exports = { preprocess: e28, print: n3, massageAstNode: c3 };
      } }), en2 = X3({ "src/common/common-options.js"(u3, l3) {
        H3();
        var t3 = "Common";
        l3.exports = { bracketSpacing: { since: "0.0.0", category: t3, type: "boolean", default: true, description: "Print spaces between brackets.", oppositeDescription: "Do not print spaces between brackets." }, singleQuote: { since: "0.0.0", category: t3, type: "boolean", default: false, description: "Use single quotes instead of double quotes." }, proseWrap: { since: "1.8.2", category: t3, type: "choice", default: [{ since: "1.8.2", value: true }, { since: "1.9.0", value: "preserve" }], description: "How to wrap prose.", choices: [{ since: "1.9.0", value: "always", description: "Wrap prose if it exceeds the print width." }, { since: "1.9.0", value: "never", description: "Do not wrap prose." }, { since: "1.9.0", value: "preserve", description: "Wrap prose as-is." }] }, bracketSameLine: { since: "2.4.0", category: t3, type: "boolean", default: false, description: "Put > of opening tags on the last line instead of on a new line." }, singleAttributePerLine: { since: "2.6.0", category: t3, type: "boolean", default: false, description: "Enforce single attribute per line in HTML, Vue and JSX." } };
      } }), ws2 = X3({ "src/language-js/options.js"(u3, l3) {
        H3();
        var t3 = en2(), s3 = "JavaScript";
        l3.exports = { arrowParens: { since: "1.9.0", category: s3, type: "choice", default: [{ since: "1.9.0", value: "avoid" }, { since: "2.0.0", value: "always" }], description: "Include parentheses around a sole arrow function parameter.", choices: [{ value: "always", description: "Always include parens. Example: `(x) => x`" }, { value: "avoid", description: "Omit parens when possible. Example: `x => x`" }] }, bracketSameLine: t3.bracketSameLine, bracketSpacing: t3.bracketSpacing, jsxBracketSameLine: { since: "0.17.0", category: s3, type: "boolean", description: "Put > on the last line instead of at a new line.", deprecated: "2.4.0" }, semi: { since: "1.0.0", category: s3, type: "boolean", default: true, description: "Print semicolons.", oppositeDescription: "Do not print semicolons, except at the beginning of lines which may need them." }, singleQuote: t3.singleQuote, jsxSingleQuote: { since: "1.15.0", category: s3, type: "boolean", default: false, description: "Use single quotes in JSX." }, quoteProps: { since: "1.17.0", category: s3, type: "choice", default: "as-needed", description: "Change when properties in objects are quoted.", choices: [{ value: "as-needed", description: "Only add quotes around object properties where required." }, { value: "consistent", description: "If at least one property in an object requires quotes, quote all properties." }, { value: "preserve", description: "Respect the input use of quotes in object properties." }] }, trailingComma: { since: "0.0.0", category: s3, type: "choice", default: [{ since: "0.0.0", value: false }, { since: "0.19.0", value: "none" }, { since: "2.0.0", value: "es5" }], description: "Print trailing commas wherever possible when multi-line.", choices: [{ value: "es5", description: "Trailing commas where valid in ES5 (objects, arrays, etc.)" }, { value: "none", description: "No trailing commas." }, { value: "all", description: "Trailing commas wherever possible (including function arguments)." }] }, singleAttributePerLine: t3.singleAttributePerLine };
      } }), Ns2 = X3({ "src/language-js/parse/parsers.js"() {
        H3();
      } }), dr2 = X3({ "node_modules/linguist-languages/data/JavaScript.json"(u3, l3) {
        l3.exports = { name: "JavaScript", type: "programming", tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "text/javascript", color: "#f1e05a", aliases: ["js", "node"], extensions: [".js", "._js", ".bones", ".cjs", ".es", ".es6", ".frag", ".gs", ".jake", ".javascript", ".jsb", ".jscad", ".jsfl", ".jslib", ".jsm", ".jspre", ".jss", ".jsx", ".mjs", ".njs", ".pac", ".sjs", ".ssjs", ".xsjs", ".xsjslib"], filenames: ["Jakefile"], interpreters: ["chakra", "d8", "gjs", "js", "node", "nodejs", "qjs", "rhino", "v8", "v8-shell"], languageId: 183 };
      } }), ks2 = X3({ "node_modules/linguist-languages/data/TypeScript.json"(u3, l3) {
        l3.exports = { name: "TypeScript", type: "programming", color: "#3178c6", aliases: ["ts"], interpreters: ["deno", "ts-node"], extensions: [".ts", ".cts", ".mts"], tmScope: "source.ts", aceMode: "typescript", codemirrorMode: "javascript", codemirrorMimeType: "application/typescript", languageId: 378 };
      } }), Ps2 = X3({ "node_modules/linguist-languages/data/TSX.json"(u3, l3) {
        l3.exports = { name: "TSX", type: "programming", color: "#3178c6", group: "TypeScript", extensions: [".tsx"], tmScope: "source.tsx", aceMode: "javascript", codemirrorMode: "jsx", codemirrorMimeType: "text/jsx", languageId: 94901924 };
      } }), $u2 = X3({ "node_modules/linguist-languages/data/JSON.json"(u3, l3) {
        l3.exports = { name: "JSON", type: "data", color: "#292929", tmScope: "source.json", aceMode: "json", codemirrorMode: "javascript", codemirrorMimeType: "application/json", aliases: ["geojson", "jsonl", "topojson"], extensions: [".json", ".4DForm", ".4DProject", ".avsc", ".geojson", ".gltf", ".har", ".ice", ".JSON-tmLanguage", ".jsonl", ".mcmeta", ".tfstate", ".tfstate.backup", ".topojson", ".webapp", ".webmanifest", ".yy", ".yyp"], filenames: [".arcconfig", ".auto-changelog", ".c8rc", ".htmlhintrc", ".imgbotconfig", ".nycrc", ".tern-config", ".tern-project", ".watchmanconfig", "Pipfile.lock", "composer.lock", "mcmod.info"], languageId: 174 };
      } }), js2 = X3({ "node_modules/linguist-languages/data/JSON with Comments.json"(u3, l3) {
        l3.exports = { name: "JSON with Comments", type: "data", color: "#292929", group: "JSON", tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "text/javascript", aliases: ["jsonc"], extensions: [".jsonc", ".code-snippets", ".sublime-build", ".sublime-commands", ".sublime-completions", ".sublime-keymap", ".sublime-macro", ".sublime-menu", ".sublime-mousemap", ".sublime-project", ".sublime-settings", ".sublime-theme", ".sublime-workspace", ".sublime_metrics", ".sublime_session"], filenames: [".babelrc", ".devcontainer.json", ".eslintrc.json", ".jscsrc", ".jshintrc", ".jslintrc", "api-extractor.json", "devcontainer.json", "jsconfig.json", "language-configuration.json", "tsconfig.json", "tslint.json"], languageId: 423 };
      } }), Is2 = X3({ "node_modules/linguist-languages/data/JSON5.json"(u3, l3) {
        l3.exports = { name: "JSON5", type: "data", color: "#267CB9", extensions: [".json5"], tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "application/json", languageId: 175 };
      } }), Ls2 = X3({ "src/language-js/index.js"(u3, l3) {
        H3();
        var t3 = Gt2(), s3 = Ts2(), a3 = Bs2(), e28 = ws2(), n3 = Ns2(), r3 = [t3(dr2(), (c3) => ({ since: "0.0.0", parsers: ["babel", "acorn", "espree", "meriyah", "babel-flow", "babel-ts", "flow", "typescript"], vscodeLanguageIds: ["javascript", "mongo"], interpreters: [...c3.interpreters, "zx"], extensions: [...c3.extensions.filter((h3) => h3 !== ".jsx"), ".wxs"] })), t3(dr2(), () => ({ name: "Flow", since: "0.0.0", parsers: ["flow", "babel-flow"], vscodeLanguageIds: ["javascript"], aliases: [], filenames: [], extensions: [".js.flow"] })), t3(dr2(), () => ({ name: "JSX", since: "0.0.0", parsers: ["babel", "babel-flow", "babel-ts", "flow", "typescript", "espree", "meriyah"], vscodeLanguageIds: ["javascriptreact"], aliases: void 0, filenames: void 0, extensions: [".jsx"], group: "JavaScript", interpreters: void 0, tmScope: "source.js.jsx", aceMode: "javascript", codemirrorMode: "jsx", codemirrorMimeType: "text/jsx", color: void 0 })), t3(ks2(), () => ({ since: "1.4.0", parsers: ["typescript", "babel-ts"], vscodeLanguageIds: ["typescript"] })), t3(Ps2(), () => ({ since: "1.4.0", parsers: ["typescript", "babel-ts"], vscodeLanguageIds: ["typescriptreact"] })), t3($u2(), () => ({ name: "JSON.stringify", since: "1.13.0", parsers: ["json-stringify"], vscodeLanguageIds: ["json"], extensions: [".importmap"], filenames: ["package.json", "package-lock.json", "composer.json"] })), t3($u2(), (c3) => ({ since: "1.5.0", parsers: ["json"], vscodeLanguageIds: ["json"], extensions: c3.extensions.filter((h3) => h3 !== ".jsonl") })), t3(js2(), (c3) => ({ since: "1.5.0", parsers: ["json"], vscodeLanguageIds: ["jsonc"], filenames: [...c3.filenames, ".eslintrc", ".swcrc"] })), t3(Is2(), () => ({ since: "1.13.0", parsers: ["json5"], vscodeLanguageIds: ["json5"] }))], o3 = { estree: s3, "estree-json": a3 };
        l3.exports = { languages: r3, options: e28, printers: o3, parsers: n3 };
      } }), _s2 = X3({ "src/language-css/clean.js"(u3, l3) {
        H3();
        var { isFrontMatterNode: t3 } = at2(), s3 = Ct2(), a3 = /* @__PURE__ */ new Set(["raw", "raws", "sourceIndex", "source", "before", "after", "trailingComma"]);
        function e28(r3, o3, c3) {
          if (t3(r3) && r3.lang === "yaml" && delete o3.value, r3.type === "css-comment" && c3.type === "css-root" && c3.nodes.length > 0 && ((c3.nodes[0] === r3 || t3(c3.nodes[0]) && c3.nodes[1] === r3) && (delete o3.text, /^\*\s*@(?:format|prettier)\s*$/.test(r3.text)) || c3.type === "css-root" && s3(c3.nodes) === r3))
            return null;
          if (r3.type === "value-root" && delete o3.text, (r3.type === "media-query" || r3.type === "media-query-list" || r3.type === "media-feature-expression") && delete o3.value, r3.type === "css-rule" && delete o3.params, r3.type === "selector-combinator" && (o3.value = o3.value.replace(/\s+/g, " ")), r3.type === "media-feature" && (o3.value = o3.value.replace(/ /g, "")), (r3.type === "value-word" && (r3.isColor && r3.isHex || ["initial", "inherit", "unset", "revert"].includes(o3.value.replace().toLowerCase())) || r3.type === "media-feature" || r3.type === "selector-root-invalid" || r3.type === "selector-pseudo") && (o3.value = o3.value.toLowerCase()), r3.type === "css-decl" && (o3.prop = o3.prop.toLowerCase()), (r3.type === "css-atrule" || r3.type === "css-import") && (o3.name = o3.name.toLowerCase()), r3.type === "value-number" && (o3.unit = o3.unit.toLowerCase()), (r3.type === "media-feature" || r3.type === "media-keyword" || r3.type === "media-type" || r3.type === "media-unknown" || r3.type === "media-url" || r3.type === "media-value" || r3.type === "selector-attribute" || r3.type === "selector-string" || r3.type === "selector-class" || r3.type === "selector-combinator" || r3.type === "value-string") && o3.value && (o3.value = n3(o3.value)), r3.type === "selector-attribute" && (o3.attribute = o3.attribute.trim(), o3.namespace && typeof o3.namespace == "string" && (o3.namespace = o3.namespace.trim(), o3.namespace.length === 0 && (o3.namespace = true)), o3.value && (o3.value = o3.value.trim().replace(/^["']|["']$/g, ""), delete o3.quoted)), (r3.type === "media-value" || r3.type === "media-type" || r3.type === "value-number" || r3.type === "selector-root-invalid" || r3.type === "selector-class" || r3.type === "selector-combinator" || r3.type === "selector-tag") && o3.value && (o3.value = o3.value.replace(/([\d+.Ee-]+)([A-Za-z]*)/g, (h3, m3, y3) => {
            let p3 = Number(m3);
            return Number.isNaN(p3) ? h3 : p3 + y3.toLowerCase();
          })), r3.type === "selector-tag") {
            let h3 = r3.value.toLowerCase();
            ["from", "to"].includes(h3) && (o3.value = h3);
          }
          if (r3.type === "css-atrule" && r3.name.toLowerCase() === "supports" && delete o3.value, r3.type === "selector-unknown" && delete o3.value, r3.type === "value-comma_group") {
            let h3 = r3.groups.findIndex((m3) => m3.type === "value-number" && m3.unit === "...");
            h3 !== -1 && (o3.groups[h3].unit = "", o3.groups.splice(h3 + 1, 0, { type: "value-word", value: "...", isColor: false, isHex: false }));
          }
          if (r3.type === "value-comma_group" && r3.groups.some((h3) => h3.type === "value-atword" && h3.value.endsWith("[") || h3.type === "value-word" && h3.value.startsWith("]")))
            return { type: "value-atword", value: r3.groups.map((h3) => h3.value).join(""), group: { open: null, close: null, groups: [], type: "value-paren_group" } };
        }
        e28.ignoredProperties = a3;
        function n3(r3) {
          return r3.replace(/'/g, '"').replace(/\\([^\dA-Fa-f])/g, "$1");
        }
        l3.exports = e28;
      } }), Dr2 = X3({ "src/utils/front-matter/print.js"(u3, l3) {
        H3();
        var { builders: { hardline: t3, markAsRoot: s3 } } = Qe2();
        function a3(e28, n3) {
          if (e28.lang === "yaml") {
            let r3 = e28.value.trim(), o3 = r3 ? n3(r3, { parser: "yaml" }, { stripTrailingHardline: true }) : "";
            return s3([e28.startDelimiter, t3, o3, o3 ? t3 : "", e28.endDelimiter]);
          }
        }
        l3.exports = a3;
      } }), Os2 = X3({ "src/language-css/embed.js"(u3, l3) {
        H3();
        var { builders: { hardline: t3 } } = Qe2(), s3 = Dr2();
        function a3(e28, n3, r3) {
          let o3 = e28.getValue();
          if (o3.type === "front-matter") {
            let c3 = s3(o3, r3);
            return c3 ? [c3, t3] : "";
          }
        }
        l3.exports = a3;
      } }), Ru2 = X3({ "src/utils/front-matter/parse.js"(u3, l3) {
        H3();
        var t3 = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
        function s3(a3) {
          let e28 = a3.match(t3);
          if (!e28)
            return { content: a3 };
          let { startDelimiter: n3, language: r3, value: o3 = "", endDelimiter: c3 } = e28.groups, h3 = r3.trim() || "yaml";
          if (n3 === "+++" && (h3 = "toml"), h3 !== "yaml" && n3 !== c3)
            return { content: a3 };
          let [m3] = e28;
          return { frontMatter: { type: "front-matter", lang: h3, value: o3, startDelimiter: n3, endDelimiter: c3, raw: m3.replace(/\n$/, "") }, content: m3.replace(/[^\n]/g, " ") + a3.slice(m3.length) };
        }
        l3.exports = s3;
      } }), Ms2 = X3({ "src/language-css/pragma.js"(u3, l3) {
        H3();
        var t3 = Bu2(), s3 = Ru2();
        function a3(n3) {
          return t3.hasPragma(s3(n3).content);
        }
        function e28(n3) {
          let { frontMatter: r3, content: o3 } = s3(n3);
          return (r3 ? r3.raw + `

` : "") + t3.insertPragma(o3);
        }
        l3.exports = { hasPragma: a3, insertPragma: e28 };
      } }), $s2 = X3({ "src/language-css/utils/index.js"(u3, l3) {
        H3();
        var t3 = /* @__PURE__ */ new Set(["red", "green", "blue", "alpha", "a", "rgb", "hue", "h", "saturation", "s", "lightness", "l", "whiteness", "w", "blackness", "b", "tint", "shade", "blend", "blenda", "contrast", "hsl", "hsla", "hwb", "hwba"]);
        function s3(Q3, W3) {
          let ne2 = Array.isArray(W3) ? W3 : [W3], re2 = -1, he2;
          for (; he2 = Q3.getParentNode(++re2); )
            if (ne2.includes(he2.type))
              return re2;
          return -1;
        }
        function a3(Q3, W3) {
          let ne2 = s3(Q3, W3);
          return ne2 === -1 ? null : Q3.getParentNode(ne2);
        }
        function e28(Q3) {
          var W3;
          let ne2 = a3(Q3, "css-decl");
          return ne2 == null || (W3 = ne2.prop) === null || W3 === void 0 ? void 0 : W3.toLowerCase();
        }
        var n3 = /* @__PURE__ */ new Set(["initial", "inherit", "unset", "revert"]);
        function r3(Q3) {
          return n3.has(Q3.toLowerCase());
        }
        function o3(Q3, W3) {
          let ne2 = a3(Q3, "css-atrule");
          return (ne2 == null ? void 0 : ne2.name) && ne2.name.toLowerCase().endsWith("keyframes") && ["from", "to"].includes(W3.toLowerCase());
        }
        function c3(Q3) {
          return Q3.includes("$") || Q3.includes("@") || Q3.includes("#") || Q3.startsWith("%") || Q3.startsWith("--") || Q3.startsWith(":--") || Q3.includes("(") && Q3.includes(")") ? Q3 : Q3.toLowerCase();
        }
        function h3(Q3, W3) {
          var ne2;
          let re2 = a3(Q3, "value-func");
          return (re2 == null || (ne2 = re2.value) === null || ne2 === void 0 ? void 0 : ne2.toLowerCase()) === W3;
        }
        function m3(Q3) {
          var W3;
          let ne2 = a3(Q3, "css-rule"), re2 = ne2 == null || (W3 = ne2.raws) === null || W3 === void 0 ? void 0 : W3.selector;
          return re2 && (re2.startsWith(":import") || re2.startsWith(":export"));
        }
        function y3(Q3, W3) {
          let ne2 = Array.isArray(W3) ? W3 : [W3], re2 = a3(Q3, "css-atrule");
          return re2 && ne2.includes(re2.name.toLowerCase());
        }
        function p3(Q3) {
          let W3 = Q3.getValue(), ne2 = a3(Q3, "css-atrule");
          return (ne2 == null ? void 0 : ne2.name) === "import" && W3.groups[0].value === "url" && W3.groups.length === 2;
        }
        function d3(Q3) {
          return Q3.type === "value-func" && Q3.value.toLowerCase() === "url";
        }
        function C3(Q3, W3) {
          var ne2;
          let re2 = (ne2 = Q3.getParentNode()) === null || ne2 === void 0 ? void 0 : ne2.nodes;
          return re2 && re2.indexOf(W3) === re2.length - 1;
        }
        function w3(Q3) {
          let { selector: W3 } = Q3;
          return W3 ? typeof W3 == "string" && /^@.+:.*$/.test(W3) || W3.value && /^@.+:.*$/.test(W3.value) : false;
        }
        function P3(Q3) {
          return Q3.type === "value-word" && ["from", "through", "end"].includes(Q3.value);
        }
        function A3(Q3) {
          return Q3.type === "value-word" && ["and", "or", "not"].includes(Q3.value);
        }
        function N3(Q3) {
          return Q3.type === "value-word" && Q3.value === "in";
        }
        function S3(Q3) {
          return Q3.type === "value-operator" && Q3.value === "*";
        }
        function j3(Q3) {
          return Q3.type === "value-operator" && Q3.value === "/";
        }
        function k3(Q3) {
          return Q3.type === "value-operator" && Q3.value === "+";
        }
        function J3(Q3) {
          return Q3.type === "value-operator" && Q3.value === "-";
        }
        function f3(Q3) {
          return Q3.type === "value-operator" && Q3.value === "%";
        }
        function T3(Q3) {
          return S3(Q3) || j3(Q3) || k3(Q3) || J3(Q3) || f3(Q3);
        }
        function D3(Q3) {
          return Q3.type === "value-word" && ["==", "!="].includes(Q3.value);
        }
        function F3(Q3) {
          return Q3.type === "value-word" && ["<", ">", "<=", ">="].includes(Q3.value);
        }
        function i(Q3) {
          return Q3.type === "css-atrule" && ["if", "else", "for", "each", "while"].includes(Q3.name);
        }
        function g3(Q3) {
          var W3;
          return ((W3 = Q3.raws) === null || W3 === void 0 ? void 0 : W3.params) && /^\(\s*\)$/.test(Q3.raws.params);
        }
        function E3(Q3) {
          return Q3.name.startsWith("prettier-placeholder");
        }
        function x3(Q3) {
          return Q3.prop.startsWith("@prettier-placeholder");
        }
        function b3(Q3, W3) {
          return Q3.value === "$$" && Q3.type === "value-func" && (W3 == null ? void 0 : W3.type) === "value-word" && !W3.raws.before;
        }
        function B3(Q3) {
          var W3, ne2;
          return ((W3 = Q3.value) === null || W3 === void 0 ? void 0 : W3.type) === "value-root" && ((ne2 = Q3.value.group) === null || ne2 === void 0 ? void 0 : ne2.type) === "value-value" && Q3.prop.toLowerCase() === "composes";
        }
        function I3(Q3) {
          var W3, ne2, re2;
          return ((W3 = Q3.value) === null || W3 === void 0 || (ne2 = W3.group) === null || ne2 === void 0 || (re2 = ne2.group) === null || re2 === void 0 ? void 0 : re2.type) === "value-paren_group" && Q3.value.group.group.open !== null && Q3.value.group.group.close !== null;
        }
        function M3(Q3) {
          var W3;
          return ((W3 = Q3.raws) === null || W3 === void 0 ? void 0 : W3.before) === "";
        }
        function V10(Q3) {
          var W3, ne2;
          return Q3.type === "value-comma_group" && ((W3 = Q3.groups) === null || W3 === void 0 || (ne2 = W3[1]) === null || ne2 === void 0 ? void 0 : ne2.type) === "value-colon";
        }
        function $3(Q3) {
          var W3;
          return Q3.type === "value-paren_group" && ((W3 = Q3.groups) === null || W3 === void 0 ? void 0 : W3[0]) && V10(Q3.groups[0]);
        }
        function U3(Q3) {
          var W3;
          let ne2 = Q3.getValue();
          if (ne2.groups.length === 0)
            return false;
          let re2 = Q3.getParentNode(1);
          if (!$3(ne2) && !(re2 && $3(re2)))
            return false;
          let he2 = a3(Q3, "css-decl");
          return !!(he2 != null && (W3 = he2.prop) !== null && W3 !== void 0 && W3.startsWith("$") || $3(re2) || re2.type === "value-func");
        }
        function L3(Q3) {
          return Q3.type === "value-comment" && Q3.inline;
        }
        function ee2(Q3) {
          return Q3.type === "value-word" && Q3.value === "#";
        }
        function R3(Q3) {
          return Q3.type === "value-word" && Q3.value === "{";
        }
        function O3(Q3) {
          return Q3.type === "value-word" && Q3.value === "}";
        }
        function Z3(Q3) {
          return ["value-word", "value-atword"].includes(Q3.type);
        }
        function ie2(Q3) {
          return (Q3 == null ? void 0 : Q3.type) === "value-colon";
        }
        function te2(Q3, W3) {
          if (!V10(W3))
            return false;
          let { groups: ne2 } = W3, re2 = ne2.indexOf(Q3);
          return re2 === -1 ? false : ie2(ne2[re2 + 1]);
        }
        function ge2(Q3) {
          return Q3.value && ["not", "and", "or"].includes(Q3.value.toLowerCase());
        }
        function q3(Q3) {
          return Q3.type !== "value-func" ? false : t3.has(Q3.value.toLowerCase());
        }
        function z3(Q3) {
          return /\/\//.test(Q3.split(/[\n\r]/).pop());
        }
        function De2(Q3) {
          return (Q3 == null ? void 0 : Q3.type) === "value-atword" && Q3.value.startsWith("prettier-placeholder-");
        }
        function fe2(Q3, W3) {
          var ne2, re2;
          if (((ne2 = Q3.open) === null || ne2 === void 0 ? void 0 : ne2.value) !== "(" || ((re2 = Q3.close) === null || re2 === void 0 ? void 0 : re2.value) !== ")" || Q3.groups.some((he2) => he2.type !== "value-comma_group"))
            return false;
          if (W3.type === "value-comma_group") {
            let he2 = W3.groups.indexOf(Q3) - 1, Fe2 = W3.groups[he2];
            if ((Fe2 == null ? void 0 : Fe2.type) === "value-word" && Fe2.value === "with")
              return true;
          }
          return false;
        }
        function we2(Q3) {
          var W3, ne2;
          return Q3.type === "value-paren_group" && ((W3 = Q3.open) === null || W3 === void 0 ? void 0 : W3.value) === "(" && ((ne2 = Q3.close) === null || ne2 === void 0 ? void 0 : ne2.value) === ")";
        }
        l3.exports = { getAncestorCounter: s3, getAncestorNode: a3, getPropOfDeclNode: e28, maybeToLowerCase: c3, insideValueFunctionNode: h3, insideICSSRuleNode: m3, insideAtRuleNode: y3, insideURLFunctionInImportAtRuleNode: p3, isKeyframeAtRuleKeywords: o3, isWideKeywords: r3, isLastNode: C3, isSCSSControlDirectiveNode: i, isDetachedRulesetDeclarationNode: w3, isRelationalOperatorNode: F3, isEqualityOperatorNode: D3, isMultiplicationNode: S3, isDivisionNode: j3, isAdditionNode: k3, isSubtractionNode: J3, isModuloNode: f3, isMathOperatorNode: T3, isEachKeywordNode: N3, isForKeywordNode: P3, isURLFunctionNode: d3, isIfElseKeywordNode: A3, hasComposesNode: B3, hasParensAroundNode: I3, hasEmptyRawBefore: M3, isDetachedRulesetCallNode: g3, isTemplatePlaceholderNode: E3, isTemplatePropNode: x3, isPostcssSimpleVarNode: b3, isKeyValuePairNode: V10, isKeyValuePairInParenGroupNode: $3, isKeyInValuePairNode: te2, isSCSSMapItemNode: U3, isInlineValueCommentNode: L3, isHashNode: ee2, isLeftCurlyBraceNode: R3, isRightCurlyBraceNode: O3, isWordNode: Z3, isColonNode: ie2, isMediaAndSupportsKeywords: ge2, isColorAdjusterFuncNode: q3, lastLineHasInlineComment: z3, isAtWordPlaceholderNode: De2, isConfigurationNode: fe2, isParenGroupNode: we2 };
      } }), Rs2 = X3({ "src/utils/line-column-to-index.js"(u3, l3) {
        H3(), l3.exports = function(t3, s3) {
          let a3 = 0;
          for (let e28 = 0; e28 < t3.line - 1; ++e28)
            a3 = s3.indexOf(`
`, a3) + 1;
          return a3 + t3.column;
        };
      } }), Vs2 = X3({ "src/language-css/loc.js"(u3, l3) {
        H3();
        var { skipEverythingButNewLine: t3 } = bn2(), s3 = Ct2(), a3 = Rs2();
        function e28(p3, d3) {
          return typeof p3.sourceIndex == "number" ? p3.sourceIndex : p3.source ? a3(p3.source.start, d3) - 1 : null;
        }
        function n3(p3, d3) {
          if (p3.type === "css-comment" && p3.inline)
            return t3(d3, p3.source.startOffset);
          let C3 = p3.nodes && s3(p3.nodes);
          return C3 && p3.source && !p3.source.end && (p3 = C3), p3.source && p3.source.end ? a3(p3.source.end, d3) : null;
        }
        function r3(p3, d3) {
          p3.source && (p3.source.startOffset = e28(p3, d3), p3.source.endOffset = n3(p3, d3));
          for (let C3 in p3) {
            let w3 = p3[C3];
            C3 === "source" || !w3 || typeof w3 != "object" || (w3.type === "value-root" || w3.type === "value-unknown" ? o3(w3, c3(p3), w3.text || w3.value) : r3(w3, d3));
          }
        }
        function o3(p3, d3, C3) {
          p3.source && (p3.source.startOffset = e28(p3, C3) + d3, p3.source.endOffset = n3(p3, C3) + d3);
          for (let w3 in p3) {
            let P3 = p3[w3];
            w3 === "source" || !P3 || typeof P3 != "object" || o3(P3, d3, C3);
          }
        }
        function c3(p3) {
          let d3 = p3.source.startOffset;
          return typeof p3.prop == "string" && (d3 += p3.prop.length), p3.type === "css-atrule" && typeof p3.name == "string" && (d3 += 1 + p3.name.length + p3.raws.afterName.match(/^\s*:?\s*/)[0].length), p3.type !== "css-atrule" && p3.raws && typeof p3.raws.between == "string" && (d3 += p3.raws.between.length), d3;
        }
        function h3(p3) {
          let d3 = "initial", C3 = "initial", w3, P3 = false, A3 = [];
          for (let N3 = 0; N3 < p3.length; N3++) {
            let S3 = p3[N3];
            switch (d3) {
              case "initial":
                if (S3 === "'") {
                  d3 = "single-quotes";
                  continue;
                }
                if (S3 === '"') {
                  d3 = "double-quotes";
                  continue;
                }
                if ((S3 === "u" || S3 === "U") && p3.slice(N3, N3 + 4).toLowerCase() === "url(") {
                  d3 = "url", N3 += 3;
                  continue;
                }
                if (S3 === "*" && p3[N3 - 1] === "/") {
                  d3 = "comment-block";
                  continue;
                }
                if (S3 === "/" && p3[N3 - 1] === "/") {
                  d3 = "comment-inline", w3 = N3 - 1;
                  continue;
                }
                continue;
              case "single-quotes":
                if (S3 === "'" && p3[N3 - 1] !== "\\" && (d3 = C3, C3 = "initial"), S3 === `
` || S3 === "\r")
                  return p3;
                continue;
              case "double-quotes":
                if (S3 === '"' && p3[N3 - 1] !== "\\" && (d3 = C3, C3 = "initial"), S3 === `
` || S3 === "\r")
                  return p3;
                continue;
              case "url":
                if (S3 === ")" && (d3 = "initial"), S3 === `
` || S3 === "\r")
                  return p3;
                if (S3 === "'") {
                  d3 = "single-quotes", C3 = "url";
                  continue;
                }
                if (S3 === '"') {
                  d3 = "double-quotes", C3 = "url";
                  continue;
                }
                continue;
              case "comment-block":
                S3 === "/" && p3[N3 - 1] === "*" && (d3 = "initial");
                continue;
              case "comment-inline":
                (S3 === '"' || S3 === "'" || S3 === "*") && (P3 = true), (S3 === `
` || S3 === "\r") && (P3 && A3.push([w3, N3]), d3 = "initial", P3 = false);
                continue;
            }
          }
          for (let [N3, S3] of A3)
            p3 = p3.slice(0, N3) + p3.slice(N3, S3).replace(/["'*]/g, " ") + p3.slice(S3);
          return p3;
        }
        function m3(p3) {
          return p3.source.startOffset;
        }
        function y3(p3) {
          return p3.source.endOffset;
        }
        l3.exports = { locStart: m3, locEnd: y3, calculateLoc: r3, replaceQuotesInInlineComments: h3 };
      } }), Js2 = X3({ "src/language-css/utils/is-less-parser.js"(u3, l3) {
        H3();
        function t3(s3) {
          return s3.parser === "css" || s3.parser === "less";
        }
        l3.exports = t3;
      } }), qs2 = X3({ "src/language-css/utils/is-scss.js"(u3, l3) {
        H3();
        function t3(s3, a3) {
          return s3 === "less" || s3 === "scss" ? s3 === "scss" : /(?:\w\s*:\s*[^:}]+|#){|@import[^\n]+(?:url|,)/.test(a3);
        }
        l3.exports = t3;
      } }), Gs2 = X3({ "src/language-css/utils/css-units.evaluate.js"(u3, l3) {
        l3.exports = { em: "em", rem: "rem", ex: "ex", rex: "rex", cap: "cap", rcap: "rcap", ch: "ch", rch: "rch", ic: "ic", ric: "ric", lh: "lh", rlh: "rlh", vw: "vw", svw: "svw", lvw: "lvw", dvw: "dvw", vh: "vh", svh: "svh", lvh: "lvh", dvh: "dvh", vi: "vi", svi: "svi", lvi: "lvi", dvi: "dvi", vb: "vb", svb: "svb", lvb: "lvb", dvb: "dvb", vmin: "vmin", svmin: "svmin", lvmin: "lvmin", dvmin: "dvmin", vmax: "vmax", svmax: "svmax", lvmax: "lvmax", dvmax: "dvmax", cm: "cm", mm: "mm", q: "Q", in: "in", pt: "pt", pc: "pc", px: "px", deg: "deg", grad: "grad", rad: "rad", turn: "turn", s: "s", ms: "ms", hz: "Hz", khz: "kHz", dpi: "dpi", dpcm: "dpcm", dppx: "dppx", x: "x" };
      } }), Ws2 = X3({ "src/language-css/utils/print-unit.js"(u3, l3) {
        H3();
        var t3 = Gs2();
        function s3(a3) {
          let e28 = a3.toLowerCase();
          return Object.prototype.hasOwnProperty.call(t3, e28) ? t3[e28] : a3;
        }
        l3.exports = s3;
      } }), Xs2 = X3({ "src/language-css/printer-postcss.js"(u3, l3) {
        H3();
        var t3 = Ct2(), { printNumber: s3, printString: a3, hasNewline: e28, isFrontMatterNode: n3, isNextLineEmpty: r3, isNonEmptyArray: o3 } = at2(), { builders: { join: c3, line: h3, hardline: m3, softline: y3, group: p3, fill: d3, indent: C3, dedent: w3, ifBreak: P3, breakParent: A3 }, utils: { removeLines: N3, getDocParts: S3 } } = Qe2(), j3 = _s2(), k3 = Os2(), { insertPragma: J3 } = Ms2(), { getAncestorNode: f3, getPropOfDeclNode: T3, maybeToLowerCase: D3, insideValueFunctionNode: F3, insideICSSRuleNode: i, insideAtRuleNode: g3, insideURLFunctionInImportAtRuleNode: E3, isKeyframeAtRuleKeywords: x3, isWideKeywords: b3, isLastNode: B3, isSCSSControlDirectiveNode: I3, isDetachedRulesetDeclarationNode: M3, isRelationalOperatorNode: V10, isEqualityOperatorNode: $3, isMultiplicationNode: U3, isDivisionNode: L3, isAdditionNode: ee2, isSubtractionNode: R3, isMathOperatorNode: O3, isEachKeywordNode: Z3, isForKeywordNode: ie2, isURLFunctionNode: te2, isIfElseKeywordNode: ge2, hasComposesNode: q3, hasParensAroundNode: z3, hasEmptyRawBefore: De2, isKeyValuePairNode: fe2, isKeyInValuePairNode: we2, isDetachedRulesetCallNode: Q3, isTemplatePlaceholderNode: W3, isTemplatePropNode: ne2, isPostcssSimpleVarNode: re2, isSCSSMapItemNode: he2, isInlineValueCommentNode: Fe2, isHashNode: ve2, isLeftCurlyBraceNode: Re2, isRightCurlyBraceNode: tt2, isWordNode: Ze2, isColonNode: $e2, isMediaAndSupportsKeywords: Ge2, isColorAdjusterFuncNode: le2, lastLineHasInlineComment: G3, isAtWordPlaceholderNode: me2, isConfigurationNode: K3, isParenGroupNode: de2 } = $s2(), { locStart: je2, locEnd: Be2 } = Vs2(), ye2 = Js2(), v3 = qs2(), Y3 = Ws2();
        function ae2(Oe2) {
          return Oe2.trailingComma === "es5" || Oe2.trailingComma === "all";
        }
        function Ae2(Oe2, He2, Ye2) {
          let pe2 = Oe2.getValue();
          if (!pe2)
            return "";
          if (typeof pe2 == "string")
            return pe2;
          switch (pe2.type) {
            case "front-matter":
              return [pe2.raw, m3];
            case "css-root": {
              let ut2 = Se2(Oe2, He2, Ye2), it2 = pe2.raws.after.trim();
              return it2.startsWith(";") && (it2 = it2.slice(1).trim()), [ut2, it2 ? ` ${it2}` : "", S3(ut2).length > 0 ? m3 : ""];
            }
            case "css-comment": {
              let ut2 = pe2.inline || pe2.raws.inline, it2 = He2.originalText.slice(je2(pe2), Be2(pe2));
              return ut2 ? it2.trimEnd() : it2;
            }
            case "css-rule":
              return [Ye2("selector"), pe2.important ? " !important" : "", pe2.nodes ? [pe2.selector && pe2.selector.type === "selector-unknown" && G3(pe2.selector.value) ? h3 : " ", "{", pe2.nodes.length > 0 ? C3([m3, Se2(Oe2, He2, Ye2)]) : "", m3, "}", M3(pe2) ? ";" : ""] : ";"];
            case "css-decl": {
              let ut2 = Oe2.getParentNode(), { between: it2 } = pe2.raws, dt2 = it2.trim(), wt2 = dt2 === ":", _3 = q3(pe2) ? N3(Ye2("value")) : Ye2("value");
              return !wt2 && G3(dt2) && (_3 = C3([m3, w3(_3)])), [pe2.raws.before.replace(/[\s;]/g, ""), ut2.type === "css-atrule" && ut2.variable || i(Oe2) ? pe2.prop : D3(pe2.prop), dt2.startsWith("//") ? " " : "", dt2, pe2.extend ? "" : " ", ye2(He2) && pe2.extend && pe2.selector ? ["extend(", Ye2("selector"), ")"] : "", _3, pe2.raws.important ? pe2.raws.important.replace(/\s*!\s*important/i, " !important") : pe2.important ? " !important" : "", pe2.raws.scssDefault ? pe2.raws.scssDefault.replace(/\s*!default/i, " !default") : pe2.scssDefault ? " !default" : "", pe2.raws.scssGlobal ? pe2.raws.scssGlobal.replace(/\s*!global/i, " !global") : pe2.scssGlobal ? " !global" : "", pe2.nodes ? [" {", C3([y3, Se2(Oe2, He2, Ye2)]), y3, "}"] : ne2(pe2) && !ut2.raws.semicolon && He2.originalText[Be2(pe2) - 1] !== ";" ? "" : He2.__isHTMLStyleAttribute && B3(Oe2, pe2) ? P3(";") : ";"];
            }
            case "css-atrule": {
              let ut2 = Oe2.getParentNode(), it2 = W3(pe2) && !ut2.raws.semicolon && He2.originalText[Be2(pe2) - 1] !== ";";
              if (ye2(He2)) {
                if (pe2.mixin)
                  return [Ye2("selector"), pe2.important ? " !important" : "", it2 ? "" : ";"];
                if (pe2.function)
                  return [pe2.name, Ye2("params"), it2 ? "" : ";"];
                if (pe2.variable)
                  return ["@", pe2.name, ": ", pe2.value ? Ye2("value") : "", pe2.raws.between.trim() ? pe2.raws.between.trim() + " " : "", pe2.nodes ? ["{", C3([pe2.nodes.length > 0 ? y3 : "", Se2(Oe2, He2, Ye2)]), y3, "}"] : "", it2 ? "" : ";"];
              }
              return ["@", Q3(pe2) || pe2.name.endsWith(":") ? pe2.name : D3(pe2.name), pe2.params ? [Q3(pe2) ? "" : W3(pe2) ? pe2.raws.afterName === "" ? "" : pe2.name.endsWith(":") ? " " : /^\s*\n\s*\n/.test(pe2.raws.afterName) ? [m3, m3] : /^\s*\n/.test(pe2.raws.afterName) ? m3 : " " : " ", Ye2("params")] : "", pe2.selector ? C3([" ", Ye2("selector")]) : "", pe2.value ? p3([" ", Ye2("value"), I3(pe2) ? z3(pe2) ? " " : h3 : ""]) : pe2.name === "else" ? " " : "", pe2.nodes ? [I3(pe2) ? "" : pe2.selector && !pe2.selector.nodes && typeof pe2.selector.value == "string" && G3(pe2.selector.value) || !pe2.selector && typeof pe2.params == "string" && G3(pe2.params) ? h3 : " ", "{", C3([pe2.nodes.length > 0 ? y3 : "", Se2(Oe2, He2, Ye2)]), y3, "}"] : it2 ? "" : ";"];
            }
            case "media-query-list": {
              let ut2 = [];
              return Oe2.each((it2) => {
                let dt2 = it2.getValue();
                dt2.type === "media-query" && dt2.value === "" || ut2.push(Ye2());
              }, "nodes"), p3(C3(c3(h3, ut2)));
            }
            case "media-query":
              return [c3(" ", Oe2.map(Ye2, "nodes")), B3(Oe2, pe2) ? "" : ","];
            case "media-type":
              return et2(Le2(pe2.value, He2));
            case "media-feature-expression":
              return pe2.nodes ? ["(", ...Oe2.map(Ye2, "nodes"), ")"] : pe2.value;
            case "media-feature":
              return D3(Le2(pe2.value.replace(/ +/g, " "), He2));
            case "media-colon":
              return [pe2.value, " "];
            case "media-value":
              return et2(Le2(pe2.value, He2));
            case "media-keyword":
              return Le2(pe2.value, He2);
            case "media-url":
              return Le2(pe2.value.replace(/^url\(\s+/gi, "url(").replace(/\s+\)$/g, ")"), He2);
            case "media-unknown":
              return pe2.value;
            case "selector-root":
              return p3([g3(Oe2, "custom-selector") ? [f3(Oe2, "css-atrule").customSelector, h3] : "", c3([",", g3(Oe2, ["extend", "custom-selector", "nest"]) ? h3 : m3], Oe2.map(Ye2, "nodes"))]);
            case "selector-selector":
              return p3(C3(Oe2.map(Ye2, "nodes")));
            case "selector-comment":
              return pe2.value;
            case "selector-string":
              return Le2(pe2.value, He2);
            case "selector-tag": {
              let ut2 = Oe2.getParentNode(), it2 = ut2 && ut2.nodes.indexOf(pe2), dt2 = it2 && ut2.nodes[it2 - 1];
              return [pe2.namespace ? [pe2.namespace === true ? "" : pe2.namespace.trim(), "|"] : "", dt2.type === "selector-nesting" ? pe2.value : et2(x3(Oe2, pe2.value) ? pe2.value.toLowerCase() : pe2.value)];
            }
            case "selector-id":
              return ["#", pe2.value];
            case "selector-class":
              return [".", et2(Le2(pe2.value, He2))];
            case "selector-attribute": {
              var Bt2;
              return ["[", pe2.namespace ? [pe2.namespace === true ? "" : pe2.namespace.trim(), "|"] : "", pe2.attribute.trim(), (Bt2 = pe2.operator) !== null && Bt2 !== void 0 ? Bt2 : "", pe2.value ? Ue2(Le2(pe2.value.trim(), He2), He2) : "", pe2.insensitive ? " i" : "", "]"];
            }
            case "selector-combinator": {
              if (pe2.value === "+" || pe2.value === ">" || pe2.value === "~" || pe2.value === ">>>") {
                let dt2 = Oe2.getParentNode();
                return [dt2.type === "selector-selector" && dt2.nodes[0] === pe2 ? "" : h3, pe2.value, B3(Oe2, pe2) ? "" : " "];
              }
              let ut2 = pe2.value.trim().startsWith("(") ? h3 : "", it2 = et2(Le2(pe2.value.trim(), He2)) || h3;
              return [ut2, it2];
            }
            case "selector-universal":
              return [pe2.namespace ? [pe2.namespace === true ? "" : pe2.namespace.trim(), "|"] : "", pe2.value];
            case "selector-pseudo":
              return [D3(pe2.value), o3(pe2.nodes) ? p3(["(", C3([y3, c3([",", h3], Oe2.map(Ye2, "nodes"))]), y3, ")"]) : ""];
            case "selector-nesting":
              return pe2.value;
            case "selector-unknown": {
              let ut2 = f3(Oe2, "css-rule");
              if (ut2 && ut2.isSCSSNesterProperty)
                return et2(Le2(D3(pe2.value), He2));
              let it2 = Oe2.getParentNode();
              if (it2.raws && it2.raws.selector) {
                let wt2 = je2(it2), _3 = wt2 + it2.raws.selector.length;
                return He2.originalText.slice(wt2, _3).trim();
              }
              let dt2 = Oe2.getParentNode(1);
              if (it2.type === "value-paren_group" && dt2 && dt2.type === "value-func" && dt2.value === "selector") {
                let wt2 = Be2(it2.open) + 1, _3 = je2(it2.close), Ee2 = He2.originalText.slice(wt2, _3).trim();
                return G3(Ee2) ? [A3, Ee2] : Ee2;
              }
              return pe2.value;
            }
            case "value-value":
            case "value-root":
              return Ye2("group");
            case "value-comment":
              return He2.originalText.slice(je2(pe2), Be2(pe2));
            case "value-comma_group": {
              let ut2 = Oe2.getParentNode(), it2 = Oe2.getParentNode(1), dt2 = T3(Oe2), wt2 = dt2 && ut2.type === "value-value" && (dt2 === "grid" || dt2.startsWith("grid-template")), _3 = f3(Oe2, "css-atrule"), Ee2 = _3 && I3(_3), qe2 = pe2.groups.some((Nt2) => Fe2(Nt2)), st2 = Oe2.map(Ye2, "groups"), ot2 = [], St2 = F3(Oe2, "url"), gt2 = false, At2 = false;
              for (let Nt2 = 0; Nt2 < pe2.groups.length; ++Nt2) {
                var Ft2;
                ot2.push(st2[Nt2]);
                let Et2 = pe2.groups[Nt2 - 1], ze2 = pe2.groups[Nt2], nt2 = pe2.groups[Nt2 + 1], On2 = pe2.groups[Nt2 + 2];
                if (St2) {
                  (nt2 && ee2(nt2) || ee2(ze2)) && ot2.push(" ");
                  continue;
                }
                if (g3(Oe2, "forward") && ze2.type === "value-word" && ze2.value && Et2 !== void 0 && Et2.type === "value-word" && Et2.value === "as" && nt2.type === "value-operator" && nt2.value === "*" || !nt2 || ze2.type === "value-word" && ze2.value.endsWith("-") && me2(nt2))
                  continue;
                if (ze2.type === "value-string" && ze2.quoted) {
                  let Er2 = ze2.value.lastIndexOf("#{"), Cr2 = ze2.value.lastIndexOf("}");
                  Er2 !== -1 && Cr2 !== -1 ? gt2 = Er2 > Cr2 : Er2 !== -1 ? gt2 = true : Cr2 !== -1 && (gt2 = false);
                }
                if (gt2 || $e2(ze2) || $e2(nt2) || ze2.type === "value-atword" && (ze2.value === "" || ze2.value.endsWith("[")) || nt2.type === "value-word" && nt2.value.startsWith("]") || ze2.value === "~" || ze2.value && ze2.value.includes("\\") && nt2 && nt2.type !== "value-comment" || Et2 && Et2.value && Et2.value.indexOf("\\") === Et2.value.length - 1 && ze2.type === "value-operator" && ze2.value === "/" || ze2.value === "\\" || re2(ze2, nt2) || ve2(ze2) || Re2(ze2) || tt2(nt2) || Re2(nt2) && De2(nt2) || tt2(ze2) && De2(nt2) || ze2.value === "--" && ve2(nt2))
                  continue;
                let hr2 = O3(ze2), Uu2 = O3(nt2);
                if ((hr2 && ve2(nt2) || Uu2 && tt2(ze2)) && De2(nt2) || !Et2 && L3(ze2) || F3(Oe2, "calc") && (ee2(ze2) || ee2(nt2) || R3(ze2) || R3(nt2)) && De2(nt2))
                  continue;
                let ol = (ee2(ze2) || R3(ze2)) && Nt2 === 0 && (nt2.type === "value-number" || nt2.isHex) && it2 && le2(it2) && !De2(nt2), Yu2 = On2 && On2.type === "value-func" || On2 && Ze2(On2) || ze2.type === "value-func" || Ze2(ze2), zu2 = nt2.type === "value-func" || Ze2(nt2) || Et2 && Et2.type === "value-func" || Et2 && Ze2(Et2);
                if (!(!(U3(nt2) || U3(ze2)) && !F3(Oe2, "calc") && !ol && (L3(nt2) && !Yu2 || L3(ze2) && !zu2 || ee2(nt2) && !Yu2 || ee2(ze2) && !zu2 || R3(nt2) || R3(ze2)) && (De2(nt2) || hr2 && (!Et2 || Et2 && O3(Et2)))) && !((He2.parser === "scss" || He2.parser === "less") && hr2 && ze2.value === "-" && de2(nt2) && Be2(ze2) === je2(nt2.open) && nt2.open.value === "(")) {
                  if (Fe2(ze2)) {
                    if (ut2.type === "value-paren_group") {
                      ot2.push(w3(m3));
                      continue;
                    }
                    ot2.push(m3);
                    continue;
                  }
                  if (Ee2 && ($3(nt2) || V10(nt2) || ge2(nt2) || Z3(ze2) || ie2(ze2))) {
                    ot2.push(" ");
                    continue;
                  }
                  if (_3 && _3.name.toLowerCase() === "namespace") {
                    ot2.push(" ");
                    continue;
                  }
                  if (wt2) {
                    ze2.source && nt2.source && ze2.source.start.line !== nt2.source.start.line ? (ot2.push(m3), At2 = true) : ot2.push(" ");
                    continue;
                  }
                  if (Uu2) {
                    ot2.push(" ");
                    continue;
                  }
                  if (!(nt2 && nt2.value === "...") && !(me2(ze2) && me2(nt2) && Be2(ze2) === je2(nt2))) {
                    if (me2(ze2) && de2(nt2) && Be2(ze2) === je2(nt2.open)) {
                      ot2.push(y3);
                      continue;
                    }
                    if (ze2.value === "with" && de2(nt2)) {
                      ot2.push(" ");
                      continue;
                    }
                    (Ft2 = ze2.value) !== null && Ft2 !== void 0 && Ft2.endsWith("#") && nt2.value === "{" && de2(nt2.group) || ot2.push(h3);
                  }
                }
              }
              return qe2 && ot2.push(A3), At2 && ot2.unshift(m3), Ee2 ? p3(C3(ot2)) : E3(Oe2) ? p3(d3(ot2)) : p3(C3(d3(ot2)));
            }
            case "value-paren_group": {
              let ut2 = Oe2.getParentNode();
              if (ut2 && te2(ut2) && (pe2.groups.length === 1 || pe2.groups.length > 0 && pe2.groups[0].type === "value-comma_group" && pe2.groups[0].groups.length > 0 && pe2.groups[0].groups[0].type === "value-word" && pe2.groups[0].groups[0].value.startsWith("data:")))
                return [pe2.open ? Ye2("open") : "", c3(",", Oe2.map(Ye2, "groups")), pe2.close ? Ye2("close") : ""];
              if (!pe2.open) {
                let St2 = Oe2.map(Ye2, "groups"), gt2 = [];
                for (let At2 = 0; At2 < St2.length; At2++)
                  At2 !== 0 && gt2.push([",", h3]), gt2.push(St2[At2]);
                return p3(C3(d3(gt2)));
              }
              let it2 = he2(Oe2), dt2 = t3(pe2.groups), wt2 = dt2 && dt2.type === "value-comment", _3 = we2(pe2, ut2), Ee2 = K3(pe2, ut2), qe2 = Ee2 || it2 && !_3, st2 = Ee2 || _3, ot2 = p3([pe2.open ? Ye2("open") : "", C3([y3, c3([h3], Oe2.map((St2, gt2) => {
                let At2 = St2.getValue(), Nt2 = gt2 === pe2.groups.length - 1, Et2 = [Ye2(), Nt2 ? "" : ","];
                if (fe2(At2) && At2.type === "value-comma_group" && At2.groups && At2.groups[0].type !== "value-paren_group" && At2.groups[2] && At2.groups[2].type === "value-paren_group") {
                  let ze2 = S3(Et2[0].contents.contents);
                  ze2[1] = p3(ze2[1]), Et2 = [p3(w3(Et2))];
                }
                if (!Nt2 && At2.type === "value-comma_group" && o3(At2.groups)) {
                  let ze2 = t3(At2.groups);
                  !ze2.source && ze2.close && (ze2 = ze2.close), ze2.source && r3(He2.originalText, ze2, Be2) && Et2.push(m3);
                }
                return Et2;
              }, "groups"))]), P3(!wt2 && v3(He2.parser, He2.originalText) && it2 && ae2(He2) ? "," : ""), y3, pe2.close ? Ye2("close") : ""], { shouldBreak: qe2 });
              return st2 ? w3(ot2) : ot2;
            }
            case "value-func":
              return [pe2.value, g3(Oe2, "supports") && Ge2(pe2) ? " " : "", Ye2("group")];
            case "value-paren":
              return pe2.value;
            case "value-number":
              return [ct2(pe2.value), Y3(pe2.unit)];
            case "value-operator":
              return pe2.value;
            case "value-word":
              return pe2.isColor && pe2.isHex || b3(pe2.value) ? pe2.value.toLowerCase() : pe2.value;
            case "value-colon": {
              let ut2 = Oe2.getParentNode(), it2 = ut2 && ut2.groups.indexOf(pe2), dt2 = it2 && ut2.groups[it2 - 1];
              return [pe2.value, dt2 && typeof dt2.value == "string" && t3(dt2.value) === "\\" || F3(Oe2, "url") ? "" : h3];
            }
            case "value-comma":
              return [pe2.value, " "];
            case "value-string":
              return a3(pe2.raws.quote + pe2.value + pe2.raws.quote, He2);
            case "value-atword":
              return ["@", pe2.value];
            case "value-unicode-range":
              return pe2.value;
            case "value-unknown":
              return pe2.value;
            default:
              throw new Error(`Unknown postcss type ${JSON.stringify(pe2.type)}`);
          }
        }
        function Se2(Oe2, He2, Ye2) {
          let pe2 = [];
          return Oe2.each((Bt2, Ft2, ut2) => {
            let it2 = ut2[Ft2 - 1];
            if (it2 && it2.type === "css-comment" && it2.text.trim() === "prettier-ignore") {
              let dt2 = Bt2.getValue();
              pe2.push(He2.originalText.slice(je2(dt2), Be2(dt2)));
            } else
              pe2.push(Ye2());
            Ft2 !== ut2.length - 1 && (ut2[Ft2 + 1].type === "css-comment" && !e28(He2.originalText, je2(ut2[Ft2 + 1]), { backwards: true }) && !n3(ut2[Ft2]) || ut2[Ft2 + 1].type === "css-atrule" && ut2[Ft2 + 1].name === "else" && ut2[Ft2].type !== "css-comment" ? pe2.push(" ") : (pe2.push(He2.__isHTMLStyleAttribute ? h3 : m3), r3(He2.originalText, Bt2.getValue(), Be2) && !n3(ut2[Ft2]) && pe2.push(m3)));
          }, "nodes"), pe2;
        }
        var Me2 = /(["'])(?:(?!\1)[^\\]|\\.)*\1/gs, xe2 = /(?:\d*\.\d+|\d+\.?)(?:[Ee][+-]?\d+)?/g, mt2 = /[A-Za-z]+/g, _e2 = /[$@]?[A-Z_a-z\u0080-\uFFFF][\w\u0080-\uFFFF-]*/g, ft2 = new RegExp(Me2.source + `|(${_e2.source})?(${xe2.source})(${mt2.source})?`, "g");
        function Le2(Oe2, He2) {
          return Oe2.replace(Me2, (Ye2) => a3(Ye2, He2));
        }
        function Ue2(Oe2, He2) {
          let Ye2 = He2.singleQuote ? "'" : '"';
          return Oe2.includes('"') || Oe2.includes("'") ? Oe2 : Ye2 + Oe2 + Ye2;
        }
        function et2(Oe2) {
          return Oe2.replace(ft2, (He2, Ye2, pe2, Bt2, Ft2) => !pe2 && Bt2 ? ct2(Bt2) + D3(Ft2 || "") : He2);
        }
        function ct2(Oe2) {
          return s3(Oe2).replace(/\.0(?=$|e)/, "");
        }
        l3.exports = { print: Ae2, embed: k3, insertPragma: J3, massageAstNode: j3 };
      } }), Us2 = X3({ "src/language-css/options.js"(u3, l3) {
        H3();
        var t3 = en2();
        l3.exports = { singleQuote: t3.singleQuote };
      } }), Ys2 = X3({ "src/language-css/parsers.js"() {
        H3();
      } }), zs2 = X3({ "node_modules/linguist-languages/data/CSS.json"(u3, l3) {
        l3.exports = { name: "CSS", type: "markup", tmScope: "source.css", aceMode: "css", codemirrorMode: "css", codemirrorMimeType: "text/css", color: "#563d7c", extensions: [".css"], languageId: 50 };
      } }), Ks2 = X3({ "node_modules/linguist-languages/data/PostCSS.json"(u3, l3) {
        l3.exports = { name: "PostCSS", type: "markup", color: "#dc3a0c", tmScope: "source.postcss", group: "CSS", extensions: [".pcss", ".postcss"], aceMode: "text", languageId: 262764437 };
      } }), Qs2 = X3({ "node_modules/linguist-languages/data/Less.json"(u3, l3) {
        l3.exports = { name: "Less", type: "markup", color: "#1d365d", aliases: ["less-css"], extensions: [".less"], tmScope: "source.css.less", aceMode: "less", codemirrorMode: "css", codemirrorMimeType: "text/css", languageId: 198 };
      } }), Hs2 = X3({ "node_modules/linguist-languages/data/SCSS.json"(u3, l3) {
        l3.exports = { name: "SCSS", type: "markup", color: "#c6538c", tmScope: "source.css.scss", aceMode: "scss", codemirrorMode: "css", codemirrorMimeType: "text/x-scss", extensions: [".scss"], languageId: 329 };
      } }), Zs2 = X3({ "src/language-css/index.js"(u3, l3) {
        H3();
        var t3 = Gt2(), s3 = Xs2(), a3 = Us2(), e28 = Ys2(), n3 = [t3(zs2(), (o3) => ({ since: "1.4.0", parsers: ["css"], vscodeLanguageIds: ["css"], extensions: [...o3.extensions, ".wxss"] })), t3(Ks2(), () => ({ since: "1.4.0", parsers: ["css"], vscodeLanguageIds: ["postcss"] })), t3(Qs2(), () => ({ since: "1.4.0", parsers: ["less"], vscodeLanguageIds: ["less"] })), t3(Hs2(), () => ({ since: "1.4.0", parsers: ["scss"], vscodeLanguageIds: ["scss"] }))], r3 = { postcss: s3 };
        l3.exports = { languages: n3, options: a3, printers: r3, parsers: e28 };
      } }), eo2 = X3({ "src/language-handlebars/loc.js"(u3, l3) {
        H3();
        function t3(a3) {
          return a3.loc.start.offset;
        }
        function s3(a3) {
          return a3.loc.end.offset;
        }
        l3.exports = { locStart: t3, locEnd: s3 };
      } }), to2 = X3({ "src/language-handlebars/clean.js"(u3, l3) {
        H3();
        function t3(s3, a3) {
          if (s3.type === "TextNode") {
            let e28 = s3.chars.trim();
            if (!e28)
              return null;
            a3.chars = e28.replace(/[\t\n\f\r ]+/g, " ");
          }
          s3.type === "AttrNode" && s3.name.toLowerCase() === "class" && delete a3.value;
        }
        t3.ignoredProperties = /* @__PURE__ */ new Set(["loc", "selfClosing"]), l3.exports = t3;
      } }), no2 = X3({ "src/language-handlebars/html-void-elements.evaluate.js"(u3, l3) {
        l3.exports = ["area", "base", "br", "col", "command", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"];
      } }), ro2 = X3({ "src/language-handlebars/utils.js"(u3, l3) {
        H3();
        var t3 = Ct2(), s3 = no2();
        function a3(S3) {
          let j3 = S3.getValue(), k3 = S3.getParentNode(0);
          return !!(y3(S3, ["ElementNode"]) && t3(k3.children) === j3 || y3(S3, ["Block"]) && t3(k3.body) === j3);
        }
        function e28(S3) {
          return S3.toUpperCase() === S3;
        }
        function n3(S3) {
          return m3(S3, ["ElementNode"]) && typeof S3.tag == "string" && !S3.tag.startsWith(":") && (e28(S3.tag[0]) || S3.tag.includes("."));
        }
        var r3 = new Set(s3);
        function o3(S3) {
          return r3.has(S3.toLowerCase()) && !e28(S3[0]);
        }
        function c3(S3) {
          return S3.selfClosing === true || o3(S3.tag) || n3(S3) && S3.children.every((j3) => h3(j3));
        }
        function h3(S3) {
          return m3(S3, ["TextNode"]) && !/\S/.test(S3.chars);
        }
        function m3(S3, j3) {
          return S3 && j3.includes(S3.type);
        }
        function y3(S3, j3) {
          let k3 = S3.getParentNode(0);
          return m3(k3, j3);
        }
        function p3(S3, j3) {
          let k3 = w3(S3);
          return m3(k3, j3);
        }
        function d3(S3, j3) {
          let k3 = P3(S3);
          return m3(k3, j3);
        }
        function C3(S3, j3) {
          var k3, J3, f3, T3;
          let D3 = S3.getValue(), F3 = (k3 = S3.getParentNode(0)) !== null && k3 !== void 0 ? k3 : {}, i = (J3 = (f3 = (T3 = F3.children) !== null && T3 !== void 0 ? T3 : F3.body) !== null && f3 !== void 0 ? f3 : F3.parts) !== null && J3 !== void 0 ? J3 : [], g3 = i.indexOf(D3);
          return g3 !== -1 && i[g3 + j3];
        }
        function w3(S3) {
          let j3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
          return C3(S3, -j3);
        }
        function P3(S3) {
          return C3(S3, 1);
        }
        function A3(S3) {
          return m3(S3, ["MustacheCommentStatement"]) && typeof S3.value == "string" && S3.value.trim() === "prettier-ignore";
        }
        function N3(S3) {
          let j3 = S3.getValue(), k3 = w3(S3, 2);
          return A3(j3) || A3(k3);
        }
        l3.exports = { getNextNode: P3, getPreviousNode: w3, hasPrettierIgnore: N3, isLastNodeOfSiblings: a3, isNextNodeOfSomeType: d3, isNodeOfSomeType: m3, isParentOfSomeType: y3, isPreviousNodeOfSomeType: p3, isVoid: c3, isWhitespaceNode: h3 };
      } }), uo2 = X3({ "src/language-handlebars/printer-glimmer.js"(u3, l3) {
        H3();
        var { builders: { dedent: t3, fill: s3, group: a3, hardline: e28, ifBreak: n3, indent: r3, join: o3, line: c3, softline: h3 }, utils: { getDocParts: m3, replaceTextEndOfLine: y3 } } = Qe2(), { getPreferredQuote: p3, isNonEmptyArray: d3 } = at2(), { locStart: C3, locEnd: w3 } = eo2(), P3 = to2(), { getNextNode: A3, getPreviousNode: N3, hasPrettierIgnore: S3, isLastNodeOfSiblings: j3, isNextNodeOfSomeType: k3, isNodeOfSomeType: J3, isParentOfSomeType: f3, isPreviousNodeOfSomeType: T3, isVoid: D3, isWhitespaceNode: F3 } = ro2(), i = 2;
        function g3(G3, me2, K3) {
          let de2 = G3.getValue();
          if (!de2)
            return "";
          if (S3(G3))
            return me2.originalText.slice(C3(de2), w3(de2));
          let je2 = me2.singleQuote ? "'" : '"';
          switch (de2.type) {
            case "Block":
            case "Program":
            case "Template":
              return a3(G3.map(K3, "body"));
            case "ElementNode": {
              let Be2 = a3(x3(G3, K3)), ye2 = me2.htmlWhitespaceSensitivity === "ignore" && k3(G3, ["ElementNode"]) ? h3 : "";
              if (D3(de2))
                return [Be2, ye2];
              let v3 = ["</", de2.tag, ">"];
              return de2.children.length === 0 ? [Be2, r3(v3), ye2] : me2.htmlWhitespaceSensitivity === "ignore" ? [Be2, r3(b3(G3, me2, K3)), e28, r3(v3), ye2] : [Be2, r3(a3(b3(G3, me2, K3))), r3(v3), ye2];
            }
            case "BlockStatement": {
              let Be2 = G3.getParentNode(1);
              return Be2 && Be2.inverse && Be2.inverse.body.length === 1 && Be2.inverse.body[0] === de2 && Be2.inverse.body[0].path.parts[0] === Be2.path.parts[0] ? [ie2(G3, K3, Be2.inverse.body[0].path.parts[0]), De2(G3, K3, me2), fe2(G3, K3, me2)] : [O3(G3, K3), a3([De2(G3, K3, me2), fe2(G3, K3, me2), te2(G3, K3, me2)])];
            }
            case "ElementModifierStatement":
              return a3(["{{", Ze2(G3, K3), "}}"]);
            case "MustacheStatement":
              return a3([I3(de2), Ze2(G3, K3), M3(de2)]);
            case "SubExpression":
              return a3(["(", tt2(G3, K3), h3, ")"]);
            case "AttrNode": {
              let Be2 = de2.value.type === "TextNode";
              if (Be2 && de2.value.chars === "" && C3(de2.value) === w3(de2.value))
                return de2.name;
              let ye2 = Be2 ? p3(de2.value.chars, je2).quote : de2.value.type === "ConcatStatement" ? p3(de2.value.parts.filter((Y3) => Y3.type === "TextNode").map((Y3) => Y3.chars).join(""), je2).quote : "", v3 = K3("value");
              return [de2.name, "=", ye2, de2.name === "class" && ye2 ? a3(r3(v3)) : v3, ye2];
            }
            case "ConcatStatement":
              return G3.map(K3, "parts");
            case "Hash":
              return o3(c3, G3.map(K3, "pairs"));
            case "HashPair":
              return [de2.key, "=", K3("value")];
            case "TextNode": {
              let Be2 = de2.chars.replace(/{{/g, "\\{{"), ye2 = W3(G3);
              if (ye2) {
                if (ye2 === "class") {
                  let _e2 = Be2.trim().split(/\s+/).join(" "), ft2 = false, Le2 = false;
                  return f3(G3, ["ConcatStatement"]) && (T3(G3, ["MustacheStatement"]) && /^\s/.test(Be2) && (ft2 = true), k3(G3, ["MustacheStatement"]) && /\s$/.test(Be2) && _e2 !== "" && (Le2 = true)), [ft2 ? c3 : "", _e2, Le2 ? c3 : ""];
                }
                return y3(Be2);
              }
              let v3 = /^[\t\n\f\r ]*$/.test(Be2), Y3 = !N3(G3), ae2 = !A3(G3);
              if (me2.htmlWhitespaceSensitivity !== "ignore") {
                let _e2 = /^[\t\n\f\r ]*/, ft2 = /[\t\n\f\r ]*$/, Le2 = ae2 && f3(G3, ["Template"]), Ue2 = Y3 && f3(G3, ["Template"]);
                if (v3) {
                  if (Ue2 || Le2)
                    return "";
                  let Ye2 = [c3], pe2 = ne2(Be2);
                  return pe2 && (Ye2 = Fe2(pe2)), j3(G3) && (Ye2 = Ye2.map((Bt2) => t3(Bt2))), Ye2;
                }
                let [et2] = Be2.match(_e2), [ct2] = Be2.match(ft2), Oe2 = [];
                if (et2) {
                  Oe2 = [c3];
                  let Ye2 = ne2(et2);
                  Ye2 && (Oe2 = Fe2(Ye2)), Be2 = Be2.replace(_e2, "");
                }
                let He2 = [];
                if (ct2) {
                  if (!Le2) {
                    He2 = [c3];
                    let Ye2 = ne2(ct2);
                    Ye2 && (He2 = Fe2(Ye2)), j3(G3) && (He2 = He2.map((pe2) => t3(pe2)));
                  }
                  Be2 = Be2.replace(ft2, "");
                }
                return [...Oe2, s3(we2(Be2)), ...He2];
              }
              let Ae2 = ne2(Be2), Se2 = re2(Be2), Me2 = he2(Be2);
              if ((Y3 || ae2) && v3 && f3(G3, ["Block", "ElementNode", "Template"]))
                return "";
              v3 && Ae2 ? (Se2 = Math.min(Ae2, i), Me2 = 0) : (k3(G3, ["BlockStatement", "ElementNode"]) && (Me2 = Math.max(Me2, 1)), T3(G3, ["BlockStatement", "ElementNode"]) && (Se2 = Math.max(Se2, 1)));
              let xe2 = "", mt2 = "";
              return Me2 === 0 && k3(G3, ["MustacheStatement"]) && (mt2 = " "), Se2 === 0 && T3(G3, ["MustacheStatement"]) && (xe2 = " "), Y3 && (Se2 = 0, xe2 = ""), ae2 && (Me2 = 0, mt2 = ""), Be2 = Be2.replace(/^[\t\n\f\r ]+/g, xe2).replace(/[\t\n\f\r ]+$/, mt2), [...Fe2(Se2), s3(we2(Be2)), ...Fe2(Me2)];
            }
            case "MustacheCommentStatement": {
              let Be2 = C3(de2), ye2 = w3(de2), v3 = me2.originalText.charAt(Be2 + 2) === "~", Y3 = me2.originalText.charAt(ye2 - 3) === "~", ae2 = de2.value.includes("}}") ? "--" : "";
              return ["{{", v3 ? "~" : "", "!", ae2, de2.value, ae2, Y3 ? "~" : "", "}}"];
            }
            case "PathExpression":
              return de2.original;
            case "BooleanLiteral":
              return String(de2.value);
            case "CommentStatement":
              return ["<!--", de2.value, "-->"];
            case "StringLiteral": {
              if (Re2(G3)) {
                let Be2 = me2.singleQuote ? '"' : "'";
                return ve2(de2.value, Be2);
              }
              return ve2(de2.value, je2);
            }
            case "NumberLiteral":
              return String(de2.value);
            case "UndefinedLiteral":
              return "undefined";
            case "NullLiteral":
              return "null";
            default:
              throw new Error("unknown glimmer type: " + JSON.stringify(de2.type));
          }
        }
        function E3(G3, me2) {
          return C3(G3) - C3(me2);
        }
        function x3(G3, me2) {
          let K3 = G3.getValue(), de2 = ["attributes", "modifiers", "comments"].filter((Be2) => d3(K3[Be2])), je2 = de2.flatMap((Be2) => K3[Be2]).sort(E3);
          for (let Be2 of de2)
            G3.each((ye2) => {
              let v3 = je2.indexOf(ye2.getValue());
              je2.splice(v3, 1, [c3, me2()]);
            }, Be2);
          return d3(K3.blockParams) && je2.push(c3, le2(K3)), ["<", K3.tag, r3(je2), B3(K3)];
        }
        function b3(G3, me2, K3) {
          let de2 = G3.getValue().children.every((je2) => F3(je2));
          return me2.htmlWhitespaceSensitivity === "ignore" && de2 ? "" : G3.map((je2, Be2) => {
            let ye2 = K3();
            return Be2 === 0 && me2.htmlWhitespaceSensitivity === "ignore" ? [h3, ye2] : ye2;
          }, "children");
        }
        function B3(G3) {
          return D3(G3) ? n3([h3, "/>"], [" />", h3]) : n3([h3, ">"], ">");
        }
        function I3(G3) {
          let me2 = G3.escaped === false ? "{{{" : "{{", K3 = G3.strip && G3.strip.open ? "~" : "";
          return [me2, K3];
        }
        function M3(G3) {
          let me2 = G3.escaped === false ? "}}}" : "}}";
          return [G3.strip && G3.strip.close ? "~" : "", me2];
        }
        function V10(G3) {
          let me2 = I3(G3), K3 = G3.openStrip.open ? "~" : "";
          return [me2, K3, "#"];
        }
        function $3(G3) {
          let me2 = M3(G3);
          return [G3.openStrip.close ? "~" : "", me2];
        }
        function U3(G3) {
          let me2 = I3(G3), K3 = G3.closeStrip.open ? "~" : "";
          return [me2, K3, "/"];
        }
        function L3(G3) {
          let me2 = M3(G3);
          return [G3.closeStrip.close ? "~" : "", me2];
        }
        function ee2(G3) {
          let me2 = I3(G3), K3 = G3.inverseStrip.open ? "~" : "";
          return [me2, K3];
        }
        function R3(G3) {
          let me2 = M3(G3);
          return [G3.inverseStrip.close ? "~" : "", me2];
        }
        function O3(G3, me2) {
          let K3 = G3.getValue(), de2 = [], je2 = Ge2(G3, me2);
          return je2 && de2.push(a3(je2)), d3(K3.program.blockParams) && de2.push(le2(K3.program)), a3([V10(K3), $e2(G3, me2), de2.length > 0 ? r3([c3, o3(c3, de2)]) : "", h3, $3(K3)]);
        }
        function Z3(G3, me2) {
          return [me2.htmlWhitespaceSensitivity === "ignore" ? e28 : "", ee2(G3), "else", R3(G3)];
        }
        function ie2(G3, me2, K3) {
          let de2 = G3.getValue(), je2 = G3.getParentNode(1);
          return a3([ee2(je2), ["else", " ", K3], r3([c3, a3(Ge2(G3, me2)), ...d3(de2.program.blockParams) ? [c3, le2(de2.program)] : []]), h3, R3(je2)]);
        }
        function te2(G3, me2, K3) {
          let de2 = G3.getValue();
          return K3.htmlWhitespaceSensitivity === "ignore" ? [ge2(de2) ? h3 : e28, U3(de2), me2("path"), L3(de2)] : [U3(de2), me2("path"), L3(de2)];
        }
        function ge2(G3) {
          return J3(G3, ["BlockStatement"]) && G3.program.body.every((me2) => F3(me2));
        }
        function q3(G3) {
          return z3(G3) && G3.inverse.body.length === 1 && J3(G3.inverse.body[0], ["BlockStatement"]) && G3.inverse.body[0].path.parts[0] === G3.path.parts[0];
        }
        function z3(G3) {
          return J3(G3, ["BlockStatement"]) && G3.inverse;
        }
        function De2(G3, me2, K3) {
          let de2 = G3.getValue();
          if (ge2(de2))
            return "";
          let je2 = me2("program");
          return K3.htmlWhitespaceSensitivity === "ignore" ? r3([e28, je2]) : r3(je2);
        }
        function fe2(G3, me2, K3) {
          let de2 = G3.getValue(), je2 = me2("inverse"), Be2 = K3.htmlWhitespaceSensitivity === "ignore" ? [e28, je2] : je2;
          return q3(de2) ? Be2 : z3(de2) ? [Z3(de2, K3), r3(Be2)] : "";
        }
        function we2(G3) {
          return m3(o3(c3, Q3(G3)));
        }
        function Q3(G3) {
          return G3.split(/[\t\n\f\r ]+/);
        }
        function W3(G3) {
          for (let me2 = 0; me2 < 2; me2++) {
            let K3 = G3.getParentNode(me2);
            if (K3 && K3.type === "AttrNode")
              return K3.name.toLowerCase();
          }
        }
        function ne2(G3) {
          return G3 = typeof G3 == "string" ? G3 : "", G3.split(`
`).length - 1;
        }
        function re2(G3) {
          G3 = typeof G3 == "string" ? G3 : "";
          let me2 = (G3.match(/^([^\S\n\r]*[\n\r])+/g) || [])[0] || "";
          return ne2(me2);
        }
        function he2(G3) {
          G3 = typeof G3 == "string" ? G3 : "";
          let me2 = (G3.match(/([\n\r][^\S\n\r]*)+$/g) || [])[0] || "";
          return ne2(me2);
        }
        function Fe2() {
          let G3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          return Array.from({ length: Math.min(G3, i) }).fill(e28);
        }
        function ve2(G3, me2) {
          let { quote: K3, regex: de2 } = p3(G3, me2);
          return [K3, G3.replace(de2, `\\${K3}`), K3];
        }
        function Re2(G3) {
          let me2 = 0, K3 = G3.getParentNode(me2);
          for (; K3 && J3(K3, ["SubExpression"]); )
            me2++, K3 = G3.getParentNode(me2);
          return !!(K3 && J3(G3.getParentNode(me2 + 1), ["ConcatStatement"]) && J3(G3.getParentNode(me2 + 2), ["AttrNode"]));
        }
        function tt2(G3, me2) {
          let K3 = $e2(G3, me2), de2 = Ge2(G3, me2);
          return de2 ? r3([K3, c3, a3(de2)]) : K3;
        }
        function Ze2(G3, me2) {
          let K3 = $e2(G3, me2), de2 = Ge2(G3, me2);
          return de2 ? [r3([K3, c3, de2]), h3] : K3;
        }
        function $e2(G3, me2) {
          return me2("path");
        }
        function Ge2(G3, me2) {
          let K3 = G3.getValue(), de2 = [];
          if (K3.params.length > 0) {
            let je2 = G3.map(me2, "params");
            de2.push(...je2);
          }
          if (K3.hash && K3.hash.pairs.length > 0) {
            let je2 = me2("hash");
            de2.push(je2);
          }
          return de2.length === 0 ? "" : o3(c3, de2);
        }
        function le2(G3) {
          return ["as |", G3.blockParams.join(" "), "|"];
        }
        l3.exports = { print: g3, massageAstNode: P3 };
      } }), io2 = X3({ "src/language-handlebars/parsers.js"() {
        H3();
      } }), ao2 = X3({ "node_modules/linguist-languages/data/Handlebars.json"(u3, l3) {
        l3.exports = { name: "Handlebars", type: "markup", color: "#f7931e", aliases: ["hbs", "htmlbars"], extensions: [".handlebars", ".hbs"], tmScope: "text.html.handlebars", aceMode: "handlebars", languageId: 155 };
      } }), so2 = X3({ "src/language-handlebars/index.js"(u3, l3) {
        H3();
        var t3 = Gt2(), s3 = uo2(), a3 = io2(), e28 = [t3(ao2(), () => ({ since: "2.3.0", parsers: ["glimmer"], vscodeLanguageIds: ["handlebars"] }))], n3 = { glimmer: s3 };
        l3.exports = { languages: e28, printers: n3, parsers: a3 };
      } }), oo2 = X3({ "src/language-graphql/pragma.js"(u3, l3) {
        H3();
        function t3(a3) {
          return /^\s*#[^\S\n]*@(?:format|prettier)\s*(?:\n|$)/.test(a3);
        }
        function s3(a3) {
          return `# @format

` + a3;
        }
        l3.exports = { hasPragma: t3, insertPragma: s3 };
      } }), lo2 = X3({ "src/language-graphql/loc.js"(u3, l3) {
        H3();
        function t3(a3) {
          return typeof a3.start == "number" ? a3.start : a3.loc && a3.loc.start;
        }
        function s3(a3) {
          return typeof a3.end == "number" ? a3.end : a3.loc && a3.loc.end;
        }
        l3.exports = { locStart: t3, locEnd: s3 };
      } }), po2 = X3({ "src/language-graphql/printer-graphql.js"(u3, l3) {
        H3();
        var { builders: { join: t3, hardline: s3, line: a3, softline: e28, group: n3, indent: r3, ifBreak: o3 } } = Qe2(), { isNextLineEmpty: c3, isNonEmptyArray: h3 } = at2(), { insertPragma: m3 } = oo2(), { locStart: y3, locEnd: p3 } = lo2();
        function d3(k3, J3, f3) {
          let T3 = k3.getValue();
          if (!T3)
            return "";
          if (typeof T3 == "string")
            return T3;
          switch (T3.kind) {
            case "Document": {
              let D3 = [];
              return k3.each((F3, i, g3) => {
                D3.push(f3()), i !== g3.length - 1 && (D3.push(s3), c3(J3.originalText, F3.getValue(), p3) && D3.push(s3));
              }, "definitions"), [...D3, s3];
            }
            case "OperationDefinition": {
              let D3 = J3.originalText[y3(T3)] !== "{", F3 = !!T3.name;
              return [D3 ? T3.operation : "", D3 && F3 ? [" ", f3("name")] : "", D3 && !F3 && h3(T3.variableDefinitions) ? " " : "", h3(T3.variableDefinitions) ? n3(["(", r3([e28, t3([o3("", ", "), e28], k3.map(f3, "variableDefinitions"))]), e28, ")"]) : "", C3(k3, f3, T3), T3.selectionSet ? !D3 && !F3 ? "" : " " : "", f3("selectionSet")];
            }
            case "FragmentDefinition":
              return ["fragment ", f3("name"), h3(T3.variableDefinitions) ? n3(["(", r3([e28, t3([o3("", ", "), e28], k3.map(f3, "variableDefinitions"))]), e28, ")"]) : "", " on ", f3("typeCondition"), C3(k3, f3, T3), " ", f3("selectionSet")];
            case "SelectionSet":
              return ["{", r3([s3, t3(s3, w3(k3, J3, f3, "selections"))]), s3, "}"];
            case "Field":
              return n3([T3.alias ? [f3("alias"), ": "] : "", f3("name"), T3.arguments.length > 0 ? n3(["(", r3([e28, t3([o3("", ", "), e28], w3(k3, J3, f3, "arguments"))]), e28, ")"]) : "", C3(k3, f3, T3), T3.selectionSet ? " " : "", f3("selectionSet")]);
            case "Name":
              return T3.value;
            case "StringValue": {
              if (T3.block) {
                let D3 = T3.value.replace(/"""/g, "\\$&").split(`
`);
                return D3.length === 1 && (D3[0] = D3[0].trim()), D3.every((F3) => F3 === "") && (D3.length = 0), t3(s3, ['"""', ...D3, '"""']);
              }
              return ['"', T3.value.replace(/["\\]/g, "\\$&").replace(/\n/g, "\\n"), '"'];
            }
            case "IntValue":
            case "FloatValue":
            case "EnumValue":
              return T3.value;
            case "BooleanValue":
              return T3.value ? "true" : "false";
            case "NullValue":
              return "null";
            case "Variable":
              return ["$", f3("name")];
            case "ListValue":
              return n3(["[", r3([e28, t3([o3("", ", "), e28], k3.map(f3, "values"))]), e28, "]"]);
            case "ObjectValue":
              return n3(["{", J3.bracketSpacing && T3.fields.length > 0 ? " " : "", r3([e28, t3([o3("", ", "), e28], k3.map(f3, "fields"))]), e28, o3("", J3.bracketSpacing && T3.fields.length > 0 ? " " : ""), "}"]);
            case "ObjectField":
            case "Argument":
              return [f3("name"), ": ", f3("value")];
            case "Directive":
              return ["@", f3("name"), T3.arguments.length > 0 ? n3(["(", r3([e28, t3([o3("", ", "), e28], w3(k3, J3, f3, "arguments"))]), e28, ")"]) : ""];
            case "NamedType":
              return f3("name");
            case "VariableDefinition":
              return [f3("variable"), ": ", f3("type"), T3.defaultValue ? [" = ", f3("defaultValue")] : "", C3(k3, f3, T3)];
            case "ObjectTypeExtension":
            case "ObjectTypeDefinition":
              return [f3("description"), T3.description ? s3 : "", T3.kind === "ObjectTypeExtension" ? "extend " : "", "type ", f3("name"), T3.interfaces.length > 0 ? [" implements ", ...N3(k3, J3, f3)] : "", C3(k3, f3, T3), T3.fields.length > 0 ? [" {", r3([s3, t3(s3, w3(k3, J3, f3, "fields"))]), s3, "}"] : ""];
            case "FieldDefinition":
              return [f3("description"), T3.description ? s3 : "", f3("name"), T3.arguments.length > 0 ? n3(["(", r3([e28, t3([o3("", ", "), e28], w3(k3, J3, f3, "arguments"))]), e28, ")"]) : "", ": ", f3("type"), C3(k3, f3, T3)];
            case "DirectiveDefinition":
              return [f3("description"), T3.description ? s3 : "", "directive ", "@", f3("name"), T3.arguments.length > 0 ? n3(["(", r3([e28, t3([o3("", ", "), e28], w3(k3, J3, f3, "arguments"))]), e28, ")"]) : "", T3.repeatable ? " repeatable" : "", " on ", t3(" | ", k3.map(f3, "locations"))];
            case "EnumTypeExtension":
            case "EnumTypeDefinition":
              return [f3("description"), T3.description ? s3 : "", T3.kind === "EnumTypeExtension" ? "extend " : "", "enum ", f3("name"), C3(k3, f3, T3), T3.values.length > 0 ? [" {", r3([s3, t3(s3, w3(k3, J3, f3, "values"))]), s3, "}"] : ""];
            case "EnumValueDefinition":
              return [f3("description"), T3.description ? s3 : "", f3("name"), C3(k3, f3, T3)];
            case "InputValueDefinition":
              return [f3("description"), T3.description ? T3.description.block ? s3 : a3 : "", f3("name"), ": ", f3("type"), T3.defaultValue ? [" = ", f3("defaultValue")] : "", C3(k3, f3, T3)];
            case "InputObjectTypeExtension":
            case "InputObjectTypeDefinition":
              return [f3("description"), T3.description ? s3 : "", T3.kind === "InputObjectTypeExtension" ? "extend " : "", "input ", f3("name"), C3(k3, f3, T3), T3.fields.length > 0 ? [" {", r3([s3, t3(s3, w3(k3, J3, f3, "fields"))]), s3, "}"] : ""];
            case "SchemaExtension":
              return ["extend schema", C3(k3, f3, T3), ...T3.operationTypes.length > 0 ? [" {", r3([s3, t3(s3, w3(k3, J3, f3, "operationTypes"))]), s3, "}"] : []];
            case "SchemaDefinition":
              return [f3("description"), T3.description ? s3 : "", "schema", C3(k3, f3, T3), " {", T3.operationTypes.length > 0 ? r3([s3, t3(s3, w3(k3, J3, f3, "operationTypes"))]) : "", s3, "}"];
            case "OperationTypeDefinition":
              return [f3("operation"), ": ", f3("type")];
            case "InterfaceTypeExtension":
            case "InterfaceTypeDefinition":
              return [f3("description"), T3.description ? s3 : "", T3.kind === "InterfaceTypeExtension" ? "extend " : "", "interface ", f3("name"), T3.interfaces.length > 0 ? [" implements ", ...N3(k3, J3, f3)] : "", C3(k3, f3, T3), T3.fields.length > 0 ? [" {", r3([s3, t3(s3, w3(k3, J3, f3, "fields"))]), s3, "}"] : ""];
            case "FragmentSpread":
              return ["...", f3("name"), C3(k3, f3, T3)];
            case "InlineFragment":
              return ["...", T3.typeCondition ? [" on ", f3("typeCondition")] : "", C3(k3, f3, T3), " ", f3("selectionSet")];
            case "UnionTypeExtension":
            case "UnionTypeDefinition":
              return n3([f3("description"), T3.description ? s3 : "", n3([T3.kind === "UnionTypeExtension" ? "extend " : "", "union ", f3("name"), C3(k3, f3, T3), T3.types.length > 0 ? [" =", o3("", " "), r3([o3([a3, "  "]), t3([a3, "| "], k3.map(f3, "types"))])] : ""])]);
            case "ScalarTypeExtension":
            case "ScalarTypeDefinition":
              return [f3("description"), T3.description ? s3 : "", T3.kind === "ScalarTypeExtension" ? "extend " : "", "scalar ", f3("name"), C3(k3, f3, T3)];
            case "NonNullType":
              return [f3("type"), "!"];
            case "ListType":
              return ["[", f3("type"), "]"];
            default:
              throw new Error("unknown graphql type: " + JSON.stringify(T3.kind));
          }
        }
        function C3(k3, J3, f3) {
          if (f3.directives.length === 0)
            return "";
          let T3 = t3(a3, k3.map(J3, "directives"));
          return f3.kind === "FragmentDefinition" || f3.kind === "OperationDefinition" ? n3([a3, T3]) : [" ", n3(r3([e28, T3]))];
        }
        function w3(k3, J3, f3, T3) {
          return k3.map((D3, F3, i) => {
            let g3 = f3();
            return F3 < i.length - 1 && c3(J3.originalText, D3.getValue(), p3) ? [g3, s3] : g3;
          }, T3);
        }
        function P3(k3) {
          return k3.kind && k3.kind !== "Comment";
        }
        function A3(k3) {
          let J3 = k3.getValue();
          if (J3.kind === "Comment")
            return "#" + J3.value.trimEnd();
          throw new Error("Not a comment: " + JSON.stringify(J3));
        }
        function N3(k3, J3, f3) {
          let T3 = k3.getNode(), D3 = [], { interfaces: F3 } = T3, i = k3.map((g3) => f3(g3), "interfaces");
          for (let g3 = 0; g3 < F3.length; g3++) {
            let E3 = F3[g3];
            D3.push(i[g3]);
            let x3 = F3[g3 + 1];
            if (x3) {
              let b3 = J3.originalText.slice(E3.loc.end, x3.loc.start), B3 = b3.includes("#"), I3 = b3.replace(/#.*/g, "").trim();
              D3.push(I3 === "," ? "," : " &", B3 ? a3 : " ");
            }
          }
          return D3;
        }
        function S3(k3, J3) {
          k3.kind === "StringValue" && k3.block && !k3.value.includes(`
`) && (J3.value = J3.value.trim());
        }
        S3.ignoredProperties = /* @__PURE__ */ new Set(["loc", "comments"]);
        function j3(k3) {
          var J3;
          let f3 = k3.getValue();
          return f3 == null || (J3 = f3.comments) === null || J3 === void 0 ? void 0 : J3.some((T3) => T3.value.trim() === "prettier-ignore");
        }
        l3.exports = { print: d3, massageAstNode: S3, hasPrettierIgnore: j3, insertPragma: m3, printComment: A3, canAttachComment: P3 };
      } }), co2 = X3({ "src/language-graphql/options.js"(u3, l3) {
        H3();
        var t3 = en2();
        l3.exports = { bracketSpacing: t3.bracketSpacing };
      } }), Do2 = X3({ "src/language-graphql/parsers.js"() {
        H3();
      } }), fo2 = X3({ "node_modules/linguist-languages/data/GraphQL.json"(u3, l3) {
        l3.exports = { name: "GraphQL", type: "data", color: "#e10098", extensions: [".graphql", ".gql", ".graphqls"], tmScope: "source.graphql", aceMode: "text", languageId: 139 };
      } }), mo2 = X3({ "src/language-graphql/index.js"(u3, l3) {
        H3();
        var t3 = Gt2(), s3 = po2(), a3 = co2(), e28 = Do2(), n3 = [t3(fo2(), () => ({ since: "1.5.0", parsers: ["graphql"], vscodeLanguageIds: ["graphql"] }))], r3 = { graphql: s3 };
        l3.exports = { languages: n3, options: a3, printers: r3, parsers: e28 };
      } }), Vu2 = X3({ "node_modules/collapse-white-space/index.js"(u3, l3) {
        H3(), l3.exports = t3;
        function t3(s3) {
          return String(s3).replace(/\s+/g, " ");
        }
      } }), Ju2 = X3({ "src/language-markdown/loc.js"(u3, l3) {
        H3();
        function t3(a3) {
          return a3.position.start.offset;
        }
        function s3(a3) {
          return a3.position.end.offset;
        }
        l3.exports = { locStart: t3, locEnd: s3 };
      } }), go2 = X3({ "src/language-markdown/constants.evaluate.js"(u3, l3) {
        l3.exports = { cjkPattern: "(?:[\\u02ea-\\u02eb\\u1100-\\u11ff\\u2e80-\\u2e99\\u2e9b-\\u2ef3\\u2f00-\\u2fd5\\u2ff0-\\u303f\\u3041-\\u3096\\u3099-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312f\\u3131-\\u318e\\u3190-\\u3191\\u3196-\\u31ba\\u31c0-\\u31e3\\u31f0-\\u321e\\u322a-\\u3247\\u3260-\\u327e\\u328a-\\u32b0\\u32c0-\\u32cb\\u32d0-\\u3370\\u337b-\\u337f\\u33e0-\\u33fe\\u3400-\\u4db5\\u4e00-\\u9fef\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufe10-\\ufe1f\\ufe30-\\ufe6f\\uff00-\\uffef]|[\\ud840-\\ud868\\ud86a-\\ud86c\\ud86f-\\ud872\\ud874-\\ud879][\\udc00-\\udfff]|\\ud82c[\\udc00-\\udd1e\\udd50-\\udd52\\udd64-\\udd67]|\\ud83c[\\ude00\\ude50-\\ude51]|\\ud869[\\udc00-\\uded6\\udf00-\\udfff]|\\ud86d[\\udc00-\\udf34\\udf40-\\udfff]|\\ud86e[\\udc00-\\udc1d\\udc20-\\udfff]|\\ud873[\\udc00-\\udea1\\udeb0-\\udfff]|\\ud87a[\\udc00-\\udfe0]|\\ud87e[\\udc00-\\ude1d])(?:[\\ufe00-\\ufe0f]|\\udb40[\\udd00-\\uddef])?", kPattern: "[\\u1100-\\u11ff\\u3001-\\u3003\\u3008-\\u3011\\u3013-\\u301f\\u302e-\\u3030\\u3037\\u30fb\\u3131-\\u318e\\u3200-\\u321e\\u3260-\\u327e\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\ufe45-\\ufe46\\uff61-\\uff65\\uffa0-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc]", punctuationPattern: "[\\u0021-\\u002f\\u003a-\\u0040\\u005b-\\u0060\\u007b-\\u007e\\u00a1\\u00a7\\u00ab\\u00b6-\\u00b7\\u00bb\\u00bf\\u037e\\u0387\\u055a-\\u055f\\u0589-\\u058a\\u05be\\u05c0\\u05c3\\u05c6\\u05f3-\\u05f4\\u0609-\\u060a\\u060c-\\u060d\\u061b\\u061e-\\u061f\\u066a-\\u066d\\u06d4\\u0700-\\u070d\\u07f7-\\u07f9\\u0830-\\u083e\\u085e\\u0964-\\u0965\\u0970\\u09fd\\u0a76\\u0af0\\u0c77\\u0c84\\u0df4\\u0e4f\\u0e5a-\\u0e5b\\u0f04-\\u0f12\\u0f14\\u0f3a-\\u0f3d\\u0f85\\u0fd0-\\u0fd4\\u0fd9-\\u0fda\\u104a-\\u104f\\u10fb\\u1360-\\u1368\\u1400\\u166e\\u169b-\\u169c\\u16eb-\\u16ed\\u1735-\\u1736\\u17d4-\\u17d6\\u17d8-\\u17da\\u1800-\\u180a\\u1944-\\u1945\\u1a1e-\\u1a1f\\u1aa0-\\u1aa6\\u1aa8-\\u1aad\\u1b5a-\\u1b60\\u1bfc-\\u1bff\\u1c3b-\\u1c3f\\u1c7e-\\u1c7f\\u1cc0-\\u1cc7\\u1cd3\\u2010-\\u2027\\u2030-\\u2043\\u2045-\\u2051\\u2053-\\u205e\\u207d-\\u207e\\u208d-\\u208e\\u2308-\\u230b\\u2329-\\u232a\\u2768-\\u2775\\u27c5-\\u27c6\\u27e6-\\u27ef\\u2983-\\u2998\\u29d8-\\u29db\\u29fc-\\u29fd\\u2cf9-\\u2cfc\\u2cfe-\\u2cff\\u2d70\\u2e00-\\u2e2e\\u2e30-\\u2e4f\\u3001-\\u3003\\u3008-\\u3011\\u3014-\\u301f\\u3030\\u303d\\u30a0\\u30fb\\ua4fe-\\ua4ff\\ua60d-\\ua60f\\ua673\\ua67e\\ua6f2-\\ua6f7\\ua874-\\ua877\\ua8ce-\\ua8cf\\ua8f8-\\ua8fa\\ua8fc\\ua92e-\\ua92f\\ua95f\\ua9c1-\\ua9cd\\ua9de-\\ua9df\\uaa5c-\\uaa5f\\uaade-\\uaadf\\uaaf0-\\uaaf1\\uabeb\\ufd3e-\\ufd3f\\ufe10-\\ufe19\\ufe30-\\ufe52\\ufe54-\\ufe61\\ufe63\\ufe68\\ufe6a-\\ufe6b\\uff01-\\uff03\\uff05-\\uff0a\\uff0c-\\uff0f\\uff1a-\\uff1b\\uff1f-\\uff20\\uff3b-\\uff3d\\uff3f\\uff5b\\uff5d\\uff5f-\\uff65]|\\ud800[\\udd00-\\udd02\\udf9f\\udfd0]|\\ud801[\\udd6f]|\\ud802[\\udc57\\udd1f\\udd3f\\ude50-\\ude58\\ude7f\\udef0-\\udef6\\udf39-\\udf3f\\udf99-\\udf9c]|\\ud803[\\udf55-\\udf59]|\\ud804[\\udc47-\\udc4d\\udcbb-\\udcbc\\udcbe-\\udcc1\\udd40-\\udd43\\udd74-\\udd75\\uddc5-\\uddc8\\uddcd\\udddb\\udddd-\\udddf\\ude38-\\ude3d\\udea9]|\\ud805[\\udc4b-\\udc4f\\udc5b\\udc5d\\udcc6\\uddc1-\\uddd7\\ude41-\\ude43\\ude60-\\ude6c\\udf3c-\\udf3e]|\\ud806[\\udc3b\\udde2\\ude3f-\\ude46\\ude9a-\\ude9c\\ude9e-\\udea2]|\\ud807[\\udc41-\\udc45\\udc70-\\udc71\\udef7-\\udef8\\udfff]|\\ud809[\\udc70-\\udc74]|\\ud81a[\\ude6e-\\ude6f\\udef5\\udf37-\\udf3b\\udf44]|\\ud81b[\\ude97-\\ude9a\\udfe2]|\\ud82f[\\udc9f]|\\ud836[\\ude87-\\ude8b]|\\ud83a[\\udd5e-\\udd5f]" };
      } }), fr2 = X3({ "src/language-markdown/utils.js"(u3, l3) {
        H3();
        var { getLast: t3 } = at2(), { locStart: s3, locEnd: a3 } = Ju2(), { cjkPattern: e28, kPattern: n3, punctuationPattern: r3 } = go2(), o3 = ["liquidNode", "inlineCode", "emphasis", "esComment", "strong", "delete", "wikiLink", "link", "linkReference", "image", "imageReference", "footnote", "footnoteReference", "sentence", "whitespace", "word", "break", "inlineMath"], c3 = [...o3, "tableCell", "paragraph", "heading"], h3 = new RegExp(n3), m3 = new RegExp(r3);
        function y3(A3, N3) {
          let S3 = "non-cjk", j3 = "cj-letter", k3 = "k-letter", J3 = "cjk-punctuation", f3 = [], T3 = (N3.proseWrap === "preserve" ? A3 : A3.replace(new RegExp(`(${e28})
(${e28})`, "g"), "$1$2")).split(/([\t\n ]+)/);
          for (let [F3, i] of T3.entries()) {
            if (F3 % 2 === 1) {
              f3.push({ type: "whitespace", value: /\n/.test(i) ? `
` : " " });
              continue;
            }
            if ((F3 === 0 || F3 === T3.length - 1) && i === "")
              continue;
            let g3 = i.split(new RegExp(`(${e28})`));
            for (let [E3, x3] of g3.entries())
              if (!((E3 === 0 || E3 === g3.length - 1) && x3 === "")) {
                if (E3 % 2 === 0) {
                  x3 !== "" && D3({ type: "word", value: x3, kind: S3, hasLeadingPunctuation: m3.test(x3[0]), hasTrailingPunctuation: m3.test(t3(x3)) });
                  continue;
                }
                D3(m3.test(x3) ? { type: "word", value: x3, kind: J3, hasLeadingPunctuation: true, hasTrailingPunctuation: true } : { type: "word", value: x3, kind: h3.test(x3) ? k3 : j3, hasLeadingPunctuation: false, hasTrailingPunctuation: false });
              }
          }
          return f3;
          function D3(F3) {
            let i = t3(f3);
            i && i.type === "word" && (i.kind === S3 && F3.kind === j3 && !i.hasTrailingPunctuation || i.kind === j3 && F3.kind === S3 && !F3.hasLeadingPunctuation ? f3.push({ type: "whitespace", value: " " }) : !g3(S3, J3) && ![i.value, F3.value].some((E3) => /\u3000/.test(E3)) && f3.push({ type: "whitespace", value: "" })), f3.push(F3);
            function g3(E3, x3) {
              return i.kind === E3 && F3.kind === x3 || i.kind === x3 && F3.kind === E3;
            }
          }
        }
        function p3(A3, N3) {
          let [, S3, j3, k3] = N3.slice(A3.position.start.offset, A3.position.end.offset).match(/^\s*(\d+)(\.|\))(\s*)/);
          return { numberText: S3, marker: j3, leadingSpaces: k3 };
        }
        function d3(A3, N3) {
          if (!A3.ordered || A3.children.length < 2)
            return false;
          let S3 = Number(p3(A3.children[0], N3.originalText).numberText), j3 = Number(p3(A3.children[1], N3.originalText).numberText);
          if (S3 === 0 && A3.children.length > 2) {
            let k3 = Number(p3(A3.children[2], N3.originalText).numberText);
            return j3 === 1 && k3 === 1;
          }
          return j3 === 1;
        }
        function C3(A3, N3) {
          let { value: S3 } = A3;
          return A3.position.end.offset === N3.length && S3.endsWith(`
`) && N3.endsWith(`
`) ? S3.slice(0, -1) : S3;
        }
        function w3(A3, N3) {
          return function S3(j3, k3, J3) {
            let f3 = Object.assign({}, N3(j3, k3, J3));
            return f3.children && (f3.children = f3.children.map((T3, D3) => S3(T3, D3, [f3, ...J3]))), f3;
          }(A3, null, []);
        }
        function P3(A3) {
          if ((A3 == null ? void 0 : A3.type) !== "link" || A3.children.length !== 1)
            return false;
          let [N3] = A3.children;
          return s3(A3) === s3(N3) && a3(A3) === a3(N3);
        }
        l3.exports = { mapAst: w3, splitText: y3, punctuationPattern: r3, getFencedCodeBlockValue: C3, getOrderedListItemInfo: p3, hasGitDiffFriendlyOrderedList: d3, INLINE_NODE_TYPES: o3, INLINE_NODE_WRAPPER_TYPES: c3, isAutolink: P3 };
      } }), yo2 = X3({ "src/language-markdown/embed.js"(u3, l3) {
        H3();
        var { inferParserByLanguage: t3, getMaxContinuousCount: s3 } = at2(), { builders: { hardline: a3, markAsRoot: e28 }, utils: { replaceEndOfLine: n3 } } = Qe2(), r3 = Dr2(), { getFencedCodeBlockValue: o3 } = fr2();
        function c3(h3, m3, y3, p3) {
          let d3 = h3.getValue();
          if (d3.type === "code" && d3.lang !== null) {
            let C3 = t3(d3.lang, p3);
            if (C3) {
              let w3 = p3.__inJsTemplate ? "~" : "`", P3 = w3.repeat(Math.max(3, s3(d3.value, w3) + 1)), A3 = { parser: C3 };
              d3.lang === "tsx" && (A3.filepath = "dummy.tsx");
              let N3 = y3(o3(d3, p3.originalText), A3, { stripTrailingHardline: true });
              return e28([P3, d3.lang, d3.meta ? " " + d3.meta : "", a3, n3(N3), a3, P3]);
            }
          }
          switch (d3.type) {
            case "front-matter":
              return r3(d3, y3);
            case "importExport":
              return [y3(d3.value, { parser: "babel" }, { stripTrailingHardline: true }), a3];
            case "jsx":
              return y3(`<$>${d3.value}</$>`, { parser: "__js_expression", rootMarker: "mdx" }, { stripTrailingHardline: true });
          }
          return null;
        }
        l3.exports = c3;
      } }), qu2 = X3({ "src/language-markdown/pragma.js"(u3, l3) {
        H3();
        var t3 = Ru2(), s3 = ["format", "prettier"];
        function a3(e28) {
          let n3 = `@(${s3.join("|")})`, r3 = new RegExp([`<!--\\s*${n3}\\s*-->`, `{\\s*\\/\\*\\s*${n3}\\s*\\*\\/\\s*}`, `<!--.*\r?
[\\s\\S]*(^|
)[^\\S
]*${n3}[^\\S
]*($|
)[\\s\\S]*
.*-->`].join("|"), "m"), o3 = e28.match(r3);
          return (o3 == null ? void 0 : o3.index) === 0;
        }
        l3.exports = { startWithPragma: a3, hasPragma: (e28) => a3(t3(e28).content.trimStart()), insertPragma: (e28) => {
          let n3 = t3(e28), r3 = `<!-- @${s3[0]} -->`;
          return n3.frontMatter ? `${n3.frontMatter.raw}

${r3}

${n3.content}` : `${r3}

${n3.content}`;
        } };
      } }), ho2 = X3({ "src/language-markdown/print-preprocess.js"(u3, l3) {
        H3();
        var t3 = Ct2(), { getOrderedListItemInfo: s3, mapAst: a3, splitText: e28 } = fr2(), n3 = /^.$/su;
        function r3(P3, A3) {
          return P3 = h3(P3, A3), P3 = p3(P3), P3 = c3(P3, A3), P3 = C3(P3, A3), P3 = w3(P3, A3), P3 = d3(P3, A3), P3 = o3(P3), P3 = m3(P3), P3;
        }
        function o3(P3) {
          return a3(P3, (A3) => A3.type !== "import" && A3.type !== "export" ? A3 : Object.assign(Object.assign({}, A3), {}, { type: "importExport" }));
        }
        function c3(P3, A3) {
          return a3(P3, (N3) => N3.type !== "inlineCode" || A3.proseWrap === "preserve" ? N3 : Object.assign(Object.assign({}, N3), {}, { value: N3.value.replace(/\s+/g, " ") }));
        }
        function h3(P3, A3) {
          return a3(P3, (N3) => N3.type !== "text" || N3.value === "*" || N3.value === "_" || !n3.test(N3.value) || N3.position.end.offset - N3.position.start.offset === N3.value.length ? N3 : Object.assign(Object.assign({}, N3), {}, { value: A3.originalText.slice(N3.position.start.offset, N3.position.end.offset) }));
        }
        function m3(P3) {
          return y3(P3, (A3, N3) => A3.type === "importExport" && N3.type === "importExport", (A3, N3) => ({ type: "importExport", value: A3.value + `

` + N3.value, position: { start: A3.position.start, end: N3.position.end } }));
        }
        function y3(P3, A3, N3) {
          return a3(P3, (S3) => {
            if (!S3.children)
              return S3;
            let j3 = S3.children.reduce((k3, J3) => {
              let f3 = t3(k3);
              return f3 && A3(f3, J3) ? k3.splice(-1, 1, N3(f3, J3)) : k3.push(J3), k3;
            }, []);
            return Object.assign(Object.assign({}, S3), {}, { children: j3 });
          });
        }
        function p3(P3) {
          return y3(P3, (A3, N3) => A3.type === "text" && N3.type === "text", (A3, N3) => ({ type: "text", value: A3.value + N3.value, position: { start: A3.position.start, end: N3.position.end } }));
        }
        function d3(P3, A3) {
          return a3(P3, (N3, S3, j3) => {
            let [k3] = j3;
            if (N3.type !== "text")
              return N3;
            let { value: J3 } = N3;
            return k3.type === "paragraph" && (S3 === 0 && (J3 = J3.trimStart()), S3 === k3.children.length - 1 && (J3 = J3.trimEnd())), { type: "sentence", position: N3.position, children: e28(J3, A3) };
          });
        }
        function C3(P3, A3) {
          return a3(P3, (N3, S3, j3) => {
            if (N3.type === "code") {
              let k3 = /^\n?(?: {4,}|\t)/.test(A3.originalText.slice(N3.position.start.offset, N3.position.end.offset));
              if (N3.isIndented = k3, k3)
                for (let J3 = 0; J3 < j3.length; J3++) {
                  let f3 = j3[J3];
                  if (f3.hasIndentedCodeblock)
                    break;
                  f3.type === "list" && (f3.hasIndentedCodeblock = true);
                }
            }
            return N3;
          });
        }
        function w3(P3, A3) {
          return a3(P3, (j3, k3, J3) => {
            if (j3.type === "list" && j3.children.length > 0) {
              for (let f3 = 0; f3 < J3.length; f3++) {
                let T3 = J3[f3];
                if (T3.type === "list" && !T3.isAligned)
                  return j3.isAligned = false, j3;
              }
              j3.isAligned = S3(j3);
            }
            return j3;
          });
          function N3(j3) {
            return j3.children.length === 0 ? -1 : j3.children[0].position.start.column - 1;
          }
          function S3(j3) {
            if (!j3.ordered)
              return true;
            let [k3, J3] = j3.children;
            if (s3(k3, A3.originalText).leadingSpaces.length > 1)
              return true;
            let f3 = N3(k3);
            if (f3 === -1)
              return false;
            if (j3.children.length === 1)
              return f3 % A3.tabWidth === 0;
            let T3 = N3(J3);
            return f3 !== T3 ? false : f3 % A3.tabWidth === 0 ? true : s3(J3, A3.originalText).leadingSpaces.length > 1;
          }
        }
        l3.exports = r3;
      } }), Eo2 = X3({ "src/language-markdown/clean.js"(u3, l3) {
        H3();
        var t3 = Vu2(), { isFrontMatterNode: s3 } = at2(), { startWithPragma: a3 } = qu2(), e28 = /* @__PURE__ */ new Set(["position", "raw"]);
        function n3(r3, o3, c3) {
          if ((r3.type === "front-matter" || r3.type === "code" || r3.type === "yaml" || r3.type === "import" || r3.type === "export" || r3.type === "jsx") && delete o3.value, r3.type === "list" && delete o3.isAligned, (r3.type === "list" || r3.type === "listItem") && (delete o3.spread, delete o3.loose), r3.type === "text" || (r3.type === "inlineCode" && (o3.value = r3.value.replace(/[\t\n ]+/g, " ")), r3.type === "wikiLink" && (o3.value = r3.value.trim().replace(/[\t\n]+/g, " ")), (r3.type === "definition" || r3.type === "linkReference" || r3.type === "imageReference") && (o3.label = t3(r3.label)), (r3.type === "definition" || r3.type === "link" || r3.type === "image") && r3.title && (o3.title = r3.title.replace(/\\(["')])/g, "$1")), c3 && c3.type === "root" && c3.children.length > 0 && (c3.children[0] === r3 || s3(c3.children[0]) && c3.children[1] === r3) && r3.type === "html" && a3(r3.value)))
            return null;
        }
        n3.ignoredProperties = e28, l3.exports = n3;
      } }), Co2 = X3({ "src/language-markdown/printer-markdown.js"(u3, l3) {
        H3();
        var t3 = Vu2(), { getLast: s3, getMinNotPresentContinuousCount: a3, getMaxContinuousCount: e28, getStringWidth: n3, isNonEmptyArray: r3 } = at2(), { builders: { breakParent: o3, join: c3, line: h3, literalline: m3, markAsRoot: y3, hardline: p3, softline: d3, ifBreak: C3, fill: w3, align: P3, indent: A3, group: N3, hardlineWithoutBreakParent: S3 }, utils: { normalizeDoc: j3, replaceTextEndOfLine: k3 }, printer: { printDocToString: J3 } } = Qe2(), f3 = yo2(), { insertPragma: T3 } = qu2(), { locStart: D3, locEnd: F3 } = Ju2(), i = ho2(), g3 = Eo2(), { getFencedCodeBlockValue: E3, hasGitDiffFriendlyOrderedList: x3, splitText: b3, punctuationPattern: B3, INLINE_NODE_TYPES: I3, INLINE_NODE_WRAPPER_TYPES: M3, isAutolink: V10 } = fr2(), $3 = /* @__PURE__ */ new Set(["importExport"]), U3 = ["heading", "tableCell", "link", "wikiLink"], L3 = /* @__PURE__ */ new Set(["listItem", "definition", "footnoteDefinition"]);
        function ee2(le2, G3, me2) {
          let K3 = le2.getValue();
          if (Fe2(le2))
            return b3(G3.originalText.slice(K3.position.start.offset, K3.position.end.offset), G3).map((de2) => de2.type === "word" ? de2.value : de2.value === "" ? "" : q3(le2, de2.value, G3));
          switch (K3.type) {
            case "front-matter":
              return G3.originalText.slice(K3.position.start.offset, K3.position.end.offset);
            case "root":
              return K3.children.length === 0 ? "" : [j3(De2(le2, G3, me2)), $3.has(Q3(K3).type) ? "" : p3];
            case "paragraph":
              return fe2(le2, G3, me2, { postprocessor: w3 });
            case "sentence":
              return fe2(le2, G3, me2);
            case "word": {
              let de2 = K3.value.replace(/\*/g, "\\$&").replace(new RegExp([`(^|${B3})(_+)`, `(_+)(${B3}|$)`].join("|"), "g"), (ye2, v3, Y3, ae2, Ae2) => (Y3 ? `${v3}${Y3}` : `${ae2}${Ae2}`).replace(/_/g, "\\_")), je2 = (ye2, v3, Y3) => ye2.type === "sentence" && Y3 === 0, Be2 = (ye2, v3, Y3) => V10(ye2.children[Y3 - 1]);
              return de2 !== K3.value && (le2.match(void 0, je2, Be2) || le2.match(void 0, je2, (ye2, v3, Y3) => ye2.type === "emphasis" && Y3 === 0, Be2)) && (de2 = de2.replace(/^(\\?[*_])+/, (ye2) => ye2.replace(/\\/g, ""))), de2;
            }
            case "whitespace": {
              let de2 = le2.getParentNode(), je2 = de2.children.indexOf(K3), Be2 = de2.children[je2 + 1], ye2 = Be2 && /^>|^(?:[*+-]|#{1,6}|\d+[).])$/.test(Be2.value) ? "never" : G3.proseWrap;
              return q3(le2, K3.value, { proseWrap: ye2 });
            }
            case "emphasis": {
              let de2;
              if (V10(K3.children[0]))
                de2 = G3.originalText[K3.position.start.offset];
              else {
                let je2 = le2.getParentNode(), Be2 = je2.children.indexOf(K3), ye2 = je2.children[Be2 - 1], v3 = je2.children[Be2 + 1];
                de2 = ye2 && ye2.type === "sentence" && ye2.children.length > 0 && s3(ye2.children).type === "word" && !s3(ye2.children).hasTrailingPunctuation || v3 && v3.type === "sentence" && v3.children.length > 0 && v3.children[0].type === "word" && !v3.children[0].hasLeadingPunctuation || ge2(le2, "emphasis") ? "*" : "_";
              }
              return [de2, fe2(le2, G3, me2), de2];
            }
            case "strong":
              return ["**", fe2(le2, G3, me2), "**"];
            case "delete":
              return ["~~", fe2(le2, G3, me2), "~~"];
            case "inlineCode": {
              let de2 = a3(K3.value, "`"), je2 = "`".repeat(de2 || 1), Be2 = de2 && !/^\s/.test(K3.value) ? " " : "";
              return [je2, Be2, K3.value, Be2, je2];
            }
            case "wikiLink": {
              let de2 = "";
              return G3.proseWrap === "preserve" ? de2 = K3.value : de2 = K3.value.replace(/[\t\n]+/g, " "), ["[[", de2, "]]"];
            }
            case "link":
              switch (G3.originalText[K3.position.start.offset]) {
                case "<": {
                  let de2 = "mailto:";
                  return ["<", K3.url.startsWith(de2) && G3.originalText.slice(K3.position.start.offset + 1, K3.position.start.offset + 1 + de2.length) !== de2 ? K3.url.slice(de2.length) : K3.url, ">"];
                }
                case "[":
                  return ["[", fe2(le2, G3, me2), "](", ve2(K3.url, ")"), Re2(K3.title, G3), ")"];
                default:
                  return G3.originalText.slice(K3.position.start.offset, K3.position.end.offset);
              }
            case "image":
              return ["![", K3.alt || "", "](", ve2(K3.url, ")"), Re2(K3.title, G3), ")"];
            case "blockquote":
              return ["> ", P3("> ", fe2(le2, G3, me2))];
            case "heading":
              return ["#".repeat(K3.depth) + " ", fe2(le2, G3, me2)];
            case "code": {
              if (K3.isIndented) {
                let Be2 = " ".repeat(4);
                return P3(Be2, [Be2, ...k3(K3.value, p3)]);
              }
              let de2 = G3.__inJsTemplate ? "~" : "`", je2 = de2.repeat(Math.max(3, e28(K3.value, de2) + 1));
              return [je2, K3.lang || "", K3.meta ? " " + K3.meta : "", p3, ...k3(E3(K3, G3.originalText), p3), p3, je2];
            }
            case "html": {
              let de2 = le2.getParentNode(), je2 = de2.type === "root" && s3(de2.children) === K3 ? K3.value.trimEnd() : K3.value, Be2 = /^<!--.*-->$/s.test(je2);
              return k3(je2, Be2 ? p3 : y3(m3));
            }
            case "list": {
              let de2 = Z3(K3, le2.getParentNode()), je2 = x3(K3, G3);
              return fe2(le2, G3, me2, { processor: (Be2, ye2) => {
                let v3 = ae2(), Y3 = Be2.getValue();
                if (Y3.children.length === 2 && Y3.children[1].type === "html" && Y3.children[0].position.start.column !== Y3.children[1].position.start.column)
                  return [v3, R3(Be2, G3, me2, v3)];
                return [v3, P3(" ".repeat(v3.length), R3(Be2, G3, me2, v3))];
                function ae2() {
                  let Ae2 = K3.ordered ? (ye2 === 0 ? K3.start : je2 ? 1 : K3.start + ye2) + (de2 % 2 === 0 ? ". " : ") ") : de2 % 2 === 0 ? "- " : "* ";
                  return K3.isAligned || K3.hasIndentedCodeblock ? O3(Ae2, G3) : Ae2;
                }
              } });
            }
            case "thematicBreak": {
              let de2 = te2(le2, "list");
              return de2 === -1 ? "---" : Z3(le2.getParentNode(de2), le2.getParentNode(de2 + 1)) % 2 === 0 ? "***" : "---";
            }
            case "linkReference":
              return ["[", fe2(le2, G3, me2), "]", K3.referenceType === "full" ? $e2(K3) : K3.referenceType === "collapsed" ? "[]" : ""];
            case "imageReference":
              switch (K3.referenceType) {
                case "full":
                  return ["![", K3.alt || "", "]", $e2(K3)];
                default:
                  return ["![", K3.alt, "]", K3.referenceType === "collapsed" ? "[]" : ""];
              }
            case "definition": {
              let de2 = G3.proseWrap === "always" ? h3 : " ";
              return N3([$e2(K3), ":", A3([de2, ve2(K3.url), K3.title === null ? "" : [de2, Re2(K3.title, G3, false)]])]);
            }
            case "footnote":
              return ["[^", fe2(le2, G3, me2), "]"];
            case "footnoteReference":
              return Ge2(K3);
            case "footnoteDefinition": {
              let de2 = le2.getParentNode().children[le2.getName() + 1], je2 = K3.children.length === 1 && K3.children[0].type === "paragraph" && (G3.proseWrap === "never" || G3.proseWrap === "preserve" && K3.children[0].position.start.line === K3.children[0].position.end.line);
              return [Ge2(K3), ": ", je2 ? fe2(le2, G3, me2) : N3([P3(" ".repeat(4), fe2(le2, G3, me2, { processor: (Be2, ye2) => ye2 === 0 ? N3([d3, me2()]) : me2() })), de2 && de2.type === "footnoteDefinition" ? d3 : ""])];
            }
            case "table":
              return z3(le2, G3, me2);
            case "tableCell":
              return fe2(le2, G3, me2);
            case "break":
              return /\s/.test(G3.originalText[K3.position.start.offset]) ? ["  ", y3(m3)] : ["\\", p3];
            case "liquidNode":
              return k3(K3.value, p3);
            case "importExport":
              return [K3.value, p3];
            case "esComment":
              return ["{/* ", K3.value, " */}"];
            case "jsx":
              return K3.value;
            case "math":
              return ["$$", p3, K3.value ? [...k3(K3.value, p3), p3] : "", "$$"];
            case "inlineMath":
              return G3.originalText.slice(D3(K3), F3(K3));
            case "tableRow":
            case "listItem":
            default:
              throw new Error(`Unknown markdown type ${JSON.stringify(K3.type)}`);
          }
        }
        function R3(le2, G3, me2, K3) {
          let de2 = le2.getValue(), je2 = de2.checked === null ? "" : de2.checked ? "[x] " : "[ ] ";
          return [je2, fe2(le2, G3, me2, { processor: (Be2, ye2) => {
            if (ye2 === 0 && Be2.getValue().type !== "list")
              return P3(" ".repeat(je2.length), me2());
            let v3 = " ".repeat(tt2(G3.tabWidth - K3.length, 0, 3));
            return [v3, P3(v3, me2())];
          } })];
        }
        function O3(le2, G3) {
          let me2 = K3();
          return le2 + " ".repeat(me2 >= 4 ? 0 : me2);
          function K3() {
            let de2 = le2.length % G3.tabWidth;
            return de2 === 0 ? 0 : G3.tabWidth - de2;
          }
        }
        function Z3(le2, G3) {
          return ie2(le2, G3, (me2) => me2.ordered === le2.ordered);
        }
        function ie2(le2, G3, me2) {
          let K3 = -1;
          for (let de2 of G3.children)
            if (de2.type === le2.type && me2(de2) ? K3++ : K3 = -1, de2 === le2)
              return K3;
        }
        function te2(le2, G3) {
          let me2 = Array.isArray(G3) ? G3 : [G3], K3 = -1, de2;
          for (; de2 = le2.getParentNode(++K3); )
            if (me2.includes(de2.type))
              return K3;
          return -1;
        }
        function ge2(le2, G3) {
          let me2 = te2(le2, G3);
          return me2 === -1 ? null : le2.getParentNode(me2);
        }
        function q3(le2, G3, me2) {
          if (me2.proseWrap === "preserve" && G3 === `
`)
            return p3;
          let K3 = me2.proseWrap === "always" && !ge2(le2, U3);
          return G3 !== "" ? K3 ? h3 : " " : K3 ? d3 : "";
        }
        function z3(le2, G3, me2) {
          let K3 = le2.getValue(), de2 = [], je2 = le2.map((Ae2) => Ae2.map((Se2, Me2) => {
            let xe2 = J3(me2(), G3).formatted, mt2 = n3(xe2);
            return de2[Me2] = Math.max(de2[Me2] || 3, mt2), { text: xe2, width: mt2 };
          }, "children"), "children"), Be2 = v3(false);
          if (G3.proseWrap !== "never")
            return [o3, Be2];
          let ye2 = v3(true);
          return [o3, N3(C3(ye2, Be2))];
          function v3(Ae2) {
            let Se2 = [ae2(je2[0], Ae2), Y3(Ae2)];
            return je2.length > 1 && Se2.push(c3(S3, je2.slice(1).map((Me2) => ae2(Me2, Ae2)))), c3(S3, Se2);
          }
          function Y3(Ae2) {
            return `| ${de2.map((Se2, Me2) => {
              let xe2 = K3.align[Me2], mt2 = xe2 === "center" || xe2 === "left" ? ":" : "-", _e2 = xe2 === "center" || xe2 === "right" ? ":" : "-", ft2 = Ae2 ? "-" : "-".repeat(Se2 - 2);
              return `${mt2}${ft2}${_e2}`;
            }).join(" | ")} |`;
          }
          function ae2(Ae2, Se2) {
            return `| ${Ae2.map((Me2, xe2) => {
              let { text: mt2, width: _e2 } = Me2;
              if (Se2)
                return mt2;
              let ft2 = de2[xe2] - _e2, Le2 = K3.align[xe2], Ue2 = 0;
              Le2 === "right" ? Ue2 = ft2 : Le2 === "center" && (Ue2 = Math.floor(ft2 / 2));
              let et2 = ft2 - Ue2;
              return `${" ".repeat(Ue2)}${mt2}${" ".repeat(et2)}`;
            }).join(" | ")} |`;
          }
        }
        function De2(le2, G3, me2) {
          let K3 = [], de2 = null, { children: je2 } = le2.getValue();
          for (let [Be2, ye2] of je2.entries())
            switch (W3(ye2)) {
              case "start":
                de2 === null && (de2 = { index: Be2, offset: ye2.position.end.offset });
                break;
              case "end":
                de2 !== null && (K3.push({ start: de2, end: { index: Be2, offset: ye2.position.start.offset } }), de2 = null);
                break;
            }
          return fe2(le2, G3, me2, { processor: (Be2, ye2) => {
            if (K3.length > 0) {
              let v3 = K3[0];
              if (ye2 === v3.start.index)
                return [we2(je2[v3.start.index]), G3.originalText.slice(v3.start.offset, v3.end.offset), we2(je2[v3.end.index])];
              if (v3.start.index < ye2 && ye2 < v3.end.index)
                return false;
              if (ye2 === v3.end.index)
                return K3.shift(), false;
            }
            return me2();
          } });
        }
        function fe2(le2, G3, me2) {
          let K3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, { postprocessor: de2 } = K3, je2 = K3.processor || (() => me2()), Be2 = le2.getValue(), ye2 = [], v3;
          return le2.each((Y3, ae2) => {
            let Ae2 = Y3.getValue(), Se2 = je2(Y3, ae2);
            if (Se2 !== false) {
              let Me2 = { parts: ye2, prevNode: v3, parentNode: Be2, options: G3 };
              ne2(Ae2, Me2) && (ye2.push(p3), v3 && $3.has(v3.type) || (re2(Ae2, Me2) || he2(Ae2, Me2)) && ye2.push(p3), he2(Ae2, Me2) && ye2.push(p3)), ye2.push(Se2), v3 = Ae2;
            }
          }, "children"), de2 ? de2(ye2) : ye2;
        }
        function we2(le2) {
          if (le2.type === "html")
            return le2.value;
          if (le2.type === "paragraph" && Array.isArray(le2.children) && le2.children.length === 1 && le2.children[0].type === "esComment")
            return ["{/* ", le2.children[0].value, " */}"];
        }
        function Q3(le2) {
          let G3 = le2;
          for (; r3(G3.children); )
            G3 = s3(G3.children);
          return G3;
        }
        function W3(le2) {
          let G3;
          if (le2.type === "html")
            G3 = le2.value.match(/^<!--\s*prettier-ignore(?:-(start|end))?\s*-->$/);
          else {
            let me2;
            le2.type === "esComment" ? me2 = le2 : le2.type === "paragraph" && le2.children.length === 1 && le2.children[0].type === "esComment" && (me2 = le2.children[0]), me2 && (G3 = me2.value.match(/^prettier-ignore(?:-(start|end))?$/));
          }
          return G3 ? G3[1] || "next" : false;
        }
        function ne2(le2, G3) {
          let me2 = G3.parts.length === 0, K3 = I3.includes(le2.type), de2 = le2.type === "html" && M3.includes(G3.parentNode.type);
          return !me2 && !K3 && !de2;
        }
        function re2(le2, G3) {
          var me2, K3, de2;
          let je2 = (G3.prevNode && G3.prevNode.type) === le2.type && L3.has(le2.type), Be2 = G3.parentNode.type === "listItem" && !G3.parentNode.loose, ye2 = ((me2 = G3.prevNode) === null || me2 === void 0 ? void 0 : me2.type) === "listItem" && G3.prevNode.loose, v3 = W3(G3.prevNode) === "next", Y3 = le2.type === "html" && ((K3 = G3.prevNode) === null || K3 === void 0 ? void 0 : K3.type) === "html" && G3.prevNode.position.end.line + 1 === le2.position.start.line, ae2 = le2.type === "html" && G3.parentNode.type === "listItem" && ((de2 = G3.prevNode) === null || de2 === void 0 ? void 0 : de2.type) === "paragraph" && G3.prevNode.position.end.line + 1 === le2.position.start.line;
          return ye2 || !(je2 || Be2 || v3 || Y3 || ae2);
        }
        function he2(le2, G3) {
          let me2 = G3.prevNode && G3.prevNode.type === "list", K3 = le2.type === "code" && le2.isIndented;
          return me2 && K3;
        }
        function Fe2(le2) {
          let G3 = ge2(le2, ["linkReference", "imageReference"]);
          return G3 && (G3.type !== "linkReference" || G3.referenceType !== "full");
        }
        function ve2(le2) {
          let G3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], me2 = [" ", ...Array.isArray(G3) ? G3 : [G3]];
          return new RegExp(me2.map((K3) => `\\${K3}`).join("|")).test(le2) ? `<${le2}>` : le2;
        }
        function Re2(le2, G3) {
          let me2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
          if (!le2)
            return "";
          if (me2)
            return " " + Re2(le2, G3, false);
          if (le2 = le2.replace(/\\(["')])/g, "$1"), le2.includes('"') && le2.includes("'") && !le2.includes(")"))
            return `(${le2})`;
          let K3 = le2.split("'").length - 1, de2 = le2.split('"').length - 1, je2 = K3 > de2 ? '"' : de2 > K3 || G3.singleQuote ? "'" : '"';
          return le2 = le2.replace(/\\/, "\\\\"), le2 = le2.replace(new RegExp(`(${je2})`, "g"), "\\$1"), `${je2}${le2}${je2}`;
        }
        function tt2(le2, G3, me2) {
          return le2 < G3 ? G3 : le2 > me2 ? me2 : le2;
        }
        function Ze2(le2) {
          let G3 = Number(le2.getName());
          if (G3 === 0)
            return false;
          let me2 = le2.getParentNode().children[G3 - 1];
          return W3(me2) === "next";
        }
        function $e2(le2) {
          return `[${t3(le2.label)}]`;
        }
        function Ge2(le2) {
          return `[^${le2.label}]`;
        }
        l3.exports = { preprocess: i, print: ee2, embed: f3, massageAstNode: g3, hasPrettierIgnore: Ze2, insertPragma: T3 };
      } }), Fo2 = X3({ "src/language-markdown/options.js"(u3, l3) {
        H3();
        var t3 = en2();
        l3.exports = { proseWrap: t3.proseWrap, singleQuote: t3.singleQuote };
      } }), Ao2 = X3({ "src/language-markdown/parsers.js"() {
        H3();
      } }), Gu2 = X3({ "node_modules/linguist-languages/data/Markdown.json"(u3, l3) {
        l3.exports = { name: "Markdown", type: "prose", color: "#083fa1", aliases: ["pandoc"], aceMode: "markdown", codemirrorMode: "gfm", codemirrorMimeType: "text/x-gfm", wrap: true, extensions: [".md", ".livemd", ".markdown", ".mdown", ".mdwn", ".mdx", ".mkd", ".mkdn", ".mkdown", ".ronn", ".scd", ".workbook"], filenames: ["contents.lr"], tmScope: "source.gfm", languageId: 222 };
      } }), vo2 = X3({ "src/language-markdown/index.js"(u3, l3) {
        H3();
        var t3 = Gt2(), s3 = Co2(), a3 = Fo2(), e28 = Ao2(), n3 = [t3(Gu2(), (o3) => ({ since: "1.8.0", parsers: ["markdown"], vscodeLanguageIds: ["markdown"], filenames: [...o3.filenames, "README"], extensions: o3.extensions.filter((c3) => c3 !== ".mdx") })), t3(Gu2(), () => ({ name: "MDX", since: "1.15.0", parsers: ["mdx"], vscodeLanguageIds: ["mdx"], filenames: [], extensions: [".mdx"] }))], r3 = { mdast: s3 };
        l3.exports = { languages: n3, options: a3, printers: r3, parsers: e28 };
      } }), xo2 = X3({ "src/language-html/clean.js"(u3, l3) {
        H3();
        var { isFrontMatterNode: t3 } = at2(), s3 = /* @__PURE__ */ new Set(["sourceSpan", "startSourceSpan", "endSourceSpan", "nameSpan", "valueSpan"]);
        function a3(e28, n3) {
          if (e28.type === "text" || e28.type === "comment" || t3(e28) || e28.type === "yaml" || e28.type === "toml")
            return null;
          e28.type === "attribute" && delete n3.value, e28.type === "docType" && delete n3.value;
        }
        a3.ignoredProperties = s3, l3.exports = a3;
      } }), bo2 = X3({ "src/language-html/constants.evaluate.js"(u3, l3) {
        l3.exports = { CSS_DISPLAY_TAGS: { area: "none", base: "none", basefont: "none", datalist: "none", head: "none", link: "none", meta: "none", noembed: "none", noframes: "none", param: "block", rp: "none", script: "block", source: "block", style: "none", template: "inline", track: "block", title: "none", html: "block", body: "block", address: "block", blockquote: "block", center: "block", div: "block", figure: "block", figcaption: "block", footer: "block", form: "block", header: "block", hr: "block", legend: "block", listing: "block", main: "block", p: "block", plaintext: "block", pre: "block", xmp: "block", slot: "contents", ruby: "ruby", rt: "ruby-text", article: "block", aside: "block", h1: "block", h2: "block", h3: "block", h4: "block", h5: "block", h6: "block", hgroup: "block", nav: "block", section: "block", dir: "block", dd: "block", dl: "block", dt: "block", ol: "block", ul: "block", li: "list-item", table: "table", caption: "table-caption", colgroup: "table-column-group", col: "table-column", thead: "table-header-group", tbody: "table-row-group", tfoot: "table-footer-group", tr: "table-row", td: "table-cell", th: "table-cell", fieldset: "block", button: "inline-block", details: "block", summary: "block", dialog: "block", meter: "inline-block", progress: "inline-block", object: "inline-block", video: "inline-block", audio: "inline-block", select: "inline-block", option: "block", optgroup: "block" }, CSS_DISPLAY_DEFAULT: "inline", CSS_WHITE_SPACE_TAGS: { listing: "pre", plaintext: "pre", pre: "pre", xmp: "pre", nobr: "nowrap", table: "initial", textarea: "pre-wrap" }, CSS_WHITE_SPACE_DEFAULT: "normal" };
      } }), So2 = X3({ "src/language-html/utils/is-unknown-namespace.js"(u3, l3) {
        H3();
        function t3(s3) {
          return s3.type === "element" && !s3.hasExplicitNamespace && !["html", "svg"].includes(s3.namespace);
        }
        l3.exports = t3;
      } }), tn2 = X3({ "src/language-html/utils/index.js"(u3, l3) {
        H3();
        var { inferParserByLanguage: t3, isFrontMatterNode: s3 } = at2(), { builders: { line: a3, hardline: e28, join: n3 }, utils: { getDocParts: r3, replaceTextEndOfLine: o3 } } = Qe2(), { CSS_DISPLAY_TAGS: c3, CSS_DISPLAY_DEFAULT: h3, CSS_WHITE_SPACE_TAGS: m3, CSS_WHITE_SPACE_DEFAULT: y3 } = bo2(), p3 = So2(), d3 = /* @__PURE__ */ new Set(["	", `
`, "\f", "\r", " "]), C3 = (v3) => v3.replace(/^[\t\n\f\r ]+/, ""), w3 = (v3) => v3.replace(/[\t\n\f\r ]+$/, ""), P3 = (v3) => C3(w3(v3)), A3 = (v3) => v3.replace(/^[\t\f\r ]*\n/g, ""), N3 = (v3) => A3(w3(v3)), S3 = (v3) => v3.split(/[\t\n\f\r ]+/), j3 = (v3) => v3.match(/^[\t\n\f\r ]*/)[0], k3 = (v3) => {
          let [, Y3, ae2, Ae2] = v3.match(/^([\t\n\f\r ]*)(.*?)([\t\n\f\r ]*)$/s);
          return { leadingWhitespace: Y3, trailingWhitespace: Ae2, text: ae2 };
        }, J3 = (v3) => /[\t\n\f\r ]/.test(v3);
        function f3(v3, Y3) {
          return !!(v3.type === "ieConditionalComment" && v3.lastChild && !v3.lastChild.isSelfClosing && !v3.lastChild.endSourceSpan || v3.type === "ieConditionalComment" && !v3.complete || re2(v3) && v3.children.some((ae2) => ae2.type !== "text" && ae2.type !== "interpolation") || K3(v3, Y3) && !i(v3) && v3.type !== "interpolation");
        }
        function T3(v3) {
          return v3.type === "attribute" || !v3.parent || !v3.prev ? false : D3(v3.prev);
        }
        function D3(v3) {
          return v3.type === "comment" && v3.value.trim() === "prettier-ignore";
        }
        function F3(v3) {
          return v3.type === "text" || v3.type === "comment";
        }
        function i(v3) {
          return v3.type === "element" && (v3.fullName === "script" || v3.fullName === "style" || v3.fullName === "svg:style" || p3(v3) && (v3.name === "script" || v3.name === "style"));
        }
        function g3(v3) {
          return v3.children && !i(v3);
        }
        function E3(v3) {
          return i(v3) || v3.type === "interpolation" || x3(v3);
        }
        function x3(v3) {
          return Re2(v3).startsWith("pre");
        }
        function b3(v3, Y3) {
          let ae2 = Ae2();
          if (ae2 && !v3.prev && v3.parent && v3.parent.tagDefinition && v3.parent.tagDefinition.ignoreFirstLf)
            return v3.type === "interpolation";
          return ae2;
          function Ae2() {
            return s3(v3) ? false : (v3.type === "text" || v3.type === "interpolation") && v3.prev && (v3.prev.type === "text" || v3.prev.type === "interpolation") ? true : !v3.parent || v3.parent.cssDisplay === "none" ? false : re2(v3.parent) ? true : !(!v3.prev && (v3.parent.type === "root" || re2(v3) && v3.parent || i(v3.parent) || G3(v3.parent, Y3) || !fe2(v3.parent.cssDisplay)) || v3.prev && !W3(v3.prev.cssDisplay));
          }
        }
        function B3(v3, Y3) {
          return s3(v3) ? false : (v3.type === "text" || v3.type === "interpolation") && v3.next && (v3.next.type === "text" || v3.next.type === "interpolation") ? true : !v3.parent || v3.parent.cssDisplay === "none" ? false : re2(v3.parent) ? true : !(!v3.next && (v3.parent.type === "root" || re2(v3) && v3.parent || i(v3.parent) || G3(v3.parent, Y3) || !we2(v3.parent.cssDisplay)) || v3.next && !Q3(v3.next.cssDisplay));
        }
        function I3(v3) {
          return ne2(v3.cssDisplay) && !i(v3);
        }
        function M3(v3) {
          return s3(v3) || v3.next && v3.sourceSpan.end && v3.sourceSpan.end.line + 1 < v3.next.sourceSpan.start.line;
        }
        function V10(v3) {
          return $3(v3) || v3.type === "element" && v3.children.length > 0 && (["body", "script", "style"].includes(v3.name) || v3.children.some((Y3) => te2(Y3))) || v3.firstChild && v3.firstChild === v3.lastChild && v3.firstChild.type !== "text" && R3(v3.firstChild) && (!v3.lastChild.isTrailingSpaceSensitive || O3(v3.lastChild));
        }
        function $3(v3) {
          return v3.type === "element" && v3.children.length > 0 && (["html", "head", "ul", "ol", "select"].includes(v3.name) || v3.cssDisplay.startsWith("table") && v3.cssDisplay !== "table-cell");
        }
        function U3(v3) {
          return Z3(v3) || v3.prev && L3(v3.prev) || ee2(v3);
        }
        function L3(v3) {
          return Z3(v3) || v3.type === "element" && v3.fullName === "br" || ee2(v3);
        }
        function ee2(v3) {
          return R3(v3) && O3(v3);
        }
        function R3(v3) {
          return v3.hasLeadingSpaces && (v3.prev ? v3.prev.sourceSpan.end.line < v3.sourceSpan.start.line : v3.parent.type === "root" || v3.parent.startSourceSpan.end.line < v3.sourceSpan.start.line);
        }
        function O3(v3) {
          return v3.hasTrailingSpaces && (v3.next ? v3.next.sourceSpan.start.line > v3.sourceSpan.end.line : v3.parent.type === "root" || v3.parent.endSourceSpan && v3.parent.endSourceSpan.start.line > v3.sourceSpan.end.line);
        }
        function Z3(v3) {
          switch (v3.type) {
            case "ieConditionalComment":
            case "comment":
            case "directive":
              return true;
            case "element":
              return ["script", "select"].includes(v3.name);
          }
          return false;
        }
        function ie2(v3) {
          return v3.lastChild ? ie2(v3.lastChild) : v3;
        }
        function te2(v3) {
          return v3.children && v3.children.some((Y3) => Y3.type !== "text");
        }
        function ge2(v3) {
          let { type: Y3, lang: ae2 } = v3.attrMap;
          if (Y3 === "module" || Y3 === "text/javascript" || Y3 === "text/babel" || Y3 === "application/javascript" || ae2 === "jsx")
            return "babel";
          if (Y3 === "application/x-typescript" || ae2 === "ts" || ae2 === "tsx")
            return "typescript";
          if (Y3 === "text/markdown")
            return "markdown";
          if (Y3 === "text/html")
            return "html";
          if (Y3 && (Y3.endsWith("json") || Y3.endsWith("importmap")) || Y3 === "speculationrules")
            return "json";
          if (Y3 === "text/x-handlebars-template")
            return "glimmer";
        }
        function q3(v3, Y3) {
          let { lang: ae2 } = v3.attrMap;
          if (!ae2 || ae2 === "postcss" || ae2 === "css")
            return "css";
          if (ae2 === "scss")
            return "scss";
          if (ae2 === "less")
            return "less";
          if (ae2 === "stylus")
            return t3("stylus", Y3);
        }
        function z3(v3, Y3) {
          if (v3.name === "script" && !v3.attrMap.src)
            return !v3.attrMap.lang && !v3.attrMap.type ? "babel" : ge2(v3);
          if (v3.name === "style")
            return q3(v3, Y3);
          if (Y3 && K3(v3, Y3))
            return ge2(v3) || !("src" in v3.attrMap) && t3(v3.attrMap.lang, Y3);
        }
        function De2(v3) {
          return v3 === "block" || v3 === "list-item" || v3.startsWith("table");
        }
        function fe2(v3) {
          return !De2(v3) && v3 !== "inline-block";
        }
        function we2(v3) {
          return !De2(v3) && v3 !== "inline-block";
        }
        function Q3(v3) {
          return !De2(v3);
        }
        function W3(v3) {
          return !De2(v3);
        }
        function ne2(v3) {
          return !De2(v3) && v3 !== "inline-block";
        }
        function re2(v3) {
          return Re2(v3).startsWith("pre");
        }
        function he2(v3, Y3) {
          let ae2 = 0;
          for (let Ae2 = v3.stack.length - 1; Ae2 >= 0; Ae2--) {
            let Se2 = v3.stack[Ae2];
            Se2 && typeof Se2 == "object" && !Array.isArray(Se2) && Y3(Se2) && ae2++;
          }
          return ae2;
        }
        function Fe2(v3, Y3) {
          let ae2 = v3;
          for (; ae2; ) {
            if (Y3(ae2))
              return true;
            ae2 = ae2.parent;
          }
          return false;
        }
        function ve2(v3, Y3) {
          if (v3.prev && v3.prev.type === "comment") {
            let Ae2 = v3.prev.value.match(/^\s*display:\s*([a-z]+)\s*$/);
            if (Ae2)
              return Ae2[1];
          }
          let ae2 = false;
          if (v3.type === "element" && v3.namespace === "svg")
            if (Fe2(v3, (Ae2) => Ae2.fullName === "svg:foreignObject"))
              ae2 = true;
            else
              return v3.name === "svg" ? "inline-block" : "block";
          switch (Y3.htmlWhitespaceSensitivity) {
            case "strict":
              return "inline";
            case "ignore":
              return "block";
            default:
              return Y3.parser === "vue" && v3.parent && v3.parent.type === "root" ? "block" : v3.type === "element" && (!v3.namespace || ae2 || p3(v3)) && c3[v3.name] || h3;
          }
        }
        function Re2(v3) {
          return v3.type === "element" && (!v3.namespace || p3(v3)) && m3[v3.name] || y3;
        }
        function tt2(v3) {
          let Y3 = Number.POSITIVE_INFINITY;
          for (let ae2 of v3.split(`
`)) {
            if (ae2.length === 0)
              continue;
            if (!d3.has(ae2[0]))
              return 0;
            let Ae2 = j3(ae2).length;
            ae2.length !== Ae2 && Ae2 < Y3 && (Y3 = Ae2);
          }
          return Y3 === Number.POSITIVE_INFINITY ? 0 : Y3;
        }
        function Ze2(v3) {
          let Y3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : tt2(v3);
          return Y3 === 0 ? v3 : v3.split(`
`).map((ae2) => ae2.slice(Y3)).join(`
`);
        }
        function $e2(v3, Y3) {
          let ae2 = 0;
          for (let Ae2 = 0; Ae2 < v3.length; Ae2++)
            v3[Ae2] === Y3 && ae2++;
          return ae2;
        }
        function Ge2(v3) {
          return v3.replace(/&apos;/g, "'").replace(/&quot;/g, '"');
        }
        var le2 = /* @__PURE__ */ new Set(["template", "style", "script"]);
        function G3(v3, Y3) {
          return me2(v3, Y3) && !le2.has(v3.fullName);
        }
        function me2(v3, Y3) {
          return Y3.parser === "vue" && v3.type === "element" && v3.parent.type === "root" && v3.fullName.toLowerCase() !== "html";
        }
        function K3(v3, Y3) {
          return me2(v3, Y3) && (G3(v3, Y3) || v3.attrMap.lang && v3.attrMap.lang !== "html");
        }
        function de2(v3) {
          let Y3 = v3.fullName;
          return Y3.charAt(0) === "#" || Y3 === "slot-scope" || Y3 === "v-slot" || Y3.startsWith("v-slot:");
        }
        function je2(v3, Y3) {
          let ae2 = v3.parent;
          if (!me2(ae2, Y3))
            return false;
          let Ae2 = ae2.fullName, Se2 = v3.fullName;
          return Ae2 === "script" && Se2 === "setup" || Ae2 === "style" && Se2 === "vars";
        }
        function Be2(v3) {
          let Y3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : v3.value;
          return v3.parent.isWhitespaceSensitive ? v3.parent.isIndentationSensitive ? o3(Y3) : o3(Ze2(N3(Y3)), e28) : r3(n3(a3, S3(Y3)));
        }
        function ye2(v3, Y3) {
          return me2(v3, Y3) && v3.name === "script";
        }
        l3.exports = { htmlTrim: P3, htmlTrimPreserveIndentation: N3, hasHtmlWhitespace: J3, getLeadingAndTrailingHtmlWhitespace: k3, canHaveInterpolation: g3, countChars: $e2, countParents: he2, dedentString: Ze2, forceBreakChildren: $3, forceBreakContent: V10, forceNextEmptyLine: M3, getLastDescendant: ie2, getNodeCssStyleDisplay: ve2, getNodeCssStyleWhiteSpace: Re2, hasPrettierIgnore: T3, inferScriptParser: z3, isVueCustomBlock: G3, isVueNonHtmlBlock: K3, isVueScriptTag: ye2, isVueSlotAttribute: de2, isVueSfcBindingsAttribute: je2, isVueSfcBlock: me2, isDanglingSpaceSensitiveNode: I3, isIndentationSensitiveNode: x3, isLeadingSpaceSensitiveNode: b3, isPreLikeNode: re2, isScriptLikeTag: i, isTextLikeNode: F3, isTrailingSpaceSensitiveNode: B3, isWhitespaceSensitiveNode: E3, isUnknownNamespace: p3, preferHardlineAsLeadingSpaces: U3, preferHardlineAsTrailingSpaces: L3, shouldPreserveContent: f3, unescapeQuoteEntities: Ge2, getTextValueParts: Be2 };
      } }), To2 = X3({ "node_modules/angular-html-parser/lib/compiler/src/chars.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true }), u3.$EOF = 0, u3.$BSPACE = 8, u3.$TAB = 9, u3.$LF = 10, u3.$VTAB = 11, u3.$FF = 12, u3.$CR = 13, u3.$SPACE = 32, u3.$BANG = 33, u3.$DQ = 34, u3.$HASH = 35, u3.$$ = 36, u3.$PERCENT = 37, u3.$AMPERSAND = 38, u3.$SQ = 39, u3.$LPAREN = 40, u3.$RPAREN = 41, u3.$STAR = 42, u3.$PLUS = 43, u3.$COMMA = 44, u3.$MINUS = 45, u3.$PERIOD = 46, u3.$SLASH = 47, u3.$COLON = 58, u3.$SEMICOLON = 59, u3.$LT = 60, u3.$EQ = 61, u3.$GT = 62, u3.$QUESTION = 63, u3.$0 = 48, u3.$7 = 55, u3.$9 = 57, u3.$A = 65, u3.$E = 69, u3.$F = 70, u3.$X = 88, u3.$Z = 90, u3.$LBRACKET = 91, u3.$BACKSLASH = 92, u3.$RBRACKET = 93, u3.$CARET = 94, u3.$_ = 95, u3.$a = 97, u3.$b = 98, u3.$e = 101, u3.$f = 102, u3.$n = 110, u3.$r = 114, u3.$t = 116, u3.$u = 117, u3.$v = 118, u3.$x = 120, u3.$z = 122, u3.$LBRACE = 123, u3.$BAR = 124, u3.$RBRACE = 125, u3.$NBSP = 160, u3.$PIPE = 124, u3.$TILDA = 126, u3.$AT = 64, u3.$BT = 96;
        function l3(r3) {
          return r3 >= u3.$TAB && r3 <= u3.$SPACE || r3 == u3.$NBSP;
        }
        u3.isWhitespace = l3;
        function t3(r3) {
          return u3.$0 <= r3 && r3 <= u3.$9;
        }
        u3.isDigit = t3;
        function s3(r3) {
          return r3 >= u3.$a && r3 <= u3.$z || r3 >= u3.$A && r3 <= u3.$Z;
        }
        u3.isAsciiLetter = s3;
        function a3(r3) {
          return r3 >= u3.$a && r3 <= u3.$f || r3 >= u3.$A && r3 <= u3.$F || t3(r3);
        }
        u3.isAsciiHexDigit = a3;
        function e28(r3) {
          return r3 === u3.$LF || r3 === u3.$CR;
        }
        u3.isNewLine = e28;
        function n3(r3) {
          return u3.$0 <= r3 && r3 <= u3.$7;
        }
        u3.isOctalDigit = n3;
      } }), Bo2 = X3({ "node_modules/angular-html-parser/lib/compiler/src/aot/static_symbol.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = class {
          constructor(s3, a3, e28) {
            this.filePath = s3, this.name = a3, this.members = e28;
          }
          assertNoMembers() {
            if (this.members.length)
              throw new Error(`Illegal state: symbol without members expected, but got ${JSON.stringify(this)}.`);
          }
        };
        u3.StaticSymbol = l3;
        var t3 = class {
          constructor() {
            this.cache = /* @__PURE__ */ new Map();
          }
          get(s3, a3, e28) {
            e28 = e28 || [];
            let n3 = e28.length ? `.${e28.join(".")}` : "", r3 = `"${s3}".${a3}${n3}`, o3 = this.cache.get(r3);
            return o3 || (o3 = new l3(s3, a3, e28), this.cache.set(r3, o3)), o3;
          }
        };
        u3.StaticSymbolCache = t3;
      } }), wo2 = X3({ "node_modules/angular-html-parser/lib/compiler/src/util.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = /-+([a-z0-9])/g;
        function t3(i) {
          return i.replace(l3, function() {
            for (var g3 = arguments.length, E3 = new Array(g3), x3 = 0; x3 < g3; x3++)
              E3[x3] = arguments[x3];
            return E3[1].toUpperCase();
          });
        }
        u3.dashCaseToCamelCase = t3;
        function s3(i, g3) {
          return e28(i, ":", g3);
        }
        u3.splitAtColon = s3;
        function a3(i, g3) {
          return e28(i, ".", g3);
        }
        u3.splitAtPeriod = a3;
        function e28(i, g3, E3) {
          let x3 = i.indexOf(g3);
          return x3 == -1 ? E3 : [i.slice(0, x3).trim(), i.slice(x3 + 1).trim()];
        }
        function n3(i, g3, E3) {
          return Array.isArray(i) ? g3.visitArray(i, E3) : A3(i) ? g3.visitStringMap(i, E3) : i == null || typeof i == "string" || typeof i == "number" || typeof i == "boolean" ? g3.visitPrimitive(i, E3) : g3.visitOther(i, E3);
        }
        u3.visitValue = n3;
        function r3(i) {
          return i != null;
        }
        u3.isDefined = r3;
        function o3(i) {
          return i === void 0 ? null : i;
        }
        u3.noUndefined = o3;
        var c3 = class {
          visitArray(i, g3) {
            return i.map((E3) => n3(E3, this, g3));
          }
          visitStringMap(i, g3) {
            let E3 = {};
            return Object.keys(i).forEach((x3) => {
              E3[x3] = n3(i[x3], this, g3);
            }), E3;
          }
          visitPrimitive(i, g3) {
            return i;
          }
          visitOther(i, g3) {
            return i;
          }
        };
        u3.ValueTransformer = c3, u3.SyncAsync = { assertSync: (i) => {
          if (k3(i))
            throw new Error("Illegal state: value cannot be a promise");
          return i;
        }, then: (i, g3) => k3(i) ? i.then(g3) : g3(i), all: (i) => i.some(k3) ? Promise.all(i) : i };
        function h3(i) {
          throw new Error(`Internal Error: ${i}`);
        }
        u3.error = h3;
        function m3(i, g3) {
          let E3 = Error(i);
          return E3[y3] = true, g3 && (E3[p3] = g3), E3;
        }
        u3.syntaxError = m3;
        var y3 = "ngSyntaxError", p3 = "ngParseErrors";
        function d3(i) {
          return i[y3];
        }
        u3.isSyntaxError = d3;
        function C3(i) {
          return i[p3] || [];
        }
        u3.getParseErrors = C3;
        function w3(i) {
          return i.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
        }
        u3.escapeRegExp = w3;
        var P3 = Object.getPrototypeOf({});
        function A3(i) {
          return typeof i == "object" && i !== null && Object.getPrototypeOf(i) === P3;
        }
        function N3(i) {
          let g3 = "";
          for (let E3 = 0; E3 < i.length; E3++) {
            let x3 = i.charCodeAt(E3);
            if (x3 >= 55296 && x3 <= 56319 && i.length > E3 + 1) {
              let b3 = i.charCodeAt(E3 + 1);
              b3 >= 56320 && b3 <= 57343 && (E3++, x3 = (x3 - 55296 << 10) + b3 - 56320 + 65536);
            }
            x3 <= 127 ? g3 += String.fromCharCode(x3) : x3 <= 2047 ? g3 += String.fromCharCode(x3 >> 6 & 31 | 192, x3 & 63 | 128) : x3 <= 65535 ? g3 += String.fromCharCode(x3 >> 12 | 224, x3 >> 6 & 63 | 128, x3 & 63 | 128) : x3 <= 2097151 && (g3 += String.fromCharCode(x3 >> 18 & 7 | 240, x3 >> 12 & 63 | 128, x3 >> 6 & 63 | 128, x3 & 63 | 128));
          }
          return g3;
        }
        u3.utf8Encode = N3;
        function S3(i) {
          if (typeof i == "string")
            return i;
          if (i instanceof Array)
            return "[" + i.map(S3).join(", ") + "]";
          if (i == null)
            return "" + i;
          if (i.overriddenName)
            return `${i.overriddenName}`;
          if (i.name)
            return `${i.name}`;
          if (!i.toString)
            return "object";
          let g3 = i.toString();
          if (g3 == null)
            return "" + g3;
          let E3 = g3.indexOf(`
`);
          return E3 === -1 ? g3 : g3.substring(0, E3);
        }
        u3.stringify = S3;
        function j3(i) {
          return typeof i == "function" && i.hasOwnProperty("__forward_ref__") ? i() : i;
        }
        u3.resolveForwardRef = j3;
        function k3(i) {
          return !!i && typeof i.then == "function";
        }
        u3.isPromise = k3;
        var J3 = class {
          constructor(i) {
            this.full = i;
            let g3 = i.split(".");
            this.major = g3[0], this.minor = g3[1], this.patch = g3.slice(2).join(".");
          }
        };
        u3.Version = J3;
        var f3 = typeof window < "u" && window, T3 = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, D3 = typeof globalThis < "u" && globalThis, F3 = D3 || f3 || T3;
        u3.global = F3;
      } }), No2 = X3({ "node_modules/angular-html-parser/lib/compiler/src/compile_metadata.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = Bo2(), t3 = wo2(), s3 = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
        function a3(E3) {
          return E3.replace(/\W/g, "_");
        }
        u3.sanitizeIdentifier = a3;
        var e28 = 0;
        function n3(E3) {
          if (!E3 || !E3.reference)
            return null;
          let x3 = E3.reference;
          if (x3 instanceof l3.StaticSymbol)
            return x3.name;
          if (x3.__anonymousType)
            return x3.__anonymousType;
          let b3 = t3.stringify(x3);
          return b3.indexOf("(") >= 0 ? (b3 = `anonymous_${e28++}`, x3.__anonymousType = b3) : b3 = a3(b3), b3;
        }
        u3.identifierName = n3;
        function r3(E3) {
          let x3 = E3.reference;
          return x3 instanceof l3.StaticSymbol ? x3.filePath : `./${t3.stringify(x3)}`;
        }
        u3.identifierModuleUrl = r3;
        function o3(E3, x3) {
          return `View_${n3({ reference: E3 })}_${x3}`;
        }
        u3.viewClassName = o3;
        function c3(E3) {
          return `RenderType_${n3({ reference: E3 })}`;
        }
        u3.rendererTypeName = c3;
        function h3(E3) {
          return `HostView_${n3({ reference: E3 })}`;
        }
        u3.hostViewClassName = h3;
        function m3(E3) {
          return `${n3({ reference: E3 })}NgFactory`;
        }
        u3.componentFactoryName = m3;
        var y3;
        (function(E3) {
          E3[E3.Pipe = 0] = "Pipe", E3[E3.Directive = 1] = "Directive", E3[E3.NgModule = 2] = "NgModule", E3[E3.Injectable = 3] = "Injectable";
        })(y3 = u3.CompileSummaryKind || (u3.CompileSummaryKind = {}));
        function p3(E3) {
          return E3.value != null ? a3(E3.value) : n3(E3.identifier);
        }
        u3.tokenName = p3;
        function d3(E3) {
          return E3.identifier != null ? E3.identifier.reference : E3.value;
        }
        u3.tokenReference = d3;
        var C3 = class {
          constructor() {
            let { moduleUrl: E3, styles: x3, styleUrls: b3 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            this.moduleUrl = E3 || null, this.styles = k3(x3), this.styleUrls = k3(b3);
          }
        };
        u3.CompileStylesheetMetadata = C3;
        var w3 = class {
          constructor(E3) {
            let { encapsulation: x3, template: b3, templateUrl: B3, htmlAst: I3, styles: M3, styleUrls: V10, externalStylesheets: $3, animations: U3, ngContentSelectors: L3, interpolation: ee2, isInline: R3, preserveWhitespaces: O3 } = E3;
            if (this.encapsulation = x3, this.template = b3, this.templateUrl = B3, this.htmlAst = I3, this.styles = k3(M3), this.styleUrls = k3(V10), this.externalStylesheets = k3($3), this.animations = U3 ? f3(U3) : [], this.ngContentSelectors = L3 || [], ee2 && ee2.length != 2)
              throw new Error("'interpolation' should have a start and an end symbol.");
            this.interpolation = ee2, this.isInline = R3, this.preserveWhitespaces = O3;
          }
          toSummary() {
            return { ngContentSelectors: this.ngContentSelectors, encapsulation: this.encapsulation, styles: this.styles, animations: this.animations };
          }
        };
        u3.CompileTemplateMetadata = w3;
        var P3 = class {
          static create(E3) {
            let { isHost: x3, type: b3, isComponent: B3, selector: I3, exportAs: M3, changeDetection: V10, inputs: $3, outputs: U3, host: L3, providers: ee2, viewProviders: R3, queries: O3, guards: Z3, viewQueries: ie2, entryComponents: te2, template: ge2, componentViewType: q3, rendererType: z3, componentFactory: De2 } = E3, fe2 = {}, we2 = {}, Q3 = {};
            L3 != null && Object.keys(L3).forEach((re2) => {
              let he2 = L3[re2], Fe2 = re2.match(s3);
              Fe2 === null ? Q3[re2] = he2 : Fe2[1] != null ? we2[Fe2[1]] = he2 : Fe2[2] != null && (fe2[Fe2[2]] = he2);
            });
            let W3 = {};
            $3 != null && $3.forEach((re2) => {
              let he2 = t3.splitAtColon(re2, [re2, re2]);
              W3[he2[0]] = he2[1];
            });
            let ne2 = {};
            return U3 != null && U3.forEach((re2) => {
              let he2 = t3.splitAtColon(re2, [re2, re2]);
              ne2[he2[0]] = he2[1];
            }), new P3({ isHost: x3, type: b3, isComponent: !!B3, selector: I3, exportAs: M3, changeDetection: V10, inputs: W3, outputs: ne2, hostListeners: fe2, hostProperties: we2, hostAttributes: Q3, providers: ee2, viewProviders: R3, queries: O3, guards: Z3, viewQueries: ie2, entryComponents: te2, template: ge2, componentViewType: q3, rendererType: z3, componentFactory: De2 });
          }
          constructor(E3) {
            let { isHost: x3, type: b3, isComponent: B3, selector: I3, exportAs: M3, changeDetection: V10, inputs: $3, outputs: U3, hostListeners: L3, hostProperties: ee2, hostAttributes: R3, providers: O3, viewProviders: Z3, queries: ie2, guards: te2, viewQueries: ge2, entryComponents: q3, template: z3, componentViewType: De2, rendererType: fe2, componentFactory: we2 } = E3;
            this.isHost = !!x3, this.type = b3, this.isComponent = B3, this.selector = I3, this.exportAs = M3, this.changeDetection = V10, this.inputs = $3, this.outputs = U3, this.hostListeners = L3, this.hostProperties = ee2, this.hostAttributes = R3, this.providers = k3(O3), this.viewProviders = k3(Z3), this.queries = k3(ie2), this.guards = te2, this.viewQueries = k3(ge2), this.entryComponents = k3(q3), this.template = z3, this.componentViewType = De2, this.rendererType = fe2, this.componentFactory = we2;
          }
          toSummary() {
            return { summaryKind: y3.Directive, type: this.type, isComponent: this.isComponent, selector: this.selector, exportAs: this.exportAs, inputs: this.inputs, outputs: this.outputs, hostListeners: this.hostListeners, hostProperties: this.hostProperties, hostAttributes: this.hostAttributes, providers: this.providers, viewProviders: this.viewProviders, queries: this.queries, guards: this.guards, viewQueries: this.viewQueries, entryComponents: this.entryComponents, changeDetection: this.changeDetection, template: this.template && this.template.toSummary(), componentViewType: this.componentViewType, rendererType: this.rendererType, componentFactory: this.componentFactory };
          }
        };
        u3.CompileDirectiveMetadata = P3;
        var A3 = class {
          constructor(E3) {
            let { type: x3, name: b3, pure: B3 } = E3;
            this.type = x3, this.name = b3, this.pure = !!B3;
          }
          toSummary() {
            return { summaryKind: y3.Pipe, type: this.type, name: this.name, pure: this.pure };
          }
        };
        u3.CompilePipeMetadata = A3;
        var N3 = class {
        };
        u3.CompileShallowModuleMetadata = N3;
        var S3 = class {
          constructor(E3) {
            let { type: x3, providers: b3, declaredDirectives: B3, exportedDirectives: I3, declaredPipes: M3, exportedPipes: V10, entryComponents: $3, bootstrapComponents: U3, importedModules: L3, exportedModules: ee2, schemas: R3, transitiveModule: O3, id: Z3 } = E3;
            this.type = x3 || null, this.declaredDirectives = k3(B3), this.exportedDirectives = k3(I3), this.declaredPipes = k3(M3), this.exportedPipes = k3(V10), this.providers = k3(b3), this.entryComponents = k3($3), this.bootstrapComponents = k3(U3), this.importedModules = k3(L3), this.exportedModules = k3(ee2), this.schemas = k3(R3), this.id = Z3 || null, this.transitiveModule = O3 || null;
          }
          toSummary() {
            let E3 = this.transitiveModule;
            return { summaryKind: y3.NgModule, type: this.type, entryComponents: E3.entryComponents, providers: E3.providers, modules: E3.modules, exportedDirectives: E3.exportedDirectives, exportedPipes: E3.exportedPipes };
          }
        };
        u3.CompileNgModuleMetadata = S3;
        var j3 = class {
          constructor() {
            this.directivesSet = /* @__PURE__ */ new Set(), this.directives = [], this.exportedDirectivesSet = /* @__PURE__ */ new Set(), this.exportedDirectives = [], this.pipesSet = /* @__PURE__ */ new Set(), this.pipes = [], this.exportedPipesSet = /* @__PURE__ */ new Set(), this.exportedPipes = [], this.modulesSet = /* @__PURE__ */ new Set(), this.modules = [], this.entryComponentsSet = /* @__PURE__ */ new Set(), this.entryComponents = [], this.providers = [];
          }
          addProvider(E3, x3) {
            this.providers.push({ provider: E3, module: x3 });
          }
          addDirective(E3) {
            this.directivesSet.has(E3.reference) || (this.directivesSet.add(E3.reference), this.directives.push(E3));
          }
          addExportedDirective(E3) {
            this.exportedDirectivesSet.has(E3.reference) || (this.exportedDirectivesSet.add(E3.reference), this.exportedDirectives.push(E3));
          }
          addPipe(E3) {
            this.pipesSet.has(E3.reference) || (this.pipesSet.add(E3.reference), this.pipes.push(E3));
          }
          addExportedPipe(E3) {
            this.exportedPipesSet.has(E3.reference) || (this.exportedPipesSet.add(E3.reference), this.exportedPipes.push(E3));
          }
          addModule(E3) {
            this.modulesSet.has(E3.reference) || (this.modulesSet.add(E3.reference), this.modules.push(E3));
          }
          addEntryComponent(E3) {
            this.entryComponentsSet.has(E3.componentType) || (this.entryComponentsSet.add(E3.componentType), this.entryComponents.push(E3));
          }
        };
        u3.TransitiveCompileNgModuleMetadata = j3;
        function k3(E3) {
          return E3 || [];
        }
        var J3 = class {
          constructor(E3, x3) {
            let { useClass: b3, useValue: B3, useExisting: I3, useFactory: M3, deps: V10, multi: $3 } = x3;
            this.token = E3, this.useClass = b3 || null, this.useValue = B3, this.useExisting = I3, this.useFactory = M3 || null, this.dependencies = V10 || null, this.multi = !!$3;
          }
        };
        u3.ProviderMeta = J3;
        function f3(E3) {
          return E3.reduce((x3, b3) => {
            let B3 = Array.isArray(b3) ? f3(b3) : b3;
            return x3.concat(B3);
          }, []);
        }
        u3.flatten = f3;
        function T3(E3) {
          return E3.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, "ng:///");
        }
        function D3(E3, x3, b3) {
          let B3;
          return b3.isInline ? x3.type.reference instanceof l3.StaticSymbol ? B3 = `${x3.type.reference.filePath}.${x3.type.reference.name}.html` : B3 = `${n3(E3)}/${n3(x3.type)}.html` : B3 = b3.templateUrl, x3.type.reference instanceof l3.StaticSymbol ? B3 : T3(B3);
        }
        u3.templateSourceUrl = D3;
        function F3(E3, x3) {
          let b3 = E3.moduleUrl.split(/\/\\/g), B3 = b3[b3.length - 1];
          return T3(`css/${x3}${B3}.ngstyle.js`);
        }
        u3.sharedStylesheetJitUrl = F3;
        function i(E3) {
          return T3(`${n3(E3.type)}/module.ngfactory.js`);
        }
        u3.ngModuleJitUrl = i;
        function g3(E3, x3) {
          return T3(`${n3(E3)}/${n3(x3.type)}.ngfactory.js`);
        }
        u3.templateJitUrl = g3;
      } }), ko2 = X3({ "node_modules/angular-html-parser/lib/compiler/src/parse_util.js"(u3) {
        H3(), Object.defineProperty(u3, "__esModule", { value: true });
        var l3 = To2(), t3 = No2(), s3 = class {
          constructor(h3, m3, y3, p3) {
            this.file = h3, this.offset = m3, this.line = y3, this.col = p3;
          }
          toString() {
            return this.offset != null ? `${this.file.url}@${this.line}:${this.col}` : this.file.url;
          }
          moveBy(h3) {
            let m3 = this.file.content, y3 = m3.length, p3 = this.offset, d3 = this.line, C3 = this.col;
            for (; p3 > 0 && h3 < 0; )
              if (p3--, h3++, m3.charCodeAt(p3) == l3.$LF) {
                d3--;
                let w3 = m3.substr(0, p3 - 1).lastIndexOf(String.fromCharCode(l3.$LF));
                C3 = w3 > 0 ? p3 - w3 : p3;
              } else
                C3--;
            for (; p3 < y3 && h3 > 0; ) {
              let w3 = m3.charCodeAt(p3);
              p3++, h3--, w3 == l3.$LF ? (d3++, C3 = 0) : C3++;
            }
            return new s3(this.file, p3, d3, C3);
          }
          getContext(h3, m3) {
            let y3 = this.file.content, p3 = this.offset;
            if (p3 != null) {
              p3 > y3.length - 1 && (p3 = y3.length - 1);
              let d3 = p3, C3 = 0, w3 = 0;
              for (; C3 < h3 && p3 > 0 && (p3--, C3++, !(y3[p3] == `
` && ++w3 == m3)); )
                ;
              for (C3 = 0, w3 = 0; C3 < h3 && d3 < y3.length - 1 && (d3++, C3++, !(y3[d3] == `
` && ++w3 == m3)); )
                ;
              return { before: y3.substring(p3, this.offset), after: y3.substring(this.offset, d3 + 1) };
            }
            return null;
          }
        };
        u3.ParseLocation = s3;
        var a3 = class {
          constructor(h3, m3) {
            this.content = h3, this.url = m3;
          }
        };
        u3.ParseSourceFile = a3;
        var e28 = class {
          constructor(h3, m3) {
            let y3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            this.start = h3, this.end = m3, this.details = y3;
          }
          toString() {
            return this.start.file.content.substring(this.start.offset, this.end.offset);
          }
        };
        u3.ParseSourceSpan = e28, u3.EMPTY_PARSE_LOCATION = new s3(new a3("", ""), 0, 0, 0), u3.EMPTY_SOURCE_SPAN = new e28(u3.EMPTY_PARSE_LOCATION, u3.EMPTY_PARSE_LOCATION);
        var n3;
        (function(h3) {
          h3[h3.WARNING = 0] = "WARNING", h3[h3.ERROR = 1] = "ERROR";
        })(n3 = u3.ParseErrorLevel || (u3.ParseErrorLevel = {}));
        var r3 = class {
          constructor(h3, m3) {
            let y3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : n3.ERROR;
            this.span = h3, this.msg = m3, this.level = y3;
          }
          contextualMessage() {
            let h3 = this.span.start.getContext(100, 3);
            return h3 ? `${this.msg} ("${h3.before}[${n3[this.level]} ->]${h3.after}")` : this.msg;
          }
          toString() {
            let h3 = this.span.details ? `, ${this.span.details}` : "";
            return `${this.contextualMessage()}: ${this.span.start}${h3}`;
          }
        };
        u3.ParseError = r3;
        function o3(h3, m3) {
          let y3 = t3.identifierModuleUrl(m3), p3 = y3 != null ? `in ${h3} ${t3.identifierName(m3)} in ${y3}` : `in ${h3} ${t3.identifierName(m3)}`, d3 = new a3("", p3);
          return new e28(new s3(d3, -1, -1, -1), new s3(d3, -1, -1, -1));
        }
        u3.typeSourceSpan = o3;
        function c3(h3, m3, y3) {
          let p3 = `in ${h3} ${m3} in ${y3}`, d3 = new a3("", p3);
          return new e28(new s3(d3, -1, -1, -1), new s3(d3, -1, -1, -1));
        }
        u3.r3JitTypeSourceSpan = c3;
      } }), Po2 = X3({ "src/language-html/print-preprocess.js"(u3, l3) {
        H3();
        var { ParseSourceSpan: t3 } = ko2(), { htmlTrim: s3, getLeadingAndTrailingHtmlWhitespace: a3, hasHtmlWhitespace: e28, canHaveInterpolation: n3, getNodeCssStyleDisplay: r3, isDanglingSpaceSensitiveNode: o3, isIndentationSensitiveNode: c3, isLeadingSpaceSensitiveNode: h3, isTrailingSpaceSensitiveNode: m3, isWhitespaceSensitiveNode: y3, isVueScriptTag: p3 } = tn2(), d3 = [w3, P3, N3, j3, k3, T3, J3, f3, D3, S3, F3];
        function C3(i, g3) {
          for (let E3 of d3)
            E3(i, g3);
          return i;
        }
        function w3(i) {
          i.walk((g3) => {
            if (g3.type === "element" && g3.tagDefinition.ignoreFirstLf && g3.children.length > 0 && g3.children[0].type === "text" && g3.children[0].value[0] === `
`) {
              let E3 = g3.children[0];
              E3.value.length === 1 ? g3.removeChild(E3) : E3.value = E3.value.slice(1);
            }
          });
        }
        function P3(i) {
          let g3 = (E3) => E3.type === "element" && E3.prev && E3.prev.type === "ieConditionalStartComment" && E3.prev.sourceSpan.end.offset === E3.startSourceSpan.start.offset && E3.firstChild && E3.firstChild.type === "ieConditionalEndComment" && E3.firstChild.sourceSpan.start.offset === E3.startSourceSpan.end.offset;
          i.walk((E3) => {
            if (E3.children)
              for (let x3 = 0; x3 < E3.children.length; x3++) {
                let b3 = E3.children[x3];
                if (!g3(b3))
                  continue;
                let B3 = b3.prev, I3 = b3.firstChild;
                E3.removeChild(B3), x3--;
                let M3 = new t3(B3.sourceSpan.start, I3.sourceSpan.end), V10 = new t3(M3.start, b3.sourceSpan.end);
                b3.condition = B3.condition, b3.sourceSpan = V10, b3.startSourceSpan = M3, b3.removeChild(I3);
              }
          });
        }
        function A3(i, g3, E3) {
          i.walk((x3) => {
            if (x3.children)
              for (let b3 = 0; b3 < x3.children.length; b3++) {
                let B3 = x3.children[b3];
                if (B3.type !== "text" && !g3(B3))
                  continue;
                B3.type !== "text" && (B3.type = "text", B3.value = E3(B3));
                let I3 = B3.prev;
                !I3 || I3.type !== "text" || (I3.value += B3.value, I3.sourceSpan = new t3(I3.sourceSpan.start, B3.sourceSpan.end), x3.removeChild(B3), b3--);
              }
          });
        }
        function N3(i) {
          return A3(i, (g3) => g3.type === "cdata", (g3) => `<![CDATA[${g3.value}]]>`);
        }
        function S3(i) {
          let g3 = (E3) => E3.type === "element" && E3.attrs.length === 0 && E3.children.length === 1 && E3.firstChild.type === "text" && !e28(E3.children[0].value) && !E3.firstChild.hasLeadingSpaces && !E3.firstChild.hasTrailingSpaces && E3.isLeadingSpaceSensitive && !E3.hasLeadingSpaces && E3.isTrailingSpaceSensitive && !E3.hasTrailingSpaces && E3.prev && E3.prev.type === "text" && E3.next && E3.next.type === "text";
          i.walk((E3) => {
            if (E3.children)
              for (let x3 = 0; x3 < E3.children.length; x3++) {
                let b3 = E3.children[x3];
                if (!g3(b3))
                  continue;
                let B3 = b3.prev, I3 = b3.next;
                B3.value += `<${b3.rawName}>` + b3.firstChild.value + `</${b3.rawName}>` + I3.value, B3.sourceSpan = new t3(B3.sourceSpan.start, I3.sourceSpan.end), B3.isTrailingSpaceSensitive = I3.isTrailingSpaceSensitive, B3.hasTrailingSpaces = I3.hasTrailingSpaces, E3.removeChild(b3), x3--, E3.removeChild(I3);
              }
          });
        }
        function j3(i, g3) {
          if (g3.parser === "html")
            return;
          let E3 = /{{(.+?)}}/s;
          i.walk((x3) => {
            if (n3(x3))
              for (let b3 of x3.children) {
                if (b3.type !== "text")
                  continue;
                let B3 = b3.sourceSpan.start, I3 = null, M3 = b3.value.split(E3);
                for (let V10 = 0; V10 < M3.length; V10++, B3 = I3) {
                  let $3 = M3[V10];
                  if (V10 % 2 === 0) {
                    I3 = B3.moveBy($3.length), $3.length > 0 && x3.insertChildBefore(b3, { type: "text", value: $3, sourceSpan: new t3(B3, I3) });
                    continue;
                  }
                  I3 = B3.moveBy($3.length + 4), x3.insertChildBefore(b3, { type: "interpolation", sourceSpan: new t3(B3, I3), children: $3.length === 0 ? [] : [{ type: "text", value: $3, sourceSpan: new t3(B3.moveBy(2), I3.moveBy(-2)) }] });
                }
                x3.removeChild(b3);
              }
          });
        }
        function k3(i) {
          i.walk((g3) => {
            if (!g3.children)
              return;
            if (g3.children.length === 0 || g3.children.length === 1 && g3.children[0].type === "text" && s3(g3.children[0].value).length === 0) {
              g3.hasDanglingSpaces = g3.children.length > 0, g3.children = [];
              return;
            }
            let E3 = y3(g3), x3 = c3(g3);
            if (!E3)
              for (let b3 = 0; b3 < g3.children.length; b3++) {
                let B3 = g3.children[b3];
                if (B3.type !== "text")
                  continue;
                let { leadingWhitespace: I3, text: M3, trailingWhitespace: V10 } = a3(B3.value), $3 = B3.prev, U3 = B3.next;
                M3 ? (B3.value = M3, B3.sourceSpan = new t3(B3.sourceSpan.start.moveBy(I3.length), B3.sourceSpan.end.moveBy(-V10.length)), I3 && ($3 && ($3.hasTrailingSpaces = true), B3.hasLeadingSpaces = true), V10 && (B3.hasTrailingSpaces = true, U3 && (U3.hasLeadingSpaces = true))) : (g3.removeChild(B3), b3--, (I3 || V10) && ($3 && ($3.hasTrailingSpaces = true), U3 && (U3.hasLeadingSpaces = true)));
              }
            g3.isWhitespaceSensitive = E3, g3.isIndentationSensitive = x3;
          });
        }
        function J3(i) {
          i.walk((g3) => {
            g3.isSelfClosing = !g3.children || g3.type === "element" && (g3.tagDefinition.isVoid || g3.startSourceSpan === g3.endSourceSpan);
          });
        }
        function f3(i, g3) {
          i.walk((E3) => {
            E3.type === "element" && (E3.hasHtmComponentClosingTag = E3.endSourceSpan && /^<\s*\/\s*\/\s*>$/.test(g3.originalText.slice(E3.endSourceSpan.start.offset, E3.endSourceSpan.end.offset)));
          });
        }
        function T3(i, g3) {
          i.walk((E3) => {
            E3.cssDisplay = r3(E3, g3);
          });
        }
        function D3(i, g3) {
          i.walk((E3) => {
            let { children: x3 } = E3;
            if (x3) {
              if (x3.length === 0) {
                E3.isDanglingSpaceSensitive = o3(E3);
                return;
              }
              for (let b3 of x3)
                b3.isLeadingSpaceSensitive = h3(b3, g3), b3.isTrailingSpaceSensitive = m3(b3, g3);
              for (let b3 = 0; b3 < x3.length; b3++) {
                let B3 = x3[b3];
                B3.isLeadingSpaceSensitive = (b3 === 0 || B3.prev.isTrailingSpaceSensitive) && B3.isLeadingSpaceSensitive, B3.isTrailingSpaceSensitive = (b3 === x3.length - 1 || B3.next.isLeadingSpaceSensitive) && B3.isTrailingSpaceSensitive;
              }
            }
          });
        }
        function F3(i, g3) {
          if (g3.parser === "vue") {
            let E3 = i.children.find((b3) => p3(b3, g3));
            if (!E3)
              return;
            let { lang: x3 } = E3.attrMap;
            (x3 === "ts" || x3 === "typescript") && (g3.__should_parse_vue_template_with_ts = true);
          }
        }
        l3.exports = C3;
      } }), jo2 = X3({ "src/language-html/pragma.js"(u3, l3) {
        H3();
        function t3(a3) {
          return /^\s*<!--\s*@(?:format|prettier)\s*-->/.test(a3);
        }
        function s3(a3) {
          return `<!-- @format -->

` + a3.replace(/^\s*\n/, "");
        }
        l3.exports = { hasPragma: t3, insertPragma: s3 };
      } }), mr2 = X3({ "src/language-html/loc.js"(u3, l3) {
        H3();
        function t3(a3) {
          return a3.sourceSpan.start.offset;
        }
        function s3(a3) {
          return a3.sourceSpan.end.offset;
        }
        l3.exports = { locStart: t3, locEnd: s3 };
      } }), mn2 = X3({ "src/language-html/print/tag.js"(u3, l3) {
        H3();
        var t3 = pn2(), { isNonEmptyArray: s3 } = at2(), { builders: { indent: a3, join: e28, line: n3, softline: r3, hardline: o3 }, utils: { replaceTextEndOfLine: c3 } } = Qe2(), { locStart: h3, locEnd: m3 } = mr2(), { isTextLikeNode: y3, getLastDescendant: p3, isPreLikeNode: d3, hasPrettierIgnore: C3, shouldPreserveContent: w3, isVueSfcBlock: P3 } = tn2();
        function A3(L3, ee2) {
          return [L3.isSelfClosing ? "" : N3(L3, ee2), S3(L3, ee2)];
        }
        function N3(L3, ee2) {
          return L3.lastChild && i(L3.lastChild) ? "" : [j3(L3, ee2), J3(L3, ee2)];
        }
        function S3(L3, ee2) {
          return (L3.next ? D3(L3.next) : F3(L3.parent)) ? "" : [f3(L3, ee2), k3(L3, ee2)];
        }
        function j3(L3, ee2) {
          return F3(L3) ? f3(L3.lastChild, ee2) : "";
        }
        function k3(L3, ee2) {
          return i(L3) ? J3(L3.parent, ee2) : g3(L3) ? $3(L3.next) : "";
        }
        function J3(L3, ee2) {
          if (t3(!L3.isSelfClosing), T3(L3, ee2))
            return "";
          switch (L3.type) {
            case "ieConditionalComment":
              return "<!";
            case "element":
              if (L3.hasHtmComponentClosingTag)
                return "<//";
            default:
              return `</${L3.rawName}`;
          }
        }
        function f3(L3, ee2) {
          if (T3(L3, ee2))
            return "";
          switch (L3.type) {
            case "ieConditionalComment":
            case "ieConditionalEndComment":
              return "[endif]-->";
            case "ieConditionalStartComment":
              return "]><!-->";
            case "interpolation":
              return "}}";
            case "element":
              if (L3.isSelfClosing)
                return "/>";
            default:
              return ">";
          }
        }
        function T3(L3, ee2) {
          return !L3.isSelfClosing && !L3.endSourceSpan && (C3(L3) || w3(L3.parent, ee2));
        }
        function D3(L3) {
          return L3.prev && L3.prev.type !== "docType" && !y3(L3.prev) && L3.isLeadingSpaceSensitive && !L3.hasLeadingSpaces;
        }
        function F3(L3) {
          return L3.lastChild && L3.lastChild.isTrailingSpaceSensitive && !L3.lastChild.hasTrailingSpaces && !y3(p3(L3.lastChild)) && !d3(L3);
        }
        function i(L3) {
          return !L3.next && !L3.hasTrailingSpaces && L3.isTrailingSpaceSensitive && y3(p3(L3));
        }
        function g3(L3) {
          return L3.next && !y3(L3.next) && y3(L3) && L3.isTrailingSpaceSensitive && !L3.hasTrailingSpaces;
        }
        function E3(L3) {
          let ee2 = L3.trim().match(/^prettier-ignore-attribute(?:\s+(.+))?$/s);
          return ee2 ? ee2[1] ? ee2[1].split(/\s+/) : true : false;
        }
        function x3(L3) {
          return !L3.prev && L3.isLeadingSpaceSensitive && !L3.hasLeadingSpaces;
        }
        function b3(L3, ee2, R3) {
          let O3 = L3.getValue();
          if (!s3(O3.attrs))
            return O3.isSelfClosing ? " " : "";
          let Z3 = O3.prev && O3.prev.type === "comment" && E3(O3.prev.value), ie2 = typeof Z3 == "boolean" ? () => Z3 : Array.isArray(Z3) ? (De2) => Z3.includes(De2.rawName) : () => false, te2 = L3.map((De2) => {
            let fe2 = De2.getValue();
            return ie2(fe2) ? c3(ee2.originalText.slice(h3(fe2), m3(fe2))) : R3();
          }, "attrs"), ge2 = O3.type === "element" && O3.fullName === "script" && O3.attrs.length === 1 && O3.attrs[0].fullName === "src" && O3.children.length === 0, q3 = ee2.singleAttributePerLine && O3.attrs.length > 1 && !P3(O3, ee2) ? o3 : n3, z3 = [a3([ge2 ? " " : n3, e28(q3, te2)])];
          return O3.firstChild && x3(O3.firstChild) || O3.isSelfClosing && F3(O3.parent) || ge2 ? z3.push(O3.isSelfClosing ? " " : "") : z3.push(ee2.bracketSameLine ? O3.isSelfClosing ? " " : "" : O3.isSelfClosing ? n3 : r3), z3;
        }
        function B3(L3) {
          return L3.firstChild && x3(L3.firstChild) ? "" : U3(L3);
        }
        function I3(L3, ee2, R3) {
          let O3 = L3.getValue();
          return [M3(O3, ee2), b3(L3, ee2, R3), O3.isSelfClosing ? "" : B3(O3)];
        }
        function M3(L3, ee2) {
          return L3.prev && g3(L3.prev) ? "" : [V10(L3, ee2), $3(L3)];
        }
        function V10(L3, ee2) {
          return x3(L3) ? U3(L3.parent) : D3(L3) ? f3(L3.prev, ee2) : "";
        }
        function $3(L3) {
          switch (L3.type) {
            case "ieConditionalComment":
            case "ieConditionalStartComment":
              return `<!--[if ${L3.condition}`;
            case "ieConditionalEndComment":
              return "<!--<!";
            case "interpolation":
              return "{{";
            case "docType":
              return "<!DOCTYPE";
            case "element":
              if (L3.condition)
                return `<!--[if ${L3.condition}]><!--><${L3.rawName}`;
            default:
              return `<${L3.rawName}`;
          }
        }
        function U3(L3) {
          switch (t3(!L3.isSelfClosing), L3.type) {
            case "ieConditionalComment":
              return "]>";
            case "element":
              if (L3.condition)
                return "><!--<![endif]-->";
            default:
              return ">";
          }
        }
        l3.exports = { printClosingTag: A3, printClosingTagStart: N3, printClosingTagStartMarker: J3, printClosingTagEndMarker: f3, printClosingTagSuffix: k3, printClosingTagEnd: S3, needsToBorrowLastChildClosingTagEndMarker: F3, needsToBorrowParentClosingTagStartMarker: i, needsToBorrowPrevClosingTagEndMarker: D3, printOpeningTag: I3, printOpeningTagStart: M3, printOpeningTagPrefix: V10, printOpeningTagStartMarker: $3, printOpeningTagEndMarker: U3, needsToBorrowNextOpeningTagStartMarker: g3, needsToBorrowParentOpeningTagEndMarker: x3 };
      } }), Io2 = X3({ "node_modules/parse-srcset/src/parse-srcset.js"(u3, l3) {
        H3(), function(t3, s3) {
          typeof l3 == "object" && l3.exports ? l3.exports = s3() : t3.parseSrcset = s3();
        }(u3, function() {
          return function(t3, s3) {
            var a3 = s3 && s3.logger || console;
            function e28(J3) {
              return J3 === " " || J3 === "	" || J3 === `
` || J3 === "\f" || J3 === "\r";
            }
            function n3(J3) {
              var f3, T3 = J3.exec(t3.substring(N3));
              if (T3)
                return f3 = T3[0], N3 += f3.length, f3;
            }
            for (var r3 = t3.length, o3 = /^[ \t\n\r\u000c]+/, c3 = /^[, \t\n\r\u000c]+/, h3 = /^[^ \t\n\r\u000c]+/, m3 = /[,]+$/, y3 = /^\d+$/, p3 = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, d3, C3, w3, P3, A3, N3 = 0, S3 = []; ; ) {
              if (n3(c3), N3 >= r3)
                return S3;
              d3 = n3(h3), C3 = [], d3.slice(-1) === "," ? (d3 = d3.replace(m3, ""), k3()) : j3();
            }
            function j3() {
              for (n3(o3), w3 = "", P3 = "in descriptor"; ; ) {
                if (A3 = t3.charAt(N3), P3 === "in descriptor")
                  if (e28(A3))
                    w3 && (C3.push(w3), w3 = "", P3 = "after descriptor");
                  else if (A3 === ",") {
                    N3 += 1, w3 && C3.push(w3), k3();
                    return;
                  } else if (A3 === "(")
                    w3 = w3 + A3, P3 = "in parens";
                  else if (A3 === "") {
                    w3 && C3.push(w3), k3();
                    return;
                  } else
                    w3 = w3 + A3;
                else if (P3 === "in parens")
                  if (A3 === ")")
                    w3 = w3 + A3, P3 = "in descriptor";
                  else if (A3 === "") {
                    C3.push(w3), k3();
                    return;
                  } else
                    w3 = w3 + A3;
                else if (P3 === "after descriptor" && !e28(A3))
                  if (A3 === "") {
                    k3();
                    return;
                  } else
                    P3 = "in descriptor", N3 -= 1;
                N3 += 1;
              }
            }
            function k3() {
              var J3 = false, f3, T3, D3, F3, i = {}, g3, E3, x3, b3, B3;
              for (F3 = 0; F3 < C3.length; F3++)
                g3 = C3[F3], E3 = g3[g3.length - 1], x3 = g3.substring(0, g3.length - 1), b3 = parseInt(x3, 10), B3 = parseFloat(x3), y3.test(x3) && E3 === "w" ? ((f3 || T3) && (J3 = true), b3 === 0 ? J3 = true : f3 = b3) : p3.test(x3) && E3 === "x" ? ((f3 || T3 || D3) && (J3 = true), B3 < 0 ? J3 = true : T3 = B3) : y3.test(x3) && E3 === "h" ? ((D3 || T3) && (J3 = true), b3 === 0 ? J3 = true : D3 = b3) : J3 = true;
              J3 ? a3 && a3.error && a3.error("Invalid srcset descriptor found in '" + t3 + "' at '" + g3 + "'.") : (i.url = d3, f3 && (i.w = f3), T3 && (i.d = T3), D3 && (i.h = D3), S3.push(i));
            }
          };
        });
      } }), Lo2 = X3({ "src/language-html/syntax-attribute.js"(u3, l3) {
        H3();
        var t3 = Io2(), { builders: { ifBreak: s3, join: a3, line: e28 } } = Qe2();
        function n3(o3) {
          let c3 = t3(o3, { logger: { error(j3) {
            throw new Error(j3);
          } } }), h3 = c3.some((j3) => {
            let { w: k3 } = j3;
            return k3;
          }), m3 = c3.some((j3) => {
            let { h: k3 } = j3;
            return k3;
          }), y3 = c3.some((j3) => {
            let { d: k3 } = j3;
            return k3;
          });
          if (h3 + m3 + y3 > 1)
            throw new Error("Mixed descriptor in srcset is not supported");
          let p3 = h3 ? "w" : m3 ? "h" : "d", d3 = h3 ? "w" : m3 ? "h" : "x", C3 = (j3) => Math.max(...j3), w3 = c3.map((j3) => j3.url), P3 = C3(w3.map((j3) => j3.length)), A3 = c3.map((j3) => j3[p3]).map((j3) => j3 ? j3.toString() : ""), N3 = A3.map((j3) => {
            let k3 = j3.indexOf(".");
            return k3 === -1 ? j3.length : k3;
          }), S3 = C3(N3);
          return a3([",", e28], w3.map((j3, k3) => {
            let J3 = [j3], f3 = A3[k3];
            if (f3) {
              let T3 = P3 - j3.length + 1, D3 = S3 - N3[k3], F3 = " ".repeat(T3 + D3);
              J3.push(s3(F3, " "), f3 + d3);
            }
            return J3;
          }));
        }
        function r3(o3) {
          return o3.trim().split(/\s+/).join(" ");
        }
        l3.exports = { printImgSrcset: n3, printClassNames: r3 };
      } }), _o2 = X3({ "src/language-html/syntax-vue.js"(u3, l3) {
        H3();
        var { builders: { group: t3 } } = Qe2();
        function s3(r3, o3) {
          let { left: c3, operator: h3, right: m3 } = a3(r3);
          return [t3(o3(`function _(${c3}) {}`, { parser: "babel", __isVueForBindingLeft: true })), " ", h3, " ", o3(m3, { parser: "__js_expression" }, { stripTrailingHardline: true })];
        }
        function a3(r3) {
          let o3 = /(.*?)\s+(in|of)\s+(.*)/s, c3 = /,([^,\]}]*)(?:,([^,\]}]*))?$/, h3 = /^\(|\)$/g, m3 = r3.match(o3);
          if (!m3)
            return;
          let y3 = {};
          if (y3.for = m3[3].trim(), !y3.for)
            return;
          let p3 = m3[1].trim().replace(h3, ""), d3 = p3.match(c3);
          d3 ? (y3.alias = p3.replace(c3, ""), y3.iterator1 = d3[1].trim(), d3[2] && (y3.iterator2 = d3[2].trim())) : y3.alias = p3;
          let C3 = [y3.alias, y3.iterator1, y3.iterator2];
          if (!C3.some((w3, P3) => !w3 && (P3 === 0 || C3.slice(P3 + 1).some(Boolean))))
            return { left: C3.filter(Boolean).join(","), operator: m3[2], right: y3.for };
        }
        function e28(r3, o3) {
          return o3(`function _(${r3}) {}`, { parser: "babel", __isVueBindings: true });
        }
        function n3(r3) {
          let o3 = /^(?:[\w$]+|\([^)]*\))\s*=>|^function\s*\(/, c3 = /^[$A-Z_a-z][\w$]*(?:\.[$A-Z_a-z][\w$]*|\['[^']*']|\["[^"]*"]|\[\d+]|\[[$A-Z_a-z][\w$]*])*$/, h3 = r3.trim();
          return o3.test(h3) || c3.test(h3);
        }
        l3.exports = { isVueEventBindingExpression: n3, printVueFor: s3, printVueBindings: e28 };
      } }), Wu2 = X3({ "src/language-html/get-node-content.js"(u3, l3) {
        H3();
        var { needsToBorrowParentClosingTagStartMarker: t3, printClosingTagStartMarker: s3, needsToBorrowLastChildClosingTagEndMarker: a3, printClosingTagEndMarker: e28, needsToBorrowParentOpeningTagEndMarker: n3, printOpeningTagEndMarker: r3 } = mn2();
        function o3(c3, h3) {
          let m3 = c3.startSourceSpan.end.offset;
          c3.firstChild && n3(c3.firstChild) && (m3 -= r3(c3).length);
          let y3 = c3.endSourceSpan.start.offset;
          return c3.lastChild && t3(c3.lastChild) ? y3 += s3(c3, h3).length : a3(c3) && (y3 -= e28(c3.lastChild, h3).length), h3.originalText.slice(m3, y3);
        }
        l3.exports = o3;
      } }), Oo2 = X3({ "src/language-html/embed.js"(u3, l3) {
        H3();
        var { builders: { breakParent: t3, group: s3, hardline: a3, indent: e28, line: n3, fill: r3, softline: o3 }, utils: { mapDoc: c3, replaceTextEndOfLine: h3 } } = Qe2(), m3 = Dr2(), { printClosingTag: y3, printClosingTagSuffix: p3, needsToBorrowPrevClosingTagEndMarker: d3, printOpeningTagPrefix: C3, printOpeningTag: w3 } = mn2(), { printImgSrcset: P3, printClassNames: A3 } = Lo2(), { printVueFor: N3, printVueBindings: S3, isVueEventBindingExpression: j3 } = _o2(), { isScriptLikeTag: k3, isVueNonHtmlBlock: J3, inferScriptParser: f3, htmlTrimPreserveIndentation: T3, dedentString: D3, unescapeQuoteEntities: F3, isVueSlotAttribute: i, isVueSfcBindingsAttribute: g3, getTextValueParts: E3 } = tn2(), x3 = Wu2();
        function b3(I3, M3, V10) {
          let $3 = (te2) => new RegExp(te2.join("|")).test(I3.fullName), U3 = () => F3(I3.value), L3 = false, ee2 = (te2, ge2) => {
            let q3 = te2.type === "NGRoot" ? te2.node.type === "NGMicrosyntax" && te2.node.body.length === 1 && te2.node.body[0].type === "NGMicrosyntaxExpression" ? te2.node.body[0].expression : te2.node : te2.type === "JsExpressionRoot" ? te2.node : te2;
            q3 && (q3.type === "ObjectExpression" || q3.type === "ArrayExpression" || ge2.parser === "__vue_expression" && (q3.type === "TemplateLiteral" || q3.type === "StringLiteral")) && (L3 = true);
          }, R3 = (te2) => s3(te2), O3 = function(te2) {
            let ge2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            return s3([e28([o3, te2]), ge2 ? o3 : ""]);
          }, Z3 = (te2) => L3 ? R3(te2) : O3(te2), ie2 = (te2, ge2) => M3(te2, Object.assign({ __onHtmlBindingRoot: ee2, __embeddedInHtml: true }, ge2));
          if (I3.fullName === "srcset" && (I3.parent.fullName === "img" || I3.parent.fullName === "source"))
            return O3(P3(U3()));
          if (I3.fullName === "class" && !V10.parentParser) {
            let te2 = U3();
            if (!te2.includes("{{"))
              return A3(te2);
          }
          if (I3.fullName === "style" && !V10.parentParser) {
            let te2 = U3();
            if (!te2.includes("{{"))
              return O3(ie2(te2, { parser: "css", __isHTMLStyleAttribute: true }));
          }
          if (V10.parser === "vue") {
            if (I3.fullName === "v-for")
              return N3(U3(), ie2);
            if (i(I3) || g3(I3, V10))
              return S3(U3(), ie2);
            let te2 = ["^@", "^v-on:"], ge2 = ["^:", "^v-bind:"], q3 = ["^v-"];
            if ($3(te2)) {
              let z3 = U3(), De2 = j3(z3) ? "__js_expression" : V10.__should_parse_vue_template_with_ts ? "__vue_ts_event_binding" : "__vue_event_binding";
              return Z3(ie2(z3, { parser: De2 }));
            }
            if ($3(ge2))
              return Z3(ie2(U3(), { parser: "__vue_expression" }));
            if ($3(q3))
              return Z3(ie2(U3(), { parser: "__js_expression" }));
          }
          if (V10.parser === "angular") {
            let te2 = (Q3, W3) => ie2(Q3, Object.assign(Object.assign({}, W3), {}, { trailingComma: "none" })), ge2 = ["^\\*"], q3 = ["^\\(.+\\)$", "^on-"], z3 = ["^\\[.+\\]$", "^bind(on)?-", "^ng-(if|show|hide|class|style)$"], De2 = ["^i18n(-.+)?$"];
            if ($3(q3))
              return Z3(te2(U3(), { parser: "__ng_action" }));
            if ($3(z3))
              return Z3(te2(U3(), { parser: "__ng_binding" }));
            if ($3(De2)) {
              let Q3 = U3().trim();
              return O3(r3(E3(I3, Q3)), !Q3.includes("@@"));
            }
            if ($3(ge2))
              return Z3(te2(U3(), { parser: "__ng_directive" }));
            let fe2 = /{{(.+?)}}/s, we2 = U3();
            if (fe2.test(we2)) {
              let Q3 = [];
              for (let [W3, ne2] of we2.split(fe2).entries())
                if (W3 % 2 === 0)
                  Q3.push(h3(ne2));
                else
                  try {
                    Q3.push(s3(["{{", e28([n3, te2(ne2, { parser: "__ng_interpolation", __isInHtmlInterpolation: true })]), n3, "}}"]));
                  } catch {
                    Q3.push("{{", h3(ne2), "}}");
                  }
              return s3(Q3);
            }
          }
          return null;
        }
        function B3(I3, M3, V10, $3) {
          let U3 = I3.getValue();
          switch (U3.type) {
            case "element": {
              if (k3(U3) || U3.type === "interpolation")
                return;
              if (!U3.isSelfClosing && J3(U3, $3)) {
                let L3 = f3(U3, $3);
                if (!L3)
                  return;
                let ee2 = x3(U3, $3), R3 = /^\s*$/.test(ee2), O3 = "";
                return R3 || (O3 = V10(T3(ee2), { parser: L3, __embeddedInHtml: true }, { stripTrailingHardline: true }), R3 = O3 === ""), [C3(U3, $3), s3(w3(I3, $3, M3)), R3 ? "" : a3, O3, R3 ? "" : a3, y3(U3, $3), p3(U3, $3)];
              }
              break;
            }
            case "text": {
              if (k3(U3.parent)) {
                let L3 = f3(U3.parent, $3);
                if (L3) {
                  let ee2 = L3 === "markdown" ? D3(U3.value.replace(/^[^\S\n]*\n/, "")) : U3.value, R3 = { parser: L3, __embeddedInHtml: true };
                  if ($3.parser === "html" && L3 === "babel") {
                    let O3 = "script", { attrMap: Z3 } = U3.parent;
                    Z3 && (Z3.type === "module" || Z3.type === "text/babel" && Z3["data-type"] === "module") && (O3 = "module"), R3.__babelSourceType = O3;
                  }
                  return [t3, C3(U3, $3), V10(ee2, R3, { stripTrailingHardline: true }), p3(U3, $3)];
                }
              } else if (U3.parent.type === "interpolation") {
                let L3 = { __isInHtmlInterpolation: true, __embeddedInHtml: true };
                return $3.parser === "angular" ? (L3.parser = "__ng_interpolation", L3.trailingComma = "none") : $3.parser === "vue" ? L3.parser = $3.__should_parse_vue_template_with_ts ? "__vue_ts_expression" : "__vue_expression" : L3.parser = "__js_expression", [e28([n3, V10(U3.value, L3, { stripTrailingHardline: true })]), U3.parent.next && d3(U3.parent.next) ? " " : n3];
              }
              break;
            }
            case "attribute": {
              if (!U3.value)
                break;
              if (/^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test($3.originalText.slice(U3.valueSpan.start.offset, U3.valueSpan.end.offset)))
                return [U3.rawName, "=", U3.value];
              if ($3.parser === "lwc" && /^{.*}$/s.test($3.originalText.slice(U3.valueSpan.start.offset, U3.valueSpan.end.offset)))
                return [U3.rawName, "=", U3.value];
              let L3 = b3(U3, (ee2, R3) => V10(ee2, Object.assign({ __isInHtmlAttribute: true, __embeddedInHtml: true }, R3), { stripTrailingHardline: true }), $3);
              if (L3)
                return [U3.rawName, '="', s3(c3(L3, (ee2) => typeof ee2 == "string" ? ee2.replace(/"/g, "&quot;") : ee2)), '"'];
              break;
            }
            case "front-matter":
              return m3(U3, V10);
          }
        }
        l3.exports = B3;
      } }), Xu2 = X3({ "src/language-html/print/children.js"(u3, l3) {
        H3();
        var { builders: { breakParent: t3, group: s3, ifBreak: a3, line: e28, softline: n3, hardline: r3 }, utils: { replaceTextEndOfLine: o3 } } = Qe2(), { locStart: c3, locEnd: h3 } = mr2(), { forceBreakChildren: m3, forceNextEmptyLine: y3, isTextLikeNode: p3, hasPrettierIgnore: d3, preferHardlineAsLeadingSpaces: C3 } = tn2(), { printOpeningTagPrefix: w3, needsToBorrowNextOpeningTagStartMarker: P3, printOpeningTagStartMarker: A3, needsToBorrowPrevClosingTagEndMarker: N3, printClosingTagEndMarker: S3, printClosingTagSuffix: j3, needsToBorrowParentClosingTagStartMarker: k3 } = mn2();
        function J3(D3, F3, i) {
          let g3 = D3.getValue();
          return d3(g3) ? [w3(g3, F3), ...o3(F3.originalText.slice(c3(g3) + (g3.prev && P3(g3.prev) ? A3(g3).length : 0), h3(g3) - (g3.next && N3(g3.next) ? S3(g3, F3).length : 0))), j3(g3, F3)] : i();
        }
        function f3(D3, F3) {
          return p3(D3) && p3(F3) ? D3.isTrailingSpaceSensitive ? D3.hasTrailingSpaces ? C3(F3) ? r3 : e28 : "" : C3(F3) ? r3 : n3 : P3(D3) && (d3(F3) || F3.firstChild || F3.isSelfClosing || F3.type === "element" && F3.attrs.length > 0) || D3.type === "element" && D3.isSelfClosing && N3(F3) ? "" : !F3.isLeadingSpaceSensitive || C3(F3) || N3(F3) && D3.lastChild && k3(D3.lastChild) && D3.lastChild.lastChild && k3(D3.lastChild.lastChild) ? r3 : F3.hasLeadingSpaces ? e28 : n3;
        }
        function T3(D3, F3, i) {
          let g3 = D3.getValue();
          if (m3(g3))
            return [t3, ...D3.map((x3) => {
              let b3 = x3.getValue(), B3 = b3.prev ? f3(b3.prev, b3) : "";
              return [B3 ? [B3, y3(b3.prev) ? r3 : ""] : "", J3(x3, F3, i)];
            }, "children")];
          let E3 = g3.children.map(() => Symbol(""));
          return D3.map((x3, b3) => {
            let B3 = x3.getValue();
            if (p3(B3)) {
              if (B3.prev && p3(B3.prev)) {
                let ee2 = f3(B3.prev, B3);
                if (ee2)
                  return y3(B3.prev) ? [r3, r3, J3(x3, F3, i)] : [ee2, J3(x3, F3, i)];
              }
              return J3(x3, F3, i);
            }
            let I3 = [], M3 = [], V10 = [], $3 = [], U3 = B3.prev ? f3(B3.prev, B3) : "", L3 = B3.next ? f3(B3, B3.next) : "";
            return U3 && (y3(B3.prev) ? I3.push(r3, r3) : U3 === r3 ? I3.push(r3) : p3(B3.prev) ? M3.push(U3) : M3.push(a3("", n3, { groupId: E3[b3 - 1] }))), L3 && (y3(B3) ? p3(B3.next) && $3.push(r3, r3) : L3 === r3 ? p3(B3.next) && $3.push(r3) : V10.push(L3)), [...I3, s3([...M3, s3([J3(x3, F3, i), ...V10], { id: E3[b3] })]), ...$3];
          }, "children");
        }
        l3.exports = { printChildren: T3 };
      } }), Mo2 = X3({ "src/language-html/print/element.js"(u3, l3) {
        H3();
        var { builders: { breakParent: t3, dedentToRoot: s3, group: a3, ifBreak: e28, indentIfBreak: n3, indent: r3, line: o3, softline: c3 }, utils: { replaceTextEndOfLine: h3 } } = Qe2(), m3 = Wu2(), { shouldPreserveContent: y3, isScriptLikeTag: p3, isVueCustomBlock: d3, countParents: C3, forceBreakContent: w3 } = tn2(), { printOpeningTagPrefix: P3, printOpeningTag: A3, printClosingTagSuffix: N3, printClosingTag: S3, needsToBorrowPrevClosingTagEndMarker: j3, needsToBorrowLastChildClosingTagEndMarker: k3 } = mn2(), { printChildren: J3 } = Xu2();
        function f3(T3, D3, F3) {
          let i = T3.getValue();
          if (y3(i, D3))
            return [P3(i, D3), a3(A3(T3, D3, F3)), ...h3(m3(i, D3)), ...S3(i, D3), N3(i, D3)];
          let g3 = i.children.length === 1 && i.firstChild.type === "interpolation" && i.firstChild.isLeadingSpaceSensitive && !i.firstChild.hasLeadingSpaces && i.lastChild.isTrailingSpaceSensitive && !i.lastChild.hasTrailingSpaces, E3 = Symbol("element-attr-group-id"), x3 = (M3) => a3([a3(A3(T3, D3, F3), { id: E3 }), M3, S3(i, D3)]), b3 = (M3) => g3 ? n3(M3, { groupId: E3 }) : (p3(i) || d3(i, D3)) && i.parent.type === "root" && D3.parser === "vue" && !D3.vueIndentScriptAndStyle ? M3 : r3(M3), B3 = () => g3 ? e28(c3, "", { groupId: E3 }) : i.firstChild.hasLeadingSpaces && i.firstChild.isLeadingSpaceSensitive ? o3 : i.firstChild.type === "text" && i.isWhitespaceSensitive && i.isIndentationSensitive ? s3(c3) : c3, I3 = () => (i.next ? j3(i.next) : k3(i.parent)) ? i.lastChild.hasTrailingSpaces && i.lastChild.isTrailingSpaceSensitive ? " " : "" : g3 ? e28(c3, "", { groupId: E3 }) : i.lastChild.hasTrailingSpaces && i.lastChild.isTrailingSpaceSensitive ? o3 : (i.lastChild.type === "comment" || i.lastChild.type === "text" && i.isWhitespaceSensitive && i.isIndentationSensitive) && new RegExp(`\\n[\\t ]{${D3.tabWidth * C3(T3, (M3) => M3.parent && M3.parent.type !== "root")}}$`).test(i.lastChild.value) ? "" : c3;
          return i.children.length === 0 ? x3(i.hasDanglingSpaces && i.isDanglingSpaceSensitive ? o3 : "") : x3([w3(i) ? t3 : "", b3([B3(), J3(T3, D3, F3)]), I3()]);
        }
        l3.exports = { printElement: f3 };
      } }), $o2 = X3({ "src/language-html/printer-html.js"(u3, l3) {
        H3();
        var { builders: { fill: t3, group: s3, hardline: a3, literalline: e28 }, utils: { cleanDoc: n3, getDocParts: r3, isConcat: o3, replaceTextEndOfLine: c3 } } = Qe2(), h3 = xo2(), { countChars: m3, unescapeQuoteEntities: y3, getTextValueParts: p3 } = tn2(), d3 = Po2(), { insertPragma: C3 } = jo2(), { locStart: w3, locEnd: P3 } = mr2(), A3 = Oo2(), { printClosingTagSuffix: N3, printClosingTagEnd: S3, printOpeningTagPrefix: j3, printOpeningTagStart: k3 } = mn2(), { printElement: J3 } = Mo2(), { printChildren: f3 } = Xu2();
        function T3(D3, F3, i) {
          let g3 = D3.getValue();
          switch (g3.type) {
            case "front-matter":
              return c3(g3.raw);
            case "root":
              return F3.__onHtmlRoot && F3.__onHtmlRoot(g3), [s3(f3(D3, F3, i)), a3];
            case "element":
            case "ieConditionalComment":
              return J3(D3, F3, i);
            case "ieConditionalStartComment":
            case "ieConditionalEndComment":
              return [k3(g3), S3(g3)];
            case "interpolation":
              return [k3(g3, F3), ...D3.map(i, "children"), S3(g3, F3)];
            case "text": {
              if (g3.parent.type === "interpolation") {
                let x3 = /\n[^\S\n]*$/, b3 = x3.test(g3.value), B3 = b3 ? g3.value.replace(x3, "") : g3.value;
                return [...c3(B3), b3 ? a3 : ""];
              }
              let E3 = n3([j3(g3, F3), ...p3(g3), N3(g3, F3)]);
              return o3(E3) || E3.type === "fill" ? t3(r3(E3)) : E3;
            }
            case "docType":
              return [s3([k3(g3, F3), " ", g3.value.replace(/^html\b/i, "html").replace(/\s+/g, " ")]), S3(g3, F3)];
            case "comment":
              return [j3(g3, F3), ...c3(F3.originalText.slice(w3(g3), P3(g3)), e28), N3(g3, F3)];
            case "attribute": {
              if (g3.value === null)
                return g3.rawName;
              let E3 = y3(g3.value), x3 = m3(E3, "'"), b3 = m3(E3, '"'), B3 = x3 < b3 ? "'" : '"';
              return [g3.rawName, "=", B3, ...c3(B3 === '"' ? E3.replace(/"/g, "&quot;") : E3.replace(/'/g, "&apos;")), B3];
            }
            default:
              throw new Error(`Unexpected node type ${g3.type}`);
          }
        }
        l3.exports = { preprocess: d3, print: T3, insertPragma: C3, massageAstNode: h3, embed: A3 };
      } }), Ro2 = X3({ "src/language-html/options.js"(u3, l3) {
        H3();
        var t3 = en2(), s3 = "HTML";
        l3.exports = { bracketSameLine: t3.bracketSameLine, htmlWhitespaceSensitivity: { since: "1.15.0", category: s3, type: "choice", default: "css", description: "How to handle whitespaces in HTML.", choices: [{ value: "css", description: "Respect the default value of CSS display property." }, { value: "strict", description: "Whitespaces are considered sensitive." }, { value: "ignore", description: "Whitespaces are considered insensitive." }] }, singleAttributePerLine: t3.singleAttributePerLine, vueIndentScriptAndStyle: { since: "1.19.0", category: s3, type: "boolean", default: false, description: "Indent script and style tags in Vue files." } };
      } }), Vo2 = X3({ "src/language-html/parsers.js"() {
        H3();
      } }), gr2 = X3({ "node_modules/linguist-languages/data/HTML.json"(u3, l3) {
        l3.exports = { name: "HTML", type: "markup", tmScope: "text.html.basic", aceMode: "html", codemirrorMode: "htmlmixed", codemirrorMimeType: "text/html", color: "#e34c26", aliases: ["xhtml"], extensions: [".html", ".hta", ".htm", ".html.hl", ".inc", ".xht", ".xhtml"], languageId: 146 };
      } }), Jo2 = X3({ "node_modules/linguist-languages/data/Vue.json"(u3, l3) {
        l3.exports = { name: "Vue", type: "markup", color: "#41b883", extensions: [".vue"], tmScope: "text.html.vue", aceMode: "html", languageId: 391 };
      } }), qo2 = X3({ "src/language-html/index.js"(u3, l3) {
        H3();
        var t3 = Gt2(), s3 = $o2(), a3 = Ro2(), e28 = Vo2(), n3 = [t3(gr2(), () => ({ name: "Angular", since: "1.15.0", parsers: ["angular"], vscodeLanguageIds: ["html"], extensions: [".component.html"], filenames: [] })), t3(gr2(), (o3) => ({ since: "1.15.0", parsers: ["html"], vscodeLanguageIds: ["html"], extensions: [...o3.extensions, ".mjml"] })), t3(gr2(), () => ({ name: "Lightning Web Components", since: "1.17.0", parsers: ["lwc"], vscodeLanguageIds: ["html"], extensions: [], filenames: [] })), t3(Jo2(), () => ({ since: "1.10.0", parsers: ["vue"], vscodeLanguageIds: ["vue"] }))], r3 = { html: s3 };
        l3.exports = { languages: n3, printers: r3, options: a3, parsers: e28 };
      } }), Go2 = X3({ "src/language-yaml/pragma.js"(u3, l3) {
        H3();
        function t3(e28) {
          return /^\s*@(?:prettier|format)\s*$/.test(e28);
        }
        function s3(e28) {
          return /^\s*#[^\S\n]*@(?:prettier|format)\s*?(?:\n|$)/.test(e28);
        }
        function a3(e28) {
          return `# @format

${e28}`;
        }
        l3.exports = { isPragma: t3, hasPragma: s3, insertPragma: a3 };
      } }), Wo2 = X3({ "src/language-yaml/loc.js"(u3, l3) {
        H3();
        function t3(a3) {
          return a3.position.start.offset;
        }
        function s3(a3) {
          return a3.position.end.offset;
        }
        l3.exports = { locStart: t3, locEnd: s3 };
      } }), Xo2 = X3({ "src/language-yaml/embed.js"(u3, l3) {
        H3();
        function t3(s3, a3, e28, n3) {
          if (s3.getValue().type === "root" && n3.filepath && /(?:[/\\]|^)\.(?:prettier|stylelint|lintstaged)rc$/.test(n3.filepath))
            return e28(n3.originalText, Object.assign(Object.assign({}, n3), {}, { parser: "json" }));
        }
        l3.exports = t3;
      } }), nn2 = X3({ "src/language-yaml/utils.js"(u3, l3) {
        H3();
        var { getLast: t3, isNonEmptyArray: s3 } = at2();
        function a3(f3, T3) {
          let D3 = 0, F3 = f3.stack.length - 1;
          for (let i = 0; i < F3; i++) {
            let g3 = f3.stack[i];
            e28(g3) && T3(g3) && D3++;
          }
          return D3;
        }
        function e28(f3, T3) {
          return f3 && typeof f3.type == "string" && (!T3 || T3.includes(f3.type));
        }
        function n3(f3, T3, D3) {
          return T3("children" in f3 ? Object.assign(Object.assign({}, f3), {}, { children: f3.children.map((F3) => n3(F3, T3, f3)) }) : f3, D3);
        }
        function r3(f3, T3, D3) {
          Object.defineProperty(f3, T3, { get: D3, enumerable: false });
        }
        function o3(f3, T3) {
          let D3 = 0, F3 = T3.length;
          for (let i = f3.position.end.offset - 1; i < F3; i++) {
            let g3 = T3[i];
            if (g3 === `
` && D3++, D3 === 1 && /\S/.test(g3))
              return false;
            if (D3 === 2)
              return true;
          }
          return false;
        }
        function c3(f3) {
          switch (f3.getValue().type) {
            case "tag":
            case "anchor":
            case "comment":
              return false;
          }
          let T3 = f3.stack.length;
          for (let D3 = 1; D3 < T3; D3++) {
            let F3 = f3.stack[D3], i = f3.stack[D3 - 1];
            if (Array.isArray(i) && typeof F3 == "number" && F3 !== i.length - 1)
              return false;
          }
          return true;
        }
        function h3(f3) {
          return s3(f3.children) ? h3(t3(f3.children)) : f3;
        }
        function m3(f3) {
          return f3.value.trim() === "prettier-ignore";
        }
        function y3(f3) {
          let T3 = f3.getValue();
          if (T3.type === "documentBody") {
            let D3 = f3.getParentNode();
            return N3(D3.head) && m3(t3(D3.head.endComments));
          }
          return C3(T3) && m3(t3(T3.leadingComments));
        }
        function p3(f3) {
          return !s3(f3.children) && !d3(f3);
        }
        function d3(f3) {
          return C3(f3) || w3(f3) || P3(f3) || A3(f3) || N3(f3);
        }
        function C3(f3) {
          return s3(f3 == null ? void 0 : f3.leadingComments);
        }
        function w3(f3) {
          return s3(f3 == null ? void 0 : f3.middleComments);
        }
        function P3(f3) {
          return f3 == null ? void 0 : f3.indicatorComment;
        }
        function A3(f3) {
          return f3 == null ? void 0 : f3.trailingComment;
        }
        function N3(f3) {
          return s3(f3 == null ? void 0 : f3.endComments);
        }
        function S3(f3) {
          let T3 = [], D3;
          for (let F3 of f3.split(/( +)/))
            F3 !== " " ? D3 === " " ? T3.push(F3) : T3.push((T3.pop() || "") + F3) : D3 === void 0 && T3.unshift(""), D3 = F3;
          return D3 === " " && T3.push((T3.pop() || "") + " "), T3[0] === "" && (T3.shift(), T3.unshift(" " + (T3.shift() || ""))), T3;
        }
        function j3(f3, T3, D3) {
          let F3 = T3.split(`
`).map((i, g3, E3) => g3 === 0 && g3 === E3.length - 1 ? i : g3 !== 0 && g3 !== E3.length - 1 ? i.trim() : g3 === 0 ? i.trimEnd() : i.trimStart());
          return D3.proseWrap === "preserve" ? F3.map((i) => i.length === 0 ? [] : [i]) : F3.map((i) => i.length === 0 ? [] : S3(i)).reduce((i, g3, E3) => E3 !== 0 && F3[E3 - 1].length > 0 && g3.length > 0 && !(f3 === "quoteDouble" && t3(t3(i)).endsWith("\\")) ? [...i.slice(0, -1), [...t3(i), ...g3]] : [...i, g3], []).map((i) => D3.proseWrap === "never" ? [i.join(" ")] : i);
        }
        function k3(f3, T3) {
          let { parentIndent: D3, isLastDescendant: F3, options: i } = T3, g3 = f3.position.start.line === f3.position.end.line ? "" : i.originalText.slice(f3.position.start.offset, f3.position.end.offset).match(/^[^\n]*\n(.*)$/s)[1], E3;
          if (f3.indent === null) {
            let B3 = g3.match(/^(?<leadingSpace> *)[^\n\r ]/m);
            E3 = B3 ? B3.groups.leadingSpace.length : Number.POSITIVE_INFINITY;
          } else
            E3 = f3.indent - 1 + D3;
          let x3 = g3.split(`
`).map((B3) => B3.slice(E3));
          if (i.proseWrap === "preserve" || f3.type === "blockLiteral")
            return b3(x3.map((B3) => B3.length === 0 ? [] : [B3]));
          return b3(x3.map((B3) => B3.length === 0 ? [] : S3(B3)).reduce((B3, I3, M3) => M3 !== 0 && x3[M3 - 1].length > 0 && I3.length > 0 && !/^\s/.test(I3[0]) && !/^\s|\s$/.test(t3(B3)) ? [...B3.slice(0, -1), [...t3(B3), ...I3]] : [...B3, I3], []).map((B3) => B3.reduce((I3, M3) => I3.length > 0 && /\s$/.test(t3(I3)) ? [...I3.slice(0, -1), t3(I3) + " " + M3] : [...I3, M3], [])).map((B3) => i.proseWrap === "never" ? [B3.join(" ")] : B3));
          function b3(B3) {
            if (f3.chomping === "keep")
              return t3(B3).length === 0 ? B3.slice(0, -1) : B3;
            let I3 = 0;
            for (let M3 = B3.length - 1; M3 >= 0 && B3[M3].length === 0; M3--)
              I3++;
            return I3 === 0 ? B3 : I3 >= 2 && !F3 ? B3.slice(0, -(I3 - 1)) : B3.slice(0, -I3);
          }
        }
        function J3(f3) {
          if (!f3)
            return true;
          switch (f3.type) {
            case "plain":
            case "quoteDouble":
            case "quoteSingle":
            case "alias":
            case "flowMapping":
            case "flowSequence":
              return true;
            default:
              return false;
          }
        }
        l3.exports = { getLast: t3, getAncestorCount: a3, isNode: e28, isEmptyNode: p3, isInlineNode: J3, mapNode: n3, defineShortcut: r3, isNextLineEmpty: o3, isLastDescendantNode: c3, getBlockValueLineContents: k3, getFlowScalarLineContents: j3, getLastDescendantNode: h3, hasPrettierIgnore: y3, hasLeadingComments: C3, hasMiddleComments: w3, hasIndicatorComment: P3, hasTrailingComment: A3, hasEndComments: N3 };
      } }), Uo2 = X3({ "src/language-yaml/print-preprocess.js"(u3, l3) {
        H3();
        var { defineShortcut: t3, mapNode: s3 } = nn2();
        function a3(n3) {
          return s3(n3, e28);
        }
        function e28(n3) {
          switch (n3.type) {
            case "document":
              t3(n3, "head", () => n3.children[0]), t3(n3, "body", () => n3.children[1]);
              break;
            case "documentBody":
            case "sequenceItem":
            case "flowSequenceItem":
            case "mappingKey":
            case "mappingValue":
              t3(n3, "content", () => n3.children[0]);
              break;
            case "mappingItem":
            case "flowMappingItem":
              t3(n3, "key", () => n3.children[0]), t3(n3, "value", () => n3.children[1]);
              break;
          }
          return n3;
        }
        l3.exports = a3;
      } }), _n2 = X3({ "src/language-yaml/print/misc.js"(u3, l3) {
        H3();
        var { builders: { softline: t3, align: s3 } } = Qe2(), { hasEndComments: a3, isNextLineEmpty: e28, isNode: n3 } = nn2(), r3 = /* @__PURE__ */ new WeakMap();
        function o3(m3, y3) {
          let p3 = m3.getValue(), d3 = m3.stack[0], C3;
          return r3.has(d3) ? C3 = r3.get(d3) : (C3 = /* @__PURE__ */ new Set(), r3.set(d3, C3)), !C3.has(p3.position.end.line) && (C3.add(p3.position.end.line), e28(p3, y3) && !c3(m3.getParentNode())) ? t3 : "";
        }
        function c3(m3) {
          return a3(m3) && !n3(m3, ["documentHead", "documentBody", "flowMapping", "flowSequence"]);
        }
        function h3(m3, y3) {
          return s3(" ".repeat(m3), y3);
        }
        l3.exports = { alignWithSpaces: h3, shouldPrintEndComments: c3, printNextEmptyLine: o3 };
      } }), Yo2 = X3({ "src/language-yaml/print/flow-mapping-sequence.js"(u3, l3) {
        H3();
        var { builders: { ifBreak: t3, line: s3, softline: a3, hardline: e28, join: n3 } } = Qe2(), { isEmptyNode: r3, getLast: o3, hasEndComments: c3 } = nn2(), { printNextEmptyLine: h3, alignWithSpaces: m3 } = _n2();
        function y3(d3, C3, w3) {
          let P3 = d3.getValue(), A3 = P3.type === "flowMapping", N3 = A3 ? "{" : "[", S3 = A3 ? "}" : "]", j3 = a3;
          A3 && P3.children.length > 0 && w3.bracketSpacing && (j3 = s3);
          let k3 = o3(P3.children), J3 = k3 && k3.type === "flowMappingItem" && r3(k3.key) && r3(k3.value);
          return [N3, m3(w3.tabWidth, [j3, p3(d3, C3, w3), w3.trailingComma === "none" ? "" : t3(","), c3(P3) ? [e28, n3(e28, d3.map(C3, "endComments"))] : ""]), J3 ? "" : j3, S3];
        }
        function p3(d3, C3, w3) {
          let P3 = d3.getValue();
          return d3.map((A3, N3) => [C3(), N3 === P3.children.length - 1 ? "" : [",", s3, P3.children[N3].position.start.line !== P3.children[N3 + 1].position.start.line ? h3(A3, w3.originalText) : ""]], "children");
        }
        l3.exports = { printFlowMapping: y3, printFlowSequence: y3 };
      } }), zo2 = X3({ "src/language-yaml/print/mapping-item.js"(u3, l3) {
        H3();
        var { builders: { conditionalGroup: t3, group: s3, hardline: a3, ifBreak: e28, join: n3, line: r3 } } = Qe2(), { hasLeadingComments: o3, hasMiddleComments: c3, hasTrailingComment: h3, hasEndComments: m3, isNode: y3, isEmptyNode: p3, isInlineNode: d3 } = nn2(), { alignWithSpaces: C3 } = _n2();
        function w3(S3, j3, k3, J3, f3) {
          let { key: T3, value: D3 } = S3, F3 = p3(T3), i = p3(D3);
          if (F3 && i)
            return ": ";
          let g3 = J3("key"), E3 = A3(S3) ? " " : "";
          if (i)
            return S3.type === "flowMappingItem" && j3.type === "flowMapping" ? g3 : S3.type === "mappingItem" && P3(T3.content, f3) && !h3(T3.content) && (!j3.tag || j3.tag.value !== "tag:yaml.org,2002:set") ? [g3, E3, ":"] : ["? ", C3(2, g3)];
          let x3 = J3("value");
          if (F3)
            return [": ", C3(2, x3)];
          if (o3(D3) || !d3(T3.content))
            return ["? ", C3(2, g3), a3, n3("", k3.map(J3, "value", "leadingComments").map(($3) => [$3, a3])), ": ", C3(2, x3)];
          if (N3(T3.content) && !o3(T3.content) && !c3(T3.content) && !h3(T3.content) && !m3(T3) && !o3(D3.content) && !c3(D3.content) && !m3(D3) && P3(D3.content, f3))
            return [g3, E3, ": ", x3];
          let b3 = Symbol("mappingKey"), B3 = s3([e28("? "), s3(C3(2, g3), { id: b3 })]), I3 = [a3, ": ", C3(2, x3)], M3 = [E3, ":"];
          o3(D3.content) || m3(D3) && D3.content && !y3(D3.content, ["mapping", "sequence"]) || j3.type === "mapping" && h3(T3.content) && d3(D3.content) || y3(D3.content, ["mapping", "sequence"]) && D3.content.tag === null && D3.content.anchor === null ? M3.push(a3) : D3.content && M3.push(r3), M3.push(x3);
          let V10 = C3(f3.tabWidth, M3);
          return P3(T3.content, f3) && !o3(T3.content) && !c3(T3.content) && !m3(T3) ? t3([[g3, V10]]) : t3([[B3, e28(I3, V10, { groupId: b3 })]]);
        }
        function P3(S3, j3) {
          if (!S3)
            return true;
          switch (S3.type) {
            case "plain":
            case "quoteSingle":
            case "quoteDouble":
              break;
            case "alias":
              return true;
            default:
              return false;
          }
          if (j3.proseWrap === "preserve")
            return S3.position.start.line === S3.position.end.line;
          if (/\\$/m.test(j3.originalText.slice(S3.position.start.offset, S3.position.end.offset)))
            return false;
          switch (j3.proseWrap) {
            case "never":
              return !S3.value.includes(`
`);
            case "always":
              return !/[\n ]/.test(S3.value);
            default:
              return false;
          }
        }
        function A3(S3) {
          return S3.key.content && S3.key.content.type === "alias";
        }
        function N3(S3) {
          if (!S3)
            return true;
          switch (S3.type) {
            case "plain":
            case "quoteDouble":
            case "quoteSingle":
              return S3.position.start.line === S3.position.end.line;
            case "alias":
              return true;
            default:
              return false;
          }
        }
        l3.exports = w3;
      } }), Ko2 = X3({ "src/language-yaml/print/block.js"(u3, l3) {
        H3();
        var { builders: { dedent: t3, dedentToRoot: s3, fill: a3, hardline: e28, join: n3, line: r3, literalline: o3, markAsRoot: c3 }, utils: { getDocParts: h3 } } = Qe2(), { getAncestorCount: m3, getBlockValueLineContents: y3, hasIndicatorComment: p3, isLastDescendantNode: d3, isNode: C3 } = nn2(), { alignWithSpaces: w3 } = _n2();
        function P3(A3, N3, S3) {
          let j3 = A3.getValue(), k3 = m3(A3, (F3) => C3(F3, ["sequence", "mapping"])), J3 = d3(A3), f3 = [j3.type === "blockFolded" ? ">" : "|"];
          j3.indent !== null && f3.push(j3.indent.toString()), j3.chomping !== "clip" && f3.push(j3.chomping === "keep" ? "+" : "-"), p3(j3) && f3.push(" ", N3("indicatorComment"));
          let T3 = y3(j3, { parentIndent: k3, isLastDescendant: J3, options: S3 }), D3 = [];
          for (let [F3, i] of T3.entries())
            F3 === 0 && D3.push(e28), D3.push(a3(h3(n3(r3, i)))), F3 !== T3.length - 1 ? D3.push(i.length === 0 ? e28 : c3(o3)) : j3.chomping === "keep" && J3 && D3.push(s3(i.length === 0 ? e28 : o3));
          return j3.indent === null ? f3.push(t3(w3(S3.tabWidth, D3))) : f3.push(s3(w3(j3.indent - 1 + k3, D3))), f3;
        }
        l3.exports = P3;
      } }), Qo2 = X3({ "src/language-yaml/printer-yaml.js"(u3, l3) {
        H3();
        var { builders: { breakParent: t3, fill: s3, group: a3, hardline: e28, join: n3, line: r3, lineSuffix: o3, literalline: c3 }, utils: { getDocParts: h3, replaceTextEndOfLine: m3 } } = Qe2(), { isPreviousLineEmpty: y3 } = at2(), { insertPragma: p3, isPragma: d3 } = Go2(), { locStart: C3 } = Wo2(), w3 = Xo2(), { getFlowScalarLineContents: P3, getLastDescendantNode: A3, hasLeadingComments: N3, hasMiddleComments: S3, hasTrailingComment: j3, hasEndComments: k3, hasPrettierIgnore: J3, isLastDescendantNode: f3, isNode: T3, isInlineNode: D3 } = nn2(), F3 = Uo2(), { alignWithSpaces: i, printNextEmptyLine: g3, shouldPrintEndComments: E3 } = _n2(), { printFlowMapping: x3, printFlowSequence: b3 } = Yo2(), B3 = zo2(), I3 = Ko2();
        function M3(O3, Z3, ie2) {
          let te2 = O3.getValue(), ge2 = [];
          te2.type !== "mappingValue" && N3(te2) && ge2.push([n3(e28, O3.map(ie2, "leadingComments")), e28]);
          let { tag: q3, anchor: z3 } = te2;
          q3 && ge2.push(ie2("tag")), q3 && z3 && ge2.push(" "), z3 && ge2.push(ie2("anchor"));
          let De2 = "";
          T3(te2, ["mapping", "sequence", "comment", "directive", "mappingItem", "sequenceItem"]) && !f3(O3) && (De2 = g3(O3, Z3.originalText)), (q3 || z3) && (T3(te2, ["sequence", "mapping"]) && !S3(te2) ? ge2.push(e28) : ge2.push(" ")), S3(te2) && ge2.push([te2.middleComments.length === 1 ? "" : e28, n3(e28, O3.map(ie2, "middleComments")), e28]);
          let fe2 = O3.getParentNode();
          return J3(O3) ? ge2.push(m3(Z3.originalText.slice(te2.position.start.offset, te2.position.end.offset).trimEnd(), c3)) : ge2.push(a3(V10(te2, fe2, O3, Z3, ie2))), j3(te2) && !T3(te2, ["document", "documentHead"]) && ge2.push(o3([te2.type === "mappingValue" && !te2.content ? "" : " ", fe2.type === "mappingKey" && O3.getParentNode(2).type === "mapping" && D3(te2) ? "" : t3, ie2("trailingComment")])), E3(te2) && ge2.push(i(te2.type === "sequenceItem" ? 2 : 0, [e28, n3(e28, O3.map((we2) => [y3(Z3.originalText, we2.getValue(), C3) ? e28 : "", ie2()], "endComments"))])), ge2.push(De2), ge2;
        }
        function V10(O3, Z3, ie2, te2, ge2) {
          switch (O3.type) {
            case "root": {
              let { children: q3 } = O3, z3 = [];
              ie2.each((fe2, we2) => {
                let Q3 = q3[we2], W3 = q3[we2 + 1];
                we2 !== 0 && z3.push(e28), z3.push(ge2()), U3(Q3, W3) ? (z3.push(e28, "..."), j3(Q3) && z3.push(" ", ge2("trailingComment"))) : W3 && !j3(W3.head) && z3.push(e28, "---");
              }, "children");
              let De2 = A3(O3);
              return (!T3(De2, ["blockLiteral", "blockFolded"]) || De2.chomping !== "keep") && z3.push(e28), z3;
            }
            case "document": {
              let q3 = Z3.children[ie2.getName() + 1], z3 = [];
              return L3(O3, q3, Z3, te2) === "head" && ((O3.head.children.length > 0 || O3.head.endComments.length > 0) && z3.push(ge2("head")), j3(O3.head) ? z3.push(["---", " ", ge2(["head", "trailingComment"])]) : z3.push("---")), $3(O3) && z3.push(ge2("body")), n3(e28, z3);
            }
            case "documentHead":
              return n3(e28, [...ie2.map(ge2, "children"), ...ie2.map(ge2, "endComments")]);
            case "documentBody": {
              let { children: q3, endComments: z3 } = O3, De2 = "";
              if (q3.length > 0 && z3.length > 0) {
                let fe2 = A3(O3);
                T3(fe2, ["blockFolded", "blockLiteral"]) ? fe2.chomping !== "keep" && (De2 = [e28, e28]) : De2 = e28;
              }
              return [n3(e28, ie2.map(ge2, "children")), De2, n3(e28, ie2.map(ge2, "endComments"))];
            }
            case "directive":
              return ["%", n3(" ", [O3.name, ...O3.parameters])];
            case "comment":
              return ["#", O3.value];
            case "alias":
              return ["*", O3.value];
            case "tag":
              return te2.originalText.slice(O3.position.start.offset, O3.position.end.offset);
            case "anchor":
              return ["&", O3.value];
            case "plain":
              return ee2(O3.type, te2.originalText.slice(O3.position.start.offset, O3.position.end.offset), te2);
            case "quoteDouble":
            case "quoteSingle": {
              let q3 = "'", z3 = '"', De2 = te2.originalText.slice(O3.position.start.offset + 1, O3.position.end.offset - 1);
              if (O3.type === "quoteSingle" && De2.includes("\\") || O3.type === "quoteDouble" && /\\[^"]/.test(De2)) {
                let we2 = O3.type === "quoteDouble" ? z3 : q3;
                return [we2, ee2(O3.type, De2, te2), we2];
              }
              if (De2.includes(z3))
                return [q3, ee2(O3.type, O3.type === "quoteDouble" ? De2.replace(/\\"/g, z3).replace(/'/g, q3.repeat(2)) : De2, te2), q3];
              if (De2.includes(q3))
                return [z3, ee2(O3.type, O3.type === "quoteSingle" ? De2.replace(/''/g, q3) : De2, te2), z3];
              let fe2 = te2.singleQuote ? q3 : z3;
              return [fe2, ee2(O3.type, De2, te2), fe2];
            }
            case "blockFolded":
            case "blockLiteral":
              return I3(ie2, ge2, te2);
            case "mapping":
            case "sequence":
              return n3(e28, ie2.map(ge2, "children"));
            case "sequenceItem":
              return ["- ", i(2, O3.content ? ge2("content") : "")];
            case "mappingKey":
            case "mappingValue":
              return O3.content ? ge2("content") : "";
            case "mappingItem":
            case "flowMappingItem":
              return B3(O3, Z3, ie2, ge2, te2);
            case "flowMapping":
              return x3(ie2, ge2, te2);
            case "flowSequence":
              return b3(ie2, ge2, te2);
            case "flowSequenceItem":
              return ge2("content");
            default:
              throw new Error(`Unexpected node type ${O3.type}`);
          }
        }
        function $3(O3) {
          return O3.body.children.length > 0 || k3(O3.body);
        }
        function U3(O3, Z3) {
          return j3(O3) || Z3 && (Z3.head.children.length > 0 || k3(Z3.head));
        }
        function L3(O3, Z3, ie2, te2) {
          return ie2.children[0] === O3 && /---(?:\s|$)/.test(te2.originalText.slice(C3(O3), C3(O3) + 4)) || O3.head.children.length > 0 || k3(O3.head) || j3(O3.head) ? "head" : U3(O3, Z3) ? false : Z3 ? "root" : false;
        }
        function ee2(O3, Z3, ie2) {
          let te2 = P3(O3, Z3, ie2);
          return n3(e28, te2.map((ge2) => s3(h3(n3(r3, ge2)))));
        }
        function R3(O3, Z3) {
          if (T3(Z3))
            switch (delete Z3.position, Z3.type) {
              case "comment":
                if (d3(Z3.value))
                  return null;
                break;
              case "quoteDouble":
              case "quoteSingle":
                Z3.type = "quote";
                break;
            }
        }
        l3.exports = { preprocess: F3, embed: w3, print: M3, massageAstNode: R3, insertPragma: p3 };
      } }), Ho2 = X3({ "src/language-yaml/options.js"(u3, l3) {
        H3();
        var t3 = en2();
        l3.exports = { bracketSpacing: t3.bracketSpacing, singleQuote: t3.singleQuote, proseWrap: t3.proseWrap };
      } }), Zo2 = X3({ "src/language-yaml/parsers.js"() {
        H3();
      } }), el = X3({ "node_modules/linguist-languages/data/YAML.json"(u3, l3) {
        l3.exports = { name: "YAML", type: "data", color: "#cb171e", tmScope: "source.yaml", aliases: ["yml"], extensions: [".yml", ".mir", ".reek", ".rviz", ".sublime-syntax", ".syntax", ".yaml", ".yaml-tmlanguage", ".yaml.sed", ".yml.mysql"], filenames: [".clang-format", ".clang-tidy", ".gemrc", "CITATION.cff", "glide.lock", "yarn.lock"], aceMode: "yaml", codemirrorMode: "yaml", codemirrorMimeType: "text/x-yaml", languageId: 407 };
      } }), tl = X3({ "src/language-yaml/index.js"(u3, l3) {
        H3();
        var t3 = Gt2(), s3 = Qo2(), a3 = Ho2(), e28 = Zo2(), n3 = [t3(el(), (r3) => ({ since: "1.14.0", parsers: ["yaml"], vscodeLanguageIds: ["yaml", "ansible", "home-assistant"], filenames: [...r3.filenames.filter((o3) => o3 !== "yarn.lock"), ".prettierrc", ".stylelintrc", ".lintstagedrc"] }))];
        l3.exports = { languages: n3, printers: { yaml: s3 }, options: a3, parsers: e28 };
      } }), nl = X3({ "src/languages.js"(u3, l3) {
        H3(), l3.exports = [Ls2(), Zs2(), so2(), mo2(), vo2(), qo2(), tl()];
      } });
      H3();
      var { version: rl } = xt2(), rn2 = Ha2(), { getSupportInfo: ul } = Kn2(), il = Za2(), al = nl(), sl = Qe2();
      function Xt2(u3) {
        let l3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        return function() {
          for (var t3 = arguments.length, s3 = new Array(t3), a3 = 0; a3 < t3; a3++)
            s3[a3] = arguments[a3];
          let e28 = s3[l3] || {}, n3 = e28.plugins || [];
          return s3[l3] = Object.assign(Object.assign({}, e28), {}, { plugins: [...al, ...Array.isArray(n3) ? n3 : Object.values(n3)] }), u3(...s3);
        };
      }
      var yr2 = Xt2(rn2.formatWithCursor);
      oe2.exports = { formatWithCursor: yr2, format(u3, l3) {
        return yr2(u3, l3).formatted;
      }, check(u3, l3) {
        let { formatted: t3 } = yr2(u3, l3);
        return t3 === u3;
      }, doc: sl, getSupportInfo: Xt2(ul, 0), version: rl, util: il, __debug: { parse: Xt2(rn2.parse), formatAST: Xt2(rn2.formatAST), formatDoc: Xt2(rn2.formatDoc), printToDoc: Xt2(rn2.printToDoc), printDocToString: Xt2(rn2.printDocToString) } };
    });
    return Ji2();
  });
})(a$14);
var pl = a$14.exports;
const fl = /* @__PURE__ */ l$Y(pl);
var t$J = /* @__PURE__ */ ((r3) => (r3.JSON = "json", r3.JAVASCRIPT = "javascript", r3.HTML = "html", r3.CSS = "css", r3))(t$J || {}), s$11 = /* @__PURE__ */ ((r3) => (r3.Focus = "focus", r3.Blur = "blur", r3.Input = "input", r3.Paste = "paste", r3))(s$11 || {});
const X$7 = ["id"], Y$5 = defineComponent({
  name: "UICodeEditor",
  inheritAttrs: false
}), Z$8 = defineComponent(__spreadProps(__spreadValues({}, Y$5), {
  props: {
    value: String,
    language: String,
    id: {
      type: String,
      required: true,
      default: "ghl-editor"
    },
    resize: {
      type: Boolean,
      default: true
    },
    prettify: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:value"],
  setup(p3, { expose: T3, emit: E3 }) {
    const o3 = p3;
    let a3 = null;
    const c3 = E3, g3 = ref$1(null), L3 = (e28) => {
      if (!a3)
        return false;
      a3.dispatch({
        changes: {
          from: 0,
          to: a3.state.doc.length,
          insert: i(e28)
        }
      }), c3("update:value", i(e28));
    }, i = (e28) => {
      if (!o3.prettify)
        return e28;
      try {
        if (o3.language === t$J.CSS)
          return fl.format(e28, {
            parser: "css",
            plugins: [qi$1]
          });
        if (o3.language === t$J.JAVASCRIPT)
          return fl.format(e28, {
            parser: "babel",
            plugins: [vo$2]
          });
        if (o3.language === t$J.HTML)
          return fl.format(e28, {
            parser: "html",
            plugins: [jr$1]
          });
        if (o3.language === t$J.JSON)
          return JSON.stringify(JSON.parse(e28), null, 2);
      } catch {
        return e28;
      }
    }, m3 = (e28, t3) => {
      const I3 = [
        s$11.Input,
        s$11.Blur,
        s$11.Focus,
        s$11.Paste
      ];
      if (!e28 || !I3.includes(t3))
        return false;
      setTimeout(() => {
        let s3 = e28.state.doc.toString();
        t3 !== s$11.Input && (s3 = i(s3), e28.dispatch({
          changes: {
            from: 0,
            to: e28.state.doc.length,
            insert: s3
          }
        })), c3("update:value", s3);
      }, 0);
    }, b3 = {
      [t$J.JAVASCRIPT]: [
        ke$4(he$6(new cR())),
        xe$4(),
        I$i,
        ge$5(),
        m$16.data.of({
          autocomplete: ye$5(globalThis)
        })
      ],
      [t$J.CSS]: [
        ke$4(he$6(new cR())),
        xe$4(),
        I$i,
        Z$b()
      ],
      [t$J.HTML]: [
        xe$4(),
        I$i,
        ye$6(),
        k$n.data.of({
          autocomplete: be$5
        })
      ],
      [t$J.JSON]: [
        xe$4(),
        I$i,
        ke$4(f$K()),
        l$Z(),
        m$15
      ]
    }, A3 = [
      A$m.domEventHandlers({
        input: (e28, t3) => m3(t3, e28.type),
        paste: (e28, t3) => m3(t3, e28.type),
        blur: (e28, t3) => m3(t3, e28.type)
      })
    ], h3 = (e28 = t$J.JAVASCRIPT) => {
      a3 && a3.destroy(), a3 = new A$m({
        state: w$q.create({
          doc: i(o3.value),
          extensions: [
            ...b3[e28],
            ...A3,
            Kr$1.of([un$1])
          ]
        }),
        parent: g3.value
      });
    };
    return onMounted(() => h3(o3.language)), onUnmounted(() => a3 && a3.destroy()), T3({
      setContent: L3
    }), watch(() => o3.language, (e28) => {
      h3(e28);
    }), (e28, t3) => (openBlock(), createElementBlock("div", {
      ref_key: "editorContainer",
      ref: g3,
      class: normalizeClass(["ghl-code-mirror", p3.resize ? "allow-resize" : null].join(" ")),
      id: p3.id
    }, null, 10, X$7));
  }
})), he$3 = Z$8;
const n$G = l$25("collapse-transition", {
  width: "100%"
}, [x$E()]);
const e$W = (o3) => {
  const {
    cubicBezierEaseInOut: n3
  } = o3;
  return {
    bezier: n3
  };
}, i$U = {
  name: "CollapseTransition",
  common: d$1T,
  self: e$W
}, a$13 = i$U;
const E$g = Object.assign(Object.assign({}, _$F.props), {
  show: {
    type: Boolean,
    default: true
  },
  appear: Boolean,
  collapsed: {
    type: Boolean,
    default: void 0
  }
}), j$8 = defineComponent({
  name: "CollapseTransition",
  props: E$g,
  inheritAttrs: false,
  setup(e28) {
    const {
      mergedClsPrefixRef: t3,
      inlineThemeDisabled: n3,
      mergedRtlRef: a3
    } = a$2x(e28), d3 = _$F("CollapseTransition", "-collapse-transition", n$G, a$13, e28, t3), f3 = v$17("CollapseTransition", a3, t3), m3 = computed(() => e28.collapsed !== void 0 ? e28.collapsed : e28.show), o3 = computed(() => {
      const {
        self: {
          bezier: p3
        }
      } = d3.value;
      return {
        "--n-bezier": p3
      };
    }), s3 = n3 ? E$J("collapse-transition", void 0, o3, e28) : void 0;
    return {
      rtlEnabled: f3,
      mergedShow: m3,
      mergedClsPrefix: t3,
      cssVars: n3 ? void 0 : o3,
      themeClass: s3 == null ? void 0 : s3.themeClass,
      onRender: s3 == null ? void 0 : s3.onRender
    };
  },
  render() {
    return h$1R(l$1W, {
      appear: this.appear
    }, {
      default: () => {
        var e28;
        if (this.mergedShow)
          return (e28 = this.onRender) === null || e28 === void 0 || e28.call(this), h$1R("div", mergeProps({
            class: [`${this.mergedClsPrefix}-collapse-transition`, this.rtlEnabled && `${this.mergedClsPrefix}-collapse-transition--rtl`, this.themeClass],
            style: this.cssVars
          }, this.$attrs), this.$slots);
      }
    });
  }
});
const f$G = defineComponent({
  name: "UICollapseTransition",
  inheritAttrs: false
}), i$T = defineComponent(__spreadProps(__spreadValues({}, f$G), {
  props: {
    appear: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  setup(e28) {
    return (a3, u3) => (openBlock(), createBlock(unref(j$8), {
      appear: e28.appear,
      show: e28.show
    }, {
      default: withCtx(() => [
        renderSlot(a3.$slots, "default")
      ]),
      _: 3
    }, 8, ["appear", "show"]));
  }
})), h$U = i$T;
function u$Y(e28, h3, t3) {
  h3 /= 100, t3 /= 100;
  const n3 = h3 * Math.min(t3, 1 - t3) + t3;
  return [e28, n3 ? (2 - 2 * t3 / n3) * 100 : 0, n3 * 100];
}
function M$b(e28, h3, t3) {
  h3 /= 100, t3 /= 100;
  const n3 = t3 - t3 * h3 / 2, a3 = Math.min(n3, 1 - n3);
  return [e28, a3 ? (t3 - n3) / a3 * 100 : 0, n3 * 100];
}
function c$16(e28, h3, t3) {
  h3 /= 100, t3 /= 100;
  let n3 = (a3, i = (a3 + e28 / 60) % 6) => t3 - t3 * h3 * Math.max(Math.min(i, 4 - i, 1), 0);
  return [n3(5) * 255, n3(3) * 255, n3(1) * 255];
}
function o$Q(e28, h3, t3) {
  e28 /= 255, h3 /= 255, t3 /= 255;
  let n3 = Math.max(e28, h3, t3), a3 = n3 - Math.min(e28, h3, t3), i = a3 && (n3 == e28 ? (h3 - t3) / a3 : n3 == h3 ? 2 + (t3 - e28) / a3 : 4 + (e28 - h3) / a3);
  return [60 * (i < 0 ? i + 6 : i), n3 && a3 / n3 * 100, n3 * 100];
}
function f$F(e28, h3, t3) {
  e28 /= 255, h3 /= 255, t3 /= 255;
  let n3 = Math.max(e28, h3, t3), a3 = n3 - Math.min(e28, h3, t3), i = 1 - Math.abs(n3 + n3 - a3 - 1), m3 = a3 && (n3 == e28 ? (h3 - t3) / a3 : n3 == h3 ? 2 + (t3 - e28) / a3 : 4 + (e28 - h3) / a3);
  return [60 * (m3 < 0 ? m3 + 6 : m3), i ? a3 / i * 100 : 0, (n3 + n3 - a3) * 50];
}
function s$10(e28, h3, t3) {
  h3 /= 100, t3 /= 100;
  let n3 = h3 * Math.min(t3, 1 - t3), a3 = (i, m3 = (i + e28 / 30) % 12) => t3 - n3 * Math.max(Math.min(m3 - 3, 9 - m3, 1), -1);
  return [a3(0) * 255, a3(8) * 255, a3(4) * 255];
}
function z$9(r3, n3) {
  switch (r3[0]) {
    case "hex":
      return n3 ? "#000000FF" : "#000000";
    case "rgb":
      return n3 ? "rgba(0, 0, 0, 1)" : "rgb(0, 0, 0)";
    case "hsl":
      return n3 ? "hsla(0, 0%, 0%, 1)" : "hsl(0, 0%, 0%)";
    case "hsv":
      return n3 ? "hsva(0, 0%, 0%, 1)" : "hsv(0, 0%, 0%)";
  }
  return "#000000";
}
function H$a(r3) {
  return r3 === null ? null : /^ *#/.test(r3) ? "hex" : r3.includes("rgb") ? "rgb" : r3.includes("hsl") ? "hsl" : r3.includes("hsv") ? "hsv" : null;
}
function D$l(r3) {
  return r3 = Math.round(r3), r3 >= 360 ? 359 : r3 < 0 ? 0 : r3;
}
function E$f(r3) {
  return r3 = Math.round(r3 * 100) / 100, r3 > 1 ? 1 : r3 < 0 ? 0 : r3;
}
const S$f = {
  rgb: {
    hex(r3) {
      return X$m(p$3J(r3));
    },
    hsl(r3) {
      const [n3, t3, s3, e28] = p$3J(r3);
      return W$q([...f$F(n3, t3, s3), e28]);
    },
    hsv(r3) {
      const [n3, t3, s3, e28] = p$3J(r3);
      return Q$s([...o$Q(n3, t3, s3), e28]);
    }
  },
  hex: {
    rgb(r3) {
      return D$L(p$3J(r3));
    },
    hsl(r3) {
      const [n3, t3, s3, e28] = p$3J(r3);
      return W$q([...f$F(n3, t3, s3), e28]);
    },
    hsv(r3) {
      const [n3, t3, s3, e28] = p$3J(r3);
      return Q$s([...o$Q(n3, t3, s3), e28]);
    }
  },
  hsl: {
    hex(r3) {
      const [n3, t3, s3, e28] = q$D(r3);
      return X$m([...s$10(n3, t3, s3), e28]);
    },
    rgb(r3) {
      const [n3, t3, s3, e28] = q$D(r3);
      return D$L([...s$10(n3, t3, s3), e28]);
    },
    hsv(r3) {
      const [n3, t3, s3, e28] = q$D(r3);
      return Q$s([...u$Y(n3, t3, s3), e28]);
    }
  },
  hsv: {
    hex(r3) {
      const [n3, t3, s3, e28] = B$S(r3);
      return X$m([...c$16(n3, t3, s3), e28]);
    },
    rgb(r3) {
      const [n3, t3, s3, e28] = B$S(r3);
      return D$L([...c$16(n3, t3, s3), e28]);
    },
    hsl(r3) {
      const [n3, t3, s3, e28] = B$S(r3);
      return W$q([...M$b(n3, t3, s3), e28]);
    }
  }
};
function N$l(r3, n3, t3) {
  return t3 = t3 || H$a(r3), t3 ? t3 === n3 ? r3 : S$f[t3][n3](r3) : null;
}
const n$F = "12px", v$w = 12, t$I = "6px", R$9 = 6, x$g = "linear-gradient(90deg,red,#ff0 16.66%,#0f0 33.33%,#0ff 50%,#00f 66.66%,#f0f 83.33%,red)", H$9 = defineComponent({
  name: "HueSlider",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    hue: {
      type: Number,
      required: true
    },
    onUpdateHue: {
      type: Function,
      required: true
    },
    onComplete: Function
  },
  setup(e28) {
    const i = ref$1(null);
    function a3(o3) {
      i.value && (J$o("mousemove", document, u3), J$o("mouseup", document, l3), u3(o3));
    }
    function u3(o3) {
      const {
        value: d3
      } = i;
      if (!d3)
        return;
      const {
        width: f3,
        left: h3
      } = d3.getBoundingClientRect(), m3 = D$l((o3.clientX - h3 - R$9) / (f3 - v$w) * 360);
      e28.onUpdateHue(m3);
    }
    function l3() {
      var o3;
      K$p("mousemove", document, u3), K$p("mouseup", document, l3), (o3 = e28.onComplete) === null || o3 === void 0 || o3.call(e28);
    }
    return {
      railRef: i,
      handleMouseDown: a3
    };
  },
  render() {
    const {
      clsPrefix: e28
    } = this;
    return h$1R("div", {
      class: `${e28}-color-picker-slider`,
      style: {
        height: n$F,
        borderRadius: t$I
      }
    }, h$1R("div", {
      ref: "railRef",
      style: {
        boxShadow: "inset 0 0 2px 0 rgba(0, 0, 0, .24)",
        boxSizing: "border-box",
        backgroundImage: x$g,
        height: n$F,
        borderRadius: t$I,
        position: "relative"
      },
      onMousedown: this.handleMouseDown
    }, h$1R("div", {
      style: {
        position: "absolute",
        left: t$I,
        right: t$I,
        top: 0,
        bottom: 0
      }
    }, h$1R("div", {
      class: `${e28}-color-picker-handle`,
      style: {
        left: `calc((${this.hue}%) / 359 * 100 - ${t$I})`,
        borderRadius: t$I,
        width: n$F,
        height: n$F
      }
    }, h$1R("div", {
      class: `${e28}-color-picker-handle__fill`,
      style: {
        backgroundColor: `hsl(${this.hue}, 100%, 50%)`,
        borderRadius: t$I,
        width: n$F,
        height: n$F
      }
    })))));
  }
});
const i$S = "12px", y$q = 12, r$T = "6px", _$f = defineComponent({
  name: "AlphaSlider",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    rgba: {
      type: Array,
      default: null
    },
    alpha: {
      type: Number,
      default: 0
    },
    onUpdateAlpha: {
      type: Function,
      required: true
    },
    onComplete: Function
  },
  setup(o3) {
    const l3 = ref$1(null);
    function c3(e28) {
      !l3.value || !o3.rgba || (J$o("mousemove", document, n3), J$o("mouseup", document, a3), n3(e28));
    }
    function n3(e28) {
      const {
        value: d3
      } = l3;
      if (!d3)
        return;
      const {
        width: h3,
        left: p3
      } = d3.getBoundingClientRect(), m3 = (e28.clientX - p3) / (h3 - y$q);
      o3.onUpdateAlpha(E$f(m3));
    }
    function a3() {
      var e28;
      K$p("mousemove", document, n3), K$p("mouseup", document, a3), (e28 = o3.onComplete) === null || e28 === void 0 || e28.call(o3);
    }
    return {
      railRef: l3,
      railBackgroundImage: computed(() => {
        const {
          rgba: e28
        } = o3;
        return e28 ? `linear-gradient(to right, rgba(${e28[0]}, ${e28[1]}, ${e28[2]}, 0) 0%, rgba(${e28[0]}, ${e28[1]}, ${e28[2]}, 1) 100%)` : "";
      }),
      handleMouseDown: c3
    };
  },
  render() {
    const {
      clsPrefix: o3
    } = this;
    return h$1R("div", {
      class: `${o3}-color-picker-slider`,
      ref: "railRef",
      style: {
        height: i$S,
        borderRadius: r$T
      },
      onMousedown: this.handleMouseDown
    }, h$1R("div", {
      style: {
        borderRadius: r$T,
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        overflow: "hidden"
      }
    }, h$1R("div", {
      class: `${o3}-color-picker-checkboard`
    }), h$1R("div", {
      class: `${o3}-color-picker-slider__image`,
      style: {
        backgroundImage: this.railBackgroundImage
      }
    })), this.rgba && h$1R("div", {
      style: {
        position: "absolute",
        left: r$T,
        right: r$T,
        top: 0,
        bottom: 0
      }
    }, h$1R("div", {
      class: `${o3}-color-picker-handle`,
      style: {
        left: `calc(${this.alpha * 100}% - ${r$T})`,
        borderRadius: r$T,
        width: i$S,
        height: i$S
      }
    }, h$1R("div", {
      class: `${o3}-color-picker-handle__fill`,
      style: {
        backgroundColor: D$L(this.rgba),
        borderRadius: r$T,
        width: i$S,
        height: i$S
      }
    }))));
  }
});
const l$X = "12px", r$S = "6px", C$z = defineComponent({
  name: "Pallete",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    rgba: {
      type: Array,
      default: null
    },
    displayedHue: {
      type: Number,
      required: true
    },
    displayedSv: {
      type: Array,
      required: true
    },
    onUpdateSV: {
      type: Function,
      required: true
    },
    onComplete: Function
  },
  setup(t3) {
    const n3 = ref$1(null);
    function h3(e28) {
      n3.value && (J$o("mousemove", document, a3), J$o("mouseup", document, s3), a3(e28));
    }
    function a3(e28) {
      const {
        value: c3
      } = n3;
      if (!c3)
        return;
      const {
        width: m3,
        height: f3,
        left: g3,
        bottom: y3
      } = c3.getBoundingClientRect(), i = (y3 - e28.clientY) / f3, d3 = (e28.clientX - g3) / m3, v3 = 100 * (d3 > 1 ? 1 : d3 < 0 ? 0 : d3), b3 = 100 * (i > 1 ? 1 : i < 0 ? 0 : i);
      t3.onUpdateSV(v3, b3);
    }
    function s3() {
      var e28;
      K$p("mousemove", document, a3), K$p("mouseup", document, s3), (e28 = t3.onComplete) === null || e28 === void 0 || e28.call(t3);
    }
    return {
      palleteRef: n3,
      handleColor: computed(() => {
        const {
          rgba: e28
        } = t3;
        return e28 ? `rgb(${e28[0]}, ${e28[1]}, ${e28[2]})` : "";
      }),
      handleMouseDown: h3
    };
  },
  render() {
    const {
      clsPrefix: t3
    } = this;
    return h$1R("div", {
      class: `${t3}-color-picker-pallete`,
      onMousedown: this.handleMouseDown,
      ref: "palleteRef"
    }, h$1R("div", {
      class: `${t3}-color-picker-pallete__layer`,
      style: {
        backgroundImage: `linear-gradient(90deg, white, hsl(${this.displayedHue}, 100%, 50%))`
      }
    }), h$1R("div", {
      class: `${t3}-color-picker-pallete__layer ${t3}-color-picker-pallete__layer--shadowed`,
      style: {
        backgroundImage: "linear-gradient(180deg, rgba(0, 0, 0, 0%), rgba(0, 0, 0, 100%))"
      }
    }), this.rgba && h$1R("div", {
      class: `${t3}-color-picker-handle`,
      style: {
        width: l$X,
        height: l$X,
        borderRadius: r$S,
        left: `calc(${this.displayedSv[0]}% - ${r$S})`,
        bottom: `calc(${this.displayedSv[1]}% - ${r$S})`
      }
    }, h$1R("div", {
      class: `${t3}-color-picker-handle__fill`,
      style: {
        backgroundColor: this.handleColor,
        borderRadius: r$S,
        width: l$X,
        height: l$X
      }
    })));
  }
});
const c$15 = n$28("n-color-picker");
function U$c(e28) {
  return /^\d{1,3}\.?\d*$/.test(e28.trim()) ? Math.max(0, Math.min(parseInt(e28), 255)) : false;
}
function I$h(e28) {
  return /^\d{1,3}\.?\d*$/.test(e28.trim()) ? Math.max(0, Math.min(parseInt(e28), 360)) : false;
}
function g$B(e28) {
  return /^\d{1,3}\.?\d*$/.test(e28.trim()) ? Math.max(0, Math.min(parseInt(e28), 100)) : false;
}
function V$c(e28) {
  const a3 = e28.trim();
  return /^#[0-9a-fA-F]+$/.test(a3) ? [4, 5, 7, 9].includes(a3.length) : false;
}
function b$u(e28) {
  return /^\d{1,3}\.?\d*%$/.test(e28.trim()) ? Math.max(0, Math.min(parseInt(e28) / 100, 100)) : false;
}
const M$a = {
  paddingSmall: "0 4px"
}, k$k = defineComponent({
  name: "ColorInputUnit",
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      default: null
    },
    showAlpha: Boolean,
    onUpdateValue: {
      type: Function,
      required: true
    }
  },
  setup(e28) {
    const a3 = ref$1(""), {
      themeRef: l3
    } = inject(c$15, null);
    watchEffect(() => {
      a3.value = r3();
    });
    function r3() {
      const {
        value: n3
      } = e28;
      if (n3 === null)
        return "";
      const {
        label: t3
      } = e28;
      return t3 === "HEX" ? n3 : t3 === "A" ? `${Math.floor(n3 * 100)}%` : String(Math.floor(n3));
    }
    function u3(n3) {
      a3.value = n3;
    }
    function s3(n3) {
      let t3, i;
      switch (e28.label) {
        case "HEX":
          i = V$c(n3), i && e28.onUpdateValue(n3), a3.value = r3();
          break;
        case "H":
          t3 = I$h(n3), t3 === false ? a3.value = r3() : e28.onUpdateValue(t3);
          break;
        case "S":
        case "L":
        case "V":
          t3 = g$B(n3), t3 === false ? a3.value = r3() : e28.onUpdateValue(t3);
          break;
        case "A":
          t3 = b$u(n3), t3 === false ? a3.value = r3() : e28.onUpdateValue(t3);
          break;
        case "R":
        case "G":
        case "B":
          t3 = U$c(n3), t3 === false ? a3.value = r3() : e28.onUpdateValue(t3);
          break;
      }
    }
    return {
      mergedTheme: l3,
      inputValue: a3,
      handleInputChange: s3,
      handleInputUpdateValue: u3
    };
  },
  render() {
    const {
      mergedTheme: e28
    } = this;
    return h$1R(Zn$3, {
      size: "small",
      placeholder: this.label,
      theme: e28.peers.Input,
      themeOverrides: e28.peerOverrides.Input,
      builtinThemeOverrides: M$a,
      value: this.inputValue,
      onUpdateValue: this.handleInputUpdateValue,
      onChange: this.handleInputChange,
      style: this.label === "A" ? "flex-grow: 1.25;" : ""
    });
  }
});
const x$f = defineComponent({
  name: "ColorInput",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    modes: {
      type: Array,
      required: true
    },
    showAlpha: {
      type: Boolean,
      required: true
    },
    value: {
      type: String,
      default: null
    },
    valueArr: {
      type: Array,
      default: null
    },
    onUpdateValue: {
      type: Function,
      required: true
    },
    onUpdateMode: {
      type: Function,
      required: true
    }
  },
  setup(e28) {
    return {
      handleUnitUpdateValue(a3, l3) {
        const {
          showAlpha: r3
        } = e28;
        if (e28.mode === "hex") {
          e28.onUpdateValue((r3 ? X$m : Y$m)(l3));
          return;
        }
        let t3;
        switch (e28.valueArr === null ? t3 = [0, 0, 0, 0] : t3 = Array.from(e28.valueArr), e28.mode) {
          case "hsv":
            t3[a3] = l3, e28.onUpdateValue((r3 ? Q$s : O$B)(t3));
            break;
          case "rgb":
            t3[a3] = l3, e28.onUpdateValue((r3 ? D$L : L$I)(t3));
            break;
          case "hsl":
            t3[a3] = l3, e28.onUpdateValue((r3 ? W$q : T$N)(t3));
            break;
        }
      }
    };
  },
  render() {
    const {
      clsPrefix: e28,
      modes: a3
    } = this;
    return h$1R("div", {
      class: `${e28}-color-picker-input`
    }, h$1R("div", {
      class: `${e28}-color-picker-input__mode`,
      onClick: this.onUpdateMode,
      style: {
        cursor: a3.length === 1 ? "" : "pointer"
      }
    }, this.mode.toUpperCase() + (this.showAlpha ? "A" : "")), h$1R(d$1u, null, {
      default: () => {
        const {
          mode: l3,
          valueArr: r3,
          showAlpha: t3
        } = this;
        if (l3 === "hex") {
          let u3 = null;
          try {
            u3 = r3 === null ? null : (t3 ? X$m : Y$m)(r3);
          } catch {
          }
          return h$1R(k$k, {
            label: "HEX",
            showAlpha: t3,
            value: u3,
            onUpdateValue: (n3) => {
              this.handleUnitUpdateValue(0, n3);
            }
          });
        }
        return (l3 + (t3 ? "a" : "")).split("").map((u3, n3) => h$1R(k$k, {
          label: u3.toUpperCase(),
          value: r3 === null ? null : r3[n3],
          onUpdateValue: (p3) => {
            this.handleUnitUpdateValue(n3, p3);
          }
        }));
      }
    }));
  }
});
const m$14 = defineComponent({
  name: "ColorPickerTrigger",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: null
    },
    hsla: {
      type: Array,
      default: null
    },
    disabled: Boolean,
    onClick: Function
  },
  setup(c3) {
    const {
      colorPickerSlots: n3,
      renderLabelRef: a3
    } = inject(c$15, null);
    return () => {
      const {
        hsla: e28,
        value: o3,
        clsPrefix: r3,
        onClick: s3,
        disabled: i
      } = c3, t3 = n3.label || a3.value;
      return h$1R("div", {
        class: [`${r3}-color-picker-trigger`, i && `${r3}-color-picker-trigger--disabled`],
        onClick: i ? void 0 : s3
      }, h$1R("div", {
        class: `${r3}-color-picker-trigger__fill`
      }, h$1R("div", {
        class: `${r3}-color-picker-checkboard`
      }), h$1R("div", {
        style: {
          position: "absolute",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          backgroundColor: e28 ? W$q(e28) : ""
        }
      }), o3 && e28 ? h$1R("div", {
        class: `${r3}-color-picker-trigger__value`,
        style: {
          color: e28[2] > 50 || e28[3] < 0.5 ? "black" : "white"
        }
      }, t3 ? t3(o3) : o3) : null));
    };
  }
});
function y$p(e28, t3) {
  if (t3 === "hsv") {
    const [c3, i, l3, r3] = B$S(e28);
    return D$L([...c$16(c3, i, l3), r3]);
  }
  return e28;
}
function g$A(e28) {
  const t3 = document.createElement("canvas").getContext("2d");
  return t3 ? (t3.fillStyle = e28, t3.fillStyle) : "#000000";
}
const $$5 = defineComponent({
  name: "ColorPickerSwatches",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    swatches: {
      type: Array,
      required: true
    },
    onUpdateColor: {
      type: Function,
      required: true
    }
  },
  setup(e28) {
    const t3 = computed(() => e28.swatches.map((r3) => {
      const o3 = H$a(r3);
      return {
        value: r3,
        mode: o3,
        legalValue: y$p(r3, o3)
      };
    }));
    function c3(r3) {
      const {
        mode: o3
      } = e28;
      let {
        value: n3,
        mode: a3
      } = r3;
      return a3 || (a3 = "hex", /^[a-zA-Z]+$/.test(n3) ? n3 = g$A(n3) : (s$2a("color-picker", `color ${n3} in swatches is invalid.`), n3 = "#000000")), a3 === o3 ? n3 : N$l(n3, o3, a3);
    }
    function i(r3) {
      e28.onUpdateColor(c3(r3));
    }
    function l3(r3, o3) {
      r3.key === "Enter" && i(o3);
    }
    return {
      parsedSwatchesRef: t3,
      handleSwatchSelect: i,
      handleSwatchKeyDown: l3
    };
  },
  render() {
    const {
      clsPrefix: e28
    } = this;
    return h$1R("div", {
      class: `${e28}-color-picker-swatches`
    }, this.parsedSwatchesRef.map((t3) => h$1R("div", {
      class: `${e28}-color-picker-swatch`,
      tabindex: 0,
      onClick: () => {
        this.handleSwatchSelect(t3);
      },
      onKeydown: (c3) => {
        this.handleSwatchKeyDown(c3, t3);
      }
    }, h$1R("div", {
      class: `${e28}-color-picker-swatch__fill`,
      style: {
        background: t3.legalValue
      }
    }))));
  }
});
const u$X = defineComponent({
  name: "ColorPreview",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: null,
      validator: (e28) => {
        const o3 = H$a(e28);
        return !!(!e28 || o3 && o3 !== "hsv");
      }
    },
    onUpdateColor: {
      type: Function,
      required: true
    }
  },
  setup(e28) {
    function o3(n3) {
      var r3;
      const l3 = n3.target.value;
      (r3 = e28.onUpdateColor) === null || r3 === void 0 || r3.call(e28, N$l(l3.toUpperCase(), e28.mode, "hex")), n3.stopPropagation();
    }
    return {
      handleChange: o3
    };
  },
  render() {
    const {
      clsPrefix: e28
    } = this;
    return h$1R("div", {
      class: `${e28}-color-picker-preview__preview`
    }, h$1R("span", {
      class: `${e28}-color-picker-preview__fill`,
      style: {
        background: this.color || "#000000"
      }
    }), h$1R("input", {
      class: `${e28}-color-picker-preview__input`,
      type: "color",
      value: this.color,
      onChange: this.handleChange
    }));
  }
});
const p$2O = r$2a([l$25("color-picker", `
 display: inline-block;
 box-sizing: border-box;
 height: var(--n-height);
 font-size: var(--n-font-size);
 width: 100%;
 position: relative;
 `), l$25("color-picker-panel", `
 margin: 4px 0;
 width: 240px;
 font-size: var(--n-panel-font-size);
 color: var(--n-text-color);
 background-color: var(--n-color);
 transition:
 box-shadow .3s var(--n-bezier),
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 border-radius: var(--n-border-radius);
 box-shadow: var(--n-box-shadow);
 `, [$$n(), l$25("input", `
 text-align: center;
 `)]), l$25("color-picker-checkboard", `
 background: white; 
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [r$2a("&::after", `
 background-image: linear-gradient(45deg, #DDD 25%, #0000 25%), linear-gradient(-45deg, #DDD 25%, #0000 25%), linear-gradient(45deg, #0000 75%, #DDD 75%), linear-gradient(-45deg, #0000 75%, #DDD 75%);
 background-size: 12px 12px;
 background-position: 0 0, 0 6px, 6px -6px, -6px 0px;
 background-repeat: repeat;
 content: "";
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `)]), l$25("color-picker-slider", `
 margin-bottom: 8px;
 position: relative;
 box-sizing: border-box;
 `, [M$y("image", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `), r$2a("&::after", `
 content: "";
 position: absolute;
 border-radius: inherit;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 box-shadow: inset 0 0 2px 0 rgba(0, 0, 0, .24);
 pointer-events: none;
 `)]), l$25("color-picker-handle", `
 z-index: 1;
 box-shadow: 0 0 2px 0 rgba(0, 0, 0, .45);
 position: absolute;
 background-color: white;
 overflow: hidden;
 `, [M$y("fill", `
 box-sizing: border-box;
 border: 2px solid white;
 `)]), l$25("color-picker-pallete", `
 height: 180px;
 position: relative;
 margin-bottom: 8px;
 cursor: crosshair;
 `, [M$y("layer", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [g$1j("shadowed", `
 box-shadow: inset 0 0 2px 0 rgba(0, 0, 0, .24);
 `)])]), l$25("color-picker-preview", `
 display: flex;
 `, [M$y("sliders", `
 flex: 1 0 auto;
 `), M$y("preview", `
 position: relative;
 height: 30px;
 width: 30px;
 margin: 0 0 8px 6px;
 border-radius: 50%;
 box-shadow: rgba(0, 0, 0, .15) 0px 0px 0px 1px inset;
 overflow: hidden;
 `), M$y("fill", `
 display: block;
 width: 30px;
 height: 30px;
 `), M$y("input", `
 position: absolute;
 top: 0;
 left: 0;
 width: 30px;
 height: 30px;
 opacity: 0;
 z-index: 1;
 `)]), l$25("color-picker-input", `
 display: flex;
 align-items: center;
 `, [l$25("input", `
 flex-grow: 1;
 flex-basis: 0;
 `), M$y("mode", `
 width: 72px;
 text-align: center;
 `)]), l$25("color-picker-control", `
 padding: 12px;
 `), l$25("color-picker-action", `
 display: flex;
 margin-top: -4px;
 border-top: 1px solid var(--n-divider-color);
 padding: 8px 12px;
 justify-content: flex-end;
 `, [l$25("button", "margin-left: 8px;")]), l$25("color-picker-trigger", `
 border: var(--n-border);
 height: 100%;
 box-sizing: border-box;
 border-radius: var(--n-border-radius);
 transition: border-color .3s var(--n-bezier);
 cursor: pointer;
 `, [M$y("value", `
 white-space: nowrap;
 position: relative;
 `), M$y("fill", `
 border-radius: var(--n-border-radius);
 position: absolute;
 display: flex;
 align-items: center;
 justify-content: center;
 left: 4px;
 right: 4px;
 top: 4px;
 bottom: 4px;
 `), g$1j("disabled", "cursor: not-allowed"), l$25("color-picker-checkboard", `
 border-radius: var(--n-border-radius);
 `, [r$2a("&::after", `
 --n-block-size: calc((var(--n-height) - 8px) / 3);
 background-size: calc(var(--n-block-size) * 2) calc(var(--n-block-size) * 2);
 background-position: 0 0, 0 var(--n-block-size), var(--n-block-size) calc(-1 * var(--n-block-size)), calc(-1 * var(--n-block-size)) 0px; 
 `)])]), l$25("color-picker-swatches", `
 display: grid;
 grid-gap: 8px;
 flex-wrap: wrap;
 position: relative;
 grid-template-columns: repeat(auto-fill, 18px);
 margin-top: 10px;
 `, [l$25("color-picker-swatch", `
 width: 18px;
 height: 18px;
 background-image: linear-gradient(45deg, #DDD 25%, #0000 25%), linear-gradient(-45deg, #DDD 25%, #0000 25%), linear-gradient(45deg, #0000 75%, #DDD 75%), linear-gradient(-45deg, #0000 75%, #DDD 75%);
 background-size: 8px 8px;
 background-position: 0px 0, 0px 4px, 4px -4px, -4px 0px;
 background-repeat: repeat;
 `, [M$y("fill", `
 position: relative;
 width: 100%;
 height: 100%;
 border-radius: 3px;
 box-shadow: rgba(0, 0, 0, .15) 0px 0px 0px 1px inset;
 cursor: pointer;
 `), r$2a("&:focus", `
 outline: none;
 `, [M$y("fill", [r$2a("&::after", `
 position: absolute;
 top: 0;
 right: 0;
 bottom: 0;
 left: 0;
 background: inherit;
 filter: blur(2px);
 content: "";
 `)])])])])]);
const L$i = (o3) => {
  const {
    fontSize: r3,
    boxShadow2: t3,
    popoverColor: e28,
    textColor2: i,
    borderRadius: m3,
    borderColor: n3,
    heightSmall: l3,
    heightMedium: h3,
    heightLarge: c3,
    fontSizeSmall: a3,
    fontSizeMedium: d3,
    fontSizeLarge: p3,
    dividerColor: f3
  } = o3;
  return {
    panelFontSize: r3,
    boxShadow: t3,
    color: e28,
    textColor: i,
    borderRadius: m3,
    border: `1px solid ${n3}`,
    heightSmall: l3,
    heightMedium: h3,
    heightLarge: c3,
    fontSizeSmall: a3,
    fontSizeMedium: d3,
    fontSizeLarge: p3,
    dividerColor: f3
  };
}, b$t = G$w({
  name: "ColorPicker",
  common: d$1T,
  peers: {
    Input: k$H,
    Button: B$P
  },
  self: L$i
}), P$r = b$t;
const vo$1 = Object.assign(Object.assign({}, _$F.props), {
  value: String,
  show: {
    type: Boolean,
    default: void 0
  },
  defaultShow: Boolean,
  defaultValue: String,
  modes: {
    type: Array,
    default: () => ["rgb", "hex", "hsl"]
  },
  placement: {
    type: String,
    default: "bottom-start"
  },
  to: f$1m.propTo,
  showAlpha: {
    type: Boolean,
    default: true
  },
  showPreview: Boolean,
  swatches: Array,
  disabled: {
    type: Boolean,
    default: void 0
  },
  actions: {
    type: Array,
    default: null
  },
  internalActions: Array,
  size: String,
  renderLabel: Function,
  onComplete: Function,
  onConfirm: Function,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array]
}), No$1 = defineComponent({
  name: "ColorPicker",
  props: vo$1,
  setup(r3, {
    slots: y3
  }) {
    const P3 = ref$1(null);
    let B3 = null;
    const $3 = h$1B(r3), {
      mergedSizeRef: ae2,
      mergedDisabledRef: pe2
    } = $3, {
      localeRef: I3
    } = R$p("global"), {
      mergedClsPrefixRef: j3,
      namespaceRef: be2,
      inlineThemeDisabled: _3
    } = a$2x(r3), L3 = _$F("ColorPicker", "-color-picker", p$2O, P$r, r3, j3);
    provide(c$15, {
      themeRef: L3,
      renderLabelRef: toRef$1(r3, "renderLabel"),
      colorPickerSlots: y3
    });
    const ne2 = ref$1(r3.defaultShow), se2 = d$1S(toRef$1(r3, "show"), ne2);
    function H3(e28) {
      const {
        onUpdateShow: o3,
        "onUpdate:show": a3
      } = r3;
      o3 && i$1Z(o3, e28), a3 && i$1Z(a3, e28), ne2.value = e28;
    }
    const {
      defaultValue: ie2
    } = r3, ue2 = ref$1(ie2 === void 0 ? z$9(r3.modes, r3.showAlpha) : ie2), c3 = d$1S(toRef$1(r3, "value"), ue2), A3 = ref$1([c3.value]), g3 = ref$1(0), E3 = computed(() => H$a(c3.value)), {
      modes: we2
    } = r3, m3 = ref$1(H$a(c3.value) || we2[0] || "rgb");
    function ke2() {
      const {
        modes: e28
      } = r3, {
        value: o3
      } = m3, a3 = e28.findIndex((n3) => n3 === o3);
      ~a3 ? m3.value = e28[(a3 + 1) % e28.length] : m3.value = "rgb";
    }
    let f3, h3, V10, U3, k3, C3, S3, v3;
    const F3 = computed(() => {
      const {
        value: e28
      } = c3;
      if (!e28)
        return null;
      switch (E3.value) {
        case "hsv":
          return B$S(e28);
        case "hsl":
          return [f3, h3, V10, v3] = q$D(e28), [...u$Y(f3, h3, V10), v3];
        case "rgb":
        case "hex":
          return [k3, C3, S3, v3] = p$3J(e28), [...o$Q(k3, C3, S3), v3];
      }
    }), R3 = computed(() => {
      const {
        value: e28
      } = c3;
      if (!e28)
        return null;
      switch (E3.value) {
        case "rgb":
        case "hex":
          return p$3J(e28);
        case "hsv":
          return [f3, h3, U3, v3] = B$S(e28), [...c$16(f3, h3, U3), v3];
        case "hsl":
          return [f3, h3, V10, v3] = q$D(e28), [...s$10(f3, h3, V10), v3];
      }
    }), K3 = computed(() => {
      const {
        value: e28
      } = c3;
      if (!e28)
        return null;
      switch (E3.value) {
        case "hsl":
          return q$D(e28);
        case "hsv":
          return [f3, h3, U3, v3] = B$S(e28), [...M$b(f3, h3, U3), v3];
        case "rgb":
        case "hex":
          return [k3, C3, S3, v3] = p$3J(e28), [...f$F(k3, C3, S3), v3];
      }
    }), Ce2 = computed(() => {
      switch (m3.value) {
        case "rgb":
        case "hex":
          return R3.value;
        case "hsv":
          return F3.value;
        case "hsl":
          return K3.value;
      }
    }), O3 = ref$1(0), N3 = ref$1(1), q3 = ref$1([0, 0]);
    function Se2(e28, o3) {
      const {
        value: a3
      } = F3, n3 = O3.value, s3 = a3 ? a3[3] : 1;
      q3.value = [e28, o3];
      const {
        showAlpha: l3
      } = r3;
      switch (m3.value) {
        case "hsv":
          i((l3 ? Q$s : O$B)([n3, e28, o3, s3]), "cursor");
          break;
        case "hsl":
          i((l3 ? W$q : T$N)([...M$b(n3, e28, o3), s3]), "cursor");
          break;
        case "rgb":
          i((l3 ? D$L : L$I)([...c$16(n3, e28, o3), s3]), "cursor");
          break;
        case "hex":
          i((l3 ? X$m : Y$m)([...c$16(n3, e28, o3), s3]), "cursor");
          break;
      }
    }
    function Re2(e28) {
      O3.value = e28;
      const {
        value: o3
      } = F3;
      if (!o3)
        return;
      const [, a3, n3, s3] = o3, {
        showAlpha: l3
      } = r3;
      switch (m3.value) {
        case "hsv":
          i((l3 ? Q$s : O$B)([e28, a3, n3, s3]), "cursor");
          break;
        case "rgb":
          i((l3 ? D$L : L$I)([...c$16(e28, a3, n3), s3]), "cursor");
          break;
        case "hex":
          i((l3 ? X$m : Y$m)([...c$16(e28, a3, n3), s3]), "cursor");
          break;
        case "hsl":
          i((l3 ? W$q : T$N)([...M$b(e28, a3, n3), s3]), "cursor");
          break;
      }
    }
    function xe2(e28) {
      switch (m3.value) {
        case "hsv":
          [f3, h3, U3] = F3.value, i(Q$s([f3, h3, U3, e28]), "cursor");
          break;
        case "rgb":
          [k3, C3, S3] = R3.value, i(D$L([k3, C3, S3, e28]), "cursor");
          break;
        case "hex":
          [k3, C3, S3] = R3.value, i(X$m([k3, C3, S3, e28]), "cursor");
          break;
        case "hsl":
          [f3, h3, V10] = K3.value, i(W$q([f3, h3, V10, e28]), "cursor");
          break;
      }
      N3.value = e28;
    }
    function i(e28, o3) {
      o3 === "cursor" ? B3 = e28 : B3 = null;
      const {
        nTriggerFormChange: a3,
        nTriggerFormInput: n3
      } = $3, {
        onUpdateValue: s3,
        "onUpdate:value": l3
      } = r3;
      s3 && i$1Z(s3, e28), l3 && i$1Z(l3, e28), a3(), n3(), ue2.value = e28;
    }
    function ye2(e28) {
      i(e28, "input"), nextTick(T3);
    }
    function T3(e28 = true) {
      const {
        value: o3
      } = c3;
      if (o3) {
        const {
          nTriggerFormChange: a3,
          nTriggerFormInput: n3
        } = $3, {
          onComplete: s3
        } = r3;
        s3 && s3(o3);
        const {
          value: l3
        } = A3, {
          value: d3
        } = g3;
        e28 && (l3.splice(d3 + 1, l3.length, o3), g3.value = d3 + 1), a3(), n3();
      }
    }
    function Pe2() {
      const {
        value: e28
      } = g3;
      e28 - 1 < 0 || (i(A3.value[e28 - 1], "input"), T3(false), g3.value = e28 - 1);
    }
    function Ae2() {
      const {
        value: e28
      } = g3;
      e28 < 0 || e28 + 1 >= A3.value.length || (i(A3.value[e28 + 1], "input"), T3(false), g3.value = e28 + 1);
    }
    function Ve2() {
      i(null, "input"), H3(false);
    }
    function Ue2() {
      const {
        value: e28
      } = c3, {
        onConfirm: o3
      } = r3;
      o3 && o3(e28), H3(false);
    }
    const Te2 = computed(() => g3.value >= 1), Be2 = computed(() => {
      const {
        value: e28
      } = A3;
      return e28.length > 1 && g3.value < e28.length - 1;
    });
    watch(se2, (e28) => {
      e28 || (A3.value = [c3.value], g3.value = 0);
    }), watchEffect(() => {
      if (!(B3 && B3 === c3.value)) {
        const {
          value: e28
        } = F3;
        e28 && (O3.value = e28[0], N3.value = e28[3], q3.value = [e28[1], e28[2]]);
      }
      B3 = null;
    });
    const G3 = computed(() => {
      const {
        value: e28
      } = ae2, {
        common: {
          cubicBezierEaseInOut: o3
        },
        self: {
          textColor: a3,
          color: n3,
          panelFontSize: s3,
          boxShadow: l3,
          border: d3,
          borderRadius: u3,
          dividerColor: x3,
          [_$H("height", e28)]: ze2,
          [_$H("fontSize", e28)]: Ie2
        }
      } = L3.value;
      return {
        "--n-bezier": o3,
        "--n-text-color": a3,
        "--n-color": n3,
        "--n-panel-font-size": s3,
        "--n-font-size": Ie2,
        "--n-box-shadow": l3,
        "--n-border": d3,
        "--n-border-radius": u3,
        "--n-height": ze2,
        "--n-divider-color": x3
      };
    }), p3 = _3 ? E$J("color-picker", computed(() => ae2.value[0]), G3, r3) : void 0;
    function Fe2() {
      var e28;
      const {
        value: o3
      } = R3, {
        value: a3
      } = O3, {
        internalActions: n3,
        modes: s3,
        actions: l3
      } = r3, {
        value: d3
      } = L3, {
        value: u3
      } = j3;
      return h$1R("div", {
        class: [`${u3}-color-picker-panel`, p3 == null ? void 0 : p3.themeClass.value],
        onDragstart: (x3) => {
          x3.preventDefault();
        },
        style: _3 ? void 0 : G3.value
      }, h$1R("div", {
        class: `${u3}-color-picker-control`
      }, h$1R(C$z, {
        clsPrefix: u3,
        rgba: o3,
        displayedHue: a3,
        displayedSv: q3.value,
        onUpdateSV: Se2,
        onComplete: T3
      }), h$1R("div", {
        class: `${u3}-color-picker-preview`
      }, h$1R("div", {
        class: `${u3}-color-picker-preview__sliders`
      }, h$1R(H$9, {
        clsPrefix: u3,
        hue: a3,
        onUpdateHue: Re2,
        onComplete: T3
      }), r3.showAlpha ? h$1R(_$f, {
        clsPrefix: u3,
        rgba: o3,
        alpha: N3.value,
        onUpdateAlpha: xe2,
        onComplete: T3
      }) : null), r3.showPreview ? h$1R(u$X, {
        clsPrefix: u3,
        mode: m3.value,
        color: R3.value && Y$m(R3.value),
        onUpdateColor: (x3) => {
          i(x3, "input");
        }
      }) : null), h$1R(x$f, {
        clsPrefix: u3,
        showAlpha: r3.showAlpha,
        mode: m3.value,
        modes: s3,
        onUpdateMode: ke2,
        value: c3.value,
        valueArr: Ce2.value,
        onUpdateValue: ye2
      }), ((e28 = r3.swatches) === null || e28 === void 0 ? void 0 : e28.length) && h$1R($$5, {
        clsPrefix: u3,
        mode: m3.value,
        swatches: r3.swatches,
        onUpdateColor: (x3) => {
          i(x3, "input");
        }
      })), l3 != null && l3.length ? h$1R("div", {
        class: `${u3}-color-picker-action`
      }, l3.includes("confirm") && h$1R(le$g, {
        size: "small",
        onClick: Ue2,
        theme: d3.peers.Button,
        themeOverrides: d3.peerOverrides.Button
      }, {
        default: () => I3.value.confirm
      }), l3.includes("clear") && h$1R(le$g, {
        size: "small",
        onClick: Ve2,
        disabled: !c3.value,
        theme: d3.peers.Button,
        themeOverrides: d3.peerOverrides.Button
      }, {
        default: () => I3.value.clear
      })) : null, y3.action ? h$1R("div", {
        class: `${u3}-color-picker-action`
      }, {
        default: y3.action
      }) : n3 ? h$1R("div", {
        class: `${u3}-color-picker-action`
      }, n3.includes("undo") && h$1R(le$g, {
        size: "small",
        onClick: Pe2,
        disabled: !Te2.value,
        theme: d3.peers.Button,
        themeOverrides: d3.peerOverrides.Button
      }, {
        default: () => I3.value.undo
      }), n3.includes("redo") && h$1R(le$g, {
        size: "small",
        onClick: Ae2,
        disabled: !Be2.value,
        theme: d3.peers.Button,
        themeOverrides: d3.peerOverrides.Button
      }, {
        default: () => I3.value.redo
      })) : null);
    }
    return {
      mergedClsPrefix: j3,
      namespace: be2,
      selfRef: P3,
      hsla: K3,
      rgba: R3,
      mergedShow: se2,
      mergedDisabled: pe2,
      isMounted: u$1C(),
      adjustedTo: f$1m(r3),
      mergedValue: c3,
      handleTriggerClick() {
        H3(true);
      },
      handleClickOutside(e28) {
        var o3;
        !((o3 = P3.value) === null || o3 === void 0) && o3.contains(t$1G(e28)) || H3(false);
      },
      renderPanel: Fe2,
      cssVars: _3 ? void 0 : G3,
      themeClass: p3 == null ? void 0 : p3.themeClass,
      onRender: p3 == null ? void 0 : p3.onRender
    };
  },
  render() {
    const {
      $slots: r3,
      mergedClsPrefix: y3,
      onRender: P3
    } = this;
    return P3 == null || P3(), h$1R("div", {
      class: [this.themeClass, `${y3}-color-picker`],
      ref: "selfRef",
      style: this.cssVars
    }, h$1R(F$x, null, {
      default: () => [h$1R(g$19, null, {
        default: () => h$1R(m$14, {
          clsPrefix: y3,
          value: this.mergedValue,
          hsla: this.hsla,
          disabled: this.mergedDisabled,
          onClick: this.handleTriggerClick
        }, {
          label: r3.label
        })
      }), h$1R(me$h, {
        placement: this.placement,
        show: this.mergedShow,
        containerClass: this.namespace,
        teleportDisabled: this.adjustedTo === f$1m.tdkey,
        to: this.adjustedTo
      }, {
        default: () => h$1R(Transition, {
          name: "fade-in-scale-up-transition",
          appear: this.isMounted
        }, {
          default: () => this.mergedShow ? withDirectives(this.renderPanel(), [[a$2i, this.handleClickOutside, void 0, {
            capture: true
          }]]) : null
        })
      })]
    }));
  }
});
const h$T = defineComponent({
  name: "UIColorPicker",
  inheritAttrs: false,
  components: { NColorPicker: No$1 }
}), v$v = defineComponent(__spreadProps(__spreadValues({}, h$T), {
  props: {
    placement: {
      type: String,
      default: "bottom"
    },
    compact: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: void 0
    },
    enableAlpha: {
      type: Boolean,
      default: true
    },
    defaultShow: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    modes: {
      type: Array,
      default: void 0
    },
    customTrigger: {
      type: Function,
      default: void 0
    },
    defaultValue: {
      type: String,
      default: "#000"
    },
    value: {
      type: String,
      default: null
    },
    swatches: {
      type: Array,
      default: void 0
    },
    to: {
      type: [String, HTMLElement, Boolean],
      default: "body"
    }
  },
  emits: ["onComplete", "update:value"],
  setup(e28, { emit: u3 }) {
    const s3 = e28, r3 = (o3) => {
      if (s3.compact)
        return h$1R("div", {
          class: "ghl-color-preview",
          style: {
            "background-color": o3 != null ? o3 : "#000",
            width: "24px",
            height: "24px",
            "border-radius": "50%",
            outline: "#00000069 solid 1px",
            padding: "2px"
          }
        });
    }, a3 = u3;
    return (o3, t3) => {
      var _a2;
      return openBlock(), createBlock(unref(No$1), {
        class: normalizeClass(e28.compact || e28.customTrigger ? "compact-picker" : ""),
        placement: e28.placement,
        "render-label": (_a2 = e28.customTrigger) != null ? _a2 : r3,
        value: e28.value,
        "default-value": e28.defaultValue,
        "default-show": e28.defaultShow,
        show: e28.show,
        "show-alpha": e28.enableAlpha,
        to: e28.to,
        disabled: e28.disabled,
        swatches: e28.swatches,
        modes: e28.modes,
        onComplete: t3[0] || (t3[0] = (l3) => a3("onComplete", l3)),
        "onUpdate:value": t3[1] || (t3[1] = (l3) => a3("update:value", l3))
      }, null, 8, ["class", "placement", "render-label", "value", "default-value", "default-show", "show", "show-alpha", "to", "disabled", "swatches", "modes"]);
    };
  }
})), g$z = v$v;
const o$P = {
  name: "common",
  common: {
    name: "common",
    fontFamily: 'Inter var, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji""',
    fontFamilyMono: "v-mono, SFMono-Regular, Menlo, Consolas, Courier, monospace",
    fontWeight: "400",
    fontWeightStrong: "500",
    cubicBezierEaseInOut: "cubic-bezier(.4, 0, .2, 1)",
    cubicBezierEaseOut: "cubic-bezier(0, 0, .2, 1)",
    cubicBezierEaseIn: "cubic-bezier(.4, 0, 1, 1)",
    borderRadius: "3px",
    borderRadiusSmall: "2px",
    fontSize: "14px",
    fontSizeMini: "12px",
    fontSizeTiny: "12px",
    fontSizeSmall: "14px",
    fontSizeMedium: "14px",
    fontSizeLarge: "15px",
    fontSizeHuge: "16px",
    lineHeight: "1.6",
    heightMini: "16px",
    heightTiny: "22px",
    heightSmall: "28px",
    heightMedium: "34px",
    heightLarge: "40px",
    heightHuge: "46px",
    baseColor: "#FFF",
    primaryColor: "#155EEF",
    primaryColorHover: "#004EEB",
    primaryColorPressed: "#155EEF",
    primaryColorSuppl: "#155EEF",
    infoColor: "#2080f0",
    infoColorHover: "#4098fc",
    infoColorPressed: "#1060c9",
    infoColorSuppl: "#4098fc",
    successColor: "#155EEF",
    successColorHover: "#155EEF",
    successColorPressed: "#004EEB",
    successColorSuppl: "#155EEF",
    warningColor: "#f0a020",
    warningColorHover: "#fcb040",
    warningColorPressed: "#c97c10",
    warningColorSuppl: "#fcb040",
    errorColor: "#D92D20",
    errorColorHover: "#B42318",
    errorColorPressed: "#D92D20",
    errorColorSuppl: "#D92D20",
    textColorBase: "#000",
    textColor1: "rgba(16, 24, 40, 1)",
    textColor2: "rgba(52, 64, 84, 1)",
    textColor3: "rgb(118, 124, 130)",
    textColorDisabled: "rgba(194, 194, 194, 1)",
    placeholderColor: "rgba(102, 112, 133, 1)",
    placeholderColorDisabled: "rgba(209, 209, 209, 1)",
    iconColor: "rgba(194, 194, 194, 1)",
    iconColorHover: "rgba(146, 146, 146, 1)",
    iconColorPressed: "rgba(175, 175, 175, 1)",
    iconColorDisabled: "rgba(209, 209, 209, 1)",
    opacity1: "0.82",
    opacity2: "0.72",
    opacity3: "0.38",
    opacity4: "0.24",
    opacity5: "0.18",
    dividerColor: "rgb(239, 239, 245)",
    borderColor: "rgb(224, 224, 230)",
    closeIconColor: "rgba(102, 102, 102, 1)",
    closeIconColorHover: "rgba(102, 102, 102, 1)",
    closeIconColorPressed: "rgba(102, 102, 102, 1)",
    closeColorHover: "rgba(0, 0, 0, .09)",
    closeColorPressed: "rgba(0, 0, 0, .13)",
    clearColor: "rgba(194, 194, 194, 1)",
    clearColorHover: "rgba(146, 146, 146, 1)",
    clearColorPressed: "rgba(175, 175, 175, 1)",
    scrollbarColor: "rgba(0, 0, 0, 0.25)",
    scrollbarColorHover: "rgba(0, 0, 0, 0.4)",
    scrollbarWidth: "5px",
    scrollbarHeight: "5px",
    scrollbarBorderRadius: "5px",
    progressRailColor: "rgba(235, 235, 235, 1)",
    railColor: "rgb(219, 219, 223)",
    popoverColor: "#fff",
    tableColor: "#fff",
    cardColor: "#fff",
    modalColor: "#fff",
    bodyColor: "#fff",
    tagColor: "#eee",
    avatarColor: "rgba(204, 204, 204, 1)",
    invertedColor: "rgb(0, 20, 40)",
    inputColor: "rgba(255, 255, 255, 1)",
    codeColor: "rgb(244, 244, 248)",
    tabColor: "rgb(247, 247, 250)",
    actionColor: "rgb(250, 250, 252)",
    tableHeaderColor: "rgb(250, 250, 252)",
    hoverColor: "rgb(243, 243, 245)",
    tableColorHover: "rgba(0, 0, 100, 0.03)",
    tableColorStriped: "rgba(0, 0, 100, 0.02)",
    pressedColor: "rgb(237, 237, 239)",
    opacityDisabled: "0.5",
    inputColorDisabled: "rgb(250, 250, 252)",
    buttonColor2: "rgba(46, 51, 56, .05)",
    buttonColor2Hover: "rgba(46, 51, 56, .09)",
    buttonColor2Pressed: "rgba(46, 51, 56, .13)",
    boxShadow1: "0 1px 2px -2px rgba(0, 0, 0, .08), 0 3px 6px 0 rgba(0, 0, 0, .06), 0 5px 12px 4px rgba(0, 0, 0, .04)",
    boxShadow2: "0 3px 6px -4px rgba(0, 0, 0, .12), 0 6px 16px 0 rgba(0, 0, 0, .08), 0 9px 28px 8px rgba(0, 0, 0, .05)",
    boxShadow3: "0 6px 16px -9px rgba(0, 0, 0, .08), 0 9px 28px 0 rgba(0, 0, 0, .05), 0 12px 48px 16px rgba(0, 0, 0, .03)"
  }
}, r$R = {
  Notification: {
    common: {
      successColor: "#039855",
      infoColor: "#155EEF",
      warningColor: "#DC6803",
      errorColor: "#D92D20"
    }
  },
  Badge: {
    common: {
      successColor: "var(--success-600)",
      infoColor: "var(--primary-600)"
    }
  }
};
const m$13 = {
  name: i$1i.englishUS,
  locale: s$1J
};
const N$k = {
  abstract: Boolean,
  bordered: {
    type: Boolean,
    default: void 0
  },
  clsPrefix: {
    type: String,
    default: u$1$
  },
  locale: Object,
  dateLocale: Object,
  namespace: String,
  rtl: Array,
  tag: {
    type: String,
    default: "div"
  },
  hljs: Object,
  katex: Object,
  theme: Object,
  themeOverrides: Object,
  componentOptions: Object,
  icons: Object,
  breakpoints: Object,
  preflightStyleDisabled: Boolean,
  inlineThemeDisabled: {
    type: Boolean,
    default: void 0
  },
  as: {
    type: String,
    validator: () => (s$2a("config-provider", "`as` is deprecated, please use `tag` instead."), true),
    default: void 0
  }
}, E$e = defineComponent({
  name: "ConfigProvider",
  alias: ["App"],
  props: N$k,
  setup(r3) {
    const e28 = inject(n$27, null), a3 = computed(() => {
      const {
        theme: n3
      } = r3;
      if (n3 === null)
        return;
      const d3 = e28 == null ? void 0 : e28.mergedThemeRef.value;
      return n3 === void 0 ? d3 : d3 === void 0 ? n3 : Object.assign({}, d3, n3);
    }), t3 = computed(() => {
      const {
        themeOverrides: n3
      } = r3;
      if (n3 !== null) {
        if (n3 === void 0)
          return e28 == null ? void 0 : e28.mergedThemeOverridesRef.value;
        {
          const d3 = e28 == null ? void 0 : e28.mergedThemeOverridesRef.value;
          return d3 === void 0 ? n3 : g$1f({}, d3, n3);
        }
      }
    }), f3 = n$1U(() => {
      const {
        namespace: n3
      } = r3;
      return n3 === void 0 ? e28 == null ? void 0 : e28.mergedNamespaceRef.value : n3;
    }), m3 = n$1U(() => {
      const {
        bordered: n3
      } = r3;
      return n3 === void 0 ? e28 == null ? void 0 : e28.mergedBorderedRef.value : n3;
    }), R3 = computed(() => {
      const {
        icons: n3
      } = r3;
      return n3 === void 0 ? e28 == null ? void 0 : e28.mergedIconsRef.value : n3;
    }), O3 = computed(() => {
      const {
        componentOptions: n3
      } = r3;
      return n3 !== void 0 ? n3 : e28 == null ? void 0 : e28.mergedComponentPropsRef.value;
    }), c3 = computed(() => {
      const {
        clsPrefix: n3
      } = r3;
      return n3 !== void 0 ? n3 : e28 ? e28.mergedClsPrefixRef.value : u$1$;
    }), p3 = computed(() => {
      var n3;
      const {
        rtl: d3
      } = r3;
      if (d3 === void 0)
        return e28 == null ? void 0 : e28.mergedRtlRef.value;
      const l3 = {};
      for (const o3 of d3)
        l3[o3.name] = markRaw(o3), (n3 = o3.peers) === null || n3 === void 0 || n3.forEach((u3) => {
          u3.name in l3 || (l3[u3.name] = markRaw(u3));
        });
      return l3;
    }), j3 = computed(() => r3.breakpoints || (e28 == null ? void 0 : e28.mergedBreakpointsRef.value)), T3 = r3.inlineThemeDisabled || (e28 == null ? void 0 : e28.inlineThemeDisabled), y3 = r3.preflightStyleDisabled || (e28 == null ? void 0 : e28.preflightStyleDisabled), P3 = computed(() => {
      const {
        value: n3
      } = a3, {
        value: d3
      } = t3, l3 = d3 && Object.keys(d3).length !== 0, o3 = n3 == null ? void 0 : n3.name;
      return o3 ? l3 ? `${o3}-${c$2c(JSON.stringify(t3.value))}` : o3 : l3 ? c$2c(JSON.stringify(t3.value)) : "";
    });
    return provide(n$27, {
      mergedThemeHashRef: P3,
      mergedBreakpointsRef: j3,
      mergedRtlRef: p3,
      mergedIconsRef: R3,
      mergedComponentPropsRef: O3,
      mergedBorderedRef: m3,
      mergedNamespaceRef: f3,
      mergedClsPrefixRef: c3,
      mergedLocaleRef: computed(() => {
        const {
          locale: n3
        } = r3;
        if (n3 !== null)
          return n3 === void 0 ? e28 == null ? void 0 : e28.mergedLocaleRef.value : n3;
      }),
      mergedDateLocaleRef: computed(() => {
        const {
          dateLocale: n3
        } = r3;
        if (n3 !== null)
          return n3 === void 0 ? e28 == null ? void 0 : e28.mergedDateLocaleRef.value : n3;
      }),
      mergedHljsRef: computed(() => {
        const {
          hljs: n3
        } = r3;
        return n3 === void 0 ? e28 == null ? void 0 : e28.mergedHljsRef.value : n3;
      }),
      mergedKatexRef: computed(() => {
        const {
          katex: n3
        } = r3;
        return n3 === void 0 ? e28 == null ? void 0 : e28.mergedKatexRef.value : n3;
      }),
      mergedThemeRef: a3,
      mergedThemeOverridesRef: t3,
      inlineThemeDisabled: T3 || false,
      preflightStyleDisabled: y3 || false
    }), {
      mergedClsPrefix: c3,
      mergedBordered: m3,
      mergedNamespace: f3,
      mergedTheme: a3,
      mergedThemeOverrides: t3
    };
  },
  render() {
    var r3, e28, a3, t3;
    return this.abstract ? (t3 = (a3 = this.$slots).default) === null || t3 === void 0 ? void 0 : t3.call(a3) : h$1R(this.as || this.tag, {
      class: `${this.mergedClsPrefix || u$1$}-config-provider`
    }, (e28 = (r3 = this.$slots).default) === null || e28 === void 0 ? void 0 : e28.call(r3));
  }
});
const n$E = n$28("n-notification-provider");
const g$y = defineComponent({
  name: "NotificationContainer",
  props: {
    scrollable: {
      type: Boolean,
      required: true
    },
    placement: {
      type: String,
      required: true
    }
  },
  setup() {
    const {
      mergedThemeRef: o3,
      mergedClsPrefixRef: n3,
      wipTransitionCountRef: i
    } = inject(n$E), e28 = ref$1(null);
    return watchEffect(() => {
      var r3, t3;
      i.value > 0 ? (r3 = e28 == null ? void 0 : e28.value) === null || r3 === void 0 || r3.classList.add("transitioning") : (t3 = e28 == null ? void 0 : e28.value) === null || t3 === void 0 || t3.classList.remove("transitioning");
    }), {
      selfRef: e28,
      mergedTheme: o3,
      mergedClsPrefix: n3,
      transitioning: i
    };
  },
  render() {
    const {
      $slots: o3,
      scrollable: n3,
      mergedClsPrefix: i,
      mergedTheme: e28,
      placement: r3
    } = this;
    return h$1R("div", {
      ref: "selfRef",
      class: [`${i}-notification-container`, n3 && `${i}-notification-container--scrollable`, `${i}-notification-container--${r3}`]
    }, n3 ? h$1R(hn$2, {
      theme: e28.peers.Scrollbar,
      themeOverrides: e28.peerOverrides.Scrollbar,
      contentStyle: {
        overflow: "hidden"
      }
    }, o3) : o3);
  }
});
const lo$1 = {
  info: () => h$1R(n$1f, null),
  success: () => h$1R(t$1g, null),
  warning: () => h$1R(C$Y, null),
  error: () => h$1R(C$X, null),
  default: () => null
}, c$14 = {
  closable: {
    type: Boolean,
    default: true
  },
  type: {
    type: String,
    default: "default"
  },
  avatar: Function,
  title: [String, Function],
  description: [String, Function],
  content: [String, Function],
  meta: [String, Function],
  action: [String, Function],
  onClose: {
    type: Function,
    required: true
  },
  keepAliveOnHover: Boolean,
  onMouseenter: Function,
  onMouseleave: Function
}, Ro$1 = t$1y(c$14), So$1 = defineComponent({
  name: "Notification",
  props: c$14,
  setup(t3) {
    const {
      mergedClsPrefixRef: o3,
      mergedThemeRef: a3,
      props: d3
    } = inject(n$E), {
      inlineThemeDisabled: r3,
      mergedRtlRef: f3
    } = a$2x(), u3 = v$17("Notification", f3, o3), l3 = computed(() => {
      const {
        type: m3
      } = t3, {
        self: {
          color: h3,
          textColor: p3,
          closeIconColor: v3,
          closeIconColorHover: C3,
          closeIconColorPressed: g3,
          headerTextColor: b3,
          descriptionTextColor: z3,
          actionTextColor: x3,
          borderRadius: y3,
          headerFontWeight: _3,
          boxShadow: R3,
          lineHeight: S3,
          fontSize: $3,
          closeMargin: F3,
          closeSize: I3,
          width: w3,
          padding: P3,
          closeIconSize: M3,
          closeBorderRadius: B3,
          closeColorHover: E3,
          closeColorPressed: T3,
          titleFontSize: k3,
          metaFontSize: H3,
          descriptionFontSize: N3,
          [_$H("iconColor", m3)]: A3
        },
        common: {
          cubicBezierEaseOut: O3,
          cubicBezierEaseIn: V10,
          cubicBezierEaseInOut: K3
        }
      } = a3.value, {
        left: j3,
        right: W3,
        top: q3,
        bottom: D3
      } = f$1f(P3);
      return {
        "--n-color": h3,
        "--n-font-size": $3,
        "--n-text-color": p3,
        "--n-description-text-color": z3,
        "--n-action-text-color": x3,
        "--n-title-text-color": b3,
        "--n-title-font-weight": _3,
        "--n-bezier": K3,
        "--n-bezier-ease-out": O3,
        "--n-bezier-ease-in": V10,
        "--n-border-radius": y3,
        "--n-box-shadow": R3,
        "--n-close-border-radius": B3,
        "--n-close-color-hover": E3,
        "--n-close-color-pressed": T3,
        "--n-close-icon-color": v3,
        "--n-close-icon-color-hover": C3,
        "--n-close-icon-color-pressed": g3,
        "--n-line-height": S3,
        "--n-icon-color": A3,
        "--n-close-margin": F3,
        "--n-close-size": I3,
        "--n-close-icon-size": M3,
        "--n-width": w3,
        "--n-padding-left": j3,
        "--n-padding-right": W3,
        "--n-padding-top": q3,
        "--n-padding-bottom": D3,
        "--n-title-font-size": k3,
        "--n-meta-font-size": H3,
        "--n-description-font-size": N3
      };
    }), i = r3 ? E$J("notification", computed(() => t3.type[0]), l3, d3) : void 0;
    return {
      mergedClsPrefix: o3,
      showAvatar: computed(() => t3.avatar || t3.type !== "default"),
      handleCloseClick() {
        t3.onClose();
      },
      rtlEnabled: u3,
      cssVars: r3 ? void 0 : l3,
      themeClass: i == null ? void 0 : i.themeClass,
      onRender: i == null ? void 0 : i.onRender
    };
  },
  render() {
    var t3;
    const {
      mergedClsPrefix: o3
    } = this;
    return (t3 = this.onRender) === null || t3 === void 0 || t3.call(this), h$1R("div", {
      class: [`${o3}-notification-wrapper`, this.themeClass],
      onMouseenter: this.onMouseenter,
      onMouseleave: this.onMouseleave,
      style: this.cssVars
    }, h$1R("div", {
      class: [`${o3}-notification`, this.rtlEnabled && `${o3}-notification--rtl`, this.themeClass, {
        [`${o3}-notification--closable`]: this.closable,
        [`${o3}-notification--show-avatar`]: this.showAvatar
      }],
      style: this.cssVars
    }, this.showAvatar ? h$1R("div", {
      class: `${o3}-notification__avatar`
    }, this.avatar ? o$1c(this.avatar) : this.type !== "default" ? h$1R(d$1R, {
      clsPrefix: o3
    }, {
      default: () => lo$1[this.type]()
    }) : null) : null, this.closable ? h$1R(g$1b, {
      clsPrefix: o3,
      class: `${o3}-notification__close`,
      onClick: this.handleCloseClick
    }) : null, h$1R("div", {
      ref: "bodyRef",
      class: `${o3}-notification-main`
    }, this.title ? h$1R("div", {
      class: `${o3}-notification-main__header`
    }, o$1c(this.title)) : null, this.description ? h$1R("div", {
      class: `${o3}-notification-main__description`
    }, o$1c(this.description)) : null, this.content ? h$1R("pre", {
      class: `${o3}-notification-main__content`
    }, o$1c(this.content)) : null, this.meta || this.action ? h$1R("div", {
      class: `${o3}-notification-main-footer`
    }, this.meta ? h$1R("div", {
      class: `${o3}-notification-main-footer__meta`
    }, o$1c(this.meta)) : null, this.action ? h$1R("div", {
      class: `${o3}-notification-main-footer__action`
    }, o$1c(this.action)) : null) : null)));
  }
});
const M$9 = Object.assign(Object.assign({}, c$14), {
  duration: Number,
  onClose: Function,
  onLeave: Function,
  onAfterEnter: Function,
  onAfterLeave: Function,
  onHide: Function,
  onAfterShow: Function,
  onAfterHide: Function
}), K$8 = defineComponent({
  name: "NotificationEnvironment",
  props: Object.assign(Object.assign({}, M$9), {
    internalKey: {
      type: String,
      required: true
    },
    onInternalAfterLeave: {
      type: Function,
      required: true
    }
  }),
  setup(n3) {
    const {
      wipTransitionCountRef: a3
    } = inject(n$E), f3 = ref$1(true);
    let i = null;
    function o3() {
      f3.value = false, i && window.clearTimeout(i);
    }
    function u3(e28) {
      a3.value++, nextTick(() => {
        e28.style.height = `${e28.offsetHeight}px`, e28.style.maxHeight = "0", e28.style.transition = "none", e28.offsetHeight, e28.style.transition = "", e28.style.maxHeight = e28.style.height;
      });
    }
    function h3(e28) {
      a3.value--, e28.style.height = "", e28.style.maxHeight = "";
      const {
        onAfterEnter: t3,
        onAfterShow: r3
      } = n3;
      t3 && t3(), r3 && r3();
    }
    function d3(e28) {
      a3.value++, e28.style.maxHeight = `${e28.offsetHeight}px`, e28.style.height = `${e28.offsetHeight}px`, e28.offsetHeight;
    }
    function l3(e28) {
      const {
        onHide: t3
      } = n3;
      t3 && t3(), e28.style.maxHeight = "0", e28.offsetHeight;
    }
    function c3() {
      a3.value--;
      const {
        onAfterLeave: e28,
        onInternalAfterLeave: t3,
        onAfterHide: r3,
        internalKey: H3
      } = n3;
      e28 && e28(), t3(H3), r3 && r3();
    }
    function v3() {
      const {
        duration: e28
      } = n3;
      e28 && (i = window.setTimeout(o3, e28));
    }
    function m3(e28) {
      e28.currentTarget === e28.target && i !== null && (window.clearTimeout(i), i = null);
    }
    function g3(e28) {
      e28.currentTarget === e28.target && v3();
    }
    function A3() {
      const {
        onClose: e28
      } = n3;
      e28 ? Promise.resolve(e28()).then((t3) => {
        t3 !== false && o3();
      }) : o3();
    }
    return onMounted(() => {
      n3.duration && (i = window.setTimeout(o3, n3.duration));
    }), {
      show: f3,
      hide: o3,
      handleClose: A3,
      handleAfterLeave: c3,
      handleLeave: l3,
      handleBeforeLeave: d3,
      handleAfterEnter: h3,
      handleBeforeEnter: u3,
      handleMouseenter: m3,
      handleMouseleave: g3
    };
  },
  render() {
    return h$1R(Transition, {
      name: "notification-transition",
      appear: true,
      onBeforeEnter: this.handleBeforeEnter,
      onAfterEnter: this.handleAfterEnter,
      onBeforeLeave: this.handleBeforeLeave,
      onLeave: this.handleLeave,
      onAfterLeave: this.handleAfterLeave
    }, {
      default: () => this.show ? h$1R(So$1, Object.assign({}, r$1C(this.$props, Ro$1), {
        onClose: this.handleClose,
        onMouseenter: this.duration && this.keepAliveOnHover ? this.handleMouseenter : void 0,
        onMouseleave: this.duration && this.keepAliveOnHover ? this.handleMouseleave : void 0
      })) : null
    });
  }
});
const p$2N = r$2a([l$25("notification-container", `
 z-index: 4000;
 position: fixed;
 overflow: visible;
 display: flex;
 flex-direction: column;
 align-items: flex-end;
 `, [r$2a(">", [l$25("scrollbar", `
 width: initial;
 overflow: visible;
 height: -moz-fit-content !important;
 height: fit-content !important;
 max-height: 100vh !important;
 `, [r$2a(">", [l$25("scrollbar-container", `
 height: -moz-fit-content !important;
 height: fit-content !important;
 max-height: 100vh !important;
 `, [l$25("scrollbar-content", `
 padding-top: 12px;
 padding-bottom: 33px;
 `)])])])]), g$1j("top, top-right, top-left", `
 top: 12px;
 `, [r$2a("&.transitioning >", [l$25("scrollbar", [r$2a(">", [l$25("scrollbar-container", `
 min-height: 100vh !important;
 `)])])])]), g$1j("bottom, bottom-right, bottom-left", `
 bottom: 12px;
 `, [r$2a(">", [l$25("scrollbar", [r$2a(">", [l$25("scrollbar-container", [l$25("scrollbar-content", `
 padding-bottom: 12px;
 `)])])])]), l$25("notification-wrapper", `
 display: flex;
 align-items: flex-end;
 margin-bottom: 0;
 margin-top: 12px;
 `)]), g$1j("top, bottom", `
 left: 50%;
 transform: translateX(-50%);
 `, [l$25("notification-wrapper", [r$2a("&.notification-transition-enter-from, &.notification-transition-leave-to", `
 transform: scale(0.85);
 `), r$2a("&.notification-transition-leave-from, &.notification-transition-enter-to", `
 transform: scale(1);
 `)])]), g$1j("top", [l$25("notification-wrapper", `
 transform-origin: top center;
 `)]), g$1j("bottom", [l$25("notification-wrapper", `
 transform-origin: bottom center;
 `)]), g$1j("top-right, bottom-right", [l$25("notification", `
 margin-left: 28px;
 margin-right: 16px;
 `)]), g$1j("top-left, bottom-left", [l$25("notification", `
 margin-left: 16px;
 margin-right: 28px;
 `)]), g$1j("top-right", `
 right: 0;
 `, [r$Q("top-right")]), g$1j("top-left", `
 left: 0;
 `, [r$Q("top-left")]), g$1j("bottom-right", `
 right: 0;
 `, [r$Q("bottom-right")]), g$1j("bottom-left", `
 left: 0;
 `, [r$Q("bottom-left")]), g$1j("scrollable", [g$1j("top-right", `
 top: 0;
 `), g$1j("top-left", `
 top: 0;
 `), g$1j("bottom-right", `
 bottom: 0;
 `), g$1j("bottom-left", `
 bottom: 0;
 `)]), l$25("notification-wrapper", `
 margin-bottom: 12px;
 `, [r$2a("&.notification-transition-enter-from, &.notification-transition-leave-to", `
 opacity: 0;
 margin-top: 0 !important;
 margin-bottom: 0 !important;
 `), r$2a("&.notification-transition-leave-from, &.notification-transition-enter-to", `
 opacity: 1;
 `), r$2a("&.notification-transition-leave-active", `
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 transform .3s var(--n-bezier-ease-in),
 max-height .3s var(--n-bezier),
 margin-top .3s linear,
 margin-bottom .3s linear,
 box-shadow .3s var(--n-bezier);
 `), r$2a("&.notification-transition-enter-active", `
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 transform .3s var(--n-bezier-ease-out),
 max-height .3s var(--n-bezier),
 margin-top .3s linear,
 margin-bottom .3s linear,
 box-shadow .3s var(--n-bezier);
 `)]), l$25("notification", `
 background-color: var(--n-color);
 color: var(--n-text-color);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 font-family: inherit;
 font-size: var(--n-font-size);
 font-weight: 400;
 position: relative;
 display: flex;
 overflow: hidden;
 flex-shrink: 0;
 padding-left: var(--n-padding-left);
 padding-right: var(--n-padding-right);
 width: var(--n-width);
 max-width: calc(100vw - 16px - 16px);
 border-radius: var(--n-border-radius);
 box-shadow: var(--n-box-shadow);
 box-sizing: border-box;
 opacity: 1;
 `, [M$y("avatar", [l$25("icon", `
 color: var(--n-icon-color);
 `), l$25("base-icon", `
 color: var(--n-icon-color);
 `)]), g$1j("show-avatar", [l$25("notification-main", `
 margin-left: 40px;
 width: calc(100% - 40px); 
 `)]), g$1j("closable", [l$25("notification-main", [r$2a("> *:first-child", `
 padding-right: 20px;
 `)]), M$y("close", `
 position: absolute;
 top: 0;
 right: 0;
 margin: var(--n-close-margin);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)]), M$y("avatar", `
 position: absolute;
 top: var(--n-padding-top);
 left: var(--n-padding-left);
 width: 28px;
 height: 28px;
 font-size: 28px;
 display: flex;
 align-items: center;
 justify-content: center;
 `, [l$25("icon", "transition: color .3s var(--n-bezier);")]), l$25("notification-main", `
 padding-top: var(--n-padding-top);
 padding-bottom: var(--n-padding-bottom);
 box-sizing: border-box;
 display: flex;
 flex-direction: column;
 margin-left: 8px;
 width: calc(100% - 8px);
 `, [l$25("notification-main-footer", `
 display: flex;
 align-items: center;
 justify-content: space-between;
 margin-top: 12px;
 `, [M$y("meta", `
 font-size: var(--n-meta-font-size);
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-description-text-color);
 `), M$y("action", `
 cursor: pointer;
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-action-text-color);
 `)]), M$y("header", `
 font-weight: var(--n-title-font-weight);
 font-size: var(--n-title-font-size);
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-title-text-color);
 `), M$y("description", `
 margin-top: 8px;
 font-size: var(--n-description-font-size);
 white-space: pre-wrap;
 word-wrap: break-word;
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-description-text-color);
 `), M$y("content", `
 line-height: var(--n-line-height);
 margin: 12px 0 0 0;
 font-family: inherit;
 white-space: pre-wrap;
 word-wrap: break-word;
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-text-color);
 `, [r$2a("&:first-child", "margin: 0;")])])])])]);
function r$Q(a3) {
  const e28 = a3.split("-")[1] === "left" ? "calc(-100%)" : "calc(100%)", c3 = "0";
  return l$25("notification-wrapper", [r$2a("&.notification-transition-enter-from, &.notification-transition-leave-to", `
 transform: translate(${e28}, 0);
 `), r$2a("&.notification-transition-leave-from, &.notification-transition-enter-to", `
 transform: translate(${c3}, 0);
 `)]);
}
const e$V = {
  closeMargin: "16px 12px",
  closeSize: "20px",
  closeIconSize: "16px",
  width: "365px",
  padding: "16px",
  titleFontSize: "16px",
  metaFontSize: "12px",
  descriptionFontSize: "12px"
};
const T$j = (e28) => {
  const {
    textColor2: o3,
    successColor: t3,
    infoColor: i,
    warningColor: n3,
    errorColor: c3,
    popoverColor: l3,
    closeIconColor: s3,
    closeIconColorHover: C3,
    closeIconColorPressed: a3,
    closeColorHover: m3,
    closeColorPressed: f3,
    textColor1: d3,
    textColor3: g3,
    borderRadius: r3,
    fontWeightStrong: h3,
    boxShadow2: x3,
    lineHeight: p3,
    fontSize: b3
  } = e28;
  return Object.assign(Object.assign({}, e$V), {
    borderRadius: r3,
    lineHeight: p3,
    fontSize: b3,
    headerFontWeight: h3,
    iconColor: o3,
    iconColorSuccess: t3,
    iconColorInfo: i,
    iconColorWarning: n3,
    iconColorError: c3,
    color: l3,
    textColor: o3,
    closeIconColor: s3,
    closeIconColorHover: C3,
    closeIconColorPressed: a3,
    closeBorderRadius: r3,
    closeColorHover: m3,
    closeColorPressed: f3,
    headerTextColor: d3,
    descriptionTextColor: g3,
    actionTextColor: o3,
    boxShadow: x3
  });
}, v$u = G$w({
  name: "Notification",
  common: d$1T,
  peers: {
    Scrollbar: n$1N
  },
  self: T$j
}), O$k = v$u;
const E$d = n$28("n-notification-api"), z$8 = Object.assign(Object.assign({}, _$F.props), {
  containerClass: String,
  containerStyle: [String, Object],
  to: [String, Object],
  scrollable: {
    type: Boolean,
    default: true
  },
  max: Number,
  placement: {
    type: String,
    default: "top-right"
  },
  keepAliveOnHover: Boolean
}), X$6 = defineComponent({
  name: "NotificationProvider",
  props: z$8,
  setup(r3) {
    const {
      mergedClsPrefixRef: s3
    } = a$2x(r3), e28 = ref$1([]), n3 = {}, t3 = /* @__PURE__ */ new Set();
    function c3(i) {
      const o3 = i$1Y(), f3 = () => {
        t3.add(o3), n3[o3] && n3[o3].hide();
      }, u3 = reactive(Object.assign(Object.assign({}, i), {
        key: o3,
        destroy: f3,
        hide: f3,
        deactivate: f3
      })), {
        max: p3
      } = r3;
      if (p3 && e28.value.length - t3.size >= p3) {
        let v3 = false, h3 = 0;
        for (const m3 of e28.value) {
          if (!t3.has(m3.key)) {
            n3[m3.key] && (m3.destroy(), v3 = true);
            break;
          }
          h3++;
        }
        v3 || e28.value.splice(h3, 1);
      }
      return e28.value.push(u3), u3;
    }
    const a3 = ["info", "success", "warning", "error"].map((i) => (o3) => c3(Object.assign(Object.assign({}, o3), {
      type: i
    })));
    function O3(i) {
      t3.delete(i), e28.value.splice(e28.value.findIndex((o3) => o3.key === i), 1);
    }
    const j3 = _$F("Notification", "-notification", p$2N, O$k, r3, s3), d3 = {
      create: c3,
      info: a3[0],
      success: a3[1],
      warning: a3[2],
      error: a3[3],
      open: A3,
      destroyAll: R3
    }, k3 = ref$1(0);
    provide(E$d, d3), provide(n$E, {
      props: r3,
      mergedClsPrefixRef: s3,
      mergedThemeRef: j3,
      wipTransitionCountRef: k3
    });
    function A3(i) {
      return c3(i);
    }
    function R3() {
      Object.values(e28.value).forEach((i) => {
        i.hide();
      });
    }
    return Object.assign({
      mergedClsPrefix: s3,
      notificationList: e28,
      notificationRefs: n3,
      handleAfterLeave: O3
    }, d3);
  },
  render() {
    var r3, s3, e28;
    const {
      placement: n3
    } = this;
    return h$1R(Fragment, null, (s3 = (r3 = this.$slots).default) === null || s3 === void 0 ? void 0 : s3.call(r3), this.notificationList.length ? h$1R(Teleport, {
      to: (e28 = this.to) !== null && e28 !== void 0 ? e28 : "body"
    }, h$1R(g$y, {
      class: this.containerClass,
      style: this.containerStyle,
      scrollable: this.scrollable && n3 !== "top" && n3 !== "bottom",
      placement: n3
    }, {
      default: () => this.notificationList.map((t3) => h$1R(K$8, Object.assign({
        ref: (c3) => {
          const a3 = t3.key;
          c3 === null ? delete this.notificationRefs[a3] : this.notificationRefs[a3] = c3;
        }
      }, i$1g(t3, ["destroy", "hide", "deactivate"]), {
        internalKey: t3.key,
        onInternalAfterLeave: this.handleAfterLeave,
        keepAliveOnHover: t3.keepAliveOnHover === void 0 ? this.keepAliveOnHover : t3.keepAliveOnHover
      })))
    })) : null);
  }
});
const t$H = {
  name: i$1i.swedish,
  global: {
    undo: "\xC5ngra",
    redo: "Klar",
    confirm: "Bekr\xE4fta",
    clear: "Klar",
    more: "mer",
    cancel: "Avbryta"
  },
  Popconfirm: {
    positiveText: "Bekr\xE4fta",
    negativeText: "Avbryt"
  },
  Cascader: {
    placeholder: "V\xE4nligen v\xE4lj",
    loading: "Laddar",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Klar",
    now: "Nu",
    confirm: "Bekr\xE4fta",
    selectTime: "V\xE4lj tidpunkt",
    selectDate: "V\xE4lj datum",
    datePlaceholder: "V\xE4lj datum",
    datetimePlaceholder: "V\xE4lj datum och tid",
    monthPlaceholder: "V\xE4lj m\xE5nad",
    yearPlaceholder: "V\xE4lj \xE5r",
    quarterPlaceholder: "V\xE4lj kvartal",
    startDatePlaceholder: "Startdatum",
    endDatePlaceholder: "Slutdatum",
    startDatetimePlaceholder: "Startdatum och tid",
    endDatetimePlaceholder: "Slutdatum och tidpunkt",
    startMonthPlaceholder: "Startm\xE5nad",
    endMonthPlaceholder: "Slutet av m\xE5naden",
    monthBeforeYear: true,
    firstDayOfWeek: 6,
    today: "Idag"
  },
  DataTable: {
    checkTableAll: "V\xE4lj allt i tabellen",
    uncheckTableAll: "Avmarkera allt i tabellen",
    confirm: "Bekr\xE4fta",
    clear: "Klar",
    apply: "Ans\xF6k",
    filters: "Filter",
    sort: "Sortera"
  },
  LegacyTransfer: {
    sourceTitle: "K\xE4lla",
    targetTitle: "M\xE5l"
  },
  Transfer: {
    selectAll: "Markera alla",
    unselectAll: "Avmarkera alla",
    clearAll: "Tydlig"
  },
  Empty: {
    description: "Inget data"
  },
  Select: {
    placeholder: "V\xE4lj"
  },
  TimePicker: {
    placeholder: "V\xE4lj tid",
    positiveText: "OK",
    negativeText: "Avbryt",
    now: "Nu"
  },
  Pagination: {
    goto: "G\xE5 till",
    selectionSuffix: "sida",
    next: "N\xE4sta",
    previous: "F\xF6reg\xE5ende"
  },
  DynamicTags: {
    add: "L\xE4gg till"
  },
  Log: {
    loading: "L\xE4ser in"
  },
  Input: {
    placeholder: "V\xE4nligen ange"
  },
  InputNumber: {
    placeholder: "Var v\xE4nlig ange"
  },
  DynamicInput: {
    create: "Skapa"
  },
  ThemeEditor: {
    title: "Teman Redigerare",
    clearAllVars: "Rensa alla variabler",
    clearSearch: "Rensa s\xF6kning",
    filterCompName: "Filterkomponentnamn",
    filterVarName: "Filter Variabelnamn",
    import: "Importera",
    export: "Export",
    restore: "\xC5terst\xE4ll till standardinst\xE4llningar"
  },
  Image: {
    tipPrevious: "F\xF6reg\xE5ende bild (\u2190)",
    tipNext: "N\xE4sta bild (\u2192)",
    tipCounterclockwise: "Moturs",
    tipClockwise: "Medurs",
    tipZoomOut: "Zooma ut",
    tipZoomIn: "Zooma in",
    tipClose: "St\xE4ng (Esc)",
    tipOriginalSize: "Zooma till originalstorlek"
  },
  SortFilter: {
    heading: "Sortera och filtrera",
    sortHeading: "Sortera efter",
    newestFirst: "Nyast f\xF6rst",
    oldestFirst: "\xC4ldst f\xF6rst",
    ascending: "Stigande",
    descending: "Fallande",
    aToZ: "A-\xD6",
    zToA: "\xD6-A",
    apply: "Anv\xE4nd",
    clear: "Rensa",
    cancel: "Avbryt",
    filters: "Filter"
  },
  IconPicker: {
    noMatchingFound: "Inga matchande resultat hittades"
  }
};
var a$12 = {
  lessThanXSeconds: {
    one: "mindre \xE4n en sekund",
    other: "mindre \xE4n {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre \xE4n en minut",
    other: "mindre \xE4n {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungef\xE4r en timme",
    other: "ungef\xE4r {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungef\xE4r en vecka",
    other: "ungef\xE4r {{count}} vecka"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} vecka"
  },
  aboutXMonths: {
    one: "ungef\xE4r en m\xE5nad",
    other: "ungef\xE4r {{count}} m\xE5nader"
  },
  xMonths: {
    one: "en m\xE5nad",
    other: "{{count}} m\xE5nader"
  },
  aboutXYears: {
    one: "ungef\xE4r ett \xE5r",
    other: "ungef\xE4r {{count}} \xE5r"
  },
  xYears: {
    one: "ett \xE5r",
    other: "{{count}} \xE5r"
  },
  overXYears: {
    one: "\xF6ver ett \xE5r",
    other: "\xF6ver {{count}} \xE5r"
  },
  almostXYears: {
    one: "n\xE4stan ett \xE5r",
    other: "n\xE4stan {{count}} \xE5r"
  }
}, u$W = ["noll", "en", "tv\xE5", "tre", "fyra", "fem", "sex", "sju", "\xE5tta", "nio", "tio", "elva", "tolv"], s$$ = function(o3, r3, e28) {
  var n3, t3 = a$12[o3];
  return typeof t3 == "string" ? n3 = t3 : r3 === 1 ? n3 = t3.one : e28 && e28.onlyNumeric ? n3 = t3.other.replace("{{count}}", String(r3)) : n3 = t3.other.replace("{{count}}", r3 < 13 ? u$W[r3] : String(r3)), e28 != null && e28.addSuffix ? e28.comparison && e28.comparison > 0 ? "om " + n3 : n3 + " sedan" : n3;
};
const i$R = s$$;
var m$12 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, a$11 = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, d$_ = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, e$U = {
  date: u$1s({
    formats: m$12,
    defaultWidth: "full"
  }),
  time: u$1s({
    formats: a$11,
    defaultWidth: "full"
  }),
  dateTime: u$1s({
    formats: d$_,
    defaultWidth: "full"
  })
};
const o$O = e$U;
var t$G = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'ig\xE5r kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, a$10 = function(e28, r3, l3, i) {
  return t$G[e28];
};
const E$c = a$10;
var i$Q = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["f\xF6re Kristus", "efter Kristus"]
}, m$11 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, d$Z = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
}, o$N = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["s\xF6", "m\xE5", "ti", "on", "to", "fr", "l\xF6"],
  abbreviated: ["s\xF6n", "m\xE5n", "tis", "ons", "tors", "fre", "l\xF6r"],
  wide: ["s\xF6ndag", "m\xE5ndag", "tisdag", "onsdag", "torsdag", "fredag", "l\xF6rdag"]
}, g$x = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kv\xE4ll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kv\xE4ll",
    night: "natt"
  },
  wide: {
    am: "f\xF6rmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kv\xE4ll",
    night: "natt"
  }
}, l$W = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "p\xE5 morg.",
    afternoon: "p\xE5 efterm.",
    evening: "p\xE5 kv\xE4llen",
    night: "p\xE5 natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "p\xE5 morg.",
    afternoon: "p\xE5 efterm.",
    evening: "p\xE5 kv\xE4llen",
    night: "p\xE5 natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "p\xE5 morgonen",
    afternoon: "p\xE5 eftermiddagen",
    evening: "p\xE5 kv\xE4llen",
    night: "p\xE5 natten"
  }
}, u$V = function(a3, v3) {
  var n3 = Number(a3), r3 = n3 % 100;
  if (r3 > 20 || r3 < 10)
    switch (r3 % 10) {
      case 1:
      case 2:
        return n3 + ":a";
    }
  return n3 + ":e";
}, f$E = {
  ordinalNumber: u$V,
  era: f$1h({
    values: i$Q,
    defaultWidth: "wide"
  }),
  quarter: f$1h({
    values: m$11,
    defaultWidth: "wide",
    argumentCallback: function(a3) {
      return a3 - 1;
    }
  }),
  month: f$1h({
    values: d$Z,
    defaultWidth: "wide"
  }),
  day: f$1h({
    values: o$N,
    defaultWidth: "wide"
  }),
  dayPeriod: f$1h({
    values: g$x,
    defaultWidth: "wide",
    formattingValues: l$W,
    defaultFormattingWidth: "wide"
  })
};
const b$s = f$E;
var i$P = /^(\d+)(:a|:e)?/i, n$D = /\d+/i, d$Y = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, s$_ = {
  any: [/^f/i, /^[ev]/i]
}, m$10 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, o$M = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, l$V = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, u$U = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, f$D = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, h$S = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, v$t = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, P$q = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, c$13 = {
  ordinalNumber: v$Z({
    matchPattern: i$P,
    parsePattern: n$D,
    valueCallback: function(t3) {
      return parseInt(t3, 10);
    }
  }),
  era: o$1h({
    matchPatterns: d$Y,
    defaultMatchWidth: "wide",
    parsePatterns: s$_,
    defaultParseWidth: "any"
  }),
  quarter: o$1h({
    matchPatterns: m$10,
    defaultMatchWidth: "wide",
    parsePatterns: o$M,
    defaultParseWidth: "any",
    valueCallback: function(t3) {
      return t3 + 1;
    }
  }),
  month: o$1h({
    matchPatterns: l$V,
    defaultMatchWidth: "wide",
    parsePatterns: u$U,
    defaultParseWidth: "any"
  }),
  day: o$1h({
    matchPatterns: f$D,
    defaultMatchWidth: "wide",
    parsePatterns: h$S,
    defaultParseWidth: "any"
  }),
  dayPeriod: o$1h({
    matchPatterns: v$t,
    defaultMatchWidth: "any",
    parsePatterns: P$q,
    defaultParseWidth: "any"
  })
};
const g$w = c$13;
var e$T = {
  code: "sv",
  formatDistance: i$R,
  formatLong: o$O,
  formatRelative: E$c,
  localize: b$s,
  match: g$w,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const n$C = e$T;
const m$$ = {
  name: i$1i.swedish,
  locale: n$C
};
const r$P = {
  name: i$1i.spanish,
  global: {
    undo: "Deshacer",
    redo: "Rehacer",
    confirm: "Confirmar",
    clear: "Limpiar",
    more: "m\xE1s",
    cancel: "Cancelar"
  },
  Popconfirm: {
    positiveText: "Confirmar",
    negativeText: "Cancelar"
  },
  Cascader: {
    placeholder: "Por favor Seleccionar",
    loading: "Cargando",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Limpiar",
    now: "Ahora",
    confirm: "Confirmar",
    selectTime: "Seleccionar Hora",
    selectDate: "Seleccionar Fecha",
    datePlaceholder: "Seleccionar Fecha",
    datetimePlaceholder: "Seleccionar Fecha y Hora",
    monthPlaceholder: "Seleccionar Mes",
    yearPlaceholder: "Seleccionar A\xF1o",
    quarterPlaceholder: "Seleccionar Trimestre",
    startDatePlaceholder: "Fecha de Inicio",
    endDatePlaceholder: "Fecha Final",
    startDatetimePlaceholder: "Fecha y Hora de Inicio",
    endDatetimePlaceholder: "Fecha Hora Final",
    monthBeforeYear: true,
    startMonthPlaceholder: "Mes de Inicio",
    endMonthPlaceholder: "Mes final",
    firstDayOfWeek: 6,
    today: "Hoy"
  },
  DataTable: {
    checkTableAll: "Seleccionar todo en la tabla",
    uncheckTableAll: "Deseleccionar todo en la tabla",
    confirm: "Confirmar",
    clear: "Limpiar",
    apply: "Aplicar",
    filters: "Filtros",
    sort: "Ordenar"
  },
  LegacyTransfer: {
    sourceTitle: "Origen",
    targetTitle: "Objetivo"
  },
  Transfer: {
    selectAll: "Seleccionar Todos",
    unselectAll: "Deseleccionar todos",
    clearAll: "Limpiar"
  },
  Empty: {
    description: "Sin datos"
  },
  Select: {
    placeholder: "Por favor selecciona"
  },
  TimePicker: {
    placeholder: "Seleccionar hora",
    positiveText: "De acuerdo",
    negativeText: "Cancelar",
    now: "Ahora"
  },
  Pagination: {
    goto: "Ir a",
    selectionSuffix: "Pagina",
    next: "Siguiente",
    previous: "Anterior"
  },
  DynamicTags: {
    add: "Agregar"
  },
  Log: {
    loading: "Cargando"
  },
  Input: {
    placeholder: "Por favor, entrada"
  },
  InputNumber: {
    placeholder: "Por favor, entrada"
  },
  DynamicInput: {
    create: "Crear"
  },
  ThemeEditor: {
    title: "Editor de Tema",
    clearAllVars: "Limpiar todas las variables",
    clearSearch: "Limpiar b\xFAsqueda",
    filterCompName: "Filtrar nombre del componente",
    filterVarName: "Filtrar variable de nombre",
    import: "Importar",
    export: "Exportar",
    restore: "restablecer a predeterminado"
  },
  Image: {
    tipPrevious: "Foto anterior (\u2190)",
    tipNext: "Siguiente foto (\u2192)",
    tipCounterclockwise: "Sentido contrario a las agujas del reloj",
    tipClockwise: "Sentido de las agujas del reloj",
    tipZoomOut: "Zoom out",
    tipZoomIn: "Zoom in",
    tipClose: "Cerrar (Esc)",
    tipOriginalSize: "Zoom al tama\xF1o original"
  },
  SortFilter: {
    heading: "Ordenar y filtrar",
    sortHeading: "Ordenar por",
    newestFirst: "M\xE1s recientes primero",
    oldestFirst: "M\xE1s antiguos primero",
    ascending: "Ascendente",
    descending: "Descendente",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Aplicar",
    clear: "Limpiar",
    cancel: "Cancelar",
    filters: "Filtros"
  },
  IconPicker: {
    noMatchingFound: "No se encontraron resultados coincidentes"
  }
};
var s$Z = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 d\xEDa",
    other: "{{count}} d\xEDas"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 a\xF1o",
    other: "alrededor de {{count}} a\xF1os"
  },
  xYears: {
    one: "1 a\xF1o",
    other: "{{count}} a\xF1os"
  },
  overXYears: {
    one: "m\xE1s de 1 a\xF1o",
    other: "m\xE1s de {{count}} a\xF1os"
  },
  almostXYears: {
    one: "casi 1 a\xF1o",
    other: "casi {{count}} a\xF1os"
  }
}, t$F = function(r3, a3, o3) {
  var e28, n3 = s$Z[r3];
  return typeof n3 == "string" ? e28 = n3 : a3 === 1 ? e28 = n3.one : e28 = n3.other.replace("{{count}}", a3.toString()), o3 != null && o3.addSuffix ? o3.comparison && o3.comparison > 0 ? "en " + e28 : "hace " + e28 : e28;
};
const d$X = t$F;
var m$_ = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, a$$ = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, d$W = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, e$S = {
  date: u$1s({
    formats: m$_,
    defaultWidth: "full"
  }),
  time: u$1s({
    formats: a$$,
    defaultWidth: "full"
  }),
  dateTime: u$1s({
    formats: d$W,
    defaultWidth: "full"
  })
};
const o$L = e$S;
var t$E = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'ma\xF1ana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, o$K = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'ma\xF1ana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, l$U = function(a3, e28, s3, p3) {
  return e28.getUTCHours() !== 1 ? o$K[a3] : t$E[a3];
};
const y$o = l$U;
var i$O = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "despu\xE9s de cristo"]
}, d$V = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
}, o$J = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
}, t$D = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "s\xE1"],
  abbreviated: ["dom", "lun", "mar", "mi\xE9", "jue", "vie", "s\xE1b"],
  wide: ["domingo", "lunes", "martes", "mi\xE9rcoles", "jueves", "viernes", "s\xE1bado"]
}, m$Z = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "ma\xF1ana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "ma\xF1ana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "ma\xF1ana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, l$T = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la ma\xF1ana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la ma\xF1ana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la ma\xF1ana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, u$T = function(a3, v3) {
  var r3 = Number(a3);
  return r3 + "\xBA";
}, s$Y = {
  ordinalNumber: u$T,
  era: f$1h({
    values: i$O,
    defaultWidth: "wide"
  }),
  quarter: f$1h({
    values: d$V,
    defaultWidth: "wide",
    argumentCallback: function(a3) {
      return Number(a3) - 1;
    }
  }),
  month: f$1h({
    values: o$J,
    defaultWidth: "wide"
  }),
  day: f$1h({
    values: t$D,
    defaultWidth: "wide"
  }),
  dayPeriod: f$1h({
    values: m$Z,
    defaultWidth: "wide",
    formattingValues: l$T,
    defaultFormattingWidth: "wide"
  })
};
const b$r = s$Y;
var t$C = /^(\d+)(º)?/i, n$B = /\d+/i, d$U = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, s$X = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
}, m$Y = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, o$I = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, c$12 = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, u$S = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
}, l$S = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, h$R = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, P$p = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, v$s = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, b$q = {
  ordinalNumber: v$Z({
    matchPattern: t$C,
    parsePattern: n$B,
    valueCallback: function(e28) {
      return parseInt(e28, 10);
    }
  }),
  era: o$1h({
    matchPatterns: d$U,
    defaultMatchWidth: "wide",
    parsePatterns: s$X,
    defaultParseWidth: "any"
  }),
  quarter: o$1h({
    matchPatterns: m$Y,
    defaultMatchWidth: "wide",
    parsePatterns: o$I,
    defaultParseWidth: "any",
    valueCallback: function(e28) {
      return e28 + 1;
    }
  }),
  month: o$1h({
    matchPatterns: c$12,
    defaultMatchWidth: "wide",
    parsePatterns: u$S,
    defaultParseWidth: "any"
  }),
  day: o$1h({
    matchPatterns: l$S,
    defaultMatchWidth: "wide",
    parsePatterns: h$R,
    defaultParseWidth: "any"
  }),
  dayPeriod: o$1h({
    matchPatterns: P$p,
    defaultMatchWidth: "any",
    parsePatterns: v$s,
    defaultParseWidth: "any"
  })
};
const y$n = b$q;
var m$X = {
  code: "es",
  formatDistance: d$X,
  formatLong: o$L,
  formatRelative: y$o,
  localize: b$r,
  match: y$n,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const n$A = m$X;
const m$W = {
  name: i$1i.spanish,
  locale: n$A
};
const r$O = {
  name: i$1i.portugueseBrazil,
  global: {
    undo: "Desfazer",
    redo: "Refazer",
    confirm: "Confirmar",
    clear: "Limpar",
    more: "mais",
    cancel: "Cancelar"
  },
  Popconfirm: {
    positiveText: "Confirmar",
    negativeText: "Cancelar"
  },
  Cascader: {
    placeholder: "Por favor, selecione",
    loading: "Carregando",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy/MM",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "yyyy/qqq",
    clear: "Limpar",
    now: "Agora",
    confirm: "Confirmar",
    selectTime: "Selecionar Hor\xE1rio",
    selectDate: "Selecionar Data",
    datePlaceholder: "Selecionar Data",
    datetimePlaceholder: "Selecionar Data e Hora",
    monthPlaceholder: "Selecionar M\xEAs",
    yearPlaceholder: "Selecionar Ano",
    quarterPlaceholder: "Selecionar Trimestre",
    startDatePlaceholder: "Data de In\xEDcio",
    endDatePlaceholder: "Data Final",
    startDatetimePlaceholder: "Data e Hora Inicial",
    endDatetimePlaceholder: "Data e Hora Final",
    startMonthPlaceholder: "M\xEAs de In\xEDcio",
    endMonthPlaceholder: "M\xEAs Final",
    monthBeforeYear: true,
    firstDayOfWeek: 6,
    today: "Hoje"
  },
  DataTable: {
    checkTableAll: "Selecionar tudo na tabela",
    uncheckTableAll: "Desmarcar tudo na tabela",
    confirm: "Confirmar",
    clear: "Limpar",
    apply: "Aplicar",
    filters: "Filtros",
    sort: "Ordenar"
  },
  LegacyTransfer: {
    sourceTitle: "Origem",
    targetTitle: "Destino"
  },
  Transfer: {
    selectAll: "Selecionar tudo",
    unselectAll: "Desmarcar tudo",
    clearAll: "Limpar"
  },
  Empty: {
    description: "Sem Dados"
  },
  Select: {
    placeholder: "Por favor, selecione"
  },
  TimePicker: {
    placeholder: "Selecionar Hor\xE1rio",
    positiveText: "OK",
    negativeText: "Cancelar",
    now: "Agora"
  },
  Pagination: {
    goto: "Ir para",
    selectionSuffix: "p\xE1gina",
    next: "Pr\xF3ximo",
    previous: "Anterior"
  },
  DynamicTags: {
    add: "Adicionar"
  },
  Log: {
    loading: "Carregando"
  },
  Input: {
    placeholder: "Por favor, insira"
  },
  InputNumber: {
    placeholder: "Por favor, preencha"
  },
  DynamicInput: {
    create: "Criar"
  },
  ThemeEditor: {
    title: "Editor de Tema",
    clearAllVars: "Limpar todas as vari\xE1veis",
    clearSearch: "Limpar Busca",
    filterCompName: "Filtrar Nome do Componente",
    filterVarName: "Filtrar Nome da Vari\xE1vel",
    import: "Importar",
    export: "Exportar",
    restore: "Redefinir para o Padr\xE3o"
  },
  Image: {
    tipPrevious: "Imagem Anterior (\u2190)",
    tipNext: "Pr\xF3xima Imagem (\u2192)",
    tipCounterclockwise: "Sentido Anti-hor\xE1rio",
    tipClockwise: "Sentido Hor\xE1rio",
    tipZoomOut: "Reduzir Zoom",
    tipZoomIn: "Aumentar Zoom",
    tipClose: "Fechar (Esc)",
    tipOriginalSize: "Zoom para Tamanho Original"
  },
  SortFilter: {
    heading: "Classificar e filtrar",
    sortHeading: "Classificar por",
    newestFirst: "Mais recentes primeiro",
    oldestFirst: "Mais antigos primeiro",
    ascending: "Crescente",
    descending: "Decrescente",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Aplicar",
    clear: "Limpar",
    cancel: "Cancelar",
    filters: "Filtros"
  },
  IconPicker: {
    noMatchingFound: "Nenhum resultado correspondente encontrado"
  }
};
var t$B = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "cerca de 1 hora",
    other: "cerca de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "cerca de 1 semana",
    other: "cerca de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "cerca de 1 m\xEAs",
    other: "cerca de {{count}} meses"
  },
  xMonths: {
    one: "1 m\xEAs",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "cerca de 1 ano",
    other: "cerca de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, r$N = function(s3, a3, o3) {
  var e28, n3 = t$B[s3];
  return typeof n3 == "string" ? e28 = n3 : a3 === 1 ? e28 = n3.one : e28 = n3.other.replace("{{count}}", String(a3)), o3 != null && o3.addSuffix ? o3.comparison && o3.comparison > 0 ? "em " + e28 : "h\xE1 " + e28 : e28;
};
const c$11 = r$N;
var m$V = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, d$T = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, e$R = {
  full: "{{date}} '\xE0s' {{time}}",
  long: "{{date}} '\xE0s' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, a$_ = {
  date: u$1s({
    formats: m$V,
    defaultWidth: "full"
  }),
  time: u$1s({
    formats: d$T,
    defaultWidth: "full"
  }),
  dateTime: u$1s({
    formats: e$R,
    defaultWidth: "full"
  })
};
const l$R = a$_;
var n$z = {
  lastWeek: function(t3) {
    var e28 = t3.getUTCDay(), o3 = e28 === 0 || e28 === 6 ? "\xFAltimo" : "\xFAltima";
    return "'" + o3 + "' eeee '\xE0s' p";
  },
  yesterday: "'ontem \xE0s' p",
  today: "'hoje \xE0s' p",
  tomorrow: "'amanh\xE3 \xE0s' p",
  nextWeek: "eeee '\xE0s' p",
  other: "P"
}, s$W = function(t3, e28, o3, f3) {
  var a3 = n$z[t3];
  return typeof a3 == "function" ? a3(e28) : a3;
};
const i$N = s$W;
var t$A = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "depois de cristo"]
}, o$H = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
}, d$S = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  wide: ["janeiro", "fevereiro", "mar\xE7o", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
}, m$U = {
  narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  abbreviated: ["domingo", "segunda", "ter\xE7a", "quarta", "quinta", "sexta", "s\xE1bado"],
  wide: ["domingo", "segunda-feira", "ter\xE7a-feira", "quarta-feira", "quinta-feira", "sexta-feira", "s\xE1bado"]
}, u$R = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  }
}, l$Q = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  }
}, g$v = function(e28, n3) {
  var i = Number(e28);
  return (n3 == null ? void 0 : n3.unit) === "week" ? i + "\xAA" : i + "\xBA";
}, s$V = {
  ordinalNumber: g$v,
  era: f$1h({
    values: t$A,
    defaultWidth: "wide"
  }),
  quarter: f$1h({
    values: o$H,
    defaultWidth: "wide",
    argumentCallback: function(e28) {
      return e28 - 1;
    }
  }),
  month: f$1h({
    values: d$S,
    defaultWidth: "wide"
  }),
  day: f$1h({
    values: m$U,
    defaultWidth: "wide"
  }),
  dayPeriod: f$1h({
    values: u$R,
    defaultWidth: "wide",
    formattingValues: l$Q,
    defaultFormattingWidth: "wide"
  })
};
const b$p = s$V;
var r$M = /^(\d+)[ºªo]?/i, n$y = /\d+/i, d$R = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
}, s$U = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
}, o$G = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, m$T = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, u$Q = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, h$Q = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
}, c$10 = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
}, P$o = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
}, l$P = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
}, b$o = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
}, v$r = {
  ordinalNumber: v$Z({
    matchPattern: r$M,
    parsePattern: n$y,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: o$1h({
    matchPatterns: d$R,
    defaultMatchWidth: "wide",
    parsePatterns: s$U,
    defaultParseWidth: "any"
  }),
  quarter: o$1h({
    matchPatterns: o$G,
    defaultMatchWidth: "wide",
    parsePatterns: m$T,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: o$1h({
    matchPatterns: u$Q,
    defaultMatchWidth: "wide",
    parsePatterns: h$Q,
    defaultParseWidth: "any"
  }),
  day: o$1h({
    matchPatterns: c$10,
    defaultMatchWidth: "wide",
    parsePatterns: P$o,
    defaultParseWidth: "any"
  }),
  dayPeriod: o$1h({
    matchPatterns: l$P,
    defaultMatchWidth: "any",
    parsePatterns: b$o,
    defaultParseWidth: "any"
  })
};
const y$m = v$r;
var e$Q = {
  code: "pt-BR",
  formatDistance: c$11,
  formatLong: l$R,
  formatRelative: i$N,
  localize: b$p,
  match: y$m,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const p$2M = e$Q;
const a$Z = {
  name: i$1i.portugueseBrazil,
  locale: p$2M
};
const r$L = {
  name: i$1i.portuguesePortugal,
  global: {
    undo: "Desfazer",
    redo: "Refazer",
    confirm: "Confirmar",
    clear: "Claro",
    more: "mais",
    cancel: "Cancelar"
  },
  Popconfirm: {
    positiveText: "Confirmar",
    negativeText: "Cancelar"
  },
  Cascader: {
    placeholder: "Por favor, selecione",
    loading: "A carregar",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy/MM",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "yyyy/qqq",
    clear: "Claro",
    now: "Agora",
    confirm: "Confirmar",
    selectTime: "Selecionar Tempo",
    selectDate: "Selecionar Data",
    datePlaceholder: "Selecionar Data",
    datetimePlaceholder: "Selecionar Data e Hora",
    monthPlaceholder: "Selecionar M\xEAs",
    yearPlaceholder: "Selecionar Ano",
    quarterPlaceholder: "Selecionar Trimestre",
    startDatePlaceholder: "Data de In\xEDcio",
    endDatePlaceholder: "Data de t\xE9rmino",
    startDatetimePlaceholder: "Data e Hora de In\xEDcio",
    endDatetimePlaceholder: "Data e Hora de Fim",
    startMonthPlaceholder: "M\xEAs de In\xEDcio",
    endMonthPlaceholder: "Fim do m\xEAs",
    monthBeforeYear: true,
    firstDayOfWeek: 6,
    today: "Hoje"
  },
  DataTable: {
    checkTableAll: "Selecione tudo na tabela",
    uncheckTableAll: "Desmarcar tudo na tabela",
    confirm: "Confirmar",
    clear: "Claro",
    apply: "Aplicar",
    filters: "Filtros",
    sort: "Ordenar"
  },
  LegacyTransfer: {
    sourceTitle: "Fonte",
    targetTitle: "Alvo"
  },
  Transfer: {
    selectAll: "Selecionar tudo",
    unselectAll: "Desmarcar tudo",
    clearAll: "Claro"
  },
  Empty: {
    description: "Sem Dados"
  },
  Select: {
    placeholder: "Por favor, selecione"
  },
  TimePicker: {
    placeholder: "Selecionar Tempo",
    positiveText: "OK",
    negativeText: "Cancelar",
    now: "Agora"
  },
  Pagination: {
    goto: "Ir para",
    selectionSuffix: "p\xE1gina",
    next: "Seguinte",
    previous: "Anterior"
  },
  DynamicTags: {
    add: "Adicionar"
  },
  Log: {
    loading: "A carregar"
  },
  Input: {
    placeholder: "Por favor, introduza"
  },
  InputNumber: {
    placeholder: "Por favor, introduza"
  },
  DynamicInput: {
    create: "Criar"
  },
  ThemeEditor: {
    title: "Editor de Temas",
    clearAllVars: "Limpar todas as vari\xE1veis",
    clearSearch: "Limpar pesquisa",
    filterCompName: "Nome do Componente de Filtro",
    filterVarName: "Nome da Vari\xE1vel de Filtro",
    import: "Importar",
    export: "Exportar",
    restore: "Repor para o Padr\xE3o"
  },
  Image: {
    tipPrevious: "Imagem anterior (\u2190)",
    tipNext: "Pr\xF3xima Imagem (\u2192)",
    tipCounterclockwise: "Anticlockwise",
    tipClockwise: "No sentido dos ponteiros do rel\xF3gio",
    tipZoomOut: "Afastar o zoom",
    tipZoomIn: "Ampliar",
    tipClose: "Fechar (Esc)",
    tipOriginalSize: "Ampliar para o tamanho original"
  },
  SortFilter: {
    heading: "Classificar e filtrar",
    sortHeading: "Classificar por",
    newestFirst: "Mais recentes primeiro",
    oldestFirst: "Mais antigos primeiro",
    ascending: "Crescente",
    descending: "Decrescente",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Aplicar",
    clear: "Limpar",
    cancel: "Cancelar",
    filters: "Filtros"
  },
  IconPicker: {
    noMatchingFound: "Nenhum resultado correspondente encontrado"
  }
};
var s$T = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "aproximadamente 1 hora",
    other: "aproximadamente {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "aproximadamente 1 semana",
    other: "aproximadamente {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "aproximadamente 1 m\xEAs",
    other: "aproximadamente {{count}} meses"
  },
  xMonths: {
    one: "1 m\xEAs",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "aproximadamente 1 ano",
    other: "aproximadamente {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, r$K = function(t3, n3, o3) {
  var e28, a3 = s$T[t3];
  return typeof a3 == "string" ? e28 = a3 : n3 === 1 ? e28 = a3.one : e28 = a3.other.replace("{{count}}", String(n3)), o3 != null && o3.addSuffix ? o3.comparison && o3.comparison > 0 ? "daqui a " + e28 : "h\xE1 " + e28 : e28;
};
const m$S = r$K;
var m$R = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y"
}, d$Q = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, e$P = {
  full: "{{date}} '\xE0s' {{time}}",
  long: "{{date}} '\xE0s' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, a$Y = {
  date: u$1s({
    formats: m$R,
    defaultWidth: "full"
  }),
  time: u$1s({
    formats: d$Q,
    defaultWidth: "full"
  }),
  dateTime: u$1s({
    formats: e$P,
    defaultWidth: "full"
  })
};
const l$O = a$Y;
var n$x = {
  lastWeek: function(t3) {
    var e28 = t3.getUTCDay(), o3 = e28 === 0 || e28 === 6 ? "\xFAltimo" : "\xFAltima";
    return "'" + o3 + "' eeee '\xE0s' p";
  },
  yesterday: "'ontem \xE0s' p",
  today: "'hoje \xE0s' p",
  tomorrow: "'amanh\xE3 \xE0s' p",
  nextWeek: "eeee '\xE0s' p",
  other: "P"
}, s$S = function(t3, e28, o3, f3) {
  var a3 = n$x[t3];
  return typeof a3 == "function" ? a3(e28) : a3;
};
const i$M = s$S;
var r$J = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"]
}, o$F = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
}, t$z = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  wide: ["janeiro", "fevereiro", "mar\xE7o", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
}, d$P = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"],
  wide: ["domingo", "segunda-feira", "ter\xE7a-feira", "quarta-feira", "quinta-feira", "sexta-feira", "s\xE1bado"]
}, m$Q = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  }
}, u$P = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  }
}, g$u = function(e28, l3) {
  var n3 = Number(e28);
  return n3 + "\xBA";
}, s$R = {
  ordinalNumber: g$u,
  era: f$1h({
    values: r$J,
    defaultWidth: "wide"
  }),
  quarter: f$1h({
    values: o$F,
    defaultWidth: "wide",
    argumentCallback: function(e28) {
      return e28 - 1;
    }
  }),
  month: f$1h({
    values: t$z,
    defaultWidth: "wide"
  }),
  day: f$1h({
    values: d$P,
    defaultWidth: "wide"
  }),
  dayPeriod: f$1h({
    values: m$Q,
    defaultWidth: "wide",
    formattingValues: u$P,
    defaultFormattingWidth: "wide"
  })
};
const b$n = s$R;
var r$I = /^(\d+)(º|ª)?/i, n$w = /\d+/i, s$Q = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
}, d$O = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
}, o$E = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
}, m$P = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, u$O = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, c$$ = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, h$P = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
}, P$n = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
}, l$N = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
}, b$m = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
}, f$C = {
  ordinalNumber: v$Z({
    matchPattern: r$I,
    parsePattern: n$w,
    valueCallback: function(e28) {
      return parseInt(e28, 10);
    }
  }),
  era: o$1h({
    matchPatterns: s$Q,
    defaultMatchWidth: "wide",
    parsePatterns: d$O,
    defaultParseWidth: "any"
  }),
  quarter: o$1h({
    matchPatterns: o$E,
    defaultMatchWidth: "wide",
    parsePatterns: m$P,
    defaultParseWidth: "any",
    valueCallback: function(e28) {
      return e28 + 1;
    }
  }),
  month: o$1h({
    matchPatterns: u$O,
    defaultMatchWidth: "wide",
    parsePatterns: c$$,
    defaultParseWidth: "any"
  }),
  day: o$1h({
    matchPatterns: h$P,
    defaultMatchWidth: "wide",
    parsePatterns: P$n,
    defaultParseWidth: "any"
  }),
  dayPeriod: o$1h({
    matchPatterns: l$N,
    defaultMatchWidth: "any",
    parsePatterns: b$m,
    defaultParseWidth: "any"
  })
};
const y$l = f$C;
var e$O = {
  code: "pt",
  formatDistance: m$S,
  formatLong: l$O,
  formatRelative: i$M,
  localize: b$n,
  match: y$l,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const p$2L = e$O;
const a$X = {
  name: i$1i.portuguesePortugal,
  locale: p$2L
};
const r$H = {
  name: i$1i.norwegian,
  global: {
    undo: "Angre",
    redo: "Gj\xF8r om",
    confirm: "Gj\xF8r om",
    clear: "Gj\xF8r om",
    more: "mer",
    cancel: "Kansellere"
  },
  Popconfirm: {
    positiveText: "Bekreft",
    negativeText: "Avbryt"
  },
  Cascader: {
    placeholder: "Vennligst Velg",
    loading: "Laster",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM.yyyy",
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "T\xF8m",
    now: "N\xE5",
    confirm: "Bekreft",
    selectTime: "Velg Tid",
    selectDate: "Velg Dato",
    datePlaceholder: "Velg Dato",
    datetimePlaceholder: "Velg Dato og Tid",
    monthPlaceholder: "Velg M\xE5ned",
    yearPlaceholder: "Velg \xC5r",
    quarterPlaceholder: "Velg Kvartal",
    startDatePlaceholder: "Start Dato",
    endDatePlaceholder: "Slutt Dato",
    startDatetimePlaceholder: "Start Dato og Tid",
    endDatetimePlaceholder: "Slutt Dato og Tid",
    startMonthPlaceholder: "Start M\xE5ned",
    endMonthPlaceholder: "Slutt M\xE5ned",
    monthBeforeYear: true,
    firstDayOfWeek: 0,
    today: "I Dag"
  },
  DataTable: {
    checkTableAll: "Velg alle i tabellen",
    uncheckTableAll: "Fjern markeringen av alle i tabellen",
    confirm: "Bekreft",
    clear: "T\xF8m",
    apply: "Bruk",
    filters: "Filtere",
    sort: "Sortere"
  },
  LegacyTransfer: {
    sourceTitle: "Kilde",
    targetTitle: "M\xE5l"
  },
  Transfer: {
    selectAll: "Marker alle",
    unselectAll: "Fjern alle valg",
    clearAll: "T\xF8m"
  },
  Empty: {
    description: "Ingen Data"
  },
  Select: {
    placeholder: "Vennligst Velg"
  },
  TimePicker: {
    placeholder: "Velg Tid",
    positiveText: "OK",
    negativeText: "Avbryt",
    now: "N\xE5"
  },
  Pagination: {
    goto: "G\xE5 til",
    selectionSuffix: "side",
    next: "Neste",
    previous: "Forrige"
  },
  DynamicTags: {
    add: "Legg tid"
  },
  Log: {
    loading: "Laster"
  },
  Input: {
    placeholder: "Vennligst Skriv Inn"
  },
  InputNumber: {
    placeholder: "Vennligst Skriv Inn"
  },
  DynamicInput: {
    create: "Opprett"
  },
  ThemeEditor: {
    title: "Tema Redigerer",
    clearAllVars: "T\xF8m Alle Variabler",
    clearSearch: "T\xF8m S\xF8k",
    filterCompName: "Filtrer Komponentnavn",
    filterVarName: "Filtrer Variabelnavn",
    import: "Importer",
    export: "Eksporter",
    restore: "Tilbakestill til Standard"
  },
  Image: {
    tipPrevious: "Forrige bilde (\u2190)",
    tipNext: "Neste bilde (\u2192)",
    tipCounterclockwise: "Mot klokken",
    tipClockwise: "Med klokken",
    tipZoomOut: "Zoom ut",
    tipZoomIn: "Zoom inn",
    tipClose: "Lukk (Esc)",
    tipOriginalSize: "Zoom til original st\xF8rrelse"
  },
  SortFilter: {
    heading: "Sorter og filtrer",
    sortHeading: "Sorter etter",
    newestFirst: "Nyeste f\xF8rst",
    oldestFirst: "Eldste f\xF8rst",
    ascending: "\xD8kende",
    descending: "Synkende",
    aToZ: "A-\xC5",
    zToA: "\xC5-A",
    apply: "Bruk",
    clear: "T\xF8m",
    cancel: "Avbryt",
    filters: "Filtre"
  },
  IconPicker: {
    noMatchingFound: "Ingen matchende resultater funnet"
  }
};
var u$N = {
  lessThanXSeconds: {
    one: "mindre enn ett sekund",
    other: "mindre enn {{count}} sekunder"
  },
  xSeconds: {
    one: "ett sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "et halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn ett minutt",
    other: "mindre enn {{count}} minutter"
  },
  xMinutes: {
    one: "ett minutt",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "omtrent en time",
    other: "omtrent {{count}} timer"
  },
  xHours: {
    one: "en time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dager"
  },
  aboutXWeeks: {
    one: "omtrent en uke",
    other: "omtrent {{count}} uker"
  },
  xWeeks: {
    one: "en uke",
    other: "{{count}} uker"
  },
  aboutXMonths: {
    one: "omtrent en m\xE5ned",
    other: "omtrent {{count}} m\xE5neder"
  },
  xMonths: {
    one: "en m\xE5ned",
    other: "{{count}} m\xE5neder"
  },
  aboutXYears: {
    one: "omtrent ett \xE5r",
    other: "omtrent {{count}} \xE5r"
  },
  xYears: {
    one: "ett \xE5r",
    other: "{{count}} \xE5r"
  },
  overXYears: {
    one: "over ett \xE5r",
    other: "over {{count}} \xE5r"
  },
  almostXYears: {
    one: "nesten ett \xE5r",
    other: "nesten {{count}} \xE5r"
  }
}, a$W = function(r3, o3, t3) {
  var e28, n3 = u$N[r3];
  return typeof n3 == "string" ? e28 = n3 : o3 === 1 ? e28 = n3.one : e28 = n3.other.replace("{{count}}", String(o3)), t3 != null && t3.addSuffix ? t3.comparison && t3.comparison > 0 ? "om " + e28 : e28 + " siden" : e28;
};
const m$O = a$W;
var m$N = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, a$V = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, d$N = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, e$N = {
  date: u$1s({
    formats: m$N,
    defaultWidth: "full"
  }),
  time: u$1s({
    formats: a$V,
    defaultWidth: "full"
  }),
  dateTime: u$1s({
    formats: d$N,
    defaultWidth: "full"
  })
};
const o$D = e$N;
var t$y = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i g\xE5r kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, a$U = function(e28, r3, l3, i) {
  return t$y[e28];
};
const f$B = a$U;
var t$x = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["f\xF8r Kristus", "etter Kristus"]
}, i$L = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, d$M = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."],
  wide: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]
}, o$C = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["s\xF8", "ma", "ti", "on", "to", "fr", "l\xF8"],
  abbreviated: ["s\xF8n", "man", "tir", "ons", "tor", "fre", "l\xF8r"],
  wide: ["s\xF8ndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "l\xF8rdag"]
}, m$M = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "p\xE5 morg.",
    afternoon: "p\xE5 etterm.",
    evening: "p\xE5 kvelden",
    night: "p\xE5 natten"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "p\xE5 morg.",
    afternoon: "p\xE5 etterm.",
    evening: "p\xE5 kvelden",
    night: "p\xE5 natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "p\xE5 morgenen",
    afternoon: "p\xE5 ettermiddagen",
    evening: "p\xE5 kvelden",
    night: "p\xE5 natten"
  }
}, l$M = function(e28, s3) {
  var n3 = Number(e28);
  return n3 + ".";
}, u$M = {
  ordinalNumber: l$M,
  era: f$1h({
    values: t$x,
    defaultWidth: "wide"
  }),
  quarter: f$1h({
    values: i$L,
    defaultWidth: "wide",
    argumentCallback: function(e28) {
      return e28 - 1;
    }
  }),
  month: f$1h({
    values: d$M,
    defaultWidth: "wide"
  }),
  day: f$1h({
    values: o$C,
    defaultWidth: "wide"
  }),
  dayPeriod: f$1h({
    values: m$M,
    defaultWidth: "wide"
  })
};
const v$q = u$M;
var i$K = /^(\d+)\.?/i, n$v = /\d+/i, d$L = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, s$P = {
  any: [/^f/i, /^e/i]
}, m$L = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, o$B = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, l$L = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, u$L = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, h$O = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, v$p = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, f$A = {
  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
}, P$m = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, c$_ = {
  ordinalNumber: v$Z({
    matchPattern: i$K,
    parsePattern: n$v,
    valueCallback: function(t3) {
      return parseInt(t3, 10);
    }
  }),
  era: o$1h({
    matchPatterns: d$L,
    defaultMatchWidth: "wide",
    parsePatterns: s$P,
    defaultParseWidth: "any"
  }),
  quarter: o$1h({
    matchPatterns: m$L,
    defaultMatchWidth: "wide",
    parsePatterns: o$B,
    defaultParseWidth: "any",
    valueCallback: function(t3) {
      return t3 + 1;
    }
  }),
  month: o$1h({
    matchPatterns: l$L,
    defaultMatchWidth: "wide",
    parsePatterns: u$L,
    defaultParseWidth: "any"
  }),
  day: o$1h({
    matchPatterns: h$O,
    defaultMatchWidth: "wide",
    parsePatterns: v$p,
    defaultParseWidth: "any"
  }),
  dayPeriod: o$1h({
    matchPatterns: f$A,
    defaultMatchWidth: "any",
    parsePatterns: P$m,
    defaultParseWidth: "any"
  })
};
const g$t = c$_;
var e$M = {
  code: "nb",
  formatDistance: m$O,
  formatLong: o$D,
  formatRelative: f$B,
  localize: v$q,
  match: g$t,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const s$O = e$M;
const r$G = {
  name: i$1i.norwegian,
  locale: s$O
};
const i$J = {
  name: i$1i.italian,
  global: {
    undo: "Annulla",
    redo: "Rifare",
    confirm: "Confermare",
    clear: "Chiaro",
    more: "pi\xF9",
    cancel: "Cancellare"
  },
  Popconfirm: {
    positiveText: "Confermare",
    negativeText: "Annulla"
  },
  Cascader: {
    placeholder: "Per favore seleziona.",
    loading: "Caricamento",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Chiaro",
    now: "Adesso",
    confirm: "Conferma",
    selectTime: "Seleziona l'orario",
    selectDate: "Seleziona data",
    datePlaceholder: "Seleziona la data",
    datetimePlaceholder: "Seleziona data e ora",
    monthPlaceholder: "Seleziona mese",
    yearPlaceholder: "Seleziona anno",
    quarterPlaceholder: "Seleziona il trimestre",
    startDatePlaceholder: "Data di inizio",
    endDatePlaceholder: "Data di fine",
    startDatetimePlaceholder: "Data e Ora di inizio",
    endDatetimePlaceholder: "Data e ora di fine",
    startMonthPlaceholder: "Mese di Inizio",
    endMonthPlaceholder: "Fine Mese",
    monthBeforeYear: true,
    firstDayOfWeek: 0,
    today: "Oggi"
  },
  DataTable: {
    checkTableAll: "Selezionare tutto nella tabella.",
    uncheckTableAll: "Deseleziona tutto nella tabella.",
    confirm: "Confermare",
    clear: "Chiaro",
    apply: "Applica",
    filters: "Filtri",
    sort: "Ordinare"
  },
  LegacyTransfer: {
    sourceTitle: "Fonte",
    targetTitle: "Obiettivo"
  },
  Transfer: {
    selectAll: "Seleziona tutto",
    unselectAll: "Deseleziona tutto",
    clearAll: "Chiaro"
  },
  Empty: {
    description: "Nessun dato"
  },
  Select: {
    placeholder: "Per favore seleziona"
  },
  TimePicker: {
    placeholder: "Seleziona orario",
    positiveText: "OK",
    negativeText: "Annullare",
    now: "Ora"
  },
  Pagination: {
    goto: "Andare a",
    selectionSuffix: "pagina",
    next: "Prossimo",
    previous: "Precedente"
  },
  DynamicTags: {
    add: "Aggiungi"
  },
  Log: {
    loading: "Caricamento"
  },
  Input: {
    placeholder: "Per favore, inserisci"
  },
  InputNumber: {
    placeholder: "Inserisci per favore."
  },
  DynamicInput: {
    create: "Creare"
  },
  ThemeEditor: {
    title: "Editor di temi",
    clearAllVars: "Cancella tutte le variabili",
    clearSearch: "Cancella ricerca",
    filterCompName: "Nome del componente di filtro",
    filterVarName: "Nome variabile filtro",
    import: "importazione",
    export: "Esportazione",
    restore: "Ripristina impostazioni predefinite"
  },
  Image: {
    tipPrevious: "Immagine precedente (\u2190)",
    tipNext: "Prossima immagine (\u2192)",
    tipCounterclockwise: "Controverse",
    tipClockwise: "in senso orario",
    tipZoomOut: "Allontana l'immagine",
    tipZoomIn: "Ingrandisci",
    tipClose: "Chiudi (Esc)",
    tipOriginalSize: "Ingrandisci alla dimensione originale"
  },
  SortFilter: {
    heading: "Ordina e filtra",
    sortHeading: "Ordina per",
    newestFirst: "Pi\xF9 recenti per primi",
    oldestFirst: "Pi\xF9 vecchi per primi",
    ascending: "Crescente",
    descending: "Decrescente",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Applica",
    clear: "Cancella",
    cancel: "Annulla",
    filters: "Filtri"
  },
  IconPicker: {
    noMatchingFound: "Nessun risultato corrispondente trovato"
  }
};
var r$F = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "pi\xF9 di un anno",
    other: "pi\xF9 di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
}, i$I = function(a3, t3, e28) {
  var n3, o3 = r$F[a3];
  return typeof o3 == "string" ? n3 = o3 : t3 === 1 ? n3 = o3.one : n3 = o3.other.replace("{{count}}", t3.toString()), e28 != null && e28.addSuffix ? e28.comparison && e28.comparison > 0 ? "tra " + n3 : n3 + " fa" : n3;
};
const c$Z = i$I;
var m$K = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, a$T = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, d$K = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, e$L = {
  date: u$1s({
    formats: m$K,
    defaultWidth: "full"
  }),
  time: u$1s({
    formats: a$T,
    defaultWidth: "full"
  }),
  dateTime: u$1s({
    formats: d$K,
    defaultWidth: "full"
  })
};
const l$K = e$L;
function n$u(e28, t3) {
  if (t3.length < e28)
    throw new TypeError(e28 + " argument" + (e28 > 1 ? "s" : "") + " required, but only " + t3.length + " present");
}
function o$A(e28) {
  "@babel/helpers - typeof";
  return o$A = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t3) {
    return typeof t3;
  } : function(t3) {
    return t3 && typeof Symbol == "function" && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
  }, o$A(e28);
}
function a$S(e28) {
  n$u(1, arguments);
  var t3 = Object.prototype.toString.call(e28);
  return e28 instanceof Date || o$A(e28) === "object" && t3 === "[object Date]" ? new Date(e28.getTime()) : typeof e28 == "number" || t3 === "[object Number]" ? new Date(e28) : ((typeof e28 == "string" || t3 === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function n$t(a3) {
  if (a3 === null || a3 === true || a3 === false)
    return NaN;
  var e28 = Number(a3);
  return isNaN(e28) ? e28 : e28 < 0 ? Math.ceil(e28) : Math.floor(e28);
}
var t$w = {};
function e$K() {
  return t$w;
}
function C$y(O3, e28) {
  var l3, r3, a3, i, n3, d3, v3, u3;
  n$u(1, arguments);
  var s3 = e$K(), o3 = n$t((l3 = (r3 = (a3 = (i = e28 == null ? void 0 : e28.weekStartsOn) !== null && i !== void 0 ? i : e28 == null || (n3 = e28.locale) === null || n3 === void 0 || (d3 = n3.options) === null || d3 === void 0 ? void 0 : d3.weekStartsOn) !== null && a3 !== void 0 ? a3 : s3.weekStartsOn) !== null && r3 !== void 0 ? r3 : (v3 = s3.locale) === null || v3 === void 0 || (u3 = v3.options) === null || u3 === void 0 ? void 0 : u3.weekStartsOn) !== null && l3 !== void 0 ? l3 : 0);
  if (!(o3 >= 0 && o3 <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var t3 = a$S(O3), f3 = t3.getUTCDay(), m3 = (f3 < o3 ? 7 : 0) + f3 - o3;
  return t3.setUTCDate(t3.getUTCDate() - m3), t3.setUTCHours(0, 0, 0, 0), t3;
}
function d$J(r3, a3, e28) {
  n$u(2, arguments);
  var f3 = C$y(r3, e28), m3 = C$y(a3, e28);
  return f3.getTime() === m3.getTime();
}
var l$J = ["domenica", "luned\xEC", "marted\xEC", "mercoled\xEC", "gioved\xEC", "venerd\xEC", "sabato"];
function u$K(e28) {
  switch (e28) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + l$J[e28] + " scorso alle' p";
  }
}
function s$N(e28) {
  return "'" + l$J[e28] + " alle' p";
}
function f$z(e28) {
  switch (e28) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + l$J[e28] + " prossimo alle' p";
  }
}
var c$Y = {
  lastWeek: function(t3, a3, o3) {
    var r3 = t3.getUTCDay();
    return d$J(t3, a3, o3) ? s$N(r3) : u$K(r3);
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: function(t3, a3, o3) {
    var r3 = t3.getUTCDay();
    return d$J(t3, a3, o3) ? s$N(r3) : f$z(r3);
  },
  other: "P"
}, m$J = function(t3, a3, o3, r3) {
  var n3 = c$Y[t3];
  return typeof n3 == "function" ? n3(a3, o3, r3) : n3;
};
const p$2K = m$J;
var n$s = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
}, t$v = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
}, r$E = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
  wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
}, m$I = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: ["domenica", "luned\xEC", "marted\xEC", "mercoled\xEC", "gioved\xEC", "venerd\xEC", "sabato"]
}, d$I = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
}, g$s = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
}, l$I = function(a3, s3) {
  var i = Number(a3);
  return String(i);
}, u$J = {
  ordinalNumber: l$I,
  era: f$1h({
    values: n$s,
    defaultWidth: "wide"
  }),
  quarter: f$1h({
    values: t$v,
    defaultWidth: "wide",
    argumentCallback: function(a3) {
      return a3 - 1;
    }
  }),
  month: f$1h({
    values: r$E,
    defaultWidth: "wide"
  }),
  day: f$1h({
    values: m$I,
    defaultWidth: "wide"
  }),
  dayPeriod: f$1h({
    values: d$I,
    defaultWidth: "wide",
    formattingValues: g$s,
    defaultFormattingWidth: "wide"
  })
};
const b$l = u$J;
var r$D = /^(\d+)(º)?/i, n$r = /\d+/i, o$z = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
}, d$H = {
  any: [/^a/i, /^(d|e)/i]
}, m$H = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, s$M = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, l$H = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
}, g$r = {
  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, h$N = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
}, v$o = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
}, u$I = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
}, P$l = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
}, c$X = {
  ordinalNumber: v$Z({
    matchPattern: r$D,
    parsePattern: n$r,
    valueCallback: function(t3) {
      return parseInt(t3, 10);
    }
  }),
  era: o$1h({
    matchPatterns: o$z,
    defaultMatchWidth: "wide",
    parsePatterns: d$H,
    defaultParseWidth: "any"
  }),
  quarter: o$1h({
    matchPatterns: m$H,
    defaultMatchWidth: "wide",
    parsePatterns: s$M,
    defaultParseWidth: "any",
    valueCallback: function(t3) {
      return t3 + 1;
    }
  }),
  month: o$1h({
    matchPatterns: l$H,
    defaultMatchWidth: "wide",
    parsePatterns: g$r,
    defaultParseWidth: "any"
  }),
  day: o$1h({
    matchPatterns: h$N,
    defaultMatchWidth: "wide",
    parsePatterns: v$o,
    defaultParseWidth: "any"
  }),
  dayPeriod: o$1h({
    matchPatterns: u$I,
    defaultMatchWidth: "any",
    parsePatterns: P$l,
    defaultParseWidth: "any"
  })
};
const f$y = c$X;
var e$J = {
  code: "it",
  formatDistance: c$Z,
  formatLong: l$K,
  formatRelative: p$2K,
  localize: b$l,
  match: f$y,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const s$L = e$J;
const i$H = {
  name: i$1i.italian,
  locale: s$L
};
const n$q = {
  name: i$1i.german,
  global: {
    undo: "R\xFCckg\xE4ngig machen",
    redo: "Wiederholen",
    confirm: "Best\xE4tigen Sie",
    clear: "L\xF6schen",
    more: "mehr",
    cancel: "Stornieren"
  },
  Popconfirm: {
    positiveText: "Best\xE4tigen",
    negativeText: "Abbrechen"
  },
  Cascader: {
    placeholder: "Bitte ausw\xE4hlen",
    loading: "Laden",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM-yyyy",
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "L\xF6schen",
    now: "Jetzt",
    confirm: "Best\xE4tigen Sie",
    selectTime: "Zeit ausw\xE4hlen",
    selectDate: "Datum ausw\xE4hlen",
    datePlaceholder: "Datum ausw\xE4hlen",
    datetimePlaceholder: "Datum und Uhrzeit w\xE4hlen",
    monthPlaceholder: "Monat w\xE4hlen",
    yearPlaceholder: "Jahr w\xE4hlen",
    quarterPlaceholder: "Quartal w\xE4hlen",
    startDatePlaceholder: "Startdatum",
    endDatePlaceholder: "Enddatum",
    startDatetimePlaceholder: "Startdatum und Uhrzeit",
    endDatetimePlaceholder: "Enddatum und -uhrzeit",
    startMonthPlaceholder: "Monat beginnen",
    endMonthPlaceholder: "Ende Monat",
    monthBeforeYear: true,
    firstDayOfWeek: 0,
    today: "Heute"
  },
  DataTable: {
    checkTableAll: "Alles in der Tabelle markieren",
    uncheckTableAll: "Alle in der Tabelle abw\xE4hlen",
    confirm: "Best\xE4tigen",
    clear: "L\xF6schen",
    apply: "Anwenden",
    filters: "Filtern",
    sort: "Sortieren"
  },
  LegacyTransfer: {
    sourceTitle: "Quelle",
    targetTitle: "Ziel"
  },
  Transfer: {
    selectAll: "Alles ausw\xE4hlen",
    unselectAll: "Alle abw\xE4hlen",
    clearAll: "L\xF6schen"
  },
  Empty: {
    description: "Keine Daten"
  },
  Select: {
    placeholder: "Bitte ausw\xE4hlen"
  },
  TimePicker: {
    placeholder: "Zeit ausw\xE4hlen",
    positiveText: "OK",
    negativeText: "Abbrechen",
    now: "Jetzt"
  },
  Pagination: {
    goto: "Gehe zu",
    selectionSuffix: "Seite",
    next: "N\xE4chste",
    previous: "Vorherige"
  },
  DynamicTags: {
    add: "hinzuf\xFCgen"
  },
  Log: {
    loading: "Laden"
  },
  Input: {
    placeholder: "Bitte eingeben"
  },
  InputNumber: {
    placeholder: "Bitte eingeben"
  },
  DynamicInput: {
    create: "erstellen"
  },
  ThemeEditor: {
    title: "Themen-Editor",
    clearAllVars: "Alle Variablen l\xF6schen",
    clearSearch: "Suche l\xF6schen",
    filterCompName: "Komponentenname filtern",
    filterVarName: "Variablenname filtern",
    import: "Importieren",
    export: "Exportieren",
    restore: "Auf Standard zur\xFCcksetzen"
  },
  Image: {
    tipPrevious: "Vorheriges Bild (\u2190)",
    tipNext: "N\xE4chstes Bild (\u2192)",
    tipCounterclockwise: "Gegen den Uhrzeigersinn",
    tipClockwise: "Im Uhrzeigersinn",
    tipZoomOut: "Verkleinern",
    tipZoomIn: "Einzoomen",
    tipClose: "Schlie\xDFen (Esc)",
    tipOriginalSize: "Auf Originalgr\xF6\xDFe zoomen"
  },
  SortFilter: {
    heading: "Sortieren und filtern",
    sortHeading: "Sortieren nach",
    newestFirst: "Neueste zuerst",
    oldestFirst: "\xC4lteste zuerst",
    ascending: "Aufsteigend",
    descending: "Absteigend",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Anwenden",
    clear: "L\xF6schen",
    cancel: "Abbrechen",
    filters: "Filter"
  },
  IconPicker: {
    noMatchingFound: "Keine \xFCbereinstimmenden Ergebnisse gefunden"
  }
};
var r$C = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "halbe Minute",
    withPreposition: "halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, h$M = function(o3, a3, e28) {
  var n3, t3 = e28 != null && e28.addSuffix ? r$C[o3].withPreposition : r$C[o3].standalone;
  return typeof t3 == "string" ? n3 = t3 : a3 === 1 ? n3 = t3.one : n3 = t3.other.replace("{{count}}", String(a3)), e28 != null && e28.addSuffix ? e28.comparison && e28.comparison > 0 ? "in " + n3 : "vor " + n3 : n3;
};
const s$K = h$M;
var m$G = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "dd.MM.y"
}, a$R = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, o$y = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, d$G = {
  date: u$1s({
    formats: m$G,
    defaultWidth: "full"
  }),
  time: u$1s({
    formats: a$R,
    defaultWidth: "full"
  }),
  dateTime: u$1s({
    formats: o$y,
    defaultWidth: "full"
  })
};
const l$G = d$G;
var t$u = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, a$Q = function(e28, r3, m3, n3) {
  return t$u[e28];
};
const u$H = a$Q;
var i$G = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, o$x = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, t$t = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "M\xE4r", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Januar", "Februar", "M\xE4rz", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
}, m$F = {
  narrow: t$t.narrow,
  abbreviated: ["Jan.", "Feb.", "M\xE4rz", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: t$t.wide
}, g$q = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
}, d$F = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, u$G = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, h$L = function(n3) {
  var r3 = Number(n3);
  return r3 + ".";
}, l$F = {
  ordinalNumber: h$L,
  era: f$1h({
    values: i$G,
    defaultWidth: "wide"
  }),
  quarter: f$1h({
    values: o$x,
    defaultWidth: "wide",
    argumentCallback: function(n3) {
      return n3 - 1;
    }
  }),
  month: f$1h({
    values: t$t,
    formattingValues: m$F,
    defaultWidth: "wide"
  }),
  day: f$1h({
    values: g$q,
    defaultWidth: "wide"
  }),
  dayPeriod: f$1h({
    values: d$F,
    defaultWidth: "wide",
    formattingValues: u$G,
    defaultFormattingWidth: "wide"
  })
};
const v$n = l$F;
var e$I = /^(\d+)(\.)?/i, n$p = /\d+/i, s$J = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, d$E = {
  any: [/^v/i, /^n/i]
}, m$E = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, h$K = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, o$w = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, u$F = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, c$W = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, v$m = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, l$E = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, P$k = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    evening: /abends/i,
    night: /nachts/i
  }
}, b$k = {
  ordinalNumber: v$Z({
    matchPattern: e$I,
    parsePattern: n$p,
    valueCallback: function(t3) {
      return parseInt(t3);
    }
  }),
  era: o$1h({
    matchPatterns: s$J,
    defaultMatchWidth: "wide",
    parsePatterns: d$E,
    defaultParseWidth: "any"
  }),
  quarter: o$1h({
    matchPatterns: m$E,
    defaultMatchWidth: "wide",
    parsePatterns: h$K,
    defaultParseWidth: "any",
    valueCallback: function(t3) {
      return t3 + 1;
    }
  }),
  month: o$1h({
    matchPatterns: o$w,
    defaultMatchWidth: "wide",
    parsePatterns: u$F,
    defaultParseWidth: "any"
  }),
  day: o$1h({
    matchPatterns: c$W,
    defaultMatchWidth: "wide",
    parsePatterns: v$m,
    defaultParseWidth: "any"
  }),
  dayPeriod: o$1h({
    matchPatterns: l$E,
    defaultMatchWidth: "wide",
    parsePatterns: P$k,
    defaultParseWidth: "any"
  })
};
const p$2J = b$k;
var m$D = {
  code: "de",
  formatDistance: s$K,
  formatLong: l$G,
  formatRelative: u$H,
  localize: v$n,
  match: p$2J,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const s$I = m$D;
const r$B = {
  name: i$1i.german,
  locale: s$I
};
const t$s = {
  name: i$1i.frenchFrance,
  global: {
    undo: "Annuler",
    redo: "R\xE9tablir",
    confirm: "Confirmer",
    clear: "Effacer",
    more: "plus",
    cancel: "Annuler"
  },
  Popconfirm: {
    positiveText: "Confirmer",
    negativeText: "Annuler"
  },
  Cascader: {
    placeholder: "Veuillez s\xE9lectionner",
    loading: "Chargement",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM/yyyy",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "qqq yyyy",
    clear: "Effacer",
    now: "Maintenant",
    confirm: "Confirmer",
    selectTime: "S\xE9lectionner l'heure",
    selectDate: "S\xE9lectionner la date",
    datePlaceholder: "S\xE9lectionner la date",
    datetimePlaceholder: "S\xE9lectionner la date et l'heure",
    monthPlaceholder: "S\xE9lectionner le mois",
    yearPlaceholder: "S\xE9lectionner l'ann\xE9e",
    quarterPlaceholder: "S\xE9lectionner le trimestre",
    startDatePlaceholder: "Date de d\xE9but",
    endDatePlaceholder: "Date de fin",
    startDatetimePlaceholder: "Heure de d\xE9but",
    endDatetimePlaceholder: "Heure de fin",
    startMonthPlaceholder: "Mois de d\xE9but",
    endMonthPlaceholder: "Mois de fin",
    monthBeforeYear: true,
    firstDayOfWeek: 1,
    today: "Aujourd'hui"
  },
  DataTable: {
    checkTableAll: "S\xE9lectionner tout dans le tableau",
    uncheckTableAll: "D\xE9selectionner tout dans le tableau",
    confirm: "Confirmer",
    clear: "Effacer",
    apply: "Appliquer",
    filters: "Filtres",
    sort: "Trier"
  },
  LegacyTransfer: {
    sourceTitle: "Source",
    targetTitle: "Cible"
  },
  Transfer: {
    selectAll: "S\xE9lectionner tout",
    unselectAll: "D\xE9s\xE9lectionner tout",
    clearAll: "Effacer"
  },
  Empty: {
    description: "Pas de donn\xE9es"
  },
  Select: {
    placeholder: "Veuillez s\xE9lectionner"
  },
  TimePicker: {
    placeholder: "S\xE9lectionner l'heure",
    positiveText: "OK",
    negativeText: "Annuler",
    now: "Maintenant"
  },
  Pagination: {
    goto: "Aller \xE0",
    selectionSuffix: "page",
    next: "Suivant",
    previous: "Pr\xE9c\xE9dent"
  },
  DynamicTags: {
    add: "Ajouter"
  },
  Log: {
    loading: "Chargement"
  },
  Input: {
    placeholder: "Veuillez entrer"
  },
  InputNumber: {
    placeholder: "Veuillez entrer"
  },
  DynamicInput: {
    create: "Cr\xE9er"
  },
  ThemeEditor: {
    title: "\xC9diteur de th\xE8me",
    clearAllVars: "Effacer toutes les variables",
    clearSearch: "Effacer la recherche",
    filterCompName: "Filtrer le nom de l'\xE9l\xE9ment",
    filterVarName: "Filtrer le nom de la variable",
    import: "Importer",
    export: "Exporter",
    restore: "Remise \xE0 l'\xE9tat initial"
  },
  Image: {
    tipPrevious: "Image pr\xE9c\xE9dente (\u2190)",
    tipNext: "Image suivante (\u2192)",
    tipCounterclockwise: "Sens antihoraire",
    tipClockwise: "Sens horaire",
    tipZoomOut: "Zoom arri\xE8re",
    tipZoomIn: "Zoom avant",
    tipClose: "Fermer (Esc)",
    tipOriginalSize: "Zoom sur la taille originale"
  },
  SortFilter: {
    heading: "Trier et filtrer",
    sortHeading: "Trier par",
    newestFirst: "Plus r\xE9cent en premier",
    oldestFirst: "Plus ancien en premier",
    ascending: "Croissant",
    descending: "D\xE9croissant",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Appliquer",
    clear: "Effacer",
    cancel: "Annuler",
    filters: "Filtres"
  },
  IconPicker: {
    noMatchingFound: "Aucun r\xE9sultat correspondant trouv\xE9"
  }
};
var t$r = {
  lessThanXSeconds: {
    one: "moins d\u2019une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d\u2019une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d\u2019un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu\u2019un an",
    other: "presque {{count}} ans"
  }
}, u$E = function(r3, s3, n3) {
  var e28, o3 = t$r[r3];
  return typeof o3 == "string" ? e28 = o3 : s3 === 1 ? e28 = o3.one : e28 = o3.other.replace("{{count}}", String(s3)), n3 != null && n3.addSuffix ? n3.comparison && n3.comparison > 0 ? "dans " + e28 : "il y a " + e28 : e28;
};
const i$F = u$E;
var m$C = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, a$P = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, d$D = {
  full: "{{date}} '\xE0' {{time}}",
  long: "{{date}} '\xE0' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, e$H = {
  date: u$1s({
    formats: m$C,
    defaultWidth: "full"
  }),
  time: u$1s({
    formats: a$P,
    defaultWidth: "full"
  }),
  dateTime: u$1s({
    formats: d$D,
    defaultWidth: "full"
  })
};
const l$D = e$H;
var a$O = {
  lastWeek: "eeee 'dernier \xE0' p",
  yesterday: "'hier \xE0' p",
  today: "'aujourd\u2019hui \xE0' p",
  tomorrow: "'demain \xE0' p'",
  nextWeek: "eeee 'prochain \xE0' p",
  other: "P"
}, t$q = function(e28, o3, i, n3) {
  return a$O[e28];
};
const p$2I = t$q;
var u$D = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant J\xE9sus-Christ", "apr\xE8s J\xE9sus-Christ"]
}, o$v = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2\xE8me trim.", "3\xE8me trim.", "4\xE8me trim."],
  wide: ["1er trimestre", "2\xE8me trimestre", "3\xE8me trimestre", "4\xE8me trimestre"]
}, l$C = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "f\xE9vr.", "mars", "avr.", "mai", "juin", "juil.", "ao\xFBt", "sept.", "oct.", "nov.", "d\xE9c."],
  wide: ["janvier", "f\xE9vrier", "mars", "avril", "mai", "juin", "juillet", "ao\xFBt", "septembre", "octobre", "novembre", "d\xE9cembre"]
}, v$l = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
}, s$H = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "apr\xE8s-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l\u2019apr\xE8s-midi",
    evening: "du soir",
    night: "du matin"
  }
}, b$j = function(i, r3) {
  var a3 = Number(i), t3 = r3 == null ? void 0 : r3.unit;
  if (a3 === 0)
    return "0";
  var d3 = ["year", "week", "hour", "minute", "second"], n3;
  return a3 === 1 ? n3 = t3 && d3.includes(t3) ? "\xE8re" : "er" : n3 = "\xE8me", a3 + n3;
}, f$x = {
  ordinalNumber: b$j,
  era: f$1h({
    values: u$D,
    defaultWidth: "wide"
  }),
  quarter: f$1h({
    values: o$v,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: f$1h({
    values: l$C,
    defaultWidth: "wide"
  }),
  day: f$1h({
    values: v$l,
    defaultWidth: "wide"
  }),
  dayPeriod: f$1h({
    values: s$H,
    defaultWidth: "wide"
  })
};
const c$V = f$x;
var e$G = /^(\d+)(ième|ère|ème|er|e)?/i, n$o = /\d+/i, d$C = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, m$B = {
  any: [/^av/i, /^ap/i]
}, s$G = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, u$C = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, l$B = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, o$u = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, v$k = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, h$J = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, c$U = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, P$j = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, p$2H = {
  ordinalNumber: v$Z({
    matchPattern: e$G,
    parsePattern: n$o,
    valueCallback: function(i) {
      return parseInt(i);
    }
  }),
  era: o$1h({
    matchPatterns: d$C,
    defaultMatchWidth: "wide",
    parsePatterns: m$B,
    defaultParseWidth: "any"
  }),
  quarter: o$1h({
    matchPatterns: s$G,
    defaultMatchWidth: "wide",
    parsePatterns: u$C,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: o$1h({
    matchPatterns: l$B,
    defaultMatchWidth: "wide",
    parsePatterns: o$u,
    defaultParseWidth: "any"
  }),
  day: o$1h({
    matchPatterns: v$k,
    defaultMatchWidth: "wide",
    parsePatterns: h$J,
    defaultParseWidth: "any"
  }),
  dayPeriod: o$1h({
    matchPatterns: c$U,
    defaultMatchWidth: "any",
    parsePatterns: P$j,
    defaultParseWidth: "any"
  })
};
const j$7 = p$2H;
var e$F = {
  code: "fr",
  formatDistance: i$F,
  formatLong: l$D,
  formatRelative: p$2I,
  localize: c$V,
  match: j$7,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const s$F = e$F;
const f$w = {
  name: i$1i.frenchFrance,
  locale: s$F
};
const t$p = {
  name: i$1i.frenchCanada,
  global: {
    undo: "Annuler",
    redo: "R\xE9tablir",
    confirm: "Confirmer",
    clear: "Effacer",
    more: "plus",
    cancel: "Annuler"
  },
  Popconfirm: {
    positiveText: "Confirmer",
    negativeText: "Effacer"
  },
  Cascader: {
    placeholder: "Veuillez s\xE9lectionner",
    loading: "Chargement",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM/yyyy",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "qqq yyyy",
    clear: "Effacer",
    now: "Maintenant",
    confirm: "Confirmer",
    selectTime: "S\xE9lectionner l'heure",
    selectDate: "S\xE9lectionner la date",
    datePlaceholder: "S\xE9lectionner une date",
    datetimePlaceholder: "S\xE9lectionner la date et l'heure",
    monthPlaceholder: "S\xE9lectionner le mois",
    yearPlaceholder: "S\xE9lectionner l'ann\xE9e",
    quarterPlaceholder: "S\xE9lectionner le trimestre",
    startDatePlaceholder: "Date de d\xE9but",
    endDatePlaceholder: "Date de fin",
    startDatetimePlaceholder: "Date et heure de d\xE9but",
    endDatetimePlaceholder: "Date et heure de fin",
    startMonthPlaceholder: "Mois de d\xE9but",
    endMonthPlaceholder: "Mois de fin",
    monthBeforeYear: true,
    firstDayOfWeek: 1,
    today: "Aujourd'hui"
  },
  DataTable: {
    checkTableAll: "S\xE9lectionner tout dans le tableau",
    uncheckTableAll: "D\xE9selectionner tout dans le tableau",
    confirm: "Confirmer",
    clear: "Effacer",
    apply: "Appliquer",
    filters: "Filtres",
    sort: "Trier"
  },
  LegacyTransfer: {
    sourceTitle: "Source",
    targetTitle: "Cible"
  },
  Transfer: {
    selectAll: "Tout s\xE9lectionner",
    unselectAll: "Tout d\xE9s\xE9lectionner",
    clearAll: "Effacer"
  },
  Empty: {
    description: "Aucune donn\xE9e"
  },
  Select: {
    placeholder: "Veuillez s\xE9lectionner"
  },
  TimePicker: {
    placeholder: "S\xE9lectionner l'heure",
    positiveText: "OK",
    negativeText: "Annuler",
    now: "Maintenant"
  },
  Pagination: {
    goto: "Aller \xE0",
    selectionSuffix: "page",
    next: "Suivant",
    previous: "Pr\xE9c\xE9dent"
  },
  DynamicTags: {
    add: "Ajouter"
  },
  Log: {
    loading: "Chargement"
  },
  Input: {
    placeholder: "Veuillez entrer"
  },
  InputNumber: {
    placeholder: "Veuillez entrer"
  },
  DynamicInput: {
    create: "Cr\xE9er"
  },
  ThemeEditor: {
    title: "\xC9diteur de th\xE8me",
    clearAllVars: "Effacer toutes les variables",
    clearSearch: "Effacer la recherche",
    filterCompName: "Filtrer le nom du composant",
    filterVarName: "Filtrer le nom de la variable",
    import: "Importer",
    export: "Exporter",
    restore: "R\xE9initialiser par d\xE9faut"
  },
  Image: {
    tipPrevious: "Image pr\xE9c\xE9dente (\u2190)",
    tipNext: "Image suivante (\u2192)",
    tipCounterclockwise: "Dans le sens antihoraire",
    tipClockwise: "Dans le sens horaire",
    tipZoomOut: "Zoom arri\xE8re",
    tipZoomIn: "Zoom avant",
    tipClose: "Fermer (Esc)",
    tipOriginalSize: "Zoom \xE0 la taille d'origine"
  },
  SortFilter: {
    heading: "Trier et filtrer",
    sortHeading: "Trier par",
    newestFirst: "Plus r\xE9cent en premier",
    oldestFirst: "Plus ancien en premier",
    ascending: "Croissant",
    descending: "D\xE9croissant",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Appliquer",
    clear: "Effacer",
    cancel: "Annuler",
    filters: "Filtres"
  },
  IconPicker: {
    noMatchingFound: "Aucun r\xE9sultat correspondant trouv\xE9"
  }
};
var m$A = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "yy-MM-dd"
}, a$N = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, d$B = {
  full: "{{date}} '\xE0' {{time}}",
  long: "{{date}} '\xE0' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, e$E = {
  date: u$1s({
    formats: m$A,
    defaultWidth: "full"
  }),
  time: u$1s({
    formats: a$N,
    defaultWidth: "full"
  }),
  dateTime: u$1s({
    formats: d$B,
    defaultWidth: "full"
  })
};
const l$A = e$E;
var e$D = {
  code: "fr-CA",
  formatDistance: i$F,
  formatLong: l$A,
  formatRelative: p$2I,
  localize: c$V,
  match: j$7,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const s$E = e$D;
const f$v = {
  name: i$1i.frenchCanada,
  locale: s$E
};
const t$o = {
  name: i$1i.finnish,
  global: {
    undo: "Kumoa",
    redo: "tehd\xE4 uudelleen",
    confirm: "Vahvista",
    clear: "Selv\xE4",
    more: "lis\xE4\xE4",
    cancel: "Peruuttaa"
  },
  Popconfirm: {
    positiveText: "vahvista",
    negativeText: "Peruuta"
  },
  Cascader: {
    placeholder: "Valitse, ole hyv\xE4",
    loading: "Ladataan",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "selv\xE4",
    now: "Nyt",
    confirm: "Vahvistaa",
    selectTime: "Valitse aika",
    selectDate: "Valitse p\xE4iv\xE4m\xE4\xE4r\xE4",
    datePlaceholder: "Valitse p\xE4iv\xE4m\xE4\xE4r\xE4",
    datetimePlaceholder: "Valitse p\xE4iv\xE4m\xE4\xE4r\xE4 ja aika",
    monthPlaceholder: "Valitse kuukausi",
    yearPlaceholder: "Valitse vuosi",
    quarterPlaceholder: "Valitse nelj\xE4nnes",
    startDatePlaceholder: "Aloitus p\xE4iv\xE4m\xE4\xE4r\xE4",
    endDatePlaceholder: "P\xE4\xE4ttymisp\xE4iv\xE4m\xE4\xE4r\xE4",
    startDatetimePlaceholder: "Aloitusajankohta ja -aika",
    endDatetimePlaceholder: "P\xE4\xE4t\xF6sp\xE4iv\xE4 ja aika",
    startMonthPlaceholder: "Aloituskuukausi",
    endMonthPlaceholder: "Lopun kuukausi",
    monthBeforeYear: true,
    firstDayOfWeek: 6,
    today: "T\xE4n\xE4\xE4n"
  },
  DataTable: {
    checkTableAll: "Valitse kaikki taulukosta",
    uncheckTableAll: "Poista valinnat taulukosta",
    confirm: "Vahvista",
    clear: "Selv\xE4",
    apply: "Ans\xF8g",
    filters: "Suodattimet",
    sort: "Lajitella"
  },
  LegacyTransfer: {
    sourceTitle: "L\xE4hde",
    targetTitle: "kohde"
  },
  Transfer: {
    selectAll: "Valitse kaikki",
    unselectAll: "Poista kaikki valinnat",
    clearAll: "Kirkas"
  },
  Empty: {
    description: "Ei dataa"
  },
  Select: {
    placeholder: "Valitse, kiitos"
  },
  TimePicker: {
    placeholder: "Valitse aika",
    positiveText: "OK",
    negativeText: "peruuttaa",
    now: "Nyt"
  },
  Pagination: {
    goto: "Siirry",
    selectionSuffix: "sivu",
    next: "Seuraava",
    previous: "Edellinen"
  },
  DynamicTags: {
    add: "Lis\xE4\xE4"
  },
  Log: {
    loading: "Lataus"
  },
  Input: {
    placeholder: "Sy\xF6t\xE4th\xE4n tiedot"
  },
  InputNumber: {
    placeholder: "Sy\xF6t\xE4 kiitos"
  },
  DynamicInput: {
    create: "Luoda"
  },
  ThemeEditor: {
    title: "Teeman muokkaaja",
    clearAllVars: "Poista kaikki muuttujat",
    clearSearch: "Tyhjenn\xE4 haku",
    filterCompName: "Suodatin osan nimi",
    filterVarName: "Suodattimen muuttujan nimi",
    import: "Tuonti",
    export: "Vienti",
    restore: "Nollaa oletusarvoihin"
  },
  Image: {
    tipPrevious: "Edellinen kuva (\u2190)",
    tipNext: "Seuraava kuva (\u2192)",
    tipCounterclockwise: "Vastap\xE4iv\xE4\xE4n",
    tipClockwise: "My\xF6t\xE4p\xE4iv\xE4\xE4n",
    tipZoomOut: "Zoomaa ulos",
    tipZoomIn: "L\xE4henn\xE4",
    tipClose: "Sulje (Esc)",
    tipOriginalSize: "Zoomaa alkuper\xE4iseen kokoon"
  },
  SortFilter: {
    heading: "Lajittele ja suodata",
    sortHeading: "Lajittele mukaan",
    newestFirst: "Uusimmat ensin",
    oldestFirst: "Vanhimmat ensin",
    ascending: "Nouseva",
    descending: "Laskeva",
    aToZ: "A-\xD6",
    zToA: "\xD6-A",
    apply: "K\xE4yt\xE4",
    clear: "Tyhjenn\xE4",
    cancel: "Peruuta",
    filters: "Suodattimet"
  },
  IconPicker: {
    noMatchingFound: "Ei vastaavia tuloksia l\xF6ytynyt"
  }
};
function a$M(e28) {
  return e28.replace(/sekuntia?/, "sekunnin");
}
function s$D(e28) {
  return e28.replace(/minuuttia?/, "minuutin");
}
function f$u(e28) {
  return e28.replace(/tuntia?/, "tunnin");
}
function l$z(e28) {
  return e28.replace(/päivää?/, "p\xE4iv\xE4n");
}
function c$T(e28) {
  return e28.replace(/(viikko|viikkoa)/, "viikon");
}
function k$j(e28) {
  return e28.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function t$n(e28) {
  return e28.replace(/(vuosi|vuotta)/, "vuoden");
}
var v$j = {
  lessThanXSeconds: {
    one: "alle sekunti",
    other: "alle {{count}} sekuntia",
    futureTense: a$M
  },
  xSeconds: {
    one: "sekunti",
    other: "{{count}} sekuntia",
    futureTense: a$M
  },
  halfAMinute: {
    one: "puoli minuuttia",
    other: "puoli minuuttia",
    futureTense: function(r3) {
      return "puolen minuutin";
    }
  },
  lessThanXMinutes: {
    one: "alle minuutti",
    other: "alle {{count}} minuuttia",
    futureTense: s$D
  },
  xMinutes: {
    one: "minuutti",
    other: "{{count}} minuuttia",
    futureTense: s$D
  },
  aboutXHours: {
    one: "noin tunti",
    other: "noin {{count}} tuntia",
    futureTense: f$u
  },
  xHours: {
    one: "tunti",
    other: "{{count}} tuntia",
    futureTense: f$u
  },
  xDays: {
    one: "p\xE4iv\xE4",
    other: "{{count}} p\xE4iv\xE4\xE4",
    futureTense: l$z
  },
  aboutXWeeks: {
    one: "noin viikko",
    other: "noin {{count}} viikkoa",
    futureTense: c$T
  },
  xWeeks: {
    one: "viikko",
    other: "{{count}} viikkoa",
    futureTense: c$T
  },
  aboutXMonths: {
    one: "noin kuukausi",
    other: "noin {{count}} kuukautta",
    futureTense: k$j
  },
  xMonths: {
    one: "kuukausi",
    other: "{{count}} kuukautta",
    futureTense: k$j
  },
  aboutXYears: {
    one: "noin vuosi",
    other: "noin {{count}} vuotta",
    futureTense: t$n
  },
  xYears: {
    one: "vuosi",
    other: "{{count}} vuotta",
    futureTense: t$n
  },
  overXYears: {
    one: "yli vuosi",
    other: "yli {{count}} vuotta",
    futureTense: t$n
  },
  almostXYears: {
    one: "l\xE4hes vuosi",
    other: "l\xE4hes {{count}} vuotta",
    futureTense: t$n
  }
}, h$I = function(r3, i, u3) {
  var n3 = v$j[r3], o3 = i === 1 ? n3.one : n3.other.replace("{{count}}", String(i));
  return u3 != null && u3.addSuffix ? u3.comparison && u3.comparison > 0 ? n3.futureTense(o3) + " kuluttua" : o3 + " sitten" : o3;
};
const T$i = h$I;
var m$z = {
  full: "eeee d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "d.M.y"
}, e$C = {
  full: "HH.mm.ss zzzz",
  long: "HH.mm.ss z",
  medium: "HH.mm.ss",
  short: "HH.mm"
}, a$L = {
  full: "{{date}} 'klo' {{time}}",
  long: "{{date}} 'klo' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, o$t = {
  date: u$1s({
    formats: m$z,
    defaultWidth: "full"
  }),
  time: u$1s({
    formats: e$C,
    defaultWidth: "full"
  }),
  dateTime: u$1s({
    formats: a$L,
    defaultWidth: "full"
  })
};
const l$y = o$t;
var t$m = {
  lastWeek: "'viime' eeee 'klo' p",
  yesterday: "'eilen klo' p",
  today: "'t\xE4n\xE4\xE4n klo' p",
  tomorrow: "'huomenna klo' p",
  nextWeek: "'ensi' eeee 'klo' p",
  other: "P"
}, o$s = function(e28, l3, r3, n3) {
  return t$m[e28];
};
const i$E = o$s;
var r$A = {
  narrow: ["eaa.", "jaa."],
  abbreviated: ["eaa.", "jaa."],
  wide: ["ennen ajanlaskun alkua", "j\xE4lkeen ajanlaskun alun"]
}, l$x = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartaali", "2. kvartaali", "3. kvartaali", "4. kvartaali"]
}, t$l = {
  narrow: ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"],
  abbreviated: ["tammi", "helmi", "maalis", "huhti", "touko", "kes\xE4", "hein\xE4", "elo", "syys", "loka", "marras", "joulu"],
  wide: ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kes\xE4kuu", "hein\xE4kuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"]
}, o$r = {
  narrow: t$l.narrow,
  abbreviated: t$l.abbreviated,
  wide: ["tammikuuta", "helmikuuta", "maaliskuuta", "huhtikuuta", "toukokuuta", "kes\xE4kuuta", "hein\xE4kuuta", "elokuuta", "syyskuuta", "lokakuuta", "marraskuuta", "joulukuuta"]
}, i$D = {
  narrow: ["S", "M", "T", "K", "T", "P", "L"],
  short: ["su", "ma", "ti", "ke", "to", "pe", "la"],
  abbreviated: ["sunn.", "maan.", "tiis.", "kesk.", "torst.", "perj.", "la"],
  wide: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"]
}, k$i = {
  narrow: i$D.narrow,
  short: i$D.short,
  abbreviated: i$D.abbreviated,
  wide: ["sunnuntaina", "maanantaina", "tiistaina", "keskiviikkona", "torstaina", "perjantaina", "lauantaina"]
}, s$C = {
  narrow: {
    am: "ap",
    pm: "ip",
    midnight: "keskiy\xF6",
    noon: "keskip\xE4iv\xE4",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "y\xF6ll\xE4"
  },
  abbreviated: {
    am: "ap",
    pm: "ip",
    midnight: "keskiy\xF6",
    noon: "keskip\xE4iv\xE4",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "y\xF6ll\xE4"
  },
  wide: {
    am: "ap",
    pm: "ip",
    midnight: "keskiy\xF6ll\xE4",
    noon: "keskip\xE4iv\xE4ll\xE4",
    morning: "aamup\xE4iv\xE4ll\xE4",
    afternoon: "iltap\xE4iv\xE4ll\xE4",
    evening: "illalla",
    night: "y\xF6ll\xE4"
  }
}, d$A = function(e28, v3) {
  var n3 = Number(e28);
  return n3 + ".";
}, m$y = {
  ordinalNumber: d$A,
  era: f$1h({
    values: r$A,
    defaultWidth: "wide"
  }),
  quarter: f$1h({
    values: l$x,
    defaultWidth: "wide",
    argumentCallback: function(e28) {
      return e28 - 1;
    }
  }),
  month: f$1h({
    values: t$l,
    defaultWidth: "wide",
    formattingValues: o$r,
    defaultFormattingWidth: "wide"
  }),
  day: f$1h({
    values: i$D,
    defaultWidth: "wide",
    formattingValues: k$i,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: f$1h({
    values: s$C,
    defaultWidth: "wide"
  })
};
const b$i = m$y;
var r$z = /^(\d+)(\.)/i, n$n = /\d+/i, l$w = {
  narrow: /^(e|j)/i,
  abbreviated: /^(eaa.|jaa.)/i,
  wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
}, s$B = {
  any: [/^e/i, /^j/i]
}, u$B = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\.? kvartaali/i
}, h$H = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, k$h = {
  narrow: /^[thmkeslj]/i,
  abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
  wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
}, m$x = {
  narrow: [/^t/i, /^h/i, /^m/i, /^h/i, /^t/i, /^k/i, /^h/i, /^e/i, /^s/i, /^l/i, /^m/i, /^j/i],
  any: [/^ta/i, /^hel/i, /^maa/i, /^hu/i, /^to/i, /^k/i, /^hei/i, /^e/i, /^s/i, /^l/i, /^mar/i, /^j/i]
}, d$z = {
  narrow: /^[smtkpl]/i,
  short: /^(su|ma|ti|ke|to|pe|la)/i,
  abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
  wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
}, o$q = {
  narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
}, p$2G = {
  narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
  any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
}, v$i = {
  any: {
    am: /^ap/i,
    pm: /^ip/i,
    midnight: /^keskiyö/i,
    noon: /^keskipäivä/i,
    morning: /aamupäivällä/i,
    afternoon: /iltapäivällä/i,
    evening: /illalla/i,
    night: /yöllä/i
  }
}, P$i = {
  ordinalNumber: v$Z({
    matchPattern: r$z,
    parsePattern: n$n,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: o$1h({
    matchPatterns: l$w,
    defaultMatchWidth: "wide",
    parsePatterns: s$B,
    defaultParseWidth: "any"
  }),
  quarter: o$1h({
    matchPatterns: u$B,
    defaultMatchWidth: "wide",
    parsePatterns: h$H,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: o$1h({
    matchPatterns: k$h,
    defaultMatchWidth: "wide",
    parsePatterns: m$x,
    defaultParseWidth: "any"
  }),
  day: o$1h({
    matchPatterns: d$z,
    defaultMatchWidth: "wide",
    parsePatterns: o$q,
    defaultParseWidth: "any"
  }),
  dayPeriod: o$1h({
    matchPatterns: p$2G,
    defaultMatchWidth: "any",
    parsePatterns: v$i,
    defaultParseWidth: "any"
  })
};
const b$h = P$i;
var e$B = {
  code: "fi",
  formatDistance: T$i,
  formatLong: l$y,
  formatRelative: i$E,
  localize: b$i,
  match: b$h,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const s$A = e$B;
const f$t = {
  name: i$1i.finnish,
  locale: s$A
};
const a$K = {
  name: i$1i.dutch,
  global: {
    undo: "Ongedaan maken",
    redo: "Opnieuw uitvoeren",
    confirm: "Bevestig",
    clear: "Duidelijk",
    more: "meer",
    cancel: "Annuleren"
  },
  Popconfirm: {
    positiveText: "Bevestig",
    negativeText: "Annuleer"
  },
  Cascader: {
    placeholder: "Gelieve te selecteren",
    loading: "Bezig met laden",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM/yyyy",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "qqq yyyy",
    clear: "Duidelijk",
    now: "Nu",
    confirm: "Bevestig",
    selectTime: "Selecteer Tijd",
    selectDate: "Selecteer Datum",
    datePlaceholder: "Selecteer Datum",
    datetimePlaceholder: "Selecteer Tijd en Datum",
    monthPlaceholder: "Selecteer Maand",
    yearPlaceholder: "Selecteer Jaar",
    quarterPlaceholder: "Selecteer Kwartaal",
    startDatePlaceholder: "Start Datum",
    endDatePlaceholder: "Eind Datum",
    startDatetimePlaceholder: "Start Datum en Tijd",
    endDatetimePlaceholder: "Eind Datum en Tijd",
    startMonthPlaceholder: "Start Maand",
    endMonthPlaceholder: "Einde Maand",
    monthBeforeYear: true,
    firstDayOfWeek: 0,
    today: "Vandaag"
  },
  DataTable: {
    checkTableAll: "Selecteer alles in de tabel",
    uncheckTableAll: "Deselecteer alles in de tabel",
    confirm: "Bevestig",
    clear: "Duidelijk",
    apply: "Toepassen",
    filters: "Filters",
    sort: "Sorteren"
  },
  LegacyTransfer: {
    sourceTitle: "Bron",
    targetTitle: "Target"
  },
  Transfer: {
    selectAll: "Selecteer Alle",
    unselectAll: "Deselecteer Alle",
    clearAll: "Duidelijk"
  },
  Empty: {
    description: "Geen Data"
  },
  Select: {
    placeholder: "Selecteer alstublieft"
  },
  TimePicker: {
    placeholder: "Selecteer Tijd",
    positiveText: "OK",
    negativeText: "Annuleer",
    now: "Nu"
  },
  Pagination: {
    goto: "Ga naar",
    selectionSuffix: "Pagina",
    next: "Volgende",
    previous: "Vorige"
  },
  DynamicTags: {
    add: "Toevoegen"
  },
  Log: {
    loading: "Bezig met laden"
  },
  Input: {
    placeholder: "Vul alsjeblieft in"
  },
  InputNumber: {
    placeholder: "Vul alsjeblieft in"
  },
  DynamicInput: {
    create: "Maak"
  },
  ThemeEditor: {
    title: "Thema Editor",
    clearAllVars: "Wis Alle Variabelen",
    clearSearch: "Zoekopdracht Wissen",
    filterCompName: "Naam van filter component",
    filterVarName: "Naam van filter variable",
    import: "Import",
    export: "Export",
    restore: "Resetten naar standaard"
  },
  Image: {
    tipPrevious: "Vorige Afbeelding (\u2190)",
    tipNext: "Volgende afbeelding (\u2192)",
    tipCounterclockwise: "Tegen de klok in",
    tipClockwise: "Met de klok mee",
    tipZoomOut: "Zoom uit",
    tipZoomIn: "Zoom in",
    tipClose: "Sluiten (Esc)",
    tipOriginalSize: "Zoom in op originele grootte"
  },
  SortFilter: {
    heading: "Sorteer en filter",
    sortHeading: "Sorteer op",
    newestFirst: "Nieuwste eerst",
    oldestFirst: "Oudste eerst",
    ascending: "Oplopend",
    descending: "Afdalend",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Toepassen",
    clear: "Wissen",
    cancel: "Annuleren",
    filters: "Filters"
  },
  IconPicker: {
    noMatchingFound: "Geen overeenkomende resultaten gevonden"
  }
};
var t$k = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, u$A = function(a3, r3, n3) {
  var e28, o3 = t$k[a3];
  return typeof o3 == "string" ? e28 = o3 : r3 === 1 ? e28 = o3.one : e28 = o3.other.replace("{{count}}", String(r3)), n3 != null && n3.addSuffix ? n3.comparison && n3.comparison > 0 ? "over " + e28 : e28 + " geleden" : e28;
};
const c$S = u$A;
var m$w = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, a$J = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, d$y = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, e$A = {
  date: u$1s({
    formats: m$w,
    defaultWidth: "full"
  }),
  time: u$1s({
    formats: a$J,
    defaultWidth: "full"
  }),
  dateTime: u$1s({
    formats: d$y,
    defaultWidth: "full"
  })
};
const l$v = e$A;
var a$I = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, t$j = function(e28, r3, m3, n3) {
  return a$I[e28];
};
const l$u = t$j;
var d$x = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, i$C = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, t$i = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
}, o$p = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
}, s$z = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, u$z = function(e28, l3) {
  var n3 = Number(e28);
  return n3 + "e";
}, m$v = {
  ordinalNumber: u$z,
  era: f$1h({
    values: d$x,
    defaultWidth: "wide"
  }),
  quarter: f$1h({
    values: i$C,
    defaultWidth: "wide",
    argumentCallback: function(e28) {
      return e28 - 1;
    }
  }),
  month: f$1h({
    values: t$i,
    defaultWidth: "wide"
  }),
  day: f$1h({
    values: o$p,
    defaultWidth: "wide"
  }),
  dayPeriod: f$1h({
    values: s$z,
    defaultWidth: "wide"
  })
};
const h$G = m$v;
var e$z = /^(\d+)e?/i, n$m = /\d+/i, d$w = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, s$y = {
  any: [/^v/, /^n/]
}, m$u = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, o$o = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, h$F = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, u$y = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
}, c$R = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, v$h = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, l$t = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, P$h = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, p$2F = {
  ordinalNumber: v$Z({
    matchPattern: e$z,
    parsePattern: n$m,
    valueCallback: function(t3) {
      return parseInt(t3, 10);
    }
  }),
  era: o$1h({
    matchPatterns: d$w,
    defaultMatchWidth: "wide",
    parsePatterns: s$y,
    defaultParseWidth: "any"
  }),
  quarter: o$1h({
    matchPatterns: m$u,
    defaultMatchWidth: "wide",
    parsePatterns: o$o,
    defaultParseWidth: "any",
    valueCallback: function(t3) {
      return t3 + 1;
    }
  }),
  month: o$1h({
    matchPatterns: h$F,
    defaultMatchWidth: "wide",
    parsePatterns: u$y,
    defaultParseWidth: "any"
  }),
  day: o$1h({
    matchPatterns: c$R,
    defaultMatchWidth: "wide",
    parsePatterns: v$h,
    defaultParseWidth: "any"
  }),
  dayPeriod: o$1h({
    matchPatterns: l$t,
    defaultMatchWidth: "any",
    parsePatterns: P$h,
    defaultParseWidth: "any"
  })
};
const w$g = p$2F;
var e$y = {
  code: "nl",
  formatDistance: c$S,
  formatLong: l$v,
  formatRelative: l$u,
  localize: h$G,
  match: w$g,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const s$x = e$y;
const m$t = {
  name: i$1i.dutch,
  locale: s$x
};
const l$s = {
  name: i$1i.danish,
  global: {
    undo: "Fortryd",
    redo: "Gentag",
    confirm: "Bekr\xE6ft",
    clear: "Ryd",
    more: "mere",
    cancel: "Aflyse"
  },
  Popconfirm: {
    positiveText: "Bekr\xE6ft",
    negativeText: "Annuller"
  },
  Cascader: {
    placeholder: "V\xE6lg venligst",
    loading: "Indl\xE6ser",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Ryd",
    now: "Nu",
    confirm: "Bekr\xE6ft",
    selectTime: "V\xE6lg Tid",
    selectDate: "V\xE6lg Dato",
    datePlaceholder: "V\xE6lg Dato",
    datetimePlaceholder: "V\xE6lg Dato og Tid",
    monthPlaceholder: "V\xE6lg M\xE5ned",
    yearPlaceholder: "V\xE6lg \xC5r",
    quarterPlaceholder: "V\xE6lg Kvartal",
    startDatePlaceholder: "Start Dato",
    endDatePlaceholder: "Slut Dato",
    startDatetimePlaceholder: "Start Dato og Tid",
    endDatetimePlaceholder: "Slut Dato og Tid",
    startMonthPlaceholder: "Start M\xE5ned",
    endMonthPlaceholder: "Slut M\xE5ned",
    monthBeforeYear: true,
    firstDayOfWeek: 6,
    today: "I dag"
  },
  DataTable: {
    checkTableAll: "V\xE6lg alt i tabellen",
    uncheckTableAll: "Frav\xE6lg alt i tabellen",
    confirm: "Bekr\xE6ft",
    clear: "Ryd",
    apply: "Anvend",
    filters: "Filtre",
    sort: "Sortere"
  },
  LegacyTransfer: {
    sourceTitle: "Kilde",
    targetTitle: "M\xE5l"
  },
  Transfer: {
    selectAll: "V\xE6lg alle",
    unselectAll: "Frav\xE6lg alle",
    clearAll: "Ryd"
  },
  Empty: {
    description: "Ingen data"
  },
  Select: {
    placeholder: "V\xE6lg venligst"
  },
  TimePicker: {
    placeholder: "V\xE6lg tid",
    positiveText: "OK",
    negativeText: "Annuller",
    now: "Nu"
  },
  Pagination: {
    goto: "G\xE5 til",
    selectionSuffix: "side",
    next: "N\xE6ste",
    previous: "Tidligere"
  },
  DynamicTags: {
    add: "Tilf\xF8j"
  },
  Log: {
    loading: "Indl\xE6ser"
  },
  Input: {
    placeholder: "Indtast venligst"
  },
  InputNumber: {
    placeholder: "Indtast venligst"
  },
  DynamicInput: {
    create: "Opret"
  },
  ThemeEditor: {
    title: "Tema Editor",
    clearAllVars: "Ryd alle variabler",
    clearSearch: "Ryd s\xF8gning",
    filterCompName: "Filterkomponentnavn",
    filterVarName: "Filtervariabelnavn",
    import: "Import",
    export: "Eksport",
    restore: "Nulstil til standard"
  },
  Image: {
    tipPrevious: "Forrige billede (\u2190)",
    tipNext: "N\xE6ste billede (\u2192)",
    tipCounterclockwise: "Mod uret",
    tipClockwise: "Med uret",
    tipZoomOut: "Zoom ud",
    tipZoomIn: "Zoom ind",
    tipClose: "Luk (ESC)",
    tipOriginalSize: "Zoom til original st\xF8rrelse"
  },
  SortFilter: {
    heading: "Sort\xE9r og filtre",
    sortHeading: "Sort\xE9r efter",
    newestFirst: "Nyeste f\xF8rst",
    oldestFirst: "\xC6ldste f\xF8rst",
    ascending: "Stigende",
    descending: "Faldende",
    aToZ: "A-\xC5",
    zToA: "\xC5-A",
    apply: "Anvend",
    clear: "Ryd",
    cancel: "Annuller",
    filters: "Filtre"
  },
  IconPicker: {
    noMatchingFound: "Ingen matchende resultater fundet"
  }
};
var u$x = {
  lessThanXSeconds: {
    one: "mindre end \xE9t sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "\xE9t halvt minut",
  lessThanXMinutes: {
    one: "mindre end \xE9t minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 m\xE5ned",
    other: "cirka {{count}} m\xE5neder"
  },
  xMonths: {
    one: "1 m\xE5ned",
    other: "{{count}} m\xE5neder"
  },
  aboutXYears: {
    one: "cirka 1 \xE5r",
    other: "cirka {{count}} \xE5r"
  },
  xYears: {
    one: "1 \xE5r",
    other: "{{count}} \xE5r"
  },
  overXYears: {
    one: "over 1 \xE5r",
    other: "over {{count}} \xE5r"
  },
  almostXYears: {
    one: "n\xE6sten 1 \xE5r",
    other: "n\xE6sten {{count}} \xE5r"
  }
}, a$H = function(o3, t3, n3) {
  var e28, r3 = u$x[o3];
  return typeof r3 == "string" ? e28 = r3 : t3 === 1 ? e28 = r3.one : e28 = r3.other.replace("{{count}}", String(t3)), n3 != null && n3.addSuffix ? n3.comparison && n3.comparison > 0 ? "om " + e28 : e28 + " siden" : e28;
};
const s$w = a$H;
var m$s = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
}, a$G = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, d$v = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, e$x = {
  date: u$1s({
    formats: m$s,
    defaultWidth: "full"
  }),
  time: u$1s({
    formats: a$G,
    defaultWidth: "full"
  }),
  dateTime: u$1s({
    formats: d$v,
    defaultWidth: "full"
  })
};
const o$n = e$x;
var t$h = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i g\xE5r kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'p\xE5' eeee 'kl.' p",
  other: "P"
}, a$F = function(e28, r3, l3, i) {
  return t$h[e28];
};
const p$2E = a$F;
var r$y = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["f\xF8r vesterlandsk tidsregning", "vesterlandsk tidsregning"]
}, i$B = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, d$u = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
}, m$r = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["s\xF8", "ma", "ti", "on", "to", "fr", "l\xF8"],
  abbreviated: ["s\xF8n.", "man.", "tir.", "ons.", "tor.", "fre.", "l\xF8r."],
  wide: ["s\xF8ndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "l\xF8rdag"]
}, o$m = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
}, g$p = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
}, l$r = function(n3, v3) {
  var t3 = Number(n3);
  return t3 + ".";
}, u$w = {
  ordinalNumber: l$r,
  era: f$1h({
    values: r$y,
    defaultWidth: "wide"
  }),
  quarter: f$1h({
    values: i$B,
    defaultWidth: "wide",
    argumentCallback: function(n3) {
      return n3 - 1;
    }
  }),
  month: f$1h({
    values: d$u,
    defaultWidth: "wide"
  }),
  day: f$1h({
    values: m$r,
    defaultWidth: "wide"
  }),
  dayPeriod: f$1h({
    values: o$m,
    defaultWidth: "wide",
    formattingValues: g$p,
    defaultFormattingWidth: "wide"
  })
};
const s$v = u$w;
var i$A = /^(\d+)(\.)?/i, n$l = /\d+/i, d$t = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
}, s$u = {
  any: [/^f/i, /^(v|e)/i]
}, m$q = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
}, o$l = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, l$q = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
}, f$s = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, u$v = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, h$E = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, v$g = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
}, P$g = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
}, c$Q = {
  ordinalNumber: v$Z({
    matchPattern: i$A,
    parsePattern: n$l,
    valueCallback: function(t3) {
      return parseInt(t3, 10);
    }
  }),
  era: o$1h({
    matchPatterns: d$t,
    defaultMatchWidth: "wide",
    parsePatterns: s$u,
    defaultParseWidth: "any"
  }),
  quarter: o$1h({
    matchPatterns: m$q,
    defaultMatchWidth: "wide",
    parsePatterns: o$l,
    defaultParseWidth: "any",
    valueCallback: function(t3) {
      return t3 + 1;
    }
  }),
  month: o$1h({
    matchPatterns: l$q,
    defaultMatchWidth: "wide",
    parsePatterns: f$s,
    defaultParseWidth: "any"
  }),
  day: o$1h({
    matchPatterns: u$v,
    defaultMatchWidth: "wide",
    parsePatterns: h$E,
    defaultParseWidth: "any"
  }),
  dayPeriod: o$1h({
    matchPatterns: v$g,
    defaultMatchWidth: "any",
    parsePatterns: P$g,
    defaultParseWidth: "any"
  })
};
const b$g = c$Q;
var e$w = {
  code: "da",
  formatDistance: s$w,
  formatLong: o$n,
  formatRelative: p$2E,
  localize: s$v,
  match: b$g,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const s$t = e$w;
const r$x = {
  name: i$1i.danish,
  locale: s$t
};
const J$6 = defineComponent({
  name: "UIContentWrap",
  inheritAttrs: true
}), Q$6 = defineComponent(__spreadProps(__spreadValues({}, J$6), {
  props: {
    fullScreen: {
      type: Boolean,
      default: false
    },
    locale: {
      type: String,
      default: i$1i.englishUS
    },
    notificationConfig: {
      type: Object,
      default: () => ({})
    }
  },
  setup(t3) {
    const r3 = t3, e28 = ref$1(a$1C), o3 = ref$1(m$13), l3 = () => {
      switch (function() {
        return r3 != null && r3.locale ? r3.locale.includes("_") ? (console.warn(`Deprecated used of '_' in the language '${r3.locale}', please change to use hyphen '-'.`), r3.locale.replace("_", "-")) : r3.locale : i$1i.englishUS;
      }()) {
        case i$1i.englishUS:
        default: {
          e28.value = a$1C, o3.value = m$13;
          break;
        }
        case i$1i.danish: {
          e28.value = l$s, o3.value = r$x;
          break;
        }
        case i$1i.dutch: {
          e28.value = a$K, o3.value = m$t;
          break;
        }
        case i$1i.finnish: {
          e28.value = t$o, o3.value = f$t;
          break;
        }
        case i$1i.frenchCanada: {
          e28.value = t$p, o3.value = f$v;
          break;
        }
        case i$1i.frenchFrance: {
          e28.value = t$s, o3.value = f$w;
          break;
        }
        case i$1i.german: {
          e28.value = n$q, o3.value = r$B;
          break;
        }
        case i$1i.italian: {
          e28.value = i$J, o3.value = i$H;
          break;
        }
        case i$1i.norwegian: {
          e28.value = r$H, o3.value = r$G;
          break;
        }
        case i$1i.portuguesePortugal: {
          e28.value = r$L, o3.value = a$X;
          break;
        }
        case i$1i.portugueseBrazil: {
          e28.value = r$O, o3.value = a$Z;
          break;
        }
        case i$1i.spanish: {
          e28.value = r$P, o3.value = m$W;
          break;
        }
        case i$1i.swedish: {
          e28.value = t$H, o3.value = m$$;
          break;
        }
      }
    };
    return onMounted(() => {
      l3();
    }), onUpdated(() => {
      l3();
    }), provide("customLocale", e28), (i, X3) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["font-sans hl-wrapper-container", { "full-screen": t3.fullScreen }])
    }, [
      createVNode(unref(E$e), {
        theme: unref(o$P),
        "theme-overrides": unref(r$R),
        locale: e28.value,
        "date-locale": o3.value
      }, {
        default: withCtx(() => [
          createVNode(unref(X$6), {
            "container-class": t3.notificationConfig.containerClass,
            "container-style": t3.notificationConfig.containerStyle,
            to: t3.notificationConfig.to,
            placement: t3.notificationConfig.placement,
            max: t3.notificationConfig.max,
            scrollable: t3.notificationConfig.scrollable
          }, {
            default: withCtx(() => [
              renderSlot(i.$slots, "default")
            ]),
            _: 3
          }, 8, ["container-class", "container-style", "to", "placement", "max", "scrollable"])
        ]),
        _: 3
      }, 8, ["theme", "theme-overrides", "locale", "date-locale"])
    ], 2));
  }
})), Re$2 = Q$6;
const T$h = 1901, o$k = 40;
function o$j(a3, t3) {
  (t3 == null || t3 > a3.length) && (t3 = a3.length);
  for (var r3 = 0, f3 = new Array(t3); r3 < t3; r3++)
    f3[r3] = a3[r3];
  return f3;
}
function i$z(r3, e28) {
  if (r3) {
    if (typeof r3 == "string")
      return o$j(r3, e28);
    var t3 = Object.prototype.toString.call(r3).slice(8, -1);
    if (t3 === "Object" && r3.constructor && (t3 = r3.constructor.name), t3 === "Map" || t3 === "Set")
      return Array.from(r3);
    if (t3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t3))
      return o$j(r3, e28);
  }
}
function s$s(r3, l3) {
  var e28 = typeof Symbol < "u" && r3[Symbol.iterator] || r3["@@iterator"];
  if (!e28) {
    if (Array.isArray(r3) || (e28 = i$z(r3)) || l3 && r3 && typeof r3.length == "number") {
      e28 && (r3 = e28);
      var a3 = 0, o3 = function() {
      };
      return {
        s: o3,
        n: function() {
          return a3 >= r3.length ? {
            done: true
          } : {
            done: false,
            value: r3[a3++]
          };
        },
        e: function(n3) {
          throw n3;
        },
        f: o3
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = true, f3 = false, u3;
  return {
    s: function() {
      e28 = e28.call(r3);
    },
    n: function() {
      var n3 = e28.next();
      return i = n3.done, n3;
    },
    e: function(n3) {
      f3 = true, u3 = n3;
    },
    f: function() {
      try {
        !i && e28.return != null && e28.return();
      } finally {
        if (f3)
          throw u3;
      }
    }
  };
}
function d$s(t3, r3) {
  n$u(2, arguments);
  var e28 = a$S(t3).getTime(), o3 = n$t(r3);
  return new Date(e28 + o3);
}
function a$E(r3, o3) {
  n$u(2, arguments);
  var t3 = n$t(o3);
  return d$s(r3, -t3);
}
function i$y(n3, r3) {
  if (n3 == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var e28 in r3)
    Object.prototype.hasOwnProperty.call(r3, e28) && (n3[e28] = r3[e28]);
  return n3;
}
var P$f = function(t3, e28) {
  switch (t3) {
    case "P":
      return e28.date({
        width: "short"
      });
    case "PP":
      return e28.date({
        width: "medium"
      });
    case "PPP":
      return e28.date({
        width: "long"
      });
    case "PPPP":
    default:
      return e28.date({
        width: "full"
      });
  }
}, c$P = function(t3, e28) {
  switch (t3) {
    case "p":
      return e28.time({
        width: "short"
      });
    case "pp":
      return e28.time({
        width: "medium"
      });
    case "ppp":
      return e28.time({
        width: "long"
      });
    case "pppp":
    default:
      return e28.time({
        width: "full"
      });
  }
}, s$r = function(t3, e28) {
  var i = t3.match(/(P+)(p+)?/) || [], d3 = i[1], u3 = i[2];
  if (!u3)
    return P$f(t3, e28);
  var a3;
  switch (d3) {
    case "P":
      a3 = e28.dateTime({
        width: "short"
      });
      break;
    case "PP":
      a3 = e28.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      a3 = e28.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      a3 = e28.dateTime({
        width: "full"
      });
      break;
  }
  return a3.replace("{{date}}", P$f(d3, e28)).replace("{{time}}", c$P(u3, e28));
}, h$D = {
  p: c$P,
  P: s$r
};
const m$p = h$D;
function g$o(e28) {
  var t3 = new Date(Date.UTC(e28.getFullYear(), e28.getMonth(), e28.getDate(), e28.getHours(), e28.getMinutes(), e28.getSeconds(), e28.getMilliseconds()));
  return t3.setUTCFullYear(e28.getFullYear()), e28.getTime() - t3.getTime();
}
var n$k = ["D", "DD"], r$w = ["YY", "YYYY"];
function s$q(e28) {
  return n$k.indexOf(e28) !== -1;
}
function a$D(e28) {
  return r$w.indexOf(e28) !== -1;
}
function c$O(e28, t3, o3) {
  if (e28 === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t3, "`) for formatting years to the input `").concat(o3, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e28 === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t3, "`) for formatting years to the input `").concat(o3, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e28 === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t3, "`) for formatting days of the month to the input `").concat(o3, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e28 === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t3, "`) for formatting days of the month to the input `").concat(o3, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
function i$x(e28) {
  if (e28 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e28;
}
function e$v(o3, r3) {
  return e$v = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t3, f3) {
    return t3.__proto__ = f3, t3;
  }, e$v(o3, r3);
}
function i$w(e28, t3) {
  if (typeof t3 != "function" && t3 !== null)
    throw new TypeError("Super expression must either be null or a function");
  e28.prototype = Object.create(t3 && t3.prototype, {
    constructor: {
      value: e28,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(e28, "prototype", {
    writable: false
  }), t3 && e$v(e28, t3);
}
function e$u(o3) {
  return e$u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t3) {
    return t3.__proto__ || Object.getPrototypeOf(t3);
  }, e$u(o3);
}
function t$g() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return false;
  if (typeof Proxy == "function")
    return true;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), true;
  } catch {
    return false;
  }
}
function f$r(e28, r3) {
  if (r3 && (o$A(r3) === "object" || typeof r3 == "function"))
    return r3;
  if (r3 !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return i$x(e28);
}
function l$p(o3) {
  var s3 = t$g();
  return function() {
    var r3 = e$u(o3), t3;
    if (s3) {
      var u3 = e$u(this).constructor;
      t3 = Reflect.construct(r3, arguments, u3);
    } else
      t3 = r3.apply(this, arguments);
    return f$r(this, t3);
  };
}
function c$N(a3, n3) {
  if (!(a3 instanceof n3))
    throw new TypeError("Cannot call a class as a function");
}
function f$q(r3, e28) {
  if (o$A(r3) !== "object" || r3 === null)
    return r3;
  var t3 = r3[Symbol.toPrimitive];
  if (t3 !== void 0) {
    var i = t3.call(r3, e28 || "default");
    if (o$A(i) !== "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e28 === "string" ? String : Number)(r3);
}
function f$p(t3) {
  var r3 = f$q(t3, "string");
  return o$A(r3) === "symbol" ? r3 : String(r3);
}
function n$j(f3, l3) {
  for (var a3 = 0; a3 < l3.length; a3++) {
    var e28 = l3[a3];
    e28.enumerable = e28.enumerable || false, e28.configurable = true, "value" in e28 && (e28.writable = true), Object.defineProperty(f3, f$p(e28.key), e28);
  }
}
function u$u(f3, l3, a3) {
  return l3 && n$j(f3.prototype, l3), a3 && n$j(f3, a3), Object.defineProperty(f3, "prototype", {
    writable: false
  }), f3;
}
function u$t(r3, e28, t3) {
  return e28 = f$p(e28), e28 in r3 ? Object.defineProperty(r3, e28, {
    value: t3,
    enumerable: true,
    configurable: true,
    writable: true
  }) : r3[e28] = t3, r3;
}
var T$g = 10, p$2D = /* @__PURE__ */ function() {
  function u3() {
    c$N(this, u3), u$t(this, "priority", void 0), u$t(this, "subPriority", 0);
  }
  return u$u(u3, [{
    key: "validate",
    value: function(e28, i) {
      return true;
    }
  }]), u3;
}(), D$k = /* @__PURE__ */ function(u3) {
  i$w(e28, u3);
  var s3 = l$p(e28);
  function e28(i, t3, a3, r3, c3) {
    var n3;
    return c$N(this, e28), n3 = s3.call(this), n3.value = i, n3.validateValue = t3, n3.setValue = a3, n3.priority = r3, c3 && (n3.subPriority = c3), n3;
  }
  return u$u(e28, [{
    key: "validate",
    value: function(t3, a3) {
      return this.validateValue(t3, this.value, a3);
    }
  }, {
    key: "set",
    value: function(t3, a3, r3) {
      return this.setValue(t3, a3, this.value, r3);
    }
  }]), e28;
}(p$2D), I$g = /* @__PURE__ */ function(u3) {
  i$w(e28, u3);
  var s3 = l$p(e28);
  function e28() {
    var i;
    c$N(this, e28);
    for (var t3 = arguments.length, a3 = new Array(t3), r3 = 0; r3 < t3; r3++)
      a3[r3] = arguments[r3];
    return i = s3.call.apply(s3, [this].concat(a3)), u$t(i$x(i), "priority", T$g), u$t(i$x(i), "subPriority", -1), i;
  }
  return u$u(e28, [{
    key: "set",
    value: function(t3, a3) {
      if (a3.timestampIsSet)
        return t3;
      var r3 = /* @__PURE__ */ new Date(0);
      return r3.setFullYear(t3.getUTCFullYear(), t3.getUTCMonth(), t3.getUTCDate()), r3.setHours(t3.getUTCHours(), t3.getUTCMinutes(), t3.getUTCSeconds(), t3.getUTCMilliseconds()), r3;
    }
  }]), e28;
}(p$2D);
var m$o = /* @__PURE__ */ function() {
  function t3() {
    c$N(this, t3), u$t(this, "incompatibleTokens", void 0), u$t(this, "priority", void 0), u$t(this, "subPriority", void 0);
  }
  return u$u(t3, [{
    key: "run",
    value: function(i, o3, s3, u3) {
      var r3 = this.parse(i, o3, s3, u3);
      return r3 ? {
        setter: new D$k(r3.value, this.validate, this.set, this.priority, this.subPriority),
        rest: r3.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(i, o3, s3) {
      return true;
    }
  }]), t3;
}();
var T$f = /* @__PURE__ */ function(u3) {
  i$w(i, u3);
  var s3 = l$p(i);
  function i() {
    var a3;
    c$N(this, i);
    for (var e28 = arguments.length, t3 = new Array(e28), r3 = 0; r3 < e28; r3++)
      t3[r3] = arguments[r3];
    return a3 = s3.call.apply(s3, [this].concat(t3)), u$t(i$x(a3), "priority", 140), u$t(i$x(a3), "incompatibleTokens", ["R", "u", "t", "T"]), a3;
  }
  return u$u(i, [{
    key: "parse",
    value: function(e28, t3, r3) {
      switch (t3) {
        case "G":
        case "GG":
        case "GGG":
          return r3.era(e28, {
            width: "abbreviated"
          }) || r3.era(e28, {
            width: "narrow"
          });
        case "GGGGG":
          return r3.era(e28, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return r3.era(e28, {
            width: "wide"
          }) || r3.era(e28, {
            width: "abbreviated"
          }) || r3.era(e28, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(e28, t3, r3) {
      return t3.era = r3, e28.setUTCFullYear(r3, 0, 1), e28.setUTCHours(0, 0, 0, 0), e28;
    }
  }]), i;
}(m$o);
var n$i = 6e4, i$v = 36e5, e$t = 1e3;
var d$r = {
  month: /^(1[0-2]|0?\d)/,
  date: /^(3[0-1]|[0-2]?\d)/,
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  week: /^(5[0-3]|[0-4]?\d)/,
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  hour11h: /^(1[0-1]|0?\d)/,
  hour12h: /^(1[0-2]|0?\d)/,
  minute: /^[0-5]?\d/,
  second: /^[0-5]?\d/,
  singleDigit: /^\d/,
  twoDigits: /^\d{1,2}/,
  threeDigits: /^\d{1,3}/,
  fourDigits: /^\d{1,4}/,
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  twoDigitsSigned: /^-?\d{1,2}/,
  threeDigitsSigned: /^-?\d{1,3}/,
  fourDigitsSigned: /^-?\d{1,4}/
}, i$u = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function h$C(e28, r3) {
  return e28 && {
    value: r3(e28.value),
    rest: e28.rest
  };
}
function i$t(e28, r3) {
  var n3 = r3.match(e28);
  return n3 ? {
    value: parseInt(n3[0], 10),
    rest: r3.slice(n3[0].length)
  } : null;
}
function p$2C(e28, r3) {
  var n3 = r3.match(e28);
  if (!n3)
    return null;
  if (n3[0] === "Z")
    return {
      value: 0,
      rest: r3.slice(1)
    };
  var u3 = n3[1] === "+" ? 1 : -1, t3 = n3[2] ? parseInt(n3[2], 10) : 0, a3 = n3[3] ? parseInt(n3[3], 10) : 0, c3 = n3[5] ? parseInt(n3[5], 10) : 0;
  return {
    value: u3 * (t3 * i$v + a3 * n$i + c3 * e$t),
    rest: r3.slice(n3[0].length)
  };
}
function D$j(e28) {
  return i$t(d$r.anyDigitsSigned, e28);
}
function d$q(e28, r3) {
  switch (e28) {
    case 1:
      return i$t(d$r.singleDigit, r3);
    case 2:
      return i$t(d$r.twoDigits, r3);
    case 3:
      return i$t(d$r.threeDigits, r3);
    case 4:
      return i$t(d$r.fourDigits, r3);
    default:
      return i$t(new RegExp("^\\d{1," + e28 + "}"), r3);
  }
}
function I$f(e28, r3) {
  switch (e28) {
    case 1:
      return i$t(d$r.singleDigitSigned, r3);
    case 2:
      return i$t(d$r.twoDigitsSigned, r3);
    case 3:
      return i$t(d$r.threeDigitsSigned, r3);
    case 4:
      return i$t(d$r.fourDigitsSigned, r3);
    default:
      return i$t(new RegExp("^-?\\d{1," + e28 + "}"), r3);
  }
}
function w$f(e28) {
  switch (e28) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function x$e(e28, r3) {
  var n3 = r3 > 0, u3 = n3 ? r3 : 1 - r3, t3;
  if (u3 <= 50)
    t3 = e28 || 100;
  else {
    var a3 = u3 + 50, c3 = Math.floor(a3 / 100) * 100, o3 = e28 >= a3 % 100;
    t3 = e28 + c3 - (o3 ? 100 : 0);
  }
  return n3 ? t3 : 1 - t3;
}
function P$e(e28) {
  return e28 % 400 === 0 || e28 % 4 === 0 && e28 % 100 !== 0;
}
var k$g = /* @__PURE__ */ function(f3) {
  i$w(t3, f3);
  var u3 = l$p(t3);
  function t3() {
    var i;
    c$N(this, t3);
    for (var r3 = arguments.length, e28 = new Array(r3), a3 = 0; a3 < r3; a3++)
      e28[a3] = arguments[a3];
    return i = u3.call.apply(u3, [this].concat(e28)), u$t(i$x(i), "priority", 130), u$t(i$x(i), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), i;
  }
  return u$u(t3, [{
    key: "parse",
    value: function(r3, e28, a3) {
      var o3 = function(s3) {
        return {
          year: s3,
          isTwoDigitYear: e28 === "yy"
        };
      };
      switch (e28) {
        case "y":
          return h$C(d$q(4, r3), o3);
        case "yo":
          return h$C(a3.ordinalNumber(r3, {
            unit: "year"
          }), o3);
        default:
          return h$C(d$q(e28.length, r3), o3);
      }
    }
  }, {
    key: "validate",
    value: function(r3, e28) {
      return e28.isTwoDigitYear || e28.year > 0;
    }
  }, {
    key: "set",
    value: function(r3, e28, a3) {
      var o3 = r3.getUTCFullYear();
      if (a3.isTwoDigitYear) {
        var l3 = x$e(a3.year, o3);
        return r3.setUTCFullYear(l3, 0, 1), r3.setUTCHours(0, 0, 0, 0), r3;
      }
      var s3 = !("era" in e28) || e28.era === 1 ? a3.year : 1 - a3.year;
      return r3.setUTCFullYear(s3, 0, 1), r3.setUTCHours(0, 0, 0, 0), r3;
    }
  }]), t3;
}(m$o);
function h$B(g3, e28) {
  var a3, i, o3, l3, n3, s3, f3, u3;
  n$u(1, arguments);
  var v3 = a$S(g3), t3 = v3.getUTCFullYear(), C3 = e$K(), r3 = n$t((a3 = (i = (o3 = (l3 = e28 == null ? void 0 : e28.firstWeekContainsDate) !== null && l3 !== void 0 ? l3 : e28 == null || (n3 = e28.locale) === null || n3 === void 0 || (s3 = n3.options) === null || s3 === void 0 ? void 0 : s3.firstWeekContainsDate) !== null && o3 !== void 0 ? o3 : C3.firstWeekContainsDate) !== null && i !== void 0 ? i : (f3 = C3.locale) === null || f3 === void 0 || (u3 = f3.options) === null || u3 === void 0 ? void 0 : u3.firstWeekContainsDate) !== null && a3 !== void 0 ? a3 : 1);
  if (!(r3 >= 1 && r3 <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var d3 = /* @__PURE__ */ new Date(0);
  d3.setUTCFullYear(t3 + 1, 0, r3), d3.setUTCHours(0, 0, 0, 0);
  var k3 = C$y(d3, e28), m3 = /* @__PURE__ */ new Date(0);
  m3.setUTCFullYear(t3, 0, r3), m3.setUTCHours(0, 0, 0, 0);
  var W3 = C$y(m3, e28);
  return v3.getTime() >= k3.getTime() ? t3 + 1 : v3.getTime() >= W3.getTime() ? t3 : t3 - 1;
}
var I$e = /* @__PURE__ */ function(Y3) {
  i$w(o3, Y3);
  var u3 = l$p(o3);
  function o3() {
    var i;
    c$N(this, o3);
    for (var r3 = arguments.length, e28 = new Array(r3), a3 = 0; a3 < r3; a3++)
      e28[a3] = arguments[a3];
    return i = u3.call.apply(u3, [this].concat(e28)), u$t(i$x(i), "priority", 130), u$t(i$x(i), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), i;
  }
  return u$u(o3, [{
    key: "parse",
    value: function(r3, e28, a3) {
      var t3 = function(s3) {
        return {
          year: s3,
          isTwoDigitYear: e28 === "YY"
        };
      };
      switch (e28) {
        case "Y":
          return h$C(d$q(4, r3), t3);
        case "Yo":
          return h$C(a3.ordinalNumber(r3, {
            unit: "year"
          }), t3);
        default:
          return h$C(d$q(e28.length, r3), t3);
      }
    }
  }, {
    key: "validate",
    value: function(r3, e28) {
      return e28.isTwoDigitYear || e28.year > 0;
    }
  }, {
    key: "set",
    value: function(r3, e28, a3, t3) {
      var l3 = h$B(r3, t3);
      if (a3.isTwoDigitYear) {
        var s3 = x$e(a3.year, l3);
        return r3.setUTCFullYear(s3, 0, t3.firstWeekContainsDate), r3.setUTCHours(0, 0, 0, 0), C$y(r3, t3);
      }
      var C3 = !("era" in e28) || e28.era === 1 ? a3.year : 1 - a3.year;
      return r3.setUTCFullYear(C3, 0, t3.firstWeekContainsDate), r3.setUTCHours(0, 0, 0, 0), C$y(r3, t3);
    }
  }]), o3;
}(m$o);
function i$s(a3) {
  n$u(1, arguments);
  var e28 = 1, t3 = a$S(a3), r3 = t3.getUTCDay(), o3 = (r3 < e28 ? 7 : 0) + r3 - e28;
  return t3.setUTCDate(t3.getUTCDate() - o3), t3.setUTCHours(0, 0, 0, 0), t3;
}
var P$d = /* @__PURE__ */ function(p3) {
  i$w(i, p3);
  var s3 = l$p(i);
  function i() {
    var r3;
    c$N(this, i);
    for (var e28 = arguments.length, t3 = new Array(e28), a3 = 0; a3 < e28; a3++)
      t3[a3] = arguments[a3];
    return r3 = s3.call.apply(s3, [this].concat(t3)), u$t(i$x(r3), "priority", 130), u$t(i$x(r3), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r3;
  }
  return u$u(i, [{
    key: "parse",
    value: function(e28, t3) {
      return t3 === "R" ? I$f(4, e28) : I$f(t3.length, e28);
    }
  }, {
    key: "set",
    value: function(e28, t3, a3) {
      var o3 = /* @__PURE__ */ new Date(0);
      return o3.setUTCFullYear(a3, 0, 4), o3.setUTCHours(0, 0, 0, 0), i$s(o3);
    }
  }]), i;
}(m$o);
var Y$4 = /* @__PURE__ */ function(p3) {
  i$w(o3, p3);
  var s3 = l$p(o3);
  function o3() {
    var e28;
    c$N(this, o3);
    for (var r3 = arguments.length, t3 = new Array(r3), i = 0; i < r3; i++)
      t3[i] = arguments[i];
    return e28 = s3.call.apply(s3, [this].concat(t3)), u$t(i$x(e28), "priority", 130), u$t(i$x(e28), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), e28;
  }
  return u$u(o3, [{
    key: "parse",
    value: function(r3, t3) {
      return t3 === "u" ? I$f(4, r3) : I$f(t3.length, r3);
    }
  }, {
    key: "set",
    value: function(r3, t3, i) {
      return r3.setUTCFullYear(i, 0, 1), r3.setUTCHours(0, 0, 0, 0), r3;
    }
  }]), o3;
}(m$o);
var C$x = /* @__PURE__ */ function(u3) {
  i$w(o3, u3);
  var i = l$p(o3);
  function o3() {
    var a3;
    c$N(this, o3);
    for (var r3 = arguments.length, e28 = new Array(r3), t3 = 0; t3 < r3; t3++)
      e28[t3] = arguments[t3];
    return a3 = i.call.apply(i, [this].concat(e28)), u$t(i$x(a3), "priority", 120), u$t(i$x(a3), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a3;
  }
  return u$u(o3, [{
    key: "parse",
    value: function(r3, e28, t3) {
      switch (e28) {
        case "Q":
        case "QQ":
          return d$q(e28.length, r3);
        case "Qo":
          return t3.ordinalNumber(r3, {
            unit: "quarter"
          });
        case "QQQ":
          return t3.quarter(r3, {
            width: "abbreviated",
            context: "formatting"
          }) || t3.quarter(r3, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return t3.quarter(r3, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return t3.quarter(r3, {
            width: "wide",
            context: "formatting"
          }) || t3.quarter(r3, {
            width: "abbreviated",
            context: "formatting"
          }) || t3.quarter(r3, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r3, e28) {
      return e28 >= 1 && e28 <= 4;
    }
  }, {
    key: "set",
    value: function(r3, e28, t3) {
      return r3.setUTCMonth((t3 - 1) * 3, 1), r3.setUTCHours(0, 0, 0, 0), r3;
    }
  }]), o3;
}(m$o);
var T$e = /* @__PURE__ */ function(u3) {
  i$w(n3, u3);
  var o3 = l$p(n3);
  function n3() {
    var a3;
    c$N(this, n3);
    for (var r3 = arguments.length, t3 = new Array(r3), e28 = 0; e28 < r3; e28++)
      t3[e28] = arguments[e28];
    return a3 = o3.call.apply(o3, [this].concat(t3)), u$t(i$x(a3), "priority", 120), u$t(i$x(a3), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a3;
  }
  return u$u(n3, [{
    key: "parse",
    value: function(r3, t3, e28) {
      switch (t3) {
        case "q":
        case "qq":
          return d$q(t3.length, r3);
        case "qo":
          return e28.ordinalNumber(r3, {
            unit: "quarter"
          });
        case "qqq":
          return e28.quarter(r3, {
            width: "abbreviated",
            context: "standalone"
          }) || e28.quarter(r3, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return e28.quarter(r3, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return e28.quarter(r3, {
            width: "wide",
            context: "standalone"
          }) || e28.quarter(r3, {
            width: "abbreviated",
            context: "standalone"
          }) || e28.quarter(r3, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r3, t3) {
      return t3 >= 1 && t3 <= 4;
    }
  }, {
    key: "set",
    value: function(r3, t3, e28) {
      return r3.setUTCMonth((e28 - 1) * 3, 1), r3.setUTCHours(0, 0, 0, 0), r3;
    }
  }]), n3;
}(m$o);
var I$d = /* @__PURE__ */ function(c3) {
  i$w(n3, c3);
  var s3 = l$p(n3);
  function n3() {
    var o3;
    c$N(this, n3);
    for (var r3 = arguments.length, e28 = new Array(r3), t3 = 0; t3 < r3; t3++)
      e28[t3] = arguments[t3];
    return o3 = s3.call.apply(s3, [this].concat(e28)), u$t(i$x(o3), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), u$t(i$x(o3), "priority", 110), o3;
  }
  return u$u(n3, [{
    key: "parse",
    value: function(r3, e28, t3) {
      var a3 = function(f3) {
        return f3 - 1;
      };
      switch (e28) {
        case "M":
          return h$C(i$t(d$r.month, r3), a3);
        case "MM":
          return h$C(d$q(2, r3), a3);
        case "Mo":
          return h$C(t3.ordinalNumber(r3, {
            unit: "month"
          }), a3);
        case "MMM":
          return t3.month(r3, {
            width: "abbreviated",
            context: "formatting"
          }) || t3.month(r3, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return t3.month(r3, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return t3.month(r3, {
            width: "wide",
            context: "formatting"
          }) || t3.month(r3, {
            width: "abbreviated",
            context: "formatting"
          }) || t3.month(r3, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r3, e28) {
      return e28 >= 0 && e28 <= 11;
    }
  }, {
    key: "set",
    value: function(r3, e28, t3) {
      return r3.setUTCMonth(t3, 1), r3.setUTCHours(0, 0, 0, 0), r3;
    }
  }]), n3;
}(m$o);
var D$i = /* @__PURE__ */ function(m3) {
  i$w(o3, m3);
  var i = l$p(o3);
  function o3() {
    var n3;
    c$N(this, o3);
    for (var r3 = arguments.length, e28 = new Array(r3), t3 = 0; t3 < r3; t3++)
      e28[t3] = arguments[t3];
    return n3 = i.call.apply(i, [this].concat(e28)), u$t(i$x(n3), "priority", 110), u$t(i$x(n3), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), n3;
  }
  return u$u(o3, [{
    key: "parse",
    value: function(r3, e28, t3) {
      var a3 = function(c3) {
        return c3 - 1;
      };
      switch (e28) {
        case "L":
          return h$C(i$t(d$r.month, r3), a3);
        case "LL":
          return h$C(d$q(2, r3), a3);
        case "Lo":
          return h$C(t3.ordinalNumber(r3, {
            unit: "month"
          }), a3);
        case "LLL":
          return t3.month(r3, {
            width: "abbreviated",
            context: "standalone"
          }) || t3.month(r3, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return t3.month(r3, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return t3.month(r3, {
            width: "wide",
            context: "standalone"
          }) || t3.month(r3, {
            width: "abbreviated",
            context: "standalone"
          }) || t3.month(r3, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r3, e28) {
      return e28 >= 0 && e28 <= 11;
    }
  }, {
    key: "set",
    value: function(r3, e28, t3) {
      return r3.setUTCMonth(t3, 1), r3.setUTCHours(0, 0, 0, 0), r3;
    }
  }]), o3;
}(m$o);
function U$b(v3, e28) {
  var t3, o3, r3, l3, i, a3, n3, f3;
  n$u(1, arguments);
  var s3 = e$K(), u3 = n$t((t3 = (o3 = (r3 = (l3 = e28 == null ? void 0 : e28.firstWeekContainsDate) !== null && l3 !== void 0 ? l3 : e28 == null || (i = e28.locale) === null || i === void 0 || (a3 = i.options) === null || a3 === void 0 ? void 0 : a3.firstWeekContainsDate) !== null && r3 !== void 0 ? r3 : s3.firstWeekContainsDate) !== null && o3 !== void 0 ? o3 : (n3 = s3.locale) === null || n3 === void 0 || (f3 = n3.options) === null || f3 === void 0 ? void 0 : f3.firstWeekContainsDate) !== null && t3 !== void 0 ? t3 : 1), m3 = h$B(v3, e28), d3 = /* @__PURE__ */ new Date(0);
  d3.setUTCFullYear(m3, 0, u3), d3.setUTCHours(0, 0, 0, 0);
  var C3 = C$y(d3, e28);
  return C3;
}
var u$s = 6048e5;
function p$2B(t3, r3) {
  n$u(1, arguments);
  var e28 = a$S(t3), a3 = C$y(e28, r3).getTime() - U$b(e28, r3).getTime();
  return Math.round(a3 / u$s) + 1;
}
function C$w(t3, r3, o3) {
  n$u(2, arguments);
  var e28 = a$S(t3), a3 = n$t(r3), m3 = p$2B(e28, o3) - a3;
  return e28.setUTCDate(e28.getUTCDate() - m3 * 7), e28;
}
var U$a = /* @__PURE__ */ function(u3) {
  i$w(i, u3);
  var o3 = l$p(i);
  function i() {
    var a3;
    c$N(this, i);
    for (var r3 = arguments.length, e28 = new Array(r3), t3 = 0; t3 < r3; t3++)
      e28[t3] = arguments[t3];
    return a3 = o3.call.apply(o3, [this].concat(e28)), u$t(i$x(a3), "priority", 100), u$t(i$x(a3), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), a3;
  }
  return u$u(i, [{
    key: "parse",
    value: function(r3, e28, t3) {
      switch (e28) {
        case "w":
          return i$t(d$r.week, r3);
        case "wo":
          return t3.ordinalNumber(r3, {
            unit: "week"
          });
        default:
          return d$q(e28.length, r3);
      }
    }
  }, {
    key: "validate",
    value: function(r3, e28) {
      return e28 >= 1 && e28 <= 53;
    }
  }, {
    key: "set",
    value: function(r3, e28, t3, s3) {
      return C$y(C$w(r3, t3, s3), s3);
    }
  }]), i;
}(m$o);
function O$j(s3) {
  n$u(1, arguments);
  var r3 = a$S(s3), e28 = r3.getUTCFullYear(), t3 = /* @__PURE__ */ new Date(0);
  t3.setUTCFullYear(e28 + 1, 0, 4), t3.setUTCHours(0, 0, 0, 0);
  var u3 = i$s(t3), a3 = /* @__PURE__ */ new Date(0);
  a3.setUTCFullYear(e28, 0, 4), a3.setUTCHours(0, 0, 0, 0);
  var i = i$s(a3);
  return r3.getTime() >= u3.getTime() ? e28 + 1 : r3.getTime() >= i.getTime() ? e28 : e28 - 1;
}
function O$i(e28) {
  n$u(1, arguments);
  var t3 = O$j(e28), r3 = /* @__PURE__ */ new Date(0);
  r3.setUTCFullYear(t3, 0, 4), r3.setUTCHours(0, 0, 0, 0);
  var a3 = i$s(r3);
  return a3;
}
var i$r = 6048e5;
function g$n(e28) {
  n$u(1, arguments);
  var r3 = a$S(e28), t3 = i$s(r3).getTime() - O$i(r3).getTime();
  return Math.round(t3 / i$r) + 1;
}
function d$p(t3, r3) {
  n$u(2, arguments);
  var e28 = a$S(t3), o3 = n$t(r3), a3 = g$n(e28) - o3;
  return e28.setUTCDate(e28.getUTCDate() - a3 * 7), e28;
}
var b$f = /* @__PURE__ */ function(m3) {
  i$w(i, m3);
  var o3 = l$p(i);
  function i() {
    var a3;
    c$N(this, i);
    for (var r3 = arguments.length, e28 = new Array(r3), t3 = 0; t3 < r3; t3++)
      e28[t3] = arguments[t3];
    return a3 = o3.call.apply(o3, [this].concat(e28)), u$t(i$x(a3), "priority", 100), u$t(i$x(a3), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a3;
  }
  return u$u(i, [{
    key: "parse",
    value: function(r3, e28, t3) {
      switch (e28) {
        case "I":
          return i$t(d$r.week, r3);
        case "Io":
          return t3.ordinalNumber(r3, {
            unit: "week"
          });
        default:
          return d$q(e28.length, r3);
      }
    }
  }, {
    key: "validate",
    value: function(r3, e28) {
      return e28 >= 1 && e28 <= 53;
    }
  }, {
    key: "set",
    value: function(r3, e28, t3) {
      return i$s(d$p(r3, t3));
    }
  }]), i;
}(m$o);
var D$h = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], N$j = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], H$8 = /* @__PURE__ */ function(u3) {
  i$w(i, u3);
  var n3 = l$p(i);
  function i() {
    var a3;
    c$N(this, i);
    for (var r3 = arguments.length, e28 = new Array(r3), t3 = 0; t3 < r3; t3++)
      e28[t3] = arguments[t3];
    return a3 = n3.call.apply(n3, [this].concat(e28)), u$t(i$x(a3), "priority", 90), u$t(i$x(a3), "subPriority", 1), u$t(i$x(a3), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), a3;
  }
  return u$u(i, [{
    key: "parse",
    value: function(r3, e28, t3) {
      switch (e28) {
        case "d":
          return i$t(d$r.date, r3);
        case "do":
          return t3.ordinalNumber(r3, {
            unit: "date"
          });
        default:
          return d$q(e28.length, r3);
      }
    }
  }, {
    key: "validate",
    value: function(r3, e28) {
      var t3 = r3.getUTCFullYear(), p3 = P$e(t3), m3 = r3.getUTCMonth();
      return p3 ? e28 >= 1 && e28 <= N$j[m3] : e28 >= 1 && e28 <= D$h[m3];
    }
  }, {
    key: "set",
    value: function(r3, e28, t3) {
      return r3.setUTCDate(t3), r3.setUTCHours(0, 0, 0, 0), r3;
    }
  }]), i;
}(m$o);
var L$h = /* @__PURE__ */ function(u3) {
  i$w(i, u3);
  var n3 = l$p(i);
  function i() {
    var a3;
    c$N(this, i);
    for (var r3 = arguments.length, e28 = new Array(r3), t3 = 0; t3 < r3; t3++)
      e28[t3] = arguments[t3];
    return a3 = n3.call.apply(n3, [this].concat(e28)), u$t(i$x(a3), "priority", 90), u$t(i$x(a3), "subpriority", 1), u$t(i$x(a3), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), a3;
  }
  return u$u(i, [{
    key: "parse",
    value: function(r3, e28, t3) {
      switch (e28) {
        case "D":
        case "DD":
          return i$t(d$r.dayOfYear, r3);
        case "Do":
          return t3.ordinalNumber(r3, {
            unit: "date"
          });
        default:
          return d$q(e28.length, r3);
      }
    }
  }, {
    key: "validate",
    value: function(r3, e28) {
      var t3 = r3.getUTCFullYear(), m3 = P$e(t3);
      return m3 ? e28 >= 1 && e28 <= 366 : e28 >= 1 && e28 <= 365;
    }
  }, {
    key: "set",
    value: function(r3, e28, t3) {
      return r3.setUTCMonth(0, t3), r3.setUTCHours(0, 0, 0, 0), r3;
    }
  }]), i;
}(m$o);
function U$9(O3, p3, e28) {
  var r3, o3, a3, l3, n3, i, d3, v3;
  n$u(2, arguments);
  var s3 = e$K(), u3 = n$t((r3 = (o3 = (a3 = (l3 = e28 == null ? void 0 : e28.weekStartsOn) !== null && l3 !== void 0 ? l3 : e28 == null || (n3 = e28.locale) === null || n3 === void 0 || (i = n3.options) === null || i === void 0 ? void 0 : i.weekStartsOn) !== null && a3 !== void 0 ? a3 : s3.weekStartsOn) !== null && o3 !== void 0 ? o3 : (d3 = s3.locale) === null || d3 === void 0 || (v3 = d3.options) === null || v3 === void 0 ? void 0 : v3.weekStartsOn) !== null && r3 !== void 0 ? r3 : 0);
  if (!(u3 >= 0 && u3 <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var t3 = a$S(O3), f3 = n$t(p3), w3 = t3.getUTCDay(), c3 = f3 % 7, _3 = (c3 + 7) % 7, g3 = (_3 < u3 ? 7 : 0) + f3 - w3;
  return t3.setUTCDate(t3.getUTCDate() + g3), t3;
}
var T$d = /* @__PURE__ */ function(f3) {
  i$w(a3, f3);
  var i = l$p(a3);
  function a3() {
    var e28;
    c$N(this, a3);
    for (var r3 = arguments.length, o3 = new Array(r3), t3 = 0; t3 < r3; t3++)
      o3[t3] = arguments[t3];
    return e28 = i.call.apply(i, [this].concat(o3)), u$t(i$x(e28), "priority", 90), u$t(i$x(e28), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), e28;
  }
  return u$u(a3, [{
    key: "parse",
    value: function(r3, o3, t3) {
      switch (o3) {
        case "E":
        case "EE":
        case "EEE":
          return t3.day(r3, {
            width: "abbreviated",
            context: "formatting"
          }) || t3.day(r3, {
            width: "short",
            context: "formatting"
          }) || t3.day(r3, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return t3.day(r3, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return t3.day(r3, {
            width: "short",
            context: "formatting"
          }) || t3.day(r3, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return t3.day(r3, {
            width: "wide",
            context: "formatting"
          }) || t3.day(r3, {
            width: "abbreviated",
            context: "formatting"
          }) || t3.day(r3, {
            width: "short",
            context: "formatting"
          }) || t3.day(r3, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r3, o3) {
      return o3 >= 0 && o3 <= 6;
    }
  }, {
    key: "set",
    value: function(r3, o3, t3, c3) {
      return r3 = U$9(r3, t3, c3), r3.setUTCHours(0, 0, 0, 0), r3;
    }
  }]), a3;
}(m$o);
var N$i = /* @__PURE__ */ function(m3) {
  i$w(a3, m3);
  var n3 = l$p(a3);
  function a3() {
    var o3;
    c$N(this, a3);
    for (var r3 = arguments.length, t3 = new Array(r3), e28 = 0; e28 < r3; e28++)
      t3[e28] = arguments[e28];
    return o3 = n3.call.apply(n3, [this].concat(t3)), u$t(i$x(o3), "priority", 90), u$t(i$x(o3), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), o3;
  }
  return u$u(a3, [{
    key: "parse",
    value: function(r3, t3, e28, i) {
      var s3 = function(f3) {
        var p3 = Math.floor((f3 - 1) / 7) * 7;
        return (f3 + i.weekStartsOn + 6) % 7 + p3;
      };
      switch (t3) {
        case "e":
        case "ee":
          return h$C(d$q(t3.length, r3), s3);
        case "eo":
          return h$C(e28.ordinalNumber(r3, {
            unit: "day"
          }), s3);
        case "eee":
          return e28.day(r3, {
            width: "abbreviated",
            context: "formatting"
          }) || e28.day(r3, {
            width: "short",
            context: "formatting"
          }) || e28.day(r3, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return e28.day(r3, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return e28.day(r3, {
            width: "short",
            context: "formatting"
          }) || e28.day(r3, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return e28.day(r3, {
            width: "wide",
            context: "formatting"
          }) || e28.day(r3, {
            width: "abbreviated",
            context: "formatting"
          }) || e28.day(r3, {
            width: "short",
            context: "formatting"
          }) || e28.day(r3, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r3, t3) {
      return t3 >= 0 && t3 <= 6;
    }
  }, {
    key: "set",
    value: function(r3, t3, e28, i) {
      return r3 = U$9(r3, e28, i), r3.setUTCHours(0, 0, 0, 0), r3;
    }
  }]), a3;
}(m$o);
var N$h = /* @__PURE__ */ function(p3) {
  i$w(o3, p3);
  var s3 = l$p(o3);
  function o3() {
    var t3;
    c$N(this, o3);
    for (var r3 = arguments.length, a3 = new Array(r3), e28 = 0; e28 < r3; e28++)
      a3[e28] = arguments[e28];
    return t3 = s3.call.apply(s3, [this].concat(a3)), u$t(i$x(t3), "priority", 90), u$t(i$x(t3), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), t3;
  }
  return u$u(o3, [{
    key: "parse",
    value: function(r3, a3, e28, n3) {
      var c3 = function(i) {
        var f3 = Math.floor((i - 1) / 7) * 7;
        return (i + n3.weekStartsOn + 6) % 7 + f3;
      };
      switch (a3) {
        case "c":
        case "cc":
          return h$C(d$q(a3.length, r3), c3);
        case "co":
          return h$C(e28.ordinalNumber(r3, {
            unit: "day"
          }), c3);
        case "ccc":
          return e28.day(r3, {
            width: "abbreviated",
            context: "standalone"
          }) || e28.day(r3, {
            width: "short",
            context: "standalone"
          }) || e28.day(r3, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return e28.day(r3, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return e28.day(r3, {
            width: "short",
            context: "standalone"
          }) || e28.day(r3, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return e28.day(r3, {
            width: "wide",
            context: "standalone"
          }) || e28.day(r3, {
            width: "abbreviated",
            context: "standalone"
          }) || e28.day(r3, {
            width: "short",
            context: "standalone"
          }) || e28.day(r3, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r3, a3) {
      return a3 >= 0 && a3 <= 6;
    }
  }, {
    key: "set",
    value: function(r3, a3, e28, n3) {
      return r3 = U$9(r3, e28, n3), r3.setUTCHours(0, 0, 0, 0), r3;
    }
  }]), o3;
}(m$o);
function y$k(t3, a3) {
  n$u(2, arguments);
  var r3 = n$t(a3);
  r3 % 7 === 0 && (r3 = r3 - 7);
  var o3 = 1, e28 = a$S(t3), n3 = e28.getUTCDay(), d3 = r3 % 7, f3 = (d3 + 7) % 7, i = (f3 < o3 ? 7 : 0) + r3 - n3;
  return e28.setUTCDate(e28.getUTCDate() + i), e28;
}
var O$h = /* @__PURE__ */ function(l3) {
  i$w(e28, l3);
  var s3 = l$p(e28);
  function e28() {
    var o3;
    c$N(this, e28);
    for (var r3 = arguments.length, i = new Array(r3), t3 = 0; t3 < r3; t3++)
      i[t3] = arguments[t3];
    return o3 = s3.call.apply(s3, [this].concat(i)), u$t(i$x(o3), "priority", 90), u$t(i$x(o3), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), o3;
  }
  return u$u(e28, [{
    key: "parse",
    value: function(r3, i, t3) {
      var a3 = function(u3) {
        return u3 === 0 ? 7 : u3;
      };
      switch (i) {
        case "i":
        case "ii":
          return d$q(i.length, r3);
        case "io":
          return t3.ordinalNumber(r3, {
            unit: "day"
          });
        case "iii":
          return h$C(t3.day(r3, {
            width: "abbreviated",
            context: "formatting"
          }) || t3.day(r3, {
            width: "short",
            context: "formatting"
          }) || t3.day(r3, {
            width: "narrow",
            context: "formatting"
          }), a3);
        case "iiiii":
          return h$C(t3.day(r3, {
            width: "narrow",
            context: "formatting"
          }), a3);
        case "iiiiii":
          return h$C(t3.day(r3, {
            width: "short",
            context: "formatting"
          }) || t3.day(r3, {
            width: "narrow",
            context: "formatting"
          }), a3);
        case "iiii":
        default:
          return h$C(t3.day(r3, {
            width: "wide",
            context: "formatting"
          }) || t3.day(r3, {
            width: "abbreviated",
            context: "formatting"
          }) || t3.day(r3, {
            width: "short",
            context: "formatting"
          }) || t3.day(r3, {
            width: "narrow",
            context: "formatting"
          }), a3);
      }
    }
  }, {
    key: "validate",
    value: function(r3, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(r3, i, t3) {
      return r3 = y$k(r3, t3), r3.setUTCHours(0, 0, 0, 0), r3;
    }
  }]), e28;
}(m$o);
var _$e = /* @__PURE__ */ function(f3) {
  i$w(e28, f3);
  var i = l$p(e28);
  function e28() {
    var a3;
    c$N(this, e28);
    for (var t3 = arguments.length, o3 = new Array(t3), r3 = 0; r3 < t3; r3++)
      o3[r3] = arguments[r3];
    return a3 = i.call.apply(i, [this].concat(o3)), u$t(i$x(a3), "priority", 80), u$t(i$x(a3), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), a3;
  }
  return u$u(e28, [{
    key: "parse",
    value: function(t3, o3, r3) {
      switch (o3) {
        case "a":
        case "aa":
        case "aaa":
          return r3.dayPeriod(t3, {
            width: "abbreviated",
            context: "formatting"
          }) || r3.dayPeriod(t3, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return r3.dayPeriod(t3, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return r3.dayPeriod(t3, {
            width: "wide",
            context: "formatting"
          }) || r3.dayPeriod(t3, {
            width: "abbreviated",
            context: "formatting"
          }) || r3.dayPeriod(t3, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(t3, o3, r3) {
      return t3.setUTCHours(w$f(r3), 0, 0, 0), t3;
    }
  }]), e28;
}(m$o);
var M$8 = /* @__PURE__ */ function(d3) {
  i$w(o3, d3);
  var a3 = l$p(o3);
  function o3() {
    var e28;
    c$N(this, o3);
    for (var t3 = arguments.length, i = new Array(t3), r3 = 0; r3 < t3; r3++)
      i[r3] = arguments[r3];
    return e28 = a3.call.apply(a3, [this].concat(i)), u$t(i$x(e28), "priority", 80), u$t(i$x(e28), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), e28;
  }
  return u$u(o3, [{
    key: "parse",
    value: function(t3, i, r3) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return r3.dayPeriod(t3, {
            width: "abbreviated",
            context: "formatting"
          }) || r3.dayPeriod(t3, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return r3.dayPeriod(t3, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return r3.dayPeriod(t3, {
            width: "wide",
            context: "formatting"
          }) || r3.dayPeriod(t3, {
            width: "abbreviated",
            context: "formatting"
          }) || r3.dayPeriod(t3, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(t3, i, r3) {
      return t3.setUTCHours(w$f(r3), 0, 0, 0), t3;
    }
  }]), o3;
}(m$o);
var T$c = /* @__PURE__ */ function(d3) {
  i$w(o3, d3);
  var a3 = l$p(o3);
  function o3() {
    var e28;
    c$N(this, o3);
    for (var t3 = arguments.length, i = new Array(t3), r3 = 0; r3 < t3; r3++)
      i[r3] = arguments[r3];
    return e28 = a3.call.apply(a3, [this].concat(i)), u$t(i$x(e28), "priority", 80), u$t(i$x(e28), "incompatibleTokens", ["a", "b", "t", "T"]), e28;
  }
  return u$u(o3, [{
    key: "parse",
    value: function(t3, i, r3) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return r3.dayPeriod(t3, {
            width: "abbreviated",
            context: "formatting"
          }) || r3.dayPeriod(t3, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return r3.dayPeriod(t3, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return r3.dayPeriod(t3, {
            width: "wide",
            context: "formatting"
          }) || r3.dayPeriod(t3, {
            width: "abbreviated",
            context: "formatting"
          }) || r3.dayPeriod(t3, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(t3, i, r3) {
      return t3.setUTCHours(w$f(r3), 0, 0, 0), t3;
    }
  }]), o3;
}(m$o);
var w$e = /* @__PURE__ */ function(m3) {
  i$w(s3, m3);
  var i = l$p(s3);
  function s3() {
    var o3;
    c$N(this, s3);
    for (var r3 = arguments.length, e28 = new Array(r3), t3 = 0; t3 < r3; t3++)
      e28[t3] = arguments[t3];
    return o3 = i.call.apply(i, [this].concat(e28)), u$t(i$x(o3), "priority", 70), u$t(i$x(o3), "incompatibleTokens", ["H", "K", "k", "t", "T"]), o3;
  }
  return u$u(s3, [{
    key: "parse",
    value: function(r3, e28, t3) {
      switch (e28) {
        case "h":
          return i$t(d$r.hour12h, r3);
        case "ho":
          return t3.ordinalNumber(r3, {
            unit: "hour"
          });
        default:
          return d$q(e28.length, r3);
      }
    }
  }, {
    key: "validate",
    value: function(r3, e28) {
      return e28 >= 1 && e28 <= 12;
    }
  }, {
    key: "set",
    value: function(r3, e28, t3) {
      var a3 = r3.getUTCHours() >= 12;
      return a3 && t3 < 12 ? r3.setUTCHours(t3 + 12, 0, 0, 0) : !a3 && t3 === 12 ? r3.setUTCHours(0, 0, 0, 0) : r3.setUTCHours(t3, 0, 0, 0), r3;
    }
  }]), s3;
}(m$o);
var k$f = /* @__PURE__ */ function(u3) {
  i$w(a3, u3);
  var i = l$p(a3);
  function a3() {
    var o3;
    c$N(this, a3);
    for (var r3 = arguments.length, t3 = new Array(r3), e28 = 0; e28 < r3; e28++)
      t3[e28] = arguments[e28];
    return o3 = i.call.apply(i, [this].concat(t3)), u$t(i$x(o3), "priority", 70), u$t(i$x(o3), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), o3;
  }
  return u$u(a3, [{
    key: "parse",
    value: function(r3, t3, e28) {
      switch (t3) {
        case "H":
          return i$t(d$r.hour23h, r3);
        case "Ho":
          return e28.ordinalNumber(r3, {
            unit: "hour"
          });
        default:
          return d$q(t3.length, r3);
      }
    }
  }, {
    key: "validate",
    value: function(r3, t3) {
      return t3 >= 0 && t3 <= 23;
    }
  }, {
    key: "set",
    value: function(r3, t3, e28) {
      return r3.setUTCHours(e28, 0, 0, 0), r3;
    }
  }]), a3;
}(m$o);
var k$e = /* @__PURE__ */ function(u3) {
  i$w(i, u3);
  var s3 = l$p(i);
  function i() {
    var o3;
    c$N(this, i);
    for (var r3 = arguments.length, e28 = new Array(r3), t3 = 0; t3 < r3; t3++)
      e28[t3] = arguments[t3];
    return o3 = s3.call.apply(s3, [this].concat(e28)), u$t(i$x(o3), "priority", 70), u$t(i$x(o3), "incompatibleTokens", ["h", "H", "k", "t", "T"]), o3;
  }
  return u$u(i, [{
    key: "parse",
    value: function(r3, e28, t3) {
      switch (e28) {
        case "K":
          return i$t(d$r.hour11h, r3);
        case "Ko":
          return t3.ordinalNumber(r3, {
            unit: "hour"
          });
        default:
          return d$q(e28.length, r3);
      }
    }
  }, {
    key: "validate",
    value: function(r3, e28) {
      return e28 >= 0 && e28 <= 11;
    }
  }, {
    key: "set",
    value: function(r3, e28, t3) {
      var m3 = r3.getUTCHours() >= 12;
      return m3 && t3 < 12 ? r3.setUTCHours(t3 + 12, 0, 0, 0) : r3.setUTCHours(t3, 0, 0, 0), r3;
    }
  }]), i;
}(m$o);
var w$d = /* @__PURE__ */ function(u3) {
  i$w(a3, u3);
  var i = l$p(a3);
  function a3() {
    var o3;
    c$N(this, a3);
    for (var r3 = arguments.length, e28 = new Array(r3), t3 = 0; t3 < r3; t3++)
      e28[t3] = arguments[t3];
    return o3 = i.call.apply(i, [this].concat(e28)), u$t(i$x(o3), "priority", 70), u$t(i$x(o3), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), o3;
  }
  return u$u(a3, [{
    key: "parse",
    value: function(r3, e28, t3) {
      switch (e28) {
        case "k":
          return i$t(d$r.hour24h, r3);
        case "ko":
          return t3.ordinalNumber(r3, {
            unit: "hour"
          });
        default:
          return d$q(e28.length, r3);
      }
    }
  }, {
    key: "validate",
    value: function(r3, e28) {
      return e28 >= 1 && e28 <= 24;
    }
  }, {
    key: "set",
    value: function(r3, e28, t3) {
      var m3 = t3 <= 24 ? t3 % 24 : t3;
      return r3.setUTCHours(m3, 0, 0, 0), r3;
    }
  }]), a3;
}(m$o);
var w$c = /* @__PURE__ */ function(m3) {
  i$w(a3, m3);
  var n3 = l$p(a3);
  function a3() {
    var i;
    c$N(this, a3);
    for (var r3 = arguments.length, t3 = new Array(r3), e28 = 0; e28 < r3; e28++)
      t3[e28] = arguments[e28];
    return i = n3.call.apply(n3, [this].concat(t3)), u$t(i$x(i), "priority", 60), u$t(i$x(i), "incompatibleTokens", ["t", "T"]), i;
  }
  return u$u(a3, [{
    key: "parse",
    value: function(r3, t3, e28) {
      switch (t3) {
        case "m":
          return i$t(d$r.minute, r3);
        case "mo":
          return e28.ordinalNumber(r3, {
            unit: "minute"
          });
        default:
          return d$q(t3.length, r3);
      }
    }
  }, {
    key: "validate",
    value: function(r3, t3) {
      return t3 >= 0 && t3 <= 59;
    }
  }, {
    key: "set",
    value: function(r3, t3, e28) {
      return r3.setUTCMinutes(e28, 0, 0), r3;
    }
  }]), a3;
}(m$o);
var S$e = /* @__PURE__ */ function(m3) {
  i$w(a3, m3);
  var i = l$p(a3);
  function a3() {
    var o3;
    c$N(this, a3);
    for (var r3 = arguments.length, e28 = new Array(r3), t3 = 0; t3 < r3; t3++)
      e28[t3] = arguments[t3];
    return o3 = i.call.apply(i, [this].concat(e28)), u$t(i$x(o3), "priority", 50), u$t(i$x(o3), "incompatibleTokens", ["t", "T"]), o3;
  }
  return u$u(a3, [{
    key: "parse",
    value: function(r3, e28, t3) {
      switch (e28) {
        case "s":
          return i$t(d$r.second, r3);
        case "so":
          return t3.ordinalNumber(r3, {
            unit: "second"
          });
        default:
          return d$q(e28.length, r3);
      }
    }
  }, {
    key: "validate",
    value: function(r3, e28) {
      return e28 >= 0 && e28 <= 59;
    }
  }, {
    key: "set",
    value: function(r3, e28, t3) {
      return r3.setUTCSeconds(t3, 0), r3;
    }
  }]), a3;
}(m$o);
var k$d = /* @__PURE__ */ function(l3) {
  i$w(o3, l3);
  var i = l$p(o3);
  function o3() {
    var e28;
    c$N(this, o3);
    for (var t3 = arguments.length, a3 = new Array(t3), r3 = 0; r3 < t3; r3++)
      a3[r3] = arguments[r3];
    return e28 = i.call.apply(i, [this].concat(a3)), u$t(i$x(e28), "priority", 30), u$t(i$x(e28), "incompatibleTokens", ["t", "T"]), e28;
  }
  return u$u(o3, [{
    key: "parse",
    value: function(t3, a3) {
      var r3 = function(p3) {
        return Math.floor(p3 * Math.pow(10, -a3.length + 3));
      };
      return h$C(d$q(a3.length, t3), r3);
    }
  }, {
    key: "set",
    value: function(t3, a3, r3) {
      return t3.setUTCMilliseconds(r3), t3;
    }
  }]), o3;
}(m$o);
var _$d = /* @__PURE__ */ function(c3) {
  i$w(o3, c3);
  var a3 = l$p(o3);
  function o3() {
    var r3;
    c$N(this, o3);
    for (var e28 = arguments.length, t3 = new Array(e28), i = 0; i < e28; i++)
      t3[i] = arguments[i];
    return r3 = a3.call.apply(a3, [this].concat(t3)), u$t(i$x(r3), "priority", 10), u$t(i$x(r3), "incompatibleTokens", ["t", "T", "x"]), r3;
  }
  return u$u(o3, [{
    key: "parse",
    value: function(e28, t3) {
      switch (t3) {
        case "X":
          return p$2C(i$u.basicOptionalMinutes, e28);
        case "XX":
          return p$2C(i$u.basic, e28);
        case "XXXX":
          return p$2C(i$u.basicOptionalSeconds, e28);
        case "XXXXX":
          return p$2C(i$u.extendedOptionalSeconds, e28);
        case "XXX":
        default:
          return p$2C(i$u.extended, e28);
      }
    }
  }, {
    key: "set",
    value: function(e28, t3, i) {
      return t3.timestampIsSet ? e28 : new Date(e28.getTime() - i);
    }
  }]), o3;
}(m$o);
var w$b = /* @__PURE__ */ function(c3) {
  i$w(o3, c3);
  var a3 = l$p(o3);
  function o3() {
    var r3;
    c$N(this, o3);
    for (var e28 = arguments.length, t3 = new Array(e28), i = 0; i < e28; i++)
      t3[i] = arguments[i];
    return r3 = a3.call.apply(a3, [this].concat(t3)), u$t(i$x(r3), "priority", 10), u$t(i$x(r3), "incompatibleTokens", ["t", "T", "X"]), r3;
  }
  return u$u(o3, [{
    key: "parse",
    value: function(e28, t3) {
      switch (t3) {
        case "x":
          return p$2C(i$u.basicOptionalMinutes, e28);
        case "xx":
          return p$2C(i$u.basic, e28);
        case "xxxx":
          return p$2C(i$u.basicOptionalSeconds, e28);
        case "xxxxx":
          return p$2C(i$u.extendedOptionalSeconds, e28);
        case "xxx":
        default:
          return p$2C(i$u.extended, e28);
      }
    }
  }, {
    key: "set",
    value: function(e28, t3, i) {
      return t3.timestampIsSet ? e28 : new Date(e28.getTime() - i);
    }
  }]), o3;
}(m$o);
var C$v = /* @__PURE__ */ function(m3) {
  i$w(t3, m3);
  var s3 = l$p(t3);
  function t3() {
    var r3;
    c$N(this, t3);
    for (var i = arguments.length, a3 = new Array(i), e28 = 0; e28 < i; e28++)
      a3[e28] = arguments[e28];
    return r3 = s3.call.apply(s3, [this].concat(a3)), u$t(i$x(r3), "priority", 40), u$t(i$x(r3), "incompatibleTokens", "*"), r3;
  }
  return u$u(t3, [{
    key: "parse",
    value: function(i) {
      return D$j(i);
    }
  }, {
    key: "set",
    value: function(i, a3, e28) {
      return [new Date(e28 * 1e3), {
        timestampIsSet: true
      }];
    }
  }]), t3;
}(m$o);
var S$d = /* @__PURE__ */ function(m3) {
  i$w(t3, m3);
  var a3 = l$p(t3);
  function t3() {
    var r3;
    c$N(this, t3);
    for (var i = arguments.length, s3 = new Array(i), e28 = 0; e28 < i; e28++)
      s3[e28] = arguments[e28];
    return r3 = a3.call.apply(a3, [this].concat(s3)), u$t(i$x(r3), "priority", 20), u$t(i$x(r3), "incompatibleTokens", "*"), r3;
  }
  return u$u(t3, [{
    key: "parse",
    value: function(i) {
      return D$j(i);
    }
  }, {
    key: "set",
    value: function(i, s3, e28) {
      return [new Date(e28), {
        timestampIsSet: true
      }];
    }
  }]), t3;
}(m$o);
var sr$1 = {
  G: new T$f(),
  y: new k$g(),
  Y: new I$e(),
  R: new P$d(),
  u: new Y$4(),
  Q: new C$x(),
  q: new T$e(),
  M: new I$d(),
  L: new D$i(),
  w: new U$a(),
  I: new b$f(),
  d: new H$8(),
  D: new L$h(),
  E: new T$d(),
  e: new N$i(),
  c: new N$h(),
  i: new O$h(),
  a: new _$e(),
  b: new M$8(),
  B: new T$c(),
  h: new w$e(),
  H: new k$f(),
  K: new k$e(),
  k: new w$d(),
  m: new w$c(),
  s: new S$e(),
  S: new k$d(),
  X: new _$d(),
  x: new w$b(),
  t: new C$v(),
  T: new S$d()
};
var me$4 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, pe$4 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ge$4 = /^'([^]*?)'?$/, he$2 = /''/g, ke$2 = /\S/, we$3 = /[a-zA-Z]/;
function Pe$2(o3, X3, q3, r3) {
  var m3, p3, g3, h3, k3, w3, _3, O3, y3, D3, S3, $3, E3, N3, T3, C3, W3, b3;
  n$u(3, arguments);
  var a3 = String(o3), f3 = String(X3), i = e$K(), s3 = (m3 = (p3 = r3 == null ? void 0 : r3.locale) !== null && p3 !== void 0 ? p3 : i.locale) !== null && m3 !== void 0 ? m3 : s$1J;
  if (!s3.match)
    throw new RangeError("locale must contain match property");
  var x3 = n$t((g3 = (h3 = (k3 = (w3 = r3 == null ? void 0 : r3.firstWeekContainsDate) !== null && w3 !== void 0 ? w3 : r3 == null || (_3 = r3.locale) === null || _3 === void 0 || (O3 = _3.options) === null || O3 === void 0 ? void 0 : O3.firstWeekContainsDate) !== null && k3 !== void 0 ? k3 : i.firstWeekContainsDate) !== null && h3 !== void 0 ? h3 : (y3 = i.locale) === null || y3 === void 0 || (D3 = y3.options) === null || D3 === void 0 ? void 0 : D3.firstWeekContainsDate) !== null && g3 !== void 0 ? g3 : 1);
  if (!(x3 >= 1 && x3 <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var R3 = n$t((S3 = ($3 = (E3 = (N3 = r3 == null ? void 0 : r3.weekStartsOn) !== null && N3 !== void 0 ? N3 : r3 == null || (T3 = r3.locale) === null || T3 === void 0 || (C3 = T3.options) === null || C3 === void 0 ? void 0 : C3.weekStartsOn) !== null && E3 !== void 0 ? E3 : i.weekStartsOn) !== null && $3 !== void 0 ? $3 : (W3 = i.locale) === null || W3 === void 0 || (b3 = W3.options) === null || b3 === void 0 ? void 0 : b3.weekStartsOn) !== null && S3 !== void 0 ? S3 : 0);
  if (!(R3 >= 0 && R3 <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (f3 === "")
    return a3 === "" ? a$S(q3) : /* @__PURE__ */ new Date(NaN);
  var A3 = {
    firstWeekContainsDate: x3,
    weekStartsOn: R3,
    locale: s3
  }, P3 = [new I$g()], ee2 = f3.match(pe$4).map(function(t3) {
    var e28 = t3[0];
    if (e28 in m$p) {
      var n3 = m$p[e28];
      return n3(t3, s3.formatLong);
    }
    return t3;
  }).join("").match(me$4), F3 = [], u3 = s$s(ee2), z3;
  try {
    var re2 = function() {
      var e28 = z3.value;
      !(r3 != null && r3.useAdditionalWeekYearTokens) && a$D(e28) && c$O(e28, f3, o3), !(r3 != null && r3.useAdditionalDayOfYearTokens) && s$q(e28) && c$O(e28, f3, o3);
      var n3 = e28[0], d3 = sr$1[n3];
      if (d3) {
        var Q3 = d3.incompatibleTokens;
        if (Array.isArray(Q3)) {
          var K3 = F3.find(function(U3) {
            return Q3.includes(U3.token) || U3.token === n3;
          });
          if (K3)
            throw new RangeError("The format string mustn't contain `".concat(K3.fullToken, "` and `").concat(e28, "` at the same time"));
        } else if (d3.incompatibleTokens === "*" && F3.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(e28, "` and any other token at the same time"));
        F3.push({
          token: n3,
          fullToken: e28
        });
        var I3 = d3.run(a3, e28, s3.match, A3);
        if (!I3)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        P3.push(I3.setter), a3 = I3.rest;
      } else {
        if (n3.match(we$3))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + n3 + "`");
        if (e28 === "''" ? e28 = "'" : n3 === "'" && (e28 = _e$2(e28)), a3.indexOf(e28) === 0)
          a3 = a3.slice(e28.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (u3.s(); !(z3 = u3.n()).done; ) {
      var L3 = re2();
      if (o$A(L3) === "object")
        return L3.v;
    }
  } catch (t3) {
    u3.e(t3);
  } finally {
    u3.f();
  }
  if (a3.length > 0 && ke$2.test(a3))
    return /* @__PURE__ */ new Date(NaN);
  var te2 = P3.map(function(t3) {
    return t3.priority;
  }).sort(function(t3, e28) {
    return e28 - t3;
  }).filter(function(t3, e28, n3) {
    return n3.indexOf(t3) === e28;
  }).map(function(t3) {
    return P3.filter(function(e28) {
      return e28.priority === t3;
    }).sort(function(e28, n3) {
      return n3.subPriority - e28.subPriority;
    });
  }).map(function(t3) {
    return t3[0];
  }), Y3 = a$S(q3);
  if (isNaN(Y3.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var l3 = a$E(Y3, g$o(Y3)), M3 = {}, v3 = s$s(te2), j3;
  try {
    for (v3.s(); !(j3 = v3.n()).done; ) {
      var H3 = j3.value;
      if (!H3.validate(l3, A3))
        return /* @__PURE__ */ new Date(NaN);
      var c3 = H3.set(l3, M3, A3);
      Array.isArray(c3) ? (l3 = c3[0], i$y(M3, c3[1])) : l3 = c3;
    }
  } catch (t3) {
    v3.e(t3);
  } finally {
    v3.f();
  }
  return l3;
}
function _e$2(o3) {
  return o3.match(ge$4)[1].replace(he$2, "'");
}
function n$h(t3) {
  return n$u(1, arguments), t3 instanceof Date || o$A(t3) === "object" && Object.prototype.toString.call(t3) === "[object Date]";
}
function u$r(r3) {
  if (n$u(1, arguments), !n$h(r3) && typeof r3 != "number")
    return false;
  var e28 = a$S(r3);
  return !isNaN(Number(e28));
}
var i$q = 864e5;
function u$q(r3) {
  n$u(1, arguments);
  var e28 = a$S(r3), t3 = e28.getTime();
  e28.setUTCMonth(0, 1), e28.setUTCHours(0, 0, 0, 0);
  var a3 = e28.getTime(), m3 = t3 - a3;
  return Math.floor(m3 / i$q) + 1;
}
function r$v(a3, e28) {
  for (var n3 = a3 < 0 ? "-" : "", t3 = Math.abs(a3).toString(); t3.length < e28; )
    t3 = "0" + t3;
  return n3 + t3;
}
var s$p = {
  y: function(e28, t3) {
    var r3 = e28.getUTCFullYear(), u3 = r3 > 0 ? r3 : 1 - r3;
    return r$v(t3 === "yy" ? u3 % 100 : u3, t3.length);
  },
  M: function(e28, t3) {
    var r3 = e28.getUTCMonth();
    return t3 === "M" ? String(r3 + 1) : r$v(r3 + 1, 2);
  },
  d: function(e28, t3) {
    return r$v(e28.getUTCDate(), t3.length);
  },
  a: function(e28, t3) {
    var r3 = e28.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (t3) {
      case "a":
      case "aa":
        return r3.toUpperCase();
      case "aaa":
        return r3;
      case "aaaaa":
        return r3[0];
      case "aaaa":
      default:
        return r3 === "am" ? "a.m." : "p.m.";
    }
  },
  h: function(e28, t3) {
    return r$v(e28.getUTCHours() % 12 || 12, t3.length);
  },
  H: function(e28, t3) {
    return r$v(e28.getUTCHours(), t3.length);
  },
  m: function(e28, t3) {
    return r$v(e28.getUTCMinutes(), t3.length);
  },
  s: function(e28, t3) {
    return r$v(e28.getUTCSeconds(), t3.length);
  },
  S: function(e28, t3) {
    var r3 = t3.length, u3 = e28.getUTCMilliseconds(), o3 = Math.floor(u3 * Math.pow(10, r3 - 3));
    return r$v(o3, t3.length);
  }
};
const c$M = s$p;
var s$o = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, y$j = {
  G: function(n3, e28, t3) {
    var r3 = n3.getUTCFullYear() > 0 ? 1 : 0;
    switch (e28) {
      case "G":
      case "GG":
      case "GGG":
        return t3.era(r3, {
          width: "abbreviated"
        });
      case "GGGGG":
        return t3.era(r3, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return t3.era(r3, {
          width: "wide"
        });
    }
  },
  y: function(n3, e28, t3) {
    if (e28 === "yo") {
      var r3 = n3.getUTCFullYear(), a3 = r3 > 0 ? r3 : 1 - r3;
      return t3.ordinalNumber(a3, {
        unit: "year"
      });
    }
    return c$M.y(n3, e28);
  },
  Y: function(n3, e28, t3, r3) {
    var a3 = h$B(n3, r3), u3 = a3 > 0 ? a3 : 1 - a3;
    if (e28 === "YY") {
      var h3 = u3 % 100;
      return r$v(h3, 2);
    }
    return e28 === "Yo" ? t3.ordinalNumber(u3, {
      unit: "year"
    }) : r$v(u3, e28.length);
  },
  R: function(n3, e28) {
    var t3 = O$j(n3);
    return r$v(t3, e28.length);
  },
  u: function(n3, e28) {
    var t3 = n3.getUTCFullYear();
    return r$v(t3, e28.length);
  },
  Q: function(n3, e28, t3) {
    var r3 = Math.ceil((n3.getUTCMonth() + 1) / 3);
    switch (e28) {
      case "Q":
        return String(r3);
      case "QQ":
        return r$v(r3, 2);
      case "Qo":
        return t3.ordinalNumber(r3, {
          unit: "quarter"
        });
      case "QQQ":
        return t3.quarter(r3, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t3.quarter(r3, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t3.quarter(r3, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  q: function(n3, e28, t3) {
    var r3 = Math.ceil((n3.getUTCMonth() + 1) / 3);
    switch (e28) {
      case "q":
        return String(r3);
      case "qq":
        return r$v(r3, 2);
      case "qo":
        return t3.ordinalNumber(r3, {
          unit: "quarter"
        });
      case "qqq":
        return t3.quarter(r3, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t3.quarter(r3, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t3.quarter(r3, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  M: function(n3, e28, t3) {
    var r3 = n3.getUTCMonth();
    switch (e28) {
      case "M":
      case "MM":
        return c$M.M(n3, e28);
      case "Mo":
        return t3.ordinalNumber(r3 + 1, {
          unit: "month"
        });
      case "MMM":
        return t3.month(r3, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t3.month(r3, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t3.month(r3, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  L: function(n3, e28, t3) {
    var r3 = n3.getUTCMonth();
    switch (e28) {
      case "L":
        return String(r3 + 1);
      case "LL":
        return r$v(r3 + 1, 2);
      case "Lo":
        return t3.ordinalNumber(r3 + 1, {
          unit: "month"
        });
      case "LLL":
        return t3.month(r3, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t3.month(r3, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t3.month(r3, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  w: function(n3, e28, t3, r3) {
    var a3 = p$2B(n3, r3);
    return e28 === "wo" ? t3.ordinalNumber(a3, {
      unit: "week"
    }) : r$v(a3, e28.length);
  },
  I: function(n3, e28, t3) {
    var r3 = g$n(n3);
    return e28 === "Io" ? t3.ordinalNumber(r3, {
      unit: "week"
    }) : r$v(r3, e28.length);
  },
  d: function(n3, e28, t3) {
    return e28 === "do" ? t3.ordinalNumber(n3.getUTCDate(), {
      unit: "date"
    }) : c$M.d(n3, e28);
  },
  D: function(n3, e28, t3) {
    var r3 = u$q(n3);
    return e28 === "Do" ? t3.ordinalNumber(r3, {
      unit: "dayOfYear"
    }) : r$v(r3, e28.length);
  },
  E: function(n3, e28, t3) {
    var r3 = n3.getUTCDay();
    switch (e28) {
      case "E":
      case "EE":
      case "EEE":
        return t3.day(r3, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t3.day(r3, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t3.day(r3, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t3.day(r3, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  e: function(n3, e28, t3, r3) {
    var a3 = n3.getUTCDay(), u3 = (a3 - r3.weekStartsOn + 8) % 7 || 7;
    switch (e28) {
      case "e":
        return String(u3);
      case "ee":
        return r$v(u3, 2);
      case "eo":
        return t3.ordinalNumber(u3, {
          unit: "day"
        });
      case "eee":
        return t3.day(a3, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t3.day(a3, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t3.day(a3, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t3.day(a3, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  c: function(n3, e28, t3, r3) {
    var a3 = n3.getUTCDay(), u3 = (a3 - r3.weekStartsOn + 8) % 7 || 7;
    switch (e28) {
      case "c":
        return String(u3);
      case "cc":
        return r$v(u3, e28.length);
      case "co":
        return t3.ordinalNumber(u3, {
          unit: "day"
        });
      case "ccc":
        return t3.day(a3, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t3.day(a3, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t3.day(a3, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t3.day(a3, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  i: function(n3, e28, t3) {
    var r3 = n3.getUTCDay(), a3 = r3 === 0 ? 7 : r3;
    switch (e28) {
      case "i":
        return String(a3);
      case "ii":
        return r$v(a3, e28.length);
      case "io":
        return t3.ordinalNumber(a3, {
          unit: "day"
        });
      case "iii":
        return t3.day(r3, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t3.day(r3, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t3.day(r3, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t3.day(r3, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  a: function(n3, e28, t3) {
    var r3 = n3.getUTCHours(), a3 = r3 / 12 >= 1 ? "pm" : "am";
    switch (e28) {
      case "a":
      case "aa":
        return t3.dayPeriod(a3, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t3.dayPeriod(a3, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t3.dayPeriod(a3, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t3.dayPeriod(a3, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  b: function(n3, e28, t3) {
    var r3 = n3.getUTCHours(), a3;
    switch (r3 === 12 ? a3 = s$o.noon : r3 === 0 ? a3 = s$o.midnight : a3 = r3 / 12 >= 1 ? "pm" : "am", e28) {
      case "b":
      case "bb":
        return t3.dayPeriod(a3, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t3.dayPeriod(a3, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t3.dayPeriod(a3, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t3.dayPeriod(a3, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  B: function(n3, e28, t3) {
    var r3 = n3.getUTCHours(), a3;
    switch (r3 >= 17 ? a3 = s$o.evening : r3 >= 12 ? a3 = s$o.afternoon : r3 >= 4 ? a3 = s$o.morning : a3 = s$o.night, e28) {
      case "B":
      case "BB":
      case "BBB":
        return t3.dayPeriod(a3, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t3.dayPeriod(a3, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t3.dayPeriod(a3, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  h: function(n3, e28, t3) {
    if (e28 === "ho") {
      var r3 = n3.getUTCHours() % 12;
      return r3 === 0 && (r3 = 12), t3.ordinalNumber(r3, {
        unit: "hour"
      });
    }
    return c$M.h(n3, e28);
  },
  H: function(n3, e28, t3) {
    return e28 === "Ho" ? t3.ordinalNumber(n3.getUTCHours(), {
      unit: "hour"
    }) : c$M.H(n3, e28);
  },
  K: function(n3, e28, t3) {
    var r3 = n3.getUTCHours() % 12;
    return e28 === "Ko" ? t3.ordinalNumber(r3, {
      unit: "hour"
    }) : r$v(r3, e28.length);
  },
  k: function(n3, e28, t3) {
    var r3 = n3.getUTCHours();
    return r3 === 0 && (r3 = 24), e28 === "ko" ? t3.ordinalNumber(r3, {
      unit: "hour"
    }) : r$v(r3, e28.length);
  },
  m: function(n3, e28, t3) {
    return e28 === "mo" ? t3.ordinalNumber(n3.getUTCMinutes(), {
      unit: "minute"
    }) : c$M.m(n3, e28);
  },
  s: function(n3, e28, t3) {
    return e28 === "so" ? t3.ordinalNumber(n3.getUTCSeconds(), {
      unit: "second"
    }) : c$M.s(n3, e28);
  },
  S: function(n3, e28) {
    return c$M.S(n3, e28);
  },
  X: function(n3, e28, t3, r3) {
    var a3 = r3._originalDate || n3, u3 = a3.getTimezoneOffset();
    if (u3 === 0)
      return "Z";
    switch (e28) {
      case "X":
        return m$n(u3);
      case "XXXX":
      case "XX":
        return d$o(u3);
      case "XXXXX":
      case "XXX":
      default:
        return d$o(u3, ":");
    }
  },
  x: function(n3, e28, t3, r3) {
    var a3 = r3._originalDate || n3, u3 = a3.getTimezoneOffset();
    switch (e28) {
      case "x":
        return m$n(u3);
      case "xxxx":
      case "xx":
        return d$o(u3);
      case "xxxxx":
      case "xxx":
      default:
        return d$o(u3, ":");
    }
  },
  O: function(n3, e28, t3, r3) {
    var a3 = r3._originalDate || n3, u3 = a3.getTimezoneOffset();
    switch (e28) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + f$o(u3, ":");
      case "OOOO":
      default:
        return "GMT" + d$o(u3, ":");
    }
  },
  z: function(n3, e28, t3, r3) {
    var a3 = r3._originalDate || n3, u3 = a3.getTimezoneOffset();
    switch (e28) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + f$o(u3, ":");
      case "zzzz":
      default:
        return "GMT" + d$o(u3, ":");
    }
  },
  t: function(n3, e28, t3, r3) {
    var a3 = r3._originalDate || n3, u3 = Math.floor(a3.getTime() / 1e3);
    return r$v(u3, e28.length);
  },
  T: function(n3, e28, t3, r3) {
    var a3 = r3._originalDate || n3, u3 = a3.getTime();
    return r$v(u3, e28.length);
  }
};
function f$o(i, n3) {
  var e28 = i > 0 ? "-" : "+", t3 = Math.abs(i), r3 = Math.floor(t3 / 60), a3 = t3 % 60;
  if (a3 === 0)
    return e28 + String(r3);
  var u3 = n3 || "";
  return e28 + String(r3) + u3 + r$v(a3, 2);
}
function m$n(i, n3) {
  if (i % 60 === 0) {
    var e28 = i > 0 ? "-" : "+";
    return e28 + r$v(Math.abs(i) / 60, 2);
  }
  return d$o(i, n3);
}
function d$o(i, n3) {
  var e28 = n3 || "", t3 = i > 0 ? "-" : "+", r3 = Math.abs(i), a3 = r$v(Math.floor(r3 / 60), 2), u3 = r$v(r3 % 60, 2);
  return t3 + a3 + e28 + u3;
}
const U$8 = y$j;
var Z$7 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, B$g = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, G$7 = /^'([^]*?)'?$/, J$5 = /''/g, N$g = /[a-zA-Z]/;
function de$4(a3, t3, e28) {
  var v3, d3, c3, u3, m3, s3, p3, k3, w3, g3, O3, _3, h3, $3, D3, E3, S3, C3;
  n$u(2, arguments);
  var z3 = String(t3), l3 = e$K(), n3 = (v3 = (d3 = e28 == null ? void 0 : e28.locale) !== null && d3 !== void 0 ? d3 : l3.locale) !== null && v3 !== void 0 ? v3 : s$1J, R3 = n$t((c3 = (u3 = (m3 = (s3 = e28 == null ? void 0 : e28.firstWeekContainsDate) !== null && s3 !== void 0 ? s3 : e28 == null || (p3 = e28.locale) === null || p3 === void 0 || (k3 = p3.options) === null || k3 === void 0 ? void 0 : k3.firstWeekContainsDate) !== null && m3 !== void 0 ? m3 : l3.firstWeekContainsDate) !== null && u3 !== void 0 ? u3 : (w3 = l3.locale) === null || w3 === void 0 || (g3 = w3.options) === null || g3 === void 0 ? void 0 : g3.firstWeekContainsDate) !== null && c3 !== void 0 ? c3 : 1);
  if (!(R3 >= 1 && R3 <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var W3 = n$t((O3 = (_3 = (h3 = ($3 = e28 == null ? void 0 : e28.weekStartsOn) !== null && $3 !== void 0 ? $3 : e28 == null || (D3 = e28.locale) === null || D3 === void 0 || (E3 = D3.options) === null || E3 === void 0 ? void 0 : E3.weekStartsOn) !== null && h3 !== void 0 ? h3 : l3.weekStartsOn) !== null && _3 !== void 0 ? _3 : (S3 = l3.locale) === null || S3 === void 0 || (C3 = S3.options) === null || C3 === void 0 ? void 0 : C3.weekStartsOn) !== null && O3 !== void 0 ? O3 : 0);
  if (!(W3 >= 0 && W3 <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!n3.localize)
    throw new RangeError("locale must contain localize property");
  if (!n3.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var i = a$S(a3);
  if (!u$r(i))
    throw new RangeError("Invalid time value");
  var P3 = g$o(i), L3 = a$E(i, P3), Y3 = {
    firstWeekContainsDate: R3,
    weekStartsOn: W3,
    locale: n3,
    _originalDate: i
  }, A3 = z3.match(B$g).map(function(r3) {
    var o3 = r3[0];
    if (o3 === "p" || o3 === "P") {
      var f3 = m$p[o3];
      return f3(r3, n3.formatLong);
    }
    return r3;
  }).join("").match(Z$7).map(function(r3) {
    if (r3 === "''")
      return "'";
    var o3 = r3[0];
    if (o3 === "'")
      return X$5(r3);
    var f3 = U$8[o3];
    if (f3)
      return !(e28 != null && e28.useAdditionalWeekYearTokens) && a$D(r3) && c$O(r3, t3, String(a3)), !(e28 != null && e28.useAdditionalDayOfYearTokens) && s$q(r3) && c$O(r3, t3, String(a3)), f3(L3, r3, n3.localize, Y3);
    if (o3.match(N$g))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + o3 + "`");
    return r3;
  }).join("");
  return A3;
}
function X$5(a3) {
  var t3 = a3.match(G$7);
  return t3 ? t3[1].replace(J$5, "'") : a3;
}
function u$p(t3) {
  n$u(1, arguments);
  var r3 = a$S(t3), e28 = r3.getMonth();
  return e28;
}
function u$o(t3) {
  n$u(1, arguments);
  var e28 = a$S(t3), r3 = e28.getTime();
  return r3;
}
function u$n(r3) {
  n$u(1, arguments);
  var t3 = a$S(r3);
  return t3.setDate(1), t3.setHours(0, 0, 0, 0), t3;
}
function s$n(e28, a3) {
  n$u(2, arguments);
  var t3 = a$S(e28), r3 = n$t(a3);
  return isNaN(r3) ? /* @__PURE__ */ new Date(NaN) : (r3 && t3.setDate(t3.getDate() + r3), t3);
}
function d$n(r3) {
  n$u(1, arguments);
  var t3 = a$S(r3), a3 = t3.getDay();
  return a3;
}
function l$o(r3) {
  n$u(1, arguments);
  var t3 = a$S(r3), e28 = /* @__PURE__ */ new Date(0);
  return e28.setFullYear(t3.getFullYear(), 0, 1), e28.setHours(0, 0, 0, 0), e28;
}
function h$A(n3, o3) {
  n$u(2, arguments);
  var t3 = a$S(n3), r3 = n$t(o3);
  if (isNaN(r3))
    return /* @__PURE__ */ new Date(NaN);
  if (!r3)
    return t3;
  var a3 = t3.getDate(), e28 = new Date(t3.getTime());
  e28.setMonth(t3.getMonth() + r3 + 1, 0);
  var i = e28.getDate();
  return a3 >= i ? e28 : (t3.setFullYear(e28.getFullYear(), e28.getMonth(), a3), t3);
}
function f$n(r3, t3) {
  n$u(2, arguments);
  var o3 = n$t(t3), a3 = o3 * 3;
  return h$A(r3, a3);
}
function f$m(r3, t3) {
  n$u(2, arguments);
  var o3 = n$t(t3);
  return h$A(r3, o3 * 12);
}
function n$g(t3) {
  n$u(1, arguments);
  var r3 = a$S(t3), e28 = r3.getDate();
  return e28;
}
function u$m(r3) {
  return n$u(1, arguments), a$S(r3).getFullYear();
}
function i$p(a3, o3) {
  n$u(2, arguments);
  var t3 = a$S(a3), e28 = a$S(o3);
  return t3.getFullYear() === e28.getFullYear() && t3.getMonth() === e28.getMonth();
}
function f$l(r3, t3) {
  n$u(2, arguments);
  var a3 = a$S(r3), o3 = a$S(t3);
  return a3.getFullYear() === o3.getFullYear();
}
function m$m(r3) {
  n$u(1, arguments);
  var t3 = a$S(r3), e28 = Math.floor(t3.getMonth() / 3) + 1;
  return e28;
}
function m$l(e28) {
  n$u(1, arguments);
  var t3 = a$S(e28), r3 = t3.getMonth(), o3 = r3 - r3 % 3;
  return t3.setMonth(o3, 1), t3.setHours(0, 0, 0, 0), t3;
}
function o$i(t3, e28) {
  n$u(2, arguments);
  var a3 = m$l(t3), u3 = m$l(e28);
  return a3.getTime() === u3.getTime();
}
function u$l(t3) {
  n$u(1, arguments);
  var r3 = a$S(t3);
  return r3.setHours(0, 0, 0, 0), r3;
}
function g$m(r3, a3) {
  n$u(2, arguments);
  var e28 = u$l(r3), f3 = u$l(a3);
  return e28.getTime() === f3.getTime();
}
function D$g(O3, e28) {
  var l3, r3, a3, i, n3, d3, v3, u3;
  n$u(1, arguments);
  var s3 = e$K(), o3 = n$t((l3 = (r3 = (a3 = (i = e28 == null ? void 0 : e28.weekStartsOn) !== null && i !== void 0 ? i : e28 == null || (n3 = e28.locale) === null || n3 === void 0 || (d3 = n3.options) === null || d3 === void 0 ? void 0 : d3.weekStartsOn) !== null && a3 !== void 0 ? a3 : s3.weekStartsOn) !== null && r3 !== void 0 ? r3 : (v3 = s3.locale) === null || v3 === void 0 || (u3 = v3.options) === null || u3 === void 0 ? void 0 : u3.weekStartsOn) !== null && l3 !== void 0 ? l3 : 0);
  if (!(o3 >= 0 && o3 <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var t3 = a$S(O3), f3 = t3.getDay(), m3 = (f3 < o3 ? 7 : 0) + f3 - o3;
  return t3.setDate(t3.getDate() - m3), t3.setHours(0, 0, 0, 0), t3;
}
function d$m(r3, a3, e28) {
  n$u(2, arguments);
  var f3 = D$g(r3, e28), m3 = D$g(a3, e28);
  return f3.getTime() === m3.getTime();
}
const F$d = {
  date: g$m,
  month: i$p,
  year: f$l,
  quarter: o$i
};
function E$b(t3) {
  return (e28, r3) => {
    const n3 = (t3 + 1) % 7;
    return d$m(e28, r3, {
      weekStartsOn: n3
    });
  };
}
function i$o(t3, e28, r3, n3 = 0) {
  return (r3 === "week" ? E$b(n3) : F$d[r3])(t3, e28);
}
function g$l(t3, e28, r3, n3, o3, a3) {
  return o3 === "date" ? L$g(t3, e28, r3, n3) : P$c(t3, e28, r3, n3, a3);
}
function L$g(t3, e28, r3, n3) {
  let o3 = false, a3 = false, f3 = false;
  Array.isArray(r3) && (r3[0] < t3 && t3 < r3[1] && (o3 = true), i$o(r3[0], t3, "date") && (a3 = true), i$o(r3[1], t3, "date") && (f3 = true));
  const s3 = r3 !== null && (Array.isArray(r3) ? i$o(r3[0], t3, "date") || i$o(r3[1], t3, "date") : i$o(r3, t3, "date"));
  return {
    type: "date",
    dateObject: {
      date: n$g(t3),
      month: u$p(t3),
      year: u$m(t3)
    },
    inCurrentMonth: i$p(t3, e28),
    isCurrentDate: i$o(n3, t3, "date"),
    inSpan: o3,
    inSelectedWeek: false,
    startOfSpan: a3,
    endOfSpan: f3,
    selected: s3,
    ts: u$o(t3)
  };
}
function dt$2(t3, e28, r3) {
  const n3 = Date.UTC(2e3, t3, 1);
  return de$4(n3, e28, {
    locale: r3
  });
}
function st$2(t3, e28, r3) {
  const n3 = Date.UTC(t3, 1, 1);
  return de$4(n3, e28, {
    locale: r3
  });
}
function pt$2(t3, e28, r3) {
  const n3 = Date.UTC(2e3, t3 * 3 - 2, 1);
  return de$4(n3, e28, {
    locale: r3
  });
}
function P$c(t3, e28, r3, n3, o3) {
  let a3 = false, f3 = false, s3 = false;
  Array.isArray(r3) && (r3[0] < t3 && t3 < r3[1] && (a3 = true), i$o(r3[0], t3, "week", o3) && (f3 = true), i$o(r3[1], t3, "week", o3) && (s3 = true));
  const u3 = r3 !== null && (Array.isArray(r3) ? i$o(r3[0], t3, "week", o3) || i$o(r3[1], t3, "week", o3) : i$o(r3, t3, "week", o3));
  return {
    type: "date",
    dateObject: {
      date: n$g(t3),
      month: u$p(t3),
      year: u$m(t3)
    },
    inCurrentMonth: i$p(t3, e28),
    isCurrentDate: i$o(n3, t3, "date"),
    inSpan: a3,
    startOfSpan: f3,
    endOfSpan: s3,
    selected: false,
    inSelectedWeek: u3,
    ts: u$o(t3)
  };
}
function W$7(t3, e28, r3, {
  monthFormat: n3
}) {
  return {
    type: "month",
    monthFormat: n3,
    dateObject: {
      month: u$p(t3),
      year: u$m(t3)
    },
    isCurrent: i$p(r3, t3),
    selected: e28 !== null && i$o(e28, t3, "month"),
    ts: u$o(t3)
  };
}
function _$c(t3, e28, r3, {
  yearFormat: n3
}) {
  return {
    type: "year",
    yearFormat: n3,
    dateObject: {
      year: u$m(t3)
    },
    isCurrent: f$l(r3, t3),
    selected: e28 !== null && i$o(e28, t3, "year"),
    ts: u$o(t3)
  };
}
function z$7(t3, e28, r3, {
  quarterFormat: n3
}) {
  return {
    type: "quarter",
    quarterFormat: n3,
    dateObject: {
      quarter: m$m(t3),
      year: u$m(t3)
    },
    isCurrent: o$i(r3, t3),
    selected: e28 !== null && i$o(e28, t3, "quarter"),
    ts: u$o(t3)
  };
}
function mt$3(t3, e28, r3, n3, o3 = false, a3 = false) {
  const f3 = a3 ? "week" : "date", s3 = u$p(t3);
  let u3 = u$o(u$n(t3)), l3 = u$o(s$n(u3, -1));
  const d3 = [];
  let A3 = !o3;
  for (; d$n(l3) !== n3 || A3; )
    d3.unshift(g$l(l3, t3, e28, r3, f3, n3)), l3 = u$o(s$n(l3, -1)), A3 = false;
  for (; u$p(u3) === s3; )
    d3.push(g$l(u3, t3, e28, r3, f3, n3)), u3 = u$o(s$n(u3, 1));
  const I3 = o3 ? d3.length <= 28 ? 28 : d3.length <= 35 ? 35 : 42 : 42;
  for (; d3.length < I3; )
    d3.push(g$l(u3, t3, e28, r3, f3, n3)), u3 = u$o(s$n(u3, 1));
  return d3;
}
function lt$2(t3, e28, r3, n3) {
  const o3 = [], a3 = l$o(t3);
  for (let f3 = 0; f3 < 12; f3++)
    o3.push(W$7(u$o(h$A(a3, f3)), e28, r3, n3));
  return o3;
}
function ht$2(t3, e28, r3, n3) {
  const o3 = [], a3 = l$o(t3);
  for (let f3 = 0; f3 < 4; f3++)
    o3.push(z$7(u$o(f$n(a3, f3)), e28, r3, n3));
  return o3;
}
function yt$3(t3, e28, r3) {
  const n3 = [], o3 = new Date(T$h, 0, 1);
  for (let a3 = 0; a3 < 200; a3++)
    n3.push(_$c(u$o(f$m(o3, a3)), t3, e28, r3));
  return n3;
}
function St$2(t3, e28, r3, n3) {
  const o3 = Pe$2(t3, e28, r3, n3);
  return u$r(o3) ? de$4(o3, e28, n3) === t3 ? o3 : /* @__PURE__ */ new Date(NaN) : o3;
}
function gt$2(t3) {
  if (t3 === void 0)
    return;
  if (typeof t3 == "number")
    return t3;
  const [e28, r3, n3] = t3.split(":");
  return {
    hours: Number(e28),
    minutes: Number(r3),
    seconds: Number(n3)
  };
}
function At$2(t3, e28) {
  return Array.isArray(t3) ? t3[e28 === "start" ? 0 : 1] : null;
}
function m$k(r3) {
  n$u(1, arguments);
  var t3 = a$S(r3), e28 = t3.getHours();
  return e28;
}
function o$h(t3) {
  n$u(1, arguments);
  var e28 = a$S(t3), r3 = e28.getMinutes();
  return r3;
}
function d$l(e28) {
  n$u(1, arguments);
  var r3 = a$S(e28), t3 = r3.getSeconds();
  return t3;
}
function V$b(s3, r3) {
  const l3 = computed(() => {
    const {
      isTimeDisabled: i
    } = s3, {
      value: e28
    } = r3;
    if (!(e28 === null || Array.isArray(e28)))
      return i == null ? void 0 : i(e28);
  }), d3 = computed(() => {
    var i;
    return (i = l3.value) === null || i === void 0 ? void 0 : i.isHourDisabled;
  }), o3 = computed(() => {
    var i;
    return (i = l3.value) === null || i === void 0 ? void 0 : i.isMinuteDisabled;
  }), v3 = computed(() => {
    var i;
    return (i = l3.value) === null || i === void 0 ? void 0 : i.isSecondDisabled;
  }), c3 = computed(() => {
    const {
      type: i,
      isDateDisabled: e28
    } = s3, {
      value: a3
    } = r3;
    return a3 === null || Array.isArray(a3) || !["date", "datetime"].includes(i) || !e28 ? false : e28(a3, {
      type: "input"
    });
  }), f3 = computed(() => {
    const {
      type: i
    } = s3, {
      value: e28
    } = r3;
    if (e28 === null || i === "datetime" || Array.isArray(e28))
      return false;
    const a3 = new Date(e28), t3 = a3.getHours(), u3 = a3.getMinutes(), b3 = a3.getMinutes();
    return (d3.value ? d3.value(t3) : false) || (o3.value ? o3.value(u3, t3) : false) || (v3.value ? v3.value(b3, u3, t3) : false);
  }), D3 = computed(() => c3.value || f3.value);
  return {
    isValueInvalidRef: computed(() => {
      const {
        type: i
      } = s3;
      return i === "date" ? c3.value : i === "datetime" ? D3.value : false;
    }),
    isDateInvalidRef: c3,
    isTimeInvalidRef: f3,
    isDateTimeInvalidRef: D3,
    isHourDisabledRef: d3,
    isMinuteDisabledRef: o3,
    isSecondDisabledRef: v3
  };
}
function j$6(s3, r3) {
  const l3 = computed(() => {
    const {
      isTimeDisabled: e28
    } = s3, {
      value: a3
    } = r3;
    return !Array.isArray(a3) || !e28 ? [void 0, void 0] : [e28 == null ? void 0 : e28(a3[0], "start", a3), e28 == null ? void 0 : e28(a3[1], "end", a3)];
  }), d3 = {
    isStartHourDisabledRef: computed(() => {
      var e28;
      return (e28 = l3.value[0]) === null || e28 === void 0 ? void 0 : e28.isHourDisabled;
    }),
    isEndHourDisabledRef: computed(() => {
      var e28;
      return (e28 = l3.value[1]) === null || e28 === void 0 ? void 0 : e28.isHourDisabled;
    }),
    isStartMinuteDisabledRef: computed(() => {
      var e28;
      return (e28 = l3.value[0]) === null || e28 === void 0 ? void 0 : e28.isMinuteDisabled;
    }),
    isEndMinuteDisabledRef: computed(() => {
      var e28;
      return (e28 = l3.value[1]) === null || e28 === void 0 ? void 0 : e28.isMinuteDisabled;
    }),
    isStartSecondDisabledRef: computed(() => {
      var e28;
      return (e28 = l3.value[0]) === null || e28 === void 0 ? void 0 : e28.isSecondDisabled;
    }),
    isEndSecondDisabledRef: computed(() => {
      var e28;
      return (e28 = l3.value[1]) === null || e28 === void 0 ? void 0 : e28.isSecondDisabled;
    })
  }, o3 = computed(() => {
    const {
      type: e28,
      isDateDisabled: a3
    } = s3, {
      value: t3
    } = r3;
    return t3 === null || !Array.isArray(t3) || !["daterange", "datetimerange"].includes(e28) || !a3 ? false : a3(t3[0], "start", t3);
  }), v3 = computed(() => {
    const {
      type: e28,
      isDateDisabled: a3
    } = s3, {
      value: t3
    } = r3;
    return t3 === null || !Array.isArray(t3) || !["daterange", "datetimerange"].includes(e28) || !a3 ? false : a3(t3[1], "end", t3);
  }), c3 = computed(() => {
    const {
      type: e28
    } = s3, {
      value: a3
    } = r3;
    if (a3 === null || !Array.isArray(a3) || e28 !== "datetimerange")
      return false;
    const t3 = m$k(a3[0]), u3 = o$h(a3[0]), b3 = d$l(a3[0]), {
      isStartHourDisabledRef: m3,
      isStartMinuteDisabledRef: y3,
      isStartSecondDisabledRef: R3
    } = d3;
    return (m3.value ? m3.value(t3) : false) || (y3.value ? y3.value(u3, t3) : false) || (R3.value ? R3.value(b3, u3, t3) : false);
  }), f3 = computed(() => {
    const {
      type: e28
    } = s3, {
      value: a3
    } = r3;
    if (a3 === null || !Array.isArray(a3) || e28 !== "datetimerange")
      return false;
    const t3 = m$k(a3[1]), u3 = o$h(a3[1]), b3 = d$l(a3[1]), {
      isEndHourDisabledRef: m3,
      isEndMinuteDisabledRef: y3,
      isEndSecondDisabledRef: R3
    } = d3;
    return (m3.value ? m3.value(t3) : false) || (y3.value ? y3.value(u3, t3) : false) || (R3.value ? R3.value(b3, u3, t3) : false);
  }), D3 = computed(() => o3.value || c3.value), S3 = computed(() => v3.value || f3.value), i = computed(() => D3.value || S3.value);
  return Object.assign(Object.assign({}, d3), {
    isStartDateInvalidRef: o3,
    isEndDateInvalidRef: v3,
    isStartTimeInvalidRef: c3,
    isEndTimeInvalidRef: f3,
    isStartValueInvalidRef: D3,
    isEndValueInvalidRef: S3,
    isRangeInvalidRef: i
  });
}
const c$L = n$28("n-date-picker");
const L$f = "HH:mm:ss", w$a = {
  active: Boolean,
  dateFormat: String,
  timeFormat: {
    type: String,
    value: L$f
  },
  value: {
    type: [Array, Number],
    default: null
  },
  shortcuts: Object,
  defaultTime: [Number, String, Array],
  onClear: Function,
  onConfirm: Function,
  onClose: Function,
  onTabOut: Function,
  onUpdateValue: {
    type: Function,
    required: true
  },
  themeClass: String,
  onRender: Function,
  panel: Boolean,
  onNextMonth: Function,
  onPrevMonth: Function,
  onNextYear: Function,
  onPrevYear: Function
};
function z$6(t3) {
  const {
    dateLocaleRef: h3,
    timePickerSizeRef: v3,
    timePickerPropsRef: P3,
    localeRef: F3,
    mergedClsPrefixRef: C3,
    mergedThemeRef: g3
  } = inject(c$L), b3 = computed(() => ({
    locale: h3.value.locale
  })), a3 = ref$1(null), r3 = B$x();
  function T3() {
    const {
      onClear: e28
    } = t3;
    e28 && e28();
  }
  function y3() {
    const {
      onConfirm: e28,
      value: n3
    } = t3;
    e28 && e28(n3);
  }
  function c3(e28, n3) {
    const {
      onUpdateValue: o3
    } = t3;
    o3(e28, n3);
  }
  function f3(e28 = false) {
    const {
      onClose: n3
    } = t3;
    n3 && n3(e28);
  }
  function i() {
    const {
      onTabOut: e28
    } = t3;
    e28 && e28();
  }
  function k3() {
    c3(null, true), f3(true), T3();
  }
  function S3() {
    i();
  }
  function R3() {
    (t3.active || t3.panel) && nextTick(() => {
      const {
        value: e28
      } = a3;
      if (!e28)
        return;
      const n3 = e28.querySelectorAll("[data-n-date]");
      n3.forEach((o3) => {
        o3.classList.add("transition-disabled");
      }), e28.offsetWidth, n3.forEach((o3) => {
        o3.classList.remove("transition-disabled");
      });
    });
  }
  function O3(e28) {
    e28.key === "Tab" && e28.target === a3.value && r3.shift && (e28.preventDefault(), i());
  }
  function V10(e28) {
    const {
      value: n3
    } = a3;
    r3.tab && e28.target === n3 && (n3 != null && n3.contains(e28.relatedTarget)) && i();
  }
  let s3 = null, l3 = false;
  function p3() {
    s3 = t3.value, l3 = true;
  }
  function M3() {
    l3 = false;
  }
  function d3() {
    l3 && (c3(s3, false), l3 = false);
  }
  function x3(e28) {
    return typeof e28 == "function" ? e28() : e28;
  }
  const u3 = ref$1(false);
  function E3() {
    u3.value = !u3.value;
  }
  return {
    mergedTheme: g3,
    mergedClsPrefix: C3,
    dateFnsOptions: b3,
    timePickerSize: v3,
    timePickerProps: P3,
    selfRef: a3,
    locale: F3,
    doConfirm: y3,
    doClose: f3,
    doUpdateValue: c3,
    doTabOut: i,
    handleClearClick: k3,
    handleFocusDetectorFocus: S3,
    disableTransitionOneTick: R3,
    handlePanelKeyDown: O3,
    handlePanelFocus: V10,
    cachePendingValue: p3,
    clearPendingValue: M3,
    restorePendingValue: d3,
    getShortcutValue: x3,
    handleShortcutMouseleave: d3,
    showMonthYearPanel: u3,
    handleOpenQuickSelectMonthPanel: E3
  };
}
function l$n(r3) {
  n$u(1, arguments);
  var e28 = a$S(r3), a3 = e28.getFullYear(), o3 = e28.getMonth(), t3 = /* @__PURE__ */ new Date(0);
  return t3.setFullYear(a3, o3 + 1, 0), t3.setHours(0, 0, 0, 0), t3.getDate();
}
function l$m(a3, o3) {
  n$u(2, arguments);
  var t3 = a$S(a3), e28 = n$t(o3), n3 = t3.getFullYear(), m3 = t3.getDate(), r3 = /* @__PURE__ */ new Date(0);
  r3.setFullYear(n3, e28, 15), r3.setHours(0, 0, 0, 0);
  var s3 = l$n(r3);
  return t3.setMonth(e28, Math.min(m3, s3)), t3;
}
function u$k(o3, t3) {
  if (n$u(2, arguments), o$A(t3) !== "object" || t3 === null)
    throw new RangeError("values parameter must be an object");
  var r3 = a$S(o3);
  return isNaN(r3.getTime()) ? /* @__PURE__ */ new Date(NaN) : (t3.year != null && r3.setFullYear(t3.year), t3.month != null && (r3 = l$m(r3, t3.month)), t3.date != null && r3.setDate(n$t(t3.date)), t3.hours != null && r3.setHours(n$t(t3.hours)), t3.minutes != null && r3.setMinutes(n$t(t3.minutes)), t3.seconds != null && r3.setSeconds(n$t(t3.seconds)), t3.milliseconds != null && r3.setMilliseconds(n$t(t3.milliseconds)), r3);
}
function h$z(t3, o3) {
  n$u(2, arguments);
  var r3 = a$S(t3), e28 = n$t(o3), a3 = Math.floor(r3.getMonth() / 3) + 1, f3 = e28 - a3;
  return l$m(r3, r3.getMonth() + f3 * 3);
}
function s$m(e28, t3) {
  n$u(2, arguments);
  var r3 = a$S(e28), a3 = n$t(t3);
  return isNaN(r3.getTime()) ? /* @__PURE__ */ new Date(NaN) : (r3.setFullYear(a3), r3);
}
function i$n(t3) {
  n$u(1, arguments);
  var r3 = a$S(t3);
  return r3.setMilliseconds(0), r3;
}
const va$2 = Object.assign(Object.assign({}, w$a), {
  defaultCalendarStartTime: Number,
  actions: {
    type: Array,
    default: () => ["now", "clear", "confirm"]
  }
});
function ma$2(a3, i) {
  var R3;
  const n3 = z$6(a3), {
    isValueInvalidRef: E3,
    isDateDisabledRef: H3,
    isDateInvalidRef: W3,
    isTimeInvalidRef: N3,
    isDateTimeInvalidRef: z3,
    isHourDisabledRef: L3,
    isMinuteDisabledRef: Q3,
    isSecondDisabledRef: B3,
    localeRef: s3,
    firstDayOfWeekRef: w3,
    datePickerSlots: G3,
    yearFormatRef: I3,
    monthFormatRef: K3,
    quarterFormatRef: J3
  } = inject(c$L), O3 = {
    isValueInvalid: E3,
    isDateDisabled: H3,
    isDateInvalid: W3,
    isTimeInvalid: N3,
    isDateTimeInvalid: z3,
    isHourDisabled: L3,
    isMinuteDisabled: Q3,
    isSecondDisabled: B3
  }, m3 = computed(() => a3.dateFormat || s3.value.dateFormat), d3 = ref$1(a3.value === null || Array.isArray(a3.value) ? "" : de$4(a3.value, m3.value)), u3 = ref$1(a3.value === null || Array.isArray(a3.value) ? (R3 = a3.defaultCalendarStartTime) !== null && R3 !== void 0 ? R3 : Date.now() : a3.value), y3 = ref$1(null), V10 = ref$1(null), T3 = ref$1(null), A3 = ref$1(Date.now()), C3 = computed(() => {
    var e28;
    return mt$3(u3.value, a3.value, A3.value, (e28 = w3.value) !== null && e28 !== void 0 ? e28 : s3.value.firstDayOfWeek, false, i === "week");
  }), X3 = computed(() => {
    const {
      value: e28
    } = a3;
    return lt$2(u3.value, Array.isArray(e28) ? null : e28, A3.value, {
      monthFormat: K3.value
    });
  }), Z3 = computed(() => {
    const {
      value: e28
    } = a3;
    return yt$3(Array.isArray(e28) ? null : e28, A3.value, {
      yearFormat: I3.value
    });
  }), $3 = computed(() => {
    const {
      value: e28
    } = a3;
    return ht$2(u3.value, Array.isArray(e28) ? null : e28, A3.value, {
      quarterFormat: J3.value
    });
  }), p3 = computed(() => C3.value.slice(0, 7).map((e28) => {
    const {
      ts: t3
    } = e28;
    return de$4(t3, s3.value.dayFormat, n3.dateFnsOptions.value);
  })), ee2 = computed(() => de$4(u3.value, s3.value.monthFormat, n3.dateFnsOptions.value)), ae2 = computed(() => de$4(u3.value, s3.value.yearFormat, n3.dateFnsOptions.value));
  watch(u3, (e28, t3) => {
    (i === "date" || i === "datetime") && (i$p(e28, t3) || n3.disableTransitionOneTick());
  }), watch(computed(() => a3.value), (e28) => {
    e28 !== null && !Array.isArray(e28) ? (d3.value = de$4(e28, m3.value, n3.dateFnsOptions.value), u3.value = e28) : d3.value = "";
  });
  function c3(e28) {
    var t3;
    if (i === "datetime")
      return u$o(i$n(e28));
    if (i === "month")
      return u$o(u$n(e28));
    if (i === "year")
      return u$o(l$o(e28));
    if (i === "quarter")
      return u$o(m$l(e28));
    if (i === "week") {
      const l3 = (((t3 = w3.value) !== null && t3 !== void 0 ? t3 : s3.value.firstDayOfWeek) + 1) % 7;
      return u$o(D$g(e28, {
        weekStartsOn: l3
      }));
    }
    return u$o(u$l(e28));
  }
  function j3(e28, t3) {
    const {
      isDateDisabled: {
        value: l3
      }
    } = O3;
    return l3 ? l3(e28, t3) : false;
  }
  function te2(e28) {
    const t3 = St$2(e28, m3.value, /* @__PURE__ */ new Date(), n3.dateFnsOptions.value);
    if (u$r(t3)) {
      if (a3.value === null)
        n3.doUpdateValue(u$o(c3(Date.now())), a3.panel);
      else if (!Array.isArray(a3.value)) {
        const l3 = u$k(a3.value, {
          year: u$m(t3),
          month: u$p(t3),
          date: n$g(t3)
        });
        n3.doUpdateValue(u$o(c3(u$o(l3))), a3.panel);
      }
    } else
      d3.value = e28;
  }
  function ne2() {
    const e28 = St$2(d3.value, m3.value, /* @__PURE__ */ new Date(), n3.dateFnsOptions.value);
    if (u$r(e28)) {
      if (a3.value === null)
        n3.doUpdateValue(u$o(c3(Date.now())), false);
      else if (!Array.isArray(a3.value)) {
        const t3 = u$k(a3.value, {
          year: u$m(e28),
          month: u$p(e28),
          date: n$g(e28)
        });
        n3.doUpdateValue(u$o(c3(u$o(t3))), false);
      }
    } else
      fe2();
  }
  function re2() {
    n3.doUpdateValue(null, true), d3.value = "", n3.doClose(true), n3.handleClearClick();
  }
  function le2() {
    n3.doUpdateValue(u$o(c3(Date.now())), true);
    const e28 = Date.now();
    u3.value = e28, n3.doClose(true), a3.panel && (i === "month" || i === "quarter" || i === "year") && (n3.disableTransitionOneTick(), h3(e28));
  }
  const S3 = ref$1(null);
  function ie2(e28) {
    e28.type === "date" && i === "week" && (S3.value = c3(u$o(e28.ts)));
  }
  function ue2(e28) {
    return e28.type === "date" && i === "week" ? c3(u$o(e28.ts)) === S3.value : false;
  }
  function oe2(e28) {
    if (j3(e28.ts, e28.type === "date" ? {
      type: "date",
      year: e28.dateObject.year,
      month: e28.dateObject.month,
      date: e28.dateObject.date
    } : e28.type === "month" ? {
      type: "month",
      year: e28.dateObject.year,
      month: e28.dateObject.month
    } : e28.type === "year" ? {
      type: "year",
      year: e28.dateObject.year
    } : {
      type: "quarter",
      year: e28.dateObject.year,
      quarter: e28.dateObject.quarter
    }))
      return;
    let t3;
    if (a3.value !== null && !Array.isArray(a3.value) ? t3 = a3.value : t3 = Date.now(), i === "datetime" && a3.defaultTime !== null && !Array.isArray(a3.defaultTime)) {
      const l3 = gt$2(a3.defaultTime);
      l3 && (t3 = u$o(u$k(t3, l3)));
    }
    switch (t3 = u$o(e28.type === "quarter" && e28.dateObject.quarter ? h$z(s$m(t3, e28.dateObject.year), e28.dateObject.quarter) : u$k(t3, e28.dateObject)), n3.doUpdateValue(c3(t3), a3.panel || i === "date" || i === "week" || i === "year"), i) {
      case "date":
      case "week":
        n3.doClose();
        break;
      case "year":
        a3.panel && n3.disableTransitionOneTick(), n3.doClose();
        break;
      case "month":
        n3.disableTransitionOneTick(), h3(t3);
        break;
      case "quarter":
        n3.disableTransitionOneTick(), h3(t3);
        break;
    }
  }
  function de2(e28, t3) {
    let l3;
    a3.value !== null && !Array.isArray(a3.value) ? l3 = a3.value : l3 = Date.now(), l3 = u$o(e28.type === "month" ? l$m(l3, e28.dateObject.month) : s$m(l3, e28.dateObject.year)), t3(l3), h3(l3);
  }
  function ce2(e28) {
    u3.value = e28;
  }
  function fe2(e28) {
    if (a3.value === null || Array.isArray(a3.value)) {
      d3.value = "";
      return;
    }
    e28 === void 0 && (e28 = a3.value), d3.value = de$4(e28, m3.value, n3.dateFnsOptions.value);
  }
  function g3() {
    O3.isDateInvalid.value || O3.isTimeInvalid.value || (n3.doConfirm(), se2());
  }
  function se2() {
    a3.active && n3.doClose();
  }
  function ve2() {
    var e28;
    u3.value = u$o(f$m(u3.value, 1)), (e28 = a3.onNextYear) === null || e28 === void 0 || e28.call(a3);
  }
  function me2() {
    var e28;
    u3.value = u$o(f$m(u3.value, -1)), (e28 = a3.onPrevYear) === null || e28 === void 0 || e28.call(a3);
  }
  function ye2() {
    var e28;
    u3.value = u$o(h$A(u3.value, 1)), (e28 = a3.onNextMonth) === null || e28 === void 0 || e28.call(a3);
  }
  function he2() {
    var e28;
    u3.value = u$o(h$A(u3.value, -1)), (e28 = a3.onPrevMonth) === null || e28 === void 0 || e28.call(a3);
  }
  function De2() {
    const {
      value: e28
    } = y3;
    return (e28 == null ? void 0 : e28.listElRef) || null;
  }
  function be2() {
    const {
      value: e28
    } = y3;
    return (e28 == null ? void 0 : e28.itemsElRef) || null;
  }
  function Oe2(e28) {
    var t3;
    (t3 = V10.value) === null || t3 === void 0 || t3.sync();
  }
  function Ae2(e28) {
    e28 !== null && n3.doUpdateValue(e28, a3.panel);
  }
  function ke2(e28) {
    n3.cachePendingValue();
    const t3 = n3.getShortcutValue(e28);
    typeof t3 == "number" && n3.doUpdateValue(t3, false);
  }
  function Re2(e28) {
    const t3 = n3.getShortcutValue(e28);
    typeof t3 == "number" && (n3.doUpdateValue(t3, a3.panel), n3.clearPendingValue(), g3());
  }
  function h3(e28) {
    const {
      value: t3
    } = a3;
    if (T3.value) {
      const l3 = e28 === void 0 ? t3 === null ? u$p(Date.now()) : u$p(t3) : u$p(e28);
      T3.value.scrollTo({
        top: l3 * o$k
      });
    }
    if (y3.value) {
      const l3 = (e28 === void 0 ? t3 === null ? u$m(Date.now()) : u$m(t3) : u$m(e28)) - T$h;
      y3.value.scrollTo({
        top: l3 * o$k
      });
    }
  }
  const Te2 = {
    monthScrollbarRef: T3,
    yearScrollbarRef: V10,
    yearVlRef: y3
  };
  return Object.assign(Object.assign(Object.assign(Object.assign({
    dateArray: C3,
    monthArray: X3,
    yearArray: Z3,
    quarterArray: $3,
    calendarYear: ae2,
    calendarMonth: ee2,
    weekdays: p3,
    mergedIsDateDisabled: j3,
    nextYear: ve2,
    prevYear: me2,
    nextMonth: ye2,
    prevMonth: he2,
    handleNowClick: le2,
    handleConfirmClick: g3,
    handleSingleShortcutMouseenter: ke2,
    handleSingleShortcutClick: Re2
  }, O3), n3), Te2), {
    handleDateClick: oe2,
    handleDateInputBlur: ne2,
    handleDateInput: te2,
    handleDateMouseEnter: ie2,
    isWeekHovered: ue2,
    handleTimePickerChange: Ae2,
    clearSelectedDateTime: re2,
    virtualListContainer: De2,
    virtualListContent: be2,
    handleVirtualListScroll: Oe2,
    timePickerSize: n3.timePickerSize,
    dateInputValue: d3,
    datePickerSlots: G3,
    handleQuickMonthClick: de2,
    justifyColumnsScrollState: h3,
    calendarValue: u3,
    onUpdateCalendarValue: ce2
  });
}
const L$e = defineComponent({
  name: "MonthPanel",
  props: Object.assign(Object.assign({}, va$2), {
    type: {
      type: String,
      required: true
    },
    useAsQuickJump: Boolean
  }),
  setup(t3) {
    const r3 = ma$2(t3, t3.type), {
      dateLocaleRef: o3
    } = R$p("DatePicker"), n3 = (e28) => {
      switch (e28.type) {
        case "year":
          return st$2(e28.dateObject.year, e28.yearFormat, o3.value.locale);
        case "month":
          return dt$2(e28.dateObject.month, e28.monthFormat, o3.value.locale);
        case "quarter":
          return pt$2(e28.dateObject.quarter, e28.quarterFormat, o3.value.locale);
      }
    }, {
      useAsQuickJump: c3
    } = t3, i = (e28, s3, l3) => {
      const {
        mergedIsDateDisabled: h3,
        handleDateClick: p3,
        handleQuickMonthClick: m3
      } = r3;
      return h$1R("div", {
        "data-n-date": true,
        key: s3,
        class: [`${l3}-date-panel-month-calendar__picker-col-item`, e28.isCurrent && `${l3}-date-panel-month-calendar__picker-col-item--current`, e28.selected && `${l3}-date-panel-month-calendar__picker-col-item--selected`, !c3 && h3(e28.ts, e28.type === "year" ? {
          type: "year",
          year: e28.dateObject.year
        } : e28.type === "month" ? {
          type: "month",
          year: e28.dateObject.year,
          month: e28.dateObject.month
        } : e28.type === "quarter" ? {
          type: "month",
          year: e28.dateObject.year,
          month: e28.dateObject.quarter
        } : null) && `${l3}-date-panel-month-calendar__picker-col-item--disabled`],
        onClick: () => {
          c3 ? m3(e28, (y3) => {
            t3.onUpdateValue(y3, false);
          }) : p3(e28);
        }
      }, n3(e28));
    };
    return onMounted(() => {
      r3.justifyColumnsScrollState();
    }), Object.assign(Object.assign({}, r3), {
      renderItem: i
    });
  },
  render() {
    const {
      mergedClsPrefix: t3,
      mergedTheme: r3,
      shortcuts: o3,
      actions: n3,
      renderItem: c3,
      type: i,
      onRender: e28
    } = this;
    return e28 == null || e28(), h$1R("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${t3}-date-panel`, `${t3}-date-panel--month`, !this.panel && `${t3}-date-panel--shadow`, this.themeClass],
      onFocus: this.handlePanelFocus,
      onKeydown: this.handlePanelKeyDown
    }, h$1R("div", {
      class: `${t3}-date-panel-month-calendar`
    }, h$1R(hn$2, {
      ref: "yearScrollbarRef",
      class: `${t3}-date-panel-month-calendar__picker-col`,
      theme: r3.peers.Scrollbar,
      themeOverrides: r3.peerOverrides.Scrollbar,
      container: this.virtualListContainer,
      content: this.virtualListContent,
      horizontalRailStyle: {
        zIndex: 1
      },
      verticalRailStyle: {
        zIndex: 1
      }
    }, {
      default: () => h$1R(ve$c, {
        ref: "yearVlRef",
        items: this.yearArray,
        itemSize: o$k,
        showScrollbar: false,
        keyField: "ts",
        onScroll: this.handleVirtualListScroll,
        paddingBottom: 4
      }, {
        default: ({
          item: s3,
          index: l3
        }) => c3(s3, l3, t3)
      })
    }), i === "month" || i === "quarter" ? h$1R("div", {
      class: `${t3}-date-panel-month-calendar__picker-col`
    }, h$1R(hn$2, {
      ref: "monthScrollbarRef",
      theme: r3.peers.Scrollbar,
      themeOverrides: r3.peerOverrides.Scrollbar
    }, {
      default: () => [(i === "month" ? this.monthArray : this.quarterArray).map((s3, l3) => c3(s3, l3, t3)), h$1R("div", {
        class: `${t3}-date-panel-${i}-calendar__padding`
      })]
    })) : null), this.datePickerSlots.footer ? h$1R("div", {
      class: `${t3}-date-panel-footer`
    }, {
      default: this.datePickerSlots.footer
    }) : null, n3 != null && n3.length || o3 ? h$1R("div", {
      class: `${t3}-date-panel-actions`
    }, h$1R("div", {
      class: `${t3}-date-panel-actions__prefix`
    }, o3 && Object.keys(o3).map((s3) => {
      const l3 = o3[s3];
      return Array.isArray(l3) ? null : h$1R(ie$h, {
        size: "tiny",
        onMouseenter: () => {
          this.handleSingleShortcutMouseenter(l3);
        },
        onClick: () => {
          this.handleSingleShortcutClick(l3);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => s3
      });
    })), h$1R("div", {
      class: `${t3}-date-panel-actions__suffix`
    }, n3 != null && n3.includes("clear") ? h$1R(le$g, {
      theme: r3.peers.Button,
      themeOverrides: r3.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleClearClick
    }, {
      default: () => this.locale.clear
    }) : null, n3 != null && n3.includes("now") ? h$1R(le$g, {
      theme: r3.peers.Button,
      themeOverrides: r3.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleNowClick
    }, {
      default: () => this.locale.now
    }) : null, n3 != null && n3.includes("confirm") ? h$1R(le$g, {
      theme: r3.peers.Button,
      themeOverrides: r3.peerOverrides.Button,
      size: "tiny",
      type: "primary",
      disabled: this.isDateInvalid,
      onClick: this.handleConfirmClick
    }, {
      default: () => this.locale.confirm
    }) : null)) : null, h$1R(u$1l, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
const q$9 = defineComponent({
  props: {
    mergedClsPrefix: {
      type: String,
      required: true
    },
    value: Number,
    monthBeforeYear: {
      type: Boolean,
      required: true
    },
    calendarMonth: {
      type: String,
      required: true
    },
    calendarYear: {
      type: String,
      required: true
    },
    onUpdateValue: {
      type: Function,
      required: true
    }
  },
  setup() {
    const a3 = ref$1(null), t3 = ref$1(null), r3 = ref$1(false);
    function o3(u3) {
      var n3;
      r3.value && !(!((n3 = a3.value) === null || n3 === void 0) && n3.contains(t$1G(u3))) && (r3.value = false);
    }
    function l3() {
      r3.value = !r3.value;
    }
    return {
      show: r3,
      triggerRef: a3,
      monthPanelRef: t3,
      handleHeaderClick: l3,
      handleClickOutside: o3
    };
  },
  render() {
    const {
      handleClickOutside: a3,
      mergedClsPrefix: t3
    } = this;
    return h$1R("div", {
      class: `${t3}-date-panel-month__month-year`,
      ref: "triggerRef"
    }, h$1R(F$x, null, {
      default: () => [h$1R(g$19, null, {
        default: () => h$1R("div", {
          class: [`${t3}-date-panel-month__text`, this.show && `${t3}-date-panel-month__text--active`],
          onClick: this.handleHeaderClick
        }, this.monthBeforeYear ? [this.calendarMonth, " ", this.calendarYear] : [this.calendarYear, " ", this.calendarMonth])
      }), h$1R(me$h, {
        show: this.show,
        teleportDisabled: true
      }, {
        default: () => h$1R(Transition, {
          name: "fade-in-scale-up-transition",
          appear: true
        }, {
          default: () => this.show ? withDirectives(h$1R(L$e, {
            ref: "monthPanelRef",
            onUpdateValue: this.onUpdateValue,
            actions: [],
            type: "month",
            key: "month",
            useAsQuickJump: true,
            value: this.value
          }), [[a$2i, a3, void 0, {
            capture: true
          }]]) : null
        })
      })]
    }));
  }
});
var e$s = { exports: {} };
var e$r = { exports: {} };
(function(e28) {
  function u3(t3) {
    return t3 && t3.__esModule ? t3 : {
      default: t3
    };
  }
  e28.exports = u3, e28.exports.__esModule = true, e28.exports.default = e28.exports;
})(e$r);
var p$2A = e$r.exports;
var s$l = { exports: {} };
(function(i, e28) {
  Object.defineProperty(e28, "__esModule", {
    value: true
  }), e28.default = o3;
  function o3(n3, r3) {
    if (n3 == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var a3 in r3)
      Object.prototype.hasOwnProperty.call(r3, a3) && (n3[a3] = r3[a3]);
    return n3;
  }
  i.exports = e28.default;
})(s$l, s$l.exports);
var u$j = s$l.exports;
(function(o3, e28) {
  var r3 = p$2A.default;
  Object.defineProperty(e28, "__esModule", {
    value: true
  }), e28.default = u3;
  var a3 = r3(u$j);
  function u3(f3) {
    return (0, a3.default)({}, f3);
  }
  o3.exports = e28.default;
})(e$s, e$s.exports);
var p$2z = e$s.exports;
const x$d = /* @__PURE__ */ l$Y(p$2z);
var o$g = { exports: {} };
var a$C = { exports: {} };
var e$q = { exports: {} };
var e$p = { exports: {} };
(function(t3) {
  function e28(p3) {
    "@babel/helpers - typeof";
    return t3.exports = e28 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o3) {
      return typeof o3;
    } : function(o3) {
      return o3 && typeof Symbol == "function" && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
    }, t3.exports.__esModule = true, t3.exports.default = t3.exports, e28(p3);
  }
  t3.exports = e28, t3.exports.__esModule = true, t3.exports.default = t3.exports;
})(e$p);
var s$k = e$p.exports;
var r$u = { exports: {} };
(function(u3, e28) {
  Object.defineProperty(e28, "__esModule", {
    value: true
  }), e28.default = n3;
  function n3(r3, o3) {
    if (o3.length < r3)
      throw new TypeError(r3 + " argument" + (r3 > 1 ? "s" : "") + " required, but only " + o3.length + " present");
  }
  u3.exports = e28.default;
})(r$u, r$u.exports);
var l$l = r$u.exports;
(function(a3, t3) {
  var o3 = p$2A.default;
  Object.defineProperty(t3, "__esModule", {
    value: true
  }), t3.default = p3;
  var i = o3(s$k), f3 = o3(l$l);
  function p3(e28) {
    return (0, f3.default)(1, arguments), e28 instanceof Date || (0, i.default)(e28) === "object" && Object.prototype.toString.call(e28) === "[object Date]";
  }
  a3.exports = t3.default;
})(e$q, e$q.exports);
var c$K = e$q.exports;
var e$o = { exports: {} };
(function(s3, t3) {
  var a3 = p$2A.default;
  Object.defineProperty(t3, "__esModule", {
    value: true
  }), t3.default = f3;
  var n3 = a3(s$k), i = a3(l$l);
  function f3(e28) {
    (0, i.default)(1, arguments);
    var r3 = Object.prototype.toString.call(e28);
    return e28 instanceof Date || (0, n3.default)(e28) === "object" && r3 === "[object Date]" ? new Date(e28.getTime()) : typeof e28 == "number" || r3 === "[object Number]" ? new Date(e28) : ((typeof e28 == "string" || r3 === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  s3.exports = t3.default;
})(e$o, e$o.exports);
var D$f = e$o.exports;
(function(i, r3) {
  var e28 = p$2A.default;
  Object.defineProperty(r3, "__esModule", {
    value: true
  }), r3.default = f3;
  var o3 = e28(c$K), u3 = e28(D$f), s3 = e28(l$l);
  function f3(t3) {
    if ((0, s3.default)(1, arguments), !(0, o3.default)(t3) && typeof t3 != "number")
      return false;
    var p3 = (0, u3.default)(t3);
    return !isNaN(Number(p3));
  }
  i.exports = r3.default;
})(a$C, a$C.exports);
var c$J = a$C.exports;
var s$j = { exports: {} };
var d$k = { exports: {} };
var e$n = { exports: {} };
(function(a3, r3) {
  Object.defineProperty(r3, "__esModule", {
    value: true
  }), r3.default = n3;
  function n3(t3) {
    if (t3 === null || t3 === true || t3 === false)
      return NaN;
    var e28 = Number(t3);
    return isNaN(e28) ? e28 : e28 < 0 ? Math.ceil(e28) : Math.floor(e28);
  }
  a3.exports = r3.default;
})(e$n, e$n.exports);
var f$k = e$n.exports;
const p$2y = /* @__PURE__ */ l$Y(f$k);
(function(a3, e28) {
  var t3 = p$2A.default;
  Object.defineProperty(e28, "__esModule", {
    value: true
  }), e28.default = s3;
  var o3 = t3(f$k), i = t3(D$f), d3 = t3(l$l);
  function s3(u3, n3) {
    (0, d3.default)(2, arguments);
    var l3 = (0, i.default)(u3).getTime(), f3 = (0, o3.default)(n3);
    return new Date(l3 + f3);
  }
  a3.exports = e28.default;
})(d$k, d$k.exports);
var M$7 = d$k.exports;
(function(o3, e28) {
  var r3 = p$2A.default;
  Object.defineProperty(e28, "__esModule", {
    value: true
  }), e28.default = u3;
  var s3 = r3(M$7), a3 = r3(l$l), i = r3(f$k);
  function u3(d3, l3) {
    (0, a3.default)(2, arguments);
    var n3 = (0, i.default)(l3);
    return (0, s3.default)(d3, -n3);
  }
  o3.exports = e28.default;
})(s$j, s$j.exports);
var b$e = s$j.exports;
var r$t = { exports: {} };
var e$m = { exports: {} };
(function(o3, r3) {
  var a3 = p$2A.default;
  Object.defineProperty(r3, "__esModule", {
    value: true
  }), r3.default = u3;
  var f3 = a3(D$f), i = a3(l$l), s3 = 864e5;
  function u3(m3) {
    (0, i.default)(1, arguments);
    var e28 = (0, f3.default)(m3), p3 = e28.getTime();
    e28.setUTCMonth(0, 1), e28.setUTCHours(0, 0, 0, 0);
    var d3 = e28.getTime(), n3 = p3 - d3;
    return Math.floor(n3 / s3) + 1;
  }
  o3.exports = r3.default;
})(e$m, e$m.exports);
var C$u = e$m.exports;
var e$l = { exports: {} };
var e$k = { exports: {} };
(function(f3, t3) {
  var a3 = p$2A.default;
  Object.defineProperty(t3, "__esModule", {
    value: true
  }), t3.default = d3;
  var u3 = a3(D$f), i = a3(l$l);
  function d3(p3) {
    (0, i.default)(1, arguments);
    var o3 = 1, e28 = (0, u3.default)(p3), s3 = e28.getUTCDay(), n3 = (s3 < o3 ? 7 : 0) + s3 - o3;
    return e28.setUTCDate(e28.getUTCDate() - n3), e28.setUTCHours(0, 0, 0, 0), e28;
  }
  f3.exports = t3.default;
})(e$k, e$k.exports);
var U$7 = e$k.exports;
var e$j = { exports: {} };
var e$i = { exports: {} };
(function(i, r3) {
  var t3 = p$2A.default;
  Object.defineProperty(r3, "__esModule", {
    value: true
  }), r3.default = m3;
  var l3 = t3(D$f), n3 = t3(l$l), f3 = t3(U$7);
  function m3(d3) {
    (0, n3.default)(1, arguments);
    var a3 = (0, l3.default)(d3), e28 = a3.getUTCFullYear(), u3 = /* @__PURE__ */ new Date(0);
    u3.setUTCFullYear(e28 + 1, 0, 4), u3.setUTCHours(0, 0, 0, 0);
    var p3 = (0, f3.default)(u3), o3 = /* @__PURE__ */ new Date(0);
    o3.setUTCFullYear(e28, 0, 4), o3.setUTCHours(0, 0, 0, 0);
    var T3 = (0, f3.default)(o3);
    return a3.getTime() >= p3.getTime() ? e28 + 1 : a3.getTime() >= T3.getTime() ? e28 : e28 - 1;
  }
  i.exports = r3.default;
})(e$i, e$i.exports);
var E$a = e$i.exports;
(function(o3, e28) {
  var r3 = p$2A.default;
  Object.defineProperty(e28, "__esModule", {
    value: true
  }), e28.default = i;
  var s3 = r3(E$a), u3 = r3(U$7), f3 = r3(l$l);
  function i(p3) {
    (0, f3.default)(1, arguments);
    var d3 = (0, s3.default)(p3), t3 = /* @__PURE__ */ new Date(0);
    t3.setUTCFullYear(d3, 0, 4), t3.setUTCHours(0, 0, 0, 0);
    var n3 = (0, u3.default)(t3);
    return n3;
  }
  o3.exports = e28.default;
})(e$j, e$j.exports);
var k$c = e$j.exports;
(function(o3, r3) {
  var e28 = p$2A.default;
  Object.defineProperty(r3, "__esModule", {
    value: true
  }), r3.default = p3;
  var f3 = e28(D$f), i = e28(U$7), s3 = e28(k$c), u3 = e28(l$l), d3 = 6048e5;
  function p3(m3) {
    (0, u3.default)(1, arguments);
    var a3 = (0, f3.default)(m3), n3 = (0, i.default)(a3).getTime() - (0, s3.default)(a3).getTime();
    return Math.round(n3 / d3) + 1;
  }
  o3.exports = r3.default;
})(e$l, e$l.exports);
var W$6 = e$l.exports;
var e$h = { exports: {} };
var e$g = { exports: {} };
var t$f = {};
(function(O3, o3) {
  var a3 = p$2A.default;
  Object.defineProperty(o3, "__esModule", {
    value: true
  }), o3.default = g3;
  var x3 = a3(D$f), c3 = a3(l$l), k3 = a3(f$k), w3 = t$f;
  function g3(C3, e28) {
    var l3, i, n3, d3, s3, u3, f3, v3;
    (0, c3.default)(1, arguments);
    var _3 = (0, w3.getDefaultOptions)(), r3 = (0, k3.default)((l3 = (i = (n3 = (d3 = e28 == null ? void 0 : e28.weekStartsOn) !== null && d3 !== void 0 ? d3 : e28 == null || (s3 = e28.locale) === null || s3 === void 0 || (u3 = s3.options) === null || u3 === void 0 ? void 0 : u3.weekStartsOn) !== null && n3 !== void 0 ? n3 : _3.weekStartsOn) !== null && i !== void 0 ? i : (f3 = _3.locale) === null || f3 === void 0 || (v3 = f3.options) === null || v3 === void 0 ? void 0 : v3.weekStartsOn) !== null && l3 !== void 0 ? l3 : 0);
    if (!(r3 >= 0 && r3 <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var t3 = (0, x3.default)(C3), m3 = t3.getUTCDay(), D3 = (m3 < r3 ? 7 : 0) + m3 - r3;
    return t3.setUTCDate(t3.getUTCDate() - D3), t3.setUTCHours(0, 0, 0, 0), t3;
  }
  O3.exports = o3.default;
})(e$g, e$g.exports);
var A$c = e$g.exports;
var e$f = { exports: {} };
var e$e = { exports: {} };
(function(g3, o3) {
  var r3 = p$2A.default;
  Object.defineProperty(o3, "__esModule", {
    value: true
  }), o3.default = c3;
  var k3 = r3(D$f), W3 = r3(l$l), C3 = r3(A$c), D3 = r3(f$k), O3 = t$f;
  function c3(Y3, e28) {
    var i, l3, s3, n3, f3, u3, d3, v3;
    (0, W3.default)(1, arguments);
    var p3 = (0, k3.default)(Y3), t3 = p3.getUTCFullYear(), T3 = (0, O3.getDefaultOptions)(), a3 = (0, D3.default)((i = (l3 = (s3 = (n3 = e28 == null ? void 0 : e28.firstWeekContainsDate) !== null && n3 !== void 0 ? n3 : e28 == null || (f3 = e28.locale) === null || f3 === void 0 || (u3 = f3.options) === null || u3 === void 0 ? void 0 : u3.firstWeekContainsDate) !== null && s3 !== void 0 ? s3 : T3.firstWeekContainsDate) !== null && l3 !== void 0 ? l3 : (d3 = T3.locale) === null || d3 === void 0 || (v3 = d3.options) === null || v3 === void 0 ? void 0 : v3.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
    if (!(a3 >= 1 && a3 <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var m3 = /* @__PURE__ */ new Date(0);
    m3.setUTCFullYear(t3 + 1, 0, a3), m3.setUTCHours(0, 0, 0, 0);
    var U3 = (0, C3.default)(m3, e28), _3 = /* @__PURE__ */ new Date(0);
    _3.setUTCFullYear(t3, 0, a3), _3.setUTCHours(0, 0, 0, 0);
    var E3 = (0, C3.default)(_3, e28);
    return p3.getTime() >= U3.getTime() ? t3 + 1 : p3.getTime() >= E3.getTime() ? t3 : t3 - 1;
  }
  g3.exports = o3.default;
})(e$e, e$e.exports);
var P$b = e$e.exports;
(function(_3, r3) {
  var t3 = p$2A.default;
  Object.defineProperty(r3, "__esModule", {
    value: true
  }), r3.default = O3;
  var m3 = t3(P$b), x3 = t3(l$l), C3 = t3(A$c), k3 = t3(f$k), W3 = t$f;
  function O3(c3, e28) {
    var a3, o3, i, l3, s3, n3, f3, d3;
    (0, x3.default)(1, arguments);
    var p3 = (0, W3.getDefaultOptions)(), D3 = (0, k3.default)((a3 = (o3 = (i = (l3 = e28 == null ? void 0 : e28.firstWeekContainsDate) !== null && l3 !== void 0 ? l3 : e28 == null || (s3 = e28.locale) === null || s3 === void 0 || (n3 = s3.options) === null || n3 === void 0 ? void 0 : n3.firstWeekContainsDate) !== null && i !== void 0 ? i : p3.firstWeekContainsDate) !== null && o3 !== void 0 ? o3 : (f3 = p3.locale) === null || f3 === void 0 || (d3 = f3.options) === null || d3 === void 0 ? void 0 : d3.firstWeekContainsDate) !== null && a3 !== void 0 ? a3 : 1), T3 = (0, m3.default)(c3, e28), u3 = /* @__PURE__ */ new Date(0);
    u3.setUTCFullYear(T3, 0, D3), u3.setUTCHours(0, 0, 0, 0);
    var U3 = (0, C3.default)(u3, e28);
    return U3;
  }
  _3.exports = r3.default;
})(e$f, e$f.exports);
var M$6 = e$f.exports;
(function(f3, r3) {
  var e28 = p$2A.default;
  Object.defineProperty(r3, "__esModule", {
    value: true
  }), r3.default = p3;
  var i = e28(D$f), u3 = e28(A$c), s3 = e28(M$6), d3 = e28(l$l), m3 = 6048e5;
  function p3(n3, a3) {
    (0, d3.default)(1, arguments);
    var o3 = (0, i.default)(n3), l3 = (0, u3.default)(o3, a3).getTime() - (0, s3.default)(o3, a3).getTime();
    return Math.round(l3 / m3) + 1;
  }
  f3.exports = r3.default;
})(e$h, e$h.exports);
var O$g = e$h.exports;
var e$d = { exports: {} };
(function(o3, t3) {
  Object.defineProperty(t3, "__esModule", {
    value: true
  }), t3.default = d3;
  function d3(r3, n3) {
    for (var i = r3 < 0 ? "-" : "", e28 = Math.abs(r3).toString(); e28.length < n3; )
      e28 = "0" + e28;
    return i + e28;
  }
  o3.exports = t3.default;
})(e$d, e$d.exports);
var u$i = e$d.exports;
var r$s = { exports: {} };
(function(i, u3) {
  var f3 = p$2A.default;
  Object.defineProperty(u3, "__esModule", {
    value: true
  }), u3.default = void 0;
  var r3 = f3(u$i), s3 = {
    y: function(t3, e28) {
      var a3 = t3.getUTCFullYear(), o3 = a3 > 0 ? a3 : 1 - a3;
      return (0, r3.default)(e28 === "yy" ? o3 % 100 : o3, e28.length);
    },
    M: function(t3, e28) {
      var a3 = t3.getUTCMonth();
      return e28 === "M" ? String(a3 + 1) : (0, r3.default)(a3 + 1, 2);
    },
    d: function(t3, e28) {
      return (0, r3.default)(t3.getUTCDate(), e28.length);
    },
    a: function(t3, e28) {
      var a3 = t3.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (e28) {
        case "a":
        case "aa":
          return a3.toUpperCase();
        case "aaa":
          return a3;
        case "aaaaa":
          return a3[0];
        case "aaaa":
        default:
          return a3 === "am" ? "a.m." : "p.m.";
      }
    },
    h: function(t3, e28) {
      return (0, r3.default)(t3.getUTCHours() % 12 || 12, e28.length);
    },
    H: function(t3, e28) {
      return (0, r3.default)(t3.getUTCHours(), e28.length);
    },
    m: function(t3, e28) {
      return (0, r3.default)(t3.getUTCMinutes(), e28.length);
    },
    s: function(t3, e28) {
      return (0, r3.default)(t3.getUTCSeconds(), e28.length);
    },
    S: function(t3, e28) {
      var a3 = e28.length, o3 = t3.getUTCMilliseconds(), g3 = Math.floor(o3 * Math.pow(10, a3 - 3));
      return (0, r3.default)(g3, e28.length);
    }
  }, d3 = s3;
  u3.default = d3, i.exports = u3.default;
})(r$s, r$s.exports);
var C$t = r$s.exports;
(function(v3, m3) {
  var s3 = p$2A.default;
  Object.defineProperty(m3, "__esModule", {
    value: true
  }), m3.default = void 0;
  var l3 = s3(C$u), x3 = s3(W$6), b3 = s3(E$a), y3 = s3(O$g), T3 = s3(P$b), o3 = s3(u$i), d3 = s3(C$t), c3 = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, M3 = {
    G: function(a3, r3, t3) {
      var e28 = a3.getUTCFullYear() > 0 ? 1 : 0;
      switch (r3) {
        case "G":
        case "GG":
        case "GGG":
          return t3.era(e28, {
            width: "abbreviated"
          });
        case "GGGGG":
          return t3.era(e28, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return t3.era(e28, {
            width: "wide"
          });
      }
    },
    y: function(a3, r3, t3) {
      if (r3 === "yo") {
        var e28 = a3.getUTCFullYear(), n3 = e28 > 0 ? e28 : 1 - e28;
        return t3.ordinalNumber(n3, {
          unit: "year"
        });
      }
      return d3.default.y(a3, r3);
    },
    Y: function(a3, r3, t3, e28) {
      var n3 = (0, T3.default)(a3, e28), u3 = n3 > 0 ? n3 : 1 - n3;
      if (r3 === "YY") {
        var E3 = u3 % 100;
        return (0, o3.default)(E3, 2);
      }
      return r3 === "Yo" ? t3.ordinalNumber(u3, {
        unit: "year"
      }) : (0, o3.default)(u3, r3.length);
    },
    R: function(a3, r3) {
      var t3 = (0, b3.default)(a3);
      return (0, o3.default)(t3, r3.length);
    },
    u: function(a3, r3) {
      var t3 = a3.getUTCFullYear();
      return (0, o3.default)(t3, r3.length);
    },
    Q: function(a3, r3, t3) {
      var e28 = Math.ceil((a3.getUTCMonth() + 1) / 3);
      switch (r3) {
        case "Q":
          return String(e28);
        case "QQ":
          return (0, o3.default)(e28, 2);
        case "Qo":
          return t3.ordinalNumber(e28, {
            unit: "quarter"
          });
        case "QQQ":
          return t3.quarter(e28, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return t3.quarter(e28, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return t3.quarter(e28, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    q: function(a3, r3, t3) {
      var e28 = Math.ceil((a3.getUTCMonth() + 1) / 3);
      switch (r3) {
        case "q":
          return String(e28);
        case "qq":
          return (0, o3.default)(e28, 2);
        case "qo":
          return t3.ordinalNumber(e28, {
            unit: "quarter"
          });
        case "qqq":
          return t3.quarter(e28, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return t3.quarter(e28, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return t3.quarter(e28, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    M: function(a3, r3, t3) {
      var e28 = a3.getUTCMonth();
      switch (r3) {
        case "M":
        case "MM":
          return d3.default.M(a3, r3);
        case "Mo":
          return t3.ordinalNumber(e28 + 1, {
            unit: "month"
          });
        case "MMM":
          return t3.month(e28, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return t3.month(e28, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return t3.month(e28, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    L: function(a3, r3, t3) {
      var e28 = a3.getUTCMonth();
      switch (r3) {
        case "L":
          return String(e28 + 1);
        case "LL":
          return (0, o3.default)(e28 + 1, 2);
        case "Lo":
          return t3.ordinalNumber(e28 + 1, {
            unit: "month"
          });
        case "LLL":
          return t3.month(e28, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return t3.month(e28, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return t3.month(e28, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    w: function(a3, r3, t3, e28) {
      var n3 = (0, y3.default)(a3, e28);
      return r3 === "wo" ? t3.ordinalNumber(n3, {
        unit: "week"
      }) : (0, o3.default)(n3, r3.length);
    },
    I: function(a3, r3, t3) {
      var e28 = (0, x3.default)(a3);
      return r3 === "Io" ? t3.ordinalNumber(e28, {
        unit: "week"
      }) : (0, o3.default)(e28, r3.length);
    },
    d: function(a3, r3, t3) {
      return r3 === "do" ? t3.ordinalNumber(a3.getUTCDate(), {
        unit: "date"
      }) : d3.default.d(a3, r3);
    },
    D: function(a3, r3, t3) {
      var e28 = (0, l3.default)(a3);
      return r3 === "Do" ? t3.ordinalNumber(e28, {
        unit: "dayOfYear"
      }) : (0, o3.default)(e28, r3.length);
    },
    E: function(a3, r3, t3) {
      var e28 = a3.getUTCDay();
      switch (r3) {
        case "E":
        case "EE":
        case "EEE":
          return t3.day(e28, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return t3.day(e28, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return t3.day(e28, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return t3.day(e28, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    e: function(a3, r3, t3, e28) {
      var n3 = a3.getUTCDay(), u3 = (n3 - e28.weekStartsOn + 8) % 7 || 7;
      switch (r3) {
        case "e":
          return String(u3);
        case "ee":
          return (0, o3.default)(u3, 2);
        case "eo":
          return t3.ordinalNumber(u3, {
            unit: "day"
          });
        case "eee":
          return t3.day(n3, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return t3.day(n3, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return t3.day(n3, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return t3.day(n3, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    c: function(a3, r3, t3, e28) {
      var n3 = a3.getUTCDay(), u3 = (n3 - e28.weekStartsOn + 8) % 7 || 7;
      switch (r3) {
        case "c":
          return String(u3);
        case "cc":
          return (0, o3.default)(u3, r3.length);
        case "co":
          return t3.ordinalNumber(u3, {
            unit: "day"
          });
        case "ccc":
          return t3.day(n3, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return t3.day(n3, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return t3.day(n3, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return t3.day(n3, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    i: function(a3, r3, t3) {
      var e28 = a3.getUTCDay(), n3 = e28 === 0 ? 7 : e28;
      switch (r3) {
        case "i":
          return String(n3);
        case "ii":
          return (0, o3.default)(n3, r3.length);
        case "io":
          return t3.ordinalNumber(n3, {
            unit: "day"
          });
        case "iii":
          return t3.day(e28, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return t3.day(e28, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return t3.day(e28, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return t3.day(e28, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    a: function(a3, r3, t3) {
      var e28 = a3.getUTCHours(), n3 = e28 / 12 >= 1 ? "pm" : "am";
      switch (r3) {
        case "a":
        case "aa":
          return t3.dayPeriod(n3, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return t3.dayPeriod(n3, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return t3.dayPeriod(n3, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return t3.dayPeriod(n3, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    b: function(a3, r3, t3) {
      var e28 = a3.getUTCHours(), n3;
      switch (e28 === 12 ? n3 = c3.noon : e28 === 0 ? n3 = c3.midnight : n3 = e28 / 12 >= 1 ? "pm" : "am", r3) {
        case "b":
        case "bb":
          return t3.dayPeriod(n3, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return t3.dayPeriod(n3, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return t3.dayPeriod(n3, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return t3.dayPeriod(n3, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    B: function(a3, r3, t3) {
      var e28 = a3.getUTCHours(), n3;
      switch (e28 >= 17 ? n3 = c3.evening : e28 >= 12 ? n3 = c3.afternoon : e28 >= 4 ? n3 = c3.morning : n3 = c3.night, r3) {
        case "B":
        case "BB":
        case "BBB":
          return t3.dayPeriod(n3, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return t3.dayPeriod(n3, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return t3.dayPeriod(n3, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    h: function(a3, r3, t3) {
      if (r3 === "ho") {
        var e28 = a3.getUTCHours() % 12;
        return e28 === 0 && (e28 = 12), t3.ordinalNumber(e28, {
          unit: "hour"
        });
      }
      return d3.default.h(a3, r3);
    },
    H: function(a3, r3, t3) {
      return r3 === "Ho" ? t3.ordinalNumber(a3.getUTCHours(), {
        unit: "hour"
      }) : d3.default.H(a3, r3);
    },
    K: function(a3, r3, t3) {
      var e28 = a3.getUTCHours() % 12;
      return r3 === "Ko" ? t3.ordinalNumber(e28, {
        unit: "hour"
      }) : (0, o3.default)(e28, r3.length);
    },
    k: function(a3, r3, t3) {
      var e28 = a3.getUTCHours();
      return e28 === 0 && (e28 = 24), r3 === "ko" ? t3.ordinalNumber(e28, {
        unit: "hour"
      }) : (0, o3.default)(e28, r3.length);
    },
    m: function(a3, r3, t3) {
      return r3 === "mo" ? t3.ordinalNumber(a3.getUTCMinutes(), {
        unit: "minute"
      }) : d3.default.m(a3, r3);
    },
    s: function(a3, r3, t3) {
      return r3 === "so" ? t3.ordinalNumber(a3.getUTCSeconds(), {
        unit: "second"
      }) : d3.default.s(a3, r3);
    },
    S: function(a3, r3) {
      return d3.default.S(a3, r3);
    },
    X: function(a3, r3, t3, e28) {
      var n3 = e28._originalDate || a3, u3 = n3.getTimezoneOffset();
      if (u3 === 0)
        return "Z";
      switch (r3) {
        case "X":
          return w3(u3);
        case "XXXX":
        case "XX":
          return f3(u3);
        case "XXXXX":
        case "XXX":
        default:
          return f3(u3, ":");
      }
    },
    x: function(a3, r3, t3, e28) {
      var n3 = e28._originalDate || a3, u3 = n3.getTimezoneOffset();
      switch (r3) {
        case "x":
          return w3(u3);
        case "xxxx":
        case "xx":
          return f3(u3);
        case "xxxxx":
        case "xxx":
        default:
          return f3(u3, ":");
      }
    },
    O: function(a3, r3, t3, e28) {
      var n3 = e28._originalDate || a3, u3 = n3.getTimezoneOffset();
      switch (r3) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + g3(u3, ":");
        case "OOOO":
        default:
          return "GMT" + f3(u3, ":");
      }
    },
    z: function(a3, r3, t3, e28) {
      var n3 = e28._originalDate || a3, u3 = n3.getTimezoneOffset();
      switch (r3) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + g3(u3, ":");
        case "zzzz":
        default:
          return "GMT" + f3(u3, ":");
      }
    },
    t: function(a3, r3, t3, e28) {
      var n3 = e28._originalDate || a3, u3 = Math.floor(n3.getTime() / 1e3);
      return (0, o3.default)(u3, r3.length);
    },
    T: function(a3, r3, t3, e28) {
      var n3 = e28._originalDate || a3, u3 = n3.getTime();
      return (0, o3.default)(u3, r3.length);
    }
  };
  function g3(i, a3) {
    var r3 = i > 0 ? "-" : "+", t3 = Math.abs(i), e28 = Math.floor(t3 / 60), n3 = t3 % 60;
    if (n3 === 0)
      return r3 + String(e28);
    var u3 = a3 || "";
    return r3 + String(e28) + u3 + (0, o3.default)(n3, 2);
  }
  function w3(i, a3) {
    if (i % 60 === 0) {
      var r3 = i > 0 ? "-" : "+";
      return r3 + (0, o3.default)(Math.abs(i) / 60, 2);
    }
    return f3(i, a3);
  }
  function f3(i, a3) {
    var r3 = a3 || "", t3 = i > 0 ? "-" : "+", e28 = Math.abs(i), n3 = (0, o3.default)(Math.floor(e28 / 60), 2), u3 = (0, o3.default)(e28 % 60, 2);
    return t3 + n3 + r3 + u3;
  }
  var O3 = M3;
  m3.default = O3, v3.exports = m3.default;
})(r$t, r$t.exports);
var k$b = r$t.exports;
var o$f = { exports: {} };
(function(m3, r3) {
  Object.defineProperty(r3, "__esModule", {
    value: true
  }), r3.default = void 0;
  var i = function(t3, e28) {
    switch (t3) {
      case "P":
        return e28.date({
          width: "short"
        });
      case "PP":
        return e28.date({
          width: "medium"
        });
      case "PPP":
        return e28.date({
          width: "long"
        });
      case "PPPP":
      default:
        return e28.date({
          width: "full"
        });
    }
  }, u3 = function(t3, e28) {
    switch (t3) {
      case "p":
        return e28.time({
          width: "short"
        });
      case "pp":
        return e28.time({
          width: "medium"
        });
      case "ppp":
        return e28.time({
          width: "long"
        });
      case "pppp":
      default:
        return e28.time({
          width: "full"
        });
    }
  }, h3 = function(t3, e28) {
    var s3 = t3.match(/(P+)(p+)?/) || [], P3 = s3[1], c3 = s3[2];
    if (!c3)
      return i(t3, e28);
    var a3;
    switch (P3) {
      case "P":
        a3 = e28.dateTime({
          width: "short"
        });
        break;
      case "PP":
        a3 = e28.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        a3 = e28.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        a3 = e28.dateTime({
          width: "full"
        });
        break;
    }
    return a3.replace("{{date}}", i(P3, e28)).replace("{{time}}", u3(c3, e28));
  }, n3 = {
    p: u3,
    P: h3
  }, p3 = n3;
  r3.default = p3, m3.exports = r3.default;
})(o$f, o$f.exports);
var o$e = o$f.exports;
var e$c = { exports: {} };
(function(n3, t3) {
  Object.defineProperty(t3, "__esModule", {
    value: true
  }), t3.default = l3;
  function l3(e28) {
    var s3 = new Date(Date.UTC(e28.getFullYear(), e28.getMonth(), e28.getDate(), e28.getHours(), e28.getMinutes(), e28.getSeconds(), e28.getMilliseconds()));
    return s3.setUTCFullYear(e28.getFullYear()), e28.getTime() - s3.getTime();
  }
  n3.exports = t3.default;
})(e$c, e$c.exports);
var r$r = e$c.exports;
const g$k = /* @__PURE__ */ l$Y(r$r);
var e$b = {};
var e$a = { exports: {} };
var e$9 = { exports: {} };
var a$B = { exports: {} };
(function(s3, t3) {
  Object.defineProperty(t3, "__esModule", {
    value: true
  }), t3.default = void 0;
  var u3 = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, h3 = function(l3, r3, o3) {
    var e28, n3 = u3[l3];
    return typeof n3 == "string" ? e28 = n3 : r3 === 1 ? e28 = n3.one : e28 = n3.other.replace("{{count}}", r3.toString()), o3 != null && o3.addSuffix ? o3.comparison && o3.comparison > 0 ? "in " + e28 : e28 + " ago" : e28;
  }, c3 = h3;
  t3.default = c3, s3.exports = t3.default;
})(a$B, a$B.exports);
var m$j = a$B.exports;
var o$d = { exports: {} };
var o$c = { exports: {} };
(function(o3, e28) {
  Object.defineProperty(e28, "__esModule", {
    value: true
  }), e28.default = u3;
  function u3(t3) {
    return function() {
      var r3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a3 = r3.width ? String(r3.width) : t3.defaultWidth, d3 = t3.formats[a3] || t3.formats[t3.defaultWidth];
      return d3;
    };
  }
  o3.exports = e28.default;
})(o$c, o$c.exports);
var f$j = o$c.exports;
(function(m3, t3) {
  var o3 = p$2A.default;
  Object.defineProperty(t3, "__esModule", {
    value: true
  }), t3.default = void 0;
  var a3 = o3(f$j), r3 = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, d3 = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, l3 = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, f3 = {
    date: (0, a3.default)({
      formats: r3,
      defaultWidth: "full"
    }),
    time: (0, a3.default)({
      formats: d3,
      defaultWidth: "full"
    }),
    dateTime: (0, a3.default)({
      formats: l3,
      defaultWidth: "full"
    })
  }, u3 = f3;
  t3.default = u3, m3.exports = t3.default;
})(o$d, o$d.exports);
var p$2x = o$d.exports;
var e$8 = { exports: {} };
(function(a3, e28) {
  Object.defineProperty(e28, "__esModule", {
    value: true
  }), e28.default = void 0;
  var o3 = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, r3 = function(f3, i, u3, v3) {
    return o3[f3];
  }, l3 = r3;
  e28.default = l3, a3.exports = e28.default;
})(e$8, e$8.exports);
var p$2w = e$8.exports;
var e$7 = { exports: {} };
var e$6 = { exports: {} };
(function(i, l3) {
  Object.defineProperty(l3, "__esModule", {
    value: true
  }), l3.default = n3;
  function n3(t3) {
    return function(d3, e28) {
      var f3 = e28 != null && e28.context ? String(e28.context) : "standalone", a3;
      if (f3 === "formatting" && t3.formattingValues) {
        var r3 = t3.defaultFormattingWidth || t3.defaultWidth, v3 = e28 != null && e28.width ? String(e28.width) : r3;
        a3 = t3.formattingValues[v3] || t3.formattingValues[r3];
      } else {
        var c3 = t3.defaultWidth, m3 = e28 != null && e28.width ? String(e28.width) : t3.defaultWidth;
        a3 = t3.values[m3] || t3.values[c3];
      }
      var b3 = t3.argumentCallback ? t3.argumentCallback(d3) : d3;
      return a3[b3];
    };
  }
  i.exports = l3.default;
})(e$6, e$6.exports);
var x$c = e$6.exports;
(function(o3, a3) {
  var d3 = p$2A.default;
  Object.defineProperty(a3, "__esModule", {
    value: true
  }), a3.default = void 0;
  var n3 = d3(x$c), u3 = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, m3 = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, g3 = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, l3 = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, h3 = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, f3 = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, v3 = function(r3, y3) {
    var e28 = Number(r3), i = e28 % 100;
    if (i > 20 || i < 10)
      switch (i % 10) {
        case 1:
          return e28 + "st";
        case 2:
          return e28 + "nd";
        case 3:
          return e28 + "rd";
      }
    return e28 + "th";
  }, s3 = {
    ordinalNumber: v3,
    era: (0, n3.default)({
      values: u3,
      defaultWidth: "wide"
    }),
    quarter: (0, n3.default)({
      values: m3,
      defaultWidth: "wide",
      argumentCallback: function(r3) {
        return r3 - 1;
      }
    }),
    month: (0, n3.default)({
      values: g3,
      defaultWidth: "wide"
    }),
    day: (0, n3.default)({
      values: l3,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, n3.default)({
      values: h3,
      defaultWidth: "wide",
      formattingValues: f3,
      defaultFormattingWidth: "wide"
    })
  }, b3 = s3;
  a3.default = b3, o3.exports = a3.default;
})(e$7, e$7.exports);
var W$5 = e$7.exports;
var a$A = { exports: {} };
var a$z = { exports: {} };
(function(h3, u3) {
  Object.defineProperty(u3, "__esModule", {
    value: true
  }), u3.default = o3;
  function o3(t3) {
    return function(n3) {
      var e28 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a3 = e28.width, p3 = a3 && t3.matchPatterns[a3] || t3.matchPatterns[t3.defaultMatchWidth], c3 = n3.match(p3);
      if (!c3)
        return null;
      var l3 = c3[0], i = a3 && t3.parsePatterns[a3] || t3.parsePatterns[t3.defaultParseWidth], v3 = Array.isArray(i) ? m3(i, function(d3) {
        return d3.test(l3);
      }) : s3(i, function(d3) {
        return d3.test(l3);
      }), r3;
      r3 = t3.valueCallback ? t3.valueCallback(v3) : v3, r3 = e28.valueCallback ? e28.valueCallback(r3) : r3;
      var P3 = n3.slice(l3.length);
      return {
        value: r3,
        rest: P3
      };
    };
  }
  function s3(t3, n3) {
    for (var e28 in t3)
      if (t3.hasOwnProperty(e28) && n3(t3[e28]))
        return e28;
  }
  function m3(t3, n3) {
    for (var e28 = 0; e28 < t3.length; e28++)
      if (n3(t3[e28]))
        return e28;
  }
  h3.exports = u3.default;
})(a$z, a$z.exports);
var M$5 = a$z.exports;
var t$e = { exports: {} };
(function(v3, a3) {
  Object.defineProperty(a3, "__esModule", {
    value: true
  }), a3.default = o3;
  function o3(e28) {
    return function(l3) {
      var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c3 = l3.match(e28.matchPattern);
      if (!c3)
        return null;
      var i = c3[0], r3 = l3.match(e28.parsePattern);
      if (!r3)
        return null;
      var t3 = e28.valueCallback ? e28.valueCallback(r3[0]) : r3[0];
      t3 = n3.valueCallback ? n3.valueCallback(t3) : t3;
      var d3 = l3.slice(i.length);
      return {
        value: t3,
        rest: d3
      };
    };
  }
  v3.exports = a3.default;
})(t$e, t$e.exports);
var s$i = t$e.exports;
(function(n3, t3) {
  var i = p$2A.default;
  Object.defineProperty(t3, "__esModule", {
    value: true
  }), t3.default = void 0;
  var a3 = i(M$5), d3 = i(s$i), s3 = /^(\d+)(th|st|nd|rd)?/i, o3 = /\d+/i, u3 = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, m3 = {
    any: [/^b/i, /^(a|c)/i]
  }, h3 = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, f3 = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, l3 = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, c3 = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, p3 = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, v3 = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, P3 = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, b3 = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, y3 = {
    ordinalNumber: (0, d3.default)({
      matchPattern: s3,
      parsePattern: o3,
      valueCallback: function(e28) {
        return parseInt(e28, 10);
      }
    }),
    era: (0, a3.default)({
      matchPatterns: u3,
      defaultMatchWidth: "wide",
      parsePatterns: m3,
      defaultParseWidth: "any"
    }),
    quarter: (0, a3.default)({
      matchPatterns: h3,
      defaultMatchWidth: "wide",
      parsePatterns: f3,
      defaultParseWidth: "any",
      valueCallback: function(e28) {
        return e28 + 1;
      }
    }),
    month: (0, a3.default)({
      matchPatterns: l3,
      defaultMatchWidth: "wide",
      parsePatterns: c3,
      defaultParseWidth: "any"
    }),
    day: (0, a3.default)({
      matchPatterns: p3,
      defaultMatchWidth: "wide",
      parsePatterns: v3,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a3.default)({
      matchPatterns: P3,
      defaultMatchWidth: "any",
      parsePatterns: b3,
      defaultParseWidth: "any"
    })
  }, w3 = y3;
  t3.default = w3, n3.exports = t3.default;
})(a$A, a$A.exports);
var q$8 = a$A.exports;
(function(r3, t3) {
  var e28 = p$2A.default;
  Object.defineProperty(t3, "__esModule", {
    value: true
  }), t3.default = void 0;
  var o3 = e28(m$j), f3 = e28(p$2x), i = e28(p$2w), l3 = e28(W$5), m3 = e28(q$8), s3 = {
    code: "en-US",
    formatDistance: o3.default,
    formatLong: f3.default,
    formatRelative: i.default,
    localize: l3.default,
    match: m3.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, n3 = s3;
  t3.default = n3, r3.exports = t3.default;
})(e$9, e$9.exports);
var h$y = e$9.exports;
(function(a3, e28) {
  var r3 = p$2A.default;
  Object.defineProperty(e28, "__esModule", {
    value: true
  }), e28.default = void 0;
  var o3 = r3(h$y), u3 = o3.default;
  e28.default = u3, a3.exports = e28.default;
})(e$a, e$a.exports);
var s$h = e$a.exports;
(function(Y3, v3) {
  var t3 = p$2A.default;
  Object.defineProperty(v3, "__esModule", {
    value: true
  }), v3.default = J3;
  var j3 = t3(c$J), q3 = t3(b$e), y3 = t3(D$f), A3 = t3(k$b), F3 = t3(o$e), I3 = t3(r$r), d3 = e$b, L3 = t3(f$k), M3 = t3(l$l), Q3 = t$f, H3 = t3(s$h), K3 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, V10 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Z3 = /^'([^]*?)'?$/, B3 = /''/g, G3 = /[a-zA-Z]/;
  function J3(o3, l3, e28) {
    var s3, m3, c3, p3, _3, x3, g3, k3, w3, E3, O3, h3, D3, $3, R3, C3, S3, W3;
    (0, M3.default)(2, arguments);
    var U3 = String(l3), i = (0, Q3.getDefaultOptions)(), n3 = (s3 = (m3 = e28 == null ? void 0 : e28.locale) !== null && m3 !== void 0 ? m3 : i.locale) !== null && s3 !== void 0 ? s3 : H3.default, P3 = (0, L3.default)((c3 = (p3 = (_3 = (x3 = e28 == null ? void 0 : e28.firstWeekContainsDate) !== null && x3 !== void 0 ? x3 : e28 == null || (g3 = e28.locale) === null || g3 === void 0 || (k3 = g3.options) === null || k3 === void 0 ? void 0 : k3.firstWeekContainsDate) !== null && _3 !== void 0 ? _3 : i.firstWeekContainsDate) !== null && p3 !== void 0 ? p3 : (w3 = i.locale) === null || w3 === void 0 || (E3 = w3.options) === null || E3 === void 0 ? void 0 : E3.firstWeekContainsDate) !== null && c3 !== void 0 ? c3 : 1);
    if (!(P3 >= 1 && P3 <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var T3 = (0, L3.default)((O3 = (h3 = (D3 = ($3 = e28 == null ? void 0 : e28.weekStartsOn) !== null && $3 !== void 0 ? $3 : e28 == null || (R3 = e28.locale) === null || R3 === void 0 || (C3 = R3.options) === null || C3 === void 0 ? void 0 : C3.weekStartsOn) !== null && D3 !== void 0 ? D3 : i.weekStartsOn) !== null && h3 !== void 0 ? h3 : (S3 = i.locale) === null || S3 === void 0 || (W3 = S3.options) === null || W3 === void 0 ? void 0 : W3.weekStartsOn) !== null && O3 !== void 0 ? O3 : 0);
    if (!(T3 >= 0 && T3 <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!n3.localize)
      throw new RangeError("locale must contain localize property");
    if (!n3.formatLong)
      throw new RangeError("locale must contain formatLong property");
    var f3 = (0, y3.default)(o3);
    if (!(0, j3.default)(f3))
      throw new RangeError("Invalid time value");
    var X3 = (0, I3.default)(f3), b3 = (0, q3.default)(f3, X3), ee2 = {
      firstWeekContainsDate: P3,
      weekStartsOn: T3,
      locale: n3,
      _originalDate: f3
    }, re2 = U3.match(V10).map(function(r3) {
      var a3 = r3[0];
      if (a3 === "p" || a3 === "P") {
        var u3 = F3.default[a3];
        return u3(r3, n3.formatLong);
      }
      return r3;
    }).join("").match(K3).map(function(r3) {
      if (r3 === "''")
        return "'";
      var a3 = r3[0];
      if (a3 === "'")
        return N3(r3);
      var u3 = A3.default[a3];
      if (u3)
        return !(e28 != null && e28.useAdditionalWeekYearTokens) && (0, d3.isProtectedWeekYearToken)(r3) && (0, d3.throwProtectedError)(r3, l3, String(o3)), !(e28 != null && e28.useAdditionalDayOfYearTokens) && (0, d3.isProtectedDayOfYearToken)(r3) && (0, d3.throwProtectedError)(r3, l3, String(o3)), u3(b3, r3, n3.localize, ee2);
      if (a3.match(G3))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + a3 + "`");
      return r3;
    }).join("");
    return re2;
  }
  function N3(o3) {
    var l3 = o3.match(Z3);
    return l3 ? l3[1].replace(B3, "'") : o3;
  }
  Y3.exports = v3.default;
})(o$g, o$g.exports);
var pe$3 = o$g.exports;
const ze$1 = /* @__PURE__ */ l$Y(pe$3);
function f$i(n3, r3, e28) {
  var t3 = m$i(n3, e28.timeZone, e28.locale);
  return t3.formatToParts ? a$y(t3, r3) : o$b(t3, r3);
}
function a$y(n3, r3) {
  for (var e28 = n3.formatToParts(r3), t3 = e28.length - 1; t3 >= 0; --t3)
    if (e28[t3].type === "timeZoneName")
      return e28[t3].value;
}
function o$b(n3, r3) {
  var e28 = n3.format(r3).replace(/\u200E/g, ""), t3 = / [\w-+ ]+$/.exec(e28);
  return t3 ? t3[0].substr(1) : "";
}
function m$i(n3, r3, e28) {
  if (e28 && !e28.code)
    throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
  return new Intl.DateTimeFormat(e28 ? [e28.code, "en-US"] : void 0, {
    timeZone: r3,
    timeZoneName: n3
  });
}
function h$x(r3, a3) {
  var e28 = f$h(a3);
  return e28.formatToParts ? m$h(e28, r3) : c$I(e28, r3);
}
var d$j = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function m$h(r3, a3) {
  try {
    for (var e28 = r3.formatToParts(a3), t3 = [], n3 = 0; n3 < e28.length; n3++) {
      var o3 = d$j[e28[n3].type];
      o3 >= 0 && (t3[o3] = parseInt(e28[n3].value, 10));
    }
    return t3;
  } catch (u3) {
    if (u3 instanceof RangeError)
      return [NaN];
    throw u3;
  }
}
function c$I(r3, a3) {
  var e28 = r3.format(a3).replace(/\u200E/g, ""), t3 = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(e28);
  return [t3[3], t3[1], t3[2], t3[4], t3[5], t3[6]];
}
var i$m = {};
function f$h(r3) {
  if (!i$m[r3]) {
    var a3 = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), e28 = a3 === "06/25/2014, 00:00:00" || a3 === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
    i$m[r3] = e28 ? new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: r3,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: r3,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return i$m[r3];
}
function o$a(t3, a3, r3, u3, n3, s3, l3) {
  var e28 = /* @__PURE__ */ new Date(0);
  return e28.setUTCFullYear(t3, a3, r3), e28.setUTCHours(u3, n3, s3, l3), e28;
}
var c$H = 36e5, m$g = 6e4, i$l = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function x$b(e28, r3, n3) {
  var a3, u3;
  if (!e28 || (a3 = i$l.timezoneZ.exec(e28), a3))
    return 0;
  var t3;
  if (a3 = i$l.timezoneHH.exec(e28), a3)
    return t3 = parseInt(a3[1], 10), l$k(t3) ? -(t3 * c$H) : NaN;
  if (a3 = i$l.timezoneHHMM.exec(e28), a3) {
    t3 = parseInt(a3[1], 10);
    var o3 = parseInt(a3[2], 10);
    return l$k(t3, o3) ? (u3 = Math.abs(t3) * c$H + o3 * m$g, t3 > 0 ? -u3 : u3) : NaN;
  }
  if (p$2v(e28)) {
    r3 = new Date(r3 || Date.now());
    var I3 = n3 ? r3 : D$e(r3), f3 = v$f(I3, e28), N3 = n3 ? f3 : H$7(r3, f3, e28);
    return -N3;
  }
  return NaN;
}
function D$e(e28) {
  return o$a(e28.getFullYear(), e28.getMonth(), e28.getDate(), e28.getHours(), e28.getMinutes(), e28.getSeconds(), e28.getMilliseconds());
}
function v$f(e28, r3) {
  var n3 = h$x(e28, r3), a3 = o$a(n3[0], n3[1] - 1, n3[2], n3[3] % 24, n3[4], n3[5], 0).getTime(), u3 = e28.getTime(), t3 = u3 % 1e3;
  return u3 -= t3 >= 0 ? t3 : 1e3 + t3, a3 - u3;
}
function H$7(e28, r3, n3) {
  var a3 = e28.getTime(), u3 = a3 - r3, t3 = v$f(new Date(u3), n3);
  if (r3 === t3)
    return r3;
  u3 -= t3 - r3;
  var o3 = v$f(new Date(u3), n3);
  return t3 === o3 ? t3 : Math.max(t3, o3);
}
function l$k(e28, r3) {
  return -23 <= e28 && e28 <= 23 && (r3 == null || 0 <= r3 && r3 <= 59);
}
var s$g = {};
function p$2v(e28) {
  if (s$g[e28])
    return true;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e28 }), s$g[e28] = true, true;
  } catch {
    return false;
  }
}
var z$5 = 60 * 1e3, v$e = {
  X: function(e28, a3, n3, r3) {
    var t3 = c$G(r3.timeZone, r3._originalDate || e28);
    if (t3 === 0)
      return "Z";
    switch (a3) {
      case "X":
        return l$j(t3);
      case "XXXX":
      case "XX":
        return i$k(t3);
      case "XXXXX":
      case "XXX":
      default:
        return i$k(t3, ":");
    }
  },
  x: function(e28, a3, n3, r3) {
    var t3 = c$G(r3.timeZone, r3._originalDate || e28);
    switch (a3) {
      case "x":
        return l$j(t3);
      case "xxxx":
      case "xx":
        return i$k(t3);
      case "xxxxx":
      case "xxx":
      default:
        return i$k(t3, ":");
    }
  },
  O: function(e28, a3, n3, r3) {
    var t3 = c$G(r3.timeZone, r3._originalDate || e28);
    switch (a3) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + O$f(t3, ":");
      case "OOOO":
      default:
        return "GMT" + i$k(t3, ":");
    }
  },
  z: function(e28, a3, n3, r3) {
    var t3 = r3._originalDate || e28;
    switch (a3) {
      case "z":
      case "zz":
      case "zzz":
        return f$i("short", t3, r3);
      case "zzzz":
      default:
        return f$i("long", t3, r3);
    }
  }
};
function c$G(e28, a3) {
  var n3 = e28 ? x$b(e28, a3, true) / z$5 : a3.getTimezoneOffset();
  if (Number.isNaN(n3))
    throw new RangeError("Invalid time zone specified: " + e28);
  return n3;
}
function s$f(e28, a3) {
  for (var n3 = e28 < 0 ? "-" : "", r3 = Math.abs(e28).toString(); r3.length < a3; )
    r3 = "0" + r3;
  return n3 + r3;
}
function i$k(e28, a3) {
  var n3 = a3 || "", r3 = e28 > 0 ? "-" : "+", t3 = Math.abs(e28), o3 = s$f(Math.floor(t3 / 60), 2), u3 = s$f(Math.floor(t3 % 60), 2);
  return r3 + o3 + n3 + u3;
}
function l$j(e28, a3) {
  if (e28 % 60 === 0) {
    var n3 = e28 > 0 ? "-" : "+";
    return n3 + s$f(Math.abs(e28) / 60, 2);
  }
  return i$k(e28, a3);
}
function O$f(e28, a3) {
  var n3 = e28 > 0 ? "-" : "+", r3 = Math.abs(e28), t3 = Math.floor(r3 / 60), o3 = r3 % 60;
  if (o3 === 0)
    return n3 + String(t3);
  var u3 = a3 || "";
  return n3 + String(t3) + u3 + s$f(o3, 2);
}
const g$j = v$e;
var a$x = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var v$d = 36e5, c$F = 6e4, _$b = 2, i$j = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    /^([+-]\d{3})$/,
    /^([+-]\d{4})$/
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    /^([+-]\d{5})/,
    /^([+-]\d{6})/
  ],
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  timeZone: a$x
};
function j$5(t3, r3) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t3 === null)
    return /* @__PURE__ */ new Date(NaN);
  var e28 = r3 || {}, a3 = e28.additionalDigits == null ? _$b : p$2y(e28.additionalDigits);
  if (a3 !== 2 && a3 !== 1 && a3 !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t3 instanceof Date || typeof t3 == "object" && Object.prototype.toString.call(t3) === "[object Date]")
    return new Date(t3.getTime());
  if (typeof t3 == "number" || Object.prototype.toString.call(t3) === "[object Number]")
    return new Date(t3);
  if (!(typeof t3 == "string" || Object.prototype.toString.call(t3) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var n3 = $$4(t3), l3 = b$d(n3.date, a3), u3 = l3.year, o3 = l3.restDateString, f3 = U$6(o3, u3);
  if (isNaN(f3))
    return /* @__PURE__ */ new Date(NaN);
  if (f3) {
    var Y3 = f3.getTime(), D3 = 0, s3;
    if (n3.time && (D3 = m$f(n3.time), isNaN(D3)))
      return /* @__PURE__ */ new Date(NaN);
    if (n3.timeZone || e28.timeZone) {
      if (s3 = x$b(n3.timeZone || e28.timeZone, new Date(Y3 + D3)), isNaN(s3))
        return /* @__PURE__ */ new Date(NaN);
    } else
      s3 = g$k(new Date(Y3 + D3)), s3 = g$k(new Date(Y3 + D3 + s3));
    return new Date(Y3 + D3 + s3);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function $$4(t3) {
  var r3 = {}, e28 = i$j.dateTimePattern.exec(t3), a3;
  if (e28 ? (r3.date = e28[1], a3 = e28[3]) : (e28 = i$j.datePattern.exec(t3), e28 ? (r3.date = e28[1], a3 = e28[2]) : (r3.date = null, a3 = t3)), a3) {
    var n3 = i$j.timeZone.exec(a3);
    n3 ? (r3.time = a3.replace(n3[1], ""), r3.timeZone = n3[1].trim()) : r3.time = a3;
  }
  return r3;
}
function b$d(t3, r3) {
  var e28 = i$j.YYY[r3], a3 = i$j.YYYYY[r3], n3;
  if (n3 = i$j.YYYY.exec(t3) || a3.exec(t3), n3) {
    var l3 = n3[1];
    return {
      year: parseInt(l3, 10),
      restDateString: t3.slice(l3.length)
    };
  }
  if (n3 = i$j.YY.exec(t3) || e28.exec(t3), n3) {
    var u3 = n3[1];
    return {
      year: parseInt(u3, 10) * 100,
      restDateString: t3.slice(u3.length)
    };
  }
  return {
    year: null
  };
}
function U$6(t3, r3) {
  if (r3 === null)
    return null;
  var e28, a3, n3, l3;
  if (t3.length === 0)
    return a3 = /* @__PURE__ */ new Date(0), a3.setUTCFullYear(r3), a3;
  if (e28 = i$j.MM.exec(t3), e28)
    return a3 = /* @__PURE__ */ new Date(0), n3 = parseInt(e28[1], 10) - 1, I$c(r3, n3) ? (a3.setUTCFullYear(r3, n3), a3) : /* @__PURE__ */ new Date(NaN);
  if (e28 = i$j.DDD.exec(t3), e28) {
    a3 = /* @__PURE__ */ new Date(0);
    var u3 = parseInt(e28[1], 10);
    return F$c(r3, u3) ? (a3.setUTCFullYear(r3, 0, u3), a3) : /* @__PURE__ */ new Date(NaN);
  }
  if (e28 = i$j.MMDD.exec(t3), e28) {
    a3 = /* @__PURE__ */ new Date(0), n3 = parseInt(e28[1], 10) - 1;
    var o3 = parseInt(e28[2], 10);
    return I$c(r3, n3, o3) ? (a3.setUTCFullYear(r3, n3, o3), a3) : /* @__PURE__ */ new Date(NaN);
  }
  if (e28 = i$j.Www.exec(t3), e28)
    return l3 = parseInt(e28[1], 10) - 1, d$i(r3, l3) ? w$9(r3, l3) : /* @__PURE__ */ new Date(NaN);
  if (e28 = i$j.WwwD.exec(t3), e28) {
    l3 = parseInt(e28[1], 10) - 1;
    var f3 = parseInt(e28[2], 10) - 1;
    return d$i(r3, l3, f3) ? w$9(r3, l3, f3) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function m$f(t3) {
  var r3, e28, a3;
  if (r3 = i$j.HH.exec(t3), r3)
    return e28 = parseFloat(r3[1].replace(",", ".")), N$f(e28) ? e28 % 24 * v$d : NaN;
  if (r3 = i$j.HHMM.exec(t3), r3)
    return e28 = parseInt(r3[1], 10), a3 = parseFloat(r3[2].replace(",", ".")), N$f(e28, a3) ? e28 % 24 * v$d + a3 * c$F : NaN;
  if (r3 = i$j.HHMMSS.exec(t3), r3) {
    e28 = parseInt(r3[1], 10), a3 = parseInt(r3[2], 10);
    var n3 = parseFloat(r3[3].replace(",", "."));
    return N$f(e28, a3, n3) ? e28 % 24 * v$d + a3 * c$F + n3 * 1e3 : NaN;
  }
  return null;
}
function w$9(t3, r3, e28) {
  r3 = r3 || 0, e28 = e28 || 0;
  var a3 = /* @__PURE__ */ new Date(0);
  a3.setUTCFullYear(t3, 0, 4);
  var n3 = a3.getUTCDay() || 7, l3 = r3 * 7 + e28 + 1 - n3;
  return a3.setUTCDate(a3.getUTCDate() + l3), a3;
}
var C$s = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], O$e = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function T$b(t3) {
  return t3 % 400 === 0 || t3 % 4 === 0 && t3 % 100 !== 0;
}
function I$c(t3, r3, e28) {
  if (r3 < 0 || r3 > 11)
    return false;
  if (e28 != null) {
    if (e28 < 1)
      return false;
    var a3 = T$b(t3);
    if (a3 && e28 > O$e[r3] || !a3 && e28 > C$s[r3])
      return false;
  }
  return true;
}
function F$c(t3, r3) {
  if (r3 < 1)
    return false;
  var e28 = T$b(t3);
  return !(e28 && r3 > 366 || !e28 && r3 > 365);
}
function d$i(t3, r3, e28) {
  return !(r3 < 0 || r3 > 52 || e28 != null && (e28 < 0 || e28 > 6));
}
function N$f(t3, r3, e28) {
  return !(t3 != null && (t3 < 0 || t3 >= 25) || r3 != null && (r3 < 0 || r3 >= 60) || e28 != null && (e28 < 0 || e28 >= 60));
}
var g$i = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function b$c(m3, f3, p3) {
  var t3 = String(f3), o3 = p3 || {}, n3 = t3.match(g$i);
  if (n3) {
    var c3 = j$5(m3, o3);
    t3 = n3.reduce(function(a3, r3) {
      if (r3[0] === "'")
        return a3;
      var e28 = a3.indexOf(r3), s3 = a3[e28 - 1] === "'", i = a3.replace(r3, "'" + g$j[r3[0]](c3, r3, null, o3) + "'");
      return s3 ? i.substring(0, e28 - 1) + i.substring(e28 + 1) : i;
    }, t3);
  }
  return ze$1(m3, t3, o3);
}
function g$h(o3, a3, s3) {
  var r3 = j$5(o3, s3), n3 = x$b(a3, r3, true), e28 = new Date(r3.getTime() - n3), t3 = /* @__PURE__ */ new Date(0);
  return t3.setFullYear(e28.getUTCFullYear(), e28.getUTCMonth(), e28.getUTCDate()), t3.setHours(e28.getUTCHours(), e28.getUTCMinutes(), e28.getUTCSeconds(), e28.getUTCMilliseconds()), t3;
}
function d$h(e28, o3, r3, m3) {
  var t3 = x$d(m3);
  return t3.timeZone = o3, b$c(g$h(e28, o3), r3, t3);
}
const p$2u = {
  amHours: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11"],
  pmHours: ["12", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11"],
  hours: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"],
  minutes: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"],
  seconds: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"],
  period: ["AM", "PM"]
};
function f$g(e28) {
  return `00${e28}`.slice(-2);
}
function N$e(e28, m3, u3) {
  return Array.isArray(m3) ? (u3 === "am" ? m3.filter((r3) => r3 < 12) : u3 === "pm" ? m3.filter((r3) => r3 >= 12).map((r3) => r3 === 12 ? 12 : r3 - 12) : m3).map((r3) => f$g(r3)) : typeof m3 == "number" ? u3 === "am" ? e28.filter((r3) => {
    const n3 = Number(r3);
    return n3 < 12 && n3 % m3 === 0;
  }) : u3 === "pm" ? e28.filter((r3) => {
    const n3 = Number(r3);
    return n3 >= 12 && n3 % m3 === 0;
  }).map((r3) => {
    const n3 = Number(r3);
    return f$g(n3 === 12 ? 12 : n3 - 12);
  }) : e28.filter((r3) => Number(r3) % m3 === 0) : u3 === "am" ? e28.filter((r3) => Number(r3) < 12) : u3 === "pm" ? e28.map((r3) => Number(r3)).filter((r3) => Number(r3) >= 12).map((r3) => f$g(r3 === 12 ? 12 : r3 - 12)) : e28;
}
function d$g(e28, m3, u3) {
  return u3 ? typeof u3 == "number" ? e28 % u3 === 0 : u3.includes(e28) : true;
}
function g$g(e28, m3, u3) {
  const r3 = N$e(p$2u[m3], u3).map(Number);
  let n3, o3;
  for (let i = 0; i < r3.length; ++i) {
    const t3 = r3[i];
    if (t3 === e28)
      return t3;
    if (t3 > e28) {
      o3 = t3;
      break;
    }
    n3 = t3;
  }
  return n3 === void 0 ? (o3 || t$1P("time-picker", "Please set 'hours' or 'minutes' or 'seconds' props"), o3) : o3 === void 0 || o3 - e28 > e28 - n3 ? n3 : o3;
}
function y$i(e28) {
  return m$k(e28) < 12 ? "am" : "pm";
}
const i$i = n$28("n-time-picker");
const m$e = defineComponent({
  name: "TimePickerPanelCol",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    activeValue: {
      type: Number,
      default: null
    },
    onItemClick: Function
  },
  render() {
    const {
      activeValue: c3,
      onItemClick: t3,
      clsPrefix: e28
    } = this;
    return this.data.map((n3) => {
      const {
        label: i,
        disabled: a3,
        value: l3
      } = n3, r3 = c3 === l3;
      return h$1R("div", {
        key: i,
        "data-active": r3 ? "" : null,
        class: [`${e28}-time-picker-col__item`, r3 && `${e28}-time-picker-col__item--active`, a3 && `${e28}-time-picker-col__item--disabled`],
        onClick: t3 && !a3 ? () => {
          t3(l3);
        } : void 0
      }, i);
    });
  }
});
const B$f = {
  actions: {
    type: Array,
    default: () => ["now", "confirm"]
  },
  showHour: {
    type: Boolean,
    default: true
  },
  showMinute: {
    type: Boolean,
    default: true
  },
  showSecond: {
    type: Boolean,
    default: true
  },
  showPeriod: {
    type: Boolean,
    default: true
  },
  isHourInvalid: Boolean,
  isMinuteInvalid: Boolean,
  isSecondInvalid: Boolean,
  isAmPmInvalid: Boolean,
  isValueInvalid: Boolean,
  hourValue: {
    type: Number,
    default: null
  },
  minuteValue: {
    type: Number,
    default: null
  },
  secondValue: {
    type: Number,
    default: null
  },
  amPmValue: {
    type: String,
    default: null
  },
  isHourDisabled: Function,
  isMinuteDisabled: Function,
  isSecondDisabled: Function,
  onHourClick: {
    type: Function,
    required: true
  },
  onMinuteClick: {
    type: Function,
    required: true
  },
  onSecondClick: {
    type: Function,
    required: true
  },
  onAmPmClick: {
    type: Function,
    required: true
  },
  onNowClick: Function,
  clearText: String,
  nowText: String,
  confirmText: String,
  transitionDisabled: Boolean,
  onClearClick: Function,
  onConfirmClick: Function,
  onFocusin: Function,
  onFocusout: Function,
  onFocusDetectorFocus: Function,
  onKeydown: Function,
  hours: [Number, Array],
  minutes: [Number, Array],
  seconds: [Number, Array],
  use12Hours: Boolean
}, A$b = defineComponent({
  name: "TimePickerPanel",
  props: B$f,
  setup(n3) {
    const {
      mergedThemeRef: u3,
      mergedClsPrefixRef: c3
    } = inject(i$i), d3 = computed(() => {
      const {
        isHourDisabled: t3,
        hours: s3,
        use12Hours: o3,
        amPmValue: r3
      } = n3;
      if (o3) {
        const a3 = r3 != null ? r3 : y$i(Date.now());
        return N$e(p$2u.hours, s3, a3).map((C3) => {
          const k3 = Number(C3), S3 = a3 === "pm" && k3 !== 12 ? k3 + 12 : k3;
          return {
            label: C3,
            value: S3,
            disabled: t3 ? t3(S3) : false
          };
        });
      } else
        return N$e(p$2u.hours, s3).map((a3) => ({
          label: a3,
          value: Number(a3),
          disabled: t3 ? t3(Number(a3)) : false
        }));
    }), e28 = computed(() => {
      const {
        isMinuteDisabled: t3,
        minutes: s3
      } = n3;
      return N$e(p$2u.minutes, s3).map((o3) => ({
        label: o3,
        value: Number(o3),
        disabled: t3 ? t3(Number(o3), n3.hourValue) : false
      }));
    }), l3 = computed(() => {
      const {
        isSecondDisabled: t3,
        seconds: s3
      } = n3;
      return N$e(p$2u.seconds, s3).map((o3) => ({
        label: o3,
        value: Number(o3),
        disabled: t3 ? t3(Number(o3), n3.minuteValue, n3.hourValue) : false
      }));
    }), F3 = computed(() => {
      const {
        isHourDisabled: t3
      } = n3;
      let s3 = true, o3 = true;
      for (let r3 = 0; r3 < 12; ++r3)
        if (!(t3 != null && t3(r3))) {
          s3 = false;
          break;
        }
      for (let r3 = 12; r3 < 24; ++r3)
        if (!(t3 != null && t3(r3))) {
          o3 = false;
          break;
        }
      return [{
        label: "AM",
        value: "am",
        disabled: s3
      }, {
        label: "PM",
        value: "pm",
        disabled: o3
      }];
    });
    return {
      mergedTheme: u3,
      mergedClsPrefix: c3,
      hours: d3,
      minutes: e28,
      seconds: l3,
      amPm: F3,
      hourScrollRef: ref$1(null),
      minuteScrollRef: ref$1(null),
      secondScrollRef: ref$1(null),
      amPmScrollRef: ref$1(null)
    };
  },
  render() {
    var n3, u3, c3, d3;
    const {
      mergedClsPrefix: e28,
      mergedTheme: l3
    } = this;
    return h$1R("div", {
      tabindex: 0,
      class: `${e28}-time-picker-panel`,
      onFocusin: this.onFocusin,
      onFocusout: this.onFocusout,
      onKeydown: this.onKeydown
    }, h$1R("div", {
      class: `${e28}-time-picker-cols`
    }, this.showHour ? h$1R("div", {
      class: [`${e28}-time-picker-col`, this.isHourInvalid && `${e28}-time-picker-col--invalid`, this.transitionDisabled && `${e28}-time-picker-col--transition-disabled`]
    }, h$1R(hn$2, {
      ref: "hourScrollRef",
      theme: l3.peers.Scrollbar,
      themeOverrides: l3.peerOverrides.Scrollbar
    }, {
      default: () => [h$1R(m$e, {
        clsPrefix: e28,
        data: this.hours,
        activeValue: this.hourValue,
        onItemClick: this.onHourClick
      }), h$1R("div", {
        class: `${e28}-time-picker-col__padding`
      })]
    })) : null, this.showMinute ? h$1R("div", {
      class: [`${e28}-time-picker-col`, this.transitionDisabled && `${e28}-time-picker-col--transition-disabled`, this.isMinuteInvalid && `${e28}-time-picker-col--invalid`]
    }, h$1R(hn$2, {
      ref: "minuteScrollRef",
      theme: l3.peers.Scrollbar,
      themeOverrides: l3.peerOverrides.Scrollbar
    }, {
      default: () => [h$1R(m$e, {
        clsPrefix: e28,
        data: this.minutes,
        activeValue: this.minuteValue,
        onItemClick: this.onMinuteClick
      }), h$1R("div", {
        class: `${e28}-time-picker-col__padding`
      })]
    })) : null, this.showSecond ? h$1R("div", {
      class: [`${e28}-time-picker-col`, this.isSecondInvalid && `${e28}-time-picker-col--invalid`, this.transitionDisabled && `${e28}-time-picker-col--transition-disabled`]
    }, h$1R(hn$2, {
      ref: "secondScrollRef",
      theme: l3.peers.Scrollbar,
      themeOverrides: l3.peerOverrides.Scrollbar
    }, {
      default: () => [h$1R(m$e, {
        clsPrefix: e28,
        data: this.seconds,
        activeValue: this.secondValue,
        onItemClick: this.onSecondClick
      }), h$1R("div", {
        class: `${e28}-time-picker-col__padding`
      })]
    })) : null, this.use12Hours ? h$1R("div", {
      class: [`${e28}-time-picker-col`, this.isAmPmInvalid && `${e28}-time-picker-col--invalid`, this.transitionDisabled && `${e28}-time-picker-col--transition-disabled`]
    }, h$1R(hn$2, {
      ref: "amPmScrollRef",
      theme: l3.peers.Scrollbar,
      themeOverrides: l3.peerOverrides.Scrollbar
    }, {
      default: () => [h$1R(m$e, {
        clsPrefix: e28,
        data: this.amPm,
        activeValue: this.amPmValue,
        onItemClick: this.onAmPmClick
      }), h$1R("div", {
        class: `${e28}-time-picker-col__padding`
      })]
    })) : null), !((n3 = this.actions) === null || n3 === void 0) && n3.length ? h$1R("div", {
      class: `${e28}-time-picker-actions`
    }, !((u3 = this.actions) === null || u3 === void 0) && u3.includes("clear") ? h$1R(le$g, {
      theme: l3.peers.Button,
      themeOverrides: l3.peerOverrides.Button,
      size: "tiny",
      onClick: this.onClearClick
    }, {
      default: () => this.clearText
    }) : null, !((c3 = this.actions) === null || c3 === void 0) && c3.includes("now") ? h$1R(le$g, {
      size: "tiny",
      theme: l3.peers.Button,
      themeOverrides: l3.peerOverrides.Button,
      onClick: this.onNowClick
    }, {
      default: () => this.nowText
    }) : null, !((d3 = this.actions) === null || d3 === void 0) && d3.includes("confirm") ? h$1R(le$g, {
      size: "tiny",
      type: "primary",
      class: `${e28}-time-picker-actions__confirm`,
      theme: l3.peers.Button,
      themeOverrides: l3.peerOverrides.Button,
      disabled: this.isValueInvalid,
      onClick: this.onConfirmClick
    }, {
      default: () => this.confirmText
    }) : null) : null, h$1R(u$1l, {
      onFocus: this.onFocusDetectorFocus
    }));
  }
});
const l$i = r$2a([l$25("time-picker", `
 z-index: auto;
 position: relative;
 `, [l$25("time-picker-icon", `
 color: var(--n-icon-color-override);
 transition: color .3s var(--n-bezier);
 `), g$1j("disabled", [l$25("time-picker-icon", `
 color: var(--n-icon-color-disabled-override);
 `)])]), l$25("time-picker-panel", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 font-size: var(--n-item-font-size);
 border-radius: var(--n-border-radius);
 margin: 4px 0;
 min-width: 104px;
 overflow: hidden;
 background-color: var(--n-panel-color);
 box-shadow: var(--n-panel-box-shadow);
 `, [$$n(), l$25("time-picker-actions", `
 padding: var(--n-panel-action-padding);
 align-items: center;
 display: flex;
 justify-content: space-evenly;
 `), l$25("time-picker-cols", `
 height: calc(var(--n-item-height) * 6);
 display: flex;
 position: relative;
 transition: border-color .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-panel-divider-color);
 `), l$25("time-picker-col", `
 flex-grow: 1;
 min-width: var(--n-item-width);
 height: calc(var(--n-item-height) * 6);
 flex-direction: column;
 transition: box-shadow .3s var(--n-bezier);
 `, [g$1j("transition-disabled", [M$y("item", "transition: none;", [r$2a("&::before", "transition: none;")])]), M$y("padding", `
 height: calc(var(--n-item-height) * 5);
 `), r$2a("&:first-child", "min-width: calc(var(--n-item-width) + 4px);", [M$y("item", [r$2a("&::before", "left: 4px;")])]), M$y("item", `
 cursor: pointer;
 height: var(--n-item-height);
 display: flex;
 align-items: center;
 justify-content: center;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 text-decoration-color .3s var(--n-bezier);
 background: #0000;
 text-decoration-color: #0000;
 color: var(--n-item-text-color);
 z-index: 0;
 box-sizing: border-box;
 padding-top: 4px;
 position: relative;
 `, [r$2a("&::before", `
 content: "";
 transition: background-color .3s var(--n-bezier);
 z-index: -1;
 position: absolute;
 left: 0;
 right: 4px;
 top: 4px;
 bottom: 0;
 border-radius: var(--n-item-border-radius);
 `), x$I("disabled", [r$2a("&:hover::before", `
 background-color: var(--n-item-color-hover);
 `)]), g$1j("active", `
 color: var(--n-item-text-color-active);
 `, [r$2a("&::before", `
 background-color: var(--n-item-color-hover);
 `)]), g$1j("disabled", `
 opacity: var(--n-item-opacity-disabled);
 cursor: not-allowed;
 `)]), g$1j("invalid", [M$y("item", [g$1j("active", `
 text-decoration: line-through;
 text-decoration-color: var(--n-item-text-color-active);
 `)])])])])]);
const r$q = f$1z("time", h$1R("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, h$1R("path", {
  d: "M256,64C150,64,64,150,64,256s86,192,192,192,192-86,192-192S362,64,256,64Z",
  style: `
        fill: none;
        stroke: currentColor;
        stroke-miterlimit: 10;
        stroke-width: 32px;
      `
}), h$1R("polyline", {
  points: "256 128 256 272 352 272",
  style: `
        fill: none;
        stroke: currentColor;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 32px;
      `
})));
const t$d = {
  itemFontSize: "12px",
  itemHeight: "36px",
  itemWidth: "52px",
  panelActionPadding: "8px 0"
};
const g$f = (r3) => {
  const {
    popoverColor: t3,
    textColor2: e28,
    primaryColor: i,
    hoverColor: m3,
    dividerColor: l3,
    opacityDisabled: a3,
    boxShadow2: c3,
    borderRadius: o3,
    iconColor: n3,
    iconColorDisabled: p3
  } = r3;
  return Object.assign(Object.assign({}, t$d), {
    panelColor: t3,
    panelBoxShadow: c3,
    panelDividerColor: l3,
    itemTextColor: e28,
    itemTextColorActive: i,
    itemColorHover: m3,
    itemOpacityDisabled: a3,
    itemBorderRadius: o3,
    borderRadius: o3,
    iconColor: n3,
    iconColorDisabled: p3
  });
}, u$h = G$w({
  name: "TimePicker",
  common: d$1T,
  peers: {
    Scrollbar: n$1N,
    Button: B$P,
    Input: k$H
  },
  self: g$f
}), y$h = u$h;
function n$f(t3, o3) {
  n$u(2, arguments);
  var r3 = a$S(t3), e28 = n$t(o3);
  return r3.setHours(e28), r3;
}
function s$e(t3) {
  n$u(1, arguments);
  var r3 = a$S(t3);
  return r3.setMinutes(0, 0, 0), r3;
}
function f$f(r3, e28) {
  n$u(2, arguments);
  var t3 = a$S(r3), o3 = n$t(e28);
  return t3.setMinutes(o3), t3;
}
function s$d(r3) {
  n$u(1, arguments);
  var t3 = a$S(r3);
  return t3.setSeconds(0, 0), t3;
}
function i$h(e28, t3) {
  n$u(2, arguments);
  var r3 = a$S(e28), o3 = n$t(t3);
  return r3.setSeconds(o3), r3;
}
function l$h(e28) {
  n$u(1, arguments);
  var r3 = a$S(e28), t3 = r3.getMilliseconds();
  return t3;
}
function W$4(n3, T3) {
  return n3 === void 0 ? true : Array.isArray(n3) ? n3.every((d3) => d3 >= 0 && d3 <= T3) : n3 >= 0 && n3 <= T3;
}
const $t$2 = Object.assign(Object.assign({}, _$F.props), {
  to: f$1m.propTo,
  bordered: {
    type: Boolean,
    default: void 0
  },
  actions: Array,
  defaultValue: {
    type: Number,
    default: null
  },
  defaultFormattedValue: String,
  placeholder: String,
  placement: {
    type: String,
    default: "bottom-start"
  },
  value: Number,
  format: {
    type: String,
    default: "HH:mm:ss"
  },
  valueFormat: String,
  formattedValue: String,
  isHourDisabled: Function,
  size: String,
  isMinuteDisabled: Function,
  isSecondDisabled: Function,
  inputReadonly: Boolean,
  clearable: Boolean,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onUpdateFormattedValue: [Function, Array],
  "onUpdate:formattedValue": [Function, Array],
  onBlur: [Function, Array],
  onConfirm: [Function, Array],
  onClear: Function,
  onFocus: [Function, Array],
  timeZone: String,
  showIcon: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  show: {
    type: Boolean,
    default: void 0
  },
  hours: {
    type: [Number, Array],
    validator: (n3) => W$4(n3, 23)
  },
  minutes: {
    type: [Number, Array],
    validator: (n3) => W$4(n3, 59)
  },
  seconds: {
    type: [Number, Array],
    validator: (n3) => W$4(n3, 59)
  },
  use12Hours: Boolean,
  stateful: {
    type: Boolean,
    default: true
  },
  onChange: [Function, Array]
}), xn$1 = defineComponent({
  name: "TimePicker",
  props: $t$2,
  setup(n3) {
    const {
      mergedBorderedRef: T3,
      mergedClsPrefixRef: d3,
      namespaceRef: k3,
      inlineThemeDisabled: A3
    } = a$2x(n3), {
      localeRef: D3,
      dateLocaleRef: ge2
    } = R$p("TimePicker"), H3 = h$1B(n3), {
      mergedSizeRef: pe2,
      mergedDisabledRef: M3,
      mergedStatusRef: Te2
    } = H3, x3 = _$F("TimePicker", "-time-picker", l$i, y$h, n3, d3), Fe2 = B$x(), b3 = ref$1(null), I3 = ref$1(null), F3 = computed(() => ({
      locale: ge2.value.locale
    }));
    function J3(e28) {
      return e28 === null ? null : St$2(e28, n3.valueFormat || n3.format, /* @__PURE__ */ new Date(), F3.value).getTime();
    }
    const {
      defaultValue: Ce2,
      defaultFormattedValue: Q3
    } = n3, N3 = ref$1(Q3 !== void 0 ? J3(Q3) : Ce2), r3 = computed(() => {
      const {
        formattedValue: e28
      } = n3;
      if (e28 !== void 0)
        return J3(e28);
      const {
        value: t3
      } = n3;
      return t3 !== void 0 ? t3 : N3.value;
    }), S3 = computed(() => {
      const {
        timeZone: e28
      } = n3;
      return e28 ? (t3, i, o3) => d$h(t3, e28, i, o3) : (t3, i, o3) => de$4(t3, i, o3);
    }), P3 = ref$1("");
    watch(() => n3.timeZone, () => {
      const e28 = r3.value;
      P3.value = e28 === null ? "" : S3.value(e28, n3.format, F3.value);
    }, {
      immediate: true
    });
    const X3 = ref$1(false), Ve2 = toRef$1(n3, "show"), m3 = d$1S(Ve2, X3), U3 = ref$1(r3.value), O3 = ref$1(false), be2 = computed(() => D3.value.clear), Ie2 = computed(() => D3.value.now), Se2 = computed(() => n3.placeholder !== void 0 ? n3.placeholder : D3.value.placeholder), we2 = computed(() => D3.value.negativeText), Re2 = computed(() => D3.value.positiveText), ye2 = computed(() => /H|h|K|k/.test(n3.format)), ke2 = computed(() => n3.format.includes("m")), De2 = computed(() => n3.format.includes("s")), Y3 = computed(() => {
      const {
        isHourDisabled: e28
      } = n3;
      return w3.value === null ? false : d$g(w3.value, "hours", n3.hours) ? e28 ? e28(w3.value) : false : true;
    }), ee2 = computed(() => {
      const {
        value: e28
      } = _3, {
        value: t3
      } = w3;
      if (e28 === null || t3 === null)
        return false;
      if (!d$g(e28, "minutes", n3.minutes))
        return true;
      const {
        isMinuteDisabled: i
      } = n3;
      return i ? i(e28, t3) : false;
    }), te2 = computed(() => {
      const {
        value: e28
      } = _3, {
        value: t3
      } = w3, {
        value: i
      } = ie2;
      if (i === null || e28 === null || t3 === null)
        return false;
      if (!d$g(i, "seconds", n3.seconds))
        return true;
      const {
        isSecondDisabled: o3
      } = n3;
      return o3 ? o3(i, e28, t3) : false;
    }), ne2 = computed(() => Y3.value || ee2.value || te2.value), Pe2 = computed(() => n3.format.length + 4), ze2 = computed(() => {
      const {
        value: e28
      } = r3;
      return e28 === null ? null : m$k(e28) < 12 ? "am" : "pm";
    }), w3 = computed(() => {
      const {
        value: e28
      } = r3;
      return e28 === null ? null : Number(S3.value(e28, "HH", F3.value));
    }), _3 = computed(() => {
      const {
        value: e28
      } = r3;
      return e28 === null ? null : Number(S3.value(e28, "mm", F3.value));
    }), ie2 = computed(() => {
      const {
        value: e28
      } = r3;
      return e28 === null ? null : Number(S3.value(e28, "ss", F3.value));
    });
    function Ae2(e28, t3) {
      const {
        onUpdateFormattedValue: i,
        "onUpdate:formattedValue": o3
      } = n3;
      i && i$1Z(i, e28, t3), o3 && i$1Z(o3, e28, t3);
    }
    function oe2(e28) {
      return e28 === null ? null : S3.value(e28, n3.valueFormat || n3.format);
    }
    function a3(e28) {
      const {
        onUpdateValue: t3,
        "onUpdate:value": i,
        onChange: o3
      } = n3, {
        nTriggerFormChange: h3,
        nTriggerFormInput: v3
      } = H3, u3 = oe2(e28);
      t3 && i$1Z(t3, e28, u3), i && i$1Z(i, e28, u3), o3 && i$1Z(o3, e28, u3), Ae2(u3, e28), N3.value = e28, h3(), v3();
    }
    function He2(e28) {
      const {
        onFocus: t3
      } = n3, {
        nTriggerFormFocus: i
      } = H3;
      t3 && i$1Z(t3, e28), i();
    }
    function E3(e28) {
      const {
        onBlur: t3
      } = n3, {
        nTriggerFormBlur: i
      } = H3;
      t3 && i$1Z(t3, e28), i();
    }
    function Me2() {
      const {
        onConfirm: e28
      } = n3;
      e28 && i$1Z(e28, r3.value, oe2(r3.value));
    }
    function xe2(e28) {
      var t3;
      e28.stopPropagation(), a3(null), p3(null), (t3 = n3.onClear) === null || t3 === void 0 || t3.call(n3);
    }
    function Be2() {
      f3({
        returnFocus: true
      });
    }
    function Ne2() {
      a3(null), p3(null), f3({
        returnFocus: true
      });
    }
    function Ue2(e28) {
      e28.key === "Escape" && m3.value && n$1D(e28);
    }
    function Oe2(e28) {
      var t3;
      switch (e28.key) {
        case "Escape":
          m3.value && (n$1D(e28), f3({
            returnFocus: true
          }));
          break;
        case "Tab":
          Fe2.shift && e28.target === ((t3 = I3.value) === null || t3 === void 0 ? void 0 : t3.$el) && (e28.preventDefault(), f3({
            returnFocus: true
          }));
          break;
      }
    }
    function _e2() {
      O3.value = true, nextTick(() => {
        O3.value = false;
      });
    }
    function Ee2(e28) {
      M3.value || a$2j(e28, "clear") || m3.value || le2();
    }
    function Ke2(e28) {
      typeof e28 != "string" && (r3.value === null ? a3(u$o(n$f(s$e(/* @__PURE__ */ new Date()), e28))) : a3(u$o(n$f(r3.value, e28))));
    }
    function je2(e28) {
      typeof e28 != "string" && (r3.value === null ? a3(u$o(f$f(s$d(/* @__PURE__ */ new Date()), e28))) : a3(u$o(f$f(r3.value, e28))));
    }
    function $e2(e28) {
      typeof e28 != "string" && (r3.value === null ? a3(u$o(i$h(i$n(/* @__PURE__ */ new Date()), e28))) : a3(u$o(i$h(r3.value, e28))));
    }
    function Ze2(e28) {
      const {
        value: t3
      } = r3;
      if (t3 === null) {
        const i = /* @__PURE__ */ new Date(), o3 = m$k(i);
        e28 === "pm" && o3 < 12 ? a3(u$o(n$f(i, o3 + 12))) : e28 === "am" && o3 >= 12 && a3(u$o(n$f(i, o3 - 12))), a3(u$o(i));
      } else {
        const i = m$k(t3);
        e28 === "pm" && i < 12 ? a3(u$o(n$f(t3, i + 12))) : e28 === "am" && i >= 12 && a3(u$o(n$f(t3, i - 12)));
      }
    }
    function p3(e28) {
      e28 === void 0 && (e28 = r3.value), e28 === null ? P3.value = "" : P3.value = S3.value(e28, n3.format, F3.value);
    }
    function Le2(e28) {
      j3(e28) || He2(e28);
    }
    function qe2(e28) {
      var t3;
      if (!j3(e28))
        if (m3.value) {
          const i = (t3 = I3.value) === null || t3 === void 0 ? void 0 : t3.$el;
          i != null && i.contains(e28.relatedTarget) || (p3(), E3(e28), f3({
            returnFocus: false
          }));
        } else
          p3(), E3(e28);
    }
    function We2() {
      M3.value || m3.value || le2();
    }
    function Ge2() {
      M3.value || (p3(), f3({
        returnFocus: false
      }));
    }
    function re2() {
      if (!I3.value)
        return;
      const {
        hourScrollRef: e28,
        minuteScrollRef: t3,
        secondScrollRef: i,
        amPmScrollRef: o3
      } = I3.value;
      [e28, t3, i, o3].forEach((h3) => {
        var v3;
        if (!h3)
          return;
        const u3 = (v3 = h3.contentRef) === null || v3 === void 0 ? void 0 : v3.querySelector("[data-active]");
        u3 && h3.scrollTo({
          top: u3.offsetTop
        });
      });
    }
    function K3(e28) {
      X3.value = e28;
      const {
        onUpdateShow: t3,
        "onUpdate:show": i
      } = n3;
      t3 && i$1Z(t3, e28), i && i$1Z(i, e28);
    }
    function j3(e28) {
      var t3, i, o3;
      return !!(!((i = (t3 = b3.value) === null || t3 === void 0 ? void 0 : t3.wrapperElRef) === null || i === void 0) && i.contains(e28.relatedTarget) || !((o3 = I3.value) === null || o3 === void 0) && o3.$el.contains(e28.relatedTarget));
    }
    function le2() {
      U3.value = r3.value, K3(true), nextTick(re2);
    }
    function Je2(e28) {
      var t3, i;
      m3.value && !(!((i = (t3 = b3.value) === null || t3 === void 0 ? void 0 : t3.wrapperElRef) === null || i === void 0) && i.contains(t$1G(e28))) && f3({
        returnFocus: false
      });
    }
    function f3({
      returnFocus: e28
    }) {
      var t3;
      m3.value && (K3(false), e28 && ((t3 = b3.value) === null || t3 === void 0 || t3.focus()));
    }
    function Qe2(e28) {
      if (e28 === "") {
        a3(null);
        return;
      }
      const t3 = St$2(e28, n3.format, /* @__PURE__ */ new Date(), F3.value);
      if (P3.value = e28, u$r(t3)) {
        const {
          value: i
        } = r3;
        if (i !== null) {
          const o3 = u$k(i, {
            hours: m$k(t3),
            minutes: o$h(t3),
            seconds: d$l(t3),
            milliseconds: l$h(t3)
          });
          a3(u$o(o3));
        } else
          a3(u$o(t3));
      }
    }
    function Xe2() {
      a3(U3.value), K3(false);
    }
    function Ye2() {
      const e28 = /* @__PURE__ */ new Date(), t3 = {
        hours: m$k,
        minutes: o$h,
        seconds: d$l
      }, [i, o3, h3] = ["hours", "minutes", "seconds"].map((u3) => !n3[u3] || d$g(t3[u3](e28), u3, n3[u3]) ? t3[u3](e28) : g$g(t3[u3](e28), u3, n3[u3])), v3 = i$h(f$f(n$f(r3.value ? r3.value : u$o(e28), i), o3), h3);
      a3(u$o(v3));
    }
    function et2() {
      p3(), Me2(), f3({
        returnFocus: true
      });
    }
    function tt2(e28) {
      j3(e28) || (p3(), E3(e28), f3({
        returnFocus: false
      }));
    }
    watch(r3, (e28) => {
      p3(e28), _e2(), nextTick(re2);
    }), watch(m3, () => {
      ne2.value && a3(U3.value);
    }), provide(i$i, {
      mergedThemeRef: x3,
      mergedClsPrefixRef: d3
    });
    const ae2 = {
      focus: () => {
        var e28;
        (e28 = b3.value) === null || e28 === void 0 || e28.focus();
      },
      blur: () => {
        var e28;
        (e28 = b3.value) === null || e28 === void 0 || e28.blur();
      }
    }, ue2 = computed(() => {
      const {
        common: {
          cubicBezierEaseInOut: e28
        },
        self: {
          iconColor: t3,
          iconColorDisabled: i
        }
      } = x3.value;
      return {
        "--n-icon-color-override": t3,
        "--n-icon-color-disabled-override": i,
        "--n-bezier": e28
      };
    }), R3 = A3 ? E$J("time-picker-trigger", void 0, ue2, n3) : void 0, se2 = computed(() => {
      const {
        self: {
          panelColor: e28,
          itemTextColor: t3,
          itemTextColorActive: i,
          itemColorHover: o3,
          panelDividerColor: h3,
          panelBoxShadow: v3,
          itemOpacityDisabled: u3,
          borderRadius: nt2,
          itemFontSize: it2,
          itemWidth: ot2,
          itemHeight: rt2,
          panelActionPadding: lt2,
          itemBorderRadius: at2
        },
        common: {
          cubicBezierEaseInOut: ut2
        }
      } = x3.value;
      return {
        "--n-bezier": ut2,
        "--n-border-radius": nt2,
        "--n-item-color-hover": o3,
        "--n-item-font-size": it2,
        "--n-item-height": rt2,
        "--n-item-opacity-disabled": u3,
        "--n-item-text-color": t3,
        "--n-item-text-color-active": i,
        "--n-item-width": ot2,
        "--n-panel-action-padding": lt2,
        "--n-panel-box-shadow": v3,
        "--n-panel-color": e28,
        "--n-panel-divider-color": h3,
        "--n-item-border-radius": at2
      };
    }), y3 = A3 ? E$J("time-picker", void 0, se2, n3) : void 0;
    return {
      focus: ae2.focus,
      blur: ae2.blur,
      mergedStatus: Te2,
      mergedBordered: T3,
      mergedClsPrefix: d3,
      namespace: k3,
      uncontrolledValue: N3,
      mergedValue: r3,
      isMounted: u$1C(),
      inputInstRef: b3,
      panelInstRef: I3,
      adjustedTo: f$1m(n3),
      mergedShow: m3,
      localizedClear: be2,
      localizedNow: Ie2,
      localizedPlaceholder: Se2,
      localizedNegativeText: we2,
      localizedPositiveText: Re2,
      hourInFormat: ye2,
      minuteInFormat: ke2,
      secondInFormat: De2,
      mergedAttrSize: Pe2,
      displayTimeString: P3,
      mergedSize: pe2,
      mergedDisabled: M3,
      isValueInvalid: ne2,
      isHourInvalid: Y3,
      isMinuteInvalid: ee2,
      isSecondInvalid: te2,
      transitionDisabled: O3,
      hourValue: w3,
      minuteValue: _3,
      secondValue: ie2,
      amPmValue: ze2,
      handleInputKeydown: Ue2,
      handleTimeInputFocus: Le2,
      handleTimeInputBlur: qe2,
      handleNowClick: Ye2,
      handleConfirmClick: et2,
      handleTimeInputUpdateValue: Qe2,
      handleMenuFocusOut: tt2,
      handleCancelClick: Xe2,
      handleClickOutside: Je2,
      handleTimeInputActivate: We2,
      handleTimeInputDeactivate: Ge2,
      handleHourClick: Ke2,
      handleMinuteClick: je2,
      handleSecondClick: $e2,
      handleAmPmClick: Ze2,
      handleTimeInputClear: xe2,
      handleFocusDetectorFocus: Be2,
      handleMenuKeydown: Oe2,
      handleTriggerClick: Ee2,
      mergedTheme: x3,
      triggerCssVars: A3 ? void 0 : ue2,
      triggerThemeClass: R3 == null ? void 0 : R3.themeClass,
      triggerOnRender: R3 == null ? void 0 : R3.onRender,
      cssVars: A3 ? void 0 : se2,
      themeClass: y3 == null ? void 0 : y3.themeClass,
      onRender: y3 == null ? void 0 : y3.onRender,
      clearSelectedValue: Ne2
    };
  },
  render() {
    const {
      mergedClsPrefix: n3,
      $slots: T3,
      triggerOnRender: d3
    } = this;
    return d3 == null || d3(), h$1R("div", {
      class: [`${n3}-time-picker`, this.triggerThemeClass],
      style: this.triggerCssVars
    }, h$1R(F$x, null, {
      default: () => [h$1R(g$19, null, {
        default: () => h$1R(Zn$3, {
          ref: "inputInstRef",
          status: this.mergedStatus,
          value: this.displayTimeString,
          bordered: this.mergedBordered,
          passivelyActivated: true,
          attrSize: this.mergedAttrSize,
          theme: this.mergedTheme.peers.Input,
          themeOverrides: this.mergedTheme.peerOverrides.Input,
          stateful: this.stateful,
          size: this.mergedSize,
          placeholder: this.localizedPlaceholder,
          clearable: this.clearable,
          disabled: this.mergedDisabled,
          textDecoration: this.isValueInvalid ? "line-through" : void 0,
          onFocus: this.handleTimeInputFocus,
          onBlur: this.handleTimeInputBlur,
          onActivate: this.handleTimeInputActivate,
          onDeactivate: this.handleTimeInputDeactivate,
          onUpdateValue: this.handleTimeInputUpdateValue,
          onClear: this.handleTimeInputClear,
          internalDeactivateOnEnter: true,
          internalForceFocus: this.mergedShow,
          readonly: this.inputReadonly || this.mergedDisabled,
          onClick: this.handleTriggerClick,
          onKeydown: this.handleInputKeydown
        }, this.showIcon ? {
          [this.clearable ? "clear-icon-placeholder" : "suffix"]: () => h$1R(d$1R, {
            clsPrefix: n3,
            class: `${n3}-time-picker-icon`
          }, {
            default: () => T3.icon ? T3.icon() : h$1R(r$q, null)
          })
        } : null)
      }), h$1R(me$h, {
        teleportDisabled: this.adjustedTo === f$1m.tdkey,
        show: this.mergedShow,
        to: this.adjustedTo,
        containerClass: this.namespace,
        placement: this.placement
      }, {
        default: () => h$1R(Transition, {
          name: "fade-in-scale-up-transition",
          appear: this.isMounted
        }, {
          default: () => {
            var k3;
            return this.mergedShow ? ((k3 = this.onRender) === null || k3 === void 0 || k3.call(this), withDirectives(h$1R(A$b, {
              ref: "panelInstRef",
              actions: this.actions,
              class: this.themeClass,
              style: this.cssVars,
              seconds: this.seconds,
              minutes: this.minutes,
              hours: this.hours,
              transitionDisabled: this.transitionDisabled,
              hourValue: this.hourValue,
              showHour: this.hourInFormat,
              isHourInvalid: this.isHourInvalid,
              isHourDisabled: this.isHourDisabled,
              minuteValue: this.minuteValue,
              showMinute: this.minuteInFormat,
              isMinuteInvalid: this.isMinuteInvalid,
              isMinuteDisabled: this.isMinuteDisabled,
              secondValue: this.secondValue,
              amPmValue: this.amPmValue,
              showSecond: this.secondInFormat,
              isSecondInvalid: this.isSecondInvalid,
              isSecondDisabled: this.isSecondDisabled,
              isValueInvalid: this.isValueInvalid,
              clearText: this.localizedClear,
              nowText: this.localizedNow,
              confirmText: this.localizedPositiveText,
              use12Hours: this.use12Hours,
              onFocusout: this.handleMenuFocusOut,
              onKeydown: this.handleMenuKeydown,
              onHourClick: this.handleHourClick,
              onMinuteClick: this.handleMinuteClick,
              onSecondClick: this.handleSecondClick,
              onAmPmClick: this.handleAmPmClick,
              onNowClick: this.handleNowClick,
              onConfirmClick: this.handleConfirmClick,
              onClearClick: this.clearSelectedValue,
              onFocusDetectorFocus: this.handleFocusDetectorFocus
            }), [[a$2i, this.handleClickOutside, void 0, {
              capture: true
            }]])) : null;
          }
        })
      })]
    }));
  }
});
const I$b = defineComponent({
  name: "DateTimePanel",
  props: va$2,
  setup(s3) {
    return ma$2(s3, "datetime");
  },
  render() {
    var s3, d3, c3, h3;
    const {
      mergedClsPrefix: t3,
      mergedTheme: i,
      shortcuts: n3,
      timePickerProps: m3,
      onRender: u3,
      $slots: r3
    } = this;
    return u3 == null || u3(), h$1R("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${t3}-date-panel`, `${t3}-date-panel--datetime`, !this.panel && `${t3}-date-panel--shadow`, this.themeClass],
      onKeydown: this.handlePanelKeyDown,
      onFocus: this.handlePanelFocus
    }, h$1R("div", {
      class: `${t3}-date-panel-header`
    }, h$1R(Zn$3, {
      value: this.dateInputValue,
      theme: i.peers.Input,
      themeOverrides: i.peerOverrides.Input,
      stateful: false,
      size: this.timePickerSize,
      class: `${t3}-date-panel-date-input`,
      textDecoration: this.isDateInvalid ? "line-through" : "",
      placeholder: this.locale.selectDate,
      onBlur: this.handleDateInputBlur,
      onUpdateValue: this.handleDateInput
    }), h$1R(xn$1, Object.assign({
      size: this.timePickerSize,
      placeholder: this.locale.selectTime,
      format: this.timeFormat
    }, Array.isArray(m3) ? void 0 : m3, {
      showIcon: false,
      to: false,
      theme: i.peers.TimePicker,
      themeOverrides: i.peerOverrides.TimePicker,
      value: Array.isArray(this.value) ? null : this.value,
      isHourDisabled: this.isHourDisabled,
      isMinuteDisabled: this.isMinuteDisabled,
      isSecondDisabled: this.isSecondDisabled,
      onUpdateValue: this.handleTimePickerChange,
      stateful: false
    }))), h$1R("div", {
      class: `${t3}-date-panel-calendar`
    }, h$1R("div", {
      class: `${t3}-date-panel-month`
    }, h$1R("div", {
      class: `${t3}-date-panel-month__fast-prev`,
      onClick: this.prevYear
    }, p$3H(r3["prev-year"], () => [h$1R(n$12, null)])), h$1R("div", {
      class: `${t3}-date-panel-month__prev`,
      onClick: this.prevMonth
    }, p$3H(r3["prev-month"], () => [h$1R(o$15, null)])), h$1R(q$9, {
      monthBeforeYear: this.locale.monthBeforeYear,
      value: this.calendarValue,
      onUpdateValue: this.onUpdateCalendarValue,
      mergedClsPrefix: t3,
      calendarMonth: this.calendarMonth,
      calendarYear: this.calendarYear
    }), h$1R("div", {
      class: `${t3}-date-panel-month__next`,
      onClick: this.nextMonth
    }, p$3H(r3["next-month"], () => [h$1R(n$14, null)])), h$1R("div", {
      class: `${t3}-date-panel-month__fast-next`,
      onClick: this.nextYear
    }, p$3H(r3["next-year"], () => [h$1R(n$13, null)]))), h$1R("div", {
      class: `${t3}-date-panel-weekdays`
    }, this.weekdays.map((a3) => h$1R("div", {
      key: a3,
      class: `${t3}-date-panel-weekdays__day`
    }, a3))), h$1R("div", {
      class: `${t3}-date-panel-dates`
    }, this.dateArray.map((a3, l3) => h$1R("div", {
      "data-n-date": true,
      key: l3,
      class: [`${t3}-date-panel-date`, {
        [`${t3}-date-panel-date--current`]: a3.isCurrentDate,
        [`${t3}-date-panel-date--selected`]: a3.selected,
        [`${t3}-date-panel-date--excluded`]: !a3.inCurrentMonth,
        [`${t3}-date-panel-date--disabled`]: this.mergedIsDateDisabled(a3.ts, {
          type: "date",
          year: a3.dateObject.year,
          month: a3.dateObject.month,
          date: a3.dateObject.date
        })
      }],
      onClick: () => {
        this.handleDateClick(a3);
      }
    }, h$1R("div", {
      class: `${t3}-date-panel-date__trigger`
    }), a3.dateObject.date, a3.isCurrentDate ? h$1R("div", {
      class: `${t3}-date-panel-date__sup`
    }) : null)))), this.datePickerSlots.footer ? h$1R("div", {
      class: `${t3}-date-panel-footer`
    }, this.datePickerSlots.footer()) : null, !((s3 = this.actions) === null || s3 === void 0) && s3.length || n3 ? h$1R("div", {
      class: `${t3}-date-panel-actions`
    }, h$1R("div", {
      class: `${t3}-date-panel-actions__prefix`
    }, n3 && Object.keys(n3).map((a3) => {
      const l3 = n3[a3];
      return Array.isArray(l3) ? null : h$1R(ie$h, {
        size: "tiny",
        onMouseenter: () => {
          this.handleSingleShortcutMouseenter(l3);
        },
        onClick: () => {
          this.handleSingleShortcutClick(l3);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => a3
      });
    })), h$1R("div", {
      class: `${t3}-date-panel-actions__suffix`
    }, !((d3 = this.actions) === null || d3 === void 0) && d3.includes("clear") ? h$1R(le$g, {
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      size: "tiny",
      onClick: this.clearSelectedDateTime
    }, {
      default: () => this.locale.clear
    }) : null, !((c3 = this.actions) === null || c3 === void 0) && c3.includes("now") ? h$1R(le$g, {
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleNowClick
    }, {
      default: () => this.locale.now
    }) : null, !((h3 = this.actions) === null || h3 === void 0) && h3.includes("confirm") ? h$1R(le$g, {
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      size: "tiny",
      type: "primary",
      disabled: this.isDateInvalid,
      onClick: this.handleConfirmClick
    }, {
      default: () => this.locale.confirm
    }) : null)) : null, h$1R(u$1l, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
const Ka$2 = Object.assign(Object.assign({}, w$a), {
  defaultCalendarStartTime: Number,
  defaultCalendarEndTime: Number,
  bindCalendarMonths: Boolean,
  actions: {
    type: Array,
    default: () => ["clear", "confirm"]
  }
});
function Ja$2(n3, R3) {
  var z3, H3;
  const {
    isDateDisabledRef: J3,
    isStartHourDisabledRef: Ae2,
    isEndHourDisabledRef: Re2,
    isStartMinuteDisabledRef: Ce2,
    isEndMinuteDisabledRef: Se2,
    isStartSecondDisabledRef: ge2,
    isEndSecondDisabledRef: Ve2,
    isStartDateInvalidRef: be2,
    isEndDateInvalidRef: Te2,
    isStartTimeInvalidRef: we2,
    isEndTimeInvalidRef: Fe2,
    isStartValueInvalidRef: Oe2,
    isEndValueInvalidRef: Me2,
    isRangeInvalidRef: X3,
    localeRef: g3,
    rangesRef: Z3,
    closeOnSelectRef: Ee2,
    updateValueOnCloseRef: Pe2,
    firstDayOfWeekRef: $3,
    datePickerSlots: Ie2,
    monthFormatRef: p3,
    yearFormatRef: ee2,
    quarterFormatRef: ae2
  } = inject(c$L), Ye2 = {
    isDateDisabled: J3,
    isStartHourDisabled: Ae2,
    isEndHourDisabled: Re2,
    isStartMinuteDisabled: Ce2,
    isEndMinuteDisabled: Se2,
    isStartSecondDisabled: ge2,
    isEndSecondDisabled: Ve2,
    isStartDateInvalid: be2,
    isEndDateInvalid: Te2,
    isStartTimeInvalid: we2,
    isEndTimeInvalid: Fe2,
    isStartValueInvalid: Oe2,
    isEndValueInvalid: Me2,
    isRangeInvalid: X3
  }, r3 = z$6(n3), ke2 = ref$1(null), xe2 = ref$1(null), te2 = ref$1(null), ne2 = ref$1(null), k3 = ref$1(null), x3 = ref$1(null), N3 = ref$1(null), Q3 = ref$1(null), {
    value: C3
  } = n3, re2 = (z3 = n3.defaultCalendarStartTime) !== null && z3 !== void 0 ? z3 : Array.isArray(C3) && typeof C3[0] == "number" ? C3[0] : Date.now(), o3 = ref$1(re2), s3 = ref$1((H3 = n3.defaultCalendarEndTime) !== null && H3 !== void 0 ? H3 : Array.isArray(C3) && typeof C3[1] == "number" ? C3[1] : u$o(h$A(re2, 1)));
  h3(true);
  const V10 = ref$1(Date.now()), b3 = ref$1(false), I3 = ref$1(0), S3 = computed(() => n3.dateFormat || g3.value.dateFormat), O3 = ref$1(Array.isArray(C3) ? de$4(C3[0], S3.value, r3.dateFnsOptions.value) : ""), M3 = ref$1(Array.isArray(C3) ? de$4(C3[1], S3.value, r3.dateFnsOptions.value) : ""), _e2 = computed(() => b3.value ? "end" : "start"), le2 = computed(() => {
    var e28;
    return mt$3(o3.value, n3.value, V10.value, (e28 = $3.value) !== null && e28 !== void 0 ? e28 : g3.value.firstDayOfWeek);
  }), je2 = computed(() => {
    var e28;
    return mt$3(s3.value, n3.value, V10.value, (e28 = $3.value) !== null && e28 !== void 0 ? e28 : g3.value.firstDayOfWeek);
  }), Ue2 = computed(() => le2.value.slice(0, 7).map((e28) => {
    const {
      ts: a3
    } = e28;
    return de$4(a3, g3.value.dayFormat, r3.dateFnsOptions.value);
  })), qe2 = computed(() => de$4(o3.value, g3.value.monthFormat, r3.dateFnsOptions.value)), ze2 = computed(() => de$4(s3.value, g3.value.monthFormat, r3.dateFnsOptions.value)), He2 = computed(() => de$4(o3.value, g3.value.yearFormat, r3.dateFnsOptions.value)), Ne2 = computed(() => de$4(s3.value, g3.value.yearFormat, r3.dateFnsOptions.value)), Qe2 = computed(() => {
    const {
      value: e28
    } = n3;
    return Array.isArray(e28) ? e28[0] : null;
  }), We2 = computed(() => {
    const {
      value: e28
    } = n3;
    return Array.isArray(e28) ? e28[1] : null;
  }), Be2 = computed(() => {
    const {
      shortcuts: e28
    } = n3;
    return e28 || Z3.value;
  }), Le2 = computed(() => yt$3(At$2(n3.value, "start"), V10.value, {
    yearFormat: ee2.value
  })), Ge2 = computed(() => yt$3(At$2(n3.value, "end"), V10.value, {
    yearFormat: ee2.value
  })), Ke2 = computed(() => {
    const e28 = At$2(n3.value, "start");
    return ht$2(e28 != null ? e28 : Date.now(), e28, V10.value, {
      quarterFormat: ae2.value
    });
  }), Je2 = computed(() => {
    const e28 = At$2(n3.value, "end");
    return ht$2(e28 != null ? e28 : Date.now(), e28, V10.value, {
      quarterFormat: ae2.value
    });
  }), Xe2 = computed(() => {
    const e28 = At$2(n3.value, "start");
    return lt$2(e28 != null ? e28 : Date.now(), e28, V10.value, {
      monthFormat: p3.value
    });
  }), Ze2 = computed(() => {
    const e28 = At$2(n3.value, "end");
    return lt$2(e28 != null ? e28 : Date.now(), e28, V10.value, {
      monthFormat: p3.value
    });
  });
  watch(computed(() => n3.value), (e28) => {
    if (e28 !== null && Array.isArray(e28)) {
      const [a3, t3] = e28;
      O3.value = de$4(a3, S3.value, r3.dateFnsOptions.value), M3.value = de$4(t3, S3.value, r3.dateFnsOptions.value), b3.value || sa2(e28);
    } else
      O3.value = "", M3.value = "";
  });
  function ue2(e28, a3) {
    (R3 === "daterange" || R3 === "datetimerange") && (u$m(e28) !== u$m(a3) || u$p(e28) !== u$p(a3)) && r3.disableTransitionOneTick();
  }
  watch(o3, ue2), watch(s3, ue2);
  function h3(e28) {
    const a3 = u$n(o3.value), t3 = u$n(s3.value);
    (n3.bindCalendarMonths || a3 >= t3) && (e28 ? s3.value = u$o(h$A(a3, 1)) : o3.value = u$o(h$A(t3, -1)));
  }
  function $e2() {
    o3.value = u$o(h$A(o3.value, 12)), h3(true);
  }
  function pe2() {
    o3.value = u$o(h$A(o3.value, -12)), h3(true);
  }
  function ea2() {
    o3.value = u$o(h$A(o3.value, 1)), h3(true);
  }
  function aa2() {
    o3.value = u$o(h$A(o3.value, -1)), h3(true);
  }
  function ta2() {
    s3.value = u$o(h$A(s3.value, 12)), h3(false);
  }
  function na2() {
    s3.value = u$o(h$A(s3.value, -12)), h3(false);
  }
  function ra2() {
    s3.value = u$o(h$A(s3.value, 1)), h3(false);
  }
  function la2() {
    s3.value = u$o(h$A(s3.value, -1)), h3(false);
  }
  function ua2(e28) {
    o3.value = e28, h3(true);
  }
  function ia2(e28) {
    s3.value = e28, h3(false);
  }
  function ie2(e28) {
    const a3 = J3.value;
    if (!a3)
      return false;
    if (!Array.isArray(n3.value) || _e2.value === "start")
      return a3(e28, "start", null);
    {
      const {
        value: t3
      } = I3;
      return e28 < I3.value ? a3(e28, "start", [t3, t3]) : a3(e28, "end", [t3, t3]);
    }
  }
  function sa2(e28) {
    if (e28 === null)
      return;
    const [a3, t3] = e28;
    o3.value = a3, u$n(t3) <= u$n(a3) ? s3.value = u$o(u$n(h$A(a3, 1))) : s3.value = u$o(u$n(t3));
  }
  function oa2(e28) {
    if (!b3.value)
      b3.value = true, I3.value = e28.ts, E3(e28.ts, e28.ts, "done");
    else {
      b3.value = false;
      const {
        value: a3
      } = n3;
      n3.panel && Array.isArray(a3) ? E3(a3[0], a3[1], "done") : Ee2.value && R3 === "daterange" && (Pe2.value ? se2() : W3());
    }
  }
  function da2(e28) {
    if (b3.value) {
      if (ie2(e28.ts))
        return;
      e28.ts >= I3.value ? E3(I3.value, e28.ts, "wipPreview") : E3(e28.ts, I3.value, "wipPreview");
    }
  }
  function W3() {
    X3.value || (r3.doConfirm(), se2());
  }
  function se2() {
    b3.value = false, n3.active && r3.doClose();
  }
  function _3(e28) {
    typeof e28 != "number" && (e28 = u$o(e28)), n3.value === null ? r3.doUpdateValue([e28, e28], n3.panel) : Array.isArray(n3.value) && r3.doUpdateValue([e28, Math.max(n3.value[1], e28)], n3.panel);
  }
  function j3(e28) {
    typeof e28 != "number" && (e28 = u$o(e28)), n3.value === null ? r3.doUpdateValue([e28, e28], n3.panel) : Array.isArray(n3.value) && r3.doUpdateValue([Math.min(n3.value[0], e28), e28], n3.panel);
  }
  function E3(e28, a3, t3) {
    if (typeof e28 != "number" && (e28 = u$o(e28)), t3 !== "shortcutPreview") {
      let d3, w3;
      if (R3 === "datetimerange") {
        const {
          defaultTime: u3
        } = n3;
        Array.isArray(u3) ? (d3 = gt$2(u3[0]), w3 = gt$2(u3[1])) : (d3 = gt$2(u3), w3 = d3);
      }
      d3 && (e28 = u$o(u$k(e28, d3))), w3 && (a3 = u$o(u$k(a3, w3)));
    }
    r3.doUpdateValue([e28, a3], n3.panel && t3 === "done");
  }
  function D3(e28) {
    return R3 === "datetimerange" ? u$o(i$n(e28)) : R3 === "monthrange" ? u$o(u$n(e28)) : u$o(u$l(e28));
  }
  function fa2(e28) {
    const a3 = St$2(e28, S3.value, /* @__PURE__ */ new Date(), r3.dateFnsOptions.value);
    if (u$r(a3))
      if (n3.value) {
        if (Array.isArray(n3.value)) {
          const t3 = u$k(n3.value[0], {
            year: u$m(a3),
            month: u$p(a3),
            date: n$g(a3)
          });
          _3(D3(u$o(t3)));
        }
      } else {
        const t3 = u$k(/* @__PURE__ */ new Date(), {
          year: u$m(a3),
          month: u$p(a3),
          date: n$g(a3)
        });
        _3(D3(u$o(t3)));
      }
    else
      O3.value = e28;
  }
  function ca2(e28) {
    const a3 = St$2(e28, S3.value, /* @__PURE__ */ new Date(), r3.dateFnsOptions.value);
    if (u$r(a3)) {
      if (n3.value === null) {
        const t3 = u$k(/* @__PURE__ */ new Date(), {
          year: u$m(a3),
          month: u$p(a3),
          date: n$g(a3)
        });
        j3(D3(u$o(t3)));
      } else if (Array.isArray(n3.value)) {
        const t3 = u$k(n3.value[1], {
          year: u$m(a3),
          month: u$p(a3),
          date: n$g(a3)
        });
        j3(D3(u$o(t3)));
      }
    } else
      M3.value = e28;
  }
  function va2() {
    const e28 = St$2(O3.value, S3.value, /* @__PURE__ */ new Date(), r3.dateFnsOptions.value), {
      value: a3
    } = n3;
    if (u$r(e28)) {
      if (a3 === null) {
        const t3 = u$k(/* @__PURE__ */ new Date(), {
          year: u$m(e28),
          month: u$p(e28),
          date: n$g(e28)
        });
        _3(D3(u$o(t3)));
      } else if (Array.isArray(a3)) {
        const t3 = u$k(a3[0], {
          year: u$m(e28),
          month: u$p(e28),
          date: n$g(e28)
        });
        _3(D3(u$o(t3)));
      }
    } else
      oe2();
  }
  function ma2() {
    const e28 = St$2(M3.value, S3.value, /* @__PURE__ */ new Date(), r3.dateFnsOptions.value), {
      value: a3
    } = n3;
    if (u$r(e28)) {
      if (a3 === null) {
        const t3 = u$k(/* @__PURE__ */ new Date(), {
          year: u$m(e28),
          month: u$p(e28),
          date: n$g(e28)
        });
        j3(D3(u$o(t3)));
      } else if (Array.isArray(a3)) {
        const t3 = u$k(a3[1], {
          year: u$m(e28),
          month: u$p(e28),
          date: n$g(e28)
        });
        j3(D3(u$o(t3)));
      }
    } else
      oe2();
  }
  function oe2(e28) {
    const {
      value: a3
    } = n3;
    if (a3 === null || !Array.isArray(a3)) {
      O3.value = "", M3.value = "";
      return;
    }
    e28 === void 0 && (e28 = a3), O3.value = de$4(e28[0], S3.value, r3.dateFnsOptions.value), M3.value = de$4(e28[1], S3.value, r3.dateFnsOptions.value);
  }
  function ya2(e28) {
    e28 !== null && _3(e28);
  }
  function ha2(e28) {
    e28 !== null && j3(e28);
  }
  function Da2(e28) {
    r3.cachePendingValue();
    const a3 = r3.getShortcutValue(e28);
    Array.isArray(a3) && E3(a3[0], a3[1], "shortcutPreview");
  }
  function Aa2(e28) {
    const a3 = r3.getShortcutValue(e28);
    Array.isArray(a3) && (E3(a3[0], a3[1], "done"), r3.clearPendingValue(), W3());
  }
  function T3(e28, a3) {
    const t3 = e28 === void 0 ? n3.value : e28;
    if (e28 === void 0 || a3 === "start") {
      if (N3.value) {
        const d3 = Array.isArray(t3) ? u$p(t3[0]) : u$p(Date.now());
        N3.value.scrollTo({
          debounce: false,
          index: d3,
          elSize: o$k
        });
      }
      if (k3.value) {
        const d3 = (Array.isArray(t3) ? u$m(t3[0]) : u$m(Date.now())) - T$h;
        k3.value.scrollTo({
          index: d3,
          debounce: false
        });
      }
    }
    if (e28 === void 0 || a3 === "end") {
      if (Q3.value) {
        const d3 = Array.isArray(t3) ? u$p(t3[1]) : u$p(Date.now());
        Q3.value.scrollTo({
          debounce: false,
          index: d3,
          elSize: o$k
        });
      }
      if (x3.value) {
        const d3 = (Array.isArray(t3) ? u$m(t3[1]) : u$m(Date.now())) - T$h;
        x3.value.scrollTo({
          index: d3,
          debounce: false
        });
      }
    }
  }
  function Ra2(e28, a3) {
    const {
      value: t3
    } = n3, d3 = !Array.isArray(t3), w3 = e28.type === "year" && R3 !== "yearrange" ? d3 ? u$k(e28.ts, {
      month: u$p(R3 === "quarterrange" ? m$l(/* @__PURE__ */ new Date()) : /* @__PURE__ */ new Date())
    }).valueOf() : u$k(e28.ts, {
      month: u$p(R3 === "quarterrange" ? m$l(t3[a3 === "start" ? 0 : 1]) : t3[a3 === "start" ? 0 : 1])
    }).valueOf() : e28.ts;
    if (d3) {
      const de2 = D3(w3), L3 = [de2, de2];
      r3.doUpdateValue(L3, n3.panel), T3(L3, "start"), T3(L3, "end"), r3.disableTransitionOneTick();
      return;
    }
    const u3 = [t3[0], t3[1]];
    let B3 = false;
    switch (a3 === "start" ? (u3[0] = D3(w3), u3[0] > u3[1] && (u3[1] = u3[0], B3 = true)) : (u3[1] = D3(w3), u3[0] > u3[1] && (u3[0] = u3[1], B3 = true)), r3.doUpdateValue(u3, n3.panel), R3) {
      case "monthrange":
      case "quarterrange":
        r3.disableTransitionOneTick(), B3 ? (T3(u3, "start"), T3(u3, "end")) : T3(u3, a3);
        break;
      case "yearrange":
        r3.disableTransitionOneTick(), T3(u3, "start"), T3(u3, "end");
    }
  }
  function Ca2() {
    var e28;
    (e28 = te2.value) === null || e28 === void 0 || e28.sync();
  }
  function Sa2() {
    var e28;
    (e28 = ne2.value) === null || e28 === void 0 || e28.sync();
  }
  function ga2(e28) {
    var a3, t3;
    return e28 === "start" ? ((a3 = k3.value) === null || a3 === void 0 ? void 0 : a3.listElRef) || null : ((t3 = x3.value) === null || t3 === void 0 ? void 0 : t3.listElRef) || null;
  }
  function Va2(e28) {
    var a3, t3;
    return e28 === "start" ? ((a3 = k3.value) === null || a3 === void 0 ? void 0 : a3.itemsElRef) || null : ((t3 = x3.value) === null || t3 === void 0 ? void 0 : t3.itemsElRef) || null;
  }
  const ba2 = {
    startYearVlRef: k3,
    endYearVlRef: x3,
    startMonthScrollbarRef: N3,
    endMonthScrollbarRef: Q3,
    startYearScrollbarRef: te2,
    endYearScrollbarRef: ne2
  };
  return Object.assign(Object.assign(Object.assign(Object.assign({
    startDatesElRef: ke2,
    endDatesElRef: xe2,
    handleDateClick: oa2,
    handleColItemClick: Ra2,
    handleDateMouseEnter: da2,
    handleConfirmClick: W3,
    startCalendarPrevYear: pe2,
    startCalendarPrevMonth: aa2,
    startCalendarNextYear: $e2,
    startCalendarNextMonth: ea2,
    endCalendarPrevYear: na2,
    endCalendarPrevMonth: la2,
    endCalendarNextMonth: ra2,
    endCalendarNextYear: ta2,
    mergedIsDateDisabled: ie2,
    changeStartEndTime: E3,
    ranges: Z3,
    startCalendarMonth: qe2,
    startCalendarYear: He2,
    endCalendarMonth: ze2,
    endCalendarYear: Ne2,
    weekdays: Ue2,
    startDateArray: le2,
    endDateArray: je2,
    startYearArray: Le2,
    startMonthArray: Xe2,
    startQuarterArray: Ke2,
    endYearArray: Ge2,
    endMonthArray: Ze2,
    endQuarterArray: Je2,
    isSelecting: b3,
    handleRangeShortcutMouseenter: Da2,
    handleRangeShortcutClick: Aa2
  }, r3), Ye2), ba2), {
    startDateDisplayString: O3,
    endDateInput: M3,
    timePickerSize: r3.timePickerSize,
    startTimeValue: Qe2,
    endTimeValue: We2,
    datePickerSlots: Ie2,
    shortcuts: Be2,
    startCalendarDateTime: o3,
    endCalendarDateTime: s3,
    justifyColumnsScrollState: T3,
    handleFocusDetectorFocus: r3.handleFocusDetectorFocus,
    handleStartTimePickerChange: ya2,
    handleEndTimePickerChange: ha2,
    handleStartDateInput: fa2,
    handleStartDateInputBlur: va2,
    handleEndDateInput: ca2,
    handleEndDateInputBlur: ma2,
    handleStartYearVlScroll: Ca2,
    handleEndYearVlScroll: Sa2,
    virtualListContainer: ga2,
    virtualListContent: Va2,
    onUpdateStartCalendarValue: ua2,
    onUpdateEndCalendarValue: ia2
  });
}
const j$4 = defineComponent({
  name: "DateTimeRangePanel",
  props: Ka$2,
  setup(o3) {
    return Ja$2(o3, "datetimerange");
  },
  render() {
    var o3, d3, p3;
    const {
      mergedClsPrefix: e28,
      mergedTheme: n3,
      shortcuts: h3,
      timePickerProps: c3,
      onRender: u3,
      $slots: s3
    } = this;
    return u3 == null || u3(), h$1R("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${e28}-date-panel`, `${e28}-date-panel--datetimerange`, !this.panel && `${e28}-date-panel--shadow`, this.themeClass],
      onKeydown: this.handlePanelKeyDown,
      onFocus: this.handlePanelFocus
    }, h$1R("div", {
      class: `${e28}-date-panel-header`
    }, h$1R(Zn$3, {
      value: this.startDateDisplayString,
      theme: n3.peers.Input,
      themeOverrides: n3.peerOverrides.Input,
      size: this.timePickerSize,
      stateful: false,
      class: `${e28}-date-panel-date-input`,
      textDecoration: this.isStartValueInvalid ? "line-through" : "",
      placeholder: this.locale.selectDate,
      onBlur: this.handleStartDateInputBlur,
      onUpdateValue: this.handleStartDateInput
    }), h$1R(xn$1, Object.assign({
      placeholder: this.locale.selectTime,
      format: this.timeFormat,
      size: this.timePickerSize
    }, Array.isArray(c3) ? c3[0] : c3, {
      value: this.startTimeValue,
      to: false,
      showIcon: false,
      disabled: this.isSelecting,
      theme: n3.peers.TimePicker,
      themeOverrides: n3.peerOverrides.TimePicker,
      stateful: false,
      isHourDisabled: this.isStartHourDisabled,
      isMinuteDisabled: this.isStartMinuteDisabled,
      isSecondDisabled: this.isStartSecondDisabled,
      onUpdateValue: this.handleStartTimePickerChange
    })), h$1R(Zn$3, {
      value: this.endDateInput,
      theme: n3.peers.Input,
      themeOverrides: n3.peerOverrides.Input,
      stateful: false,
      size: this.timePickerSize,
      class: `${e28}-date-panel-date-input`,
      textDecoration: this.isEndValueInvalid ? "line-through" : "",
      placeholder: this.locale.selectDate,
      onBlur: this.handleEndDateInputBlur,
      onUpdateValue: this.handleEndDateInput
    }), h$1R(xn$1, Object.assign({
      placeholder: this.locale.selectTime,
      format: this.timeFormat,
      size: this.timePickerSize
    }, Array.isArray(c3) ? c3[1] : c3, {
      disabled: this.isSelecting,
      showIcon: false,
      theme: n3.peers.TimePicker,
      themeOverrides: n3.peerOverrides.TimePicker,
      to: false,
      stateful: false,
      value: this.endTimeValue,
      isHourDisabled: this.isEndHourDisabled,
      isMinuteDisabled: this.isEndMinuteDisabled,
      isSecondDisabled: this.isEndSecondDisabled,
      onUpdateValue: this.handleEndTimePickerChange
    }))), h$1R("div", {
      ref: "startDatesElRef",
      class: `${e28}-date-panel-calendar ${e28}-date-panel-calendar--start`
    }, h$1R("div", {
      class: `${e28}-date-panel-month`
    }, h$1R("div", {
      class: `${e28}-date-panel-month__fast-prev`,
      onClick: this.startCalendarPrevYear
    }, p$3H(s3["prev-year"], () => [h$1R(n$12, null)])), h$1R("div", {
      class: `${e28}-date-panel-month__prev`,
      onClick: this.startCalendarPrevMonth
    }, p$3H(s3["prev-month"], () => [h$1R(o$15, null)])), h$1R(q$9, {
      monthBeforeYear: this.locale.monthBeforeYear,
      value: this.startCalendarDateTime,
      onUpdateValue: this.onUpdateStartCalendarValue,
      mergedClsPrefix: e28,
      calendarMonth: this.startCalendarMonth,
      calendarYear: this.startCalendarYear
    }), h$1R("div", {
      class: `${e28}-date-panel-month__next`,
      onClick: this.startCalendarNextMonth
    }, p$3H(s3["next-month"], () => [h$1R(n$14, null)])), h$1R("div", {
      class: `${e28}-date-panel-month__fast-next`,
      onClick: this.startCalendarNextYear
    }, p$3H(s3["next-year"], () => [h$1R(n$13, null)]))), h$1R("div", {
      class: `${e28}-date-panel-weekdays`
    }, this.weekdays.map((t3) => h$1R("div", {
      key: t3,
      class: `${e28}-date-panel-weekdays__day`
    }, t3))), h$1R("div", {
      class: `${e28}-date-panel__divider`
    }), h$1R("div", {
      class: `${e28}-date-panel-dates`
    }, this.startDateArray.map((t3, i) => {
      const r3 = this.mergedIsDateDisabled(t3.ts);
      return h$1R("div", {
        "data-n-date": true,
        key: i,
        class: [`${e28}-date-panel-date`, {
          [`${e28}-date-panel-date--excluded`]: !t3.inCurrentMonth,
          [`${e28}-date-panel-date--current`]: t3.isCurrentDate,
          [`${e28}-date-panel-date--selected`]: t3.selected,
          [`${e28}-date-panel-date--covered`]: t3.inSpan,
          [`${e28}-date-panel-date--start`]: t3.startOfSpan,
          [`${e28}-date-panel-date--end`]: t3.endOfSpan,
          [`${e28}-date-panel-date--disabled`]: r3
        }],
        onClick: r3 ? void 0 : () => {
          this.handleDateClick(t3);
        },
        onMouseenter: r3 ? void 0 : () => {
          this.handleDateMouseEnter(t3);
        }
      }, h$1R("div", {
        class: `${e28}-date-panel-date__trigger`
      }), t3.dateObject.date, t3.isCurrentDate ? h$1R("div", {
        class: `${e28}-date-panel-date__sup`
      }) : null);
    }))), h$1R("div", {
      class: `${e28}-date-panel__vertical-divider`
    }), h$1R("div", {
      ref: "endDatesElRef",
      class: `${e28}-date-panel-calendar ${e28}-date-panel-calendar--end`
    }, h$1R("div", {
      class: `${e28}-date-panel-month`
    }, h$1R("div", {
      class: `${e28}-date-panel-month__fast-prev`,
      onClick: this.endCalendarPrevYear
    }, p$3H(s3["prev-year"], () => [h$1R(n$12, null)])), h$1R("div", {
      class: `${e28}-date-panel-month__prev`,
      onClick: this.endCalendarPrevMonth
    }, p$3H(s3["prev-month"], () => [h$1R(o$15, null)])), h$1R(q$9, {
      monthBeforeYear: this.locale.monthBeforeYear,
      value: this.endCalendarDateTime,
      onUpdateValue: this.onUpdateEndCalendarValue,
      mergedClsPrefix: e28,
      calendarMonth: this.endCalendarMonth,
      calendarYear: this.endCalendarYear
    }), h$1R("div", {
      class: `${e28}-date-panel-month__next`,
      onClick: this.endCalendarNextMonth
    }, p$3H(s3["next-month"], () => [h$1R(n$14, null)])), h$1R("div", {
      class: `${e28}-date-panel-month__fast-next`,
      onClick: this.endCalendarNextYear
    }, p$3H(s3["next-year"], () => [h$1R(n$13, null)]))), h$1R("div", {
      class: `${e28}-date-panel-weekdays`
    }, this.weekdays.map((t3) => h$1R("div", {
      key: t3,
      class: `${e28}-date-panel-weekdays__day`
    }, t3))), h$1R("div", {
      class: `${e28}-date-panel__divider`
    }), h$1R("div", {
      class: `${e28}-date-panel-dates`
    }, this.endDateArray.map((t3, i) => {
      const r3 = this.mergedIsDateDisabled(t3.ts);
      return h$1R("div", {
        "data-n-date": true,
        key: i,
        class: [`${e28}-date-panel-date`, {
          [`${e28}-date-panel-date--excluded`]: !t3.inCurrentMonth,
          [`${e28}-date-panel-date--current`]: t3.isCurrentDate,
          [`${e28}-date-panel-date--selected`]: t3.selected,
          [`${e28}-date-panel-date--covered`]: t3.inSpan,
          [`${e28}-date-panel-date--start`]: t3.startOfSpan,
          [`${e28}-date-panel-date--end`]: t3.endOfSpan,
          [`${e28}-date-panel-date--disabled`]: r3
        }],
        onClick: r3 ? void 0 : () => {
          this.handleDateClick(t3);
        },
        onMouseenter: r3 ? void 0 : () => {
          this.handleDateMouseEnter(t3);
        }
      }, h$1R("div", {
        class: `${e28}-date-panel-date__trigger`
      }), t3.dateObject.date, t3.isCurrentDate ? h$1R("div", {
        class: `${e28}-date-panel-date__sup`
      }) : null);
    }))), this.datePickerSlots.footer ? h$1R("div", {
      class: `${e28}-date-panel-footer`
    }, this.datePickerSlots.footer()) : null, !((o3 = this.actions) === null || o3 === void 0) && o3.length || h3 ? h$1R("div", {
      class: `${e28}-date-panel-actions`
    }, h$1R("div", {
      class: `${e28}-date-panel-actions__prefix`
    }, h3 && Object.keys(h3).map((t3) => {
      const i = h3[t3];
      return Array.isArray(i) || typeof i == "function" ? h$1R(ie$h, {
        size: "tiny",
        onMouseenter: () => {
          this.handleRangeShortcutMouseenter(i);
        },
        onClick: () => {
          this.handleRangeShortcutClick(i);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => t3
      }) : null;
    })), h$1R("div", {
      class: `${e28}-date-panel-actions__suffix`
    }, !((d3 = this.actions) === null || d3 === void 0) && d3.includes("clear") ? h$1R(le$g, {
      theme: n3.peers.Button,
      themeOverrides: n3.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleClearClick
    }, {
      default: () => this.locale.clear
    }) : null, !((p3 = this.actions) === null || p3 === void 0) && p3.includes("confirm") ? h$1R(le$g, {
      theme: n3.peers.Button,
      themeOverrides: n3.peerOverrides.Button,
      size: "tiny",
      type: "primary",
      disabled: this.isRangeInvalid || this.isSelecting,
      onClick: this.handleConfirmClick
    }, {
      default: () => this.locale.confirm
    }) : null)) : null, h$1R(u$1l, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
const V$a = defineComponent({
  name: "DatePanel",
  props: Object.assign(Object.assign({}, va$2), {
    type: {
      type: String,
      required: true
    }
  }),
  setup(n3) {
    return ma$2(n3, n3.type);
  },
  render() {
    var n3, l3, c3;
    const {
      mergedClsPrefix: e28,
      mergedTheme: o3,
      shortcuts: r3,
      onRender: h3,
      $slots: i,
      type: u3
    } = this;
    return h3 == null || h3(), h$1R("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${e28}-date-panel`, `${e28}-date-panel--${u3}`, !this.panel && `${e28}-date-panel--shadow`, this.themeClass],
      onFocus: this.handlePanelFocus,
      onKeydown: this.handlePanelKeyDown
    }, h$1R("div", {
      class: `${e28}-date-panel-calendar`
    }, h$1R("div", {
      class: `${e28}-date-panel-month`
    }, h$1R("div", {
      class: `${e28}-date-panel-month__fast-prev`,
      onClick: this.prevYear
    }, p$3H(i["prev-year"], () => [h$1R(n$12, null)])), h$1R("div", {
      class: `${e28}-date-panel-month__prev`,
      onClick: this.prevMonth
    }, p$3H(i["prev-month"], () => [h$1R(o$15, null)])), h$1R(q$9, {
      monthBeforeYear: this.locale.monthBeforeYear,
      value: this.calendarValue,
      onUpdateValue: this.onUpdateCalendarValue,
      mergedClsPrefix: e28,
      calendarMonth: this.calendarMonth,
      calendarYear: this.calendarYear
    }), h$1R("div", {
      class: `${e28}-date-panel-month__next`,
      onClick: this.nextMonth
    }, p$3H(i["next-month"], () => [h$1R(n$14, null)])), h$1R("div", {
      class: `${e28}-date-panel-month__fast-next`,
      onClick: this.nextYear
    }, p$3H(i["next-year"], () => [h$1R(n$13, null)]))), h$1R("div", {
      class: `${e28}-date-panel-weekdays`
    }, this.weekdays.map((a3) => h$1R("div", {
      key: a3,
      class: `${e28}-date-panel-weekdays__day`
    }, a3))), h$1R("div", {
      class: `${e28}-date-panel-dates`
    }, this.dateArray.map((a3, s3) => h$1R("div", {
      "data-n-date": true,
      key: s3,
      class: [`${e28}-date-panel-date`, {
        [`${e28}-date-panel-date--current`]: a3.isCurrentDate,
        [`${e28}-date-panel-date--selected`]: a3.selected,
        [`${e28}-date-panel-date--excluded`]: !a3.inCurrentMonth,
        [`${e28}-date-panel-date--disabled`]: this.mergedIsDateDisabled(a3.ts, {
          type: "date",
          year: a3.dateObject.year,
          month: a3.dateObject.month,
          date: a3.dateObject.date
        }),
        [`${e28}-date-panel-date--week-hovered`]: this.isWeekHovered(a3),
        [`${e28}-date-panel-date--week-selected`]: a3.inSelectedWeek
      }],
      onClick: () => {
        this.handleDateClick(a3);
      },
      onMouseenter: () => {
        this.handleDateMouseEnter(a3);
      }
    }, h$1R("div", {
      class: `${e28}-date-panel-date__trigger`
    }), a3.dateObject.date, a3.isCurrentDate ? h$1R("div", {
      class: `${e28}-date-panel-date__sup`
    }) : null)))), this.datePickerSlots.footer ? h$1R("div", {
      class: `${e28}-date-panel-footer`
    }, this.datePickerSlots.footer()) : null, !((n3 = this.actions) === null || n3 === void 0) && n3.length || r3 ? h$1R("div", {
      class: `${e28}-date-panel-actions`
    }, h$1R("div", {
      class: `${e28}-date-panel-actions__prefix`
    }, r3 && Object.keys(r3).map((a3) => {
      const s3 = r3[a3];
      return Array.isArray(s3) ? null : h$1R(ie$h, {
        size: "tiny",
        onMouseenter: () => {
          this.handleSingleShortcutMouseenter(s3);
        },
        onClick: () => {
          this.handleSingleShortcutClick(s3);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => a3
      });
    })), h$1R("div", {
      class: `${e28}-date-panel-actions__suffix`
    }, !((l3 = this.actions) === null || l3 === void 0) && l3.includes("clear") ? h$1R(le$g, {
      theme: o3.peers.Button,
      themeOverrides: o3.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleClearClick
    }, {
      default: () => this.locale.clear
    }) : null, !((c3 = this.actions) === null || c3 === void 0) && c3.includes("now") ? h$1R(le$g, {
      theme: o3.peers.Button,
      themeOverrides: o3.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleNowClick
    }, {
      default: () => this.locale.now
    }) : null)) : null, h$1R(u$1l, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
const N$d = defineComponent({
  name: "DateRangePanel",
  props: Ka$2,
  setup(r3) {
    return Ja$2(r3, "daterange");
  },
  render() {
    var r3, s3, c3;
    const {
      mergedClsPrefix: e28,
      mergedTheme: i,
      shortcuts: o3,
      onRender: p3,
      $slots: n3
    } = this;
    return p3 == null || p3(), h$1R("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${e28}-date-panel`, `${e28}-date-panel--daterange`, !this.panel && `${e28}-date-panel--shadow`, this.themeClass],
      onKeydown: this.handlePanelKeyDown,
      onFocus: this.handlePanelFocus
    }, h$1R("div", {
      ref: "startDatesElRef",
      class: `${e28}-date-panel-calendar ${e28}-date-panel-calendar--start`
    }, h$1R("div", {
      class: `${e28}-date-panel-month`
    }, h$1R("div", {
      class: `${e28}-date-panel-month__fast-prev`,
      onClick: this.startCalendarPrevYear
    }, p$3H(n3["prev-year"], () => [h$1R(n$12, null)])), h$1R("div", {
      class: `${e28}-date-panel-month__prev`,
      onClick: this.startCalendarPrevMonth
    }, p$3H(n3["prev-month"], () => [h$1R(o$15, null)])), h$1R(q$9, {
      monthBeforeYear: this.locale.monthBeforeYear,
      value: this.startCalendarDateTime,
      onUpdateValue: this.onUpdateStartCalendarValue,
      mergedClsPrefix: e28,
      calendarMonth: this.startCalendarMonth,
      calendarYear: this.startCalendarYear
    }), h$1R("div", {
      class: `${e28}-date-panel-month__next`,
      onClick: this.startCalendarNextMonth
    }, p$3H(n3["next-month"], () => [h$1R(n$14, null)])), h$1R("div", {
      class: `${e28}-date-panel-month__fast-next`,
      onClick: this.startCalendarNextYear
    }, p$3H(n3["next-year"], () => [h$1R(n$13, null)]))), h$1R("div", {
      class: `${e28}-date-panel-weekdays`
    }, this.weekdays.map((t3) => h$1R("div", {
      key: t3,
      class: `${e28}-date-panel-weekdays__day`
    }, t3))), h$1R("div", {
      class: `${e28}-date-panel__divider`
    }), h$1R("div", {
      class: `${e28}-date-panel-dates`
    }, this.startDateArray.map((t3, l3) => h$1R("div", {
      "data-n-date": true,
      key: l3,
      class: [`${e28}-date-panel-date`, {
        [`${e28}-date-panel-date--excluded`]: !t3.inCurrentMonth,
        [`${e28}-date-panel-date--current`]: t3.isCurrentDate,
        [`${e28}-date-panel-date--selected`]: t3.selected,
        [`${e28}-date-panel-date--covered`]: t3.inSpan,
        [`${e28}-date-panel-date--start`]: t3.startOfSpan,
        [`${e28}-date-panel-date--end`]: t3.endOfSpan,
        [`${e28}-date-panel-date--disabled`]: this.mergedIsDateDisabled(t3.ts)
      }],
      onClick: () => {
        this.handleDateClick(t3);
      },
      onMouseenter: () => {
        this.handleDateMouseEnter(t3);
      }
    }, h$1R("div", {
      class: `${e28}-date-panel-date__trigger`
    }), t3.dateObject.date, t3.isCurrentDate ? h$1R("div", {
      class: `${e28}-date-panel-date__sup`
    }) : null)))), h$1R("div", {
      class: `${e28}-date-panel__vertical-divider`
    }), h$1R("div", {
      ref: "endDatesElRef",
      class: `${e28}-date-panel-calendar ${e28}-date-panel-calendar--end`
    }, h$1R("div", {
      class: `${e28}-date-panel-month`
    }, h$1R("div", {
      class: `${e28}-date-panel-month__fast-prev`,
      onClick: this.endCalendarPrevYear
    }, p$3H(n3["prev-year"], () => [h$1R(n$12, null)])), h$1R("div", {
      class: `${e28}-date-panel-month__prev`,
      onClick: this.endCalendarPrevMonth
    }, p$3H(n3["prev-month"], () => [h$1R(o$15, null)])), h$1R(q$9, {
      monthBeforeYear: this.locale.monthBeforeYear,
      value: this.endCalendarDateTime,
      onUpdateValue: this.onUpdateEndCalendarValue,
      mergedClsPrefix: e28,
      calendarMonth: this.endCalendarMonth,
      calendarYear: this.endCalendarYear
    }), h$1R("div", {
      class: `${e28}-date-panel-month__next`,
      onClick: this.endCalendarNextMonth
    }, p$3H(n3["next-month"], () => [h$1R(n$14, null)])), h$1R("div", {
      class: `${e28}-date-panel-month__fast-next`,
      onClick: this.endCalendarNextYear
    }, p$3H(n3["next-year"], () => [h$1R(n$13, null)]))), h$1R("div", {
      class: `${e28}-date-panel-weekdays`
    }, this.weekdays.map((t3) => h$1R("div", {
      key: t3,
      class: `${e28}-date-panel-weekdays__day`
    }, t3))), h$1R("div", {
      class: `${e28}-date-panel__divider`
    }), h$1R("div", {
      class: `${e28}-date-panel-dates`
    }, this.endDateArray.map((t3, l3) => h$1R("div", {
      "data-n-date": true,
      key: l3,
      class: [`${e28}-date-panel-date`, {
        [`${e28}-date-panel-date--excluded`]: !t3.inCurrentMonth,
        [`${e28}-date-panel-date--current`]: t3.isCurrentDate,
        [`${e28}-date-panel-date--selected`]: t3.selected,
        [`${e28}-date-panel-date--covered`]: t3.inSpan,
        [`${e28}-date-panel-date--start`]: t3.startOfSpan,
        [`${e28}-date-panel-date--end`]: t3.endOfSpan,
        [`${e28}-date-panel-date--disabled`]: this.mergedIsDateDisabled(t3.ts)
      }],
      onClick: () => {
        this.handleDateClick(t3);
      },
      onMouseenter: () => {
        this.handleDateMouseEnter(t3);
      }
    }, h$1R("div", {
      class: `${e28}-date-panel-date__trigger`
    }), t3.dateObject.date, t3.isCurrentDate ? h$1R("div", {
      class: `${e28}-date-panel-date__sup`
    }) : null)))), this.datePickerSlots.footer ? h$1R("div", {
      class: `${e28}-date-panel-footer`
    }, this.datePickerSlots.footer()) : null, !((r3 = this.actions) === null || r3 === void 0) && r3.length || o3 ? h$1R("div", {
      class: `${e28}-date-panel-actions`
    }, h$1R("div", {
      class: `${e28}-date-panel-actions__prefix`
    }, o3 && Object.keys(o3).map((t3) => {
      const l3 = o3[t3];
      return Array.isArray(l3) || typeof l3 == "function" ? h$1R(ie$h, {
        size: "tiny",
        onMouseenter: () => {
          this.handleRangeShortcutMouseenter(l3);
        },
        onClick: () => {
          this.handleRangeShortcutClick(l3);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => t3
      }) : null;
    })), h$1R("div", {
      class: `${e28}-date-panel-actions__suffix`
    }, !((s3 = this.actions) === null || s3 === void 0) && s3.includes("clear") ? h$1R(le$g, {
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleClearClick
    }, {
      default: () => this.locale.clear
    }) : null, !((c3 = this.actions) === null || c3 === void 0) && c3.includes("confirm") ? h$1R(le$g, {
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      size: "tiny",
      type: "primary",
      disabled: this.isRangeInvalid || this.isSelecting,
      onClick: this.handleConfirmClick
    }, {
      default: () => this.locale.confirm
    }) : null)) : null, h$1R(u$1l, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
const B$e = defineComponent({
  name: "MonthRangePanel",
  props: Object.assign(Object.assign({}, Ka$2), {
    type: {
      type: String,
      required: true
    }
  }),
  setup(o3) {
    const s3 = Ja$2(o3, o3.type), {
      dateLocaleRef: i
    } = R$p("DatePicker"), t3 = (e28, d3, r3, c3) => {
      const {
        handleColItemClick: h3
      } = s3, n3 = false;
      return h$1R("div", {
        "data-n-date": true,
        key: d3,
        class: [`${r3}-date-panel-month-calendar__picker-col-item`, e28.isCurrent && `${r3}-date-panel-month-calendar__picker-col-item--current`, e28.selected && `${r3}-date-panel-month-calendar__picker-col-item--selected`, n3],
        onClick: () => {
          h3(e28, c3);
        }
      }, e28.type === "month" ? dt$2(e28.dateObject.month, e28.monthFormat, i.value.locale) : e28.type === "quarter" ? pt$2(e28.dateObject.quarter, e28.quarterFormat, i.value.locale) : st$2(e28.dateObject.year, e28.yearFormat, i.value.locale));
    };
    return onMounted(() => {
      s3.justifyColumnsScrollState();
    }), Object.assign(Object.assign({}, s3), {
      renderItem: t3
    });
  },
  render() {
    var o3, s3, i;
    const {
      mergedClsPrefix: t3,
      mergedTheme: e28,
      shortcuts: d3,
      type: r3,
      renderItem: c3,
      onRender: h3
    } = this;
    return h3 == null || h3(), h$1R("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${t3}-date-panel`, `${t3}-date-panel--daterange`, !this.panel && `${t3}-date-panel--shadow`, this.themeClass],
      onKeydown: this.handlePanelKeyDown,
      onFocus: this.handlePanelFocus
    }, h$1R("div", {
      ref: "startDatesElRef",
      class: `${t3}-date-panel-calendar ${t3}-date-panel-calendar--start`
    }, h$1R("div", {
      class: `${t3}-date-panel-month-calendar`
    }, h$1R(hn$2, {
      ref: "startYearScrollbarRef",
      class: `${t3}-date-panel-month-calendar__picker-col`,
      theme: e28.peers.Scrollbar,
      themeOverrides: e28.peerOverrides.Scrollbar,
      container: () => this.virtualListContainer("start"),
      content: () => this.virtualListContent("start"),
      horizontalRailStyle: {
        zIndex: 1
      },
      verticalRailStyle: {
        zIndex: 1
      }
    }, {
      default: () => h$1R(ve$c, {
        ref: "startYearVlRef",
        items: this.startYearArray,
        itemSize: o$k,
        showScrollbar: false,
        keyField: "ts",
        onScroll: this.handleStartYearVlScroll,
        paddingBottom: 4
      }, {
        default: ({
          item: n3,
          index: l3
        }) => c3(n3, l3, t3, "start")
      })
    }), r3 === "monthrange" || r3 === "quarterrange" ? h$1R("div", {
      class: `${t3}-date-panel-month-calendar__picker-col`
    }, h$1R(hn$2, {
      ref: "startMonthScrollbarRef",
      theme: e28.peers.Scrollbar,
      themeOverrides: e28.peerOverrides.Scrollbar
    }, {
      default: () => [(r3 === "monthrange" ? this.startMonthArray : this.startQuarterArray).map((n3, l3) => c3(n3, l3, t3, "start")), r3 === "monthrange" && h$1R("div", {
        class: `${t3}-date-panel-month-calendar__padding`
      })]
    })) : null)), h$1R("div", {
      class: `${t3}-date-panel__vertical-divider`
    }), h$1R("div", {
      ref: "endDatesElRef",
      class: `${t3}-date-panel-calendar ${t3}-date-panel-calendar--end`
    }, h$1R("div", {
      class: `${t3}-date-panel-month-calendar`
    }, h$1R(hn$2, {
      ref: "endYearScrollbarRef",
      class: `${t3}-date-panel-month-calendar__picker-col`,
      theme: e28.peers.Scrollbar,
      themeOverrides: e28.peerOverrides.Scrollbar,
      container: () => this.virtualListContainer("end"),
      content: () => this.virtualListContent("end"),
      horizontalRailStyle: {
        zIndex: 1
      },
      verticalRailStyle: {
        zIndex: 1
      }
    }, {
      default: () => h$1R(ve$c, {
        ref: "endYearVlRef",
        items: this.endYearArray,
        itemSize: o$k,
        showScrollbar: false,
        keyField: "ts",
        onScroll: this.handleEndYearVlScroll,
        paddingBottom: 4
      }, {
        default: ({
          item: n3,
          index: l3
        }) => c3(n3, l3, t3, "end")
      })
    }), r3 === "monthrange" || r3 === "quarterrange" ? h$1R("div", {
      class: `${t3}-date-panel-month-calendar__picker-col`
    }, h$1R(hn$2, {
      ref: "endMonthScrollbarRef",
      theme: e28.peers.Scrollbar,
      themeOverrides: e28.peerOverrides.Scrollbar
    }, {
      default: () => [(r3 === "monthrange" ? this.endMonthArray : this.endQuarterArray).map((n3, l3) => c3(n3, l3, t3, "end")), r3 === "monthrange" && h$1R("div", {
        class: `${t3}-date-panel-month-calendar__padding`
      })]
    })) : null)), this.datePickerSlots.footer ? h$1R("div", {
      class: `${t3}-date-panel-footer`
    }, renderSlot(this.datePickerSlots, "footer")) : null, !((o3 = this.actions) === null || o3 === void 0) && o3.length || d3 ? h$1R("div", {
      class: `${t3}-date-panel-actions`
    }, h$1R("div", {
      class: `${t3}-date-panel-actions__prefix`
    }, d3 && Object.keys(d3).map((n3) => {
      const l3 = d3[n3];
      return Array.isArray(l3) || typeof l3 == "function" ? h$1R(ie$h, {
        size: "tiny",
        onMouseenter: () => {
          this.handleRangeShortcutMouseenter(l3);
        },
        onClick: () => {
          this.handleRangeShortcutClick(l3);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => n3
      }) : null;
    })), h$1R("div", {
      class: `${t3}-date-panel-actions__suffix`
    }, !((s3 = this.actions) === null || s3 === void 0) && s3.includes("clear") ? h$1R(ie$h, {
      theme: e28.peers.Button,
      themeOverrides: e28.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleClearClick
    }, {
      default: () => this.locale.clear
    }) : null, !((i = this.actions) === null || i === void 0) && i.includes("confirm") ? h$1R(ie$h, {
      theme: e28.peers.Button,
      themeOverrides: e28.peerOverrides.Button,
      size: "tiny",
      type: "primary",
      disabled: this.isRangeInvalid,
      onClick: this.handleConfirmClick
    }, {
      default: () => this.locale.confirm
    }) : null)) : null, h$1R(u$1l, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
const l$g = r$2a([l$25("date-picker", `
 position: relative;
 z-index: auto;
 `, [l$25("date-picker-icon", `
 color: var(--n-icon-color-override);
 transition: color .3s var(--n-bezier);
 `), l$25("icon", `
 color: var(--n-icon-color-override);
 transition: color .3s var(--n-bezier);
 `), g$1j("disabled", [l$25("date-picker-icon", `
 color: var(--n-icon-color-disabled-override);
 `), l$25("icon", `
 color: var(--n-icon-color-disabled-override);
 `)])]), l$25("date-panel", `
 width: fit-content;
 outline: none;
 margin: 4px 0;
 display: grid;
 grid-template-columns: 0fr;
 border-radius: var(--n-panel-border-radius);
 background-color: var(--n-panel-color);
 color: var(--n-panel-text-color);
 user-select: none;
 `, [$$n(), g$1j("shadow", `
 box-shadow: var(--n-panel-box-shadow);
 `), l$25("date-panel-calendar", {
  padding: "var(--n-calendar-left-padding)",
  display: "grid",
  gridTemplateColumns: "1fr",
  gridArea: "left-calendar"
}, [g$1j("end", {
  padding: "var(--n-calendar-right-padding)",
  gridArea: "right-calendar"
})]), l$25("date-panel-month-calendar", {
  display: "flex",
  gridArea: "left-calendar"
}, [M$y("picker-col", `
 min-width: var(--n-scroll-item-width);
 height: calc(var(--n-scroll-item-height) * 6);
 user-select: none;
 -webkit-user-select: none;
 `, [r$2a("&:first-child", `
 min-width: calc(var(--n-scroll-item-width) + 4px);
 `, [M$y("picker-col-item", [r$2a("&::before", "left: 4px;")])]), M$y("padding", `
 height: calc(var(--n-scroll-item-height) * 5)
 `)]), M$y("picker-col-item", `
 z-index: 0;
 cursor: pointer;
 height: var(--n-scroll-item-height);
 box-sizing: border-box;
 padding-top: 4px;
 display: flex;
 align-items: center;
 justify-content: center;
 position: relative;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 background: #0000;
 color: var(--n-item-text-color);
 `, [r$2a("&::before", `
 z-index: -1;
 content: "";
 position: absolute;
 left: 0;
 right: 4px;
 top: 4px;
 bottom: 0;
 border-radius: var(--n-scroll-item-border-radius);
 transition: 
 background-color .3s var(--n-bezier);
 `), x$I("disabled", [r$2a("&:hover::before", `
 background-color: var(--n-item-color-hover);
 `), g$1j("selected", `
 color: var(--n-item-color-active);
 `, [r$2a("&::before", "background-color: var(--n-item-color-hover);")])]), g$1j("disabled", `
 color: var(--n-item-text-color-disabled);
 cursor: not-allowed;
 `, [g$1j("selected", [r$2a("&::before", `
 background-color: var(--n-item-color-disabled);
 `)])])])]), g$1j("date", {
  gridTemplateAreas: `
 "left-calendar"
 "footer"
 "action"
 `
}), g$1j("week", {
  gridTemplateAreas: `
 "left-calendar"
 "footer"
 "action"
 `
}), g$1j("daterange", {
  gridTemplateAreas: `
 "left-calendar divider right-calendar"
 "footer footer footer"
 "action action action"
 `
}), g$1j("datetime", {
  gridTemplateAreas: `
 "header"
 "left-calendar"
 "footer"
 "action"
 `
}), g$1j("datetimerange", {
  gridTemplateAreas: `
 "header header header"
 "left-calendar divider right-calendar"
 "footer footer footer"
 "action action action"
 `
}), g$1j("month", {
  gridTemplateAreas: `
 "left-calendar"
 "footer"
 "action"
 `
}), l$25("date-panel-footer", {
  gridArea: "footer"
}), l$25("date-panel-actions", {
  gridArea: "action"
}), l$25("date-panel-header", {
  gridArea: "header"
}), l$25("date-panel-header", `
 box-sizing: border-box;
 width: 100%;
 align-items: center;
 padding: var(--n-panel-header-padding);
 display: flex;
 justify-content: space-between;
 border-bottom: 1px solid var(--n-panel-header-divider-color);
 `, [r$2a(">", [r$2a("*:not(:last-child)", {
  marginRight: "10px"
}), r$2a("*", {
  flex: 1,
  width: 0
}), l$25("time-picker", {
  zIndex: 1
})])]), l$25("date-panel-month", `
 box-sizing: border-box;
 display: grid;
 grid-template-columns: var(--n-calendar-title-grid-template-columns);
 align-items: center;
 justify-items: center;
 padding: var(--n-calendar-title-padding);
 height: var(--n-calendar-title-height);
 `, [M$y("prev, next, fast-prev, fast-next", `
 line-height: 0;
 cursor: pointer;
 width: var(--n-arrow-size);
 height: var(--n-arrow-size);
 color: var(--n-arrow-color);
 `), M$y("month-year", `
 user-select: none;
 -webkit-user-select: none;
 flex-grow: 1;
 position: relative;
 `, [M$y("text", `
 font-size: var(--n-calendar-title-font-size);
 line-height: var(--n-calendar-title-font-size);
 font-weight: var(--n-calendar-title-font-weight);
 padding: 6px 8px;
 text-align: center;
 color: var(--n-calendar-title-text-color);
 cursor: pointer;
 transition: background-color .3s var(--n-bezier);
 border-radius: var(--n-panel-border-radius);
 `, [g$1j("active", `
 background-color: var(--n-calendar-title-color-hover);
 `), r$2a("&:hover", `
 background-color: var(--n-calendar-title-color-hover);
 `)])])]), l$25("date-panel-weekdays", `
 display: grid;
 margin: auto;
 grid-template-columns: repeat(7, var(--n-item-cell-width));
 grid-template-rows: repeat(1, var(--n-item-cell-height));
 align-items: center;
 justify-items: center;
 margin-bottom: 4px;
 border-bottom: 1px solid var(--n-calendar-days-divider-color);
 `, [M$y("day", `
 user-select: none;
 -webkit-user-select: none;
 line-height: 15px;
 width: var(--n-item-size);
 text-align: center;
 font-size: var(--n-calendar-days-font-size);
 color: var(--n-item-text-color);
 `)]), l$25("date-panel-dates", `
 margin: auto;
 display: grid;
 grid-template-columns: repeat(7, var(--n-item-cell-width));
 grid-template-rows: repeat(6, var(--n-item-cell-height));
 align-items: center;
 justify-items: center;
 flex-wrap: wrap;
 `, [l$25("date-panel-date", `
 user-select: none;
 -webkit-user-select: none;
 position: relative;
 width: var(--n-item-size);
 height: var(--n-item-size);
 line-height: var(--n-item-size);
 text-align: center;
 font-size: var(--n-item-font-size);
 border-radius: var(--n-item-border-radius);
 z-index: 0;
 cursor: pointer;
 transition:
 background-color .2s var(--n-bezier),
 color .2s var(--n-bezier);
 `, [M$y("trigger", `
 position: absolute;
 left: calc(var(--n-item-size) / 2 - var(--n-item-cell-width) / 2);
 top: calc(var(--n-item-size) / 2 - var(--n-item-cell-height) / 2);
 width: var(--n-item-cell-width);
 height: var(--n-item-cell-height);
 `), g$1j("current", [M$y("sup", `
 position: absolute;
 top: 2px;
 right: 2px;
 content: "";
 height: 4px;
 width: 4px;
 border-radius: 2px;
 background-color: var(--n-item-color-active);
 transition:
 background-color .2s var(--n-bezier);
 `)]), r$2a("&::after", `
 content: "";
 z-index: -1;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 transition: background-color .3s var(--n-bezier);
 `), g$1j("covered, start, end", [x$I("excluded", [r$2a("&::before", `
 content: "";
 z-index: -2;
 position: absolute;
 left: calc((var(--n-item-size) - var(--n-item-cell-width)) / 2);
 right: calc((var(--n-item-size) - var(--n-item-cell-width)) / 2);
 top: 0;
 bottom: 0;
 background-color: var(--n-item-color-included);
 `), r$2a("&:nth-child(7n + 1)::before", {
  borderTopLeftRadius: "var(--n-item-border-radius)",
  borderBottomLeftRadius: "var(--n-item-border-radius)"
}), r$2a("&:nth-child(7n + 7)::before", {
  borderTopRightRadius: "var(--n-item-border-radius)",
  borderBottomRightRadius: "var(--n-item-border-radius)"
})])]), g$1j("selected", {
  color: "var(--n-item-text-color-active)"
}, [r$2a("&::after", {
  backgroundColor: "var(--n-item-color-active)"
}), g$1j("start", [r$2a("&::before", {
  left: "50%"
})]), g$1j("end", [r$2a("&::before", {
  right: "50%"
})]), M$y("sup", {
  backgroundColor: "var(--n-panel-color)"
})]), g$1j("excluded", {
  color: "var(--n-item-text-color-disabled)"
}, [g$1j("selected", [r$2a("&::after", {
  backgroundColor: "var(--n-item-color-disabled)"
})])]), g$1j("disabled", {
  cursor: "not-allowed",
  color: "var(--n-item-text-color-disabled)"
}, [g$1j("covered", [r$2a("&::before", {
  backgroundColor: "var(--n-item-color-disabled)"
})]), g$1j("selected", [r$2a("&::before", {
  backgroundColor: "var(--n-item-color-disabled)"
}), r$2a("&::after", {
  backgroundColor: "var(--n-item-color-disabled)"
})])]), g$1j("week-hovered", [r$2a("&::before", `
 background-color: var(--n-item-color-included);
 `), r$2a("&:nth-child(7n + 1)::before", `
 border-top-left-radius: var(--n-item-border-radius);
 border-bottom-left-radius: var(--n-item-border-radius);
 `), r$2a("&:nth-child(7n + 7)::before", `
 border-top-right-radius: var(--n-item-border-radius);
 border-bottom-right-radius: var(--n-item-border-radius);
 `)]), g$1j("week-selected", `
 color: var(--n-item-text-color-active)
 `, [r$2a("&::before", `
 background-color: var(--n-item-color-active);
 `), r$2a("&:nth-child(7n + 1)::before", `
 border-top-left-radius: var(--n-item-border-radius);
 border-bottom-left-radius: var(--n-item-border-radius);
 `), r$2a("&:nth-child(7n + 7)::before", `
 border-top-right-radius: var(--n-item-border-radius);
 border-bottom-right-radius: var(--n-item-border-radius);
 `)])])]), x$I("week", [l$25("date-panel-dates", [l$25("date-panel-date", [x$I("disabled", [x$I("selected", [r$2a("&:hover", `
 background-color: var(--n-item-color-hover);
 `)])])])])]), g$1j("week", [l$25("date-panel-dates", [l$25("date-panel-date", [r$2a("&::before", `
 content: "";
 z-index: -2;
 position: absolute;
 left: calc((var(--n-item-size) - var(--n-item-cell-width)) / 2);
 right: calc((var(--n-item-size) - var(--n-item-cell-width)) / 2);
 top: 0;
 bottom: 0;
 transition: background-color .3s var(--n-bezier);
 `)])])]), M$y("vertical-divider", `
 grid-area: divider;
 height: 100%;
 width: 1px;
 background-color: var(--n-calendar-divider-color);
 `), l$25("date-panel-footer", `
 border-top: 1px solid var(--n-panel-action-divider-color);
 padding: var(--n-panel-extra-footer-padding);
 `), l$25("date-panel-actions", `
 flex: 1;
 padding: var(--n-panel-action-padding);
 display: flex;
 align-items: center;
 justify-content: space-between;
 border-top: 1px solid var(--n-panel-action-divider-color);
 `, [M$y("prefix, suffix", `
 display: flex;
 margin-bottom: -8px;
 `), M$y("suffix", `
 align-self: flex-end;
 `), M$y("prefix", `
 flex-wrap: wrap;
 `), l$25("button", `
 margin-bottom: 8px;
 `, [r$2a("&:not(:last-child)", `
 margin-right: 8px;
 `)])])]), r$2a("[data-n-date].transition-disabled", {
  transition: "none !important"
}, [r$2a("&::before, &::after", {
  transition: "none !important"
})])]);
const a$w = {
  itemSize: "24px",
  itemCellWidth: "38px",
  itemCellHeight: "32px",
  scrollItemWidth: "80px",
  scrollItemHeight: "40px",
  panelExtraFooterPadding: "8px 12px",
  panelActionPadding: "8px 12px",
  calendarTitlePadding: "0",
  calendarTitleHeight: "28px",
  arrowSize: "14px",
  panelHeaderPadding: "8px 12px",
  calendarDaysHeight: "32px",
  calendarTitleGridTempateColumns: "28px 28px 1fr 28px 28px",
  calendarLeftPaddingDate: "6px 12px 4px 12px",
  calendarLeftPaddingDatetime: "4px 12px",
  calendarLeftPaddingDaterange: "6px 12px 4px 12px",
  calendarLeftPaddingDatetimerange: "4px 12px",
  calendarLeftPaddingMonth: "0",
  calendarLeftPaddingYear: "0",
  calendarLeftPaddingQuarter: "0",
  calendarLeftPaddingMonthrange: "0",
  calendarLeftPaddingQuarterrange: "0",
  calendarLeftPaddingYearrange: "0",
  calendarLeftPaddingWeek: "6px 12px 4px 12px",
  calendarRightPaddingDate: "6px 12px 4px 12px",
  calendarRightPaddingDatetime: "4px 12px",
  calendarRightPaddingDaterange: "6px 12px 4px 12px",
  calendarRightPaddingDatetimerange: "4px 12px",
  calendarRightPaddingMonth: "0",
  calendarRightPaddingYear: "0",
  calendarRightPaddingQuarter: "0",
  calendarRightPaddingMonthrange: "0",
  calendarRightPaddingQuarterrange: "0",
  calendarRightPaddingYearrange: "0",
  calendarRightPaddingWeek: "0"
};
const S$c = (m3) => {
  const {
    hoverColor: r3,
    fontSize: e28,
    textColor2: t3,
    textColorDisabled: d3,
    popoverColor: l3,
    primaryColor: i,
    borderRadiusSmall: c3,
    iconColor: a3,
    iconColorDisabled: C3,
    textColor1: s3,
    dividerColor: o3,
    boxShadow2: p3,
    borderRadius: n3,
    fontWeightStrong: h3
  } = m3;
  return Object.assign(Object.assign({}, a$w), {
    itemFontSize: e28,
    calendarDaysFontSize: e28,
    calendarTitleFontSize: e28,
    itemTextColor: t3,
    itemTextColorDisabled: d3,
    itemTextColorActive: l3,
    itemTextColorCurrent: i,
    itemColorIncluded: J$p(i, {
      alpha: 0.1
    }),
    itemColorHover: r3,
    itemColorDisabled: r3,
    itemColorActive: i,
    itemBorderRadius: c3,
    panelColor: l3,
    panelTextColor: t3,
    arrowColor: a3,
    calendarTitleTextColor: s3,
    calendarTitleColorHover: r3,
    calendarDaysTextColor: t3,
    panelHeaderDividerColor: o3,
    calendarDaysDividerColor: o3,
    calendarDividerColor: o3,
    panelActionDividerColor: o3,
    panelBoxShadow: p3,
    panelBorderRadius: n3,
    calendarTitleFontWeight: h3,
    scrollItemBorderRadius: n3,
    iconColor: a3,
    iconColorDisabled: C3
  });
}, L$d = G$w({
  name: "DatePicker",
  common: d$1T,
  peers: {
    Input: k$H,
    Button: B$P,
    TimePicker: y$h,
    Scrollbar: n$1N
  },
  self: S$c
}), A$a = L$d;
const t$c = f$1z("to", h$1R("svg", {
  viewBox: "0 0 20 20",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("g", {
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, h$1R("g", {
  fill: "currentColor",
  "fill-rule": "nonzero"
}, h$1R("path", {
  d: "M11.2654,3.20511 C10.9644,2.92049 10.4897,2.93371 10.2051,3.23464 C9.92049,3.53558 9.93371,4.01027 10.2346,4.29489 L15.4737,9.25 L2.75,9.25 C2.33579,9.25 2,9.58579 2,10.0000012 C2,10.4142 2.33579,10.75 2.75,10.75 L15.476,10.75 L10.2346,15.7073 C9.93371,15.9919 9.92049,16.4666 10.2051,16.7675 C10.4897,17.0684 10.9644,17.0817 11.2654,16.797 L17.6826,10.7276 C17.8489,10.5703 17.9489,10.3702 17.9826,10.1614 C17.994,10.1094 18,10.0554 18,10.0000012 C18,9.94241 17.9935,9.88633 17.9812,9.83246 C17.9462,9.62667 17.8467,9.42976 17.6826,9.27455 L11.2654,3.20511 Z"
})))));
const L$c = f$1z("date", h$1R("svg", {
  width: "28px",
  height: "28px",
  viewBox: "0 0 28 28",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("g", {
  stroke: "none",
  "stroke-width": "1",
  "fill-rule": "evenodd"
}, h$1R("g", {
  "fill-rule": "nonzero"
}, h$1R("path", {
  d: "M21.75,3 C23.5449254,3 25,4.45507456 25,6.25 L25,21.75 C25,23.5449254 23.5449254,25 21.75,25 L6.25,25 C4.45507456,25 3,23.5449254 3,21.75 L3,6.25 C3,4.45507456 4.45507456,3 6.25,3 L21.75,3 Z M23.5,9.503 L4.5,9.503 L4.5,21.75 C4.5,22.7164983 5.28350169,23.5 6.25,23.5 L21.75,23.5 C22.7164983,23.5 23.5,22.7164983 23.5,21.75 L23.5,9.503 Z M21.75,4.5 L6.25,4.5 C5.28350169,4.5 4.5,5.28350169 4.5,6.25 L4.5,8.003 L23.5,8.003 L23.5,6.25 C23.5,5.28350169 22.7164983,4.5 21.75,4.5 Z"
})))));
const da$2 = Object.assign(Object.assign({}, _$F.props), {
  to: f$1m.propTo,
  bordered: {
    type: Boolean,
    default: void 0
  },
  clearable: Boolean,
  updateValueOnClose: Boolean,
  defaultValue: [Number, Array],
  defaultFormattedValue: [String, Array],
  defaultTime: [Number, String, Array],
  disabled: {
    type: Boolean,
    default: void 0
  },
  placement: {
    type: String,
    default: "bottom-start"
  },
  value: [Number, Array],
  formattedValue: [String, Array],
  size: String,
  type: {
    type: String,
    default: "date"
  },
  valueFormat: String,
  separator: String,
  placeholder: String,
  startPlaceholder: String,
  endPlaceholder: String,
  format: String,
  dateFormat: String,
  timeFormat: String,
  actions: Array,
  shortcuts: Object,
  isDateDisabled: Function,
  isTimeDisabled: Function,
  show: {
    type: Boolean,
    default: void 0
  },
  panel: Boolean,
  ranges: Object,
  firstDayOfWeek: Number,
  inputReadonly: Boolean,
  closeOnSelect: Boolean,
  status: String,
  timePickerProps: [Object, Array],
  onClear: Function,
  onConfirm: Function,
  defaultCalendarStartTime: Number,
  defaultCalendarEndTime: Number,
  bindCalendarMonths: Boolean,
  monthFormat: {
    type: String,
    default: "M"
  },
  yearFormat: {
    type: String,
    default: "y"
  },
  quarterFormat: {
    type: String,
    default: "'Q'Q"
  },
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  "onUpdate:formattedValue": [Function, Array],
  onUpdateFormattedValue: [Function, Array],
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onNextMonth: Function,
  onPrevMonth: Function,
  onNextYear: Function,
  onPrevYear: Function,
  onChange: [Function, Array]
}), Wa$2 = defineComponent({
  name: "DatePicker",
  props: da$2,
  setup(t3, {
    slots: k3
  }) {
    var d3;
    const {
      localeRef: r3,
      dateLocaleRef: f3
    } = R$p("DatePicker"), C3 = h$1B(t3), {
      mergedSizeRef: z3,
      mergedDisabledRef: l3,
      mergedStatusRef: pe2
    } = C3, {
      mergedComponentPropsRef: M3,
      mergedClsPrefixRef: j3,
      mergedBorderedRef: ye2,
      namespaceRef: Ce2,
      inlineThemeDisabled: U3
    } = a$2x(t3), Q3 = ref$1(null), G3 = ref$1(null), S3 = ref$1(null), J3 = ref$1(false), Pe2 = toRef$1(t3, "show"), h3 = d$1S(Pe2, J3), g3 = computed(() => ({
      locale: f3.value.locale
    })), P3 = computed(() => {
      const {
        format: e28
      } = t3;
      if (e28)
        return e28;
      switch (t3.type) {
        case "date":
        case "daterange":
          return r3.value.dateFormat;
        case "datetime":
        case "datetimerange":
          return r3.value.dateTimeFormat;
        case "year":
        case "yearrange":
          return r3.value.yearTypeFormat;
        case "month":
        case "monthrange":
          return r3.value.monthTypeFormat;
        case "quarter":
        case "quarterrange":
          return r3.value.quarterFormat;
        case "week":
          return r3.value.weekFormat;
      }
    }), N3 = computed(() => {
      var e28;
      return (e28 = t3.valueFormat) !== null && e28 !== void 0 ? e28 : P3.value;
    });
    function X3(e28) {
      if (e28 === null)
        return null;
      const {
        value: a3
      } = N3, {
        value: n3
      } = g3;
      return Array.isArray(e28) ? [St$2(e28[0], a3, /* @__PURE__ */ new Date(), n3).getTime(), St$2(e28[1], a3, /* @__PURE__ */ new Date(), n3).getTime()] : St$2(e28, a3, /* @__PURE__ */ new Date(), n3).getTime();
    }
    const {
      defaultFormattedValue: Z3,
      defaultValue: Te2
    } = t3, _3 = ref$1((d3 = Z3 !== void 0 ? X3(Z3) : Te2) !== null && d3 !== void 0 ? d3 : null), Fe2 = computed(() => {
      const {
        formattedValue: e28
      } = t3;
      return e28 !== void 0 ? X3(e28) : t3.value;
    }), ee2 = d$1S(Fe2, _3), s3 = ref$1(null);
    watchEffect(() => {
      s3.value = ee2.value;
    });
    const x3 = ref$1(""), A3 = ref$1(""), E3 = ref$1(""), B3 = _$F("DatePicker", "-date-picker", l$g, A$a, t3, j3), Se2 = computed(() => {
      var e28, a3;
      return ((a3 = (e28 = M3 == null ? void 0 : M3.value) === null || e28 === void 0 ? void 0 : e28.DatePicker) === null || a3 === void 0 ? void 0 : a3.timePickerSize) || "small";
    }), te2 = computed(() => ["daterange", "datetimerange", "monthrange", "quarterrange", "yearrange"].includes(t3.type)), Re2 = computed(() => {
      const {
        placeholder: e28
      } = t3;
      if (e28 === void 0) {
        const {
          type: a3
        } = t3;
        switch (a3) {
          case "date":
            return r3.value.datePlaceholder;
          case "datetime":
            return r3.value.datetimePlaceholder;
          case "month":
            return r3.value.monthPlaceholder;
          case "year":
            return r3.value.yearPlaceholder;
          case "quarter":
            return r3.value.quarterPlaceholder;
          case "week":
            return r3.value.weekPlaceholder;
          default:
            return "";
        }
      } else
        return e28;
    }), be2 = computed(() => t3.startPlaceholder === void 0 ? t3.type === "daterange" ? r3.value.startDatePlaceholder : t3.type === "datetimerange" ? r3.value.startDatetimePlaceholder : t3.type === "monthrange" ? r3.value.startMonthPlaceholder : "" : t3.startPlaceholder), Ve2 = computed(() => t3.endPlaceholder === void 0 ? t3.type === "daterange" ? r3.value.endDatePlaceholder : t3.type === "datetimerange" ? r3.value.endDatetimePlaceholder : t3.type === "monthrange" ? r3.value.endMonthPlaceholder : "" : t3.endPlaceholder), we2 = computed(() => {
      const {
        actions: e28,
        type: a3,
        clearable: n3
      } = t3;
      if (e28 === null)
        return [];
      if (e28 !== void 0)
        return e28;
      const i = n3 ? ["clear"] : [];
      switch (a3) {
        case "date":
        case "week":
          return i.push("now"), i;
        case "datetime":
          return i.push("now", "confirm"), i;
        case "daterange":
          return i.push("confirm"), i;
        case "datetimerange":
          return i.push("confirm"), i;
        case "month":
          return i.push("now", "confirm"), i;
        case "year":
          return i.push("now"), i;
        case "quarter":
          return i.push("now", "confirm"), i;
        case "monthrange":
        case "yearrange":
        case "quarterrange":
          return i.push("confirm"), i;
        default: {
          s$2a("date-picker", "The type is wrong, n-date-picker's type only supports `date`, `datetime`, `daterange` and `datetimerange`.");
          break;
        }
      }
    });
    function De2(e28) {
      if (e28 === null)
        return null;
      if (Array.isArray(e28)) {
        const {
          value: a3
        } = N3, {
          value: n3
        } = g3;
        return [de$4(e28[0], a3, n3), de$4(e28[1], a3, g3.value)];
      } else
        return de$4(e28, N3.value, g3.value);
    }
    function Ie2(e28) {
      s3.value = e28;
    }
    function Oe2(e28, a3) {
      const {
        "onUpdate:formattedValue": n3,
        onUpdateFormattedValue: i
      } = t3;
      n3 && i$1Z(n3, e28, a3), i && i$1Z(i, e28, a3);
    }
    function R3(e28, a3) {
      const {
        "onUpdate:value": n3,
        onUpdateValue: i,
        onChange: y3
      } = t3, {
        nTriggerFormChange: T3,
        nTriggerFormInput: F3
      } = C3, c3 = De2(e28);
      a3.doConfirm && ke2(e28, c3), i && i$1Z(i, e28, c3), n3 && i$1Z(n3, e28, c3), y3 && i$1Z(y3, e28, c3), _3.value = e28, Oe2(c3, e28), T3(), F3();
    }
    function ae2() {
      const {
        onClear: e28
      } = t3;
      e28 == null || e28();
    }
    function ke2(e28, a3) {
      const {
        onConfirm: n3
      } = t3;
      n3 && n3(e28, a3);
    }
    function xe2(e28) {
      const {
        onFocus: a3
      } = t3, {
        nTriggerFormFocus: n3
      } = C3;
      a3 && i$1Z(a3, e28), n3();
    }
    function Ae2(e28) {
      const {
        onBlur: a3
      } = t3, {
        nTriggerFormBlur: n3
      } = C3;
      a3 && i$1Z(a3, e28), n3();
    }
    function q3(e28) {
      const {
        "onUpdate:show": a3,
        onUpdateShow: n3
      } = t3;
      a3 && i$1Z(a3, e28), n3 && i$1Z(n3, e28), J3.value = e28;
    }
    function Ee2(e28) {
      e28.key === "Escape" && h3.value && (n$1D(e28), V10({
        returnFocus: true
      }));
    }
    function ze2(e28) {
      e28.key === "Escape" && h3.value && n$1D(e28);
    }
    function Ue2() {
      var e28;
      q3(false), (e28 = S3.value) === null || e28 === void 0 || e28.deactivate(), ae2();
    }
    function Be2() {
      var e28;
      (e28 = S3.value) === null || e28 === void 0 || e28.deactivate(), ae2();
    }
    function Me2() {
      V10({
        returnFocus: true
      });
    }
    function je2(e28) {
      var a3;
      h3.value && !(!((a3 = G3.value) === null || a3 === void 0) && a3.contains(t$1G(e28))) && V10({
        returnFocus: false
      });
    }
    function Ne2(e28) {
      V10({
        returnFocus: true,
        disableUpdateOnClose: e28
      });
    }
    function _e2(e28, a3) {
      a3 ? R3(e28, {
        doConfirm: false
      }) : Ie2(e28);
    }
    function ne2() {
      const e28 = s3.value;
      R3(Array.isArray(e28) ? [e28[0], e28[1]] : e28, {
        doConfirm: true
      });
    }
    function b3() {
      const {
        value: e28
      } = s3;
      te2.value ? (Array.isArray(e28) || e28 === null) && He2(e28) : Array.isArray(e28) || qe2(e28);
    }
    function qe2(e28) {
      e28 === null ? x3.value = "" : x3.value = de$4(e28, P3.value, g3.value);
    }
    function He2(e28) {
      if (e28 === null)
        A3.value = "", E3.value = "";
      else {
        const a3 = g3.value;
        A3.value = de$4(e28[0], P3.value, a3), E3.value = de$4(e28[1], P3.value, a3);
      }
    }
    function Ke2() {
      h3.value || re2();
    }
    function Ye2(e28) {
      var a3;
      !((a3 = Q3.value) === null || a3 === void 0) && a3.$el.contains(e28.relatedTarget) || (Ae2(e28), b3(), V10({
        returnFocus: false
      }));
    }
    function $e2() {
      l3.value || (b3(), V10({
        returnFocus: false
      }));
    }
    function We2(e28) {
      if (e28 === "") {
        R3(null, {
          doConfirm: false
        }), s3.value = null, x3.value = "";
        return;
      }
      const a3 = St$2(e28, P3.value, /* @__PURE__ */ new Date(), g3.value);
      u$r(a3) ? (R3(u$o(a3), {
        doConfirm: false
      }), b3()) : x3.value = e28;
    }
    function Le2(e28, {
      source: a3
    }) {
      if (e28[0] === "" && e28[1] === "") {
        R3(null, {
          doConfirm: false
        }), s3.value = null, A3.value = "", E3.value = "";
        return;
      }
      const [n3, i] = e28, y3 = St$2(n3, P3.value, /* @__PURE__ */ new Date(), g3.value), T3 = St$2(i, P3.value, /* @__PURE__ */ new Date(), g3.value);
      if (u$r(y3) && u$r(T3)) {
        let F3 = u$o(y3), c3 = u$o(T3);
        T3 < y3 && (a3 === 0 ? c3 = F3 : F3 = c3), R3([F3, c3], {
          doConfirm: false
        }), b3();
      } else
        [A3.value, E3.value] = e28;
    }
    function Qe2(e28) {
      l3.value || a$2j(e28, "clear") || h3.value || re2();
    }
    function Ge2(e28) {
      l3.value || xe2(e28);
    }
    function re2() {
      l3.value || h3.value || q3(true);
    }
    function V10({
      returnFocus: e28,
      disableUpdateOnClose: a3
    }) {
      var n3;
      h3.value && (q3(false), t3.type !== "date" && t3.updateValueOnClose && !a3 && ne2(), e28 && ((n3 = S3.value) === null || n3 === void 0 || n3.focus()));
    }
    watch(s3, () => {
      b3();
    }), b3(), watch(h3, (e28) => {
      e28 || (s3.value = ee2.value);
    });
    const ie2 = V$b(t3, s3), H3 = j$6(t3, s3);
    provide(c$L, Object.assign(Object.assign(Object.assign({
      mergedClsPrefixRef: j3,
      mergedThemeRef: B3,
      timePickerSizeRef: Se2,
      localeRef: r3,
      dateLocaleRef: f3,
      firstDayOfWeekRef: toRef$1(t3, "firstDayOfWeek"),
      isDateDisabledRef: toRef$1(t3, "isDateDisabled"),
      rangesRef: toRef$1(t3, "ranges"),
      timePickerPropsRef: toRef$1(t3, "timePickerProps"),
      closeOnSelectRef: toRef$1(t3, "closeOnSelect"),
      updateValueOnCloseRef: toRef$1(t3, "updateValueOnClose"),
      monthFormatRef: toRef$1(t3, "monthFormat"),
      yearFormatRef: toRef$1(t3, "yearFormat"),
      quarterFormatRef: toRef$1(t3, "quarterFormat")
    }, ie2), H3), {
      datePickerSlots: k3
    }));
    const Je2 = {
      focus: () => {
        var e28;
        (e28 = S3.value) === null || e28 === void 0 || e28.focus();
      },
      blur: () => {
        var e28;
        (e28 = S3.value) === null || e28 === void 0 || e28.blur();
      }
    }, le2 = computed(() => {
      const {
        common: {
          cubicBezierEaseInOut: e28
        },
        self: {
          iconColor: a3,
          iconColorDisabled: n3
        }
      } = B3.value;
      return {
        "--n-bezier": e28,
        "--n-icon-color-override": a3,
        "--n-icon-color-disabled-override": n3
      };
    }), w3 = U3 ? E$J("date-picker-trigger", void 0, le2, t3) : void 0, oe2 = computed(() => {
      const {
        type: e28
      } = t3, {
        common: {
          cubicBezierEaseInOut: a3
        },
        self: {
          calendarTitleFontSize: n3,
          calendarDaysFontSize: i,
          itemFontSize: y3,
          itemTextColor: T3,
          itemColorDisabled: F3,
          itemColorIncluded: c3,
          itemColorHover: Xe2,
          itemColorActive: Ze2,
          itemBorderRadius: et2,
          itemTextColorDisabled: tt2,
          itemTextColorActive: at2,
          panelColor: nt2,
          panelTextColor: rt2,
          arrowColor: it2,
          calendarTitleTextColor: lt2,
          panelActionDividerColor: ot2,
          panelHeaderDividerColor: dt2,
          calendarDaysDividerColor: ut2,
          panelBoxShadow: st2,
          panelBorderRadius: ct2,
          calendarTitleFontWeight: mt2,
          panelExtraFooterPadding: ft2,
          panelActionPadding: ht2,
          itemSize: gt2,
          itemCellWidth: vt2,
          itemCellHeight: pt2,
          scrollItemWidth: yt2,
          scrollItemHeight: Ct2,
          calendarTitlePadding: Pt2,
          calendarTitleHeight: Tt2,
          calendarDaysHeight: Ft2,
          calendarDaysTextColor: St2,
          arrowSize: Rt2,
          panelHeaderPadding: bt2,
          calendarDividerColor: Vt2,
          calendarTitleGridTempateColumns: wt2,
          iconColor: Dt2,
          iconColorDisabled: It2,
          scrollItemBorderRadius: Ot2,
          calendarTitleColorHover: kt2,
          [_$H("calendarLeftPadding", e28)]: xt2,
          [_$H("calendarRightPadding", e28)]: At2
        }
      } = B3.value;
      return {
        "--n-bezier": a3,
        "--n-panel-border-radius": ct2,
        "--n-panel-color": nt2,
        "--n-panel-box-shadow": st2,
        "--n-panel-text-color": rt2,
        "--n-panel-header-padding": bt2,
        "--n-panel-header-divider-color": dt2,
        "--n-calendar-left-padding": xt2,
        "--n-calendar-right-padding": At2,
        "--n-calendar-title-color-hover": kt2,
        "--n-calendar-title-height": Tt2,
        "--n-calendar-title-padding": Pt2,
        "--n-calendar-title-font-size": n3,
        "--n-calendar-title-font-weight": mt2,
        "--n-calendar-title-text-color": lt2,
        "--n-calendar-title-grid-template-columns": wt2,
        "--n-calendar-days-height": Ft2,
        "--n-calendar-days-divider-color": ut2,
        "--n-calendar-days-font-size": i,
        "--n-calendar-days-text-color": St2,
        "--n-calendar-divider-color": Vt2,
        "--n-panel-action-padding": ht2,
        "--n-panel-extra-footer-padding": ft2,
        "--n-panel-action-divider-color": ot2,
        "--n-item-font-size": y3,
        "--n-item-border-radius": et2,
        "--n-item-size": gt2,
        "--n-item-cell-width": vt2,
        "--n-item-cell-height": pt2,
        "--n-item-text-color": T3,
        "--n-item-color-included": c3,
        "--n-item-color-disabled": F3,
        "--n-item-color-hover": Xe2,
        "--n-item-color-active": Ze2,
        "--n-item-text-color-disabled": tt2,
        "--n-item-text-color-active": at2,
        "--n-scroll-item-width": yt2,
        "--n-scroll-item-height": Ct2,
        "--n-scroll-item-border-radius": Ot2,
        "--n-arrow-size": Rt2,
        "--n-arrow-color": it2,
        "--n-icon-color": Dt2,
        "--n-icon-color-disabled": It2
      };
    }), D3 = U3 ? E$J("date-picker", computed(() => t3.type), oe2, t3) : void 0;
    return Object.assign(Object.assign({}, Je2), {
      mergedStatus: pe2,
      mergedClsPrefix: j3,
      mergedBordered: ye2,
      namespace: Ce2,
      uncontrolledValue: _3,
      pendingValue: s3,
      panelInstRef: Q3,
      triggerElRef: G3,
      inputInstRef: S3,
      isMounted: u$1C(),
      displayTime: x3,
      displayStartTime: A3,
      displayEndTime: E3,
      mergedShow: h3,
      adjustedTo: f$1m(t3),
      isRange: te2,
      localizedStartPlaceholder: be2,
      localizedEndPlaceholder: Ve2,
      mergedSize: z3,
      mergedDisabled: l3,
      localizedPlacehoder: Re2,
      isValueInvalid: ie2.isValueInvalidRef,
      isStartValueInvalid: H3.isStartValueInvalidRef,
      isEndValueInvalid: H3.isEndValueInvalidRef,
      handleInputKeydown: ze2,
      handleClickOutside: je2,
      handleKeydown: Ee2,
      handleClear: Ue2,
      handlePanelClear: Be2,
      handleTriggerClick: Qe2,
      handleInputActivate: Ke2,
      handleInputDeactivate: $e2,
      handleInputFocus: Ge2,
      handleInputBlur: Ye2,
      handlePanelTabOut: Me2,
      handlePanelClose: Ne2,
      handleRangeUpdateValue: Le2,
      handleSingleUpdateValue: We2,
      handlePanelUpdateValue: _e2,
      handlePanelConfirm: ne2,
      mergedTheme: B3,
      actions: we2,
      triggerCssVars: U3 ? void 0 : le2,
      triggerThemeClass: w3 == null ? void 0 : w3.themeClass,
      triggerOnRender: w3 == null ? void 0 : w3.onRender,
      cssVars: U3 ? void 0 : oe2,
      themeClass: D3 == null ? void 0 : D3.themeClass,
      onRender: D3 == null ? void 0 : D3.onRender,
      onNextMonth: t3.onNextMonth,
      onPrevMonth: t3.onPrevMonth,
      onNextYear: t3.onNextYear,
      onPrevYear: t3.onPrevYear
    });
  },
  render() {
    const {
      clearable: t3,
      triggerOnRender: k3,
      mergedClsPrefix: d3,
      $slots: r3
    } = this, f3 = {
      onUpdateValue: this.handlePanelUpdateValue,
      onTabOut: this.handlePanelTabOut,
      onClose: this.handlePanelClose,
      onClear: this.handlePanelClear,
      onKeydown: this.handleKeydown,
      onConfirm: this.handlePanelConfirm,
      ref: "panelInstRef",
      value: this.pendingValue,
      active: this.mergedShow,
      actions: this.actions,
      shortcuts: this.shortcuts,
      style: this.cssVars,
      defaultTime: this.defaultTime,
      themeClass: this.themeClass,
      panel: this.panel,
      onRender: this.onRender,
      onNextMonth: this.onNextMonth,
      onPrevMonth: this.onPrevMonth,
      onNextYear: this.onNextYear,
      onPrevYear: this.onPrevYear
    }, C3 = () => {
      const {
        type: l3
      } = this;
      return l3 === "datetime" ? h$1R(I$b, Object.assign({}, f3, {
        defaultCalendarStartTime: this.defaultCalendarStartTime
      }), r3) : l3 === "daterange" ? h$1R(N$d, Object.assign({}, f3, {
        defaultCalendarStartTime: this.defaultCalendarStartTime,
        defaultCalendarEndTime: this.defaultCalendarEndTime,
        bindCalendarMonths: this.bindCalendarMonths
      }), r3) : l3 === "datetimerange" ? h$1R(j$4, Object.assign({}, f3, {
        defaultCalendarStartTime: this.defaultCalendarStartTime,
        defaultCalendarEndTime: this.defaultCalendarEndTime,
        bindCalendarMonths: this.bindCalendarMonths
      }), r3) : l3 === "month" || l3 === "year" || l3 === "quarter" ? h$1R(L$e, Object.assign({}, f3, {
        type: l3,
        key: l3
      })) : l3 === "monthrange" || l3 === "yearrange" || l3 === "quarterrange" ? h$1R(B$e, Object.assign({}, f3, {
        type: l3
      })) : h$1R(V$a, Object.assign({}, f3, {
        type: l3,
        defaultCalendarStartTime: this.defaultCalendarStartTime
      }), r3);
    };
    if (this.panel)
      return C3();
    k3 == null || k3();
    const z3 = {
      bordered: this.mergedBordered,
      size: this.mergedSize,
      passivelyActivated: true,
      disabled: this.mergedDisabled,
      readonly: this.inputReadonly || this.mergedDisabled,
      clearable: t3,
      onClear: this.handleClear,
      onClick: this.handleTriggerClick,
      onKeydown: this.handleInputKeydown,
      onActivate: this.handleInputActivate,
      onDeactivate: this.handleInputDeactivate,
      onFocus: this.handleInputFocus,
      onBlur: this.handleInputBlur
    };
    return h$1R("div", {
      ref: "triggerElRef",
      class: [`${d3}-date-picker`, this.mergedDisabled && `${d3}-date-picker--disabled`, this.isRange && `${d3}-date-picker--range`, this.triggerThemeClass],
      style: this.triggerCssVars,
      onKeydown: this.handleKeydown
    }, h$1R(F$x, null, {
      default: () => [h$1R(g$19, null, {
        default: () => this.isRange ? h$1R(Zn$3, Object.assign({
          ref: "inputInstRef",
          status: this.mergedStatus,
          value: [this.displayStartTime, this.displayEndTime],
          placeholder: [this.localizedStartPlaceholder, this.localizedEndPlaceholder],
          textDecoration: [this.isStartValueInvalid ? "line-through" : "", this.isEndValueInvalid ? "line-through" : ""],
          pair: true,
          onUpdateValue: this.handleRangeUpdateValue,
          theme: this.mergedTheme.peers.Input,
          themeOverrides: this.mergedTheme.peerOverrides.Input,
          internalForceFocus: this.mergedShow,
          internalDeactivateOnEnter: true
        }, z3), {
          separator: () => this.separator === void 0 ? p$3H(r3.separator, () => [h$1R(d$1R, {
            clsPrefix: d3,
            class: `${d3}-date-picker-icon`
          }, {
            default: () => h$1R(t$c, null)
          })]) : this.separator,
          [t3 ? "clear-icon-placeholder" : "suffix"]: () => p$3H(r3["date-icon"], () => [h$1R(d$1R, {
            clsPrefix: d3,
            class: `${d3}-date-picker-icon`
          }, {
            default: () => h$1R(L$c, null)
          })])
        }) : h$1R(Zn$3, Object.assign({
          ref: "inputInstRef",
          status: this.mergedStatus,
          value: this.displayTime,
          placeholder: this.localizedPlacehoder,
          textDecoration: this.isValueInvalid && !this.isRange ? "line-through" : "",
          onUpdateValue: this.handleSingleUpdateValue,
          theme: this.mergedTheme.peers.Input,
          themeOverrides: this.mergedTheme.peerOverrides.Input,
          internalForceFocus: this.mergedShow,
          internalDeactivateOnEnter: true
        }, z3), {
          [t3 ? "clear-icon-placeholder" : "suffix"]: () => h$1R(d$1R, {
            clsPrefix: d3,
            class: `${d3}-date-picker-icon`
          }, {
            default: () => p$3H(r3["date-icon"], () => [h$1R(L$c, null)])
          })
        })
      }), h$1R(me$h, {
        show: this.mergedShow,
        containerClass: this.namespace,
        to: this.adjustedTo,
        teleportDisabled: this.adjustedTo === f$1m.tdkey,
        placement: this.placement
      }, {
        default: () => h$1R(Transition, {
          name: "fade-in-scale-up-transition",
          appear: this.isMounted
        }, {
          default: () => this.mergedShow ? withDirectives(C3(), [[a$2i, this.handleClickOutside, void 0, {
            capture: true
          }]]) : null
        })
      })]
    }));
  }
});
const b$b = defineComponent({
  name: "UIDatepicker"
}), m$d = defineComponent(__spreadProps(__spreadValues({}, b$b), {
  props: {
    type: {
      type: String,
      default: "date"
    },
    clearable: {
      type: Boolean,
      default: false
    },
    panel: {
      type: Boolean,
      default: false
    },
    isDateDisabled: {
      type: Function
    },
    isTimeDisabled: {
      type: Function
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    shortcuts: {
      type: Object,
      default: void 0
    },
    value: {
      type: [Number, Array]
    },
    defaultValue: {
      type: [Number, Array]
    },
    format: {
      type: String
    }
  },
  setup(e28) {
    return (t3, a3) => (openBlock(), createBlock(unref(Wa$2), mergeProps({ id: e28.id }, t3.$attrs, {
      disabled: e28.disabled,
      "is-date-disabled": e28.isDateDisabled,
      "is-time-disabled": e28.isTimeDisabled,
      panel: e28.panel,
      value: e28.value,
      "default-value": e28.defaultValue,
      "onUpdate:value": a3[0] || (a3[0] = (d3) => t3.$emit("update:value", d3)),
      clearable: e28.clearable,
      type: e28.type,
      size: "large",
      shortcuts: e28.shortcuts,
      format: e28.format
    }), {
      default: withCtx(() => [
        renderSlot(t3.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "disabled", "is-date-disabled", "is-time-disabled", "panel", "value", "default-value", "clearable", "type", "shortcuts", "format"]));
  }
})), p$2t = m$d;
function u$g(e28, n3) {
  return n3 = typeof n3 == "function" ? n3 : void 0, e28 && e28.length ? x$r(e28, void 0, n3) : [];
}
const n$e = l$25("dynamic-tags", [l$25("input", {
  minWidth: "var(--n-input-width)"
})]);
let t$b;
const d$f = () => {
  if (!e$1O)
    return true;
  if (t$b === void 0) {
    const e28 = document.createElement("div");
    e28.style.display = "flex", e28.style.flexDirection = "column", e28.style.rowGap = "1px", e28.appendChild(document.createElement("div")), e28.appendChild(document.createElement("div")), document.body.appendChild(e28);
    const r3 = e28.scrollHeight === 1;
    return document.body.removeChild(e28), t$b = r3;
  }
  return t$b;
};
const p$2s = {
  gapSmall: "4px 8px",
  gapMedium: "8px 12px",
  gapLarge: "12px 16px"
};
const e$5 = () => p$2s, o$9 = {
  name: "Space",
  self: e$5
}, a$v = o$9;
const O$d = Object.assign(Object.assign({}, _$F.props), {
  align: String,
  justify: {
    type: String,
    default: "start"
  },
  inline: Boolean,
  vertical: Boolean,
  reverse: Boolean,
  size: {
    type: [String, Number, Array],
    default: "medium"
  },
  wrapItem: {
    type: Boolean,
    default: true
  },
  itemClass: String,
  itemStyle: [String, Object],
  wrap: {
    type: Boolean,
    default: true
  },
  internalUseGap: {
    type: Boolean,
    default: void 0
  }
}), q$7 = defineComponent({
  name: "Space",
  props: O$d,
  setup(e28) {
    const {
      mergedClsPrefixRef: a3,
      mergedRtlRef: f3
    } = a$2x(e28), g3 = _$F("Space", "-space", void 0, a$v, e28, a3), t3 = v$17("Space", f3, a3);
    return {
      useGap: d$f(),
      rtlEnabled: t3,
      mergedClsPrefix: a3,
      margin: computed(() => {
        const {
          size: r3
        } = e28;
        if (Array.isArray(r3))
          return {
            horizontal: r3[0],
            vertical: r3[1]
          };
        if (typeof r3 == "number")
          return {
            horizontal: r3,
            vertical: r3
          };
        const {
          self: {
            [_$H("gap", r3)]: u3
          }
        } = g3.value, {
          row: n3,
          col: d3
        } = s$1I(u3);
        return {
          horizontal: i$1y(d3),
          vertical: i$1y(n3)
        };
      })
    };
  },
  render() {
    const {
      vertical: e28,
      reverse: a3,
      align: f3,
      inline: g3,
      justify: t3,
      itemClass: r3,
      itemStyle: u3,
      margin: n3,
      wrap: d3,
      mergedClsPrefix: h3,
      rtlEnabled: v3,
      useGap: l3,
      wrapItem: z3,
      internalUseGap: B3
    } = this, p3 = i$1A(l$1u(this), false);
    if (!p3.length)
      return null;
    const S3 = `${n3.horizontal}px`, m3 = `${n3.horizontal / 2}px`, $3 = `${n3.vertical}px`, i = `${n3.vertical / 2}px`, s3 = p3.length - 1, c3 = t3.startsWith("space-");
    return h$1R("div", {
      role: "none",
      class: [`${h3}-space`, v3 && `${h3}-space--rtl`],
      style: {
        display: g3 ? "inline-flex" : "flex",
        flexDirection: (() => e28 && !a3 ? "column" : e28 && a3 ? "column-reverse" : !e28 && a3 ? "row-reverse" : "row")(),
        justifyContent: ["start", "end"].includes(t3) ? "flex-" + t3 : t3,
        flexWrap: !d3 || e28 ? "nowrap" : "wrap",
        marginTop: l3 || e28 ? "" : `-${i}`,
        marginBottom: l3 || e28 ? "" : `-${i}`,
        alignItems: f3,
        gap: l3 ? `${n3.vertical}px ${n3.horizontal}px` : ""
      }
    }, !z3 && (l3 || B3) ? p3 : p3.map((y3, o3) => y3.type === Comment ? y3 : h$1R("div", {
      role: "none",
      class: r3,
      style: [u3, {
        maxWidth: "100%"
      }, l3 ? "" : e28 ? {
        marginBottom: o3 !== s3 ? $3 : ""
      } : v3 ? {
        marginLeft: c3 ? t3 === "space-between" && o3 === s3 ? "" : m3 : o3 !== s3 ? S3 : "",
        marginRight: c3 ? t3 === "space-between" && o3 === 0 ? "" : m3 : "",
        paddingTop: i,
        paddingBottom: i
      } : {
        marginRight: c3 ? t3 === "space-between" && o3 === s3 ? "" : m3 : o3 !== s3 ? S3 : "",
        marginLeft: c3 ? t3 === "space-between" && o3 === 0 ? "" : m3 : "",
        paddingTop: i,
        paddingBottom: i
      }]
    }, y3)));
  }
});
const n$d = G$w({
  name: "DynamicTags",
  common: d$1T,
  peers: {
    Input: k$H,
    Button: B$P,
    Tag: w$F,
    Space: a$v
  },
  self() {
    return {
      inputWidth: "64px"
    };
  }
}), f$e = n$d;
const ne$4 = Object.assign(Object.assign(Object.assign({}, _$F.props), e$1i), {
  size: {
    type: String,
    default: "medium"
  },
  closable: {
    type: Boolean,
    default: true
  },
  defaultValue: {
    type: Array,
    default: () => []
  },
  value: Array,
  inputClass: String,
  inputStyle: [String, Object],
  inputProps: Object,
  max: Number,
  tagClass: String,
  tagStyle: [String, Object],
  renderTag: Function,
  onCreate: {
    type: Function,
    default: (t3) => t3
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onChange: [Function, Array]
}), Te$2 = defineComponent({
  name: "DynamicTags",
  props: ne$4,
  setup(t3) {
    const {
      mergedClsPrefixRef: y3,
      inlineThemeDisabled: d3
    } = a$2x(t3), {
      localeRef: c3
    } = R$p("DynamicTags"), m3 = h$1B(t3), {
      mergedDisabledRef: i
    } = m3, f3 = ref$1(""), p3 = ref$1(false), g3 = ref$1(true), C3 = ref$1(null), b3 = _$F("DynamicTags", "-dynamic-tags", n$e, f$e, t3, y3), R3 = ref$1(t3.defaultValue), O3 = toRef$1(t3, "value"), s3 = d$1S(O3, R3), F3 = computed(() => c3.value.add), z3 = computed(() => r$1o(t3.size)), D3 = computed(() => i.value || !!t3.max && s3.value.length >= t3.max);
    function T3(e28) {
      const {
        onChange: n3,
        "onUpdate:value": a3,
        onUpdateValue: l3
      } = t3, {
        nTriggerFormInput: B3,
        nTriggerFormChange: P3
      } = m3;
      n3 && i$1Z(n3, e28), l3 && i$1Z(l3, e28), a3 && i$1Z(a3, e28), R3.value = e28, B3(), P3();
    }
    function I3(e28) {
      const n3 = s3.value.slice(0);
      n3.splice(e28, 1), T3(n3);
    }
    function w3(e28) {
      switch (e28.key) {
        case "Enter":
          o3();
      }
    }
    function o3(e28) {
      const n3 = e28 != null ? e28 : f3.value;
      if (n3) {
        const a3 = s3.value.slice(0);
        a3.push(t3.onCreate(n3)), T3(a3);
      }
      p3.value = false, g3.value = true, f3.value = "";
    }
    function A3() {
      o3();
    }
    function S3() {
      p3.value = true, nextTick(() => {
        var e28;
        (e28 = C3.value) === null || e28 === void 0 || e28.focus(), g3.value = false;
      });
    }
    const h3 = computed(() => {
      const {
        self: {
          inputWidth: e28
        }
      } = b3.value;
      return {
        "--n-input-width": e28
      };
    }), r3 = d3 ? E$J("dynamic-tags", void 0, h3, t3) : void 0;
    return {
      mergedClsPrefix: y3,
      inputInstRef: C3,
      localizedAdd: F3,
      inputSize: z3,
      inputValue: f3,
      showInput: p3,
      inputForceFocused: g3,
      mergedValue: s3,
      mergedDisabled: i,
      triggerDisabled: D3,
      handleInputKeyDown: w3,
      handleAddClick: S3,
      handleInputBlur: A3,
      handleCloseClick: I3,
      handleInputConfirm: o3,
      mergedTheme: b3,
      cssVars: d3 ? void 0 : h3,
      themeClass: r3 == null ? void 0 : r3.themeClass,
      onRender: r3 == null ? void 0 : r3.onRender
    };
  },
  render() {
    const {
      mergedTheme: t3,
      cssVars: y3,
      mergedClsPrefix: d3,
      onRender: c3,
      renderTag: m3
    } = this;
    return c3 == null || c3(), h$1R(q$7, {
      class: [`${d3}-dynamic-tags`, this.themeClass],
      size: "small",
      style: y3,
      theme: t3.peers.Space,
      themeOverrides: t3.peerOverrides.Space,
      itemStyle: "display: flex;"
    }, {
      default: () => {
        const {
          mergedTheme: i,
          tagClass: f3,
          tagStyle: p3,
          type: g3,
          round: C3,
          size: b3,
          color: R3,
          closable: O3,
          mergedDisabled: s3,
          showInput: F3,
          inputValue: z3,
          inputClass: D3,
          inputStyle: T3,
          inputSize: I3,
          inputForceFocused: w3,
          triggerDisabled: o3,
          handleInputKeyDown: A3,
          handleInputBlur: S3,
          handleAddClick: h3,
          handleCloseClick: r3,
          handleInputConfirm: e28,
          $slots: n3
        } = this;
        return this.mergedValue.map((a3, l3) => m3 ? m3(a3, l3) : h$1R(He$7, {
          key: l3,
          theme: i.peers.Tag,
          themeOverrides: i.peerOverrides.Tag,
          class: f3,
          style: p3,
          type: g3,
          round: C3,
          size: b3,
          color: R3,
          closable: O3,
          disabled: s3,
          onClose: () => {
            r3(l3);
          }
        }, {
          default: () => typeof a3 == "string" ? a3 : a3.label
        })).concat(F3 ? n3.input ? n3.input({
          submit: e28,
          deactivate: S3
        }) : h$1R(Zn$3, Object.assign({
          placeholder: "",
          size: I3,
          style: T3,
          class: D3,
          autosize: true
        }, this.inputProps, {
          ref: "inputInstRef",
          value: z3,
          onUpdateValue: (a3) => {
            this.inputValue = a3;
          },
          theme: i.peers.Input,
          themeOverrides: i.peerOverrides.Input,
          onKeydown: A3,
          onBlur: S3,
          internalForceFocus: w3
        })) : n3.trigger ? n3.trigger({
          activate: h3,
          disabled: o3
        }) : h$1R(le$g, {
          dashed: true,
          disabled: o3,
          theme: i.peers.Button,
          themeOverrides: i.peerOverrides.Button,
          size: I3,
          onClick: h3
        }, {
          icon: () => h$1R(d$1R, {
            clsPrefix: d3
          }, {
            default: () => h$1R(r$18, null)
          })
        }));
      }
    });
  }
});
const g$e = defineComponent({
  name: "UIDynamicTags",
  inheritAttrs: false,
  components: { NDynamicTags: Te$2 }
}), v$c = defineComponent(__spreadProps(__spreadValues({}, g$e), {
  props: {
    id: {
      required: true,
      type: String
    },
    defaultValue: {
      type: Array,
      default: null
    },
    type: {
      type: String,
      default: "default"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 10
    },
    closable: {
      type: Boolean,
      default: true
    },
    round: {
      type: Boolean,
      default: true
    }
  },
  emits: ["onUpdate"],
  setup(e28, { emit: u3 }) {
    var _a2;
    const d3 = e28, r3 = u3, t3 = ref$1((_a2 = d3.defaultValue) != null ? _a2 : []), s3 = (a3) => {
      t3.value = u$g(a3, (l3, i) => l3.trim() === i.trim()), r3("onUpdate", t3.value);
    };
    return (a3, l3) => (openBlock(), createBlock(unref(Te$2), mergeProps({
      value: t3.value,
      type: e28.type,
      disabled: e28.disabled,
      max: e28.max,
      closable: e28.closable,
      round: e28.round,
      class: [`hl-${e28.type}`]
    }, a3.$attrs, { "onUpdate:value": s3 }), null, 16, ["value", "type", "disabled", "max", "closable", "round", "class"]));
  }
})), B$d = v$c;
const C$r = { class: "hl-empty" }, S$b = {
  key: 1,
  class: "hl-empty-icon-container"
}, x$a = { class: "hl-empty-icon" }, T$a = {
  key: 2,
  class: "hl-empty-title"
}, $$3 = {
  key: 3,
  class: "hl-empty-description"
}, I$a = { class: "hl-empty-actions" }, B$c = defineComponent({
  name: "UIEmpty",
  inheritAttrs: false
}), E$9 = defineComponent(__spreadProps(__spreadValues({}, B$c), {
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    positiveText: {
      type: String,
      default: ""
    },
    icon: {
      type: Function,
      default: a$1K
    },
    negativeText: {
      type: String,
      default: ""
    },
    positiveIcon: {
      type: Function,
      default: () => ""
    }
  },
  setup(t3) {
    const p3 = useSlots();
    return (d3, n3) => (openBlock(), createElementBlock("div", C$r, [
      createElementVNode("div", null, [
        unref(p3).media ? renderSlot(d3.$slots, "media", { key: 0 }) : (openBlock(), createElementBlock("div", S$b, [
          createElementVNode("div", x$a, [
            (openBlock(), createBlock(resolveDynamicComponent(t3.icon), { class: "w-5 h-6" }))
          ])
        ])),
        t3.title ? (openBlock(), createElementBlock("div", T$a, toDisplayString(t3.title), 1)) : createCommentVNode("", true),
        t3.description ? (openBlock(), createElementBlock("div", $$3, toDisplayString(t3.description), 1)) : createCommentVNode("", true)
      ]),
      createElementVNode("div", I$a, [
        t3.negativeText ? (openBlock(), createBlock(unref(q$C), {
          key: 0,
          id: `${t3.id}-btn-negative-action`,
          onClick: n3[0] || (n3[0] = (f3) => d3.$emit("negativeClick"))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(t3.negativeText), 1)
          ]),
          _: 1
        }, 8, ["id"])) : createCommentVNode("", true),
        t3.positiveText ? (openBlock(), createBlock(unref(q$C), {
          key: 1,
          id: `${t3.id}-btn-positive-action`,
          type: "primary",
          onClick: n3[1] || (n3[1] = (f3) => d3.$emit("positiveClick"))
        }, {
          default: withCtx(() => [
            t3.positiveIcon ? (openBlock(), createBlock(resolveDynamicComponent(t3.positiveIcon), {
              key: 0,
              class: "w-5 h-6"
            })) : createCommentVNode("", true),
            createTextVNode(" " + toDisplayString(t3.positiveText), 1)
          ]),
          _: 1
        }, 8, ["id"])) : createCommentVNode("", true)
      ])
    ]));
  }
})), D$d = E$9;
const B$b = { class: "hl-header" }, S$a = {
  key: 0,
  class: "back"
}, $$2 = {
  key: 1,
  class: "header"
}, w$8 = { class: "hl-header-content" }, U$5 = { class: "hl-title-container" }, A$9 = { class: "flex" }, O$c = { class: "space-x-2 flex" }, N$c = { key: 3 }, D$c = {
  key: 2,
  class: "footer"
}, V$9 = defineComponent({
  name: "UIHeader",
  inheritAttrs: false
}), M$4 = defineComponent(__spreadProps(__spreadValues({}, V$9), {
  props: {
    title: {
      type: String,
      default: ""
    },
    secondaryTitle: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    primaryText: {
      type: String,
      default: void 0
    },
    secondaryText: {
      type: String,
      default: void 0
    },
    primaryActionIcon: {
      type: Function
    },
    secondaryActionIcon: {
      type: Function
    },
    primaryOptions: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      required: true
    },
    primaryButtonConfig: {
      type: Object,
      default: () => ({})
    },
    secondaryButtonConfig: {
      type: Object,
      default: () => ({})
    }
  },
  setup(t3) {
    const y3 = useSlots();
    return (n3, a3) => (openBlock(), createElementBlock("div", B$b, [
      unref(y3).back ? (openBlock(), createElementBlock("div", S$a, [
        renderSlot(n3.$slots, "back")
      ])) : createCommentVNode("", true),
      unref(y3).header ? (openBlock(), createElementBlock("div", $$2, [
        renderSlot(n3.$slots, "header")
      ])) : createCommentVNode("", true),
      createElementVNode("div", w$8, [
        createElementVNode("div", U$5, [
          t3.title ? (openBlock(), createBlock(unref(c$1T), {
            key: 0,
            class: "title"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(t3.title), 1)
            ]),
            _: 1
          })) : createCommentVNode("", true),
          t3.secondaryTitle ? (openBlock(), createBlock(unref(p$3z), { key: 1 }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(t3.secondaryTitle), 1)
            ]),
            _: 1
          })) : createCommentVNode("", true),
          t3.description ? (openBlock(), createBlock(resolveDynamicComponent(t3.secondaryTitle ? unref(f$1w) : unref(_$D)), {
            key: 2,
            class: "description max-w-3xl"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(t3.description), 1)
            ]),
            _: 1
          })) : createCommentVNode("", true)
        ]),
        createElementVNode("div", A$9, [
          createElementVNode("div", O$c, [
            t3.secondaryText ? (openBlock(), createBlock(unref(q$C), {
              key: 0,
              onClick: a3[0] || (a3[0] = (g3) => n3.$emit("secondaryClick")),
              id: `${t3.id}-btn-secondary`,
              loading: t3.secondaryButtonConfig.loading,
              disabled: t3.secondaryButtonConfig.disabled
            }, {
              default: withCtx(() => [
                (openBlock(), createBlock(resolveDynamicComponent(t3.secondaryActionIcon), { class: "w-5 h-4 mr-1" })),
                createTextVNode(" " + toDisplayString(t3.secondaryText), 1)
              ]),
              _: 1
            }, 8, ["id", "loading", "disabled"])) : createCommentVNode("", true),
            t3.primaryText && !t3.primaryOptions.length ? (openBlock(), createBlock(unref(q$C), {
              key: 1,
              onClick: a3[1] || (a3[1] = (g3) => n3.$emit("primaryClick")),
              type: "primary",
              id: `${t3.id}-btn-primary`,
              loading: t3.primaryButtonConfig.loading,
              disabled: t3.primaryButtonConfig.disabled
            }, {
              default: withCtx(() => [
                (openBlock(), createBlock(resolveDynamicComponent(t3.primaryActionIcon), { class: "w-5 h-4 mr-1" })),
                createTextVNode(" " + toDisplayString(t3.primaryText), 1)
              ]),
              _: 1
            }, 8, ["id", "loading", "disabled"])) : createCommentVNode("", true),
            t3.primaryOptions && t3.primaryOptions.length ? (openBlock(), createBlock(unref(g$Q), {
              key: 2,
              options: t3.primaryOptions,
              onSelect: a3[2] || (a3[2] = (g3) => n3.$emit("primaryClick", g3)),
              id: `${t3.id}-dropdown-primary`
            }, {
              default: withCtx(() => [
                createVNode(unref(q$C), {
                  type: "primary",
                  id: `${t3.id}-dropdown-btn-primary`,
                  loading: t3.primaryButtonConfig.loading,
                  disabled: t3.primaryButtonConfig.disabled
                }, {
                  default: withCtx(() => [
                    (openBlock(), createBlock(resolveDynamicComponent(t3.primaryActionIcon), { class: "w-5 h-4 mr-1" })),
                    createTextVNode(" " + toDisplayString(t3.primaryText), 1)
                  ]),
                  _: 1
                }, 8, ["id", "loading", "disabled"])
              ]),
              _: 1
            }, 8, ["options", "id"])) : createCommentVNode("", true),
            unref(y3).extra ? (openBlock(), createElementBlock("div", N$c, [
              renderSlot(n3.$slots, "extra")
            ])) : createCommentVNode("", true)
          ])
        ])
      ]),
      unref(y3).footer ? (openBlock(), createElementBlock("div", D$c, [
        renderSlot(n3.$slots, "footer")
      ])) : createCommentVNode("", true)
    ]));
  }
})), Q$5 = M$4;
const T$9 = /^[a-z0-9]+(-[a-z0-9]+)*$/, N$b = (t3, e28, n3, r3 = "") => {
  const o3 = t3.split(":");
  if (t3.slice(0, 1) === "@") {
    if (o3.length < 2 || o3.length > 3)
      return null;
    r3 = o3.shift().slice(1);
  }
  if (o3.length > 3 || !o3.length)
    return null;
  if (o3.length > 1) {
    const c3 = o3.pop(), l3 = o3.pop(), f3 = {
      provider: o3.length > 0 ? o3[0] : r3,
      prefix: l3,
      name: c3
    };
    return e28 && !F$b(f3) ? null : f3;
  }
  const i = o3[0], s3 = i.split("-");
  if (s3.length > 1) {
    const c3 = {
      provider: r3,
      prefix: s3.shift(),
      name: s3.join("-")
    };
    return e28 && !F$b(c3) ? null : c3;
  }
  if (n3 && r3 === "") {
    const c3 = {
      provider: r3,
      prefix: "",
      name: i
    };
    return e28 && !F$b(c3, n3) ? null : c3;
  }
  return null;
}, F$b = (t3, e28) => t3 ? !!((t3.provider === "" || t3.provider.match(T$9)) && (e28 && t3.prefix === "" || t3.prefix.match(T$9)) && t3.name.match(T$9)) : false, gt$1 = Object.freeze({
  left: 0,
  top: 0,
  width: 16,
  height: 16
}), _$a = Object.freeze({
  rotate: 0,
  vFlip: false,
  hFlip: false
}), E$8 = Object.freeze(__spreadValues(__spreadValues({}, gt$1), _$a)), Q$4 = Object.freeze(__spreadProps(__spreadValues({}, E$8), {
  body: "",
  hidden: false
}));
function Ot$1(t3, e28) {
  const n3 = {};
  !t3.hFlip != !e28.hFlip && (n3.hFlip = true), !t3.vFlip != !e28.vFlip && (n3.vFlip = true);
  const r3 = ((t3.rotate || 0) + (e28.rotate || 0)) % 4;
  return r3 && (n3.rotate = r3), n3;
}
function et$1(t3, e28) {
  const n3 = Ot$1(t3, e28);
  for (const r3 in Q$4)
    r3 in _$a ? r3 in t3 && !(r3 in n3) && (n3[r3] = _$a[r3]) : r3 in e28 ? n3[r3] = e28[r3] : r3 in t3 && (n3[r3] = t3[r3]);
  return n3;
}
function At$1(t3, e28) {
  const n3 = t3.icons, r3 = t3.aliases || /* @__PURE__ */ Object.create(null), o3 = /* @__PURE__ */ Object.create(null);
  function i(s3) {
    if (n3[s3])
      return o3[s3] = [];
    if (!(s3 in o3)) {
      o3[s3] = null;
      const c3 = r3[s3] && r3[s3].parent, l3 = c3 && i(c3);
      l3 && (o3[s3] = [c3].concat(l3));
    }
    return o3[s3];
  }
  return (e28 || Object.keys(n3).concat(Object.keys(r3))).forEach(i), o3;
}
function _t$1(t3, e28, n3) {
  const r3 = t3.icons, o3 = t3.aliases || /* @__PURE__ */ Object.create(null);
  let i = {};
  function s3(c3) {
    i = et$1(r3[c3] || o3[c3], i);
  }
  return s3(e28), n3.forEach(s3), et$1(t3, i);
}
function mt$2(t3, e28) {
  const n3 = [];
  if (typeof t3 != "object" || typeof t3.icons != "object")
    return n3;
  t3.not_found instanceof Array && t3.not_found.forEach((o3) => {
    e28(o3, null), n3.push(o3);
  });
  const r3 = At$1(t3);
  for (const o3 in r3) {
    const i = r3[o3];
    i && (e28(o3, _t$1(t3, o3, i)), n3.push(o3));
  }
  return n3;
}
const Nt$1 = __spreadValues({
  provider: "",
  aliases: {},
  not_found: {}
}, gt$1);
function z$4(t3, e28) {
  for (const n3 in e28)
    if (n3 in t3 && typeof t3[n3] != typeof e28[n3])
      return false;
  return true;
}
function yt$2(t3) {
  if (typeof t3 != "object" || t3 === null)
    return null;
  const e28 = t3;
  if (typeof e28.prefix != "string" || !t3.icons || typeof t3.icons != "object" || !z$4(t3, Nt$1))
    return null;
  const n3 = e28.icons;
  for (const o3 in n3) {
    const i = n3[o3];
    if (!o3.match(T$9) || typeof i.body != "string" || !z$4(i, Q$4))
      return null;
  }
  const r3 = e28.aliases || /* @__PURE__ */ Object.create(null);
  for (const o3 in r3) {
    const i = r3[o3], s3 = i.parent;
    if (!o3.match(T$9) || typeof s3 != "string" || !n3[s3] && !r3[s3] || !z$4(i, Q$4))
      return null;
  }
  return e28;
}
const nt$1 = /* @__PURE__ */ Object.create(null);
function Dt$1(t3, e28) {
  return {
    provider: t3,
    prefix: e28,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function v$b(t3, e28) {
  const n3 = nt$1[t3] || (nt$1[t3] = /* @__PURE__ */ Object.create(null));
  return n3[e28] || (n3[e28] = Dt$1(t3, e28));
}
function G$6(t3, e28) {
  return yt$2(e28) ? mt$2(e28, (n3, r3) => {
    r3 ? t3.icons[n3] = r3 : t3.missing.add(n3);
  }) : [];
}
function Rt$1(t3, e28, n3) {
  try {
    if (typeof n3.body == "string")
      return t3.icons[e28] = __spreadValues({}, n3), true;
  } catch {
  }
  return false;
}
let j$3 = false;
function bt$1(t3) {
  return typeof t3 == "boolean" && (j$3 = t3), j$3;
}
function wt$2(t3) {
  const e28 = typeof t3 == "string" ? N$b(t3, true, j$3) : t3;
  if (e28) {
    const n3 = v$b(e28.provider, e28.prefix), r3 = e28.name;
    return n3.icons[r3] || (n3.missing.has(r3) ? null : void 0);
  }
}
function zt$1(t3, e28) {
  const n3 = N$b(t3, true, j$3);
  if (!n3)
    return false;
  const r3 = v$b(n3.provider, n3.prefix);
  return Rt$1(r3, n3.name, e28);
}
function Bt$1(t3, e28) {
  if (typeof t3 != "object")
    return false;
  if (typeof e28 != "string" && (e28 = t3.provider || ""), j$3 && !e28 && !t3.prefix) {
    let o3 = false;
    return yt$2(t3) && (t3.prefix = "", mt$2(t3, (i, s3) => {
      s3 && zt$1(i, s3) && (o3 = true);
    })), o3;
  }
  const n3 = t3.prefix;
  if (!F$b({
    provider: e28,
    prefix: n3,
    name: "a"
  }))
    return false;
  const r3 = v$b(e28, n3);
  return !!G$6(r3, t3);
}
function Fe$3(t3) {
  const e28 = wt$2(t3);
  return e28 ? __spreadValues(__spreadValues({}, E$8), e28) : null;
}
const xt$1 = Object.freeze({
  width: null,
  height: null
}), It$1 = Object.freeze(__spreadValues(__spreadValues({}, xt$1), _$a)), Qt$1 = /(-?[0-9.]*[0-9]+[0-9.]*)/g, $t$1 = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function ot$1(t3, e28, n3) {
  if (e28 === 1)
    return t3;
  if (n3 = n3 || 100, typeof t3 == "number")
    return Math.ceil(t3 * e28 * n3) / n3;
  if (typeof t3 != "string")
    return t3;
  const r3 = t3.split(Qt$1);
  if (r3 === null || !r3.length)
    return t3;
  const o3 = [];
  let i = r3.shift(), s3 = $t$1.test(i);
  for (; ; ) {
    if (s3) {
      const c3 = parseFloat(i);
      isNaN(c3) ? o3.push(i) : o3.push(Math.ceil(c3 * e28 * n3) / n3);
    } else
      o3.push(i);
    if (i = r3.shift(), i === void 0)
      return o3.join("");
    s3 = !s3;
  }
}
const qt$1 = (t3) => t3 === "unset" || t3 === "undefined" || t3 === "none";
function Ht$1(t3, e28) {
  const n3 = __spreadValues(__spreadValues({}, E$8), t3), r3 = __spreadValues(__spreadValues({}, It$1), e28), o3 = {
    left: n3.left,
    top: n3.top,
    width: n3.width,
    height: n3.height
  };
  let i = n3.body;
  [n3, r3].forEach((w3) => {
    const h3 = [], a3 = w3.hFlip, I3 = w3.vFlip;
    let y3 = w3.rotate;
    a3 ? I3 ? y3 += 2 : (h3.push("translate(" + (o3.width + o3.left).toString() + " " + (0 - o3.top).toString() + ")"), h3.push("scale(-1 1)"), o3.top = o3.left = 0) : I3 && (h3.push("translate(" + (0 - o3.left).toString() + " " + (o3.height + o3.top).toString() + ")"), h3.push("scale(1 -1)"), o3.top = o3.left = 0);
    let b3;
    switch (y3 < 0 && (y3 -= Math.floor(y3 / 4) * 4), y3 = y3 % 4, y3) {
      case 1:
        b3 = o3.height / 2 + o3.top, h3.unshift("rotate(90 " + b3.toString() + " " + b3.toString() + ")");
        break;
      case 2:
        h3.unshift("rotate(180 " + (o3.width / 2 + o3.left).toString() + " " + (o3.height / 2 + o3.top).toString() + ")");
        break;
      case 3:
        b3 = o3.width / 2 + o3.left, h3.unshift("rotate(-90 " + b3.toString() + " " + b3.toString() + ")");
        break;
    }
    y3 % 2 === 1 && (o3.left !== o3.top && (b3 = o3.left, o3.left = o3.top, o3.top = b3), o3.width !== o3.height && (b3 = o3.width, o3.width = o3.height, o3.height = b3)), h3.length && (i = '<g transform="' + h3.join(" ") + '">' + i + "</g>");
  });
  const s3 = r3.width, c3 = r3.height, l3 = o3.width, f3 = o3.height;
  let u3, d3;
  s3 === null ? (d3 = c3 === null ? "1em" : c3 === "auto" ? f3 : c3, u3 = ot$1(d3, l3 / f3)) : (u3 = s3 === "auto" ? l3 : s3, d3 = c3 === null ? ot$1(u3, f3 / l3) : c3 === "auto" ? f3 : c3);
  const g3 = {}, m3 = (w3, h3) => {
    qt$1(h3) || (g3[w3] = h3.toString());
  };
  return m3("width", u3), m3("height", d3), g3.viewBox = o3.left.toString() + " " + o3.top.toString() + " " + l3.toString() + " " + f3.toString(), {
    attributes: g3,
    body: i
  };
}
const Ut$1 = /\sid="(\S+)"/g, Vt$1 = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let Kt$1 = 0;
function Gt$2(t3, e28 = Vt$1) {
  const n3 = [];
  let r3;
  for (; r3 = Ut$1.exec(t3); )
    n3.push(r3[1]);
  if (!n3.length)
    return t3;
  const o3 = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  return n3.forEach((i) => {
    const s3 = typeof e28 == "function" ? e28(i) : e28 + (Kt$1++).toString(), c3 = i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    t3 = t3.replace(new RegExp('([#;"])(' + c3 + ')([")]|\\.[a-z])', "g"), "$1" + s3 + o3 + "$3");
  }), t3 = t3.replace(new RegExp(o3, "g"), ""), t3;
}
const $$1 = /* @__PURE__ */ Object.create(null);
function Jt$1(t3, e28) {
  $$1[t3] = e28;
}
function q$6(t3) {
  return $$1[t3] || $$1[""];
}
function J$4(t3) {
  let e28;
  if (typeof t3.resources == "string")
    e28 = [t3.resources];
  else if (e28 = t3.resources, !(e28 instanceof Array) || !e28.length)
    return null;
  return {
    resources: e28,
    path: t3.path || "/",
    maxURL: t3.maxURL || 500,
    rotate: t3.rotate || 750,
    timeout: t3.timeout || 5e3,
    random: t3.random === true,
    index: t3.index || 0,
    dataAfterTimeout: t3.dataAfterTimeout !== false
  };
}
const W$3 = /* @__PURE__ */ Object.create(null), k$a = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], O$b = [];
for (; k$a.length > 0; )
  k$a.length === 1 || Math.random() > 0.5 ? O$b.push(k$a.shift()) : O$b.push(k$a.pop());
W$3[""] = J$4({
  resources: ["https://api.iconify.design"].concat(O$b)
});
function Wt$1(t3, e28) {
  const n3 = J$4(e28);
  return n3 === null ? false : (W$3[t3] = n3, true);
}
function X$4(t3) {
  return W$3[t3];
}
const Xt$1 = () => {
  let t3;
  try {
    if (t3 = fetch, typeof t3 == "function")
      return t3;
  } catch {
  }
};
let rt$1 = Xt$1();
function Yt$1(t3, e28) {
  const n3 = X$4(t3);
  if (!n3)
    return 0;
  let r3;
  if (!n3.maxURL)
    r3 = 0;
  else {
    let o3 = 0;
    n3.resources.forEach((s3) => {
      o3 = Math.max(o3, s3.length);
    });
    const i = e28 + ".json?icons=";
    r3 = n3.maxURL - o3 - n3.path.length - i.length;
  }
  return r3;
}
function Zt$1(t3) {
  return t3 === 404;
}
const te$3 = (t3, e28, n3) => {
  const r3 = [], o3 = Yt$1(t3, e28), i = "icons";
  let s3 = {
    type: i,
    provider: t3,
    prefix: e28,
    icons: []
  }, c3 = 0;
  return n3.forEach((l3, f3) => {
    c3 += l3.length + 1, c3 >= o3 && f3 > 0 && (r3.push(s3), s3 = {
      type: i,
      provider: t3,
      prefix: e28,
      icons: []
    }, c3 = l3.length), s3.icons.push(l3);
  }), r3.push(s3), r3;
};
function ee$3(t3) {
  if (typeof t3 == "string") {
    const e28 = X$4(t3);
    if (e28)
      return e28.path;
  }
  return "/";
}
const ne$3 = (t3, e28, n3) => {
  if (!rt$1) {
    n3("abort", 424);
    return;
  }
  let r3 = ee$3(e28.provider);
  switch (e28.type) {
    case "icons": {
      const i = e28.prefix, c3 = e28.icons.join(","), l3 = new URLSearchParams({
        icons: c3
      });
      r3 += i + ".json?" + l3.toString();
      break;
    }
    case "custom": {
      const i = e28.uri;
      r3 += i.slice(0, 1) === "/" ? i.slice(1) : i;
      break;
    }
    default:
      n3("abort", 400);
      return;
  }
  let o3 = 503;
  rt$1(t3 + r3).then((i) => {
    const s3 = i.status;
    if (s3 !== 200) {
      setTimeout(() => {
        n3(Zt$1(s3) ? "abort" : "next", s3);
      });
      return;
    }
    return o3 = 501, i.json();
  }).then((i) => {
    if (typeof i != "object" || i === null) {
      setTimeout(() => {
        i === 404 ? n3("abort", i) : n3("next", o3);
      });
      return;
    }
    setTimeout(() => {
      n3("success", i);
    });
  }).catch(() => {
    n3("next", o3);
  });
}, oe$4 = {
  prepare: te$3,
  send: ne$3
};
function re$2(t3) {
  const e28 = {
    loaded: [],
    missing: [],
    pending: []
  }, n3 = /* @__PURE__ */ Object.create(null);
  t3.sort((o3, i) => o3.provider !== i.provider ? o3.provider.localeCompare(i.provider) : o3.prefix !== i.prefix ? o3.prefix.localeCompare(i.prefix) : o3.name.localeCompare(i.name));
  let r3 = {
    provider: "",
    prefix: "",
    name: ""
  };
  return t3.forEach((o3) => {
    if (r3.name === o3.name && r3.prefix === o3.prefix && r3.provider === o3.provider)
      return;
    r3 = o3;
    const i = o3.provider, s3 = o3.prefix, c3 = o3.name, l3 = n3[i] || (n3[i] = /* @__PURE__ */ Object.create(null)), f3 = l3[s3] || (l3[s3] = v$b(i, s3));
    let u3;
    c3 in f3.icons ? u3 = e28.loaded : s3 === "" || f3.missing.has(c3) ? u3 = e28.missing : u3 = e28.pending;
    const d3 = {
      provider: i,
      prefix: s3,
      name: c3
    };
    u3.push(d3);
  }), e28;
}
function St$1(t3, e28) {
  t3.forEach((n3) => {
    const r3 = n3.loaderCallbacks;
    r3 && (n3.loaderCallbacks = r3.filter((o3) => o3.id !== e28));
  });
}
function ie$3(t3) {
  t3.pendingCallbacksFlag || (t3.pendingCallbacksFlag = true, setTimeout(() => {
    t3.pendingCallbacksFlag = false;
    const e28 = t3.loaderCallbacks ? t3.loaderCallbacks.slice(0) : [];
    if (!e28.length)
      return;
    let n3 = false;
    const r3 = t3.provider, o3 = t3.prefix;
    e28.forEach((i) => {
      const s3 = i.icons, c3 = s3.pending.length;
      s3.pending = s3.pending.filter((l3) => {
        if (l3.prefix !== o3)
          return true;
        const f3 = l3.name;
        if (t3.icons[f3])
          s3.loaded.push({
            provider: r3,
            prefix: o3,
            name: f3
          });
        else if (t3.missing.has(f3))
          s3.missing.push({
            provider: r3,
            prefix: o3,
            name: f3
          });
        else
          return n3 = true, true;
        return false;
      }), s3.pending.length !== c3 && (n3 || St$1([t3], i.id), i.callback(s3.loaded.slice(0), s3.missing.slice(0), s3.pending.slice(0), i.abort));
    });
  }));
}
let se$3 = 0;
function ce$2(t3, e28, n3) {
  const r3 = se$3++, o3 = St$1.bind(null, n3, r3);
  if (!e28.pending.length)
    return o3;
  const i = {
    id: r3,
    icons: e28,
    callback: t3,
    abort: o3
  };
  return n3.forEach((s3) => {
    (s3.loaderCallbacks || (s3.loaderCallbacks = [])).push(i);
  }), o3;
}
function le$2(t3, e28 = true, n3 = false) {
  const r3 = [];
  return t3.forEach((o3) => {
    const i = typeof o3 == "string" ? N$b(o3, e28, n3) : o3;
    i && r3.push(i);
  }), r3;
}
var fe$2 = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: false,
  dataAfterTimeout: false
};
function ue$2(t3, e28, n3, r3) {
  const o3 = t3.resources.length, i = t3.random ? Math.floor(Math.random() * o3) : t3.index;
  let s3;
  if (t3.random) {
    let p3 = t3.resources.slice(0);
    for (s3 = []; p3.length > 1; ) {
      const x3 = Math.floor(Math.random() * p3.length);
      s3.push(p3[x3]), p3 = p3.slice(0, x3).concat(p3.slice(x3 + 1));
    }
    s3 = s3.concat(p3);
  } else
    s3 = t3.resources.slice(i).concat(t3.resources.slice(0, i));
  const c3 = Date.now();
  let l3 = "pending", f3 = 0, u3, d3 = null, g3 = [], m3 = [];
  typeof r3 == "function" && m3.push(r3);
  function w3() {
    d3 && (clearTimeout(d3), d3 = null);
  }
  function h3() {
    l3 === "pending" && (l3 = "aborted"), w3(), g3.forEach((p3) => {
      p3.status === "pending" && (p3.status = "aborted");
    }), g3 = [];
  }
  function a3(p3, x3) {
    x3 && (m3 = []), typeof p3 == "function" && m3.push(p3);
  }
  function I3() {
    return {
      startTime: c3,
      payload: e28,
      status: l3,
      queriesSent: f3,
      queriesPending: g3.length,
      subscribe: a3,
      abort: h3
    };
  }
  function y3() {
    l3 = "failed", m3.forEach((p3) => {
      p3(void 0, u3);
    });
  }
  function b3() {
    g3.forEach((p3) => {
      p3.status === "pending" && (p3.status = "aborted");
    }), g3 = [];
  }
  function Lt2(p3, x3, C3) {
    const M3 = x3 !== "success";
    switch (g3 = g3.filter((S3) => S3 !== p3), l3) {
      case "pending":
        break;
      case "failed":
        if (M3 || !t3.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (x3 === "abort") {
      u3 = C3, y3();
      return;
    }
    if (M3) {
      u3 = C3, g3.length || (s3.length ? R3() : y3());
      return;
    }
    if (w3(), b3(), !t3.random) {
      const S3 = t3.resources.indexOf(p3.resource);
      S3 !== -1 && S3 !== t3.index && (t3.index = S3);
    }
    l3 = "completed", m3.forEach((S3) => {
      S3(C3);
    });
  }
  function R3() {
    if (l3 !== "pending")
      return;
    w3();
    const p3 = s3.shift();
    if (p3 === void 0) {
      if (g3.length) {
        d3 = setTimeout(() => {
          w3(), l3 === "pending" && (b3(), y3());
        }, t3.timeout);
        return;
      }
      y3();
      return;
    }
    const x3 = {
      status: "pending",
      resource: p3,
      callback: (C3, M3) => {
        Lt2(x3, C3, M3);
      }
    };
    g3.push(x3), f3++, d3 = setTimeout(R3, t3.rotate), n3(p3, e28, x3.callback);
  }
  return setTimeout(R3), I3;
}
function vt$1(t3) {
  const e28 = __spreadValues(__spreadValues({}, fe$2), t3);
  let n3 = [];
  function r3() {
    n3 = n3.filter((c3) => c3().status === "pending");
  }
  function o3(c3, l3, f3) {
    const u3 = ue$2(e28, c3, l3, (d3, g3) => {
      r3(), f3 && f3(d3, g3);
    });
    return n3.push(u3), u3;
  }
  function i(c3) {
    return n3.find((l3) => c3(l3)) || null;
  }
  return {
    query: o3,
    find: i,
    setIndex: (c3) => {
      e28.index = c3;
    },
    getIndex: () => e28.index,
    cleanup: r3
  };
}
function it$1() {
}
const B$a = /* @__PURE__ */ Object.create(null);
function ae$3(t3) {
  if (!B$a[t3]) {
    const e28 = X$4(t3);
    if (!e28)
      return;
    const n3 = vt$1(e28), r3 = {
      config: e28,
      redundancy: n3
    };
    B$a[t3] = r3;
  }
  return B$a[t3];
}
function de$3(t3, e28, n3) {
  let r3, o3;
  if (typeof t3 == "string") {
    const i = q$6(t3);
    if (!i)
      return n3(void 0, 424), it$1;
    o3 = i.send;
    const s3 = ae$3(t3);
    s3 && (r3 = s3.redundancy);
  } else {
    const i = J$4(t3);
    if (i) {
      r3 = vt$1(i);
      const s3 = t3.resources ? t3.resources[0] : "", c3 = q$6(s3);
      c3 && (o3 = c3.send);
    }
  }
  return !r3 || !o3 ? (n3(void 0, 424), it$1) : r3.query(e28, o3, n3)().abort;
}
const st$1 = "iconify2", P$a = "iconify", Ct$1 = P$a + "-count", ct$1 = P$a + "-version", kt$1 = 36e5, he$1 = 168;
function H$6(t3, e28) {
  try {
    return t3.getItem(e28);
  } catch {
  }
}
function Y$3(t3, e28, n3) {
  try {
    return t3.setItem(e28, n3), true;
  } catch {
  }
}
function lt$1(t3, e28) {
  try {
    t3.removeItem(e28);
  } catch {
  }
}
function U$4(t3, e28) {
  return Y$3(t3, Ct$1, e28.toString());
}
function V$8(t3) {
  return parseInt(H$6(t3, Ct$1)) || 0;
}
const D$b = {
  local: true,
  session: true
}, Tt$1 = {
  local: /* @__PURE__ */ new Set(),
  session: /* @__PURE__ */ new Set()
};
let Z$6 = false;
function pe$2(t3) {
  Z$6 = t3;
}
let L$b = typeof window > "u" ? {} : window;
function jt$1(t3) {
  const e28 = t3 + "Storage";
  try {
    if (L$b && L$b[e28] && typeof L$b[e28].length == "number")
      return L$b[e28];
  } catch {
  }
  D$b[t3] = false;
}
function Pt$1(t3, e28) {
  const n3 = jt$1(t3);
  if (!n3)
    return;
  const r3 = H$6(n3, ct$1);
  if (r3 !== st$1) {
    if (r3) {
      const c3 = V$8(n3);
      for (let l3 = 0; l3 < c3; l3++)
        lt$1(n3, P$a + l3.toString());
    }
    Y$3(n3, ct$1, st$1), U$4(n3, 0);
    return;
  }
  const o3 = Math.floor(Date.now() / kt$1) - he$1, i = (c3) => {
    const l3 = P$a + c3.toString(), f3 = H$6(n3, l3);
    if (typeof f3 == "string") {
      try {
        const u3 = JSON.parse(f3);
        if (typeof u3 == "object" && typeof u3.cached == "number" && u3.cached > o3 && typeof u3.provider == "string" && typeof u3.data == "object" && typeof u3.data.prefix == "string" && e28(u3, c3))
          return true;
      } catch {
      }
      lt$1(n3, l3);
    }
  };
  let s3 = V$8(n3);
  for (let c3 = s3 - 1; c3 >= 0; c3--)
    i(c3) || (c3 === s3 - 1 ? (s3--, U$4(n3, s3)) : Tt$1[t3].add(c3));
}
function Et$1() {
  if (!Z$6) {
    pe$2(true);
    for (const t3 in D$b)
      Pt$1(t3, (e28) => {
        const n3 = e28.data, r3 = e28.provider, o3 = n3.prefix, i = v$b(r3, o3);
        if (!G$6(i, n3).length)
          return false;
        const s3 = n3.lastModified || -1;
        return i.lastModifiedCached = i.lastModifiedCached ? Math.min(i.lastModifiedCached, s3) : s3, true;
      });
  }
}
function ge$3(t3, e28) {
  const n3 = t3.lastModifiedCached;
  if (n3 && n3 >= e28)
    return n3 === e28;
  if (t3.lastModifiedCached = e28, n3)
    for (const r3 in D$b)
      Pt$1(r3, (o3) => {
        const i = o3.data;
        return o3.provider !== t3.provider || i.prefix !== t3.prefix || i.lastModified === e28;
      });
  return true;
}
function me$3(t3, e28) {
  Z$6 || Et$1();
  function n3(r3) {
    let o3;
    if (!D$b[r3] || !(o3 = jt$1(r3)))
      return;
    const i = Tt$1[r3];
    let s3;
    if (i.size)
      i.delete(s3 = Array.from(i).shift());
    else if (s3 = V$8(o3), !U$4(o3, s3 + 1))
      return;
    const c3 = {
      cached: Math.floor(Date.now() / kt$1),
      provider: t3.provider,
      data: e28
    };
    return Y$3(o3, P$a + s3.toString(), JSON.stringify(c3));
  }
  e28.lastModified && !ge$3(t3, e28.lastModified) || Object.keys(e28.icons).length && (e28.not_found && (e28 = Object.assign({}, e28), delete e28.not_found), n3("local") || n3("session"));
}
function ft$1() {
}
function ye$3(t3) {
  t3.iconsLoaderFlag || (t3.iconsLoaderFlag = true, setTimeout(() => {
    t3.iconsLoaderFlag = false, ie$3(t3);
  }));
}
function be$3(t3, e28) {
  t3.iconsToLoad ? t3.iconsToLoad = t3.iconsToLoad.concat(e28).sort() : t3.iconsToLoad = e28, t3.iconsQueueFlag || (t3.iconsQueueFlag = true, setTimeout(() => {
    t3.iconsQueueFlag = false;
    const { provider: n3, prefix: r3 } = t3, o3 = t3.iconsToLoad;
    delete t3.iconsToLoad;
    let i;
    if (!o3 || !(i = q$6(n3)))
      return;
    i.prepare(n3, r3, o3).forEach((c3) => {
      de$3(n3, c3, (l3) => {
        if (typeof l3 != "object")
          c3.icons.forEach((f3) => {
            t3.missing.add(f3);
          });
        else
          try {
            const f3 = G$6(t3, l3);
            if (!f3.length)
              return;
            const u3 = t3.pendingIcons;
            u3 && f3.forEach((d3) => {
              u3.delete(d3);
            }), me$3(t3, l3);
          } catch (f3) {
            console.error(f3);
          }
        ye$3(t3);
      });
    });
  }));
}
const we$2 = (t3, e28) => {
  const n3 = le$2(t3, true, bt$1()), r3 = re$2(n3);
  if (!r3.pending.length) {
    let l3 = true;
    return e28 && setTimeout(() => {
      l3 && e28(r3.loaded, r3.missing, r3.pending, ft$1);
    }), () => {
      l3 = false;
    };
  }
  const o3 = /* @__PURE__ */ Object.create(null), i = [];
  let s3, c3;
  return r3.pending.forEach((l3) => {
    const { provider: f3, prefix: u3 } = l3;
    if (u3 === c3 && f3 === s3)
      return;
    s3 = f3, c3 = u3, i.push(v$b(f3, u3));
    const d3 = o3[f3] || (o3[f3] = /* @__PURE__ */ Object.create(null));
    d3[u3] || (d3[u3] = []);
  }), r3.pending.forEach((l3) => {
    const { provider: f3, prefix: u3, name: d3 } = l3, g3 = v$b(f3, u3), m3 = g3.pendingIcons || (g3.pendingIcons = /* @__PURE__ */ new Set());
    m3.has(d3) || (m3.add(d3), o3[f3][u3].push(d3));
  }), i.forEach((l3) => {
    const { provider: f3, prefix: u3 } = l3;
    o3[f3][u3].length && be$3(l3, o3[f3][u3]);
  }), e28 ? ce$2(e28, r3, i) : ft$1;
};
function xe$2(t3, e28) {
  const n3 = __spreadValues({}, t3);
  for (const r3 in e28) {
    const o3 = e28[r3], i = typeof o3;
    r3 in xt$1 ? (o3 === null || o3 && (i === "string" || i === "number")) && (n3[r3] = o3) : i === typeof n3[r3] && (n3[r3] = r3 === "rotate" ? o3 % 4 : o3);
  }
  return n3;
}
const Ie$1 = /[\s,]+/;
function Se$1(t3, e28) {
  e28.split(Ie$1).forEach((n3) => {
    switch (n3.trim()) {
      case "horizontal":
        t3.hFlip = true;
        break;
      case "vertical":
        t3.vFlip = true;
        break;
    }
  });
}
function ve$3(t3, e28 = 0) {
  const n3 = t3.replace(/^-?[0-9.]*/, "");
  function r3(o3) {
    for (; o3 < 0; )
      o3 += 4;
    return o3 % 4;
  }
  if (n3 === "") {
    const o3 = parseInt(t3);
    return isNaN(o3) ? 0 : r3(o3);
  } else if (n3 !== t3) {
    let o3 = 0;
    switch (n3) {
      case "%":
        o3 = 25;
        break;
      case "deg":
        o3 = 90;
    }
    if (o3) {
      let i = parseFloat(t3.slice(0, t3.length - n3.length));
      return isNaN(i) ? 0 : (i = i / o3, i % 1 === 0 ? r3(i) : 0);
    }
  }
  return e28;
}
function Ce$3(t3, e28) {
  let n3 = t3.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const r3 in e28)
    n3 += " " + r3 + '="' + e28[r3] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + n3 + ">" + t3 + "</svg>";
}
function ke$1(t3) {
  return t3.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function Te$1(t3) {
  return "data:image/svg+xml," + ke$1(t3);
}
function je$2(t3) {
  return 'url("' + Te$1(t3) + '")';
}
const ut$1 = __spreadProps(__spreadValues({}, It$1), {
  inline: false
}), Pe$1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": true,
  role: "img"
}, Ee$1 = {
  display: "inline-block"
}, K$7 = {
  backgroundColor: "currentColor"
}, Mt$1 = {
  backgroundColor: "transparent"
}, at$1 = {
  Image: "var(--svg)",
  Repeat: "no-repeat",
  Size: "100% 100%"
}, dt$1 = {
  webkitMask: K$7,
  mask: K$7,
  background: Mt$1
};
for (const t3 in dt$1) {
  const e28 = dt$1[t3];
  for (const n3 in at$1)
    e28[t3 + n3] = at$1[n3];
}
const A$8 = {};
["horizontal", "vertical"].forEach((t3) => {
  const e28 = t3.slice(0, 1) + "Flip";
  A$8[t3 + "-flip"] = e28, A$8[t3.slice(0, 1) + "-flip"] = e28, A$8[t3 + "Flip"] = e28;
});
function ht$1(t3) {
  return t3 + (t3.match(/^[-0-9.]+$/) ? "px" : "");
}
const pt$1 = (t3, e28) => {
  const n3 = xe$2(ut$1, e28), r3 = __spreadValues({}, Pe$1), o3 = e28.mode || "svg", i = {}, s3 = e28.style, c3 = typeof s3 == "object" && !(s3 instanceof Array) ? s3 : {};
  for (let h3 in e28) {
    const a3 = e28[h3];
    if (a3 !== void 0)
      switch (h3) {
        case "icon":
        case "style":
        case "onLoad":
        case "mode":
          break;
        case "inline":
        case "hFlip":
        case "vFlip":
          n3[h3] = a3 === true || a3 === "true" || a3 === 1;
          break;
        case "flip":
          typeof a3 == "string" && Se$1(n3, a3);
          break;
        case "color":
          i.color = a3;
          break;
        case "rotate":
          typeof a3 == "string" ? n3[h3] = ve$3(a3) : typeof a3 == "number" && (n3[h3] = a3);
          break;
        case "ariaHidden":
        case "aria-hidden":
          a3 !== true && a3 !== "true" && delete r3["aria-hidden"];
          break;
        default: {
          const I3 = A$8[h3];
          I3 ? (a3 === true || a3 === "true" || a3 === 1) && (n3[I3] = true) : ut$1[h3] === void 0 && (r3[h3] = a3);
        }
      }
  }
  const l3 = Ht$1(t3, n3), f3 = l3.attributes;
  if (n3.inline && (i.verticalAlign = "-0.125em"), o3 === "svg") {
    r3.style = __spreadValues(__spreadValues({}, i), c3), Object.assign(r3, f3);
    let h3 = 0, a3 = e28.id;
    return typeof a3 == "string" && (a3 = a3.replace(/-/g, "_")), r3.innerHTML = Gt$2(l3.body, a3 ? () => a3 + "ID" + h3++ : "iconifyVue"), h$1R("svg", r3);
  }
  const { body: u3, width: d3, height: g3 } = t3, m3 = o3 === "mask" || (o3 === "bg" ? false : u3.indexOf("currentColor") !== -1), w3 = Ce$3(u3, __spreadProps(__spreadValues({}, f3), {
    width: d3 + "",
    height: g3 + ""
  }));
  return r3.style = __spreadValues(__spreadValues(__spreadValues(__spreadProps(__spreadValues({}, i), {
    "--svg": je$2(w3),
    width: ht$1(f3.width),
    height: ht$1(f3.height)
  }), Ee$1), m3 ? K$7 : Mt$1), c3), h$1R("span", r3);
};
bt$1(true);
Jt$1("", oe$4);
if (typeof document < "u" && typeof window < "u") {
  Et$1();
  const t3 = window;
  if (t3.IconifyPreload !== void 0) {
    const e28 = t3.IconifyPreload, n3 = "Invalid IconifyPreload syntax.";
    typeof e28 == "object" && e28 !== null && (e28 instanceof Array ? e28 : [e28]).forEach((r3) => {
      try {
        (typeof r3 != "object" || r3 === null || r3 instanceof Array || typeof r3.icons != "object" || typeof r3.prefix != "string" || !Bt$1(r3)) && console.error(n3);
      } catch {
        console.error(n3);
      }
    });
  }
  if (t3.IconifyProviders !== void 0) {
    const e28 = t3.IconifyProviders;
    if (typeof e28 == "object" && e28 !== null)
      for (let n3 in e28) {
        const r3 = "IconifyProviders[" + n3 + "] is invalid.";
        try {
          const o3 = e28[n3];
          if (typeof o3 != "object" || !o3 || o3.resources === void 0)
            continue;
          Wt$1(n3, o3) || console.error(r3);
        } catch {
          console.error(r3);
        }
      }
  }
}
const Me$1 = __spreadProps(__spreadValues({}, E$8), {
  body: ""
}), Oe$1 = defineComponent({
  inheritAttrs: false,
  data() {
    return {
      iconMounted: false,
      counter: 0
    };
  },
  mounted() {
    this._name = "", this._loadingIcon = null, this.iconMounted = true;
  },
  unmounted() {
    this.abortLoading();
  },
  methods: {
    abortLoading() {
      this._loadingIcon && (this._loadingIcon.abort(), this._loadingIcon = null);
    },
    getIcon(t3, e28) {
      if (typeof t3 == "object" && t3 !== null && typeof t3.body == "string")
        return this._name = "", this.abortLoading(), {
          data: t3
        };
      let n3;
      if (typeof t3 != "string" || (n3 = N$b(t3, false, true)) === null)
        return this.abortLoading(), null;
      const r3 = wt$2(n3);
      if (!r3)
        return (!this._loadingIcon || this._loadingIcon.name !== t3) && (this.abortLoading(), this._name = "", r3 !== null && (this._loadingIcon = {
          name: t3,
          abort: we$2([n3], () => {
            this.counter++;
          })
        })), null;
      this.abortLoading(), this._name !== t3 && (this._name = t3, e28 && e28(t3));
      const o3 = ["iconify"];
      return n3.prefix !== "" && o3.push("iconify--" + n3.prefix), n3.provider !== "" && o3.push("iconify--" + n3.provider), { data: r3, classes: o3 };
    }
  },
  render() {
    this.counter;
    const t3 = this.$attrs, e28 = this.iconMounted ? this.getIcon(t3.icon, t3.onLoad) : null;
    if (!e28)
      return pt$1(Me$1, t3);
    let n3 = t3;
    return e28.classes && (n3 = __spreadProps(__spreadValues({}, t3), {
      class: (typeof t3.class == "string" ? t3.class + " " : "") + e28.classes.join(" ")
    })), pt$1(__spreadValues(__spreadValues({}, E$8), e28.data), n3);
  }
});
const i$g = (t3, r3) => new Promise((n3, o3) => {
  fetch(`${t3}/search?query=${r3}&limit=100`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    }
  }).then((e28) => {
    if (!e28.ok)
      throw new Error("Failed to retrieve icons. Please try again later.");
    return e28.json();
  }).then((e28) => n3(e28.icons)).catch((e28) => {
    o3(e28);
  });
});
const O$a = { class: "flex items-center" }, Q$3 = { class: "title" }, W$2 = { class: "icon-picker__container" }, X$3 = { class: "icon-picker__search" }, Y$2 = {
  key: 0,
  class: "icon-picker__icons-lists"
}, Z$5 = { key: 1 }, ee$2 = {
  key: 1,
  class: "text-gray-400 p-1 text-center"
}, te$2 = {
  name: "UIIconPicker",
  inheritAttrs: false
}, oe$3 = defineComponent(__spreadProps(__spreadValues({}, te$2), {
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: "",
      required: false
    },
    searchPlaceholder: {
      type: String,
      required: false,
      default: "Search"
    },
    trigger: {
      type: String,
      default: "click"
    },
    placement: {
      type: String,
      default: "bottom-end"
    },
    show: {
      type: Boolean,
      default: void 0
    },
    showArrow: {
      type: Boolean,
      default: false
    },
    preLoad: {
      type: String,
      default: "social"
    }
  },
  emits: ["onSelected"],
  setup(i, { emit: S3 }) {
    const x3 = S3, P3 = i, l3 = ref$1([]), c3 = ref$1(""), k3 = useSlots(), d3 = ref$1(false), y3 = ref$1();
    let h3 = [];
    const b3 = [
      "https://api.iconify.design",
      "https://api.simplesvg.com",
      "https://api.unisvg.com"
    ], B3 = s$1v("IconPicker");
    let p3 = [];
    const _3 = async (e28) => {
      if (d3.value = true, e28 === null) {
        d3.value = false;
        return;
      }
      try {
        for (const t3 of b3)
          if (!p3.includes(t3))
            try {
              const o3 = await i$g(t3, e28);
              if (o3) {
                l3.value = o3;
                break;
              }
            } catch (o3) {
              console.error(`Error loading icons from ${t3}:`, o3), p3.push(t3);
            }
        return p3.length === 3 && (p3 = []), l3.value;
      } catch (t3) {
        console.error("Error loading icons:", t3);
      } finally {
        d3.value = false;
      }
    }, C3 = (e28) => {
      u3();
      const t3 = Fe$3(e28);
      x3("onSelected", {
        class: e28,
        svg: t3.body
      }), y3.value.handleClick();
    };
    onMounted(() => {
      u3();
    }), watch(() => c3.value, _$q((e28) => {
      e28 ? _3(e28) : u3();
    }, 500), { deep: true });
    const u3 = () => {
      h3.length === 0 ? _3(P3.preLoad).then((e28) => {
        h3 = e28;
      }) : l3.value = h3, c3.value = "";
    };
    return (e28, t3) => (openBlock(), createBlock(unref(Ie$8), {
      class: "icon-picker override-shadow",
      trigger: i.trigger,
      "show-arrow": i.showArrow,
      show: i.show,
      ref_key: "popoverRef",
      ref: y3,
      placement: i.placement,
      id: i.id,
      raw: "",
      onClickoutside: u3
    }, {
      trigger: withCtx(() => [
        unref(k3).trigger ? renderSlot(e28.$slots, "trigger", { key: 0 }, void 0, true) : (openBlock(), createBlock(unref(q$C), {
          key: 1,
          size: "large",
          id: "icon-picker__button"
        }, {
          default: withCtx(() => [
            createElementVNode("div", O$a, [
              createElementVNode("span", Q$3, toDisplayString(i.title), 1)
            ])
          ]),
          _: 1
        }))
      ]),
      default: withCtx(() => [
        createElementVNode("div", W$2, [
          createElementVNode("div", X$3, [
            createVNode(unref(Zn$3), {
              id: "icon-picker-search",
              placeholder: i.searchPlaceholder,
              value: c3.value,
              "onUpdate:value": t3[0] || (t3[0] = (o3) => c3.value = o3),
              loading: d3.value,
              size: "small"
            }, {
              prefix: withCtx(() => [
                createVNode(unref(a$1j), { class: "w-4 h-4 text-gray-600" })
              ]),
              _: 1
            }, 8, ["placeholder", "value", "loading"])
          ]),
          l3.value.length ? (openBlock(), createElementBlock("div", Y$2, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(l3.value, (o3, E3) => (openBlock(), createElementBlock("div", {
              key: E3,
              class: "icon-picker__icon_wrapper"
            }, [
              createVNode(unref(w$K), null, {
                trigger: withCtx(() => [
                  createVNode(unref(Oe$1), {
                    icon: o3,
                    class: "icon-picker__icon",
                    onClick: () => C3(o3),
                    inline: ""
                  }, null, 8, ["icon", "onClick"])
                ]),
                default: withCtx(() => [
                  createTextVNode(" " + toDisplayString(o3), 1)
                ]),
                _: 2
              }, 1024)
            ]))), 128))
          ])) : (openBlock(), createElementBlock("div", Z$5, [
            unref(k3).empty ? renderSlot(e28.$slots, "emptyData", { key: 0 }, void 0, true) : (openBlock(), createElementBlock("p", ee$2, toDisplayString(unref(B3).noMatchingFound), 1))
          ]))
        ])
      ]),
      _: 3
    }, 8, ["trigger", "show-arrow", "show", "placement", "id"]));
  }
})), ve$2 = /* @__PURE__ */ s$1d(oe$3, [["__scopeId", "data-v-5ff12930"]]);
function t$a(n3) {
  return n3 == null || typeof n3 == "string" && n3.trim() === "" ? null : Number(n3);
}
function e$4(n3) {
  return n3.includes(".") && (/^(-)?\d+.*(\.|0)$/.test(n3) || /^\.\d+$/.test(n3));
}
function u$f(n3) {
  return n3 == null ? true : !Number.isNaN(n3);
}
function i$f(n3, r3) {
  return n3 == null ? "" : r3 === void 0 ? String(n3) : n3.toFixed(r3);
}
function f$d(n3) {
  if (n3 === null)
    return null;
  if (typeof n3 == "number")
    return n3;
  {
    const r3 = Number(n3);
    return Number.isNaN(r3) ? null : r3;
  }
}
const l$f = r$2a([l$25("input-number-suffix", `
 display: inline-block;
 margin-right: 10px;
 `), l$25("input-number-prefix", `
 display: inline-block;
 margin-left: 10px;
 `)]);
const i$e = (t3) => {
  const {
    textColorDisabled: o3
  } = t3;
  return {
    iconColorDisabled: o3
  };
}, u$e = G$w({
  name: "InputNumber",
  common: d$1T,
  peers: {
    Button: B$P,
    Input: k$H
  },
  self: i$e
}), b$a = u$e;
const r$p = defineComponent({
  name: "Remove",
  render() {
    return h$1R("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512"
    }, h$1R("line", {
      x1: "400",
      y1: "256",
      x2: "112",
      y2: "256",
      style: `
        fill: none;
        stroke: currentColor;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 32px;
      `
    }));
  }
});
const ee$1 = 800, te$1 = 100, Ge$1 = Object.assign(Object.assign({}, _$F.props), {
  autofocus: Boolean,
  loading: {
    type: Boolean,
    default: void 0
  },
  placeholder: String,
  defaultValue: {
    type: Number,
    default: null
  },
  value: Number,
  step: {
    type: [Number, String],
    default: 1
  },
  min: [Number, String],
  max: [Number, String],
  size: String,
  disabled: {
    type: Boolean,
    default: void 0
  },
  validator: Function,
  bordered: {
    type: Boolean,
    default: void 0
  },
  showButton: {
    type: Boolean,
    default: true
  },
  buttonPlacement: {
    type: String,
    default: "right"
  },
  inputProps: Object,
  readonly: Boolean,
  clearable: Boolean,
  keyboard: {
    type: Object,
    default: {}
  },
  updateValueOnInput: {
    type: Boolean,
    default: true
  },
  parse: Function,
  format: Function,
  precision: Number,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onClear: [Function, Array],
  onChange: [Function, Array]
}), mt$1 = defineComponent({
  name: "InputNumber",
  props: Ge$1,
  setup(n3) {
    const {
      mergedBorderedRef: i,
      mergedClsPrefixRef: g3,
      mergedRtlRef: S3
    } = a$2x(n3), u3 = _$F("InputNumber", "-input-number", l$f, b$a, n3, g3), {
      localeRef: v3
    } = R$p("InputNumber"), M3 = h$1B(n3), {
      mergedSizeRef: re2,
      mergedDisabledRef: le2,
      mergedStatusRef: ie2
    } = M3, s3 = ref$1(null), j3 = ref$1(null), z3 = ref$1(null), D3 = ref$1(n3.defaultValue), ue2 = toRef$1(n3, "value"), f3 = d$1S(ue2, D3), p3 = ref$1(""), O3 = (e28) => {
      const t3 = String(e28).split(".")[1];
      return t3 ? t3.length : 0;
    }, ae2 = (e28) => {
      const t3 = [n3.min, n3.max, n3.step, e28].map((r3) => r3 === void 0 ? 0 : O3(r3));
      return Math.max(...t3);
    }, oe2 = n$1U(() => {
      const {
        placeholder: e28
      } = n3;
      return e28 !== void 0 ? e28 : v3.value.placeholder;
    }), N3 = n$1U(() => {
      const e28 = f$d(n3.step);
      return e28 !== null ? e28 === 0 ? 1 : Math.abs(e28) : 1;
    }), G3 = n$1U(() => {
      const e28 = f$d(n3.min);
      return e28 !== null ? e28 : null;
    }), K3 = n$1U(() => {
      const e28 = f$d(n3.max);
      return e28 !== null ? e28 : null;
    }), V10 = (e28) => {
      const {
        value: t3
      } = f3;
      if (e28 === t3) {
        b3();
        return;
      }
      const {
        "onUpdate:value": r3,
        onUpdateValue: l3,
        onChange: o3
      } = n3, {
        nTriggerFormInput: c3,
        nTriggerFormChange: x3
      } = M3;
      o3 && i$1Z(o3, e28), l3 && i$1Z(l3, e28), r3 && i$1Z(r3, e28), D3.value = e28, c3(), x3();
    }, a3 = ({
      offset: e28,
      doUpdateIfValid: t3,
      fixPrecision: r3,
      isInputing: l3
    }) => {
      const {
        value: o3
      } = p3;
      if (l3 && e$4(o3))
        return false;
      const c3 = (n3.parse || t$a)(o3);
      if (c3 === null)
        return t3 && V10(null), null;
      if (u$f(c3)) {
        const x3 = O3(c3), {
          precision: R3
        } = n3;
        if (R3 !== void 0 && R3 < x3 && !r3)
          return false;
        let m3 = parseFloat((c3 + e28).toFixed(R3 != null ? R3 : ae2(c3)));
        if (u$f(m3)) {
          const {
            value: k3
          } = K3, {
            value: $3
          } = G3;
          if (k3 !== null && m3 > k3) {
            if (!t3 || l3)
              return false;
            m3 = k3;
          }
          if ($3 !== null && m3 < $3) {
            if (!t3 || l3)
              return false;
            m3 = $3;
          }
          return n3.validator && !n3.validator(m3) ? false : (t3 && V10(m3), m3);
        }
      }
      return false;
    }, b3 = () => {
      const {
        value: e28
      } = f3;
      if (u$f(e28)) {
        const {
          format: t3,
          precision: r3
        } = n3;
        t3 ? p3.value = t3(e28) : e28 === null || r3 === void 0 || O3(e28) > r3 ? p3.value = i$f(e28, void 0) : p3.value = i$f(e28, r3);
      } else
        p3.value = String(e28);
    };
    b3();
    const de2 = n$1U(() => a3({
      offset: 0,
      doUpdateIfValid: false,
      isInputing: false,
      fixPrecision: false
    }) === false), C3 = n$1U(() => {
      const {
        value: e28
      } = f3;
      if (n3.validator && e28 === null)
        return false;
      const {
        value: t3
      } = N3;
      return a3({
        offset: -t3,
        doUpdateIfValid: false,
        isInputing: false,
        fixPrecision: false
      }) !== false;
    }), F3 = n$1U(() => {
      const {
        value: e28
      } = f3;
      if (n3.validator && e28 === null)
        return false;
      const {
        value: t3
      } = N3;
      return a3({
        offset: +t3,
        doUpdateIfValid: false,
        isInputing: false,
        fixPrecision: false
      }) !== false;
    });
    function se2(e28) {
      const {
        onFocus: t3
      } = n3, {
        nTriggerFormFocus: r3
      } = M3;
      t3 && i$1Z(t3, e28), r3();
    }
    function fe2(e28) {
      var t3, r3;
      if (e28.target === ((t3 = s3.value) === null || t3 === void 0 ? void 0 : t3.wrapperElRef))
        return;
      const l3 = a3({
        offset: 0,
        doUpdateIfValid: true,
        isInputing: false,
        fixPrecision: true
      });
      if (l3 !== false) {
        const x3 = (r3 = s3.value) === null || r3 === void 0 ? void 0 : r3.inputElRef;
        x3 && (x3.value = String(l3 || "")), f3.value === l3 && b3();
      } else
        b3();
      const {
        onBlur: o3
      } = n3, {
        nTriggerFormBlur: c3
      } = M3;
      o3 && i$1Z(o3, e28), c3(), nextTick(() => {
        b3();
      });
    }
    function ce2(e28) {
      const {
        onClear: t3
      } = n3;
      t3 && i$1Z(t3, e28);
    }
    function A3() {
      const {
        value: e28
      } = F3;
      if (!e28) {
        E3();
        return;
      }
      const {
        value: t3
      } = f3;
      if (t3 === null)
        n3.validator || V10(W3());
      else {
        const {
          value: r3
        } = N3;
        a3({
          offset: r3,
          doUpdateIfValid: true,
          isInputing: false,
          fixPrecision: true
        });
      }
    }
    function U3() {
      const {
        value: e28
      } = C3;
      if (!e28) {
        _3();
        return;
      }
      const {
        value: t3
      } = f3;
      if (t3 === null)
        n3.validator || V10(W3());
      else {
        const {
          value: r3
        } = N3;
        a3({
          offset: -r3,
          doUpdateIfValid: true,
          isInputing: false,
          fixPrecision: true
        });
      }
    }
    const me2 = se2, ve2 = fe2;
    function W3() {
      if (n3.validator)
        return null;
      const {
        value: e28
      } = G3, {
        value: t3
      } = K3;
      return e28 !== null ? Math.max(0, e28) : t3 !== null ? Math.min(0, t3) : 0;
    }
    function pe2(e28) {
      ce2(e28), V10(null);
    }
    function he2(e28) {
      var t3, r3, l3;
      !((t3 = z3.value) === null || t3 === void 0) && t3.$el.contains(e28.target) && e28.preventDefault(), !((r3 = j3.value) === null || r3 === void 0) && r3.$el.contains(e28.target) && e28.preventDefault(), (l3 = s3.value) === null || l3 === void 0 || l3.activate();
    }
    let w3 = null, y3 = null, T3 = null;
    function _3() {
      T3 && (window.clearTimeout(T3), T3 = null), w3 && (window.clearInterval(w3), w3 = null);
    }
    function E3() {
      P3 && (window.clearTimeout(P3), P3 = null), y3 && (window.clearInterval(y3), y3 = null);
    }
    function ge2() {
      _3(), T3 = window.setTimeout(() => {
        w3 = window.setInterval(() => {
          U3();
        }, te$1);
      }, ee$1), J$o("mouseup", document, _3, {
        once: true
      });
    }
    let P3 = null;
    function be2() {
      E3(), P3 = window.setTimeout(() => {
        y3 = window.setInterval(() => {
          A3();
        }, te$1);
      }, ee$1), J$o("mouseup", document, E3, {
        once: true
      });
    }
    const xe2 = () => {
      y3 || A3();
    }, Ie2 = () => {
      w3 || U3();
    };
    function Ve2(e28) {
      var t3, r3;
      if (e28.key === "Enter") {
        if (e28.target === ((t3 = s3.value) === null || t3 === void 0 ? void 0 : t3.wrapperElRef))
          return;
        a3({
          offset: 0,
          doUpdateIfValid: true,
          isInputing: false,
          fixPrecision: true
        }) !== false && ((r3 = s3.value) === null || r3 === void 0 || r3.deactivate());
      } else if (e28.key === "ArrowUp") {
        if (!F3.value || n3.keyboard.ArrowUp === false)
          return;
        e28.preventDefault(), a3({
          offset: 0,
          doUpdateIfValid: true,
          isInputing: false,
          fixPrecision: true
        }) !== false && A3();
      } else if (e28.key === "ArrowDown") {
        if (!C3.value || n3.keyboard.ArrowDown === false)
          return;
        e28.preventDefault(), a3({
          offset: 0,
          doUpdateIfValid: true,
          isInputing: false,
          fixPrecision: true
        }) !== false && U3();
      }
    }
    function we2(e28) {
      p3.value = e28, n3.updateValueOnInput && !n3.format && !n3.parse && n3.precision === void 0 && a3({
        offset: 0,
        doUpdateIfValid: true,
        isInputing: true,
        fixPrecision: false
      });
    }
    watch(f3, () => {
      b3();
    });
    const ye2 = {
      focus: () => {
        var e28;
        return (e28 = s3.value) === null || e28 === void 0 ? void 0 : e28.focus();
      },
      blur: () => {
        var e28;
        return (e28 = s3.value) === null || e28 === void 0 ? void 0 : e28.blur();
      },
      select: () => {
        var e28;
        return (e28 = s3.value) === null || e28 === void 0 ? void 0 : e28.select();
      }
    }, Re2 = v$17("InputNumber", S3, g3);
    return Object.assign(Object.assign({}, ye2), {
      rtlEnabled: Re2,
      inputInstRef: s3,
      minusButtonInstRef: j3,
      addButtonInstRef: z3,
      mergedClsPrefix: g3,
      mergedBordered: i,
      uncontrolledValue: D3,
      mergedValue: f3,
      mergedPlaceholder: oe2,
      displayedValueInvalid: de2,
      mergedSize: re2,
      mergedDisabled: le2,
      displayedValue: p3,
      addable: F3,
      minusable: C3,
      mergedStatus: ie2,
      handleFocus: me2,
      handleBlur: ve2,
      handleClear: pe2,
      handleMouseDown: he2,
      handleAddClick: xe2,
      handleMinusClick: Ie2,
      handleAddMousedown: be2,
      handleMinusMousedown: ge2,
      handleKeyDown: Ve2,
      handleUpdateDisplayedValue: we2,
      mergedTheme: u3,
      inputThemeOverrides: {
        paddingSmall: "0 8px 0 10px",
        paddingMedium: "0 8px 0 12px",
        paddingLarge: "0 8px 0 14px"
      },
      buttonThemeOverrides: computed(() => {
        const {
          self: {
            iconColorDisabled: e28
          }
        } = u3.value, [t3, r3, l3, o3] = p$3J(e28);
        return {
          textColorTextDisabled: `rgb(${t3}, ${r3}, ${l3})`,
          opacityDisabled: `${o3}`
        };
      })
    });
  },
  render() {
    const {
      mergedClsPrefix: n3,
      $slots: i
    } = this, g3 = () => h$1R(ie$h, {
      text: true,
      disabled: !this.minusable || this.mergedDisabled || this.readonly,
      focusable: false,
      theme: this.mergedTheme.peers.Button,
      themeOverrides: this.mergedTheme.peerOverrides.Button,
      builtinThemeOverrides: this.buttonThemeOverrides,
      onClick: this.handleMinusClick,
      onMousedown: this.handleMinusMousedown,
      ref: "minusButtonInstRef"
    }, {
      icon: () => p$3H(i["minus-icon"], () => [h$1R(d$1R, {
        clsPrefix: n3
      }, {
        default: () => h$1R(r$p, null)
      })])
    }), S3 = () => h$1R(ie$h, {
      text: true,
      disabled: !this.addable || this.mergedDisabled || this.readonly,
      focusable: false,
      theme: this.mergedTheme.peers.Button,
      themeOverrides: this.mergedTheme.peerOverrides.Button,
      builtinThemeOverrides: this.buttonThemeOverrides,
      onClick: this.handleAddClick,
      onMousedown: this.handleAddMousedown,
      ref: "addButtonInstRef"
    }, {
      icon: () => p$3H(i["add-icon"], () => [h$1R(d$1R, {
        clsPrefix: n3
      }, {
        default: () => h$1R(r$18, null)
      })])
    });
    return h$1R("div", {
      class: [`${n3}-input-number`, this.rtlEnabled && `${n3}-input-number--rtl`]
    }, h$1R(Zn$3, {
      ref: "inputInstRef",
      autofocus: this.autofocus,
      status: this.mergedStatus,
      bordered: this.mergedBordered,
      loading: this.loading,
      value: this.displayedValue,
      onUpdateValue: this.handleUpdateDisplayedValue,
      theme: this.mergedTheme.peers.Input,
      themeOverrides: this.mergedTheme.peerOverrides.Input,
      builtinThemeOverrides: this.inputThemeOverrides,
      size: this.mergedSize,
      placeholder: this.mergedPlaceholder,
      disabled: this.mergedDisabled,
      readonly: this.readonly,
      textDecoration: this.displayedValueInvalid ? "line-through" : void 0,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onKeydown: this.handleKeyDown,
      onMousedown: this.handleMouseDown,
      onClear: this.handleClear,
      clearable: this.clearable,
      inputProps: this.inputProps,
      internalLoadingBeforeSuffix: true
    }, {
      prefix: () => {
        var u3;
        return this.showButton && this.buttonPlacement === "both" ? [g3(), m$26(i.prefix, (v3) => v3 ? h$1R("span", {
          class: `${n3}-input-number-prefix`
        }, v3) : null)] : (u3 = i.prefix) === null || u3 === void 0 ? void 0 : u3.call(i);
      },
      suffix: () => {
        var u3;
        return this.showButton ? [m$26(i.suffix, (v3) => v3 ? h$1R("span", {
          class: `${n3}-input-number-suffix`
        }, v3) : null), this.buttonPlacement === "right" ? g3() : null, S3()] : (u3 = i.suffix) === null || u3 === void 0 ? void 0 : u3.call(i);
      }
    }));
  }
});
const p$2r = defineComponent({
  name: "UIInput"
}), y$g = defineComponent(__spreadProps(__spreadValues({}, p$2r), {
  props: {
    modelValue: {
      type: Number
    },
    placeholder: String,
    readonly: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    precision: {
      type: Number,
      default: void 0
    },
    size: {
      type: String,
      default: "medium"
    },
    buttonPlacement: {
      type: String,
      default: void 0
    },
    showButton: {
      type: Boolean,
      default: void 0
    },
    max: {
      type: Number,
      default: void 0
    },
    min: {
      type: Number,
      default: void 0
    },
    id: {
      type: String,
      required: true
    }
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(e28, { emit: u3 }) {
    const d3 = u3;
    function r3(t3) {
      d3("update:modelValue", t3);
    }
    return (t3, l3) => (openBlock(), createBlock(unref(mt$1), mergeProps({
      id: e28.id,
      max: e28.max,
      min: e28.min,
      "button-placement": e28.buttonPlacement,
      "show-button": e28.showButton,
      precision: e28.precision,
      disabled: e28.disabled,
      size: e28.size,
      readonly: e28.readonly,
      value: e28.modelValue,
      "onUpdate:value": r3,
      placeholder: e28.placeholder,
      clearable: e28.clearable,
      loading: e28.loading
    }, t3.$attrs, {
      class: [e28.loading ? "" : "hide-loader", "hl-input-number font-sans"],
      onFocus: l3[0] || (l3[0] = (a3) => t3.$emit("focus", a3)),
      onBlur: l3[1] || (l3[1] = (a3) => t3.$emit("blur", a3))
    }), {
      prefix: withCtx(() => [
        renderSlot(t3.$slots, "prefix")
      ]),
      suffix: withCtx(() => [
        renderSlot(t3.$slots, "suffix")
      ]),
      _: 3
    }, 16, ["id", "max", "min", "button-placement", "show-button", "precision", "disabled", "size", "readonly", "value", "placeholder", "clearable", "loading", "class"]));
  }
})), v$a = y$g;
var R$8 = /* @__PURE__ */ ((A3) => (A3[A3.BACKSPACE = 8] = "BACKSPACE", A3[A3.DELETE = 46] = "DELETE", A3[A3.LEFT_ARROW = 37] = "LEFT_ARROW", A3[A3.RIGHT_ARROW = 39] = "RIGHT_ARROW", A3[A3.ZERO = 48] = "ZERO", A3[A3.NUMPAD_0 = 96] = "NUMPAD_0", A3[A3.NINE = 57] = "NINE", A3[A3.NUMPAD_9 = 105] = "NUMPAD_9", A3[A3.V = 86] = "V", A3))(R$8 || {});
const P$9 = { class: "hl-otp-field-wrapper" }, K$6 = ["disabled", "required", "placeholder"], N$a = defineComponent({
  name: "SingleInput"
}), O$9 = defineComponent(__spreadProps(__spreadValues({}, N$a), {
  props: {
    focus: {
      type: Boolean
    },
    value: {
      type: String,
      default: null
    },
    fieldClass: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    required: {
      type: Boolean
    },
    placeholder: {
      type: String
    }
  },
  emits: [
    "onChange",
    "onKeydown",
    "onPaste",
    "onFocus",
    "onBlur"
  ],
  setup(a3, { emit: p3 }) {
    const i = a3, t3 = ref$1(""), u3 = ref$1(null), s3 = p3, f3 = () => {
      s3("onBlur");
    }, h3 = () => {
      t3.value.toString().length > 1 ? t3.value = t3.value.toString().slice(0, 1) : t3.value = t3.value.toString(), s3("onChange", t3.value);
    }, m3 = () => {
      s3("onFocus");
    }, v3 = (e28) => {
      s3("onPaste", e28);
    }, y3 = (e28) => {
      const n3 = e28, l3 = n3.which ? n3.which : n3.keyCode;
      g3(l3) || l3 === R$8.BACKSPACE || l3 === R$8.V || l3 === R$8.DELETE ? s3("onKeydown", e28) : n3.preventDefault();
    }, g3 = (e28) => e28 >= R$8.ZERO && e28 <= R$8.NINE || e28 >= R$8.NUMPAD_0 && e28 <= R$8.NUMPAD_9;
    return watch(() => i.focus, (e28, n3) => {
      e28 !== n3 && u3.value && i.focus && (u3.value.focus(), u3.value.select());
    }), watch(() => i.value, (e28, n3) => {
      e28 !== n3 && (t3.value = e28);
    }), (e28, n3) => (openBlock(), createElementBlock("div", P$9, [
      withDirectives(createElementVNode("input", {
        class: normalizeClass(["hl-otp-field-input", a3.fieldClass]),
        ref_key: "input",
        ref: u3,
        type: "number",
        min: "0",
        max: "9",
        maxlength: "1",
        pattern: "[0-9]",
        "onUpdate:modelValue": n3[0] || (n3[0] = (l3) => t3.value = l3),
        disabled: a3.disabled,
        required: a3.required,
        placeholder: a3.placeholder,
        onInput: h3,
        onKeydown: y3,
        onPaste: v3,
        onFocus: m3,
        onBlur: f3
      }, null, 42, K$6), [
        [vModelText, t3.value]
      ])
    ]));
  }
})), _$9 = O$9;
const R$7 = { class: "hl-input-otp" }, q$5 = { class: "hl-input-otp__fields" }, P$8 = {
  key: 0,
  class: "hl-input-otp__separator"
}, w$7 = defineComponent({
  name: "UIInputOtp"
}), K$5 = defineComponent(__spreadProps(__spreadValues({}, w$7), {
  props: {
    fields: {
      type: Number,
      default: 6
    },
    fieldClass: {
      type: String,
      default: void 0
    },
    label: {
      type: String,
      default: void 0
    },
    labelClass: {
      type: String,
      default: void 0
    },
    hint: {
      type: String,
      default: void 0
    },
    hintClass: {
      type: String,
      default: void 0
    },
    disabled: {
      type: Boolean
    },
    required: {
      type: Boolean
    },
    placeholder: {
      type: String,
      default: "0"
    }
  },
  emits: ["onComplete", "onChange"],
  setup(t3, { emit: D3 }) {
    const i = t3, a3 = ref$1([]), h3 = ref$1([]), l3 = ref$1(0), v3 = D3, d3 = (e28) => {
      h3.value = Object.assign([], a3.value), a3.value[l3.value] = e28, h3.value.join("") !== a3.value.join("") && (v3("onChange", a3.value.join("")), b3());
    }, u3 = (e28) => {
      l3.value = Math.max(Math.min(i.fields - 1, e28), 0);
    }, m3 = () => {
      u3(l3.value + 1);
    }, C3 = () => {
      u3(l3.value - 1);
    }, E3 = (e28) => {
      d3(e28), m3();
    }, S3 = (e28) => {
      switch (e28.keyCode) {
        case R$8.BACKSPACE:
          e28.preventDefault(), d3(""), C3();
          break;
        case R$8.DELETE:
          e28.preventDefault(), d3("");
          break;
        case R$8.LEFT_ARROW:
          e28.preventDefault(), C3();
          break;
        case R$8.RIGHT_ARROW:
          e28.preventDefault(), m3();
          break;
      }
    }, j3 = (e28) => {
      e28.preventDefault();
      const r3 = e28.clipboardData.getData("text/plain").slice(0, i.fields - l3.value).split("");
      if (!r3.join("").match(/^\d+$/))
        return "Invalid pasted data";
      const n3 = a3.value.slice(0, l3.value).concat(r3);
      a3.value = n3.slice(0, i.fields), u3(n3.slice(0, i.fields).length), b3();
    }, B3 = (e28) => {
      l3.value = e28;
    }, H3 = () => {
      l3.value = -1;
    }, b3 = () => {
      const e28 = a3.value.join("");
      e28.length === i.fields && v3("onComplete", {
        otp: e28,
        state: "completed"
      });
    };
    return (e28, r3) => (openBlock(), createElementBlock("div", R$7, [
      t3.label ? (openBlock(), createElementBlock("label", {
        key: 0,
        class: normalizeClass(["hl-input-otp__label", t3.labelClass])
      }, toDisplayString(t3.label), 3)) : createCommentVNode("", true),
      createElementVNode("div", q$5, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(t3.fields, (g3, n3) => (openBlock(), createElementBlock(Fragment, { key: g3 }, [
          createVNode(_$9, {
            focus: l3.value === n3,
            value: a3.value[n3],
            fieldClass: t3.fieldClass,
            disabled: t3.disabled,
            required: t3.required,
            placeholder: t3.placeholder,
            onOnChange: E3,
            onOnKeydown: S3,
            onOnPaste: j3,
            onOnFocus: (L3) => B3(n3),
            onOnBlur: H3
          }, null, 8, ["focus", "value", "fieldClass", "disabled", "required", "placeholder", "onOnFocus"]),
          t3.fields === 6 && n3 === 2 ? (openBlock(), createElementBlock("div", P$8)) : createCommentVNode("", true)
        ], 64))), 128))
      ]),
      t3.hint ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass(["hl-input-otp__hint", t3.hintClass])
      }, toDisplayString(t3.hint), 3)) : createCommentVNode("", true)
    ]));
  }
})), U$3 = K$5;
function c$E(t3, n3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 9l6 6 6-6"
    })
  ]);
}
function c$D(t3, n3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19 12H5m0 0l7 7m-7-7l7-7"
    })
  ]);
}
const B$9 = {
  key: 0,
  class: "dropdown-tree__breadcrumb"
}, h$w = { class: "dropdown-tree__breadcrumb-content" }, v$9 = { class: "dropdown-tree__breadcrumb-title" }, N$9 = defineComponent({
  __name: "BreadCrumb",
  props: {
    disabled: Boolean,
    title: String,
    show: Boolean,
    icon: Function,
    iconClass: String
  },
  emits: ["onClick"],
  setup(e28, { emit: s3 }) {
    const d3 = s3;
    return (y3, r3) => e28.show ? (openBlock(), createElementBlock("div", B$9, [
      createVNode(unref(q$C), {
        id: "dropdown-backward-traversal",
        text: "",
        onClick: r3[0] || (r3[0] = (V10) => d3("onClick")),
        disabled: e28.disabled
      }, {
        default: withCtx(() => [
          createElementVNode("div", h$w, [
            createVNode(unref(c$D), { class: "w-5 h-5" }),
            createElementVNode("span", v$9, [
              (openBlock(), createBlock(resolveDynamicComponent(e28.icon), {
                class: normalizeClass(e28.iconClass)
              }, null, 8, ["class"])),
              createVNode(unref(q$u), {
                style: { "max-width": "250px" },
                tooltip: false
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(e28.title), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["disabled"])
    ])) : createCommentVNode("", true);
  }
}), T$8 = /* @__PURE__ */ s$1d(N$9, [["__scopeId", "data-v-4aa44406"]]);
function c$C(t3, n3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 18l6-6-6-6"
    })
  ]);
}
const D$a = ["onClick"], I$9 = { class: "flex gap-1" }, R$6 = { class: "dropdown-tree__item--path" }, S$9 = { class: "dropdown-tree__item--label" }, T$7 = {
  key: 0,
  class: "dropdown-tree__item--icon"
}, V$7 = defineComponent({
  __name: "DropdownItem",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    showPath: {
      type: Boolean,
      default: false
    }
  },
  emits: ["onForwardTraverse", "onSelect"],
  setup(l3, { emit: y3 }) {
    const u3 = y3, b3 = (s3) => {
      var n3;
      !s3.disabled && ((n3 = s3.children) != null && n3.length) ? u3("onForwardTraverse", s3) : u3("onSelect", s3.value);
    }, g3 = (s3) => s3 ? s3 == null ? void 0 : s3.split("/").filter(Boolean).at(-1) : null;
    return (s3, n3) => (openBlock(true), createElementBlock(Fragment, null, renderList(l3.options, (e28) => {
      var f3;
      return openBlock(), createElementBlock("a", {
        key: e28.label.toString(),
        class: normalizeClass(["dropdown-tree__item", [e28 == null ? void 0 : e28.className, e28.disabled ? "disabled" : ""]]),
        onClick: () => b3(e28)
      }, [
        createElementVNode("span", I$9, [
          l3.showPath && e28._pathFromRoot !== "/" ? (openBlock(), createBlock(unref(w$K), {
            key: 0,
            disabled: !l3.showPath && e28._pathFromRoot
          }, {
            trigger: withCtx(() => [
              createElementVNode("span", R$6, [
                createVNode(unref(q$u), {
                  class: "dropdown-tree__item--path-label",
                  tooltip: false
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(g3(e28._pathFromRoot)), 1)
                  ]),
                  _: 2
                }, 1024),
                createTextVNode(" " + toDisplayString("/"))
              ])
            ]),
            default: withCtx(() => [
              createTextVNode(" " + toDisplayString(e28 == null ? void 0 : e28._pathFromRoot), 1)
            ]),
            _: 2
          }, 1032, ["disabled"])) : createCommentVNode("", true),
          createElementVNode("span", S$9, [
            (openBlock(), createBlock(resolveDynamicComponent(e28.icon), {
              class: normalizeClass(e28.iconClass)
            }, null, 8, ["class"])),
            createVNode(unref(q$u), {
              class: normalizeClass(l3.showPath ? "showPath" : ""),
              tooltip: false
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(e28.label), 1)
              ]),
              _: 2
            }, 1032, ["class"])
          ])
        ]),
        (f3 = e28.children) != null && f3.length ? (openBlock(), createElementBlock("span", T$7, [
          e28.customArrow ? (openBlock(), createBlock(resolveDynamicComponent(e28 == null ? void 0 : e28.customArrow), {
            key: 0,
            class: normalizeClass(e28 == null ? void 0 : e28.arrowClass)
          }, null, 8, ["class"])) : (openBlock(), createBlock(unref(c$C), {
            key: 1,
            class: "chevron"
          }))
        ])) : createCommentVNode("", true)
      ], 10, D$a);
    }), 128));
  }
}), q$4 = /* @__PURE__ */ s$1d(V$7, [["__scopeId", "data-v-91330f12"]]);
const oe$2 = { class: "dropdown-tree__container" }, ae$2 = { class: "dropdown-tree__search" }, le$1 = { key: 0 }, re$1 = {
  key: 1,
  class: "no-data"
}, ne$2 = { key: 1 }, ie$2 = {
  key: 1,
  class: "empty-search"
}, se$2 = defineComponent({
  name: "UIDropdownTree",
  inheritAttrs: false,
  components: { UIInput: P$O, UIButton: q$C, BreadCrumb: T$8, DropdownItem: q$4, NInput: Zn$3 }
}), de$2 = defineComponent(__spreadProps(__spreadValues({}, se$2), {
  props: {
    id: String,
    options: {
      type: Array,
      default: () => []
    },
    pathSeparator: {
      type: String,
      default: "/"
    },
    disabled: Boolean,
    triggerLabel: String,
    debug: Boolean,
    placement: String,
    loading: Boolean,
    remote: Boolean,
    searchPlaceholder: {
      type: String,
      required: false,
      default: "Search"
    },
    trigger: {
      type: String,
      default: "click"
    },
    show: {
      type: Boolean,
      default: void 0
    },
    x: Number,
    y: Number,
    to: {
      type: [String, HTMLElement, Boolean],
      default: "body"
    }
  },
  emits: ["onSelect", "onSearch", "onClickOutside"],
  setup(a3, { emit: E3 }) {
    const o3 = a3, j3 = computed(() => {
      const e28 = g$O(o3.options).filter((t3) => t3.type !== "parent");
      return o3.debug && d$17("flattenedOptions", e28), e28;
    }), A3 = computed(() => {
      const e28 = g$O(o3.options).filter((t3) => t3.type === "parent");
      return o3.debug && d$17("flattenedParents", e28), e28;
    }), r3 = ref$1(o3.options);
    watch(() => o3.options, (e28) => {
      r3.value = e28;
    });
    const l3 = ref$1(""), d3 = ref$1(o3.pathSeparator), m3 = ref$1(null), f3 = useSlots(), b3 = E3, v3 = ref$1(false), R3 = (e28) => {
      var _a2;
      var t3;
      (t3 = l3.value) != null && t3.includes(e28) || (l3.value ? l3.value += `${e28}${d3.value}` : l3.value += `${e28}${d3.value}`, r3.value = (_a2 = h$13({ options: o3.options, path: l3.value })) != null ? _a2 : [], o3.debug && d$17(`handleForwardTraversal(${e28})`, `${JSON.stringify(r3.value)}   ${l3.value}`));
    }, q3 = (e28) => {
      var _a2;
      const t3 = e28.split(d3.value).filter(Boolean), n3 = t3.slice(0, t3.length - 1).join(d3.value);
      l3.value = n3 ? `${n3}${d3.value}` : "", r3.value = (_a2 = h$13({ options: o3.options, path: n3 })) != null ? _a2 : [], o3.debug && d$17(`handleBackwardTraversal(${e28})`, r3.value);
    }, S3 = computed(() => {
      const e28 = l3.value.split(d3.value).filter(Boolean).at(-1), t3 = A3.value.find((n3) => n3.value === e28);
      return o3.debug && d$17(`[Computed] currentViewTitle for ${e28} is`, t3), t3;
    }), z3 = (e28) => {
      if (l3.value = "", v3.value = true, o3.remote)
        b3("onSearch", e28);
      else if (e28) {
        const t3 = j3.value.filter((n3) => n3.label.toLowerCase().includes(e28.toLowerCase()));
        r3.value = t3;
      } else
        r3.value = o3.options, v3.value = false;
      o3.debug && d$17(`handleSearch with remote ${o3.remote} and search string is ${e28}`, r3.value);
    };
    watch(() => m3, _$q((e28) => {
      z3(e28.value);
    }, 300), { deep: true });
    const H3 = () => {
      setTimeout(() => {
        r3.value = o3.options, m3.value = null, l3.value = "";
      }, 300), b3("onClickOutside");
    }, C3 = ref$1(), J3 = (e28) => {
      b3("onSelect", e28), M3();
    }, M3 = () => {
      C3.value.handleClick();
    };
    return (e28, t3) => (openBlock(), createBlock(unref(Ie$8), {
      raw: "",
      id: a3.id,
      class: "dropdown-tree",
      disabled: a3.disabled,
      "show-arrow": false,
      trigger: a3.trigger,
      onClickoutside: H3,
      placement: a3.placement,
      ref_key: "popoverRef",
      ref: C3,
      show: a3.show,
      x: a3.x,
      y: a3.y,
      to: a3.to
    }, {
      trigger: withCtx(() => [
        unref(f3).trigger ? renderSlot(e28.$slots, "trigger", {
          key: 0,
          disabled: a3.disabled
        }, void 0, true) : (openBlock(), createBlock(unref(q$C), {
          key: 1,
          id: "dropdown-tree__trigger",
          class: "dropdown-tree__trigger",
          disabled: a3.disabled,
          loading: a3.loading
        }, {
          default: withCtx(() => [
            createElementVNode("span", null, [
              createTextVNode(toDisplayString(a3.triggerLabel) + " ", 1),
              (openBlock(), createBlock(resolveDynamicComponent(unref(c$E)), { class: "chevron" }))
            ])
          ]),
          _: 1
        }, 8, ["disabled", "loading"]))
      ]),
      default: withCtx(() => {
        var n3, T3, P3;
        return [
          createElementVNode("div", oe$2, [
            createElementVNode("div", ae$2, [
              createVNode(unref(Zn$3), {
                id: "dropdown-tree-search",
                placeholder: a3.searchPlaceholder,
                value: m3.value,
                "onUpdate:value": t3[0] || (t3[0] = (u3) => m3.value = u3),
                loading: a3.loading,
                size: "small"
              }, {
                prefix: withCtx(() => [
                  unref(f3).searchIcon ? renderSlot(e28.$slots, "searchIcon", { key: 0 }, void 0, true) : (openBlock(), createBlock(unref(a$1j), {
                    key: 1,
                    class: "icon"
                  }))
                ]),
                _: 3
              }, 8, ["placeholder", "value", "loading"])
            ]),
            createVNode(T$8, {
              show: !!l3.value.length,
              title: (n3 = S3.value) == null ? void 0 : n3.label,
              disabled: !l3.value,
              onOnClick: t3[1] || (t3[1] = (u3) => q3(l3.value)),
              icon: (T3 = S3.value) == null ? void 0 : T3.icon,
              "icon-class": (P3 = S3.value) == null ? void 0 : P3.iconClass
            }, null, 8, ["show", "title", "disabled", "icon", "icon-class"]),
            createVNode(q$4, {
              showPath: v3.value,
              options: r3.value,
              onOnForwardTraverse: t3[2] || (t3[2] = (u3) => R3(u3.value)),
              onOnSelect: t3[3] || (t3[3] = (u3) => J3(u3))
            }, null, 8, ["showPath", "options"]),
            !v3.value && !a3.options.length ? (openBlock(), createElementBlock("div", le$1, [
              unref(f3).empty ? renderSlot(e28.$slots, "empty", { key: 0 }, void 0, true) : (openBlock(), createElementBlock("p", re$1, "No data"))
            ])) : createCommentVNode("", true),
            v3.value && !r3.value.length ? (openBlock(), createElementBlock("div", ne$2, [
              unref(f3).emptySearch ? renderSlot(e28.$slots, "emptySearch", { key: 0 }, void 0, true) : (openBlock(), createElementBlock("p", ie$2, "No matching results found"))
            ])) : createCommentVNode("", true)
          ])
        ];
      }),
      _: 3
    }, 8, ["id", "disabled", "trigger", "placement", "show", "x", "y", "to"]));
  }
})), Ce$2 = /* @__PURE__ */ s$1d(de$2, [["__scopeId", "data-v-596d9d3e"]]);
function c$B(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3551)" }, [
      createElementVNode("path", {
        d: "M17.2175 1.19072C15.6399 0.427875 13.87 0 12.0001 0C10.1303 0 8.36037 0.427875 6.78274 1.19072L5.73926 12L6.78274 22.8093C8.36037 23.5721 10.1303 24 12.0001 24C13.87 24 15.6399 23.5721 17.2175 22.8093L18.261 12L17.2175 1.19072Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.78262 1.19135C2.76872 3.1323 0 7.24272 0 12.0002C0 16.7577 2.76872 20.8681 6.78262 22.8091V1.19135Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M17.2178 1.19135V22.8091C21.2317 20.8681 24.0004 16.7577 24.0004 12.0002C24.0004 7.24272 21.2317 3.1323 17.2178 1.19135Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M12.0001 7.82672C9.69484 7.82672 7.82617 9.69544 7.82617 12.0006C7.82617 14.3058 9.69489 16.1745 12.0001 16.1745C14.3052 16.1745 16.174 14.3058 16.174 12.0006C16.174 9.69544 14.3053 7.82672 12.0001 7.82672ZM12.0001 14.6093C10.5593 14.6093 9.39138 13.4413 9.39138 12.0006C9.39138 10.5599 10.5594 9.39192 12.0001 9.39192C13.4408 9.39192 14.6088 10.5599 14.6088 12.0006C14.6088 13.4413 13.4408 14.6093 12.0001 14.6093Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0005 10.4362C11.4242 10.4362 10.957 10.9034 10.957 11.4797V13.0449H13.044V11.4797C13.044 10.9034 12.5768 10.4362 12.0005 10.4362Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3551" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2q(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3552)" }, [
      createElementVNode("path", {
        d: "M23.5866 15.1299C23.8556 14.1317 24 13.0826 24 11.9994C24 10.9163 23.8556 9.86715 23.5866 8.869L10.9565 0.045105C8.61178 0.247136 6.46008 1.12323 4.69566 2.4789L0.413391 8.869C0.144375 9.86715 0 10.9163 0 11.9994C0 13.0763 0.142641 14.1197 0.408656 15.1126L4.69561 21.52C6.46003 22.8757 8.61173 23.7518 10.9565 23.9538L23.5866 15.1299Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M0.413086 15.1305C1.1074 17.7067 2.63763 19.9395 4.69535 21.5206V15.1305H0.413086Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M10.9561 23.9544C11.3 23.984 11.6479 24.0001 11.9995 24.0001C17.5439 24.0001 22.2091 20.2397 23.5861 15.1305H10.9561V23.9544Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.5861 8.86955C22.2091 3.76036 17.5439 0 11.9995 0C11.6479 0 11.3 0.0160312 10.9561 0.0456562V8.86955H23.5861Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M4.69535 2.4798C2.63763 4.06089 1.1074 6.29369 0.413086 8.86989H4.69535V2.4798Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4343H9.39136H9.39131V0.284729C8.28234 0.530635 7.23098 0.929213 6.26086 1.45857V10.4342H0.101578C0.0347813 10.9466 0 11.469 0 11.9995C0 12.53 0.0347813 13.0524 0.101578 13.5647H6.26081H6.26086V22.5404C7.23098 23.0697 8.28234 23.4684 9.39131 23.7142V13.5648V13.5647H23.8984C23.9651 13.0524 24 12.53 24 11.9995C24 11.469 23.9651 10.9466 23.8984 10.4343Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3552" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$v(C3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3553)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.783 8.90742H14.4364C14.7048 8.62646 14.8699 8.24606 14.8699 7.82686C14.8699 6.96244 14.1691 6.26166 13.3047 6.26166C12.7601 6.26166 12.2807 6.53991 12.0004 6.96183C11.72 6.53991 11.2406 6.26166 10.696 6.26166C9.83159 6.26166 9.13081 6.96244 9.13081 7.82686C9.13081 8.24606 9.29595 8.6265 9.56426 8.90742H5.21777C5.21777 10.06 6.2217 10.9943 7.37421 10.9943H7.30465C7.30465 12.147 8.23901 13.0814 9.39166 13.0814C9.39166 13.4547 9.49005 13.8046 9.6618 14.1076L7.93071 15.8388L9.25887 17.1668L11.1429 15.2829C11.2166 15.3099 11.293 15.3316 11.3719 15.3464L10.2334 17.9168L12.0004 19.8269L13.7673 17.9167L12.6289 15.3463C12.7077 15.3316 12.7841 15.3099 12.8578 15.2828L14.7418 17.1668L16.07 15.8386L14.3389 14.1075C14.5106 13.8046 14.609 13.4545 14.609 13.0812C15.7616 13.0812 16.696 12.1469 16.696 10.9942H16.6265C17.779 10.9943 18.783 10.06 18.783 8.90742Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3553" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2p(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3554)" }, [
      createElementVNode("path", {
        d: "M12.0008 0C18.6281 0 24.0007 5.37262 24.0007 12C24.0007 18.6274 18.6281 24 12.0008 24C12.0008 23.4783 10.4355 12 10.4355 12L12.0008 0Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 24C5.37262 24 0 18.6274 0 12C0 5.37262 5.37262 0 12 0",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M14.5781 9.69867L13.5936 11.0555L11.999 10.5383L12.9852 11.894L12.0007 13.2508L13.5946 12.7318L14.5808 14.0874L14.5798 12.4111L16.1738 11.8921L14.5793 11.3751L14.5781 9.69867Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.9948 15.392C11.1219 15.392 9.60353 13.8736 9.60353 12.0007C9.60353 10.1277 11.1219 8.60935 12.9948 8.60935C13.5788 8.60935 14.1283 8.757 14.608 9.01697C13.8554 8.28099 12.8262 7.82672 11.6905 7.82672C9.38528 7.82672 7.5166 9.69544 7.5166 12.0006C7.5166 14.3058 9.38532 16.1745 11.6905 16.1745C12.8263 16.1745 13.8555 15.7202 14.608 14.9843C14.1283 15.2443 13.5788 15.392 12.9948 15.392Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3554" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function L$a(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3555)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M17.8217 1.50525C16.0974 0.54675 14.1127 0 12 0C5.37309 0 0.00084375 5.37178 0 11.9986L8.34783 7.82611L17.8217 1.50525Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M0 12.0019C0.00084375 18.6287 5.37309 24.0005 12 24.0005C14.1127 24.0005 16.0974 23.4538 17.8217 22.4952L8.34783 16.1744L0 12.0019Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M18.8217 2.12703C18.4994 1.90395 18.1654 1.69648 17.8213 1.50519L0 11.9983C0 11.9988 0 11.9993 0 11.9998C0 12.0002 0 12.0007 0 12.0012L17.8213 22.4943C18.1655 22.3029 18.4994 22.0955 18.8218 21.8724L2.05416 11.9998L18.8217 2.12703Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.8692 11.5526H19.4398C19.8115 11.1064 19.7885 10.4425 19.3698 10.0238C19.8133 9.58035 19.8133 8.86124 19.3698 8.41766L19.3431 8.44447C19.7866 8.00099 19.8133 7.25507 19.3698 6.81158L12.9453 13.2361C13.3888 13.6797 14.0953 13.6744 14.5388 13.2308L14.6625 13.1178L17.7388 12.8382V14.1613H18.7823V12.7433L20.3475 12.601L20.8692 11.5526Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M13.0439 14.6089L12 14.0872L13.0439 13.5654H19.8264V14.6089H13.0439Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3555" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2o(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3556)" }, [
      createElementVNode("path", {
        d: "M6.78274 22.8093C8.36037 23.5721 10.1302 24 12.0001 24C13.87 24 15.6399 23.5721 17.2175 22.8093L18.261 12L17.2175 1.19072C15.6399 0.427875 13.87 0 12.0001 0C10.1302 0 8.36037 0.427875 6.78274 1.19072L5.73926 12L6.78274 22.8093Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M17.2168 22.8091C21.2308 20.8682 23.9994 16.7577 23.9994 12.0002C23.9994 7.24272 21.2308 3.13225 17.2168 1.19135V22.8091Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.78262 22.8091V1.19135C2.76867 3.13225 0 7.24267 0 12.0002C0 16.7577 2.76867 20.8682 6.78262 22.8091Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12 16.1734C12 14.2585 12 11.9995 12 11.9995H15.1304V13.5647C15.1304 13.8366 14.6087 14.833 13.3209 15.6517C12.8332 15.9618 12.3283 16.0616 12 16.1734Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9996 8.86884H8.86914V11.9993H11.9996V8.86884Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.5653 7.8262C13.5653 7.24987 13.0981 6.78271 12.5218 6.78271C12.3315 6.78271 12.1536 6.83446 12.0001 6.92343C11.8465 6.83446 11.6687 6.78271 11.4783 6.78271C10.9021 6.78271 10.4349 7.24987 10.4349 7.8262H7.82617V13.0435C7.82617 14.9858 9.36864 16.1091 10.5782 16.6914C10.4877 16.846 10.4349 17.0254 10.4349 17.2175C10.4349 17.7938 10.9021 18.261 11.4783 18.261C11.6687 18.261 11.8465 18.2093 12.0001 18.1203C12.1537 18.2093 12.3315 18.261 12.5218 18.261C13.0981 18.261 13.5653 17.7938 13.5653 17.2175C13.5653 17.0254 13.5124 16.846 13.4218 16.6914C14.6314 16.1091 16.174 14.9859 16.174 13.0435V7.8262H13.5653ZM14.6088 13.0435C14.6088 13.3155 14.6087 14.1428 13.321 14.9616C12.8332 15.2717 12.3284 15.4728 12.0001 15.5846C11.6718 15.4728 11.1669 15.2717 10.6791 14.9616C9.39138 14.1428 9.39138 13.3155 9.39138 13.0435V9.3914H14.6088V13.0435Z",
        fill: "#FF9811"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3556" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function L$9(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3557)" }, [
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M24 12.0004C24 18.6277 18.6274 24.0004 12 24.0004C5.37262 24.0004 0 18.6277 0 12.0004",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M10.3535 9.54359L11.3708 10.2819L10.9831 11.4776L11.9997 10.7381L13.017 11.4763L12.6279 10.281L13.6443 9.54162L12.3874 9.54237L11.9982 8.34711L11.6105 9.5428L10.3535 9.54359Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.9994 6.80332C14.0538 6.25736 13.0199 5.99969 11.9994 6.00147V7.56635C12.7537 7.56499 13.5178 7.7553 14.2168 8.1589C16.3345 9.38158 17.0627 12.0992 15.84 14.2169C14.6173 16.3346 11.8998 17.0628 9.78199 15.8402C9.16502 15.484 8.66698 15.0003 8.29985 14.4422L6.99316 15.3048C7.4899 16.06 8.16471 16.7137 8.99941 17.1956C11.8646 18.8498 15.5413 17.8646 17.1955 14.9995C18.8497 12.1343 17.8646 8.45754 14.9994 6.80332Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M8.53898 10.956C8.12414 11.7144 8.40267 12.6655 9.16101 13.0804L14.2446 15.8582C13.8989 16.4901 14.0825 17.2593 14.7144 17.605L16.0876 18.3561C16.7195 18.7019 17.5122 18.4698 17.8579 17.8378L18.6091 16.4646L8.53898 10.956Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3557" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2n(i, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3558)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 12.0005H11.9999C11.9999 11.9897 11.9999 11.9792 11.9999 11.9684C11.9892 11.9791 11.9785 11.9898 11.9678 12.0005Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.37145 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78637 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07027 1.56506C4.19344 2.63377 2.63311 4.19405 1.56445 6.07088V11.9999H4.69491V4.69561V4.69552H11.9993C11.9993 3.70819 11.9993 2.7676 11.9993 1.56506H6.07027Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9989 10.5248L7.73539 6.26135H6.25977V6.26145L11.9988 12.0005H11.9989C11.9989 12.0005 11.9989 10.9829 11.9989 10.5248Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.2942 13.7574C20.6393 13.2826 20.8698 12.7029 20.8698 12.0008V6.78339C20.4337 7.11095 19.8919 7.30511 19.3046 7.30511C18.4512 7.30511 17.6935 6.89528 17.2176 6.26172C16.7416 6.89528 15.984 7.30511 15.1306 7.30511C14.5433 7.30511 14.0014 7.11091 13.5654 6.78348V12.0008C13.5654 12.7029 13.7959 13.2826 14.141 13.7574H20.2942Z",
        fill: "#F3F3F3"
      }),
      createElementVNode("path", {
        d: "M19.208 11.0321C19.3741 10.6269 19.5033 10.0345 19.5033 9.7397C19.5033 9.26603 18.8858 8.88208 18.8858 8.88208C18.8858 8.88208 18.2682 9.26603 18.2682 9.7397C18.2682 10.0345 18.3975 10.6269 18.5635 11.0321L18.207 11.837C18.4166 11.9222 18.6456 11.9696 18.8858 11.9696C19.1261 11.9696 19.355 11.9222 19.5646 11.837L19.208 11.0321Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M16.7955 8.42672C16.3617 8.4855 15.784 8.66995 15.5287 8.81733C15.1185 9.05419 15.0947 9.78089 15.0947 9.78089C15.0947 9.78089 15.7361 10.1237 16.1462 9.88687C16.4016 9.73945 16.8499 9.33145 17.1177 8.98495L17.9932 8.8912C17.9622 8.66723 17.8885 8.44519 17.7685 8.2372C17.6483 8.02922 17.4929 7.85447 17.3144 7.71558L16.7955 8.42672Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M15.7445 11.8206C16.0123 12.1669 16.4608 12.5748 16.7162 12.7223C17.1264 12.9591 17.7677 12.6164 17.7677 12.6164C17.7677 12.6164 17.7438 11.8896 17.3336 11.6528C17.0782 11.5053 16.5007 11.3211 16.0667 11.2624L15.5479 10.5511C15.3694 10.69 15.214 10.8648 15.0938 11.0726C14.9738 11.2807 14.9003 11.5027 14.8691 11.7268L15.7445 11.8206Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M14.0117 13.5657C14.9862 15.1292 17.2175 15.6525 17.2175 15.6525C17.2175 15.6525 19.4487 15.1292 20.4232 13.5657H14.0117Z",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3558" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2m(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3559)" }, [
      createElementVNode("path", {
        d: "M0 11.9992C0 12.8212 0.082875 13.6238 0.240328 14.3992L12 15.1297L23.7597 14.3992C23.9172 13.6238 24 12.8212 24 11.9992C24 11.1773 23.9171 10.3747 23.7597 9.59923L12 8.86877L0.240328 9.59923C0.082875 10.3747 0 11.1773 0 11.9992Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.7596 14.3992H0.240234C1.35206 19.8765 6.19448 23.9992 11.9999 23.9992C17.8053 23.9992 22.6477 19.8765 23.7596 14.3992Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0.240234 9.6H23.7597C22.6478 4.12266 17.8054 0 11.9999 0C6.19439 0 1.35206 4.12266 0.240234 9.6Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M17.218 9.59937H6.7832L8.91508 8.59653L7.77981 6.53192L10.0947 6.97466L10.3882 4.63611L12.0006 6.35614L13.6131 4.63611L13.9063 6.97466L16.2214 6.53192L15.0862 8.59662L17.218 9.59937Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M0 12.0008C0 18.6282 5.37262 24.0008 12 24.0008L2.39981 4.80042C0.893062 6.80615 0 9.2991 0 12.0008Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M12 23.9999C18.6274 23.9999 24 18.6272 24 11.9999C24 9.29813 23.1069 6.80517 21.6002 4.79944L12 23.9999Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3559" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$A(L3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3560)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 -0.000976562C7.24316 -0.000976562 3.13241 2.7677 1.19141 6.78165H22.8099C20.869 2.7677 16.7582 -0.000976562 12.0007 -0.000976562Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.0007 23.9987C16.7582 23.9987 20.869 21.23 22.81 17.2161H1.19141C3.13241 21.23 7.24316 23.9987 12.0007 23.9987Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M15.5864 12L14.1208 12.6894L14.9012 14.1087L13.3098 13.8043L13.1082 15.4119L11.9997 14.2295L10.8912 15.4119L10.6896 13.8043L9.09821 14.1087L9.87859 12.6894L8.41309 12L9.87863 11.3106L9.09821 9.89135L10.6896 10.1958L10.8913 8.58813L11.9997 9.77051L13.1082 8.58813L13.3098 10.1958L14.9013 9.89135L14.1209 11.3107L15.5864 12Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3560" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2l(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3561)" }, [
      createElementVNode("path", {
        d: "M24 12.0001C24 10.5323 23.736 9.12615 23.2536 7.82621L12 7.30444L0.746391 7.82616C0.264047 9.12614 0 10.5323 0 12.0001C0 13.4679 0.264047 14.874 0.746391 16.174L12 16.6957L23.2536 16.174C23.736 14.874 24 13.4679 24 12.0001Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9996C17.1593 23.9996 21.5578 20.7431 23.2533 16.1735H0.746094C2.44161 20.7431 6.84012 23.9996 11.9997 23.9996Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M0.746094 7.82611H23.2534C21.5578 3.2565 17.1593 0 11.9997 0C6.84012 0 2.44161 3.2565 0.746094 7.82611Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3561" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2k(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3562)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9999 24.0003C15.637 24.0003 18.8959 22.382 21.0965 19.8264H2.90332C5.10396 22.382 8.36285 24.0003 11.9999 24.0003Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M24 12C24 5.37263 18.6274 0 12 0C5.37262 0 0 5.37263 0 12C0 13.0831 0.144375 14.1323 0.413391 15.1305H23.5867C23.8556 14.1323 24 13.0831 24 12Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M0.954102 16.6962C1.18543 17.2397 1.45585 17.7625 1.76152 18.2614H22.239C22.5446 17.7624 22.8151 17.2397 23.0465 16.6962H0.954102Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M5.4988 7.56904L3.1543 6.53432L5.4988 5.4996L6.53347 3.15515L7.56814 5.4996L9.9126 6.53432L7.56814 7.56904L6.53347 9.9135L5.4988 7.56904Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.53326 4.44739L7.17221 5.89531L8.62018 6.53436L7.17221 7.17336L6.53326 8.62128L5.89421 7.17336L4.44629 6.53436L5.89421 5.89531L6.53326 4.44739Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3562" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function i$d(a3, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createTextVNode(" > "),
    createElementVNode("defs", null, [
      createElementVNode("linearGradient", {
        id: "IconifyId17ecdb2904d178eab26117",
        gradientUnits: "userSpaceOnUse",
        x1: "-1706.416",
        x2: "-1705.416",
        gradientTransform: "matrix(1.972 -1.9014 -2.3361 -1.2306 7188.126 -1233.376)"
      }, [
        createElementVNode("stop", { "stop-color": "#288549" }),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#288549"
        })
      ]),
      createElementVNode("linearGradient", {
        id: "IconifyId17ecdb2904d178eab26118",
        gradientUnits: "userSpaceOnUse",
        x1: "-1426.487",
        x2: "-1425.487",
        gradientTransform: "matrix(4.2109 1.6428 -2.7757 3.3581 11406.147 -4099.373)"
      }, [
        createElementVNode("stop", { "stop-color": "#288549" }),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#288549"
        })
      ]),
      createElementVNode("linearGradient", {
        id: "IconifyId17ecdb2904d178eab26119",
        gradientUnits: "userSpaceOnUse",
        x1: "-1740.867",
        x2: "-1739.866",
        gradientTransform: "matrix(-.6286 -2.665 -2.2494 1.3805 3029.934 -7118.667)"
      }, [
        createElementVNode("stop", { "stop-color": "#288549" }),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#288549"
        })
      ]),
      createElementVNode("linearGradient", {
        id: "IconifyId17ecdb2904d178eab26120",
        gradientUnits: "userSpaceOnUse",
        x1: "47.56",
        x2: "52.91",
        gradientTransform: "matrix(1 0 0 -1 0 66)"
      }, [
        createElementVNode("stop", { "stop-color": "#288549" }),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#288549"
        })
      ]),
      createElementVNode("linearGradient", {
        id: "IconifyId17ecdb2904d178eab26121",
        gradientUnits: "userSpaceOnUse",
        x1: "-1458.591",
        x2: "-1457.591",
        gradientTransform: "rotate(45 10033.28 17957.933) scale(6.6516)"
      }, [
        createElementVNode("stop", { "stop-color": "#288549" }),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#288549"
        })
      ]),
      createElementVNode("linearGradient", {
        id: "IconifyId17ecdb2904d178eab26122",
        gradientUnits: "userSpaceOnUse",
        x1: "-1618.009",
        x2: "-1617.009",
        gradientTransform: "matrix(1.1995 -5.0853 4.2924 2.6342 -5986.943 -13088.627)"
      }, [
        createElementVNode("stop", { "stop-color": "#288549" }),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#288549"
        })
      ])
    ]),
    createElementVNode("path", {
      fill: "#2a5f9e",
      d: "M11.9 12h20.8v20.8H11.9z"
    }),
    createElementVNode("path", {
      fill: "#ffffff",
      d: "M18.8 8.1V14h-7.3l14.4 18h6v-7.5z"
    }),
    createElementVNode("path", {
      d: "M31.9 2v30h-30c0 16.6 13.4 30 30 30s30-13.4 30-30s-13.5-30-30-30",
      fill: "#2a5f9e"
    }),
    createElementVNode("path", {
      d: "M10.9 18.9h-6c-1.9 4-3 8.4-3 13.1h12V13.9h-3v5",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      fill: "#ed4c5c",
      d: "M31.9 27.1L18.9 11h-6l17 21h2z"
    }),
    createElementVNode("path", {
      d: "M18.8 5v6h-7.9v3h21V2c-4.7 0-9.2 1.1-13.1 3",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M31.9 5H18.8c-6.1 2.9-11 7.9-13.9 13.9V32h6V11h21V5",
      fill: "#ed4c5c"
    }),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M49.9 27.9c.6-1.5 1.9-2.4 3-2c.3.1.6.3.7.6c-.1-.9-.5-1.7-1.2-2c-1.1-.4-2.5.5-3 2c-.4 1.1-.3 2.2.2 2.9c.1-.4.1-.9.3-1.5" }),
      createElementVNode("path", { d: "M42.1 24.5c-1.1-.4-2.4.5-3 2c-.3.7-.3 1.3-.2 1.9c-.5.4-1.2.6-2 .7c-.6 0-1.1 0-1.5-.2c.5.7 1.6 1.1 2.7 1.1c1.6-.1 2.9-1.1 2.8-2.3c0-.4-.2-.8-.5-1.1c.6-.6 1.5-.9 2.2-.7c.3.1.6.3.7.6c0-1-.5-1.7-1.2-2" }),
      createElementVNode("path", { d: "M59.6 27.6c-1-1.1-2.3-1.4-2.9-.5c-.2.2-.3.5-.3.8c-.3-.9-.2-1.7.2-2.3c.7-.8 2-.6 2.9.5c.7.8 1 1.9.9 2.7c-.2-.4-.5-.9-.8-1.2" }),
      createElementVNode("path", { d: "M36.2 27.1c.5-1.1.2-2.2-.6-2.4c-.2-.1-.5 0-.8 0c.5-.5 1.2-.8 1.8-.6c.9.2 1.1 1.3.6 2.4c-.4.8-1.1 1.4-1.8 1.6c.4-.2.7-.6.8-1" })
    ]),
    createElementVNode("path", {
      d: "M42.6 31.8s.1 5.1.1 5.5c.1.5.4 3.4 4.5 5.1c0 0 3.2-1.4 4-3.3c.8-1.9.7-5.5.7-5.5v-2l-9.3.2",
      fill: "#000000"
    }),
    createElementVNode("path", {
      d: "M43 32.2s.1 4.7.1 5.1c.1.4.3 3.1 4.2 4.7c0 0 3-1.3 3.8-3c.8-1.8.6-5.1.6-5.1v-1.8l-8.7.1",
      fill: "#ffffff"
    }),
    createElementVNode("g", { fill: "#1b81b6" }, [
      createElementVNode("path", { d: "M51.7 33.7l-1.2-.4l-1.6.7l-1.6-.5l-1.4.5l-1.7-.7l-1.2.5v1.6l1.2-.5l1.7.7l1.4-.5l1.6.5l1.6-.7l1.3.4l-.1-1.6" }),
      createElementVNode("path", { d: "M43.9 39.4c.1 0 2.1.6 2.1.6l1.4-.6l1.6.6s1.8-.7 2-.7c.5.1-2.7 2.7-3.6 2.7c-.8.1-4-2.4-3.5-2.6" }),
      createElementVNode("path", { d: "M51.4 38c-.2-.1-1-.3-1-.3l-1.5.7l-1.6-.6l-1.4.6l-1.6-.7s-.8.2-1 .4c-.1.1-.2-1.2-.2-1.2l1.2-.5l1.6.7l1.4-.6l1.6.6l1.5-.7l1.3.4c-.1 0-.2 1.3-.3 1.2" })
    ]),
    createElementVNode("path", {
      d: "M50.7 39.7l-.1.1l.1-.1m-3.2-5.5l-4.1 4.4c.2.4.4.8.7 1.3l3.4-3.5l3.2 3.4c.3-.4.6-.9.7-1.4l-3.9-4.2",
      fill: "url(#IconifyId17ecdb2904d178eab26121)"
    }),
    createElementVNode("path", {
      d: "M44.6 28.3l.6 1.4h4.2l.6-1.4l-2.7-6.4z",
      fill: "#000000"
    }),
    createElementVNode("path", {
      fill: "#7ed16d",
      d: "M44.8 28.1l.6 1.4h3.8l.5-1.4l-2.4-5.7z"
    }),
    createElementVNode("path", {
      fill: "#93695a",
      d: "M44.1 26.9l2.1 2.6l2.6-.1l.5-1.8l-1.8-.1l-1.2.6z"
    }),
    createElementVNode("path", {
      d: "M47.1 29.1l-3.2.9l1.5 1.8v1.7l1.6-.2s.8-1.5.9-1.5c.1 0 1.5.5 1.5.5l.3-.8l1.8-.6l-3.1-.9l.1-.8l-1.4-.1",
      fill: "#6baaa7"
    }),
    createElementVNode("path", {
      d: "M51.9 29.8c-.6.3-1.2.5-1.8.4c.7-.1 1.4-.7 1.6-1.4c.2-.8 0-1.6-.6-2.1c.1.4.1.7 0 1.1c-.3 1.1-1.5 1.9-2.6 1.4c-.5-.2-.6-.9-.6-1.2c-.3.7-.4 1.5 0 2.2c-.1.1-.1.2-.2.3c-.4 1 .1 2.1 1.1 2.4c.7.3 1.5.1 2-.4c-.3.1-.7 0-1-.1c-.6-.2-1-.7-1.1-1.2c.9.7 2.1.8 3.1.2c.9-.6 1.3-1.6 1.2-2.6c-.3.3-.6.7-1.1 1",
      fill: "url(#IconifyId17ecdb2904d178eab26120)"
    }),
    createElementVNode("path", {
      d: "M42.6 25.9c.5 1.5.1 3.1-1 3.5c-.3.1-.6.1-.9 0c.6.7 1.5 1 2.2.7c1.1-.4 1.6-1.9 1-3.5c-.4-1.1-1.2-1.9-2-2.1c.2.4.5.9.7 1.4",
      fill: "url(#IconifyId17ecdb2904d178eab26122)"
    }),
    createElementVNode("path", {
      d: "M36.1 27.2c-.3.8 0 1.6.5 1.8c.2.1.3.1.5 0c-.3.4-.8.5-1.1.4c-.6-.2-.8-1-.5-1.8c.2-.6.6-1 1.1-1.1c-.3.2-.4.4-.5.7",
      fill: "url(#IconifyId17ecdb2904d178eab26119)"
    }),
    createElementVNode("path", {
      d: "M58 25.4c-.8.2-1.4.8-1.3 1.4c0 .2.1.3.2.4c-.5-.1-.8-.4-.9-.8c-.1-.6.5-1.2 1.3-1.4c.6-.1 1.2 0 1.5.4H58",
      fill: "url(#IconifyId17ecdb2904d178eab26117)"
    }),
    createElementVNode("path", {
      d: "M55.9 27.5c-1.3.3-2.5-.4-2.7-1.5c-.1-.3 0-.6.1-.9c-.6.5-1 1.3-.8 2.1c.2 1.1 1.4 1.8 2.7 1.5c.9-.2 1.7-.9 1.9-1.7c-.3.1-.7.3-1.2.5",
      fill: "url(#IconifyId17ecdb2904d178eab26118)"
    }),
    createElementVNode("path", {
      d: "M36.1 43.3c-1.3-.5 2.9-2.7 4.7-2.6c1.4.1 4.2 2.5 3.2 2.8c-4.9 1.3-4.8 1-7.9-.2",
      fill: "#74948f"
    }),
    createElementVNode("path", {
      d: "M40.6 31.8c.1-.4.5-1.2.8-1.5c.3-.3 1.1-.6 1.5-.5c.3 0 1 .4.9.6h-.3c-.3.1-.4.9-.6 1.2c-.2.2-.8.3-.9.5c-.1.2.1 1 .1 1l-1.5.1s-.1-1 0-1.4",
      fill: "#e5c9bd"
    }),
    createElementVNode("path", {
      d: "M41 36.9c0 .1.7 1.8.9 2.5c.3 1.2-1.6 3.3-1.5 2.3c.2-1.3-.5-2.6-.5-2.6l1.1-2.2",
      fill: "#c6a397"
    }),
    createElementVNode("g", { fill: "#e5c9bd" }, [
      createElementVNode("path", { d: "M40.5 37.9c-.1.1.1 1.9.1 2.6c-.1 1.3-2.5 2.6-2.1 1.7c.6-1.2.3-2.6.3-2.6l1.7-1.7" }),
      createElementVNode("path", { d: "M41.5 33.3c0 .1 1.6 1.1 2.1 1.5c.9.9.5 3.6.1 2.7c-.6-1.2-1.8-1.9-1.8-1.9l-.4-2.3" })
    ]),
    createElementVNode("path", {
      d: "M41 32.4c-1.2.1-2.9 2.5-3.4 3.6c-.5 1.2-1.2 5-.5 5.2c.9.3 3.9-2 4.6-3.3c.6-1 .9-3.6.4-4.7c0-.2-.7-.8-1.1-.8",
      fill: "#d66b3c"
    }),
    createElementVNode("path", {
      d: "M58.6 43.3c1.3-.5-2.9-2.7-4.7-2.6c-1.4.1-4.2 2.5-3.2 2.8c4.9 1.3 4.7 1 7.9-.2",
      fill: "#74948f"
    }),
    createElementVNode("path", {
      d: "M54.1 31.8c-.1-.4-.5-1.2-.8-1.5c-.3-.3-1.1-.6-1.5-.5c-.3 0-1 .4-.9.6h.3c.3.1.4.9.6 1.2c.2.2.8.3.9.5c.1.2-.1 1-.1 1l1.5.1c-.1 0 .1-1 0-1.4",
      fill: "#e5c9bd"
    }),
    createElementVNode("path", {
      d: "M53.7 36.9c0 .1-.7 1.8-.9 2.5c-.3 1.2 1.6 3.3 1.5 2.3c-.2-1.3.5-2.6.5-2.6l-1.1-2.2",
      fill: "#c6a397"
    }),
    createElementVNode("g", { fill: "#e5c9bd" }, [
      createElementVNode("path", { d: "M54.2 37.9c.1.1-.1 1.9-.1 2.6c.1 1.3 2.5 2.6 2.1 1.7c-.6-1.2-.3-2.6-.3-2.6l-1.7-1.7" }),
      createElementVNode("path", { d: "M53.2 33.3c0 .1-1.6 1.1-2.1 1.5c-.9.9-.5 3.6-.1 2.7c.6-1.2 1.8-1.9 1.8-1.9l.4-2.3" })
    ]),
    createElementVNode("path", {
      d: "M53.7 32.4c1.2.1 2.9 2.5 3.4 3.6c.5 1.2 1.2 5 .5 5.2c-.9.3-3.9-2-4.6-3.3c-.6-1-.9-3.6-.4-4.7c0-.2.7-.8 1.1-.8",
      fill: "#d66b3c"
    })
  ]);
}
function h$u(i, F3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3563)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0028 12 0.00135937 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 12.0004H11.9999C11.9999 11.9895 11.9999 11.9791 11.9999 11.9683C11.9892 11.979 11.9785 11.9897 11.9678 12.0004Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26171C12 4.15023 12 2.76662 12 0.000854492H11.998C5.3715 0.00193262 0 5.37404 0 12.0008H6.26086V8.47524L9.78642 12.0008H11.9679C11.9787 11.9901 11.9894 11.9794 12 11.9687C12 11.1602 12 10.4389 12 9.78732L8.47443 6.26171H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.56567C4.19441 2.63438 2.63413 4.19466 1.56543 6.07149V12.0005H4.69588V4.69617V4.69613H12.0002C12.0002 3.7088 12.0002 2.76821 12.0002 1.56567H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0008 10.5249L7.73739 6.2615H6.26172C6.26172 6.26145 6.26172 6.2615 6.26172 6.2615L12.0008 12.0005H12.0008C12.0008 12.0005 12.0008 10.9831 12.0008 10.5249Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.23729 14.0864L7.89588 15.4635L9.38309 15.1198L8.71709 16.4933L9.91305 17.4417L8.42398 17.7774L8.42815 19.3038L7.23729 18.3488L6.04648 19.3038L6.05065 17.7774L4.56152 17.4417L5.75754 16.4933L5.09145 15.1198L6.57874 15.4635L7.23729 14.0864Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M17.9668 16.6954L18.2961 17.384L19.0397 17.2121L18.7066 17.8989L19.3047 18.3731L18.5601 18.5409L18.5622 19.3041L17.9668 18.8266L17.3714 19.3041L17.3734 18.5409L16.6289 18.3731L17.2269 17.8989L16.8939 17.2121L17.6375 17.384L17.9668 16.6954Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M14.9033 9.39148L15.2326 10.0801L15.9762 9.90814L15.6432 10.5949L16.2412 11.0691L15.4967 11.2369L15.4987 12.0002L14.9033 11.5227L14.3079 12.0002L14.3099 11.2369L13.5654 11.0691L14.1634 10.5949L13.8304 9.90814L14.574 10.0801L14.9033 9.39148Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M17.9668 5.21765L18.2961 5.90625L19.0397 5.73436L18.7067 6.42112L19.3046 6.89531L18.5601 7.06317L18.5622 7.82639L17.9668 7.34887L17.3714 7.82639L17.3734 7.06317L16.6289 6.89531L17.2268 6.42112L16.8939 5.73436L17.6375 5.90625L17.9668 5.21765Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M20.6416 8.34778L20.9709 9.03637L21.7145 8.86443L21.3815 9.5512L21.9795 10.0254L21.2349 10.1933L21.237 10.9565L20.6416 10.479L20.0462 10.9565L20.0482 10.1933L19.3037 10.0254L19.9017 9.5512L19.5687 8.86443L20.3123 9.03637L20.6416 8.34778Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M18.729 12.0004L18.988 12.7975H19.8262L19.1481 13.2902L19.4072 14.0873L18.729 13.5947L18.0509 14.0873L18.3099 13.2902L17.6318 12.7975H18.47L18.729 12.0004Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3563" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2j(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3564)" }, [
      createElementVNode("path", {
        d: "M23.2536 16.173C23.736 14.8731 24 13.467 24 11.9991C24 10.5313 23.736 9.12525 23.2536 7.82522L12 6.78174L0.746391 7.82522C0.264047 9.12525 0 10.5313 0 11.9991C0 13.467 0.264047 14.8731 0.746391 16.173L12 17.2165L23.2536 16.173Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9998 23.9996C17.1593 23.9996 21.5578 20.7431 23.2533 16.1735H0.746094C2.44166 20.7431 6.84013 23.9996 11.9998 23.9996Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9997 0C6.84012 0 2.44166 3.2565 0.746094 7.82611H23.2534C21.5578 3.2565 17.1593 0 11.9997 0Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3564" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$q(i, L3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3565)" }, [
      createElementVNode("path", {
        d: "M24 12.0001C24 10.5323 23.736 9.12615 23.2536 7.82621L12 7.30444L0.746391 7.82616C0.264047 9.12614 0 10.5323 0 12.0001C0 13.4679 0.264047 14.874 0.746391 16.174L12 16.6957L23.2536 16.174C23.736 14.874 24 13.4679 24 12.0001Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0007 23.9996C17.1603 23.9996 21.5588 20.7431 23.2543 16.1735H0.74707C2.44259 20.7431 6.8411 23.9996 12.0007 23.9996Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M0.74707 7.82513H23.2543C21.5588 3.25552 17.1603 -0.000976562 12.0007 -0.000976562C6.8411 -0.000976562 2.44259 3.25552 0.74707 7.82513Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.2605 15.3911C10.3875 15.3911 8.86915 13.8727 8.86915 11.9997C8.86915 10.1268 10.3875 8.60843 12.2605 8.60843C12.8444 8.60843 13.3939 8.75609 13.8737 9.01606C13.121 8.28007 12.0918 7.82581 10.9561 7.82581C8.6509 7.82581 6.78223 9.69452 6.78223 11.9997C6.78223 14.3049 8.65094 16.1736 10.9561 16.1736C12.0919 16.1736 13.1211 15.7193 13.8737 14.9833C13.3939 15.2434 12.8444 15.3911 12.2605 15.3911Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M14.8693 9.65076L15.3185 10.9141L16.5295 10.3384L15.9538 11.5493L17.2171 11.9986L15.9538 12.4478L16.5295 13.6588L15.3185 13.0831L14.8693 14.3464L14.4202 13.0831L13.2091 13.6588L13.7849 12.4478L12.5215 11.9986L13.7849 11.5493L13.2091 10.3384L14.4202 10.9141L14.8693 9.65076Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3565" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2i(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3566)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M7.30584 7.82513H23.2551C21.5596 3.25552 17.161 -0.000976562 12.0015 -0.000976562C8.68771 -0.000976562 5.68804 1.34241 3.5166 3.51413L7.30584 7.82513Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M7.30486 16.1725H23.2541C21.5586 20.7421 17.16 23.9986 12.0005 23.9986C8.68673 23.9986 5.68706 22.6552 3.51562 20.4835L7.30486 16.1725Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51428C-1.17157 8.20056 -1.17157 15.7986 3.51471 20.4849C5.45126 18.5484 7.31374 16.6859 12 11.9996L3.51471 3.51428Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3566" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function r$o(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3567)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000976562C9.59141 -0.000976562 7.34928 0.708945 5.46997 1.93018L8.55617 3.99873L4.69531 5.9987L8.55617 7.99866L4.69531 9.99863L8.55617 11.9984L4.69531 13.9983L8.55617 15.9982L4.69531 17.9984L8.55617 19.9983L5.46959 22.0675C7.349 23.289 9.59127 23.999 11.9997 23.999C18.627 23.999 23.9997 18.6264 23.9997 11.999C23.9997 5.37165 18.627 -0.000976562 11.9997 -0.000976562Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3567" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function r$n(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3568)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M9.3912 17.2175C12.2727 17.2175 14.6086 14.8816 14.6086 12.0001C14.6086 9.11861 12.2727 6.78271 9.3912 6.78271C6.50973 6.78271 4.17383 9.11861 4.17383 12.0001C4.17383 14.8816 6.50973 17.2175 9.3912 17.2175Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3568" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2h(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3569)" }, [
      createElementVNode("path", {
        d: "M17.2175 1.19084C15.6399 0.427997 13.87 0.00012207 12.0001 0.00012207C10.1303 0.00012207 8.36037 0.427997 6.78274 1.19084L5.73926 12.0001L6.78274 22.8094C8.36037 23.5722 10.1303 24.0001 12.0001 24.0001C13.87 24.0001 15.6399 23.5722 17.2175 22.8094L18.261 12.0001L17.2175 1.19084Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M6.78262 1.19128C2.76872 3.13219 0 7.24261 0 12.0001C0 16.7577 2.76872 20.8681 6.78262 22.809V1.19128Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M17.2178 1.19165V22.8094C21.2317 20.8685 24.0004 16.758 24.0004 12.0005C24.0004 7.24303 21.2317 3.13256 17.2178 1.19165Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M15.6518 7.30337L16.3518 7.65334L15.6518 7.30337L14.9518 6.9534C14.9096 7.03783 13.9956 8.8975 13.8463 11.7382H12.7822V7.30337L11.9996 6.25989L11.217 7.30337V11.7382H10.153C10.0036 8.8975 9.08966 7.03783 9.04743 6.9534L7.64746 7.65339C7.65712 7.67261 8.60835 9.60878 8.60835 12.5208V13.3034H11.217V17.7382H12.7822V13.3034H15.3909V12.5207C15.3909 11.0152 15.6514 9.77378 15.87 8.99744C16.1083 8.15087 16.3503 7.65648 16.3527 7.65156L15.6518 7.30337Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3569" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2g(e28, L3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3570)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FCFCFC"
      }),
      createElementVNode("path", {
        d: "M4.95669 11.1289L3.65234 8.76249L4.95669 6.43323L6.26103 8.76249L4.95669 11.1289Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M2.34731 11.1289L1.04297 8.76249L2.34731 6.43323L3.65166 8.76249L2.34731 11.1289Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M4.95669 17.5643L3.65234 15.1979L4.95669 12.8687L6.26103 15.1979L4.95669 17.5643Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M2.34731 17.5643L1.04297 15.1979L2.34731 12.8687L3.65166 15.1979L2.34731 17.5643Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M6.26041 2.32875L5.89113 1.66931C5.22878 2.06175 4.60755 2.51611 4.03516 3.02442L4.95606 4.69509L6.26041 2.32875Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M4.95605 19.3042L4.02539 20.9662C4.59727 21.4752 5.21808 21.9302 5.88014 22.3235L6.26044 21.6335L4.95605 19.3042Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M7.30371 15.1306V23.0461C8.74601 23.66 10.3329 24.0002 11.9994 24.0002C17.1589 24.0002 21.5575 20.7437 23.253 16.1741L7.30371 15.1306Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M23.253 16.174C23.7354 14.874 23.9994 13.468 23.9994 12.0001C23.9994 5.37275 18.6268 0.00012207 11.9994 0.00012207C10.333 0.00012207 8.74601 0.340106 7.30371 0.953935V16.1741H23.253V16.174Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3570" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2f(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3571)" }, [
      createElementVNode("path", {
        d: "M16.1735 0.746513C14.8735 0.264169 13.4675 0.00012207 11.9996 0.00012207C10.5318 0.00012207 9.1257 0.264169 7.82571 0.746513L6.78223 12.0001L7.82571 23.2537C9.1257 23.7361 10.5318 24.0001 11.9996 24.0001C13.4675 24.0001 14.8735 23.7361 16.1735 23.2537L17.217 12.0001L16.1735 0.746513Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.9999 11.9993C23.9999 6.83976 20.7434 2.4412 16.1738 0.745728V23.253C20.7434 21.5574 23.9999 17.1589 23.9999 11.9993Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 12C0 17.1596 3.2565 21.5581 7.82611 23.2537V0.74646C3.2565 2.44193 0 6.84049 0 12Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3571" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2e(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3572)" }, [
      createElementVNode("path", {
        d: "M24 12C24 7.8815 21.9249 4.24808 18.7635 2.08695L12 1.56519L5.23655 2.0869C2.07516 4.24808 0 7.88155 0 12C0 16.1186 2.07516 19.7519 5.23655 21.913L12 22.4348L18.7635 21.9131C21.9249 19.7519 24 16.1186 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M18.7642 2.08709C16.8384 0.77056 14.5097 0.00012207 12.0008 0.00012207C9.49187 0.00012207 7.16316 0.77056 5.2373 2.08709H18.7642Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M5.23633 21.9133C7.16214 23.2299 9.49089 24.0003 11.9998 24.0003C14.5087 24.0003 16.8374 23.2299 18.7632 21.9133H5.23633Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M12.0009 17.7382C15.1705 17.7382 17.74 15.1687 17.74 11.999C17.74 8.82939 15.1705 6.25989 12.0009 6.25989C8.83122 6.25989 6.26172 8.82939 6.26172 11.999C6.26172 15.1687 8.83122 17.7382 12.0009 17.7382Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0003 16.6954C14.5937 16.6954 16.696 14.5931 16.696 11.9997C16.696 9.4064 14.5937 7.30408 12.0003 7.30408C9.40701 7.30408 7.30469 9.4064 7.30469 11.9997C7.30469 14.5931 9.40701 16.6954 12.0003 16.6954Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M11.9996 15.1296C13.7285 15.1296 15.13 13.728 15.13 11.9991C15.13 10.2702 13.7285 8.86865 11.9996 8.86865C10.2707 8.86865 8.86914 10.2702 8.86914 11.9991C8.86914 13.728 10.2707 15.1296 11.9996 15.1296Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9994 11.217L10.3037 11.9997V13.304L11.9994 14.3475L13.695 13.304V11.9997L11.9994 11.217Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M13.695 10.4358H10.3037V12.001H13.695V10.4358Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3572" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2d(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3573)" }, [
      createElementVNode("path", {
        d: "M7.82617 10.9569L8.86966 23.587C9.86777 23.856 10.9169 24.0004 12.0001 24.0004C18.6274 24.0004 24.0001 18.6278 24.0001 12.0004L7.82617 10.9569Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.82617 12.0001L8.86961 0.413513C9.86777 0.144497 10.9169 0.00012207 12.0001 0.00012207C18.6274 0.00012207 24.0001 5.37275 24.0001 12.0001H7.82617Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M0 11.9997C0 17.544 3.76036 22.2093 8.86955 23.5863V0.413086C3.76036 1.79009 0 6.45537 0 11.9997Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3573" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$u(e28, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3574)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0001 5.73889V9.78622L7.82617 5.73889H12.0001Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M6.26098 11.9996H9.78649L6.26098 7.30396L5.73926 10.9561L6.26098 11.9996Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9688 12.0012H12.0009C12.0009 11.9904 12.0009 11.9798 12.0009 11.969C11.9902 11.9797 11.9795 11.9905 11.9688 12.0012Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.999 6.26135C11.999 4.14986 11.999 2.76635 11.999 0.000488281H11.997C5.37048 0.00161328 -0.000976562 5.37372 -0.000976562 12.0005H6.25988V8.47497L9.7854 12.0005H11.967C11.9776 11.9898 11.9883 11.9791 11.9991 11.9684C11.9991 11.1599 11.9991 10.4386 11.9991 9.78696L8.47346 6.26135H11.999Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07027 1.56519C4.19344 2.63389 2.63311 4.19417 1.56445 6.071V12.5217H4.69491V4.69573V4.69564H12.521C12.521 3.70831 12.521 2.76772 12.521 1.56519H6.07027Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.476 11.0002L7.73539 6.25977H6.25977V6.25986L12.4758 12.4759H12.4759C12.476 12.476 12.476 11.4584 12.476 11.0002Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.5654 6.25989V11.999C13.5654 14.7946 20.8698 14.7946 20.8698 11.999V6.25989H13.5654Z",
        fill: "#F3F3F3"
      }),
      createElementVNode("path", {
        d: "M13.5654 12.0005V12.0005C13.5654 14.7961 17.2176 15.6527 17.2176 15.6527C17.2176 15.6527 20.8698 14.7961 20.8698 12.0005V12.0005H13.5654Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M17.2171 9.70447L15.5215 10.4349V12.0001L17.2171 13.0436L18.9128 12.0001V10.4349L17.2171 9.70447Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M18.9128 8.86865H15.5215V10.4339H18.9128V8.86865Z",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3574" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$z(C3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3575)" }, [
      createElementVNode("path", {
        d: "M3.51373 20.4854C-1.17255 15.7991 -1.17255 8.20118 3.51373 3.51485C8.20002 -1.17148 15.798 -1.17143 20.4844 3.51485C20.4844 3.51649 23.6704 14.2988 18.984 18.9851C14.2978 23.6715 3.51702 20.4887 3.51373 20.4854Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.51465 20.4846C8.20093 25.1709 15.7989 25.1709 20.4853 20.4846C25.1716 15.7983 25.1716 8.20036 20.4853 3.51404L3.51465 20.4846Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M18.7886 6.78192V4.69495H14.7885L14.4829 5.00052C13.3959 6.08751 13.5788 7.35557 13.7123 8.28145C13.8361 9.14034 13.8509 9.46935 13.5315 9.78881C13.2121 10.1082 12.883 10.0934 12.0242 9.96946C11.0983 9.83601 9.83032 9.65315 8.74334 10.7401C7.6564 11.827 7.83935 13.095 7.97294 14.0208C8.09684 14.8796 8.11174 15.2086 7.79243 15.5279C7.47307 15.8472 7.14396 15.8323 6.28535 15.7084C5.95057 15.6601 5.6044 15.6102 5.23484 15.6061L5.21191 17.693C5.4432 17.6955 5.70752 17.7336 5.98737 17.774C6.31868 17.8219 6.69368 17.876 7.08865 17.876C7.49796 17.876 7.92855 17.8176 8.3538 17.634V19.3037H11.4843V17.7385H9.91905V16.695H10.9625V15.1298H10.1285C10.1681 14.6235 10.0985 14.1386 10.0385 13.7229C9.91465 12.8641 9.89974 12.5351 10.2191 12.2159C10.5385 11.8965 10.8674 11.9113 11.7264 12.0351C12.401 12.1324 13.2574 12.2553 14.093 11.8946V13.5646H17.2234V11.9994H15.6582V10.9559H16.7017V9.3907H15.8678C15.9074 8.88431 15.8379 8.39948 15.7779 7.98365C15.6914 7.3836 15.658 7.04217 15.7548 6.78196H18.7886V6.78192Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3575" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2c(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3576)" }, [
      createElementVNode("path", {
        d: "M24 12.0006C24 10.5328 23.736 9.12669 23.2536 7.82676L12 7.30499L0.746391 7.82671C0.264 9.12669 0 10.5328 0 12.0006C0 13.4685 0.264 14.8746 0.746391 16.1745L12 16.6963L23.2536 16.1746C23.736 14.8746 24 13.4685 24 12.0006Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9999C17.1593 23.9999 21.5578 20.7434 23.2533 16.1738H0.746094C2.44161 20.7434 6.84013 23.9999 11.9997 23.9999Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M0.746094 7.82641H23.2534C21.5578 3.25681 17.1593 0.000305176 11.9997 0.000305176C6.84012 0.000305176 2.44161 3.25681 0.746094 7.82641Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3576" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$p(i, L3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3577)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M3.51534 3.51432C0.943538 6.08612 -0.216478 9.5349 0.034444 12.898L12.899 0.0334789C9.53587 -0.21749 6.08713 0.942526 3.51534 3.51432Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M4.28516 21.1899C8.99989 25.1565 16.048 24.9219 20.4856 20.4843C24.9233 16.0467 25.1579 8.99856 21.1912 4.28387L4.28516 21.1899Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.957 11.5167L12.9912 10.9566L11.957 10.3964C11.7156 8.82794 10.4763 7.58861 8.90783 7.34721L8.34763 6.31305L7.78747 7.34716C6.21904 7.58857 4.97976 8.82789 4.73826 10.3964L3.7041 10.9566L4.73821 11.5167C4.97966 13.0852 6.21894 14.3246 7.78743 14.566L8.34763 15.6001L8.90778 14.566C10.4763 14.3246 11.7156 13.0852 11.957 11.5167ZM8.34768 13.0436C7.19507 13.0436 6.26071 12.1092 6.26071 10.9566C6.26071 9.80393 7.19502 8.86961 8.34768 8.86961C9.50033 8.86961 10.4346 9.80393 10.4346 10.9566C10.4346 12.1092 9.50029 13.0436 8.34768 13.0436Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M8.34767 9.39093L8.7995 10.1735H9.7032L9.25133 10.9561L9.7032 11.7388H8.7995L8.34767 12.5213L7.89584 11.7388H6.99219L7.44402 10.9561L6.99219 10.1735H7.89584L8.34767 9.39093Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3577" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$o(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3578)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9999 -0.000732422C7.74505 -0.000732422 4.0077 2.21378 1.87695 5.55297L18.15 22.3047C21.6536 20.2093 23.9999 16.3785 23.9999 11.9993C23.9999 5.37189 18.6273 -0.000732422 11.9999 -0.000732422Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.9996 11.9991C23.9996 8.8856 22.8137 6.04928 20.8691 3.91656V20.0817C22.8137 17.949 23.9996 15.1127 23.9996 11.9991Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M14.9901 22.587L16.2471 22.5862L16.6348 21.3904L17.024 22.5857L17.6544 22.5853C18.041 22.3784 18.4149 22.1509 18.7747 21.9043L2.0948 5.22437C1.81992 5.62543 1.56923 6.04421 1.34381 6.47827L1.49203 6.93352L2.74898 6.93272L1.73255 7.67218L2.1217 8.86744L1.10433 8.12926L0.497531 8.57063C0.174047 9.65701 0 10.8077 0 11.9992C0 18.6265 5.37262 23.9992 12 23.9992C13.4012 23.9992 14.7461 23.7586 15.9961 23.317L14.9901 22.587ZM2.67652 11.4774L3.06417 10.2818L2.04689 9.54348L3.30384 9.54268L3.69155 8.34694L4.0807 9.54221L5.33766 9.54141L4.32117 10.2809L4.71033 11.4761L3.69295 10.7379L2.67652 11.4774ZM5.26519 14.0861L5.65284 12.8904L4.63556 12.1522L5.89252 12.1514L6.28022 10.9556L6.66937 12.1509L7.92633 12.1501L6.90989 12.8896L7.29905 14.0848L6.28167 13.3466L5.26519 14.0861ZM7.85381 16.6948L8.24147 15.4991L7.22419 14.7608L8.48114 14.7601L8.86884 13.5643L9.258 14.7596L10.515 14.7588L9.49851 15.4982L9.88767 16.6935L8.8703 15.9552L7.85381 16.6948ZM11.4589 18.5641L10.4424 19.3035L10.8301 18.1078L9.81281 17.3695L11.0698 17.3687L11.4575 16.173L11.8467 17.3683L13.1036 17.3675L12.0872 18.1069L12.4763 19.3022L11.4589 18.5641ZM13.0311 21.9122L13.4188 20.7165L12.4015 19.9782L13.6584 19.9774L14.0461 18.7817L14.4353 19.977L15.6922 19.9762L14.6758 20.7156L15.065 21.9109L14.0476 21.1726L13.0311 21.9122Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3578" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2b(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3579)" }, [
      createElementVNode("path", {
        d: "M0.566625 8.34777C0.199031 9.49944 -4.68667e-05 10.7263 8.276e-09 11.9999C-4.68667e-05 13.2735 0.199031 14.5004 0.566672 15.6521L12 16.1739L23.4333 15.6521C23.8008 14.5004 24 13.2734 24 12C24 10.7264 23.8009 9.49944 23.4333 8.34777L12 7.82605L0.566625 8.34777Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M24 12.0005C24 11.2886 23.9377 10.5913 23.8187 9.91351H0.181313C0.0623437 10.5913 0 11.2885 0 12.0005C0 12.7124 0.0623906 13.4096 0.181313 14.0874H23.8187C23.9376 13.4096 24 12.7124 24 12.0005Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9997C17.3536 23.9997 21.8878 20.4933 23.433 15.6518H0.566406C2.11164 20.4932 6.64591 23.9996 11.9997 23.9997Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M11.9998 -0.00061035C6.64595 -0.00061035 2.11173 3.50578 0.566406 8.34712L23.433 8.34717C21.8878 3.50578 17.3536 -0.0007041 11.9998 -0.00061035Z",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3579" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$2a(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3580)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M11.9999 4.69611L21.913 12.0004L11.9999 19.3048L2.08691 12.0004L11.9999 4.69611Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0001 16.1738C14.3052 16.1738 16.174 14.3051 16.174 11.9999C16.174 9.69476 14.3052 7.82605 12.0001 7.82605C9.69489 7.82605 7.82617 9.69476 7.82617 11.9999C7.82617 14.3051 9.69489 16.1738 12.0001 16.1738Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.91276 11.7395C9.18694 11.7395 8.48649 11.8499 7.82715 12.0547C7.85635 14.3347 9.71279 16.1743 11.9997 16.1743C13.4138 16.1743 14.6628 15.4704 15.4178 14.3945C14.1261 12.7775 12.1385 11.7395 9.91276 11.7395Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M16.0962 12.7998C16.1464 12.5409 16.1735 12.2737 16.1735 12.0001C16.1735 9.69491 14.3048 7.82623 11.9997 7.82623C10.2796 7.82623 8.80306 8.86691 8.16406 10.3528C8.72891 10.2357 9.31372 10.1741 9.91273 10.1741C12.337 10.174 14.5301 11.1817 16.0962 12.7998Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3580" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$t(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3581)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M21.9999 13.4358C20.9999 13.4358 20.9999 12.5214 19.9998 12.5214C18.9999 12.5214 18.9999 13.4358 17.9999 13.4358C17 13.4358 16.9999 12.5214 16 12.5214C15 12.5214 15 13.4358 14 13.4358C13 13.4358 12.9999 12.5214 11.9998 12.5214C10.9998 12.5214 10.9998 13.4358 9.99991 13.4358C9.00006 13.4358 9.00006 12.5214 8.00008 12.5214C7 12.5214 7 13.4358 5.99992 13.4358C4.99984 13.4358 4.99984 12.5214 3.99977 12.5214C2.99992 12.5214 2.99992 13.4358 1.99994 13.4358C1.00534 13.4358 0.999578 12.5315 0.015625 12.5218C0.0433281 13.0707 0.108859 13.6096 0.207953 14.1366C1.00502 14.2537 1.07481 15.0357 2.00003 15.0357C3.00002 15.0357 3.00002 14.1215 3.99986 14.1215C4.99994 14.1215 4.99994 15.0357 6.00002 15.0357C7.00009 15.0357 7.00009 14.1215 8.00017 14.1215C9.00016 14.1215 9.00016 15.0357 10 15.0357C11 15.0357 11 14.1215 11.9999 14.1215C13 14.1215 13 15.0357 14.0001 15.0357C15.0002 15.0357 15.0002 14.1215 16.0001 14.1215C17.0001 14.1215 17.0001 15.0357 18 15.0357C19 15.0357 19 14.1215 19.9999 14.1215C21 14.1215 21 15.0357 22 15.0357C22.9252 15.0357 22.995 14.2537 23.7921 14.1366C23.8913 13.6096 23.9567 13.0708 23.9845 12.5218C23.0004 12.5315 22.9945 13.4358 21.9999 13.4358Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M20.0003 15.6514C19.0003 15.6514 19.0003 16.5658 18.0003 16.5658C17.0004 16.5658 17.0004 15.6514 16.0004 15.6514C15.0004 15.6514 15.0004 16.5658 14.0004 16.5658C13.0003 16.5658 13.0003 15.6514 12.0003 15.6514C11.0003 15.6514 11.0003 16.5658 10.0003 16.5658C9.00049 16.5658 9.00049 15.6514 8.00051 15.6514C7.00043 15.6514 7.00043 16.5658 6.00035 16.5658C5.00027 16.5658 5.00027 15.6514 4.0002 15.6514C3.00035 15.6514 3.00035 16.5658 2.00037 16.5658C1.26373 16.5658 1.06924 16.0699 0.618164 15.8087C0.891352 16.6253 1.25018 17.4024 1.68354 18.1301C1.77738 18.1527 1.88173 18.1658 2.00032 18.1658C3.0003 18.1658 3.0003 17.2515 4.00015 17.2515C5.00023 17.2515 5.00023 18.1658 6.0003 18.1658C7.00038 18.1658 7.00038 17.2515 8.00046 17.2515C9.00045 17.2515 9.00045 18.1658 10.0003 18.1658C11.0003 18.1658 11.0003 17.2515 12.0002 17.2515C13.0003 17.2515 13.0003 18.1658 14.0004 18.1658C15.0004 18.1658 15.0004 17.2515 16.0004 17.2515C17.0004 17.2515 17.0004 18.1658 18.0003 18.1658C19.0002 18.1658 19.0003 17.2515 20.0002 17.2515C21.0003 17.2515 21.0003 18.1658 22.0002 18.1658C22.1189 18.1658 22.2234 18.1527 22.3173 18.13C22.7507 17.4024 23.1094 16.6253 23.3826 15.8088C22.9315 16.07 22.737 16.5658 22.0002 16.5658C21.0004 16.5658 21.0003 15.6514 20.0003 15.6514Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.7211 9.41946C22.9902 9.57119 22.897 10.306 22.0002 10.306C21.0002 10.306 21.0002 9.39166 20.0002 9.39166C19.0002 9.39166 19.0002 10.306 18.0002 10.306C17.0003 10.306 17.0003 9.39166 16.0003 9.39166C15.0003 9.39166 15.0003 10.306 14.0003 10.306C13.0003 10.306 13.0002 9.39166 12.0001 9.39166C11.4598 9.39166 11.2114 9.65857 10.9395 9.904V11.504C11.2114 11.2586 11.4598 10.9917 12.0001 10.9917C13.0002 10.9917 13.0002 11.906 14.0003 11.906C15.0004 11.906 15.0004 10.9917 16.0003 10.9917C17.0003 10.9917 17.0003 11.906 18.0002 11.906C19.0002 11.906 19.0002 10.9917 20.0002 10.9917C21.0002 10.9917 21.0002 11.906 22.0002 11.906C22.9254 11.906 22.9952 11.124 23.7923 11.0069C23.8434 11.0069 23.9005 11.0064 23.959 11.0057C23.9147 10.466 23.8345 9.93654 23.7211 9.41946Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M22.8445 6.85727C22.6373 7.03132 22.3978 7.17588 22.0002 7.17588C21.0002 7.17588 21.0002 6.26154 20.0002 6.26154C19.0002 6.26154 19.0002 7.17588 18.0002 7.17588C17.0003 7.17588 17.0003 6.26154 16.0003 6.26154C15.0003 6.26154 15.0003 7.17588 14.0003 7.17588C13.0003 7.17588 13.0002 6.26154 12.0001 6.26154C11.4598 6.26154 11.2114 6.52844 10.9395 6.77388V8.37386C11.2114 8.12847 11.4598 7.86161 12.0001 7.86161C13.0002 7.86161 13.0002 8.77586 14.0003 8.77586C15.0003 8.77586 15.0003 7.86161 16.0003 7.86161C17.0003 7.86161 17.0003 8.77586 18.0002 8.77586C19.0001 8.77586 19.0001 7.86161 20.0001 7.86161C21.0002 7.86161 21.0002 8.77586 22.0001 8.77586C22.7097 8.77586 22.9164 8.31625 23.3335 8.04897C23.1914 7.6413 23.0281 7.24357 22.8445 6.85727Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M20.0856 3.13263C20.0579 3.13113 20.0296 3.13019 20.0002 3.13019C19.0002 3.13019 19.0002 4.04453 18.0003 4.04453C17.0003 4.04453 17.0003 3.13019 16.0004 3.13019C15.0004 3.13019 15.0004 4.04453 14.0003 4.04453C13.0002 4.04453 13.0002 3.13019 12.0001 3.13019C11.4598 3.13019 11.2114 3.39709 10.9395 3.64253V5.24252C11.2114 4.99713 11.4598 4.73027 12.0001 4.73027C13.0002 4.73027 13.0002 5.64452 14.0003 5.64452C15.0004 5.64452 15.0004 4.73027 16.0003 4.73027C17.0003 4.73027 17.0003 5.64452 18.0002 5.64452C19.0002 5.64452 19.0002 4.73027 20.0002 4.73027C21.0002 4.73027 21.0002 5.64452 22.0002 5.64452C22.0618 5.64452 22.1193 5.64086 22.1738 5.63435C21.5929 4.70791 20.8896 3.86617 20.0856 3.13263Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M15.0668 0.396249C14.7923 0.643186 14.5443 0.914405 13.9996 0.914405C12.9996 0.914405 12.9996 0.000154785 11.9995 6.10352e-05H11.9994C11.4822 0.00010791 11.2326 0.244655 10.9736 0.480858V2.08089C11.2325 1.84469 11.4823 1.60009 11.9995 1.60009C12.9996 1.60009 12.9996 2.51434 13.9997 2.51434C14.9997 2.51434 14.9997 1.60009 15.9997 1.60009C16.9997 1.60009 16.9997 2.51434 17.9996 2.51434C18.4192 2.51434 18.6626 2.35328 18.8778 2.16644C17.7371 1.36698 16.4509 0.761077 15.0668 0.396249Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M14.0003 22.8273C13.0002 22.8273 13.0002 21.913 12.0001 21.913C11.0002 21.913 11.0002 22.8273 10.0002 22.8273C9.00037 22.8273 9.00037 21.913 8.00038 21.913C7.2344 21.913 7.05473 22.4489 6.56348 22.7001C7.91817 23.3898 9.42131 23.8294 11.0122 23.9591C11.2583 23.7343 11.5082 23.513 12.0001 23.513C12.4922 23.513 12.7421 23.7343 12.9882 23.9592C14.5792 23.8295 16.0824 23.3898 17.4372 22.7001C16.9458 22.449 16.7662 21.9129 16.0003 21.9129C15.0004 21.9129 15.0004 22.8273 14.0003 22.8273Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M18.0003 19.6977C17.0003 19.6977 17.0003 18.7833 16.0003 18.7833C15.0004 18.7833 15.0004 19.6977 14.0003 19.6977C13.0002 19.6977 13.0003 18.7833 12.0002 18.7833C11.0002 18.7833 11.0002 19.6977 10.0003 19.6977C9.00041 19.6977 9.00041 18.7833 8.00042 18.7833C7.00034 18.7833 7.00034 19.6977 6.00027 19.6977C5.00019 19.6977 5.00019 18.7833 4.00011 18.7833C3.281 18.7833 3.07906 19.2563 2.65039 19.5218C2.91908 19.8555 3.20473 20.1749 3.50703 20.4777C3.64245 20.4199 3.80136 20.3834 4.00006 20.3834C5.00014 20.3834 5.00014 21.2976 6.00022 21.2976C7.0003 21.2976 7.0003 20.3834 8.00038 20.3834C9.00036 20.3834 9.00036 21.2976 10.0002 21.2976C11.0002 21.2976 11.0002 20.3834 12.0001 20.3834C13.0002 20.3834 13.0002 21.2976 14.0003 21.2976C15.0004 21.2976 15.0004 20.3834 16.0003 20.3834C17.0002 20.3834 17.0003 21.2976 18.0002 21.2976C19.0002 21.2976 19.0002 20.3834 20.0001 20.3834C20.1991 20.3834 20.358 20.4199 20.4935 20.4778C20.7958 20.1749 21.0815 19.8555 21.3502 19.5219C20.9215 19.2564 20.7195 18.7834 20.0002 18.7834C19.0002 18.7833 19.0002 19.6977 18.0003 19.6977Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 11.9991H11.9999C11.9999 11.9883 11.9999 11.9778 11.9999 11.9669C11.9892 11.9777 11.9785 11.9884 11.9678 11.9991Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0001 6.26153V9.78714L7.82617 5.73981L12.0001 6.26153Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M6.26102 12.0005H9.78649L6.26098 7.30487L5.73926 10.957L6.26102 12.0005Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.3715 0.001125 0 5.37323 0 12H6.2609V8.47448L9.78637 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.56415C4.19441 2.63285 2.63413 4.19313 1.56543 6.06996V11.9989H4.69588V4.6947V4.6946H12.0002C12.0002 3.70727 12.0002 2.76668 12.0002 1.56415H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9999 10.5234L7.73637 6.25995H6.26074V6.26004L11.9998 11.999H11.9999C11.9999 11.999 11.9999 10.9815 11.9999 10.5234Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.6523 6.26099H20.348L18.0002 8.60882L15.6523 6.26099Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M18.522 8.08649H17.4785V10.956H18.522V8.08649Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M18.521 15.652H17.4775V18.5215H18.521V15.652Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M21.13 14.0874C21.13 13.2229 20.4292 12.5222 19.5648 12.5222C19.1638 12.5222 18.7983 12.6731 18.5213 12.921V12.0004H19.043V10.9569H18.5213V10.4352H17.4778V10.9569H16.9561V12.0004H17.4778V12.921C17.2008 12.6731 16.8353 12.5222 16.4343 12.5222C15.5699 12.5222 14.8691 13.2229 14.8691 14.0874C14.8691 14.5508 15.0708 14.9671 15.3909 15.2537V16.1743H20.6082V15.2537C20.9284 14.9671 21.13 14.5508 21.13 14.0874Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.5652 13.5649C19.4006 13.5649 19.2854 13.6372 19.2177 13.6978L18.5217 14.3208H17.4783L16.7823 13.6978C16.7146 13.6372 16.5994 13.5649 16.4348 13.5649C16.1471 13.5649 15.9131 13.799 15.9131 14.0867C15.9131 14.2893 16.0224 14.4173 16.0875 14.4757L16.4349 14.7867V15.1301H19.5653V14.7867L19.9127 14.4757C19.9778 14.4174 20.0871 14.2893 20.0871 14.0867C20.087 13.799 19.8529 13.5649 19.5652 13.5649Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3581" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function V$6(h3, H3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3582)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9688 12.0007H12.0009C12.0009 11.9899 12.0009 11.9794 12.0009 11.9686C11.9902 11.9793 11.9795 11.99 11.9688 12.0007Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26178C12 4.15029 12 2.76677 12 0.000915527H11.998C5.37145 0.00204053 0 5.37415 0 12.0009H6.26086V8.4754L9.78637 12.0009H11.9679C11.9786 11.9902 11.9893 11.9795 12 11.9688C12 11.1604 12 10.439 12 9.78738L8.47443 6.26178H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07027 1.56415C4.19344 2.63285 2.63311 4.19313 1.56445 6.06996V11.9989H4.69491V4.6947V4.6946H11.9993C11.9993 3.70727 11.9993 2.76668 11.9993 1.56415H6.07027Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M17.218 11.9996L13.9746 15.2431C14.5825 16.4154 15.8063 17.217 17.218 17.217C18.6298 17.217 19.8536 16.4154 20.4615 15.2431L17.218 11.9996Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9999 10.5244L7.73637 6.26099H6.26074V6.26108L11.9998 12.0001H11.9999C11.9999 12.0001 11.9999 10.9826 11.9999 10.5244Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.5654 6.26099V12.0001V12.0001C13.5655 14.7957 17.2176 15.6523 17.2176 15.6523C17.2176 15.6523 20.8697 14.7957 20.8698 12.0001V12.0001V6.26099H13.5654Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M17.9998 8.86987H16.4346V13.0438H17.9998V8.86987Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M17.2172 9.65174C17.6494 9.65174 17.9998 9.30135 17.9998 8.86911C17.9998 8.43688 17.6494 8.08649 17.2172 8.08649C16.785 8.08649 16.4346 8.43688 16.4346 8.86911C16.4346 9.30135 16.785 9.65174 17.2172 9.65174Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M15.6529 7.30481H14.6094V8.34829H15.6529V7.30481Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.6519 9.65198H14.6084V10.6955H15.6519V9.65198Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.6519 12.0005H14.6084V13.044H15.6519V12.0005Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.8257 7.30548H18.7822V8.34897H19.8257V7.30548Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.8257 9.65198H18.7822V10.6955H19.8257V9.65198Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.8257 12.0005H18.7822V13.044H19.8257V12.0005Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3582" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$29(C3, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3583)" }, [
      createElementVNode("path", {
        d: "M12.0002 23.9977C18.6266 23.9977 23.9984 18.6259 23.9984 11.9995C23.9984 5.37302 18.6266 0.0012207 12.0002 0.0012207C5.37375 0.0012207 0.00195312 5.37302 0.00195312 11.9995C0.00195312 18.6259 5.37375 23.9977 12.0002 23.9977Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.6094 6.00122C1.06784 6.93912 0.668365 7.91967 0.402344 8.91846L20.468 20.5034C21.2 19.7736 21.8495 18.9373 22.3909 17.9995L1.6094 6.00122Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M17.9983 1.6092C13.1974 -1.16253 7.27791 -0.238742 3.53125 3.4969L23.5969 15.0818C24.9588 9.9694 22.799 4.38098 17.9983 1.6092Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M6.0003 22.3899C10.8011 25.1617 16.7207 24.2379 20.4673 20.5023L0.401573 8.91724C-0.960222 14.0298 1.19945 19.6182 6.0003 22.3899Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.3903 10.6964C15.3903 12.569 13.8722 14.0872 11.9995 14.0872C10.1268 14.0872 8.60867 12.5691 8.60867 10.6964C8.60867 10.1125 8.75629 9.56306 9.01626 9.08337C8.28045 9.83587 7.82617 10.8649 7.82617 12.0005C7.82617 14.3054 9.6946 16.1738 11.9995 16.1738C14.3044 16.1738 16.1728 14.3054 16.1728 12.0005C16.1728 10.8649 15.7186 9.83587 14.9827 9.08337C15.2427 9.56315 15.3903 10.1125 15.3903 10.6964Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.7828 6.78357H11.2178V14.6085H12.7828V6.78357Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.6082 8.34827H9.3916C9.3916 8.70841 9.70534 9.00036 10.0654 9.00036H10.0437C10.0437 9.36051 10.3357 9.65245 10.6958 9.65245C10.6958 10.0126 10.9878 10.3045 11.3479 10.3045H12.652C13.0122 10.3045 13.3041 10.0126 13.3041 9.65245C13.6643 9.65245 13.9562 9.36051 13.9562 9.00036H13.9345C14.2945 9.00031 14.6082 8.70846 14.6082 8.34827Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.6519 15.13H8.34863V16.695H15.6519V15.13Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.6944 15.651H13.5645V17.216H16.6944V15.651Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M10.4346 15.651H7.30469V17.216H10.4346V15.651Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3583" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$28(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3584)" }, [
      createElementVNode("path", {
        d: "M24 12.0007C24 10.5329 23.736 9.12676 23.2536 7.82682L12 7.30505L0.746391 7.82677C0.264047 9.12675 0 10.5329 0 12.0007C0 13.4685 0.264047 14.8747 0.746391 16.1746L12 16.6964L23.2536 16.1746C23.736 14.8747 24 13.4685 24 12.0007Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9999C17.1593 23.9999 21.5578 20.7434 23.2533 16.1738H0.746094C2.44161 20.7434 6.84012 23.9999 11.9997 23.9999Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0.746094 7.82538H23.2534C21.5578 3.25577 17.1593 -0.000732422 11.9997 -0.000732422C6.84012 -0.000732422 2.44161 3.25577 0.746094 7.82538Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3584" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$27(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3585)" }, [
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M24 12.0007C24 18.6281 18.6274 24.0007 12 24.0007C5.37262 24.0007 0 18.6281 0 12.0007",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0003 7.82544L12.9067 10.6153H15.8405L13.4671 12.3397L14.3736 15.1298L12.0003 13.4055L9.62697 15.1298L10.5336 12.3397L8.16016 10.6153H11.0938L12.0003 7.82544Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3585" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$26(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3674)" }, [
      createElementVNode("path", {
        d: "M23.2536 16.1744C23.736 14.8744 24 13.4683 24 12.0005C24 10.5326 23.736 9.1265 23.2536 7.82657L12 6.78308L0.746391 7.82657C0.264047 9.1265 0 10.5326 0 12.0005C0 13.4683 0.264047 14.8744 0.746391 16.1744L12 17.2178L23.2536 16.1744Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M23.2533 7.82599C21.5578 3.25638 17.1593 -0.00012207 11.9997 -0.00012207C6.84013 -0.00012207 2.44161 3.25638 0.746094 7.82599H23.2533Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9991C17.1593 23.9991 21.5578 20.7426 23.2533 16.173H0.746094C2.44161 20.7426 6.84012 23.9991 11.9997 23.9991Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.2292 10.153H13.9429L12.0003 4.17444L10.0577 10.153H3.77148L8.85719 13.848L6.91459 19.8267L12.0003 16.1744L17.0861 19.8266L15.1435 13.8479L20.2292 10.153Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3674" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$25(i, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3586)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M19.3067 2.48005C15.0105 -0.82586 8.98955 -0.82586 4.69336 2.48L12 9.78669L19.3067 2.48005Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 14.214L4.69336 21.5206C8.98955 24.8265 15.0105 24.8265 19.3067 21.5206L12 14.2139L12 14.214Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.78705 12.0003L2.48041 4.6936C-0.8255 8.98979 -0.8255 15.0108 2.48041 19.307L9.78705 12.0003Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M14.2148 12.0003L21.5214 19.307C24.8273 15.0108 24.8273 8.98979 21.5214 4.6936L14.2148 12.0003Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0006 17.2178C14.8821 17.2178 17.218 14.8819 17.218 12.0005C17.218 9.11898 14.8821 6.78308 12.0006 6.78308C9.1191 6.78308 6.7832 9.11898 6.7832 12.0005C6.7832 14.8819 9.1191 17.2178 12.0006 17.2178Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 8.34827L12.4518 9.13089H13.3555L12.9037 9.91347L13.3555 10.6961H12.4518L12 11.4787L11.5482 10.6961H10.6445L11.0964 9.91347L10.6445 9.13089H11.5482L12 8.34827Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.70319 12.001L10.155 12.7836H11.0587L10.6068 13.5662L11.0587 14.3488H10.155L9.70319 15.1314L9.25131 14.3488H8.34766L8.79948 13.5662L8.34766 12.7836H9.25131L9.70319 12.001Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.2969 12.001L14.7488 12.7836H15.6524L15.2006 13.5662L15.6524 14.3488H14.7488L14.2969 15.1314L13.8451 14.3488H12.9414L13.3932 13.5662L12.9414 12.7836H13.8451L14.2969 12.001Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3586" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$24(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3587)" }, [
      createElementVNode("path", {
        d: "M0 12.0009C0 14.0798 0.528891 16.0351 1.45908 17.74L12 18.7835L22.5409 17.74C23.4711 16.0351 24 14.0798 24 12.0009C24 9.92198 23.4711 7.96664 22.5409 6.26175L12 5.21826L1.45908 6.26175C0.528891 7.96664 0 9.92198 0 12.0009Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M1.45898 6.26123H22.5408C20.5056 2.5311 16.5484 0.000366211 11.9999 0.000366211C7.45139 0.000366211 3.49425 2.5311 1.45898 6.26123Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9999 24.0008C16.5484 24.0008 20.5056 21.4701 22.5408 17.74H1.45898C3.49425 21.4701 7.45139 24.0008 11.9999 24.0008Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M16.1745 14.3473V12.7821H15.131V10.6951L14.0876 9.65167L13.0441 10.6951V8.60818L12.0006 7.5647L10.9571 8.60818V10.6951L9.91361 9.65167L8.87013 10.6951V12.7821H7.82669V14.3473H6.7832V15.9125H17.218V14.3473H16.1745Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3587" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$23(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3588)" }, [
      createElementVNode("path", {
        d: "M17.2175 1.19108C15.6399 0.428241 13.87 0.000366211 12.0001 0.000366211C10.1303 0.000366211 8.36037 0.428241 6.78274 1.19108L5.73926 12.0004L6.78274 22.8096C8.36037 23.5725 10.1303 24.0004 12.0001 24.0004C13.87 24.0004 15.6399 23.5725 17.2175 22.8096L18.261 12.0004L17.2175 1.19108Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 7.82544L13.0359 11.0138H16.3888L13.6764 12.9846L14.7124 16.1732L12 14.2025L9.28753 16.1732L10.3237 12.9846L7.61133 11.0138H10.964L12 7.82544Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M6.78262 1.19165C2.76872 3.13256 0 7.24298 0 12.0005C0 16.758 2.76872 20.8685 6.78262 22.8094V1.19165Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M17.2178 1.19165V22.8094C21.2317 20.8685 24.0004 16.758 24.0004 12.0005C24.0004 7.24303 21.2317 3.13256 17.2178 1.19165Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3588" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$22(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3589)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M24.0004 12.0011C24.0004 7.24352 21.2317 3.13277 17.2178 1.19177V22.8103C21.2317 20.8693 24.0004 16.7586 24.0004 12.0011Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 12.0004C0 16.758 2.76867 20.8687 6.78262 22.8097V1.19116C2.76867 3.13216 0 7.24291 0 12.0004Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.087 13.5663L16.174 12.5228L15.1305 12.001V10.9576L13.0435 12.001L14.087 9.91408H13.0435L12.0001 8.34888L10.9566 9.91408H9.91309L10.9566 12.001L8.86961 10.9576V12.001L7.82617 12.5228L9.91309 13.5663L9.39138 14.6097H11.4783V16.1749H12.5218V14.6097H14.6088L14.087 13.5663Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3589" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function d$e(f3, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { fill: "#2a5f9e" }, [
      createElementVNode("path", { d: "M32 62c9.8 0 18.5-4.7 24-12H8c5.5 7.3 14.2 12 24 12" }),
      createElementVNode("path", { d: "M32 2C15.4 2 2 15.4 2 32h60C62 15.4 48.6 2 32 2z" })
    ]),
    createElementVNode("path", {
      d: "M61.4 38c.4-1.9.6-3.9.6-6H2c0 2.1.2 4.1.6 6h58.8",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M4.5 44h55c.8-1.9 1.5-3.9 1.9-6H2.6c.4 2.1 1.1 4.1 1.9 6",
      fill: "#ed4c5c"
    }),
    createElementVNode("path", {
      d: "M4.5 44c.9 2.1 2.1 4.2 3.5 6h48c1.4-1.8 2.6-3.9 3.5-6h-55",
      fill: "#ffffff"
    }),
    createElementVNode("g", { fill: "#ffce31" }, [
      createElementVNode("path", { d: "M25 26.1l1.2.9l-.4-1.5l1.2-1h-1.5L25 23l-.5 1.5H23l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M25 56.1l1.2.9l-.4-1.5l1.2-1h-1.5L25 53l-.5 1.5H23l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M36 36.1l1.2.9l-.4-1.5l1.2-1h-1.5L36 33l-.5 1.5H34l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M18 29.1l1.2.9l-.4-1.5l1.2-1h-1.5L18 26l-.5 1.5H16l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M32 29.1l1.2.9l-.4-1.5l1.2-1h-1.5L32 26l-.5 1.5H30l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M13 36.1l1.2.9l-.4-1.5l1.2-1h-1.5L13 33l-.5 1.5H11l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M36 48.1l1.2.9l-.4-1.5l1.2-1h-1.5L36 45l-.5 1.5H34l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M13 48.1l1.2.9l-.4-1.5l1.2-1h-1.5L13 45l-.5 1.5H11l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M31 54.1l1.2.9l-.4-1.5l1.2-1h-1.5L31 51l-.5 1.5H29l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M18 54.1l1.2.9l-.4-1.5l1.2-1h-1.5L18 51l-.5 1.5H16l1.2 1l-.4 1.5z" })
    ])
  ]);
}
function p$21(i, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3590)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9688 12.0004H12.0009C12.0009 11.9896 12.0009 11.9791 12.0009 11.9683C11.9902 11.979 11.9795 11.9897 11.9688 12.0004Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26037C12 4.14889 12 2.76537 12 -0.000488281H11.998C5.37145 0.000636719 0 5.37275 0 11.9995H6.26086V8.474L9.78638 11.9995H11.9679C11.9786 11.9888 11.9893 11.9781 12 11.9674C12 11.1589 12 10.4376 12 9.78598L8.47444 6.26037H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M17.2169 8.86913C18.3695 8.86913 19.3038 7.93476 19.3038 6.78216C19.3038 5.62956 18.3695 4.69519 17.2169 4.69519C16.0642 4.69519 15.1299 5.62956 15.1299 6.78216C15.1299 7.93476 16.0642 8.86913 17.2169 8.86913Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M6.07027 1.56531C4.19344 2.63401 2.63311 4.19429 1.56445 6.07112V12.0001H4.69491V4.69586V4.69576H11.9993C11.9993 3.70843 11.9993 2.76784 11.9993 1.56531H6.07027Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9989 10.5239L7.73539 6.2605H6.25977V6.26059L11.9988 11.9996H11.9989C11.9989 11.9996 11.9989 10.9821 11.9989 10.5239Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.8688 6.2605H13.5645V9.39095H20.8688V6.2605Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.5654 14.0869V16.1739H14.6634C15.3218 16.8191 16.223 17.2174 17.2176 17.2174C18.2122 17.2174 19.1134 16.8191 19.7718 16.1739H19.8263H20.8698V14.0869H13.5654Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M13.5654 8.86902V11.9995C13.5654 14.7951 17.2176 15.6516 17.2176 15.6516C17.2176 15.6516 20.8698 14.7951 20.8698 11.9995V8.86902H13.5654Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M17.2174 10.5404C16.3044 10.5404 16.3044 11.3752 15.3914 11.3752C14.4784 11.3752 14.4784 10.5404 13.5654 10.5404V12.0013C14.4784 12.0013 14.4784 12.8361 15.3914 12.8361C16.3044 12.8361 16.3044 12.0013 17.2174 12.0013C18.1304 12.0013 18.1304 12.8361 19.0436 12.8361C19.9567 12.8361 19.9566 12.0013 20.8698 12.0013V10.5404C19.9567 10.5404 19.9567 11.3752 19.0436 11.3752C18.1304 11.3752 18.1304 10.5404 17.2174 10.5404Z",
        fill: "#F3F3F3"
      }),
      createElementVNode("path", {
        d: "M17.2174 7.6167C16.3044 7.6167 16.3044 8.4515 15.3914 8.4515C14.4784 8.4515 14.4784 7.6167 13.5654 7.6167V9.07756C14.4784 9.07756 14.4784 9.91236 15.3914 9.91236C16.3044 9.91236 16.3044 9.07756 17.2174 9.07756C18.1304 9.07756 18.1304 9.91236 19.0436 9.91236C19.9567 9.91236 19.9566 9.07756 20.8698 9.07756V7.6167C19.9567 7.6167 19.9567 8.4515 19.0436 8.4515C18.1304 8.4515 18.1304 7.6167 17.2174 7.6167Z",
        fill: "#F3F3F3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3590" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$s(e28, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3591)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M22.5406 6.26036C20.99 3.41837 18.3236 1.27295 15.1301 0.412231L14.6084 6.26036H22.5406Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M1.45898 6.2606H9.39117L8.86945 0.412476C5.676 1.27319 3.00966 3.41866 1.45898 6.2606Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M14.6084 12.0017V17.7408H22.5406C23.4708 16.036 23.9997 14.0806 23.9997 12.0017H14.6084Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M9.39131 12.0007H0C0 14.0796 0.528891 16.035 1.45908 17.7399H9.39127V12.0007H9.39131Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M1.45898 17.7396C3.00966 20.5816 5.676 22.727 8.86945 23.5878L9.39117 18.4733L1.45898 17.7396Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.1301 23.5884C18.3236 22.7276 20.99 20.5822 22.5406 17.7402L14.6084 18.4738L15.1301 23.5884Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.6084 18.4738L22.5406 17.7402H14.6084V18.4738Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.39122 17.7396H1.45898L9.39122 18.4732V17.7396Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0006 0.000366211C10.9174 0.000366211 9.86827 0.144741 8.87012 0.413757V23.587C9.86827 23.856 10.9174 24.0004 12.0006 24.0004C13.0837 24.0004 14.1329 23.856 15.131 23.587V0.413757C14.1329 0.144741 13.0837 0.000366211 12.0006 0.000366211Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.45438 2.60913L6.7781 3.60555H7.8259L6.9783 4.2214L7.30207 5.21782L6.45438 4.60202L5.60674 5.21782L5.9306 4.2214L5.08301 3.60555H6.13071L6.45438 2.60913Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3591" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$20(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3592)" }, [
      createElementVNode("path", {
        d: "M12.0003 -0.000488281C10.5325 -0.000488281 9.12639 0.263559 7.82645 0.745902L7.30469 11.9995L7.82641 23.2531C9.12639 23.7355 10.5325 23.9995 12.0003 23.9995C13.4682 23.9995 14.8743 23.7355 16.1742 23.2531L16.696 11.9995L16.1743 0.745902C14.8743 0.263559 13.4682 -0.000488281 12.0003 -0.000488281Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M24.0009 12.0004C24.0009 6.84086 20.7444 2.44234 16.1748 0.746826V23.2541C20.7444 21.5585 24.0009 17.16 24.0009 12.0004Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.82611 23.254V0.746826C3.2565 2.44234 0 6.84086 0 12.0004C0 17.16 3.2565 21.5585 7.82611 23.254Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3592" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1$(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3593)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M24 12.0003C24 18.6277 18.6274 24.0003 12 24.0003C5.37262 24.0003 0 18.6277 0 12.0003C0 5.37293 12 12.0003 12 12.0003C12 12.0003 21.0825 12.0003 24 12.0003Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C12 4.56352 12 12 12 12C12 12 4.17389 12 0 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M7.14312 4.17346L7.92017 6.56493H10.4347L8.40041 8.0429L9.17741 10.4344L7.14312 8.95635L5.10884 10.4344L5.88584 8.0429L3.85156 6.56493H6.36608L7.14312 4.17346Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3593" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1_(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3594)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.56719 7.30139L7.60313 10.4889H10.9547L8.24531 12.4623L9.28125 15.6498L6.56719 13.6811L3.85313 15.6498L4.89375 12.4623L2.17969 10.4889H5.53125L6.56719 7.30139Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.226 18.5846L13.4338 17.6096L12.2619 18.0643L12.9416 17.0096L12.1494 16.03L13.3635 16.3534L14.0479 15.2987L14.1135 16.555L15.3322 16.8784L14.1557 17.3284L14.226 18.5846Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.802 15.7253L16.177 14.5253L15.1504 13.7987L16.4066 13.78L16.777 12.58L17.1848 13.7706L18.441 13.7565L17.4332 14.5065L17.8363 15.6971L16.8098 14.9706L15.802 15.7253Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M17.9256 8.80662L17.3725 9.9363L18.2725 10.8129L17.0303 10.6347L16.4771 11.7597L16.2615 10.5222L15.0146 10.3441L16.1303 9.75818L15.9146 8.51599L16.8146 9.39255L17.9256 8.80662Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.2592 5.38501L14.1654 6.63657L15.3326 7.11001L14.1092 7.41001L14.0201 8.66626L13.3592 7.59751L12.1357 7.89751L12.9467 6.93657L12.2811 5.87251L13.4482 6.34595L14.2592 5.38501Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3594" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$t(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3595)" }, [
      createElementVNode("path", {
        d: "M20.4853 20.4857C15.799 25.172 8.20104 25.172 3.51472 20.4857C-1.1716 15.7995 -1.17155 8.20146 3.51472 3.51514C3.88363 3.884 13.1068 10.8936 13.1068 10.8936L20.4853 20.4857Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M3.51465 3.51422C8.20092 -1.17206 15.7989 -1.17206 20.4853 3.51422C25.1716 8.20049 25.1715 15.7985 20.4853 20.4848",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0006 15.131C13.7295 15.131 15.131 13.7295 15.131 12.0006C15.131 10.2717 13.7295 8.87012 12.0006 8.87012C10.2717 8.87012 8.87012 10.2717 8.87012 12.0006C8.87012 13.7295 10.2717 15.131 12.0006 15.131Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M4.46876 17.2175L4.79806 17.9061L5.54164 17.7342L5.20864 18.4209L5.80667 18.8952L5.06211 19.0629L5.06417 19.8262L4.46876 19.3487L3.87336 19.8262L3.87542 19.0629L3.13086 18.8952L3.72889 18.4209L3.39584 17.7342L4.13947 17.9061L4.46876 17.2175Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M2.31442 11.4769L2.64372 12.1655L3.38729 11.9935L3.05434 12.6803L3.65228 13.1546L2.90776 13.3223L2.90982 14.0856L2.31442 13.6081L1.71906 14.0856L1.72108 13.3223L0.976562 13.1546L1.57455 12.6803L1.24155 11.9935L1.98512 12.1655L2.31442 11.4769Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M4.46872 6.78186L4.79801 7.47041L5.54159 7.29847L5.20864 7.98528L5.80662 8.45951L5.06206 8.62728L5.06412 9.39054L4.46872 8.91307L3.87331 9.39054L3.87537 8.62728L3.13086 8.45951L3.7288 7.98528L3.3958 7.29847L4.13942 7.47041L4.46872 6.78186Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.1445 10.4346L7.47379 11.1231L8.21742 10.9512L7.88437 11.638L8.48236 12.1122L7.73784 12.28L7.73986 13.0432L7.1445 12.5658L6.54909 13.0432L6.55116 12.28L5.80664 12.1122L6.40458 11.638L6.07162 10.9512L6.8152 11.1231L7.1445 10.4346Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.23094 13.5646L5.48998 14.3617H6.3281L5.65001 14.8544L5.90904 15.6515L5.23094 15.1589L4.55285 15.6515L4.81188 14.8544L4.13379 14.3617H4.97191L5.23094 13.5646Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 14.0871H13.0434C13.0434 14.0871 13.4956 13.2872 13.0434 12.5219L14.0869 11.4784L13.5652 10.4349H13.0435C13.0435 10.4349 12.7826 11.2176 11.7391 11.2176C10.6957 11.2176 10.4348 10.4349 10.4348 10.4349H9.91309L10.4348 11.4784L9.91309 12.5219L10.4348 13.0436C10.4348 13.0436 10.9565 12.0001 12 12.5219C12 12.5219 12.4434 13.1741 12 14.0871Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M19.7888 6.57258C19.8134 6.44437 19.8265 6.31214 19.8265 6.17677C19.8265 5.24864 19.2205 4.4625 18.3828 4.19128C18.6387 4.7116 18.783 5.29678 18.783 5.91591C18.783 6.12469 18.7662 6.32953 18.7347 6.52945C18.6086 6.32634 18.4466 6.14077 18.2488 5.98331C17.5034 5.39025 16.4849 5.37455 15.7318 5.874C16.3132 6.00094 16.8754 6.25898 17.3726 6.65456C17.7618 6.96431 18.0763 7.38328 18.3172 7.78772L15.1309 8.78545C18.2613 9.30717 20.87 7.22025 20.87 7.22025C20.5809 6.64219 20.132 6.54469 19.7888 6.57258Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3595" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$n(i, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3596)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M18.4209 17.2178L18.7502 17.9063L19.4938 17.7345L19.1608 18.4212L19.7588 18.8954L19.0142 19.0632L19.0163 19.8265L18.4209 19.349L17.8255 19.8265L17.8275 19.0632L17.083 18.8954L17.681 18.4212L17.348 17.7345L18.0916 17.9063L18.4209 17.2178Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.3574 9.91223L15.6867 10.6008L16.4304 10.4289L16.0973 11.1157L16.6953 11.5899L15.9508 11.7577L15.9528 12.5209L15.3574 12.0435L14.762 12.5209L14.764 11.7577L14.0195 11.5899L14.6175 11.1157L14.2845 10.4289L15.0281 10.6008L15.3574 9.91223Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M18.4208 5.73828L18.7501 6.42683L19.4937 6.25489L19.1608 6.9417L19.7587 7.41594L19.0142 7.5837L19.0162 8.34697L18.4208 7.86945L17.8254 8.34697L17.8275 7.5837L17.083 7.41594L17.6809 6.9417L17.3479 6.25489L18.0915 6.42683L18.4208 5.73828Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M21.0976 8.87012L21.4269 9.55866L22.1706 9.38677L21.8376 10.0736L22.4355 10.5478L21.691 10.7156L21.6931 11.4788L21.0976 11.0013L20.5022 11.4788L20.5042 10.7156L19.7598 10.5478L20.3578 10.0736L20.0247 9.38677L20.7683 9.55866L21.0976 8.87012Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.1841 12.5211L19.4432 13.3183H20.2813L19.6032 13.811L19.8623 14.6081L19.1841 14.1155L18.506 14.6081L18.765 13.811L18.0869 13.3183H18.9251L19.1841 12.5211Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M13.3045 15.3913C11.4315 15.3913 9.9131 13.8729 9.9131 12C9.9131 10.127 11.4314 8.60867 13.3045 8.60867C13.8884 8.60867 14.4379 8.75638 14.9177 9.0163C14.1651 8.28027 13.1359 7.82605 12 7.82605C9.69489 7.82605 7.82617 9.69477 7.82617 11.9999C7.82617 14.3051 9.69489 16.1738 12 16.1738C13.1359 16.1738 14.1651 15.7196 14.9176 14.9836C14.4379 15.2436 13.8884 15.3913 13.3045 15.3913Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M7.54678 4.69546C7.18584 4.07184 6.51201 3.65198 5.7397 3.65198C4.96738 3.65198 4.29356 4.07184 3.93262 4.69546H7.54678Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M7.55328 4.7074L5.73927 6.52141L3.92525 4.7074C3.75186 5.01166 3.65234 5.36355 3.65234 5.73883C3.65234 6.89144 4.5867 7.8258 5.73931 7.8258C6.89192 7.8258 7.82628 6.89149 7.82628 5.73883C7.82623 5.36355 7.72667 5.01166 7.55328 4.7074Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.21777 6.00049V7.76083C5.38451 7.80372 5.55935 7.82655 5.73949 7.82655C5.91964 7.82655 6.09448 7.80367 6.26121 7.76083V6.00049H5.21777Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3596" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1Z(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3597)" }, [
      createElementVNode("path", {
        d: "M0 12C0 5.37263 5.37262 0 12 0C18.6274 0 24 5.37263 24 12L12 13.0435L0 12Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M1.60547 18.0005C3.68039 21.5872 7.55808 24.0005 11.9997 24.0005C16.4414 24.0005 20.319 21.5872 22.394 18.0005L11.9997 17.2179L1.60547 18.0005Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M22.3942 17.9998C23.4153 16.2347 24 14.1856 24 11.9998H0C0 14.1856 0.584719 16.2347 1.60575 17.9998H22.3942Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3597" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$m(i, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3598)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9994 11.9653H10.9911C8.40842 14.548 6.84664 16.542 5.25195 18.1367L12.0346 18.7479L22.5596 17.7044C23.4781 16.0078 23.9998 14.0649 23.9998 12.0001C23.9998 11.9884 23.9994 11.977 23.9994 11.9653Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M5.25272 6.22564H22.522C20.4812 2.51464 16.5348 -0.000488281 12.0005 -0.000488281C8.69559 -0.000488281 5.70328 1.33597 3.5332 3.49751L5.25272 6.22564Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.77327 17.704C4.69449 18.7828 4.27759 19.6866 3.49707 20.4671C5.66996 22.649 8.67676 23.9996 11.9994 23.9996C16.562 23.9996 20.5297 21.4531 22.5592 17.704H5.77327Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.48035C-1.17157 8.16663 -1.17157 15.7646 3.51471 20.451C5.45126 18.5144 7.31374 16.6519 12 11.9657L3.51471 3.48035Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M3.16584 11.9647C3.16584 10.2163 4.39457 8.75575 6.03538 8.39744C5.78319 8.34236 5.52154 8.3125 5.25276 8.3125C3.23568 8.3125 1.60059 9.9476 1.60059 11.9647C1.60059 13.9818 3.23568 15.6169 5.25276 15.6169C5.52149 15.6169 5.78315 15.587 6.03538 15.5319C4.39457 15.1736 3.16584 13.713 3.16584 11.9647Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.99574 8.83472L6.19004 9.43256H6.81863L6.31004 9.80208L6.50434 10.3999L5.99574 10.0305L5.48715 10.3999L5.68145 9.80208L5.17285 9.43256H5.80145L5.99574 8.83472Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.99574 10.3998L6.19004 10.9977H6.81863L6.31004 11.3671L6.50434 11.965L5.99574 11.5955L5.48715 11.965L5.68145 11.3671L5.17285 10.9977H5.80145L5.99574 10.3998Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.99574 11.9646L6.19004 12.5624H6.81863L6.31004 12.932L6.50434 13.5298L5.99574 13.1603L5.48715 13.5298L5.68145 12.932L5.17285 12.5624H5.80145L5.99574 11.9646Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.99574 13.5297L6.19004 14.1275H6.81863L6.31004 14.497L6.50434 15.0949L5.99574 14.7254L5.48715 15.0949L5.68145 14.497L5.17285 14.1275H5.80145L5.99574 13.5297Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3598" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1Y(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3694)" }, [
      createElementVNode("path", {
        d: "M6.50505 22.6698L15.3206 15.3194L22.6709 6.50387C21.5281 4.28913 19.716 2.47605 17.5022 1.33179L8.67967 8.67854L1.33301 17.501C2.47718 19.7149 4.29025 21.527 6.50505 22.6698Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M20.485 20.4851C24.2709 16.6992 24.9977 11.0134 22.6669 6.49719L6.49707 22.667C11.0133 24.9978 16.6991 24.271 20.485 20.4851Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.51436 3.51375C-0.271537 7.29965 -0.998285 12.9855 1.33248 17.5017L17.5023 1.33191C12.9861 -0.998946 7.30026 -0.272103 3.51436 3.51375Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3694" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1X(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3606)" }, [
      createElementVNode("path", {
        d: "M22.667 6.49842C22.1125 5.42409 21.3857 4.41572 20.4852 3.51516C19.5845 2.61455 18.5761 1.88775 17.5018 1.33331L9.04798 9.04922L1.33203 17.5031C1.88652 18.5774 2.61331 19.5858 3.51387 20.4864C4.41444 21.387 5.42286 22.1138 6.49714 22.6682L14.951 14.9523L22.667 6.49842Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.51455 20.4854C4.01795 20.9888 4.55509 21.4378 5.11848 21.8331L21.8334 5.11811C21.4381 4.55472 20.9892 4.01758 20.4858 3.51419C19.9824 3.0108 19.4453 2.56188 18.8819 2.16663L2.16699 18.8815C2.5622 19.4448 3.01112 19.982 3.51455 20.4854Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.51441 3.51437C-0.271541 7.30032 -0.998338 12.9862 1.33257 17.5023L17.5024 1.33257C12.9862 -0.998286 7.30032 -0.271396 3.51441 3.51437Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M20.486 20.4851C24.2719 16.6992 24.9986 11.0133 22.6679 6.49713L6.49805 22.6669C11.0142 24.9978 16.7001 24.271 20.486 20.4851Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M6.39547 3.65118L7.043 5.64417H9.1385L7.44322 6.87586L8.09075 8.86879L6.39547 7.63706L4.70009 8.86879L5.34772 6.87586L3.65234 5.64417H5.74784L6.39547 3.65118Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3606" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function e$3(F3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3599)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 12.001H11.9999C11.9999 11.9902 11.9999 11.9797 11.9999 11.9689C11.9892 11.9796 11.9785 11.9903 11.9678 12.001Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26184C12 4.15035 12 2.76684 12 0.000976562H11.998C5.37145 0.00210156 0 5.37421 0 12.001H6.26086V8.47546L9.78637 12.001H11.9679C11.9786 11.9903 11.9893 11.9796 12 11.9689C12 11.1604 12 10.4391 12 9.78745L8.47443 6.26184H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.56458C4.19441 2.63328 2.63409 4.19356 1.56543 6.07039V11.9994H4.69588V4.69512V4.69503H12.0002C12.0002 3.7077 12.0002 2.76711 12.0002 1.56458H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9999 10.5236L7.73637 6.26013H6.26074V6.26023L11.9998 11.9992H11.9999C11.9999 11.9992 11.9999 10.9817 11.9999 10.5236Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.1747 12L16.3968 12.6833H17.1152L16.534 13.1055L16.756 13.7888L16.1747 13.3665L15.5935 13.7888L15.8155 13.1055L15.2344 12.6833H15.9527L16.1747 12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.2229 13.223L13.863 13.5491L14.371 13.0411L14.2586 13.7507L14.8987 14.0769L14.1891 14.1892L14.0768 14.8989L13.7506 14.2587L13.041 14.3711L13.5491 13.8631L13.2229 13.223Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 16.1731L12.6833 15.9511L12.6833 15.2328L13.1055 15.8139L13.7888 15.5918L13.3665 16.1731L13.7888 16.7544L13.1055 16.5324L12.6833 17.1135V16.3952L12 16.1731Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.2229 19.1254L13.549 18.4853L13.041 17.9774L13.7506 18.0897L14.0768 17.4496L14.1891 18.1592L14.8987 18.2715L14.2586 18.5977L14.371 19.3073L13.863 18.7992L13.2229 19.1254Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M16.1738 20.3481L15.9518 19.6648H15.2334L15.8146 19.2426L15.5926 18.5593L16.1738 18.9816L16.7551 18.5593L16.5331 19.2426L17.1143 19.6648H16.3959L16.1738 20.3481Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M19.125 19.1254L18.4849 18.7994L17.977 19.3073L18.0893 18.5977L17.4492 18.2716L18.1588 18.1592L18.2712 17.4496L18.5973 18.0897L19.3069 17.9774L18.7988 18.4853L19.125 19.1254Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M20.3484 16.1731L19.6651 16.3952V17.1135L19.2428 16.5323L18.5596 16.7544L18.9819 16.1731L18.5596 15.5918L19.2428 15.8139L19.6651 15.2328V15.9511L20.3484 16.1731Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M19.125 13.223L18.799 13.8631L19.3069 14.3711L18.5973 14.2587L18.2712 14.8988L18.1588 14.1892L17.4492 14.0768L18.0893 13.7507L17.977 13.0411L18.485 13.5491L19.125 13.223Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3599" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1W(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3600)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.2536 7.82617H0.746391C0.264047 9.12616 0 10.5322 0 12.0001C0 13.4679 0.264047 14.874 0.746391 16.174H23.2537C23.736 14.874 24 13.4679 24 12.0001C24 10.5322 23.736 9.12616 23.2536 7.82617Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0009 -0.000488281C8.36383 -0.000488281 5.10494 1.61782 2.9043 4.1734H21.0975C18.8969 1.61782 15.638 -0.000488281 12.0009 -0.000488281Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M21.0965 19.826H2.90332C5.10396 22.3816 8.36285 23.9999 11.9999 23.9999C15.637 23.9999 18.8959 22.3816 21.0965 19.826Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3600" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function i$c(n3, c3) {
  return openBlock(), createElementBlock("svg", {
    height: "24",
    width: "24",
    viewBox: "0 0 473.681 473.681",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      style: { fill: "#008E56" },
      d: `M315.8,13.537l-27.64,76.628c25.511,84.197,25.511,209.158,0,293.358l27.639,76.624\r
	c91.975-32.523,157.881-120.201,157.881-223.309C473.682,133.731,407.774,46.057,315.8,13.537z`
    }),
    createElementVNode("g", null, [
      createElementVNode("path", {
        style: { fill: "#E7E7E7" },
        d: `M315.8,90.161V13.537c-24.7-8.736-51.266-13.534-78.961-13.534\r
		C273.359,0.004,222.723,123.772,315.8,90.161z`
      }),
      createElementVNode("path", {
        style: { fill: "#E7E7E7" },
        d: `M236.839,473.681c27.695,0,54.261-4.798,78.961-13.534v-76.624\r
		C223.657,374.328,236.839,473.681,236.839,473.681z`
      })
    ]),
    createElementVNode("path", {
      style: { fill: "#E97E24" },
      d: `M0.001,236.838c0,103.456,66.355,191.362,158.805,223.623V13.223\r
	C66.356,45.484,0.001,133.391,0.001,236.838z`
    }),
    createElementVNode("path", {
      style: { fill: "#14B36F" },
      d: "M315.8,90.161v293.358C341.315,299.323,341.315,174.361,315.8,90.161z"
    }),
    createElementVNode("path", {
      style: { fill: "#F3F1F2" },
      d: `M315.8,383.523V90.161C299.672,36.94,273.356,0,236.839,0c-27.351,0-53.592,4.693-78.034,13.223\r
	v447.238c24.442,8.523,50.682,13.219,78.034,13.219C273.359,473.681,299.674,436.745,315.8,383.523z`
    })
  ]);
}
function p$1V(i, H3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3601)" }, [
      createElementVNode("path", {
        d: "M24 12C24 10.5321 23.736 9.12602 23.2536 7.82609L12 7.30432L0.746391 7.82604C0.264047 9.12602 0 10.5321 0 12C0 13.4678 0.264047 14.8739 0.746391 16.1739L12 16.6956L23.2536 16.1739C23.736 14.8739 24 13.4678 24 12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9995C17.1593 23.9995 21.5578 20.743 23.2533 16.1733H0.746094C2.44161 20.743 6.84013 23.9995 11.9997 23.9995Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M0.746094 7.82666H23.2534C21.5578 3.25705 17.1593 0.000549316 11.9997 0.000549316C6.84012 0.000549316 2.44161 3.25705 0.746094 7.82666Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.1309 8.34753H13.0439L13.3918 5.7388L14.7831 4.69531L16.1743 5.7388V7.82576L15.1309 8.34753Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M8.86961 8.34802H10.9566L10.6087 5.73928L9.21742 4.6958L7.82617 5.73928V7.82625L8.86961 8.34802Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M13.3911 8.34777H10.6084V5.73904L11.9997 4.69556L13.3911 5.73904V8.34777Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M7.82617 7.82574V13.5648C7.82617 14.9314 8.48627 16.1467 9.50439 16.9085L10.2348 16.7258L11.1566 17.653C11.4292 17.7092 11.7112 17.7388 12.0001 17.7388C12.2875 17.7388 12.5681 17.7096 12.8392 17.654L13.8914 16.7779L14.4957 16.9068C15.5134 16.145 16.174 14.931 16.174 13.5648V7.82574H7.82617Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.49572 7.82593H7.82617V9.49548H9.49572V7.82593Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.8346 7.82593H11.165V9.49548H12.8346V7.82593Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.1744 7.82593H14.5049V9.49548H16.1744V7.82593Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.1647 9.495H9.49512V11.1645H11.1647V9.495Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.5045 9.495H12.835V11.1645H14.5045V9.495Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.49572 11.1638H7.82617V12.8334H9.49572V11.1638Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.1647 12.8347H9.49512V14.5042H11.1647V12.8347Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.8346 11.1638H11.165V12.8334H12.8346V11.1638Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.1744 11.1638H14.5049V12.8334H16.1744V11.1638Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.5045 12.8347H12.835V14.5042H14.5045V12.8347Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.8346 14.5039H11.165V16.1734H12.8346V14.5039Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.49542 14.5039H7.93359C8.07684 15.1245 8.35847 15.6924 8.74462 16.1734H9.49542V14.5039V14.5039Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.5049 16.1736H15.2556C15.6419 15.6926 15.9234 15.1247 16.0667 14.5041H14.5049V16.1736V16.1736Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.49512 16.1732V16.9016C9.98069 17.267 10.5482 17.529 11.1647 17.6547V16.1732H9.49512V16.1732Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.835 16.1732V17.6547C13.4515 17.5291 14.0189 17.267 14.5045 16.9016V16.1732H12.835V16.1732Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3601" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$l(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3602)" }, [
      createElementVNode("path", {
        d: "M12 24.0001C18.6273 24.0001 23.9999 18.6275 23.9999 12.0001C23.9999 5.37274 18.6273 0.000183105 12 0.000183105C5.37256 0.000183105 0 5.37274 0 12.0001C0 18.6275 5.37256 24.0001 12 24.0001Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9999 0.000244141C8.07405 0.000244141 4.58871 1.8857 2.39941 4.80024H21.6004C19.4111 1.88565 15.9258 0.000244141 11.9999 0.000244141Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9999 24.0002C15.9258 24.0002 19.4111 22.1147 21.6004 19.2002H2.39941C4.58866 22.1148 8.07406 24.0002 11.9999 24.0002Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M0 12.0002C0 12.8222 0.0828749 13.6248 0.240328 14.4002H23.7597C23.9172 13.6248 24 12.8222 24 12.0002C24 11.1783 23.9171 10.3757 23.7597 9.60022H0.240328C0.0828749 10.3757 0 11.1783 0 12.0002Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M3.51468 3.51459C-1.17156 8.20082 -1.17156 15.7988 3.51468 20.4852C5.45122 18.5486 7.31366 16.6861 11.9999 11.9999L3.51468 3.51459Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.85695 8.86957L5.63385 11.2609H8.14851L6.11427 12.739L6.89118 15.1303L4.85695 13.6524L2.82262 15.1303L3.59971 12.739L1.56543 11.2609H4.0799L4.85695 8.86957Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3602" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1U(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3603)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12 24.0007C15.9375 24.0007 19.432 22.1042 21.6201 19.1749H2.37988C4.56801 22.1042 8.06249 24.0007 12 24.0007Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M24 12C24 5.37263 18.6274 0 12 0C5.37262 0 0 5.37263 0 12C0 13.419 0.246984 14.7803 0.699188 16.0439H23.3008C23.753 14.7803 24 13.419 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M8.21457 7.69598L8.86205 9.68873H10.9576L9.26232 10.9205L9.9098 12.9134L8.21457 11.6817L6.51934 12.9134L7.16691 10.9205L5.47168 9.68873H7.56708L8.21457 7.69598Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M4.61541 5.6095L5.00391 6.80519H6.26124L5.2441 7.54422L5.6326 8.73995L4.61541 8.00092L3.59827 8.73995L3.98682 7.54422L2.96973 6.80519H4.22701L4.61541 5.6095Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3603" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$y(C3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3604)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FCFCFC"
      }),
      createElementVNode("path", {
        d: "M18.7829 10.4344C18.4177 10.4344 17.9655 10.4344 17.2177 10.4344C17.2177 13.316 14.8818 15.6518 12.0004 15.6518C9.1188 15.6518 6.78298 13.316 6.78298 10.4344C6.2786 10.4344 5.72205 10.4344 5.21777 10.4344C5.21777 13.5383 7.30259 16.1552 10.1484 16.9611C9.83637 17.5538 9.8839 18.3 10.3296 18.8562C10.915 18.387 11.521 17.9013 12.0351 17.4894C12.5493 17.9014 13.1553 18.387 13.7407 18.8562C14.1908 18.2945 14.2351 17.5388 13.9127 16.9432C16.7273 16.1175 18.7829 13.5162 18.7829 10.4344Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M7.82617 9.91286C7.82617 9.91286 7.82617 12.5215 10.4349 12.5215L10.9566 13.0433H12.0001C12.0001 13.0433 12.5218 11.4781 13.5653 11.4781C13.5653 11.4781 13.5653 10.4346 14.6088 10.4346C15.6522 10.4346 16.174 10.4346 16.174 10.4346C16.174 10.4346 15.6522 8.34761 18.2609 6.7824L17.2174 6.26068C17.2174 6.26068 13.5653 8.86937 10.9566 8.34765V9.39114H9.91309L9.39138 8.86942L7.82617 9.91286Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3604" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1T(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3605)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.9565 11.9993C10.9565 11.9993 3.52168 20.4863 3.51465 20.4846C5.68618 22.6562 8.68623 23.9993 12 23.9993C18.6273 23.9993 24 18.6267 24 11.9993H10.9565Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51459C-1.17157 8.20087 -1.17157 15.7989 3.51471 20.4852C5.45126 18.5487 7.31375 16.6862 12 11.9999L3.51471 3.51459Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3605" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$x(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3607)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.39165 10.4349H23.8987C23.1317 4.54709 18.0972 0.00012207 12.0003 0.00012207C11.1043 0.00012207 10.2316 0.099169 9.3916 0.285356V10.4349H9.39165Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.26085 10.4357V1.46002C2.96586 3.25787 0.607016 6.55557 0.101562 10.4357H6.26085V10.4357Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.2608 13.5656H0.101562C0.607016 17.4457 2.96586 20.7434 6.26085 22.5412L6.2608 13.5656Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.3916 13.5656V23.7151C10.2316 23.9013 11.1043 24.0003 12.0003 24.0003C18.0972 24.0003 23.1317 19.4534 23.8987 13.5656H9.3916V13.5656Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3607" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1S(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3608)" }, [
      createElementVNode("path", {
        d: "M10.9565 13.044C10.9565 13.044 3.52168 3.51354 3.51465 3.51522C5.68618 1.34364 8.68623 0.000488281 12 0.000488281C18.6273 0.000488281 24 5.37311 24 12.0005L10.9565 13.044Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M10.9565 11.9994C10.9565 11.9994 3.52168 20.4863 3.51465 20.4847C5.68618 22.6562 8.68623 23.9994 12 23.9994C18.6273 23.9994 24 18.6268 24 11.9994H10.9565Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51465C-1.17157 8.20093 -1.17157 15.7989 3.51471 20.4853C5.45126 18.5487 7.31374 16.6862 12 12L3.51471 3.51465Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M4.85597 8.86938L5.63292 11.2608H8.14758L6.1133 12.7388L6.8902 15.1303L4.85597 13.6523L2.82164 15.1303L3.59873 12.7388L1.56445 11.2608H4.07892L4.85597 8.86938Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3608" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$k(i, a3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3609)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M14.3486 23.7693C19.0925 22.8282 22.8294 19.0913 23.7705 14.3474H14.3486V23.7693Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M0.230469 14.3474C1.17148 19.0913 4.90845 22.8282 9.65234 23.7693V14.3474H0.230469Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M23.7705 9.65222C22.8294 4.90838 19.0925 1.17141 14.3486 0.230347V9.65222H23.7705Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M9.65234 0.230469C4.90845 1.17153 1.17148 4.9085 0.230469 9.65234H9.65234V0.230469Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M11.2175 14.3481H9.65234V23.77C10.1631 23.8713 10.6857 23.9399 11.2175 23.9742V14.3481Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.2175 9.6528V0.0267334C10.6857 0.0609522 10.1631 0.129624 9.65234 0.230921V9.6528H11.2175Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.782 0.0265977C12.5232 0.00986328 12.2624 0.000488281 11.9994 0.000488281C11.7364 0.000488281 11.4756 0.00986328 11.2168 0.0265977V9.65271H12.782V0.0265977H12.782Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M11.2168 23.9738C11.4756 23.9906 11.7364 24 11.9994 24C12.2624 24 12.5232 23.9906 12.782 23.9738V14.3478H11.2168V23.9738H11.2168Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M9.65243 11.2178V9.65259H0.230555C0.129211 10.1634 0.0605859 10.6859 0.0263672 11.2178H9.65243Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.3486 11.2183H23.9747C23.9405 10.6864 23.8719 10.1639 23.7706 9.65308H14.3487V11.2183H14.3486Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.3477 12.7832H23.9738C23.9904 12.5244 23.9998 12.2635 23.9998 12.0005C23.9998 11.7375 23.9904 11.4767 23.9737 11.2179H14.3477V12.7832Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M0.0261094 11.2179C0.00942187 11.4767 0 11.7375 0 12.0005C0 12.2635 0.00942187 12.5244 0.0261094 12.7832H9.65222V11.2179H0.0261094V11.2179Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M11.9999 17.7389C15.1695 17.7389 17.739 15.1694 17.739 11.9998C17.739 8.83012 15.1695 6.26062 11.9999 6.26062C8.83024 6.26062 6.26074 8.83012 6.26074 11.9998C6.26074 15.1694 8.83024 17.7389 11.9999 17.7389Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.3075 12.6408C12.8806 11.7871 12.3258 10.9218 12.3258 10.9218C12.3258 10.9218 12.3395 10.5278 12.3395 10.293C12.3395 9.9394 12.0529 9.65271 11.6992 9.65271C11.3642 9.65271 11.0897 9.9101 11.0617 10.2378C10.7983 10.255 10.5898 10.4735 10.5898 10.7413C10.5898 10.936 10.7001 11.1047 10.8616 11.189C10.9418 11.0013 11.099 10.8548 11.2933 10.788C11.325 10.8139 11.359 10.8371 11.3953 10.8567L11.4774 10.896C11.4774 10.896 11.1732 11.7534 11.1732 12.214C11.1732 13.5088 12.027 13.9082 12.027 13.9082V13.9215L11.6001 14.3484H12.4538V13.4946L12.8807 13.9215C12.8845 13.9135 13.6893 13.4044 13.3075 12.6408Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M11.9996 7.30444L12.1938 7.90229H12.8224L12.3139 8.2718L12.5082 8.86964L11.9996 8.50018L11.491 8.86964L11.6853 8.2718L11.1768 7.90229H11.8054L11.9996 7.30444Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M9.24012 8.20183L9.74862 8.57135L10.2572 8.20178L10.063 8.79972L10.5716 9.16914L9.94292 9.16919L9.74867 9.76704L9.55437 9.16919L8.92578 9.16914L9.43433 8.79963L9.24012 8.20183Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M7.53418 10.5491H8.16273L8.35702 9.95129L8.55127 10.5491L9.17991 10.5491L8.67136 10.9187L8.86566 11.5165L8.35702 11.147L7.84848 11.5165L8.04268 10.9186L7.53418 10.5491Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M7.53418 13.4513L8.04268 13.0819L7.84843 12.484L8.35702 12.8535L8.86562 12.484L8.67137 13.0819L9.17996 13.4514L8.55127 13.4514L8.35702 14.0492L8.16273 13.4513H7.53418Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M9.24017 15.7989L9.43437 15.2012L8.92578 14.8317H9.55442L9.74872 14.2338L9.94297 14.8316H10.5716L10.063 15.2012L10.2573 15.799L9.74867 15.4295L9.24017 15.7989Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M11.9996 16.6963L11.8054 16.0986H11.1768L11.6853 15.729L11.491 15.1312L11.9996 15.5006L12.5081 15.1311L12.3139 15.729L12.8224 16.0985L12.1938 16.0986L11.9996 16.6963Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M14.7601 15.7989L14.2516 15.4295L13.7431 15.799L13.9373 15.2012L13.4287 14.8317L14.0574 14.8316L14.2516 14.2338L14.4459 14.8317H15.0745L14.5659 15.2012L14.7601 15.7989Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M16.4661 13.4514H15.8375L15.6433 14.0493L15.449 13.4515H14.8203L15.3289 13.0819L15.1346 12.4841L15.6433 12.8536L16.1518 12.4841L15.9576 13.082L16.4661 13.4514Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M16.4661 10.5491L15.9576 10.9186L16.1518 11.5164L15.6433 11.1469L15.1347 11.5165L15.3289 10.9186L14.8203 10.5491L15.449 10.549L15.6432 9.95129L15.8375 10.5491H16.4661Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M14.7601 8.20178L14.5659 8.79958L15.0745 9.1691H14.4459L14.2516 9.76699L14.0574 9.16915L13.4287 9.16919L13.9373 8.79958L13.7431 8.20183L14.2516 8.57125L14.7601 8.20178Z",
        fill: "#496E2D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3609" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$j(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3610)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0.414062 15.1311C1.52209 19.2422 4.75914 22.4793 8.87027 23.5873V15.1311H0.414062Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M8.86924 0.41333C4.75816 1.52131 1.52107 4.75841 0.413086 8.86949H8.86929V0.41333H8.86924Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.587 8.86973C22.479 4.75865 19.2419 1.52156 15.1309 0.413574V8.86978H23.587V8.86973Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.1309 23.5871C19.2419 22.479 22.479 19.242 23.5871 15.1309H15.1309V23.5871Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M15.131 11.9998C15.131 13.7288 13.7295 15.1303 12.0006 15.1303C10.2717 15.1303 8.87012 13.7288 8.87012 11.9998C8.87012 10.2709 12.0006 8.86938 12.0006 8.86938C12.0006 8.86938 15.131 10.2709 15.131 11.9998Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M8.87012 11.9998C8.87012 10.2709 10.2717 8.86938 12.0006 8.86938C13.7295 8.86938 15.131 10.2709 15.131 11.9998",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M10.2393 10.4344V12.391C10.2393 13.3635 11.0276 14.1518 12.0001 14.1518C12.9726 14.1518 13.761 13.3635 13.761 12.391V10.4344H10.2393Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3610" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1R(C3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3612)" }, [
      createElementVNode("path", {
        d: "M0 12C0 5.37263 5.37262 0 12 0C18.6274 0 24 5.37263 24 12L12 13.0435L0 12Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M1.60547 18.0009C3.68039 21.5876 7.55808 24.0009 11.9997 24.0009C16.4414 24.0009 20.319 21.5876 22.394 18.0009L11.9997 17.2183L1.60547 18.0009Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M22.3942 18.0002C23.4153 16.2352 24 14.1861 24 12.0002H0C0 14.1861 0.584719 16.2352 1.60575 18.0002H22.3942Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0001 16.1744C14.3052 16.1744 16.174 14.3057 16.174 12.0006C16.174 9.69537 14.3052 7.82666 12.0001 7.82666C9.69489 7.82666 7.82617 9.69537 7.82617 12.0006C7.82617 14.3057 9.69489 16.1744 12.0001 16.1744Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0003 14.6092C10.5618 14.6092 9.3916 13.439 9.3916 12.0005V10.4353C9.3916 8.99689 10.5619 7.82666 12.0003 7.82666C13.4387 7.82666 14.609 8.99694 14.609 10.4353V12.0005C14.609 13.439 13.4387 14.6092 12.0003 14.6092Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M16.1741 5.74002H13.0436C13.0436 5.16374 12.5764 4.69653 12.0001 4.69653C11.4238 4.69653 10.9566 5.16374 10.9566 5.74002H7.82617C7.82617 6.31635 8.32816 6.7835 8.90439 6.7835H8.86966C8.86966 7.35983 9.33681 7.82699 9.91314 7.82699C9.91314 8.40332 10.3803 8.87047 10.9566 8.87047H13.0436C13.6199 8.87047 14.0871 8.40332 14.0871 7.82699C14.6634 7.82699 15.1306 7.35983 15.1306 6.7835H15.0958C15.6721 6.7835 16.1741 6.3163 16.1741 5.74002Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3612" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$w(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3613)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000366211C6.84013 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2534C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0003C17.1593 24.0003 21.5578 20.7438 23.2533 16.1742H0.746094C2.44161 20.7438 6.84012 24.0003 11.9997 24.0003Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M16.174 10.6956H13.0436C13.0436 10.1193 12.5764 9.6521 12.0001 9.6521C11.4238 9.6521 10.9566 10.1193 10.9566 10.6956H7.82617C7.82617 11.2719 8.32816 11.7391 8.90444 11.7391H8.86966C8.86966 12.3154 9.33681 12.7826 9.91314 12.7826C9.91314 13.3589 10.3803 13.826 10.9566 13.826H13.0436C13.6199 13.826 14.0871 13.3589 14.0871 12.7826C14.6634 12.7826 15.1306 12.3154 15.1306 11.7391H15.0958C15.6721 11.7391 16.174 11.2719 16.174 10.6956Z",
        fill: "#FF9811"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3613" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1Q(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3752)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000976562C7.24218 -0.000976562 3.13143 2.7677 1.19043 6.78165H22.8089C20.868 2.7677 16.7572 -0.000976562 11.9997 -0.000976562Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9989C16.7572 23.9989 20.868 21.2302 22.809 17.2162H1.19043C3.13143 21.2302 7.24218 23.9989 11.9997 23.9989Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M9.58984 12.5225L11.9997 8.34857L14.4095 12.5225H9.58984Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.13 13.8996L11.9996 15.4649L8.86914 13.8996V11.8127H15.13V13.8996Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M14.9514 8.52728L13.8446 9.63405C14.3167 10.1061 14.6088 10.7583 14.6088 11.4787C14.6088 12.9194 13.4408 14.0874 12.0001 14.0874C10.5594 14.0874 9.39138 12.9194 9.39138 11.4787C9.39138 10.7583 9.68341 10.1061 10.1555 9.63405L9.04872 8.52728C8.29333 9.28253 7.82617 10.326 7.82617 11.4787C7.82617 13.7839 9.69489 15.6526 12.0001 15.6526C14.3052 15.6526 16.174 13.7839 16.174 11.4787C16.1739 10.326 15.7068 9.28253 14.9514 8.52728Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3752" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1P(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3615)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.30486 7.82574H23.2541C21.5586 3.25613 17.16 -0.000366211 12.0005 -0.000366211C8.68673 -0.000366211 5.68706 1.34302 3.51562 3.51474L7.30486 7.82574Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M7.30486 16.1742H23.2541C21.5586 20.7438 17.16 24.0003 12.0005 24.0003C8.68673 24.0003 5.68706 22.6569 3.51562 20.4852L7.30486 16.1742Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.5155C-1.17157 8.20178 -1.17157 15.7998 3.51471 20.4861C5.45126 18.5496 7.31375 16.6871 12 12.0008L3.51471 3.5155Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M14.0869 9.91272V12.5214C14.0869 14.1189 16.1739 14.6084 16.1739 14.6084C16.1739 14.6084 18.2609 14.1189 18.2609 12.5214V9.91272H14.0869Z",
        fill: "#DEDDE0"
      }),
      createElementVNode("path", {
        d: "M16.6958 12.0524H15.6523V13.5654H16.6958V12.0524Z",
        fill: "#786145"
      }),
      createElementVNode("path", {
        d: "M17.2171 11.4788C17.2171 10.9025 16.7499 10.4353 16.1736 10.4353C15.5973 10.4353 15.1301 10.9025 15.1301 11.4788C14.842 11.4788 14.6084 11.7124 14.6084 12.0005C14.6084 12.2887 14.842 12.5222 15.1301 12.5222C15.3012 12.5222 17.046 12.5222 17.2171 12.5222C17.5052 12.5222 17.7388 12.2887 17.7388 12.0005C17.7388 11.7124 17.5053 11.4788 17.2171 11.4788Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3615" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$v(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3616)" }, [
      createElementVNode("path", {
        d: "M10.9565 10.9565C10.9565 10.9565 3.52168 20.487 3.51465 20.4853C5.68618 22.6569 8.68623 24 12 24C18.6273 24 24 18.6274 24 12L10.9565 10.9565Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M10.9565 11.9996C10.9565 11.9996 3.52168 3.51268 3.51465 3.51437C5.68618 1.34279 8.68623 -0.000366211 12 -0.000366211C18.6273 -0.000366211 24 5.37226 24 11.9996H10.9565Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M3.51373 3.5155C-1.17255 8.20178 -1.17255 15.7998 3.51373 20.4861C3.51341 20.4881 23.999 12.0008 23.999 12.0008L3.51373 3.5155Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.26081 7.04321C3.95929 7.04321 2.08691 8.91563 2.08691 11.2171V12.7823C2.08691 15.0838 3.95934 16.9562 6.26081 16.9562C8.56227 16.9562 10.4347 15.0838 10.4347 12.7823V11.2171C10.4347 8.91563 8.56232 7.04321 6.26081 7.04321ZM8.86949 12.7824C8.86949 13.9482 8.10065 14.9377 7.04338 15.2709V13.565L8.15076 12.4576L7.04399 11.3508L7.04338 10.9569V10.4346H5.47823V11.9997L4.3716 13.1063L5.47823 14.2129V15.271C4.42096 14.9378 3.65212 13.9483 3.65212 12.7824V11.2172C3.65212 9.77874 4.8224 8.60851 6.26081 8.60851C7.69921 8.60851 8.86949 9.77879 8.86949 11.2172V12.7824Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3616" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1O(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3617)" }, [
      createElementVNode("path", {
        d: "M0 11.9995C0 13.4673 0.264047 14.8734 0.746391 16.1734L12 16.6951L23.2536 16.1734C23.736 14.8734 24 13.4673 24 11.9995C24 10.5316 23.736 9.12558 23.2536 7.8256L12 7.30383L0.746391 7.82555C0.264047 9.12558 0 10.5316 0 11.9995Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000366211C6.84013 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2534C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.2533 16.1742H0.746094C2.44161 20.7438 6.84012 24.0003 11.9997 24.0003C17.1593 24.0003 21.5578 20.7438 23.2533 16.1742Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3617" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function r$m(h3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 512 512"
  }, [
    createElementVNode("path", {
      style: { fill: "#FFDA44" },
      d: `M486.598,367.304C502.872,333.649,512,295.89,512,256s-9.128-77.649-25.402-111.304L256,133.565\r
	l-230.598,11.13C9.128,178.351,0,216.11,0,256s9.128,77.649,25.402,111.304L256,378.435L486.598,367.304z`
    }),
    createElementVNode("path", { d: "M256,0C154.506,0,66.81,59.065,25.402,144.696h461.195C445.19,59.065,357.493,0,256,0z" }),
    createElementVNode("path", {
      style: { fill: "#0052B4" },
      d: "M256,512c-101.494,0-189.19-59.065-230.598-144.696h461.195C445.19,452.935,357.493,512,256,512z"
    }),
    createElementVNode("path", {
      style: { fill: "#A2001D" },
      d: `M499.911,178.087H12.089C4.247,202.656,0,228.831,0,256s4.247,53.344,12.089,77.913H499.91\r
	C507.753,309.344,512,283.169,512,256S507.753,202.656,499.911,178.087z`
    }),
    createElementVNode("g", null, [
      createElementVNode("rect", {
        x: "89.043",
        y: "244.87",
        style: { fill: "#FFDA44" },
        width: "333.913",
        height: "22.261"
      }),
      createElementVNode("rect", {
        x: "133.565",
        y: "200.348",
        style: { fill: "#FFDA44" },
        width: "244.87",
        height: "22.261"
      })
    ]),
    createElementVNode("path", {
      style: { fill: "#F0F0F0" },
      d: `M380.025,256c0,0-57.243,66.783-124.025,66.783S189.217,256,189.217,256s0-66.783,66.783-66.783\r
	S380.025,256,380.025,256z`
    }),
    createElementVNode("path", { d: "M256,322.783c-66.783,0-124.025-66.783-124.025-66.783S189.217,189.217,256,189.217" }),
    createElementVNode("rect", {
      x: "211.478",
      y: "233.739",
      style: { fill: "#F0F0F0" },
      width: "22.261",
      height: "44.522"
    }),
    createElementVNode("rect", {
      x: "278.261",
      y: "233.739",
      width: "22.261",
      height: "44.522"
    }),
    createElementVNode("g", null, [
      createElementVNode("circle", {
        style: { fill: "#0052B4" },
        cx: "89.043",
        cy: "256",
        r: "22.261"
      }),
      createElementVNode("circle", {
        style: { fill: "#0052B4" },
        cx: "422.957",
        cy: "256",
        r: "22.261"
      })
    ])
  ]);
}
function p$1N(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3618)" }, [
      createElementVNode("path", {
        d: "M0 12C0 13.4679 0.264047 14.874 0.746437 16.174L12 17.2173L23.2536 16.1739C23.736 14.874 24 13.4679 24 12C24 10.5522 23.7435 9.1644 23.2737 7.87942L12 6.78259L0.726281 7.87947C0.256453 9.1644 0 10.5522 0 12Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0003C17.1593 24.0003 21.5578 20.7438 23.2533 16.1742H0.746094C2.44161 20.7438 6.84012 24.0003 11.9997 24.0003Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000366211C6.84013 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2534C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M11.9999 17.7399C15.1695 17.7399 17.739 15.1704 17.739 12.0007C17.739 8.8311 15.1695 6.2616 11.9999 6.2616C8.83024 6.2616 6.26074 8.8311 6.26074 12.0007C6.26074 15.1704 8.83024 17.7399 11.9999 17.7399Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.999 7.5564L13.035 10.7449H16.393L13.6753 12.7156L14.7195 15.9136L11.999 13.9336L9.28269 15.9099L10.3227 12.7156L7.60742 10.7449H10.963L11.999 7.5564Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M16.1308 12.7938L12.8441 11.7258L14.8753 8.93018L14.0312 8.31677L11.9999 11.1126L9.96872 8.31682L9.1245 8.93013L11.1557 11.726L7.86914 12.7938L8.19155 13.7862L11.4782 12.7184V16.1741H12.5217V12.7183L15.8082 13.7862L16.1308 12.7938Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3618" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1M(i, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3619)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 12.0002H11.9999C11.9999 11.9894 11.9999 11.9789 11.9999 11.968C11.9892 11.9788 11.9785 11.9895 11.9678 12.0002Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26074C12 4.14925 12 2.76574 12 -0.00012207H11.998C5.3715 0.00100293 0 5.37311 0 11.9999H6.26086V8.47436L9.78642 11.9999H11.9679C11.9786 11.9892 11.9893 11.9785 12 11.9678C12 11.1593 12 10.438 12 9.78635L8.47443 6.26074H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07027 1.56494C4.19344 2.63364 2.63316 4.19393 1.56445 6.07075V11.9997H4.69491V4.69549V4.69539H11.9993C11.9993 3.70807 11.9993 2.76747 11.9993 1.56494H6.07027Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9989 10.5244L7.73544 6.26099H6.25977V6.26108L11.9988 12.0001H11.9989C11.9989 12.0001 11.9989 10.9826 11.9989 10.5244Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M19.3046 14.0863V14.608H15.1307V14.0863H13.5654V16.1732H14.6089V16.695H19.8263V16.1732H20.8698V14.0863H19.3046Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M13.5654 6.2616V12.0007C13.5654 14.7963 17.2176 15.6529 17.2176 15.6529C17.2176 15.6529 20.8698 14.7963 20.8698 12.0007V6.2616H13.5654Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M17.2174 10.5428C16.3044 10.5428 16.3044 11.3776 15.3914 11.3776C14.4784 11.3776 14.4784 10.5428 13.5654 10.5428V12.0037C14.4784 12.0037 14.4784 12.8385 15.3914 12.8385C16.3044 12.8385 16.3044 12.0037 17.2174 12.0037C18.1304 12.0037 18.1304 12.8385 19.0436 12.8385C19.9567 12.8385 19.9566 12.0037 20.8698 12.0037V10.5428C19.9567 10.5428 19.9567 11.3776 19.0436 11.3776C18.1304 11.3776 18.1304 10.5428 17.2174 10.5428Z",
        fill: "#F3F3F3"
      }),
      createElementVNode("path", {
        d: "M17.2174 7.61804C16.3044 7.61804 16.3044 8.45284 15.3914 8.45284C14.4784 8.45284 14.4784 7.61804 13.5654 7.61804V9.0789C14.4784 9.0789 14.4784 9.9137 15.3914 9.9137C16.3044 9.9137 16.3044 9.0789 17.2174 9.0789C18.1304 9.0789 18.1304 9.9137 19.0436 9.9137C19.9567 9.9137 19.9566 9.0789 20.8698 9.0789V7.61804C19.9567 7.61804 19.9567 8.45284 19.0436 8.45284C18.1304 8.45284 18.1304 7.61804 17.2174 7.61804Z",
        fill: "#F3F3F3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3619" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$u(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3620)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.4781 12L23.898 10.4348C23.8283 9.90131 23.7237 9.37875 23.5865 8.86959H10.9563V0.0456543C10.4238 0.0914981 9.90139 0.172545 9.39111 0.285701L7.30414 1.5652L6.26066 1.45987C5.71151 1.7595 5.18834 2.10075 4.69545 2.47945V8.86954H0.413187C0.275984 9.3787 0.171359 9.90126 0.101609 10.4347L0.521516 12L0.101562 13.5652C0.171312 14.0987 0.275937 14.6213 0.413141 15.1304H4.69541V21.5205C5.1883 21.8993 5.71151 22.2405 6.26061 22.5401L7.82581 22.4347L9.39101 23.7142C9.90134 23.8274 10.4238 23.9084 10.9562 23.9543V15.1305H23.5863C23.7235 14.6213 23.8281 14.0987 23.8979 13.5652L23.4781 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4347H9.39136H9.39131V0.285156C8.28234 0.531062 7.23098 0.929641 6.26086 1.459V10.4347H0.101578C0.034875 10.9471 0 11.4694 0 11.9999C0 12.5304 0.034875 13.0528 0.101578 13.5651H6.26081H6.26086V22.5408C7.23098 23.0701 8.28234 23.4688 9.39131 23.7146V13.5653V13.5652H23.8984C23.9651 13.0528 24 12.5304 24 11.9999C24 11.4694 23.9651 10.9471 23.8984 10.4347Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3620" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1L(e28, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3621)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.0001 5.74023V9.78756L7.82617 5.74023H12.0001Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M6.26098 12.0018H9.78654L6.26098 7.30615L5.73926 10.9583L6.26098 12.0018Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 12.0001H11.9999C11.9999 11.9893 11.9999 11.9787 11.9999 11.9679C11.9892 11.9786 11.9785 11.9894 11.9678 12.0001Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26147C12 4.14999 12 2.76647 12 0.000610352H11.998C5.3715 0.00173535 0 5.37384 0 12.0006H6.26086V8.47509L9.78642 12.0006H11.968C11.9787 11.9899 11.9894 11.9792 12.0001 11.9685C12.0001 11.16 12.0001 10.4387 12.0001 9.78708L8.47443 6.26147H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.5658C4.19441 2.6345 2.63413 4.19478 1.56543 6.07161V12.0006H4.69588V4.69635V4.69625H12.0002C12.0002 3.70892 12.0002 2.76833 12.0002 1.5658H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9998 10.5249L7.73641 6.26147H6.26074V6.26157L11.9997 12.0006H11.9998C11.9998 12.0006 11.9998 10.983 11.9998 10.5249Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.5654 7.82718V12.001C13.5654 14.7966 17.2176 15.6532 17.2176 15.6532C17.2176 15.6532 20.8698 14.7966 20.8698 12.001V7.82718L17.2176 6.78369L13.5654 7.82718Z",
        fill: "#F3F3F3"
      }),
      createElementVNode("path", {
        d: "M20.8698 7.82631V6.26111H13.5654V7.82631H16.6958V10.9568H13.5654V12.0002C13.5654 12.0002 13.5654 12.0003 13.5654 12.0003L16.6958 12.0003V15.4924C17.0107 15.6038 17.2176 15.6524 17.2176 15.6524C17.2176 15.6524 17.4244 15.6039 17.7393 15.4924V12.0003H20.8698V12.0002V10.9568H17.7393V7.82626H20.8698V7.82631Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3621" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function r$l(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3622)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4347H9.39136H9.39131V0.285156C8.28234 0.531062 7.23098 0.929641 6.26086 1.459V10.4346V10.4347H0.101578C0.0347813 10.9471 0 11.4694 0 11.9999C0 12.5304 0.0347813 13.0528 0.101578 13.5651H6.26081H6.26086V22.5408C7.23098 23.0701 8.28234 23.4688 9.39131 23.7146V13.5653V13.5652H23.8984C23.9651 13.0528 24 12.5304 24 11.9999C24 11.4694 23.9651 10.9471 23.8984 10.4347Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3622" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1K(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3623)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9999 11.9999C23.9999 6.84037 20.7434 2.44185 16.1738 0.746338V23.2536C20.7434 21.558 23.9999 17.1595 23.9999 11.9999Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 12.0008C0 17.1604 3.25655 21.5589 7.82611 23.2544V0.747192C3.25655 2.44271 0 6.84122 0 12.0008Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3623" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$s(c3, o3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      d: "M2 32c0 16.6 13.4 30 30 30c11.7 0 21.9-6.8 26.8-16.6L5.2 18.6C3.1 22.6 2 27.2 2 32z",
      fill: "#ffce31"
    }),
    createElementVNode("path", {
      d: "M32 2C20.3 2 10.1 8.8 5.2 18.6l53.7 26.8c2-4 3.2-8.6 3.2-13.4C62 15.4 48.6 2 32 2z",
      fill: "#699635"
    }),
    createElementVNode("path", {
      fill: "#da121a",
      d: "M32 17.9L35.3 28h10.6l-8.6 6.3l3.3 10.1l-8.6-6.2l-8.6 6.2l3.3-10.1l-8.6-6.3h10.6z"
    })
  ]);
}
function a$r(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3624)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.45898 6.26159H22.5408C20.5056 2.53147 16.5484 0.000732422 11.9999 0.000732422C7.45139 0.000732422 3.49425 2.53147 1.45898 6.26159Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9999 23.9999C16.5484 23.9999 20.5056 21.4691 22.5408 17.739H1.45898C3.49425 21.4691 7.45139 23.9999 11.9999 23.9999Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.174 11.9997C16.174 14.3049 14.3052 15.6519 12.0001 15.6519C9.69489 15.6519 7.82617 14.3049 7.82617 11.9997C7.82617 9.69448 9.69489 7.82581 12.0001 7.82581C14.3052 7.82581 16.174 9.69448 16.174 11.9997Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M16.174 11.9998C16.174 14.305 14.3052 16.1737 12.0001 16.1737C9.69489 16.1737 7.82617 14.305 7.82617 11.9998",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M10.4351 10.9559H9.3916V13.0429H10.4351V10.9559Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.6089 10.9559H13.5654V13.0429H14.6089V10.9559Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.522 9.39087H11.4785V13.043H12.522V9.39087Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3624" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1J(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3625)" }, [
      createElementVNode("path", {
        d: "M23.2536 16.175C23.736 14.875 24 13.4689 24 12.0011C24 10.5332 23.736 9.12721 23.2536 7.82718L12 6.78369L0.746391 7.82718C0.264047 9.12721 0 10.5332 0 12.0011C0 13.4689 0.264047 14.875 0.746391 16.175L12 17.2184L23.2536 16.175Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0007 23.9997C17.1603 23.9997 21.5588 20.7432 23.2543 16.1736H0.74707C2.44263 20.7432 6.8411 23.9997 12.0007 23.9997Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0007 0.000732422C6.8411 0.000732422 2.44263 3.25723 0.74707 7.82684H23.2543C21.5588 3.25723 17.1603 0.000732422 12.0007 0.000732422Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3625" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1I(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3726)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0003 0.000793457C7.03927 0.000793457 2.78171 3.01139 0.954102 7.30514H23.0465C21.2189 3.01139 16.9613 0.000793457 12.0003 0.000793457Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M12.0003 24.0007C16.9613 24.0007 21.2189 20.9901 23.0465 16.6964H0.954102C2.78171 20.9901 7.03927 24.0007 12.0003 24.0007Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M23.5866 8.86963H0.413391C0.144375 9.86774 0 10.9169 0 12.0001C0 13.0832 0.144375 14.1324 0.413391 15.1305H23.5867C23.8556 14.1324 24 13.0832 24 12.0001C24 10.9169 23.8556 9.86774 23.5866 8.86963Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3726" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$r(t3, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3727)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4695 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4695 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.30428 5.73981V4.17456H5.73908V5.73981H4.17383V7.30501H5.73908V8.87022H7.30428V7.30501H8.86948V5.73981H7.30428Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.2613 5.73981V4.17456H16.6961V5.73981H15.1309V7.30501H16.6961V8.87022H18.2613V7.30501H19.8265V5.73981H18.2613Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.30428 16.6967V15.1315H5.73908V16.6967H4.17383V18.2619H5.73908V19.8271H7.30428V18.2619H8.86948V16.6967H7.30428Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.2613 16.6967V15.1315H16.6961V16.6967H15.1309V18.2619H16.6961V19.8271H18.2613V18.2619H19.8265V16.6967H18.2613Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3727" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1H(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3728)" }, [
      createElementVNode("path", {
        d: "M0.746094 16.1749C2.44161 20.7445 6.84012 24.001 11.9997 24.001C17.1593 24.001 21.5578 20.7445 23.2533 16.1749L11.9997 15.1315L0.746094 16.1749Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9997 0.000793457C6.84012 0.000793457 2.44161 3.25729 0.746094 7.8269L11.9997 8.87034L23.2533 7.82686C21.5578 3.25729 17.1593 0.000793457 11.9997 0.000793457Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M0.746391 7.82574C0.264047 9.12573 0 10.5318 0 11.9996C0 13.4675 0.264047 14.8735 0.746391 16.1735H23.2537C23.736 14.8735 24 13.4675 24 11.9996C24 10.5318 23.736 9.12573 23.2536 7.82574H0.746391Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3728" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1G(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3626)" }, [
      createElementVNode("path", {
        d: "M0 11.9991C0 13.467 0.264047 14.873 0.746391 16.173L12 16.6948L23.2536 16.1731C23.736 14.873 24 13.467 24 11.9991C24 10.5313 23.736 9.12522 23.2536 7.82523L12 7.30347L0.746391 7.82519C0.264047 9.12522 0 10.5313 0 11.9991Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000976562C6.84012 -0.000976562 2.44161 3.25552 0.746094 7.82513H23.2534C21.5578 3.25552 17.1593 -0.000976562 11.9997 -0.000976562Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.2533 16.1741H0.746094C2.44161 20.7436 6.84013 24.0002 11.9997 24.0002C17.1593 24.0002 21.5578 20.7436 23.2533 16.1741Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M12 7.82629L13.0359 11.0147H16.3888L13.6764 12.9855L14.7124 16.1741L12 14.2035L9.28753 16.1741L10.3237 12.9855L7.61133 11.0147H10.964L12 7.82629Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3626" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$q(t3, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3627)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F9F9F9"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0007C17.1593 24.0007 21.5578 20.7442 23.2533 16.1746H0.746094C2.44166 20.7442 6.84012 24.0007 11.9997 24.0007Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.6955 9.91359V8.34839H17.2173V7.30491H16.1738V7.82667H15.1303V7.30491H14.0869V8.34839H14.6086V9.91359H13.5651V6.26152H14.0869V5.21808H13.0434V5.7397H12.5216V5.21808H11.4782V5.7397H10.9564V5.21808H9.91292V6.26152H10.4347V9.91359H9.3912V8.34839H9.91292V7.30491H8.86943V7.82667H7.82599V7.30491H6.78251V8.34839H7.30423V9.91359H6.26074V14.0875H17.739V9.91359H16.6955Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 13.5651C11.1356 13.5651 10.4348 14.2659 10.4348 15.1303C10.4348 15.8117 10.8705 16.3913 11.4783 16.6061V18.7826H9.91309V20.8695H12.5218V16.6062C13.1296 16.3913 13.5653 15.8118 13.5653 15.1304C13.5652 14.266 12.8644 13.5651 12 13.5651ZM12 15.6521C11.7119 15.6521 11.4783 15.4185 11.4783 15.1304C11.4783 14.8422 11.7119 14.6087 12 14.6087C12.2881 14.6087 12.5217 14.8422 12.5217 15.1304C12.5217 15.4185 12.2881 15.6521 12 15.6521Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3627" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$i(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3628)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 8.87002H23.5866C23.2857 7.75373 22.8284 6.70181 22.2387 5.73956H12V8.87002Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M4.53058 21.3914H19.4702C20.5654 20.5191 21.5046 19.4597 22.2391 18.2609H1.76172C2.4963 19.4596 3.43548 20.5191 4.53058 21.3914Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M4.17433 2.90375C3.23092 3.71614 2.41534 4.67281 1.76172 5.7395H4.17433V2.90375Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12 12C12 10.7776 12 9.75469 12 8.86951H7.30434V12H4.17389V8.86951H0.413391C0.144375 9.86766 0 10.9168 0 12C0 13.0831 0.144375 14.1323 0.413391 15.1304H23.5867C23.8556 14.1323 24 13.0831 24 12H12Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.0003 0.000671387C10.334 0.000671387 8.74703 0.340656 7.30469 0.954484V5.73981H12.0003C12.0003 4.64706 12.0003 3.71767 12.0003 2.60936H19.4702C17.4203 0.976796 14.8245 0.000671387 12.0003 0.000671387Z",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3628" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1F(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3629)" }, [
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M24 12.0004C24 18.6278 18.6274 24.0004 12 24.0004C5.37262 24.0004 0 18.6278 0 12.0004",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M8.34754 17.7397C11.5172 17.7397 14.0867 15.1702 14.0867 12.0006C14.0867 8.83091 11.5172 6.26141 8.34754 6.26141C5.1779 6.26141 2.6084 8.83091 2.6084 12.0006C2.6084 15.1702 5.1779 17.7397 8.34754 17.7397Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M2.6084 12.0006C2.6084 8.83101 5.1779 6.26141 8.34754 6.26141C11.5172 6.26141 14.0867 8.83096 14.0867 12.0006",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3629" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1E(i, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3630)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.23633 2.08691C7.16219 0.770377 9.49084 -6.10352e-05 11.9998 -6.10352e-05C14.5087 -6.10352e-05 16.8374 0.770377 18.7632 2.08691L11.9998 2.60863L5.23633 2.08691Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M12.0004 11.9995L11.2346 11.2336L11.0312 11.5979L12.0004 11.9995Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51514C-1.17157 8.20142 -1.17157 15.7994 3.51471 20.4858C5.45126 18.5492 7.31375 16.6867 12 12.0004L3.51471 3.51514Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M20.4853 3.51587C25.1716 8.20215 25.1716 15.8002 20.4853 20.4865C18.5488 18.5499 16.6863 16.6875 12 12.0012L20.4853 3.51587Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M12.0001 16.1741C14.3052 16.1741 16.174 14.3054 16.174 12.0002C16.174 9.69501 14.3052 7.82629 12.0001 7.82629C9.69489 7.82629 7.82617 9.69501 7.82617 12.0002C7.82617 14.3054 9.69489 16.1741 12.0001 16.1741Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M11.9996 7.82642L12.9352 10.7059H15.9633L13.5137 12.4859L14.4492 15.3655L11.9996 13.5859L9.54996 15.3655L10.4857 12.4859L8.03613 10.7059H11.064L11.9996 7.82642Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0043 -6.10352e-05H11.9963C8.68444 0.00101709 5.68627 1.34366 3.51562 3.51406H20.485C18.3143 1.34366 15.3161 0.00101709 12.0043 -6.10352e-05Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M3.51562 20.4857C5.68716 22.6569 8.68688 23.9998 12.0002 23.9998C15.3136 23.9998 18.3133 22.6569 20.4848 20.4857H3.51562Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M12.0006 1.3042L12.1949 1.90204H12.8235L12.315 2.27156L12.5093 2.8694L12.0006 2.49993L11.4921 2.8694L11.6864 2.27156L11.1777 1.90204H11.8063L12.0006 1.3042Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.09047 1.3042L9.28477 1.90204H9.91336L9.40481 2.27156L9.59911 2.8694L9.09047 2.49993L8.58197 2.8694L8.77622 2.27156L8.26758 1.90204H8.89617L9.09047 1.3042Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.9098 1.3042L15.1041 1.90204H15.7327L15.2241 2.27156L15.4184 2.8694L14.9098 2.49993L14.4013 2.8694L14.5956 2.27156L14.0869 1.90204H14.7155L14.9098 1.3042Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0006 21.1298L12.1949 21.7276H12.8235L12.315 22.0971L12.5093 22.695L12.0006 22.3254L11.4921 22.695L11.6864 22.0971L11.1777 21.7276H11.8063L12.0006 21.1298Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.09047 21.1298L9.28477 21.7276H9.91336L9.40481 22.0971L9.59911 22.695L9.09047 22.3254L8.58197 22.695L8.77622 22.0971L8.26758 21.7276H8.89617L9.09047 21.1298Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.9098 21.1298L15.1041 21.7276H15.7327L15.2241 22.0971L15.4184 22.695L14.9098 22.3254L14.4013 22.695L14.5956 22.0971L14.0869 21.7276H14.7155L14.9098 21.1298Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.65664 11.8019C3.96484 12.2889 3.82 12.9335 3.33301 13.2417C2.84607 13.55 2.20145 13.4051 1.8932 12.9182C1.33515 12.0365 1.65873 10.5967 1.65873 10.5967C1.65873 10.5967 3.09854 10.9203 3.65664 11.8019Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.05395 13.3225C3.34209 13.3225 3.57567 13.0889 3.57567 12.8008C3.57567 12.5126 3.34209 12.2791 3.05395 12.2791C2.76581 12.2791 2.53223 12.5126 2.53223 12.8008C2.53223 13.0889 2.76581 13.3225 3.05395 13.3225Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3630" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1D(t3, a3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      d: "M2 32c0 16.6 13.4 30 30 30s30-13.4 30-30c0-3.5-.6-6.9-1.7-10H3.7C2.6 25.1 2 28.5 2 32z",
      fill: "#3e4347"
    }),
    createElementVNode("path", {
      d: "M32 2C18.9 2 7.8 10.4 3.7 22h56.6C56.2 10.4 45.1 2 32 2z",
      fill: "#2a5f9e"
    }),
    createElementVNode("g", { fill: "#ffce31" }, [
      createElementVNode("path", { d: "M30.9 5.2c-1 1.6-1.1 2.9-.4 5c.3 1 .7 2.5.8 3.4c.2 1.2.2 1.3.2 1.5h1.1c0-.4.1-.9.2-1.5c.1-.7.4-2.3.7-3.4c.6-2.2.5-3.5-.5-5c-.4-.6-.9-1-1.1-1c-.2 0-.7.4-1 1m4.7 4.4c-1.4.6-2.2 2.2-2.6 4.4c-.1.4-.1.6-.1 1h.7c.1-.3.1-.5.2-.9c.5-1.7 2.2-2.4 2.1-.8c0 .4-.2.7-.4.9c.3-.1.8-.3 1.3-.6c2.4-1.4 1.4-5.1-1.2-4m-5.5 6.1H34v-.3h-3.9v.3m.3 1.3c-.4.4-1 .7-1 .7s.5.1 1.1 0s.8-.1 1.1-.2c-.1.6-.1 1.2-.1 1.2c.1.8.2 1 .3 1.4c.2.3.4.3.5 0c.2-.4.3-.8.3-1.4c0-.4 0-.6-.1-1.2c.4.2.6.2 1.1.2h1s-.7-.4-1-.8c-.3-.4-.2-.4-.5-.9H31c-.3.5-.3.6-.6 1m-2-7.4c1.4.6 2.2 2.2 2.6 4.4c.1.4.1.6.1 1h-.7c-.1-.3-.1-.5-.2-.9c-.5-1.7-2.2-2.4-2.1-.8c0 .4.2.7.4.9c-.3-.1-.8-.3-1.3-.6c-2.4-1.4-1.4-5.1 1.2-4" }),
      createElementVNode("path", { d: "M13.6 13.6c.2 1.2.2 1.3.2 1.5h1.1c0-.4.1-.9.2-1.5c.1-.7.4-2.3.7-3.4c.4-1.5.5-2.5.3-3.5c-1.2.8-2.4 1.6-3.5 2.6c.1.3.1.6.3 1c.2.9.5 2.5.7 3.3" }),
      createElementVNode("path", { d: "M16.2 15.7v-.3h-3.9v.3h3.9" }),
      createElementVNode("path", { d: "M9.6 13.7c.4.3 1 .5 1.3.6c-.2-.2-.4-.5-.4-.9c-.1-1.6 1.5-.9 2.1.8c.1.4.2.6.2.9h.7c0-.5-.1-.6-.1-1c-.4-1.8-.9-3.1-1.8-3.9c-1 .9-1.9 1.9-2.7 2.9c.1.2.3.4.7.6" }),
      createElementVNode("path", { d: "M15.9 17c-.3-.4-.2-.4-.5-.9h-2.1c-.2.5-.3.6-.6 1c-.4.4-1 .7-1 .7s.5.1 1.1 0s.8-.1 1.1-.2c-.1.6-.1 1.2-.1 1.2c.1.8.2 1 .3 1.4c.2.3.4.3.5 0c.2-.4.3-.8.3-1.4c0-.4 0-.6-.1-1.2c.4.2.6.2 1.1.2h1s-.7-.4-1-.8" }),
      createElementVNode("path", { d: "M17.9 9.6c-1.4.6-2.2 2.2-2.6 4.4c-.1.4-.1.6-.1 1h.7c.1-.3.1-.5.2-.9c.5-1.7 2.2-2.4 2.1-.8c0 .4-.2.7-.4.9c.3-.1.8-.3 1.3-.6c2.4-1.4 1.4-5.1-1.2-4" }),
      createElementVNode("path", { d: "M48.2 15.1h.7c0-.5-.1-.6-.1-1c-.4-2.2-1.3-3.8-2.6-4.4c-2.6-1.1-3.6 2.6-1.1 4.1c.4.3 1 .5 1.3.6c-.2-.2-.4-.5-.4-.9c-.1-1.6 1.5-.9 2.1.8c0 .3 0 .5.1.8" }),
      createElementVNode("path", { d: "M48.2 10.2c.3 1 .7 2.5.8 3.4c.2 1.2.2 1.3.2 1.5h1c0-.4.1-.9.2-1.5c.1-.7.4-2.3.7-3.4c.1-.4.2-.7.3-1.1c-1.1-.9-2.2-1.8-3.4-2.5c-.3 1-.3 2.1.2 3.6" }),
      createElementVNode("path", { d: "M51.3 17c-.3-.4-.2-.4-.5-.9h-2.1c-.2.5-.3.6-.6 1c-.4.4-1 .7-1 .7s.5.1 1.1 0s.8-.1 1.1-.2c-.1.6-.1 1.2-.1 1.2c.1.8.2 1 .3 1.4c.2.3.4.3.5 0c.2-.4.3-.8.3-1.4c0-.4 0-.6-.1-1.2c.4.2.6.2 1.1.2h1s-.7-.4-1-.8" }),
      createElementVNode("path", { d: "M47.8 15.7h3.9v-.3h-3.9v.3" }),
      createElementVNode("path", { d: "M50.7 14.1c-.1.4-.1.6-.1 1h.7c.1-.3.1-.5.2-.9c.5-1.7 2.2-2.4 2.1-.8c0 .4-.2.7-.4.9c.3-.1.8-.3 1.3-.6c.3-.2.6-.4.8-.7c-.8-1-1.7-2-2.7-2.9c-.9.9-1.5 2.2-1.9 4" })
    ]),
    createElementVNode("g", { fill: "#83bf4f" }, [
      createElementVNode("path", { d: "M53.8 50.8l-.2.7l-15.8-6.9l.2-.6z" }),
      createElementVNode("path", { d: "M54.3 49.1l-.2.7L38 43.9l.2-.7z" }),
      createElementVNode("path", { d: "M54.7 47.7l-.1.6l-16.4-5.2l.2-.6z" }),
      createElementVNode("path", { d: "M38.47 42.113l.195-.672l16.421 4.769l-.195.672z" }),
      createElementVNode("path", { d: "M55.6 44.6l-.2.7l-16.6-4.1l.2-.7z" }),
      createElementVNode("path", { d: "M14.3 28.1l.4-.5l12.5 12l-.4.5z" }),
      createElementVNode("path", { d: "M12 28.7l.4-.5l13 11.2l-.4.5z" }),
      createElementVNode("path", { d: "M9.6 28.2l.4-.6l13.5 10.6l-.4.6z" }),
      createElementVNode("path", { d: "M9.158 29.737l.419-.561L23.28 39.403l-.42.561z" }),
      createElementVNode("path", { d: "M6.4 29.5l.4-.5l14.1 9.7l-.4.5z" }),
      createElementVNode("path", { d: "M6.3 32.3v-.6l16.9 3.8l-.1.6z" }),
      createElementVNode("path", { d: "M4.9 33.6v-.7l17 2.9l-.1.6z" }),
      createElementVNode("path", { d: "M7 35.4l.1-.7l17 2l-.1.7z" }),
      createElementVNode("path", { d: "M4.915 36.483l.066-.697l17.023 1.612l-.066.697z" }),
      createElementVNode("path", { d: "M7.8 38.7l.1-.7l17.1.9l-.1.7z" })
    ]),
    createElementVNode("path", {
      d: "M33.3 50.6l.7.5c1 .7 1.5 1.6 1.4 2.6v.8l.3-.8c.3-.8.3-2.1-.1-3l-.2-.5l.8.3c1.1.5 1.8 1.3 1.9 2.2l.1.8l.1-.8c.2-.9-.1-2.1-.7-2.9l-.3-.5l.8.2c1.2.2 2 .9 2.4 1.8l.3.7v-.8c0-.9-.6-2-1.3-2.7l-.4-.4h.8c1.2 0 2.2.4 2.7 1.2l.4.7l-.2-.8c-.2-.9-1-1.8-1.8-2.4l-.5-.3l.8-.2c1.1-.3 2.2 0 2.9.6l.6.6l-.4-.8c-.4-.8-1.3-1.6-2.3-1.9l-.6-.2l.8-.3c1.1-.5 2.1-.5 3 0l.7.4l-.5-.7c-.5-.7-1.6-1.3-2.6-1.4H42l.7-.5c.9-.7 2-.9 2.9-.6l.7.3l-.6-.5c-.7-.6-1.9-.9-2.9-.8l-.6.1l.5-.6c.8-.9 1.8-1.3 2.7-1.2l.8.1l-.7-.4c-.8-.4-2-.5-3-.2l-.6.2l.4-.7c.6-1 1.4-1.7 2.4-1.7h.8l-.8-.2c-.9-.3-2.1-.1-3 .4l-.5.3l.2-.8c.3-1.1 1.1-1.9 2-2.2l.8-.2l-.8-.1c-.9-.1-2.1.4-2.8 1l-.4.4l.1-.8c.1-1.2.6-2.1 1.5-2.5l.7-.4h-.8c-.9.1-1.9.8-2.5 1.6l-.3.5l-.1-.8c-.1-1.2.2-2.2.9-2.8l.6-.5l-.8.3c-.8.3-1.7 1.2-2.1 2.1l-.2.5l-.3-.8c-.4-1.1-.3-2.2.3-2.9l.5-.6l-.8.4c-.8.5-1.5 1.5-1.7 2.5v.5l-.4-.7c-.6-1-.7-2.1-.3-2.9l.4-.7l-.6.6c-.7.6-1.1 1.8-1.1 2.8v.6l-.7-.7c-.8-.9-1.1-1.9-.9-2.8l.2-.8l-.5.7c-.5.7-.7 2-.5 2.9l.1.6l-.7-.5c-1-.7-1.5-1.6-1.4-2.6v-.8l-.3.8c-.3.8-.3 2.1.1 3l.2.5l-.8-.3c-1.1-.5-1.8-1.3-1.9-2.2l-.1-.8v.9c-.2.9.1 2.1.7 2.9l.3.5l-.8-.2c-1.2-.2-2-.9-2.4-1.8l-.3-.7v.8c0 .9.6 2 1.3 2.7l.4.4h-.8c-1.2 0-2.2-.4-2.7-1.2l-.4-.7l.2.8c.2.9 1 1.8 1.8 2.4l.5.3l-.7.2c-1.1.3-2.2 0-2.9-.6l-.6-.6l.4.8c.4.8 1.3 1.6 2.3 1.9l.6.2l-.7.3c-1.1.5-2.1.5-3 0l-.7-.4l.5.7c.5.7 1.6 1.3 2.6 1.4l.6.1l-.7.5c-.9.7-2 .9-2.9.6l-.6-.5l.6.5c.7.6 1.9.9 2.9.8l.6-.1l-.5.6c-.8.9-1.8 1.3-2.7 1.2H18l.7.4c.8.4 2 .5 3 .2l.6-.2l-.4.7c-.6 1-1.4 1.7-2.4 1.7h-.8l.8.2c.9.3 2.1.1 3-.4l.5-.3l-.2.8c-.3 1.1-1.1 1.9-2 2.2l-.8.3l.8.1c.9.1 2.1-.4 2.8-1l.4-.4v.7c-.1 1.2-.6 2.1-1.5 2.5l-.7.4l.8-.1c.9-.1 1.9-.8 2.5-1.6l.3-.5l.1.8c.1 1.2-.2 2.2-.9 2.8l-.6.6l.8-.3c.8-.3 1.7-1.2 2.1-2.1l.2-.5l.3.8c.4 1.1.3 2.2-.3 2.9l-.5.6l.7-.5c.8-.5 1.5-1.5 1.7-2.5l.1-.6l.4.7c.6 1 .7 2.1.3 2.9l-.4.7l.6-.4c.7-.6 1.1-1.8 1.1-2.8v-.6l.6.6c.8.9 1.1 1.9.9 2.8l-.2.8l.5-.7c.5-.7.7-2 .5-2.9l-.1-.6",
      fill: "#ffce31"
    })
  ]);
}
function p$1C(e28, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3631)" }, [
      createElementVNode("path", {
        d: "M5.23633 21.9123C7.16214 23.2288 9.49089 23.9992 11.9998 23.9992C14.5087 23.9992 16.8374 23.2288 18.7632 21.9123L11.9998 20.8688L5.23633 21.9123Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.7642 2.08685C16.8383 0.770362 14.5096 -0.00012207 12.0008 -0.00012207C9.49187 -0.00012207 7.16312 0.770362 5.2373 2.08685L12.0008 3.13033L18.7642 2.08685Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M24 12.0004C24 8.02965 21.6227 4.042 18.7635 2.0874H5.23655C2.07516 4.24853 0 7.882 0 12.0004C0 16.119 2.07516 19.7523 5.23655 21.9135H18.7635C21.9249 19.7523 24 16.119 24 12.0004Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.3213 19.5748C11.1573 19.4342 7.30469 16.0851 7.30469 12C7.30469 7.91486 11.1573 4.56569 11.3213 4.42511L12.0003 3.84302L12.6794 4.42506C12.8434 4.56569 16.696 7.91481 16.696 12C16.696 16.0851 12.8434 19.4343 12.6794 19.5748L12.0003 20.1569L11.3213 19.5748Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.652 12C15.652 8.34786 11.9998 5.21741 11.9998 5.21741C11.9998 5.21741 8.34766 8.34795 8.34766 12C8.34766 13.1173 8.6897 14.1855 9.16417 15.1305H14.8355C15.31 14.1855 15.652 13.1173 15.652 12Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M15.652 12.0005C15.652 13.1178 15.31 14.186 14.8355 15.1309L11.9998 15.6527L9.16417 15.1309C8.6897 14.186 8.34766 13.1178 8.34766 12.0005H15.652Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9997 18.7824C11.9997 18.7824 13.7588 17.2741 14.8354 15.1302H9.16406C10.2406 17.2741 11.9997 18.7824 11.9997 18.7824Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.65137 9.9126H14.347L11.9992 12.2604L9.65137 9.9126Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.783 11.4773H11.2178V16.173H12.783V11.4773Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3631" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function L$8(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3632)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9994 12.0002C23.9994 7.24267 21.2307 3.13192 17.2168 1.19092V22.8094C21.2307 20.8685 23.9994 16.7577 23.9994 12.0002Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M0 12.0001C0 16.7576 2.76867 20.8684 6.78262 22.8094V1.1908C2.76867 3.1318 0 7.24255 0 12.0001Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M15.135 14.0284L13.106 11.9994L15.0374 10.0679L14.9499 9.04778L14.3969 8.49475L11.9992 10.8925L9.60142 8.49475L9.04848 9.04778L8.96097 10.0679L10.8924 11.9994L8.86328 14.0284L9.97009 15.1351L11.9992 13.1061L14.0282 15.1351L15.135 14.0284Z",
        fill: "#ACABB1"
      }),
      createElementVNode("path", {
        d: "M14.9515 9.04895L13.8447 10.1557C14.3168 10.6278 14.6088 11.28 14.6088 12.0003C14.6088 13.4411 13.4408 14.609 12.0001 14.609C10.5594 14.609 9.39138 13.4411 9.39138 12.0003C9.39138 11.28 9.68341 10.6278 10.1555 10.1557L9.04872 9.04895C8.29333 9.8042 7.82617 10.8477 7.82617 12.0003C7.82617 14.3056 9.69489 16.1742 12.0001 16.1742C14.3052 16.1742 16.174 14.3055 16.174 12.0003C16.174 10.8477 15.7068 9.80425 14.9515 9.04895Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3632" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1B(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3633)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4695 0 10.9471 0.034875 10.4348 0.101578V10.4348H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5305 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4695 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5305 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.3914 12.5219L16.174 13.0437V10.9567L15.3914 11.4785H12.5218V8.60887L13.0435 7.82629H10.9566L11.4783 8.60887V11.4785H8.60875L7.82617 10.9567V13.0437L8.60875 12.5219H11.4783V15.3915L10.9566 16.1741H13.0435L12.5218 15.3915V12.5219H15.3914Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3633" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function r$k(c3, n3) {
  return openBlock(), createElementBlock("svg", {
    height: "24",
    width: "24",
    viewBox: "0 0 512 512"
  }, [
    createElementVNode("path", {
      style: { fill: "#FFDA44" },
      d: `M256,0c-23.106,0-45.49,3.08-66.783,8.819L166.957,256l22.261,247.181\r
	C210.51,508.92,232.894,512,256,512c141.384,0,256-114.616,256-256S397.384,0,256,0z`
    }),
    createElementVNode("path", {
      style: { fill: "#6DA544" },
      d: `M166.957,256l22.261,247.181C210.51,508.92,232.894,512,256,512c141.384,0,256-114.616,256-256\r
	H166.957z`
    }),
    createElementVNode("g", null, [
      createElementVNode("path", {
        style: { fill: "#D80027" },
        d: "M0,256c0,97.035,53.99,181.455,133.565,224.873V31.127C53.99,74.545,0,158.965,0,256z"
      }),
      createElementVNode("path", {
        style: { fill: "#D80027" },
        d: "M0,256c0,118.279,80.221,217.805,189.217,247.181V8.819C80.221,38.195,0,137.721,0,256z"
      })
    ]),
    createElementVNode("polygon", { points: `96.736,189.217 113.311,240.233 166.957,240.233 123.559,271.765 140.133,322.783 96.736,291.252 53.337,322.783 \r
	69.915,271.765 26.517,240.233 80.16,240.233 ` })
  ]);
}
function p$1A(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3635)" }, [
      createElementVNode("path", {
        d: "M16.1743 0.746315C14.8742 0.263925 13.4681 -0.00012207 12.0002 -0.00012207C10.5325 -0.00012207 9.12639 0.263925 7.82645 0.746222L7.30469 11.9999L7.82641 23.2535C9.12639 23.7359 10.5325 23.9999 12.0002 23.9999C13.4682 23.9999 14.8742 23.7359 16.1743 23.2534L16.696 11.9999L16.1743 0.746315Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M0 12.0004C0 17.1599 3.2565 21.5585 7.82611 23.2539V0.746704C3.2565 2.44227 0 6.84073 0 12.0004Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.9999 12.0004C23.9999 6.84073 20.7434 2.44227 16.1738 0.746704V23.254C20.7434 21.5585 23.9999 17.1599 23.9999 12.0004Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3635" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1z(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3636)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000976562C9.87813 -0.000976562 7.88556 0.550367 6.15625 1.51646V22.4816C7.88561 23.4477 9.87813 23.999 11.9997 23.999C18.6271 23.999 23.9997 18.6264 23.9997 11.999C23.9997 5.37165 18.6271 -0.000976562 11.9997 -0.000976562Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M6.19178 1.49817C5.43686 1.91653 4.73195 2.41378 4.08794 2.97909C4.15305 2.922 4.21881 2.86556 4.28509 2.80987L13.4756 12.0005L4.28505 21.1911C4.21872 21.1354 4.153 21.0789 4.08789 21.0218C4.73191 21.5872 5.43686 22.0844 6.19173 22.5028L24 12.0005L6.19178 1.49817Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.17837 2.12695C4.81241 2.38036 4.46095 2.65303 4.12602 2.94445L12.0001 11.9997L4.12598 21.0549C4.4609 21.3463 4.81237 21.619 5.17832 21.8724L21.9459 11.9997L5.17837 2.12695Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M4.28504 2.80981C4.01827 3.03397 3.76084 3.26896 3.51465 3.5151L10.9565 12.0004L3.51465 20.4857C3.76084 20.7319 4.01823 20.9669 4.28504 21.191L13.4756 12.0004L4.28504 2.80981Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51428C-1.17157 8.20056 -1.17157 15.7986 3.51471 20.4849C5.45126 18.5484 7.31375 16.6859 12 11.9996L3.51471 3.51428Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3636" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$q(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3637)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 5.37262 12 0 12 0C12 0 24 5.37262 24 12Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M16.174 15.1305L12.0001 14.6088L7.82617 15.1305V8.86963H16.174V15.1305Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0001 14.6083C13.1527 14.6083 14.087 13.6739 14.087 12.5213C14.087 11.3687 13.1527 10.4343 12.0001 10.4343C10.8475 10.4343 9.91309 11.3687 9.91309 12.5213C9.91309 13.6739 10.8475 14.6083 12.0001 14.6083Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0005 13.5651C12.5768 13.5651 13.044 13.0979 13.044 12.5216C13.044 11.9453 12.5768 11.4781 12.0005 11.4781C11.4242 11.4781 10.957 11.9453 10.957 12.5216C10.957 13.0979 11.4242 13.5651 12.0005 13.5651Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M10.4346 9.91333H13.565L11.9998 11.4786L10.4346 9.91333Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.522 10.9556H11.4785V14.086H12.522V10.9556Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M13.6696 13.7745H10.3304L7.82617 15.1311H16.174L13.6696 13.7745Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3637" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1y(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3638)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9987C16.7572 23.9987 20.868 21.23 22.809 17.2161H1.19043C3.13143 21.23 7.24218 23.9987 11.9997 23.9987Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.0007 -0.000976562C7.24316 -0.000976562 3.13241 2.7677 1.19141 6.78165H22.8099C20.869 2.7677 16.7582 -0.000976562 12.0007 -0.000976562Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M7.38504 7.82446L7.77354 9.0202H9.03077L8.01368 9.75913L8.40223 10.9549L7.38504 10.2159L6.36785 10.9549L6.7564 9.75913L5.73926 9.0202H6.99649L7.38504 7.82446Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M7.38504 13.0425L7.77354 14.2383H9.03077L8.01368 14.9772L8.40223 16.1729L7.38504 15.4339L6.36785 16.1729L6.7564 14.9772L5.73926 14.2383H6.99649L7.38504 13.0425Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M16.6145 7.82446L17.0031 9.0202H18.2603L17.2432 9.75913L17.6317 10.9549L16.6145 10.2159L15.5973 10.9549L15.9859 9.75913L14.9688 9.0202H16.226L16.6145 7.82446Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M16.6145 13.0425L17.0031 14.2383H18.2603L17.2432 14.9772L17.6317 16.1729L16.6145 15.4339L15.5973 16.1729L15.9859 14.9772L14.9688 14.2383H16.226L16.6145 13.0425Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M11.9993 10.4333L12.3878 11.6291H13.6451L12.6279 12.3681L13.0165 13.5638L11.9993 12.8248L10.9821 13.5638L11.3707 12.3681L10.3535 11.6291H11.6107L11.9993 10.4333Z",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3638" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1x(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3639)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.2387 9.07752C12.966 10.2118 12.4815 9.99552 12.2437 10.9848C10.8429 10.648 9.98021 9.23938 10.317 7.83852C10.6537 6.43775 12.0624 5.57506 13.4632 5.91186C12.9876 7.89031 13.4827 8.063 13.2387 9.07752Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.60395 9.91749C10.5985 10.5273 10.243 10.9214 11.1103 11.4533C10.3571 12.6815 8.75092 13.0665 7.5227 12.3134C6.29453 11.5603 5.90936 9.954 6.66255 8.72583C8.3972 9.78952 8.71431 9.372 9.60395 9.91749Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.27946 13.6349C10.1668 12.8775 10.4316 13.3373 11.2055 12.6769C12.1409 13.7727 12.0108 15.4193 10.915 16.3547C9.81918 17.2901 8.17255 17.1598 7.2373 16.0641C8.78483 14.743 8.48573 14.3123 9.27946 13.6349Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.7145 15.0914C12.2683 14.0135 12.7875 13.9036 12.3984 12.9636C13.7296 12.4127 15.2555 13.0452 15.8065 14.3764C16.3574 15.7076 15.7248 17.2334 14.3936 17.7844C13.6156 15.9043 13.1136 16.0557 12.7145 15.0914Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M15.1618 12.2739C13.9987 12.3652 14.0545 11.8374 13.0403 11.917C12.9277 10.4808 14.0009 9.22495 15.4372 9.11222C16.8734 8.99976 18.1292 10.0728 18.2418 11.5092C16.2132 11.6682 16.202 12.1924 15.1618 12.2739Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3639" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1w(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3640)" }, [
      createElementVNode("path", {
        d: "M0.746391 7.82522C0.264047 9.12525 0 10.5313 0 11.9991C0 13.467 0.264047 14.8731 0.746391 16.173L12 17.2165L23.2536 16.173C23.736 14.8731 24 13.467 24 11.9991C24 10.5313 23.736 9.12525 23.2536 7.82522L12 6.78174L0.746391 7.82522Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0006 -0.000976562C6.8411 -0.000976562 2.44254 3.25552 0.74707 7.82513H23.2543C21.5587 3.25552 17.1603 -0.000976562 12.0006 -0.000976562Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0006 23.9993C17.1603 23.9993 21.5587 20.7428 23.2543 16.1732H0.74707C2.44254 20.7428 6.8411 23.9993 12.0006 23.9993Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3640" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1v(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3641)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0.413086 15.1301C1.1074 17.7063 2.63763 19.9392 4.69535 21.5202V15.1301H0.413086Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M10.9561 23.954C11.3 23.9837 11.6479 23.9997 11.9995 23.9997C17.5439 23.9997 22.2091 20.2393 23.5861 15.1301H10.9561V23.954Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.5861 8.86918C22.2091 3.75999 17.5439 -0.000366211 11.9995 -0.000366211C11.6479 -0.000366211 11.3 0.015665 10.9561 0.04529V8.86918H23.5861Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M4.69535 2.47937C2.63763 4.06046 1.1074 6.29326 0.413086 8.86946H4.69535V2.47937Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4352H9.39136H9.39131V0.285645C8.28234 0.531551 7.23098 0.930129 6.26086 1.45949V10.4352H0.101578C0.0347813 10.9476 0 11.4699 0 12.0004C0 12.5309 0.0347813 13.0533 0.101578 13.5656H6.26081H6.26086V22.5413C7.23098 23.0706 8.28234 23.4693 9.39131 23.7151V13.5658V13.5657H23.8984C23.9651 13.0533 24 12.5309 24 12.0004C24 11.4699 23.9651 10.9475 23.8984 10.4352Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3641" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1u(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3642)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000976562C7.24218 -0.000976562 3.13143 2.7677 1.19043 6.78165H22.8089C20.868 2.7677 16.7572 -0.000976562 11.9997 -0.000976562Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9997C16.7572 23.9997 20.868 21.231 22.809 17.217H1.19043C3.13143 21.231 7.24218 23.9997 11.9997 23.9997Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0001 16.1732C14.3052 16.1732 16.174 14.3045 16.174 11.9993C16.174 9.69415 14.3052 7.82544 12.0001 7.82544C9.69489 7.82544 7.82617 9.69415 7.82617 11.9993C7.82617 14.3045 9.69489 16.1732 12.0001 16.1732Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0003 14.608C13.441 14.608 14.609 13.44 14.609 11.9993C14.609 10.5586 13.441 9.39062 12.0003 9.39062C10.5595 9.39062 9.3916 10.5586 9.3916 11.9993C9.3916 13.44 10.5595 14.608 12.0003 14.608Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 8.78088L12.8055 10.6061L14.7885 10.3904L13.6102 12L14.7885 13.6095L12.8055 13.3939L12.0007 15.2191L11.1959 13.3939L9.21289 13.6095L10.3911 12L9.21289 10.3904L11.1959 10.6061L12.0007 8.78088Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3642" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function r$j(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3643)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3643" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$h(e28, V10) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3644)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M15.8976 8.86968H14.3275C14.3405 9.04222 14.3479 9.21632 14.3479 9.39139C14.3479 10.5522 14.0577 11.6774 13.5519 12.4783C13.3958 12.7253 13.1336 13.0741 12.7826 13.3094V8.86963H11.2174V13.3094C10.8665 13.0741 10.6042 12.7253 10.4481 12.4783C9.94227 11.6774 9.65216 10.5522 9.65216 9.39139C9.65216 9.21632 9.65957 9.04218 9.67251 8.86968H8.10248C8.0924 9.04138 8.08691 9.21529 8.08691 9.39139C8.08691 12.6096 9.80573 15.1305 11.9999 15.1305C14.1942 15.1305 15.913 12.6096 15.913 9.39139C15.9131 9.21529 15.9076 9.04138 15.8976 8.86968Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.9572 5.73816H6.52241V6.78165H8.08761V5.73816H9.65281V6.78165H11.218V5.73816H12.7832V6.78165H14.3484V5.73816H15.9136V6.78165H17.4788V5.73816H19.044V6.78165H22.8098C20.869 2.7677 16.7582 -0.000976562 12.0007 -0.000976562C7.2432 -0.000976562 3.13241 2.7677 1.19141 6.78165H4.9572V5.73816Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M19.0442 17.217V18.2605H17.479V17.217H15.9138V18.2605H14.3486V17.217H12.7834V18.2605H11.2182V17.217H9.65295V18.2605H8.08775V17.217H6.52241V18.2605H4.9572V17.217H1.19141C3.13241 21.231 7.24316 23.9997 12.0007 23.9997C16.7582 23.9997 20.869 21.231 22.81 17.217H19.0442Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3644" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1t(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3645)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000610352C6.84012 -0.000610352 2.44161 3.25589 0.746094 7.8255H23.2534C21.5578 3.25589 17.1593 -0.000610352 11.9997 -0.000610352Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0006C17.1593 24.0006 21.5578 20.7441 23.2533 16.1744H0.746094C2.44161 20.7441 6.84013 24.0006 11.9997 24.0006Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M9.13039 11.2186C9.12383 11.2186 9.1174 11.219 9.11084 11.2191V11.2186H6.81692C6.93322 10.7692 7.34094 10.4359 7.82605 10.4359V8.87073C6.38759 8.87073 5.21736 10.041 5.21736 11.4794V12.7577V12.7838H9.11084C9.11966 12.7838 9.12659 12.7838 9.13039 12.7838C9.27425 12.7838 9.39125 12.9009 9.39125 13.0447V13.5664H4.17383V15.1316H10.9565V13.0446C10.9565 12.0377 10.1373 11.2186 9.13039 11.2186Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M13.0437 13.5657V8.87H11.4785V15.1309H14.0872V13.5657H13.0437Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M18.2606 13.5657V8.87H16.6954V13.5657H16.1736V12.0005H14.6084V15.1309H19.3041V13.5657H18.2606Z",
        fill: "#496E2D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3645" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1s(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3646)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9999 11.999C23.9999 6.83951 20.7434 2.44095 16.1738 0.745483V23.2527C20.7434 21.5571 23.9999 17.1587 23.9999 11.999Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M0 11.9997C0 17.1593 3.2565 21.5578 7.82611 23.2533V0.746094C3.2565 2.44156 0 6.84013 0 11.9997Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3646" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$p(L3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3647)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.4437 8.04392L15.5955 11.0707L13.0507 10.6008L11.4126 7.22412L6.98727 8.79448L6.63828 7.81104L5.48047 7.6684L6.35286 10.1269L9.39828 9.34812L10.2637 11.787L8.15848 14.8939L11.7312 17.9411L11.054 18.735L11.5093 19.8091L13.2024 17.8242L11.0052 15.5763L12.6845 13.6074L16.4279 13.8771L17.2805 9.25943L18.3066 9.44895L19.0093 8.51754L16.4437 8.04392Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3647" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$o(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3729)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M16.5173 9.39207H13.505L11.9989 6.78339L10.4928 9.39207H7.48047L8.98675 12.0008L7.48047 14.6094H10.4928L11.9989 17.2181L13.505 14.6094H16.5173L15.011 12.0008L16.5173 9.39207ZM13.8493 12.0008L12.9242 13.6033H11.0738L10.1485 12.0008L11.0737 10.3982H12.9241L13.8493 12.0008ZM11.9989 8.79559L12.3432 9.39203H11.6546L11.9989 8.79559ZM9.22324 10.3982H9.91192L9.56758 10.9946L9.22324 10.3982ZM9.22324 13.6033L9.56763 13.0069L9.91197 13.6033H9.22324ZM11.9989 15.2059L11.6546 14.6094H12.3432L11.9989 15.2059ZM14.7746 13.6033H14.0859L14.4303 13.0069L14.7746 13.6033ZM14.0859 10.3982H14.7746L14.4302 10.9946L14.0859 10.3982Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M19.4693 2.60907H4.5296C3.43446 3.48132 2.49527 4.54079 1.76074 5.73952H22.2382C21.5036 4.54084 20.5644 3.48132 19.4693 2.60907Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M4.5296 21.3914H19.4693C20.5644 20.5191 21.5036 19.4597 22.2381 18.2609H1.76074C2.49532 19.4596 3.43451 20.5191 4.5296 21.3914Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3729" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1r(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3730)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9999 11.9992C23.9999 6.83958 20.7434 2.44106 16.1738 0.745544V23.2528C20.7434 21.5572 23.9999 17.1587 23.9999 11.9992Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 11.9997C0 17.1593 3.2565 21.5578 7.82611 23.2533V0.746094C3.2565 2.44161 0 6.84013 0 11.9997Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3730" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$p(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3731)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.3059 2.48075C17.2824 0.925388 14.7495 0.00012207 12.0001 0.00012207C9.25073 0.00012207 6.71779 0.925434 4.69434 2.48075L12.0001 9.7865L19.3059 2.48075Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M2.48058 4.6936C0.925312 6.71706 0 9.24995 0 11.9994C0 14.7488 0.925312 17.2817 2.48062 19.3052L9.78642 11.9994L2.48058 4.6936Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M4.69434 21.5188C6.71784 23.0741 9.25073 23.9994 12.0001 23.9994C14.7495 23.9994 17.2824 23.0741 19.3059 21.5188L12.0001 14.213L4.69434 21.5188Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M21.5196 19.3051C23.075 17.2816 24.0002 14.7488 24.0002 11.9994C24.0002 9.24995 23.075 6.71706 21.5196 4.6936L14.2139 11.9994L21.5196 19.3051Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3731" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function r$i(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3732)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9996 17.2178C14.8811 17.2178 17.217 14.8819 17.217 12.0004C17.217 9.11892 14.8811 6.78302 11.9996 6.78302C9.11813 6.78302 6.78223 9.11892 6.78223 12.0004C6.78223 14.8819 9.11813 17.2178 11.9996 17.2178Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3732" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$g(i, L3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3733)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M21.5209 19.3071L14.2143 12.0006H14.2142L21.5209 4.69382C21.2058 4.28432 20.861 3.89033 20.486 3.51519C20.1109 3.1401 19.7169 2.79533 19.3074 2.48029L12.0007 9.78693L12.0007 9.78697L4.69405 2.48029C4.28459 2.79538 3.89056 3.14005 3.51542 3.51519C3.14028 3.89033 2.79556 4.28432 2.48052 4.69382L9.78716 12.0004L9.7872 12.0005L2.48047 19.3072C2.79561 19.7167 3.14033 20.1107 3.51538 20.4858C3.89052 20.8609 4.28445 21.2057 4.694 21.5207L12.0007 14.2141L12.0007 14.214L19.3074 21.5207C19.7168 21.2056 20.1109 20.8609 20.486 20.4858C20.8611 20.1106 21.2058 19.7166 21.5209 19.3071Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.91309 3.65288L12.0001 4.1746L14.087 3.65288V1.87899L13.2522 2.29636L12.0001 1.04419L10.7479 2.29636L9.91309 1.87899V3.65288Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.91309 3.65289V4.95733C9.91309 6.55483 12.0001 7.0443 12.0001 7.0443C12.0001 7.0443 14.087 6.55478 14.087 4.95733V3.65289H9.91309Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3733" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$t(i, L3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3734)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.30388 7.82623H23.2531C21.5576 3.25662 17.1591 0.00012207 11.9995 0.00012207C8.68576 0.00012207 5.68609 1.34351 3.51465 3.51523L7.30388 7.82623Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M7.30388 16.1745H23.2531C21.5576 20.7441 17.1591 24.0006 11.9995 24.0006C8.68576 24.0006 5.68609 22.6572 3.51465 20.4855L7.30388 16.1745Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51379C-1.17157 8.20008 -1.17157 15.7981 3.51471 20.4844C5.45126 18.5479 7.31375 16.6854 12 11.9991L3.51471 3.51379Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.76268 9.39178L5.42123 10.7689L6.90852 10.4252L6.24243 11.7987L7.43845 12.7471L5.94937 13.0827L5.95349 14.6092L4.76268 13.6542L3.57182 14.6092L3.57599 13.0827L2.08691 12.7471L3.28288 11.7987L2.61688 10.4252L4.10409 10.7689L4.76268 9.39178Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3734" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$s(L3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3648)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M18.783 12.1301H5.21777C5.21777 13.0666 6.03345 13.8258 6.96987 13.8258H6.91343C6.91343 14.7623 7.67257 15.5214 8.60909 15.5214C8.60909 16.458 9.36823 17.2171 10.3047 17.2171H13.6961C14.6326 17.2171 15.3917 16.458 15.3917 15.5214C16.3282 15.5214 17.0874 14.7623 17.0874 13.8258H17.0309C17.9673 13.8258 18.783 13.0666 18.783 12.1301Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M16.696 9.91351C16.696 12.5068 14.5937 14.6092 12.0003 14.6092C9.40698 14.6092 7.30469 12.5068 7.30469 9.91351",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M15.5864 9.91238L14.1208 10.6018L14.9012 12.0212L13.3098 11.7167L13.1082 13.3243L11.9997 12.1419L10.8912 13.3243L10.6896 11.7167L9.09821 12.0211L9.87859 10.6017L8.41309 9.91238L9.87863 9.22304L9.09821 7.80371L10.6896 8.10812L10.8913 6.50049L11.9997 7.68291L13.1082 6.50049L13.3098 8.10812L14.9013 7.80371L14.1209 9.22308L15.5864 9.91238Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3648" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$o(C3, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3649)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 -0.000732422C7.24316 -0.000732422 3.13241 2.76794 1.19141 6.78189H22.8099C20.869 2.76794 16.7582 -0.000732422 12.0007 -0.000732422Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M12.0007 24C7.24316 24 3.13241 21.2314 1.19141 17.2174H22.8099C20.869 21.2314 16.7582 24 12.0007 24Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M23.4333 8.34705H0.566672C0.199078 9.49872 0 10.7257 0 11.9992C0 13.2728 0.199078 14.4997 0.566672 15.6514H23.4333C23.8009 14.4997 24 13.2728 24 11.9992C24 10.7257 23.8009 9.49872 23.4333 8.34705Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M15.7369 5.54508L14.3158 4.88916L12.0003 10.1322L9.68478 4.88916L8.26367 5.54508L11.1384 11.9997L8.26367 18.4544L9.68478 19.1103L12.0003 13.8673L14.3158 19.1103L15.7369 18.4544L12.8622 11.9997L15.7369 5.54508Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.9656 6.16321C12.4154 5.56242 12.0004 5.21704 12.0004 5.21704C12.0004 5.21704 11.5853 5.56237 11.0352 6.16321V17.836C11.5853 18.4369 12.0004 18.7823 12.0004 18.7823C12.0004 18.7823 12.4154 18.437 12.9656 17.8361V6.16321Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.3916 8.40226V15.5981C9.97294 16.6282 10.6845 17.4725 11.2177 18.0323V5.96814C10.6845 6.52787 9.9729 7.37223 9.3916 8.40226Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M14.6083 8.40287C14.0269 7.3728 13.3155 6.52848 12.7822 5.96875V18.0329C13.3154 17.4731 14.0269 16.6288 14.6083 15.5987V8.40287Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M14.6084 8.40088V15.5968C15.1969 14.5538 15.6519 13.3206 15.6519 11.9989C15.6519 10.6771 15.1969 9.44385 14.6084 8.40088Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M9.39114 8.40088V15.5968C8.80263 14.5538 8.34766 13.3206 8.34766 11.9989C8.34766 10.6771 8.80263 9.44385 9.39114 8.40088Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3649" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$n(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3650)" }, [
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.173 11.16L14.4674 11.9622L15.3757 13.614L13.5237 13.2597L13.289 15.1305L11.9991 13.7545L10.7091 15.1305L10.4745 13.2597L8.62249 13.6139L9.5307 11.9622L7.8252 11.16L9.5307 10.3577L8.62249 8.70605L10.4744 9.06023L10.7091 7.18945L11.9991 8.56537L13.2891 7.18945L13.5237 9.06023L15.3757 8.70605L14.4676 10.3578L16.173 11.16Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.13 3.913H12.7822C12.7822 3.48086 12.4318 3.13037 11.9996 3.13037C11.5674 3.13037 11.217 3.48081 11.217 3.913H8.86914C8.86914 4.34518 9.24564 4.69562 9.67783 4.69562H9.65172C9.65172 5.12781 10.0021 5.47824 10.4343 5.47824C10.4343 5.91043 10.7847 6.26087 11.217 6.26087H12.7822C13.2143 6.26087 13.5648 5.91048 13.5648 5.47824C13.9969 5.47824 14.3474 5.12785 14.3474 4.69562H14.3213C14.7535 4.69562 15.13 4.34523 15.13 3.913Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M24 11.9996C24 18.627 18.6274 23.9996 12 23.9996C5.37262 23.9996 0 18.627 0 11.9996C0.521719 11.9996 24 11.9996 24 11.9996Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0004 24.0005C15.7515 24.0005 19.0999 22.279 21.3005 19.5835C20.9047 19.3137 20.691 18.8774 20.0003 18.8774C19.0003 18.8774 19.0003 19.7918 18.0003 19.7918C17.0004 19.7918 17.0004 18.8774 16.0004 18.8774C15.0004 18.8774 15.0004 19.7918 14.0004 19.7918C13.0004 19.7918 13.0003 18.8774 12.0002 18.8774C11.0003 18.8774 11.0003 19.7918 10.0003 19.7918C9.00048 19.7918 9.00048 18.8774 8.00049 18.8774C7.00041 18.8774 7.00041 19.7918 6.00034 19.7918C5.00026 19.7918 5.00026 18.8774 4.00018 18.8774C3.30952 18.8774 3.09582 19.3136 2.7002 19.5834C4.9007 22.279 8.24935 24.0005 12.0004 24.0005Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M21.9999 13.5312C20.9999 13.5312 20.9999 12.6168 19.9998 12.6168C18.9999 12.6168 18.9999 13.5312 17.9999 13.5312C17 13.5312 16.9999 12.6168 16 12.6168C15 12.6168 15 13.5312 14 13.5312C13 13.5312 12.9999 12.6168 11.9998 12.6168C10.9998 12.6168 10.9998 13.5312 9.99991 13.5312C9.00006 13.5312 9.00006 12.6168 8.00008 12.6168C7 12.6168 7 13.5312 5.99992 13.5312C4.99984 13.5312 4.99984 12.6168 3.99977 12.6168C2.99992 12.6168 2.99992 13.5312 1.99994 13.5312C1.00534 13.5312 0.999578 12.6269 0.015625 12.6172C0.0433281 13.1661 0.108859 13.705 0.207953 14.232C1.00502 14.3491 1.07481 15.1311 1.99998 15.1311C2.99997 15.1311 2.99997 14.2169 3.99981 14.2169C4.99989 14.2169 4.99989 15.1311 5.99997 15.1311C7.00005 15.1311 7.00005 14.2169 8.00012 14.2169C9.00011 14.2169 9.00011 15.1311 9.99995 15.1311C10.9999 15.1311 10.9999 14.2169 11.9999 14.2169C13 14.2169 13 15.1311 14 15.1311C15.0001 15.1311 15.0001 14.2169 16 14.2169C17 14.2169 17 15.1311 18 15.1311C18.9999 15.1311 19 14.2169 19.9999 14.2169C21 14.2169 21 15.1311 21.9999 15.1311C22.9252 15.1311 22.995 14.3492 23.7921 14.232C23.8912 13.705 23.9567 13.1662 23.9845 12.6173C23.0004 12.627 22.9945 13.5312 21.9999 13.5312Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M19.9998 15.7477C18.9998 15.7477 18.9998 16.662 17.9998 16.662C16.9999 16.662 16.9999 15.7477 15.9999 15.7477C14.9999 15.7477 14.9999 16.662 13.9999 16.662C12.9998 16.662 12.9998 15.7477 11.9998 15.7477C10.9998 15.7477 10.9998 16.662 9.99983 16.662C8.99998 16.662 8.99998 15.7477 8 15.7477C6.99992 15.7477 6.99992 16.662 5.99984 16.662C4.99977 16.662 4.99977 15.7477 3.99969 15.7477C2.99984 15.7477 2.99984 16.662 1.99986 16.662C1.28534 16.662 1.08125 16.1953 0.658203 15.9287C0.939828 16.7424 1.3062 17.5165 1.74744 18.24C1.82417 18.2542 1.9077 18.262 1.99986 18.262C2.99984 18.262 2.99984 17.3478 3.99969 17.3478C4.99977 17.3478 4.99977 18.262 5.99984 18.262C6.99992 18.262 6.99992 17.3478 8 17.3478C8.99998 17.3478 8.99998 18.262 9.99983 18.262C10.9998 18.262 10.9998 17.3478 11.9998 17.3478C12.9998 17.3478 12.9998 18.262 13.9999 18.262C15 18.262 15 17.3478 15.9999 17.3478C16.9999 17.3478 16.9999 18.262 17.9998 18.262C18.9998 18.262 18.9998 17.3478 19.9998 17.3478C20.9998 17.3478 20.9998 18.262 21.9998 18.262C22.092 18.262 22.1756 18.2542 22.2523 18.24C22.6935 17.5165 23.0599 16.7424 23.3416 15.9288C22.9185 16.1952 22.7144 16.662 21.9998 16.662C20.9998 16.662 20.9998 15.7477 19.9998 15.7477Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.9628 11.0511C23.0004 11.0738 22.9872 11.9644 21.9998 11.9644C20.9999 11.9644 20.9999 11.05 19.9998 11.05C18.9998 11.05 18.9998 11.9644 17.9999 11.9644C17 11.9644 16.9999 11.05 16 11.05C15 11.05 15 11.9644 14 11.9644C12.9999 11.9644 12.9999 11.05 11.9998 11.05C10.9998 11.05 10.9998 11.9644 9.99989 11.9644C9.00005 11.9644 9.00005 11.05 8.00006 11.05C6.99998 11.05 6.99998 11.9644 5.99991 11.9644C4.99983 11.9644 4.99983 11.05 3.99975 11.05C2.99991 11.05 2.99991 11.9644 1.99992 11.9644C1.01278 11.9644 0.999422 11.0739 0.0371719 11.0511C0.01275 11.3639 0 11.68 0 11.9991C0 12.2177 0.0061875 12.4349 0.0178594 12.6505C0.999563 12.6616 1.00608 13.5643 1.99997 13.5643C2.99995 13.5643 2.99995 12.6501 3.9998 12.6501C4.99988 12.6501 4.99988 13.5643 5.99995 13.5643C7.00003 13.5643 7.00003 12.6501 8.00011 12.6501C9.00009 12.6501 9.00009 13.5643 9.99994 13.5643C10.9999 13.5643 10.9999 12.6501 11.9999 12.6501C12.9999 12.6501 12.9999 13.5643 14 13.5643C15.0001 13.5643 15.0001 12.6501 16 12.6501C17 12.6501 17 13.5643 18 13.5643C18.9999 13.5643 18.9999 12.6501 19.9999 12.6501C21 12.6501 21 13.5643 21.9999 13.5643C22.9939 13.5643 23.0004 12.6616 23.9823 12.6505C23.9938 12.4348 24 12.2177 24 11.9991C24 11.68 23.9872 11.3639 23.9628 11.0511Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3650" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function r$h(o3, e28) {
  return openBlock(), createElementBlock("svg", {
    height: "24",
    width: "24",
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("circle", {
      style: { fill: "#0052B4" },
      cx: "256",
      cy: "256",
      r: "256"
    }),
    createElementVNode("g", null, [
      createElementVNode("polygon", {
        style: { fill: "#F0F0F0" },
        points: `112.449,155.827 117.975,172.835 135.855,172.835 121.39,183.344 126.915,200.349 \r
		112.449,189.84 97.982,200.349 103.509,183.344 89.043,172.835 106.922,172.835 	`
      }),
      createElementVNode("polygon", {
        style: { fill: "#F0F0F0" },
        points: `168.101,139.132 173.627,156.139 191.507,156.139 177.042,166.648 182.567,183.653 \r
		168.101,173.144 153.635,183.653 159.161,166.648 144.696,156.139 162.576,156.139 	`
      }),
      createElementVNode("polygon", {
        style: { fill: "#F0F0F0" },
        points: `223.753,122.436 229.279,139.443 247.159,139.443 232.694,149.953 238.219,166.958 \r
		223.753,156.448 209.287,166.958 214.813,149.953 200.348,139.443 218.228,139.443 	`
      }),
      createElementVNode("polygon", {
        style: { fill: "#F0F0F0" },
        points: `399.551,155.827 394.025,172.835 376.145,172.835 390.611,183.344 385.085,200.349 \r
		399.551,189.84 414.018,200.349 408.491,183.344 422.957,172.835 405.077,172.835 	`
      }),
      createElementVNode("polygon", {
        style: { fill: "#F0F0F0" },
        points: `343.899,139.132 338.373,156.139 320.493,156.139 334.959,166.648 329.433,183.653 \r
		343.899,173.144 358.365,183.653 352.839,166.648 367.304,156.139 349.424,156.139 	`
      }),
      createElementVNode("polygon", {
        style: { fill: "#F0F0F0" },
        points: `288.247,122.436 282.721,139.443 264.841,139.443 279.306,149.953 273.781,166.958 \r
		288.247,156.448 302.713,166.958 297.187,149.953 311.652,139.443 293.772,139.443 	`
      })
    ]),
    createElementVNode("path", {
      style: { fill: "#FFDA44" },
      d: `M300.522,267.13L256,211.478l-22.261,11.13v22.261l-33.391,22.261h-22.261v28.759\r
	c32.628,13.212,55.652,45.181,55.652,82.546l0,0H256v-22.261l22.261-22.261l22.261,22.261l22.261-22.261v-22.261l22.261-33.391\r
	L300.522,267.13z`
    })
  ]);
}
function p$1q(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3651)" }, [
      createElementVNode("path", {
        d: "M23.2536 16.173C23.736 14.873 24 13.467 24 11.9991C24 10.5313 23.736 9.12521 23.2536 7.82522L12 6.78174L0.746391 7.82522C0.264047 9.12521 0 10.5313 0 11.9991C0 13.467 0.264047 14.873 0.746391 16.173L12 17.2165L23.2536 16.173Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 23.9996C17.1603 23.9996 21.5588 20.7431 23.2543 16.1735H0.74707C2.44263 20.7431 6.8411 23.9996 12.0007 23.9996Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000488281C6.84012 -0.000488281 2.44166 3.25601 0.746094 7.82562H23.2534C21.5578 3.25601 17.1593 -0.000488281 11.9997 -0.000488281Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51453C-1.17157 8.20081 -1.17157 15.7988 3.51471 20.4852C4.73791 19.2619 5.93182 18.068 7.82609 16.1738V7.82595L3.51471 3.51453Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3651" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$m(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3652)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M17.8681 12L15.4702 13.1279L16.7471 15.4504L14.1431 14.9522L13.8133 17.5826L11.9994 15.6481L10.1857 17.5826L9.85578 14.9522L7.25197 15.4503L8.52884 13.1278L6.13086 12L8.52884 10.8721L7.25197 8.54956L9.85569 9.04784L10.1858 6.41736L11.9994 8.35193L13.8133 6.41736L14.1431 9.04784L16.7472 8.54956L15.4702 10.8723L17.8681 12Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9998 15.6514C14.0169 15.6514 15.652 14.0163 15.652 11.9992C15.652 9.98218 14.0169 8.34705 11.9998 8.34705C9.98279 8.34705 8.34766 9.98218 8.34766 11.9992C8.34766 14.0163 9.98279 15.6514 11.9998 15.6514Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M10.1746 12.0004C10.0867 12.0004 9.9998 12.0049 9.91406 12.0134C9.9172 12.5192 10.1002 12.9822 10.4025 13.3419C10.5637 12.908 10.8045 12.5123 11.1081 12.1737C10.8181 12.0621 10.5035 12.0004 10.1746 12.0004Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.2988 13.967C11.5182 14.0454 11.7544 14.0884 12.0008 14.0884C12.2472 14.0884 12.4834 14.0454 12.7027 13.967C12.5832 13.4977 12.3363 13.0788 12.0008 12.7495C11.6653 13.0787 11.4184 13.4977 11.2988 13.967Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M13.8079 10.9573C13.447 10.3335 12.7731 9.91345 12.0006 9.91345C11.2281 9.91345 10.5542 10.3335 10.1934 10.9573C10.8512 10.9606 11.4681 11.1395 12.0006 11.4483C12.5332 11.1395 13.15 10.9606 13.8079 10.9573Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.8936 12.1739C13.1972 12.5125 13.4379 12.9082 13.5992 13.3421C13.9014 12.9825 14.0844 12.5195 14.0876 12.0136C14.0018 12.0051 13.9149 12.0006 13.827 12.0006C13.4982 12.0006 13.1836 12.0623 12.8936 12.1739Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3652" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1p(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3653)" }, [
      createElementVNode("path", {
        d: "M22.809 6.78189C20.868 2.76794 16.7572 -0.000732422 11.9997 -0.000732422C7.24218 -0.000732422 3.13143 2.76794 1.19043 6.78189L11.9997 7.82538L22.809 6.78189Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M1.19043 17.2162C3.13143 21.2302 7.24218 23.9988 11.9997 23.9988C16.7572 23.9988 20.868 21.2302 22.809 17.2162L11.9997 16.1727L1.19043 17.2162Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M22.8093 6.78174H1.19072C0.427875 8.35932 0 10.1292 0 11.9991C0 13.869 0.427875 15.6389 1.19072 17.2165H22.8092C23.5722 15.6389 24 13.869 24 11.9991C24 10.1292 23.5722 8.35932 22.8093 6.78174Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0001 16.1736C14.3052 16.1736 16.174 14.3049 16.174 11.9997C16.174 9.69452 14.3052 7.82581 12.0001 7.82581C9.69489 7.82581 7.82617 9.69452 7.82617 11.9997C7.82617 14.3049 9.69489 16.1736 12.0001 16.1736Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3653" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1o(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3654)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 -0.000732422C6.45634 -0.000732422 1.79106 3.75963 0.414062 8.86881H23.5873C22.2103 3.75963 17.545 -0.000732422 12.0007 -0.000732422Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M12.0007 23.9986C17.545 23.9986 22.2103 20.2382 23.5873 15.129H0.414062C1.79106 20.2382 6.45634 23.9986 12.0007 23.9986Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3654" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1n(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3655)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000732422C7.24218 -0.000732422 3.13143 2.76794 1.19043 6.78189H22.8089C20.868 2.76794 16.7572 -0.000732422 11.9997 -0.000732422Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9993C16.7572 23.9993 20.868 21.2306 22.809 17.2167H1.19043C3.13143 21.2306 7.24218 23.9993 11.9997 23.9993Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.131 14.0862L12.0006 8.34705L8.87012 14.0862H11.2179V15.6514H12.7832V14.0862H15.131Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3655" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1m(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3656)" }, [
      createElementVNode("path", {
        d: "M0 11.9999C0 13.8697 0.427828 15.6396 1.19072 17.2173L12 17.739L22.8093 17.2173C23.5722 15.6396 24 13.8697 24 11.9999C24 10.13 23.5722 8.36013 22.8093 6.78251L12 6.26074L1.19072 6.78246C0.427828 8.36013 0 10.13 0 11.9999Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 24C16.7582 24 20.869 21.2314 22.81 17.2174H1.19141C3.13241 21.2314 7.24316 24 12.0007 24Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0007 -0.000732422C7.24316 -0.000732422 3.13241 2.76794 1.19141 6.78189H22.8099C20.869 2.76794 16.7582 -0.000732422 12.0007 -0.000732422Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.7828 11.7392V8.86963H11.2176V11.7392L9.32715 13.6297C9.87694 14.5297 10.8684 15.1305 12.0002 15.1305C13.1321 15.1305 14.1235 14.5297 14.6733 13.6297L12.7828 11.7392Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3656" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1l(C3, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3657)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M2.74316 4.36307H21.2573C20.5735 3.53502 19.7804 2.80073 18.9006 2.18127H5.0999C4.2201 2.80063 3.42702 3.53498 2.74316 4.36307Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 12.0005C0 12.3684 0.0174844 12.732 0.049875 13.0915H23.9501C23.9825 12.732 24 12.3684 24 12.0005C24 11.6327 23.9825 11.2691 23.9501 10.9097H0.049875C0.0174844 11.2691 0 11.6327 0 12.0005Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.30884 17.4546H22.6917C23.0451 16.7634 23.3332 16.0335 23.5484 15.2728H0.452148C0.667258 16.0335 0.955539 16.7634 1.30884 17.4546Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.0999 21.818H18.9005C19.7803 21.1986 20.5734 20.4643 21.2572 19.6362H2.74316C3.42702 20.4642 4.2201 21.1986 5.0999 21.818Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0.452148 8.72782H23.5485C23.3333 7.96713 23.0451 7.23719 22.6918 6.54602H1.30888C0.955586 7.23719 0.667305 7.96713 0.452148 8.72782Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.73926 2.18192H18.9004C16.9486 0.807638 14.5687 0.00012207 12.0001 0.00012207C10.4349 0.00012207 7.69113 0.807638 5.73926 2.18192Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.4785 6.54532H22.6917C22.2926 5.76471 21.8107 5.03351 21.2573 4.36353H11.4785V6.54532Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.4785 10.9085H23.9504C23.8829 10.1593 23.7472 9.42976 23.5484 8.72668H11.4785V10.9085Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0.451805 15.2737H23.5481C23.7469 14.5707 23.8826 13.8411 23.9501 13.0919H0.0498047C0.117305 13.8411 0.252961 14.5706 0.451805 15.2737Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M2.74297 19.6369H21.2571C21.8105 18.9668 22.2924 18.2356 22.6915 17.4551H1.30859C1.70764 18.2357 2.18961 18.9669 2.74297 19.6369Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9999 24.0005C14.5685 24.0005 16.9484 23.193 18.9003 21.8187H5.09961C7.05148 23.193 9.43133 24.0005 11.9999 24.0005Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0.451758 8.72692C0.252914 9.43004 0.117305 10.1596 0.0498047 10.9087H11.9999V-0.000366211C6.50711 -0.000366211 1.87638 3.6902 0.451758 8.72692Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M7.14405 3.13049L7.92101 5.52182H10.4357L8.40138 6.99989L9.17829 9.39136L7.14405 7.91339L5.10973 9.39136L5.88682 6.99989L3.85254 5.52182H6.36705L7.14405 3.13049Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3657" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$r(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3658)" }, [
      createElementVNode("path", {
        d: "M1.19072 6.78274C0.427875 8.36037 0 10.1302 0 12.0001C0 13.87 0.427875 15.6399 1.19072 17.2175L12 18.261L22.8093 17.2175C23.5721 15.6399 24 13.87 24 12.0001C24 10.1302 23.5721 8.36037 22.8093 6.78274L12 5.73926L1.19072 6.78274Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M1.19141 17.2168C3.13231 21.2307 7.24273 23.9994 12.0003 23.9994C16.7577 23.9994 20.8682 21.2307 22.8091 17.2168H1.19141Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M1.19141 6.78299H22.8091C20.8682 2.76904 16.7577 0.000366211 12.0003 0.000366211C7.24273 0.000366211 3.13231 2.76904 1.19141 6.78299Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.7929 9.80481L15.7775 11.1616L17.372 10.6446L16.3859 12.0002L17.3704 13.357L15.7764 12.838L14.7903 14.1936L14.7913 12.5173L13.1973 11.9983L14.7919 11.4812L14.7929 9.80481Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.1062 15.3904C10.2332 15.3904 8.71485 13.8721 8.71485 11.9991C8.71485 10.1262 10.2332 8.60782 12.1062 8.60782C12.6901 8.60782 13.2396 8.75548 13.7194 9.01545C12.9667 8.27946 11.9376 7.8252 10.8018 7.8252C8.4966 7.8252 6.62793 9.69391 6.62793 11.9991C6.62793 14.3043 8.49665 16.173 10.8018 16.173C11.9376 16.173 12.9668 15.7187 13.7194 14.9827C13.2396 15.2428 12.6902 15.3904 12.1062 15.3904Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3658" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1k(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3659)" }, [
      createElementVNode("path", {
        d: "M24 11.9995C24 18.6269 18.6274 23.9995 12 23.9995C5.37262 23.9995 0 18.6269 0 11.9995C0.521719 11.9995 12 10.4343 12 10.4343L24 11.9995Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M8.87023 8.34736C8.87023 7.48294 8.16945 6.78216 7.30503 6.78216C6.90401 6.78216 6.53853 6.9331 6.26154 7.18102V6.26039H6.78326V5.21691H6.26154V4.69519H5.21806V5.21691H4.69634V6.26039H5.21806V7.18102C4.94108 6.9331 4.57559 6.78216 4.17458 6.78216C3.31016 6.78216 2.60938 7.48294 2.60938 8.34736C2.60938 8.81082 2.81098 9.22707 3.13109 9.51371V10.4343H8.34846V9.51371C8.66867 9.22707 8.87023 8.81082 8.87023 8.34736Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3659" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1j(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3660)" }, [
      createElementVNode("path", {
        d: "M23.2536 16.1743C23.736 14.8744 24 13.4683 24 12.0005C24 10.5326 23.736 9.1265 23.2536 7.82656L12 6.78308L0.746391 7.82656C0.264 9.1265 0 10.5326 0 12.0005C0 13.4683 0.264 14.8744 0.746391 16.1743L12 17.2178L23.2536 16.1743Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M23.2533 7.82574C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211C6.84013 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2533Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0007 24.0008C17.1603 24.0008 21.5588 20.7443 23.2543 16.1747H0.74707C2.44259 20.7443 6.8411 24.0008 12.0007 24.0008Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3660" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1i(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3661)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000366211C6.84012 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2534C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0007 24.0008C17.1603 24.0008 21.5588 20.7443 23.2543 16.1747H0.74707C2.44259 20.7443 6.8411 24.0008 12.0007 24.0008Z",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3661" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$f(i, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3662)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M14.0872 11.5003C13.7927 11.5003 13.513 11.559 13.2533 11.6525C13.3956 11.3354 13.491 10.9826 13.491 10.6059C13.491 9.11521 12.0003 7.99719 12.0003 7.99719C12.0003 7.99719 10.5096 9.11521 10.5096 10.6059C10.5096 10.9826 10.605 11.3354 10.7473 11.6525C10.4875 11.5591 10.2079 11.5003 9.91337 11.5003C8.4227 11.5003 7.30469 12.9909 7.30469 12.9909C7.30469 12.9909 8.4227 14.4816 9.91337 14.4816C10.7874 14.4816 11.5328 13.9694 12.0003 13.5454C12.4679 13.9693 13.2133 14.4816 14.0873 14.4816C15.578 14.4816 16.696 12.9909 16.696 12.9909C16.696 12.9909 15.5779 11.5003 14.0872 11.5003Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0006 4.69458L12.3086 5.64221H13.305L12.499 6.22796L12.8066 7.17558L12.0006 6.58983L11.1946 7.17558L11.5023 6.22796L10.6963 5.64221H11.6927L12.0006 4.69458Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M8.2111 6.35156L8.80351 6.88491L9.49384 6.48637L9.16965 7.21458L9.76201 7.74802L8.96926 7.66467L8.64507 8.39288L8.47923 7.6132L7.68652 7.52986L8.3768 7.13123L8.2111 6.35156Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.4375 9.12594L6.21722 9.29164L6.6158 8.60132L6.69914 9.39402L7.47877 9.55986L6.75061 9.8841L6.83395 10.6768L6.30047 10.0845L5.57231 10.4087L5.97089 9.7183L5.4375 9.12594Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.7891 6.35156L15.1968 6.88491L14.5065 6.48637L14.8306 7.21458L14.2383 7.74802L15.031 7.66467L15.3552 8.39288L15.5211 7.6132L16.3138 7.52986L15.6235 7.13123L15.7891 6.35156Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M18.5627 9.12594L17.783 9.29164L17.3845 8.60132L17.3011 9.39402L16.5215 9.55986L17.2496 9.8841L17.1663 10.6768L17.6998 10.0845L18.4279 10.4087L18.0294 9.7183L18.5627 9.12594Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9997 18.6554C13.1838 18.6554 14.2752 18.2603 15.1507 17.5956H8.84863C9.72416 18.2603 10.8156 18.6554 11.9997 18.6554Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.2168 15.5243C7.38241 15.9033 7.59241 16.2583 7.83906 16.5841H16.1602C16.4069 16.2584 16.6169 15.9033 16.7825 15.5243H7.2168Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3662" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$e(e28, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3692)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M13.8259 23.8624C15.7776 23.5647 17.5741 22.7961 19.0973 21.6772L12.001 12.0004L13.8259 23.8624Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M10.1757 0.137695C8.22408 0.435445 6.42755 1.20401 4.9043 2.32287L12.0007 11.9997L10.1757 0.137695Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.9043 21.6772C6.42745 22.7961 8.22398 23.5646 10.1756 23.8625L12.0007 12.0004L4.9043 21.6772Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M2.32384 4.90234C1.20494 6.42559 0.436469 8.22208 0.138672 10.1738L12.0007 11.9988L2.32384 4.90234Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0.138672 13.8253C0.436422 15.777 1.20498 17.5735 2.32389 19.0967L12.0007 12.0004L0.138672 13.8253Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.863 10.174C23.5652 8.22233 22.7967 6.42579 21.6778 4.90259L12.001 11.999L23.863 10.174Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M19.0973 2.32282C17.5741 1.20396 15.7776 0.435445 13.8259 0.137695L12.001 11.9997L19.0973 2.32282Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M21.6779 19.0967C22.7968 17.5735 23.5653 15.7769 23.8631 13.8254L12.001 12.0004L21.6779 19.0967Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.001 16.1743C14.3062 16.1743 16.1749 14.3056 16.1749 12.0004C16.1749 9.69525 14.3062 7.82654 12.001 7.82654C9.69586 7.82654 7.82715 9.69525 7.82715 12.0004C7.82715 14.3056 9.69586 16.1743 12.001 16.1743Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0006 15.1297C13.7295 15.1297 15.131 13.7281 15.131 11.9992C15.131 10.2703 13.7295 8.86877 12.0006 8.86877C10.2717 8.86877 8.87012 10.2703 8.87012 11.9992C8.87012 13.7281 10.2717 15.1297 12.0006 15.1297Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3692" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1h(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3663)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.82617 11.9995V23.2531C9.12611 23.7355 10.5322 23.9995 12.0001 23.9995C18.6274 23.9995 24.0001 18.6268 24.0001 11.9995C24.0001 5.37208 7.82617 11.9995 7.82617 11.9995Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0001 0.000366211C10.5322 0.000366211 9.12611 0.264413 7.82617 0.746757V12.0004C7.82617 12.0004 18.4697 12.0004 24.0001 12.0004C24.0001 5.37299 18.6274 0.000366211 12.0001 0.000366211Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3663" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function L$7(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3664)" }, [
      createElementVNode("path", {
        d: "M0 11.9997C0 13.4676 0.264047 14.8736 0.746391 16.1736L12 16.6954L23.2536 16.1737C23.736 14.8736 24 13.4676 24 11.9997C24 10.5319 23.736 9.12583 23.2536 7.82584L12 7.30408L0.746391 7.8258C0.264047 9.12583 0 10.5319 0 11.9997Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000366211C6.84013 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2534C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.2533 16.1747H0.746094C2.44161 20.7442 6.84012 24.0008 11.9997 24.0008C17.1593 24.0008 21.5578 20.7442 23.2533 16.1747Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M15.5864 5.73994L14.1209 5.0506L14.9013 3.63127L13.3099 3.93572L13.1082 2.328L11.9997 3.51042L10.8913 2.328L10.6896 3.93572L9.09821 3.63127L9.87863 5.0506L8.41309 5.73994H15.5864Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3664" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1g(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3665)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.4785 12.0002H24.0002C24.0002 10.9171 23.8559 9.86791 23.5869 8.86975H11.4785V12.0002Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.4785 5.73873H22.239C21.5044 4.54004 20.5652 3.48053 19.4701 2.60828H11.4785V5.73873Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0011 24.0002C14.8253 24.0002 17.4211 23.024 19.471 21.3915H4.53125C6.58114 23.024 9.17694 24.0002 12.0011 24.0002Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M1.76195 18.2601H22.2394C22.8291 17.2978 23.2864 16.2459 23.5873 15.1296H0.414062C0.714859 16.2459 1.17222 17.2978 1.76195 18.2601Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M7.98001 10.2709C6.34117 10.2709 5.01263 8.94229 5.01263 7.30349C5.01263 5.6647 6.34121 4.33612 7.98001 4.33612C8.491 4.33612 8.97179 4.46535 9.39156 4.69279C8.73306 4.04887 7.8325 3.65137 6.8387 3.65137C4.82171 3.65137 3.18652 5.28651 3.18652 7.30354C3.18652 9.32057 4.82171 10.9557 6.8387 10.9557C7.8325 10.9557 8.73306 10.5582 9.39156 9.91429C8.97179 10.1416 8.49104 10.2709 7.98001 10.2709Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M8.81647 5.21729L9.3433 6.31894L10.533 6.04407L10.0002 7.14277L10.9571 7.90153L9.76578 8.17008L9.76911 9.39122L8.81647 8.62725L7.86378 9.39122L7.86706 8.17008L6.67578 7.90153L7.63259 7.14277L7.09977 6.04407L8.28959 6.31894L8.81647 5.21729Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3665" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1f(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3666)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M19.826 6.26099H4.17383V17.7393H19.826V6.26099Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M13.9323 15.3913C12.0594 15.3913 10.541 13.8729 10.541 12C10.541 10.127 12.0594 8.60867 13.9323 8.60867C14.5163 8.60867 15.0658 8.75633 15.5455 9.0163C14.793 8.28032 13.7638 7.82605 12.628 7.82605C10.3229 7.82605 8.4541 9.69477 8.4541 11.9999C8.4541 14.3051 10.3229 16.1738 12.628 16.1738C13.7638 16.1738 14.793 15.7196 15.5455 14.9836C15.0658 15.2436 14.5163 15.3913 13.9323 15.3913Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3666" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1e(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3735)" }, [
      createElementVNode("path", {
        d: "M16.1745 0.745902C14.8745 0.263559 13.4684 -0.000488281 12.0006 -0.000488281C10.5327 -0.000488281 9.12667 0.263559 7.82669 0.745902L6.7832 11.9995L7.82669 23.2531C9.12667 23.7355 10.5327 23.9995 12.0006 23.9995C13.4684 23.9995 14.8745 23.7355 16.1745 23.2531L17.218 11.9995L16.1745 0.745902Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.9999 12.0002C23.9999 6.84067 20.7434 2.44211 16.1738 0.746643V23.2539C20.7434 21.5583 23.9999 17.1598 23.9999 12.0002Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 11.9994C0 17.159 3.2565 21.5575 7.82611 23.2531V0.74585C3.2565 2.44132 0 6.83988 0 11.9994Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3735" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1d(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3736)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 -0.000488281C18.6274 -0.000488281 24 5.37214 24 11.9995C24 18.6269 18.6274 23.9995 12 23.9995",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M8.34725 4.69624V3.13104H6.78205V4.69624H5.2168V6.26145H6.78205V7.82669H8.34725V6.26145H9.91245V4.69624H8.34725Z",
        fill: "#ACABB1"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3736" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$q(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3737)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 9.98611 23.5031 8.08847 22.6265 6.42188L11.9859 12.0141L17.5781 1.37353C15.9115 0.496875 14.0139 0 12 0C5.37262 0 0 5.37262 0 12C0 15.3137 1.34316 18.3137 3.51469 20.4853C5.68627 22.6569 8.68627 24 12 24Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M22.6141 6.43435C22.0648 5.38885 21.3507 4.40724 20.4716 3.52815C19.5925 2.64906 18.611 1.93492 17.5654 1.38568L3.50098 20.4987L22.6141 6.43435Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M3.50098 20.4994L22.6141 6.43501C22.0648 5.38951 21.3507 4.4079 20.4716 3.52881L3.50098 20.4994Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M10.4204 7.03688L8.95485 7.72622L9.73527 9.1456L8.14387 8.84114L7.94221 10.4488L6.83371 9.26635L5.72521 10.4488L5.52365 8.84114L3.93224 9.1455L4.71257 7.72617L3.24707 7.03688L4.71262 6.34749L3.93224 4.9282L5.52355 5.23256L5.72526 3.62494L6.83371 4.80736L7.94221 3.62494L8.14387 5.23256L9.73532 4.9282L8.9549 6.34753L10.4204 7.03688Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3737" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$l(H3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3738)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.8964 10.4353C23.5654 7.90475 22.4287 5.45947 20.4845 3.51533C18.5404 1.57119 16.095 0.434425 13.5645 0.103394L13.5645 10.4353H23.8964Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M10.4345 0.104065C7.9039 0.435096 5.45857 1.57182 3.51443 3.51596C1.57034 5.46014 0.43357 7.90547 0.102539 10.4361L10.4345 10.4361L10.4345 0.104065Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M0.102539 13.5664C0.43357 16.097 1.57034 18.5424 3.51443 20.4865C5.45857 22.4306 7.90385 23.5673 10.4345 23.8984L10.4345 13.5665L0.102539 13.5664Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M13.5645 23.8983C16.095 23.5673 18.5403 22.4306 20.4845 20.4864C22.4286 18.5423 23.5653 16.097 23.8964 13.5664H13.5645V23.8983Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M16.0961 7.61471C16.0961 7.45515 16.2258 7.32545 16.3854 7.32545H17.0053C17.9851 7.32545 18.7823 6.52829 18.7823 5.54846C18.7823 4.56863 17.9852 3.77143 17.0053 3.77143H16.4166C16.2245 3.6271 15.9667 3.53809 15.6824 3.53809C15.0892 3.53809 14.6084 3.9227 14.6084 4.39716C14.6084 4.86704 15.0801 5.24823 15.6652 5.25563L15.665 5.25906H17.0053C17.1649 5.25906 17.2946 5.38881 17.2946 5.54837C17.2946 5.70793 17.1649 5.83763 17.0053 5.83763H16.3854C15.4055 5.83763 14.6084 6.63479 14.6084 7.61462C14.6084 8.59445 15.4055 9.39165 16.3854 9.39165H18.7823V7.90393H16.3854C16.2258 7.90398 16.0961 7.77428 16.0961 7.61471Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.70442 7.61484C6.70442 7.45527 6.83413 7.32557 6.99373 7.32557H7.61361C8.59348 7.32557 9.39069 6.52841 9.39069 5.54858C9.39069 4.56876 8.59353 3.77155 7.61361 3.77155H7.02495C6.83281 3.62722 6.57505 3.53821 6.2907 3.53821C5.69759 3.53821 5.2168 3.92282 5.2168 4.39729C5.2168 4.86716 5.68841 5.24835 6.27359 5.25576L6.27331 5.25918H7.61366C7.77327 5.25918 7.90297 5.38893 7.90297 5.54849C7.90297 5.70805 7.77327 5.83776 7.61366 5.83776H6.99378C6.01391 5.83776 5.2168 6.63491 5.2168 7.61474C5.2168 8.59457 6.01386 9.39177 6.99378 9.39177H9.39064V7.90406H6.99373C6.83413 7.9041 6.70442 7.7744 6.70442 7.61484Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M16.0961 18.6859C16.0961 18.5264 16.2258 18.3967 16.3854 18.3967H17.0053C17.9852 18.3967 18.7824 17.5995 18.7824 16.6197C18.7824 15.6399 17.9852 14.8427 17.0053 14.8427H16.4167C16.2245 14.6983 15.9667 14.6093 15.6824 14.6093C15.0892 14.6093 14.6084 14.994 14.6084 15.4684C14.6084 15.9383 15.0801 16.3195 15.6652 16.3269L15.665 16.3303H17.0053C17.1649 16.3303 17.2946 16.46 17.2946 16.6196C17.2946 16.7792 17.1649 16.9089 17.0053 16.9089H16.3854C15.4055 16.9089 14.6084 17.706 14.6084 18.6858C14.6084 19.6657 15.4055 20.4629 16.3854 20.4629H18.7823V18.9752H16.3854C16.2258 18.9753 16.0961 18.8455 16.0961 18.6859Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.70447 18.6859C6.70447 18.5264 6.83417 18.3967 6.99378 18.3967H7.61365C8.59353 18.3967 9.39073 17.5995 9.39073 16.6197C9.39073 15.6399 8.59358 14.8427 7.61365 14.8427H7.025C6.83286 14.6983 6.57509 14.6093 6.29075 14.6093C5.69759 14.6093 5.2168 14.994 5.2168 15.4684C5.2168 15.9383 5.68841 16.3195 6.27359 16.3269L6.27331 16.3303H7.61365C7.77326 16.3303 7.90297 16.46 7.90297 16.6196C7.90297 16.7792 7.77326 16.9089 7.61365 16.9089H6.99378C6.01391 16.9089 5.2168 17.706 5.2168 18.6858C5.2168 19.6657 6.01386 20.4629 6.99378 20.4629H9.39068V18.9752H6.99378C6.83417 18.9753 6.70447 18.8455 6.70447 18.6859Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3738" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1c(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3739)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M12.0001 13.8637C10.002 13.8637 8.33275 12.4594 7.9232 10.5842C7.8603 10.8724 7.82617 11.1714 7.82617 11.4786C7.82617 13.7838 9.69484 15.6525 12.0001 15.6525C14.3053 15.6525 16.174 13.7838 16.174 11.4786C16.174 11.1714 16.1398 10.8724 16.0769 10.5841C15.6674 12.4594 13.9982 13.8637 12.0001 13.8637Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0002 8.34778L12.3887 9.54351H13.6461L12.6289 10.2825L13.0174 11.4782L12.0002 10.7392L10.9831 11.4782L11.3716 10.2825L10.3545 9.54351H11.6117L12.0002 8.34778Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3739" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$1b(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3740)" }, [
      createElementVNode("path", {
        d: "M1.45898 6.26037L11.9999 7.30386L22.5408 6.26037C20.5056 2.53025 16.5484 -0.000488281 11.9999 -0.000488281C7.45139 -0.000488281 3.49425 2.53025 1.45898 6.26037Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M1.45908 17.7384L12 18.7819L22.5409 17.7384C23.4711 16.0335 24 14.0782 24 11.9993L12 10.9558L0 11.9993C0 14.0782 0.528891 16.0335 1.45908 17.7384Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M1.45908 6.26099C0.528891 7.96588 0 9.92122 0 12.0001H24C24 9.92122 23.4711 7.96588 22.5409 6.26099H12H1.45908Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9999 23.9996C16.5484 23.9996 20.5056 21.4688 22.5408 17.7387H1.45898C3.49425 21.4688 7.45139 23.9996 11.9999 23.9996Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3740" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function e$2(f3, d3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("circle", {
      cx: "32",
      cy: "32",
      r: "30",
      fill: "#f5f5f5"
    }),
    createElementVNode("path", {
      d: "M17.8 21.2v-4.1h1.3l.9 3.1l.9-3.1h1.3v4.1h-.8v-3.3l-.9 3.3h-.9l-.9-3.3v3.3h-.9m6.9-3.3l-.6 1.7h1.2l-.6-1.7m-.5-.8h1l1.6 4.1h-.9l-.3-.8h-1.7l-.3.8h-.9l1.5-4.1m5 4.1h-.9v-1.5l-1.6-2.5h1.1l.9 1.8l.9-1.8h1l-1.4 2.5v1.5m2.5-2.1c0 .4.1.8.3 1c.2.2.5.4.9.4s.7-.1.9-.4c.2-.2.3-.6.3-1s-.1-.8-.3-1c-.2-.2-.5-.4-.9-.4s-.7.1-.9.4s-.3.6-.3 1m-.9 0c0-.7.2-1.2.6-1.6c.4-.4.9-.6 1.6-.6c.7 0 1.2.2 1.6.6c.4.4.6.9.6 1.6c0 .7-.2 1.2-.6 1.6c-.4.4-.9.6-1.6.6c-.7 0-1.2-.2-1.6-.6c-.4-.4-.6-.9-.6-1.6m5.9 2.1v-3.3h-1.3v-.7h3.5v.7h-1.3v3.3h-.9m3.6 0v-3.3H39v-.7h3.5v.7h-1.3v3.3h-.9m2.7 0v-4.1h3.2v.7h-2.3v.9H46v.7h-2.1v1h2.4v.8H43",
      fill: "#ed4c5c"
    }),
    createElementVNode("path", {
      d: "M22.7 44.7c-1.3.4-3.1 1.3-3.8 1.8c-.2.2-.2.4.1 1.1c.3.5.5.9.6.9c.1 0 .8-.3 1.6-.7c.8-.4 1.8-.9 2.3-1c.4-.1.7-.1.9-.2c.1.2 0 .1.2.4c.2.4.1.4.4.6c.4.1 1.3-.4 1.3-.4c1.1-.4 1.7-.4 5.7-.4s4.6 0 5.7.4c0 0 .9.3 1 .3c.1 0 .2.1.3 0c.1 0 .2-.2.3-.3c0 0 .2-.6.3-.8c.2.1.6.2 1 .4s1.4.6 2.2 1c.8.4 1.5.7 1.6.7c0 0 .3-.4.6-.9c.5-1 .6-.9-1.3-1.9c-2.5-1.3-4.9-1.9-5.2-1.2c0 .1-.1.2-.1.3c-.2-.1-.9-.2-1.5-.3c-2-.4-7.5-.4-9.5 0c-.6.1-1.1.3-1.5.4c-.2-.4-.2-.2-.2-.4c-.3-.4-1.4-.3-3 .2",
      fill: "#3e4347"
    }),
    createElementVNode("g", { fill: "#dfdfdf" }, [
      createElementVNode("path", { d: "M24.8 44.4c-.9 0-2.6.6-4.4 1.5c-1.5.7-1.5.8-1.1 1.6c.2.4.4.7.4.7c.1 0 .7-.3 1.5-.7c.8-.4 1.8-.8 2.3-1c.3-.1.6-.1.9-.2l-.2-.6c.2-.6.7-1.1 1.2-1.2c-.3 0-.4-.1-.6-.1" }),
      createElementVNode("path", { d: "M31.8 44.5c-1.8 0-3.5.1-4.3.2c-1.4.2-2.1.7-2.6.9c-.2.1-.3.2-.5.3c.2.4.2.6.3.9c.1.3.1.5.5.6c.4 0 1.2-.4 1.2-.4c1.1-.4 1.7-.4 5.7-.4s4.8.1 5.7.4c.7.2.9.4 1.2.4c.1 0 .2-.2.3-.5c.1-.3.3-.8.4-1.3c-.2 0-.1.1-.4-.1c-.6-.3-.7-.3-1.1-.5c-.5-.2-.9-.2-1.6-.3c-.8-.1-2.7-.2-4.5-.2h-.3" }),
      createElementVNode("path", { d: "M39.2 44.5h-.3c.2.1.4.3.5.4c.4.2.4.5.4.9c0 .2 0 .3-.1.5c.2.1.6.2.9.4c.4.1 1.4.6 2.3 1c.8.4 1.4.7 1.5.7c0 0 .2-.4.4-.7c.3-.5.3-.7.1-.9c-.5-.4-2.4-1.3-3.7-1.7c-1-.5-1.6-.6-2-.6" }),
      createElementVNode("path", { d: "M38.6 44.6c-.1.1-.1.2-.1.3c.1 0 .6.3.9.3h.1s-.1-.1-.3-.2c-.2-.1-.4-.3-.6-.4" }),
      createElementVNode("path", { d: "M25.4 44.6c-.1.1-.4.3-.5.4c-.3.2-.3.3-.4.6c0 0 .2-.2.7-.4c.4-.2.2-.1.5-.2c-.2-.2-.3-.2-.3-.4" })
    ]),
    createElementVNode("path", {
      d: "M26.1 24.8c-.5.2-.7.6-.8 1.1c0 .5.1.9.4 1.2l.3.3s-.1.2-.2.3c-.3.3-.5.7-.5 1.1c0 .4.1.7.5 1l.3.3l-.3.3c-.6.7-.6 1.4 0 2l.3.3h12.2l.3-.3c.6-.6.6-1.3 0-2l-.4-.4l.3-.3c.6-.7.6-1.4 0-2.1c-.3-.3-.3-.4-.1-.5c.4-.2.6-1 .4-1.5c-.2-.7-1.3-1.2-1.9-.9c-.1.1-.3.2-.5.4c-.2.1-.3.3-.4.3c0 0-.2-.1-.3-.3c-.6-.5-1.4-.5-2 .1l-.2.2l-.3-.3c-.6-.6-1.4-.6-2.1.1l-.2.2l-.3-.2c-.4-.4-.6-.5-1.1-.5c-.4 0-.8.2-1.1.5l-.2.2l-.3-.3c-.7-.6-1.2-.6-1.8-.3",
      fill: "#2a5f9e"
    }),
    createElementVNode("path", {
      d: "M25.7 33.1c-.6.7-.6 1.4 0 2.1l.2.3l-.3.3c-.1.2-.3.4-.4.5c-.2.5-.1 1.2.4 1.5c.2.2.3.3 0 .6c-.1.1-.2.3-.3.4c-.5.9.2 2.1 1.3 2.1c.4 0 .8-.1 1-.4c.2-.2.4-.3.6 0c.3.3.7.5 1 .5c.4 0 .6-.1 1-.5l.3-.3l.3.3c.6.6 1.2.7 2 .1l.3-.2l.3.3c.4.3.6.4 1 .4s.6-.1 1-.5l.3-.3l.3.2c.5.4.8.6 1.1.6c.4 0 .6-.1 1-.5c.4-.3.5-.7.5-1c0-.3-.3-.9-.6-1.1l-.2-.2l.3-.3c.6-.7.6-1.3 0-2.1l-.3-.3l.3-.3c.6-.7.6-1.4 0-2l-.3-.3H25.6l.1.1",
      fill: "#ed4c5c"
    }),
    createElementVNode("path", {
      d: "M24.4 32.2v8.4c0 .3.2.4.5.7c.5.4 1 .8 3.7.5c2.5 0 3 .2 3.3 1.2l.1.6l.1-.6c.2-1 .8-1.2 3.2-1.2c3.1 0 3.4-.1 3.8-.5c0 0 .3-.2.4-.5c.1-.3 0-.5 0-.5V23.7H24.4v8.5m15 .1v7c0 .9.1 1.2 0 1.4c-.1.2-.3.4-.3.4c-.5.5-.9.6-3 .5c-1.4 0-2.1 0-3.2.2c-.2.2-.6.1-.9 1c-.3-.9-.5-.9-.5-.9c-1.2-.5-1.7-.4-3.5-.4c-1.2.2-2.5-.1-3-.5c0 0-.1 0-.4-.4V23.8h14.8v8.5",
      fill: "#3e4347"
    }),
    createElementVNode("path", {
      d: "M30.9 29.4c.8.5 2.1.4 2.8-.4c.3-.3.4-.8.5-1c.1-.2.1-.3.1-.5c.1.2.2.3.2.7c.1.5 0 .9-.2 1.3c-.6 1.6-2.6 2.1-3.8.9c-.6-.5-1.1-1.6-.8-2.3c.1-.2.1-.4.2-.6c0 .2 0 .4.2.8c.2.5.5.8.8 1.1",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M29 35.7c0 .4 0 .6.1.8c-.2-.2-.4-.3-.6-.5c-.3-.2-.8-.4-.9-.1c-.1.2.3.5.6.7c.3.2.5.2.8.3c-.2.1-.4.2-.7.3c-.3.2-.7.5-.5.8c.2.2.6 0 .9-.2c.2-.1.5-.4.6-.5c0 .2-.1.5-.1.8c0 .4.1.8.4.8c.3 0 .4-.5.4-.9s0-.6-.1-.8c.1.1.3.3.6.5c.2.2.7.4.9.2c.2-.2-.1-.5-.5-.8c-.3-.2-.5-.3-.7-.4c.2-.1.4-.1.8-.3c.5-.3.7-.5.6-.8c-.1-.2-.4-.1-.9.2c-.2.2-.5.4-.6.5c0-.2.1-.6.1-.8c0-.4-.1-.9-.3-.9c-.8.2-.8.6-.9 1.1",
      fill: "#ffce31"
    }),
    createElementVNode("path", {
      d: "M29.8 36.9c0 .2-.2.4-.4.4s-.4-.2-.4-.4s.2-.4.4-.4s.4.2.4.4",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M34.3 35.7c0 .4 0 .6.1.8c-.2-.2-.4-.3-.6-.5c-.3-.2-.8-.4-.9-.1c-.1.2.3.5.6.7c.3.2.5.2.8.3c-.2.1-.4.2-.7.3c-.3.2-.7.5-.5.8c.2.2.6 0 .9-.2c.2-.1.5-.4.6-.5c0 .2-.1.5-.1.8c0 .4.1.8.3.8c.3 0 .4-.5.4-.9s0-.6-.1-.8c.1.1.3.3.6.5c.2.2.7.4.9.2c.2-.2-.1-.5-.5-.8c-.3-.2-.5-.3-.7-.4c.2-.1.4-.1.8-.3c.5-.3.7-.5.6-.8c-.1-.2-.4-.1-.9.2c-.2.2-.5.4-.6.5c0-.2.1-.6.1-.8c0-.4-.1-.9-.3-.9c-.8.2-.8.6-.8 1.1",
      fill: "#ffce31"
    }),
    createElementVNode("path", {
      d: "M35 36.9c0 .2-.2.4-.4.4s-.4-.2-.4-.4s.2-.4.4-.4s.4.2.4.4",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M23.4 34.7c-.4-1.8-1.4-3.2-2.7-4h1.1l1.5-.1l-1.3-.8c-.4-.2-1.4-1.1-1.4-1.8c0-.2 0-.4.4-.7l.9-.7l-1-.1l.4-1l-1.1.3l-.1-1l.4-.3l-.9-.8l-.8-.1l-.9.4l-.3-.8l-.5.8l-.6-.8l-.3 1.2l-.7-.4l-.2 1l-1-.8l.1 1.6l-1.5-.3l.4 1.2l-1.3-.1l1 1.9l-1.2.7l1.7 1.7v.5l-3.5-.8l2.1 2.1l-.6 2.1l2.4.2l-.9 1.8l2.9-.7l.7 1.9c-.1 0-.3-.1-.4-.1c-1.6 0-3 2.5-3 3.9s2.4 3.8 4.8 3.8c1 0 1.9-.4 2.7-1.2c2.5-2.4 3.5-6.2 2.7-9.7M18 36.4c.6.6 1.8 2 1.9 4.1c0 .7-.4 1.6-1.1 2.4c-.5.5-.9.7-1.1.7c-1.9-.4-2.9-1.2-2.8-2.4c.1-.9.7-1.5.9-1.5c.4 0 .4.1.4.5c0 .2.1.5.4.7l.2.1h.1c.4 0 .7-.3.9-.7c.2-.5.2-1.2-.4-1.8c-.2-.2-.4-.3-.6-.4l1.2-1.7",
      fill: "#3e4347"
    }),
    createElementVNode("path", {
      d: "M18.9 24.3l-1.3.5l-.1-.3l-.3.5l-.4-.5l-.2.8l-.7-.4l-.2 1.1l-.8-.6l.1 1.2l-1.4-.2l.3 1.1l-1.1-.1l.8 1.5l-1 .6l1.4 1.4l.1 1.3l-2.4-.6l1 1.1l-.5 1.8l2.5.2l-.8 1.6l2.3-.6l.6 1.6l1.1-1.5s2.4 1.6 2.5 4.8c0 1.8-1.9 3.8-2.8 3.6c-5-1-2.9-4.9-1.8-4.9c1.2 0 .8 1.1 1 1.2c.4.2.9-.8.2-1.6c-1.4-1.4-3.4 1.4-3.4 3.1c0 1.4 3.8 5.1 6.6 2.3c4.3-4.3 3.5-12.1-.9-13.4c-4.4-1.3-3.3-3.2-3.3-3.2c.5 3.2 5.6 2.8 5.6 2.8s-2.6-2-.9-3.5h-.5l.3-.6l-.7.2l-.1-.9l-.5.5l-.8-.2l-.2-.5l1.5-1l-.3-.2h-.5",
      fill: "#dfdfdf"
    }),
    createElementVNode("path", {
      d: "M43.4 44.5c.8.8 1.7 1.2 2.7 1.2c2.4 0 4.8-2.4 4.8-3.8c0-1.5-1.4-3.9-3-3.9c-.1 0-.3 0-.4.1l.7-1.9l2.9.7l-1-1.9l2.4-.2l-.5-2.1l2.1-2.1l-3.5.8v-.5l1.7-1.7l-1.2-.7l1-1.9l-1.3.1l.4-1.2l-1.5.3l.1-1.6l-1 .8l-.2-1l-.8.4l-.3-1.2l-.6.8l-.5-.8l-.3.8l-.9-.4l-.8.1l-.9.8l.4.3l-.1 1l-1.1-.3l.4 1l-1 .1l.9.7c.4.3.4.5.4.7c0 .7-1.1 1.5-1.4 1.8l-1.2.8l1.5.1h1.1c-1.3.8-2.2 2.2-2.7 4c-.9 3.5.1 7.3 2.7 9.8m3.8-6.5c-.2.1-.4.2-.6.4c-.6.6-.6 1.3-.4 1.8c.2.4.5.7.9.7h.1l.2-.1c.3-.1.4-.5.4-.7c0-.4.1-.5.4-.5c.2 0 .9.6.9 1.5c.1 1.2-.9 2-2.8 2.4c-.2 0-.7-.2-1.1-.7c-.7-.7-1.1-1.7-1.1-2.4c.1-2.1 1.3-3.5 1.9-4.1l1.2 1.7",
      fill: "#3e4347"
    }),
    createElementVNode("path", {
      d: "M45.1 24.3h-.5l-.2.2l1.5 1l-.3.5l-.8.2l-.5-.5l-.1.9l-.7-.2l.3.6h-.5c1.7 1.4-1.1 3.3-1.1 3.3s5.2.4 5.6-2.8c0 0 1.1 1.9-3.3 3.2c-4.4 1.4-5.2 9.1-.9 13.4c2.9 2.9 6.6-.9 6.6-2.3c0-1.7-2-4.4-3.4-3.1c-.7.7-.2 1.7.2 1.6c.2-.1-.1-1.2 1-1.2c1.2 0 3.3 3.9-1.8 4.9c-.9.2-2.9-1.8-2.8-3.6c.1-3.1 2.5-4.8 2.5-4.8l1.1 1.5l.6-1.6l2.3.6l-.8-1.6l2.5-.2l-.5-1.8l1-1.1l-2.4.6l.1-1.3l1.4-1.4l-1-.6l.8-1.5l-1.1.1l.3-1.1l-1.2.3l.1-1.2l-.8.6l-.2-1.1l-.7.4l-.2-.8l-.4.6l-.3-.5l-.1.3l-1.3-.5",
      fill: "#dfdfdf"
    })
  ]);
}
function p$1a(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3741)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9994 11.9997C23.9994 7.24218 21.2307 3.13143 17.2168 1.19043V22.8089C21.2307 20.868 23.9994 16.7572 23.9994 11.9997Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 11.9997C0 16.7572 2.76867 20.868 6.78262 22.809V1.19043C2.76867 3.13143 0 7.24218 0 11.9997Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M8.87012 11.9992C8.87012 13.7281 10.2717 15.1297 12.0006 15.1297C13.7295 15.1297 15.131 13.7281 15.131 11.9992V10.9557H8.87012V11.9992Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M16.1731 9.91336H13.0426C13.0426 9.33708 12.5754 8.86987 11.9991 8.86987C11.4229 8.86987 10.9557 9.33708 10.9557 9.91336H7.8252C7.8252 10.4897 8.32718 10.9568 8.90342 10.9568H8.86868C8.86868 11.5332 9.33584 12.0003 9.91217 12.0003C9.91217 12.5766 10.3793 13.0438 10.9557 13.0438H13.0426C13.619 13.0438 14.0861 12.5766 14.0861 12.0003C14.6624 12.0003 15.1296 11.5332 15.1296 10.9568H15.0948C15.6711 10.9568 16.1731 10.4897 16.1731 9.91336Z",
        fill: "#FF9811"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3741" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$19(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3742)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.001 5.21741L12.519 6.81172H14.1954L12.8392 7.79708L13.3572 9.39134L12.001 8.40603L10.6448 9.39134L11.1629 7.79708L9.80664 6.81172H11.483L12.001 5.21741Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.21777 11.9997L6.81209 11.4816V9.80518L7.79745 11.1615L9.39171 10.6434L8.4064 11.9997L9.39171 13.3558L7.79745 12.8377L6.81209 14.1939V12.5176L5.21777 11.9997Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0011 18.7829L11.4831 17.1886H9.80664L11.1629 16.2033L10.6449 14.609L12.0011 15.5943L13.3572 14.609L12.8392 16.2033L14.1954 17.1886H12.5191L12.0011 18.7829Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M18.7833 11.9995L17.189 12.5176V14.1939L16.2036 12.8377L14.6094 13.3557L15.5947 11.9995L14.6094 10.6434L16.2036 11.1615L17.189 9.80518V11.4816L18.7833 11.9995Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3742" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$18(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3667)" }, [
      createElementVNode("path", {
        d: "M17.2175 1.19133C15.6399 0.428485 13.87 0.000610352 12.0001 0.000610352C10.1303 0.000610352 8.36037 0.428485 6.78274 1.19133L5.73926 12.0006L6.78274 22.8099C8.36037 23.5727 10.1303 24.0006 12.0001 24.0006C13.87 24.0006 15.6399 23.5727 17.2175 22.8099L18.261 12.0006L17.2175 1.19133Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M6.78262 1.19214C2.76872 3.13309 0 7.24351 0 12.001C0 16.7585 2.76872 20.8689 6.78262 22.8099V1.19214Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M17.2178 1.19214V22.8099C21.2317 20.8689 24.0004 16.7585 24.0004 12.001C24.0004 7.24351 21.2317 3.13309 17.2178 1.19214Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.174 9.44228H13.3044C13.3044 8.72191 12.7204 8.13794 12.0001 8.13794C11.2797 8.13794 10.6957 8.72191 10.6957 9.44228H7.82617C7.82617 10.1515 8.44403 10.7265 9.1532 10.7265H9.11045C9.11045 11.4358 9.68542 12.0108 10.3947 12.0108C10.3947 12.6388 10.8458 13.1606 11.4415 13.2722L10.4294 15.5569C10.9143 15.754 11.4443 15.8636 12.0001 15.8636C12.5558 15.8636 13.0858 15.754 13.5707 15.5569L12.5587 13.2722C13.1544 13.1606 13.6054 12.6388 13.6054 12.0108C14.3147 12.0108 14.8897 11.4358 14.8897 10.7265H14.8469C15.5561 10.7265 16.174 10.1515 16.174 9.44228Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M12.0003 11.2178L10.3047 12.0004V13.5656L12.0003 14.6091L13.696 13.5656V12.0004L12.0003 11.2178Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M13.696 10.4341H10.3047V11.9993H13.696V10.4341Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3667" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function r$g(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3668)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3668" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$n(e28, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3669)" }, [
      createElementVNode("path", {
        d: "M11.9994 24.0006C13.4672 24.0006 14.8733 23.7366 16.1733 23.2542L16.695 12.0006L16.1733 0.747001C14.8733 0.264657 13.4672 0.000610352 11.9994 0.000610352C10.5315 0.000610352 9.12541 0.264657 7.82548 0.747001L7.30371 12.0006L7.82543 23.2542C9.12541 23.7366 10.5315 24.0006 11.9994 24.0006Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M0 12.0001C0 17.1596 3.2565 21.5582 7.82611 23.2537V0.74646C3.2565 2.44198 0 6.84049 0 12.0001Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M16.1738 0.745972V23.2532C20.7434 21.5577 23.9999 17.1592 23.9999 11.9996C23.9999 6.84 20.7434 2.44149 16.1738 0.745972Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M6.78274 11.9989H5.73926V16.1728H6.78274V11.9989Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M2.60891 11.9989H1.56543V16.1728H2.60891V11.9989Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M4.17434 14.6085C4.75064 14.6085 5.21783 14.1413 5.21783 13.565C5.21783 12.9887 4.75064 12.5215 4.17434 12.5215C3.59804 12.5215 3.13086 12.9887 3.13086 13.565C3.13086 14.1413 3.59804 14.6085 4.17434 14.6085Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M4.17406 10.4336C4.4622 10.4336 4.69578 10.2 4.69578 9.91185C4.69578 9.62372 4.4622 9.39014 4.17406 9.39014C3.88593 9.39014 3.65234 9.62372 3.65234 9.91185C3.65234 10.2 3.88593 10.4336 4.17406 10.4336Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.21783 15.1288H3.13086V16.1723H5.21783V15.1288Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.21783 10.9551H3.13086V11.9986H5.21783V10.9551Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M4.17458 6.26001L4.54414 7.3972H5.73983L4.77256 8.10004L5.14184 9.23723L4.17458 8.53439L3.20736 9.23723L3.57664 8.10004L2.60938 7.3972H3.80506L4.17458 6.26001Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3669" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function L$6(C3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3670)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M24 11.9997C24 7.88122 21.9249 4.24775 18.7635 2.08667H5.23655C2.07516 4.24775 0 7.88122 0 11.9997C0 16.1183 2.07516 19.7517 5.23655 21.9127H18.7635C21.9249 19.7517 24 16.1183 24 11.9997Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M9.3916 8.87015H14.609V6.78323L13.5655 7.30495L12.0003 5.73975L10.4351 7.30495L9.3916 6.78323V8.87015Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M16.6961 12.0003H14.0884C14.1907 11.8234 14.2501 11.6187 14.2501 11.3997C14.2501 10.7347 13.711 10.1957 13.0461 10.1957C12.5867 10.1957 12.1877 10.4531 11.9846 10.8314C11.7816 10.4531 11.3826 10.1957 10.9232 10.1957C10.2583 10.1957 9.71917 10.7347 9.71917 11.3997C9.71917 11.6188 9.7787 11.8235 9.88089 12.0003H7.30469C7.30469 12.7983 7.9997 13.4451 8.79761 13.4451H8.74952C8.74952 14.0996 9.18484 14.6523 9.7817 14.8298L8.60903 16.0026L9.7158 17.1093L11.2858 15.5393C11.3473 15.5619 11.4109 15.5799 11.4767 15.5923L10.528 17.7342C10.9826 17.9191 11.4794 18.0217 12.0004 18.0217C12.5214 18.0217 13.0182 17.9191 13.4729 17.7342L12.5242 15.5923C12.5899 15.5799 12.6535 15.5619 12.715 15.5393L14.285 17.1093L15.3917 16.0026L14.219 14.8298C14.8158 14.6522 15.2512 14.0997 15.2512 13.4451H15.203C16.001 13.4451 16.6961 12.7983 16.6961 12.0003Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0003 12.7828L10.3047 13.5654V15.1307L12.0003 16.1741L13.696 15.1307V13.5654L12.0003 12.7828Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M13.696 11.9991H10.3047V14.0861H13.696V11.9991Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3670" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$17(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3671)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 11.9997H11.9999C11.9999 11.9889 11.9999 11.9784 11.9999 11.9675C11.9892 11.9783 11.9785 11.989 11.9678 11.9997Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26123C12 4.14974 12 2.76623 12 0.000366211H11.998C5.37145 0.00149121 0 5.3736 0 12.0004H6.26086V8.47485L9.78637 12.0004H11.9679C11.9786 11.9897 11.9893 11.979 12 11.9683C12 11.1598 12 10.4384 12 9.78683L8.47443 6.26123H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.56543C4.19441 2.63413 2.63409 4.19441 1.56543 6.07124V12.0002H4.69588V4.69598V4.69588H12.0002C12.0002 3.70856 12.0002 2.76796 12.0002 1.56543H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0009 10.5242L7.73734 6.26074H6.26172V6.26084L12.0008 11.9998H12.0009C12.0009 11.9998 12.0009 10.9823 12.0009 10.5242Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.5654 6.2605V11.9996C13.5654 14.7952 17.2176 15.6518 17.2176 15.6518C17.2176 15.6518 20.8698 14.7952 20.8698 11.9996V6.2605H13.5654Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M13.5654 11.9991C13.5654 14.7948 17.2176 15.6514 17.2176 15.6514C17.2176 15.6514 20.8698 14.7948 20.8698 11.9991H13.5654Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M18.7828 8.86909H17.7393V7.82556H16.6958V8.86909H15.6523V9.91253H16.6958V13.0429H17.7393V9.91253H18.7828V8.86909Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3671" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$k(l3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3672)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M19.0924 9.84775H13.6749L12.0008 4.69543L10.3267 9.84775H4.90918L9.29204 13.0321L7.6179 18.1845L12.0008 15.0002L16.3837 18.1846L14.7096 13.0321L19.0924 9.84775ZM10.5187 12.6335L11.0848 10.8912H12.9167L13.4829 12.6335V12.6335L12.0008 13.7103L10.5188 12.6335L10.5187 12.6335ZM12.5777 9.84775H11.4239L12.0008 8.07212L12.5777 9.84775ZM14.3705 11.9886L14.0139 10.8912H15.8809L14.3705 11.9886ZM9.98766 10.8912L9.63109 11.9886L8.12063 10.8912H9.98766ZM9.60273 15.4526L10.1797 13.6771L11.1132 14.3552L9.60273 15.4526ZM12.8884 14.3553L13.8219 13.6771L14.3989 15.4527L12.8884 14.3553Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3672" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$m(i, L3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3673)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.48568 16.6959L3.51465 20.4852C5.68609 22.6569 8.68576 24.0003 11.9995 24.0003C16.9603 24.0003 21.2172 20.9895 23.0447 16.6959H6.48568Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.0634 7.34841C21.2461 3.03164 16.9771 0.000610352 11.9995 0.000610352C8.68576 0.000610352 5.68609 1.344 3.51465 3.51572L6.51981 7.34841H23.0634Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M2.6084 8.82593V15.1302H23.5864C23.8555 14.1322 23.9997 13.083 23.9997 11.9998C23.9997 10.901 23.8517 9.83693 23.575 8.82593H2.6084Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51428C-1.17157 8.20056 -1.17157 15.7986 3.51471 20.4849C5.45126 18.5484 7.31374 16.6859 12 11.9996L3.51471 3.51428Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M4.85694 8.86938L5.6339 11.2608H8.14855L6.11427 12.7388L6.89118 15.1303L4.85694 13.6523L2.82262 15.1303L3.59971 12.7388L1.56543 11.2608H4.0799L4.85694 8.86938Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M7.13101 11.9991H2.58301V14.0861H7.13101V11.9991Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.99252 9.60729L7.25466 8.86938L4.8571 11.2669L2.45954 8.86938L1.72168 9.60729L4.12135 12.0027L1.72168 14.4024L2.45954 15.1303L4.8571 12.737L7.25466 15.1303L7.99252 14.4024L5.59285 12.0027L7.99252 9.60729Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3673" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$16(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3675)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M3.51451 20.4849C4.0179 20.9883 4.55499 21.4372 5.11838 21.8325L21.8326 5.11826C21.4374 4.55487 20.9884 4.01778 20.485 3.51439C19.9816 3.011 19.4445 2.56212 18.8811 2.16687L2.16699 18.8811C2.5622 19.4444 3.01112 19.9815 3.51451 20.4849Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M3.51526 3.51478C-0.270555 7.30059 -0.997306 12.9862 1.33346 17.5022L17.5026 1.33307C12.9866 -0.997692 7.30098 -0.270848 3.51526 3.51478Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M20.4854 20.4847C24.2711 16.699 24.9979 11.0134 22.6672 6.49731L6.49805 22.6665C11.014 24.9972 16.6996 24.2705 20.4854 20.4847Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M9.91356 6.78182L8.56891 7.41431L9.28497 8.71659L7.82486 8.43731L7.6398 9.91223L6.6228 8.8274L5.60575 9.91223L5.42078 8.43731L3.96063 8.71654L4.67664 7.41426L3.33203 6.78182L4.67669 6.14929L3.96063 4.8471L5.42073 5.12638L5.6058 3.65137L6.6228 4.73624L7.63984 3.65137L7.82486 5.12638L9.28497 4.8471L8.569 6.14934L9.91356 6.78182Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3675" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$15(i, L3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3676)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0012 -0.000488281C5.72536 -0.000488281 0.575766 4.81737 0.046875 10.956H23.9555C23.4266 4.81737 18.277 -0.000488281 12.0012 -0.000488281Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0002 24.0001C18.276 24.0001 23.4256 19.1822 23.9545 13.0436H0.0458984C0.574789 19.1822 5.72438 24.0001 12.0002 24.0001Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M9.91361 16.1745L8.56895 16.807L9.28497 18.1092L7.82486 17.8299L7.63984 19.3049L6.6228 18.2201L5.6058 19.3049L5.42078 17.8299L3.96063 18.1092L4.67669 16.807L3.33203 16.1745L4.67673 15.542L3.96063 14.2398L5.42073 14.5191L5.60584 13.0441L6.6228 14.1289L7.63989 13.0441L7.82486 14.5191L9.28502 14.2398L8.569 15.542L9.91361 16.1745Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3676" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$14(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3677)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9292 13.3041C23.9292 13.304 23.9293 13.3039 23.9293 13.3037L10.7693 0.0621338C10.1757 0.122649 9.59475 0.226431 9.02986 0.37029C3.83897 1.69193 0 11.9997 0 11.9997C0 11.9997 16.7999 23.242 18.7165 21.9449C19.1 21.6854 19.4677 21.4043 19.8177 21.1034L12.0185 13.3041H23.9292Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M20.8695 11.9995L9.19899 0.328979C3.92288 1.59071 0 6.33662 0 11.9995C0 18.6269 5.37263 23.9995 12 23.9995C14.5139 23.9995 16.8467 23.226 18.7748 21.9047L8.86955 11.9995H20.8695Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.4126 17.7174L9.94704 17.028L10.7275 15.6087L9.13605 15.9131L8.9344 14.3054L7.82595 15.4878L6.71749 14.3054L6.51579 15.9131L4.92443 15.6086L5.70485 17.028L4.23926 17.7174L5.70485 18.4067L4.92443 19.826L6.51588 19.5216L6.71745 21.1292L7.82595 19.9468L8.9344 21.1292L9.13605 19.5216L10.7274 19.8261L9.94699 18.4067L11.4126 17.7174Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.4342 6.6549L9.36828 6.15357L9.93589 5.12124L8.77841 5.34268L8.63174 4.17334L7.82553 5.03335L7.01933 4.17334L6.87261 5.34268L5.71512 5.12124L6.28278 6.15357L5.2168 6.6549L7.82553 7.17671L10.4342 6.6549Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.9572 6.65527C10.9572 8.38416 9.55563 9.78572 7.82674 9.78572C6.09785 9.78572 4.69629 8.38416 4.69629 6.65527",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3677" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$13(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3678)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000488281C6.84013 -0.000488281 2.44161 3.25601 0.746094 7.82562H23.2534C21.5578 3.25601 17.1593 -0.000488281 11.9997 -0.000488281Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0004C17.1593 24.0004 21.5578 20.7439 23.2533 16.1743H0.746094C2.44161 20.7439 6.84012 24.0004 11.9997 24.0004Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3678" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$j(s3, l3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      d: "M32 62c13.1 0 24.2-8.3 28.3-20H3.7C7.8 53.7 18.9 62 32 62z",
      fill: "#83bf4f"
    }),
    createElementVNode("path", {
      d: "M32 2C18.9 2 7.8 10.4 3.7 22h56.6C56.2 10.4 45.1 2 32 2z",
      fill: "#2a5f9e"
    }),
    createElementVNode("path", {
      d: "M60.3 42c1.1-3.1 1.7-6.5 1.7-10s-.6-6.9-1.7-10H3.7C2.6 25.1 2 28.5 2 32s.6 6.9 1.7 10h56.6z",
      fill: "#ed4c5c"
    }),
    createElementVNode("circle", {
      cx: "24",
      cy: "32",
      r: "17.7",
      fill: "#ffe62e"
    }),
    createElementVNode("path", {
      d: "M24 14c-9.9 0-18 8.1-18 18s8.1 18 18 18s18-8.1 18-18s-8.1-18-18-18M6.6 32c0-9.5 7.6-17.2 17-17.4v3.9c-1.1.5-1.9.9-2.1 1.9c0 .1-.1 1.4-.1 1.8c0 0 .2 0 .6-.3c.2-.2.8-.3 1.6-.7v2c-1.2.2-2 1.2-2 2.4s.9 2.2 2 2.4v.5c-.9 0-1.7-.3-2.4-1.7c-.4-.8-1.4-2-1.4-2s.5 1.3.5 2.7c.1 2 1.9 2.2 3.2 2.2v.4H21v.7h2.6v.4c-1.2.1-2 .7-2 1.5s.9 1.4 2 1.5v.4H21v.4h2.6v.4c-2 .1-3 .9-3.1 2.1c-.2 2.5-.7 4.5-.7 4.5s.8-.9 1.6-3.1c.4-1 1.3-1.6 2.2-1.8v.3c-.9.2-1.6 1.4-1.6 2.8s.7 2.6 1.6 2.8v.8c-1.2 0-2.4.3-3 .8c-.8.7-2.8 2.6-3.6 3.4c-6.1-2.7-10.4-8.8-10.4-16m24 16.1c-.7-.8-2.5-2.7-3.6-3.5c-.6-.5-1.6-.7-2.6-.8V43c.9-.2 1.6-1.4 1.6-2.8s-.7-2.6-1.6-2.8v-.3c.9.1 1.8.8 2.2 1.8c.9 2.2 1.6 3.1 1.6 3.1s-.5-2-.7-4.5c-.1-1.2-1.1-2-3.1-2.1V35H27v-.7h-2.6v-.4c1.2-.1 2-.7 2-1.5s-.9-1.4-2-1.5v-.4H27v-.7h-2.6v-.4c1.4 0 3.1-.2 3.2-2.2c.1-1.4.5-2.7.5-2.7s-1 1.2-1.4 2c-.7 1.4-1.5 1.7-2.4 1.7v-.5c1.2-.2 2-1.2 2-2.4s-.9-2.2-2-2.4v-2.5c.7-.6 1.5-1.5 2.3-2.9c.4-.8.2-1.1.2-1.1s0 .1-.3.3c-.7.6-1.5 1-2.2 1.4v-3.5c9.4.2 17 7.9 17 17.4c.1 7.3-4.4 13.5-10.7 16.1",
      fill: "#3e4347"
    })
  ]);
}
function p$12(i, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3679)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 12.0004H11.9999C11.9999 11.9896 11.9999 11.9791 11.9999 11.9683C11.9892 11.979 11.9785 11.9897 11.9678 12.0004Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.3715 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78642 12H11.9679C11.9786 11.9893 11.9894 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.56494C4.19441 2.63364 2.63413 4.19393 1.56543 6.07075V11.9997H4.69588V4.69549V4.69539H12.0002C12.0002 3.70807 12.0002 2.76747 12.0002 1.56494H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0008 10.5247L7.73739 6.26123C7.73739 6.26123 6.26172 6.26132 6.26172 6.26123V6.26132L12.0008 12.0003H12.0008C12.0008 12.0003 12.0008 10.9828 12.0008 10.5247Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.7808 8.90466L21.0398 9.70182H21.878L21.1999 10.1945L21.4589 10.9916L20.7808 10.499L20.1027 10.9916L20.3617 10.1945L19.6836 9.70182H20.5218L20.7808 8.90466Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M17.7854 14.6436L18.174 15.8393H19.4312L18.414 16.5783L18.8026 17.774L17.7854 17.035L16.7682 17.774L17.1568 16.5783L16.1396 15.8393H17.3969L17.7854 14.6436Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M17.8988 5.25183L18.2226 6.24834H19.2703L18.4226 6.86405L18.7464 7.86051L17.8988 7.24463L17.0512 7.86051L17.3749 6.86405L16.5273 6.24834H17.575L17.8988 5.25183Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.0149 8.86987L15.4034 10.0657H16.6607L15.6435 10.8046L16.0321 12.0003L15.0149 11.2613L13.9977 12.0003L14.3863 10.8046L13.3691 10.0657H14.6264L15.0149 8.86987Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3679" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$d(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3680)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 -0.000244141C7.24316 -0.000244141 3.13241 2.76843 1.19141 6.78238H22.8099C20.869 2.76843 16.7582 -0.000244141 12.0007 -0.000244141Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.0007 24.001C16.7582 24.001 20.869 21.2323 22.81 17.2184H1.19141C3.13241 21.2323 7.24316 24.001 12.0007 24.001Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M11.9998 8.34766C9.9828 8.34766 8.34766 9.9828 8.34766 11.9998C8.34766 14.0169 9.9828 15.652 11.9998 15.652C14.0169 15.652 15.652 14.0169 15.652 11.9998C15.652 9.9828 14.0169 8.34766 11.9998 8.34766ZM11.9998 14.0868C10.8473 14.0868 9.91286 13.1525 9.91286 11.9998C9.91286 10.8472 10.8472 9.91286 11.9998 9.91286C13.1524 9.91286 14.0868 10.8472 14.0868 11.9998C14.0868 13.1525 13.1524 14.0868 11.9998 14.0868Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M13.8071 12.5222L11.9997 12.0005L10.1923 12.5222L9.58984 13.5657H14.4095L13.8071 12.5222Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9998 9.39136L10.7949 11.4783L11.9998 12L13.2048 11.4783L11.9998 9.39136Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M10.1924 12.5211H13.8072L13.2047 11.4777H10.7949L10.1924 12.5211Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3680" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$11(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3681)" }, [
      createElementVNode("path", {
        d: "M1.19072 6.78213C0.427875 8.35976 0 10.1296 0 11.9995C0 13.8694 0.427875 15.6393 1.19072 17.2169L12 18.2604L22.8093 17.2169C23.5721 15.6393 24 13.8694 24 11.9995C24 10.1296 23.5721 8.35976 22.8093 6.78213L12 5.73865L1.19072 6.78213Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.19043 17.2183C3.13134 21.2322 7.24176 24.0009 11.9993 24.0009C16.7568 24.0009 20.8672 21.2322 22.8081 17.2183H1.19043Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M1.19043 6.78238H22.8081C20.8672 2.76843 16.7568 -0.000244141 11.9993 -0.000244141C7.24181 -0.000244141 3.13134 2.76843 1.19043 6.78238Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M11.9991 16.1742C14.3043 16.1742 16.173 14.3055 16.173 12.0003C16.173 9.69513 14.3043 7.82642 11.9991 7.82642C9.69391 7.82642 7.8252 9.69513 7.8252 12.0003C7.8252 14.3055 9.69391 16.1742 11.9991 16.1742Z",
        fill: "#FF9811"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3681" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$10(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3682)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 12.0003C0 17.1599 3.2565 21.5584 7.82611 23.2539V0.746704C3.2565 2.44217 0 6.84074 0 12.0003Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M23.9999 12.0003C23.9999 6.84074 20.7434 2.44217 16.1738 0.746704V23.254C20.7434 21.5584 23.9999 17.1599 23.9999 12.0003Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3682" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$$(i, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3683)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0001 5.7395V9.78683L7.82617 5.7395H12.0001Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M6.26098 12.0002H9.78649L6.26098 7.30457L5.73926 10.9567L6.26098 12.0002Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9688 12.0007H12.0009C12.0009 11.9899 12.0009 11.9794 12.0009 11.9685C11.9902 11.9793 11.9795 11.99 11.9688 12.0007Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.37145 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78637 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9989 10.5247L7.73539 6.26123H6.25977V6.26132L11.9988 12.0003H11.9989C11.9989 12.0003 11.9989 10.9828 11.9989 10.5247Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.07027 1.56494C5.60766 1.82838 5.16445 2.12196 4.74295 2.44244H5.23533L3.93398 3.3881L4.43095 4.91796L3.12961 3.97249L2.99114 4.07313C2.45081 4.68672 1.97175 5.35554 1.56445 6.07075V11.9997H4.69491V4.69549V4.69539H11.9993C11.9993 3.70807 11.9993 2.76747 11.9993 1.56494H6.07027Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M5.12601 2.16431C4.99659 2.25492 4.86899 2.34806 4.74332 2.44363L3.93449 3.38929L3.13012 3.97363L2.99048 4.07507C2.69582 4.40976 2.41949 4.76095 2.16309 5.12718C2.45535 5.26903 2.78343 5.34876 3.13012 5.34876C4.35477 5.34876 5.34749 4.35604 5.34749 3.13138C5.34759 2.7846 5.2679 2.45662 5.12601 2.16431Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M2.99023 4.07382L3.12987 3.97238L4.43122 4.9179L3.9342 3.38804L5.23545 2.44238H4.74299C4.10577 2.92702 3.51856 3.47377 2.99023 4.07382Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M8.29451 2.0874L8.55354 2.88451H9.39167L8.71362 3.37721L8.97251 4.17432L8.29451 3.68167L7.61647 4.17432L7.87531 3.37721L7.19727 2.88451H8.03544L8.29451 2.0874Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.13041 7.30518L3.38944 8.10228H4.22756L3.54956 8.59504L3.80845 9.39215L3.13041 8.89944L2.45231 9.39215L2.7112 8.59504L2.0332 8.10228H2.87133L3.13041 7.30518Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3683" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$_(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3743)" }, [
      createElementVNode("path", {
        d: "M17.2165 1.19047C15.6389 0.427631 13.869 -0.000244141 11.9991 -0.000244141C10.1292 -0.000244141 8.35939 0.427631 6.78176 1.19047L5.73828 11.9998L6.78176 22.809C8.35939 23.5719 10.1292 23.9998 11.9991 23.9998C13.869 23.9998 15.6389 23.5719 17.2165 22.809L18.26 11.9998L17.2165 1.19047Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.78262 1.19122C2.76867 3.13213 0 7.24255 0 12.0001C0 16.7576 2.76867 20.868 6.78262 22.8089V1.19122Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M17.2168 1.19122V22.8089C21.2307 20.868 23.9994 16.7576 23.9994 12.0001C23.9994 7.2426 21.2307 3.13213 17.2168 1.19122Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M15.131 15.6516L12.0006 5.73859L8.87012 15.6516H11.2179V18.2603H12.7832V15.6516H15.131Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3743" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$Z(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3744)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9999 -0.000244141C8.36285 -0.000244141 5.10396 1.61807 2.90332 4.17365H21.0965C18.8959 1.61807 15.637 -0.000244141 11.9999 -0.000244141Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M21.0965 19.827H2.90332C5.10396 22.3825 8.36285 24.0009 11.9999 24.0009C15.637 24.0009 18.8959 22.3825 21.0965 19.827Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M22.2387 5.73859H1.76128C0.644297 7.56132 0 9.70506 0 11.9994C0 14.2938 0.644297 16.4376 1.76128 18.2603H22.2387C23.3557 16.4376 24 14.2938 24 11.9994C24 9.70506 23.3557 7.56132 22.2387 5.73859Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.383 16.6182C9.9331 16.6182 12.0004 14.551 12.0004 12.0009C12.0004 9.45076 9.9331 7.38348 7.383 7.38348C4.83289 7.38348 2.76562 9.45076 2.76562 12.0009C2.76562 14.551 4.83289 16.6182 7.383 16.6182Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.38279 7.38348L8.41877 10.572H11.7768L9.05913 12.5427L10.1032 15.7407L7.38279 13.7606L4.66648 15.737L5.70645 12.5427L2.99121 10.572H6.34676L7.38279 7.38348Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3744" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$Y(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3745)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M11.6216 19.5561C11.2981 19.5405 11.0304 19.3302 10.9256 19.0448C10.7404 19.2864 10.4221 19.408 10.1085 19.3271C9.79442 19.2462 9.57482 18.9864 9.52939 18.6848C9.29877 18.8841 8.96277 18.9383 8.67219 18.796C8.38105 18.653 8.2183 18.354 8.23499 18.0498C7.96944 18.199 7.62927 18.1844 7.3731 17.9861C7.11744 17.7879 7.01778 17.4628 7.09499 17.168C6.80488 17.2609 6.47516 17.1785 6.26385 16.9327C6.05253 16.6875 6.02014 16.3489 6.15482 16.076C5.85219 16.1083 5.54544 15.9612 5.38785 15.6785C5.22974 15.3957 5.2663 15.0571 5.45357 14.8165C5.15043 14.7873 4.87911 14.5812 4.78208 14.2723C4.68453 13.9635 4.78888 13.639 5.02105 13.4412C4.72991 13.3514 4.5066 13.0947 4.47374 12.7728C4.44088 12.451 4.60785 12.1551 4.87442 12.008C4.6078 11.8619 4.4398 11.5661 4.47163 11.2447C4.47163 11.2447 4.47163 11.2447 4.47214 11.2447C4.50397 10.9222 4.72728 10.6651 5.01786 10.5742C4.78569 10.377 4.68032 10.053 4.77683 9.74411C4.87335 9.43474 5.1441 9.22811 5.44728 9.19783C5.25997 8.95783 5.22243 8.61916 5.37946 8.33594C5.53649 8.05315 5.84328 7.90549 6.14643 7.93732C6.01077 7.66446 6.0426 7.32583 6.25339 7.0796C6.46367 6.83388 6.79339 6.75091 7.08402 6.84274C7.00574 6.54846 7.10488 6.22291 7.36053 6.02416C7.61567 5.82532 7.95585 5.81018 8.22139 5.95835C8.20419 5.65422 8.36642 5.35521 8.65705 5.21172C8.94716 5.06875 9.28368 5.122 9.51477 5.32127C9.55911 5.01977 9.77877 4.75891 10.0923 4.67744C10.4053 4.59607 10.7236 4.71658 10.9093 4.95761C11.0142 4.67224 11.2813 4.46144 11.6048 4.44527C11.9278 4.42863 12.2147 4.61013 12.3483 4.88308C12.508 4.62429 12.8116 4.47091 13.1315 4.51943C13.4518 4.56743 13.6976 4.80321 13.7737 5.09805C13.9824 4.87572 14.3111 4.7876 14.6148 4.89921C14.9189 5.01138 15.112 5.29207 15.1266 5.59675C15.3755 5.42149 15.7156 5.4011 15.9906 5.57224C16.2656 5.74286 16.3976 6.05641 16.3506 6.35744C16.6297 6.2359 16.9668 6.28441 17.2016 6.50664C17.4364 6.72944 17.5031 7.06282 17.3967 7.34819C17.6946 7.28505 18.015 7.39985 18.2007 7.66539C18.3864 7.93043 18.3849 8.2706 18.2237 8.52888C18.5278 8.52677 18.8185 8.70419 18.9473 9.00105C19.0757 9.29843 19.0052 9.63185 18.795 9.85254C19.094 9.91202 19.3428 10.1442 19.4085 10.4614C19.4737 10.7786 19.3376 11.0901 19.0877 11.2638C19.3673 11.3823 19.5645 11.6593 19.5651 11.9828C19.5651 11.9864 19.5651 11.9896 19.5651 11.9933C19.5651 11.9954 19.5651 11.998 19.5651 12.0001C19.5651 12.3235 19.3689 12.6011 19.0892 12.7206C19.3397 12.8933 19.4769 13.2048 19.4117 13.522C19.347 13.8392 19.0986 14.0719 18.7997 14.1324C19.0105 14.3526 19.082 14.6854 18.9541 14.9834C18.8263 15.2808 18.5357 15.4587 18.231 15.4571C18.3927 15.7154 18.3953 16.0556 18.2101 16.3211C18.0249 16.5867 17.7051 16.7025 17.4072 16.6399C17.5141 16.9248 17.4478 17.2587 17.2136 17.482C16.9788 17.7048 16.6423 17.7538 16.3632 17.6333C16.4106 17.9338 16.2792 18.2479 16.0047 18.4196C15.7303 18.5913 15.3901 18.5714 15.1407 18.3966C15.1266 18.7013 14.9346 18.9826 14.631 19.0953C14.631 19.0953 14.631 19.0953 14.6305 19.0953C14.3268 19.2074 13.9981 19.1198 13.7889 18.8981C13.7138 19.1934 13.4686 19.4297 13.1482 19.4788C12.8284 19.5273 12.5242 19.375 12.3641 19.1162C12.2368 19.3786 11.9676 19.557 11.6608 19.557C11.6477 19.5572 11.6346 19.5567 11.6216 19.5561Z",
        fill: "#F3F3F3"
      }),
      createElementVNode("path", {
        d: "M12.0006 17.2183C14.8821 17.2183 17.218 14.8824 17.218 12.0009C17.218 9.11941 14.8821 6.78351 12.0006 6.78351C9.1191 6.78351 6.7832 9.11941 6.7832 12.0009C6.7832 14.8824 9.1191 17.2183 12.0006 17.2183Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M13.142 10.2289C13.3983 10.0388 13.5652 9.73488 13.5652 9.39119V8.86947C13.5652 8.29315 13.0981 7.82599 12.5217 7.82599H11.4783C10.902 7.82599 10.4348 8.29315 10.4348 8.86947V9.39119C10.4348 9.73488 10.6017 10.0388 10.858 10.2289L9.91309 19.8259C9.91309 19.8259 10.4348 20.3478 12.0001 20.3478C13.5653 20.3478 14.087 19.8259 14.087 19.8259L13.142 10.2289Z",
        fill: "#BDBCC1"
      }),
      createElementVNode("path", {
        d: "M12.0002 7.82599L12.9067 10.6159H15.8404L13.4671 12.3403L14.3735 15.1303L12.0002 13.406L9.62687 15.1303L10.5335 12.3403L8.16016 10.6159H11.0937L12.0002 7.82599Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3745" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$X(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3746)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0.413086 15.131C1.1074 17.7072 2.63763 19.94 4.69535 21.5211V15.131H0.413086Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M10.9561 23.9549C11.3 23.9845 11.6479 24.0005 11.9995 24.0005C17.5439 24.0005 22.2091 20.2402 23.5861 15.131H10.9561V23.9549Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.5861 8.87004C22.2091 3.76085 17.5439 0.000488281 11.9995 0.000488281C11.6479 0.000488281 11.3 0.0165195 10.9561 0.0461445V8.87004H23.5861Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.69535 2.48029C2.63763 4.06138 1.1074 6.29418 0.413086 8.87038H4.69535V2.48029Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4343H9.39136H9.39131V0.284729C8.28234 0.530635 7.23098 0.929213 6.26086 1.45857V10.4342V10.4342H0.101578C0.0347813 10.9466 0 11.469 0 11.9995C0 12.53 0.0347813 13.0524 0.101578 13.5647H6.26081H6.26086V22.5404C7.23098 23.0697 8.28234 23.4684 9.39131 23.7142V13.5648V13.5647H23.8984C23.9651 13.0524 24 12.53 24 11.9995C24 11.469 23.9651 10.9466 23.8984 10.4343Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3746" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$c(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3747)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 12.0005C0 16.549 2.53078 20.5062 6.26086 22.5414V1.45959C2.53078 3.49481 0 7.452 0 12.0005Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.2537 16.1752C23.736 14.8752 24 13.4691 24 12.0013C24 10.5334 23.736 9.12733 23.2537 7.82739H0.746438C0.264047 9.12733 0 10.5334 0 12.0013C0 13.4691 0.264047 14.8752 0.746438 16.1752L12 17.2187L23.2537 16.1752Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0006 23.9997C17.1603 23.9997 21.5587 20.7432 23.2543 16.1736H0.74707C2.44254 20.7432 6.8411 23.9997 12.0006 23.9997Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M0 11.9996C0 17.544 3.76036 22.2092 8.86955 23.5862V0.413025C3.76036 1.79002 0 6.45531 0 11.9996Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.34159 5.28157L6.23483 4.1748L5.49701 4.91271L4.7592 4.1748L3.65244 5.28157L4.3903 6.01943L3.65234 6.75734L4.75911 7.8641L5.49697 7.1262L6.23483 7.8641L7.34159 6.75734L6.60373 6.01943L7.34159 5.28157Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3747" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$W(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3748)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 12.0002C0 16.5487 2.53074 20.5059 6.26086 22.5411V1.45929C2.53074 3.49455 0 7.4517 0 12.0002Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9999 0.000793457C9.92098 0.000793457 7.96563 0.529684 6.26074 1.45987V22.5417C7.96563 23.4719 9.92098 24.0008 11.9999 24.0008C18.6273 24.0008 23.9999 18.6282 23.9999 12.0008C23.9999 5.37342 18.6273 0.000793457 11.9999 0.000793457Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M17.1307 13.9861C15.6126 15.083 13.4926 14.7415 12.3957 13.2234C11.2987 11.7053 11.6402 9.58533 13.1584 8.48846C13.6317 8.14646 14.1636 7.94428 14.7046 7.87402C13.6637 7.71835 12.5633 7.95291 11.6428 8.61802C9.77437 9.96811 9.35404 12.5772 10.7041 14.4458C12.0541 16.3142 14.6633 16.7345 16.5318 15.3843C17.4524 14.7192 18.0206 13.7483 18.1995 12.711C17.963 13.2025 17.6041 13.644 17.1307 13.9861Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M17.0659 7.82721L17.9211 8.74882L19.0618 8.22044L18.4495 9.31844L19.3047 10.2401L18.0711 9.9971L17.4588 11.0952L17.3088 9.84691L16.0752 9.60386L17.216 9.07549L17.0659 7.82721Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3748" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function r$f(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3749)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M9.3912 17.2183C12.2727 17.2183 14.6086 14.8824 14.6086 12.0009C14.6086 9.11941 12.2727 6.78351 9.3912 6.78351C6.50973 6.78351 4.17383 9.11941 4.17383 12.0009C4.17383 14.8824 6.50973 17.2183 9.3912 17.2183Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3749" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$V(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3750)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.30388 7.82696H23.2531C21.5576 3.25735 17.1591 0.000854492 11.9995 0.000854492C8.68576 0.000854492 5.68609 1.34424 3.51465 3.51596L7.30388 7.82696Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M7.30388 16.1736H23.2531C21.5576 20.7432 17.1591 23.9997 11.9995 23.9997C8.68576 23.9997 5.68609 22.6563 3.51465 20.4846L7.30388 16.1736Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51489C-1.17157 8.20117 -1.17157 15.7992 3.51471 20.4855C5.45126 18.549 7.31375 16.6865 12 12.0002L3.51471 3.51489Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3750" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$U(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3751)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 11.9998C0 18.6271 5.37262 23.9998 12 23.9998C12 19.4362 12 11.9998 12 11.9998C12 11.9998 4.17389 11.9998 0 11.9998Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12 0.000854492C18.6274 0.000854492 24 5.37348 24 12.0009C19.4365 12.0009 12 12.0009 12 12.0009C12 12.0009 12 4.17475 12 0.000854492Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.1441 4.1748L7.92115 6.56627H10.4357L8.40138 8.04424L9.17838 10.4357L7.1441 8.9577L5.10982 10.4357L5.88682 8.04424L3.85254 6.56627H6.36705L7.1441 4.1748Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M16.857 13.5647L17.634 15.9562H20.1486L18.1142 17.4341L18.8913 19.8256L16.857 18.3476L14.8227 19.8256L15.5997 17.4341L13.5654 15.9562H16.0799L16.857 13.5647Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3751" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$l(e28, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      d: "M32 62c9.8 0 18.5-4.7 24-12L8 14c-3.8 5-6 11.2-6 18c0 16.6 13.4 30 30 30z",
      fill: "#3e4347"
    }),
    createElementVNode("path", {
      d: "M62 32C62 15.4 48.6 2 32 2C22.2 2 13.5 6.7 8 14l48 36c3.8-5 6-11.2 6-18",
      fill: "#c94747"
    }),
    createElementVNode("path", {
      d: "M53 29.7c-.2-2.8-1.1-3.2-1.3-3.6c-.1-.4.2.1.5.2s-.1-.6-.1-.9c-.1-.3.9.7 1.2.7c.3.1-.6-2.3-.9-2.5c-.3-.2.3.1.4.1S51.2 21 50.9 21s.3-.1.5-.1s-2-1.8-2.4-1.8s.8-.5.9-.5c.2 0-2.5-1.5-5 0c-.1-.1 1.2-1 1.2-1.4c0-.1-.4-.3-.5-.4c0-.1.7-.5.7-.7c0-.2-.3-.1-.5-.1c0-.2.6-.7.5-1c0-.1-.5-.2-.6-.1s.3-.6.2-.8c-.1-.1-.3 0-.5 0c-.1 0 .7-1.3.6-1.4c-.2-.2-2.6 1.3-3.5 2.9c-.9 1.6-.2 2.9-.3 3.4c-.1.5-.3 1.1-.6 1.1c-.4 0-1.2-.6-1.5-.9s-.3-.5-.7-.6c-.4-.1-1.3.2-1.7.3c-.3 0-1.7-.3-1.8-.2c-.1.1 1.3.6 1.6.8c.3.2.3.4.6.5c.2.1 2.4.8 1.7 1.7c-.5.6-1.6-.6-3-.7c-1.4 0-2.3 1.3-2.7 1.8c-.4.5-1.7 2.9-1.7 3.1c0 .3.8-.7 1.1-.9c0 .3-.3.7-.2.9c.1.1 1-.7 1.3-.7c.1.2-.2.5-.1.8c.1.1.6-.6 1-.7c.1.3-.3.7-.1 1.1c.1 0 1-1 1.3-1.1c.3-.1-.1.9 0 1c.3-.2 1.1-1.1 1.3-1.2c.3-.1 0 1.2.1 1.2c.3-.2 1.1-1.3 1.2-1.5c.1-.2-.1 1.7.8 2.6s2.2 2.1 2.4 2.1c.2-.3-.1-1 .1-.9c.4.4 1.1 1.1 1.3 1.1s-.1-.7.1-.7c.5.4 1.8 2.1 4.3 2.9c-.2-.5-.5-.9-.6-1.1c.2 0 .8.3.9.3c.1 0-1.3-1.7-1.2-1.9c.3 0 .5.2.6 0c-.1-.2-1.3-1.6-1.3-1.9c0-.3.4.1.5 0c.1-.1-.5-1.3-.3-1.4c.1-.1 1.4.8 1.7.8c.1 0 .2-.2.2-.4c.9.7 2.5 2 3.7 3.7c0 .4-.1.7-.2 1.1c-.9 2.1-2.6 3.2-5.1 2.3c.1.2 1.5 1.3 2.9.9c1.2-.3 2.7-1.2 3-3.2c.3.7.5 1.5.5 2.3c0 3.8-3.4 3.7-4.3 3.5c1.1.9 5.2.7 5.2-3.5c-.1-1.3-.7-2.6-1.5-3.7m-4.3-4.1c0-.1 0-.2.1-.2c.1-.1 1.2.6 1.4.6s.2-.5.3-.4c.1 0 1.4 1.4 1.8 3.2c-1.4-1.6-2.9-2.8-3.6-3.2",
      fill: "#ffce31"
    }),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M19.4 41.2L19 40l-.4 1.2h-1.2l1 .8l-.4 1.2l1-.8l1 .8l-.4-1.2l1-.8z" }),
      createElementVNode("path", { d: "M14.4 26.6l-.7 2.3l1.9-1.4l2 1.5l-.8-2.4l2-1.5h-2.4l-.8-2.5l-.7 2.5h-2.5z" }),
      createElementVNode("path", { d: "M8.9 34.7l-.8-2.4l-.7 2.4H4.9l2 1.5l-.7 2.4l1.9-1.5l2 1.5l-.8-2.4l2-1.5z" }),
      createElementVNode("path", { d: "M24.3 35.5l2-1.5h-2.4l-.8-2.4l-.7 2.4h-2.5l2 1.5l-.7 2.4l1.9-1.5l2 1.5z" }),
      createElementVNode("path", { d: "M16.4 47.7l-.8-2.5l-.7 2.5h-2.5l2 1.5l-.7 2.3l1.9-1.4l2 1.5l-.8-2.4l2-1.5z" })
    ])
  ]);
}
function p$T(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3685)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 0C7.24316 0 3.13241 2.76867 1.19141 6.78262H22.8099C20.869 2.76867 16.7582 0 12.0007 0Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0007 24.0008C16.7582 24.0008 20.869 21.2321 22.81 17.2181H1.19141C3.13241 21.2321 7.24316 24.0008 12.0007 24.0008Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M14.9514 8.52661L13.8446 9.63338C14.3167 10.1055 14.6088 10.7576 14.6088 11.478C14.6088 12.9188 13.4408 14.0867 12.0001 14.0867C10.5594 14.0867 9.39138 12.9187 9.39138 11.478C9.39138 10.7576 9.68341 10.1055 10.1555 9.63338L9.04872 8.52661C8.29333 9.28186 7.82617 10.3253 7.82617 11.478C7.82617 13.7832 9.69489 15.6519 12.0001 15.6519C14.3052 15.6519 16.174 13.7832 16.174 11.478C16.1739 10.3253 15.7068 9.28186 14.9514 8.52661Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0003 9.9126L12.3888 11.1084H13.6461L12.6289 11.8473L13.0175 13.043L12.0003 12.3041L10.9831 13.043L11.3716 11.8473L10.3545 11.1084H11.6117L12.0003 9.9126Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3685" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$S(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3686)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9999 12.0015C23.9999 6.84196 20.7434 2.44339 16.1738 0.747925V23.2552C20.7434 21.5596 23.9999 17.1611 23.9999 12.0015Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 12.0006C0 17.1603 3.2565 21.5587 7.82611 23.2543V0.74707C3.2565 2.44254 0 6.8411 0 12.0006Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3686" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$R(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3687)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 0V12L3.51465 20.4853C5.68623 22.6568 8.68623 24 12 24C18.6273 24 24 18.6274 24 12C24 5.37262 12 0 12 0Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 0C8.68623 0 5.68623 1.34316 3.51465 3.51469C6.45887 6.45891 7.50404 7.50412 12 12H24C24 5.37262 18.6273 0 12 0Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M8.21723 11.9998L6.75173 11.3104L7.53215 9.89111L5.94074 10.1956L5.73909 8.58789L4.63059 9.77027L3.52213 8.58789L3.32043 10.1956L1.72907 9.89106L2.50949 11.3104L1.04395 11.9998L2.50949 12.6891L1.72907 14.1085L3.32057 13.8041L3.52209 15.4117L4.63059 14.2293L5.73909 15.4117L5.94074 13.8041L7.53205 14.1085L6.75168 12.6892L8.21723 11.9998Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.20082 4.69519L3.68851 5.37689L4.48749 5.12382L3.98977 5.79825L4.47746 6.47996L3.68218 6.21507L3.18451 6.88946L3.19074 6.05133L2.39551 5.78639L3.19463 5.53332L3.20082 4.69519Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.20082 17.1095L3.68851 17.7912L4.48749 17.5381L3.98977 18.2126L4.47746 18.8943L3.68218 18.6294L3.18451 19.3038L3.19074 18.4656L2.39551 18.2007L3.19463 17.9476L3.20082 17.1095Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M10.1558 10.9032L9.66817 11.5849L8.86914 11.3317L9.36686 12.0062L8.87917 12.688L9.67445 12.423L10.1722 13.0974L10.1659 12.2593L10.9611 11.9944L10.162 11.7413L10.1558 10.9032Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3687" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$Q(e28, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3688)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 12.0005H11.9999C11.9999 11.9897 11.9999 11.9792 11.9999 11.9684C11.9892 11.9791 11.9785 11.9898 11.9678 12.0005Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26098C12 4.1495 12 2.76598 12 0.00012207H11.998C5.37145 0.00124707 0 5.37336 0 12.0001H6.26086V8.47461L9.78637 12.0001H11.9679C11.9786 11.9894 11.9893 11.9787 12 11.968C12 11.1596 12 10.4382 12 9.78659L8.47443 6.26098H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.56506C4.19441 2.63377 2.63409 4.19405 1.56543 6.07088V11.9999H4.69588V4.69561V4.69552H12.0002C12.0002 3.70819 12.0002 2.7676 12.0002 1.56506H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0009 10.5248L7.73734 6.26135H6.26172V6.26145L12.0008 12.0005H12.0009C12.0009 12.0005 12.0009 10.9829 12.0009 10.5248Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.783 7.30388L17.2178 7.82564L15.6526 7.30388L15.1309 5.99953L15.6526 4.69519H18.783L18.2613 5.99953L18.783 7.30388Z",
        fill: "#ACABB1"
      }),
      createElementVNode("path", {
        d: "M13.5654 7.30396V13.0431C13.5654 15.8387 17.2176 16.6953 17.2176 16.6953C17.2176 16.6953 20.8698 15.8387 20.8698 13.0431V7.30396H13.5654Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M13.8945 14.4023C14.7923 16.1258 17.2175 16.6948 17.2175 16.6948C17.2175 16.6948 19.6427 16.1258 20.5405 14.4023L17.2175 8.86877L13.8945 14.4023Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M20.8698 12.9851L17.2176 7.30396L13.5654 12.9851V13.043C13.5654 13.5605 13.6908 14.0113 13.8946 14.4027L17.2176 9.23356L20.5406 14.4027C20.7444 14.0112 20.8698 13.5604 20.8698 13.043V12.9851Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3688" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function r$e(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3693)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M24 11.9995C24 18.6269 18.6274 23.9995 12 23.9995C5.37262 23.9995 0 18.6269 0 11.9995",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3693" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$b(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3689)" }, [
      createElementVNode("path", {
        d: "M0 12.0007C0 17.1602 3.2565 21.5587 7.82602 23.2542L8.86955 12.0006L7.82602 0.74707C3.2565 2.44263 0 6.8411 0 12.0007Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M24.0002 12C24.0002 5.37262 18.6275 0 12.0002 0C10.5323 0 9.1262 0.264047 7.82617 0.746391V23.2536C9.1262 23.736 10.5323 24 12.0002 24C18.6275 24 24.0002 18.6274 24.0002 12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.82623 16.1744C10.1314 16.1744 12.0001 14.3057 12.0001 12.0006C12.0001 9.69537 10.1314 7.82666 7.82623 7.82666C5.52106 7.82666 3.65234 9.69537 3.65234 12.0006C3.65234 14.3057 5.52106 16.1744 7.82623 16.1744Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.47754 9.9126V12.5213C5.47754 13.8179 6.52866 14.8691 7.82537 14.8691C9.12207 14.8691 10.1732 13.818 10.1732 12.5213V9.9126H5.47754Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.82657 13.3037C7.39504 13.3037 7.04395 12.9526 7.04395 12.5211V11.4777H8.60915V12.5211C8.60915 12.9526 8.25805 13.3037 7.82657 13.3037Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3689" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function C$a(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3690)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.999 -0.000610352C8.07308 -0.000610352 4.58769 1.88484 2.39844 4.79939H21.5995C19.4102 1.88484 15.9248 -0.000610352 11.999 -0.000610352Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.999 23.9993C15.9248 23.9993 19.4102 22.1139 21.5995 19.1993H2.39844C4.58769 22.1139 8.07308 23.9993 11.999 23.9993Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M-0.000976562 11.9994C-0.000976562 12.8213 0.0818984 13.6239 0.239352 14.3994H23.7588C23.9162 13.6239 23.999 12.8213 23.999 11.9994C23.999 11.1774 23.9161 10.3748 23.7587 9.59937H0.239352C0.0818984 10.3748 -0.000976562 11.1774 -0.000976562 11.9994Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51538C-1.17157 8.20166 -1.17157 15.7997 3.51471 20.486C5.45126 18.5495 7.31374 16.687 12 12.0007L3.51471 3.51538Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M4.85694 8.86877L5.6339 11.2601H8.14855L6.11427 12.7382L6.89118 15.1297L4.85694 13.6517L2.82262 15.1297L3.59971 12.7382L1.56543 11.2601H4.0799L4.85694 8.86877Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3690" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$i(i, L3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3691)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9997 12C23.9997 5.37262 18.627 0 11.9997 0C9.65216 0 7.46244 0.674766 5.61284 1.83989L8.24314 2.95744L4.69531 4.46484L8.24314 5.9722L4.69531 7.47952L8.24314 8.98678L4.69531 10.4939L8.24314 12.0008L4.69531 13.5082L8.24314 15.0154L4.69531 16.5225L8.24314 18.0297L4.69531 19.537L8.24314 21.0441L5.61402 22.161C7.46338 23.3256 9.65263 24 11.9997 24C18.627 24 23.9997 18.6274 23.9997 12Z",
        fill: "#751A46"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3691" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$k(e28, t3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      fill: "#2a5f9e",
      d: "M14 8v48l24-24z"
    }),
    createElementVNode("path", {
      d: "M56 14C50.5 6.7 41.8 2 32 2c-6.8 0-13 2.2-18 6l24 24l18-18",
      fill: "#ffce31"
    }),
    createElementVNode("path", {
      d: "M56 50c3.8-5 6-11.2 6-18c0-6.8-2.2-13-6-18L38 32l18 18",
      fill: "#ed4c5c"
    }),
    createElementVNode("path", {
      d: "M38 32L14 56c5 3.8 11.2 6 18 6c9.8 0 18.5-4.7 24-12L38 32z",
      fill: "#699635"
    }),
    createElementVNode("path", {
      d: "M6 17c-2.5 4.4-4 9.5-4 15s1.5 10.6 4 15V17",
      fill: "#2a5f9e"
    }),
    createElementVNode("path", {
      d: "M6 17v30c1.1 2 2.5 3.8 4 5.4V11.6c-1.5 1.7-2.9 3.5-4 5.4",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M10 11.6v40.8c1.2 1.3 2.6 2.5 4 3.6V8c-1.4 1.1-2.8 2.3-4 3.6",
      fill: "#ed4c5c"
    }),
    createElementVNode("circle", {
      cx: "38",
      cy: "32",
      r: "12",
      fill: "#ffffff"
    })
  ]);
}
function p$P(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3695)" }, [
      createElementVNode("path", {
        d: "M16.1745 0.745367C14.8744 0.26307 13.4684 -0.000976556 12.0006 -0.000976556C10.5327 -0.00102343 9.12667 0.26307 7.82669 0.745367L6.7832 11.999L7.82669 23.2526C9.12662 23.735 10.5327 23.999 12.0006 23.999C13.4684 23.999 14.8745 23.735 16.1745 23.2526L17.2179 11.999L16.1745 0.745367Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.9999 11.9996C23.9999 6.84005 20.7434 2.44144 16.1738 0.745972V23.2533C20.7434 21.5576 23.9999 17.1592 23.9999 11.9996Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 11.9995C0 17.1592 3.2565 21.5576 7.82602 23.2532L7.82606 0.745972C3.2565 2.44144 0 6.83991 0 11.9995Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3695" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$O(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3696)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.2536 16.1733C23.736 14.8734 24 13.4673 24 11.9995C24 10.5316 23.736 9.12555 23.2536 7.82556H0.746391C0.264047 9.12555 0 10.5316 0 11.9995C0 13.4673 0.264047 14.8734 0.746391 16.1733L12 17.2168L23.2536 16.1733Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0007 23.9995C17.1603 23.9995 21.5588 20.743 23.2543 16.1733H0.74707C2.44259 20.743 6.8411 23.9995 12.0007 23.9995Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3696" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$p(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3697)" }, [
      createElementVNode("path", {
        d: "M0 11.9991C0 14.078 0.528891 16.0333 1.45908 17.7382L12 18.7817L22.5409 17.7382C23.4711 16.0333 24 14.078 24 11.9991L12 10.9556L0 11.9991Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M22.5409 6.26086C20.5057 2.53073 16.5485 0 12 0C7.45148 0 3.49434 2.53073 1.45908 6.26086C0.528891 7.96575 0 9.92109 0 12H24C24 9.92109 23.4711 7.96575 22.5409 6.26086Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M11.9999 23.9991C16.5484 23.9991 20.5056 21.4684 22.5408 17.7383H1.45898C3.49425 21.4684 7.45139 23.9991 11.9999 23.9991Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M13.5654 7.02244L15.031 7.71183L14.2506 9.1312L15.842 8.8268L16.0437 10.4344L17.1521 9.252L18.2606 10.4344L18.4622 8.8268L20.0536 9.13111L19.2732 7.71178L20.7387 7.02244L19.2732 6.33314L20.0536 4.91377L18.4622 5.21817L18.2605 3.6106L17.1521 4.79297L16.0436 3.6106L15.842 5.21817L14.2506 4.91377L15.031 6.33319L13.5654 7.02244Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3697" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function H$5(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3710)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M21.4265 9.65236H17.4787C17.4787 8.932 16.8947 8.34802 16.1744 8.34802L15.1309 10.435C15.1309 10.435 16.2439 13.5654 16.2091 13.5654H17.5135C18.2339 13.5654 18.8178 12.9815 18.8178 12.2611C19.5382 12.2611 20.1221 11.6771 20.1221 10.9567H20.0787C20.799 10.9567 21.4265 10.3728 21.4265 9.65236Z",
        fill: "#ACABB1"
      }),
      createElementVNode("path", {
        d: "M2.57422 9.65224H6.52204C6.52204 8.93188 7.10601 8.3479 7.82637 8.3479L8.86987 10.4348C8.86987 10.4348 7.7568 13.5653 7.79161 13.5653H6.48727C5.76687 13.5653 5.18294 12.9814 5.18294 12.261C4.46253 12.261 3.8786 11.677 3.8786 10.9566H3.92204C3.20164 10.9566 2.57422 10.3726 2.57422 9.65224Z",
        fill: "#ACABB1"
      }),
      createElementVNode("path", {
        d: "M16.174 16.6957V17.2174H7.82621V16.6957H5.73926V18.7826H7.82621V19.3043H16.174V18.7826H18.261V16.6957H16.174Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M7.82617 8.34851V13.5659C7.82617 16.7608 12.0001 17.7398 12.0001 17.7398C12.0001 17.7398 16.174 16.7608 16.174 13.5659V8.34851L12.0001 7.82678L7.82617 8.34851Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M16.174 10.4342H7.82617V13.5646H16.174V10.4342Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.087 5.73881V6.52142L13.5653 6.78231L13.0436 6.26054V4.69531H10.9566V6.26054L10.4349 6.78231L9.91312 6.52142V5.73881H7.82617V8.34748H16.174V5.73881H14.087Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3710" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$j(h3, t3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      d: "M32 2v10H12v20H2c0 16.6 13.4 30 30 30s30-13.4 30-30S48.6 2 32 2z",
      fill: "#2a5f9e"
    }),
    createElementVNode("path", {
      d: "M32 2c-4.7 0-9.1 1.1-13.1 3v6H11v7.9H5c-1.9 4-3 8.4-3 13.1h12V17l12 15h6v-7.5L23.6 14H32V2z",
      fill: "#ffffff"
    }),
    createElementVNode("g", { fill: "#ed4c5c" }, [
      createElementVNode("path", { d: "M15.4 14L30 32h2v-4.9L21.4 14z" }),
      createElementVNode("path", { d: "M32 5H18.9c-6 2.9-11 7.9-13.9 13.9V32h6V11h21V5z" })
    ]),
    createElementVNode("path", {
      d: "M57.9 29.2c0 7.4-1.2 15.3-10.7 19.1c-9.5-3.8-10.7-11.7-10.7-19.1h21.4",
      fill: "#49c3f2"
    }),
    createElementVNode("path", {
      d: "M47.2 48.3c4.3-1.7 6.9-4.3 8.5-7.3h-.9c-.2 0-9.2-.9-10.2-1.3c-.9-.3-4.4.3-6.1.9c1.5 3.2 4.1 5.9 8.7 7.7",
      fill: "#428bc1"
    }),
    createElementVNode("path", {
      d: "M40.5 43.8c.1 0 2.6.4 3-.2c.4-.6-1.2-1.9-1.1-2.6c0-.2.2-.6.4-.7c.4-.2 1.7.3 1.8-.6c.1-1.5-1.2-2.7-1.6-4.1c-.3-.9-.3-1.7-.4-2.6c0-.4-.1-.6-.5-.7c-.5-.2-.5-.6-.7-1.1c-.2 0-.7.4-.7.6c0 .9-.8.9-1.2 1.6c-.3-.4-.5-1.1-.8-1.5c-.4-.4-.5-.4-.4-1c-.6-.5-.6.3-1 .5c-.1.2-.5.5-.8 1c.3 4.1 1.2 8.1 4 11.4",
      fill: "#c94747"
    }),
    createElementVNode("path", {
      d: "M57.9 29.2c0-2.8-.1-5.5-.1-7.8c-3.6-1.6-8.3-1.9-10.7-1.9c-2.4 0-7.1.3-10.7 1.9c.1 2.4-.1 5.1-.1 7.8h21.6",
      fill: "#ffe62e"
    }),
    createElementVNode("path", {
      d: "M49.6 39.9c-1.4 0-2.7 0-3.7-.1c-.9-.1-1.2-.3-1.9-.7c-1-.6-1.2-.7-2.6-1.5c-.2-.1-.4 0-.1.2c1.4.9 1.9 1.2 2.5 1.7c.7.4 2.7 1.7 2.7 1.7h8.1l1.3-2.7c0-.2-.1-.4-.1-.5c-1.5.1-2.9.1-4 .1c-.1.1-.2.3-.3.5c-.6.1-1 .2-1.2.2c.1.1-.5.9-.7 1.1",
      fill: "#3e4347"
    }),
    createElementVNode("path", {
      d: "M44.7 21.3c-.4 0-1.1 0-1.3.1c-.2.1-.2.1.1.2c.3.1.8.2 1 .4c.3.2.5.5.4.9c-.2 1.2.4 2.4 1.4 2.9c.1 0 .1.1.1.2c0 .2-.1.4-.1.5c-.1.1-.1.2.1.1c-.1.2-.4.6-.4.7c-.8-.1-1.4 0-1.4.8c0 .1 0 .2.1 0s.2-.4.6-.4c-.3.3-.4.5-.3.7c0 .2.1.3.2.1s.2-.4.4-.5c.1 0 .1-.1.1.1s0 .4.1.5c.1.1.1.1.1-.1s0-.5.2-.6c.3-.1.5-.1.6.1c.1.2.2 0 .1-.2s-.3-.4-.5-.4c.2-.3.4-.7.4-.8c0-.1.1-.1.2-.1s.1 0 .2-.1s.2-.5.3-.7c.1 0 .2 0 .2-.1c.2.3.4.6.4.7c0 .1.1.1.1.2s-.2.6-.2.7c-.6 0-.8 0-1 .3c-.1.1 0 .2.2.1c.1-.1.3-.1.4-.1c.1 0 .1.1 0 .1c-.3.2-.6.4-.5.7c0 .1.1.2.1 0c.1-.2.3-.4.6-.5c0 .2 0 .6.2.7c.2.1.2 0 .1-.1c-.1-.2 0-.5.1-.6c.2-.3.8.1.9.2c.1.1.2.1.1-.1c-.1-.3-.5-.5-.9-.6c.1-.5.4-1.6.5-1.9c.2.1.4-.2.8-.1c.6.2 1.6.8 1.7 1s.2.1.3 0c.1-.1.2 0 .3 0c.1 0 .2.1.1-.2c-.1-.3-.5-.8-1.1-1.2c.3 0 .8 0 .8-.1s-.5-.3-.8-.3c.2-.1.5-.2.7-.3c.1-.1 0-.1-.3-.1c-1 0-1.5 0-2-.3c-.8-.5-1.3-1-1.7-1.2c-.2-.1-.3-.4-.4-.6c-.3-.7-.3-1-.9-1.3c-.4 0-1.2.3-1.5.6",
      fill: "#c94747"
    })
  ]);
}
function p$N(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3699)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.51539 20.4852C4.01878 20.9885 4.55593 21.4375 5.11932 21.8327L21.8335 5.11856C21.4383 4.55512 20.9893 4.01802 20.4859 3.51463C19.9825 3.01124 19.4454 2.56241 18.882 2.16711L2.16797 18.8813C2.56313 19.4447 3.012 19.9818 3.51539 20.4852Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M3.51426 3.51475C-0.271509 7.30053 -0.998308 12.9861 1.33251 17.5021L17.5016 1.33309C12.9856 -0.997679 7.2999 -0.27088 3.51426 3.51475Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M20.4855 20.4847C24.2712 16.699 24.998 11.0134 22.6673 6.49731L6.49805 22.6665C11.0141 24.9972 16.6997 24.2705 20.4855 20.4847Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.62971 14.1578L8.74993 14.7286L9.63896 13.8396L9.44228 15.0813L10.5624 15.6521L9.32068 15.8488L9.12399 17.0905L8.55324 15.9703L7.31152 16.167L8.20051 15.278L7.62971 14.1578Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M14.1561 7.63057L15.2763 8.20136L16.1653 7.31238L15.9686 8.55405L17.0888 9.1249L15.8471 9.32158L15.6504 10.5633L15.0796 9.44313L13.8379 9.63977L14.7269 8.75079L14.1561 7.63057Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3699" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$M(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3711)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M7.56543 16.1739H16.435L12.0002 5.73914L7.56543 16.1739Z",
        fill: "#F3F3F3"
      }),
      createElementVNode("path", {
        d: "M9.10645 15.1303L12 8.54858L14.8936 15.1303H9.10645Z",
        fill: "#333333"
      }),
      createElementVNode("path", {
        d: "M7.56543 16.1745H16.435L12.0002 12.0006L7.56543 16.1745Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3711" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$h(L3, k3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1518_57409)" }, [
      createElementVNode("path", {
        d: "M0 0H1200V800H0V0Z",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M0 0H1200V400H0V0Z",
        fill: "#DC171D"
      }),
      createElementVNode("path", {
        d: "M0 0V800L533.333 400L0 0Z",
        fill: "white"
      }),
      createElementVNode("path", {
        d: "M269.43 301.951L269.593 295.758C269.593 295.758 266.268 290.461 270.127 284.769C270.127 284.769 261.928 280.431 263.836 273.638C263.836 273.638 256.422 271.743 256.967 263.587C256.967 263.587 248.964 263.032 248.135 256.219C248.135 256.219 240.132 257.537 236.61 250.898C236.61 250.898 228.803 252.424 226.601 246.951C226.601 246.951 219.012 249.58 214.509 243.147C214.509 243.147 206.495 246.385 203.136 240.312C199.822 246.364 191.808 243.147 191.808 243.147C187.359 249.557 179.716 246.897 179.716 246.897C177.589 252.391 169.804 250.832 169.804 250.832C166.293 257.473 158.301 256.152 158.301 256.152C157.516 262.945 149.524 263.5 149.524 263.5C150.156 271.676 142.753 273.53 142.753 273.53C144.704 280.322 136.516 284.649 136.516 284.649C140.474 290.373 137.181 295.628 137.181 295.628L136.996 301.339L269.451 301.951H269.43Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.399999"
      }),
      createElementVNode("path", {
        d: "M203.377 264.624C206.926 268.208 203.608 270.166 200.334 268.326C192.241 262.202 182.783 258.806 169.775 262.509C151.084 262.577 131.229 261.452 122.15 271.367C121.504 273.28 116.435 280.488 136.041 269.913C134.819 277.226 143.939 271.248 150.99 267.93C146.132 273.008 158.427 273.84 166.203 268.855C162.381 273.983 169.095 273.845 175.463 273.88C184.779 274.171 179.633 282.272 163.69 282.606C162.527 282.525 158.057 284.622 164.086 286.176C166.879 286.315 164.607 290.209 174.273 285.251C173.672 288.152 177.814 287.59 183.665 285.779C186.984 288.387 189.677 285.684 192.529 284.325C204.741 289.098 220.866 293.878 225.205 277.317C235.397 276.143 243.833 274.648 239.266 270.769C252.543 276.182 253.312 274.094 253.11 271.424C259.477 273.829 266.883 277.087 263.867 271.798C269.989 273.362 276.694 273.906 281.921 277.033C287.218 279.776 285.504 274.984 284.26 272.826C281.547 268.486 278.117 267.205 270.382 267.047C263.822 266.912 233.085 258.343 217.096 267.59C217.096 267.59 217.47 267.59 217.189 267.59C216.909 267.59 210.548 261.607 210.548 261.607C212.011 261.568 213.068 260.831 213.915 259.737C220.152 260.051 226.388 259.454 232.624 257.774C235.465 256.887 237.085 258.578 237.021 259.83C239.62 255.259 236.021 254.312 233.372 254.501C222.823 255.099 216.49 254.547 211.39 253.66C201.278 248.615 189.107 256.354 200.351 262.729L203.377 264.624Z",
        fill: "#BC715F",
        stroke: "black",
        "stroke-width": "0.4"
      }),
      createElementVNode("path", {
        d: "M205.753 255.674C203.637 255.989 201.453 256.243 200.608 257.708C200.67 255.297 204.26 255.131 205.753 255.674Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M204.631 257.495C205.135 257.495 205.543 257.076 205.543 256.56C205.543 256.044 205.135 255.625 204.631 255.625C204.127 255.625 203.719 256.044 203.719 256.56C203.719 257.076 204.127 257.495 204.631 257.495Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M89.9346 285.812C94.1107 309.512 98.7459 333.803 101.025 358.615C105.986 395.362 83.6328 426.215 92.8026 462.517C98.2762 479.937 117.433 490.062 134.966 492.069C158.225 496.465 186.342 492.083 203.32 509.479C220.298 492.08 248.415 496.465 271.674 492.069C289.207 490.062 308.364 479.937 313.837 462.517C323.007 426.215 300.654 395.362 305.615 358.615C307.894 333.803 312.529 309.512 316.705 285.812C275.764 308.04 235.31 279.124 203.32 297.611C171.33 279.124 130.876 308.04 89.9346 285.812Z",
        fill: "#DC171D",
        stroke: "black",
        "stroke-width": "0.399999"
      }),
      createElementVNode("path", {
        d: "M105.198 304.957C108.805 324.511 112.808 344.553 114.777 365.024C119.062 395.344 99.7552 420.8 107.675 450.752C112.403 465.124 128.949 473.479 144.092 475.134C164.181 478.761 188.466 475.141 203.13 489.499C217.794 475.143 242.079 478.761 262.168 475.134C277.311 473.479 293.857 465.124 298.584 450.752C306.504 420.8 287.198 395.344 291.483 365.024C293.451 344.553 297.455 324.511 301.062 304.957C265.7 323.296 230.76 299.438 203.13 314.692C175.499 299.438 140.559 323.296 105.198 304.957Z",
        fill: "#62AFE1",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M183.937 359.77L142.561 388.126V422.266H263.699V388.126L222.323 359.77H183.937Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M132.733 416.617V423.144H136.718V456.673H269.543V423.144H273.527V416.617H132.733Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M203.128 322.797L183.937 341.476V359.772H222.323V341.476L203.128 322.797Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M148.541 392.762H160.678V411.983H148.541V392.762Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M182.997 392.762H195.134V411.983H182.997V392.762Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M257.717 392.762H245.579V411.983H257.717V392.762Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M223.263 392.762H211.126V411.983H223.263V392.762Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M148.541 426.188H160.678V445.409H148.541V426.188Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M257.717 426.188H245.579V445.409H257.717V426.188Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M212.644 425.102H193.616V456.675H212.644V425.102Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M182.554 416.617H174.021V456.673H182.554V416.617Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M223.706 416.617H232.243V456.673H223.706V416.617Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M235.411 417.987V408.094H170.849V417.987H235.411Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M183.937 341.477H222.323Z",
        fill: "white"
      }),
      createElementVNode("path", {
        d: "M183.937 341.477H222.323",
        stroke: "black",
        "stroke-width": "0.9"
      }),
      createElementVNode("path", {
        d: "M142.561 388.129H263.699Z",
        fill: "white"
      }),
      createElementVNode("path", {
        d: "M142.561 388.129H263.699",
        stroke: "black",
        "stroke-width": "0.9"
      }),
      createElementVNode("path", {
        d: "M129.691 452.484H276.569V462.864H129.691V452.484Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M210.453 345.438H195.805V355.812H210.453V345.438Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M175.461 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M230.799 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M226.188 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M221.576 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M216.965 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M212.353 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M207.741 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M203.13 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M198.518 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M193.907 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M189.295 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M184.684 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M180.072 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M235.411 408.766V417.984",
        stroke: "black",
        "stroke-width": "0.9"
      }),
      createElementVNode("path", {
        d: "M140.901 320.895C150.019 326.712 154.33 332.092 154.352 337.081C143.005 336.478 132.744 331.137 140.901 320.895Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M148.243 326.195C157.024 331.19 161.971 336.629 163.497 342.463C154.577 344.015 145.061 339.806 148.243 326.195Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M136.893 334.777C138.075 344.808 136.628 352.016 132.833 356.703C126.295 350.442 124.044 340.284 136.893 334.777Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M136.904 334.805C145.152 340.637 149.542 346.534 150.488 352.49C141.459 353.16 132.402 348.037 136.904 334.805Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M142.382 326.777L146.183 329.151L150.261 328.748L151.973 331.566C151.973 331.566 151.514 337.357 151.511 337.886C151.507 338.414 152.771 341.653 152.771 341.653L149.995 343.671L142.559 346.717L135.605 341.068L131.221 341.522L129.299 336.076L131.459 331.433L136.886 327.91L142.382 326.777Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M135.246 329.655C131.672 339.103 127.066 344.833 121.538 347.245C118.621 338.676 121.304 328.624 135.246 329.655Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M135.226 330.347C125.314 328.396 118.896 324.809 115.598 319.76C123.564 315.458 133.924 316.431 135.226 330.347Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M154.181 330.685C164.244 331.578 171.408 329.924 175.985 325.997C169.537 319.643 159.317 317.685 154.181 330.685Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M154.212 330.696C160.28 338.771 166.303 342.989 172.284 343.763C172.694 334.72 167.312 325.816 154.212 330.696Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M151.05 335.633C158.613 342.329 162.334 348.67 162.625 354.694C153.577 354.375 145.132 348.296 151.05 335.633Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M147.933 346.73C153.108 355.405 154.73 362.575 153.18 368.403C144.655 365.356 138.452 357.002 147.933 346.73Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M144.292 346.168C145.438 356.203 143.965 363.406 140.153 368.079C133.638 361.794 131.423 351.628 144.292 346.168Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M137.72 334.909C136.992 334.393 136.445 333.496 136.317 332.61C136.208 331.854 136.27 331.368 136.61 330.302C136.783 329.762 136.92 329.308 136.915 329.292C136.91 329.277 136.775 329.237 136.615 329.205C136.337 329.147 136.303 329.165 135.802 329.627C134.09 331.208 132.528 331.966 131.459 331.734C130.22 331.465 129.746 329.747 130.435 328.024C131.02 326.559 132.119 325.663 133.523 325.504C134.042 325.446 134.261 325.466 134.867 325.632C135.265 325.741 135.576 325.798 135.558 325.758C135.54 325.719 135.237 325.504 134.885 325.281C133.155 324.184 132.132 322.915 132.063 321.78C132.013 320.957 132.552 320.166 133.476 319.71C135.028 318.943 136.97 319.489 137.874 320.947C138.307 321.646 138.42 322.203 138.419 323.642C138.418 324.477 138.452 324.956 138.515 324.982C138.569 325.005 138.712 325.135 138.832 325.271L139.051 325.519L139.908 324.816C140.781 324.1 141.414 323.664 142.123 323.286C143.104 322.764 144.26 322.616 144.839 322.939C146.108 323.646 146.103 325.952 144.829 327.531C143.795 328.812 142.225 329.264 140.79 328.693C140.468 328.564 140.013 328.408 139.778 328.344L139.351 328.229L140.012 329.069C140.903 330.203 141.404 331.014 141.749 331.883C142.401 333.524 142.069 334.789 140.846 335.332C139.904 335.75 138.669 335.583 137.72 334.909Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M139.421 327.788C139.202 328.338 138.797 328.788 138.297 329.038C137.796 329.289 137.24 329.321 136.75 329.126C136.261 328.931 135.879 328.526 135.688 327.999C135.497 327.473 135.513 326.868 135.732 326.319C135.951 325.769 136.356 325.319 136.857 325.068C137.357 324.817 137.913 324.786 138.403 324.981C138.892 325.176 139.274 325.581 139.465 326.107C139.656 326.634 139.64 327.239 139.421 327.788Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M146.811 324.251C146.818 325.028 146.949 325.517 147.433 326.574C147.678 327.109 147.876 327.56 147.874 327.576C147.871 327.592 147.747 327.643 147.599 327.689C147.341 327.769 147.305 327.754 146.757 327.323C144.884 325.852 143.275 325.205 142.285 325.526C141.136 325.897 140.935 327.681 141.85 329.378C142.628 330.819 143.813 331.643 145.181 331.694C145.688 331.712 145.895 331.674 146.451 331.458C146.816 331.316 147.106 331.233 147.094 331.275C147.083 331.316 146.825 331.558 146.52 331.813C145.024 333.065 144.23 334.435 144.332 335.594C144.406 336.435 145.039 337.196 145.992 337.586C147.592 338.243 149.373 337.534 150.024 335.982C150.337 335.236 150.362 334.662 150.148 333.199C150.024 332.35 149.987 331.861 150.044 331.829C150.092 331.802 150.209 331.659 150.305 331.511L150.478 331.242L151.403 331.888C152.345 332.547 153.016 332.941 153.751 333.268C154.769 333.722 155.899 333.78 156.406 333.407C157.518 332.587 157.172 330.244 155.718 328.74C154.539 327.52 152.967 327.185 151.676 327.879C151.387 328.035 150.973 328.23 150.757 328.313L150.365 328.464L150.874 327.557C151.561 326.335 151.922 325.471 152.124 324.56C152.506 322.841 152.002 321.582 150.749 321.127C149.785 320.777 148.626 321.044 147.911 321.715C147.195 322.385 146.803 323.341 146.811 324.251Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.449764"
      }),
      createElementVNode("path", {
        d: "M146.921 328.816C147.182 328.269 147.626 327.827 148.155 327.587C148.684 327.348 149.255 327.331 149.741 327.54C150.228 327.749 150.592 328.167 150.751 328.702C150.911 329.236 150.854 329.845 150.593 330.392C150.332 330.94 149.888 331.382 149.359 331.621C148.83 331.861 148.259 331.878 147.772 331.669C147.285 331.46 146.922 331.042 146.762 330.507C146.602 329.972 146.659 329.364 146.921 328.816Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M135.662 346.222C135.459 345.327 135.477 344.729 135.747 343.384C135.884 342.702 135.99 342.13 135.982 342.112C135.975 342.095 135.819 342.069 135.636 342.057C135.317 342.035 135.281 342.062 134.767 342.705C133.012 344.905 131.338 346.084 130.112 345.985C128.691 345.869 127.976 343.873 128.568 341.675C129.071 339.806 130.21 338.538 131.77 338.109C132.347 337.95 132.595 337.938 133.293 338.036C133.752 338.1 134.107 338.116 134.083 338.072C134.059 338.027 133.696 337.819 133.277 337.609C131.217 336.576 129.933 335.215 129.735 333.856C129.592 332.869 130.114 331.823 131.103 331.116C132.765 329.927 135.006 330.259 136.175 331.866C136.736 332.638 136.922 333.292 137.073 335.031C137.16 336.041 137.25 336.613 137.323 336.634C137.387 336.652 137.56 336.785 137.71 336.93L137.982 337.192L138.87 336.198C139.776 335.186 140.44 334.551 141.197 333.975C142.243 333.178 143.527 332.804 144.211 333.096C145.712 333.736 145.95 336.524 144.686 338.647C143.661 340.369 141.944 341.18 140.272 340.732C139.897 340.632 139.369 340.519 139.098 340.483L138.606 340.416L139.437 341.319C140.559 342.538 141.208 343.434 141.688 344.426C142.593 346.298 142.355 347.883 141.038 348.745C140.024 349.409 138.62 349.416 137.615 348.839C136.61 348.262 135.9 347.271 135.662 346.222Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M138.638 339.87C138.45 340.571 138.043 341.183 137.507 341.571C136.971 341.958 136.35 342.091 135.78 341.938C135.209 341.785 134.737 341.36 134.467 340.756C134.197 340.152 134.15 339.419 134.338 338.718C134.526 338.017 134.933 337.405 135.469 337.017C136.005 336.63 136.626 336.497 137.196 336.65C137.766 336.803 138.239 337.228 138.509 337.832C138.779 338.436 138.826 339.169 138.638 339.87Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M148.377 336.769C148.201 337.648 148.233 338.232 148.53 339.539C148.681 340.201 148.798 340.758 148.792 340.775C148.785 340.792 148.633 340.821 148.455 340.837C148.144 340.867 148.108 340.841 147.59 340.226C145.822 338.121 144.157 337.011 142.963 337.139C141.578 337.287 140.93 339.254 141.562 341.386C142.1 343.198 143.244 344.409 144.778 344.789C145.345 344.93 145.588 344.936 146.267 344.823C146.713 344.749 147.06 344.724 147.037 344.768C147.015 344.812 146.666 345.025 146.262 345.24C144.276 346.3 143.056 347.661 142.897 348.993C142.781 349.961 143.317 350.97 144.301 351.636C145.953 352.756 148.133 352.376 149.235 350.777C149.764 350.009 149.929 349.366 150.033 347.663C150.093 346.675 150.166 346.114 150.238 346.092C150.299 346.073 150.465 345.938 150.608 345.794L150.867 345.531L151.759 346.479C152.669 347.446 153.333 348.049 154.086 348.593C155.128 349.345 156.391 349.679 157.052 349.377C158.501 348.714 158.665 345.986 157.378 343.943C156.334 342.287 154.637 341.537 153.015 342.016C152.651 342.124 152.138 342.246 151.875 342.289L151.396 342.367L152.185 341.463C153.25 340.245 153.862 339.355 154.306 338.374C155.143 336.523 154.871 334.981 153.564 334.171C152.557 333.548 151.185 333.576 150.218 334.164C149.251 334.753 148.583 335.739 148.377 336.769Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.450001"
      }),
      createElementVNode("path", {
        d: "M149.289 340.879C148.58 340.898 147.906 341.168 147.417 341.632C146.927 342.096 146.661 342.715 146.677 343.352C146.693 343.99 146.99 344.595 147.503 345.033C148.016 345.471 148.702 345.707 149.411 345.689C150.12 345.671 150.793 345.4 151.283 344.937C151.773 344.473 152.039 343.854 152.023 343.216C152.007 342.578 151.709 341.974 151.197 341.536C150.684 341.097 149.998 340.861 149.289 340.879Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.450001"
      }),
      createElementVNode("path", {
        d: "M283.679 361.85H278.595V358.237H274.264V354.109H269.306L269.302 327.908L263.655 318.027L258.008 327.908V354.109H253.05V358.237H248.719V361.85H243.635V367.183L283.679 367.297V361.85Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.800001"
      }),
      createElementVNode("path", {
        d: "M203.576 526.322C223.922 526.387 248.946 522.234 260.667 516.174L286.41 513.894L286.923 545.303C265.116 557.326 214.763 559.909 203.685 559.822C192.597 559.909 141.623 557.283 119.718 545.215L120.001 513.785L145.799 516.107C157.52 522.137 183.307 526.322 203.631 526.322H203.576Z",
        fill: "#F9D90F"
      }),
      createElementVNode("path", {
        d: "M119.718 545.218L146.265 539.146L119.806 535.359L119.718 545.218Z",
        fill: "#F9B60F"
      }),
      createElementVNode("path", {
        d: "M53.4459 392.354L76.1252 399.571L69.2668 436.288L47.7978 439.623C47.7978 439.623 44.1779 420.316 53.4459 392.332",
        fill: "#F9D90F"
      }),
      createElementVNode("path", {
        d: "M47.7979 439.62L61.7435 420.379L69.2668 436.285L47.7979 439.62Z",
        fill: "#F9B60F"
      }),
      createElementVNode("path", {
        d: "M53.4459 392.354L76.1252 399.571L69.2668 436.288L47.7978 439.623C47.7978 439.623 44.1779 420.316 53.4459 392.332V392.354Z",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M119.718 545.217L146.434 539.145",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M61.7646 420.262L69.2669 436.284",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M286.923 545.3L260.375 539.228L286.834 535.441L286.923 545.3Z",
        fill: "#F9B60F"
      }),
      createElementVNode("path", {
        d: "M353.194 392.444L330.515 399.66L337.373 436.378L358.842 439.713C358.842 439.713 362.462 420.406 353.194 392.422",
        fill: "#F9D90F"
      }),
      createElementVNode("path", {
        d: "M358.842 439.714L344.897 420.473L337.373 436.379L358.842 439.714Z",
        fill: "#F9B60F"
      }),
      createElementVNode("path", {
        d: "M353.194 392.444L330.515 399.66L337.373 436.378L358.842 439.713C358.842 439.713 362.462 420.406 353.194 392.422V392.444Z",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M286.923 545.307L260.206 539.234",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M344.875 420.352L337.373 436.374",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M203.576 526.326C223.922 526.391 248.946 522.238 260.667 516.178L286.41 513.898L286.923 545.306C265.116 557.33 214.763 559.913 203.685 559.826C192.597 559.913 141.623 557.287 119.718 545.219L120.001 513.789L145.799 516.111C157.52 522.141 183.307 526.326 203.631 526.326H203.576Z",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M366.758 418.887L344.897 420.466C344.406 438.989 342.16 509.675 257.745 513.512L260.373 539.229C363.127 540.296 370.934 452.529 366.758 418.887Z",
        fill: "#F9D90F"
      }),
      createElementVNode("path", {
        d: "M366.758 418.887L344.897 420.466C344.406 438.989 342.16 509.675 257.745 513.512L260.373 539.229C363.127 540.296 370.934 452.529 366.758 418.887Z",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M39.8818 418.805L61.7433 420.384C62.2338 438.907 64.4801 509.593 148.895 513.43L146.267 539.147C43.5126 540.214 35.7057 452.447 39.8818 418.805Z",
        fill: "#F9D90F"
      }),
      createElementVNode("path", {
        d: "M39.8818 418.805L61.7433 420.384C62.2338 438.907 64.4801 509.593 148.895 513.43L146.267 539.147C43.5126 540.214 35.7057 452.447 39.8818 418.805Z",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M189.244 541.802C188.666 542.172 187.881 542.271 186.976 542.227L182.898 542.02L183.247 536.93L187.292 537.147C188.088 537.201 188.721 537.355 189.113 537.594C189.931 538.019 190.291 538.805 190.214 539.894C190.16 540.831 189.833 541.443 189.233 541.802M182.386 549.815L182.789 543.611L187.543 543.939C189.08 544.059 190.225 543.656 190.999 542.87C191.806 542.107 192.221 541.105 192.275 539.971C192.373 538.651 192.035 537.572 191.25 536.776C190.498 536.013 189.429 535.61 188.088 535.48L181.295 535.055L180.358 549.662L182.375 549.794",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M197.841 537.59L202.813 537.644C203.533 537.709 204.1 537.797 204.514 537.993C205.277 538.353 205.637 539.072 205.637 540.119C205.637 541.101 205.354 541.755 204.798 542.148C204.263 542.506 203.489 542.67 202.562 542.67L197.787 542.615L197.83 537.59M197.754 550.53L197.798 544.294L202.464 544.361C203.293 544.361 203.904 544.425 204.329 544.632C205.016 544.948 205.354 545.614 205.386 546.529L205.506 548.982C205.539 549.571 205.55 549.931 205.583 550.17C205.648 550.345 205.681 550.53 205.768 550.662H208.276L208.232 550.345C207.949 550.192 207.72 549.899 207.622 549.451C207.535 549.167 207.491 548.742 207.469 548.208L207.425 546.257C207.393 545.374 207.24 544.764 206.902 544.425C206.608 544.033 206.204 543.695 205.583 543.488C206.281 543.118 206.804 542.693 207.186 542.168C207.545 541.591 207.731 540.86 207.731 539.967C207.731 538.289 207.044 537.143 205.648 536.523C204.896 536.185 203.936 536.009 202.802 535.988L195.792 535.922L195.737 550.574H197.754",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M214.363 547.472C213.469 546.383 212.989 545.021 212.88 543.407C212.782 541.379 213.175 539.832 214.102 538.784C215.039 537.65 216.25 537.106 217.831 537.019C219.422 536.932 220.731 537.444 221.701 538.446C222.694 539.428 223.261 540.791 223.359 542.492C223.413 544.126 223.13 545.576 222.377 546.851C221.636 548.149 220.404 548.88 218.583 548.922C216.686 549.022 215.268 548.575 214.363 547.472ZM211.964 538.25C211.027 539.7 210.645 541.379 210.743 543.407C210.885 545.597 211.561 547.408 212.837 548.771C214.254 550.133 216.13 550.819 218.441 550.688C220.916 550.579 222.781 549.642 224.046 547.92C225.07 546.362 225.561 544.551 225.452 542.316C225.31 540.321 224.732 538.697 223.653 537.487C222.29 535.862 220.295 535.144 217.591 535.253C215.039 535.415 213.164 536.353 211.954 538.25",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M49.8913 446.007L50.2293 447.837C49.4116 448.001 48.7574 448.329 48.2776 448.754C47.4162 449.56 47.1218 450.771 47.4162 452.417C47.5472 453.114 47.7978 453.801 48.1141 454.347C48.7685 455.459 49.6187 455.905 50.6982 455.73C51.4942 455.589 52.0176 455.284 52.2683 454.717C52.5082 454.16 52.6829 453.31 52.7373 452.221L52.8354 450.16C52.9026 448.884 53.0424 447.882 53.3259 447.325C53.7727 446.322 54.6126 445.701 55.8664 445.495C57.2076 445.254 58.3852 445.559 59.3992 446.322C60.4241 447.031 61.1001 448.263 61.3509 449.898C61.6674 451.392 61.5256 452.733 60.9363 453.942C60.3692 455.121 59.279 455.839 57.6107 456.144L57.2835 454.292C58.0576 454.009 58.6356 453.735 59.0172 453.355C59.6717 452.623 59.8676 451.567 59.6165 450.117C59.4203 448.939 59.0172 448.175 58.4062 447.795C57.8069 447.347 57.2069 447.173 56.5527 447.283C55.8221 447.392 55.3424 447.795 55.1134 448.449C54.9716 448.884 54.8627 449.789 54.7646 451.174L54.6666 453.31C54.6128 454.313 54.4596 455.143 54.1216 455.709C53.5875 456.755 52.6823 457.398 51.363 457.605C49.6948 457.889 48.4081 457.507 47.4923 456.439C46.5546 455.392 45.9766 454.139 45.6823 452.58C45.3551 450.726 45.5949 449.287 46.3367 448.133C47.0891 446.945 48.2776 446.258 49.8913 446.029",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M48.9644 465.335L63.3787 460.996L66.737 471.144L64.9815 471.7L62.2339 463.361L57.8507 464.681L60.3912 472.387L58.712 472.921L56.1933 465.193L51.3086 466.653L54.0998 475.178L52.3771 475.67L48.9644 465.335Z",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M55.3542 482.929L68.6129 475.898L70.0304 478.372L60.915 488.009L74.2282 485.731L75.602 488.184L62.3761 495.172L61.4384 493.547L69.2453 489.438C69.5288 489.274 69.9649 489.034 70.5973 488.697C71.2189 488.413 71.9166 488.031 72.6145 487.671L59.3558 489.928L58.3854 488.205L67.4353 478.601L66.9992 478.82C66.7157 478.982 66.2251 479.223 65.56 479.604C64.9055 480.008 64.4151 480.258 64.0989 480.389L56.3138 484.564L55.3543 482.908",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M80.0612 502.457C79.396 502.306 78.7419 501.923 78.0986 501.258L75.2964 498.369L79.069 494.913L81.893 497.792C82.4379 498.327 82.7871 498.849 82.9725 499.297C83.2338 500.157 82.9725 500.943 82.1765 501.683C81.4569 502.348 80.7372 502.621 80.0612 502.457ZM69.4085 503.798L74.0316 499.557L77.3135 502.882C78.3712 503.962 79.4506 504.452 80.5846 504.431C81.7403 504.365 82.7326 503.94 83.6048 503.111C84.5862 502.239 85.055 501.214 85.055 500.114C85.0415 499.045 84.5537 498.043 83.6485 497.106L78.9382 492.297L67.9692 502.37L69.3867 503.798",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M82.6345 515.57L90.5832 503.109L99.982 508.822L99.0007 510.305L91.281 505.683L88.8931 509.455L95.9913 513.76L95.0754 515.189L87.9663 510.905L85.2622 515.123L93.0801 519.822L92.1424 521.294L82.6345 515.57Z",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M106.164 513.162L110.94 514.678C111.616 514.884 112.107 515.146 112.434 515.441C113.044 516.019 113.208 516.847 112.848 517.849C112.554 518.722 112.107 519.288 111.409 519.529C110.787 519.637 110.002 519.637 109.086 519.354L104.583 517.916L106.164 513.162ZM102.043 525.404L104.027 519.463L108.476 520.913C109.272 521.121 109.85 521.404 110.133 521.698C110.678 522.188 110.842 522.919 110.569 523.825L109.904 526.189C109.752 526.767 109.675 527.148 109.61 527.323C109.61 527.509 109.61 527.706 109.643 527.835L111.988 528.598L112.129 528.26C111.879 528.064 111.737 527.706 111.748 527.259C111.802 526.985 111.879 526.55 112.031 526.047L112.598 524.151C112.828 523.322 112.915 522.701 112.707 522.255C112.533 521.785 112.238 521.36 111.748 520.957C112.489 520.825 113.133 520.597 113.678 520.193C114.19 519.746 114.626 519.125 114.888 518.254C115.422 516.672 115.128 515.353 113.95 514.35C113.362 513.828 112.522 513.38 111.421 512.966L104.748 510.906L100.081 524.805L102.033 525.404",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M279.855 516.151C281.266 515.936 282.485 516.025 283.59 516.426C285.216 516.968 286.295 518.199 286.948 520.064L284.926 520.31C284.508 519.3 283.9 518.602 283.067 518.205C282.256 517.831 281.233 517.724 280.052 517.878C278.675 518.06 277.561 518.725 276.767 519.813C275.983 520.975 275.725 522.542 276.026 524.552C276.279 526.216 276.864 527.632 277.85 528.587C278.759 529.563 280.116 529.926 281.897 529.708C283.231 529.514 284.309 529.001 285.078 528.098C285.879 527.241 286.132 525.926 285.902 524.22L281.19 524.855L280.98 523.238L287.539 522.353L288.673 530.126L287.372 530.299L286.598 528.496C286.038 529.294 285.482 529.905 284.995 530.255C284.177 530.874 283.08 531.257 281.713 531.428C279.942 531.668 278.335 531.322 276.891 530.358C275.31 529.141 274.307 527.356 273.959 524.897C273.578 522.481 273.997 520.427 275.139 518.823C276.225 517.274 277.778 516.386 279.855 516.129",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M294.669 515.285L299.388 513.67C300.036 513.443 300.593 513.376 301.072 513.44C301.932 513.521 302.555 514.044 302.896 515.075C303.218 515.953 303.204 516.716 302.812 517.245C302.399 517.792 301.759 518.185 300.837 518.505L296.404 520.005L294.669 515.285ZM299.136 527.481L296.954 521.564L301.343 520.073C302.165 519.827 302.735 519.695 303.159 519.748C303.931 519.859 304.512 520.34 304.888 521.239L305.839 523.493C306.047 524.052 306.215 524.393 306.354 524.549C306.416 524.747 306.555 524.869 306.662 525.001L309.044 524.173L308.918 523.855C308.57 523.848 308.235 523.646 307.992 523.259C307.811 522.984 307.644 522.588 307.402 522.126L306.661 520.28C306.327 519.478 305.976 518.982 305.567 518.679C305.157 518.442 304.636 518.28 304.016 518.226C304.506 517.678 304.865 517.128 305.007 516.477C305.161 515.816 305.109 515.073 304.808 514.239C304.237 512.67 303.152 511.799 301.606 511.662C300.789 511.582 299.848 511.739 298.762 512.1L292.135 514.324L297.203 528.197L299.146 527.524",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M316.417 520.536L308.278 508.185L317.564 502.5L318.551 503.991L310.941 508.659L313.446 512.434L320.472 508.092L321.394 509.537L314.368 513.88L317.128 518.041L324.87 513.286L325.857 514.744L316.406 520.536",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M324.126 499.104L326.572 496.51C327.706 495.353 328.893 494.84 330.176 495.016C331.461 495.149 332.757 495.848 334.13 497.095C334.506 497.396 334.837 497.784 335.178 498.215C335.774 499.022 336.121 499.727 336.337 500.428C336.517 501.304 336.459 502.099 336.14 502.857C335.948 503.234 335.613 503.675 335.112 504.201L332.655 506.773L324.126 499.083M336.689 505.057C338.424 503.215 338.831 501.205 337.881 498.909C337.325 497.665 336.464 496.45 335.262 495.382C333.75 493.991 332.16 493.264 330.473 493.104C328.6 492.927 326.996 493.575 325.584 495.063L321.416 499.37L332.509 509.409L336.678 505.08",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M345.628 493.854L332.795 485.998L333.883 484.34L346.739 492.152L345.639 493.876",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M350.881 485.096L336.975 479.236L341.287 469.458L342.975 470.143L339.458 478.202L343.647 479.937L346.934 472.516L348.535 473.212L345.281 480.621L349.967 482.624L353.573 474.47L355.261 475.143L350.87 485.095",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M357.627 468.011L342.948 464.483L343.48 462.214L357.18 457.863L345.269 455.006L345.738 453.227L360.419 456.667L359.91 458.871L346.186 463.321L358.098 466.122L357.638 468.011",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M356.803 449.274L357.022 447.424C357.872 447.462 358.594 447.344 359.144 447.06C360.223 446.501 360.864 445.413 361.058 443.791C361.137 443.03 361.117 442.363 360.954 441.728C360.66 440.502 359.985 439.813 358.886 439.684C358.07 439.582 357.478 439.767 357.045 440.207C356.654 440.713 356.237 441.445 355.912 442.487L355.201 444.404C354.742 445.66 354.323 446.524 353.878 447.007C353.163 447.911 352.176 448.209 350.924 448.099C349.586 447.933 348.506 447.379 347.75 446.34C346.972 445.388 346.669 444.041 346.895 442.387C347.054 440.875 347.579 439.609 348.491 438.601C349.337 437.679 350.632 437.254 352.275 437.459L352.088 439.309C351.281 439.294 350.636 439.424 350.161 439.743C349.302 440.196 348.815 441.179 348.647 442.626C348.505 443.824 348.654 444.633 349.101 445.252C349.549 445.773 350.121 446.109 350.796 446.176C351.514 446.255 352.085 446.036 352.488 445.489C352.778 445.111 353.131 444.289 353.614 442.957L354.316 440.942C354.66 440.01 355.066 439.298 355.533 438.794C356.366 437.959 357.441 437.619 358.78 437.742C360.412 437.945 361.566 438.644 362.143 439.897C362.709 441.161 362.913 442.55 362.742 444.117C362.524 445.889 361.921 447.275 360.836 448.193C359.75 449.131 358.414 449.434 356.803 449.274Z",
        fill: "#012A87"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1518_57409" }, [
        createElementVNode("rect", {
          width: "800",
          height: "800",
          rx: "400",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$L(t3, d3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      d: "M25.8 9.3H15.4V7c-.8.5-1.5 1.1-2.3 1.7c-1.7 1.4-3.3 3-4.6 4.7h2.8v8.1H3.9C2.7 24.8 2 28.3 2 32c0 3.5.6 6.9 1.7 10h22V21.6H15.4v-8.2h10.4V9.3",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M32 2c-2.1 0-4.2.2-6.2.6v58.7c2 .4 4.1.6 6.2.6c16.6 0 30-13.4 30-30C62 15.4 48.6 2 32 2",
      fill: "#0091c8"
    }),
    createElementVNode("path", {
      d: "M61.5 32.3c0-.2.3-.7.5-1.2v-.9c-.2.4-.4.7-.4.9c-.2.6-.4.2-.4-1.6c-.1-1.4 0-2.8.2-4.1c-.7-3.3-2-6.4-3.8-9.2c-.4.1-.7.2-.7.2s.2-.3.4-.7c-.1-.1-.2-.3-.3-.4c-.6.8-1.2 1.5-1.3 1.5c-.2.1-.9.3-1.7.6l-1.4.6l1.1-1c.6-.5 1.7-1.6 2.5-2.3l.2-.2c-.1-.1-.2-.2-.2-.3l-1.5 1.4c-1.6 1.5-3.2 2.9-3.4 3c-.2.1-.5.3-.5.5c-.1.3 0 .7.3.8c.2.1.1.3-.5 1.1c-.8 1.1-1.5 2.4-2 3.7l-.4 1l-.2-.9c-.3-1.1-.6-2.7-.6-3.8c0-1 0-1 .7-1.9c.8-1.1 2.7-3.1 3.7-3.9c.4-.3 1.1-.8 1.6-1c1-.5 1.3-.7 1.3-1c0-.4-.3-.6-.8-.5c-.3.1-1.4-.1-3.3-.5c-1.6-.3-2.9-.6-3-.6c0 0 .1-.6.3-1.2c.2-.8.4-1.3.6-1.5c.4-.4.4-.9 0-1.2c-.6-.6-1.6-.1-1.5.8l.1.4l-.8.1c-.5.1-1.6.3-2.4.5c-1.8.5-3.1.6-4 .2c-.3-.1-.5-.2-.5-.2v.3c0 .5.3 1 .9 1.3l.5.3l-.4.1c-.2.1-.8.1-1.3 0s-.9 0-.9 0c0 .3.6 1 1 1.2c.9.5 2.7.3 4.8-.4c1-.4 2.4-.5 2.3-.2c0 .2-1.8 1.5-4.9 3.7c-1.6 1.1-1.8 1.4-1.6 1.9c.1.3.1.4-.3 1c-.8 1.4-1.6 3.8-1.6 5c0 .6 0 .7-.9 1.6c-1.7 1.8-5.1 6-5.8 7.3l-.2.3l-.2-.3c-.5-.6-1.5-.3-1.5.5c0 .5.3.8.9.8c.3 0 1 .3 2.1.8l1.7.8l-.4.5c-.6.7-.7 1.2-.4 1.6c.2.2.3.2 1.1.2s1 .1 1.9.5c.9.4 1.2.7 2.5 2c3.8 3.9 4.8 4.9 6.9 6.2c.6.3 1.1.5 1.3.5c.2-.1.6-.4 1-.8c1.7-2 3.1-1.5 6.3.3c1.6.9 2.2 1.1 2.4 1.1v-.2c.4-1.8 1-2.4 2.4-2.6c.8-1.7 1.5-3.5 2-5.4h-2.3l-1.3-.1l.1-.4c.1-.6.5-1.3 1.1-1.9c.3-.3.5-.6.6-.6c0 0 .4.2.9.5c.4.3.9.6 1.3.8c.2-1.1.4-2.3.5-3.4c-.3-.8-.5-1.7-.4-2m-14.7-18c.3-1.2.6-2.3.7-2.3c.1 0 1.1.2 2.3.5c2.7.5 2.7.6 2.2.7c-.2.1-1.5.4-2.8.8l-2.5.7l.1-.4M36.1 35.2h-.4c-.5-.1-4.3-1.8-4.3-2c0-.5 3.6-5.1 5.7-7.3l.8-.8v.4c0 .2.1.8.2 1.2l.2.8l-1.1 3.9l-1.1 3.8m4 2c-.1 0-.8-.3-1.5-.8c-.7-.4-1.5-.8-1.7-.9l-.4-.1l1-3.5c.5-1.9 1-3.5 1-3.5c.1 0 .2.3.4.7c.2.5.3.9.3 2v1.3h.8v1.1c0 .6.1 1.6.3 2.1c.2 1 .2 1.6-.2 1.6m1.6-9.3l-.4 1.2h-.9c-.5 0-.9 0-1-.1c-.2-.2 0-1.1.3-1.6s1.2-1 1.8-1c.2 0 .4 0 .4.1c.2.1 0 .7-.2 1.4m2.4 1.3h-1.2l.1-.4c.1-.2.2-.6.3-1l.2-.7l.4.3c.3.2.6.6.9.9c.2.3.4.6.4.7c0 .1-.5.2-1.1.2m.3-13.9c-.5.1-1.4.4-1.9.5c-.5.1-.8.2-.8.2c.1-.1 4.2-3.1 4.3-3.1v.2c0 .1-.2.6-.3 1.1l-.3.8l-1 .3m4.8 21.8c-1.1-.8-2.2-2.2-2.8-3.7c-.4-.9-.4-1-.1-1c.2 0 .2-.3.2-1.6v-1.6h-.4c-.3 0-.4-.1-.5-.5c-.1-.3-.2-1.2-.2-2.3c0-1.9.2-2.7 1-4.5c.4-1 .6-.9.6.1c0 .7.3 2.2.7 3.3c.3.8.3 1 .2 1.5c-.1.3-.2 1.1-.3 1.9c-.2 2.4.2 4.7 1.2 6.9c.3.6.6 1.3.6 1.5l.1.3l-.3-.3m3.3-2.6c0 .1-.3.9-.6 1.8s-.6 1.7-.6 1.8c0 .1-.3 0-.6-.1c-.4-.2-.5-.3-.7-.9c-.2-.6-.2-.7.2-1.2c.4-.7 1-1.2 1.7-1.3c.6-.3.6-.3.6-.1m3.5 4.9c-.4 0-1.2-.2-1.9-.3l-1.3-.3l.3-1c.2-.5.5-1.5.6-2.1c.3-1.1.4-1.2.9-1c.2.1.3.3.5 1.1c.2.7.5 1.5.9 2.4l.7 1.3l-.7-.1m2.2-2.3c-.3.4-.7.9-.8 1.2c-.1.3-.2.6-.3.7c-.2.3-1.7-3.1-1.7-3.8c0-.3.5-.1 2 .6l1.3.6l-.5.7",
      fill: "#ffce31"
    }),
    createElementVNode("g", { fill: "#3e4347" }, [
      createElementVNode("path", { d: "M56.6 47.6v.2c-.2 0-.8-.2-2.4-1.1c-3.2-1.9-4.6-2.4-6.3-.3c-.4.4-.8.7-1 .8c-.2-.1-.7-.2-1.3-.5c-.2-.1-.5-.2-.7-.3c-1.9-1-3.3-1.3-4.4-1c-.7.2-1.2.6-1.5 1.3c-.2.4-.4.7-.6.7c-.5.1-2.2-.9-2.8-1.3c-2.3-1.4-3.7-1.5-5.8-.1c-.4.3-.8.5-1 .5c-.1 0-.5-.1-.9-.2c-.5-.2-.9-.4-1-.5c-.2-.4-.6-.6-1-.5l-.1.1V47c.3.3.8.6 1.5.8c1.6.6 2 .5 3.5-.5c1.4-.9 2.1-1 3.8.1c1.9 1.2 3.1 1.8 4.2 1.5c.9-.2 1.4-1 1.7-1.6c.2-.3.3-.4.5-.4c.3-.1 1.1-.1 3 .8c.2.1 2.1 1.1 2.9 1.1c.5 0 1.1-.4 1.5-.7c.4-.3.7-.6.8-.7c.8-.9 1-1.1 4.1.7c1.3.8 2.3 1.2 3.1 1.3c.3-.4.6-.8.9-1.3l.2-.3c.4-.6.8-1.3 1.1-2l.1-.2c.1-.3.3-.5.4-.8c-1.5.4-2.1 1-2.5 2.8" }),
      createElementVNode("path", { d: "M25.5 34l.3.2v-.5z" }),
      createElementVNode("path", { d: "M23.1 34l1.3.3l.3-.3l-.3-.4z" }),
      createElementVNode("path", { d: "M24.8 33.3l.3.3l.4-.3l-.4-1.3z" }),
      createElementVNode("path", { d: "M25.8 37.2v-1.7l-.6-1.2H25l-1.3 2.9h.8l.5.7h.2l.5-.7h.1" }),
      createElementVNode("path", { d: "M17.5 34l.3.3l1.3-.3l-1.3-.4z" }),
      createElementVNode("path", { d: "M15 34l1.3.3l.3-.3l-.3-.4z" }),
      createElementVNode("path", { d: "M16.7 33.3l.3.3l.4-.3L17 32z" }),
      createElementVNode("path", { d: "M16.9 34.3l-1.3 2.9h.9l.4.7h.2l.5-.7h.8l-1.3-2.9z" }),
      createElementVNode("path", { d: "M9.4 34l.3.3L11 34l-1.3-.4z" }),
      createElementVNode("path", { d: "M8.5 34l-.3-.4l-1.3.4l1.3.3z" }),
      createElementVNode("path", { d: "M8.6 33.3l.4.3l.3-.3L9 32z" }),
      createElementVNode("path", { d: "M8.8 34.3l-1.2 2.9h.8l.4.7h.3l.4-.7h.9l-1.3-2.9z" }),
      createElementVNode("path", { d: "M25 23.7h.2l.5-.7h.1v-1.4h-1.4l-.7 1.4h.8z" }),
      createElementVNode("path", { d: "M16.9 23.7h.2l.5-.7h.8l-.6-1.4h-1.5l-.7 1.4h.9z" }),
      createElementVNode("path", { d: "M8.8 23.7h.3l.4-.7h.9l-.7-1.4H8.2L7.6 23h.8z" }),
      createElementVNode("path", { d: "M6.9 27l-1.3-.4l-.3.4l.3.3z" }),
      createElementVNode("path", { d: "M4.5 27l-.3-.4l-1.3.4l1.3.3z" }),
      createElementVNode("path", { d: "M5.3 26.3L4.9 25l-.3 1.3l.3.3z" }),
      createElementVNode("path", { d: "M4.8 27.3l-1.3 2.9h.8l.5.7H5l.4-.7h.9L5 27.3z" }),
      createElementVNode("path", { d: "M15 27l-1.3-.4l-.3.4l.3.3z" }),
      createElementVNode("path", { d: "M12.6 27l-.3-.4l-1.3.4l1.3.3z" }),
      createElementVNode("path", { d: "M13.3 26.3L13 25l-.3 1.3l.3.3z" }),
      createElementVNode("path", { d: "M12.9 27.3l-1.3 2.9h.8l.5.7h.2l.4-.7h.9l-1.3-2.9z" }),
      createElementVNode("path", { d: "M23.1 27l-1.3-.4l-.3.4l.3.3z" }),
      createElementVNode("path", { d: "M20.7 27l-.3-.4l-1.3.4l1.3.3z" }),
      createElementVNode("path", { d: "M21.4 26.3l-.3-1.3l-.4 1.3l.4.3z" }),
      createElementVNode("path", { d: "M21 27.3l-1.3 2.9h.8l.5.7h.2l.4-.7h.9l-1.3-2.9z" }),
      createElementVNode("path", { d: "M13.4 41.5l.3.3l1.3-.3l-1.3-.4z" }),
      createElementVNode("path", { d: "M11 41.5l1.3.3l.3-.3l-.3-.4z" }),
      createElementVNode("path", { d: "M12.7 40.8l.3.3l.3-.3l-.3-1.3z" }),
      createElementVNode("path", { d: "M21.5 41.5l.3.3l1.3-.3l-1.3-.4z" }),
      createElementVNode("path", { d: "M19.1 41.5l1.3.3l.3-.3l-.3-.4z" }),
      createElementVNode("path", { d: "M20.7 40.8l.4.3l.3-.3l-.3-1.3z" })
    ]),
    createElementVNode("g", { fill: "#ed4c5c" }, [
      createElementVNode("path", { d: "M22.7 21.6l-7.3-6v6h10.4h-1.4z" }),
      createElementVNode("path", { d: "M18.9 9.3h6.9V3.7z" }),
      createElementVNode("path", { d: "M18.9 13.4l6.9 5.6v1.4v-7z" }),
      createElementVNode("path", { d: "M3.9 21.5v.1h7.3v-6.1z" })
    ]),
    createElementVNode("path", {
      fill: "#dc241f",
      d: "M25.8 2.6v.5v-.5"
    }),
    createElementVNode("g", { fill: "#699635" }, [
      createElementVNode("path", { d: "M25.8 20.4V19l-6.9-5.6h-3.5v2.2l7.3 6h3.1v-.3z" }),
      createElementVNode("path", { d: "M25.8 3.1v-.5c-3.5.7-6.9 2.1-9.8 4c-.2.1-.4.2-.6.4v2.3h3.5l6.9-5.6v-.6" }),
      createElementVNode("path", { d: "M8.5 13.4c-1.9 2.4-3.5 5.1-4.6 8.1l7.3-6v-2.1H8.5" })
    ]),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M53.3 48.2c-3.1-1.8-3.3-1.6-4.1-.7c-.1.1-.4.4-.8.7c-.4.4-1 .7-1.5.7c-.8 0-2.7-1-2.9-1.1c-1.9-1-2.7-.9-3-.8c-.1 0-.3.1-.5.4c-.3.6-.8 1.4-1.7 1.6c-1.1.3-2.3-.3-4.2-1.5c-1.8-1.1-2.5-1-3.8-.1c-1.5 1-1.9 1-3.5.5c-.7-.2-1.2-.5-1.5-.8v.5c.3.4.9.8 1.8 1.1c1.6.6 2 .5 3.5-.5c1.4-.9 2.1-1 3.8.1c1.9 1.2 3.1 1.8 4.2 1.5c.9-.2 1.4-1 1.7-1.6c.2-.3.3-.4.5-.4c.3-.1 1.1-.1 3 .8c.2.1 2.1 1.1 2.9 1.1c.7 0 1.5-.7 2-1.2l.3-.3c.8-.9 1-1.1 4.1.7c.9.5 1.7.9 2.3 1.2c.2-.2.3-.4.5-.6c-.8-.1-1.8-.6-3.1-1.3" }),
      createElementVNode("path", { d: "M32.7 51.7c.8-.1 1.4 0 2.5.7c2.2 1.2 3.1 1.3 4.5.4c1.7-1 2.4-1.2 3.8-.9c1 .2 1.1.2.7-.2c-.9-.8-2.6-.8-4.1 0c-1.8.9-2.6.9-4.6 0c-1.8-.8-2.4-.9-3.3-.3c-.6.4-.5.4.5.3" }),
      createElementVNode("path", { d: "M49.9 52.5c-1.4-.3-1.6-.1-.3.6c1 .5 2 .6 3.6.2c.4-.4.8-.9 1.2-1.3c-2 .6-3.4.8-4.5.5" }),
      createElementVNode("path", { d: "M47.4 55.9c-1.5 1.2-2.4 1.2-4 .1c-1.4-1-2.4-1-4.2-.1c-1.1.5-1.3.7-.9.8c.3.1.9 0 1.5-.2c1.4-.6 2.1-.6 3.8.5c.9.5 1.7 1 1.9 1s.8-.4 1.5-.8c1.4-.9 2.1-1.3 3-1.2c.3-.2.5-.4.8-.6c-1.6-.7-2.1-.6-3.4.5" }),
      createElementVNode("path", { d: "M41.6 59.2c-1.2-.9-2.4-.9-4.2 0c-1.7.8-2.2.8-4.3-.7c-1.7-1.2-1.8-1.2-2.8-.8c-.4.2-.8.5-1 .8c-.4.5-.3.5.2.3c.8-.4 2.1-.4 2.4 0c.1.2.8.7 1.5 1.1c1.6 1 3 1.1 4.6.1c1.3-.7 2.1-.8 3.9-.2c.5.1.4 0-.3-.6" })
    ]),
    createElementVNode("g", { fill: "#ed4c5c" }, [
      createElementVNode("path", { d: "M20.6 59.5c-.3-.1-.2-.4 0-.4c.3-.1.6.2 1.4.2c.2 0 .4 0 .4-.4c0-.5-.4-.9-1.8-.7c-1.1.2-2 .2-2.6.1v.5c.8.4 1.5.8 2.3 1.1c.1-.3.2-.4.3-.4" }),
      createElementVNode("path", { d: "M3.7 42c.7 1.8 1.5 3.6 2.5 5.3c.5.5 3.2 3.5 2.5 3.7c1.7 2 3.6 3.8 5.7 5.4c.2 0 7.3 3.6 7.1 3.8c1.4.5 2.8.9 4.3 1.2V42H3.7" })
    ]),
    createElementVNode("g", { fill: "#ffe62e" }, [
      createElementVNode("path", { d: "M23.5 48.6c-.1-.2-.2-.3-.5-.2c-.8.2-3 .1-3.7-.3c1.1.4 2.4-.4 2.4-1.1c0-.8-1-1.4-3.2-1c-2.1.4-4.7.2-4.7-.4c0-.6 1.9-.7 2.8-.6c1 .1 1.6.2 3.4-.3c-.4.1-1.9.2-3-.1c-1.1-.3-3.9-.3-3.9 1s2.9 1.2 5.5.9c1.5-.2 2.3-.1 2.3.4c0 .4-1.4.6-2.4.5c-1-.1-2.1-.1-3.4.2c-2.2.6-4.8.2-5.4-.8c0-.1.1-.2.1-.4c.2-.1.3-.4.4-.6c.1-.5-.1-.5-.7-.3c-.2-.2-.6-.3-1.2-.3s-.9.1-1.2.3c-.6-.2-.8-.2-.7.3c.1.2.2.5.4.6c0 .7.9 1.8.9 1.8c-.5 0-1.1-.4-1.6-.9c.5.8.9 1.5 1.5 2.2c.2.2.3.3.4.5c.2.3.5.6.7.9c.7-.1 1.3-.4 2-.9c.4 0 3.1-.1 4.2-.6c.7.7.8.6 1.4.7c.6.1 1 .1.6.4c-.1.1-.8.1-1.2.1c-1.1 0-1.6-.6-1.9-.3c-.2.3 0 .4.4.4c-.3 0-.7 0-.6.3c.1.5.7-.1.9.1c-.2 0-.5.1-.5.2c0 .2.4.4.9 0c.3-.2.6-.2.8-.2c.7 0 2.4.3 3-.2c.2-.2-.1-.4-.3-.6c-.2-.2-.3-.4-.2-.9c.6.1 1.4.1 2.6-.1c1.4-.2 1.8.2 1.8.7c0 .4-.3.4-.4.4c-.8 0-1.1-.2-1.4-.2c-.2.1-.3.3 0 .4c-.2.1-.2.3-.1.4c.1.1.4 0 .7-.1c-.3.1-.6.3-.4.5c.1.1.3.2.6 0c.2-.3.7-.4.9-.5c.9.2 1.4-1.3 1-2.3" }),
      createElementVNode("path", { d: "M23.5 57.2c-.1-.2-.2-.3-.5-.2c-.8.2-3 .1-3.7-.3c1.1.4 2.4-.4 2.4-1.1c0-.8-1-1.4-3.2-1c-2.1.4-4.7.2-4.7-.4s1.9-.7 2.8-.6c1 .1 1.6.2 3.4-.3c-.4.2-1.9.2-3-.1c-1.1-.3-3.9-.3-3.9 1s2.9 1.2 5.5.9c1.5-.2 2.3-.1 2.3.4c0 .4-1.4.6-2.4.5c-1-.1-2.1-.1-3.4.2c-.2.1-.5.1-.7.2c1.2.8 2.4 1.6 3.7 2.3v-.5c.6.1 1.4.1 2.6-.1c1.4-.2 1.8.2 1.8.7c0 .4-.3.4-.4.4c-.8 0-1.1-.2-1.4-.2c-.2.1-.3.3 0 .4c-.1.1-.2.1-.2.2c.1.1.3.1.4.2h.1c.2.1.4.2.6.2c.2-.2.6-.3.8-.3c1 0 1.5-1.5 1.1-2.5" })
    ])
  ]);
}
function p$K(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3712)" }, [
      createElementVNode("path", {
        d: "M17.7395 1.45932C16.0346 0.529135 14.0793 0.000244141 12.0004 0.000244141C9.92149 0.000244141 7.96615 0.529135 6.26126 1.45932L5.21777 12.0002L6.26126 22.5412C7.96615 23.4714 9.92149 24.0002 12.0004 24.0002C14.0793 24.0002 16.0346 23.4714 17.7395 22.5412L18.783 12.0002L17.7395 1.45932Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M6.26086 22.5408V1.45898C2.53073 3.4943 0 7.45144 0 12C0 16.5485 2.53073 20.5056 6.26086 22.5408Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M24.0001 12.0002C24.0001 7.45168 21.4694 3.49454 17.7393 1.45923V22.541C21.4694 20.5059 24.0001 16.5487 24.0001 12.0002Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M9.3917 15.1298L7.30469 11.9993L9.39166 8.8689L11.4787 11.9993L9.3917 15.1298Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M14.6094 15.1298L12.5225 11.9993L14.6094 8.8689L16.6964 11.9993L14.6094 15.1298Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.001 19.3037L9.91406 16.1733L12.001 13.0428L14.088 16.1733L12.001 19.3037Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3712" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$J(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3753)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C4.12172 7.87828 7.61737 4.38263 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M9.61098 7.82617L9.80527 8.42406H10.4339L9.92527 8.79348L10.1196 9.39137L9.61098 9.02186L9.10238 9.39137L9.29668 8.79348L8.78809 8.42406H9.41668L9.61098 7.82617Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.45448 3.13116L6.77824 4.12768H7.826L6.97831 4.74338L7.30217 5.73985L6.45448 5.12396L5.60684 5.73985L5.93065 4.74338L5.08301 4.12768H6.13067L6.45448 3.13116Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.58534 4.17499L9.9091 5.17155H10.9568L10.1092 5.78725L10.4329 6.78372L9.58534 6.16783L8.7377 6.78372L9.06151 5.78725L8.21387 5.17155H9.26153L9.58534 4.17499Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.11072 8.349L7.43454 9.34551H8.48219L7.63455 9.96122L7.95836 10.9577L7.11072 10.3418L6.26309 10.9577L6.5869 9.96122L5.73926 9.34551H6.78696L7.11072 8.349Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M4.36752 5.73987L4.69133 6.73638H5.73903L4.89135 7.35209L5.21516 8.34856L4.36752 7.73271L3.51992 8.34856L3.84369 7.35209L2.99609 6.73638H4.04375L4.36752 5.73987Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3753" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$I(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3754)" }, [
      createElementVNode("path", {
        d: "M24 11.9997C24 18.6271 18.6274 23.9997 12 23.9997C5.37262 23.9997 0 18.6271 0 11.9997C0.521719 11.9997 12 10.4345 12 10.4345L24 11.9997Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M16.7631 8.28088L11.9998 13.0442L7.23659 8.28088C6.6206 9.19527 6.26074 10.2959 6.26074 11.4789V13.0441C6.26074 15.5574 7.88473 17.6983 10.1383 18.4732C9.83754 19.0627 9.88826 19.7984 10.329 20.3485C10.9144 19.8793 11.5204 19.3936 12.0346 18.9817C12.5487 19.3937 13.1548 19.8794 13.7401 20.3485C14.186 19.792 14.2331 19.0453 13.9204 18.4523C16.1433 17.6606 17.7389 15.5354 17.7389 13.0441V11.479C17.739 10.2959 17.3791 9.19532 16.7631 8.28088Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0001 17.2176C9.69855 17.2176 7.82617 15.3451 7.82617 13.0437V11.4785C7.82617 9.17694 9.69859 7.30457 12.0001 7.30457C14.3015 7.30457 16.174 9.17699 16.174 11.4785V13.0437C16.174 15.3451 14.3016 17.2176 12.0001 17.2176Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.609 13.0433V11.4781C14.609 10.0397 13.4387 8.86945 12.0003 8.86945C10.5619 8.86945 9.3916 10.0397 9.3916 11.4781V13.0433L12.0003 13.565L14.609 13.0433Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M9.3916 13.0432C9.3916 14.4817 10.5619 15.6519 12.0003 15.6519C13.4387 15.6519 14.609 14.4816 14.609 13.0432H9.3916Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M15.13 7.30397C15.13 6.43955 14.4292 5.73876 13.5648 5.73876C13.1638 5.73876 12.7983 5.8897 12.5213 6.13762V5.217H13.043V4.17351H12.5213V3.65179H11.4778V4.17351H10.9561V5.217H11.4778V6.13762C11.2008 5.8897 10.8353 5.73876 10.4343 5.73876C9.56992 5.73876 8.86914 6.43955 8.86914 7.30397C8.86914 7.76742 9.07075 8.18367 9.39086 8.47031V9.39094H14.6082V8.47031C14.9284 8.18367 15.13 7.76742 15.13 7.30397Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3754" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$i(c3, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { fill: "#83bf4f" }, [
      createElementVNode("path", { d: "M60 42c-5.5 0-10-4.5-10-10H10.8v21.2C16.2 58.6 23.7 62 32 62c13.1 0 24.2-8.4 28.3-20H60" }),
      createElementVNode("path", { d: "M60 22h.3C56.2 10.4 45.1 2 32 2c-8.3 0-15.8 3.4-21.2 8.8V32H50c0-5.5 4.5-10 10-10" })
    ]),
    createElementVNode("path", {
      d: "M60.3 22H10.8v20h49.5c1.1-3.1 1.7-6.5 1.7-10s-.6-6.9-1.7-10",
      fill: "#ffe62e"
    }),
    createElementVNode("path", {
      d: "M10.8 10.8C5.4 16.2 2 23.7 2 32s3.4 15.8 8.8 21.2L32 32L10.8 10.8z",
      fill: "#ed4c5c"
    }),
    createElementVNode("g", { fill: "#3e4347" }, [
      createElementVNode("path", { d: "M40 34.1l2.5 1.9l-1-3.1l2.5-1.8l-3-.1l-1-3l-1 3l-3 .1l2.5 1.8l-1 3.1z" }),
      createElementVNode("path", { d: "M52 34.1l2.5 1.9l-1-3.1l2.5-1.8l-3-.1l-1-3l-1 3l-3 .1l2.5 1.8l-1 3.1z" })
    ])
  ]);
}
function h$g(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3756)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M6.7832 14.3477C6.7832 15.2121 7.48399 15.9129 8.34841 15.9129H13.0441C13.0441 16.6332 13.628 17.2172 14.3484 17.2172H15.9136C16.634 17.2172 17.218 16.6332 17.218 15.9129V14.3477H6.7832Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M17.3472 6.78308V10.4352C17.3472 11.0106 16.8791 11.4787 16.3037 11.4787V13.0439C17.7422 13.0439 18.9124 11.8737 18.9124 10.4352V6.78308H17.3472Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.1304 10.435C6.1304 11.0104 5.6623 11.4785 5.08691 11.4785V13.0437C6.52537 13.0437 7.6956 11.8734 7.6956 10.435V6.78284H6.1304V10.435Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M16.5652 6.78308H15V10.4353H16.5652V6.78308Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.6524 8.87005C12.6524 9.01391 12.5354 9.13091 12.3916 9.13091C12.2477 9.13091 12.1307 9.01386 12.1307 8.87005V6.78308H10.5655V8.87005C10.5655 9.01391 10.4484 9.13091 10.3046 9.13091C10.1608 9.13091 10.0438 9.01386 10.0438 8.87005V6.78308H8.47852V8.87005C8.47852 9.87697 9.2977 10.6962 10.3046 10.6962C10.6924 10.6962 11.0521 10.5743 11.3481 10.3673C11.6441 10.5742 12.0038 10.6962 12.3916 10.6962C12.4697 10.6962 12.5465 10.6907 12.622 10.6811C12.5111 11.138 12.0995 11.4787 11.609 11.4787V13.0439C13.0474 13.0439 14.2177 11.8737 14.2177 10.4353V8.87005V6.78308H12.6525V8.87005H12.6524Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.8263 11.4781H8.47852V13.0433H10.8263V11.4781Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3756" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$H(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3757)" }, [
      createElementVNode("path", {
        d: "M17.2175 1.19084C15.6399 0.427997 13.87 0.00012207 12.0001 0.00012207C10.1303 0.00012207 8.36037 0.427997 6.78274 1.19084L5.73926 12.0001L6.78274 22.8094C8.36037 23.5722 10.1303 24.0001 12.0001 24.0001C13.87 24.0001 15.6399 23.5722 17.2175 22.8094L18.261 12.0001L17.2175 1.19084Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12 7.82605L13.0359 11.0145H16.3888L13.6764 12.9853L14.7124 16.1738L12 14.2032L9.28753 16.1738L10.3237 12.9853L7.61133 11.0145H10.964L12 7.82605Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M6.78262 1.1908C2.76872 3.13175 0 7.24217 0 11.9997C0 16.7571 2.76872 20.8676 6.78262 22.8085V1.1908Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M17.2178 1.19141V22.8091C21.2317 20.8682 24.0004 16.7578 24.0004 12.0003C24.0004 7.24278 21.2317 3.13236 17.2178 1.19141Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3757" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$G(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3758)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 0C5.37262 0 0 5.37262 0 12C0 13.4678 0.264047 14.874 0.746391 16.1739H23.2537C23.736 14.874 24 13.4678 24 12C24 5.37262 18.6274 0 12 0Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0007 0.00012207C6.8411 0.00012207 2.44259 3.25662 0.74707 7.82623H23.2543C21.5588 3.25662 17.1603 0.00012207 12.0007 0.00012207Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.10352 6.78314V12.7694C3.10352 16.1746 7.552 17.2179 7.552 17.2179C7.552 17.2179 12.0004 16.1746 12.0004 12.7694V6.78314H3.10352Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.94238 7.82638H10.1598V5.73941L9.11632 6.26113L7.55112 4.69592L5.98587 6.26113L4.94238 5.73941V7.82638Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M10.9565 13.6026L7.56514 10.2112L4.17383 13.6026L5.28059 14.7093L7.56514 12.4248L9.84969 14.7093L10.9565 13.6026Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M10.9565 10.4341H9.37414C9.46311 10.2805 9.51486 10.1027 9.51486 9.91244C9.51486 9.33607 9.04766 8.86896 8.47137 8.86896C8.07317 8.86896 7.72737 9.09199 7.55145 9.41988C7.37553 9.09204 7.02973 8.86896 6.63153 8.86896C6.05525 8.86896 5.58805 9.33607 5.58805 9.91244C5.58805 10.1027 5.6398 10.2806 5.72877 10.4341H4.17383C4.17383 11.0104 4.67581 11.4776 5.25205 11.4776H5.21731C5.21731 12.0539 5.68447 12.521 6.2608 12.521C6.2608 13.0313 6.62726 13.4553 7.11125 13.546L6.28906 15.4023C6.68309 15.5625 7.11369 15.6515 7.56519 15.6515C8.01669 15.6515 8.44728 15.5625 8.84131 15.4023L8.01912 13.546C8.50311 13.4553 8.86958 13.0314 8.86958 12.521C9.44591 12.521 9.91306 12.0539 9.91306 11.4776H9.87833C10.4545 11.4776 10.9565 11.0103 10.9565 10.4341Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3758" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$o(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3759)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M20.1006 3.14638C17.9659 1.19206 15.1224 -0.000671387 12.0002 -0.000671387C11.489 -0.000671387 10.9854 0.0315317 10.491 0.0935474L4.69581 6.78195L0.379883 15.0055C0.658695 16.0865 1.08498 17.108 1.63496 18.0485L12.0002 11.9993L20.1006 3.14638Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M21.9903 18.6479L5.20117 21.8879C7.13378 23.2192 9.47556 23.9993 11.9998 23.9993C16.168 23.9993 19.8392 21.8738 21.9903 18.6479Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M20.1021 3.14819L1.6416 18.0603C2.12446 18.8838 2.70257 19.6446 3.36102 20.3276L23.9999 11.9996C23.9999 8.49522 22.4976 5.34204 20.1021 3.14819Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 12C0 13.0382 0.131906 14.0455 0.379734 15.0062L10.4909 0.0942383C4.57584 0.836457 0 5.88377 0 12Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3759" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$F(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3760)" }, [
      createElementVNode("path", {
        d: "M23.2536 16.1743C23.736 14.8744 24 13.4683 24 12.0005C24 10.5326 23.736 9.12655 23.2536 7.82656L12 6.78308L0.746391 7.82656C0.264 9.12655 0 10.5326 0 12.0005C0 13.4683 0.264 14.8744 0.746391 16.1743L12 17.2178L23.2536 16.1743Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0006C17.1593 24.0006 21.5578 20.7441 23.2533 16.1744H0.746094C2.44166 20.7441 6.84012 24.0006 11.9997 24.0006Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M11.9997 0.00012207C6.84012 0.00012207 2.44166 3.25662 0.746094 7.82623H23.2534C21.5578 3.25662 17.1593 0.00012207 11.9997 0.00012207Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3760" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$f(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3761)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.30353 6.26101C7.30353 4.51267 8.53226 3.05214 10.1731 2.69378C9.92089 2.63875 9.65928 2.60889 9.39045 2.60889C7.37337 2.60889 5.73828 4.24398 5.73828 6.26106C5.73828 8.27814 7.37337 9.91323 9.39045 9.91323C9.65919 9.91323 9.92084 9.88337 10.1731 9.82829C8.53226 9.46993 7.30353 8.0094 7.30353 6.26101Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9995 2.87L12.2585 3.66711H13.0967L12.4186 4.15981L12.6776 4.95692L11.9995 4.46431L11.3214 4.95692L11.5804 4.15981L10.9023 3.66711H11.7405L11.9995 2.87Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.96639 4.43469L10.2254 5.23185H11.0635L10.3855 5.7245L10.6445 6.52161L9.96639 6.029L9.2882 6.52161L9.54728 5.7245L8.86914 5.23185H9.70731L9.96639 4.43469Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M14.0327 4.43469L14.2918 5.23185H15.1299L14.4518 5.7245L14.7108 6.52161L14.0327 6.029L13.3546 6.52161L13.6136 5.7245L12.9355 5.23185H13.7737L14.0327 4.43469Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.2505 6.78345L13.5095 7.5806H14.3476L13.6695 8.07326L13.9286 8.87037L13.2505 8.37776L12.5724 8.87037L12.8314 8.07326L12.1533 7.5806H12.9914L13.2505 6.78345Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.7486 6.78345L11.0076 7.5806H11.8458L11.1676 8.07326L11.4267 8.87037L10.7486 8.37776L10.0704 8.87037L10.3295 8.07326L9.65137 7.5806H10.4895L10.7486 6.78345Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3761" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$E(i, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3762)" }, [
      createElementVNode("path", {
        d: "M5.2373 21.9127C7.16321 23.2292 9.49182 23.9997 12.0008 23.9997C14.5097 23.9997 16.8384 23.2292 18.7642 21.9127L12.0008 20.8693L5.2373 21.9127Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.7642 2.08709C16.8384 0.770606 14.5097 0.00012207 12.0008 0.00012207C9.49182 0.00012207 7.16312 0.770606 5.2373 2.08709L12.0008 3.13057L18.7642 2.08709Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M5.2373 21.9127C7.16321 23.2292 9.49182 23.9997 12.0008 23.9997C14.5097 23.9997 16.8384 23.2292 18.7642 21.9127L12.0008 20.8693L5.2373 21.9127Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.7642 2.08709C16.8384 0.770606 14.5097 0.00012207 12.0008 0.00012207C9.49182 0.00012207 7.16312 0.770606 5.2373 2.08709L12.0008 3.13057L18.7642 2.08709Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.9706 11.2165C23.6863 7.51292 21.436 3.91217 18.7646 2.08606H5.2377C2.2782 4.10923 0.27068 7.42274 0.0263672 11.2165L12.0012 11.9991L23.9706 11.2165Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M0.0253906 12.7823C0.269703 16.5761 2.27717 19.8895 5.23667 21.9127H18.7636C21.7232 19.8896 23.7306 16.5761 23.9749 12.7823L12.0002 11.9996L0.0253906 12.7823Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.9694 11.2173H12.7826V1.56519H11.2174V11.2173H0.0252656C0.008625 11.4761 0 11.737 0 12C0 12.2629 0.00857813 12.5238 0.0252187 12.7826H11.2174V22.4348H12.7826V12.7826H23.9748C23.9914 12.5238 24 12.2629 24 12C24 11.7389 23.9895 11.4779 23.9694 11.2173Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.69629 11.9992L12.0006 7.4082L19.305 11.9992L12.0006 16.5903L4.69629 11.9992Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.82617 14.0872H17.2174L15.1305 10.9568L14.087 12.0003L13.0435 11.4786L12.0001 13.0438H9.91309L8.86961 12.0003L7.82617 14.0872Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0004 8.8689L12.2595 9.66601H13.0975L12.4195 10.1587L12.6785 10.9559L12.0004 10.4632L11.3223 10.9559L11.5814 10.1587L10.9033 9.66601H11.7414L12.0004 8.8689Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0006 6.09656L2.60938 11.9993L12.0006 17.9021L21.392 11.9993L12.0006 6.09656ZM5.55069 11.9993L12.0006 7.94526L18.4507 11.9993L12.0006 16.0534L5.55069 11.9993Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3762" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$D(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3700)" }, [
      createElementVNode("path", {
        d: "M10.9565 13.0426C10.9565 13.0426 3.52168 3.51219 3.51465 3.51388C5.68618 1.3423 8.68623 -0.000854492 12 -0.000854492C18.6273 -0.000854492 24 5.37177 24 11.9991L10.9565 13.0426Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M10.9565 11.9995C10.9565 11.9995 3.52168 20.4865 3.51465 20.4848C5.68618 22.6563 8.68623 23.9995 12 23.9995C18.6273 23.9995 24 18.6269 24 11.9995H10.9565Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51465C-1.17157 8.20093 -1.17157 15.7989 3.51471 20.4853C5.45126 18.5487 7.31375 16.6862 12 12L3.51471 3.51465Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.3157 11.9995C1.30914 12.0857 1.30469 12.1725 1.30469 12.2603C1.30469 14.1333 2.82306 15.6516 4.696 15.6516C6.56894 15.6516 8.08731 14.1333 8.08731 12.2603C8.08731 12.1725 8.08286 12.0856 8.0763 11.9995H1.3157Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M4.69583 10.4338C5.27213 10.4338 5.73931 9.96659 5.73931 9.39029C5.73931 8.81399 5.27213 8.3468 4.69583 8.3468C4.11953 8.3468 3.65234 8.81399 3.65234 9.39029C3.65234 9.96659 4.11953 10.4338 4.69583 10.4338Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M2.34766 9.13025V12.5216C2.34766 14.3187 4.69548 14.8694 4.69548 14.8694C4.69548 14.8694 7.04331 14.3187 7.04331 12.5216V9.13025H2.34766Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.69712 13.7777C4.26155 13.6209 3.3916 13.2203 3.3916 12.5219V10.1741H6.00033V12.5219C6.00033 13.2226 5.13048 13.6222 4.69712 13.7777Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M5.21743 11.4777V10.9559L4.69571 10.6951L4.17395 10.9559V11.4777L3.91309 11.7386V12.782H5.47834V11.7386L5.21743 11.4777Z",
        fill: "#F3F3F3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3700" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$C(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3701)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 23.9996C18.6274 23.9996 24 18.6269 24 11.9996C24 10.5317 23.736 9.12562 23.2536 7.82568H0.746391C0.264047 9.12562 0 10.5317 0 11.9996C0 18.6269 5.37262 23.9996 12 23.9996Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9997C17.1593 23.9997 21.5578 20.7432 23.2533 16.1736H0.746094C2.44161 20.7432 6.84012 23.9997 11.9997 23.9997Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.10254 6.78186V12.7681C3.10254 16.1733 7.55102 17.2167 7.55102 17.2167C7.55102 17.2167 11.9995 16.1733 11.9995 12.7681V6.78186H3.10254Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M4.14648 6.78186V12.7681C4.14648 13.1678 4.23527 13.5454 4.41114 13.8993C6.15648 13.8993 8.76517 13.8993 10.6918 13.8993C10.8677 13.5454 10.9564 13.1678 10.9564 12.7681V6.78186H4.14648Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.63874 10.9561H8.07358V9.91261H9.11707V8.86912H8.07358V7.82568H7.03009V8.86912H5.98666V9.91261H7.03009V10.9561H5.46484V11.9996H7.03009V13.0431H8.07358V11.9996H9.63874V10.9561Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.8344 15.3573C6.50682 15.7799 7.19766 16.0252 7.55134 16.1343C7.90501 16.0253 8.59585 15.7799 9.26827 15.3573C9.94637 14.9311 10.4217 14.4437 10.6916 13.9007C10.3939 13.69 10.0307 13.5658 9.63831 13.5658C9.49543 13.5658 9.35663 13.5827 9.22318 13.6138C8.94038 12.9713 8.29843 12.5223 7.55138 12.5223C6.80434 12.5223 6.16234 12.9713 5.87959 13.6138C5.74613 13.5827 5.60729 13.5658 5.46446 13.5658C5.07207 13.5658 4.70884 13.69 4.41113 13.9007C4.6809 14.4437 5.15626 14.9311 5.8344 15.3573Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3701" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$B(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3702)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.2536 7.82637H10.4348V4.69592H4.17389V7.82637H0.746391C0.264047 9.12631 0 10.5324 0 12.0003C0 13.4681 0.264047 14.8742 0.746391 16.1742L12 17.2176L23.2536 16.1742C23.736 14.8742 24 13.4681 24 12.0003C24 10.5324 23.736 9.12631 23.2536 7.82637Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9997C17.1593 23.9997 21.5578 20.7432 23.2533 16.1736H0.746094C2.44161 20.7432 6.84012 23.9997 11.9997 23.9997Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.17383 7.82641V8.86984C4.17383 11.2661 7.30428 12.0003 7.30428 12.0003C7.30428 12.0003 10.4347 11.2661 10.4347 8.86984V7.82641L9.39125 8.86989L7.30428 7.30469L5.21731 8.86989L4.17383 7.82641Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3702" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$A(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3703)" }, [
      createElementVNode("path", {
        d: "M20.4863 20.4851C24.9868 15.9846 25.1645 8.79939 21.0213 4.08569L12.0007 11.9994L4.08691 21.0201C8.80061 25.1633 15.9858 24.9856 20.4863 20.4851Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M3.51438 3.5144C8.01488 -0.986107 15.2001 -1.16381 19.9138 2.97942L12 12.0001L2.97944 19.9138C-1.16383 15.2001 -0.986083 8.01491 3.51438 3.5144Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M19.9139 2.98022L2.97949 19.9146C3.15068 20.1094 3.32843 20.3005 3.51448 20.4864C3.70048 20.6724 3.89158 20.8502 4.0864 21.0214L21.0207 4.08703C20.8495 3.89222 20.6717 3.70116 20.4856 3.51511C20.2997 3.32921 20.1086 3.15141 19.9139 2.98022Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.05619 4.17444L5.31526 4.97164H6.15343L5.47534 5.46425L5.73433 6.26145L5.05619 5.76875L4.37805 6.26145L4.63712 5.46425L3.95898 4.97164H4.7972L5.05619 4.17444Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.33744 4.17358L9.59652 4.97079H10.4346L9.75655 5.46339L10.0156 6.2606L9.33744 5.76789L8.6593 6.2606L8.91837 5.46339L8.24023 4.97079H9.07841L9.33744 4.17358Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.05619 8.34778L5.31526 9.14498H6.15343L5.47534 9.63763L5.73433 10.4348L5.05619 9.94213L4.37805 10.4348L4.63712 9.63763L3.95898 9.14498H4.7972L5.05619 8.34778Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.33744 8.34778L9.59652 9.14498H10.4346L9.75655 9.63763L10.0156 10.4348L9.33744 9.94213L8.6593 10.4348L8.91837 9.63763L8.24023 9.14498H9.07841L9.33744 8.34778Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.19686 6.2616L7.45593 7.0588H8.29406L7.61597 7.55145L7.875 8.34865L7.19686 7.85595L6.51872 8.34865L6.77775 7.55145L6.09961 7.0588H6.93783L7.19686 6.2616Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3703" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function r$d(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3704)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.0006 6.26062L13.2956 10.2464H17.4864L14.096 12.7096L15.391 16.6954L12.0006 14.2321L8.6101 16.6954L9.90516 12.7096L6.51465 10.2464H10.7055L12.0006 6.26062Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3704" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$z(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3705)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M3.51471 20.4853C-1.17157 15.7989 -1.17157 8.20098 3.51471 3.51465C3.51438 3.51516 10.4348 12 10.4348 12L3.51471 20.4853Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M10.4351 12.0002L1.59187 6.02429C1.3177 6.50087 1.07591 6.99831 0.868164 7.51318L5.34515 12.0003L0.868305 16.4876C1.07587 17.0021 1.31741 17.4992 1.5914 17.9755L10.4351 12.0002Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.8982 10.4347H10.4342L3.51434 3.51477C2.76865 4.26046 2.12079 5.10379 1.59129 6.02399L7.55562 11.9999L1.59082 17.975C2.12032 18.8955 2.76846 19.7391 3.51434 20.485L10.4342 13.5651H23.8982C23.9649 13.0528 23.9997 12.5304 23.9997 11.9999C23.9997 11.4694 23.9649 10.947 23.8982 10.4347Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M4.69336 21.5181C6.71691 23.0735 9.24989 23.9988 11.9994 23.9988C17.5437 23.9988 22.209 20.2385 23.586 15.1293H11.0822L4.69336 21.5181Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.586 8.86869C22.209 3.7595 17.5437 -0.000854492 11.9994 -0.000854492C9.24989 -0.000854492 6.71691 0.924505 4.69336 2.47991L11.0821 8.86869H23.586Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3705" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$h(h3, d3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("defs", null, [
      createElementVNode("linearGradient", {
        id: "IconifyId17ecdb2904d178eab26137",
        gradientUnits: "userSpaceOnUse",
        x1: "-1760.792",
        x2: "-1759.792",
        gradientTransform: "matrix(-.5968 -1.5125 -1.2072 .7477 87.385 -3301.715)"
      }, [
        createElementVNode("stop", { "stop-color": "#d5dfff" }),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#ffffff"
        })
      ])
    ]),
    createElementVNode("g", { fill: "#2a5f9e" }, [
      createElementVNode("path", { d: "M32 2v30H2c0 16.6 13.4 30 30 30s30-13.4 30-30S48.6 2 32 2z" }),
      createElementVNode("path", { d: "M12 12h21v21H12z" })
    ]),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M18.9 8.1V14h-7.3L26 32h6v-7.5z" }),
      createElementVNode("path", { d: "M11 18.9H5c-1.9 4-3 8.4-3 13.1h12V13.9h-3v5" })
    ]),
    createElementVNode("path", {
      fill: "#ed4c5c",
      d: "M32 27.1L19 11h-6l17 21h2z"
    }),
    createElementVNode("path", {
      d: "M18.9 5v6H11v3h21V2c-4.7 0-9.1 1.1-13.1 3z",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M32 5H18.9c-6 2.9-11 7.9-13.9 13.9V32h6V11h21V5z",
      fill: "#ed4c5c"
    }),
    createElementVNode("path", {
      d: "M44.6 41.7c-.6.6-1.8 1.2-2.6.6c-1.1.2-.5.5-1.5-.2c-.7.2-.9.2-1.9-.2c-.5.9-1.1 1.1-1.9.5c.1-.2.3-.4.4-.6c0 .4-1.6.3-1.7.3c.9-2.9 4.6-5.3 6.7-7.3c1 1.8 3.7 4.7 2.5 6.9",
      fill: "#6a4c2d"
    }),
    createElementVNode("path", {
      fill: "#ffffff",
      d: "M48.8 42h1.5l-.7-.3l5.9-.3l-.8-.3l-.8-1l-3.6-.3l-.3-.5l-1.9-.2l-1.1.8l.8 2z"
    }),
    createElementVNode("path", {
      d: "M48.8 31.1c.1-.1.5-.2.4-.7c0-.5-.5-.6-.8-.6c-.3 0-.5.2-.5.2l-.9-.5s.4-2.7.9-2.9c.4-.3.5-.5.5-.5l-.2-.3l-2.8-.3l-2.7.3s-.2.3-.2.4c0 .1 0 .3.5.6c.5.4.9 2.7.9 2.7l-.8.3s-.3-.1-.4-.1s-.5.2-.5.7c0 .5.4.8.4.8s2.6-.3 2.9.4c.5-.6 3-.3 3.3-.5",
      fill: "#656263"
    }),
    createElementVNode("path", {
      d: "M51.5 28.3c.2-.6.6-.6 1.2-.6c1.2 0 1.1.4 1.5 1.4c.5 1.4 1.4 2.8 1.5 4.4c.1 1.7.1 4-.7 5.5c-.6 1.1.7 1.4 1.5 1.8l-.6-.2l.6.5l-.7-.3l.4.4l-1-.5l.4.4l-.8-.4c.1.2.3.3.4.5c-.2-.1-.4-.2-.7-.3v.2c-.8-.6-2-.7-2.3-1.6c-.4-1-1.2-2.5-1.1-3.6c.3-2.3 1-5.3.4-7.6",
      fill: "#3e4347"
    }),
    createElementVNode("path", {
      fill: "#00713d",
      d: "M44 39.7l-.3 1l.4-.5v1l.3-.5v1.2l.3-.6v1.1l.3-.5l.2 1l.3-.7l.4.8l.1-.6l.6.7v-.7l.7.6v-.4l.7.3v-.4l.8.2l-.5-.5h.5l-.8-.5h.4l-.7-.6h.5l-.8-.6l.4-.1z"
    }),
    createElementVNode("path", {
      d: "M41.9 31.4h2.2s1.4 0 1.6.5c.3-.6 1.5-.6 1.5-.6c.7 0 1.5-.1 2.2-.1v5.4c-.4 2.1-2 3.6-3.6 4.2c-2-.6-3.3-2.3-3.7-4.2c0-1.8-.1-3.5-.2-5.2",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M42.7 31.4l3.1 8.4l2.8-8.6c-.9.1-2.8-.1-3 .7c-.3-.8-2.3-.5-2.9-.5",
      fill: "#006b00"
    }),
    createElementVNode("g", { fill: "#cdad56" }, [
      createElementVNode("path", { d: "M44 17.8l1.8-1.5l.3-1.1l-.4.2l-.1-.5l-.1-.1l-.1.2l-.2-.4l-.3.4l.5 1l-.5.8l-.2-.5l.2-.6l-.3.1v-.6l-.4.4l-.1-.1l.4 1.2l-.3.4l-.5-1.3l-.1.3l-.2-.2l.1.7h-.2l.3.4l-.3.4l.6-.2l-.2.4z" }),
      createElementVNode("path", { d: "M42.6 17.8L41 16.4l-.1-1l.2.2l.2-.5l.2.3l.3-.4l.2.3l-.6.9l.4.7l.2-.5l-.3-.4h.4v-.5l.3.3l.2-.3l-.5 1.3l.2.3l.4-1l.2.2l.2-.2l-.1.6h.2l-.1.4l.1.3l-.5-.2l.1.4z" })
    ]),
    createElementVNode("path", {
      d: "M48.2 32.6l-.3-.4l.4-.5l-.6.1l-.1-.6l-.3.8l-.6-.3l.4.5l-1.1.8l.3.1l-.4.1l.1.2l-.3.1l.2.1h-.8V33h.8l-.4-.8l-.3.2l-.2-.3l-.7.2l.4-.5l-.6.3l-.1-.7l-.1.6l-.6-.1l.5.4l-.4.5l.5-.2l.2.6l.1-.4l.3.2h.1l.1 2l-.2.4l.1-.1l.3.7l.1-.6l.5-.2l.3-.1l.2.1l.1.6l-.5.7H45l-.2.3l.6-.3v.3l.3-.3v.2l.2-.1l-.5 1.4l.5-.4v.6l.2-.4l.2-.2l.1.2v-.5l.2.1l-.2-.7l.3.2l-.2-.9l.8-.4v-.4H47l.2-.4l.1-.6v.3v-.5l.3.1l-.2-.3l.4-.2h-.2l.5-.5l-1.3.9l-.1 1.7l-.4-1.9l.2.3l.2-.8l.4.1l-.2-.3l.2.1l-.3-.2l.4-.1l-.4-.3l.5-.2v.6l.2-.6l.7.2M45 34.8l.1-.7l.8-.1l-.9.8",
      fill: "#ffc900"
    }),
    createElementVNode("g", { fill: "#ed4c5c" }, [
      createElementVNode("path", { d: "M38.8 48.8c.3-.1 2 .4 2.7 1.1c-.1-1.3-.5-2.2-.5-2.2s-1-.3-1.2-.2c-.2.2-.8.9-1 1.3" }),
      createElementVNode("path", { d: "M38.2 43c-.1 0-.2.1-.4.3c-.1.3-.2 1.2-.4 1.4s-.4.2-.4.4s0 .6.6.8c.5 0 1.4-.9 1.4-.9s.4-.5.6-1c-1 .3-1.7-.6-1.4-1" }),
      createElementVNode("path", { d: "M53.4 48.6c-.3-.1-2.1.4-2.7 1.1c.1-1.3.5-2.2.5-2.2c.1 0 1-.3 1.1-.2c.2.2.8.9 1.1 1.3" }),
      createElementVNode("path", { d: "M53.8 42.8c.1 0 .2.2.3.4c.1.3.3.8.5 1c.2.2.4.5.4.7s0 .4-.6.6c-.5 0-1.3-.7-1.3-.7s-.4-.5-.6-1c1 .4 1.7-.6 1.3-1" })
    ]),
    createElementVNode("path", {
      d: "M52.3 45.4c.4-.4.7-.6.7-.6s-.5-.6-.6-1c1 .5 2.3-1.1.8-1.2c-1 .1-1.9.9-2.5 1.9c-3.1-1.5-6.7-1.4-9.6.1c-.6-1-1.4-1.8-2.4-1.8c-1.5.1-.1 1.7.8 1.2c-.1.4-.6 1-.6 1s.3.1.7.5c-.8.6-1.5 1.3-2.1 2.2c0 0 1.1.7 1.1 1.1c.5-.7 1.1-1.4 1.9-1.9c.4.7.7 1.7.9 3.1c0 0 .6-1.6.9-1.6c.2 0 0-1.1-.5-2.2c2.4-1.2 5.5-1.4 8.1-.2c-.5 1.1-.6 2.1-.5 2.4c.3 0 1 1.4 1 1.4c.2-1.3.5-2.3.9-3c.7.5 1.3 1.1 1.9 1.8c.6-.7 1.1-1 1.1-1c-.5-.9-1.2-1.6-2-2.2",
      fill: "#ffce31"
    }),
    createElementVNode("g", { fill: "#1e5aa6" }, [
      createElementVNode("path", { d: "M48.7 31.2h.4l-.8 1l.9 1.1l-1.8 2.3l1.7 2c-.2.5-.4.9-.7 1.2l-1-1.1l1.8-2.2l-1.4-1.6l.9-2.7" }),
      createElementVNode("path", { d: "M42.6 31.4h-.5l.8.9l-.9 1.1l1.9 2l-1.5 2.1c.2.5.5 1 .7 1.3l.9-1.2l-1.9-2.1l1.4-1.8l-.9-2.3" }),
      createElementVNode("path", { d: "M44.7 36.8l-.7.9l2.4 2.8c.4-.2.8-.5 1.1-.7l-1.2-1.4l.5-1.5l.7.8l-2.3 2.9c-.4-.2-.8-.4-1.2-.7l1.2-1.5l-.5-1.6" }),
      createElementVNode("path", { d: "M44 35.5l.4.5l-.3-.7z" }),
      createElementVNode("path", { d: "M47.1 35.9l.4-.4l-.2-.2z" })
    ]),
    createElementVNode("path", {
      d: "M51.5 29.5c.2 0 1.4 0 1.4.2c-.5.2-.8.5-1.1 1c.3.5.6.9.9 1.4c.1 1-1.3 2-1.2 3.5c.1 1.1.1 2.2 1 2.9c1.1 1 .6-2.1.7-2.4c0-.2 1.1 1 1.1 1.4c-.1 1.1-.5.5-.5.8c-.3 1.1-.3 1.8-1.3 1.8c-1.4-.8-2.7-8.8-1-10.6",
      fill: "#f5f5f5"
    }),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M47.4 27.6s1.1 1.2 1.9 1.2c.1.4-.3.7-.5.8c-.4-.1-.7 0-1.6-1c.1-.6.3-.9.2-1" }),
      createElementVNode("path", { d: "M49 24.8c.1-.5.4-.8.7-.8c-.1-.3.5-1.9 2.3-2.4c.1.8-.7 1.5-.7 1.5s2.6-.4 3.1-1.1c-.1.3-.6 2.1-3.3 2.1c1 1-.3 1.8-.9 1.5c.9-.8-.5-1.3-1.2-.8" })
    ]),
    createElementVNode("g", { fill: "#00f" }, [
      createElementVNode("path", { d: "M48.8 29.7s1.4.4 1.6-1.6c-.3-.9-.7-2.8-.1-3.3c-.6-.4-1.2 0-1.2 0c0 .1-.6.8.1 2.2c-1.7-.4-1 1.2-1 1.2c.1-.2 1-.5 1.2.8c0 .2-.7.7-.6.7" }),
      createElementVNode("path", { d: "M50.3 28.1s1.5-.8 1.4-2.7c-1.3 0-1.7 1.7-1.7 1.7l.3 1" })
    ]),
    createElementVNode("path", {
      d: "M43.7 28s-1.1 1-1.7.6c-.5.3-1-.2-1-.2s.6 2.3 2.9.6l-.2-1",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M42 28.6c.1-.5.5-.7.8-.3c.4.1.8-1.6-.6-1.3c.4-2.2-.8-3-.8-3s-.4 2.4-.2 2.9s-.3-.8-1.9-1.2c0 1.8 1.8 2.7 1.8 2.7s.4.4.9.2",
      fill: "#00f"
    }),
    createElementVNode("path", {
      d: "M41.1 24.9s-1 0-.4 1.1c-.5.1-1.5-.5-.8-1.4c-2.3-.1-3.3-1.2-3.3-2.2c.7.7 2.3.4 2.9.9c-.7-.7-.6-1.6-.6-1.6s2 .6 2.4 2.4c-.1.2-.2.8-.2.8",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M42.9 24.3c-.1.2-.1.4-.2.5c1.9 0 3.7.1 5.6.1c-.1-.6-.5-1.2-.7-1.7c.1-.4.1-1.1.2-1.6s-.7-.6-.5-1.1c-.1.2.6 0 .6 0c-.3 0-.4-1-.7-1.1c-.7-.2-1 0-1.6 0c-.8 0-2 0-1.8-1.2c.4.1.9 0 1-.4c-.1-.1-1.4-.3-1.6-.3c-.2 0-1.6.4-1.7.5c.4.5.8.4 1.2.8c.2.2.3 1.1.1 1h.2c-.1.1-.2.2-.2.3h.4c-.1.2-.2.3-.3.5h.5c-.1.2-.1.3-.2.5c.1 0 .2-.1.4-.1c.4.9-.3 2.4-.7 3.3m4.2-1c.2-.1.2-.1 0 0m-.2-1.9c.8 0 .4 1.8.1 1.9c-.8.1-.7-1.9-.1-1.9m-2 .6c-.3-1.6 2-1.1 1.3.1c-.1.2-.6 1.3-.6 1.3c-.6 0-.8-.9-.7-1.4m-1 1c.4-.5-.3-1.7.6-2c0 .7 0 1.7-.4 2.4c-.1-.2-.2-.3-.4-.2c.1 0 .2-.1.2-.2",
      fill: "#923f00"
    }),
    createElementVNode("path", {
      d: "M42.7 26.4l2.8 1.8l2.5-1.7s.5-.3.5-.5s-.2-.1-.3-.1l-2.6 1.8l-2.7-1.7s-.2-.1-.2.1c-.1.2 0 .3 0 .3",
      fill: "#b4b6b9"
    }),
    createElementVNode("g", { fill: "#ff7000" }, [
      createElementVNode("path", { d: "M52 39.8l-1 .1l.3.3h1.3z" }),
      createElementVNode("path", { d: "M51.6 28.4l-1.3.7l.3.3h1.3z" }),
      createElementVNode("path", { d: "M51.3 40.4l.6.4l1.7-.3l-.5-.3z" })
    ]),
    createElementVNode("path", {
      d: "M51 31.7c-.2-.1-.8-.2-1.6.3v1.7s1.1-.6 1.7-.5c0-.4 0-1.1-.1-1.5",
      fill: "url(#IconifyId17ecdb2904d178eab26137)"
    }),
    createElementVNode("path", {
      d: "M40 30c-.3.8.7 2 1 2.7c.7-.8 1-.9 1 .2c0 .3.1.7 0 1c-.1.3-.8.1-.5.5c.6 1 .5 1.6.2 2.6c-.1.4-.5 2.5-1.1 2.6c0 0 .1-1.5 0-1.7c-.1-.3-.6-1-.4-1.3c-.2.3-1 1.5-1.5 1.1c.2.5 0 .7-.1 1.2c-.1.3-.1.7-.1 1c-.1.4-.7.8-.6 1.4c-2.1-.7-3.5-2.3-2.8-4.6c.2-.5.4-1 .9-1.3c.5-.4.6-1 .8-1.7c.1-.2.3-.5.3-.8c-.1-.6.3-.8.3-1.2c.1-.7.2-1.5.2-2.2c0-1.1.4-1 1.3-1.5c.3-.1 1.5.1 1.8.3c.2.3-.5 1.5-.7 1.7",
      fill: "#8a9396"
    }),
    createElementVNode("path", {
      fill: "#ffffff",
      d: "M42.6 24.7h5.9v1.2h-5.9z"
    })
  ]);
}
function c$n(t3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3706)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M16.174 11.9996C16.174 13.0431 14.3052 15.6517 12.0001 15.6517C9.69489 15.6517 7.82617 13.0431 7.82617 11.9996C7.82617 9.69436 9.69489 7.82568 12.0001 7.82568C14.3052 7.82568 16.174 9.69436 16.174 11.9996Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.174 11.9995C16.174 14.3047 14.3052 16.1734 12.0001 16.1734C9.69489 16.1734 7.82617 14.3047 7.82617 11.9995",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M17.5335 14.5826L16.4268 15.6893L17.1646 16.4272L18.2714 15.3204L17.5335 14.5826Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M15.6888 16.4268L14.582 17.5336L15.3199 18.2714L16.4266 17.1647L15.6888 16.4268Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M19.7474 16.7947L18.6406 17.9015L19.3785 18.6393L20.4852 17.5326L19.7474 16.7947Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M17.9027 18.6409L16.7959 19.7477L17.5337 20.4855L18.6405 19.3788L17.9027 18.6409Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M18.6409 15.6896L17.5342 16.7964L18.272 17.5342L19.3788 16.4275L18.6409 15.6896Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M16.7962 17.5339L15.6895 18.6406L16.4273 19.3785L17.5341 18.2717L16.7962 17.5339Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M15.6893 5.35821L18.6406 8.30957L19.3785 7.57172L16.4271 4.62037L15.6893 5.35821Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M14.5827 6.46612L15.6895 7.57288L16.4273 6.83506L15.3205 5.7283L14.5827 6.46612Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M16.4274 8.31L17.5342 9.41675L18.272 8.67893L17.1652 7.57218L16.4274 8.31Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M16.7946 4.25225L17.9014 5.35901L18.6392 4.62116L17.5325 3.5144L16.7946 4.25225Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M18.6413 6.09771L19.748 7.20447L20.4859 6.46662L19.3791 5.35987L18.6413 6.09771Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M7.20331 19.748L4.25195 16.7966L3.5141 17.5345L6.46546 20.4858L7.20331 19.748Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M8.31086 18.64L7.2041 17.5332L6.46629 18.271L7.57304 19.3778L8.31086 18.64Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M6.46613 16.796L5.35938 15.6892L4.62153 16.4271L5.72828 17.5338L6.46613 16.796Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M9.41718 17.5336L6.46582 14.5823L5.72797 15.3201L8.67933 18.2715L9.41718 17.5336Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M4.25274 7.20465L7.2041 4.2533L6.46625 3.51545L3.5149 6.46681L4.25274 7.20465Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M5.35821 8.30976L8.30957 5.3584L7.57172 4.62055L4.62036 7.57191L5.35821 8.30976Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M6.46661 9.41706L9.41797 6.4657L8.68015 5.72788L5.7288 8.67924L6.46661 9.41706Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3706" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$g(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3707)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.0634 7.34694C21.2461 3.03018 16.9771 -0.000854492 11.9995 -0.000854492C8.68576 -0.000854492 5.68609 1.34254 3.51465 3.51425L6.51981 7.34694H23.0634Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M6.55388 16.6075L3.51465 20.4837C5.68609 22.6554 8.68576 23.9988 11.9995 23.9988C16.9939 23.9988 21.2751 20.9475 23.0819 16.6075H6.55388Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M2.6084 8.82605V15.1304H23.5864C23.8555 14.1323 23.9997 13.0831 23.9997 12C23.9997 10.9011 23.8517 9.83705 23.575 8.82605H2.6084Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51465C-1.17157 8.20093 -1.17157 15.7989 3.51471 20.4853C5.45126 18.5487 7.31375 16.6862 12 12L3.51471 3.51465Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M3.90889 9.01648L5.3735 11.0603L7.77013 10.2988L6.27899 12.3235L7.7436 14.3674L5.35728 13.5748L3.8661 15.5995L3.8825 13.085L1.49609 12.2923L3.89253 11.5309L3.90889 9.01648Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3707" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$y(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3708)" }, [
      createElementVNode("path", {
        d: "M0 11.9992C0 13.4671 0.264047 14.8731 0.746391 16.1731L12 17.2166L23.2536 16.1731C23.736 14.8731 24 13.4671 24 11.9992C24 10.5314 23.736 9.12533 23.2536 7.82534L12 6.78186L0.746391 7.82534C0.264047 9.12533 0 10.5314 0 11.9992Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.2553 7.82574C21.5597 3.25618 17.1612 -0.000366211 12.0017 -0.000366211C6.84208 -0.000366211 2.44356 3.25618 0.748047 7.82574H23.2553Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0.74707 16.174C2.44259 20.7435 6.8411 24.0001 12.0007 24.0001C17.1603 24.0001 21.5588 20.7435 23.2543 16.174H0.74707Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3708" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function V$5(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3709)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.39149 2.08618H5.23672C5.0526 2.21204 4.87241 2.34306 4.69583 2.47867L3.65234 11.9992L4.69583 21.5197C4.87241 21.6554 5.0526 21.7864 5.23672 21.9122H9.39149V2.08618Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M0 12.0007C0 15.8793 1.84069 19.3276 4.69567 21.5212V2.4801C1.84069 4.67376 0 8.12199 0 12.0007Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M19.3047 7.31531V7.61582L19.3159 7.61751L19.3047 7.31531Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.043 15.1296H20.7821L19.8256 16.1731V18.2601H17.7386V17.2166H18.7821V15.1296H14.0865V16.434H13.043V13.9482C12.7228 13.6616 12.5213 13.2453 12.5213 12.7818V5.99922C12.5213 5.1348 13.222 4.43401 14.0865 4.43401V14.0862H16.1734L16.8895 13.4894C16.7644 13.1915 16.6952 12.8644 16.6952 12.521V10.9558H15.13V7.82538H18.2604C18.2604 7.30366 19.043 6.78189 19.043 6.78189C19.043 6.78189 19.8256 7.30361 19.8256 7.82538V8.60801V10.9558C20.4061 10.9627 21.3283 10.9477 22.3246 10.9558C22.0629 10.4983 21.9125 9.95548 21.9125 9.39063C21.9125 8.46996 22.31 7.64224 22.9428 7.06943C22.0308 5.04841 20.5755 3.32518 18.763 2.08618H10.9561V21.9123H18.763C20.967 20.4057 22.6428 18.1833 23.4558 15.5799L23.043 15.1296Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3709" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$x(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3713)" }, [
      createElementVNode("path", {
        d: "M1.19072 6.78262C0.427875 8.36025 0 10.1301 0 12C0 13.8699 0.427875 15.6398 1.19072 17.2174L12 18.2609L22.8093 17.2174C23.5721 15.6398 24 13.8699 24 12C24 10.1301 23.5721 8.36025 22.8093 6.78262L12 5.73914L1.19072 6.78262Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.19141 17.2167C3.13231 21.2306 7.24273 23.9993 12.0003 23.9993C16.7578 23.9993 20.8682 21.2306 22.8091 17.2167H1.19141Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M1.19141 6.78287H22.8091C20.8682 2.76892 16.7578 0.000244141 12.0003 0.000244141C7.24273 0.000244141 3.13231 2.76892 1.19141 6.78287Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51392C-1.17157 8.2002 -1.17157 15.7982 3.51471 20.4845C5.45126 18.548 7.31375 16.6855 12 11.9992L3.51471 3.51392Z",
        fill: "#496E2D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3713" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$m(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3763)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.2536 7.82684H0.746344C0.264047 9.12687 0 10.5329 0 12.0007C0 13.4686 0.264047 14.8747 0.746344 16.1746H23.2536C23.736 14.8747 24 13.4686 24 12.0007C24 10.5329 23.736 9.12687 23.2536 7.82684Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M12.0345 24.0012C16.1446 24.0012 19.7716 21.9344 21.9343 18.7838H2.13477C4.29748 21.9344 7.92439 24.0012 12.0345 24.0012Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0345 0.000305176C16.1446 0.000305176 19.7716 2.06712 21.9343 5.21768H2.13477C4.29748 2.06712 7.92439 0.000305176 12.0345 0.000305176Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M11.9991 7.82684L13.0351 11.0153H16.3878L13.6754 12.9861L14.7115 16.1746L11.9991 14.204L9.28665 16.1746L10.3228 12.9861L7.61035 11.0153H10.9631L11.9991 7.82684Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3763" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function d$d(c3, l3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M61.7 28c-.1-1-.3-2-.6-3H2.8l-.6 3h59.5" }),
      createElementVNode("path", { d: "M2.3 36c.1 1 .3 2 .6 3h58.3l.6-3H2.3" }),
      createElementVNode("path", { d: "M20 4.5L17 6v52c1 .6 2 1.1 3 1.5v-55" }),
      createElementVNode("path", { d: "M28 2.3v59.5l3 .3V2c-1 0-2 .1-3 .3" })
    ]),
    createElementVNode("g", { fill: "#2a5f9e" }, [
      createElementVNode("path", { d: "M2 32c0 1.4.1 2.7.3 4h59.5c.2-1.3.3-2.6.3-4s-.1-2.7-.3-4H2.3c-.2 1.3-.3 2.6-.3 4" }),
      createElementVNode("path", { d: "M20 59.5c2.5 1.1 5.2 1.9 8 2.2V2.3c-2.8.4-5.5 1.1-8 2.2v55" })
    ]),
    createElementVNode("g", { fill: "#ed4c5c" }, [
      createElementVNode("path", { d: "M17 25V6C10 10.1 4.8 16.9 2.8 25H17z" }),
      createElementVNode("path", { d: "M17 39v19C10 53.9 4.8 47.1 2.8 39H17z" }),
      createElementVNode("path", { d: "M32 2h-1v23h30.2C58 11.8 46.2 2 32 2z" }),
      createElementVNode("path", { d: "M31 39v23h1c14.2 0 26-9.8 29.2-23H31" })
    ])
  ]);
}
function c$l(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3765)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.39067 10.435H23.8977C23.1307 4.54721 18.0962 0.000244141 11.9993 0.000244141C11.1033 0.000244141 10.2306 0.099291 9.39062 0.285479V10.435H9.39067Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M6.26085 10.4349V1.45923C2.96581 3.25707 0.607016 6.55478 0.101562 10.4349H6.26085V10.4349Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M6.2608 13.5657H0.101562C0.607016 17.4458 2.96581 20.7436 6.26085 22.5414L6.2608 13.5657Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M9.39062 13.5657V23.7152C10.2306 23.9014 11.1033 24.0005 11.9993 24.0005C18.0962 24.0005 23.1307 19.4535 23.8977 13.5657H9.39062V13.5657Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3765" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function r$c(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3766)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.26 9.91308H14.0861V5.73914H9.91217V9.91308H5.73828V14.087H9.91217V18.2609H14.0861V14.087H18.26V9.91308Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3766" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$k(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3767)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000732422C6.84013 -0.000732422 2.44161 3.25577 0.746094 7.82538H23.2534C21.5578 3.25577 17.1593 -0.000732422 11.9997 -0.000732422Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0005C17.1593 24.0005 21.5578 20.744 23.2533 16.1744H0.746094C2.44161 20.744 6.84012 24.0005 11.9997 24.0005Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M7.17067 9.13013L7.81815 11.1229H9.91361L8.21837 12.3547L8.8659 14.3475L7.17067 13.1159L5.47544 14.3475L6.12297 12.3547L4.42773 11.1229H6.52319L7.17067 9.13013Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M16.8308 9.13013L17.4783 11.1229H19.5738L17.8785 12.3547L18.5261 14.3475L16.8308 13.1159L15.1356 14.3475L15.7831 12.3547L14.0879 11.1229H16.1833L16.8308 9.13013Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3767" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$w(i, L3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3768)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C4.12172 7.87828 7.61737 4.38263 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M10.435 7.02305L8.96945 7.71249L9.74983 9.13181L8.15847 8.82731L7.95677 10.435L6.84836 9.25261L5.73986 10.435L5.53825 8.82731L3.94684 9.13172L4.72722 7.71239L3.26172 7.02305L4.72727 6.33375L3.94684 4.91438L5.5382 5.21883L5.73991 3.61121L6.84836 4.79358L7.95681 3.61121L8.15847 5.21883L9.74987 4.91438L8.96945 6.3338L10.435 7.02305Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.84897 9.25671C8.08262 9.25671 9.0827 8.25664 9.0827 7.02298C9.0827 5.78932 8.08262 4.78925 6.84897 4.78925C5.61531 4.78925 4.61523 5.78932 4.61523 7.02298C4.61523 8.25664 5.61531 9.25671 6.84897 9.25671Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M6.84841 8.21399C6.19211 8.21399 5.6582 7.68004 5.6582 7.02374C5.6582 6.36745 6.19216 5.8335 6.84841 5.8335C7.50471 5.8335 8.03866 6.36745 8.03866 7.02374C8.03861 7.68004 7.50461 8.21399 6.84841 8.21399Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3768" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$v(i, e28) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3769)" }, [
      createElementVNode("path", {
        d: "M1.19072 6.78177C0.427875 8.35939 0 10.1293 0 11.9991C0 13.869 0.427875 15.6389 1.19072 17.2165L12 18.26L22.8093 17.2165C23.5721 15.6389 24 13.869 24 11.9991C24 10.1293 23.5721 8.35939 22.8093 6.78177L12 5.73828L1.19072 6.78177Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.19141 17.2176C3.13236 21.2315 7.24278 24.0002 12.0003 24.0002C16.7577 24.0002 20.8682 21.2315 22.8091 17.2176H1.19141Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M1.19141 6.78201H22.8091C20.8682 2.76811 16.7577 -0.000610352 12.0003 -0.000610352C7.24278 -0.000610352 3.13236 2.76811 1.19141 6.78201Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.91309 15.1315H14.087V13.3576L13.2522 13.7749L12.0001 12.5228L10.7479 13.7749L9.91309 13.3576V15.1315Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M7.52504 13.0438L7.71934 13.6416H8.34793L7.83934 14.0111L8.03363 14.609L7.52504 14.2395L7.01645 14.609L7.21074 14.0111L6.70215 13.6416H7.33074L7.52504 13.0438Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M8.12758 10.9577L8.32187 11.5555H8.95047L8.44187 11.9251L8.63612 12.5229L8.12758 12.1534L7.61898 12.5229L7.81328 11.9251L7.30469 11.5555H7.93328L8.12758 10.9577Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.84926 9.39282L10.0436 9.99067H10.6721L10.1636 10.3602L10.3578 10.958L9.84926 10.5886L9.34071 10.958L9.53496 10.3602L9.02637 9.99067H9.65501L9.84926 9.39282Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M16.4752 13.0438L16.2809 13.6416H15.6523L16.1609 14.0111L15.9666 14.609L16.4752 14.2395L16.9838 14.609L16.7895 14.0111L17.2981 13.6416H16.6695L16.4752 13.0438Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.8727 10.9577L15.6784 11.5555H15.0498L15.5584 11.9251L15.3641 12.5229L15.8727 12.1534L16.3813 12.5229L16.187 11.9251L16.6956 11.5555H16.067L15.8727 10.9577Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.151 9.39282L13.9567 9.99067H13.3281L13.8366 10.3602L13.6424 10.958L14.151 10.5886L14.6595 10.958L14.4653 10.3602L14.9738 9.99067H14.3452L14.151 9.39282Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0006 8.60938L12.1949 9.20722H12.8235L12.3149 9.57673L12.5092 10.1746L12.0006 9.80511L11.492 10.1746L11.6863 9.57673L11.1777 9.20722H11.8063L12.0006 8.60938Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3769" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$u(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3770)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.51446 20.4856C4.01785 20.989 4.55495 21.4379 5.11834 21.8331L21.8326 5.11887C21.4374 4.55548 20.9884 4.01839 20.485 3.515C19.9816 3.01161 19.4446 2.56273 18.8812 2.16748L2.16699 18.8817C2.56215 19.445 3.01112 19.9821 3.51446 20.4856Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M3.51422 3.5138C-0.271495 7.29961 -0.998292 12.9851 1.33247 17.5012L17.5016 1.3321C12.9856 -0.998668 7.29999 -0.271825 3.51422 3.5138Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M20.4854 20.4851C24.2711 16.6994 24.9979 11.0138 22.6672 6.49768L6.49805 22.6668C11.014 24.9976 16.6996 24.2708 20.4854 20.4851Z",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3770" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$t(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3771)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.2536 7.82593H0.746391C0.264 9.12591 0 10.532 0 11.9998C0 13.4677 0.264 14.8737 0.746391 16.1737H23.2537C23.736 14.8737 24 13.4677 24 11.9998C24 10.532 23.736 9.12591 23.2536 7.82593Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0009 -0.000610352C8.36383 -0.000610352 5.10494 1.6177 2.9043 4.17328H21.0975C18.8969 1.6177 15.638 -0.000610352 12.0009 -0.000610352Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M21.0965 19.826H2.90332C5.10396 22.3816 8.36285 23.9999 11.9999 23.9999C15.637 23.9999 18.8959 22.3816 21.0965 19.826Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3771" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$s(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3611)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0001 -0.000366211C9.06209 -0.000366211 6.37119 1.05606 4.28516 2.80904L17.2175 11.9996L4.28516 21.1902C6.37119 22.9432 9.06209 23.9996 12.0001 23.9996C18.6275 23.9996 24.0001 18.627 24.0001 11.9996C24.0001 5.37226 18.6275 -0.000366211 12.0001 -0.000366211Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.5155C-1.17157 8.20178 -1.17157 15.7998 3.51471 20.4861C5.45126 18.5496 7.31375 16.6871 12 12.0008L3.51471 3.5155Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M3.32659 9.25146L5.15284 10.9798L7.36103 9.77684L6.28173 12.0479L8.10803 13.7763L5.61456 13.4516L4.53513 15.7226L4.07355 13.2508L1.58008 12.926L3.78817 11.7231L3.32659 9.25146Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3611" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$f(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3772)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0002 0.000366211C11.9915 0.000459961 11.4785 4.80037 11.4785 4.80037H21.6008C19.4115 1.88582 15.9261 0.000366211 12.0002 0.000366211Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M11.9999 24.0003C15.9258 24.0003 19.4112 22.1149 21.6004 19.2003H2.39941C4.58866 22.1149 8.07405 24.0003 11.9999 24.0003Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M23.7599 9.60034H11.4785L12.0002 14.4003H23.7599C23.9174 13.6249 24.0002 12.8223 24.0002 12.0003C24.0002 11.1784 23.9174 10.3758 23.7599 9.60034Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M12 14.4C12 11.8957 12 2.81737 12 0C5.37262 0 0 5.37262 0 12C0 12.822 0.082875 13.6245 0.240281 14.4H12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.62155 5.73828L7.39855 8.12961H9.91316L7.87892 9.60772L8.65583 11.9991L6.62155 10.5212L4.58727 11.9991L5.36431 9.60772L3.33008 8.12961H5.84459L6.62155 5.73828Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3772" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$r(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3773)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.3043 5.73914C19.1967 6.25641 19.1478 6.80733 19.1478 7.35652C19.1478 10.5222 21.035 13.2621 23.7394 14.4955C23.9097 13.6904 24 12.8558 24 12C24 5.37262 18.6274 0 12 0C5.37262 0 0 5.37262 0 12C0 18.6274 5.37262 24 12 24C16.1101 24 19.7371 21.9332 21.8998 18.7826H6.78263V17.2174H22.8093C22.9733 16.8782 23.1215 16.53 23.2537 16.1739H6.78263L19.3043 5.73914Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M8.81498 6.26123L9.07401 7.05839H9.91214L9.23409 7.55109L9.49312 8.3482L8.81498 7.85559L8.13693 8.3482L8.39592 7.55109L7.71777 7.05839H8.55595L8.81498 6.26123Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.41146 12L5.73528 12.9965H6.78294L5.93529 13.6122L6.25911 14.6087L5.41146 13.9928L4.56387 14.6087L4.88763 13.6122L4.04004 12.9965H5.0877L5.41146 12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.41146 3.65247L5.73528 4.64898H6.78294L5.93529 5.26468L6.25911 6.26115L5.41146 5.64531L4.56387 6.26115L4.88763 5.26468L4.04004 4.64898H5.0877L5.41146 3.65247Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M2.80209 8.34753L3.1259 9.34405H4.17351L3.32591 9.95975L3.64973 10.9562L2.80209 10.3404L1.95449 10.9562L2.27826 9.95975L1.43066 9.34405H2.47827L2.80209 8.34753Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3773" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$q(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3774)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.82577 6.26137V4.69617H6.26052V6.26137H4.69531V7.82662H6.26052V9.39183H7.82577V7.82662H9.39097V6.26137H7.82577Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 0V12C5.37262 12 2.73867 12 0 12C0 18.6274 5.37262 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37262 18.6274 0 12 0Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3774" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$p(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3775)" }, [
      createElementVNode("path", {
        d: "M6.49812 1.33191C5.42384 1.88639 4.41541 2.61319 3.51485 3.51375C2.61424 4.41436 1.88745 5.42278 1.33301 6.49706L9.04896 14.9509L17.5028 22.6669C18.5771 22.1124 19.5856 21.3856 20.4861 20.4851C21.3867 19.5845 22.1135 18.576 22.668 17.5018L14.952 9.04786L6.49812 1.33191Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M20.4858 20.486C20.9892 19.9826 21.4382 19.4455 21.8334 18.8821L5.11852 2.16711C4.55513 2.56232 4.01799 3.01129 3.5146 3.51468C3.01121 4.01807 2.56224 4.55521 2.16699 5.11865L18.8819 21.8335C19.4453 21.4383 19.9824 20.9894 20.4858 20.486Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M3.51431 20.4865C7.30026 24.2725 12.9861 24.9992 17.5023 22.6683L1.33251 6.49854C-0.998347 11.0148 -0.271457 16.7006 3.51431 20.4865Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.485 3.51461C16.6991 -0.271293 11.0133 -0.998043 6.49707 1.33272L22.6668 17.5026C24.9977 12.9864 24.271 7.30052 20.485 3.51461Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3775" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$j(i, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3714)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9999 17.7386C15.1695 17.7386 17.739 15.1692 17.739 11.9995C17.739 8.82988 15.1695 6.26038 11.9999 6.26038C8.83025 6.26038 6.26074 8.82988 6.26074 11.9995C6.26074 15.1692 8.83025 17.7386 11.9999 17.7386Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.707 9.80505L13.6915 11.1619L15.2861 10.6448L14.3 12.0004L15.2844 13.3572L13.6904 12.8382L12.7043 14.1938L12.7053 12.5175L11.1113 11.9985L12.7059 11.4815L12.707 9.80505Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.3044 15.3906C11.4315 15.3906 9.91309 13.8722 9.91309 11.9993C9.91309 10.1263 11.4315 8.60794 13.3044 8.60794C13.8884 8.60794 14.4379 8.7556 14.9176 9.01557C14.165 8.27958 13.1359 7.82532 12.0001 7.82532C9.69494 7.82532 7.82617 9.69404 7.82617 11.9992C7.82617 14.3044 9.69494 16.1731 12.0001 16.1731C13.1359 16.1731 14.1651 15.7188 14.9176 14.9828C14.4379 15.2429 13.8884 15.3906 13.3044 15.3906Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3714" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$o(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3715)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.5087 9.80505L12.4933 11.1619L14.0879 10.6448L13.1017 12.0004L14.0862 13.3572L12.4922 12.8382L11.5061 14.1938L11.5071 12.5175L9.91309 11.9985L11.5077 11.4815L11.5087 9.80505Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M8.82198 15.3906C6.94905 15.3906 5.43067 13.8722 5.43067 11.9993C5.43067 10.1263 6.94905 8.60794 8.82198 8.60794C9.40595 8.60794 9.95542 8.75565 10.4351 9.01557C9.68256 8.27954 8.65333 7.82532 7.51764 7.82532C5.21242 7.82532 3.34375 9.69404 3.34375 11.9992C3.34375 14.3044 5.21247 16.1731 7.51764 16.1731C8.65342 16.1731 9.68261 15.7188 10.4351 14.9828C9.95542 15.2429 9.40595 15.3906 8.82198 15.3906Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3715" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function H$4(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3716)" }, [
      createElementVNode("path", {
        d: "M11.9995 -0.000610352C11.1035 -0.000610352 10.2308 0.0984365 9.39086 0.284624L8.86914 11.9993L9.39086 23.7141C10.2308 23.9003 11.1036 23.9994 11.9995 23.9994C18.6269 23.9994 23.9995 18.6268 23.9995 11.9993C23.9995 5.37197 18.6269 -0.000610352 11.9995 -0.000610352Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M3.13041 3.91711C1.18584 6.04974 0 8.88615 0 11.9997C0 15.1132 1.18589 17.9496 3.13045 20.0823L3.65217 11.9997L3.13041 3.91711Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M17.5512 9.05156C18.1416 7.40596 17.4783 5.61623 16.0548 4.72485C16.3109 4.75818 16.5672 4.81846 16.8201 4.90917C18.7187 5.59035 19.7056 7.68154 19.0244 9.58007C18.3432 11.4787 16.252 12.4656 14.3535 11.7844C14.1005 11.6936 13.8643 11.5771 13.6455 11.4401C15.311 11.657 16.9608 10.6971 17.5512 9.05156Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M14.2766 4.27429L13.7636 4.9372L12.9747 4.65412L13.4465 5.34684L12.9336 6.00965L13.7382 5.77499L14.2101 6.46762L14.2355 5.62987L15.0401 5.39517L14.2513 5.11218L14.2766 4.27429Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M15.6624 6.4353L15.1493 7.09816L14.3604 6.81508L14.8323 7.5078L14.3193 8.17062L15.1239 7.93587L15.5959 8.62863L15.6213 7.79083L16.4259 7.55608L15.637 7.27305L15.6624 6.4353Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.8332 5.06042L11.3202 5.72324L10.5313 5.44025L11.0032 6.13293L10.4902 6.79578L11.2948 6.56108L11.7667 7.25375L11.7921 6.416L12.5967 6.1813L11.8079 5.89822L11.8332 5.06042Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.7776 7.53455L11.2646 8.19741L10.4757 7.91437L10.9477 8.60709L10.4346 9.26991L11.2393 9.03525L11.7112 9.72787L11.7365 8.89012L12.5412 8.65542L11.7522 8.37234L11.7776 7.53455Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M14.1321 8.38L13.6191 9.04282L12.8302 8.75979L13.3022 9.4525L12.7891 10.1153L13.5938 9.88061L14.0657 10.5733L14.091 9.73549L14.8957 9.50083L14.1067 9.2178L14.1321 8.38Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M3.12988 3.91743V20.0826C4.76488 21.8758 6.9366 23.1707 9.39074 23.7147V0.285278C6.93655 0.82931 4.76493 2.12423 3.12988 3.91743Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M5.51985 6.31761L4.47168 5.53676V4.43253L5.51985 3.65173H7.00228L8.05045 4.43253V5.53676L7.00228 6.31761H5.51985Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.26108 3.65173H5.51985L4.47168 4.43253V4.97239H6.26108V3.65173Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M6.26074 6.31668H7.00193L8.0501 5.53583V4.97253H6.26074V6.31668Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M5.51985 20.3485L4.47168 19.5676V18.4635L5.51985 17.6826H7.00228L8.05045 18.4635V19.5676L7.00228 20.3485H5.51985Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.26108 17.6826H5.51985L4.47168 18.4635V19.0033H6.26108V17.6826Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M6.26074 20.3493H7.00193L8.0501 19.5685V19.0052H6.26074V20.3493Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M5.51985 13.3324L4.47168 12.5515V11.4473L5.51985 10.6665H7.00227L8.05044 11.4473V12.5515L7.00227 13.3324H5.51985Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M8.0867 15.0514H7.63014V14.5949H6.82787L6.26059 14.0276L5.69335 14.5949H4.89109V15.0514H4.43457V15.9644H4.89109V16.4209H5.69331L6.26063 16.9883L6.82787 16.4209H7.63014V15.9644H8.0867V15.0514Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M8.0867 8.03605H7.63014V7.57949H6.82787L6.26059 7.01221L5.69335 7.57949H4.89109V8.03605H4.43457V8.94908H4.89109V9.4056H5.69331L6.26063 9.97297L6.82787 9.4056H7.63014V8.94908H8.0867V8.03605Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M6.78274 11.4791H5.73926V12.5226H6.78274V11.4791Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.26097 9.01487C6.54911 9.01487 6.78269 8.78129 6.78269 8.49315C6.78269 8.20502 6.54911 7.97144 6.26097 7.97144C5.97284 7.97144 5.73926 8.20502 5.73926 8.49315C5.73926 8.78129 5.97284 9.01487 6.26097 9.01487Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.26097 16.0309C6.54911 16.0309 6.78269 15.7973 6.78269 15.5091C6.78269 15.221 6.54911 14.9874 6.26097 14.9874C5.97284 14.9874 5.73926 15.221 5.73926 15.5091C5.73926 15.7973 5.97284 16.0309 6.26097 16.0309Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3716" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$e(h3, t3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { fill: "#2a5f9e" }, [
      createElementVNode("path", { d: "M32 2v30H2c0 16.6 13.4 30 30 30s30-13.4 30-30S48.6 2 32 2z" }),
      createElementVNode("path", { d: "M12 12h21v21H12z" })
    ]),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M18.9 8.1V14h-7.3L26 32h6v-7.5z" }),
      createElementVNode("path", { d: "M11 18.9H5c-1.9 4-3 8.4-3 13.1h12V13.9h-3v5" })
    ]),
    createElementVNode("path", {
      fill: "#ed4c5c",
      d: "M32 27.1L19 11h-6l17 21h2z"
    }),
    createElementVNode("path", {
      d: "M18.9 5v6H11v3h21V2c-4.7 0-9.1 1.1-13.1 3z",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M32 5H18.9c-6 2.9-11 7.9-13.9 13.9V32h6V11h21V5z",
      fill: "#ed4c5c"
    }),
    createElementVNode("path", {
      d: "M58 26.5v9.3c0 7.6-3 14.6-11.9 18.8c-8.9-4.2-11.9-11.2-11.9-18.8v-9.3H58",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M57.2 27.4V36c0 7.1-2.8 13.6-11.1 17.5C37.8 49.6 35 43.1 35 36v-8.6h22.2",
      fill: "#ffce31"
    }),
    createElementVNode("path", {
      d: "M41 31.2c-.5-.4-.4 0-.6-.6c-.2-.4-.6-.5-.9-.7c-.2-.1-1.2-1.5-1.5-1.4c-.3.1-.4 1-.4 1.1c-.2.6.1.5.2.9c-.3 0 .1.4.2.4c-.1.1-.1.2 0 .3c-.6 0-1.1.6-1.5.9c.3 0 .4-.2.7-.2c.3 0 .5.3.8.2c-.2.2-.5.4-.5.7c-.1.6-.8.6-1 1.2c.4.9 1.3 1 2.1 1.5c.6.4 1 .8 1.4 1.4c.4.7 1.3 1.7 2 .6c.4-.7.2-2.2.2-3c-.1-.8-.2-2.7-1.2-3.3",
      fill: "#ff9e3d"
    }),
    createElementVNode("path", {
      d: "M41.7 29.1c-.8.9-.7 1.4-.7 2.5s-.9 1.2-1.2 2.1c-.3 1 1 1.6 1.2 2.5c.1.5.1 1 .4 1.4c.2.3 1.1.2 1.4 0c.3-.2.1-.7.3-1c.2-.4.7-.3.9-.6c.5-.7.5-2 .1-2.7c-.2-.4.1-.9-.4-1.2c-.4-.3-.2-.7-.6-1c-.7-.6-.4-1.6-1.4-2",
      fill: "#ff927f"
    }),
    createElementVNode("path", {
      d: "M41.8 37.8c.9-.2.8-1.7.7-2.3s-.5-1.5-.2-2.2c.4-1-.5-1.9-.2-2.3c.2-.4.2-.6.2-.7c0-.1-.2-.2-.2 0c0 .3-.1.3-.2.5s-.1.5 0 .9s.4 1 0 1.7c-.4.8-.2 1.1-.1 1.5c0 .6.6 2.6 0 2.9",
      fill: "#ff9ee1"
    }),
    createElementVNode("g", { fill: "#ff9e3d" }, [
      createElementVNode("path", { d: "M37.8 29.4c.1 0 .3 0 .3.1" }),
      createElementVNode("path", { d: "M37.6 30.1c.1-.1.3 0 .5-.1" }),
      createElementVNode("path", { d: "M37.8 30.6c.2 0 .4 0 .6-.2" }),
      createElementVNode("path", { d: "M38 31.1c.1 0 .4-.1.5-.3" }),
      createElementVNode("path", { d: "M38.1 31.4c.3 0 .7.1.7 0" }),
      createElementVNode("path", { d: "M38.1 32.3c.2-.2.7-.3.8-.5" }),
      createElementVNode("path", { d: "M38.6 29.3c.3.1.2.3.4.4c.3.2 0 .5.3.5c.2.1.2.1.2.4c-.1.3.2.3.1.5" }),
      createElementVNode("path", { d: "M40.4 31c-.1 0-.5 0-.7.4" }),
      createElementVNode("path", { d: "M37.6 34.9c.2 0 .2-.1.3-.1c0-.1.1-.2.2-.2s.4 0 .4-.2s.2 0 .4-.3c.1-.3.2-.6.6-.7" })
    ]),
    createElementVNode("path", {
      d: "M48.1 40.7c.2.2 0 .5.2.6c.3.1 0 .5.4.6c.3.1 0 .5.3.7c.3.2-.1.5.4.7s-.1.7.2.8s-.1.6.3.8c.4.2-.2.5.2.8c.3.3-.1.6.3.9s-.2.5.1.9c.3.3-.1.5.1.9c.1.3-.1 1.3-.8 1.2c-.3.4-1.2.8-1.6.7c-.4.3-1.5.6-2.1.1c-.6.6-1.7.2-2.1-.1c-.4.1-1.3-.3-1.6-.7c-.7.1-1-.9-.8-1.2c.2-.4-.2-.6.1-.9c.3-.3-.2-.6.1-.9s-.1-.6.3-.9c.3-.3-.2-.6.2-.8c.4-.2-.1-.6.3-.8c.3-.2-.2-.6.2-.8s.1-.6.4-.7c.3-.2 0-.5.3-.7c.4-.1.1-.5.4-.6c.3-.1.1-.3.3-.6c.6.3 3 .5 3.9 0",
      fill: "#699635"
    }),
    createElementVNode("path", {
      d: "M48.2 40.5s-.1-.1-.2-.1c-.1-2.4-.5-3.3-1.9-3.3s-1.8.9-1.9 3.3c-.1 0-.1 0-.2.1c-.2.2-.2.4.4.6c.4.2 1.1.3 1.7.3c.6 0 1.2-.1 1.7-.3c.5-.2.5-.3.4-.6",
      fill: "#ed4c5c"
    }),
    createElementVNode("path", {
      d: "M54.6 33.4v-.7l2.2-.2l-2.2-.2V32l-.1-.6l2.2-.4l-2.3.1l-.3-.6l1.6-1.3l-1.9 1l-.8-.4l-.8-1.2l.1-.4l-.8 1.8v.6l.1.4l-.1-.6v-.6l-.8-1.8l.1.4l-.8 1.2l-.8.4l-1.9-1l1.6 1.3l-.3.6l-2.2.1l2.2.4l-.1.6v.3l-2.2.2l2.2.2v.7l-2 .8l2-.5l.2 4.3l-.5 2.8l.8-2.6l-.1-4.5l1.1.3l.2.5l.1.6l.2.5v.1l.1.6l.1.6l.1.5l.2.2l-.9.9l-.1.8l.6-.2l.1.7l.3-.1l.2.3l.4-.8l.4.8l.2-.3l.3.1l.1-.7l.6.2l-.1-.7l-.9-.9l.2-.2l.1-.5l.1-.6l.1-.6v-.1l.2-.5l.1-.6l.2-.5l1.1-.3l-.1 4.5l.8 2.6l-.6-2.9l.2-4.3l2 .5l-2-.8m-3.5-2.5l-.7-.8l.7.5v.3m-.2.3l-.1.1l-1.2-.9l.6-.2l.7 1m0-2.6l.4 1.3v.2l-.9-.3l.5-1.2m-1.6 2.1l1.2.9l-.1.2l-1.1-.5l-.2-.1l.2-.5m-.4 1.3l.1-.5l1.2.6v.3l-.1.3l-.8-.3l-.4-.1V32m0 1.4v-.6l1.2.4v.5l-1-.2l-.2-.1m3.5-2.1l-.1-.1l.8-1l.6.2l-1.3.9m-.3-.4v-.2l.7-.5l-.7.7m.8.9l-.1-.2l1.2-.9l.2.5H54l-1.1.6m-.5-3.2l.5 1.1l-.9.4v-.2l.4-1.3m.6 3.5l1.2-.6l.1.5v.3l-.3.1l-.8.3l-.2-.3v-.3m1.2 1.3l-1 .2v-.5l1.2-.4v.6l-.2.1",
      fill: "#b95a1e"
    })
  ]);
}
function F$a(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3718)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37263 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M5.73926 12.0012H9.78654L6.26098 7.82727L5.73926 9.39247V12.0012Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0001 9.78671L7.82617 5.73938H12.0001L12.0001 9.78671Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 11.9996H11.9999C11.9999 11.9888 11.9999 11.9783 11.9999 11.9674C11.9892 11.9782 11.9785 11.9889 11.9678 11.9996Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26123C12 4.14974 12 2.76618 12 0.000366211H11.998C5.3715 0.00149121 0 5.3736 0 12.0004H6.26091V8.47485L9.78642 12.0004H11.968C11.9787 11.9897 11.9894 11.979 12.0001 11.9683C12.0001 11.1598 12.0001 10.4384 12.0001 9.78683L8.47444 6.26123H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.56543C4.19441 2.63413 2.63413 4.19441 1.56543 6.07124V12.0002H4.69588V4.69598V4.69588H12.0002C12.0002 3.70856 12.0002 2.76796 12.0002 1.56543H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0009 10.5242L7.73735 6.26074H6.26172V6.26084L12.0008 11.9998H12.0009C12.0009 11.9998 12.0009 10.9823 12.0009 10.5242Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.0972 19.8252L13.3562 20.6224H14.1944L13.5163 21.115L13.7753 21.9121L13.0972 21.4195L12.4191 21.9121L12.6781 21.115L12 20.6224H12.8381L13.0972 19.8252Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.773 14.6094L20.032 15.4065H20.8701L20.1921 15.8992L20.4512 16.6963L19.773 16.2037L19.0949 16.6963L19.354 15.8992L18.6758 15.4065H19.5139L19.773 14.6094Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M21.4448 6.78259L21.7038 7.57975H22.542L21.864 8.07241L22.123 8.86951L21.4448 8.3769L20.7668 8.86951L21.0258 8.07241L20.3477 7.57975H21.1858L21.4448 6.78259Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M21.8599 12.5215L22.1189 13.3187H22.9571L22.279 13.8113L22.538 14.6085L21.8599 14.1158L21.1819 14.6085L21.4409 13.8113L20.7627 13.3187H21.6009L21.8599 12.5215Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.299 17.9513L15.0459 18.3319L15.6386 17.7393L15.5075 18.567L16.2543 18.9475L15.4264 19.0787L15.2953 19.9066L14.9148 19.1597L14.0869 19.2909L14.6796 18.6983L14.299 17.9513Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.299 14.8215L15.0459 15.202L15.6386 14.6094L15.5075 15.4372L16.2543 15.8177L15.4264 15.9488L15.2953 16.7767L14.9148 16.0299L14.0869 16.161L14.6796 15.5684L14.299 14.8215Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M16.9084 16.8272L17.6553 17.2078L18.2479 16.6151L18.1169 17.4429L18.8637 17.8234L18.0357 17.9546L17.9046 18.7824L17.5242 18.0355L16.6963 18.1668L17.2889 17.5741L16.9084 16.8272Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M16.9084 10.1248L17.6553 10.5054L18.2479 9.91272L18.1169 10.7405L18.8637 11.121L18.0357 11.2522L17.9046 12.08L17.5242 11.3332L16.6963 11.4644L17.2889 10.8717L16.9084 10.1248Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.4367 10.0445L20.1836 10.425L20.7763 9.8324L20.6451 10.6602L21.392 11.0407L20.5641 11.1718L20.4329 11.9997L20.0525 11.2529L19.2246 11.3841L19.8172 10.7914L19.4367 10.0445Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3718" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function a$d(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3719)" }, [
      createElementVNode("path", {
        d: "M20.9434 20.0001C22.8439 17.8771 24 15.0739 24 12.0002C24 8.92648 22.8438 6.12321 20.9434 4.00015L12 3.13062L3.05662 4.00015C1.15617 6.12321 0 8.92648 0 12.0002C0 15.0739 1.15613 17.8771 3.05658 20.0001L12 20.8697L20.9434 20.0001Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.05664 4.00047H20.9434C18.7462 1.54577 15.5537 0.000488281 12 0.000488281C8.44628 0.000488281 5.25386 1.54577 3.05664 4.00047Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M0 12.0008L12 13.0442L24 12.0008C24 10.5981 23.7585 9.25192 23.3162 8.00073H0.683812C0.241453 9.25192 0 10.5981 0 12.0008Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0.683812 15.9993H23.3163C23.7585 14.7481 24 13.402 24 11.9993H0C0 13.402 0.241453 14.7481 0.683812 15.9993Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M20.9435 19.9995H3.05664C5.25386 22.4543 8.44628 23.9995 12.0001 23.9995C15.5538 23.9995 18.7463 22.4543 20.9435 19.9995Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.0038 12.0007C16.0038 14.2124 14.2112 16.005 11.9995 16.005C9.78776 16.005 7.99512 14.2124 7.99512 12.0007C7.99512 9.78898 9.78776 7.99634 11.9995 7.99634C14.2112 7.99634 16.0038 9.78898 16.0038 12.0007Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.4669 12.2036L11.9999 11.568C11.9999 11.568 12.3431 10.4288 12.3614 10.3508C12.3748 10.2939 12.3819 10.2345 12.3819 10.1734C12.3819 9.9573 12.2943 9.76164 12.1526 9.62008L12.5215 9.25117C12.2855 9.01516 11.9594 8.86914 11.5992 8.86914C11.239 8.86914 10.9129 9.01511 10.6769 9.25117L11.0458 9.62008C10.9042 9.76169 10.8166 9.95734 10.8166 10.1734C10.8166 10.2525 10.8285 10.3286 10.8503 10.4006L10.2949 10.956H11.3044C11.3044 10.956 10.887 11.5829 10.6592 12.0977C10.4313 12.6125 10.6623 13.2409 11.1889 13.475L11.4934 13.6104L11.9999 14.0864V14.6081L11.4782 15.1299H12.5217V14.0864L12.9978 13.6103H13.9825C13.9873 13.6005 13.9922 13.5909 13.9967 13.5809C14.2307 13.0543 13.9935 12.4376 13.4669 12.2036Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3719" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function r$b(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3720)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3720" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$n(h3, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3722)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M2.48032 4.69299C1.53771 5.91938 0.826945 7.3329 0.413086 8.86848H6.6558L2.48032 4.69299Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.5864 8.86855C23.1725 7.33302 22.4617 5.91951 21.5191 4.69312L17.3438 8.86855H23.5864Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M0.413086 15.1302C0.826992 16.6658 1.53776 18.0793 2.48032 19.3056L6.65567 15.1302H0.413086Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M19.3053 2.47976C18.0789 1.53715 16.6655 0.826382 15.1299 0.412476V6.65515L19.3053 2.47976Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M4.69336 21.5176C5.91975 22.4602 7.33327 23.171 8.8688 23.5849V17.3423L4.69336 21.5176Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M8.86875 0.412476C7.33322 0.826382 5.9197 1.53715 4.69336 2.47971L8.86875 6.6551V0.412476Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M15.1299 23.5849C16.6654 23.171 18.0789 22.4602 19.3053 21.5177L15.1299 17.3423V23.5849Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M17.3438 15.1302L21.5191 19.3057C22.4617 18.0793 23.1725 16.6658 23.5864 15.1302H17.3438Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.1309 15.1313L20.4857 20.4861C20.732 20.2399 20.9669 19.9825 21.191 19.7157L16.6066 15.1312H15.1309V15.1313Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M8.86951 15.1312H8.86941L3.51465 20.486C3.76084 20.7323 4.01823 20.9672 4.28504 21.1914L8.86951 16.6068V15.1312Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M8.86976 8.86911V8.86902L3.51495 3.51416C3.26866 3.76035 3.03373 4.01774 2.80957 4.28455L7.39409 8.86907H8.86976V8.86911Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.1309 8.87017L20.4857 3.51526C20.2395 3.26898 19.9821 3.03405 19.7153 2.80994L15.1309 7.39445V8.87017Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3722" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$m(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3721)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.78223 16.1729L7.82571 23.2527C9.12565 23.7351 10.5318 23.999 11.9996 23.999C17.1591 23.999 21.5577 20.7425 23.2532 16.1729H6.78223Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M6.78223 7.8266L7.82571 0.746785C9.12565 0.264394 10.5318 0.000488281 11.9996 0.000488281C17.1591 0.000488281 21.5577 3.25699 23.2532 7.8266H6.78223Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M0 11.9999C0 17.1595 3.25655 21.558 7.82611 23.2536V0.746338C3.25655 2.44185 0 6.84037 0 11.9999Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3721" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$e(e28, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3723)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.4775 12H23.9993C23.9993 10.9169 23.8549 9.86761 23.5859 8.86951H11.4775V12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.4775 5.73848H22.238C21.5034 4.5398 20.5642 3.48028 19.4691 2.60803H11.4775V5.73848Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0001 23.9999C14.8243 23.9999 17.4201 23.0238 19.4699 21.3912H4.53027C6.58012 23.0238 9.17591 23.9999 12.0001 23.9999Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M1.76098 18.2598H22.2384C22.8281 17.2975 23.2855 16.2457 23.5863 15.1294H0.413086C0.713883 16.2457 1.17124 17.2975 1.76098 18.2598Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M5.55863 1.87397H6.65217L5.63498 2.61295L6.02353 3.80869L5.00639 3.0697L3.98925 3.80869L4.32487 2.7757C3.42928 3.52172 2.64431 4.39575 1.99744 5.36963H2.34783L1.70034 5.84002C1.59947 6.0083 1.50272 6.17925 1.41 6.35273L1.71919 7.30434L1.14234 6.88523C0.998953 7.18903 0.867797 7.49967 0.749906 7.81678L1.09055 8.86528H2.34783L1.33064 9.60427L1.71919 10.8L0.702047 10.061L0.0927656 10.5037C0.0317812 10.9939 0 11.4932 0 12H12C12 5.37262 12 4.59131 12 0C9.62944 0 7.41961 0.687656 5.55863 1.87397ZM6.02353 10.8L5.00639 10.061L3.98925 10.8L4.3778 9.60427L3.36061 8.86528H4.61789L5.00639 7.66955L5.39489 8.86528H6.65217L5.63498 9.60427L6.02353 10.8ZM5.63498 6.10861L6.02353 7.30434L5.00639 6.56536L3.98925 7.30434L4.3778 6.10861L3.36061 5.36963H4.61789L5.00639 4.17389L5.39489 5.36963H6.65217L5.63498 6.10861ZM10.3279 10.8L9.31073 10.061L8.29359 10.8L8.68214 9.60427L7.66495 8.86528H8.92223L9.31073 7.66955L9.69923 8.86528H10.9565L9.93933 9.60427L10.3279 10.8ZM9.93933 6.10861L10.3279 7.30434L9.31073 6.56536L8.29359 7.30434L8.68214 6.10861L7.66495 5.36963H8.92223L9.31073 4.17389L9.69923 5.36963H10.9565L9.93933 6.10861ZM9.93933 2.61295L10.3279 3.80869L9.31073 3.0697L8.29359 3.80869L8.68214 2.61295L7.66495 1.87397H8.92223L9.31073 0.678234L9.69923 1.87397H10.9565L9.93933 2.61295Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3723" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$l(i, L3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3724)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 8.86873H23.5866C23.2857 7.75245 22.8284 6.70053 22.2387 5.73828H12V8.86873Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M4.5296 21.3898H19.4693C20.5644 20.5176 21.5036 19.4581 22.2381 18.2594H1.76074C2.49532 19.4581 3.43451 20.5176 4.5296 21.3898Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12 -0.000854492C12 1.04263 12 2.60783 12 2.60783H19.4699C17.42 0.975271 14.8242 -0.000854492 12 -0.000854492Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12 8.86873H23.5866C23.2857 7.75245 22.8284 6.70053 22.2387 5.73828H12V8.86873Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M0 12.0001C0 13.0833 0.144375 14.1324 0.413391 15.1306H23.5867C23.8556 14.1324 24 13.0833 24 12.0001H0Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M10.435 7.02317L8.96941 7.71256L9.74983 9.13194L8.15842 8.82753L7.95677 10.4351L6.84836 9.25273L5.73986 10.4351L5.53825 8.82753L3.94684 9.13184L4.72722 7.71251L3.26172 7.02317L4.72727 6.33387L3.94684 4.9145L5.5382 5.21891L5.73991 3.61133L6.84836 4.7937L7.95681 3.61133L8.15842 5.21891L9.74988 4.9145L8.96945 6.33392L10.435 7.02317Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3724" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$k(e28, C3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3779)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FCFCFC"
      }),
      createElementVNode("path", {
        d: "M14.0373 8.38349C14.0373 7.25793 13.1249 6.34546 11.9993 6.34546C10.8737 6.34546 9.96118 7.25793 9.96118 8.38349H5.47754C5.47754 9.49166 6.44288 10.3901 7.55105 10.3901H7.48431C7.48431 11.4984 8.38262 12.3969 9.49098 12.3969C9.49098 13.3781 10.1957 14.1934 11.1264 14.3677L11.1212 14.3794H12.8774L12.8722 14.3677C13.8029 14.1934 14.5076 13.3781 14.5076 12.3969C15.6159 12.3969 16.5143 11.4984 16.5143 10.3901H16.4474C17.5556 10.3901 18.521 9.49166 18.521 8.38349H14.0373Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.1035 14.1724L9.83984 17.0253C10.5066 17.2964 11.2354 17.447 11.9995 17.447C12.7636 17.447 13.4923 17.2964 14.159 17.0253L12.8954 14.1724H11.1035Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.3916 9.3855V12.896C9.3916 14.8928 12.0003 15.5047 12.0003 15.5047C12.0003 15.5047 14.609 14.8928 14.609 12.896V9.3855H9.3916Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M2.91024 12.0846L4.32113 16.0307L5.71735 12.0846H6.78292L4.74732 17.302H3.8949L1.84473 12.0846H2.91024Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M19.3047 17.302V12.0846H20.3187V17.302H19.3047Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M10.4346 10.5195V14.7736C10.7932 15.0376 11.1791 15.2191 11.4781 15.3354V10.5195H10.4346Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.565 10.5195V14.7736C13.2063 15.0376 12.8205 15.2191 12.5215 15.3354V10.5195H13.565Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.609 9.3855H9.3916V11.0409H14.609V9.3855Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3779" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$j(t3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3725)" }, [
      createElementVNode("path", {
        d: "M0.566625 8.34794C0.199031 9.49956 -4.68667e-05 10.7264 8.27601e-09 12C-4.68667e-05 13.2736 0.199078 14.5005 0.566672 15.6521L12 16.174L23.4333 15.6522C23.8009 14.5006 24.0001 13.2736 24.0001 12.0001C24 10.7265 23.8009 9.49956 23.4333 8.34789L12 7.82617L0.566625 8.34794Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.4332 8.34789L11.9999 7.82617L0.5665 8.34789C0.457563 8.68933 0.363766 9.03747 0.285156 9.39137H23.7144C23.6359 9.03742 23.5421 8.68923 23.4332 8.34789Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0.285156 14.609C0.363672 14.9629 0.457469 15.311 0.566406 15.6524L0.567531 15.6525L11.9997 16.1742L23.433 15.6525C23.542 15.3111 23.6358 14.9629 23.7143 14.609H0.285156Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0007 24.0007C17.3545 24.0007 21.8888 20.4943 23.434 15.6528H0.567383C2.11262 20.4942 6.64693 24.0007 12.0007 24.0007Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000854492C6.64595 -0.000807617 2.11173 3.50558 0.566406 8.34697L23.433 8.34702C21.8879 3.50554 17.3536 -0.000901367 11.9997 -0.000854492Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M5.48376 4.95618C5.48376 3.83226 6.27365 2.89335 7.32847 2.66301C7.16638 2.62757 6.99815 2.6084 6.82536 2.6084C5.52871 2.6084 4.47754 3.65952 4.47754 4.95623C4.47754 6.25293 5.52862 7.30406 6.82536 7.30406C6.99815 7.30406 7.16633 7.28484 7.32847 7.24945C6.27369 7.01901 5.48376 6.0801 5.48376 4.95618Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M8.71531 6.02246L8.87421 6.5116H9.38853L8.97246 6.81395L9.13137 7.30309L8.71531 7.00079L8.29915 7.30309L8.4581 6.81395L8.04199 6.5116H8.55631L8.71531 6.02246Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.3578 6.02246L10.5167 6.5116H11.0311L10.6149 6.81395L10.7739 7.30309L10.3578 7.00079L9.94168 7.30309L10.1006 6.81395L9.68457 6.5116H10.1988L10.3578 6.02246Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9995 6.02246L12.1584 6.5116H12.6728L12.2566 6.81395L12.4156 7.30309L11.9995 7.00079L11.5833 7.30309L11.7423 6.81395L11.3262 6.5116H11.8405L11.9995 6.02246Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.6411 6.02246L13.8 6.5116H14.3143L13.8982 6.81395L14.0572 7.30309L13.6411 7.00079L13.2249 7.30309L13.3839 6.81395L12.9678 6.5116H13.4821L13.6411 6.02246Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M15.2826 6.02246L15.4415 6.5116H15.9559L15.5398 6.81395L15.6987 7.30309L15.2826 7.00079L14.8665 7.30309L15.0254 6.81395L14.6094 6.5116H15.1236L15.2826 6.02246Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.3578 4.31506L10.5167 4.80416H11.0311L10.6149 5.10655L10.7739 5.59564L10.3578 5.29335L9.94168 5.59564L10.1006 5.10655L9.68457 4.80416H10.1988L10.3578 4.31506Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9995 4.31506L12.1584 4.80416H12.6728L12.2566 5.10655L12.4156 5.59564L11.9995 5.29335L11.5833 5.59564L11.7423 5.10655L11.3262 4.80416H11.8405L11.9995 4.31506Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.6411 4.31506L13.8 4.80416H14.3143L13.8982 5.10655L14.0572 5.59564L13.6411 5.29335L13.2249 5.59564L13.3839 5.10655L12.9678 4.80416H13.4821L13.6411 4.31506Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M15.2826 4.31506L15.4415 4.80416H15.9559L15.5398 5.10655L15.6987 5.59564L15.2826 5.29335L14.8665 5.59564L15.0254 5.10655L14.6094 4.80416H15.1236L15.2826 4.31506Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9995 2.60803L12.1584 3.09722H12.6728L12.2566 3.39952L12.4156 3.8887L11.9995 3.58641L11.5833 3.8887L11.7423 3.39952L11.3262 3.09722H11.8405L11.9995 2.60803Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.6411 2.60803L13.8 3.09722H14.3143L13.8982 3.39952L14.0572 3.8887L13.6411 3.58641L13.2249 3.8887L13.3839 3.39952L12.9678 3.09722H13.4821L13.6411 2.60803Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M15.2826 2.60803L15.4415 3.09722H15.9559L15.5398 3.39952L15.6987 3.8887L15.2826 3.58641L14.8665 3.8887L15.0254 3.39952L14.6094 3.09722H15.1236L15.2826 2.60803Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3725" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$i(a3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3776)" }, [
      createElementVNode("path", {
        d: "M24 12.0003C24 11.4698 23.9651 10.9475 23.8984 10.4351H10.4347C7.98306 7.98365 3.51452 3.51539 3.5147 3.51501C-1.17157 8.20129 -1.17157 15.7992 3.5147 20.4856L10.4348 13.5656H23.8984C23.9651 13.0532 24 12.5308 24 12.0003Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9968 12.2726C23.9963 12.2958 23.9958 12.319 23.9951 12.3422C23.9957 12.3189 23.9962 12.2958 23.9968 12.2726Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9853 12.6002C23.9843 12.6232 23.9827 12.646 23.9814 12.6689C23.9827 12.6461 23.9842 12.6232 23.9853 12.6002Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9684 12.8632C23.966 12.8969 23.9637 12.9307 23.9609 12.9643C23.9637 12.9307 23.966 12.8969 23.9684 12.8632Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9287 10.6921C23.9331 10.7323 23.9375 10.7724 23.9415 10.8127C23.9375 10.7724 23.9331 10.7323 23.9287 10.6921Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9805 11.3298C23.9817 11.3527 23.9833 11.3756 23.9844 11.3985C23.9832 11.3756 23.9817 11.3527 23.9805 11.3298Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9951 11.6567C23.9958 11.6799 23.9962 11.7032 23.9968 11.7264C23.9963 11.7031 23.9957 11.6799 23.9951 11.6567Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9609 11.0355C23.9637 11.0692 23.966 11.1029 23.9684 11.1367C23.966 11.1029 23.9637 11.0692 23.9609 11.0355Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4344C23.9038 10.4755 23.9086 10.5168 23.9135 10.558C23.2013 4.61044 18.1395 -0.000366211 12 -0.000366211C8.68626 -0.000366211 5.68622 1.34283 3.51465 3.5145L10.4345 10.4344H23.8984V10.4344Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.8984 13.5652H10.4345L3.51465 20.4851C5.68622 22.6567 8.68626 24 12 24C18.1395 24 23.2014 19.3892 23.9135 13.4415C23.9086 13.4827 23.9037 13.5241 23.8984 13.5652Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M23.9415 13.1877C23.9375 13.228 23.9331 13.2681 23.9287 13.3083C23.9331 13.2681 23.9376 13.2281 23.9415 13.1877Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9688 11.137C23.9733 11.2012 23.9774 11.2655 23.981 11.33C23.9774 11.2655 23.9733 11.2012 23.9688 11.137Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9131 10.5583C23.9185 10.6029 23.9236 10.6475 23.9284 10.6922C23.9235 10.6475 23.9184 10.6029 23.9131 10.5583Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9414 10.8124C23.9487 10.8869 23.9553 10.9616 23.9613 11.0367C23.9554 10.9616 23.9488 10.8869 23.9414 10.8124Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M24.0005 12C24.0005 12.0913 23.9991 12.1823 23.9971 12.2731C23.9991 12.1823 24.0005 12.0913 24.0005 12Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.981 12.6688C23.9774 12.7333 23.9733 12.7977 23.9688 12.8619C23.9733 12.7977 23.9773 12.7333 23.981 12.6688Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9613 12.964C23.9553 13.0389 23.9487 13.1137 23.9414 13.1882C23.9488 13.1137 23.9554 13.0389 23.9613 12.964Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9284 13.3081C23.9236 13.3528 23.9185 13.3974 23.9131 13.4419C23.9184 13.3974 23.9235 13.3528 23.9284 13.3081Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9971 11.7274C23.9991 11.8183 24.0005 11.9093 24.0005 12.0005C24.0005 11.9093 23.9991 11.8183 23.9971 11.7274Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9854 11.3982C23.9896 11.4841 23.9928 11.5704 23.9952 11.6569C23.9928 11.5704 23.9896 11.4841 23.9854 11.3982Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9952 12.3419C23.9928 12.4283 23.9896 12.5146 23.9854 12.6006C23.9897 12.5146 23.9928 12.4283 23.9952 12.3419Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9892 11.4733H9.9945L2.80591 4.28577C2.57355 4.53083 2.32169 4.87302 2.16592 5.11672L9.04055 11.995L2.16016 18.8755C2.29637 19.1178 2.59314 19.4765 2.8015 19.7099L9.99464 12.5168H23.9909C23.9984 12.3437 24.0007 12.1699 24.0007 11.995C24.0007 11.7608 23.9942 11.588 23.9892 11.4733Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M2.91515 14.5574V13.5523C3.91818 13.5523 4.73413 12.7362 4.73413 11.7333C4.73413 11.0237 4.15677 10.4464 3.44718 10.4464C2.96376 10.4464 2.57043 10.8396 2.57043 11.3232C2.57043 11.6323 2.82191 11.8838 3.1311 11.8838C3.30585 11.8838 3.44802 11.7416 3.44802 11.5668H4.45311C4.45311 12.2959 3.86005 12.8889 3.13115 12.8889C2.26776 12.889 1.56543 12.1865 1.56543 11.3232C1.56543 10.2856 2.40965 9.44141 3.44722 9.44141C4.71106 9.44141 5.73931 10.4697 5.73931 11.7335C5.73927 13.2905 4.47238 14.5574 2.91515 14.5574Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3776" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$h(h3, t3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      d: "M62 32C62 15.4 48.6 2 32 2v60c16.6 0 30-13.4 30-30",
      fill: "#f9f9f9"
    }),
    createElementVNode("path", {
      d: "M2 32c0 16.6 13.4 30 30 30V2C15.4 2 2 15.4 2 32z",
      fill: "#ffe62e"
    }),
    createElementVNode("path", {
      d: "M49 21.3c0 2.9 0 3.8-3 3.8s-3-.9-3-3.8s1.3-5.3 3-5.3s3 2.4 3 5.3",
      fill: "#ffffff"
    }),
    createElementVNode("g", { fill: "#dbb471" }, [
      createElementVNode("path", { d: "M47.5 17.8L46 16.6l-1.5 1.2l-1.5-1.2l.5 2.4h5l.5-2.4z" }),
      createElementVNode("path", { d: "M47.5 20.6L46 19.2l-1.5 1.4l-1.5-1.4V22h6v-2.8z" }),
      createElementVNode("path", { d: "M47.5 23.5L46 22l-1.5 1.5L43 22v3h6v-3z" }),
      createElementVNode("ellipse", {
        cx: "46",
        cy: "15.1",
        rx: ".5",
        ry: "1.5"
      })
    ]),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("ellipse", {
        cx: "46",
        cy: "25",
        rx: "3",
        ry: ".7"
      }),
      createElementVNode("path", { d: "M41.9 32.6c-1.4 0-2.5-2.1-2.6-2.8c-.2-1 .3-2 .8-3.1c.3-.5.7-1.6.7-1.9c-.1-.4-1.2-1.5-2.3-2.3l1.2-1.6c.8.6 2.7 2.3 3 3.4c.2 1-.3 2-.8 3.2c-.3.6-.7 1.5-.7 1.9c.1.3.4.8.7 1.1c.5-.5 1.3-2.9 1.7-5.3l2 .3c-.4 2.5-1.4 6.7-3.4 7c-.1.1-.2.1-.3.1" }),
      createElementVNode("path", { d: "M50.1 32.6h-.2c-2.1-.3-3-4.5-3.4-7l2-.3c.4 2.3 1.1 4.6 1.7 5.2c.3-.3.6-.8.7-1.1c.1-.3-.4-1.3-.7-1.9c-.5-1.1-1-2.2-.8-3.2c.3-1.2 2.2-2.8 3-3.4l1.2 1.6c-1.1.9-2.2 2-2.3 2.3c-.1.3.4 1.3.7 1.8c.5 1.1 1 2.2.8 3.1c-.3.8-1.3 2.9-2.7 2.9" })
    ]),
    createElementVNode("path", {
      d: "M41.5 36.6c-1.4-.9-3.2-.7-4.5.6c-1.4 1.6-1.4 4.1 0 5.6c1.4 1.6 3.8 1.6 5.2 0c1.2-1.3 1.4-3.3.6-4.8l9.6-10.2l1.3 1.4l1.3-1.4l-2.6-2.8l-10.9 11.6",
      fill: "#dbb471"
    }),
    createElementVNode("path", {
      d: "M40.3 39.4c.3-.3.3-.8 0-1.2s-.8-.3-1.2 0c-.3.3-.3.8 0 1.2c-.3-.3-.8-.3-1.2 0c-.3.3-.3.8 0 1.2c.3.3.8.3 1.2 0c-.3.3-.3.8 0 1.2c.3.3.8.3 1.2 0s.3-.8 0-1.2c.3.3.8.3 1.2 0c.3-.3.3-.8 0-1.2c-.4-.3-.9-.3-1.2 0",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M50.5 36.6c1.4-.9 3.2-.7 4.5.6c1.4 1.6 1.4 4.1 0 5.6c-1.4 1.6-3.8 1.6-5.2 0c-1.2-1.3-1.4-3.3-.6-4.8l-9.6-10.2l-1.3 1.4l-1.3-1.4l2.6-2.8l10.9 11.6",
      fill: "#d0d0d0"
    }),
    createElementVNode("path", {
      d: "M51.7 39.4c-.3-.3-.3-.8 0-1.2c.3-.3.8-.3 1.2 0c.3.3.3.8 0 1.2c.3-.3.8-.3 1.2 0c.3.3.3.8 0 1.2c-.3.3-.8.3-1.2 0c.3.3.3.8 0 1.2c-.3.3-.8.3-1.2 0s-.3-.8 0-1.2c-.3.3-.8.3-1.2 0c-.3-.3-.3-.8 0-1.2c.4-.3.9-.3 1.2 0",
      fill: "#ffffff"
    }),
    createElementVNode("g", { fill: "#ed4c5c" }, [
      createElementVNode("path", { d: "M50.4 39.8c-2.9.4-5.9.4-8.8 0c-.6-.1-.8.6-.2.7c3.1.5 6.2.5 9.3 0c.6-.2.3-.8-.3-.7" }),
      createElementVNode("path", { d: "M50.3 39.2c-1.8-1.3-3.4-2.9-4.7-4.7c-.3-.4-.8-.1-.5.2c1.4 1.9 3.1 3.6 5 5c.3.3.6-.2.2-.5" }),
      createElementVNode("path", { d: "M46.4 34.5c-1.3 1.8-2.9 3.4-4.7 4.7c-.4.3-.1.8.2.5c1.9-1.4 3.6-3.1 5-5c.3-.3-.2-.5-.5-.2" }),
      createElementVNode("path", { d: "M45.5 31h1v13h-1z" }),
      createElementVNode("path", { d: "M43.481 33.436l.708-.707l2.404 2.404l-.707.708z" }),
      createElementVNode("path", { d: "M45.411 35.062l2.404-2.404l.707.707l-2.404 2.404z" })
    ]),
    createElementVNode("g", { fill: "#ff717f" }, [
      createElementVNode("path", { d: "M45.5 42.7c-.6 0-1 .4-1 1v3h2v-3c0-.5-.4-1-1-1" }),
      createElementVNode("path", { d: "M46.5 41.8c-.6 0-1 .4-1 1v3h2v-3c0-.6-.4-1-1-1" })
    ]),
    createElementVNode("g", { fill: "#94989b" }, [
      createElementVNode("circle", {
        cx: "42.6",
        cy: "37.1",
        r: "1.2"
      }),
      createElementVNode("circle", {
        cx: "36.8",
        cy: "42.9",
        r: "1.2"
      }),
      createElementVNode("circle", {
        cx: "36.8",
        cy: "37.1",
        r: "1.2"
      }),
      createElementVNode("circle", {
        cx: "42.6",
        cy: "42.9",
        r: "1.2"
      })
    ]),
    createElementVNode("g", { fill: "#dbb471" }, [
      createElementVNode("circle", {
        cx: "55.2",
        cy: "37.1",
        r: "1.2"
      }),
      createElementVNode("circle", {
        cx: "49.4",
        cy: "42.9",
        r: "1.2"
      }),
      createElementVNode("circle", {
        cx: "49.4",
        cy: "37.1",
        r: "1.2"
      }),
      createElementVNode("circle", {
        cx: "55.2",
        cy: "42.9",
        r: "1.2"
      }),
      createElementVNode("path", { d: "M38.1 20.9h2v2.2h-2z" }),
      createElementVNode("path", { d: "M51.9 20.9h2v2.2h-2z" }),
      createElementVNode("path", { d: "M43.577 28.624l.607-2.218l.58.158l-.608 2.219z" }),
      createElementVNode("path", { d: "M43.386 27.408l.16-.579l1.542.425l-.159.578z" }),
      createElementVNode("path", { d: "M47.2 26.532l.578-.158l.608 2.218l-.58.158z" }),
      createElementVNode("path", { d: "M46.95 27.212l1.543-.424l.16.579l-1.543.424z" })
    ]),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M52.5 28.1l-1.7 1.5l-1.1-3.1l1.7-.9z" }),
      createElementVNode("path", { d: "M39.5 28.1l1.7 1.5l1.1-3.1l-1.7-.9z" })
    ]),
    createElementVNode("g", { fill: "#dbb471" }, [
      createElementVNode("path", { d: "M41.5 26.5l-.6-.2l-.1.5l-.4-.1l-.2.6l.4.1l-.2 1.1l.5.2l.3-1.1l.5.1l.1-.6l-.4-.1z" }),
      createElementVNode("path", { d: "M51.8 27.3l-.2-.6l-.4.1l-.1-.5l-.6.2l.1.5l-.4.1l.1.6l.5-.1l.3 1.1l.5-.2l-.2-1.1z" })
    ])
  ]);
}
function h$d(i, F3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3777)" }, [
      createElementVNode("path", {
        d: "M22.8093 17.2166C23.5722 15.639 24 13.8692 24 11.9993C24 10.1294 23.5722 8.35951 22.8093 6.78189L12 5.7384L1.19072 6.78189C0.427828 8.35951 0 10.1294 0 11.9993C0 13.8692 0.427828 15.639 1.19072 17.2166L12 18.2601L22.8093 17.2166Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0004C16.7572 24.0004 20.868 21.2317 22.809 17.2178H1.19043C3.13143 21.2317 7.24218 24.0004 11.9997 24.0004Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.7824 14.3561L20.1486 14.8514L20.4236 15.607L19.7568 15.1574L19.1229 15.6525L19.3445 14.8793L18.6777 14.4295L19.4816 14.4015L19.7034 13.6283L19.9786 14.3841L20.7824 14.3561Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M19.1585 11.5444L18.7324 12.2266L19.2495 12.8426L18.469 12.6483L18.0427 13.3303L17.9865 12.5279L17.2061 12.3333L17.9519 12.0319L17.8959 11.2295L18.4129 11.8458L19.1585 11.5444Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M16.6724 9.45837L16.5052 10.2452L17.2018 10.6474L16.4019 10.7317L16.2346 11.5183L15.9074 10.7835L15.1074 10.8675L15.7053 10.3293L15.3781 9.59455L16.0747 9.99664L16.6724 9.45837Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.6219 8.34802L13.7339 9.14457L14.526 9.28416L13.8031 9.63695L13.9151 10.4334L13.3563 9.85482L12.6332 10.2074L13.0109 9.49712L12.4521 8.91859L13.2443 9.05823L13.6219 8.34802Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.3767 8.34802L10.7544 9.05822L11.5464 8.91849L10.9878 9.49726L11.3653 10.2075L10.6424 9.85482L10.0835 10.4333L10.1956 9.63694L9.47266 9.28435L10.2648 9.14457L10.3767 8.34802Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.32614 9.45837L7.92399 9.99664L8.62041 9.59455L8.29336 10.3295L8.89106 10.8677L8.09114 10.7835L7.76386 11.5183L7.59684 10.7315L6.79688 10.6475L7.49344 10.2453L7.32614 9.45837Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M4.83973 11.5444L5.58565 11.8457L6.10249 11.2296L6.04657 12.0322L6.79225 12.3335L6.01183 12.528L5.95563 13.3303L5.52954 12.6483L4.74902 12.8428L5.26605 12.2266L4.83973 11.5444Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M3.2168 14.3561L4.0208 14.3841L4.29577 13.6284L4.51772 14.4017L5.32148 14.4297L4.65464 14.8796L4.87627 15.6527L4.24252 15.1575L3.57562 15.6072L3.85073 14.8514L3.2168 14.3561Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M22.809 6.78226C20.868 2.76831 16.7572 -0.000366211 11.9997 -0.000366211C7.24218 -0.000366211 3.13143 2.76831 1.19043 6.78226H22.809Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3777" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function r$a(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3778)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0005 6.26123L13.2956 10.247H17.4864L14.0959 12.7103L15.391 16.696L12.0005 14.2327L8.61005 16.696L9.90511 12.7103L6.51465 10.247H10.7055L12.0005 6.26123Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3778" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$g(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1520_57548)" }, [
      createElementVNode("path", {
        d: "M0 0H900V800H0V0Z",
        fill: "#CE1126"
      }),
      createElementVNode("path", {
        d: "M-60 0H286V346H-60V0Z",
        fill: "white"
      }),
      createElementVNode("path", {
        d: "M-60 0H113V346H-60V0Z",
        fill: "#002654"
      }),
      createElementVNode("path", {
        d: "M-60 346H459V0",
        stroke: "white",
        "stroke-width": "6"
      }),
      createElementVNode("path", {
        d: "M528 506L432 410H624L528 506ZM496 538L400 442V634L496 538ZM528 570L432 666H624L528 570ZM560 538L656 442V634L560 538Z",
        fill: "white"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1520_57548" }, [
        createElementVNode("rect", {
          width: "800",
          height: "800",
          rx: "400",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$f(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3780)" }, [
      createElementVNode("path", {
        d: "M1.19072 6.78189C0.427875 8.35951 0 10.1294 0 11.9993C0 13.8692 0.427875 15.639 1.19072 17.2166L12 18.2601L22.8093 17.2166C23.5721 15.639 24 13.8692 24 11.9993C24 10.1294 23.5721 8.35951 22.8093 6.78189L12 5.7384L1.19072 6.78189Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.19141 17.2178C3.13231 21.2317 7.24278 24.0004 12.0003 24.0004C16.7577 24.0004 20.8682 21.2317 22.8091 17.2178H1.19141Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M1.19141 6.78226H22.8091C20.8682 2.76831 16.7578 -0.000366211 12.0003 -0.000366211C7.24273 -0.000366211 3.13231 2.76831 1.19141 6.78226Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51501C-1.17157 8.2013 -1.17157 15.7993 3.51471 20.4856C5.45126 18.5491 7.31375 16.6866 12 12.0003L3.51471 3.51501Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.1307 12C15.1307 10.2516 16.3594 8.79103 18.0002 8.43272C17.748 8.37764 17.4864 8.34778 17.2176 8.34778C15.2005 8.34778 13.5654 9.98287 13.5654 12C13.5654 14.017 15.2005 15.6521 17.2176 15.6521C17.4863 15.6521 17.748 15.6223 18.0002 15.5672C16.3594 15.2089 15.1307 13.7483 15.1307 12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.1533 9.6521L18.6714 11.2465H20.3477L18.9915 12.2317L19.5096 13.826L18.1533 12.8407L16.7972 13.826L17.3153 12.2317L15.959 11.2465H17.6353L18.1533 9.6521Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3780" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function p$e(i, c3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3781)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9992C17.1593 23.9992 21.5578 20.7427 23.2533 16.1731H0.746094C2.44161 20.7427 6.84013 23.9992 11.9997 23.9992Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M11.9997 0.000610352C6.84013 0.000610352 2.44161 3.25711 0.746094 7.82672H23.2534C21.5578 3.25711 17.1593 0.000610352 11.9997 0.000610352Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3781" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function c$i(i, h3) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3782)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M16.6957 11.9993H12V23.9993C13.4027 23.9993 14.7488 23.7578 16 23.3156L16.6957 11.9993Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.0003 20.9427C22.4551 18.7455 24.0004 15.553 24.0004 11.9993H19.3047L20.0003 20.9427Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M16 11.9993V23.3155C17.4905 22.7886 18.8458 21.9759 20 20.9427V11.9993H16Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M22.174 7.82669H19.0436C19.0436 7.25041 18.5764 6.7832 18.0001 6.7832C17.4238 6.7832 16.9566 7.25041 16.9566 7.82669H13.8262C13.8262 8.40302 14.3282 8.87017 14.9044 8.87017H14.8697C14.8697 9.4465 15.3368 9.91366 15.9131 9.91366C15.9131 10.49 16.3803 10.9571 16.9566 10.9571H19.0436C19.6199 10.9571 20.0871 10.49 20.0871 9.91366C20.6634 9.91366 21.1306 9.4465 21.1306 8.87017H21.0958C21.6721 8.87013 22.174 8.40297 22.174 7.82669Z",
        fill: "#FF9811"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3782" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function h$c(L3, i) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3783)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M22.8522 6.87246C22.2426 5.58461 21.4105 4.42291 20.4055 3.43643L12.0008 2.60913L3.5961 3.43647C3.56929 3.46277 3.54313 3.48968 3.5166 3.51625L6.87285 6.8725L12.0008 7.02911L22.8522 6.87246Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.51562 20.4852C3.55978 20.5294 3.60384 20.5736 3.64866 20.6171L12 21.3922L20.3512 20.6171C21.3665 19.6327 22.2088 18.4709 22.827 17.181L7.30425 16.6965C5.96864 18.0322 4.42814 19.5726 3.51562 20.4852Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.8807 10.3081L9.91309 9.91309L12.0001 12.0001C11.3819 12.6182 10.4591 13.541 9.91309 14.087L23.8734 13.7442C23.9564 13.1747 24.0001 12.5925 24.0001 12.0001C24.0001 11.4256 23.9588 10.861 23.8807 10.3081Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M12.0004 0.000610352C8.7272 0.000610352 5.76067 1.3117 3.5957 3.43664H20.4051C18.2401 1.3117 15.2736 0.000610352 12.0004 0.000610352Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M10.3071 10.3086H23.8797C23.7085 9.09551 23.3562 7.94079 22.8505 6.87256H6.87109L10.3071 10.3086Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.81934 17.1815H22.8266C23.3382 16.1141 23.6961 14.9592 23.8729 13.7455H10.2554C8.92473 15.0761 7.79701 16.2038 6.81934 17.1815Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9996 24.0006C15.246 24.0006 18.1907 22.7109 20.3508 20.6167H3.64844C5.80863 22.7109 8.75331 24.0006 11.9996 24.0006Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M4.28504 2.80994C4.01827 3.03409 3.76088 3.26908 3.51465 3.51522L12 12.0005L3.51465 20.4858C3.76084 20.732 4.01827 20.967 4.28504 21.1911L13.4756 12.0005L4.28504 2.80994Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M4.82467 8.86914L5.60163 11.2605H8.11624L6.08195 12.7386L6.85895 15.13L4.82467 13.652L2.79034 15.13L3.56744 12.7386L1.5332 11.2605H4.04767L4.82467 8.86914Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.96184 12.1947L4.93694 11.4773C4.93694 11.4773 4.78731 10.0738 4.77827 10.0262C4.70955 9.66418 4.39141 9.39038 4.00937 9.39038C3.57719 9.39038 3.22675 9.74077 3.22675 10.173C3.22675 10.2447 3.2372 10.3137 3.25525 10.3797L2.6875 10.9513C2.6875 10.9513 3.36184 10.9513 3.697 10.9513C3.697 11.9991 2.91512 11.9991 2.91512 13.0425L3.34886 14.086H5.95755L6.39236 13.0425H6.39217C6.43572 12.9424 6.46216 12.8392 6.47308 12.736C6.84789 12.5844 6.96184 12.1947 6.96184 12.1947Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3783" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
const lp = [
  {
    name: "Afghanistan (\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646)",
    code: "AF",
    phoneCode: "+93",
    placeholder: "070 123 4567",
    icon: c$B
  },
  {
    name: "\xC5land Islands",
    code: "AX",
    phoneCode: "+358",
    placeholder: "041 2345678",
    icon: p$2q
  },
  {
    name: "Albania (Shqip\xEBri)",
    code: "AL",
    phoneCode: "+355",
    placeholder: "066 123 4567",
    icon: h$v
  },
  {
    name: "Algeria (\u0627\u0644\u062C\u0632\u0627\u0626\u0631)",
    code: "DZ",
    phoneCode: "+213",
    placeholder: "05 12 34 56 78",
    icon: p$2p
  },
  {
    name: "American Samoa",
    code: "AS",
    phoneCode: "+1",
    placeholder: "(684) 733-1234",
    icon: L$a
  },
  {
    name: "Andorra",
    code: "AD",
    phoneCode: "+376",
    placeholder: "312 345",
    icon: p$2o
  },
  {
    name: "Angola",
    code: "AO",
    phoneCode: "+244",
    placeholder: "923 123 456",
    icon: L$9
  },
  {
    name: "Anguilla",
    code: "AI",
    phoneCode: "+1",
    placeholder: "(264) 235-1234",
    icon: p$2n
  },
  {
    name: "Antigua and Barbuda",
    code: "AG",
    phoneCode: "+1",
    placeholder: "(268) 722-1234",
    icon: p$2m
  },
  {
    name: "Argentina",
    code: "AR",
    phoneCode: "+54",
    placeholder: "011 15-2345-6789",
    icon: c$A
  },
  {
    name: "Armenia (\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576)",
    code: "AM",
    phoneCode: "+374",
    placeholder: "077 123456",
    icon: p$2l
  },
  {
    name: "Aruba",
    code: "AW",
    phoneCode: "+297",
    placeholder: "560-1234",
    icon: p$2k
  },
  {
    name: "Ascension Island",
    code: "AC",
    phoneCode: "+247",
    placeholder: "3 2250",
    icon: i$d
  },
  {
    name: "Australia",
    code: "AU",
    phoneCode: "+61",
    placeholder: "0412 345 678",
    icon: h$u
  },
  {
    name: "Austria (\xD6sterreich)",
    code: "AT",
    phoneCode: "+43",
    placeholder: "0664 123456",
    icon: p$2j
  },
  {
    name: "Azerbaijan (Az\u0259rbaycan)",
    code: "AZ",
    phoneCode: "+994",
    placeholder: "040 123 45 67",
    icon: C$q
  },
  {
    name: "Bahamas",
    code: "BS",
    phoneCode: "+1",
    placeholder: "(242) 359-1234",
    icon: p$2i
  },
  {
    name: "Bahrain (\u0627\u0644\u0628\u062D\u0631\u064A\u0646)",
    code: "BH",
    phoneCode: "+973",
    placeholder: "3600 1234",
    icon: r$o
  },
  {
    name: "Bangladesh (\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6)",
    code: "BD",
    phoneCode: "+880",
    placeholder: "01812-345678",
    icon: r$n
  },
  {
    name: "Barbados",
    code: "BB",
    phoneCode: "+1",
    placeholder: "(246) 250-1234",
    icon: p$2h
  },
  {
    name: "Belarus (\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C)",
    code: "BY",
    phoneCode: "+375",
    placeholder: "8 029 491-19-11",
    icon: p$2g
  },
  {
    name: "Belgium (Belgi\xEB)",
    code: "BE",
    phoneCode: "+32",
    placeholder: "0470 12 34 56",
    icon: p$2f
  },
  {
    name: "Belize",
    code: "BZ",
    phoneCode: "+501",
    placeholder: "622-1234",
    icon: p$2e
  },
  {
    name: "Benin (B\xE9nin)",
    code: "BJ",
    phoneCode: "+229",
    placeholder: "90 01 12 34",
    icon: p$2d
  },
  {
    name: "Bermuda",
    code: "BM",
    phoneCode: "+1",
    placeholder: "(441) 370-1234",
    icon: a$u
  },
  {
    name: "Bhutan (\u0F60\u0F56\u0FB2\u0F74\u0F42)",
    code: "BT",
    phoneCode: "+975",
    placeholder: "17 12 34 56",
    icon: c$z
  },
  {
    name: "Bolivia",
    code: "BO",
    phoneCode: "+591",
    placeholder: "71234567",
    icon: p$2c
  },
  {
    name: "Bosnia and Herzegovina (\u0411\u043E\u0441\u043D\u0430 \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430)",
    code: "BA",
    phoneCode: "+387",
    placeholder: "061 123 456",
    icon: C$o
  },
  {
    name: "Botswana",
    code: "BW",
    phoneCode: "+267",
    placeholder: "71 123 456",
    icon: p$2b
  },
  {
    name: "Brazil (Brasil)",
    code: "BR",
    phoneCode: "+55",
    placeholder: "(11) 91234-5678",
    icon: p$2a
  },
  {
    name: "British Indian Ocean Territory",
    code: "IO",
    phoneCode: "+246",
    placeholder: "370 5123",
    icon: a$t
  },
  {
    name: "British Virgin Islands",
    code: "VG",
    phoneCode: "+1",
    placeholder: "(284) 300-1234",
    icon: V$6
  },
  {
    name: "Brunei",
    code: "BN",
    phoneCode: "+673",
    placeholder: "712 3456",
    icon: p$29
  },
  {
    name: "Bulgaria (\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F)",
    code: "BG",
    phoneCode: "+359",
    placeholder: "0881 234 567",
    icon: p$28
  },
  {
    name: "Burkina Faso",
    code: "BF",
    phoneCode: "+226",
    placeholder: "70 12 34 56",
    icon: p$27
  },
  {
    name: "Burundi (Uburundi)",
    code: "BI",
    phoneCode: "+257",
    placeholder: "79 56 12 34",
    icon: p$25
  },
  {
    name: "Cambodia (\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6)",
    code: "KH",
    phoneCode: "+855",
    placeholder: "091 234 567",
    icon: p$24
  },
  {
    name: "Cameroon (Cameroun)",
    code: "CM",
    phoneCode: "+237",
    placeholder: "6 71 23 45 67",
    icon: p$23
  },
  {
    name: "Canada",
    code: "CA",
    phoneCode: "+1",
    placeholder: "(204) 123-4567",
    icon: p$22
  },
  {
    name: "Cape Verde (Kabu Verdi)",
    code: "CV",
    phoneCode: "+238",
    placeholder: "991 12 34",
    icon: d$e
  },
  {
    name: "Bonaire (Caribbean Netherlands)",
    code: "BQ",
    phoneCode: "+599",
    placeholder: "318 1234",
    icon: C$p
  },
  {
    name: "Cayman Islands",
    code: "KY",
    phoneCode: "+1",
    placeholder: "(345) 323-1234",
    icon: p$21
  },
  {
    name: "Central African Republic (R\xE9publique centrafricaine)",
    code: "CF",
    phoneCode: "+236",
    placeholder: "70 01 23 45",
    icon: a$s
  },
  {
    name: "Chad (Tchad)",
    code: "TD",
    phoneCode: "+235",
    placeholder: "63 01 23 45",
    icon: p$20
  },
  {
    name: "Chile",
    code: "CL",
    phoneCode: "+56",
    placeholder: "9 9123 4567",
    icon: p$1$
  },
  {
    name: "China (\u4E2D\u56FD)",
    code: "CN",
    phoneCode: "+86",
    placeholder: "131 2345 6789",
    icon: p$1_
  },
  {
    name: "Christmas Island",
    code: "CX",
    phoneCode: "+61",
    placeholder: "0412 345 678",
    icon: h$t
  },
  {
    name: "Cocos (Keeling) Islands",
    code: "CC",
    phoneCode: "+61",
    placeholder: "0412 345 678",
    icon: C$n
  },
  {
    name: "Colombia",
    code: "CO",
    phoneCode: "+57",
    placeholder: "321 1234567",
    icon: p$1Z
  },
  {
    name: "Comoros (\u062C\u0632\u0631 \u0627\u0644\u0642\u0645\u0631)",
    code: "KM",
    phoneCode: "+269",
    placeholder: "321 12 34",
    icon: C$m
  },
  {
    name: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    code: "CD",
    phoneCode: "+243",
    placeholder: "081 234 5678",
    icon: p$1X
  },
  {
    name: "Congo (Republic) (Congo-Brazzaville)",
    code: "CG",
    phoneCode: "+242",
    placeholder: "06 123 4567",
    icon: p$1Y
  },
  {
    name: "Cook Islands",
    code: "CK",
    phoneCode: "+682",
    placeholder: "21 234",
    icon: e$3
  },
  {
    name: "Costa Rica",
    code: "CR",
    phoneCode: "+506",
    placeholder: "8312 3456",
    icon: p$1W
  },
  {
    name: "C\xF4te d\u2019Ivoire",
    code: "CI",
    phoneCode: "+225",
    placeholder: "01 23 45 67",
    icon: i$c
  },
  {
    name: "Croatia (Hrvatska)",
    code: "HR",
    phoneCode: "+385",
    placeholder: "091 234 5678",
    icon: p$1V
  },
  {
    name: "Cuba",
    code: "CU",
    phoneCode: "+53",
    placeholder: "05 1234567",
    icon: C$l
  },
  {
    name: "Cura\xE7ao",
    code: "CW",
    phoneCode: "+599",
    placeholder: "9 512 3456",
    icon: p$1U
  },
  {
    name: "Cyprus (\u039A\u03CD\u03C0\u03C1\u03BF\u03C2)",
    code: "CY",
    phoneCode: "+357",
    placeholder: "96 123456",
    icon: c$y
  },
  {
    name: "Czech Republic (\u010Cesk\xE1 republika)",
    code: "CZ",
    phoneCode: "+420",
    placeholder: "601 123 456",
    icon: p$1T
  },
  {
    name: "Denmark (Danmark)",
    code: "DK",
    phoneCode: "+45",
    placeholder: "20 12 34 56",
    icon: c$x
  },
  {
    name: "Djibouti",
    code: "DJ",
    phoneCode: "+253",
    placeholder: "77 83 10 20",
    icon: p$1S
  },
  {
    name: "Dominica",
    code: "DM",
    phoneCode: "+1",
    placeholder: "(767) 225-1234",
    icon: C$k
  },
  {
    name: "Dominican Republic (Rep\xFAblica Dominicana)",
    code: "DO",
    phoneCode: "+1",
    placeholder: "(809) 234-5678",
    icon: C$j
  },
  {
    name: "Ecuador",
    code: "EC",
    phoneCode: "+593",
    placeholder: "099 123 4567",
    icon: p$1R
  },
  {
    name: "Egypt (\u0645\u0635\u0631)",
    code: "EG",
    phoneCode: "+20",
    placeholder: "0100 123 4567",
    icon: c$w
  },
  {
    name: "El Salvador",
    code: "SV",
    phoneCode: "+503",
    placeholder: "7012 3456",
    icon: p$1Q
  },
  {
    name: "Equatorial Guinea (Guinea Ecuatorial)",
    code: "GQ",
    phoneCode: "+240",
    placeholder: "222 123 456",
    icon: p$1P
  },
  {
    name: "Eritrea",
    code: "ER",
    phoneCode: "+291",
    placeholder: "07 123 456",
    icon: c$v
  },
  {
    name: "Estonia (Eesti)",
    code: "EE",
    phoneCode: "+372",
    placeholder: "5123 4567",
    icon: p$1O
  },
  {
    name: "Eswatini",
    code: "SZ",
    phoneCode: "+268",
    placeholder: "7612 3456",
    icon: r$m
  },
  {
    name: "Ethiopia",
    code: "ET",
    phoneCode: "+251",
    placeholder: "091 123 4567",
    icon: p$1N
  },
  {
    name: "Falkland Islands (Islas Malvinas)",
    code: "FK",
    phoneCode: "+500",
    placeholder: "51234",
    icon: p$1M
  },
  {
    name: "Faroe Islands (F\xF8royar)",
    code: "FO",
    phoneCode: "+298",
    placeholder: "211234",
    icon: c$u
  },
  {
    name: "Fiji",
    code: "FJ",
    phoneCode: "+679",
    placeholder: "701 2345",
    icon: p$1L
  },
  {
    name: "Finland (Suomi)",
    code: "FI",
    phoneCode: "+358",
    placeholder: "041 2345678",
    icon: r$l
  },
  {
    name: "France",
    code: "FR",
    phoneCode: "+33",
    placeholder: "06 12 34 56 78",
    icon: p$1K
  },
  {
    name: "French Guiana (Guyane fran\xE7aise)",
    code: "GF",
    phoneCode: "+594",
    placeholder: "0694 20 12 34",
    icon: h$s
  },
  {
    name: "French Polynesia (Polyn\xE9sie fran\xE7aise)",
    code: "PF",
    phoneCode: "+689",
    placeholder: "87 12 34 56",
    icon: a$r
  },
  {
    name: "Gabon",
    code: "GA",
    phoneCode: "+241",
    placeholder: "06 03 12 34",
    icon: p$1J
  },
  {
    name: "Gambia",
    code: "GM",
    phoneCode: "+220",
    placeholder: "301 2345",
    icon: p$1I
  },
  {
    name: "Georgia (\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD)",
    code: "GE",
    phoneCode: "+995",
    placeholder: "555 12 34 56",
    icon: h$r
  },
  {
    name: "Germany (Deutschland)",
    code: "DE",
    phoneCode: "+49",
    placeholder: "01512 3456789",
    icon: p$1H
  },
  {
    name: "Ghana (Gaana)",
    code: "GH",
    phoneCode: "+233",
    placeholder: "023 123 4567",
    icon: p$1G
  },
  {
    name: "Gibraltar",
    code: "GI",
    phoneCode: "+350",
    placeholder: "57123456",
    icon: h$q
  },
  {
    name: "Greece (\u0395\u03BB\u03BB\u03AC\u03B4\u03B1)",
    code: "GR",
    phoneCode: "+30",
    placeholder: "691 234 5678",
    icon: C$i
  },
  {
    name: "Greenland (Kalaallit Nunaat)",
    code: "GL",
    phoneCode: "+299",
    placeholder: "22 12 34",
    icon: p$1F
  },
  {
    name: "Grenada",
    code: "GD",
    phoneCode: "+1",
    placeholder: "(473) 403-1234",
    icon: p$1E
  },
  {
    name: "Guadeloupe",
    code: "GP",
    phoneCode: "+590",
    placeholder: "0690 30 12 34",
    icon: p$1D
  },
  {
    name: "Guam",
    code: "GU",
    phoneCode: "+1",
    placeholder: "(671) 300-1234",
    icon: p$1C
  },
  {
    name: "Guatemala",
    code: "GT",
    phoneCode: "+502",
    placeholder: "5123 4567",
    icon: L$8
  },
  {
    name: "Guernsey",
    code: "GG",
    phoneCode: "+44",
    placeholder: "07781 123456",
    icon: p$1B
  },
  {
    name: "Guinea (Guin\xE9e)",
    code: "GN",
    phoneCode: "+224",
    placeholder: "601 12 34 56",
    icon: p$1A
  },
  {
    name: "Guinea-Bissau (Guin\xE9 Bissau)",
    code: "GW",
    phoneCode: "+245",
    placeholder: "955 123 456",
    icon: r$k
  },
  {
    name: "Guyana",
    code: "GY",
    phoneCode: "+592",
    placeholder: "609 1234",
    icon: p$1z
  },
  {
    name: "Haiti",
    code: "HT",
    phoneCode: "+509",
    placeholder: "34 10 1234",
    icon: a$q
  },
  {
    name: "Honduras",
    code: "HN",
    phoneCode: "+504",
    placeholder: "9123-4567",
    icon: p$1y
  },
  {
    name: "Hong Kong (\u9999\u6E2F)",
    code: "HK",
    phoneCode: "+852",
    placeholder: "5123 4567",
    icon: p$1x
  },
  {
    name: "Hungary (Magyarorsz\xE1g)",
    code: "HU",
    phoneCode: "+36",
    placeholder: "20 123 4567",
    icon: p$1w
  },
  {
    name: "Iceland (\xCDsland)",
    code: "IS",
    phoneCode: "+354",
    placeholder: "611 1234",
    icon: p$1v
  },
  {
    name: "India (\u092D\u093E\u0930\u0924)",
    code: "IN",
    phoneCode: "+91",
    placeholder: "90123 45678",
    icon: p$1u
  },
  {
    name: "Indonesia",
    code: "ID",
    phoneCode: "+62",
    placeholder: "0812-345-678",
    icon: r$j
  },
  {
    name: "Iran (\u0627\u06CC\u0631\u0627\u0646)",
    code: "IR",
    phoneCode: "+98",
    placeholder: "0912 345 6789",
    icon: C$h
  },
  {
    name: "Iraq (\u0627\u0644\u0639\u0631\u0627\u0642)",
    code: "IQ",
    phoneCode: "+964",
    placeholder: "0791 234 5678",
    icon: p$1t
  },
  {
    name: "Ireland",
    code: "IE",
    phoneCode: "+353",
    placeholder: "085 123 4567",
    icon: p$1s
  },
  {
    name: "Isle of Man",
    code: "IM",
    phoneCode: "+44",
    placeholder: "07924 123456",
    icon: h$p
  },
  {
    name: "Israel (\u05D9\u05E9\u05E8\u05D0\u05DC)",
    code: "IL",
    phoneCode: "+972",
    placeholder: "050-123-4567",
    icon: h$o
  },
  {
    name: "Italy (Italia)",
    code: "IT",
    phoneCode: "+39",
    placeholder: "312 345 6789",
    icon: p$1r
  },
  {
    name: "Jamaica",
    code: "JM",
    phoneCode: "+1",
    placeholder: "(876) 210-1234",
    icon: a$p
  },
  {
    name: "Japan (\u65E5\u672C)",
    code: "JP",
    phoneCode: "+81",
    placeholder: "090-1234-5678",
    icon: r$i
  },
  {
    name: "Jersey",
    code: "JE",
    phoneCode: "+44",
    placeholder: "07797 123456",
    icon: C$g
  },
  {
    name: "Jordan (\u0627\u0644\u0623\u0631\u062F\u0646)",
    code: "JO",
    phoneCode: "+962",
    placeholder: "07 9012 3456",
    icon: c$t
  },
  {
    name: "Kazakhstan (\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D)",
    code: "KZ",
    phoneCode: "+7",
    placeholder: "8 (771) 000 9998",
    icon: c$s
  },
  {
    name: "Kenya",
    code: "KE",
    phoneCode: "+254",
    placeholder: "0712 123456",
    icon: a$o
  },
  {
    name: "Kiribati",
    code: "KI",
    phoneCode: "+686",
    placeholder: "72012345",
    icon: h$n
  },
  {
    name: "Kosovo",
    code: "XK",
    phoneCode: "+383",
    placeholder: "044 123 456",
    icon: r$h
  },
  {
    name: "Kuwait (\u0627\u0644\u0643\u0648\u064A\u062A)",
    code: "KW",
    phoneCode: "+965",
    placeholder: "50012345",
    icon: p$1q
  },
  {
    name: "Kyrgyzstan (\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D)",
    code: "KG",
    phoneCode: "+996",
    placeholder: "0700 123 456",
    icon: h$m
  },
  {
    name: "Laos (\u0EA5\u0EB2\u0EA7)",
    code: "LA",
    phoneCode: "+856",
    placeholder: "020 23 123 456",
    icon: p$1p
  },
  {
    name: "Latvia (Latvija)",
    code: "LV",
    phoneCode: "+371",
    placeholder: "21 234 567",
    icon: p$1o
  },
  {
    name: "Lebanon (\u0644\u0628\u0646\u0627\u0646)",
    code: "LB",
    phoneCode: "+961",
    placeholder: "03 123 456",
    icon: p$1n
  },
  {
    name: "Lesotho",
    code: "LS",
    phoneCode: "+266",
    placeholder: "5012 3456",
    icon: p$1m
  },
  {
    name: "Liberia",
    code: "LR",
    phoneCode: "+231",
    placeholder: "077 012 3456",
    icon: p$1l
  },
  {
    name: "Libya (\u0644\u064A\u0628\u064A\u0627)",
    code: "LY",
    phoneCode: "+218",
    placeholder: "091-2345678",
    icon: c$r
  },
  {
    name: "Liechtenstein",
    code: "LI",
    phoneCode: "+423",
    placeholder: "660 234 567",
    icon: p$1k
  },
  {
    name: "Lithuania (Lietuva)",
    code: "LT",
    phoneCode: "+370",
    placeholder: "612 34567",
    icon: p$1j
  },
  {
    name: "Luxembourg",
    code: "LU",
    phoneCode: "+352",
    placeholder: "621 123 456",
    icon: p$1i
  },
  {
    name: "Macau",
    code: "MO",
    phoneCode: "+853",
    placeholder: "6612 3456",
    icon: C$f
  },
  {
    name: "Madagascar (Madagasikara)",
    code: "MG",
    phoneCode: "+261",
    placeholder: "032 12 345 67",
    icon: p$1h
  },
  {
    name: "Malawi",
    code: "MW",
    phoneCode: "+265",
    placeholder: "0991 23 45 67",
    icon: L$7
  },
  {
    name: "Malaysia",
    code: "MY",
    phoneCode: "+60",
    placeholder: "012-345 6789",
    icon: p$1g
  },
  {
    name: "Maldives",
    code: "MV",
    phoneCode: "+960",
    placeholder: "771-2345",
    icon: p$1f
  },
  {
    name: "Mali",
    code: "ML",
    phoneCode: "+223",
    placeholder: "60 12 34 56",
    icon: p$1e
  },
  {
    name: "Malta",
    code: "MT",
    phoneCode: "+356",
    placeholder: "9696 1234",
    icon: p$1d
  },
  {
    name: "Marshall Islands",
    code: "MH",
    phoneCode: "+692",
    placeholder: "235-1234",
    icon: c$q
  },
  {
    name: "Martinique",
    code: "MQ",
    phoneCode: "+596",
    placeholder: "0696 20 12 34",
    icon: h$l
  },
  {
    name: "Mauritania (\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627)",
    code: "MR",
    phoneCode: "+222",
    placeholder: "22 12 34 56",
    icon: p$1c
  },
  {
    name: "Mauritius (Moris)",
    code: "MU",
    phoneCode: "+230",
    placeholder: "5251 2345",
    icon: p$1b
  },
  {
    name: "Mayotte",
    code: "YT",
    phoneCode: "+262",
    placeholder: "0639 01 23 45",
    icon: e$2
  },
  {
    name: "Mexico (M\xE9xico)",
    code: "MX",
    phoneCode: "+52",
    placeholder: "044 55 1234 5678",
    icon: p$1a
  },
  {
    name: "Micronesia",
    code: "FM",
    phoneCode: "+691",
    placeholder: "350 1234",
    icon: p$19
  },
  {
    name: "Moldova (Republica Moldova)",
    code: "MD",
    phoneCode: "+373",
    placeholder: "0621 12 345",
    icon: p$18
  },
  {
    name: "Monaco",
    code: "MC",
    phoneCode: "+377",
    placeholder: "06 12 34 56 78",
    icon: r$g
  },
  {
    name: "Mongolia (\u041C\u043E\u043D\u0433\u043E\u043B)",
    code: "MN",
    phoneCode: "+976",
    placeholder: "8812 3456",
    icon: a$n
  },
  {
    name: "Montenegro (Crna Gora)",
    code: "ME",
    phoneCode: "+382",
    placeholder: "067 123 456",
    icon: L$6
  },
  {
    name: "Montserrat",
    code: "MS",
    phoneCode: "+1",
    placeholder: "(664) 492-3456",
    icon: p$17
  },
  {
    name: "Morocco (\u0627\u0644\u0645\u063A\u0631\u0628)",
    code: "MA",
    phoneCode: "+212",
    placeholder: "0650-123456",
    icon: h$k
  },
  {
    name: "Mozambique (Mo\xE7ambique)",
    code: "MZ",
    phoneCode: "+258",
    placeholder: "82 123 4567",
    icon: a$m
  },
  {
    name: "Myanmar (Burma) (\u1019\u103C\u1014\u103A\u1019\u102C)",
    code: "MM",
    phoneCode: "+95",
    placeholder: "09 123 4567",
    icon: p$26
  },
  {
    name: "Namibia (Namibi\xEB)",
    code: "NA",
    phoneCode: "+264",
    placeholder: "081 123 4567",
    icon: p$16
  },
  {
    name: "Nauru",
    code: "NR",
    phoneCode: "+674",
    placeholder: "555 1234",
    icon: p$15
  },
  {
    name: "Nepal (\u0928\u0947\u092A\u093E\u0932)",
    code: "NP",
    phoneCode: "+977",
    placeholder: "984-1234567",
    icon: p$14
  },
  {
    name: "Netherlands (Nederland)",
    code: "NL",
    phoneCode: "+31",
    placeholder: "06 12345678",
    icon: p$13
  },
  {
    name: "New Caledonia (Nouvelle-Cal\xE9donie)",
    code: "NC",
    phoneCode: "+687",
    placeholder: "75.12.34",
    icon: h$j
  },
  {
    name: "New Zealand",
    code: "NZ",
    phoneCode: "+64",
    placeholder: "021 123 456",
    icon: p$12
  },
  {
    name: "Nicaragua",
    code: "NI",
    phoneCode: "+505",
    placeholder: "8123 4567",
    icon: C$d
  },
  {
    name: "Niger (Nijar)",
    code: "NE",
    phoneCode: "+227",
    placeholder: "93 12 34 56",
    icon: p$11
  },
  {
    name: "Nigeria",
    code: "NG",
    phoneCode: "+234",
    placeholder: "0802 123 4567",
    icon: p$10
  },
  {
    name: "Niue",
    code: "NU",
    phoneCode: "+683",
    placeholder: "1234",
    icon: p$$
  },
  {
    name: "Norfolk Island",
    code: "NF",
    phoneCode: "+672",
    placeholder: "3 81234",
    icon: p$_
  },
  {
    name: "North Korea (\uC870\uC120 \uBBFC\uC8FC\uC8FC\uC758 \uC778\uBBFC \uACF5\uD654\uAD6D)",
    code: "KP",
    phoneCode: "+850",
    placeholder: "0192 123 4567",
    icon: p$Z
  },
  {
    name: "North Macedonia (\u0421\u0435\u0432\u0435\u0440\u043D\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430)",
    code: "MK",
    phoneCode: "+389",
    placeholder: "072 123 456",
    icon: C$e
  },
  {
    name: "Northern Mariana Islands",
    code: "MP",
    phoneCode: "+1",
    placeholder: "(670) 234-5678",
    icon: p$Y
  },
  {
    name: "Norway (Norge)",
    code: "NO",
    phoneCode: "+47",
    placeholder: "406 12 345",
    icon: p$X
  },
  {
    name: "Oman (\u0639\u064F\u0645\u0627\u0646)",
    code: "OM",
    phoneCode: "+968",
    placeholder: "9212 3456",
    icon: C$c
  },
  {
    name: "Pakistan (\u067E\u0627\u06A9\u0633\u062A\u0627\u0646)",
    code: "PK",
    phoneCode: "+92",
    placeholder: "0301 2345678",
    icon: p$W
  },
  {
    name: "Palau",
    code: "PW",
    phoneCode: "+680",
    placeholder: "620 1234",
    icon: r$f
  },
  {
    name: "Palestine (\u0641\u0644\u0633\u0637\u064A\u0646)",
    code: "PS",
    phoneCode: "+970",
    placeholder: "0599 123 456",
    icon: p$V
  },
  {
    name: "Panama (Panam\xE1)",
    code: "PA",
    phoneCode: "+507",
    placeholder: "6123-4567",
    icon: p$U
  },
  {
    name: "Papua New Guinea",
    code: "PG",
    phoneCode: "+675",
    placeholder: "7012 3456",
    icon: a$l
  },
  {
    name: "Paraguay",
    code: "PY",
    phoneCode: "+595",
    placeholder: "0961 456789",
    icon: p$T
  },
  {
    name: "Peru (Per\xFA)",
    code: "PE",
    phoneCode: "+51",
    placeholder: "912 345 678",
    icon: p$S
  },
  {
    name: "Philippines",
    code: "PH",
    phoneCode: "+63",
    placeholder: "0912 345 6789",
    icon: p$R
  },
  {
    name: "Pitcairn",
    code: "PN",
    phoneCode: "+870",
    placeholder: "5123",
    icon: p$Q
  },
  {
    name: "Poland (Polska)",
    code: "PL",
    phoneCode: "+48",
    placeholder: "512 345 678",
    icon: r$e
  },
  {
    name: "Portugal",
    code: "PT",
    phoneCode: "+351",
    placeholder: "912 345 678",
    icon: C$b
  },
  {
    name: "Puerto Rico",
    code: "PR",
    phoneCode: "+1",
    placeholder: "(787) 234-5678",
    icon: C$a
  },
  {
    name: "Qatar (\u0642\u0637\u0631)",
    code: "QA",
    phoneCode: "+974",
    placeholder: "3312 3456",
    icon: h$i
  },
  {
    name: "R\xE9union (La R\xE9union)",
    code: "RE",
    phoneCode: "+262",
    placeholder: "0692 12 34 56",
    icon: a$k
  },
  {
    name: "Romania (Rom\xE2nia)",
    code: "RO",
    phoneCode: "+40",
    placeholder: "0712 345 678",
    icon: p$P
  },
  {
    name: "Russia (\u0420\u043E\u0441\u0441\u0438\u044F)",
    code: "RU",
    phoneCode: "+7",
    placeholder: "8 (912) 345-67-89",
    icon: p$O
  },
  {
    name: "Rwanda",
    code: "RW",
    phoneCode: "+250",
    placeholder: "0720 123 456",
    icon: c$p
  },
  {
    name: "Saint Barth\xE9lemy",
    code: "BL",
    phoneCode: "+590",
    placeholder: "0690 30 12 34",
    icon: H$5
  },
  {
    name: "Saint Helena",
    code: "SH",
    phoneCode: "+290",
    placeholder: "51234",
    icon: a$j
  },
  {
    name: "Saint Kitts and Nevis",
    code: "KN",
    phoneCode: "+1",
    placeholder: "(869) 765-1234",
    icon: p$N
  },
  {
    name: "Saint Lucia",
    code: "LC",
    phoneCode: "+1",
    placeholder: "(758) 284-5678",
    icon: p$M
  },
  {
    name: "Saint Martin (partie fran\xE7aise)",
    code: "MF",
    phoneCode: "+590",
    placeholder: "0690 30 12 34",
    icon: h$h
  },
  {
    name: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    code: "PM",
    phoneCode: "+508",
    placeholder: "055 12 34",
    icon: p$L
  },
  {
    name: "Saint Vincent and the Grenadines",
    code: "VC",
    phoneCode: "+1",
    placeholder: "(784) 430-1234",
    icon: p$K
  },
  {
    name: "Samoa",
    code: "WS",
    phoneCode: "+685",
    placeholder: "601234",
    icon: p$J
  },
  {
    name: "San Marino",
    code: "SM",
    phoneCode: "+378",
    placeholder: "66 66 12 34",
    icon: p$I
  },
  {
    name: "S\xE3o Tom\xE9 and Pr\xEDncipe (S\xE3o Tom\xE9 e Pr\xEDncipe)",
    code: "ST",
    phoneCode: "+239",
    placeholder: "981 2345",
    icon: a$i
  },
  {
    name: "Saudi Arabia (\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629)",
    code: "SA",
    phoneCode: "+966",
    placeholder: "055 123 4567",
    icon: h$g
  },
  {
    name: "Senegal (S\xE9n\xE9gal)",
    code: "SN",
    phoneCode: "+221",
    placeholder: "70 123 45 67",
    icon: p$H
  },
  {
    name: "Serbia (\u0421\u0440\u0431\u0438\u0458\u0430)",
    code: "RS",
    phoneCode: "+381",
    placeholder: "060 1234567",
    icon: p$G
  },
  {
    name: "Seychelles",
    code: "SC",
    phoneCode: "+248",
    placeholder: "2 510 123",
    icon: c$o
  },
  {
    name: "Sierra Leone",
    code: "SL",
    phoneCode: "+232",
    placeholder: "025 123456",
    icon: p$F
  },
  {
    name: "Singapore",
    code: "SG",
    phoneCode: "+65",
    placeholder: "8123 4567",
    icon: h$f
  },
  {
    name: "Sint Maarten",
    code: "SX",
    phoneCode: "+1",
    placeholder: "(721) 520-1234",
    icon: p$D
  },
  {
    name: "Sint Eustatius",
    code: "BQ",
    phoneCode: "+599",
    placeholder: "318 1234",
    icon: p$E
  },
  {
    name: "Slovakia (Slovensko)",
    code: "SK",
    phoneCode: "+421",
    placeholder: "0912 123 456",
    icon: p$C
  },
  {
    name: "Slovenia (Slovenija)",
    code: "SI",
    phoneCode: "+386",
    placeholder: "031 234 567",
    icon: p$B
  },
  {
    name: "Solomon Islands",
    code: "SB",
    phoneCode: "+677",
    placeholder: "74 21234",
    icon: p$A
  },
  {
    name: "Somalia (Soomaaliya)",
    code: "SO",
    phoneCode: "+252",
    placeholder: "7 1123456",
    icon: r$d
  },
  {
    name: "South Africa",
    code: "ZA",
    phoneCode: "+27",
    placeholder: "071 234 5678",
    icon: p$z
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    code: "GS",
    phoneCode: "+500",
    placeholder: "51234",
    icon: a$h
  },
  {
    name: "South Korea (\uB300\uD55C\uBBFC\uAD6D)",
    code: "KR",
    phoneCode: "+82",
    placeholder: "010-1234-5678",
    icon: c$n
  },
  {
    name: "South Sudan (\u062C\u0646\u0648\u0628 \u0627\u0644\u0633\u0648\u062F\u0627\u0646)",
    code: "SS",
    phoneCode: "+211",
    placeholder: "0977 123 456",
    icon: a$g
  },
  {
    name: "Spain (Espa\xF1a)",
    code: "ES",
    phoneCode: "+34",
    placeholder: "612 34 56 78",
    icon: p$y
  },
  {
    name: "Sri Lanka (\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF\u0DC0)",
    code: "LK",
    phoneCode: "+94",
    placeholder: "071 234 5678",
    icon: V$5
  },
  {
    name: "Sudan (\u0627\u0644\u0633\u0648\u062F\u0627\u0646)",
    code: "SD",
    phoneCode: "+249",
    placeholder: "091 123 4567",
    icon: p$x
  },
  {
    name: "Suriname",
    code: "SR",
    phoneCode: "+597",
    placeholder: "741-2345",
    icon: c$m
  },
  {
    name: "Svalbard and Jan Mayen",
    code: "SJ",
    phoneCode: "+47",
    placeholder: "412 34 567",
    icon: d$d
  },
  {
    name: "Sweden (Sverige)",
    code: "SE",
    phoneCode: "+46",
    placeholder: "070-123 45 67",
    icon: c$l
  },
  {
    name: "Switzerland (Schweiz)",
    code: "CH",
    phoneCode: "+41",
    placeholder: "078 123 45 67",
    icon: r$c
  },
  {
    name: "Syria (\u0633\u0648\u0631\u064A\u0627)",
    code: "SY",
    phoneCode: "+963",
    placeholder: "0944 567 890",
    icon: c$k
  },
  {
    name: "Taiwan (\u53F0\u7063)",
    code: "TW",
    phoneCode: "+886",
    placeholder: "0912 345 678",
    icon: p$w
  },
  {
    name: "Tajikistan",
    code: "TJ",
    phoneCode: "+992",
    placeholder: "917 12 3456",
    icon: p$v
  },
  {
    name: "Tanzania",
    code: "TZ",
    phoneCode: "+255",
    placeholder: "0621 234 567",
    icon: p$u
  },
  {
    name: "Thailand (\u0E44\u0E17\u0E22)",
    code: "TH",
    phoneCode: "+66",
    placeholder: "081 234 5678",
    icon: p$t
  },
  {
    name: "Timor-Leste",
    code: "TL",
    phoneCode: "+670",
    placeholder: "7721 2345",
    icon: p$s
  },
  {
    name: "Togo",
    code: "TG",
    phoneCode: "+228",
    placeholder: "90 11 12 34",
    icon: a$f
  },
  {
    name: "Tokelau",
    code: "TK",
    phoneCode: "+690",
    placeholder: "7290",
    icon: p$r
  },
  {
    name: "Tonga",
    code: "TO",
    phoneCode: "+676",
    placeholder: "771 5123",
    icon: p$q
  },
  {
    name: "Trinidad and Tobago",
    code: "TT",
    phoneCode: "+1",
    placeholder: "(868) 291-1234",
    icon: p$p
  },
  {
    name: "Tunisia (\u062A\u0648\u0646\u0633)",
    code: "TN",
    phoneCode: "+216",
    placeholder: "20 123 456",
    icon: c$j
  },
  {
    name: "Turkey (T\xFCrkiye)",
    code: "TR",
    phoneCode: "+90",
    placeholder: "0501 234 5678",
    icon: p$o
  },
  {
    name: "Turkmenistan",
    code: "TM",
    phoneCode: "+993",
    placeholder: "8 66 123456",
    icon: H$4
  },
  {
    name: "Turks and Caicos Islands",
    code: "TC",
    phoneCode: "+1",
    placeholder: "(649) 231-1234",
    icon: a$e
  },
  {
    name: "Tuvalu",
    code: "TV",
    phoneCode: "+688",
    placeholder: "901234",
    icon: F$a
  },
  {
    name: "U.S. Virgin Islands",
    code: "VI",
    phoneCode: "+1",
    placeholder: "(340) 642-1234",
    icon: p$k
  },
  {
    name: "Uganda",
    code: "UG",
    phoneCode: "+256",
    placeholder: "0712 345678",
    icon: a$d
  },
  {
    name: "Ukraine (\u0423\u043A\u0440\u0430\u0457\u043D\u0430)",
    code: "UA",
    phoneCode: "+380",
    placeholder: "039 123 4567",
    icon: r$b
  },
  {
    name: "United Arab Emirates (\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629)",
    code: "AE",
    phoneCode: "+971",
    placeholder: "050 123 4567",
    icon: p$m
  },
  {
    name: "United Kingdom",
    code: "GB",
    phoneCode: "+44",
    placeholder: "07700 900123",
    icon: p$n
  },
  {
    name: "United States",
    code: "US",
    phoneCode: "+1",
    placeholder: "(201) 555-0123",
    icon: h$e
  },
  {
    name: "Uruguay",
    code: "UY",
    phoneCode: "+598",
    placeholder: "091 234 567",
    icon: p$l
  },
  {
    name: "Uzbekistan (O\u02BBzbekiston)",
    code: "UZ",
    phoneCode: "+998",
    placeholder: "8 91 234 56 78",
    icon: p$j
  },
  {
    name: "Vanuatu",
    code: "VU",
    phoneCode: "+678",
    placeholder: "591 2345",
    icon: p$i
  },
  {
    name: "Vatican City (Citt\xE0 del Vaticano)",
    code: "VA",
    phoneCode: "+379",
    placeholder: "3123456789",
    icon: p$h
  },
  {
    name: "Venezuela",
    code: "VE",
    phoneCode: "+58",
    placeholder: "0412-1234567",
    icon: h$d
  },
  {
    name: "Vietnam (Vi\u1EC7t Nam)",
    code: "VN",
    phoneCode: "+84",
    placeholder: "091 234 56 78",
    icon: r$a
  },
  {
    name: "Wallis and Futuna (Wallis-et-Futuna)",
    code: "WF",
    phoneCode: "+681",
    placeholder: "50 12 34",
    icon: p$g
  },
  {
    name: "Western Sahara (\u0627\u0644\u0635\u062D\u0631\u0627\u0621 \u0627\u0644\u063A\u0631\u0628\u064A\u0629)",
    code: "EH",
    phoneCode: "+212",
    placeholder: "0650-123456",
    icon: p$f
  },
  {
    name: "Yemen (\u0627\u0644\u064A\u0645\u0646)",
    code: "YE",
    phoneCode: "+967",
    placeholder: "0712 345 678",
    icon: p$e
  },
  {
    name: "Zambia",
    code: "ZM",
    phoneCode: "+260",
    placeholder: "095 1234567",
    icon: c$i
  },
  {
    name: "Zimbabwe",
    code: "ZW",
    phoneCode: "+263",
    placeholder: "071 123 4567",
    icon: h$c
  }
];
const d$c = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6], 0, 0, 0, 0, 0, 0, 0, [["6[2-467]\\d{3}", [5]], ["4\\d{4}", [5]], 0, 0, 0, 0, ["(?:0[1-9]|[1589]\\d)\\d{4}", [6]]]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [["[78]\\d{5}", [6]], ["690\\d{6}|[356]\\d{5}", [6, 9]], ["180[02]\\d{4}", [8]], ["[19]\\d{5}", [6]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[2-4679][2-8]\\d{6}", [8]], ["5[024-68]\\d{7}", [9]], ["400\\d{6}|800\\d{2,9}"], ["900[02]\\d{5}", [9]], 0, 0, ["600[25]\\d{5}", [9]], 0, 0, ["700[05]\\d{5}", [9]]]], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}"], ["7\\d{8}"]]], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268", [["268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"], ["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["26840[69]\\d{4}"], ["26848[01]\\d{4}"]]], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264", [["264(?:292|4(?:6[12]|9[78]))\\d{4}"], ["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["264724\\d{4}"]]], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", [8]], ["6(?:[78][2-9]|9\\d)\\d{6}", [9]], ["800\\d{4}", [7]], ["900[1-9]\\d\\d", [6]], ["700[2-9]\\d{4}", [8]], 0, 0, 0, 0, ["808[1-9]\\d\\d", [6]]]], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}"], ["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"], ["800\\d{5}"], ["90[016]\\d{5}"], 0, 0, 0, 0, ["60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}"], ["80[1-4]\\d{5}"]]], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}"], ["9[1-59]\\d{7}"]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1", 0, 0, [["3888[013-9]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}", [10]], ["93(?:7(?:1[15]|81)[46]|8(?:(?:21|4[16]|69|9[12])[46]|88[013-9]))\\d{5}|9(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"], ["800\\d{7,8}"], ["60[04579]\\d{7}", [10]], 0, 0, ["810\\d{7}", [10]]]], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684", [["6846(?:22|33|44|55|77|88|9[19])\\d{4}"], ["684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"], ["6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", [7, 8, 9, 10, 11, 12, 13]], ["800\\d{6,10}", [9, 10, 11, 12, 13]], ["(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", [9, 10, 11, 12, 13]], 0, 0, 0, 0, ["5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", [5, 6, 7, 8, 9, 10, 11, 12, 13]], ["8(?:10|2[018])\\d{6,10}|828\\d{5}", [8, 9, 10, 11, 12, 13]]]], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], 0, 0, 0, 0, 0, 0, [["5(?:2\\d|8[1-9])\\d{4}"], ["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"], ["800\\d{4}"], ["900\\d{4}"], 0, 0, 0, 0, ["(?:28\\d|501)\\d{4}"]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", [["18[1-8]\\d{3,6}", [6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}"], ["36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"], ["88\\d{7}"], ["900200\\d{3}"]]], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", [8]], ["6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"], ["8[08]\\d{6}", [8]], ["9[0246]\\d{6}", [8]], 0, 0, ["703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", [8]], 0, 0, ["8[12]\\d{6}", [8]]]], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246", [["246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"], ["246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:246976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}"], 0, ["24631\\d{5}"]]], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:222|[45]\\d)\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}"], ["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", [10]], ["80[03]\\d{7}", [10]], 0, 0, 0, 0, 0, ["96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", [10]]]], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, [["80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", [8]], ["4[5-9]\\d{7}", [9]], ["800[1-9]\\d{4}", [8]], ["(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}", [8]], 0, 0, ["78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}", [8]], 0, 0, ["7879\\d{4}", [8]]]], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}"], ["(?:0[1-35-7]|5[0-8]|[67]\\d)\\d{6}"]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", [6, 7, 8]], ["(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", [8, 9]], ["(?:00800\\d\\d|800)\\d{5}", [8, 12]], ["90\\d{6}", [8]], 0, 0, 0, 0, 0, ["700\\d{5}", [8]]]], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}"], ["(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}"], ["8[02369]\\d{6}"], ["(?:87|9[0-8])\\d{6}"], 0, 0, 0, 0, 0, ["84\\d{6}"]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], 0, 0, 0, 0, 0, 0, [["(?:22|31)\\d{6}"], ["(?:29|[67][125-9])\\d{6}"]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]], 0, 0, 0, 0, 0, 0, [["2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}"], ["(?:4[0-356]|[56]\\d|9[013-9])\\d{6}"], 0, 0, 0, 0, ["81\\d{6}"], 0, ["857[58]\\d{4}"]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441", [["441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"], ["441(?:[2378]\\d|5[0-39]|92)\\d{5}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}"], ["(?:22[89]|[78]\\d\\d)\\d{4}"], 0, 0, 0, 0, 0, 0, ["5[34]\\d{5}"]]], BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?", 0, 0, 0, [["(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", [8]], ["[67]\\d{7}", [8]], ["8001[07]\\d{4}", [9]]]], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]", [["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"], ["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", 0, 0, [["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", [10]], ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", [10, 11]], ["800\\d{6,7}", [9, 10]], ["300\\d{6}|[59]00\\d{6,7}", [9, 10]], 0, 0, 0, 0, 0, ["(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", [8, 10]]]], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242", [["242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"], ["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}"], ["242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["242225\\d{4}"]]], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", [7]], ["(?:1[67]|77)\\d{6}", [8]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}", [7]], ["(?:321|7[1-8]\\d)\\d{5}", [8]], ["(?:0800|800\\d)\\d{6}", [10]], ["90\\d{5}", [7]], 0, 0, 0, 0, ["79(?:1(?:[01]\\d|2[0-8])|2[0-7]\\d)\\d{3}", [8]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, [["(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", [9]], ["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", [9]], ["800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}"], ["(?:810|902)\\d{7}", [10]], 0, 0, 0, 0, ["249\\d{6}", [9]]], "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", [7]], ["6[0-35-7]\\d{5}", [7]], ["0800\\d{7}", [11]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["12\\d{7}|[1-6]\\d{6}"], ["88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}"]]], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], 0, 0, 0, 0, 0, 0, [["2[12]\\d{6}"], ["7[024-7]\\d{6}"], 0, ["8776\\d{4}"]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], 0, 0, 0, 0, 0, 0, [["222[1-589]\\d{5}"], ["026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"], 0, ["80[0-2]\\d{6}"]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}"], ["7[35-9]\\d{7}"], ["800\\d{6}"], ["90[016]\\d{6}"], ["878\\d{6}"], 0, ["5[18]\\d{7}"], ["74[0248]\\d{6}"], 0, ["84[0248]\\d{6}"]]], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], 0, 0, 0, 0, 0, 0, [["2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}"], ["0[157]\\d{8}"]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[13-7]|4[1-5])\\d{3}"], ["[578]\\d{4}"]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], 0, 0, 0, 0, 0, 0, [["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", [9]], ["", [9]], ["(?:123|8)00\\d{6}", [9, 11]], 0, 0, 0, 0, 0, ["44\\d{7}", [9]], ["600\\d{7,8}", [10, 11]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], 0, 0, 0, 0, 0, 0, [["2(?:22|33)\\d{6}", [9]], ["(?:24[23]|6[25-9]\\d)\\d{6}", [9]], ["88\\d{6,7}"]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, [["(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))", [7, 8, 9, 10, 11]], ["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", [11]], ["(?:(?:10|21)8|8)00\\d{7}", [10, 12]], ["16[08]\\d{5}", [8]], 0, 0, 0, 0, 0, ["10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", [7, 8, 9, 10, 11]]], "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?", 0, 0, 0, [["601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60(?:[124-7][2-9]|8[1-9])\\d{6}", [10]], ["333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", [10]], ["1800\\d{7}", [11]], ["19(?:0[01]|4[78])\\d{7}", [11]]]], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))", 0, 0, 0, [["210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", [8]], ["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", [8]], ["800\\d{7}", [10]], ["90[059]\\d{7}", [10]], 0, 0, 0, 0, ["(?:210[0-6]|4\\d{3}|5100)\\d{4}", [8]]]], CU: ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}"], ["(?:5\\d|63)\\d{6}", [8]], ["800\\d{7}", [10]], 0, 0, 0, 0, 0, 0, ["807\\d{7}", [10]]]], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}"], ["(?:36|5[1-389]|9\\d)\\d{5}"], ["800\\d{4}"], 0, 0, 0, 0, 0, ["(?:3[3-5]|4[356])\\d{5}"]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]", [["9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"], ["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"], 0, 0, 0, 0, 0, ["955\\d{5}", [8]], 0, ["60[0-2]\\d{4}", [7]]]], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], 0, 0, 0, 0, 0, 0, [["2[2-6]\\d{6}"], ["9(?:10|[4-79]\\d)\\d{5}"], ["800\\d{5}"], ["90[09]\\d{5}"], ["700\\d{5}"], 0, ["(?:50|77)\\d{6}"], 0, 0, ["80[1-9]\\d{5}"]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}"], ["(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}"], ["800\\d{6}"], ["9(?:0[05689]|76)\\d{6}"], ["70[01]\\d{6}"], 0, ["9(?:5\\d|7[2-4])\\d{6}"], 0, ["9[17]0\\d{6}"], ["8[134]\\d{7}"]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0", 0, 0, 0, 0, 0, [["32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}", [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]], ["15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}", [10, 11]], ["800\\d{7,12}", [10, 11, 12, 13, 14, 15]], ["(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", [10, 11]], ["700\\d{8}", [11]], 0, ["18(?:1\\d{5,11}|[2-9]\\d{8})", [8, 9, 10, 11, 12, 13, 14]], ["16(?:4\\d{1,10}|[89]\\d{1,11})", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], 0, ["180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", [7, 8, 9, 10, 11, 12, 13, 14]]]], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], 0, 0, 0, 0, 0, 0, [["2(?:1[2-5]|7[45])\\d{5}"], ["77\\d{6}"]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}"], [""], ["80\\d{6}"], ["90\\d{6}"]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767", [["767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"], ["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9", [["8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"], ["8[024]9[2-9]\\d{6}"], ["8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}"], ["(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["80[3-689]1\\d{5}", [9]], 0, 0, 0, 0, ["98[23]\\d{6}", [9]], ["80[12]1\\d{5}", [9]]]], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["[2-7][2-7]\\d{6}", [8]], ["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", [9]], ["1800\\d{7}|1[78]00\\d{6}", [10, 11]], 0, 0, 0, 0, 0, ["[2-7]890\\d{4}", [8]]]], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", [7]], ["(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", [7, 8]], ["800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"], ["(?:40\\d\\d|900)\\d{4}", [7, 8]], ["70[0-2]\\d{5}", [8]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", [8, 9]], ["1[0-25]\\d{8}", [10]], ["800\\d{7}", [10]], ["900\\d{7}", [10]]]], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]", [["528[89]\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}"], ["(?:17[1-3]|7\\d\\d)\\d{4}"]]], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"], ["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"], ["[89]00\\d{6}"], ["80[367]\\d{6}"], ["70\\d{7}"], 0, ["51\\d{7}"], 0, 0, ["90[12]\\d{6}"]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}"], ["700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"]]], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", [["(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}", [5, 6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, [["603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", [7]], ["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", [7]], ["0800\\d{7}", [11]]], "00"], FK: ["500", "00", "[2-7]\\d{4}", [5], 0, 0, 0, 0, 0, 0, 0, [["[2-47]\\d{4}"], ["[56]\\d{4}"]]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], 0, 0, 0, 0, 0, 0, [["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}"], ["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))", 0, 0, 0, [["(?:20|[34]\\d|8[19])\\d{4}"], ["(?:[27][1-9]|5\\d|9[16])\\d{4}"], ["80[257-9]\\d{3}"], ["90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d"], 0, 0, 0, 0, ["(?:6[0-36]|88)\\d{4}"]]], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["59[1-9]\\d{6}|(?:[1-3]\\d|4[1-9]|5[0-8])\\d{7}"], ["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"], ["80[0-5]\\d{6}"], ["836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"], 0, 0, ["80[6-9]\\d{6}"], 0, ["9\\d{8}"], ["8(?:1[01]|2[0156]|4[02]|84)\\d{6}"]]], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", 0, 0, [["[01]1\\d{6}", [8]], ["(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"]]], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473", [["473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"], ["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}"], ["5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|(?:5(?:00(?:0\\d|11|22|33|44|5[05]|77|88|99)|1(?:1(?:00|[124]\\d|3[01])|4\\d\\d)|(?:44|68)\\d\\d|5(?:[0157-9]\\d\\d|200)|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|58[89]|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}|5(?:0(?:070|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["70[67]\\d{6}"]]], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["594(?:[02-49]\\d|1[0-4]|5[6-9]|6[0-3]|80)\\d{4}"], ["694(?:[0-249]\\d|3[0-8])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}"]]], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", [9]], ["(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", [9]], ["800\\d{5}", [8]]]], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]], 0, 0, 0, 0, 0, 0, [["2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}"], ["5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}"], ["[245]\\d{5}"], ["80\\d{4}"], 0, 0, 0, 0, 0, ["3[89]\\d{4}"]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}"], ["(?:[23679]\\d|5[0-489])\\d{5}"]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", [8]], ["6[0-356]\\d{7}", [9]], 0, 0, 0, 0, 0, 0, ["722\\d{6}", [9]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}"], ["(?:222|55\\d)\\d{6}"], ["80\\d[1-9]\\d{5}"], ["90\\d[1-9]\\d{5}"]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", [10]], ["68[57-9]\\d{7}|(?:69|94)\\d{8}", [10]], ["800\\d{7,9}"], ["90[19]\\d{7}", [10]], ["70\\d{8}", [10]], 0, ["5005000\\d{3}", [10]], 0, 0, ["8(?:0[16]|12|[27]5|50)\\d{7}", [10]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["[267][2-9]\\d{6}", [8]], ["(?:[3-5]\\d\\d|80[0-4])\\d{5}", [8]], ["18[01]\\d{8}", [11]], ["19\\d{9}", [11]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([3-9]\\d{6})$|1", "671$1", 0, "671", [["671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], 0, 0, 0, 0, 0, 0, [["443\\d{6}", [9]], ["9(?:5\\d|6[569]|77)\\d{6}", [9]], 0, 0, 0, 0, 0, 0, ["40\\d{5}", [7]]]], GY: ["592", "001", "9008\\d{3}|(?:[2-467]\\d\\d|510|862)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}"], ["(?:510|6\\d\\d|7(?:0\\d|1[0-8]|25|49))\\d{4}"], ["(?:289|862)\\d{4}"], ["9008\\d{3}"]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:[45][0-8]|6[01]|9\\d))|58(?:0[1-9]|1[2-9]))\\d{4}", [8]], ["(?:4(?:44[5-9]|6(?:0[0-7]|1[0-6]|4[0-57-9]|6[0-4]))|573[0-6]|6(?:26[013-8]|66[0-3])|70(?:7[1-5]|8[0-4])|848[0-25-9]|9(?:29[013-9]|59[0-4]))\\d{4}|(?:4(?:4[01]|6[23578])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", [8]], ["800\\d{6}", [9]], ["900(?:[0-24-9]\\d{7}|3\\d{1,4})", [5, 6, 7, 8, 11]], ["8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", [8]], 0, ["30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", [8]], ["7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", [8]]], "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}", [8]], ["[37-9]\\d{7}", [8]], ["8002\\d{7}", [11]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", [8, 9]], ["9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|77|9[67])))\\d{4}|98\\d{6}", [8, 9]], ["80\\d{5,7}", [7, 8, 9]], ["6[01459]\\d{6}|6[01]\\d{4,5}", [6, 7, 8]], ["7[45]\\d{6}", [8]], 0, ["62\\d{6,7}|72\\d{6}", [8, 9]]]], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2\\d|5[1-5]|81|9[149])\\d{5}"], ["(?:[34]\\d|55)\\d{6}"], ["8\\d{7}"], 0, 0, 0, 0, 0, ["9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}"]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06", 0, 0, 0, 0, 0, [["(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", [8]], ["(?:[257]0|3[01])\\d{7}", [9]], ["(?:[48]0\\d|680[29])\\d{5}"], ["9[01]\\d{6}", [8]], 0, 0, ["38\\d{7}", [9]], 0, ["21\\d{7}", [9]]]], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", [7, 8, 9, 10, 11]], ["8[1-35-9]\\d{7,10}", [9, 10, 11, 12]], ["00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}", [8, 9, 10, 11, 12, 13]], ["809\\d{7}", [10]], 0, 0, ["(?:1500|8071\\d{3})\\d{3}", [7, 10]], 0, 0, ["804\\d{7}", [10]]]], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"], ["8(?:22|[35-9]\\d)\\d{6}", [9]], ["1800\\d{6}", [10]], ["15(?:1[2-8]|[2-8]0|9[089])\\d{6}", [10]], ["700\\d{6}", [9]], 0, ["818\\d{6}", [9]], 0, ["76\\d{7}", [9]], ["18[59]0\\d{6}", [10]]]], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0", 0, 0, 0, 0, 0, [["153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", [8, 11, 12]], ["55410\\d{4}|5(?:(?:[02][02-9]|[149][2-9]|[36]\\d|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", [9]], ["1(?:255|80[019]\\d{3})\\d{3}", [7, 10]], ["1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", [8, 10]], 0, 0, ["1599\\d{6}", [10]], 0, ["7(?:38(?:0\\d|5[09]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}", [9]], ["1700\\d{6}", [10]]]], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24", [["1624(?:230|[5-8]\\d\\d)\\d{3}"], ["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"], ["808162\\d{4}"], ["8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"], ["70\\d{8}"], 0, ["3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"], 0, ["56\\d{8}"]]], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0", 0, 0, 0, 0, 0, [["2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}", [10]], ["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}", [10]], ["000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))"], ["186[12]\\d{9}", [13]], 0, 0, ["140\\d{7}", [10]], 0, 0, ["1860\\d{7}", [11]]]], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]], 0, 0, 0, 0, 0, 0, [["37\\d{5}"], ["38\\d{5}"]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", [8, 9]], ["7[3-9]\\d{8}", [10]]]], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}", [6, 7, 10]], ["9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", [10]], 0, 0, 0, 0, ["96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", [4, 5]]]], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", [7]], ["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"], ["80[0-8]\\d{4}", [7]], ["90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}", [7]], 0, 0, ["809\\d{4}", [7]], 0, ["49[0-24-79]\\d{4}", [7]]], "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876", [["8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"], ["(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}", [8]], ["7(?:[78][0-25-9]|9\\d)\\d{6}", [9]], ["80\\d{6}", [8]], ["9\\d{7}", [8]], ["70\\d{7}", [9]], 0, ["8(?:10|8\\d)\\d{5}", [8]], ["74(?:66|77)\\d{5}", [9]], 0, ["85\\d{6}", [8]]]], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", 0, 0, [["(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", [9]], ["[7-9]0[1-9]\\d{7}", [10]], ["00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}"], ["990\\d{6}", [9]], ["60\\d{7}", [9]], 0, ["570\\d{6}", [9]], ["20\\d{8}", [10]], ["50[1-9]\\d{7}", [10]]]], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}", [7, 8, 9]], ["(?:1(?:0[0-6]|1[0-5]|2[014]|30)|7\\d\\d)\\d{6}", [9]], ["800[2-8]\\d{5,6}", [9, 10]], ["900[02-9]\\d{5}", [9]]]], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", [9]], ["312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", [9]], ["800\\d{6,7}"]]], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})", [8, 9]], ["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", [8, 9]], ["1800(?:1\\d|2[019])\\d{4}", [10]], ["1900(?:1\\d|2[09])\\d{4}", [10]]]], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0", 0, 0, 0, 0, 0, [["(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}"], ["(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}", [8]], 0, 0, 0, 0, 0, 0, ["30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", [8]]]], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], 0, 0, 0, 0, 0, 0, [["7[4-7]\\d{5}"], ["[34]\\d{6}"], 0, ["8\\d{6}"]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869", [["869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}"], ["869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}"], ["19[1-3]\\d{7}", [10]]]], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?", 0, 0, 0, [["(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}", [5, 6, 8, 9, 10]], ["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", [9, 10]], ["00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}", [9, 11, 12, 13, 14]], ["60[2-9]\\d{6}", [9]], ["50\\d{8,9}", [10, 11]], 0, ["1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[168]|88)|8(?:00|33|55|77|99))\\d{4}", [8]], ["15\\d{7,8}", [9, 10]], ["70\\d{8}", [10]]]], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", [8]], ["(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|66)|222|3[36]3|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}", [8]], ["18\\d{5}", [7]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345", [["345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}"], ["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:345976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["345849\\d{4}"]]], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", [["(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}", [10]], ["7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", [10]], ["8(?:00|108\\d{3})\\d{7}"], ["809\\d{7}", [10]], ["808\\d{7}", [10]], 0, 0, 0, ["751\\d{7}", [10]]], "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[13]|[35-7][14]|41|8[1468])\\d{6}", [8]], ["(?:20(?:[2359]\\d|7[6-8]|88)|302\\d)\\d{6}", [10]], 0, 0, 0, 0, ["30[013-9]\\d{6}", [9]]]], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0", 0, 0, 0, 0, 0, [["7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}"], ["793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"], 0, ["9[01]\\d{6}", [8]], 0, 0, 0, 0, 0, ["80\\d{6}", [8]]]], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758", [["758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"], ["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0", 0, 0, 0, [["(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}", [7]], ["(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[0245]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"], ["8002[28]\\d\\d|80(?:05\\d|9)\\d{4}"], ["90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", [7]], 0, 0, ["870(?:28|87)\\d\\d", [7]]]], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}"], ["7(?:[0-25-8]\\d|4[0-4])\\d{6}"], 0, 0, 0, 0, ["1973\\d{5}"]]], LR: ["231", "00", "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{7}", [8]], ["(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}", [7, 9]], 0, ["332(?:02|[34]\\d)\\d{4}", [9]]]], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["[56]\\d{7}"], ["800[256]\\d{4}"]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]", 0, 0, 0, [["(?:3[1478]|4[124-6]|52)\\d{6}"], ["6\\d{7}"], ["80[02]\\d{5}"], ["9(?:0[0239]|10)\\d{5}"], ["70[05]\\d{5}"], 0, ["70[67]\\d{5}"], 0, ["[89]01\\d{5}"], ["808\\d{5}"]]], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", 0, 0, 0, [["(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"], ["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", [9]], ["800\\d{5}", [8]], ["90[015]\\d{5}", [8]], 0, 0, 0, 0, ["20(?:1\\d{5}|[2-689]\\d{1,7})", [4, 5, 6, 7, 8, 9, 10]], ["801\\d{5}", [8]]]], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]], 0, 0, 0, 0, 0, 0, [["6\\d{7}"], ["23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}"], ["80\\d{6}"], ["90\\d{6}"], 0, 0, 0, 0, 0, ["81\\d{6}"]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}"], ["9[1-6]\\d{7}"]]], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29[1289]|389)", "529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:870|9[2-47-9]\\d)\\d{5}", [8]], ["4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"], ["(?:800|90\\d)\\d{5}", [8]]]], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}"], ["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"], ["800\\d{5}"], ["90[056]\\d{5}"], 0, 0, ["803\\d{5}"], 0, ["3[08]\\d{6}"], ["808\\d{5}"]]], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", [8]], ["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", [8]], ["80(?:[0-2578]|9\\d)\\d{5}"], ["9(?:4[1568]|5[178])\\d{5}", [8]], 0, 0, ["77[1-9]\\d{5}", [8]], 0, ["78[1-49]\\d{5}", [8]]]], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1", 0, 0, [["2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}"], ["3[2-47-9]\\d{7}"], 0, 0, 0, 0, 0, 0, ["22\\d{7}"]]], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1", 0, 0, 0, 0, 0, [["(?:247|45[78]|528|625)\\d{4}"], ["(?:(?:23|54)5|329|45[356])\\d{4}"], 0, 0, 0, 0, 0, 0, ["635\\d{4}"]]], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}"], ["7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|60|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"], ["800\\d{5}"], ["5\\d{7}"], 0, 0, 0, 0, 0, ["8(?:0[1-9]|[1-9]\\d)\\d{5}"]]], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}"], ["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}"], ["80\\d{6}"]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:(?:3\\d|8[01459])\\d|4[67]0)))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}", [6, 7, 8, 9]], ["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", [7, 8, 9, 10]], ["80080(?:0[1-9]|2\\d)\\d{3}", [10]], 0, 0, 0, 0, 0, ["1333\\d{4}|[12]468\\d{4}", [8]]]], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}"], ["(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}", [8]], 0, 0, 0, 0, 0, 0, ["712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}", [8]]]], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], 0, 0, 0, 0, 0, 0, [["(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}", [8]], ["6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", [8]], ["0800\\d{3}", [7]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670", [["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["596(?:[03-7]\\d|10|2[7-9]|8[0-39]|9[04-9])\\d{4}"], ["69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:397[0-2]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}"]]], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], 0, 0, 0, 0, 0, 0, [["(?:25[08]|35\\d|45[1-7])\\d{5}"], ["[2-4][0-46-9]\\d{6}"], ["800\\d{5}"]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664", [["6644(?:1[0-3]|91)\\d{4}"], ["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], 0, 0, 0, 0, 0, 0, [["20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}"], ["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"], ["800(?:02|[3467]\\d)\\d{3}"], ["5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"], 0, 0, ["501\\d{5}"], ["7117\\d{4}"], ["3550\\d{4}"]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", [7, 8]], ["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-3]|3[013]))\\d{5}", [8]], ["802\\d{7}|80[0-2]\\d{4}", [7, 10]], ["30\\d{5}", [7]], 0, 0, 0, 0, ["3(?:20|9\\d)\\d{4}", [7]]], "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}", [7]], ["(?:46[46]|[79]\\d\\d)\\d{4}", [7]], ["800\\d{7}", [10]], ["900\\d{7}", [10]], 0, 0, ["4(?:0[01]|50)\\d{4}", [7]]], "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[2-9]|2[12]\\d\\d)\\d{5}"], ["111\\d{6}|(?:31|77|[89][89])\\d{7}", [9]]]], MX: ["52", "0[09]", "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, [["657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}", [10]], ["657[12]\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}"], ["8(?:00|88)\\d{7}", [10]], ["900\\d{7}", [10]], ["500\\d{7}", [10]], 0, 0, 0, 0, ["300\\d{7}", [10]]], "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", [8, 9]], ["1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", [9, 10]], ["1[378]00\\d{6}", [10]], ["1600\\d{6}", [10]], 0, 0, 0, 0, ["15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", [10]]]], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", [8]], ["8[2-79]\\d{7}", [9]], ["800\\d{6}", [9]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}"], ["(?:60|8[1245])\\d{7}", [9]], ["80\\d{7}", [9]], ["8701\\d{5}", [9]], 0, 0, 0, 0, ["8(?:3\\d\\d|86)\\d{5}"]]], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}"], ["(?:5[0-4]|[79]\\d|8[0-79])\\d{4}"], ["050\\d{3}"], ["36\\d{4}"]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}"], ["(?:23|7[047]|[89]\\d)\\d{6}"], ["08\\d{6}"], ["09\\d{6}"]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1", 0, 0, [["(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}"], ["(?:14|3[58])\\d{4}"]]], NG: ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}", [7, 8]], ["(?:702[0-24-9]|819[01])\\d{6}|(?:70[13-689]|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-356]))\\d{7}", [10]], ["800\\d{7,11}", [10, 11, 12, 13, 14]], 0, 0, 0, ["700\\d{7,11}", [10, 11, 12, 13, 14]]]], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"], ["1800\\d{4}"]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", [9]], ["(?:6[1-58]|970\\d)\\d{7}", [9, 11]], ["800\\d{4,7}", [7, 8, 9, 10]], ["90[069]\\d{4,7}", [7, 8, 9, 10]], 0, 0, ["140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", [5, 6, 9]], ["66\\d{7}", [9]], ["(?:85|91)\\d{7}", [9]]]], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]", [["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], 0, ["(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", [8]], ["9(?:6[0-3]|7[024-6]|8[0-24-68])\\d{7}", [10]], ["1(?:66001|800\\d\\d)\\d{5}", [11]]]], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]], 0, 0, 0, 0, 0, 0, [["444\\d{4}"], ["(?:55[3-9]|666|8\\d\\d)\\d{4}"]]], NU: ["683", "00", "(?:[47]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["[47]\\d{3}", [4]], ["888[1-9]\\d{3}", [7]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", [8]], ["2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", [8, 9, 10]], ["508\\d{6,7}|80\\d{6,8}", [8, 9, 10]], ["(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", [7, 8, 9, 10]], ["70\\d{7}", [9]], 0, ["8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}"]], "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], 0, 0, 0, 0, 0, 0, [["2[1-6]\\d{6}", [8]], ["1505\\d{4}|(?:7(?:[1289]\\d|6[89]|7[0-5])|9(?:0[1-9]|[1-9]\\d))\\d{5}", [8]], ["8007\\d{4,5}|(?:500|800[05])\\d{4}"], ["900\\d{5}", [8]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[089]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068]|7[0-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}", [7]], ["(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", [7, 8]], ["800\\d{4,5}|(?:00800|800\\d)\\d{6}"], ["(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", [7]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", [8]], ["9\\d{8}", [9]], ["800\\d{5}", [8]], ["805\\d{5}", [8]], ["80[24]\\d{5}", [8]], 0, 0, 0, 0, ["801\\d{5}", [8]]], "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["4(?:0[4-689]|9[4-68])\\d{5}", [8]], ["8[7-9]\\d{6}", [8]], ["80[0-5]\\d{6}", [9]], 0, 0, 0, ["44\\d{4}", [6]], 0, ["499\\d{5}", [8]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, [["(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", [7]], ["(?:7\\d|8[128])\\d{6}", [8]], ["180\\d{4}", [7]], 0, 0, 0, 0, ["27[01]\\d{4}", [7]], ["2(?:0[0-57]|7[568])\\d{4}", [7]]], "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}", [6, 8, 9, 10]], ["(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", [10]], ["1800\\d{7,9}", [11, 12, 13]]]], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", [9, 10]], ["3(?:[0-24]\\d|3[0-79]|55|64)\\d{7}", [10]], ["800\\d{5}(?:\\d{3})?", [8, 11]], ["900\\d{5}", [8]], ["122\\d{6}", [9]], 0, ["(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", [11, 12]]]], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", [7, 9]], ["21(?:1(?:[145]\\d|3[1-5])|2\\d\\d)\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", [9]], ["800\\d{6,7}", [9, 10]], ["70[01346-8]\\d{6}", [9]], 0, 0, ["804\\d{6}", [9]], ["64\\d{4,7}", [6, 7, 8, 9]], ["39\\d{7}", [9]], ["801\\d{6}", [9]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[1-35-7]|5[01])\\d{4}", [6]], ["(?:4[02-4]|5[056]|708[45][0-5])\\d{4}"], ["80[0-5]\\d{6}", [9]]]], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939", [["(?:787|939)[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", [8]], ["5[69]\\d{7}", [9]], ["1800\\d{6}", [10]], 0, 0, 0, 0, 0, 0, ["1700\\d{6}", [10]]]], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}"], ["6(?:[06]92(?:30|9\\d)|[35]92(?:3[03]|9\\d))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"], ["80[02]\\d{6}"], ["(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"], ["884[0-4689]\\d{5}"], 0, ["70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}"], ["6222\\d{5}"], ["30\\d{7}"], ["80(?:8\\d|9[1579])\\d{5}"]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}"], ["(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}"]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}", [7, 8, 9]], ["9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}", [9]], ["9800\\d{5,7}", [9, 10, 11]], 0, 0, 0, ["[2-9]0\\d{4,7}", [6, 7, 8, 9]], 0, ["8700[0-4]\\d{4}", [9]]]], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], 0, 0, 0, 0, 0, 0, [["4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}", [8]], ["[35-7]\\d{7}", [8]], ["800\\d{4}|(?:0080[01]|800)\\d{6}", [7, 9, 11]], 0, 0, 0, 0, ["2[16]\\d{5}", [7]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"], ["7020\\d{5}|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-29])\\d{6}", [9]], ["800\\d{6}", [9]], ["90[0136]\\d{6}", [9]], 0, 0, ["(?:37\\d|80[578])\\d{6}", [9]], 0, 0, ["801\\d{6}", [9]]], 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", [7, 8, 9, 10, 11, 12]], ["6(?:[0-689]|7\\d)\\d{6,7}", [8, 9, 10]], ["800\\d{3,9}"], ["(?:78\\d|90[0169])\\d{3,7}", [6, 7, 8, 9, 10]], 0, 0, ["7[06]\\d{4,10}"]]], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", [["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:06|2[23568]\\d)\\d{6}"], ["7[237-9]\\d{7}", [9]], ["800\\d{6}", [9]], ["900\\d{6}", [9]]]], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, 0, 0, 0, 0, [["1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", [9]], ["579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}", [9]], ["800\\d{7}", [10]], ["925\\d{6}", [9]], 0, 0, ["811\\d{7}", [10]], 0, 0, ["920\\d{6}", [9]]]], SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]], 0, 0, 0, 0, 0, 0, [["(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", [5]], ["48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"], ["1[38]\\d{3}", [5]], 0, 0, 0, 0, 0, ["5[12]\\d{3}", [5]]]], SC: ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, [["4[2-46]\\d{5}"], ["2[125-8]\\d{5}"], ["800[08]\\d{3}"], 0, 0, 0, 0, 0, ["971\\d{4}|(?:64|95)\\d{5}"]], "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:5\\d|8[35-7])\\d{6}"], ["(?:1[0-2]|9[0-3569])\\d{7}"]]], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}", [7, 8, 9]], ["7[02369]\\d{7}", [9]], ["20\\d{4,7}", [6, 7, 8, 9]], ["649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", [7, 8, 9, 10]], ["75[1-8]\\d{6}", [9]], 0, ["10[1-8]\\d{6}", [9]], ["74[02-9]\\d{6}", [9]], 0, ["77[0-7]\\d{6}", [9]]]], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-8]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}", [8]], ["8(?:08[01]|95[0-2])\\d{4}|(?:8(?:0[1-7]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}", [8]], ["(?:18|8)00\\d{7}", [10, 11]], ["1900\\d{7}", [11]], 0, 0, ["7000\\d{7}", [11]], 0, ["(?:3[12]\\d|666)\\d{5}", [8]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]", [["2(?:[0-57-9]\\d|6[4-9])\\d\\d"], ["[56]\\d{4}", [5]], 0, 0, 0, 0, 0, 0, ["262\\d\\d", [5]]]], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:[1-357][2-8]|4[24-8])\\d{6}", [8]], ["65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", [8]], ["80\\d{4,6}", [6, 7, 8]], ["89[1-3]\\d{2,5}|90\\d{4,6}"], 0, 0, 0, 0, ["(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", [8]]], "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79", [["79\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], 0, ["(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"], ["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["9(?:00|[78]\\d)\\d{6}", [9]], 0, 0, ["96\\d{7}", [9]], ["9090\\d{3}", [7]], ["6(?:02|5[0-4]|9[0-6])\\d{6}", [9]], ["8[5-9]\\d{7}", [9]]]], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["22[2-4][2-9]\\d{4}"], ["(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}"]]], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1", 0, 0, [["0549(?:8[0157-9]|9\\d)\\d{4}", [10]], ["6[16]\\d{6}", [8]], 0, ["7[178]\\d{6}", [8]], 0, 0, 0, 0, ["5[158]\\d{6}", [8]]]], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}"], ["7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}"], ["800\\d{6}"], ["88[4689]\\d{6}"], 0, 0, 0, 0, ["(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}"], ["81[02468]\\d{6}"]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}", [6, 7]], ["(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", [7, 8, 9]]]], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}"], ["(?:7[124-7]|8[124-9])\\d{5}", [7]], 0, 0, 0, 0, 0, 0, ["56\\d{4}", [6]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1[89]\\d{7}"], ["(?:12|9[1257-9])\\d{7}"]]], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["22\\d{5}"], ["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]], SV: ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}", [8]], ["[67]\\d{7}", [8]], ["800\\d{4}(?:\\d{4})?", [7, 11]], ["900\\d{4}(?:\\d{4})?", [7, 11]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721", [["7215(?:4[2-8]|8[239]|9[056])\\d{4}"], ["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}"], ["9[1-689]\\d{7}", [9]]]], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]], 0, 0, 0, 0, 0, 0, [["[23][2-5]\\d{6}", [8]], ["7[6-9]\\d{6}", [8]], ["0800\\d{4}", [8]], ["900\\d{6}", [9]], 0, 0, 0, 0, ["70\\d{6}", [8]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8", [["8\\d{3}"]]], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649", [["649(?:266|712|9(?:4\\d|50))\\d{4}"], ["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["649(?:71[01]|966)\\d{4}"]]], TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, [["22(?:[37-9]0|5[0-5]|6[89])\\d{4}"], ["(?:6[0235689]|77|9\\d)\\d{6}"]], "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}"], ["(?:7[019]|9[0-36-9])\\d{6}"]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", [8]], ["671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", [9]], ["(?:001800\\d|1800)\\d{6}", [10, 13]], ["1900\\d{6}", [10]], 0, 0, 0, 0, ["6[08]\\d{7}", [9]]]], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[04]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:4[046]|74|87))\\d{6}"], ["(?:41[18]|81[1-9])\\d{6}|(?:0[0-57-9]|1[017]|2[02]|[34]0|5[05]|7[0178]|8[078]|9\\d)\\d{7}"]], "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7], 0, 0, 0, 0, 0, 0, 0, [["(?:2[2-4]|[34]\\d)\\d{2,5}"], ["7[2-4]\\d{2,5}"]]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", [7]], ["7[2-8]\\d{6}", [8]], ["80\\d{5}", [7]], ["90\\d{5}", [7]], ["70\\d{5}", [7]]]], TM: ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}"], ["6\\d{7}"]], "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], 0, 0, 0, 0, 0, 0, [["81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}"], ["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"], ["8010\\d{4}"], ["88\\d{6}"], 0, 0, 0, 0, 0, ["8[12]10\\d{4}"]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", [5]], ["(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", [7]], ["0800\\d{3}", [7]], 0, 0, 0, 0, 0, ["55[0-37-9]\\d{4}", [7]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", [10]], ["561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", [10]], ["8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", [10, 12, 13]], ["(?:8[89]8|900)\\d{7}", [10]], ["592(?:21[12]|461)\\d{4}", [10]], 0, ["444\\d{4}", [7]], ["512\\d{7}", [10]], ["850\\d{7}", [10]]]], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868", [["868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"], ["868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["2[02-9]\\d{3}", [5]], ["(?:7[01]\\d|90)\\d{4}", [6, 7]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}", [8, 9]], ["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", [9]], ["80[0-79]\\d{6}|800\\d{5}", [8, 9]], ["20(?:[013-9]\\d\\d|2)\\d{4}", [7, 9]], ["99\\d{7}", [9]], 0, ["50[0-46-9]\\d{6}", [9]], 0, ["7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", [10, 11]]], 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[2-8]\\d{7}"], ["77[2-9]\\d{6}|(?:6[125-9]|7[13-689])\\d{7}"], ["80[08]\\d{6}"], ["90\\d{7}"], 0, 0, 0, 0, ["41\\d{7}"], ["8(?:40|6[01])\\d{6}"]]], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", [9]], ["(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}", [9]], ["800[1-8]\\d{5,6}"], ["900[239]\\d{5,6}"], 0, 0, 0, 0, ["89[1-579]\\d{6}", [9]]], "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}"], ["726[01]\\d{5}|7(?:[015-8]\\d|20|36|4[0-4]|9[89])\\d{6}"], ["800[1-3]\\d{5}"], ["90[1-3]\\d{6}"]]], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["5056(?:[0-35-9]\\d|4[468])\\d{4}|(?:4722|505[2-57-9]|983[29])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, [["(?:1(?:770|9(?:20|87))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", [8]], ["9[1-9]\\d{6}", [8]], ["0004\\d{2,9}|(?:405|80[05])\\d{4}"], ["90[0-8]\\d{4}", [7]]], "00", " int. "], UZ: ["998", "810", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|[68]\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}"], ["(?:(?:[25]0|33|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"]], "8~10"], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698", [["06698\\d{1,6}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784", [["784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"], ["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["78451[0-2]\\d{4}"]]], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}"], ["4(?:1[24-8]|2[46])\\d{7}"], ["800\\d{7}"], ["90[01]\\d{7}"], 0, 0, ["501\\d{7}"]]], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284", [["284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"], ["284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340", [["340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", [10]], ["(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", [9]], ["1800\\d{4,6}|12(?:0[13]|28)\\d{4}", [8, 9, 10]], ["1900\\d{4,6}", [8, 9, 10]], 0, 0, ["(?:[17]99|80\\d)\\d{4}|69\\d{5,6}", [7, 8]], 0, ["672\\d{6}", [9]]]], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", [5]], ["(?:[58]\\d|7[013-7])\\d{5}", [7]], ["81[18]\\d\\d", [5]], 0, 0, 0, ["(?:3[03]|900\\d)\\d{3}"], 0, ["9(?:0[1-9]|1[01])\\d{4}", [7]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["72\\d{4}", [6]], ["(?:72|8[23])\\d{4}", [6]], ["80[0-5]\\d{6}", [9]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", [5, 6]], ["(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", [7, 10]], ["800\\d{3}", [6]]]], XK: ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[89]|39)0\\d{6}|[23][89]\\d{6}"], ["4[3-9]\\d{6}", [8]], ["800\\d{5}", [8]], ["900\\d{5}", [8]]]], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", [7, 8]], ["7[01378]\\d{7}", [9]]]], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", [9]], ["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", [5, 6, 7, 8, 9]], ["80\\d{7}", [9]], ["(?:86[2-9]|9[0-2]\\d)\\d{6}", [9]], 0, 0, ["861\\d{6,7}", [9, 10]], 0, ["87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", [9]], ["860\\d{6}", [9]]]], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["21[1-8]\\d{6}"], ["(?:7[5-79]|9[5-8])\\d{7}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["63\\d{7}"]]], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}"], ["7(?:[178]\\d|3[1-9])\\d{6}", [9]], ["80(?:[01]\\d|20|8[0-8])\\d{3}", [7]], 0, 0, 0, 0, 0, ["86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", [10]]]] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function o$8(a3, r3) {
  var t3 = Array.prototype.slice.call(r3);
  return t3.push(d$c), a3.apply(this, t3);
}
var v$8 = 2, A$7 = 17, E$7 = 3, _$8 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9", F$9 = "-\u2010-\u2015\u2212\u30FC\uFF0D", u$d = "\uFF0F/", a$c = "\uFF0E.", S$8 = " \xA0\xAD\u200B\u2060\u3000", r$9 = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]", c$h = "~\u2053\u223C\uFF5E", N$8 = "".concat(F$9).concat(u$d).concat(a$c).concat(S$8).concat(r$9).concat(c$h), T$6 = "+\uFF0B";
function p$d(e28) {
  "@babel/helpers - typeof";
  return p$d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t3) {
    return typeof t3;
  } : function(t3) {
    return t3 && typeof Symbol == "function" && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
  }, p$d(e28);
}
function s$c(e28, t3) {
  for (var n3 = 0; n3 < t3.length; n3++) {
    var r3 = t3[n3];
    r3.enumerable = r3.enumerable || false, r3.configurable = true, "value" in r3 && (r3.writable = true), Object.defineProperty(e28, r3.key, r3);
  }
}
function O$8(e28, t3, n3) {
  return t3 && s$c(e28.prototype, t3), n3 && s$c(e28, n3), Object.defineProperty(e28, "prototype", { writable: false }), e28;
}
function m$c(e28, t3) {
  if (!(e28 instanceof t3))
    throw new TypeError("Cannot call a class as a function");
}
function w$6(e28, t3) {
  if (typeof t3 != "function" && t3 !== null)
    throw new TypeError("Super expression must either be null or a function");
  e28.prototype = Object.create(t3 && t3.prototype, { constructor: { value: e28, writable: true, configurable: true } }), Object.defineProperty(e28, "prototype", { writable: false }), t3 && u$c(e28, t3);
}
function d$b(e28) {
  var t3 = h$b();
  return function() {
    var r3 = f$c(e28), o3;
    if (t3) {
      var c3 = f$c(this).constructor;
      o3 = Reflect.construct(r3, arguments, c3);
    } else
      o3 = r3.apply(this, arguments);
    return g$d(this, o3);
  };
}
function g$d(e28, t3) {
  if (t3 && (p$d(t3) === "object" || typeof t3 == "function"))
    return t3;
  if (t3 !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _$7(e28);
}
function _$7(e28) {
  if (e28 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e28;
}
function l$e(e28) {
  var t3 = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return l$e = function(r3) {
    if (r3 === null || !P$7(r3))
      return r3;
    if (typeof r3 != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t3 < "u") {
      if (t3.has(r3))
        return t3.get(r3);
      t3.set(r3, o3);
    }
    function o3() {
      return i$b(r3, arguments, f$c(this).constructor);
    }
    return o3.prototype = Object.create(r3.prototype, { constructor: { value: o3, enumerable: false, writable: true, configurable: true } }), u$c(o3, r3);
  }, l$e(e28);
}
function i$b(e28, t3, n3) {
  return h$b() ? i$b = Reflect.construct : i$b = function(o3, c3, y3) {
    var a3 = [null];
    a3.push.apply(a3, c3);
    var v3 = Function.bind.apply(o3, a3), b3 = new v3();
    return y3 && u$c(b3, y3.prototype), b3;
  }, i$b.apply(null, arguments);
}
function h$b() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return false;
  if (typeof Proxy == "function")
    return true;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), true;
  } catch {
    return false;
  }
}
function P$7(e28) {
  return Function.toString.call(e28).indexOf("[native code]") !== -1;
}
function u$c(e28, t3) {
  return u$c = Object.setPrototypeOf || function(r3, o3) {
    return r3.__proto__ = o3, r3;
  }, u$c(e28, t3);
}
function f$c(e28) {
  return f$c = Object.setPrototypeOf ? Object.getPrototypeOf : function(n3) {
    return n3.__proto__ || Object.getPrototypeOf(n3);
  }, f$c(e28);
}
var S$7 = /* @__PURE__ */ function(e28) {
  w$6(n3, e28);
  var t3 = d$b(n3);
  function n3(r3) {
    var o3;
    return m$c(this, n3), o3 = t3.call(this, r3), Object.setPrototypeOf(_$7(o3), n3.prototype), o3.name = o3.constructor.name, o3;
  }
  return O$8(n3);
}(/* @__PURE__ */ l$e(Error));
function f$b(r3, t3) {
  r3 = r3.split("-"), t3 = t3.split("-");
  for (var N3 = r3[0].split("."), s3 = t3[0].split("."), e28 = 0; e28 < 3; e28++) {
    var i = Number(N3[e28]), u3 = Number(s3[e28]);
    if (i > u3)
      return 1;
    if (u3 > i)
      return -1;
    if (!isNaN(i) && isNaN(u3))
      return 1;
    if (isNaN(i) && !isNaN(u3))
      return -1;
  }
  return r3[1] && t3[1] ? r3[1] > t3[1] ? 1 : r3[1] < t3[1] ? -1 : 0 : !r3[1] && t3[1] ? 1 : r3[1] && !t3[1] ? -1 : 0;
}
var t$9 = {}.constructor;
function n$c(r3) {
  return r3 != null && r3.constructor === t$9;
}
function l$d(n3) {
  "@babel/helpers - typeof";
  return l$d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t3) {
    return typeof t3;
  } : function(t3) {
    return t3 && typeof Symbol == "function" && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
  }, l$d(n3);
}
function r$8(n3, t3) {
  if (!(n3 instanceof t3))
    throw new TypeError("Cannot call a class as a function");
}
function h$a(n3, t3) {
  for (var e28 = 0; e28 < t3.length; e28++) {
    var a3 = t3[e28];
    a3.enumerable = a3.enumerable || false, a3.configurable = true, "value" in a3 && (a3.writable = true), Object.defineProperty(n3, a3.key, a3);
  }
}
function o$7(n3, t3, e28) {
  return t3 && h$a(n3.prototype, t3), e28 && h$a(n3, e28), Object.defineProperty(n3, "prototype", { writable: false }), n3;
}
var v$7 = "1.2.0", P$6 = "1.7.35", g$c = " ext. ", d$a = /^\d+$/, C$9 = /* @__PURE__ */ function() {
  function n3(t3) {
    r$8(this, n3), k$9(t3), this.metadata = t3, y$f.call(this, t3);
  }
  return o$7(n3, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(e28) {
        return e28 !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(e28) {
      return this.metadata.countries[e28];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(e28) {
      return this.getCountryMetadata(e28) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(e28) {
      if (this.getCountryCodesForCallingCode(e28))
        return true;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[e28])
          return true;
      } else {
        var a3 = this.countryCallingCodes()[e28];
        if (a3 && a3.length === 1 && a3[0] === "001")
          return true;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(e28) {
      return this.nonGeographic() ? !!this.nonGeographic()[e28] : !this.getCountryCodesForCallingCode(e28);
    }
  }, {
    key: "country",
    value: function(e28) {
      return this.selectNumberingPlan(e28);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(e28, a3) {
      if (e28 && d$a.test(e28) && (a3 = e28, e28 = null), e28 && e28 !== "001") {
        if (!this.hasCountry(e28))
          throw new Error("Unknown country: ".concat(e28));
        this.numberingPlan = new c$g(this.getCountryMetadata(e28), this);
      } else if (a3) {
        if (!this.hasCallingCode(a3))
          throw new Error("Unknown calling code: ".concat(a3));
        this.numberingPlan = new c$g(this.getNumberingPlanMetadata(a3), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(e28) {
      var a3 = this.countryCallingCodes()[e28];
      if (a3)
        return a3.length === 1 && a3[0].length === 3 ? void 0 : a3;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(e28) {
      var a3 = this.getCountryCodesForCallingCode(e28);
      if (a3)
        return a3[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(e28) {
      var a3 = this.getCountryCodeForCallingCode(e28);
      if (a3)
        return this.getCountryMetadata(a3);
      if (this.nonGeographic()) {
        var i = this.nonGeographic()[e28];
        if (i)
          return i;
      } else {
        var u3 = this.countryCallingCodes()[e28];
        if (u3 && u3.length === 1 && u3[0] === "001")
          return this.metadata.countries["001"];
      }
    }
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
  }, {
    key: "type",
    value: function(e28) {
      return this.numberingPlan.type(e28);
    }
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(e28) {
      return this.selectNumberingPlan(e28);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), n3;
}(), c$g = /* @__PURE__ */ function() {
  function n3(t3, e28) {
    r$8(this, n3), this.globalMetadataObject = e28, this.metadata = t3, y$f.call(this, e28.metadata);
  }
  return o$7(n3, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(e28) {
      return e28[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
  }, {
    key: "formats",
    value: function() {
      var e28 = this, a3 = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return a3.map(function(i) {
        return new p$c(i, e28);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(e28) {
      return e28[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? false : !!this.types();
    }
  }, {
    key: "type",
    value: function(e28) {
      if (this.hasTypes() && m$b(this.types(), e28))
        return new F$8(m$b(this.types(), e28), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? g$c : this.metadata[13] || g$c;
    }
  }]), n3;
}(), p$c = /* @__PURE__ */ function() {
  function n3(t3, e28) {
    r$8(this, n3), this._format = t3, this.metadata = e28;
  }
  return o$7(n3, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && !b$9.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), n3;
}(), b$9 = /^\(?\$1\)?$/, F$8 = /* @__PURE__ */ function() {
  function n3(t3, e28) {
    r$8(this, n3), this.type = t3, this.metadata = e28;
  }
  return o$7(n3, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), n3;
}();
function m$b(n3, t3) {
  switch (t3) {
    case "FIXED_LINE":
      return n3[0];
    case "MOBILE":
      return n3[1];
    case "TOLL_FREE":
      return n3[2];
    case "PREMIUM_RATE":
      return n3[3];
    case "PERSONAL_NUMBER":
      return n3[4];
    case "VOICEMAIL":
      return n3[5];
    case "UAN":
      return n3[6];
    case "PAGER":
      return n3[7];
    case "VOIP":
      return n3[8];
    case "SHARED_COST":
      return n3[9];
  }
}
function k$9(n3) {
  if (!n3)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!n$c(n3) || !n$c(n3.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(n$c(n3) ? "an object of shape: { " + Object.keys(n3).join(", ") + " }" : "a " + x$9(n3) + ": " + n3, "."));
}
var x$9 = function(t3) {
  return l$d(t3);
};
function I$8(n3, t3) {
  if (t3 = new C$9(t3), t3.hasCountry(n3))
    return t3.country(n3).countryCallingCode();
  throw new Error("Unknown country: ".concat(n3));
}
function y$f(n3) {
  var t3 = n3.version;
  typeof t3 == "number" ? (this.v1 = t3 === 1, this.v2 = t3 === 2, this.v3 = t3 === 3, this.v4 = t3 === 4) : t3 ? f$b(t3, v$7) === -1 ? this.v2 = true : f$b(t3, P$6) === -1 ? this.v3 = true : this.v4 = true : this.v1 = true;
}
var g$b = ";ext=", t$8 = function(a3) {
  return "([".concat(_$8, "]{1,").concat(a3, "})");
};
function D$9(x3) {
  var a3 = "20", o3 = "15", i = "9", F3 = "6", n3 = "[ \xA0\\t,]*", e28 = "[:\\.\uFF0E]?[ \xA0\\t,-]*", r3 = "#?", s3 = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)", E3 = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)", l3 = "[- ]+", u3 = "[ \xA0\\t]*", v3 = "(?:,{2}|;)", b3 = g$b + t$8(a3), m3 = n3 + s3 + e28 + t$8(a3) + r3, p3 = n3 + E3 + e28 + t$8(i) + r3, L3 = l3 + t$8(F3) + "#", f3 = u3 + v3 + e28 + t$8(o3) + r3, c3 = u3 + "(?:,)+" + e28 + t$8(i) + r3;
  return b3 + "|" + m3 + "|" + p3 + "|" + L3 + "|" + f3 + "|" + c3;
}
var n$b = "[" + _$8 + "]{" + v$8 + "}", I$7 = "[" + T$6 + "]{0,1}(?:[" + N$8 + "]*[" + _$8 + "]){3,}[" + N$8 + _$8 + "]*", P$5 = new RegExp("^[" + T$6 + "]{0,1}(?:[" + N$8 + "]*[" + _$8 + "]){1,2}$", "i"), R$5 = I$7 + "(?:" + D$9() + ")?", T$5 = new RegExp("^" + n$b + "$|^" + R$5 + "$", "i");
function A$6(N3) {
  return N3.length >= v$8 && T$5.test(N3);
}
function o$6(N3) {
  return P$5.test(N3);
}
var n$a = new RegExp("(?:" + D$9() + ")$", "i");
function c$f(e28) {
  var a3 = e28.search(n$a);
  if (a3 < 0)
    return {};
  for (var i = e28.slice(0, a3), r3 = e28.match(n$a), t3 = 1; t3 < r3.length; ) {
    if (r3[t3])
      return {
        number: i,
        ext: r3[t3]
      };
    t3++;
  }
}
var F$7 = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "\uFF10": "0",
  "\uFF11": "1",
  "\uFF12": "2",
  "\uFF13": "3",
  "\uFF14": "4",
  "\uFF15": "5",
  "\uFF16": "6",
  "\uFF17": "7",
  "\uFF18": "8",
  "\uFF19": "9",
  "\u0660": "0",
  "\u0661": "1",
  "\u0662": "2",
  "\u0663": "3",
  "\u0664": "4",
  "\u0665": "5",
  "\u0666": "6",
  "\u0667": "7",
  "\u0668": "8",
  "\u0669": "9",
  "\u06F0": "0",
  "\u06F1": "1",
  "\u06F2": "2",
  "\u06F3": "3",
  "\u06F4": "4",
  "\u06F5": "5",
  "\u06F6": "6",
  "\u06F7": "7",
  "\u06F8": "8",
  "\u06F9": "9"
};
function r$7(u3) {
  return F$7[u3];
}
function o$5(r3, e28) {
  var t3 = typeof Symbol < "u" && r3[Symbol.iterator] || r3["@@iterator"];
  if (t3)
    return (t3 = t3.call(r3)).next.bind(t3);
  if (Array.isArray(r3) || (t3 = f$a(r3)) || e28 && r3 && typeof r3.length == "number") {
    t3 && (r3 = t3);
    var n3 = 0;
    return function() {
      return n3 >= r3.length ? { done: true } : { done: false, value: r3[n3++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function f$a(r3, e28) {
  if (r3) {
    if (typeof r3 == "string")
      return a$b(r3, e28);
    var t3 = Object.prototype.toString.call(r3).slice(8, -1);
    if (t3 === "Object" && r3.constructor && (t3 = r3.constructor.name), t3 === "Map" || t3 === "Set")
      return Array.from(r3);
    if (t3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t3))
      return a$b(r3, e28);
  }
}
function a$b(r3, e28) {
  (e28 == null || e28 > r3.length) && (e28 = r3.length);
  for (var t3 = 0, n3 = new Array(e28); t3 < e28; t3++)
    n3[t3] = r3[t3];
  return n3;
}
function p$b(r3) {
  for (var e28 = "", t3 = o$5(r3.split("")), n3; !(n3 = t3()).done; ) {
    var u3 = n3.value;
    e28 += l$c(u3, e28) || "";
  }
  return e28;
}
function l$c(r3, e28) {
  return r3 === "+" ? e28 ? void 0 : "+" : r$7(r3);
}
function l$b(r3, e28) {
  var t3 = typeof Symbol < "u" && r3[Symbol.iterator] || r3["@@iterator"];
  if (t3)
    return (t3 = t3.call(r3)).next.bind(t3);
  if (Array.isArray(r3) || (t3 = c$e(r3)) || e28 && r3 && typeof r3.length == "number") {
    t3 && (r3 = t3);
    var n3 = 0;
    return function() {
      return n3 >= r3.length ? { done: true } : { done: false, value: r3[n3++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function c$e(r3, e28) {
  if (r3) {
    if (typeof r3 == "string")
      return u$b(r3, e28);
    var t3 = Object.prototype.toString.call(r3).slice(8, -1);
    if (t3 === "Object" && r3.constructor && (t3 = r3.constructor.name), t3 === "Map" || t3 === "Set")
      return Array.from(r3);
    if (t3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t3))
      return u$b(r3, e28);
  }
}
function u$b(r3, e28) {
  (e28 == null || e28 > r3.length) && (e28 = r3.length);
  for (var t3 = 0, n3 = new Array(e28); t3 < e28; t3++)
    n3[t3] = r3[t3];
  return n3;
}
function y$e(r3, e28) {
  for (var t3 = r3.slice(), n3 = l$b(e28), a3; !(a3 = n3()).done; ) {
    var i = a3.value;
    r3.indexOf(i) < 0 && t3.push(i);
  }
  return t3.sort(function(o3, f3) {
    return o3 - f3;
  });
}
function _$6(i, r3) {
  return s$b(i, void 0, r3);
}
function s$b(i, r3, n3) {
  var I3 = n3.type(r3), e28 = I3 && I3.possibleLengths() || n3.possibleLengths();
  if (!e28)
    return "IS_POSSIBLE";
  if (r3 === "FIXED_LINE_OR_MOBILE") {
    if (!n3.type("FIXED_LINE"))
      return s$b(i, "MOBILE", n3);
    var t3 = n3.type("MOBILE");
    t3 && (e28 = y$e(e28, t3.possibleLengths()));
  } else if (r3 && !I3)
    return "INVALID_LENGTH";
  var L3 = i.length, f3 = e28[0];
  return f3 === L3 ? "IS_POSSIBLE" : f3 > L3 ? "TOO_SHORT" : e28[e28.length - 1] < L3 ? "TOO_LONG" : e28.indexOf(L3, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function u$a(e28, n3, r3) {
  if (n3 === void 0 && (n3 = {}), r3 = new C$9(r3), n3.v2) {
    if (!e28.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    r3.selectNumberingPlan(e28.countryCallingCode);
  } else {
    if (!e28.phone)
      return false;
    if (e28.country) {
      if (!r3.hasCountry(e28.country))
        throw new Error("Unknown country: ".concat(e28.country));
      r3.country(e28.country);
    } else {
      if (!e28.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      r3.selectNumberingPlan(e28.countryCallingCode);
    }
  }
  if (r3.possibleLengths())
    return s$a(e28.phone || e28.nationalNumber, r3);
  if (e28.countryCallingCode && r3.isNonGeographicCallingCode(e28.countryCallingCode))
    return true;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function s$a(e28, n3) {
  switch (_$6(e28, n3)) {
    case "IS_POSSIBLE":
      return true;
    default:
      return false;
  }
}
function r$6(e28, n3) {
  return e28 = e28 || "", new RegExp("^(?:" + n3 + ")$").test(e28);
}
function I$6(r3, n3) {
  var e28 = typeof Symbol < "u" && r3[Symbol.iterator] || r3["@@iterator"];
  if (e28)
    return (e28 = e28.call(r3)).next.bind(e28);
  if (Array.isArray(r3) || (e28 = c$d(r3)) || n3 && r3 && typeof r3.length == "number") {
    e28 && (r3 = e28);
    var t3 = 0;
    return function() {
      return t3 >= r3.length ? { done: true } : { done: false, value: r3[t3++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function c$d(r3, n3) {
  if (r3) {
    if (typeof r3 == "string")
      return f$9(r3, n3);
    var e28 = Object.prototype.toString.call(r3).slice(8, -1);
    if (e28 === "Object" && r3.constructor && (e28 = r3.constructor.name), e28 === "Map" || e28 === "Set")
      return Array.from(r3);
    if (e28 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e28))
      return f$9(r3, n3);
  }
}
function f$9(r3, n3) {
  (n3 == null || n3 > r3.length) && (n3 = r3.length);
  for (var e28 = 0, t3 = new Array(n3); e28 < n3; e28++)
    t3[e28] = r3[e28];
  return t3;
}
var s$9 = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function L$5(r3, n3, e28) {
  if (n3 = n3 || {}, !(!r3.country && !r3.countryCallingCode)) {
    e28 = new C$9(e28), e28.selectNumberingPlan(r3.country, r3.countryCallingCode);
    var t3 = n3.v2 ? r3.nationalNumber : r3.phone;
    if (r$6(t3, e28.nationalNumberPattern())) {
      if (u$9(t3, "FIXED_LINE", e28))
        return e28.type("MOBILE") && e28.type("MOBILE").pattern() === "" || !e28.type("MOBILE") || u$9(t3, "MOBILE", e28) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var E3 = I$6(s$9), i; !(i = E3()).done; ) {
        var o3 = i.value;
        if (u$9(t3, o3, e28))
          return o3;
      }
    }
  }
}
function u$9(r3, n3, e28) {
  return n3 = e28.type(n3), !n3 || !n3.pattern() || n3.possibleLengths() && n3.possibleLengths().indexOf(r3.length) < 0 ? false : r$6(r3, n3.pattern());
}
function b$8(e28, n3, r3) {
  if (n3 = n3 || {}, r3 = new C$9(r3), r3.selectNumberingPlan(e28.country, e28.countryCallingCode), r3.hasTypes())
    return L$5(e28, n3, r3.metadata) !== void 0;
  var l3 = n3.v2 ? e28.nationalNumber : e28.phone;
  return r$6(l3, r3.nationalNumberPattern());
}
function s$8(r3, t3, e28) {
  var n3 = new C$9(e28), o3 = n3.getCountryCodesForCallingCode(r3);
  return o3 ? o3.filter(function(a3) {
    return i$a(t3, a3, e28);
  }) : [];
}
function i$a(r3, t3, e28) {
  var n3 = new C$9(e28);
  return n3.selectNumberingPlan(t3), n3.numberingPlan.possibleLengths().indexOf(r3.length) >= 0;
}
function a$a(t3) {
  return t3.replace(new RegExp("[".concat(N$8, "]+"), "g"), " ").trim();
}
var l$a = /(\$\d)/;
function u$8(n3, a3, t3) {
  var r3 = t3.useInternationalFormat, i = t3.withNationalPrefix;
  t3.carrierCode, t3.metadata;
  var e28 = n3.replace(new RegExp(a3.pattern()), r3 ? a3.internationalFormat() : i && a3.nationalPrefixFormattingRule() ? a3.format().replace(l$a, a3.nationalPrefixFormattingRule()) : a3.format());
  return r3 ? a$a(e28) : e28;
}
var u$7 = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function D$8(t3, r3, a3) {
  var e28 = new C$9(a3);
  if (e28.selectNumberingPlan(t3, r3), e28.defaultIDDPrefix())
    return e28.defaultIDDPrefix();
  if (u$7.test(e28.IDDPrefix()))
    return e28.IDDPrefix();
}
function n$9(r3) {
  var t3 = r3.number, e28 = r3.ext;
  if (!t3)
    return "";
  if (t3[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t3).concat(e28 ? ";ext=" + e28 : "");
}
function d$9(r3, n3) {
  var e28 = typeof Symbol < "u" && r3[Symbol.iterator] || r3["@@iterator"];
  if (e28)
    return (e28 = e28.call(r3)).next.bind(e28);
  if (Array.isArray(r3) || (e28 = A$5(r3)) || n3 && r3 && typeof r3.length == "number") {
    e28 && (r3 = e28);
    var t3 = 0;
    return function() {
      return t3 >= r3.length ? { done: true } : { done: false, value: r3[t3++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function A$5(r3, n3) {
  if (r3) {
    if (typeof r3 == "string")
      return l$9(r3, n3);
    var e28 = Object.prototype.toString.call(r3).slice(8, -1);
    if (e28 === "Object" && r3.constructor && (e28 = r3.constructor.name), e28 === "Map" || e28 === "Set")
      return Array.from(r3);
    if (e28 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e28))
      return l$9(r3, n3);
  }
}
function l$9(r3, n3) {
  (n3 == null || n3 > r3.length) && (n3 = r3.length);
  for (var e28 = 0, t3 = new Array(n3); e28 < n3; e28++)
    t3[e28] = r3[e28];
  return t3;
}
function s$7(r3, n3) {
  var e28 = Object.keys(r3);
  if (Object.getOwnPropertySymbols) {
    var t3 = Object.getOwnPropertySymbols(r3);
    n3 && (t3 = t3.filter(function(o3) {
      return Object.getOwnPropertyDescriptor(r3, o3).enumerable;
    })), e28.push.apply(e28, t3);
  }
  return e28;
}
function y$d(r3) {
  for (var n3 = 1; n3 < arguments.length; n3++) {
    var e28 = arguments[n3] != null ? arguments[n3] : {};
    n3 % 2 ? s$7(Object(e28), true).forEach(function(t3) {
      I$5(r3, t3, e28[t3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r3, Object.getOwnPropertyDescriptors(e28)) : s$7(Object(e28)).forEach(function(t3) {
      Object.defineProperty(r3, t3, Object.getOwnPropertyDescriptor(e28, t3));
    });
  }
  return r3;
}
function I$5(r3, n3, e28) {
  return n3 in r3 ? Object.defineProperty(r3, n3, { value: e28, enumerable: true, configurable: true, writable: true }) : r3[n3] = e28, r3;
}
var m$a = {
  formatExtension: function(n3, e28, t3) {
    return "".concat(n3).concat(t3.ext()).concat(e28);
  }
};
function D$7(r3, n3, e28, t3) {
  if (e28 ? e28 = y$d(y$d({}, m$a), e28) : e28 = m$a, t3 = new C$9(t3), r3.country && r3.country !== "001") {
    if (!t3.hasCountry(r3.country))
      throw new Error("Unknown country: ".concat(r3.country));
    t3.country(r3.country);
  } else if (r3.countryCallingCode)
    t3.selectNumberingPlan(r3.countryCallingCode);
  else
    return r3.phone || "";
  var o3 = t3.countryCallingCode(), a3 = e28.v2 ? r3.nationalNumber : r3.phone, c3;
  switch (n3) {
    case "NATIONAL":
      return a3 ? (c3 = i$9(a3, r3.carrierCode, "NATIONAL", t3, e28), u$6(c3, r3.ext, t3, e28.formatExtension)) : "";
    case "INTERNATIONAL":
      return a3 ? (c3 = i$9(a3, null, "INTERNATIONAL", t3, e28), c3 = "+".concat(o3, " ").concat(c3), u$6(c3, r3.ext, t3, e28.formatExtension)) : "+".concat(o3);
    case "E.164":
      return "+".concat(o3).concat(a3);
    case "RFC3966":
      return n$9({
        number: "+".concat(o3).concat(a3),
        ext: r3.ext
      });
    case "IDD":
      if (!e28.fromCountry)
        return;
      var f3 = P$4(a3, r3.carrierCode, o3, e28.fromCountry, t3);
      return u$6(f3, r3.ext, t3, e28.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(n3, '"'));
  }
}
function i$9(r3, n3, e28, t3, o3) {
  var a3 = w$5(t3.formats(), r3);
  return a3 ? u$8(r3, a3, {
    useInternationalFormat: e28 === "INTERNATIONAL",
    withNationalPrefix: !(a3.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && o3 && o3.nationalPrefix === false),
    carrierCode: n3,
    metadata: t3
  }) : r3;
}
function w$5(r3, n3) {
  for (var e28 = d$9(r3), t3; !(t3 = e28()).done; ) {
    var o3 = t3.value;
    if (o3.leadingDigitsPatterns().length > 0) {
      var a3 = o3.leadingDigitsPatterns()[o3.leadingDigitsPatterns().length - 1];
      if (n3.search(a3) !== 0)
        continue;
    }
    if (r$6(n3, o3.pattern()))
      return o3;
  }
}
function u$6(r3, n3, e28, t3) {
  return n3 ? t3(r3, n3, e28) : r3;
}
function P$4(r3, n3, e28, t3, o3) {
  var a3 = I$8(t3, o3.metadata);
  if (a3 === e28) {
    var c3 = i$9(r3, n3, "NATIONAL", o3);
    return e28 === "1" ? e28 + " " + c3 : c3;
  }
  var f3 = D$8(t3, void 0, o3.metadata);
  if (f3)
    return "".concat(f3, " ").concat(e28, " ").concat(i$9(r3, null, "INTERNATIONAL", o3));
}
function a$9(r3, t3) {
  var e28 = Object.keys(r3);
  if (Object.getOwnPropertySymbols) {
    var n3 = Object.getOwnPropertySymbols(r3);
    t3 && (n3 = n3.filter(function(i) {
      return Object.getOwnPropertyDescriptor(r3, i).enumerable;
    })), e28.push.apply(e28, n3);
  }
  return e28;
}
function o$4(r3) {
  for (var t3 = 1; t3 < arguments.length; t3++) {
    var e28 = arguments[t3] != null ? arguments[t3] : {};
    t3 % 2 ? a$9(Object(e28), true).forEach(function(n3) {
      b$7(r3, n3, e28[n3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r3, Object.getOwnPropertyDescriptors(e28)) : a$9(Object(e28)).forEach(function(n3) {
      Object.defineProperty(r3, n3, Object.getOwnPropertyDescriptor(e28, n3));
    });
  }
  return r3;
}
function b$7(r3, t3, e28) {
  return t3 in r3 ? Object.defineProperty(r3, t3, { value: e28, enumerable: true, configurable: true, writable: true }) : r3[t3] = e28, r3;
}
function p$a(r3, t3) {
  if (!(r3 instanceof t3))
    throw new TypeError("Cannot call a class as a function");
}
function u$5(r3, t3) {
  for (var e28 = 0; e28 < t3.length; e28++) {
    var n3 = t3[e28];
    n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(r3, n3.key, n3);
  }
}
function d$8(r3, t3, e28) {
  return t3 && u$5(r3.prototype, t3), e28 && u$5(r3, e28), Object.defineProperty(r3, "prototype", { writable: false }), r3;
}
var j$2 = /* @__PURE__ */ function() {
  function r3(t3, e28, n3) {
    if (p$a(this, r3), !t3)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!e28)
      throw new TypeError("`nationalNumber` not passed");
    if (!n3)
      throw new TypeError("`metadata` not passed");
    var i = C$8(t3, n3), s3 = i.country, f3 = i.countryCallingCode;
    this.country = s3, this.countryCallingCode = f3, this.nationalNumber = e28, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return n3;
    };
  }
  return d$8(r3, [{
    key: "setExt",
    value: function(e28) {
      this.ext = e28;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : s$8(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return u$a(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return b$8(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var e28 = new C$9(this.getMetadata());
      return e28.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(e28) {
      return this.number === e28.number && this.ext === e28.ext;
    }
  }, {
    key: "getType",
    value: function() {
      return L$5(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(e28, n3) {
      return D$7(this, e28, n3 ? o$4(o$4({}, n3), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(e28) {
      return this.format("NATIONAL", e28);
    }
  }, {
    key: "formatInternational",
    value: function(e28) {
      return this.format("INTERNATIONAL", e28);
    }
  }, {
    key: "getURI",
    value: function(e28) {
      return this.format("RFC3966", e28);
    }
  }]), r3;
}(), v$6 = function(t3) {
  return /^[A-Z]{2}$/.test(t3);
};
function C$8(r3, t3) {
  var e28, n3, i = new C$9(t3);
  return v$6(r3) ? (e28 = r3, i.selectNumberingPlan(e28), n3 = i.countryCallingCode()) : n3 = r3, {
    country: e28,
    countryCallingCode: n3
  };
}
var c$c = new RegExp("([" + _$8 + "])");
function D$6(t3, r3, f3, n3) {
  if (r3) {
    var a3 = new C$9(n3);
    a3.selectNumberingPlan(r3, f3);
    var i = new RegExp(a3.IDDPrefix());
    if (t3.search(i) === 0) {
      t3 = t3.slice(t3.match(i)[0].length);
      var e28 = t3.match(c$c);
      if (!(e28 && e28[1] != null && e28[1].length > 0 && e28[1] === "0"))
        return t3;
    }
  }
}
function F$6(l3, i) {
  if (l3 && i.numberingPlan.nationalPrefixForParsing()) {
    var g3 = new RegExp("^(?:" + i.numberingPlan.nationalPrefixForParsing() + ")"), n3 = g3.exec(l3);
    if (n3) {
      var r3, P3, v3 = n3.length - 1, e28 = v3 > 0 && n3[v3];
      if (i.nationalPrefixTransformRule() && e28)
        r3 = l3.replace(g3, i.nationalPrefixTransformRule()), v3 > 1 && (P3 = n3[1]);
      else {
        var o3 = n3[0];
        r3 = l3.slice(o3.length), e28 && (P3 = n3[1]);
      }
      var f3;
      if (e28) {
        var s3 = l3.indexOf(n3[1]), a3 = l3.slice(0, s3);
        a3 === i.numberingPlan.nationalPrefix() && (f3 = i.numberingPlan.nationalPrefix());
      } else
        f3 = n3[0];
      return {
        nationalNumber: r3,
        nationalPrefix: f3,
        carrierCode: P3
      };
    }
  }
  return {
    nationalNumber: l3
  };
}
function m$9(r3, e28) {
  var t3 = F$6(r3, e28), o3 = t3.carrierCode, n3 = t3.nationalNumber;
  if (n3 !== r3) {
    if (!l$8(r3, n3, e28))
      return {
        nationalNumber: r3
      };
    if (e28.possibleLengths() && !N$7(n3, e28))
      return {
        nationalNumber: r3
      };
  }
  return {
    nationalNumber: n3,
    carrierCode: o3
  };
}
function l$8(r3, e28, t3) {
  return !(r$6(r3, t3.nationalNumberPattern()) && !r$6(e28, t3.nationalNumberPattern()));
}
function N$7(r3, e28) {
  switch (_$6(r3, e28)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return false;
    default:
      return true;
  }
}
function x$8(n3, i, e28, r3) {
  var o3 = i ? I$8(i, r3) : e28;
  if (n3.indexOf(o3) === 0) {
    r3 = new C$9(r3), r3.selectNumberingPlan(i, e28);
    var t3 = n3.slice(o3.length), C3 = m$9(t3, r3), g3 = C3.nationalNumber, N3 = m$9(n3, r3), l3 = N3.nationalNumber;
    if (!r$6(l3, r3.nationalNumberPattern()) && r$6(g3, r3.nationalNumberPattern()) || _$6(l3, r3) === "TOO_LONG")
      return {
        countryCallingCode: o3,
        number: t3
      };
  }
  return {
    number: n3
  };
}
function p$9(r3, o3, f3, i) {
  if (!r3)
    return {};
  var n3;
  if (r3[0] !== "+") {
    var l3 = D$6(r3, o3, f3, i);
    if (l3 && l3 !== r3)
      n3 = true, r3 = "+" + l3;
    else {
      if (o3 || f3) {
        var _3 = x$8(r3, o3, f3, i), C3 = _3.countryCallingCode, N3 = _3.number;
        if (C3)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: C3,
            number: N3
          };
      }
      return {
        number: r3
      };
    }
  }
  if (r3[1] === "0")
    return {};
  i = new C$9(i);
  for (var e28 = 2; e28 - 1 <= E$7 && e28 <= r3.length; ) {
    var t3 = r3.slice(1, e28);
    if (i.hasCallingCode(t3))
      return i.selectNumberingPlan(t3), {
        countryCallingCodeSource: n3 ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: t3,
        number: r3.slice(e28)
      };
    e28++;
  }
  return {};
}
function m$8(t3, e28) {
  var r3 = typeof Symbol < "u" && t3[Symbol.iterator] || t3["@@iterator"];
  if (r3)
    return (r3 = r3.call(t3)).next.bind(r3);
  if (Array.isArray(t3) || (r3 = y$c(t3)) || e28 && t3 && typeof t3.length == "number") {
    r3 && (t3 = r3);
    var a3 = 0;
    return function() {
      return a3 >= t3.length ? { done: true } : { done: false, value: t3[a3++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function y$c(t3, e28) {
  if (t3) {
    if (typeof t3 == "string")
      return o$3(t3, e28);
    var r3 = Object.prototype.toString.call(t3).slice(8, -1);
    if (r3 === "Object" && t3.constructor && (r3 = t3.constructor.name), r3 === "Map" || r3 === "Set")
      return Array.from(t3);
    if (r3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r3))
      return o$3(t3, e28);
  }
}
function o$3(t3, e28) {
  (e28 == null || e28 > t3.length) && (e28 = t3.length);
  for (var r3 = 0, a3 = new Array(e28); r3 < e28; r3++)
    a3[r3] = t3[r3];
  return a3;
}
function g$a(t3, e28) {
  var r3 = e28.countries, a3 = e28.defaultCountry, i = e28.metadata;
  i = new C$9(i);
  for (var u3 = [], l3 = m$8(r3), f3; !(f3 = l3()).done; ) {
    var n3 = f3.value;
    if (i.country(n3), i.leadingDigits()) {
      if (t3 && t3.search(i.leadingDigits()) === 0)
        return n3;
    } else if (L$5({
      phone: t3,
      country: n3
    }, void 0, i.metadata))
      if (a3) {
        if (n3 === a3)
          return n3;
        u3.push(n3);
      } else
        return n3;
  }
  if (u3.length > 0)
    return u3[0];
}
function l$7(r3, a3) {
  var n3 = a3.nationalNumber, o3 = a3.defaultCountry, e28 = a3.metadata;
  var t3 = e28.getCountryCodesForCallingCode(r3);
  if (t3)
    return t3.length === 1 ? t3[0] : g$a(n3, {
      countries: t3,
      defaultCountry: o3,
      metadata: e28.metadata
    });
}
var v$5 = "+", I$4 = "[\\-\\.\\(\\)]?", R$4 = "([" + _$8 + "]|" + I$4 + ")", i$8 = "^\\" + v$5 + R$4 + "*[" + _$8 + "]" + R$4 + "*$", N$6 = new RegExp(i$8, "g"), r$5 = _$8, C$7 = "[" + r$5 + "]+((\\-)*[" + r$5 + "])*", L$4 = "a-zA-Z", f$8 = "[" + L$4 + "]+((\\-)*[" + r$5 + "])*", E$6 = "^(" + C$7 + "\\.)*" + f$8 + "\\.?$", O$7 = new RegExp(E$6, "g"), l$6 = "tel:", a$8 = ";phone-context=", u$4 = ";isub=";
function D$5(_3) {
  var t3 = _3.indexOf(a$8);
  if (t3 < 0)
    return null;
  var e28 = t3 + a$8.length;
  if (e28 >= _3.length)
    return "";
  var A3 = _3.indexOf(";", e28);
  return A3 >= 0 ? _3.substring(e28, A3) : _3.substring(e28);
}
function S$6(_3) {
  return _3 === null ? true : _3.length === 0 ? false : N$6.test(_3) || O$7.test(_3);
}
function S$5(r3, _3) {
  var f3 = _3.extractFormattedPhoneNumber, e28 = D$5(r3);
  if (!S$6(e28))
    throw new S$7("NOT_A_NUMBER");
  var t3;
  if (e28 === null)
    t3 = f3(r3) || "";
  else {
    t3 = "", e28.charAt(0) === v$5 && (t3 += e28);
    var n3 = r3.indexOf(l$6), o3;
    n3 >= 0 ? o3 = n3 + l$6.length : o3 = 0;
    var h3 = r3.indexOf(a$8);
    t3 += r3.substring(o3, h3);
  }
  var i = t3.indexOf(u$4);
  if (i > 0 && (t3 = t3.substring(0, i)), t3 !== "")
    return t3;
}
var H$3 = 250, L$3 = new RegExp("[" + T$6 + _$8 + "]"), U$2 = new RegExp("[^" + _$8 + "#]+$");
function Z$4(t3, r3, n3) {
  if (r3 = r3 || {}, n3 = new C$9(n3), r3.defaultCountry && !n3.hasCountry(r3.defaultCountry))
    throw r3.v2 ? new S$7("INVALID_COUNTRY") : new Error("Unknown country: ".concat(r3.defaultCountry));
  var e28 = G$5(t3, r3.v2, r3.extract), l3 = e28.number, c3 = e28.ext, u3 = e28.error;
  if (!l3) {
    if (r3.v2)
      throw u3 === "TOO_SHORT" ? new S$7("TOO_SHORT") : new S$7("NOT_A_NUMBER");
    return {};
  }
  var a3 = D$4(l3, r3.defaultCountry, r3.defaultCallingCode, n3), i = a3.country, o3 = a3.nationalNumber, N3 = a3.countryCallingCode, _3 = a3.countryCallingCodeSource, f3 = a3.carrierCode;
  if (!n3.hasSelectedNumberingPlan()) {
    if (r3.v2)
      throw new S$7("INVALID_COUNTRY");
    return {};
  }
  if (!o3 || o3.length < v$8) {
    if (r3.v2)
      throw new S$7("TOO_SHORT");
    return {};
  }
  if (o3.length > A$7) {
    if (r3.v2)
      throw new S$7("TOO_LONG");
    return {};
  }
  if (r3.v2) {
    var C3 = new j$2(N3, o3, n3.metadata);
    return i && (C3.country = i), f3 && (C3.carrierCode = f3), c3 && (C3.ext = c3), C3.__countryCallingCodeSource = _3, C3;
  }
  var b3 = (r3.extended ? n3.hasSelectedNumberingPlan() : i) ? r$6(o3, n3.nationalNumberPattern()) : false;
  return r3.extended ? {
    country: i,
    countryCallingCode: N3,
    carrierCode: f3,
    valid: b3,
    possible: b3 ? true : !!(r3.extended === true && n3.possibleLengths() && s$a(o3, n3)),
    phone: o3,
    ext: c3
  } : b3 ? M$3(i, o3, c3) : {};
}
function F$5(t3, r3, n3) {
  if (t3) {
    if (t3.length > H$3) {
      if (n3)
        throw new S$7("TOO_LONG");
      return;
    }
    if (r3 === false)
      return t3;
    var e28 = t3.search(L$3);
    if (!(e28 < 0))
      return t3.slice(e28).replace(U$2, "");
  }
}
function G$5(t3, r3, n3) {
  var e28 = S$5(t3, {
    extractFormattedPhoneNumber: function(u3) {
      return F$5(u3, n3, r3);
    }
  });
  if (!e28)
    return {};
  if (!A$6(e28))
    return o$6(e28) ? {
      error: "TOO_SHORT"
    } : {};
  var l3 = c$f(e28);
  return l3.ext ? l3 : {
    number: e28
  };
}
function M$3(t3, r3, n3) {
  var e28 = {
    country: t3,
    phone: r3
  };
  return n3 && (e28.ext = n3), e28;
}
function D$4(t3, r3, n3, e28) {
  var l3 = p$9(p$b(t3), r3, n3, e28.metadata), c3 = l3.countryCallingCodeSource, u3 = l3.countryCallingCode, a3 = l3.number, i;
  if (u3)
    e28.selectNumberingPlan(u3);
  else if (a3 && (r3 || n3))
    e28.selectNumberingPlan(r3, n3), r3 && (i = r3), u3 = n3 || I$8(r3, e28.metadata);
  else
    return {};
  if (!a3)
    return {
      countryCallingCodeSource: c3,
      countryCallingCode: u3
    };
  var o3 = m$9(p$b(a3), e28), N3 = o3.nationalNumber, _3 = o3.carrierCode, f3 = l$7(u3, {
    nationalNumber: N3,
    defaultCountry: r3,
    metadata: e28
  });
  return f3 && (i = f3, f3 === "001" || e28.country(i)), {
    country: i,
    countryCallingCode: u3,
    countryCallingCodeSource: c3,
    nationalNumber: N3,
    carrierCode: _3
  };
}
function o$2(e28, t3) {
  var r3 = Object.keys(e28);
  if (Object.getOwnPropertySymbols) {
    var n3 = Object.getOwnPropertySymbols(e28);
    t3 && (n3 = n3.filter(function(u3) {
      return Object.getOwnPropertyDescriptor(e28, u3).enumerable;
    })), r3.push.apply(r3, n3);
  }
  return r3;
}
function p$8(e28) {
  for (var t3 = 1; t3 < arguments.length; t3++) {
    var r3 = arguments[t3] != null ? arguments[t3] : {};
    t3 % 2 ? o$2(Object(r3), true).forEach(function(n3) {
      f$7(e28, n3, r3[n3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e28, Object.getOwnPropertyDescriptors(r3)) : o$2(Object(r3)).forEach(function(n3) {
      Object.defineProperty(e28, n3, Object.getOwnPropertyDescriptor(r3, n3));
    });
  }
  return e28;
}
function f$7(e28, t3, r3) {
  return t3 in e28 ? Object.defineProperty(e28, t3, { value: r3, enumerable: true, configurable: true, writable: true }) : e28[t3] = r3, e28;
}
function O$6(e28, t3, r3) {
  return Z$4(e28, p$8(p$8({}, t3), {}, {
    v2: true
  }), r3);
}
function c$b(r3, e28) {
  var t3 = Object.keys(r3);
  if (Object.getOwnPropertySymbols) {
    var n3 = Object.getOwnPropertySymbols(r3);
    e28 && (n3 = n3.filter(function(a3) {
      return Object.getOwnPropertyDescriptor(r3, a3).enumerable;
    })), t3.push.apply(t3, n3);
  }
  return t3;
}
function y$b(r3) {
  for (var e28 = 1; e28 < arguments.length; e28++) {
    var t3 = arguments[e28] != null ? arguments[e28] : {};
    e28 % 2 ? c$b(Object(t3), true).forEach(function(n3) {
      b$6(r3, n3, t3[n3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r3, Object.getOwnPropertyDescriptors(t3)) : c$b(Object(t3)).forEach(function(n3) {
      Object.defineProperty(r3, n3, Object.getOwnPropertyDescriptor(t3, n3));
    });
  }
  return r3;
}
function b$6(r3, e28, t3) {
  return e28 in r3 ? Object.defineProperty(r3, e28, { value: t3, enumerable: true, configurable: true, writable: true }) : r3[e28] = t3, r3;
}
function d$7(r3, e28) {
  return _$5(r3) || O$5(r3, e28) || m$7(r3, e28) || g$9();
}
function g$9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function m$7(r3, e28) {
  if (r3) {
    if (typeof r3 == "string")
      return s$6(r3, e28);
    var t3 = Object.prototype.toString.call(r3).slice(8, -1);
    if (t3 === "Object" && r3.constructor && (t3 = r3.constructor.name), t3 === "Map" || t3 === "Set")
      return Array.from(r3);
    if (t3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t3))
      return s$6(r3, e28);
  }
}
function s$6(r3, e28) {
  (e28 == null || e28 > r3.length) && (e28 = r3.length);
  for (var t3 = 0, n3 = new Array(e28); t3 < e28; t3++)
    n3[t3] = r3[t3];
  return n3;
}
function O$5(r3, e28) {
  var t3 = r3 == null ? null : typeof Symbol < "u" && r3[Symbol.iterator] || r3["@@iterator"];
  if (t3 != null) {
    var n3 = [], a3 = true, i = false, u3, f3;
    try {
      for (t3 = t3.call(r3); !(a3 = (u3 = t3.next()).done) && (n3.push(u3.value), !(e28 && n3.length === e28)); a3 = true)
        ;
    } catch (o3) {
      i = true, f3 = o3;
    } finally {
      try {
        !a3 && t3.return != null && t3.return();
      } finally {
        if (i)
          throw f3;
      }
    }
    return n3;
  }
}
function _$5(r3) {
  if (Array.isArray(r3))
    return r3;
}
function h$9(r3) {
  var e28 = Array.prototype.slice.call(r3), t3 = d$7(e28, 4), n3 = t3[0], a3 = t3[1], i = t3[2], u3 = t3[3], f3, o3, l3;
  if (typeof n3 == "string")
    f3 = n3;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!a3 || typeof a3 == "string")
    u3 ? (o3 = i, l3 = u3) : (o3 = void 0, l3 = i), a3 && (o3 = y$b({
      defaultCountry: a3
    }, o3));
  else if (n$c(a3))
    i ? (o3 = a3, l3 = i) : l3 = a3;
  else
    throw new Error("Invalid second argument: ".concat(a3));
  return {
    text: f3,
    options: o3,
    metadata: l3
  };
}
function s$5() {
  var r3 = h$9(arguments), t3 = r3.text, e28 = r3.options, o3 = r3.metadata;
  return O$6(t3, e28, o3);
}
function m$6() {
  return o$8(s$5, arguments);
}
const B$8 = { class: "button-container" }, C$6 = defineComponent({
  name: "UIInputPhone",
  inheritAttrs: false
}), E$5 = defineComponent(__spreadProps(__spreadValues({}, C$6), {
  props: {
    id: String,
    countryCode: String,
    disabled: Boolean,
    value: String
  },
  emits: [
    "internationalFormat",
    "isValid",
    "nationalFormat",
    "update:countryCode",
    "update:value"
  ],
  setup(c3, { emit: b3 }) {
    const r3 = c3, l3 = b3, a3 = function() {
      return r3.countryCode ? ref$1(lp.filter((e28) => e28.code === r3.countryCode)[0]) : ref$1(lp.filter((e28) => e28.code === "US")[0]);
    }();
    onMounted(() => {
      d3(r3.value, a3.value.code);
    }), watch(() => r3.value, (e28) => {
      d3(e28, a3.value.code);
    });
    function F3(e28) {
      d3(e28, a3.value.code);
    }
    function N3(e28) {
      const [t3, o3] = e28.split("--");
      a3.value = lp.filter((n3) => n3.code === t3 && n3.name === o3)[0], d3(r3.value, t3);
    }
    function u3({
      countryCode: e28,
      internationalFormat: t3,
      isPhoneNumberValid: o3,
      nationalFormat: n3,
      phoneNumber: g3
    }) {
      l3("update:countryCode", e28), l3("internationalFormat", t3), l3("isValid", o3), l3("nationalFormat", n3), l3("update:value", g3);
    }
    function d3(e28, t3) {
      try {
        const o3 = m$6(e28, t3), n3 = o3.isValid() && o3.country === t3;
        if (n3)
          return u3({
            countryCode: t3,
            internationalFormat: o3.formatInternational(),
            isPhoneNumberValid: n3,
            nationalFormat: o3.formatNational(),
            phoneNumber: o3.formatNational()
          });
        u3({
          countryCode: t3,
          internationalFormat: "",
          isPhoneNumberValid: n3,
          nationalFormat: "",
          phoneNumber: e28
        });
      } catch {
        u3({
          countryCode: t3,
          internationalFormat: "",
          isPhoneNumberValid: false,
          nationalFormat: "",
          phoneNumber: e28
        });
      }
    }
    const I3 = lp.map((e28) => ({
      label: `${e28.name} ${e28.phoneCode}`,
      value: `${e28.code}--${e28.name}`,
      icon: () => h$1R(e28.icon),
      placeholder: e28.placeholder
    }));
    return (e28, t3) => (openBlock(), createBlock(P$O, {
      modelValue: c3.value,
      id: c3.id,
      class: "phone-input-container",
      placeholder: unref(a3).placeholder,
      disabled: c3.disabled,
      "onUpdate:modelValue": F3
    }, {
      prefix: withCtx(() => [
        createVNode(unref(Ce$2), {
          options: unref(I3),
          onOnSelect: N3
        }, {
          trigger: withCtx(() => [
            createElementVNode("div", B$8, [
              unref(a3) ? (openBlock(), createBlock(resolveDynamicComponent(unref(a3).icon), { key: 0 })) : createCommentVNode("", true),
              createVNode(unref(c$E), { class: "w-5 h-5" })
            ])
          ]),
          _: 1
        }, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "id", "placeholder", "disabled"]));
  }
})), G$4 = E$5;
const i$7 = n$28("n-loading-bar"), a$7 = n$28("n-loading-bar-api");
function d$6() {
  const o3 = inject(a$7, null);
  return o3 === null && t$1P("use-loading-bar", "No outer <n-loading-bar-provider /> founded."), o3;
}
const g$8 = defineComponent({
  setup() {
    const o3 = d$6();
    return {
      startLoading: () => {
        o3.start();
      },
      finishLoading: () => {
        o3.finish();
      },
      errorLoading: () => {
        o3.error();
      }
    };
  }
});
const t$7 = l$25("loading-bar-container", `
 z-index: 5999;
 position: fixed;
 top: 0;
 left: 0;
 right: 0;
 height: 2px;
`, [l$1T({
  enterDuration: "0.3s",
  leaveDuration: "0.8s"
}), l$25("loading-bar", `
 width: 100%;
 transition:
 max-width 4s linear,
 background .2s linear;
 height: var(--n-height);
 `, [g$1j("starting", `
 background: var(--n-color-loading);
 `), g$1j("finishing", `
 background: var(--n-color-loading);
 transition:
 max-width .2s linear,
 background .2s linear;
 `), g$1j("error", `
 background: var(--n-color-error);
 transition:
 max-width .2s linear,
 background .2s linear;
 `)])]);
const a$6 = (o3) => {
  const {
    primaryColor: r3,
    errorColor: n3
  } = o3;
  return {
    colorError: n3,
    colorLoading: r3,
    height: "2px"
  };
}, i$6 = {
  name: "LoadingBar",
  common: d$1T,
  self: a$6
}, g$7 = i$6;
var g$6 = globalThis && globalThis.__awaiter || function(o3, n3, i, r3) {
  function u3(s3) {
    return s3 instanceof i ? s3 : new i(function(t3) {
      t3(s3);
    });
  }
  return new (i || (i = Promise))(function(s3, t3) {
    function m3(l3) {
      try {
        a3(r3.next(l3));
      } catch (c3) {
        t3(c3);
      }
    }
    function d3(l3) {
      try {
        a3(r3.throw(l3));
      } catch (c3) {
        t3(c3);
      }
    }
    function a3(l3) {
      l3.done ? s3(l3.value) : u3(l3.value).then(m3, d3);
    }
    a3((r3 = r3.apply(o3, n3 || [])).next());
  });
};
function p$7(o3, n3) {
  return `${n3}-loading-bar ${n3}-loading-bar--${o3}`;
}
const Q$2 = defineComponent({
  name: "LoadingBar",
  props: {
    containerClass: String,
    containerStyle: [String, Object]
  },
  setup() {
    const {
      inlineThemeDisabled: o3
    } = a$2x(), {
      props: n3,
      mergedClsPrefixRef: i
    } = inject(i$7), r3 = ref$1(null), u3 = ref$1(false), s3 = ref$1(false), t3 = ref$1(false), m3 = ref$1(false);
    let d3 = false;
    const a3 = ref$1(false), l3 = computed(() => {
      const {
        loadingBarStyle: e28
      } = n3;
      return e28 ? e28[a3.value ? "error" : "loading"] : "";
    });
    function c3() {
      return g$6(this, void 0, void 0, function* () {
        u3.value = false, t3.value = false, d3 = false, a3.value = false, m3.value = true, yield nextTick(), m3.value = false;
      });
    }
    function x3(e28 = 0, y3 = 80, b3 = "starting") {
      return g$6(this, void 0, void 0, function* () {
        if (s3.value = true, yield c3(), d3)
          return;
        t3.value = true, yield nextTick();
        const f3 = r3.value;
        f3 && (f3.style.maxWidth = `${e28}%`, f3.style.transition = "none", f3.offsetWidth, f3.className = p$7(b3, i.value), f3.style.transition = "", f3.style.maxWidth = `${y3}%`);
      });
    }
    function S3() {
      return g$6(this, void 0, void 0, function* () {
        if (d3 || a3.value)
          return;
        s3.value && (yield nextTick()), d3 = true;
        const e28 = r3.value;
        e28 && (e28.className = p$7("finishing", i.value), e28.style.maxWidth = "100%", e28.offsetWidth, t3.value = false);
      });
    }
    function W3() {
      if (!(d3 || a3.value))
        if (!t3.value)
          x3(100, 100, "error").then(() => {
            a3.value = true;
            const e28 = r3.value;
            e28 && (e28.className = p$7("error", i.value), e28.offsetWidth, t3.value = false);
          });
        else {
          a3.value = true;
          const e28 = r3.value;
          if (!e28)
            return;
          e28.className = p$7("error", i.value), e28.style.maxWidth = "100%", e28.offsetWidth, t3.value = false;
        }
    }
    function w3() {
      u3.value = true;
    }
    function E3() {
      u3.value = false;
    }
    function T3() {
      return g$6(this, void 0, void 0, function* () {
        yield c3();
      });
    }
    const $3 = _$F("LoadingBar", "-loading-bar", t$7, g$7, n3, i), B3 = computed(() => {
      const {
        self: {
          height: e28,
          colorError: y3,
          colorLoading: b3
        }
      } = $3.value;
      return {
        "--n-height": e28,
        "--n-color-loading": b3,
        "--n-color-error": y3
      };
    }), h3 = o3 ? E$J("loading-bar", void 0, B3, n3) : void 0;
    return {
      mergedClsPrefix: i,
      loadingBarRef: r3,
      started: s3,
      loading: t3,
      entering: u3,
      transitionDisabled: m3,
      start: x3,
      error: W3,
      finish: S3,
      handleEnter: w3,
      handleAfterEnter: E3,
      handleAfterLeave: T3,
      mergedLoadingBarStyle: l3,
      cssVars: o3 ? void 0 : B3,
      themeClass: h3 == null ? void 0 : h3.themeClass,
      onRender: h3 == null ? void 0 : h3.onRender
    };
  },
  render() {
    if (!this.started)
      return null;
    const {
      mergedClsPrefix: o3
    } = this;
    return h$1R(Transition, {
      name: "fade-in-transition",
      appear: true,
      onEnter: this.handleEnter,
      onAfterEnter: this.handleAfterEnter,
      onAfterLeave: this.handleAfterLeave,
      css: !this.transitionDisabled
    }, {
      default: () => {
        var n3;
        return (n3 = this.onRender) === null || n3 === void 0 || n3.call(this), withDirectives(h$1R("div", {
          class: [`${o3}-loading-bar-container`, this.themeClass, this.containerClass],
          style: this.containerStyle
        }, h$1R("div", {
          ref: "loadingBarRef",
          class: [`${o3}-loading-bar`],
          style: [this.cssVars, this.mergedLoadingBarStyle]
        })), [[vShow, this.loading || !this.loading && this.entering]]);
      }
    });
  }
});
const y$a = Object.assign(Object.assign({}, _$F.props), {
  to: {
    type: [String, Object, Boolean],
    default: void 0
  },
  containerClass: String,
  containerStyle: [String, Object],
  loadingBarStyle: {
    type: Object
  }
}), R$3 = defineComponent({
  name: "LoadingBarProvider",
  props: y$a,
  setup(a3) {
    const i = u$1C(), r3 = ref$1(null), l3 = {
      start() {
        var e28;
        i.value ? (e28 = r3.value) === null || e28 === void 0 || e28.start() : nextTick(() => {
          var o3;
          (o3 = r3.value) === null || o3 === void 0 || o3.start();
        });
      },
      error() {
        var e28;
        i.value ? (e28 = r3.value) === null || e28 === void 0 || e28.error() : nextTick(() => {
          var o3;
          (o3 = r3.value) === null || o3 === void 0 || o3.error();
        });
      },
      finish() {
        var e28;
        i.value ? (e28 = r3.value) === null || e28 === void 0 || e28.finish() : nextTick(() => {
          var o3;
          (o3 = r3.value) === null || o3 === void 0 || o3.finish();
        });
      }
    }, {
      mergedClsPrefixRef: d3
    } = a$2x(a3);
    return provide(a$7, l3), provide(i$7, {
      props: a3,
      mergedClsPrefixRef: d3
    }), Object.assign(l3, {
      loadingBarRef: r3
    });
  },
  render() {
    var a3, i;
    return h$1R(Fragment, null, h$1R(Teleport, {
      disabled: this.to === false,
      to: this.to || "body"
    }, h$1R(Q$2, {
      ref: "loadingBarRef",
      containerStyle: this.containerStyle,
      containerClass: this.containerClass
    })), (i = (a3 = this.$slots).default) === null || i === void 0 ? void 0 : i.call(a3));
  }
});
const B$7 = defineComponent({
  name: "UILoadingBar"
}), y$9 = defineComponent(__spreadProps(__spreadValues({}, B$7), {
  props: {
    containerClass: {
      type: String,
      default: void 0
    },
    containerStyle: {
      type: [String, Object],
      default: void 0
    },
    loadingBarStyle: {
      type: Object,
      default: void 0
    },
    to: {
      type: [String, HTMLElement, void 0],
      default: void 0
    }
  },
  setup(t3, { expose: n3 }) {
    const a3 = ref$1();
    return n3({
      startLoadBar: () => {
        var e28;
        (e28 = a3.value) == null || e28.startLoading();
      },
      stopLoadBar: () => {
        var e28;
        (e28 = a3.value) == null || e28.finishLoading();
      },
      errorLoadBar: () => {
        var e28;
        (e28 = a3.value) == null || e28.errorLoading();
      }
    }), (e28, v3) => (openBlock(), createBlock(unref(R$3), {
      "container-class": t3.containerClass,
      "container-style": t3.containerStyle,
      to: t3.to,
      "loading-bar-style": t3.loadingBarStyle
    }, {
      default: withCtx(() => [
        renderSlot(e28.$slots, "default"),
        createVNode(unref(g$8), {
          ref_key: "loadingTriggerRef",
          ref: a3
        }, null, 512)
      ]),
      _: 3
    }, 8, ["container-class", "container-style", "to", "loading-bar-style"]));
  }
})), T$4 = y$9;
const t$6 = n$28("n-layout-sider");
const o$1 = n$28("n-menu"), t$5 = n$28("n-submenu"), m$5 = n$28("n-menu-item-group");
const a$5 = 8;
function y$8(u3) {
  const v3 = inject(o$1), {
    props: n3,
    mergedCollapsedRef: l3
  } = v3, d3 = inject(t$5, null), f3 = inject(m$5, null), r3 = computed(() => n3.mode === "horizontal"), R3 = computed(() => r3.value ? n3.dropdownPlacement : "tmNodes" in u3 ? "right-start" : "right"), s3 = computed(() => {
    var e28;
    return Math.max((e28 = n3.collapsedIconSize) !== null && e28 !== void 0 ? e28 : n3.iconSize, n3.iconSize);
  }), g3 = computed(() => {
    var e28;
    return !r3.value && u3.root && l3.value && (e28 = n3.collapsedIconSize) !== null && e28 !== void 0 ? e28 : n3.iconSize;
  }), z3 = computed(() => {
    if (r3.value || r3.value)
      return;
    const {
      collapsedWidth: e28,
      indent: t3,
      rootIndent: i
    } = n3, {
      root: c3,
      isGroup: m3
    } = u3, I3 = i === void 0 ? t3 : i;
    return c3 ? l3.value ? e28 / 2 - s3.value / 2 : I3 : f3 && typeof f3.paddingLeftRef.value == "number" ? t3 / 2 + f3.paddingLeftRef.value : d3 && typeof d3.paddingLeftRef.value == "number" ? (m3 ? t3 / 2 : t3) + d3.paddingLeftRef.value : 0;
  }), S3 = computed(() => {
    const {
      collapsedWidth: e28,
      indent: t3,
      rootIndent: i
    } = n3, {
      value: c3
    } = s3, {
      root: m3
    } = u3;
    return r3.value || !m3 || !l3.value ? a$5 : (i === void 0 ? t3 : i) + c3 + a$5 - (e28 + c3) / 2;
  });
  return {
    dropdownPlacement: R3,
    activeIconSize: g3,
    maxIconSize: s3,
    paddingLeft: z3,
    iconMarginRight: S3,
    NMenu: v3,
    NSubmenu: d3
  };
}
const e$1 = {
  internalKey: {
    type: [String, Number],
    required: true
  },
  root: Boolean,
  isGroup: Boolean,
  level: {
    type: Number,
    required: true
  },
  title: [String, Function],
  extra: [String, Function]
};
const N$5 = Object.assign(Object.assign({}, e$1), {
  tmNode: {
    type: Object,
    required: true
  },
  tmNodes: {
    type: Array,
    required: true
  }
}), G$3 = defineComponent({
  name: "MenuOptionGroup",
  props: N$5,
  setup(t3) {
    provide(t$5, null);
    const r3 = y$8(t3);
    provide(m$5, {
      paddingLeftRef: r3.paddingLeft
    });
    const {
      mergedClsPrefixRef: l3,
      props: i
    } = inject(o$1);
    return function() {
      const {
        value: u3
      } = l3, d3 = r3.paddingLeft.value, {
        nodeProps: o3
      } = i, e28 = o3 == null ? void 0 : o3(t3.tmNode.rawNode);
      return h$1R("div", {
        class: `${u3}-menu-item-group`,
        role: "group"
      }, h$1R("div", Object.assign({}, e28, {
        class: [`${u3}-menu-item-group-title`, e28 == null ? void 0 : e28.class],
        style: [(e28 == null ? void 0 : e28.style) || "", d3 !== void 0 ? `padding-left: ${d3}px;` : ""]
      }), o$1c(t3.title), t3.extra ? h$1R(Fragment, null, " ", o$1c(t3.extra)) : null), h$1R("div", null, t3.tmNodes.map((p3) => F$4(p3, i))));
    };
  }
});
const r$4 = defineComponent({
  name: "ChevronDownFilled",
  render() {
    return h$1R("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, h$1R("path", {
      d: "M3.20041 5.73966C3.48226 5.43613 3.95681 5.41856 4.26034 5.70041L8 9.22652L11.7397 5.70041C12.0432 5.41856 12.5177 5.43613 12.7996 5.73966C13.0815 6.0432 13.0639 6.51775 12.7603 6.7996L8.51034 10.7996C8.22258 11.0668 7.77743 11.0668 7.48967 10.7996L3.23966 6.7996C2.93613 6.51775 2.91856 6.0432 3.20041 5.73966Z",
      fill: "currentColor"
    }));
  }
});
const w$4 = defineComponent({
  name: "MenuOptionContent",
  props: {
    collapsed: Boolean,
    disabled: Boolean,
    title: [String, Function],
    icon: Function,
    extra: [String, Function],
    showArrow: Boolean,
    childActive: Boolean,
    hover: Boolean,
    paddingLeft: Number,
    selected: Boolean,
    maxIconSize: {
      type: Number,
      required: true
    },
    activeIconSize: {
      type: Number,
      required: true
    },
    iconMarginRight: {
      type: Number,
      required: true
    },
    clsPrefix: {
      type: String,
      required: true
    },
    onClick: Function,
    tmNode: {
      type: Object,
      required: true
    },
    isEllipsisPlaceholder: Boolean
  },
  setup(e28) {
    const {
      props: n3
    } = inject(o$1);
    return {
      menuProps: n3,
      style: computed(() => {
        const {
          paddingLeft: t3
        } = e28;
        return {
          paddingLeft: t3 && `${t3}px`
        };
      }),
      iconStyle: computed(() => {
        const {
          maxIconSize: t3,
          activeIconSize: r3,
          iconMarginRight: o3
        } = e28;
        return {
          width: `${t3}px`,
          height: `${t3}px`,
          fontSize: `${r3}px`,
          marginRight: `${o3}px`
        };
      })
    };
  },
  render() {
    const {
      clsPrefix: e28,
      tmNode: n3,
      menuProps: {
        renderIcon: t3,
        renderLabel: r3,
        renderExtra: o3,
        expandIcon: s3
      }
    } = this, a3 = t3 ? t3(n3.rawNode) : o$1c(this.icon);
    return h$1R("div", {
      onClick: (u3) => {
        var c3;
        (c3 = this.onClick) === null || c3 === void 0 || c3.call(this, u3);
      },
      role: "none",
      class: [`${e28}-menu-item-content`, {
        [`${e28}-menu-item-content--selected`]: this.selected,
        [`${e28}-menu-item-content--collapsed`]: this.collapsed,
        [`${e28}-menu-item-content--child-active`]: this.childActive,
        [`${e28}-menu-item-content--disabled`]: this.disabled,
        [`${e28}-menu-item-content--hover`]: this.hover
      }],
      style: this.style
    }, a3 && h$1R("div", {
      class: `${e28}-menu-item-content__icon`,
      style: this.iconStyle,
      role: "none"
    }, [a3]), h$1R("div", {
      class: `${e28}-menu-item-content-header`,
      role: "none"
    }, this.isEllipsisPlaceholder ? this.title : r3 ? r3(n3.rawNode) : o$1c(this.title), this.extra || o3 ? h$1R("span", {
      class: `${e28}-menu-item-content-header__extra`
    }, " ", o3 ? o3(n3.rawNode) : o$1c(this.extra)) : null), this.showArrow ? h$1R(d$1R, {
      ariaHidden: true,
      class: `${e28}-menu-item-content__arrow`,
      clsPrefix: e28
    }, {
      default: () => s3 ? s3(n3.rawNode) : h$1R(r$4, null)
    }) : null);
  }
});
const K$4 = Object.assign(Object.assign({}, e$1), {
  rawNodes: {
    type: Array,
    default: () => []
  },
  tmNodes: {
    type: Array,
    default: () => []
  },
  tmNode: {
    type: Object,
    required: true
  },
  disabled: Boolean,
  icon: Function,
  onClick: Function,
  domId: String,
  virtualChildActive: {
    type: Boolean,
    default: void 0
  },
  isEllipsisPlaceholder: Boolean
}), J$3 = defineComponent({
  name: "Submenu",
  props: K$4,
  setup(i) {
    const n3 = y$8(i), {
      NMenu: o3,
      NSubmenu: s3
    } = n3, {
      props: d3,
      mergedCollapsedRef: l3,
      mergedThemeRef: u3
    } = o3, r3 = computed(() => {
      const {
        disabled: e28
      } = i;
      return s3 != null && s3.mergedDisabledRef.value || d3.disabled ? true : e28;
    }), a3 = ref$1(false);
    provide(t$5, {
      paddingLeftRef: n3.paddingLeft,
      mergedDisabledRef: r3
    }), provide(m$5, null);
    function c3() {
      const {
        onClick: e28
      } = i;
      e28 && e28();
    }
    function h3() {
      r3.value || (l3.value || o3.toggleExpand(i.internalKey), c3());
    }
    function p3(e28) {
      a3.value = e28;
    }
    return {
      menuProps: d3,
      mergedTheme: u3,
      doSelect: o3.doSelect,
      inverted: o3.invertedRef,
      isHorizontal: o3.isHorizontalRef,
      mergedClsPrefix: o3.mergedClsPrefixRef,
      maxIconSize: n3.maxIconSize,
      activeIconSize: n3.activeIconSize,
      iconMarginRight: n3.iconMarginRight,
      dropdownPlacement: n3.dropdownPlacement,
      dropdownShow: a3,
      paddingLeft: n3.paddingLeft,
      mergedDisabled: r3,
      mergedValue: o3.mergedValueRef,
      childActive: n$1U(() => {
        var e28;
        return (e28 = i.virtualChildActive) !== null && e28 !== void 0 ? e28 : o3.activePathRef.value.includes(i.internalKey);
      }),
      collapsed: computed(() => d3.mode === "horizontal" ? false : l3.value ? true : !o3.mergedExpandedKeysRef.value.includes(i.internalKey)),
      dropdownEnabled: computed(() => !r3.value && (d3.mode === "horizontal" || l3.value)),
      handlePopoverShowChange: p3,
      handleClick: h3
    };
  },
  render() {
    var i;
    const {
      mergedClsPrefix: n3,
      menuProps: {
        renderIcon: o3,
        renderLabel: s3
      }
    } = this, d3 = () => {
      const {
        isHorizontal: u3,
        paddingLeft: r3,
        collapsed: a3,
        mergedDisabled: c3,
        maxIconSize: h3,
        activeIconSize: p3,
        title: e28,
        childActive: S3,
        icon: w3,
        handleClick: C3,
        menuProps: {
          nodeProps: f3
        },
        dropdownShow: x3,
        iconMarginRight: I3,
        tmNode: g3,
        mergedClsPrefix: b3,
        isEllipsisPlaceholder: z3,
        extra: R3
      } = this, m3 = f3 == null ? void 0 : f3(g3.rawNode);
      return h$1R("div", Object.assign({}, m3, {
        class: [`${b3}-menu-item`, m3 == null ? void 0 : m3.class],
        role: "menuitem"
      }), h$1R(w$4, {
        tmNode: g3,
        paddingLeft: r3,
        collapsed: a3,
        disabled: c3,
        iconMarginRight: I3,
        maxIconSize: h3,
        activeIconSize: p3,
        title: e28,
        extra: R3,
        showArrow: !u3,
        childActive: S3,
        clsPrefix: b3,
        icon: w3,
        hover: x3,
        onClick: C3,
        isEllipsisPlaceholder: z3
      }));
    }, l3 = () => h$1R(l$1W, null, {
      default: () => {
        const {
          tmNodes: u3,
          collapsed: r3
        } = this;
        return r3 ? null : h$1R("div", {
          class: `${n3}-submenu-children`,
          role: "menu"
        }, u3.map((a3) => F$4(a3, this.menuProps)));
      }
    });
    return this.root ? h$1R(Le$6, Object.assign({
      size: "large",
      trigger: "hover"
    }, (i = this.menuProps) === null || i === void 0 ? void 0 : i.dropdownProps, {
      themeOverrides: this.mergedTheme.peerOverrides.Dropdown,
      theme: this.mergedTheme.peers.Dropdown,
      builtinThemeOverrides: {
        fontSizeLarge: "14px",
        optionIconSizeLarge: "18px"
      },
      value: this.mergedValue,
      disabled: !this.dropdownEnabled,
      placement: this.dropdownPlacement,
      keyField: this.menuProps.keyField,
      labelField: this.menuProps.labelField,
      childrenField: this.menuProps.childrenField,
      onUpdateShow: this.handlePopoverShowChange,
      options: this.rawNodes,
      onSelect: this.doSelect,
      inverted: this.inverted,
      renderIcon: o3,
      renderLabel: s3
    }), {
      default: () => h$1R("div", {
        class: `${n3}-submenu`,
        role: "menuitem",
        "aria-expanded": !this.collapsed,
        id: this.domId
      }, d3(), this.isHorizontal ? null : l3())
    }) : h$1R("div", {
      class: `${n3}-submenu`,
      role: "menuitem",
      "aria-expanded": !this.collapsed,
      id: this.domId
    }, d3(), l3());
  }
});
const N$4 = Object.assign(Object.assign({}, e$1), {
  tmNode: {
    type: Object,
    required: true
  },
  disabled: Boolean,
  icon: Function,
  onClick: Function
}), k$8 = defineComponent({
  name: "MenuOption",
  props: N$4,
  setup(e28) {
    const i = y$8(e28), {
      NSubmenu: n3,
      NMenu: t3
    } = i, {
      props: o3,
      mergedClsPrefixRef: r3,
      mergedCollapsedRef: c3
    } = t3, u3 = n3 ? n3.mergedDisabledRef : {
      value: false
    }, d3 = computed(() => u3.value || e28.disabled);
    function f3(l3) {
      const {
        onClick: a3
      } = e28;
      a3 && a3(l3);
    }
    function h3(l3) {
      d3.value || (t3.doSelect(e28.internalKey, e28.tmNode.rawNode), f3(l3));
    }
    return {
      mergedClsPrefix: r3,
      dropdownPlacement: i.dropdownPlacement,
      paddingLeft: i.paddingLeft,
      iconMarginRight: i.iconMarginRight,
      maxIconSize: i.maxIconSize,
      activeIconSize: i.activeIconSize,
      mergedTheme: t3.mergedThemeRef,
      menuProps: o3,
      dropdownEnabled: n$1U(() => e28.root && c3.value && o3.mode !== "horizontal" && !d3.value),
      selected: n$1U(() => t3.mergedValueRef.value === e28.internalKey),
      mergedDisabled: d3,
      handleClick: h3
    };
  },
  render() {
    const {
      mergedClsPrefix: e28,
      mergedTheme: i,
      tmNode: n3,
      menuProps: {
        renderLabel: t3,
        nodeProps: o3
      }
    } = this, r3 = o3 == null ? void 0 : o3(n3.rawNode);
    return h$1R("div", Object.assign({}, r3, {
      role: "menuitem",
      class: [`${e28}-menu-item`, r3 == null ? void 0 : r3.class]
    }), h$1R(b$10, {
      theme: i.peers.Tooltip,
      themeOverrides: i.peerOverrides.Tooltip,
      trigger: "hover",
      placement: this.dropdownPlacement,
      disabled: !this.dropdownEnabled || this.title === void 0,
      internalExtraClass: ["menu-tooltip"]
    }, {
      default: () => t3 ? t3(n3.rawNode) : o$1c(this.title),
      trigger: () => h$1R(w$4, {
        tmNode: n3,
        clsPrefix: e28,
        paddingLeft: this.paddingLeft,
        iconMarginRight: this.iconMarginRight,
        maxIconSize: this.maxIconSize,
        activeIconSize: this.activeIconSize,
        selected: this.selected,
        title: this.title,
        extra: this.extra,
        disabled: this.mergedDisabled,
        icon: this.icon,
        onClick: this.handleClick
      })
    }));
  }
});
const d$5 = defineComponent({
  name: "MenuDivider",
  setup() {
    const e28 = inject(o$1), {
      mergedClsPrefixRef: n3,
      isHorizontalRef: i
    } = e28;
    return () => i.value ? null : h$1R("div", {
      class: `${n3.value}-menu-divider`
    });
  }
});
const g$5 = t$1y(N$5), k$7 = t$1y(N$4), v$4 = t$1y(K$4);
function P$3(r3) {
  return r3.type === "divider" || r3.type === "render";
}
function x$7(r3) {
  return r3.type === "divider";
}
function F$4(r3, p3) {
  const {
    rawNode: e28
  } = r3, {
    show: l3
  } = e28;
  if (l3 === false)
    return null;
  if (P$3(e28))
    return x$7(e28) ? h$1R(d$5, Object.assign({
      key: r3.key
    }, e28.props)) : null;
  const {
    labelField: c3
  } = p3, {
    key: n3,
    level: u3,
    isGroup: f3
  } = r3, t3 = Object.assign(Object.assign({}, e28), {
    title: e28.title || e28[c3],
    extra: e28.titleExtra || e28.extra,
    key: n3,
    internalKey: n3,
    level: u3,
    root: u3 === 0,
    isGroup: f3
  });
  return r3.children ? r3.isGroup ? h$1R(G$3, r$1C(t3, g$5, {
    tmNode: r3,
    tmNodes: r3.children,
    key: n3
  })) : h$1R(J$3, r$1C(t3, v$4, {
    key: n3,
    rawNodes: e28[p3.childrenField],
    tmNodes: r3.children,
    tmNode: r3
  })) : h$1R(k$8, r$1C(t3, k$7, {
    key: n3,
    tmNode: r3
  }));
}
const l$5 = [r$2a("&::before", "background-color: var(--n-item-color-hover);"), M$y("arrow", `
 color: var(--n-arrow-color-hover);
 `), M$y("icon", `
 color: var(--n-item-icon-color-hover);
 `), l$25("menu-item-content-header", `
 color: var(--n-item-text-color-hover);
 `, [r$2a("a", `
 color: var(--n-item-text-color-hover);
 `), M$y("extra", `
 color: var(--n-item-text-color-hover);
 `)])], v$3 = [M$y("icon", `
 color: var(--n-item-icon-color-hover-horizontal);
 `), l$25("menu-item-content-header", `
 color: var(--n-item-text-color-hover-horizontal);
 `, [r$2a("a", `
 color: var(--n-item-text-color-hover-horizontal);
 `), M$y("extra", `
 color: var(--n-item-text-color-hover-horizontal);
 `)])], s$4 = r$2a([l$25("menu", `
 background-color: var(--n-color);
 color: var(--n-item-text-color);
 overflow: hidden;
 transition: background-color .3s var(--n-bezier);
 box-sizing: border-box;
 font-size: var(--n-font-size);
 padding-bottom: 6px;
 `, [g$1j("horizontal", `
 max-width: 100%;
 width: 100%;
 display: flex;
 overflow: hidden;
 padding-bottom: 0;
 `, [l$25("submenu", "margin: 0;"), l$25("menu-item", "margin: 0;"), l$25("menu-item-content", `
 padding: 0 20px;
 border-bottom: 2px solid #0000;
 `, [r$2a("&::before", "display: none;"), g$1j("selected", "border-bottom: 2px solid var(--n-border-color-horizontal)")]), l$25("menu-item-content", [g$1j("selected", [M$y("icon", "color: var(--n-item-icon-color-active-horizontal);"), l$25("menu-item-content-header", `
 color: var(--n-item-text-color-active-horizontal);
 `, [r$2a("a", "color: var(--n-item-text-color-active-horizontal);"), M$y("extra", "color: var(--n-item-text-color-active-horizontal);")])]), g$1j("child-active", `
 border-bottom: 2px solid var(--n-border-color-horizontal);
 `, [l$25("menu-item-content-header", `
 color: var(--n-item-text-color-child-active-horizontal);
 `, [r$2a("a", `
 color: var(--n-item-text-color-child-active-horizontal);
 `), M$y("extra", `
 color: var(--n-item-text-color-child-active-horizontal);
 `)]), M$y("icon", `
 color: var(--n-item-icon-color-child-active-horizontal);
 `)]), x$I("disabled", [x$I("selected, child-active", [r$2a("&:focus-within", v$3)]), g$1j("selected", [i$5(null, [M$y("icon", "color: var(--n-item-icon-color-active-hover-horizontal);"), l$25("menu-item-content-header", `
 color: var(--n-item-text-color-active-hover-horizontal);
 `, [r$2a("a", "color: var(--n-item-text-color-active-hover-horizontal);"), M$y("extra", "color: var(--n-item-text-color-active-hover-horizontal);")])])]), g$1j("child-active", [i$5(null, [M$y("icon", "color: var(--n-item-icon-color-child-active-hover-horizontal);"), l$25("menu-item-content-header", `
 color: var(--n-item-text-color-child-active-hover-horizontal);
 `, [r$2a("a", "color: var(--n-item-text-color-child-active-hover-horizontal);"), M$y("extra", "color: var(--n-item-text-color-child-active-hover-horizontal);")])])]), i$5("border-bottom: 2px solid var(--n-border-color-horizontal);", v$3)]), l$25("menu-item-content-header", [r$2a("a", "color: var(--n-item-text-color-horizontal);")])])]), x$I("responsive", [l$25("menu-item-content-header", `
 overflow: hidden;
 text-overflow: ellipsis;
 `)]), g$1j("collapsed", [l$25("menu-item-content", [g$1j("selected", [r$2a("&::before", `
 background-color: var(--n-item-color-active-collapsed) !important;
 `)]), l$25("menu-item-content-header", "opacity: 0;"), M$y("arrow", "opacity: 0;"), M$y("icon", "color: var(--n-item-icon-color-collapsed);")])]), l$25("menu-item", `
 height: var(--n-item-height);
 margin-top: 6px;
 position: relative;
 `), l$25("menu-item-content", `
 box-sizing: border-box;
 line-height: 1.75;
 height: 100%;
 display: grid;
 grid-template-areas: "icon content arrow";
 grid-template-columns: auto 1fr auto;
 align-items: center;
 cursor: pointer;
 position: relative;
 padding-right: 18px;
 transition:
 background-color .3s var(--n-bezier),
 padding-left .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [r$2a("> *", "z-index: 1;"), r$2a("&::before", `
 z-index: auto;
 content: "";
 background-color: #0000;
 position: absolute;
 left: 8px;
 right: 8px;
 top: 0;
 bottom: 0;
 pointer-events: none;
 border-radius: var(--n-border-radius);
 transition: background-color .3s var(--n-bezier);
 `), g$1j("disabled", `
 opacity: .45;
 cursor: not-allowed;
 `), g$1j("collapsed", [M$y("arrow", "transform: rotate(0);")]), g$1j("selected", [r$2a("&::before", "background-color: var(--n-item-color-active);"), M$y("arrow", "color: var(--n-arrow-color-active);"), M$y("icon", "color: var(--n-item-icon-color-active);"), l$25("menu-item-content-header", `
 color: var(--n-item-text-color-active);
 `, [r$2a("a", "color: var(--n-item-text-color-active);"), M$y("extra", "color: var(--n-item-text-color-active);")])]), g$1j("child-active", [l$25("menu-item-content-header", `
 color: var(--n-item-text-color-child-active);
 `, [r$2a("a", `
 color: var(--n-item-text-color-child-active);
 `), M$y("extra", `
 color: var(--n-item-text-color-child-active);
 `)]), M$y("arrow", `
 color: var(--n-arrow-color-child-active);
 `), M$y("icon", `
 color: var(--n-item-icon-color-child-active);
 `)]), x$I("disabled", [x$I("selected, child-active", [r$2a("&:focus-within", l$5)]), g$1j("selected", [i$5(null, [M$y("arrow", "color: var(--n-arrow-color-active-hover);"), M$y("icon", "color: var(--n-item-icon-color-active-hover);"), l$25("menu-item-content-header", `
 color: var(--n-item-text-color-active-hover);
 `, [r$2a("a", "color: var(--n-item-text-color-active-hover);"), M$y("extra", "color: var(--n-item-text-color-active-hover);")])])]), g$1j("child-active", [i$5(null, [M$y("arrow", "color: var(--n-arrow-color-child-active-hover);"), M$y("icon", "color: var(--n-item-icon-color-child-active-hover);"), l$25("menu-item-content-header", `
 color: var(--n-item-text-color-child-active-hover);
 `, [r$2a("a", "color: var(--n-item-text-color-child-active-hover);"), M$y("extra", "color: var(--n-item-text-color-child-active-hover);")])])]), g$1j("selected", [i$5(null, [r$2a("&::before", "background-color: var(--n-item-color-active-hover);")])]), i$5(null, l$5)]), M$y("icon", `
 grid-area: icon;
 color: var(--n-item-icon-color);
 transition:
 color .3s var(--n-bezier),
 font-size .3s var(--n-bezier),
 margin-right .3s var(--n-bezier);
 box-sizing: content-box;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 `), M$y("arrow", `
 grid-area: arrow;
 font-size: 16px;
 color: var(--n-arrow-color);
 transform: rotate(180deg);
 opacity: 1;
 transition:
 color .3s var(--n-bezier),
 transform 0.2s var(--n-bezier),
 opacity 0.2s var(--n-bezier);
 `), l$25("menu-item-content-header", `
 grid-area: content;
 transition:
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 opacity: 1;
 white-space: nowrap;
 color: var(--n-item-text-color);
 `, [r$2a("a", `
 outline: none;
 text-decoration: none;
 transition: color .3s var(--n-bezier);
 color: var(--n-item-text-color);
 `, [r$2a("&::before", `
 content: "";
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `)]), M$y("extra", `
 font-size: .93em;
 color: var(--n-group-text-color);
 transition: color .3s var(--n-bezier);
 `)])]), l$25("submenu", `
 cursor: pointer;
 position: relative;
 margin-top: 6px;
 `, [l$25("menu-item-content", `
 height: var(--n-item-height);
 `), l$25("submenu-children", `
 overflow: hidden;
 padding: 0;
 `, [x$E({
  duration: ".2s"
})])]), l$25("menu-item-group", [l$25("menu-item-group-title", `
 margin-top: 6px;
 color: var(--n-group-text-color);
 cursor: default;
 font-size: .93em;
 height: 36px;
 display: flex;
 align-items: center;
 transition:
 padding-left .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)])]), l$25("menu-tooltip", [r$2a("a", `
 color: inherit;
 text-decoration: none;
 `)]), l$25("menu-divider", `
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-divider-color);
 height: 1px;
 margin: 6px 18px;
 `)]);
function i$5(c3, a3) {
  return [g$1j("hover", c3, a3), r$2a("&:hover", c3, a3)];
}
function a$4(r3, t3, o3, e28) {
  return {
    itemColorHoverInverted: "#0000",
    itemColorActiveInverted: t3,
    itemColorActiveHoverInverted: t3,
    itemColorActiveCollapsedInverted: t3,
    itemTextColorInverted: r3,
    itemTextColorHoverInverted: o3,
    itemTextColorChildActiveInverted: o3,
    itemTextColorChildActiveHoverInverted: o3,
    itemTextColorActiveInverted: o3,
    itemTextColorActiveHoverInverted: o3,
    itemTextColorHorizontalInverted: r3,
    itemTextColorHoverHorizontalInverted: o3,
    itemTextColorChildActiveHorizontalInverted: o3,
    itemTextColorChildActiveHoverHorizontalInverted: o3,
    itemTextColorActiveHorizontalInverted: o3,
    itemTextColorActiveHoverHorizontalInverted: o3,
    itemIconColorInverted: r3,
    itemIconColorHoverInverted: o3,
    itemIconColorActiveInverted: o3,
    itemIconColorActiveHoverInverted: o3,
    itemIconColorChildActiveInverted: o3,
    itemIconColorChildActiveHoverInverted: o3,
    itemIconColorCollapsedInverted: r3,
    itemIconColorHorizontalInverted: r3,
    itemIconColorHoverHorizontalInverted: o3,
    itemIconColorActiveHorizontalInverted: o3,
    itemIconColorActiveHoverHorizontalInverted: o3,
    itemIconColorChildActiveHorizontalInverted: o3,
    itemIconColorChildActiveHoverHorizontalInverted: o3,
    arrowColorInverted: r3,
    arrowColorHoverInverted: o3,
    arrowColorActiveInverted: o3,
    arrowColorActiveHoverInverted: o3,
    arrowColorChildActiveInverted: o3,
    arrowColorChildActiveHoverInverted: o3,
    groupTextColorInverted: e28
  };
}
const h$8 = (r3) => {
  const {
    borderRadius: t3,
    textColor3: o3,
    primaryColor: e28,
    textColor2: i,
    textColor1: l3,
    fontSize: C3,
    dividerColor: m3,
    hoverColor: d3,
    primaryColorHover: v3
  } = r3;
  return Object.assign({
    borderRadius: t3,
    color: "#0000",
    groupTextColor: o3,
    itemColorHover: d3,
    itemColorActive: J$p(e28, {
      alpha: 0.1
    }),
    itemColorActiveHover: J$p(e28, {
      alpha: 0.1
    }),
    itemColorActiveCollapsed: J$p(e28, {
      alpha: 0.1
    }),
    itemTextColor: i,
    itemTextColorHover: i,
    itemTextColorActive: e28,
    itemTextColorActiveHover: e28,
    itemTextColorChildActive: e28,
    itemTextColorChildActiveHover: e28,
    itemTextColorHorizontal: i,
    itemTextColorHoverHorizontal: v3,
    itemTextColorActiveHorizontal: e28,
    itemTextColorActiveHoverHorizontal: e28,
    itemTextColorChildActiveHorizontal: e28,
    itemTextColorChildActiveHoverHorizontal: e28,
    itemIconColor: l3,
    itemIconColorHover: l3,
    itemIconColorActive: e28,
    itemIconColorActiveHover: e28,
    itemIconColorChildActive: e28,
    itemIconColorChildActiveHover: e28,
    itemIconColorCollapsed: l3,
    itemIconColorHorizontal: l3,
    itemIconColorHoverHorizontal: v3,
    itemIconColorActiveHorizontal: e28,
    itemIconColorActiveHoverHorizontal: e28,
    itemIconColorChildActiveHorizontal: e28,
    itemIconColorChildActiveHoverHorizontal: e28,
    itemHeight: "42px",
    arrowColor: i,
    arrowColorHover: i,
    arrowColorActive: e28,
    arrowColorActiveHover: e28,
    arrowColorChildActive: e28,
    arrowColorChildActiveHover: e28,
    colorInverted: "#0000",
    borderColorHorizontal: "#0000",
    fontSize: C3,
    dividerColor: m3
  }, a$4("#BBB", e28, "#FFF", "#AAA"));
}, z$3 = G$w({
  name: "Menu",
  common: d$1T,
  peers: {
    Tooltip: d$1z,
    Dropdown: w$z
  },
  self: h$8
}), f$6 = z$3;
const xe$1 = Object.assign(Object.assign({}, _$F.props), {
  options: {
    type: Array,
    default: () => []
  },
  collapsed: {
    type: Boolean,
    default: void 0
  },
  collapsedWidth: {
    type: Number,
    default: 48
  },
  iconSize: {
    type: Number,
    default: 20
  },
  collapsedIconSize: {
    type: Number,
    default: 24
  },
  rootIndent: Number,
  indent: {
    type: Number,
    default: 32
  },
  labelField: {
    type: String,
    default: "label"
  },
  keyField: {
    type: String,
    default: "key"
  },
  childrenField: {
    type: String,
    default: "children"
  },
  disabledField: {
    type: String,
    default: "disabled"
  },
  defaultExpandAll: Boolean,
  defaultExpandedKeys: Array,
  expandedKeys: Array,
  value: [String, Number],
  defaultValue: {
    type: [String, Number],
    default: null
  },
  mode: {
    type: String,
    default: "vertical"
  },
  watchProps: {
    type: Array,
    default: void 0
  },
  disabled: Boolean,
  show: {
    type: Boolean,
    default: true
  },
  inverted: Boolean,
  "onUpdate:expandedKeys": [Function, Array],
  onUpdateExpandedKeys: [Function, Array],
  onUpdateValue: [Function, Array],
  "onUpdate:value": [Function, Array],
  expandIcon: Function,
  renderIcon: Function,
  renderLabel: Function,
  renderExtra: Function,
  dropdownProps: Object,
  accordion: Boolean,
  nodeProps: Function,
  dropdownPlacement: {
    type: String,
    default: "bottom"
  },
  responsive: Boolean,
  items: Array,
  onOpenNamesChange: [Function, Array],
  onSelect: [Function, Array],
  onExpandedNamesChange: [Function, Array],
  expandedNames: Array,
  defaultExpandedNames: Array
}), Ve$1 = defineComponent({
  name: "Menu",
  props: xe$1,
  setup(n3) {
    const {
      mergedClsPrefixRef: v3,
      inlineThemeDisabled: y3
    } = a$2x(n3), m3 = _$F("Menu", "-menu", s$4, f$6, n3, v3), f3 = inject(t$6, null), g3 = computed(() => {
      var t3;
      const {
        collapsed: i
      } = n3;
      if (i !== void 0)
        return i;
      if (f3) {
        const {
          collapseModeRef: e28,
          collapsedRef: r3
        } = f3;
        if (e28.value === "width")
          return (t3 = r3.value) !== null && t3 !== void 0 ? t3 : false;
      }
      return false;
    }), a3 = computed(() => {
      const {
        keyField: t3,
        childrenField: i,
        disabledField: e28
      } = n3;
      return U$s(n3.items || n3.options, {
        getIgnored(r3) {
          return P$3(r3);
        },
        getChildren(r3) {
          return r3[i];
        },
        getDisabled(r3) {
          return r3[e28];
        },
        getKey(r3) {
          var l3;
          return (l3 = r3[t3]) !== null && l3 !== void 0 ? l3 : r3.name;
        }
      });
    }), u3 = computed(() => new Set(a3.value.treeNodes.map((t3) => t3.key))), {
      watchProps: d3
    } = n3, C3 = ref$1(null);
    d3 != null && d3.includes("defaultValue") ? watchEffect(() => {
      C3.value = n3.defaultValue;
    }) : C3.value = n3.defaultValue;
    const k3 = toRef$1(n3, "value"), p3 = d$1S(k3, C3), A3 = ref$1([]), T3 = () => {
      A3.value = n3.defaultExpandAll ? a3.value.getNonLeafKeys() : n3.defaultExpandedNames || n3.defaultExpandedKeys || a3.value.getPath(p3.value, {
        includeSelf: false
      }).keyPath;
    };
    d3 != null && d3.includes("defaultExpandedKeys") ? watchEffect(T3) : T3();
    const b3 = f$1j(n3, ["expandedNames", "expandedKeys"]), z3 = d$1S(b3, A3), j3 = computed(() => a3.value.treeNodes), w3 = computed(() => a3.value.getPath(p3.value).keyPath);
    provide(o$1, {
      props: n3,
      mergedCollapsedRef: g3,
      mergedThemeRef: m3,
      mergedValueRef: p3,
      mergedExpandedKeysRef: z3,
      activePathRef: w3,
      mergedClsPrefixRef: v3,
      isHorizontalRef: computed(() => n3.mode === "horizontal"),
      invertedRef: toRef$1(n3, "inverted"),
      doSelect: $3,
      toggleExpand: D3
    });
    function $3(t3, i) {
      const {
        "onUpdate:value": e28,
        onUpdateValue: r3,
        onSelect: l3
      } = n3;
      r3 && i$1Z(r3, t3, i), e28 && i$1Z(e28, t3, i), l3 && i$1Z(l3, t3, i), C3.value = t3;
    }
    function E3(t3) {
      const {
        "onUpdate:expandedKeys": i,
        onUpdateExpandedKeys: e28,
        onExpandedNamesChange: r3,
        onOpenNamesChange: l3
      } = n3;
      i && i$1Z(i, t3), e28 && i$1Z(e28, t3), r3 && i$1Z(r3, t3), l3 && i$1Z(l3, t3), A3.value = t3;
    }
    function D3(t3) {
      const i = Array.from(z3.value), e28 = i.findIndex((r3) => r3 === t3);
      if (~e28)
        i.splice(e28, 1);
      else {
        if (n3.accordion && u3.value.has(t3)) {
          const r3 = i.findIndex((l3) => u3.value.has(l3));
          r3 > -1 && i.splice(r3, 1);
        }
        i.push(t3);
      }
      E3(i);
    }
    const G3 = (t3) => {
      const i = a3.value.getPath(t3 != null ? t3 : p3.value, {
        includeSelf: false
      }).keyPath;
      if (!i.length)
        return;
      const e28 = Array.from(z3.value), r3 = /* @__PURE__ */ new Set([...e28, ...i]);
      n3.accordion && u3.value.forEach((l3) => {
        r3.has(l3) && !i.includes(l3) && r3.delete(l3);
      }), E3(Array.from(r3));
    }, K3 = computed(() => {
      const {
        inverted: t3
      } = n3, {
        common: {
          cubicBezierEaseInOut: i
        },
        self: e28
      } = m3.value, {
        borderRadius: r3,
        borderColorHorizontal: l3,
        fontSize: ee2,
        itemHeight: oe2,
        dividerColor: te2
      } = e28, o3 = {
        "--n-divider-color": te2,
        "--n-bezier": i,
        "--n-font-size": ee2,
        "--n-border-color-horizontal": l3,
        "--n-border-radius": r3,
        "--n-item-height": oe2
      };
      return t3 ? (o3["--n-group-text-color"] = e28.groupTextColorInverted, o3["--n-color"] = e28.colorInverted, o3["--n-item-text-color"] = e28.itemTextColorInverted, o3["--n-item-text-color-hover"] = e28.itemTextColorHoverInverted, o3["--n-item-text-color-active"] = e28.itemTextColorActiveInverted, o3["--n-item-text-color-child-active"] = e28.itemTextColorChildActiveInverted, o3["--n-item-text-color-child-active-hover"] = e28.itemTextColorChildActiveInverted, o3["--n-item-text-color-active-hover"] = e28.itemTextColorActiveHoverInverted, o3["--n-item-icon-color"] = e28.itemIconColorInverted, o3["--n-item-icon-color-hover"] = e28.itemIconColorHoverInverted, o3["--n-item-icon-color-active"] = e28.itemIconColorActiveInverted, o3["--n-item-icon-color-active-hover"] = e28.itemIconColorActiveHoverInverted, o3["--n-item-icon-color-child-active"] = e28.itemIconColorChildActiveInverted, o3["--n-item-icon-color-child-active-hover"] = e28.itemIconColorChildActiveHoverInverted, o3["--n-item-icon-color-collapsed"] = e28.itemIconColorCollapsedInverted, o3["--n-item-text-color-horizontal"] = e28.itemTextColorHorizontalInverted, o3["--n-item-text-color-hover-horizontal"] = e28.itemTextColorHoverHorizontalInverted, o3["--n-item-text-color-active-horizontal"] = e28.itemTextColorActiveHorizontalInverted, o3["--n-item-text-color-child-active-horizontal"] = e28.itemTextColorChildActiveHorizontalInverted, o3["--n-item-text-color-child-active-hover-horizontal"] = e28.itemTextColorChildActiveHoverHorizontalInverted, o3["--n-item-text-color-active-hover-horizontal"] = e28.itemTextColorActiveHoverHorizontalInverted, o3["--n-item-icon-color-horizontal"] = e28.itemIconColorHorizontalInverted, o3["--n-item-icon-color-hover-horizontal"] = e28.itemIconColorHoverHorizontalInverted, o3["--n-item-icon-color-active-horizontal"] = e28.itemIconColorActiveHorizontalInverted, o3["--n-item-icon-color-active-hover-horizontal"] = e28.itemIconColorActiveHoverHorizontalInverted, o3["--n-item-icon-color-child-active-horizontal"] = e28.itemIconColorChildActiveHorizontalInverted, o3["--n-item-icon-color-child-active-hover-horizontal"] = e28.itemIconColorChildActiveHoverHorizontalInverted, o3["--n-arrow-color"] = e28.arrowColorInverted, o3["--n-arrow-color-hover"] = e28.arrowColorHoverInverted, o3["--n-arrow-color-active"] = e28.arrowColorActiveInverted, o3["--n-arrow-color-active-hover"] = e28.arrowColorActiveHoverInverted, o3["--n-arrow-color-child-active"] = e28.arrowColorChildActiveInverted, o3["--n-arrow-color-child-active-hover"] = e28.arrowColorChildActiveHoverInverted, o3["--n-item-color-hover"] = e28.itemColorHoverInverted, o3["--n-item-color-active"] = e28.itemColorActiveInverted, o3["--n-item-color-active-hover"] = e28.itemColorActiveHoverInverted, o3["--n-item-color-active-collapsed"] = e28.itemColorActiveCollapsedInverted) : (o3["--n-group-text-color"] = e28.groupTextColor, o3["--n-color"] = e28.color, o3["--n-item-text-color"] = e28.itemTextColor, o3["--n-item-text-color-hover"] = e28.itemTextColorHover, o3["--n-item-text-color-active"] = e28.itemTextColorActive, o3["--n-item-text-color-child-active"] = e28.itemTextColorChildActive, o3["--n-item-text-color-child-active-hover"] = e28.itemTextColorChildActiveHover, o3["--n-item-text-color-active-hover"] = e28.itemTextColorActiveHover, o3["--n-item-icon-color"] = e28.itemIconColor, o3["--n-item-icon-color-hover"] = e28.itemIconColorHover, o3["--n-item-icon-color-active"] = e28.itemIconColorActive, o3["--n-item-icon-color-active-hover"] = e28.itemIconColorActiveHover, o3["--n-item-icon-color-child-active"] = e28.itemIconColorChildActive, o3["--n-item-icon-color-child-active-hover"] = e28.itemIconColorChildActiveHover, o3["--n-item-icon-color-collapsed"] = e28.itemIconColorCollapsed, o3["--n-item-text-color-horizontal"] = e28.itemTextColorHorizontal, o3["--n-item-text-color-hover-horizontal"] = e28.itemTextColorHoverHorizontal, o3["--n-item-text-color-active-horizontal"] = e28.itemTextColorActiveHorizontal, o3["--n-item-text-color-child-active-horizontal"] = e28.itemTextColorChildActiveHorizontal, o3["--n-item-text-color-child-active-hover-horizontal"] = e28.itemTextColorChildActiveHoverHorizontal, o3["--n-item-text-color-active-hover-horizontal"] = e28.itemTextColorActiveHoverHorizontal, o3["--n-item-icon-color-horizontal"] = e28.itemIconColorHorizontal, o3["--n-item-icon-color-hover-horizontal"] = e28.itemIconColorHoverHorizontal, o3["--n-item-icon-color-active-horizontal"] = e28.itemIconColorActiveHorizontal, o3["--n-item-icon-color-active-hover-horizontal"] = e28.itemIconColorActiveHoverHorizontal, o3["--n-item-icon-color-child-active-horizontal"] = e28.itemIconColorChildActiveHorizontal, o3["--n-item-icon-color-child-active-hover-horizontal"] = e28.itemIconColorChildActiveHoverHorizontal, o3["--n-arrow-color"] = e28.arrowColor, o3["--n-arrow-color-hover"] = e28.arrowColorHover, o3["--n-arrow-color-active"] = e28.arrowColorActive, o3["--n-arrow-color-active-hover"] = e28.arrowColorActiveHover, o3["--n-arrow-color-child-active"] = e28.arrowColorChildActive, o3["--n-arrow-color-child-active-hover"] = e28.arrowColorChildActiveHover, o3["--n-item-color-hover"] = e28.itemColorHover, o3["--n-item-color-active"] = e28.itemColorActive, o3["--n-item-color-active-hover"] = e28.itemColorActiveHover, o3["--n-item-color-active-collapsed"] = e28.itemColorActiveCollapsed), o3;
    }), h3 = y3 ? E$J("menu", computed(() => n3.inverted ? "a" : "b"), K3, n3) : void 0, R3 = i$1Y(), F3 = ref$1(null), L3 = ref$1(null);
    let _3 = true;
    const P3 = () => {
      var t3;
      _3 ? _3 = false : (t3 = F3.value) === null || t3 === void 0 || t3.sync({
        showAllItemsBeforeCalculate: true
      });
    };
    function W3() {
      return document.getElementById(R3);
    }
    const H3 = ref$1(-1);
    function q3(t3) {
      H3.value = n3.options.length - t3;
    }
    function J3(t3) {
      t3 || (H3.value = -1);
    }
    const Q3 = computed(() => {
      const t3 = H3.value;
      return {
        children: t3 === -1 ? [] : n3.options.slice(t3)
      };
    }), X3 = computed(() => {
      const {
        childrenField: t3,
        disabledField: i,
        keyField: e28
      } = n3;
      return U$s([Q3.value], {
        getIgnored(r3) {
          return P$3(r3);
        },
        getChildren(r3) {
          return r3[t3];
        },
        getDisabled(r3) {
          return r3[i];
        },
        getKey(r3) {
          var l3;
          return (l3 = r3[e28]) !== null && l3 !== void 0 ? l3 : r3.name;
        }
      });
    }), Y3 = computed(() => U$s([{}]).treeNodes[0]);
    function Z3() {
      var t3;
      if (H3.value === -1)
        return h$1R(J$3, {
          root: true,
          level: 0,
          key: "__ellpisisGroupPlaceholder__",
          internalKey: "__ellpisisGroupPlaceholder__",
          title: "\xB7\xB7\xB7",
          tmNode: Y3.value,
          domId: R3,
          isEllipsisPlaceholder: true
        });
      const i = X3.value.treeNodes[0], e28 = w3.value, r3 = !!(!((t3 = i.children) === null || t3 === void 0) && t3.some((l3) => e28.includes(l3.key)));
      return h$1R(J$3, {
        level: 0,
        root: true,
        key: "__ellpisisGroup__",
        internalKey: "__ellpisisGroup__",
        title: "\xB7\xB7\xB7",
        virtualChildActive: r3,
        tmNode: i,
        domId: R3,
        rawNodes: i.rawNode.children || [],
        tmNodes: i.children || [],
        isEllipsisPlaceholder: true
      });
    }
    return {
      mergedClsPrefix: v3,
      controlledExpandedKeys: b3,
      uncontrolledExpanededKeys: A3,
      mergedExpandedKeys: z3,
      uncontrolledValue: C3,
      mergedValue: p3,
      activePath: w3,
      tmNodes: j3,
      mergedTheme: m3,
      mergedCollapsed: g3,
      cssVars: y3 ? void 0 : K3,
      themeClass: h3 == null ? void 0 : h3.themeClass,
      overflowRef: F3,
      counterRef: L3,
      updateCounter: () => {
      },
      onResize: P3,
      onUpdateOverflow: J3,
      onUpdateCount: q3,
      renderCounter: Z3,
      getCounter: W3,
      onRender: h3 == null ? void 0 : h3.onRender,
      showOption: G3,
      deriveResponsiveState: P3
    };
  },
  render() {
    const {
      mergedClsPrefix: n3,
      mode: v3,
      themeClass: y3,
      onRender: m3
    } = this;
    m3 == null || m3();
    const f3 = () => this.tmNodes.map((d3) => F$4(d3, this.$props)), a3 = v3 === "horizontal" && this.responsive, u3 = () => h$1R("div", {
      role: v3 === "horizontal" ? "menubar" : "menu",
      class: [`${n3}-menu`, y3, `${n3}-menu--${v3}`, a3 && `${n3}-menu--responsive`, this.mergedCollapsed && `${n3}-menu--collapsed`],
      style: this.cssVars
    }, a3 ? h$1R(D$D, {
      ref: "overflowRef",
      onUpdateOverflow: this.onUpdateOverflow,
      getCounter: this.getCounter,
      onUpdateCount: this.onUpdateCount,
      updateCounter: this.updateCounter,
      style: {
        width: "100%",
        display: "flex",
        overflow: "hidden"
      }
    }, {
      default: f3,
      counter: this.renderCounter
    }) : f3());
    return a3 ? h$1R(x$D, {
      onResize: this.onResize
    }, {
      default: u3
    }) : u3();
  }
});
const i$4 = defineComponent({
  name: "UIMenu",
  inheritAttrs: false
}), m$4 = defineComponent(__spreadProps(__spreadValues({}, i$4), {
  props: {
    options: {
      type: Array
    },
    value: {
      type: [String, Number]
    }
  },
  emits: ["update:value"],
  setup(e28) {
    return (t3, n3) => (openBlock(), createBlock(unref(Ve$1), mergeProps({
      options: e28.options,
      "onUpdate:value": n3[0] || (n3[0] = (r3) => t3.$emit("update:value", r3)),
      value: e28.value
    }, t3.$attrs), null, 16, ["options", "value"]));
  }
})), d$4 = m$4;
const v$2 = defineComponent({
  name: "UIPopselect",
  inheritAttrs: false
}), w$3 = defineComponent(__spreadProps(__spreadValues({}, v$2), {
  props: {
    multiple: {
      type: Boolean,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    },
    renderLabel: {
      type: Function,
      default: void 0
    },
    scrollable: {
      type: Boolean,
      default: void 0
    },
    size: {
      type: String,
      default: "medium"
    },
    value: {
      type: [String, Number, Array, null],
      default: null
    },
    virtualScroll: {
      type: Boolean,
      default: void 0
    },
    trigger: {
      type: String,
      default: "hover"
    },
    delay: {
      type: Number
    },
    duration: {
      type: Number
    },
    placement: {
      type: String,
      default: "top"
    },
    show: {
      type: Boolean,
      default: void 0
    },
    showArrow: {
      type: Boolean,
      default: true
    },
    positionX: {
      type: Number,
      default: void 0
    },
    positionY: {
      type: Number,
      default: void 0
    },
    onClickoutside: {
      type: Function,
      default: void 0
    },
    onUpdateShow: {
      type: Function,
      default: void 0
    },
    animated: {
      type: Boolean,
      default: true
    },
    arrowPointToCenter: {
      type: Boolean,
      default: void 0
    },
    arrowClass: {
      type: String,
      default: void 0
    },
    arrowStyle: {
      type: String || Object,
      default: void 0
    },
    arrowWrapperClass: {
      type: String,
      default: void 0
    },
    arrowWrapperStyle: {
      type: String || Object,
      default: void 0
    },
    contentClass: {
      type: String,
      default: void 0
    },
    contentStyle: {
      type: String || Object,
      default: void 0
    },
    footerClass: {
      type: String,
      default: void 0
    },
    footerStyle: {
      type: String || Object,
      default: void 0
    },
    headerClass: {
      type: String,
      default: void 0
    },
    headerStyle: {
      type: String || Object,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    flip: {
      type: Boolean,
      default: true
    },
    keepAliveOnHover: {
      type: Boolean,
      default: true
    },
    overlap: {
      type: Boolean,
      default: void 0
    },
    raw: {
      type: Boolean,
      default: void 0
    },
    title: {
      type: String,
      default: void 0
    },
    to: {
      type: [String, Object, Boolean],
      default: "body"
    },
    width: {
      type: [Number, String],
      default: void 0
    },
    zIndex: {
      type: Number,
      default: void 0
    }
  },
  emits: ["update:value"],
  setup(e28) {
    const r3 = useSlots();
    return (t3, m3) => (openBlock(), createBlock(unref(E$w), {
      multiple: e28.multiple,
      options: e28.options,
      "render-label": e28.renderLabel,
      scrollable: e28.scrollable,
      size: e28.size,
      value: e28.value,
      "virtual-scroll": e28.virtualScroll,
      "on-update:value": (n3, d3) => t3.$emit("update:value", n3, d3),
      "show-arrow": e28.showArrow,
      show: e28.show,
      placement: e28.placement,
      trigger: e28.trigger,
      delay: e28.delay,
      duration: e28.duration,
      x: e28.positionX,
      y: e28.positionY,
      "on-clickoutside": e28.onClickoutside,
      animated: e28.animated,
      "arrow-point-to-center": e28.arrowPointToCenter,
      "arrow-class": e28.arrowClass,
      "arrow-style": e28.arrowStyle,
      "arrow-wrapper-class": e28.arrowWrapperClass,
      "arrow-wrapper-style": e28.arrowWrapperStyle,
      "content-class": e28.contentClass,
      "content-style": e28.contentStyle,
      disabled: e28.disabled,
      flip: e28.flip,
      "footer-class": e28.footerClass,
      "footer-style": e28.footerStyle,
      "header-class": e28.headerClass,
      "header-style": e28.headerStyle,
      "keep-alive-on-hover": e28.keepAliveOnHover,
      overlap: e28.overlap,
      raw: e28.raw,
      title: e28.title,
      to: e28.to,
      width: e28.width,
      "z-index": e28.zIndex,
      "on-update:show": e28.onUpdateShow
    }, createSlots({
      default: withCtx(() => [
        renderSlot(t3.$slots, "default")
      ]),
      _: 2
    }, [
      unref(r3).action ? {
        name: "action",
        fn: withCtx(() => [
          renderSlot(t3.$slots, "action")
        ]),
        key: "0"
      } : void 0,
      unref(r3).empty ? {
        name: "empty",
        fn: withCtx(() => [
          renderSlot(t3.$slots, "empty")
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["multiple", "options", "render-label", "scrollable", "size", "value", "virtual-scroll", "on-update:value", "show-arrow", "show", "placement", "trigger", "delay", "duration", "x", "y", "on-clickoutside", "animated", "arrow-point-to-center", "arrow-class", "arrow-style", "arrow-wrapper-class", "arrow-wrapper-style", "content-class", "content-style", "disabled", "flip", "footer-class", "footer-style", "header-class", "header-style", "keep-alive-on-hover", "overlap", "raw", "title", "to", "width", "z-index", "on-update:show"]));
  }
})), h$7 = w$3;
const e27 = {
  mobile: {
    device: {
      width: "280px",
      height: "564px"
    },
    page: {
      width: "248px",
      height: "473px"
    }
  }
};
const C$5 = ["id"], y$7 = ["src"], w$2 = {
  key: 1,
  class: "ghl-ui-preview__page--html-code"
}, S$4 = defineComponent({
  name: "UIPreview",
  inheritAttrs: false
}), k$6 = defineComponent(__spreadProps(__spreadValues({}, S$4), {
  props: {
    id: {
      type: String,
      required: true
    },
    href: {
      type: String,
      required: false
    },
    deviceClasses: {
      type: String,
      default: "",
      required: false
    },
    pageClasses: {
      type: String,
      default: "",
      required: false
    }
  },
  setup(e$110) {
    const t3 = e$110, n3 = useSlots(), l3 = computed(() => {
      const s3 = e27.mobile;
      return {
        device: t3.deviceClasses ? "" : s3.device,
        page: t3.pageClasses ? "" : s3.page
      };
    });
    return (s3, q3) => (openBlock(), createElementBlock("div", mergeProps(s3.$attrs, {
      class: "ghl-ui-preview",
      id: e$110.id
    }), [
      createElementVNode("div", {
        class: normalizeClass(["ghl-ui-preview__page", e$110.pageClasses]),
        style: normalizeStyle(l3.value.page)
      }, [
        t3.href ? (openBlock(), createElementBlock("iframe", {
          key: 0,
          src: e$110.href,
          id: "iphone-preview",
          class: "ghl-ui-preview__page--iframe"
        }, null, 8, y$7)) : unref(n3).html ? (openBlock(), createElementBlock("div", w$2, [
          renderSlot(s3.$slots, "html", {}, void 0, true)
        ])) : createCommentVNode("", true)
      ], 6),
      createElementVNode("div", {
        class: normalizeClass(["ghl-ui-preview__device--mobile", e$110.deviceClasses]),
        style: normalizeStyle(l3.value.device)
      }, null, 6)
    ], 16, C$5));
  }
})), B$6 = /* @__PURE__ */ s$1d(k$6, [["__scopeId", "data-v-3efbf9aa"]]);
const t$4 = r$2a([l$25("progress", {
  display: "inline-block"
}, [l$25("progress-icon", `
 color: var(--n-icon-color);
 transition: color .3s var(--n-bezier);
 `), g$1j("line", `
 width: 100%;
 display: block;
 `, [l$25("progress-content", `
 display: flex;
 align-items: center;
 `, [l$25("progress-graph", {
  flex: 1
})]), l$25("progress-custom-content", {
  marginLeft: "14px"
}), l$25("progress-icon", `
 width: 30px;
 padding-left: 14px;
 height: var(--n-icon-size-line);
 line-height: var(--n-icon-size-line);
 font-size: var(--n-icon-size-line);
 `, [g$1j("as-text", `
 color: var(--n-text-color-line-outer);
 text-align: center;
 width: 40px;
 font-size: var(--n-font-size);
 padding-left: 4px;
 transition: color .3s var(--n-bezier);
 `)])]), g$1j("circle, dashboard", {
  width: "120px"
}, [l$25("progress-custom-content", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 display: flex;
 align-items: center;
 justify-content: center;
 `), l$25("progress-text", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 display: flex;
 align-items: center;
 color: inherit;
 font-size: var(--n-font-size-circle);
 color: var(--n-text-color-circle);
 font-weight: var(--n-font-weight-circle);
 transition: color .3s var(--n-bezier);
 white-space: nowrap;
 `), l$25("progress-icon", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 display: flex;
 align-items: center;
 color: var(--n-icon-color);
 font-size: var(--n-icon-size-circle);
 `)]), g$1j("multiple-circle", `
 width: 200px;
 color: inherit;
 `, [l$25("progress-text", `
 font-weight: var(--n-font-weight-circle);
 color: var(--n-text-color-circle);
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 display: flex;
 align-items: center;
 justify-content: center;
 transition: color .3s var(--n-bezier);
 `)]), l$25("progress-content", {
  position: "relative"
}), l$25("progress-graph", {
  position: "relative"
}, [l$25("progress-graph-circle", [r$2a("svg", {
  verticalAlign: "bottom"
}), l$25("progress-graph-circle-fill", `
 stroke: var(--n-fill-color);
 transition:
 opacity .3s var(--n-bezier),
 stroke .3s var(--n-bezier),
 stroke-dasharray .3s var(--n-bezier);
 `, [g$1j("empty", {
  opacity: 0
})]), l$25("progress-graph-circle-rail", `
 transition: stroke .3s var(--n-bezier);
 overflow: hidden;
 stroke: var(--n-rail-color);
 `)]), l$25("progress-graph-line", [g$1j("indicator-inside", [l$25("progress-graph-line-rail", `
 height: 16px;
 line-height: 16px;
 border-radius: 10px;
 `, [l$25("progress-graph-line-fill", `
 height: inherit;
 border-radius: 10px;
 `), l$25("progress-graph-line-indicator", `
 background: #0000;
 white-space: nowrap;
 text-align: right;
 margin-left: 14px;
 margin-right: 14px;
 height: inherit;
 font-size: 12px;
 color: var(--n-text-color-line-inner);
 transition: color .3s var(--n-bezier);
 `)])]), g$1j("indicator-inside-label", `
 height: 16px;
 display: flex;
 align-items: center;
 `, [l$25("progress-graph-line-rail", `
 flex: 1;
 transition: background-color .3s var(--n-bezier);
 `), l$25("progress-graph-line-indicator", `
 background: var(--n-fill-color);
 font-size: 12px;
 transform: translateZ(0);
 display: flex;
 vertical-align: middle;
 height: 16px;
 line-height: 16px;
 padding: 0 10px;
 border-radius: 10px;
 position: absolute;
 white-space: nowrap;
 color: var(--n-text-color-line-inner);
 transition:
 right .2s var(--n-bezier),
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `)]), l$25("progress-graph-line-rail", `
 position: relative;
 overflow: hidden;
 height: var(--n-rail-height);
 border-radius: 5px;
 background-color: var(--n-rail-color);
 transition: background-color .3s var(--n-bezier);
 `, [l$25("progress-graph-line-fill", `
 background: var(--n-fill-color);
 position: relative;
 border-radius: 5px;
 height: inherit;
 width: 100%;
 max-width: 0%;
 transition:
 background-color .3s var(--n-bezier),
 max-width .2s var(--n-bezier);
 `, [g$1j("processing", [r$2a("&::after", `
 content: "";
 background-image: var(--n-line-bg-processing);
 animation: progress-processing-animation 2s var(--n-bezier) infinite;
 `)])])])])])]), r$2a("@keyframes progress-processing-animation", `
 0% {
 position: absolute;
 left: 0;
 top: 0;
 bottom: 0;
 right: 100%;
 opacity: 1;
 }
 66% {
 position: absolute;
 left: 0;
 top: 0;
 bottom: 0;
 right: 0;
 opacity: 0;
 }
 100% {
 position: absolute;
 left: 0;
 top: 0;
 bottom: 0;
 right: 0;
 opacity: 0;
 }
 `)]);
const x$6 = {
  success: h$1R(t$1g, null),
  error: h$1R(C$X, null),
  warning: h$1R(C$Y, null),
  info: h$1R(n$1f, null)
}, H$2 = defineComponent({
  name: "ProgressLine",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    percentage: {
      type: Number,
      default: 0
    },
    railColor: String,
    railStyle: [String, Object],
    fillColor: String,
    status: {
      type: String,
      required: true
    },
    indicatorPlacement: {
      type: String,
      required: true
    },
    indicatorTextColor: String,
    unit: {
      type: String,
      default: "%"
    },
    processing: {
      type: Boolean,
      required: true
    },
    showIndicator: {
      type: Boolean,
      required: true
    },
    height: [String, Number],
    railBorderRadius: [String, Number],
    fillBorderRadius: [String, Number]
  },
  setup(r3, {
    slots: n3
  }) {
    const o3 = computed(() => o$1z(r3.height)), g3 = computed(() => r3.railBorderRadius !== void 0 ? o$1z(r3.railBorderRadius) : r3.height !== void 0 ? o$1z(r3.height, {
      c: 0.5
    }) : ""), f3 = computed(() => r3.fillBorderRadius !== void 0 ? o$1z(r3.fillBorderRadius) : r3.railBorderRadius !== void 0 ? o$1z(r3.railBorderRadius) : r3.height !== void 0 ? o$1z(r3.height, {
      c: 0.5
    }) : "");
    return () => {
      const {
        indicatorPlacement: l3,
        railColor: h3,
        railStyle: m3,
        percentage: d3,
        unit: u3,
        indicatorTextColor: a3,
        status: c3,
        showIndicator: p3,
        fillColor: y3,
        processing: R3,
        clsPrefix: i
      } = r3;
      return h$1R("div", {
        class: `${i}-progress-content`,
        role: "none"
      }, h$1R("div", {
        class: `${i}-progress-graph`,
        "aria-hidden": true
      }, h$1R("div", {
        class: [`${i}-progress-graph-line`, {
          [`${i}-progress-graph-line--indicator-${l3}`]: true
        }]
      }, h$1R("div", {
        class: `${i}-progress-graph-line-rail`,
        style: [{
          backgroundColor: h3,
          height: o3.value,
          borderRadius: g3.value
        }, m3]
      }, h$1R("div", {
        class: [`${i}-progress-graph-line-fill`, R3 && `${i}-progress-graph-line-fill--processing`],
        style: {
          maxWidth: `${r3.percentage}%`,
          backgroundColor: y3,
          height: o3.value,
          lineHeight: o3.value,
          borderRadius: f3.value
        }
      }, l3 === "inside" ? h$1R("div", {
        class: `${i}-progress-graph-line-indicator`,
        style: {
          color: a3
        }
      }, n3.default ? n3.default() : `${d3}${u3}`) : null)))), p3 && l3 === "outside" ? h$1R("div", null, n3.default ? h$1R("div", {
        class: `${i}-progress-custom-content`,
        style: {
          color: a3
        },
        role: "none"
      }, n3.default()) : c3 === "default" ? h$1R("div", {
        role: "none",
        class: `${i}-progress-icon ${i}-progress-icon--as-text`,
        style: {
          color: a3
        }
      }, d3, u3) : h$1R("div", {
        class: `${i}-progress-icon`,
        "aria-hidden": true
      }, h$1R(d$1R, {
        clsPrefix: i
      }, {
        default: () => x$6[c3]
      }))) : null);
    };
  }
});
const C$4 = {
  success: h$1R(t$1g, null),
  error: h$1R(C$X, null),
  warning: h$1R(C$Y, null),
  info: h$1R(n$1f, null)
}, O$4 = defineComponent({
  name: "ProgressCircle",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    strokeWidth: {
      type: Number,
      required: true
    },
    fillColor: String,
    railColor: String,
    railStyle: [String, Object],
    percentage: {
      type: Number,
      default: 0
    },
    offsetDegree: {
      type: Number,
      default: 0
    },
    showIndicator: {
      type: Boolean,
      required: true
    },
    indicatorTextColor: String,
    unit: String,
    viewBoxWidth: {
      type: Number,
      required: true
    },
    gapDegree: {
      type: Number,
      required: true
    },
    gapOffsetDegree: {
      type: Number,
      default: 0
    }
  },
  setup($3, {
    slots: m3
  }) {
    function y3(p3, o3, n3) {
      const {
        gapDegree: l3,
        viewBoxWidth: a3,
        strokeWidth: s3
      } = $3, t3 = 50, u3 = 0, d3 = t3, i = 0, r3 = 2 * t3, c3 = 50 + s3 / 2, g3 = `M ${c3},${c3} m ${u3},${d3}
      a ${t3},${t3} 0 1 1 ${i},${-r3}
      a ${t3},${t3} 0 1 1 ${-i},${r3}`, f3 = Math.PI * 2 * t3, h3 = {
        stroke: n3,
        strokeDasharray: `${p3 / 100 * (f3 - l3)}px ${a3 * 8}px`,
        strokeDashoffset: `-${l3 / 2}px`,
        transformOrigin: o3 ? "center" : void 0,
        transform: o3 ? `rotate(${o3}deg)` : void 0
      };
      return {
        pathString: g3,
        pathStyle: h3
      };
    }
    return () => {
      const {
        fillColor: p3,
        railColor: o3,
        strokeWidth: n3,
        offsetDegree: l3,
        status: a3,
        percentage: s3,
        showIndicator: t3,
        indicatorTextColor: u3,
        unit: d3,
        gapOffsetDegree: i,
        clsPrefix: r3
      } = $3, {
        pathString: c3,
        pathStyle: g3
      } = y3(100, 0, o3), {
        pathString: f3,
        pathStyle: h3
      } = y3(s3, l3, p3), S3 = 100 + n3;
      return h$1R("div", {
        class: `${r3}-progress-content`,
        role: "none"
      }, h$1R("div", {
        class: `${r3}-progress-graph`,
        "aria-hidden": true
      }, h$1R("div", {
        class: `${r3}-progress-graph-circle`,
        style: {
          transform: i ? `rotate(${i}deg)` : void 0
        }
      }, h$1R("svg", {
        viewBox: `0 0 ${S3} ${S3}`
      }, h$1R("g", null, h$1R("path", {
        class: `${r3}-progress-graph-circle-rail`,
        d: c3,
        "stroke-width": n3,
        "stroke-linecap": "round",
        fill: "none",
        style: g3
      })), h$1R("g", null, h$1R("path", {
        class: [`${r3}-progress-graph-circle-fill`, s3 === 0 && `${r3}-progress-graph-circle-fill--empty`],
        d: f3,
        "stroke-width": n3,
        "stroke-linecap": "round",
        fill: "none",
        style: h3
      }))))), t3 ? h$1R("div", null, m3.default ? h$1R("div", {
        class: `${r3}-progress-custom-content`,
        role: "none"
      }, m3.default()) : a3 !== "default" ? h$1R("div", {
        class: `${r3}-progress-icon`,
        "aria-hidden": true
      }, h$1R(d$1R, {
        clsPrefix: r3
      }, {
        default: () => C$4[a3]
      })) : h$1R("div", {
        class: `${r3}-progress-text`,
        style: {
          color: u3
        },
        role: "none"
      }, h$1R("span", {
        class: `${r3}-progress-text__percentage`
      }, s3), h$1R("span", {
        class: `${r3}-progress-text__unit`
      }, d3))) : null);
    };
  }
});
function u$3(e28, c3, i = 100) {
  return `m ${i / 2} ${i / 2 - e28} a ${e28} ${e28} 0 1 1 0 ${2 * e28} a ${e28} ${e28} 0 1 1 0 -${2 * e28}`;
}
const m$3 = defineComponent({
  name: "ProgressMultipleCircle",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    viewBoxWidth: {
      type: Number,
      required: true
    },
    percentage: {
      type: Array,
      default: [0]
    },
    strokeWidth: {
      type: Number,
      required: true
    },
    circleGap: {
      type: Number,
      required: true
    },
    showIndicator: {
      type: Boolean,
      required: true
    },
    fillColor: {
      type: Array,
      default: () => []
    },
    railColor: {
      type: Array,
      default: () => []
    },
    railStyle: {
      type: Array,
      default: () => []
    }
  },
  setup(e28, {
    slots: c3
  }) {
    const i = computed(() => e28.percentage.map((a3, o3) => `${Math.PI * a3 / 100 * (e28.viewBoxWidth / 2 - e28.strokeWidth / 2 * (1 + 2 * o3) - e28.circleGap * o3) * 2}, ${e28.viewBoxWidth * 8}`));
    return () => {
      const {
        viewBoxWidth: l3,
        strokeWidth: a3,
        circleGap: o3,
        showIndicator: p3,
        fillColor: n3,
        railColor: d3,
        railStyle: h3,
        percentage: f3,
        clsPrefix: s3
      } = e28;
      return h$1R("div", {
        class: `${s3}-progress-content`,
        role: "none"
      }, h$1R("div", {
        class: `${s3}-progress-graph`,
        "aria-hidden": true
      }, h$1R("div", {
        class: `${s3}-progress-graph-circle`
      }, h$1R("svg", {
        viewBox: `0 0 ${l3} ${l3}`
      }, f3.map((y3, r3) => h$1R("g", {
        key: r3
      }, h$1R("path", {
        class: `${s3}-progress-graph-circle-rail`,
        d: u$3(l3 / 2 - a3 / 2 * (1 + 2 * r3) - o3 * r3, a3, l3),
        "stroke-width": a3,
        "stroke-linecap": "round",
        fill: "none",
        style: [{
          strokeDashoffset: 0,
          stroke: d3[r3]
        }, h3[r3]]
      }), h$1R("path", {
        class: [`${s3}-progress-graph-circle-fill`, y3 === 0 && `${s3}-progress-graph-circle-fill--empty`],
        d: u$3(l3 / 2 - a3 / 2 * (1 + 2 * r3) - o3 * r3, a3, l3),
        "stroke-width": a3,
        "stroke-linecap": "round",
        fill: "none",
        style: {
          strokeDasharray: i.value[r3],
          strokeDashoffset: 0,
          stroke: n3[r3]
        }
      })))))), p3 && c3.default ? h$1R("div", null, h$1R("div", {
        class: `${s3}-progress-text`
      }, c3.default())) : null);
    };
  }
});
const g$4 = (n3) => {
  const {
    infoColor: o3,
    successColor: r3,
    warningColor: i,
    errorColor: l3,
    textColor2: e28,
    progressRailColor: t3,
    fontSize: c3,
    fontWeight: C3
  } = n3;
  return {
    fontSize: c3,
    fontSizeCircle: "28px",
    fontWeightCircle: C3,
    railColor: t3,
    railHeight: "8px",
    iconSizeCircle: "36px",
    iconSizeLine: "18px",
    iconColor: o3,
    iconColorInfo: o3,
    iconColorSuccess: r3,
    iconColorWarning: i,
    iconColorError: l3,
    textColorCircle: e28,
    textColorLineInner: "rgb(255, 255, 255)",
    textColorLineOuter: e28,
    fillColor: o3,
    fillColorInfo: o3,
    fillColorSuccess: r3,
    fillColorWarning: i,
    fillColorError: l3,
    lineBgProcessing: "linear-gradient(90deg, rgba(255, 255, 255, .3) 0%, rgba(255, 255, 255, .5) 100%)"
  };
}, f$5 = {
  name: "Progress",
  common: d$1T,
  self: g$4
}, p$6 = f$5;
const k$5 = Object.assign(Object.assign({}, _$F.props), {
  processing: Boolean,
  type: {
    type: String,
    default: "line"
  },
  gapDegree: Number,
  gapOffsetDegree: Number,
  status: {
    type: String,
    default: "default"
  },
  railColor: [String, Array],
  railStyle: [String, Array],
  color: [String, Array],
  viewBoxWidth: {
    type: Number,
    default: 100
  },
  strokeWidth: {
    type: Number,
    default: 7
  },
  percentage: [Number, Array],
  unit: {
    type: String,
    default: "%"
  },
  showIndicator: {
    type: Boolean,
    default: true
  },
  indicatorPosition: {
    type: String,
    default: "outside"
  },
  indicatorPlacement: {
    type: String,
    default: "outside"
  },
  indicatorTextColor: String,
  circleGap: {
    type: Number,
    default: 1
  },
  height: Number,
  borderRadius: [String, Number],
  fillBorderRadius: [String, Number],
  offsetDegree: Number
}), J$2 = defineComponent({
  name: "Progress",
  props: k$5,
  setup(e28) {
    const h3 = computed(() => e28.indicatorPlacement || e28.indicatorPosition), c3 = computed(() => {
      if (e28.gapDegree || e28.gapDegree === 0)
        return e28.gapDegree;
      if (e28.type === "dashboard")
        return 75;
    }), {
      mergedClsPrefixRef: o3,
      inlineThemeDisabled: n3
    } = a$2x(e28), s3 = _$F("Progress", "-progress", t$4, p$6, e28, o3), l3 = computed(() => {
      const {
        status: t3
      } = e28, {
        common: {
          cubicBezierEaseInOut: d3
        },
        self: {
          fontSize: g3,
          fontSizeCircle: C3,
          railColor: u3,
          railHeight: y3,
          iconSizeCircle: b3,
          iconSizeLine: x3,
          textColorCircle: S3,
          textColorLineInner: P3,
          textColorLineOuter: i,
          lineBgProcessing: f3,
          fontWeightCircle: v3,
          [_$H("iconColor", t3)]: D3,
          [_$H("fillColor", t3)]: a3
        }
      } = s3.value;
      return {
        "--n-bezier": d3,
        "--n-fill-color": a3,
        "--n-font-size": g3,
        "--n-font-size-circle": C3,
        "--n-font-weight-circle": v3,
        "--n-icon-color": D3,
        "--n-icon-size-circle": b3,
        "--n-icon-size-line": x3,
        "--n-line-bg-processing": f3,
        "--n-rail-color": u3,
        "--n-rail-height": y3,
        "--n-text-color-circle": S3,
        "--n-text-color-line-inner": P3,
        "--n-text-color-line-outer": i
      };
    }), r3 = n3 ? E$J("progress", computed(() => e28.status[0]), l3, e28) : void 0;
    return {
      mergedClsPrefix: o3,
      mergedIndicatorPlacement: h3,
      gapDeg: c3,
      cssVars: n3 ? void 0 : l3,
      themeClass: r3 == null ? void 0 : r3.themeClass,
      onRender: r3 == null ? void 0 : r3.onRender
    };
  },
  render() {
    const {
      type: e28,
      cssVars: h3,
      indicatorTextColor: c3,
      showIndicator: o3,
      status: n3,
      railColor: s3,
      railStyle: l3,
      color: r3,
      percentage: t3,
      viewBoxWidth: d3,
      strokeWidth: g3,
      mergedIndicatorPlacement: C3,
      unit: u3,
      borderRadius: y3,
      fillBorderRadius: b3,
      height: x3,
      processing: S3,
      circleGap: P3,
      mergedClsPrefix: i,
      gapDeg: f3,
      gapOffsetDegree: v3,
      themeClass: D3,
      $slots: a3,
      onRender: R3
    } = this;
    return R3 == null || R3(), h$1R("div", {
      class: [D3, `${i}-progress`, `${i}-progress--${e28}`, `${i}-progress--${n3}`],
      style: h3,
      "aria-valuemax": 100,
      "aria-valuemin": 0,
      "aria-valuenow": t3,
      role: e28 === "circle" || e28 === "line" || e28 === "dashboard" ? "progressbar" : "none"
    }, e28 === "circle" || e28 === "dashboard" ? h$1R(O$4, {
      clsPrefix: i,
      status: n3,
      showIndicator: o3,
      indicatorTextColor: c3,
      railColor: s3,
      fillColor: r3,
      railStyle: l3,
      offsetDegree: this.offsetDegree,
      percentage: t3,
      viewBoxWidth: d3,
      strokeWidth: g3,
      gapDegree: f3 === void 0 ? e28 === "dashboard" ? 75 : 0 : f3,
      gapOffsetDegree: v3,
      unit: u3
    }, a3) : e28 === "line" ? h$1R(H$2, {
      clsPrefix: i,
      status: n3,
      showIndicator: o3,
      indicatorTextColor: c3,
      railColor: s3,
      fillColor: r3,
      railStyle: l3,
      percentage: t3,
      processing: S3,
      indicatorPlacement: C3,
      unit: u3,
      fillBorderRadius: b3,
      railBorderRadius: y3,
      height: x3
    }, a3) : e28 === "multiple-circle" ? h$1R(m$3, {
      clsPrefix: i,
      strokeWidth: g3,
      railColor: s3,
      fillColor: r3,
      railStyle: l3,
      viewBoxWidth: d3,
      percentage: t3,
      showIndicator: o3,
      circleGap: P3
    }, a3) : null);
  }
});
const y$6 = { key: 1 }, p$5 = {
  class: "n-progress-text",
  role: "none"
}, h$6 = { class: "n-progress-text__percentage" }, m$2 = /* @__PURE__ */ createElementVNode("span", { class: "n-progress-text__unit" }, "%", -1), b$5 = defineComponent({
  name: "UIProgress",
  inheritAttrs: false
}), S$3 = defineComponent(__spreadProps(__spreadValues({}, b$5), {
  props: {
    percentage: {
      type: Number
    },
    type: {
      type: String,
      default: "line"
    },
    processing: {
      type: Boolean
    },
    indicatorPlacement: {
      type: String,
      default: "inside"
    },
    status: {
      type: String
    },
    showIndicator: {
      type: Boolean,
      default: void 0
    },
    borderRadius: {
      type: [Number, String],
      default: void 0
    },
    circleGap: {
      type: Number,
      default: 1
    },
    color: {
      type: [String, Array],
      default: void 0
    },
    fillBorderRadius: {
      type: [Number, String],
      default: void 0
    },
    gapDegree: {
      type: Number,
      default: 75
    },
    gapOffsetDegree: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: void 0
    },
    indicatorTextColor: {
      type: String,
      default: void 0
    },
    offsetDegress: {
      type: Number,
      default: 0
    },
    railColor: {
      type: [String, Array],
      default: void 0
    },
    railStyle: {
      type: [String, Object, Array],
      default: void 0
    },
    strokeWidth: {
      type: Number,
      default: 7
    },
    unit: {
      type: String,
      default: "%"
    }
  },
  setup(e28) {
    const a3 = useSlots();
    return (l3, N3) => (openBlock(), createBlock(unref(J$2), {
      "indicator-placement": e28.indicatorPlacement,
      percentage: e28.percentage,
      processing: e28.processing,
      "show-indicator": e28.showIndicator,
      status: e28.status,
      type: e28.type,
      "gap-position": "bottom",
      "border-radius": e28.borderRadius,
      "circle-gap": e28.circleGap,
      color: e28.color,
      "fill-border-radius": e28.fillBorderRadius,
      "gap-degree": e28.gapDegree,
      "gap-offset-degree": e28.gapOffsetDegree,
      height: e28.height,
      "indicator-text-color": e28.indicatorTextColor,
      "offset-degress": e28.offsetDegress,
      "rail-color": e28.railColor,
      "rail-style": e28.railStyle,
      "stroke-width": e28.strokeWidth,
      unit: e28.unit
    }, {
      default: withCtx(() => [
        unref(a3).default ? renderSlot(l3.$slots, "default", { key: 0 }) : (openBlock(), createElementBlock("div", y$6, [
          createElementVNode("div", p$5, [
            createElementVNode("span", h$6, toDisplayString(e28.percentage), 1),
            m$2
          ])
        ]))
      ]),
      _: 3
    }, 8, ["indicator-placement", "percentage", "processing", "show-indicator", "status", "type", "border-radius", "circle-gap", "color", "fill-border-radius", "gap-degree", "gap-offset-degree", "height", "indicator-text-color", "offset-degress", "rail-color", "rail-style", "stroke-width", "unit"]));
  }
})), x$5 = S$3;
const u$2 = defineComponent({
  name: "RadioButton",
  props: T$F,
  setup: _$w,
  render() {
    const {
      mergedClsPrefix: e28
    } = this;
    return h$1R("label", {
      class: [`${e28}-radio-button`, this.mergedDisabled && `${e28}-radio-button--disabled`, this.renderSafeChecked && `${e28}-radio-button--checked`, this.focus && [`${e28}-radio-button--focus`]]
    }, h$1R("input", {
      ref: "inputRef",
      type: "radio",
      class: `${e28}-radio-input`,
      value: this.value,
      name: this.mergedName,
      checked: this.renderSafeChecked,
      disabled: this.mergedDisabled,
      onChange: this.handleRadioInputChange,
      onFocus: this.handleRadioInputFocus,
      onBlur: this.handleRadioInputBlur
    }), h$1R("div", {
      class: `${e28}-radio-button__state-border`
    }), m$26(this.$slots.default, (a3) => !a3 && !this.label ? null : h$1R("div", {
      ref: "labelRef",
      class: `${e28}-radio__label`
    }, a3 || this.label)));
  }
});
const b$4 = { class: "hl-radio-group-item-container" }, B$5 = {
  key: 0,
  class: "hl-radio-group-item-icon"
}, g$3 = {
  key: 1,
  class: "hl-radio-group-item-content"
}, N$3 = { class: "hl-radio-group-item-action" }, _$4 = defineComponent({
  name: "UIRadioButton",
  inheritAttrs: false
}), k$4 = defineComponent(__spreadProps(__spreadValues({}, _$4), {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Boolean]
    },
    compact: Boolean
  },
  setup(e28) {
    const l3 = useSlots();
    return (o3, y3) => (openBlock(), createBlock(unref(u$2), mergeProps(o3.$attrs, {
      value: e28.value,
      disabled: e28.disabled,
      class: ["hl-radio-group-item", e28.compact ? "compact-radio-item" : null]
    }), {
      default: withCtx(() => [
        createElementVNode("div", b$4, [
          unref(l3).icon ? (openBlock(), createElementBlock("div", B$5, [
            renderSlot(o3.$slots, "icon")
          ])) : createCommentVNode("", true),
          unref(l3).content ? (openBlock(), createElementBlock("div", g$3, [
            renderSlot(o3.$slots, "content")
          ])) : createCommentVNode("", true),
          createElementVNode("div", N$3, [
            createVNode(unref(Y$l), {
              value: e28.value,
              disabled: e28.disabled
            }, null, 8, ["value", "disabled"])
          ])
        ])
      ]),
      _: 3
    }, 16, ["value", "disabled", "class"]));
  }
})), V$4 = k$4;
const a$3 = r$2a([l$25("skeleton", `
 height: 1em;
 width: 100%;
 transition:
 --n-color-start .3s var(--n-bezier),
 --n-color-end .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 animation: 2s skeleton-loading infinite cubic-bezier(0.36, 0, 0.64, 1);
 background-color: var(--n-color-start);
 `), r$2a("@keyframes skeleton-loading", `
 0% {
 background: var(--n-color-start);
 }
 40% {
 background: var(--n-color-end);
 }
 80% {
 background: var(--n-color-start);
 }
 100% {
 background: var(--n-color-start);
 }
 `)]);
const h$5 = (e28) => {
  const {
    heightSmall: o3,
    heightMedium: t3,
    heightLarge: n3,
    borderRadius: r3
  } = e28;
  return {
    color: "#eee",
    colorEnd: "#ddd",
    borderRadius: r3,
    heightSmall: o3,
    heightMedium: t3,
    heightLarge: n3
  };
}, c$a = {
  name: "Skeleton",
  common: d$1T,
  self: h$5
};
let i$3 = false;
function t$3() {
  if (e$1O && window.CSS && !i$3 && (i$3 = true, "registerProperty" in (window == null ? void 0 : window.CSS)))
    try {
      CSS.registerProperty({
        name: "--n-color-start",
        syntax: "<color>",
        inherits: false,
        initialValue: "#0000"
      }), CSS.registerProperty({
        name: "--n-color-end",
        syntax: "<color>",
        inherits: false,
        initialValue: "#0000"
      });
    } catch {
    }
}
const E$4 = Object.assign(Object.assign({}, _$F.props), {
  text: Boolean,
  round: Boolean,
  circle: Boolean,
  height: [String, Number],
  width: [String, Number],
  size: String,
  repeat: {
    type: Number,
    default: 1
  },
  animated: {
    type: Boolean,
    default: true
  },
  sharp: {
    type: Boolean,
    default: true
  }
}), D$3 = defineComponent({
  name: "Skeleton",
  inheritAttrs: false,
  props: E$4,
  setup(t3) {
    t$3();
    const {
      mergedClsPrefixRef: n3
    } = a$2x(t3), i = _$F("Skeleton", "-skeleton", a$3, c$a, t3, n3);
    return {
      mergedClsPrefix: n3,
      style: computed(() => {
        var r3, o3;
        const s3 = i.value, {
          common: {
            cubicBezierEaseInOut: y3
          }
        } = s3, c3 = s3.self, {
          color: k3,
          colorEnd: v3,
          borderRadius: x3
        } = c3;
        let l3;
        const {
          circle: m3,
          sharp: B3,
          round: P3,
          width: e28,
          height: a3,
          size: p3,
          text: f3,
          animated: S3
        } = t3;
        p3 !== void 0 && (l3 = c3[_$H("height", p3)]);
        const d3 = m3 ? (r3 = e28 != null ? e28 : a3) !== null && r3 !== void 0 ? r3 : l3 : e28, u3 = (o3 = m3 ? e28 != null ? e28 : a3 : a3) !== null && o3 !== void 0 ? o3 : l3;
        return {
          display: f3 ? "inline-block" : "",
          verticalAlign: f3 ? "-0.125em" : "",
          borderRadius: m3 ? "50%" : P3 ? "4096px" : B3 ? "" : x3,
          width: typeof d3 == "number" ? o$1f(d3) : d3,
          height: typeof u3 == "number" ? o$1f(u3) : u3,
          animation: S3 ? "" : "none",
          "--n-bezier": y3,
          "--n-color-start": k3,
          "--n-color-end": v3
        };
      })
    };
  },
  render() {
    const {
      repeat: t3,
      style: n3,
      mergedClsPrefix: i,
      $attrs: r3
    } = this, o3 = h$1R("div", mergeProps({
      class: `${i}-skeleton`,
      style: n3
    }, r3));
    return t3 > 1 ? h$1R(Fragment, null, o$1G(t3, null).map((s3) => [o3, `
`])) : o3;
  }
});
const d$3 = defineComponent({
  name: "UISkeleton",
  inheritAttrs: false
}), u$1 = defineComponent(__spreadProps(__spreadValues({}, d$3), {
  props: {
    text: {
      type: Boolean,
      default: true
    },
    repeat: {
      type: Number,
      default: 1
    },
    width: {
      type: [String, Number],
      default: void 0
    },
    height: {
      type: [String, Number],
      default: void 0
    },
    animated: {
      type: Boolean,
      default: true
    },
    circle: {
      type: Boolean,
      default: false
    }
  },
  setup(e28) {
    return (a3, c3) => (openBlock(), createBlock(unref(D$3), mergeProps(a3.$attrs, {
      text: e28.text,
      repeat: e28.repeat,
      width: e28.width,
      height: e28.height,
      animated: e28.animated,
      circle: e28.circle
    }), null, 16, ["text", "repeat", "width", "height", "animated", "circle"]));
  }
})), h$4 = u$1;
const ae$1 = {
  key: 0,
  class: "title"
}, se$1 = {
  key: 1,
  class: "sort-filter-component__button__badge"
}, ne$1 = { class: "sort-filter-component__container" }, ie$1 = { class: "sort-filter-component__header" }, ce$1 = { class: "sort-filter-component__header__title" }, de$1 = {
  key: 0,
  class: "sort-filter-component__sort-wrapper"
}, ue$1 = { class: "sort-filter-component__heading" }, fe$1 = ["onClick"], pe$1 = {
  key: 1,
  class: "sort-filter-component__filter-wrapper"
}, me$2 = { class: "sort-filter-component__heading" }, ve$1 = { class: "sort-filter-component__filter-item-heading" }, ge$2 = { class: "sort-filter-component__cta-wrapper" }, ye$2 = {
  name: "UISortFilter",
  inheritAttrs: false
}, _e$1 = defineComponent(__spreadProps(__spreadValues({}, ye$2), {
  props: {
    id: {
      type: String,
      required: true
    },
    triggerLabel: {
      type: String,
      default: void 0,
      required: false
    },
    title: {
      type: String,
      default: null,
      required: false
    },
    trigger: {
      type: String,
      default: "click"
    },
    placement: {
      type: String,
      default: "bottom-end"
    },
    show: {
      type: Boolean,
      default: void 0
    },
    showArrow: {
      type: Boolean,
      default: false
    },
    sortOptions: {
      type: Array,
      default: () => []
    },
    sortSelectedValue: {
      type: Object,
      default: () => ({})
    },
    filterOptions: {
      type: Array,
      default: () => []
    },
    filterSelectedValue: {
      type: Object,
      default: () => ({})
    },
    icon: {
      type: Function,
      default: c$1A
    },
    dotColor: {
      type: String,
      default: void 0
    },
    sortHeading: {
      type: String,
      default: void 0
    },
    filterHeading: {
      type: String,
      default: void 0
    }
  },
  emits: ["onApply", "onClear", "onSelect"],
  setup(l3, { emit: B3 }) {
    const f3 = l3, w3 = B3, P3 = useSlots(), o3 = s$1v("SortFilter"), F3 = ref$1(), s3 = ref$1(f3.filterSelectedValue), n3 = ref$1({
      label: f3.sortSelectedValue.label,
      sortType: f3.sortSelectedValue.sortType
    }), c3 = ref$1({
      sort: {
        label: f3.sortSelectedValue.label,
        sortType: f3.sortSelectedValue.sortType
      },
      filter: f3.filterSelectedValue
    }), x3 = {
      clearable: true,
      placeholder: "Please Select"
    }, m3 = ref$1(0), h3 = {
      string: [o3.value.aToZ, o3.value.zToA],
      number: [o3.value.ascending, o3.value.descending],
      date: [o3.value.newestFirst, o3.value.oldestFirst]
    }, H3 = (t3) => {
      n3.value = {
        label: t3.label,
        sortType: h3[t3.type][0]
      }, m3.value = 0;
    }, z3 = (t3) => {
      const i = (m3.value + 1) % 2;
      m3.value = i, n3.value = {
        label: t3.label,
        sortType: h3[t3.type][m3.value]
      };
    }, N3 = (t3) => {
      var i;
      return s3.value[t3] ? ((i = s3.value[t3]) == null ? void 0 : i.value) || "" : [];
    }, D3 = (t3, i, e28) => {
      Array.isArray(e28) && e28.length === 0 && s3.value[t3] || e28 === null ? delete s3.value[t3] : s3.value[t3] = { label: i, value: e28 }, w3("onSelect", { key: t3, label: i, value: e28 });
    }, L3 = () => {
      const t3 = __spreadValues(__spreadValues({}, n3.value.label !== "" && { sort: n3.value }), Object.keys(s3.value).length > 0 && {
        filter: s3.value
      });
      c3.value.sort = L$A(n3.value), c3.value.filter = L$A(s3.value), w3("onApply", t3), C3();
    }, C3 = () => {
      F3.value.handleClick();
    }, R3 = (t3) => __spreadValues(__spreadValues({}, x3), t3), $3 = () => {
      n3.value = {
        label: "",
        sortType: ""
      }, s3.value = {}, c3.value = {
        sort: {
          label: "",
          sortType: ""
        },
        filter: {}
      }, w3("onClear"), C3();
    }, I3 = () => {
      const t3 = f3.sortOptions.filter((i) => i.label === c3.value.sort.label);
      t3.length && (m3.value = h3[t3[0].type].indexOf(c3.value.sort.sortType)), n3.value = L$A(c3.value.sort), s3.value = L$A(c3.value.filter);
    }, q3 = () => {
      I3(), C3();
    }, E3 = () => {
      I3();
    };
    return watchEffect(() => console.log(f3.filterOptions)), (t3, i) => (openBlock(), createBlock(unref(Ie$8), {
      class: "sort-filter-component",
      trigger: l3.trigger,
      "show-arrow": l3.showArrow,
      show: l3.show,
      ref_key: "popoverRef",
      ref: F3,
      placement: l3.placement,
      id: l3.id,
      raw: "",
      "on-clickoutside": E3
    }, {
      trigger: withCtx(() => [
        unref(P3).trigger ? renderSlot(t3.$slots, "trigger", { key: 0 }) : (openBlock(), createBlock(unref(q$C), {
          key: 1,
          size: "large",
          class: "sort-filter-component__button",
          id: "sort-filter-component__button"
        }, {
          default: withCtx(() => [
            (openBlock(), createBlock(resolveDynamicComponent(l3.icon), { class: "sort-filter-component__button__icon" })),
            l3.triggerLabel ? (openBlock(), createElementBlock("span", ae$1, toDisplayString(l3.triggerLabel), 1)) : createCommentVNode("", true),
            c3.value.sort.label || Object.keys(c3.value.filter).length ? (openBlock(), createElementBlock("div", se$1, [
              createVNode(unref(p$32), {
                color: l3.dotColor,
                id: "sort-filter-component__button__badge",
                dot: ""
              }, null, 8, ["color"])
            ])) : createCommentVNode("", true)
          ]),
          _: 1
        }))
      ]),
      default: withCtx(() => {
        var _a2, _b2, _c2;
        return [
          createElementVNode("div", ne$1, [
            createElementVNode("div", ie$1, [
              createElementVNode("span", ce$1, toDisplayString((_a2 = l3.title) != null ? _a2 : unref(o3).heading), 1),
              createVNode(unref(q$C), {
                text: "",
                onClick: $3,
                class: "sort-filter-component__header__reset",
                id: "sort-filter-component-reset"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(o3).clear), 1)
                ]),
                _: 1
              })
            ]),
            l3.sortOptions.length ? (openBlock(), createElementBlock("div", de$1, [
              createElementVNode("div", ue$1, toDisplayString((_b2 = l3.sortHeading) != null ? _b2 : unref(o3).sortHeading), 1),
              (openBlock(true), createElementBlock(Fragment, null, renderList(l3.sortOptions, (e28, T3) => {
                var y3, S3;
                return openBlock(), createElementBlock("div", {
                  class: "sort-filter-component__sort-item",
                  key: T3
                }, [
                  createVNode(unref(c$1D), {
                    value: e28.label,
                    label: e28.label,
                    id: e28.label,
                    checked: e28.label === ((y3 = n3.value) == null ? void 0 : y3.label),
                    onChange: (Z3) => H3(e28)
                  }, null, 8, ["value", "label", "id", "checked", "onChange"]),
                  e28.label === ((S3 = n3.value) == null ? void 0 : S3.label) ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: "sort-filter-component__sort-type",
                    onClick: (Z3) => z3(e28)
                  }, toDisplayString(h3[e28.type][m3.value]), 9, fe$1)) : createCommentVNode("", true)
                ]);
              }), 128))
            ])) : createCommentVNode("", true),
            l3.filterOptions.length ? (openBlock(), createElementBlock("div", pe$1, [
              createElementVNode("div", me$2, toDisplayString((_c2 = l3.filterHeading) != null ? _c2 : unref(o3).filters), 1),
              (openBlock(true), createElementBlock(Fragment, null, renderList(l3.filterOptions, (e28, T3) => {
                var y3;
                return openBlock(), createElementBlock("div", {
                  key: T3,
                  class: "sort-filter-component__filter-item"
                }, [
                  createElementVNode("div", ve$1, toDisplayString(e28.label), 1),
                  createVNode(unref(I$y), mergeProps(e28 != null && e28.config ? R3(e28.config.props) : x3, {
                    options: e28.options,
                    id: e28.label,
                    value: N3(e28.key),
                    "onUpdate:value": (S3) => D3(e28.key, e28.label, S3),
                    size: "medium"
                  }, toHandlers((y3 = e28 == null ? void 0 : e28.config) == null ? void 0 : y3.methods)), null, 16, ["options", "id", "value", "onUpdate:value"])
                ]);
              }), 128))
            ])) : createCommentVNode("", true),
            createElementVNode("div", ge$2, [
              createVNode(unref(q$C), {
                id: "sort-filter-component__cancel-btn",
                class: "cta-btn",
                size: "small",
                onClick: q3
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(o3).cancel), 1)
                ]),
                _: 1
              }),
              createVNode(unref(q$C), {
                id: "sort-filter-component__apply-btn",
                class: "cta-btn",
                disabled: !(n3.value.label || Object.keys(s3.value).length),
                size: "small",
                type: "primary",
                onClick: L3
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(o3).apply), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ];
      }),
      _: 3
    }, 8, ["trigger", "show-arrow", "show", "placement", "id"]));
  }
})), je$1 = _e$1;
const s$3 = defineComponent({
  name: "UISpace",
  inheritAttrs: false
}), c$9 = defineComponent(__spreadProps(__spreadValues({}, s$3), {
  props: {
    align: {
      type: String,
      default: void 0
    },
    inline: {
      type: Boolean,
      default: false
    },
    wrapItem: {
      type: Boolean,
      default: true
    },
    justify: {
      type: String,
      default: "start"
    },
    size: {
      type: String,
      default: "medium"
    },
    vertical: {
      type: Boolean,
      default: false
    },
    wrap: {
      type: Boolean,
      default: true
    }
  },
  setup(e28) {
    return (t3, d3) => (openBlock(), createBlock(unref(q$7), mergeProps(t3.$attrs, {
      align: e28.align,
      inline: e28.inline,
      "wrap-item": e28.wrapItem,
      justify: e28.justify,
      size: e28.size,
      vertical: e28.vertical,
      wrap: e28.wrap
    }), {
      default: withCtx(() => [
        renderSlot(t3.$slots, "default")
      ]),
      _: 3
    }, 16, ["align", "inline", "wrap-item", "justify", "size", "vertical", "wrap"]));
  }
})), y$5 = c$9;
const s$2 = r$2a([r$2a("@keyframes spin-rotate", `
 from {
 transform: rotate(0);
 }
 to {
 transform: rotate(360deg);
 }
 `), l$25("spin-container", `
 position: relative;
 `, [l$25("spin-body", `
 position: absolute;
 top: 50%;
 left: 50%;
 transform: translateX(-50%) translateY(-50%);
 `, [l$1T()])]), l$25("spin-body", `
 display: inline-flex;
 align-items: center;
 justify-content: center;
 flex-direction: column;
 `), l$25("spin", `
 display: inline-flex;
 height: var(--n-size);
 width: var(--n-size);
 font-size: var(--n-size);
 color: var(--n-color);
 `, [g$1j("rotate", `
 animation: spin-rotate 2s linear infinite;
 `)]), l$25("spin-description", `
 display: inline-block;
 font-size: var(--n-font-size);
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 margin-top: 8px;
 `), l$25("spin-content", `
 opacity: 1;
 transition: opacity .3s var(--n-bezier);
 pointer-events: all;
 `, [g$1j("spinning", `
 user-select: none;
 -webkit-user-select: none;
 pointer-events: none;
 opacity: var(--n-opacity-spinning);
 `)])]);
const a$2 = (e28) => {
  const {
    opacityDisabled: t3,
    heightTiny: o3,
    heightSmall: n3,
    heightMedium: s3,
    heightLarge: g3,
    heightHuge: h3,
    primaryColor: i,
    fontSize: m3
  } = e28;
  return {
    fontSize: m3,
    textColor: i,
    sizeTiny: o3,
    sizeSmall: n3,
    sizeMedium: s3,
    sizeLarge: g3,
    sizeHuge: h3,
    color: i,
    opacitySpinning: t3
  };
}, l$4 = {
  name: "Spin",
  common: d$1T,
  self: a$2
}, p$4 = l$4;
const V$3 = {
  small: 20,
  medium: 18,
  large: 16
}, B$4 = Object.assign(Object.assign({}, _$F.props), {
  contentClass: String,
  contentStyle: [Object, String],
  description: String,
  stroke: String,
  size: {
    type: [String, Number],
    default: "medium"
  },
  show: {
    type: Boolean,
    default: true
  },
  strokeWidth: Number,
  rotate: {
    type: Boolean,
    default: true
  },
  spinning: {
    type: Boolean,
    validator: () => true,
    default: void 0
  },
  delay: Number
}), A$4 = defineComponent({
  name: "Spin",
  props: B$4,
  setup(e28) {
    const {
      mergedClsPrefixRef: a3,
      inlineThemeDisabled: t3
    } = a$2x(e28), i = _$F("Spin", "-spin", s$2, p$4, e28, a3), c3 = computed(() => {
      const {
        size: s3
      } = e28, {
        common: {
          cubicBezierEaseInOut: r3
        },
        self: m3
      } = i.value, {
        opacitySpinning: h3,
        color: v3,
        textColor: g3
      } = m3, y3 = typeof s3 == "number" ? o$1f(s3) : m3[_$H("size", s3)];
      return {
        "--n-bezier": r3,
        "--n-opacity-spinning": h3,
        "--n-size": y3,
        "--n-color": v3,
        "--n-text-color": g3
      };
    }), n3 = t3 ? E$J("spin", computed(() => {
      const {
        size: s3
      } = e28;
      return typeof s3 == "number" ? String(s3) : s3[0];
    }), c3, e28) : void 0, d3 = f$1j(e28, ["spinning", "show"]), l3 = ref$1(false);
    return watchEffect((s3) => {
      let r3;
      if (d3.value) {
        const {
          delay: m3
        } = e28;
        if (m3) {
          r3 = window.setTimeout(() => {
            l3.value = true;
          }, m3), s3(() => {
            clearTimeout(r3);
          });
          return;
        }
      }
      l3.value = d3.value;
    }), {
      mergedClsPrefix: a3,
      active: l3,
      mergedStrokeWidth: computed(() => {
        const {
          strokeWidth: s3
        } = e28;
        if (s3 !== void 0)
          return s3;
        const {
          size: r3
        } = e28;
        return V$3[typeof r3 == "number" ? "medium" : r3];
      }),
      cssVars: t3 ? void 0 : c3,
      themeClass: n3 == null ? void 0 : n3.themeClass,
      onRender: n3 == null ? void 0 : n3.onRender
    };
  },
  render() {
    var e28, a3;
    const {
      $slots: t3,
      mergedClsPrefix: i,
      description: c3
    } = this, n3 = t3.icon && this.rotate, d3 = (c3 || t3.description) && h$1R("div", {
      class: `${i}-spin-description`
    }, c3 || ((e28 = t3.description) === null || e28 === void 0 ? void 0 : e28.call(t3))), l3 = t3.icon ? h$1R("div", {
      class: [`${i}-spin-body`, this.themeClass]
    }, h$1R("div", {
      class: [`${i}-spin`, n3 && `${i}-spin--rotate`],
      style: t3.default ? "" : this.cssVars
    }, t3.icon()), d3) : h$1R("div", {
      class: [`${i}-spin-body`, this.themeClass]
    }, h$1R(h$1A, {
      clsPrefix: i,
      style: t3.default ? "" : this.cssVars,
      stroke: this.stroke,
      "stroke-width": this.mergedStrokeWidth,
      class: `${i}-spin`
    }), d3);
    return (a3 = this.onRender) === null || a3 === void 0 || a3.call(this), t3.default ? h$1R("div", {
      class: [`${i}-spin-container`, this.themeClass],
      style: this.cssVars
    }, h$1R("div", {
      class: [`${i}-spin-content`, this.active && `${i}-spin-content--spinning`, this.contentClass],
      style: this.contentStyle
    }, t3), h$1R(Transition, {
      name: "fade-in-transition"
    }, {
      default: () => this.active ? l3 : null
    })) : l3;
  }
});
const d$2 = defineComponent({
  name: "UISpin",
  inheritAttrs: false
}), c$8 = defineComponent(__spreadProps(__spreadValues({}, d$2), {
  props: {
    size: {
      type: [String, Number],
      default: "medium"
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  setup(e28) {
    const n3 = useSlots();
    return (t3, h3) => (openBlock(), createBlock(unref(A$4), mergeProps(t3.$attrs, {
      show: e28.show,
      size: e28.size
    }), createSlots({ _: 2 }, [
      unref(n3).default ? {
        name: "default",
        fn: withCtx(() => [
          renderSlot(t3.$slots, "default")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["show", "size"]));
  }
})), _$3 = c$8;
const B$3 = { class: "hl-statistic" }, C$3 = { class: "hl-statistic-header" }, T$3 = {
  key: 0,
  class: "hl-statistic-action"
}, G$2 = { class: "hl-content" }, N$2 = { class: "hl-container" }, V$2 = {
  key: 0,
  class: "trend trend-container"
}, _$2 = { key: 1 }, q$3 = { key: 0 }, D$2 = { key: 0 }, A$3 = {
  key: 0,
  class: "badge badge--positive"
}, E$3 = { key: 1 }, z$2 = {
  key: 0,
  class: "badge badge--negative"
}, F$3 = { key: 1 }, M$2 = defineComponent({
  name: "UIStatistic",
  inheritAttrs: false
}), j$1 = defineComponent(__spreadProps(__spreadValues({}, M$2), {
  props: {
    id: {
      type: String,
      required: true
    },
    icon: {
      type: Function
    },
    title: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "success"
    },
    trendTitle: {
      type: String,
      default: ""
    },
    showGraph: {
      type: Boolean,
      default: false,
      required: false
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  emits: ["select"],
  setup(t3) {
    const n3 = useSlots();
    return (d3, u3) => {
      var h3;
      return openBlock(), createElementBlock("div", B$3, [
        createElementVNode("div", C$3, [
          createElementVNode("div", null, [
            (h3 = unref(n3)) != null && h3.icon ? (openBlock(), createBlock(unref(C$14), {
              key: 0,
              type: "success"
            }, {
              default: withCtx(() => [
                renderSlot(d3.$slots, "icon")
              ]),
              _: 3
            })) : createCommentVNode("", true),
            createVNode(unref(d$1H), { class: "title" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(t3.title), 1)
              ]),
              _: 1
            })
          ]),
          t3.options.length ? (openBlock(), createElementBlock("div", T$3, [
            createVNode(unref(g$Q), {
              options: t3.options,
              onSelect: u3[0] || (u3[0] = (f3) => d3.$emit("select", f3)),
              id: `${t3.id}-dropdown`
            }, {
              default: withCtx(() => [
                createVNode(unref(q$C), {
                  circle: "",
                  quaternary: "",
                  id: `${t3.id}-dropdown-trigger`
                }, {
                  default: withCtx(() => [
                    createVNode(unref(l$19), { class: "w-5 h-5" })
                  ]),
                  _: 1
                }, 8, ["id"])
              ]),
              _: 1
            }, 8, ["options", "id"])
          ])) : createCommentVNode("", true)
        ]),
        createElementVNode("div", G$2, [
          createElementVNode("div", N$2, [
            createVNode(unref(c$1S), null, {
              default: withCtx(() => [
                renderSlot(d3.$slots, "default")
              ]),
              _: 3
            }),
            t3.showGraph ? (openBlock(), createElementBlock("div", V$2, [
              unref(n3).badge ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass({
                  "trend trend--success": t3.type === "success",
                  "trend trend--error": t3.type === "error"
                })
              }, [
                renderSlot(d3.$slots, "badge")
              ], 2)) : createCommentVNode("", true),
              t3.trendTitle ? (openBlock(), createElementBlock("div", _$2, toDisplayString(t3.trendTitle), 1)) : createCommentVNode("", true)
            ])) : createCommentVNode("", true)
          ]),
          t3.showGraph ? createCommentVNode("", true) : (openBlock(), createElementBlock("div", q$3, [
            t3.type === "success" ? (openBlock(), createElementBlock("div", D$2, [
              unref(n3).badge ? (openBlock(), createElementBlock("div", A$3, [
                renderSlot(d3.$slots, "badge")
              ])) : createCommentVNode("", true)
            ])) : createCommentVNode("", true),
            t3.type === "error" ? (openBlock(), createElementBlock("div", E$3, [
              unref(n3).badge ? (openBlock(), createElementBlock("div", z$2, [
                renderSlot(d3.$slots, "badge")
              ])) : createCommentVNode("", true)
            ])) : createCommentVNode("", true)
          ])),
          t3.showGraph && unref(n3).graph ? (openBlock(), createElementBlock("div", F$3, [
            renderSlot(d3.$slots, "graph")
          ])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
})), Z$3 = j$1;
const s$1 = l$25("switch", `
 height: var(--n-height);
 min-width: var(--n-width);
 vertical-align: middle;
 user-select: none;
 -webkit-user-select: none;
 display: inline-flex;
 outline: none;
 justify-content: center;
 align-items: center;
`, [M$y("children-placeholder", `
 height: var(--n-rail-height);
 display: flex;
 flex-direction: column;
 overflow: hidden;
 pointer-events: none;
 visibility: hidden;
 `), M$y("rail-placeholder", `
 display: flex;
 flex-wrap: none;
 `), M$y("button-placeholder", `
 width: calc(1.75 * var(--n-rail-height));
 height: var(--n-rail-height);
 `), l$25("base-loading", `
 position: absolute;
 top: 50%;
 left: 50%;
 transform: translateX(-50%) translateY(-50%);
 font-size: calc(var(--n-button-width) - 4px);
 color: var(--n-loading-color);
 transition: color .3s var(--n-bezier);
 `, [m$22({
  left: "50%",
  top: "50%",
  originalTransform: "translateX(-50%) translateY(-50%)"
})]), M$y("checked, unchecked", `
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 box-sizing: border-box;
 position: absolute;
 white-space: nowrap;
 top: 0;
 bottom: 0;
 display: flex;
 align-items: center;
 line-height: 1;
 `), M$y("checked", `
 right: 0;
 padding-right: calc(1.25 * var(--n-rail-height) - var(--n-offset));
 `), M$y("unchecked", `
 left: 0;
 justify-content: flex-end;
 padding-left: calc(1.25 * var(--n-rail-height) - var(--n-offset));
 `), r$2a("&:focus", [M$y("rail", `
 box-shadow: var(--n-box-shadow-focus);
 `)]), g$1j("round", [M$y("rail", "border-radius: calc(var(--n-rail-height) / 2);", [M$y("button", "border-radius: calc(var(--n-button-height) / 2);")])]), x$I("disabled", [x$I("icon", [g$1j("rubber-band", [g$1j("pressed", [M$y("rail", [M$y("button", "max-width: var(--n-button-width-pressed);")])]), M$y("rail", [r$2a("&:active", [M$y("button", "max-width: var(--n-button-width-pressed);")])]), g$1j("active", [g$1j("pressed", [M$y("rail", [M$y("button", "left: calc(100% - var(--n-offset) - var(--n-button-width-pressed));")])]), M$y("rail", [r$2a("&:active", [M$y("button", "left: calc(100% - var(--n-offset) - var(--n-button-width-pressed));")])])])])])]), g$1j("active", [M$y("rail", [M$y("button", "left: calc(100% - var(--n-button-width) - var(--n-offset))")])]), M$y("rail", `
 overflow: hidden;
 height: var(--n-rail-height);
 min-width: var(--n-rail-width);
 border-radius: var(--n-rail-border-radius);
 cursor: pointer;
 position: relative;
 transition:
 opacity .3s var(--n-bezier),
 background .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 background-color: var(--n-rail-color);
 `, [M$y("button-icon", `
 color: var(--n-icon-color);
 transition: color .3s var(--n-bezier);
 font-size: calc(var(--n-button-height) - 4px);
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 display: flex;
 justify-content: center;
 align-items: center;
 line-height: 1;
 `, [m$22()]), M$y("button", `
 align-items: center; 
 top: var(--n-offset);
 left: var(--n-offset);
 height: var(--n-button-height);
 width: var(--n-button-width-pressed);
 max-width: var(--n-button-width);
 border-radius: var(--n-button-border-radius);
 background-color: var(--n-button-color);
 box-shadow: var(--n-button-box-shadow);
 box-sizing: border-box;
 cursor: inherit;
 content: "";
 position: absolute;
 transition:
 background-color .3s var(--n-bezier),
 left .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 max-width .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 `)]), g$1j("active", [M$y("rail", "background-color: var(--n-rail-color-active);")]), g$1j("loading", [M$y("rail", `
 cursor: wait;
 `)]), g$1j("disabled", [M$y("rail", `
 cursor: not-allowed;
 opacity: .5;
 `)])]);
const t$2 = {
  buttonHeightSmall: "14px",
  buttonHeightMedium: "18px",
  buttonHeightLarge: "22px",
  buttonWidthSmall: "14px",
  buttonWidthMedium: "18px",
  buttonWidthLarge: "22px",
  buttonWidthPressedSmall: "20px",
  buttonWidthPressedMedium: "24px",
  buttonWidthPressedLarge: "28px",
  railHeightSmall: "18px",
  railHeightMedium: "22px",
  railHeightLarge: "26px",
  railWidthSmall: "32px",
  railWidthMedium: "40px",
  railWidthLarge: "48px"
};
const n$8 = (t3) => {
  const {
    primaryColor: r3,
    opacityDisabled: a3,
    borderRadius: o3,
    textColor3: i
  } = t3, e28 = "rgba(0, 0, 0, .14)";
  return Object.assign(Object.assign({}, t$2), {
    iconColor: i,
    textColor: "white",
    loadingColor: r3,
    opacityDisabled: a3,
    railColor: e28,
    railColorActive: r3,
    buttonBoxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)",
    buttonColor: "#FFF",
    railBorderRadiusSmall: o3,
    railBorderRadiusMedium: o3,
    railBorderRadiusLarge: o3,
    buttonBorderRadiusSmall: o3,
    buttonBorderRadiusMedium: o3,
    buttonBorderRadiusLarge: o3,
    boxShadowFocus: `0 0 0 2px ${J$p(r3, {
      alpha: 0.2
    })}`
  });
}, c$7 = {
  name: "Switch",
  common: d$1T,
  self: n$8
}, g$2 = c$7;
const me$1 = Object.assign(Object.assign({}, _$F.props), {
  size: {
    type: String,
    default: "medium"
  },
  value: {
    type: [String, Number, Boolean],
    default: void 0
  },
  loading: Boolean,
  defaultValue: {
    type: [String, Number, Boolean],
    default: false
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  round: {
    type: Boolean,
    default: true
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  checkedValue: {
    type: [String, Number, Boolean],
    default: true
  },
  uncheckedValue: {
    type: [String, Number, Boolean],
    default: false
  },
  railStyle: Function,
  rubberBand: {
    type: Boolean,
    default: true
  },
  onChange: [Function, Array]
});
let p$3;
const Fe$2 = defineComponent({
  name: "Switch",
  props: me$1,
  setup(e28) {
    p$3 === void 0 && (typeof CSS < "u" ? typeof CSS.supports < "u" ? p$3 = CSS.supports("width", "max(1px)") : p$3 = false : p$3 = true);
    const {
      mergedClsPrefixRef: k3,
      inlineThemeDisabled: b3
    } = a$2x(e28), B3 = _$F("Switch", "-switch", s$1, g$2, e28, k3), l3 = h$1B(e28), {
      mergedSizeRef: S3,
      mergedDisabledRef: c3
    } = l3, w3 = ref$1(e28.defaultValue), $3 = toRef$1(e28, "value"), u3 = d$1S($3, w3), v3 = computed(() => u3.value === e28.checkedValue), m3 = ref$1(false), n3 = ref$1(false), a3 = computed(() => {
      const {
        railStyle: t3
      } = e28;
      if (t3)
        return t3({
          focused: n3.value,
          checked: v3.value
        });
    });
    function d3(t3) {
      const {
        "onUpdate:value": C3,
        onChange: _3,
        onUpdateValue: R3
      } = e28, {
        nTriggerFormInput: x3,
        nTriggerFormChange: F3
      } = l3;
      C3 && i$1Z(C3, t3), R3 && i$1Z(R3, t3), _3 && i$1Z(_3, t3), w3.value = t3, x3(), F3();
    }
    function H3() {
      const {
        nTriggerFormFocus: t3
      } = l3;
      t3();
    }
    function O3() {
      const {
        nTriggerFormBlur: t3
      } = l3;
      t3();
    }
    function A3() {
      e28.loading || c3.value || (u3.value !== e28.checkedValue ? d3(e28.checkedValue) : d3(e28.uncheckedValue));
    }
    function I3() {
      n3.value = true, H3();
    }
    function M3() {
      n3.value = false, O3(), m3.value = false;
    }
    function j3(t3) {
      e28.loading || c3.value || t3.key === " " && (u3.value !== e28.checkedValue ? d3(e28.checkedValue) : d3(e28.uncheckedValue), m3.value = false);
    }
    function L3(t3) {
      e28.loading || c3.value || t3.key === " " && (t3.preventDefault(), m3.value = true);
    }
    const z3 = computed(() => {
      const {
        value: t3
      } = S3, {
        self: {
          opacityDisabled: C3,
          railColor: _3,
          railColorActive: R3,
          buttonBoxShadow: x3,
          buttonColor: F3,
          boxShadowFocus: q3,
          loadingColor: G3,
          textColor: J3,
          iconColor: Q3,
          [_$H("buttonHeight", t3)]: r3,
          [_$H("buttonWidth", t3)]: X3,
          [_$H("buttonWidthPressed", t3)]: Y3,
          [_$H("railHeight", t3)]: s3,
          [_$H("railWidth", t3)]: y3,
          [_$H("railBorderRadius", t3)]: Z3,
          [_$H("buttonBorderRadius", t3)]: ee2
        },
        common: {
          cubicBezierEaseInOut: te2
        }
      } = B3.value;
      let N3, D3, T3;
      return p$3 ? (N3 = `calc((${s3} - ${r3}) / 2)`, D3 = `max(${s3}, ${r3})`, T3 = `max(${y3}, calc(${y3} + ${r3} - ${s3}))`) : (N3 = o$1f((i$1y(s3) - i$1y(r3)) / 2), D3 = o$1f(Math.max(i$1y(s3), i$1y(r3))), T3 = i$1y(s3) > i$1y(r3) ? y3 : o$1f(i$1y(y3) + i$1y(r3) - i$1y(s3))), {
        "--n-bezier": te2,
        "--n-button-border-radius": ee2,
        "--n-button-box-shadow": x3,
        "--n-button-color": F3,
        "--n-button-width": X3,
        "--n-button-width-pressed": Y3,
        "--n-button-height": r3,
        "--n-height": D3,
        "--n-offset": N3,
        "--n-opacity-disabled": C3,
        "--n-rail-border-radius": Z3,
        "--n-rail-color": _3,
        "--n-rail-color-active": R3,
        "--n-rail-height": s3,
        "--n-rail-width": y3,
        "--n-width": T3,
        "--n-box-shadow-focus": q3,
        "--n-loading-color": G3,
        "--n-text-color": J3,
        "--n-icon-color": Q3
      };
    }), g3 = b3 ? E$J("switch", computed(() => S3.value[0]), z3, e28) : void 0;
    return {
      handleClick: A3,
      handleBlur: M3,
      handleFocus: I3,
      handleKeyup: j3,
      handleKeydown: L3,
      mergedRailStyle: a3,
      pressed: m3,
      mergedClsPrefix: k3,
      mergedValue: u3,
      checked: v3,
      mergedDisabled: c3,
      cssVars: b3 ? void 0 : z3,
      themeClass: g3 == null ? void 0 : g3.themeClass,
      onRender: g3 == null ? void 0 : g3.onRender
    };
  },
  render() {
    const {
      mergedClsPrefix: e28,
      mergedDisabled: k3,
      checked: b3,
      mergedRailStyle: B3,
      onRender: l3,
      $slots: S3
    } = this;
    l3 == null || l3();
    const {
      checked: c3,
      unchecked: w3,
      icon: $3,
      "checked-icon": u3,
      "unchecked-icon": v3
    } = S3, m3 = !(a$2k($3) && a$2k(u3) && a$2k(v3));
    return h$1R("div", {
      role: "switch",
      "aria-checked": b3,
      class: [`${e28}-switch`, this.themeClass, m3 && `${e28}-switch--icon`, b3 && `${e28}-switch--active`, k3 && `${e28}-switch--disabled`, this.round && `${e28}-switch--round`, this.loading && `${e28}-switch--loading`, this.pressed && `${e28}-switch--pressed`, this.rubberBand && `${e28}-switch--rubber-band`],
      tabindex: this.mergedDisabled ? void 0 : 0,
      style: this.cssVars,
      onClick: this.handleClick,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onKeyup: this.handleKeyup,
      onKeydown: this.handleKeydown
    }, h$1R("div", {
      class: `${e28}-switch__rail`,
      "aria-hidden": "true",
      style: B3
    }, m$26(c3, (n3) => m$26(w3, (a3) => n3 || a3 ? h$1R("div", {
      "aria-hidden": true,
      class: `${e28}-switch__children-placeholder`
    }, h$1R("div", {
      class: `${e28}-switch__rail-placeholder`
    }, h$1R("div", {
      class: `${e28}-switch__button-placeholder`
    }), n3), h$1R("div", {
      class: `${e28}-switch__rail-placeholder`
    }, h$1R("div", {
      class: `${e28}-switch__button-placeholder`
    }), a3)) : null)), h$1R("div", {
      class: `${e28}-switch__button`
    }, m$26($3, (n3) => m$26(u3, (a3) => m$26(v3, (d3) => h$1R(m$21, null, {
      default: () => this.loading ? h$1R(h$1A, {
        key: "loading",
        clsPrefix: e28,
        strokeWidth: 20
      }) : this.checked && (a3 || n3) ? h$1R("div", {
        class: `${e28}-switch__button-icon`,
        key: a3 ? "checked-icon" : "icon"
      }, a3 || n3) : !this.checked && (d3 || n3) ? h$1R("div", {
        class: `${e28}-switch__button-icon`,
        key: d3 ? "unchecked-icon" : "icon"
      }, d3 || n3) : null
    })))), m$26(c3, (n3) => n3 && h$1R("div", {
      key: "checked",
      class: `${e28}-switch__checked`
    }, n3)), m$26(w3, (n3) => n3 && h$1R("div", {
      key: "unchecked",
      class: `${e28}-switch__unchecked`
    }, n3)))));
  }
});
const r$3 = defineComponent({
  name: "UISwitch",
  inheritAttrs: false
}), c$6 = defineComponent(__spreadProps(__spreadValues({}, r$3), {
  props: {
    checkedValue: {
      type: [String, Number, Boolean],
      default: true
    },
    defaultValue: {
      type: [String, Number, Boolean]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    rubberBand: {
      type: Boolean,
      default: false
    },
    size: {
      type: String
    },
    uncheckedValue: {
      type: [String, Number, Boolean],
      default: false
    },
    value: {
      type: [String, Number, Boolean]
    }
  },
  setup(e28) {
    return (u3, a3) => (openBlock(), createBlock(unref(Fe$2), {
      "checked-value": e28.checkedValue,
      "default-value": e28.defaultValue,
      disabled: e28.disabled,
      loading: e28.loading,
      "rubber-band": e28.rubberBand,
      size: e28.size,
      "unchecked-value": e28.uncheckedValue,
      value: e28.value,
      "onUpdate:value": a3[0] || (a3[0] = (t3) => u3.$emit("update:value", t3))
    }, null, 8, ["checked-value", "default-value", "disabled", "loading", "rubber-band", "size", "unchecked-value", "value"]));
  }
})), s = c$6;
const f$4 = defineComponent({
  name: "UITimePicker",
  inheritAttrs: false
}), c$5 = defineComponent(__spreadProps(__spreadValues({}, f$4), {
  props: {
    defaultValue: {
      type: Number
    },
    defaultFormattedValue: {
      type: String
    },
    size: {
      type: String,
      default: "large"
    },
    isHourDisabled: {
      type: Function
    },
    isMinuteDisabled: {
      type: Function
    },
    isSecondDisabled: {
      type: Function
    },
    format: {
      type: String
    },
    value: {
      type: Number
    },
    status: {
      type: String
    },
    placeholder: {
      type: String
    },
    actions: {
      type: Array
    }
  },
  emits: ["confirm", "update:value"],
  setup(e28) {
    return (t3, a3) => (openBlock(), createBlock(unref(xn$1), mergeProps(t3.$attrs, {
      actions: e28.actions,
      placeholder: e28.placeholder,
      status: e28.status,
      value: e28.value,
      "onUpdate:value": a3[0] || (a3[0] = (i) => t3.$emit("update:value", i)),
      size: e28.size,
      "default-value": e28.defaultValue,
      "default-formatted-value": e28.defaultFormattedValue,
      onConfirm: a3[1] || (a3[1] = (i) => t3.$emit("confirm", i)),
      format: e28.format,
      "is-hour-disabled": e28.isHourDisabled,
      "is-minute-disabled": e28.isMinuteDisabled,
      "is-second-disabled": e28.isSecondDisabled
    }), {
      default: withCtx(() => [
        renderSlot(t3.$slots, "default")
      ]),
      _: 3
    }, 16, ["actions", "placeholder", "status", "value", "size", "default-value", "default-formatted-value", "format", "is-hour-disabled", "is-minute-disabled", "is-second-disabled"]));
  }
})), v$1 = c$5;
const c$4 = n$28("n-tree-select");
const n$7 = n$28("n-tree");
const n$6 = defineComponent({
  name: "Switcher",
  render() {
    return h$1R("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32"
    }, h$1R("path", {
      d: "M12 8l10 8l-10 8z"
    }));
  }
});
const B$2 = defineComponent({
  name: "NTreeSwitcher",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    indent: {
      type: Number,
      required: true
    },
    expanded: Boolean,
    selected: Boolean,
    hide: Boolean,
    loading: Boolean,
    onClick: Function,
    tmNode: {
      type: Object,
      required: true
    }
  },
  setup(r3) {
    const {
      renderSwitcherIconRef: i
    } = inject(n$7, null);
    return () => {
      const {
        clsPrefix: e28,
        expanded: o3,
        hide: d3,
        indent: c3,
        onClick: l3
      } = r3;
      return h$1R("span", {
        "data-switcher": true,
        class: [`${e28}-tree-node-switcher`, o3 && `${e28}-tree-node-switcher--expanded`, d3 && `${e28}-tree-node-switcher--hide`],
        style: {
          width: `${c3}px`
        },
        onClick: l3
      }, h$1R("div", {
        class: `${e28}-tree-node-switcher__icon`
      }, h$1R(m$21, null, {
        default: () => {
          if (r3.loading)
            return h$1R(h$1A, {
              clsPrefix: e28,
              key: "loading",
              radius: 85,
              strokeWidth: 20
            });
          const {
            value: n3
          } = i;
          return n3 ? n3({
            expanded: r3.expanded,
            selected: r3.selected,
            option: r3.tmNode.rawNode
          }) : h$1R(d$1R, {
            clsPrefix: e28,
            key: "switcher"
          }, {
            default: () => h$1R(n$6, null)
          });
        }
      })));
    };
  }
});
const k$3 = defineComponent({
  name: "NTreeNodeCheckbox",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    indent: {
      type: Number,
      required: true
    },
    right: Boolean,
    focusable: Boolean,
    disabled: Boolean,
    checked: Boolean,
    indeterminate: Boolean,
    onCheck: Function
  },
  setup(t3) {
    const o3 = inject(n$7);
    function n3(e28) {
      const {
        onCheck: r3
      } = t3;
      r3 && r3(e28);
    }
    function d3(e28) {
      n3(e28);
    }
    return {
      handleUpdateValue: d3,
      mergedTheme: o3.mergedThemeRef
    };
  },
  render() {
    const {
      clsPrefix: t3,
      mergedTheme: o3,
      checked: n3,
      indeterminate: d3,
      disabled: e28,
      focusable: r3,
      indent: i,
      handleUpdateValue: h3
    } = this;
    return h$1R("span", {
      class: [`${t3}-tree-node-checkbox`, this.right && `${t3}-tree-node-checkbox--right`],
      style: {
        width: `${i}px`
      },
      "data-checkbox": true
    }, h$1R(Pe$a, {
      focusable: r3,
      disabled: e28,
      theme: o3.peers.Checkbox,
      themeOverrides: o3.peerOverrides.Checkbox,
      checked: n3,
      indeterminate: d3,
      onUpdateChecked: h3
    }));
  }
});
const R$2 = defineComponent({
  name: "TreeNodeContent",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    disabled: Boolean,
    checked: Boolean,
    selected: Boolean,
    onClick: Function,
    onDragstart: Function,
    tmNode: {
      type: Object,
      required: true
    },
    nodeProps: Object
  },
  setup(e28) {
    const {
      renderLabelRef: c3,
      renderPrefixRef: n3,
      renderSuffixRef: r3,
      labelFieldRef: t3
    } = inject(n$7), f3 = ref$1(null);
    function o3(l3) {
      const {
        onClick: i
      } = e28;
      i && i(l3);
    }
    function d3(l3) {
      o3(l3);
    }
    return {
      selfRef: f3,
      renderLabel: c3,
      renderPrefix: n3,
      renderSuffix: r3,
      labelField: t3,
      handleClick: d3
    };
  },
  render() {
    const {
      clsPrefix: e28,
      labelField: c3,
      nodeProps: n3,
      checked: r3 = false,
      selected: t3 = false,
      renderLabel: f3,
      renderPrefix: o3,
      renderSuffix: d3,
      handleClick: l3,
      onDragstart: i,
      tmNode: {
        rawNode: a3,
        rawNode: {
          prefix: p3,
          suffix: x3,
          [c3]: b3
        }
      }
    } = this;
    return h$1R("span", Object.assign({}, n3, {
      ref: "selfRef",
      class: [`${e28}-tree-node-content`, n3 == null ? void 0 : n3.class],
      onClick: l3,
      draggable: i === void 0 ? void 0 : true,
      onDragstart: i
    }), o3 || p3 ? h$1R("div", {
      class: `${e28}-tree-node-content__prefix`
    }, o3 ? o3({
      option: a3,
      selected: t3,
      checked: r3
    }) : o$1c(p3)) : null, h$1R("div", {
      class: `${e28}-tree-node-content__text`
    }, f3 ? f3({
      option: a3,
      selected: t3,
      checked: r3
    }) : o$1c(b3)), d3 || x3 ? h$1R("div", {
      class: `${e28}-tree-node-content__suffix`
    }, d3 ? d3({
      option: a3,
      selected: t3,
      checked: r3
    }) : o$1c(x3)) : null);
  }
});
function f$3({
  position: o3,
  offsetLevel: t3,
  indent: i,
  el: n3
}) {
  const r3 = {
    position: "absolute",
    boxSizing: "border-box",
    right: 0
  };
  if (o3 === "inside")
    r3.left = 0, r3.top = 0, r3.bottom = 0, r3.borderRadius = "inherit", r3.boxShadow = "inset 0 0 0 2px var(--n-drop-mark-color)";
  else {
    const e28 = o3 === "before" ? "top" : "bottom";
    r3[e28] = 0, r3.left = `${n3.offsetLeft + 6 - t3 * i}px`, r3.height = "2px", r3.backgroundColor = "var(--n-drop-mark-color)", r3.transformOrigin = e28, r3.borderRadius = "1px", r3.transform = o3 === "before" ? "translateY(-4px)" : "translateY(4px)";
  }
  return h$1R("div", {
    style: r3
  });
}
function l$3({
  dropPosition: o3,
  node: t3
}) {
  return t3.isLeaf === false || t3.children ? true : o3 !== "inside";
}
function O$3(t3) {
  return computed(() => t3.leafOnly ? "child" : t3.checkStrategy);
}
function B$1(t3, o3) {
  return !!t3.rawNode[o3];
}
function S$2(t3, o3, n3, s3) {
  t3 == null || t3.forEach((e28) => {
    n3(e28), S$2(e28[o3], o3, n3, s3), s3(e28);
  });
}
function I$3(t3, o3, n3, s3, e28) {
  const r3 = /* @__PURE__ */ new Set(), u3 = /* @__PURE__ */ new Set(), a3 = [];
  return S$2(t3, s3, (p3) => {
    if (a3.push(p3), e28(o3, p3)) {
      u3.add(p3[n3]);
      for (let f3 = a3.length - 2; f3 >= 0; --f3)
        if (!r3.has(a3[f3][n3]))
          r3.add(a3[f3][n3]);
        else
          return;
    }
  }, () => {
    a3.pop();
  }), {
    expandedKeys: Array.from(r3),
    highlightKeySet: u3
  };
}
if (e$1O && Image) {
  const t3 = new Image();
  t3.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
}
function x$4(t3, o3, n3, s3, e28) {
  const r3 = /* @__PURE__ */ new Set(), u3 = /* @__PURE__ */ new Set(), a3 = /* @__PURE__ */ new Set(), p3 = [], f3 = [], g3 = [];
  function l3(d3) {
    d3.forEach((i) => {
      if (g3.push(i), o3(n3, i)) {
        r3.add(i[s3]), a3.add(i[s3]);
        for (let h3 = g3.length - 2; h3 >= 0; --h3) {
          const A3 = g3[h3][s3];
          if (!u3.has(A3))
            u3.add(A3), r3.has(A3) && r3.delete(A3);
          else
            break;
        }
      }
      const c3 = i[e28];
      c3 && l3(c3), g3.pop();
    });
  }
  l3(t3);
  function m3(d3, i) {
    d3.forEach((c3) => {
      const h3 = c3[s3], A3 = r3.has(h3), E3 = u3.has(h3);
      if (!A3 && !E3)
        return;
      const y3 = c3[e28];
      if (y3)
        if (A3)
          i.push(c3);
        else {
          p3.push(h3);
          const w3 = Object.assign(Object.assign({}, c3), {
            [e28]: []
          });
          i.push(w3), m3(y3, w3[e28]);
        }
      else
        i.push(c3);
    });
  }
  return m3(t3, f3), {
    filteredTree: f3,
    highlightKeySet: a3,
    expandedKeys: p3
  };
}
function n$5(t3) {
  return typeof t3 == "string" ? `s-${t3}` : `n-${t3}`;
}
const oe$1 = defineComponent({
  name: "TreeNode",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    tmNode: {
      type: Object,
      required: true
    }
  },
  setup(t3) {
    const e28 = inject(n$7), {
      droppingNodeParentRef: m3,
      droppingMouseNodeRef: y3,
      draggingNodeRef: b3,
      droppingPositionRef: c3,
      droppingOffsetLevelRef: p3,
      nodePropsRef: x3,
      indentRef: h3,
      blockLineRef: s3,
      checkboxPlacementRef: f3,
      checkOnClickRef: w3,
      disabledFieldRef: u3,
      showLineRef: N3,
      renderSwitcherIconRef: L3,
      overrideDefaultNodeClickBehaviorRef: v3
    } = e28, P3 = n$1U(() => !!t3.tmNode.rawNode.checkboxDisabled), R3 = n$1U(() => B$1(t3.tmNode, u3.value)), C3 = n$1U(() => e28.disabledRef.value || R3.value), k3 = computed(() => {
      const {
        value: n3
      } = x3;
      if (n3)
        return n3({
          option: t3.tmNode.rawNode
        });
    }), g3 = ref$1(null), K3 = {
      value: null
    };
    onMounted(() => {
      K3.value = g3.value.$el;
    });
    function O3() {
      const n3 = () => {
        const {
          tmNode: d3
        } = t3;
        if (!d3.isLeaf && !d3.shallowLoaded) {
          if (!e28.loadingKeysRef.value.has(d3.key))
            e28.loadingKeysRef.value.add(d3.key);
          else
            return;
          const {
            onLoadRef: {
              value: i
            }
          } = e28;
          i && i(d3.rawNode).then((o3) => {
            o3 !== false && e28.handleSwitcherClick(d3);
          }).finally(() => {
            e28.loadingKeysRef.value.delete(d3.key);
          });
        } else
          e28.handleSwitcherClick(d3);
      };
      L3.value ? setTimeout(n3, 0) : n3();
    }
    const E3 = n$1U(() => !R3.value && e28.selectableRef.value && (e28.internalTreeSelect ? e28.mergedCheckStrategyRef.value !== "child" || e28.multipleRef.value && e28.cascadeRef.value || t3.tmNode.isLeaf : true)), T3 = n$1U(() => e28.checkableRef.value && (e28.cascadeRef.value || e28.mergedCheckStrategyRef.value !== "child" || t3.tmNode.isLeaf)), S3 = n$1U(() => e28.displayedCheckedKeysRef.value.includes(t3.tmNode.key)), M3 = n$1U(() => {
      const {
        value: n3
      } = T3;
      if (!n3)
        return false;
      const {
        value: d3
      } = w3, {
        tmNode: i
      } = t3;
      return typeof d3 == "boolean" ? !i.disabled && d3 : d3(t3.tmNode.rawNode);
    });
    function _3(n3) {
      const {
        value: d3
      } = e28.expandOnClickRef, {
        value: i
      } = E3, {
        value: o3
      } = M3;
      if (!i && !d3 && !o3 || a$2j(n3, "checkbox") || a$2j(n3, "switcher"))
        return;
      const {
        tmNode: r3
      } = t3;
      i && e28.handleSelect(r3), d3 && !r3.isLeaf && O3(), o3 && $3(!S3.value);
    }
    function I3(n3) {
      var d3, i;
      if (!(a$2j(n3, "checkbox") || a$2j(n3, "switcher"))) {
        if (!C3.value) {
          const o3 = v3.value;
          let r3 = false;
          if (o3)
            switch (o3({
              option: t3.tmNode.rawNode
            })) {
              case "toggleCheck":
                r3 = true, $3(!S3.value);
                break;
              case "toggleSelect":
                r3 = true, e28.handleSelect(t3.tmNode);
                break;
              case "toggleExpand":
                r3 = true, O3(), r3 = true;
                break;
              case "none":
                r3 = true, r3 = true;
                return;
            }
          r3 || _3(n3);
        }
        (i = (d3 = k3.value) === null || d3 === void 0 ? void 0 : d3.onClick) === null || i === void 0 || i.call(d3, n3);
      }
    }
    function q3(n3) {
      s3.value || I3(n3);
    }
    function A3(n3) {
      s3.value && I3(n3);
    }
    function $3(n3) {
      e28.handleCheck(t3.tmNode, n3);
    }
    function B3(n3) {
      e28.handleDragStart({
        event: n3,
        node: t3.tmNode
      });
    }
    function H3(n3) {
      n3.currentTarget === n3.target && e28.handleDragEnter({
        event: n3,
        node: t3.tmNode
      });
    }
    function z3(n3) {
      n3.preventDefault(), e28.handleDragOver({
        event: n3,
        node: t3.tmNode
      });
    }
    function G3(n3) {
      e28.handleDragEnd({
        event: n3,
        node: t3.tmNode
      });
    }
    function J3(n3) {
      n3.currentTarget === n3.target && e28.handleDragLeave({
        event: n3,
        node: t3.tmNode
      });
    }
    function Q3(n3) {
      n3.preventDefault(), c3.value !== null && e28.handleDrop({
        event: n3,
        node: t3.tmNode,
        dropPosition: c3.value
      });
    }
    const U3 = computed(() => {
      const {
        clsPrefix: n3
      } = t3, {
        value: d3
      } = h3;
      if (N3.value) {
        const i = [];
        let o3 = t3.tmNode.parent;
        for (; o3; )
          o3.isLastChild ? i.push(h$1R("div", {
            class: `${n3}-tree-node-indent`
          }, h$1R("div", {
            style: {
              width: `${d3}px`
            }
          }))) : i.push(h$1R("div", {
            class: [`${n3}-tree-node-indent`, `${n3}-tree-node-indent--show-line`]
          }, h$1R("div", {
            style: {
              width: `${d3}px`
            }
          }))), o3 = o3.parent;
        return i.reverse();
      } else
        return o$1G(t3.tmNode.level, h$1R("div", {
          class: `${t3.clsPrefix}-tree-node-indent`
        }, h$1R("div", {
          style: {
            width: `${d3}px`
          }
        })));
    });
    return {
      showDropMark: n$1U(() => {
        const {
          value: n3
        } = b3;
        if (!n3)
          return;
        const {
          value: d3
        } = c3;
        if (!d3)
          return;
        const {
          value: i
        } = y3;
        if (!i)
          return;
        const {
          tmNode: o3
        } = t3;
        return o3.key === i.key;
      }),
      showDropMarkAsParent: n$1U(() => {
        const {
          value: n3
        } = m3;
        if (!n3)
          return false;
        const {
          tmNode: d3
        } = t3, {
          value: i
        } = c3;
        return i === "before" || i === "after" ? n3.key === d3.key : false;
      }),
      pending: n$1U(() => e28.pendingNodeKeyRef.value === t3.tmNode.key),
      loading: n$1U(() => e28.loadingKeysRef.value.has(t3.tmNode.key)),
      highlight: n$1U(() => {
        var n3;
        return (n3 = e28.highlightKeySetRef.value) === null || n3 === void 0 ? void 0 : n3.has(t3.tmNode.key);
      }),
      checked: S3,
      indeterminate: n$1U(() => e28.displayedIndeterminateKeysRef.value.includes(t3.tmNode.key)),
      selected: n$1U(() => e28.mergedSelectedKeysRef.value.includes(t3.tmNode.key)),
      expanded: n$1U(() => e28.mergedExpandedKeysRef.value.includes(t3.tmNode.key)),
      disabled: C3,
      checkable: T3,
      mergedCheckOnClick: M3,
      checkboxDisabled: P3,
      selectable: E3,
      expandOnClick: e28.expandOnClickRef,
      internalScrollable: e28.internalScrollableRef,
      draggable: e28.draggableRef,
      blockLine: s3,
      nodeProps: k3,
      checkboxFocusable: e28.internalCheckboxFocusableRef,
      droppingPosition: c3,
      droppingOffsetLevel: p3,
      indent: h3,
      checkboxPlacement: f3,
      showLine: N3,
      contentInstRef: g3,
      contentElRef: K3,
      indentNodes: U3,
      handleCheck: $3,
      handleDrop: Q3,
      handleDragStart: B3,
      handleDragEnter: H3,
      handleDragOver: z3,
      handleDragEnd: G3,
      handleDragLeave: J3,
      handleLineClick: A3,
      handleContentClick: q3,
      handleSwitcherClick: O3
    };
  },
  render() {
    const {
      tmNode: t3,
      clsPrefix: e28,
      checkable: m3,
      expandOnClick: y3,
      selectable: b3,
      selected: c3,
      checked: p3,
      highlight: x3,
      draggable: h3,
      blockLine: s3,
      indent: f3,
      indentNodes: w3,
      disabled: u3,
      pending: N3,
      internalScrollable: L3,
      nodeProps: v3,
      checkboxPlacement: P3
    } = this, R3 = h3 && !u3 ? {
      onDragenter: this.handleDragEnter,
      onDragleave: this.handleDragLeave,
      onDragend: this.handleDragEnd,
      onDrop: this.handleDrop,
      onDragover: this.handleDragOver
    } : void 0, C3 = L3 ? n$5(t3.key) : void 0, k3 = P3 === "right", g3 = m3 ? h$1R(k$3, {
      indent: f3,
      right: k3,
      focusable: this.checkboxFocusable,
      disabled: u3 || this.checkboxDisabled,
      clsPrefix: e28,
      checked: this.checked,
      indeterminate: this.indeterminate,
      onCheck: this.handleCheck
    }) : null;
    return h$1R("div", Object.assign({
      class: `${e28}-tree-node-wrapper`
    }, R3), h$1R("div", Object.assign({}, s3 ? v3 : void 0, {
      class: [`${e28}-tree-node`, {
        [`${e28}-tree-node--selected`]: c3,
        [`${e28}-tree-node--checkable`]: m3,
        [`${e28}-tree-node--highlight`]: x3,
        [`${e28}-tree-node--pending`]: N3,
        [`${e28}-tree-node--disabled`]: u3,
        [`${e28}-tree-node--selectable`]: b3,
        [`${e28}-tree-node--clickable`]: b3 || y3 || this.mergedCheckOnClick
      }, v3 == null ? void 0 : v3.class],
      "data-key": C3,
      draggable: h3 && s3,
      onClick: this.handleLineClick,
      onDragstart: h3 && s3 && !u3 ? this.handleDragStart : void 0
    }), w3, t3.isLeaf && this.showLine ? h$1R("div", {
      class: [`${e28}-tree-node-indent`, `${e28}-tree-node-indent--show-line`, t3.isLeaf && `${e28}-tree-node-indent--is-leaf`, t3.isLastChild && `${e28}-tree-node-indent--last-child`]
    }, h$1R("div", {
      style: {
        width: `${f3}px`
      }
    })) : h$1R(B$2, {
      clsPrefix: e28,
      expanded: this.expanded,
      selected: c3,
      loading: this.loading,
      hide: t3.isLeaf,
      tmNode: this.tmNode,
      indent: f3,
      onClick: this.handleSwitcherClick
    }), k3 ? null : g3, h$1R(R$2, {
      ref: "contentInstRef",
      clsPrefix: e28,
      checked: p3,
      selected: c3,
      onClick: this.handleContentClick,
      nodeProps: s3 ? void 0 : v3,
      onDragstart: h3 && !s3 && !u3 ? this.handleDragStart : void 0,
      tmNode: t3
    }), h3 ? this.showDropMark ? f$3({
      el: this.contentElRef.value,
      position: this.droppingPosition,
      offsetLevel: this.droppingOffsetLevel,
      indent: f3
    }) : this.showDropMarkAsParent ? f$3({
      el: this.contentElRef.value,
      position: "inside",
      offsetLevel: this.droppingOffsetLevel,
      indent: f3
    }) : null : null, k3 ? g3 : null));
  }
}), be$2 = oe$1;
function K$3({
  props: a3,
  fNodesRef: s3,
  mergedExpandedKeysRef: c3,
  mergedSelectedKeysRef: g3,
  mergedCheckedKeysRef: w3,
  handleCheck: b3,
  handleSelect: k3,
  handleSwitcherClick: u3
}) {
  const {
    value: f3
  } = g3, v3 = inject(c$4, null), t3 = v3 ? v3.pendingNodeKeyRef : ref$1(f3.length ? f3[f3.length - 1] : null);
  function h3(r3) {
    var d3;
    if (!a3.keyboard)
      return {
        enterBehavior: null
      };
    const {
      value: o3
    } = t3;
    let i = null;
    if (o3 === null) {
      if ((r3.key === "ArrowDown" || r3.key === "ArrowUp") && r3.preventDefault(), ["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"].includes(r3.key) && o3 === null) {
        const {
          value: n3
        } = s3;
        let e28 = 0;
        for (; e28 < n3.length; ) {
          if (!n3[e28].disabled) {
            t3.value = n3[e28].key;
            break;
          }
          e28 += 1;
        }
      }
    } else {
      const {
        value: n3
      } = s3;
      let e28 = n3.findIndex((l3) => l3.key === o3);
      if (!~e28)
        return {
          enterBehavior: null
        };
      if (r3.key === "Enter") {
        const l3 = n3[e28];
        switch (i = ((d3 = a3.overrideDefaultNodeClickBehavior) === null || d3 === void 0 ? void 0 : d3.call(a3, {
          option: l3.rawNode
        })) || null, i) {
          case "toggleCheck":
            b3(l3, !w3.value.includes(l3.key));
            break;
          case "toggleSelect":
            k3(l3);
            break;
          case "toggleExpand":
            u3(l3);
            break;
          case "none":
            break;
          case "default":
          default:
            i = "default", k3(l3);
        }
      } else if (r3.key === "ArrowDown")
        for (r3.preventDefault(), e28 += 1; e28 < n3.length; ) {
          if (!n3[e28].disabled) {
            t3.value = n3[e28].key;
            break;
          }
          e28 += 1;
        }
      else if (r3.key === "ArrowUp")
        for (r3.preventDefault(), e28 -= 1; e28 >= 0; ) {
          if (!n3[e28].disabled) {
            t3.value = n3[e28].key;
            break;
          }
          e28 -= 1;
        }
      else if (r3.key === "ArrowLeft") {
        const l3 = n3[e28];
        if (l3.isLeaf || !c3.value.includes(o3)) {
          const y3 = l3.getParent();
          y3 && (t3.value = y3.key);
        } else
          u3(l3);
      } else if (r3.key === "ArrowRight") {
        const l3 = n3[e28];
        if (l3.isLeaf)
          return {
            enterBehavior: null
          };
        if (!c3.value.includes(o3))
          u3(l3);
        else
          for (e28 += 1; e28 < n3.length; ) {
            if (!n3[e28].disabled) {
              t3.value = n3[e28].key;
              break;
            }
            e28 += 1;
          }
      }
    }
    return {
      enterBehavior: i
    };
  }
  return {
    pendingNodeKeyRef: t3,
    handleKeydown: h3
  };
}
const f$2 = defineComponent({
  name: "TreeMotionWrapper",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    height: Number,
    nodes: {
      type: Array,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    onAfterEnter: {
      type: Function,
      required: true
    }
  },
  render() {
    const {
      clsPrefix: e28
    } = this;
    return h$1R(l$1W, {
      onAfterEnter: this.onAfterEnter,
      appear: true,
      reverse: this.mode === "collapse"
    }, {
      default: () => h$1R("div", {
        class: [`${e28}-tree-motion-wrapper`, `${e28}-tree-motion-wrapper--${this.mode}`],
        style: {
          height: o$1f(this.height)
        }
      }, this.nodes.map((t3) => h$1R(be$2, {
        clsPrefix: e28,
        tmNode: t3
      })))
    });
  }
});
const i$2 = m$22(), b$3 = l$25("tree", `
 font-size: var(--n-font-size);
 outline: none;
`, [r$2a("ul, li", `
 margin: 0;
 padding: 0;
 list-style: none;
 `), r$2a(">", [l$25("tree-node", [r$2a("&:first-child", "margin-top: 0;")])]), l$25("tree-motion-wrapper", [g$1j("expand", [x$E({
  duration: "0.2s"
})]), g$1j("collapse", [x$E({
  duration: "0.2s",
  reverse: true
})])]), l$25("tree-node-wrapper", `
 box-sizing: border-box;
 padding: var(--n-node-wrapper-padding);
 `), l$25("tree-node", `
 transform: translate3d(0,0,0);
 position: relative;
 display: flex;
 border-radius: var(--n-node-border-radius);
 transition: background-color .3s var(--n-bezier);
 `, [g$1j("highlight", [l$25("tree-node-content", [M$y("text", "border-bottom-color: var(--n-node-text-color-disabled);")])]), g$1j("disabled", [l$25("tree-node-content", `
 color: var(--n-node-text-color-disabled);
 cursor: not-allowed;
 `)]), x$I("disabled", [g$1j("clickable", [l$25("tree-node-content", `
 cursor: pointer;
 `)])])]), g$1j("block-node", [l$25("tree-node-content", `
 flex: 1;
 min-width: 0;
 `)]), x$I("block-line", [l$25("tree-node", [x$I("disabled", [l$25("tree-node-content", [r$2a("&:hover", "background: var(--n-node-color-hover);")]), g$1j("selectable", [l$25("tree-node-content", [r$2a("&:active", "background: var(--n-node-color-pressed);")])]), g$1j("pending", [l$25("tree-node-content", `
 background: var(--n-node-color-hover);
 `)]), g$1j("selected", [l$25("tree-node-content", "background: var(--n-node-color-active);")])]), g$1j("selected", [l$25("tree-node-content", "background: var(--n-node-color-active);")])])]), g$1j("block-line", [l$25("tree-node", [x$I("disabled", [r$2a("&:hover", "background: var(--n-node-color-hover);"), g$1j("pending", `
 background: var(--n-node-color-hover);
 `), g$1j("selectable", [x$I("selected", [r$2a("&:active", "background: var(--n-node-color-pressed);")])]), g$1j("selected", "background: var(--n-node-color-active);")]), g$1j("selected", "background: var(--n-node-color-active);"), g$1j("disabled", `
 cursor: not-allowed;
 `)])]), l$25("tree-node-indent", `
 flex-grow: 0;
 flex-shrink: 0;
 `, [g$1j("show-line", "position: relative", [r$2a("&::before", `
 position: absolute;
 left: 50%;
 border-left: 1px solid var(--n-line-color);
 transition: border-color .3s var(--n-bezier);
 transform: translate(-50%);
 content: "";
 top: var(--n-line-offset-top);
 bottom: var(--n-line-offset-bottom);
 `), g$1j("last-child", [r$2a("&::before", `
 bottom: 50%;
 `)]), g$1j("is-leaf", [r$2a("&::after", `
 position: absolute;
 content: "";
 left: calc(50% + 0.5px);
 right: 0;
 bottom: 50%;
 transition: border-color .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-line-color);
 `)])]), x$I("show-line", "height: 0;")]), l$25("tree-node-switcher", `
 cursor: pointer;
 display: inline-flex;
 flex-shrink: 0;
 height: var(--n-node-content-height);
 align-items: center;
 justify-content: center;
 transition: transform .15s var(--n-bezier);
 vertical-align: bottom;
 `, [M$y("icon", `
 position: relative;
 height: 14px;
 width: 14px;
 display: flex;
 color: var(--n-arrow-color);
 transition: color .3s var(--n-bezier);
 font-size: 14px;
 `, [l$25("icon", [i$2]), l$25("base-loading", `
 color: var(--n-loading-color);
 position: absolute;
 left: 0;
 top: 0;
 right: 0;
 bottom: 0;
 `, [i$2]), l$25("base-icon", [i$2])]), g$1j("hide", "visibility: hidden;"), g$1j("expanded", "transform: rotate(90deg);")]), l$25("tree-node-checkbox", `
 display: inline-flex;
 height: var(--n-node-content-height);
 vertical-align: bottom;
 align-items: center;
 justify-content: center;
 `), l$25("tree-node-content", `
 user-select: none;
 position: relative;
 display: inline-flex;
 align-items: center;
 min-height: var(--n-node-content-height);
 box-sizing: border-box;
 line-height: var(--n-line-height);
 vertical-align: bottom;
 padding: 0 6px 0 4px;
 cursor: default;
 border-radius: var(--n-node-border-radius);
 color: var(--n-node-text-color);
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [r$2a("&:last-child", "margin-bottom: 0;"), M$y("prefix", `
 display: inline-flex;
 margin-right: 8px;
 `), M$y("text", `
 border-bottom: 1px solid #0000;
 transition: border-color .3s var(--n-bezier);
 flex-grow: 1;
 max-width: 100%;
 `), M$y("suffix", `
 display: inline-flex;
 `)]), M$y("empty", "margin: auto;")]);
const x$3 = (r3) => {
  const {
    borderRadiusSmall: e28,
    dividerColor: t3,
    hoverColor: l3,
    pressedColor: i,
    primaryColor: o3,
    textColor3: d3,
    textColor2: m3,
    textColorDisabled: n3,
    fontSize: a3
  } = r3;
  return {
    fontSize: a3,
    lineHeight: "1.5",
    nodeHeight: "30px",
    nodeWrapperPadding: "3px 0",
    nodeBorderRadius: e28,
    nodeColorHover: l3,
    nodeColorPressed: i,
    nodeColorActive: J$p(o3, {
      alpha: 0.1
    }),
    arrowColor: d3,
    nodeTextColor: m3,
    nodeTextColorDisabled: n3,
    loadingColor: o3,
    dropMarkColor: o3,
    lineColor: t3
  };
}, f$1 = G$w({
  name: "Tree",
  common: d$1T,
  peers: {
    Checkbox: S$v,
    Scrollbar: n$1N,
    Empty: x$v
  },
  self: x$3
}), y$4 = f$1;
var Wn$1 = globalThis && globalThis.__awaiter || function(n3, x3, R3, f3) {
  function V10(s3) {
    return s3 instanceof R3 ? s3 : new R3(function(w3) {
      w3(s3);
    });
  }
  return new (R3 || (R3 = Promise))(function(s3, w3) {
    function A3(m3) {
      try {
        U3(f3.next(m3));
      } catch (E3) {
        w3(E3);
      }
    }
    function F3(m3) {
      try {
        U3(f3.throw(m3));
      } catch (E3) {
        w3(E3);
      }
    }
    function U3(m3) {
      m3.done ? s3(m3.value) : V10(m3.value).then(A3, F3);
    }
    U3((f3 = f3.apply(n3, x3 || [])).next());
  });
};
function Yn$1(n3, x3, R3, f3) {
  return {
    getIsGroup() {
      return false;
    },
    getKey(s3) {
      return s3[n3];
    },
    getChildren: f3 || ((s3) => s3[x3]),
    getDisabled(s3) {
      return !!(s3[R3] || s3.checkboxDisabled);
    }
  };
}
const qn$1 = {
  allowCheckingNotLoaded: Boolean,
  filter: Function,
  defaultExpandAll: Boolean,
  expandedKeys: Array,
  keyField: {
    type: String,
    default: "key"
  },
  labelField: {
    type: String,
    default: "label"
  },
  childrenField: {
    type: String,
    default: "children"
  },
  disabledField: {
    type: String,
    default: "disabled"
  },
  defaultExpandedKeys: {
    type: Array,
    default: () => []
  },
  indeterminateKeys: Array,
  renderSwitcherIcon: Function,
  onUpdateIndeterminateKeys: [Function, Array],
  "onUpdate:indeterminateKeys": [Function, Array],
  onUpdateExpandedKeys: [Function, Array],
  "onUpdate:expandedKeys": [Function, Array],
  overrideDefaultNodeClickBehavior: Function
}, Jn$1 = Object.assign(Object.assign(Object.assign(Object.assign({}, _$F.props), {
  accordion: Boolean,
  showIrrelevantNodes: {
    type: Boolean,
    default: true
  },
  data: {
    type: Array,
    default: () => []
  },
  expandOnDragenter: {
    type: Boolean,
    default: true
  },
  expandOnClick: Boolean,
  checkOnClick: {
    type: [Boolean, Function],
    default: false
  },
  cancelable: {
    type: Boolean,
    default: true
  },
  checkable: Boolean,
  draggable: Boolean,
  blockNode: Boolean,
  blockLine: Boolean,
  showLine: Boolean,
  disabled: Boolean,
  checkedKeys: Array,
  defaultCheckedKeys: {
    type: Array,
    default: () => []
  },
  selectedKeys: Array,
  defaultSelectedKeys: {
    type: Array,
    default: () => []
  },
  multiple: Boolean,
  pattern: {
    type: String,
    default: ""
  },
  onLoad: Function,
  cascade: Boolean,
  selectable: {
    type: Boolean,
    default: true
  },
  scrollbarProps: Object,
  indent: {
    type: Number,
    default: 24
  },
  allowDrop: {
    type: Function,
    default: l$3
  },
  animated: {
    type: Boolean,
    default: true
  },
  checkboxPlacement: {
    type: String,
    default: "left"
  },
  virtualScroll: Boolean,
  watchProps: Array,
  renderLabel: Function,
  renderPrefix: Function,
  renderSuffix: Function,
  nodeProps: Function,
  keyboard: {
    type: Boolean,
    default: true
  },
  getChildren: Function,
  onDragenter: [Function, Array],
  onDragleave: [Function, Array],
  onDragend: [Function, Array],
  onDragstart: [Function, Array],
  onDragover: [Function, Array],
  onDrop: [Function, Array],
  onUpdateCheckedKeys: [Function, Array],
  "onUpdate:checkedKeys": [Function, Array],
  onUpdateSelectedKeys: [Function, Array],
  "onUpdate:selectedKeys": [Function, Array]
}), qn$1), {
  internalTreeSelect: Boolean,
  internalScrollable: Boolean,
  internalScrollablePadding: String,
  internalRenderEmpty: Function,
  internalHighlightKeySet: Object,
  internalUnifySelectCheck: Boolean,
  internalCheckboxFocusable: {
    type: Boolean,
    default: true
  },
  internalFocusable: {
    type: Boolean,
    default: true
  },
  checkStrategy: {
    type: String,
    default: "all"
  },
  leafOnly: Boolean
}), wt$1 = defineComponent({
  name: "Tree",
  props: Jn$1,
  setup(n3) {
    const {
      mergedClsPrefixRef: x3,
      inlineThemeDisabled: R3,
      mergedRtlRef: f3
    } = a$2x(n3), V10 = v$17("Tree", f3, x3), s3 = _$F("Tree", "-tree", b$3, y$4, n3, x3), w3 = ref$1(null), A3 = ref$1(null), F3 = ref$1(null);
    function U3() {
      var e28;
      return (e28 = F3.value) === null || e28 === void 0 ? void 0 : e28.listElRef;
    }
    function m3() {
      var e28;
      return (e28 = F3.value) === null || e28 === void 0 ? void 0 : e28.itemsElRef;
    }
    const E3 = computed(() => {
      const {
        filter: e28
      } = n3;
      if (e28)
        return e28;
      const {
        labelField: t3
      } = n3;
      return (l3, a3) => {
        if (!l3.length)
          return true;
        const i = a3[t3];
        return typeof i == "string" ? i.toLowerCase().includes(l3.toLowerCase()) : false;
      };
    }), H3 = computed(() => {
      const {
        pattern: e28
      } = n3;
      return e28 ? !e28.length || !E3.value ? {
        filteredTree: n3.data,
        highlightKeySet: null,
        expandedKeys: void 0
      } : x$4(n3.data, E3.value, e28, n3.keyField, n3.childrenField) : {
        filteredTree: n3.data,
        highlightKeySet: null,
        expandedKeys: void 0
      };
    }), B3 = computed(() => U$s(n3.showIrrelevantNodes ? n3.data : H3.value.filteredTree, Yn$1(n3.keyField, n3.childrenField, n3.disabledField, n3.getChildren))), L3 = inject(c$4, null), P3 = n3.internalTreeSelect ? L3.dataTreeMate : B3, {
      watchProps: y3
    } = n3, p3 = ref$1([]);
    y3 != null && y3.includes("defaultCheckedKeys") ? watchEffect(() => {
      p3.value = n3.defaultCheckedKeys;
    }) : p3.value = n3.defaultCheckedKeys;
    const Ke2 = toRef$1(n3, "checkedKeys"), b3 = d$1S(Ke2, p3), M3 = computed(() => P3.value.getCheckedKeys(b3.value, {
      cascade: n3.cascade,
      allowNotLoaded: n3.allowCheckingNotLoaded
    })), j3 = O$3(n3), G3 = computed(() => M3.value.checkedKeys), Se2 = computed(() => {
      const {
        indeterminateKeys: e28
      } = n3;
      return e28 !== void 0 ? e28 : M3.value.indeterminateKeys;
    }), re2 = ref$1([]);
    y3 != null && y3.includes("defaultSelectedKeys") ? watchEffect(() => {
      re2.value = n3.defaultSelectedKeys;
    }) : re2.value = n3.defaultSelectedKeys;
    const Ge2 = toRef$1(n3, "selectedKeys"), ce2 = d$1S(Ge2, re2), xe2 = ref$1([]), Oe2 = (e28) => {
      xe2.value = n3.defaultExpandAll ? P3.value.getNonLeafKeys() : e28 === void 0 ? n3.defaultExpandedKeys : e28;
    };
    y3 != null && y3.includes("defaultExpandedKeys") ? watchEffect(() => {
      Oe2(void 0);
    }) : watchEffect(() => {
      Oe2(n3.defaultExpandedKeys);
    });
    const Xe2 = toRef$1(n3, "expandedKeys"), T3 = d$1S(Xe2, xe2), X3 = computed(() => B3.value.getFlattenedNodes(T3.value)), {
      pendingNodeKeyRef: W3,
      handleKeydown: We2
    } = K$3({
      props: n3,
      mergedCheckedKeysRef: b3,
      mergedSelectedKeysRef: ce2,
      fNodesRef: X3,
      mergedExpandedKeysRef: T3,
      handleCheck: De2,
      handleSelect: Te2,
      handleSwitcherClick: Pe2
    });
    let O3 = null, Y3 = null;
    const Re2 = ref$1(/* @__PURE__ */ new Set()), Ye2 = computed(() => n3.internalHighlightKeySet || H3.value.highlightKeySet), qe2 = d$1S(Ye2, Re2), se2 = ref$1(/* @__PURE__ */ new Set()), Je2 = computed(() => T3.value.filter((e28) => !se2.value.has(e28)));
    let Ie2 = 0;
    const ae2 = ref$1(null), fe2 = ref$1(null), ue2 = ref$1(null), he2 = ref$1(null), ye2 = ref$1(0), Qe2 = computed(() => {
      const {
        value: e28
      } = fe2;
      return e28 ? e28.parent : null;
    });
    let we2 = false;
    watch(toRef$1(n3, "data"), () => {
      we2 = true, nextTick(() => {
        we2 = false;
      }), se2.value.clear(), W3.value = null, de2();
    }, {
      deep: false
    });
    let Ce2 = false;
    const Ne2 = () => {
      Ce2 = true, nextTick(() => {
        Ce2 = false;
      });
    };
    let ie2;
    watch(toRef$1(n3, "pattern"), (e28, t3) => {
      if (n3.showIrrelevantNodes)
        if (ie2 = void 0, e28) {
          const {
            expandedKeys: l3,
            highlightKeySet: a3
          } = I$3(n3.data, n3.pattern, n3.keyField, n3.childrenField, E3.value);
          Re2.value = a3, Ne2(), J3(l3, k3(l3), {
            node: null,
            action: "filter"
          });
        } else
          Re2.value = /* @__PURE__ */ new Set();
      else if (!e28.length)
        ie2 !== void 0 && (Ne2(), J3(ie2, k3(ie2), {
          node: null,
          action: "filter"
        }));
      else {
        t3.length || (ie2 = T3.value);
        const {
          expandedKeys: l3
        } = H3.value;
        l3 !== void 0 && (Ne2(), J3(l3, k3(l3), {
          node: null,
          action: "filter"
        }));
      }
    });
    function Ae2(e28) {
      return Wn$1(this, void 0, void 0, function* () {
        const {
          onLoad: t3
        } = n3;
        if (!t3) {
          yield Promise.resolve();
          return;
        }
        const {
          value: l3
        } = se2;
        if (!l3.has(e28.key)) {
          l3.add(e28.key);
          try {
            (yield t3(e28.rawNode)) === false && Q3();
          } catch (a3) {
            console.error(a3), Q3();
          }
          l3.delete(e28.key);
        }
      });
    }
    watchEffect(() => {
      var e28;
      const {
        value: t3
      } = B3;
      if (!t3)
        return;
      const {
        getNode: l3
      } = t3;
      (e28 = T3.value) === null || e28 === void 0 || e28.forEach((a3) => {
        const i = l3(a3);
        i && !i.shallowLoaded && Ae2(i);
      });
    });
    const q3 = ref$1(false), _3 = ref$1([]);
    watch(Je2, (e28, t3) => {
      if (!n3.animated || Ce2) {
        nextTick(ge2);
        return;
      }
      if (we2)
        return;
      const l3 = i$1y(s3.value.self.nodeHeight), a3 = new Set(t3);
      let i = null, c3 = null;
      for (const o3 of e28)
        if (!a3.has(o3)) {
          if (i !== null)
            return;
          i = o3;
        }
      const g3 = new Set(e28);
      for (const o3 of t3)
        if (!g3.has(o3)) {
          if (c3 !== null)
            return;
          c3 = o3;
        }
      if (i === null && c3 === null)
        return;
      const {
        virtualScroll: K3
      } = n3, ee2 = (K3 ? F3.value.listElRef : w3.value).offsetHeight, ne2 = Math.ceil(ee2 / l3) + 1;
      let C3;
      if (i !== null && (C3 = t3), c3 !== null && (C3 === void 0 ? C3 = e28 : C3 = C3.filter((o3) => o3 !== c3)), q3.value = true, _3.value = B3.value.getFlattenedNodes(C3), i !== null) {
        const o3 = _3.value.findIndex((N3) => N3.key === i);
        if (~o3) {
          const N3 = _3.value[o3].children;
          if (N3) {
            const D3 = a$1E(N3, e28);
            _3.value.splice(o3 + 1, 0, {
              __motion: true,
              mode: "expand",
              height: K3 ? D3.length * l3 : void 0,
              nodes: K3 ? D3.slice(0, ne2) : D3
            });
          }
        }
      }
      if (c3 !== null) {
        const o3 = _3.value.findIndex((N3) => N3.key === c3);
        if (~o3) {
          const N3 = _3.value[o3].children;
          if (!N3)
            return;
          q3.value = true;
          const D3 = a$1E(N3, e28);
          _3.value.splice(o3 + 1, 0, {
            __motion: true,
            mode: "collapse",
            height: K3 ? D3.length * l3 : void 0,
            nodes: K3 ? D3.slice(0, ne2) : D3
          });
        }
      }
    });
    const Ze2 = computed(() => g$11(X3.value)), en2 = computed(() => q3.value ? _3.value : X3.value);
    function ge2() {
      const {
        value: e28
      } = A3;
      e28 && e28.sync();
    }
    function nn2() {
      q3.value = false, n3.virtualScroll && nextTick(ge2);
    }
    function k3(e28) {
      const {
        getNode: t3
      } = P3.value;
      return e28.map((l3) => {
        var a3;
        return ((a3 = t3(l3)) === null || a3 === void 0 ? void 0 : a3.rawNode) || null;
      });
    }
    function J3(e28, t3, l3) {
      const {
        "onUpdate:expandedKeys": a3,
        onUpdateExpandedKeys: i
      } = n3;
      xe2.value = e28, a3 && i$1Z(a3, e28, t3, l3), i && i$1Z(i, e28, t3, l3);
    }
    function Be2(e28, t3, l3) {
      const {
        "onUpdate:checkedKeys": a3,
        onUpdateCheckedKeys: i
      } = n3;
      p3.value = e28, i && i$1Z(i, e28, t3, l3), a3 && i$1Z(a3, e28, t3, l3);
    }
    function tn2(e28, t3) {
      const {
        "onUpdate:indeterminateKeys": l3,
        onUpdateIndeterminateKeys: a3
      } = n3;
      l3 && i$1Z(l3, e28, t3), a3 && i$1Z(a3, e28, t3);
    }
    function Fe2(e28, t3, l3) {
      const {
        "onUpdate:selectedKeys": a3,
        onUpdateSelectedKeys: i
      } = n3;
      re2.value = e28, i && i$1Z(i, e28, t3, l3), a3 && i$1Z(a3, e28, t3, l3);
    }
    function ln2(e28) {
      const {
        onDragenter: t3
      } = n3;
      t3 && i$1Z(t3, e28);
    }
    function an2(e28) {
      const {
        onDragleave: t3
      } = n3;
      t3 && i$1Z(t3, e28);
    }
    function dn2(e28) {
      const {
        onDragend: t3
      } = n3;
      t3 && i$1Z(t3, e28);
    }
    function on2(e28) {
      const {
        onDragstart: t3
      } = n3;
      t3 && i$1Z(t3, e28);
    }
    function rn2(e28) {
      const {
        onDragover: t3
      } = n3;
      t3 && i$1Z(t3, e28);
    }
    function cn2(e28) {
      const {
        onDrop: t3
      } = n3;
      t3 && i$1Z(t3, e28);
    }
    function de2() {
      sn2(), $3();
    }
    function sn2() {
      ae2.value = null;
    }
    function $3() {
      ye2.value = 0, fe2.value = null, ue2.value = null, he2.value = null, Q3();
    }
    function Q3() {
      O3 && (window.clearTimeout(O3), O3 = null), Y3 = null;
    }
    function De2(e28, t3) {
      if (n3.disabled || B$1(e28, n3.disabledField))
        return;
      if (n3.internalUnifySelectCheck && !n3.multiple) {
        Te2(e28);
        return;
      }
      const l3 = t3 ? "check" : "uncheck", {
        checkedKeys: a3,
        indeterminateKeys: i
      } = P3.value[l3](e28.key, G3.value, {
        cascade: n3.cascade,
        checkStrategy: j3.value,
        allowNotLoaded: n3.allowCheckingNotLoaded
      });
      Be2(a3, k3(a3), {
        node: e28.rawNode,
        action: l3
      }), tn2(i, k3(i));
    }
    function fn2(e28) {
      if (n3.disabled)
        return;
      const {
        key: t3
      } = e28, {
        value: l3
      } = T3, a3 = l3.findIndex((i) => i === t3);
      if (~a3) {
        const i = Array.from(l3);
        i.splice(a3, 1), J3(i, k3(i), {
          node: e28.rawNode,
          action: "collapse"
        });
      } else {
        const i = B3.value.getNode(t3);
        if (!i || i.isLeaf)
          return;
        let c3;
        if (n3.accordion) {
          const g3 = new Set(e28.siblings.map(({
            key: K3
          }) => K3));
          c3 = l3.filter((K3) => !g3.has(K3)), c3.push(t3);
        } else
          c3 = l3.concat(t3);
        J3(c3, k3(c3), {
          node: e28.rawNode,
          action: "expand"
        });
      }
    }
    function Pe2(e28) {
      n3.disabled || q3.value || fn2(e28);
    }
    function Te2(e28) {
      if (!(n3.disabled || !n3.selectable)) {
        if (W3.value = e28.key, n3.internalUnifySelectCheck) {
          const {
            value: {
              checkedKeys: t3,
              indeterminateKeys: l3
            }
          } = M3;
          n3.multiple ? De2(e28, !(t3.includes(e28.key) || l3.includes(e28.key))) : Be2([e28.key], k3([e28.key]), {
            node: e28.rawNode,
            action: "check"
          });
        }
        if (n3.multiple) {
          const t3 = Array.from(ce2.value), l3 = t3.findIndex((a3) => a3 === e28.key);
          ~l3 ? n3.cancelable && t3.splice(l3, 1) : ~l3 || t3.push(e28.key), Fe2(t3, k3(t3), {
            node: e28.rawNode,
            action: ~l3 ? "unselect" : "select"
          });
        } else
          ce2.value.includes(e28.key) ? n3.cancelable && Fe2([], [], {
            node: e28.rawNode,
            action: "unselect"
          }) : Fe2([e28.key], k3([e28.key]), {
            node: e28.rawNode,
            action: "select"
          });
      }
    }
    function un2(e28) {
      if (O3 && (window.clearTimeout(O3), O3 = null), e28.isLeaf)
        return;
      Y3 = e28.key;
      const t3 = () => {
        if (Y3 !== e28.key)
          return;
        const {
          value: l3
        } = ue2;
        if (l3 && l3.key === e28.key && !T3.value.includes(e28.key)) {
          const a3 = T3.value.concat(e28.key);
          J3(a3, k3(a3), {
            node: e28.rawNode,
            action: "expand"
          });
        }
        O3 = null, Y3 = null;
      };
      e28.shallowLoaded ? O3 = window.setTimeout(() => {
        t3();
      }, 1e3) : O3 = window.setTimeout(() => {
        Ae2(e28).then(() => {
          t3();
        });
      }, 1e3);
    }
    function hn2({
      event: e28,
      node: t3
    }) {
      !n3.draggable || n3.disabled || B$1(t3, n3.disabledField) || (pe2({
        event: e28,
        node: t3
      }, false), ln2({
        event: e28,
        node: t3.rawNode
      }));
    }
    function yn2({
      event: e28,
      node: t3
    }) {
      !n3.draggable || n3.disabled || B$1(t3, n3.disabledField) || an2({
        event: e28,
        node: t3.rawNode
      });
    }
    function gn2(e28) {
      e28.target === e28.currentTarget && $3();
    }
    function vn2({
      event: e28,
      node: t3
    }) {
      de2(), !(!n3.draggable || n3.disabled || B$1(t3, n3.disabledField)) && dn2({
        event: e28,
        node: t3.rawNode
      });
    }
    function mn2({
      event: e28,
      node: t3
    }) {
      !n3.draggable || n3.disabled || B$1(t3, n3.disabledField) || (Ie2 = e28.clientX, ae2.value = t3, on2({
        event: e28,
        node: t3.rawNode
      }));
    }
    function pe2({
      event: e28,
      node: t3
    }, l3 = true) {
      var a3;
      if (!n3.draggable || n3.disabled || B$1(t3, n3.disabledField))
        return;
      const {
        value: i
      } = ae2;
      if (!i)
        return;
      const {
        allowDrop: c3,
        indent: g3
      } = n3;
      l3 && rn2({
        event: e28,
        node: t3.rawNode
      });
      const K3 = e28.currentTarget, {
        height: ee2,
        top: ne2
      } = K3.getBoundingClientRect(), C3 = e28.clientY - ne2;
      let o3;
      c3({
        node: t3.rawNode,
        dropPosition: "inside",
        phase: "drag"
      }) ? C3 <= 8 ? o3 = "before" : C3 >= ee2 - 8 ? o3 = "after" : o3 = "inside" : C3 <= ee2 / 2 ? o3 = "before" : o3 = "after";
      const {
        value: D3
      } = Ze2;
      let d3, u3;
      const te2 = D3(t3.key);
      if (te2 === null) {
        $3();
        return;
      }
      let ve2 = false;
      o3 === "inside" ? (d3 = t3, u3 = "inside") : o3 === "before" ? t3.isFirstChild ? (d3 = t3, u3 = "before") : (d3 = X3.value[te2 - 1], u3 = "after") : (d3 = t3, u3 = "after"), !d3.isLeaf && T3.value.includes(d3.key) && (ve2 = true, u3 === "after" && (d3 = X3.value[te2 + 1], d3 ? u3 = "before" : (d3 = t3, u3 = "inside")));
      const Ue2 = d3;
      if (ue2.value = Ue2, !ve2 && i.isLastChild && i.key === d3.key && (u3 = "after"), u3 === "after") {
        let He2 = Ie2 - e28.clientX, Ee2 = 0;
        for (; He2 >= g3 / 2 && d3.parent !== null && d3.isLastChild && Ee2 < 1; )
          He2 -= g3, Ee2 += 1, d3 = d3.parent;
        ye2.value = Ee2;
      } else
        ye2.value = 0;
      if ((i.contains(d3) || u3 === "inside" && ((a3 = i.parent) === null || a3 === void 0 ? void 0 : a3.key) === d3.key) && !(i.key === Ue2.key && i.key === d3.key)) {
        $3();
        return;
      }
      if (!c3({
        node: d3.rawNode,
        dropPosition: u3,
        phase: "drag"
      })) {
        $3();
        return;
      }
      if (i.key === d3.key)
        Q3();
      else if (Y3 !== d3.key)
        if (u3 === "inside") {
          if (n3.expandOnDragenter) {
            if (un2(d3), !d3.shallowLoaded && Y3 !== d3.key) {
              de2();
              return;
            }
          } else if (!d3.shallowLoaded) {
            de2();
            return;
          }
        } else
          Q3();
      else
        u3 !== "inside" && Q3();
      he2.value = u3, fe2.value = d3;
    }
    function bn2({
      event: e28,
      node: t3,
      dropPosition: l3
    }) {
      if (!n3.draggable || n3.disabled || B$1(t3, n3.disabledField))
        return;
      const {
        value: a3
      } = ae2, {
        value: i
      } = fe2, {
        value: c3
      } = he2;
      if (!(!a3 || !i || !c3) && n3.allowDrop({
        node: i.rawNode,
        dropPosition: c3,
        phase: "drag"
      }) && a3.key !== i.key) {
        if (c3 === "before") {
          const g3 = a3.getNext({
            includeDisabled: true
          });
          if (g3 && g3.key === i.key) {
            $3();
            return;
          }
        }
        if (c3 === "after") {
          const g3 = a3.getPrev({
            includeDisabled: true
          });
          if (g3 && g3.key === i.key) {
            $3();
            return;
          }
        }
        cn2({
          event: e28,
          node: i.rawNode,
          dragNode: a3.rawNode,
          dropPosition: l3
        }), de2();
      }
    }
    function kn2() {
      ge2();
    }
    function Kn2() {
      ge2();
    }
    function Sn2(e28) {
      var t3;
      if (n3.virtualScroll || n3.internalScrollable) {
        const {
          value: l3
        } = A3;
        if (!((t3 = l3 == null ? void 0 : l3.containerRef) === null || t3 === void 0) && t3.contains(e28.relatedTarget))
          return;
        W3.value = null;
      } else {
        const {
          value: l3
        } = w3;
        if (l3 != null && l3.contains(e28.relatedTarget))
          return;
        W3.value = null;
      }
    }
    watch(W3, (e28) => {
      var t3, l3;
      if (e28 !== null) {
        if (n3.virtualScroll)
          (t3 = F3.value) === null || t3 === void 0 || t3.scrollTo({
            key: e28
          });
        else if (n3.internalScrollable) {
          const {
            value: a3
          } = A3;
          if (a3 === null)
            return;
          const i = (l3 = a3.contentRef) === null || l3 === void 0 ? void 0 : l3.querySelector(`[data-key="${n$5(e28)}"]`);
          if (!i)
            return;
          a3.scrollTo({
            el: i
          });
        }
      }
    }), provide(n$7, {
      loadingKeysRef: se2,
      highlightKeySetRef: qe2,
      displayedCheckedKeysRef: G3,
      displayedIndeterminateKeysRef: Se2,
      mergedSelectedKeysRef: ce2,
      mergedExpandedKeysRef: T3,
      mergedThemeRef: s3,
      mergedCheckStrategyRef: j3,
      nodePropsRef: toRef$1(n3, "nodeProps"),
      disabledRef: toRef$1(n3, "disabled"),
      checkableRef: toRef$1(n3, "checkable"),
      selectableRef: toRef$1(n3, "selectable"),
      expandOnClickRef: toRef$1(n3, "expandOnClick"),
      onLoadRef: toRef$1(n3, "onLoad"),
      draggableRef: toRef$1(n3, "draggable"),
      blockLineRef: toRef$1(n3, "blockLine"),
      indentRef: toRef$1(n3, "indent"),
      cascadeRef: toRef$1(n3, "cascade"),
      checkOnClickRef: toRef$1(n3, "checkOnClick"),
      checkboxPlacementRef: n3.checkboxPlacement,
      droppingMouseNodeRef: ue2,
      droppingNodeParentRef: Qe2,
      draggingNodeRef: ae2,
      droppingPositionRef: he2,
      droppingOffsetLevelRef: ye2,
      fNodesRef: X3,
      pendingNodeKeyRef: W3,
      showLineRef: toRef$1(n3, "showLine"),
      disabledFieldRef: toRef$1(n3, "disabledField"),
      internalScrollableRef: toRef$1(n3, "internalScrollable"),
      internalCheckboxFocusableRef: toRef$1(n3, "internalCheckboxFocusable"),
      internalTreeSelect: n3.internalTreeSelect,
      renderLabelRef: toRef$1(n3, "renderLabel"),
      renderPrefixRef: toRef$1(n3, "renderPrefix"),
      renderSuffixRef: toRef$1(n3, "renderSuffix"),
      renderSwitcherIconRef: toRef$1(n3, "renderSwitcherIcon"),
      labelFieldRef: toRef$1(n3, "labelField"),
      multipleRef: toRef$1(n3, "multiple"),
      overrideDefaultNodeClickBehaviorRef: toRef$1(n3, "overrideDefaultNodeClickBehavior"),
      handleSwitcherClick: Pe2,
      handleDragEnd: vn2,
      handleDragEnter: hn2,
      handleDragLeave: yn2,
      handleDragStart: mn2,
      handleDrop: bn2,
      handleDragOver: pe2,
      handleSelect: Te2,
      handleCheck: De2
    });
    function xn2(e28, t3) {
      var l3, a3;
      typeof e28 == "number" ? (l3 = F3.value) === null || l3 === void 0 || l3.scrollTo(e28, t3 || 0) : (a3 = F3.value) === null || a3 === void 0 || a3.scrollTo(e28);
    }
    const Rn2 = {
      handleKeydown: We2,
      scrollTo: xn2,
      getCheckedData: () => {
        if (!n3.checkable)
          return {
            keys: [],
            options: []
          };
        const {
          checkedKeys: e28
        } = M3.value;
        return {
          keys: e28,
          options: k3(e28)
        };
      },
      getIndeterminateData: () => {
        if (!n3.checkable)
          return {
            keys: [],
            options: []
          };
        const {
          indeterminateKeys: e28
        } = M3.value;
        return {
          keys: e28,
          options: k3(e28)
        };
      }
    }, _e2 = computed(() => {
      const {
        common: {
          cubicBezierEaseInOut: e28
        },
        self: {
          fontSize: t3,
          nodeBorderRadius: l3,
          nodeColorHover: a3,
          nodeColorPressed: i,
          nodeColorActive: c3,
          arrowColor: g3,
          loadingColor: K3,
          nodeTextColor: ee2,
          nodeTextColorDisabled: ne2,
          dropMarkColor: C3,
          nodeWrapperPadding: o3,
          nodeHeight: N3,
          lineHeight: D3,
          lineColor: d3
        }
      } = s3.value, u3 = f$1f(o3, "top"), te2 = f$1f(o3, "bottom"), ve2 = o$1f(i$1y(N3) - i$1y(u3) - i$1y(te2));
      return {
        "--n-arrow-color": g3,
        "--n-loading-color": K3,
        "--n-bezier": e28,
        "--n-font-size": t3,
        "--n-node-border-radius": l3,
        "--n-node-color-active": c3,
        "--n-node-color-hover": a3,
        "--n-node-color-pressed": i,
        "--n-node-text-color": ee2,
        "--n-node-text-color-disabled": ne2,
        "--n-drop-mark-color": C3,
        "--n-node-wrapper-padding": o3,
        "--n-line-offset-top": `-${u3}`,
        "--n-line-offset-bottom": `-${te2}`,
        "--n-node-content-height": ve2,
        "--n-line-height": D3,
        "--n-line-color": d3
      };
    }), Z3 = R3 ? E$J("tree", void 0, _e2, n3) : void 0;
    return Object.assign(Object.assign({}, Rn2), {
      mergedClsPrefix: x3,
      mergedTheme: s3,
      rtlEnabled: V10,
      fNodes: en2,
      aip: q3,
      selfElRef: w3,
      virtualListInstRef: F3,
      scrollbarInstRef: A3,
      handleFocusout: Sn2,
      handleDragLeaveTree: gn2,
      handleScroll: kn2,
      getScrollContainer: U3,
      getScrollContent: m3,
      handleAfterEnter: nn2,
      handleResize: Kn2,
      cssVars: R3 ? void 0 : _e2,
      themeClass: Z3 == null ? void 0 : Z3.themeClass,
      onRender: Z3 == null ? void 0 : Z3.onRender
    });
  },
  render() {
    var n3;
    const {
      fNodes: x3,
      internalRenderEmpty: R3
    } = this;
    if (!x3.length && R3)
      return R3();
    const {
      mergedClsPrefix: f3,
      blockNode: V10,
      blockLine: s3,
      draggable: w3,
      disabled: A3,
      internalFocusable: F3,
      checkable: U3,
      handleKeydown: m3,
      rtlEnabled: E3,
      handleFocusout: H3,
      scrollbarProps: B3
    } = this, L3 = F3 && !A3, P3 = L3 ? "0" : void 0, y3 = [`${f3}-tree`, E3 && `${f3}-tree--rtl`, U3 && `${f3}-tree--checkable`, (s3 || V10) && `${f3}-tree--block-node`, s3 && `${f3}-tree--block-line`], p3 = (b3) => "__motion" in b3 ? h$1R(f$2, {
      height: b3.height,
      nodes: b3.nodes,
      clsPrefix: f3,
      mode: b3.mode,
      onAfterEnter: this.handleAfterEnter
    }) : h$1R(be$2, {
      key: b3.key,
      tmNode: b3,
      clsPrefix: f3
    });
    if (this.virtualScroll) {
      const {
        mergedTheme: b3,
        internalScrollablePadding: M3
      } = this, j3 = f$1f(M3 || "0");
      return h$1R(vn$3, Object.assign({}, B3, {
        ref: "scrollbarInstRef",
        onDragleave: w3 ? this.handleDragLeaveTree : void 0,
        container: this.getScrollContainer,
        content: this.getScrollContent,
        class: y3,
        theme: b3.peers.Scrollbar,
        themeOverrides: b3.peerOverrides.Scrollbar,
        tabindex: P3,
        onKeydown: L3 ? m3 : void 0,
        onFocusout: L3 ? H3 : void 0
      }), {
        default: () => {
          var G3;
          return (G3 = this.onRender) === null || G3 === void 0 || G3.call(this), x3.length ? h$1R(ve$c, {
            ref: "virtualListInstRef",
            items: this.fNodes,
            itemSize: i$1y(b3.self.nodeHeight),
            ignoreItemResize: this.aip,
            paddingTop: j3.top,
            paddingBottom: j3.bottom,
            class: this.themeClass,
            style: [this.cssVars, {
              paddingLeft: j3.left,
              paddingRight: j3.right
            }],
            onScroll: this.handleScroll,
            onResize: this.handleResize,
            showScrollbar: false,
            itemResizable: true
          }, {
            default: ({
              item: Se2
            }) => p3(Se2)
          }) : p$3H(this.$slots.empty, () => [h$1R(q$s, {
            class: `${f3}-tree__empty`,
            theme: this.mergedTheme.peers.Empty,
            themeOverrides: this.mergedTheme.peerOverrides.Empty
          })]);
        }
      });
    }
    const {
      internalScrollable: Ke2
    } = this;
    return y3.push(this.themeClass), (n3 = this.onRender) === null || n3 === void 0 || n3.call(this), Ke2 ? h$1R(vn$3, Object.assign({}, B3, {
      class: y3,
      tabindex: P3,
      onKeydown: L3 ? m3 : void 0,
      onFocusout: L3 ? H3 : void 0,
      style: this.cssVars,
      contentStyle: {
        padding: this.internalScrollablePadding
      }
    }), {
      default: () => h$1R("div", {
        onDragleave: w3 ? this.handleDragLeaveTree : void 0,
        ref: "selfElRef"
      }, this.fNodes.map(p3))
    }) : h$1R("div", {
      class: y3,
      tabindex: P3,
      ref: "selfElRef",
      style: this.cssVars,
      onKeydown: L3 ? m3 : void 0,
      onFocusout: L3 ? H3 : void 0,
      onDragleave: w3 ? this.handleDragLeaveTree : void 0
    }, x3.length ? x3.map(p3) : p$3H(this.$slots.empty, () => [h$1R(q$s, {
      class: `${f3}-tree__empty`,
      theme: this.mergedTheme.peers.Empty,
      themeOverrides: this.mergedTheme.peerOverrides.Empty
    })]));
  }
});
function c$3(e28, n3) {
  const {
    rawNode: t3
  } = e28;
  return Object.assign(Object.assign({}, t3), {
    label: t3[n3],
    value: e28.key
  });
}
function r$2(e28, n3, t3, a3) {
  const {
    rawNode: i
  } = e28;
  return Object.assign(Object.assign({}, i), {
    value: e28.key,
    label: n3.map((o3) => o3.rawNode[a3]).join(t3)
  });
}
const t$1 = r$2a([l$25("tree-select", `
 z-index: auto;
 outline: none;
 width: 100%;
 position: relative;
 `), l$25("tree-select-menu", `
 position: relative;
 overflow: hidden;
 margin: 4px 0;
 transition: box-shadow .3s var(--n-bezier), background-color .3s var(--n-bezier);
 border-radius: var(--n-menu-border-radius);
 box-shadow: var(--n-menu-box-shadow);
 background-color: var(--n-menu-color);
 outline: none;
 `, [l$25("tree", "max-height: var(--n-menu-height);"), M$y("empty", `
 display: flex;
 padding: 12px 32px;
 flex: 1;
 justify-content: center;
 `), M$y("action", `
 padding: var(--n-action-padding);
 transition: 
 color .3s var(--n-bezier);
 border-color .3s var(--n-bezier);
 border-top: 1px solid var(--n-action-divider-color);
 color: var(--n-action-text-color);
 `), $$n()])]);
const h$3 = (e28) => {
  const {
    popoverColor: o3,
    boxShadow2: t3,
    borderRadius: r3,
    heightMedium: i,
    dividerColor: m3,
    textColor2: n3
  } = e28;
  return {
    menuPadding: "4px",
    menuColor: o3,
    menuBoxShadow: t3,
    menuBorderRadius: r3,
    menuHeight: `calc(${i} * 7.6)`,
    actionDividerColor: m3,
    actionTextColor: n3,
    actionPadding: "8px 12px"
  };
}, g$1 = G$w({
  name: "TreeSelect",
  common: d$1T,
  peers: {
    Tree: y$4,
    Empty: x$v,
    InternalSelection: V$p
  },
  self: h$3
}), C$2 = g$1;
const yt$1 = Object.assign(Object.assign(Object.assign(Object.assign({}, _$F.props), {
  bordered: {
    type: Boolean,
    default: true
  },
  cascade: Boolean,
  checkable: Boolean,
  clearable: Boolean,
  clearFilterAfterSelect: {
    type: Boolean,
    default: true
  },
  consistentMenuWidth: {
    type: Boolean,
    default: true
  },
  defaultShow: Boolean,
  defaultValue: {
    type: [String, Number, Array],
    default: null
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  filterable: Boolean,
  checkStrategy: {
    type: String,
    default: "all"
  },
  loading: Boolean,
  maxTagCount: [String, Number],
  multiple: Boolean,
  showPath: Boolean,
  separator: {
    type: String,
    default: " / "
  },
  options: {
    type: Array,
    default: () => []
  },
  placeholder: String,
  placement: {
    type: String,
    default: "bottom-start"
  },
  show: {
    type: Boolean,
    default: void 0
  },
  size: String,
  value: [String, Number, Array],
  to: f$1m.propTo,
  menuProps: Object,
  virtualScroll: {
    type: Boolean,
    default: true
  },
  status: String,
  renderTag: Function,
  ellipsisTagPopoverProps: Object
}), qn$1), {
  renderLabel: Function,
  renderPrefix: Function,
  renderSuffix: Function,
  nodeProps: Function,
  watchProps: Array,
  getChildren: Function,
  onBlur: Function,
  onFocus: Function,
  onLoad: Function,
  onUpdateShow: [Function, Array],
  onUpdateValue: [Function, Array],
  "onUpdate:value": [Function, Array],
  "onUpdate:show": [Function, Array],
  leafOnly: Boolean
}), Gt$1 = defineComponent({
  name: "TreeSelect",
  props: yt$1,
  setup(t3) {
    const T3 = ref$1(null), d3 = ref$1(null), g3 = ref$1(null), i = ref$1(null), {
      mergedClsPrefixRef: F3,
      namespaceRef: M3,
      inlineThemeDisabled: f3
    } = a$2x(t3), {
      localeRef: N3
    } = R$p("Select"), {
      mergedSizeRef: P3,
      mergedDisabledRef: A3,
      mergedStatusRef: ae2,
      nTriggerFormBlur: re2,
      nTriggerFormChange: oe2,
      nTriggerFormFocus: ie2,
      nTriggerFormInput: de2
    } = h$1B(t3), D3 = ref$1(t3.defaultValue), se2 = toRef$1(t3, "value"), p3 = d$1S(se2, D3), j3 = ref$1(t3.defaultShow), ue2 = toRef$1(t3, "show"), S3 = d$1S(ue2, j3), C3 = ref$1(""), ce2 = computed(() => {
      const {
        filter: e28
      } = t3;
      if (e28)
        return e28;
      const {
        labelField: n3
      } = t3;
      return (a3, l3) => a3.length ? l3[n3].toLowerCase().includes(a3.toLowerCase()) : true;
    }), b3 = computed(() => U$s(t3.options, Yn$1(t3.keyField, t3.childrenField, t3.disabledField, void 0))), {
      value: x3
    } = p3, z3 = ref$1(t3.checkable ? null : Array.isArray(x3) && x3.length ? x3[x3.length - 1] : null), O3 = computed(() => t3.multiple && t3.cascade && t3.checkable), $3 = ref$1(t3.defaultExpandAll ? void 0 : t3.defaultExpandedKeys || t3.expandedKeys), fe2 = toRef$1(t3, "expandedKeys"), he2 = d$1S(fe2, $3), R3 = ref$1(false), me2 = computed(() => {
      const {
        placeholder: e28
      } = t3;
      return e28 !== void 0 ? e28 : N3.value.placeholder;
    }), ge2 = computed(() => t3.checkable ? [] : W3.value), W3 = computed(() => {
      const {
        value: e28
      } = p3;
      return t3.multiple ? Array.isArray(e28) ? e28 : [] : e28 === null || Array.isArray(e28) ? [] : [e28];
    }), ve2 = computed(() => {
      const {
        multiple: e28,
        showPath: n3,
        separator: a3,
        labelField: l3
      } = t3;
      if (e28)
        return null;
      const {
        value: r3
      } = p3;
      if (!Array.isArray(r3) && r3 !== null) {
        const {
          value: o3
        } = b3, h3 = o3.getNode(r3);
        if (h3 !== null)
          return n3 ? r$2(h3, o3.getPath(r3).treeNodePath, a3, l3) : c$3(h3, l3);
      }
      return null;
    }), ye2 = computed(() => {
      const {
        multiple: e28,
        showPath: n3,
        separator: a3
      } = t3;
      if (!e28)
        return null;
      const {
        value: l3
      } = p3;
      if (Array.isArray(l3)) {
        const r3 = [], {
          value: o3
        } = b3, {
          checkedKeys: h3
        } = o3.getCheckedKeys(l3, {
          checkStrategy: t3.checkStrategy,
          cascade: O3.value,
          allowNotLoaded: t3.allowCheckingNotLoaded
        }), {
          labelField: c3
        } = t3;
        return h3.forEach((ee2) => {
          const _3 = o3.getNode(ee2);
          _3 !== null && r3.push(n3 ? r$2(_3, o3.getPath(ee2).treeNodePath, a3, c3) : c$3(_3, c3));
        }), r3;
      }
      return [];
    }), pe2 = computed(() => {
      const {
        self: {
          menuPadding: e28
        }
      } = E3.value;
      return e28;
    });
    function I3() {
      var e28;
      (e28 = d3.value) === null || e28 === void 0 || e28.focus();
    }
    function H3() {
      var e28;
      (e28 = d3.value) === null || e28 === void 0 || e28.focusInput();
    }
    function q3(e28) {
      const {
        onUpdateShow: n3,
        "onUpdate:show": a3
      } = t3;
      n3 && i$1Z(n3, e28), a3 && i$1Z(a3, e28), j3.value = e28;
    }
    function w3(e28, n3, a3) {
      const {
        onUpdateValue: l3,
        "onUpdate:value": r3
      } = t3;
      l3 && i$1Z(l3, e28, n3, a3), r3 && i$1Z(r3, e28, n3, a3), D3.value = e28, de2(), oe2();
    }
    function Se2(e28, n3) {
      const {
        onUpdateIndeterminateKeys: a3,
        "onUpdate:indeterminateKeys": l3
      } = t3;
      a3 && i$1Z(a3, e28, n3), l3 && i$1Z(l3, e28, n3);
    }
    function be2(e28, n3, a3) {
      const {
        onUpdateExpandedKeys: l3,
        "onUpdate:expandedKeys": r3
      } = t3;
      l3 && i$1Z(l3, e28, n3, a3), r3 && i$1Z(r3, e28, n3, a3), $3.value = e28;
    }
    function G3(e28) {
      const {
        onFocus: n3
      } = t3;
      n3 && n3(e28), ie2();
    }
    function J3(e28) {
      v3();
      const {
        onBlur: n3
      } = t3;
      n3 && n3(e28), re2();
    }
    function v3() {
      q3(false);
    }
    function B3() {
      A3.value || (C3.value = "", q3(true), t3.filterable && H3());
    }
    function we2() {
      C3.value = "";
    }
    function ke2(e28) {
      var n3;
      S3.value && (!((n3 = d3.value) === null || n3 === void 0) && n3.$el.contains(t$1G(e28)) || v3());
    }
    function Ke2() {
      A3.value || (S3.value ? t3.filterable || v3() : B3());
    }
    function k3(e28) {
      const {
        value: {
          getNode: n3
        }
      } = b3;
      return e28.map((a3) => {
        var l3;
        return ((l3 = n3(a3)) === null || l3 === void 0 ? void 0 : l3.rawNode) || null;
      });
    }
    function Te2(e28, n3, a3) {
      const l3 = k3(e28), r3 = a3.action === "check" ? "select" : "unselect", o3 = a3.node;
      t3.multiple ? (w3(e28, l3, {
        node: o3,
        action: r3
      }), t3.filterable && (H3(), t3.clearFilterAfterSelect && (C3.value = ""))) : (e28.length ? w3(e28[0], l3[0] || null, {
        node: o3,
        action: r3
      }) : w3(null, null, {
        node: o3,
        action: r3
      }), v3(), I3());
    }
    function Ce2(e28) {
      t3.checkable && Se2(e28, k3(e28));
    }
    function Re2(e28) {
      var n3;
      !((n3 = i.value) === null || n3 === void 0) && n3.contains(e28.relatedTarget) || (R3.value = true, G3(e28));
    }
    function Fe2(e28) {
      var n3;
      !((n3 = i.value) === null || n3 === void 0) && n3.contains(e28.relatedTarget) || (R3.value = false, J3(e28));
    }
    function Pe2(e28) {
      var n3, a3, l3;
      !((n3 = i.value) === null || n3 === void 0) && n3.contains(e28.relatedTarget) || !((l3 = (a3 = d3.value) === null || a3 === void 0 ? void 0 : a3.$el) === null || l3 === void 0) && l3.contains(e28.relatedTarget) || (R3.value = true, G3(e28));
    }
    function xe2(e28) {
      var n3, a3, l3;
      !((n3 = i.value) === null || n3 === void 0) && n3.contains(e28.relatedTarget) || !((l3 = (a3 = d3.value) === null || a3 === void 0 ? void 0 : a3.$el) === null || l3 === void 0) && l3.contains(e28.relatedTarget) || (R3.value = false, J3(e28));
    }
    function Oe2(e28) {
      e28.stopPropagation();
      const {
        multiple: n3
      } = t3;
      !n3 && t3.filterable && v3(), n3 ? w3([], [], {
        node: null,
        action: "clear"
      }) : w3(null, null, {
        node: null,
        action: "clear"
      });
    }
    function Ie2(e28) {
      const {
        value: n3
      } = p3;
      if (Array.isArray(n3)) {
        const {
          value: a3
        } = b3, {
          checkedKeys: l3
        } = a3.getCheckedKeys(n3, {
          cascade: O3.value,
          allowNotLoaded: t3.allowCheckingNotLoaded
        }), r3 = l3.findIndex((o3) => o3 === e28.value);
        if (~r3) {
          const o3 = l3[r3], h3 = k3([o3])[0];
          if (t3.checkable) {
            const {
              checkedKeys: c3
            } = a3.uncheck(e28.value, l3, {
              checkStrategy: t3.checkStrategy,
              cascade: O3.value,
              allowNotLoaded: t3.allowCheckingNotLoaded
            });
            w3(c3, k3(c3), {
              node: h3,
              action: "delete"
            });
          } else {
            const c3 = Array.from(l3);
            c3.splice(r3, 1), w3(c3, k3(c3), {
              node: h3,
              action: "delete"
            });
          }
        }
      }
    }
    function Me2(e28) {
      const {
        value: n3
      } = e28.target;
      C3.value = n3;
    }
    function Q3(e28) {
      const {
        value: n3
      } = g3;
      return n3 ? n3.handleKeydown(e28) : {
        enterBehavior: null
      };
    }
    function Ne2(e28) {
      if (e28.key === "Enter") {
        if (S3.value) {
          const {
            enterBehavior: n3
          } = Q3(e28);
          if (!t3.multiple)
            switch (n3) {
              case "default":
              case "toggleSelect":
                v3(), I3();
                break;
            }
        } else
          B3();
        e28.preventDefault();
      } else
        e28.key === "Escape" ? S3.value && (n$1D(e28), v3(), I3()) : S3.value ? Q3(e28) : e28.key === "ArrowDown" && B3();
    }
    function Ae2() {
      v3(), I3();
    }
    function Be2(e28) {
      a$2j(e28, "action") || e28.preventDefault();
    }
    const Ee2 = computed(() => {
      const {
        renderTag: e28
      } = t3;
      if (e28)
        return function({
          option: a3,
          handleClose: l3
        }) {
          const {
            value: r3
          } = a3;
          if (r3 !== void 0) {
            const o3 = b3.value.getNode(r3);
            if (o3)
              return e28({
                option: o3.rawNode,
                handleClose: l3
              });
          }
          return r3;
        };
    });
    provide(c$4, {
      pendingNodeKeyRef: z3,
      dataTreeMate: b3
    });
    function X3() {
      var e28;
      S3.value && ((e28 = T3.value) === null || e28 === void 0 || e28.syncPosition());
    }
    a$1D(i, X3);
    const _e2 = O$3(t3), Y3 = computed(() => {
      if (t3.checkable) {
        const e28 = p3.value;
        return t3.multiple && Array.isArray(e28) ? b3.value.getCheckedKeys(e28, {
          cascade: t3.cascade,
          checkStrategy: _e2.value,
          allowNotLoaded: t3.allowCheckingNotLoaded
        }) : {
          checkedKeys: Array.isArray(e28) || e28 === null ? [] : [e28],
          indeterminateKeys: []
        };
      }
      return {
        checkedKeys: [],
        indeterminateKeys: []
      };
    }), Ue2 = {
      getCheckedData: () => {
        const {
          checkedKeys: e28
        } = Y3.value;
        return {
          keys: e28,
          options: k3(e28)
        };
      },
      getIndeterminateData: () => {
        const {
          indeterminateKeys: e28
        } = Y3.value;
        return {
          keys: e28,
          options: k3(e28)
        };
      },
      focus: () => {
        var e28;
        return (e28 = d3.value) === null || e28 === void 0 ? void 0 : e28.focus();
      },
      focusInput: () => {
        var e28;
        return (e28 = d3.value) === null || e28 === void 0 ? void 0 : e28.focusInput();
      },
      blur: () => {
        var e28;
        return (e28 = d3.value) === null || e28 === void 0 ? void 0 : e28.blur();
      },
      blurInput: () => {
        var e28;
        return (e28 = d3.value) === null || e28 === void 0 ? void 0 : e28.blurInput();
      }
    }, E3 = _$F("TreeSelect", "-tree-select", t$1, C$2, t3, F3), Z3 = computed(() => {
      const {
        common: {
          cubicBezierEaseInOut: e28
        },
        self: {
          menuBoxShadow: n3,
          menuBorderRadius: a3,
          menuColor: l3,
          menuHeight: r3,
          actionPadding: o3,
          actionDividerColor: h3,
          actionTextColor: c3
        }
      } = E3.value;
      return {
        "--n-menu-box-shadow": n3,
        "--n-menu-border-radius": a3,
        "--n-menu-color": l3,
        "--n-menu-height": r3,
        "--n-bezier": e28,
        "--n-action-padding": o3,
        "--n-action-text-color": c3,
        "--n-action-divider-color": h3
      };
    }), K3 = f3 ? E$J("tree-select", void 0, Z3, t3) : void 0;
    return Object.assign(Object.assign({}, Ue2), {
      menuElRef: i,
      mergedStatus: ae2,
      triggerInstRef: d3,
      followerInstRef: T3,
      treeInstRef: g3,
      mergedClsPrefix: F3,
      mergedValue: p3,
      mergedShow: S3,
      namespace: M3,
      adjustedTo: f$1m(t3),
      isMounted: u$1C(),
      focused: R3,
      menuPadding: pe2,
      mergedPlaceholder: me2,
      mergedExpandedKeys: he2,
      treeSelectedKeys: ge2,
      treeCheckedKeys: W3,
      mergedSize: P3,
      mergedDisabled: A3,
      selectedOption: ve2,
      selectedOptions: ye2,
      pattern: C3,
      pendingNodeKey: z3,
      mergedCascade: O3,
      mergedFilter: ce2,
      selectionRenderTag: Ee2,
      handleTriggerOrMenuResize: X3,
      doUpdateExpandedKeys: be2,
      handleMenuLeave: we2,
      handleTriggerClick: Ke2,
      handleMenuClickoutside: ke2,
      handleUpdateCheckedKeys: Te2,
      handleUpdateIndeterminateKeys: Ce2,
      handleTriggerFocus: Re2,
      handleTriggerBlur: Fe2,
      handleMenuFocusin: Pe2,
      handleMenuFocusout: xe2,
      handleClear: Oe2,
      handleDeleteOption: Ie2,
      handlePatternInput: Me2,
      handleKeydown: Ne2,
      handleTabOut: Ae2,
      handleMenuMousedown: Be2,
      mergedTheme: E3,
      cssVars: f3 ? void 0 : Z3,
      themeClass: K3 == null ? void 0 : K3.themeClass,
      onRender: K3 == null ? void 0 : K3.onRender
    });
  },
  render() {
    const {
      mergedTheme: t3,
      mergedClsPrefix: T3,
      $slots: d3
    } = this;
    return h$1R("div", {
      class: `${T3}-tree-select`
    }, h$1R(F$x, null, {
      default: () => [h$1R(g$19, null, {
        default: () => h$1R(Kt$3, {
          ref: "triggerInstRef",
          onResize: this.handleTriggerOrMenuResize,
          status: this.mergedStatus,
          focused: this.focused,
          clsPrefix: T3,
          theme: t3.peers.InternalSelection,
          themeOverrides: t3.peerOverrides.InternalSelection,
          ellipsisTagPopoverProps: this.ellipsisTagPopoverProps,
          renderTag: this.selectionRenderTag,
          selectedOption: this.selectedOption,
          selectedOptions: this.selectedOptions,
          size: this.mergedSize,
          bordered: this.bordered,
          placeholder: this.mergedPlaceholder,
          disabled: this.mergedDisabled,
          active: this.mergedShow,
          loading: this.loading,
          multiple: this.multiple,
          maxTagCount: this.maxTagCount,
          showArrow: true,
          filterable: this.filterable,
          clearable: this.clearable,
          pattern: this.pattern,
          onPatternInput: this.handlePatternInput,
          onClear: this.handleClear,
          onClick: this.handleTriggerClick,
          onFocus: this.handleTriggerFocus,
          onBlur: this.handleTriggerBlur,
          onDeleteOption: this.handleDeleteOption,
          onKeydown: this.handleKeydown
        }, {
          arrow: () => {
            var g3, i;
            return [(i = (g3 = this.$slots).arrow) === null || i === void 0 ? void 0 : i.call(g3)];
          }
        })
      }), h$1R(me$h, {
        ref: "followerInstRef",
        show: this.mergedShow,
        placement: this.placement,
        to: this.adjustedTo,
        teleportDisabled: this.adjustedTo === f$1m.tdkey,
        containerClass: this.namespace,
        width: this.consistentMenuWidth ? "target" : void 0,
        minWidth: "target"
      }, {
        default: () => h$1R(Transition, {
          name: "fade-in-scale-up-transition",
          appear: this.isMounted,
          onLeave: this.handleMenuLeave
        }, {
          default: () => {
            var g3;
            if (!this.mergedShow)
              return null;
            const {
              mergedClsPrefix: i,
              checkable: F3,
              multiple: M3,
              menuProps: f3,
              options: N3
            } = this;
            return (g3 = this.onRender) === null || g3 === void 0 || g3.call(this), withDirectives(h$1R("div", Object.assign({}, f3, {
              class: [`${i}-tree-select-menu`, f3 == null ? void 0 : f3.class, this.themeClass],
              ref: "menuElRef",
              style: [(f3 == null ? void 0 : f3.style) || "", this.cssVars],
              tabindex: 0,
              onMousedown: this.handleMenuMousedown,
              onKeydown: this.handleKeydown,
              onFocusin: this.handleMenuFocusin,
              onFocusout: this.handleMenuFocusout
            }), h$1R(wt$1, {
              ref: "treeInstRef",
              blockLine: true,
              allowCheckingNotLoaded: this.allowCheckingNotLoaded,
              showIrrelevantNodes: false,
              animated: false,
              pattern: this.pattern,
              getChildren: this.getChildren,
              filter: this.mergedFilter,
              data: N3,
              cancelable: M3,
              labelField: this.labelField,
              keyField: this.keyField,
              disabledField: this.disabledField,
              childrenField: this.childrenField,
              theme: t3.peers.Tree,
              themeOverrides: t3.peerOverrides.Tree,
              defaultExpandAll: this.defaultExpandAll,
              defaultExpandedKeys: this.defaultExpandedKeys,
              expandedKeys: this.mergedExpandedKeys,
              checkedKeys: this.treeCheckedKeys,
              selectedKeys: this.treeSelectedKeys,
              checkable: F3,
              checkStrategy: this.checkStrategy,
              cascade: this.mergedCascade,
              leafOnly: this.leafOnly,
              multiple: this.multiple,
              renderLabel: this.renderLabel,
              renderPrefix: this.renderPrefix,
              renderSuffix: this.renderSuffix,
              renderSwitcherIcon: this.renderSwitcherIcon,
              nodeProps: this.nodeProps,
              watchProps: this.watchProps,
              virtualScroll: this.consistentMenuWidth && this.virtualScroll,
              overrideDefaultNodeClickBehavior: this.overrideDefaultNodeClickBehavior,
              internalTreeSelect: true,
              internalUnifySelectCheck: true,
              internalScrollable: true,
              internalScrollablePadding: this.menuPadding,
              internalFocusable: false,
              internalCheckboxFocusable: false,
              internalRenderEmpty: () => h$1R("div", {
                class: `${i}-tree-select-menu__empty`
              }, p$3H(d3.empty, () => [h$1R(q$s, {
                theme: t3.peers.Empty,
                themeOverrides: t3.peerOverrides.Empty
              })])),
              onLoad: this.onLoad,
              onUpdateCheckedKeys: this.handleUpdateCheckedKeys,
              onUpdateIndeterminateKeys: this.handleUpdateIndeterminateKeys,
              onUpdateExpandedKeys: this.doUpdateExpandedKeys
            }), m$26(d3.action, (P3) => P3 ? h$1R("div", {
              class: `${i}-tree-select-menu__action`,
              "data-action": true
            }, P3) : null), h$1R(u$1l, {
              onFocus: this.handleTabOut
            })), [[a$2i, this.handleMenuClickoutside, void 0, {
              capture: true
            }]]);
          }
        })
      })]
    }));
  }
});
const m$1 = defineComponent({
  name: "UITreeSelect",
  inheritAttrs: false
}), y$3 = defineComponent(__spreadProps(__spreadValues({}, m$1), {
  props: {
    id: {
      type: String,
      required: true
    },
    allowCheckingNotLoaded: {
      type: Boolean,
      default: false
    },
    cascade: {
      type: Boolean,
      default: false
    },
    checkable: {
      type: Boolean,
      default: false
    },
    checkStrategy: {
      type: String,
      default: "all"
    },
    clearable: {
      type: Boolean,
      default: false
    },
    consistentMenuWidth: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    maxTagCount: {
      type: [Number, String],
      validator: (e28) => typeof e28 == "number" || e28 === "responsive" ? true : (console.warn('Invalid maxTagCount prop. It should be a number or "responsive".'), false),
      default: void 0
    },
    multiple: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: "Please Select"
    },
    placement: {
      type: String,
      default: "bottom-start"
    },
    renderLabel: {
      type: Function,
      default: void 0
    },
    renderPrefix: {
      type: Function,
      default: void 0
    },
    renderSuffix: {
      type: Function,
      default: void 0
    },
    size: {
      type: String,
      default: "medium"
    },
    status: {
      type: String,
      default: void 0
    },
    value: {
      type: [String, Number, Array],
      default: void 0
    },
    onLoad: {
      type: Function,
      default: void 0
    }
  },
  emits: ["update:value"],
  setup(e28) {
    return (t3, n3) => (openBlock(), createBlock(unref(Gt$1), {
      id: e28.id,
      "allow-checking-not-loaded": e28.allowCheckingNotLoaded,
      cascade: e28.cascade,
      checkable: e28.checkable,
      "check-strategy": e28.checkStrategy,
      clearable: e28.clearable,
      "consistent-menu-width": e28.consistentMenuWidth,
      disabled: e28.disabled,
      filterable: e28.filterable,
      loading: e28.loading,
      "max-tag-count": e28.maxTagCount,
      multiple: e28.multiple,
      options: e28.options,
      placeholder: e28.placeholder,
      placement: e28.placement,
      "render-label": e28.renderLabel,
      "render-prefix": e28.renderPrefix,
      "render-suffix": e28.renderSuffix,
      size: e28.size,
      status: e28.status,
      value: e28.value,
      "onUpdate:value": n3[0] || (n3[0] = (o3, i, r3) => t3.$emit("update:value", o3, i, r3)),
      onLoad: e28.onLoad
    }, {
      action: withCtx(() => [
        renderSlot(t3.$slots, "action")
      ]),
      arrow: withCtx(() => [
        renderSlot(t3.$slots, "arrow")
      ]),
      empty: withCtx(() => [
        renderSlot(t3.$slots, "empty")
      ]),
      _: 3
    }, 8, ["id", "allow-checking-not-loaded", "cascade", "checkable", "check-strategy", "clearable", "consistent-menu-width", "disabled", "filterable", "loading", "max-tag-count", "multiple", "options", "placeholder", "placement", "render-label", "render-prefix", "render-suffix", "size", "status", "value", "onLoad"]));
  }
})), h$2 = y$3;
function a$1(t3, n3) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8 16l4-4m0 0l4 4m-4-4v9m8-4.257A5.5 5.5 0 0016.5 7a.62.62 0 01-.534-.302 7.5 7.5 0 10-11.78 9.096"
    })
  ]);
}
const c$2 = (n3) => {
  if (n3) {
    const { url: t3, name: e28 } = n3;
    if (!t3)
      return;
    const o3 = document.createElement("a");
    return o3.href = t3, o3.target = "_blank", e28 !== void 0 && (o3.download = e28), document.body.appendChild(o3), o3.click(), document.body.removeChild(o3), true;
  }
  return null;
};
const n$4 = n$28("n-upload");
const u = "__UPLOAD_DRAGGER__", c$1 = defineComponent({
  name: "UploadDragger",
  [u]: true,
  setup(i, {
    slots: a3
  }) {
    const e28 = inject(n$4, null);
    return e28 || t$1P("upload-dragger", "`n-upload-dragger` must be placed inside `n-upload`."), () => {
      const {
        mergedClsPrefixRef: {
          value: r3
        },
        mergedDisabledRef: {
          value: d3
        },
        maxReachedRef: {
          value: o3
        }
      } = e28;
      return h$1R("div", {
        class: [`${r3}-upload-dragger`, (d3 || o3) && `${r3}-upload-dragger--disabled`]
      }, a3);
    };
  }
});
var d$1 = globalThis && globalThis.__awaiter || function(e28, n3, i, r3) {
  function u3(t3) {
    return t3 instanceof i ? t3 : new i(function(o3) {
      o3(t3);
    });
  }
  return new (i || (i = Promise))(function(t3, o3) {
    function l3(c3) {
      try {
        a3(r3.next(c3));
      } catch (f3) {
        o3(f3);
      }
    }
    function s3(c3) {
      try {
        a3(r3.throw(c3));
      } catch (f3) {
        o3(f3);
      }
    }
    function a3(c3) {
      c3.done ? t3(c3.value) : u3(c3.value).then(l3, s3);
    }
    a3((r3 = r3.apply(e28, n3 || [])).next());
  });
};
const m = (e28) => e28.includes("image/"), p$2 = (e28 = "") => {
  const n3 = e28.split("/"), r3 = n3[n3.length - 1].split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(r3) || [""])[0];
}, y$2 = /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i, F$2 = (e28) => {
  if (e28.type)
    return m(e28.type);
  const n3 = p$2(e28.name || "");
  if (y$2.test(n3))
    return true;
  const i = e28.thumbnailUrl || e28.url || "", r3 = p$2(i);
  return !!(/^data:image\//.test(i) || y$2.test(r3));
};
function b$2(e28) {
  return d$1(this, void 0, void 0, function* () {
    return yield new Promise((n3) => {
      if (!e28.type || !m(e28.type)) {
        n3("");
        return;
      }
      n3(window.URL.createObjectURL(e28));
    });
  });
}
const x$2 = e$1O && window.FileReader && window.File;
function w$1(e28) {
  return e28.isDirectory;
}
function g(e28) {
  return e28.isFile;
}
function E$2(e28, n3) {
  return d$1(this, void 0, void 0, function* () {
    const i = [];
    function r3(u3) {
      return d$1(this, void 0, void 0, function* () {
        for (const t3 of u3)
          if (t3) {
            if (n3 && w$1(t3)) {
              const o3 = t3.createReader();
              try {
                const l3 = yield new Promise((s3, a3) => {
                  o3.readEntries(s3, a3);
                });
                yield r3(l3);
              } catch {
              }
            } else if (g(t3))
              try {
                const o3 = yield new Promise((l3, s3) => {
                  t3.file(l3, s3);
                });
                i.push({
                  file: o3,
                  entry: t3,
                  source: "dnd"
                });
              } catch {
              }
          }
      });
    }
    return yield r3(e28), i;
  });
}
function L$2(e28) {
  const {
    id: n3,
    name: i,
    percentage: r3,
    status: u3,
    url: t3,
    file: o3,
    thumbnailUrl: l3,
    type: s3,
    fullPath: a3,
    batchId: c3
  } = e28;
  return {
    id: n3,
    name: i,
    percentage: r3 != null ? r3 : null,
    status: u3,
    url: t3 != null ? t3 : null,
    file: o3 != null ? o3 : null,
    thumbnailUrl: l3 != null ? l3 : null,
    type: s3 != null ? s3 : null,
    fullPath: a3 != null ? a3 : null,
    batchId: c3 != null ? c3 : null
  };
}
function _$1(e28, n3, i) {
  return e28 = e28.toLowerCase(), n3 = n3.toLocaleLowerCase(), i = i.toLocaleLowerCase(), i.split(",").map((u3) => u3.trim()).filter(Boolean).some((u3) => {
    if (u3.startsWith(".")) {
      if (e28.endsWith(u3))
        return true;
    } else if (u3.includes("/")) {
      const [t3, o3] = n3.split("/"), [l3, s3] = u3.split("/");
      if ((l3 === "*" || t3 && l3 && l3 === t3) && (s3 === "*" || o3 && s3 && s3 === o3))
        return true;
    } else
      return true;
    return false;
  });
}
const q$2 = defineComponent({
  name: "UploadTrigger",
  props: {
    abstract: Boolean
  },
  setup(c3, {
    slots: l3
  }) {
    const u3 = inject(n$4, null);
    u3 || t$1P("upload-trigger", "`n-upload-trigger` must be placed inside `n-upload`.");
    const {
      mergedClsPrefixRef: D3,
      mergedDisabledRef: o3,
      maxReachedRef: i,
      listTypeRef: h3,
      dragOverRef: a3,
      openOpenFileDialog: R3,
      draggerInsideRef: T3,
      handleFileAddition: y3,
      mergedDirectoryDndRef: C3,
      triggerClassRef: b3,
      triggerStyleRef: I3
    } = u3, g3 = computed(() => h3.value === "image-card");
    function f3() {
      o3.value || i.value || R3();
    }
    function v3(e28) {
      e28.preventDefault(), a3.value = true;
    }
    function p3(e28) {
      e28.preventDefault(), a3.value = true;
    }
    function s3(e28) {
      e28.preventDefault(), a3.value = false;
    }
    function m3(e28) {
      var r3;
      if (e28.preventDefault(), !T3.value || o3.value || i.value) {
        a3.value = false;
        return;
      }
      const n3 = (r3 = e28.dataTransfer) === null || r3 === void 0 ? void 0 : r3.items;
      n3 != null && n3.length ? E$2(Array.from(n3).map((d3) => d3.webkitGetAsEntry()), C3.value).then((d3) => {
        y3(d3);
      }).finally(() => {
        a3.value = false;
      }) : a3.value = false;
    }
    return () => {
      var e28;
      const {
        value: r3
      } = D3;
      return c3.abstract ? (e28 = l3.default) === null || e28 === void 0 ? void 0 : e28.call(l3, {
        handleClick: f3,
        handleDrop: m3,
        handleDragOver: v3,
        handleDragEnter: p3,
        handleDragLeave: s3
      }) : h$1R("div", {
        class: [`${r3}-upload-trigger`, (o3.value || i.value) && `${r3}-upload-trigger--disabled`, g3.value && `${r3}-upload-trigger--image-card`, b3.value],
        style: I3.value,
        onClick: f3,
        onDrop: m3,
        onDragover: v3,
        onDragenter: p3,
        onDragleave: s3
      }, g3.value ? h$1R(c$1, null, {
        default: () => p$3H(l3.default, () => [h$1R(d$1R, {
          clsPrefix: r3
        }, {
          default: () => h$1R(r$18, null)
        })])
      }) : l3);
    };
  }
});
const h$1 = defineComponent({
  name: "UploadProgress",
  props: {
    show: Boolean,
    percentage: {
      type: Number,
      required: true
    },
    status: {
      type: String,
      required: true
    }
  },
  setup() {
    return {
      mergedTheme: inject(n$4).mergedThemeRef
    };
  },
  render() {
    return h$1R(l$1W, null, {
      default: () => this.show ? h$1R(J$2, {
        type: "line",
        showIndicator: false,
        percentage: this.percentage,
        status: this.status,
        height: 2,
        theme: this.mergedTheme.peers.Progress,
        themeOverrides: this.mergedTheme.peerOverrides.Progress
      }) : null
    });
  }
});
const a = h$1R("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28"
}, h$1R("g", {
  fill: "none"
}, h$1R("path", {
  d: "M21.75 3A3.25 3.25 0 0 1 25 6.25v15.5A3.25 3.25 0 0 1 21.75 25H6.25A3.25 3.25 0 0 1 3 21.75V6.25A3.25 3.25 0 0 1 6.25 3h15.5zm.583 20.4l-7.807-7.68a.75.75 0 0 0-.968-.07l-.084.07l-7.808 7.68c.183.065.38.1.584.1h15.5c.204 0 .4-.035.583-.1l-7.807-7.68l7.807 7.68zM21.75 4.5H6.25A1.75 1.75 0 0 0 4.5 6.25v15.5c0 .208.036.408.103.593l7.82-7.692a2.25 2.25 0 0 1 3.026-.117l.129.117l7.82 7.692c.066-.185.102-.385.102-.593V6.25a1.75 1.75 0 0 0-1.75-1.75zm-3.25 3a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0-5zm0 1.5a1 1 0 1 0 0 2a1 1 0 0 0 0-2z",
  fill: "currentColor"
}))), n$3 = h$1R("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28"
}, h$1R("g", {
  fill: "none"
}, h$1R("path", {
  d: "M6.4 2A2.4 2.4 0 0 0 4 4.4v19.2A2.4 2.4 0 0 0 6.4 26h15.2a2.4 2.4 0 0 0 2.4-2.4V11.578c0-.729-.29-1.428-.805-1.944l-6.931-6.931A2.4 2.4 0 0 0 14.567 2H6.4zm-.9 2.4a.9.9 0 0 1 .9-.9H14V10a2 2 0 0 0 2 2h6.5v11.6a.9.9 0 0 1-.9.9H6.4a.9.9 0 0 1-.9-.9V4.4zm16.44 6.1H16a.5.5 0 0 1-.5-.5V4.06l6.44 6.44z",
  fill: "currentColor"
})));
const l$2 = f$1z("attach", h$1R("svg", {
  viewBox: "0 0 16 16",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("g", {
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, h$1R("g", {
  fill: "currentColor",
  "fill-rule": "nonzero"
}, h$1R("path", {
  d: "M3.25735931,8.70710678 L7.85355339,4.1109127 C8.82986412,3.13460197 10.4127766,3.13460197 11.3890873,4.1109127 C12.365398,5.08722343 12.365398,6.67013588 11.3890873,7.64644661 L6.08578644,12.9497475 C5.69526215,13.3402718 5.06209717,13.3402718 4.67157288,12.9497475 C4.28104858,12.5592232 4.28104858,11.9260582 4.67157288,11.5355339 L9.97487373,6.23223305 C10.1701359,6.0369709 10.1701359,5.72038841 9.97487373,5.52512627 C9.77961159,5.32986412 9.4630291,5.32986412 9.26776695,5.52512627 L3.96446609,10.8284271 C3.18341751,11.6094757 3.18341751,12.8758057 3.96446609,13.6568542 C4.74551468,14.4379028 6.01184464,14.4379028 6.79289322,13.6568542 L12.0961941,8.35355339 C13.4630291,6.98671837 13.4630291,4.77064094 12.0961941,3.40380592 C10.7293591,2.0369709 8.51328163,2.0369709 7.14644661,3.40380592 L2.55025253,8 C2.35499039,8.19526215 2.35499039,8.51184464 2.55025253,8.70710678 C2.74551468,8.90236893 3.06209717,8.90236893 3.25735931,8.70710678 Z"
})))));
const n$2 = f$1z("trash", h$1R("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, h$1R("path", {
  d: "M432,144,403.33,419.74A32,32,0,0,1,371.55,448H140.46a32,32,0,0,1-31.78-28.26L80,144",
  style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;"
}), h$1R("rect", {
  x: "32",
  y: "64",
  width: "448",
  height: "80",
  rx: "16",
  ry: "16",
  style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;"
}), h$1R("line", {
  x1: "312",
  y1: "240",
  x2: "200",
  y2: "352",
  style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;"
}), h$1R("line", {
  x1: "312",
  y1: "352",
  x2: "200",
  y2: "240",
  style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;"
})));
const n$1 = f$1z("cancel", h$1R("svg", {
  viewBox: "0 0 16 16",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("g", {
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, h$1R("g", {
  fill: "currentColor",
  "fill-rule": "nonzero"
}, h$1R("path", {
  d: "M2.58859116,2.7156945 L2.64644661,2.64644661 C2.82001296,2.47288026 3.08943736,2.45359511 3.2843055,2.58859116 L3.35355339,2.64644661 L8,7.293 L12.6464466,2.64644661 C12.8417088,2.45118446 13.1582912,2.45118446 13.3535534,2.64644661 C13.5488155,2.84170876 13.5488155,3.15829124 13.3535534,3.35355339 L8.707,8 L13.3535534,12.6464466 C13.5271197,12.820013 13.5464049,13.0894374 13.4114088,13.2843055 L13.3535534,13.3535534 C13.179987,13.5271197 12.9105626,13.5464049 12.7156945,13.4114088 L12.6464466,13.3535534 L8,8.707 L3.35355339,13.3535534 C3.15829124,13.5488155 2.84170876,13.5488155 2.64644661,13.3535534 C2.45118446,13.1582912 2.45118446,12.8417088 2.64644661,12.6464466 L7.293,8 L2.64644661,3.35355339 C2.47288026,3.17998704 2.45359511,2.91056264 2.58859116,2.7156945 L2.64644661,2.64644661 L2.58859116,2.7156945 Z"
})))));
const l$1 = f$1z("retry", h$1R("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, h$1R("path", {
  d: "M320,146s24.36-12-64-12A160,160,0,1,0,416,294",
  style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 32px;"
}), h$1R("polyline", {
  points: "256 58 336 138 256 218",
  style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;"
})));
const r$1 = f$1z("download", h$1R("svg", {
  viewBox: "0 0 16 16",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, h$1R("g", {
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, h$1R("g", {
  fill: "currentColor",
  "fill-rule": "nonzero"
}, h$1R("path", {
  d: "M3.5,13 L12.5,13 C12.7761424,13 13,13.2238576 13,13.5 C13,13.7454599 12.8231248,13.9496084 12.5898756,13.9919443 L12.5,14 L3.5,14 C3.22385763,14 3,13.7761424 3,13.5 C3,13.2545401 3.17687516,13.0503916 3.41012437,13.0080557 L3.5,13 L12.5,13 L3.5,13 Z M7.91012437,1.00805567 L8,1 C8.24545989,1 8.44960837,1.17687516 8.49194433,1.41012437 L8.5,1.5 L8.5,10.292 L11.1819805,7.6109127 C11.3555469,7.43734635 11.6249713,7.4180612 11.8198394,7.55305725 L11.8890873,7.6109127 C12.0626536,7.78447906 12.0819388,8.05390346 11.9469427,8.2487716 L11.8890873,8.31801948 L8.35355339,11.8535534 C8.17998704,12.0271197 7.91056264,12.0464049 7.7156945,11.9114088 L7.64644661,11.8535534 L4.1109127,8.31801948 C3.91565056,8.12275734 3.91565056,7.80617485 4.1109127,7.6109127 C4.28447906,7.43734635 4.55390346,7.4180612 4.7487716,7.55305725 L4.81801948,7.6109127 L7.5,10.292 L7.5,1.5 C7.5,1.25454011 7.67687516,1.05039163 7.91012437,1.00805567 L8,1 L7.91012437,1.00805567 Z"
})))));
var Z$2 = globalThis && globalThis.__awaiter || function(e28, i, o3, r3) {
  function d3(s3) {
    return s3 instanceof o3 ? s3 : new o3(function(u3) {
      u3(s3);
    });
  }
  return new (o3 || (o3 = Promise))(function(s3, u3) {
    function w3(a3) {
      try {
        h3(r3.next(a3));
      } catch (v3) {
        u3(v3);
      }
    }
    function p3(a3) {
      try {
        h3(r3.throw(a3));
      } catch (v3) {
        u3(v3);
      }
    }
    function h3(a3) {
      a3.done ? s3(a3.value) : d3(a3.value).then(w3, p3);
    }
    h3((r3 = r3.apply(e28, i || [])).next());
  });
};
const y$1 = {
  paddingMedium: "0 3px",
  heightMedium: "24px",
  iconSizeMedium: "18px"
}, ge$1 = defineComponent({
  name: "UploadFile",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    file: {
      type: Object,
      required: true
    },
    listType: {
      type: String,
      required: true
    }
  },
  setup(e28) {
    const i = inject(n$4), o3 = ref$1(null), r3 = ref$1(""), d3 = computed(() => {
      const {
        file: t3
      } = e28;
      return t3.status === "finished" ? "success" : t3.status === "error" ? "error" : "info";
    }), s3 = computed(() => {
      const {
        file: t3
      } = e28;
      if (t3.status === "error")
        return "error";
    }), u3 = computed(() => {
      const {
        file: t3
      } = e28;
      return t3.status === "uploading";
    }), w3 = computed(() => {
      if (!i.showCancelButtonRef.value)
        return false;
      const {
        file: t3
      } = e28;
      return ["uploading", "pending", "error"].includes(t3.status);
    }), p3 = computed(() => {
      if (!i.showRemoveButtonRef.value)
        return false;
      const {
        file: t3
      } = e28;
      return ["finished"].includes(t3.status);
    }), h3 = computed(() => {
      if (!i.showDownloadButtonRef.value)
        return false;
      const {
        file: t3
      } = e28;
      return ["finished"].includes(t3.status);
    }), a3 = computed(() => {
      if (!i.showRetryButtonRef.value)
        return false;
      const {
        file: t3
      } = e28;
      return ["error"].includes(t3.status);
    }), v3 = n$1U(() => r3.value || e28.file.thumbnailUrl || e28.file.url), B3 = computed(() => {
      if (!i.showPreviewButtonRef.value)
        return false;
      const {
        file: {
          status: t3
        },
        listType: l3
      } = e28;
      return ["finished"].includes(t3) && v3.value && l3 === "image-card";
    });
    function C3() {
      i.submit(e28.file.id);
    }
    function k3(t3) {
      t3.preventDefault();
      const {
        file: l3
      } = e28;
      ["finished", "pending", "error"].includes(l3.status) ? b3(l3) : ["uploading"].includes(l3.status) ? U3(l3) : s$2a("upload", "The button clicked type is unknown.");
    }
    function P3(t3) {
      t3.preventDefault(), O3(e28.file);
    }
    function b3(t3) {
      const {
        xhrMap: l3,
        doChange: m3,
        onRemoveRef: {
          value: R3
        },
        mergedFileListRef: {
          value: _3
        }
      } = i;
      Promise.resolve(R3 ? R3({
        file: Object.assign({}, t3),
        fileList: _3
      }) : true).then(($3) => {
        if ($3 === false)
          return;
        const D3 = Object.assign({}, t3, {
          status: "removed"
        });
        l3.delete(t3.id), m3(D3, void 0, {
          remove: true
        });
      });
    }
    function O3(t3) {
      const {
        onDownloadRef: {
          value: l3
        }
      } = i;
      Promise.resolve(l3 ? l3(Object.assign({}, t3)) : true).then((m3) => {
        m3 !== false && n$V(t3.url, t3.name);
      });
    }
    function U3(t3) {
      const {
        xhrMap: l3
      } = i, m3 = l3.get(t3.id);
      m3 == null || m3.abort(), b3(Object.assign({}, t3));
    }
    function x3() {
      const {
        onPreviewRef: {
          value: t3
        }
      } = i;
      if (t3)
        t3(e28.file);
      else if (e28.listType === "image-card") {
        const {
          value: l3
        } = o3;
        if (!l3)
          return;
        l3.click();
      }
    }
    const I3 = () => Z$2(this, void 0, void 0, function* () {
      const {
        listType: t3
      } = e28;
      t3 !== "image" && t3 !== "image-card" || i.shouldUseThumbnailUrlRef.value(e28.file) && (r3.value = yield i.getFileThumbnailUrlResolver(e28.file));
    });
    return watchEffect(() => {
      I3();
    }), {
      mergedTheme: i.mergedThemeRef,
      progressStatus: d3,
      buttonType: s3,
      showProgress: u3,
      disabled: i.mergedDisabledRef,
      showCancelButton: w3,
      showRemoveButton: p3,
      showDownloadButton: h3,
      showRetryButton: a3,
      showPreviewButton: B3,
      mergedThumbnailUrl: v3,
      shouldUseThumbnailUrl: i.shouldUseThumbnailUrlRef,
      renderIcon: i.renderIconRef,
      imageRef: o3,
      handleRemoveOrCancelClick: k3,
      handleDownloadClick: P3,
      handleRetryClick: C3,
      handlePreviewClick: x3
    };
  },
  render() {
    const {
      clsPrefix: e28,
      mergedTheme: i,
      listType: o3,
      file: r3,
      renderIcon: d3
    } = this;
    let s3;
    const u3 = o3 === "image";
    u3 || o3 === "image-card" ? s3 = !this.shouldUseThumbnailUrl(r3) || !this.mergedThumbnailUrl ? h$1R("span", {
      class: `${e28}-upload-file-info__thumbnail`
    }, d3 ? d3(r3) : F$2(r3) ? h$1R(d$1R, {
      clsPrefix: e28
    }, {
      default: () => a
    }) : h$1R(d$1R, {
      clsPrefix: e28
    }, {
      default: () => n$3
    })) : h$1R("a", {
      rel: "noopener noreferer",
      target: "_blank",
      href: r3.url || void 0,
      class: `${e28}-upload-file-info__thumbnail`,
      onClick: this.handlePreviewClick
    }, o3 === "image-card" ? h$1R(F$m, {
      src: this.mergedThumbnailUrl || void 0,
      previewSrc: r3.url || void 0,
      alt: r3.name,
      ref: "imageRef"
    }) : h$1R("img", {
      src: this.mergedThumbnailUrl || void 0,
      alt: r3.name
    })) : s3 = h$1R("span", {
      class: `${e28}-upload-file-info__thumbnail`
    }, d3 ? d3(r3) : h$1R(d$1R, {
      clsPrefix: e28
    }, {
      default: () => h$1R(l$2, null)
    }));
    const p3 = h$1R(h$1, {
      show: this.showProgress,
      percentage: r3.percentage || 0,
      status: this.progressStatus
    }), h3 = o3 === "text" || o3 === "image";
    return h$1R("div", {
      class: [`${e28}-upload-file`, `${e28}-upload-file--${this.progressStatus}-status`, r3.url && r3.status !== "error" && o3 !== "image-card" && `${e28}-upload-file--with-url`, `${e28}-upload-file--${o3}-type`]
    }, h$1R("div", {
      class: `${e28}-upload-file-info`
    }, s3, h$1R("div", {
      class: `${e28}-upload-file-info__name`
    }, h3 && (r3.url && r3.status !== "error" ? h$1R("a", {
      rel: "noopener noreferer",
      target: "_blank",
      href: r3.url || void 0,
      onClick: this.handlePreviewClick
    }, r3.name) : h$1R("span", {
      onClick: this.handlePreviewClick
    }, r3.name)), u3 && p3), h$1R("div", {
      class: [`${e28}-upload-file-info__action`, `${e28}-upload-file-info__action--${o3}-type`]
    }, this.showPreviewButton ? h$1R(le$g, {
      key: "preview",
      quaternary: true,
      type: this.buttonType,
      onClick: this.handlePreviewClick,
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      builtinThemeOverrides: y$1
    }, {
      icon: () => h$1R(d$1R, {
        clsPrefix: e28
      }, {
        default: () => h$1R(t$1h, null)
      })
    }) : null, (this.showRemoveButton || this.showCancelButton) && !this.disabled && h$1R(le$g, {
      key: "cancelOrTrash",
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      quaternary: true,
      builtinThemeOverrides: y$1,
      type: this.buttonType,
      onClick: this.handleRemoveOrCancelClick
    }, {
      icon: () => h$1R(m$21, null, {
        default: () => this.showRemoveButton ? h$1R(d$1R, {
          clsPrefix: e28,
          key: "trash"
        }, {
          default: () => h$1R(n$2, null)
        }) : h$1R(d$1R, {
          clsPrefix: e28,
          key: "cancel"
        }, {
          default: () => h$1R(n$1, null)
        })
      })
    }), this.showRetryButton && !this.disabled && h$1R(le$g, {
      key: "retry",
      quaternary: true,
      type: this.buttonType,
      onClick: this.handleRetryClick,
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      builtinThemeOverrides: y$1
    }, {
      icon: () => h$1R(d$1R, {
        clsPrefix: e28
      }, {
        default: () => h$1R(l$1, null)
      })
    }), this.showDownloadButton ? h$1R(le$g, {
      key: "download",
      quaternary: true,
      type: this.buttonType,
      onClick: this.handleDownloadClick,
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      builtinThemeOverrides: y$1
    }, {
      icon: () => h$1R(d$1R, {
        clsPrefix: e28
      }, {
        default: () => h$1R(r$1, null)
      })
    }) : null)), !u3 && p3);
  }
});
const K$2 = defineComponent({
  name: "UploadFileList",
  setup(I3, {
    slots: f3
  }) {
    const t3 = inject(n$4, null);
    t3 || t$1P("upload-file-list", "`n-upload-file-list` must be placed inside `n-upload`.");
    const {
      abstractRef: p3,
      mergedClsPrefixRef: o3,
      listTypeRef: r3,
      mergedFileListRef: n3,
      fileListClassRef: m3,
      fileListStyleRef: c3,
      cssVarsRef: s3,
      themeClassRef: a3,
      maxReachedRef: v3,
      showTriggerRef: g3,
      imageGroupPropsRef: R3
    } = t3, i = computed(() => r3.value === "image-card"), u3 = () => n3.value.map((e28) => h$1R(ge$1, {
      clsPrefix: o3.value,
      key: e28.id,
      file: e28,
      listType: r3.value
    })), y3 = () => i.value ? h$1R(j$h, Object.assign({}, R3.value), {
      default: u3
    }) : h$1R(l$1W, {
      group: true
    }, {
      default: u3
    });
    return () => {
      const {
        value: e28
      } = o3, {
        value: d3
      } = p3;
      return h$1R("div", {
        class: [`${e28}-upload-file-list`, i.value && `${e28}-upload-file-list--grid`, d3 ? a3 == null ? void 0 : a3.value : void 0, m3.value],
        style: [d3 && s3 ? s3.value : "", c3.value]
      }, y3(), g3.value && !v3.value && i.value && h$1R(q$2, null, f3));
    };
  }
});
const p$1 = r$2a([l$25("upload", "width: 100%;", [g$1j("dragger-inside", [l$25("upload-trigger", `
 display: block;
 `)]), g$1j("drag-over", [l$25("upload-dragger", `
 border: var(--n-dragger-border-hover);
 `)])]), l$25("upload-dragger", `
 cursor: pointer;
 box-sizing: border-box;
 width: 100%;
 text-align: center;
 border-radius: var(--n-border-radius);
 padding: 24px;
 opacity: 1;
 transition:
 opacity .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 background-color: var(--n-dragger-color);
 border: var(--n-dragger-border);
 `, [r$2a("&:hover", `
 border: var(--n-dragger-border-hover);
 `), g$1j("disabled", `
 cursor: not-allowed;
 `)]), l$25("upload-trigger", `
 display: inline-block;
 box-sizing: border-box;
 opacity: 1;
 transition: opacity .3s var(--n-bezier);
 `, [r$2a("+", [l$25("upload-file-list", "margin-top: 8px;")]), g$1j("disabled", `
 opacity: var(--n-item-disabled-opacity);
 cursor: not-allowed;
 `), g$1j("image-card", `
 width: 96px;
 height: 96px;
 `, [l$25("base-icon", `
 font-size: 24px;
 `), l$25("upload-dragger", `
 padding: 0;
 height: 100%;
 width: 100%;
 display: flex;
 align-items: center;
 justify-content: center;
 `)])]), l$25("upload-file-list", `
 line-height: var(--n-line-height);
 opacity: 1;
 transition: opacity .3s var(--n-bezier);
 `, [r$2a("a, img", "outline: none;"), g$1j("disabled", `
 opacity: var(--n-item-disabled-opacity);
 cursor: not-allowed;
 `, [l$25("upload-file", "cursor: not-allowed;")]), g$1j("grid", `
 display: grid;
 grid-template-columns: repeat(auto-fill, 96px);
 grid-gap: 8px;
 margin-top: 0;
 `), l$25("upload-file", `
 display: block;
 box-sizing: border-box;
 cursor: default;
 padding: 0px 12px 0 6px;
 transition: background-color .3s var(--n-bezier);
 border-radius: var(--n-border-radius);
 `, [x$E(), l$25("progress", [x$E({
  foldPadding: true
})]), r$2a("&:hover", `
 background-color: var(--n-item-color-hover);
 `, [l$25("upload-file-info", [M$y("action", `
 opacity: 1;
 `)])]), g$1j("image-type", `
 border-radius: var(--n-border-radius);
 text-decoration: underline;
 text-decoration-color: #0000;
 `, [l$25("upload-file-info", `
 padding-top: 0px;
 padding-bottom: 0px;
 width: 100%;
 height: 100%;
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 6px 0;
 `, [l$25("progress", `
 padding: 2px 0;
 margin-bottom: 0;
 `), M$y("name", `
 padding: 0 8px;
 `), M$y("thumbnail", `
 width: 32px;
 height: 32px;
 font-size: 28px;
 display: flex;
 justify-content: center;
 align-items: center;
 `, [r$2a("img", `
 width: 100%;
 `)])])]), g$1j("text-type", [l$25("progress", `
 box-sizing: border-box;
 padding-bottom: 6px;
 margin-bottom: 6px;
 `)]), g$1j("image-card-type", `
 position: relative;
 width: 96px;
 height: 96px;
 border: var(--n-item-border-image-card);
 border-radius: var(--n-border-radius);
 padding: 0;
 display: flex;
 align-items: center;
 justify-content: center;
 transition: border-color .3s var(--n-bezier), background-color .3s var(--n-bezier);
 border-radius: var(--n-border-radius);
 overflow: hidden;
 `, [l$25("progress", `
 position: absolute;
 left: 8px;
 bottom: 8px;
 right: 8px;
 width: unset;
 `), l$25("upload-file-info", `
 padding: 0;
 width: 100%;
 height: 100%;
 `, [M$y("thumbnail", `
 width: 100%;
 height: 100%;
 display: flex;
 flex-direction: column;
 align-items: center;
 justify-content: center;
 font-size: 36px;
 `, [r$2a("img", `
 width: 100%;
 `)])]), r$2a("&::before", `
 position: absolute;
 z-index: 1;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 opacity: 0;
 transition: opacity .2s var(--n-bezier);
 content: "";
 `), r$2a("&:hover", [r$2a("&::before", "opacity: 1;"), l$25("upload-file-info", [M$y("thumbnail", "opacity: .12;")])])]), g$1j("error-status", [r$2a("&:hover", `
 background-color: var(--n-item-color-hover-error);
 `), l$25("upload-file-info", [M$y("name", "color: var(--n-item-text-color-error);"), M$y("thumbnail", "color: var(--n-item-text-color-error);")]), g$1j("image-card-type", `
 border: var(--n-item-border-image-card-error);
 `)]), g$1j("with-url", `
 cursor: pointer;
 `, [l$25("upload-file-info", [M$y("name", `
 color: var(--n-item-text-color-success);
 text-decoration-color: var(--n-item-text-color-success);
 `, [r$2a("a", `
 text-decoration: underline;
 `)])])]), l$25("upload-file-info", `
 position: relative;
 padding-top: 6px;
 padding-bottom: 6px;
 display: flex;
 flex-wrap: nowrap;
 `, [M$y("thumbnail", `
 font-size: 18px;
 opacity: 1;
 transition: opacity .2s var(--n-bezier);
 color: var(--n-item-icon-color);
 `, [l$25("base-icon", `
 margin-right: 2px;
 vertical-align: middle;
 transition: color .3s var(--n-bezier);
 `)]), M$y("action", `
 padding-top: inherit;
 padding-bottom: inherit;
 position: absolute;
 right: 0;
 top: 0;
 bottom: 0;
 width: 80px;
 display: flex;
 align-items: center;
 transition: opacity .2s var(--n-bezier);
 justify-content: flex-end;
 opacity: 0;
 `, [l$25("button", [r$2a("&:not(:last-child)", {
  marginRight: "4px"
}), l$25("base-icon", [r$2a("svg", [m$22()])])]), g$1j("image-type", `
 position: relative;
 max-width: 80px;
 width: auto;
 `), g$1j("image-card-type", `
 z-index: 2;
 position: absolute;
 width: 100%;
 height: 100%;
 left: 0;
 right: 0;
 bottom: 0;
 top: 0;
 display: flex;
 justify-content: center;
 align-items: center;
 `)]), M$y("name", `
 color: var(--n-item-text-color);
 flex: 1;
 display: flex;
 justify-content: center;
 text-overflow: ellipsis;
 overflow: hidden;
 flex-direction: column;
 text-decoration-color: #0000;
 font-size: var(--n-font-size);
 transition:
 color .3s var(--n-bezier),
 text-decoration-color .3s var(--n-bezier); 
 `, [r$2a("a", `
 color: inherit;
 text-decoration: underline;
 `)])])])]), l$25("upload-file-input", `
 display: none;
 width: 0;
 height: 0;
 opacity: 0;
 `)]);
const f = (e28) => {
  const {
    iconColor: t3,
    primaryColor: i,
    errorColor: o3,
    textColor2: m3,
    successColor: l3,
    opacityDisabled: a3,
    actionColor: d3,
    borderColor: r3,
    hoverColor: s3,
    lineHeight: p3,
    borderRadius: C3,
    fontSize: c3
  } = e28;
  return {
    fontSize: c3,
    lineHeight: p3,
    borderRadius: C3,
    draggerColor: d3,
    draggerBorder: `1px dashed ${r3}`,
    draggerBorderHover: `1px dashed ${i}`,
    itemColorHover: s3,
    itemColorHoverError: J$p(o3, {
      alpha: 0.06
    }),
    itemTextColor: m3,
    itemTextColorError: o3,
    itemTextColorSuccess: l3,
    itemIconColor: t3,
    itemDisabledOpacity: a3,
    itemBorderImageCardError: `1px solid ${o3}`,
    itemBorderImageCard: `1px solid ${r3}`
  };
}, b$1 = G$w({
  name: "Upload",
  common: d$1T,
  peers: {
    Button: B$P,
    Progress: p$6
  },
  self: f
}), T$2 = b$1;
var X$2 = globalThis && globalThis.__awaiter || function(e28, i, n3, r3) {
  function s3(f3) {
    return f3 instanceof n3 ? f3 : new n3(function(u3) {
      u3(f3);
    });
  }
  return new (n3 || (n3 = Promise))(function(f3, u3) {
    function R3(o3) {
      try {
        a3(r3.next(o3));
      } catch (d3) {
        u3(d3);
      }
    }
    function l3(o3) {
      try {
        a3(r3.throw(o3));
      } catch (d3) {
        u3(d3);
      }
    }
    function a3(o3) {
      o3.done ? f3(o3.value) : s3(o3.value).then(R3, l3);
    }
    a3((r3 = r3.apply(e28, i || [])).next());
  });
};
function Re$1(e28, i, n3) {
  const {
    doChange: r3,
    xhrMap: s3
  } = e28;
  let f3 = 0;
  function u3(l3) {
    var a3;
    let o3 = Object.assign({}, i, {
      status: "error",
      percentage: f3
    });
    s3.delete(i.id), o3 = L$2(((a3 = e28.onError) === null || a3 === void 0 ? void 0 : a3.call(e28, {
      file: o3,
      event: l3
    })) || o3), r3(o3, l3);
  }
  function R3(l3) {
    var a3;
    if (e28.isErrorState) {
      if (e28.isErrorState(n3)) {
        u3(l3);
        return;
      }
    } else if (n3.status < 200 || n3.status >= 300) {
      u3(l3);
      return;
    }
    let o3 = Object.assign({}, i, {
      status: "finished",
      percentage: f3
    });
    s3.delete(i.id), o3 = L$2(((a3 = e28.onFinish) === null || a3 === void 0 ? void 0 : a3.call(e28, {
      file: o3,
      event: l3
    })) || o3), r3(o3, l3);
  }
  return {
    handleXHRLoad: R3,
    handleXHRError: u3,
    handleXHRAbort(l3) {
      const a3 = Object.assign({}, i, {
        status: "removed",
        file: null,
        percentage: f3
      });
      s3.delete(i.id), r3(a3, l3);
    },
    handleXHRProgress(l3) {
      const a3 = Object.assign({}, i, {
        status: "uploading"
      });
      if (l3.lengthComputable) {
        const o3 = Math.ceil(l3.loaded / l3.total * 100);
        a3.percentage = o3, f3 = o3;
      }
      r3(a3, l3);
    }
  };
}
function be$1(e28) {
  const {
    inst: i,
    file: n3,
    data: r3,
    headers: s3,
    withCredentials: f3,
    action: u3,
    customRequest: R3
  } = e28, {
    doChange: l3
  } = e28.inst;
  let a3 = 0;
  R3({
    file: n3,
    data: r3,
    headers: s3,
    withCredentials: f3,
    action: u3,
    onProgress(o3) {
      const d3 = Object.assign({}, n3, {
        status: "uploading"
      }), U3 = o3.percent;
      d3.percentage = U3, a3 = U3, l3(d3);
    },
    onFinish() {
      var o3;
      let d3 = Object.assign({}, n3, {
        status: "finished",
        percentage: a3
      });
      d3 = L$2(((o3 = i.onFinish) === null || o3 === void 0 ? void 0 : o3.call(i, {
        file: d3
      })) || d3), l3(d3);
    },
    onError() {
      var o3;
      let d3 = Object.assign({}, n3, {
        status: "error",
        percentage: a3
      });
      d3 = L$2(((o3 = i.onError) === null || o3 === void 0 ? void 0 : o3.call(i, {
        file: d3
      })) || d3), l3(d3);
    }
  });
}
function ye$1(e28, i, n3) {
  const r3 = Re$1(e28, i, n3);
  n3.onabort = r3.handleXHRAbort, n3.onerror = r3.handleXHRError, n3.onload = r3.handleXHRLoad, n3.upload && (n3.upload.onprogress = r3.handleXHRProgress);
}
function A$2(e28, i) {
  return typeof e28 == "function" ? e28({
    file: i
  }) : e28 || {};
}
function Ce$1(e28, i, n3) {
  const r3 = A$2(i, n3);
  r3 && Object.keys(r3).forEach((s3) => {
    e28.setRequestHeader(s3, r3[s3]);
  });
}
function we$1(e28, i, n3) {
  const r3 = A$2(i, n3);
  r3 && Object.keys(r3).forEach((s3) => {
    e28.append(s3, r3[s3]);
  });
}
function Fe$1(e28, i, n3, {
  method: r3,
  action: s3,
  withCredentials: f3,
  responseType: u3,
  headers: R3,
  data: l3
}) {
  const a3 = new XMLHttpRequest();
  a3.responseType = u3, e28.xhrMap.set(n3.id, a3), a3.withCredentials = f3;
  const o3 = new FormData();
  if (we$1(o3, l3, n3), n3.file !== null && o3.append(i, n3.file), ye$1(e28, n3, a3), s3 !== void 0) {
    a3.open(r3.toUpperCase(), s3), Ce$1(a3, R3, n3), a3.send(o3);
    const d3 = Object.assign({}, n3, {
      status: "uploading"
    });
    e28.doChange(d3);
  }
}
const Be$1 = Object.assign(Object.assign({}, _$F.props), {
  name: {
    type: String,
    default: "file"
  },
  accept: String,
  action: String,
  customRequest: Function,
  directory: Boolean,
  directoryDnd: {
    type: Boolean,
    default: void 0
  },
  method: {
    type: String,
    default: "POST"
  },
  multiple: Boolean,
  showFileList: {
    type: Boolean,
    default: true
  },
  data: [Object, Function],
  headers: [Object, Function],
  withCredentials: Boolean,
  responseType: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  onChange: Function,
  onRemove: Function,
  onFinish: Function,
  onError: Function,
  onBeforeUpload: Function,
  isErrorState: Function,
  onDownload: Function,
  defaultUpload: {
    type: Boolean,
    default: true
  },
  fileList: Array,
  "onUpdate:fileList": [Function, Array],
  onUpdateFileList: [Function, Array],
  fileListClass: String,
  fileListStyle: [String, Object],
  defaultFileList: {
    type: Array,
    default: () => []
  },
  showCancelButton: {
    type: Boolean,
    default: true
  },
  showRemoveButton: {
    type: Boolean,
    default: true
  },
  showDownloadButton: Boolean,
  showRetryButton: {
    type: Boolean,
    default: true
  },
  showPreviewButton: {
    type: Boolean,
    default: true
  },
  listType: {
    type: String,
    default: "text"
  },
  onPreview: Function,
  shouldUseThumbnailUrl: {
    type: Function,
    default: (e28) => x$2 ? F$2(e28) : false
  },
  createThumbnailUrl: Function,
  abstract: Boolean,
  max: Number,
  showTrigger: {
    type: Boolean,
    default: true
  },
  imageGroupProps: Object,
  inputProps: Object,
  triggerClass: String,
  triggerStyle: [String, Object],
  renderIcon: Function
}), Ae$1 = defineComponent({
  name: "Upload",
  props: Be$1,
  setup(e28) {
    e28.abstract && e28.listType === "image-card" && t$1P("upload", "when the list-type is image-card, abstract is not supported.");
    const {
      mergedClsPrefixRef: i,
      inlineThemeDisabled: n3
    } = a$2x(e28), r3 = _$F("Upload", "-upload", p$1, T$2, e28, i), s3 = h$1B(e28), f3 = computed(() => {
      const {
        max: t3
      } = e28;
      return t3 !== void 0 ? B3.value.length >= t3 : false;
    }), u3 = ref$1(e28.defaultFileList), R3 = toRef$1(e28, "fileList"), l3 = ref$1(null), a3 = {
      value: false
    }, o3 = ref$1(false), d3 = /* @__PURE__ */ new Map(), U3 = d$1S(R3, u3), B3 = computed(() => U3.value.map(L$2));
    function I3() {
      var t3;
      (t3 = l3.value) === null || t3 === void 0 || t3.click();
    }
    function V10(t3) {
      const m3 = t3.target;
      H3(m3.files ? Array.from(m3.files).map((v3) => ({
        file: v3,
        entry: null,
        source: "input"
      })) : null, t3), m3.value = "";
    }
    function $3(t3) {
      const {
        "onUpdate:fileList": m3,
        onUpdateFileList: v3
      } = e28;
      m3 && i$1Z(m3, t3), v3 && i$1Z(v3, t3), u3.value = t3;
    }
    const E3 = computed(() => e28.multiple || e28.directory);
    function H3(t3, m3) {
      if (!t3 || t3.length === 0)
        return;
      const {
        onBeforeUpload: v3
      } = e28;
      t3 = E3.value ? t3 : [t3[0]];
      const {
        max: C3,
        accept: y3
      } = e28;
      t3 = t3.filter(({
        file: h3,
        source: g3
      }) => g3 === "dnd" && (y3 != null && y3.trim()) ? _$1(h3.name, h3.type, y3) : true), C3 && (t3 = t3.slice(0, C3 - B3.value.length));
      const p3 = i$1Y();
      Promise.all(t3.map(({
        file: h3,
        entry: g3
      }) => X$2(this, void 0, void 0, function* () {
        var w3;
        const F3 = {
          id: i$1Y(),
          batchId: p3,
          name: h3.name,
          status: "pending",
          percentage: 0,
          file: h3,
          url: null,
          type: h3.type,
          thumbnailUrl: null,
          fullPath: (w3 = g3 == null ? void 0 : g3.fullPath) !== null && w3 !== void 0 ? w3 : `/${h3.webkitRelativePath || h3.name}`
        };
        return !v3 || (yield v3({
          file: F3,
          fileList: B3.value
        })) !== false ? F3 : null;
      }))).then((h3) => X$2(this, void 0, void 0, function* () {
        let g3 = Promise.resolve();
        h3.forEach((w3) => {
          g3 = g3.then(nextTick).then(() => {
            w3 && S3(w3, m3, {
              append: true
            });
          });
        }), yield g3;
      })).then(() => {
        e28.defaultUpload && x3();
      });
    }
    function x3(t3) {
      const {
        method: m3,
        action: v3,
        withCredentials: C3,
        headers: y3,
        data: p3,
        name: h3
      } = e28, g3 = t3 !== void 0 ? B3.value.filter((F3) => F3.id === t3) : B3.value, w3 = t3 !== void 0;
      g3.forEach((F3) => {
        const {
          status: j3
        } = F3;
        (j3 === "pending" || j3 === "error" && w3) && (e28.customRequest ? be$1({
          inst: {
            doChange: S3,
            xhrMap: d3,
            onFinish: e28.onFinish,
            onError: e28.onError
          },
          file: F3,
          action: v3,
          withCredentials: C3,
          headers: y3,
          data: p3,
          customRequest: e28.customRequest
        }) : Fe$1({
          doChange: S3,
          xhrMap: d3,
          onFinish: e28.onFinish,
          onError: e28.onError,
          isErrorState: e28.isErrorState
        }, h3, F3, {
          method: m3,
          action: v3,
          withCredentials: C3,
          responseType: e28.responseType,
          headers: y3,
          data: p3
        }));
      });
    }
    const S3 = (t3, m3, v3 = {
      append: false,
      remove: false
    }) => {
      const {
        append: C3,
        remove: y3
      } = v3, p3 = Array.from(B3.value), h3 = p3.findIndex((g3) => g3.id === t3.id);
      if (C3 || y3 || ~h3) {
        C3 ? p3.push(t3) : y3 ? p3.splice(h3, 1) : p3.splice(h3, 1, t3);
        const {
          onChange: g3
        } = e28;
        g3 && g3({
          file: t3,
          fileList: p3,
          event: m3
        }), $3(p3);
      }
    };
    function k3(t3) {
      var m3;
      if (t3.thumbnailUrl)
        return t3.thumbnailUrl;
      const {
        createThumbnailUrl: v3
      } = e28;
      return v3 ? (m3 = v3(t3.file, t3)) !== null && m3 !== void 0 ? m3 : t3.url || "" : t3.url ? t3.url : t3.file ? b$2(t3.file) : "";
    }
    const P3 = computed(() => {
      const {
        common: {
          cubicBezierEaseInOut: t3
        },
        self: {
          draggerColor: m3,
          draggerBorder: v3,
          draggerBorderHover: C3,
          itemColorHover: y3,
          itemColorHoverError: p3,
          itemTextColorError: h3,
          itemTextColorSuccess: g3,
          itemTextColor: w3,
          itemIconColor: F3,
          itemDisabledOpacity: j3,
          lineHeight: q3,
          borderRadius: G3,
          fontSize: K3,
          itemBorderImageCardError: J3,
          itemBorderImageCard: Q3
        }
      } = r3.value;
      return {
        "--n-bezier": t3,
        "--n-border-radius": G3,
        "--n-dragger-border": v3,
        "--n-dragger-border-hover": C3,
        "--n-dragger-color": m3,
        "--n-font-size": K3,
        "--n-item-color-hover": y3,
        "--n-item-color-hover-error": p3,
        "--n-item-disabled-opacity": j3,
        "--n-item-icon-color": F3,
        "--n-item-text-color": w3,
        "--n-item-text-color-error": h3,
        "--n-item-text-color-success": g3,
        "--n-line-height": q3,
        "--n-item-border-image-card-error": J3,
        "--n-item-border-image-card": Q3
      };
    }), b3 = n3 ? E$J("upload", void 0, P3, e28) : void 0;
    provide(n$4, {
      mergedClsPrefixRef: i,
      mergedThemeRef: r3,
      showCancelButtonRef: toRef$1(e28, "showCancelButton"),
      showDownloadButtonRef: toRef$1(e28, "showDownloadButton"),
      showRemoveButtonRef: toRef$1(e28, "showRemoveButton"),
      showRetryButtonRef: toRef$1(e28, "showRetryButton"),
      onRemoveRef: toRef$1(e28, "onRemove"),
      onDownloadRef: toRef$1(e28, "onDownload"),
      mergedFileListRef: B3,
      triggerClassRef: toRef$1(e28, "triggerClass"),
      triggerStyleRef: toRef$1(e28, "triggerStyle"),
      shouldUseThumbnailUrlRef: toRef$1(e28, "shouldUseThumbnailUrl"),
      renderIconRef: toRef$1(e28, "renderIcon"),
      xhrMap: d3,
      submit: x3,
      doChange: S3,
      showPreviewButtonRef: toRef$1(e28, "showPreviewButton"),
      onPreviewRef: toRef$1(e28, "onPreview"),
      getFileThumbnailUrlResolver: k3,
      listTypeRef: toRef$1(e28, "listType"),
      dragOverRef: o3,
      openOpenFileDialog: I3,
      draggerInsideRef: a3,
      handleFileAddition: H3,
      mergedDisabledRef: s3.mergedDisabledRef,
      maxReachedRef: f3,
      fileListClassRef: toRef$1(e28, "fileListClass"),
      fileListStyleRef: toRef$1(e28, "fileListStyle"),
      abstractRef: toRef$1(e28, "abstract"),
      acceptRef: toRef$1(e28, "accept"),
      cssVarsRef: n3 ? void 0 : P3,
      themeClassRef: b3 == null ? void 0 : b3.themeClass,
      onRender: b3 == null ? void 0 : b3.onRender,
      showTriggerRef: toRef$1(e28, "showTrigger"),
      imageGroupPropsRef: toRef$1(e28, "imageGroupProps"),
      mergedDirectoryDndRef: computed(() => {
        var t3;
        return (t3 = e28.directoryDnd) !== null && t3 !== void 0 ? t3 : e28.directory;
      })
    });
    const z3 = {
      clear: () => {
        u3.value = [];
      },
      submit: x3,
      openOpenFileDialog: I3
    };
    return Object.assign({
      mergedClsPrefix: i,
      draggerInsideRef: a3,
      inputElRef: l3,
      mergedTheme: r3,
      dragOver: o3,
      mergedMultiple: E3,
      cssVars: n3 ? void 0 : P3,
      themeClass: b3 == null ? void 0 : b3.themeClass,
      onRender: b3 == null ? void 0 : b3.onRender,
      handleFileInputChange: V10
    }, z3);
  },
  render() {
    var e28, i;
    const {
      draggerInsideRef: n3,
      mergedClsPrefix: r3,
      $slots: s3,
      directory: f3,
      onRender: u$110
    } = this;
    if (s3.default && !this.abstract) {
      const l3 = s3.default()[0];
      !((e28 = l3 == null ? void 0 : l3.type) === null || e28 === void 0) && e28[u] && (n3.value = true);
    }
    const R3 = h$1R("input", Object.assign({}, this.inputProps, {
      ref: "inputElRef",
      type: "file",
      class: `${r3}-upload-file-input`,
      accept: this.accept,
      multiple: this.mergedMultiple,
      onChange: this.handleFileInputChange,
      webkitdirectory: f3 || void 0,
      directory: f3 || void 0
    }));
    return this.abstract ? h$1R(Fragment, null, (i = s3.default) === null || i === void 0 ? void 0 : i.call(s3), h$1R(Teleport, {
      to: "body"
    }, R3)) : (u$110 == null || u$110(), h$1R("div", {
      class: [`${r3}-upload`, n3.value && `${r3}-upload--dragger-inside`, this.dragOver && `${r3}-upload--drag-over`, this.themeClass],
      style: this.cssVars
    }, R3, this.showTrigger && this.listType !== "image-card" && h$1R(q$2, null, s3), this.showFileList && h$1R(K$2, null, s3)));
  }
});
const b = { class: "upload-icon" }, k$2 = { key: 0 }, C$1 = defineComponent({
  name: "UIUpload"
}), I$2 = defineComponent(__spreadProps(__spreadValues({}, C$1), {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    fileList: {
      type: Array,
      default: () => []
    },
    max: Number,
    showDownloadButton: Boolean,
    accept: String,
    onDownload: Function
  },
  emits: ["change", "remove", "update:file-list", "download"],
  setup(o3, { emit: s3 }) {
    const m3 = o3, u3 = s3, p3 = useSlots(), f3 = (e28) => e28 ? m3.onDownload ? (u3("download", e28), false) : (c$2(e28), false) : null;
    return (e28, t3) => (openBlock(), createBlock(unref(Ae$1), mergeProps(e28.$attrs, {
      "list-type": "image",
      onChange: t3[0] || (t3[0] = (l3) => e28.$emit("change", l3)),
      multiple: o3.multiple,
      "file-list": o3.fileList,
      max: o3.max,
      accept: o3.accept,
      "show-download-button": o3.showDownloadButton,
      onRemove: t3[1] || (t3[1] = (l3) => e28.$emit("remove", l3)),
      "onUpdate:fileList": t3[2] || (t3[2] = (l3) => e28.$emit("update:file-list", l3)),
      onDownload: f3
    }), {
      default: withCtx(() => [
        createVNode(unref(c$1), null, {
          default: withCtx(() => [
            createElementVNode("div", b, [
              createVNode(unref(a$1), { class: "text-gray-600" })
            ]),
            unref(p3).extra ? (openBlock(), createElementBlock("div", k$2, [
              renderSlot(e28.$slots, "extra", {}, void 0, true)
            ])) : createCommentVNode("", true)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16, ["multiple", "file-list", "max", "accept", "show-download-button"]));
  }
})), O$2 = /* @__PURE__ */ s$1d(I$2, [["__scopeId", "data-v-272bad21"]]);
const o = (r3) => () => h$1R(r3, {
  class: "h-4 w-4"
}, {});
function c() {
  const o3 = inject(E$d, null);
  return o3 === null && t$1P("use-notification", "No outer `n-notification-provider` found."), o3;
}
({
  UIButton: q$C,
  UIButtonGroup: B$D,
  UIContentWrap: Re$2,
  UIDropdown: g$Q,
  UIBadge: p$32,
  UIInput: P$O,
  UIInputGroup: m$1J,
  UIInputGroupLabel: _$y,
  UIPagination: v$N,
  UITable: ke$b,
  UIActionDropdown: A$u,
  UIActionButtons: S$u,
  UICheckbox: y$C,
  UIModal: k$G,
  UIModalContent: _$x,
  UIModalFooter: E$A,
  UIModalHeader: z$q,
  UISelect: I$y,
  UITag: $$l,
  UITooltip: w$K,
  UIForm: B$M,
  UIFormItem: V$u,
  UIFormContentHorizontal: R$s,
  UIFormLabelTooltip: S$I,
  UIDatePicker: p$2t,
  UIHeader: Q$5,
  UITabs: g$P,
  UITab: o$_,
  UITabPane: l$18,
  UIStatistic: Z$3,
  UIInputNumber: v$a,
  UIEmpty: D$d,
  UIAvatar: I$v,
  UIAvatarGroup: te$d,
  UIRadio: c$1D,
  UIRadioGroup: g$16,
  UIDrawer: c$1X,
  UIDrawerContent: K$o,
  UISpin: _$3,
  UICollapse: y$18,
  UICollapseItem: I$F,
  UICollapseTransition: h$U,
  UIStep: S$D,
  UISteps: v$V,
  UIToolbar: f$V,
  UIToolbarGroup: f$U,
  UIDisplaySmMedium: c$1T,
  UITextLgMedium: p$3z,
  UITextSmNormal: f$1w,
  UITextSmMedium: d$1H,
  UITextXsMedium: p$3y,
  UITextMdMedium: p$3x,
  UITextMdNormal: _$D,
  UIDisplaySmSemibold: c$1S,
  UITextSmRegular: _$C,
  UITextXsRegular: _$E,
  UIDivider: p$3A,
  UIMenu: d$4,
  UICard: $$h,
  UITimePicker: v$1,
  UIPopover: S$s,
  UISwitch: s,
  UIProgress: x$5,
  UIUpload: O$2,
  UISpace: y$5,
  UISkeleton: h$4,
  UIRadioGroupItem: V$4,
  UISlider: s$19,
  UIAlert: M$j,
  UIBreadcrumb: i$1$,
  UIBreadcrumbItem: p$3G,
  UIPreview: B$6,
  UIBuilderSpace: ie$d,
  UIDynamicTags: B$d,
  UIColorPicker: g$z,
  UICarousel: z$k,
  UIDraggableElement: U$q,
  UIDropdownTree: Ce$2,
  UIDataTable: i$13,
  UICodeEditor: he$3,
  UIInputPhone: G$4,
  UIFilter: ue$g,
  UIAdvancedSelect: Ne$7,
  UIIconPicker: ve$2,
  UISortFilter: je$1,
  UITreeSelect: h$2,
  UIPopselect: h$7,
  UIInputOtp: U$3,
  UICheckboxGroup: b$D,
  UICheckboxItem: q$l,
  UILoadingBar: T$4
});
function tryOnScopeDispose(fn2) {
  if (getCurrentScope()) {
    onScopeDispose(fn2);
    return true;
  }
  return false;
}
function toValue(r3) {
  return typeof r3 === "function" ? r3() : unref(r3);
}
const isClient = typeof window !== "undefined" && typeof document !== "undefined";
typeof WorkerGlobalScope !== "undefined" && globalThis instanceof WorkerGlobalScope;
const notNullish = (val) => val != null;
const toString$3 = Object.prototype.toString;
const isObject$3 = (val) => toString$3.call(val) === "[object Object]";
const noop$1 = () => {
};
const isIOS = /* @__PURE__ */ getIsIOS();
function getIsIOS() {
  var _a2, _b2;
  return isClient && ((_a2 = window == null ? void 0 : window.navigator) == null ? void 0 : _a2.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((_b2 = window == null ? void 0 : window.navigator) == null ? void 0 : _b2.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function createFilterWrapper(filter2, fn2) {
  function wrapper(...args) {
    return new Promise((resolve, reject) => {
      Promise.resolve(filter2(() => fn2.apply(this, args), { fn: fn2, thisArg: this, args })).then(resolve).catch(reject);
    });
  }
  return wrapper;
}
function debounceFilter(ms2, options = {}) {
  let timer;
  let maxTimer;
  let lastRejector = noop$1;
  const _clearTimeout = (timer2) => {
    clearTimeout(timer2);
    lastRejector();
    lastRejector = noop$1;
  };
  const filter2 = (invoke) => {
    const duration = toValue(ms2);
    const maxDuration = toValue(options.maxWait);
    if (timer)
      _clearTimeout(timer);
    if (duration <= 0 || maxDuration !== void 0 && maxDuration <= 0) {
      if (maxTimer) {
        _clearTimeout(maxTimer);
        maxTimer = null;
      }
      return Promise.resolve(invoke());
    }
    return new Promise((resolve, reject) => {
      lastRejector = options.rejectOnCancel ? reject : resolve;
      if (maxDuration && !maxTimer) {
        maxTimer = setTimeout(() => {
          if (timer)
            _clearTimeout(timer);
          maxTimer = null;
          resolve(invoke());
        }, maxDuration);
      }
      timer = setTimeout(() => {
        if (maxTimer)
          _clearTimeout(maxTimer);
        maxTimer = null;
        resolve(invoke());
      }, duration);
    });
  };
  return filter2;
}
function throttleFilter(ms2, trailing = true, leading = true, rejectOnCancel = false) {
  let lastExec = 0;
  let timer;
  let isLeading = true;
  let lastRejector = noop$1;
  let lastValue;
  const clear = () => {
    if (timer) {
      clearTimeout(timer);
      timer = void 0;
      lastRejector();
      lastRejector = noop$1;
    }
  };
  const filter2 = (_invoke) => {
    const duration = toValue(ms2);
    const elapsed = Date.now() - lastExec;
    const invoke = () => {
      return lastValue = _invoke();
    };
    clear();
    if (duration <= 0) {
      lastExec = Date.now();
      return invoke();
    }
    if (elapsed > duration && (leading || !isLeading)) {
      lastExec = Date.now();
      invoke();
    } else if (trailing) {
      lastValue = new Promise((resolve, reject) => {
        lastRejector = rejectOnCancel ? reject : resolve;
        timer = setTimeout(() => {
          lastExec = Date.now();
          isLeading = true;
          resolve(invoke());
          clear();
        }, Math.max(0, duration - elapsed));
      });
    }
    if (!leading && !timer)
      timer = setTimeout(() => isLeading = true, duration);
    isLeading = false;
    return lastValue;
  };
  return filter2;
}
const directiveHooks = {
  mounted: "mounted",
  updated: "updated",
  unmounted: "unmounted"
};
function getLifeCycleTarget(target) {
  return target || getCurrentInstance();
}
function toRef(...args) {
  if (args.length !== 1)
    return toRef$1(...args);
  const r3 = args[0];
  return typeof r3 === "function" ? readonly(customRef(() => ({ get: r3, set: noop$1 }))) : ref$1(r3);
}
function useDebounceFn(fn2, ms2 = 200, options = {}) {
  return createFilterWrapper(debounceFilter(ms2, options), fn2);
}
function useThrottleFn(fn2, ms2 = 200, trailing = false, leading = true, rejectOnCancel = false) {
  return createFilterWrapper(throttleFilter(ms2, trailing, leading, rejectOnCancel), fn2);
}
function tryOnMounted(fn2, sync = true, target) {
  const instance = getLifeCycleTarget();
  if (instance)
    onMounted(fn2, target);
  else if (sync)
    fn2();
  else
    nextTick(fn2);
}
isClient ? window : void 0;
const defaultDocument = isClient ? window.document : void 0;
isClient ? window.navigator : void 0;
isClient ? window.location : void 0;
function useFavicon(newIcon = null, options = {}) {
  const {
    baseUrl = "",
    rel = "icon",
    document: document2 = defaultDocument
  } = options;
  const favicon = toRef(newIcon);
  const applyIcon = (icon) => {
    const elements = document2 == null ? void 0 : document2.head.querySelectorAll(`link[rel*="${rel}"]`);
    if (!elements || elements.length === 0) {
      const link = document2 == null ? void 0 : document2.createElement("link");
      if (link) {
        link.rel = rel;
        link.href = `${baseUrl}${icon}`;
        link.type = `image/${icon.split(".").pop()}`;
        document2 == null ? void 0 : document2.head.append(link);
      }
      return;
    }
    elements == null ? void 0 : elements.forEach((el) => el.href = `${baseUrl}${icon}`);
  };
  watch(favicon, (i, o3) => {
    if (typeof i === "string" && i !== o3)
      applyIcon(i);
  }, { immediate: true });
  return favicon;
}
function bind(fn2, thisArg) {
  return function wrap() {
    return fn2.apply(thisArg, arguments);
  };
}
const { toString: toString$2 } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = ((cache) => (thing) => {
  const str = toString$2.call(thing);
  return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));
const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type;
};
const typeOfTest = (type) => (thing) => typeof thing === type;
const { isArray: isArray$1 } = Array;
const isUndefined$1 = typeOfTest("undefined");
function isBuffer(val) {
  return val !== null && !isUndefined$1(val) && val.constructor !== null && !isUndefined$1(val.constructor) && isFunction$3(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(val) {
  let result2;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result2 = ArrayBuffer.isView(val);
  } else {
    result2 = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result2;
}
const isString$2 = typeOfTest("string");
const isFunction$3 = typeOfTest("function");
const isNumber$1 = typeOfTest("number");
const isObject$2 = (thing) => thing !== null && typeof thing === "object";
const isBoolean = (thing) => thing === true || thing === false;
const isPlainObject$1 = (val) => {
  if (kindOf(val) !== "object") {
    return false;
  }
  const prototype2 = getPrototypeOf(val);
  return (prototype2 === null || prototype2 === Object.prototype || Object.getPrototypeOf(prototype2) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
const isDate$2 = kindOfTest("Date");
const isFile = kindOfTest("File");
const isBlob = kindOfTest("Blob");
const isFileList = kindOfTest("FileList");
const isStream = (val) => isObject$2(val) && isFunction$3(val.pipe);
const isFormData = (thing) => {
  let kind;
  return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction$3(thing.append) && ((kind = kindOf(thing)) === "formdata" || kind === "object" && isFunction$3(thing.toString) && thing.toString() === "[object FormData]"));
};
const isURLSearchParams = kindOfTest("URLSearchParams");
const [isReadableStream, isRequest, isResponse, isHeaders] = ["ReadableStream", "Request", "Response", "Headers"].map(kindOfTest);
const trim = (str) => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach$1(obj, fn2, { allOwnKeys = false } = {}) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  let i;
  let l3;
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray$1(obj)) {
    for (i = 0, l3 = obj.length; i < l3; i++) {
      fn2.call(null, obj[i], i, obj);
    }
  } else {
    const keys2 = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys2.length;
    let key;
    for (i = 0; i < len; i++) {
      key = keys2[i];
      fn2.call(null, obj[key], key, obj);
    }
  }
}
function findKey(obj, key) {
  key = key.toLowerCase();
  const keys2 = Object.keys(obj);
  let i = keys2.length;
  let _key;
  while (i-- > 0) {
    _key = keys2[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}
const _global = (() => {
  if (typeof globalThis !== "undefined")
    return globalThis;
  return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
})();
const isContextDefined = (context) => !isUndefined$1(context) && context !== _global;
function merge() {
  const { caseless } = isContextDefined(this) && this || {};
  const result2 = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result2, key) || key;
    if (isPlainObject$1(result2[targetKey]) && isPlainObject$1(val)) {
      result2[targetKey] = merge(result2[targetKey], val);
    } else if (isPlainObject$1(val)) {
      result2[targetKey] = merge({}, val);
    } else if (isArray$1(val)) {
      result2[targetKey] = val.slice();
    } else {
      result2[targetKey] = val;
    }
  };
  for (let i = 0, l3 = arguments.length; i < l3; i++) {
    arguments[i] && forEach$1(arguments[i], assignValue);
  }
  return result2;
}
const extend$1 = (a3, b3, thisArg, { allOwnKeys } = {}) => {
  forEach$1(b3, (val, key) => {
    if (thisArg && isFunction$3(val)) {
      a3[key] = bind(val, thisArg);
    } else {
      a3[key] = val;
    }
  }, { allOwnKeys });
  return a3;
};
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
};
const inherits = (constructor, superConstructor, props, descriptors2) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors2);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, "super", {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};
const toFlatObject = (sourceObj, destObj, filter2, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};
  destObj = destObj || {};
  if (sourceObj == null)
    return destObj;
  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter2 !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter2 || filter2(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
};
const endsWith$1 = (str, searchString, position) => {
  str = String(str);
  if (position === void 0 || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};
const toArray$3 = (thing) => {
  if (!thing)
    return null;
  if (isArray$1(thing))
    return thing;
  let i = thing.length;
  if (!isNumber$1(i))
    return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};
const isTypedArray = ((TypedArray) => {
  return (thing) => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
const forEachEntry = (obj, fn2) => {
  const generator = obj && obj[Symbol.iterator];
  const iterator = generator.call(obj);
  let result2;
  while ((result2 = iterator.next()) && !result2.done) {
    const pair = result2.value;
    fn2.call(obj, pair[0], pair[1]);
  }
};
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];
  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }
  return arr;
};
const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str) => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m3, p1, p22) {
    return p1.toUpperCase() + p22;
  });
};
const hasOwnProperty = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop) => hasOwnProperty2.call(obj, prop))(Object.prototype);
const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer) => {
  const descriptors2 = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};
  forEach$1(descriptors2, (descriptor, name2) => {
    let ret;
    if ((ret = reducer(descriptor, name2, obj)) !== false) {
      reducedDescriptors[name2] = ret || descriptor;
    }
  });
  Object.defineProperties(obj, reducedDescriptors);
};
const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name2) => {
    if (isFunction$3(obj) && ["arguments", "caller", "callee"].indexOf(name2) !== -1) {
      return false;
    }
    const value = obj[name2];
    if (!isFunction$3(value))
      return;
    descriptor.enumerable = false;
    if ("writable" in descriptor) {
      descriptor.writable = false;
      return;
    }
    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error("Can not rewrite read-only method '" + name2 + "'");
      };
    }
  });
};
const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};
  const define = (arr) => {
    arr.forEach((value) => {
      obj[value] = true;
    });
  };
  isArray$1(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
  return obj;
};
const noop = () => {
};
const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const ALPHA = "abcdefghijklmnopqrstuvwxyz";
const DIGIT = "0123456789";
const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = "";
  const { length } = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length | 0];
  }
  return str;
};
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction$3(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const toJSONObject = (obj) => {
  const stack = new Array(10);
  const visit = (source, i) => {
    if (isObject$2(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }
      if (!("toJSON" in source)) {
        stack[i] = source;
        const target = isArray$1(source) ? [] : {};
        forEach$1(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined$1(reducedValue) && (target[key] = reducedValue);
        });
        stack[i] = void 0;
        return target;
      }
    }
    return source;
  };
  return visit(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable = (thing) => thing && (isObject$2(thing) || isFunction$3(thing)) && isFunction$3(thing.then) && isFunction$3(thing.catch);
const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }
  return postMessageSupported ? ((token2, callbacks) => {
    _global.addEventListener("message", ({ source, data }) => {
      if (source === _global && data === token2) {
        callbacks.length && callbacks.shift()();
      }
    }, false);
    return (cb2) => {
      callbacks.push(cb2);
      _global.postMessage(token2, "*");
    };
  })(`axios@${Math.random()}`, []) : (cb2) => setTimeout(cb2);
})(typeof setImmediate === "function", isFunction$3(_global.postMessage));
const asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind(_global) : typeof process !== "undefined" && process.nextTick || _setImmediate;
var utils$1 = {
  isArray: isArray$1,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString: isString$2,
  isNumber: isNumber$1,
  isBoolean,
  isObject: isObject$2,
  isPlainObject: isPlainObject$1,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined: isUndefined$1,
  isDate: isDate$2,
  isFile,
  isBlob,
  isRegExp,
  isFunction: isFunction$3,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach: forEach$1,
  merge,
  extend: extend$1,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith: endsWith$1,
  toArray: toArray$3,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap
};
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = new Error().stack;
  }
  this.message = message;
  this.name = "AxiosError";
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}
utils$1.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const prototype$1 = AxiosError.prototype;
const descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
].forEach((code) => {
  descriptors[code] = { value: code };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: true });
AxiosError.from = (error2, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);
  utils$1.toFlatObject(error2, axiosError, function filter2(obj) {
    return obj !== Error.prototype;
  }, (prop) => {
    return prop !== "isAxiosError";
  });
  AxiosError.call(axiosError, error2.message, code, config, request, response);
  axiosError.cause = error2;
  axiosError.name = error2.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};
var httpAdapter = null;
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}
function removeBrackets(key) {
  return utils$1.endsWith(key, "[]") ? key.slice(0, -2) : key;
}
function renderKey(path, key, dots) {
  if (!path)
    return key;
  return path.concat(key).map(function each2(token2, i) {
    token2 = removeBrackets(token2);
    return !dots && i ? "[" + token2 + "]" : token2;
  }).join(dots ? "." : "");
}
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}
const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});
function toFormData(obj, formData, options) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError("target must be an object");
  }
  formData = formData || new FormData();
  options = utils$1.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    return !utils$1.isUndefined(source[option]);
  });
  const metaTokens = options.metaTokens;
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);
  if (!utils$1.isFunction(visitor)) {
    throw new TypeError("visitor must be a function");
  }
  function convertValue(value) {
    if (value === null)
      return "";
    if (utils$1.isDate(value)) {
      return value.toISOString();
    }
    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError("Blob is not supported. Use a Buffer instead.");
    }
    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
    }
    return value;
  }
  function defaultVisitor(value, key, path) {
    let arr = value;
    if (value && !path && typeof value === "object") {
      if (utils$1.endsWith(key, "{}")) {
        key = metaTokens ? key : key.slice(0, -2);
        value = JSON.stringify(value);
      } else if (utils$1.isArray(value) && isFlatArray(value) || (utils$1.isFileList(value) || utils$1.endsWith(key, "[]")) && (arr = utils$1.toArray(value))) {
        key = removeBrackets(key);
        arr.forEach(function each2(el, index) {
          !(utils$1.isUndefined(el) || el === null) && formData.append(indexes === true ? renderKey([key], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
        });
        return false;
      }
    }
    if (isVisitable(value)) {
      return true;
    }
    formData.append(renderKey(path, key, dots), convertValue(value));
    return false;
  }
  const stack = [];
  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });
  function build(value, path) {
    if (utils$1.isUndefined(value))
      return;
    if (stack.indexOf(value) !== -1) {
      throw Error("Circular reference detected in " + path.join("."));
    }
    stack.push(value);
    utils$1.forEach(value, function each2(el, key) {
      const result2 = !(utils$1.isUndefined(el) || el === null) && visitor.call(formData, el, utils$1.isString(key) ? key.trim() : key, path, exposedHelpers);
      if (result2 === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });
    stack.pop();
  }
  if (!utils$1.isObject(obj)) {
    throw new TypeError("data must be an object");
  }
  build(obj);
  return formData;
}
function encode$2(str) {
  const charMap = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}
function AxiosURLSearchParams(params2, options) {
  this._pairs = [];
  params2 && toFormData(params2, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name2, value) {
  this._pairs.push([name2, value]);
};
prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$2);
  } : encode$2;
  return this._pairs.map(function each2(pair) {
    return _encode(pair[0]) + "=" + _encode(pair[1]);
  }, "").join("&");
};
function encode$1(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url, params2, options) {
  if (!params2) {
    return url;
  }
  const _encode = options && options.encode || encode$1;
  const serializeFn = options && options.serialize;
  let serializedParams;
  if (serializeFn) {
    serializedParams = serializeFn(params2, options);
  } else {
    serializedParams = utils$1.isURLSearchParams(params2) ? params2.toString() : new AxiosURLSearchParams(params2, options).toString(_encode);
  }
  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }
  eject(id2) {
    if (this.handlers[id2]) {
      this.handlers[id2] = null;
    }
  }
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }
  forEach(fn2) {
    utils$1.forEach(this.handlers, function forEachHandler(h3) {
      if (h3 !== null) {
        fn2(h3);
      }
    });
  }
}
var InterceptorManager$1 = InterceptorManager;
var transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
var URLSearchParams$1 = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams;
var FormData$1 = typeof FormData !== "undefined" ? FormData : null;
var Blob$1 = typeof Blob !== "undefined" ? Blob : null;
var platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
const hasStandardBrowserEnv = ((product) => {
  return hasBrowserEnv && ["ReactNative", "NativeScript", "NS"].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
const hasStandardBrowserWebWorkerEnv = (() => {
  return typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const origin = hasBrowserEnv && window.location.href || "http://localhost";
var utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserWebWorkerEnv,
  hasStandardBrowserEnv,
  origin
}, Symbol.toStringTag, { value: "Module" }));
var platform = __spreadValues(__spreadValues({}, utils), platform$1);
function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString("base64"));
        return false;
      }
      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}
function parsePropPath(name2) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name2).map((match) => {
    return match[0] === "[]" ? "" : match[1] || match[0];
  });
}
function arrayToObject(arr) {
  const obj = {};
  const keys2 = Object.keys(arr);
  let i;
  const len = keys2.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys2[i];
    obj[key] = arr[key];
  }
  return obj;
}
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name2 = path[index++];
    if (name2 === "__proto__")
      return true;
    const isNumericKey = Number.isFinite(+name2);
    const isLast = index >= path.length;
    name2 = !name2 && utils$1.isArray(target) ? target.length : name2;
    if (isLast) {
      if (utils$1.hasOwnProp(target, name2)) {
        target[name2] = [target[name2], value];
      } else {
        target[name2] = value;
      }
      return !isNumericKey;
    }
    if (!target[name2] || !utils$1.isObject(target[name2])) {
      target[name2] = [];
    }
    const result2 = buildPath(path, value, target[name2], index);
    if (result2 && utils$1.isArray(target[name2])) {
      target[name2] = arrayToObject(target[name2]);
    }
    return !isNumericKey;
  }
  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};
    utils$1.forEachEntry(formData, (name2, value) => {
      buildPath(parsePropPath(name2), value, obj, 0);
    });
    return obj;
  }
  return null;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e28) {
      if (e28.name !== "SyntaxError") {
        throw e28;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
const defaults$1 = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || "";
    const hasJSONContentType = contentType.indexOf("application/json") > -1;
    const isObjectPayload = utils$1.isObject(data);
    if (isObjectPayload && utils$1.isHTMLForm(data)) {
      data = new FormData(data);
    }
    const isFormData2 = utils$1.isFormData(data);
    if (isFormData2) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }
    if (utils$1.isArrayBuffer(data) || utils$1.isBuffer(data) || utils$1.isStream(data) || utils$1.isFile(data) || utils$1.isBlob(data) || utils$1.isReadableStream(data)) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
      return data.toString();
    }
    let isFileList2;
    if (isObjectPayload) {
      if (contentType.indexOf("application/x-www-form-urlencoded") > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }
      if ((isFileList2 = utils$1.isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
        const _FormData = this.env && this.env.FormData;
        return toFormData(isFileList2 ? { "files[]": data } : data, _FormData && new _FormData(), this.formSerializer);
      }
    }
    if (isObjectPayload || hasJSONContentType) {
      headers.setContentType("application/json", false);
      return stringifySafely(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    const transitional2 = this.transitional || defaults$1.transitional;
    const forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    const JSONRequested = this.responseType === "json";
    if (utils$1.isResponse(data) || utils$1.isReadableStream(data)) {
      return data;
    }
    if (data && utils$1.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      const silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;
      try {
        return JSON.parse(data);
      } catch (e28) {
        if (strictJSONParsing) {
          if (e28.name === "SyntaxError") {
            throw AxiosError.from(e28, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e28;
        }
      }
    }
    return data;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (method) => {
  defaults$1.headers[method] = {};
});
var defaults$2 = defaults$1;
const ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]);
var parseHeaders = (rawHeaders) => {
  const parsed = {};
  let key;
  let val;
  let i;
  rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
    i = line.indexOf(":");
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();
    if (!key || parsed[key] && ignoreDuplicateOf[key]) {
      return;
    }
    if (key === "set-cookie") {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    }
  });
  return parsed;
};
const $internals = Symbol("internals");
function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }
  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
  const tokens2 = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;
  while (match = tokensRE.exec(str)) {
    tokens2[match[1]] = match[2];
  }
  return tokens2;
}
const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter2, isHeaderNameFilter) {
  if (utils$1.isFunction(filter2)) {
    return filter2.call(this, value, header);
  }
  if (isHeaderNameFilter) {
    value = header;
  }
  if (!utils$1.isString(value))
    return;
  if (utils$1.isString(filter2)) {
    return value.indexOf(filter2) !== -1;
  }
  if (utils$1.isRegExp(filter2)) {
    return filter2.test(value);
  }
}
function formatHeader(header) {
  return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w3, char, str) => {
    return char.toUpperCase() + str;
  });
}
function buildAccessors(obj, header) {
  const accessorName = utils$1.toCamelCase(" " + header);
  ["get", "set", "has"].forEach((methodName) => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}
class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }
  set(header, valueOrRewrite, rewrite) {
    const self2 = this;
    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);
      if (!lHeader) {
        throw new Error("header name must be a non-empty string");
      }
      const key = utils$1.findKey(self2, lHeader);
      if (!key || self2[key] === void 0 || _rewrite === true || _rewrite === void 0 && self2[key] !== false) {
        self2[key || _header] = normalizeValue(_value);
      }
    }
    const setHeaders = (headers, _rewrite) => utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));
    if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if (utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils$1.isHeaders(header)) {
      for (const [key, value] of header.entries()) {
        setHeader(value, key, rewrite);
      }
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }
    return this;
  }
  get(header, parser) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils$1.findKey(this, header);
      if (key) {
        const value = this[key];
        if (!parser) {
          return value;
        }
        if (parser === true) {
          return parseTokens(value);
        }
        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }
        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(header, matcher) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils$1.findKey(this, header);
      return !!(key && this[key] !== void 0 && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }
    return false;
  }
  delete(header, matcher) {
    const self2 = this;
    let deleted = false;
    function deleteHeader(_header) {
      _header = normalizeHeader(_header);
      if (_header) {
        const key = utils$1.findKey(self2, _header);
        if (key && (!matcher || matchHeaderValue(self2, self2[key], key, matcher))) {
          delete self2[key];
          deleted = true;
        }
      }
    }
    if (utils$1.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }
    return deleted;
  }
  clear(matcher) {
    const keys2 = Object.keys(this);
    let i = keys2.length;
    let deleted = false;
    while (i--) {
      const key = keys2[i];
      if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }
    return deleted;
  }
  normalize(format2) {
    const self2 = this;
    const headers = {};
    utils$1.forEach(this, (value, header) => {
      const key = utils$1.findKey(headers, header);
      if (key) {
        self2[key] = normalizeValue(value);
        delete self2[header];
        return;
      }
      const normalized = format2 ? formatHeader(header) : String(header).trim();
      if (normalized !== header) {
        delete self2[header];
      }
      self2[normalized] = normalizeValue(value);
      headers[normalized] = true;
    });
    return this;
  }
  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }
  toJSON(asStrings) {
    const obj = Object.create(null);
    utils$1.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(", ") : value);
    });
    return obj;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ": " + value).join("\n");
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }
  static concat(first, ...targets) {
    const computed2 = new this(first);
    targets.forEach((target) => computed2.set(target));
    return computed2;
  }
  static accessor(header) {
    const internals = this[$internals] = this[$internals] = {
      accessors: {}
    };
    const accessors = internals.accessors;
    const prototype2 = this.prototype;
    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);
      if (!accessors[lHeader]) {
        buildAccessors(prototype2, _header);
        accessors[lHeader] = true;
      }
    }
    utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
    return this;
  }
}
AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({ value }, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1);
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders);
var AxiosHeaders$1 = AxiosHeaders;
function transformData(fns, response) {
  const config = this || defaults$2;
  const context = response || config;
  const headers = AxiosHeaders$1.from(context.headers);
  let data = context.data;
  utils$1.forEach(fns, function transform(fn2) {
    data = fn2.call(config, data, headers.normalize(), response ? response.status : void 0);
  });
  headers.normalize();
  return data;
}
function isCancel(value) {
  return !!(value && value.__CANCEL__);
}
function CanceledError(message, config, request) {
  AxiosError.call(this, message == null ? "canceled" : message, AxiosError.ERR_CANCELED, config, request);
  this.name = "CanceledError";
}
utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});
function settle(resolve, reject, response) {
  const validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError("Request failed with status code " + response.status, [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4], response.config, response.request, response));
  }
}
function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || "";
}
function speedometer(samplesCount, min2) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;
  min2 = min2 !== void 0 ? min2 : 1e3;
  return function push(chunkLength) {
    const now2 = Date.now();
    const startedAt = timestamps[tail];
    if (!firstSampleTS) {
      firstSampleTS = now2;
    }
    bytes[head] = chunkLength;
    timestamps[head] = now2;
    let i = tail;
    let bytesCount = 0;
    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }
    head = (head + 1) % samplesCount;
    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }
    if (now2 - firstSampleTS < min2) {
      return;
    }
    const passed = startedAt && now2 - startedAt;
    return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
  };
}
function throttle(fn2, freq) {
  let timestamp = 0;
  let threshold = 1e3 / freq;
  let lastArgs;
  let timer;
  const invoke = (args, now2 = Date.now()) => {
    timestamp = now2;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn2.apply(null, args);
  };
  const throttled = (...args) => {
    const now2 = Date.now();
    const passed = now2 - timestamp;
    if (passed >= threshold) {
      invoke(args, now2);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };
  const flush = () => lastArgs && invoke(lastArgs);
  return [throttled, flush];
}
const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);
  return throttle((e28) => {
    const loaded = e28.loaded;
    const total = e28.lengthComputable ? e28.total : void 0;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;
    bytesNotified = loaded;
    const data = {
      loaded,
      total,
      progress: total ? loaded / total : void 0,
      bytes: progressBytes,
      rate: rate ? rate : void 0,
      estimated: rate && total && inRange ? (total - loaded) / rate : void 0,
      event: e28,
      lengthComputable: total != null,
      [isDownloadStream ? "download" : "upload"]: true
    };
    listener(data);
  }, freq);
};
const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;
  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
};
const asyncDecorator = (fn2) => (...args) => utils$1.asap(() => fn2(...args));
var isURLSameOrigin = platform.hasStandardBrowserEnv ? function standardBrowserEnv() {
  const msie = /(msie|trident)/i.test(navigator.userAgent);
  const urlParsingNode = document.createElement("a");
  let originURL;
  function resolveURL(url) {
    let href = url;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    const parsed = utils$1.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
var cookies = platform.hasStandardBrowserEnv ? {
  write(name2, value, expires, path, domain, secure) {
    const cookie = [name2 + "=" + encodeURIComponent(value)];
    utils$1.isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
    utils$1.isString(path) && cookie.push("path=" + path);
    utils$1.isString(domain) && cookie.push("domain=" + domain);
    secure === true && cookie.push("secure");
    document.cookie = cookie.join("; ");
  },
  read(name2) {
    const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name2 + ")=([^;]*)"));
    return match ? decodeURIComponent(match[3]) : null;
  },
  remove(name2) {
    this.write(name2, "", Date.now() - 864e5);
  }
} : {
  write() {
  },
  read() {
    return null;
  },
  remove() {
  }
};
function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}
const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? __spreadValues({}, thing) : thing;
function mergeConfig(config1, config2) {
  config2 = config2 || {};
  const config = {};
  function getMergedValue(target, source, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({ caseless }, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(a3, b3, caseless) {
    if (!utils$1.isUndefined(b3)) {
      return getMergedValue(a3, b3, caseless);
    } else if (!utils$1.isUndefined(a3)) {
      return getMergedValue(void 0, a3, caseless);
    }
  }
  function valueFromConfig2(a3, b3) {
    if (!utils$1.isUndefined(b3)) {
      return getMergedValue(void 0, b3);
    }
  }
  function defaultToConfig2(a3, b3) {
    if (!utils$1.isUndefined(b3)) {
      return getMergedValue(void 0, b3);
    } else if (!utils$1.isUndefined(a3)) {
      return getMergedValue(void 0, a3);
    }
  }
  function mergeDirectKeys(a3, b3, prop) {
    if (prop in config2) {
      return getMergedValue(a3, b3);
    } else if (prop in config1) {
      return getMergedValue(void 0, a3);
    }
  }
  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a3, b3) => mergeDeepProperties(headersToObject(a3), headersToObject(b3), true)
  };
  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge2 = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge2(config1[prop], config2[prop], prop);
    utils$1.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
}
var resolveConfig = (config) => {
  const newConfig = mergeConfig({}, config);
  let { data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth } = newConfig;
  newConfig.headers = headers = AxiosHeaders$1.from(headers);
  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
  if (auth) {
    headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
  }
  let contentType;
  if (utils$1.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(void 0);
    } else if ((contentType = headers.getContentType()) !== false) {
      const [type, ...tokens2] = contentType ? contentType.split(";").map((token2) => token2.trim()).filter(Boolean) : [];
      headers.setContentType([type || "multipart/form-data", ...tokens2].join("; "));
    }
  }
  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
    if (withXSRFToken || withXSRFToken !== false && isURLSameOrigin(newConfig.url)) {
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);
      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }
  return newConfig;
};
const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var xhrAdapter = isXHRAdapterSupported && function(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = AxiosHeaders$1.from(_config.headers).normalize();
    let { responseType, onUploadProgress, onDownloadProgress } = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;
    function done() {
      flushUpload && flushUpload();
      flushDownload && flushDownload();
      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
      _config.signal && _config.signal.removeEventListener("abort", onCanceled);
    }
    let request = new XMLHttpRequest();
    request.open(_config.method.toUpperCase(), _config.url, true);
    request.timeout = _config.timeout;
    function onloadend() {
      if (!request) {
        return;
      }
      const responseHeaders = AxiosHeaders$1.from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
      const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request = null;
    }
    if ("onloadend" in request) {
      request.onloadend = onloadend;
    } else {
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject(new AxiosError("Request aborted", AxiosError.ECONNABORTED, config, request));
      request = null;
    };
    request.onerror = function handleError() {
      reject(new AxiosError("Network Error", AxiosError.ERR_NETWORK, config, request));
      request = null;
    };
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
      const transitional2 = _config.transitional || transitionalDefaults;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new AxiosError(timeoutErrorMessage, transitional2.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED, config, request));
      request = null;
    };
    requestData === void 0 && requestHeaders.setContentType(null);
    if ("setRequestHeader" in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }
    if (!utils$1.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request.responseType = _config.responseType;
    }
    if (onDownloadProgress) {
      [downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true);
      request.addEventListener("progress", downloadThrottled);
    }
    if (onUploadProgress && request.upload) {
      [uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress);
      request.upload.addEventListener("progress", uploadThrottled);
      request.upload.addEventListener("loadend", flushUpload);
    }
    if (_config.cancelToken || _config.signal) {
      onCanceled = (cancel) => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };
      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
      }
    }
    const protocol = parseProtocol(_config.url);
    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError("Unsupported protocol " + protocol + ":", AxiosError.ERR_BAD_REQUEST, config));
      return;
    }
    request.send(requestData || null);
  });
};
const composeSignals = (signals, timeout) => {
  let controller = new AbortController();
  let aborted;
  const onabort = function(cancel) {
    if (!aborted) {
      aborted = true;
      unsubscribe();
      const err = cancel instanceof Error ? cancel : this.reason;
      controller.abort(err instanceof AxiosError ? err : new CanceledError(err instanceof Error ? err.message : err));
    }
  };
  let timer = timeout && setTimeout(() => {
    onabort(new AxiosError(`timeout ${timeout} of ms exceeded`, AxiosError.ETIMEDOUT));
  }, timeout);
  const unsubscribe = () => {
    if (signals) {
      timer && clearTimeout(timer);
      timer = null;
      signals.forEach((signal2) => {
        signal2 && (signal2.removeEventListener ? signal2.removeEventListener("abort", onabort) : signal2.unsubscribe(onabort));
      });
      signals = null;
    }
  };
  signals.forEach((signal2) => signal2 && signal2.addEventListener && signal2.addEventListener("abort", onabort));
  const { signal } = controller;
  signal.unsubscribe = unsubscribe;
  return [signal, () => {
    timer && clearTimeout(timer);
    timer = null;
  }];
};
var composeSignals$1 = composeSignals;
const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;
  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }
  let pos = 0;
  let end;
  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};
const readBytes = async function* (iterable, chunkSize, encode2) {
  for await (const chunk of iterable) {
    yield* streamChunk(ArrayBuffer.isView(chunk) ? chunk : await encode2(String(chunk)), chunkSize);
  }
};
const trackStream = (stream, chunkSize, onProgress, onFinish, encode2) => {
  const iterator = readBytes(stream, chunkSize, encode2);
  let bytes = 0;
  let done;
  let _onFinish = (e28) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e28);
    }
  };
  return new ReadableStream({
    async pull(controller) {
      try {
        const { done: done2, value } = await iterator.next();
        if (done2) {
          _onFinish();
          controller.close();
          return;
        }
        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  });
};
const isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === "function";
const encodeText = isFetchSupported && (typeof TextEncoder === "function" ? ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) : async (str) => new Uint8Array(await new Response(str).arrayBuffer()));
const test = (fn2, ...args) => {
  try {
    return !!fn2(...args);
  } catch (e28) {
    return false;
  }
};
const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;
  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      duplexAccessed = true;
      return "half";
    }
  }).headers.has("Content-Type");
  return duplexAccessed && !hasContentType;
});
const DEFAULT_CHUNK_SIZE = 64 * 1024;
const supportsResponseStream = isReadableStreamSupported && test(() => utils$1.isReadableStream(new Response("").body));
const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};
isFetchSupported && ((res) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((type) => {
    !resolvers[type] && (resolvers[type] = utils$1.isFunction(res[type]) ? (res2) => res2[type]() : (_3, config) => {
      throw new AxiosError(`Response type '${type}' is not supported`, AxiosError.ERR_NOT_SUPPORT, config);
    });
  });
})(new Response());
const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }
  if (utils$1.isBlob(body)) {
    return body.size;
  }
  if (utils$1.isSpecCompliantForm(body)) {
    return (await new Request(body).arrayBuffer()).byteLength;
  }
  if (utils$1.isArrayBufferView(body) || utils$1.isArrayBuffer(body)) {
    return body.byteLength;
  }
  if (utils$1.isURLSearchParams(body)) {
    body = body + "";
  }
  if (utils$1.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
};
const resolveBodyLength = async (headers, body) => {
  const length = utils$1.toFiniteNumber(headers.getContentLength());
  return length == null ? getBodyLength(body) : length;
};
var fetchAdapter = isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = "same-origin",
    fetchOptions
  } = resolveConfig(config);
  responseType = responseType ? (responseType + "").toLowerCase() : "text";
  let [composedSignal, stopTimeout] = signal || cancelToken || timeout ? composeSignals$1([signal, cancelToken], timeout) : [];
  let finished, request;
  const onFinish = () => {
    !finished && setTimeout(() => {
      composedSignal && composedSignal.unsubscribe();
    });
    finished = true;
  };
  let requestContentLength;
  try {
    if (onUploadProgress && supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
      let _request = new Request(url, {
        method: "POST",
        body: data,
        duplex: "half"
      });
      let contentTypeHeader;
      if (utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) {
        headers.setContentType(contentTypeHeader);
      }
      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(requestContentLength, progressEventReducer(asyncDecorator(onUploadProgress)));
        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush, encodeText);
      }
    }
    if (!utils$1.isString(withCredentials)) {
      withCredentials = withCredentials ? "include" : "omit";
    }
    request = new Request(url, __spreadProps(__spreadValues({}, fetchOptions), {
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: withCredentials
    }));
    let response = await fetch(request);
    const isStreamResponse = supportsResponseStream && (responseType === "stream" || responseType === "response");
    if (supportsResponseStream && (onDownloadProgress || isStreamResponse)) {
      const options = {};
      ["status", "statusText", "headers"].forEach((prop) => {
        options[prop] = response[prop];
      });
      const responseContentLength = utils$1.toFiniteNumber(response.headers.get("content-length"));
      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(responseContentLength, progressEventReducer(asyncDecorator(onDownloadProgress), true)) || [];
      response = new Response(trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
        flush && flush();
        isStreamResponse && onFinish();
      }, encodeText), options);
    }
    responseType = responseType || "text";
    let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || "text"](response, config);
    !isStreamResponse && onFinish();
    stopTimeout && stopTimeout();
    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: AxiosHeaders$1.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      });
    });
  } catch (err) {
    onFinish();
    if (err && err.name === "TypeError" && /fetch/i.test(err.message)) {
      throw Object.assign(new AxiosError("Network Error", AxiosError.ERR_NETWORK, config, request), {
        cause: err.cause || err
      });
    }
    throw AxiosError.from(err, err && err.code, config, request);
  }
});
const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};
utils$1.forEach(knownAdapters, (fn2, value) => {
  if (fn2) {
    try {
      Object.defineProperty(fn2, "name", { value });
    } catch (e28) {
    }
    Object.defineProperty(fn2, "adapterName", { value });
  }
});
const renderReason = (reason) => `- ${reason}`;
const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;
var adapters = {
  getAdapter: (adapters2) => {
    adapters2 = utils$1.isArray(adapters2) ? adapters2 : [adapters2];
    const { length } = adapters2;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters2[i];
      let id2;
      adapter = nameOrAdapter;
      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id2 = String(nameOrAdapter)).toLowerCase()];
        if (adapter === void 0) {
          throw new AxiosError(`Unknown adapter '${id2}'`);
        }
      }
      if (adapter) {
        break;
      }
      rejectedReasons[id2 || "#" + i] = adapter;
    }
    if (!adapter) {
      const reasons = Object.entries(rejectedReasons).map(([id2, state]) => `adapter ${id2} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
      let s3 = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
      throw new AxiosError(`There is no suitable adapter to dispatch the request ` + s3, "ERR_NOT_SUPPORT");
    }
    return adapter;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}
function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = AxiosHeaders$1.from(config.headers);
  config.data = transformData.call(config, config.transformRequest);
  if (["post", "put", "patch"].indexOf(config.method) !== -1) {
    config.headers.setContentType("application/x-www-form-urlencoded", false);
  }
  const adapter = adapters.getAdapter(config.adapter || defaults$2.adapter);
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData.call(config, config.transformResponse, response);
    response.headers = AxiosHeaders$1.from(response.headers);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData.call(config, config.transformResponse, reason.response);
        reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
      }
    }
    return Promise.reject(reason);
  });
}
const VERSION = "1.7.3";
const validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((type, i) => {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version2, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return (value, opt, opts) => {
    if (validator2 === false) {
      throw new AxiosError(formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")), AxiosError.ERR_DEPRECATED);
    }
    if (version2 && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(formatMessage(opt, " has been deprecated since v" + version2 + " and will be removed in the near future"));
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys2 = Object.keys(options);
  let i = keys2.length;
  while (i-- > 0) {
    const opt = keys2[i];
    const validator2 = schema[opt];
    if (validator2) {
      const value = options[opt];
      const result2 = value === void 0 || validator2(value, opt, options);
      if (result2 !== true) {
        throw new AxiosError("option " + opt + " must be " + result2, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError("Unknown option " + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}
var validator = {
  assertOptions,
  validators: validators$1
};
const validators = validator.validators;
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager$1(),
      response: new InterceptorManager$1()
    };
  }
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy;
        Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
        try {
          if (!err.stack) {
            err.stack = stack;
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) {
            err.stack += "\n" + stack;
          }
        } catch (e28) {
        }
      }
      throw err;
    }
  }
  _request(configOrUrl, config) {
    if (typeof configOrUrl === "string") {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }
    config = mergeConfig(this.defaults, config);
    const { transitional: transitional2, paramsSerializer, headers } = config;
    if (transitional2 !== void 0) {
      validator.assertOptions(transitional2, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }
    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }
    config.method = (config.method || this.defaults.method || "get").toLowerCase();
    let contextHeaders = headers && utils$1.merge(headers.common, headers[config.method]);
    headers && utils$1.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (method) => {
      delete headers[method];
    });
    config.headers = AxiosHeaders$1.concat(contextHeaders, headers);
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
        return;
      }
      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    let promise;
    let i = 0;
    let len;
    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), void 0];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;
      promise = Promise.resolve(config);
      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }
      return promise;
    }
    len = requestInterceptorChain.length;
    let newConfig = config;
    i = 0;
    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error2) {
        onRejected.call(this, error2);
        break;
      }
    }
    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error2) {
      return Promise.reject(error2);
    }
    i = 0;
    len = responseInterceptorChain.length;
    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }
    return promise;
  }
  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}
utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url,
        data
      }));
    };
  }
  Axios.prototype[method] = generateHTTPMethod();
  Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var Axios$1 = Axios;
class CancelToken {
  constructor(executor) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    let resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    const token2 = this;
    this.promise.then((cancel) => {
      if (!token2._listeners)
        return;
      let i = token2._listeners.length;
      while (i-- > 0) {
        token2._listeners[i](cancel);
      }
      token2._listeners = null;
    });
    this.promise.then = (onfulfilled) => {
      let _resolve;
      const promise = new Promise((resolve) => {
        token2.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);
      promise.cancel = function reject() {
        token2.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel(message, config, request) {
      if (token2.reason) {
        return;
      }
      token2.reason = new CanceledError(message, config, request);
      resolvePromise(token2.reason);
    });
  }
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }
  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }
  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }
  static source() {
    let cancel;
    const token2 = new CancelToken(function executor(c3) {
      cancel = c3;
    });
    return {
      token: token2,
      cancel
    };
  }
}
var CancelToken$1 = CancelToken;
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}
function isAxiosError(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === true;
}
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});
var HttpStatusCode$1 = HttpStatusCode;
function createInstance(defaultConfig) {
  const context = new Axios$1(defaultConfig);
  const instance = bind(Axios$1.prototype.request, context);
  utils$1.extend(instance, Axios$1.prototype, context, { allOwnKeys: true });
  utils$1.extend(instance, context, null, { allOwnKeys: true });
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };
  return instance;
}
const axios = createInstance(defaults$2);
axios.Axios = Axios$1;
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;
axios.AxiosError = AxiosError;
axios.Cancel = axios.CanceledError;
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = spread;
axios.isAxiosError = isAxiosError;
axios.mergeConfig = mergeConfig;
axios.AxiosHeaders = AxiosHeaders$1;
axios.formToJSON = (thing) => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode$1;
axios.default = axios;
var axios$1 = axios;
(function() {
  var k3, aa2 = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a3, b3, c3) {
    a3 != Array.prototype && a3 != Object.prototype && (a3[b3] = c3.value);
  };
  function ba2(a3) {
    a3 = [typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global, a3];
    for (var b3 = 0; b3 < a3.length; ++b3) {
      var c3 = a3[b3];
      if (c3 && c3.Math == Math)
        return c3;
    }
    return globalThis;
  }
  var ca2 = ba2(this);
  function da2(a3, b3) {
    if (b3) {
      var c3 = ca2;
      a3 = a3.split(".");
      for (var d3 = 0; d3 < a3.length - 1; d3++) {
        var e28 = a3[d3];
        e28 in c3 || (c3[e28] = {});
        c3 = c3[e28];
      }
      a3 = a3[a3.length - 1];
      d3 = c3[a3];
      b3 = b3(d3);
      b3 != d3 && b3 != null && aa2(c3, a3, { configurable: true, writable: true, value: b3 });
    }
  }
  function ea2(a3) {
    var b3 = 0;
    return function() {
      return b3 < a3.length ? { done: false, value: a3[b3++] } : { done: true };
    };
  }
  function fa2(a3) {
    var b3 = typeof Symbol != "undefined" && Symbol.iterator && a3[Symbol.iterator];
    return b3 ? b3.call(a3) : { next: ea2(a3) };
  }
  da2("Promise", function(a3) {
    function b3(g3) {
      this.b = 0;
      this.c = void 0;
      this.a = [];
      var h3 = this.f();
      try {
        g3(h3.resolve, h3.reject);
      } catch (n3) {
        h3.reject(n3);
      }
    }
    function c3() {
      this.a = null;
    }
    function d3(g3) {
      return g3 instanceof b3 ? g3 : new b3(function(h3) {
        h3(g3);
      });
    }
    if (a3)
      return a3;
    c3.prototype.b = function(g3) {
      if (this.a == null) {
        this.a = [];
        var h3 = this;
        this.c(function() {
          h3.g();
        });
      }
      this.a.push(g3);
    };
    var e28 = ca2.setTimeout;
    c3.prototype.c = function(g3) {
      e28(g3, 0);
    };
    c3.prototype.g = function() {
      for (; this.a && this.a.length; ) {
        var g3 = this.a;
        this.a = [];
        for (var h3 = 0; h3 < g3.length; ++h3) {
          var n3 = g3[h3];
          g3[h3] = null;
          try {
            n3();
          } catch (p3) {
            this.f(p3);
          }
        }
      }
      this.a = null;
    };
    c3.prototype.f = function(g3) {
      this.c(function() {
        throw g3;
      });
    };
    b3.prototype.f = function() {
      function g3(p3) {
        return function(v3) {
          n3 || (n3 = true, p3.call(h3, v3));
        };
      }
      var h3 = this, n3 = false;
      return { resolve: g3(this.v), reject: g3(this.g) };
    };
    b3.prototype.v = function(g3) {
      if (g3 === this)
        this.g(new TypeError("A Promise cannot resolve to itself"));
      else if (g3 instanceof b3)
        this.s(g3);
      else {
        a:
          switch (typeof g3) {
            case "object":
              var h3 = g3 != null;
              break a;
            case "function":
              h3 = true;
              break a;
            default:
              h3 = false;
          }
        h3 ? this.m(g3) : this.i(g3);
      }
    };
    b3.prototype.m = function(g3) {
      var h3 = void 0;
      try {
        h3 = g3.then;
      } catch (n3) {
        this.g(n3);
        return;
      }
      typeof h3 == "function" ? this.u(h3, g3) : this.i(g3);
    };
    b3.prototype.g = function(g3) {
      this.h(2, g3);
    };
    b3.prototype.i = function(g3) {
      this.h(1, g3);
    };
    b3.prototype.h = function(g3, h3) {
      if (this.b != 0)
        throw Error("Cannot settle(" + g3 + ", " + h3 + "): Promise already settled in state" + this.b);
      this.b = g3;
      this.c = h3;
      this.l();
    };
    b3.prototype.l = function() {
      if (this.a != null) {
        for (var g3 = 0; g3 < this.a.length; ++g3)
          f3.b(this.a[g3]);
        this.a = null;
      }
    };
    var f3 = new c3();
    b3.prototype.s = function(g3) {
      var h3 = this.f();
      g3.Pa(h3.resolve, h3.reject);
    };
    b3.prototype.u = function(g3, h3) {
      var n3 = this.f();
      try {
        g3.call(h3, n3.resolve, n3.reject);
      } catch (p3) {
        n3.reject(p3);
      }
    };
    b3.prototype.then = function(g3, h3) {
      function n3(A3, Q3) {
        return typeof A3 == "function" ? function(xa2) {
          try {
            p3(A3(xa2));
          } catch (Ad2) {
            v3(Ad2);
          }
        } : Q3;
      }
      var p3, v3, B3 = new b3(function(A3, Q3) {
        p3 = A3;
        v3 = Q3;
      });
      this.Pa(n3(g3, p3), n3(h3, v3));
      return B3;
    };
    b3.prototype.catch = function(g3) {
      return this.then(void 0, g3);
    };
    b3.prototype.Pa = function(g3, h3) {
      function n3() {
        switch (p3.b) {
          case 1:
            g3(p3.c);
            break;
          case 2:
            h3(p3.c);
            break;
          default:
            throw Error("Unexpected state: " + p3.b);
        }
      }
      var p3 = this;
      this.a == null ? f3.b(n3) : this.a.push(n3);
    };
    b3.resolve = d3;
    b3.reject = function(g3) {
      return new b3(function(h3, n3) {
        n3(g3);
      });
    };
    b3.race = function(g3) {
      return new b3(function(h3, n3) {
        for (var p3 = fa2(g3), v3 = p3.next(); !v3.done; v3 = p3.next())
          d3(v3.value).Pa(h3, n3);
      });
    };
    b3.all = function(g3) {
      var h3 = fa2(g3), n3 = h3.next();
      return n3.done ? d3([]) : new b3(function(p3, v3) {
        function B3(xa2) {
          return function(Ad2) {
            A3[xa2] = Ad2;
            Q3--;
            Q3 == 0 && p3(A3);
          };
        }
        var A3 = [], Q3 = 0;
        do
          A3.push(void 0), Q3++, d3(n3.value).Pa(B3(A3.length - 1), v3), n3 = h3.next();
        while (!n3.done);
      });
    };
    return b3;
  });
  var ha2 = ha2 || {}, l3 = this || self, ia2 = /^[\w+/_-]+[=]{0,2}$/, ja2 = null;
  function ka2(a3) {
    return (a3 = a3.querySelector && a3.querySelector("script[nonce]")) && (a3 = a3.nonce || a3.getAttribute("nonce")) && ia2.test(a3) ? a3 : "";
  }
  function la2() {
  }
  function ma2(a3) {
    var b3 = typeof a3;
    return b3 != "object" ? b3 : a3 ? Array.isArray(a3) ? "array" : b3 : "null";
  }
  function na2(a3) {
    var b3 = ma2(a3);
    return b3 == "array" || b3 == "object" && typeof a3.length == "number";
  }
  function oa2(a3) {
    return ma2(a3) == "function";
  }
  function m3(a3) {
    var b3 = typeof a3;
    return b3 == "object" && a3 != null || b3 == "function";
  }
  function pa2(a3) {
    return Object.prototype.hasOwnProperty.call(a3, qa2) && a3[qa2] || (a3[qa2] = ++ra2);
  }
  var qa2 = "closure_uid_" + (1e9 * Math.random() >>> 0), ra2 = 0;
  function sa2(a3, b3, c3) {
    return a3.call.apply(a3.bind, arguments);
  }
  function ta2(a3, b3, c3) {
    if (!a3)
      throw Error();
    if (2 < arguments.length) {
      var d3 = Array.prototype.slice.call(arguments, 2);
      return function() {
        var e28 = Array.prototype.slice.call(arguments);
        Array.prototype.unshift.apply(e28, d3);
        return a3.apply(b3, e28);
      };
    }
    return function() {
      return a3.apply(b3, arguments);
    };
  }
  function q3(a3, b3, c3) {
    Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? q3 = sa2 : q3 = ta2;
    return q3.apply(null, arguments);
  }
  function ua2(a3, b3) {
    var c3 = Array.prototype.slice.call(arguments, 1);
    return function() {
      var d3 = c3.slice();
      d3.push.apply(d3, arguments);
      return a3.apply(this, d3);
    };
  }
  var va2 = Date.now;
  function r3(a3, b3) {
    function c3() {
    }
    c3.prototype = b3.prototype;
    a3.$a = b3.prototype;
    a3.prototype = new c3();
    a3.prototype.constructor = a3;
  }
  function wa2(a3) {
    return a3;
  }
  function t3(a3, b3, c3) {
    this.code = ya2 + a3;
    this.message = b3 || za2[a3] || "";
    this.a = c3 || null;
  }
  r3(t3, Error);
  t3.prototype.w = function() {
    var a3 = { code: this.code, message: this.message };
    this.a && (a3.serverResponse = this.a);
    return a3;
  };
  t3.prototype.toJSON = function() {
    return this.w();
  };
  function Aa2(a3) {
    var b3 = a3 && a3.code;
    return b3 ? new t3(b3.substring(ya2.length), a3.message, a3.serverResponse) : null;
  }
  var ya2 = "auth/", za2 = {
    "admin-restricted-operation": "This operation is restricted to administrators only.",
    "argument-error": "",
    "app-not-authorized": "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
    "app-not-installed": "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
    "captcha-check-failed": "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
    "code-expired": "The SMS code has expired. Please re-send the verification code to try again.",
    "cordova-not-ready": "Cordova framework is not ready.",
    "cors-unsupported": "This browser is not supported.",
    "credential-already-in-use": "This credential is already associated with a different user account.",
    "custom-token-mismatch": "The custom token corresponds to a different audience.",
    "requires-recent-login": "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
    "dynamic-link-not-activated": "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
    "email-change-needs-verification": "Multi-factor users must always have a verified email.",
    "email-already-in-use": "The email address is already in use by another account.",
    "expired-action-code": "The action code has expired. ",
    "cancelled-popup-request": "This operation has been cancelled due to another conflicting popup being opened.",
    "internal-error": "An internal error has occurred.",
    "invalid-app-credential": "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
    "invalid-app-id": "The mobile app identifier is not registed for the current project.",
    "invalid-user-token": "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
    "invalid-auth-event": "An internal error has occurred.",
    "invalid-verification-code": "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.",
    "invalid-continue-uri": "The continue URL provided in the request is invalid.",
    "invalid-cordova-configuration": "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
    "invalid-custom-token": "The custom token format is incorrect. Please check the documentation.",
    "invalid-dynamic-link-domain": "The provided dynamic link domain is not configured or authorized for the current project.",
    "invalid-email": "The email address is badly formatted.",
    "invalid-api-key": "Your API key is invalid, please check you have copied it correctly.",
    "invalid-cert-hash": "The SHA-1 certificate hash provided is invalid.",
    "invalid-credential": "The supplied auth credential is malformed or has expired.",
    "invalid-message-payload": "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
    "invalid-multi-factor-session": "The request does not contain a valid proof of first factor successful sign-in.",
    "invalid-oauth-provider": "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
    "invalid-oauth-client-id": "The OAuth client ID provided is either invalid or does not match the specified API key.",
    "unauthorized-domain": "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
    "invalid-action-code": "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
    "wrong-password": "The password is invalid or the user does not have a password.",
    "invalid-persistence-type": "The specified persistence type is invalid. It can only be local, session or none.",
    "invalid-phone-number": "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
    "invalid-provider-id": "The specified provider ID is invalid.",
    "invalid-recipient-email": "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
    "invalid-sender": "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
    "invalid-verification-id": "The verification ID used to create the phone auth credential is invalid.",
    "invalid-tenant-id": "The Auth instance's tenant ID is invalid.",
    "multi-factor-info-not-found": "The user does not have a second factor matching the identifier provided.",
    "multi-factor-auth-required": "Proof of ownership of a second factor is required to complete sign-in.",
    "missing-android-pkg-name": "An Android Package Name must be provided if the Android App is required to be installed.",
    "auth-domain-config-required": "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
    "missing-app-credential": "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
    "missing-verification-code": "The phone auth credential was created with an empty SMS verification code.",
    "missing-continue-uri": "A continue URL must be provided in the request.",
    "missing-iframe-start": "An internal error has occurred.",
    "missing-ios-bundle-id": "An iOS Bundle ID must be provided if an App Store ID is provided.",
    "missing-multi-factor-info": "No second factor identifier is provided.",
    "missing-multi-factor-session": "The request is missing proof of first factor successful sign-in.",
    "missing-or-invalid-nonce": "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
    "missing-phone-number": "To send verification codes, provide a phone number for the recipient.",
    "missing-verification-id": "The phone auth credential was created with an empty verification ID.",
    "app-deleted": "This instance of FirebaseApp has been deleted.",
    "account-exists-with-different-credential": "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
    "network-request-failed": "A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
    "no-auth-event": "An internal error has occurred.",
    "no-such-provider": "User was not linked to an account with the given provider.",
    "null-user": "A null user object was provided as the argument for an operation which requires a non-null user object.",
    "operation-not-allowed": "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
    "operation-not-supported-in-this-environment": 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
    "popup-blocked": "Unable to establish a connection with the popup. It may have been blocked by the browser.",
    "popup-closed-by-user": "The popup has been closed by the user before finalizing the operation.",
    "provider-already-linked": "User can only be linked to one identity for the given provider.",
    "quota-exceeded": "The project's quota for this operation has been exceeded.",
    "redirect-cancelled-by-user": "The redirect operation has been cancelled by the user before finalizing.",
    "redirect-operation-pending": "A redirect sign-in operation is already pending.",
    "rejected-credential": "The request contains malformed or mismatching credentials.",
    "second-factor-already-in-use": "The second factor is already enrolled on this account.",
    "maximum-second-factor-count-exceeded": "The maximum allowed number of second factors on a user has been exceeded.",
    "tenant-id-mismatch": "The provided tenant ID does not match the Auth instance's tenant ID",
    timeout: "The operation has timed out.",
    "user-token-expired": "The user's credential is no longer valid. The user must sign in again.",
    "too-many-requests": "We have blocked all requests from this device due to unusual activity. Try again later.",
    "unauthorized-continue-uri": "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
    "unsupported-first-factor": "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
    "unsupported-persistence-type": "The current environment does not support the specified persistence type.",
    "unsupported-tenant-operation": "This operation is not supported in a multi-tenant context.",
    "unverified-email": "The operation requires a verified email.",
    "user-cancelled": "The user did not grant your application the permissions it requested.",
    "user-not-found": "There is no user record corresponding to this identifier. The user may have been deleted.",
    "user-disabled": "The user account has been disabled by an administrator.",
    "user-mismatch": "The supplied credentials do not correspond to the previously signed in user.",
    "user-signed-out": "",
    "weak-password": "The password must be 6 characters long or more.",
    "web-storage-unsupported": "This browser is not supported or 3rd party cookies and data may be disabled."
  };
  var Ba2 = { kd: { Sa: "https://staging-identitytoolkit.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/", Ya: "https://staging-securetoken.sandbox.googleapis.com/v1/token", Va: "https://staging-identitytoolkit.sandbox.googleapis.com/v2/", id: "b" }, rd: { Sa: "https://www.googleapis.com/identitytoolkit/v3/relyingparty/", Ya: "https://securetoken.googleapis.com/v1/token", Va: "https://identitytoolkit.googleapis.com/v2/", id: "p" }, td: {
    Sa: "https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",
    Ya: "https://staging-securetoken.sandbox.googleapis.com/v1/token",
    Va: "https://staging-identitytoolkit.sandbox.googleapis.com/v2/",
    id: "s"
  }, ud: { Sa: "https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/", Ya: "https://test-securetoken.sandbox.googleapis.com/v1/token", Va: "https://test-identitytoolkit.sandbox.googleapis.com/v2/", id: "t" } };
  function Ca2(a3) {
    for (var b3 in Ba2)
      if (Ba2[b3].id === a3)
        return a3 = Ba2[b3], { firebaseEndpoint: a3.Sa, secureTokenEndpoint: a3.Ya, identityPlatformEndpoint: a3.Va };
    return null;
  }
  var Da2;
  Da2 = Ca2("__EID__") ? "__EID__" : void 0;
  function Ea2(a3) {
    if (!a3)
      return false;
    try {
      return !!a3.$goog_Thenable;
    } catch (b3) {
      return false;
    }
  }
  function u3(a3) {
    if (Error.captureStackTrace)
      Error.captureStackTrace(this, u3);
    else {
      var b3 = Error().stack;
      b3 && (this.stack = b3);
    }
    a3 && (this.message = String(a3));
  }
  r3(u3, Error);
  u3.prototype.name = "CustomError";
  function Fa2(a3, b3) {
    a3 = a3.split("%s");
    for (var c3 = "", d3 = a3.length - 1, e28 = 0; e28 < d3; e28++)
      c3 += a3[e28] + (e28 < b3.length ? b3[e28] : "%s");
    u3.call(this, c3 + a3[d3]);
  }
  r3(Fa2, u3);
  Fa2.prototype.name = "AssertionError";
  function Ga2(a3, b3) {
    throw new Fa2("Failure" + (a3 ? ": " + a3 : ""), Array.prototype.slice.call(arguments, 1));
  }
  function Ha2(a3, b3) {
    this.c = a3;
    this.f = b3;
    this.b = 0;
    this.a = null;
  }
  Ha2.prototype.get = function() {
    if (0 < this.b) {
      this.b--;
      var a3 = this.a;
      this.a = a3.next;
      a3.next = null;
    } else
      a3 = this.c();
    return a3;
  };
  function Ia2(a3, b3) {
    a3.f(b3);
    100 > a3.b && (a3.b++, b3.next = a3.a, a3.a = b3);
  }
  function Ja2() {
    this.b = this.a = null;
  }
  var La2 = new Ha2(function() {
    return new Ka2();
  }, function(a3) {
    a3.reset();
  });
  Ja2.prototype.add = function(a3, b3) {
    var c3 = La2.get();
    c3.set(a3, b3);
    this.b ? this.b.next = c3 : this.a = c3;
    this.b = c3;
  };
  function Ma2() {
    var a3 = Na2, b3 = null;
    a3.a && (b3 = a3.a, a3.a = a3.a.next, a3.a || (a3.b = null), b3.next = null);
    return b3;
  }
  function Ka2() {
    this.next = this.b = this.a = null;
  }
  Ka2.prototype.set = function(a3, b3) {
    this.a = a3;
    this.b = b3;
    this.next = null;
  };
  Ka2.prototype.reset = function() {
    this.next = this.b = this.a = null;
  };
  var Oa2 = Array.prototype.indexOf ? function(a3, b3) {
    return Array.prototype.indexOf.call(a3, b3, void 0);
  } : function(a3, b3) {
    if (typeof a3 === "string")
      return typeof b3 !== "string" || b3.length != 1 ? -1 : a3.indexOf(b3, 0);
    for (var c3 = 0; c3 < a3.length; c3++)
      if (c3 in a3 && a3[c3] === b3)
        return c3;
    return -1;
  }, w3 = Array.prototype.forEach ? function(a3, b3, c3) {
    Array.prototype.forEach.call(a3, b3, c3);
  } : function(a3, b3, c3) {
    for (var d3 = a3.length, e28 = typeof a3 === "string" ? a3.split("") : a3, f3 = 0; f3 < d3; f3++)
      f3 in e28 && b3.call(c3, e28[f3], f3, a3);
  };
  function Pa2(a3, b3) {
    for (var c3 = typeof a3 === "string" ? a3.split("") : a3, d3 = a3.length - 1; 0 <= d3; --d3)
      d3 in c3 && b3.call(void 0, c3[d3], d3, a3);
  }
  var Qa2 = Array.prototype.filter ? function(a3, b3) {
    return Array.prototype.filter.call(a3, b3, void 0);
  } : function(a3, b3) {
    for (var c3 = a3.length, d3 = [], e28 = 0, f3 = typeof a3 === "string" ? a3.split("") : a3, g3 = 0; g3 < c3; g3++)
      if (g3 in f3) {
        var h3 = f3[g3];
        b3.call(void 0, h3, g3, a3) && (d3[e28++] = h3);
      }
    return d3;
  }, Ra2 = Array.prototype.map ? function(a3, b3) {
    return Array.prototype.map.call(a3, b3, void 0);
  } : function(a3, b3) {
    for (var c3 = a3.length, d3 = Array(c3), e28 = typeof a3 === "string" ? a3.split("") : a3, f3 = 0; f3 < c3; f3++)
      f3 in e28 && (d3[f3] = b3.call(void 0, e28[f3], f3, a3));
    return d3;
  }, Sa2 = Array.prototype.some ? function(a3, b3) {
    return Array.prototype.some.call(a3, b3, void 0);
  } : function(a3, b3) {
    for (var c3 = a3.length, d3 = typeof a3 === "string" ? a3.split("") : a3, e28 = 0; e28 < c3; e28++)
      if (e28 in d3 && b3.call(void 0, d3[e28], e28, a3))
        return true;
    return false;
  };
  function Ta2(a3) {
    a: {
      var b3 = Ua2;
      for (var c3 = a3.length, d3 = typeof a3 === "string" ? a3.split("") : a3, e28 = 0; e28 < c3; e28++)
        if (e28 in d3 && b3.call(void 0, d3[e28], e28, a3)) {
          b3 = e28;
          break a;
        }
      b3 = -1;
    }
    return 0 > b3 ? null : typeof a3 === "string" ? a3.charAt(b3) : a3[b3];
  }
  function Va2(a3, b3) {
    return 0 <= Oa2(a3, b3);
  }
  function Wa2(a3, b3) {
    b3 = Oa2(a3, b3);
    var c3;
    (c3 = 0 <= b3) && Array.prototype.splice.call(a3, b3, 1);
    return c3;
  }
  function Xa2(a3, b3) {
    var c3 = 0;
    Pa2(a3, function(d3, e28) {
      b3.call(void 0, d3, e28, a3) && Array.prototype.splice.call(a3, e28, 1).length == 1 && c3++;
    });
  }
  function Ya2(a3) {
    return Array.prototype.concat.apply([], arguments);
  }
  function Za2(a3) {
    var b3 = a3.length;
    if (0 < b3) {
      for (var c3 = Array(b3), d3 = 0; d3 < b3; d3++)
        c3[d3] = a3[d3];
      return c3;
    }
    return [];
  }
  var $a2 = String.prototype.trim ? function(a3) {
    return a3.trim();
  } : function(a3) {
    return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a3)[1];
  }, ab2 = /&/g, bb2 = /</g, cb2 = />/g, db2 = /"/g, eb2 = /'/g, fb2 = /\x00/g, gb2 = /[\x00&<>"']/;
  function x3(a3, b3) {
    return a3.indexOf(b3) != -1;
  }
  function hb2(a3, b3) {
    return a3 < b3 ? -1 : a3 > b3 ? 1 : 0;
  }
  var ib2;
  a: {
    var jb2 = l3.navigator;
    if (jb2) {
      var kb2 = jb2.userAgent;
      if (kb2) {
        ib2 = kb2;
        break a;
      }
    }
    ib2 = "";
  }
  function y3(a3) {
    return x3(ib2, a3);
  }
  function lb2(a3, b3) {
    for (var c3 in a3)
      b3.call(void 0, a3[c3], c3, a3);
  }
  function mb2(a3) {
    for (var b3 in a3)
      return false;
    return true;
  }
  function nb2(a3) {
    var b3 = {}, c3;
    for (c3 in a3)
      b3[c3] = a3[c3];
    return b3;
  }
  var ob2 = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
  function z3(a3, b3) {
    for (var c3, d3, e28 = 1; e28 < arguments.length; e28++) {
      d3 = arguments[e28];
      for (c3 in d3)
        a3[c3] = d3[c3];
      for (var f3 = 0; f3 < ob2.length; f3++)
        c3 = ob2[f3], Object.prototype.hasOwnProperty.call(d3, c3) && (a3[c3] = d3[c3]);
    }
  }
  function pb2(a3, b3) {
    a: {
      try {
        var c3 = a3 && a3.ownerDocument, d3 = c3 && (c3.defaultView || c3.parentWindow);
        d3 = d3 || l3;
        if (d3.Element && d3.Location) {
          var e28 = d3;
          break a;
        }
      } catch (g3) {
      }
      e28 = null;
    }
    if (e28 && typeof e28[b3] != "undefined" && (!a3 || !(a3 instanceof e28[b3]) && (a3 instanceof e28.Location || a3 instanceof e28.Element))) {
      if (m3(a3))
        try {
          var f3 = a3.constructor.displayName || a3.constructor.name || Object.prototype.toString.call(a3);
        } catch (g3) {
          f3 = "<object could not be stringified>";
        }
      else
        f3 = a3 === void 0 ? "undefined" : a3 === null ? "null" : typeof a3;
      Ga2("Argument is not a %s (or a non-Element, non-Location mock); got: %s", b3, f3);
    }
  }
  function qb2(a3, b3) {
    this.a = a3 === rb2 && b3 || "";
    this.b = sb2;
  }
  qb2.prototype.sa = true;
  qb2.prototype.ra = function() {
    return this.a;
  };
  qb2.prototype.toString = function() {
    return "Const{" + this.a + "}";
  };
  function tb2(a3) {
    if (a3 instanceof qb2 && a3.constructor === qb2 && a3.b === sb2)
      return a3.a;
    Ga2("expected object of type Const, got '" + a3 + "'");
    return "type_error:Const";
  }
  var sb2 = {}, rb2 = {};
  var ub2;
  function vb2() {
    if (ub2 === void 0) {
      var a3 = null, b3 = l3.trustedTypes;
      if (b3 && b3.createPolicy) {
        try {
          a3 = b3.createPolicy("goog#html", { createHTML: wa2, createScript: wa2, createScriptURL: wa2 });
        } catch (c3) {
          l3.console && l3.console.error(c3.message);
        }
        ub2 = a3;
      } else
        ub2 = a3;
    }
    return ub2;
  }
  function wb2(a3, b3) {
    this.a = b3 === xb2 ? a3 : "";
  }
  wb2.prototype.sa = true;
  wb2.prototype.ra = function() {
    return this.a.toString();
  };
  wb2.prototype.toString = function() {
    return "TrustedResourceUrl{" + this.a + "}";
  };
  function yb2(a3) {
    if (a3 instanceof wb2 && a3.constructor === wb2)
      return a3.a;
    Ga2("expected object of type TrustedResourceUrl, got '" + a3 + "' of type " + ma2(a3));
    return "type_error:TrustedResourceUrl";
  }
  function zb2(a3, b3) {
    var c3 = tb2(a3);
    if (!Ab2.test(c3))
      throw Error("Invalid TrustedResourceUrl format: " + c3);
    a3 = c3.replace(Bb2, function(d3, e28) {
      if (!Object.prototype.hasOwnProperty.call(b3, e28))
        throw Error('Found marker, "' + e28 + '", in format string, "' + c3 + '", but no valid label mapping found in args: ' + JSON.stringify(b3));
      d3 = b3[e28];
      return d3 instanceof qb2 ? tb2(d3) : encodeURIComponent(String(d3));
    });
    return Cb2(a3);
  }
  var Bb2 = /%{(\w+)}/g, Ab2 = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i, xb2 = {};
  function Cb2(a3) {
    var b3 = vb2();
    a3 = b3 ? b3.createScriptURL(a3) : a3;
    return new wb2(a3, xb2);
  }
  function C3(a3, b3) {
    this.a = b3 === Db2 ? a3 : "";
  }
  C3.prototype.sa = true;
  C3.prototype.ra = function() {
    return this.a.toString();
  };
  C3.prototype.toString = function() {
    return "SafeUrl{" + this.a + "}";
  };
  function Eb2(a3) {
    if (a3 instanceof C3 && a3.constructor === C3)
      return a3.a;
    Ga2("expected object of type SafeUrl, got '" + a3 + "' of type " + ma2(a3));
    return "type_error:SafeUrl";
  }
  var Fb2 = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|font\/\w+|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|text\/csv|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i, Gb2 = /^data:(.*);base64,[a-z0-9+\/]+=*$/i, Hb2 = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
  function Ib2(a3) {
    if (a3 instanceof C3)
      return a3;
    a3 = typeof a3 == "object" && a3.sa ? a3.ra() : String(a3);
    if (Hb2.test(a3))
      a3 = new C3(a3, Db2);
    else {
      a3 = String(a3);
      a3 = a3.replace(/(%0A|%0D)/g, "");
      var b3 = a3.match(Gb2);
      a3 = b3 && Fb2.test(b3[1]) ? new C3(a3, Db2) : null;
    }
    return a3;
  }
  function Jb2(a3) {
    if (a3 instanceof C3)
      return a3;
    a3 = typeof a3 == "object" && a3.sa ? a3.ra() : String(a3);
    Hb2.test(a3) || (a3 = "about:invalid#zClosurez");
    return new C3(a3, Db2);
  }
  var Db2 = {}, Kb2 = new C3("about:invalid#zClosurez", Db2);
  function Lb2(a3, b3, c3) {
    this.a = c3 === Mb2 ? a3 : "";
  }
  Lb2.prototype.sa = true;
  Lb2.prototype.ra = function() {
    return this.a.toString();
  };
  Lb2.prototype.toString = function() {
    return "SafeHtml{" + this.a + "}";
  };
  function Nb2(a3) {
    if (a3 instanceof Lb2 && a3.constructor === Lb2)
      return a3.a;
    Ga2("expected object of type SafeHtml, got '" + a3 + "' of type " + ma2(a3));
    return "type_error:SafeHtml";
  }
  var Mb2 = {};
  function Ob2(a3, b3) {
    pb2(a3, "HTMLScriptElement");
    a3.src = yb2(b3);
    (b3 = a3.ownerDocument && a3.ownerDocument.defaultView) && b3 != l3 ? b3 = ka2(b3.document) : (ja2 === null && (ja2 = ka2(l3.document)), b3 = ja2);
    b3 && a3.setAttribute("nonce", b3);
  }
  function Pb2(a3, b3, c3, d3) {
    a3 = a3 instanceof C3 ? a3 : Jb2(a3);
    b3 = b3 || l3;
    c3 = c3 instanceof qb2 ? tb2(c3) : c3 || "";
    return b3.open(Eb2(a3), c3, d3, void 0);
  }
  function Qb2(a3, b3) {
    for (var c3 = a3.split("%s"), d3 = "", e28 = Array.prototype.slice.call(arguments, 1); e28.length && 1 < c3.length; )
      d3 += c3.shift() + e28.shift();
    return d3 + c3.join("%s");
  }
  function Rb2(a3) {
    gb2.test(a3) && (a3.indexOf("&") != -1 && (a3 = a3.replace(ab2, "&amp;")), a3.indexOf("<") != -1 && (a3 = a3.replace(bb2, "&lt;")), a3.indexOf(">") != -1 && (a3 = a3.replace(cb2, "&gt;")), a3.indexOf('"') != -1 && (a3 = a3.replace(db2, "&quot;")), a3.indexOf("'") != -1 && (a3 = a3.replace(eb2, "&#39;")), a3.indexOf("\0") != -1 && (a3 = a3.replace(fb2, "&#0;")));
    return a3;
  }
  function Sb2(a3) {
    Sb2[" "](a3);
    return a3;
  }
  Sb2[" "] = la2;
  function Tb2(a3, b3) {
    var c3 = Ub2;
    return Object.prototype.hasOwnProperty.call(c3, a3) ? c3[a3] : c3[a3] = b3(a3);
  }
  var Vb2 = y3("Opera"), Wb2 = y3("Trident") || y3("MSIE"), Xb2 = y3("Edge"), Yb2 = Xb2 || Wb2, Zb2 = y3("Gecko") && !(x3(ib2.toLowerCase(), "webkit") && !y3("Edge")) && !(y3("Trident") || y3("MSIE")) && !y3("Edge"), $b2 = x3(ib2.toLowerCase(), "webkit") && !y3("Edge");
  function ac2() {
    var a3 = l3.document;
    return a3 ? a3.documentMode : void 0;
  }
  var bc2;
  a: {
    var cc2 = "", dc2 = function() {
      var a3 = ib2;
      if (Zb2)
        return /rv:([^\);]+)(\)|;)/.exec(a3);
      if (Xb2)
        return /Edge\/([\d\.]+)/.exec(a3);
      if (Wb2)
        return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a3);
      if ($b2)
        return /WebKit\/(\S+)/.exec(a3);
      if (Vb2)
        return /(?:Version)[ \/]?(\S+)/.exec(a3);
    }();
    dc2 && (cc2 = dc2 ? dc2[1] : "");
    if (Wb2) {
      var ec2 = ac2();
      if (ec2 != null && ec2 > parseFloat(cc2)) {
        bc2 = String(ec2);
        break a;
      }
    }
    bc2 = cc2;
  }
  var Ub2 = {};
  function fc2(a3) {
    return Tb2(a3, function() {
      for (var b3 = 0, c3 = $a2(String(bc2)).split("."), d3 = $a2(String(a3)).split("."), e28 = Math.max(c3.length, d3.length), f3 = 0; b3 == 0 && f3 < e28; f3++) {
        var g3 = c3[f3] || "", h3 = d3[f3] || "";
        do {
          g3 = /(\d*)(\D*)(.*)/.exec(g3) || ["", "", "", ""];
          h3 = /(\d*)(\D*)(.*)/.exec(h3) || ["", "", "", ""];
          if (g3[0].length == 0 && h3[0].length == 0)
            break;
          b3 = hb2(g3[1].length == 0 ? 0 : parseInt(g3[1], 10), h3[1].length == 0 ? 0 : parseInt(h3[1], 10)) || hb2(g3[2].length == 0, h3[2].length == 0) || hb2(g3[2], h3[2]);
          g3 = g3[3];
          h3 = h3[3];
        } while (b3 == 0);
      }
      return 0 <= b3;
    });
  }
  var gc2;
  if (l3.document && Wb2) {
    var hc2 = ac2();
    gc2 = hc2 ? hc2 : parseInt(bc2, 10) || void 0;
  } else
    gc2 = void 0;
  var ic2 = gc2;
  try {
    new self.OffscreenCanvas(0, 0).getContext("2d");
  } catch (a3) {
  }
  var jc2 = !Wb2 || 9 <= Number(ic2);
  function kc2(a3) {
    var b3 = document;
    return typeof a3 === "string" ? b3.getElementById(a3) : a3;
  }
  function lc2(a3, b3) {
    lb2(b3, function(c3, d3) {
      c3 && typeof c3 == "object" && c3.sa && (c3 = c3.ra());
      d3 == "style" ? a3.style.cssText = c3 : d3 == "class" ? a3.className = c3 : d3 == "for" ? a3.htmlFor = c3 : mc2.hasOwnProperty(d3) ? a3.setAttribute(mc2[d3], c3) : d3.lastIndexOf("aria-", 0) == 0 || d3.lastIndexOf("data-", 0) == 0 ? a3.setAttribute(d3, c3) : a3[d3] = c3;
    });
  }
  var mc2 = { cellpadding: "cellPadding", cellspacing: "cellSpacing", colspan: "colSpan", frameborder: "frameBorder", height: "height", maxlength: "maxLength", nonce: "nonce", role: "role", rowspan: "rowSpan", type: "type", usemap: "useMap", valign: "vAlign", width: "width" };
  function nc2(a3, b3, c3) {
    var d3 = arguments, e28 = document, f3 = String(d3[0]), g3 = d3[1];
    if (!jc2 && g3 && (g3.name || g3.type)) {
      f3 = ["<", f3];
      g3.name && f3.push(' name="', Rb2(g3.name), '"');
      if (g3.type) {
        f3.push(' type="', Rb2(g3.type), '"');
        var h3 = {};
        z3(h3, g3);
        delete h3.type;
        g3 = h3;
      }
      f3.push(">");
      f3 = f3.join("");
    }
    f3 = oc2(e28, f3);
    g3 && (typeof g3 === "string" ? f3.className = g3 : Array.isArray(g3) ? f3.className = g3.join(" ") : lc2(f3, g3));
    2 < d3.length && pc2(e28, f3, d3);
    return f3;
  }
  function pc2(a3, b3, c3) {
    function d3(h3) {
      h3 && b3.appendChild(typeof h3 === "string" ? a3.createTextNode(h3) : h3);
    }
    for (var e28 = 2; e28 < c3.length; e28++) {
      var f3 = c3[e28];
      if (!na2(f3) || m3(f3) && 0 < f3.nodeType)
        d3(f3);
      else {
        a: {
          if (f3 && typeof f3.length == "number") {
            if (m3(f3)) {
              var g3 = typeof f3.item == "function" || typeof f3.item == "string";
              break a;
            }
            if (oa2(f3)) {
              g3 = typeof f3.item == "function";
              break a;
            }
          }
          g3 = false;
        }
        w3(g3 ? Za2(f3) : f3, d3);
      }
    }
  }
  function oc2(a3, b3) {
    b3 = String(b3);
    a3.contentType === "application/xhtml+xml" && (b3 = b3.toLowerCase());
    return a3.createElement(b3);
  }
  function qc2(a3) {
    l3.setTimeout(function() {
      throw a3;
    }, 0);
  }
  var rc2;
  function sc2() {
    var a3 = l3.MessageChannel;
    typeof a3 === "undefined" && typeof window !== "undefined" && window.postMessage && window.addEventListener && !y3("Presto") && (a3 = function() {
      var e28 = oc2(document, "IFRAME");
      e28.style.display = "none";
      document.documentElement.appendChild(e28);
      var f3 = e28.contentWindow;
      e28 = f3.document;
      e28.open();
      e28.close();
      var g3 = "callImmediate" + Math.random(), h3 = f3.location.protocol == "file:" ? "*" : f3.location.protocol + "//" + f3.location.host;
      e28 = q3(function(n3) {
        if ((h3 == "*" || n3.origin == h3) && n3.data == g3)
          this.port1.onmessage();
      }, this);
      f3.addEventListener("message", e28, false);
      this.port1 = {};
      this.port2 = { postMessage: function() {
        f3.postMessage(g3, h3);
      } };
    });
    if (typeof a3 !== "undefined" && !y3("Trident") && !y3("MSIE")) {
      var b3 = new a3(), c3 = {}, d3 = c3;
      b3.port1.onmessage = function() {
        if (c3.next !== void 0) {
          c3 = c3.next;
          var e28 = c3.Fb;
          c3.Fb = null;
          e28();
        }
      };
      return function(e28) {
        d3.next = { Fb: e28 };
        d3 = d3.next;
        b3.port2.postMessage(0);
      };
    }
    return function(e28) {
      l3.setTimeout(e28, 0);
    };
  }
  function tc2(a3, b3) {
    uc2 || vc2();
    wc2 || (uc2(), wc2 = true);
    Na2.add(a3, b3);
  }
  var uc2;
  function vc2() {
    if (l3.Promise && l3.Promise.resolve) {
      var a3 = l3.Promise.resolve(void 0);
      uc2 = function() {
        a3.then(xc2);
      };
    } else
      uc2 = function() {
        var b3 = xc2;
        !oa2(l3.setImmediate) || l3.Window && l3.Window.prototype && !y3("Edge") && l3.Window.prototype.setImmediate == l3.setImmediate ? (rc2 || (rc2 = sc2()), rc2(b3)) : l3.setImmediate(b3);
      };
  }
  var wc2 = false, Na2 = new Ja2();
  function xc2() {
    for (var a3; a3 = Ma2(); ) {
      try {
        a3.a.call(a3.b);
      } catch (b3) {
        qc2(b3);
      }
      Ia2(La2, a3);
    }
    wc2 = false;
  }
  function D3(a3, b3) {
    this.a = yc2;
    this.h = void 0;
    this.f = this.b = this.c = null;
    this.g = this.i = false;
    if (a3 != la2)
      try {
        var c3 = this;
        a3.call(b3, function(d3) {
          zc2(c3, Ac2, d3);
        }, function(d3) {
          if (!(d3 instanceof Bc2))
            try {
              if (d3 instanceof Error)
                throw d3;
              throw Error("Promise rejected.");
            } catch (e28) {
            }
          zc2(c3, Cc2, d3);
        });
      } catch (d3) {
        zc2(this, Cc2, d3);
      }
  }
  var yc2 = 0, Ac2 = 2, Cc2 = 3;
  function Dc2() {
    this.next = this.f = this.b = this.g = this.a = null;
    this.c = false;
  }
  Dc2.prototype.reset = function() {
    this.f = this.b = this.g = this.a = null;
    this.c = false;
  };
  var Ec2 = new Ha2(function() {
    return new Dc2();
  }, function(a3) {
    a3.reset();
  });
  function Fc2(a3, b3, c3) {
    var d3 = Ec2.get();
    d3.g = a3;
    d3.b = b3;
    d3.f = c3;
    return d3;
  }
  function E3(a3) {
    if (a3 instanceof D3)
      return a3;
    var b3 = new D3(la2);
    zc2(b3, Ac2, a3);
    return b3;
  }
  function F3(a3) {
    return new D3(function(b3, c3) {
      c3(a3);
    });
  }
  function Gc2(a3, b3, c3) {
    Hc2(a3, b3, c3, null) || tc2(ua2(b3, a3));
  }
  function Ic2(a3) {
    return new D3(function(b3, c3) {
      var d3 = a3.length, e28 = [];
      if (d3)
        for (var f3 = function(p3, v3) {
          d3--;
          e28[p3] = v3;
          d3 == 0 && b3(e28);
        }, g3 = function(p3) {
          c3(p3);
        }, h3 = 0, n3; h3 < a3.length; h3++)
          n3 = a3[h3], Gc2(n3, ua2(f3, h3), g3);
      else
        b3(e28);
    });
  }
  function Jc2(a3) {
    return new D3(function(b3) {
      var c3 = a3.length, d3 = [];
      if (c3)
        for (var e28 = function(h3, n3, p3) {
          c3--;
          d3[h3] = n3 ? { Ob: true, value: p3 } : { Ob: false, reason: p3 };
          c3 == 0 && b3(d3);
        }, f3 = 0, g3; f3 < a3.length; f3++)
          g3 = a3[f3], Gc2(g3, ua2(e28, f3, true), ua2(e28, f3, false));
      else
        b3(d3);
    });
  }
  D3.prototype.then = function(a3, b3, c3) {
    return Kc2(this, oa2(a3) ? a3 : null, oa2(b3) ? b3 : null, c3);
  };
  D3.prototype.$goog_Thenable = true;
  k3 = D3.prototype;
  k3.na = function(a3, b3) {
    a3 = Fc2(a3, a3, b3);
    a3.c = true;
    Lc2(this, a3);
    return this;
  };
  k3.o = function(a3, b3) {
    return Kc2(this, null, a3, b3);
  };
  k3.cancel = function(a3) {
    if (this.a == yc2) {
      var b3 = new Bc2(a3);
      tc2(function() {
        Mc2(this, b3);
      }, this);
    }
  };
  function Mc2(a3, b3) {
    if (a3.a == yc2)
      if (a3.c) {
        var c3 = a3.c;
        if (c3.b) {
          for (var d3 = 0, e28 = null, f3 = null, g3 = c3.b; g3 && (g3.c || (d3++, g3.a == a3 && (e28 = g3), !(e28 && 1 < d3))); g3 = g3.next)
            e28 || (f3 = g3);
          e28 && (c3.a == yc2 && d3 == 1 ? Mc2(c3, b3) : (f3 ? (d3 = f3, d3.next == c3.f && (c3.f = d3), d3.next = d3.next.next) : Nc2(c3), Oc2(c3, e28, Cc2, b3)));
        }
        a3.c = null;
      } else
        zc2(a3, Cc2, b3);
  }
  function Lc2(a3, b3) {
    a3.b || a3.a != Ac2 && a3.a != Cc2 || Pc2(a3);
    a3.f ? a3.f.next = b3 : a3.b = b3;
    a3.f = b3;
  }
  function Kc2(a3, b3, c3, d3) {
    var e28 = Fc2(null, null, null);
    e28.a = new D3(function(f3, g3) {
      e28.g = b3 ? function(h3) {
        try {
          var n3 = b3.call(d3, h3);
          f3(n3);
        } catch (p3) {
          g3(p3);
        }
      } : f3;
      e28.b = c3 ? function(h3) {
        try {
          var n3 = c3.call(d3, h3);
          n3 === void 0 && h3 instanceof Bc2 ? g3(h3) : f3(n3);
        } catch (p3) {
          g3(p3);
        }
      } : g3;
    });
    e28.a.c = a3;
    Lc2(a3, e28);
    return e28.a;
  }
  k3.Zc = function(a3) {
    this.a = yc2;
    zc2(this, Ac2, a3);
  };
  k3.$c = function(a3) {
    this.a = yc2;
    zc2(this, Cc2, a3);
  };
  function zc2(a3, b3, c3) {
    a3.a == yc2 && (a3 === c3 && (b3 = Cc2, c3 = new TypeError("Promise cannot resolve to itself")), a3.a = 1, Hc2(c3, a3.Zc, a3.$c, a3) || (a3.h = c3, a3.a = b3, a3.c = null, Pc2(a3), b3 != Cc2 || c3 instanceof Bc2 || Qc2(a3, c3)));
  }
  function Hc2(a3, b3, c3, d3) {
    if (a3 instanceof D3)
      return Lc2(a3, Fc2(b3 || la2, c3 || null, d3)), true;
    if (Ea2(a3))
      return a3.then(b3, c3, d3), true;
    if (m3(a3))
      try {
        var e28 = a3.then;
        if (oa2(e28))
          return Rc2(a3, e28, b3, c3, d3), true;
      } catch (f3) {
        return c3.call(d3, f3), true;
      }
    return false;
  }
  function Rc2(a3, b3, c3, d3, e28) {
    function f3(n3) {
      h3 || (h3 = true, d3.call(e28, n3));
    }
    function g3(n3) {
      h3 || (h3 = true, c3.call(e28, n3));
    }
    var h3 = false;
    try {
      b3.call(a3, g3, f3);
    } catch (n3) {
      f3(n3);
    }
  }
  function Pc2(a3) {
    a3.i || (a3.i = true, tc2(a3.fc, a3));
  }
  function Nc2(a3) {
    var b3 = null;
    a3.b && (b3 = a3.b, a3.b = b3.next, b3.next = null);
    a3.b || (a3.f = null);
    return b3;
  }
  k3.fc = function() {
    for (var a3; a3 = Nc2(this); )
      Oc2(this, a3, this.a, this.h);
    this.i = false;
  };
  function Oc2(a3, b3, c3, d3) {
    if (c3 == Cc2 && b3.b && !b3.c)
      for (; a3 && a3.g; a3 = a3.c)
        a3.g = false;
    if (b3.a)
      b3.a.c = null, Sc2(b3, c3, d3);
    else
      try {
        b3.c ? b3.g.call(b3.f) : Sc2(b3, c3, d3);
      } catch (e28) {
        Tc2.call(null, e28);
      }
    Ia2(Ec2, b3);
  }
  function Sc2(a3, b3, c3) {
    b3 == Ac2 ? a3.g.call(a3.f, c3) : a3.b && a3.b.call(a3.f, c3);
  }
  function Qc2(a3, b3) {
    a3.g = true;
    tc2(function() {
      a3.g && Tc2.call(null, b3);
    });
  }
  var Tc2 = qc2;
  function Bc2(a3) {
    u3.call(this, a3);
  }
  r3(Bc2, u3);
  Bc2.prototype.name = "cancel";
  function Uc2() {
    this.xa = this.xa;
    this.oa = this.oa;
  }
  var Vc2 = 0;
  Uc2.prototype.xa = false;
  function Xc2(a3) {
    if (!a3.xa && (a3.xa = true, a3.Da(), Vc2 != 0)) {
      pa2(a3);
    }
  }
  Uc2.prototype.Da = function() {
    if (this.oa)
      for (; this.oa.length; )
        this.oa.shift()();
  };
  var Yc2 = Object.freeze || function(a3) {
    return a3;
  };
  var Zc2 = !Wb2 || 9 <= Number(ic2), $c2 = Wb2 && !fc2("9"), ad2 = function() {
    if (!l3.addEventListener || !Object.defineProperty)
      return false;
    var a3 = false, b3 = Object.defineProperty({}, "passive", { get: function() {
      a3 = true;
    } });
    try {
      l3.addEventListener("test", la2, b3), l3.removeEventListener("test", la2, b3);
    } catch (c3) {
    }
    return a3;
  }();
  function G3(a3, b3) {
    this.type = a3;
    this.b = this.target = b3;
    this.defaultPrevented = false;
  }
  G3.prototype.preventDefault = function() {
    this.defaultPrevented = true;
  };
  function bd2(a3, b3) {
    G3.call(this, a3 ? a3.type : "");
    this.relatedTarget = this.b = this.target = null;
    this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
    this.key = "";
    this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = false;
    this.pointerId = 0;
    this.pointerType = "";
    this.a = null;
    if (a3) {
      var c3 = this.type = a3.type, d3 = a3.changedTouches && a3.changedTouches.length ? a3.changedTouches[0] : null;
      this.target = a3.target || a3.srcElement;
      this.b = b3;
      if (b3 = a3.relatedTarget) {
        if (Zb2) {
          a: {
            try {
              Sb2(b3.nodeName);
              var e28 = true;
              break a;
            } catch (f3) {
            }
            e28 = false;
          }
          e28 || (b3 = null);
        }
      } else
        c3 == "mouseover" ? b3 = a3.fromElement : c3 == "mouseout" && (b3 = a3.toElement);
      this.relatedTarget = b3;
      d3 ? (this.clientX = d3.clientX !== void 0 ? d3.clientX : d3.pageX, this.clientY = d3.clientY !== void 0 ? d3.clientY : d3.pageY, this.screenX = d3.screenX || 0, this.screenY = d3.screenY || 0) : (this.clientX = a3.clientX !== void 0 ? a3.clientX : a3.pageX, this.clientY = a3.clientY !== void 0 ? a3.clientY : a3.pageY, this.screenX = a3.screenX || 0, this.screenY = a3.screenY || 0);
      this.button = a3.button;
      this.key = a3.key || "";
      this.ctrlKey = a3.ctrlKey;
      this.altKey = a3.altKey;
      this.shiftKey = a3.shiftKey;
      this.metaKey = a3.metaKey;
      this.pointerId = a3.pointerId || 0;
      this.pointerType = typeof a3.pointerType === "string" ? a3.pointerType : cd2[a3.pointerType] || "";
      this.a = a3;
      a3.defaultPrevented && this.preventDefault();
    }
  }
  r3(bd2, G3);
  var cd2 = Yc2({ 2: "touch", 3: "pen", 4: "mouse" });
  bd2.prototype.preventDefault = function() {
    bd2.$a.preventDefault.call(this);
    var a3 = this.a;
    if (a3.preventDefault)
      a3.preventDefault();
    else if (a3.returnValue = false, $c2)
      try {
        if (a3.ctrlKey || 112 <= a3.keyCode && 123 >= a3.keyCode)
          a3.keyCode = -1;
      } catch (b3) {
      }
  };
  bd2.prototype.g = function() {
    return this.a;
  };
  var dd2 = "closure_listenable_" + (1e6 * Math.random() | 0), ed2 = 0;
  function fd2(a3, b3, c3, d3, e28) {
    this.listener = a3;
    this.proxy = null;
    this.src = b3;
    this.type = c3;
    this.capture = !!d3;
    this.Ua = e28;
    this.key = ++ed2;
    this.va = this.Oa = false;
  }
  function gd2(a3) {
    a3.va = true;
    a3.listener = null;
    a3.proxy = null;
    a3.src = null;
    a3.Ua = null;
  }
  function hd2(a3) {
    this.src = a3;
    this.a = {};
    this.b = 0;
  }
  hd2.prototype.add = function(a3, b3, c3, d3, e28) {
    var f3 = a3.toString();
    a3 = this.a[f3];
    a3 || (a3 = this.a[f3] = [], this.b++);
    var g3 = id2(a3, b3, d3, e28);
    -1 < g3 ? (b3 = a3[g3], c3 || (b3.Oa = false)) : (b3 = new fd2(b3, this.src, f3, !!d3, e28), b3.Oa = c3, a3.push(b3));
    return b3;
  };
  function jd2(a3, b3) {
    var c3 = b3.type;
    c3 in a3.a && Wa2(a3.a[c3], b3) && (gd2(b3), a3.a[c3].length == 0 && (delete a3.a[c3], a3.b--));
  }
  function id2(a3, b3, c3, d3) {
    for (var e28 = 0; e28 < a3.length; ++e28) {
      var f3 = a3[e28];
      if (!f3.va && f3.listener == b3 && f3.capture == !!c3 && f3.Ua == d3)
        return e28;
    }
    return -1;
  }
  var kd2 = "closure_lm_" + (1e6 * Math.random() | 0), ld2 = {};
  function nd2(a3, b3, c3, d3, e28) {
    if (d3 && d3.once)
      od2(a3, b3, c3, d3, e28);
    else if (Array.isArray(b3))
      for (var f3 = 0; f3 < b3.length; f3++)
        nd2(a3, b3[f3], c3, d3, e28);
    else
      c3 = pd2(c3), a3 && a3[dd2] ? qd2(a3, b3, c3, m3(d3) ? !!d3.capture : !!d3, e28) : rd2(a3, b3, c3, false, d3, e28);
  }
  function rd2(a3, b3, c3, d3, e28, f3) {
    if (!b3)
      throw Error("Invalid event type");
    var g3 = m3(e28) ? !!e28.capture : !!e28, h3 = sd2(a3);
    h3 || (a3[kd2] = h3 = new hd2(a3));
    c3 = h3.add(b3, c3, d3, g3, f3);
    if (!c3.proxy) {
      d3 = td2();
      c3.proxy = d3;
      d3.src = a3;
      d3.listener = c3;
      if (a3.addEventListener)
        ad2 || (e28 = g3), e28 === void 0 && (e28 = false), a3.addEventListener(b3.toString(), d3, e28);
      else if (a3.attachEvent)
        a3.attachEvent(ud2(b3.toString()), d3);
      else if (a3.addListener && a3.removeListener)
        a3.addListener(d3);
      else
        throw Error("addEventListener and attachEvent are unavailable.");
    }
  }
  function td2() {
    var a3 = vd2, b3 = Zc2 ? function(c3) {
      return a3.call(b3.src, b3.listener, c3);
    } : function(c3) {
      c3 = a3.call(b3.src, b3.listener, c3);
      if (!c3)
        return c3;
    };
    return b3;
  }
  function od2(a3, b3, c3, d3, e28) {
    if (Array.isArray(b3))
      for (var f3 = 0; f3 < b3.length; f3++)
        od2(a3, b3[f3], c3, d3, e28);
    else
      c3 = pd2(c3), a3 && a3[dd2] ? wd2(a3, b3, c3, m3(d3) ? !!d3.capture : !!d3, e28) : rd2(a3, b3, c3, true, d3, e28);
  }
  function H3(a3, b3, c3, d3, e28) {
    if (Array.isArray(b3))
      for (var f3 = 0; f3 < b3.length; f3++)
        H3(a3, b3[f3], c3, d3, e28);
    else
      (d3 = m3(d3) ? !!d3.capture : !!d3, c3 = pd2(c3), a3 && a3[dd2]) ? (a3 = a3.v, b3 = String(b3).toString(), b3 in a3.a && (f3 = a3.a[b3], c3 = id2(f3, c3, d3, e28), -1 < c3 && (gd2(f3[c3]), Array.prototype.splice.call(f3, c3, 1), f3.length == 0 && (delete a3.a[b3], a3.b--)))) : a3 && (a3 = sd2(a3)) && (b3 = a3.a[b3.toString()], a3 = -1, b3 && (a3 = id2(b3, c3, d3, e28)), (c3 = -1 < a3 ? b3[a3] : null) && xd2(c3));
  }
  function xd2(a3) {
    if (typeof a3 !== "number" && a3 && !a3.va) {
      var b3 = a3.src;
      if (b3 && b3[dd2])
        jd2(b3.v, a3);
      else {
        var c3 = a3.type, d3 = a3.proxy;
        b3.removeEventListener ? b3.removeEventListener(c3, d3, a3.capture) : b3.detachEvent ? b3.detachEvent(ud2(c3), d3) : b3.addListener && b3.removeListener && b3.removeListener(d3);
        (c3 = sd2(b3)) ? (jd2(c3, a3), c3.b == 0 && (c3.src = null, b3[kd2] = null)) : gd2(a3);
      }
    }
  }
  function ud2(a3) {
    return a3 in ld2 ? ld2[a3] : ld2[a3] = "on" + a3;
  }
  function yd2(a3, b3, c3, d3) {
    var e28 = true;
    if (a3 = sd2(a3)) {
      if (b3 = a3.a[b3.toString()])
        for (b3 = b3.concat(), a3 = 0; a3 < b3.length; a3++) {
          var f3 = b3[a3];
          f3 && f3.capture == c3 && !f3.va && (f3 = zd2(f3, d3), e28 = e28 && f3 !== false);
        }
    }
    return e28;
  }
  function zd2(a3, b3) {
    var c3 = a3.listener, d3 = a3.Ua || a3.src;
    a3.Oa && xd2(a3);
    return c3.call(d3, b3);
  }
  function vd2(a3, b3) {
    if (a3.va)
      return true;
    if (!Zc2) {
      if (!b3)
        a: {
          b3 = ["window", "event"];
          for (var c3 = l3, d3 = 0; d3 < b3.length; d3++)
            if (c3 = c3[b3[d3]], c3 == null) {
              b3 = null;
              break a;
            }
          b3 = c3;
        }
      d3 = b3;
      b3 = new bd2(d3, this);
      c3 = true;
      if (!(0 > d3.keyCode || d3.returnValue != void 0)) {
        a: {
          var e28 = false;
          if (d3.keyCode == 0)
            try {
              d3.keyCode = -1;
              break a;
            } catch (g3) {
              e28 = true;
            }
          if (e28 || d3.returnValue == void 0)
            d3.returnValue = true;
        }
        d3 = [];
        for (e28 = b3.b; e28; e28 = e28.parentNode)
          d3.push(e28);
        a3 = a3.type;
        for (e28 = d3.length - 1; 0 <= e28; e28--) {
          b3.b = d3[e28];
          var f3 = yd2(d3[e28], a3, true, b3);
          c3 = c3 && f3;
        }
        for (e28 = 0; e28 < d3.length; e28++)
          b3.b = d3[e28], f3 = yd2(d3[e28], a3, false, b3), c3 = c3 && f3;
      }
      return c3;
    }
    return zd2(a3, new bd2(b3, this));
  }
  function sd2(a3) {
    a3 = a3[kd2];
    return a3 instanceof hd2 ? a3 : null;
  }
  var Bd2 = "__closure_events_fn_" + (1e9 * Math.random() >>> 0);
  function pd2(a3) {
    if (oa2(a3))
      return a3;
    a3[Bd2] || (a3[Bd2] = function(b3) {
      return a3.handleEvent(b3);
    });
    return a3[Bd2];
  }
  function I3() {
    Uc2.call(this);
    this.v = new hd2(this);
    this.$b = this;
    this.fb = null;
  }
  r3(I3, Uc2);
  I3.prototype[dd2] = true;
  I3.prototype.addEventListener = function(a3, b3, c3, d3) {
    nd2(this, a3, b3, c3, d3);
  };
  I3.prototype.removeEventListener = function(a3, b3, c3, d3) {
    H3(this, a3, b3, c3, d3);
  };
  I3.prototype.dispatchEvent = function(a3) {
    var b3, c3 = this.fb;
    if (c3)
      for (b3 = []; c3; c3 = c3.fb)
        b3.push(c3);
    c3 = this.$b;
    var d3 = a3.type || a3;
    if (typeof a3 === "string")
      a3 = new G3(a3, c3);
    else if (a3 instanceof G3)
      a3.target = a3.target || c3;
    else {
      var e28 = a3;
      a3 = new G3(d3, c3);
      z3(a3, e28);
    }
    e28 = true;
    if (b3)
      for (var f3 = b3.length - 1; 0 <= f3; f3--) {
        var g3 = a3.b = b3[f3];
        e28 = Cd2(g3, d3, true, a3) && e28;
      }
    g3 = a3.b = c3;
    e28 = Cd2(g3, d3, true, a3) && e28;
    e28 = Cd2(g3, d3, false, a3) && e28;
    if (b3)
      for (f3 = 0; f3 < b3.length; f3++)
        g3 = a3.b = b3[f3], e28 = Cd2(g3, d3, false, a3) && e28;
    return e28;
  };
  I3.prototype.Da = function() {
    I3.$a.Da.call(this);
    if (this.v) {
      var a3 = this.v, c3;
      for (c3 in a3.a) {
        for (var d3 = a3.a[c3], e28 = 0; e28 < d3.length; e28++)
          gd2(d3[e28]);
        delete a3.a[c3];
        a3.b--;
      }
    }
    this.fb = null;
  };
  function qd2(a3, b3, c3, d3, e28) {
    a3.v.add(String(b3), c3, false, d3, e28);
  }
  function wd2(a3, b3, c3, d3, e28) {
    a3.v.add(String(b3), c3, true, d3, e28);
  }
  function Cd2(a3, b3, c3, d3) {
    b3 = a3.v.a[String(b3)];
    if (!b3)
      return true;
    b3 = b3.concat();
    for (var e28 = true, f3 = 0; f3 < b3.length; ++f3) {
      var g3 = b3[f3];
      if (g3 && !g3.va && g3.capture == c3) {
        var h3 = g3.listener, n3 = g3.Ua || g3.src;
        g3.Oa && jd2(a3.v, g3);
        e28 = h3.call(n3, d3) !== false && e28;
      }
    }
    return e28 && !d3.defaultPrevented;
  }
  function Dd2(a3, b3, c3) {
    if (oa2(a3))
      c3 && (a3 = q3(a3, c3));
    else if (a3 && typeof a3.handleEvent == "function")
      a3 = q3(a3.handleEvent, a3);
    else
      throw Error("Invalid listener argument");
    return 2147483647 < Number(b3) ? -1 : l3.setTimeout(a3, b3 || 0);
  }
  function Ed2(a3) {
    var b3 = null;
    return new D3(function(c3, d3) {
      b3 = Dd2(function() {
        c3(void 0);
      }, a3);
      b3 == -1 && d3(Error("Failed to schedule timer."));
    }).o(function(c3) {
      l3.clearTimeout(b3);
      throw c3;
    });
  }
  function Fd2(a3) {
    if (a3.V && typeof a3.V == "function")
      return a3.V();
    if (typeof a3 === "string")
      return a3.split("");
    if (na2(a3)) {
      for (var b3 = [], c3 = a3.length, d3 = 0; d3 < c3; d3++)
        b3.push(a3[d3]);
      return b3;
    }
    b3 = [];
    c3 = 0;
    for (d3 in a3)
      b3[c3++] = a3[d3];
    return b3;
  }
  function Gd2(a3) {
    if (a3.Y && typeof a3.Y == "function")
      return a3.Y();
    if (!a3.V || typeof a3.V != "function") {
      if (na2(a3) || typeof a3 === "string") {
        var b3 = [];
        a3 = a3.length;
        for (var c3 = 0; c3 < a3; c3++)
          b3.push(c3);
        return b3;
      }
      b3 = [];
      c3 = 0;
      for (var d3 in a3)
        b3[c3++] = d3;
      return b3;
    }
  }
  function Hd2(a3, b3) {
    if (a3.forEach && typeof a3.forEach == "function")
      a3.forEach(b3, void 0);
    else if (na2(a3) || typeof a3 === "string")
      w3(a3, b3, void 0);
    else
      for (var c3 = Gd2(a3), d3 = Fd2(a3), e28 = d3.length, f3 = 0; f3 < e28; f3++)
        b3.call(void 0, d3[f3], c3 && c3[f3], a3);
  }
  function Id2(a3, b3) {
    this.b = {};
    this.a = [];
    this.c = 0;
    var c3 = arguments.length;
    if (1 < c3) {
      if (c3 % 2)
        throw Error("Uneven number of arguments");
      for (var d3 = 0; d3 < c3; d3 += 2)
        this.set(arguments[d3], arguments[d3 + 1]);
    } else if (a3)
      if (a3 instanceof Id2)
        for (c3 = a3.Y(), d3 = 0; d3 < c3.length; d3++)
          this.set(c3[d3], a3.get(c3[d3]));
      else
        for (d3 in a3)
          this.set(d3, a3[d3]);
  }
  k3 = Id2.prototype;
  k3.V = function() {
    Jd2(this);
    for (var a3 = [], b3 = 0; b3 < this.a.length; b3++)
      a3.push(this.b[this.a[b3]]);
    return a3;
  };
  k3.Y = function() {
    Jd2(this);
    return this.a.concat();
  };
  k3.clear = function() {
    this.b = {};
    this.c = this.a.length = 0;
  };
  function Jd2(a3) {
    if (a3.c != a3.a.length) {
      for (var b3 = 0, c3 = 0; b3 < a3.a.length; ) {
        var d3 = a3.a[b3];
        Kd2(a3.b, d3) && (a3.a[c3++] = d3);
        b3++;
      }
      a3.a.length = c3;
    }
    if (a3.c != a3.a.length) {
      var e28 = {};
      for (c3 = b3 = 0; b3 < a3.a.length; )
        d3 = a3.a[b3], Kd2(e28, d3) || (a3.a[c3++] = d3, e28[d3] = 1), b3++;
      a3.a.length = c3;
    }
  }
  k3.get = function(a3, b3) {
    return Kd2(this.b, a3) ? this.b[a3] : b3;
  };
  k3.set = function(a3, b3) {
    Kd2(this.b, a3) || (this.c++, this.a.push(a3));
    this.b[a3] = b3;
  };
  k3.forEach = function(a3, b3) {
    for (var c3 = this.Y(), d3 = 0; d3 < c3.length; d3++) {
      var e28 = c3[d3], f3 = this.get(e28);
      a3.call(b3, f3, e28, this);
    }
  };
  function Kd2(a3, b3) {
    return Object.prototype.hasOwnProperty.call(a3, b3);
  }
  var Ld2 = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
  function Md2(a3, b3) {
    if (a3) {
      a3 = a3.split("&");
      for (var c3 = 0; c3 < a3.length; c3++) {
        var d3 = a3[c3].indexOf("="), e28 = null;
        if (0 <= d3) {
          var f3 = a3[c3].substring(0, d3);
          e28 = a3[c3].substring(d3 + 1);
        } else
          f3 = a3[c3];
        b3(f3, e28 ? decodeURIComponent(e28.replace(/\+/g, " ")) : "");
      }
    }
  }
  function Nd2(a3, b3) {
    this.a = this.l = this.f = "";
    this.g = null;
    this.i = this.c = "";
    this.h = false;
    var c3;
    a3 instanceof Nd2 ? (this.h = b3 !== void 0 ? b3 : a3.h, Od2(this, a3.f), this.l = a3.l, this.a = a3.a, Pd2(this, a3.g), this.c = a3.c, Qd2(this, Rd2(a3.b)), this.i = a3.i) : a3 && (c3 = String(a3).match(Ld2)) ? (this.h = !!b3, Od2(this, c3[1] || "", true), this.l = Sd2(c3[2] || ""), this.a = Sd2(c3[3] || "", true), Pd2(this, c3[4]), this.c = Sd2(c3[5] || "", true), Qd2(this, c3[6] || "", true), this.i = Sd2(c3[7] || "")) : (this.h = !!b3, this.b = new Td2(null, this.h));
  }
  Nd2.prototype.toString = function() {
    var a3 = [], b3 = this.f;
    b3 && a3.push(Ud2(b3, Vd2, true), ":");
    var c3 = this.a;
    if (c3 || b3 == "file")
      a3.push("//"), (b3 = this.l) && a3.push(Ud2(b3, Vd2, true), "@"), a3.push(encodeURIComponent(String(c3)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c3 = this.g, c3 != null && a3.push(":", String(c3));
    if (c3 = this.c)
      this.a && c3.charAt(0) != "/" && a3.push("/"), a3.push(Ud2(c3, c3.charAt(0) == "/" ? Wd2 : Xd2, true));
    (c3 = this.b.toString()) && a3.push("?", c3);
    (c3 = this.i) && a3.push("#", Ud2(c3, Yd2));
    return a3.join("");
  };
  Nd2.prototype.resolve = function(a3) {
    var b3 = new Nd2(this), c3 = !!a3.f;
    c3 ? Od2(b3, a3.f) : c3 = !!a3.l;
    c3 ? b3.l = a3.l : c3 = !!a3.a;
    c3 ? b3.a = a3.a : c3 = a3.g != null;
    var d3 = a3.c;
    if (c3)
      Pd2(b3, a3.g);
    else if (c3 = !!a3.c) {
      if (d3.charAt(0) != "/")
        if (this.a && !this.c)
          d3 = "/" + d3;
        else {
          var e28 = b3.c.lastIndexOf("/");
          e28 != -1 && (d3 = b3.c.substr(0, e28 + 1) + d3);
        }
      e28 = d3;
      if (e28 == ".." || e28 == ".")
        d3 = "";
      else if (x3(e28, "./") || x3(e28, "/.")) {
        d3 = e28.lastIndexOf("/", 0) == 0;
        e28 = e28.split("/");
        for (var f3 = [], g3 = 0; g3 < e28.length; ) {
          var h3 = e28[g3++];
          h3 == "." ? d3 && g3 == e28.length && f3.push("") : h3 == ".." ? ((1 < f3.length || f3.length == 1 && f3[0] != "") && f3.pop(), d3 && g3 == e28.length && f3.push("")) : (f3.push(h3), d3 = true);
        }
        d3 = f3.join("/");
      } else
        d3 = e28;
    }
    c3 ? b3.c = d3 : c3 = a3.b.toString() !== "";
    c3 ? Qd2(b3, Rd2(a3.b)) : c3 = !!a3.i;
    c3 && (b3.i = a3.i);
    return b3;
  };
  function Od2(a3, b3, c3) {
    a3.f = c3 ? Sd2(b3, true) : b3;
    a3.f && (a3.f = a3.f.replace(/:$/, ""));
  }
  function Pd2(a3, b3) {
    if (b3) {
      b3 = Number(b3);
      if (isNaN(b3) || 0 > b3)
        throw Error("Bad port number " + b3);
      a3.g = b3;
    } else
      a3.g = null;
  }
  function Qd2(a3, b3, c3) {
    b3 instanceof Td2 ? (a3.b = b3, Zd2(a3.b, a3.h)) : (c3 || (b3 = Ud2(b3, $d2)), a3.b = new Td2(b3, a3.h));
  }
  function J3(a3, b3, c3) {
    a3.b.set(b3, c3);
  }
  function ae2(a3, b3) {
    return a3.b.get(b3);
  }
  function be2(a3) {
    return a3 instanceof Nd2 ? new Nd2(a3) : new Nd2(a3, void 0);
  }
  function ce2(a3, b3, c3, d3) {
    var e28 = new Nd2(null, void 0);
    a3 && Od2(e28, a3);
    b3 && (e28.a = b3);
    c3 && Pd2(e28, c3);
    d3 && (e28.c = d3);
    return e28;
  }
  function Sd2(a3, b3) {
    return a3 ? b3 ? decodeURI(a3.replace(/%25/g, "%2525")) : decodeURIComponent(a3) : "";
  }
  function Ud2(a3, b3, c3) {
    return typeof a3 === "string" ? (a3 = encodeURI(a3).replace(b3, de2), c3 && (a3 = a3.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a3) : null;
  }
  function de2(a3) {
    a3 = a3.charCodeAt(0);
    return "%" + (a3 >> 4 & 15).toString(16) + (a3 & 15).toString(16);
  }
  var Vd2 = /[#\/\?@]/g, Xd2 = /[#\?:]/g, Wd2 = /[#\?]/g, $d2 = /[#\?@]/g, Yd2 = /#/g;
  function Td2(a3, b3) {
    this.b = this.a = null;
    this.c = a3 || null;
    this.f = !!b3;
  }
  function ee2(a3) {
    a3.a || (a3.a = new Id2(), a3.b = 0, a3.c && Md2(a3.c, function(b3, c3) {
      a3.add(decodeURIComponent(b3.replace(/\+/g, " ")), c3);
    }));
  }
  function fe2(a3) {
    var b3 = Gd2(a3);
    if (typeof b3 == "undefined")
      throw Error("Keys are undefined");
    var c3 = new Td2(null, void 0);
    a3 = Fd2(a3);
    for (var d3 = 0; d3 < b3.length; d3++) {
      var e28 = b3[d3], f3 = a3[d3];
      Array.isArray(f3) ? ge2(c3, e28, f3) : c3.add(e28, f3);
    }
    return c3;
  }
  k3 = Td2.prototype;
  k3.add = function(a3, b3) {
    ee2(this);
    this.c = null;
    a3 = he2(this, a3);
    var c3 = this.a.get(a3);
    c3 || this.a.set(a3, c3 = []);
    c3.push(b3);
    this.b += 1;
    return this;
  };
  function ie2(a3, b3) {
    ee2(a3);
    b3 = he2(a3, b3);
    Kd2(a3.a.b, b3) && (a3.c = null, a3.b -= a3.a.get(b3).length, a3 = a3.a, Kd2(a3.b, b3) && (delete a3.b[b3], a3.c--, a3.a.length > 2 * a3.c && Jd2(a3)));
  }
  k3.clear = function() {
    this.a = this.c = null;
    this.b = 0;
  };
  function je2(a3, b3) {
    ee2(a3);
    b3 = he2(a3, b3);
    return Kd2(a3.a.b, b3);
  }
  k3.forEach = function(a3, b3) {
    ee2(this);
    this.a.forEach(function(c3, d3) {
      w3(c3, function(e28) {
        a3.call(b3, e28, d3, this);
      }, this);
    }, this);
  };
  k3.Y = function() {
    ee2(this);
    for (var a3 = this.a.V(), b3 = this.a.Y(), c3 = [], d3 = 0; d3 < b3.length; d3++)
      for (var e28 = a3[d3], f3 = 0; f3 < e28.length; f3++)
        c3.push(b3[d3]);
    return c3;
  };
  k3.V = function(a3) {
    ee2(this);
    var b3 = [];
    if (typeof a3 === "string")
      je2(this, a3) && (b3 = Ya2(b3, this.a.get(he2(this, a3))));
    else {
      a3 = this.a.V();
      for (var c3 = 0; c3 < a3.length; c3++)
        b3 = Ya2(b3, a3[c3]);
    }
    return b3;
  };
  k3.set = function(a3, b3) {
    ee2(this);
    this.c = null;
    a3 = he2(this, a3);
    je2(this, a3) && (this.b -= this.a.get(a3).length);
    this.a.set(a3, [b3]);
    this.b += 1;
    return this;
  };
  k3.get = function(a3, b3) {
    if (!a3)
      return b3;
    a3 = this.V(a3);
    return 0 < a3.length ? String(a3[0]) : b3;
  };
  function ge2(a3, b3, c3) {
    ie2(a3, b3);
    0 < c3.length && (a3.c = null, a3.a.set(he2(a3, b3), Za2(c3)), a3.b += c3.length);
  }
  k3.toString = function() {
    if (this.c)
      return this.c;
    if (!this.a)
      return "";
    for (var a3 = [], b3 = this.a.Y(), c3 = 0; c3 < b3.length; c3++) {
      var d3 = b3[c3], e28 = encodeURIComponent(String(d3));
      d3 = this.V(d3);
      for (var f3 = 0; f3 < d3.length; f3++) {
        var g3 = e28;
        d3[f3] !== "" && (g3 += "=" + encodeURIComponent(String(d3[f3])));
        a3.push(g3);
      }
    }
    return this.c = a3.join("&");
  };
  function Rd2(a3) {
    var b3 = new Td2();
    b3.c = a3.c;
    a3.a && (b3.a = new Id2(a3.a), b3.b = a3.b);
    return b3;
  }
  function he2(a3, b3) {
    b3 = String(b3);
    a3.f && (b3 = b3.toLowerCase());
    return b3;
  }
  function Zd2(a3, b3) {
    b3 && !a3.f && (ee2(a3), a3.c = null, a3.a.forEach(function(c3, d3) {
      var e28 = d3.toLowerCase();
      d3 != e28 && (ie2(this, d3), ge2(this, e28, c3));
    }, a3));
    a3.f = b3;
  }
  function ke2(a3) {
    var b3 = [];
    le2(new me2(), a3, b3);
    return b3.join("");
  }
  function me2() {
  }
  function le2(a3, b3, c3) {
    if (b3 == null)
      c3.push("null");
    else {
      if (typeof b3 == "object") {
        if (Array.isArray(b3)) {
          var d3 = b3;
          b3 = d3.length;
          c3.push("[");
          for (var e28 = "", f3 = 0; f3 < b3; f3++)
            c3.push(e28), le2(a3, d3[f3], c3), e28 = ",";
          c3.push("]");
          return;
        }
        if (b3 instanceof String || b3 instanceof Number || b3 instanceof Boolean)
          b3 = b3.valueOf();
        else {
          c3.push("{");
          e28 = "";
          for (d3 in b3)
            Object.prototype.hasOwnProperty.call(b3, d3) && (f3 = b3[d3], typeof f3 != "function" && (c3.push(e28), ne2(d3, c3), c3.push(":"), le2(a3, f3, c3), e28 = ","));
          c3.push("}");
          return;
        }
      }
      switch (typeof b3) {
        case "string":
          ne2(b3, c3);
          break;
        case "number":
          c3.push(isFinite(b3) && !isNaN(b3) ? String(b3) : "null");
          break;
        case "boolean":
          c3.push(String(b3));
          break;
        case "function":
          c3.push("null");
          break;
        default:
          throw Error("Unknown type: " + typeof b3);
      }
    }
  }
  var oe2 = { '"': '\\"', "\\": "\\\\", "/": "\\/", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t", "\v": "\\u000b" }, pe2 = /\uffff/.test("\uFFFF") ? /[\\"\x00-\x1f\x7f-\uffff]/g : /[\\"\x00-\x1f\x7f-\xff]/g;
  function ne2(a3, b3) {
    b3.push('"', a3.replace(pe2, function(c3) {
      var d3 = oe2[c3];
      d3 || (d3 = "\\u" + (c3.charCodeAt(0) | 65536).toString(16).substr(1), oe2[c3] = d3);
      return d3;
    }), '"');
  }
  function qe2() {
    var a3 = K3();
    return Wb2 && !!ic2 && ic2 == 11 || /Edge\/\d+/.test(a3);
  }
  function re2() {
    return l3.window && l3.window.location.href || self && self.location && self.location.href || "";
  }
  function se2(a3, b3) {
    b3 = b3 || l3.window;
    var c3 = "about:blank";
    a3 && (c3 = Eb2(Ib2(a3) || Kb2));
    b3.location.href = c3;
  }
  function te2(a3, b3) {
    var c3 = [], d3;
    for (d3 in a3)
      d3 in b3 ? typeof a3[d3] != typeof b3[d3] ? c3.push(d3) : typeof a3[d3] == "object" && a3[d3] != null && b3[d3] != null ? 0 < te2(a3[d3], b3[d3]).length && c3.push(d3) : a3[d3] !== b3[d3] && c3.push(d3) : c3.push(d3);
    for (d3 in b3)
      d3 in a3 || c3.push(d3);
    return c3;
  }
  function ue2() {
    var a3 = K3();
    a3 = ve2(a3) != we2 ? null : (a3 = a3.match(/\sChrome\/(\d+)/i)) && a3.length == 2 ? parseInt(a3[1], 10) : null;
    return a3 && 30 > a3 ? false : !Wb2 || !ic2 || 9 < ic2;
  }
  function xe2(a3) {
    a3 = (a3 || K3()).toLowerCase();
    return a3.match(/android/) || a3.match(/webos/) || a3.match(/iphone|ipad|ipod/) || a3.match(/blackberry/) || a3.match(/windows phone/) || a3.match(/iemobile/) ? true : false;
  }
  function ye2(a3) {
    a3 = a3 || l3.window;
    try {
      a3.close();
    } catch (b3) {
    }
  }
  function ze2(a3, b3, c3) {
    var d3 = Math.floor(1e9 * Math.random()).toString();
    b3 = b3 || 500;
    c3 = c3 || 600;
    var e28 = (window.screen.availHeight - c3) / 2, f3 = (window.screen.availWidth - b3) / 2;
    b3 = { width: b3, height: c3, top: 0 < e28 ? e28 : 0, left: 0 < f3 ? f3 : 0, location: true, resizable: true, statusbar: true, toolbar: false };
    c3 = K3().toLowerCase();
    d3 && (b3.target = d3, x3(c3, "crios/") && (b3.target = "_blank"));
    ve2(K3()) == Ae2 && (a3 = a3 || "http://localhost", b3.scrollbars = true);
    c3 = a3 || "";
    (a3 = b3) || (a3 = {});
    d3 = window;
    b3 = c3 instanceof C3 ? c3 : Ib2(typeof c3.href != "undefined" ? c3.href : String(c3)) || Kb2;
    c3 = a3.target || c3.target;
    e28 = [];
    for (g3 in a3)
      switch (g3) {
        case "width":
        case "height":
        case "top":
        case "left":
          e28.push(g3 + "=" + a3[g3]);
          break;
        case "target":
        case "noopener":
        case "noreferrer":
          break;
        default:
          e28.push(g3 + "=" + (a3[g3] ? 1 : 0));
      }
    var g3 = e28.join(",");
    if ((y3("iPhone") && !y3("iPod") && !y3("iPad") || y3("iPad") || y3("iPod")) && d3.navigator && d3.navigator.standalone && c3 && c3 != "_self")
      g3 = oc2(document, "A"), pb2(g3, "HTMLAnchorElement"), b3 = b3 instanceof C3 ? b3 : Jb2(b3), g3.href = Eb2(b3), g3.setAttribute("target", c3), a3.noreferrer && g3.setAttribute("rel", "noreferrer"), a3 = document.createEvent("MouseEvent"), a3.initMouseEvent("click", true, true, d3, 1), g3.dispatchEvent(a3), g3 = {};
    else if (a3.noreferrer) {
      if (g3 = Pb2("", d3, c3, g3), a3 = Eb2(b3), g3 && (Yb2 && x3(a3, ";") && (a3 = "'" + a3.replace(/'/g, "%27") + "'"), g3.opener = null, a3 = '<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url=' + Rb2(a3) + '">', a3 = (d3 = vb2()) ? d3.createHTML(a3) : a3, a3 = new Lb2(a3, null, Mb2), d3 = g3.document))
        d3.write(Nb2(a3)), d3.close();
    } else
      (g3 = Pb2(b3, d3, c3, g3)) && a3.noopener && (g3.opener = null);
    if (g3)
      try {
        g3.focus();
      } catch (h3) {
      }
    return g3;
  }
  function Be2(a3) {
    return new D3(function(b3) {
      function c3() {
        Ed2(2e3).then(function() {
          if (!a3 || a3.closed)
            b3();
          else
            return c3();
        });
      }
      return c3();
    });
  }
  var Ce2 = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, De2 = /^[^@]+@[^@]+$/;
  function Ee2() {
    var a3 = null;
    return new D3(function(b3) {
      l3.document.readyState == "complete" ? b3() : (a3 = function() {
        b3();
      }, od2(window, "load", a3));
    }).o(function(b3) {
      H3(window, "load", a3);
      throw b3;
    });
  }
  function Fe2() {
    return Ge2(void 0) ? Ee2().then(function() {
      return new D3(function(a3, b3) {
        var c3 = l3.document, d3 = setTimeout(function() {
          b3(Error("Cordova framework is not ready."));
        }, 1e3);
        c3.addEventListener("deviceready", function() {
          clearTimeout(d3);
          a3();
        }, false);
      });
    }) : F3(Error("Cordova must run in an Android or iOS file scheme."));
  }
  function Ge2(a3) {
    a3 = a3 || K3();
    return !(He2() !== "file:" && He2() !== "ionic:" || !a3.toLowerCase().match(/iphone|ipad|ipod|android/));
  }
  function Ie2() {
    var a3 = l3.window;
    try {
      return !(!a3 || a3 == a3.top);
    } catch (b3) {
      return false;
    }
  }
  function Je2() {
    return typeof l3.WorkerGlobalScope !== "undefined" && typeof l3.importScripts === "function";
  }
  function Ke2() {
    return firebase$1.INTERNAL.hasOwnProperty("reactNative") ? "ReactNative" : firebase$1.INTERNAL.hasOwnProperty("node") ? "Node" : Je2() ? "Worker" : "Browser";
  }
  function Le2() {
    var a3 = Ke2();
    return a3 === "ReactNative" || a3 === "Node";
  }
  function Me2() {
    for (var a3 = 50, b3 = []; 0 < a3; )
      b3.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), a3--;
    return b3.join("");
  }
  var Ae2 = "Firefox", we2 = "Chrome";
  function ve2(a3) {
    var b3 = a3.toLowerCase();
    if (x3(b3, "opera/") || x3(b3, "opr/") || x3(b3, "opios/"))
      return "Opera";
    if (x3(b3, "iemobile"))
      return "IEMobile";
    if (x3(b3, "msie") || x3(b3, "trident/"))
      return "IE";
    if (x3(b3, "edge/"))
      return "Edge";
    if (x3(b3, "firefox/"))
      return Ae2;
    if (x3(b3, "silk/"))
      return "Silk";
    if (x3(b3, "blackberry"))
      return "Blackberry";
    if (x3(b3, "webos"))
      return "Webos";
    if (!x3(b3, "safari/") || x3(b3, "chrome/") || x3(b3, "crios/") || x3(b3, "android"))
      if (!x3(b3, "chrome/") && !x3(b3, "crios/") || x3(b3, "edge/")) {
        if (x3(b3, "android"))
          return "Android";
        if ((a3 = a3.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/)) && a3.length == 2)
          return a3[1];
      } else
        return we2;
    else
      return "Safari";
    return "Other";
  }
  var Ne2 = { ld: "FirebaseCore-web", nd: "FirebaseUI-web" };
  function Oe2(a3, b3) {
    b3 = b3 || [];
    var c3 = [], d3 = {}, e28;
    for (e28 in Ne2)
      d3[Ne2[e28]] = true;
    for (e28 = 0; e28 < b3.length; e28++)
      typeof d3[b3[e28]] !== "undefined" && (delete d3[b3[e28]], c3.push(b3[e28]));
    c3.sort();
    b3 = c3;
    b3.length || (b3 = ["FirebaseCore-web"]);
    c3 = Ke2();
    c3 === "Browser" ? (d3 = K3(), c3 = ve2(d3)) : c3 === "Worker" && (d3 = K3(), c3 = ve2(d3) + "-" + c3);
    return c3 + "/JsCore/" + a3 + "/" + b3.join(",");
  }
  function K3() {
    return l3.navigator && l3.navigator.userAgent || "";
  }
  function L3(a3, b3) {
    a3 = a3.split(".");
    b3 = b3 || l3;
    for (var c3 = 0; c3 < a3.length && typeof b3 == "object" && b3 != null; c3++)
      b3 = b3[a3[c3]];
    c3 != a3.length && (b3 = void 0);
    return b3;
  }
  function Pe2() {
    try {
      var a3 = l3.localStorage, b3 = Qe2();
      if (a3)
        return a3.setItem(b3, "1"), a3.removeItem(b3), qe2() ? !!l3.indexedDB : true;
    } catch (c3) {
      return Je2() && !!l3.indexedDB;
    }
    return false;
  }
  function Re2() {
    return (Se2() || He2() === "chrome-extension:" || Ge2()) && !Le2() && Pe2() && !Je2();
  }
  function Se2() {
    return He2() === "http:" || He2() === "https:";
  }
  function He2() {
    return l3.location && l3.location.protocol || null;
  }
  function Te2(a3) {
    a3 = a3 || K3();
    return xe2(a3) || ve2(a3) == Ae2 ? false : true;
  }
  function Ue2(a3) {
    return typeof a3 === "undefined" ? null : ke2(a3);
  }
  function Ve2(a3) {
    var b3 = {}, c3;
    for (c3 in a3)
      a3.hasOwnProperty(c3) && a3[c3] !== null && a3[c3] !== void 0 && (b3[c3] = a3[c3]);
    return b3;
  }
  function We2(a3) {
    if (a3 !== null)
      return JSON.parse(a3);
  }
  function Qe2(a3) {
    return a3 ? a3 : Math.floor(1e9 * Math.random()).toString();
  }
  function Xe2(a3) {
    a3 = a3 || K3();
    return ve2(a3) == "Safari" || a3.toLowerCase().match(/iphone|ipad|ipod/) ? false : true;
  }
  function Ye2() {
    var a3 = l3.___jsl;
    if (a3 && a3.H) {
      for (var b3 in a3.H)
        if (a3.H[b3].r = a3.H[b3].r || [], a3.H[b3].L = a3.H[b3].L || [], a3.H[b3].r = a3.H[b3].L.concat(), a3.CP)
          for (var c3 = 0; c3 < a3.CP.length; c3++)
            a3.CP[c3] = null;
    }
  }
  function Ze2(a3, b3) {
    if (a3 > b3)
      throw Error("Short delay should be less than long delay!");
    this.a = a3;
    this.c = b3;
    a3 = K3();
    b3 = Ke2();
    this.b = xe2(a3) || b3 === "ReactNative";
  }
  Ze2.prototype.get = function() {
    var a3 = l3.navigator;
    return (a3 && typeof a3.onLine === "boolean" && (Se2() || He2() === "chrome-extension:" || typeof a3.connection !== "undefined") ? a3.onLine : 1) ? this.b ? this.c : this.a : Math.min(5e3, this.a);
  };
  function $e2() {
    var a3 = l3.document;
    return a3 && typeof a3.visibilityState !== "undefined" ? a3.visibilityState == "visible" : true;
  }
  function af2() {
    var a3 = l3.document, b3 = null;
    return $e2() || !a3 ? E3() : new D3(function(c3) {
      b3 = function() {
        $e2() && (a3.removeEventListener("visibilitychange", b3, false), c3());
      };
      a3.addEventListener("visibilitychange", b3, false);
    }).o(function(c3) {
      a3.removeEventListener("visibilitychange", b3, false);
      throw c3;
    });
  }
  function bf2(a3) {
    try {
      var b3 = new Date(parseInt(a3, 10));
      if (!isNaN(b3.getTime()) && !/[^0-9]/.test(a3))
        return b3.toUTCString();
    } catch (c3) {
    }
    return null;
  }
  function cf2() {
    return !(!L3("fireauth.oauthhelper", l3) && !L3("fireauth.iframe", l3));
  }
  function df2() {
    var a3 = l3.navigator;
    return a3 && a3.serviceWorker && a3.serviceWorker.controller || null;
  }
  function ef2() {
    var a3 = l3.navigator;
    return a3 && a3.serviceWorker ? E3().then(function() {
      return a3.serviceWorker.ready;
    }).then(function(b3) {
      return b3.active || null;
    }).o(function() {
      return null;
    }) : E3(null);
  }
  var ff2 = {};
  function gf2(a3) {
    ff2[a3] || (ff2[a3] = true, typeof console !== "undefined" && typeof console.warn === "function" && console.warn(a3));
  }
  var hf2;
  try {
    var jf = {};
    Object.defineProperty(jf, "abcd", { configurable: true, enumerable: true, value: 1 });
    Object.defineProperty(jf, "abcd", { configurable: true, enumerable: true, value: 2 });
    hf2 = jf.abcd == 2;
  } catch (a3) {
    hf2 = false;
  }
  function M3(a3, b3, c3) {
    hf2 ? Object.defineProperty(a3, b3, { configurable: true, enumerable: true, value: c3 }) : a3[b3] = c3;
  }
  function N3(a3, b3) {
    if (b3)
      for (var c3 in b3)
        b3.hasOwnProperty(c3) && M3(a3, c3, b3[c3]);
  }
  function kf2(a3) {
    var b3 = {};
    N3(b3, a3);
    return b3;
  }
  function lf2(a3) {
    var b3 = {}, c3;
    for (c3 in a3)
      a3.hasOwnProperty(c3) && (b3[c3] = a3[c3]);
    return b3;
  }
  function mf2(a3, b3) {
    if (!b3 || !b3.length)
      return true;
    if (!a3)
      return false;
    for (var c3 = 0; c3 < b3.length; c3++) {
      var d3 = a3[b3[c3]];
      if (d3 === void 0 || d3 === null || d3 === "")
        return false;
    }
    return true;
  }
  function nf2(a3) {
    var b3 = a3;
    if (typeof a3 == "object" && a3 != null) {
      b3 = "length" in a3 ? [] : {};
      for (var c3 in a3)
        M3(b3, c3, nf2(a3[c3]));
    }
    return b3;
  }
  function of2(a3) {
    var b3 = a3 && (a3[pf2] ? "phone" : null);
    if (b3 && a3 && a3[qf]) {
      M3(this, "uid", a3[qf]);
      M3(this, "displayName", a3[rf2] || null);
      var c3 = null;
      a3[sf2] && (c3 = new Date(a3[sf2]).toUTCString());
      M3(this, "enrollmentTime", c3);
      M3(this, "factorId", b3);
    } else
      throw new t3("internal-error", "Internal assert: invalid MultiFactorInfo object");
  }
  of2.prototype.w = function() {
    return { uid: this.uid, displayName: this.displayName, factorId: this.factorId, enrollmentTime: this.enrollmentTime };
  };
  function tf2(a3) {
    try {
      var b3 = new uf2(a3);
    } catch (c3) {
      b3 = null;
    }
    return b3;
  }
  var rf2 = "displayName", sf2 = "enrolledAt", qf = "mfaEnrollmentId", pf2 = "phoneInfo";
  function uf2(a3) {
    of2.call(this, a3);
    M3(this, "phoneNumber", a3[pf2]);
  }
  r3(uf2, of2);
  uf2.prototype.w = function() {
    var a3 = uf2.$a.w.call(this);
    a3.phoneNumber = this.phoneNumber;
    return a3;
  };
  function vf2(a3) {
    var b3 = {}, c3 = a3[wf], d3 = a3[xf2], e28 = a3[yf2];
    a3 = tf2(a3[zf]);
    if (!e28 || e28 != Af && e28 != Bf && !c3 || e28 == Bf && !d3 || e28 == Cf2 && !a3)
      throw Error("Invalid checkActionCode response!");
    e28 == Bf ? (b3[Df] = c3 || null, b3[Ef2] = c3 || null, b3[Ff] = d3) : (b3[Df] = d3 || null, b3[Ef2] = d3 || null, b3[Ff] = c3 || null);
    b3[Gf] = a3 || null;
    M3(this, Hf, e28);
    M3(this, If, nf2(b3));
  }
  var Cf2 = "REVERT_SECOND_FACTOR_ADDITION", Af = "EMAIL_SIGNIN", Bf = "VERIFY_AND_CHANGE_EMAIL", wf = "email", zf = "mfaInfo", xf2 = "newEmail", yf2 = "requestType", Ff = "email", Df = "fromEmail", Gf = "multiFactorInfo", Ef2 = "previousEmail", If = "data", Hf = "operation";
  function Jf(a3) {
    a3 = be2(a3);
    var b3 = ae2(a3, Kf) || null, c3 = ae2(a3, Lf) || null, d3 = ae2(a3, Mf) || null;
    d3 = d3 ? Nf[d3] || null : null;
    if (!b3 || !c3 || !d3)
      throw new t3("argument-error", Kf + ", " + Lf + "and " + Mf + " are required in a valid action code URL.");
    N3(this, { apiKey: b3, operation: d3, code: c3, continueUrl: ae2(a3, Of) || null, languageCode: ae2(a3, Pf) || null, tenantId: ae2(a3, Qf) || null });
  }
  var Kf = "apiKey", Lf = "oobCode", Of = "continueUrl", Pf = "languageCode", Mf = "mode", Qf = "tenantId", Nf = { recoverEmail: "RECOVER_EMAIL", resetPassword: "PASSWORD_RESET", revertSecondFactorAddition: Cf2, signIn: Af, verifyAndChangeEmail: Bf, verifyEmail: "VERIFY_EMAIL" };
  function Rf(a3) {
    try {
      return new Jf(a3);
    } catch (b3) {
      return null;
    }
  }
  function Sf2(a3) {
    var b3 = a3[Tf];
    if (typeof b3 === "undefined")
      throw new t3("missing-continue-uri");
    if (typeof b3 !== "string" || typeof b3 === "string" && !b3.length)
      throw new t3("invalid-continue-uri");
    this.i = b3;
    this.b = this.a = null;
    this.g = false;
    var c3 = a3[Uf];
    if (c3 && typeof c3 === "object") {
      b3 = c3[Vf];
      var d3 = c3[Wf];
      c3 = c3[Xf];
      if (typeof b3 === "string" && b3.length) {
        this.a = b3;
        if (typeof d3 !== "undefined" && typeof d3 !== "boolean")
          throw new t3("argument-error", Wf + " property must be a boolean when specified.");
        this.g = !!d3;
        if (typeof c3 !== "undefined" && (typeof c3 !== "string" || typeof c3 === "string" && !c3.length))
          throw new t3("argument-error", Xf + " property must be a non empty string when specified.");
        this.b = c3 || null;
      } else {
        if (typeof b3 !== "undefined")
          throw new t3("argument-error", Vf + " property must be a non empty string when specified.");
        if (typeof d3 !== "undefined" || typeof c3 !== "undefined")
          throw new t3("missing-android-pkg-name");
      }
    } else if (typeof c3 !== "undefined")
      throw new t3("argument-error", Uf + " property must be a non null object when specified.");
    this.f = null;
    if ((b3 = a3[Yf]) && typeof b3 === "object")
      if (b3 = b3[Zf], typeof b3 === "string" && b3.length)
        this.f = b3;
      else {
        if (typeof b3 !== "undefined")
          throw new t3("argument-error", Zf + " property must be a non empty string when specified.");
      }
    else if (typeof b3 !== "undefined")
      throw new t3("argument-error", Yf + " property must be a non null object when specified.");
    b3 = a3[$f];
    if (typeof b3 !== "undefined" && typeof b3 !== "boolean")
      throw new t3("argument-error", $f + " property must be a boolean when specified.");
    this.c = !!b3;
    a3 = a3[ag2];
    if (typeof a3 !== "undefined" && (typeof a3 !== "string" || typeof a3 === "string" && !a3.length))
      throw new t3("argument-error", ag2 + " property must be a non empty string when specified.");
    this.h = a3 || null;
  }
  var Uf = "android", ag2 = "dynamicLinkDomain", $f = "handleCodeInApp", Yf = "iOS", Tf = "url", Wf = "installApp", Xf = "minimumVersion", Vf = "packageName", Zf = "bundleId";
  function bg(a3) {
    var b3 = {};
    b3.continueUrl = a3.i;
    b3.canHandleCodeInApp = a3.c;
    if (b3.androidPackageName = a3.a)
      b3.androidMinimumVersion = a3.b, b3.androidInstallApp = a3.g;
    b3.iOSBundleId = a3.f;
    b3.dynamicLinkDomain = a3.h;
    for (var c3 in b3)
      b3[c3] === null && delete b3[c3];
    return b3;
  }
  function cg(a3) {
    return Ra2(a3, function(b3) {
      b3 = b3.toString(16);
      return 1 < b3.length ? b3 : "0" + b3;
    }).join("");
  }
  var dg = null;
  function eg2(a3) {
    var b3 = "";
    fg(a3, function(c3) {
      b3 += String.fromCharCode(c3);
    });
    return b3;
  }
  function fg(a3, b3) {
    function c3(n3) {
      for (; d3 < a3.length; ) {
        var p3 = a3.charAt(d3++), v3 = dg[p3];
        if (v3 != null)
          return v3;
        if (!/^[\s\xa0]*$/.test(p3))
          throw Error("Unknown base64 encoding at char: " + p3);
      }
      return n3;
    }
    gg();
    for (var d3 = 0; ; ) {
      var e28 = c3(-1), f3 = c3(0), g3 = c3(64), h3 = c3(64);
      if (h3 === 64 && e28 === -1)
        break;
      b3(e28 << 2 | f3 >> 4);
      g3 != 64 && (b3(f3 << 4 & 240 | g3 >> 2), h3 != 64 && b3(g3 << 6 & 192 | h3));
    }
  }
  function gg() {
    if (!dg) {
      dg = {};
      for (var a3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b3 = ["+/=", "+/", "-_=", "-_.", "-_"], c3 = 0; 5 > c3; c3++)
        for (var d3 = a3.concat(b3[c3].split("")), e28 = 0; e28 < d3.length; e28++) {
          var f3 = d3[e28];
          dg[f3] === void 0 && (dg[f3] = e28);
        }
    }
  }
  function hg(a3) {
    var b3 = ig2(a3);
    if (!(b3 && b3.sub && b3.iss && b3.aud && b3.exp))
      throw Error("Invalid JWT");
    this.i = a3;
    this.a = b3.exp;
    this.h = b3.sub;
    a3 = Date.now() / 1e3;
    this.g = b3.iat || (a3 > this.a ? this.a : a3);
    this.b = b3.provider_id || b3.firebase && b3.firebase.sign_in_provider || null;
    this.f = b3.firebase && b3.firebase.tenant || null;
    this.c = !!b3.is_anonymous || this.b == "anonymous";
  }
  hg.prototype.S = function() {
    return this.f;
  };
  hg.prototype.l = function() {
    return this.c;
  };
  hg.prototype.toString = function() {
    return this.i;
  };
  function jg(a3) {
    try {
      return new hg(a3);
    } catch (b3) {
      return null;
    }
  }
  function ig2(a3) {
    if (!a3)
      return null;
    a3 = a3.split(".");
    if (a3.length != 3)
      return null;
    a3 = a3[1];
    for (var b3 = (4 - a3.length % 4) % 4, c3 = 0; c3 < b3; c3++)
      a3 += ".";
    try {
      return JSON.parse(eg2(a3));
    } catch (d3) {
    }
    return null;
  }
  var kg = "oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "), lg = ["client_id", "response_type", "scope", "redirect_uri", "state"], mg = { md: { Ja: "locale", ua: 700, ta: 600, fa: "facebook.com", Wa: lg }, od: { Ja: null, ua: 500, ta: 750, fa: "github.com", Wa: lg }, pd: { Ja: "hl", ua: 515, ta: 680, fa: "google.com", Wa: lg }, vd: { Ja: "lang", ua: 485, ta: 705, fa: "twitter.com", Wa: kg }, jd: { Ja: "locale", ua: 640, ta: 600, fa: "apple.com", Wa: [] } };
  function ng2(a3) {
    for (var b3 in mg)
      if (mg[b3].fa == a3)
        return mg[b3];
    return null;
  }
  function og2(a3) {
    var b3 = {};
    b3["facebook.com"] = pg;
    b3["google.com"] = qg;
    b3["github.com"] = rg2;
    b3["twitter.com"] = sg2;
    var c3 = a3 && a3[tg2];
    try {
      if (c3)
        return b3[c3] ? new b3[c3](a3) : new ug2(a3);
      if (typeof a3[vg] !== "undefined")
        return new wg(a3);
    } catch (d3) {
    }
    return null;
  }
  var vg = "idToken", tg2 = "providerId";
  function wg(a3) {
    var b3 = a3[tg2];
    if (!b3 && a3[vg]) {
      var c3 = jg(a3[vg]);
      c3 && c3.b && (b3 = c3.b);
    }
    if (!b3)
      throw Error("Invalid additional user info!");
    if (b3 == "anonymous" || b3 == "custom")
      b3 = null;
    c3 = false;
    typeof a3.isNewUser !== "undefined" ? c3 = !!a3.isNewUser : a3.kind === "identitytoolkit#SignupNewUserResponse" && (c3 = true);
    M3(this, "providerId", b3);
    M3(this, "isNewUser", c3);
  }
  function ug2(a3) {
    wg.call(this, a3);
    a3 = We2(a3.rawUserInfo || "{}");
    M3(this, "profile", nf2(a3 || {}));
  }
  r3(ug2, wg);
  function pg(a3) {
    ug2.call(this, a3);
    if (this.providerId != "facebook.com")
      throw Error("Invalid provider ID!");
  }
  r3(pg, ug2);
  function rg2(a3) {
    ug2.call(this, a3);
    if (this.providerId != "github.com")
      throw Error("Invalid provider ID!");
    M3(this, "username", this.profile && this.profile.login || null);
  }
  r3(rg2, ug2);
  function qg(a3) {
    ug2.call(this, a3);
    if (this.providerId != "google.com")
      throw Error("Invalid provider ID!");
  }
  r3(qg, ug2);
  function sg2(a3) {
    ug2.call(this, a3);
    if (this.providerId != "twitter.com")
      throw Error("Invalid provider ID!");
    M3(this, "username", a3.screenName || null);
  }
  r3(sg2, ug2);
  function xg(a3) {
    var b3 = be2(a3), c3 = ae2(b3, "link"), d3 = ae2(be2(c3), "link");
    b3 = ae2(b3, "deep_link_id");
    return ae2(be2(b3), "link") || b3 || d3 || c3 || a3;
  }
  function yg(a3, b3) {
    if (!a3 && !b3)
      throw new t3("internal-error", "Internal assert: no raw session string available");
    if (a3 && b3)
      throw new t3("internal-error", "Internal assert: unable to determine the session type");
    this.a = a3 || null;
    this.b = b3 || null;
    this.type = this.a ? zg : Ag;
  }
  var zg = "enroll", Ag = "signin";
  yg.prototype.Ha = function() {
    return this.a ? E3(this.a) : E3(this.b);
  };
  yg.prototype.w = function() {
    return this.type == zg ? { multiFactorSession: { idToken: this.a } } : { multiFactorSession: { pendingCredential: this.b } };
  };
  function Bg() {
  }
  Bg.prototype.ja = function() {
  };
  Bg.prototype.b = function() {
  };
  Bg.prototype.c = function() {
  };
  Bg.prototype.w = function() {
  };
  function Cg(a3, b3) {
    return a3.then(function(c3) {
      if (c3[Dg]) {
        var d3 = jg(c3[Dg]);
        if (!d3 || b3 != d3.h)
          throw new t3("user-mismatch");
        return c3;
      }
      throw new t3("user-mismatch");
    }).o(function(c3) {
      throw c3 && c3.code && c3.code == ya2 + "user-not-found" ? new t3("user-mismatch") : c3;
    });
  }
  function Eg(a3, b3) {
    if (b3)
      this.a = b3;
    else
      throw new t3("internal-error", "failed to construct a credential");
    M3(this, "providerId", a3);
    M3(this, "signInMethod", a3);
  }
  Eg.prototype.ja = function(a3) {
    return Fg(a3, Gg(this));
  };
  Eg.prototype.b = function(a3, b3) {
    var c3 = Gg(this);
    c3.idToken = b3;
    return Hg(a3, c3);
  };
  Eg.prototype.c = function(a3, b3) {
    return Cg(Ig(a3, Gg(this)), b3);
  };
  function Gg(a3) {
    return { pendingToken: a3.a, requestUri: "http://localhost" };
  }
  Eg.prototype.w = function() {
    return { providerId: this.providerId, signInMethod: this.signInMethod, pendingToken: this.a };
  };
  function Jg(a3) {
    if (a3 && a3.providerId && a3.signInMethod && a3.providerId.indexOf("saml.") == 0 && a3.pendingToken)
      try {
        return new Eg(a3.providerId, a3.pendingToken);
      } catch (b3) {
      }
    return null;
  }
  function Kg(a3, b3, c3) {
    this.a = null;
    if (b3.idToken || b3.accessToken)
      b3.idToken && M3(this, "idToken", b3.idToken), b3.accessToken && M3(this, "accessToken", b3.accessToken), b3.nonce && !b3.pendingToken && M3(this, "nonce", b3.nonce), b3.pendingToken && (this.a = b3.pendingToken);
    else if (b3.oauthToken && b3.oauthTokenSecret)
      M3(this, "accessToken", b3.oauthToken), M3(this, "secret", b3.oauthTokenSecret);
    else
      throw new t3("internal-error", "failed to construct a credential");
    M3(this, "providerId", a3);
    M3(this, "signInMethod", c3);
  }
  Kg.prototype.ja = function(a3) {
    return Fg(a3, Lg(this));
  };
  Kg.prototype.b = function(a3, b3) {
    var c3 = Lg(this);
    c3.idToken = b3;
    return Hg(a3, c3);
  };
  Kg.prototype.c = function(a3, b3) {
    var c3 = Lg(this);
    return Cg(Ig(a3, c3), b3);
  };
  function Lg(a3) {
    var b3 = {};
    a3.idToken && (b3.id_token = a3.idToken);
    a3.accessToken && (b3.access_token = a3.accessToken);
    a3.secret && (b3.oauth_token_secret = a3.secret);
    b3.providerId = a3.providerId;
    a3.nonce && !a3.a && (b3.nonce = a3.nonce);
    b3 = { postBody: fe2(b3).toString(), requestUri: "http://localhost" };
    a3.a && (delete b3.postBody, b3.pendingToken = a3.a);
    return b3;
  }
  Kg.prototype.w = function() {
    var a3 = { providerId: this.providerId, signInMethod: this.signInMethod };
    this.idToken && (a3.oauthIdToken = this.idToken);
    this.accessToken && (a3.oauthAccessToken = this.accessToken);
    this.secret && (a3.oauthTokenSecret = this.secret);
    this.nonce && (a3.nonce = this.nonce);
    this.a && (a3.pendingToken = this.a);
    return a3;
  };
  function Mg(a3) {
    if (a3 && a3.providerId && a3.signInMethod) {
      var b3 = { idToken: a3.oauthIdToken, accessToken: a3.oauthTokenSecret ? null : a3.oauthAccessToken, oauthTokenSecret: a3.oauthTokenSecret, oauthToken: a3.oauthTokenSecret && a3.oauthAccessToken, nonce: a3.nonce, pendingToken: a3.pendingToken };
      try {
        return new Kg(a3.providerId, b3, a3.signInMethod);
      } catch (c3) {
      }
    }
    return null;
  }
  function Ng(a3, b3) {
    this.Pc = b3 || [];
    N3(this, { providerId: a3, isOAuthProvider: true });
    this.Hb = {};
    this.ob = (ng2(a3) || {}).Ja || null;
    this.nb = null;
  }
  Ng.prototype.Ka = function(a3) {
    this.Hb = nb2(a3);
    return this;
  };
  function Og(a3) {
    if (typeof a3 !== "string" || a3.indexOf("saml.") != 0)
      throw new t3("argument-error", 'SAML provider IDs must be prefixed with "saml."');
    Ng.call(this, a3, []);
  }
  r3(Og, Ng);
  function Pg(a3) {
    Ng.call(this, a3, lg);
    this.a = [];
  }
  r3(Pg, Ng);
  Pg.prototype.Ca = function(a3) {
    Va2(this.a, a3) || this.a.push(a3);
    return this;
  };
  Pg.prototype.Pb = function() {
    return Za2(this.a);
  };
  Pg.prototype.credential = function(a3, b3) {
    var c3;
    m3(a3) ? c3 = { idToken: a3.idToken || null, accessToken: a3.accessToken || null, nonce: a3.rawNonce || null } : c3 = { idToken: a3 || null, accessToken: b3 || null };
    if (!c3.idToken && !c3.accessToken)
      throw new t3("argument-error", "credential failed: must provide the ID token and/or the access token.");
    return new Kg(this.providerId, c3, this.providerId);
  };
  function Qg() {
    Pg.call(this, "facebook.com");
  }
  r3(Qg, Pg);
  M3(Qg, "PROVIDER_ID", "facebook.com");
  M3(Qg, "FACEBOOK_SIGN_IN_METHOD", "facebook.com");
  function Rg(a3) {
    if (!a3)
      throw new t3("argument-error", "credential failed: expected 1 argument (the OAuth access token).");
    var b3 = a3;
    m3(a3) && (b3 = a3.accessToken);
    return new Qg().credential({ accessToken: b3 });
  }
  function Sg() {
    Pg.call(this, "github.com");
  }
  r3(Sg, Pg);
  M3(Sg, "PROVIDER_ID", "github.com");
  M3(Sg, "GITHUB_SIGN_IN_METHOD", "github.com");
  function Tg(a3) {
    if (!a3)
      throw new t3("argument-error", "credential failed: expected 1 argument (the OAuth access token).");
    var b3 = a3;
    m3(a3) && (b3 = a3.accessToken);
    return new Sg().credential({ accessToken: b3 });
  }
  function Ug() {
    Pg.call(this, "google.com");
    this.Ca("profile");
  }
  r3(Ug, Pg);
  M3(Ug, "PROVIDER_ID", "google.com");
  M3(Ug, "GOOGLE_SIGN_IN_METHOD", "google.com");
  function Vg(a3, b3) {
    var c3 = a3;
    m3(a3) && (c3 = a3.idToken, b3 = a3.accessToken);
    return new Ug().credential({ idToken: c3, accessToken: b3 });
  }
  function Wg() {
    Ng.call(this, "twitter.com", kg);
  }
  r3(Wg, Ng);
  M3(Wg, "PROVIDER_ID", "twitter.com");
  M3(Wg, "TWITTER_SIGN_IN_METHOD", "twitter.com");
  function Xg(a3, b3) {
    var c3 = a3;
    m3(c3) || (c3 = { oauthToken: a3, oauthTokenSecret: b3 });
    if (!c3.oauthToken || !c3.oauthTokenSecret)
      throw new t3("argument-error", "credential failed: expected 2 arguments (the OAuth access token and secret).");
    return new Kg("twitter.com", c3, "twitter.com");
  }
  function Yg(a3, b3, c3) {
    this.a = a3;
    this.f = b3;
    M3(this, "providerId", "password");
    M3(this, "signInMethod", c3 === Zg.EMAIL_LINK_SIGN_IN_METHOD ? Zg.EMAIL_LINK_SIGN_IN_METHOD : Zg.EMAIL_PASSWORD_SIGN_IN_METHOD);
  }
  Yg.prototype.ja = function(a3) {
    return this.signInMethod == Zg.EMAIL_LINK_SIGN_IN_METHOD ? O3(a3, $g, { email: this.a, oobCode: this.f }) : O3(a3, ah, { email: this.a, password: this.f });
  };
  Yg.prototype.b = function(a3, b3) {
    return this.signInMethod == Zg.EMAIL_LINK_SIGN_IN_METHOD ? O3(a3, bh, { idToken: b3, email: this.a, oobCode: this.f }) : O3(a3, ch, { idToken: b3, email: this.a, password: this.f });
  };
  Yg.prototype.c = function(a3, b3) {
    return Cg(this.ja(a3), b3);
  };
  Yg.prototype.w = function() {
    return { email: this.a, password: this.f, signInMethod: this.signInMethod };
  };
  function dh(a3) {
    return a3 && a3.email && a3.password ? new Yg(a3.email, a3.password, a3.signInMethod) : null;
  }
  function Zg() {
    N3(this, { providerId: "password", isOAuthProvider: false });
  }
  function eh(a3, b3) {
    b3 = fh(b3);
    if (!b3)
      throw new t3("argument-error", "Invalid email link!");
    return new Yg(a3, b3.code, Zg.EMAIL_LINK_SIGN_IN_METHOD);
  }
  function fh(a3) {
    a3 = xg(a3);
    return (a3 = Rf(a3)) && a3.operation === Af ? a3 : null;
  }
  N3(Zg, { PROVIDER_ID: "password" });
  N3(Zg, { EMAIL_LINK_SIGN_IN_METHOD: "emailLink" });
  N3(Zg, { EMAIL_PASSWORD_SIGN_IN_METHOD: "password" });
  function gh(a3) {
    if (!(a3.cb && a3.bb || a3.La && a3.ea))
      throw new t3("internal-error");
    this.a = a3;
    M3(this, "providerId", "phone");
    this.fa = "phone";
    M3(this, "signInMethod", "phone");
  }
  gh.prototype.ja = function(a3) {
    return a3.eb(hh(this));
  };
  gh.prototype.b = function(a3, b3) {
    var c3 = hh(this);
    c3.idToken = b3;
    return O3(a3, ih, c3);
  };
  gh.prototype.c = function(a3, b3) {
    var c3 = hh(this);
    c3.operation = "REAUTH";
    a3 = O3(a3, jh2, c3);
    return Cg(a3, b3);
  };
  gh.prototype.w = function() {
    var a3 = { providerId: "phone" };
    this.a.cb && (a3.verificationId = this.a.cb);
    this.a.bb && (a3.verificationCode = this.a.bb);
    this.a.La && (a3.temporaryProof = this.a.La);
    this.a.ea && (a3.phoneNumber = this.a.ea);
    return a3;
  };
  function kh(a3) {
    if (a3 && a3.providerId === "phone" && (a3.verificationId && a3.verificationCode || a3.temporaryProof && a3.phoneNumber)) {
      var b3 = {};
      w3(["verificationId", "verificationCode", "temporaryProof", "phoneNumber"], function(c3) {
        a3[c3] && (b3[c3] = a3[c3]);
      });
      return new gh(b3);
    }
    return null;
  }
  function hh(a3) {
    return a3.a.La && a3.a.ea ? { temporaryProof: a3.a.La, phoneNumber: a3.a.ea } : { sessionInfo: a3.a.cb, code: a3.a.bb };
  }
  function lh(a3) {
    try {
      this.a = a3 || firebase$1.auth();
    } catch (b3) {
      throw new t3("argument-error", "Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");
    }
    N3(this, { providerId: "phone", isOAuthProvider: false });
  }
  lh.prototype.eb = function(a3, b3) {
    var c3 = this.a.a;
    return E3(b3.verify()).then(function(d3) {
      if (typeof d3 !== "string")
        throw new t3("argument-error", "An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");
      switch (b3.type) {
        case "recaptcha":
          var e28 = m3(a3) ? a3.session : null, f3 = m3(a3) ? a3.phoneNumber : a3, g3;
          e28 && e28.type == zg ? g3 = e28.Ha().then(function(h3) {
            return mh(c3, { idToken: h3, phoneEnrollmentInfo: { phoneNumber: f3, recaptchaToken: d3 } });
          }) : e28 && e28.type == Ag ? g3 = e28.Ha().then(function(h3) {
            return nh(c3, { mfaPendingCredential: h3, mfaEnrollmentId: a3.multiFactorHint && a3.multiFactorHint.uid || a3.multiFactorUid, phoneSignInInfo: { recaptchaToken: d3 } });
          }) : g3 = oh(c3, { phoneNumber: f3, recaptchaToken: d3 });
          return g3.then(function(h3) {
            typeof b3.reset === "function" && b3.reset();
            return h3;
          }, function(h3) {
            typeof b3.reset === "function" && b3.reset();
            throw h3;
          });
        default:
          throw new t3("argument-error", 'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');
      }
    });
  };
  function ph(a3, b3) {
    if (!a3)
      throw new t3("missing-verification-id");
    if (!b3)
      throw new t3("missing-verification-code");
    return new gh({ cb: a3, bb: b3 });
  }
  N3(lh, { PROVIDER_ID: "phone" });
  N3(lh, { PHONE_SIGN_IN_METHOD: "phone" });
  function qh2(a3) {
    if (a3.temporaryProof && a3.phoneNumber)
      return new gh({ La: a3.temporaryProof, ea: a3.phoneNumber });
    var b3 = a3 && a3.providerId;
    if (!b3 || b3 === "password")
      return null;
    var c3 = a3 && a3.oauthAccessToken, d3 = a3 && a3.oauthTokenSecret, e28 = a3 && a3.nonce, f3 = a3 && a3.oauthIdToken, g3 = a3 && a3.pendingToken;
    try {
      switch (b3) {
        case "google.com":
          return Vg(f3, c3);
        case "facebook.com":
          return Rg(c3);
        case "github.com":
          return Tg(c3);
        case "twitter.com":
          return Xg(c3, d3);
        default:
          return c3 || d3 || f3 || g3 ? g3 ? b3.indexOf("saml.") == 0 ? new Eg(b3, g3) : new Kg(b3, {
            pendingToken: g3,
            idToken: a3.oauthIdToken,
            accessToken: a3.oauthAccessToken
          }, b3) : new Pg(b3).credential({ idToken: f3, accessToken: c3, rawNonce: e28 }) : null;
      }
    } catch (h3) {
      return null;
    }
  }
  function rh(a3) {
    if (!a3.isOAuthProvider)
      throw new t3("invalid-oauth-provider");
  }
  function sh(a3, b3, c3, d3, e28, f3, g3) {
    this.c = a3;
    this.b = b3 || null;
    this.g = c3 || null;
    this.f = d3 || null;
    this.h = f3 || null;
    this.i = g3 || null;
    this.a = e28 || null;
    if (this.g || this.a) {
      if (this.g && this.a)
        throw new t3("invalid-auth-event");
      if (this.g && !this.f)
        throw new t3("invalid-auth-event");
    } else
      throw new t3("invalid-auth-event");
  }
  sh.prototype.getUid = function() {
    var a3 = [];
    a3.push(this.c);
    this.b && a3.push(this.b);
    this.f && a3.push(this.f);
    this.i && a3.push(this.i);
    return a3.join("-");
  };
  sh.prototype.S = function() {
    return this.i;
  };
  sh.prototype.w = function() {
    return { type: this.c, eventId: this.b, urlResponse: this.g, sessionId: this.f, postBody: this.h, tenantId: this.i, error: this.a && this.a.w() };
  };
  function th(a3) {
    a3 = a3 || {};
    return a3.type ? new sh(a3.type, a3.eventId, a3.urlResponse, a3.sessionId, a3.error && Aa2(a3.error), a3.postBody, a3.tenantId) : null;
  }
  function uh() {
    this.b = null;
    this.a = [];
  }
  var vh = null;
  function wh(a3) {
    var b3 = vh;
    b3.a.push(a3);
    b3.b || (b3.b = function(c3) {
      for (var d3 = 0; d3 < b3.a.length; d3++)
        b3.a[d3](c3);
    }, a3 = L3("universalLinks.subscribe", l3), typeof a3 === "function" && a3(null, b3.b));
  }
  function xh(a3) {
    var b3 = "unauthorized-domain", c3 = void 0, d3 = be2(a3);
    a3 = d3.a;
    d3 = d3.f;
    d3 == "chrome-extension" ? c3 = Qb2("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a3) : d3 == "http" || d3 == "https" ? c3 = Qb2("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a3) : b3 = "operation-not-supported-in-this-environment";
    t3.call(this, b3, c3);
  }
  r3(xh, t3);
  function yh(a3, b3, c3) {
    t3.call(this, a3, c3);
    a3 = b3 || {};
    a3.Ib && M3(this, "email", a3.Ib);
    a3.ea && M3(this, "phoneNumber", a3.ea);
    a3.credential && M3(this, "credential", a3.credential);
    a3.Yb && M3(this, "tenantId", a3.Yb);
  }
  r3(yh, t3);
  yh.prototype.w = function() {
    var a3 = { code: this.code, message: this.message };
    this.email && (a3.email = this.email);
    this.phoneNumber && (a3.phoneNumber = this.phoneNumber);
    this.tenantId && (a3.tenantId = this.tenantId);
    var b3 = this.credential && this.credential.w();
    b3 && z3(a3, b3);
    return a3;
  };
  yh.prototype.toJSON = function() {
    return this.w();
  };
  function zh2(a3) {
    if (a3.code) {
      var b3 = a3.code || "";
      b3.indexOf(ya2) == 0 && (b3 = b3.substring(ya2.length));
      var c3 = { credential: qh2(a3), Yb: a3.tenantId };
      if (a3.email)
        c3.Ib = a3.email;
      else if (a3.phoneNumber)
        c3.ea = a3.phoneNumber;
      else if (!c3.credential)
        return new t3(b3, a3.message || void 0);
      return new yh(b3, c3, a3.message);
    }
    return null;
  }
  function Ah() {
  }
  Ah.prototype.c = null;
  function Bh2(a3) {
    return a3.c || (a3.c = a3.b());
  }
  var Ch;
  function Dh() {
  }
  r3(Dh, Ah);
  Dh.prototype.a = function() {
    var a3 = Eh(this);
    return a3 ? new ActiveXObject(a3) : new XMLHttpRequest();
  };
  Dh.prototype.b = function() {
    var a3 = {};
    Eh(this) && (a3[0] = true, a3[1] = true);
    return a3;
  };
  function Eh(a3) {
    if (!a3.f && typeof XMLHttpRequest == "undefined" && typeof ActiveXObject != "undefined") {
      for (var b3 = ["MSXML2.XMLHTTP.6.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"], c3 = 0; c3 < b3.length; c3++) {
        var d3 = b3[c3];
        try {
          return new ActiveXObject(d3), a3.f = d3;
        } catch (e28) {
        }
      }
      throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
    }
    return a3.f;
  }
  Ch = new Dh();
  function Fh() {
  }
  r3(Fh, Ah);
  Fh.prototype.a = function() {
    var a3 = new XMLHttpRequest();
    if ("withCredentials" in a3)
      return a3;
    if (typeof XDomainRequest != "undefined")
      return new Gh2();
    throw Error("Unsupported browser");
  };
  Fh.prototype.b = function() {
    return {};
  };
  function Gh2() {
    this.a = new XDomainRequest();
    this.readyState = 0;
    this.onreadystatechange = null;
    this.responseType = this.responseText = this.response = "";
    this.status = -1;
    this.statusText = "";
    this.a.onload = q3(this.pc, this);
    this.a.onerror = q3(this.Rb, this);
    this.a.onprogress = q3(this.qc, this);
    this.a.ontimeout = q3(this.uc, this);
  }
  k3 = Gh2.prototype;
  k3.open = function(a3, b3, c3) {
    if (c3 != null && !c3)
      throw Error("Only async requests are supported.");
    this.a.open(a3, b3);
  };
  k3.send = function(a3) {
    if (a3)
      if (typeof a3 == "string")
        this.a.send(a3);
      else
        throw Error("Only string data is supported");
    else
      this.a.send();
  };
  k3.abort = function() {
    this.a.abort();
  };
  k3.setRequestHeader = function() {
  };
  k3.getResponseHeader = function(a3) {
    return a3.toLowerCase() == "content-type" ? this.a.contentType : "";
  };
  k3.pc = function() {
    this.status = 200;
    this.response = this.responseText = this.a.responseText;
    Hh2(this, 4);
  };
  k3.Rb = function() {
    this.status = 500;
    this.response = this.responseText = "";
    Hh2(this, 4);
  };
  k3.uc = function() {
    this.Rb();
  };
  k3.qc = function() {
    this.status = 200;
    Hh2(this, 1);
  };
  function Hh2(a3, b3) {
    a3.readyState = b3;
    if (a3.onreadystatechange)
      a3.onreadystatechange();
  }
  k3.getAllResponseHeaders = function() {
    return "content-type: " + this.a.contentType;
  };
  function Ih(a3, b3, c3) {
    this.reset(a3, b3, c3, void 0, void 0);
  }
  Ih.prototype.a = null;
  Ih.prototype.reset = function(a3, b3, c3, d3, e28) {
    delete this.a;
  };
  function Kh2(a3) {
    this.f = a3;
    this.b = this.c = this.a = null;
  }
  function Lh2(a3, b3) {
    this.name = a3;
    this.value = b3;
  }
  Lh2.prototype.toString = function() {
    return this.name;
  };
  var Mh2 = new Lh2("SEVERE", 1e3), Nh2 = new Lh2("WARNING", 900), Oh2 = new Lh2("CONFIG", 700), Ph = new Lh2("FINE", 500);
  function Qh2(a3) {
    if (a3.c)
      return a3.c;
    if (a3.a)
      return Qh2(a3.a);
    Ga2("Root logger has no level set.");
    return null;
  }
  Kh2.prototype.log = function(a3, b3, c3) {
    if (a3.value >= Qh2(this).value)
      for (oa2(b3) && (b3 = b3()), a3 = new Ih(a3, String(b3), this.f), c3 && (a3.a = c3), c3 = this; c3; )
        c3 = c3.a;
  };
  var Rh = {}, Sh = null;
  function Th(a3) {
    Sh || (Sh = new Kh2(""), Rh[""] = Sh, Sh.c = Oh2);
    var b3;
    if (!(b3 = Rh[a3])) {
      b3 = new Kh2(a3);
      var c3 = a3.lastIndexOf("."), d3 = a3.substr(c3 + 1);
      c3 = Th(a3.substr(0, c3));
      c3.b || (c3.b = {});
      c3.b[d3] = b3;
      b3.a = c3;
      Rh[a3] = b3;
    }
    return b3;
  }
  function Uh2(a3, b3) {
    a3 && a3.log(Ph, b3, void 0);
  }
  function Vh2(a3) {
    this.f = a3;
  }
  r3(Vh2, Ah);
  Vh2.prototype.a = function() {
    return new Wh2(this.f);
  };
  Vh2.prototype.b = function(a3) {
    return function() {
      return a3;
    };
  }({});
  function Wh2(a3) {
    I3.call(this);
    this.u = a3;
    this.i = void 0;
    this.readyState = Xh2;
    this.status = 0;
    this.responseType = this.responseText = this.response = this.statusText = "";
    this.onreadystatechange = null;
    this.l = new Headers();
    this.b = null;
    this.s = "GET";
    this.f = "";
    this.a = false;
    this.h = Th("goog.net.FetchXmlHttp");
    this.m = this.c = this.g = null;
  }
  r3(Wh2, I3);
  var Xh2 = 0;
  k3 = Wh2.prototype;
  k3.open = function(a3, b3) {
    if (this.readyState != Xh2)
      throw this.abort(), Error("Error reopening a connection");
    this.s = a3;
    this.f = b3;
    this.readyState = 1;
    Yh2(this);
  };
  k3.send = function(a3) {
    if (this.readyState != 1)
      throw this.abort(), Error("need to call open() first. ");
    this.a = true;
    var b3 = { headers: this.l, method: this.s, credentials: this.i, cache: void 0 };
    a3 && (b3.body = a3);
    this.u.fetch(new Request(this.f, b3)).then(this.tc.bind(this), this.Ta.bind(this));
  };
  k3.abort = function() {
    this.response = this.responseText = "";
    this.l = new Headers();
    this.status = 0;
    this.c && this.c.cancel("Request was aborted.");
    1 <= this.readyState && this.a && this.readyState != 4 && (this.a = false, Zh2(this));
    this.readyState = Xh2;
  };
  k3.tc = function(a3) {
    this.a && (this.g = a3, this.b || (this.status = this.g.status, this.statusText = this.g.statusText, this.b = a3.headers, this.readyState = 2, Yh2(this)), this.a && (this.readyState = 3, Yh2(this), this.a && (this.responseType === "arraybuffer" ? a3.arrayBuffer().then(this.rc.bind(this), this.Ta.bind(this)) : typeof l3.ReadableStream !== "undefined" && "body" in a3 ? (this.response = this.responseText = "", this.c = a3.body.getReader(), this.m = new TextDecoder(), $h2(this)) : a3.text().then(this.sc.bind(this), this.Ta.bind(this)))));
  };
  function $h2(a3) {
    a3.c.read().then(a3.oc.bind(a3)).catch(a3.Ta.bind(a3));
  }
  k3.oc = function(a3) {
    if (this.a) {
      var b3 = this.m.decode(a3.value ? a3.value : new Uint8Array(0), { stream: !a3.done });
      b3 && (this.response = this.responseText += b3);
      a3.done ? Zh2(this) : Yh2(this);
      this.readyState == 3 && $h2(this);
    }
  };
  k3.sc = function(a3) {
    this.a && (this.response = this.responseText = a3, Zh2(this));
  };
  k3.rc = function(a3) {
    this.a && (this.response = a3, Zh2(this));
  };
  k3.Ta = function(a3) {
    var b3 = this.h;
    b3 && b3.log(Nh2, "Failed to fetch url " + this.f, a3 instanceof Error ? a3 : Error(a3));
    this.a && Zh2(this);
  };
  function Zh2(a3) {
    a3.readyState = 4;
    a3.g = null;
    a3.c = null;
    a3.m = null;
    Yh2(a3);
  }
  k3.setRequestHeader = function(a3, b3) {
    this.l.append(a3, b3);
  };
  k3.getResponseHeader = function(a3) {
    return this.b ? this.b.get(a3.toLowerCase()) || "" : ((a3 = this.h) && a3.log(Nh2, "Attempting to get response header but no headers have been received for url: " + this.f, void 0), "");
  };
  k3.getAllResponseHeaders = function() {
    if (!this.b) {
      var a3 = this.h;
      a3 && a3.log(Nh2, "Attempting to get all response headers but no headers have been received for url: " + this.f, void 0);
      return "";
    }
    a3 = [];
    for (var b3 = this.b.entries(), c3 = b3.next(); !c3.done; )
      c3 = c3.value, a3.push(c3[0] + ": " + c3[1]), c3 = b3.next();
    return a3.join("\r\n");
  };
  function Yh2(a3) {
    a3.onreadystatechange && a3.onreadystatechange.call(a3);
  }
  Object.defineProperty(Wh2.prototype, "withCredentials", { get: function() {
    return this.i === "include";
  }, set: function(a3) {
    this.i = a3 ? "include" : "same-origin";
  } });
  function ai2(a3) {
    I3.call(this);
    this.headers = new Id2();
    this.O = a3 || null;
    this.c = false;
    this.A = this.a = null;
    this.i = this.P = this.l = "";
    this.f = this.N = this.h = this.G = false;
    this.g = 0;
    this.s = null;
    this.m = bi2;
    this.u = this.R = false;
  }
  r3(ai2, I3);
  var bi2 = "";
  ai2.prototype.b = Th("goog.net.XhrIo");
  var ci2 = /^https?$/i, di2 = ["POST", "PUT"];
  function ei2(a3, b3, c3, d3, e28) {
    if (a3.a)
      throw Error("[goog.net.XhrIo] Object is active with another request=" + a3.l + "; newUri=" + b3);
    c3 = c3 ? c3.toUpperCase() : "GET";
    a3.l = b3;
    a3.i = "";
    a3.P = c3;
    a3.G = false;
    a3.c = true;
    a3.a = a3.O ? a3.O.a() : Ch.a();
    a3.A = a3.O ? Bh2(a3.O) : Bh2(Ch);
    a3.a.onreadystatechange = q3(a3.Ub, a3);
    try {
      Uh2(a3.b, fi2(a3, "Opening Xhr")), a3.N = true, a3.a.open(c3, String(b3), true), a3.N = false;
    } catch (g3) {
      Uh2(a3.b, fi2(a3, "Error opening Xhr: " + g3.message));
      gi2(a3, g3);
      return;
    }
    b3 = d3 || "";
    var f3 = new Id2(a3.headers);
    e28 && Hd2(e28, function(g3, h3) {
      f3.set(h3, g3);
    });
    e28 = Ta2(f3.Y());
    d3 = l3.FormData && b3 instanceof l3.FormData;
    !Va2(di2, c3) || e28 || d3 || f3.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    f3.forEach(function(g3, h3) {
      this.a.setRequestHeader(h3, g3);
    }, a3);
    a3.m && (a3.a.responseType = a3.m);
    "withCredentials" in a3.a && a3.a.withCredentials !== a3.R && (a3.a.withCredentials = a3.R);
    try {
      hi2(a3), 0 < a3.g && (a3.u = ii2(a3.a), Uh2(a3.b, fi2(a3, "Will abort after " + a3.g + "ms if incomplete, xhr2 " + a3.u)), a3.u ? (a3.a.timeout = a3.g, a3.a.ontimeout = q3(a3.Ma, a3)) : a3.s = Dd2(a3.Ma, a3.g, a3)), Uh2(a3.b, fi2(a3, "Sending request")), a3.h = true, a3.a.send(b3), a3.h = false;
    } catch (g3) {
      Uh2(a3.b, fi2(a3, "Send error: " + g3.message)), gi2(a3, g3);
    }
  }
  function ii2(a3) {
    return Wb2 && fc2(9) && typeof a3.timeout === "number" && a3.ontimeout !== void 0;
  }
  function Ua2(a3) {
    return a3.toLowerCase() == "content-type";
  }
  k3 = ai2.prototype;
  k3.Ma = function() {
    typeof ha2 != "undefined" && this.a && (this.i = "Timed out after " + this.g + "ms, aborting", Uh2(this.b, fi2(this, this.i)), this.dispatchEvent("timeout"), this.abort(8));
  };
  function gi2(a3, b3) {
    a3.c = false;
    a3.a && (a3.f = true, a3.a.abort(), a3.f = false);
    a3.i = b3;
    ji2(a3);
    ki2(a3);
  }
  function ji2(a3) {
    a3.G || (a3.G = true, a3.dispatchEvent("complete"), a3.dispatchEvent("error"));
  }
  k3.abort = function() {
    this.a && this.c && (Uh2(this.b, fi2(this, "Aborting")), this.c = false, this.f = true, this.a.abort(), this.f = false, this.dispatchEvent("complete"), this.dispatchEvent("abort"), ki2(this));
  };
  k3.Da = function() {
    this.a && (this.c && (this.c = false, this.f = true, this.a.abort(), this.f = false), ki2(this, true));
    ai2.$a.Da.call(this);
  };
  k3.Ub = function() {
    this.xa || (this.N || this.h || this.f ? li2(this) : this.Ic());
  };
  k3.Ic = function() {
    li2(this);
  };
  function li2(a3) {
    if (a3.c && typeof ha2 != "undefined") {
      if (a3.A[1] && mi2(a3) == 4 && ni2(a3) == 2)
        Uh2(a3.b, fi2(a3, "Local request error detected and ignored"));
      else if (a3.h && mi2(a3) == 4)
        Dd2(a3.Ub, 0, a3);
      else if (a3.dispatchEvent("readystatechange"), mi2(a3) == 4) {
        Uh2(a3.b, fi2(a3, "Request complete"));
        a3.c = false;
        try {
          var b3 = ni2(a3);
          a:
            switch (b3) {
              case 200:
              case 201:
              case 202:
              case 204:
              case 206:
              case 304:
              case 1223:
                var c3 = true;
                break a;
              default:
                c3 = false;
            }
          var d3;
          if (!(d3 = c3)) {
            var e28;
            if (e28 = b3 === 0) {
              var f3 = String(a3.l).match(Ld2)[1] || null;
              if (!f3 && l3.self && l3.self.location) {
                var g3 = l3.self.location.protocol;
                f3 = g3.substr(0, g3.length - 1);
              }
              e28 = !ci2.test(f3 ? f3.toLowerCase() : "");
            }
            d3 = e28;
          }
          if (d3)
            a3.dispatchEvent("complete"), a3.dispatchEvent("success");
          else {
            try {
              var h3 = 2 < mi2(a3) ? a3.a.statusText : "";
            } catch (n3) {
              Uh2(a3.b, "Can not get status: " + n3.message), h3 = "";
            }
            a3.i = h3 + " [" + ni2(a3) + "]";
            ji2(a3);
          }
        } finally {
          ki2(a3);
        }
      }
    }
  }
  function ki2(a3, b3) {
    if (a3.a) {
      hi2(a3);
      var c3 = a3.a, d3 = a3.A[0] ? la2 : null;
      a3.a = null;
      a3.A = null;
      b3 || a3.dispatchEvent("ready");
      try {
        c3.onreadystatechange = d3;
      } catch (e28) {
        (a3 = a3.b) && a3.log(Mh2, "Problem encountered resetting onreadystatechange: " + e28.message, void 0);
      }
    }
  }
  function hi2(a3) {
    a3.a && a3.u && (a3.a.ontimeout = null);
    a3.s && (l3.clearTimeout(a3.s), a3.s = null);
  }
  function mi2(a3) {
    return a3.a ? a3.a.readyState : 0;
  }
  function ni2(a3) {
    try {
      return 2 < mi2(a3) ? a3.a.status : -1;
    } catch (b3) {
      return -1;
    }
  }
  function oi2(a3) {
    try {
      return a3.a ? a3.a.responseText : "";
    } catch (b3) {
      return Uh2(a3.b, "Can not get responseText: " + b3.message), "";
    }
  }
  k3.getResponse = function() {
    try {
      if (!this.a)
        return null;
      if ("response" in this.a)
        return this.a.response;
      switch (this.m) {
        case bi2:
        case "text":
          return this.a.responseText;
        case "arraybuffer":
          if ("mozResponseArrayBuffer" in this.a)
            return this.a.mozResponseArrayBuffer;
      }
      var a3 = this.b;
      a3 && a3.log(Mh2, "Response type " + this.m + " is not supported on this browser", void 0);
      return null;
    } catch (b3) {
      return Uh2(this.b, "Can not get response: " + b3.message), null;
    }
  };
  function fi2(a3, b3) {
    return b3 + " [" + a3.P + " " + a3.l + " " + ni2(a3) + "]";
  }
  function pi2(a3) {
    var b3 = qi2;
    this.g = [];
    this.u = b3;
    this.s = a3 || null;
    this.f = this.a = false;
    this.c = void 0;
    this.m = this.A = this.h = false;
    this.i = 0;
    this.b = null;
    this.l = 0;
  }
  pi2.prototype.cancel = function(a3) {
    if (this.a)
      this.c instanceof pi2 && this.c.cancel();
    else {
      if (this.b) {
        var b3 = this.b;
        delete this.b;
        a3 ? b3.cancel(a3) : (b3.l--, 0 >= b3.l && b3.cancel());
      }
      this.u ? this.u.call(this.s, this) : this.m = true;
      this.a || (a3 = new ri2(), si2(this), ti2(this, false, a3));
    }
  };
  pi2.prototype.v = function(a3, b3) {
    this.h = false;
    ti2(this, a3, b3);
  };
  function ti2(a3, b3, c3) {
    a3.a = true;
    a3.c = c3;
    a3.f = !b3;
    ui2(a3);
  }
  function si2(a3) {
    if (a3.a) {
      if (!a3.m)
        throw new vi2();
      a3.m = false;
    }
  }
  function wi2(a3, b3) {
    xi2(a3, null, b3, void 0);
  }
  function xi2(a3, b3, c3, d3) {
    a3.g.push([b3, c3, d3]);
    a3.a && ui2(a3);
  }
  pi2.prototype.then = function(a3, b3, c3) {
    var d3, e28, f3 = new D3(function(g3, h3) {
      d3 = g3;
      e28 = h3;
    });
    xi2(this, d3, function(g3) {
      g3 instanceof ri2 ? f3.cancel() : e28(g3);
    });
    return f3.then(a3, b3, c3);
  };
  pi2.prototype.$goog_Thenable = true;
  function yi2(a3) {
    return Sa2(a3.g, function(b3) {
      return oa2(b3[1]);
    });
  }
  function ui2(a3) {
    if (a3.i && a3.a && yi2(a3)) {
      var b3 = a3.i, c3 = zi2[b3];
      c3 && (l3.clearTimeout(c3.a), delete zi2[b3]);
      a3.i = 0;
    }
    a3.b && (a3.b.l--, delete a3.b);
    b3 = a3.c;
    for (var d3 = c3 = false; a3.g.length && !a3.h; ) {
      var e28 = a3.g.shift(), f3 = e28[0], g3 = e28[1];
      e28 = e28[2];
      if (f3 = a3.f ? g3 : f3)
        try {
          var h3 = f3.call(e28 || a3.s, b3);
          h3 !== void 0 && (a3.f = a3.f && (h3 == b3 || h3 instanceof Error), a3.c = b3 = h3);
          if (Ea2(b3) || typeof l3.Promise === "function" && b3 instanceof l3.Promise)
            d3 = true, a3.h = true;
        } catch (n3) {
          b3 = n3, a3.f = true, yi2(a3) || (c3 = true);
        }
    }
    a3.c = b3;
    d3 && (h3 = q3(a3.v, a3, true), d3 = q3(a3.v, a3, false), b3 instanceof pi2 ? (xi2(b3, h3, d3), b3.A = true) : b3.then(h3, d3));
    c3 && (b3 = new Ai2(b3), zi2[b3.a] = b3, a3.i = b3.a);
  }
  function vi2() {
    u3.call(this);
  }
  r3(vi2, u3);
  vi2.prototype.message = "Deferred has already fired";
  vi2.prototype.name = "AlreadyCalledError";
  function ri2() {
    u3.call(this);
  }
  r3(ri2, u3);
  ri2.prototype.message = "Deferred was canceled";
  ri2.prototype.name = "CanceledError";
  function Ai2(a3) {
    this.a = l3.setTimeout(q3(this.c, this), 0);
    this.b = a3;
  }
  Ai2.prototype.c = function() {
    delete zi2[this.a];
    throw this.b;
  };
  var zi2 = {};
  function Bi2(a3) {
    var b3 = {}, c3 = b3.document || document, d3 = yb2(a3).toString(), e28 = oc2(document, "SCRIPT"), f3 = { Vb: e28, Ma: void 0 }, g3 = new pi2(f3), h3 = null, n3 = b3.timeout != null ? b3.timeout : 5e3;
    0 < n3 && (h3 = window.setTimeout(function() {
      Ci2(e28, true);
      var p3 = new Di2(Ei2, "Timeout reached for loading script " + d3);
      si2(g3);
      ti2(g3, false, p3);
    }, n3), f3.Ma = h3);
    e28.onload = e28.onreadystatechange = function() {
      e28.readyState && e28.readyState != "loaded" && e28.readyState != "complete" || (Ci2(e28, b3.wd || false, h3), si2(g3), ti2(g3, true, null));
    };
    e28.onerror = function() {
      Ci2(e28, true, h3);
      var p3 = new Di2(Fi2, "Error while loading script " + d3);
      si2(g3);
      ti2(g3, false, p3);
    };
    f3 = b3.attributes || {};
    z3(f3, { type: "text/javascript", charset: "UTF-8" });
    lc2(e28, f3);
    Ob2(e28, a3);
    Gi2(c3).appendChild(e28);
    return g3;
  }
  function Gi2(a3) {
    var b3;
    return (b3 = (a3 || document).getElementsByTagName("HEAD")) && b3.length != 0 ? b3[0] : a3.documentElement;
  }
  function qi2() {
    if (this && this.Vb) {
      var a3 = this.Vb;
      a3 && a3.tagName == "SCRIPT" && Ci2(a3, true, this.Ma);
    }
  }
  function Ci2(a3, b3, c3) {
    c3 != null && l3.clearTimeout(c3);
    a3.onload = la2;
    a3.onerror = la2;
    a3.onreadystatechange = la2;
    b3 && window.setTimeout(function() {
      a3 && a3.parentNode && a3.parentNode.removeChild(a3);
    }, 0);
  }
  var Fi2 = 0, Ei2 = 1;
  function Di2(a3, b3) {
    var c3 = "Jsloader error (code #" + a3 + ")";
    b3 && (c3 += ": " + b3);
    u3.call(this, c3);
    this.code = a3;
  }
  r3(Di2, u3);
  function Hi2(a3) {
    this.f = a3;
  }
  r3(Hi2, Ah);
  Hi2.prototype.a = function() {
    return new this.f();
  };
  Hi2.prototype.b = function() {
    return {};
  };
  function Ii2(a3, b3, c3) {
    this.c = a3;
    a3 = b3 || {};
    this.l = a3.secureTokenEndpoint || "https://securetoken.googleapis.com/v1/token";
    this.v = a3.secureTokenTimeout || Ji2;
    this.g = nb2(a3.secureTokenHeaders || Ki2);
    this.i = a3.firebaseEndpoint || "https://www.googleapis.com/identitytoolkit/v3/relyingparty/";
    this.h = a3.identityPlatformEndpoint || "https://identitytoolkit.googleapis.com/v2/";
    this.m = a3.firebaseTimeout || Li2;
    this.a = nb2(a3.firebaseHeaders || Mi2);
    c3 && (this.a["X-Client-Version"] = c3, this.g["X-Client-Version"] = c3);
    c3 = Ke2() == "Node";
    c3 = l3.XMLHttpRequest || c3 && firebase$1.INTERNAL.node && firebase$1.INTERNAL.node.XMLHttpRequest;
    if (!c3 && !Je2())
      throw new t3("internal-error", "The XMLHttpRequest compatibility library was not found.");
    this.f = void 0;
    Je2() ? this.f = new Vh2(self) : Le2() ? this.f = new Hi2(c3) : this.f = new Fh();
    this.b = null;
  }
  var Ni2, Dg = "idToken", Ji2 = new Ze2(3e4, 6e4), Ki2 = { "Content-Type": "application/x-www-form-urlencoded" }, Li2 = new Ze2(3e4, 6e4), Mi2 = { "Content-Type": "application/json" };
  function Oi2(a3, b3) {
    b3 ? a3.a["X-Firebase-Locale"] = b3 : delete a3.a["X-Firebase-Locale"];
  }
  function Pi2(a3, b3) {
    b3 && (a3.l = Qi2("https://securetoken.googleapis.com/v1/token", b3), a3.i = Qi2("https://www.googleapis.com/identitytoolkit/v3/relyingparty/", b3), a3.h = Qi2("https://identitytoolkit.googleapis.com/v2/", b3));
  }
  function Qi2(a3, b3) {
    a3 = be2(a3);
    b3 = be2(b3.url);
    a3.c = a3.a + a3.c;
    Od2(a3, b3.f);
    a3.a = b3.a;
    Pd2(a3, b3.g);
    return a3.toString();
  }
  function Ri2(a3, b3) {
    b3 ? (a3.a["X-Client-Version"] = b3, a3.g["X-Client-Version"] = b3) : (delete a3.a["X-Client-Version"], delete a3.g["X-Client-Version"]);
  }
  Ii2.prototype.S = function() {
    return this.b;
  };
  function Si2(a3, b3, c3, d3, e28, f3, g3) {
    ue2() || Je2() ? a3 = q3(a3.u, a3) : (Ni2 || (Ni2 = new D3(function(h3, n3) {
      Ti2(h3, n3);
    })), a3 = q3(a3.s, a3));
    a3(b3, c3, d3, e28, f3, g3);
  }
  Ii2.prototype.u = function(a3, b3, c3, d3, e28, f3) {
    if (Je2() && (typeof l3.fetch === "undefined" || typeof l3.Headers === "undefined" || typeof l3.Request === "undefined"))
      throw new t3("operation-not-supported-in-this-environment", "fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");
    var g3 = new ai2(this.f);
    if (f3) {
      g3.g = Math.max(0, f3);
      var h3 = setTimeout(function() {
        g3.dispatchEvent("timeout");
      }, f3);
    }
    qd2(g3, "complete", function() {
      h3 && clearTimeout(h3);
      var n3 = null;
      try {
        n3 = JSON.parse(oi2(this)) || null;
      } catch (p3) {
        n3 = null;
      }
      b3 && b3(n3);
    });
    wd2(g3, "ready", function() {
      h3 && clearTimeout(h3);
      Xc2(this);
    });
    wd2(g3, "timeout", function() {
      h3 && clearTimeout(h3);
      Xc2(this);
      b3 && b3(null);
    });
    ei2(g3, a3, c3, d3, e28);
  };
  var Ui2 = new qb2(rb2, "https://apis.google.com/js/client.js?onload=%{onload}"), Vi2 = "__fcb" + Math.floor(1e6 * Math.random()).toString();
  function Ti2(a3, b3) {
    if (((window.gapi || {}).client || {}).request)
      a3();
    else {
      l3[Vi2] = function() {
        ((window.gapi || {}).client || {}).request ? a3() : b3(Error("CORS_UNSUPPORTED"));
      };
      var c3 = zb2(Ui2, { onload: Vi2 });
      wi2(Bi2(c3), function() {
        b3(Error("CORS_UNSUPPORTED"));
      });
    }
  }
  Ii2.prototype.s = function(a3, b3, c3, d3, e28) {
    var f3 = this;
    Ni2.then(function() {
      window.gapi.client.setApiKey(f3.c);
      var g3 = window.gapi.auth.getToken();
      window.gapi.auth.setToken(null);
      window.gapi.client.request({ path: a3, method: c3, body: d3, headers: e28, authType: "none", callback: function(h3) {
        window.gapi.auth.setToken(g3);
        b3 && b3(h3);
      } });
    }).o(function(g3) {
      b3 && b3({ error: { message: g3 && g3.message || "CORS_UNSUPPORTED" } });
    });
  };
  function Wi2(a3, b3) {
    return new D3(function(c3, d3) {
      b3.grant_type == "refresh_token" && b3.refresh_token || b3.grant_type == "authorization_code" && b3.code ? Si2(a3, a3.l + "?key=" + encodeURIComponent(a3.c), function(e28) {
        e28 ? e28.error ? d3(Xi2(e28)) : e28.access_token && e28.refresh_token ? c3(e28) : d3(new t3("internal-error")) : d3(new t3("network-request-failed"));
      }, "POST", fe2(b3).toString(), a3.g, a3.v.get()) : d3(new t3("internal-error"));
    });
  }
  function Yi2(a3, b3, c3, d3, e28, f3, g3) {
    var h3 = be2(b3 + c3);
    J3(h3, "key", a3.c);
    g3 && J3(h3, "cb", va2().toString());
    var n3 = d3 == "GET";
    if (n3)
      for (var p3 in e28)
        e28.hasOwnProperty(p3) && J3(h3, p3, e28[p3]);
    return new D3(function(v3, B3) {
      Si2(a3, h3.toString(), function(A3) {
        A3 ? A3.error ? B3(Xi2(A3, f3 || {})) : v3(A3) : B3(new t3("network-request-failed"));
      }, d3, n3 ? void 0 : ke2(Ve2(e28)), a3.a, a3.m.get());
    });
  }
  function Zi2(a3) {
    a3 = a3.email;
    if (typeof a3 !== "string" || !De2.test(a3))
      throw new t3("invalid-email");
  }
  function $i2(a3) {
    "email" in a3 && Zi2(a3);
  }
  function aj2(a3, b3) {
    return O3(a3, bj2, { identifier: b3, continueUri: Se2() ? re2() : "http://localhost" }).then(function(c3) {
      return c3.signinMethods || [];
    });
  }
  function cj2(a3) {
    return O3(a3, dj2, {}).then(function(b3) {
      return b3.authorizedDomains || [];
    });
  }
  function P3(a3) {
    if (!a3[Dg]) {
      if (a3.mfaPendingCredential)
        throw new t3("multi-factor-auth-required", null, nb2(a3));
      throw new t3("internal-error");
    }
  }
  function ej2(a3) {
    if (a3.phoneNumber || a3.temporaryProof) {
      if (!a3.phoneNumber || !a3.temporaryProof)
        throw new t3("internal-error");
    } else {
      if (!a3.sessionInfo)
        throw new t3("missing-verification-id");
      if (!a3.code)
        throw new t3("missing-verification-code");
    }
  }
  Ii2.prototype.yb = function() {
    return O3(this, fj2, {});
  };
  Ii2.prototype.Ab = function(a3, b3) {
    return O3(this, gj2, { idToken: a3, email: b3 });
  };
  Ii2.prototype.Bb = function(a3, b3) {
    return O3(this, ch, { idToken: a3, password: b3 });
  };
  var hj2 = { displayName: "DISPLAY_NAME", photoUrl: "PHOTO_URL" };
  k3 = Ii2.prototype;
  k3.Cb = function(a3, b3) {
    var c3 = { idToken: a3 }, d3 = [];
    lb2(hj2, function(e28, f3) {
      var g3 = b3[f3];
      g3 === null ? d3.push(e28) : f3 in b3 && (c3[f3] = g3);
    });
    d3.length && (c3.deleteAttribute = d3);
    return O3(this, gj2, c3);
  };
  k3.ub = function(a3, b3) {
    a3 = { requestType: "PASSWORD_RESET", email: a3 };
    z3(a3, b3);
    return O3(this, ij2, a3);
  };
  k3.vb = function(a3, b3) {
    a3 = { requestType: "EMAIL_SIGNIN", email: a3 };
    z3(a3, b3);
    return O3(this, jj2, a3);
  };
  k3.tb = function(a3, b3) {
    a3 = { requestType: "VERIFY_EMAIL", idToken: a3 };
    z3(a3, b3);
    return O3(this, kj2, a3);
  };
  k3.Db = function(a3, b3, c3) {
    a3 = { requestType: "VERIFY_AND_CHANGE_EMAIL", idToken: a3, newEmail: b3 };
    z3(a3, c3);
    return O3(this, lj2, a3);
  };
  function oh(a3, b3) {
    return O3(a3, mj2, b3);
  }
  k3.eb = function(a3) {
    return O3(this, nj2, a3);
  };
  function mh(a3, b3) {
    return O3(a3, oj2, b3).then(function(c3) {
      return c3.phoneSessionInfo.sessionInfo;
    });
  }
  function pj2(a3) {
    if (!a3.phoneVerificationInfo)
      throw new t3("internal-error");
    if (!a3.phoneVerificationInfo.sessionInfo)
      throw new t3("missing-verification-id");
    if (!a3.phoneVerificationInfo.code)
      throw new t3("missing-verification-code");
  }
  function nh(a3, b3) {
    return O3(a3, qj2, b3).then(function(c3) {
      return c3.phoneResponseInfo.sessionInfo;
    });
  }
  function rj2(a3, b3, c3) {
    return O3(a3, sj2, { idToken: b3, deleteProvider: c3 });
  }
  function tj2(a3) {
    if (!a3.requestUri || !a3.sessionId && !a3.postBody && !a3.pendingToken)
      throw new t3("internal-error");
  }
  function uj2(a3, b3) {
    b3.oauthIdToken && b3.providerId && b3.providerId.indexOf("oidc.") == 0 && !b3.pendingToken && (a3.sessionId ? b3.nonce = a3.sessionId : a3.postBody && (a3 = new Td2(a3.postBody), je2(a3, "nonce") && (b3.nonce = a3.get("nonce"))));
    return b3;
  }
  function vj2(a3) {
    var b3 = null;
    a3.needConfirmation ? (a3.code = "account-exists-with-different-credential", b3 = zh2(a3)) : a3.errorMessage == "FEDERATED_USER_ID_ALREADY_LINKED" ? (a3.code = "credential-already-in-use", b3 = zh2(a3)) : a3.errorMessage == "EMAIL_EXISTS" ? (a3.code = "email-already-in-use", b3 = zh2(a3)) : a3.errorMessage && (b3 = wj2(a3.errorMessage));
    if (b3)
      throw b3;
    P3(a3);
  }
  function Fg(a3, b3) {
    b3.returnIdpCredential = true;
    return O3(a3, xj2, b3);
  }
  function Hg(a3, b3) {
    b3.returnIdpCredential = true;
    return O3(a3, yj2, b3);
  }
  function Ig(a3, b3) {
    b3.returnIdpCredential = true;
    b3.autoCreate = false;
    return O3(a3, zj2, b3);
  }
  function Aj2(a3) {
    if (!a3.oobCode)
      throw new t3("invalid-action-code");
  }
  k3.mb = function(a3, b3) {
    return O3(this, Bj2, { oobCode: a3, newPassword: b3 });
  };
  k3.Qa = function(a3) {
    return O3(this, Cj2, { oobCode: a3 });
  };
  k3.ib = function(a3) {
    return O3(this, Dj2, { oobCode: a3 });
  };
  var Dj2 = { endpoint: "setAccountInfo", B: Aj2, Z: "email", C: true }, Cj2 = { endpoint: "resetPassword", B: Aj2, F: function(a3) {
    var b3 = a3.requestType;
    if (!b3 || !a3.email && b3 != "EMAIL_SIGNIN" && b3 != "VERIFY_AND_CHANGE_EMAIL")
      throw new t3("internal-error");
  }, C: true }, Ej2 = { endpoint: "signupNewUser", B: function(a3) {
    Zi2(a3);
    if (!a3.password)
      throw new t3("weak-password");
  }, F: P3, U: true, C: true }, bj2 = { endpoint: "createAuthUri", C: true }, Fj2 = { endpoint: "deleteAccount", M: ["idToken"] }, sj2 = { endpoint: "setAccountInfo", M: ["idToken", "deleteProvider"], B: function(a3) {
    if (!Array.isArray(a3.deleteProvider))
      throw new t3("internal-error");
  } }, $g = { endpoint: "emailLinkSignin", M: ["email", "oobCode"], B: Zi2, F: P3, U: true, C: true }, bh = { endpoint: "emailLinkSignin", M: ["idToken", "email", "oobCode"], B: Zi2, F: P3, U: true }, Gj2 = { endpoint: "accounts/mfaEnrollment:finalize", M: ["idToken", "phoneVerificationInfo"], B: pj2, F: P3, C: true, Na: true }, Hj2 = { endpoint: "accounts/mfaSignIn:finalize", M: ["mfaPendingCredential", "phoneVerificationInfo"], B: pj2, F: P3, C: true, Na: true }, Ij2 = { endpoint: "getAccountInfo" }, jj2 = { endpoint: "getOobConfirmationCode", M: ["requestType"], B: function(a3) {
    if (a3.requestType != "EMAIL_SIGNIN")
      throw new t3("internal-error");
    Zi2(a3);
  }, Z: "email", C: true }, kj2 = { endpoint: "getOobConfirmationCode", M: ["idToken", "requestType"], B: function(a3) {
    if (a3.requestType != "VERIFY_EMAIL")
      throw new t3("internal-error");
  }, Z: "email", C: true }, lj2 = { endpoint: "getOobConfirmationCode", M: ["idToken", "newEmail", "requestType"], B: function(a3) {
    if (a3.requestType != "VERIFY_AND_CHANGE_EMAIL")
      throw new t3("internal-error");
  }, Z: "email", C: true }, ij2 = { endpoint: "getOobConfirmationCode", M: ["requestType"], B: function(a3) {
    if (a3.requestType != "PASSWORD_RESET")
      throw new t3("internal-error");
    Zi2(a3);
  }, Z: "email", C: true }, dj2 = { kb: true, endpoint: "getProjectConfig", Tb: "GET" }, Jj2 = { kb: true, endpoint: "getRecaptchaParam", Tb: "GET", F: function(a3) {
    if (!a3.recaptchaSiteKey)
      throw new t3("internal-error");
  } }, Bj2 = { endpoint: "resetPassword", B: Aj2, Z: "email", C: true }, mj2 = { endpoint: "sendVerificationCode", M: ["phoneNumber", "recaptchaToken"], Z: "sessionInfo", C: true }, gj2 = { endpoint: "setAccountInfo", M: ["idToken"], B: $i2, U: true }, ch = {
    endpoint: "setAccountInfo",
    M: ["idToken"],
    B: function(a3) {
      $i2(a3);
      if (!a3.password)
        throw new t3("weak-password");
    },
    F: P3,
    U: true
  }, fj2 = { endpoint: "signupNewUser", F: P3, U: true, C: true }, oj2 = { endpoint: "accounts/mfaEnrollment:start", M: ["idToken", "phoneEnrollmentInfo"], B: function(a3) {
    if (!a3.phoneEnrollmentInfo)
      throw new t3("internal-error");
    if (!a3.phoneEnrollmentInfo.phoneNumber)
      throw new t3("missing-phone-number");
    if (!a3.phoneEnrollmentInfo.recaptchaToken)
      throw new t3("missing-app-credential");
  }, F: function(a3) {
    if (!a3.phoneSessionInfo || !a3.phoneSessionInfo.sessionInfo)
      throw new t3("internal-error");
  }, C: true, Na: true }, qj2 = {
    endpoint: "accounts/mfaSignIn:start",
    M: ["mfaPendingCredential", "mfaEnrollmentId", "phoneSignInInfo"],
    B: function(a3) {
      if (!a3.phoneSignInInfo || !a3.phoneSignInInfo.recaptchaToken)
        throw new t3("missing-app-credential");
    },
    F: function(a3) {
      if (!a3.phoneResponseInfo || !a3.phoneResponseInfo.sessionInfo)
        throw new t3("internal-error");
    },
    C: true,
    Na: true
  }, xj2 = { endpoint: "verifyAssertion", B: tj2, Xa: uj2, F: vj2, U: true, C: true }, zj2 = { endpoint: "verifyAssertion", B: tj2, Xa: uj2, F: function(a3) {
    if (a3.errorMessage && a3.errorMessage == "USER_NOT_FOUND")
      throw new t3("user-not-found");
    if (a3.errorMessage)
      throw wj2(a3.errorMessage);
    P3(a3);
  }, U: true, C: true }, yj2 = { endpoint: "verifyAssertion", B: function(a3) {
    tj2(a3);
    if (!a3.idToken)
      throw new t3("internal-error");
  }, Xa: uj2, F: vj2, U: true }, Kj2 = { endpoint: "verifyCustomToken", B: function(a3) {
    if (!a3.token)
      throw new t3("invalid-custom-token");
  }, F: P3, U: true, C: true }, ah = { endpoint: "verifyPassword", B: function(a3) {
    Zi2(a3);
    if (!a3.password)
      throw new t3("wrong-password");
  }, F: P3, U: true, C: true }, nj2 = { endpoint: "verifyPhoneNumber", B: ej2, F: P3, C: true }, ih = {
    endpoint: "verifyPhoneNumber",
    B: function(a3) {
      if (!a3.idToken)
        throw new t3("internal-error");
      ej2(a3);
    },
    F: function(a3) {
      if (a3.temporaryProof)
        throw a3.code = "credential-already-in-use", zh2(a3);
      P3(a3);
    }
  }, jh2 = { Gb: { USER_NOT_FOUND: "user-not-found" }, endpoint: "verifyPhoneNumber", B: ej2, F: P3, C: true }, Lj2 = { endpoint: "accounts/mfaEnrollment:withdraw", M: ["idToken", "mfaEnrollmentId"], F: function(a3) {
    if (!!a3[Dg] ^ !!a3.refreshToken)
      throw new t3("internal-error");
  }, C: true, Na: true };
  function O3(a3, b3, c3) {
    if (!mf2(c3, b3.M))
      return F3(new t3("internal-error"));
    var d3 = !!b3.Na, e28 = b3.Tb || "POST", f3;
    return E3(c3).then(b3.B).then(function() {
      b3.U && (c3.returnSecureToken = true);
      b3.C && a3.b && typeof c3.tenantId === "undefined" && (c3.tenantId = a3.b);
      return d3 ? Yi2(a3, a3.h, b3.endpoint, e28, c3, b3.Gb, b3.kb || false) : Yi2(a3, a3.i, b3.endpoint, e28, c3, b3.Gb, b3.kb || false);
    }).then(function(g3) {
      f3 = g3;
      return b3.Xa ? b3.Xa(c3, f3) : f3;
    }).then(b3.F).then(function() {
      if (!b3.Z)
        return f3;
      if (!(b3.Z in f3))
        throw new t3("internal-error");
      return f3[b3.Z];
    });
  }
  function wj2(a3) {
    return Xi2({ error: { errors: [{ message: a3 }], code: 400, message: a3 } });
  }
  function Xi2(a3, b3) {
    var c3 = (a3.error && a3.error.errors && a3.error.errors[0] || {}).reason || "";
    var d3 = { keyInvalid: "invalid-api-key", ipRefererBlocked: "app-not-authorized" };
    if (c3 = d3[c3] ? new t3(d3[c3]) : null)
      return c3;
    c3 = a3.error && a3.error.message || "";
    d3 = {
      INVALID_CUSTOM_TOKEN: "invalid-custom-token",
      CREDENTIAL_MISMATCH: "custom-token-mismatch",
      MISSING_CUSTOM_TOKEN: "internal-error",
      INVALID_IDENTIFIER: "invalid-email",
      MISSING_CONTINUE_URI: "internal-error",
      INVALID_EMAIL: "invalid-email",
      INVALID_PASSWORD: "wrong-password",
      USER_DISABLED: "user-disabled",
      MISSING_PASSWORD: "internal-error",
      EMAIL_EXISTS: "email-already-in-use",
      PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
      INVALID_IDP_RESPONSE: "invalid-credential",
      INVALID_PENDING_TOKEN: "invalid-credential",
      FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
      MISSING_OR_INVALID_NONCE: "missing-or-invalid-nonce",
      INVALID_MESSAGE_PAYLOAD: "invalid-message-payload",
      INVALID_RECIPIENT_EMAIL: "invalid-recipient-email",
      INVALID_SENDER: "invalid-sender",
      EMAIL_NOT_FOUND: "user-not-found",
      RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
      EXPIRED_OOB_CODE: "expired-action-code",
      INVALID_OOB_CODE: "invalid-action-code",
      MISSING_OOB_CODE: "internal-error",
      INVALID_PROVIDER_ID: "invalid-provider-id",
      CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
      INVALID_ID_TOKEN: "invalid-user-token",
      TOKEN_EXPIRED: "user-token-expired",
      USER_NOT_FOUND: "user-token-expired",
      CORS_UNSUPPORTED: "cors-unsupported",
      DYNAMIC_LINK_NOT_ACTIVATED: "dynamic-link-not-activated",
      INVALID_APP_ID: "invalid-app-id",
      TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
      WEAK_PASSWORD: "weak-password",
      OPERATION_NOT_ALLOWED: "operation-not-allowed",
      USER_CANCELLED: "user-cancelled",
      CAPTCHA_CHECK_FAILED: "captcha-check-failed",
      INVALID_APP_CREDENTIAL: "invalid-app-credential",
      INVALID_CODE: "invalid-verification-code",
      INVALID_PHONE_NUMBER: "invalid-phone-number",
      INVALID_SESSION_INFO: "invalid-verification-id",
      INVALID_TEMPORARY_PROOF: "invalid-credential",
      MISSING_APP_CREDENTIAL: "missing-app-credential",
      MISSING_CODE: "missing-verification-code",
      MISSING_PHONE_NUMBER: "missing-phone-number",
      MISSING_SESSION_INFO: "missing-verification-id",
      QUOTA_EXCEEDED: "quota-exceeded",
      SESSION_EXPIRED: "code-expired",
      REJECTED_CREDENTIAL: "rejected-credential",
      INVALID_CONTINUE_URI: "invalid-continue-uri",
      MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
      MISSING_IOS_BUNDLE_ID: "missing-ios-bundle-id",
      UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
      INVALID_DYNAMIC_LINK_DOMAIN: "invalid-dynamic-link-domain",
      INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
      INVALID_CERT_HASH: "invalid-cert-hash",
      UNSUPPORTED_TENANT_OPERATION: "unsupported-tenant-operation",
      INVALID_TENANT_ID: "invalid-tenant-id",
      TENANT_ID_MISMATCH: "tenant-id-mismatch",
      ADMIN_ONLY_OPERATION: "admin-restricted-operation",
      INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
      MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
      MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
      MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
      EMAIL_CHANGE_NEEDS_VERIFICATION: "email-change-needs-verification",
      SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
      SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
      UNSUPPORTED_FIRST_FACTOR: "unsupported-first-factor",
      UNVERIFIED_EMAIL: "unverified-email"
    };
    z3(d3, b3 || {});
    b3 = (b3 = c3.match(/^[^\s]+\s*:\s*([\s\S]*)$/)) && 1 < b3.length ? b3[1] : void 0;
    for (var e28 in d3)
      if (c3.indexOf(e28) === 0)
        return new t3(d3[e28], b3);
    !b3 && a3 && (b3 = Ue2(a3));
    return new t3("internal-error", b3);
  }
  function Mj2(a3) {
    this.b = a3;
    this.a = null;
    this.qb = Nj2(this);
  }
  function Nj2(a3) {
    return Oj2().then(function() {
      return new D3(function(b3, c3) {
        L3("gapi.iframes.getContext")().open({ where: document.body, url: a3.b, messageHandlersFilter: L3("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"), attributes: { style: { position: "absolute", top: "-100px", width: "1px", height: "1px" } }, dontclear: true }, function(d3) {
          function e28() {
            clearTimeout(f3);
            b3();
          }
          a3.a = d3;
          a3.a.restyle({ setHideOnLeave: false });
          var f3 = setTimeout(function() {
            c3(Error("Network Error"));
          }, Pj2.get());
          d3.ping(e28).then(e28, function() {
            c3(Error("Network Error"));
          });
        });
      });
    });
  }
  function Qj2(a3, b3) {
    return a3.qb.then(function() {
      return new D3(function(c3) {
        a3.a.send(b3.type, b3, c3, L3("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
      });
    });
  }
  function Rj2(a3, b3) {
    a3.qb.then(function() {
      a3.a.register("authEvent", b3, L3("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
    });
  }
  var Sj2 = new qb2(rb2, "https://apis.google.com/js/api.js?onload=%{onload}"), Tj2 = new Ze2(3e4, 6e4), Pj2 = new Ze2(5e3, 15e3), Uj2 = null;
  function Oj2() {
    return Uj2 ? Uj2 : Uj2 = new D3(function(a3, b3) {
      function c3() {
        Ye2();
        L3("gapi.load")("gapi.iframes", { callback: a3, ontimeout: function() {
          Ye2();
          b3(Error("Network Error"));
        }, timeout: Tj2.get() });
      }
      if (L3("gapi.iframes.Iframe"))
        a3();
      else if (L3("gapi.load"))
        c3();
      else {
        var d3 = "__iframefcb" + Math.floor(1e6 * Math.random()).toString();
        l3[d3] = function() {
          L3("gapi.load") ? c3() : b3(Error("Network Error"));
        };
        d3 = zb2(Sj2, { onload: d3 });
        E3(Bi2(d3)).o(function() {
          b3(Error("Network Error"));
        });
      }
    }).o(function(a3) {
      Uj2 = null;
      throw a3;
    });
  }
  function Vj2(a3, b3, c3, d3) {
    this.l = a3;
    this.i = b3;
    this.h = c3;
    this.g = d3;
    this.f = null;
    this.g ? (a3 = be2(this.g.url), a3 = ce2(a3.f, a3.a, a3.g, "/emulator/auth/iframe")) : a3 = ce2("https", this.l, null, "/__/auth/iframe");
    this.a = a3;
    J3(this.a, "apiKey", this.i);
    J3(this.a, "appName", this.h);
    this.b = null;
    this.c = [];
  }
  Vj2.prototype.toString = function() {
    this.f ? J3(this.a, "v", this.f) : ie2(this.a.b, "v");
    this.b ? J3(this.a, "eid", this.b) : ie2(this.a.b, "eid");
    this.c.length ? J3(this.a, "fw", this.c.join(",")) : ie2(this.a.b, "fw");
    return this.a.toString();
  };
  function Wj2(a3, b3, c3, d3, e28, f3) {
    this.u = a3;
    this.s = b3;
    this.c = c3;
    this.v = d3;
    this.m = f3;
    this.h = this.g = this.l = null;
    this.a = e28;
    this.i = this.f = null;
  }
  Wj2.prototype.xb = function(a3) {
    this.i = a3;
    return this;
  };
  Wj2.prototype.toString = function() {
    if (this.m) {
      var a3 = be2(this.m.url);
      a3 = ce2(a3.f, a3.a, a3.g, "/emulator/auth/handler");
    } else
      a3 = ce2("https", this.u, null, "/__/auth/handler");
    J3(a3, "apiKey", this.s);
    J3(a3, "appName", this.c);
    J3(a3, "authType", this.v);
    if (this.a.isOAuthProvider) {
      var b3 = this.a;
      try {
        var c3 = firebase$1.app(this.c).auth().ka();
      } catch (h3) {
        c3 = null;
      }
      b3.nb = c3;
      J3(a3, "providerId", this.a.providerId);
      c3 = this.a;
      b3 = Ve2(c3.Hb);
      for (var d3 in b3)
        b3[d3] = b3[d3].toString();
      d3 = c3.Pc;
      b3 = nb2(b3);
      for (var e28 = 0; e28 < d3.length; e28++) {
        var f3 = d3[e28];
        f3 in b3 && delete b3[f3];
      }
      c3.ob && c3.nb && !b3[c3.ob] && (b3[c3.ob] = c3.nb);
      mb2(b3) || J3(a3, "customParameters", Ue2(b3));
    }
    typeof this.a.Pb === "function" && (c3 = this.a.Pb(), c3.length && J3(a3, "scopes", c3.join(",")));
    this.l ? J3(a3, "redirectUrl", this.l) : ie2(a3.b, "redirectUrl");
    this.g ? J3(a3, "eventId", this.g) : ie2(a3.b, "eventId");
    this.h ? J3(a3, "v", this.h) : ie2(a3.b, "v");
    if (this.b)
      for (var g3 in this.b)
        this.b.hasOwnProperty(g3) && !ae2(a3, g3) && J3(a3, g3, this.b[g3]);
    this.i ? J3(a3, "tid", this.i) : ie2(a3.b, "tid");
    this.f ? J3(a3, "eid", this.f) : ie2(a3.b, "eid");
    g3 = Xj2(this.c);
    g3.length && J3(a3, "fw", g3.join(","));
    return a3.toString();
  };
  function Xj2(a3) {
    try {
      return firebase$1.app(a3).auth().Ga();
    } catch (b3) {
      return [];
    }
  }
  function Yj2(a3, b3, c3, d3, e28, f3) {
    this.s = a3;
    this.g = b3;
    this.b = c3;
    this.f = f3;
    this.c = d3 || null;
    this.h = e28 || null;
    this.l = this.u = this.A = null;
    this.i = [];
    this.v = this.a = null;
  }
  function Zj2(a3) {
    var b3 = re2();
    return cj2(a3).then(function(c3) {
      a: {
        var d3 = be2(b3), e28 = d3.f;
        d3 = d3.a;
        for (var f3 = 0; f3 < c3.length; f3++) {
          var g3 = c3[f3];
          var h3 = d3;
          var n3 = e28;
          g3.indexOf("chrome-extension://") == 0 ? h3 = be2(g3).a == h3 && n3 == "chrome-extension" : n3 != "http" && n3 != "https" ? h3 = false : Ce2.test(g3) ? h3 = h3 == g3 : (g3 = g3.split(".").join("\\."), h3 = new RegExp("^(.+\\." + g3 + "|" + g3 + ")$", "i").test(h3));
          if (h3) {
            c3 = true;
            break a;
          }
        }
        c3 = false;
      }
      if (!c3)
        throw new xh(re2());
    });
  }
  function ak2(a3) {
    if (a3.v)
      return a3.v;
    a3.v = Ee2().then(function() {
      if (!a3.u) {
        var b3 = a3.c, c3 = a3.h, d3 = Xj2(a3.b), e28 = new Vj2(a3.s, a3.g, a3.b, a3.f);
        e28.f = b3;
        e28.b = c3;
        e28.c = Za2(d3 || []);
        a3.u = e28.toString();
      }
      a3.m = new Mj2(a3.u);
      bk2(a3);
    });
    return a3.v;
  }
  k3 = Yj2.prototype;
  k3.Nb = function(a3, b3, c3) {
    var d3 = new t3("popup-closed-by-user"), e28 = new t3("web-storage-unsupported"), f3 = this, g3 = false;
    return this.la().then(function() {
      ck2(f3).then(function(h3) {
        h3 || (a3 && ye2(a3), b3(e28), g3 = true);
      });
    }).o(function() {
    }).then(function() {
      if (!g3)
        return Be2(a3);
    }).then(function() {
      if (!g3)
        return Ed2(c3).then(function() {
          b3(d3);
        });
    });
  };
  k3.Wb = function() {
    var a3 = K3();
    return !Te2(a3) && !Xe2(a3);
  };
  k3.Sb = function() {
    return false;
  };
  k3.Lb = function(a3, b3, c3, d3, e28, f3, g3, h3) {
    if (!a3)
      return F3(new t3("popup-blocked"));
    if (g3 && !Te2())
      return this.la().o(function(p3) {
        ye2(a3);
        e28(p3);
      }), d3(), E3();
    this.a || (this.a = Zj2(dk2(this)));
    var n3 = this;
    return this.a.then(function() {
      var p3 = n3.la().o(function(v3) {
        ye2(a3);
        e28(v3);
        throw v3;
      });
      d3();
      return p3;
    }).then(function() {
      rh(c3);
      if (!g3) {
        var p3 = ek2(n3.s, n3.g, n3.b, b3, c3, null, f3, n3.c, void 0, n3.h, h3, n3.f);
        se2(p3, a3);
      }
    }).o(function(p3) {
      p3.code == "auth/network-request-failed" && (n3.a = null);
      throw p3;
    });
  };
  function dk2(a3) {
    a3.l || (a3.A = a3.c ? Oe2(a3.c, Xj2(a3.b)) : null, a3.l = new Ii2(a3.g, Ca2(a3.h), a3.A), a3.f && Pi2(a3.l, a3.f));
    return a3.l;
  }
  k3.Mb = function(a3, b3, c3, d3) {
    this.a || (this.a = Zj2(dk2(this)));
    var e28 = this;
    return this.a.then(function() {
      rh(b3);
      var f3 = ek2(e28.s, e28.g, e28.b, a3, b3, re2(), c3, e28.c, void 0, e28.h, d3, e28.f);
      se2(f3);
    }).o(function(f3) {
      f3.code == "auth/network-request-failed" && (e28.a = null);
      throw f3;
    });
  };
  k3.la = function() {
    var a3 = this;
    return ak2(this).then(function() {
      return a3.m.qb;
    }).o(function() {
      a3.a = null;
      throw new t3("network-request-failed");
    });
  };
  k3.Zb = function() {
    return true;
  };
  function ek2(a3, b3, c3, d3, e28, f3, g3, h3, n3, p3, v3, B3) {
    a3 = new Wj2(a3, b3, c3, d3, e28, B3);
    a3.l = f3;
    a3.g = g3;
    a3.h = h3;
    a3.b = nb2(n3 || null);
    a3.f = p3;
    return a3.xb(v3).toString();
  }
  function bk2(a3) {
    if (!a3.m)
      throw Error("IfcHandler must be initialized!");
    Rj2(a3.m, function(b3) {
      var c3 = {};
      if (b3 && b3.authEvent) {
        var d3 = false;
        b3 = th(b3.authEvent);
        for (c3 = 0; c3 < a3.i.length; c3++)
          d3 = a3.i[c3](b3) || d3;
        c3 = {};
        c3.status = d3 ? "ACK" : "ERROR";
        return E3(c3);
      }
      c3.status = "ERROR";
      return E3(c3);
    });
  }
  function ck2(a3) {
    var b3 = { type: "webStorageSupport" };
    return ak2(a3).then(function() {
      return Qj2(a3.m, b3);
    }).then(function(c3) {
      if (c3 && c3.length && typeof c3[0].webStorageSupport !== "undefined")
        return c3[0].webStorageSupport;
      throw Error();
    });
  }
  k3.Ea = function(a3) {
    this.i.push(a3);
  };
  k3.Ra = function(a3) {
    Xa2(this.i, function(b3) {
      return b3 == a3;
    });
  };
  function fk2(a3) {
    this.a = a3 || firebase$1.INTERNAL.reactNative && firebase$1.INTERNAL.reactNative.AsyncStorage;
    if (!this.a)
      throw new t3("internal-error", "The React Native compatibility library was not found.");
    this.type = "asyncStorage";
  }
  k3 = fk2.prototype;
  k3.get = function(a3) {
    return E3(this.a.getItem(a3)).then(function(b3) {
      return b3 && We2(b3);
    });
  };
  k3.set = function(a3, b3) {
    return E3(this.a.setItem(a3, Ue2(b3)));
  };
  k3.T = function(a3) {
    return E3(this.a.removeItem(a3));
  };
  k3.ca = function() {
  };
  k3.ia = function() {
  };
  function gk2(a3) {
    this.b = a3;
    this.a = {};
    this.f = q3(this.c, this);
  }
  var hk2 = [];
  function ik2() {
    var a3 = Je2() ? self : null;
    w3(hk2, function(c3) {
      c3.b == a3 && (b3 = c3);
    });
    if (!b3) {
      var b3 = new gk2(a3);
      hk2.push(b3);
    }
    return b3;
  }
  gk2.prototype.c = function(a3) {
    var b3 = a3.data.eventType, c3 = a3.data.eventId, d3 = this.a[b3];
    if (d3 && 0 < d3.length) {
      a3.ports[0].postMessage({ status: "ack", eventId: c3, eventType: b3, response: null });
      var e28 = [];
      w3(d3, function(f3) {
        e28.push(E3().then(function() {
          return f3(a3.origin, a3.data.data);
        }));
      });
      Jc2(e28).then(function(f3) {
        var g3 = [];
        w3(f3, function(h3) {
          g3.push({ fulfilled: h3.Ob, value: h3.value, reason: h3.reason ? h3.reason.message : void 0 });
        });
        w3(g3, function(h3) {
          for (var n3 in h3)
            typeof h3[n3] === "undefined" && delete h3[n3];
        });
        a3.ports[0].postMessage({
          status: "done",
          eventId: c3,
          eventType: b3,
          response: g3
        });
      });
    }
  };
  function jk2(a3, b3, c3) {
    mb2(a3.a) && a3.b.addEventListener("message", a3.f);
    typeof a3.a[b3] === "undefined" && (a3.a[b3] = []);
    a3.a[b3].push(c3);
  }
  function kk2(a3) {
    this.a = a3;
  }
  kk2.prototype.postMessage = function(a3, b3) {
    this.a.postMessage(a3, b3);
  };
  function lk2(a3) {
    this.c = a3;
    this.b = false;
    this.a = [];
  }
  function mk2(a3, b3, c3, d3) {
    var e28, f3 = c3 || {}, g3, h3, n3, p3 = null;
    if (a3.b)
      return F3(Error("connection_unavailable"));
    var v3 = d3 ? 800 : 50, B3 = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
    return new D3(function(A3, Q3) {
      B3 ? (e28 = Math.floor(Math.random() * Math.pow(10, 20)).toString(), B3.port1.start(), h3 = setTimeout(function() {
        Q3(Error("unsupported_event"));
      }, v3), g3 = function(xa2) {
        xa2.data.eventId === e28 && (xa2.data.status === "ack" ? (clearTimeout(h3), n3 = setTimeout(function() {
          Q3(Error("timeout"));
        }, 3e3)) : xa2.data.status === "done" ? (clearTimeout(n3), typeof xa2.data.response !== "undefined" ? A3(xa2.data.response) : Q3(Error("unknown_error"))) : (clearTimeout(h3), clearTimeout(n3), Q3(Error("invalid_response"))));
      }, p3 = { messageChannel: B3, onMessage: g3 }, a3.a.push(p3), B3.port1.addEventListener("message", g3), a3.c.postMessage({ eventType: b3, eventId: e28, data: f3 }, [B3.port2])) : Q3(Error("connection_unavailable"));
    }).then(function(A3) {
      nk2(a3, p3);
      return A3;
    }).o(function(A3) {
      nk2(a3, p3);
      throw A3;
    });
  }
  function nk2(a3, b3) {
    if (b3) {
      var c3 = b3.messageChannel, d3 = b3.onMessage;
      c3 && (c3.port1.removeEventListener("message", d3), c3.port1.close());
      Xa2(a3.a, function(e28) {
        return e28 == b3;
      });
    }
  }
  lk2.prototype.close = function() {
    for (; 0 < this.a.length; )
      nk2(this, this.a[0]);
    this.b = true;
  };
  function ok2() {
    if (!pk2())
      throw new t3("web-storage-unsupported");
    this.c = {};
    this.a = [];
    this.b = 0;
    this.v = l3.indexedDB;
    this.type = "indexedDB";
    this.g = this.m = this.f = this.l = null;
    this.s = false;
    this.i = null;
    var a3 = this;
    Je2() && self ? (this.m = ik2(), jk2(this.m, "keyChanged", function(b3, c3) {
      return qk2(a3).then(function(d3) {
        0 < d3.length && w3(a3.a, function(e28) {
          e28(d3);
        });
        return { keyProcessed: Va2(d3, c3.key) };
      });
    }), jk2(this.m, "ping", function() {
      return E3(["keyChanged"]);
    })) : ef2().then(function(b3) {
      if (a3.i = b3)
        a3.g = new lk2(new kk2(b3)), mk2(a3.g, "ping", null, true).then(function(c3) {
          c3[0].fulfilled && Va2(c3[0].value, "keyChanged") && (a3.s = true);
        }).o(function() {
        });
    });
  }
  var rk2;
  function sk2(a3) {
    return new D3(function(b3, c3) {
      var d3 = a3.v.deleteDatabase("firebaseLocalStorageDb");
      d3.onsuccess = function() {
        b3();
      };
      d3.onerror = function(e28) {
        c3(Error(e28.target.error));
      };
    });
  }
  function tk2(a3) {
    return new D3(function(b3, c3) {
      var d3 = a3.v.open("firebaseLocalStorageDb", 1);
      d3.onerror = function(e28) {
        try {
          e28.preventDefault();
        } catch (f3) {
        }
        c3(Error(e28.target.error));
      };
      d3.onupgradeneeded = function(e28) {
        e28 = e28.target.result;
        try {
          e28.createObjectStore("firebaseLocalStorage", { keyPath: "fbase_key" });
        } catch (f3) {
          c3(f3);
        }
      };
      d3.onsuccess = function(e28) {
        e28 = e28.target.result;
        e28.objectStoreNames.contains("firebaseLocalStorage") ? b3(e28) : sk2(a3).then(function() {
          return tk2(a3);
        }).then(function(f3) {
          b3(f3);
        }).o(function(f3) {
          c3(f3);
        });
      };
    });
  }
  function uk2(a3) {
    a3.h || (a3.h = tk2(a3));
    return a3.h;
  }
  function vk2(a3, b3) {
    function c3(e28, f3) {
      uk2(a3).then(b3).then(e28).o(function(g3) {
        if (3 < ++d3)
          f3(g3);
        else
          return uk2(a3).then(function(h3) {
            h3.close();
            a3.h = void 0;
            return c3(e28, f3);
          }).o(function(h3) {
            f3(h3);
          });
      });
    }
    var d3 = 0;
    return new D3(c3);
  }
  function pk2() {
    try {
      return !!l3.indexedDB;
    } catch (a3) {
      return false;
    }
  }
  function wk2(a3) {
    return a3.objectStore("firebaseLocalStorage");
  }
  function xk2(a3, b3) {
    return a3.transaction(["firebaseLocalStorage"], b3 ? "readwrite" : "readonly");
  }
  function yk2(a3) {
    return new D3(function(b3, c3) {
      a3.onsuccess = function(d3) {
        d3 && d3.target ? b3(d3.target.result) : b3();
      };
      a3.onerror = function(d3) {
        c3(d3.target.error);
      };
    });
  }
  k3 = ok2.prototype;
  k3.set = function(a3, b3) {
    var c3 = this, d3 = false;
    return vk2(this, function(e28) {
      e28 = wk2(xk2(e28, true));
      return yk2(e28.get(a3));
    }).then(function(e28) {
      return vk2(c3, function(f3) {
        f3 = wk2(xk2(f3, true));
        if (e28)
          return e28.value = b3, yk2(f3.put(e28));
        c3.b++;
        d3 = true;
        var g3 = {};
        g3.fbase_key = a3;
        g3.value = b3;
        return yk2(f3.add(g3));
      });
    }).then(function() {
      c3.c[a3] = b3;
      return zk2(c3, a3);
    }).na(function() {
      d3 && c3.b--;
    });
  };
  function zk2(a3, b3) {
    return a3.g && a3.i && df2() === a3.i ? mk2(a3.g, "keyChanged", { key: b3 }, a3.s).then(function() {
    }).o(function() {
    }) : E3();
  }
  k3.get = function(a3) {
    return vk2(this, function(b3) {
      return yk2(wk2(xk2(b3, false)).get(a3));
    }).then(function(b3) {
      return b3 && b3.value;
    });
  };
  k3.T = function(a3) {
    var b3 = this, c3 = false;
    return vk2(this, function(d3) {
      c3 = true;
      b3.b++;
      return yk2(wk2(xk2(d3, true))["delete"](a3));
    }).then(function() {
      delete b3.c[a3];
      return zk2(b3, a3);
    }).na(function() {
      c3 && b3.b--;
    });
  };
  function qk2(a3) {
    return uk2(a3).then(function(b3) {
      var c3 = wk2(xk2(b3, false));
      return c3.getAll ? yk2(c3.getAll()) : new D3(function(d3, e28) {
        var f3 = [], g3 = c3.openCursor();
        g3.onsuccess = function(h3) {
          (h3 = h3.target.result) ? (f3.push(h3.value), h3["continue"]()) : d3(f3);
        };
        g3.onerror = function(h3) {
          e28(h3.target.error);
        };
      });
    }).then(function(b3) {
      var c3 = {}, d3 = [];
      if (a3.b == 0) {
        for (d3 = 0; d3 < b3.length; d3++)
          c3[b3[d3].fbase_key] = b3[d3].value;
        d3 = te2(a3.c, c3);
        a3.c = c3;
      }
      return d3;
    });
  }
  k3.ca = function(a3) {
    this.a.length == 0 && Ak2(this);
    this.a.push(a3);
  };
  k3.ia = function(a3) {
    Xa2(this.a, function(b3) {
      return b3 == a3;
    });
    this.a.length == 0 && Bk2(this);
  };
  function Ak2(a3) {
    function b3() {
      a3.f = setTimeout(function() {
        a3.l = qk2(a3).then(function(c3) {
          0 < c3.length && w3(a3.a, function(d3) {
            d3(c3);
          });
        }).then(function() {
          b3();
        }).o(function(c3) {
          c3.message != "STOP_EVENT" && b3();
        });
      }, 800);
    }
    Bk2(a3);
    b3();
  }
  function Bk2(a3) {
    a3.l && a3.l.cancel("STOP_EVENT");
    a3.f && (clearTimeout(a3.f), a3.f = null);
  }
  function Ck2(a3) {
    var b3 = this, c3 = null;
    this.a = [];
    this.type = "indexedDB";
    this.c = a3;
    this.b = E3().then(function() {
      if (pk2()) {
        var d3 = Qe2(), e28 = "__sak" + d3;
        rk2 || (rk2 = new ok2());
        c3 = rk2;
        return c3.set(e28, d3).then(function() {
          return c3.get(e28);
        }).then(function(f3) {
          if (f3 !== d3)
            throw Error("indexedDB not supported!");
          return c3.T(e28);
        }).then(function() {
          return c3;
        }).o(function() {
          return b3.c;
        });
      }
      return b3.c;
    }).then(function(d3) {
      b3.type = d3.type;
      d3.ca(function(e28) {
        w3(b3.a, function(f3) {
          f3(e28);
        });
      });
      return d3;
    });
  }
  k3 = Ck2.prototype;
  k3.get = function(a3) {
    return this.b.then(function(b3) {
      return b3.get(a3);
    });
  };
  k3.set = function(a3, b3) {
    return this.b.then(function(c3) {
      return c3.set(a3, b3);
    });
  };
  k3.T = function(a3) {
    return this.b.then(function(b3) {
      return b3.T(a3);
    });
  };
  k3.ca = function(a3) {
    this.a.push(a3);
  };
  k3.ia = function(a3) {
    Xa2(this.a, function(b3) {
      return b3 == a3;
    });
  };
  function Dk2() {
    this.a = {};
    this.type = "inMemory";
  }
  k3 = Dk2.prototype;
  k3.get = function(a3) {
    return E3(this.a[a3]);
  };
  k3.set = function(a3, b3) {
    this.a[a3] = b3;
    return E3();
  };
  k3.T = function(a3) {
    delete this.a[a3];
    return E3();
  };
  k3.ca = function() {
  };
  k3.ia = function() {
  };
  function Ek2() {
    if (!Fk2()) {
      if (Ke2() == "Node")
        throw new t3("internal-error", "The LocalStorage compatibility library was not found.");
      throw new t3("web-storage-unsupported");
    }
    this.a = Gk2() || firebase$1.INTERNAL.node.localStorage;
    this.type = "localStorage";
  }
  function Gk2() {
    try {
      var a3 = l3.localStorage, b3 = Qe2();
      a3 && (a3.setItem(b3, "1"), a3.removeItem(b3));
      return a3;
    } catch (c3) {
      return null;
    }
  }
  function Fk2() {
    var a3 = Ke2() == "Node";
    a3 = Gk2() || a3 && firebase$1.INTERNAL.node && firebase$1.INTERNAL.node.localStorage;
    if (!a3)
      return false;
    try {
      return a3.setItem("__sak", "1"), a3.removeItem("__sak"), true;
    } catch (b3) {
      return false;
    }
  }
  k3 = Ek2.prototype;
  k3.get = function(a3) {
    var b3 = this;
    return E3().then(function() {
      var c3 = b3.a.getItem(a3);
      return We2(c3);
    });
  };
  k3.set = function(a3, b3) {
    var c3 = this;
    return E3().then(function() {
      var d3 = Ue2(b3);
      d3 === null ? c3.T(a3) : c3.a.setItem(a3, d3);
    });
  };
  k3.T = function(a3) {
    var b3 = this;
    return E3().then(function() {
      b3.a.removeItem(a3);
    });
  };
  k3.ca = function(a3) {
    l3.window && nd2(l3.window, "storage", a3);
  };
  k3.ia = function(a3) {
    l3.window && H3(l3.window, "storage", a3);
  };
  function Hk2() {
    this.type = "nullStorage";
  }
  k3 = Hk2.prototype;
  k3.get = function() {
    return E3(null);
  };
  k3.set = function() {
    return E3();
  };
  k3.T = function() {
    return E3();
  };
  k3.ca = function() {
  };
  k3.ia = function() {
  };
  function Ik2() {
    if (!Jk2()) {
      if (Ke2() == "Node")
        throw new t3("internal-error", "The SessionStorage compatibility library was not found.");
      throw new t3("web-storage-unsupported");
    }
    this.a = Kk2() || firebase$1.INTERNAL.node.sessionStorage;
    this.type = "sessionStorage";
  }
  function Kk2() {
    try {
      var a3 = l3.sessionStorage, b3 = Qe2();
      a3 && (a3.setItem(b3, "1"), a3.removeItem(b3));
      return a3;
    } catch (c3) {
      return null;
    }
  }
  function Jk2() {
    var a3 = Ke2() == "Node";
    a3 = Kk2() || a3 && firebase$1.INTERNAL.node && firebase$1.INTERNAL.node.sessionStorage;
    if (!a3)
      return false;
    try {
      return a3.setItem("__sak", "1"), a3.removeItem("__sak"), true;
    } catch (b3) {
      return false;
    }
  }
  k3 = Ik2.prototype;
  k3.get = function(a3) {
    var b3 = this;
    return E3().then(function() {
      var c3 = b3.a.getItem(a3);
      return We2(c3);
    });
  };
  k3.set = function(a3, b3) {
    var c3 = this;
    return E3().then(function() {
      var d3 = Ue2(b3);
      d3 === null ? c3.T(a3) : c3.a.setItem(a3, d3);
    });
  };
  k3.T = function(a3) {
    var b3 = this;
    return E3().then(function() {
      b3.a.removeItem(a3);
    });
  };
  k3.ca = function() {
  };
  k3.ia = function() {
  };
  function Lk2() {
    var a3 = {};
    a3.Browser = Mk2;
    a3.Node = Nk2;
    a3.ReactNative = Ok2;
    a3.Worker = Pk2;
    this.a = a3[Ke2()];
  }
  var Qk2, Mk2 = { D: Ek2, ab: Ik2 }, Nk2 = { D: Ek2, ab: Ik2 }, Ok2 = { D: fk2, ab: Hk2 }, Pk2 = { D: Ek2, ab: Hk2 };
  var Rk2 = { qd: "local", NONE: "none", sd: "session" };
  function Sk2(a3) {
    var b3 = new t3("invalid-persistence-type"), c3 = new t3("unsupported-persistence-type");
    a: {
      for (d3 in Rk2)
        if (Rk2[d3] == a3) {
          var d3 = true;
          break a;
        }
      d3 = false;
    }
    if (!d3 || typeof a3 !== "string")
      throw b3;
    switch (Ke2()) {
      case "ReactNative":
        if (a3 === "session")
          throw c3;
        break;
      case "Node":
        if (a3 !== "none")
          throw c3;
        break;
      case "Worker":
        if (a3 === "session" || !pk2() && a3 !== "none")
          throw c3;
        break;
      default:
        if (!Pe2() && a3 !== "none")
          throw c3;
    }
  }
  function Tk2() {
    var a3 = !Xe2(K3()) && Ie2() ? true : false, b3 = Te2(), c3 = Pe2();
    this.v = a3;
    this.i = b3;
    this.l = c3;
    this.a = {};
    Qk2 || (Qk2 = new Lk2());
    a3 = Qk2;
    try {
      this.g = !qe2() && cf2() || !l3.indexedDB ? new a3.a.D() : new Ck2(Je2() ? new Dk2() : new a3.a.D());
    } catch (d3) {
      this.g = new Dk2(), this.i = true;
    }
    try {
      this.h = new a3.a.ab();
    } catch (d3) {
      this.h = new Dk2();
    }
    this.m = new Dk2();
    this.f = q3(this.Xb, this);
    this.b = {};
  }
  var Uk2;
  function Vk2() {
    Uk2 || (Uk2 = new Tk2());
    return Uk2;
  }
  function Wk2(a3, b3) {
    switch (b3) {
      case "session":
        return a3.h;
      case "none":
        return a3.m;
      default:
        return a3.g;
    }
  }
  function Xk2(a3, b3) {
    return "firebase:" + a3.name + (b3 ? ":" + b3 : "");
  }
  function Yk2(a3, b3, c3) {
    var d3 = Xk2(b3, c3), e28 = Wk2(a3, b3.D);
    return a3.get(b3, c3).then(function(f3) {
      var g3 = null;
      try {
        g3 = We2(l3.localStorage.getItem(d3));
      } catch (h3) {
      }
      if (g3 && !f3)
        return l3.localStorage.removeItem(d3), a3.set(b3, g3, c3);
      g3 && f3 && e28.type != "localStorage" && l3.localStorage.removeItem(d3);
    });
  }
  k3 = Tk2.prototype;
  k3.get = function(a3, b3) {
    return Wk2(this, a3.D).get(Xk2(a3, b3));
  };
  function Zk2(a3, b3, c3) {
    c3 = Xk2(b3, c3);
    b3.D == "local" && (a3.b[c3] = null);
    return Wk2(a3, b3.D).T(c3);
  }
  k3.set = function(a3, b3, c3) {
    var d3 = Xk2(a3, c3), e28 = this, f3 = Wk2(this, a3.D);
    return f3.set(d3, b3).then(function() {
      return f3.get(d3);
    }).then(function(g3) {
      a3.D == "local" && (e28.b[d3] = g3);
    });
  };
  k3.addListener = function(a3, b3, c3) {
    a3 = Xk2(a3, b3);
    this.l && (this.b[a3] = l3.localStorage.getItem(a3));
    mb2(this.a) && (Wk2(this, "local").ca(this.f), this.i || (qe2() || !cf2()) && l3.indexedDB || !this.l || $k2(this));
    this.a[a3] || (this.a[a3] = []);
    this.a[a3].push(c3);
  };
  k3.removeListener = function(a3, b3, c3) {
    a3 = Xk2(a3, b3);
    this.a[a3] && (Xa2(this.a[a3], function(d3) {
      return d3 == c3;
    }), this.a[a3].length == 0 && delete this.a[a3]);
    mb2(this.a) && (Wk2(this, "local").ia(this.f), al(this));
  };
  function $k2(a3) {
    al(a3);
    a3.c = setInterval(function() {
      for (var b3 in a3.a) {
        var c3 = l3.localStorage.getItem(b3), d3 = a3.b[b3];
        c3 != d3 && (a3.b[b3] = c3, c3 = new bd2({ type: "storage", key: b3, target: window, oldValue: d3, newValue: c3, a: true }), a3.Xb(c3));
      }
    }, 1e3);
  }
  function al(a3) {
    a3.c && (clearInterval(a3.c), a3.c = null);
  }
  k3.Xb = function(a3) {
    if (a3 && a3.g) {
      var b3 = a3.a.key;
      if (b3 == null)
        for (var c3 in this.a) {
          var d3 = this.b[c3];
          typeof d3 === "undefined" && (d3 = null);
          var e28 = l3.localStorage.getItem(c3);
          e28 !== d3 && (this.b[c3] = e28, this.lb(c3));
        }
      else if (b3.indexOf("firebase:") == 0 && this.a[b3]) {
        typeof a3.a.a !== "undefined" ? Wk2(this, "local").ia(this.f) : al(this);
        if (this.v) {
          if (c3 = l3.localStorage.getItem(b3), d3 = a3.a.newValue, d3 !== c3)
            d3 !== null ? l3.localStorage.setItem(b3, d3) : l3.localStorage.removeItem(b3);
          else if (this.b[b3] === d3 && typeof a3.a.a === "undefined")
            return;
        }
        var f3 = this;
        c3 = function() {
          if (typeof a3.a.a !== "undefined" || f3.b[b3] !== l3.localStorage.getItem(b3))
            f3.b[b3] = l3.localStorage.getItem(b3), f3.lb(b3);
        };
        Wb2 && ic2 && ic2 == 10 && l3.localStorage.getItem(b3) !== a3.a.newValue && a3.a.newValue !== a3.a.oldValue ? setTimeout(c3, 10) : c3();
      }
    } else
      w3(a3, q3(this.lb, this));
  };
  k3.lb = function(a3) {
    this.a[a3] && w3(this.a[a3], function(b3) {
      b3();
    });
  };
  function bl2(a3) {
    this.a = a3;
    this.b = Vk2();
  }
  var cl = { name: "authEvent", D: "local" };
  function dl(a3) {
    return a3.b.get(cl, a3.a).then(function(b3) {
      return th(b3);
    });
  }
  function el() {
    this.a = Vk2();
  }
  function fl2() {
    this.b = -1;
  }
  function gl(a3, b3) {
    this.b = hl;
    this.f = l3.Uint8Array ? new Uint8Array(this.b) : Array(this.b);
    this.g = this.c = 0;
    this.a = [];
    this.h = a3;
    this.i = b3;
    this.l = l3.Int32Array ? new Int32Array(64) : Array(64);
    il === void 0 && (l3.Int32Array ? il = new Int32Array(jl2) : il = jl2);
    this.reset();
  }
  var il;
  r3(gl, fl2);
  for (var hl = 64, kl = hl - 1, ll = [], ml = 0; ml < kl; ml++)
    ll[ml] = 0;
  var nl = Ya2(128, ll);
  gl.prototype.reset = function() {
    this.g = this.c = 0;
    this.a = l3.Int32Array ? new Int32Array(this.i) : Za2(this.i);
  };
  function ol(a3) {
    for (var b3 = a3.f, c3 = a3.l, d3 = 0, e28 = 0; e28 < b3.length; )
      c3[d3++] = b3[e28] << 24 | b3[e28 + 1] << 16 | b3[e28 + 2] << 8 | b3[e28 + 3], e28 = 4 * d3;
    for (b3 = 16; 64 > b3; b3++) {
      e28 = c3[b3 - 15] | 0;
      d3 = c3[b3 - 2] | 0;
      var f3 = (c3[b3 - 16] | 0) + ((e28 >>> 7 | e28 << 25) ^ (e28 >>> 18 | e28 << 14) ^ e28 >>> 3) | 0, g3 = (c3[b3 - 7] | 0) + ((d3 >>> 17 | d3 << 15) ^ (d3 >>> 19 | d3 << 13) ^ d3 >>> 10) | 0;
      c3[b3] = f3 + g3 | 0;
    }
    d3 = a3.a[0] | 0;
    e28 = a3.a[1] | 0;
    var h3 = a3.a[2] | 0, n3 = a3.a[3] | 0, p3 = a3.a[4] | 0, v3 = a3.a[5] | 0, B3 = a3.a[6] | 0;
    f3 = a3.a[7] | 0;
    for (b3 = 0; 64 > b3; b3++) {
      var A3 = ((d3 >>> 2 | d3 << 30) ^ (d3 >>> 13 | d3 << 19) ^ (d3 >>> 22 | d3 << 10)) + (d3 & e28 ^ d3 & h3 ^ e28 & h3) | 0;
      g3 = p3 & v3 ^ ~p3 & B3;
      f3 = f3 + ((p3 >>> 6 | p3 << 26) ^ (p3 >>> 11 | p3 << 21) ^ (p3 >>> 25 | p3 << 7)) | 0;
      g3 = g3 + (il[b3] | 0) | 0;
      g3 = f3 + (g3 + (c3[b3] | 0) | 0) | 0;
      f3 = B3;
      B3 = v3;
      v3 = p3;
      p3 = n3 + g3 | 0;
      n3 = h3;
      h3 = e28;
      e28 = d3;
      d3 = g3 + A3 | 0;
    }
    a3.a[0] = a3.a[0] + d3 | 0;
    a3.a[1] = a3.a[1] + e28 | 0;
    a3.a[2] = a3.a[2] + h3 | 0;
    a3.a[3] = a3.a[3] + n3 | 0;
    a3.a[4] = a3.a[4] + p3 | 0;
    a3.a[5] = a3.a[5] + v3 | 0;
    a3.a[6] = a3.a[6] + B3 | 0;
    a3.a[7] = a3.a[7] + f3 | 0;
  }
  function pl2(a3, b3, c3) {
    c3 === void 0 && (c3 = b3.length);
    var d3 = 0, e28 = a3.c;
    if (typeof b3 === "string")
      for (; d3 < c3; )
        a3.f[e28++] = b3.charCodeAt(d3++), e28 == a3.b && (ol(a3), e28 = 0);
    else if (na2(b3))
      for (; d3 < c3; ) {
        var f3 = b3[d3++];
        if (!(typeof f3 == "number" && 0 <= f3 && 255 >= f3 && f3 == (f3 | 0)))
          throw Error("message must be a byte array");
        a3.f[e28++] = f3;
        e28 == a3.b && (ol(a3), e28 = 0);
      }
    else
      throw Error("message must be string or array");
    a3.c = e28;
    a3.g += c3;
  }
  var jl2 = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ];
  function ql2() {
    gl.call(this, 8, rl);
  }
  r3(ql2, gl);
  var rl = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225];
  function sl(a3, b3, c3, d3, e28, f3) {
    this.m = a3;
    this.h = b3;
    this.l = c3;
    this.v = d3 || null;
    this.u = e28 || null;
    this.s = f3;
    this.i = b3 + ":" + c3;
    this.A = new el();
    this.g = new bl2(this.i);
    this.f = null;
    this.b = [];
    this.a = this.c = null;
  }
  function tl(a3) {
    return new t3("invalid-cordova-configuration", a3);
  }
  k3 = sl.prototype;
  k3.la = function() {
    return this.Ia ? this.Ia : this.Ia = Fe2().then(function() {
      if (typeof L3("universalLinks.subscribe", l3) !== "function")
        throw tl("cordova-universal-links-plugin-fix is not installed");
      if (typeof L3("BuildInfo.packageName", l3) === "undefined")
        throw tl("cordova-plugin-buildinfo is not installed");
      if (typeof L3("cordova.plugins.browsertab.openUrl", l3) !== "function")
        throw tl("cordova-plugin-browsertab is not installed");
      if (typeof L3("cordova.InAppBrowser.open", l3) !== "function")
        throw tl("cordova-plugin-inappbrowser is not installed");
    }, function() {
      throw new t3("cordova-not-ready");
    });
  };
  function ul() {
    for (var a3 = 20, b3 = []; 0 < a3; )
      b3.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), a3--;
    return b3.join("");
  }
  function vl(a3) {
    var b3 = new ql2();
    pl2(b3, a3);
    a3 = [];
    var c3 = 8 * b3.g;
    56 > b3.c ? pl2(b3, nl, 56 - b3.c) : pl2(b3, nl, b3.b - (b3.c - 56));
    for (var d3 = 63; 56 <= d3; d3--)
      b3.f[d3] = c3 & 255, c3 /= 256;
    ol(b3);
    for (d3 = c3 = 0; d3 < b3.h; d3++)
      for (var e28 = 24; 0 <= e28; e28 -= 8)
        a3[c3++] = b3.a[d3] >> e28 & 255;
    return cg(a3);
  }
  k3.Nb = function(a3, b3) {
    b3(new t3("operation-not-supported-in-this-environment"));
    return E3();
  };
  k3.Lb = function() {
    return F3(new t3("operation-not-supported-in-this-environment"));
  };
  k3.Zb = function() {
    return false;
  };
  k3.Wb = function() {
    return true;
  };
  k3.Sb = function() {
    return true;
  };
  k3.Mb = function(a3, b3, c3, d3) {
    if (this.c)
      return F3(new t3("redirect-operation-pending"));
    var e28 = this, f3 = l3.document, g3 = null, h3 = null, n3 = null, p3 = null;
    return this.c = E3().then(function() {
      rh(b3);
      return wl2(e28);
    }).then(function() {
      return xl(e28, a3, b3, c3, d3);
    }).then(function() {
      return new D3(function(v3, B3) {
        h3 = function() {
          var A3 = L3("cordova.plugins.browsertab.close", l3);
          v3();
          typeof A3 === "function" && A3();
          e28.a && typeof e28.a.close === "function" && (e28.a.close(), e28.a = null);
          return false;
        };
        e28.Ea(h3);
        n3 = function() {
          g3 || (g3 = Ed2(2e3).then(function() {
            B3(new t3("redirect-cancelled-by-user"));
          }));
        };
        p3 = function() {
          $e2() && n3();
        };
        f3.addEventListener("resume", n3, false);
        K3().toLowerCase().match(/android/) || f3.addEventListener("visibilitychange", p3, false);
      }).o(function(v3) {
        return yl(e28).then(function() {
          throw v3;
        });
      });
    }).na(function() {
      n3 && f3.removeEventListener("resume", n3, false);
      p3 && f3.removeEventListener("visibilitychange", p3, false);
      g3 && g3.cancel();
      h3 && e28.Ra(h3);
      e28.c = null;
    });
  };
  function xl(a3, b3, c3, d3, e28) {
    var f3 = ul(), g3 = new sh(b3, d3, null, f3, new t3("no-auth-event"), null, e28), h3 = L3("BuildInfo.packageName", l3);
    if (typeof h3 !== "string")
      throw new t3("invalid-cordova-configuration");
    var n3 = L3("BuildInfo.displayName", l3), p3 = {};
    if (K3().toLowerCase().match(/iphone|ipad|ipod/))
      p3.ibi = h3;
    else if (K3().toLowerCase().match(/android/))
      p3.apn = h3;
    else
      return F3(new t3("operation-not-supported-in-this-environment"));
    n3 && (p3.appDisplayName = n3);
    f3 = vl(f3);
    p3.sessionId = f3;
    var v3 = ek2(a3.m, a3.h, a3.l, b3, c3, null, d3, a3.v, p3, a3.u, e28, a3.s);
    return a3.la().then(function() {
      var B3 = a3.i;
      return a3.A.a.set(cl, g3.w(), B3);
    }).then(function() {
      var B3 = L3("cordova.plugins.browsertab.isAvailable", l3);
      if (typeof B3 !== "function")
        throw new t3("invalid-cordova-configuration");
      var A3 = null;
      B3(function(Q3) {
        if (Q3) {
          A3 = L3("cordova.plugins.browsertab.openUrl", l3);
          if (typeof A3 !== "function")
            throw new t3("invalid-cordova-configuration");
          A3(v3);
        } else {
          A3 = L3("cordova.InAppBrowser.open", l3);
          if (typeof A3 !== "function")
            throw new t3("invalid-cordova-configuration");
          Q3 = K3();
          a3.a = A3(v3, Q3.match(/(iPad|iPhone|iPod).*OS 7_\d/i) || Q3.match(/(iPad|iPhone|iPod).*OS 8_\d/i) ? "_blank" : "_system", "location=yes");
        }
      });
    });
  }
  function zl2(a3, b3) {
    for (var c3 = 0; c3 < a3.b.length; c3++)
      try {
        a3.b[c3](b3);
      } catch (d3) {
      }
  }
  function wl2(a3) {
    a3.f || (a3.f = a3.la().then(function() {
      return new D3(function(b3) {
        function c3(d3) {
          b3(d3);
          a3.Ra(c3);
          return false;
        }
        a3.Ea(c3);
        Al2(a3);
      });
    }));
    return a3.f;
  }
  function yl(a3) {
    var b3 = null;
    return dl(a3.g).then(function(c3) {
      b3 = c3;
      c3 = a3.g;
      return Zk2(c3.b, cl, c3.a);
    }).then(function() {
      return b3;
    });
  }
  function Al2(a3) {
    function b3(g3) {
      d3 = true;
      e28 && e28.cancel();
      yl(a3).then(function(h3) {
        var n3 = c3;
        if (h3 && g3 && g3.url) {
          var p3 = null;
          n3 = xg(g3.url);
          n3.indexOf("/__/auth/callback") != -1 && (p3 = be2(n3), p3 = We2(ae2(p3, "firebaseError") || null), p3 = (p3 = typeof p3 === "object" ? Aa2(p3) : null) ? new sh(h3.c, h3.b, null, null, p3, null, h3.S()) : new sh(h3.c, h3.b, n3, h3.f, null, null, h3.S()));
          n3 = p3 || c3;
        }
        zl2(a3, n3);
      });
    }
    var c3 = new sh("unknown", null, null, null, new t3("no-auth-event")), d3 = false, e28 = Ed2(500).then(function() {
      return yl(a3).then(function() {
        d3 || zl2(a3, c3);
      });
    }), f3 = l3.handleOpenURL;
    l3.handleOpenURL = function(g3) {
      g3.toLowerCase().indexOf(L3("BuildInfo.packageName", l3).toLowerCase() + "://") == 0 && b3({ url: g3 });
      if (typeof f3 === "function")
        try {
          f3(g3);
        } catch (h3) {
          console.error(h3);
        }
    };
    vh || (vh = new uh());
    wh(b3);
  }
  k3.Ea = function(a3) {
    this.b.push(a3);
    wl2(this).o(function(b3) {
      b3.code === "auth/invalid-cordova-configuration" && (b3 = new sh("unknown", null, null, null, new t3("no-auth-event")), a3(b3));
    });
  };
  k3.Ra = function(a3) {
    Xa2(this.b, function(b3) {
      return b3 == a3;
    });
  };
  function Bl2(a3) {
    this.a = a3;
    this.b = Vk2();
  }
  var Cl2 = { name: "pendingRedirect", D: "session" };
  function Dl2(a3) {
    return a3.b.set(Cl2, "pending", a3.a);
  }
  function El2(a3) {
    return Zk2(a3.b, Cl2, a3.a);
  }
  function Fl2(a3) {
    return a3.b.get(Cl2, a3.a).then(function(b3) {
      return b3 == "pending";
    });
  }
  function Gl2(a3, b3, c3, d3) {
    this.h = {};
    this.u = 0;
    this.O = a3;
    this.m = b3;
    this.v = c3;
    this.G = d3;
    this.i = [];
    this.f = false;
    this.l = q3(this.s, this);
    this.b = new Hl2();
    this.A = new Il2();
    this.g = new Bl2(Jl2(this.m, this.v));
    this.c = {};
    this.c.unknown = this.b;
    this.c.signInViaRedirect = this.b;
    this.c.linkViaRedirect = this.b;
    this.c.reauthViaRedirect = this.b;
    this.c.signInViaPopup = this.A;
    this.c.linkViaPopup = this.A;
    this.c.reauthViaPopup = this.A;
    this.a = Kl2(this.O, this.m, this.v, Da2, this.G);
  }
  function Kl2(a3, b3, c3, d3, e28) {
    var f3 = firebase$1.SDK_VERSION || null;
    return Ge2() ? new sl(a3, b3, c3, f3, d3, e28) : new Yj2(a3, b3, c3, f3, d3, e28);
  }
  Gl2.prototype.reset = function() {
    this.f = false;
    this.a.Ra(this.l);
    this.a = Kl2(this.O, this.m, this.v, null, this.G);
    this.h = {};
  };
  function Ll2(a3) {
    a3.f || (a3.f = true, a3.a.Ea(a3.l));
    var b3 = a3.a;
    return a3.a.la().o(function(c3) {
      a3.a == b3 && a3.reset();
      throw c3;
    });
  }
  function Ml2(a3) {
    a3.a.Wb() && Ll2(a3).o(function(b3) {
      var c3 = new sh("unknown", null, null, null, new t3("operation-not-supported-in-this-environment"));
      Nl2(b3) && a3.s(c3);
    });
    a3.a.Sb() || Ol2(a3.b);
  }
  function Pl2(a3, b3) {
    Va2(a3.i, b3) || a3.i.push(b3);
    a3.f || Fl2(a3.g).then(function(c3) {
      c3 ? El2(a3.g).then(function() {
        Ll2(a3).o(function(d3) {
          var e28 = new sh("unknown", null, null, null, new t3("operation-not-supported-in-this-environment"));
          Nl2(d3) && a3.s(e28);
        });
      }) : Ml2(a3);
    }).o(function() {
      Ml2(a3);
    });
  }
  function Ql2(a3, b3) {
    Xa2(a3.i, function(c3) {
      return c3 == b3;
    });
  }
  Gl2.prototype.s = function(a3) {
    if (!a3)
      throw new t3("invalid-auth-event");
    6e5 <= va2() - this.u && (this.h = {}, this.u = 0);
    if (a3 && a3.getUid() && this.h.hasOwnProperty(a3.getUid()))
      return false;
    for (var b3 = false, c3 = 0; c3 < this.i.length; c3++) {
      var d3 = this.i[c3];
      if (d3.Eb(a3.c, a3.b)) {
        if (b3 = this.c[a3.c])
          b3.i(a3, d3), a3 && (a3.f || a3.b) && (this.h[a3.getUid()] = true, this.u = va2());
        b3 = true;
        break;
      }
    }
    Ol2(this.b);
    return b3;
  };
  var Rl2 = new Ze2(2e3, 1e4), Sl2 = new Ze2(3e4, 6e4);
  Gl2.prototype.qa = function() {
    return this.b.qa();
  };
  function Tl(a3, b3, c3, d3, e28, f3, g3) {
    return a3.a.Lb(b3, c3, d3, function() {
      a3.f || (a3.f = true, a3.a.Ea(a3.l));
    }, function() {
      a3.reset();
    }, e28, f3, g3);
  }
  function Nl2(a3) {
    return a3 && a3.code == "auth/cordova-not-ready" ? true : false;
  }
  function Ul2(a3, b3, c3, d3, e28) {
    var f3;
    return Dl2(a3.g).then(function() {
      return a3.a.Mb(b3, c3, d3, e28).o(function(g3) {
        if (Nl2(g3))
          throw new t3("operation-not-supported-in-this-environment");
        f3 = g3;
        return El2(a3.g).then(function() {
          throw f3;
        });
      }).then(function() {
        return a3.a.Zb() ? new D3(function() {
        }) : El2(a3.g).then(function() {
          return a3.qa();
        }).then(function() {
        }).o(function() {
        });
      });
    });
  }
  function Vl2(a3, b3, c3, d3, e28) {
    return a3.a.Nb(d3, function(f3) {
      b3.ma(c3, null, f3, e28);
    }, Rl2.get());
  }
  var Wl2 = {};
  function Jl2(a3, b3, c3) {
    a3 = a3 + ":" + b3;
    c3 && (a3 = a3 + ":" + c3.url);
    return a3;
  }
  function Xl2(a3, b3, c3, d3) {
    var e28 = Jl2(b3, c3, d3);
    Wl2[e28] || (Wl2[e28] = new Gl2(a3, b3, c3, d3));
    return Wl2[e28];
  }
  function Hl2() {
    this.b = null;
    this.f = [];
    this.c = [];
    this.a = null;
    this.h = this.g = false;
  }
  Hl2.prototype.reset = function() {
    this.b = null;
    this.a && (this.a.cancel(), this.a = null);
  };
  Hl2.prototype.i = function(a3, b3) {
    if (a3) {
      this.reset();
      this.g = true;
      var c3 = a3.c, d3 = a3.b, e28 = a3.a && a3.a.code == "auth/web-storage-unsupported", f3 = a3.a && a3.a.code == "auth/operation-not-supported-in-this-environment";
      this.h = !(!e28 && !f3);
      c3 != "unknown" || e28 || f3 ? a3.a ? (Yl2(this, true, null, a3.a), E3()) : b3.Fa(c3, d3) ? Zl2(this, a3, b3) : F3(new t3("invalid-auth-event")) : (Yl2(this, false, null, null), E3());
    } else
      F3(new t3("invalid-auth-event"));
  };
  function Ol2(a3) {
    a3.g || (a3.g = true, Yl2(a3, false, null, null));
  }
  function $l2(a3) {
    a3.g && !a3.h && Yl2(a3, false, null, null);
  }
  function Zl2(a3, b3, c3) {
    c3 = c3.Fa(b3.c, b3.b);
    var d3 = b3.g, e28 = b3.f, f3 = b3.h, g3 = b3.S(), h3 = !!b3.c.match(/Redirect$/);
    c3(d3, e28, g3, f3).then(function(n3) {
      Yl2(a3, h3, n3, null);
    }).o(function(n3) {
      Yl2(a3, h3, null, n3);
    });
  }
  function am2(a3, b3) {
    a3.b = function() {
      return F3(b3);
    };
    if (a3.c.length)
      for (var c3 = 0; c3 < a3.c.length; c3++)
        a3.c[c3](b3);
  }
  function bm2(a3, b3) {
    a3.b = function() {
      return E3(b3);
    };
    if (a3.f.length)
      for (var c3 = 0; c3 < a3.f.length; c3++)
        a3.f[c3](b3);
  }
  function Yl2(a3, b3, c3, d3) {
    b3 ? d3 ? am2(a3, d3) : bm2(a3, c3) : bm2(a3, { user: null });
    a3.f = [];
    a3.c = [];
  }
  Hl2.prototype.qa = function() {
    var a3 = this;
    return new D3(function(b3, c3) {
      a3.b ? a3.b().then(b3, c3) : (a3.f.push(b3), a3.c.push(c3), cm2(a3));
    });
  };
  function cm2(a3) {
    var b3 = new t3("timeout");
    a3.a && a3.a.cancel();
    a3.a = Ed2(Sl2.get()).then(function() {
      a3.b || (a3.g = true, Yl2(a3, true, null, b3));
    });
  }
  function Il2() {
  }
  Il2.prototype.i = function(a3, b3) {
    if (a3) {
      var c3 = a3.c, d3 = a3.b;
      a3.a ? (b3.ma(a3.c, null, a3.a, a3.b), E3()) : b3.Fa(c3, d3) ? dm2(a3, b3) : F3(new t3("invalid-auth-event"));
    } else
      F3(new t3("invalid-auth-event"));
  };
  function dm2(a3, b3) {
    var c3 = a3.b, d3 = a3.c;
    b3.Fa(d3, c3)(a3.g, a3.f, a3.S(), a3.h).then(function(e28) {
      b3.ma(d3, e28, null, c3);
    }).o(function(e28) {
      b3.ma(d3, null, e28, c3);
    });
  }
  function em2() {
    this.hb = false;
    Object.defineProperty(this, "appVerificationDisabled", { get: function() {
      return this.hb;
    }, set: function(a3) {
      this.hb = a3;
    }, enumerable: false });
  }
  function fm2(a3, b3) {
    this.a = b3;
    M3(this, "verificationId", a3);
  }
  fm2.prototype.confirm = function(a3) {
    a3 = ph(this.verificationId, a3);
    return this.a(a3);
  };
  function gm2(a3, b3, c3, d3) {
    return new lh(a3).eb(b3, c3).then(function(e28) {
      return new fm2(e28, d3);
    });
  }
  function hm2(a3) {
    var b3 = ig2(a3);
    if (!(b3 && b3.exp && b3.auth_time && b3.iat))
      throw new t3("internal-error", "An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");
    N3(this, { token: a3, expirationTime: bf2(1e3 * b3.exp), authTime: bf2(1e3 * b3.auth_time), issuedAtTime: bf2(1e3 * b3.iat), signInProvider: b3.firebase && b3.firebase.sign_in_provider ? b3.firebase.sign_in_provider : null, signInSecondFactor: b3.firebase && b3.firebase.sign_in_second_factor ? b3.firebase.sign_in_second_factor : null, claims: b3 });
  }
  function im2(a3, b3, c3) {
    var d3 = b3 && b3[jm2];
    if (!d3)
      throw new t3("argument-error", "Internal assert: Invalid MultiFactorResolver");
    this.a = a3;
    this.f = nb2(b3);
    this.g = c3;
    this.c = new yg(null, d3);
    this.b = [];
    var e28 = this;
    w3(b3[km2] || [], function(f3) {
      (f3 = tf2(f3)) && e28.b.push(f3);
    });
    M3(this, "auth", this.a);
    M3(this, "session", this.c);
    M3(this, "hints", this.b);
  }
  var km2 = "mfaInfo", jm2 = "mfaPendingCredential";
  im2.prototype.Qc = function(a3) {
    var b3 = this;
    return a3.rb(this.a.a, this.c).then(function(c3) {
      var d3 = nb2(b3.f);
      delete d3[km2];
      delete d3[jm2];
      z3(d3, c3);
      return b3.g(d3);
    });
  };
  function lm2(a3, b3, c3, d3) {
    t3.call(this, "multi-factor-auth-required", d3, b3);
    this.b = new im2(a3, b3, c3);
    M3(this, "resolver", this.b);
  }
  r3(lm2, t3);
  function mm2(a3, b3, c3) {
    if (a3 && m3(a3.serverResponse) && a3.code === "auth/multi-factor-auth-required")
      try {
        return new lm2(b3, a3.serverResponse, c3, a3.message);
      } catch (d3) {
      }
    return null;
  }
  function nm2() {
  }
  nm2.prototype.rb = function(a3, b3, c3) {
    return b3.type == zg ? om2(this, a3, b3, c3) : pm2(this, a3, b3);
  };
  function om2(a3, b3, c3, d3) {
    return c3.Ha().then(function(e28) {
      e28 = { idToken: e28 };
      typeof d3 !== "undefined" && (e28.displayName = d3);
      z3(e28, { phoneVerificationInfo: hh(a3.a) });
      return O3(b3, Gj2, e28);
    });
  }
  function pm2(a3, b3, c3) {
    return c3.Ha().then(function(d3) {
      d3 = { mfaPendingCredential: d3 };
      z3(d3, { phoneVerificationInfo: hh(a3.a) });
      return O3(b3, Hj2, d3);
    });
  }
  function qm2(a3) {
    M3(this, "factorId", a3.fa);
    this.a = a3;
  }
  r3(qm2, nm2);
  function rm2(a3) {
    qm2.call(this, a3);
    if (this.a.fa != lh.PROVIDER_ID)
      throw new t3("argument-error", "firebase.auth.PhoneMultiFactorAssertion requires a valid firebase.auth.PhoneAuthCredential");
  }
  r3(rm2, qm2);
  function sm2(a3, b3) {
    G3.call(this, a3);
    for (var c3 in b3)
      this[c3] = b3[c3];
  }
  r3(sm2, G3);
  function tm2(a3, b3) {
    this.a = a3;
    this.b = [];
    this.c = q3(this.xc, this);
    nd2(this.a, "userReloaded", this.c);
    var c3 = [];
    b3 && b3.multiFactor && b3.multiFactor.enrolledFactors && w3(b3.multiFactor.enrolledFactors, function(d3) {
      var e28 = null, f3 = {};
      if (d3) {
        d3.uid && (f3[qf] = d3.uid);
        d3.displayName && (f3[rf2] = d3.displayName);
        d3.enrollmentTime && (f3[sf2] = new Date(d3.enrollmentTime).toISOString());
        d3.phoneNumber && (f3[pf2] = d3.phoneNumber);
        try {
          e28 = new uf2(f3);
        } catch (g3) {
        }
        d3 = e28;
      } else
        d3 = null;
      d3 && c3.push(d3);
    });
    um2(this, c3);
  }
  function vm2(a3) {
    var b3 = [];
    w3(a3.mfaInfo || [], function(c3) {
      (c3 = tf2(c3)) && b3.push(c3);
    });
    return b3;
  }
  k3 = tm2.prototype;
  k3.xc = function(a3) {
    um2(this, vm2(a3.gd));
  };
  function um2(a3, b3) {
    a3.b = b3;
    M3(a3, "enrolledFactors", b3);
  }
  k3.Qb = function() {
    return this.a.I().then(function(a3) {
      return new yg(a3, null);
    });
  };
  k3.ec = function(a3, b3) {
    var c3 = this, d3 = this.a.a;
    return this.Qb().then(function(e28) {
      return a3.rb(d3, e28, b3);
    }).then(function(e28) {
      wm2(c3.a, e28);
      return c3.a.reload();
    });
  };
  k3.ad = function(a3) {
    var b3 = this, c3 = typeof a3 === "string" ? a3 : a3.uid, d3 = this.a.a;
    return this.a.I().then(function(e28) {
      return O3(d3, Lj2, { idToken: e28, mfaEnrollmentId: c3 });
    }).then(function(e28) {
      var f3 = Qa2(b3.b, function(g3) {
        return g3.uid != c3;
      });
      um2(b3, f3);
      wm2(b3.a, e28);
      return b3.a.reload().o(function(g3) {
        if (g3.code != "auth/user-token-expired")
          throw g3;
      });
    });
  };
  k3.w = function() {
    return { multiFactor: { enrolledFactors: Ra2(this.b, function(a3) {
      return a3.w();
    }) } };
  };
  function xm2(a3, b3, c3) {
    this.i = a3;
    this.h = b3;
    this.g = c3;
    this.c = 3e4;
    this.f = 96e4;
    this.b = null;
    this.a = this.c;
    if (this.f < this.c)
      throw Error("Proactive refresh lower bound greater than upper bound!");
  }
  xm2.prototype.start = function() {
    this.a = this.c;
    ym2(this, true);
  };
  function zm2(a3, b3) {
    if (b3)
      return a3.a = a3.c, a3.g();
    b3 = a3.a;
    a3.a *= 2;
    a3.a > a3.f && (a3.a = a3.f);
    return b3;
  }
  function ym2(a3, b3) {
    a3.stop();
    a3.b = Ed2(zm2(a3, b3)).then(function() {
      return af2();
    }).then(function() {
      return a3.i();
    }).then(function() {
      ym2(a3, true);
    }).o(function(c3) {
      a3.h(c3) && ym2(a3, false);
    });
  }
  xm2.prototype.stop = function() {
    this.b && (this.b.cancel(), this.b = null);
  };
  function Am2(a3) {
    this.f = a3;
    this.b = this.a = null;
    this.c = Date.now();
  }
  Am2.prototype.w = function() {
    return { apiKey: this.f.c, refreshToken: this.a, accessToken: this.b && this.b.toString(), expirationTime: this.c };
  };
  function Bm2(a3, b3) {
    typeof b3 === "undefined" && (a3.b ? (b3 = a3.b, b3 = b3.a - b3.g) : b3 = 0);
    a3.c = Date.now() + 1e3 * b3;
  }
  function Cm2(a3, b3) {
    a3.b = jg(b3[Dg] || "");
    a3.a = b3.refreshToken;
    b3 = b3.expiresIn;
    Bm2(a3, typeof b3 !== "undefined" ? Number(b3) : void 0);
  }
  function Dm2(a3, b3) {
    a3.b = b3.b;
    a3.a = b3.a;
    a3.c = b3.c;
  }
  function Em2(a3, b3) {
    return Wi2(a3.f, b3).then(function(c3) {
      a3.b = jg(c3.access_token);
      a3.a = c3.refresh_token;
      Bm2(a3, c3.expires_in);
      return { accessToken: a3.b.toString(), refreshToken: a3.a };
    }).o(function(c3) {
      c3.code == "auth/user-token-expired" && (a3.a = null);
      throw c3;
    });
  }
  Am2.prototype.getToken = function(a3) {
    a3 = !!a3;
    return this.b && !this.a ? F3(new t3("user-token-expired")) : a3 || !this.b || Date.now() > this.c - 3e4 ? this.a ? Em2(this, { grant_type: "refresh_token", refresh_token: this.a }) : E3(null) : E3({ accessToken: this.b.toString(), refreshToken: this.a });
  };
  function Fm2(a3, b3) {
    this.a = a3 || null;
    this.b = b3 || null;
    N3(this, { lastSignInTime: bf2(b3 || null), creationTime: bf2(a3 || null) });
  }
  function Gm2(a3) {
    return new Fm2(a3.a, a3.b);
  }
  Fm2.prototype.w = function() {
    return { lastLoginAt: this.b, createdAt: this.a };
  };
  function Hm2(a3, b3, c3, d3, e28, f3) {
    N3(this, { uid: a3, displayName: d3 || null, photoURL: e28 || null, email: c3 || null, phoneNumber: f3 || null, providerId: b3 });
  }
  function Im2(a3, b3, c3) {
    this.G = [];
    this.l = a3.apiKey;
    this.m = a3.appName;
    this.s = a3.authDomain || null;
    var d3 = firebase$1.SDK_VERSION ? Oe2(firebase$1.SDK_VERSION) : null;
    this.a = new Ii2(this.l, Ca2(Da2), d3);
    a3.emulatorConfig && Pi2(this.a, a3.emulatorConfig);
    this.b = new Am2(this.a);
    Jm2(this, b3[Dg]);
    Cm2(this.b, b3);
    M3(this, "refreshToken", this.b.a);
    Km2(this, c3 || {});
    I3.call(this);
    this.P = false;
    this.s && Re2() && (this.h = Xl2(this.s, this.l, this.m));
    this.R = [];
    this.f = null;
    this.u = Lm2(this);
    this.$ = q3(this.gb, this);
    var e28 = this;
    this.pa = null;
    this.Ba = function(f3) {
      e28.wa(f3.i);
    };
    this.ba = null;
    this.za = function(f3) {
      Pi2(e28.a, f3.c);
    };
    this.W = null;
    this.X = [];
    this.Aa = function(f3) {
      Mm2(e28, f3.f);
    };
    this.aa = null;
    this.N = new tm2(this, c3);
    M3(this, "multiFactor", this.N);
  }
  r3(Im2, I3);
  Im2.prototype.wa = function(a3) {
    this.pa = a3;
    Oi2(this.a, a3);
  };
  Im2.prototype.ka = function() {
    return this.pa;
  };
  function Nm2(a3, b3) {
    a3.ba && H3(a3.ba, "languageCodeChanged", a3.Ba);
    (a3.ba = b3) && nd2(b3, "languageCodeChanged", a3.Ba);
  }
  function Om2(a3, b3) {
    a3.W && H3(a3.W, "emulatorConfigChanged", a3.za);
    (a3.W = b3) && nd2(b3, "emulatorConfigChanged", a3.za);
  }
  function Mm2(a3, b3) {
    a3.X = b3;
    Ri2(a3.a, firebase$1.SDK_VERSION ? Oe2(firebase$1.SDK_VERSION, a3.X) : null);
  }
  Im2.prototype.Ga = function() {
    return Za2(this.X);
  };
  function Pm2(a3, b3) {
    a3.aa && H3(a3.aa, "frameworkChanged", a3.Aa);
    (a3.aa = b3) && nd2(b3, "frameworkChanged", a3.Aa);
  }
  Im2.prototype.gb = function() {
    this.u.b && (this.u.stop(), this.u.start());
  };
  function Qm2(a3) {
    try {
      return firebase$1.app(a3.m).auth();
    } catch (b3) {
      throw new t3("internal-error", "No firebase.auth.Auth instance is available for the Firebase App '" + a3.m + "'!");
    }
  }
  function Lm2(a3) {
    return new xm2(function() {
      return a3.I(true);
    }, function(b3) {
      return b3 && b3.code == "auth/network-request-failed" ? true : false;
    }, function() {
      var b3 = a3.b.c - Date.now() - 3e5;
      return 0 < b3 ? b3 : 0;
    });
  }
  function Rm2(a3) {
    a3.A || a3.u.b || (a3.u.start(), H3(a3, "tokenChanged", a3.$), nd2(a3, "tokenChanged", a3.$));
  }
  function Sm2(a3) {
    H3(a3, "tokenChanged", a3.$);
    a3.u.stop();
  }
  function Jm2(a3, b3) {
    a3.ya = b3;
    M3(a3, "_lat", b3);
  }
  function Tm2(a3, b3) {
    Xa2(a3.R, function(c3) {
      return c3 == b3;
    });
  }
  function Um2(a3) {
    for (var b3 = [], c3 = 0; c3 < a3.R.length; c3++)
      b3.push(a3.R[c3](a3));
    return Jc2(b3).then(function() {
      return a3;
    });
  }
  function Vm2(a3) {
    a3.h && !a3.P && (a3.P = true, Pl2(a3.h, a3));
  }
  function Km2(a3, b3) {
    N3(a3, { uid: b3.uid, displayName: b3.displayName || null, photoURL: b3.photoURL || null, email: b3.email || null, emailVerified: b3.emailVerified || false, phoneNumber: b3.phoneNumber || null, isAnonymous: b3.isAnonymous || false, tenantId: b3.tenantId || null, metadata: new Fm2(b3.createdAt, b3.lastLoginAt), providerData: [] });
    a3.a.b = a3.tenantId;
  }
  M3(Im2.prototype, "providerId", "firebase");
  function Wm2() {
  }
  function Xm2(a3) {
    return E3().then(function() {
      if (a3.A)
        throw new t3("app-deleted");
    });
  }
  function Ym2(a3) {
    return Ra2(a3.providerData, function(b3) {
      return b3.providerId;
    });
  }
  function Zm2(a3, b3) {
    b3 && ($m2(a3, b3.providerId), a3.providerData.push(b3));
  }
  function $m2(a3, b3) {
    Xa2(a3.providerData, function(c3) {
      return c3.providerId == b3;
    });
  }
  function an2(a3, b3, c3) {
    (b3 != "uid" || c3) && a3.hasOwnProperty(b3) && M3(a3, b3, c3);
  }
  function bn2(a3, b3) {
    a3 != b3 && (N3(a3, { uid: b3.uid, displayName: b3.displayName, photoURL: b3.photoURL, email: b3.email, emailVerified: b3.emailVerified, phoneNumber: b3.phoneNumber, isAnonymous: b3.isAnonymous, tenantId: b3.tenantId, providerData: [] }), b3.metadata ? M3(a3, "metadata", Gm2(b3.metadata)) : M3(a3, "metadata", new Fm2()), w3(b3.providerData, function(c3) {
      Zm2(a3, c3);
    }), Dm2(a3.b, b3.b), M3(a3, "refreshToken", a3.b.a), um2(a3.N, b3.N.b));
  }
  k3 = Im2.prototype;
  k3.reload = function() {
    var a3 = this;
    return R3(this, Xm2(this).then(function() {
      return cn2(a3).then(function() {
        return Um2(a3);
      }).then(Wm2);
    }));
  };
  function cn2(a3) {
    return a3.I().then(function(b3) {
      var c3 = a3.isAnonymous;
      return dn2(a3, b3).then(function() {
        c3 || an2(a3, "isAnonymous", false);
        return b3;
      });
    });
  }
  k3.nc = function(a3) {
    return this.I(a3).then(function(b3) {
      return new hm2(b3);
    });
  };
  k3.I = function(a3) {
    var b3 = this;
    return R3(this, Xm2(this).then(function() {
      return b3.b.getToken(a3);
    }).then(function(c3) {
      if (!c3)
        throw new t3("internal-error");
      c3.accessToken != b3.ya && (Jm2(b3, c3.accessToken), b3.dispatchEvent(new sm2("tokenChanged")));
      an2(b3, "refreshToken", c3.refreshToken);
      return c3.accessToken;
    }));
  };
  function wm2(a3, b3) {
    b3[Dg] && a3.ya != b3[Dg] && (Cm2(a3.b, b3), a3.dispatchEvent(new sm2("tokenChanged")), Jm2(a3, b3[Dg]), an2(a3, "refreshToken", a3.b.a));
  }
  function dn2(a3, b3) {
    return O3(a3.a, Ij2, { idToken: b3 }).then(q3(a3.Jc, a3));
  }
  k3.Jc = function(a3) {
    a3 = a3.users;
    if (!a3 || !a3.length)
      throw new t3("internal-error");
    a3 = a3[0];
    Km2(this, { uid: a3.localId, displayName: a3.displayName, photoURL: a3.photoUrl, email: a3.email, emailVerified: !!a3.emailVerified, phoneNumber: a3.phoneNumber, lastLoginAt: a3.lastLoginAt, createdAt: a3.createdAt, tenantId: a3.tenantId });
    for (var b3 = en2(a3), c3 = 0; c3 < b3.length; c3++)
      Zm2(this, b3[c3]);
    an2(this, "isAnonymous", !(this.email && a3.passwordHash) && !(this.providerData && this.providerData.length));
    this.dispatchEvent(new sm2("userReloaded", { gd: a3 }));
  };
  function en2(a3) {
    return (a3 = a3.providerUserInfo) && a3.length ? Ra2(a3, function(b3) {
      return new Hm2(b3.rawId, b3.providerId, b3.email, b3.displayName, b3.photoUrl, b3.phoneNumber);
    }) : [];
  }
  k3.Kc = function(a3) {
    gf2("firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");
    return this.sb(a3);
  };
  k3.sb = function(a3) {
    var b3 = this, c3 = null;
    return R3(this, a3.c(this.a, this.uid).then(function(d3) {
      wm2(b3, d3);
      c3 = fn2(b3, d3, "reauthenticate");
      b3.f = null;
      return b3.reload();
    }).then(function() {
      return c3;
    }), true);
  };
  function gn2(a3, b3) {
    return cn2(a3).then(function() {
      if (Va2(Ym2(a3), b3))
        return Um2(a3).then(function() {
          throw new t3("provider-already-linked");
        });
    });
  }
  k3.Bc = function(a3) {
    gf2("firebase.User.prototype.linkAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");
    return this.pb(a3);
  };
  k3.pb = function(a3) {
    var b3 = this, c3 = null;
    return R3(this, gn2(this, a3.providerId).then(function() {
      return b3.I();
    }).then(function(d3) {
      return a3.b(b3.a, d3);
    }).then(function(d3) {
      c3 = fn2(b3, d3, "link");
      return hn2(b3, d3);
    }).then(function() {
      return c3;
    }));
  };
  k3.Cc = function(a3, b3) {
    var c3 = this;
    return R3(this, gn2(this, "phone").then(function() {
      return gm2(Qm2(c3), a3, b3, q3(c3.pb, c3));
    }));
  };
  k3.Lc = function(a3, b3) {
    var c3 = this;
    return R3(this, E3().then(function() {
      return gm2(Qm2(c3), a3, b3, q3(c3.sb, c3));
    }), true);
  };
  function fn2(a3, b3, c3) {
    var d3 = qh2(b3);
    b3 = og2(b3);
    return kf2({ user: a3, credential: d3, additionalUserInfo: b3, operationType: c3 });
  }
  function hn2(a3, b3) {
    wm2(a3, b3);
    return a3.reload().then(function() {
      return a3;
    });
  }
  k3.Ab = function(a3) {
    var b3 = this;
    return R3(this, this.I().then(function(c3) {
      return b3.a.Ab(c3, a3);
    }).then(function(c3) {
      wm2(b3, c3);
      return b3.reload();
    }));
  };
  k3.dd = function(a3) {
    var b3 = this;
    return R3(this, this.I().then(function(c3) {
      return a3.b(b3.a, c3);
    }).then(function(c3) {
      wm2(b3, c3);
      return b3.reload();
    }));
  };
  k3.Bb = function(a3) {
    var b3 = this;
    return R3(this, this.I().then(function(c3) {
      return b3.a.Bb(c3, a3);
    }).then(function(c3) {
      wm2(b3, c3);
      return b3.reload();
    }));
  };
  k3.Cb = function(a3) {
    if (a3.displayName === void 0 && a3.photoURL === void 0)
      return Xm2(this);
    var b3 = this;
    return R3(this, this.I().then(function(c3) {
      return b3.a.Cb(c3, { displayName: a3.displayName, photoUrl: a3.photoURL });
    }).then(function(c3) {
      wm2(b3, c3);
      an2(b3, "displayName", c3.displayName || null);
      an2(b3, "photoURL", c3.photoUrl || null);
      w3(b3.providerData, function(d3) {
        d3.providerId === "password" && (M3(d3, "displayName", b3.displayName), M3(d3, "photoURL", b3.photoURL));
      });
      return Um2(b3);
    }).then(Wm2));
  };
  k3.bd = function(a3) {
    var b3 = this;
    return R3(this, cn2(this).then(function(c3) {
      return Va2(Ym2(b3), a3) ? rj2(b3.a, c3, [a3]).then(function(d3) {
        var e28 = {};
        w3(d3.providerUserInfo || [], function(f3) {
          e28[f3.providerId] = true;
        });
        w3(Ym2(b3), function(f3) {
          e28[f3] || $m2(b3, f3);
        });
        e28[lh.PROVIDER_ID] || M3(b3, "phoneNumber", null);
        return Um2(b3);
      }) : Um2(b3).then(function() {
        throw new t3("no-such-provider");
      });
    }));
  };
  k3.delete = function() {
    var a3 = this;
    return R3(this, this.I().then(function(b3) {
      return O3(a3.a, Fj2, { idToken: b3 });
    }).then(function() {
      a3.dispatchEvent(new sm2("userDeleted"));
    })).then(function() {
      for (var b3 = 0; b3 < a3.G.length; b3++)
        a3.G[b3].cancel("app-deleted");
      Nm2(a3, null);
      Om2(a3, null);
      Pm2(a3, null);
      a3.G = [];
      a3.A = true;
      Sm2(a3);
      M3(a3, "refreshToken", null);
      a3.h && Ql2(a3.h, a3);
    });
  };
  k3.Eb = function(a3, b3) {
    return a3 == "linkViaPopup" && (this.i || null) == b3 && this.g || a3 == "reauthViaPopup" && (this.i || null) == b3 && this.g || a3 == "linkViaRedirect" && (this.ga || null) == b3 || a3 == "reauthViaRedirect" && (this.ga || null) == b3 ? true : false;
  };
  k3.ma = function(a3, b3, c3, d3) {
    a3 != "linkViaPopup" && a3 != "reauthViaPopup" || d3 != (this.i || null) || (c3 && this.O ? this.O(c3) : b3 && !c3 && this.g && this.g(b3), this.c && (this.c.cancel(), this.c = null), delete this.g, delete this.O);
  };
  k3.Fa = function(a3, b3) {
    return a3 == "linkViaPopup" && b3 == (this.i || null) ? q3(this.Jb, this) : a3 == "reauthViaPopup" && b3 == (this.i || null) ? q3(this.Kb, this) : a3 == "linkViaRedirect" && (this.ga || null) == b3 ? q3(this.Jb, this) : a3 == "reauthViaRedirect" && (this.ga || null) == b3 ? q3(this.Kb, this) : null;
  };
  k3.Dc = function(a3) {
    var b3 = this;
    return jn2(this, "linkViaPopup", a3, function() {
      return gn2(b3, a3.providerId).then(function() {
        return Um2(b3);
      });
    }, false);
  };
  k3.Mc = function(a3) {
    return jn2(this, "reauthViaPopup", a3, function() {
      return E3();
    }, true);
  };
  function jn2(a3, b3, c3, d3, e28) {
    if (!Re2())
      return F3(new t3("operation-not-supported-in-this-environment"));
    if (a3.f && !e28)
      return F3(a3.f);
    var f3 = ng2(c3.providerId), g3 = Qe2(a3.uid + ":::"), h3 = null;
    (!Te2() || Ie2()) && a3.s && c3.isOAuthProvider && (h3 = ek2(a3.s, a3.l, a3.m, b3, c3, null, g3, firebase$1.SDK_VERSION || null, null, null, a3.tenantId));
    var n3 = ze2(h3, f3 && f3.ua, f3 && f3.ta);
    d3 = d3().then(function() {
      kn2(a3);
      if (!e28)
        return a3.I().then(function() {
        });
    }).then(function() {
      return Tl(a3.h, n3, b3, c3, g3, !!h3, a3.tenantId);
    }).then(function() {
      return new D3(function(p3, v3) {
        a3.ma(b3, null, new t3("cancelled-popup-request"), a3.i || null);
        a3.g = p3;
        a3.O = v3;
        a3.i = g3;
        a3.c = Vl2(a3.h, a3, b3, n3, g3);
      });
    }).then(function(p3) {
      n3 && ye2(n3);
      return p3 ? kf2(p3) : null;
    }).o(function(p3) {
      n3 && ye2(n3);
      throw p3;
    });
    return R3(a3, d3, e28);
  }
  k3.Ec = function(a3) {
    var b3 = this;
    return ln2(this, "linkViaRedirect", a3, function() {
      return gn2(b3, a3.providerId);
    }, false);
  };
  k3.Nc = function(a3) {
    return ln2(this, "reauthViaRedirect", a3, function() {
      return E3();
    }, true);
  };
  function ln2(a3, b3, c3, d3, e28) {
    if (!Re2())
      return F3(new t3("operation-not-supported-in-this-environment"));
    if (a3.f && !e28)
      return F3(a3.f);
    var f3 = null, g3 = Qe2(a3.uid + ":::");
    d3 = d3().then(function() {
      kn2(a3);
      if (!e28)
        return a3.I().then(function() {
        });
    }).then(function() {
      a3.ga = g3;
      return Um2(a3);
    }).then(function(h3) {
      a3.ha && (h3 = a3.ha, h3 = h3.b.set(mn2, a3.w(), h3.a));
      return h3;
    }).then(function() {
      return Ul2(a3.h, b3, c3, g3, a3.tenantId);
    }).o(function(h3) {
      f3 = h3;
      if (a3.ha)
        return nn2(a3.ha);
      throw f3;
    }).then(function() {
      if (f3)
        throw f3;
    });
    return R3(a3, d3, e28);
  }
  function kn2(a3) {
    if (!a3.h || !a3.P) {
      if (a3.h && !a3.P)
        throw new t3("internal-error");
      throw new t3("auth-domain-config-required");
    }
  }
  k3.Jb = function(a3, b3, c3, d3) {
    var e28 = this;
    this.c && (this.c.cancel(), this.c = null);
    var f3 = null;
    c3 = this.I().then(function(g3) {
      return Hg(e28.a, { requestUri: a3, postBody: d3, sessionId: b3, idToken: g3 });
    }).then(function(g3) {
      f3 = fn2(e28, g3, "link");
      return hn2(e28, g3);
    }).then(function() {
      return f3;
    });
    return R3(this, c3);
  };
  k3.Kb = function(a3, b3, c3, d3) {
    var e28 = this;
    this.c && (this.c.cancel(), this.c = null);
    var f3 = null, g3 = E3().then(function() {
      return Cg(Ig(e28.a, { requestUri: a3, sessionId: b3, postBody: d3, tenantId: c3 }), e28.uid);
    }).then(function(h3) {
      f3 = fn2(e28, h3, "reauthenticate");
      wm2(e28, h3);
      e28.f = null;
      return e28.reload();
    }).then(function() {
      return f3;
    });
    return R3(this, g3, true);
  };
  k3.tb = function(a3) {
    var b3 = this, c3 = null;
    return R3(this, this.I().then(function(d3) {
      c3 = d3;
      return typeof a3 === "undefined" || mb2(a3) ? {} : bg(new Sf2(a3));
    }).then(function(d3) {
      return b3.a.tb(c3, d3);
    }).then(function(d3) {
      if (b3.email != d3)
        return b3.reload();
    }).then(function() {
    }));
  };
  k3.Db = function(a3, b3) {
    var c3 = this, d3 = null;
    return R3(this, this.I().then(function(e28) {
      d3 = e28;
      return typeof b3 === "undefined" || mb2(b3) ? {} : bg(new Sf2(b3));
    }).then(function(e28) {
      return c3.a.Db(d3, a3, e28);
    }).then(function(e28) {
      if (c3.email != e28)
        return c3.reload();
    }).then(function() {
    }));
  };
  function R3(a3, b3, c3) {
    var d3 = on2(a3, b3, c3);
    a3.G.push(d3);
    d3.na(function() {
      Wa2(a3.G, d3);
    });
    return d3.o(function(e28) {
      var f3 = null;
      e28 && e28.code === "auth/multi-factor-auth-required" && (f3 = mm2(e28.w(), Qm2(a3), q3(a3.ic, a3)));
      throw f3 || e28;
    });
  }
  k3.ic = function(a3) {
    var b3 = null, c3 = this;
    a3 = Cg(E3(a3), c3.uid).then(function(d3) {
      b3 = fn2(c3, d3, "reauthenticate");
      wm2(c3, d3);
      c3.f = null;
      return c3.reload();
    }).then(function() {
      return b3;
    });
    return R3(this, a3, true);
  };
  function on2(a3, b3, c3) {
    return a3.f && !c3 ? (b3.cancel(), F3(a3.f)) : b3.o(function(d3) {
      !d3 || d3.code != "auth/user-disabled" && d3.code != "auth/user-token-expired" || (a3.f || a3.dispatchEvent(new sm2("userInvalidated")), a3.f = d3);
      throw d3;
    });
  }
  k3.toJSON = function() {
    return this.w();
  };
  k3.w = function() {
    var a3 = { uid: this.uid, displayName: this.displayName, photoURL: this.photoURL, email: this.email, emailVerified: this.emailVerified, phoneNumber: this.phoneNumber, isAnonymous: this.isAnonymous, tenantId: this.tenantId, providerData: [], apiKey: this.l, appName: this.m, authDomain: this.s, stsTokenManager: this.b.w(), redirectEventId: this.ga || null };
    this.metadata && z3(a3, this.metadata.w());
    w3(this.providerData, function(b3) {
      a3.providerData.push(lf2(b3));
    });
    z3(a3, this.N.w());
    return a3;
  };
  function pn2(a3) {
    if (!a3.apiKey)
      return null;
    var b3 = { apiKey: a3.apiKey, authDomain: a3.authDomain, appName: a3.appName, emulatorConfig: a3.emulatorConfig }, c3 = {};
    if (a3.stsTokenManager && a3.stsTokenManager.accessToken) {
      c3[Dg] = a3.stsTokenManager.accessToken;
      c3.refreshToken = a3.stsTokenManager.refreshToken || null;
      var d3 = a3.stsTokenManager.expirationTime;
      d3 && (c3.expiresIn = (d3 - Date.now()) / 1e3);
    } else
      return null;
    var e28 = new Im2(b3, c3, a3);
    a3.providerData && w3(a3.providerData, function(f3) {
      f3 && Zm2(e28, kf2(f3));
    });
    a3.redirectEventId && (e28.ga = a3.redirectEventId);
    return e28;
  }
  function qn2(a3, b3, c3, d3) {
    var e28 = new Im2(a3, b3);
    c3 && (e28.ha = c3);
    d3 && Mm2(e28, d3);
    return e28.reload().then(function() {
      return e28;
    });
  }
  function rn2(a3, b3, c3, d3) {
    var e28 = a3.b, f3 = {};
    f3[Dg] = e28.b && e28.b.toString();
    f3.refreshToken = e28.a;
    b3 = new Im2(b3 || { apiKey: a3.l, authDomain: a3.s, appName: a3.m }, f3);
    c3 && (b3.ha = c3);
    d3 && Mm2(b3, d3);
    bn2(b3, a3);
    return b3;
  }
  function sn2(a3) {
    this.a = a3;
    this.b = Vk2();
  }
  var mn2 = { name: "redirectUser", D: "session" };
  function nn2(a3) {
    return Zk2(a3.b, mn2, a3.a);
  }
  function tn2(a3, b3) {
    return a3.b.get(mn2, a3.a).then(function(c3) {
      c3 && b3 && (c3.authDomain = b3);
      return pn2(c3 || {});
    });
  }
  function un2(a3) {
    this.a = a3;
    this.b = Vk2();
    this.c = null;
    this.f = vn2(this);
    this.b.addListener(wn2("local"), this.a, q3(this.g, this));
  }
  un2.prototype.g = function() {
    var a3 = this, b3 = wn2("local");
    xn2(this, function() {
      return E3().then(function() {
        return a3.c && a3.c.D != "local" ? a3.b.get(b3, a3.a) : null;
      }).then(function(c3) {
        if (c3)
          return yn2(a3, "local").then(function() {
            a3.c = b3;
          });
      });
    });
  };
  function yn2(a3, b3) {
    var c3 = [], d3;
    for (d3 in Rk2)
      Rk2[d3] !== b3 && c3.push(Zk2(a3.b, wn2(Rk2[d3]), a3.a));
    c3.push(Zk2(a3.b, zn2, a3.a));
    return Ic2(c3);
  }
  function vn2(a3) {
    var b3 = wn2("local"), c3 = wn2("session"), d3 = wn2("none");
    return Yk2(a3.b, b3, a3.a).then(function() {
      return a3.b.get(c3, a3.a);
    }).then(function(e28) {
      return e28 ? c3 : a3.b.get(d3, a3.a).then(function(f3) {
        return f3 ? d3 : a3.b.get(b3, a3.a).then(function(g3) {
          return g3 ? b3 : a3.b.get(zn2, a3.a).then(function(h3) {
            return h3 ? wn2(h3) : b3;
          });
        });
      });
    }).then(function(e28) {
      a3.c = e28;
      return yn2(a3, e28.D);
    }).o(function() {
      a3.c || (a3.c = b3);
    });
  }
  var zn2 = { name: "persistence", D: "session" };
  function wn2(a3) {
    return { name: "authUser", D: a3 };
  }
  un2.prototype.wb = function(a3) {
    var b3 = null, c3 = this;
    Sk2(a3);
    return xn2(this, function() {
      return a3 != c3.c.D ? c3.b.get(c3.c, c3.a).then(function(d3) {
        b3 = d3;
        return yn2(c3, a3);
      }).then(function() {
        c3.c = wn2(a3);
        if (b3)
          return c3.b.set(c3.c, b3, c3.a);
      }) : E3();
    });
  };
  function An2(a3) {
    return xn2(a3, function() {
      return a3.b.set(zn2, a3.c.D, a3.a);
    });
  }
  function Bn2(a3, b3) {
    return xn2(a3, function() {
      return a3.b.set(a3.c, b3.w(), a3.a);
    });
  }
  function Cn2(a3) {
    return xn2(a3, function() {
      return Zk2(a3.b, a3.c, a3.a);
    });
  }
  function Dn2(a3, b3, c3) {
    return xn2(a3, function() {
      return a3.b.get(a3.c, a3.a).then(function(d3) {
        d3 && b3 && (d3.authDomain = b3);
        d3 && c3 && (d3.emulatorConfig = c3);
        return pn2(d3 || {});
      });
    });
  }
  function xn2(a3, b3) {
    a3.f = a3.f.then(b3, b3);
    return a3.f;
  }
  function En2(a3) {
    this.m = false;
    M3(this, "settings", new em2());
    M3(this, "app", a3);
    if (S3(this).options && S3(this).options.apiKey)
      a3 = firebase$1.SDK_VERSION ? Oe2(firebase$1.SDK_VERSION) : null, this.a = new Ii2(S3(this).options && S3(this).options.apiKey, Ca2(Da2), a3);
    else
      throw new t3("invalid-api-key");
    this.R = [];
    this.u = [];
    this.P = [];
    this.ac = firebase$1.INTERNAL.createSubscribe(q3(this.yc, this));
    this.X = void 0;
    this.bc = firebase$1.INTERNAL.createSubscribe(q3(this.zc, this));
    Fn2(this, null);
    this.l = new un2(S3(this).options.apiKey + ":" + S3(this).name);
    this.G = new sn2(S3(this).options.apiKey + ":" + S3(this).name);
    this.$ = T3(this, Gn2(this));
    this.h = T3(this, Hn2(this));
    this.ba = false;
    this.pa = q3(this.Yc, this);
    this.Ba = q3(this.da, this);
    this.ya = q3(this.kc, this);
    this.za = q3(this.vc, this);
    this.Aa = q3(this.wc, this);
    this.b = null;
    In2(this);
    this.INTERNAL = {};
    this.INTERNAL["delete"] = q3(this.delete, this);
    this.INTERNAL.logFramework = q3(this.Fc, this);
    this.A = 0;
    I3.call(this);
    Jn2(this);
    this.N = [];
    this.f = null;
  }
  r3(En2, I3);
  function Kn2(a3) {
    G3.call(this, "languageCodeChanged");
    this.i = a3;
  }
  r3(Kn2, G3);
  function Ln2(a3) {
    G3.call(this, "emulatorConfigChanged");
    this.c = a3;
  }
  r3(Ln2, G3);
  function Mn2(a3) {
    G3.call(this, "frameworkChanged");
    this.f = a3;
  }
  r3(Mn2, G3);
  k3 = En2.prototype;
  k3.wb = function(a3) {
    a3 = this.l.wb(a3);
    return T3(this, a3);
  };
  k3.wa = function(a3) {
    this.aa === a3 || this.m || (this.aa = a3, Oi2(this.a, this.aa), this.dispatchEvent(new Kn2(this.ka())));
  };
  k3.ka = function() {
    return this.aa;
  };
  k3.ed = function() {
    var a3 = l3.navigator;
    this.wa(a3 ? a3.languages && a3.languages[0] || a3.language || a3.userLanguage || null : null);
  };
  k3.fd = function(a3, b3) {
    if (!this.f) {
      if (!/^https?:\/\//.test(a3))
        throw new t3("argument-error", "Emulator URL must start with a valid scheme (http:// or https://).");
      Nn2(b3 ? !!b3.disableWarnings : false);
      this.f = { url: a3 };
      this.settings.hb = true;
      Pi2(this.a, this.f);
      this.dispatchEvent(new Ln2(this.f));
    }
  };
  function Nn2(a3) {
    typeof console !== "undefined" && typeof console.info === "function" && console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    l3.document && !a3 && Ee2().then(function() {
      var b3 = l3.document.createElement("div");
      b3.innerText = "Running in emulator mode. Do not use with production credentials.";
      b3.style.position = "fixed";
      b3.style.width = "100%";
      b3.style.backgroundColor = "#ffffff";
      b3.style.border = ".1em solid #000000";
      b3.style.color = "#ff0000";
      b3.style.bottom = "0px";
      b3.style.left = "0px";
      b3.style.margin = "0px";
      b3.style.zIndex = 1e4;
      b3.style.textAlign = "center";
      b3.classList.add("firebase-emulator-warning");
      l3.document.body.appendChild(b3);
    });
  }
  k3.Fc = function(a3) {
    this.N.push(a3);
    Ri2(this.a, firebase$1.SDK_VERSION ? Oe2(firebase$1.SDK_VERSION, this.N) : null);
    this.dispatchEvent(new Mn2(this.N));
  };
  k3.Ga = function() {
    return Za2(this.N);
  };
  k3.xb = function(a3) {
    this.W === a3 || this.m || (this.W = a3, this.a.b = this.W);
  };
  k3.S = function() {
    return this.W;
  };
  function Jn2(a3) {
    Object.defineProperty(a3, "lc", { get: function() {
      return this.ka();
    }, set: function(b3) {
      this.wa(b3);
    }, enumerable: false });
    a3.aa = null;
    Object.defineProperty(a3, "ti", { get: function() {
      return this.S();
    }, set: function(b3) {
      this.xb(b3);
    }, enumerable: false });
    a3.W = null;
  }
  k3.toJSON = function() {
    return { apiKey: S3(this).options.apiKey, authDomain: S3(this).options.authDomain, appName: S3(this).name, currentUser: U3(this) && U3(this).w() };
  };
  function On2(a3) {
    return a3.gb || F3(new t3("auth-domain-config-required"));
  }
  function In2(a3) {
    var b3 = S3(a3).options.authDomain, c3 = S3(a3).options.apiKey;
    b3 && Re2() && (a3.gb = a3.$.then(function() {
      if (!a3.m) {
        a3.b = Xl2(b3, c3, S3(a3).name, a3.f);
        Pl2(a3.b, a3);
        U3(a3) && Vm2(U3(a3));
        if (a3.s) {
          Vm2(a3.s);
          var d3 = a3.s;
          d3.wa(a3.ka());
          Nm2(d3, a3);
          d3 = a3.s;
          Mm2(d3, a3.N);
          Pm2(d3, a3);
          d3 = a3.s;
          Pi2(d3.a, a3.f);
          Om2(d3, a3);
          a3.s = null;
        }
        return a3.b;
      }
    }));
  }
  k3.Eb = function(a3, b3) {
    switch (a3) {
      case "unknown":
      case "signInViaRedirect":
        return true;
      case "signInViaPopup":
        return this.i == b3 && !!this.g;
      default:
        return false;
    }
  };
  k3.ma = function(a3, b3, c3, d3) {
    a3 == "signInViaPopup" && this.i == d3 && (c3 && this.O ? this.O(c3) : b3 && !c3 && this.g && this.g(b3), this.c && (this.c.cancel(), this.c = null), delete this.g, delete this.O);
  };
  k3.Fa = function(a3, b3) {
    return a3 == "signInViaRedirect" || a3 == "signInViaPopup" && this.i == b3 && this.g ? q3(this.hc, this) : null;
  };
  k3.hc = function(a3, b3, c3, d3) {
    var e28 = this, f3 = { requestUri: a3, postBody: d3, sessionId: b3, tenantId: c3 };
    this.c && (this.c.cancel(), this.c = null);
    return e28.$.then(function() {
      return Pn2(e28, Fg(e28.a, f3));
    });
  };
  k3.Wc = function(a3) {
    if (!Re2())
      return F3(new t3("operation-not-supported-in-this-environment"));
    var b3 = this, c3 = ng2(a3.providerId), d3 = Qe2(), e28 = null;
    (!Te2() || Ie2()) && S3(this).options.authDomain && a3.isOAuthProvider && (e28 = ek2(S3(this).options.authDomain, S3(this).options.apiKey, S3(this).name, "signInViaPopup", a3, null, d3, firebase$1.SDK_VERSION || null, null, null, this.S(), this.f));
    var f3 = ze2(e28, c3 && c3.ua, c3 && c3.ta);
    c3 = On2(this).then(function(g3) {
      return Tl(g3, f3, "signInViaPopup", a3, d3, !!e28, b3.S());
    }).then(function() {
      return new D3(function(g3, h3) {
        b3.ma("signInViaPopup", null, new t3("cancelled-popup-request"), b3.i);
        b3.g = g3;
        b3.O = h3;
        b3.i = d3;
        b3.c = Vl2(b3.b, b3, "signInViaPopup", f3, d3);
      });
    }).then(function(g3) {
      f3 && ye2(f3);
      return g3 ? kf2(g3) : null;
    }).o(function(g3) {
      f3 && ye2(f3);
      throw g3;
    });
    return T3(this, c3);
  };
  k3.Xc = function(a3) {
    if (!Re2())
      return F3(new t3("operation-not-supported-in-this-environment"));
    var b3 = this, c3 = On2(this).then(function() {
      return An2(b3.l);
    }).then(function() {
      return Ul2(b3.b, "signInViaRedirect", a3, void 0, b3.S());
    });
    return T3(this, c3);
  };
  function Qn2(a3) {
    if (!Re2())
      return F3(new t3("operation-not-supported-in-this-environment"));
    var b3 = On2(a3).then(function() {
      return a3.b.qa();
    }).then(function(c3) {
      return c3 ? kf2(c3) : null;
    });
    return T3(a3, b3);
  }
  k3.qa = function() {
    var a3 = this;
    return Qn2(this).then(function(b3) {
      a3.b && $l2(a3.b.b);
      return b3;
    }).o(function(b3) {
      a3.b && $l2(a3.b.b);
      throw b3;
    });
  };
  k3.cd = function(a3) {
    if (!a3)
      return F3(new t3("null-user"));
    if (this.W != a3.tenantId)
      return F3(new t3("tenant-id-mismatch"));
    var b3 = this, c3 = {};
    c3.apiKey = S3(this).options.apiKey;
    c3.authDomain = S3(this).options.authDomain;
    c3.appName = S3(this).name;
    var d3 = rn2(a3, c3, b3.G, b3.Ga());
    return T3(this, this.h.then(function() {
      if (S3(b3).options.apiKey != a3.l)
        return d3.reload();
    }).then(function() {
      if (U3(b3) && a3.uid == U3(b3).uid)
        return bn2(U3(b3), a3), b3.da(a3);
      Fn2(b3, d3);
      Vm2(d3);
      return b3.da(d3);
    }).then(function() {
      Rn2(b3);
    }));
  };
  function Sn2(a3, b3) {
    var c3 = {};
    c3.apiKey = S3(a3).options.apiKey;
    c3.authDomain = S3(a3).options.authDomain;
    c3.appName = S3(a3).name;
    a3.f && (c3.emulatorConfig = a3.f);
    return a3.$.then(function() {
      return qn2(c3, b3, a3.G, a3.Ga());
    }).then(function(d3) {
      if (U3(a3) && d3.uid == U3(a3).uid)
        return bn2(U3(a3), d3), a3.da(d3);
      Fn2(a3, d3);
      Vm2(d3);
      return a3.da(d3);
    }).then(function() {
      Rn2(a3);
    });
  }
  function Fn2(a3, b3) {
    U3(a3) && (Tm2(U3(a3), a3.Ba), H3(U3(a3), "tokenChanged", a3.ya), H3(U3(a3), "userDeleted", a3.za), H3(U3(a3), "userInvalidated", a3.Aa), Sm2(U3(a3)));
    b3 && (b3.R.push(a3.Ba), nd2(b3, "tokenChanged", a3.ya), nd2(b3, "userDeleted", a3.za), nd2(b3, "userInvalidated", a3.Aa), 0 < a3.A && Rm2(b3));
    M3(a3, "currentUser", b3);
    b3 && (b3.wa(a3.ka()), Nm2(b3, a3), Mm2(b3, a3.N), Pm2(b3, a3), Pi2(b3.a, a3.f), Om2(b3, a3));
  }
  k3.zb = function() {
    var a3 = this, b3 = this.h.then(function() {
      a3.b && $l2(a3.b.b);
      if (!U3(a3))
        return E3();
      Fn2(a3, null);
      return Cn2(a3.l).then(function() {
        Rn2(a3);
      });
    });
    return T3(this, b3);
  };
  function Tn2(a3) {
    var b3 = tn2(a3.G, S3(a3).options.authDomain).then(function(c3) {
      if (a3.s = c3)
        c3.ha = a3.G;
      return nn2(a3.G);
    });
    return T3(a3, b3);
  }
  function Gn2(a3) {
    var b3 = S3(a3).options.authDomain, c3 = Tn2(a3).then(function() {
      return Dn2(a3.l, b3, a3.f);
    }).then(function(d3) {
      return d3 ? (d3.ha = a3.G, a3.s && (a3.s.ga || null) == (d3.ga || null) ? d3 : d3.reload().then(function() {
        return Bn2(a3.l, d3).then(function() {
          return d3;
        });
      }).o(function(e28) {
        return e28.code == "auth/network-request-failed" ? d3 : Cn2(a3.l);
      })) : null;
    }).then(function(d3) {
      Fn2(a3, d3 || null);
    });
    return T3(a3, c3);
  }
  function Hn2(a3) {
    return a3.$.then(function() {
      return Qn2(a3);
    }).o(function() {
    }).then(function() {
      if (!a3.m)
        return a3.pa();
    }).o(function() {
    }).then(function() {
      if (!a3.m) {
        a3.ba = true;
        var b3 = a3.l;
        b3.b.addListener(wn2("local"), b3.a, a3.pa);
      }
    });
  }
  k3.Yc = function() {
    var a3 = this;
    return Dn2(this.l, S3(this).options.authDomain).then(function(b3) {
      if (!a3.m) {
        var c3;
        if (c3 = U3(a3) && b3) {
          c3 = U3(a3).uid;
          var d3 = b3.uid;
          c3 = c3 === void 0 || c3 === null || c3 === "" || d3 === void 0 || d3 === null || d3 === "" ? false : c3 == d3;
        }
        if (c3)
          return bn2(U3(a3), b3), U3(a3).I();
        if (U3(a3) || b3)
          Fn2(a3, b3), b3 && (Vm2(b3), b3.ha = a3.G), a3.b && Pl2(a3.b, a3), Rn2(a3);
      }
    });
  };
  k3.da = function(a3) {
    return Bn2(this.l, a3);
  };
  k3.kc = function() {
    Rn2(this);
    this.da(U3(this));
  };
  k3.vc = function() {
    this.zb();
  };
  k3.wc = function() {
    this.zb();
  };
  function Pn2(a3, b3) {
    var c3 = null, d3 = null;
    return T3(a3, b3.then(function(e28) {
      c3 = qh2(e28);
      d3 = og2(e28);
      return Sn2(a3, e28);
    }, function(e28) {
      var f3 = null;
      e28 && e28.code === "auth/multi-factor-auth-required" && (f3 = mm2(e28.w(), a3, q3(a3.jc, a3)));
      throw f3 || e28;
    }).then(function() {
      return kf2({ user: U3(a3), credential: c3, additionalUserInfo: d3, operationType: "signIn" });
    }));
  }
  k3.jc = function(a3) {
    var b3 = this;
    return this.h.then(function() {
      return Pn2(b3, E3(a3));
    });
  };
  k3.yc = function(a3) {
    var b3 = this;
    this.addAuthTokenListener(function() {
      a3.next(U3(b3));
    });
  };
  k3.zc = function(a3) {
    var b3 = this;
    Un2(this, function() {
      a3.next(U3(b3));
    });
  };
  k3.Hc = function(a3, b3, c3) {
    var d3 = this;
    this.ba && Promise.resolve().then(function() {
      typeof a3 === "function" ? a3(U3(d3)) : typeof a3.next === "function" && a3.next(U3(d3));
    });
    return this.ac(a3, b3, c3);
  };
  k3.Gc = function(a3, b3, c3) {
    var d3 = this;
    this.ba && Promise.resolve().then(function() {
      d3.X = d3.getUid();
      typeof a3 === "function" ? a3(U3(d3)) : typeof a3.next === "function" && a3.next(U3(d3));
    });
    return this.bc(a3, b3, c3);
  };
  k3.mc = function(a3) {
    var b3 = this, c3 = this.h.then(function() {
      return U3(b3) ? U3(b3).I(a3).then(function(d3) {
        return { accessToken: d3 };
      }) : null;
    });
    return T3(this, c3);
  };
  k3.Sc = function(a3) {
    var b3 = this;
    return this.h.then(function() {
      return Pn2(b3, O3(b3.a, Kj2, { token: a3 }));
    }).then(function(c3) {
      var d3 = c3.user;
      an2(d3, "isAnonymous", false);
      b3.da(d3);
      return c3;
    });
  };
  k3.Tc = function(a3, b3) {
    var c3 = this;
    return this.h.then(function() {
      return Pn2(c3, O3(c3.a, ah, { email: a3, password: b3 }));
    });
  };
  k3.dc = function(a3, b3) {
    var c3 = this;
    return this.h.then(function() {
      return Pn2(c3, O3(c3.a, Ej2, { email: a3, password: b3 }));
    });
  };
  k3.Za = function(a3) {
    var b3 = this;
    return this.h.then(function() {
      return Pn2(b3, a3.ja(b3.a));
    });
  };
  k3.Rc = function(a3) {
    gf2("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInWithCredential instead.");
    return this.Za(a3);
  };
  k3.yb = function() {
    var a3 = this;
    return this.h.then(function() {
      var b3 = U3(a3);
      if (b3 && b3.isAnonymous) {
        var c3 = kf2({ providerId: null, isNewUser: false });
        return kf2({ user: b3, credential: null, additionalUserInfo: c3, operationType: "signIn" });
      }
      return Pn2(a3, a3.a.yb()).then(function(d3) {
        var e28 = d3.user;
        an2(e28, "isAnonymous", true);
        a3.da(e28);
        return d3;
      });
    });
  };
  function S3(a3) {
    return a3.app;
  }
  function U3(a3) {
    return a3.currentUser;
  }
  k3.getUid = function() {
    return U3(this) && U3(this).uid || null;
  };
  function Vn2(a3) {
    return U3(a3) && U3(a3)._lat || null;
  }
  function Rn2(a3) {
    if (a3.ba) {
      for (var b3 = 0; b3 < a3.u.length; b3++)
        if (a3.u[b3])
          a3.u[b3](Vn2(a3));
      if (a3.X !== a3.getUid() && a3.P.length) {
        for (a3.X = a3.getUid(), b3 = 0; b3 < a3.P.length; b3++)
          if (a3.P[b3])
            a3.P[b3](Vn2(a3));
      }
    }
  }
  k3.cc = function(a3) {
    this.addAuthTokenListener(a3);
    this.A++;
    0 < this.A && U3(this) && Rm2(U3(this));
  };
  k3.Oc = function(a3) {
    var b3 = this;
    w3(this.u, function(c3) {
      c3 == a3 && b3.A--;
    });
    0 > this.A && (this.A = 0);
    this.A == 0 && U3(this) && Sm2(U3(this));
    this.removeAuthTokenListener(a3);
  };
  k3.addAuthTokenListener = function(a3) {
    var b3 = this;
    this.u.push(a3);
    T3(this, this.h.then(function() {
      b3.m || Va2(b3.u, a3) && a3(Vn2(b3));
    }));
  };
  k3.removeAuthTokenListener = function(a3) {
    Xa2(this.u, function(b3) {
      return b3 == a3;
    });
  };
  function Un2(a3, b3) {
    a3.P.push(b3);
    T3(a3, a3.h.then(function() {
      !a3.m && Va2(a3.P, b3) && a3.X !== a3.getUid() && (a3.X = a3.getUid(), b3(Vn2(a3)));
    }));
  }
  k3.delete = function() {
    this.m = true;
    for (var a3 = 0; a3 < this.R.length; a3++)
      this.R[a3].cancel("app-deleted");
    this.R = [];
    this.l && (a3 = this.l, a3.b.removeListener(wn2("local"), a3.a, this.pa));
    this.b && (Ql2(this.b, this), $l2(this.b.b));
    return Promise.resolve();
  };
  function T3(a3, b3) {
    a3.R.push(b3);
    b3.na(function() {
      Wa2(a3.R, b3);
    });
    return b3;
  }
  k3.gc = function(a3) {
    return T3(this, aj2(this.a, a3));
  };
  k3.Ac = function(a3) {
    return !!fh(a3);
  };
  k3.vb = function(a3, b3) {
    var c3 = this;
    return T3(this, E3().then(function() {
      var d3 = new Sf2(b3);
      if (!d3.c)
        throw new t3("argument-error", $f + " must be true when sending sign in link to email");
      return bg(d3);
    }).then(function(d3) {
      return c3.a.vb(a3, d3);
    }).then(function() {
    }));
  };
  k3.hd = function(a3) {
    return this.Qa(a3).then(function(b3) {
      return b3.data.email;
    });
  };
  k3.mb = function(a3, b3) {
    return T3(this, this.a.mb(a3, b3).then(function() {
    }));
  };
  k3.Qa = function(a3) {
    return T3(this, this.a.Qa(a3).then(function(b3) {
      return new vf2(b3);
    }));
  };
  k3.ib = function(a3) {
    return T3(this, this.a.ib(a3).then(function() {
    }));
  };
  k3.ub = function(a3, b3) {
    var c3 = this;
    return T3(this, E3().then(function() {
      return typeof b3 === "undefined" || mb2(b3) ? {} : bg(new Sf2(b3));
    }).then(function(d3) {
      return c3.a.ub(a3, d3);
    }).then(function() {
    }));
  };
  k3.Vc = function(a3, b3) {
    return T3(this, gm2(this, a3, b3, q3(this.Za, this)));
  };
  k3.Uc = function(a3, b3) {
    var c3 = this;
    return T3(this, E3().then(function() {
      var d3 = b3 || re2(), e28 = eh(a3, d3);
      d3 = fh(d3);
      if (!d3)
        throw new t3("argument-error", "Invalid email link!");
      if (d3.tenantId !== c3.S())
        throw new t3("tenant-id-mismatch");
      return c3.Za(e28);
    }));
  };
  function Wn2() {
  }
  Wn2.prototype.render = function() {
  };
  Wn2.prototype.reset = function() {
  };
  Wn2.prototype.getResponse = function() {
  };
  Wn2.prototype.execute = function() {
  };
  function Xn2() {
    this.a = {};
    this.b = 1e12;
  }
  var Yn2 = null;
  Xn2.prototype.render = function(a3, b3) {
    this.a[this.b.toString()] = new Zn2(a3, b3);
    return this.b++;
  };
  Xn2.prototype.reset = function(a3) {
    var b3 = $n2(this, a3);
    a3 = ao2(a3);
    b3 && a3 && (b3.delete(), delete this.a[a3]);
  };
  Xn2.prototype.getResponse = function(a3) {
    return (a3 = $n2(this, a3)) ? a3.getResponse() : null;
  };
  Xn2.prototype.execute = function(a3) {
    (a3 = $n2(this, a3)) && a3.execute();
  };
  function $n2(a3, b3) {
    return (b3 = ao2(b3)) ? a3.a[b3] || null : null;
  }
  function ao2(a3) {
    return (a3 = typeof a3 === "undefined" ? 1e12 : a3) ? a3.toString() : null;
  }
  function Zn2(a3, b3) {
    this.g = false;
    this.c = b3;
    this.a = this.b = null;
    this.i = this.c.size !== "invisible";
    this.f = kc2(a3);
    var c3 = this;
    this.h = function() {
      c3.execute();
    };
    this.i ? this.execute() : nd2(this.f, "click", this.h);
  }
  Zn2.prototype.getResponse = function() {
    bo2(this);
    return this.b;
  };
  Zn2.prototype.execute = function() {
    bo2(this);
    var a3 = this;
    this.a || (this.a = setTimeout(function() {
      a3.b = Me2();
      var b3 = a3.c.callback, c3 = a3.c["expired-callback"];
      if (b3)
        try {
          b3(a3.b);
        } catch (d3) {
        }
      a3.a = setTimeout(function() {
        a3.a = null;
        a3.b = null;
        if (c3)
          try {
            c3();
          } catch (d3) {
          }
        a3.i && a3.execute();
      }, 6e4);
    }, 500));
  };
  Zn2.prototype.delete = function() {
    bo2(this);
    this.g = true;
    clearTimeout(this.a);
    this.a = null;
    H3(this.f, "click", this.h);
  };
  function bo2(a3) {
    if (a3.g)
      throw Error("reCAPTCHA mock was already deleted!");
  }
  function co2() {
  }
  M3(co2, "FACTOR_ID", "phone");
  function eo2() {
  }
  eo2.prototype.g = function() {
    Yn2 || (Yn2 = new Xn2());
    return E3(Yn2);
  };
  eo2.prototype.c = function() {
  };
  var fo2 = null;
  function go2() {
    this.b = l3.grecaptcha ? Infinity : 0;
    this.f = null;
    this.a = "__rcb" + Math.floor(1e6 * Math.random()).toString();
  }
  var ho2 = new qb2(rb2, "https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"), io2 = new Ze2(3e4, 6e4);
  go2.prototype.g = function(a3) {
    var b3 = this;
    return new D3(function(c3, d3) {
      var e28 = setTimeout(function() {
        d3(new t3("network-request-failed"));
      }, io2.get());
      if (!l3.grecaptcha || a3 !== b3.f && !b3.b) {
        l3[b3.a] = function() {
          if (l3.grecaptcha) {
            b3.f = a3;
            var g3 = l3.grecaptcha.render;
            l3.grecaptcha.render = function(h3, n3) {
              h3 = g3(h3, n3);
              b3.b++;
              return h3;
            };
            clearTimeout(e28);
            c3(l3.grecaptcha);
          } else
            clearTimeout(e28), d3(new t3("internal-error"));
          delete l3[b3.a];
        };
        var f3 = zb2(ho2, { onload: b3.a, hl: a3 || "" });
        E3(Bi2(f3)).o(function() {
          clearTimeout(e28);
          d3(new t3("internal-error", "Unable to load external reCAPTCHA dependencies!"));
        });
      } else
        clearTimeout(e28), c3(l3.grecaptcha);
    });
  };
  go2.prototype.c = function() {
    this.b--;
  };
  var jo2 = null;
  function ko2(a3, b3, c3, d3, e28, f3, g3) {
    M3(this, "type", "recaptcha");
    this.c = this.f = null;
    this.A = false;
    this.m = b3;
    this.g = null;
    g3 ? (fo2 || (fo2 = new eo2()), g3 = fo2) : (jo2 || (jo2 = new go2()), g3 = jo2);
    this.v = g3;
    this.a = c3 || { theme: "light", type: "image" };
    this.i = [];
    if (this.a[lo2])
      throw new t3("argument-error", "sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");
    this.h = this.a[mo2] === "invisible";
    if (!l3.document)
      throw new t3("operation-not-supported-in-this-environment", "RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
    if (!kc2(b3) || !this.h && kc2(b3).hasChildNodes())
      throw new t3("argument-error", "reCAPTCHA container is either not found or already contains inner elements!");
    this.s = new Ii2(a3, f3 || null, e28 || null);
    this.u = d3 || function() {
      return null;
    };
    var h3 = this;
    this.l = [];
    var n3 = this.a[no2];
    this.a[no2] = function(v3) {
      oo2(h3, v3);
      if (typeof n3 === "function")
        n3(v3);
      else if (typeof n3 === "string") {
        var B3 = L3(n3, l3);
        typeof B3 === "function" && B3(v3);
      }
    };
    var p3 = this.a[po2];
    this.a[po2] = function() {
      oo2(h3, null);
      if (typeof p3 === "function")
        p3();
      else if (typeof p3 === "string") {
        var v3 = L3(p3, l3);
        typeof v3 === "function" && v3();
      }
    };
  }
  var no2 = "callback", po2 = "expired-callback", lo2 = "sitekey", mo2 = "size";
  function oo2(a3, b3) {
    for (var c3 = 0; c3 < a3.l.length; c3++)
      try {
        a3.l[c3](b3);
      } catch (d3) {
      }
  }
  function qo2(a3, b3) {
    Xa2(a3.l, function(c3) {
      return c3 == b3;
    });
  }
  function ro2(a3, b3) {
    a3.i.push(b3);
    b3.na(function() {
      Wa2(a3.i, b3);
    });
    return b3;
  }
  k3 = ko2.prototype;
  k3.Ia = function() {
    var a3 = this;
    return this.f ? this.f : this.f = ro2(this, E3().then(function() {
      if (Se2() && !Je2())
        return Ee2();
      throw new t3("operation-not-supported-in-this-environment", "RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");
    }).then(function() {
      return a3.v.g(a3.u());
    }).then(function(b3) {
      a3.g = b3;
      return O3(a3.s, Jj2, {});
    }).then(function(b3) {
      a3.a[lo2] = b3.recaptchaSiteKey;
    }).o(function(b3) {
      a3.f = null;
      throw b3;
    }));
  };
  k3.render = function() {
    so2(this);
    var a3 = this;
    return ro2(this, this.Ia().then(function() {
      if (a3.c === null) {
        var b3 = a3.m;
        if (!a3.h) {
          var c3 = kc2(b3);
          b3 = nc2("DIV");
          c3.appendChild(b3);
        }
        a3.c = a3.g.render(b3, a3.a);
      }
      return a3.c;
    }));
  };
  k3.verify = function() {
    so2(this);
    var a3 = this;
    return ro2(this, this.render().then(function(b3) {
      return new D3(function(c3) {
        var d3 = a3.g.getResponse(b3);
        if (d3)
          c3(d3);
        else {
          var e28 = function(f3) {
            f3 && (qo2(a3, e28), c3(f3));
          };
          a3.l.push(e28);
          a3.h && a3.g.execute(a3.c);
        }
      });
    }));
  };
  k3.reset = function() {
    so2(this);
    this.c !== null && this.g.reset(this.c);
  };
  function so2(a3) {
    if (a3.A)
      throw new t3("internal-error", "RecaptchaVerifier instance has been destroyed.");
  }
  k3.clear = function() {
    so2(this);
    this.A = true;
    this.v.c();
    for (var a3 = 0; a3 < this.i.length; a3++)
      this.i[a3].cancel("RecaptchaVerifier instance has been destroyed.");
    if (!this.h) {
      a3 = kc2(this.m);
      for (var b3; b3 = a3.firstChild; )
        a3.removeChild(b3);
    }
  };
  function to2(a3, b3, c3) {
    var d3 = false;
    try {
      this.b = c3 || firebase$1.app();
    } catch (g3) {
      throw new t3("argument-error", "No firebase.app.App instance is currently initialized.");
    }
    if (this.b.options && this.b.options.apiKey)
      c3 = this.b.options.apiKey;
    else
      throw new t3("invalid-api-key");
    var e28 = this, f3 = null;
    try {
      f3 = this.b.auth().Ga();
    } catch (g3) {
    }
    try {
      d3 = this.b.auth().settings.appVerificationDisabledForTesting;
    } catch (g3) {
    }
    f3 = firebase$1.SDK_VERSION ? Oe2(firebase$1.SDK_VERSION, f3) : null;
    ko2.call(this, c3, a3, b3, function() {
      try {
        var g3 = e28.b.auth().ka();
      } catch (h3) {
        g3 = null;
      }
      return g3;
    }, f3, Ca2(Da2), d3);
  }
  r3(to2, ko2);
  function uo2(a3, b3, c3, d3) {
    a: {
      c3 = Array.prototype.slice.call(c3);
      var e28 = 0;
      for (var f3 = false, g3 = 0; g3 < b3.length; g3++)
        if (b3[g3].optional)
          f3 = true;
        else {
          if (f3)
            throw new t3("internal-error", "Argument validator encountered a required argument after an optional argument.");
          e28++;
        }
      f3 = b3.length;
      if (c3.length < e28 || f3 < c3.length)
        d3 = "Expected " + (e28 == f3 ? e28 == 1 ? "1 argument" : e28 + " arguments" : e28 + "-" + f3 + " arguments") + " but got " + c3.length + ".";
      else {
        for (e28 = 0; e28 < c3.length; e28++)
          if (f3 = b3[e28].optional && c3[e28] === void 0, !b3[e28].K(c3[e28]) && !f3) {
            b3 = b3[e28];
            if (0 > e28 || e28 >= vo2.length)
              throw new t3("internal-error", "Argument validator received an unsupported number of arguments.");
            c3 = vo2[e28];
            d3 = (d3 ? "" : c3 + " argument ") + (b3.name ? '"' + b3.name + '" ' : "") + "must be " + b3.J + ".";
            break a;
          }
        d3 = null;
      }
    }
    if (d3)
      throw new t3("argument-error", a3 + " failed: " + d3);
  }
  var vo2 = "First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");
  function V10(a3, b3) {
    return { name: a3 || "", J: "a valid string", optional: !!b3, K: function(c3) {
      return typeof c3 === "string";
    } };
  }
  function wo2(a3, b3) {
    return { name: a3 || "", J: "a boolean", optional: !!b3, K: function(c3) {
      return typeof c3 === "boolean";
    } };
  }
  function W3(a3, b3) {
    return { name: a3 || "", J: "a valid object", optional: !!b3, K: m3 };
  }
  function xo2(a3, b3) {
    return { name: a3 || "", J: "a function", optional: !!b3, K: function(c3) {
      return typeof c3 === "function";
    } };
  }
  function yo2(a3, b3) {
    return { name: a3 || "", J: "null", optional: !!b3, K: function(c3) {
      return c3 === null;
    } };
  }
  function zo2() {
    return { name: "", J: "an HTML element", optional: false, K: function(a3) {
      return !!(a3 && a3 instanceof Element);
    } };
  }
  function Ao2() {
    return { name: "auth", J: "an instance of Firebase Auth", optional: true, K: function(a3) {
      return !!(a3 && a3 instanceof En2);
    } };
  }
  function Bo2() {
    return { name: "app", J: "an instance of Firebase App", optional: true, K: function(a3) {
      return !!(a3 && a3 instanceof firebase$1.app.App);
    } };
  }
  function Co2(a3) {
    return { name: a3 ? a3 + "Credential" : "credential", J: a3 ? "a valid " + a3 + " credential" : "a valid credential", optional: false, K: function(b3) {
      if (!b3)
        return false;
      var c3 = !a3 || b3.providerId === a3;
      return !(!b3.ja || !c3);
    } };
  }
  function Do2() {
    return { name: "multiFactorAssertion", J: "a valid multiFactorAssertion", optional: false, K: function(a3) {
      return a3 ? !!a3.rb : false;
    } };
  }
  function Eo2() {
    return { name: "authProvider", J: "a valid Auth provider", optional: false, K: function(a3) {
      return !!(a3 && a3.providerId && a3.hasOwnProperty && a3.hasOwnProperty("isOAuthProvider"));
    } };
  }
  function Fo2(a3, b3) {
    return m3(a3) && typeof a3.type === "string" && a3.type === b3 && typeof a3.Ha === "function";
  }
  function Go2(a3) {
    return m3(a3) && typeof a3.uid === "string";
  }
  function Ho2() {
    return { name: "applicationVerifier", J: "an implementation of firebase.auth.ApplicationVerifier", optional: false, K: function(a3) {
      return !(!a3 || typeof a3.type !== "string" || typeof a3.verify !== "function");
    } };
  }
  function X3(a3, b3, c3, d3) {
    return { name: c3 || "", J: a3.J + " or " + b3.J, optional: !!d3, K: function(e28) {
      return a3.K(e28) || b3.K(e28);
    } };
  }
  function Y3(a3, b3) {
    for (var c3 in b3) {
      var d3 = b3[c3].name;
      a3[d3] = Io2(d3, a3[c3], b3[c3].j);
    }
  }
  function Jo2(a3, b3) {
    for (var c3 in b3) {
      var d3 = b3[c3].name;
      d3 !== c3 && Object.defineProperty(a3, d3, { get: ua2(function(e28) {
        return this[e28];
      }, c3), set: ua2(function(e28, f3, g3, h3) {
        uo2(e28, [g3], [h3], true);
        this[f3] = h3;
      }, d3, c3, b3[c3].jb), enumerable: true });
    }
  }
  function Z3(a3, b3, c3, d3) {
    a3[b3] = Io2(b3, c3, d3);
  }
  function Io2(a3, b3, c3) {
    function d3() {
      var g3 = Array.prototype.slice.call(arguments);
      uo2(e28, c3, g3);
      return b3.apply(this, g3);
    }
    if (!c3)
      return b3;
    var e28 = Ko2(a3), f3;
    for (f3 in b3)
      d3[f3] = b3[f3];
    for (f3 in b3.prototype)
      d3.prototype[f3] = b3.prototype[f3];
    return d3;
  }
  function Ko2(a3) {
    a3 = a3.split(".");
    return a3[a3.length - 1];
  }
  Y3(En2.prototype, {
    ib: { name: "applyActionCode", j: [V10("code")] },
    Qa: { name: "checkActionCode", j: [V10("code")] },
    mb: { name: "confirmPasswordReset", j: [V10("code"), V10("newPassword")] },
    dc: { name: "createUserWithEmailAndPassword", j: [V10("email"), V10("password")] },
    gc: { name: "fetchSignInMethodsForEmail", j: [V10("email")] },
    qa: { name: "getRedirectResult", j: [] },
    Ac: { name: "isSignInWithEmailLink", j: [V10("emailLink")] },
    Gc: { name: "onAuthStateChanged", j: [X3(W3(), xo2(), "nextOrObserver"), xo2("opt_error", true), xo2("opt_completed", true)] },
    Hc: {
      name: "onIdTokenChanged",
      j: [X3(W3(), xo2(), "nextOrObserver"), xo2("opt_error", true), xo2("opt_completed", true)]
    },
    ub: { name: "sendPasswordResetEmail", j: [V10("email"), X3(W3("opt_actionCodeSettings", true), yo2(null, true), "opt_actionCodeSettings", true)] },
    vb: { name: "sendSignInLinkToEmail", j: [V10("email"), W3("actionCodeSettings")] },
    wb: { name: "setPersistence", j: [V10("persistence")] },
    Rc: { name: "signInAndRetrieveDataWithCredential", j: [Co2()] },
    yb: { name: "signInAnonymously", j: [] },
    Za: { name: "signInWithCredential", j: [Co2()] },
    Sc: { name: "signInWithCustomToken", j: [V10("token")] },
    Tc: { name: "signInWithEmailAndPassword", j: [V10("email"), V10("password")] },
    Uc: { name: "signInWithEmailLink", j: [V10("email"), V10("emailLink", true)] },
    Vc: { name: "signInWithPhoneNumber", j: [V10("phoneNumber"), Ho2()] },
    Wc: { name: "signInWithPopup", j: [Eo2()] },
    Xc: { name: "signInWithRedirect", j: [Eo2()] },
    cd: { name: "updateCurrentUser", j: [X3(function(a3) {
      return { name: "user", J: "an instance of Firebase User", optional: !!a3, K: function(b3) {
        return !!(b3 && b3 instanceof Im2);
      } };
    }(), yo2(), "user")] },
    zb: { name: "signOut", j: [] },
    toJSON: { name: "toJSON", j: [V10(null, true)] },
    ed: { name: "useDeviceLanguage", j: [] },
    fd: { name: "useEmulator", j: [V10("url"), W3("options", true)] },
    hd: { name: "verifyPasswordResetCode", j: [V10("code")] }
  });
  Jo2(En2.prototype, { lc: { name: "languageCode", jb: X3(V10(), yo2(), "languageCode") }, ti: { name: "tenantId", jb: X3(V10(), yo2(), "tenantId") } });
  En2.Persistence = Rk2;
  En2.Persistence.LOCAL = "local";
  En2.Persistence.SESSION = "session";
  En2.Persistence.NONE = "none";
  Y3(Im2.prototype, {
    "delete": { name: "delete", j: [] },
    nc: { name: "getIdTokenResult", j: [wo2("opt_forceRefresh", true)] },
    I: { name: "getIdToken", j: [wo2("opt_forceRefresh", true)] },
    Bc: { name: "linkAndRetrieveDataWithCredential", j: [Co2()] },
    pb: { name: "linkWithCredential", j: [Co2()] },
    Cc: { name: "linkWithPhoneNumber", j: [V10("phoneNumber"), Ho2()] },
    Dc: { name: "linkWithPopup", j: [Eo2()] },
    Ec: { name: "linkWithRedirect", j: [Eo2()] },
    Kc: { name: "reauthenticateAndRetrieveDataWithCredential", j: [Co2()] },
    sb: { name: "reauthenticateWithCredential", j: [Co2()] },
    Lc: {
      name: "reauthenticateWithPhoneNumber",
      j: [V10("phoneNumber"), Ho2()]
    },
    Mc: { name: "reauthenticateWithPopup", j: [Eo2()] },
    Nc: { name: "reauthenticateWithRedirect", j: [Eo2()] },
    reload: { name: "reload", j: [] },
    tb: { name: "sendEmailVerification", j: [X3(W3("opt_actionCodeSettings", true), yo2(null, true), "opt_actionCodeSettings", true)] },
    toJSON: { name: "toJSON", j: [V10(null, true)] },
    bd: { name: "unlink", j: [V10("provider")] },
    Ab: { name: "updateEmail", j: [V10("email")] },
    Bb: { name: "updatePassword", j: [V10("password")] },
    dd: { name: "updatePhoneNumber", j: [Co2("phone")] },
    Cb: { name: "updateProfile", j: [W3("profile")] },
    Db: { name: "verifyBeforeUpdateEmail", j: [V10("email"), X3(W3("opt_actionCodeSettings", true), yo2(null, true), "opt_actionCodeSettings", true)] }
  });
  Y3(Xn2.prototype, { execute: { name: "execute" }, render: { name: "render" }, reset: { name: "reset" }, getResponse: { name: "getResponse" } });
  Y3(Wn2.prototype, { execute: { name: "execute" }, render: { name: "render" }, reset: { name: "reset" }, getResponse: { name: "getResponse" } });
  Y3(D3.prototype, { na: { name: "finally" }, o: { name: "catch" }, then: { name: "then" } });
  Jo2(em2.prototype, { appVerificationDisabled: { name: "appVerificationDisabledForTesting", jb: wo2("appVerificationDisabledForTesting") } });
  Y3(fm2.prototype, { confirm: { name: "confirm", j: [V10("verificationCode")] } });
  Z3(Bg, "fromJSON", function(a3) {
    a3 = typeof a3 === "string" ? JSON.parse(a3) : a3;
    for (var b3, c3 = [Mg, dh, kh, Jg], d3 = 0; d3 < c3.length; d3++)
      if (b3 = c3[d3](a3))
        return b3;
    return null;
  }, [X3(V10(), W3(), "json")]);
  Z3(Zg, "credential", function(a3, b3) {
    return new Yg(a3, b3);
  }, [V10("email"), V10("password")]);
  Y3(Yg.prototype, { w: { name: "toJSON", j: [V10(null, true)] } });
  Y3(Qg.prototype, { Ca: { name: "addScope", j: [V10("scope")] }, Ka: { name: "setCustomParameters", j: [W3("customOAuthParameters")] } });
  Z3(Qg, "credential", Rg, [X3(V10(), W3(), "token")]);
  Z3(Zg, "credentialWithLink", eh, [V10("email"), V10("emailLink")]);
  Y3(Sg.prototype, { Ca: { name: "addScope", j: [V10("scope")] }, Ka: { name: "setCustomParameters", j: [W3("customOAuthParameters")] } });
  Z3(Sg, "credential", Tg, [X3(V10(), W3(), "token")]);
  Y3(Ug.prototype, { Ca: { name: "addScope", j: [V10("scope")] }, Ka: { name: "setCustomParameters", j: [W3("customOAuthParameters")] } });
  Z3(Ug, "credential", Vg, [X3(V10(), X3(W3(), yo2()), "idToken"), X3(V10(), yo2(), "accessToken", true)]);
  Y3(Wg.prototype, { Ka: { name: "setCustomParameters", j: [W3("customOAuthParameters")] } });
  Z3(Wg, "credential", Xg, [X3(V10(), W3(), "token"), V10("secret", true)]);
  Y3(Pg.prototype, { Ca: { name: "addScope", j: [V10("scope")] }, credential: { name: "credential", j: [X3(V10(), X3(W3(), yo2()), "optionsOrIdToken"), X3(V10(), yo2(), "accessToken", true)] }, Ka: { name: "setCustomParameters", j: [W3("customOAuthParameters")] } });
  Y3(Kg.prototype, { w: { name: "toJSON", j: [V10(null, true)] } });
  Y3(Eg.prototype, { w: { name: "toJSON", j: [V10(null, true)] } });
  Z3(lh, "credential", ph, [V10("verificationId"), V10("verificationCode")]);
  Y3(lh.prototype, { eb: { name: "verifyPhoneNumber", j: [X3(V10(), function(a3, b3) {
    return { name: a3 || "phoneInfoOptions", J: "valid phone info options", optional: !!b3, K: function(c3) {
      return c3 ? c3.session && c3.phoneNumber ? Fo2(c3.session, zg) && typeof c3.phoneNumber === "string" : c3.session && c3.multiFactorHint ? Fo2(c3.session, Ag) && Go2(c3.multiFactorHint) : c3.session && c3.multiFactorUid ? Fo2(c3.session, Ag) && typeof c3.multiFactorUid === "string" : c3.phoneNumber ? typeof c3.phoneNumber === "string" : false : false;
    } };
  }(), "phoneInfoOptions"), Ho2()] } });
  Y3(gh.prototype, { w: { name: "toJSON", j: [V10(null, true)] } });
  Y3(t3.prototype, { toJSON: { name: "toJSON", j: [V10(null, true)] } });
  Y3(yh.prototype, { toJSON: { name: "toJSON", j: [V10(null, true)] } });
  Y3(xh.prototype, { toJSON: { name: "toJSON", j: [V10(null, true)] } });
  Y3(lm2.prototype, { toJSON: { name: "toJSON", j: [V10(null, true)] } });
  Y3(im2.prototype, { Qc: { name: "resolveSignIn", j: [Do2()] } });
  Y3(tm2.prototype, { Qb: { name: "getSession", j: [] }, ec: { name: "enroll", j: [Do2(), V10("displayName", true)] }, ad: { name: "unenroll", j: [X3({ name: "multiFactorInfo", J: "a valid multiFactorInfo", optional: false, K: Go2 }, V10(), "multiFactorInfoIdentifier")] } });
  Y3(to2.prototype, { clear: { name: "clear", j: [] }, render: { name: "render", j: [] }, verify: { name: "verify", j: [] } });
  Z3(Jf, "parseLink", Rf, [V10("link")]);
  Z3(co2, "assertion", function(a3) {
    return new rm2(a3);
  }, [Co2("phone")]);
  (function() {
    if (typeof firebase$1 !== "undefined" && firebase$1.INTERNAL && firebase$1.INTERNAL.registerComponent) {
      var a3 = { ActionCodeInfo: { Operation: { EMAIL_SIGNIN: Af, PASSWORD_RESET: "PASSWORD_RESET", RECOVER_EMAIL: "RECOVER_EMAIL", REVERT_SECOND_FACTOR_ADDITION: Cf2, VERIFY_AND_CHANGE_EMAIL: Bf, VERIFY_EMAIL: "VERIFY_EMAIL" } }, Auth: En2, AuthCredential: Bg, Error: t3 };
      Z3(a3, "EmailAuthProvider", Zg, []);
      Z3(a3, "FacebookAuthProvider", Qg, []);
      Z3(a3, "GithubAuthProvider", Sg, []);
      Z3(a3, "GoogleAuthProvider", Ug, []);
      Z3(a3, "TwitterAuthProvider", Wg, []);
      Z3(a3, "OAuthProvider", Pg, [V10("providerId")]);
      Z3(a3, "SAMLAuthProvider", Og, [V10("providerId")]);
      Z3(a3, "PhoneAuthProvider", lh, [Ao2()]);
      Z3(a3, "RecaptchaVerifier", to2, [X3(V10(), zo2(), "recaptchaContainer"), W3("recaptchaParameters", true), Bo2()]);
      Z3(a3, "ActionCodeURL", Jf, []);
      Z3(a3, "PhoneMultiFactorGenerator", co2, []);
      firebase$1.INTERNAL.registerComponent({ name: "auth", instanceFactory: function(b3) {
        b3 = b3.getProvider("app").getImmediate();
        return new En2(b3);
      }, multipleInstances: false, serviceProps: a3, instantiationMode: "LAZY", type: "PUBLIC" });
      firebase$1.INTERNAL.registerComponent({
        name: "auth-internal",
        instanceFactory: function(b3) {
          b3 = b3.getProvider("auth").getImmediate();
          return { getUid: q3(b3.getUid, b3), getToken: q3(b3.mc, b3), addAuthTokenListener: q3(b3.cc, b3), removeAuthTokenListener: q3(b3.Oc, b3) };
        },
        multipleInstances: false,
        instantiationMode: "LAZY",
        type: "PRIVATE"
      });
      firebase$1.registerVersion("@firebase/auth", "0.16.1");
      firebase$1.INTERNAL.extendNamespace({ User: Im2 });
    } else
      throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");
  })();
}).apply(typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DOMStorageWrapper = function() {
  function DOMStorageWrapper2(domStorage_) {
    this.domStorage_ = domStorage_;
    this.prefix_ = "firebase:";
  }
  DOMStorageWrapper2.prototype.set = function(key, value) {
    if (value == null) {
      this.domStorage_.removeItem(this.prefixedName_(key));
    } else {
      this.domStorage_.setItem(this.prefixedName_(key), stringify(value));
    }
  };
  DOMStorageWrapper2.prototype.get = function(key) {
    var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
    if (storedVal == null) {
      return null;
    } else {
      return jsonEval(storedVal);
    }
  };
  DOMStorageWrapper2.prototype.remove = function(key) {
    this.domStorage_.removeItem(this.prefixedName_(key));
  };
  DOMStorageWrapper2.prototype.prefixedName_ = function(name2) {
    return this.prefix_ + name2;
  };
  DOMStorageWrapper2.prototype.toString = function() {
    return this.domStorage_.toString();
  };
  return DOMStorageWrapper2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MemoryStorage = function() {
  function MemoryStorage2() {
    this.cache_ = {};
    this.isInMemoryStorage = true;
  }
  MemoryStorage2.prototype.set = function(key, value) {
    if (value == null) {
      delete this.cache_[key];
    } else {
      this.cache_[key] = value;
    }
  };
  MemoryStorage2.prototype.get = function(key) {
    if (contains(this.cache_, key)) {
      return this.cache_[key];
    }
    return null;
  };
  MemoryStorage2.prototype.remove = function(key) {
    delete this.cache_[key];
  };
  return MemoryStorage2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var createStoragefor = function(domStorageName) {
  try {
    if (typeof window !== "undefined" && typeof window[domStorageName] !== "undefined") {
      var domStorage = window[domStorageName];
      domStorage.setItem("firebase:sentinel", "cache");
      domStorage.removeItem("firebase:sentinel");
      return new DOMStorageWrapper(domStorage);
    }
  } catch (e28) {
  }
  return new MemoryStorage();
};
var PersistentStorage = createStoragefor("localStorage");
var SessionStorage = createStoragefor("sessionStorage");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logClient = new Logger("@firebase/database");
var LUIDGenerator = function() {
  var id2 = 1;
  return function() {
    return id2++;
  };
}();
var sha1 = function(str) {
  var utf8Bytes = stringToByteArray$1(str);
  var sha12 = new Sha1();
  sha12.update(utf8Bytes);
  var sha1Bytes = sha12.digest();
  return base64.encodeByteArray(sha1Bytes);
};
var buildLogMessage_ = function() {
  var varArgs = [];
  for (var _i2 = 0; _i2 < arguments.length; _i2++) {
    varArgs[_i2] = arguments[_i2];
  }
  var message = "";
  for (var i = 0; i < varArgs.length; i++) {
    var arg = varArgs[i];
    if (Array.isArray(arg) || arg && typeof arg === "object" && typeof arg.length === "number") {
      message += buildLogMessage_.apply(null, arg);
    } else if (typeof arg === "object") {
      message += stringify(arg);
    } else {
      message += arg;
    }
    message += " ";
  }
  return message;
};
var logger$2 = null;
var firstLog_ = true;
var enableLogging = function(logger_, persistent) {
  assert(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
  if (logger_ === true) {
    logClient.logLevel = LogLevel.VERBOSE;
    logger$2 = logClient.log.bind(logClient);
    if (persistent) {
      SessionStorage.set("logging_enabled", true);
    }
  } else if (typeof logger_ === "function") {
    logger$2 = logger_;
  } else {
    logger$2 = null;
    SessionStorage.remove("logging_enabled");
  }
};
var log = function() {
  var varArgs = [];
  for (var _i2 = 0; _i2 < arguments.length; _i2++) {
    varArgs[_i2] = arguments[_i2];
  }
  if (firstLog_ === true) {
    firstLog_ = false;
    if (logger$2 === null && SessionStorage.get("logging_enabled") === true) {
      enableLogging(true);
    }
  }
  if (logger$2) {
    var message = buildLogMessage_.apply(null, varArgs);
    logger$2(message);
  }
};
var logWrapper = function(prefix) {
  return function() {
    var varArgs = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      varArgs[_i2] = arguments[_i2];
    }
    log.apply(void 0, __spread([prefix], varArgs));
  };
};
var error = function() {
  var varArgs = [];
  for (var _i2 = 0; _i2 < arguments.length; _i2++) {
    varArgs[_i2] = arguments[_i2];
  }
  var message = "FIREBASE INTERNAL ERROR: " + buildLogMessage_.apply(void 0, __spread(varArgs));
  logClient.error(message);
};
var fatal = function() {
  var varArgs = [];
  for (var _i2 = 0; _i2 < arguments.length; _i2++) {
    varArgs[_i2] = arguments[_i2];
  }
  var message = "FIREBASE FATAL ERROR: " + buildLogMessage_.apply(void 0, __spread(varArgs));
  logClient.error(message);
  throw new Error(message);
};
var warn$2 = function() {
  var varArgs = [];
  for (var _i2 = 0; _i2 < arguments.length; _i2++) {
    varArgs[_i2] = arguments[_i2];
  }
  var message = "FIREBASE WARNING: " + buildLogMessage_.apply(void 0, __spread(varArgs));
  logClient.warn(message);
};
var warnIfPageIsSecure = function() {
  if (typeof window !== "undefined" && window.location && window.location.protocol && window.location.protocol.indexOf("https:") !== -1) {
    warn$2("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
  }
};
var isInvalidJSONNumber = function(data) {
  return typeof data === "number" && (data !== data || data === Number.POSITIVE_INFINITY || data === Number.NEGATIVE_INFINITY);
};
var executeWhenDOMReady = function(fn2) {
  if (document.readyState === "complete") {
    fn2();
  } else {
    var called_1 = false;
    var wrappedFn_1 = function() {
      if (!document.body) {
        setTimeout(wrappedFn_1, Math.floor(10));
        return;
      }
      if (!called_1) {
        called_1 = true;
        fn2();
      }
    };
    if (document.addEventListener) {
      document.addEventListener("DOMContentLoaded", wrappedFn_1, false);
      window.addEventListener("load", wrappedFn_1, false);
    } else if (document.attachEvent) {
      document.attachEvent("onreadystatechange", function() {
        if (document.readyState === "complete") {
          wrappedFn_1();
        }
      });
      window.attachEvent("onload", wrappedFn_1);
    }
  }
};
var MIN_NAME = "[MIN_NAME]";
var MAX_NAME = "[MAX_NAME]";
var nameCompare = function(a3, b3) {
  if (a3 === b3) {
    return 0;
  } else if (a3 === MIN_NAME || b3 === MAX_NAME) {
    return -1;
  } else if (b3 === MIN_NAME || a3 === MAX_NAME) {
    return 1;
  } else {
    var aAsInt = tryParseInt(a3), bAsInt = tryParseInt(b3);
    if (aAsInt !== null) {
      if (bAsInt !== null) {
        return aAsInt - bAsInt === 0 ? a3.length - b3.length : aAsInt - bAsInt;
      } else {
        return -1;
      }
    } else if (bAsInt !== null) {
      return 1;
    } else {
      return a3 < b3 ? -1 : 1;
    }
  }
};
var stringCompare = function(a3, b3) {
  if (a3 === b3) {
    return 0;
  } else if (a3 < b3) {
    return -1;
  } else {
    return 1;
  }
};
var requireKey = function(key, obj) {
  if (obj && key in obj) {
    return obj[key];
  } else {
    throw new Error("Missing required key (" + key + ") in object: " + stringify(obj));
  }
};
var ObjectToUniqueKey = function(obj) {
  if (typeof obj !== "object" || obj === null) {
    return stringify(obj);
  }
  var keys2 = [];
  for (var k3 in obj) {
    keys2.push(k3);
  }
  keys2.sort();
  var key = "{";
  for (var i = 0; i < keys2.length; i++) {
    if (i !== 0) {
      key += ",";
    }
    key += stringify(keys2[i]);
    key += ":";
    key += ObjectToUniqueKey(obj[keys2[i]]);
  }
  key += "}";
  return key;
};
var splitStringBySize = function(str, segsize) {
  var len = str.length;
  if (len <= segsize) {
    return [str];
  }
  var dataSegs = [];
  for (var c3 = 0; c3 < len; c3 += segsize) {
    if (c3 + segsize > len) {
      dataSegs.push(str.substring(c3, len));
    } else {
      dataSegs.push(str.substring(c3, c3 + segsize));
    }
  }
  return dataSegs;
};
function each(obj, fn2) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      fn2(key, obj[key]);
    }
  }
}
var doubleToIEEE754String = function(v3) {
  assert(!isInvalidJSONNumber(v3), "Invalid JSON number");
  var ebits = 11, fbits = 52;
  var bias = (1 << ebits - 1) - 1;
  var s3, e28, f3, ln2, i;
  if (v3 === 0) {
    e28 = 0;
    f3 = 0;
    s3 = 1 / v3 === -Infinity ? 1 : 0;
  } else {
    s3 = v3 < 0;
    v3 = Math.abs(v3);
    if (v3 >= Math.pow(2, 1 - bias)) {
      ln2 = Math.min(Math.floor(Math.log(v3) / Math.LN2), bias);
      e28 = ln2 + bias;
      f3 = Math.round(v3 * Math.pow(2, fbits - ln2) - Math.pow(2, fbits));
    } else {
      e28 = 0;
      f3 = Math.round(v3 / Math.pow(2, 1 - bias - fbits));
    }
  }
  var bits = [];
  for (i = fbits; i; i -= 1) {
    bits.push(f3 % 2 ? 1 : 0);
    f3 = Math.floor(f3 / 2);
  }
  for (i = ebits; i; i -= 1) {
    bits.push(e28 % 2 ? 1 : 0);
    e28 = Math.floor(e28 / 2);
  }
  bits.push(s3 ? 1 : 0);
  bits.reverse();
  var str = bits.join("");
  var hexByteString = "";
  for (i = 0; i < 64; i += 8) {
    var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
    if (hexByte.length === 1) {
      hexByte = "0" + hexByte;
    }
    hexByteString = hexByteString + hexByte;
  }
  return hexByteString.toLowerCase();
};
var isChromeExtensionContentScript = function() {
  return !!(typeof window === "object" && window["chrome"] && window["chrome"]["extension"] && !/^chrome/.test(window.location.href));
};
var isWindowsStoreApp = function() {
  return typeof Windows === "object" && typeof Windows.UI === "object";
};
var errorForServerCode = function(code, query2) {
  var reason = "Unknown Error";
  if (code === "too_big") {
    reason = "The data requested exceeds the maximum size that can be accessed with a single request.";
  } else if (code === "permission_denied") {
    reason = "Client doesn't have permission to access the desired data.";
  } else if (code === "unavailable") {
    reason = "The service is unavailable";
  }
  var error2 = new Error(code + " at " + query2.path.toString() + ": " + reason);
  error2.code = code.toUpperCase();
  return error2;
};
var INTEGER_REGEXP_ = new RegExp("^-?(0*)\\d{1,10}$");
var tryParseInt = function(str) {
  if (INTEGER_REGEXP_.test(str)) {
    var intVal = Number(str);
    if (intVal >= -2147483648 && intVal <= 2147483647) {
      return intVal;
    }
  }
  return null;
};
var exceptionGuard = function(fn2) {
  try {
    fn2();
  } catch (e28) {
    setTimeout(function() {
      var stack = e28.stack || "";
      warn$2("Exception was thrown by user callback.", stack);
      throw e28;
    }, Math.floor(0));
  }
};
var beingCrawled = function() {
  var userAgent = typeof window === "object" && window["navigator"] && window["navigator"]["userAgent"] || "";
  return userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
};
var setTimeoutNonBlocking = function(fn2, time) {
  var timeout = setTimeout(fn2, time);
  if (typeof timeout === "object" && timeout["unref"]) {
    timeout["unref"]();
  }
  return timeout;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Path = function() {
  function Path2(pathOrString, pieceNum) {
    if (pieceNum === void 0) {
      this.pieces_ = pathOrString.split("/");
      var copyTo = 0;
      for (var i = 0; i < this.pieces_.length; i++) {
        if (this.pieces_[i].length > 0) {
          this.pieces_[copyTo] = this.pieces_[i];
          copyTo++;
        }
      }
      this.pieces_.length = copyTo;
      this.pieceNum_ = 0;
    } else {
      this.pieces_ = pathOrString;
      this.pieceNum_ = pieceNum;
    }
  }
  Object.defineProperty(Path2, "Empty", {
    get: function() {
      return new Path2("");
    },
    enumerable: false,
    configurable: true
  });
  Path2.prototype.getFront = function() {
    if (this.pieceNum_ >= this.pieces_.length) {
      return null;
    }
    return this.pieces_[this.pieceNum_];
  };
  Path2.prototype.getLength = function() {
    return this.pieces_.length - this.pieceNum_;
  };
  Path2.prototype.popFront = function() {
    var pieceNum = this.pieceNum_;
    if (pieceNum < this.pieces_.length) {
      pieceNum++;
    }
    return new Path2(this.pieces_, pieceNum);
  };
  Path2.prototype.getBack = function() {
    if (this.pieceNum_ < this.pieces_.length) {
      return this.pieces_[this.pieces_.length - 1];
    }
    return null;
  };
  Path2.prototype.toString = function() {
    var pathString = "";
    for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
      if (this.pieces_[i] !== "") {
        pathString += "/" + this.pieces_[i];
      }
    }
    return pathString || "/";
  };
  Path2.prototype.toUrlEncodedString = function() {
    var pathString = "";
    for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
      if (this.pieces_[i] !== "") {
        pathString += "/" + encodeURIComponent(String(this.pieces_[i]));
      }
    }
    return pathString || "/";
  };
  Path2.prototype.slice = function(begin) {
    if (begin === void 0) {
      begin = 0;
    }
    return this.pieces_.slice(this.pieceNum_ + begin);
  };
  Path2.prototype.parent = function() {
    if (this.pieceNum_ >= this.pieces_.length) {
      return null;
    }
    var pieces = [];
    for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++) {
      pieces.push(this.pieces_[i]);
    }
    return new Path2(pieces, 0);
  };
  Path2.prototype.child = function(childPathObj) {
    var pieces = [];
    for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
      pieces.push(this.pieces_[i]);
    }
    if (childPathObj instanceof Path2) {
      for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
        pieces.push(childPathObj.pieces_[i]);
      }
    } else {
      var childPieces = childPathObj.split("/");
      for (var i = 0; i < childPieces.length; i++) {
        if (childPieces[i].length > 0) {
          pieces.push(childPieces[i]);
        }
      }
    }
    return new Path2(pieces, 0);
  };
  Path2.prototype.isEmpty = function() {
    return this.pieceNum_ >= this.pieces_.length;
  };
  Path2.relativePath = function(outerPath, innerPath) {
    var outer = outerPath.getFront(), inner = innerPath.getFront();
    if (outer === null) {
      return innerPath;
    } else if (outer === inner) {
      return Path2.relativePath(outerPath.popFront(), innerPath.popFront());
    } else {
      throw new Error("INTERNAL ERROR: innerPath (" + innerPath + ") is not within outerPath (" + outerPath + ")");
    }
  };
  Path2.comparePaths = function(left, right) {
    var leftKeys = left.slice();
    var rightKeys = right.slice();
    for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
      var cmp = nameCompare(leftKeys[i], rightKeys[i]);
      if (cmp !== 0) {
        return cmp;
      }
    }
    if (leftKeys.length === rightKeys.length) {
      return 0;
    }
    return leftKeys.length < rightKeys.length ? -1 : 1;
  };
  Path2.prototype.equals = function(other) {
    if (this.getLength() !== other.getLength()) {
      return false;
    }
    for (var i = this.pieceNum_, j3 = other.pieceNum_; i <= this.pieces_.length; i++, j3++) {
      if (this.pieces_[i] !== other.pieces_[j3]) {
        return false;
      }
    }
    return true;
  };
  Path2.prototype.contains = function(other) {
    var i = this.pieceNum_;
    var j3 = other.pieceNum_;
    if (this.getLength() > other.getLength()) {
      return false;
    }
    while (i < this.pieces_.length) {
      if (this.pieces_[i] !== other.pieces_[j3]) {
        return false;
      }
      ++i;
      ++j3;
    }
    return true;
  };
  return Path2;
}();
var ValidationPath = function() {
  function ValidationPath2(path, errorPrefix_) {
    this.errorPrefix_ = errorPrefix_;
    this.parts_ = path.slice();
    this.byteLength_ = Math.max(1, this.parts_.length);
    for (var i = 0; i < this.parts_.length; i++) {
      this.byteLength_ += stringLength(this.parts_[i]);
    }
    this.checkValid_();
  }
  Object.defineProperty(ValidationPath2, "MAX_PATH_DEPTH", {
    get: function() {
      return 32;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ValidationPath2, "MAX_PATH_LENGTH_BYTES", {
    get: function() {
      return 768;
    },
    enumerable: false,
    configurable: true
  });
  ValidationPath2.prototype.push = function(child2) {
    if (this.parts_.length > 0) {
      this.byteLength_ += 1;
    }
    this.parts_.push(child2);
    this.byteLength_ += stringLength(child2);
    this.checkValid_();
  };
  ValidationPath2.prototype.pop = function() {
    var last = this.parts_.pop();
    this.byteLength_ -= stringLength(last);
    if (this.parts_.length > 0) {
      this.byteLength_ -= 1;
    }
  };
  ValidationPath2.prototype.checkValid_ = function() {
    if (this.byteLength_ > ValidationPath2.MAX_PATH_LENGTH_BYTES) {
      throw new Error(this.errorPrefix_ + "has a key path longer than " + ValidationPath2.MAX_PATH_LENGTH_BYTES + " bytes (" + this.byteLength_ + ").");
    }
    if (this.parts_.length > ValidationPath2.MAX_PATH_DEPTH) {
      throw new Error(this.errorPrefix_ + "path specified exceeds the maximum depth that can be written (" + ValidationPath2.MAX_PATH_DEPTH + ") or object contains a cycle " + this.toErrorString());
    }
  };
  ValidationPath2.prototype.toErrorString = function() {
    if (this.parts_.length === 0) {
      return "";
    }
    return "in property '" + this.parts_.join(".") + "'";
  };
  return ValidationPath2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PROTOCOL_VERSION = "5";
var VERSION_PARAM = "v";
var TRANSPORT_SESSION_PARAM = "s";
var REFERER_PARAM = "r";
var FORGE_REF = "f";
var FORGE_DOMAIN = "firebaseio.com";
var LAST_SESSION_PARAM = "ls";
var APPLICATION_ID_PARAM = "p";
var WEBSOCKET = "websocket";
var LONG_POLLING = "long_polling";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RepoInfo = function() {
  function RepoInfo2(host, secure, namespace, webSocketOnly, nodeAdmin, persistenceKey, includeNamespaceInQueryParams) {
    if (nodeAdmin === void 0) {
      nodeAdmin = false;
    }
    if (persistenceKey === void 0) {
      persistenceKey = "";
    }
    if (includeNamespaceInQueryParams === void 0) {
      includeNamespaceInQueryParams = false;
    }
    this.secure = secure;
    this.namespace = namespace;
    this.webSocketOnly = webSocketOnly;
    this.nodeAdmin = nodeAdmin;
    this.persistenceKey = persistenceKey;
    this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
    this.host = host.toLowerCase();
    this.domain = this.host.substr(this.host.indexOf(".") + 1);
    this.internalHost = PersistentStorage.get("host:" + host) || this.host;
  }
  RepoInfo2.prototype.needsQueryParam = function() {
    return this.host !== this.internalHost || this.isCustomHost() || this.includeNamespaceInQueryParams;
  };
  RepoInfo2.prototype.isCacheableHost = function() {
    return this.internalHost.substr(0, 2) === "s-";
  };
  RepoInfo2.prototype.isDemoHost = function() {
    return this.domain === "firebaseio-demo.com";
  };
  RepoInfo2.prototype.isCustomHost = function() {
    return this.domain !== "firebaseio.com" && this.domain !== "firebaseio-demo.com";
  };
  RepoInfo2.prototype.updateHost = function(newHost) {
    if (newHost !== this.internalHost) {
      this.internalHost = newHost;
      if (this.isCacheableHost()) {
        PersistentStorage.set("host:" + this.host, this.internalHost);
      }
    }
  };
  RepoInfo2.prototype.connectionURL = function(type, params2) {
    assert(typeof type === "string", "typeof type must == string");
    assert(typeof params2 === "object", "typeof params must == object");
    var connURL;
    if (type === WEBSOCKET) {
      connURL = (this.secure ? "wss://" : "ws://") + this.internalHost + "/.ws?";
    } else if (type === LONG_POLLING) {
      connURL = (this.secure ? "https://" : "http://") + this.internalHost + "/.lp?";
    } else {
      throw new Error("Unknown connection type: " + type);
    }
    if (this.needsQueryParam()) {
      params2["ns"] = this.namespace;
    }
    var pairs = [];
    each(params2, function(key, value) {
      pairs.push(key + "=" + value);
    });
    return connURL + pairs.join("&");
  };
  RepoInfo2.prototype.toString = function() {
    var str = this.toURLString();
    if (this.persistenceKey) {
      str += "<" + this.persistenceKey + ">";
    }
    return str;
  };
  RepoInfo2.prototype.toURLString = function() {
    return (this.secure ? "https://" : "http://") + this.host;
  };
  return RepoInfo2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function decodePath(pathString) {
  var pathStringDecoded = "";
  var pieces = pathString.split("/");
  for (var i = 0; i < pieces.length; i++) {
    if (pieces[i].length > 0) {
      var piece = pieces[i];
      try {
        piece = decodeURIComponent(piece.replace(/\+/g, " "));
      } catch (e28) {
      }
      pathStringDecoded += "/" + piece;
    }
  }
  return pathStringDecoded;
}
function decodeQuery(queryString) {
  var e_1, _a2;
  var results = {};
  if (queryString.charAt(0) === "?") {
    queryString = queryString.substring(1);
  }
  try {
    for (var _b2 = __values$1(queryString.split("&")), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
      var segment = _c2.value;
      if (segment.length === 0) {
        continue;
      }
      var kv2 = segment.split("=");
      if (kv2.length === 2) {
        results[decodeURIComponent(kv2[0])] = decodeURIComponent(kv2[1]);
      } else {
        warn$2("Invalid query segment '" + segment + "' in query '" + queryString + "'");
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (_c2 && !_c2.done && (_a2 = _b2.return))
        _a2.call(_b2);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return results;
}
var parseRepoInfo = function(dataURL, nodeAdmin) {
  var parsedUrl = parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
  if (parsedUrl.domain === "firebase.com") {
    fatal(parsedUrl.host + " is no longer supported. Please use <YOUR FIREBASE>.firebaseio.com instead");
  }
  if ((!namespace || namespace === "undefined") && parsedUrl.domain !== "localhost") {
    fatal("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com");
  }
  if (!parsedUrl.secure) {
    warnIfPageIsSecure();
  }
  var webSocketOnly = parsedUrl.scheme === "ws" || parsedUrl.scheme === "wss";
  return {
    repoInfo: new RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, nodeAdmin, webSocketOnly, "", namespace !== parsedUrl.subdomain),
    path: new Path(parsedUrl.pathString)
  };
};
var parseDatabaseURL = function(dataURL) {
  var host = "", domain = "", subdomain = "", pathString = "", namespace = "";
  var secure = true, scheme = "https", port = 443;
  if (typeof dataURL === "string") {
    var colonInd = dataURL.indexOf("//");
    if (colonInd >= 0) {
      scheme = dataURL.substring(0, colonInd - 1);
      dataURL = dataURL.substring(colonInd + 2);
    }
    var slashInd = dataURL.indexOf("/");
    if (slashInd === -1) {
      slashInd = dataURL.length;
    }
    var questionMarkInd = dataURL.indexOf("?");
    if (questionMarkInd === -1) {
      questionMarkInd = dataURL.length;
    }
    host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
    if (slashInd < questionMarkInd) {
      pathString = decodePath(dataURL.substring(slashInd, questionMarkInd));
    }
    var queryParams = decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
    colonInd = host.indexOf(":");
    if (colonInd >= 0) {
      secure = scheme === "https" || scheme === "wss";
      port = parseInt(host.substring(colonInd + 1), 10);
    } else {
      colonInd = host.length;
    }
    var hostWithoutPort = host.slice(0, colonInd);
    if (hostWithoutPort.toLowerCase() === "localhost") {
      domain = "localhost";
    } else if (hostWithoutPort.split(".").length <= 2) {
      domain = hostWithoutPort;
    } else {
      var dotInd = host.indexOf(".");
      subdomain = host.substring(0, dotInd).toLowerCase();
      domain = host.substring(dotInd + 1);
      namespace = subdomain;
    }
    if ("ns" in queryParams) {
      namespace = queryParams["ns"];
    }
  }
  return {
    host,
    port,
    domain,
    subdomain,
    secure,
    scheme,
    pathString,
    namespace
  };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
var INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
var MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
var isValidKey = function(key) {
  return typeof key === "string" && key.length !== 0 && !INVALID_KEY_REGEX_.test(key);
};
var isValidPathString = function(pathString) {
  return typeof pathString === "string" && pathString.length !== 0 && !INVALID_PATH_REGEX_.test(pathString);
};
var isValidRootPathString = function(pathString) {
  if (pathString) {
    pathString = pathString.replace(/^\/*\.info(\/|$)/, "/");
  }
  return isValidPathString(pathString);
};
var isValidPriority = function(priority) {
  return priority === null || typeof priority === "string" || typeof priority === "number" && !isInvalidJSONNumber(priority) || priority && typeof priority === "object" && contains(priority, ".sv");
};
var validateFirebaseDataArg = function(fnName, argumentNumber, data, path, optional) {
  if (optional && data === void 0) {
    return;
  }
  validateFirebaseData(errorPrefix(fnName, argumentNumber, optional), data, path);
};
var validateFirebaseData = function(errorPrefix2, data, path_) {
  var path = path_ instanceof Path ? new ValidationPath(path_, errorPrefix2) : path_;
  if (data === void 0) {
    throw new Error(errorPrefix2 + "contains undefined " + path.toErrorString());
  }
  if (typeof data === "function") {
    throw new Error(errorPrefix2 + "contains a function " + path.toErrorString() + " with contents = " + data.toString());
  }
  if (isInvalidJSONNumber(data)) {
    throw new Error(errorPrefix2 + "contains " + data.toString() + " " + path.toErrorString());
  }
  if (typeof data === "string" && data.length > MAX_LEAF_SIZE_ / 3 && stringLength(data) > MAX_LEAF_SIZE_) {
    throw new Error(errorPrefix2 + "contains a string greater than " + MAX_LEAF_SIZE_ + " utf8 bytes " + path.toErrorString() + " ('" + data.substring(0, 50) + "...')");
  }
  if (data && typeof data === "object") {
    var hasDotValue_1 = false;
    var hasActualChild_1 = false;
    each(data, function(key, value) {
      if (key === ".value") {
        hasDotValue_1 = true;
      } else if (key !== ".priority" && key !== ".sv") {
        hasActualChild_1 = true;
        if (!isValidKey(key)) {
          throw new Error(errorPrefix2 + " contains an invalid key (" + key + ") " + path.toErrorString() + `.  Keys must be non-empty strings and can't contain ".", "#", "$", "/", "[", or "]"`);
        }
      }
      path.push(key);
      validateFirebaseData(errorPrefix2, value, path);
      path.pop();
    });
    if (hasDotValue_1 && hasActualChild_1) {
      throw new Error(errorPrefix2 + ' contains ".value" child ' + path.toErrorString() + " in addition to actual children.");
    }
  }
};
var validateFirebaseMergePaths = function(errorPrefix2, mergePaths) {
  var i, curPath;
  for (i = 0; i < mergePaths.length; i++) {
    curPath = mergePaths[i];
    var keys2 = curPath.slice();
    for (var j3 = 0; j3 < keys2.length; j3++) {
      if (keys2[j3] === ".priority" && j3 === keys2.length - 1)
        ;
      else if (!isValidKey(keys2[j3])) {
        throw new Error(errorPrefix2 + "contains an invalid key (" + keys2[j3] + ") in path " + curPath.toString() + `. Keys must be non-empty strings and can't contain ".", "#", "$", "/", "[", or "]"`);
      }
    }
  }
  mergePaths.sort(Path.comparePaths);
  var prevPath = null;
  for (i = 0; i < mergePaths.length; i++) {
    curPath = mergePaths[i];
    if (prevPath !== null && prevPath.contains(curPath)) {
      throw new Error(errorPrefix2 + "contains a path " + prevPath.toString() + " that is ancestor of another path " + curPath.toString());
    }
    prevPath = curPath;
  }
};
var validateFirebaseMergeDataArg = function(fnName, argumentNumber, data, path, optional) {
  if (optional && data === void 0) {
    return;
  }
  var errorPrefix$1 = errorPrefix(fnName, argumentNumber, optional);
  if (!(data && typeof data === "object") || Array.isArray(data)) {
    throw new Error(errorPrefix$1 + " must be an object containing the children to replace.");
  }
  var mergePaths = [];
  each(data, function(key, value) {
    var curPath = new Path(key);
    validateFirebaseData(errorPrefix$1, value, path.child(curPath));
    if (curPath.getBack() === ".priority") {
      if (!isValidPriority(value)) {
        throw new Error(errorPrefix$1 + "contains an invalid value for '" + curPath.toString() + "', which must be a valid Firebase priority (a string, finite number, server value, or null).");
      }
    }
    mergePaths.push(curPath);
  });
  validateFirebaseMergePaths(errorPrefix$1, mergePaths);
};
var validatePriority = function(fnName, argumentNumber, priority, optional) {
  if (optional && priority === void 0) {
    return;
  }
  if (isInvalidJSONNumber(priority)) {
    throw new Error(errorPrefix(fnName, argumentNumber, optional) + "is " + priority.toString() + ", but must be a valid Firebase priority (a string, finite number, server value, or null).");
  }
  if (!isValidPriority(priority)) {
    throw new Error(errorPrefix(fnName, argumentNumber, optional) + "must be a valid Firebase priority (a string, finite number, server value, or null).");
  }
};
var validateEventType = function(fnName, argumentNumber, eventType, optional) {
  if (optional && eventType === void 0) {
    return;
  }
  switch (eventType) {
    case "value":
    case "child_added":
    case "child_removed":
    case "child_changed":
    case "child_moved":
      break;
    default:
      throw new Error(errorPrefix(fnName, argumentNumber, optional) + 'must be a valid event type = "value", "child_added", "child_removed", "child_changed", or "child_moved".');
  }
};
var validateKey = function(fnName, argumentNumber, key, optional) {
  if (optional && key === void 0) {
    return;
  }
  if (!isValidKey(key)) {
    throw new Error(errorPrefix(fnName, argumentNumber, optional) + 'was an invalid key = "' + key + `".  Firebase keys must be non-empty strings and can't contain ".", "#", "$", "/", "[", or "]").`);
  }
};
var validatePathString = function(fnName, argumentNumber, pathString, optional) {
  if (optional && pathString === void 0) {
    return;
  }
  if (!isValidPathString(pathString)) {
    throw new Error(errorPrefix(fnName, argumentNumber, optional) + 'was an invalid path = "' + pathString + `". Paths must be non-empty strings and can't contain ".", "#", "$", "[", or "]"`);
  }
};
var validateRootPathString = function(fnName, argumentNumber, pathString, optional) {
  if (pathString) {
    pathString = pathString.replace(/^\/*\.info(\/|$)/, "/");
  }
  validatePathString(fnName, argumentNumber, pathString, optional);
};
var validateWritablePath = function(fnName, path) {
  if (path.getFront() === ".info") {
    throw new Error(fnName + " failed = Can't modify data under /.info/");
  }
};
var validateUrl = function(fnName, argumentNumber, parsedUrl) {
  var pathString = parsedUrl.path.toString();
  if (!(typeof parsedUrl.repoInfo.host === "string") || parsedUrl.repoInfo.host.length === 0 || !isValidKey(parsedUrl.repoInfo.namespace) && parsedUrl.repoInfo.host.split(":")[0] !== "localhost" || pathString.length !== 0 && !isValidRootPathString(pathString)) {
    throw new Error(errorPrefix(fnName, argumentNumber, false) + `must be a valid firebase URL and the path can't contain ".", "#", "$", "[", or "]".`);
  }
};
var validateBoolean = function(fnName, argumentNumber, bool, optional) {
  if (optional && bool === void 0) {
    return;
  }
  if (typeof bool !== "boolean") {
    throw new Error(errorPrefix(fnName, argumentNumber, optional) + "must be a boolean.");
  }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OnDisconnect = function() {
  function OnDisconnect2(repo_, path_) {
    this.repo_ = repo_;
    this.path_ = path_;
  }
  OnDisconnect2.prototype.cancel = function(onComplete) {
    validateArgCount("OnDisconnect.cancel", 0, 1, arguments.length);
    validateCallback("OnDisconnect.cancel", 1, onComplete, true);
    var deferred = new Deferred();
    this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
    return deferred.promise;
  };
  OnDisconnect2.prototype.remove = function(onComplete) {
    validateArgCount("OnDisconnect.remove", 0, 1, arguments.length);
    validateWritablePath("OnDisconnect.remove", this.path_);
    validateCallback("OnDisconnect.remove", 1, onComplete, true);
    var deferred = new Deferred();
    this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
    return deferred.promise;
  };
  OnDisconnect2.prototype.set = function(value, onComplete) {
    validateArgCount("OnDisconnect.set", 1, 2, arguments.length);
    validateWritablePath("OnDisconnect.set", this.path_);
    validateFirebaseDataArg("OnDisconnect.set", 1, value, this.path_, false);
    validateCallback("OnDisconnect.set", 2, onComplete, true);
    var deferred = new Deferred();
    this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
    return deferred.promise;
  };
  OnDisconnect2.prototype.setWithPriority = function(value, priority, onComplete) {
    validateArgCount("OnDisconnect.setWithPriority", 2, 3, arguments.length);
    validateWritablePath("OnDisconnect.setWithPriority", this.path_);
    validateFirebaseDataArg("OnDisconnect.setWithPriority", 1, value, this.path_, false);
    validatePriority("OnDisconnect.setWithPriority", 2, priority, false);
    validateCallback("OnDisconnect.setWithPriority", 3, onComplete, true);
    var deferred = new Deferred();
    this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
    return deferred.promise;
  };
  OnDisconnect2.prototype.update = function(objectToMerge, onComplete) {
    validateArgCount("OnDisconnect.update", 1, 2, arguments.length);
    validateWritablePath("OnDisconnect.update", this.path_);
    if (Array.isArray(objectToMerge)) {
      var newObjectToMerge = {};
      for (var i = 0; i < objectToMerge.length; ++i) {
        newObjectToMerge["" + i] = objectToMerge[i];
      }
      objectToMerge = newObjectToMerge;
      warn$2("Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
    }
    validateFirebaseMergeDataArg("OnDisconnect.update", 1, objectToMerge, this.path_, false);
    validateCallback("OnDisconnect.update", 2, onComplete, true);
    var deferred = new Deferred();
    this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
    return deferred.promise;
  };
  return OnDisconnect2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TransactionResult = function() {
  function TransactionResult2(committed, snapshot) {
    this.committed = committed;
    this.snapshot = snapshot;
  }
  TransactionResult2.prototype.toJSON = function() {
    validateArgCount("TransactionResult.toJSON", 0, 1, arguments.length);
    return { committed: this.committed, snapshot: this.snapshot.toJSON() };
  };
  return TransactionResult2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var nextPushId = function() {
  var PUSH_CHARS = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz";
  var lastPushTime = 0;
  var lastRandChars = [];
  return function(now2) {
    var duplicateTime = now2 === lastPushTime;
    lastPushTime = now2;
    var i;
    var timeStampChars = new Array(8);
    for (i = 7; i >= 0; i--) {
      timeStampChars[i] = PUSH_CHARS.charAt(now2 % 64);
      now2 = Math.floor(now2 / 64);
    }
    assert(now2 === 0, "Cannot push at time == 0");
    var id2 = timeStampChars.join("");
    if (!duplicateTime) {
      for (i = 0; i < 12; i++) {
        lastRandChars[i] = Math.floor(Math.random() * 64);
      }
    } else {
      for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
        lastRandChars[i] = 0;
      }
      lastRandChars[i]++;
    }
    for (i = 0; i < 12; i++) {
      id2 += PUSH_CHARS.charAt(lastRandChars[i]);
    }
    assert(id2.length === 20, "nextPushId: Length should be 20.");
    return id2;
  };
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var NamedNode = function() {
  function NamedNode2(name2, node) {
    this.name = name2;
    this.node = node;
  }
  NamedNode2.Wrap = function(name2, node) {
    return new NamedNode2(name2, node);
  };
  return NamedNode2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Index$1 = function() {
  function Index2() {
  }
  Index2.prototype.getCompare = function() {
    return this.compare.bind(this);
  };
  Index2.prototype.indexedValueChanged = function(oldNode, newNode) {
    var oldWrapped = new NamedNode(MIN_NAME, oldNode);
    var newWrapped = new NamedNode(MIN_NAME, newNode);
    return this.compare(oldWrapped, newWrapped) !== 0;
  };
  Index2.prototype.minPost = function() {
    return NamedNode.MIN;
  };
  return Index2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __EMPTY_NODE;
var KeyIndex = function(_super) {
  __extends$1(KeyIndex2, _super);
  function KeyIndex2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(KeyIndex2, "__EMPTY_NODE", {
    get: function() {
      return __EMPTY_NODE;
    },
    set: function(val) {
      __EMPTY_NODE = val;
    },
    enumerable: false,
    configurable: true
  });
  KeyIndex2.prototype.compare = function(a3, b3) {
    return nameCompare(a3.name, b3.name);
  };
  KeyIndex2.prototype.isDefinedOn = function(node) {
    throw assertionError("KeyIndex.isDefinedOn not expected to be called.");
  };
  KeyIndex2.prototype.indexedValueChanged = function(oldNode, newNode) {
    return false;
  };
  KeyIndex2.prototype.minPost = function() {
    return NamedNode.MIN;
  };
  KeyIndex2.prototype.maxPost = function() {
    return new NamedNode(MAX_NAME, __EMPTY_NODE);
  };
  KeyIndex2.prototype.makePost = function(indexValue, name2) {
    assert(typeof indexValue === "string", "KeyIndex indexValue must always be a string.");
    return new NamedNode(indexValue, __EMPTY_NODE);
  };
  KeyIndex2.prototype.toString = function() {
    return ".key";
  };
  return KeyIndex2;
}(Index$1);
var KEY_INDEX = new KeyIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MAX_NODE;
function setMaxNode(val) {
  MAX_NODE = val;
}
var priorityHashText = function(priority) {
  if (typeof priority === "number") {
    return "number:" + doubleToIEEE754String(priority);
  } else {
    return "string:" + priority;
  }
};
var validatePriorityNode = function(priorityNode) {
  if (priorityNode.isLeafNode()) {
    var val = priorityNode.val();
    assert(typeof val === "string" || typeof val === "number" || typeof val === "object" && contains(val, ".sv"), "Priority must be a string or number.");
  } else {
    assert(priorityNode === MAX_NODE || priorityNode.isEmpty(), "priority of unexpected type.");
  }
  assert(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __childrenNodeConstructor;
var LeafNode = function() {
  function LeafNode2(value_, priorityNode_) {
    if (priorityNode_ === void 0) {
      priorityNode_ = LeafNode2.__childrenNodeConstructor.EMPTY_NODE;
    }
    this.value_ = value_;
    this.priorityNode_ = priorityNode_;
    this.lazyHash_ = null;
    assert(this.value_ !== void 0 && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
    validatePriorityNode(this.priorityNode_);
  }
  Object.defineProperty(LeafNode2, "__childrenNodeConstructor", {
    get: function() {
      return __childrenNodeConstructor;
    },
    set: function(val) {
      __childrenNodeConstructor = val;
    },
    enumerable: false,
    configurable: true
  });
  LeafNode2.prototype.isLeafNode = function() {
    return true;
  };
  LeafNode2.prototype.getPriority = function() {
    return this.priorityNode_;
  };
  LeafNode2.prototype.updatePriority = function(newPriorityNode) {
    return new LeafNode2(this.value_, newPriorityNode);
  };
  LeafNode2.prototype.getImmediateChild = function(childName) {
    if (childName === ".priority") {
      return this.priorityNode_;
    } else {
      return LeafNode2.__childrenNodeConstructor.EMPTY_NODE;
    }
  };
  LeafNode2.prototype.getChild = function(path) {
    if (path.isEmpty()) {
      return this;
    } else if (path.getFront() === ".priority") {
      return this.priorityNode_;
    } else {
      return LeafNode2.__childrenNodeConstructor.EMPTY_NODE;
    }
  };
  LeafNode2.prototype.hasChild = function() {
    return false;
  };
  LeafNode2.prototype.getPredecessorChildName = function(childName, childNode) {
    return null;
  };
  LeafNode2.prototype.updateImmediateChild = function(childName, newChildNode) {
    if (childName === ".priority") {
      return this.updatePriority(newChildNode);
    } else if (newChildNode.isEmpty() && childName !== ".priority") {
      return this;
    } else {
      return LeafNode2.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
    }
  };
  LeafNode2.prototype.updateChild = function(path, newChildNode) {
    var front = path.getFront();
    if (front === null) {
      return newChildNode;
    } else if (newChildNode.isEmpty() && front !== ".priority") {
      return this;
    } else {
      assert(front !== ".priority" || path.getLength() === 1, ".priority must be the last token in a path");
      return this.updateImmediateChild(front, LeafNode2.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
    }
  };
  LeafNode2.prototype.isEmpty = function() {
    return false;
  };
  LeafNode2.prototype.numChildren = function() {
    return 0;
  };
  LeafNode2.prototype.forEachChild = function(index, action) {
    return false;
  };
  LeafNode2.prototype.val = function(exportFormat) {
    if (exportFormat && !this.getPriority().isEmpty()) {
      return {
        ".value": this.getValue(),
        ".priority": this.getPriority().val()
      };
    } else {
      return this.getValue();
    }
  };
  LeafNode2.prototype.hash = function() {
    if (this.lazyHash_ === null) {
      var toHash = "";
      if (!this.priorityNode_.isEmpty()) {
        toHash += "priority:" + priorityHashText(this.priorityNode_.val()) + ":";
      }
      var type = typeof this.value_;
      toHash += type + ":";
      if (type === "number") {
        toHash += doubleToIEEE754String(this.value_);
      } else {
        toHash += this.value_;
      }
      this.lazyHash_ = sha1(toHash);
    }
    return this.lazyHash_;
  };
  LeafNode2.prototype.getValue = function() {
    return this.value_;
  };
  LeafNode2.prototype.compareTo = function(other) {
    if (other === LeafNode2.__childrenNodeConstructor.EMPTY_NODE) {
      return 1;
    } else if (other instanceof LeafNode2.__childrenNodeConstructor) {
      return -1;
    } else {
      assert(other.isLeafNode(), "Unknown node type");
      return this.compareToLeafNode_(other);
    }
  };
  LeafNode2.prototype.compareToLeafNode_ = function(otherLeaf) {
    var otherLeafType = typeof otherLeaf.value_;
    var thisLeafType = typeof this.value_;
    var otherIndex = LeafNode2.VALUE_TYPE_ORDER.indexOf(otherLeafType);
    var thisIndex = LeafNode2.VALUE_TYPE_ORDER.indexOf(thisLeafType);
    assert(otherIndex >= 0, "Unknown leaf type: " + otherLeafType);
    assert(thisIndex >= 0, "Unknown leaf type: " + thisLeafType);
    if (otherIndex === thisIndex) {
      if (thisLeafType === "object") {
        return 0;
      } else {
        if (this.value_ < otherLeaf.value_) {
          return -1;
        } else if (this.value_ === otherLeaf.value_) {
          return 0;
        } else {
          return 1;
        }
      }
    } else {
      return thisIndex - otherIndex;
    }
  };
  LeafNode2.prototype.withIndex = function() {
    return this;
  };
  LeafNode2.prototype.isIndexed = function() {
    return true;
  };
  LeafNode2.prototype.equals = function(other) {
    if (other === this) {
      return true;
    } else if (other.isLeafNode()) {
      var otherLeaf = other;
      return this.value_ === otherLeaf.value_ && this.priorityNode_.equals(otherLeaf.priorityNode_);
    } else {
      return false;
    }
  };
  LeafNode2.VALUE_TYPE_ORDER = ["object", "boolean", "number", "string"];
  return LeafNode2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var nodeFromJSON;
var MAX_NODE$1;
function setNodeFromJSON(val) {
  nodeFromJSON = val;
}
function setMaxNode$1(val) {
  MAX_NODE$1 = val;
}
var PriorityIndex = function(_super) {
  __extends$1(PriorityIndex2, _super);
  function PriorityIndex2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PriorityIndex2.prototype.compare = function(a3, b3) {
    var aPriority = a3.node.getPriority();
    var bPriority = b3.node.getPriority();
    var indexCmp = aPriority.compareTo(bPriority);
    if (indexCmp === 0) {
      return nameCompare(a3.name, b3.name);
    } else {
      return indexCmp;
    }
  };
  PriorityIndex2.prototype.isDefinedOn = function(node) {
    return !node.getPriority().isEmpty();
  };
  PriorityIndex2.prototype.indexedValueChanged = function(oldNode, newNode) {
    return !oldNode.getPriority().equals(newNode.getPriority());
  };
  PriorityIndex2.prototype.minPost = function() {
    return NamedNode.MIN;
  };
  PriorityIndex2.prototype.maxPost = function() {
    return new NamedNode(MAX_NAME, new LeafNode("[PRIORITY-POST]", MAX_NODE$1));
  };
  PriorityIndex2.prototype.makePost = function(indexValue, name2) {
    var priorityNode = nodeFromJSON(indexValue);
    return new NamedNode(name2, new LeafNode("[PRIORITY-POST]", priorityNode));
  };
  PriorityIndex2.prototype.toString = function() {
    return ".priority";
  };
  return PriorityIndex2;
}(Index$1);
var PRIORITY_INDEX = new PriorityIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SortedMapIterator = function() {
  function SortedMapIterator2(node, startKey, comparator, isReverse_, resultGenerator_) {
    if (resultGenerator_ === void 0) {
      resultGenerator_ = null;
    }
    this.isReverse_ = isReverse_;
    this.resultGenerator_ = resultGenerator_;
    this.nodeStack_ = [];
    var cmp = 1;
    while (!node.isEmpty()) {
      node = node;
      cmp = startKey ? comparator(node.key, startKey) : 1;
      if (isReverse_) {
        cmp *= -1;
      }
      if (cmp < 0) {
        if (this.isReverse_) {
          node = node.left;
        } else {
          node = node.right;
        }
      } else if (cmp === 0) {
        this.nodeStack_.push(node);
        break;
      } else {
        this.nodeStack_.push(node);
        if (this.isReverse_) {
          node = node.right;
        } else {
          node = node.left;
        }
      }
    }
  }
  SortedMapIterator2.prototype.getNext = function() {
    if (this.nodeStack_.length === 0) {
      return null;
    }
    var node = this.nodeStack_.pop();
    var result2;
    if (this.resultGenerator_) {
      result2 = this.resultGenerator_(node.key, node.value);
    } else {
      result2 = { key: node.key, value: node.value };
    }
    if (this.isReverse_) {
      node = node.left;
      while (!node.isEmpty()) {
        this.nodeStack_.push(node);
        node = node.right;
      }
    } else {
      node = node.right;
      while (!node.isEmpty()) {
        this.nodeStack_.push(node);
        node = node.left;
      }
    }
    return result2;
  };
  SortedMapIterator2.prototype.hasNext = function() {
    return this.nodeStack_.length > 0;
  };
  SortedMapIterator2.prototype.peek = function() {
    if (this.nodeStack_.length === 0) {
      return null;
    }
    var node = this.nodeStack_[this.nodeStack_.length - 1];
    if (this.resultGenerator_) {
      return this.resultGenerator_(node.key, node.value);
    } else {
      return { key: node.key, value: node.value };
    }
  };
  return SortedMapIterator2;
}();
var LLRBNode = function() {
  function LLRBNode2(key, value, color, left, right) {
    this.key = key;
    this.value = value;
    this.color = color != null ? color : LLRBNode2.RED;
    this.left = left != null ? left : SortedMap.EMPTY_NODE;
    this.right = right != null ? right : SortedMap.EMPTY_NODE;
  }
  LLRBNode2.prototype.copy = function(key, value, color, left, right) {
    return new LLRBNode2(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
  };
  LLRBNode2.prototype.count = function() {
    return this.left.count() + 1 + this.right.count();
  };
  LLRBNode2.prototype.isEmpty = function() {
    return false;
  };
  LLRBNode2.prototype.inorderTraversal = function(action) {
    return this.left.inorderTraversal(action) || !!action(this.key, this.value) || this.right.inorderTraversal(action);
  };
  LLRBNode2.prototype.reverseTraversal = function(action) {
    return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
  };
  LLRBNode2.prototype.min_ = function() {
    if (this.left.isEmpty()) {
      return this;
    } else {
      return this.left.min_();
    }
  };
  LLRBNode2.prototype.minKey = function() {
    return this.min_().key;
  };
  LLRBNode2.prototype.maxKey = function() {
    if (this.right.isEmpty()) {
      return this.key;
    } else {
      return this.right.maxKey();
    }
  };
  LLRBNode2.prototype.insert = function(key, value, comparator) {
    var n3 = this;
    var cmp = comparator(key, n3.key);
    if (cmp < 0) {
      n3 = n3.copy(null, null, null, n3.left.insert(key, value, comparator), null);
    } else if (cmp === 0) {
      n3 = n3.copy(null, value, null, null, null);
    } else {
      n3 = n3.copy(null, null, null, null, n3.right.insert(key, value, comparator));
    }
    return n3.fixUp_();
  };
  LLRBNode2.prototype.removeMin_ = function() {
    if (this.left.isEmpty()) {
      return SortedMap.EMPTY_NODE;
    }
    var n3 = this;
    if (!n3.left.isRed_() && !n3.left.left.isRed_()) {
      n3 = n3.moveRedLeft_();
    }
    n3 = n3.copy(null, null, null, n3.left.removeMin_(), null);
    return n3.fixUp_();
  };
  LLRBNode2.prototype.remove = function(key, comparator) {
    var n3, smallest;
    n3 = this;
    if (comparator(key, n3.key) < 0) {
      if (!n3.left.isEmpty() && !n3.left.isRed_() && !n3.left.left.isRed_()) {
        n3 = n3.moveRedLeft_();
      }
      n3 = n3.copy(null, null, null, n3.left.remove(key, comparator), null);
    } else {
      if (n3.left.isRed_()) {
        n3 = n3.rotateRight_();
      }
      if (!n3.right.isEmpty() && !n3.right.isRed_() && !n3.right.left.isRed_()) {
        n3 = n3.moveRedRight_();
      }
      if (comparator(key, n3.key) === 0) {
        if (n3.right.isEmpty()) {
          return SortedMap.EMPTY_NODE;
        } else {
          smallest = n3.right.min_();
          n3 = n3.copy(smallest.key, smallest.value, null, null, n3.right.removeMin_());
        }
      }
      n3 = n3.copy(null, null, null, null, n3.right.remove(key, comparator));
    }
    return n3.fixUp_();
  };
  LLRBNode2.prototype.isRed_ = function() {
    return this.color;
  };
  LLRBNode2.prototype.fixUp_ = function() {
    var n3 = this;
    if (n3.right.isRed_() && !n3.left.isRed_()) {
      n3 = n3.rotateLeft_();
    }
    if (n3.left.isRed_() && n3.left.left.isRed_()) {
      n3 = n3.rotateRight_();
    }
    if (n3.left.isRed_() && n3.right.isRed_()) {
      n3 = n3.colorFlip_();
    }
    return n3;
  };
  LLRBNode2.prototype.moveRedLeft_ = function() {
    var n3 = this.colorFlip_();
    if (n3.right.left.isRed_()) {
      n3 = n3.copy(null, null, null, null, n3.right.rotateRight_());
      n3 = n3.rotateLeft_();
      n3 = n3.colorFlip_();
    }
    return n3;
  };
  LLRBNode2.prototype.moveRedRight_ = function() {
    var n3 = this.colorFlip_();
    if (n3.left.left.isRed_()) {
      n3 = n3.rotateRight_();
      n3 = n3.colorFlip_();
    }
    return n3;
  };
  LLRBNode2.prototype.rotateLeft_ = function() {
    var nl = this.copy(null, null, LLRBNode2.RED, null, this.right.left);
    return this.right.copy(null, null, this.color, nl, null);
  };
  LLRBNode2.prototype.rotateRight_ = function() {
    var nr2 = this.copy(null, null, LLRBNode2.RED, this.left.right, null);
    return this.left.copy(null, null, this.color, null, nr2);
  };
  LLRBNode2.prototype.colorFlip_ = function() {
    var left = this.left.copy(null, null, !this.left.color, null, null);
    var right = this.right.copy(null, null, !this.right.color, null, null);
    return this.copy(null, null, !this.color, left, right);
  };
  LLRBNode2.prototype.checkMaxDepth_ = function() {
    var blackDepth = this.check_();
    return Math.pow(2, blackDepth) <= this.count() + 1;
  };
  LLRBNode2.prototype.check_ = function() {
    if (this.isRed_() && this.left.isRed_()) {
      throw new Error("Red node has red child(" + this.key + "," + this.value + ")");
    }
    if (this.right.isRed_()) {
      throw new Error("Right child of (" + this.key + "," + this.value + ") is red");
    }
    var blackDepth = this.left.check_();
    if (blackDepth !== this.right.check_()) {
      throw new Error("Black depths differ");
    } else {
      return blackDepth + (this.isRed_() ? 0 : 1);
    }
  };
  LLRBNode2.RED = true;
  LLRBNode2.BLACK = false;
  return LLRBNode2;
}();
var LLRBEmptyNode = function() {
  function LLRBEmptyNode2() {
  }
  LLRBEmptyNode2.prototype.copy = function(key, value, color, left, right) {
    return this;
  };
  LLRBEmptyNode2.prototype.insert = function(key, value, comparator) {
    return new LLRBNode(key, value, null);
  };
  LLRBEmptyNode2.prototype.remove = function(key, comparator) {
    return this;
  };
  LLRBEmptyNode2.prototype.count = function() {
    return 0;
  };
  LLRBEmptyNode2.prototype.isEmpty = function() {
    return true;
  };
  LLRBEmptyNode2.prototype.inorderTraversal = function(action) {
    return false;
  };
  LLRBEmptyNode2.prototype.reverseTraversal = function(action) {
    return false;
  };
  LLRBEmptyNode2.prototype.minKey = function() {
    return null;
  };
  LLRBEmptyNode2.prototype.maxKey = function() {
    return null;
  };
  LLRBEmptyNode2.prototype.check_ = function() {
    return 0;
  };
  LLRBEmptyNode2.prototype.isRed_ = function() {
    return false;
  };
  return LLRBEmptyNode2;
}();
var SortedMap = function() {
  function SortedMap2(comparator_, root_) {
    if (root_ === void 0) {
      root_ = SortedMap2.EMPTY_NODE;
    }
    this.comparator_ = comparator_;
    this.root_ = root_;
  }
  SortedMap2.prototype.insert = function(key, value) {
    return new SortedMap2(this.comparator_, this.root_.insert(key, value, this.comparator_).copy(null, null, LLRBNode.BLACK, null, null));
  };
  SortedMap2.prototype.remove = function(key) {
    return new SortedMap2(this.comparator_, this.root_.remove(key, this.comparator_).copy(null, null, LLRBNode.BLACK, null, null));
  };
  SortedMap2.prototype.get = function(key) {
    var cmp;
    var node = this.root_;
    while (!node.isEmpty()) {
      cmp = this.comparator_(key, node.key);
      if (cmp === 0) {
        return node.value;
      } else if (cmp < 0) {
        node = node.left;
      } else if (cmp > 0) {
        node = node.right;
      }
    }
    return null;
  };
  SortedMap2.prototype.getPredecessorKey = function(key) {
    var cmp, node = this.root_, rightParent = null;
    while (!node.isEmpty()) {
      cmp = this.comparator_(key, node.key);
      if (cmp === 0) {
        if (!node.left.isEmpty()) {
          node = node.left;
          while (!node.right.isEmpty()) {
            node = node.right;
          }
          return node.key;
        } else if (rightParent) {
          return rightParent.key;
        } else {
          return null;
        }
      } else if (cmp < 0) {
        node = node.left;
      } else if (cmp > 0) {
        rightParent = node;
        node = node.right;
      }
    }
    throw new Error("Attempted to find predecessor key for a nonexistent key.  What gives?");
  };
  SortedMap2.prototype.isEmpty = function() {
    return this.root_.isEmpty();
  };
  SortedMap2.prototype.count = function() {
    return this.root_.count();
  };
  SortedMap2.prototype.minKey = function() {
    return this.root_.minKey();
  };
  SortedMap2.prototype.maxKey = function() {
    return this.root_.maxKey();
  };
  SortedMap2.prototype.inorderTraversal = function(action) {
    return this.root_.inorderTraversal(action);
  };
  SortedMap2.prototype.reverseTraversal = function(action) {
    return this.root_.reverseTraversal(action);
  };
  SortedMap2.prototype.getIterator = function(resultGenerator) {
    return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
  };
  SortedMap2.prototype.getIteratorFrom = function(key, resultGenerator) {
    return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
  };
  SortedMap2.prototype.getReverseIteratorFrom = function(key, resultGenerator) {
    return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
  };
  SortedMap2.prototype.getReverseIterator = function(resultGenerator) {
    return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
  };
  SortedMap2.EMPTY_NODE = new LLRBEmptyNode();
  return SortedMap2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_2 = Math.log(2);
var Base12Num = function() {
  function Base12Num2(length) {
    var logBase2 = function(num) {
      return parseInt(Math.log(num) / LOG_2, 10);
    };
    var bitMask = function(bits) {
      return parseInt(Array(bits + 1).join("1"), 2);
    };
    this.count = logBase2(length + 1);
    this.current_ = this.count - 1;
    var mask = bitMask(this.count);
    this.bits_ = length + 1 & mask;
  }
  Base12Num2.prototype.nextBitIsOne = function() {
    var result2 = !(this.bits_ & 1 << this.current_);
    this.current_--;
    return result2;
  };
  return Base12Num2;
}();
var buildChildSet = function(childList, cmp, keyFn, mapSortFn) {
  childList.sort(cmp);
  var buildBalancedTree = function(low, high) {
    var length = high - low;
    var namedNode;
    var key;
    if (length === 0) {
      return null;
    } else if (length === 1) {
      namedNode = childList[low];
      key = keyFn ? keyFn(namedNode) : namedNode;
      return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, null, null);
    } else {
      var middle = parseInt(length / 2, 10) + low;
      var left = buildBalancedTree(low, middle);
      var right = buildBalancedTree(middle + 1, high);
      namedNode = childList[middle];
      key = keyFn ? keyFn(namedNode) : namedNode;
      return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, left, right);
    }
  };
  var buildFrom12Array = function(base122) {
    var node = null;
    var root2 = null;
    var index = childList.length;
    var buildPennant = function(chunkSize2, color) {
      var low = index - chunkSize2;
      var high = index;
      index -= chunkSize2;
      var childTree = buildBalancedTree(low + 1, high);
      var namedNode = childList[low];
      var key = keyFn ? keyFn(namedNode) : namedNode;
      attachPennant(new LLRBNode(key, namedNode.node, color, null, childTree));
    };
    var attachPennant = function(pennant) {
      if (node) {
        node.left = pennant;
        node = pennant;
      } else {
        root2 = pennant;
        node = pennant;
      }
    };
    for (var i = 0; i < base122.count; ++i) {
      var isOne = base122.nextBitIsOne();
      var chunkSize = Math.pow(2, base122.count - (i + 1));
      if (isOne) {
        buildPennant(chunkSize, LLRBNode.BLACK);
      } else {
        buildPennant(chunkSize, LLRBNode.BLACK);
        buildPennant(chunkSize, LLRBNode.RED);
      }
    }
    return root2;
  };
  var base12 = new Base12Num(childList.length);
  var root = buildFrom12Array(base12);
  return new SortedMap(mapSortFn || cmp, root);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _defaultIndexMap;
var fallbackObject = {};
var IndexMap = function() {
  function IndexMap2(indexes_, indexSet_) {
    this.indexes_ = indexes_;
    this.indexSet_ = indexSet_;
  }
  Object.defineProperty(IndexMap2, "Default", {
    get: function() {
      assert(fallbackObject && PRIORITY_INDEX, "ChildrenNode.ts has not been loaded");
      _defaultIndexMap = _defaultIndexMap || new IndexMap2({ ".priority": fallbackObject }, { ".priority": PRIORITY_INDEX });
      return _defaultIndexMap;
    },
    enumerable: false,
    configurable: true
  });
  IndexMap2.prototype.get = function(indexKey) {
    var sortedMap = safeGet(this.indexes_, indexKey);
    if (!sortedMap) {
      throw new Error("No index defined for " + indexKey);
    }
    if (sortedMap instanceof SortedMap) {
      return sortedMap;
    } else {
      return null;
    }
  };
  IndexMap2.prototype.hasIndex = function(indexDefinition) {
    return contains(this.indexSet_, indexDefinition.toString());
  };
  IndexMap2.prototype.addIndex = function(indexDefinition, existingChildren) {
    assert(indexDefinition !== KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
    var childList = [];
    var sawIndexedValue = false;
    var iter = existingChildren.getIterator(NamedNode.Wrap);
    var next = iter.getNext();
    while (next) {
      sawIndexedValue = sawIndexedValue || indexDefinition.isDefinedOn(next.node);
      childList.push(next);
      next = iter.getNext();
    }
    var newIndex;
    if (sawIndexedValue) {
      newIndex = buildChildSet(childList, indexDefinition.getCompare());
    } else {
      newIndex = fallbackObject;
    }
    var indexName = indexDefinition.toString();
    var newIndexSet = __assign({}, this.indexSet_);
    newIndexSet[indexName] = indexDefinition;
    var newIndexes = __assign({}, this.indexes_);
    newIndexes[indexName] = newIndex;
    return new IndexMap2(newIndexes, newIndexSet);
  };
  IndexMap2.prototype.addToIndexes = function(namedNode, existingChildren) {
    var _this = this;
    var newIndexes = map$1(this.indexes_, function(indexedChildren, indexName) {
      var index = safeGet(_this.indexSet_, indexName);
      assert(index, "Missing index implementation for " + indexName);
      if (indexedChildren === fallbackObject) {
        if (index.isDefinedOn(namedNode.node)) {
          var childList = [];
          var iter = existingChildren.getIterator(NamedNode.Wrap);
          var next = iter.getNext();
          while (next) {
            if (next.name !== namedNode.name) {
              childList.push(next);
            }
            next = iter.getNext();
          }
          childList.push(namedNode);
          return buildChildSet(childList, index.getCompare());
        } else {
          return fallbackObject;
        }
      } else {
        var existingSnap = existingChildren.get(namedNode.name);
        var newChildren = indexedChildren;
        if (existingSnap) {
          newChildren = newChildren.remove(new NamedNode(namedNode.name, existingSnap));
        }
        return newChildren.insert(namedNode, namedNode.node);
      }
    });
    return new IndexMap2(newIndexes, this.indexSet_);
  };
  IndexMap2.prototype.removeFromIndexes = function(namedNode, existingChildren) {
    var newIndexes = map$1(this.indexes_, function(indexedChildren) {
      if (indexedChildren === fallbackObject) {
        return indexedChildren;
      } else {
        var existingSnap = existingChildren.get(namedNode.name);
        if (existingSnap) {
          return indexedChildren.remove(new NamedNode(namedNode.name, existingSnap));
        } else {
          return indexedChildren;
        }
      }
    });
    return new IndexMap2(newIndexes, this.indexSet_);
  };
  return IndexMap2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function NAME_ONLY_COMPARATOR(left, right) {
  return nameCompare(left.name, right.name);
}
function NAME_COMPARATOR(left, right) {
  return nameCompare(left, right);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var EMPTY_NODE;
var ChildrenNode = function() {
  function ChildrenNode2(children_, priorityNode_, indexMap_) {
    this.children_ = children_;
    this.priorityNode_ = priorityNode_;
    this.indexMap_ = indexMap_;
    this.lazyHash_ = null;
    if (this.priorityNode_) {
      validatePriorityNode(this.priorityNode_);
    }
    if (this.children_.isEmpty()) {
      assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), "An empty node cannot have a priority");
    }
  }
  Object.defineProperty(ChildrenNode2, "EMPTY_NODE", {
    get: function() {
      return EMPTY_NODE || (EMPTY_NODE = new ChildrenNode2(new SortedMap(NAME_COMPARATOR), null, IndexMap.Default));
    },
    enumerable: false,
    configurable: true
  });
  ChildrenNode2.prototype.isLeafNode = function() {
    return false;
  };
  ChildrenNode2.prototype.getPriority = function() {
    return this.priorityNode_ || EMPTY_NODE;
  };
  ChildrenNode2.prototype.updatePriority = function(newPriorityNode) {
    if (this.children_.isEmpty()) {
      return this;
    } else {
      return new ChildrenNode2(this.children_, newPriorityNode, this.indexMap_);
    }
  };
  ChildrenNode2.prototype.getImmediateChild = function(childName) {
    if (childName === ".priority") {
      return this.getPriority();
    } else {
      var child2 = this.children_.get(childName);
      return child2 === null ? EMPTY_NODE : child2;
    }
  };
  ChildrenNode2.prototype.getChild = function(path) {
    var front = path.getFront();
    if (front === null) {
      return this;
    }
    return this.getImmediateChild(front).getChild(path.popFront());
  };
  ChildrenNode2.prototype.hasChild = function(childName) {
    return this.children_.get(childName) !== null;
  };
  ChildrenNode2.prototype.updateImmediateChild = function(childName, newChildNode) {
    assert(newChildNode, "We should always be passing snapshot nodes");
    if (childName === ".priority") {
      return this.updatePriority(newChildNode);
    } else {
      var namedNode = new NamedNode(childName, newChildNode);
      var newChildren = void 0, newIndexMap = void 0;
      if (newChildNode.isEmpty()) {
        newChildren = this.children_.remove(childName);
        newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
      } else {
        newChildren = this.children_.insert(childName, newChildNode);
        newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
      }
      var newPriority = newChildren.isEmpty() ? EMPTY_NODE : this.priorityNode_;
      return new ChildrenNode2(newChildren, newPriority, newIndexMap);
    }
  };
  ChildrenNode2.prototype.updateChild = function(path, newChildNode) {
    var front = path.getFront();
    if (front === null) {
      return newChildNode;
    } else {
      assert(path.getFront() !== ".priority" || path.getLength() === 1, ".priority must be the last token in a path");
      var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
      return this.updateImmediateChild(front, newImmediateChild);
    }
  };
  ChildrenNode2.prototype.isEmpty = function() {
    return this.children_.isEmpty();
  };
  ChildrenNode2.prototype.numChildren = function() {
    return this.children_.count();
  };
  ChildrenNode2.prototype.val = function(exportFormat) {
    if (this.isEmpty()) {
      return null;
    }
    var obj = {};
    var numKeys = 0, maxKey = 0, allIntegerKeys = true;
    this.forEachChild(PRIORITY_INDEX, function(key2, childNode) {
      obj[key2] = childNode.val(exportFormat);
      numKeys++;
      if (allIntegerKeys && ChildrenNode2.INTEGER_REGEXP_.test(key2)) {
        maxKey = Math.max(maxKey, Number(key2));
      } else {
        allIntegerKeys = false;
      }
    });
    if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
      var array2 = [];
      for (var key in obj) {
        array2[key] = obj[key];
      }
      return array2;
    } else {
      if (exportFormat && !this.getPriority().isEmpty()) {
        obj[".priority"] = this.getPriority().val();
      }
      return obj;
    }
  };
  ChildrenNode2.prototype.hash = function() {
    if (this.lazyHash_ === null) {
      var toHash_1 = "";
      if (!this.getPriority().isEmpty()) {
        toHash_1 += "priority:" + priorityHashText(this.getPriority().val()) + ":";
      }
      this.forEachChild(PRIORITY_INDEX, function(key, childNode) {
        var childHash = childNode.hash();
        if (childHash !== "") {
          toHash_1 += ":" + key + ":" + childHash;
        }
      });
      this.lazyHash_ = toHash_1 === "" ? "" : sha1(toHash_1);
    }
    return this.lazyHash_;
  };
  ChildrenNode2.prototype.getPredecessorChildName = function(childName, childNode, index) {
    var idx = this.resolveIndex_(index);
    if (idx) {
      var predecessor = idx.getPredecessorKey(new NamedNode(childName, childNode));
      return predecessor ? predecessor.name : null;
    } else {
      return this.children_.getPredecessorKey(childName);
    }
  };
  ChildrenNode2.prototype.getFirstChildName = function(indexDefinition) {
    var idx = this.resolveIndex_(indexDefinition);
    if (idx) {
      var minKey = idx.minKey();
      return minKey && minKey.name;
    } else {
      return this.children_.minKey();
    }
  };
  ChildrenNode2.prototype.getFirstChild = function(indexDefinition) {
    var minKey = this.getFirstChildName(indexDefinition);
    if (minKey) {
      return new NamedNode(minKey, this.children_.get(minKey));
    } else {
      return null;
    }
  };
  ChildrenNode2.prototype.getLastChildName = function(indexDefinition) {
    var idx = this.resolveIndex_(indexDefinition);
    if (idx) {
      var maxKey = idx.maxKey();
      return maxKey && maxKey.name;
    } else {
      return this.children_.maxKey();
    }
  };
  ChildrenNode2.prototype.getLastChild = function(indexDefinition) {
    var maxKey = this.getLastChildName(indexDefinition);
    if (maxKey) {
      return new NamedNode(maxKey, this.children_.get(maxKey));
    } else {
      return null;
    }
  };
  ChildrenNode2.prototype.forEachChild = function(index, action) {
    var idx = this.resolveIndex_(index);
    if (idx) {
      return idx.inorderTraversal(function(wrappedNode) {
        return action(wrappedNode.name, wrappedNode.node);
      });
    } else {
      return this.children_.inorderTraversal(action);
    }
  };
  ChildrenNode2.prototype.getIterator = function(indexDefinition) {
    return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
  };
  ChildrenNode2.prototype.getIteratorFrom = function(startPost, indexDefinition) {
    var idx = this.resolveIndex_(indexDefinition);
    if (idx) {
      return idx.getIteratorFrom(startPost, function(key) {
        return key;
      });
    } else {
      var iterator = this.children_.getIteratorFrom(startPost.name, NamedNode.Wrap);
      var next = iterator.peek();
      while (next != null && indexDefinition.compare(next, startPost) < 0) {
        iterator.getNext();
        next = iterator.peek();
      }
      return iterator;
    }
  };
  ChildrenNode2.prototype.getReverseIterator = function(indexDefinition) {
    return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
  };
  ChildrenNode2.prototype.getReverseIteratorFrom = function(endPost, indexDefinition) {
    var idx = this.resolveIndex_(indexDefinition);
    if (idx) {
      return idx.getReverseIteratorFrom(endPost, function(key) {
        return key;
      });
    } else {
      var iterator = this.children_.getReverseIteratorFrom(endPost.name, NamedNode.Wrap);
      var next = iterator.peek();
      while (next != null && indexDefinition.compare(next, endPost) > 0) {
        iterator.getNext();
        next = iterator.peek();
      }
      return iterator;
    }
  };
  ChildrenNode2.prototype.compareTo = function(other) {
    if (this.isEmpty()) {
      if (other.isEmpty()) {
        return 0;
      } else {
        return -1;
      }
    } else if (other.isLeafNode() || other.isEmpty()) {
      return 1;
    } else if (other === MAX_NODE$2) {
      return -1;
    } else {
      return 0;
    }
  };
  ChildrenNode2.prototype.withIndex = function(indexDefinition) {
    if (indexDefinition === KEY_INDEX || this.indexMap_.hasIndex(indexDefinition)) {
      return this;
    } else {
      var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
      return new ChildrenNode2(this.children_, this.priorityNode_, newIndexMap);
    }
  };
  ChildrenNode2.prototype.isIndexed = function(index) {
    return index === KEY_INDEX || this.indexMap_.hasIndex(index);
  };
  ChildrenNode2.prototype.equals = function(other) {
    if (other === this) {
      return true;
    } else if (other.isLeafNode()) {
      return false;
    } else {
      var otherChildrenNode = other;
      if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
        return false;
      } else if (this.children_.count() === otherChildrenNode.children_.count()) {
        var thisIter = this.getIterator(PRIORITY_INDEX);
        var otherIter = otherChildrenNode.getIterator(PRIORITY_INDEX);
        var thisCurrent = thisIter.getNext();
        var otherCurrent = otherIter.getNext();
        while (thisCurrent && otherCurrent) {
          if (thisCurrent.name !== otherCurrent.name || !thisCurrent.node.equals(otherCurrent.node)) {
            return false;
          }
          thisCurrent = thisIter.getNext();
          otherCurrent = otherIter.getNext();
        }
        return thisCurrent === null && otherCurrent === null;
      } else {
        return false;
      }
    }
  };
  ChildrenNode2.prototype.resolveIndex_ = function(indexDefinition) {
    if (indexDefinition === KEY_INDEX) {
      return null;
    } else {
      return this.indexMap_.get(indexDefinition.toString());
    }
  };
  ChildrenNode2.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
  return ChildrenNode2;
}();
var MaxNode = function(_super) {
  __extends$1(MaxNode2, _super);
  function MaxNode2() {
    return _super.call(this, new SortedMap(NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, IndexMap.Default) || this;
  }
  MaxNode2.prototype.compareTo = function(other) {
    if (other === this) {
      return 0;
    } else {
      return 1;
    }
  };
  MaxNode2.prototype.equals = function(other) {
    return other === this;
  };
  MaxNode2.prototype.getPriority = function() {
    return this;
  };
  MaxNode2.prototype.getImmediateChild = function(childName) {
    return ChildrenNode.EMPTY_NODE;
  };
  MaxNode2.prototype.isEmpty = function() {
    return false;
  };
  return MaxNode2;
}(ChildrenNode);
var MAX_NODE$2 = new MaxNode();
Object.defineProperties(NamedNode, {
  MIN: {
    value: new NamedNode(MIN_NAME, ChildrenNode.EMPTY_NODE)
  },
  MAX: {
    value: new NamedNode(MAX_NAME, MAX_NODE$2)
  }
});
KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
LeafNode.__childrenNodeConstructor = ChildrenNode;
setMaxNode(MAX_NODE$2);
setMaxNode$1(MAX_NODE$2);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var USE_HINZE = true;
function nodeFromJSON$1(json, priority) {
  if (priority === void 0) {
    priority = null;
  }
  if (json === null) {
    return ChildrenNode.EMPTY_NODE;
  }
  if (typeof json === "object" && ".priority" in json) {
    priority = json[".priority"];
  }
  assert(priority === null || typeof priority === "string" || typeof priority === "number" || typeof priority === "object" && ".sv" in priority, "Invalid priority type found: " + typeof priority);
  if (typeof json === "object" && ".value" in json && json[".value"] !== null) {
    json = json[".value"];
  }
  if (typeof json !== "object" || ".sv" in json) {
    var jsonLeaf = json;
    return new LeafNode(jsonLeaf, nodeFromJSON$1(priority));
  }
  if (!(json instanceof Array) && USE_HINZE) {
    var children_1 = [];
    var childrenHavePriority_1 = false;
    var hinzeJsonObj = json;
    each(hinzeJsonObj, function(key, child2) {
      if (key.substring(0, 1) !== ".") {
        var childNode = nodeFromJSON$1(child2);
        if (!childNode.isEmpty()) {
          childrenHavePriority_1 = childrenHavePriority_1 || !childNode.getPriority().isEmpty();
          children_1.push(new NamedNode(key, childNode));
        }
      }
    });
    if (children_1.length === 0) {
      return ChildrenNode.EMPTY_NODE;
    }
    var childSet = buildChildSet(children_1, NAME_ONLY_COMPARATOR, function(namedNode) {
      return namedNode.name;
    }, NAME_COMPARATOR);
    if (childrenHavePriority_1) {
      var sortedChildSet = buildChildSet(children_1, PRIORITY_INDEX.getCompare());
      return new ChildrenNode(childSet, nodeFromJSON$1(priority), new IndexMap({ ".priority": sortedChildSet }, { ".priority": PRIORITY_INDEX }));
    } else {
      return new ChildrenNode(childSet, nodeFromJSON$1(priority), IndexMap.Default);
    }
  } else {
    var node_1 = ChildrenNode.EMPTY_NODE;
    each(json, function(key, childData) {
      if (contains(json, key)) {
        if (key.substring(0, 1) !== ".") {
          var childNode = nodeFromJSON$1(childData);
          if (childNode.isLeafNode() || !childNode.isEmpty()) {
            node_1 = node_1.updateImmediateChild(key, childNode);
          }
        }
      }
    });
    return node_1.updatePriority(nodeFromJSON$1(priority));
  }
}
setNodeFromJSON(nodeFromJSON$1);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ValueIndex = function(_super) {
  __extends$1(ValueIndex2, _super);
  function ValueIndex2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ValueIndex2.prototype.compare = function(a3, b3) {
    var indexCmp = a3.node.compareTo(b3.node);
    if (indexCmp === 0) {
      return nameCompare(a3.name, b3.name);
    } else {
      return indexCmp;
    }
  };
  ValueIndex2.prototype.isDefinedOn = function(node) {
    return true;
  };
  ValueIndex2.prototype.indexedValueChanged = function(oldNode, newNode) {
    return !oldNode.equals(newNode);
  };
  ValueIndex2.prototype.minPost = function() {
    return NamedNode.MIN;
  };
  ValueIndex2.prototype.maxPost = function() {
    return NamedNode.MAX;
  };
  ValueIndex2.prototype.makePost = function(indexValue, name2) {
    var valueNode = nodeFromJSON$1(indexValue);
    return new NamedNode(name2, valueNode);
  };
  ValueIndex2.prototype.toString = function() {
    return ".value";
  };
  return ValueIndex2;
}(Index$1);
var VALUE_INDEX = new ValueIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PathIndex = function(_super) {
  __extends$1(PathIndex2, _super);
  function PathIndex2(indexPath_) {
    var _this = _super.call(this) || this;
    _this.indexPath_ = indexPath_;
    assert(!indexPath_.isEmpty() && indexPath_.getFront() !== ".priority", "Can't create PathIndex with empty path or .priority key");
    return _this;
  }
  PathIndex2.prototype.extractChild = function(snap) {
    return snap.getChild(this.indexPath_);
  };
  PathIndex2.prototype.isDefinedOn = function(node) {
    return !node.getChild(this.indexPath_).isEmpty();
  };
  PathIndex2.prototype.compare = function(a3, b3) {
    var aChild = this.extractChild(a3.node);
    var bChild = this.extractChild(b3.node);
    var indexCmp = aChild.compareTo(bChild);
    if (indexCmp === 0) {
      return nameCompare(a3.name, b3.name);
    } else {
      return indexCmp;
    }
  };
  PathIndex2.prototype.makePost = function(indexValue, name2) {
    var valueNode = nodeFromJSON$1(indexValue);
    var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
    return new NamedNode(name2, node);
  };
  PathIndex2.prototype.maxPost = function() {
    var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, MAX_NODE$2);
    return new NamedNode(MAX_NAME, node);
  };
  PathIndex2.prototype.toString = function() {
    return this.indexPath_.slice().join("/");
  };
  return PathIndex2;
}(Index$1);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DataSnapshot = function() {
  function DataSnapshot2(node_, ref_, index_) {
    this.node_ = node_;
    this.ref_ = ref_;
    this.index_ = index_;
  }
  DataSnapshot2.prototype.val = function() {
    validateArgCount("DataSnapshot.val", 0, 0, arguments.length);
    return this.node_.val();
  };
  DataSnapshot2.prototype.exportVal = function() {
    validateArgCount("DataSnapshot.exportVal", 0, 0, arguments.length);
    return this.node_.val(true);
  };
  DataSnapshot2.prototype.toJSON = function() {
    validateArgCount("DataSnapshot.toJSON", 0, 1, arguments.length);
    return this.exportVal();
  };
  DataSnapshot2.prototype.exists = function() {
    validateArgCount("DataSnapshot.exists", 0, 0, arguments.length);
    return !this.node_.isEmpty();
  };
  DataSnapshot2.prototype.child = function(childPathString) {
    validateArgCount("DataSnapshot.child", 0, 1, arguments.length);
    childPathString = String(childPathString);
    validatePathString("DataSnapshot.child", 1, childPathString, false);
    var childPath = new Path(childPathString);
    var childRef = this.ref_.child(childPath);
    return new DataSnapshot2(this.node_.getChild(childPath), childRef, PRIORITY_INDEX);
  };
  DataSnapshot2.prototype.hasChild = function(childPathString) {
    validateArgCount("DataSnapshot.hasChild", 1, 1, arguments.length);
    validatePathString("DataSnapshot.hasChild", 1, childPathString, false);
    var childPath = new Path(childPathString);
    return !this.node_.getChild(childPath).isEmpty();
  };
  DataSnapshot2.prototype.getPriority = function() {
    validateArgCount("DataSnapshot.getPriority", 0, 0, arguments.length);
    return this.node_.getPriority().val();
  };
  DataSnapshot2.prototype.forEach = function(action) {
    var _this = this;
    validateArgCount("DataSnapshot.forEach", 1, 1, arguments.length);
    validateCallback("DataSnapshot.forEach", 1, action, false);
    if (this.node_.isLeafNode()) {
      return false;
    }
    var childrenNode = this.node_;
    return !!childrenNode.forEachChild(this.index_, function(key, node) {
      return action(new DataSnapshot2(node, _this.ref_.child(key), PRIORITY_INDEX));
    });
  };
  DataSnapshot2.prototype.hasChildren = function() {
    validateArgCount("DataSnapshot.hasChildren", 0, 0, arguments.length);
    if (this.node_.isLeafNode()) {
      return false;
    } else {
      return !this.node_.isEmpty();
    }
  };
  Object.defineProperty(DataSnapshot2.prototype, "key", {
    get: function() {
      return this.ref_.getKey();
    },
    enumerable: false,
    configurable: true
  });
  DataSnapshot2.prototype.numChildren = function() {
    validateArgCount("DataSnapshot.numChildren", 0, 0, arguments.length);
    return this.node_.numChildren();
  };
  DataSnapshot2.prototype.getRef = function() {
    validateArgCount("DataSnapshot.ref", 0, 0, arguments.length);
    return this.ref_;
  };
  Object.defineProperty(DataSnapshot2.prototype, "ref", {
    get: function() {
      return this.getRef();
    },
    enumerable: false,
    configurable: true
  });
  return DataSnapshot2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DataEvent = function() {
  function DataEvent2(eventType, eventRegistration, snapshot, prevName) {
    this.eventType = eventType;
    this.eventRegistration = eventRegistration;
    this.snapshot = snapshot;
    this.prevName = prevName;
  }
  DataEvent2.prototype.getPath = function() {
    var ref2 = this.snapshot.getRef();
    if (this.eventType === "value") {
      return ref2.path;
    } else {
      return ref2.getParent().path;
    }
  };
  DataEvent2.prototype.getEventType = function() {
    return this.eventType;
  };
  DataEvent2.prototype.getEventRunner = function() {
    return this.eventRegistration.getEventRunner(this);
  };
  DataEvent2.prototype.toString = function() {
    return this.getPath().toString() + ":" + this.eventType + ":" + stringify(this.snapshot.exportVal());
  };
  return DataEvent2;
}();
var CancelEvent = function() {
  function CancelEvent2(eventRegistration, error2, path) {
    this.eventRegistration = eventRegistration;
    this.error = error2;
    this.path = path;
  }
  CancelEvent2.prototype.getPath = function() {
    return this.path;
  };
  CancelEvent2.prototype.getEventType = function() {
    return "cancel";
  };
  CancelEvent2.prototype.getEventRunner = function() {
    return this.eventRegistration.getEventRunner(this);
  };
  CancelEvent2.prototype.toString = function() {
    return this.path.toString() + ":cancel";
  };
  return CancelEvent2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ValueEventRegistration = function() {
  function ValueEventRegistration2(callback_, cancelCallback_, context_) {
    this.callback_ = callback_;
    this.cancelCallback_ = cancelCallback_;
    this.context_ = context_;
  }
  ValueEventRegistration2.prototype.respondsTo = function(eventType) {
    return eventType === "value";
  };
  ValueEventRegistration2.prototype.createEvent = function(change, query2) {
    var index = query2.getQueryParams().getIndex();
    return new DataEvent("value", this, new DataSnapshot(change.snapshotNode, query2.getRef(), index));
  };
  ValueEventRegistration2.prototype.getEventRunner = function(eventData) {
    var ctx = this.context_;
    if (eventData.getEventType() === "cancel") {
      assert(this.cancelCallback_, "Raising a cancel event on a listener with no cancel callback");
      var cancelCB_1 = this.cancelCallback_;
      return function() {
        cancelCB_1.call(ctx, eventData.error);
      };
    } else {
      var cb_1 = this.callback_;
      return function() {
        cb_1.call(ctx, eventData.snapshot);
      };
    }
  };
  ValueEventRegistration2.prototype.createCancelEvent = function(error2, path) {
    if (this.cancelCallback_) {
      return new CancelEvent(this, error2, path);
    } else {
      return null;
    }
  };
  ValueEventRegistration2.prototype.matches = function(other) {
    if (!(other instanceof ValueEventRegistration2)) {
      return false;
    } else if (!other.callback_ || !this.callback_) {
      return true;
    } else {
      return other.callback_ === this.callback_ && other.context_ === this.context_;
    }
  };
  ValueEventRegistration2.prototype.hasAnyCallback = function() {
    return this.callback_ !== null;
  };
  return ValueEventRegistration2;
}();
var ChildEventRegistration = function() {
  function ChildEventRegistration2(callbacks_, cancelCallback_, context_) {
    this.callbacks_ = callbacks_;
    this.cancelCallback_ = cancelCallback_;
    this.context_ = context_;
  }
  ChildEventRegistration2.prototype.respondsTo = function(eventType) {
    var eventToCheck = eventType === "children_added" ? "child_added" : eventType;
    eventToCheck = eventToCheck === "children_removed" ? "child_removed" : eventToCheck;
    return contains(this.callbacks_, eventToCheck);
  };
  ChildEventRegistration2.prototype.createCancelEvent = function(error2, path) {
    if (this.cancelCallback_) {
      return new CancelEvent(this, error2, path);
    } else {
      return null;
    }
  };
  ChildEventRegistration2.prototype.createEvent = function(change, query2) {
    assert(change.childName != null, "Child events should have a childName.");
    var ref2 = query2.getRef().child(change.childName);
    var index = query2.getQueryParams().getIndex();
    return new DataEvent(change.type, this, new DataSnapshot(change.snapshotNode, ref2, index), change.prevName);
  };
  ChildEventRegistration2.prototype.getEventRunner = function(eventData) {
    var ctx = this.context_;
    if (eventData.getEventType() === "cancel") {
      assert(this.cancelCallback_, "Raising a cancel event on a listener with no cancel callback");
      var cancelCB_2 = this.cancelCallback_;
      return function() {
        cancelCB_2.call(ctx, eventData.error);
      };
    } else {
      var cb_2 = this.callbacks_[eventData.eventType];
      return function() {
        cb_2.call(ctx, eventData.snapshot, eventData.prevName);
      };
    }
  };
  ChildEventRegistration2.prototype.matches = function(other) {
    var _this = this;
    if (other instanceof ChildEventRegistration2) {
      if (!this.callbacks_ || !other.callbacks_) {
        return true;
      } else if (this.context_ === other.context_) {
        var otherKeys = Object.keys(other.callbacks_);
        var thisKeys = Object.keys(this.callbacks_);
        var otherCount = otherKeys.length;
        var thisCount = thisKeys.length;
        if (otherCount === thisCount) {
          if (otherCount === 1) {
            var otherKey = otherKeys[0];
            var thisKey = thisKeys[0];
            return thisKey === otherKey && (!other.callbacks_[otherKey] || !this.callbacks_[thisKey] || other.callbacks_[otherKey] === this.callbacks_[thisKey]);
          } else {
            return thisKeys.every(function(eventType) {
              return other.callbacks_[eventType] === _this.callbacks_[eventType];
            });
          }
        }
      }
    }
    return false;
  };
  ChildEventRegistration2.prototype.hasAnyCallback = function() {
    return this.callbacks_ !== null;
  };
  return ChildEventRegistration2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor;
var Query = function() {
  function Query2(repo, path, queryParams_, orderByCalled_) {
    this.repo = repo;
    this.path = path;
    this.queryParams_ = queryParams_;
    this.orderByCalled_ = orderByCalled_;
  }
  Object.defineProperty(Query2, "__referenceConstructor", {
    get: function() {
      assert(__referenceConstructor, "Reference.ts has not been loaded");
      return __referenceConstructor;
    },
    set: function(val) {
      __referenceConstructor = val;
    },
    enumerable: false,
    configurable: true
  });
  Query2.validateQueryEndpoints_ = function(params2) {
    var startNode = null;
    var endNode = null;
    if (params2.hasStart()) {
      startNode = params2.getIndexStartValue();
    }
    if (params2.hasEnd()) {
      endNode = params2.getIndexEndValue();
    }
    if (params2.getIndex() === KEY_INDEX) {
      var tooManyArgsError = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().";
      var wrongArgTypeError = "Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.";
      if (params2.hasStart()) {
        var startName = params2.getIndexStartName();
        if (startName !== MIN_NAME) {
          throw new Error(tooManyArgsError);
        } else if (typeof startNode !== "string") {
          throw new Error(wrongArgTypeError);
        }
      }
      if (params2.hasEnd()) {
        var endName = params2.getIndexEndName();
        if (endName !== MAX_NAME) {
          throw new Error(tooManyArgsError);
        } else if (typeof endNode !== "string") {
          throw new Error(wrongArgTypeError);
        }
      }
    } else if (params2.getIndex() === PRIORITY_INDEX) {
      if (startNode != null && !isValidPriority(startNode) || endNode != null && !isValidPriority(endNode)) {
        throw new Error("Query: When ordering by priority, the first argument passed to startAt(), endAt(), or equalTo() must be a valid priority value (null, a number, or a string).");
      }
    } else {
      assert(params2.getIndex() instanceof PathIndex || params2.getIndex() === VALUE_INDEX, "unknown index type.");
      if (startNode != null && typeof startNode === "object" || endNode != null && typeof endNode === "object") {
        throw new Error("Query: First argument passed to startAt(), endAt(), or equalTo() cannot be an object.");
      }
    }
  };
  Query2.validateLimit_ = function(params2) {
    if (params2.hasStart() && params2.hasEnd() && params2.hasLimit() && !params2.hasAnchoredLimit()) {
      throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
    }
  };
  Query2.prototype.validateNoPreviousOrderByCall_ = function(fnName) {
    if (this.orderByCalled_ === true) {
      throw new Error(fnName + ": You can't combine multiple orderBy calls.");
    }
  };
  Query2.prototype.getQueryParams = function() {
    return this.queryParams_;
  };
  Query2.prototype.getRef = function() {
    validateArgCount("Query.ref", 0, 0, arguments.length);
    return new Query2.__referenceConstructor(this.repo, this.path);
  };
  Query2.prototype.on = function(eventType, callback, cancelCallbackOrContext, context) {
    validateArgCount("Query.on", 2, 4, arguments.length);
    validateEventType("Query.on", 1, eventType, false);
    validateCallback("Query.on", 2, callback, false);
    var ret = Query2.getCancelAndContextArgs_("Query.on", cancelCallbackOrContext, context);
    if (eventType === "value") {
      this.onValueEvent(callback, ret.cancel, ret.context);
    } else {
      var callbacks = {};
      callbacks[eventType] = callback;
      this.onChildEvent(callbacks, ret.cancel, ret.context);
    }
    return callback;
  };
  Query2.prototype.onValueEvent = function(callback, cancelCallback, context) {
    var container = new ValueEventRegistration(callback, cancelCallback || null, context || null);
    this.repo.addEventCallbackForQuery(this, container);
  };
  Query2.prototype.onChildEvent = function(callbacks, cancelCallback, context) {
    var container = new ChildEventRegistration(callbacks, cancelCallback, context);
    this.repo.addEventCallbackForQuery(this, container);
  };
  Query2.prototype.off = function(eventType, callback, context) {
    validateArgCount("Query.off", 0, 3, arguments.length);
    validateEventType("Query.off", 1, eventType, true);
    validateCallback("Query.off", 2, callback, true);
    validateContextObject("Query.off", 3, context, true);
    var container = null;
    var callbacks = null;
    if (eventType === "value") {
      var valueCallback = callback || null;
      container = new ValueEventRegistration(valueCallback, null, context || null);
    } else if (eventType) {
      if (callback) {
        callbacks = {};
        callbacks[eventType] = callback;
      }
      container = new ChildEventRegistration(callbacks, null, context || null);
    }
    this.repo.removeEventCallbackForQuery(this, container);
  };
  Query2.prototype.get = function() {
    return this.repo.getValue(this);
  };
  Query2.prototype.once = function(eventType, userCallback, failureCallbackOrContext, context) {
    var _this = this;
    validateArgCount("Query.once", 1, 4, arguments.length);
    validateEventType("Query.once", 1, eventType, false);
    validateCallback("Query.once", 2, userCallback, true);
    var ret = Query2.getCancelAndContextArgs_("Query.once", failureCallbackOrContext, context);
    var firstCall = true;
    var deferred = new Deferred();
    deferred.promise.catch(function() {
    });
    var onceCallback = function(snapshot) {
      if (firstCall) {
        firstCall = false;
        _this.off(eventType, onceCallback);
        if (userCallback) {
          userCallback.bind(ret.context)(snapshot);
        }
        deferred.resolve(snapshot);
      }
    };
    this.on(eventType, onceCallback, function(err) {
      _this.off(eventType, onceCallback);
      if (ret.cancel) {
        ret.cancel.bind(ret.context)(err);
      }
      deferred.reject(err);
    });
    return deferred.promise;
  };
  Query2.prototype.limitToFirst = function(limit) {
    validateArgCount("Query.limitToFirst", 1, 1, arguments.length);
    if (typeof limit !== "number" || Math.floor(limit) !== limit || limit <= 0) {
      throw new Error("Query.limitToFirst: First argument must be a positive integer.");
    }
    if (this.queryParams_.hasLimit()) {
      throw new Error("Query.limitToFirst: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");
    }
    return new Query2(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
  };
  Query2.prototype.limitToLast = function(limit) {
    validateArgCount("Query.limitToLast", 1, 1, arguments.length);
    if (typeof limit !== "number" || Math.floor(limit) !== limit || limit <= 0) {
      throw new Error("Query.limitToLast: First argument must be a positive integer.");
    }
    if (this.queryParams_.hasLimit()) {
      throw new Error("Query.limitToLast: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");
    }
    return new Query2(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
  };
  Query2.prototype.orderByChild = function(path) {
    validateArgCount("Query.orderByChild", 1, 1, arguments.length);
    if (path === "$key") {
      throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
    } else if (path === "$priority") {
      throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
    } else if (path === "$value") {
      throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
    }
    validatePathString("Query.orderByChild", 1, path, false);
    this.validateNoPreviousOrderByCall_("Query.orderByChild");
    var parsedPath = new Path(path);
    if (parsedPath.isEmpty()) {
      throw new Error("Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.");
    }
    var index = new PathIndex(parsedPath);
    var newParams = this.queryParams_.orderBy(index);
    Query2.validateQueryEndpoints_(newParams);
    return new Query2(this.repo, this.path, newParams, true);
  };
  Query2.prototype.orderByKey = function() {
    validateArgCount("Query.orderByKey", 0, 0, arguments.length);
    this.validateNoPreviousOrderByCall_("Query.orderByKey");
    var newParams = this.queryParams_.orderBy(KEY_INDEX);
    Query2.validateQueryEndpoints_(newParams);
    return new Query2(this.repo, this.path, newParams, true);
  };
  Query2.prototype.orderByPriority = function() {
    validateArgCount("Query.orderByPriority", 0, 0, arguments.length);
    this.validateNoPreviousOrderByCall_("Query.orderByPriority");
    var newParams = this.queryParams_.orderBy(PRIORITY_INDEX);
    Query2.validateQueryEndpoints_(newParams);
    return new Query2(this.repo, this.path, newParams, true);
  };
  Query2.prototype.orderByValue = function() {
    validateArgCount("Query.orderByValue", 0, 0, arguments.length);
    this.validateNoPreviousOrderByCall_("Query.orderByValue");
    var newParams = this.queryParams_.orderBy(VALUE_INDEX);
    Query2.validateQueryEndpoints_(newParams);
    return new Query2(this.repo, this.path, newParams, true);
  };
  Query2.prototype.startAt = function(value, name2) {
    if (value === void 0) {
      value = null;
    }
    validateArgCount("Query.startAt", 0, 2, arguments.length);
    validateFirebaseDataArg("Query.startAt", 1, value, this.path, true);
    validateKey("Query.startAt", 2, name2, true);
    var newParams = this.queryParams_.startAt(value, name2);
    Query2.validateLimit_(newParams);
    Query2.validateQueryEndpoints_(newParams);
    if (this.queryParams_.hasStart()) {
      throw new Error("Query.startAt: Starting point was already set (by another call to startAt or equalTo).");
    }
    if (value === void 0) {
      value = null;
      name2 = null;
    }
    return new Query2(this.repo, this.path, newParams, this.orderByCalled_);
  };
  Query2.prototype.endAt = function(value, name2) {
    if (value === void 0) {
      value = null;
    }
    validateArgCount("Query.endAt", 0, 2, arguments.length);
    validateFirebaseDataArg("Query.endAt", 1, value, this.path, true);
    validateKey("Query.endAt", 2, name2, true);
    var newParams = this.queryParams_.endAt(value, name2);
    Query2.validateLimit_(newParams);
    Query2.validateQueryEndpoints_(newParams);
    if (this.queryParams_.hasEnd()) {
      throw new Error("Query.endAt: Ending point was already set (by another call to endAt or equalTo).");
    }
    return new Query2(this.repo, this.path, newParams, this.orderByCalled_);
  };
  Query2.prototype.equalTo = function(value, name2) {
    validateArgCount("Query.equalTo", 1, 2, arguments.length);
    validateFirebaseDataArg("Query.equalTo", 1, value, this.path, false);
    validateKey("Query.equalTo", 2, name2, true);
    if (this.queryParams_.hasStart()) {
      throw new Error("Query.equalTo: Starting point was already set (by another call to startAt or equalTo).");
    }
    if (this.queryParams_.hasEnd()) {
      throw new Error("Query.equalTo: Ending point was already set (by another call to endAt or equalTo).");
    }
    return this.startAt(value, name2).endAt(value, name2);
  };
  Query2.prototype.toString = function() {
    validateArgCount("Query.toString", 0, 0, arguments.length);
    return this.repo.toString() + this.path.toUrlEncodedString();
  };
  Query2.prototype.toJSON = function() {
    validateArgCount("Query.toJSON", 0, 1, arguments.length);
    return this.toString();
  };
  Query2.prototype.queryObject = function() {
    return this.queryParams_.getQueryObject();
  };
  Query2.prototype.queryIdentifier = function() {
    var obj = this.queryObject();
    var id2 = ObjectToUniqueKey(obj);
    return id2 === "{}" ? "default" : id2;
  };
  Query2.prototype.isEqual = function(other) {
    validateArgCount("Query.isEqual", 1, 1, arguments.length);
    if (!(other instanceof Query2)) {
      var error2 = "Query.isEqual failed: First argument must be an instance of firebase.database.Query.";
      throw new Error(error2);
    }
    var sameRepo = this.repo === other.repo;
    var samePath = this.path.equals(other.path);
    var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
    return sameRepo && samePath && sameQueryIdentifier;
  };
  Query2.getCancelAndContextArgs_ = function(fnName, cancelOrContext, context) {
    var ret = { cancel: null, context: null };
    if (cancelOrContext && context) {
      ret.cancel = cancelOrContext;
      validateCallback(fnName, 3, ret.cancel, true);
      ret.context = context;
      validateContextObject(fnName, 4, ret.context, true);
    } else if (cancelOrContext) {
      if (typeof cancelOrContext === "object" && cancelOrContext !== null) {
        ret.context = cancelOrContext;
      } else if (typeof cancelOrContext === "function") {
        ret.cancel = cancelOrContext;
      } else {
        throw new Error(errorPrefix(fnName, 3, true) + " must either be a cancel callback or a context object.");
      }
    }
    return ret;
  };
  Object.defineProperty(Query2.prototype, "ref", {
    get: function() {
      return this.getRef();
    },
    enumerable: false,
    configurable: true
  });
  return Query2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ExistingValueProvider = function() {
  function ExistingValueProvider2(node_) {
    this.node_ = node_;
  }
  ExistingValueProvider2.prototype.getImmediateChild = function(childName) {
    var child2 = this.node_.getImmediateChild(childName);
    return new ExistingValueProvider2(child2);
  };
  ExistingValueProvider2.prototype.node = function() {
    return this.node_;
  };
  return ExistingValueProvider2;
}();
var DeferredValueProvider = function() {
  function DeferredValueProvider2(syncTree, path) {
    this.syncTree_ = syncTree;
    this.path_ = path;
  }
  DeferredValueProvider2.prototype.getImmediateChild = function(childName) {
    var childPath = this.path_.child(childName);
    return new DeferredValueProvider2(this.syncTree_, childPath);
  };
  DeferredValueProvider2.prototype.node = function() {
    return this.syncTree_.calcCompleteEventCache(this.path_);
  };
  return DeferredValueProvider2;
}();
var generateWithValues = function(values) {
  values = values || {};
  values["timestamp"] = values["timestamp"] || new Date().getTime();
  return values;
};
var resolveDeferredLeafValue = function(value, existingVal, serverValues) {
  if (!value || typeof value !== "object") {
    return value;
  }
  assert(".sv" in value, "Unexpected leaf node or priority contents");
  if (typeof value[".sv"] === "string") {
    return resolveScalarDeferredValue(value[".sv"], existingVal, serverValues);
  } else if (typeof value[".sv"] === "object") {
    return resolveComplexDeferredValue(value[".sv"], existingVal);
  } else {
    assert(false, "Unexpected server value: " + JSON.stringify(value, null, 2));
  }
};
var resolveScalarDeferredValue = function(op2, existing, serverValues) {
  switch (op2) {
    case "timestamp":
      return serverValues["timestamp"];
    default:
      assert(false, "Unexpected server value: " + op2);
  }
};
var resolveComplexDeferredValue = function(op2, existing, unused) {
  if (!op2.hasOwnProperty("increment")) {
    assert(false, "Unexpected server value: " + JSON.stringify(op2, null, 2));
  }
  var delta = op2["increment"];
  if (typeof delta !== "number") {
    assert(false, "Unexpected increment value: " + delta);
  }
  var existingNode = existing.node();
  assert(existingNode !== null && typeof existingNode !== "undefined", "Expected ChildrenNode.EMPTY_NODE for nulls");
  if (!existingNode.isLeafNode()) {
    return delta;
  }
  var leaf = existingNode;
  var existingVal = leaf.getValue();
  if (typeof existingVal !== "number") {
    return delta;
  }
  return existingVal + delta;
};
var resolveDeferredValueTree = function(path, node, syncTree, serverValues) {
  return resolveDeferredValue(node, new DeferredValueProvider(syncTree, path), serverValues);
};
var resolveDeferredValueSnapshot = function(node, existing, serverValues) {
  return resolveDeferredValue(node, new ExistingValueProvider(existing), serverValues);
};
function resolveDeferredValue(node, existingVal, serverValues) {
  var rawPri = node.getPriority().val();
  var priority = resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild(".priority"), serverValues);
  var newNode;
  if (node.isLeafNode()) {
    var leafNode = node;
    var value = resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
    if (value !== leafNode.getValue() || priority !== leafNode.getPriority().val()) {
      return new LeafNode(value, nodeFromJSON$1(priority));
    } else {
      return node;
    }
  } else {
    var childrenNode = node;
    newNode = childrenNode;
    if (priority !== childrenNode.getPriority().val()) {
      newNode = newNode.updatePriority(new LeafNode(priority));
    }
    childrenNode.forEachChild(PRIORITY_INDEX, function(childName, childNode) {
      var newChildNode = resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
      if (newChildNode !== childNode) {
        newNode = newNode.updateImmediateChild(childName, newChildNode);
      }
    });
    return newNode;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SparseSnapshotTree = function() {
  function SparseSnapshotTree2() {
    this.value = null;
    this.children = new Map();
  }
  SparseSnapshotTree2.prototype.find = function(path) {
    if (this.value != null) {
      return this.value.getChild(path);
    } else if (!path.isEmpty() && this.children.size > 0) {
      var childKey = path.getFront();
      path = path.popFront();
      if (this.children.has(childKey)) {
        var childTree = this.children.get(childKey);
        return childTree.find(path);
      } else {
        return null;
      }
    } else {
      return null;
    }
  };
  SparseSnapshotTree2.prototype.remember = function(path, data) {
    if (path.isEmpty()) {
      this.value = data;
      this.children.clear();
    } else if (this.value !== null) {
      this.value = this.value.updateChild(path, data);
    } else {
      var childKey = path.getFront();
      if (!this.children.has(childKey)) {
        this.children.set(childKey, new SparseSnapshotTree2());
      }
      var child2 = this.children.get(childKey);
      path = path.popFront();
      child2.remember(path, data);
    }
  };
  SparseSnapshotTree2.prototype.forget = function(path) {
    if (path.isEmpty()) {
      this.value = null;
      this.children.clear();
      return true;
    } else {
      if (this.value !== null) {
        if (this.value.isLeafNode()) {
          return false;
        } else {
          var value = this.value;
          this.value = null;
          var self_1 = this;
          value.forEachChild(PRIORITY_INDEX, function(key, tree) {
            self_1.remember(new Path(key), tree);
          });
          return this.forget(path);
        }
      } else if (this.children.size > 0) {
        var childKey = path.getFront();
        path = path.popFront();
        if (this.children.has(childKey)) {
          var safeToRemove = this.children.get(childKey).forget(path);
          if (safeToRemove) {
            this.children.delete(childKey);
          }
        }
        return this.children.size === 0;
      } else {
        return true;
      }
    }
  };
  SparseSnapshotTree2.prototype.forEachTree = function(prefixPath, func) {
    if (this.value !== null) {
      func(prefixPath, this.value);
    } else {
      this.forEachChild(function(key, tree) {
        var path = new Path(prefixPath.toString() + "/" + key);
        tree.forEachTree(path, func);
      });
    }
  };
  SparseSnapshotTree2.prototype.forEachChild = function(func) {
    this.children.forEach(function(tree, key) {
      func(key, tree);
    });
  };
  return SparseSnapshotTree2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OperationType;
(function(OperationType2) {
  OperationType2[OperationType2["OVERWRITE"] = 0] = "OVERWRITE";
  OperationType2[OperationType2["MERGE"] = 1] = "MERGE";
  OperationType2[OperationType2["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
  OperationType2[OperationType2["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})(OperationType || (OperationType = {}));
var OperationSource = function() {
  function OperationSource2(fromUser, fromServer, queryId, tagged) {
    this.fromUser = fromUser;
    this.fromServer = fromServer;
    this.queryId = queryId;
    this.tagged = tagged;
    assert(!tagged || fromServer, "Tagged queries must be from server.");
  }
  OperationSource2.User = new OperationSource2(true, false, null, false);
  OperationSource2.Server = new OperationSource2(false, true, null, false);
  OperationSource2.forServerTaggedQuery = function(queryId) {
    return new OperationSource2(false, true, queryId, true);
  };
  return OperationSource2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AckUserWrite = function() {
  function AckUserWrite2(path, affectedTree, revert) {
    this.path = path;
    this.affectedTree = affectedTree;
    this.revert = revert;
    this.type = OperationType.ACK_USER_WRITE;
    this.source = OperationSource.User;
  }
  AckUserWrite2.prototype.operationForChild = function(childName) {
    if (!this.path.isEmpty()) {
      assert(this.path.getFront() === childName, "operationForChild called for unrelated child.");
      return new AckUserWrite2(this.path.popFront(), this.affectedTree, this.revert);
    } else if (this.affectedTree.value != null) {
      assert(this.affectedTree.children.isEmpty(), "affectedTree should not have overlapping affected paths.");
      return this;
    } else {
      var childTree = this.affectedTree.subtree(new Path(childName));
      return new AckUserWrite2(Path.Empty, childTree, this.revert);
    }
  };
  return AckUserWrite2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var emptyChildrenSingleton;
var EmptyChildren = function() {
  if (!emptyChildrenSingleton) {
    emptyChildrenSingleton = new SortedMap(stringCompare);
  }
  return emptyChildrenSingleton;
};
var ImmutableTree = function() {
  function ImmutableTree2(value, children) {
    if (children === void 0) {
      children = EmptyChildren();
    }
    this.value = value;
    this.children = children;
  }
  ImmutableTree2.fromObject = function(obj) {
    var tree = ImmutableTree2.Empty;
    each(obj, function(childPath, childSnap) {
      tree = tree.set(new Path(childPath), childSnap);
    });
    return tree;
  };
  ImmutableTree2.prototype.isEmpty = function() {
    return this.value === null && this.children.isEmpty();
  };
  ImmutableTree2.prototype.findRootMostMatchingPathAndValue = function(relativePath, predicate) {
    if (this.value != null && predicate(this.value)) {
      return { path: Path.Empty, value: this.value };
    } else {
      if (relativePath.isEmpty()) {
        return null;
      } else {
        var front = relativePath.getFront();
        var child2 = this.children.get(front);
        if (child2 !== null) {
          var childExistingPathAndValue = child2.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
          if (childExistingPathAndValue != null) {
            var fullPath = new Path(front).child(childExistingPathAndValue.path);
            return { path: fullPath, value: childExistingPathAndValue.value };
          } else {
            return null;
          }
        } else {
          return null;
        }
      }
    }
  };
  ImmutableTree2.prototype.findRootMostValueAndPath = function(relativePath) {
    return this.findRootMostMatchingPathAndValue(relativePath, function() {
      return true;
    });
  };
  ImmutableTree2.prototype.subtree = function(relativePath) {
    if (relativePath.isEmpty()) {
      return this;
    } else {
      var front = relativePath.getFront();
      var childTree = this.children.get(front);
      if (childTree !== null) {
        return childTree.subtree(relativePath.popFront());
      } else {
        return ImmutableTree2.Empty;
      }
    }
  };
  ImmutableTree2.prototype.set = function(relativePath, toSet) {
    if (relativePath.isEmpty()) {
      return new ImmutableTree2(toSet, this.children);
    } else {
      var front = relativePath.getFront();
      var child2 = this.children.get(front) || ImmutableTree2.Empty;
      var newChild = child2.set(relativePath.popFront(), toSet);
      var newChildren = this.children.insert(front, newChild);
      return new ImmutableTree2(this.value, newChildren);
    }
  };
  ImmutableTree2.prototype.remove = function(relativePath) {
    if (relativePath.isEmpty()) {
      if (this.children.isEmpty()) {
        return ImmutableTree2.Empty;
      } else {
        return new ImmutableTree2(null, this.children);
      }
    } else {
      var front = relativePath.getFront();
      var child2 = this.children.get(front);
      if (child2) {
        var newChild = child2.remove(relativePath.popFront());
        var newChildren = void 0;
        if (newChild.isEmpty()) {
          newChildren = this.children.remove(front);
        } else {
          newChildren = this.children.insert(front, newChild);
        }
        if (this.value === null && newChildren.isEmpty()) {
          return ImmutableTree2.Empty;
        } else {
          return new ImmutableTree2(this.value, newChildren);
        }
      } else {
        return this;
      }
    }
  };
  ImmutableTree2.prototype.get = function(relativePath) {
    if (relativePath.isEmpty()) {
      return this.value;
    } else {
      var front = relativePath.getFront();
      var child2 = this.children.get(front);
      if (child2) {
        return child2.get(relativePath.popFront());
      } else {
        return null;
      }
    }
  };
  ImmutableTree2.prototype.setTree = function(relativePath, newTree) {
    if (relativePath.isEmpty()) {
      return newTree;
    } else {
      var front = relativePath.getFront();
      var child2 = this.children.get(front) || ImmutableTree2.Empty;
      var newChild = child2.setTree(relativePath.popFront(), newTree);
      var newChildren = void 0;
      if (newChild.isEmpty()) {
        newChildren = this.children.remove(front);
      } else {
        newChildren = this.children.insert(front, newChild);
      }
      return new ImmutableTree2(this.value, newChildren);
    }
  };
  ImmutableTree2.prototype.fold = function(fn2) {
    return this.fold_(Path.Empty, fn2);
  };
  ImmutableTree2.prototype.fold_ = function(pathSoFar, fn2) {
    var accum = {};
    this.children.inorderTraversal(function(childKey, childTree) {
      accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn2);
    });
    return fn2(pathSoFar, this.value, accum);
  };
  ImmutableTree2.prototype.findOnPath = function(path, f3) {
    return this.findOnPath_(path, Path.Empty, f3);
  };
  ImmutableTree2.prototype.findOnPath_ = function(pathToFollow, pathSoFar, f3) {
    var result2 = this.value ? f3(pathSoFar, this.value) : false;
    if (result2) {
      return result2;
    } else {
      if (pathToFollow.isEmpty()) {
        return null;
      } else {
        var front = pathToFollow.getFront();
        var nextChild = this.children.get(front);
        if (nextChild) {
          return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f3);
        } else {
          return null;
        }
      }
    }
  };
  ImmutableTree2.prototype.foreachOnPath = function(path, f3) {
    return this.foreachOnPath_(path, Path.Empty, f3);
  };
  ImmutableTree2.prototype.foreachOnPath_ = function(pathToFollow, currentRelativePath, f3) {
    if (pathToFollow.isEmpty()) {
      return this;
    } else {
      if (this.value) {
        f3(currentRelativePath, this.value);
      }
      var front = pathToFollow.getFront();
      var nextChild = this.children.get(front);
      if (nextChild) {
        return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f3);
      } else {
        return ImmutableTree2.Empty;
      }
    }
  };
  ImmutableTree2.prototype.foreach = function(f3) {
    this.foreach_(Path.Empty, f3);
  };
  ImmutableTree2.prototype.foreach_ = function(currentRelativePath, f3) {
    this.children.inorderTraversal(function(childName, childTree) {
      childTree.foreach_(currentRelativePath.child(childName), f3);
    });
    if (this.value) {
      f3(currentRelativePath, this.value);
    }
  };
  ImmutableTree2.prototype.foreachChild = function(f3) {
    this.children.inorderTraversal(function(childName, childTree) {
      if (childTree.value) {
        f3(childName, childTree.value);
      }
    });
  };
  ImmutableTree2.Empty = new ImmutableTree2(null);
  return ImmutableTree2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ListenComplete = function() {
  function ListenComplete2(source, path) {
    this.source = source;
    this.path = path;
    this.type = OperationType.LISTEN_COMPLETE;
  }
  ListenComplete2.prototype.operationForChild = function(childName) {
    if (this.path.isEmpty()) {
      return new ListenComplete2(this.source, Path.Empty);
    } else {
      return new ListenComplete2(this.source, this.path.popFront());
    }
  };
  return ListenComplete2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Overwrite = function() {
  function Overwrite2(source, path, snap) {
    this.source = source;
    this.path = path;
    this.snap = snap;
    this.type = OperationType.OVERWRITE;
  }
  Overwrite2.prototype.operationForChild = function(childName) {
    if (this.path.isEmpty()) {
      return new Overwrite2(this.source, Path.Empty, this.snap.getImmediateChild(childName));
    } else {
      return new Overwrite2(this.source, this.path.popFront(), this.snap);
    }
  };
  return Overwrite2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Merge = function() {
  function Merge2(source, path, children) {
    this.source = source;
    this.path = path;
    this.children = children;
    this.type = OperationType.MERGE;
  }
  Merge2.prototype.operationForChild = function(childName) {
    if (this.path.isEmpty()) {
      var childTree = this.children.subtree(new Path(childName));
      if (childTree.isEmpty()) {
        return null;
      } else if (childTree.value) {
        return new Overwrite(this.source, Path.Empty, childTree.value);
      } else {
        return new Merge2(this.source, Path.Empty, childTree);
      }
    } else {
      assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
      return new Merge2(this.source, this.path.popFront(), this.children);
    }
  };
  Merge2.prototype.toString = function() {
    return "Operation(" + this.path + ": " + this.source.toString() + " merge: " + this.children.toString() + ")";
  };
  return Merge2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var CacheNode = function() {
  function CacheNode2(node_, fullyInitialized_, filtered_) {
    this.node_ = node_;
    this.fullyInitialized_ = fullyInitialized_;
    this.filtered_ = filtered_;
  }
  CacheNode2.prototype.isFullyInitialized = function() {
    return this.fullyInitialized_;
  };
  CacheNode2.prototype.isFiltered = function() {
    return this.filtered_;
  };
  CacheNode2.prototype.isCompleteForPath = function(path) {
    if (path.isEmpty()) {
      return this.isFullyInitialized() && !this.filtered_;
    }
    var childKey = path.getFront();
    return this.isCompleteForChild(childKey);
  };
  CacheNode2.prototype.isCompleteForChild = function(key) {
    return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(key);
  };
  CacheNode2.prototype.getNode = function() {
    return this.node_;
  };
  return CacheNode2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ViewCache = function() {
  function ViewCache2(eventCache_, serverCache_) {
    this.eventCache_ = eventCache_;
    this.serverCache_ = serverCache_;
  }
  ViewCache2.prototype.updateEventSnap = function(eventSnap, complete, filtered) {
    return new ViewCache2(new CacheNode(eventSnap, complete, filtered), this.serverCache_);
  };
  ViewCache2.prototype.updateServerSnap = function(serverSnap, complete, filtered) {
    return new ViewCache2(this.eventCache_, new CacheNode(serverSnap, complete, filtered));
  };
  ViewCache2.prototype.getEventCache = function() {
    return this.eventCache_;
  };
  ViewCache2.prototype.getCompleteEventSnap = function() {
    return this.eventCache_.isFullyInitialized() ? this.eventCache_.getNode() : null;
  };
  ViewCache2.prototype.getServerCache = function() {
    return this.serverCache_;
  };
  ViewCache2.prototype.getCompleteServerSnap = function() {
    return this.serverCache_.isFullyInitialized() ? this.serverCache_.getNode() : null;
  };
  ViewCache2.Empty = new ViewCache2(new CacheNode(ChildrenNode.EMPTY_NODE, false, false), new CacheNode(ChildrenNode.EMPTY_NODE, false, false));
  return ViewCache2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Change = function() {
  function Change2(type, snapshotNode, childName, oldSnap, prevName) {
    this.type = type;
    this.snapshotNode = snapshotNode;
    this.childName = childName;
    this.oldSnap = oldSnap;
    this.prevName = prevName;
  }
  Change2.valueChange = function(snapshot) {
    return new Change2(Change2.VALUE, snapshot);
  };
  Change2.childAddedChange = function(childKey, snapshot) {
    return new Change2(Change2.CHILD_ADDED, snapshot, childKey);
  };
  Change2.childRemovedChange = function(childKey, snapshot) {
    return new Change2(Change2.CHILD_REMOVED, snapshot, childKey);
  };
  Change2.childChangedChange = function(childKey, newSnapshot, oldSnapshot) {
    return new Change2(Change2.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
  };
  Change2.childMovedChange = function(childKey, snapshot) {
    return new Change2(Change2.CHILD_MOVED, snapshot, childKey);
  };
  Change2.CHILD_ADDED = "child_added";
  Change2.CHILD_REMOVED = "child_removed";
  Change2.CHILD_CHANGED = "child_changed";
  Change2.CHILD_MOVED = "child_moved";
  Change2.VALUE = "value";
  return Change2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var IndexedFilter = function() {
  function IndexedFilter2(index_) {
    this.index_ = index_;
  }
  IndexedFilter2.prototype.updateChild = function(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
    assert(snap.isIndexed(this.index_), "A node must be indexed if only a child is updated");
    var oldChild = snap.getImmediateChild(key);
    if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
      if (oldChild.isEmpty() === newChild.isEmpty()) {
        return snap;
      }
    }
    if (optChangeAccumulator != null) {
      if (newChild.isEmpty()) {
        if (snap.hasChild(key)) {
          optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, oldChild));
        } else {
          assert(snap.isLeafNode(), "A child remove without an old child only makes sense on a leaf node");
        }
      } else if (oldChild.isEmpty()) {
        optChangeAccumulator.trackChildChange(Change.childAddedChange(key, newChild));
      } else {
        optChangeAccumulator.trackChildChange(Change.childChangedChange(key, newChild, oldChild));
      }
    }
    if (snap.isLeafNode() && newChild.isEmpty()) {
      return snap;
    } else {
      return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
    }
  };
  IndexedFilter2.prototype.updateFullNode = function(oldSnap, newSnap, optChangeAccumulator) {
    if (optChangeAccumulator != null) {
      if (!oldSnap.isLeafNode()) {
        oldSnap.forEachChild(PRIORITY_INDEX, function(key, childNode) {
          if (!newSnap.hasChild(key)) {
            optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, childNode));
          }
        });
      }
      if (!newSnap.isLeafNode()) {
        newSnap.forEachChild(PRIORITY_INDEX, function(key, childNode) {
          if (oldSnap.hasChild(key)) {
            var oldChild = oldSnap.getImmediateChild(key);
            if (!oldChild.equals(childNode)) {
              optChangeAccumulator.trackChildChange(Change.childChangedChange(key, childNode, oldChild));
            }
          } else {
            optChangeAccumulator.trackChildChange(Change.childAddedChange(key, childNode));
          }
        });
      }
    }
    return newSnap.withIndex(this.index_);
  };
  IndexedFilter2.prototype.updatePriority = function(oldSnap, newPriority) {
    if (oldSnap.isEmpty()) {
      return ChildrenNode.EMPTY_NODE;
    } else {
      return oldSnap.updatePriority(newPriority);
    }
  };
  IndexedFilter2.prototype.filtersNodes = function() {
    return false;
  };
  IndexedFilter2.prototype.getIndexedFilter = function() {
    return this;
  };
  IndexedFilter2.prototype.getIndex = function() {
    return this.index_;
  };
  return IndexedFilter2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ChildChangeAccumulator = function() {
  function ChildChangeAccumulator2() {
    this.changeMap = new Map();
  }
  ChildChangeAccumulator2.prototype.trackChildChange = function(change) {
    var type = change.type;
    var childKey = change.childName;
    assert(type === Change.CHILD_ADDED || type === Change.CHILD_CHANGED || type === Change.CHILD_REMOVED, "Only child changes supported for tracking");
    assert(childKey !== ".priority", "Only non-priority child changes can be tracked.");
    var oldChange = this.changeMap.get(childKey);
    if (oldChange) {
      var oldType = oldChange.type;
      if (type === Change.CHILD_ADDED && oldType === Change.CHILD_REMOVED) {
        this.changeMap.set(childKey, Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode));
      } else if (type === Change.CHILD_REMOVED && oldType === Change.CHILD_ADDED) {
        this.changeMap.delete(childKey);
      } else if (type === Change.CHILD_REMOVED && oldType === Change.CHILD_CHANGED) {
        this.changeMap.set(childKey, Change.childRemovedChange(childKey, oldChange.oldSnap));
      } else if (type === Change.CHILD_CHANGED && oldType === Change.CHILD_ADDED) {
        this.changeMap.set(childKey, Change.childAddedChange(childKey, change.snapshotNode));
      } else if (type === Change.CHILD_CHANGED && oldType === Change.CHILD_CHANGED) {
        this.changeMap.set(childKey, Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap));
      } else {
        throw assertionError("Illegal combination of changes: " + change + " occurred after " + oldChange);
      }
    } else {
      this.changeMap.set(childKey, change);
    }
  };
  ChildChangeAccumulator2.prototype.getChanges = function() {
    return Array.from(this.changeMap.values());
  };
  return ChildChangeAccumulator2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var NoCompleteChildSource_ = function() {
  function NoCompleteChildSource_2() {
  }
  NoCompleteChildSource_2.prototype.getCompleteChild = function(childKey) {
    return null;
  };
  NoCompleteChildSource_2.prototype.getChildAfterChild = function(index, child2, reverse) {
    return null;
  };
  return NoCompleteChildSource_2;
}();
var NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
var WriteTreeCompleteChildSource = function() {
  function WriteTreeCompleteChildSource2(writes_, viewCache_, optCompleteServerCache_) {
    if (optCompleteServerCache_ === void 0) {
      optCompleteServerCache_ = null;
    }
    this.writes_ = writes_;
    this.viewCache_ = viewCache_;
    this.optCompleteServerCache_ = optCompleteServerCache_;
  }
  WriteTreeCompleteChildSource2.prototype.getCompleteChild = function(childKey) {
    var node = this.viewCache_.getEventCache();
    if (node.isCompleteForChild(childKey)) {
      return node.getNode().getImmediateChild(childKey);
    } else {
      var serverNode = this.optCompleteServerCache_ != null ? new CacheNode(this.optCompleteServerCache_, true, false) : this.viewCache_.getServerCache();
      return this.writes_.calcCompleteChild(childKey, serverNode);
    }
  };
  WriteTreeCompleteChildSource2.prototype.getChildAfterChild = function(index, child2, reverse) {
    var completeServerData = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : this.viewCache_.getCompleteServerSnap();
    var nodes = this.writes_.calcIndexedSlice(completeServerData, child2, 1, reverse, index);
    if (nodes.length === 0) {
      return null;
    } else {
      return nodes[0];
    }
  };
  return WriteTreeCompleteChildSource2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ProcessorResult = function() {
  function ProcessorResult2(viewCache, changes) {
    this.viewCache = viewCache;
    this.changes = changes;
  }
  return ProcessorResult2;
}();
var ViewProcessor = function() {
  function ViewProcessor2(filter_) {
    this.filter_ = filter_;
  }
  ViewProcessor2.prototype.assertIndexed = function(viewCache) {
    assert(viewCache.getEventCache().getNode().isIndexed(this.filter_.getIndex()), "Event snap not indexed");
    assert(viewCache.getServerCache().getNode().isIndexed(this.filter_.getIndex()), "Server snap not indexed");
  };
  ViewProcessor2.prototype.applyOperation = function(oldViewCache, operation, writesCache, completeCache) {
    var accumulator = new ChildChangeAccumulator();
    var newViewCache, filterServerNode;
    if (operation.type === OperationType.OVERWRITE) {
      var overwrite = operation;
      if (overwrite.source.fromUser) {
        newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
      } else {
        assert(overwrite.source.fromServer, "Unknown source.");
        filterServerNode = overwrite.source.tagged || oldViewCache.getServerCache().isFiltered() && !overwrite.path.isEmpty();
        newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
      }
    } else if (operation.type === OperationType.MERGE) {
      var merge2 = operation;
      if (merge2.source.fromUser) {
        newViewCache = this.applyUserMerge_(oldViewCache, merge2.path, merge2.children, writesCache, completeCache, accumulator);
      } else {
        assert(merge2.source.fromServer, "Unknown source.");
        filterServerNode = merge2.source.tagged || oldViewCache.getServerCache().isFiltered();
        newViewCache = this.applyServerMerge_(oldViewCache, merge2.path, merge2.children, writesCache, completeCache, filterServerNode, accumulator);
      }
    } else if (operation.type === OperationType.ACK_USER_WRITE) {
      var ackUserWrite = operation;
      if (!ackUserWrite.revert) {
        newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
      } else {
        newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
      }
    } else if (operation.type === OperationType.LISTEN_COMPLETE) {
      newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
    } else {
      throw assertionError("Unknown operation type: " + operation.type);
    }
    var changes = accumulator.getChanges();
    ViewProcessor2.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
    return new ProcessorResult(newViewCache, changes);
  };
  ViewProcessor2.maybeAddValueEvent_ = function(oldViewCache, newViewCache, accumulator) {
    var eventSnap = newViewCache.getEventCache();
    if (eventSnap.isFullyInitialized()) {
      var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
      var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
      if (accumulator.length > 0 || !oldViewCache.getEventCache().isFullyInitialized() || isLeafOrEmpty && !eventSnap.getNode().equals(oldCompleteSnap) || !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) {
        accumulator.push(Change.valueChange(newViewCache.getCompleteEventSnap()));
      }
    }
  };
  ViewProcessor2.prototype.generateEventCacheAfterServerEvent_ = function(viewCache, changePath, writesCache, source, accumulator) {
    var oldEventSnap = viewCache.getEventCache();
    if (writesCache.shadowingWrite(changePath) != null) {
      return viewCache;
    } else {
      var newEventCache = void 0, serverNode = void 0;
      if (changePath.isEmpty()) {
        assert(viewCache.getServerCache().isFullyInitialized(), "If change path is empty, we must have complete server data");
        if (viewCache.getServerCache().isFiltered()) {
          var serverCache = viewCache.getCompleteServerSnap();
          var completeChildren = serverCache instanceof ChildrenNode ? serverCache : ChildrenNode.EMPTY_NODE;
          var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
          newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
        } else {
          var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
          newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
        }
      } else {
        var childKey = changePath.getFront();
        if (childKey === ".priority") {
          assert(changePath.getLength() === 1, "Can't have a priority with additional path components");
          var oldEventNode = oldEventSnap.getNode();
          serverNode = viewCache.getServerCache().getNode();
          var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
          if (updatedPriority != null) {
            newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
          } else {
            newEventCache = oldEventSnap.getNode();
          }
        } else {
          var childChangePath = changePath.popFront();
          var newEventChild = void 0;
          if (oldEventSnap.isCompleteForChild(childKey)) {
            serverNode = viewCache.getServerCache().getNode();
            var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
            if (eventChildUpdate != null) {
              newEventChild = oldEventSnap.getNode().getImmediateChild(childKey).updateChild(childChangePath, eventChildUpdate);
            } else {
              newEventChild = oldEventSnap.getNode().getImmediateChild(childKey);
            }
          } else {
            newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
          }
          if (newEventChild != null) {
            newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
          } else {
            newEventCache = oldEventSnap.getNode();
          }
        }
      }
      return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
    }
  };
  ViewProcessor2.prototype.applyServerOverwrite_ = function(oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
    var oldServerSnap = oldViewCache.getServerCache();
    var newServerCache;
    var serverFilter = filterServerNode ? this.filter_ : this.filter_.getIndexedFilter();
    if (changePath.isEmpty()) {
      newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
    } else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
      var newServerNode = oldServerSnap.getNode().updateChild(changePath, changedSnap);
      newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
    } else {
      var childKey = changePath.getFront();
      if (!oldServerSnap.isCompleteForPath(changePath) && changePath.getLength() > 1) {
        return oldViewCache;
      }
      var childChangePath = changePath.popFront();
      var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
      var newChildNode = childNode.updateChild(childChangePath, changedSnap);
      if (childKey === ".priority") {
        newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
      } else {
        newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, NO_COMPLETE_CHILD_SOURCE, null);
      }
    }
    var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
    var source = new WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
    return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
  };
  ViewProcessor2.prototype.applyUserOverwrite_ = function(oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
    var oldEventSnap = oldViewCache.getEventCache();
    var newViewCache, newEventCache;
    var source = new WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
    if (changePath.isEmpty()) {
      newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
      newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
    } else {
      var childKey = changePath.getFront();
      if (childKey === ".priority") {
        newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
        newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
      } else {
        var childChangePath = changePath.popFront();
        var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
        var newChild = void 0;
        if (childChangePath.isEmpty()) {
          newChild = changedSnap;
        } else {
          var childNode = source.getCompleteChild(childKey);
          if (childNode != null) {
            if (childChangePath.getBack() === ".priority" && childNode.getChild(childChangePath.parent()).isEmpty()) {
              newChild = childNode;
            } else {
              newChild = childNode.updateChild(childChangePath, changedSnap);
            }
          } else {
            newChild = ChildrenNode.EMPTY_NODE;
          }
        }
        if (!oldChild.equals(newChild)) {
          var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
          newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
        } else {
          newViewCache = oldViewCache;
        }
      }
    }
    return newViewCache;
  };
  ViewProcessor2.cacheHasChild_ = function(viewCache, childKey) {
    return viewCache.getEventCache().isCompleteForChild(childKey);
  };
  ViewProcessor2.prototype.applyUserMerge_ = function(viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
    var _this = this;
    var curViewCache = viewCache;
    changedChildren.foreach(function(relativePath, childNode) {
      var writePath = path.child(relativePath);
      if (ViewProcessor2.cacheHasChild_(viewCache, writePath.getFront())) {
        curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
      }
    });
    changedChildren.foreach(function(relativePath, childNode) {
      var writePath = path.child(relativePath);
      if (!ViewProcessor2.cacheHasChild_(viewCache, writePath.getFront())) {
        curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
      }
    });
    return curViewCache;
  };
  ViewProcessor2.prototype.applyMerge_ = function(node, merge2) {
    merge2.foreach(function(relativePath, childNode) {
      node = node.updateChild(relativePath, childNode);
    });
    return node;
  };
  ViewProcessor2.prototype.applyServerMerge_ = function(viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
    var _this = this;
    if (viewCache.getServerCache().getNode().isEmpty() && !viewCache.getServerCache().isFullyInitialized()) {
      return viewCache;
    }
    var curViewCache = viewCache;
    var viewMergeTree;
    if (path.isEmpty()) {
      viewMergeTree = changedChildren;
    } else {
      viewMergeTree = ImmutableTree.Empty.setTree(path, changedChildren);
    }
    var serverNode = viewCache.getServerCache().getNode();
    viewMergeTree.children.inorderTraversal(function(childKey, childTree) {
      if (serverNode.hasChild(childKey)) {
        var serverChild = viewCache.getServerCache().getNode().getImmediateChild(childKey);
        var newChild = _this.applyMerge_(serverChild, childTree);
        curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
      }
    });
    viewMergeTree.children.inorderTraversal(function(childKey, childMergeTree) {
      var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) && childMergeTree.value == null;
      if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
        var serverChild = viewCache.getServerCache().getNode().getImmediateChild(childKey);
        var newChild = _this.applyMerge_(serverChild, childMergeTree);
        curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
      }
    });
    return curViewCache;
  };
  ViewProcessor2.prototype.ackUserWrite_ = function(viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
    if (writesCache.shadowingWrite(ackPath) != null) {
      return viewCache;
    }
    var filterServerNode = viewCache.getServerCache().isFiltered();
    var serverCache = viewCache.getServerCache();
    if (affectedTree.value != null) {
      if (ackPath.isEmpty() && serverCache.isFullyInitialized() || serverCache.isCompleteForPath(ackPath)) {
        return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
      } else if (ackPath.isEmpty()) {
        var changedChildren_1 = ImmutableTree.Empty;
        serverCache.getNode().forEachChild(KEY_INDEX, function(name2, node) {
          changedChildren_1 = changedChildren_1.set(new Path(name2), node);
        });
        return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
      } else {
        return viewCache;
      }
    } else {
      var changedChildren_2 = ImmutableTree.Empty;
      affectedTree.foreach(function(mergePath, value) {
        var serverCachePath = ackPath.child(mergePath);
        if (serverCache.isCompleteForPath(serverCachePath)) {
          changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
        }
      });
      return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
    }
  };
  ViewProcessor2.prototype.listenComplete_ = function(viewCache, path, writesCache, accumulator) {
    var oldServerNode = viewCache.getServerCache();
    var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
    return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, NO_COMPLETE_CHILD_SOURCE, accumulator);
  };
  ViewProcessor2.prototype.revertUserWrite_ = function(viewCache, path, writesCache, completeServerCache, accumulator) {
    var complete;
    if (writesCache.shadowingWrite(path) != null) {
      return viewCache;
    } else {
      var source = new WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
      var oldEventCache = viewCache.getEventCache().getNode();
      var newEventCache = void 0;
      if (path.isEmpty() || path.getFront() === ".priority") {
        var newNode = void 0;
        if (viewCache.getServerCache().isFullyInitialized()) {
          newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
        } else {
          var serverChildren = viewCache.getServerCache().getNode();
          assert(serverChildren instanceof ChildrenNode, "serverChildren would be complete if leaf node");
          newNode = writesCache.calcCompleteEventChildren(serverChildren);
        }
        newNode = newNode;
        newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
      } else {
        var childKey = path.getFront();
        var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
        if (newChild == null && viewCache.getServerCache().isCompleteForChild(childKey)) {
          newChild = oldEventCache.getImmediateChild(childKey);
        }
        if (newChild != null) {
          newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
        } else if (viewCache.getEventCache().getNode().hasChild(childKey)) {
          newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
        } else {
          newEventCache = oldEventCache;
        }
        if (newEventCache.isEmpty() && viewCache.getServerCache().isFullyInitialized()) {
          complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
          if (complete.isLeafNode()) {
            newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
          }
        }
      }
      complete = viewCache.getServerCache().isFullyInitialized() || writesCache.shadowingWrite(Path.Empty) != null;
      return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
    }
  };
  return ViewProcessor2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var EventGenerator = function() {
  function EventGenerator2(query_) {
    this.query_ = query_;
    this.index_ = this.query_.getQueryParams().getIndex();
  }
  EventGenerator2.prototype.generateEventsForChanges = function(changes, eventCache, eventRegistrations) {
    var _this = this;
    var events = [];
    var moves = [];
    changes.forEach(function(change) {
      if (change.type === Change.CHILD_CHANGED && _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
        moves.push(Change.childMovedChange(change.childName, change.snapshotNode));
      }
    });
    this.generateEventsForType_(events, Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
    this.generateEventsForType_(events, Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
    this.generateEventsForType_(events, Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
    this.generateEventsForType_(events, Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
    this.generateEventsForType_(events, Change.VALUE, changes, eventRegistrations, eventCache);
    return events;
  };
  EventGenerator2.prototype.generateEventsForType_ = function(events, eventType, changes, registrations, eventCache) {
    var _this = this;
    var filteredChanges = changes.filter(function(change) {
      return change.type === eventType;
    });
    filteredChanges.sort(this.compareChanges_.bind(this));
    filteredChanges.forEach(function(change) {
      var materializedChange = _this.materializeSingleChange_(change, eventCache);
      registrations.forEach(function(registration) {
        if (registration.respondsTo(change.type)) {
          events.push(registration.createEvent(materializedChange, _this.query_));
        }
      });
    });
  };
  EventGenerator2.prototype.materializeSingleChange_ = function(change, eventCache) {
    if (change.type === "value" || change.type === "child_removed") {
      return change;
    } else {
      change.prevName = eventCache.getPredecessorChildName(change.childName, change.snapshotNode, this.index_);
      return change;
    }
  };
  EventGenerator2.prototype.compareChanges_ = function(a3, b3) {
    if (a3.childName == null || b3.childName == null) {
      throw assertionError("Should only compare child_ events.");
    }
    var aWrapped = new NamedNode(a3.childName, a3.snapshotNode);
    var bWrapped = new NamedNode(b3.childName, b3.snapshotNode);
    return this.index_.compare(aWrapped, bWrapped);
  };
  return EventGenerator2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var View = function() {
  function View2(query_, initialViewCache) {
    this.query_ = query_;
    this.eventRegistrations_ = [];
    var params2 = this.query_.getQueryParams();
    var indexFilter = new IndexedFilter(params2.getIndex());
    var filter2 = params2.getNodeFilter();
    this.processor_ = new ViewProcessor(filter2);
    var initialServerCache = initialViewCache.getServerCache();
    var initialEventCache = initialViewCache.getEventCache();
    var serverSnap = indexFilter.updateFullNode(ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
    var eventSnap = filter2.updateFullNode(ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
    var newServerCache = new CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
    var newEventCache = new CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter2.filtersNodes());
    this.viewCache_ = new ViewCache(newEventCache, newServerCache);
    this.eventGenerator_ = new EventGenerator(this.query_);
  }
  View2.prototype.getQuery = function() {
    return this.query_;
  };
  View2.prototype.getServerCache = function() {
    return this.viewCache_.getServerCache().getNode();
  };
  View2.prototype.getCompleteServerCache = function(path) {
    var cache = this.viewCache_.getCompleteServerSnap();
    if (cache) {
      if (this.query_.getQueryParams().loadsAllData() || !path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty()) {
        return cache.getChild(path);
      }
    }
    return null;
  };
  View2.prototype.isEmpty = function() {
    return this.eventRegistrations_.length === 0;
  };
  View2.prototype.addEventRegistration = function(eventRegistration) {
    this.eventRegistrations_.push(eventRegistration);
  };
  View2.prototype.removeEventRegistration = function(eventRegistration, cancelError) {
    var cancelEvents = [];
    if (cancelError) {
      assert(eventRegistration == null, "A cancel should cancel all event registrations.");
      var path_1 = this.query_.path;
      this.eventRegistrations_.forEach(function(registration) {
        cancelError = cancelError;
        var maybeEvent = registration.createCancelEvent(cancelError, path_1);
        if (maybeEvent) {
          cancelEvents.push(maybeEvent);
        }
      });
    }
    if (eventRegistration) {
      var remaining = [];
      for (var i = 0; i < this.eventRegistrations_.length; ++i) {
        var existing = this.eventRegistrations_[i];
        if (!existing.matches(eventRegistration)) {
          remaining.push(existing);
        } else if (eventRegistration.hasAnyCallback()) {
          remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
          break;
        }
      }
      this.eventRegistrations_ = remaining;
    } else {
      this.eventRegistrations_ = [];
    }
    return cancelEvents;
  };
  View2.prototype.applyOperation = function(operation, writesCache, completeServerCache) {
    if (operation.type === OperationType.MERGE && operation.source.queryId !== null) {
      assert(this.viewCache_.getCompleteServerSnap(), "We should always have a full cache before handling merges");
      assert(this.viewCache_.getCompleteEventSnap(), "Missing event cache, even though we have a server cache");
    }
    var oldViewCache = this.viewCache_;
    var result2 = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
    this.processor_.assertIndexed(result2.viewCache);
    assert(result2.viewCache.getServerCache().isFullyInitialized() || !oldViewCache.getServerCache().isFullyInitialized(), "Once a server snap is complete, it should never go back");
    this.viewCache_ = result2.viewCache;
    return this.generateEventsForChanges_(result2.changes, result2.viewCache.getEventCache().getNode(), null);
  };
  View2.prototype.getInitialEvents = function(registration) {
    var eventSnap = this.viewCache_.getEventCache();
    var initialChanges = [];
    if (!eventSnap.getNode().isLeafNode()) {
      var eventNode = eventSnap.getNode();
      eventNode.forEachChild(PRIORITY_INDEX, function(key, childNode) {
        initialChanges.push(Change.childAddedChange(key, childNode));
      });
    }
    if (eventSnap.isFullyInitialized()) {
      initialChanges.push(Change.valueChange(eventSnap.getNode()));
    }
    return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
  };
  View2.prototype.generateEventsForChanges_ = function(changes, eventCache, eventRegistration) {
    var registrations = eventRegistration ? [eventRegistration] : this.eventRegistrations_;
    return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
  };
  return View2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor$1;
var SyncPoint = function() {
  function SyncPoint2() {
    this.views = new Map();
  }
  Object.defineProperty(SyncPoint2, "__referenceConstructor", {
    get: function() {
      assert(__referenceConstructor$1, "Reference.ts has not been loaded");
      return __referenceConstructor$1;
    },
    set: function(val) {
      assert(!__referenceConstructor$1, "__referenceConstructor has already been defined");
      __referenceConstructor$1 = val;
    },
    enumerable: false,
    configurable: true
  });
  SyncPoint2.prototype.isEmpty = function() {
    return this.views.size === 0;
  };
  SyncPoint2.prototype.applyOperation = function(operation, writesCache, optCompleteServerCache) {
    var e_1, _a2;
    var queryId = operation.source.queryId;
    if (queryId !== null) {
      var view = this.views.get(queryId);
      assert(view != null, "SyncTree gave us an op for an invalid query.");
      return view.applyOperation(operation, writesCache, optCompleteServerCache);
    } else {
      var events = [];
      try {
        for (var _b2 = __values$1(this.views.values()), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
          var view = _c2.value;
          events = events.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c2 && !_c2.done && (_a2 = _b2.return))
            _a2.call(_b2);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      return events;
    }
  };
  SyncPoint2.prototype.addEventRegistration = function(query2, eventRegistration, writesCache, serverCache, serverCacheComplete) {
    var queryId = query2.queryIdentifier();
    var view = this.views.get(queryId);
    if (!view) {
      var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
      var eventCacheComplete = false;
      if (eventCache) {
        eventCacheComplete = true;
      } else if (serverCache instanceof ChildrenNode) {
        eventCache = writesCache.calcCompleteEventChildren(serverCache);
        eventCacheComplete = false;
      } else {
        eventCache = ChildrenNode.EMPTY_NODE;
        eventCacheComplete = false;
      }
      var viewCache = new ViewCache(new CacheNode(eventCache, eventCacheComplete, false), new CacheNode(serverCache, serverCacheComplete, false));
      view = new View(query2, viewCache);
      this.views.set(queryId, view);
    }
    view.addEventRegistration(eventRegistration);
    return view.getInitialEvents(eventRegistration);
  };
  SyncPoint2.prototype.removeEventRegistration = function(query2, eventRegistration, cancelError) {
    var e_2, _a2;
    var queryId = query2.queryIdentifier();
    var removed = [];
    var cancelEvents = [];
    var hadCompleteView = this.hasCompleteView();
    if (queryId === "default") {
      try {
        for (var _b2 = __values$1(this.views.entries()), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
          var _d2 = __read(_c2.value, 2), viewQueryId = _d2[0], view = _d2[1];
          cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
          if (view.isEmpty()) {
            this.views.delete(viewQueryId);
            if (!view.getQuery().getQueryParams().loadsAllData()) {
              removed.push(view.getQuery());
            }
          }
        }
      } catch (e_2_1) {
        e_2 = { error: e_2_1 };
      } finally {
        try {
          if (_c2 && !_c2.done && (_a2 = _b2.return))
            _a2.call(_b2);
        } finally {
          if (e_2)
            throw e_2.error;
        }
      }
    } else {
      var view = this.views.get(queryId);
      if (view) {
        cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
        if (view.isEmpty()) {
          this.views.delete(queryId);
          if (!view.getQuery().getQueryParams().loadsAllData()) {
            removed.push(view.getQuery());
          }
        }
      }
    }
    if (hadCompleteView && !this.hasCompleteView()) {
      removed.push(new SyncPoint2.__referenceConstructor(query2.repo, query2.path));
    }
    return { removed, events: cancelEvents };
  };
  SyncPoint2.prototype.getQueryViews = function() {
    var e_3, _a2;
    var result2 = [];
    try {
      for (var _b2 = __values$1(this.views.values()), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
        var view = _c2.value;
        if (!view.getQuery().getQueryParams().loadsAllData()) {
          result2.push(view);
        }
      }
    } catch (e_3_1) {
      e_3 = { error: e_3_1 };
    } finally {
      try {
        if (_c2 && !_c2.done && (_a2 = _b2.return))
          _a2.call(_b2);
      } finally {
        if (e_3)
          throw e_3.error;
      }
    }
    return result2;
  };
  SyncPoint2.prototype.getCompleteServerCache = function(path) {
    var e_4, _a2;
    var serverCache = null;
    try {
      for (var _b2 = __values$1(this.views.values()), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
        var view = _c2.value;
        serverCache = serverCache || view.getCompleteServerCache(path);
      }
    } catch (e_4_1) {
      e_4 = { error: e_4_1 };
    } finally {
      try {
        if (_c2 && !_c2.done && (_a2 = _b2.return))
          _a2.call(_b2);
      } finally {
        if (e_4)
          throw e_4.error;
      }
    }
    return serverCache;
  };
  SyncPoint2.prototype.viewForQuery = function(query2) {
    var params2 = query2.getQueryParams();
    if (params2.loadsAllData()) {
      return this.getCompleteView();
    } else {
      var queryId = query2.queryIdentifier();
      return this.views.get(queryId);
    }
  };
  SyncPoint2.prototype.viewExistsForQuery = function(query2) {
    return this.viewForQuery(query2) != null;
  };
  SyncPoint2.prototype.hasCompleteView = function() {
    return this.getCompleteView() != null;
  };
  SyncPoint2.prototype.getCompleteView = function() {
    var e_5, _a2;
    try {
      for (var _b2 = __values$1(this.views.values()), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
        var view = _c2.value;
        if (view.getQuery().getQueryParams().loadsAllData()) {
          return view;
        }
      }
    } catch (e_5_1) {
      e_5 = { error: e_5_1 };
    } finally {
      try {
        if (_c2 && !_c2.done && (_a2 = _b2.return))
          _a2.call(_b2);
      } finally {
        if (e_5)
          throw e_5.error;
      }
    }
    return null;
  };
  return SyncPoint2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var CompoundWrite = function() {
  function CompoundWrite2(writeTree_) {
    this.writeTree_ = writeTree_;
  }
  CompoundWrite2.prototype.addWrite = function(path, node) {
    if (path.isEmpty()) {
      return new CompoundWrite2(new ImmutableTree(node));
    } else {
      var rootmost = this.writeTree_.findRootMostValueAndPath(path);
      if (rootmost != null) {
        var rootMostPath = rootmost.path;
        var value = rootmost.value;
        var relativePath = Path.relativePath(rootMostPath, path);
        value = value.updateChild(relativePath, node);
        return new CompoundWrite2(this.writeTree_.set(rootMostPath, value));
      } else {
        var subtree = new ImmutableTree(node);
        var newWriteTree = this.writeTree_.setTree(path, subtree);
        return new CompoundWrite2(newWriteTree);
      }
    }
  };
  CompoundWrite2.prototype.addWrites = function(path, updates) {
    var newWrite = this;
    each(updates, function(childKey, node) {
      newWrite = newWrite.addWrite(path.child(childKey), node);
    });
    return newWrite;
  };
  CompoundWrite2.prototype.removeWrite = function(path) {
    if (path.isEmpty()) {
      return CompoundWrite2.Empty;
    } else {
      var newWriteTree = this.writeTree_.setTree(path, ImmutableTree.Empty);
      return new CompoundWrite2(newWriteTree);
    }
  };
  CompoundWrite2.prototype.hasCompleteWrite = function(path) {
    return this.getCompleteNode(path) != null;
  };
  CompoundWrite2.prototype.getCompleteNode = function(path) {
    var rootmost = this.writeTree_.findRootMostValueAndPath(path);
    if (rootmost != null) {
      return this.writeTree_.get(rootmost.path).getChild(Path.relativePath(rootmost.path, path));
    } else {
      return null;
    }
  };
  CompoundWrite2.prototype.getCompleteChildren = function() {
    var children = [];
    var node = this.writeTree_.value;
    if (node != null) {
      if (!node.isLeafNode()) {
        node.forEachChild(PRIORITY_INDEX, function(childName, childNode) {
          children.push(new NamedNode(childName, childNode));
        });
      }
    } else {
      this.writeTree_.children.inorderTraversal(function(childName, childTree) {
        if (childTree.value != null) {
          children.push(new NamedNode(childName, childTree.value));
        }
      });
    }
    return children;
  };
  CompoundWrite2.prototype.childCompoundWrite = function(path) {
    if (path.isEmpty()) {
      return this;
    } else {
      var shadowingNode = this.getCompleteNode(path);
      if (shadowingNode != null) {
        return new CompoundWrite2(new ImmutableTree(shadowingNode));
      } else {
        return new CompoundWrite2(this.writeTree_.subtree(path));
      }
    }
  };
  CompoundWrite2.prototype.isEmpty = function() {
    return this.writeTree_.isEmpty();
  };
  CompoundWrite2.prototype.apply = function(node) {
    return applySubtreeWrite(Path.Empty, this.writeTree_, node);
  };
  CompoundWrite2.Empty = new CompoundWrite2(new ImmutableTree(null));
  return CompoundWrite2;
}();
function applySubtreeWrite(relativePath, writeTree, node) {
  if (writeTree.value != null) {
    return node.updateChild(relativePath, writeTree.value);
  } else {
    var priorityWrite_1 = null;
    writeTree.children.inorderTraversal(function(childKey, childTree) {
      if (childKey === ".priority") {
        assert(childTree.value !== null, "Priority writes must always be leaf nodes");
        priorityWrite_1 = childTree.value;
      } else {
        node = applySubtreeWrite(relativePath.child(childKey), childTree, node);
      }
    });
    if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
      node = node.updateChild(relativePath.child(".priority"), priorityWrite_1);
    }
    return node;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WriteTree = function() {
  function WriteTree2() {
    this.visibleWrites_ = CompoundWrite.Empty;
    this.allWrites_ = [];
    this.lastWriteId_ = -1;
  }
  WriteTree2.prototype.childWrites = function(path) {
    return new WriteTreeRef(path, this);
  };
  WriteTree2.prototype.addOverwrite = function(path, snap, writeId, visible) {
    assert(writeId > this.lastWriteId_, "Stacking an older write on top of newer ones");
    if (visible === void 0) {
      visible = true;
    }
    this.allWrites_.push({
      path,
      snap,
      writeId,
      visible
    });
    if (visible) {
      this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
    }
    this.lastWriteId_ = writeId;
  };
  WriteTree2.prototype.addMerge = function(path, changedChildren, writeId) {
    assert(writeId > this.lastWriteId_, "Stacking an older merge on top of newer ones");
    this.allWrites_.push({
      path,
      children: changedChildren,
      writeId,
      visible: true
    });
    this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
    this.lastWriteId_ = writeId;
  };
  WriteTree2.prototype.getWrite = function(writeId) {
    for (var i = 0; i < this.allWrites_.length; i++) {
      var record = this.allWrites_[i];
      if (record.writeId === writeId) {
        return record;
      }
    }
    return null;
  };
  WriteTree2.prototype.removeWrite = function(writeId) {
    var _this = this;
    var idx = this.allWrites_.findIndex(function(s3) {
      return s3.writeId === writeId;
    });
    assert(idx >= 0, "removeWrite called with nonexistent writeId.");
    var writeToRemove = this.allWrites_[idx];
    this.allWrites_.splice(idx, 1);
    var removedWriteWasVisible = writeToRemove.visible;
    var removedWriteOverlapsWithOtherWrites = false;
    var i = this.allWrites_.length - 1;
    while (removedWriteWasVisible && i >= 0) {
      var currentWrite = this.allWrites_[i];
      if (currentWrite.visible) {
        if (i >= idx && this.recordContainsPath_(currentWrite, writeToRemove.path)) {
          removedWriteWasVisible = false;
        } else if (writeToRemove.path.contains(currentWrite.path)) {
          removedWriteOverlapsWithOtherWrites = true;
        }
      }
      i--;
    }
    if (!removedWriteWasVisible) {
      return false;
    } else if (removedWriteOverlapsWithOtherWrites) {
      this.resetTree_();
      return true;
    } else {
      if (writeToRemove.snap) {
        this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
      } else {
        var children = writeToRemove.children;
        each(children, function(childName) {
          _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
        });
      }
      return true;
    }
  };
  WriteTree2.prototype.getCompleteWriteData = function(path) {
    return this.visibleWrites_.getCompleteNode(path);
  };
  WriteTree2.prototype.calcCompleteEventCache = function(treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    if (!writeIdsToExclude && !includeHiddenWrites) {
      var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
      if (shadowingNode != null) {
        return shadowingNode;
      } else {
        var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
        if (subMerge.isEmpty()) {
          return completeServerCache;
        } else if (completeServerCache == null && !subMerge.hasCompleteWrite(Path.Empty)) {
          return null;
        } else {
          var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
          return subMerge.apply(layeredCache);
        }
      }
    } else {
      var merge2 = this.visibleWrites_.childCompoundWrite(treePath);
      if (!includeHiddenWrites && merge2.isEmpty()) {
        return completeServerCache;
      } else {
        if (!includeHiddenWrites && completeServerCache == null && !merge2.hasCompleteWrite(Path.Empty)) {
          return null;
        } else {
          var filter2 = function(write) {
            return (write.visible || includeHiddenWrites) && (!writeIdsToExclude || !~writeIdsToExclude.indexOf(write.writeId)) && (write.path.contains(treePath) || treePath.contains(write.path));
          };
          var mergeAtPath = WriteTree2.layerTree_(this.allWrites_, filter2, treePath);
          var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
          return mergeAtPath.apply(layeredCache);
        }
      }
    }
  };
  WriteTree2.prototype.calcCompleteEventChildren = function(treePath, completeServerChildren) {
    var completeChildren = ChildrenNode.EMPTY_NODE;
    var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
    if (topLevelSet) {
      if (!topLevelSet.isLeafNode()) {
        topLevelSet.forEachChild(PRIORITY_INDEX, function(childName, childSnap) {
          completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
        });
      }
      return completeChildren;
    } else if (completeServerChildren) {
      var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
      completeServerChildren.forEachChild(PRIORITY_INDEX, function(childName, childNode) {
        var node = merge_1.childCompoundWrite(new Path(childName)).apply(childNode);
        completeChildren = completeChildren.updateImmediateChild(childName, node);
      });
      merge_1.getCompleteChildren().forEach(function(namedNode) {
        completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
      });
      return completeChildren;
    } else {
      var merge2 = this.visibleWrites_.childCompoundWrite(treePath);
      merge2.getCompleteChildren().forEach(function(namedNode) {
        completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
      });
      return completeChildren;
    }
  };
  WriteTree2.prototype.calcEventCacheAfterServerOverwrite = function(treePath, childPath, existingEventSnap, existingServerSnap) {
    assert(existingEventSnap || existingServerSnap, "Either existingEventSnap or existingServerSnap must exist");
    var path = treePath.child(childPath);
    if (this.visibleWrites_.hasCompleteWrite(path)) {
      return null;
    } else {
      var childMerge = this.visibleWrites_.childCompoundWrite(path);
      if (childMerge.isEmpty()) {
        return existingServerSnap.getChild(childPath);
      } else {
        return childMerge.apply(existingServerSnap.getChild(childPath));
      }
    }
  };
  WriteTree2.prototype.calcCompleteChild = function(treePath, childKey, existingServerSnap) {
    var path = treePath.child(childKey);
    var shadowingNode = this.visibleWrites_.getCompleteNode(path);
    if (shadowingNode != null) {
      return shadowingNode;
    } else {
      if (existingServerSnap.isCompleteForChild(childKey)) {
        var childMerge = this.visibleWrites_.childCompoundWrite(path);
        return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
      } else {
        return null;
      }
    }
  };
  WriteTree2.prototype.shadowingWrite = function(path) {
    return this.visibleWrites_.getCompleteNode(path);
  };
  WriteTree2.prototype.calcIndexedSlice = function(treePath, completeServerData, startPost, count, reverse, index) {
    var toIterate;
    var merge2 = this.visibleWrites_.childCompoundWrite(treePath);
    var shadowingNode = merge2.getCompleteNode(Path.Empty);
    if (shadowingNode != null) {
      toIterate = shadowingNode;
    } else if (completeServerData != null) {
      toIterate = merge2.apply(completeServerData);
    } else {
      return [];
    }
    toIterate = toIterate.withIndex(index);
    if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
      var nodes = [];
      var cmp = index.getCompare();
      var iter = reverse ? toIterate.getReverseIteratorFrom(startPost, index) : toIterate.getIteratorFrom(startPost, index);
      var next = iter.getNext();
      while (next && nodes.length < count) {
        if (cmp(next, startPost) !== 0) {
          nodes.push(next);
        }
        next = iter.getNext();
      }
      return nodes;
    } else {
      return [];
    }
  };
  WriteTree2.prototype.recordContainsPath_ = function(writeRecord, path) {
    if (writeRecord.snap) {
      return writeRecord.path.contains(path);
    } else {
      for (var childName in writeRecord.children) {
        if (writeRecord.children.hasOwnProperty(childName) && writeRecord.path.child(childName).contains(path)) {
          return true;
        }
      }
      return false;
    }
  };
  WriteTree2.prototype.resetTree_ = function() {
    this.visibleWrites_ = WriteTree2.layerTree_(this.allWrites_, WriteTree2.DefaultFilter_, Path.Empty);
    if (this.allWrites_.length > 0) {
      this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
    } else {
      this.lastWriteId_ = -1;
    }
  };
  WriteTree2.DefaultFilter_ = function(write) {
    return write.visible;
  };
  WriteTree2.layerTree_ = function(writes, filter2, treeRoot) {
    var compoundWrite = CompoundWrite.Empty;
    for (var i = 0; i < writes.length; ++i) {
      var write = writes[i];
      if (filter2(write)) {
        var writePath = write.path;
        var relativePath = void 0;
        if (write.snap) {
          if (treeRoot.contains(writePath)) {
            relativePath = Path.relativePath(treeRoot, writePath);
            compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
          } else if (writePath.contains(treeRoot)) {
            relativePath = Path.relativePath(writePath, treeRoot);
            compoundWrite = compoundWrite.addWrite(Path.Empty, write.snap.getChild(relativePath));
          } else
            ;
        } else if (write.children) {
          if (treeRoot.contains(writePath)) {
            relativePath = Path.relativePath(treeRoot, writePath);
            compoundWrite = compoundWrite.addWrites(relativePath, write.children);
          } else if (writePath.contains(treeRoot)) {
            relativePath = Path.relativePath(writePath, treeRoot);
            if (relativePath.isEmpty()) {
              compoundWrite = compoundWrite.addWrites(Path.Empty, write.children);
            } else {
              var child2 = safeGet(write.children, relativePath.getFront());
              if (child2) {
                var deepNode = child2.getChild(relativePath.popFront());
                compoundWrite = compoundWrite.addWrite(Path.Empty, deepNode);
              }
            }
          } else
            ;
        } else {
          throw assertionError("WriteRecord should have .snap or .children");
        }
      }
    }
    return compoundWrite;
  };
  return WriteTree2;
}();
var WriteTreeRef = function() {
  function WriteTreeRef2(path, writeTree) {
    this.treePath_ = path;
    this.writeTree_ = writeTree;
  }
  WriteTreeRef2.prototype.calcCompleteEventCache = function(completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
  };
  WriteTreeRef2.prototype.calcCompleteEventChildren = function(completeServerChildren) {
    return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
  };
  WriteTreeRef2.prototype.calcEventCacheAfterServerOverwrite = function(path, existingEventSnap, existingServerSnap) {
    return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
  };
  WriteTreeRef2.prototype.shadowingWrite = function(path) {
    return this.writeTree_.shadowingWrite(this.treePath_.child(path));
  };
  WriteTreeRef2.prototype.calcIndexedSlice = function(completeServerData, startPost, count, reverse, index) {
    return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
  };
  WriteTreeRef2.prototype.calcCompleteChild = function(childKey, existingServerCache) {
    return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
  };
  WriteTreeRef2.prototype.child = function(childName) {
    return new WriteTreeRef2(this.treePath_.child(childName), this.writeTree_);
  };
  return WriteTreeRef2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SyncTree = function() {
  function SyncTree2(listenProvider_) {
    this.listenProvider_ = listenProvider_;
    this.syncPointTree_ = ImmutableTree.Empty;
    this.pendingWriteTree_ = new WriteTree();
    this.tagToQueryMap = new Map();
    this.queryToTagMap = new Map();
  }
  SyncTree2.prototype.applyUserOverwrite = function(path, newData, writeId, visible) {
    this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
    if (!visible) {
      return [];
    } else {
      return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.User, path, newData));
    }
  };
  SyncTree2.prototype.applyUserMerge = function(path, changedChildren, writeId) {
    this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
    var changeTree = ImmutableTree.fromObject(changedChildren);
    return this.applyOperationToSyncPoints_(new Merge(OperationSource.User, path, changeTree));
  };
  SyncTree2.prototype.ackUserWrite = function(writeId, revert) {
    if (revert === void 0) {
      revert = false;
    }
    var write = this.pendingWriteTree_.getWrite(writeId);
    var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
    if (!needToReevaluate) {
      return [];
    } else {
      var affectedTree_1 = ImmutableTree.Empty;
      if (write.snap != null) {
        affectedTree_1 = affectedTree_1.set(Path.Empty, true);
      } else {
        each(write.children, function(pathString, node) {
          affectedTree_1 = affectedTree_1.set(new Path(pathString), node);
        });
      }
      return this.applyOperationToSyncPoints_(new AckUserWrite(write.path, affectedTree_1, revert));
    }
  };
  SyncTree2.prototype.applyServerOverwrite = function(path, newData) {
    return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.Server, path, newData));
  };
  SyncTree2.prototype.applyServerMerge = function(path, changedChildren) {
    var changeTree = ImmutableTree.fromObject(changedChildren);
    return this.applyOperationToSyncPoints_(new Merge(OperationSource.Server, path, changeTree));
  };
  SyncTree2.prototype.applyListenComplete = function(path) {
    return this.applyOperationToSyncPoints_(new ListenComplete(OperationSource.Server, path));
  };
  SyncTree2.prototype.applyTaggedQueryOverwrite = function(path, snap, tag) {
    var queryKey = this.queryKeyForTag_(tag);
    if (queryKey != null) {
      var r3 = SyncTree2.parseQueryKey_(queryKey);
      var queryPath = r3.path, queryId = r3.queryId;
      var relativePath = Path.relativePath(queryPath, path);
      var op2 = new Overwrite(OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
      return this.applyTaggedOperation_(queryPath, op2);
    } else {
      return [];
    }
  };
  SyncTree2.prototype.applyTaggedQueryMerge = function(path, changedChildren, tag) {
    var queryKey = this.queryKeyForTag_(tag);
    if (queryKey) {
      var r3 = SyncTree2.parseQueryKey_(queryKey);
      var queryPath = r3.path, queryId = r3.queryId;
      var relativePath = Path.relativePath(queryPath, path);
      var changeTree = ImmutableTree.fromObject(changedChildren);
      var op2 = new Merge(OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
      return this.applyTaggedOperation_(queryPath, op2);
    } else {
      return [];
    }
  };
  SyncTree2.prototype.applyTaggedListenComplete = function(path, tag) {
    var queryKey = this.queryKeyForTag_(tag);
    if (queryKey) {
      var r3 = SyncTree2.parseQueryKey_(queryKey);
      var queryPath = r3.path, queryId = r3.queryId;
      var relativePath = Path.relativePath(queryPath, path);
      var op2 = new ListenComplete(OperationSource.forServerTaggedQuery(queryId), relativePath);
      return this.applyTaggedOperation_(queryPath, op2);
    } else {
      return [];
    }
  };
  SyncTree2.prototype.addEventRegistration = function(query2, eventRegistration) {
    var path = query2.path;
    var serverCache = null;
    var foundAncestorDefaultView = false;
    this.syncPointTree_.foreachOnPath(path, function(pathToSyncPoint, sp2) {
      var relativePath = Path.relativePath(pathToSyncPoint, path);
      serverCache = serverCache || sp2.getCompleteServerCache(relativePath);
      foundAncestorDefaultView = foundAncestorDefaultView || sp2.hasCompleteView();
    });
    var syncPoint = this.syncPointTree_.get(path);
    if (!syncPoint) {
      syncPoint = new SyncPoint();
      this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
    } else {
      foundAncestorDefaultView = foundAncestorDefaultView || syncPoint.hasCompleteView();
      serverCache = serverCache || syncPoint.getCompleteServerCache(Path.Empty);
    }
    var serverCacheComplete;
    if (serverCache != null) {
      serverCacheComplete = true;
    } else {
      serverCacheComplete = false;
      serverCache = ChildrenNode.EMPTY_NODE;
      var subtree = this.syncPointTree_.subtree(path);
      subtree.foreachChild(function(childName, childSyncPoint) {
        var completeCache = childSyncPoint.getCompleteServerCache(Path.Empty);
        if (completeCache) {
          serverCache = serverCache.updateImmediateChild(childName, completeCache);
        }
      });
    }
    var viewAlreadyExists = syncPoint.viewExistsForQuery(query2);
    if (!viewAlreadyExists && !query2.getQueryParams().loadsAllData()) {
      var queryKey = SyncTree2.makeQueryKey_(query2);
      assert(!this.queryToTagMap.has(queryKey), "View does not exist, but we have a tag");
      var tag = SyncTree2.getNextQueryTag_();
      this.queryToTagMap.set(queryKey, tag);
      this.tagToQueryMap.set(tag, queryKey);
    }
    var writesCache = this.pendingWriteTree_.childWrites(path);
    var events = syncPoint.addEventRegistration(query2, eventRegistration, writesCache, serverCache, serverCacheComplete);
    if (!viewAlreadyExists && !foundAncestorDefaultView) {
      var view = syncPoint.viewForQuery(query2);
      events = events.concat(this.setupListener_(query2, view));
    }
    return events;
  };
  SyncTree2.prototype.removeEventRegistration = function(query2, eventRegistration, cancelError) {
    var _this = this;
    var path = query2.path;
    var maybeSyncPoint = this.syncPointTree_.get(path);
    var cancelEvents = [];
    if (maybeSyncPoint && (query2.queryIdentifier() === "default" || maybeSyncPoint.viewExistsForQuery(query2))) {
      var removedAndEvents = maybeSyncPoint.removeEventRegistration(query2, eventRegistration, cancelError);
      if (maybeSyncPoint.isEmpty()) {
        this.syncPointTree_ = this.syncPointTree_.remove(path);
      }
      var removed = removedAndEvents.removed;
      cancelEvents = removedAndEvents.events;
      var removingDefault = removed.findIndex(function(query3) {
        return query3.getQueryParams().loadsAllData();
      }) !== -1;
      var covered = this.syncPointTree_.findOnPath(path, function(relativePath, parentSyncPoint) {
        return parentSyncPoint.hasCompleteView();
      });
      if (removingDefault && !covered) {
        var subtree = this.syncPointTree_.subtree(path);
        if (!subtree.isEmpty()) {
          var newViews = this.collectDistinctViewsForSubTree_(subtree);
          for (var i = 0; i < newViews.length; ++i) {
            var view = newViews[i], newQuery = view.getQuery();
            var listener = this.createListenerForView_(view);
            this.listenProvider_.startListening(SyncTree2.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
          }
        }
      }
      if (!covered && removed.length > 0 && !cancelError) {
        if (removingDefault) {
          var defaultTag = null;
          this.listenProvider_.stopListening(SyncTree2.queryForListening_(query2), defaultTag);
        } else {
          removed.forEach(function(queryToRemove) {
            var tagToRemove = _this.queryToTagMap.get(SyncTree2.makeQueryKey_(queryToRemove));
            _this.listenProvider_.stopListening(SyncTree2.queryForListening_(queryToRemove), tagToRemove);
          });
        }
      }
      this.removeTags_(removed);
    }
    return cancelEvents;
  };
  SyncTree2.prototype.calcCompleteEventCache = function(path, writeIdsToExclude) {
    var includeHiddenSets = true;
    var writeTree = this.pendingWriteTree_;
    var serverCache = this.syncPointTree_.findOnPath(path, function(pathSoFar, syncPoint) {
      var relativePath = Path.relativePath(pathSoFar, path);
      var serverCache2 = syncPoint.getCompleteServerCache(relativePath);
      if (serverCache2) {
        return serverCache2;
      }
    });
    return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
  };
  SyncTree2.prototype.collectDistinctViewsForSubTree_ = function(subtree) {
    return subtree.fold(function(relativePath, maybeChildSyncPoint, childMap) {
      if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
        var completeView = maybeChildSyncPoint.getCompleteView();
        return [completeView];
      } else {
        var views_1 = [];
        if (maybeChildSyncPoint) {
          views_1 = maybeChildSyncPoint.getQueryViews();
        }
        each(childMap, function(_key, childViews) {
          views_1 = views_1.concat(childViews);
        });
        return views_1;
      }
    });
  };
  SyncTree2.prototype.removeTags_ = function(queries) {
    for (var j3 = 0; j3 < queries.length; ++j3) {
      var removedQuery = queries[j3];
      if (!removedQuery.getQueryParams().loadsAllData()) {
        var removedQueryKey = SyncTree2.makeQueryKey_(removedQuery);
        var removedQueryTag = this.queryToTagMap.get(removedQueryKey);
        this.queryToTagMap.delete(removedQueryKey);
        this.tagToQueryMap.delete(removedQueryTag);
      }
    }
  };
  SyncTree2.queryForListening_ = function(query2) {
    if (query2.getQueryParams().loadsAllData() && !query2.getQueryParams().isDefault()) {
      return query2.getRef();
    } else {
      return query2;
    }
  };
  SyncTree2.prototype.setupListener_ = function(query2, view) {
    var path = query2.path;
    var tag = this.tagForQuery_(query2);
    var listener = this.createListenerForView_(view);
    var events = this.listenProvider_.startListening(SyncTree2.queryForListening_(query2), tag, listener.hashFn, listener.onComplete);
    var subtree = this.syncPointTree_.subtree(path);
    if (tag) {
      assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
    } else {
      var queriesToStop = subtree.fold(function(relativePath, maybeChildSyncPoint, childMap) {
        if (!relativePath.isEmpty() && maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
          return [maybeChildSyncPoint.getCompleteView().getQuery()];
        } else {
          var queries_1 = [];
          if (maybeChildSyncPoint) {
            queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function(view2) {
              return view2.getQuery();
            }));
          }
          each(childMap, function(_key, childQueries) {
            queries_1 = queries_1.concat(childQueries);
          });
          return queries_1;
        }
      });
      for (var i = 0; i < queriesToStop.length; ++i) {
        var queryToStop = queriesToStop[i];
        this.listenProvider_.stopListening(SyncTree2.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
      }
    }
    return events;
  };
  SyncTree2.prototype.createListenerForView_ = function(view) {
    var _this = this;
    var query2 = view.getQuery();
    var tag = this.tagForQuery_(query2);
    return {
      hashFn: function() {
        var cache = view.getServerCache() || ChildrenNode.EMPTY_NODE;
        return cache.hash();
      },
      onComplete: function(status) {
        if (status === "ok") {
          if (tag) {
            return _this.applyTaggedListenComplete(query2.path, tag);
          } else {
            return _this.applyListenComplete(query2.path);
          }
        } else {
          var error2 = errorForServerCode(status, query2);
          return _this.removeEventRegistration(query2, null, error2);
        }
      }
    };
  };
  SyncTree2.makeQueryKey_ = function(query2) {
    return query2.path.toString() + "$" + query2.queryIdentifier();
  };
  SyncTree2.parseQueryKey_ = function(queryKey) {
    var splitIndex = queryKey.indexOf("$");
    assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, "Bad queryKey.");
    return {
      queryId: queryKey.substr(splitIndex + 1),
      path: new Path(queryKey.substr(0, splitIndex))
    };
  };
  SyncTree2.prototype.queryKeyForTag_ = function(tag) {
    return this.tagToQueryMap.get(tag);
  };
  SyncTree2.prototype.tagForQuery_ = function(query2) {
    var queryKey = SyncTree2.makeQueryKey_(query2);
    return this.queryToTagMap.get(queryKey);
  };
  SyncTree2.getNextQueryTag_ = function() {
    return SyncTree2.nextQueryTag_++;
  };
  SyncTree2.prototype.applyTaggedOperation_ = function(queryPath, operation) {
    var syncPoint = this.syncPointTree_.get(queryPath);
    assert(syncPoint, "Missing sync point for query tag that we're tracking");
    var writesCache = this.pendingWriteTree_.childWrites(queryPath);
    return syncPoint.applyOperation(operation, writesCache, null);
  };
  SyncTree2.prototype.applyOperationToSyncPoints_ = function(operation) {
    return this.applyOperationHelper_(operation, this.syncPointTree_, null, this.pendingWriteTree_.childWrites(Path.Empty));
  };
  SyncTree2.prototype.applyOperationHelper_ = function(operation, syncPointTree, serverCache, writesCache) {
    if (operation.path.isEmpty()) {
      return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
    } else {
      var syncPoint = syncPointTree.get(Path.Empty);
      if (serverCache == null && syncPoint != null) {
        serverCache = syncPoint.getCompleteServerCache(Path.Empty);
      }
      var events = [];
      var childName = operation.path.getFront();
      var childOperation = operation.operationForChild(childName);
      var childTree = syncPointTree.children.get(childName);
      if (childTree && childOperation) {
        var childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
        var childWritesCache = writesCache.child(childName);
        events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
      }
      if (syncPoint) {
        events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
      }
      return events;
    }
  };
  SyncTree2.prototype.applyOperationDescendantsHelper_ = function(operation, syncPointTree, serverCache, writesCache) {
    var _this = this;
    var syncPoint = syncPointTree.get(Path.Empty);
    if (serverCache == null && syncPoint != null) {
      serverCache = syncPoint.getCompleteServerCache(Path.Empty);
    }
    var events = [];
    syncPointTree.children.inorderTraversal(function(childName, childTree) {
      var childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
      var childWritesCache = writesCache.child(childName);
      var childOperation = operation.operationForChild(childName);
      if (childOperation) {
        events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
      }
    });
    if (syncPoint) {
      events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
    }
    return events;
  };
  SyncTree2.nextQueryTag_ = 1;
  return SyncTree2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SnapshotHolder = function() {
  function SnapshotHolder2() {
    this.rootNode_ = ChildrenNode.EMPTY_NODE;
  }
  SnapshotHolder2.prototype.getNode = function(path) {
    return this.rootNode_.getChild(path);
  };
  SnapshotHolder2.prototype.updateSnapshot = function(path, newSnapshotNode) {
    this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
  };
  return SnapshotHolder2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StatsCollection = function() {
  function StatsCollection2() {
    this.counters_ = {};
  }
  StatsCollection2.prototype.incrementCounter = function(name2, amount) {
    if (amount === void 0) {
      amount = 1;
    }
    if (!contains(this.counters_, name2)) {
      this.counters_[name2] = 0;
    }
    this.counters_[name2] += amount;
  };
  StatsCollection2.prototype.get = function() {
    return deepCopy(this.counters_);
  };
  return StatsCollection2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StatsManager = function() {
  function StatsManager2() {
  }
  StatsManager2.getCollection = function(repoInfo) {
    var hashString = repoInfo.toString();
    if (!this.collections_[hashString]) {
      this.collections_[hashString] = new StatsCollection();
    }
    return this.collections_[hashString];
  };
  StatsManager2.getOrCreateReporter = function(repoInfo, creatorFunction) {
    var hashString = repoInfo.toString();
    if (!this.reporters_[hashString]) {
      this.reporters_[hashString] = creatorFunction();
    }
    return this.reporters_[hashString];
  };
  StatsManager2.collections_ = {};
  StatsManager2.reporters_ = {};
  return StatsManager2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StatsListener = function() {
  function StatsListener2(collection_) {
    this.collection_ = collection_;
    this.last_ = null;
  }
  StatsListener2.prototype.get = function() {
    var newStats = this.collection_.get();
    var delta = __assign({}, newStats);
    if (this.last_) {
      each(this.last_, function(stat, value) {
        delta[stat] = delta[stat] - value;
      });
    }
    this.last_ = newStats;
    return delta;
  };
  return StatsListener2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FIRST_STATS_MIN_TIME = 10 * 1e3;
var FIRST_STATS_MAX_TIME = 30 * 1e3;
var REPORT_STATS_INTERVAL = 5 * 60 * 1e3;
var StatsReporter = function() {
  function StatsReporter2(collection, server_) {
    this.server_ = server_;
    this.statsToReport_ = {};
    this.statsListener_ = new StatsListener(collection);
    var timeout = FIRST_STATS_MIN_TIME + (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
    setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
  }
  StatsReporter2.prototype.includeStat = function(stat) {
    this.statsToReport_[stat] = true;
  };
  StatsReporter2.prototype.reportStats_ = function() {
    var _this = this;
    var stats2 = this.statsListener_.get();
    var reportedStats = {};
    var haveStatsToReport = false;
    each(stats2, function(stat, value) {
      if (value > 0 && contains(_this.statsToReport_, stat)) {
        reportedStats[stat] = value;
        haveStatsToReport = true;
      }
    });
    if (haveStatsToReport) {
      this.server_.reportStats(reportedStats);
    }
    setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
  };
  return StatsReporter2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var EventQueue = function() {
  function EventQueue2() {
    this.eventLists_ = [];
    this.recursionDepth_ = 0;
  }
  EventQueue2.prototype.queueEvents = function(eventDataList) {
    var currList = null;
    for (var i = 0; i < eventDataList.length; i++) {
      var eventData = eventDataList[i];
      var eventPath = eventData.getPath();
      if (currList !== null && !eventPath.equals(currList.getPath())) {
        this.eventLists_.push(currList);
        currList = null;
      }
      if (currList === null) {
        currList = new EventList(eventPath);
      }
      currList.add(eventData);
    }
    if (currList) {
      this.eventLists_.push(currList);
    }
  };
  EventQueue2.prototype.raiseEventsAtPath = function(path, eventDataList) {
    this.queueEvents(eventDataList);
    this.raiseQueuedEventsMatchingPredicate_(function(eventPath) {
      return eventPath.equals(path);
    });
  };
  EventQueue2.prototype.raiseEventsForChangedPath = function(changedPath, eventDataList) {
    this.queueEvents(eventDataList);
    this.raiseQueuedEventsMatchingPredicate_(function(eventPath) {
      return eventPath.contains(changedPath) || changedPath.contains(eventPath);
    });
  };
  EventQueue2.prototype.raiseQueuedEventsMatchingPredicate_ = function(predicate) {
    this.recursionDepth_++;
    var sentAll = true;
    for (var i = 0; i < this.eventLists_.length; i++) {
      var eventList = this.eventLists_[i];
      if (eventList) {
        var eventPath = eventList.getPath();
        if (predicate(eventPath)) {
          this.eventLists_[i].raise();
          this.eventLists_[i] = null;
        } else {
          sentAll = false;
        }
      }
    }
    if (sentAll) {
      this.eventLists_ = [];
    }
    this.recursionDepth_--;
  };
  return EventQueue2;
}();
var EventList = function() {
  function EventList2(path_) {
    this.path_ = path_;
    this.events_ = [];
  }
  EventList2.prototype.add = function(eventData) {
    this.events_.push(eventData);
  };
  EventList2.prototype.raise = function() {
    for (var i = 0; i < this.events_.length; i++) {
      var eventData = this.events_[i];
      if (eventData !== null) {
        this.events_[i] = null;
        var eventFn = eventData.getEventRunner();
        if (logger$2) {
          log("event: " + eventData.toString());
        }
        exceptionGuard(eventFn);
      }
    }
  };
  EventList2.prototype.getPath = function() {
    return this.path_;
  };
  return EventList2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var EventEmitter = function() {
  function EventEmitter2(allowedEvents_) {
    this.allowedEvents_ = allowedEvents_;
    this.listeners_ = {};
    assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, "Requires a non-empty array");
  }
  EventEmitter2.prototype.trigger = function(eventType) {
    var varArgs = [];
    for (var _i2 = 1; _i2 < arguments.length; _i2++) {
      varArgs[_i2 - 1] = arguments[_i2];
    }
    if (Array.isArray(this.listeners_[eventType])) {
      var listeners = __spread(this.listeners_[eventType]);
      for (var i = 0; i < listeners.length; i++) {
        listeners[i].callback.apply(listeners[i].context, varArgs);
      }
    }
  };
  EventEmitter2.prototype.on = function(eventType, callback, context) {
    this.validateEventType_(eventType);
    this.listeners_[eventType] = this.listeners_[eventType] || [];
    this.listeners_[eventType].push({ callback, context });
    var eventData = this.getInitialEvent(eventType);
    if (eventData) {
      callback.apply(context, eventData);
    }
  };
  EventEmitter2.prototype.off = function(eventType, callback, context) {
    this.validateEventType_(eventType);
    var listeners = this.listeners_[eventType] || [];
    for (var i = 0; i < listeners.length; i++) {
      if (listeners[i].callback === callback && (!context || context === listeners[i].context)) {
        listeners.splice(i, 1);
        return;
      }
    }
  };
  EventEmitter2.prototype.validateEventType_ = function(eventType) {
    assert(this.allowedEvents_.find(function(et2) {
      return et2 === eventType;
    }), "Unknown event: " + eventType);
  };
  return EventEmitter2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var VisibilityMonitor = function(_super) {
  __extends$1(VisibilityMonitor2, _super);
  function VisibilityMonitor2() {
    var _this = _super.call(this, ["visible"]) || this;
    var hidden;
    var visibilityChange;
    if (typeof document !== "undefined" && typeof document.addEventListener !== "undefined") {
      if (typeof document["hidden"] !== "undefined") {
        visibilityChange = "visibilitychange";
        hidden = "hidden";
      } else if (typeof document["mozHidden"] !== "undefined") {
        visibilityChange = "mozvisibilitychange";
        hidden = "mozHidden";
      } else if (typeof document["msHidden"] !== "undefined") {
        visibilityChange = "msvisibilitychange";
        hidden = "msHidden";
      } else if (typeof document["webkitHidden"] !== "undefined") {
        visibilityChange = "webkitvisibilitychange";
        hidden = "webkitHidden";
      }
    }
    _this.visible_ = true;
    if (visibilityChange) {
      document.addEventListener(visibilityChange, function() {
        var visible = !document[hidden];
        if (visible !== _this.visible_) {
          _this.visible_ = visible;
          _this.trigger("visible", visible);
        }
      }, false);
    }
    return _this;
  }
  VisibilityMonitor2.getInstance = function() {
    return new VisibilityMonitor2();
  };
  VisibilityMonitor2.prototype.getInitialEvent = function(eventType) {
    assert(eventType === "visible", "Unknown event type: " + eventType);
    return [this.visible_];
  };
  return VisibilityMonitor2;
}(EventEmitter);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OnlineMonitor = function(_super) {
  __extends$1(OnlineMonitor2, _super);
  function OnlineMonitor2() {
    var _this = _super.call(this, ["online"]) || this;
    _this.online_ = true;
    if (typeof window !== "undefined" && typeof window.addEventListener !== "undefined" && !isMobileCordova()) {
      window.addEventListener("online", function() {
        if (!_this.online_) {
          _this.online_ = true;
          _this.trigger("online", true);
        }
      }, false);
      window.addEventListener("offline", function() {
        if (_this.online_) {
          _this.online_ = false;
          _this.trigger("online", false);
        }
      }, false);
    }
    return _this;
  }
  OnlineMonitor2.getInstance = function() {
    return new OnlineMonitor2();
  };
  OnlineMonitor2.prototype.getInitialEvent = function(eventType) {
    assert(eventType === "online", "Unknown event type: " + eventType);
    return [this.online_];
  };
  OnlineMonitor2.prototype.currentlyOnline = function() {
    return this.online_;
  };
  return OnlineMonitor2;
}(EventEmitter);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PacketReceiver = function() {
  function PacketReceiver2(onMessage_) {
    this.onMessage_ = onMessage_;
    this.pendingResponses = [];
    this.currentResponseNum = 0;
    this.closeAfterResponse = -1;
    this.onClose = null;
  }
  PacketReceiver2.prototype.closeAfter = function(responseNum, callback) {
    this.closeAfterResponse = responseNum;
    this.onClose = callback;
    if (this.closeAfterResponse < this.currentResponseNum) {
      this.onClose();
      this.onClose = null;
    }
  };
  PacketReceiver2.prototype.handleResponse = function(requestNum, data) {
    var _this = this;
    this.pendingResponses[requestNum] = data;
    var _loop_1 = function() {
      var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
      delete this_1.pendingResponses[this_1.currentResponseNum];
      var _loop_2 = function(i3) {
        if (toProcess[i3]) {
          exceptionGuard(function() {
            _this.onMessage_(toProcess[i3]);
          });
        }
      };
      for (var i = 0; i < toProcess.length; ++i) {
        _loop_2(i);
      }
      if (this_1.currentResponseNum === this_1.closeAfterResponse) {
        if (this_1.onClose) {
          this_1.onClose();
          this_1.onClose = null;
        }
        return "break";
      }
      this_1.currentResponseNum++;
    };
    var this_1 = this;
    while (this.pendingResponses[this.currentResponseNum]) {
      var state_1 = _loop_1();
      if (state_1 === "break")
        break;
    }
  };
  return PacketReceiver2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FIREBASE_LONGPOLL_START_PARAM = "start";
var FIREBASE_LONGPOLL_CLOSE_COMMAND = "close";
var FIREBASE_LONGPOLL_COMMAND_CB_NAME = "pLPCommand";
var FIREBASE_LONGPOLL_DATA_CB_NAME = "pRTLPCB";
var FIREBASE_LONGPOLL_ID_PARAM = "id";
var FIREBASE_LONGPOLL_PW_PARAM = "pw";
var FIREBASE_LONGPOLL_SERIAL_PARAM = "ser";
var FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = "cb";
var FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = "seg";
var FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = "ts";
var FIREBASE_LONGPOLL_DATA_PARAM = "d";
var FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = "dframe";
var MAX_URL_DATA_SIZE = 1870;
var SEG_HEADER_SIZE = 30;
var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
var KEEPALIVE_REQUEST_INTERVAL = 25e3;
var LP_CONNECT_TIMEOUT = 3e4;
var BrowserPollConnection = function() {
  function BrowserPollConnection2(connId, repoInfo, applicationId, transportSessionId, lastSessionId) {
    this.connId = connId;
    this.repoInfo = repoInfo;
    this.applicationId = applicationId;
    this.transportSessionId = transportSessionId;
    this.lastSessionId = lastSessionId;
    this.bytesSent = 0;
    this.bytesReceived = 0;
    this.everConnected_ = false;
    this.log_ = logWrapper(connId);
    this.stats_ = StatsManager.getCollection(repoInfo);
    this.urlFn = function(params2) {
      return repoInfo.connectionURL(LONG_POLLING, params2);
    };
  }
  BrowserPollConnection2.prototype.open = function(onMessage, onDisconnect) {
    var _this = this;
    this.curSegmentNum = 0;
    this.onDisconnect_ = onDisconnect;
    this.myPacketOrderer = new PacketReceiver(onMessage);
    this.isClosed_ = false;
    this.connectTimeoutTimer_ = setTimeout(function() {
      _this.log_("Timed out trying to connect.");
      _this.onClosed_();
      _this.connectTimeoutTimer_ = null;
    }, Math.floor(LP_CONNECT_TIMEOUT));
    executeWhenDOMReady(function() {
      if (_this.isClosed_) {
        return;
      }
      _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function() {
        var args = [];
        for (var _i2 = 0; _i2 < arguments.length; _i2++) {
          args[_i2] = arguments[_i2];
        }
        var _a2 = __read(args, 5), command = _a2[0], arg1 = _a2[1], arg2 = _a2[2];
        _a2[3];
        _a2[4];
        _this.incrementIncomingBytes_(args);
        if (!_this.scriptTagHolder) {
          return;
        }
        if (_this.connectTimeoutTimer_) {
          clearTimeout(_this.connectTimeoutTimer_);
          _this.connectTimeoutTimer_ = null;
        }
        _this.everConnected_ = true;
        if (command === FIREBASE_LONGPOLL_START_PARAM) {
          _this.id = arg1;
          _this.password = arg2;
        } else if (command === FIREBASE_LONGPOLL_CLOSE_COMMAND) {
          if (arg1) {
            _this.scriptTagHolder.sendNewPolls = false;
            _this.myPacketOrderer.closeAfter(arg1, function() {
              _this.onClosed_();
            });
          } else {
            _this.onClosed_();
          }
        } else {
          throw new Error("Unrecognized command received: " + command);
        }
      }, function() {
        var args = [];
        for (var _i2 = 0; _i2 < arguments.length; _i2++) {
          args[_i2] = arguments[_i2];
        }
        var _a2 = __read(args, 2), pN2 = _a2[0], data = _a2[1];
        _this.incrementIncomingBytes_(args);
        _this.myPacketOrderer.handleResponse(pN2, data);
      }, function() {
        _this.onClosed_();
      }, _this.urlFn);
      var urlParams = {};
      urlParams[FIREBASE_LONGPOLL_START_PARAM] = "t";
      urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 1e8);
      if (_this.scriptTagHolder.uniqueCallbackIdentifier) {
        urlParams[FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
      }
      urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
      if (_this.transportSessionId) {
        urlParams[TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
      }
      if (_this.lastSessionId) {
        urlParams[LAST_SESSION_PARAM] = _this.lastSessionId;
      }
      if (_this.applicationId) {
        urlParams[APPLICATION_ID_PARAM] = _this.applicationId;
      }
      if (typeof location !== "undefined" && location.href && location.href.indexOf(FORGE_DOMAIN) !== -1) {
        urlParams[REFERER_PARAM] = FORGE_REF;
      }
      var connectURL = _this.urlFn(urlParams);
      _this.log_("Connecting via long-poll to " + connectURL);
      _this.scriptTagHolder.addTag(connectURL, function() {
      });
    });
  };
  BrowserPollConnection2.prototype.start = function() {
    this.scriptTagHolder.startLongPoll(this.id, this.password);
    this.addDisconnectPingFrame(this.id, this.password);
  };
  BrowserPollConnection2.forceAllow = function() {
    BrowserPollConnection2.forceAllow_ = true;
  };
  BrowserPollConnection2.forceDisallow = function() {
    BrowserPollConnection2.forceDisallow_ = true;
  };
  BrowserPollConnection2.isAvailable = function() {
    if (BrowserPollConnection2.forceAllow_) {
      return true;
    } else {
      return !BrowserPollConnection2.forceDisallow_ && typeof document !== "undefined" && document.createElement != null && !isChromeExtensionContentScript() && !isWindowsStoreApp();
    }
  };
  BrowserPollConnection2.prototype.markConnectionHealthy = function() {
  };
  BrowserPollConnection2.prototype.shutdown_ = function() {
    this.isClosed_ = true;
    if (this.scriptTagHolder) {
      this.scriptTagHolder.close();
      this.scriptTagHolder = null;
    }
    if (this.myDisconnFrame) {
      document.body.removeChild(this.myDisconnFrame);
      this.myDisconnFrame = null;
    }
    if (this.connectTimeoutTimer_) {
      clearTimeout(this.connectTimeoutTimer_);
      this.connectTimeoutTimer_ = null;
    }
  };
  BrowserPollConnection2.prototype.onClosed_ = function() {
    if (!this.isClosed_) {
      this.log_("Longpoll is closing itself");
      this.shutdown_();
      if (this.onDisconnect_) {
        this.onDisconnect_(this.everConnected_);
        this.onDisconnect_ = null;
      }
    }
  };
  BrowserPollConnection2.prototype.close = function() {
    if (!this.isClosed_) {
      this.log_("Longpoll is being closed.");
      this.shutdown_();
    }
  };
  BrowserPollConnection2.prototype.send = function(data) {
    var dataStr = stringify(data);
    this.bytesSent += dataStr.length;
    this.stats_.incrementCounter("bytes_sent", dataStr.length);
    var base64data = base64Encode(dataStr);
    var dataSegs = splitStringBySize(base64data, MAX_PAYLOAD_SIZE);
    for (var i = 0; i < dataSegs.length; i++) {
      this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
      this.curSegmentNum++;
    }
  };
  BrowserPollConnection2.prototype.addDisconnectPingFrame = function(id2, pw2) {
    this.myDisconnFrame = document.createElement("iframe");
    var urlParams = {};
    urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = "t";
    urlParams[FIREBASE_LONGPOLL_ID_PARAM] = id2;
    urlParams[FIREBASE_LONGPOLL_PW_PARAM] = pw2;
    this.myDisconnFrame.src = this.urlFn(urlParams);
    this.myDisconnFrame.style.display = "none";
    document.body.appendChild(this.myDisconnFrame);
  };
  BrowserPollConnection2.prototype.incrementIncomingBytes_ = function(args) {
    var bytesReceived = stringify(args).length;
    this.bytesReceived += bytesReceived;
    this.stats_.incrementCounter("bytes_received", bytesReceived);
  };
  return BrowserPollConnection2;
}();
var FirebaseIFrameScriptHolder = function() {
  function FirebaseIFrameScriptHolder2(commandCB, onMessageCB, onDisconnect, urlFn) {
    this.onDisconnect = onDisconnect;
    this.urlFn = urlFn;
    this.outstandingRequests = new Set();
    this.pendingSegs = [];
    this.currentSerial = Math.floor(Math.random() * 1e8);
    this.sendNewPolls = true;
    {
      this.uniqueCallbackIdentifier = LUIDGenerator();
      window[FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
      window[FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
      this.myIFrame = FirebaseIFrameScriptHolder2.createIFrame_();
      var script2 = "";
      if (this.myIFrame.src && this.myIFrame.src.substr(0, "javascript:".length) === "javascript:") {
        var currentDomain = document.domain;
        script2 = '<script>document.domain="' + currentDomain + '";<\/script>';
      }
      var iframeContents = "<html><body>" + script2 + "</body></html>";
      try {
        this.myIFrame.doc.open();
        this.myIFrame.doc.write(iframeContents);
        this.myIFrame.doc.close();
      } catch (e28) {
        log("frame writing exception");
        if (e28.stack) {
          log(e28.stack);
        }
        log(e28);
      }
    }
  }
  FirebaseIFrameScriptHolder2.createIFrame_ = function() {
    var iframe = document.createElement("iframe");
    iframe.style.display = "none";
    if (document.body) {
      document.body.appendChild(iframe);
      try {
        var a3 = iframe.contentWindow.document;
        if (!a3) {
          log("No IE domain setting required");
        }
      } catch (e28) {
        var domain = document.domain;
        iframe.src = "javascript:void((function(){document.open();document.domain='" + domain + "';document.close();})())";
      }
    } else {
      throw "Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
    }
    if (iframe.contentDocument) {
      iframe.doc = iframe.contentDocument;
    } else if (iframe.contentWindow) {
      iframe.doc = iframe.contentWindow.document;
    } else if (iframe.document) {
      iframe.doc = iframe.document;
    }
    return iframe;
  };
  FirebaseIFrameScriptHolder2.prototype.close = function() {
    var _this = this;
    this.alive = false;
    if (this.myIFrame) {
      this.myIFrame.doc.body.innerHTML = "";
      setTimeout(function() {
        if (_this.myIFrame !== null) {
          document.body.removeChild(_this.myIFrame);
          _this.myIFrame = null;
        }
      }, Math.floor(0));
    }
    var onDisconnect = this.onDisconnect;
    if (onDisconnect) {
      this.onDisconnect = null;
      onDisconnect();
    }
  };
  FirebaseIFrameScriptHolder2.prototype.startLongPoll = function(id2, pw2) {
    this.myID = id2;
    this.myPW = pw2;
    this.alive = true;
    while (this.newRequest_()) {
    }
  };
  FirebaseIFrameScriptHolder2.prototype.newRequest_ = function() {
    if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
      this.currentSerial++;
      var urlParams = {};
      urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
      urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
      urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
      var theURL = this.urlFn(urlParams);
      var curDataString = "";
      var i = 0;
      while (this.pendingSegs.length > 0) {
        var nextSeg = this.pendingSegs[0];
        if (nextSeg.d.length + SEG_HEADER_SIZE + curDataString.length <= MAX_URL_DATA_SIZE) {
          var theSeg = this.pendingSegs.shift();
          curDataString = curDataString + "&" + FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM + i + "=" + theSeg.seg + "&" + FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET + i + "=" + theSeg.ts + "&" + FIREBASE_LONGPOLL_DATA_PARAM + i + "=" + theSeg.d;
          i++;
        } else {
          break;
        }
      }
      theURL = theURL + curDataString;
      this.addLongPollTag_(theURL, this.currentSerial);
      return true;
    } else {
      return false;
    }
  };
  FirebaseIFrameScriptHolder2.prototype.enqueueSegment = function(segnum, totalsegs, data) {
    this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
    if (this.alive) {
      this.newRequest_();
    }
  };
  FirebaseIFrameScriptHolder2.prototype.addLongPollTag_ = function(url, serial) {
    var _this = this;
    this.outstandingRequests.add(serial);
    var doNewRequest = function() {
      _this.outstandingRequests.delete(serial);
      _this.newRequest_();
    };
    var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
    var readyStateCB = function() {
      clearTimeout(keepaliveTimeout);
      doNewRequest();
    };
    this.addTag(url, readyStateCB);
  };
  FirebaseIFrameScriptHolder2.prototype.addTag = function(url, loadCB) {
    var _this = this;
    {
      setTimeout(function() {
        try {
          if (!_this.sendNewPolls) {
            return;
          }
          var newScript_1 = _this.myIFrame.doc.createElement("script");
          newScript_1.type = "text/javascript";
          newScript_1.async = true;
          newScript_1.src = url;
          newScript_1.onload = newScript_1.onreadystatechange = function() {
            var rstate = newScript_1.readyState;
            if (!rstate || rstate === "loaded" || rstate === "complete") {
              newScript_1.onload = newScript_1.onreadystatechange = null;
              if (newScript_1.parentNode) {
                newScript_1.parentNode.removeChild(newScript_1);
              }
              loadCB();
            }
          };
          newScript_1.onerror = function() {
            log("Long-poll script failed to load: " + url);
            _this.sendNewPolls = false;
            _this.close();
          };
          _this.myIFrame.doc.body.appendChild(newScript_1);
        } catch (e28) {
        }
      }, Math.floor(1));
    }
  };
  return FirebaseIFrameScriptHolder2;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SDK_VERSION$1 = "";
function setSDKVersion(version2) {
  SDK_VERSION$1 = version2;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WEBSOCKET_MAX_FRAME_SIZE = 16384;
var WEBSOCKET_KEEPALIVE_INTERVAL = 45e3;
var WebSocketImpl = null;
if (typeof MozWebSocket !== "undefined") {
  WebSocketImpl = MozWebSocket;
} else if (typeof WebSocket !== "undefined") {
  WebSocketImpl = WebSocket;
}
var WebSocketConnection = function() {
  function WebSocketConnection2(connId, repoInfo, applicationId, transportSessionId, lastSessionId) {
    this.connId = connId;
    this.applicationId = applicationId;
    this.keepaliveTimer = null;
    this.frames = null;
    this.totalFrames = 0;
    this.bytesSent = 0;
    this.bytesReceived = 0;
    this.log_ = logWrapper(this.connId);
    this.stats_ = StatsManager.getCollection(repoInfo);
    this.connURL = WebSocketConnection2.connectionURL_(repoInfo, transportSessionId, lastSessionId);
    this.nodeAdmin = repoInfo.nodeAdmin;
  }
  WebSocketConnection2.connectionURL_ = function(repoInfo, transportSessionId, lastSessionId) {
    var urlParams = {};
    urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
    if (typeof location !== "undefined" && location.href && location.href.indexOf(FORGE_DOMAIN) !== -1) {
      urlParams[REFERER_PARAM] = FORGE_REF;
    }
    if (transportSessionId) {
      urlParams[TRANSPORT_SESSION_PARAM] = transportSessionId;
    }
    if (lastSessionId) {
      urlParams[LAST_SESSION_PARAM] = lastSessionId;
    }
    return repoInfo.connectionURL(WEBSOCKET, urlParams);
  };
  WebSocketConnection2.prototype.open = function(onMessage, onDisconnect) {
    var _this = this;
    this.onDisconnect = onDisconnect;
    this.onMessage = onMessage;
    this.log_("Websocket connecting to " + this.connURL);
    this.everConnected_ = false;
    PersistentStorage.set("previous_websocket_failure", true);
    try {
      var device, options, env, proxy;
      if (isNodeSdk())
        ;
      else {
        var options = {
          headers: {
            "X-Firebase-GMPID": this.applicationId || ""
          }
        };
        this.mySock = new WebSocketImpl(this.connURL, [], options);
      }
    } catch (e28) {
      this.log_("Error instantiating WebSocket.");
      var error2 = e28.message || e28.data;
      if (error2) {
        this.log_(error2);
      }
      this.onClosed_();
      return;
    }
    this.mySock.onopen = function() {
      _this.log_("Websocket connected.");
      _this.everConnected_ = true;
    };
    this.mySock.onclose = function() {
      _this.log_("Websocket connection was disconnected.");
      _this.mySock = null;
      _this.onClosed_();
    };
    this.mySock.onmessage = function(m3) {
      _this.handleIncomingFrame(m3);
    };
    this.mySock.onerror = function(e28) {
      _this.log_("WebSocket error.  Closing connection.");
      var error3 = e28.message || e28.data;
      if (error3) {
        _this.log_(error3);
      }
      _this.onClosed_();
    };
  };
  WebSocketConnection2.prototype.start = function() {
  };
  WebSocketConnection2.forceDisallow = function() {
    WebSocketConnection2.forceDisallow_ = true;
  };
  WebSocketConnection2.isAvailable = function() {
    var isOldAndroid = false;
    if (typeof navigator !== "undefined" && navigator.userAgent) {
      var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
      var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
      if (oldAndroidMatch && oldAndroidMatch.length > 1) {
        if (parseFloat(oldAndroidMatch[1]) < 4.4) {
          isOldAndroid = true;
        }
      }
    }
    return !isOldAndroid && WebSocketImpl !== null && !WebSocketConnection2.forceDisallow_;
  };
  WebSocketConnection2.previouslyFailed = function() {
    return PersistentStorage.isInMemoryStorage || PersistentStorage.get("previous_websocket_failure") === true;
  };
  WebSocketConnection2.prototype.markConnectionHealthy = function() {
    PersistentStorage.remove("previous_websocket_failure");
  };
  WebSocketConnection2.prototype.appendFrame_ = function(data) {
    this.frames.push(data);
    if (this.frames.length === this.totalFrames) {
      var fullMess = this.frames.join("");
      this.frames = null;
      var jsonMess = jsonEval(fullMess);
      this.onMessage(jsonMess);
    }
  };
  WebSocketConnection2.prototype.handleNewFrameCount_ = function(frameCount) {
    this.totalFrames = frameCount;
    this.frames = [];
  };
  WebSocketConnection2.prototype.extractFrameCount_ = function(data) {
    assert(this.frames === null, "We already have a frame buffer");
    if (data.length <= 6) {
      var frameCount = Number(data);
      if (!isNaN(frameCount)) {
        this.handleNewFrameCount_(frameCount);
        return null;
      }
    }
    this.handleNewFrameCount_(1);
    return data;
  };
  WebSocketConnection2.prototype.handleIncomingFrame = function(mess) {
    if (this.mySock === null) {
      return;
    }
    var data = mess["data"];
    this.bytesReceived += data.length;
    this.stats_.incrementCounter("bytes_received", data.length);
    this.resetKeepAlive();
    if (this.frames !== null) {
      this.appendFrame_(data);
    } else {
      var remainingData = this.extractFrameCount_(data);
      if (remainingData !== null) {
        this.appendFrame_(remainingData);
      }
    }
  };
  WebSocketConnection2.prototype.send = function(data) {
    this.resetKeepAlive();
    var dataStr = stringify(data);
    this.bytesSent += dataStr.length;
    this.stats_.incrementCounter("bytes_sent", dataStr.length);
    var dataSegs = splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
    if (dataSegs.length > 1) {
      this.sendString_(String(dataSegs.length));
    }
    for (var i = 0; i < dataSegs.length; i++) {
      this.sendString_(dataSegs[i]);
    }
  };
  WebSocketConnection2.prototype.shutdown_ = function() {
    this.isClosed_ = true;
    if (this.keepaliveTimer) {
      clearInterval(this.keepaliveTimer);
      this.keepaliveTimer = null;
    }
    if (this.mySock) {
      this.mySock.close();
      this.mySock = null;
    }
  };
  WebSocketConnection2.prototype.onClosed_ = function() {
    if (!this.isClosed_) {
      this.log_("WebSocket is closing itself");
      this.shutdown_();
      if (this.onDisconnect) {
        this.onDisconnect(this.everConnected_);
        this.onDisconnect = null;
      }
    }
  };
  WebSocketConnection2.prototype.close = function() {
    if (!this.isClosed_) {
      this.log_("WebSocket is being closed");
      this.shutdown_();
    }
  };
  WebSocketConnection2.prototype.resetKeepAlive = function() {
    var _this = this;
    clearInterval(this.keepaliveTimer);
    this.keepaliveTimer = setInterval(function() {
      if (_this.mySock) {
        _this.sendString_("0");
      }
      _this.resetKeepAlive();
    }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
  };
  WebSocketConnection2.prototype.sendString_ = function(str) {
    try {
      this.mySock.send(str);
    } catch (e28) {
      this.log_("Exception thrown from WebSocket.send():", e28.message || e28.data, "Closing connection.");
      setTimeout(this.onClosed_.bind(this), 0);
    }
  };
  WebSocketConnection2.responsesRequiredToBeHealthy = 2;
  WebSocketConnection2.healthyTimeout = 3e4;
  return WebSocketConnection2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TransportManager = function() {
  function TransportManager2(repoInfo) {
    this.initTransports_(repoInfo);
  }
  Object.defineProperty(TransportManager2, "ALL_TRANSPORTS", {
    get: function() {
      return [BrowserPollConnection, WebSocketConnection];
    },
    enumerable: false,
    configurable: true
  });
  TransportManager2.prototype.initTransports_ = function(repoInfo) {
    var e_1, _a2;
    var isWebSocketsAvailable2 = WebSocketConnection && WebSocketConnection["isAvailable"]();
    var isSkipPollConnection = isWebSocketsAvailable2 && !WebSocketConnection.previouslyFailed();
    if (repoInfo.webSocketOnly) {
      if (!isWebSocketsAvailable2) {
        warn$2("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
      }
      isSkipPollConnection = true;
    }
    if (isSkipPollConnection) {
      this.transports_ = [WebSocketConnection];
    } else {
      var transports = this.transports_ = [];
      try {
        for (var _b2 = __values$1(TransportManager2.ALL_TRANSPORTS), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
          var transport = _c2.value;
          if (transport && transport["isAvailable"]()) {
            transports.push(transport);
          }
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (_c2 && !_c2.done && (_a2 = _b2.return))
            _a2.call(_b2);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
    }
  };
  TransportManager2.prototype.initialTransport = function() {
    if (this.transports_.length > 0) {
      return this.transports_[0];
    } else {
      throw new Error("No transports available");
    }
  };
  TransportManager2.prototype.upgradeTransport = function() {
    if (this.transports_.length > 1) {
      return this.transports_[1];
    } else {
      return null;
    }
  };
  return TransportManager2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var UPGRADE_TIMEOUT = 6e4;
var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5e3;
var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
var MESSAGE_TYPE = "t";
var MESSAGE_DATA = "d";
var CONTROL_SHUTDOWN = "s";
var CONTROL_RESET = "r";
var CONTROL_ERROR = "e";
var CONTROL_PONG = "o";
var SWITCH_ACK = "a";
var END_TRANSMISSION = "n";
var PING = "p";
var SERVER_HELLO = "h";
var Connection = function() {
  function Connection2(id2, repoInfo_, applicationId_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
    this.id = id2;
    this.repoInfo_ = repoInfo_;
    this.applicationId_ = applicationId_;
    this.onMessage_ = onMessage_;
    this.onReady_ = onReady_;
    this.onDisconnect_ = onDisconnect_;
    this.onKill_ = onKill_;
    this.lastSessionId = lastSessionId;
    this.connectionCount = 0;
    this.pendingDataMessages = [];
    this.state_ = 0;
    this.log_ = logWrapper("c:" + this.id + ":");
    this.transportManager_ = new TransportManager(repoInfo_);
    this.log_("Connection created");
    this.start_();
  }
  Connection2.prototype.start_ = function() {
    var _this = this;
    var conn = this.transportManager_.initialTransport();
    this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, void 0, this.lastSessionId);
    this.primaryResponsesRequired_ = conn["responsesRequiredToBeHealthy"] || 0;
    var onMessageReceived = this.connReceiver_(this.conn_);
    var onConnectionLost = this.disconnReceiver_(this.conn_);
    this.tx_ = this.conn_;
    this.rx_ = this.conn_;
    this.secondaryConn_ = null;
    this.isHealthy_ = false;
    setTimeout(function() {
      _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
    }, Math.floor(0));
    var healthyTimeoutMS = conn["healthyTimeout"] || 0;
    if (healthyTimeoutMS > 0) {
      this.healthyTimeout_ = setTimeoutNonBlocking(function() {
        _this.healthyTimeout_ = null;
        if (!_this.isHealthy_) {
          if (_this.conn_ && _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
            _this.log_("Connection exceeded healthy timeout but has received " + _this.conn_.bytesReceived + " bytes.  Marking connection healthy.");
            _this.isHealthy_ = true;
            _this.conn_.markConnectionHealthy();
          } else if (_this.conn_ && _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
            _this.log_("Connection exceeded healthy timeout but has sent " + _this.conn_.bytesSent + " bytes.  Leaving connection alive.");
          } else {
            _this.log_("Closing unhealthy connection after timeout.");
            _this.close();
          }
        }
      }, Math.floor(healthyTimeoutMS));
    }
  };
  Connection2.prototype.nextTransportId_ = function() {
    return "c:" + this.id + ":" + this.connectionCount++;
  };
  Connection2.prototype.disconnReceiver_ = function(conn) {
    var _this = this;
    return function(everConnected) {
      if (conn === _this.conn_) {
        _this.onConnectionLost_(everConnected);
      } else if (conn === _this.secondaryConn_) {
        _this.log_("Secondary connection lost.");
        _this.onSecondaryConnectionLost_();
      } else {
        _this.log_("closing an old connection");
      }
    };
  };
  Connection2.prototype.connReceiver_ = function(conn) {
    var _this = this;
    return function(message) {
      if (_this.state_ !== 2) {
        if (conn === _this.rx_) {
          _this.onPrimaryMessageReceived_(message);
        } else if (conn === _this.secondaryConn_) {
          _this.onSecondaryMessageReceived_(message);
        } else {
          _this.log_("message on old connection");
        }
      }
    };
  };
  Connection2.prototype.sendRequest = function(dataMsg) {
    var msg = { t: "d", d: dataMsg };
    this.sendData_(msg);
  };
  Connection2.prototype.tryCleanupConnection = function() {
    if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
      this.log_("cleaning up and promoting a connection: " + this.secondaryConn_.connId);
      this.conn_ = this.secondaryConn_;
      this.secondaryConn_ = null;
    }
  };
  Connection2.prototype.onSecondaryControl_ = function(controlData) {
    if (MESSAGE_TYPE in controlData) {
      var cmd = controlData[MESSAGE_TYPE];
      if (cmd === SWITCH_ACK) {
        this.upgradeIfSecondaryHealthy_();
      } else if (cmd === CONTROL_RESET) {
        this.log_("Got a reset on secondary, closing it");
        this.secondaryConn_.close();
        if (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) {
          this.close();
        }
      } else if (cmd === CONTROL_PONG) {
        this.log_("got pong on secondary.");
        this.secondaryResponsesRequired_--;
        this.upgradeIfSecondaryHealthy_();
      }
    }
  };
  Connection2.prototype.onSecondaryMessageReceived_ = function(parsedData) {
    var layer = requireKey("t", parsedData);
    var data = requireKey("d", parsedData);
    if (layer === "c") {
      this.onSecondaryControl_(data);
    } else if (layer === "d") {
      this.pendingDataMessages.push(data);
    } else {
      throw new Error("Unknown protocol layer: " + layer);
    }
  };
  Connection2.prototype.upgradeIfSecondaryHealthy_ = function() {
    if (this.secondaryResponsesRequired_ <= 0) {
      this.log_("Secondary connection is healthy.");
      this.isHealthy_ = true;
      this.secondaryConn_.markConnectionHealthy();
      this.proceedWithUpgrade_();
    } else {
      this.log_("sending ping on secondary.");
      this.secondaryConn_.send({ t: "c", d: { t: PING, d: {} } });
    }
  };
  Connection2.prototype.proceedWithUpgrade_ = function() {
    this.secondaryConn_.start();
    this.log_("sending client ack on secondary");
    this.secondaryConn_.send({ t: "c", d: { t: SWITCH_ACK, d: {} } });
    this.log_("Ending transmission on primary");
    this.conn_.send({ t: "c", d: { t: END_TRANSMISSION, d: {} } });
    this.tx_ = this.secondaryConn_;
    this.tryCleanupConnection();
  };
  Connection2.prototype.onPrimaryMessageReceived_ = function(parsedData) {
    var layer = requireKey("t", parsedData);
    var data = requireKey("d", parsedData);
    if (layer === "c") {
      this.onControl_(data);
    } else if (layer === "d") {
      this.onDataMessage_(data);
    }
  };
  Connection2.prototype.onDataMessage_ = function(message) {
    this.onPrimaryResponse_();
    this.onMessage_(message);
  };
  Connection2.prototype.onPrimaryResponse_ = function() {
    if (!this.isHealthy_) {
      this.primaryResponsesRequired_--;
      if (this.primaryResponsesRequired_ <= 0) {
        this.log_("Primary connection is healthy.");
        this.isHealthy_ = true;
        this.conn_.markConnectionHealthy();
      }
    }
  };
  Connection2.prototype.onControl_ = function(controlData) {
    var cmd = requireKey(MESSAGE_TYPE, controlData);
    if (MESSAGE_DATA in controlData) {
      var payload = controlData[MESSAGE_DATA];
      if (cmd === SERVER_HELLO) {
        this.onHandshake_(payload);
      } else if (cmd === END_TRANSMISSION) {
        this.log_("recvd end transmission on primary");
        this.rx_ = this.secondaryConn_;
        for (var i = 0; i < this.pendingDataMessages.length; ++i) {
          this.onDataMessage_(this.pendingDataMessages[i]);
        }
        this.pendingDataMessages = [];
        this.tryCleanupConnection();
      } else if (cmd === CONTROL_SHUTDOWN) {
        this.onConnectionShutdown_(payload);
      } else if (cmd === CONTROL_RESET) {
        this.onReset_(payload);
      } else if (cmd === CONTROL_ERROR) {
        error("Server Error: " + payload);
      } else if (cmd === CONTROL_PONG) {
        this.log_("got pong on primary.");
        this.onPrimaryResponse_();
        this.sendPingOnPrimaryIfNecessary_();
      } else {
        error("Unknown control packet command: " + cmd);
      }
    }
  };
  Connection2.prototype.onHandshake_ = function(handshake) {
    var timestamp = handshake.ts;
    var version2 = handshake.v;
    var host = handshake.h;
    this.sessionId = handshake.s;
    this.repoInfo_.updateHost(host);
    if (this.state_ === 0) {
      this.conn_.start();
      this.onConnectionEstablished_(this.conn_, timestamp);
      if (PROTOCOL_VERSION !== version2) {
        warn$2("Protocol version mismatch detected");
      }
      this.tryStartUpgrade_();
    }
  };
  Connection2.prototype.tryStartUpgrade_ = function() {
    var conn = this.transportManager_.upgradeTransport();
    if (conn) {
      this.startUpgrade_(conn);
    }
  };
  Connection2.prototype.startUpgrade_ = function(conn) {
    var _this = this;
    this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.sessionId);
    this.secondaryResponsesRequired_ = conn["responsesRequiredToBeHealthy"] || 0;
    var onMessage = this.connReceiver_(this.secondaryConn_);
    var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
    this.secondaryConn_.open(onMessage, onDisconnect);
    setTimeoutNonBlocking(function() {
      if (_this.secondaryConn_) {
        _this.log_("Timed out trying to upgrade.");
        _this.secondaryConn_.close();
      }
    }, Math.floor(UPGRADE_TIMEOUT));
  };
  Connection2.prototype.onReset_ = function(host) {
    this.log_("Reset packet received.  New host: " + host);
    this.repoInfo_.updateHost(host);
    if (this.state_ === 1) {
      this.close();
    } else {
      this.closeConnections_();
      this.start_();
    }
  };
  Connection2.prototype.onConnectionEstablished_ = function(conn, timestamp) {
    var _this = this;
    this.log_("Realtime connection established.");
    this.conn_ = conn;
    this.state_ = 1;
    if (this.onReady_) {
      this.onReady_(timestamp, this.sessionId);
      this.onReady_ = null;
    }
    if (this.primaryResponsesRequired_ === 0) {
      this.log_("Primary connection is healthy.");
      this.isHealthy_ = true;
    } else {
      setTimeoutNonBlocking(function() {
        _this.sendPingOnPrimaryIfNecessary_();
      }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
    }
  };
  Connection2.prototype.sendPingOnPrimaryIfNecessary_ = function() {
    if (!this.isHealthy_ && this.state_ === 1) {
      this.log_("sending ping on primary.");
      this.sendData_({ t: "c", d: { t: PING, d: {} } });
    }
  };
  Connection2.prototype.onSecondaryConnectionLost_ = function() {
    var conn = this.secondaryConn_;
    this.secondaryConn_ = null;
    if (this.tx_ === conn || this.rx_ === conn) {
      this.close();
    }
  };
  Connection2.prototype.onConnectionLost_ = function(everConnected) {
    this.conn_ = null;
    if (!everConnected && this.state_ === 0) {
      this.log_("Realtime connection failed.");
      if (this.repoInfo_.isCacheableHost()) {
        PersistentStorage.remove("host:" + this.repoInfo_.host);
        this.repoInfo_.internalHost = this.repoInfo_.host;
      }
    } else if (this.state_ === 1) {
      this.log_("Realtime connection lost.");
    }
    this.close();
  };
  Connection2.prototype.onConnectionShutdown_ = function(reason) {
    this.log_("Connection shutdown command received. Shutting down...");
    if (this.onKill_) {
      this.onKill_(reason);
      this.onKill_ = null;
    }
    this.onDisconnect_ = null;
    this.close();
  };
  Connection2.prototype.sendData_ = function(data) {
    if (this.state_ !== 1) {
      throw "Connection is not connected";
    } else {
      this.tx_.send(data);
    }
  };
  Connection2.prototype.close = function() {
    if (this.state_ !== 2) {
      this.log_("Closing realtime connection.");
      this.state_ = 2;
      this.closeConnections_();
      if (this.onDisconnect_) {
        this.onDisconnect_();
        this.onDisconnect_ = null;
      }
    }
  };
  Connection2.prototype.closeConnections_ = function() {
    this.log_("Shutting down all connections");
    if (this.conn_) {
      this.conn_.close();
      this.conn_ = null;
    }
    if (this.secondaryConn_) {
      this.secondaryConn_.close();
      this.secondaryConn_ = null;
    }
    if (this.healthyTimeout_) {
      clearTimeout(this.healthyTimeout_);
      this.healthyTimeout_ = null;
    }
  };
  return Connection2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ServerActions = function() {
  function ServerActions2() {
  }
  ServerActions2.prototype.put = function(pathString, data, onComplete, hash) {
  };
  ServerActions2.prototype.merge = function(pathString, data, onComplete, hash) {
  };
  ServerActions2.prototype.refreshAuthToken = function(token2) {
  };
  ServerActions2.prototype.onDisconnectPut = function(pathString, data, onComplete) {
  };
  ServerActions2.prototype.onDisconnectMerge = function(pathString, data, onComplete) {
  };
  ServerActions2.prototype.onDisconnectCancel = function(pathString, onComplete) {
  };
  ServerActions2.prototype.reportStats = function(stats2) {
  };
  return ServerActions2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RECONNECT_MIN_DELAY = 1e3;
var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1e3;
var GET_CONNECT_TIMEOUT = 3 * 1e3;
var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1e3;
var RECONNECT_DELAY_MULTIPLIER = 1.3;
var RECONNECT_DELAY_RESET_TIMEOUT = 3e4;
var SERVER_KILL_INTERRUPT_REASON = "server_kill";
var INVALID_AUTH_TOKEN_THRESHOLD = 3;
var PersistentConnection = function(_super) {
  __extends$1(PersistentConnection2, _super);
  function PersistentConnection2(repoInfo_, applicationId_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
    var _this = _super.call(this) || this;
    _this.repoInfo_ = repoInfo_;
    _this.applicationId_ = applicationId_;
    _this.onDataUpdate_ = onDataUpdate_;
    _this.onConnectStatus_ = onConnectStatus_;
    _this.onServerInfoUpdate_ = onServerInfoUpdate_;
    _this.authTokenProvider_ = authTokenProvider_;
    _this.authOverride_ = authOverride_;
    _this.id = PersistentConnection2.nextPersistentConnectionId_++;
    _this.log_ = logWrapper("p:" + _this.id + ":");
    _this.interruptReasons_ = {};
    _this.listens = new Map();
    _this.outstandingPuts_ = [];
    _this.outstandingGets_ = [];
    _this.outstandingPutCount_ = 0;
    _this.outstandingGetCount_ = 0;
    _this.onDisconnectRequestQueue_ = [];
    _this.connected_ = false;
    _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
    _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
    _this.securityDebugCallback_ = null;
    _this.lastSessionId = null;
    _this.establishConnectionTimer_ = null;
    _this.visible_ = false;
    _this.requestCBHash_ = {};
    _this.requestNumber_ = 0;
    _this.realtime_ = null;
    _this.authToken_ = null;
    _this.forceTokenRefresh_ = false;
    _this.invalidAuthTokenCount_ = 0;
    _this.firstConnection_ = true;
    _this.lastConnectionAttemptTime_ = null;
    _this.lastConnectionEstablishedTime_ = null;
    if (authOverride_ && !isNodeSdk()) {
      throw new Error("Auth override specified in options, but not supported on non Node.js platforms");
    }
    _this.scheduleConnect_(0);
    VisibilityMonitor.getInstance().on("visible", _this.onVisible_, _this);
    if (repoInfo_.host.indexOf("fblocal") === -1) {
      OnlineMonitor.getInstance().on("online", _this.onOnline_, _this);
    }
    return _this;
  }
  PersistentConnection2.prototype.sendRequest = function(action, body, onResponse) {
    var curReqNum = ++this.requestNumber_;
    var msg = { r: curReqNum, a: action, b: body };
    this.log_(stringify(msg));
    assert(this.connected_, "sendRequest call when we're not connected not allowed.");
    this.realtime_.sendRequest(msg);
    if (onResponse) {
      this.requestCBHash_[curReqNum] = onResponse;
    }
  };
  PersistentConnection2.prototype.get = function(query2) {
    var _this = this;
    var deferred = new Deferred();
    var request = {
      p: query2.path.toString(),
      q: query2.queryObject()
    };
    var outstandingGet = {
      action: "g",
      request,
      onComplete: function(message) {
        var payload = message["d"];
        if (message["s"] === "ok") {
          _this.onDataUpdate_(request["p"], payload, false, null);
          deferred.resolve(payload);
        } else {
          deferred.reject(payload);
        }
      }
    };
    this.outstandingGets_.push(outstandingGet);
    this.outstandingGetCount_++;
    var index = this.outstandingGets_.length - 1;
    if (!this.connected_) {
      setTimeout(function() {
        var get2 = _this.outstandingGets_[index];
        if (get2 === void 0 || outstandingGet !== get2) {
          return;
        }
        delete _this.outstandingGets_[index];
        _this.outstandingGetCount_--;
        if (_this.outstandingGetCount_ === 0) {
          _this.outstandingGets_ = [];
        }
        _this.log_("get " + index + " timed out on connection");
        deferred.reject(new Error("Client is offline."));
      }, GET_CONNECT_TIMEOUT);
    }
    if (this.connected_) {
      this.sendGet_(index);
    }
    return deferred.promise;
  };
  PersistentConnection2.prototype.listen = function(query2, currentHashFn, tag, onComplete) {
    var queryId = query2.queryIdentifier();
    var pathString = query2.path.toString();
    this.log_("Listen called for " + pathString + " " + queryId);
    if (!this.listens.has(pathString)) {
      this.listens.set(pathString, new Map());
    }
    assert(query2.getQueryParams().isDefault() || !query2.getQueryParams().loadsAllData(), "listen() called for non-default but complete query");
    assert(!this.listens.get(pathString).has(queryId), "listen() called twice for same path/queryId.");
    var listenSpec = {
      onComplete,
      hashFn: currentHashFn,
      query: query2,
      tag
    };
    this.listens.get(pathString).set(queryId, listenSpec);
    if (this.connected_) {
      this.sendListen_(listenSpec);
    }
  };
  PersistentConnection2.prototype.sendGet_ = function(index) {
    var _this = this;
    var get2 = this.outstandingGets_[index];
    this.sendRequest("g", get2.request, function(message) {
      delete _this.outstandingGets_[index];
      _this.outstandingGetCount_--;
      if (_this.outstandingGetCount_ === 0) {
        _this.outstandingGets_ = [];
      }
      if (get2.onComplete) {
        get2.onComplete(message);
      }
    });
  };
  PersistentConnection2.prototype.sendListen_ = function(listenSpec) {
    var _this = this;
    var query2 = listenSpec.query;
    var pathString = query2.path.toString();
    var queryId = query2.queryIdentifier();
    this.log_("Listen on " + pathString + " for " + queryId);
    var req = { p: pathString };
    var action = "q";
    if (listenSpec.tag) {
      req["q"] = query2.queryObject();
      req["t"] = listenSpec.tag;
    }
    req["h"] = listenSpec.hashFn();
    this.sendRequest(action, req, function(message) {
      var payload = message["d"];
      var status = message["s"];
      PersistentConnection2.warnOnListenWarnings_(payload, query2);
      var currentListenSpec = _this.listens.get(pathString) && _this.listens.get(pathString).get(queryId);
      if (currentListenSpec === listenSpec) {
        _this.log_("listen response", message);
        if (status !== "ok") {
          _this.removeListen_(pathString, queryId);
        }
        if (listenSpec.onComplete) {
          listenSpec.onComplete(status, payload);
        }
      }
    });
  };
  PersistentConnection2.warnOnListenWarnings_ = function(payload, query2) {
    if (payload && typeof payload === "object" && contains(payload, "w")) {
      var warnings = safeGet(payload, "w");
      if (Array.isArray(warnings) && ~warnings.indexOf("no_index")) {
        var indexSpec = '".indexOn": "' + query2.getQueryParams().getIndex().toString() + '"';
        var indexPath = query2.path.toString();
        warn$2("Using an unspecified index. Your data will be downloaded and " + ("filtered on the client. Consider adding " + indexSpec + " at ") + (indexPath + " to your security rules for better performance."));
      }
    }
  };
  PersistentConnection2.prototype.refreshAuthToken = function(token2) {
    this.authToken_ = token2;
    this.log_("Auth token refreshed");
    if (this.authToken_) {
      this.tryAuth();
    } else {
      if (this.connected_) {
        this.sendRequest("unauth", {}, function() {
        });
      }
    }
    this.reduceReconnectDelayIfAdminCredential_(token2);
  };
  PersistentConnection2.prototype.reduceReconnectDelayIfAdminCredential_ = function(credential) {
    var isFirebaseSecret = credential && credential.length === 40;
    if (isFirebaseSecret || isAdmin(credential)) {
      this.log_("Admin auth credential detected.  Reducing max reconnect time.");
      this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
    }
  };
  PersistentConnection2.prototype.tryAuth = function() {
    var _this = this;
    if (this.connected_ && this.authToken_) {
      var token_1 = this.authToken_;
      var authMethod = isValidFormat(token_1) ? "auth" : "gauth";
      var requestData = { cred: token_1 };
      if (this.authOverride_ === null) {
        requestData["noauth"] = true;
      } else if (typeof this.authOverride_ === "object") {
        requestData["authvar"] = this.authOverride_;
      }
      this.sendRequest(authMethod, requestData, function(res) {
        var status = res["s"];
        var data = res["d"] || "error";
        if (_this.authToken_ === token_1) {
          if (status === "ok") {
            _this.invalidAuthTokenCount_ = 0;
          } else {
            _this.onAuthRevoked_(status, data);
          }
        }
      });
    }
  };
  PersistentConnection2.prototype.unlisten = function(query2, tag) {
    var pathString = query2.path.toString();
    var queryId = query2.queryIdentifier();
    this.log_("Unlisten called for " + pathString + " " + queryId);
    assert(query2.getQueryParams().isDefault() || !query2.getQueryParams().loadsAllData(), "unlisten() called for non-default but complete query");
    var listen = this.removeListen_(pathString, queryId);
    if (listen && this.connected_) {
      this.sendUnlisten_(pathString, queryId, query2.queryObject(), tag);
    }
  };
  PersistentConnection2.prototype.sendUnlisten_ = function(pathString, queryId, queryObj, tag) {
    this.log_("Unlisten on " + pathString + " for " + queryId);
    var req = { p: pathString };
    var action = "n";
    if (tag) {
      req["q"] = queryObj;
      req["t"] = tag;
    }
    this.sendRequest(action, req);
  };
  PersistentConnection2.prototype.onDisconnectPut = function(pathString, data, onComplete) {
    if (this.connected_) {
      this.sendOnDisconnect_("o", pathString, data, onComplete);
    } else {
      this.onDisconnectRequestQueue_.push({
        pathString,
        action: "o",
        data,
        onComplete
      });
    }
  };
  PersistentConnection2.prototype.onDisconnectMerge = function(pathString, data, onComplete) {
    if (this.connected_) {
      this.sendOnDisconnect_("om", pathString, data, onComplete);
    } else {
      this.onDisconnectRequestQueue_.push({
        pathString,
        action: "om",
        data,
        onComplete
      });
    }
  };
  PersistentConnection2.prototype.onDisconnectCancel = function(pathString, onComplete) {
    if (this.connected_) {
      this.sendOnDisconnect_("oc", pathString, null, onComplete);
    } else {
      this.onDisconnectRequestQueue_.push({
        pathString,
        action: "oc",
        data: null,
        onComplete
      });
    }
  };
  PersistentConnection2.prototype.sendOnDisconnect_ = function(action, pathString, data, onComplete) {
    var request = { p: pathString, d: data };
    this.log_("onDisconnect " + action, request);
    this.sendRequest(action, request, function(response) {
      if (onComplete) {
        setTimeout(function() {
          onComplete(response["s"], response["d"]);
        }, Math.floor(0));
      }
    });
  };
  PersistentConnection2.prototype.put = function(pathString, data, onComplete, hash) {
    this.putInternal("p", pathString, data, onComplete, hash);
  };
  PersistentConnection2.prototype.merge = function(pathString, data, onComplete, hash) {
    this.putInternal("m", pathString, data, onComplete, hash);
  };
  PersistentConnection2.prototype.putInternal = function(action, pathString, data, onComplete, hash) {
    var request = {
      p: pathString,
      d: data
    };
    if (hash !== void 0) {
      request["h"] = hash;
    }
    this.outstandingPuts_.push({
      action,
      request,
      onComplete
    });
    this.outstandingPutCount_++;
    var index = this.outstandingPuts_.length - 1;
    if (this.connected_) {
      this.sendPut_(index);
    } else {
      this.log_("Buffering put: " + pathString);
    }
  };
  PersistentConnection2.prototype.sendPut_ = function(index) {
    var _this = this;
    var action = this.outstandingPuts_[index].action;
    var request = this.outstandingPuts_[index].request;
    var onComplete = this.outstandingPuts_[index].onComplete;
    this.outstandingPuts_[index].queued = this.connected_;
    this.sendRequest(action, request, function(message) {
      _this.log_(action + " response", message);
      delete _this.outstandingPuts_[index];
      _this.outstandingPutCount_--;
      if (_this.outstandingPutCount_ === 0) {
        _this.outstandingPuts_ = [];
      }
      if (onComplete) {
        onComplete(message["s"], message["d"]);
      }
    });
  };
  PersistentConnection2.prototype.reportStats = function(stats2) {
    var _this = this;
    if (this.connected_) {
      var request = { c: stats2 };
      this.log_("reportStats", request);
      this.sendRequest("s", request, function(result2) {
        var status = result2["s"];
        if (status !== "ok") {
          var errorReason = result2["d"];
          _this.log_("reportStats", "Error sending stats: " + errorReason);
        }
      });
    }
  };
  PersistentConnection2.prototype.onDataMessage_ = function(message) {
    if ("r" in message) {
      this.log_("from server: " + stringify(message));
      var reqNum = message["r"];
      var onResponse = this.requestCBHash_[reqNum];
      if (onResponse) {
        delete this.requestCBHash_[reqNum];
        onResponse(message["b"]);
      }
    } else if ("error" in message) {
      throw "A server-side error has occurred: " + message["error"];
    } else if ("a" in message) {
      this.onDataPush_(message["a"], message["b"]);
    }
  };
  PersistentConnection2.prototype.onDataPush_ = function(action, body) {
    this.log_("handleServerMessage", action, body);
    if (action === "d") {
      this.onDataUpdate_(body["p"], body["d"], false, body["t"]);
    } else if (action === "m") {
      this.onDataUpdate_(body["p"], body["d"], true, body["t"]);
    } else if (action === "c") {
      this.onListenRevoked_(body["p"], body["q"]);
    } else if (action === "ac") {
      this.onAuthRevoked_(body["s"], body["d"]);
    } else if (action === "sd") {
      this.onSecurityDebugPacket_(body);
    } else {
      error("Unrecognized action received from server: " + stringify(action) + "\nAre you using the latest client?");
    }
  };
  PersistentConnection2.prototype.onReady_ = function(timestamp, sessionId) {
    this.log_("connection ready");
    this.connected_ = true;
    this.lastConnectionEstablishedTime_ = new Date().getTime();
    this.handleTimestamp_(timestamp);
    this.lastSessionId = sessionId;
    if (this.firstConnection_) {
      this.sendConnectStats_();
    }
    this.restoreState_();
    this.firstConnection_ = false;
    this.onConnectStatus_(true);
  };
  PersistentConnection2.prototype.scheduleConnect_ = function(timeout) {
    var _this = this;
    assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
    if (this.establishConnectionTimer_) {
      clearTimeout(this.establishConnectionTimer_);
    }
    this.establishConnectionTimer_ = setTimeout(function() {
      _this.establishConnectionTimer_ = null;
      _this.establishConnection_();
    }, Math.floor(timeout));
  };
  PersistentConnection2.prototype.onVisible_ = function(visible) {
    if (visible && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_) {
      this.log_("Window became visible.  Reducing delay.");
      this.reconnectDelay_ = RECONNECT_MIN_DELAY;
      if (!this.realtime_) {
        this.scheduleConnect_(0);
      }
    }
    this.visible_ = visible;
  };
  PersistentConnection2.prototype.onOnline_ = function(online) {
    if (online) {
      this.log_("Browser went online.");
      this.reconnectDelay_ = RECONNECT_MIN_DELAY;
      if (!this.realtime_) {
        this.scheduleConnect_(0);
      }
    } else {
      this.log_("Browser went offline.  Killing connection.");
      if (this.realtime_) {
        this.realtime_.close();
      }
    }
  };
  PersistentConnection2.prototype.onRealtimeDisconnect_ = function() {
    this.log_("data client disconnected");
    this.connected_ = false;
    this.realtime_ = null;
    this.cancelSentTransactions_();
    this.requestCBHash_ = {};
    if (this.shouldReconnect_()) {
      if (!this.visible_) {
        this.log_("Window isn't visible.  Delaying reconnect.");
        this.reconnectDelay_ = this.maxReconnectDelay_;
        this.lastConnectionAttemptTime_ = new Date().getTime();
      } else if (this.lastConnectionEstablishedTime_) {
        var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
        if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT) {
          this.reconnectDelay_ = RECONNECT_MIN_DELAY;
        }
        this.lastConnectionEstablishedTime_ = null;
      }
      var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
      var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
      reconnectDelay = Math.random() * reconnectDelay;
      this.log_("Trying to reconnect in " + reconnectDelay + "ms");
      this.scheduleConnect_(reconnectDelay);
      this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
    }
    this.onConnectStatus_(false);
  };
  PersistentConnection2.prototype.establishConnection_ = function() {
    var _this = this;
    if (this.shouldReconnect_()) {
      this.log_("Making a connection attempt");
      this.lastConnectionAttemptTime_ = new Date().getTime();
      this.lastConnectionEstablishedTime_ = null;
      var onDataMessage_1 = this.onDataMessage_.bind(this);
      var onReady_1 = this.onReady_.bind(this);
      var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
      var connId_1 = this.id + ":" + PersistentConnection2.nextConnectionId_++;
      var self_1 = this;
      var lastSessionId_1 = this.lastSessionId;
      var canceled_1 = false;
      var connection_1 = null;
      var closeFn_1 = function() {
        if (connection_1) {
          connection_1.close();
        } else {
          canceled_1 = true;
          onDisconnect_1();
        }
      };
      var sendRequestFn = function(msg) {
        assert(connection_1, "sendRequest call when we're not connected not allowed.");
        connection_1.sendRequest(msg);
      };
      this.realtime_ = {
        close: closeFn_1,
        sendRequest: sendRequestFn
      };
      var forceRefresh = this.forceTokenRefresh_;
      this.forceTokenRefresh_ = false;
      this.authTokenProvider_.getToken(forceRefresh).then(function(result2) {
        if (!canceled_1) {
          log("getToken() completed. Creating connection.");
          self_1.authToken_ = result2 && result2.accessToken;
          connection_1 = new Connection(connId_1, self_1.repoInfo_, self_1.applicationId_, onDataMessage_1, onReady_1, onDisconnect_1, function(reason) {
            warn$2(reason + " (" + self_1.repoInfo_.toString() + ")");
            self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
          }, lastSessionId_1);
        } else {
          log("getToken() completed but was canceled");
        }
      }).then(null, function(error2) {
        self_1.log_("Failed to get token: " + error2);
        if (!canceled_1) {
          if (_this.repoInfo_.nodeAdmin) {
            warn$2(error2);
          }
          closeFn_1();
        }
      });
    }
  };
  PersistentConnection2.prototype.interrupt = function(reason) {
    log("Interrupting connection for reason: " + reason);
    this.interruptReasons_[reason] = true;
    if (this.realtime_) {
      this.realtime_.close();
    } else {
      if (this.establishConnectionTimer_) {
        clearTimeout(this.establishConnectionTimer_);
        this.establishConnectionTimer_ = null;
      }
      if (this.connected_) {
        this.onRealtimeDisconnect_();
      }
    }
  };
  PersistentConnection2.prototype.resume = function(reason) {
    log("Resuming connection for reason: " + reason);
    delete this.interruptReasons_[reason];
    if (isEmpty(this.interruptReasons_)) {
      this.reconnectDelay_ = RECONNECT_MIN_DELAY;
      if (!this.realtime_) {
        this.scheduleConnect_(0);
      }
    }
  };
  PersistentConnection2.prototype.handleTimestamp_ = function(timestamp) {
    var delta = timestamp - new Date().getTime();
    this.onServerInfoUpdate_({ serverTimeOffset: delta });
  };
  PersistentConnection2.prototype.cancelSentTransactions_ = function() {
    for (var i = 0; i < this.outstandingPuts_.length; i++) {
      var put = this.outstandingPuts_[i];
      if (put && "h" in put.request && put.queued) {
        if (put.onComplete) {
          put.onComplete("disconnect");
        }
        delete this.outstandingPuts_[i];
        this.outstandingPutCount_--;
      }
    }
    if (this.outstandingPutCount_ === 0) {
      this.outstandingPuts_ = [];
    }
  };
  PersistentConnection2.prototype.onListenRevoked_ = function(pathString, query2) {
    var queryId;
    if (!query2) {
      queryId = "default";
    } else {
      queryId = query2.map(function(q3) {
        return ObjectToUniqueKey(q3);
      }).join("$");
    }
    var listen = this.removeListen_(pathString, queryId);
    if (listen && listen.onComplete) {
      listen.onComplete("permission_denied");
    }
  };
  PersistentConnection2.prototype.removeListen_ = function(pathString, queryId) {
    var normalizedPathString = new Path(pathString).toString();
    var listen;
    if (this.listens.has(normalizedPathString)) {
      var map2 = this.listens.get(normalizedPathString);
      listen = map2.get(queryId);
      map2.delete(queryId);
      if (map2.size === 0) {
        this.listens.delete(normalizedPathString);
      }
    } else {
      listen = void 0;
    }
    return listen;
  };
  PersistentConnection2.prototype.onAuthRevoked_ = function(statusCode, explanation) {
    log("Auth token revoked: " + statusCode + "/" + explanation);
    this.authToken_ = null;
    this.forceTokenRefresh_ = true;
    this.realtime_.close();
    if (statusCode === "invalid_token" || statusCode === "permission_denied") {
      this.invalidAuthTokenCount_++;
      if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
        this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
        this.authTokenProvider_.notifyForInvalidToken();
      }
    }
  };
  PersistentConnection2.prototype.onSecurityDebugPacket_ = function(body) {
    if (this.securityDebugCallback_) {
      this.securityDebugCallback_(body);
    } else {
      if ("msg" in body) {
        console.log("FIREBASE: " + body["msg"].replace("\n", "\nFIREBASE: "));
      }
    }
  };
  PersistentConnection2.prototype.restoreState_ = function() {
    var e_1, _a2, e_2, _b2;
    this.tryAuth();
    try {
      for (var _c2 = __values$1(this.listens.values()), _d2 = _c2.next(); !_d2.done; _d2 = _c2.next()) {
        var queries = _d2.value;
        try {
          for (var _e2 = (e_2 = void 0, __values$1(queries.values())), _f = _e2.next(); !_f.done; _f = _e2.next()) {
            var listenSpec = _f.value;
            this.sendListen_(listenSpec);
          }
        } catch (e_2_1) {
          e_2 = { error: e_2_1 };
        } finally {
          try {
            if (_f && !_f.done && (_b2 = _e2.return))
              _b2.call(_e2);
          } finally {
            if (e_2)
              throw e_2.error;
          }
        }
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (_d2 && !_d2.done && (_a2 = _c2.return))
          _a2.call(_c2);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
    for (var i = 0; i < this.outstandingPuts_.length; i++) {
      if (this.outstandingPuts_[i]) {
        this.sendPut_(i);
      }
    }
    while (this.onDisconnectRequestQueue_.length) {
      var request = this.onDisconnectRequestQueue_.shift();
      this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
    }
    for (var i = 0; i < this.outstandingGets_.length; i++) {
      if (this.outstandingGets_[i]) {
        this.sendGet_(i);
      }
    }
  };
  PersistentConnection2.prototype.sendConnectStats_ = function() {
    var stats2 = {};
    var clientName = "js";
    stats2["sdk." + clientName + "." + SDK_VERSION$1.replace(/\./g, "-")] = 1;
    if (isMobileCordova()) {
      stats2["framework.cordova"] = 1;
    } else if (isReactNative()) {
      stats2["framework.reactnative"] = 1;
    }
    this.reportStats(stats2);
  };
  PersistentConnection2.prototype.shouldReconnect_ = function() {
    var online = OnlineMonitor.getInstance().currentlyOnline();
    return isEmpty(this.interruptReasons_) && online;
  };
  PersistentConnection2.nextPersistentConnectionId_ = 0;
  PersistentConnection2.nextConnectionId_ = 0;
  return PersistentConnection2;
}(ServerActions);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ReadonlyRestClient = function(_super) {
  __extends$1(ReadonlyRestClient2, _super);
  function ReadonlyRestClient2(repoInfo_, onDataUpdate_, authTokenProvider_) {
    var _this = _super.call(this) || this;
    _this.repoInfo_ = repoInfo_;
    _this.onDataUpdate_ = onDataUpdate_;
    _this.authTokenProvider_ = authTokenProvider_;
    _this.log_ = logWrapper("p:rest:");
    _this.listens_ = {};
    return _this;
  }
  ReadonlyRestClient2.prototype.reportStats = function(stats2) {
    throw new Error("Method not implemented.");
  };
  ReadonlyRestClient2.getListenId_ = function(query2, tag) {
    if (tag !== void 0) {
      return "tag$" + tag;
    } else {
      assert(query2.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
      return query2.path.toString();
    }
  };
  ReadonlyRestClient2.prototype.listen = function(query2, currentHashFn, tag, onComplete) {
    var _this = this;
    var pathString = query2.path.toString();
    this.log_("Listen called for " + pathString + " " + query2.queryIdentifier());
    var listenId = ReadonlyRestClient2.getListenId_(query2, tag);
    var thisListen = {};
    this.listens_[listenId] = thisListen;
    var queryStringParameters = query2.getQueryParams().toRestQueryStringParameters();
    this.restRequest_(pathString + ".json", queryStringParameters, function(error2, result2) {
      var data = result2;
      if (error2 === 404) {
        data = null;
        error2 = null;
      }
      if (error2 === null) {
        _this.onDataUpdate_(pathString, data, false, tag);
      }
      if (safeGet(_this.listens_, listenId) === thisListen) {
        var status_1;
        if (!error2) {
          status_1 = "ok";
        } else if (error2 === 401) {
          status_1 = "permission_denied";
        } else {
          status_1 = "rest_error:" + error2;
        }
        onComplete(status_1, null);
      }
    });
  };
  ReadonlyRestClient2.prototype.unlisten = function(query2, tag) {
    var listenId = ReadonlyRestClient2.getListenId_(query2, tag);
    delete this.listens_[listenId];
  };
  ReadonlyRestClient2.prototype.get = function(query2) {
    var _this = this;
    var queryStringParameters = query2.getQueryParams().toRestQueryStringParameters();
    var pathString = query2.path.toString();
    var deferred = new Deferred();
    this.restRequest_(pathString + ".json", queryStringParameters, function(error2, result2) {
      var data = result2;
      if (error2 === 404) {
        data = null;
        error2 = null;
      }
      if (error2 === null) {
        _this.onDataUpdate_(pathString, data, false, null);
        deferred.resolve(data);
      } else {
        deferred.reject(new Error(data));
      }
    });
    return deferred.promise;
  };
  ReadonlyRestClient2.prototype.refreshAuthToken = function(token2) {
  };
  ReadonlyRestClient2.prototype.restRequest_ = function(pathString, queryStringParameters, callback) {
    var _this = this;
    if (queryStringParameters === void 0) {
      queryStringParameters = {};
    }
    queryStringParameters["format"] = "export";
    this.authTokenProvider_.getToken(false).then(function(authTokenData) {
      var authToken = authTokenData && authTokenData.accessToken;
      if (authToken) {
        queryStringParameters["auth"] = authToken;
      }
      var url = (_this.repoInfo_.secure ? "https://" : "http://") + _this.repoInfo_.host + pathString + "?ns=" + _this.repoInfo_.namespace + querystring(queryStringParameters);
      _this.log_("Sending REST request for " + url);
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function() {
        if (callback && xhr.readyState === 4) {
          _this.log_("REST Response for " + url + " received. status:", xhr.status, "response:", xhr.responseText);
          var res = null;
          if (xhr.status >= 200 && xhr.status < 300) {
            try {
              res = jsonEval(xhr.responseText);
            } catch (e28) {
              warn$2("Failed to parse JSON response for " + url + ": " + xhr.responseText);
            }
            callback(null, res);
          } else {
            if (xhr.status !== 401 && xhr.status !== 404) {
              warn$2("Got unsuccessful REST response for " + url + " Status: " + xhr.status);
            }
            callback(xhr.status);
          }
          callback = null;
        }
      };
      xhr.open("GET", url, true);
      xhr.send();
    });
  };
  return ReadonlyRestClient2;
}(ServerActions);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var INTERRUPT_REASON = "repo_interrupt";
var Repo = function() {
  function Repo2(repoInfo_, forceRestClient_, app, authTokenProvider_) {
    this.repoInfo_ = repoInfo_;
    this.forceRestClient_ = forceRestClient_;
    this.app = app;
    this.authTokenProvider_ = authTokenProvider_;
    this.dataUpdateCount = 0;
    this.statsListener_ = null;
    this.eventQueue_ = new EventQueue();
    this.nextWriteId_ = 1;
    this.interceptServerDataCallback_ = null;
    this.onDisconnect_ = new SparseSnapshotTree();
    this.persistentConnection_ = null;
    this.key = this.repoInfo_.toURLString();
  }
  Repo2.prototype.start = function() {
    var _this = this;
    this.stats_ = StatsManager.getCollection(this.repoInfo_);
    if (this.forceRestClient_ || beingCrawled()) {
      this.server_ = new ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), this.authTokenProvider_);
      setTimeout(this.onConnectStatus_.bind(this, true), 0);
    } else {
      var authOverride = this.app.options["databaseAuthVariableOverride"];
      if (typeof authOverride !== "undefined" && authOverride !== null) {
        if (typeof authOverride !== "object") {
          throw new Error("Only objects are supported for option databaseAuthVariableOverride");
        }
        try {
          stringify(authOverride);
        } catch (e28) {
          throw new Error("Invalid authOverride provided: " + e28);
        }
      }
      this.persistentConnection_ = new PersistentConnection(this.repoInfo_, this.app.options.appId, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), this.authTokenProvider_, authOverride);
      this.server_ = this.persistentConnection_;
    }
    this.authTokenProvider_.addTokenChangeListener(function(token2) {
      _this.server_.refreshAuthToken(token2);
    });
    this.statsReporter_ = StatsManager.getOrCreateReporter(this.repoInfo_, function() {
      return new StatsReporter(_this.stats_, _this.server_);
    });
    this.transactionsInit_();
    this.infoData_ = new SnapshotHolder();
    this.infoSyncTree_ = new SyncTree({
      startListening: function(query2, tag, currentHashFn, onComplete) {
        var infoEvents = [];
        var node = _this.infoData_.getNode(query2.path);
        if (!node.isEmpty()) {
          infoEvents = _this.infoSyncTree_.applyServerOverwrite(query2.path, node);
          setTimeout(function() {
            onComplete("ok");
          }, 0);
        }
        return infoEvents;
      },
      stopListening: function() {
      }
    });
    this.updateInfo_("connected", false);
    this.serverSyncTree_ = new SyncTree({
      startListening: function(query2, tag, currentHashFn, onComplete) {
        _this.server_.listen(query2, currentHashFn, tag, function(status, data) {
          var events = onComplete(status, data);
          _this.eventQueue_.raiseEventsForChangedPath(query2.path, events);
        });
        return [];
      },
      stopListening: function(query2, tag) {
        _this.server_.unlisten(query2, tag);
      }
    });
  };
  Repo2.prototype.toString = function() {
    return (this.repoInfo_.secure ? "https://" : "http://") + this.repoInfo_.host;
  };
  Repo2.prototype.name = function() {
    return this.repoInfo_.namespace;
  };
  Repo2.prototype.serverTime = function() {
    var offsetNode = this.infoData_.getNode(new Path(".info/serverTimeOffset"));
    var offset2 = offsetNode.val() || 0;
    return new Date().getTime() + offset2;
  };
  Repo2.prototype.generateServerValues = function() {
    return generateWithValues({
      timestamp: this.serverTime()
    });
  };
  Repo2.prototype.onDataUpdate_ = function(pathString, data, isMerge, tag) {
    this.dataUpdateCount++;
    var path = new Path(pathString);
    data = this.interceptServerDataCallback_ ? this.interceptServerDataCallback_(pathString, data) : data;
    var events = [];
    if (tag) {
      if (isMerge) {
        var taggedChildren = map$1(data, function(raw) {
          return nodeFromJSON$1(raw);
        });
        events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
      } else {
        var taggedSnap = nodeFromJSON$1(data);
        events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
      }
    } else if (isMerge) {
      var changedChildren = map$1(data, function(raw) {
        return nodeFromJSON$1(raw);
      });
      events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
    } else {
      var snap = nodeFromJSON$1(data);
      events = this.serverSyncTree_.applyServerOverwrite(path, snap);
    }
    var affectedPath = path;
    if (events.length > 0) {
      affectedPath = this.rerunTransactions_(path);
    }
    this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
  };
  Repo2.prototype.interceptServerData_ = function(callback) {
    this.interceptServerDataCallback_ = callback;
  };
  Repo2.prototype.onConnectStatus_ = function(connectStatus) {
    this.updateInfo_("connected", connectStatus);
    if (connectStatus === false) {
      this.runOnDisconnectEvents_();
    }
  };
  Repo2.prototype.onServerInfoUpdate_ = function(updates) {
    var _this = this;
    each(updates, function(key, value) {
      _this.updateInfo_(key, value);
    });
  };
  Repo2.prototype.updateInfo_ = function(pathString, value) {
    var path = new Path("/.info/" + pathString);
    var newNode = nodeFromJSON$1(value);
    this.infoData_.updateSnapshot(path, newNode);
    var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
    this.eventQueue_.raiseEventsForChangedPath(path, events);
  };
  Repo2.prototype.getNextWriteId_ = function() {
    return this.nextWriteId_++;
  };
  Repo2.prototype.getValue = function(query2) {
    var _this = this;
    return this.server_.get(query2).then(function(payload) {
      var node = nodeFromJSON$1(payload);
      var events = _this.serverSyncTree_.applyServerOverwrite(query2.path, node);
      _this.eventQueue_.raiseEventsAtPath(query2.path, events);
      return Promise.resolve(new DataSnapshot(node, query2.getRef(), query2.getQueryParams().getIndex()));
    }, function(err) {
      _this.log_("get for query " + stringify(query2) + " falling back to cache after error: " + err);
      var cached = _this.serverSyncTree_.calcCompleteEventCache(query2.path);
      if (!cached.isEmpty()) {
        return Promise.resolve(new DataSnapshot(cached, query2.getRef(), query2.getQueryParams().getIndex()));
      }
      return Promise.reject(new Error(err));
    });
  };
  Repo2.prototype.setWithPriority = function(path, newVal, newPriority, onComplete) {
    var _this = this;
    this.log_("set", {
      path: path.toString(),
      value: newVal,
      priority: newPriority
    });
    var serverValues = this.generateServerValues();
    var newNodeUnresolved = nodeFromJSON$1(newVal, newPriority);
    var existing = this.serverSyncTree_.calcCompleteEventCache(path);
    var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
    var writeId = this.getNextWriteId_();
    var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
    this.eventQueue_.queueEvents(events);
    this.server_.put(path.toString(), newNodeUnresolved.val(true), function(status, errorReason) {
      var success = status === "ok";
      if (!success) {
        warn$2("set at " + path + " failed: " + status);
      }
      var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
      _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
      _this.callOnCompleteCallback(onComplete, status, errorReason);
    });
    var affectedPath = this.abortTransactions_(path);
    this.rerunTransactions_(affectedPath);
    this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
  };
  Repo2.prototype.update = function(path, childrenToMerge, onComplete) {
    var _this = this;
    this.log_("update", { path: path.toString(), value: childrenToMerge });
    var empty = true;
    var serverValues = this.generateServerValues();
    var changedChildren = {};
    each(childrenToMerge, function(changedKey, changedValue) {
      empty = false;
      changedChildren[changedKey] = resolveDeferredValueTree(path.child(changedKey), nodeFromJSON$1(changedValue), _this.serverSyncTree_, serverValues);
    });
    if (!empty) {
      var writeId_1 = this.getNextWriteId_();
      var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
      this.eventQueue_.queueEvents(events);
      this.server_.merge(path.toString(), childrenToMerge, function(status, errorReason) {
        var success = status === "ok";
        if (!success) {
          warn$2("update at " + path + " failed: " + status);
        }
        var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
        var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
        _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
        _this.callOnCompleteCallback(onComplete, status, errorReason);
      });
      each(childrenToMerge, function(changedPath) {
        var affectedPath = _this.abortTransactions_(path.child(changedPath));
        _this.rerunTransactions_(affectedPath);
      });
      this.eventQueue_.raiseEventsForChangedPath(path, []);
    } else {
      log("update() called with empty data.  Don't do anything.");
      this.callOnCompleteCallback(onComplete, "ok");
    }
  };
  Repo2.prototype.runOnDisconnectEvents_ = function() {
    var _this = this;
    this.log_("onDisconnectEvents");
    var serverValues = this.generateServerValues();
    var resolvedOnDisconnectTree = new SparseSnapshotTree();
    this.onDisconnect_.forEachTree(Path.Empty, function(path, node) {
      var resolved = resolveDeferredValueTree(path, node, _this.serverSyncTree_, serverValues);
      resolvedOnDisconnectTree.remember(path, resolved);
    });
    var events = [];
    resolvedOnDisconnectTree.forEachTree(Path.Empty, function(path, snap) {
      events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
      var affectedPath = _this.abortTransactions_(path);
      _this.rerunTransactions_(affectedPath);
    });
    this.onDisconnect_ = new SparseSnapshotTree();
    this.eventQueue_.raiseEventsForChangedPath(Path.Empty, events);
  };
  Repo2.prototype.onDisconnectCancel = function(path, onComplete) {
    var _this = this;
    this.server_.onDisconnectCancel(path.toString(), function(status, errorReason) {
      if (status === "ok") {
        _this.onDisconnect_.forget(path);
      }
      _this.callOnCompleteCallback(onComplete, status, errorReason);
    });
  };
  Repo2.prototype.onDisconnectSet = function(path, value, onComplete) {
    var _this = this;
    var newNode = nodeFromJSON$1(value);
    this.server_.onDisconnectPut(path.toString(), newNode.val(true), function(status, errorReason) {
      if (status === "ok") {
        _this.onDisconnect_.remember(path, newNode);
      }
      _this.callOnCompleteCallback(onComplete, status, errorReason);
    });
  };
  Repo2.prototype.onDisconnectSetWithPriority = function(path, value, priority, onComplete) {
    var _this = this;
    var newNode = nodeFromJSON$1(value, priority);
    this.server_.onDisconnectPut(path.toString(), newNode.val(true), function(status, errorReason) {
      if (status === "ok") {
        _this.onDisconnect_.remember(path, newNode);
      }
      _this.callOnCompleteCallback(onComplete, status, errorReason);
    });
  };
  Repo2.prototype.onDisconnectUpdate = function(path, childrenToMerge, onComplete) {
    var _this = this;
    if (isEmpty(childrenToMerge)) {
      log("onDisconnect().update() called with empty data.  Don't do anything.");
      this.callOnCompleteCallback(onComplete, "ok");
      return;
    }
    this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function(status, errorReason) {
      if (status === "ok") {
        each(childrenToMerge, function(childName, childNode) {
          var newChildNode = nodeFromJSON$1(childNode);
          _this.onDisconnect_.remember(path.child(childName), newChildNode);
        });
      }
      _this.callOnCompleteCallback(onComplete, status, errorReason);
    });
  };
  Repo2.prototype.addEventCallbackForQuery = function(query2, eventRegistration) {
    var events;
    if (query2.path.getFront() === ".info") {
      events = this.infoSyncTree_.addEventRegistration(query2, eventRegistration);
    } else {
      events = this.serverSyncTree_.addEventRegistration(query2, eventRegistration);
    }
    this.eventQueue_.raiseEventsAtPath(query2.path, events);
  };
  Repo2.prototype.removeEventCallbackForQuery = function(query2, eventRegistration) {
    var events;
    if (query2.path.getFront() === ".info") {
      events = this.infoSyncTree_.removeEventRegistration(query2, eventRegistration);
    } else {
      events = this.serverSyncTree_.removeEventRegistration(query2, eventRegistration);
    }
    this.eventQueue_.raiseEventsAtPath(query2.path, events);
  };
  Repo2.prototype.interrupt = function() {
    if (this.persistentConnection_) {
      this.persistentConnection_.interrupt(INTERRUPT_REASON);
    }
  };
  Repo2.prototype.resume = function() {
    if (this.persistentConnection_) {
      this.persistentConnection_.resume(INTERRUPT_REASON);
    }
  };
  Repo2.prototype.stats = function(showDelta) {
    if (showDelta === void 0) {
      showDelta = false;
    }
    if (typeof console === "undefined") {
      return;
    }
    var stats2;
    if (showDelta) {
      if (!this.statsListener_) {
        this.statsListener_ = new StatsListener(this.stats_);
      }
      stats2 = this.statsListener_.get();
    } else {
      stats2 = this.stats_.get();
    }
    var longestName = Object.keys(stats2).reduce(function(previousValue, currentValue) {
      return Math.max(currentValue.length, previousValue);
    }, 0);
    each(stats2, function(stat, value) {
      var paddedStat = stat;
      for (var i = stat.length; i < longestName + 2; i++) {
        paddedStat += " ";
      }
      console.log(paddedStat + value);
    });
  };
  Repo2.prototype.statsIncrementCounter = function(metric) {
    this.stats_.incrementCounter(metric);
    this.statsReporter_.includeStat(metric);
  };
  Repo2.prototype.log_ = function() {
    var varArgs = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      varArgs[_i2] = arguments[_i2];
    }
    var prefix = "";
    if (this.persistentConnection_) {
      prefix = this.persistentConnection_.id + ":";
    }
    log.apply(void 0, __spread([prefix], varArgs));
  };
  Repo2.prototype.callOnCompleteCallback = function(callback, status, errorReason) {
    if (callback) {
      exceptionGuard(function() {
        if (status === "ok") {
          callback(null);
        } else {
          var code = (status || "error").toUpperCase();
          var message = code;
          if (errorReason) {
            message += ": " + errorReason;
          }
          var error2 = new Error(message);
          error2.code = code;
          callback(error2);
        }
      });
    }
  };
  Object.defineProperty(Repo2.prototype, "database", {
    get: function() {
      return this.__database || (this.__database = new Database(this));
    },
    enumerable: false,
    configurable: true
  });
  return Repo2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RangedFilter = function() {
  function RangedFilter2(params2) {
    this.indexedFilter_ = new IndexedFilter(params2.getIndex());
    this.index_ = params2.getIndex();
    this.startPost_ = RangedFilter2.getStartPost_(params2);
    this.endPost_ = RangedFilter2.getEndPost_(params2);
  }
  RangedFilter2.prototype.getStartPost = function() {
    return this.startPost_;
  };
  RangedFilter2.prototype.getEndPost = function() {
    return this.endPost_;
  };
  RangedFilter2.prototype.matches = function(node) {
    return this.index_.compare(this.getStartPost(), node) <= 0 && this.index_.compare(node, this.getEndPost()) <= 0;
  };
  RangedFilter2.prototype.updateChild = function(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
    if (!this.matches(new NamedNode(key, newChild))) {
      newChild = ChildrenNode.EMPTY_NODE;
    }
    return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
  };
  RangedFilter2.prototype.updateFullNode = function(oldSnap, newSnap, optChangeAccumulator) {
    if (newSnap.isLeafNode()) {
      newSnap = ChildrenNode.EMPTY_NODE;
    }
    var filtered = newSnap.withIndex(this.index_);
    filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
    var self2 = this;
    newSnap.forEachChild(PRIORITY_INDEX, function(key, childNode) {
      if (!self2.matches(new NamedNode(key, childNode))) {
        filtered = filtered.updateImmediateChild(key, ChildrenNode.EMPTY_NODE);
      }
    });
    return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
  };
  RangedFilter2.prototype.updatePriority = function(oldSnap, newPriority) {
    return oldSnap;
  };
  RangedFilter2.prototype.filtersNodes = function() {
    return true;
  };
  RangedFilter2.prototype.getIndexedFilter = function() {
    return this.indexedFilter_;
  };
  RangedFilter2.prototype.getIndex = function() {
    return this.index_;
  };
  RangedFilter2.getStartPost_ = function(params2) {
    if (params2.hasStart()) {
      var startName = params2.getIndexStartName();
      return params2.getIndex().makePost(params2.getIndexStartValue(), startName);
    } else {
      return params2.getIndex().minPost();
    }
  };
  RangedFilter2.getEndPost_ = function(params2) {
    if (params2.hasEnd()) {
      var endName = params2.getIndexEndName();
      return params2.getIndex().makePost(params2.getIndexEndValue(), endName);
    } else {
      return params2.getIndex().maxPost();
    }
  };
  return RangedFilter2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LimitedFilter = function() {
  function LimitedFilter2(params2) {
    this.rangedFilter_ = new RangedFilter(params2);
    this.index_ = params2.getIndex();
    this.limit_ = params2.getLimit();
    this.reverse_ = !params2.isViewFromLeft();
  }
  LimitedFilter2.prototype.updateChild = function(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
    if (!this.rangedFilter_.matches(new NamedNode(key, newChild))) {
      newChild = ChildrenNode.EMPTY_NODE;
    }
    if (snap.getImmediateChild(key).equals(newChild)) {
      return snap;
    } else if (snap.numChildren() < this.limit_) {
      return this.rangedFilter_.getIndexedFilter().updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    } else {
      return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
    }
  };
  LimitedFilter2.prototype.updateFullNode = function(oldSnap, newSnap, optChangeAccumulator) {
    var filtered;
    if (newSnap.isLeafNode() || newSnap.isEmpty()) {
      filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
    } else {
      if (this.limit_ * 2 < newSnap.numChildren() && newSnap.isIndexed(this.index_)) {
        filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        var iterator = void 0;
        if (this.reverse_) {
          iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
        } else {
          iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
        }
        var count = 0;
        while (iterator.hasNext() && count < this.limit_) {
          var next = iterator.getNext();
          var inRange = void 0;
          if (this.reverse_) {
            inRange = this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
          } else {
            inRange = this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
          }
          if (inRange) {
            filtered = filtered.updateImmediateChild(next.name, next.node);
            count++;
          } else {
            break;
          }
        }
      } else {
        filtered = newSnap.withIndex(this.index_);
        filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
        var startPost = void 0;
        var endPost = void 0;
        var cmp = void 0;
        var iterator = void 0;
        if (this.reverse_) {
          iterator = filtered.getReverseIterator(this.index_);
          startPost = this.rangedFilter_.getEndPost();
          endPost = this.rangedFilter_.getStartPost();
          var indexCompare_1 = this.index_.getCompare();
          cmp = function(a3, b3) {
            return indexCompare_1(b3, a3);
          };
        } else {
          iterator = filtered.getIterator(this.index_);
          startPost = this.rangedFilter_.getStartPost();
          endPost = this.rangedFilter_.getEndPost();
          cmp = this.index_.getCompare();
        }
        var count = 0;
        var foundStartPost = false;
        while (iterator.hasNext()) {
          var next = iterator.getNext();
          if (!foundStartPost && cmp(startPost, next) <= 0) {
            foundStartPost = true;
          }
          var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
          if (inRange) {
            count++;
          } else {
            filtered = filtered.updateImmediateChild(next.name, ChildrenNode.EMPTY_NODE);
          }
        }
      }
    }
    return this.rangedFilter_.getIndexedFilter().updateFullNode(oldSnap, filtered, optChangeAccumulator);
  };
  LimitedFilter2.prototype.updatePriority = function(oldSnap, newPriority) {
    return oldSnap;
  };
  LimitedFilter2.prototype.filtersNodes = function() {
    return true;
  };
  LimitedFilter2.prototype.getIndexedFilter = function() {
    return this.rangedFilter_.getIndexedFilter();
  };
  LimitedFilter2.prototype.getIndex = function() {
    return this.index_;
  };
  LimitedFilter2.prototype.fullLimitUpdateChild_ = function(snap, childKey, childSnap, source, changeAccumulator) {
    var cmp;
    if (this.reverse_) {
      var indexCmp_1 = this.index_.getCompare();
      cmp = function(a3, b3) {
        return indexCmp_1(b3, a3);
      };
    } else {
      cmp = this.index_.getCompare();
    }
    var oldEventCache = snap;
    assert(oldEventCache.numChildren() === this.limit_, "");
    var newChildNamedNode = new NamedNode(childKey, childSnap);
    var windowBoundary = this.reverse_ ? oldEventCache.getFirstChild(this.index_) : oldEventCache.getLastChild(this.index_);
    var inRange = this.rangedFilter_.matches(newChildNamedNode);
    if (oldEventCache.hasChild(childKey)) {
      var oldChildSnap = oldEventCache.getImmediateChild(childKey);
      var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
      while (nextChild != null && (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name))) {
        nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
      }
      var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
      var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
      if (remainsInWindow) {
        if (changeAccumulator != null) {
          changeAccumulator.trackChildChange(Change.childChangedChange(childKey, childSnap, oldChildSnap));
        }
        return oldEventCache.updateImmediateChild(childKey, childSnap);
      } else {
        if (changeAccumulator != null) {
          changeAccumulator.trackChildChange(Change.childRemovedChange(childKey, oldChildSnap));
        }
        var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode.EMPTY_NODE);
        var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
        if (nextChildInRange) {
          if (changeAccumulator != null) {
            changeAccumulator.trackChildChange(Change.childAddedChange(nextChild.name, nextChild.node));
          }
          return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
        } else {
          return newEventCache;
        }
      }
    } else if (childSnap.isEmpty()) {
      return snap;
    } else if (inRange) {
      if (cmp(windowBoundary, newChildNamedNode) >= 0) {
        if (changeAccumulator != null) {
          changeAccumulator.trackChildChange(Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
          changeAccumulator.trackChildChange(Change.childAddedChange(childKey, childSnap));
        }
        return oldEventCache.updateImmediateChild(childKey, childSnap).updateImmediateChild(windowBoundary.name, ChildrenNode.EMPTY_NODE);
      } else {
        return snap;
      }
    } else {
      return snap;
    }
  };
  return LimitedFilter2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var QueryParams = function() {
  function QueryParams2() {
    this.limitSet_ = false;
    this.startSet_ = false;
    this.startNameSet_ = false;
    this.endSet_ = false;
    this.endNameSet_ = false;
    this.limit_ = 0;
    this.viewFrom_ = "";
    this.indexStartValue_ = null;
    this.indexStartName_ = "";
    this.indexEndValue_ = null;
    this.indexEndName_ = "";
    this.index_ = PRIORITY_INDEX;
  }
  QueryParams2.prototype.hasStart = function() {
    return this.startSet_;
  };
  QueryParams2.prototype.isViewFromLeft = function() {
    if (this.viewFrom_ === "") {
      return this.startSet_;
    } else {
      return this.viewFrom_ === QueryParams2.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
    }
  };
  QueryParams2.prototype.getIndexStartValue = function() {
    assert(this.startSet_, "Only valid if start has been set");
    return this.indexStartValue_;
  };
  QueryParams2.prototype.getIndexStartName = function() {
    assert(this.startSet_, "Only valid if start has been set");
    if (this.startNameSet_) {
      return this.indexStartName_;
    } else {
      return MIN_NAME;
    }
  };
  QueryParams2.prototype.hasEnd = function() {
    return this.endSet_;
  };
  QueryParams2.prototype.getIndexEndValue = function() {
    assert(this.endSet_, "Only valid if end has been set");
    return this.indexEndValue_;
  };
  QueryParams2.prototype.getIndexEndName = function() {
    assert(this.endSet_, "Only valid if end has been set");
    if (this.endNameSet_) {
      return this.indexEndName_;
    } else {
      return MAX_NAME;
    }
  };
  QueryParams2.prototype.hasLimit = function() {
    return this.limitSet_;
  };
  QueryParams2.prototype.hasAnchoredLimit = function() {
    return this.limitSet_ && this.viewFrom_ !== "";
  };
  QueryParams2.prototype.getLimit = function() {
    assert(this.limitSet_, "Only valid if limit has been set");
    return this.limit_;
  };
  QueryParams2.prototype.getIndex = function() {
    return this.index_;
  };
  QueryParams2.prototype.copy_ = function() {
    var copy = new QueryParams2();
    copy.limitSet_ = this.limitSet_;
    copy.limit_ = this.limit_;
    copy.startSet_ = this.startSet_;
    copy.indexStartValue_ = this.indexStartValue_;
    copy.startNameSet_ = this.startNameSet_;
    copy.indexStartName_ = this.indexStartName_;
    copy.endSet_ = this.endSet_;
    copy.indexEndValue_ = this.indexEndValue_;
    copy.endNameSet_ = this.endNameSet_;
    copy.indexEndName_ = this.indexEndName_;
    copy.index_ = this.index_;
    copy.viewFrom_ = this.viewFrom_;
    return copy;
  };
  QueryParams2.prototype.limit = function(newLimit) {
    var newParams = this.copy_();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "";
    return newParams;
  };
  QueryParams2.prototype.limitToFirst = function(newLimit) {
    var newParams = this.copy_();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = QueryParams2.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
    return newParams;
  };
  QueryParams2.prototype.limitToLast = function(newLimit) {
    var newParams = this.copy_();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = QueryParams2.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
    return newParams;
  };
  QueryParams2.prototype.startAt = function(indexValue, key) {
    var newParams = this.copy_();
    newParams.startSet_ = true;
    if (indexValue === void 0) {
      indexValue = null;
    }
    newParams.indexStartValue_ = indexValue;
    if (key != null) {
      newParams.startNameSet_ = true;
      newParams.indexStartName_ = key;
    } else {
      newParams.startNameSet_ = false;
      newParams.indexStartName_ = "";
    }
    return newParams;
  };
  QueryParams2.prototype.endAt = function(indexValue, key) {
    var newParams = this.copy_();
    newParams.endSet_ = true;
    if (indexValue === void 0) {
      indexValue = null;
    }
    newParams.indexEndValue_ = indexValue;
    if (key !== void 0) {
      newParams.endNameSet_ = true;
      newParams.indexEndName_ = key;
    } else {
      newParams.endNameSet_ = false;
      newParams.indexEndName_ = "";
    }
    return newParams;
  };
  QueryParams2.prototype.orderBy = function(index) {
    var newParams = this.copy_();
    newParams.index_ = index;
    return newParams;
  };
  QueryParams2.prototype.getQueryObject = function() {
    var WIRE_PROTOCOL_CONSTANTS = QueryParams2.WIRE_PROTOCOL_CONSTANTS_;
    var obj = {};
    if (this.startSet_) {
      obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
      if (this.startNameSet_) {
        obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
      }
    }
    if (this.endSet_) {
      obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
      if (this.endNameSet_) {
        obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
      }
    }
    if (this.limitSet_) {
      obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
      var viewFrom = this.viewFrom_;
      if (viewFrom === "") {
        if (this.isViewFromLeft()) {
          viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
        } else {
          viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
        }
      }
      obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
    }
    if (this.index_ !== PRIORITY_INDEX) {
      obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
    }
    return obj;
  };
  QueryParams2.prototype.loadsAllData = function() {
    return !(this.startSet_ || this.endSet_ || this.limitSet_);
  };
  QueryParams2.prototype.isDefault = function() {
    return this.loadsAllData() && this.index_ === PRIORITY_INDEX;
  };
  QueryParams2.prototype.getNodeFilter = function() {
    if (this.loadsAllData()) {
      return new IndexedFilter(this.getIndex());
    } else if (this.hasLimit()) {
      return new LimitedFilter(this);
    } else {
      return new RangedFilter(this);
    }
  };
  QueryParams2.prototype.toRestQueryStringParameters = function() {
    var REST_CONSTANTS = QueryParams2.REST_QUERY_CONSTANTS_;
    var qs2 = {};
    if (this.isDefault()) {
      return qs2;
    }
    var orderBy;
    if (this.index_ === PRIORITY_INDEX) {
      orderBy = REST_CONSTANTS.PRIORITY_INDEX;
    } else if (this.index_ === VALUE_INDEX) {
      orderBy = REST_CONSTANTS.VALUE_INDEX;
    } else if (this.index_ === KEY_INDEX) {
      orderBy = REST_CONSTANTS.KEY_INDEX;
    } else {
      assert(this.index_ instanceof PathIndex, "Unrecognized index type!");
      orderBy = this.index_.toString();
    }
    qs2[REST_CONSTANTS.ORDER_BY] = stringify(orderBy);
    if (this.startSet_) {
      qs2[REST_CONSTANTS.START_AT] = stringify(this.indexStartValue_);
      if (this.startNameSet_) {
        qs2[REST_CONSTANTS.START_AT] += "," + stringify(this.indexStartName_);
      }
    }
    if (this.endSet_) {
      qs2[REST_CONSTANTS.END_AT] = stringify(this.indexEndValue_);
      if (this.endNameSet_) {
        qs2[REST_CONSTANTS.END_AT] += "," + stringify(this.indexEndName_);
      }
    }
    if (this.limitSet_) {
      if (this.isViewFromLeft()) {
        qs2[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
      } else {
        qs2[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
      }
    }
    return qs2;
  };
  QueryParams2.WIRE_PROTOCOL_CONSTANTS_ = {
    INDEX_START_VALUE: "sp",
    INDEX_START_NAME: "sn",
    INDEX_END_VALUE: "ep",
    INDEX_END_NAME: "en",
    LIMIT: "l",
    VIEW_FROM: "vf",
    VIEW_FROM_LEFT: "l",
    VIEW_FROM_RIGHT: "r",
    INDEX: "i"
  };
  QueryParams2.REST_QUERY_CONSTANTS_ = {
    ORDER_BY: "orderBy",
    PRIORITY_INDEX: "$priority",
    VALUE_INDEX: "$value",
    KEY_INDEX: "$key",
    START_AT: "startAt",
    END_AT: "endAt",
    LIMIT_TO_FIRST: "limitToFirst",
    LIMIT_TO_LAST: "limitToLast"
  };
  QueryParams2.DEFAULT = new QueryParams2();
  return QueryParams2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Reference$2 = function(_super) {
  __extends$1(Reference2, _super);
  function Reference2(repo, path) {
    var _this = this;
    if (!(repo instanceof Repo)) {
      throw new Error("new Reference() no longer supported - use app.database().");
    }
    _this = _super.call(this, repo, path, QueryParams.DEFAULT, false) || this;
    return _this;
  }
  Reference2.prototype.getKey = function() {
    validateArgCount("Reference.key", 0, 0, arguments.length);
    if (this.path.isEmpty()) {
      return null;
    } else {
      return this.path.getBack();
    }
  };
  Reference2.prototype.child = function(pathString) {
    validateArgCount("Reference.child", 1, 1, arguments.length);
    if (typeof pathString === "number") {
      pathString = String(pathString);
    } else if (!(pathString instanceof Path)) {
      if (this.path.getFront() === null) {
        validateRootPathString("Reference.child", 1, pathString, false);
      } else {
        validatePathString("Reference.child", 1, pathString, false);
      }
    }
    return new Reference2(this.repo, this.path.child(pathString));
  };
  Reference2.prototype.getParent = function() {
    validateArgCount("Reference.parent", 0, 0, arguments.length);
    var parentPath = this.path.parent();
    return parentPath === null ? null : new Reference2(this.repo, parentPath);
  };
  Reference2.prototype.getRoot = function() {
    validateArgCount("Reference.root", 0, 0, arguments.length);
    var ref2 = this;
    while (ref2.getParent() !== null) {
      ref2 = ref2.getParent();
    }
    return ref2;
  };
  Reference2.prototype.databaseProp = function() {
    return this.repo.database;
  };
  Reference2.prototype.set = function(newVal, onComplete) {
    validateArgCount("Reference.set", 1, 2, arguments.length);
    validateWritablePath("Reference.set", this.path);
    validateFirebaseDataArg("Reference.set", 1, newVal, this.path, false);
    validateCallback("Reference.set", 2, onComplete, true);
    var deferred = new Deferred();
    this.repo.setWithPriority(this.path, newVal, null, deferred.wrapCallback(onComplete));
    return deferred.promise;
  };
  Reference2.prototype.update = function(objectToMerge, onComplete) {
    validateArgCount("Reference.update", 1, 2, arguments.length);
    validateWritablePath("Reference.update", this.path);
    if (Array.isArray(objectToMerge)) {
      var newObjectToMerge = {};
      for (var i = 0; i < objectToMerge.length; ++i) {
        newObjectToMerge["" + i] = objectToMerge[i];
      }
      objectToMerge = newObjectToMerge;
      warn$2("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
    }
    validateFirebaseMergeDataArg("Reference.update", 1, objectToMerge, this.path, false);
    validateCallback("Reference.update", 2, onComplete, true);
    var deferred = new Deferred();
    this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
    return deferred.promise;
  };
  Reference2.prototype.setWithPriority = function(newVal, newPriority, onComplete) {
    validateArgCount("Reference.setWithPriority", 2, 3, arguments.length);
    validateWritablePath("Reference.setWithPriority", this.path);
    validateFirebaseDataArg("Reference.setWithPriority", 1, newVal, this.path, false);
    validatePriority("Reference.setWithPriority", 2, newPriority, false);
    validateCallback("Reference.setWithPriority", 3, onComplete, true);
    if (this.getKey() === ".length" || this.getKey() === ".keys") {
      throw "Reference.setWithPriority failed: " + this.getKey() + " is a read-only object.";
    }
    var deferred = new Deferred();
    this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
    return deferred.promise;
  };
  Reference2.prototype.remove = function(onComplete) {
    validateArgCount("Reference.remove", 0, 1, arguments.length);
    validateWritablePath("Reference.remove", this.path);
    validateCallback("Reference.remove", 1, onComplete, true);
    return this.set(null, onComplete);
  };
  Reference2.prototype.transaction = function(transactionUpdate, onComplete, applyLocally) {
    validateArgCount("Reference.transaction", 1, 3, arguments.length);
    validateWritablePath("Reference.transaction", this.path);
    validateCallback("Reference.transaction", 1, transactionUpdate, false);
    validateCallback("Reference.transaction", 2, onComplete, true);
    validateBoolean("Reference.transaction", 3, applyLocally, true);
    if (this.getKey() === ".length" || this.getKey() === ".keys") {
      throw "Reference.transaction failed: " + this.getKey() + " is a read-only object.";
    }
    if (applyLocally === void 0) {
      applyLocally = true;
    }
    var deferred = new Deferred();
    if (typeof onComplete === "function") {
      deferred.promise.catch(function() {
      });
    }
    var promiseComplete = function(error2, committed, snapshot) {
      if (error2) {
        deferred.reject(error2);
      } else {
        deferred.resolve(new TransactionResult(committed, snapshot));
      }
      if (typeof onComplete === "function") {
        onComplete(error2, committed, snapshot);
      }
    };
    this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
    return deferred.promise;
  };
  Reference2.prototype.setPriority = function(priority, onComplete) {
    validateArgCount("Reference.setPriority", 1, 2, arguments.length);
    validateWritablePath("Reference.setPriority", this.path);
    validatePriority("Reference.setPriority", 1, priority, false);
    validateCallback("Reference.setPriority", 2, onComplete, true);
    var deferred = new Deferred();
    this.repo.setWithPriority(this.path.child(".priority"), priority, null, deferred.wrapCallback(onComplete));
    return deferred.promise;
  };
  Reference2.prototype.push = function(value, onComplete) {
    validateArgCount("Reference.push", 0, 2, arguments.length);
    validateWritablePath("Reference.push", this.path);
    validateFirebaseDataArg("Reference.push", 1, value, this.path, true);
    validateCallback("Reference.push", 2, onComplete, true);
    var now2 = this.repo.serverTime();
    var name2 = nextPushId(now2);
    var thennablePushRef = this.child(name2);
    var pushRef = this.child(name2);
    var promise;
    if (value != null) {
      promise = thennablePushRef.set(value, onComplete).then(function() {
        return pushRef;
      });
    } else {
      promise = Promise.resolve(pushRef);
    }
    thennablePushRef.then = promise.then.bind(promise);
    thennablePushRef.catch = promise.then.bind(promise, void 0);
    if (typeof onComplete === "function") {
      promise.catch(function() {
      });
    }
    return thennablePushRef;
  };
  Reference2.prototype.onDisconnect = function() {
    validateWritablePath("Reference.onDisconnect", this.path);
    return new OnDisconnect(this.repo, this.path);
  };
  Object.defineProperty(Reference2.prototype, "database", {
    get: function() {
      return this.databaseProp();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Reference2.prototype, "key", {
    get: function() {
      return this.getKey();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Reference2.prototype, "parent", {
    get: function() {
      return this.getParent();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Reference2.prototype, "root", {
    get: function() {
      return this.getRoot();
    },
    enumerable: false,
    configurable: true
  });
  return Reference2;
}(Query);
Query.__referenceConstructor = Reference$2;
SyncPoint.__referenceConstructor = Reference$2;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TreeNode = function() {
  function TreeNode2() {
    this.children = {};
    this.childCount = 0;
    this.value = null;
  }
  return TreeNode2;
}();
var Tree = function() {
  function Tree2(name_, parent_, node_) {
    if (name_ === void 0) {
      name_ = "";
    }
    if (parent_ === void 0) {
      parent_ = null;
    }
    if (node_ === void 0) {
      node_ = new TreeNode();
    }
    this.name_ = name_;
    this.parent_ = parent_;
    this.node_ = node_;
  }
  Tree2.prototype.subTree = function(pathObj) {
    var path = pathObj instanceof Path ? pathObj : new Path(pathObj);
    var child2 = this, next = path.getFront();
    while (next !== null) {
      var childNode = safeGet(child2.node_.children, next) || new TreeNode();
      child2 = new Tree2(next, child2, childNode);
      path = path.popFront();
      next = path.getFront();
    }
    return child2;
  };
  Tree2.prototype.getValue = function() {
    return this.node_.value;
  };
  Tree2.prototype.setValue = function(value) {
    assert(typeof value !== "undefined", "Cannot set value to undefined");
    this.node_.value = value;
    this.updateParents_();
  };
  Tree2.prototype.clear = function() {
    this.node_.value = null;
    this.node_.children = {};
    this.node_.childCount = 0;
    this.updateParents_();
  };
  Tree2.prototype.hasChildren = function() {
    return this.node_.childCount > 0;
  };
  Tree2.prototype.isEmpty = function() {
    return this.getValue() === null && !this.hasChildren();
  };
  Tree2.prototype.forEachChild = function(action) {
    var _this = this;
    each(this.node_.children, function(child2, childTree) {
      action(new Tree2(child2, _this, childTree));
    });
  };
  Tree2.prototype.forEachDescendant = function(action, includeSelf, childrenFirst) {
    if (includeSelf && !childrenFirst) {
      action(this);
    }
    this.forEachChild(function(child2) {
      child2.forEachDescendant(action, true, childrenFirst);
    });
    if (includeSelf && childrenFirst) {
      action(this);
    }
  };
  Tree2.prototype.forEachAncestor = function(action, includeSelf) {
    var node = includeSelf ? this : this.parent();
    while (node !== null) {
      if (action(node)) {
        return true;
      }
      node = node.parent();
    }
    return false;
  };
  Tree2.prototype.forEachImmediateDescendantWithValue = function(action) {
    this.forEachChild(function(child2) {
      if (child2.getValue() !== null) {
        action(child2);
      } else {
        child2.forEachImmediateDescendantWithValue(action);
      }
    });
  };
  Tree2.prototype.path = function() {
    return new Path(this.parent_ === null ? this.name_ : this.parent_.path() + "/" + this.name_);
  };
  Tree2.prototype.name = function() {
    return this.name_;
  };
  Tree2.prototype.parent = function() {
    return this.parent_;
  };
  Tree2.prototype.updateParents_ = function() {
    if (this.parent_ !== null) {
      this.parent_.updateChild_(this.name_, this);
    }
  };
  Tree2.prototype.updateChild_ = function(childName, child2) {
    var childEmpty = child2.isEmpty();
    var childExists = contains(this.node_.children, childName);
    if (childEmpty && childExists) {
      delete this.node_.children[childName];
      this.node_.childCount--;
      this.updateParents_();
    } else if (!childEmpty && !childExists) {
      this.node_.children[childName] = child2.node_;
      this.node_.childCount++;
      this.updateParents_();
    }
  };
  return Tree2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TransactionStatus;
(function(TransactionStatus2) {
  TransactionStatus2[TransactionStatus2["RUN"] = 0] = "RUN";
  TransactionStatus2[TransactionStatus2["SENT"] = 1] = "SENT";
  TransactionStatus2[TransactionStatus2["COMPLETED"] = 2] = "COMPLETED";
  TransactionStatus2[TransactionStatus2["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
  TransactionStatus2[TransactionStatus2["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
})(TransactionStatus || (TransactionStatus = {}));
Repo.MAX_TRANSACTION_RETRIES_ = 25;
Repo.prototype.transactionsInit_ = function() {
  this.transactionQueueTree_ = new Tree();
};
Repo.prototype.startTransaction = function(path, transactionUpdate, onComplete, applyLocally) {
  this.log_("transaction on " + path);
  var valueCallback = function() {
  };
  var watchRef = new Reference$2(this, path);
  watchRef.on("value", valueCallback);
  var unwatcher = function() {
    watchRef.off("value", valueCallback);
  };
  var transaction = {
    path,
    update: transactionUpdate,
    onComplete,
    status: null,
    order: LUIDGenerator(),
    applyLocally,
    retryCount: 0,
    unwatcher,
    abortReason: null,
    currentWriteId: null,
    currentInputSnapshot: null,
    currentOutputSnapshotRaw: null,
    currentOutputSnapshotResolved: null
  };
  var currentState = this.getLatestState_(path);
  transaction.currentInputSnapshot = currentState;
  var newVal = transaction.update(currentState.val());
  if (newVal === void 0) {
    transaction.unwatcher();
    transaction.currentOutputSnapshotRaw = null;
    transaction.currentOutputSnapshotResolved = null;
    if (transaction.onComplete) {
      var snapshot = new DataSnapshot(transaction.currentInputSnapshot, new Reference$2(this, transaction.path), PRIORITY_INDEX);
      transaction.onComplete(null, false, snapshot);
    }
  } else {
    validateFirebaseData("transaction failed: Data returned ", newVal, transaction.path);
    transaction.status = TransactionStatus.RUN;
    var queueNode = this.transactionQueueTree_.subTree(path);
    var nodeQueue = queueNode.getValue() || [];
    nodeQueue.push(transaction);
    queueNode.setValue(nodeQueue);
    var priorityForNode = void 0;
    if (typeof newVal === "object" && newVal !== null && contains(newVal, ".priority")) {
      priorityForNode = safeGet(newVal, ".priority");
      assert(isValidPriority(priorityForNode), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.");
    } else {
      var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) || ChildrenNode.EMPTY_NODE;
      priorityForNode = currentNode.getPriority().val();
    }
    priorityForNode = priorityForNode;
    var serverValues = this.generateServerValues();
    var newNodeUnresolved = nodeFromJSON$1(newVal, priorityForNode);
    var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
    transaction.currentOutputSnapshotRaw = newNodeUnresolved;
    transaction.currentOutputSnapshotResolved = newNode;
    transaction.currentWriteId = this.getNextWriteId_();
    var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
    this.eventQueue_.raiseEventsForChangedPath(path, events);
    this.sendReadyTransactions_();
  }
};
Repo.prototype.getLatestState_ = function(path, excludeSets) {
  return this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) || ChildrenNode.EMPTY_NODE;
};
Repo.prototype.sendReadyTransactions_ = function(node) {
  var _this = this;
  if (node === void 0) {
    node = this.transactionQueueTree_;
  }
  if (!node) {
    this.pruneCompletedTransactionsBelowNode_(node);
  }
  if (node.getValue() !== null) {
    var queue2 = this.buildTransactionQueue_(node);
    assert(queue2.length > 0, "Sending zero length transaction queue");
    var allRun = queue2.every(function(transaction) {
      return transaction.status === TransactionStatus.RUN;
    });
    if (allRun) {
      this.sendTransactionQueue_(node.path(), queue2);
    }
  } else if (node.hasChildren()) {
    node.forEachChild(function(childNode) {
      _this.sendReadyTransactions_(childNode);
    });
  }
};
Repo.prototype.sendTransactionQueue_ = function(path, queue2) {
  var _this = this;
  var setsToIgnore = queue2.map(function(txn2) {
    return txn2.currentWriteId;
  });
  var latestState = this.getLatestState_(path, setsToIgnore);
  var snapToSend = latestState;
  var latestHash = latestState.hash();
  for (var i = 0; i < queue2.length; i++) {
    var txn = queue2[i];
    assert(txn.status === TransactionStatus.RUN, "tryToSendTransactionQueue_: items in queue should all be run.");
    txn.status = TransactionStatus.SENT;
    txn.retryCount++;
    var relativePath = Path.relativePath(path, txn.path);
    snapToSend = snapToSend.updateChild(relativePath, txn.currentOutputSnapshotRaw);
  }
  var dataToSend = snapToSend.val(true);
  var pathToSend = path;
  this.server_.put(pathToSend.toString(), dataToSend, function(status) {
    _this.log_("transaction put response", {
      path: pathToSend.toString(),
      status
    });
    var events = [];
    if (status === "ok") {
      var callbacks = [];
      for (var i3 = 0; i3 < queue2.length; i3++) {
        queue2[i3].status = TransactionStatus.COMPLETED;
        events = events.concat(_this.serverSyncTree_.ackUserWrite(queue2[i3].currentWriteId));
        if (queue2[i3].onComplete) {
          var node = queue2[i3].currentOutputSnapshotResolved;
          var ref2 = new Reference$2(_this, queue2[i3].path);
          var snapshot = new DataSnapshot(node, ref2, PRIORITY_INDEX);
          callbacks.push(queue2[i3].onComplete.bind(null, null, true, snapshot));
        }
        queue2[i3].unwatcher();
      }
      _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
      _this.sendReadyTransactions_();
      _this.eventQueue_.raiseEventsForChangedPath(path, events);
      for (var i3 = 0; i3 < callbacks.length; i3++) {
        exceptionGuard(callbacks[i3]);
      }
    } else {
      if (status === "datastale") {
        for (var i3 = 0; i3 < queue2.length; i3++) {
          if (queue2[i3].status === TransactionStatus.SENT_NEEDS_ABORT) {
            queue2[i3].status = TransactionStatus.NEEDS_ABORT;
          } else {
            queue2[i3].status = TransactionStatus.RUN;
          }
        }
      } else {
        warn$2("transaction at " + pathToSend.toString() + " failed: " + status);
        for (var i3 = 0; i3 < queue2.length; i3++) {
          queue2[i3].status = TransactionStatus.NEEDS_ABORT;
          queue2[i3].abortReason = status;
        }
      }
      _this.rerunTransactions_(path);
    }
  }, latestHash);
};
Repo.prototype.rerunTransactions_ = function(changedPath) {
  var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
  var path = rootMostTransactionNode.path();
  var queue2 = this.buildTransactionQueue_(rootMostTransactionNode);
  this.rerunTransactionQueue_(queue2, path);
  return path;
};
Repo.prototype.rerunTransactionQueue_ = function(queue2, path) {
  if (queue2.length === 0) {
    return;
  }
  var callbacks = [];
  var events = [];
  var txnsToRerun = queue2.filter(function(q3) {
    return q3.status === TransactionStatus.RUN;
  });
  var setsToIgnore = txnsToRerun.map(function(q3) {
    return q3.currentWriteId;
  });
  for (var i = 0; i < queue2.length; i++) {
    var transaction = queue2[i];
    var relativePath = Path.relativePath(path, transaction.path);
    var abortTransaction = false, abortReason = void 0;
    assert(relativePath !== null, "rerunTransactionsUnderNode_: relativePath should not be null.");
    if (transaction.status === TransactionStatus.NEEDS_ABORT) {
      abortTransaction = true;
      abortReason = transaction.abortReason;
      events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
    } else if (transaction.status === TransactionStatus.RUN) {
      if (transaction.retryCount >= Repo.MAX_TRANSACTION_RETRIES_) {
        abortTransaction = true;
        abortReason = "maxretry";
        events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
      } else {
        var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
        transaction.currentInputSnapshot = currentNode;
        var newData = queue2[i].update(currentNode.val());
        if (newData !== void 0) {
          validateFirebaseData("transaction failed: Data returned ", newData, transaction.path);
          var newDataNode = nodeFromJSON$1(newData);
          var hasExplicitPriority = typeof newData === "object" && newData != null && contains(newData, ".priority");
          if (!hasExplicitPriority) {
            newDataNode = newDataNode.updatePriority(currentNode.getPriority());
          }
          var oldWriteId = transaction.currentWriteId;
          var serverValues = this.generateServerValues();
          var newNodeResolved = resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
          transaction.currentOutputSnapshotRaw = newDataNode;
          transaction.currentOutputSnapshotResolved = newNodeResolved;
          transaction.currentWriteId = this.getNextWriteId_();
          setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
          events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
          events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
        } else {
          abortTransaction = true;
          abortReason = "nodata";
          events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
        }
      }
    }
    this.eventQueue_.raiseEventsForChangedPath(path, events);
    events = [];
    if (abortTransaction) {
      queue2[i].status = TransactionStatus.COMPLETED;
      (function(unwatcher) {
        setTimeout(unwatcher, Math.floor(0));
      })(queue2[i].unwatcher);
      if (queue2[i].onComplete) {
        if (abortReason === "nodata") {
          var ref2 = new Reference$2(this, queue2[i].path);
          var lastInput = queue2[i].currentInputSnapshot;
          var snapshot = new DataSnapshot(lastInput, ref2, PRIORITY_INDEX);
          callbacks.push(queue2[i].onComplete.bind(null, null, false, snapshot));
        } else {
          callbacks.push(queue2[i].onComplete.bind(null, new Error(abortReason), false, null));
        }
      }
    }
  }
  this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
  for (var i = 0; i < callbacks.length; i++) {
    exceptionGuard(callbacks[i]);
  }
  this.sendReadyTransactions_();
};
Repo.prototype.getAncestorTransactionNode_ = function(path) {
  var front;
  var transactionNode = this.transactionQueueTree_;
  front = path.getFront();
  while (front !== null && transactionNode.getValue() === null) {
    transactionNode = transactionNode.subTree(front);
    path = path.popFront();
    front = path.getFront();
  }
  return transactionNode;
};
Repo.prototype.buildTransactionQueue_ = function(transactionNode) {
  var transactionQueue = [];
  this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
  transactionQueue.sort(function(a3, b3) {
    return a3.order - b3.order;
  });
  return transactionQueue;
};
Repo.prototype.aggregateTransactionQueuesForNode_ = function(node, queue2) {
  var _this = this;
  var nodeQueue = node.getValue();
  if (nodeQueue !== null) {
    for (var i = 0; i < nodeQueue.length; i++) {
      queue2.push(nodeQueue[i]);
    }
  }
  node.forEachChild(function(child2) {
    _this.aggregateTransactionQueuesForNode_(child2, queue2);
  });
};
Repo.prototype.pruneCompletedTransactionsBelowNode_ = function(node) {
  var _this = this;
  var queue2 = node.getValue();
  if (queue2) {
    var to2 = 0;
    for (var from2 = 0; from2 < queue2.length; from2++) {
      if (queue2[from2].status !== TransactionStatus.COMPLETED) {
        queue2[to2] = queue2[from2];
        to2++;
      }
    }
    queue2.length = to2;
    node.setValue(queue2.length > 0 ? queue2 : null);
  }
  node.forEachChild(function(childNode) {
    _this.pruneCompletedTransactionsBelowNode_(childNode);
  });
};
Repo.prototype.abortTransactions_ = function(path) {
  var _this = this;
  var affectedPath = this.getAncestorTransactionNode_(path).path();
  var transactionNode = this.transactionQueueTree_.subTree(path);
  transactionNode.forEachAncestor(function(node) {
    _this.abortTransactionsOnNode_(node);
  });
  this.abortTransactionsOnNode_(transactionNode);
  transactionNode.forEachDescendant(function(node) {
    _this.abortTransactionsOnNode_(node);
  });
  return affectedPath;
};
Repo.prototype.abortTransactionsOnNode_ = function(node) {
  var queue2 = node.getValue();
  if (queue2 !== null) {
    var callbacks = [];
    var events = [];
    var lastSent = -1;
    for (var i = 0; i < queue2.length; i++) {
      if (queue2[i].status === TransactionStatus.SENT_NEEDS_ABORT)
        ;
      else if (queue2[i].status === TransactionStatus.SENT) {
        assert(lastSent === i - 1, "All SENT items should be at beginning of queue.");
        lastSent = i;
        queue2[i].status = TransactionStatus.SENT_NEEDS_ABORT;
        queue2[i].abortReason = "set";
      } else {
        assert(queue2[i].status === TransactionStatus.RUN, "Unexpected transaction status in abort");
        queue2[i].unwatcher();
        events = events.concat(this.serverSyncTree_.ackUserWrite(queue2[i].currentWriteId, true));
        if (queue2[i].onComplete) {
          var snapshot = null;
          callbacks.push(queue2[i].onComplete.bind(null, new Error("set"), false, snapshot));
        }
      }
    }
    if (lastSent === -1) {
      node.setValue(null);
    } else {
      queue2.length = lastSent + 1;
    }
    this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
    for (var i = 0; i < callbacks.length; i++) {
      exceptionGuard(callbacks[i]);
    }
  }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FirebaseAuthTokenProvider = function() {
  function FirebaseAuthTokenProvider2(app_, authProvider_) {
    var _this = this;
    this.app_ = app_;
    this.authProvider_ = authProvider_;
    this.auth_ = null;
    this.auth_ = authProvider_.getImmediate({ optional: true });
    if (!this.auth_) {
      authProvider_.get().then(function(auth) {
        return _this.auth_ = auth;
      });
    }
  }
  FirebaseAuthTokenProvider2.prototype.getToken = function(forceRefresh) {
    if (!this.auth_) {
      return Promise.resolve(null);
    }
    return this.auth_.getToken(forceRefresh).catch(function(error2) {
      if (error2 && error2.code === "auth/token-not-initialized") {
        log("Got auth/token-not-initialized error.  Treating as null token.");
        return null;
      } else {
        return Promise.reject(error2);
      }
    });
  };
  FirebaseAuthTokenProvider2.prototype.addTokenChangeListener = function(listener) {
    if (this.auth_) {
      this.auth_.addAuthTokenListener(listener);
    } else {
      setTimeout(function() {
        return listener(null);
      }, 0);
      this.authProvider_.get().then(function(auth) {
        return auth.addAuthTokenListener(listener);
      });
    }
  };
  FirebaseAuthTokenProvider2.prototype.removeTokenChangeListener = function(listener) {
    this.authProvider_.get().then(function(auth) {
      return auth.removeAuthTokenListener(listener);
    });
  };
  FirebaseAuthTokenProvider2.prototype.notifyForInvalidToken = function() {
    var errorMessage = 'Provided authentication credentials for the app named "' + this.app_.name + '" are invalid. This usually indicates your app was not initialized correctly. ';
    if ("credential" in this.app_.options) {
      errorMessage += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
    } else if ("serviceAccount" in this.app_.options) {
      errorMessage += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
    } else {
      errorMessage += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.';
    }
    warn$2(errorMessage);
  };
  return FirebaseAuthTokenProvider2;
}();
var EmulatorAdminTokenProvider = function() {
  function EmulatorAdminTokenProvider2() {
  }
  EmulatorAdminTokenProvider2.prototype.getToken = function(forceRefresh) {
    return Promise.resolve({
      accessToken: EmulatorAdminTokenProvider2.EMULATOR_AUTH_TOKEN
    });
  };
  EmulatorAdminTokenProvider2.prototype.addTokenChangeListener = function(listener) {
    listener(EmulatorAdminTokenProvider2.EMULATOR_AUTH_TOKEN);
  };
  EmulatorAdminTokenProvider2.prototype.removeTokenChangeListener = function(listener) {
  };
  EmulatorAdminTokenProvider2.prototype.notifyForInvalidToken = function() {
  };
  EmulatorAdminTokenProvider2.EMULATOR_AUTH_TOKEN = "owner";
  return EmulatorAdminTokenProvider2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FIREBASE_DATABASE_EMULATOR_HOST_VAR = "FIREBASE_DATABASE_EMULATOR_HOST";
var _staticInstance;
var RepoManager = function() {
  function RepoManager2() {
    this.repos_ = {};
    this.useRestClient_ = false;
  }
  RepoManager2.getInstance = function() {
    if (!_staticInstance) {
      _staticInstance = new RepoManager2();
    }
    return _staticInstance;
  };
  RepoManager2.prototype.interrupt = function() {
    var e_1, _a2, e_2, _b2;
    try {
      for (var _c2 = __values$1(Object.keys(this.repos_)), _d2 = _c2.next(); !_d2.done; _d2 = _c2.next()) {
        var appName = _d2.value;
        try {
          for (var _e2 = (e_2 = void 0, __values$1(Object.keys(this.repos_[appName]))), _f = _e2.next(); !_f.done; _f = _e2.next()) {
            var dbUrl = _f.value;
            this.repos_[appName][dbUrl].interrupt();
          }
        } catch (e_2_1) {
          e_2 = { error: e_2_1 };
        } finally {
          try {
            if (_f && !_f.done && (_b2 = _e2.return))
              _b2.call(_e2);
          } finally {
            if (e_2)
              throw e_2.error;
          }
        }
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (_d2 && !_d2.done && (_a2 = _c2.return))
          _a2.call(_c2);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
  };
  RepoManager2.prototype.resume = function() {
    var e_3, _a2, e_4, _b2;
    try {
      for (var _c2 = __values$1(Object.keys(this.repos_)), _d2 = _c2.next(); !_d2.done; _d2 = _c2.next()) {
        var appName = _d2.value;
        try {
          for (var _e2 = (e_4 = void 0, __values$1(Object.keys(this.repos_[appName]))), _f = _e2.next(); !_f.done; _f = _e2.next()) {
            var dbUrl = _f.value;
            this.repos_[appName][dbUrl].resume();
          }
        } catch (e_4_1) {
          e_4 = { error: e_4_1 };
        } finally {
          try {
            if (_f && !_f.done && (_b2 = _e2.return))
              _b2.call(_e2);
          } finally {
            if (e_4)
              throw e_4.error;
          }
        }
      }
    } catch (e_3_1) {
      e_3 = { error: e_3_1 };
    } finally {
      try {
        if (_d2 && !_d2.done && (_a2 = _c2.return))
          _a2.call(_c2);
      } finally {
        if (e_3)
          throw e_3.error;
      }
    }
  };
  RepoManager2.prototype.applyEmulatorSettings = function(repo, host, port) {
    repo.repoInfo_ = new RepoInfo(host + ":" + port, false, repo.repoInfo_.namespace, repo.repoInfo_.webSocketOnly, repo.repoInfo_.nodeAdmin, repo.repoInfo_.persistenceKey, repo.repoInfo_.includeNamespaceInQueryParams);
    if (repo.repoInfo_.nodeAdmin) {
      repo.authTokenProvider_ = new EmulatorAdminTokenProvider();
    }
  };
  RepoManager2.prototype.databaseFromApp = function(app, authProvider, url, nodeAdmin) {
    var dbUrl = url || app.options.databaseURL;
    if (dbUrl === void 0) {
      if (!app.options.projectId) {
        fatal("Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp().");
      }
      log("Using default host for project ", app.options.projectId);
      dbUrl = app.options.projectId + "-default-rtdb.firebaseio.com";
    }
    var parsedUrl = parseRepoInfo(dbUrl, nodeAdmin);
    var repoInfo = parsedUrl.repoInfo;
    var isEmulator;
    var dbEmulatorHost = void 0;
    if (typeof process !== "undefined") {
      dbEmulatorHost = process.env[FIREBASE_DATABASE_EMULATOR_HOST_VAR];
    }
    if (dbEmulatorHost) {
      isEmulator = true;
      dbUrl = "http://" + dbEmulatorHost + "?ns=" + repoInfo.namespace;
      parsedUrl = parseRepoInfo(dbUrl, nodeAdmin);
      repoInfo = parsedUrl.repoInfo;
    } else {
      isEmulator = !parsedUrl.repoInfo.secure;
    }
    var authTokenProvider = nodeAdmin && isEmulator ? new EmulatorAdminTokenProvider() : new FirebaseAuthTokenProvider(app, authProvider);
    validateUrl("Invalid Firebase Database URL", 1, parsedUrl);
    if (!parsedUrl.path.isEmpty()) {
      fatal("Database URL must point to the root of a Firebase Database (not including a child path).");
    }
    var repo = this.createRepo(repoInfo, app, authTokenProvider);
    return repo.database;
  };
  RepoManager2.prototype.deleteRepo = function(repo) {
    var appRepos = safeGet(this.repos_, repo.app.name);
    if (!appRepos || safeGet(appRepos, repo.key) !== repo) {
      fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
    }
    repo.interrupt();
    delete appRepos[repo.key];
  };
  RepoManager2.prototype.createRepo = function(repoInfo, app, authTokenProvider) {
    var appRepos = safeGet(this.repos_, app.name);
    if (!appRepos) {
      appRepos = {};
      this.repos_[app.name] = appRepos;
    }
    var repo = safeGet(appRepos, repoInfo.toURLString());
    if (repo) {
      fatal("Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.");
    }
    repo = new Repo(repoInfo, this.useRestClient_, app, authTokenProvider);
    appRepos[repoInfo.toURLString()] = repo;
    return repo;
  };
  RepoManager2.prototype.forceRestClient = function(forceRestClient2) {
    this.useRestClient_ = forceRestClient2;
  };
  return RepoManager2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Database = function() {
  function Database2(repoInternal_) {
    var _this = this;
    this.repoInternal_ = repoInternal_;
    this.instanceStarted_ = false;
    this.INTERNAL = {
      delete: function() {
        return __awaiter(_this, void 0, void 0, function() {
          return __generator(this, function(_a2) {
            this.checkDeleted_("delete");
            RepoManager.getInstance().deleteRepo(this.repo_);
            this.repoInternal_ = null;
            this.rootInternal_ = null;
            return [2];
          });
        });
      }
    };
    if (!(repoInternal_ instanceof Repo)) {
      fatal("Don't call new Database() directly - please use firebase.database().");
    }
  }
  Object.defineProperty(Database2.prototype, "repo_", {
    get: function() {
      if (!this.instanceStarted_) {
        this.repoInternal_.start();
        this.instanceStarted_ = true;
      }
      return this.repoInternal_;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Database2.prototype, "root_", {
    get: function() {
      if (!this.rootInternal_) {
        this.rootInternal_ = new Reference$2(this.repo_, Path.Empty);
      }
      return this.rootInternal_;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Database2.prototype, "app", {
    get: function() {
      return this.repo_.app;
    },
    enumerable: false,
    configurable: true
  });
  Database2.prototype.useEmulator = function(host, port) {
    this.checkDeleted_("useEmulator");
    if (this.instanceStarted_) {
      fatal("Cannot call useEmulator() after instance has already been initialized.");
      return;
    }
    RepoManager.getInstance().applyEmulatorSettings(this.repoInternal_, host, port);
  };
  Database2.prototype.ref = function(path) {
    this.checkDeleted_("ref");
    validateArgCount("database.ref", 0, 1, arguments.length);
    if (path instanceof Reference$2) {
      return this.refFromURL(path.toString());
    }
    return path !== void 0 ? this.root_.child(path) : this.root_;
  };
  Database2.prototype.refFromURL = function(url) {
    var apiName = "database.refFromURL";
    this.checkDeleted_(apiName);
    validateArgCount(apiName, 1, 1, arguments.length);
    var parsedURL = parseRepoInfo(url, this.repo_.repoInfo_.nodeAdmin);
    validateUrl(apiName, 1, parsedURL);
    var repoInfo = parsedURL.repoInfo;
    if (!repoInfo.isCustomHost() && repoInfo.host !== this.repo_.repoInfo_.host) {
      fatal(apiName + ": Host name does not match the current database: (found " + repoInfo.host + " but expected " + this.repo_.repoInfo_.host + ")");
    }
    return this.ref(parsedURL.path.toString());
  };
  Database2.prototype.checkDeleted_ = function(apiName) {
    if (this.repoInternal_ === null) {
      fatal("Cannot call " + apiName + " on a deleted database.");
    }
  };
  Database2.prototype.goOffline = function() {
    validateArgCount("database.goOffline", 0, 0, arguments.length);
    this.checkDeleted_("goOffline");
    this.repo_.interrupt();
  };
  Database2.prototype.goOnline = function() {
    validateArgCount("database.goOnline", 0, 0, arguments.length);
    this.checkDeleted_("goOnline");
    this.repo_.resume();
  };
  Database2.ServerValue = {
    TIMESTAMP: {
      ".sv": "timestamp"
    },
    increment: function(delta) {
      return {
        ".sv": {
          "increment": delta
        }
      };
    }
  };
  return Database2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var forceLongPolling = function() {
  WebSocketConnection.forceDisallow();
  BrowserPollConnection.forceAllow();
};
var forceWebSockets = function() {
  BrowserPollConnection.forceDisallow();
};
var isWebSocketsAvailable = function() {
  return WebSocketConnection["isAvailable"]();
};
var setSecurityDebugCallback = function(ref2, callback) {
  ref2.repo.persistentConnection_.securityDebugCallback_ = callback;
};
var stats = function(ref2, showDelta) {
  ref2.repo.stats(showDelta);
};
var statsIncrementCounter = function(ref2, metric) {
  ref2.repo.statsIncrementCounter(metric);
};
var dataUpdateCount = function(ref2) {
  return ref2.repo.dataUpdateCount;
};
var interceptServerData = function(ref2, callback) {
  return ref2.repo.interceptServerData_(callback);
};
function initStandalone(_a2) {
  var app = _a2.app, url = _a2.url, version2 = _a2.version, customAuthImpl = _a2.customAuthImpl, namespace = _a2.namespace, _b2 = _a2.nodeAdmin, nodeAdmin = _b2 === void 0 ? false : _b2;
  setSDKVersion(version2);
  var authProvider = new Provider("auth-internal", new ComponentContainer("database-standalone"));
  authProvider.setComponent(new Component("auth-internal", function() {
    return customAuthImpl;
  }, "PRIVATE"));
  return {
    instance: RepoManager.getInstance().databaseFromApp(app, authProvider, url, nodeAdmin),
    namespace
  };
}
var INTERNAL = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  forceLongPolling,
  forceWebSockets,
  isWebSocketsAvailable,
  setSecurityDebugCallback,
  stats,
  statsIncrementCounter,
  dataUpdateCount,
  interceptServerData,
  initStandalone
});
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DataConnection = PersistentConnection;
PersistentConnection.prototype.simpleListen = function(pathString, onComplete) {
  this.sendRequest("q", { p: pathString }, onComplete);
};
PersistentConnection.prototype.echo = function(data, onEcho) {
  this.sendRequest("echo", { d: data }, onEcho);
};
var RealTimeConnection = Connection;
var hijackHash = function(newHash) {
  var oldPut = PersistentConnection.prototype.put;
  PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
    if (hash !== void 0) {
      hash = newHash();
    }
    oldPut.call(this, pathString, data, onComplete, hash);
  };
  return function() {
    PersistentConnection.prototype.put = oldPut;
  };
};
var ConnectionTarget = RepoInfo;
var queryIdentifier = function(query2) {
  return query2.queryIdentifier();
};
var forceRestClient = function(forceRestClient2) {
  RepoManager.getInstance().forceRestClient(forceRestClient2);
};
var TEST_ACCESS = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  DataConnection,
  RealTimeConnection,
  hijackHash,
  ConnectionTarget,
  queryIdentifier,
  forceRestClient
});
var name$8 = "@firebase/database";
var version$8 = "0.8.1";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ServerValue = Database.ServerValue;
function registerDatabase(instance) {
  setSDKVersion(instance.SDK_VERSION);
  instance.INTERNAL.registerComponent(new Component("database", function(container, url) {
    var app = container.getProvider("app").getImmediate();
    var authProvider = container.getProvider("auth-internal");
    return RepoManager.getInstance().databaseFromApp(app, authProvider, url);
  }, "PUBLIC").setServiceProps({
    Reference: Reference$2,
    Query,
    Database,
    DataSnapshot,
    enableLogging,
    INTERNAL,
    ServerValue,
    TEST_ACCESS
  }).setMultipleInstances(true));
  instance.registerVersion(name$8, version$8);
}
registerDatabase(firebase$1);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(d3, b3) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d6, b10) {
    d6.__proto__ = b10;
  } || function(d6, b10) {
    for (var p3 in b10)
      if (Object.prototype.hasOwnProperty.call(b10, p3))
        d6[p3] = b10[p3];
  };
  return extendStatics(d3, b3);
};
function __extends(d3, b3) {
  extendStatics(d3, b3);
  function __() {
    this.constructor = d3;
  }
  d3.prototype = b3 === null ? Object.create(b3) : (__.prototype = b3.prototype, new __());
}
function __values(o3) {
  var s3 = typeof Symbol === "function" && Symbol.iterator, m3 = s3 && o3[s3], i = 0;
  if (m3)
    return m3.call(o3);
  if (o3 && typeof o3.length === "number")
    return {
      next: function() {
        if (o3 && i >= o3.length)
          o3 = void 0;
        return { value: o3 && o3[i++], done: !o3 };
      }
    };
  throw new TypeError(s3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
var commonjsGlobal$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var h, goog = goog || {}, k$1 = commonjsGlobal$1 || self;
function aa$1() {
}
function ba$1(a3) {
  var b3 = typeof a3;
  b3 = b3 != "object" ? b3 : a3 ? Array.isArray(a3) ? "array" : b3 : "null";
  return b3 == "array" || b3 == "object" && typeof a3.length == "number";
}
function n(a3) {
  var b3 = typeof a3;
  return b3 == "object" && a3 != null || b3 == "function";
}
function ca$1(a3) {
  return Object.prototype.hasOwnProperty.call(a3, da$1) && a3[da$1] || (a3[da$1] = ++ea$1);
}
var da$1 = "closure_uid_" + (1e9 * Math.random() >>> 0), ea$1 = 0;
function fa$1(a3, b3, c3) {
  return a3.call.apply(a3.bind, arguments);
}
function ha$1(a3, b3, c3) {
  if (!a3)
    throw Error();
  if (2 < arguments.length) {
    var d3 = Array.prototype.slice.call(arguments, 2);
    return function() {
      var e28 = Array.prototype.slice.call(arguments);
      Array.prototype.unshift.apply(e28, d3);
      return a3.apply(b3, e28);
    };
  }
  return function() {
    return a3.apply(b3, arguments);
  };
}
function p(a3, b3, c3) {
  Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? p = fa$1 : p = ha$1;
  return p.apply(null, arguments);
}
function ja$1(a3, b3) {
  var c3 = Array.prototype.slice.call(arguments, 1);
  return function() {
    var d3 = c3.slice();
    d3.push.apply(d3, arguments);
    return a3.apply(this, d3);
  };
}
function q$1() {
  return Date.now();
}
function r(a3, b3) {
  function c3() {
  }
  c3.prototype = b3.prototype;
  a3.X = b3.prototype;
  a3.prototype = new c3();
  a3.prototype.constructor = a3;
  a3.Kb = function(d3, e28, f3) {
    for (var g3 = Array(arguments.length - 2), m3 = 2; m3 < arguments.length; m3++)
      g3[m3 - 2] = arguments[m3];
    return b3.prototype[e28].apply(d3, g3);
  };
}
function t() {
  this.j = this.j;
  this.i = this.i;
}
var ka$1 = 0;
t.prototype.j = false;
t.prototype.ja = function() {
  if (!this.j && (this.j = true, this.G(), ka$1 != 0)) {
    ca$1(this);
  }
};
t.prototype.G = function() {
  if (this.i)
    for (; this.i.length; )
      this.i.shift()();
};
var ma$1 = Array.prototype.indexOf ? function(a3, b3) {
  return Array.prototype.indexOf.call(a3, b3, void 0);
} : function(a3, b3) {
  if (typeof a3 === "string")
    return typeof b3 !== "string" || b3.length != 1 ? -1 : a3.indexOf(b3, 0);
  for (var c3 = 0; c3 < a3.length; c3++)
    if (c3 in a3 && a3[c3] === b3)
      return c3;
  return -1;
}, na$1 = Array.prototype.forEach ? function(a3, b3, c3) {
  Array.prototype.forEach.call(a3, b3, c3);
} : function(a3, b3, c3) {
  for (var d3 = a3.length, e28 = typeof a3 === "string" ? a3.split("") : a3, f3 = 0; f3 < d3; f3++)
    f3 in e28 && b3.call(c3, e28[f3], f3, a3);
};
function oa$1(a3) {
  a: {
    var b3 = pa$1;
    for (var c3 = a3.length, d3 = typeof a3 === "string" ? a3.split("") : a3, e28 = 0; e28 < c3; e28++)
      if (e28 in d3 && b3.call(void 0, d3[e28], e28, a3)) {
        b3 = e28;
        break a;
      }
    b3 = -1;
  }
  return 0 > b3 ? null : typeof a3 === "string" ? a3.charAt(b3) : a3[b3];
}
function qa$1(a3) {
  return Array.prototype.concat.apply([], arguments);
}
function ra$1(a3) {
  var b3 = a3.length;
  if (0 < b3) {
    for (var c3 = Array(b3), d3 = 0; d3 < b3; d3++)
      c3[d3] = a3[d3];
    return c3;
  }
  return [];
}
function sa$1(a3) {
  return /^[\s\xa0]*$/.test(a3);
}
var ta$1 = String.prototype.trim ? function(a3) {
  return a3.trim();
} : function(a3) {
  return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a3)[1];
};
function v(a3, b3) {
  return a3.indexOf(b3) != -1;
}
function ua$1(a3, b3) {
  return a3 < b3 ? -1 : a3 > b3 ? 1 : 0;
}
var w;
a: {
  var va$1 = k$1.navigator;
  if (va$1) {
    var wa$1 = va$1.userAgent;
    if (wa$1) {
      w = wa$1;
      break a;
    }
  }
  w = "";
}
function za$1(a3, b3, c3) {
  for (var d3 in a3)
    b3.call(c3, a3[d3], d3, a3);
}
function Aa$1(a3) {
  var b3 = {};
  for (var c3 in a3)
    b3[c3] = a3[c3];
  return b3;
}
var Ba$1 = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function Ca$1(a3, b3) {
  var c3, d3;
  for (var e28 = 1; e28 < arguments.length; e28++) {
    d3 = arguments[e28];
    for (c3 in d3)
      a3[c3] = d3[c3];
    for (var f3 = 0; f3 < Ba$1.length; f3++)
      c3 = Ba$1[f3], Object.prototype.hasOwnProperty.call(d3, c3) && (a3[c3] = d3[c3]);
  }
}
function Da$1(a3) {
  Da$1[" "](a3);
  return a3;
}
Da$1[" "] = aa$1;
function Ea$1(a3, b3) {
  var c3 = Fa$1;
  return Object.prototype.hasOwnProperty.call(c3, a3) ? c3[a3] : c3[a3] = b3(a3);
}
var Ga$1 = v(w, "Opera"), x$1 = v(w, "Trident") || v(w, "MSIE"), Ha$1 = v(w, "Edge"), Ia$1 = Ha$1 || x$1, Ja$1 = v(w, "Gecko") && !(v(w.toLowerCase(), "webkit") && !v(w, "Edge")) && !(v(w, "Trident") || v(w, "MSIE")) && !v(w, "Edge"), Ka$1 = v(w.toLowerCase(), "webkit") && !v(w, "Edge");
function La$1() {
  var a3 = k$1.document;
  return a3 ? a3.documentMode : void 0;
}
var Ma$1;
a: {
  var Na$1 = "", Oa$1 = function() {
    var a3 = w;
    if (Ja$1)
      return /rv:([^\);]+)(\)|;)/.exec(a3);
    if (Ha$1)
      return /Edge\/([\d\.]+)/.exec(a3);
    if (x$1)
      return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a3);
    if (Ka$1)
      return /WebKit\/(\S+)/.exec(a3);
    if (Ga$1)
      return /(?:Version)[ \/]?(\S+)/.exec(a3);
  }();
  Oa$1 && (Na$1 = Oa$1 ? Oa$1[1] : "");
  if (x$1) {
    var Pa$1 = La$1();
    if (Pa$1 != null && Pa$1 > parseFloat(Na$1)) {
      Ma$1 = String(Pa$1);
      break a;
    }
  }
  Ma$1 = Na$1;
}
var Fa$1 = {};
function Qa$1(a3) {
  return Ea$1(a3, function() {
    {
      var b3 = 0;
      var e28 = ta$1(String(Ma$1)).split("."), f3 = ta$1(String(a3)).split("."), g3 = Math.max(e28.length, f3.length);
      for (var m3 = 0; b3 == 0 && m3 < g3; m3++) {
        var c3 = e28[m3] || "", d3 = f3[m3] || "";
        do {
          c3 = /(\d*)(\D*)(.*)/.exec(c3) || ["", "", "", ""];
          d3 = /(\d*)(\D*)(.*)/.exec(d3) || ["", "", "", ""];
          if (c3[0].length == 0 && d3[0].length == 0)
            break;
          b3 = ua$1(c3[1].length == 0 ? 0 : parseInt(c3[1], 10), d3[1].length == 0 ? 0 : parseInt(d3[1], 10)) || ua$1(c3[2].length == 0, d3[2].length == 0) || ua$1(c3[2], d3[2]);
          c3 = c3[3];
          d3 = d3[3];
        } while (b3 == 0);
      }
    }
    return 0 <= b3;
  });
}
var Ra$1;
if (k$1.document && x$1) {
  var Sa$1 = La$1();
  Ra$1 = Sa$1 ? Sa$1 : parseInt(Ma$1, 10) || void 0;
} else
  Ra$1 = void 0;
var Ta$1 = Ra$1;
var Ua$1 = !x$1 || 9 <= Number(Ta$1), Va$1 = x$1 && !Qa$1("9"), Wa$1 = function() {
  if (!k$1.addEventListener || !Object.defineProperty)
    return false;
  var a3 = false, b3 = Object.defineProperty({}, "passive", { get: function() {
    a3 = true;
  } });
  try {
    k$1.addEventListener("test", aa$1, b3), k$1.removeEventListener("test", aa$1, b3);
  } catch (c3) {
  }
  return a3;
}();
function y(a3, b3) {
  this.type = a3;
  this.a = this.target = b3;
  this.defaultPrevented = false;
}
y.prototype.b = function() {
  this.defaultPrevented = true;
};
function z$1(a3, b3) {
  y.call(this, a3 ? a3.type : "");
  this.relatedTarget = this.a = this.target = null;
  this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
  this.key = "";
  this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = false;
  this.pointerId = 0;
  this.pointerType = "";
  this.c = null;
  if (a3) {
    var c3 = this.type = a3.type, d3 = a3.changedTouches && a3.changedTouches.length ? a3.changedTouches[0] : null;
    this.target = a3.target || a3.srcElement;
    this.a = b3;
    if (b3 = a3.relatedTarget) {
      if (Ja$1) {
        a: {
          try {
            Da$1(b3.nodeName);
            var e28 = true;
            break a;
          } catch (f3) {
          }
          e28 = false;
        }
        e28 || (b3 = null);
      }
    } else
      c3 == "mouseover" ? b3 = a3.fromElement : c3 == "mouseout" && (b3 = a3.toElement);
    this.relatedTarget = b3;
    d3 ? (this.clientX = d3.clientX !== void 0 ? d3.clientX : d3.pageX, this.clientY = d3.clientY !== void 0 ? d3.clientY : d3.pageY, this.screenX = d3.screenX || 0, this.screenY = d3.screenY || 0) : (this.clientX = a3.clientX !== void 0 ? a3.clientX : a3.pageX, this.clientY = a3.clientY !== void 0 ? a3.clientY : a3.pageY, this.screenX = a3.screenX || 0, this.screenY = a3.screenY || 0);
    this.button = a3.button;
    this.key = a3.key || "";
    this.ctrlKey = a3.ctrlKey;
    this.altKey = a3.altKey;
    this.shiftKey = a3.shiftKey;
    this.metaKey = a3.metaKey;
    this.pointerId = a3.pointerId || 0;
    this.pointerType = typeof a3.pointerType === "string" ? a3.pointerType : Xa$1[a3.pointerType] || "";
    this.c = a3;
    a3.defaultPrevented && this.b();
  }
}
r(z$1, y);
var Xa$1 = { 2: "touch", 3: "pen", 4: "mouse" };
z$1.prototype.b = function() {
  z$1.X.b.call(this);
  var a3 = this.c;
  if (a3.preventDefault)
    a3.preventDefault();
  else if (a3.returnValue = false, Va$1)
    try {
      if (a3.ctrlKey || 112 <= a3.keyCode && 123 >= a3.keyCode)
        a3.keyCode = -1;
    } catch (b3) {
    }
};
var A$1 = "closure_listenable_" + (1e6 * Math.random() | 0), Ya$1 = 0;
function Za$1(a3, b3, c3, d3, e28) {
  this.listener = a3;
  this.proxy = null;
  this.src = b3;
  this.type = c3;
  this.capture = !!d3;
  this.ca = e28;
  this.key = ++Ya$1;
  this.Y = this.Z = false;
}
function $a$1(a3) {
  a3.Y = true;
  a3.listener = null;
  a3.proxy = null;
  a3.src = null;
  a3.ca = null;
}
function ab(a3) {
  this.src = a3;
  this.a = {};
  this.b = 0;
}
ab.prototype.add = function(a3, b3, c3, d3, e28) {
  var f3 = a3.toString();
  a3 = this.a[f3];
  a3 || (a3 = this.a[f3] = [], this.b++);
  var g3 = bb(a3, b3, d3, e28);
  -1 < g3 ? (b3 = a3[g3], c3 || (b3.Z = false)) : (b3 = new Za$1(b3, this.src, f3, !!d3, e28), b3.Z = c3, a3.push(b3));
  return b3;
};
function cb(a3, b3) {
  var c3 = b3.type;
  if (c3 in a3.a) {
    var d3 = a3.a[c3], e28 = ma$1(d3, b3), f3;
    (f3 = 0 <= e28) && Array.prototype.splice.call(d3, e28, 1);
    f3 && ($a$1(b3), a3.a[c3].length == 0 && (delete a3.a[c3], a3.b--));
  }
}
function bb(a3, b3, c3, d3) {
  for (var e28 = 0; e28 < a3.length; ++e28) {
    var f3 = a3[e28];
    if (!f3.Y && f3.listener == b3 && f3.capture == !!c3 && f3.ca == d3)
      return e28;
  }
  return -1;
}
var db = "closure_lm_" + (1e6 * Math.random() | 0), eb = {};
function gb(a3, b3, c3, d3, e28) {
  if (d3 && d3.once)
    return hb(a3, b3, c3, d3, e28);
  if (Array.isArray(b3)) {
    for (var f3 = 0; f3 < b3.length; f3++)
      gb(a3, b3[f3], c3, d3, e28);
    return null;
  }
  c3 = ib(c3);
  return a3 && a3[A$1] ? a3.va(b3, c3, n(d3) ? !!d3.capture : !!d3, e28) : jb(a3, b3, c3, false, d3, e28);
}
function jb(a3, b3, c3, d3, e28, f3) {
  if (!b3)
    throw Error("Invalid event type");
  var g3 = n(e28) ? !!e28.capture : !!e28;
  if (g3 && !Ua$1)
    return null;
  var m3 = kb(a3);
  m3 || (a3[db] = m3 = new ab(a3));
  c3 = m3.add(b3, c3, d3, g3, f3);
  if (c3.proxy)
    return c3;
  d3 = lb();
  c3.proxy = d3;
  d3.src = a3;
  d3.listener = c3;
  if (a3.addEventListener)
    Wa$1 || (e28 = g3), e28 === void 0 && (e28 = false), a3.addEventListener(b3.toString(), d3, e28);
  else if (a3.attachEvent)
    a3.attachEvent(mb(b3.toString()), d3);
  else if (a3.addListener && a3.removeListener)
    a3.addListener(d3);
  else
    throw Error("addEventListener and attachEvent are unavailable.");
  return c3;
}
function lb() {
  var a3 = nb, b3 = Ua$1 ? function(c3) {
    return a3.call(b3.src, b3.listener, c3);
  } : function(c3) {
    c3 = a3.call(b3.src, b3.listener, c3);
    if (!c3)
      return c3;
  };
  return b3;
}
function hb(a3, b3, c3, d3, e28) {
  if (Array.isArray(b3)) {
    for (var f3 = 0; f3 < b3.length; f3++)
      hb(a3, b3[f3], c3, d3, e28);
    return null;
  }
  c3 = ib(c3);
  return a3 && a3[A$1] ? a3.wa(b3, c3, n(d3) ? !!d3.capture : !!d3, e28) : jb(a3, b3, c3, true, d3, e28);
}
function ob(a3, b3, c3, d3, e28) {
  if (Array.isArray(b3))
    for (var f3 = 0; f3 < b3.length; f3++)
      ob(a3, b3[f3], c3, d3, e28);
  else
    (d3 = n(d3) ? !!d3.capture : !!d3, c3 = ib(c3), a3 && a3[A$1]) ? (a3 = a3.c, b3 = String(b3).toString(), b3 in a3.a && (f3 = a3.a[b3], c3 = bb(f3, c3, d3, e28), -1 < c3 && ($a$1(f3[c3]), Array.prototype.splice.call(f3, c3, 1), f3.length == 0 && (delete a3.a[b3], a3.b--)))) : a3 && (a3 = kb(a3)) && (b3 = a3.a[b3.toString()], a3 = -1, b3 && (a3 = bb(b3, c3, d3, e28)), (c3 = -1 < a3 ? b3[a3] : null) && pb(c3));
}
function pb(a3) {
  if (typeof a3 !== "number" && a3 && !a3.Y) {
    var b3 = a3.src;
    if (b3 && b3[A$1])
      cb(b3.c, a3);
    else {
      var c3 = a3.type, d3 = a3.proxy;
      b3.removeEventListener ? b3.removeEventListener(c3, d3, a3.capture) : b3.detachEvent ? b3.detachEvent(mb(c3), d3) : b3.addListener && b3.removeListener && b3.removeListener(d3);
      (c3 = kb(b3)) ? (cb(c3, a3), c3.b == 0 && (c3.src = null, b3[db] = null)) : $a$1(a3);
    }
  }
}
function mb(a3) {
  return a3 in eb ? eb[a3] : eb[a3] = "on" + a3;
}
function qb(a3, b3) {
  var c3 = a3.listener, d3 = a3.ca || a3.src;
  a3.Z && pb(a3);
  return c3.call(d3, b3);
}
function nb(a3, b3) {
  if (a3.Y)
    return true;
  if (!Ua$1) {
    if (!b3)
      a: {
        b3 = ["window", "event"];
        for (var c3 = k$1, d3 = 0; d3 < b3.length; d3++)
          if (c3 = c3[b3[d3]], c3 == null) {
            b3 = null;
            break a;
          }
        b3 = c3;
      }
    b3 = new z$1(b3, this);
    return qb(a3, b3);
  }
  return qb(a3, new z$1(b3, this));
}
function kb(a3) {
  a3 = a3[db];
  return a3 instanceof ab ? a3 : null;
}
var sb = "__closure_events_fn_" + (1e9 * Math.random() >>> 0);
function ib(a3) {
  if (typeof a3 === "function")
    return a3;
  a3[sb] || (a3[sb] = function(b3) {
    return a3.handleEvent(b3);
  });
  return a3[sb];
}
function D$1() {
  t.call(this);
  this.c = new ab(this);
  this.J = this;
  this.C = null;
}
r(D$1, t);
D$1.prototype[A$1] = true;
h = D$1.prototype;
h.addEventListener = function(a3, b3, c3, d3) {
  gb(this, a3, b3, c3, d3);
};
h.removeEventListener = function(a3, b3, c3, d3) {
  ob(this, a3, b3, c3, d3);
};
function E$1(a3, b3) {
  var c3, d3 = a3.C;
  if (d3)
    for (c3 = []; d3; d3 = d3.C)
      c3.push(d3);
  a3 = a3.J;
  d3 = b3.type || b3;
  if (typeof b3 === "string")
    b3 = new y(b3, a3);
  else if (b3 instanceof y)
    b3.target = b3.target || a3;
  else {
    var e28 = b3;
    b3 = new y(d3, a3);
    Ca$1(b3, e28);
  }
  e28 = true;
  if (c3)
    for (var f3 = c3.length - 1; 0 <= f3; f3--) {
      var g3 = b3.a = c3[f3];
      e28 = tb(g3, d3, true, b3) && e28;
    }
  g3 = b3.a = a3;
  e28 = tb(g3, d3, true, b3) && e28;
  e28 = tb(g3, d3, false, b3) && e28;
  if (c3)
    for (f3 = 0; f3 < c3.length; f3++)
      g3 = b3.a = c3[f3], e28 = tb(g3, d3, false, b3) && e28;
}
h.G = function() {
  D$1.X.G.call(this);
  if (this.c) {
    var a3 = this.c, c3;
    for (c3 in a3.a) {
      for (var d3 = a3.a[c3], e28 = 0; e28 < d3.length; e28++)
        $a$1(d3[e28]);
      delete a3.a[c3];
      a3.b--;
    }
  }
  this.C = null;
};
h.va = function(a3, b3, c3, d3) {
  return this.c.add(String(a3), b3, false, c3, d3);
};
h.wa = function(a3, b3, c3, d3) {
  return this.c.add(String(a3), b3, true, c3, d3);
};
function tb(a3, b3, c3, d3) {
  b3 = a3.c.a[String(b3)];
  if (!b3)
    return true;
  b3 = b3.concat();
  for (var e28 = true, f3 = 0; f3 < b3.length; ++f3) {
    var g3 = b3[f3];
    if (g3 && !g3.Y && g3.capture == c3) {
      var m3 = g3.listener, l3 = g3.ca || g3.src;
      g3.Z && cb(a3.c, g3);
      e28 = m3.call(l3, d3) !== false && e28;
    }
  }
  return e28 && !d3.defaultPrevented;
}
var ub = k$1.JSON.stringify;
function vb() {
  this.b = this.a = null;
}
var xb = new (function() {
  function class_1(a3, b3) {
    this.c = a3;
    this.f = b3;
    this.b = 0;
    this.a = null;
  }
  class_1.prototype.get = function() {
    var a3;
    0 < this.b ? (this.b--, a3 = this.a, this.a = a3.next, a3.next = null) : a3 = this.c();
    return a3;
  };
  return class_1;
}())(function() {
  return new wb();
}, function(a3) {
  a3.reset();
});
vb.prototype.add = function(a3, b3) {
  var c3 = xb.get();
  c3.set(a3, b3);
  this.b ? this.b.next = c3 : this.a = c3;
  this.b = c3;
};
function yb() {
  var a3 = zb, b3 = null;
  a3.a && (b3 = a3.a, a3.a = a3.a.next, a3.a || (a3.b = null), b3.next = null);
  return b3;
}
function wb() {
  this.next = this.b = this.a = null;
}
wb.prototype.set = function(a3, b3) {
  this.a = a3;
  this.b = b3;
  this.next = null;
};
wb.prototype.reset = function() {
  this.next = this.b = this.a = null;
};
function Ab(a3) {
  k$1.setTimeout(function() {
    throw a3;
  }, 0);
}
function Bb(a3, b3) {
  Cb || Db();
  Eb || (Cb(), Eb = true);
  zb.add(a3, b3);
}
var Cb;
function Db() {
  var a3 = k$1.Promise.resolve(void 0);
  Cb = function() {
    a3.then(Fb);
  };
}
var Eb = false, zb = new vb();
function Fb() {
  for (var a3; a3 = yb(); ) {
    try {
      a3.a.call(a3.b);
    } catch (c3) {
      Ab(c3);
    }
    var b3 = xb;
    b3.f(a3);
    100 > b3.b && (b3.b++, a3.next = b3.a, b3.a = a3);
  }
  Eb = false;
}
function Gb(a3, b3) {
  D$1.call(this);
  this.b = a3 || 1;
  this.a = b3 || k$1;
  this.f = p(this.Za, this);
  this.g = q$1();
}
r(Gb, D$1);
h = Gb.prototype;
h.aa = false;
h.M = null;
h.Za = function() {
  if (this.aa) {
    var a3 = q$1() - this.g;
    0 < a3 && a3 < 0.8 * this.b ? this.M = this.a.setTimeout(this.f, this.b - a3) : (this.M && (this.a.clearTimeout(this.M), this.M = null), E$1(this, "tick"), this.aa && (Hb(this), this.start()));
  }
};
h.start = function() {
  this.aa = true;
  this.M || (this.M = this.a.setTimeout(this.f, this.b), this.g = q$1());
};
function Hb(a3) {
  a3.aa = false;
  a3.M && (a3.a.clearTimeout(a3.M), a3.M = null);
}
h.G = function() {
  Gb.X.G.call(this);
  Hb(this);
  delete this.a;
};
function Ib(a3, b3, c3) {
  if (typeof a3 === "function")
    c3 && (a3 = p(a3, c3));
  else if (a3 && typeof a3.handleEvent == "function")
    a3 = p(a3.handleEvent, a3);
  else
    throw Error("Invalid listener argument");
  return 2147483647 < Number(b3) ? -1 : k$1.setTimeout(a3, b3 || 0);
}
function Jb(a3) {
  a3.a = Ib(function() {
    a3.a = null;
    a3.c && (a3.c = false, Jb(a3));
  }, a3.h);
  var b3 = a3.b;
  a3.b = null;
  a3.g.apply(null, b3);
}
var Kb = function(_super) {
  __extends(Kb2, _super);
  function Kb2(a3, b3) {
    var _this = _super.call(this) || this;
    _this.g = a3;
    _this.h = b3;
    _this.b = null;
    _this.c = false;
    _this.a = null;
    return _this;
  }
  Kb2.prototype.f = function(a3) {
    this.b = arguments;
    this.a ? this.c = true : Jb(this);
  };
  Kb2.prototype.G = function() {
    _super.prototype.G.call(this);
    this.a && (k$1.clearTimeout(this.a), this.a = null, this.c = false, this.b = null);
  };
  return Kb2;
}(t);
function F$1(a3) {
  t.call(this);
  this.b = a3;
  this.a = {};
}
r(F$1, t);
var Lb = [];
function Mb(a3, b3, c3, d3) {
  Array.isArray(c3) || (c3 && (Lb[0] = c3.toString()), c3 = Lb);
  for (var e28 = 0; e28 < c3.length; e28++) {
    var f3 = gb(b3, c3[e28], d3 || a3.handleEvent, false, a3.b || a3);
    if (!f3)
      break;
    a3.a[f3.key] = f3;
  }
}
function Nb(a3) {
  za$1(a3.a, function(b3, c3) {
    this.a.hasOwnProperty(c3) && pb(b3);
  }, a3);
  a3.a = {};
}
F$1.prototype.G = function() {
  F$1.X.G.call(this);
  Nb(this);
};
F$1.prototype.handleEvent = function() {
  throw Error("EventHandler.handleEvent not implemented");
};
function Ob() {
  this.a = true;
}
function Pb(a3, b3, c3, d3, e28, f3) {
  a3.info(function() {
    if (a3.a)
      if (f3) {
        var g3 = "";
        for (var m3 = f3.split("&"), l3 = 0; l3 < m3.length; l3++) {
          var u3 = m3[l3].split("=");
          if (1 < u3.length) {
            var C3 = u3[0];
            u3 = u3[1];
            var B3 = C3.split("_");
            g3 = 2 <= B3.length && B3[1] == "type" ? g3 + (C3 + "=" + u3 + "&") : g3 + (C3 + "=redacted&");
          }
        }
      } else
        g3 = null;
    else
      g3 = f3;
    return "XMLHTTP REQ (" + d3 + ") [attempt " + e28 + "]: " + b3 + "\n" + c3 + "\n" + g3;
  });
}
function Qb(a3, b3, c3, d3, e28, f3, g3) {
  a3.info(function() {
    return "XMLHTTP RESP (" + d3 + ") [ attempt " + e28 + "]: " + b3 + "\n" + c3 + "\n" + f3 + " " + g3;
  });
}
function G$1(a3, b3, c3, d3) {
  a3.info(function() {
    return "XMLHTTP TEXT (" + b3 + "): " + Rb(a3, c3) + (d3 ? " " + d3 : "");
  });
}
function Sb(a3, b3) {
  a3.info(function() {
    return "TIMEOUT: " + b3;
  });
}
Ob.prototype.info = function() {
};
function Rb(a3, b3) {
  if (!a3.a)
    return b3;
  if (!b3)
    return null;
  try {
    var c3 = JSON.parse(b3);
    if (c3) {
      for (a3 = 0; a3 < c3.length; a3++)
        if (Array.isArray(c3[a3])) {
          var d3 = c3[a3];
          if (!(2 > d3.length)) {
            var e28 = d3[1];
            if (Array.isArray(e28) && !(1 > e28.length)) {
              var f3 = e28[0];
              if (f3 != "noop" && f3 != "stop" && f3 != "close")
                for (var g3 = 1; g3 < e28.length; g3++)
                  e28[g3] = "";
            }
          }
        }
    }
    return ub(c3);
  } catch (m3) {
    return b3;
  }
}
var H$1 = {}, Tb = null;
function Ub() {
  return Tb = Tb || new D$1();
}
H$1.Fa = "serverreachability";
function Vb(a3) {
  y.call(this, H$1.Fa, a3);
}
r(Vb, y);
function I$1(a3) {
  var b3 = Ub();
  E$1(b3, new Vb(b3));
}
H$1.STAT_EVENT = "statevent";
function Wb(a3, b3) {
  y.call(this, H$1.STAT_EVENT, a3);
  this.stat = b3;
}
r(Wb, y);
function J$1(a3) {
  var b3 = Ub();
  E$1(b3, new Wb(b3, a3));
}
H$1.Ga = "timingevent";
function Xb(a3) {
  y.call(this, H$1.Ga, a3);
}
r(Xb, y);
function K$1(a3, b3) {
  if (typeof a3 !== "function")
    throw Error("Fn must not be null and must be a function");
  return k$1.setTimeout(function() {
    a3();
  }, b3);
}
var Yb = { NO_ERROR: 0, $a: 1, nb: 2, mb: 3, hb: 4, lb: 5, ob: 6, Da: 7, TIMEOUT: 8, rb: 9 };
var Zb = { fb: "complete", Bb: "success", Ea: "error", Da: "abort", tb: "ready", ub: "readystatechange", TIMEOUT: "timeout", pb: "incrementaldata", sb: "progress", ib: "downloadprogress", Jb: "uploadprogress" };
function $b() {
}
$b.prototype.a = null;
function ac$1(a3) {
  var b3;
  (b3 = a3.a) || (b3 = a3.a = {});
  return b3;
}
function bc$1() {
}
var L$1 = { OPEN: "a", eb: "b", Ea: "c", qb: "d" };
function cc$1() {
  y.call(this, "d");
}
r(cc$1, y);
function dc$1() {
  y.call(this, "c");
}
r(dc$1, y);
var ec$1;
function fc$1() {
}
r(fc$1, $b);
ec$1 = new fc$1();
function M$1(a3, b3, c3, d3) {
  this.g = a3;
  this.c = b3;
  this.f = c3;
  this.S = d3 || 1;
  this.J = new F$1(this);
  this.P = gc$1;
  a3 = Ia$1 ? 125 : void 0;
  this.R = new Gb(a3);
  this.B = null;
  this.b = false;
  this.j = this.l = this.i = this.H = this.u = this.T = this.o = null;
  this.s = [];
  this.a = null;
  this.D = 0;
  this.h = this.m = null;
  this.N = -1;
  this.A = false;
  this.O = 0;
  this.F = null;
  this.V = this.C = this.U = this.I = false;
}
var gc$1 = 45e3, hc$1 = {}, ic$1 = {};
h = M$1.prototype;
h.setTimeout = function(a3) {
  this.P = a3;
};
function jc$1(a3, b3, c3) {
  a3.H = 1;
  a3.i = kc$1(N$1(b3));
  a3.j = c3;
  a3.I = true;
  lc$1(a3, null);
}
function lc$1(a3, b3) {
  a3.u = q$1();
  mc$1(a3);
  a3.l = N$1(a3.i);
  var c3 = a3.l, d3 = a3.S;
  Array.isArray(d3) || (d3 = [String(d3)]);
  nc$1(c3.b, "t", d3);
  a3.D = 0;
  a3.a = oc$1(a3.g, a3.g.C ? b3 : null);
  0 < a3.O && (a3.F = new Kb(p(a3.Ca, a3, a3.a), a3.O));
  Mb(a3.J, a3.a, "readystatechange", a3.Xa);
  b3 = a3.B ? Aa$1(a3.B) : {};
  a3.j ? (a3.m || (a3.m = "POST"), b3["Content-Type"] = "application/x-www-form-urlencoded", a3.a.ba(a3.l, a3.m, a3.j, b3)) : (a3.m = "GET", a3.a.ba(a3.l, a3.m, null, b3));
  I$1();
  Pb(a3.c, a3.m, a3.l, a3.f, a3.S, a3.j);
}
h.Xa = function(a3) {
  a3 = a3.target;
  var b3 = this.F;
  b3 && O$1(a3) == 3 ? b3.f() : this.Ca(a3);
};
h.Ca = function(a3) {
  try {
    if (a3 == this.a)
      a: {
        var b3 = O$1(this.a), c3 = this.a.ua(), d3 = this.a.W();
        if (!(3 > b3 || b3 == 3 && !Ia$1 && !this.a.$())) {
          this.A || b3 != 4 || c3 == 7 || (c3 == 8 || 0 >= d3 ? I$1(3) : I$1(2));
          pc$1(this);
          var e28 = this.a.W();
          this.N = e28;
          var f3 = this.a.$();
          this.b = e28 == 200;
          Qb(this.c, this.m, this.l, this.f, this.S, b3, e28);
          if (this.b) {
            if (this.U && !this.C) {
              b: {
                if (this.a) {
                  var g3, m3 = this.a;
                  if ((g3 = m3.a ? m3.a.getResponseHeader("X-HTTP-Initial-Response") : null) && !sa$1(g3)) {
                    var l3 = g3;
                    break b;
                  }
                }
                l3 = null;
              }
              if (l3)
                G$1(this.c, this.f, l3, "Initial handshake response via X-HTTP-Initial-Response"), this.C = true, qc$1(this, l3);
              else {
                this.b = false;
                this.h = 3;
                J$1(12);
                P$2(this);
                rc$1(this);
                break a;
              }
            }
            this.I ? (sc$1(this, b3, f3), Ia$1 && this.b && b3 == 3 && (Mb(this.J, this.R, "tick", this.Wa), this.R.start())) : (G$1(this.c, this.f, f3, null), qc$1(this, f3));
            b3 == 4 && P$2(this);
            this.b && !this.A && (b3 == 4 ? uc$1(this.g, this) : (this.b = false, mc$1(this)));
          } else
            e28 == 400 && 0 < f3.indexOf("Unknown SID") ? (this.h = 3, J$1(12)) : (this.h = 0, J$1(13)), P$2(this), rc$1(this);
        }
      }
  } catch (u3) {
  } finally {
  }
};
function sc$1(a3, b3, c3) {
  for (var d3 = true; !a3.A && a3.D < c3.length; ) {
    var e28 = vc$1(a3, c3);
    if (e28 == ic$1) {
      b3 == 4 && (a3.h = 4, J$1(14), d3 = false);
      G$1(a3.c, a3.f, null, "[Incomplete Response]");
      break;
    } else if (e28 == hc$1) {
      a3.h = 4;
      J$1(15);
      G$1(a3.c, a3.f, c3, "[Invalid Chunk]");
      d3 = false;
      break;
    } else
      G$1(a3.c, a3.f, e28, null), qc$1(a3, e28);
  }
  b3 == 4 && c3.length == 0 && (a3.h = 1, J$1(16), d3 = false);
  a3.b = a3.b && d3;
  d3 ? 0 < c3.length && !a3.V && (a3.V = true, b3 = a3.g, b3.a == a3 && b3.U && !b3.F && (b3.c.info("Great, no buffering proxy detected. Bytes received: " + c3.length), wc$1(b3), b3.F = true, J$1(11))) : (G$1(a3.c, a3.f, c3, "[Invalid Chunked Response]"), P$2(a3), rc$1(a3));
}
h.Wa = function() {
  if (this.a) {
    var a3 = O$1(this.a), b3 = this.a.$();
    this.D < b3.length && (pc$1(this), sc$1(this, a3, b3), this.b && a3 != 4 && mc$1(this));
  }
};
function vc$1(a3, b3) {
  var c3 = a3.D, d3 = b3.indexOf("\n", c3);
  if (d3 == -1)
    return ic$1;
  c3 = Number(b3.substring(c3, d3));
  if (isNaN(c3))
    return hc$1;
  d3 += 1;
  if (d3 + c3 > b3.length)
    return ic$1;
  b3 = b3.substr(d3, c3);
  a3.D = d3 + c3;
  return b3;
}
h.cancel = function() {
  this.A = true;
  P$2(this);
};
function mc$1(a3) {
  a3.T = q$1() + a3.P;
  yc$1(a3, a3.P);
}
function yc$1(a3, b3) {
  if (a3.o != null)
    throw Error("WatchDog timer not null");
  a3.o = K$1(p(a3.Va, a3), b3);
}
function pc$1(a3) {
  a3.o && (k$1.clearTimeout(a3.o), a3.o = null);
}
h.Va = function() {
  this.o = null;
  var a3 = q$1();
  0 <= a3 - this.T ? (Sb(this.c, this.l), this.H != 2 && (I$1(), J$1(17)), P$2(this), this.h = 2, rc$1(this)) : yc$1(this, this.T - a3);
};
function rc$1(a3) {
  a3.g.v == 0 || a3.A || uc$1(a3.g, a3);
}
function P$2(a3) {
  pc$1(a3);
  var b3 = a3.F;
  b3 && typeof b3.ja == "function" && b3.ja();
  a3.F = null;
  Hb(a3.R);
  Nb(a3.J);
  a3.a && (b3 = a3.a, a3.a = null, b3.abort(), b3.ja());
}
function qc$1(a3, b3) {
  try {
    var c3 = a3.g;
    if (c3.v != 0 && (c3.a == a3 || zc$1(c3.b, a3))) {
      if (c3.I = a3.N, !a3.C && zc$1(c3.b, a3) && c3.v == 3) {
        try {
          var d3 = c3.ka.a.parse(b3);
        } catch (tc2) {
          d3 = null;
        }
        if (Array.isArray(d3) && d3.length == 3) {
          var e28 = d3;
          if (e28[0] == 0)
            a: {
              if (!c3.j) {
                if (c3.a)
                  if (c3.a.u + 3e3 < a3.u)
                    Ac$1(c3), Bc$1(c3);
                  else
                    break a;
                Cc$1(c3);
                J$1(18);
              }
            }
          else
            c3.oa = e28[1], 0 < c3.oa - c3.P && 37500 > e28[2] && c3.H && c3.o == 0 && !c3.m && (c3.m = K$1(p(c3.Sa, c3), 6e3));
          if (1 >= Dc$1(c3.b) && c3.ea) {
            try {
              c3.ea();
            } catch (tc2) {
            }
            c3.ea = void 0;
          }
        } else
          Q$1(c3, 11);
      } else if ((a3.C || c3.a == a3) && Ac$1(c3), !sa$1(b3))
        for (b3 = d3 = c3.ka.a.parse(b3), d3 = 0; d3 < b3.length; d3++)
          if (e28 = b3[d3], c3.P = e28[0], e28 = e28[1], c3.v == 2)
            if (e28[0] == "c") {
              c3.J = e28[1];
              c3.ga = e28[2];
              var f3 = e28[3];
              f3 != null && (c3.ha = f3, c3.c.info("VER=" + c3.ha));
              var g3 = e28[4];
              g3 != null && (c3.pa = g3, c3.c.info("SVER=" + c3.pa));
              var m3 = e28[5];
              if (m3 != null && typeof m3 === "number" && 0 < m3) {
                var l3 = 1.5 * m3;
                c3.D = l3;
                c3.c.info("backChannelRequestTimeoutMs_=" + l3);
              }
              l3 = c3;
              var u3 = a3.a;
              if (u3) {
                var C3 = u3.a ? u3.a.getResponseHeader("X-Client-Wire-Protocol") : null;
                if (C3) {
                  var B3 = l3.b;
                  !B3.a && (v(C3, "spdy") || v(C3, "quic") || v(C3, "h2")) && (B3.f = B3.g, B3.a = new Set(), B3.b && (Ec$1(B3, B3.b), B3.b = null));
                }
                if (l3.A) {
                  var rb2 = u3.a ? u3.a.getResponseHeader("X-HTTP-Session-Id") : null;
                  rb2 && (l3.na = rb2, R$1(l3.B, l3.A, rb2));
                }
              }
              c3.v = 3;
              c3.f && c3.f.ta();
              c3.U && (c3.N = q$1() - a3.u, c3.c.info("Handshake RTT: " + c3.N + "ms"));
              l3 = c3;
              var xa2 = a3;
              l3.la = Fc$1(l3, l3.C ? l3.ga : null, l3.fa);
              if (xa2.C) {
                Gc$1(l3.b, xa2);
                var ya2 = xa2, xc2 = l3.D;
                xc2 && ya2.setTimeout(xc2);
                ya2.o && (pc$1(ya2), mc$1(ya2));
                l3.a = xa2;
              } else
                Hc(l3);
              0 < c3.g.length && Ic$1(c3);
            } else
              e28[0] != "stop" && e28[0] != "close" || Q$1(c3, 7);
          else
            c3.v == 3 && (e28[0] == "stop" || e28[0] == "close" ? e28[0] == "stop" ? Q$1(c3, 7) : Jc(c3) : e28[0] != "noop" && c3.f && c3.f.sa(e28), c3.o = 0);
    }
    I$1(4);
  } catch (tc2) {
  }
}
function Kc(a3) {
  if (a3.K && typeof a3.K == "function")
    return a3.K();
  if (typeof a3 === "string")
    return a3.split("");
  if (ba$1(a3)) {
    for (var b3 = [], c3 = a3.length, d3 = 0; d3 < c3; d3++)
      b3.push(a3[d3]);
    return b3;
  }
  b3 = [];
  c3 = 0;
  for (d3 in a3)
    b3[c3++] = a3[d3];
  return a3 = b3;
}
function Lc$1(a3, b3) {
  if (a3.forEach && typeof a3.forEach == "function")
    a3.forEach(b3, void 0);
  else if (ba$1(a3) || typeof a3 === "string")
    na$1(a3, b3, void 0);
  else {
    if (a3.L && typeof a3.L == "function")
      var c3 = a3.L();
    else if (a3.K && typeof a3.K == "function")
      c3 = void 0;
    else if (ba$1(a3) || typeof a3 === "string") {
      c3 = [];
      for (var d3 = a3.length, e28 = 0; e28 < d3; e28++)
        c3.push(e28);
    } else
      for (e28 in c3 = [], d3 = 0, a3)
        c3[d3++] = e28;
    d3 = Kc(a3);
    e28 = d3.length;
    for (var f3 = 0; f3 < e28; f3++)
      b3.call(void 0, d3[f3], c3 && c3[f3], a3);
  }
}
function S$1(a3, b3) {
  this.b = {};
  this.a = [];
  this.c = 0;
  var c3 = arguments.length;
  if (1 < c3) {
    if (c3 % 2)
      throw Error("Uneven number of arguments");
    for (var d3 = 0; d3 < c3; d3 += 2)
      this.set(arguments[d3], arguments[d3 + 1]);
  } else if (a3)
    if (a3 instanceof S$1)
      for (c3 = a3.L(), d3 = 0; d3 < c3.length; d3++)
        this.set(c3[d3], a3.get(c3[d3]));
    else
      for (d3 in a3)
        this.set(d3, a3[d3]);
}
h = S$1.prototype;
h.K = function() {
  Mc$1(this);
  for (var a3 = [], b3 = 0; b3 < this.a.length; b3++)
    a3.push(this.b[this.a[b3]]);
  return a3;
};
h.L = function() {
  Mc$1(this);
  return this.a.concat();
};
function Mc$1(a3) {
  if (a3.c != a3.a.length) {
    for (var b3 = 0, c3 = 0; b3 < a3.a.length; ) {
      var d3 = a3.a[b3];
      T$1(a3.b, d3) && (a3.a[c3++] = d3);
      b3++;
    }
    a3.a.length = c3;
  }
  if (a3.c != a3.a.length) {
    var e28 = {};
    for (c3 = b3 = 0; b3 < a3.a.length; )
      d3 = a3.a[b3], T$1(e28, d3) || (a3.a[c3++] = d3, e28[d3] = 1), b3++;
    a3.a.length = c3;
  }
}
h.get = function(a3, b3) {
  return T$1(this.b, a3) ? this.b[a3] : b3;
};
h.set = function(a3, b3) {
  T$1(this.b, a3) || (this.c++, this.a.push(a3));
  this.b[a3] = b3;
};
h.forEach = function(a3, b3) {
  for (var c3 = this.L(), d3 = 0; d3 < c3.length; d3++) {
    var e28 = c3[d3], f3 = this.get(e28);
    a3.call(b3, f3, e28, this);
  }
};
function T$1(a3, b3) {
  return Object.prototype.hasOwnProperty.call(a3, b3);
}
var Nc$1 = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
function Oc$1(a3, b3) {
  if (a3) {
    a3 = a3.split("&");
    for (var c3 = 0; c3 < a3.length; c3++) {
      var d3 = a3[c3].indexOf("="), e28 = null;
      if (0 <= d3) {
        var f3 = a3[c3].substring(0, d3);
        e28 = a3[c3].substring(d3 + 1);
      } else
        f3 = a3[c3];
      b3(f3, e28 ? decodeURIComponent(e28.replace(/\+/g, " ")) : "");
    }
  }
}
function U$1(a3, b3) {
  this.c = this.j = this.f = "";
  this.h = null;
  this.i = this.g = "";
  this.a = false;
  if (a3 instanceof U$1) {
    this.a = b3 !== void 0 ? b3 : a3.a;
    Pc$1(this, a3.f);
    this.j = a3.j;
    Qc(this, a3.c);
    Rc$1(this, a3.h);
    this.g = a3.g;
    b3 = a3.b;
    var c3 = new Sc$1();
    c3.c = b3.c;
    b3.a && (c3.a = new S$1(b3.a), c3.b = b3.b);
    Tc$1(this, c3);
    this.i = a3.i;
  } else
    a3 && (c3 = String(a3).match(Nc$1)) ? (this.a = !!b3, Pc$1(this, c3[1] || "", true), this.j = Uc$1(c3[2] || ""), Qc(this, c3[3] || "", true), Rc$1(this, c3[4]), this.g = Uc$1(c3[5] || "", true), Tc$1(this, c3[6] || "", true), this.i = Uc$1(c3[7] || "")) : (this.a = !!b3, this.b = new Sc$1(null, this.a));
}
U$1.prototype.toString = function() {
  var a3 = [], b3 = this.f;
  b3 && a3.push(Vc$1(b3, Wc, true), ":");
  var c3 = this.c;
  if (c3 || b3 == "file")
    a3.push("//"), (b3 = this.j) && a3.push(Vc$1(b3, Wc, true), "@"), a3.push(encodeURIComponent(String(c3)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c3 = this.h, c3 != null && a3.push(":", String(c3));
  if (c3 = this.g)
    this.c && c3.charAt(0) != "/" && a3.push("/"), a3.push(Vc$1(c3, c3.charAt(0) == "/" ? Xc : Yc, true));
  (c3 = this.b.toString()) && a3.push("?", c3);
  (c3 = this.i) && a3.push("#", Vc$1(c3, Zc));
  return a3.join("");
};
function N$1(a3) {
  return new U$1(a3);
}
function Pc$1(a3, b3, c3) {
  a3.f = c3 ? Uc$1(b3, true) : b3;
  a3.f && (a3.f = a3.f.replace(/:$/, ""));
}
function Qc(a3, b3, c3) {
  a3.c = c3 ? Uc$1(b3, true) : b3;
}
function Rc$1(a3, b3) {
  if (b3) {
    b3 = Number(b3);
    if (isNaN(b3) || 0 > b3)
      throw Error("Bad port number " + b3);
    a3.h = b3;
  } else
    a3.h = null;
}
function Tc$1(a3, b3, c3) {
  b3 instanceof Sc$1 ? (a3.b = b3, $c(a3.b, a3.a)) : (c3 || (b3 = Vc$1(b3, ad)), a3.b = new Sc$1(b3, a3.a));
}
function R$1(a3, b3, c3) {
  a3.b.set(b3, c3);
}
function kc$1(a3) {
  R$1(a3, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ q$1()).toString(36));
  return a3;
}
function bd(a3) {
  return a3 instanceof U$1 ? N$1(a3) : new U$1(a3, void 0);
}
function cd(a3, b3, c3, d3) {
  var e28 = new U$1(null, void 0);
  a3 && Pc$1(e28, a3);
  b3 && Qc(e28, b3);
  c3 && Rc$1(e28, c3);
  d3 && (e28.g = d3);
  return e28;
}
function Uc$1(a3, b3) {
  return a3 ? b3 ? decodeURI(a3.replace(/%25/g, "%2525")) : decodeURIComponent(a3) : "";
}
function Vc$1(a3, b3, c3) {
  return typeof a3 === "string" ? (a3 = encodeURI(a3).replace(b3, dd), c3 && (a3 = a3.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a3) : null;
}
function dd(a3) {
  a3 = a3.charCodeAt(0);
  return "%" + (a3 >> 4 & 15).toString(16) + (a3 & 15).toString(16);
}
var Wc = /[#\/\?@]/g, Yc = /[#\?:]/g, Xc = /[#\?]/g, ad = /[#\?@]/g, Zc = /#/g;
function Sc$1(a3, b3) {
  this.b = this.a = null;
  this.c = a3 || null;
  this.f = !!b3;
}
function V$1(a3) {
  a3.a || (a3.a = new S$1(), a3.b = 0, a3.c && Oc$1(a3.c, function(b3, c3) {
    a3.add(decodeURIComponent(b3.replace(/\+/g, " ")), c3);
  }));
}
h = Sc$1.prototype;
h.add = function(a3, b3) {
  V$1(this);
  this.c = null;
  a3 = W$1(this, a3);
  var c3 = this.a.get(a3);
  c3 || this.a.set(a3, c3 = []);
  c3.push(b3);
  this.b += 1;
  return this;
};
function ed(a3, b3) {
  V$1(a3);
  b3 = W$1(a3, b3);
  T$1(a3.a.b, b3) && (a3.c = null, a3.b -= a3.a.get(b3).length, a3 = a3.a, T$1(a3.b, b3) && (delete a3.b[b3], a3.c--, a3.a.length > 2 * a3.c && Mc$1(a3)));
}
function fd(a3, b3) {
  V$1(a3);
  b3 = W$1(a3, b3);
  return T$1(a3.a.b, b3);
}
h.forEach = function(a3, b3) {
  V$1(this);
  this.a.forEach(function(c3, d3) {
    na$1(c3, function(e28) {
      a3.call(b3, e28, d3, this);
    }, this);
  }, this);
};
h.L = function() {
  V$1(this);
  for (var a3 = this.a.K(), b3 = this.a.L(), c3 = [], d3 = 0; d3 < b3.length; d3++)
    for (var e28 = a3[d3], f3 = 0; f3 < e28.length; f3++)
      c3.push(b3[d3]);
  return c3;
};
h.K = function(a3) {
  V$1(this);
  var b3 = [];
  if (typeof a3 === "string")
    fd(this, a3) && (b3 = qa$1(b3, this.a.get(W$1(this, a3))));
  else {
    a3 = this.a.K();
    for (var c3 = 0; c3 < a3.length; c3++)
      b3 = qa$1(b3, a3[c3]);
  }
  return b3;
};
h.set = function(a3, b3) {
  V$1(this);
  this.c = null;
  a3 = W$1(this, a3);
  fd(this, a3) && (this.b -= this.a.get(a3).length);
  this.a.set(a3, [b3]);
  this.b += 1;
  return this;
};
h.get = function(a3, b3) {
  if (!a3)
    return b3;
  a3 = this.K(a3);
  return 0 < a3.length ? String(a3[0]) : b3;
};
function nc$1(a3, b3, c3) {
  ed(a3, b3);
  0 < c3.length && (a3.c = null, a3.a.set(W$1(a3, b3), ra$1(c3)), a3.b += c3.length);
}
h.toString = function() {
  if (this.c)
    return this.c;
  if (!this.a)
    return "";
  for (var a3 = [], b3 = this.a.L(), c3 = 0; c3 < b3.length; c3++) {
    var d3 = b3[c3], e28 = encodeURIComponent(String(d3));
    d3 = this.K(d3);
    for (var f3 = 0; f3 < d3.length; f3++) {
      var g3 = e28;
      d3[f3] !== "" && (g3 += "=" + encodeURIComponent(String(d3[f3])));
      a3.push(g3);
    }
  }
  return this.c = a3.join("&");
};
function W$1(a3, b3) {
  b3 = String(b3);
  a3.f && (b3 = b3.toLowerCase());
  return b3;
}
function $c(a3, b3) {
  b3 && !a3.f && (V$1(a3), a3.c = null, a3.a.forEach(function(c3, d3) {
    var e28 = d3.toLowerCase();
    d3 != e28 && (ed(this, d3), nc$1(this, e28, c3));
  }, a3));
  a3.f = b3;
}
var gd = function() {
  function gd2(a3, b3) {
    this.b = a3;
    this.a = b3;
  }
  return gd2;
}();
function hd(a3) {
  this.g = a3 || id;
  k$1.PerformanceNavigationTiming ? (a3 = k$1.performance.getEntriesByType("navigation"), a3 = 0 < a3.length && (a3[0].nextHopProtocol == "hq" || a3[0].nextHopProtocol == "h2")) : a3 = !!(k$1.ia && k$1.ia.ya && k$1.ia.ya() && k$1.ia.ya().Lb);
  this.f = a3 ? this.g : 1;
  this.a = null;
  1 < this.f && (this.a = new Set());
  this.b = null;
  this.c = [];
}
var id = 10;
function jd(a3) {
  return a3.b ? true : a3.a ? a3.a.size >= a3.f : false;
}
function Dc$1(a3) {
  return a3.b ? 1 : a3.a ? a3.a.size : 0;
}
function zc$1(a3, b3) {
  return a3.b ? a3.b == b3 : a3.a ? a3.a.has(b3) : false;
}
function Ec$1(a3, b3) {
  a3.a ? a3.a.add(b3) : a3.b = b3;
}
function Gc$1(a3, b3) {
  a3.b && a3.b == b3 ? a3.b = null : a3.a && a3.a.has(b3) && a3.a.delete(b3);
}
hd.prototype.cancel = function() {
  var e_1, _a2;
  this.c = kd(this);
  if (this.b)
    this.b.cancel(), this.b = null;
  else if (this.a && this.a.size !== 0) {
    try {
      for (var _b2 = __values(this.a.values()), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
        var a3 = _c2.value;
        a3.cancel();
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (_c2 && !_c2.done && (_a2 = _b2.return))
          _a2.call(_b2);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
    this.a.clear();
  }
};
function kd(a3) {
  var e_2, _a2;
  if (a3.b != null)
    return a3.c.concat(a3.b.s);
  if (a3.a != null && a3.a.size !== 0) {
    var b3 = a3.c;
    try {
      for (var _b2 = __values(a3.a.values()), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
        var c3 = _c2.value;
        b3 = b3.concat(c3.s);
      }
    } catch (e_2_1) {
      e_2 = { error: e_2_1 };
    } finally {
      try {
        if (_c2 && !_c2.done && (_a2 = _b2.return))
          _a2.call(_b2);
      } finally {
        if (e_2)
          throw e_2.error;
      }
    }
    return b3;
  }
  return ra$1(a3.c);
}
function ld() {
}
ld.prototype.stringify = function(a3) {
  return k$1.JSON.stringify(a3, void 0);
};
ld.prototype.parse = function(a3) {
  return k$1.JSON.parse(a3, void 0);
};
function md() {
  this.a = new ld();
}
function nd(a3, b3, c3) {
  var d3 = c3 || "";
  try {
    Lc$1(a3, function(e28, f3) {
      var g3 = e28;
      n(e28) && (g3 = ub(e28));
      b3.push(d3 + f3 + "=" + encodeURIComponent(g3));
    });
  } catch (e28) {
    throw b3.push(d3 + "type=" + encodeURIComponent("_badmap")), e28;
  }
}
function od(a3, b3) {
  var c3 = new Ob();
  if (k$1.Image) {
    var d3 = new Image();
    d3.onload = ja$1(pd, c3, d3, "TestLoadImage: loaded", true, b3);
    d3.onerror = ja$1(pd, c3, d3, "TestLoadImage: error", false, b3);
    d3.onabort = ja$1(pd, c3, d3, "TestLoadImage: abort", false, b3);
    d3.ontimeout = ja$1(pd, c3, d3, "TestLoadImage: timeout", false, b3);
    k$1.setTimeout(function() {
      if (d3.ontimeout)
        d3.ontimeout();
    }, 1e4);
    d3.src = a3;
  } else
    b3(false);
}
function pd(a3, b3, c3, d3, e28) {
  try {
    b3.onload = null, b3.onerror = null, b3.onabort = null, b3.ontimeout = null, e28(d3);
  } catch (f3) {
  }
}
var qd = k$1.JSON.parse;
function X$1(a3) {
  D$1.call(this);
  this.headers = new S$1();
  this.H = a3 || null;
  this.b = false;
  this.s = this.a = null;
  this.B = "";
  this.h = 0;
  this.f = "";
  this.g = this.A = this.l = this.u = false;
  this.o = 0;
  this.m = null;
  this.I = rd;
  this.D = this.F = false;
}
r(X$1, D$1);
var rd = "", sd = /^https?$/i, td = ["POST", "PUT"];
h = X$1.prototype;
h.ba = function(a3, b3, c3, d3) {
  if (this.a)
    throw Error("[goog.net.XhrIo] Object is active with another request=" + this.B + "; newUri=" + a3);
  b3 = b3 ? b3.toUpperCase() : "GET";
  this.B = a3;
  this.f = "";
  this.h = 0;
  this.u = false;
  this.b = true;
  this.a = new XMLHttpRequest();
  this.s = this.H ? ac$1(this.H) : ac$1(ec$1);
  this.a.onreadystatechange = p(this.za, this);
  try {
    this.A = true, this.a.open(b3, String(a3), true), this.A = false;
  } catch (f3) {
    ud(this, f3);
    return;
  }
  a3 = c3 || "";
  var e28 = new S$1(this.headers);
  d3 && Lc$1(d3, function(f3, g3) {
    e28.set(g3, f3);
  });
  d3 = oa$1(e28.L());
  c3 = k$1.FormData && a3 instanceof k$1.FormData;
  !(0 <= ma$1(td, b3)) || d3 || c3 || e28.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
  e28.forEach(function(f3, g3) {
    this.a.setRequestHeader(g3, f3);
  }, this);
  this.I && (this.a.responseType = this.I);
  "withCredentials" in this.a && this.a.withCredentials !== this.F && (this.a.withCredentials = this.F);
  try {
    vd(this), 0 < this.o && ((this.D = wd(this.a)) ? (this.a.timeout = this.o, this.a.ontimeout = p(this.xa, this)) : this.m = Ib(this.xa, this.o, this)), this.l = true, this.a.send(a3), this.l = false;
  } catch (f3) {
    ud(this, f3);
  }
};
function wd(a3) {
  return x$1 && Qa$1(9) && typeof a3.timeout === "number" && a3.ontimeout !== void 0;
}
function pa$1(a3) {
  return a3.toLowerCase() == "content-type";
}
h.xa = function() {
  typeof goog != "undefined" && this.a && (this.f = "Timed out after " + this.o + "ms, aborting", this.h = 8, E$1(this, "timeout"), this.abort(8));
};
function ud(a3, b3) {
  a3.b = false;
  a3.a && (a3.g = true, a3.a.abort(), a3.g = false);
  a3.f = b3;
  a3.h = 5;
  xd(a3);
  yd(a3);
}
function xd(a3) {
  a3.u || (a3.u = true, E$1(a3, "complete"), E$1(a3, "error"));
}
h.abort = function(a3) {
  this.a && this.b && (this.b = false, this.g = true, this.a.abort(), this.g = false, this.h = a3 || 7, E$1(this, "complete"), E$1(this, "abort"), yd(this));
};
h.G = function() {
  this.a && (this.b && (this.b = false, this.g = true, this.a.abort(), this.g = false), yd(this, true));
  X$1.X.G.call(this);
};
h.za = function() {
  this.j || (this.A || this.l || this.g ? zd(this) : this.Ua());
};
h.Ua = function() {
  zd(this);
};
function zd(a3) {
  if (a3.b && typeof goog != "undefined" && (!a3.s[1] || O$1(a3) != 4 || a3.W() != 2)) {
    if (a3.l && O$1(a3) == 4)
      Ib(a3.za, 0, a3);
    else if (E$1(a3, "readystatechange"), O$1(a3) == 4) {
      a3.b = false;
      try {
        {
          var l3 = a3.W();
          a:
            switch (l3) {
              case 200:
              case 201:
              case 202:
              case 204:
              case 206:
              case 304:
              case 1223:
                var b3 = true;
                break a;
              default:
                b3 = false;
            }
          var c3;
          if (!(c3 = b3)) {
            var d3;
            if (d3 = l3 === 0) {
              var e28 = String(a3.B).match(Nc$1)[1] || null;
              if (!e28 && k$1.self && k$1.self.location) {
                var f3 = k$1.self.location.protocol;
                e28 = f3.substr(0, f3.length - 1);
              }
              d3 = !sd.test(e28 ? e28.toLowerCase() : "");
            }
            c3 = d3;
          }
          var g3 = c3;
        }
        if (g3)
          E$1(a3, "complete"), E$1(a3, "success");
        else {
          a3.h = 6;
          try {
            var m3 = 2 < O$1(a3) ? a3.a.statusText : "";
          } catch (l6) {
            m3 = "";
          }
          a3.f = m3 + " [" + a3.W() + "]";
          xd(a3);
        }
      } finally {
        yd(a3);
      }
    }
  }
}
function yd(a3, b3) {
  if (a3.a) {
    vd(a3);
    var c3 = a3.a, d3 = a3.s[0] ? aa$1 : null;
    a3.a = null;
    a3.s = null;
    b3 || E$1(a3, "ready");
    try {
      c3.onreadystatechange = d3;
    } catch (e28) {
    }
  }
}
function vd(a3) {
  a3.a && a3.D && (a3.a.ontimeout = null);
  a3.m && (k$1.clearTimeout(a3.m), a3.m = null);
}
function O$1(a3) {
  return a3.a ? a3.a.readyState : 0;
}
h.W = function() {
  try {
    return 2 < O$1(this) ? this.a.status : -1;
  } catch (a3) {
    return -1;
  }
};
h.$ = function() {
  try {
    return this.a ? this.a.responseText : "";
  } catch (a3) {
    return "";
  }
};
h.Pa = function(a3) {
  if (this.a) {
    var b3 = this.a.responseText;
    a3 && b3.indexOf(a3) == 0 && (b3 = b3.substring(a3.length));
    return qd(b3);
  }
};
h.ua = function() {
  return this.h;
};
h.Qa = function() {
  return typeof this.f === "string" ? this.f : String(this.f);
};
function Ad(a3) {
  var b3 = "";
  za$1(a3, function(c3, d3) {
    b3 += d3;
    b3 += ":";
    b3 += c3;
    b3 += "\r\n";
  });
  return b3;
}
function Bd(a3, b3, c3) {
  a: {
    for (d3 in c3) {
      var d3 = false;
      break a;
    }
    d3 = true;
  }
  d3 || (c3 = Ad(c3), typeof a3 === "string" ? c3 != null && encodeURIComponent(String(c3)) : R$1(a3, b3, c3));
}
function Cd(a3, b3, c3) {
  return c3 && c3.internalChannelParams ? c3.internalChannelParams[a3] || b3 : b3;
}
function Dd(a3) {
  this.pa = 0;
  this.g = [];
  this.c = new Ob();
  this.ga = this.la = this.B = this.fa = this.a = this.na = this.A = this.V = this.i = this.O = this.l = null;
  this.Oa = this.R = 0;
  this.La = Cd("failFast", false, a3);
  this.H = this.m = this.j = this.h = this.f = null;
  this.S = true;
  this.I = this.oa = this.P = -1;
  this.T = this.o = this.u = 0;
  this.Ha = Cd("baseRetryDelayMs", 5e3, a3);
  this.Ra = Cd("retryDelaySeedMs", 1e4, a3);
  this.Ma = Cd("forwardChannelMaxRetries", 2, a3);
  this.ma = Cd("forwardChannelRequestTimeoutMs", 2e4, a3);
  this.Na = a3 && a3.g || void 0;
  this.D = void 0;
  this.C = a3 && a3.supportsCrossDomainXhr || false;
  this.J = "";
  this.b = new hd(a3 && a3.concurrentRequestLimit);
  this.ka = new md();
  this.da = a3 && a3.fastHandshake || false;
  this.Ia = a3 && a3.b || false;
  a3 && a3.f && (this.c.a = false);
  a3 && a3.forceLongPolling && (this.S = false);
  this.U = !this.da && this.S && a3 && a3.detectBufferingProxy || false;
  this.ea = void 0;
  this.N = 0;
  this.F = false;
  this.s = null;
  (this.Ka = a3 && a3.c || false) && this.c.info("Opt-in to enable Chrome Origin Trials.");
}
h = Dd.prototype;
h.ha = 8;
h.v = 1;
function Jc(a3) {
  Ed(a3);
  if (a3.v == 3) {
    var b3 = a3.R++, c3 = N$1(a3.B);
    R$1(c3, "SID", a3.J);
    R$1(c3, "RID", b3);
    R$1(c3, "TYPE", "terminate");
    Fd(a3, c3);
    b3 = new M$1(a3, a3.c, b3, void 0);
    b3.H = 2;
    b3.i = kc$1(N$1(c3));
    c3 = false;
    k$1.navigator && k$1.navigator.sendBeacon && (c3 = k$1.navigator.sendBeacon(b3.i.toString(), ""));
    !c3 && k$1.Image && (new Image().src = b3.i, c3 = true);
    c3 || (b3.a = oc$1(b3.g, null), b3.a.ba(b3.i));
    b3.u = q$1();
    mc$1(b3);
  }
  Gd(a3);
}
function Bc$1(a3) {
  a3.a && (wc$1(a3), a3.a.cancel(), a3.a = null);
}
function Ed(a3) {
  Bc$1(a3);
  a3.j && (k$1.clearTimeout(a3.j), a3.j = null);
  Ac$1(a3);
  a3.b.cancel();
  a3.h && (typeof a3.h === "number" && k$1.clearTimeout(a3.h), a3.h = null);
}
function Hd(a3, b3) {
  a3.g.push(new gd(a3.Oa++, b3));
  a3.v == 3 && Ic$1(a3);
}
function Ic$1(a3) {
  jd(a3.b) || a3.h || (a3.h = true, Bb(a3.Ba, a3), a3.u = 0);
}
function Id(a3, b3) {
  if (Dc$1(a3.b) >= a3.b.f - (a3.h ? 1 : 0))
    return false;
  if (a3.h)
    return a3.g = b3.s.concat(a3.g), true;
  if (a3.v == 1 || a3.v == 2 || a3.u >= (a3.La ? 0 : a3.Ma))
    return false;
  a3.h = K$1(p(a3.Ba, a3, b3), Jd(a3, a3.u));
  a3.u++;
  return true;
}
h.Ba = function(a3) {
  if (this.h)
    if (this.h = null, this.v == 1) {
      if (!a3) {
        this.R = Math.floor(1e5 * Math.random());
        a3 = this.R++;
        var b3 = new M$1(this, this.c, a3, void 0), c3 = this.l;
        this.O && (c3 ? (c3 = Aa$1(c3), Ca$1(c3, this.O)) : c3 = this.O);
        this.i === null && (b3.B = c3);
        var d3;
        if (this.da)
          a: {
            for (var e28 = d3 = 0; e28 < this.g.length; e28++) {
              b: {
                var f3 = this.g[e28];
                if ("__data__" in f3.a && (f3 = f3.a.__data__, typeof f3 === "string")) {
                  f3 = f3.length;
                  break b;
                }
                f3 = void 0;
              }
              if (f3 === void 0)
                break;
              d3 += f3;
              if (4096 < d3) {
                d3 = e28;
                break a;
              }
              if (d3 === 4096 || e28 === this.g.length - 1) {
                d3 = e28 + 1;
                break a;
              }
            }
            d3 = 1e3;
          }
        else
          d3 = 1e3;
        d3 = Kd(this, b3, d3);
        e28 = N$1(this.B);
        R$1(e28, "RID", a3);
        R$1(e28, "CVER", 22);
        this.A && R$1(e28, "X-HTTP-Session-Id", this.A);
        Fd(this, e28);
        this.i && c3 && Bd(e28, this.i, c3);
        Ec$1(this.b, b3);
        this.Ia && R$1(e28, "TYPE", "init");
        this.da ? (R$1(e28, "$req", d3), R$1(e28, "SID", "null"), b3.U = true, jc$1(b3, e28, null)) : jc$1(b3, e28, d3);
        this.v = 2;
      }
    } else
      this.v == 3 && (a3 ? Ld(this, a3) : this.g.length == 0 || jd(this.b) || Ld(this));
};
function Ld(a3, b3) {
  var c3;
  b3 ? c3 = b3.f : c3 = a3.R++;
  var d3 = N$1(a3.B);
  R$1(d3, "SID", a3.J);
  R$1(d3, "RID", c3);
  R$1(d3, "AID", a3.P);
  Fd(a3, d3);
  a3.i && a3.l && Bd(d3, a3.i, a3.l);
  c3 = new M$1(a3, a3.c, c3, a3.u + 1);
  a3.i === null && (c3.B = a3.l);
  b3 && (a3.g = b3.s.concat(a3.g));
  b3 = Kd(a3, c3, 1e3);
  c3.setTimeout(Math.round(0.5 * a3.ma) + Math.round(0.5 * a3.ma * Math.random()));
  Ec$1(a3.b, c3);
  jc$1(c3, d3, b3);
}
function Fd(a3, b3) {
  a3.f && Lc$1({}, function(c3, d3) {
    R$1(b3, d3, c3);
  });
}
function Kd(a3, b3, c3) {
  c3 = Math.min(a3.g.length, c3);
  var d3 = a3.f ? p(a3.f.Ja, a3.f, a3) : null;
  a:
    for (var e28 = a3.g, f3 = -1; ; ) {
      var g3 = ["count=" + c3];
      f3 == -1 ? 0 < c3 ? (f3 = e28[0].b, g3.push("ofs=" + f3)) : f3 = 0 : g3.push("ofs=" + f3);
      for (var m3 = true, l3 = 0; l3 < c3; l3++) {
        var u3 = e28[l3].b, C3 = e28[l3].a;
        u3 -= f3;
        if (0 > u3)
          f3 = Math.max(0, e28[l3].b - 100), m3 = false;
        else
          try {
            nd(C3, g3, "req" + u3 + "_");
          } catch (B3) {
            d3 && d3(C3);
          }
      }
      if (m3) {
        d3 = g3.join("&");
        break a;
      }
    }
  a3 = a3.g.splice(0, c3);
  b3.s = a3;
  return d3;
}
function Hc(a3) {
  a3.a || a3.j || (a3.T = 1, Bb(a3.Aa, a3), a3.o = 0);
}
function Cc$1(a3) {
  if (a3.a || a3.j || 3 <= a3.o)
    return false;
  a3.T++;
  a3.j = K$1(p(a3.Aa, a3), Jd(a3, a3.o));
  a3.o++;
  return true;
}
h.Aa = function() {
  this.j = null;
  Md(this);
  if (this.U && !(this.F || this.a == null || 0 >= this.N)) {
    var a3 = 2 * this.N;
    this.c.info("BP detection timer enabled: " + a3);
    this.s = K$1(p(this.Ta, this), a3);
  }
};
h.Ta = function() {
  this.s && (this.s = null, this.c.info("BP detection timeout reached."), this.c.info("Buffering proxy detected and switch to long-polling!"), this.H = false, this.F = true, J$1(10), Bc$1(this), Md(this));
};
function wc$1(a3) {
  a3.s != null && (k$1.clearTimeout(a3.s), a3.s = null);
}
function Md(a3) {
  a3.a = new M$1(a3, a3.c, "rpc", a3.T);
  a3.i === null && (a3.a.B = a3.l);
  a3.a.O = 0;
  var b3 = N$1(a3.la);
  R$1(b3, "RID", "rpc");
  R$1(b3, "SID", a3.J);
  R$1(b3, "CI", a3.H ? "0" : "1");
  R$1(b3, "AID", a3.P);
  Fd(a3, b3);
  R$1(b3, "TYPE", "xmlhttp");
  a3.i && a3.l && Bd(b3, a3.i, a3.l);
  a3.D && a3.a.setTimeout(a3.D);
  var c3 = a3.a;
  a3 = a3.ga;
  c3.H = 1;
  c3.i = kc$1(N$1(b3));
  c3.j = null;
  c3.I = true;
  lc$1(c3, a3);
}
h.Sa = function() {
  this.m != null && (this.m = null, Bc$1(this), Cc$1(this), J$1(19));
};
function Ac$1(a3) {
  a3.m != null && (k$1.clearTimeout(a3.m), a3.m = null);
}
function uc$1(a3, b3) {
  var c3 = null;
  if (a3.a == b3) {
    Ac$1(a3);
    wc$1(a3);
    a3.a = null;
    var d3 = 2;
  } else if (zc$1(a3.b, b3))
    c3 = b3.s, Gc$1(a3.b, b3), d3 = 1;
  else
    return;
  a3.I = b3.N;
  if (a3.v != 0) {
    if (b3.b)
      if (d3 == 1) {
        c3 = b3.j ? b3.j.length : 0;
        b3 = q$1() - b3.u;
        var e28 = a3.u;
        d3 = Ub();
        E$1(d3, new Xb(d3));
        Ic$1(a3);
      } else
        Hc(a3);
    else if (e28 = b3.h, e28 == 3 || e28 == 0 && 0 < a3.I || !(d3 == 1 && Id(a3, b3) || d3 == 2 && Cc$1(a3)))
      switch (c3 && 0 < c3.length && (b3 = a3.b, b3.c = b3.c.concat(c3)), e28) {
        case 1:
          Q$1(a3, 5);
          break;
        case 4:
          Q$1(a3, 10);
          break;
        case 3:
          Q$1(a3, 6);
          break;
        default:
          Q$1(a3, 2);
      }
  }
}
function Jd(a3, b3) {
  var c3 = a3.Ha + Math.floor(Math.random() * a3.Ra);
  a3.f || (c3 *= 2);
  return c3 * b3;
}
function Q$1(a3, b3) {
  a3.c.info("Error code " + b3);
  if (b3 == 2) {
    var c3 = null;
    a3.f && (c3 = null);
    var d3 = p(a3.Ya, a3);
    c3 || (c3 = new U$1("//www.google.com/images/cleardot.gif"), k$1.location && k$1.location.protocol == "http" || Pc$1(c3, "https"), kc$1(c3));
    od(c3.toString(), d3);
  } else
    J$1(2);
  a3.v = 0;
  a3.f && a3.f.ra(b3);
  Gd(a3);
  Ed(a3);
}
h.Ya = function(a3) {
  a3 ? (this.c.info("Successfully pinged google.com"), J$1(2)) : (this.c.info("Failed to ping google.com"), J$1(1));
};
function Gd(a3) {
  a3.v = 0;
  a3.I = -1;
  if (a3.f) {
    if (kd(a3.b).length != 0 || a3.g.length != 0)
      a3.b.c.length = 0, ra$1(a3.g), a3.g.length = 0;
    a3.f.qa();
  }
}
function Fc$1(a3, b3, c3) {
  var d3 = bd(c3);
  if (d3.c != "")
    b3 && Qc(d3, b3 + "." + d3.c), Rc$1(d3, d3.h);
  else {
    var e28 = k$1.location;
    d3 = cd(e28.protocol, b3 ? b3 + "." + e28.hostname : e28.hostname, +e28.port, c3);
  }
  a3.V && za$1(a3.V, function(f3, g3) {
    R$1(d3, g3, f3);
  });
  b3 = a3.A;
  c3 = a3.na;
  b3 && c3 && R$1(d3, b3, c3);
  R$1(d3, "VER", a3.ha);
  Fd(a3, d3);
  return d3;
}
function oc$1(a3, b3) {
  if (b3 && !a3.C)
    throw Error("Can't create secondary domain capable XhrIo object.");
  b3 = new X$1(a3.Na);
  b3.F = a3.C;
  return b3;
}
function Nd() {
}
h = Nd.prototype;
h.ta = function() {
};
h.sa = function() {
};
h.ra = function() {
};
h.qa = function() {
};
h.Ja = function() {
};
function Od() {
  if (x$1 && !(10 <= Number(Ta$1)))
    throw Error("Environmental error: no available transport.");
}
Od.prototype.a = function(a3, b3) {
  return new Y$1(a3, b3);
};
function Y$1(a3, b3) {
  D$1.call(this);
  this.a = new Dd(b3);
  this.o = a3;
  this.b = b3 && b3.messageUrlParams || null;
  a3 = b3 && b3.messageHeaders || null;
  b3 && b3.clientProtocolHeaderRequired && (a3 ? a3["X-Client-Protocol"] = "webchannel" : a3 = { "X-Client-Protocol": "webchannel" });
  this.a.l = a3;
  a3 = b3 && b3.initMessageHeaders || null;
  b3 && b3.messageContentType && (a3 ? a3["X-WebChannel-Content-Type"] = b3.messageContentType : a3 = { "X-WebChannel-Content-Type": b3.messageContentType });
  b3 && b3.a && (a3 ? a3["X-WebChannel-Client-Profile"] = b3.a : a3 = { "X-WebChannel-Client-Profile": b3.a });
  this.a.O = a3;
  (a3 = b3 && b3.httpHeadersOverwriteParam) && !sa$1(a3) && (this.a.i = a3);
  this.m = b3 && b3.supportsCrossDomainXhr || false;
  this.l = b3 && b3.sendRawJson || false;
  (b3 = b3 && b3.httpSessionIdParam) && !sa$1(b3) && (this.a.A = b3, a3 = this.b, a3 !== null && b3 in a3 && (a3 = this.b, b3 in a3 && delete a3[b3]));
  this.f = new Z$1(this);
}
r(Y$1, D$1);
Y$1.prototype.g = function() {
  this.a.f = this.f;
  this.m && (this.a.C = true);
  var a3 = this.a, b3 = this.o, c3 = this.b || void 0;
  J$1(0);
  a3.fa = b3;
  a3.V = c3 || {};
  a3.H = a3.S;
  a3.B = Fc$1(a3, null, a3.fa);
  Ic$1(a3);
};
Y$1.prototype.close = function() {
  Jc(this.a);
};
Y$1.prototype.h = function(a3) {
  if (typeof a3 === "string") {
    var b3 = {};
    b3.__data__ = a3;
    Hd(this.a, b3);
  } else
    this.l ? (b3 = {}, b3.__data__ = ub(a3), Hd(this.a, b3)) : Hd(this.a, a3);
};
Y$1.prototype.G = function() {
  this.a.f = null;
  delete this.f;
  Jc(this.a);
  delete this.a;
  Y$1.X.G.call(this);
};
function Pd(a3) {
  cc$1.call(this);
  var b3 = a3.__sm__;
  if (b3) {
    a: {
      for (var c3 in b3) {
        a3 = c3;
        break a;
      }
      a3 = void 0;
    }
    (this.c = a3) ? (a3 = this.c, this.data = b3 !== null && a3 in b3 ? b3[a3] : void 0) : this.data = b3;
  } else
    this.data = a3;
}
r(Pd, cc$1);
function Qd() {
  dc$1.call(this);
  this.status = 1;
}
r(Qd, dc$1);
function Z$1(a3) {
  this.a = a3;
}
r(Z$1, Nd);
Z$1.prototype.ta = function() {
  E$1(this.a, "a");
};
Z$1.prototype.sa = function(a3) {
  E$1(this.a, new Pd(a3));
};
Z$1.prototype.ra = function(a3) {
  E$1(this.a, new Qd());
};
Z$1.prototype.qa = function() {
  E$1(this.a, "b");
};
Od.prototype.createWebChannel = Od.prototype.a;
Y$1.prototype.send = Y$1.prototype.h;
Y$1.prototype.open = Y$1.prototype.g;
Y$1.prototype.close = Y$1.prototype.close;
Yb.NO_ERROR = 0;
Yb.TIMEOUT = 8;
Yb.HTTP_ERROR = 6;
Zb.COMPLETE = "complete";
bc$1.EventType = L$1;
L$1.OPEN = "a";
L$1.CLOSE = "b";
L$1.ERROR = "c";
L$1.MESSAGE = "d";
D$1.prototype.listen = D$1.prototype.va;
X$1.prototype.listenOnce = X$1.prototype.wa;
X$1.prototype.getLastError = X$1.prototype.Qa;
X$1.prototype.getLastErrorCode = X$1.prototype.ua;
X$1.prototype.getStatus = X$1.prototype.W;
X$1.prototype.getResponseJson = X$1.prototype.Pa;
X$1.prototype.getResponseText = X$1.prototype.$;
X$1.prototype.send = X$1.prototype.ba;
var createWebChannelTransport = function() {
  return new Od();
};
var getStatEventTarget = function() {
  return Ub();
};
var ErrorCode$1 = Yb;
var EventType = Zb;
var Event$1 = H$1;
var Stat = { gb: 0, jb: 1, kb: 2, Db: 3, Ib: 4, Fb: 5, Gb: 6, Eb: 7, Cb: 8, Hb: 9, PROXY: 10, NOPROXY: 11, Ab: 12, wb: 13, xb: 14, vb: 15, yb: 16, zb: 17, bb: 18, ab: 19, cb: 20 };
var WebChannel = bc$1;
var XhrIo = X$1;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var I = new Logger("@firebase/firestore");
function _() {
  return I.logLevel;
}
function E(t3) {
  for (var n3 = [], r3 = 1; r3 < arguments.length; r3++)
    n3[r3 - 1] = arguments[r3];
  if (I.logLevel <= LogLevel.DEBUG) {
    var i = n3.map(A);
    I.debug.apply(I, __spreadArrays$1(["Firestore (8.2.1): " + t3], i));
  }
}
function T(t3) {
  for (var n3 = [], r3 = 1; r3 < arguments.length; r3++)
    n3[r3 - 1] = arguments[r3];
  if (I.logLevel <= LogLevel.ERROR) {
    var i = n3.map(A);
    I.error.apply(I, __spreadArrays$1(["Firestore (8.2.1): " + t3], i));
  }
}
function N(t3) {
  for (var n3 = [], r3 = 1; r3 < arguments.length; r3++)
    n3[r3 - 1] = arguments[r3];
  if (I.logLevel <= LogLevel.WARN) {
    var i = n3.map(A);
    I.warn.apply(I, __spreadArrays$1(["Firestore (8.2.1): " + t3], i));
  }
}
function A(t3) {
  if (typeof t3 == "string")
    return t3;
  try {
    return e28 = t3, JSON.stringify(e28);
  } catch (e29) {
    return t3;
  }
  /**
  * @license
  * Copyright 2020 Google LLC
  *
  * Licensed under the Apache License, Version 2.0 (the "License");
  * you may not use this file except in compliance with the License.
  * You may obtain a copy of the License at
  *
  *   http://www.apache.org/licenses/LICENSE-2.0
  *
  * Unless required by applicable law or agreed to in writing, software
  * distributed under the License is distributed on an "AS IS" BASIS,
  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  * See the License for the specific language governing permissions and
  * limitations under the License.
  */
  var e28;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function S(t3) {
  t3 === void 0 && (t3 = "Unexpected state");
  var e28 = "FIRESTORE (8.2.1) INTERNAL ASSERTION FAILED: " + t3;
  throw T(e28), new Error(e28);
}
function x(t3, e28) {
  t3 || S();
}
function D(t3, e28) {
  return t3;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function k(t3) {
  var e28 = typeof self != "undefined" && (self.crypto || self.msCrypto), n3 = new Uint8Array(t3);
  if (e28 && typeof e28.getRandomValues == "function")
    e28.getRandomValues(n3);
  else
    for (var r3 = 0; r3 < t3; r3++)
      n3[r3] = Math.floor(256 * Math.random());
  return n3;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var O = function() {
  function t3() {
  }
  return t3.t = function() {
    for (var t6 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", e28 = Math.floor(256 / t6.length) * t6.length, n3 = ""; n3.length < 20; )
      for (var r3 = k(40), i = 0; i < r3.length; ++i)
        n3.length < 20 && r3[i] < e28 && (n3 += t6.charAt(r3[i] % t6.length));
    return n3;
  }, t3;
}();
function P$1(t3, e28) {
  return t3 < e28 ? -1 : t3 > e28 ? 1 : 0;
}
function C(t3, e28, n3) {
  return t3.length === e28.length && t3.every(function(t6, r3) {
    return n3(t6, e28[r3]);
  });
}
function L(t3) {
  return t3 + "\0";
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var R = function() {
  function t3(t6) {
    this.i = t6;
  }
  return t3.fromBase64String = function(e28) {
    return new t3(atob(e28));
  }, t3.fromUint8Array = function(e28) {
    return new t3(function(t6) {
      for (var e29 = "", n3 = 0; n3 < t6.length; ++n3)
        e29 += String.fromCharCode(t6[n3]);
      return e29;
    }(e28));
  }, t3.prototype.toBase64 = function() {
    return t6 = this.i, btoa(t6);
    var t6;
  }, t3.prototype.toUint8Array = function() {
    return function(t6) {
      for (var e28 = new Uint8Array(t6.length), n3 = 0; n3 < t6.length; n3++)
        e28[n3] = t6.charCodeAt(n3);
      return e28;
    }(this.i);
  }, t3.prototype.o = function() {
    return 2 * this.i.length;
  }, t3.prototype.u = function(t6) {
    return P$1(this.i, t6.i);
  }, t3.prototype.isEqual = function(t6) {
    return this.i === t6.i;
  }, t3;
}();
R.h = new R("");
var V = {
  OK: "ok",
  CANCELLED: "cancelled",
  UNKNOWN: "unknown",
  INVALID_ARGUMENT: "invalid-argument",
  DEADLINE_EXCEEDED: "deadline-exceeded",
  NOT_FOUND: "not-found",
  ALREADY_EXISTS: "already-exists",
  PERMISSION_DENIED: "permission-denied",
  UNAUTHENTICATED: "unauthenticated",
  RESOURCE_EXHAUSTED: "resource-exhausted",
  FAILED_PRECONDITION: "failed-precondition",
  ABORTED: "aborted",
  OUT_OF_RANGE: "out-of-range",
  UNIMPLEMENTED: "unimplemented",
  INTERNAL: "internal",
  UNAVAILABLE: "unavailable",
  DATA_LOSS: "data-loss"
}, M = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, n3) || this).code = e29, r3.message = n3, r3.name = "FirebaseError", r3.toString = function() {
      return r3.name + ": [code=" + r3.code + "]: " + r3.message;
    }, r3;
  }
  return __extends$1(e28, t3), e28;
}(Error), U = function() {
  function t3(t6) {
    this.l = t6;
  }
  return t3.fromBase64String = function(e28) {
    try {
      return new t3(R.fromBase64String(e28));
    } catch (e29) {
      throw new M(V.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e29);
    }
  }, t3.fromUint8Array = function(e28) {
    return new t3(R.fromUint8Array(e28));
  }, t3.prototype.toBase64 = function() {
    return this.l.toBase64();
  }, t3.prototype.toUint8Array = function() {
    return this.l.toUint8Array();
  }, t3.prototype.toString = function() {
    return "Bytes(base64: " + this.toBase64() + ")";
  }, t3.prototype.isEqual = function(t6) {
    return this.l.isEqual(t6.l);
  }, t3;
}(), q = function(t3) {
  this._ = t3;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function F() {
  if (typeof Uint8Array == "undefined")
    throw new M(V.UNIMPLEMENTED, "Uint8Arrays are not available in this environment.");
}
function j() {
  if (typeof atob == "undefined")
    throw new M(V.UNIMPLEMENTED, "Blobs are unavailable in Firestore in this environment.");
}
var z = function(t3) {
  function e28() {
    return t3 !== null && t3.apply(this, arguments) || this;
  }
  return __extends$1(e28, t3), e28.fromBase64String = function(t6) {
    return j(), new e28(U.fromBase64String(t6));
  }, e28.fromUint8Array = function(t6) {
    return F(), new e28(U.fromUint8Array(t6));
  }, e28.prototype.toBase64 = function() {
    return j(), this._.toBase64();
  }, e28.prototype.toUint8Array = function() {
    return F(), this._.toUint8Array();
  }, e28.prototype.isEqual = function(t6) {
    return this._.isEqual(t6._);
  }, e28.prototype.toString = function() {
    return "Blob(base64: " + this.toBase64() + ")";
  }, e28;
}(q), G = function(t3, e28, n3, r3, i, o3) {
  this.T = t3, this.persistenceKey = e28, this.host = n3, this.ssl = r3, this.forceLongPolling = i, this.I = o3;
}, B = function() {
  function t3(t6, e28) {
    this.projectId = t6, this.database = e28 || "(default)";
  }
  return Object.defineProperty(t3.prototype, "m", {
    get: function() {
      return this.database === "(default)";
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.isEqual = function(e28) {
    return e28 instanceof t3 && e28.projectId === this.projectId && e28.database === this.database;
  }, t3;
}(), K = function() {
  function t3(t6) {
    this.uid = t6;
  }
  return t3.prototype.A = function() {
    return this.uid != null;
  }, t3.prototype.R = function() {
    return this.A() ? "uid:" + this.uid : "anonymous-user";
  }, t3.prototype.isEqual = function(t6) {
    return t6.uid === this.uid;
  }, t3;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
K.UNAUTHENTICATED = new K(null), K.P = new K("google-credentials-uid"), K.g = new K("first-party-uid");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var H = function(t3, e28) {
  this.user = e28, this.type = "OAuth", this.V = {}, this.V.Authorization = "Bearer " + t3;
}, J = function() {
  function t3() {
    this.p = null;
  }
  return t3.prototype.getToken = function() {
    return Promise.resolve(null);
  }, t3.prototype.v = function() {
  }, t3.prototype.S = function(t6) {
    this.p = t6, t6(K.UNAUTHENTICATED);
  }, t3.prototype.D = function() {
    this.p = null;
  }, t3;
}(), W = function() {
  function t3(t6) {
    var e28 = this;
    this.C = null, this.currentUser = K.UNAUTHENTICATED, this.N = false, this.F = 0, this.p = null, this.forceRefresh = false, this.C = function() {
      e28.F++, e28.currentUser = e28.O(), e28.N = true, e28.p && e28.p(e28.currentUser);
    }, this.F = 0, this.auth = t6.getImmediate({
      optional: true
    }), this.auth ? this.auth.addAuthTokenListener(this.C) : (this.C(null), t6.get().then(function(t10) {
      e28.auth = t10, e28.C && e28.auth.addAuthTokenListener(e28.C);
    }, function() {
    }));
  }
  return t3.prototype.getToken = function() {
    var t6 = this, e28 = this.F, n3 = this.forceRefresh;
    return this.forceRefresh = false, this.auth ? this.auth.getToken(n3).then(function(n6) {
      return t6.F !== e28 ? (E("FirebaseCredentialsProvider", "getToken aborted due to token change."), t6.getToken()) : n6 ? (x(typeof n6.accessToken == "string"), new H(n6.accessToken, t6.currentUser)) : null;
    }) : Promise.resolve(null);
  }, t3.prototype.v = function() {
    this.forceRefresh = true;
  }, t3.prototype.S = function(t6) {
    this.p = t6, this.N && t6(this.currentUser);
  }, t3.prototype.D = function() {
    this.auth && this.auth.removeAuthTokenListener(this.C), this.C = null, this.p = null;
  }, t3.prototype.O = function() {
    var t6 = this.auth && this.auth.getUid();
    return x(t6 === null || typeof t6 == "string"), new K(t6);
  }, t3;
}(), Q = function() {
  function t3(t6, e28) {
    this.k = t6, this.M = e28, this.type = "FirstParty", this.user = K.g;
  }
  return Object.defineProperty(t3.prototype, "V", {
    get: function() {
      var t6 = {
        "X-Goog-AuthUser": this.M
      }, e28 = this.k.auth.getAuthHeaderValueForFirstParty([]);
      return e28 && (t6.Authorization = e28), t6;
    },
    enumerable: false,
    configurable: true
  }), t3;
}(), Y = function() {
  function t3(t6, e28) {
    this.k = t6, this.M = e28;
  }
  return t3.prototype.getToken = function() {
    return Promise.resolve(new Q(this.k, this.M));
  }, t3.prototype.S = function(t6) {
    t6(K.g);
  }, t3.prototype.D = function() {
  }, t3.prototype.v = function() {
  }, t3;
}(), $ = function() {
  function t3(t6, e28) {
    var n3 = this;
    this.previousValue = t6, e28 && (e28.L = function(t10) {
      return n3.$(t10);
    }, this.B = function(t10) {
      return e28.q(t10);
    });
  }
  return t3.prototype.$ = function(t6) {
    return this.previousValue = Math.max(t6, this.previousValue), this.previousValue;
  }, t3.prototype.next = function() {
    var t6 = ++this.previousValue;
    return this.B && this.B(t6), t6;
  }, t3;
}();
$.U = -1;
var X = function() {
  function t3(t6, e28) {
    if (this.seconds = t6, this.nanoseconds = e28, e28 < 0)
      throw new M(V.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e28);
    if (e28 >= 1e9)
      throw new M(V.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e28);
    if (t6 < -62135596800)
      throw new M(V.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t6);
    if (t6 >= 253402300800)
      throw new M(V.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t6);
  }
  return t3.now = function() {
    return t3.fromMillis(Date.now());
  }, t3.fromDate = function(e28) {
    return t3.fromMillis(e28.getTime());
  }, t3.fromMillis = function(e28) {
    var n3 = Math.floor(e28 / 1e3);
    return new t3(n3, 1e6 * (e28 - 1e3 * n3));
  }, t3.prototype.toDate = function() {
    return new Date(this.toMillis());
  }, t3.prototype.toMillis = function() {
    return 1e3 * this.seconds + this.nanoseconds / 1e6;
  }, t3.prototype.K = function(t6) {
    return this.seconds === t6.seconds ? P$1(this.nanoseconds, t6.nanoseconds) : P$1(this.seconds, t6.seconds);
  }, t3.prototype.isEqual = function(t6) {
    return t6.seconds === this.seconds && t6.nanoseconds === this.nanoseconds;
  }, t3.prototype.toString = function() {
    return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
  }, t3.prototype.toJSON = function() {
    return {
      seconds: this.seconds,
      nanoseconds: this.nanoseconds
    };
  }, t3.prototype.valueOf = function() {
    var t6 = this.seconds - -62135596800;
    return String(t6).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
  }, t3;
}(), Z = function() {
  function t3(t6) {
    this.timestamp = t6;
  }
  return t3.W = function(e28) {
    return new t3(e28);
  }, t3.min = function() {
    return new t3(new X(0, 0));
  }, t3.prototype.u = function(t6) {
    return this.timestamp.K(t6.timestamp);
  }, t3.prototype.isEqual = function(t6) {
    return this.timestamp.isEqual(t6.timestamp);
  }, t3.prototype.j = function() {
    return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
  }, t3.prototype.toString = function() {
    return "SnapshotVersion(" + this.timestamp.toString() + ")";
  }, t3.prototype.G = function() {
    return this.timestamp;
  }, t3;
}(), tt = function() {
  function t3(t6, e28, n3) {
    e28 === void 0 ? e28 = 0 : e28 > t6.length && S(), n3 === void 0 ? n3 = t6.length - e28 : n3 > t6.length - e28 && S(), this.segments = t6, this.offset = e28, this.H = n3;
  }
  return Object.defineProperty(t3.prototype, "length", {
    get: function() {
      return this.H;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.isEqual = function(e28) {
    return t3.J(this, e28) === 0;
  }, t3.prototype.child = function(e28) {
    var n3 = this.segments.slice(this.offset, this.limit());
    return e28 instanceof t3 ? e28.forEach(function(t6) {
      n3.push(t6);
    }) : n3.push(e28), this.Y(n3);
  }, t3.prototype.limit = function() {
    return this.offset + this.length;
  }, t3.prototype.X = function(t6) {
    return t6 = t6 === void 0 ? 1 : t6, this.Y(this.segments, this.offset + t6, this.length - t6);
  }, t3.prototype.Z = function() {
    return this.Y(this.segments, this.offset, this.length - 1);
  }, t3.prototype.tt = function() {
    return this.segments[this.offset];
  }, t3.prototype.et = function() {
    return this.get(this.length - 1);
  }, t3.prototype.get = function(t6) {
    return this.segments[this.offset + t6];
  }, t3.prototype.nt = function() {
    return this.length === 0;
  }, t3.prototype.st = function(t6) {
    if (t6.length < this.length)
      return false;
    for (var e28 = 0; e28 < this.length; e28++)
      if (this.get(e28) !== t6.get(e28))
        return false;
    return true;
  }, t3.prototype.it = function(t6) {
    if (this.length + 1 !== t6.length)
      return false;
    for (var e28 = 0; e28 < this.length; e28++)
      if (this.get(e28) !== t6.get(e28))
        return false;
    return true;
  }, t3.prototype.forEach = function(t6) {
    for (var e28 = this.offset, n3 = this.limit(); e28 < n3; e28++)
      t6(this.segments[e28]);
  }, t3.prototype.rt = function() {
    return this.segments.slice(this.offset, this.limit());
  }, t3.J = function(t6, e28) {
    for (var n3 = Math.min(t6.length, e28.length), r3 = 0; r3 < n3; r3++) {
      var i = t6.get(r3), o3 = e28.get(r3);
      if (i < o3)
        return -1;
      if (i > o3)
        return 1;
    }
    return t6.length < e28.length ? -1 : t6.length > e28.length ? 1 : 0;
  }, t3;
}(), et = function(t3) {
  function e28() {
    return t3 !== null && t3.apply(this, arguments) || this;
  }
  return __extends$1(e28, t3), e28.prototype.Y = function(t6, n3, r3) {
    return new e28(t6, n3, r3);
  }, e28.prototype.ot = function() {
    return this.rt().join("/");
  }, e28.prototype.toString = function() {
    return this.ot();
  }, e28.ct = function() {
    for (var t6 = [], n3 = 0; n3 < arguments.length; n3++)
      t6[n3] = arguments[n3];
    for (var r3 = [], i = 0, o3 = t6; i < o3.length; i++) {
      var u3 = o3[i];
      if (u3.indexOf("//") >= 0)
        throw new M(V.INVALID_ARGUMENT, "Invalid segment (" + u3 + "). Paths must not contain // in them.");
      r3.push.apply(r3, u3.split("/").filter(function(t10) {
        return t10.length > 0;
      }));
    }
    return new e28(r3);
  }, e28.at = function() {
    return new e28([]);
  }, e28;
}(tt), nt = /^[_a-zA-Z][_a-zA-Z0-9]*$/, rt = function(t3) {
  function e28() {
    return t3 !== null && t3.apply(this, arguments) || this;
  }
  return __extends$1(e28, t3), e28.prototype.Y = function(t6, n3, r3) {
    return new e28(t6, n3, r3);
  }, e28.ut = function(t6) {
    return nt.test(t6);
  }, e28.prototype.ot = function() {
    return this.rt().map(function(t6) {
      return t6 = t6.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), e28.ut(t6) || (t6 = "`" + t6 + "`"), t6;
    }).join(".");
  }, e28.prototype.toString = function() {
    return this.ot();
  }, e28.prototype.ht = function() {
    return this.length === 1 && this.get(0) === "__name__";
  }, e28.lt = function() {
    return new e28(["__name__"]);
  }, e28._t = function(t6) {
    for (var n3 = [], r3 = "", i = 0, o3 = function() {
      if (r3.length === 0)
        throw new M(V.INVALID_ARGUMENT, "Invalid field path (" + t6 + "). Paths must not be empty, begin with '.', end with '.', or contain '..'");
      n3.push(r3), r3 = "";
    }, u3 = false; i < t6.length; ) {
      var s3 = t6[i];
      if (s3 === "\\") {
        if (i + 1 === t6.length)
          throw new M(V.INVALID_ARGUMENT, "Path has trailing escape character: " + t6);
        var a3 = t6[i + 1];
        if (a3 !== "\\" && a3 !== "." && a3 !== "`")
          throw new M(V.INVALID_ARGUMENT, "Path has invalid escape sequence: " + t6);
        r3 += a3, i += 2;
      } else
        s3 === "`" ? (u3 = !u3, i++) : s3 !== "." || u3 ? (r3 += s3, i++) : (o3(), i++);
    }
    if (o3(), u3)
      throw new M(V.INVALID_ARGUMENT, "Unterminated ` in path: " + t6);
    return new e28(n3);
  }, e28.at = function() {
    return new e28([]);
  }, e28;
}(tt), it = function() {
  function t3(t6) {
    this.path = t6;
  }
  return t3.ft = function(e28) {
    return new t3(et.ct(e28));
  }, t3.dt = function(e28) {
    return new t3(et.ct(e28).X(5));
  }, t3.prototype.wt = function(t6) {
    return this.path.length >= 2 && this.path.get(this.path.length - 2) === t6;
  }, t3.prototype.isEqual = function(t6) {
    return t6 !== null && et.J(this.path, t6.path) === 0;
  }, t3.prototype.toString = function() {
    return this.path.toString();
  }, t3.J = function(t6, e28) {
    return et.J(t6.path, e28.path);
  }, t3.Et = function(t6) {
    return t6.length % 2 == 0;
  }, t3.Tt = function(e28) {
    return new t3(new et(e28.slice()));
  }, t3;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ot(t3) {
  var e28 = 0;
  for (var n3 in t3)
    Object.prototype.hasOwnProperty.call(t3, n3) && e28++;
  return e28;
}
function ut(t3, e28) {
  for (var n3 in t3)
    Object.prototype.hasOwnProperty.call(t3, n3) && e28(n3, t3[n3]);
}
function st(t3) {
  for (var e28 in t3)
    if (Object.prototype.hasOwnProperty.call(t3, e28))
      return false;
  return true;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var at = function() {
  function t3(t6) {
    this.fields = t6, t6.sort(rt.J);
  }
  return t3.prototype.It = function(t6) {
    for (var e28 = 0, n3 = this.fields; e28 < n3.length; e28++) {
      if (n3[e28].st(t6))
        return true;
    }
    return false;
  }, t3.prototype.isEqual = function(t6) {
    return C(this.fields, t6.fields, function(t10, e28) {
      return t10.isEqual(e28);
    });
  }, t3;
}(), ct = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ft(t3) {
  if (x(!!t3), typeof t3 == "string") {
    var e28 = 0, n3 = ct.exec(t3);
    if (x(!!n3), n3[1]) {
      var r3 = n3[1];
      r3 = (r3 + "000000000").substr(0, 9), e28 = Number(r3);
    }
    var i = new Date(t3);
    return {
      seconds: Math.floor(i.getTime() / 1e3),
      nanos: e28
    };
  }
  return {
    seconds: ht(t3.seconds),
    nanos: ht(t3.nanos)
  };
}
function ht(t3) {
  return typeof t3 == "number" ? t3 : typeof t3 == "string" ? Number(t3) : 0;
}
function lt(t3) {
  return typeof t3 == "string" ? R.fromBase64String(t3) : R.fromUint8Array(t3);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function pt(t3) {
  var e28, n3;
  return ((n3 = (((e28 = t3 == null ? void 0 : t3.mapValue) === null || e28 === void 0 ? void 0 : e28.fields) || {}).__type__) === null || n3 === void 0 ? void 0 : n3.stringValue) === "server_timestamp";
}
function dt(t3) {
  var e28 = t3.mapValue.fields.__previous_value__;
  return pt(e28) ? dt(e28) : e28;
}
function vt(t3) {
  var e28 = ft(t3.mapValue.fields.__local_write_time__.timestampValue);
  return new X(e28.seconds, e28.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function yt(t3) {
  return t3 == null;
}
function mt(t3) {
  return t3 === 0 && 1 / t3 == -1 / 0;
}
function gt(t3) {
  return typeof t3 == "number" && Number.isInteger(t3) && !mt(t3) && t3 <= Number.MAX_SAFE_INTEGER && t3 >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function wt(t3) {
  return "nullValue" in t3 ? 0 : "booleanValue" in t3 ? 1 : "integerValue" in t3 || "doubleValue" in t3 ? 2 : "timestampValue" in t3 ? 3 : "stringValue" in t3 ? 5 : "bytesValue" in t3 ? 6 : "referenceValue" in t3 ? 7 : "geoPointValue" in t3 ? 8 : "arrayValue" in t3 ? 9 : "mapValue" in t3 ? pt(t3) ? 4 : 10 : S();
}
function bt(t3, e28) {
  var n3 = wt(t3);
  if (n3 !== wt(e28))
    return false;
  switch (n3) {
    case 0:
      return true;
    case 1:
      return t3.booleanValue === e28.booleanValue;
    case 4:
      return vt(t3).isEqual(vt(e28));
    case 3:
      return function(t6, e29) {
        if (typeof t6.timestampValue == "string" && typeof e29.timestampValue == "string" && t6.timestampValue.length === e29.timestampValue.length)
          return t6.timestampValue === e29.timestampValue;
        var n6 = ft(t6.timestampValue), r3 = ft(e29.timestampValue);
        return n6.seconds === r3.seconds && n6.nanos === r3.nanos;
      }(t3, e28);
    case 5:
      return t3.stringValue === e28.stringValue;
    case 6:
      return function(t6, e29) {
        return lt(t6.bytesValue).isEqual(lt(e29.bytesValue));
      }(t3, e28);
    case 7:
      return t3.referenceValue === e28.referenceValue;
    case 8:
      return function(t6, e29) {
        return ht(t6.geoPointValue.latitude) === ht(e29.geoPointValue.latitude) && ht(t6.geoPointValue.longitude) === ht(e29.geoPointValue.longitude);
      }(t3, e28);
    case 2:
      return function(t6, e29) {
        if ("integerValue" in t6 && "integerValue" in e29)
          return ht(t6.integerValue) === ht(e29.integerValue);
        if ("doubleValue" in t6 && "doubleValue" in e29) {
          var n6 = ht(t6.doubleValue), r3 = ht(e29.doubleValue);
          return n6 === r3 ? mt(n6) === mt(r3) : isNaN(n6) && isNaN(r3);
        }
        return false;
      }(t3, e28);
    case 9:
      return C(t3.arrayValue.values || [], e28.arrayValue.values || [], bt);
    case 10:
      return function(t6, e29) {
        var n6 = t6.mapValue.fields || {}, r3 = e29.mapValue.fields || {};
        if (ot(n6) !== ot(r3))
          return false;
        for (var i in n6)
          if (n6.hasOwnProperty(i) && (r3[i] === void 0 || !bt(n6[i], r3[i])))
            return false;
        return true;
      }(t3, e28);
    default:
      return S();
  }
}
function It(t3, e28) {
  return (t3.values || []).find(function(t6) {
    return bt(t6, e28);
  }) !== void 0;
}
function _t(t3, e28) {
  var n3 = wt(t3), r3 = wt(e28);
  if (n3 !== r3)
    return P$1(n3, r3);
  switch (n3) {
    case 0:
      return 0;
    case 1:
      return P$1(t3.booleanValue, e28.booleanValue);
    case 2:
      return function(t6, e29) {
        var n6 = ht(t6.integerValue || t6.doubleValue), r6 = ht(e29.integerValue || e29.doubleValue);
        return n6 < r6 ? -1 : n6 > r6 ? 1 : n6 === r6 ? 0 : isNaN(n6) ? isNaN(r6) ? 0 : -1 : 1;
      }(t3, e28);
    case 3:
      return Et(t3.timestampValue, e28.timestampValue);
    case 4:
      return Et(vt(t3), vt(e28));
    case 5:
      return P$1(t3.stringValue, e28.stringValue);
    case 6:
      return function(t6, e29) {
        var n6 = lt(t6), r6 = lt(e29);
        return n6.u(r6);
      }(t3.bytesValue, e28.bytesValue);
    case 7:
      return function(t6, e29) {
        for (var n6 = t6.split("/"), r6 = e29.split("/"), i = 0; i < n6.length && i < r6.length; i++) {
          var o3 = P$1(n6[i], r6[i]);
          if (o3 !== 0)
            return o3;
        }
        return P$1(n6.length, r6.length);
      }(t3.referenceValue, e28.referenceValue);
    case 8:
      return function(t6, e29) {
        var n6 = P$1(ht(t6.latitude), ht(e29.latitude));
        return n6 !== 0 ? n6 : P$1(ht(t6.longitude), ht(e29.longitude));
      }(t3.geoPointValue, e28.geoPointValue);
    case 9:
      return function(t6, e29) {
        for (var n6 = t6.values || [], r6 = e29.values || [], i = 0; i < n6.length && i < r6.length; ++i) {
          var o3 = _t(n6[i], r6[i]);
          if (o3)
            return o3;
        }
        return P$1(n6.length, r6.length);
      }(t3.arrayValue, e28.arrayValue);
    case 10:
      return function(t6, e29) {
        var n6 = t6.fields || {}, r6 = Object.keys(n6), i = e29.fields || {}, o3 = Object.keys(i);
        r6.sort(), o3.sort();
        for (var u3 = 0; u3 < r6.length && u3 < o3.length; ++u3) {
          var s3 = P$1(r6[u3], o3[u3]);
          if (s3 !== 0)
            return s3;
          var a3 = _t(n6[r6[u3]], i[o3[u3]]);
          if (a3 !== 0)
            return a3;
        }
        return P$1(r6.length, o3.length);
      }(t3.mapValue, e28.mapValue);
    default:
      throw S();
  }
}
function Et(t3, e28) {
  if (typeof t3 == "string" && typeof e28 == "string" && t3.length === e28.length)
    return P$1(t3, e28);
  var n3 = ft(t3), r3 = ft(e28), i = P$1(n3.seconds, r3.seconds);
  return i !== 0 ? i : P$1(n3.nanos, r3.nanos);
}
function Tt(t3) {
  return Nt(t3);
}
function Nt(t3) {
  return "nullValue" in t3 ? "null" : "booleanValue" in t3 ? "" + t3.booleanValue : "integerValue" in t3 ? "" + t3.integerValue : "doubleValue" in t3 ? "" + t3.doubleValue : "timestampValue" in t3 ? function(t6) {
    var e29 = ft(t6);
    return "time(" + e29.seconds + "," + e29.nanos + ")";
  }(t3.timestampValue) : "stringValue" in t3 ? t3.stringValue : "bytesValue" in t3 ? lt(t3.bytesValue).toBase64() : "referenceValue" in t3 ? (n3 = t3.referenceValue, it.dt(n3).toString()) : "geoPointValue" in t3 ? "geo(" + (e28 = t3.geoPointValue).latitude + "," + e28.longitude + ")" : "arrayValue" in t3 ? function(t6) {
    for (var e29 = "[", n6 = true, r3 = 0, i = t6.values || []; r3 < i.length; r3++) {
      n6 ? n6 = false : e29 += ",", e29 += Nt(i[r3]);
    }
    return e29 + "]";
  }(t3.arrayValue) : "mapValue" in t3 ? function(t6) {
    for (var e29 = "{", n6 = true, r3 = 0, i = Object.keys(t6.fields || {}).sort(); r3 < i.length; r3++) {
      var o3 = i[r3];
      n6 ? n6 = false : e29 += ",", e29 += o3 + ":" + Nt(t6.fields[o3]);
    }
    return e29 + "}";
  }(t3.mapValue) : S();
  var e28, n3;
}
function At(t3, e28) {
  return {
    referenceValue: "projects/" + t3.projectId + "/databases/" + t3.database + "/documents/" + e28.path.ot()
  };
}
function St(t3) {
  return !!t3 && "integerValue" in t3;
}
function xt(t3) {
  return !!t3 && "arrayValue" in t3;
}
function Dt(t3) {
  return !!t3 && "nullValue" in t3;
}
function kt(t3) {
  return !!t3 && "doubleValue" in t3 && isNaN(Number(t3.doubleValue));
}
function Ot(t3) {
  return !!t3 && "mapValue" in t3;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Pt = function() {
  function t3(t6) {
    this.proto = t6;
  }
  return t3.empty = function() {
    return new t3({
      mapValue: {}
    });
  }, t3.prototype.field = function(t6) {
    if (t6.nt())
      return this.proto;
    for (var e28 = this.proto, n3 = 0; n3 < t6.length - 1; ++n3) {
      if (!e28.mapValue.fields)
        return null;
      if (!Ot(e28 = e28.mapValue.fields[t6.get(n3)]))
        return null;
    }
    return (e28 = (e28.mapValue.fields || {})[t6.et()]) || null;
  }, t3.prototype.isEqual = function(t6) {
    return bt(this.proto, t6.proto);
  }, t3;
}(), Ct = function() {
  function t3(t6) {
    t6 === void 0 && (t6 = Pt.empty()), this.At = t6, this.Rt = new Map();
  }
  return t3.prototype.set = function(t6, e28) {
    return this.Pt(t6, e28), this;
  }, t3.prototype.delete = function(t6) {
    return this.Pt(t6, null), this;
  }, t3.prototype.Pt = function(t6, e28) {
    for (var n3 = this.Rt, r3 = 0; r3 < t6.length - 1; ++r3) {
      var i = t6.get(r3), o3 = n3.get(i);
      o3 instanceof Map ? n3 = o3 : o3 && wt(o3) === 10 ? (o3 = new Map(Object.entries(o3.mapValue.fields || {})), n3.set(i, o3), n3 = o3) : (o3 = new Map(), n3.set(i, o3), n3 = o3);
    }
    n3.set(t6.et(), e28);
  }, t3.prototype.yt = function() {
    var t6 = this.gt(rt.at(), this.Rt);
    return t6 != null ? new Pt(t6) : this.At;
  }, t3.prototype.gt = function(t6, e28) {
    var n3 = this, r3 = false, i = this.At.field(t6), o3 = Ot(i) ? Object.assign({}, i.mapValue.fields) : {};
    return e28.forEach(function(e29, i3) {
      if (e29 instanceof Map) {
        var u3 = n3.gt(t6.child(i3), e29);
        u3 != null && (o3[i3] = u3, r3 = true);
      } else
        e29 !== null ? (o3[i3] = e29, r3 = true) : o3.hasOwnProperty(i3) && (delete o3[i3], r3 = true);
    }), r3 ? {
      mapValue: {
        fields: o3
      }
    } : null;
  }, t3;
}();
function Lt(t3) {
  var e28 = [];
  return ut(t3.fields || {}, function(t6, n3) {
    var r3 = new rt([t6]);
    if (Ot(n3)) {
      var i = Lt(n3.mapValue).fields;
      if (i.length === 0)
        e28.push(r3);
      else
        for (var o3 = 0, u3 = i; o3 < u3.length; o3++) {
          var s3 = u3[o3];
          e28.push(r3.child(s3));
        }
    } else
      e28.push(r3);
  }), new at(e28);
}
var Rt = function(t3, e28) {
  this.key = t3, this.version = e28;
}, Vt = function(t3) {
  function e28(e29, n3, r3, i) {
    var o3 = this;
    return (o3 = t3.call(this, e29, n3) || this).Vt = r3, o3.bt = !!i.bt, o3.hasCommittedMutations = !!i.hasCommittedMutations, o3;
  }
  return __extends$1(e28, t3), e28.prototype.field = function(t6) {
    return this.Vt.field(t6);
  }, e28.prototype.data = function() {
    return this.Vt;
  }, e28.prototype.vt = function() {
    return this.Vt.proto;
  }, e28.prototype.isEqual = function(t6) {
    return t6 instanceof e28 && this.key.isEqual(t6.key) && this.version.isEqual(t6.version) && this.bt === t6.bt && this.hasCommittedMutations === t6.hasCommittedMutations && this.Vt.isEqual(t6.Vt);
  }, e28.prototype.toString = function() {
    return "Document(" + this.key + ", " + this.version + ", " + this.Vt.toString() + ", {hasLocalMutations: " + this.bt + "}), {hasCommittedMutations: " + this.hasCommittedMutations + "})";
  }, Object.defineProperty(e28.prototype, "hasPendingWrites", {
    get: function() {
      return this.bt || this.hasCommittedMutations;
    },
    enumerable: false,
    configurable: true
  }), e28;
}(Rt), Mt = function(t3) {
  function e28(e29, n3, r3) {
    var i = this;
    return (i = t3.call(this, e29, n3) || this).hasCommittedMutations = !(!r3 || !r3.hasCommittedMutations), i;
  }
  return __extends$1(e28, t3), e28.prototype.toString = function() {
    return "NoDocument(" + this.key + ", " + this.version + ")";
  }, Object.defineProperty(e28.prototype, "hasPendingWrites", {
    get: function() {
      return this.hasCommittedMutations;
    },
    enumerable: false,
    configurable: true
  }), e28.prototype.isEqual = function(t6) {
    return t6 instanceof e28 && t6.hasCommittedMutations === this.hasCommittedMutations && t6.version.isEqual(this.version) && t6.key.isEqual(this.key);
  }, e28;
}(Rt), Ut = function(t3) {
  function e28() {
    return t3 !== null && t3.apply(this, arguments) || this;
  }
  return __extends$1(e28, t3), e28.prototype.toString = function() {
    return "UnknownDocument(" + this.key + ", " + this.version + ")";
  }, Object.defineProperty(e28.prototype, "hasPendingWrites", {
    get: function() {
      return true;
    },
    enumerable: false,
    configurable: true
  }), e28.prototype.isEqual = function(t6) {
    return t6 instanceof e28 && t6.version.isEqual(this.version) && t6.key.isEqual(this.key);
  }, e28;
}(Rt), qt = function(t3, e28, n3, r3, i, o3, u3) {
  e28 === void 0 && (e28 = null), n3 === void 0 && (n3 = []), r3 === void 0 && (r3 = []), i === void 0 && (i = null), o3 === void 0 && (o3 = null), u3 === void 0 && (u3 = null), this.path = t3, this.collectionGroup = e28, this.orderBy = n3, this.filters = r3, this.limit = i, this.startAt = o3, this.endAt = u3, this.St = null;
};
function Ft(t3, e28, n3, r3, i, o3, u3) {
  return e28 === void 0 && (e28 = null), n3 === void 0 && (n3 = []), r3 === void 0 && (r3 = []), i === void 0 && (i = null), o3 === void 0 && (o3 = null), u3 === void 0 && (u3 = null), new qt(t3, e28, n3, r3, i, o3, u3);
}
function jt(t3) {
  var e28 = D(t3);
  if (e28.St === null) {
    var n3 = e28.path.ot();
    e28.collectionGroup !== null && (n3 += "|cg:" + e28.collectionGroup), n3 += "|f:", n3 += e28.filters.map(function(t6) {
      return function(t10) {
        return t10.field.ot() + t10.op.toString() + Tt(t10.value);
      }(t6);
    }).join(","), n3 += "|ob:", n3 += e28.orderBy.map(function(t6) {
      return function(t10) {
        return t10.field.ot() + t10.dir;
      }(t6);
    }).join(","), yt(e28.limit) || (n3 += "|l:", n3 += e28.limit), e28.startAt && (n3 += "|lb:", n3 += te(e28.startAt)), e28.endAt && (n3 += "|ub:", n3 += te(e28.endAt)), e28.St = n3;
  }
  return e28.St;
}
function zt(t3, e28) {
  if (t3.limit !== e28.limit)
    return false;
  if (t3.orderBy.length !== e28.orderBy.length)
    return false;
  for (var n3 = 0; n3 < t3.orderBy.length; n3++)
    if (!ne(t3.orderBy[n3], e28.orderBy[n3]))
      return false;
  if (t3.filters.length !== e28.filters.length)
    return false;
  for (var r3 = 0; r3 < t3.filters.length; r3++)
    if (i = t3.filters[r3], o3 = e28.filters[r3], i.op !== o3.op || !i.field.isEqual(o3.field) || !bt(i.value, o3.value))
      return false;
  var i, o3;
  return t3.collectionGroup === e28.collectionGroup && !!t3.path.isEqual(e28.path) && !!ie(t3.startAt, e28.startAt) && ie(t3.endAt, e28.endAt);
}
function Gt(t3) {
  return it.Et(t3.path) && t3.collectionGroup === null && t3.filters.length === 0;
}
var Bt = function(t3) {
  function e28(e29, n3, r3) {
    var i = this;
    return (i = t3.call(this) || this).field = e29, i.op = n3, i.value = r3, i;
  }
  return __extends$1(e28, t3), e28.create = function(t6, n3, r3) {
    return t6.ht() ? n3 === "in" || n3 === "not-in" ? this.Dt(t6, n3, r3) : new Kt(t6, n3, r3) : n3 === "array-contains" ? new Qt(t6, r3) : n3 === "in" ? new Yt(t6, r3) : n3 === "not-in" ? new $t(t6, r3) : n3 === "array-contains-any" ? new Xt(t6, r3) : new e28(t6, n3, r3);
  }, e28.Dt = function(t6, e29, n3) {
    return e29 === "in" ? new Ht(t6, n3) : new Jt(t6, n3);
  }, e28.prototype.matches = function(t6) {
    var e29 = t6.field(this.field);
    return this.op === "!=" ? e29 !== null && this.Ct(_t(e29, this.value)) : e29 !== null && wt(this.value) === wt(e29) && this.Ct(_t(e29, this.value));
  }, e28.prototype.Ct = function(t6) {
    switch (this.op) {
      case "<":
        return t6 < 0;
      case "<=":
        return t6 <= 0;
      case "==":
        return t6 === 0;
      case "!=":
        return t6 !== 0;
      case ">":
        return t6 > 0;
      case ">=":
        return t6 >= 0;
      default:
        return S();
    }
  }, e28.prototype.xt = function() {
    return ["<", "<=", ">", ">=", "!=", "not-in"].indexOf(this.op) >= 0;
  }, e28;
}(function() {
});
var Kt = function(t3) {
  function e28(e29, n3, r3) {
    var i = this;
    return (i = t3.call(this, e29, n3, r3) || this).key = it.dt(r3.referenceValue), i;
  }
  return __extends$1(e28, t3), e28.prototype.matches = function(t6) {
    var e29 = it.J(t6.key, this.key);
    return this.Ct(e29);
  }, e28;
}(Bt), Ht = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, e29, "in", n3) || this).keys = Wt("in", n3), r3;
  }
  return __extends$1(e28, t3), e28.prototype.matches = function(t6) {
    return this.keys.some(function(e29) {
      return e29.isEqual(t6.key);
    });
  }, e28;
}(Bt), Jt = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, e29, "not-in", n3) || this).keys = Wt("not-in", n3), r3;
  }
  return __extends$1(e28, t3), e28.prototype.matches = function(t6) {
    return !this.keys.some(function(e29) {
      return e29.isEqual(t6.key);
    });
  }, e28;
}(Bt);
function Wt(t3, e28) {
  var n3;
  return (((n3 = e28.arrayValue) === null || n3 === void 0 ? void 0 : n3.values) || []).map(function(t6) {
    return it.dt(t6.referenceValue);
  });
}
var Qt = function(t3) {
  function e28(e29, n3) {
    return t3.call(this, e29, "array-contains", n3) || this;
  }
  return __extends$1(e28, t3), e28.prototype.matches = function(t6) {
    var e29 = t6.field(this.field);
    return xt(e29) && It(e29.arrayValue, this.value);
  }, e28;
}(Bt), Yt = function(t3) {
  function e28(e29, n3) {
    return t3.call(this, e29, "in", n3) || this;
  }
  return __extends$1(e28, t3), e28.prototype.matches = function(t6) {
    var e29 = t6.field(this.field);
    return e29 !== null && It(this.value.arrayValue, e29);
  }, e28;
}(Bt), $t = function(t3) {
  function e28(e29, n3) {
    return t3.call(this, e29, "not-in", n3) || this;
  }
  return __extends$1(e28, t3), e28.prototype.matches = function(t6) {
    if (It(this.value.arrayValue, {
      nullValue: "NULL_VALUE"
    }))
      return false;
    var e29 = t6.field(this.field);
    return e29 !== null && !It(this.value.arrayValue, e29);
  }, e28;
}(Bt), Xt = function(t3) {
  function e28(e29, n3) {
    return t3.call(this, e29, "array-contains-any", n3) || this;
  }
  return __extends$1(e28, t3), e28.prototype.matches = function(t6) {
    var e29 = this, n3 = t6.field(this.field);
    return !(!xt(n3) || !n3.arrayValue.values) && n3.arrayValue.values.some(function(t10) {
      return It(e29.value.arrayValue, t10);
    });
  }, e28;
}(Bt), Zt = function(t3, e28) {
  this.position = t3, this.before = e28;
};
function te(t3) {
  return (t3.before ? "b" : "a") + ":" + t3.position.map(function(t6) {
    return Tt(t6);
  }).join(",");
}
var ee = function(t3, e28) {
  e28 === void 0 && (e28 = "asc"), this.field = t3, this.dir = e28;
};
function ne(t3, e28) {
  return t3.dir === e28.dir && t3.field.isEqual(e28.field);
}
function re(t3, e28, n3) {
  for (var r3 = 0, i = 0; i < t3.position.length; i++) {
    var o3 = e28[i], u3 = t3.position[i];
    if (r3 = o3.field.ht() ? it.J(it.dt(u3.referenceValue), n3.key) : _t(u3, n3.field(o3.field)), o3.dir === "desc" && (r3 *= -1), r3 !== 0)
      break;
  }
  return t3.before ? r3 <= 0 : r3 < 0;
}
function ie(t3, e28) {
  if (t3 === null)
    return e28 === null;
  if (e28 === null)
    return false;
  if (t3.before !== e28.before || t3.position.length !== e28.position.length)
    return false;
  for (var n3 = 0; n3 < t3.position.length; n3++)
    if (!bt(t3.position[n3], e28.position[n3]))
      return false;
  return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var oe = function(t3, e28, n3, r3, i, o3, u3, s3) {
  e28 === void 0 && (e28 = null), n3 === void 0 && (n3 = []), r3 === void 0 && (r3 = []), i === void 0 && (i = null), o3 === void 0 && (o3 = "F"), u3 === void 0 && (u3 = null), s3 === void 0 && (s3 = null), this.path = t3, this.collectionGroup = e28, this.Nt = n3, this.filters = r3, this.limit = i, this.limitType = o3, this.startAt = u3, this.endAt = s3, this.Ft = null, this.Ot = null, this.startAt, this.endAt;
};
function ue(t3, e28, n3, r3, i, o3, u3, s3) {
  return new oe(t3, e28, n3, r3, i, o3, u3, s3);
}
function se(t3) {
  return new oe(t3);
}
function ae(t3) {
  return !yt(t3.limit) && t3.limitType === "F";
}
function ce(t3) {
  return !yt(t3.limit) && t3.limitType === "L";
}
function fe(t3) {
  return t3.Nt.length > 0 ? t3.Nt[0].field : null;
}
function he(t3) {
  for (var e28 = 0, n3 = t3.filters; e28 < n3.length; e28++) {
    var r3 = n3[e28];
    if (r3.xt())
      return r3.field;
  }
  return null;
}
function le(t3) {
  return t3.collectionGroup !== null;
}
function pe(t3) {
  var e28 = D(t3);
  if (e28.Ft === null) {
    e28.Ft = [];
    var n3 = he(e28), r3 = fe(e28);
    if (n3 !== null && r3 === null)
      n3.ht() || e28.Ft.push(new ee(n3)), e28.Ft.push(new ee(rt.lt(), "asc"));
    else {
      for (var i = false, o3 = 0, u3 = e28.Nt; o3 < u3.length; o3++) {
        var s3 = u3[o3];
        e28.Ft.push(s3), s3.field.ht() && (i = true);
      }
      if (!i) {
        var a3 = e28.Nt.length > 0 ? e28.Nt[e28.Nt.length - 1].dir : "asc";
        e28.Ft.push(new ee(rt.lt(), a3));
      }
    }
  }
  return e28.Ft;
}
function de(t3) {
  var e28 = D(t3);
  if (!e28.Ot)
    if (e28.limitType === "F")
      e28.Ot = Ft(e28.path, e28.collectionGroup, pe(e28), e28.filters, e28.limit, e28.startAt, e28.endAt);
    else {
      for (var n3 = [], r3 = 0, i = pe(e28); r3 < i.length; r3++) {
        var o3 = i[r3], u3 = o3.dir === "desc" ? "asc" : "desc";
        n3.push(new ee(o3.field, u3));
      }
      var s3 = e28.endAt ? new Zt(e28.endAt.position, !e28.endAt.before) : null, a3 = e28.startAt ? new Zt(e28.startAt.position, !e28.startAt.before) : null;
      e28.Ot = Ft(e28.path, e28.collectionGroup, n3, e28.filters, e28.limit, s3, a3);
    }
  return e28.Ot;
}
function ve(t3, e28, n3) {
  return new oe(t3.path, t3.collectionGroup, t3.Nt.slice(), t3.filters.slice(), e28, n3, t3.startAt, t3.endAt);
}
function ye(t3, e28) {
  return zt(de(t3), de(e28)) && t3.limitType === e28.limitType;
}
function me(t3) {
  return jt(de(t3)) + "|lt:" + t3.limitType;
}
function ge(t3) {
  return "Query(target=" + function(t6) {
    var e28 = t6.path.ot();
    return t6.collectionGroup !== null && (e28 += " collectionGroup=" + t6.collectionGroup), t6.filters.length > 0 && (e28 += ", filters: [" + t6.filters.map(function(t10) {
      return (e29 = t10).field.ot() + " " + e29.op + " " + Tt(e29.value);
      var e29;
    }).join(", ") + "]"), yt(t6.limit) || (e28 += ", limit: " + t6.limit), t6.orderBy.length > 0 && (e28 += ", orderBy: [" + t6.orderBy.map(function(t10) {
      return function(t11) {
        return t11.field.ot() + " (" + t11.dir + ")";
      }(t10);
    }).join(", ") + "]"), t6.startAt && (e28 += ", startAt: " + te(t6.startAt)), t6.endAt && (e28 += ", endAt: " + te(t6.endAt)), "Target(" + e28 + ")";
  }(de(t3)) + "; limitType=" + t3.limitType + ")";
}
function we(t3, e28) {
  return function(t6, e29) {
    var n3 = e29.key.path;
    return t6.collectionGroup !== null ? e29.key.wt(t6.collectionGroup) && t6.path.st(n3) : it.Et(t6.path) ? t6.path.isEqual(n3) : t6.path.it(n3);
  }(t3, e28) && function(t6, e29) {
    for (var n3 = 0, r3 = t6.Nt; n3 < r3.length; n3++) {
      var i = r3[n3];
      if (!i.field.ht() && e29.field(i.field) === null)
        return false;
    }
    return true;
  }(t3, e28) && function(t6, e29) {
    for (var n3 = 0, r3 = t6.filters; n3 < r3.length; n3++) {
      if (!r3[n3].matches(e29))
        return false;
    }
    return true;
  }(t3, e28) && function(t6, e29) {
    return !(t6.startAt && !re(t6.startAt, pe(t6), e29)) && (!t6.endAt || !re(t6.endAt, pe(t6), e29));
  }(t3, e28);
}
function be(t3) {
  return function(e28, n3) {
    for (var r3 = false, i = 0, o3 = pe(t3); i < o3.length; i++) {
      var u3 = o3[i], s3 = Ie(u3, e28, n3);
      if (s3 !== 0)
        return s3;
      r3 = r3 || u3.field.ht();
    }
    return 0;
  };
}
function Ie(t3, e28, n3) {
  var r3 = t3.field.ht() ? it.J(e28.key, n3.key) : function(t6, e29, n6) {
    var r6 = e29.field(t6), i = n6.field(t6);
    return r6 !== null && i !== null ? _t(r6, i) : S();
  }(t3.field, e28, n3);
  switch (t3.dir) {
    case "asc":
      return r3;
    case "desc":
      return -1 * r3;
    default:
      return S();
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _e = function() {
  function t3(t6, e28, n3, r3, i, o3, u3) {
    i === void 0 && (i = Z.min()), o3 === void 0 && (o3 = Z.min()), u3 === void 0 && (u3 = R.h), this.target = t6, this.targetId = e28, this.kt = n3, this.sequenceNumber = r3, this.Mt = i, this.lastLimboFreeSnapshotVersion = o3, this.resumeToken = u3;
  }
  return t3.prototype.Lt = function(e28) {
    return new t3(this.target, this.targetId, this.kt, e28, this.Mt, this.lastLimboFreeSnapshotVersion, this.resumeToken);
  }, t3.prototype.$t = function(e28, n3) {
    return new t3(this.target, this.targetId, this.kt, this.sequenceNumber, n3, this.lastLimboFreeSnapshotVersion, e28);
  }, t3.prototype.Bt = function(e28) {
    return new t3(this.target, this.targetId, this.kt, this.sequenceNumber, this.Mt, e28, this.resumeToken);
  }, t3;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ee(t3, e28) {
  if (t3.qt) {
    if (isNaN(e28))
      return {
        doubleValue: "NaN"
      };
    if (e28 === 1 / 0)
      return {
        doubleValue: "Infinity"
      };
    if (e28 === -1 / 0)
      return {
        doubleValue: "-Infinity"
      };
  }
  return {
    doubleValue: mt(e28) ? "-0" : e28
  };
}
function Te(t3) {
  return {
    integerValue: "" + t3
  };
}
function Ne(t3, e28) {
  return gt(e28) ? Te(e28) : Ee(t3, e28);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Ae = function() {
  this.Ut = void 0;
};
function Se(t3, e28, n3) {
  return t3 instanceof ke ? function(t6, e29) {
    var n6 = {
      fields: {
        __type__: {
          stringValue: "server_timestamp"
        },
        __local_write_time__: {
          timestampValue: {
            seconds: t6.seconds,
            nanos: t6.nanoseconds
          }
        }
      }
    };
    return e29 && (n6.fields.__previous_value__ = e29), {
      mapValue: n6
    };
  }(n3, e28) : t3 instanceof Oe ? Pe(t3, e28) : t3 instanceof Ce ? Le(t3, e28) : function(t6, e29) {
    var n6 = De(t6, e29), r3 = Ve(n6) + Ve(t6.Qt);
    return St(n6) && St(t6.Qt) ? Te(r3) : Ee(t6.Kt, r3);
  }(t3, e28);
}
function xe(t3, e28, n3) {
  return t3 instanceof Oe ? Pe(t3, e28) : t3 instanceof Ce ? Le(t3, e28) : n3;
}
function De(t3, e28) {
  return t3 instanceof Re ? St(n3 = e28) || function(t6) {
    return !!t6 && "doubleValue" in t6;
  }(n3) ? e28 : {
    integerValue: 0
  } : null;
  var n3;
}
var ke = function(t3) {
  function e28() {
    return t3 !== null && t3.apply(this, arguments) || this;
  }
  return __extends$1(e28, t3), e28;
}(Ae), Oe = function(t3) {
  function e28(e29) {
    var n3 = this;
    return (n3 = t3.call(this) || this).elements = e29, n3;
  }
  return __extends$1(e28, t3), e28;
}(Ae);
function Pe(t3, e28) {
  for (var n3 = Me(e28), r3 = function(t6) {
    n3.some(function(e29) {
      return bt(e29, t6);
    }) || n3.push(t6);
  }, i = 0, o3 = t3.elements; i < o3.length; i++) {
    r3(o3[i]);
  }
  return {
    arrayValue: {
      values: n3
    }
  };
}
var Ce = function(t3) {
  function e28(e29) {
    var n3 = this;
    return (n3 = t3.call(this) || this).elements = e29, n3;
  }
  return __extends$1(e28, t3), e28;
}(Ae);
function Le(t3, e28) {
  for (var n3 = Me(e28), r3 = function(t6) {
    n3 = n3.filter(function(e29) {
      return !bt(e29, t6);
    });
  }, i = 0, o3 = t3.elements; i < o3.length; i++) {
    r3(o3[i]);
  }
  return {
    arrayValue: {
      values: n3
    }
  };
}
var Re = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this) || this).Kt = e29, r3.Qt = n3, r3;
  }
  return __extends$1(e28, t3), e28;
}(Ae);
function Ve(t3) {
  return ht(t3.integerValue || t3.doubleValue);
}
function Me(t3) {
  return xt(t3) && t3.arrayValue.values ? t3.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Ue = function(t3, e28) {
  this.field = t3, this.transform = e28;
};
var qe = function(t3, e28) {
  this.version = t3, this.transformResults = e28;
}, Fe = function() {
  function t3(t6, e28) {
    this.updateTime = t6, this.exists = e28;
  }
  return t3.Wt = function() {
    return new t3();
  }, t3.exists = function(e28) {
    return new t3(void 0, e28);
  }, t3.updateTime = function(e28) {
    return new t3(e28);
  }, Object.defineProperty(t3.prototype, "jt", {
    get: function() {
      return this.updateTime === void 0 && this.exists === void 0;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.isEqual = function(t6) {
    return this.exists === t6.exists && (this.updateTime ? !!t6.updateTime && this.updateTime.isEqual(t6.updateTime) : !t6.updateTime);
  }, t3;
}();
function je(t3, e28) {
  return t3.updateTime !== void 0 ? e28 instanceof Vt && e28.version.isEqual(t3.updateTime) : t3.exists === void 0 || t3.exists === e28 instanceof Vt;
}
var ze = function() {
};
function Ge(t3, e28, n3) {
  return t3 instanceof We ? function(t6, e29, n6) {
    var r3 = t6.value;
    if (n6.transformResults) {
      var i = $e(t6.fieldTransforms, e29, n6.transformResults);
      r3 = Ze(t6.fieldTransforms, r3, i);
    }
    return new Vt(t6.key, n6.version, r3, {
      hasCommittedMutations: true
    });
  }(t3, e28, n3) : t3 instanceof Qe ? function(t6, e29, n6) {
    if (!je(t6.Gt, e29))
      return new Ut(t6.key, n6.version);
    var r3 = Ye(t6, e29, n6.transformResults ? $e(t6.fieldTransforms, e29, n6.transformResults) : []);
    return new Vt(t6.key, n6.version, r3, {
      hasCommittedMutations: true
    });
  }(t3, e28, n3) : function(t6, e29, n6) {
    return new Mt(t6.key, n6.version, {
      hasCommittedMutations: true
    });
  }(t3, 0, n3);
}
function Be(t3, e28, n3, r3) {
  return t3 instanceof We ? function(t6, e29, n6, r6) {
    if (!je(t6.Gt, e29))
      return e29;
    var i = t6.value;
    if (t6.fieldTransforms) {
      var o3 = Xe(t6.fieldTransforms, n6, e29, r6);
      i = Ze(t6.fieldTransforms, i, o3);
    }
    var u3 = Je(e29);
    return new Vt(t6.key, u3, i, {
      bt: true
    });
  }(t3, e28, r3, n3) : t3 instanceof Qe ? function(t6, e29, n6, r6) {
    if (!je(t6.Gt, e29))
      return e29;
    var i = Je(e29), o3 = Ye(t6, e29, Xe(t6.fieldTransforms, n6, e29, r6));
    return new Vt(t6.key, i, o3, {
      bt: true
    });
  }(t3, e28, r3, n3) : function(t6, e29) {
    return je(t6.Gt, e29) ? new Mt(t6.key, Z.min()) : e29;
  }(t3, e28);
}
function Ke(t3, e28) {
  return t3.fieldTransforms !== void 0 ? function(t6, e29) {
    for (var n3 = null, r3 = 0, i = t6; r3 < i.length; r3++) {
      var o3 = i[r3], u3 = e29 instanceof Vt ? e29.field(o3.field) : void 0, s3 = De(o3.transform, u3 || null);
      s3 != null && (n3 = n3 == null ? new Ct().set(o3.field, s3) : n3.set(o3.field, s3));
    }
    return n3 ? n3.yt() : null;
  }(t3.fieldTransforms, e28) : null;
}
function He(t3, e28) {
  return t3.type === e28.type && !!t3.key.isEqual(e28.key) && !!t3.Gt.isEqual(e28.Gt) && !!function(t6, e29) {
    return t6 === void 0 && e29 === void 0 || !(!t6 || !e29) && C(t6, e29, function(t10, e30) {
      return function(t11, e31) {
        return t11.field.isEqual(e31.field) && function(t12, e32) {
          return t12 instanceof Oe && e32 instanceof Oe || t12 instanceof Ce && e32 instanceof Ce ? C(t12.elements, e32.elements, bt) : t12 instanceof Re && e32 instanceof Re ? bt(t12.Qt, e32.Qt) : t12 instanceof ke && e32 instanceof ke;
        }(t11.transform, e31.transform);
      }(t10, e30);
    });
  }(t3.fieldTransforms, e28.fieldTransforms) && (t3.type === 0 ? t3.value.isEqual(e28.value) : t3.type !== 1 || t3.data.isEqual(e28.data) && t3.zt.isEqual(e28.zt));
}
function Je(t3) {
  return t3 instanceof Vt ? t3.version : Z.min();
}
var We = function(t3) {
  function e28(e29, n3, r3, i) {
    i === void 0 && (i = []);
    var o3 = this;
    return (o3 = t3.call(this) || this).key = e29, o3.value = n3, o3.Gt = r3, o3.fieldTransforms = i, o3.type = 0, o3;
  }
  return __extends$1(e28, t3), e28;
}(ze), Qe = function(t3) {
  function e28(e29, n3, r3, i, o3) {
    o3 === void 0 && (o3 = []);
    var u3 = this;
    return (u3 = t3.call(this) || this).key = e29, u3.data = n3, u3.zt = r3, u3.Gt = i, u3.fieldTransforms = o3, u3.type = 1, u3;
  }
  return __extends$1(e28, t3), e28;
}(ze);
function Ye(t3, e28, n3) {
  var r3;
  return r3 = function(t6, e29) {
    var n6 = new Ct(e29);
    return t6.zt.fields.forEach(function(e30) {
      if (!e30.nt()) {
        var r6 = t6.data.field(e30);
        r6 !== null ? n6.set(e30, r6) : n6.delete(e30);
      }
    }), n6.yt();
  }(t3, r3 = e28 instanceof Vt ? e28.data() : Pt.empty()), r3 = Ze(t3.fieldTransforms, r3, n3);
}
function $e(t3, e28, n3) {
  var r3 = [];
  x(t3.length === n3.length);
  for (var i = 0; i < n3.length; i++) {
    var o3 = t3[i], u3 = o3.transform, s3 = null;
    e28 instanceof Vt && (s3 = e28.field(o3.field)), r3.push(xe(u3, s3, n3[i]));
  }
  return r3;
}
function Xe(t3, e28, n3, r3) {
  for (var i = [], o3 = 0, u3 = t3; o3 < u3.length; o3++) {
    var s3 = u3[o3], a3 = s3.transform, c3 = null;
    n3 instanceof Vt && (c3 = n3.field(s3.field)), c3 === null && r3 instanceof Vt && (c3 = r3.field(s3.field)), i.push(Se(a3, c3, e28));
  }
  return i;
}
function Ze(t3, e28, n3) {
  for (var r3 = new Ct(e28), i = 0; i < t3.length; i++) {
    var o3 = t3[i];
    r3.set(o3.field, n3[i]);
  }
  return r3.yt();
}
var tn, en, nn = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this) || this).key = e29, r3.Gt = n3, r3.type = 2, r3.fieldTransforms = [], r3;
  }
  return __extends$1(e28, t3), e28;
}(ze), rn = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this) || this).key = e29, r3.Gt = n3, r3.type = 3, r3.fieldTransforms = [], r3;
  }
  return __extends$1(e28, t3), e28;
}(ze), on = function(t3) {
  this.count = t3;
};
function un(t3) {
  switch (t3) {
    case V.OK:
      return S();
    case V.CANCELLED:
    case V.UNKNOWN:
    case V.DEADLINE_EXCEEDED:
    case V.RESOURCE_EXHAUSTED:
    case V.INTERNAL:
    case V.UNAVAILABLE:
    case V.UNAUTHENTICATED:
      return false;
    case V.INVALID_ARGUMENT:
    case V.NOT_FOUND:
    case V.ALREADY_EXISTS:
    case V.PERMISSION_DENIED:
    case V.FAILED_PRECONDITION:
    case V.ABORTED:
    case V.OUT_OF_RANGE:
    case V.UNIMPLEMENTED:
    case V.DATA_LOSS:
      return true;
    default:
      return S();
  }
}
function sn(t3) {
  if (t3 === void 0)
    return T("GRPC error has no .code"), V.UNKNOWN;
  switch (t3) {
    case tn.OK:
      return V.OK;
    case tn.CANCELLED:
      return V.CANCELLED;
    case tn.UNKNOWN:
      return V.UNKNOWN;
    case tn.DEADLINE_EXCEEDED:
      return V.DEADLINE_EXCEEDED;
    case tn.RESOURCE_EXHAUSTED:
      return V.RESOURCE_EXHAUSTED;
    case tn.INTERNAL:
      return V.INTERNAL;
    case tn.UNAVAILABLE:
      return V.UNAVAILABLE;
    case tn.UNAUTHENTICATED:
      return V.UNAUTHENTICATED;
    case tn.INVALID_ARGUMENT:
      return V.INVALID_ARGUMENT;
    case tn.NOT_FOUND:
      return V.NOT_FOUND;
    case tn.ALREADY_EXISTS:
      return V.ALREADY_EXISTS;
    case tn.PERMISSION_DENIED:
      return V.PERMISSION_DENIED;
    case tn.FAILED_PRECONDITION:
      return V.FAILED_PRECONDITION;
    case tn.ABORTED:
      return V.ABORTED;
    case tn.OUT_OF_RANGE:
      return V.OUT_OF_RANGE;
    case tn.UNIMPLEMENTED:
      return V.UNIMPLEMENTED;
    case tn.DATA_LOSS:
      return V.DATA_LOSS;
    default:
      return S();
  }
}
(en = tn || (tn = {}))[en.OK = 0] = "OK", en[en.CANCELLED = 1] = "CANCELLED", en[en.UNKNOWN = 2] = "UNKNOWN", en[en.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", en[en.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", en[en.NOT_FOUND = 5] = "NOT_FOUND", en[en.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", en[en.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", en[en.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", en[en.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", en[en.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", en[en.ABORTED = 10] = "ABORTED", en[en.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", en[en.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", en[en.INTERNAL = 13] = "INTERNAL", en[en.UNAVAILABLE = 14] = "UNAVAILABLE", en[en.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var an = function() {
  function t3(t6, e28) {
    this.J = t6, this.root = e28 || fn.EMPTY;
  }
  return t3.prototype.Ht = function(e28, n3) {
    return new t3(this.J, this.root.Ht(e28, n3, this.J).copy(null, null, fn.Jt, null, null));
  }, t3.prototype.remove = function(e28) {
    return new t3(this.J, this.root.remove(e28, this.J).copy(null, null, fn.Jt, null, null));
  }, t3.prototype.get = function(t6) {
    for (var e28 = this.root; !e28.nt(); ) {
      var n3 = this.J(t6, e28.key);
      if (n3 === 0)
        return e28.value;
      n3 < 0 ? e28 = e28.left : n3 > 0 && (e28 = e28.right);
    }
    return null;
  }, t3.prototype.indexOf = function(t6) {
    for (var e28 = 0, n3 = this.root; !n3.nt(); ) {
      var r3 = this.J(t6, n3.key);
      if (r3 === 0)
        return e28 + n3.left.size;
      r3 < 0 ? n3 = n3.left : (e28 += n3.left.size + 1, n3 = n3.right);
    }
    return -1;
  }, t3.prototype.nt = function() {
    return this.root.nt();
  }, Object.defineProperty(t3.prototype, "size", {
    get: function() {
      return this.root.size;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.Yt = function() {
    return this.root.Yt();
  }, t3.prototype.Xt = function() {
    return this.root.Xt();
  }, t3.prototype.Zt = function(t6) {
    return this.root.Zt(t6);
  }, t3.prototype.forEach = function(t6) {
    this.Zt(function(e28, n3) {
      return t6(e28, n3), false;
    });
  }, t3.prototype.toString = function() {
    var t6 = [];
    return this.Zt(function(e28, n3) {
      return t6.push(e28 + ":" + n3), false;
    }), "{" + t6.join(", ") + "}";
  }, t3.prototype.te = function(t6) {
    return this.root.te(t6);
  }, t3.prototype.ee = function() {
    return new cn(this.root, null, this.J, false);
  }, t3.prototype.ne = function(t6) {
    return new cn(this.root, t6, this.J, false);
  }, t3.prototype.se = function() {
    return new cn(this.root, null, this.J, true);
  }, t3.prototype.ie = function(t6) {
    return new cn(this.root, t6, this.J, true);
  }, t3;
}(), cn = function() {
  function t3(t6, e28, n3, r3) {
    this.re = r3, this.oe = [];
    for (var i = 1; !t6.nt(); )
      if (i = e28 ? n3(t6.key, e28) : 1, r3 && (i *= -1), i < 0)
        t6 = this.re ? t6.left : t6.right;
      else {
        if (i === 0) {
          this.oe.push(t6);
          break;
        }
        this.oe.push(t6), t6 = this.re ? t6.right : t6.left;
      }
  }
  return t3.prototype.ce = function() {
    var t6 = this.oe.pop(), e28 = {
      key: t6.key,
      value: t6.value
    };
    if (this.re)
      for (t6 = t6.left; !t6.nt(); )
        this.oe.push(t6), t6 = t6.right;
    else
      for (t6 = t6.right; !t6.nt(); )
        this.oe.push(t6), t6 = t6.left;
    return e28;
  }, t3.prototype.ae = function() {
    return this.oe.length > 0;
  }, t3.prototype.ue = function() {
    if (this.oe.length === 0)
      return null;
    var t6 = this.oe[this.oe.length - 1];
    return {
      key: t6.key,
      value: t6.value
    };
  }, t3;
}(), fn = function() {
  function t3(e28, n3, r3, i, o3) {
    this.key = e28, this.value = n3, this.color = r3 != null ? r3 : t3.RED, this.left = i != null ? i : t3.EMPTY, this.right = o3 != null ? o3 : t3.EMPTY, this.size = this.left.size + 1 + this.right.size;
  }
  return t3.prototype.copy = function(e28, n3, r3, i, o3) {
    return new t3(e28 != null ? e28 : this.key, n3 != null ? n3 : this.value, r3 != null ? r3 : this.color, i != null ? i : this.left, o3 != null ? o3 : this.right);
  }, t3.prototype.nt = function() {
    return false;
  }, t3.prototype.Zt = function(t6) {
    return this.left.Zt(t6) || t6(this.key, this.value) || this.right.Zt(t6);
  }, t3.prototype.te = function(t6) {
    return this.right.te(t6) || t6(this.key, this.value) || this.left.te(t6);
  }, t3.prototype.min = function() {
    return this.left.nt() ? this : this.left.min();
  }, t3.prototype.Yt = function() {
    return this.min().key;
  }, t3.prototype.Xt = function() {
    return this.right.nt() ? this.key : this.right.Xt();
  }, t3.prototype.Ht = function(t6, e28, n3) {
    var r3 = this, i = n3(t6, r3.key);
    return (r3 = i < 0 ? r3.copy(null, null, null, r3.left.Ht(t6, e28, n3), null) : i === 0 ? r3.copy(null, e28, null, null, null) : r3.copy(null, null, null, null, r3.right.Ht(t6, e28, n3))).he();
  }, t3.prototype.le = function() {
    if (this.left.nt())
      return t3.EMPTY;
    var e28 = this;
    return e28.left._e() || e28.left.left._e() || (e28 = e28.fe()), (e28 = e28.copy(null, null, null, e28.left.le(), null)).he();
  }, t3.prototype.remove = function(e28, n3) {
    var r3, i = this;
    if (n3(e28, i.key) < 0)
      i.left.nt() || i.left._e() || i.left.left._e() || (i = i.fe()), i = i.copy(null, null, null, i.left.remove(e28, n3), null);
    else {
      if (i.left._e() && (i = i.de()), i.right.nt() || i.right._e() || i.right.left._e() || (i = i.we()), n3(e28, i.key) === 0) {
        if (i.right.nt())
          return t3.EMPTY;
        r3 = i.right.min(), i = i.copy(r3.key, r3.value, null, null, i.right.le());
      }
      i = i.copy(null, null, null, null, i.right.remove(e28, n3));
    }
    return i.he();
  }, t3.prototype._e = function() {
    return this.color;
  }, t3.prototype.he = function() {
    var t6 = this;
    return t6.right._e() && !t6.left._e() && (t6 = t6.Ee()), t6.left._e() && t6.left.left._e() && (t6 = t6.de()), t6.left._e() && t6.right._e() && (t6 = t6.Te()), t6;
  }, t3.prototype.fe = function() {
    var t6 = this.Te();
    return t6.right.left._e() && (t6 = (t6 = (t6 = t6.copy(null, null, null, null, t6.right.de())).Ee()).Te()), t6;
  }, t3.prototype.we = function() {
    var t6 = this.Te();
    return t6.left.left._e() && (t6 = (t6 = t6.de()).Te()), t6;
  }, t3.prototype.Ee = function() {
    var e28 = this.copy(null, null, t3.RED, null, this.right.left);
    return this.right.copy(null, null, this.color, e28, null);
  }, t3.prototype.de = function() {
    var e28 = this.copy(null, null, t3.RED, this.left.right, null);
    return this.left.copy(null, null, this.color, null, e28);
  }, t3.prototype.Te = function() {
    var t6 = this.left.copy(null, null, !this.left.color, null, null), e28 = this.right.copy(null, null, !this.right.color, null, null);
    return this.copy(null, null, !this.color, t6, e28);
  }, t3.prototype.Ie = function() {
    var t6 = this.me();
    return Math.pow(2, t6) <= this.size + 1;
  }, t3.prototype.me = function() {
    if (this._e() && this.left._e())
      throw S();
    if (this.right._e())
      throw S();
    var t6 = this.left.me();
    if (t6 !== this.right.me())
      throw S();
    return t6 + (this._e() ? 0 : 1);
  }, t3;
}();
fn.EMPTY = null, fn.RED = true, fn.Jt = false, fn.EMPTY = new (function() {
  function t3() {
    this.size = 0;
  }
  return Object.defineProperty(t3.prototype, "key", {
    get: function() {
      throw S();
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "value", {
    get: function() {
      throw S();
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "color", {
    get: function() {
      throw S();
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "left", {
    get: function() {
      throw S();
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "right", {
    get: function() {
      throw S();
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.copy = function(t6, e28, n3, r3, i) {
    return this;
  }, t3.prototype.Ht = function(t6, e28, n3) {
    return new fn(t6, e28);
  }, t3.prototype.remove = function(t6, e28) {
    return this;
  }, t3.prototype.nt = function() {
    return true;
  }, t3.prototype.Zt = function(t6) {
    return false;
  }, t3.prototype.te = function(t6) {
    return false;
  }, t3.prototype.Yt = function() {
    return null;
  }, t3.prototype.Xt = function() {
    return null;
  }, t3.prototype._e = function() {
    return false;
  }, t3.prototype.Ie = function() {
    return true;
  }, t3.prototype.me = function() {
    return 0;
  }, t3;
}())();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var hn = function() {
  function t3(t6) {
    this.J = t6, this.data = new an(this.J);
  }
  return t3.prototype.has = function(t6) {
    return this.data.get(t6) !== null;
  }, t3.prototype.first = function() {
    return this.data.Yt();
  }, t3.prototype.last = function() {
    return this.data.Xt();
  }, Object.defineProperty(t3.prototype, "size", {
    get: function() {
      return this.data.size;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.indexOf = function(t6) {
    return this.data.indexOf(t6);
  }, t3.prototype.forEach = function(t6) {
    this.data.Zt(function(e28, n3) {
      return t6(e28), false;
    });
  }, t3.prototype.Ae = function(t6, e28) {
    for (var n3 = this.data.ne(t6[0]); n3.ae(); ) {
      var r3 = n3.ce();
      if (this.J(r3.key, t6[1]) >= 0)
        return;
      e28(r3.key);
    }
  }, t3.prototype.Re = function(t6, e28) {
    var n3;
    for (n3 = e28 !== void 0 ? this.data.ne(e28) : this.data.ee(); n3.ae(); )
      if (!t6(n3.ce().key))
        return;
  }, t3.prototype.Pe = function(t6) {
    var e28 = this.data.ne(t6);
    return e28.ae() ? e28.ce().key : null;
  }, t3.prototype.ee = function() {
    return new ln(this.data.ee());
  }, t3.prototype.ne = function(t6) {
    return new ln(this.data.ne(t6));
  }, t3.prototype.add = function(t6) {
    return this.copy(this.data.remove(t6).Ht(t6, true));
  }, t3.prototype.delete = function(t6) {
    return this.has(t6) ? this.copy(this.data.remove(t6)) : this;
  }, t3.prototype.nt = function() {
    return this.data.nt();
  }, t3.prototype.ye = function(t6) {
    var e28 = this;
    return e28.size < t6.size && (e28 = t6, t6 = this), t6.forEach(function(t10) {
      e28 = e28.add(t10);
    }), e28;
  }, t3.prototype.isEqual = function(e28) {
    if (!(e28 instanceof t3))
      return false;
    if (this.size !== e28.size)
      return false;
    for (var n3 = this.data.ee(), r3 = e28.data.ee(); n3.ae(); ) {
      var i = n3.ce().key, o3 = r3.ce().key;
      if (this.J(i, o3) !== 0)
        return false;
    }
    return true;
  }, t3.prototype.rt = function() {
    var t6 = [];
    return this.forEach(function(e28) {
      t6.push(e28);
    }), t6;
  }, t3.prototype.toString = function() {
    var t6 = [];
    return this.forEach(function(e28) {
      return t6.push(e28);
    }), "SortedSet(" + t6.toString() + ")";
  }, t3.prototype.copy = function(e28) {
    var n3 = new t3(this.J);
    return n3.data = e28, n3;
  }, t3;
}(), ln = function() {
  function t3(t6) {
    this.ge = t6;
  }
  return t3.prototype.ce = function() {
    return this.ge.ce().key;
  }, t3.prototype.ae = function() {
    return this.ge.ae();
  }, t3;
}(), pn = new an(it.J);
function dn() {
  return pn;
}
function vn() {
  return dn();
}
var yn = new an(it.J);
function mn() {
  return yn;
}
var gn = new an(it.J);
function wn() {
  return gn;
}
var bn = new hn(it.J);
function In() {
  for (var t3 = [], e28 = 0; e28 < arguments.length; e28++)
    t3[e28] = arguments[e28];
  for (var n3 = bn, r3 = 0, i = t3; r3 < i.length; r3++) {
    var o3 = i[r3];
    n3 = n3.add(o3);
  }
  return n3;
}
var _n = new hn(P$1);
function En() {
  return _n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Tn = function() {
  function t3(t6) {
    this.J = t6 ? function(e28, n3) {
      return t6(e28, n3) || it.J(e28.key, n3.key);
    } : function(t10, e28) {
      return it.J(t10.key, e28.key);
    }, this.Ve = mn(), this.pe = new an(this.J);
  }
  return t3.be = function(e28) {
    return new t3(e28.J);
  }, t3.prototype.has = function(t6) {
    return this.Ve.get(t6) != null;
  }, t3.prototype.get = function(t6) {
    return this.Ve.get(t6);
  }, t3.prototype.first = function() {
    return this.pe.Yt();
  }, t3.prototype.last = function() {
    return this.pe.Xt();
  }, t3.prototype.nt = function() {
    return this.pe.nt();
  }, t3.prototype.indexOf = function(t6) {
    var e28 = this.Ve.get(t6);
    return e28 ? this.pe.indexOf(e28) : -1;
  }, Object.defineProperty(t3.prototype, "size", {
    get: function() {
      return this.pe.size;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.forEach = function(t6) {
    this.pe.Zt(function(e28, n3) {
      return t6(e28), false;
    });
  }, t3.prototype.add = function(t6) {
    var e28 = this.delete(t6.key);
    return e28.copy(e28.Ve.Ht(t6.key, t6), e28.pe.Ht(t6, null));
  }, t3.prototype.delete = function(t6) {
    var e28 = this.get(t6);
    return e28 ? this.copy(this.Ve.remove(t6), this.pe.remove(e28)) : this;
  }, t3.prototype.isEqual = function(e28) {
    if (!(e28 instanceof t3))
      return false;
    if (this.size !== e28.size)
      return false;
    for (var n3 = this.pe.ee(), r3 = e28.pe.ee(); n3.ae(); ) {
      var i = n3.ce().key, o3 = r3.ce().key;
      if (!i.isEqual(o3))
        return false;
    }
    return true;
  }, t3.prototype.toString = function() {
    var t6 = [];
    return this.forEach(function(e28) {
      t6.push(e28.toString());
    }), t6.length === 0 ? "DocumentSet ()" : "DocumentSet (\n  " + t6.join("  \n") + "\n)";
  }, t3.prototype.copy = function(e28, n3) {
    var r3 = new t3();
    return r3.J = this.J, r3.Ve = e28, r3.pe = n3, r3;
  }, t3;
}(), Nn = function() {
  function t3() {
    this.ve = new an(it.J);
  }
  return t3.prototype.track = function(t6) {
    var e28 = t6.doc.key, n3 = this.ve.get(e28);
    n3 ? t6.type !== 0 && n3.type === 3 ? this.ve = this.ve.Ht(e28, t6) : t6.type === 3 && n3.type !== 1 ? this.ve = this.ve.Ht(e28, {
      type: n3.type,
      doc: t6.doc
    }) : t6.type === 2 && n3.type === 2 ? this.ve = this.ve.Ht(e28, {
      type: 2,
      doc: t6.doc
    }) : t6.type === 2 && n3.type === 0 ? this.ve = this.ve.Ht(e28, {
      type: 0,
      doc: t6.doc
    }) : t6.type === 1 && n3.type === 0 ? this.ve = this.ve.remove(e28) : t6.type === 1 && n3.type === 2 ? this.ve = this.ve.Ht(e28, {
      type: 1,
      doc: n3.doc
    }) : t6.type === 0 && n3.type === 1 ? this.ve = this.ve.Ht(e28, {
      type: 2,
      doc: t6.doc
    }) : S() : this.ve = this.ve.Ht(e28, t6);
  }, t3.prototype.Se = function() {
    var t6 = [];
    return this.ve.Zt(function(e28, n3) {
      t6.push(n3);
    }), t6;
  }, t3;
}(), An = function() {
  function t3(t6, e28, n3, r3, i, o3, u3, s3) {
    this.query = t6, this.docs = e28, this.De = n3, this.docChanges = r3, this.Ce = i, this.fromCache = o3, this.xe = u3, this.Ne = s3;
  }
  return t3.Fe = function(e28, n3, r3, i) {
    var o3 = [];
    return n3.forEach(function(t6) {
      o3.push({
        type: 0,
        doc: t6
      });
    }), new t3(e28, n3, Tn.be(n3), o3, r3, i, true, false);
  }, Object.defineProperty(t3.prototype, "hasPendingWrites", {
    get: function() {
      return !this.Ce.nt();
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.isEqual = function(t6) {
    if (!(this.fromCache === t6.fromCache && this.xe === t6.xe && this.Ce.isEqual(t6.Ce) && ye(this.query, t6.query) && this.docs.isEqual(t6.docs) && this.De.isEqual(t6.De)))
      return false;
    var e28 = this.docChanges, n3 = t6.docChanges;
    if (e28.length !== n3.length)
      return false;
    for (var r3 = 0; r3 < e28.length; r3++)
      if (e28[r3].type !== n3[r3].type || !e28[r3].doc.isEqual(n3[r3].doc))
        return false;
    return true;
  }, t3;
}(), Sn = function() {
  function t3(t6, e28, n3, r3, i) {
    this.Mt = t6, this.Oe = e28, this.ke = n3, this.Me = r3, this.Le = i;
  }
  return t3.$e = function(e28, n3) {
    var r3 = new Map();
    return r3.set(e28, xn.Be(e28, n3)), new t3(Z.min(), r3, En(), dn(), In());
  }, t3;
}(), xn = function() {
  function t3(t6, e28, n3, r3, i) {
    this.resumeToken = t6, this.qe = e28, this.Ue = n3, this.Qe = r3, this.Ke = i;
  }
  return t3.Be = function(e28, n3) {
    return new t3(R.h, n3, In(), In(), In());
  }, t3;
}(), Dn = function(t3, e28, n3, r3) {
  this.We = t3, this.removedTargetIds = e28, this.key = n3, this.je = r3;
}, kn = function(t3, e28) {
  this.targetId = t3, this.Ge = e28;
}, On = function(t3, e28, n3, r3) {
  n3 === void 0 && (n3 = R.h), r3 === void 0 && (r3 = null), this.state = t3, this.targetIds = e28, this.resumeToken = n3, this.cause = r3;
}, Pn = function() {
  function t3() {
    this.ze = 0, this.He = Rn(), this.Je = R.h, this.Ye = false, this.Xe = true;
  }
  return Object.defineProperty(t3.prototype, "qe", {
    get: function() {
      return this.Ye;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "resumeToken", {
    get: function() {
      return this.Je;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "Ze", {
    get: function() {
      return this.ze !== 0;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "tn", {
    get: function() {
      return this.Xe;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.en = function(t6) {
    t6.o() > 0 && (this.Xe = true, this.Je = t6);
  }, t3.prototype.nn = function() {
    var t6 = In(), e28 = In(), n3 = In();
    return this.He.forEach(function(r3, i) {
      switch (i) {
        case 0:
          t6 = t6.add(r3);
          break;
        case 2:
          e28 = e28.add(r3);
          break;
        case 1:
          n3 = n3.add(r3);
          break;
        default:
          S();
      }
    }), new xn(this.Je, this.Ye, t6, e28, n3);
  }, t3.prototype.sn = function() {
    this.Xe = false, this.He = Rn();
  }, t3.prototype.rn = function(t6, e28) {
    this.Xe = true, this.He = this.He.Ht(t6, e28);
  }, t3.prototype.on = function(t6) {
    this.Xe = true, this.He = this.He.remove(t6);
  }, t3.prototype.cn = function() {
    this.ze += 1;
  }, t3.prototype.an = function() {
    this.ze -= 1;
  }, t3.prototype.un = function() {
    this.Xe = true, this.Ye = true;
  }, t3;
}(), Cn = function() {
  function t3(t6) {
    this.hn = t6, this.ln = new Map(), this._n = dn(), this.fn = Ln(), this.dn = new hn(P$1);
  }
  return t3.prototype.wn = function(t6) {
    for (var e28 = 0, n3 = t6.We; e28 < n3.length; e28++) {
      var r3 = n3[e28];
      t6.je instanceof Vt ? this.En(r3, t6.je) : t6.je instanceof Mt && this.Tn(r3, t6.key, t6.je);
    }
    for (var i = 0, o3 = t6.removedTargetIds; i < o3.length; i++) {
      r3 = o3[i];
      this.Tn(r3, t6.key, t6.je);
    }
  }, t3.prototype.In = function(t6) {
    var e28 = this;
    this.mn(t6, function(n3) {
      var r3 = e28.An(n3);
      switch (t6.state) {
        case 0:
          e28.Rn(n3) && r3.en(t6.resumeToken);
          break;
        case 1:
          r3.an(), r3.Ze || r3.sn(), r3.en(t6.resumeToken);
          break;
        case 2:
          r3.an(), r3.Ze || e28.removeTarget(n3);
          break;
        case 3:
          e28.Rn(n3) && (r3.un(), r3.en(t6.resumeToken));
          break;
        case 4:
          e28.Rn(n3) && (e28.Pn(n3), r3.en(t6.resumeToken));
          break;
        default:
          S();
      }
    });
  }, t3.prototype.mn = function(t6, e28) {
    var n3 = this;
    t6.targetIds.length > 0 ? t6.targetIds.forEach(e28) : this.ln.forEach(function(t10, r3) {
      n3.Rn(r3) && e28(r3);
    });
  }, t3.prototype.yn = function(t6) {
    var e28 = t6.targetId, n3 = t6.Ge.count, r3 = this.gn(e28);
    if (r3) {
      var i = r3.target;
      if (Gt(i))
        if (n3 === 0) {
          var o3 = new it(i.path);
          this.Tn(e28, o3, new Mt(o3, Z.min()));
        } else
          x(n3 === 1);
      else
        this.Vn(e28) !== n3 && (this.Pn(e28), this.dn = this.dn.add(e28));
    }
  }, t3.prototype.pn = function(t6) {
    var e28 = this, n3 = new Map();
    this.ln.forEach(function(r6, i3) {
      var o3 = e28.gn(i3);
      if (o3) {
        if (r6.qe && Gt(o3.target)) {
          var u3 = new it(o3.target.path);
          e28._n.get(u3) !== null || e28.bn(i3, u3) || e28.Tn(i3, u3, new Mt(u3, t6));
        }
        r6.tn && (n3.set(i3, r6.nn()), r6.sn());
      }
    });
    var r3 = In();
    this.fn.forEach(function(t10, n6) {
      var i3 = true;
      n6.Re(function(t11) {
        var n10 = e28.gn(t11);
        return !n10 || n10.kt === 2 || (i3 = false, false);
      }), i3 && (r3 = r3.add(t10));
    });
    var i = new Sn(t6, n3, this.dn, this._n, r3);
    return this._n = dn(), this.fn = Ln(), this.dn = new hn(P$1), i;
  }, t3.prototype.En = function(t6, e28) {
    if (this.Rn(t6)) {
      var n3 = this.bn(t6, e28.key) ? 2 : 0;
      this.An(t6).rn(e28.key, n3), this._n = this._n.Ht(e28.key, e28), this.fn = this.fn.Ht(e28.key, this.vn(e28.key).add(t6));
    }
  }, t3.prototype.Tn = function(t6, e28, n3) {
    if (this.Rn(t6)) {
      var r3 = this.An(t6);
      this.bn(t6, e28) ? r3.rn(e28, 1) : r3.on(e28), this.fn = this.fn.Ht(e28, this.vn(e28).delete(t6)), n3 && (this._n = this._n.Ht(e28, n3));
    }
  }, t3.prototype.removeTarget = function(t6) {
    this.ln.delete(t6);
  }, t3.prototype.Vn = function(t6) {
    var e28 = this.An(t6).nn();
    return this.hn.Sn(t6).size + e28.Ue.size - e28.Ke.size;
  }, t3.prototype.cn = function(t6) {
    this.An(t6).cn();
  }, t3.prototype.An = function(t6) {
    var e28 = this.ln.get(t6);
    return e28 || (e28 = new Pn(), this.ln.set(t6, e28)), e28;
  }, t3.prototype.vn = function(t6) {
    var e28 = this.fn.get(t6);
    return e28 || (e28 = new hn(P$1), this.fn = this.fn.Ht(t6, e28)), e28;
  }, t3.prototype.Rn = function(t6) {
    var e28 = this.gn(t6) !== null;
    return e28 || E("WatchChangeAggregator", "Detected inactive target", t6), e28;
  }, t3.prototype.gn = function(t6) {
    var e28 = this.ln.get(t6);
    return e28 && e28.Ze ? null : this.hn.Dn(t6);
  }, t3.prototype.Pn = function(t6) {
    var e28 = this;
    this.ln.set(t6, new Pn()), this.hn.Sn(t6).forEach(function(n3) {
      e28.Tn(t6, n3, null);
    });
  }, t3.prototype.bn = function(t6, e28) {
    return this.hn.Sn(t6).has(e28);
  }, t3;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ln() {
  return new an(it.J);
}
function Rn() {
  return new an(it.J);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Vn = {
  asc: "ASCENDING",
  desc: "DESCENDING"
}, Mn = {
  "<": "LESS_THAN",
  "<=": "LESS_THAN_OR_EQUAL",
  ">": "GREATER_THAN",
  ">=": "GREATER_THAN_OR_EQUAL",
  "==": "EQUAL",
  "!=": "NOT_EQUAL",
  "array-contains": "ARRAY_CONTAINS",
  in: "IN",
  "not-in": "NOT_IN",
  "array-contains-any": "ARRAY_CONTAINS_ANY"
}, Un = function(t3, e28) {
  this.T = t3, this.qt = e28;
};
function qn(t3, e28) {
  return t3.qt ? new Date(1e3 * e28.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "") + "." + ("000000000" + e28.nanoseconds).slice(-9) + "Z" : {
    seconds: "" + e28.seconds,
    nanos: e28.nanoseconds
  };
}
function Fn(t3, e28) {
  return t3.qt ? e28.toBase64() : e28.toUint8Array();
}
function jn(t3, e28) {
  return qn(t3, e28.G());
}
function zn(t3) {
  return x(!!t3), Z.W(function(t6) {
    var e28 = ft(t6);
    return new X(e28.seconds, e28.nanos);
  }(t3));
}
function Gn(t3, e28) {
  return function(t6) {
    return new et(["projects", t6.projectId, "databases", t6.database]);
  }(t3).child("documents").child(e28).ot();
}
function Bn(t3) {
  var e28 = et.ct(t3);
  return x(dr(e28)), e28;
}
function Kn(t3, e28) {
  return Gn(t3.T, e28.path);
}
function Hn(t3, e28) {
  var n3 = Bn(e28);
  if (n3.get(1) !== t3.T.projectId)
    throw new M(V.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n3.get(1) + " vs " + t3.T.projectId);
  if (n3.get(3) !== t3.T.database)
    throw new M(V.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n3.get(3) + " vs " + t3.T.database);
  return new it(Yn(n3));
}
function Jn(t3, e28) {
  return Gn(t3.T, e28);
}
function Wn(t3) {
  var e28 = Bn(t3);
  return e28.length === 4 ? et.at() : Yn(e28);
}
function Qn(t3) {
  return new et(["projects", t3.T.projectId, "databases", t3.T.database]).ot();
}
function Yn(t3) {
  return x(t3.length > 4 && t3.get(4) === "documents"), t3.X(5);
}
function $n(t3, e28, n3) {
  return {
    name: Kn(t3, e28),
    fields: n3.proto.mapValue.fields
  };
}
function Xn(t3, e28, n3) {
  var r3 = Hn(t3, e28.name), i = zn(e28.updateTime), o3 = new Pt({
    mapValue: {
      fields: e28.fields
    }
  });
  return new Vt(r3, i, o3, {
    hasCommittedMutations: !!n3
  });
}
function Zn(t3, e28) {
  var n3;
  if (e28 instanceof We)
    n3 = {
      update: $n(t3, e28.key, e28.value)
    };
  else if (e28 instanceof nn)
    n3 = {
      delete: Kn(t3, e28.key)
    };
  else if (e28 instanceof Qe)
    n3 = {
      update: $n(t3, e28.key, e28.data),
      updateMask: pr(e28.zt)
    };
  else {
    if (!(e28 instanceof rn))
      return S();
    n3 = {
      verify: Kn(t3, e28.key)
    };
  }
  return e28.fieldTransforms.length > 0 && (n3.updateTransforms = e28.fieldTransforms.map(function(t6) {
    return function(t10, e29) {
      var n6 = e29.transform;
      if (n6 instanceof ke)
        return {
          fieldPath: e29.field.ot(),
          setToServerValue: "REQUEST_TIME"
        };
      if (n6 instanceof Oe)
        return {
          fieldPath: e29.field.ot(),
          appendMissingElements: {
            values: n6.elements
          }
        };
      if (n6 instanceof Ce)
        return {
          fieldPath: e29.field.ot(),
          removeAllFromArray: {
            values: n6.elements
          }
        };
      if (n6 instanceof Re)
        return {
          fieldPath: e29.field.ot(),
          increment: n6.Qt
        };
      throw S();
    }(0, t6);
  })), e28.Gt.jt || (n3.currentDocument = function(t6, e29) {
    return e29.updateTime !== void 0 ? {
      updateTime: jn(t6, e29.updateTime)
    } : e29.exists !== void 0 ? {
      exists: e29.exists
    } : S();
  }(t3, e28.Gt)), n3;
}
function tr(t3, e28) {
  var n3 = e28.currentDocument ? function(t6) {
    return t6.updateTime !== void 0 ? Fe.updateTime(zn(t6.updateTime)) : t6.exists !== void 0 ? Fe.exists(t6.exists) : Fe.Wt();
  }(e28.currentDocument) : Fe.Wt(), r3 = e28.updateTransforms ? e28.updateTransforms.map(function(e29) {
    return function(t6, e30) {
      var n6 = null;
      if ("setToServerValue" in e30)
        x(e30.setToServerValue === "REQUEST_TIME"), n6 = new ke();
      else if ("appendMissingElements" in e30) {
        var r6 = e30.appendMissingElements.values || [];
        n6 = new Oe(r6);
      } else if ("removeAllFromArray" in e30) {
        var i3 = e30.removeAllFromArray.values || [];
        n6 = new Ce(i3);
      } else
        "increment" in e30 ? n6 = new Re(t6, e30.increment) : S();
      var o6 = rt._t(e30.fieldPath);
      return new Ue(o6, n6);
    }(t3, e29);
  }) : [];
  if (e28.update) {
    e28.update.name;
    var i = Hn(t3, e28.update.name), o3 = new Pt({
      mapValue: {
        fields: e28.update.fields
      }
    });
    if (e28.updateMask) {
      var u3 = function(t6) {
        var e29 = t6.fieldPaths || [];
        return new at(e29.map(function(t10) {
          return rt._t(t10);
        }));
      }(e28.updateMask);
      return new Qe(i, o3, u3, n3, r3);
    }
    return new We(i, o3, n3, r3);
  }
  if (e28.delete) {
    var s3 = Hn(t3, e28.delete);
    return new nn(s3, n3);
  }
  if (e28.verify) {
    var a3 = Hn(t3, e28.verify);
    return new rn(a3, n3);
  }
  return S();
}
function er(t3, e28) {
  return {
    documents: [Jn(t3, e28.path)]
  };
}
function nr(t3, e28) {
  var n3 = {
    structuredQuery: {}
  }, r3 = e28.path;
  e28.collectionGroup !== null ? (n3.parent = Jn(t3, r3), n3.structuredQuery.from = [{
    collectionId: e28.collectionGroup,
    allDescendants: true
  }]) : (n3.parent = Jn(t3, r3.Z()), n3.structuredQuery.from = [{
    collectionId: r3.et()
  }]);
  var i = function(t6) {
    if (t6.length !== 0) {
      var e29 = t6.map(function(t10) {
        return function(t11) {
          if (t11.op === "==") {
            if (kt(t11.value))
              return {
                unaryFilter: {
                  field: cr(t11.field),
                  op: "IS_NAN"
                }
              };
            if (Dt(t11.value))
              return {
                unaryFilter: {
                  field: cr(t11.field),
                  op: "IS_NULL"
                }
              };
          } else if (t11.op === "!=") {
            if (kt(t11.value))
              return {
                unaryFilter: {
                  field: cr(t11.field),
                  op: "IS_NOT_NAN"
                }
              };
            if (Dt(t11.value))
              return {
                unaryFilter: {
                  field: cr(t11.field),
                  op: "IS_NOT_NULL"
                }
              };
          }
          return {
            fieldFilter: {
              field: cr(t11.field),
              op: ar(t11.op),
              value: t11.value
            }
          };
        }(t10);
      });
      return e29.length === 1 ? e29[0] : {
        compositeFilter: {
          op: "AND",
          filters: e29
        }
      };
    }
  }(e28.filters);
  i && (n3.structuredQuery.where = i);
  var o3 = function(t6) {
    if (t6.length !== 0)
      return t6.map(function(t10) {
        return function(t11) {
          return {
            field: cr(t11.field),
            direction: sr(t11.dir)
          };
        }(t10);
      });
  }(e28.orderBy);
  o3 && (n3.structuredQuery.orderBy = o3);
  var u3 = function(t6, e29) {
    return t6.qt || yt(e29) ? e29 : {
      value: e29
    };
  }(t3, e28.limit);
  return u3 !== null && (n3.structuredQuery.limit = u3), e28.startAt && (n3.structuredQuery.startAt = or(e28.startAt)), e28.endAt && (n3.structuredQuery.endAt = or(e28.endAt)), n3;
}
function rr(t3) {
  var e28 = Wn(t3.parent), n3 = t3.structuredQuery, r3 = n3.from ? n3.from.length : 0, i = null;
  if (r3 > 0) {
    x(r3 === 1);
    var o3 = n3.from[0];
    o3.allDescendants ? i = o3.collectionId : e28 = e28.child(o3.collectionId);
  }
  var u3 = [];
  n3.where && (u3 = ir(n3.where));
  var s3 = [];
  n3.orderBy && (s3 = n3.orderBy.map(function(t6) {
    return function(t10) {
      return new ee(fr(t10.field), function(t11) {
        switch (t11) {
          case "ASCENDING":
            return "asc";
          case "DESCENDING":
            return "desc";
          default:
            return;
        }
      }(t10.direction));
    }(t6);
  }));
  var a3 = null;
  n3.limit && (a3 = function(t6) {
    var e29;
    return yt(e29 = typeof t6 == "object" ? t6.value : t6) ? null : e29;
  }(n3.limit));
  var c3 = null;
  n3.startAt && (c3 = ur(n3.startAt));
  var f3 = null;
  return n3.endAt && (f3 = ur(n3.endAt)), ue(e28, i, s3, u3, a3, "F", c3, f3);
}
function ir(t3) {
  return t3 ? t3.unaryFilter !== void 0 ? [lr(t3)] : t3.fieldFilter !== void 0 ? [hr(t3)] : t3.compositeFilter !== void 0 ? t3.compositeFilter.filters.map(function(t6) {
    return ir(t6);
  }).reduce(function(t6, e28) {
    return t6.concat(e28);
  }) : S() : [];
}
function or(t3) {
  return {
    before: t3.before,
    values: t3.position
  };
}
function ur(t3) {
  var e28 = !!t3.before, n3 = t3.values || [];
  return new Zt(n3, e28);
}
function sr(t3) {
  return Vn[t3];
}
function ar(t3) {
  return Mn[t3];
}
function cr(t3) {
  return {
    fieldPath: t3.ot()
  };
}
function fr(t3) {
  return rt._t(t3.fieldPath);
}
function hr(t3) {
  return Bt.create(fr(t3.fieldFilter.field), function(t6) {
    switch (t6) {
      case "EQUAL":
        return "==";
      case "NOT_EQUAL":
        return "!=";
      case "GREATER_THAN":
        return ">";
      case "GREATER_THAN_OR_EQUAL":
        return ">=";
      case "LESS_THAN":
        return "<";
      case "LESS_THAN_OR_EQUAL":
        return "<=";
      case "ARRAY_CONTAINS":
        return "array-contains";
      case "IN":
        return "in";
      case "NOT_IN":
        return "not-in";
      case "ARRAY_CONTAINS_ANY":
        return "array-contains-any";
      case "OPERATOR_UNSPECIFIED":
      default:
        return S();
    }
  }(t3.fieldFilter.op), t3.fieldFilter.value);
}
function lr(t3) {
  switch (t3.unaryFilter.op) {
    case "IS_NAN":
      var e28 = fr(t3.unaryFilter.field);
      return Bt.create(e28, "==", {
        doubleValue: NaN
      });
    case "IS_NULL":
      var n3 = fr(t3.unaryFilter.field);
      return Bt.create(n3, "==", {
        nullValue: "NULL_VALUE"
      });
    case "IS_NOT_NAN":
      var r3 = fr(t3.unaryFilter.field);
      return Bt.create(r3, "!=", {
        doubleValue: NaN
      });
    case "IS_NOT_NULL":
      var i = fr(t3.unaryFilter.field);
      return Bt.create(i, "!=", {
        nullValue: "NULL_VALUE"
      });
    case "OPERATOR_UNSPECIFIED":
    default:
      return S();
  }
}
function pr(t3) {
  var e28 = [];
  return t3.fields.forEach(function(t6) {
    return e28.push(t6.ot());
  }), {
    fieldPaths: e28
  };
}
function dr(t3) {
  return t3.length >= 4 && t3.get(0) === "projects" && t3.get(2) === "databases";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var vr = function() {
  var t3 = this;
  this.promise = new Promise(function(e28, n3) {
    t3.resolve = e28, t3.reject = n3;
  });
}, yr = function() {
  function t3(t6) {
    var e28 = this;
    this.Cn = null, this.xn = null, this.result = void 0, this.error = void 0, this.Nn = false, this.Fn = false, t6(function(t10) {
      e28.Nn = true, e28.result = t10, e28.Cn && e28.Cn(t10);
    }, function(t10) {
      e28.Nn = true, e28.error = t10, e28.xn && e28.xn(t10);
    });
  }
  return t3.prototype.catch = function(t6) {
    return this.next(void 0, t6);
  }, t3.prototype.next = function(e28, n3) {
    var r3 = this;
    return this.Fn && S(), this.Fn = true, this.Nn ? this.error ? this.On(n3, this.error) : this.kn(e28, this.result) : new t3(function(t6, i) {
      r3.Cn = function(n6) {
        r3.kn(e28, n6).next(t6, i);
      }, r3.xn = function(e29) {
        r3.On(n3, e29).next(t6, i);
      };
    });
  }, t3.prototype.Mn = function() {
    var t6 = this;
    return new Promise(function(e28, n3) {
      t6.next(e28, n3);
    });
  }, t3.prototype.Ln = function(e28) {
    try {
      var n3 = e28();
      return n3 instanceof t3 ? n3 : t3.resolve(n3);
    } catch (e29) {
      return t3.reject(e29);
    }
  }, t3.prototype.kn = function(e28, n3) {
    return e28 ? this.Ln(function() {
      return e28(n3);
    }) : t3.resolve(n3);
  }, t3.prototype.On = function(e28, n3) {
    return e28 ? this.Ln(function() {
      return e28(n3);
    }) : t3.reject(n3);
  }, t3.resolve = function(e28) {
    return new t3(function(t6, n3) {
      t6(e28);
    });
  }, t3.reject = function(e28) {
    return new t3(function(t6, n3) {
      n3(e28);
    });
  }, t3.$n = function(e28) {
    return new t3(function(t6, n3) {
      var r3 = 0, i = 0, o3 = false;
      e28.forEach(function(e29) {
        ++r3, e29.next(function() {
          ++i, o3 && i === r3 && t6();
        }, function(t10) {
          return n3(t10);
        });
      }), o3 = true, i === r3 && t6();
    });
  }, t3.Bn = function(e28) {
    for (var n3 = t3.resolve(false), r3 = function(e29) {
      n3 = n3.next(function(n6) {
        return n6 ? t3.resolve(n6) : e29();
      });
    }, i = 0, o3 = e28; i < o3.length; i++) {
      r3(o3[i]);
    }
    return n3;
  }, t3.forEach = function(t6, e28) {
    var n3 = this, r3 = [];
    return t6.forEach(function(t10, i) {
      r3.push(e28.call(n3, t10, i));
    }), this.$n(r3);
  }, t3;
}(), mr = function() {
  function t3(t6, e28) {
    var n3 = this;
    this.action = t6, this.transaction = e28, this.aborted = false, this.qn = new vr(), this.transaction.oncomplete = function() {
      n3.qn.resolve();
    }, this.transaction.onabort = function() {
      e28.error ? n3.qn.reject(new br(t6, e28.error)) : n3.qn.resolve();
    }, this.transaction.onerror = function(e29) {
      var r3 = Nr(e29.target.error);
      n3.qn.reject(new br(t6, r3));
    };
  }
  return t3.open = function(e28, n3, r3, i) {
    try {
      return new t3(n3, e28.transaction(i, r3));
    } catch (e29) {
      throw new br(n3, e29);
    }
  }, Object.defineProperty(t3.prototype, "Un", {
    get: function() {
      return this.qn.promise;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.abort = function(t6) {
    t6 && this.qn.reject(t6), this.aborted || (E("SimpleDb", "Aborting transaction:", t6 ? t6.message : "Client-initiated abort"), this.aborted = true, this.transaction.abort());
  }, t3.prototype.store = function(t6) {
    var e28 = this.transaction.objectStore(t6);
    return new _r(e28);
  }, t3;
}(), gr = function() {
  function t3(e28, r3, i) {
    this.name = e28, this.version = r3, this.Qn = i, t3.Kn(getUA()) === 12.2 && T("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
  }
  return t3.delete = function(t6) {
    return E("SimpleDb", "Removing database:", t6), Er(window.indexedDB.deleteDatabase(t6)).Mn();
  }, t3.Wn = function() {
    if (typeof indexedDB == "undefined")
      return false;
    if (t3.jn())
      return true;
    var e28 = getUA(), r3 = t3.Kn(e28), i = 0 < r3 && r3 < 10, o3 = t3.Gn(e28), u3 = 0 < o3 && o3 < 4.5;
    return !(e28.indexOf("MSIE ") > 0 || e28.indexOf("Trident/") > 0 || e28.indexOf("Edge/") > 0 || i || u3);
  }, t3.jn = function() {
    var t6;
    return typeof process != "undefined" && ((t6 = process.env) === null || t6 === void 0 ? void 0 : t6.zn) === "YES";
  }, t3.Hn = function(t6, e28) {
    return t6.store(e28);
  }, t3.Kn = function(t6) {
    var e28 = t6.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n3 = e28 ? e28[1].split("_").slice(0, 2).join(".") : "-1";
    return Number(n3);
  }, t3.Gn = function(t6) {
    var e28 = t6.match(/Android ([\d.]+)/i), n3 = e28 ? e28[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n3);
  }, t3.prototype.Jn = function(t6) {
    return __awaiter(this, void 0, void 0, function() {
      var e28, n3 = this;
      return __generator(this, function(r3) {
        switch (r3.label) {
          case 0:
            return this.db ? [3, 2] : (E("SimpleDb", "Opening database:", this.name), e28 = this, [4, new Promise(function(e29, r6) {
              var i = indexedDB.open(n3.name, n3.version);
              i.onsuccess = function(t10) {
                var n6 = t10.target.result;
                e29(n6);
              }, i.onblocked = function() {
                r6(new br(t6, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
              }, i.onerror = function(e30) {
                var n6 = e30.target.error;
                n6.name === "VersionError" ? r6(new M(V.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : r6(new br(t6, n6));
              }, i.onupgradeneeded = function(t10) {
                E("SimpleDb", 'Database "' + n3.name + '" requires upgrade from version:', t10.oldVersion);
                var e30 = t10.target.result;
                n3.Qn.Yn(e30, i.transaction, t10.oldVersion, n3.version).next(function() {
                  E("SimpleDb", "Database upgrade to version " + n3.version + " complete");
                });
              };
            })]);
          case 1:
            e28.db = r3.sent(), r3.label = 2;
          case 2:
            return [2, (this.Xn && (this.db.onversionchange = function(t10) {
              return n3.Xn(t10);
            }), this.db)];
        }
      });
    });
  }, t3.prototype.Zn = function(t6) {
    this.Xn = t6, this.db && (this.db.onversionchange = function(e28) {
      return t6(e28);
    });
  }, t3.prototype.runTransaction = function(t6, e28, n3, r3) {
    return __awaiter(this, void 0, void 0, function() {
      var i, o3, u3, s3, a3;
      return __generator(this, function(c3) {
        switch (c3.label) {
          case 0:
            i = e28 === "readonly", o3 = 0, u3 = function() {
              var e29, u6, a6, c6, f3;
              return __generator(this, function(h3) {
                switch (h3.label) {
                  case 0:
                    ++o3, h3.label = 1;
                  case 1:
                    return h3.trys.push([1, 4, , 5]), [4, s3.Jn(t6)];
                  case 2:
                    return s3.db = h3.sent(), e29 = mr.open(s3.db, t6, i ? "readonly" : "readwrite", n3), u6 = r3(e29).catch(function(t10) {
                      return e29.abort(t10), yr.reject(t10);
                    }).Mn(), a6 = {}, u6.catch(function() {
                    }), [4, e29.Un];
                  case 3:
                    return [2, (a6.value = (h3.sent(), u6), a6)];
                  case 4:
                    return c6 = h3.sent(), f3 = c6.name !== "FirebaseError" && o3 < 3, E("SimpleDb", "Transaction failed with error:", c6.message, "Retrying:", f3), s3.close(), f3 ? [3, 5] : [2, {
                      value: Promise.reject(c6)
                    }];
                  case 5:
                    return [2];
                }
              });
            }, s3 = this, c3.label = 1;
          case 1:
            return [5, u3()];
          case 2:
            if (typeof (a3 = c3.sent()) == "object")
              return [2, a3.value];
            c3.label = 3;
          case 3:
            return [3, 1];
          case 4:
            return [2];
        }
      });
    });
  }, t3.prototype.close = function() {
    this.db && this.db.close(), this.db = void 0;
  }, t3;
}(), wr = function() {
  function t3(t6) {
    this.ts = t6, this.es = false, this.ns = null;
  }
  return Object.defineProperty(t3.prototype, "Nn", {
    get: function() {
      return this.es;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "ss", {
    get: function() {
      return this.ns;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "cursor", {
    set: function(t6) {
      this.ts = t6;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.done = function() {
    this.es = true;
  }, t3.prototype.rs = function(t6) {
    this.ns = t6;
  }, t3.prototype.delete = function() {
    return Er(this.ts.delete());
  }, t3;
}(), br = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, V.UNAVAILABLE, "IndexedDB transaction '" + e29 + "' failed: " + n3) || this).name = "IndexedDbTransactionError", r3;
  }
  return __extends$1(e28, t3), e28;
}(M);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ir(t3) {
  return t3.name === "IndexedDbTransactionError";
}
var _r = function() {
  function t3(t6) {
    this.store = t6;
  }
  return t3.prototype.put = function(t6, e28) {
    var n3;
    return e28 !== void 0 ? (E("SimpleDb", "PUT", this.store.name, t6, e28), n3 = this.store.put(e28, t6)) : (E("SimpleDb", "PUT", this.store.name, "<auto-key>", t6), n3 = this.store.put(t6)), Er(n3);
  }, t3.prototype.add = function(t6) {
    return E("SimpleDb", "ADD", this.store.name, t6, t6), Er(this.store.add(t6));
  }, t3.prototype.get = function(t6) {
    var e28 = this;
    return Er(this.store.get(t6)).next(function(n3) {
      return n3 === void 0 && (n3 = null), E("SimpleDb", "GET", e28.store.name, t6, n3), n3;
    });
  }, t3.prototype.delete = function(t6) {
    return E("SimpleDb", "DELETE", this.store.name, t6), Er(this.store.delete(t6));
  }, t3.prototype.count = function() {
    return E("SimpleDb", "COUNT", this.store.name), Er(this.store.count());
  }, t3.prototype.os = function(t6, e28) {
    var n3 = this.cursor(this.options(t6, e28)), r3 = [];
    return this.cs(n3, function(t10, e29) {
      r3.push(e29);
    }).next(function() {
      return r3;
    });
  }, t3.prototype.us = function(t6, e28) {
    E("SimpleDb", "DELETE ALL", this.store.name);
    var n3 = this.options(t6, e28);
    n3.hs = false;
    var r3 = this.cursor(n3);
    return this.cs(r3, function(t10, e29, n6) {
      return n6.delete();
    });
  }, t3.prototype.ls = function(t6, e28) {
    var n3;
    e28 ? n3 = t6 : (n3 = {}, e28 = t6);
    var r3 = this.cursor(n3);
    return this.cs(r3, e28);
  }, t3.prototype._s = function(t6) {
    var e28 = this.cursor({});
    return new yr(function(n3, r3) {
      e28.onerror = function(t10) {
        var e29 = Nr(t10.target.error);
        r3(e29);
      }, e28.onsuccess = function(e29) {
        var r6 = e29.target.result;
        r6 ? t6(r6.primaryKey, r6.value).next(function(t10) {
          t10 ? r6.continue() : n3();
        }) : n3();
      };
    });
  }, t3.prototype.cs = function(t6, e28) {
    var n3 = [];
    return new yr(function(r3, i) {
      t6.onerror = function(t10) {
        i(t10.target.error);
      }, t6.onsuccess = function(t10) {
        var i3 = t10.target.result;
        if (i3) {
          var o3 = new wr(i3), u3 = e28(i3.primaryKey, i3.value, o3);
          if (u3 instanceof yr) {
            var s3 = u3.catch(function(t11) {
              return o3.done(), yr.reject(t11);
            });
            n3.push(s3);
          }
          o3.Nn ? r3() : o3.ss === null ? i3.continue() : i3.continue(o3.ss);
        } else
          r3();
      };
    }).next(function() {
      return yr.$n(n3);
    });
  }, t3.prototype.options = function(t6, e28) {
    var n3 = void 0;
    return t6 !== void 0 && (typeof t6 == "string" ? n3 = t6 : e28 = t6), {
      index: n3,
      range: e28
    };
  }, t3.prototype.cursor = function(t6) {
    var e28 = "next";
    if (t6.reverse && (e28 = "prev"), t6.index) {
      var n3 = this.store.index(t6.index);
      return t6.hs ? n3.openKeyCursor(t6.range, e28) : n3.openCursor(t6.range, e28);
    }
    return this.store.openCursor(t6.range, e28);
  }, t3;
}();
function Er(t3) {
  return new yr(function(e28, n3) {
    t3.onsuccess = function(t6) {
      var n6 = t6.target.result;
      e28(n6);
    }, t3.onerror = function(t6) {
      var e29 = Nr(t6.target.error);
      n3(e29);
    };
  });
}
var Tr = false;
function Nr(t3) {
  var e28 = gr.Kn(getUA());
  if (e28 >= 12.2 && e28 < 13) {
    var r3 = "An internal error was encountered in the Indexed Database server";
    if (t3.message.indexOf(r3) >= 0) {
      var i = new M("internal", "IOS_INDEXEDDB_BUG1: IndexedDb has thrown '" + r3 + "'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
      return Tr || (Tr = true, setTimeout(function() {
        throw i;
      }, 0)), i;
    }
  }
  return t3;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Ar = function() {
  function t3(t6, e28, n3, r3, i) {
    this.fs = t6, this.ds = e28, this.ws = n3, this.op = r3, this.Es = i, this.Ts = new vr(), this.then = this.Ts.promise.then.bind(this.Ts.promise), this.Ts.promise.catch(function(t10) {
    });
  }
  return t3.Is = function(e28, n3, r3, i, o3) {
    var u3 = new t3(e28, n3, Date.now() + r3, i, o3);
    return u3.start(r3), u3;
  }, t3.prototype.start = function(t6) {
    var e28 = this;
    this.As = setTimeout(function() {
      return e28.Rs();
    }, t6);
  }, t3.prototype.Ps = function() {
    return this.Rs();
  }, t3.prototype.cancel = function(t6) {
    this.As !== null && (this.clearTimeout(), this.Ts.reject(new M(V.CANCELLED, "Operation cancelled" + (t6 ? ": " + t6 : ""))));
  }, t3.prototype.Rs = function() {
    var t6 = this;
    this.fs.ys(function() {
      return t6.As !== null ? (t6.clearTimeout(), t6.op().then(function(e28) {
        return t6.Ts.resolve(e28);
      })) : Promise.resolve();
    });
  }, t3.prototype.clearTimeout = function() {
    this.As !== null && (this.Es(this), clearTimeout(this.As), this.As = null);
  }, t3;
}();
function Sr(t3, e28) {
  if (T("AsyncQueue", e28 + ": " + t3), Ir(t3))
    return new M(V.UNAVAILABLE, e28 + ": " + t3);
  throw t3;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var xr = function(t3, e28) {
  this.progress = t3, this.gs = e28;
}, Dr = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.", kr = function() {
  function t3() {
    this.Vs = [];
  }
  return t3.prototype.ps = function(t6) {
    this.Vs.push(t6);
  }, t3.prototype.bs = function() {
    this.Vs.forEach(function(t6) {
      return t6();
    });
  }, t3;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Or(t3) {
  for (var e28 = "", n3 = 0; n3 < t3.length; n3++)
    e28.length > 0 && (e28 = Cr(e28)), e28 = Pr(t3.get(n3), e28);
  return Cr(e28);
}
function Pr(t3, e28) {
  for (var n3 = e28, r3 = t3.length, i = 0; i < r3; i++) {
    var o3 = t3.charAt(i);
    switch (o3) {
      case "\0":
        n3 += "";
        break;
      case "":
        n3 += "";
        break;
      default:
        n3 += o3;
    }
  }
  return n3;
}
function Cr(t3) {
  return t3 + "";
}
function Lr(t3) {
  var e28 = t3.length;
  if (x(e28 >= 2), e28 === 2)
    return x(t3.charAt(0) === "" && t3.charAt(1) === ""), et.at();
  for (var n3 = e28 - 2, r3 = [], i = "", o3 = 0; o3 < e28; ) {
    var u3 = t3.indexOf("", o3);
    switch ((u3 < 0 || u3 > n3) && S(), t3.charAt(u3 + 1)) {
      case "":
        var s3 = t3.substring(o3, u3), a3 = void 0;
        i.length === 0 ? a3 = s3 : (a3 = i += s3, i = ""), r3.push(a3);
        break;
      case "":
        i += t3.substring(o3, u3), i += "\0";
        break;
      case "":
        i += t3.substring(o3, u3 + 1);
        break;
      default:
        S();
    }
    o3 = u3 + 2;
  }
  return new et(r3);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Rr = function(t3, e28) {
  this.seconds = t3, this.nanoseconds = e28;
}, Vr = function(t3, e28, n3) {
  this.ownerId = t3, this.allowTabSynchronization = e28, this.leaseTimestampMs = n3;
};
Vr.store = "owner", Vr.key = "owner";
var Mr = function(t3, e28, n3) {
  this.userId = t3, this.lastAcknowledgedBatchId = e28, this.lastStreamToken = n3;
};
Mr.store = "mutationQueues", Mr.keyPath = "userId";
var Ur = function(t3, e28, n3, r3, i) {
  this.userId = t3, this.batchId = e28, this.localWriteTimeMs = n3, this.baseMutations = r3, this.mutations = i;
};
Ur.store = "mutations", Ur.keyPath = "batchId", Ur.userMutationsIndex = "userMutationsIndex", Ur.userMutationsKeyPath = ["userId", "batchId"];
var qr = function() {
  function t3() {
  }
  return t3.prefixForUser = function(t6) {
    return [t6];
  }, t3.prefixForPath = function(t6, e28) {
    return [t6, Or(e28)];
  }, t3.key = function(t6, e28, n3) {
    return [t6, Or(e28), n3];
  }, t3;
}();
qr.store = "documentMutations", qr.PLACEHOLDER = new qr();
var Fr = function(t3, e28) {
  this.path = t3, this.readTime = e28;
}, jr = function(t3, e28) {
  this.path = t3, this.version = e28;
}, zr = function(t3, e28, n3, r3, i, o3) {
  this.unknownDocument = t3, this.noDocument = e28, this.document = n3, this.hasCommittedMutations = r3, this.readTime = i, this.parentPath = o3;
};
zr.store = "remoteDocuments", zr.readTimeIndex = "readTimeIndex", zr.readTimeIndexPath = "readTime", zr.collectionReadTimeIndex = "collectionReadTimeIndex", zr.collectionReadTimeIndexPath = ["parentPath", "readTime"];
var Gr = function(t3) {
  this.byteSize = t3;
};
Gr.store = "remoteDocumentGlobal", Gr.key = "remoteDocumentGlobalKey";
var Br = function(t3, e28, n3, r3, i, o3, u3) {
  this.targetId = t3, this.canonicalId = e28, this.readTime = n3, this.resumeToken = r3, this.lastListenSequenceNumber = i, this.lastLimboFreeSnapshotVersion = o3, this.query = u3;
};
Br.store = "targets", Br.keyPath = "targetId", Br.queryTargetsIndexName = "queryTargetsIndex", Br.queryTargetsKeyPath = ["canonicalId", "targetId"];
var Kr = function(t3, e28, n3) {
  this.targetId = t3, this.path = e28, this.sequenceNumber = n3;
};
Kr.store = "targetDocuments", Kr.keyPath = ["targetId", "path"], Kr.documentTargetsIndex = "documentTargetsIndex", Kr.documentTargetsKeyPath = ["path", "targetId"];
var Hr = function(t3, e28, n3, r3) {
  this.highestTargetId = t3, this.highestListenSequenceNumber = e28, this.lastRemoteSnapshotVersion = n3, this.targetCount = r3;
};
Hr.key = "targetGlobalKey", Hr.store = "targetGlobal";
var Jr = function(t3, e28) {
  this.collectionId = t3, this.parent = e28;
};
Jr.store = "collectionParents", Jr.keyPath = ["collectionId", "parent"];
var Wr = function(t3, e28, n3, r3) {
  this.clientId = t3, this.updateTimeMs = e28, this.networkEnabled = n3, this.inForeground = r3;
};
Wr.store = "clientMetadata", Wr.keyPath = "clientId";
var Qr = function(t3, e28, n3) {
  this.bundleId = t3, this.createTime = e28, this.version = n3;
};
Qr.store = "bundles", Qr.keyPath = "bundleId";
var Yr = function(t3, e28, n3) {
  this.name = t3, this.readTime = e28, this.bundledQuery = n3;
};
Yr.store = "namedQueries", Yr.keyPath = "name";
var $r = __spreadArrays$1(__spreadArrays$1(__spreadArrays$1(__spreadArrays$1([Mr.store, Ur.store, qr.store, zr.store, Br.store, Vr.store, Hr.store, Kr.store], [Wr.store]), [Gr.store]), [Jr.store]), [Qr.store, Yr.store]), Xr = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this) || this).vs = e29, r3.Ss = n3, r3;
  }
  return __extends$1(e28, t3), e28;
}(kr);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Zr(t3, e28) {
  var n3 = D(t3);
  return gr.Hn(n3.vs, e28);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ti = function() {
  function t3(t6, e28, n3, r3) {
    this.batchId = t6, this.Ds = e28, this.baseMutations = n3, this.mutations = r3;
  }
  return t3.prototype.Cs = function(t6, e28, n3) {
    for (var r3 = n3.xs, i = 0; i < this.mutations.length; i++) {
      var o3 = this.mutations[i];
      o3.key.isEqual(t6) && (e28 = Ge(o3, e28, r3[i]));
    }
    return e28;
  }, t3.prototype.Ns = function(t6, e28) {
    for (var n3 = 0, r3 = this.baseMutations; n3 < r3.length; n3++) {
      var i = r3[n3];
      i.key.isEqual(t6) && (e28 = Be(i, e28, e28, this.Ds));
    }
    for (var o3 = e28, u3 = 0, s3 = this.mutations; u3 < s3.length; u3++) {
      var a3 = s3[u3];
      a3.key.isEqual(t6) && (e28 = Be(a3, e28, o3, this.Ds));
    }
    return e28;
  }, t3.prototype.Fs = function(t6) {
    var e28 = this, n3 = t6;
    return this.mutations.forEach(function(r3) {
      var i = e28.Ns(r3.key, t6.get(r3.key));
      i && (n3 = n3.Ht(r3.key, i));
    }), n3;
  }, t3.prototype.keys = function() {
    return this.mutations.reduce(function(t6, e28) {
      return t6.add(e28.key);
    }, In());
  }, t3.prototype.isEqual = function(t6) {
    return this.batchId === t6.batchId && C(this.mutations, t6.mutations, function(t10, e28) {
      return He(t10, e28);
    }) && C(this.baseMutations, t6.baseMutations, function(t10, e28) {
      return He(t10, e28);
    });
  }, t3;
}(), ei = function() {
  function t3(t6, e28, n3, r3) {
    this.batch = t6, this.Os = e28, this.xs = n3, this.ks = r3;
  }
  return t3.from = function(e28, n3, r3) {
    x(e28.mutations.length === r3.length);
    for (var i = wn(), o3 = e28.mutations, u3 = 0; u3 < o3.length; u3++)
      i = i.Ht(o3[u3].key, r3[u3].version);
    return new t3(e28, n3, r3, i);
  }, t3;
}(), ni = function(t3) {
  this.Ms = t3;
};
function ri(t3, e28) {
  if (e28.document)
    return Xn(t3.Ms, e28.document, !!e28.hasCommittedMutations);
  if (e28.noDocument) {
    var n3 = it.Tt(e28.noDocument.path), r3 = ai(e28.noDocument.readTime);
    return new Mt(n3, r3, {
      hasCommittedMutations: !!e28.hasCommittedMutations
    });
  }
  if (e28.unknownDocument) {
    var i = it.Tt(e28.unknownDocument.path);
    r3 = ai(e28.unknownDocument.version);
    return new Ut(i, r3);
  }
  return S();
}
function ii(t3, e28, n3) {
  var r3 = oi(n3), i = e28.key.path.Z().rt();
  if (e28 instanceof Vt) {
    var o3 = function(t6, e29) {
      return {
        name: Kn(t6, e29.key),
        fields: e29.vt().mapValue.fields,
        updateTime: qn(t6, e29.version.G())
      };
    }(t3.Ms, e28), u3 = e28.hasCommittedMutations;
    return new zr(null, null, o3, u3, r3, i);
  }
  if (e28 instanceof Mt) {
    var s3 = e28.key.path.rt(), a3 = si(e28.version);
    u3 = e28.hasCommittedMutations;
    return new zr(null, new Fr(s3, a3), null, u3, r3, i);
  }
  if (e28 instanceof Ut) {
    var c3 = e28.key.path.rt(), f3 = si(e28.version);
    return new zr(new jr(c3, f3), null, null, true, r3, i);
  }
  return S();
}
function oi(t3) {
  var e28 = t3.G();
  return [e28.seconds, e28.nanoseconds];
}
function ui(t3) {
  var e28 = new X(t3[0], t3[1]);
  return Z.W(e28);
}
function si(t3) {
  var e28 = t3.G();
  return new Rr(e28.seconds, e28.nanoseconds);
}
function ai(t3) {
  var e28 = new X(t3.seconds, t3.nanoseconds);
  return Z.W(e28);
}
function ci(t3, e28) {
  for (var n3 = (e28.baseMutations || []).map(function(e29) {
    return tr(t3.Ms, e29);
  }), r3 = e28.mutations.length - 1; r3 >= 0; --r3) {
    var i = e28.mutations[r3];
    (i == null ? void 0 : i.transform) !== void 0 && (e28.mutations[r3 - 1].updateTransforms = i.transform.fieldTransforms, e28.mutations.splice(r3, 1), --r3);
  }
  var o3 = e28.mutations.map(function(e29) {
    return tr(t3.Ms, e29);
  }), u3 = X.fromMillis(e28.localWriteTimeMs);
  return new ti(e28.batchId, u3, n3, o3);
}
function fi(t3) {
  var e28, n3, r3 = ai(t3.readTime), i = t3.lastLimboFreeSnapshotVersion !== void 0 ? ai(t3.lastLimboFreeSnapshotVersion) : Z.min();
  return t3.query.documents !== void 0 ? (x((n3 = t3.query).documents.length === 1), e28 = de(se(Wn(n3.documents[0])))) : e28 = function(t6) {
    return de(rr(t6));
  }(t3.query), new _e(e28, t3.targetId, 0, t3.lastListenSequenceNumber, r3, i, R.fromBase64String(t3.resumeToken));
}
function hi(t3, e28) {
  var n3, r3 = si(e28.Mt), i = si(e28.lastLimboFreeSnapshotVersion);
  n3 = Gt(e28.target) ? er(t3.Ms, e28.target) : nr(t3.Ms, e28.target);
  var o3 = e28.resumeToken.toBase64();
  return new Br(e28.targetId, jt(e28.target), r3, o3, e28.sequenceNumber, i, n3);
}
function li(t3) {
  var e28 = rr({
    parent: t3.parent,
    structuredQuery: t3.structuredQuery
  });
  return t3.limitType === "LAST" ? ve(e28, e28.limit, "L") : e28;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var pi = function() {
  function t3() {
  }
  return t3.prototype.Ls = function(t6, e28) {
    return di(t6).get(e28).next(function(t10) {
      if (t10)
        return {
          id: (e29 = t10).bundleId,
          createTime: ai(e29.createTime),
          version: e29.version
        };
      var e29;
    });
  }, t3.prototype.$s = function(t6, e28) {
    return di(t6).put({
      bundleId: (n3 = e28).id,
      createTime: si(zn(n3.createTime)),
      version: n3.version
    });
    var n3;
  }, t3.prototype.Bs = function(t6, e28) {
    return vi(t6).get(e28).next(function(t10) {
      if (t10)
        return {
          name: (e29 = t10).name,
          query: li(e29.bundledQuery),
          readTime: ai(e29.readTime)
        };
      var e29;
    });
  }, t3.prototype.qs = function(t6, e28) {
    return vi(t6).put(function(t10) {
      return {
        name: t10.name,
        readTime: si(zn(t10.readTime)),
        bundledQuery: t10.bundledQuery
      };
    }(e28));
  }, t3;
}();
function di(t3) {
  return Zr(t3, Qr.store);
}
function vi(t3) {
  return Zr(t3, Yr.store);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var yi = function() {
  function t3() {
    this.Us = new mi();
  }
  return t3.prototype.Qs = function(t6, e28) {
    return this.Us.add(e28), yr.resolve();
  }, t3.prototype.Ks = function(t6, e28) {
    return yr.resolve(this.Us.getEntries(e28));
  }, t3;
}(), mi = function() {
  function t3() {
    this.index = {};
  }
  return t3.prototype.add = function(t6) {
    var e28 = t6.et(), n3 = t6.Z(), r3 = this.index[e28] || new hn(et.J), i = !r3.has(n3);
    return this.index[e28] = r3.add(n3), i;
  }, t3.prototype.has = function(t6) {
    var e28 = t6.et(), n3 = t6.Z(), r3 = this.index[e28];
    return r3 && r3.has(n3);
  }, t3.prototype.getEntries = function(t6) {
    return (this.index[t6] || new hn(et.J)).rt();
  }, t3;
}(), gi = function() {
  function t3() {
    this.Ws = new mi();
  }
  return t3.prototype.Qs = function(t6, e28) {
    var n3 = this;
    if (!this.Ws.has(e28)) {
      var r3 = e28.et(), i = e28.Z();
      t6.ps(function() {
        n3.Ws.add(e28);
      });
      var o3 = {
        collectionId: r3,
        parent: Or(i)
      };
      return wi(t6).put(o3);
    }
    return yr.resolve();
  }, t3.prototype.Ks = function(t6, e28) {
    var n3 = [], r3 = IDBKeyRange.bound([e28, ""], [L(e28), ""], false, true);
    return wi(t6).os(r3).next(function(t10) {
      for (var r6 = 0, i = t10; r6 < i.length; r6++) {
        var o3 = i[r6];
        if (o3.collectionId !== e28)
          break;
        n3.push(Lr(o3.parent));
      }
      return n3;
    });
  }, t3;
}();
function wi(t3) {
  return Zr(t3, Jr.store);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var bi = {
  js: false,
  Gs: 0,
  zs: 0,
  Hs: 0
}, Ii = function() {
  function t3(t6, e28, n3) {
    this.Js = t6, this.Ys = e28, this.Xs = n3;
  }
  return t3.Zs = function(e28) {
    return new t3(e28, t3.ti, t3.ei);
  }, t3;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _i(t3) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(e28) {
      if (t3.code !== V.FAILED_PRECONDITION || t3.message !== Dr)
        throw t3;
      return E("LocalStore", "Unexpectedly lost primary lease"), [2];
    });
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Ii.ti = 10, Ii.ei = 1e3, Ii.ni = new Ii(41943040, Ii.ti, Ii.ei), Ii.si = new Ii(-1, 0, 0);
var Ei = function() {
  function t3(t6, e28) {
    this.ii = t6, this.ri = e28, this.oi = {};
  }
  return t3.prototype.get = function(t6) {
    var e28 = this.ii(t6), n3 = this.oi[e28];
    if (n3 !== void 0)
      for (var r3 = 0, i = n3; r3 < i.length; r3++) {
        var o3 = i[r3], u3 = o3[0], s3 = o3[1];
        if (this.ri(u3, t6))
          return s3;
      }
  }, t3.prototype.has = function(t6) {
    return this.get(t6) !== void 0;
  }, t3.prototype.set = function(t6, e28) {
    var n3 = this.ii(t6), r3 = this.oi[n3];
    if (r3 !== void 0) {
      for (var i = 0; i < r3.length; i++)
        if (this.ri(r3[i][0], t6))
          return void (r3[i] = [t6, e28]);
      r3.push([t6, e28]);
    } else
      this.oi[n3] = [[t6, e28]];
  }, t3.prototype.delete = function(t6) {
    var e28 = this.ii(t6), n3 = this.oi[e28];
    if (n3 === void 0)
      return false;
    for (var r3 = 0; r3 < n3.length; r3++)
      if (this.ri(n3[r3][0], t6))
        return n3.length === 1 ? delete this.oi[e28] : n3.splice(r3, 1), true;
    return false;
  }, t3.prototype.forEach = function(t6) {
    ut(this.oi, function(e28, n3) {
      for (var r3 = 0, i = n3; r3 < i.length; r3++) {
        var o3 = i[r3], u3 = o3[0], s3 = o3[1];
        t6(u3, s3);
      }
    });
  }, t3.prototype.nt = function() {
    return st(this.oi);
  }, t3;
}(), Ti = function() {
  function t3() {
    this.ci = new Ei(function(t6) {
      return t6.toString();
    }, function(t6, e28) {
      return t6.isEqual(e28);
    }), this.ai = false;
  }
  return t3.prototype.ui = function(t6) {
    var e28 = this.ci.get(t6);
    return e28 ? e28.readTime : Z.min();
  }, t3.prototype.hi = function(t6, e28) {
    this.li(), this.ci.set(t6.key, {
      _i: t6,
      readTime: e28
    });
  }, t3.prototype.fi = function(t6, e28) {
    e28 === void 0 && (e28 = null), this.li(), this.ci.set(t6, {
      _i: null,
      readTime: e28
    });
  }, t3.prototype.di = function(t6, e28) {
    this.li();
    var n3 = this.ci.get(e28);
    return n3 !== void 0 ? yr.resolve(n3._i) : this.wi(t6, e28);
  }, t3.prototype.getEntries = function(t6, e28) {
    return this.Ei(t6, e28);
  }, t3.prototype.apply = function(t6) {
    return this.li(), this.ai = true, this.Ti(t6);
  }, t3.prototype.li = function() {
  }, t3;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ni(t3, e28, n3) {
  var r3 = t3.store(Ur.store), i = t3.store(qr.store), o3 = [], u3 = IDBKeyRange.only(n3.batchId), s3 = 0, a3 = r3.ls({
    range: u3
  }, function(t6, e29, n6) {
    return s3++, n6.delete();
  });
  o3.push(a3.next(function() {
    x(s3 === 1);
  }));
  for (var c3 = [], f3 = 0, h3 = n3.mutations; f3 < h3.length; f3++) {
    var l3 = h3[f3], p3 = qr.key(e28, l3.key.path, n3.batchId);
    o3.push(i.delete(p3)), c3.push(l3.key);
  }
  return yr.$n(o3).next(function() {
    return c3;
  });
}
function Ai(t3) {
  var e28;
  if (t3.document)
    e28 = t3.document;
  else if (t3.unknownDocument)
    e28 = t3.unknownDocument;
  else {
    if (!t3.noDocument)
      throw S();
    e28 = t3.noDocument;
  }
  return JSON.stringify(e28).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Si = function() {
  function t3(t6, e28, n3, r3) {
    this.userId = t6, this.Kt = e28, this.Ii = n3, this.mi = r3, this.Ai = {};
  }
  return t3.Ri = function(e28, n3, r3, i) {
    return x(e28.uid !== ""), new t3(e28.A() ? e28.uid : "", n3, r3, i);
  }, t3.prototype.Pi = function(t6) {
    var e28 = true, n3 = IDBKeyRange.bound([this.userId, Number.NEGATIVE_INFINITY], [this.userId, Number.POSITIVE_INFINITY]);
    return Di(t6).ls({
      index: Ur.userMutationsIndex,
      range: n3
    }, function(t10, n6, r3) {
      e28 = false, r3.done();
    }).next(function() {
      return e28;
    });
  }, t3.prototype.yi = function(t6, e28, n3, r3) {
    var i = this, o3 = ki(t6), u3 = Di(t6);
    return u3.add({}).next(function(s3) {
      x(typeof s3 == "number");
      for (var a3 = new ti(s3, e28, n3, r3), c3 = function(t10, e29, n6) {
        var r6 = n6.baseMutations.map(function(e30) {
          return Zn(t10.Ms, e30);
        }), i3 = n6.mutations.map(function(e30) {
          return Zn(t10.Ms, e30);
        });
        return new Ur(e29, n6.batchId, n6.Ds.toMillis(), r6, i3);
      }(i.Kt, i.userId, a3), f3 = [], h3 = new hn(function(t10, e29) {
        return P$1(t10.ot(), e29.ot());
      }), l3 = 0, p3 = r3; l3 < p3.length; l3++) {
        var d3 = p3[l3], v3 = qr.key(i.userId, d3.key.path, s3);
        h3 = h3.add(d3.key.path.Z()), f3.push(u3.put(c3)), f3.push(o3.put(v3, qr.PLACEHOLDER));
      }
      return h3.forEach(function(e29) {
        f3.push(i.Ii.Qs(t6, e29));
      }), t6.ps(function() {
        i.Ai[s3] = a3.keys();
      }), yr.$n(f3).next(function() {
        return a3;
      });
    });
  }, t3.prototype.gi = function(t6, e28) {
    var n3 = this;
    return Di(t6).get(e28).next(function(t10) {
      return t10 ? (x(t10.userId === n3.userId), ci(n3.Kt, t10)) : null;
    });
  }, t3.prototype.Vi = function(t6, e28) {
    var n3 = this;
    return this.Ai[e28] ? yr.resolve(this.Ai[e28]) : this.gi(t6, e28).next(function(t10) {
      if (t10) {
        var r3 = t10.keys();
        return n3.Ai[e28] = r3, r3;
      }
      return null;
    });
  }, t3.prototype.pi = function(t6, e28) {
    var n3 = this, r3 = e28 + 1, i = IDBKeyRange.lowerBound([this.userId, r3]), o3 = null;
    return Di(t6).ls({
      index: Ur.userMutationsIndex,
      range: i
    }, function(t10, e29, i3) {
      e29.userId === n3.userId && (x(e29.batchId >= r3), o3 = ci(n3.Kt, e29)), i3.done();
    }).next(function() {
      return o3;
    });
  }, t3.prototype.bi = function(t6) {
    var e28 = IDBKeyRange.upperBound([this.userId, Number.POSITIVE_INFINITY]), n3 = -1;
    return Di(t6).ls({
      index: Ur.userMutationsIndex,
      range: e28,
      reverse: true
    }, function(t10, e29, r3) {
      n3 = e29.batchId, r3.done();
    }).next(function() {
      return n3;
    });
  }, t3.prototype.vi = function(t6) {
    var e28 = this, n3 = IDBKeyRange.bound([this.userId, -1], [this.userId, Number.POSITIVE_INFINITY]);
    return Di(t6).os(Ur.userMutationsIndex, n3).next(function(t10) {
      return t10.map(function(t11) {
        return ci(e28.Kt, t11);
      });
    });
  }, t3.prototype.Si = function(t6, e28) {
    var n3 = this, r3 = qr.prefixForPath(this.userId, e28.path), i = IDBKeyRange.lowerBound(r3), o3 = [];
    return ki(t6).ls({
      range: i
    }, function(r6, i3, u3) {
      var s3 = r6[0], a3 = r6[1], c3 = r6[2], f3 = Lr(a3);
      if (s3 === n3.userId && e28.path.isEqual(f3))
        return Di(t6).get(c3).next(function(t10) {
          if (!t10)
            throw S();
          x(t10.userId === n3.userId), o3.push(ci(n3.Kt, t10));
        });
      u3.done();
    }).next(function() {
      return o3;
    });
  }, t3.prototype.Di = function(t6, e28) {
    var n3 = this, r3 = new hn(P$1), i = [];
    return e28.forEach(function(e29) {
      var o3 = qr.prefixForPath(n3.userId, e29.path), u3 = IDBKeyRange.lowerBound(o3), s3 = ki(t6).ls({
        range: u3
      }, function(t10, i3, o6) {
        var u6 = t10[0], s4 = t10[1], a3 = t10[2], c3 = Lr(s4);
        u6 === n3.userId && e29.path.isEqual(c3) ? r3 = r3.add(a3) : o6.done();
      });
      i.push(s3);
    }), yr.$n(i).next(function() {
      return n3.Ci(t6, r3);
    });
  }, t3.prototype.xi = function(t6, e28) {
    var n3 = this, r3 = e28.path, i = r3.length + 1, o3 = qr.prefixForPath(this.userId, r3), u3 = IDBKeyRange.lowerBound(o3), s3 = new hn(P$1);
    return ki(t6).ls({
      range: u3
    }, function(t10, e29, o6) {
      var u6 = t10[0], a3 = t10[1], c3 = t10[2], f3 = Lr(a3);
      u6 === n3.userId && r3.st(f3) ? f3.length === i && (s3 = s3.add(c3)) : o6.done();
    }).next(function() {
      return n3.Ci(t6, s3);
    });
  }, t3.prototype.Ci = function(t6, e28) {
    var n3 = this, r3 = [], i = [];
    return e28.forEach(function(e29) {
      i.push(Di(t6).get(e29).next(function(t10) {
        if (t10 === null)
          throw S();
        x(t10.userId === n3.userId), r3.push(ci(n3.Kt, t10));
      }));
    }), yr.$n(i).next(function() {
      return r3;
    });
  }, t3.prototype.Ni = function(t6, e28) {
    var n3 = this;
    return Ni(t6.vs, this.userId, e28).next(function(r3) {
      return t6.ps(function() {
        n3.Fi(e28.batchId);
      }), yr.forEach(r3, function(e29) {
        return n3.mi.Oi(t6, e29);
      });
    });
  }, t3.prototype.Fi = function(t6) {
    delete this.Ai[t6];
  }, t3.prototype.ki = function(t6) {
    var e28 = this;
    return this.Pi(t6).next(function(n3) {
      if (!n3)
        return yr.resolve();
      var r3 = IDBKeyRange.lowerBound(qr.prefixForUser(e28.userId)), i = [];
      return ki(t6).ls({
        range: r3
      }, function(t10, n6, r6) {
        if (t10[0] === e28.userId) {
          var o3 = Lr(t10[1]);
          i.push(o3);
        } else
          r6.done();
      }).next(function() {
        x(i.length === 0);
      });
    });
  }, t3.prototype.Mi = function(t6, e28) {
    return xi(t6, this.userId, e28);
  }, t3.prototype.Li = function(t6) {
    var e28 = this;
    return Oi(t6).get(this.userId).next(function(t10) {
      return t10 || new Mr(e28.userId, -1, "");
    });
  }, t3;
}();
function xi(t3, e28, n3) {
  var r3 = qr.prefixForPath(e28, n3.path), i = r3[1], o3 = IDBKeyRange.lowerBound(r3), u3 = false;
  return ki(t3).ls({
    range: o3,
    hs: true
  }, function(t6, n6, r6) {
    var o6 = t6[0], s3 = t6[1];
    t6[2];
    o6 === e28 && s3 === i && (u3 = true), r6.done();
  }).next(function() {
    return u3;
  });
}
function Di(t3) {
  return Zr(t3, Ur.store);
}
function ki(t3) {
  return Zr(t3, qr.store);
}
function Oi(t3) {
  return Zr(t3, Mr.store);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Pi = function() {
  function t3(t6) {
    this.$i = t6;
  }
  return t3.prototype.next = function() {
    return this.$i += 2, this.$i;
  }, t3.Bi = function() {
    return new t3(0);
  }, t3.qi = function() {
    return new t3(-1);
  }, t3;
}(), Ci = function() {
  function t3(t6, e28) {
    this.mi = t6, this.Kt = e28;
  }
  return t3.prototype.Ui = function(t6) {
    var e28 = this;
    return this.Qi(t6).next(function(n3) {
      var r3 = new Pi(n3.highestTargetId);
      return n3.highestTargetId = r3.next(), e28.Ki(t6, n3).next(function() {
        return n3.highestTargetId;
      });
    });
  }, t3.prototype.Wi = function(t6) {
    return this.Qi(t6).next(function(t10) {
      return Z.W(new X(t10.lastRemoteSnapshotVersion.seconds, t10.lastRemoteSnapshotVersion.nanoseconds));
    });
  }, t3.prototype.ji = function(t6) {
    return this.Qi(t6).next(function(t10) {
      return t10.highestListenSequenceNumber;
    });
  }, t3.prototype.Gi = function(t6, e28, n3) {
    var r3 = this;
    return this.Qi(t6).next(function(i) {
      return i.highestListenSequenceNumber = e28, n3 && (i.lastRemoteSnapshotVersion = n3.G()), e28 > i.highestListenSequenceNumber && (i.highestListenSequenceNumber = e28), r3.Ki(t6, i);
    });
  }, t3.prototype.zi = function(t6, e28) {
    var n3 = this;
    return this.Hi(t6, e28).next(function() {
      return n3.Qi(t6).next(function(r3) {
        return r3.targetCount += 1, n3.Ji(e28, r3), n3.Ki(t6, r3);
      });
    });
  }, t3.prototype.Yi = function(t6, e28) {
    return this.Hi(t6, e28);
  }, t3.prototype.Xi = function(t6, e28) {
    var n3 = this;
    return this.Zi(t6, e28.targetId).next(function() {
      return Li(t6).delete(e28.targetId);
    }).next(function() {
      return n3.Qi(t6);
    }).next(function(e29) {
      return x(e29.targetCount > 0), e29.targetCount -= 1, n3.Ki(t6, e29);
    });
  }, t3.prototype.tr = function(t6, e28, n3) {
    var r3 = this, i = 0, o3 = [];
    return Li(t6).ls(function(u3, s3) {
      var a3 = fi(s3);
      a3.sequenceNumber <= e28 && n3.get(a3.targetId) === null && (i++, o3.push(r3.Xi(t6, a3)));
    }).next(function() {
      return yr.$n(o3);
    }).next(function() {
      return i;
    });
  }, t3.prototype.mn = function(t6, e28) {
    return Li(t6).ls(function(t10, n3) {
      var r3 = fi(n3);
      e28(r3);
    });
  }, t3.prototype.Qi = function(t6) {
    return Ri(t6).get(Hr.key).next(function(t10) {
      return x(t10 !== null), t10;
    });
  }, t3.prototype.Ki = function(t6, e28) {
    return Ri(t6).put(Hr.key, e28);
  }, t3.prototype.Hi = function(t6, e28) {
    return Li(t6).put(hi(this.Kt, e28));
  }, t3.prototype.Ji = function(t6, e28) {
    var n3 = false;
    return t6.targetId > e28.highestTargetId && (e28.highestTargetId = t6.targetId, n3 = true), t6.sequenceNumber > e28.highestListenSequenceNumber && (e28.highestListenSequenceNumber = t6.sequenceNumber, n3 = true), n3;
  }, t3.prototype.er = function(t6) {
    return this.Qi(t6).next(function(t10) {
      return t10.targetCount;
    });
  }, t3.prototype.nr = function(t6, e28) {
    var n3 = jt(e28), r3 = IDBKeyRange.bound([n3, Number.NEGATIVE_INFINITY], [n3, Number.POSITIVE_INFINITY]), i = null;
    return Li(t6).ls({
      range: r3,
      index: Br.queryTargetsIndexName
    }, function(t10, n6, r6) {
      var o3 = fi(n6);
      zt(e28, o3.target) && (i = o3, r6.done());
    }).next(function() {
      return i;
    });
  }, t3.prototype.sr = function(t6, e28, n3) {
    var r3 = this, i = [], o3 = Vi(t6);
    return e28.forEach(function(e29) {
      var u3 = Or(e29.path);
      i.push(o3.put(new Kr(n3, u3))), i.push(r3.mi.ir(t6, n3, e29));
    }), yr.$n(i);
  }, t3.prototype.rr = function(t6, e28, n3) {
    var r3 = this, i = Vi(t6);
    return yr.forEach(e28, function(e29) {
      var o3 = Or(e29.path);
      return yr.$n([i.delete([n3, o3]), r3.mi.cr(t6, n3, e29)]);
    });
  }, t3.prototype.Zi = function(t6, e28) {
    var n3 = Vi(t6), r3 = IDBKeyRange.bound([e28], [e28 + 1], false, true);
    return n3.delete(r3);
  }, t3.prototype.ar = function(t6, e28) {
    var n3 = IDBKeyRange.bound([e28], [e28 + 1], false, true), r3 = Vi(t6), i = In();
    return r3.ls({
      range: n3,
      hs: true
    }, function(t10, e29, n6) {
      var r6 = Lr(t10[1]), o3 = new it(r6);
      i = i.add(o3);
    }).next(function() {
      return i;
    });
  }, t3.prototype.Mi = function(t6, e28) {
    var n3 = Or(e28.path), r3 = IDBKeyRange.bound([n3], [L(n3)], false, true), i = 0;
    return Vi(t6).ls({
      index: Kr.documentTargetsIndex,
      hs: true,
      range: r3
    }, function(t10, e29, n6) {
      var r6 = t10[0];
      t10[1];
      r6 !== 0 && (i++, n6.done());
    }).next(function() {
      return i > 0;
    });
  }, t3.prototype.Dn = function(t6, e28) {
    return Li(t6).get(e28).next(function(t10) {
      return t10 ? fi(t10) : null;
    });
  }, t3;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Li(t3) {
  return Zr(t3, Br.store);
}
function Ri(t3) {
  return Zr(t3, Hr.store);
}
function Vi(t3) {
  return Zr(t3, Kr.store);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Mi(t3, e28) {
  var n3 = t3[0], r3 = t3[1], i = e28[0], o3 = e28[1], u3 = P$1(n3, i);
  return u3 === 0 ? P$1(r3, o3) : u3;
}
var Ui = function() {
  function t3(t6) {
    this.ur = t6, this.buffer = new hn(Mi), this.hr = 0;
  }
  return t3.prototype.lr = function() {
    return ++this.hr;
  }, t3.prototype._r = function(t6) {
    var e28 = [t6, this.lr()];
    if (this.buffer.size < this.ur)
      this.buffer = this.buffer.add(e28);
    else {
      var n3 = this.buffer.last();
      Mi(e28, n3) < 0 && (this.buffer = this.buffer.delete(n3).add(e28));
    }
  }, Object.defineProperty(t3.prototype, "maxValue", {
    get: function() {
      return this.buffer.last()[0];
    },
    enumerable: false,
    configurable: true
  }), t3;
}(), qi = function() {
  function t3(t6, e28) {
    this.dr = t6, this.fs = e28, this.wr = false, this.Er = null;
  }
  return t3.prototype.start = function(t6) {
    this.dr.params.Js !== -1 && this.Tr(t6);
  }, t3.prototype.stop = function() {
    this.Er && (this.Er.cancel(), this.Er = null);
  }, Object.defineProperty(t3.prototype, "Ir", {
    get: function() {
      return this.Er !== null;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.Tr = function(t6) {
    var e28 = this, n3 = this.wr ? 3e5 : 6e4;
    E("LruGarbageCollector", "Garbage collection scheduled in " + n3 + "ms"), this.Er = this.fs.mr("lru_garbage_collection", n3, function() {
      return __awaiter(e28, void 0, void 0, function() {
        var e29;
        return __generator(this, function(n6) {
          switch (n6.label) {
            case 0:
              this.Er = null, this.wr = true, n6.label = 1;
            case 1:
              return n6.trys.push([1, 3, , 7]), [4, t6.Ar(this.dr)];
            case 2:
              return n6.sent(), [3, 7];
            case 3:
              return Ir(e29 = n6.sent()) ? (E("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", e29), [3, 6]) : [3, 4];
            case 4:
              return [4, _i(e29)];
            case 5:
              n6.sent(), n6.label = 6;
            case 6:
              return [3, 7];
            case 7:
              return [4, this.Tr(t6)];
            case 8:
              return n6.sent(), [2];
          }
        });
      });
    });
  }, t3;
}(), Fi = function() {
  function t3(t6, e28) {
    this.Rr = t6, this.params = e28;
  }
  return t3.prototype.Pr = function(t6, e28) {
    return this.Rr.yr(t6).next(function(t10) {
      return Math.floor(e28 / 100 * t10);
    });
  }, t3.prototype.gr = function(t6, e28) {
    var n3 = this;
    if (e28 === 0)
      return yr.resolve($.U);
    var r3 = new Ui(e28);
    return this.Rr.mn(t6, function(t10) {
      return r3._r(t10.sequenceNumber);
    }).next(function() {
      return n3.Rr.Vr(t6, function(t10) {
        return r3._r(t10);
      });
    }).next(function() {
      return r3.maxValue;
    });
  }, t3.prototype.tr = function(t6, e28, n3) {
    return this.Rr.tr(t6, e28, n3);
  }, t3.prototype.pr = function(t6, e28) {
    return this.Rr.pr(t6, e28);
  }, t3.prototype.br = function(t6, e28) {
    var n3 = this;
    return this.params.Js === -1 ? (E("LruGarbageCollector", "Garbage collection skipped; disabled"), yr.resolve(bi)) : this.vr(t6).next(function(r3) {
      return r3 < n3.params.Js ? (E("LruGarbageCollector", "Garbage collection skipped; Cache size " + r3 + " is lower than threshold " + n3.params.Js), bi) : n3.Sr(t6, e28);
    });
  }, t3.prototype.vr = function(t6) {
    return this.Rr.vr(t6);
  }, t3.prototype.Sr = function(t6, n3) {
    var r3, i, o3, u3, s3, a3, c3, f3 = this, h3 = Date.now();
    return this.Pr(t6, this.params.Ys).next(function(e28) {
      return e28 > f3.params.Xs ? (E("LruGarbageCollector", "Capping sequence numbers to collect down to the maximum of " + f3.params.Xs + " from " + e28), i = f3.params.Xs) : i = e28, u3 = Date.now(), f3.gr(t6, i);
    }).next(function(e28) {
      return r3 = e28, s3 = Date.now(), f3.tr(t6, r3, n3);
    }).next(function(e28) {
      return o3 = e28, a3 = Date.now(), f3.pr(t6, r3);
    }).next(function(t10) {
      return c3 = Date.now(), _() <= LogLevel.DEBUG && E("LruGarbageCollector", "LRU Garbage Collection\n	Counted targets in " + (u3 - h3) + "ms\n	Determined least recently used " + i + " in " + (s3 - u3) + "ms\n	Removed " + o3 + " targets in " + (a3 - s3) + "ms\n	Removed " + t10 + " documents in " + (c3 - a3) + "ms\nTotal Duration: " + (c3 - h3) + "ms"), yr.resolve({
        js: true,
        Gs: i,
        zs: o3,
        Hs: t10
      });
    });
  }, t3;
}(), ji = function() {
  function t3(t6, e28) {
    this.db = t6, this.dr = function(t10, e29) {
      return new Fi(t10, e29);
    }(this, e28);
  }
  return t3.prototype.yr = function(t6) {
    var e28 = this.Dr(t6);
    return this.db.Cr().er(t6).next(function(t10) {
      return e28.next(function(e29) {
        return t10 + e29;
      });
    });
  }, t3.prototype.Dr = function(t6) {
    var e28 = 0;
    return this.Vr(t6, function(t10) {
      e28++;
    }).next(function() {
      return e28;
    });
  }, t3.prototype.mn = function(t6, e28) {
    return this.db.Cr().mn(t6, e28);
  }, t3.prototype.Vr = function(t6, e28) {
    return this.Nr(t6, function(t10, n3) {
      return e28(n3);
    });
  }, t3.prototype.ir = function(t6, e28, n3) {
    return zi(t6, n3);
  }, t3.prototype.cr = function(t6, e28, n3) {
    return zi(t6, n3);
  }, t3.prototype.tr = function(t6, e28, n3) {
    return this.db.Cr().tr(t6, e28, n3);
  }, t3.prototype.Oi = function(t6, e28) {
    return zi(t6, e28);
  }, t3.prototype.Fr = function(t6, e28) {
    return function(t10, e29) {
      var n3 = false;
      return Oi(t10)._s(function(r3) {
        return xi(t10, r3, e29).next(function(t11) {
          return t11 && (n3 = true), yr.resolve(!t11);
        });
      }).next(function() {
        return n3;
      });
    }(t6, e28);
  }, t3.prototype.pr = function(t6, e28) {
    var n3 = this, r3 = this.db.kr().Or(), i = [], o3 = 0;
    return this.Nr(t6, function(u3, s3) {
      if (s3 <= e28) {
        var a3 = n3.Fr(t6, u3).next(function(e29) {
          if (!e29)
            return o3++, r3.di(t6, u3).next(function() {
              return r3.fi(u3), Vi(t6).delete([0, Or(u3.path)]);
            });
        });
        i.push(a3);
      }
    }).next(function() {
      return yr.$n(i);
    }).next(function() {
      return r3.apply(t6);
    }).next(function() {
      return o3;
    });
  }, t3.prototype.removeTarget = function(t6, e28) {
    var n3 = e28.Lt(t6.Ss);
    return this.db.Cr().Yi(t6, n3);
  }, t3.prototype.Mr = function(t6, e28) {
    return zi(t6, e28);
  }, t3.prototype.Nr = function(t6, e28) {
    var n3, r3 = Vi(t6), i = $.U;
    return r3.ls({
      index: Kr.documentTargetsIndex
    }, function(t10, r6) {
      var o3 = t10[0], u3 = (t10[1], r6.path), s3 = r6.sequenceNumber;
      o3 === 0 ? (i !== $.U && e28(new it(Lr(n3)), i), i = s3, n3 = u3) : i = $.U;
    }).next(function() {
      i !== $.U && e28(new it(Lr(n3)), i);
    });
  }, t3.prototype.vr = function(t6) {
    return this.db.kr().Lr(t6);
  }, t3;
}();
function zi(t3, e28) {
  return Vi(t3).put(function(t6, e29) {
    return new Kr(0, Or(t6.path), e29);
  }(e28, t3.Ss));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Gi = function() {
  function t3(t6, e28) {
    this.Kt = t6, this.Ii = e28;
  }
  return t3.prototype.hi = function(t6, e28, n3) {
    return Hi(t6).put(Ji(e28), n3);
  }, t3.prototype.fi = function(t6, e28) {
    var n3 = Hi(t6), r3 = Ji(e28);
    return n3.delete(r3);
  }, t3.prototype.updateMetadata = function(t6, e28) {
    var n3 = this;
    return this.getMetadata(t6).next(function(r3) {
      return r3.byteSize += e28, n3.$r(t6, r3);
    });
  }, t3.prototype.di = function(t6, e28) {
    var n3 = this;
    return Hi(t6).get(Ji(e28)).next(function(t10) {
      return n3.Br(t10);
    });
  }, t3.prototype.qr = function(t6, e28) {
    var n3 = this;
    return Hi(t6).get(Ji(e28)).next(function(t10) {
      var e29 = n3.Br(t10);
      return e29 ? {
        _i: e29,
        size: Ai(t10)
      } : null;
    });
  }, t3.prototype.getEntries = function(t6, e28) {
    var n3 = this, r3 = vn();
    return this.Ur(t6, e28, function(t10, e29) {
      var i = n3.Br(e29);
      r3 = r3.Ht(t10, i);
    }).next(function() {
      return r3;
    });
  }, t3.prototype.Qr = function(t6, e28) {
    var n3 = this, r3 = vn(), i = new an(it.J);
    return this.Ur(t6, e28, function(t10, e29) {
      var o3 = n3.Br(e29);
      o3 ? (r3 = r3.Ht(t10, o3), i = i.Ht(t10, Ai(e29))) : (r3 = r3.Ht(t10, null), i = i.Ht(t10, 0));
    }).next(function() {
      return {
        Kr: r3,
        Wr: i
      };
    });
  }, t3.prototype.Ur = function(t6, e28, n3) {
    if (e28.nt())
      return yr.resolve();
    var r3 = IDBKeyRange.bound(e28.first().path.rt(), e28.last().path.rt()), i = e28.ee(), o3 = i.ce();
    return Hi(t6).ls({
      range: r3
    }, function(t10, e29, r6) {
      for (var u3 = it.Tt(t10); o3 && it.J(o3, u3) < 0; )
        n3(o3, null), o3 = i.ce();
      o3 && o3.isEqual(u3) && (n3(o3, e29), o3 = i.ae() ? i.ce() : null), o3 ? r6.rs(o3.path.rt()) : r6.done();
    }).next(function() {
      for (; o3; )
        n3(o3, null), o3 = i.ae() ? i.ce() : null;
    });
  }, t3.prototype.jr = function(t6, e28, n3) {
    var r3 = this, i = mn(), o3 = e28.path.length + 1, u3 = {};
    if (n3.isEqual(Z.min())) {
      var s3 = e28.path.rt();
      u3.range = IDBKeyRange.lowerBound(s3);
    } else {
      var a3 = e28.path.rt(), c3 = oi(n3);
      u3.range = IDBKeyRange.lowerBound([a3, c3], true), u3.index = zr.collectionReadTimeIndex;
    }
    return Hi(t6).ls(u3, function(t10, n6, u6) {
      if (t10.length === o3) {
        var s4 = ri(r3.Kt, n6);
        e28.path.st(s4.key.path) ? s4 instanceof Vt && we(e28, s4) && (i = i.Ht(s4.key, s4)) : u6.done();
      }
    }).next(function() {
      return i;
    });
  }, t3.prototype.Or = function(t6) {
    return new Bi(this, !!t6 && t6.Gr);
  }, t3.prototype.Lr = function(t6) {
    return this.getMetadata(t6).next(function(t10) {
      return t10.byteSize;
    });
  }, t3.prototype.getMetadata = function(t6) {
    return Ki(t6).get(Gr.key).next(function(t10) {
      return x(!!t10), t10;
    });
  }, t3.prototype.$r = function(t6, e28) {
    return Ki(t6).put(Gr.key, e28);
  }, t3.prototype.Br = function(t6) {
    if (t6) {
      var e28 = ri(this.Kt, t6);
      return e28 instanceof Mt && e28.version.isEqual(Z.min()) ? null : e28;
    }
    return null;
  }, t3;
}(), Bi = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this) || this).zr = e29, r3.Gr = n3, r3.Hr = new Ei(function(t6) {
      return t6.toString();
    }, function(t6, e30) {
      return t6.isEqual(e30);
    }), r3;
  }
  return __extends$1(e28, t3), e28.prototype.Ti = function(t6) {
    var e29 = this, n3 = [], r3 = 0, i = new hn(function(t10, e30) {
      return P$1(t10.ot(), e30.ot());
    });
    return this.ci.forEach(function(o3, u3) {
      var s3 = e29.Hr.get(o3);
      if (u3._i) {
        var a3 = ii(e29.zr.Kt, u3._i, e29.ui(o3));
        i = i.add(o3.path.Z());
        var c3 = Ai(a3);
        r3 += c3 - s3, n3.push(e29.zr.hi(t6, o3, a3));
      } else if (r3 -= s3, e29.Gr) {
        var f3 = ii(e29.zr.Kt, new Mt(o3, Z.min()), e29.ui(o3));
        n3.push(e29.zr.hi(t6, o3, f3));
      } else
        n3.push(e29.zr.fi(t6, o3));
    }), i.forEach(function(r6) {
      n3.push(e29.zr.Ii.Qs(t6, r6));
    }), n3.push(this.zr.updateMetadata(t6, r3)), yr.$n(n3);
  }, e28.prototype.wi = function(t6, e29) {
    var n3 = this;
    return this.zr.qr(t6, e29).next(function(t10) {
      return t10 === null ? (n3.Hr.set(e29, 0), null) : (n3.Hr.set(e29, t10.size), t10._i);
    });
  }, e28.prototype.Ei = function(t6, e29) {
    var n3 = this;
    return this.zr.Qr(t6, e29).next(function(t10) {
      var e30 = t10.Kr;
      return t10.Wr.forEach(function(t11, e31) {
        n3.Hr.set(t11, e31);
      }), e30;
    });
  }, e28;
}(Ti);
function Ki(t3) {
  return Zr(t3, Gr.store);
}
function Hi(t3) {
  return Zr(t3, zr.store);
}
function Ji(t3) {
  return t3.path.rt();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Wi = function() {
  function t3(t6) {
    this.Kt = t6;
  }
  return t3.prototype.Yn = function(t6, e28, n3, r3) {
    var i = this;
    x(n3 < r3 && n3 >= 0 && r3 <= 11);
    var o3 = new mr("createOrUpgrade", e28);
    n3 < 1 && r3 >= 1 && (function(t10) {
      t10.createObjectStore(Vr.store);
    }(t6), function(t10) {
      t10.createObjectStore(Mr.store, {
        keyPath: Mr.keyPath
      }), t10.createObjectStore(Ur.store, {
        keyPath: Ur.keyPath,
        autoIncrement: true
      }).createIndex(Ur.userMutationsIndex, Ur.userMutationsKeyPath, {
        unique: true
      }), t10.createObjectStore(qr.store);
    }(t6), Qi(t6), function(t10) {
      t10.createObjectStore(zr.store);
    }(t6));
    var u3 = yr.resolve();
    return n3 < 3 && r3 >= 3 && (n3 !== 0 && (function(t10) {
      t10.deleteObjectStore(Kr.store), t10.deleteObjectStore(Br.store), t10.deleteObjectStore(Hr.store);
    }(t6), Qi(t6)), u3 = u3.next(function() {
      return function(t10) {
        var e29 = t10.store(Hr.store), n6 = new Hr(0, 0, Z.min().G(), 0);
        return e29.put(Hr.key, n6);
      }(o3);
    })), n3 < 4 && r3 >= 4 && (n3 !== 0 && (u3 = u3.next(function() {
      return function(t10, e29) {
        return e29.store(Ur.store).os().next(function(n6) {
          t10.deleteObjectStore(Ur.store), t10.createObjectStore(Ur.store, {
            keyPath: Ur.keyPath,
            autoIncrement: true
          }).createIndex(Ur.userMutationsIndex, Ur.userMutationsKeyPath, {
            unique: true
          });
          var r6 = e29.store(Ur.store), i3 = n6.map(function(t11) {
            return r6.put(t11);
          });
          return yr.$n(i3);
        });
      }(t6, o3);
    })), u3 = u3.next(function() {
      !function(t10) {
        t10.createObjectStore(Wr.store, {
          keyPath: Wr.keyPath
        });
      }(t6);
    })), n3 < 5 && r3 >= 5 && (u3 = u3.next(function() {
      return i.Jr(o3);
    })), n3 < 6 && r3 >= 6 && (u3 = u3.next(function() {
      return function(t10) {
        t10.createObjectStore(Gr.store);
      }(t6), i.Yr(o3);
    })), n3 < 7 && r3 >= 7 && (u3 = u3.next(function() {
      return i.Xr(o3);
    })), n3 < 8 && r3 >= 8 && (u3 = u3.next(function() {
      return i.Zr(t6, o3);
    })), n3 < 9 && r3 >= 9 && (u3 = u3.next(function() {
      !function(t10) {
        t10.objectStoreNames.contains("remoteDocumentChanges") && t10.deleteObjectStore("remoteDocumentChanges");
      }(t6), function(t10) {
        var e29 = t10.objectStore(zr.store);
        e29.createIndex(zr.readTimeIndex, zr.readTimeIndexPath, {
          unique: false
        }), e29.createIndex(zr.collectionReadTimeIndex, zr.collectionReadTimeIndexPath, {
          unique: false
        });
      }(e28);
    })), n3 < 10 && r3 >= 10 && (u3 = u3.next(function() {
      return i.eo(o3);
    })), n3 < 11 && r3 >= 11 && (u3 = u3.next(function() {
      !function(t10) {
        t10.createObjectStore(Qr.store, {
          keyPath: Qr.keyPath
        });
      }(t6), function(t10) {
        t10.createObjectStore(Yr.store, {
          keyPath: Yr.keyPath
        });
      }(t6);
    })), u3;
  }, t3.prototype.Yr = function(t6) {
    var e28 = 0;
    return t6.store(zr.store).ls(function(t10, n3) {
      e28 += Ai(n3);
    }).next(function() {
      var n3 = new Gr(e28);
      return t6.store(Gr.store).put(Gr.key, n3);
    });
  }, t3.prototype.Jr = function(t6) {
    var e28 = this, n3 = t6.store(Mr.store), r3 = t6.store(Ur.store);
    return n3.os().next(function(n6) {
      return yr.forEach(n6, function(n10) {
        var i = IDBKeyRange.bound([n10.userId, -1], [n10.userId, n10.lastAcknowledgedBatchId]);
        return r3.os(Ur.userMutationsIndex, i).next(function(r6) {
          return yr.forEach(r6, function(r10) {
            x(r10.userId === n10.userId);
            var i3 = ci(e28.Kt, r10);
            return Ni(t6, n10.userId, i3).next(function() {
            });
          });
        });
      });
    });
  }, t3.prototype.Xr = function(t6) {
    var e28 = t6.store(Kr.store), n3 = t6.store(zr.store);
    return t6.store(Hr.store).get(Hr.key).next(function(t10) {
      var r3 = [];
      return n3.ls(function(n6, i) {
        var o3 = new et(n6), u3 = function(t11) {
          return [0, Or(t11)];
        }(o3);
        r3.push(e28.get(u3).next(function(n10) {
          return n10 ? yr.resolve() : function(n11) {
            return e28.put(new Kr(0, Or(n11), t10.highestListenSequenceNumber));
          }(o3);
        }));
      }).next(function() {
        return yr.$n(r3);
      });
    });
  }, t3.prototype.Zr = function(t6, e28) {
    t6.createObjectStore(Jr.store, {
      keyPath: Jr.keyPath
    });
    var n3 = e28.store(Jr.store), r3 = new mi(), i = function(t10) {
      if (r3.add(t10)) {
        var e29 = t10.et(), i3 = t10.Z();
        return n3.put({
          collectionId: e29,
          parent: Or(i3)
        });
      }
    };
    return e28.store(zr.store).ls({
      hs: true
    }, function(t10, e29) {
      var n6 = new et(t10);
      return i(n6.Z());
    }).next(function() {
      return e28.store(qr.store).ls({
        hs: true
      }, function(t10, e29) {
        t10[0];
        var n6 = t10[1], r6 = (t10[2], Lr(n6));
        return i(r6.Z());
      });
    });
  }, t3.prototype.eo = function(t6) {
    var e28 = this, n3 = t6.store(Br.store);
    return n3.ls(function(t10, r3) {
      var i = fi(r3), o3 = hi(e28.Kt, i);
      return n3.put(o3);
    });
  }, t3;
}();
function Qi(t3) {
  t3.createObjectStore(Kr.store, {
    keyPath: Kr.keyPath
  }).createIndex(Kr.documentTargetsIndex, Kr.documentTargetsKeyPath, {
    unique: true
  }), t3.createObjectStore(Br.store, {
    keyPath: Br.keyPath
  }).createIndex(Br.queryTargetsIndexName, Br.queryTargetsKeyPath, {
    unique: true
  }), t3.createObjectStore(Hr.store);
}
var Yi = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.", $i = function() {
  function t3(e28, n3, r3, i, o3, u3, s3, a3, c3, f3) {
    if (this.allowTabSynchronization = e28, this.persistenceKey = n3, this.clientId = r3, this.no = o3, this.window = u3, this.document = s3, this.so = c3, this.io = f3, this.ro = null, this.oo = false, this.isPrimary = false, this.networkEnabled = true, this.co = null, this.inForeground = false, this.ao = null, this.uo = null, this.ho = Number.NEGATIVE_INFINITY, this.lo = function(t6) {
      return Promise.resolve();
    }, !t3.Wn())
      throw new M(V.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
    this.mi = new ji(this, i), this._o = n3 + "main", this.Kt = new ni(a3), this.fo = new gr(this._o, 11, new Wi(this.Kt)), this.wo = new Ci(this.mi, this.Kt), this.Ii = new gi(), this.Eo = function(t6, e29) {
      return new Gi(t6, e29);
    }(this.Kt, this.Ii), this.To = new pi(), this.window && this.window.localStorage ? this.Io = this.window.localStorage : (this.Io = null, f3 === false && T("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
  }
  return t3.prototype.start = function() {
    var t6 = this;
    return this.mo().then(function() {
      if (!t6.isPrimary && !t6.allowTabSynchronization)
        throw new M(V.FAILED_PRECONDITION, Yi);
      return t6.Ao(), t6.Ro(), t6.Po(), t6.runTransaction("getHighestListenSequenceNumber", "readonly", function(e28) {
        return t6.wo.ji(e28);
      });
    }).then(function(e28) {
      t6.ro = new $(e28, t6.so);
    }).then(function() {
      t6.oo = true;
    }).catch(function(e28) {
      return t6.fo && t6.fo.close(), Promise.reject(e28);
    });
  }, t3.prototype.yo = function(t6) {
    var e28 = this;
    return this.lo = function(n3) {
      return __awaiter(e28, void 0, void 0, function() {
        return __generator(this, function(e29) {
          return this.Ir ? [2, t6(n3)] : [2];
        });
      });
    }, t6(this.isPrimary);
  }, t3.prototype.Vo = function(t6) {
    var e28 = this;
    this.fo.Zn(function(n3) {
      return __awaiter(e28, void 0, void 0, function() {
        return __generator(this, function(e29) {
          switch (e29.label) {
            case 0:
              return n3.newVersion === null ? [4, t6()] : [3, 2];
            case 1:
              e29.sent(), e29.label = 2;
            case 2:
              return [2];
          }
        });
      });
    });
  }, t3.prototype.po = function(t6) {
    var e28 = this;
    this.networkEnabled !== t6 && (this.networkEnabled = t6, this.no.ys(function() {
      return __awaiter(e28, void 0, void 0, function() {
        return __generator(this, function(t10) {
          switch (t10.label) {
            case 0:
              return this.Ir ? [4, this.mo()] : [3, 2];
            case 1:
              t10.sent(), t10.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }));
  }, t3.prototype.mo = function() {
    var t6 = this;
    return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", function(e28) {
      return Zi(e28).put(new Wr(t6.clientId, Date.now(), t6.networkEnabled, t6.inForeground)).next(function() {
        if (t6.isPrimary)
          return t6.bo(e28).next(function(e29) {
            e29 || (t6.isPrimary = false, t6.no.vo(function() {
              return t6.lo(false);
            }));
          });
      }).next(function() {
        return t6.So(e28);
      }).next(function(n3) {
        return t6.isPrimary && !n3 ? t6.Do(e28).next(function() {
          return false;
        }) : !!n3 && t6.Co(e28).next(function() {
          return true;
        });
      });
    }).catch(function(e28) {
      if (Ir(e28))
        return E("IndexedDbPersistence", "Failed to extend owner lease: ", e28), t6.isPrimary;
      if (!t6.allowTabSynchronization)
        throw e28;
      return E("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", e28), false;
    }).then(function(e28) {
      t6.isPrimary !== e28 && t6.no.vo(function() {
        return t6.lo(e28);
      }), t6.isPrimary = e28;
    });
  }, t3.prototype.bo = function(t6) {
    var e28 = this;
    return Xi(t6).get(Vr.key).next(function(t10) {
      return yr.resolve(e28.xo(t10));
    });
  }, t3.prototype.No = function(t6) {
    return Zi(t6).delete(this.clientId);
  }, t3.prototype.Fo = function() {
    return __awaiter(this, void 0, void 0, function() {
      var t6, e28, n3, r3, i = this;
      return __generator(this, function(o3) {
        switch (o3.label) {
          case 0:
            return !this.isPrimary || this.Oo(this.ho, 18e5) ? [3, 2] : (this.ho = Date.now(), [4, this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", function(t10) {
              var e29 = Zr(t10, Wr.store);
              return e29.os().next(function(t11) {
                var n6 = i.ko(t11, 18e5), r6 = t11.filter(function(t12) {
                  return n6.indexOf(t12) === -1;
                });
                return yr.forEach(r6, function(t12) {
                  return e29.delete(t12.clientId);
                }).next(function() {
                  return r6;
                });
              });
            }).catch(function() {
              return [];
            })]);
          case 1:
            if (t6 = o3.sent(), this.Io)
              for (e28 = 0, n3 = t6; e28 < n3.length; e28++)
                r3 = n3[e28], this.Io.removeItem(this.Mo(r3.clientId));
            o3.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, t3.prototype.Po = function() {
    var t6 = this;
    this.uo = this.no.mr("client_metadata_refresh", 4e3, function() {
      return t6.mo().then(function() {
        return t6.Fo();
      }).then(function() {
        return t6.Po();
      });
    });
  }, t3.prototype.xo = function(t6) {
    return !!t6 && t6.ownerId === this.clientId;
  }, t3.prototype.So = function(t6) {
    var e28 = this;
    return this.io ? yr.resolve(true) : Xi(t6).get(Vr.key).next(function(n3) {
      if (n3 !== null && e28.Oo(n3.leaseTimestampMs, 5e3) && !e28.Lo(n3.ownerId)) {
        if (e28.xo(n3) && e28.networkEnabled)
          return true;
        if (!e28.xo(n3)) {
          if (!n3.allowTabSynchronization)
            throw new M(V.FAILED_PRECONDITION, Yi);
          return false;
        }
      }
      return !(!e28.networkEnabled || !e28.inForeground) || Zi(t6).os().next(function(t10) {
        return e28.ko(t10, 5e3).find(function(t11) {
          if (e28.clientId !== t11.clientId) {
            var n6 = !e28.networkEnabled && t11.networkEnabled, r3 = !e28.inForeground && t11.inForeground, i = e28.networkEnabled === t11.networkEnabled;
            if (n6 || r3 && i)
              return true;
          }
          return false;
        }) === void 0;
      });
    }).next(function(t10) {
      return e28.isPrimary !== t10 && E("IndexedDbPersistence", "Client " + (t10 ? "is" : "is not") + " eligible for a primary lease."), t10;
    });
  }, t3.prototype.$o = function() {
    return __awaiter(this, void 0, void 0, function() {
      var t6 = this;
      return __generator(this, function(e28) {
        switch (e28.label) {
          case 0:
            return this.oo = false, this.Bo(), this.uo && (this.uo.cancel(), this.uo = null), this.qo(), this.Uo(), [4, this.fo.runTransaction("shutdown", "readwrite", [Vr.store, Wr.store], function(e29) {
              var n3 = new Xr(e29, $.U);
              return t6.Do(n3).next(function() {
                return t6.No(n3);
              });
            })];
          case 1:
            return e28.sent(), this.fo.close(), this.Qo(), [2];
        }
      });
    });
  }, t3.prototype.ko = function(t6, e28) {
    var n3 = this;
    return t6.filter(function(t10) {
      return n3.Oo(t10.updateTimeMs, e28) && !n3.Lo(t10.clientId);
    });
  }, t3.prototype.Ko = function() {
    var t6 = this;
    return this.runTransaction("getActiveClients", "readonly", function(e28) {
      return Zi(e28).os().next(function(e29) {
        return t6.ko(e29, 18e5).map(function(t10) {
          return t10.clientId;
        });
      });
    });
  }, Object.defineProperty(t3.prototype, "Ir", {
    get: function() {
      return this.oo;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.Wo = function(t6) {
    return Si.Ri(t6, this.Kt, this.Ii, this.mi);
  }, t3.prototype.Cr = function() {
    return this.wo;
  }, t3.prototype.kr = function() {
    return this.Eo;
  }, t3.prototype.jo = function() {
    return this.Ii;
  }, t3.prototype.Go = function() {
    return this.To;
  }, t3.prototype.runTransaction = function(t6, e28, n3) {
    var r3 = this;
    E("IndexedDbPersistence", "Starting transaction:", t6);
    var i, o3 = e28 === "readonly" ? "readonly" : "readwrite";
    return this.fo.runTransaction(t6, o3, $r, function(o6) {
      return i = new Xr(o6, r3.ro ? r3.ro.next() : $.U), e28 === "readwrite-primary" ? r3.bo(i).next(function(t10) {
        return !!t10 || r3.So(i);
      }).next(function(e29) {
        if (!e29)
          throw T("Failed to obtain primary lease for action '" + t6 + "'."), r3.isPrimary = false, r3.no.vo(function() {
            return r3.lo(false);
          }), new M(V.FAILED_PRECONDITION, Dr);
        return n3(i);
      }).next(function(t10) {
        return r3.Co(i).next(function() {
          return t10;
        });
      }) : r3.zo(i).next(function() {
        return n3(i);
      });
    }).then(function(t10) {
      return i.bs(), t10;
    });
  }, t3.prototype.zo = function(t6) {
    var e28 = this;
    return Xi(t6).get(Vr.key).next(function(t10) {
      if (t10 !== null && e28.Oo(t10.leaseTimestampMs, 5e3) && !e28.Lo(t10.ownerId) && !e28.xo(t10) && !(e28.io || e28.allowTabSynchronization && t10.allowTabSynchronization))
        throw new M(V.FAILED_PRECONDITION, Yi);
    });
  }, t3.prototype.Co = function(t6) {
    var e28 = new Vr(this.clientId, this.allowTabSynchronization, Date.now());
    return Xi(t6).put(Vr.key, e28);
  }, t3.Wn = function() {
    return gr.Wn();
  }, t3.prototype.Do = function(t6) {
    var e28 = this, n3 = Xi(t6);
    return n3.get(Vr.key).next(function(t10) {
      return e28.xo(t10) ? (E("IndexedDbPersistence", "Releasing primary lease."), n3.delete(Vr.key)) : yr.resolve();
    });
  }, t3.prototype.Oo = function(t6, e28) {
    var n3 = Date.now();
    return !(t6 < n3 - e28 || t6 > n3 && (T("Detected an update time that is in the future: " + t6 + " > " + n3), 1));
  }, t3.prototype.Ao = function() {
    var t6 = this;
    this.document !== null && typeof this.document.addEventListener == "function" && (this.ao = function() {
      t6.no.ys(function() {
        return t6.inForeground = t6.document.visibilityState === "visible", t6.mo();
      });
    }, this.document.addEventListener("visibilitychange", this.ao), this.inForeground = this.document.visibilityState === "visible");
  }, t3.prototype.qo = function() {
    this.ao && (this.document.removeEventListener("visibilitychange", this.ao), this.ao = null);
  }, t3.prototype.Ro = function() {
    var t6, e28 = this;
    typeof ((t6 = this.window) === null || t6 === void 0 ? void 0 : t6.addEventListener) == "function" && (this.co = function() {
      e28.Bo(), e28.no.ys(function() {
        return e28.$o();
      });
    }, this.window.addEventListener("unload", this.co));
  }, t3.prototype.Uo = function() {
    this.co && (this.window.removeEventListener("unload", this.co), this.co = null);
  }, t3.prototype.Lo = function(t6) {
    var e28;
    try {
      var n3 = ((e28 = this.Io) === null || e28 === void 0 ? void 0 : e28.getItem(this.Mo(t6))) !== null;
      return E("IndexedDbPersistence", "Client '" + t6 + "' " + (n3 ? "is" : "is not") + " zombied in LocalStorage"), n3;
    } catch (t10) {
      return T("IndexedDbPersistence", "Failed to get zombied client id.", t10), false;
    }
  }, t3.prototype.Bo = function() {
    if (this.Io)
      try {
        this.Io.setItem(this.Mo(this.clientId), String(Date.now()));
      } catch (t6) {
        T("Failed to set zombie client id.", t6);
      }
  }, t3.prototype.Qo = function() {
    if (this.Io)
      try {
        this.Io.removeItem(this.Mo(this.clientId));
      } catch (t6) {
      }
  }, t3.prototype.Mo = function(t6) {
    return "firestore_zombie_" + this.persistenceKey + "_" + t6;
  }, t3;
}();
function Xi(t3) {
  return Zr(t3, Vr.store);
}
function Zi(t3) {
  return Zr(t3, Wr.store);
}
function to$1(t3, e28) {
  var n3 = t3.projectId;
  return t3.m || (n3 += "." + t3.database), "firestore/" + e28 + "/" + n3 + "/";
}
var eo = function() {
  function t3(t6, e28, n3) {
    this.Eo = t6, this.Ho = e28, this.Ii = n3;
  }
  return t3.prototype.Jo = function(t6, e28) {
    var n3 = this;
    return this.Ho.Si(t6, e28).next(function(r3) {
      return n3.Yo(t6, e28, r3);
    });
  }, t3.prototype.Yo = function(t6, e28, n3) {
    return this.Eo.di(t6, e28).next(function(t10) {
      for (var r3 = 0, i = n3; r3 < i.length; r3++) {
        t10 = i[r3].Ns(e28, t10);
      }
      return t10;
    });
  }, t3.prototype.Xo = function(t6, e28, n3) {
    var r3 = vn();
    return e28.forEach(function(t10, e29) {
      for (var i = 0, o3 = n3; i < o3.length; i++) {
        e29 = o3[i].Ns(t10, e29);
      }
      r3 = r3.Ht(t10, e29);
    }), r3;
  }, t3.prototype.Zo = function(t6, e28) {
    var n3 = this;
    return this.Eo.getEntries(t6, e28).next(function(e29) {
      return n3.tc(t6, e29);
    });
  }, t3.prototype.tc = function(t6, e28) {
    var n3 = this;
    return this.Ho.Di(t6, e28).next(function(r3) {
      var i = n3.Xo(t6, e28, r3), o3 = dn();
      return i.forEach(function(t10, e29) {
        e29 || (e29 = new Mt(t10, Z.min())), o3 = o3.Ht(t10, e29);
      }), o3;
    });
  }, t3.prototype.jr = function(t6, e28, n3) {
    return function(t10) {
      return it.Et(t10.path) && t10.collectionGroup === null && t10.filters.length === 0;
    }(e28) ? this.ec(t6, e28.path) : le(e28) ? this.nc(t6, e28, n3) : this.sc(t6, e28, n3);
  }, t3.prototype.ec = function(t6, e28) {
    return this.Jo(t6, new it(e28)).next(function(t10) {
      var e29 = mn();
      return t10 instanceof Vt && (e29 = e29.Ht(t10.key, t10)), e29;
    });
  }, t3.prototype.nc = function(t6, e28, n3) {
    var r3 = this, i = e28.collectionGroup, o3 = mn();
    return this.Ii.Ks(t6, i).next(function(u3) {
      return yr.forEach(u3, function(u6) {
        var s3 = function(t10, e29) {
          return new oe(e29, null, t10.Nt.slice(), t10.filters.slice(), t10.limit, t10.limitType, t10.startAt, t10.endAt);
        }(e28, u6.child(i));
        return r3.sc(t6, s3, n3).next(function(t10) {
          t10.forEach(function(t11, e29) {
            o3 = o3.Ht(t11, e29);
          });
        });
      }).next(function() {
        return o3;
      });
    });
  }, t3.prototype.sc = function(t6, e28, n3) {
    var r3, i, o3 = this;
    return this.Eo.jr(t6, e28, n3).next(function(n6) {
      return r3 = n6, o3.Ho.xi(t6, e28);
    }).next(function(e29) {
      return i = e29, o3.ic(t6, i, r3).next(function(t10) {
        r3 = t10;
        for (var e30 = 0, n6 = i; e30 < n6.length; e30++)
          for (var o6 = n6[e30], u3 = 0, s3 = o6.mutations; u3 < s3.length; u3++) {
            var a3 = s3[u3], c3 = a3.key, f3 = r3.get(c3), h3 = Be(a3, f3, f3, o6.Ds);
            r3 = h3 instanceof Vt ? r3.Ht(c3, h3) : r3.remove(c3);
          }
      });
    }).next(function() {
      return r3.forEach(function(t10, n6) {
        we(e28, n6) || (r3 = r3.remove(t10));
      }), r3;
    });
  }, t3.prototype.ic = function(t6, e28, n3) {
    for (var r3 = In(), i = 0, o3 = e28; i < o3.length; i++)
      for (var u3 = 0, s3 = o3[i].mutations; u3 < s3.length; u3++) {
        var a3 = s3[u3];
        a3 instanceof Qe && n3.get(a3.key) === null && (r3 = r3.add(a3.key));
      }
    var c3 = n3;
    return this.Eo.getEntries(t6, r3).next(function(t10) {
      return t10.forEach(function(t11, e29) {
        e29 !== null && e29 instanceof Vt && (c3 = c3.Ht(t11, e29));
      }), c3;
    });
  }, t3;
}(), no = function() {
  function t3(t6, e28, n3, r3) {
    this.targetId = t6, this.fromCache = e28, this.rc = n3, this.oc = r3;
  }
  return t3.cc = function(e28, n3) {
    for (var r3 = In(), i = In(), o3 = 0, u3 = n3.docChanges; o3 < u3.length; o3++) {
      var s3 = u3[o3];
      switch (s3.type) {
        case 0:
          r3 = r3.add(s3.doc.key);
          break;
        case 1:
          i = i.add(s3.doc.key);
      }
    }
    return new t3(e28, n3.fromCache, r3, i);
  }, t3;
}(), ro = function() {
  function t3() {
  }
  return t3.prototype.ac = function(t6) {
    this.uc = t6;
  }, t3.prototype.jr = function(t6, n3, r3, i) {
    var o3 = this;
    return function(t10) {
      return t10.filters.length === 0 && t10.limit === null && t10.startAt == null && t10.endAt == null && (t10.Nt.length === 0 || t10.Nt.length === 1 && t10.Nt[0].field.ht());
    }(n3) || r3.isEqual(Z.min()) ? this.hc(t6, n3) : this.uc.Zo(t6, i).next(function(u3) {
      var s3 = o3.lc(n3, u3);
      return (ae(n3) || ce(n3)) && o3._c(n3.limitType, s3, i, r3) ? o3.hc(t6, n3) : (_() <= LogLevel.DEBUG && E("QueryEngine", "Re-using previous result from %s to execute query: %s", r3.toString(), ge(n3)), o3.uc.jr(t6, n3, r3).next(function(t10) {
        return s3.forEach(function(e28) {
          t10 = t10.Ht(e28.key, e28);
        }), t10;
      }));
    });
  }, t3.prototype.lc = function(t6, e28) {
    var n3 = new hn(be(t6));
    return e28.forEach(function(e29, r3) {
      r3 instanceof Vt && we(t6, r3) && (n3 = n3.add(r3));
    }), n3;
  }, t3.prototype._c = function(t6, e28, n3, r3) {
    if (n3.size !== e28.size)
      return true;
    var i = t6 === "F" ? e28.last() : e28.first();
    return !!i && (i.hasPendingWrites || i.version.u(r3) > 0);
  }, t3.prototype.hc = function(t6, n3) {
    return _() <= LogLevel.DEBUG && E("QueryEngine", "Using full collection scan to execute query:", ge(n3)), this.uc.jr(t6, n3, Z.min());
  }, t3;
}(), io = function() {
  function t3(t6, e28, n3, r3) {
    this.persistence = t6, this.fc = e28, this.Kt = r3, this.dc = new an(P$1), this.wc = new Ei(function(t10) {
      return jt(t10);
    }, zt), this.Ec = Z.min(), this.Ho = t6.Wo(n3), this.Tc = t6.kr(), this.wo = t6.Cr(), this.Ic = new eo(this.Tc, this.Ho, this.persistence.jo()), this.To = t6.Go(), this.fc.ac(this.Ic);
  }
  return t3.prototype.Ar = function(t6) {
    var e28 = this;
    return this.persistence.runTransaction("Collect garbage", "readwrite-primary", function(n3) {
      return t6.br(n3, e28.dc);
    });
  }, t3;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function oo(t3, e28, n3, r3) {
  return new io(t3, e28, n3, r3);
}
function uo(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    var n3, r3, i, o3;
    return __generator(this, function(u3) {
      switch (u3.label) {
        case 0:
          return n3 = D(t3), r3 = n3.Ho, i = n3.Ic, [4, n3.persistence.runTransaction("Handle user change", "readonly", function(t6) {
            var o6;
            return n3.Ho.vi(t6).next(function(u6) {
              return o6 = u6, r3 = n3.persistence.Wo(e28), i = new eo(n3.Tc, r3, n3.persistence.jo()), r3.vi(t6);
            }).next(function(e29) {
              for (var n6 = [], r6 = [], u6 = In(), s3 = 0, a3 = o6; s3 < a3.length; s3++) {
                var c3 = a3[s3];
                n6.push(c3.batchId);
                for (var f3 = 0, h3 = c3.mutations; f3 < h3.length; f3++) {
                  var l3 = h3[f3];
                  u6 = u6.add(l3.key);
                }
              }
              for (var p3 = 0, d3 = e29; p3 < d3.length; p3++) {
                var v3 = d3[p3];
                r6.push(v3.batchId);
                for (var y3 = 0, m3 = v3.mutations; y3 < m3.length; y3++) {
                  var g3 = m3[y3];
                  u6 = u6.add(g3.key);
                }
              }
              return i.Zo(t6, u6).next(function(t10) {
                return {
                  mc: t10,
                  Ac: n6,
                  Rc: r6
                };
              });
            });
          })];
        case 1:
          return o3 = u3.sent(), [2, (n3.Ho = r3, n3.Ic = i, n3.fc.ac(n3.Ic), o3)];
      }
    });
  });
}
function so(t3, e28) {
  var n3 = D(t3);
  return n3.persistence.runTransaction("Acknowledge batch", "readwrite-primary", function(t6) {
    var r3 = e28.batch.keys(), i = n3.Tc.Or({
      Gr: true
    });
    return function(t10, e29, n6, r6) {
      var i3 = n6.batch, o3 = i3.keys(), u3 = yr.resolve();
      return o3.forEach(function(t11) {
        u3 = u3.next(function() {
          return r6.di(e29, t11);
        }).next(function(e30) {
          var o6 = e30, u6 = n6.ks.get(t11);
          x(u6 !== null), (!o6 || o6.version.u(u6) < 0) && ((o6 = i3.Cs(t11, o6, n6)) && r6.hi(o6, n6.Os));
        });
      }), u3.next(function() {
        return t10.Ho.Ni(e29, i3);
      });
    }(n3, t6, e28, i).next(function() {
      return i.apply(t6);
    }).next(function() {
      return n3.Ho.ki(t6);
    }).next(function() {
      return n3.Ic.Zo(t6, r3);
    });
  });
}
function ao(t3) {
  var e28 = D(t3);
  return e28.persistence.runTransaction("Get last remote snapshot version", "readonly", function(t6) {
    return e28.wo.Wi(t6);
  });
}
function co(t3, e28) {
  var n3 = D(t3), r3 = e28.Mt, i = n3.dc;
  return n3.persistence.runTransaction("Apply remote event", "readwrite-primary", function(t6) {
    var o3 = n3.Tc.Or({
      Gr: true
    });
    i = n3.dc;
    var u3 = [];
    e28.Oe.forEach(function(e29, o6) {
      var s4 = i.get(o6);
      if (s4) {
        u3.push(n3.wo.rr(t6, e29.Ke, o6).next(function() {
          return n3.wo.sr(t6, e29.Ue, o6);
        }));
        var a6 = e29.resumeToken;
        if (a6.o() > 0) {
          var c3 = s4.$t(a6, r3).Lt(t6.Ss);
          i = i.Ht(o6, c3), function(t10, e30, n6) {
            return x(e30.resumeToken.o() > 0), t10.resumeToken.o() === 0 || (e30.Mt.j() - t10.Mt.j() >= 3e8 || n6.Ue.size + n6.Qe.size + n6.Ke.size > 0);
          }(s4, c3, e29) && u3.push(n3.wo.Yi(t6, c3));
        }
      }
    });
    var s3 = dn();
    if (e28.Me.forEach(function(r6, i3) {
      e28.Le.has(r6) && u3.push(n3.persistence.mi.Mr(t6, r6));
    }), u3.push(fo(t6, o3, e28.Me, r3, void 0).next(function(t10) {
      s3 = t10;
    })), !r3.isEqual(Z.min())) {
      var a3 = n3.wo.Wi(t6).next(function(e29) {
        return n3.wo.Gi(t6, t6.Ss, r3);
      });
      u3.push(a3);
    }
    return yr.$n(u3).next(function() {
      return o3.apply(t6);
    }).next(function() {
      return n3.Ic.tc(t6, s3);
    });
  }).then(function(t6) {
    return n3.dc = i, t6;
  });
}
function fo(t3, e28, n3, r3, i) {
  var o3 = In();
  return n3.forEach(function(t6) {
    return o3 = o3.add(t6);
  }), e28.getEntries(t3, o3).next(function(t6) {
    var o6 = dn();
    return n3.forEach(function(n6, u3) {
      var s3 = t6.get(n6), a3 = (i == null ? void 0 : i.get(n6)) || r3;
      u3 instanceof Mt && u3.version.isEqual(Z.min()) ? (e28.fi(n6, a3), o6 = o6.Ht(n6, u3)) : s3 == null || u3.version.u(s3.version) > 0 || u3.version.u(s3.version) === 0 && s3.hasPendingWrites ? (e28.hi(u3, a3), o6 = o6.Ht(n6, u3)) : E("LocalStore", "Ignoring outdated watch update for ", n6, ". Current version:", s3.version, " Watch version:", u3.version);
    }), o6;
  });
}
function ho(t3, e28) {
  var n3 = D(t3);
  return n3.persistence.runTransaction("Get next mutation batch", "readonly", function(t6) {
    return e28 === void 0 && (e28 = -1), n3.Ho.pi(t6, e28);
  });
}
function lo(t3, e28) {
  var n3 = D(t3);
  return n3.persistence.runTransaction("Allocate target", "readwrite", function(t6) {
    var r3;
    return n3.wo.nr(t6, e28).next(function(i) {
      return i ? (r3 = i, yr.resolve(r3)) : n3.wo.Ui(t6).next(function(i3) {
        return r3 = new _e(e28, i3, 0, t6.Ss), n3.wo.zi(t6, r3).next(function() {
          return r3;
        });
      });
    });
  }).then(function(t6) {
    var r3 = n3.dc.get(t6.targetId);
    return (r3 === null || t6.Mt.u(r3.Mt) > 0) && (n3.dc = n3.dc.Ht(t6.targetId, t6), n3.wc.set(e28, t6.targetId)), t6;
  });
}
function po(t3, e28, n3) {
  return __awaiter(this, void 0, void 0, function() {
    var r3, i, o3, u3;
    return __generator(this, function(s3) {
      switch (s3.label) {
        case 0:
          r3 = D(t3), i = r3.dc.get(e28), o3 = n3 ? "readwrite" : "readwrite-primary", s3.label = 1;
        case 1:
          return s3.trys.push([1, 4, , 5]), n3 ? [3, 3] : [4, r3.persistence.runTransaction("Release target", o3, function(t6) {
            return r3.persistence.mi.removeTarget(t6, i);
          })];
        case 2:
          s3.sent(), s3.label = 3;
        case 3:
          return [3, 5];
        case 4:
          if (!Ir(u3 = s3.sent()))
            throw u3;
          return E("LocalStore", "Failed to update sequence numbers for target " + e28 + ": " + u3), [3, 5];
        case 5:
          return r3.dc = r3.dc.remove(e28), r3.wc.delete(i.target), [2];
      }
    });
  });
}
function vo(t3, e28, n3) {
  var r3 = D(t3), i = Z.min(), o3 = In();
  return r3.persistence.runTransaction("Execute query", "readonly", function(t6) {
    return function(t10, e29, n6) {
      var r6 = D(t10), i3 = r6.wc.get(n6);
      return i3 !== void 0 ? yr.resolve(r6.dc.get(i3)) : r6.wo.nr(e29, n6);
    }(r3, t6, de(e28)).next(function(e29) {
      if (e29)
        return i = e29.lastLimboFreeSnapshotVersion, r3.wo.ar(t6, e29.targetId).next(function(t10) {
          o3 = t10;
        });
    }).next(function() {
      return r3.fc.jr(t6, e28, n3 ? i : Z.min(), n3 ? o3 : In());
    }).next(function(t10) {
      return {
        documents: t10,
        Pc: o3
      };
    });
  });
}
function yo(t3, e28) {
  var n3 = D(t3), r3 = D(n3.wo), i = n3.dc.get(e28);
  return i ? Promise.resolve(i.target) : n3.persistence.runTransaction("Get target data", "readonly", function(t6) {
    return r3.Dn(t6, e28).next(function(t10) {
      return t10 ? t10.target : null;
    });
  });
}
function mo(t3) {
  var e28 = D(t3);
  return e28.persistence.runTransaction("Get new document changes", "readonly", function(t6) {
    return function(t10, e29, n3) {
      var r3 = D(t10), i = dn(), o3 = oi(n3), u3 = Hi(e29), s3 = IDBKeyRange.lowerBound(o3, true);
      return u3.ls({
        index: zr.readTimeIndex,
        range: s3
      }, function(t11, e30) {
        var n6 = ri(r3.Kt, e30);
        i = i.Ht(n6.key, n6), o3 = e30.readTime;
      }).next(function() {
        return {
          gs: i,
          readTime: ui(o3)
        };
      });
    }(e28.Tc, t6, e28.Ec);
  }).then(function(t6) {
    var n3 = t6.gs, r3 = t6.readTime;
    return e28.Ec = r3, n3;
  });
}
function go(t3) {
  return __awaiter(this, void 0, void 0, function() {
    var e28;
    return __generator(this, function(n3) {
      return [2, (e28 = D(t3)).persistence.runTransaction("Synchronize last document change read time", "readonly", function(t6) {
        return function(t10) {
          var e29 = Hi(t10), n6 = Z.min();
          return e29.ls({
            index: zr.readTimeIndex,
            reverse: true
          }, function(t11, e30, r3) {
            e30.readTime && (n6 = ui(e30.readTime)), r3.done();
          }).next(function() {
            return n6;
          });
        }(t6);
      }).then(function(t6) {
        e28.Ec = t6;
      })];
    });
  });
}
function wo(t3, e28, n3, r3) {
  return __awaiter(this, void 0, void 0, function() {
    var i, o3, u3, s3, a3, c3, f3, h3, l3, p3;
    return __generator(this, function(d3) {
      switch (d3.label) {
        case 0:
          for (i = D(t3), o3 = In(), u3 = dn(), s3 = wn(), a3 = 0, c3 = n3; a3 < c3.length; a3++)
            f3 = c3[a3], h3 = e28.yc(f3.metadata.name), f3.document && (o3 = o3.add(h3)), u3 = u3.Ht(h3, e28.gc(f3)), s3 = s3.Ht(h3, e28.Vc(f3.metadata.readTime));
          return l3 = i.Tc.Or({
            Gr: true
          }), [4, lo(i, function(t6) {
            return de(se(et.ct("__bundle__/docs/" + t6)));
          }(r3))];
        case 1:
          return p3 = d3.sent(), [2, i.persistence.runTransaction("Apply bundle documents", "readwrite", function(t6) {
            return fo(t6, l3, u3, Z.min(), s3).next(function(e29) {
              return l3.apply(t6), e29;
            }).next(function(e29) {
              return i.wo.Zi(t6, p3.targetId).next(function() {
                return i.wo.sr(t6, o3, p3.targetId);
              }).next(function() {
                return i.Ic.tc(t6, e29);
              });
            });
          })];
      }
    });
  });
}
function bo(t3, e28, n3) {
  return n3 === void 0 && (n3 = In()), __awaiter(this, void 0, void 0, function() {
    var r3, i;
    return __generator(this, function(o3) {
      switch (o3.label) {
        case 0:
          return [4, lo(t3, de(li(e28.bundledQuery)))];
        case 1:
          return r3 = o3.sent(), [2, (i = D(t3)).persistence.runTransaction("Save named query", "readwrite", function(t6) {
            var o6 = zn(e28.readTime);
            if (r3.Mt.u(o6) >= 0)
              return i.To.qs(t6, e28);
            var u3 = r3.$t(R.h, o6);
            return i.dc = i.dc.Ht(u3.targetId, u3), i.wo.Yi(t6, u3).next(function() {
              return i.wo.Zi(t6, r3.targetId);
            }).next(function() {
              return i.wo.sr(t6, n3, r3.targetId);
            }).next(function() {
              return i.To.qs(t6, e28);
            });
          })];
      }
    });
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Io = function() {
  function t3(t6) {
    this.Kt = t6, this.bc = new Map(), this.vc = new Map();
  }
  return t3.prototype.Ls = function(t6, e28) {
    return yr.resolve(this.bc.get(e28));
  }, t3.prototype.$s = function(t6, e28) {
    var n3;
    return this.bc.set(e28.id, {
      id: (n3 = e28).id,
      version: n3.version,
      createTime: zn(n3.createTime)
    }), yr.resolve();
  }, t3.prototype.Bs = function(t6, e28) {
    return yr.resolve(this.vc.get(e28));
  }, t3.prototype.qs = function(t6, e28) {
    return this.vc.set(e28.name, function(t10) {
      return {
        name: t10.name,
        query: li(t10.bundledQuery),
        readTime: zn(t10.readTime)
      };
    }(e28)), yr.resolve();
  }, t3;
}(), _o = function() {
  function t3() {
    this.Sc = new hn(Eo.Dc), this.Cc = new hn(Eo.xc);
  }
  return t3.prototype.nt = function() {
    return this.Sc.nt();
  }, t3.prototype.ir = function(t6, e28) {
    var n3 = new Eo(t6, e28);
    this.Sc = this.Sc.add(n3), this.Cc = this.Cc.add(n3);
  }, t3.prototype.Nc = function(t6, e28) {
    var n3 = this;
    t6.forEach(function(t10) {
      return n3.ir(t10, e28);
    });
  }, t3.prototype.cr = function(t6, e28) {
    this.Fc(new Eo(t6, e28));
  }, t3.prototype.Oc = function(t6, e28) {
    var n3 = this;
    t6.forEach(function(t10) {
      return n3.cr(t10, e28);
    });
  }, t3.prototype.kc = function(t6) {
    var e28 = this, n3 = new it(new et([])), r3 = new Eo(n3, t6), i = new Eo(n3, t6 + 1), o3 = [];
    return this.Cc.Ae([r3, i], function(t10) {
      e28.Fc(t10), o3.push(t10.key);
    }), o3;
  }, t3.prototype.Mc = function() {
    var t6 = this;
    this.Sc.forEach(function(e28) {
      return t6.Fc(e28);
    });
  }, t3.prototype.Fc = function(t6) {
    this.Sc = this.Sc.delete(t6), this.Cc = this.Cc.delete(t6);
  }, t3.prototype.Lc = function(t6) {
    var e28 = new it(new et([])), n3 = new Eo(e28, t6), r3 = new Eo(e28, t6 + 1), i = In();
    return this.Cc.Ae([n3, r3], function(t10) {
      i = i.add(t10.key);
    }), i;
  }, t3.prototype.Mi = function(t6) {
    var e28 = new Eo(t6, 0), n3 = this.Sc.Pe(e28);
    return n3 !== null && t6.isEqual(n3.key);
  }, t3;
}(), Eo = function() {
  function t3(t6, e28) {
    this.key = t6, this.$c = e28;
  }
  return t3.Dc = function(t6, e28) {
    return it.J(t6.key, e28.key) || P$1(t6.$c, e28.$c);
  }, t3.xc = function(t6, e28) {
    return P$1(t6.$c, e28.$c) || it.J(t6.key, e28.key);
  }, t3;
}(), To = function() {
  function t3(t6, e28) {
    this.Ii = t6, this.mi = e28, this.Ho = [], this.Bc = 1, this.qc = new hn(Eo.Dc);
  }
  return t3.prototype.Pi = function(t6) {
    return yr.resolve(this.Ho.length === 0);
  }, t3.prototype.yi = function(t6, e28, n3, r3) {
    var i = this.Bc;
    this.Bc++, this.Ho.length > 0 && this.Ho[this.Ho.length - 1];
    var o3 = new ti(i, e28, n3, r3);
    this.Ho.push(o3);
    for (var u3 = 0, s3 = r3; u3 < s3.length; u3++) {
      var a3 = s3[u3];
      this.qc = this.qc.add(new Eo(a3.key, i)), this.Ii.Qs(t6, a3.key.path.Z());
    }
    return yr.resolve(o3);
  }, t3.prototype.gi = function(t6, e28) {
    return yr.resolve(this.Uc(e28));
  }, t3.prototype.pi = function(t6, e28) {
    var n3 = e28 + 1, r3 = this.Qc(n3), i = r3 < 0 ? 0 : r3;
    return yr.resolve(this.Ho.length > i ? this.Ho[i] : null);
  }, t3.prototype.bi = function() {
    return yr.resolve(this.Ho.length === 0 ? -1 : this.Bc - 1);
  }, t3.prototype.vi = function(t6) {
    return yr.resolve(this.Ho.slice());
  }, t3.prototype.Si = function(t6, e28) {
    var n3 = this, r3 = new Eo(e28, 0), i = new Eo(e28, Number.POSITIVE_INFINITY), o3 = [];
    return this.qc.Ae([r3, i], function(t10) {
      var e29 = n3.Uc(t10.$c);
      o3.push(e29);
    }), yr.resolve(o3);
  }, t3.prototype.Di = function(t6, e28) {
    var n3 = this, r3 = new hn(P$1);
    return e28.forEach(function(t10) {
      var e29 = new Eo(t10, 0), i = new Eo(t10, Number.POSITIVE_INFINITY);
      n3.qc.Ae([e29, i], function(t11) {
        r3 = r3.add(t11.$c);
      });
    }), yr.resolve(this.Kc(r3));
  }, t3.prototype.xi = function(t6, e28) {
    var n3 = e28.path, r3 = n3.length + 1, i = n3;
    it.Et(i) || (i = i.child(""));
    var o3 = new Eo(new it(i), 0), u3 = new hn(P$1);
    return this.qc.Re(function(t10) {
      var e29 = t10.key.path;
      return !!n3.st(e29) && (e29.length === r3 && (u3 = u3.add(t10.$c)), true);
    }, o3), yr.resolve(this.Kc(u3));
  }, t3.prototype.Kc = function(t6) {
    var e28 = this, n3 = [];
    return t6.forEach(function(t10) {
      var r3 = e28.Uc(t10);
      r3 !== null && n3.push(r3);
    }), n3;
  }, t3.prototype.Ni = function(t6, e28) {
    var n3 = this;
    x(this.Wc(e28.batchId, "removed") === 0), this.Ho.shift();
    var r3 = this.qc;
    return yr.forEach(e28.mutations, function(i) {
      var o3 = new Eo(i.key, e28.batchId);
      return r3 = r3.delete(o3), n3.mi.Oi(t6, i.key);
    }).next(function() {
      n3.qc = r3;
    });
  }, t3.prototype.Fi = function(t6) {
  }, t3.prototype.Mi = function(t6, e28) {
    var n3 = new Eo(e28, 0), r3 = this.qc.Pe(n3);
    return yr.resolve(e28.isEqual(r3 && r3.key));
  }, t3.prototype.ki = function(t6) {
    return this.Ho.length, yr.resolve();
  }, t3.prototype.Wc = function(t6, e28) {
    return this.Qc(t6);
  }, t3.prototype.Qc = function(t6) {
    return this.Ho.length === 0 ? 0 : t6 - this.Ho[0].batchId;
  }, t3.prototype.Uc = function(t6) {
    var e28 = this.Qc(t6);
    return e28 < 0 || e28 >= this.Ho.length ? null : this.Ho[e28];
  }, t3;
}(), No = function() {
  function t3(t6, e28) {
    this.Ii = t6, this.jc = e28, this.docs = new an(it.J), this.size = 0;
  }
  return t3.prototype.hi = function(t6, e28, n3) {
    var r3 = e28.key, i = this.docs.get(r3), o3 = i ? i.size : 0, u3 = this.jc(e28);
    return this.docs = this.docs.Ht(r3, {
      _i: e28,
      size: u3,
      readTime: n3
    }), this.size += u3 - o3, this.Ii.Qs(t6, r3.path.Z());
  }, t3.prototype.fi = function(t6) {
    var e28 = this.docs.get(t6);
    e28 && (this.docs = this.docs.remove(t6), this.size -= e28.size);
  }, t3.prototype.di = function(t6, e28) {
    var n3 = this.docs.get(e28);
    return yr.resolve(n3 ? n3._i : null);
  }, t3.prototype.getEntries = function(t6, e28) {
    var n3 = this, r3 = vn();
    return e28.forEach(function(t10) {
      var e29 = n3.docs.get(t10);
      r3 = r3.Ht(t10, e29 ? e29._i : null);
    }), yr.resolve(r3);
  }, t3.prototype.jr = function(t6, e28, n3) {
    for (var r3 = mn(), i = new it(e28.path.child("")), o3 = this.docs.ne(i); o3.ae(); ) {
      var u3 = o3.ce(), s3 = u3.key, a3 = u3.value, c3 = a3._i, f3 = a3.readTime;
      if (!e28.path.st(s3.path))
        break;
      f3.u(n3) <= 0 || c3 instanceof Vt && we(e28, c3) && (r3 = r3.Ht(c3.key, c3));
    }
    return yr.resolve(r3);
  }, t3.prototype.Gc = function(t6, e28) {
    return yr.forEach(this.docs, function(t10) {
      return e28(t10);
    });
  }, t3.prototype.Or = function(t6) {
    return new Ao(this);
  }, t3.prototype.Lr = function(t6) {
    return yr.resolve(this.size);
  }, t3;
}(), Ao = function(t3) {
  function e28(e29) {
    var n3 = this;
    return (n3 = t3.call(this) || this).zr = e29, n3;
  }
  return __extends$1(e28, t3), e28.prototype.Ti = function(t6) {
    var e29 = this, n3 = [];
    return this.ci.forEach(function(r3, i) {
      i && i._i ? n3.push(e29.zr.hi(t6, i._i, e29.ui(r3))) : e29.zr.fi(r3);
    }), yr.$n(n3);
  }, e28.prototype.wi = function(t6, e29) {
    return this.zr.di(t6, e29);
  }, e28.prototype.Ei = function(t6, e29) {
    return this.zr.getEntries(t6, e29);
  }, e28;
}(Ti), So = function() {
  function t3(t6) {
    this.persistence = t6, this.zc = new Ei(function(t10) {
      return jt(t10);
    }, zt), this.lastRemoteSnapshotVersion = Z.min(), this.highestTargetId = 0, this.Hc = 0, this.Jc = new _o(), this.targetCount = 0, this.Yc = Pi.Bi();
  }
  return t3.prototype.mn = function(t6, e28) {
    return this.zc.forEach(function(t10, n3) {
      return e28(n3);
    }), yr.resolve();
  }, t3.prototype.Wi = function(t6) {
    return yr.resolve(this.lastRemoteSnapshotVersion);
  }, t3.prototype.ji = function(t6) {
    return yr.resolve(this.Hc);
  }, t3.prototype.Ui = function(t6) {
    return this.highestTargetId = this.Yc.next(), yr.resolve(this.highestTargetId);
  }, t3.prototype.Gi = function(t6, e28, n3) {
    return n3 && (this.lastRemoteSnapshotVersion = n3), e28 > this.Hc && (this.Hc = e28), yr.resolve();
  }, t3.prototype.Hi = function(t6) {
    this.zc.set(t6.target, t6);
    var e28 = t6.targetId;
    e28 > this.highestTargetId && (this.Yc = new Pi(e28), this.highestTargetId = e28), t6.sequenceNumber > this.Hc && (this.Hc = t6.sequenceNumber);
  }, t3.prototype.zi = function(t6, e28) {
    return this.Hi(e28), this.targetCount += 1, yr.resolve();
  }, t3.prototype.Yi = function(t6, e28) {
    return this.Hi(e28), yr.resolve();
  }, t3.prototype.Xi = function(t6, e28) {
    return this.zc.delete(e28.target), this.Jc.kc(e28.targetId), this.targetCount -= 1, yr.resolve();
  }, t3.prototype.tr = function(t6, e28, n3) {
    var r3 = this, i = 0, o3 = [];
    return this.zc.forEach(function(u3, s3) {
      s3.sequenceNumber <= e28 && n3.get(s3.targetId) === null && (r3.zc.delete(u3), o3.push(r3.Zi(t6, s3.targetId)), i++);
    }), yr.$n(o3).next(function() {
      return i;
    });
  }, t3.prototype.er = function(t6) {
    return yr.resolve(this.targetCount);
  }, t3.prototype.nr = function(t6, e28) {
    var n3 = this.zc.get(e28) || null;
    return yr.resolve(n3);
  }, t3.prototype.sr = function(t6, e28, n3) {
    return this.Jc.Nc(e28, n3), yr.resolve();
  }, t3.prototype.rr = function(t6, e28, n3) {
    this.Jc.Oc(e28, n3);
    var r3 = this.persistence.mi, i = [];
    return r3 && e28.forEach(function(e29) {
      i.push(r3.Oi(t6, e29));
    }), yr.$n(i);
  }, t3.prototype.Zi = function(t6, e28) {
    return this.Jc.kc(e28), yr.resolve();
  }, t3.prototype.ar = function(t6, e28) {
    var n3 = this.Jc.Lc(e28);
    return yr.resolve(n3);
  }, t3.prototype.Mi = function(t6, e28) {
    return yr.resolve(this.Jc.Mi(e28));
  }, t3;
}(), xo = function() {
  function t3(t6, e28) {
    var n3 = this;
    this.Xc = {}, this.ro = new $(0), this.oo = false, this.oo = true, this.mi = t6(this), this.wo = new So(this), this.Ii = new yi(), this.Eo = function(t10, e29) {
      return new No(t10, function(t11) {
        return n3.mi.Zc(t11);
      });
    }(this.Ii), this.Kt = new ni(e28), this.To = new Io(this.Kt);
  }
  return t3.prototype.start = function() {
    return Promise.resolve();
  }, t3.prototype.$o = function() {
    return this.oo = false, Promise.resolve();
  }, Object.defineProperty(t3.prototype, "Ir", {
    get: function() {
      return this.oo;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.Vo = function() {
  }, t3.prototype.po = function() {
  }, t3.prototype.jo = function() {
    return this.Ii;
  }, t3.prototype.Wo = function(t6) {
    var e28 = this.Xc[t6.R()];
    return e28 || (e28 = new To(this.Ii, this.mi), this.Xc[t6.R()] = e28), e28;
  }, t3.prototype.Cr = function() {
    return this.wo;
  }, t3.prototype.kr = function() {
    return this.Eo;
  }, t3.prototype.Go = function() {
    return this.To;
  }, t3.prototype.runTransaction = function(t6, e28, n3) {
    var r3 = this;
    E("MemoryPersistence", "Starting transaction:", t6);
    var i = new Do(this.ro.next());
    return this.mi.ta(), n3(i).next(function(t10) {
      return r3.mi.ea(i).next(function() {
        return t10;
      });
    }).Mn().then(function(t10) {
      return i.bs(), t10;
    });
  }, t3.prototype.na = function(t6, e28) {
    return yr.Bn(Object.values(this.Xc).map(function(n3) {
      return function() {
        return n3.Mi(t6, e28);
      };
    }));
  }, t3;
}(), Do = function(t3) {
  function e28(e29) {
    var n3 = this;
    return (n3 = t3.call(this) || this).Ss = e29, n3;
  }
  return __extends$1(e28, t3), e28;
}(kr), ko = function() {
  function t3(t6) {
    this.persistence = t6, this.sa = new _o(), this.ia = null;
  }
  return t3.ra = function(e28) {
    return new t3(e28);
  }, Object.defineProperty(t3.prototype, "oa", {
    get: function() {
      if (this.ia)
        return this.ia;
      throw S();
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.ir = function(t6, e28, n3) {
    return this.sa.ir(n3, e28), this.oa.delete(n3.toString()), yr.resolve();
  }, t3.prototype.cr = function(t6, e28, n3) {
    return this.sa.cr(n3, e28), this.oa.add(n3.toString()), yr.resolve();
  }, t3.prototype.Oi = function(t6, e28) {
    return this.oa.add(e28.toString()), yr.resolve();
  }, t3.prototype.removeTarget = function(t6, e28) {
    var n3 = this;
    this.sa.kc(e28.targetId).forEach(function(t10) {
      return n3.oa.add(t10.toString());
    });
    var r3 = this.persistence.Cr();
    return r3.ar(t6, e28.targetId).next(function(t10) {
      t10.forEach(function(t11) {
        return n3.oa.add(t11.toString());
      });
    }).next(function() {
      return r3.Xi(t6, e28);
    });
  }, t3.prototype.ta = function() {
    this.ia = new Set();
  }, t3.prototype.ea = function(t6) {
    var e28 = this, n3 = this.persistence.kr().Or();
    return yr.forEach(this.oa, function(r3) {
      var i = it.ft(r3);
      return e28.ca(t6, i).next(function(t10) {
        t10 || n3.fi(i);
      });
    }).next(function() {
      return e28.ia = null, n3.apply(t6);
    });
  }, t3.prototype.Mr = function(t6, e28) {
    var n3 = this;
    return this.ca(t6, e28).next(function(t10) {
      t10 ? n3.oa.delete(e28.toString()) : n3.oa.add(e28.toString());
    });
  }, t3.prototype.Zc = function(t6) {
    return 0;
  }, t3.prototype.ca = function(t6, e28) {
    var n3 = this;
    return yr.Bn([function() {
      return yr.resolve(n3.sa.Mi(e28));
    }, function() {
      return n3.persistence.Cr().Mi(t6, e28);
    }, function() {
      return n3.persistence.na(t6, e28);
    }]);
  }, t3;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Oo(t3, e28) {
  return "firestore_clients_" + t3 + "_" + e28;
}
function Po(t3, e28, n3) {
  var r3 = "firestore_mutations_" + t3 + "_" + n3;
  return e28.A() && (r3 += "_" + e28.uid), r3;
}
function Co(t3, e28) {
  return "firestore_targets_" + t3 + "_" + e28;
}
var Lo = function() {
  function t3(t6, e28, n3, r3) {
    this.user = t6, this.batchId = e28, this.state = n3, this.error = r3;
  }
  return t3.aa = function(e28, n3, r3) {
    var i = JSON.parse(r3), o3 = typeof i == "object" && ["pending", "acknowledged", "rejected"].indexOf(i.state) !== -1 && (i.error === void 0 || typeof i.error == "object"), u3 = void 0;
    return o3 && i.error && ((o3 = typeof i.error.message == "string" && typeof i.error.code == "string") && (u3 = new M(i.error.code, i.error.message))), o3 ? new t3(e28, n3, i.state, u3) : (T("SharedClientState", "Failed to parse mutation state for ID '" + n3 + "': " + r3), null);
  }, t3.prototype.ua = function() {
    var t6 = {
      state: this.state,
      updateTimeMs: Date.now()
    };
    return this.error && (t6.error = {
      code: this.error.code,
      message: this.error.message
    }), JSON.stringify(t6);
  }, t3;
}(), Ro = function() {
  function t3(t6, e28, n3) {
    this.targetId = t6, this.state = e28, this.error = n3;
  }
  return t3.aa = function(e28, n3) {
    var r3 = JSON.parse(n3), i = typeof r3 == "object" && ["not-current", "current", "rejected"].indexOf(r3.state) !== -1 && (r3.error === void 0 || typeof r3.error == "object"), o3 = void 0;
    return i && r3.error && ((i = typeof r3.error.message == "string" && typeof r3.error.code == "string") && (o3 = new M(r3.error.code, r3.error.message))), i ? new t3(e28, r3.state, o3) : (T("SharedClientState", "Failed to parse target state for ID '" + e28 + "': " + n3), null);
  }, t3.prototype.ua = function() {
    var t6 = {
      state: this.state,
      updateTimeMs: Date.now()
    };
    return this.error && (t6.error = {
      code: this.error.code,
      message: this.error.message
    }), JSON.stringify(t6);
  }, t3;
}(), Vo = function() {
  function t3(t6, e28) {
    this.clientId = t6, this.activeTargetIds = e28;
  }
  return t3.aa = function(e28, n3) {
    for (var r3 = JSON.parse(n3), i = typeof r3 == "object" && r3.activeTargetIds instanceof Array, o3 = En(), u3 = 0; i && u3 < r3.activeTargetIds.length; ++u3)
      i = gt(r3.activeTargetIds[u3]), o3 = o3.add(r3.activeTargetIds[u3]);
    return i ? new t3(e28, o3) : (T("SharedClientState", "Failed to parse client data for instance '" + e28 + "': " + n3), null);
  }, t3;
}(), Mo = function() {
  function t3(t6, e28) {
    this.clientId = t6, this.onlineState = e28;
  }
  return t3.aa = function(e28) {
    var n3 = JSON.parse(e28);
    return typeof n3 == "object" && ["Unknown", "Online", "Offline"].indexOf(n3.onlineState) !== -1 && typeof n3.clientId == "string" ? new t3(n3.clientId, n3.onlineState) : (T("SharedClientState", "Failed to parse online state: " + e28), null);
  }, t3;
}(), Uo = function() {
  function t3() {
    this.activeTargetIds = En();
  }
  return t3.prototype.ha = function(t6) {
    this.activeTargetIds = this.activeTargetIds.add(t6);
  }, t3.prototype.la = function(t6) {
    this.activeTargetIds = this.activeTargetIds.delete(t6);
  }, t3.prototype.ua = function() {
    var t6 = {
      activeTargetIds: this.activeTargetIds.rt(),
      updateTimeMs: Date.now()
    };
    return JSON.stringify(t6);
  }, t3;
}(), qo = function() {
  function t3(t6, e28, n3, r3, i) {
    this.window = t6, this.no = e28, this.persistenceKey = n3, this._a = r3, this.fa = null, this.da = null, this.L = null, this.wa = this.Ea.bind(this), this.Ta = new an(P$1), this.Ir = false, this.Ia = [];
    var o3 = n3.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    this.storage = this.window.localStorage, this.currentUser = i, this.ma = Oo(this.persistenceKey, this._a), this.Aa = function(t10) {
      return "firestore_sequence_number_" + t10;
    }(this.persistenceKey), this.Ta = this.Ta.Ht(this._a, new Uo()), this.Ra = new RegExp("^firestore_clients_" + o3 + "_([^_]*)$"), this.Pa = new RegExp("^firestore_mutations_" + o3 + "_(\\d+)(?:_(.*))?$"), this.ya = new RegExp("^firestore_targets_" + o3 + "_(\\d+)$"), this.ga = function(t10) {
      return "firestore_online_state_" + t10;
    }(this.persistenceKey), this.Va = function(t10) {
      return "firestore_bundle_loaded_" + t10;
    }(this.persistenceKey), this.window.addEventListener("storage", this.wa);
  }
  return t3.Wn = function(t6) {
    return !(!t6 || !t6.localStorage);
  }, t3.prototype.start = function() {
    return __awaiter(this, void 0, void 0, function() {
      var t6, e28, n3, r3, i, o3, u3, s3, a3, c3, f3, h3 = this;
      return __generator(this, function(l3) {
        switch (l3.label) {
          case 0:
            return [4, this.fa.Ko()];
          case 1:
            for (t6 = l3.sent(), e28 = 0, n3 = t6; e28 < n3.length; e28++)
              (r3 = n3[e28]) !== this._a && (i = this.getItem(Oo(this.persistenceKey, r3))) && (o3 = Vo.aa(r3, i)) && (this.Ta = this.Ta.Ht(o3.clientId, o3));
            for (this.pa(), (u3 = this.storage.getItem(this.ga)) && (s3 = this.ba(u3)) && this.va(s3), a3 = 0, c3 = this.Ia; a3 < c3.length; a3++)
              f3 = c3[a3], this.Ea(f3);
            return this.Ia = [], this.window.addEventListener("unload", function() {
              return h3.$o();
            }), this.Ir = true, [2];
        }
      });
    });
  }, t3.prototype.q = function(t6) {
    this.setItem(this.Aa, JSON.stringify(t6));
  }, t3.prototype.Sa = function() {
    return this.Da(this.Ta);
  }, t3.prototype.Ca = function(t6) {
    var e28 = false;
    return this.Ta.forEach(function(n3, r3) {
      r3.activeTargetIds.has(t6) && (e28 = true);
    }), e28;
  }, t3.prototype.xa = function(t6) {
    this.Na(t6, "pending");
  }, t3.prototype.Fa = function(t6, e28, n3) {
    this.Na(t6, e28, n3), this.Oa(t6);
  }, t3.prototype.ka = function(t6) {
    var e28 = "not-current";
    if (this.Ca(t6)) {
      var n3 = this.storage.getItem(Co(this.persistenceKey, t6));
      if (n3) {
        var r3 = Ro.aa(t6, n3);
        r3 && (e28 = r3.state);
      }
    }
    return this.Ma.ha(t6), this.pa(), e28;
  }, t3.prototype.La = function(t6) {
    this.Ma.la(t6), this.pa();
  }, t3.prototype.$a = function(t6) {
    return this.Ma.activeTargetIds.has(t6);
  }, t3.prototype.Ba = function(t6) {
    this.removeItem(Co(this.persistenceKey, t6));
  }, t3.prototype.qa = function(t6, e28, n3) {
    this.Ua(t6, e28, n3);
  }, t3.prototype.Qa = function(t6, e28, n3) {
    var r3 = this;
    e28.forEach(function(t10) {
      r3.Oa(t10);
    }), this.currentUser = t6, n3.forEach(function(t10) {
      r3.xa(t10);
    });
  }, t3.prototype.Ka = function(t6) {
    this.Wa(t6);
  }, t3.prototype.ja = function() {
    this.Ga();
  }, t3.prototype.$o = function() {
    this.Ir && (this.window.removeEventListener("storage", this.wa), this.removeItem(this.ma), this.Ir = false);
  }, t3.prototype.getItem = function(t6) {
    var e28 = this.storage.getItem(t6);
    return E("SharedClientState", "READ", t6, e28), e28;
  }, t3.prototype.setItem = function(t6, e28) {
    E("SharedClientState", "SET", t6, e28), this.storage.setItem(t6, e28);
  }, t3.prototype.removeItem = function(t6) {
    E("SharedClientState", "REMOVE", t6), this.storage.removeItem(t6);
  }, t3.prototype.Ea = function(t6) {
    var e28 = this, n3 = t6;
    if (n3.storageArea === this.storage) {
      if (E("SharedClientState", "EVENT", n3.key, n3.newValue), n3.key === this.ma)
        return void T("Received WebStorage notification for local change. Another client might have garbage-collected our state");
      this.no.vo(function() {
        return __awaiter(e28, void 0, void 0, function() {
          var t10, e29, r3, i, o3, u3;
          return __generator(this, function(s3) {
            if (this.Ir) {
              if (n3.key !== null) {
                if (this.Ra.test(n3.key)) {
                  if (n3.newValue == null)
                    return t10 = this.za(n3.key), [2, this.Ha(t10, null)];
                  if (e29 = this.Ja(n3.key, n3.newValue))
                    return [2, this.Ha(e29.clientId, e29)];
                } else if (this.Pa.test(n3.key)) {
                  if (n3.newValue !== null && (r3 = this.Ya(n3.key, n3.newValue)))
                    return [2, this.Xa(r3)];
                } else if (this.ya.test(n3.key)) {
                  if (n3.newValue !== null && (i = this.Za(n3.key, n3.newValue)))
                    return [2, this.tu(i)];
                } else if (n3.key === this.ga) {
                  if (n3.newValue !== null && (o3 = this.ba(n3.newValue)))
                    return [2, this.va(o3)];
                } else if (n3.key === this.Aa)
                  (u3 = function(t11) {
                    var e30 = $.U;
                    if (t11 != null)
                      try {
                        var n6 = JSON.parse(t11);
                        x(typeof n6 == "number"), e30 = n6;
                      } catch (t12) {
                        T("SharedClientState", "Failed to read sequence number from WebStorage", t12);
                      }
                    return e30;
                  }(n3.newValue)) !== $.U && this.L(u3);
                else if (n3.key === this.Va)
                  return [2, this.fa.eu()];
              }
            } else
              this.Ia.push(n3);
            return [2];
          });
        });
      });
    }
  }, Object.defineProperty(t3.prototype, "Ma", {
    get: function() {
      return this.Ta.get(this._a);
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.pa = function() {
    this.setItem(this.ma, this.Ma.ua());
  }, t3.prototype.Na = function(t6, e28, n3) {
    var r3 = new Lo(this.currentUser, t6, e28, n3), i = Po(this.persistenceKey, this.currentUser, t6);
    this.setItem(i, r3.ua());
  }, t3.prototype.Oa = function(t6) {
    var e28 = Po(this.persistenceKey, this.currentUser, t6);
    this.removeItem(e28);
  }, t3.prototype.Wa = function(t6) {
    var e28 = {
      clientId: this._a,
      onlineState: t6
    };
    this.storage.setItem(this.ga, JSON.stringify(e28));
  }, t3.prototype.Ua = function(t6, e28, n3) {
    var r3 = Co(this.persistenceKey, t6), i = new Ro(t6, e28, n3);
    this.setItem(r3, i.ua());
  }, t3.prototype.Ga = function() {
    this.setItem(this.Va, "value-not-used");
  }, t3.prototype.za = function(t6) {
    var e28 = this.Ra.exec(t6);
    return e28 ? e28[1] : null;
  }, t3.prototype.Ja = function(t6, e28) {
    var n3 = this.za(t6);
    return Vo.aa(n3, e28);
  }, t3.prototype.Ya = function(t6, e28) {
    var n3 = this.Pa.exec(t6), r3 = Number(n3[1]), i = n3[2] !== void 0 ? n3[2] : null;
    return Lo.aa(new K(i), r3, e28);
  }, t3.prototype.Za = function(t6, e28) {
    var n3 = this.ya.exec(t6), r3 = Number(n3[1]);
    return Ro.aa(r3, e28);
  }, t3.prototype.ba = function(t6) {
    return Mo.aa(t6);
  }, t3.prototype.Xa = function(t6) {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(e28) {
        return t6.user.uid === this.currentUser.uid ? [2, this.fa.nu(t6.batchId, t6.state, t6.error)] : (E("SharedClientState", "Ignoring mutation for non-active user " + t6.user.uid), [2]);
      });
    });
  }, t3.prototype.tu = function(t6) {
    return this.fa.su(t6.targetId, t6.state, t6.error);
  }, t3.prototype.Ha = function(t6, e28) {
    var n3 = this, r3 = e28 ? this.Ta.Ht(t6, e28) : this.Ta.remove(t6), i = this.Da(this.Ta), o3 = this.Da(r3), u3 = [], s3 = [];
    return o3.forEach(function(t10) {
      i.has(t10) || u3.push(t10);
    }), i.forEach(function(t10) {
      o3.has(t10) || s3.push(t10);
    }), this.fa.iu(u3, s3).then(function() {
      n3.Ta = r3;
    });
  }, t3.prototype.va = function(t6) {
    this.Ta.get(t6.clientId) && this.da(t6.onlineState);
  }, t3.prototype.Da = function(t6) {
    var e28 = En();
    return t6.forEach(function(t10, n3) {
      e28 = e28.ye(n3.activeTargetIds);
    }), e28;
  }, t3;
}(), Fo = function() {
  function t3() {
    this.ru = new Uo(), this.ou = {}, this.da = null, this.L = null;
  }
  return t3.prototype.xa = function(t6) {
  }, t3.prototype.Fa = function(t6, e28, n3) {
  }, t3.prototype.ka = function(t6) {
    return this.ru.ha(t6), this.ou[t6] || "not-current";
  }, t3.prototype.qa = function(t6, e28, n3) {
    this.ou[t6] = e28;
  }, t3.prototype.La = function(t6) {
    this.ru.la(t6);
  }, t3.prototype.$a = function(t6) {
    return this.ru.activeTargetIds.has(t6);
  }, t3.prototype.Ba = function(t6) {
    delete this.ou[t6];
  }, t3.prototype.Sa = function() {
    return this.ru.activeTargetIds;
  }, t3.prototype.Ca = function(t6) {
    return this.ru.activeTargetIds.has(t6);
  }, t3.prototype.start = function() {
    return this.ru = new Uo(), Promise.resolve();
  }, t3.prototype.Qa = function(t6, e28, n3) {
  }, t3.prototype.Ka = function(t6) {
  }, t3.prototype.$o = function() {
  }, t3.prototype.q = function(t6) {
  }, t3.prototype.ja = function() {
  }, t3;
}(), jo = function() {
  function t3() {
  }
  return t3.prototype.cu = function(t6) {
  }, t3.prototype.$o = function() {
  }, t3;
}(), zo = function() {
  function t3() {
    var t6 = this;
    this.au = function() {
      return t6.uu();
    }, this.hu = function() {
      return t6.lu();
    }, this._u = [], this.fu();
  }
  return t3.prototype.cu = function(t6) {
    this._u.push(t6);
  }, t3.prototype.$o = function() {
    window.removeEventListener("online", this.au), window.removeEventListener("offline", this.hu);
  }, t3.prototype.fu = function() {
    window.addEventListener("online", this.au), window.addEventListener("offline", this.hu);
  }, t3.prototype.uu = function() {
    E("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
    for (var t6 = 0, e28 = this._u; t6 < e28.length; t6++) {
      (0, e28[t6])(0);
    }
  }, t3.prototype.lu = function() {
    E("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
    for (var t6 = 0, e28 = this._u; t6 < e28.length; t6++) {
      (0, e28[t6])(1);
    }
  }, t3.Wn = function() {
    return typeof window != "undefined" && window.addEventListener !== void 0 && window.removeEventListener !== void 0;
  }, t3;
}(), Go = {
  BatchGetDocuments: "batchGet",
  Commit: "commit",
  RunQuery: "runQuery"
}, Bo = function() {
  function t3(t6) {
    this.du = t6.du, this.wu = t6.wu;
  }
  return t3.prototype.Eu = function(t6) {
    this.Tu = t6;
  }, t3.prototype.Iu = function(t6) {
    this.mu = t6;
  }, t3.prototype.onMessage = function(t6) {
    this.Au = t6;
  }, t3.prototype.close = function() {
    this.wu();
  }, t3.prototype.send = function(t6) {
    this.du(t6);
  }, t3.prototype.Ru = function() {
    this.Tu();
  }, t3.prototype.Pu = function(t6) {
    this.mu(t6);
  }, t3.prototype.yu = function(t6) {
    this.Au(t6);
  }, t3;
}(), Ko = function(t3) {
  function e28(e29) {
    var n3 = this;
    return (n3 = t3.call(this, e29) || this).forceLongPolling = e29.forceLongPolling, n3.I = e29.I, n3;
  }
  return __extends$1(e28, t3), e28.prototype.Du = function(t6, e29, n3, r3) {
    return new Promise(function(i, o3) {
      var u3 = new XhrIo();
      u3.listenOnce(EventType.COMPLETE, function() {
        try {
          switch (u3.getLastErrorCode()) {
            case ErrorCode$1.NO_ERROR:
              var e30 = u3.getResponseJson();
              E("Connection", "XHR received:", JSON.stringify(e30)), i(e30);
              break;
            case ErrorCode$1.TIMEOUT:
              E("Connection", 'RPC "' + t6 + '" timed out'), o3(new M(V.DEADLINE_EXCEEDED, "Request time out"));
              break;
            case ErrorCode$1.HTTP_ERROR:
              var n6 = u3.getStatus();
              if (E("Connection", 'RPC "' + t6 + '" failed with status:', n6, "response text:", u3.getResponseText()), n6 > 0) {
                var r6 = u3.getResponseJson().error;
                if (r6 && r6.status && r6.message) {
                  var s4 = function(t10) {
                    var e31 = t10.toLowerCase().replace(/_/g, "-");
                    return Object.values(V).indexOf(e31) >= 0 ? e31 : V.UNKNOWN;
                  }(r6.status);
                  o3(new M(s4, r6.message));
                } else
                  o3(new M(V.UNKNOWN, "Server responded with status " + u3.getStatus()));
              } else
                o3(new M(V.UNAVAILABLE, "Connection failed."));
              break;
            default:
              S();
          }
        } finally {
          E("Connection", 'RPC "' + t6 + '" completed.');
        }
      });
      var s3 = JSON.stringify(r3);
      u3.send(e29, "POST", s3, n3, 15);
    });
  }, e28.prototype.xu = function(t6, e29) {
    var n3 = [this.Vu, "/", "google.firestore.v1.Firestore", "/", t6, "/channel"], c3 = createWebChannelTransport(), f3 = getStatEventTarget(), h3 = {
      httpSessionIdParam: "gsessionid",
      initMessageHeaders: {},
      messageUrlParams: {
        database: "projects/" + this.T.projectId + "/databases/" + this.T.database
      },
      sendRawJson: true,
      supportsCrossDomainXhr: true,
      internalChannelParams: {
        forwardChannelRequestTimeoutMs: 6e5
      },
      forceLongPolling: this.forceLongPolling,
      detectBufferingProxy: this.I
    };
    this.Su(h3.initMessageHeaders, e29), isMobileCordova() || isReactNative() || isElectron() || isIE() || isUWP() || isBrowserExtension() || (h3.httpHeadersOverwriteParam = "$httpHeaders");
    var m3 = n3.join("");
    E("Connection", "Creating WebChannel: " + m3, h3);
    var g3 = c3.createWebChannel(m3, h3), w3 = false, b3 = false, I3 = new Bo({
      du: function(t10) {
        b3 ? E("Connection", "Not sending because WebChannel is closed:", t10) : (w3 || (E("Connection", "Opening WebChannel transport."), g3.open(), w3 = true), E("Connection", "WebChannel sending:", t10), g3.send(t10));
      },
      wu: function() {
        return g3.close();
      }
    }), _3 = function(t10, e30, n6) {
      t10.listen(e30, function(t11) {
        try {
          n6(t11);
        } catch (t12) {
          setTimeout(function() {
            throw t12;
          }, 0);
        }
      });
    };
    return _3(g3, WebChannel.EventType.OPEN, function() {
      b3 || E("Connection", "WebChannel transport opened.");
    }), _3(g3, WebChannel.EventType.CLOSE, function() {
      b3 || (b3 = true, E("Connection", "WebChannel transport closed"), I3.Pu());
    }), _3(g3, WebChannel.EventType.ERROR, function(t10) {
      b3 || (b3 = true, N("Connection", "WebChannel transport errored:", t10), I3.Pu(new M(V.UNAVAILABLE, "The operation could not be completed")));
    }), _3(g3, WebChannel.EventType.MESSAGE, function(t10) {
      var e30;
      if (!b3) {
        var n6 = t10.data[0];
        x(!!n6);
        var r3 = n6, i = r3.error || ((e30 = r3[0]) === null || e30 === void 0 ? void 0 : e30.error);
        if (i) {
          E("Connection", "WebChannel received error:", i);
          var o3 = i.status, u3 = function(t11) {
            var e31 = tn[t11];
            if (e31 !== void 0)
              return sn(e31);
          }(o3), s3 = i.message;
          u3 === void 0 && (u3 = V.INTERNAL, s3 = "Unknown error status: " + o3 + " with message " + i.message), b3 = true, I3.Pu(new M(u3, s3)), g3.close();
        } else
          E("Connection", "WebChannel received:", n6), I3.yu(n6);
      }
    }), _3(f3, Event$1.STAT_EVENT, function(t10) {
      t10.stat === Stat.PROXY ? E("Connection", "Detected buffering proxy") : t10.stat === Stat.NOPROXY && E("Connection", "Detected no buffering proxy");
    }), setTimeout(function() {
      I3.Ru();
    }, 0), I3;
  }, e28;
}(function() {
  function t3(t6) {
    this.gu = t6, this.T = t6.T;
    var e28 = t6.ssl ? "https" : "http";
    this.Vu = e28 + "://" + t6.host, this.pu = "projects/" + this.T.projectId + "/databases/" + this.T.database + "/documents";
  }
  return t3.prototype.bu = function(t6, e28, n3, r3) {
    var i = this.vu(t6, e28);
    E("RestConnection", "Sending: ", i, n3);
    var o3 = {};
    return this.Su(o3, r3), this.Du(t6, i, o3, n3).then(function(t10) {
      return E("RestConnection", "Received: ", t10), t10;
    }, function(e29) {
      throw N("RestConnection", t6 + " failed with error: ", e29, "url: ", i, "request:", n3), e29;
    });
  }, t3.prototype.Cu = function(t6, e28, n3, r3) {
    return this.bu(t6, e28, n3, r3);
  }, t3.prototype.Su = function(t6, e28) {
    if (t6["X-Goog-Api-Client"] = "gl-js/ fire/8.2.1", t6["Content-Type"] = "text/plain", e28)
      for (var n3 in e28.V)
        e28.V.hasOwnProperty(n3) && (t6[n3] = e28.V[n3]);
  }, t3.prototype.vu = function(t6, e28) {
    var n3 = Go[t6];
    return this.Vu + "/v1/" + e28 + ":" + n3;
  }, t3;
}());
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ho() {
  return typeof window != "undefined" ? window : null;
}
function Jo() {
  return typeof document != "undefined" ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Wo(t3) {
  return new Un(t3, true);
}
var Qo = function() {
  function t3(t6, e28, n3, r3, i) {
    n3 === void 0 && (n3 = 1e3), r3 === void 0 && (r3 = 1.5), i === void 0 && (i = 6e4), this.no = t6, this.ds = e28, this.Nu = n3, this.Fu = r3, this.Ou = i, this.ku = 0, this.Mu = null, this.Lu = Date.now(), this.reset();
  }
  return t3.prototype.reset = function() {
    this.ku = 0;
  }, t3.prototype.$u = function() {
    this.ku = this.Ou;
  }, t3.prototype.Bu = function(t6) {
    var e28 = this;
    this.cancel();
    var n3 = Math.floor(this.ku + this.qu()), r3 = Math.max(0, Date.now() - this.Lu), i = Math.max(0, n3 - r3);
    i > 0 && E("ExponentialBackoff", "Backing off for " + i + " ms (base delay: " + this.ku + " ms, delay with jitter: " + n3 + " ms, last attempt: " + r3 + " ms ago)"), this.Mu = this.no.mr(this.ds, i, function() {
      return e28.Lu = Date.now(), t6();
    }), this.ku *= this.Fu, this.ku < this.Nu && (this.ku = this.Nu), this.ku > this.Ou && (this.ku = this.Ou);
  }, t3.prototype.Uu = function() {
    this.Mu !== null && (this.Mu.Ps(), this.Mu = null);
  }, t3.prototype.cancel = function() {
    this.Mu !== null && (this.Mu.cancel(), this.Mu = null);
  }, t3.prototype.qu = function() {
    return (Math.random() - 0.5) * this.ku;
  }, t3;
}(), Yo = function() {
  function t3(t6, e28, n3, r3, i, o3) {
    this.no = t6, this.Qu = n3, this.Ku = r3, this.Wu = i, this.listener = o3, this.state = 0, this.ju = 0, this.Gu = null, this.stream = null, this.zu = new Qo(t6, e28);
  }
  return t3.prototype.Hu = function() {
    return this.state === 1 || this.state === 2 || this.state === 4;
  }, t3.prototype.Ju = function() {
    return this.state === 2;
  }, t3.prototype.start = function() {
    this.state !== 3 ? this.auth() : this.Yu();
  }, t3.prototype.stop = function() {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(t6) {
        switch (t6.label) {
          case 0:
            return this.Hu() ? [4, this.close(0)] : [3, 2];
          case 1:
            t6.sent(), t6.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, t3.prototype.Xu = function() {
    this.state = 0, this.zu.reset();
  }, t3.prototype.Zu = function() {
    var t6 = this;
    this.Ju() && this.Gu === null && (this.Gu = this.no.mr(this.Qu, 6e4, function() {
      return t6.th();
    }));
  }, t3.prototype.eh = function(t6) {
    this.nh(), this.stream.send(t6);
  }, t3.prototype.th = function() {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(t6) {
        return this.Ju() ? [2, this.close(0)] : [2];
      });
    });
  }, t3.prototype.nh = function() {
    this.Gu && (this.Gu.cancel(), this.Gu = null);
  }, t3.prototype.close = function(t6, e28) {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(n3) {
        switch (n3.label) {
          case 0:
            return this.nh(), this.zu.cancel(), this.ju++, t6 !== 3 ? this.zu.reset() : e28 && e28.code === V.RESOURCE_EXHAUSTED ? (T(e28.toString()), T("Using maximum backoff delay to prevent overloading the backend."), this.zu.$u()) : e28 && e28.code === V.UNAUTHENTICATED && this.Wu.v(), this.stream !== null && (this.sh(), this.stream.close(), this.stream = null), this.state = t6, [4, this.listener.Iu(e28)];
          case 1:
            return n3.sent(), [2];
        }
      });
    });
  }, t3.prototype.sh = function() {
  }, t3.prototype.auth = function() {
    var t6 = this;
    this.state = 1;
    var e28 = this.ih(this.ju), n3 = this.ju;
    this.Wu.getToken().then(function(e29) {
      t6.ju === n3 && t6.rh(e29);
    }, function(n6) {
      e28(function() {
        var e29 = new M(V.UNKNOWN, "Fetching auth token failed: " + n6.message);
        return t6.oh(e29);
      });
    });
  }, t3.prototype.rh = function(t6) {
    var e28 = this, n3 = this.ih(this.ju);
    this.stream = this.ah(t6), this.stream.Eu(function() {
      n3(function() {
        return e28.state = 2, e28.listener.Eu();
      });
    }), this.stream.Iu(function(t10) {
      n3(function() {
        return e28.oh(t10);
      });
    }), this.stream.onMessage(function(t10) {
      n3(function() {
        return e28.onMessage(t10);
      });
    });
  }, t3.prototype.Yu = function() {
    var t6 = this;
    this.state = 4, this.zu.Bu(function() {
      return __awaiter(t6, void 0, void 0, function() {
        return __generator(this, function(t10) {
          return this.state = 0, this.start(), [2];
        });
      });
    });
  }, t3.prototype.oh = function(t6) {
    return E("PersistentStream", "close with error: " + t6), this.stream = null, this.close(3, t6);
  }, t3.prototype.ih = function(t6) {
    var e28 = this;
    return function(n3) {
      e28.no.ys(function() {
        return e28.ju === t6 ? n3() : (E("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve());
      });
    };
  }, t3;
}(), $o = function(t3) {
  function e28(e29, n3, r3, i, o3) {
    var u3 = this;
    return (u3 = t3.call(this, e29, "listen_stream_connection_backoff", "listen_stream_idle", n3, r3, o3) || this).Kt = i, u3;
  }
  return __extends$1(e28, t3), e28.prototype.ah = function(t6) {
    return this.Ku.xu("Listen", t6);
  }, e28.prototype.onMessage = function(t6) {
    this.zu.reset();
    var e29 = function(t10, e30) {
      var n6;
      if ("targetChange" in e30) {
        e30.targetChange;
        var r3 = function(t11) {
          return t11 === "NO_CHANGE" ? 0 : t11 === "ADD" ? 1 : t11 === "REMOVE" ? 2 : t11 === "CURRENT" ? 3 : t11 === "RESET" ? 4 : S();
        }(e30.targetChange.targetChangeType || "NO_CHANGE"), i = e30.targetChange.targetIds || [], o3 = function(t11, e31) {
          return t11.qt ? (x(e31 === void 0 || typeof e31 == "string"), R.fromBase64String(e31 || "")) : (x(e31 === void 0 || e31 instanceof Uint8Array), R.fromUint8Array(e31 || new Uint8Array()));
        }(t10, e30.targetChange.resumeToken), u3 = (s3 = e30.targetChange.cause) && function(t11) {
          var e31 = t11.code === void 0 ? V.UNKNOWN : sn(t11.code);
          return new M(e31, t11.message || "");
        }(s3);
        n6 = new On(r3, i, o3, u3 || null);
      } else if ("documentChange" in e30) {
        e30.documentChange, (r3 = e30.documentChange).document, r3.document.name, r3.document.updateTime, i = Hn(t10, r3.document.name), o3 = zn(r3.document.updateTime);
        var s3 = new Pt({
          mapValue: {
            fields: r3.document.fields
          }
        }), a3 = (u3 = new Vt(i, o3, s3, {}), r3.targetIds || []), c3 = r3.removedTargetIds || [];
        n6 = new Dn(a3, c3, u3.key, u3);
      } else if ("documentDelete" in e30)
        e30.documentDelete, (r3 = e30.documentDelete).document, i = Hn(t10, r3.document), o3 = r3.readTime ? zn(r3.readTime) : Z.min(), s3 = new Mt(i, o3), u3 = r3.removedTargetIds || [], n6 = new Dn([], u3, s3.key, s3);
      else if ("documentRemove" in e30)
        e30.documentRemove, (r3 = e30.documentRemove).document, i = Hn(t10, r3.document), o3 = r3.removedTargetIds || [], n6 = new Dn([], o3, i, null);
      else {
        if (!("filter" in e30))
          return S();
        e30.filter;
        var f3 = e30.filter;
        f3.targetId, r3 = f3.count || 0, i = new on(r3), o3 = f3.targetId, n6 = new kn(o3, i);
      }
      return n6;
    }(this.Kt, t6), n3 = function(t10) {
      if (!("targetChange" in t10))
        return Z.min();
      var e30 = t10.targetChange;
      return e30.targetIds && e30.targetIds.length ? Z.min() : e30.readTime ? zn(e30.readTime) : Z.min();
    }(t6);
    return this.listener.uh(e29, n3);
  }, e28.prototype.hh = function(t6) {
    var e29 = {};
    e29.database = Qn(this.Kt), e29.addTarget = function(t10, e30) {
      var n6, r3 = e30.target;
      return (n6 = Gt(r3) ? {
        documents: er(t10, r3)
      } : {
        query: nr(t10, r3)
      }).targetId = e30.targetId, e30.resumeToken.o() > 0 ? n6.resumeToken = Fn(t10, e30.resumeToken) : e30.Mt.u(Z.min()) > 0 && (n6.readTime = qn(t10, e30.Mt.G())), n6;
    }(this.Kt, t6);
    var n3 = function(t10, e30) {
      var n6 = function(t11, e31) {
        switch (e31) {
          case 0:
            return null;
          case 1:
            return "existence-filter-mismatch";
          case 2:
            return "limbo-document";
          default:
            return S();
        }
      }(0, e30.kt);
      return n6 == null ? null : {
        "goog-listen-tags": n6
      };
    }(this.Kt, t6);
    n3 && (e29.labels = n3), this.eh(e29);
  }, e28.prototype.lh = function(t6) {
    var e29 = {};
    e29.database = Qn(this.Kt), e29.removeTarget = t6, this.eh(e29);
  }, e28;
}(Yo), Xo = function(t3) {
  function e28(e29, n3, r3, i, o3) {
    var u3 = this;
    return (u3 = t3.call(this, e29, "write_stream_connection_backoff", "write_stream_idle", n3, r3, o3) || this).Kt = i, u3._h = false, u3;
  }
  return __extends$1(e28, t3), Object.defineProperty(e28.prototype, "fh", {
    get: function() {
      return this._h;
    },
    enumerable: false,
    configurable: true
  }), e28.prototype.start = function() {
    this._h = false, this.lastStreamToken = void 0, t3.prototype.start.call(this);
  }, e28.prototype.sh = function() {
    this._h && this.dh([]);
  }, e28.prototype.ah = function(t6) {
    return this.Ku.xu("Write", t6);
  }, e28.prototype.onMessage = function(t6) {
    if (x(!!t6.streamToken), this.lastStreamToken = t6.streamToken, this._h) {
      this.zu.reset();
      var e29 = function(t10, e30) {
        return t10 && t10.length > 0 ? (x(e30 !== void 0), t10.map(function(t11) {
          return function(t12, e31) {
            var n6 = t12.updateTime ? zn(t12.updateTime) : zn(e31);
            n6.isEqual(Z.min()) && (n6 = zn(e31));
            var r3 = null;
            return t12.transformResults && t12.transformResults.length > 0 && (r3 = t12.transformResults), new qe(n6, r3);
          }(t11, e30);
        })) : [];
      }(t6.writeResults, t6.commitTime), n3 = zn(t6.commitTime);
      return this.listener.wh(n3, e29);
    }
    return x(!t6.writeResults || t6.writeResults.length === 0), this._h = true, this.listener.Eh();
  }, e28.prototype.Th = function() {
    var t6 = {};
    t6.database = Qn(this.Kt), this.eh(t6);
  }, e28.prototype.dh = function(t6) {
    var e29 = this, n3 = {
      streamToken: this.lastStreamToken,
      writes: t6.map(function(t10) {
        return Zn(e29.Kt, t10);
      })
    };
    this.eh(n3);
  }, e28;
}(Yo), Zo = function(t3) {
  function e28(e29, n3, r3) {
    var i = this;
    return (i = t3.call(this) || this).credentials = e29, i.Ku = n3, i.Kt = r3, i.Ih = false, i;
  }
  return __extends$1(e28, t3), e28.prototype.mh = function() {
    if (this.Ih)
      throw new M(V.FAILED_PRECONDITION, "The client has already been terminated.");
  }, e28.prototype.bu = function(t6, e29, n3) {
    var r3 = this;
    return this.mh(), this.credentials.getToken().then(function(i) {
      return r3.Ku.bu(t6, e29, n3, i);
    }).catch(function(t10) {
      throw t10.code === V.UNAUTHENTICATED && r3.credentials.v(), t10;
    });
  }, e28.prototype.Cu = function(t6, e29, n3) {
    var r3 = this;
    return this.mh(), this.credentials.getToken().then(function(i) {
      return r3.Ku.Cu(t6, e29, n3, i);
    }).catch(function(t10) {
      throw t10.code === V.UNAUTHENTICATED && r3.credentials.v(), t10;
    });
  }, e28.prototype.terminate = function() {
    this.Ih = false;
  }, e28;
}(function() {
}), tu = function() {
  function t3(t6, e28) {
    this.fs = t6, this.da = e28, this.state = "Unknown", this.Ah = 0, this.Rh = null, this.Ph = true;
  }
  return t3.prototype.yh = function() {
    var t6 = this;
    this.Ah === 0 && (this.gh("Unknown"), this.Rh = this.fs.mr("online_state_timeout", 1e4, function() {
      return t6.Rh = null, t6.Vh("Backend didn't respond within 10 seconds."), t6.gh("Offline"), Promise.resolve();
    }));
  }, t3.prototype.ph = function(t6) {
    this.state === "Online" ? this.gh("Unknown") : (this.Ah++, this.Ah >= 1 && (this.bh(), this.Vh("Connection failed 1 times. Most recent error: " + t6.toString()), this.gh("Offline")));
  }, t3.prototype.set = function(t6) {
    this.bh(), this.Ah = 0, t6 === "Online" && (this.Ph = false), this.gh(t6);
  }, t3.prototype.gh = function(t6) {
    t6 !== this.state && (this.state = t6, this.da(t6));
  }, t3.prototype.Vh = function(t6) {
    var e28 = "Could not reach Cloud Firestore backend. " + t6 + "\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.";
    this.Ph ? (T(e28), this.Ph = false) : E("OnlineStateTracker", e28);
  }, t3.prototype.bh = function() {
    this.Rh !== null && (this.Rh.cancel(), this.Rh = null);
  }, t3;
}(), eu = function(t3, e28, n3, r3, i) {
  var o3 = this;
  this.Sh = t3, this.Dh = e28, this.fs = n3, this.Ch = {}, this.xh = [], this.Nh = new Map(), this.Fh = new Set(), this.Oh = [], this.kh = i, this.kh.cu(function(t6) {
    n3.ys(function() {
      return __awaiter(o3, void 0, void 0, function() {
        return __generator(this, function(t10) {
          switch (t10.label) {
            case 0:
              return fu(this) ? (E("RemoteStore", "Restarting streams for network reachability change."), [4, function(t11) {
                return __awaiter(this, void 0, void 0, function() {
                  var e29;
                  return __generator(this, function(n6) {
                    switch (n6.label) {
                      case 0:
                        return (e29 = D(t11)).Fh.add(4), [4, ru(e29)];
                      case 1:
                        return n6.sent(), e29.Mh.set("Unknown"), e29.Fh.delete(4), [4, nu(e29)];
                      case 2:
                        return n6.sent(), [2];
                    }
                  });
                });
              }(this)]) : [3, 2];
            case 1:
              t10.sent(), t10.label = 2;
            case 2:
              return [2];
          }
        });
      });
    });
  }), this.Mh = new tu(n3, r3);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function nu(t3) {
  return __awaiter(this, void 0, void 0, function() {
    var e28, n3;
    return __generator(this, function(r3) {
      switch (r3.label) {
        case 0:
          if (!fu(t3))
            return [3, 4];
          e28 = 0, n3 = t3.Oh, r3.label = 1;
        case 1:
          return e28 < n3.length ? [4, (0, n3[e28])(true)] : [3, 4];
        case 2:
          r3.sent(), r3.label = 3;
        case 3:
          return e28++, [3, 1];
        case 4:
          return [2];
      }
    });
  });
}
function ru(t3) {
  return __awaiter(this, void 0, void 0, function() {
    var e28, n3;
    return __generator(this, function(r3) {
      switch (r3.label) {
        case 0:
          e28 = 0, n3 = t3.Oh, r3.label = 1;
        case 1:
          return e28 < n3.length ? [4, (0, n3[e28])(false)] : [3, 4];
        case 2:
          r3.sent(), r3.label = 3;
        case 3:
          return e28++, [3, 1];
        case 4:
          return [2];
      }
    });
  });
}
function iu(t3, e28) {
  var n3 = D(t3);
  n3.Nh.has(e28.targetId) || (n3.Nh.set(e28.targetId, e28), cu(n3) ? au(n3) : Nu(n3).Ju() && uu(n3, e28));
}
function ou(t3, e28) {
  var n3 = D(t3), r3 = Nu(n3);
  n3.Nh.delete(e28), r3.Ju() && su(n3, e28), n3.Nh.size === 0 && (r3.Ju() ? r3.Zu() : fu(n3) && n3.Mh.set("Unknown"));
}
function uu(t3, e28) {
  t3.Lh.cn(e28.targetId), Nu(t3).hh(e28);
}
function su(t3, e28) {
  t3.Lh.cn(e28), Nu(t3).lh(e28);
}
function au(t3) {
  t3.Lh = new Cn({
    Sn: function(e28) {
      return t3.Ch.Sn(e28);
    },
    Dn: function(e28) {
      return t3.Nh.get(e28) || null;
    }
  }), Nu(t3).start(), t3.Mh.yh();
}
function cu(t3) {
  return fu(t3) && !Nu(t3).Hu() && t3.Nh.size > 0;
}
function fu(t3) {
  return D(t3).Fh.size === 0;
}
function hu(t3) {
  t3.Lh = void 0;
}
function lu(t3) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(e28) {
      return t3.Nh.forEach(function(e29, n3) {
        uu(t3, e29);
      }), [2];
    });
  });
}
function pu(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(n3) {
      return hu(t3), cu(t3) ? (t3.Mh.ph(e28), au(t3)) : t3.Mh.set("Unknown"), [2];
    });
  });
}
function du(t3, e28, n3) {
  return __awaiter(this, void 0, void 0, function() {
    var r3, i, o3;
    return __generator(this, function(u3) {
      switch (u3.label) {
        case 0:
          if (t3.Mh.set("Online"), !(e28 instanceof On && e28.state === 2 && e28.cause))
            return [3, 6];
          u3.label = 1;
        case 1:
          return u3.trys.push([1, 3, , 5]), [
            4,
            function(t6, e29) {
              return __awaiter(this, void 0, void 0, function() {
                var n6, r6, i3, o6;
                return __generator(this, function(u6) {
                  switch (u6.label) {
                    case 0:
                      n6 = e29.cause, r6 = 0, i3 = e29.targetIds, u6.label = 1;
                    case 1:
                      return r6 < i3.length ? (o6 = i3[r6], t6.Nh.has(o6) ? [4, t6.Ch.$h(o6, n6)] : [3, 3]) : [3, 5];
                    case 2:
                      u6.sent(), t6.Nh.delete(o6), t6.Lh.removeTarget(o6), u6.label = 3;
                    case 3:
                      u6.label = 4;
                    case 4:
                      return r6++, [3, 1];
                    case 5:
                      return [2];
                  }
                });
              });
            }(t3, e28)
          ];
        case 2:
          return u3.sent(), [3, 5];
        case 3:
          return r3 = u3.sent(), E("RemoteStore", "Failed to remove targets %s: %s ", e28.targetIds.join(","), r3), [4, vu(t3, r3)];
        case 4:
          return u3.sent(), [3, 5];
        case 5:
          return [3, 13];
        case 6:
          if (e28 instanceof Dn ? t3.Lh.wn(e28) : e28 instanceof kn ? t3.Lh.yn(e28) : t3.Lh.In(e28), n3.isEqual(Z.min()))
            return [3, 13];
          u3.label = 7;
        case 7:
          return u3.trys.push([7, 11, , 13]), [4, ao(t3.Sh)];
        case 8:
          return i = u3.sent(), n3.u(i) >= 0 ? [
            4,
            function(t6, e29) {
              var n6 = t6.Lh.pn(e29);
              return n6.Oe.forEach(function(n10, r6) {
                if (n10.resumeToken.o() > 0) {
                  var i3 = t6.Nh.get(r6);
                  i3 && t6.Nh.set(r6, i3.$t(n10.resumeToken, e29));
                }
              }), n6.ke.forEach(function(e30) {
                var n10 = t6.Nh.get(e30);
                if (n10) {
                  t6.Nh.set(e30, n10.$t(R.h, n10.Mt)), su(t6, e30);
                  var r6 = new _e(n10.target, e30, 1, n10.sequenceNumber);
                  uu(t6, r6);
                }
              }), t6.Ch.Bh(n6);
            }(t3, n3)
          ] : [3, 10];
        case 9:
          u3.sent(), u3.label = 10;
        case 10:
          return [3, 13];
        case 11:
          return E("RemoteStore", "Failed to raise snapshot:", o3 = u3.sent()), [4, vu(t3, o3)];
        case 12:
          return u3.sent(), [3, 13];
        case 13:
          return [2];
      }
    });
  });
}
function vu(t3, e28, n3) {
  return __awaiter(this, void 0, void 0, function() {
    var r3 = this;
    return __generator(this, function(i) {
      switch (i.label) {
        case 0:
          if (!Ir(e28))
            throw e28;
          return t3.Fh.add(1), [4, ru(t3)];
        case 1:
          return i.sent(), t3.Mh.set("Offline"), n3 || (n3 = function() {
            return ao(t3.Sh);
          }), t3.fs.vo(function() {
            return __awaiter(r3, void 0, void 0, function() {
              return __generator(this, function(e29) {
                switch (e29.label) {
                  case 0:
                    return E("RemoteStore", "Retrying IndexedDB access"), [4, n3()];
                  case 1:
                    return e29.sent(), t3.Fh.delete(1), [4, nu(t3)];
                  case 2:
                    return e29.sent(), [2];
                }
              });
            });
          }), [2];
      }
    });
  });
}
function yu(t3, e28) {
  return e28().catch(function(n3) {
    return vu(t3, n3, e28);
  });
}
function mu(t3) {
  return __awaiter(this, void 0, void 0, function() {
    var e28, n3, r3, i, o3;
    return __generator(this, function(u3) {
      switch (u3.label) {
        case 0:
          e28 = D(t3), n3 = Au(e28), r3 = e28.xh.length > 0 ? e28.xh[e28.xh.length - 1].batchId : -1, u3.label = 1;
        case 1:
          if (!function(t6) {
            return fu(t6) && t6.xh.length < 10;
          }(e28))
            return [3, 7];
          u3.label = 2;
        case 2:
          return u3.trys.push([2, 4, , 6]), [4, ho(e28.Sh, r3)];
        case 3:
          return (i = u3.sent()) === null ? (e28.xh.length === 0 && n3.Zu(), [3, 7]) : (r3 = i.batchId, function(t6, e29) {
            t6.xh.push(e29);
            var n6 = Au(t6);
            n6.Ju() && n6.fh && n6.dh(e29.mutations);
          }(e28, i), [3, 6]);
        case 4:
          return o3 = u3.sent(), [4, vu(e28, o3)];
        case 5:
          return u3.sent(), [3, 6];
        case 6:
          return [3, 1];
        case 7:
          return gu(e28) && wu(e28), [2];
      }
    });
  });
}
function gu(t3) {
  return fu(t3) && !Au(t3).Hu() && t3.xh.length > 0;
}
function wu(t3) {
  Au(t3).start();
}
function bu(t3) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(e28) {
      return Au(t3).Th(), [2];
    });
  });
}
function Iu(t3) {
  return __awaiter(this, void 0, void 0, function() {
    var e28, n3, r3, i;
    return __generator(this, function(o3) {
      for (e28 = Au(t3), n3 = 0, r3 = t3.xh; n3 < r3.length; n3++)
        i = r3[n3], e28.dh(i.mutations);
      return [2];
    });
  });
}
function _u(t3, e28, n3) {
  return __awaiter(this, void 0, void 0, function() {
    var r3, i;
    return __generator(this, function(o3) {
      switch (o3.label) {
        case 0:
          return r3 = t3.xh.shift(), i = ei.from(r3, e28, n3), [4, yu(t3, function() {
            return t3.Ch.qh(i);
          })];
        case 1:
          return o3.sent(), [4, mu(t3)];
        case 2:
          return o3.sent(), [2];
      }
    });
  });
}
function Eu(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(n3) {
      switch (n3.label) {
        case 0:
          return e28 && Au(t3).fh ? [4, function(t6, e29) {
            return __awaiter(this, void 0, void 0, function() {
              var n6, r3;
              return __generator(this, function(i) {
                switch (i.label) {
                  case 0:
                    return un(r3 = e29.code) && r3 !== V.ABORTED ? (n6 = t6.xh.shift(), Au(t6).Xu(), [4, yu(t6, function() {
                      return t6.Ch.Uh(n6.batchId, e29);
                    })]) : [3, 3];
                  case 1:
                    return i.sent(), [4, mu(t6)];
                  case 2:
                    i.sent(), i.label = 3;
                  case 3:
                    return [2];
                }
              });
            });
          }(t3, e28)] : [3, 2];
        case 1:
          n3.sent(), n3.label = 2;
        case 2:
          return gu(t3) && wu(t3), [2];
      }
    });
  });
}
function Tu(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    var n3;
    return __generator(this, function(i) {
      switch (i.label) {
        case 0:
          return n3 = D(t3), e28 ? (n3.Fh.delete(2), [4, nu(n3)]) : [3, 2];
        case 1:
          return i.sent(), [3, 5];
        case 2:
          return e28 ? [3, 4] : (n3.Fh.add(2), [4, ru(n3)]);
        case 3:
          i.sent(), n3.Mh.set("Unknown"), i.label = 4;
        case 4:
          i.label = 5;
        case 5:
          return [2];
      }
    });
  });
}
function Nu(t3) {
  var e28 = this;
  return t3.Qh || (t3.Qh = function(t6, e29, n3) {
    var r3 = D(t6);
    return r3.mh(), new $o(e29, r3.Ku, r3.credentials, r3.Kt, n3);
  }(t3.Dh, t3.fs, {
    Eu: lu.bind(null, t3),
    Iu: pu.bind(null, t3),
    uh: du.bind(null, t3)
  }), t3.Oh.push(function(n3) {
    return __awaiter(e28, void 0, void 0, function() {
      return __generator(this, function(e29) {
        switch (e29.label) {
          case 0:
            return n3 ? (t3.Qh.Xu(), cu(t3) ? au(t3) : t3.Mh.set("Unknown"), [3, 3]) : [3, 1];
          case 1:
            return [4, t3.Qh.stop()];
          case 2:
            e29.sent(), hu(t3), e29.label = 3;
          case 3:
            return [2];
        }
      });
    });
  })), t3.Qh;
}
function Au(t3) {
  var e28 = this;
  return t3.Kh || (t3.Kh = function(t6, e29, n3) {
    var r3 = D(t6);
    return r3.mh(), new Xo(e29, r3.Ku, r3.credentials, r3.Kt, n3);
  }(t3.Dh, t3.fs, {
    Eu: bu.bind(null, t3),
    Iu: Eu.bind(null, t3),
    Eh: Iu.bind(null, t3),
    wh: _u.bind(null, t3)
  }), t3.Oh.push(function(n3) {
    return __awaiter(e28, void 0, void 0, function() {
      return __generator(this, function(e29) {
        switch (e29.label) {
          case 0:
            return n3 ? (t3.Kh.Xu(), [4, mu(t3)]) : [3, 2];
          case 1:
            return e29.sent(), [3, 4];
          case 2:
            return [4, t3.Kh.stop()];
          case 3:
            e29.sent(), t3.xh.length > 0 && (E("RemoteStore", "Stopping write stream with " + t3.xh.length + " pending writes"), t3.xh = []), e29.label = 4;
          case 4:
            return [2];
        }
      });
    });
  })), t3.Kh;
}
var Su = function() {
  this.Wh = void 0, this.listeners = [];
}, xu = function() {
  this.queries = new Ei(function(t3) {
    return me(t3);
  }, ye), this.onlineState = "Unknown", this.jh = new Set();
};
function Du(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    var n3, r3, i, o3, u3, s3, a3;
    return __generator(this, function(c3) {
      switch (c3.label) {
        case 0:
          if (n3 = D(t3), r3 = e28.query, i = false, (o3 = n3.queries.get(r3)) || (i = true, o3 = new Su()), !i)
            return [3, 4];
          c3.label = 1;
        case 1:
          return c3.trys.push([1, 3, , 4]), u3 = o3, [4, n3.Gh(r3)];
        case 2:
          return u3.Wh = c3.sent(), [3, 4];
        case 3:
          return s3 = c3.sent(), a3 = Sr(s3, "Initialization of query '" + ge(e28.query) + "' failed"), [2, void e28.onError(a3)];
        case 4:
          return n3.queries.set(r3, o3), o3.listeners.push(e28), e28.zh(n3.onlineState), o3.Wh && e28.Hh(o3.Wh) && Cu(n3), [2];
      }
    });
  });
}
function ku(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    var n3, r3, i, o3, u3;
    return __generator(this, function(s3) {
      return n3 = D(t3), r3 = e28.query, i = false, (o3 = n3.queries.get(r3)) && (u3 = o3.listeners.indexOf(e28)) >= 0 && (o3.listeners.splice(u3, 1), i = o3.listeners.length === 0), i ? [2, (n3.queries.delete(r3), n3.Jh(r3))] : [2];
    });
  });
}
function Ou(t3, e28) {
  for (var n3 = D(t3), r3 = false, i = 0, o3 = e28; i < o3.length; i++) {
    var u3 = o3[i], s3 = u3.query, a3 = n3.queries.get(s3);
    if (a3) {
      for (var c3 = 0, f3 = a3.listeners; c3 < f3.length; c3++) {
        f3[c3].Hh(u3) && (r3 = true);
      }
      a3.Wh = u3;
    }
  }
  r3 && Cu(n3);
}
function Pu(t3, e28, n3) {
  var r3 = D(t3), i = r3.queries.get(e28);
  if (i)
    for (var o3 = 0, u3 = i.listeners; o3 < u3.length; o3++) {
      u3[o3].onError(n3);
    }
  r3.queries.delete(e28);
}
function Cu(t3) {
  t3.jh.forEach(function(t6) {
    t6.next();
  });
}
var Lu = function() {
  function t3(t6, e28, n3) {
    this.query = t6, this.Yh = e28, this.Xh = false, this.Zh = null, this.onlineState = "Unknown", this.options = n3 || {};
  }
  return t3.prototype.Hh = function(t6) {
    if (!this.options.includeMetadataChanges) {
      for (var e28 = [], n3 = 0, r3 = t6.docChanges; n3 < r3.length; n3++) {
        var i = r3[n3];
        i.type !== 3 && e28.push(i);
      }
      t6 = new An(t6.query, t6.docs, t6.De, e28, t6.Ce, t6.fromCache, t6.xe, true);
    }
    var o3 = false;
    return this.Xh ? this.tl(t6) && (this.Yh.next(t6), o3 = true) : this.el(t6, this.onlineState) && (this.nl(t6), o3 = true), this.Zh = t6, o3;
  }, t3.prototype.onError = function(t6) {
    this.Yh.error(t6);
  }, t3.prototype.zh = function(t6) {
    this.onlineState = t6;
    var e28 = false;
    return this.Zh && !this.Xh && this.el(this.Zh, t6) && (this.nl(this.Zh), e28 = true), e28;
  }, t3.prototype.el = function(t6, e28) {
    if (!t6.fromCache)
      return true;
    var n3 = e28 !== "Offline";
    return !(this.options.sl && n3 || t6.docs.nt() && e28 !== "Offline");
  }, t3.prototype.tl = function(t6) {
    if (t6.docChanges.length > 0)
      return true;
    var e28 = this.Zh && this.Zh.hasPendingWrites !== t6.hasPendingWrites;
    return !(!t6.xe && !e28) && this.options.includeMetadataChanges === true;
  }, t3.prototype.nl = function(t6) {
    t6 = An.Fe(t6.query, t6.docs, t6.Ce, t6.fromCache), this.Xh = true, this.Yh.next(t6);
  }, t3;
}(), Ru = function() {
  function t3(t6, e28) {
    this.payload = t6, this.byteLength = e28;
  }
  return t3.prototype.il = function() {
    return "metadata" in this.payload;
  }, t3;
}(), Vu = function() {
  function t3(t6) {
    this.Kt = t6;
  }
  return t3.prototype.yc = function(t6) {
    return Hn(this.Kt, t6);
  }, t3.prototype.gc = function(t6) {
    return t6.metadata.exists ? Xn(this.Kt, t6.document, false) : new Mt(this.yc(t6.metadata.name), this.Vc(t6.metadata.readTime));
  }, t3.prototype.Vc = function(t6) {
    return zn(t6);
  }, t3;
}(), Mu = function() {
  function t3(t6, e28, n3) {
    this.rl = t6, this.Sh = e28, this.Kt = n3, this.queries = [], this.documents = [], this.progress = Uu(t6);
  }
  return t3.prototype.ol = function(t6) {
    this.progress.bytesLoaded += t6.byteLength;
    var e28 = this.progress.documentsLoaded;
    return t6.payload.namedQuery ? this.queries.push(t6.payload.namedQuery) : t6.payload.documentMetadata ? (this.documents.push({
      metadata: t6.payload.documentMetadata
    }), t6.payload.documentMetadata.exists || ++e28) : t6.payload.document && (this.documents[this.documents.length - 1].document = t6.payload.document, ++e28), e28 !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = e28, Object.assign({}, this.progress)) : null;
  }, t3.prototype.cl = function(t6) {
    for (var e28 = new Map(), n3 = new Vu(this.Kt), r3 = 0, i = t6; r3 < i.length; r3++) {
      var o3 = i[r3];
      if (o3.metadata.queries)
        for (var u3 = n3.yc(o3.metadata.name), s3 = 0, a3 = o3.metadata.queries; s3 < a3.length; s3++) {
          var c3 = a3[s3], f3 = (e28.get(c3) || In()).add(u3);
          e28.set(c3, f3);
        }
    }
    return e28;
  }, t3.prototype.complete = function() {
    return __awaiter(this, void 0, void 0, function() {
      var t6, e28, n3, r3, i;
      return __generator(this, function(o3) {
        switch (o3.label) {
          case 0:
            return [4, wo(this.Sh, new Vu(this.Kt), this.documents, this.rl.id)];
          case 1:
            t6 = o3.sent(), e28 = this.cl(this.documents), n3 = 0, r3 = this.queries, o3.label = 2;
          case 2:
            return n3 < r3.length ? (i = r3[n3], [4, bo(this.Sh, i, e28.get(i.name))]) : [3, 5];
          case 3:
            o3.sent(), o3.label = 4;
          case 4:
            return n3++, [3, 2];
          case 5:
            return [2, (this.progress.taskState = "Success", new xr(Object.assign({}, this.progress), t6))];
        }
      });
    });
  }, t3;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Uu(t3) {
  return {
    taskState: "Running",
    documentsLoaded: 0,
    bytesLoaded: 0,
    totalDocuments: t3.totalDocuments,
    totalBytes: t3.totalBytes
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var qu = function(t3) {
  this.key = t3;
}, Fu = function(t3) {
  this.key = t3;
}, ju = function() {
  function t3(t6, e28) {
    this.query = t6, this.al = e28, this.ul = null, this.qe = false, this.hl = In(), this.Ce = In(), this.ll = be(t6), this._l = new Tn(this.ll);
  }
  return Object.defineProperty(t3.prototype, "fl", {
    get: function() {
      return this.al;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.dl = function(t6, e28) {
    var n3 = this, r3 = e28 ? e28.wl : new Nn(), i = e28 ? e28._l : this._l, o3 = e28 ? e28.Ce : this.Ce, u3 = i, s3 = false, a3 = ae(this.query) && i.size === this.query.limit ? i.last() : null, c3 = ce(this.query) && i.size === this.query.limit ? i.first() : null;
    if (t6.Zt(function(t10, e29) {
      var f6 = i.get(t10), h3 = e29 instanceof Vt ? e29 : null;
      h3 && (h3 = we(n3.query, h3) ? h3 : null);
      var l3 = !!f6 && n3.Ce.has(f6.key), p3 = !!h3 && (h3.bt || n3.Ce.has(h3.key) && h3.hasCommittedMutations), d3 = false;
      f6 && h3 ? f6.data().isEqual(h3.data()) ? l3 !== p3 && (r3.track({
        type: 3,
        doc: h3
      }), d3 = true) : n3.El(f6, h3) || (r3.track({
        type: 2,
        doc: h3
      }), d3 = true, (a3 && n3.ll(h3, a3) > 0 || c3 && n3.ll(h3, c3) < 0) && (s3 = true)) : !f6 && h3 ? (r3.track({
        type: 0,
        doc: h3
      }), d3 = true) : f6 && !h3 && (r3.track({
        type: 1,
        doc: f6
      }), d3 = true, (a3 || c3) && (s3 = true)), d3 && (h3 ? (u3 = u3.add(h3), o3 = p3 ? o3.add(t10) : o3.delete(t10)) : (u3 = u3.delete(t10), o3 = o3.delete(t10)));
    }), ae(this.query) || ce(this.query))
      for (; u3.size > this.query.limit; ) {
        var f3 = ae(this.query) ? u3.last() : u3.first();
        u3 = u3.delete(f3.key), o3 = o3.delete(f3.key), r3.track({
          type: 1,
          doc: f3
        });
      }
    return {
      _l: u3,
      wl: r3,
      _c: s3,
      Ce: o3
    };
  }, t3.prototype.El = function(t6, e28) {
    return t6.bt && e28.hasCommittedMutations && !e28.bt;
  }, t3.prototype.Ti = function(t6, e28, n3) {
    var r3 = this, i = this._l;
    this._l = t6._l, this.Ce = t6.Ce;
    var o3 = t6.wl.Se();
    o3.sort(function(t10, e29) {
      return function(t11, e30) {
        var n6 = function(t12) {
          switch (t12) {
            case 0:
              return 1;
            case 2:
            case 3:
              return 2;
            case 1:
              return 0;
            default:
              return S();
          }
        };
        return n6(t11) - n6(e30);
      }(t10.type, e29.type) || r3.ll(t10.doc, e29.doc);
    }), this.Tl(n3);
    var u3 = e28 ? this.Il() : [], s3 = this.hl.size === 0 && this.qe ? 1 : 0, a3 = s3 !== this.ul;
    return this.ul = s3, o3.length !== 0 || a3 ? {
      snapshot: new An(this.query, t6._l, i, o3, t6.Ce, s3 === 0, a3, false),
      ml: u3
    } : {
      ml: u3
    };
  }, t3.prototype.zh = function(t6) {
    return this.qe && t6 === "Offline" ? (this.qe = false, this.Ti({
      _l: this._l,
      wl: new Nn(),
      Ce: this.Ce,
      _c: false
    }, false)) : {
      ml: []
    };
  }, t3.prototype.Al = function(t6) {
    return !this.al.has(t6) && !!this._l.has(t6) && !this._l.get(t6).bt;
  }, t3.prototype.Tl = function(t6) {
    var e28 = this;
    t6 && (t6.Ue.forEach(function(t10) {
      return e28.al = e28.al.add(t10);
    }), t6.Qe.forEach(function(t10) {
    }), t6.Ke.forEach(function(t10) {
      return e28.al = e28.al.delete(t10);
    }), this.qe = t6.qe);
  }, t3.prototype.Il = function() {
    var t6 = this;
    if (!this.qe)
      return [];
    var e28 = this.hl;
    this.hl = In(), this._l.forEach(function(e29) {
      t6.Al(e29.key) && (t6.hl = t6.hl.add(e29.key));
    });
    var n3 = [];
    return e28.forEach(function(e29) {
      t6.hl.has(e29) || n3.push(new Fu(e29));
    }), this.hl.forEach(function(t10) {
      e28.has(t10) || n3.push(new qu(t10));
    }), n3;
  }, t3.prototype.Rl = function(t6) {
    this.al = t6.Pc, this.hl = In();
    var e28 = this.dl(t6.documents);
    return this.Ti(e28, true);
  }, t3.prototype.Pl = function() {
    return An.Fe(this.query, this._l, this.Ce, this.ul === 0);
  }, t3;
}(), zu = function(t3, e28, n3) {
  this.query = t3, this.targetId = e28, this.view = n3;
}, Gu = function(t3) {
  this.key = t3, this.yl = false;
}, Bu = function() {
  function t3(t6, e28, n3, r3, i, o3) {
    this.Sh = t6, this.gl = e28, this.Vl = n3, this.pl = r3, this.currentUser = i, this.bl = o3, this.vl = {}, this.Sl = new Ei(function(t10) {
      return me(t10);
    }, ye), this.Dl = new Map(), this.Cl = [], this.xl = new an(it.J), this.Nl = new Map(), this.Fl = new _o(), this.Ol = {}, this.kl = new Map(), this.Ml = Pi.qi(), this.onlineState = "Unknown", this.Ll = void 0;
  }
  return Object.defineProperty(t3.prototype, "$l", {
    get: function() {
      return this.Ll === true;
    },
    enumerable: false,
    configurable: true
  }), t3;
}();
function Ku(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    var n3, r3, i, o3, u3, s3;
    return __generator(this, function(a3) {
      switch (a3.label) {
        case 0:
          return n3 = bs(t3), (o3 = n3.Sl.get(e28)) ? (r3 = o3.targetId, n3.pl.ka(r3), i = o3.view.Pl(), [3, 4]) : [3, 1];
        case 1:
          return [4, lo(n3.Sh, de(e28))];
        case 2:
          return u3 = a3.sent(), s3 = n3.pl.ka(u3.targetId), r3 = u3.targetId, [4, Hu(n3, e28, r3, s3 === "current")];
        case 3:
          i = a3.sent(), n3.$l && iu(n3.gl, u3), a3.label = 4;
        case 4:
          return [2, i];
      }
    });
  });
}
function Hu(t3, e28, n3, r3) {
  return __awaiter(this, void 0, void 0, function() {
    var i, o3, u3, s3, a3, c3;
    return __generator(this, function(f3) {
      switch (f3.label) {
        case 0:
          return t3.Bl = function(e29, n6, r6) {
            return function(t6, e30, n10, r10) {
              return __awaiter(this, void 0, void 0, function() {
                var i3, o6, u6;
                return __generator(this, function(s4) {
                  switch (s4.label) {
                    case 0:
                      return i3 = e30.view.dl(n10), i3._c ? [4, vo(t6.Sh, e30.query, false).then(function(t10) {
                        var n11 = t10.documents;
                        return e30.view.dl(n11, i3);
                      })] : [3, 2];
                    case 1:
                      i3 = s4.sent(), s4.label = 2;
                    case 2:
                      return o6 = r10 && r10.Oe.get(e30.targetId), u6 = e30.view.Ti(i3, t6.$l, o6), [2, (os(t6, e30.targetId, u6.ml), u6.snapshot)];
                  }
                });
              });
            }(t3, e29, n6, r6);
          }, [4, vo(t3.Sh, e28, true)];
        case 1:
          return i = f3.sent(), o3 = new ju(e28, i.Pc), u3 = o3.dl(i.documents), s3 = xn.Be(n3, r3 && t3.onlineState !== "Offline"), a3 = o3.Ti(u3, t3.$l, s3), os(t3, n3, a3.ml), c3 = new zu(e28, n3, o3), [2, (t3.Sl.set(e28, c3), t3.Dl.has(n3) ? t3.Dl.get(n3).push(e28) : t3.Dl.set(n3, [e28]), a3.snapshot)];
      }
    });
  });
}
function Ju(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    var n3, r3, i;
    return __generator(this, function(o3) {
      switch (o3.label) {
        case 0:
          return n3 = D(t3), r3 = n3.Sl.get(e28), (i = n3.Dl.get(r3.targetId)).length > 1 ? [2, (n3.Dl.set(r3.targetId, i.filter(function(t6) {
            return !ye(t6, e28);
          })), void n3.Sl.delete(e28))] : n3.$l ? (n3.pl.La(r3.targetId), n3.pl.Ca(r3.targetId) ? [3, 2] : [4, po(n3.Sh, r3.targetId, false).then(function() {
            n3.pl.Ba(r3.targetId), ou(n3.gl, r3.targetId), rs(n3, r3.targetId);
          }).catch(_i)]) : [3, 3];
        case 1:
          o3.sent(), o3.label = 2;
        case 2:
          return [3, 5];
        case 3:
          return rs(n3, r3.targetId), [4, po(n3.Sh, r3.targetId, true)];
        case 4:
          o3.sent(), o3.label = 5;
        case 5:
          return [2];
      }
    });
  });
}
function Wu(t3, e28, n3) {
  return __awaiter(this, void 0, void 0, function() {
    var r3, i, o3, u3;
    return __generator(this, function(s3) {
      switch (s3.label) {
        case 0:
          r3 = Is(t3), s3.label = 1;
        case 1:
          return s3.trys.push([1, 5, , 6]), [4, function(t6, e29) {
            var n6, r6 = D(t6), i3 = X.now(), o6 = e29.reduce(function(t10, e30) {
              return t10.add(e30.key);
            }, In());
            return r6.persistence.runTransaction("Locally write mutations", "readwrite", function(t10) {
              return r6.Ic.Zo(t10, o6).next(function(o10) {
                n6 = o10;
                for (var u6 = [], s4 = 0, a3 = e29; s4 < a3.length; s4++) {
                  var c3 = a3[s4], f3 = Ke(c3, n6.get(c3.key));
                  f3 != null && u6.push(new Qe(c3.key, f3, Lt(f3.proto.mapValue), Fe.exists(true)));
                }
                return r6.Ho.yi(t10, i3, u6, e29);
              });
            }).then(function(t10) {
              var e30 = t10.Fs(n6);
              return {
                batchId: t10.batchId,
                ci: e30
              };
            });
          }(r3.Sh, e28)];
        case 2:
          return i = s3.sent(), r3.pl.xa(i.batchId), function(t6, e29, n6) {
            var r6 = t6.Ol[t6.currentUser.R()];
            r6 || (r6 = new an(P$1)), r6 = r6.Ht(e29, n6), t6.Ol[t6.currentUser.R()] = r6;
          }(r3, i.batchId, n3), [4, as$1(r3, i.ci)];
        case 3:
          return s3.sent(), [4, mu(r3.gl)];
        case 4:
          return s3.sent(), [3, 6];
        case 5:
          return o3 = s3.sent(), u3 = Sr(o3, "Failed to persist write"), n3.reject(u3), [3, 6];
        case 6:
          return [2];
      }
    });
  });
}
function Qu(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    var n3, r3;
    return __generator(this, function(i) {
      switch (i.label) {
        case 0:
          n3 = D(t3), i.label = 1;
        case 1:
          return i.trys.push([1, 4, , 6]), [4, co(n3.Sh, e28)];
        case 2:
          return r3 = i.sent(), e28.Oe.forEach(function(t6, e29) {
            var r6 = n3.Nl.get(e29);
            r6 && (x(t6.Ue.size + t6.Qe.size + t6.Ke.size <= 1), t6.Ue.size > 0 ? r6.yl = true : t6.Qe.size > 0 ? x(r6.yl) : t6.Ke.size > 0 && (x(r6.yl), r6.yl = false));
          }), [4, as$1(n3, r3, e28)];
        case 3:
          return i.sent(), [3, 6];
        case 4:
          return [4, _i(i.sent())];
        case 5:
          return i.sent(), [3, 6];
        case 6:
          return [2];
      }
    });
  });
}
function Yu(t3, e28, n3) {
  var r3 = D(t3);
  if (r3.$l && n3 === 0 || !r3.$l && n3 === 1) {
    var i = [];
    r3.Sl.forEach(function(t6, n6) {
      var r6 = n6.view.zh(e28);
      r6.snapshot && i.push(r6.snapshot);
    }), function(t6, e29) {
      var n6 = D(t6);
      n6.onlineState = e29;
      var r6 = false;
      n6.queries.forEach(function(t10, n10) {
        for (var i3 = 0, o3 = n10.listeners; i3 < o3.length; i3++) {
          o3[i3].zh(e29) && (r6 = true);
        }
      }), r6 && Cu(n6);
    }(r3.Vl, e28), i.length && r3.vl.uh(i), r3.onlineState = e28, r3.$l && r3.pl.Ka(e28);
  }
}
function $u(t3, e28, n3) {
  return __awaiter(this, void 0, void 0, function() {
    var r3, i, o3, u3, s3, a3;
    return __generator(this, function(c3) {
      switch (c3.label) {
        case 0:
          return (r3 = D(t3)).pl.qa(e28, "rejected", n3), i = r3.Nl.get(e28), (o3 = i && i.key) ? (u3 = (u3 = new an(it.J)).Ht(o3, new Mt(o3, Z.min())), s3 = In().add(o3), a3 = new Sn(Z.min(), new Map(), new hn(P$1), u3, s3), [4, Qu(r3, a3)]) : [3, 2];
        case 1:
          return c3.sent(), r3.xl = r3.xl.remove(o3), r3.Nl.delete(e28), ss(r3), [3, 4];
        case 2:
          return [4, po(r3.Sh, e28, false).then(function() {
            return rs(r3, e28, n3);
          }).catch(_i)];
        case 3:
          c3.sent(), c3.label = 4;
        case 4:
          return [2];
      }
    });
  });
}
function Xu(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    var n3, r3, i;
    return __generator(this, function(o3) {
      switch (o3.label) {
        case 0:
          n3 = D(t3), r3 = e28.batch.batchId, o3.label = 1;
        case 1:
          return o3.trys.push([1, 4, , 6]), [4, so(n3.Sh, e28)];
        case 2:
          return i = o3.sent(), ns(n3, r3, null), es(n3, r3), n3.pl.Fa(r3, "acknowledged"), [4, as$1(n3, i)];
        case 3:
          return o3.sent(), [3, 6];
        case 4:
          return [4, _i(o3.sent())];
        case 5:
          return o3.sent(), [3, 6];
        case 6:
          return [2];
      }
    });
  });
}
function Zu(t3, e28, n3) {
  return __awaiter(this, void 0, void 0, function() {
    var r3, i;
    return __generator(this, function(o3) {
      switch (o3.label) {
        case 0:
          r3 = D(t3), o3.label = 1;
        case 1:
          return o3.trys.push([1, 4, , 6]), [4, function(t6, e29) {
            var n6 = D(t6);
            return n6.persistence.runTransaction("Reject batch", "readwrite-primary", function(t10) {
              var r6;
              return n6.Ho.gi(t10, e29).next(function(e30) {
                return x(e30 !== null), r6 = e30.keys(), n6.Ho.Ni(t10, e30);
              }).next(function() {
                return n6.Ho.ki(t10);
              }).next(function() {
                return n6.Ic.Zo(t10, r6);
              });
            });
          }(r3.Sh, e28)];
        case 2:
          return i = o3.sent(), ns(r3, e28, n3), es(r3, e28), r3.pl.Fa(e28, "rejected", n3), [4, as$1(r3, i)];
        case 3:
          return o3.sent(), [3, 6];
        case 4:
          return [4, _i(o3.sent())];
        case 5:
          return o3.sent(), [3, 6];
        case 6:
          return [2];
      }
    });
  });
}
function ts(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    var n3, r3, i, o3, u3;
    return __generator(this, function(s3) {
      switch (s3.label) {
        case 0:
          fu((n3 = D(t3)).gl) || E("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled."), s3.label = 1;
        case 1:
          return s3.trys.push([1, 3, , 4]), [4, function(t6) {
            var e29 = D(t6);
            return e29.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", function(t10) {
              return e29.Ho.bi(t10);
            });
          }(n3.Sh)];
        case 2:
          return (r3 = s3.sent()) === -1 ? [2, void e28.resolve()] : ((i = n3.kl.get(r3) || []).push(e28), n3.kl.set(r3, i), [3, 4]);
        case 3:
          return o3 = s3.sent(), u3 = Sr(o3, "Initialization of waitForPendingWrites() operation failed"), e28.reject(u3), [3, 4];
        case 4:
          return [2];
      }
    });
  });
}
function es(t3, e28) {
  (t3.kl.get(e28) || []).forEach(function(t6) {
    t6.resolve();
  }), t3.kl.delete(e28);
}
function ns(t3, e28, n3) {
  var r3 = D(t3), i = r3.Ol[r3.currentUser.R()];
  if (i) {
    var o3 = i.get(e28);
    o3 && (n3 ? o3.reject(n3) : o3.resolve(), i = i.remove(e28)), r3.Ol[r3.currentUser.R()] = i;
  }
}
function rs(t3, e28, n3) {
  n3 === void 0 && (n3 = null), t3.pl.La(e28);
  for (var r3 = 0, i = t3.Dl.get(e28); r3 < i.length; r3++) {
    var o3 = i[r3];
    t3.Sl.delete(o3), n3 && t3.vl.ql(o3, n3);
  }
  t3.Dl.delete(e28), t3.$l && t3.Fl.kc(e28).forEach(function(e29) {
    t3.Fl.Mi(e29) || is(t3, e29);
  });
}
function is(t3, e28) {
  var n3 = t3.xl.get(e28);
  n3 !== null && (ou(t3.gl, n3), t3.xl = t3.xl.remove(e28), t3.Nl.delete(n3), ss(t3));
}
function os(t3, e28, n3) {
  for (var r3 = 0, i = n3; r3 < i.length; r3++) {
    var o3 = i[r3];
    o3 instanceof qu ? (t3.Fl.ir(o3.key, e28), us(t3, o3)) : o3 instanceof Fu ? (E("SyncEngine", "Document no longer in limbo: " + o3.key), t3.Fl.cr(o3.key, e28), t3.Fl.Mi(o3.key) || is(t3, o3.key)) : S();
  }
}
function us(t3, e28) {
  var n3 = e28.key;
  t3.xl.get(n3) || (E("SyncEngine", "New document in limbo: " + n3), t3.Cl.push(n3), ss(t3));
}
function ss(t3) {
  for (; t3.Cl.length > 0 && t3.xl.size < t3.bl; ) {
    var e28 = t3.Cl.shift(), n3 = t3.Ml.next();
    t3.Nl.set(n3, new Gu(e28)), t3.xl = t3.xl.Ht(e28, n3), iu(t3.gl, new _e(de(se(e28.path)), n3, 2, $.U));
  }
}
function as$1(t3, e28, n3) {
  return __awaiter(this, void 0, void 0, function() {
    var r3, i, o3, u3;
    return __generator(this, function(s3) {
      switch (s3.label) {
        case 0:
          return r3 = D(t3), i = [], o3 = [], u3 = [], r3.Sl.nt() ? [3, 3] : (r3.Sl.forEach(function(t6, s4) {
            u3.push(r3.Bl(s4, e28, n3).then(function(t10) {
              if (t10) {
                r3.$l && r3.pl.qa(s4.targetId, t10.fromCache ? "not-current" : "current"), i.push(t10);
                var e29 = no.cc(s4.targetId, t10);
                o3.push(e29);
              }
            }));
          }), [4, Promise.all(u3)]);
        case 1:
          return s3.sent(), r3.vl.uh(i), [4, function(t6, e29) {
            return __awaiter(this, void 0, void 0, function() {
              var n6, r6, i3, o6, u6, s4, a3, c3, f3;
              return __generator(this, function(h3) {
                switch (h3.label) {
                  case 0:
                    n6 = D(t6), h3.label = 1;
                  case 1:
                    return h3.trys.push([1, 3, , 4]), [4, n6.persistence.runTransaction("notifyLocalViewChanges", "readwrite", function(t10) {
                      return yr.forEach(e29, function(e30) {
                        return yr.forEach(e30.rc, function(r10) {
                          return n6.persistence.mi.ir(t10, e30.targetId, r10);
                        }).next(function() {
                          return yr.forEach(e30.oc, function(r10) {
                            return n6.persistence.mi.cr(t10, e30.targetId, r10);
                          });
                        });
                      });
                    })];
                  case 2:
                    return h3.sent(), [3, 4];
                  case 3:
                    if (!Ir(r6 = h3.sent()))
                      throw r6;
                    return E("LocalStore", "Failed to update sequence numbers: " + r6), [3, 4];
                  case 4:
                    for (i3 = 0, o6 = e29; i3 < o6.length; i3++)
                      u6 = o6[i3], s4 = u6.targetId, u6.fromCache || (a3 = n6.dc.get(s4), c3 = a3.Mt, f3 = a3.Bt(c3), n6.dc = n6.dc.Ht(s4, f3));
                    return [2];
                }
              });
            });
          }(r3.Sh, o3)];
        case 2:
          s3.sent(), s3.label = 3;
        case 3:
          return [2];
      }
    });
  });
}
function cs(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    var n3, r3;
    return __generator(this, function(i) {
      switch (i.label) {
        case 0:
          return (n3 = D(t3)).currentUser.isEqual(e28) ? [3, 3] : (E("SyncEngine", "User change. New user:", e28.R()), [4, uo(n3.Sh, e28)]);
        case 1:
          return r3 = i.sent(), n3.currentUser = e28, function(t6, e29) {
            t6.kl.forEach(function(t10) {
              t10.forEach(function(t11) {
                t11.reject(new M(V.CANCELLED, "'waitForPendingWrites' promise is rejected due to a user change."));
              });
            }), t6.kl.clear();
          }(n3), n3.pl.Qa(e28, r3.Ac, r3.Rc), [4, as$1(n3, r3.mc)];
        case 2:
          i.sent(), i.label = 3;
        case 3:
          return [2];
      }
    });
  });
}
function fs(t3, e28) {
  var n3 = D(t3), r3 = n3.Nl.get(e28);
  if (r3 && r3.yl)
    return In().add(r3.key);
  var i = In(), o3 = n3.Dl.get(e28);
  if (!o3)
    return i;
  for (var u3 = 0, s3 = o3; u3 < s3.length; u3++) {
    var a3 = s3[u3], c3 = n3.Sl.get(a3);
    i = i.ye(c3.view.fl);
  }
  return i;
}
function hs(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    var n3, r3, i;
    return __generator(this, function(o3) {
      switch (o3.label) {
        case 0:
          return [4, vo((n3 = D(t3)).Sh, e28.query, true)];
        case 1:
          return r3 = o3.sent(), i = e28.view.Rl(r3), [2, (n3.$l && os(n3, e28.targetId, i.ml), i)];
      }
    });
  });
}
function ls(t3) {
  return __awaiter(this, void 0, void 0, function() {
    var e28;
    return __generator(this, function(n3) {
      return [2, mo((e28 = D(t3)).Sh).then(function(t6) {
        return as$1(e28, t6);
      })];
    });
  });
}
function ps(t3, e28, n3, r3) {
  return __awaiter(this, void 0, void 0, function() {
    var i, o3;
    return __generator(this, function(u3) {
      switch (u3.label) {
        case 0:
          return [4, function(t6, e29) {
            var n6 = D(t6), r6 = D(n6.Ho);
            return n6.persistence.runTransaction("Lookup mutation documents", "readonly", function(t10) {
              return r6.Vi(t10, e29).next(function(e30) {
                return e30 ? n6.Ic.Zo(t10, e30) : yr.resolve(null);
              });
            });
          }((i = D(t3)).Sh, e28)];
        case 1:
          return (o3 = u3.sent()) === null ? [3, 6] : n3 !== "pending" ? [3, 3] : [4, mu(i.gl)];
        case 2:
          return u3.sent(), [3, 4];
        case 3:
          n3 === "acknowledged" || n3 === "rejected" ? (ns(i, e28, r3 || null), es(i, e28), function(t6, e29) {
            D(D(t6).Ho).Fi(e29);
          }(i.Sh, e28)) : S(), u3.label = 4;
        case 4:
          return [4, as$1(i, o3)];
        case 5:
          return u3.sent(), [3, 7];
        case 6:
          E("SyncEngine", "Cannot apply mutation batch with id: " + e28), u3.label = 7;
        case 7:
          return [2];
      }
    });
  });
}
function ds(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    var n3, r3, i, o3, u3, s3, a3, c3;
    return __generator(this, function(f3) {
      switch (f3.label) {
        case 0:
          return bs(n3 = D(t3)), Is(n3), e28 !== true || n3.Ll === true ? [3, 3] : (r3 = n3.pl.Sa(), [4, vs(n3, r3.rt())]);
        case 1:
          return i = f3.sent(), n3.Ll = true, [4, Tu(n3.gl, true)];
        case 2:
          for (f3.sent(), o3 = 0, u3 = i; o3 < u3.length; o3++)
            s3 = u3[o3], iu(n3.gl, s3);
          return [3, 7];
        case 3:
          return e28 !== false || n3.Ll === false ? [3, 7] : (a3 = [], c3 = Promise.resolve(), n3.Dl.forEach(function(t6, e29) {
            n3.pl.$a(e29) ? a3.push(e29) : c3 = c3.then(function() {
              return rs(n3, e29), po(n3.Sh, e29, true);
            }), ou(n3.gl, e29);
          }), [4, c3]);
        case 4:
          return f3.sent(), [4, vs(n3, a3)];
        case 5:
          return f3.sent(), function(t6) {
            var e29 = D(t6);
            e29.Nl.forEach(function(t10, n6) {
              ou(e29.gl, n6);
            }), e29.Fl.Mc(), e29.Nl = new Map(), e29.xl = new an(it.J);
          }(n3), n3.Ll = false, [4, Tu(n3.gl, false)];
        case 6:
          f3.sent(), f3.label = 7;
        case 7:
          return [2];
      }
    });
  });
}
function vs(t3, e28, n3) {
  return __awaiter(this, void 0, void 0, function() {
    var n6, r3, i, o3, u3, s3, a3, c3, f3, h3, l3, p3, d3, v3;
    return __generator(this, function(y3) {
      switch (y3.label) {
        case 0:
          n6 = D(t3), r3 = [], i = [], o3 = 0, u3 = e28, y3.label = 1;
        case 1:
          return o3 < u3.length ? (s3 = u3[o3], a3 = void 0, (c3 = n6.Dl.get(s3)) && c3.length !== 0 ? [4, lo(n6.Sh, de(c3[0]))] : [3, 7]) : [3, 13];
        case 2:
          a3 = y3.sent(), f3 = 0, h3 = c3, y3.label = 3;
        case 3:
          return f3 < h3.length ? (l3 = h3[f3], p3 = n6.Sl.get(l3), [4, hs(n6, p3)]) : [3, 6];
        case 4:
          (d3 = y3.sent()).snapshot && i.push(d3.snapshot), y3.label = 5;
        case 5:
          return f3++, [3, 3];
        case 6:
          return [3, 11];
        case 7:
          return [4, yo(n6.Sh, s3)];
        case 8:
          return v3 = y3.sent(), [4, lo(n6.Sh, v3)];
        case 9:
          return a3 = y3.sent(), [4, Hu(n6, ys(v3), s3, false)];
        case 10:
          y3.sent(), y3.label = 11;
        case 11:
          r3.push(a3), y3.label = 12;
        case 12:
          return o3++, [3, 1];
        case 13:
          return [2, (n6.vl.uh(i), r3)];
      }
    });
  });
}
function ys(t3) {
  return ue(t3.path, t3.collectionGroup, t3.orderBy, t3.filters, t3.limit, "F", t3.startAt, t3.endAt);
}
function ms(t3) {
  var e28 = D(t3);
  return D(D(e28.Sh).persistence).Ko();
}
function gs(t3, e28, n3, r3) {
  return __awaiter(this, void 0, void 0, function() {
    var i, o3, u3;
    return __generator(this, function(s3) {
      switch (s3.label) {
        case 0:
          return (i = D(t3)).Ll ? (E("SyncEngine", "Ignoring unexpected query state notification."), [3, 8]) : [3, 1];
        case 1:
          if (!i.Dl.has(e28))
            return [3, 8];
          switch (n3) {
            case "current":
            case "not-current":
              return [3, 2];
            case "rejected":
              return [3, 5];
          }
          return [3, 7];
        case 2:
          return [4, mo(i.Sh)];
        case 3:
          return o3 = s3.sent(), u3 = Sn.$e(e28, n3 === "current"), [4, as$1(i, o3, u3)];
        case 4:
          return s3.sent(), [3, 8];
        case 5:
          return [4, po(i.Sh, e28, true)];
        case 6:
          return s3.sent(), rs(i, e28, r3), [3, 8];
        case 7:
          S(), s3.label = 8;
        case 8:
          return [2];
      }
    });
  });
}
function ws(t3, e28, n3) {
  return __awaiter(this, void 0, void 0, function() {
    var r3, i, o3, u3, s3, a3, c3, f3, h3, l3;
    return __generator(this, function(p3) {
      switch (p3.label) {
        case 0:
          if (!(r3 = bs(t3)).Ll)
            return [3, 10];
          i = 0, o3 = e28, p3.label = 1;
        case 1:
          return i < o3.length ? (u3 = o3[i], r3.Dl.has(u3) ? (E("SyncEngine", "Adding an already active target " + u3), [3, 5]) : [4, yo(r3.Sh, u3)]) : [3, 6];
        case 2:
          return s3 = p3.sent(), [4, lo(r3.Sh, s3)];
        case 3:
          return a3 = p3.sent(), [4, Hu(r3, ys(s3), a3.targetId, false)];
        case 4:
          p3.sent(), iu(r3.gl, a3), p3.label = 5;
        case 5:
          return i++, [3, 1];
        case 6:
          c3 = function(t6) {
            return __generator(this, function(e29) {
              switch (e29.label) {
                case 0:
                  return r3.Dl.has(t6) ? [4, po(r3.Sh, t6, false).then(function() {
                    ou(r3.gl, t6), rs(r3, t6);
                  }).catch(_i)] : [3, 2];
                case 1:
                  e29.sent(), e29.label = 2;
                case 2:
                  return [2];
              }
            });
          }, f3 = 0, h3 = n3, p3.label = 7;
        case 7:
          return f3 < h3.length ? (l3 = h3[f3], [5, c3(l3)]) : [3, 10];
        case 8:
          p3.sent(), p3.label = 9;
        case 9:
          return f3++, [3, 7];
        case 10:
          return [2];
      }
    });
  });
}
function bs(t3) {
  var e28 = D(t3);
  return e28.gl.Ch.Bh = Qu.bind(null, e28), e28.gl.Ch.Sn = fs.bind(null, e28), e28.gl.Ch.$h = $u.bind(null, e28), e28.vl.uh = Ou.bind(null, e28.Vl), e28.vl.ql = Pu.bind(null, e28.Vl), e28;
}
function Is(t3) {
  var e28 = D(t3);
  return e28.gl.Ch.qh = Xu.bind(null, e28), e28.gl.Ch.Uh = Zu.bind(null, e28), e28;
}
function _s(t3, e28, n3) {
  var r3 = D(t3);
  (function(t6, e29, n6) {
    return __awaiter(this, void 0, void 0, function() {
      var r6, i, o3, u3, s3, a3;
      return __generator(this, function(c3) {
        switch (c3.label) {
          case 0:
            return c3.trys.push([0, 14, , 15]), [4, e29.getMetadata()];
          case 1:
            return r6 = c3.sent(), [4, function(t10, e30) {
              var n10 = D(t10), r10 = zn(e30.createTime);
              return n10.persistence.runTransaction("hasNewerBundle", "readonly", function(t11) {
                return n10.To.Ls(t11, e30.id);
              }).then(function(t11) {
                return !!t11 && t11.createTime.u(r10) >= 0;
              });
            }(t6.Sh, r6)];
          case 2:
            return c3.sent() ? [4, e29.close()] : [3, 4];
          case 3:
            return [2, (c3.sent(), void n6.Ul(function(t10) {
              return {
                taskState: "Success",
                documentsLoaded: t10.totalDocuments,
                bytesLoaded: t10.totalBytes,
                totalDocuments: t10.totalDocuments,
                totalBytes: t10.totalBytes
              };
            }(r6)))];
          case 4:
            return n6.Ql(Uu(r6)), i = new Mu(r6, t6.Sh, e29.Kt), [4, e29.Kl()];
          case 5:
            o3 = c3.sent(), c3.label = 6;
          case 6:
            return o3 ? [4, i.ol(o3)] : [3, 10];
          case 7:
            return (u3 = c3.sent()) && n6.Ql(u3), [4, e29.Kl()];
          case 8:
            o3 = c3.sent(), c3.label = 9;
          case 9:
            return [3, 6];
          case 10:
            return [4, i.complete()];
          case 11:
            return s3 = c3.sent(), [4, as$1(t6, s3.gs, void 0)];
          case 12:
            return c3.sent(), [4, function(t10, e30) {
              var n10 = D(t10);
              return n10.persistence.runTransaction("Save bundle", "readwrite", function(t11) {
                return n10.To.$s(t11, e30);
              });
            }(t6.Sh, r6)];
          case 13:
            return c3.sent(), n6.Ul(s3.progress), [3, 15];
          case 14:
            return N("SyncEngine", "Loading bundle failed with " + (a3 = c3.sent())), n6.Wl(a3), [3, 15];
          case 15:
            return [2];
        }
      });
    });
  })(r3, e28, n3).then(function() {
    r3.pl.ja();
  });
}
var Es = function() {
  function t3() {
    this.synchronizeTabs = false;
  }
  return t3.prototype.initialize = function(t6) {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(e28) {
        switch (e28.label) {
          case 0:
            return this.Kt = Wo(t6.gu.T), this.pl = this.jl(t6), this.persistence = this.Gl(t6), [4, this.persistence.start()];
          case 1:
            return e28.sent(), this.zl = this.Hl(t6), this.Sh = this.Jl(t6), [2];
        }
      });
    });
  }, t3.prototype.Hl = function(t6) {
    return null;
  }, t3.prototype.Jl = function(t6) {
    return oo(this.persistence, new ro(), t6.Yl, this.Kt);
  }, t3.prototype.Gl = function(t6) {
    return new xo(ko.ra, this.Kt);
  }, t3.prototype.jl = function(t6) {
    return new Fo();
  }, t3.prototype.terminate = function() {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(t6) {
        switch (t6.label) {
          case 0:
            return this.zl && this.zl.stop(), [4, this.pl.$o()];
          case 1:
            return t6.sent(), [4, this.persistence.$o()];
          case 2:
            return t6.sent(), [2];
        }
      });
    });
  }, t3;
}(), Ts = function(t3) {
  function e28(e29, n3, r3) {
    var i = this;
    return (i = t3.call(this) || this).Xl = e29, i.cacheSizeBytes = n3, i.forceOwnership = r3, i.synchronizeTabs = false, i;
  }
  return __extends$1(e28, t3), e28.prototype.initialize = function(e29) {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(n3) {
        switch (n3.label) {
          case 0:
            return [4, t3.prototype.initialize.call(this, e29)];
          case 1:
            return n3.sent(), [4, go(this.Sh)];
          case 2:
            return n3.sent(), [4, this.Xl.initialize(this, e29)];
          case 3:
            return n3.sent(), [4, Is(this.Xl.fa)];
          case 4:
            return n3.sent(), [4, mu(this.Xl.gl)];
          case 5:
            return n3.sent(), [2];
        }
      });
    });
  }, e28.prototype.Jl = function(t6) {
    return oo(this.persistence, new ro(), t6.Yl, this.Kt);
  }, e28.prototype.Hl = function(t6) {
    var e29 = this.persistence.mi.dr;
    return new qi(e29, t6.fs);
  }, e28.prototype.Gl = function(t6) {
    var e29 = to$1(t6.gu.T, t6.gu.persistenceKey), n3 = this.cacheSizeBytes !== void 0 ? Ii.Zs(this.cacheSizeBytes) : Ii.ni;
    return new $i(this.synchronizeTabs, e29, t6.clientId, n3, t6.fs, Ho(), Jo(), this.Kt, this.pl, !!this.forceOwnership);
  }, e28.prototype.jl = function(t6) {
    return new Fo();
  }, e28;
}(Es), Ns = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, e29, n3, false) || this).Xl = e29, r3.cacheSizeBytes = n3, r3.synchronizeTabs = true, r3;
  }
  return __extends$1(e28, t3), e28.prototype.initialize = function(e29) {
    return __awaiter(this, void 0, void 0, function() {
      var n3, r3 = this;
      return __generator(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, t3.prototype.initialize.call(this, e29)];
          case 1:
            return i.sent(), n3 = this.Xl.fa, this.pl instanceof qo ? (this.pl.fa = {
              nu: ps.bind(null, n3),
              su: gs.bind(null, n3),
              iu: ws.bind(null, n3),
              Ko: ms.bind(null, n3),
              eu: ls.bind(null, n3)
            }, [4, this.pl.start()]) : [3, 3];
          case 2:
            i.sent(), i.label = 3;
          case 3:
            return [4, this.persistence.yo(function(t6) {
              return __awaiter(r3, void 0, void 0, function() {
                return __generator(this, function(e30) {
                  switch (e30.label) {
                    case 0:
                      return [4, ds(this.Xl.fa, t6)];
                    case 1:
                      return e30.sent(), this.zl && (t6 && !this.zl.Ir ? this.zl.start(this.Sh) : t6 || this.zl.stop()), [2];
                  }
                });
              });
            })];
          case 4:
            return i.sent(), [2];
        }
      });
    });
  }, e28.prototype.jl = function(t6) {
    var e29 = Ho();
    if (!qo.Wn(e29))
      throw new M(V.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
    var n3 = to$1(t6.gu.T, t6.gu.persistenceKey);
    return new qo(e29, t6.fs, n3, t6.clientId, t6.Yl);
  }, e28;
}(Ts), As = function() {
  function t3() {
  }
  return t3.prototype.initialize = function(t6, e28) {
    return __awaiter(this, void 0, void 0, function() {
      var n3 = this;
      return __generator(this, function(r3) {
        switch (r3.label) {
          case 0:
            return this.Sh ? [3, 2] : (this.Sh = t6.Sh, this.pl = t6.pl, this.Dh = this.Zl(e28), this.gl = this.t_(e28), this.Vl = this.e_(e28), this.fa = this.n_(e28, !t6.synchronizeTabs), this.pl.da = function(t10) {
              return Yu(n3.fa, t10, 1);
            }, this.gl.Ch.s_ = cs.bind(null, this.fa), [4, Tu(this.gl, this.fa.$l)]);
          case 1:
            r3.sent(), r3.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, t3.prototype.e_ = function(t6) {
    return new xu();
  }, t3.prototype.Zl = function(t6) {
    var e28, n3 = Wo(t6.gu.T), r3 = (e28 = t6.gu, new Ko(e28));
    return function(t10, e29, n6) {
      return new Zo(t10, e29, n6);
    }(t6.credentials, r3, n3);
  }, t3.prototype.t_ = function(t6) {
    var e28, n3, r3, i, o3, u3 = this;
    return e28 = this.Sh, n3 = this.Dh, r3 = t6.fs, i = function(t10) {
      return Yu(u3.fa, t10, 0);
    }, o3 = zo.Wn() ? new zo() : new jo(), new eu(e28, n3, r3, i, o3);
  }, t3.prototype.n_ = function(t6, e28) {
    return function(t10, e29, n3, r3, i, o3, u3) {
      var s3 = new Bu(t10, e29, n3, r3, i, o3);
      return u3 && (s3.Ll = true), s3;
    }(this.Sh, this.gl, this.Vl, this.pl, t6.Yl, t6.bl, e28);
  }, t3.prototype.terminate = function() {
    return function(t6) {
      return __awaiter(this, void 0, void 0, function() {
        var e28;
        return __generator(this, function(n3) {
          switch (n3.label) {
            case 0:
              return e28 = D(t6), E("RemoteStore", "RemoteStore shutting down."), e28.Fh.add(5), [4, ru(e28)];
            case 1:
              return n3.sent(), e28.kh.$o(), e28.Mh.set("Unknown"), [2];
          }
        });
      });
    }(this.gl);
  }, t3;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ss(t3, e28) {
  e28 === void 0 && (e28 = 10240);
  var n3 = 0;
  return {
    read: function() {
      return __awaiter(this, void 0, void 0, function() {
        var r3;
        return __generator(this, function(i) {
          return n3 < t3.byteLength ? (r3 = {
            value: t3.slice(n3, n3 + e28),
            done: false
          }, [2, (n3 += e28, r3)]) : [2, {
            done: true
          }];
        });
      });
    },
    cancel: function() {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(t6) {
          return [2];
        });
      });
    },
    releaseLock: function() {
    }
  };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var xs = function() {
  function t3(t6) {
    this.observer = t6, this.muted = false;
  }
  return t3.prototype.next = function(t6) {
    this.observer.next && this.i_(this.observer.next, t6);
  }, t3.prototype.error = function(t6) {
    this.observer.error ? this.i_(this.observer.error, t6) : console.error("Uncaught Error in snapshot listener:", t6);
  }, t3.prototype.r_ = function() {
    this.muted = true;
  }, t3.prototype.i_ = function(t6, e28) {
    var n3 = this;
    this.muted || setTimeout(function() {
      n3.muted || t6(e28);
    }, 0);
  }, t3;
}(), Ds = function() {
  function t3(t6, e28) {
    var n3 = this;
    this.o_ = t6, this.Kt = e28, this.metadata = new vr(), this.buffer = new Uint8Array(), this.c_ = new TextDecoder("utf-8"), this.a_().then(function(t10) {
      t10 && t10.il() ? n3.metadata.resolve(t10.payload.metadata) : n3.metadata.reject(new Error("The first element of the bundle is not a metadata, it is\n             " + JSON.stringify(t10 == null ? void 0 : t10.payload)));
    }, function(t10) {
      return n3.metadata.reject(t10);
    });
  }
  return t3.prototype.close = function() {
    return this.o_.cancel();
  }, t3.prototype.getMetadata = function() {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(t6) {
        return [2, this.metadata.promise];
      });
    });
  }, t3.prototype.Kl = function() {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(t6) {
        switch (t6.label) {
          case 0:
            return [4, this.getMetadata()];
          case 1:
            return [2, (t6.sent(), this.a_())];
        }
      });
    });
  }, t3.prototype.a_ = function() {
    return __awaiter(this, void 0, void 0, function() {
      var t6, e28, n3, r3;
      return __generator(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, this.u_()];
          case 1:
            return (t6 = i.sent()) === null ? [2, null] : (e28 = this.c_.decode(t6), n3 = Number(e28), isNaN(n3) && this.h_("length string (" + e28 + ") is not valid number"), [4, this.l_(n3)]);
          case 2:
            return r3 = i.sent(), [2, new Ru(JSON.parse(r3), t6.length + n3)];
        }
      });
    });
  }, t3.prototype.__ = function() {
    return this.buffer.findIndex(function(t6) {
      return t6 === "{".charCodeAt(0);
    });
  }, t3.prototype.u_ = function() {
    return __awaiter(this, void 0, void 0, function() {
      var t6, e28;
      return __generator(this, function(n3) {
        switch (n3.label) {
          case 0:
            return this.__() < 0 ? [4, this.f_()] : [3, 3];
          case 1:
            if (n3.sent())
              return [3, 3];
            n3.label = 2;
          case 2:
            return [3, 0];
          case 3:
            return this.buffer.length === 0 ? [2, null] : ((t6 = this.__()) < 0 && this.h_("Reached the end of bundle when a length string is expected."), e28 = this.buffer.slice(0, t6), [2, (this.buffer = this.buffer.slice(t6), e28)]);
        }
      });
    });
  }, t3.prototype.l_ = function(t6) {
    return __awaiter(this, void 0, void 0, function() {
      var e28;
      return __generator(this, function(n3) {
        switch (n3.label) {
          case 0:
            return this.buffer.length < t6 ? [4, this.f_()] : [3, 3];
          case 1:
            n3.sent() && this.h_("Reached the end of bundle when more is expected."), n3.label = 2;
          case 2:
            return [3, 0];
          case 3:
            return e28 = this.c_.decode(this.buffer.slice(0, t6)), [2, (this.buffer = this.buffer.slice(t6), e28)];
        }
      });
    });
  }, t3.prototype.h_ = function(t6) {
    throw this.o_.cancel(), new Error("Invalid bundle format: " + t6);
  }, t3.prototype.f_ = function() {
    return __awaiter(this, void 0, void 0, function() {
      var t6, e28;
      return __generator(this, function(n3) {
        switch (n3.label) {
          case 0:
            return [4, this.o_.read()];
          case 1:
            return (t6 = n3.sent()).done || ((e28 = new Uint8Array(this.buffer.length + t6.value.length)).set(this.buffer), e28.set(t6.value, this.buffer.length), this.buffer = e28), [2, t6.done];
        }
      });
    });
  }, t3;
}(), ks = function() {
  function t3() {
    for (var t6 = [], e28 = 0; e28 < arguments.length; e28++)
      t6[e28] = arguments[e28];
    for (var n3 = 0; n3 < t6.length; ++n3)
      if (t6[n3].length === 0)
        throw new M(V.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
    this.d_ = new rt(t6);
  }
  return t3.prototype.isEqual = function(t6) {
    return this.d_.isEqual(t6.d_);
  }, t3;
}(), Os = function(t3) {
  this._methodName = t3;
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ps(t3, e28, n3) {
  if (!n3)
    throw new M(V.INVALID_ARGUMENT, "Function " + t3 + "() cannot be called with an empty " + e28 + ".");
}
function Cs(t3, e28) {
  if (e28 === void 0)
    return {
      merge: false
    };
  if (e28.mergeFields !== void 0 && e28.merge !== void 0)
    throw new M(V.INVALID_ARGUMENT, "Invalid options passed to function " + t3 + '(): You cannot specify both "merge" and "mergeFields".');
  return e28;
}
function Ls(t3, e28, n3, r3) {
  if (e28 === true && r3 === true)
    throw new M(V.INVALID_ARGUMENT, t3 + " and " + n3 + " cannot be used together.");
}
function Rs(t3) {
  if (!it.Et(t3))
    throw new M(V.INVALID_ARGUMENT, "Invalid document reference. Document references must have an even number of segments, but " + t3 + " has " + t3.length + ".");
}
function Vs(t3) {
  if (it.Et(t3))
    throw new M(V.INVALID_ARGUMENT, "Invalid collection reference. Collection references must have an odd number of segments, but " + t3 + " has " + t3.length + ".");
}
function Ms(t3) {
  if (t3 === void 0)
    return "undefined";
  if (t3 === null)
    return "null";
  if (typeof t3 == "string")
    return t3.length > 20 && (t3 = t3.substring(0, 20) + "..."), JSON.stringify(t3);
  if (typeof t3 == "number" || typeof t3 == "boolean")
    return "" + t3;
  if (typeof t3 == "object") {
    if (t3 instanceof Array)
      return "an array";
    var e28 = function(t6) {
      if (t6.constructor) {
        var e29 = /function\s+([^\s(]+)\s*\(/.exec(t6.constructor.toString());
        if (e29 && e29.length > 1)
          return e29[1];
      }
      return null;
    }(t3);
    return e28 ? "a custom " + e28 + " object" : "an object";
  }
  return typeof t3 == "function" ? "a function" : S();
}
function Us(t3, e28) {
  if ("_delegate" in t3 && (t3 = t3._), !(t3 instanceof e28)) {
    if (e28.name === t3.constructor.name)
      throw new M(V.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
    var n3 = Ms(t3);
    throw new M(V.INVALID_ARGUMENT, "Expected type '" + e28.name + "', but it was: " + n3);
  }
  return t3;
}
function qs(t3, e28) {
  if (e28 <= 0)
    throw new M(V.INVALID_ARGUMENT, "Function " + t3 + "() requires a positive number, but it was: " + e28 + ".");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Fs = function() {
  function t3(t6) {
    var e28;
    if (t6.host === void 0) {
      if (t6.ssl !== void 0)
        throw new M(V.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
      this.host = "firestore.googleapis.com", this.ssl = true;
    } else
      this.host = t6.host, this.ssl = (e28 = t6.ssl) === null || e28 === void 0 || e28;
    if (this.credentials = t6.credentials, this.ignoreUndefinedProperties = !!t6.ignoreUndefinedProperties, t6.cacheSizeBytes === void 0)
      this.cacheSizeBytes = 41943040;
    else {
      if (t6.cacheSizeBytes !== -1 && t6.cacheSizeBytes < 1048576)
        throw new M(V.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
      this.cacheSizeBytes = t6.cacheSizeBytes;
    }
    this.experimentalForceLongPolling = !!t6.experimentalForceLongPolling, this.experimentalAutoDetectLongPolling = !!t6.experimentalAutoDetectLongPolling, Ls("experimentalForceLongPolling", t6.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", t6.experimentalAutoDetectLongPolling);
  }
  return t3.prototype.isEqual = function(t6) {
    return this.host === t6.host && this.ssl === t6.ssl && this.credentials === t6.credentials && this.cacheSizeBytes === t6.cacheSizeBytes && this.experimentalForceLongPolling === t6.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === t6.experimentalAutoDetectLongPolling && this.ignoreUndefinedProperties === t6.ignoreUndefinedProperties;
  }, t3;
}(), js = new Map(), zs = function() {
  function t3(t6, e28) {
    this.w_ = "(lite)", this.E_ = new Fs({}), this.T_ = false, t6 instanceof B ? (this.I_ = t6, this.m_ = new J()) : (this.A_ = t6, this.I_ = function(t10) {
      if (!Object.prototype.hasOwnProperty.apply(t10.options, ["projectId"]))
        throw new M(V.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
      return new B(t10.options.projectId);
    }(t6), this.m_ = new W(e28));
  }
  return Object.defineProperty(t3.prototype, "app", {
    get: function() {
      if (!this.A_)
        throw new M(V.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
      return this.A_;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "R_", {
    get: function() {
      return this.T_;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "P_", {
    get: function() {
      return this.y_ !== void 0;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.g_ = function(t6) {
    if (this.T_)
      throw new M(V.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
    this.E_ = new Fs(t6), t6.credentials !== void 0 && (this.m_ = function(t10) {
      if (!t10)
        return new J();
      switch (t10.type) {
        case "gapi":
          var e28 = t10.client;
          return x(!(typeof e28 != "object" || e28 === null || !e28.auth || !e28.auth.getAuthHeaderValueForFirstParty)), new Y(e28, t10.sessionIndex || "0");
        case "provider":
          return t10.client;
        default:
          throw new M(V.INVALID_ARGUMENT, "makeCredentialsProvider failed due to invalid credential type");
      }
    }(t6.credentials));
  }, t3.prototype.V_ = function() {
    return this.E_;
  }, t3.prototype.p_ = function() {
    return this.T_ = true, this.E_;
  }, t3.prototype._delete = function() {
    return this.y_ || (this.y_ = this.b_()), this.y_;
  }, t3.prototype.b_ = function() {
    return t6 = this, (e28 = js.get(t6)) && (E("ComponentProvider", "Removing Datastore"), js.delete(t6), e28.terminate()), Promise.resolve();
    var t6, e28;
  }, t3;
}(), Gs = function() {
  function t3(t6, e28, n3) {
    this.v_ = e28, this.S_ = n3, this.type = "document", this.firestore = t6;
  }
  return Object.defineProperty(t3.prototype, "D_", {
    get: function() {
      return this.S_.path;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "id", {
    get: function() {
      return this.S_.path.et();
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "path", {
    get: function() {
      return this.S_.path.ot();
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "parent", {
    get: function() {
      return new Ks(this.firestore, this.v_, this.S_.path.Z());
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.withConverter = function(e28) {
    return new t3(this.firestore, e28, this.S_);
  }, t3;
}(), Bs = function() {
  function t3(t6, e28, n3) {
    this.v_ = e28, this.C_ = n3, this.type = "query", this.firestore = t6;
  }
  return t3.prototype.withConverter = function(e28) {
    return new t3(this.firestore, e28, this.C_);
  }, t3;
}(), Ks = function(t3) {
  function e28(e29, n3, r3) {
    var i = this;
    return (i = t3.call(this, e29, n3, se(r3)) || this).firestore = e29, i.D_ = r3, i.type = "collection", i;
  }
  return __extends$1(e28, t3), Object.defineProperty(e28.prototype, "id", {
    get: function() {
      return this.C_.path.et();
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "path", {
    get: function() {
      return this.C_.path.ot();
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "parent", {
    get: function() {
      var t6 = this.D_.Z();
      return t6.nt() ? null : new Gs(this.firestore, null, new it(t6));
    },
    enumerable: false,
    configurable: true
  }), e28.prototype.withConverter = function(t6) {
    return new e28(this.firestore, t6, this.D_);
  }, e28;
}(Bs);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Hs(t3, e28) {
  for (var n3, r3 = [], i = 2; i < arguments.length; i++)
    r3[i - 2] = arguments[i];
  if (t3 instanceof q && (t3 = t3._), Ps("collection", "path", e28), t3 instanceof zs)
    return Vs(n3 = et.ct.apply(et, __spreadArrays$1([e28], r3))), new Ks(t3, null, n3);
  if (!(t3 instanceof Gs || t3 instanceof Ks))
    throw new M(V.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
  return Vs(n3 = et.ct.apply(et, __spreadArrays$1([t3.path], r3)).child(et.ct(e28))), new Ks(t3.firestore, null, n3);
}
function Js(t3, e28) {
  for (var n3, r3 = [], i = 2; i < arguments.length; i++)
    r3[i - 2] = arguments[i];
  if (t3 instanceof q && (t3 = t3._), arguments.length === 1 && (e28 = O.t()), Ps("doc", "path", e28), t3 instanceof zs)
    return Rs(n3 = et.ct.apply(et, __spreadArrays$1([e28], r3))), new Gs(t3, null, new it(n3));
  if (!(t3 instanceof Gs || t3 instanceof Ks))
    throw new M(V.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
  return Rs(n3 = t3.D_.child(et.ct.apply(et, __spreadArrays$1([e28], r3)))), new Gs(t3.firestore, t3 instanceof Ks ? t3.v_ : null, new it(n3));
}
function Ws(t3, e28) {
  return t3 instanceof q && (t3 = t3._), e28 instanceof q && (e28 = e28._), (t3 instanceof Gs || t3 instanceof Ks) && (e28 instanceof Gs || e28 instanceof Ks) && t3.firestore === e28.firestore && t3.path === e28.path && t3.v_ === e28.v_;
}
function Qs(t3, e28) {
  return t3 instanceof q && (t3 = t3._), e28 instanceof q && (e28 = e28._), t3 instanceof Bs && e28 instanceof Bs && t3.firestore === e28.firestore && ye(t3.C_, e28.C_) && t3.v_ === e28.v_;
}
var Ys = function() {
  function t3(t6, e28) {
    if (!isFinite(t6) || t6 < -90 || t6 > 90)
      throw new M(V.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + t6);
    if (!isFinite(e28) || e28 < -180 || e28 > 180)
      throw new M(V.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + e28);
    this.x_ = t6, this.N_ = e28;
  }
  return Object.defineProperty(t3.prototype, "latitude", {
    get: function() {
      return this.x_;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "longitude", {
    get: function() {
      return this.N_;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.isEqual = function(t6) {
    return this.x_ === t6.x_ && this.N_ === t6.N_;
  }, t3.prototype.toJSON = function() {
    return {
      latitude: this.x_,
      longitude: this.N_
    };
  }, t3.prototype.K = function(t6) {
    return P$1(this.x_, t6.x_) || P$1(this.N_, t6.N_);
  }, t3;
}(), $s = /^__.*__$/, Xs = function() {
  function t3(t6, e28, n3) {
    this.data = t6, this.zt = e28, this.fieldTransforms = n3;
  }
  return t3.prototype.F_ = function(t6, e28) {
    return this.zt !== null ? new Qe(t6, this.data, this.zt, e28, this.fieldTransforms) : new We(t6, this.data, e28, this.fieldTransforms);
  }, t3;
}(), Zs = function() {
  function t3(t6, e28, n3) {
    this.data = t6, this.zt = e28, this.fieldTransforms = n3;
  }
  return t3.prototype.F_ = function(t6, e28) {
    return new Qe(t6, this.data, this.zt, e28, this.fieldTransforms);
  }, t3;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ta(t3) {
  switch (t3) {
    case 0:
    case 2:
    case 1:
      return true;
    case 3:
    case 4:
      return false;
    default:
      throw S();
  }
}
var ea = function() {
  function t3(t6, e28, n3, r3, i, o3) {
    this.settings = t6, this.T = e28, this.Kt = n3, this.ignoreUndefinedProperties = r3, i === void 0 && this.O_(), this.fieldTransforms = i || [], this.zt = o3 || [];
  }
  return Object.defineProperty(t3.prototype, "path", {
    get: function() {
      return this.settings.path;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "k_", {
    get: function() {
      return this.settings.k_;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.M_ = function(e28) {
    return new t3(Object.assign(Object.assign({}, this.settings), e28), this.T, this.Kt, this.ignoreUndefinedProperties, this.fieldTransforms, this.zt);
  }, t3.prototype.L_ = function(t6) {
    var e28, n3 = (e28 = this.path) === null || e28 === void 0 ? void 0 : e28.child(t6), r3 = this.M_({
      path: n3,
      B_: false
    });
    return r3.q_(t6), r3;
  }, t3.prototype.U_ = function(t6) {
    var e28, n3 = (e28 = this.path) === null || e28 === void 0 ? void 0 : e28.child(t6), r3 = this.M_({
      path: n3,
      B_: false
    });
    return r3.O_(), r3;
  }, t3.prototype.Q_ = function(t6) {
    return this.M_({
      path: void 0,
      B_: true
    });
  }, t3.prototype.K_ = function(t6) {
    return Ia(t6, this.settings.methodName, this.settings.W_ || false, this.path, this.settings.j_);
  }, t3.prototype.contains = function(t6) {
    return this.zt.find(function(e28) {
      return t6.st(e28);
    }) !== void 0 || this.fieldTransforms.find(function(e28) {
      return t6.st(e28.field);
    }) !== void 0;
  }, t3.prototype.O_ = function() {
    if (this.path)
      for (var t6 = 0; t6 < this.path.length; t6++)
        this.q_(this.path.get(t6));
  }, t3.prototype.q_ = function(t6) {
    if (t6.length === 0)
      throw this.K_("Document fields must not be empty");
    if (ta(this.k_) && $s.test(t6))
      throw this.K_('Document fields cannot begin and end with "__"');
  }, t3;
}(), na = function() {
  function t3(t6, e28, n3) {
    this.T = t6, this.ignoreUndefinedProperties = e28, this.Kt = n3 || Wo(t6);
  }
  return t3.prototype.G_ = function(t6, e28, n3, r3) {
    return r3 === void 0 && (r3 = false), new ea({
      k_: t6,
      methodName: e28,
      j_: n3,
      path: rt.at(),
      B_: false,
      W_: r3
    }, this.T, this.Kt, this.ignoreUndefinedProperties);
  }, t3;
}();
function ra(t3) {
  var e28 = t3.p_(), n3 = Wo(t3.I_);
  return new na(t3.I_, !!e28.ignoreUndefinedProperties, n3);
}
function ia(t3, e28, n3, r3, i, o3) {
  o3 === void 0 && (o3 = {});
  var u3 = t3.G_(o3.merge || o3.mergeFields ? 2 : 0, e28, n3, i);
  ma("Data must be an object, but it was:", u3, r3);
  var s3, a3, c3 = va(r3, u3);
  if (o3.merge)
    s3 = new at(u3.zt), a3 = u3.fieldTransforms;
  else if (o3.mergeFields) {
    for (var f3 = [], h3 = 0, l3 = o3.mergeFields; h3 < l3.length; h3++) {
      var p3 = ga(e28, l3[h3], n3);
      if (!u3.contains(p3))
        throw new M(V.INVALID_ARGUMENT, "Field '" + p3 + "' is specified in your field mask but missing from your input data.");
      _a$5(f3, p3) || f3.push(p3);
    }
    s3 = new at(f3), a3 = u3.fieldTransforms.filter(function(t6) {
      return s3.It(t6.field);
    });
  } else
    s3 = null, a3 = u3.fieldTransforms;
  return new Xs(new Pt(c3), s3, a3);
}
var oa = function(t3) {
  function e28() {
    return t3 !== null && t3.apply(this, arguments) || this;
  }
  return __extends$1(e28, t3), e28.prototype.z_ = function(t6) {
    if (t6.k_ !== 2)
      throw t6.k_ === 1 ? t6.K_(this._methodName + "() can only appear at the top level of your update data") : t6.K_(this._methodName + "() cannot be used with set() unless you pass {merge:true}");
    return t6.zt.push(t6.path), null;
  }, e28.prototype.isEqual = function(t6) {
    return t6 instanceof e28;
  }, e28;
}(Os);
function ua(t3, e28, n3) {
  return new ea({
    k_: 3,
    j_: e28.settings.j_,
    methodName: t3._methodName,
    B_: n3
  }, e28.T, e28.Kt, e28.ignoreUndefinedProperties);
}
var sa = function(t3) {
  function e28() {
    return t3 !== null && t3.apply(this, arguments) || this;
  }
  return __extends$1(e28, t3), e28.prototype.z_ = function(t6) {
    return new Ue(t6.path, new ke());
  }, e28.prototype.isEqual = function(t6) {
    return t6 instanceof e28;
  }, e28;
}(Os), aa = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, e29) || this).H_ = n3, r3;
  }
  return __extends$1(e28, t3), e28.prototype.z_ = function(t6) {
    var e29 = ua(this, t6, true), n3 = this.H_.map(function(t10) {
      return da(t10, e29);
    }), r3 = new Oe(n3);
    return new Ue(t6.path, r3);
  }, e28.prototype.isEqual = function(t6) {
    return this === t6;
  }, e28;
}(Os), ca = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, e29) || this).H_ = n3, r3;
  }
  return __extends$1(e28, t3), e28.prototype.z_ = function(t6) {
    var e29 = ua(this, t6, true), n3 = this.H_.map(function(t10) {
      return da(t10, e29);
    }), r3 = new Ce(n3);
    return new Ue(t6.path, r3);
  }, e28.prototype.isEqual = function(t6) {
    return this === t6;
  }, e28;
}(Os), fa = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, e29) || this).J_ = n3, r3;
  }
  return __extends$1(e28, t3), e28.prototype.z_ = function(t6) {
    var e29 = new Re(t6.Kt, Ne(t6.Kt, this.J_));
    return new Ue(t6.path, e29);
  }, e28.prototype.isEqual = function(t6) {
    return this === t6;
  }, e28;
}(Os);
function ha(t3, e28, n3, r3) {
  var i = t3.G_(1, e28, n3);
  ma("Data must be an object, but it was:", i, r3);
  var o3 = [], u3 = new Ct();
  ut(r3, function(t6, r6) {
    var s4 = ba(e28, t6, n3);
    r6 instanceof q && (r6 = r6._);
    var a3 = i.U_(s4);
    if (r6 instanceof oa)
      o3.push(s4);
    else {
      var c3 = da(r6, a3);
      c3 != null && (o3.push(s4), u3.set(s4, c3));
    }
  });
  var s3 = new at(o3);
  return new Zs(u3.yt(), s3, i.fieldTransforms);
}
function la(t3, e28, n3, r3, i, o3) {
  var u3 = t3.G_(1, e28, n3), s3 = [ga(e28, r3, n3)], a3 = [i];
  if (o3.length % 2 != 0)
    throw new M(V.INVALID_ARGUMENT, "Function " + e28 + "() needs to be called with an even number of arguments that alternate between field names and values.");
  for (var c3 = 0; c3 < o3.length; c3 += 2)
    s3.push(ga(e28, o3[c3])), a3.push(o3[c3 + 1]);
  for (var f3 = [], h3 = new Ct(), l3 = s3.length - 1; l3 >= 0; --l3)
    if (!_a$5(f3, s3[l3])) {
      var p3 = s3[l3], d3 = a3[l3];
      d3 instanceof q && (d3 = d3._);
      var v3 = u3.U_(p3);
      if (d3 instanceof oa)
        f3.push(p3);
      else {
        var y3 = da(d3, v3);
        y3 != null && (f3.push(p3), h3.set(p3, y3));
      }
    }
  var m3 = new at(f3);
  return new Zs(h3.yt(), m3, u3.fieldTransforms);
}
function pa(t3, e28, n3, r3) {
  return r3 === void 0 && (r3 = false), da(n3, t3.G_(r3 ? 4 : 3, e28));
}
function da(t3, e28) {
  if (t3 instanceof q && (t3 = t3._), ya(t3))
    return ma("Unsupported field value:", e28, t3), va(t3, e28);
  if (t3 instanceof Os)
    return function(t6, e29) {
      if (!ta(e29.k_))
        throw e29.K_(t6._methodName + "() can only be used with update() and set()");
      if (!e29.path)
        throw e29.K_(t6._methodName + "() is not currently supported inside arrays");
      var n3 = t6.z_(e29);
      n3 && e29.fieldTransforms.push(n3);
    }(t3, e28), null;
  if (e28.path && e28.zt.push(e28.path), t3 instanceof Array) {
    if (e28.settings.B_ && e28.k_ !== 4)
      throw e28.K_("Nested arrays are not supported");
    return function(t6, e29) {
      for (var n3 = [], r3 = 0, i = 0, o3 = t6; i < o3.length; i++) {
        var u3 = da(o3[i], e29.Q_(r3));
        u3 == null && (u3 = {
          nullValue: "NULL_VALUE"
        }), n3.push(u3), r3++;
      }
      return {
        arrayValue: {
          values: n3
        }
      };
    }(t3, e28);
  }
  return function(t6, e29) {
    if (t6 instanceof q && (t6 = t6._), t6 === null)
      return {
        nullValue: "NULL_VALUE"
      };
    if (typeof t6 == "number")
      return Ne(e29.Kt, t6);
    if (typeof t6 == "boolean")
      return {
        booleanValue: t6
      };
    if (typeof t6 == "string")
      return {
        stringValue: t6
      };
    if (t6 instanceof Date) {
      var n3 = X.fromDate(t6);
      return {
        timestampValue: qn(e29.Kt, n3)
      };
    }
    if (t6 instanceof X) {
      n3 = new X(t6.seconds, 1e3 * Math.floor(t6.nanoseconds / 1e3));
      return {
        timestampValue: qn(e29.Kt, n3)
      };
    }
    if (t6 instanceof Ys)
      return {
        geoPointValue: {
          latitude: t6.latitude,
          longitude: t6.longitude
        }
      };
    if (t6 instanceof U)
      return {
        bytesValue: Fn(e29.Kt, t6.l)
      };
    if (t6 instanceof Gs) {
      n3 = e29.T;
      var r3 = t6.firestore.I_;
      if (!r3.isEqual(n3))
        throw e29.K_("Document reference is for database " + r3.projectId + "/" + r3.database + " but should be for database " + n3.projectId + "/" + n3.database);
      return {
        referenceValue: Gn(t6.firestore.I_ || e29.T, t6.S_.path)
      };
    }
    if (t6 === void 0 && e29.ignoreUndefinedProperties)
      return null;
    throw e29.K_("Unsupported field value: " + Ms(t6));
  }(t3, e28);
}
function va(t3, e28) {
  var n3 = {};
  return st(t3) ? e28.path && e28.path.length > 0 && e28.zt.push(e28.path) : ut(t3, function(t6, r3) {
    var i = da(r3, e28.L_(t6));
    i != null && (n3[t6] = i);
  }), {
    mapValue: {
      fields: n3
    }
  };
}
function ya(t3) {
  return !(typeof t3 != "object" || t3 === null || t3 instanceof Array || t3 instanceof Date || t3 instanceof X || t3 instanceof Ys || t3 instanceof U || t3 instanceof Gs || t3 instanceof Os);
}
function ma(t3, e28, n3) {
  if (!ya(n3) || !function(t6) {
    return typeof t6 == "object" && t6 !== null && (Object.getPrototypeOf(t6) === Object.prototype || Object.getPrototypeOf(t6) === null);
  }(n3)) {
    var r3 = Ms(n3);
    throw r3 === "an object" ? e28.K_(t3 + " a custom object") : e28.K_(t3 + " " + r3);
  }
}
function ga(t3, e28, n3) {
  if (e28 instanceof q && (e28 = e28._), e28 instanceof ks)
    return e28.d_;
  if (typeof e28 == "string")
    return ba(t3, e28);
  throw Ia("Field path arguments must be of type string or FieldPath.", t3, false, void 0, n3);
}
var wa = new RegExp("[~\\*/\\[\\]]");
function ba(t3, e28, n3) {
  if (e28.search(wa) >= 0)
    throw Ia("Invalid field path (" + e28 + "). Paths must not contain '~', '*', '/', '[', or ']'", t3, false, void 0, n3);
  try {
    return new (ks.bind.apply(ks, __spreadArrays$1([void 0], e28.split("."))))().d_;
  } catch (r3) {
    throw Ia("Invalid field path (" + e28 + "). Paths must not be empty, begin with '.', end with '.', or contain '..'", t3, false, void 0, n3);
  }
}
function Ia(t3, e28, n3, r3, i) {
  var o3 = r3 && !r3.nt(), u3 = i !== void 0, s3 = "Function " + e28 + "() called with invalid data";
  n3 && (s3 += " (via `toFirestore()`)");
  var a3 = "";
  return (o3 || u3) && (a3 += " (found", o3 && (a3 += " in field " + r3), u3 && (a3 += " in document " + i), a3 += ")"), new M(V.INVALID_ARGUMENT, (s3 += ". ") + t3 + a3);
}
function _a$5(t3, e28) {
  return t3.some(function(t6) {
    return t6.isEqual(e28);
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Ea = function() {
  function t3(t6) {
    this.Dh = t6, this.Y_ = new Map(), this.mutations = [], this.X_ = false, this.Z_ = null, this.tf = new Set();
  }
  return t3.prototype.ef = function(t6) {
    return __awaiter(this, void 0, void 0, function() {
      var e28, n3 = this;
      return __generator(this, function(r3) {
        switch (r3.label) {
          case 0:
            if (this.nf(), this.mutations.length > 0)
              throw new M(V.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes.");
            return [4, function(t10, e29) {
              return __awaiter(this, void 0, void 0, function() {
                var n6, r6, i, o3, u3, s3;
                return __generator(this, function(a3) {
                  switch (a3.label) {
                    case 0:
                      return n6 = D(t10), r6 = Qn(n6.Kt) + "/documents", i = {
                        documents: e29.map(function(t11) {
                          return Kn(n6.Kt, t11);
                        })
                      }, [4, n6.Cu("BatchGetDocuments", r6, i)];
                    case 1:
                      return o3 = a3.sent(), u3 = new Map(), o3.forEach(function(t11) {
                        var e30 = function(t12, e31) {
                          return "found" in e31 ? function(t13, e32) {
                            x(!!e32.found), e32.found.name, e32.found.updateTime;
                            var n10 = Hn(t13, e32.found.name), r10 = zn(e32.found.updateTime), i3 = new Pt({
                              mapValue: {
                                fields: e32.found.fields
                              }
                            });
                            return new Vt(n10, r10, i3, {});
                          }(t12, e31) : "missing" in e31 ? function(t13, e32) {
                            x(!!e32.missing), x(!!e32.readTime);
                            var n10 = Hn(t13, e32.missing), r10 = zn(e32.readTime);
                            return new Mt(n10, r10);
                          }(t12, e31) : S();
                        }(n6.Kt, t11);
                        u3.set(e30.key.toString(), e30);
                      }), s3 = [], [2, (e29.forEach(function(t11) {
                        var e30 = u3.get(t11.toString());
                        x(!!e30), s3.push(e30);
                      }), s3)];
                  }
                });
              });
            }(this.Dh, t6)];
          case 1:
            return [2, ((e28 = r3.sent()).forEach(function(t10) {
              t10 instanceof Mt || t10 instanceof Vt ? n3.sf(t10) : S();
            }), e28)];
        }
      });
    });
  }, t3.prototype.set = function(t6, e28) {
    this.write(e28.F_(t6, this.Gt(t6))), this.tf.add(t6.toString());
  }, t3.prototype.update = function(t6, e28) {
    try {
      this.write(e28.F_(t6, this.rf(t6)));
    } catch (t10) {
      this.Z_ = t10;
    }
    this.tf.add(t6.toString());
  }, t3.prototype.delete = function(t6) {
    this.write(new nn(t6, this.Gt(t6))), this.tf.add(t6.toString());
  }, t3.prototype.commit = function() {
    return __awaiter(this, void 0, void 0, function() {
      var t6, e28 = this;
      return __generator(this, function(n3) {
        switch (n3.label) {
          case 0:
            if (this.nf(), this.Z_)
              throw this.Z_;
            return t6 = this.Y_, this.mutations.forEach(function(e29) {
              t6.delete(e29.key.toString());
            }), t6.forEach(function(t10, n6) {
              var r3 = it.ft(n6);
              e28.mutations.push(new rn(r3, e28.Gt(r3)));
            }), [4, function(t10, e29) {
              return __awaiter(this, void 0, void 0, function() {
                var n6, r3, i;
                return __generator(this, function(o3) {
                  switch (o3.label) {
                    case 0:
                      return n6 = D(t10), r3 = Qn(n6.Kt) + "/documents", i = {
                        writes: e29.map(function(t11) {
                          return Zn(n6.Kt, t11);
                        })
                      }, [4, n6.bu("Commit", r3, i)];
                    case 1:
                      return o3.sent(), [2];
                  }
                });
              });
            }(this.Dh, this.mutations)];
          case 1:
            return n3.sent(), this.X_ = true, [2];
        }
      });
    });
  }, t3.prototype.sf = function(t6) {
    var e28;
    if (t6 instanceof Vt)
      e28 = t6.version;
    else {
      if (!(t6 instanceof Mt))
        throw S();
      e28 = Z.min();
    }
    var n3 = this.Y_.get(t6.key.toString());
    if (n3) {
      if (!e28.isEqual(n3))
        throw new M(V.ABORTED, "Document version changed between two reads.");
    } else
      this.Y_.set(t6.key.toString(), e28);
  }, t3.prototype.Gt = function(t6) {
    var e28 = this.Y_.get(t6.toString());
    return !this.tf.has(t6.toString()) && e28 ? Fe.updateTime(e28) : Fe.Wt();
  }, t3.prototype.rf = function(t6) {
    var e28 = this.Y_.get(t6.toString());
    if (!this.tf.has(t6.toString()) && e28) {
      if (e28.isEqual(Z.min()))
        throw new M(V.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
      return Fe.updateTime(e28);
    }
    return Fe.exists(true);
  }, t3.prototype.write = function(t6) {
    this.nf(), this.mutations.push(t6);
  }, t3.prototype.nf = function() {
  }, t3;
}(), Ta = function() {
  function t3(t6, e28, n3, r3) {
    this.fs = t6, this.Dh = e28, this.updateFunction = n3, this.Ts = r3, this.cf = 5, this.zu = new Qo(this.fs, "transaction_retry");
  }
  return t3.prototype.run = function() {
    this.af();
  }, t3.prototype.af = function() {
    var t6 = this;
    this.zu.Bu(function() {
      return __awaiter(t6, void 0, void 0, function() {
        var t10, e28, n3 = this;
        return __generator(this, function(r3) {
          return t10 = new Ea(this.Dh), (e28 = this.uf(t10)) && e28.then(function(e29) {
            n3.fs.ys(function() {
              return t10.commit().then(function() {
                n3.Ts.resolve(e29);
              }).catch(function(t11) {
                n3.hf(t11);
              });
            });
          }).catch(function(t11) {
            n3.hf(t11);
          }), [2];
        });
      });
    });
  }, t3.prototype.uf = function(t6) {
    try {
      var e28 = this.updateFunction(t6);
      return !yt(e28) && e28.catch && e28.then ? e28 : (this.Ts.reject(Error("Transaction callback must return a Promise")), null);
    } catch (t10) {
      return this.Ts.reject(t10), null;
    }
  }, t3.prototype.hf = function(t6) {
    var e28 = this;
    this.cf > 0 && this.lf(t6) ? (this.cf -= 1, this.fs.ys(function() {
      return e28.af(), Promise.resolve();
    })) : this.Ts.reject(t6);
  }, t3.prototype.lf = function(t6) {
    if (t6.name === "FirebaseError") {
      var e28 = t6.code;
      return e28 === "aborted" || e28 === "failed-precondition" || !un(e28);
    }
    return false;
  }, t3;
}(), Na = function() {
  function t3(t6, e28, n3) {
    var r3 = this;
    this.credentials = t6, this.fs = e28, this.gu = n3, this.user = K.UNAUTHENTICATED, this.clientId = O.t(), this._f = function() {
    }, this.N = new vr(), this.credentials.S(function(t10) {
      E("FirestoreClient", "Received user=", t10.uid), r3.user = t10, r3._f(t10), r3.N.resolve();
    });
  }
  return t3.prototype.getConfiguration = function() {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(t6) {
        switch (t6.label) {
          case 0:
            return [4, this.N.promise];
          case 1:
            return [2, (t6.sent(), {
              fs: this.fs,
              gu: this.gu,
              clientId: this.clientId,
              credentials: this.credentials,
              Yl: this.user,
              bl: 100
            })];
        }
      });
    });
  }, t3.prototype.ff = function(t6) {
    var e28 = this;
    this._f = t6, this.N.promise.then(function() {
      return e28._f(e28.user);
    });
  }, t3.prototype.df = function() {
    if (this.fs.wf)
      throw new M(V.FAILED_PRECONDITION, "The client has already been terminated.");
  }, t3.prototype.terminate = function() {
    var t6 = this;
    this.fs.Ef();
    var e28 = new vr();
    return this.fs.Tf(function() {
      return __awaiter(t6, void 0, void 0, function() {
        var t10, n3;
        return __generator(this, function(r3) {
          switch (r3.label) {
            case 0:
              return r3.trys.push([0, 5, , 6]), this.If ? [4, this.If.terminate()] : [3, 2];
            case 1:
              r3.sent(), r3.label = 2;
            case 2:
              return this.mf ? [4, this.mf.terminate()] : [3, 4];
            case 3:
              r3.sent(), r3.label = 4;
            case 4:
              return this.credentials.D(), e28.resolve(), [3, 6];
            case 5:
              return t10 = r3.sent(), n3 = Sr(t10, "Failed to shutdown persistence"), e28.reject(n3), [3, 6];
            case 6:
              return [2];
          }
        });
      });
    }), e28.promise;
  }, t3;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Aa(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    var n3, r3, i = this;
    return __generator(this, function(o3) {
      switch (o3.label) {
        case 0:
          return t3.fs.Af(), E("FirestoreClient", "Initializing OfflineComponentProvider"), [4, t3.getConfiguration()];
        case 1:
          return n3 = o3.sent(), [4, e28.initialize(n3)];
        case 2:
          return o3.sent(), r3 = n3.Yl, t3.ff(function(n6) {
            r3.isEqual(n6) || (r3 = n6, t3.fs.vo(function() {
              return __awaiter(i, void 0, void 0, function() {
                return __generator(this, function(t6) {
                  switch (t6.label) {
                    case 0:
                      return [4, uo(e28.Sh, n6)];
                    case 1:
                      return t6.sent(), [2];
                  }
                });
              });
            }));
          }), e28.persistence.Vo(function() {
            return t3.terminate();
          }), t3.mf = e28, [2];
      }
    });
  });
}
function Sa(t3, e28) {
  return __awaiter(this, void 0, void 0, function() {
    var n3, r3;
    return __generator(this, function(i) {
      switch (i.label) {
        case 0:
          return t3.fs.Af(), [4, xa(t3)];
        case 1:
          return n3 = i.sent(), E("FirestoreClient", "Initializing OnlineComponentProvider"), [4, t3.getConfiguration()];
        case 2:
          return r3 = i.sent(), [4, e28.initialize(n3, r3)];
        case 3:
          return i.sent(), t3.ff(function(n6) {
            return t3.fs.vo(function() {
              return function(t6, e29) {
                return __awaiter(this, void 0, void 0, function() {
                  var n10, r6;
                  return __generator(this, function(i3) {
                    switch (i3.label) {
                      case 0:
                        return (n10 = D(t6)).fs.Af(), E("RemoteStore", "RemoteStore received new credentials"), r6 = fu(n10), n10.Fh.add(3), [4, ru(n10)];
                      case 1:
                        return i3.sent(), r6 && n10.Mh.set("Unknown"), [4, n10.Ch.s_(e29)];
                      case 2:
                        return i3.sent(), n10.Fh.delete(3), [4, nu(n10)];
                      case 3:
                        return i3.sent(), [2];
                    }
                  });
                });
              }(e28.gl, n6);
            });
          }), t3.If = e28, [2];
      }
    });
  });
}
function xa(t3) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(e28) {
      switch (e28.label) {
        case 0:
          return t3.mf ? [3, 2] : (E("FirestoreClient", "Using default OfflineComponentProvider"), [4, Aa(t3, new Es())]);
        case 1:
          e28.sent(), e28.label = 2;
        case 2:
          return [2, t3.mf];
      }
    });
  });
}
function Da(t3) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(e28) {
      switch (e28.label) {
        case 0:
          return t3.If ? [3, 2] : (E("FirestoreClient", "Using default OnlineComponentProvider"), [4, Sa(t3, new As())]);
        case 1:
          e28.sent(), e28.label = 2;
        case 2:
          return [2, t3.If];
      }
    });
  });
}
function ka(t3) {
  return xa(t3).then(function(t6) {
    return t6.persistence;
  });
}
function Oa(t3) {
  return xa(t3).then(function(t6) {
    return t6.Sh;
  });
}
function Pa(t3) {
  return Da(t3).then(function(t6) {
    return t6.gl;
  });
}
function Ca(t3) {
  return Da(t3).then(function(t6) {
    return t6.fa;
  });
}
function La(t3) {
  return __awaiter(this, void 0, void 0, function() {
    var e28, n3;
    return __generator(this, function(r3) {
      switch (r3.label) {
        case 0:
          return [4, Da(t3)];
        case 1:
          return e28 = r3.sent(), [2, ((n3 = e28.Vl).Gh = Ku.bind(null, e28.fa), n3.Jh = Ju.bind(null, e28.fa), n3)];
      }
    });
  });
}
function Ra(t3, e28, n3) {
  var r3 = this;
  n3 === void 0 && (n3 = {});
  var i = new vr();
  return t3.fs.ys(function() {
    return __awaiter(r3, void 0, void 0, function() {
      var r6;
      return __generator(this, function(o3) {
        switch (o3.label) {
          case 0:
            return r6 = function(t6, e29, n6, r10, i3) {
              var o6 = new xs({
                next: function(o10) {
                  e29.ys(function() {
                    return ku(t6, u3);
                  });
                  var s3 = o10.docs.has(n6);
                  !s3 && o10.fromCache ? i3.reject(new M(V.UNAVAILABLE, "Failed to get document because the client is offline.")) : s3 && o10.fromCache && r10 && r10.source === "server" ? i3.reject(new M(V.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i3.resolve(o10);
                },
                error: function(t10) {
                  return i3.reject(t10);
                }
              }), u3 = new Lu(se(n6.path), o6, {
                includeMetadataChanges: true,
                sl: true
              });
              return Du(t6, u3);
            }, [4, La(t3)];
          case 1:
            return [2, r6.apply(void 0, [o3.sent(), t3.fs, e28, n3, i])];
        }
      });
    });
  }), i.promise;
}
function Va(t3, e28, n3) {
  var r3 = this;
  n3 === void 0 && (n3 = {});
  var i = new vr();
  return t3.fs.ys(function() {
    return __awaiter(r3, void 0, void 0, function() {
      var r6;
      return __generator(this, function(o3) {
        switch (o3.label) {
          case 0:
            return r6 = function(t6, e29, n6, r10, i3) {
              var o6 = new xs({
                next: function(n10) {
                  e29.ys(function() {
                    return ku(t6, u3);
                  }), n10.fromCache && r10.source === "server" ? i3.reject(new M(V.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i3.resolve(n10);
                },
                error: function(t10) {
                  return i3.reject(t10);
                }
              }), u3 = new Lu(n6, o6, {
                includeMetadataChanges: true,
                sl: true
              });
              return Du(t6, u3);
            }, [4, La(t3)];
          case 1:
            return [2, r6.apply(void 0, [o3.sent(), t3.fs, e28, n3, i])];
        }
      });
    });
  }), i.promise;
}
var Ma = function() {
  function t3() {
    var t6 = this;
    this.Rf = Promise.resolve(), this.Pf = [], this.yf = false, this.gf = [], this.Vf = null, this.pf = false, this.bf = [], this.zu = new Qo(this, "async_queue_retry"), this.vf = function() {
      var e29 = Jo();
      e29 && E("AsyncQueue", "Visibility state changed to " + e29.visibilityState), t6.zu.Uu();
    };
    var e28 = Jo();
    e28 && typeof e28.addEventListener == "function" && e28.addEventListener("visibilitychange", this.vf);
  }
  return Object.defineProperty(t3.prototype, "wf", {
    get: function() {
      return this.yf;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.ys = function(t6) {
    this.enqueue(t6);
  }, t3.prototype.Tf = function(t6) {
    this.Sf(), this.Df(t6);
  }, t3.prototype.Ef = function() {
    if (!this.yf) {
      this.yf = true;
      var t6 = Jo();
      t6 && typeof t6.removeEventListener == "function" && t6.removeEventListener("visibilitychange", this.vf);
    }
  }, t3.prototype.enqueue = function(t6) {
    return this.Sf(), this.yf ? new Promise(function(t10) {
    }) : this.Df(t6);
  }, t3.prototype.vo = function(t6) {
    var e28 = this;
    this.ys(function() {
      return e28.Pf.push(t6), e28.Cf();
    });
  }, t3.prototype.Cf = function() {
    return __awaiter(this, void 0, void 0, function() {
      var t6, e28 = this;
      return __generator(this, function(n3) {
        switch (n3.label) {
          case 0:
            if (this.Pf.length === 0)
              return [3, 5];
            n3.label = 1;
          case 1:
            return n3.trys.push([1, 3, , 4]), [4, this.Pf[0]()];
          case 2:
            return n3.sent(), this.Pf.shift(), this.zu.reset(), [3, 4];
          case 3:
            if (!Ir(t6 = n3.sent()))
              throw t6;
            return E("AsyncQueue", "Operation failed with retryable error: " + t6), [3, 4];
          case 4:
            this.Pf.length > 0 && this.zu.Bu(function() {
              return e28.Cf();
            }), n3.label = 5;
          case 5:
            return [2];
        }
      });
    });
  }, t3.prototype.Df = function(t6) {
    var e28 = this, n3 = this.Rf.then(function() {
      return e28.pf = true, t6().catch(function(t10) {
        throw e28.Vf = t10, e28.pf = false, T("INTERNAL UNHANDLED ERROR: ", function(t11) {
          var e29 = t11.message || "";
          return t11.stack && (e29 = t11.stack.includes(t11.message) ? t11.stack : t11.message + "\n" + t11.stack), e29;
        }(t10)), t10;
      }).then(function(t10) {
        return e28.pf = false, t10;
      });
    });
    return this.Rf = n3, n3;
  }, t3.prototype.mr = function(t6, e28, n3) {
    var r3 = this;
    this.Sf(), this.bf.indexOf(t6) > -1 && (e28 = 0);
    var i = Ar.Is(this, t6, e28, n3, function(t10) {
      return r3.xf(t10);
    });
    return this.gf.push(i), i;
  }, t3.prototype.Sf = function() {
    this.Vf && S();
  }, t3.prototype.Af = function() {
  }, t3.prototype.Nf = function() {
    return __awaiter(this, void 0, void 0, function() {
      var t6;
      return __generator(this, function(e28) {
        switch (e28.label) {
          case 0:
            return [4, t6 = this.Rf];
          case 1:
            e28.sent(), e28.label = 2;
          case 2:
            if (t6 !== this.Rf)
              return [3, 0];
            e28.label = 3;
          case 3:
            return [2];
        }
      });
    });
  }, t3.prototype.Ff = function(t6) {
    for (var e28 = 0, n3 = this.gf; e28 < n3.length; e28++) {
      if (n3[e28].ds === t6)
        return true;
    }
    return false;
  }, t3.prototype.Of = function(t6) {
    var e28 = this;
    return this.Nf().then(function() {
      e28.gf.sort(function(t10, e29) {
        return t10.ws - e29.ws;
      });
      for (var n3 = 0, r3 = e28.gf; n3 < r3.length; n3++) {
        var i = r3[n3];
        if (i.Ps(), t6 !== "all" && i.ds === t6)
          break;
      }
      return e28.Nf();
    });
  }, t3.prototype.kf = function(t6) {
    this.bf.push(t6);
  }, t3.prototype.xf = function(t6) {
    var e28 = this.gf.indexOf(t6);
    this.gf.splice(e28, 1);
  }, t3;
}(), Ua = -1, qa = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, e29, n3) || this).Mf = new Ma(), r3.w_ = "name" in e29 ? e29.name : "[DEFAULT]", r3;
  }
  return __extends$1(e28, t3), e28.prototype.b_ = function() {
    return this.Lf || ja(this), this.Lf.terminate();
  }, e28;
}(zs);
function Fa(t3) {
  return t3.Lf || ja(t3), t3.Lf.df(), t3.Lf;
}
function ja(t3) {
  var e28 = t3.p_(), n3 = function(t6, e29, n6) {
    return new G(t6, e29, n6.host, n6.ssl, n6.experimentalForceLongPolling, n6.experimentalAutoDetectLongPolling);
  }(t3.I_, t3.w_, e28);
  t3.Lf = new Na(t3.m_, t3.Mf, n3);
}
function za(t3, e28, n3) {
  var r3 = this, i = new vr();
  return t3.fs.enqueue(function() {
    return __awaiter(r3, void 0, void 0, function() {
      var r6;
      return __generator(this, function(o3) {
        switch (o3.label) {
          case 0:
            return o3.trys.push([0, 3, , 4]), [4, Aa(t3, n3)];
          case 1:
            return o3.sent(), [4, Sa(t3, e28)];
          case 2:
            return o3.sent(), i.resolve(), [3, 4];
          case 3:
            if (!function(t6) {
              return t6.name === "FirebaseError" ? t6.code === V.FAILED_PRECONDITION || t6.code === V.UNIMPLEMENTED : !(typeof DOMException != "undefined" && t6 instanceof DOMException) || (t6.code === 22 || t6.code === 20 || t6.code === 11);
            }(r6 = o3.sent()))
              throw r6;
            return console.warn("Error enabling offline persistence. Falling back to persistence disabled: " + r6), i.reject(r6), [3, 4];
          case 4:
            return [2];
        }
      });
    });
  }).then(function() {
    return i.promise;
  });
}
function Ga(t3) {
  if (t3.R_ || t3.P_)
    throw new M(V.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Ba = function() {
  function t3() {
  }
  return t3.prototype.$f = function(t6, e28) {
    switch (e28 === void 0 && (e28 = "none"), wt(t6)) {
      case 0:
        return null;
      case 1:
        return t6.booleanValue;
      case 2:
        return ht(t6.integerValue || t6.doubleValue);
      case 3:
        return this.Bf(t6.timestampValue);
      case 4:
        return this.qf(t6, e28);
      case 5:
        return t6.stringValue;
      case 6:
        return this.Uf(lt(t6.bytesValue));
      case 7:
        return this.Qf(t6.referenceValue);
      case 8:
        return this.Kf(t6.geoPointValue);
      case 9:
        return this.Wf(t6.arrayValue, e28);
      case 10:
        return this.jf(t6.mapValue, e28);
      default:
        throw S();
    }
  }, t3.prototype.jf = function(t6, e28) {
    var n3 = this, r3 = {};
    return ut(t6.fields || {}, function(t10, i) {
      r3[t10] = n3.$f(i, e28);
    }), r3;
  }, t3.prototype.Kf = function(t6) {
    return new Ys(ht(t6.latitude), ht(t6.longitude));
  }, t3.prototype.Wf = function(t6, e28) {
    var n3 = this;
    return (t6.values || []).map(function(t10) {
      return n3.$f(t10, e28);
    });
  }, t3.prototype.qf = function(t6, e28) {
    switch (e28) {
      case "previous":
        var n3 = dt(t6);
        return n3 == null ? null : this.$f(n3, e28);
      case "estimate":
        return this.Bf(vt(t6));
      default:
        return null;
    }
  }, t3.prototype.Bf = function(t6) {
    var e28 = ft(t6);
    return new X(e28.seconds, e28.nanos);
  }, t3.prototype.Gf = function(t6, e28) {
    var n3 = et.ct(t6);
    x(dr(n3));
    var r3 = new B(n3.get(1), n3.get(3)), i = new it(n3.X(5));
    return r3.isEqual(e28) || T("Document " + i + " contains a document reference within a different database (" + r3.projectId + "/" + r3.database + ") which is not supported. It will be treated as a reference in the current database (" + e28.projectId + "/" + e28.database + ") instead."), i;
  }, t3;
}(), Ka = function() {
  function t3(t6, e28, n3, r3, i) {
    this.zf = t6, this.Hf = e28, this.S_ = n3, this.Jf = r3, this.v_ = i;
  }
  return Object.defineProperty(t3.prototype, "id", {
    get: function() {
      return this.S_.path.et();
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "ref", {
    get: function() {
      return new Gs(this.zf, this.v_, this.S_);
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.exists = function() {
    return this.Jf !== null;
  }, t3.prototype.data = function() {
    if (this.Jf) {
      if (this.v_) {
        var t6 = new Ha(this.zf, this.Hf, this.S_, this.Jf, null);
        return this.v_.fromFirestore(t6);
      }
      return this.Hf.$f(this.Jf.vt());
    }
  }, t3.prototype.get = function(t6) {
    if (this.Jf) {
      var e28 = this.Jf.data().field(Ja("DocumentSnapshot.get", t6));
      if (e28 !== null)
        return this.Hf.$f(e28);
    }
  }, t3;
}(), Ha = function(t3) {
  function e28() {
    return t3 !== null && t3.apply(this, arguments) || this;
  }
  return __extends$1(e28, t3), e28.prototype.data = function() {
    return t3.prototype.data.call(this);
  }, e28;
}(Ka);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ja(t3, e28) {
  return typeof e28 == "string" ? ba(t3, e28) : e28 instanceof q ? e28._.d_ : e28.d_;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Wa(t3) {
  if (ce(t3) && t3.Nt.length === 0)
    throw new M(V.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
var Qa = function() {
};
function Ya(t3) {
  for (var e28 = [], n3 = 1; n3 < arguments.length; n3++)
    e28[n3 - 1] = arguments[n3];
  for (var r3 = 0, i = e28; r3 < i.length; r3++) {
    var o3 = i[r3];
    t3 = o3.Yf(t3);
  }
  return t3;
}
var $a = function(t3) {
  function e28(e29, n3, r3) {
    var i = this;
    return (i = t3.call(this) || this).Xf = e29, i.Zf = n3, i.td = r3, i.type = "where", i;
  }
  return __extends$1(e28, t3), e28.prototype.Yf = function(t6) {
    var e29 = ra(t6.firestore), n3 = function(t10, e30, n6, r3, i, o3, u3) {
      var s3;
      if (i.ht()) {
        if (o3 === "array-contains" || o3 === "array-contains-any")
          throw new M(V.INVALID_ARGUMENT, "Invalid Query. You can't perform '" + o3 + "' queries on FieldPath.documentId().");
        if (o3 === "in" || o3 === "not-in") {
          ic(u3, o3);
          for (var a3 = [], c3 = 0, f3 = u3; c3 < f3.length; c3++) {
            var h3 = f3[c3];
            a3.push(rc(r3, t10, h3));
          }
          s3 = {
            arrayValue: {
              values: a3
            }
          };
        } else
          s3 = rc(r3, t10, u3);
      } else
        o3 !== "in" && o3 !== "not-in" && o3 !== "array-contains-any" || ic(u3, o3), s3 = pa(n6, "where", u3, o3 === "in" || o3 === "not-in");
      var l3 = Bt.create(i, o3, s3);
      return function(t11, e31) {
        if (e31.xt()) {
          var n10 = he(t11);
          if (n10 !== null && !n10.isEqual(e31.field))
            throw new M(V.INVALID_ARGUMENT, "Invalid query. All where filters with an inequality (<, <=, >, or >=) must be on the same field. But you have inequality filters on '" + n10.toString() + "' and '" + e31.field.toString() + "'");
          var r6 = fe(t11);
          r6 !== null && oc(t11, e31.field, r6);
        }
        var i3 = function(t12, e32) {
          for (var n11 = 0, r10 = t12.filters; n11 < r10.length; n11++) {
            var i6 = r10[n11];
            if (e32.indexOf(i6.op) >= 0)
              return i6.op;
          }
          return null;
        }(t11, function(t12) {
          switch (t12) {
            case "!=":
              return ["!=", "not-in"];
            case "array-contains":
              return ["array-contains", "array-contains-any", "not-in"];
            case "in":
              return ["array-contains-any", "in", "not-in"];
            case "array-contains-any":
              return ["array-contains", "array-contains-any", "in", "not-in"];
            case "not-in":
              return ["array-contains", "array-contains-any", "in", "not-in", "!="];
            default:
              return [];
          }
        }(e31.op));
        if (i3 !== null)
          throw i3 === e31.op ? new M(V.INVALID_ARGUMENT, "Invalid query. You cannot use more than one '" + e31.op.toString() + "' filter.") : new M(V.INVALID_ARGUMENT, "Invalid query. You cannot use '" + e31.op.toString() + "' filters with '" + i3.toString() + "' filters.");
      }(t10, l3), l3;
    }(t6.C_, 0, e29, t6.firestore.I_, this.Xf, this.Zf, this.td);
    return new Bs(t6.firestore, t6.v_, function(t10, e30) {
      var n6 = t10.filters.concat([e30]);
      return new oe(t10.path, t10.collectionGroup, t10.Nt.slice(), n6, t10.limit, t10.limitType, t10.startAt, t10.endAt);
    }(t6.C_, n3));
  }, e28;
}(Qa), Xa = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this) || this).Xf = e29, r3.ed = n3, r3.type = "orderBy", r3;
  }
  return __extends$1(e28, t3), e28.prototype.Yf = function(t6) {
    var e29 = function(t10, e30, n3) {
      if (t10.startAt !== null)
        throw new M(V.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
      if (t10.endAt !== null)
        throw new M(V.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
      var r3 = new ee(e30, n3);
      return function(t11, e31) {
        if (fe(t11) === null) {
          var n6 = he(t11);
          n6 !== null && oc(t11, n6, e31.field);
        }
      }(t10, r3), r3;
    }(t6.C_, this.Xf, this.ed);
    return new Bs(t6.firestore, t6.v_, function(t10, e30) {
      var n3 = t10.Nt.concat([e30]);
      return new oe(t10.path, t10.collectionGroup, n3, t10.filters.slice(), t10.limit, t10.limitType, t10.startAt, t10.endAt);
    }(t6.C_, e29));
  }, e28;
}(Qa), Za = function(t3) {
  function e28(e29, n3, r3) {
    var i = this;
    return (i = t3.call(this) || this).type = e29, i.nd = n3, i.sd = r3, i;
  }
  return __extends$1(e28, t3), e28.prototype.Yf = function(t6) {
    return new Bs(t6.firestore, t6.v_, ve(t6.C_, this.nd, this.sd));
  }, e28;
}(Qa), tc = function(t3) {
  function e28(e29, n3, r3) {
    var i = this;
    return (i = t3.call(this) || this).type = e29, i.rd = n3, i.od = r3, i;
  }
  return __extends$1(e28, t3), e28.prototype.Yf = function(t6) {
    var e29 = nc(t6, this.type, this.rd, this.od);
    return new Bs(t6.firestore, t6.v_, function(t10, e30) {
      return new oe(t10.path, t10.collectionGroup, t10.Nt.slice(), t10.filters.slice(), t10.limit, t10.limitType, e30, t10.endAt);
    }(t6.C_, e29));
  }, e28;
}(Qa), ec = function(t3) {
  function e28(e29, n3, r3) {
    var i = this;
    return (i = t3.call(this) || this).type = e29, i.rd = n3, i.od = r3, i;
  }
  return __extends$1(e28, t3), e28.prototype.Yf = function(t6) {
    var e29 = nc(t6, this.type, this.rd, this.od);
    return new Bs(t6.firestore, t6.v_, function(t10, e30) {
      return new oe(t10.path, t10.collectionGroup, t10.Nt.slice(), t10.filters.slice(), t10.limit, t10.limitType, t10.startAt, e30);
    }(t6.C_, e29));
  }, e28;
}(Qa);
function nc(t3, e28, n3, r3) {
  if (n3[0] instanceof q && (n3[0] = n3[0]._), n3[0] instanceof Ka)
    return function(t6, e29, n6, r6, i3) {
      if (!r6)
        throw new M(V.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for " + n6 + "().");
      for (var o3 = [], u3 = 0, s3 = pe(t6); u3 < s3.length; u3++) {
        var a3 = s3[u3];
        if (a3.field.ht())
          o3.push(At(e29, r6.key));
        else {
          var c3 = r6.field(a3.field);
          if (pt(c3))
            throw new M(V.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + a3.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
          if (c3 === null) {
            var f3 = a3.field.ot();
            throw new M(V.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a document for which the field '" + f3 + "' (used as the orderBy) does not exist.");
          }
          o3.push(c3);
        }
      }
      return new Zt(o3, i3);
    }(t3.C_, t3.firestore.I_, e28, n3[0].Jf, r3);
  var i = ra(t3.firestore);
  return function(t6, e29, n6, r6, i3, o3) {
    var u3 = t6.Nt;
    if (i3.length > u3.length)
      throw new M(V.INVALID_ARGUMENT, "Too many arguments provided to " + r6 + "(). The number of arguments must be less than or equal to the number of orderBy() clauses");
    for (var s3 = [], a3 = 0; a3 < i3.length; a3++) {
      var c3 = i3[a3];
      if (u3[a3].field.ht()) {
        if (typeof c3 != "string")
          throw new M(V.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in " + r6 + "(), but got a " + typeof c3);
        if (!le(t6) && c3.indexOf("/") !== -1)
          throw new M(V.INVALID_ARGUMENT, "Invalid query. When querying a collection and ordering by FieldPath.documentId(), the value passed to " + r6 + "() must be a plain document ID, but '" + c3 + "' contains a slash.");
        var f3 = t6.path.child(et.ct(c3));
        if (!it.Et(f3))
          throw new M(V.INVALID_ARGUMENT, "Invalid query. When querying a collection group and ordering by FieldPath.documentId(), the value passed to " + r6 + "() must result in a valid document path, but '" + f3 + "' is not because it contains an odd number of segments.");
        var h3 = new it(f3);
        s3.push(At(e29, h3));
      } else {
        var l3 = pa(n6, r6, c3);
        s3.push(l3);
      }
    }
    return new Zt(s3, o3);
  }(t3.C_, t3.firestore.I_, i, e28, n3, r3);
}
function rc(t3, e28, n3) {
  if (n3 instanceof q && (n3 = n3._), typeof n3 == "string") {
    if (n3 === "")
      throw new M(V.INVALID_ARGUMENT, "Invalid query. When querying with FieldPath.documentId(), you must provide a valid document ID, but it was an empty string.");
    if (!le(e28) && n3.indexOf("/") !== -1)
      throw new M(V.INVALID_ARGUMENT, "Invalid query. When querying a collection by FieldPath.documentId(), you must provide a plain document ID, but '" + n3 + "' contains a '/' character.");
    var r3 = e28.path.child(et.ct(n3));
    if (!it.Et(r3))
      throw new M(V.INVALID_ARGUMENT, "Invalid query. When querying a collection group by FieldPath.documentId(), the value provided must result in a valid document path, but '" + r3 + "' is not because it has an odd number of segments (" + r3.length + ").");
    return At(t3, new it(r3));
  }
  if (n3 instanceof Gs)
    return At(t3, n3.S_);
  throw new M(V.INVALID_ARGUMENT, "Invalid query. When querying with FieldPath.documentId(), you must provide a valid string or a DocumentReference, but it was: " + Ms(n3) + ".");
}
function ic(t3, e28) {
  if (!Array.isArray(t3) || t3.length === 0)
    throw new M(V.INVALID_ARGUMENT, "Invalid Query. A non-empty array is required for '" + e28.toString() + "' filters.");
  if (t3.length > 10)
    throw new M(V.INVALID_ARGUMENT, "Invalid Query. '" + e28.toString() + "' filters support a maximum of 10 elements in the value array.");
}
function oc(t3, e28, n3) {
  if (!n3.isEqual(e28))
    throw new M(V.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality (<, <=, >, or >=) on field '" + e28.toString() + "' and so you must also use '" + e28.toString() + "' as your first argument to orderBy(), but your first orderBy() is on field '" + n3.toString() + "' instead.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function uc(t3) {
  return function(t6, e28) {
    if (typeof t6 != "object" || t6 === null)
      return false;
    for (var n3 = t6, r3 = 0, i = ["next", "error", "complete"]; r3 < i.length; r3++) {
      var o3 = i[r3];
      if (o3 in n3 && typeof n3[o3] == "function")
        return true;
    }
    return false;
  }(t3);
}
function sc(t3, e28, n3) {
  return t3 ? n3 && (n3.merge || n3.mergeFields) ? t3.toFirestore(e28, n3) : t3.toFirestore(e28) : e28;
}
var ac = function(t3) {
  function e28(e29) {
    var n3 = this;
    return (n3 = t3.call(this) || this).firestore = e29, n3;
  }
  return __extends$1(e28, t3), e28.prototype.Uf = function(t6) {
    return new U(t6);
  }, e28.prototype.Qf = function(t6) {
    var e29 = this.Gf(t6, this.firestore.I_);
    return new Gs(this.firestore, null, e29);
  }, e28;
}(Ba), cc = function() {
  function t3(t6, e28) {
    this.hasPendingWrites = t6, this.fromCache = e28;
  }
  return t3.prototype.isEqual = function(t6) {
    return this.hasPendingWrites === t6.hasPendingWrites && this.fromCache === t6.fromCache;
  }, t3;
}(), fc = function(t3) {
  function e28(e29, n3, r3, i, o3, u3) {
    var s3 = this;
    return (s3 = t3.call(this, e29, n3, r3, i, u3) || this).zf = e29, s3.ad = e29, s3.metadata = o3, s3;
  }
  return __extends$1(e28, t3), e28.prototype.exists = function() {
    return t3.prototype.exists.call(this);
  }, e28.prototype.data = function(t6) {
    if (t6 === void 0 && (t6 = {}), this.Jf) {
      if (this.v_) {
        var e29 = new hc(this.zf, this.Hf, this.S_, this.Jf, this.metadata, null);
        return this.v_.fromFirestore(e29, t6);
      }
      return this.Hf.$f(this.Jf.vt(), t6.serverTimestamps);
    }
  }, e28.prototype.get = function(t6, e29) {
    if (e29 === void 0 && (e29 = {}), this.Jf) {
      var n3 = this.Jf.data().field(Ja("DocumentSnapshot.get", t6));
      if (n3 !== null)
        return this.Hf.$f(n3, e29.serverTimestamps);
    }
  }, e28;
}(Ka), hc = function(t3) {
  function e28() {
    return t3 !== null && t3.apply(this, arguments) || this;
  }
  return __extends$1(e28, t3), e28.prototype.data = function(e29) {
    return e29 === void 0 && (e29 = {}), t3.prototype.data.call(this, e29);
  }, e28;
}(fc), lc = function() {
  function t3(t6, e28, n3, r3) {
    this.zf = t6, this.Hf = e28, this.ud = r3, this.metadata = new cc(r3.hasPendingWrites, r3.fromCache), this.query = n3;
  }
  return Object.defineProperty(t3.prototype, "docs", {
    get: function() {
      var t6 = [];
      return this.forEach(function(e28) {
        return t6.push(e28);
      }), t6;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "size", {
    get: function() {
      return this.ud.docs.size;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(t3.prototype, "empty", {
    get: function() {
      return this.size === 0;
    },
    enumerable: false,
    configurable: true
  }), t3.prototype.forEach = function(t6, e28) {
    var n3 = this;
    this.ud.docs.forEach(function(r3) {
      t6.call(e28, new hc(n3.zf, n3.Hf, r3.key, r3, new cc(n3.ud.Ce.has(r3.key), n3.ud.fromCache), n3.query.v_));
    });
  }, t3.prototype.docChanges = function(t6) {
    t6 === void 0 && (t6 = {});
    var e28 = !!t6.includeMetadataChanges;
    if (e28 && this.ud.Ne)
      throw new M(V.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
    return this.hd && this.ld === e28 || (this.hd = function(t10, e29) {
      if (t10.ud.De.nt()) {
        var n3 = 0;
        return t10.ud.docChanges.map(function(e30) {
          var r6 = new hc(t10.zf, t10.Hf, e30.doc.key, e30.doc, new cc(t10.ud.Ce.has(e30.doc.key), t10.ud.fromCache), t10.query.v_);
          return e30.doc, {
            type: "added",
            doc: r6,
            oldIndex: -1,
            newIndex: n3++
          };
        });
      }
      var r3 = t10.ud.De;
      return t10.ud.docChanges.filter(function(t11) {
        return e29 || t11.type !== 3;
      }).map(function(e30) {
        var n6 = new hc(t10.zf, t10.Hf, e30.doc.key, e30.doc, new cc(t10.ud.Ce.has(e30.doc.key), t10.ud.fromCache), t10.query.v_), i = -1, o3 = -1;
        return e30.type !== 0 && (i = r3.indexOf(e30.doc.key), r3 = r3.delete(e30.doc.key)), e30.type !== 1 && (o3 = (r3 = r3.add(e30.doc)).indexOf(e30.doc.key)), {
          type: pc(e30.type),
          doc: n6,
          oldIndex: i,
          newIndex: o3
        };
      });
    }(this, e28), this.ld = e28), this.hd;
  }, t3;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function pc(t3) {
  switch (t3) {
    case 0:
      return "added";
    case 2:
    case 3:
      return "modified";
    case 1:
      return "removed";
    default:
      return S();
  }
}
function dc(t3, e28) {
  return t3 instanceof fc && e28 instanceof fc ? t3.zf === e28.zf && t3.S_.isEqual(e28.S_) && (t3.Jf === null ? e28.Jf === null : t3.Jf.isEqual(e28.Jf)) && t3.v_ === e28.v_ : t3 instanceof lc && e28 instanceof lc && t3.zf === e28.zf && Qs(t3.query, e28.query) && t3.metadata.isEqual(e28.metadata) && t3.ud.isEqual(e28.ud);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var vc = function(t3) {
  function e28(e29) {
    var n3 = this;
    return (n3 = t3.call(this) || this).firestore = e29, n3;
  }
  return __extends$1(e28, t3), e28.prototype.Uf = function(t6) {
    return new U(t6);
  }, e28.prototype.Qf = function(t6) {
    var e29 = this.Gf(t6, this.firestore.I_);
    return new Gs(this.firestore, null, e29);
  }, e28;
}(Ba);
function yc(t3, e28, n3) {
  for (var r3 = [], i = 3; i < arguments.length; i++)
    r3[i - 3] = arguments[i];
  t3 = Us(t3, Gs);
  var o3 = Us(t3.firestore, qa), u3 = ra(o3);
  return e28 instanceof q && (e28 = e28._), gc(o3, [(typeof e28 == "string" || e28 instanceof ks ? la(u3, "updateDoc", t3.S_, e28, n3, r3) : ha(u3, "updateDoc", t3.S_, e28)).F_(t3.S_, Fe.exists(true))]);
}
function mc(t3) {
  for (var e28, n3, r3, i = [], o3 = 1; o3 < arguments.length; o3++)
    i[o3 - 1] = arguments[o3];
  t3 instanceof q && (t3 = t3._);
  var u3 = {
    includeMetadataChanges: false
  }, s3 = 0;
  typeof i[s3] != "object" || uc(i[s3]) || (u3 = i[s3], s3++);
  var a3, c3, f3, h3 = {
    includeMetadataChanges: u3.includeMetadataChanges
  };
  if (uc(i[s3])) {
    var l3 = i[s3];
    i[s3] = (e28 = l3.next) === null || e28 === void 0 ? void 0 : e28.bind(l3), i[s3 + 1] = (n3 = l3.error) === null || n3 === void 0 ? void 0 : n3.bind(l3), i[s3 + 2] = (r3 = l3.complete) === null || r3 === void 0 ? void 0 : r3.bind(l3);
  }
  if (t3 instanceof Gs)
    c3 = Us(t3.firestore, qa), f3 = se(t3.S_.path), a3 = {
      next: function(e29) {
        i[s3] && i[s3](wc(c3, t3, e29));
      },
      error: i[s3 + 1],
      complete: i[s3 + 2]
    };
  else {
    var p3 = Us(t3, Bs);
    c3 = Us(p3.firestore, qa), f3 = p3.C_;
    var d3 = new vc(c3);
    a3 = {
      next: function(t6) {
        i[s3] && i[s3](new lc(c3, d3, p3, t6));
      },
      error: i[s3 + 1],
      complete: i[s3 + 2]
    }, Wa(t3.C_);
  }
  return function(t6, e29, n6, r6) {
    var i3 = this, o6 = new xs(r6), u6 = new Lu(e29, o6, n6);
    return t6.fs.ys(function() {
      return __awaiter(i3, void 0, void 0, function() {
        var e30;
        return __generator(this, function(n10) {
          switch (n10.label) {
            case 0:
              return e30 = Du, [4, La(t6)];
            case 1:
              return [2, e30.apply(void 0, [n10.sent(), u6])];
          }
        });
      });
    }), function() {
      o6.r_(), t6.fs.ys(function() {
        return __awaiter(i3, void 0, void 0, function() {
          var e30;
          return __generator(this, function(n10) {
            switch (n10.label) {
              case 0:
                return e30 = ku, [4, La(t6)];
              case 1:
                return [2, e30.apply(void 0, [n10.sent(), u6])];
            }
          });
        });
      });
    };
  }(Fa(c3), f3, h3, a3);
}
function gc(t3, e28) {
  return function(t6, e29) {
    var n3 = this, r3 = new vr();
    return t6.fs.ys(function() {
      return __awaiter(n3, void 0, void 0, function() {
        var n6;
        return __generator(this, function(i) {
          switch (i.label) {
            case 0:
              return n6 = Wu, [4, Ca(t6)];
            case 1:
              return [2, n6.apply(void 0, [i.sent(), e29, r3])];
          }
        });
      });
    }), r3.promise;
  }(Fa(t3), e28);
}
function wc(t3, e28, n3) {
  var r3 = n3.docs.get(e28.S_), i = new vc(t3);
  return new fc(t3, i, e28.S_, r3, new cc(n3.hasPendingWrites, n3.fromCache), e28.v_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var bc = function() {
  function t3(t6, e28) {
    this.zf = t6, this._d = e28, this.fd = [], this.dd = false, this.wd = ra(t6);
  }
  return t3.prototype.set = function(t6, e28, n3) {
    this.Ed();
    var r3 = Ic(t6, this.zf), i = sc(r3.v_, e28, n3), o3 = ia(this.wd, "WriteBatch.set", r3.S_, i, r3.v_ !== null, n3);
    return this.fd.push(o3.F_(r3.S_, Fe.Wt())), this;
  }, t3.prototype.update = function(t6, e28, n3) {
    for (var r3 = [], i = 3; i < arguments.length; i++)
      r3[i - 3] = arguments[i];
    this.Ed();
    var o3, u3 = Ic(t6, this.zf);
    return e28 instanceof q && (e28 = e28._), o3 = typeof e28 == "string" || e28 instanceof ks ? la(this.wd, "WriteBatch.update", u3.S_, e28, n3, r3) : ha(this.wd, "WriteBatch.update", u3.S_, e28), this.fd.push(o3.F_(u3.S_, Fe.exists(true))), this;
  }, t3.prototype.delete = function(t6) {
    this.Ed();
    var e28 = Ic(t6, this.zf);
    return this.fd = this.fd.concat(new nn(e28.S_, Fe.Wt())), this;
  }, t3.prototype.commit = function() {
    return this.Ed(), this.dd = true, this.fd.length > 0 ? this._d(this.fd) : Promise.resolve();
  }, t3.prototype.Ed = function() {
    if (this.dd)
      throw new M(V.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
  }, t3;
}();
function Ic(t3, e28) {
  if (t3 instanceof q && (t3 = t3._), t3.firestore !== e28)
    throw new M(V.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
  return t3;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _c = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, e29, n3) || this).zf = e29, r3;
  }
  return __extends$1(e28, t3), e28.prototype.get = function(e29) {
    var n3 = this, r3 = Ic(e29, this.zf), i = new vc(this.zf);
    return t3.prototype.get.call(this, e29).then(function(t6) {
      return new fc(n3.zf, i, r3.S_, t6.Jf, new cc(false, false), r3.v_);
    });
  }, e28;
}(function() {
  function t3(t6, e28) {
    this.zf = t6, this.Td = e28, this.wd = ra(t6);
  }
  return t3.prototype.get = function(t6) {
    var e28 = this, n3 = Ic(t6, this.zf), r3 = new ac(this.zf);
    return this.Td.ef([n3.S_]).then(function(t10) {
      if (!t10 || t10.length !== 1)
        return S();
      var i = t10[0];
      if (i instanceof Mt)
        return new Ka(e28.zf, r3, n3.S_, null, n3.v_);
      if (i instanceof Vt)
        return new Ka(e28.zf, r3, i.key, i, n3.v_);
      throw S();
    });
  }, t3.prototype.set = function(t6, e28, n3) {
    var r3 = Ic(t6, this.zf), i = sc(r3.v_, e28, n3), o3 = ia(this.wd, "Transaction.set", r3.S_, i, r3.v_ !== null, n3);
    return this.Td.set(r3.S_, o3), this;
  }, t3.prototype.update = function(t6, e28, n3) {
    for (var r3 = [], i = 3; i < arguments.length; i++)
      r3[i - 3] = arguments[i];
    var o3, u3 = Ic(t6, this.zf);
    return e28 instanceof q && (e28 = e28._), o3 = typeof e28 == "string" || e28 instanceof ks ? la(this.wd, "Transaction.update", u3.S_, e28, n3, r3) : ha(this.wd, "Transaction.update", u3.S_, e28), this.Td.update(u3.S_, o3), this;
  }, t3.prototype.delete = function(t6) {
    var e28 = Ic(t6, this.zf);
    return this.Td.delete(e28.S_), this;
  }, t3;
}()), Ec = function() {
  function t3() {
  }
  return t3.prototype.enableIndexedDbPersistence = function(t6, e28) {
    return function(t10, e29) {
      Ga(t10 = Us(t10, qa));
      var n3 = Fa(t10), r3 = t10.p_(), i = new As();
      return za(n3, i, new Ts(i, r3.cacheSizeBytes, e29 == null ? void 0 : e29.forceOwnership));
    }(t6._, {
      forceOwnership: e28
    });
  }, t3.prototype.enableMultiTabIndexedDbPersistence = function(t6) {
    return function(t10) {
      Ga(t10 = Us(t10, qa));
      var e28 = Fa(t10), n3 = t10.p_(), r3 = new As();
      return za(e28, r3, new Ns(r3, n3.cacheSizeBytes));
    }(t6._);
  }, t3.prototype.clearIndexedDbPersistence = function(t6) {
    return function(t10) {
      var e28 = this;
      if (t10.R_ && !t10.P_)
        throw new M(V.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
      var n3 = new vr();
      return t10.Mf.Tf(function() {
        return __awaiter(e28, void 0, void 0, function() {
          var e29;
          return __generator(this, function(r3) {
            switch (r3.label) {
              case 0:
                return r3.trys.push([0, 2, , 3]), [4, function(t11) {
                  return __awaiter(this, void 0, void 0, function() {
                    var e30;
                    return __generator(this, function(n6) {
                      switch (n6.label) {
                        case 0:
                          return gr.Wn() ? (e30 = t11 + "main", [4, gr.delete(e30)]) : [2, Promise.resolve()];
                        case 1:
                          return n6.sent(), [2];
                      }
                    });
                  });
                }(to$1(t10.I_, t10.w_))];
              case 1:
                return r3.sent(), n3.resolve(), [3, 3];
              case 2:
                return e29 = r3.sent(), n3.reject(e29), [3, 3];
              case 3:
                return [2];
            }
          });
        });
      }), n3.promise;
    }(t6._);
  }, t3;
}(), Tc = function(t3) {
  function e28(e29, n3, r3) {
    var i = this;
    return (i = t3.call(this, n3) || this).Id = r3, i.INTERNAL = {
      delete: function() {
        return i.terminate();
      }
    }, e29 instanceof B || (i.md = e29), i;
  }
  return __extends$1(e28, t3), Object.defineProperty(e28.prototype, "I_", {
    get: function() {
      return this._.I_;
    },
    enumerable: false,
    configurable: true
  }), e28.prototype.settings = function(t6) {
    t6.merge && delete (t6 = Object.assign(Object.assign({}, this._.V_()), t6)).merge, this._.g_(t6);
  }, e28.prototype.useEmulator = function(t6, e29) {
    this._.V_().host !== "firestore.googleapis.com" && N("Host has been set in both settings() and useEmulator(), emulator host will be used"), this.settings({
      host: t6 + ":" + e29,
      ssl: false,
      merge: true
    });
  }, e28.prototype.enableNetwork = function() {
    return function(t6) {
      var e29 = this;
      return t6.fs.enqueue(function() {
        return __awaiter(e29, void 0, void 0, function() {
          var e30, n3;
          return __generator(this, function(r3) {
            switch (r3.label) {
              case 0:
                return [4, ka(t6)];
              case 1:
                return e30 = r3.sent(), [4, Pa(t6)];
              case 2:
                return n3 = r3.sent(), [2, (e30.po(true), function(t10) {
                  var e31 = D(t10);
                  return e31.Fh.delete(0), nu(e31);
                }(n3))];
            }
          });
        });
      });
    }(Fa(Us(this._, qa)));
  }, e28.prototype.disableNetwork = function() {
    return function(t6) {
      var e29 = this;
      return t6.fs.enqueue(function() {
        return __awaiter(e29, void 0, void 0, function() {
          var e30, n3;
          return __generator(this, function(r3) {
            switch (r3.label) {
              case 0:
                return [4, ka(t6)];
              case 1:
                return e30 = r3.sent(), [4, Pa(t6)];
              case 2:
                return n3 = r3.sent(), [2, (e30.po(false), function(t10) {
                  return __awaiter(this, void 0, void 0, function() {
                    var e31;
                    return __generator(this, function(n6) {
                      switch (n6.label) {
                        case 0:
                          return (e31 = D(t10)).Fh.add(0), [4, ru(e31)];
                        case 1:
                          return n6.sent(), e31.Mh.set("Offline"), [2];
                      }
                    });
                  });
                }(n3))];
            }
          });
        });
      });
    }(Fa(Us(this._, qa)));
  }, e28.prototype.enablePersistence = function(t6) {
    var e29 = false, n3 = false;
    return t6 && Ls("synchronizeTabs", e29 = !!t6.synchronizeTabs, "experimentalForceOwningTab", n3 = !!t6.experimentalForceOwningTab), e29 ? this.Id.enableMultiTabIndexedDbPersistence(this) : this.Id.enableIndexedDbPersistence(this, n3);
  }, e28.prototype.clearPersistence = function() {
    return this.Id.clearIndexedDbPersistence(this);
  }, e28.prototype.terminate = function() {
    return this.app._removeServiceInstance("firestore"), this.app._removeServiceInstance("firestore-exp"), this._._delete();
  }, e28.prototype.waitForPendingWrites = function() {
    return function(t6) {
      var e29 = this, n3 = new vr();
      return t6.fs.ys(function() {
        return __awaiter(e29, void 0, void 0, function() {
          var e30;
          return __generator(this, function(r3) {
            switch (r3.label) {
              case 0:
                return e30 = ts, [4, Ca(t6)];
              case 1:
                return [2, e30.apply(void 0, [r3.sent(), n3])];
            }
          });
        });
      }), n3.promise;
    }(Fa(Us(this._, qa)));
  }, e28.prototype.onSnapshotsInSync = function(t6) {
    return function(t10, e29) {
      return function(t11, e30) {
        var n3 = this, r3 = new xs(e30);
        return t11.fs.ys(function() {
          return __awaiter(n3, void 0, void 0, function() {
            var e31;
            return __generator(this, function(n6) {
              switch (n6.label) {
                case 0:
                  return e31 = function(t12, e32) {
                    D(t12).jh.add(e32), e32.next();
                  }, [4, La(t11)];
                case 1:
                  return [2, e31.apply(void 0, [n6.sent(), r3])];
              }
            });
          });
        }), function() {
          r3.r_(), t11.fs.ys(function() {
            return __awaiter(n3, void 0, void 0, function() {
              var e31;
              return __generator(this, function(n6) {
                switch (n6.label) {
                  case 0:
                    return e31 = function(t12, e32) {
                      D(t12).jh.delete(e32);
                    }, [4, La(t11)];
                  case 1:
                    return [2, e31.apply(void 0, [n6.sent(), r3])];
                }
              });
            });
          });
        };
      }(Fa(t10 = Us(t10, qa)), uc(e29) ? e29 : {
        next: e29
      });
    }(this._, t6);
  }, Object.defineProperty(e28.prototype, "app", {
    get: function() {
      if (!this.md)
        throw new M(V.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
      return this.md;
    },
    enumerable: false,
    configurable: true
  }), e28.prototype.collection = function(t6) {
    try {
      return new Uc(this, Hs(this._, t6));
    } catch (t10) {
      throw kc(t10, "collection()", "Firestore.collection()");
    }
  }, e28.prototype.doc = function(t6) {
    try {
      return new Dc(this, Js(this._, t6));
    } catch (t10) {
      throw kc(t10, "doc()", "Firestore.doc()");
    }
  }, e28.prototype.collectionGroup = function(t6) {
    try {
      return new Rc(this, function(t10, e29) {
        if (t10 = Us(t10, zs), Ps("collectionGroup", "collection id", e29), e29.indexOf("/") >= 0)
          throw new M(V.INVALID_ARGUMENT, "Invalid collection ID '" + e29 + "' passed to function collectionGroup(). Collection IDs must not contain '/'.");
        return new Bs(t10, null, function(t11) {
          return new oe(et.at(), t11);
        }(e29));
      }(this._, t6));
    } catch (t10) {
      throw kc(t10, "collectionGroup()", "Firestore.collectionGroup()");
    }
  }, e28.prototype.runTransaction = function(t6) {
    var e29 = this;
    return function(t10, e30) {
      return function(t11, e31) {
        var n3 = this, r3 = new vr();
        return t11.fs.ys(function() {
          return __awaiter(n3, void 0, void 0, function() {
            var n6;
            return __generator(this, function(i) {
              switch (i.label) {
                case 0:
                  return [4, function(t12) {
                    return Da(t12).then(function(t13) {
                      return t13.Dh;
                    });
                  }(t11)];
                case 1:
                  return n6 = i.sent(), new Ta(t11.fs, n6, e31, r3).run(), [2];
              }
            });
          });
        }), r3.promise;
      }(Fa(t10), function(n3) {
        return e30(new _c(t10, n3));
      });
    }(this._, function(n3) {
      return t6(new Sc(e29, n3));
    });
  }, e28.prototype.batch = function() {
    var t6 = this;
    return Fa(this._), new xc(new bc(this._, function(e29) {
      return gc(t6._, e29);
    }));
  }, e28.prototype.loadBundle = function(t6) {
    throw new M(V.FAILED_PRECONDITION, '"loadBundle()" does not exist, have you imported "firebase/firestore/bundle"?');
  }, e28.prototype.namedQuery = function(t6) {
    throw new M(V.FAILED_PRECONDITION, '"namedQuery()" does not exist, have you imported "firebase/firestore/bundle"?');
  }, e28;
}(q), Nc = function(t3) {
  function e28(e29) {
    var n3 = this;
    return (n3 = t3.call(this) || this).firestore = e29, n3;
  }
  return __extends$1(e28, t3), e28.prototype.Uf = function(t6) {
    return new z(new U(t6));
  }, e28.prototype.Qf = function(t6) {
    var e29 = this.Gf(t6, this.firestore.I_);
    return Dc.Ad(e29, this.firestore, null);
  }, e28;
}(Ba);
function Ac(t3) {
  var e28;
  e28 = t3, I.setLogLevel(e28);
}
var Sc = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, n3) || this).zf = e29, r3;
  }
  return __extends$1(e28, t3), e28.prototype.get = function(t6) {
    var e29 = this, n3 = qc(t6);
    return this._.get(n3).then(function(t10) {
      return new Cc(e29.zf, t10);
    });
  }, e28.prototype.set = function(t6, e29, n3) {
    var r3 = qc(t6);
    return n3 ? (Cs("Transaction.set", n3), this._.set(r3, e29, n3)) : this._.set(r3, e29), this;
  }, e28.prototype.update = function(t6, e29, n3) {
    for (var r3, i = [], o3 = 3; o3 < arguments.length; o3++)
      i[o3 - 3] = arguments[o3];
    var u3 = qc(t6);
    return arguments.length === 2 ? this._.update(u3, e29) : (r3 = this._).update.apply(r3, __spreadArrays$1([u3, e29, n3], i)), this;
  }, e28.prototype.delete = function(t6) {
    var e29 = qc(t6);
    return this._.delete(e29), this;
  }, e28;
}(q), xc = function(t3) {
  function e28() {
    return t3 !== null && t3.apply(this, arguments) || this;
  }
  return __extends$1(e28, t3), e28.prototype.set = function(t6, e29, n3) {
    var r3 = qc(t6);
    return n3 ? (Cs("WriteBatch.set", n3), this._.set(r3, e29, n3)) : this._.set(r3, e29), this;
  }, e28.prototype.update = function(t6, e29, n3) {
    for (var r3, i = [], o3 = 3; o3 < arguments.length; o3++)
      i[o3 - 3] = arguments[o3];
    var u3 = qc(t6);
    return arguments.length === 2 ? this._.update(u3, e29) : (r3 = this._).update.apply(r3, __spreadArrays$1([u3, e29, n3], i)), this;
  }, e28.prototype.delete = function(t6) {
    var e29 = qc(t6);
    return this._.delete(e29), this;
  }, e28.prototype.commit = function() {
    return this._.commit();
  }, e28;
}(q), Dc = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, n3) || this).firestore = e29, r3.Hf = new Nc(e29), r3;
  }
  return __extends$1(e28, t3), e28.Rd = function(t6, n3, r3) {
    if (t6.length % 2 != 0)
      throw new M(V.INVALID_ARGUMENT, "Invalid document reference. Document references must have an even number of segments, but " + t6.ot() + " has " + t6.length);
    return new e28(n3, new Gs(n3._, r3, new it(t6)));
  }, e28.Ad = function(t6, n3, r3) {
    return new e28(n3, new Gs(n3._, r3, t6));
  }, Object.defineProperty(e28.prototype, "id", {
    get: function() {
      return this._.id;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "parent", {
    get: function() {
      return new Uc(this.firestore, this._.parent);
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "path", {
    get: function() {
      return this._.path;
    },
    enumerable: false,
    configurable: true
  }), e28.prototype.collection = function(t6) {
    try {
      return new Uc(this.firestore, Hs(this._, t6));
    } catch (t10) {
      throw kc(t10, "collection()", "DocumentReference.collection()");
    }
  }, e28.prototype.isEqual = function(t6) {
    return t6 instanceof q && (t6 = t6._), t6 instanceof Gs && Ws(this._, t6);
  }, e28.prototype.set = function(t6, e29) {
    e29 = Cs("DocumentReference.set", e29);
    try {
      return function(t10, e30, n3) {
        t10 = Us(t10, Gs);
        var r3 = Us(t10.firestore, qa), i = sc(t10.v_, e30, n3);
        return gc(r3, [ia(ra(r3), "setDoc", t10.S_, i, t10.v_ !== null, n3).F_(t10.S_, Fe.Wt())]);
      }(this._, t6, e29);
    } catch (t10) {
      throw kc(t10, "setDoc()", "DocumentReference.set()");
    }
  }, e28.prototype.update = function(t6, e29) {
    for (var n3 = [], r3 = 2; r3 < arguments.length; r3++)
      n3[r3 - 2] = arguments[r3];
    try {
      return arguments.length === 1 ? yc(this._, t6) : yc.apply(void 0, __spreadArrays$1([this._, t6, e29], n3));
    } catch (t10) {
      throw kc(t10, "updateDoc()", "DocumentReference.update()");
    }
  }, e28.prototype.delete = function() {
    return gc(Us((t6 = this._).firestore, qa), [new nn(t6.S_, Fe.Wt())]);
    var t6;
  }, e28.prototype.onSnapshot = function() {
    for (var t6 = this, e29 = [], n3 = 0; n3 < arguments.length; n3++)
      e29[n3] = arguments[n3];
    var r3 = Oc(e29), i = Pc(e29, function(e30) {
      return new Cc(t6.firestore, new fc(t6.firestore._, t6.Hf, e30.S_, e30.Jf, e30.metadata, t6._.v_));
    });
    return mc(this._, r3, i);
  }, e28.prototype.get = function(t6) {
    var e29 = this;
    return ((t6 == null ? void 0 : t6.source) === "cache" ? function(t10) {
      t10 = Us(t10, Gs);
      var e30 = Us(t10.firestore, qa), n3 = Fa(e30), r3 = new vc(e30);
      return function(t11, e31) {
        var n6 = this, r6 = new vr();
        return t11.fs.ys(function() {
          return __awaiter(n6, void 0, void 0, function() {
            var n10;
            return __generator(this, function(i) {
              switch (i.label) {
                case 0:
                  return n10 = function(t12, e32, n11) {
                    return __awaiter(this, void 0, void 0, function() {
                      var r10, i3;
                      return __generator(this, function(o3) {
                        switch (o3.label) {
                          case 0:
                            return o3.trys.push([0, 2, , 3]), [4, function(t13, e33) {
                              var n12 = D(t13);
                              return n12.persistence.runTransaction("read document", "readonly", function(t14) {
                                return n12.Ic.Jo(t14, e33);
                              });
                            }(t12, e32)];
                          case 1:
                            return (i3 = o3.sent()) instanceof Vt ? n11.resolve(i3) : i3 instanceof Mt ? n11.resolve(null) : n11.reject(new M(V.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)")), [3, 3];
                          case 2:
                            return r10 = o3.sent(), i3 = Sr(r10, "Failed to get document '" + e32 + " from cache"), n11.reject(i3), [3, 3];
                          case 3:
                            return [2];
                        }
                      });
                    });
                  }, [4, Oa(t11)];
                case 1:
                  return [2, n10.apply(void 0, [i.sent(), e31, r6])];
              }
            });
          });
        }), r6.promise;
      }(n3, t10.S_).then(function(n6) {
        return new fc(e30, r3, t10.S_, n6, new cc(n6 instanceof Vt && n6.bt, true), t10.v_);
      });
    }(this._) : (t6 == null ? void 0 : t6.source) === "server" ? function(t10) {
      t10 = Us(t10, Gs);
      var e30 = Us(t10.firestore, qa);
      return Ra(Fa(e30), t10.S_, {
        source: "server"
      }).then(function(n3) {
        return wc(e30, t10, n3);
      });
    }(this._) : function(t10) {
      t10 = Us(t10, Gs);
      var e30 = Us(t10.firestore, qa);
      return Ra(Fa(e30), t10.S_).then(function(n3) {
        return wc(e30, t10, n3);
      });
    }(this._)).then(function(t10) {
      return new Cc(e29.firestore, new fc(e29.firestore._, e29.Hf, t10.S_, t10.Jf, t10.metadata, e29._.v_));
    });
  }, e28.prototype.withConverter = function(t6) {
    return new e28(this.firestore, this._.withConverter(t6));
  }, e28;
}(q);
function kc(t3, e28, n3) {
  return t3.message = t3.message.replace(e28, n3), t3;
}
function Oc(t3) {
  for (var e28 = 0, n3 = t3; e28 < n3.length; e28++) {
    var r3 = n3[e28];
    if (typeof r3 == "object" && !uc(r3))
      return r3;
  }
  return {};
}
function Pc(t3, e28) {
  var n3, r3, i;
  return {
    next: function(t6) {
      i.next && i.next(e28(t6));
    },
    error: (n3 = (i = uc(t3[0]) ? t3[0] : uc(t3[1]) ? t3[1] : typeof t3[0] == "function" ? {
      next: t3[0],
      error: t3[1],
      complete: t3[2]
    } : {
      next: t3[1],
      error: t3[2],
      complete: t3[3]
    }).error) === null || n3 === void 0 ? void 0 : n3.bind(i),
    complete: (r3 = i.complete) === null || r3 === void 0 ? void 0 : r3.bind(i)
  };
}
var Cc = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, n3) || this).zf = e29, r3;
  }
  return __extends$1(e28, t3), Object.defineProperty(e28.prototype, "ref", {
    get: function() {
      return new Dc(this.zf, this._.ref);
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "id", {
    get: function() {
      return this._.id;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "metadata", {
    get: function() {
      return this._.metadata;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "exists", {
    get: function() {
      return this._.exists();
    },
    enumerable: false,
    configurable: true
  }), e28.prototype.data = function(t6) {
    return this._.data(t6);
  }, e28.prototype.get = function(t6, e29) {
    return this._.get(t6, e29);
  }, e28.prototype.isEqual = function(t6) {
    return dc(this._, t6._);
  }, e28;
}(q), Lc = function(t3) {
  function e28() {
    return t3 !== null && t3.apply(this, arguments) || this;
  }
  return __extends$1(e28, t3), e28.prototype.data = function(t6) {
    return this._.data(t6);
  }, e28;
}(Cc), Rc = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, n3) || this).firestore = e29, r3.Hf = new Nc(e29), r3;
  }
  return __extends$1(e28, t3), e28.prototype.where = function(t6, n3, r3) {
    try {
      return new e28(this.firestore, Ya(this._, function(t10, e29, n6) {
        var r6 = e29, i = Ja("where", t10);
        return new $a(i, r6, n6);
      }(t6, n3, r3)));
    } catch (t10) {
      throw kc(t10, /(orderBy|where)\(\)/, "Query.$1()");
    }
  }, e28.prototype.orderBy = function(t6, n3) {
    try {
      return new e28(this.firestore, Ya(this._, function(t10, e29) {
        e29 === void 0 && (e29 = "asc");
        var n6 = e29, r3 = Ja("orderBy", t10);
        return new Xa(r3, n6);
      }(t6, n3)));
    } catch (t10) {
      throw kc(t10, /(orderBy|where)\(\)/, "Query.$1()");
    }
  }, e28.prototype.limit = function(t6) {
    try {
      return new e28(this.firestore, Ya(this._, function(t10) {
        return qs("limit", t10), new Za("limit", t10, "F");
      }(t6)));
    } catch (t10) {
      throw kc(t10, "limit()", "Query.limit()");
    }
  }, e28.prototype.limitToLast = function(t6) {
    try {
      return new e28(this.firestore, Ya(this._, function(t10) {
        return qs("limitToLast", t10), new Za("limitToLast", t10, "L");
      }(t6)));
    } catch (t10) {
      throw kc(t10, "limitToLast()", "Query.limitToLast()");
    }
  }, e28.prototype.startAt = function() {
    for (var t6 = [], n3 = 0; n3 < arguments.length; n3++)
      t6[n3] = arguments[n3];
    try {
      return new e28(this.firestore, Ya(this._, function() {
        for (var t10 = [], e29 = 0; e29 < arguments.length; e29++)
          t10[e29] = arguments[e29];
        return new tc("startAt", t10, true);
      }.apply(void 0, t6)));
    } catch (t10) {
      throw kc(t10, "startAt()", "Query.startAt()");
    }
  }, e28.prototype.startAfter = function() {
    for (var t6 = [], n3 = 0; n3 < arguments.length; n3++)
      t6[n3] = arguments[n3];
    try {
      return new e28(this.firestore, Ya(this._, function() {
        for (var t10 = [], e29 = 0; e29 < arguments.length; e29++)
          t10[e29] = arguments[e29];
        return new tc("startAfter", t10, false);
      }.apply(void 0, t6)));
    } catch (t10) {
      throw kc(t10, "startAfter()", "Query.startAfter()");
    }
  }, e28.prototype.endBefore = function() {
    for (var t6 = [], n3 = 0; n3 < arguments.length; n3++)
      t6[n3] = arguments[n3];
    try {
      return new e28(this.firestore, Ya(this._, function() {
        for (var t10 = [], e29 = 0; e29 < arguments.length; e29++)
          t10[e29] = arguments[e29];
        return new ec("endBefore", t10, true);
      }.apply(void 0, t6)));
    } catch (t10) {
      throw kc(t10, "endBefore()", "Query.endBefore()");
    }
  }, e28.prototype.endAt = function() {
    for (var t6 = [], n3 = 0; n3 < arguments.length; n3++)
      t6[n3] = arguments[n3];
    try {
      return new e28(this.firestore, Ya(this._, function() {
        for (var t10 = [], e29 = 0; e29 < arguments.length; e29++)
          t10[e29] = arguments[e29];
        return new ec("endAt", t10, false);
      }.apply(void 0, t6)));
    } catch (t10) {
      throw kc(t10, "endAt()", "Query.endAt()");
    }
  }, e28.prototype.isEqual = function(t6) {
    return Qs(this._, t6._);
  }, e28.prototype.get = function(t6) {
    var e29 = this;
    return ((t6 == null ? void 0 : t6.source) === "cache" ? function(t10) {
      t10 = Us(t10, Bs);
      var e30 = Us(t10.firestore, qa), n3 = Fa(e30), r3 = new vc(e30);
      return function(t11, e31) {
        var n6 = this, r6 = new vr();
        return t11.fs.ys(function() {
          return __awaiter(n6, void 0, void 0, function() {
            var n10;
            return __generator(this, function(i) {
              switch (i.label) {
                case 0:
                  return n10 = function(t12, e32, n11) {
                    return __awaiter(this, void 0, void 0, function() {
                      var r10, i3, o3, u3, s3;
                      return __generator(this, function(a3) {
                        switch (a3.label) {
                          case 0:
                            return a3.trys.push([0, 2, , 3]), [4, vo(t12, e32, true)];
                          case 1:
                            return s3 = a3.sent(), r10 = new ju(e32, s3.Pc), i3 = r10.dl(s3.documents), o3 = r10.Ti(i3, false), n11.resolve(o3.snapshot), [3, 3];
                          case 2:
                            return u3 = a3.sent(), s3 = Sr(u3, "Failed to execute query '" + e32 + " against cache"), n11.reject(s3), [3, 3];
                          case 3:
                            return [2];
                        }
                      });
                    });
                  }, [4, Oa(t11)];
                case 1:
                  return [2, n10.apply(void 0, [i.sent(), e31, r6])];
              }
            });
          });
        }), r6.promise;
      }(n3, t10.C_).then(function(n6) {
        return new lc(e30, r3, t10, n6);
      });
    }(this._) : (t6 == null ? void 0 : t6.source) === "server" ? function(t10) {
      t10 = Us(t10, Bs);
      var e30 = Us(t10.firestore, qa), n3 = Fa(e30), r3 = new vc(e30);
      return Va(n3, t10.C_, {
        source: "server"
      }).then(function(n6) {
        return new lc(e30, r3, t10, n6);
      });
    }(this._) : function(t10) {
      t10 = Us(t10, Bs);
      var e30 = Us(t10.firestore, qa), n3 = Fa(e30), r3 = new vc(e30);
      return Wa(t10.C_), Va(n3, t10.C_).then(function(n6) {
        return new lc(e30, r3, t10, n6);
      });
    }(this._)).then(function(t10) {
      return new Mc(e29.firestore, new lc(e29.firestore._, e29.Hf, e29._, t10.ud));
    });
  }, e28.prototype.onSnapshot = function() {
    for (var t6 = this, e29 = [], n3 = 0; n3 < arguments.length; n3++)
      e29[n3] = arguments[n3];
    var r3 = Oc(e29), i = Pc(e29, function(e30) {
      return new Mc(t6.firestore, new lc(t6.firestore._, t6.Hf, t6._, e30.ud));
    });
    return mc(this._, r3, i);
  }, e28.prototype.withConverter = function(t6) {
    return new e28(this.firestore, this._.withConverter(t6));
  }, e28;
}(q), Vc = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, n3) || this).zf = e29, r3;
  }
  return __extends$1(e28, t3), Object.defineProperty(e28.prototype, "type", {
    get: function() {
      return this._.type;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "doc", {
    get: function() {
      return new Lc(this.zf, this._.doc);
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "oldIndex", {
    get: function() {
      return this._.oldIndex;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "newIndex", {
    get: function() {
      return this._.newIndex;
    },
    enumerable: false,
    configurable: true
  }), e28;
}(q), Mc = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, n3) || this).zf = e29, r3;
  }
  return __extends$1(e28, t3), Object.defineProperty(e28.prototype, "query", {
    get: function() {
      return new Rc(this.zf, this._.query);
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "metadata", {
    get: function() {
      return this._.metadata;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "size", {
    get: function() {
      return this._.size;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "empty", {
    get: function() {
      return this._.empty;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "docs", {
    get: function() {
      var t6 = this;
      return this._.docs.map(function(e29) {
        return new Lc(t6.zf, e29);
      });
    },
    enumerable: false,
    configurable: true
  }), e28.prototype.docChanges = function(t6) {
    var e29 = this;
    return this._.docChanges(t6).map(function(t10) {
      return new Vc(e29.zf, t10);
    });
  }, e28.prototype.forEach = function(t6, e29) {
    var n3 = this;
    this._.forEach(function(r3) {
      t6.call(e29, new Lc(n3.zf, r3));
    });
  }, e28.prototype.isEqual = function(t6) {
    return dc(this._, t6._);
  }, e28;
}(q), Uc = function(t3) {
  function e28(e29, n3) {
    var r3 = this;
    return (r3 = t3.call(this, e29, n3) || this).firestore = e29, r3._ = n3, r3;
  }
  return __extends$1(e28, t3), Object.defineProperty(e28.prototype, "id", {
    get: function() {
      return this._.id;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "path", {
    get: function() {
      return this._.path;
    },
    enumerable: false,
    configurable: true
  }), Object.defineProperty(e28.prototype, "parent", {
    get: function() {
      var t6 = this._.parent;
      return t6 ? new Dc(this.firestore, t6) : null;
    },
    enumerable: false,
    configurable: true
  }), e28.prototype.doc = function(t6) {
    try {
      return new Dc(this.firestore, t6 === void 0 ? Js(this._) : Js(this._, t6));
    } catch (t10) {
      throw kc(t10, "doc()", "CollectionReference.doc()");
    }
  }, e28.prototype.add = function(t6) {
    var e29 = this;
    return function(t10, e30) {
      var n3 = Us(t10.firestore, qa), r3 = Js(t10), i = sc(t10.v_, e30);
      return gc(n3, [ia(ra(t10.firestore), "addDoc", r3.S_, i, t10.v_ !== null, {}).F_(r3.S_, Fe.exists(false))]).then(function() {
        return r3;
      });
    }(this._, t6).then(function(t10) {
      return new Dc(e29.firestore, t10);
    });
  }, e28.prototype.isEqual = function(t6) {
    return Ws(this._, t6._);
  }, e28.prototype.withConverter = function(t6) {
    return new e28(this.firestore, this._.withConverter(t6));
  }, e28;
}(Rc);
function qc(t3) {
  return t3 instanceof q && (t3 = t3._), Us(t3, Gs);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Fc = function(t3) {
  function e28() {
    for (var e29 = [], n3 = 0; n3 < arguments.length; n3++)
      e29[n3] = arguments[n3];
    return t3.call(this, new (ks.bind.apply(ks, __spreadArrays$1([void 0], e29)))()) || this;
  }
  return __extends$1(e28, t3), e28.documentId = function() {
    return new e28(rt.lt().ot());
  }, e28.prototype.isEqual = function(t6) {
    return t6 instanceof q && (t6 = t6._), t6 instanceof ks && this._.d_.isEqual(t6.d_);
  }, e28;
}(q), jc = function(t3) {
  function e28() {
    return t3 !== null && t3.apply(this, arguments) || this;
  }
  return __extends$1(e28, t3), e28.serverTimestamp = function() {
    var t6 = new sa("serverTimestamp");
    return t6._methodName = "FieldValue.serverTimestamp", new e28(t6);
  }, e28.delete = function() {
    var t6 = new oa("deleteField");
    return t6._methodName = "FieldValue.delete", new e28(t6);
  }, e28.arrayUnion = function() {
    for (var t6 = [], n3 = 0; n3 < arguments.length; n3++)
      t6[n3] = arguments[n3];
    var r3 = function() {
      for (var t10 = [], e29 = 0; e29 < arguments.length; e29++)
        t10[e29] = arguments[e29];
      return new aa("arrayUnion", t10);
    }.apply(void 0, t6);
    return r3._methodName = "FieldValue.arrayUnion", new e28(r3);
  }, e28.arrayRemove = function() {
    for (var t6 = [], n3 = 0; n3 < arguments.length; n3++)
      t6[n3] = arguments[n3];
    var r3 = function() {
      for (var t10 = [], e29 = 0; e29 < arguments.length; e29++)
        t10[e29] = arguments[e29];
      return new ca("arrayRemove", t10);
    }.apply(void 0, t6);
    return r3._methodName = "FieldValue.arrayRemove", new e28(r3);
  }, e28.increment = function(t6) {
    var n3 = function(t10) {
      return new fa("increment", t10);
    }(t6);
    return n3._methodName = "FieldValue.increment", new e28(n3);
  }, e28.prototype.isEqual = function(t6) {
    return this._.isEqual(t6._);
  }, e28;
}(q), zc = function() {
  function t3() {
    this.Pd = {}, this.yd = new vr(), this.gd = {
      taskState: "Running",
      totalBytes: 0,
      totalDocuments: 0,
      bytesLoaded: 0,
      documentsLoaded: 0
    };
  }
  return t3.prototype.onProgress = function(t6, e28, n3) {
    this.Pd = {
      next: t6,
      error: e28,
      complete: n3
    };
  }, t3.prototype.catch = function(t6) {
    return this.yd.promise.catch(t6);
  }, t3.prototype.then = function(t6, e28) {
    return this.yd.promise.then(t6, e28);
  }, t3.prototype.Ul = function(t6) {
    this.Ql(t6), this.Pd.complete && this.Pd.complete(), this.yd.resolve(t6);
  }, t3.prototype.Wl = function(t6) {
    this.gd.taskState = "Error", this.Pd.next && this.Pd.next(this.gd), this.Pd.error && this.Pd.error(t6), this.yd.reject(t6);
  }, t3.prototype.Ql = function(t6) {
    this.gd = t6, this.Pd.next && this.Pd.next(t6);
  }, t3;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Gc(t3, e28) {
  var n3 = new zc();
  return function(t6, e29, n6, r3) {
    var i = this, o3 = function(t10, e30) {
      return function(t11, e31) {
        return new Ds(t11, e31);
      }(function(t11, e31) {
        if (t11 instanceof Uint8Array)
          return Ss(t11, e31);
        if (t11 instanceof ArrayBuffer)
          return Ss(new Uint8Array(t11), e31);
        if (t11 instanceof ReadableStream)
          return t11.getReader();
        throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
      }(typeof t10 == "string" ? new TextEncoder().encode(t10) : t10), e30);
    }(n6, Wo(e29));
    t6.fs.ys(function() {
      return __awaiter(i, void 0, void 0, function() {
        var e30;
        return __generator(this, function(n10) {
          switch (n10.label) {
            case 0:
              return e30 = _s, [4, Ca(t6)];
            case 1:
              return e30.apply(void 0, [n10.sent(), o3, r3]), [2];
          }
        });
      });
    });
  }(Fa(t3._), t3.I_, e28, n3), n3;
}
function Bc(t3, e28) {
  return function(t6, e29) {
    var n3 = this;
    return t6.fs.enqueue(function() {
      return __awaiter(n3, void 0, void 0, function() {
        var n6;
        return __generator(this, function(r3) {
          switch (r3.label) {
            case 0:
              return n6 = function(t10, e30) {
                var n10 = D(t10);
                return n10.persistence.runTransaction("Get named query", "readonly", function(t11) {
                  return n10.To.Bs(t11, e30);
                });
              }, [4, Oa(t6)];
            case 1:
              return [2, n6.apply(void 0, [r3.sent(), e29])];
          }
        });
      });
    });
  }(Fa(t3._), e28).then(function(e29) {
    return e29 ? new Rc(t3, new Bs(t3._, null, e29.query)) : null;
  });
}
var P = {
  Firestore: Tc,
  GeoPoint: Ys,
  Timestamp: X,
  Blob: z,
  Transaction: Sc,
  WriteBatch: xc,
  DocumentReference: Dc,
  DocumentSnapshot: Cc,
  Query: Rc,
  QueryDocumentSnapshot: Lc,
  QuerySnapshot: Mc,
  CollectionReference: Uc,
  FieldPath: Fc,
  FieldValue: jc,
  setLogLevel: Ac,
  CACHE_SIZE_UNLIMITED: Ua
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function d(e28) {
  !function(e29, r3) {
    e29.INTERNAL.registerComponent(new Component("firestore", function(e30) {
      var t3 = e30.getProvider("app").getImmediate();
      return r3(t3, e30.getProvider("auth-internal"));
    }, "PUBLIC").setServiceProps(Object.assign({}, P)));
  }(e28, function(e29, i) {
    return new Tc(e29, new qa(e29, i), new Ec());
  }), e28.registerVersion("@firebase/firestore", "2.1.1");
}
d(firebase$1);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function i$1(e28) {
  e28.prototype.loadBundle = function(t3) {
    return Gc(this, t3);
  }, e28.prototype.namedQuery = function(r3) {
    return Bc(this, r3);
  };
}
i$1(Tc);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var errorCodeMap = {
  OK: "ok",
  CANCELLED: "cancelled",
  UNKNOWN: "unknown",
  INVALID_ARGUMENT: "invalid-argument",
  DEADLINE_EXCEEDED: "deadline-exceeded",
  NOT_FOUND: "not-found",
  ALREADY_EXISTS: "already-exists",
  PERMISSION_DENIED: "permission-denied",
  UNAUTHENTICATED: "unauthenticated",
  RESOURCE_EXHAUSTED: "resource-exhausted",
  FAILED_PRECONDITION: "failed-precondition",
  ABORTED: "aborted",
  OUT_OF_RANGE: "out-of-range",
  UNIMPLEMENTED: "unimplemented",
  INTERNAL: "internal",
  UNAVAILABLE: "unavailable",
  DATA_LOSS: "data-loss"
};
var HttpsErrorImpl = function(_super) {
  __extends$1(HttpsErrorImpl2, _super);
  function HttpsErrorImpl2(code, message, details) {
    var _this = _super.call(this, message) || this;
    Object.setPrototypeOf(_this, HttpsErrorImpl2.prototype);
    _this.code = code;
    _this.details = details;
    return _this;
  }
  return HttpsErrorImpl2;
}(Error);
function codeForHTTPStatus(status) {
  if (status >= 200 && status < 300) {
    return "ok";
  }
  switch (status) {
    case 0:
      return "internal";
    case 400:
      return "invalid-argument";
    case 401:
      return "unauthenticated";
    case 403:
      return "permission-denied";
    case 404:
      return "not-found";
    case 409:
      return "aborted";
    case 429:
      return "resource-exhausted";
    case 499:
      return "cancelled";
    case 500:
      return "internal";
    case 501:
      return "unimplemented";
    case 503:
      return "unavailable";
    case 504:
      return "deadline-exceeded";
  }
  return "unknown";
}
function _errorForResponse(status, bodyJSON, serializer2) {
  var code = codeForHTTPStatus(status);
  var description = code;
  var details = void 0;
  try {
    var errorJSON = bodyJSON && bodyJSON.error;
    if (errorJSON) {
      var status_1 = errorJSON.status;
      if (typeof status_1 === "string") {
        if (!errorCodeMap[status_1]) {
          return new HttpsErrorImpl("internal", "internal");
        }
        code = errorCodeMap[status_1];
        description = status_1;
      }
      var message = errorJSON.message;
      if (typeof message === "string") {
        description = message;
      }
      details = errorJSON.details;
      if (details !== void 0) {
        details = serializer2.decode(details);
      }
    }
  } catch (e28) {
  }
  if (code === "ok") {
    return null;
  }
  return new HttpsErrorImpl(code, description, details);
}
var ContextProvider = function() {
  function ContextProvider2(authProvider, messagingProvider) {
    var _this = this;
    this.auth = null;
    this.messaging = null;
    this.auth = authProvider.getImmediate({ optional: true });
    this.messaging = messagingProvider.getImmediate({
      optional: true
    });
    if (!this.auth) {
      authProvider.get().then(function(auth) {
        return _this.auth = auth;
      }, function() {
      });
    }
    if (!this.messaging) {
      messagingProvider.get().then(function(messaging) {
        return _this.messaging = messaging;
      }, function() {
      });
    }
  }
  ContextProvider2.prototype.getAuthToken = function() {
    return __awaiter(this, void 0, void 0, function() {
      var token2;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (!this.auth) {
              return [2, void 0];
            }
            _a2.label = 1;
          case 1:
            _a2.trys.push([1, 3, , 4]);
            return [4, this.auth.getToken()];
          case 2:
            token2 = _a2.sent();
            if (!token2) {
              return [2, void 0];
            }
            return [2, token2.accessToken];
          case 3:
            _a2.sent();
            return [2, void 0];
          case 4:
            return [2];
        }
      });
    });
  };
  ContextProvider2.prototype.getInstanceIdToken = function() {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(_a2) {
        if (!this.messaging || !("Notification" in self) || Notification.permission !== "granted") {
          return [2, void 0];
        }
        try {
          return [2, this.messaging.getToken()];
        } catch (e28) {
          return [2, void 0];
        }
        return [2];
      });
    });
  };
  ContextProvider2.prototype.getContext = function() {
    return __awaiter(this, void 0, void 0, function() {
      var authToken, instanceIdToken;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            return [4, this.getAuthToken()];
          case 1:
            authToken = _a2.sent();
            return [4, this.getInstanceIdToken()];
          case 2:
            instanceIdToken = _a2.sent();
            return [2, { authToken, instanceIdToken }];
        }
      });
    });
  };
  return ContextProvider2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LONG_TYPE = "type.googleapis.com/google.protobuf.Int64Value";
var UNSIGNED_LONG_TYPE = "type.googleapis.com/google.protobuf.UInt64Value";
function mapValues(o3, f3) {
  var result2 = {};
  for (var key in o3) {
    if (o3.hasOwnProperty(key)) {
      result2[key] = f3(o3[key]);
    }
  }
  return result2;
}
var Serializer = function() {
  function Serializer2() {
  }
  Serializer2.prototype.encode = function(data) {
    var _this = this;
    if (data == null) {
      return null;
    }
    if (data instanceof Number) {
      data = data.valueOf();
    }
    if (typeof data === "number" && isFinite(data)) {
      return data;
    }
    if (data === true || data === false) {
      return data;
    }
    if (Object.prototype.toString.call(data) === "[object String]") {
      return data;
    }
    if (Array.isArray(data)) {
      return data.map(function(x3) {
        return _this.encode(x3);
      });
    }
    if (typeof data === "function" || typeof data === "object") {
      return mapValues(data, function(x3) {
        return _this.encode(x3);
      });
    }
    throw new Error("Data cannot be encoded in JSON: " + data);
  };
  Serializer2.prototype.decode = function(json) {
    var _this = this;
    if (json == null) {
      return json;
    }
    if (json["@type"]) {
      switch (json["@type"]) {
        case LONG_TYPE:
        case UNSIGNED_LONG_TYPE: {
          var value = Number(json["value"]);
          if (isNaN(value)) {
            throw new Error("Data cannot be decoded from JSON: " + json);
          }
          return value;
        }
        default: {
          throw new Error("Data cannot be decoded from JSON: " + json);
        }
      }
    }
    if (Array.isArray(json)) {
      return json.map(function(x3) {
        return _this.decode(x3);
      });
    }
    if (typeof json === "function" || typeof json === "object") {
      return mapValues(json, function(x3) {
        return _this.decode(x3);
      });
    }
    return json;
  };
  return Serializer2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function failAfter(millis) {
  var timer;
  var promise = new Promise(function(_3, reject) {
    timer = setTimeout(function() {
      reject(new HttpsErrorImpl("deadline-exceeded", "deadline-exceeded"));
    }, millis);
  });
  return {
    timer,
    promise
  };
}
var Service = function() {
  function Service2(app_, authProvider, messagingProvider, regionOrCustomDomain_, fetchImpl) {
    var _this = this;
    if (regionOrCustomDomain_ === void 0) {
      regionOrCustomDomain_ = "us-central1";
    }
    this.app_ = app_;
    this.fetchImpl = fetchImpl;
    this.serializer = new Serializer();
    this.emulatorOrigin = null;
    this.INTERNAL = {
      delete: function() {
        return Promise.resolve(_this.deleteService());
      }
    };
    this.contextProvider = new ContextProvider(authProvider, messagingProvider);
    this.cancelAllRequests = new Promise(function(resolve) {
      _this.deleteService = function() {
        return resolve();
      };
    });
    try {
      var url = new URL(regionOrCustomDomain_);
      this.customDomain = url.origin;
      this.region = "us-central1";
    } catch (e28) {
      this.customDomain = null;
      this.region = regionOrCustomDomain_;
    }
  }
  Object.defineProperty(Service2.prototype, "app", {
    get: function() {
      return this.app_;
    },
    enumerable: false,
    configurable: true
  });
  Service2.prototype._url = function(name2) {
    var projectId = this.app_.options.projectId;
    if (this.emulatorOrigin !== null) {
      var origin_1 = this.emulatorOrigin;
      return origin_1 + "/" + projectId + "/" + this.region + "/" + name2;
    }
    if (this.customDomain !== null) {
      return this.customDomain + "/" + name2;
    }
    return "https://" + this.region + "-" + projectId + ".cloudfunctions.net/" + name2;
  };
  Service2.prototype.useEmulator = function(host, port) {
    this.emulatorOrigin = "http://" + host + ":" + port;
  };
  Service2.prototype.useFunctionsEmulator = function(origin2) {
    this.emulatorOrigin = origin2;
  };
  Service2.prototype.httpsCallable = function(name2, options) {
    var _this = this;
    return function(data) {
      return _this.call(name2, data, options || {});
    };
  };
  Service2.prototype.postJSON = function(url, body, headers) {
    return __awaiter(this, void 0, void 0, function() {
      var response, json;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            headers["Content-Type"] = "application/json";
            _a2.label = 1;
          case 1:
            _a2.trys.push([1, 3, , 4]);
            return [4, this.fetchImpl(url, {
              method: "POST",
              body: JSON.stringify(body),
              headers
            })];
          case 2:
            response = _a2.sent();
            return [3, 4];
          case 3:
            _a2.sent();
            return [2, {
              status: 0,
              json: null
            }];
          case 4:
            json = null;
            _a2.label = 5;
          case 5:
            _a2.trys.push([5, 7, , 8]);
            return [4, response.json()];
          case 6:
            json = _a2.sent();
            return [3, 8];
          case 7:
            _a2.sent();
            return [3, 8];
          case 8:
            return [2, {
              status: response.status,
              json
            }];
        }
      });
    });
  };
  Service2.prototype.call = function(name2, data, options) {
    return __awaiter(this, void 0, void 0, function() {
      var url, body, headers, context, timeout, _a2, timer, failAfterPromise, response, error2, responseData, decodedData;
      return __generator(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            url = this._url(name2);
            data = this.serializer.encode(data);
            body = { data };
            headers = {};
            return [4, this.contextProvider.getContext()];
          case 1:
            context = _b2.sent();
            if (context.authToken) {
              headers["Authorization"] = "Bearer " + context.authToken;
            }
            if (context.instanceIdToken) {
              headers["Firebase-Instance-ID-Token"] = context.instanceIdToken;
            }
            timeout = options.timeout || 7e4;
            _a2 = failAfter(timeout), timer = _a2.timer, failAfterPromise = _a2.promise;
            return [4, Promise.race([
              clearTimeoutWrapper(timer, this.postJSON(url, body, headers)),
              failAfterPromise,
              clearTimeoutWrapper(timer, this.cancelAllRequests)
            ])];
          case 2:
            response = _b2.sent();
            if (!response) {
              throw new HttpsErrorImpl("cancelled", "Firebase Functions instance was deleted.");
            }
            error2 = _errorForResponse(response.status, response.json, this.serializer);
            if (error2) {
              throw error2;
            }
            if (!response.json) {
              throw new HttpsErrorImpl("internal", "Response is not valid JSON object.");
            }
            responseData = response.json.data;
            if (typeof responseData === "undefined") {
              responseData = response.json.result;
            }
            if (typeof responseData === "undefined") {
              throw new HttpsErrorImpl("internal", "Response is missing data field.");
            }
            decodedData = this.serializer.decode(responseData);
            return [2, { data: decodedData }];
        }
      });
    });
  };
  return Service2;
}();
function clearTimeoutWrapper(timer, promise) {
  return __awaiter(this, void 0, void 0, function() {
    var result2;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, promise];
        case 1:
          result2 = _a2.sent();
          clearTimeout(timer);
          return [2, result2];
      }
    });
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FUNCTIONS_TYPE = "functions";
function registerFunctions(instance, fetchImpl) {
  var namespaceExports = {
    Functions: Service
  };
  function factory2(container, regionOrCustomDomain) {
    var app = container.getProvider("app").getImmediate();
    var authProvider = container.getProvider("auth-internal");
    var messagingProvider = container.getProvider("messaging");
    return new Service(app, authProvider, messagingProvider, regionOrCustomDomain, fetchImpl);
  }
  instance.INTERNAL.registerComponent(new Component(FUNCTIONS_TYPE, factory2, "PUBLIC").setServiceProps(namespaceExports).setMultipleInstances(true));
}
var name$7 = "@firebase/functions";
var version$7 = "0.6.1";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
registerFunctions(firebase$1, fetch.bind(self));
firebase$1.registerVersion(name$7, version$7);
function toArray$2(arr) {
  return Array.prototype.slice.call(arr);
}
function promisifyRequest(request) {
  return new Promise(function(resolve, reject) {
    request.onsuccess = function() {
      resolve(request.result);
    };
    request.onerror = function() {
      reject(request.error);
    };
  });
}
function promisifyRequestCall(obj, method, args) {
  var request;
  var p3 = new Promise(function(resolve, reject) {
    request = obj[method].apply(obj, args);
    promisifyRequest(request).then(resolve, reject);
  });
  p3.request = request;
  return p3;
}
function promisifyCursorRequestCall(obj, method, args) {
  var p3 = promisifyRequestCall(obj, method, args);
  return p3.then(function(value) {
    if (!value)
      return;
    return new Cursor(value, p3.request);
  });
}
function proxyProperties(ProxyClass, targetProp, properties) {
  properties.forEach(function(prop) {
    Object.defineProperty(ProxyClass.prototype, prop, {
      get: function() {
        return this[targetProp][prop];
      },
      set: function(val) {
        this[targetProp][prop] = val;
      }
    });
  });
}
function proxyRequestMethods(ProxyClass, targetProp, Constructor, properties) {
  properties.forEach(function(prop) {
    if (!(prop in Constructor.prototype))
      return;
    ProxyClass.prototype[prop] = function() {
      return promisifyRequestCall(this[targetProp], prop, arguments);
    };
  });
}
function proxyMethods(ProxyClass, targetProp, Constructor, properties) {
  properties.forEach(function(prop) {
    if (!(prop in Constructor.prototype))
      return;
    ProxyClass.prototype[prop] = function() {
      return this[targetProp][prop].apply(this[targetProp], arguments);
    };
  });
}
function proxyCursorRequestMethods(ProxyClass, targetProp, Constructor, properties) {
  properties.forEach(function(prop) {
    if (!(prop in Constructor.prototype))
      return;
    ProxyClass.prototype[prop] = function() {
      return promisifyCursorRequestCall(this[targetProp], prop, arguments);
    };
  });
}
function Index(index) {
  this._index = index;
}
proxyProperties(Index, "_index", [
  "name",
  "keyPath",
  "multiEntry",
  "unique"
]);
proxyRequestMethods(Index, "_index", IDBIndex, [
  "get",
  "getKey",
  "getAll",
  "getAllKeys",
  "count"
]);
proxyCursorRequestMethods(Index, "_index", IDBIndex, [
  "openCursor",
  "openKeyCursor"
]);
function Cursor(cursor, request) {
  this._cursor = cursor;
  this._request = request;
}
proxyProperties(Cursor, "_cursor", [
  "direction",
  "key",
  "primaryKey",
  "value"
]);
proxyRequestMethods(Cursor, "_cursor", IDBCursor, [
  "update",
  "delete"
]);
["advance", "continue", "continuePrimaryKey"].forEach(function(methodName) {
  if (!(methodName in IDBCursor.prototype))
    return;
  Cursor.prototype[methodName] = function() {
    var cursor = this;
    var args = arguments;
    return Promise.resolve().then(function() {
      cursor._cursor[methodName].apply(cursor._cursor, args);
      return promisifyRequest(cursor._request).then(function(value) {
        if (!value)
          return;
        return new Cursor(value, cursor._request);
      });
    });
  };
});
function ObjectStore(store) {
  this._store = store;
}
ObjectStore.prototype.createIndex = function() {
  return new Index(this._store.createIndex.apply(this._store, arguments));
};
ObjectStore.prototype.index = function() {
  return new Index(this._store.index.apply(this._store, arguments));
};
proxyProperties(ObjectStore, "_store", [
  "name",
  "keyPath",
  "indexNames",
  "autoIncrement"
]);
proxyRequestMethods(ObjectStore, "_store", IDBObjectStore, [
  "put",
  "add",
  "delete",
  "clear",
  "get",
  "getAll",
  "getKey",
  "getAllKeys",
  "count"
]);
proxyCursorRequestMethods(ObjectStore, "_store", IDBObjectStore, [
  "openCursor",
  "openKeyCursor"
]);
proxyMethods(ObjectStore, "_store", IDBObjectStore, [
  "deleteIndex"
]);
function Transaction(idbTransaction) {
  this._tx = idbTransaction;
  this.complete = new Promise(function(resolve, reject) {
    idbTransaction.oncomplete = function() {
      resolve();
    };
    idbTransaction.onerror = function() {
      reject(idbTransaction.error);
    };
    idbTransaction.onabort = function() {
      reject(idbTransaction.error);
    };
  });
}
Transaction.prototype.objectStore = function() {
  return new ObjectStore(this._tx.objectStore.apply(this._tx, arguments));
};
proxyProperties(Transaction, "_tx", [
  "objectStoreNames",
  "mode"
]);
proxyMethods(Transaction, "_tx", IDBTransaction, [
  "abort"
]);
function UpgradeDB(db2, oldVersion, transaction) {
  this._db = db2;
  this.oldVersion = oldVersion;
  this.transaction = new Transaction(transaction);
}
UpgradeDB.prototype.createObjectStore = function() {
  return new ObjectStore(this._db.createObjectStore.apply(this._db, arguments));
};
proxyProperties(UpgradeDB, "_db", [
  "name",
  "version",
  "objectStoreNames"
]);
proxyMethods(UpgradeDB, "_db", IDBDatabase, [
  "deleteObjectStore",
  "close"
]);
function DB(db2) {
  this._db = db2;
}
DB.prototype.transaction = function() {
  return new Transaction(this._db.transaction.apply(this._db, arguments));
};
proxyProperties(DB, "_db", [
  "name",
  "version",
  "objectStoreNames"
]);
proxyMethods(DB, "_db", IDBDatabase, [
  "close"
]);
["openCursor", "openKeyCursor"].forEach(function(funcName) {
  [ObjectStore, Index].forEach(function(Constructor) {
    if (!(funcName in Constructor.prototype))
      return;
    Constructor.prototype[funcName.replace("open", "iterate")] = function() {
      var args = toArray$2(arguments);
      var callback = args[args.length - 1];
      var nativeObject = this._store || this._index;
      var request = nativeObject[funcName].apply(nativeObject, args.slice(0, -1));
      request.onsuccess = function() {
        callback(request.result);
      };
    };
  });
});
[Index, ObjectStore].forEach(function(Constructor) {
  if (Constructor.prototype.getAll)
    return;
  Constructor.prototype.getAll = function(query2, count) {
    var instance = this;
    var items = [];
    return new Promise(function(resolve) {
      instance.iterateCursor(query2, function(cursor) {
        if (!cursor) {
          resolve(items);
          return;
        }
        items.push(cursor.value);
        if (count !== void 0 && items.length == count) {
          resolve(items);
          return;
        }
        cursor.continue();
      });
    });
  };
});
function openDb(name2, version2, upgradeCallback) {
  var p3 = promisifyRequestCall(indexedDB, "open", [name2, version2]);
  var request = p3.request;
  if (request) {
    request.onupgradeneeded = function(event2) {
      if (upgradeCallback) {
        upgradeCallback(new UpgradeDB(request.result, event2.oldVersion, request.transaction));
      }
    };
  }
  return p3.then(function(db2) {
    return new DB(db2);
  });
}
function deleteDb(name2) {
  return promisifyRequestCall(indexedDB, "deleteDatabase", [name2]);
}
var name$6 = "@firebase/installations";
var version$6 = "0.4.19";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PENDING_TIMEOUT_MS = 1e4;
var PACKAGE_VERSION = "w:" + version$6;
var INTERNAL_AUTH_VERSION = "FIS_v2";
var INSTALLATIONS_API_URL = "https://firebaseinstallations.googleapis.com/v1";
var TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1e3;
var SERVICE$1 = "installations";
var SERVICE_NAME$1 = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a$4;
var ERROR_DESCRIPTION_MAP$2 = (_a$4 = {}, _a$4["missing-app-config-values"] = 'Missing App configuration value: "{$valueName}"', _a$4["not-registered"] = "Firebase Installation is not registered.", _a$4["installation-not-found"] = "Firebase Installation not found.", _a$4["request-failed"] = '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"', _a$4["app-offline"] = "Could not process request. Application offline.", _a$4["delete-pending-registration"] = "Can't delete installation while there is a pending registration request.", _a$4);
var ERROR_FACTORY$4 = new ErrorFactory(SERVICE$1, SERVICE_NAME$1, ERROR_DESCRIPTION_MAP$2);
function isServerError(error2) {
  return error2 instanceof FirebaseError && error2.code.includes("request-failed");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getInstallationsEndpoint(_a2) {
  var projectId = _a2.projectId;
  return INSTALLATIONS_API_URL + "/projects/" + projectId + "/installations";
}
function extractAuthTokenInfoFromResponse(response) {
  return {
    token: response.token,
    requestStatus: 2,
    expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
    creationTime: Date.now()
  };
}
function getErrorFromResponse(requestName, response) {
  return __awaiter(this, void 0, void 0, function() {
    var responseJson, errorData;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, response.json()];
        case 1:
          responseJson = _a2.sent();
          errorData = responseJson.error;
          return [2, ERROR_FACTORY$4.create("request-failed", {
            requestName,
            serverCode: errorData.code,
            serverMessage: errorData.message,
            serverStatus: errorData.status
          })];
      }
    });
  });
}
function getHeaders$2(_a2) {
  var apiKey = _a2.apiKey;
  return new Headers({
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-goog-api-key": apiKey
  });
}
function getHeadersWithAuth(appConfig, _a2) {
  var refreshToken = _a2.refreshToken;
  var headers = getHeaders$2(appConfig);
  headers.append("Authorization", getAuthorizationHeader(refreshToken));
  return headers;
}
function retryIfServerError(fn2) {
  return __awaiter(this, void 0, void 0, function() {
    var result2;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, fn2()];
        case 1:
          result2 = _a2.sent();
          if (result2.status >= 500 && result2.status < 600) {
            return [2, fn2()];
          }
          return [2, result2];
      }
    });
  });
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
  return Number(responseExpiresIn.replace("s", "000"));
}
function getAuthorizationHeader(refreshToken) {
  return INTERNAL_AUTH_VERSION + " " + refreshToken;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createInstallationRequest(appConfig, _a2) {
  var fid = _a2.fid;
  return __awaiter(this, void 0, void 0, function() {
    var endpoint, headers, body, request, response, responseValue, registeredInstallationEntry;
    return __generator(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          endpoint = getInstallationsEndpoint(appConfig);
          headers = getHeaders$2(appConfig);
          body = {
            fid,
            authVersion: INTERNAL_AUTH_VERSION,
            appId: appConfig.appId,
            sdkVersion: PACKAGE_VERSION
          };
          request = {
            method: "POST",
            headers,
            body: JSON.stringify(body)
          };
          return [4, retryIfServerError(function() {
            return fetch(endpoint, request);
          })];
        case 1:
          response = _b2.sent();
          if (!response.ok)
            return [3, 3];
          return [4, response.json()];
        case 2:
          responseValue = _b2.sent();
          registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2,
            refreshToken: responseValue.refreshToken,
            authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
          };
          return [2, registeredInstallationEntry];
        case 3:
          return [4, getErrorFromResponse("Create Installation", response)];
        case 4:
          throw _b2.sent();
      }
    });
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function sleep$1(ms2) {
  return new Promise(function(resolve) {
    setTimeout(resolve, ms2);
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferToBase64UrlSafe(array2) {
  var b64 = btoa(String.fromCharCode.apply(String, __spread(array2)));
  return b64.replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
var INVALID_FID = "";
function generateFid() {
  try {
    var fidByteArray = new Uint8Array(17);
    var crypto_1 = self.crypto || self.msCrypto;
    crypto_1.getRandomValues(fidByteArray);
    fidByteArray[0] = 112 + fidByteArray[0] % 16;
    var fid = encode(fidByteArray);
    return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
  } catch (_a2) {
    return INVALID_FID;
  }
}
function encode(fidByteArray) {
  var b64String = bufferToBase64UrlSafe(fidByteArray);
  return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getKey$1(appConfig) {
  return appConfig.appName + "!" + appConfig.appId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var fidChangeCallbacks = new Map();
function fidChanged(appConfig, fid) {
  var key = getKey$1(appConfig);
  callFidChangeCallbacks(key, fid);
  broadcastFidChange(key, fid);
}
function addCallback(appConfig, callback) {
  getBroadcastChannel();
  var key = getKey$1(appConfig);
  var callbackSet = fidChangeCallbacks.get(key);
  if (!callbackSet) {
    callbackSet = new Set();
    fidChangeCallbacks.set(key, callbackSet);
  }
  callbackSet.add(callback);
}
function removeCallback(appConfig, callback) {
  var key = getKey$1(appConfig);
  var callbackSet = fidChangeCallbacks.get(key);
  if (!callbackSet) {
    return;
  }
  callbackSet.delete(callback);
  if (callbackSet.size === 0) {
    fidChangeCallbacks.delete(key);
  }
  closeBroadcastChannel();
}
function callFidChangeCallbacks(key, fid) {
  var e_1, _a2;
  var callbacks = fidChangeCallbacks.get(key);
  if (!callbacks) {
    return;
  }
  try {
    for (var callbacks_1 = __values$1(callbacks), callbacks_1_1 = callbacks_1.next(); !callbacks_1_1.done; callbacks_1_1 = callbacks_1.next()) {
      var callback = callbacks_1_1.value;
      callback(fid);
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (callbacks_1_1 && !callbacks_1_1.done && (_a2 = callbacks_1.return))
        _a2.call(callbacks_1);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
}
function broadcastFidChange(key, fid) {
  var channel = getBroadcastChannel();
  if (channel) {
    channel.postMessage({ key, fid });
  }
  closeBroadcastChannel();
}
var broadcastChannel = null;
function getBroadcastChannel() {
  if (!broadcastChannel && "BroadcastChannel" in self) {
    broadcastChannel = new BroadcastChannel("[Firebase] FID Change");
    broadcastChannel.onmessage = function(e28) {
      callFidChangeCallbacks(e28.data.key, e28.data.fid);
    };
  }
  return broadcastChannel;
}
function closeBroadcastChannel() {
  if (fidChangeCallbacks.size === 0 && broadcastChannel) {
    broadcastChannel.close();
    broadcastChannel = null;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DATABASE_NAME$1 = "firebase-installations-database";
var DATABASE_VERSION$1 = 1;
var OBJECT_STORE_NAME$1 = "firebase-installations-store";
var dbPromise$1 = null;
function getDbPromise$1() {
  if (!dbPromise$1) {
    dbPromise$1 = openDb(DATABASE_NAME$1, DATABASE_VERSION$1, function(upgradeDB) {
      switch (upgradeDB.oldVersion) {
        case 0:
          upgradeDB.createObjectStore(OBJECT_STORE_NAME$1);
      }
    });
  }
  return dbPromise$1;
}
function set$2(appConfig, value) {
  return __awaiter(this, void 0, void 0, function() {
    var key, db2, tx2, objectStore, oldValue;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          key = getKey$1(appConfig);
          return [4, getDbPromise$1()];
        case 1:
          db2 = _a2.sent();
          tx2 = db2.transaction(OBJECT_STORE_NAME$1, "readwrite");
          objectStore = tx2.objectStore(OBJECT_STORE_NAME$1);
          return [4, objectStore.get(key)];
        case 2:
          oldValue = _a2.sent();
          return [4, objectStore.put(value, key)];
        case 3:
          _a2.sent();
          return [4, tx2.complete];
        case 4:
          _a2.sent();
          if (!oldValue || oldValue.fid !== value.fid) {
            fidChanged(appConfig, value.fid);
          }
          return [2, value];
      }
    });
  });
}
function remove(appConfig) {
  return __awaiter(this, void 0, void 0, function() {
    var key, db2, tx2;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          key = getKey$1(appConfig);
          return [4, getDbPromise$1()];
        case 1:
          db2 = _a2.sent();
          tx2 = db2.transaction(OBJECT_STORE_NAME$1, "readwrite");
          return [4, tx2.objectStore(OBJECT_STORE_NAME$1).delete(key)];
        case 2:
          _a2.sent();
          return [4, tx2.complete];
        case 3:
          _a2.sent();
          return [2];
      }
    });
  });
}
function update(appConfig, updateFn) {
  return __awaiter(this, void 0, void 0, function() {
    var key, db2, tx2, store, oldValue, newValue;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          key = getKey$1(appConfig);
          return [4, getDbPromise$1()];
        case 1:
          db2 = _a2.sent();
          tx2 = db2.transaction(OBJECT_STORE_NAME$1, "readwrite");
          store = tx2.objectStore(OBJECT_STORE_NAME$1);
          return [4, store.get(key)];
        case 2:
          oldValue = _a2.sent();
          newValue = updateFn(oldValue);
          if (!(newValue === void 0))
            return [3, 4];
          return [4, store.delete(key)];
        case 3:
          _a2.sent();
          return [3, 6];
        case 4:
          return [4, store.put(newValue, key)];
        case 5:
          _a2.sent();
          _a2.label = 6;
        case 6:
          return [4, tx2.complete];
        case 7:
          _a2.sent();
          if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) {
            fidChanged(appConfig, newValue.fid);
          }
          return [2, newValue];
      }
    });
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getInstallationEntry(appConfig) {
  return __awaiter(this, void 0, void 0, function() {
    var registrationPromise, installationEntry;
    var _a2;
    return __generator(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          return [4, update(appConfig, function(oldEntry) {
            var installationEntry2 = updateOrCreateInstallationEntry(oldEntry);
            var entryWithPromise = triggerRegistrationIfNecessary(appConfig, installationEntry2);
            registrationPromise = entryWithPromise.registrationPromise;
            return entryWithPromise.installationEntry;
          })];
        case 1:
          installationEntry = _b2.sent();
          if (!(installationEntry.fid === INVALID_FID))
            return [3, 3];
          _a2 = {};
          return [4, registrationPromise];
        case 2:
          return [2, (_a2.installationEntry = _b2.sent(), _a2)];
        case 3:
          return [2, {
            installationEntry,
            registrationPromise
          }];
      }
    });
  });
}
function updateOrCreateInstallationEntry(oldEntry) {
  var entry = oldEntry || {
    fid: generateFid(),
    registrationStatus: 0
  };
  return clearTimedOutRequest(entry);
}
function triggerRegistrationIfNecessary(appConfig, installationEntry) {
  if (installationEntry.registrationStatus === 0) {
    if (!navigator.onLine) {
      var registrationPromiseWithError = Promise.reject(ERROR_FACTORY$4.create("app-offline"));
      return {
        installationEntry,
        registrationPromise: registrationPromiseWithError
      };
    }
    var inProgressEntry = {
      fid: installationEntry.fid,
      registrationStatus: 1,
      registrationTime: Date.now()
    };
    var registrationPromise = registerInstallation(appConfig, inProgressEntry);
    return { installationEntry: inProgressEntry, registrationPromise };
  } else if (installationEntry.registrationStatus === 1) {
    return {
      installationEntry,
      registrationPromise: waitUntilFidRegistration(appConfig)
    };
  } else {
    return { installationEntry };
  }
}
function registerInstallation(appConfig, installationEntry) {
  return __awaiter(this, void 0, void 0, function() {
    var registeredInstallationEntry, e_1;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          _a2.trys.push([0, 2, , 7]);
          return [4, createInstallationRequest(appConfig, installationEntry)];
        case 1:
          registeredInstallationEntry = _a2.sent();
          return [2, set$2(appConfig, registeredInstallationEntry)];
        case 2:
          e_1 = _a2.sent();
          if (!(isServerError(e_1) && e_1.customData.serverCode === 409))
            return [3, 4];
          return [4, remove(appConfig)];
        case 3:
          _a2.sent();
          return [3, 6];
        case 4:
          return [4, set$2(appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0
          })];
        case 5:
          _a2.sent();
          _a2.label = 6;
        case 6:
          throw e_1;
        case 7:
          return [2];
      }
    });
  });
}
function waitUntilFidRegistration(appConfig) {
  return __awaiter(this, void 0, void 0, function() {
    var entry, _a2, installationEntry, registrationPromise;
    return __generator(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          return [4, updateInstallationRequest(appConfig)];
        case 1:
          entry = _b2.sent();
          _b2.label = 2;
        case 2:
          if (!(entry.registrationStatus === 1))
            return [3, 5];
          return [4, sleep$1(100)];
        case 3:
          _b2.sent();
          return [4, updateInstallationRequest(appConfig)];
        case 4:
          entry = _b2.sent();
          return [3, 2];
        case 5:
          if (!(entry.registrationStatus === 0))
            return [3, 7];
          return [4, getInstallationEntry(appConfig)];
        case 6:
          _a2 = _b2.sent(), installationEntry = _a2.installationEntry, registrationPromise = _a2.registrationPromise;
          if (registrationPromise) {
            return [2, registrationPromise];
          } else {
            return [2, installationEntry];
          }
        case 7:
          return [2, entry];
      }
    });
  });
}
function updateInstallationRequest(appConfig) {
  return update(appConfig, function(oldEntry) {
    if (!oldEntry) {
      throw ERROR_FACTORY$4.create("installation-not-found");
    }
    return clearTimedOutRequest(oldEntry);
  });
}
function clearTimedOutRequest(entry) {
  if (hasInstallationRequestTimedOut(entry)) {
    return {
      fid: entry.fid,
      registrationStatus: 0
    };
  }
  return entry;
}
function hasInstallationRequestTimedOut(installationEntry) {
  return installationEntry.registrationStatus === 1 && installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function generateAuthTokenRequest(_a2, installationEntry) {
  var appConfig = _a2.appConfig, platformLoggerProvider = _a2.platformLoggerProvider;
  return __awaiter(this, void 0, void 0, function() {
    var endpoint, headers, platformLogger, body, request, response, responseValue, completedAuthToken;
    return __generator(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
          headers = getHeadersWithAuth(appConfig, installationEntry);
          platformLogger = platformLoggerProvider.getImmediate({
            optional: true
          });
          if (platformLogger) {
            headers.append("x-firebase-client", platformLogger.getPlatformInfoString());
          }
          body = {
            installation: {
              sdkVersion: PACKAGE_VERSION
            }
          };
          request = {
            method: "POST",
            headers,
            body: JSON.stringify(body)
          };
          return [4, retryIfServerError(function() {
            return fetch(endpoint, request);
          })];
        case 1:
          response = _b2.sent();
          if (!response.ok)
            return [3, 3];
          return [4, response.json()];
        case 2:
          responseValue = _b2.sent();
          completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
          return [2, completedAuthToken];
        case 3:
          return [4, getErrorFromResponse("Generate Auth Token", response)];
        case 4:
          throw _b2.sent();
      }
    });
  });
}
function getGenerateAuthTokenEndpoint(appConfig, _a2) {
  var fid = _a2.fid;
  return getInstallationsEndpoint(appConfig) + "/" + fid + "/authTokens:generate";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function refreshAuthToken(dependencies, forceRefresh) {
  if (forceRefresh === void 0) {
    forceRefresh = false;
  }
  return __awaiter(this, void 0, void 0, function() {
    var tokenPromise, entry, authToken, _a2;
    return __generator(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          return [4, update(dependencies.appConfig, function(oldEntry) {
            if (!isEntryRegistered(oldEntry)) {
              throw ERROR_FACTORY$4.create("not-registered");
            }
            var oldAuthToken = oldEntry.authToken;
            if (!forceRefresh && isAuthTokenValid(oldAuthToken)) {
              return oldEntry;
            } else if (oldAuthToken.requestStatus === 1) {
              tokenPromise = waitUntilAuthTokenRequest(dependencies, forceRefresh);
              return oldEntry;
            } else {
              if (!navigator.onLine) {
                throw ERROR_FACTORY$4.create("app-offline");
              }
              var inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
              tokenPromise = fetchAuthTokenFromServer(dependencies, inProgressEntry);
              return inProgressEntry;
            }
          })];
        case 1:
          entry = _b2.sent();
          if (!tokenPromise)
            return [3, 3];
          return [4, tokenPromise];
        case 2:
          _a2 = _b2.sent();
          return [3, 4];
        case 3:
          _a2 = entry.authToken;
          _b2.label = 4;
        case 4:
          authToken = _a2;
          return [2, authToken];
      }
    });
  });
}
function waitUntilAuthTokenRequest(dependencies, forceRefresh) {
  return __awaiter(this, void 0, void 0, function() {
    var entry, authToken;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, updateAuthTokenRequest(dependencies.appConfig)];
        case 1:
          entry = _a2.sent();
          _a2.label = 2;
        case 2:
          if (!(entry.authToken.requestStatus === 1))
            return [3, 5];
          return [4, sleep$1(100)];
        case 3:
          _a2.sent();
          return [4, updateAuthTokenRequest(dependencies.appConfig)];
        case 4:
          entry = _a2.sent();
          return [3, 2];
        case 5:
          authToken = entry.authToken;
          if (authToken.requestStatus === 0) {
            return [2, refreshAuthToken(dependencies, forceRefresh)];
          } else {
            return [2, authToken];
          }
      }
    });
  });
}
function updateAuthTokenRequest(appConfig) {
  return update(appConfig, function(oldEntry) {
    if (!isEntryRegistered(oldEntry)) {
      throw ERROR_FACTORY$4.create("not-registered");
    }
    var oldAuthToken = oldEntry.authToken;
    if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
      return __assign(__assign({}, oldEntry), { authToken: { requestStatus: 0 } });
    }
    return oldEntry;
  });
}
function fetchAuthTokenFromServer(dependencies, installationEntry) {
  return __awaiter(this, void 0, void 0, function() {
    var authToken, updatedInstallationEntry, e_1, updatedInstallationEntry;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          _a2.trys.push([0, 3, , 8]);
          return [4, generateAuthTokenRequest(dependencies, installationEntry)];
        case 1:
          authToken = _a2.sent();
          updatedInstallationEntry = __assign(__assign({}, installationEntry), { authToken });
          return [4, set$2(dependencies.appConfig, updatedInstallationEntry)];
        case 2:
          _a2.sent();
          return [2, authToken];
        case 3:
          e_1 = _a2.sent();
          if (!(isServerError(e_1) && (e_1.customData.serverCode === 401 || e_1.customData.serverCode === 404)))
            return [3, 5];
          return [4, remove(dependencies.appConfig)];
        case 4:
          _a2.sent();
          return [3, 7];
        case 5:
          updatedInstallationEntry = __assign(__assign({}, installationEntry), { authToken: { requestStatus: 0 } });
          return [4, set$2(dependencies.appConfig, updatedInstallationEntry)];
        case 6:
          _a2.sent();
          _a2.label = 7;
        case 7:
          throw e_1;
        case 8:
          return [2];
      }
    });
  });
}
function isEntryRegistered(installationEntry) {
  return installationEntry !== void 0 && installationEntry.registrationStatus === 2;
}
function isAuthTokenValid(authToken) {
  return authToken.requestStatus === 2 && !isAuthTokenExpired(authToken);
}
function isAuthTokenExpired(authToken) {
  var now2 = Date.now();
  return now2 < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now2 + TOKEN_EXPIRATION_BUFFER;
}
function makeAuthTokenRequestInProgressEntry(oldEntry) {
  var inProgressAuthToken = {
    requestStatus: 1,
    requestTime: Date.now()
  };
  return __assign(__assign({}, oldEntry), { authToken: inProgressAuthToken });
}
function hasAuthTokenRequestTimedOut(authToken) {
  return authToken.requestStatus === 1 && authToken.requestTime + PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getId(dependencies) {
  return __awaiter(this, void 0, void 0, function() {
    var _a2, installationEntry, registrationPromise;
    return __generator(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          return [4, getInstallationEntry(dependencies.appConfig)];
        case 1:
          _a2 = _b2.sent(), installationEntry = _a2.installationEntry, registrationPromise = _a2.registrationPromise;
          if (registrationPromise) {
            registrationPromise.catch(console.error);
          } else {
            refreshAuthToken(dependencies).catch(console.error);
          }
          return [2, installationEntry.fid];
      }
    });
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getToken$1(dependencies, forceRefresh) {
  if (forceRefresh === void 0) {
    forceRefresh = false;
  }
  return __awaiter(this, void 0, void 0, function() {
    var authToken;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, completeInstallationRegistration(dependencies.appConfig)];
        case 1:
          _a2.sent();
          return [4, refreshAuthToken(dependencies, forceRefresh)];
        case 2:
          authToken = _a2.sent();
          return [2, authToken.token];
      }
    });
  });
}
function completeInstallationRegistration(appConfig) {
  return __awaiter(this, void 0, void 0, function() {
    var registrationPromise;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, getInstallationEntry(appConfig)];
        case 1:
          registrationPromise = _a2.sent().registrationPromise;
          if (!registrationPromise)
            return [3, 3];
          return [4, registrationPromise];
        case 2:
          _a2.sent();
          _a2.label = 3;
        case 3:
          return [2];
      }
    });
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function deleteInstallationRequest(appConfig, installationEntry) {
  return __awaiter(this, void 0, void 0, function() {
    var endpoint, headers, request, response;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          endpoint = getDeleteEndpoint(appConfig, installationEntry);
          headers = getHeadersWithAuth(appConfig, installationEntry);
          request = {
            method: "DELETE",
            headers
          };
          return [4, retryIfServerError(function() {
            return fetch(endpoint, request);
          })];
        case 1:
          response = _a2.sent();
          if (!!response.ok)
            return [3, 3];
          return [4, getErrorFromResponse("Delete Installation", response)];
        case 2:
          throw _a2.sent();
        case 3:
          return [2];
      }
    });
  });
}
function getDeleteEndpoint(appConfig, _a2) {
  var fid = _a2.fid;
  return getInstallationsEndpoint(appConfig) + "/" + fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function deleteInstallation(dependencies) {
  return __awaiter(this, void 0, void 0, function() {
    var appConfig, entry;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          appConfig = dependencies.appConfig;
          return [4, update(appConfig, function(oldEntry) {
            if (oldEntry && oldEntry.registrationStatus === 0) {
              return void 0;
            }
            return oldEntry;
          })];
        case 1:
          entry = _a2.sent();
          if (!entry)
            return [3, 6];
          if (!(entry.registrationStatus === 1))
            return [3, 2];
          throw ERROR_FACTORY$4.create("delete-pending-registration");
        case 2:
          if (!(entry.registrationStatus === 2))
            return [3, 6];
          if (!!navigator.onLine)
            return [3, 3];
          throw ERROR_FACTORY$4.create("app-offline");
        case 3:
          return [4, deleteInstallationRequest(appConfig, entry)];
        case 4:
          _a2.sent();
          return [4, remove(appConfig)];
        case 5:
          _a2.sent();
          _a2.label = 6;
        case 6:
          return [2];
      }
    });
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function onIdChange(_a2, callback) {
  var appConfig = _a2.appConfig;
  addCallback(appConfig, callback);
  return function() {
    removeCallback(appConfig, callback);
  };
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig$1(app) {
  var e_1, _a2;
  if (!app || !app.options) {
    throw getMissingValueError$1("App Configuration");
  }
  if (!app.name) {
    throw getMissingValueError$1("App Name");
  }
  var configKeys = [
    "projectId",
    "apiKey",
    "appId"
  ];
  try {
    for (var configKeys_1 = __values$1(configKeys), configKeys_1_1 = configKeys_1.next(); !configKeys_1_1.done; configKeys_1_1 = configKeys_1.next()) {
      var keyName = configKeys_1_1.value;
      if (!app.options[keyName]) {
        throw getMissingValueError$1(keyName);
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (configKeys_1_1 && !configKeys_1_1.done && (_a2 = configKeys_1.return))
        _a2.call(configKeys_1);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return {
    appName: app.name,
    projectId: app.options.projectId,
    apiKey: app.options.apiKey,
    appId: app.options.appId
  };
}
function getMissingValueError$1(valueName) {
  return ERROR_FACTORY$4.create("missing-app-config-values", {
    valueName
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerInstallations(instance) {
  var installationsName = "installations";
  instance.INTERNAL.registerComponent(new Component(installationsName, function(container) {
    var app = container.getProvider("app").getImmediate();
    var appConfig = extractAppConfig$1(app);
    var platformLoggerProvider = container.getProvider("platform-logger");
    var dependencies = {
      appConfig,
      platformLoggerProvider
    };
    var installations = {
      app,
      getId: function() {
        return getId(dependencies);
      },
      getToken: function(forceRefresh) {
        return getToken$1(dependencies, forceRefresh);
      },
      delete: function() {
        return deleteInstallation(dependencies);
      },
      onIdChange: function(callback) {
        return onIdChange(dependencies, callback);
      }
    };
    return installations;
  }, "PUBLIC"));
  instance.registerVersion(name$6, version$6);
}
registerInstallations(firebase$1);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a$3;
var ERROR_MAP = (_a$3 = {}, _a$3["missing-app-config-values"] = 'Missing App configuration value: "{$valueName}"', _a$3["only-available-in-window"] = "This method is available in a Window context.", _a$3["only-available-in-sw"] = "This method is available in a service worker context.", _a$3["permission-default"] = "The notification permission was not granted and dismissed instead.", _a$3["permission-blocked"] = "The notification permission was not granted and blocked instead.", _a$3["unsupported-browser"] = "This browser doesn't support the API's required to use the firebase SDK.", _a$3["failed-service-worker-registration"] = "We are unable to register the default service worker. {$browserErrorMessage}", _a$3["token-subscribe-failed"] = "A problem occurred while subscribing the user to FCM: {$errorInfo}", _a$3["token-subscribe-no-token"] = "FCM returned no token when subscribing the user to push.", _a$3["token-unsubscribe-failed"] = "A problem occurred while unsubscribing the user from FCM: {$errorInfo}", _a$3["token-update-failed"] = "A problem occurred while updating the user from FCM: {$errorInfo}", _a$3["token-update-no-token"] = "FCM returned no token when updating the user to push.", _a$3["use-sw-after-get-token"] = "The useServiceWorker() method may only be called once and must be called before calling getToken() to ensure your service worker is used.", _a$3["invalid-sw-registration"] = "The input to useServiceWorker() must be a ServiceWorkerRegistration.", _a$3["invalid-bg-handler"] = "The input to setBackgroundMessageHandler() must be a function.", _a$3["invalid-vapid-key"] = "The public VAPID key must be a string.", _a$3["use-vapid-key-after-get-token"] = "The usePublicVapidKey() method may only be called once and must be called before calling getToken() to ensure your VAPID key is used.", _a$3);
var ERROR_FACTORY$3 = new ErrorFactory("messaging", "Messaging", ERROR_MAP);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_SW_PATH = "/firebase-messaging-sw.js";
var DEFAULT_SW_SCOPE = "/firebase-cloud-messaging-push-scope";
var DEFAULT_VAPID_KEY = "BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4";
var ENDPOINT = "https://fcmregistrations.googleapis.com/v1";
var FCM_MSG = "FCM_MSG";
var TAG = "FirebaseMessaging: ";
var CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = "google.c.a.e";
var CONSOLE_CAMPAIGN_ID = "google.c.a.c_id";
var CONSOLE_CAMPAIGN_TIME = "google.c.a.ts";
var CONSOLE_CAMPAIGN_NAME = "google.c.a.c_l";
var BACKGROUND_HANDLE_EXECUTION_TIME_LIMIT_MS = 1e3;
var FOREGROUND_HANDLE_PREPARATION_TIME_MS = 3e3;
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */
var MessageType;
(function(MessageType2) {
  MessageType2["PUSH_RECEIVED"] = "push-received";
  MessageType2["NOTIFICATION_CLICKED"] = "notification-clicked";
})(MessageType || (MessageType = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function arrayToBase64(array2) {
  var uint8Array = new Uint8Array(array2);
  var base64String = btoa(String.fromCharCode.apply(String, __spread(uint8Array)));
  return base64String.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function base64ToArray(base64String) {
  var padding = "=".repeat((4 - base64String.length % 4) % 4);
  var base642 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
  var rawData = atob(base642);
  var outputArray = new Uint8Array(rawData.length);
  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OLD_DB_NAME = "fcm_token_details_db";
var OLD_DB_VERSION = 5;
var OLD_OBJECT_STORE_NAME = "fcm_token_object_Store";
function migrateOldDatabase(senderId) {
  return __awaiter(this, void 0, void 0, function() {
    var databases, dbNames, tokenDetails, db2;
    var _this = this;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (!("databases" in indexedDB))
            return [3, 2];
          return [4, indexedDB.databases()];
        case 1:
          databases = _a2.sent();
          dbNames = databases.map(function(db3) {
            return db3.name;
          });
          if (!dbNames.includes(OLD_DB_NAME)) {
            return [2, null];
          }
          _a2.label = 2;
        case 2:
          tokenDetails = null;
          return [4, openDb(OLD_DB_NAME, OLD_DB_VERSION, function(db3) {
            return __awaiter(_this, void 0, void 0, function() {
              var objectStore, value, oldDetails, oldDetails, oldDetails;
              var _a3;
              return __generator(this, function(_b2) {
                switch (_b2.label) {
                  case 0:
                    if (db3.oldVersion < 2) {
                      return [2];
                    }
                    if (!db3.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) {
                      return [2];
                    }
                    objectStore = db3.transaction.objectStore(OLD_OBJECT_STORE_NAME);
                    return [4, objectStore.index("fcmSenderId").get(senderId)];
                  case 1:
                    value = _b2.sent();
                    return [4, objectStore.clear()];
                  case 2:
                    _b2.sent();
                    if (!value) {
                      return [2];
                    }
                    if (db3.oldVersion === 2) {
                      oldDetails = value;
                      if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) {
                        return [2];
                      }
                      tokenDetails = {
                        token: oldDetails.fcmToken,
                        createTime: (_a3 = oldDetails.createTime) !== null && _a3 !== void 0 ? _a3 : Date.now(),
                        subscriptionOptions: {
                          auth: oldDetails.auth,
                          p256dh: oldDetails.p256dh,
                          endpoint: oldDetails.endpoint,
                          swScope: oldDetails.swScope,
                          vapidKey: typeof oldDetails.vapidKey === "string" ? oldDetails.vapidKey : arrayToBase64(oldDetails.vapidKey)
                        }
                      };
                    } else if (db3.oldVersion === 3) {
                      oldDetails = value;
                      tokenDetails = {
                        token: oldDetails.fcmToken,
                        createTime: oldDetails.createTime,
                        subscriptionOptions: {
                          auth: arrayToBase64(oldDetails.auth),
                          p256dh: arrayToBase64(oldDetails.p256dh),
                          endpoint: oldDetails.endpoint,
                          swScope: oldDetails.swScope,
                          vapidKey: arrayToBase64(oldDetails.vapidKey)
                        }
                      };
                    } else if (db3.oldVersion === 4) {
                      oldDetails = value;
                      tokenDetails = {
                        token: oldDetails.fcmToken,
                        createTime: oldDetails.createTime,
                        subscriptionOptions: {
                          auth: arrayToBase64(oldDetails.auth),
                          p256dh: arrayToBase64(oldDetails.p256dh),
                          endpoint: oldDetails.endpoint,
                          swScope: oldDetails.swScope,
                          vapidKey: arrayToBase64(oldDetails.vapidKey)
                        }
                      };
                    }
                    return [2];
                }
              });
            });
          })];
        case 3:
          db2 = _a2.sent();
          db2.close();
          return [4, deleteDb(OLD_DB_NAME)];
        case 4:
          _a2.sent();
          return [4, deleteDb("fcm_vapid_details_db")];
        case 5:
          _a2.sent();
          return [4, deleteDb("undefined")];
        case 6:
          _a2.sent();
          return [2, checkTokenDetails(tokenDetails) ? tokenDetails : null];
      }
    });
  });
}
function checkTokenDetails(tokenDetails) {
  if (!tokenDetails || !tokenDetails.subscriptionOptions) {
    return false;
  }
  var subscriptionOptions = tokenDetails.subscriptionOptions;
  return typeof tokenDetails.createTime === "number" && tokenDetails.createTime > 0 && typeof tokenDetails.token === "string" && tokenDetails.token.length > 0 && typeof subscriptionOptions.auth === "string" && subscriptionOptions.auth.length > 0 && typeof subscriptionOptions.p256dh === "string" && subscriptionOptions.p256dh.length > 0 && typeof subscriptionOptions.endpoint === "string" && subscriptionOptions.endpoint.length > 0 && typeof subscriptionOptions.swScope === "string" && subscriptionOptions.swScope.length > 0 && typeof subscriptionOptions.vapidKey === "string" && subscriptionOptions.vapidKey.length > 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DATABASE_NAME = "firebase-messaging-database";
var DATABASE_VERSION = 1;
var OBJECT_STORE_NAME = "firebase-messaging-store";
var dbPromise = null;
function getDbPromise() {
  if (!dbPromise) {
    dbPromise = openDb(DATABASE_NAME, DATABASE_VERSION, function(upgradeDb) {
      switch (upgradeDb.oldVersion) {
        case 0:
          upgradeDb.createObjectStore(OBJECT_STORE_NAME);
      }
    });
  }
  return dbPromise;
}
function dbGet(firebaseDependencies) {
  return __awaiter(this, void 0, void 0, function() {
    var key, db2, tokenDetails, oldTokenDetails;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          key = getKey(firebaseDependencies);
          return [4, getDbPromise()];
        case 1:
          db2 = _a2.sent();
          return [4, db2.transaction(OBJECT_STORE_NAME).objectStore(OBJECT_STORE_NAME).get(key)];
        case 2:
          tokenDetails = _a2.sent();
          if (!tokenDetails)
            return [3, 3];
          return [2, tokenDetails];
        case 3:
          return [4, migrateOldDatabase(firebaseDependencies.appConfig.senderId)];
        case 4:
          oldTokenDetails = _a2.sent();
          if (!oldTokenDetails)
            return [3, 6];
          return [4, dbSet(firebaseDependencies, oldTokenDetails)];
        case 5:
          _a2.sent();
          return [2, oldTokenDetails];
        case 6:
          return [2];
      }
    });
  });
}
function dbSet(firebaseDependencies, tokenDetails) {
  return __awaiter(this, void 0, void 0, function() {
    var key, db2, tx2;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          key = getKey(firebaseDependencies);
          return [4, getDbPromise()];
        case 1:
          db2 = _a2.sent();
          tx2 = db2.transaction(OBJECT_STORE_NAME, "readwrite");
          return [4, tx2.objectStore(OBJECT_STORE_NAME).put(tokenDetails, key)];
        case 2:
          _a2.sent();
          return [4, tx2.complete];
        case 3:
          _a2.sent();
          return [2, tokenDetails];
      }
    });
  });
}
function dbRemove(firebaseDependencies) {
  return __awaiter(this, void 0, void 0, function() {
    var key, db2, tx2;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          key = getKey(firebaseDependencies);
          return [4, getDbPromise()];
        case 1:
          db2 = _a2.sent();
          tx2 = db2.transaction(OBJECT_STORE_NAME, "readwrite");
          return [4, tx2.objectStore(OBJECT_STORE_NAME).delete(key)];
        case 2:
          _a2.sent();
          return [4, tx2.complete];
        case 3:
          _a2.sent();
          return [2];
      }
    });
  });
}
function getKey(_a2) {
  var appConfig = _a2.appConfig;
  return appConfig.appId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function requestGetToken(firebaseDependencies, subscriptionOptions) {
  return __awaiter(this, void 0, void 0, function() {
    var headers, body, subscribeOptions, responseData, response, err_1, message;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, getHeaders$1(firebaseDependencies)];
        case 1:
          headers = _a2.sent();
          body = getBody(subscriptionOptions);
          subscribeOptions = {
            method: "POST",
            headers,
            body: JSON.stringify(body)
          };
          _a2.label = 2;
        case 2:
          _a2.trys.push([2, 5, , 6]);
          return [4, fetch(getEndpoint(firebaseDependencies.appConfig), subscribeOptions)];
        case 3:
          response = _a2.sent();
          return [4, response.json()];
        case 4:
          responseData = _a2.sent();
          return [3, 6];
        case 5:
          err_1 = _a2.sent();
          throw ERROR_FACTORY$3.create("token-subscribe-failed", {
            errorInfo: err_1
          });
        case 6:
          if (responseData.error) {
            message = responseData.error.message;
            throw ERROR_FACTORY$3.create("token-subscribe-failed", {
              errorInfo: message
            });
          }
          if (!responseData.token) {
            throw ERROR_FACTORY$3.create("token-subscribe-no-token");
          }
          return [2, responseData.token];
      }
    });
  });
}
function requestUpdateToken(firebaseDependencies, tokenDetails) {
  return __awaiter(this, void 0, void 0, function() {
    var headers, body, updateOptions, responseData, response, err_2, message;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, getHeaders$1(firebaseDependencies)];
        case 1:
          headers = _a2.sent();
          body = getBody(tokenDetails.subscriptionOptions);
          updateOptions = {
            method: "PATCH",
            headers,
            body: JSON.stringify(body)
          };
          _a2.label = 2;
        case 2:
          _a2.trys.push([2, 5, , 6]);
          return [4, fetch(getEndpoint(firebaseDependencies.appConfig) + "/" + tokenDetails.token, updateOptions)];
        case 3:
          response = _a2.sent();
          return [4, response.json()];
        case 4:
          responseData = _a2.sent();
          return [3, 6];
        case 5:
          err_2 = _a2.sent();
          throw ERROR_FACTORY$3.create("token-update-failed", {
            errorInfo: err_2
          });
        case 6:
          if (responseData.error) {
            message = responseData.error.message;
            throw ERROR_FACTORY$3.create("token-update-failed", {
              errorInfo: message
            });
          }
          if (!responseData.token) {
            throw ERROR_FACTORY$3.create("token-update-no-token");
          }
          return [2, responseData.token];
      }
    });
  });
}
function requestDeleteToken(firebaseDependencies, token2) {
  return __awaiter(this, void 0, void 0, function() {
    var headers, unsubscribeOptions, response, responseData, message, err_3;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, getHeaders$1(firebaseDependencies)];
        case 1:
          headers = _a2.sent();
          unsubscribeOptions = {
            method: "DELETE",
            headers
          };
          _a2.label = 2;
        case 2:
          _a2.trys.push([2, 5, , 6]);
          return [4, fetch(getEndpoint(firebaseDependencies.appConfig) + "/" + token2, unsubscribeOptions)];
        case 3:
          response = _a2.sent();
          return [4, response.json()];
        case 4:
          responseData = _a2.sent();
          if (responseData.error) {
            message = responseData.error.message;
            throw ERROR_FACTORY$3.create("token-unsubscribe-failed", {
              errorInfo: message
            });
          }
          return [3, 6];
        case 5:
          err_3 = _a2.sent();
          throw ERROR_FACTORY$3.create("token-unsubscribe-failed", {
            errorInfo: err_3
          });
        case 6:
          return [2];
      }
    });
  });
}
function getEndpoint(_a2) {
  var projectId = _a2.projectId;
  return ENDPOINT + "/projects/" + projectId + "/registrations";
}
function getHeaders$1(_a2) {
  var appConfig = _a2.appConfig, installations = _a2.installations;
  return __awaiter(this, void 0, void 0, function() {
    var authToken;
    return __generator(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          return [4, installations.getToken()];
        case 1:
          authToken = _b2.sent();
          return [2, new Headers({
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-goog-api-key": appConfig.apiKey,
            "x-goog-firebase-installations-auth": "FIS " + authToken
          })];
      }
    });
  });
}
function getBody(_a2) {
  var p256dh = _a2.p256dh, auth = _a2.auth, endpoint = _a2.endpoint, vapidKey = _a2.vapidKey;
  var body = {
    web: {
      endpoint,
      auth,
      p256dh
    }
  };
  if (vapidKey !== DEFAULT_VAPID_KEY) {
    body.web.applicationPubKey = vapidKey;
  }
  return body;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TOKEN_EXPIRATION_MS = 7 * 24 * 60 * 60 * 1e3;
function getToken(firebaseDependencies, swRegistration, vapidKey) {
  return __awaiter(this, void 0, void 0, function() {
    var pushSubscription, tokenDetails, subscriptionOptions, e_1;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (Notification.permission !== "granted") {
            throw ERROR_FACTORY$3.create("permission-blocked");
          }
          return [4, getPushSubscription(swRegistration, vapidKey)];
        case 1:
          pushSubscription = _a2.sent();
          return [4, dbGet(firebaseDependencies)];
        case 2:
          tokenDetails = _a2.sent();
          subscriptionOptions = {
            vapidKey,
            swScope: swRegistration.scope,
            endpoint: pushSubscription.endpoint,
            auth: arrayToBase64(pushSubscription.getKey("auth")),
            p256dh: arrayToBase64(pushSubscription.getKey("p256dh"))
          };
          if (!!tokenDetails)
            return [3, 3];
          return [2, getNewToken(firebaseDependencies, subscriptionOptions)];
        case 3:
          if (!!isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions))
            return [3, 8];
          _a2.label = 4;
        case 4:
          _a2.trys.push([4, 6, , 7]);
          return [4, requestDeleteToken(firebaseDependencies, tokenDetails.token)];
        case 5:
          _a2.sent();
          return [3, 7];
        case 6:
          e_1 = _a2.sent();
          console.warn(e_1);
          return [3, 7];
        case 7:
          return [2, getNewToken(firebaseDependencies, subscriptionOptions)];
        case 8:
          if (Date.now() >= tokenDetails.createTime + TOKEN_EXPIRATION_MS) {
            return [2, updateToken({
              token: tokenDetails.token,
              createTime: Date.now(),
              subscriptionOptions
            }, firebaseDependencies, swRegistration)];
          } else {
            return [2, tokenDetails.token];
          }
        case 9:
          return [2];
      }
    });
  });
}
function deleteToken(firebaseDependencies, swRegistration) {
  return __awaiter(this, void 0, void 0, function() {
    var tokenDetails, pushSubscription;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, dbGet(firebaseDependencies)];
        case 1:
          tokenDetails = _a2.sent();
          if (!tokenDetails)
            return [3, 4];
          return [4, requestDeleteToken(firebaseDependencies, tokenDetails.token)];
        case 2:
          _a2.sent();
          return [4, dbRemove(firebaseDependencies)];
        case 3:
          _a2.sent();
          _a2.label = 4;
        case 4:
          return [4, swRegistration.pushManager.getSubscription()];
        case 5:
          pushSubscription = _a2.sent();
          if (pushSubscription) {
            return [2, pushSubscription.unsubscribe()];
          }
          return [2, true];
      }
    });
  });
}
function updateToken(tokenDetails, firebaseDependencies, swRegistration) {
  return __awaiter(this, void 0, void 0, function() {
    var updatedToken, updatedTokenDetails, e_2;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          _a2.trys.push([0, 3, , 5]);
          return [4, requestUpdateToken(firebaseDependencies, tokenDetails)];
        case 1:
          updatedToken = _a2.sent();
          updatedTokenDetails = __assign(__assign({}, tokenDetails), { token: updatedToken, createTime: Date.now() });
          return [4, dbSet(firebaseDependencies, updatedTokenDetails)];
        case 2:
          _a2.sent();
          return [2, updatedToken];
        case 3:
          e_2 = _a2.sent();
          return [4, deleteToken(firebaseDependencies, swRegistration)];
        case 4:
          _a2.sent();
          throw e_2;
        case 5:
          return [2];
      }
    });
  });
}
function getNewToken(firebaseDependencies, subscriptionOptions) {
  return __awaiter(this, void 0, void 0, function() {
    var token2, tokenDetails;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, requestGetToken(firebaseDependencies, subscriptionOptions)];
        case 1:
          token2 = _a2.sent();
          tokenDetails = {
            token: token2,
            createTime: Date.now(),
            subscriptionOptions
          };
          return [4, dbSet(firebaseDependencies, tokenDetails)];
        case 2:
          _a2.sent();
          return [2, tokenDetails.token];
      }
    });
  });
}
function getPushSubscription(swRegistration, vapidKey) {
  return __awaiter(this, void 0, void 0, function() {
    var subscription;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, swRegistration.pushManager.getSubscription()];
        case 1:
          subscription = _a2.sent();
          if (subscription) {
            return [2, subscription];
          }
          return [2, swRegistration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: base64ToArray(vapidKey)
          })];
      }
    });
  });
}
function isTokenValid(dbOptions, currentOptions) {
  var isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
  var isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
  var isAuthEqual = currentOptions.auth === dbOptions.auth;
  var isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
  return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function externalizePayload(internalPayload) {
  var payload = {
    from: internalPayload.from,
    collapseKey: internalPayload.collapse_key
  };
  propagateNotificationPayload(payload, internalPayload);
  propagateDataPayload(payload, internalPayload);
  propagateFcmOptions(payload, internalPayload);
  return payload;
}
function propagateNotificationPayload(payload, messagePayloadInternal) {
  if (!messagePayloadInternal.notification) {
    return;
  }
  payload.notification = {};
  var title = messagePayloadInternal.notification.title;
  if (!!title) {
    payload.notification.title = title;
  }
  var body = messagePayloadInternal.notification.body;
  if (!!body) {
    payload.notification.body = body;
  }
  var image = messagePayloadInternal.notification.image;
  if (!!image) {
    payload.notification.image = image;
  }
}
function propagateDataPayload(payload, messagePayloadInternal) {
  if (!messagePayloadInternal.data) {
    return;
  }
  payload.data = messagePayloadInternal.data;
}
function propagateFcmOptions(payload, messagePayloadInternal) {
  if (!messagePayloadInternal.fcmOptions) {
    return;
  }
  payload.fcmOptions = {};
  var link = messagePayloadInternal.fcmOptions.link;
  if (!!link) {
    payload.fcmOptions.link = link;
  }
  var analyticsLabel = messagePayloadInternal.fcmOptions.analytics_label;
  if (!!analyticsLabel) {
    payload.fcmOptions.analyticsLabel = analyticsLabel;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isConsoleMessage(data) {
  return typeof data === "object" && !!data && CONSOLE_CAMPAIGN_ID in data;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function sleep(ms2) {
  return new Promise(function(resolve) {
    setTimeout(resolve, ms2);
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SwController = function() {
  function SwController2(firebaseDependencies) {
    var _this = this;
    this.firebaseDependencies = firebaseDependencies;
    this.isOnBackgroundMessageUsed = null;
    this.vapidKey = null;
    this.bgMessageHandler = null;
    self.addEventListener("push", function(e28) {
      e28.waitUntil(_this.onPush(e28));
    });
    self.addEventListener("pushsubscriptionchange", function(e28) {
      e28.waitUntil(_this.onSubChange(e28));
    });
    self.addEventListener("notificationclick", function(e28) {
      e28.waitUntil(_this.onNotificationClick(e28));
    });
  }
  Object.defineProperty(SwController2.prototype, "app", {
    get: function() {
      return this.firebaseDependencies.app;
    },
    enumerable: false,
    configurable: true
  });
  SwController2.prototype.setBackgroundMessageHandler = function(callback) {
    this.isOnBackgroundMessageUsed = false;
    if (!callback || typeof callback !== "function") {
      throw ERROR_FACTORY$3.create("invalid-bg-handler");
    }
    this.bgMessageHandler = callback;
  };
  SwController2.prototype.onBackgroundMessage = function(nextOrObserver) {
    var _this = this;
    this.isOnBackgroundMessageUsed = true;
    this.bgMessageHandler = nextOrObserver;
    return function() {
      _this.bgMessageHandler = null;
    };
  };
  SwController2.prototype.getToken = function() {
    var _a2, _b2;
    return __awaiter(this, void 0, void 0, function() {
      var tokenDetails;
      return __generator(this, function(_c2) {
        switch (_c2.label) {
          case 0:
            if (!!this.vapidKey)
              return [3, 2];
            return [4, dbGet(this.firebaseDependencies)];
          case 1:
            tokenDetails = _c2.sent();
            this.vapidKey = (_b2 = (_a2 = tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.subscriptionOptions) === null || _a2 === void 0 ? void 0 : _a2.vapidKey) !== null && _b2 !== void 0 ? _b2 : DEFAULT_VAPID_KEY;
            _c2.label = 2;
          case 2:
            return [2, getToken(this.firebaseDependencies, self.registration, this.vapidKey)];
        }
      });
    });
  };
  SwController2.prototype.deleteToken = function() {
    return deleteToken(this.firebaseDependencies, self.registration);
  };
  SwController2.prototype.requestPermission = function() {
    throw ERROR_FACTORY$3.create("only-available-in-window");
  };
  SwController2.prototype.usePublicVapidKey = function(vapidKey) {
    if (this.vapidKey !== null) {
      throw ERROR_FACTORY$3.create("use-vapid-key-after-get-token");
    }
    if (typeof vapidKey !== "string" || vapidKey.length === 0) {
      throw ERROR_FACTORY$3.create("invalid-vapid-key");
    }
    this.vapidKey = vapidKey;
  };
  SwController2.prototype.useServiceWorker = function() {
    throw ERROR_FACTORY$3.create("only-available-in-window");
  };
  SwController2.prototype.onMessage = function() {
    throw ERROR_FACTORY$3.create("only-available-in-window");
  };
  SwController2.prototype.onTokenRefresh = function() {
    throw ERROR_FACTORY$3.create("only-available-in-window");
  };
  SwController2.prototype.onPush = function(event2) {
    return __awaiter(this, void 0, void 0, function() {
      var internalPayload, clientList, isNotificationShown, payload;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            internalPayload = getMessagePayloadInternal(event2);
            if (!internalPayload) {
              console.debug(TAG + "failed to get parsed MessagePayload from the PushEvent. Skip handling the push.");
              return [2];
            }
            return [4, getClientList()];
          case 1:
            clientList = _a2.sent();
            if (hasVisibleClients(clientList)) {
              return [2, sendMessagePayloadInternalToWindows(clientList, internalPayload)];
            }
            isNotificationShown = false;
            if (!!!internalPayload.notification)
              return [3, 3];
            return [4, showNotification(wrapInternalPayload(internalPayload))];
          case 2:
            _a2.sent();
            isNotificationShown = true;
            _a2.label = 3;
          case 3:
            if (isNotificationShown === true && this.isOnBackgroundMessageUsed === false) {
              return [2];
            }
            if (!!this.bgMessageHandler) {
              payload = externalizePayload(internalPayload);
              if (typeof this.bgMessageHandler === "function") {
                this.bgMessageHandler(payload);
              } else {
                this.bgMessageHandler.next(payload);
              }
            }
            return [4, sleep(BACKGROUND_HANDLE_EXECUTION_TIME_LIMIT_MS)];
          case 4:
            _a2.sent();
            return [2];
        }
      });
    });
  };
  SwController2.prototype.onSubChange = function(event2) {
    var _a2, _b2;
    return __awaiter(this, void 0, void 0, function() {
      var newSubscription, tokenDetails;
      return __generator(this, function(_c2) {
        switch (_c2.label) {
          case 0:
            newSubscription = event2.newSubscription;
            if (!!newSubscription)
              return [3, 2];
            return [4, deleteToken(this.firebaseDependencies, self.registration)];
          case 1:
            _c2.sent();
            return [2];
          case 2:
            return [4, dbGet(this.firebaseDependencies)];
          case 3:
            tokenDetails = _c2.sent();
            return [4, deleteToken(this.firebaseDependencies, self.registration)];
          case 4:
            _c2.sent();
            return [4, getToken(this.firebaseDependencies, self.registration, (_b2 = (_a2 = tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.subscriptionOptions) === null || _a2 === void 0 ? void 0 : _a2.vapidKey) !== null && _b2 !== void 0 ? _b2 : DEFAULT_VAPID_KEY)];
          case 5:
            _c2.sent();
            return [2];
        }
      });
    });
  };
  SwController2.prototype.onNotificationClick = function(event2) {
    var _a2, _b2;
    return __awaiter(this, void 0, void 0, function() {
      var internalPayload, link, url, originUrl, client;
      return __generator(this, function(_c2) {
        switch (_c2.label) {
          case 0:
            internalPayload = (_b2 = (_a2 = event2.notification) === null || _a2 === void 0 ? void 0 : _a2.data) === null || _b2 === void 0 ? void 0 : _b2[FCM_MSG];
            if (!internalPayload) {
              return [2];
            } else if (event2.action) {
              return [2];
            }
            event2.stopImmediatePropagation();
            event2.notification.close();
            link = getLink(internalPayload);
            if (!link) {
              return [2];
            }
            url = new URL(link, self.location.href);
            originUrl = new URL(self.location.origin);
            if (url.host !== originUrl.host) {
              return [2];
            }
            return [4, getWindowClient(url)];
          case 1:
            client = _c2.sent();
            if (!!client)
              return [3, 4];
            return [4, self.clients.openWindow(link)];
          case 2:
            client = _c2.sent();
            return [4, sleep(FOREGROUND_HANDLE_PREPARATION_TIME_MS)];
          case 3:
            _c2.sent();
            return [3, 6];
          case 4:
            return [4, client.focus()];
          case 5:
            client = _c2.sent();
            _c2.label = 6;
          case 6:
            if (!client) {
              return [2];
            }
            internalPayload.messageType = MessageType.NOTIFICATION_CLICKED;
            internalPayload.isFirebaseMessaging = true;
            return [2, client.postMessage(internalPayload)];
        }
      });
    });
  };
  return SwController2;
}();
function wrapInternalPayload(internalPayload) {
  var _a2;
  var wrappedInternalPayload = __assign({}, internalPayload.notification);
  wrappedInternalPayload.data = (_a2 = {}, _a2[FCM_MSG] = internalPayload, _a2);
  return wrappedInternalPayload;
}
function getMessagePayloadInternal(_a2) {
  var data = _a2.data;
  if (!data) {
    return null;
  }
  try {
    return data.json();
  } catch (err) {
    return null;
  }
}
function getWindowClient(url) {
  return __awaiter(this, void 0, void 0, function() {
    var clientList, clientList_1, clientList_1_1, client, clientUrl;
    var e_1, _a2;
    return __generator(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          return [4, getClientList()];
        case 1:
          clientList = _b2.sent();
          try {
            for (clientList_1 = __values$1(clientList), clientList_1_1 = clientList_1.next(); !clientList_1_1.done; clientList_1_1 = clientList_1.next()) {
              client = clientList_1_1.value;
              clientUrl = new URL(client.url, self.location.href);
              if (url.host === clientUrl.host) {
                return [2, client];
              }
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (clientList_1_1 && !clientList_1_1.done && (_a2 = clientList_1.return))
                _a2.call(clientList_1);
            } finally {
              if (e_1)
                throw e_1.error;
            }
          }
          return [2, null];
      }
    });
  });
}
function hasVisibleClients(clientList) {
  return clientList.some(function(client) {
    return client.visibilityState === "visible" && !client.url.startsWith("chrome-extension://");
  });
}
function sendMessagePayloadInternalToWindows(clientList, internalPayload) {
  var e_2, _a2;
  internalPayload.isFirebaseMessaging = true;
  internalPayload.messageType = MessageType.PUSH_RECEIVED;
  try {
    for (var clientList_2 = __values$1(clientList), clientList_2_1 = clientList_2.next(); !clientList_2_1.done; clientList_2_1 = clientList_2.next()) {
      var client = clientList_2_1.value;
      client.postMessage(internalPayload);
    }
  } catch (e_2_1) {
    e_2 = { error: e_2_1 };
  } finally {
    try {
      if (clientList_2_1 && !clientList_2_1.done && (_a2 = clientList_2.return))
        _a2.call(clientList_2);
    } finally {
      if (e_2)
        throw e_2.error;
    }
  }
}
function getClientList() {
  return self.clients.matchAll({
    type: "window",
    includeUncontrolled: true
  });
}
function showNotification(notificationPayloadInternal) {
  var _a2;
  var actions = notificationPayloadInternal.actions;
  var maxActions = Notification.maxActions;
  if (actions && maxActions && actions.length > maxActions) {
    console.warn("This browser only supports " + maxActions + " actions. The remaining actions will not be displayed.");
  }
  return self.registration.showNotification((_a2 = notificationPayloadInternal.title) !== null && _a2 !== void 0 ? _a2 : "", notificationPayloadInternal);
}
function getLink(payload) {
  var _a2, _b2, _c2;
  var link = (_b2 = (_a2 = payload.fcmOptions) === null || _a2 === void 0 ? void 0 : _a2.link) !== null && _b2 !== void 0 ? _b2 : (_c2 = payload.notification) === null || _c2 === void 0 ? void 0 : _c2.click_action;
  if (link) {
    return link;
  }
  if (isConsoleMessage(payload.data)) {
    return self.location.origin;
  } else {
    return null;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WindowController = function() {
  function WindowController2(firebaseDependencies) {
    var _this = this;
    this.firebaseDependencies = firebaseDependencies;
    this.vapidKey = null;
    this.onMessageCallback = null;
    navigator.serviceWorker.addEventListener("message", function(e28) {
      return _this.messageEventListener(e28);
    });
  }
  Object.defineProperty(WindowController2.prototype, "app", {
    get: function() {
      return this.firebaseDependencies.app;
    },
    enumerable: false,
    configurable: true
  });
  WindowController2.prototype.messageEventListener = function(event2) {
    return __awaiter(this, void 0, void 0, function() {
      var internalPayload, dataPayload;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            internalPayload = event2.data;
            if (!internalPayload.isFirebaseMessaging) {
              return [2];
            }
            if (this.onMessageCallback && internalPayload.messageType === MessageType.PUSH_RECEIVED) {
              if (typeof this.onMessageCallback === "function") {
                this.onMessageCallback(stripInternalFields(Object.assign({}, internalPayload)));
              } else {
                this.onMessageCallback.next(Object.assign({}, internalPayload));
              }
            }
            dataPayload = internalPayload.data;
            if (!(isConsoleMessage(dataPayload) && dataPayload[CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === "1"))
              return [3, 2];
            return [4, this.logEvent(internalPayload.messageType, dataPayload)];
          case 1:
            _a2.sent();
            _a2.label = 2;
          case 2:
            return [2];
        }
      });
    });
  };
  WindowController2.prototype.getVapidKey = function() {
    return this.vapidKey;
  };
  WindowController2.prototype.getSwReg = function() {
    return this.swRegistration;
  };
  WindowController2.prototype.getToken = function(options) {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (!(Notification.permission === "default"))
              return [3, 2];
            return [4, Notification.requestPermission()];
          case 1:
            _a2.sent();
            _a2.label = 2;
          case 2:
            if (Notification.permission !== "granted") {
              throw ERROR_FACTORY$3.create("permission-blocked");
            }
            return [4, this.updateVapidKey(options === null || options === void 0 ? void 0 : options.vapidKey)];
          case 3:
            _a2.sent();
            return [4, this.updateSwReg(options === null || options === void 0 ? void 0 : options.serviceWorkerRegistration)];
          case 4:
            _a2.sent();
            return [2, getToken(this.firebaseDependencies, this.swRegistration, this.vapidKey)];
        }
      });
    });
  };
  WindowController2.prototype.updateVapidKey = function(vapidKey) {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(_a2) {
        if (!!vapidKey) {
          this.vapidKey = vapidKey;
        } else if (!this.vapidKey) {
          this.vapidKey = DEFAULT_VAPID_KEY;
        }
        return [2];
      });
    });
  };
  WindowController2.prototype.updateSwReg = function(swRegistration) {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (!(!swRegistration && !this.swRegistration))
              return [3, 2];
            return [4, this.registerDefaultSw()];
          case 1:
            _a2.sent();
            _a2.label = 2;
          case 2:
            if (!swRegistration && !!this.swRegistration) {
              return [2];
            }
            if (!(swRegistration instanceof ServiceWorkerRegistration)) {
              throw ERROR_FACTORY$3.create("invalid-sw-registration");
            }
            this.swRegistration = swRegistration;
            return [2];
        }
      });
    });
  };
  WindowController2.prototype.registerDefaultSw = function() {
    return __awaiter(this, void 0, void 0, function() {
      var _a2, e_1;
      return __generator(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            _b2.trys.push([0, 2, , 3]);
            _a2 = this;
            return [4, navigator.serviceWorker.register(DEFAULT_SW_PATH, {
              scope: DEFAULT_SW_SCOPE
            })];
          case 1:
            _a2.swRegistration = _b2.sent();
            this.swRegistration.update().catch(function() {
            });
            return [3, 3];
          case 2:
            e_1 = _b2.sent();
            throw ERROR_FACTORY$3.create("failed-service-worker-registration", {
              browserErrorMessage: e_1.message
            });
          case 3:
            return [2];
        }
      });
    });
  };
  WindowController2.prototype.deleteToken = function() {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (!!this.swRegistration)
              return [3, 2];
            return [4, this.registerDefaultSw()];
          case 1:
            _a2.sent();
            _a2.label = 2;
          case 2:
            return [2, deleteToken(this.firebaseDependencies, this.swRegistration)];
        }
      });
    });
  };
  WindowController2.prototype.requestPermission = function() {
    return __awaiter(this, void 0, void 0, function() {
      var permissionResult;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            if (Notification.permission === "granted") {
              return [2];
            }
            return [4, Notification.requestPermission()];
          case 1:
            permissionResult = _a2.sent();
            if (permissionResult === "granted") {
              return [2];
            } else if (permissionResult === "denied") {
              throw ERROR_FACTORY$3.create("permission-blocked");
            } else {
              throw ERROR_FACTORY$3.create("permission-default");
            }
        }
      });
    });
  };
  WindowController2.prototype.usePublicVapidKey = function(vapidKey) {
    if (this.vapidKey !== null) {
      throw ERROR_FACTORY$3.create("use-vapid-key-after-get-token");
    }
    if (typeof vapidKey !== "string" || vapidKey.length === 0) {
      throw ERROR_FACTORY$3.create("invalid-vapid-key");
    }
    this.vapidKey = vapidKey;
  };
  WindowController2.prototype.useServiceWorker = function(swRegistration) {
    if (!(swRegistration instanceof ServiceWorkerRegistration)) {
      throw ERROR_FACTORY$3.create("invalid-sw-registration");
    }
    if (this.swRegistration) {
      throw ERROR_FACTORY$3.create("use-sw-after-get-token");
    }
    this.swRegistration = swRegistration;
  };
  WindowController2.prototype.onMessage = function(nextOrObserver) {
    var _this = this;
    this.onMessageCallback = nextOrObserver;
    return function() {
      _this.onMessageCallback = null;
    };
  };
  WindowController2.prototype.setBackgroundMessageHandler = function() {
    throw ERROR_FACTORY$3.create("only-available-in-sw");
  };
  WindowController2.prototype.onBackgroundMessage = function() {
    throw ERROR_FACTORY$3.create("only-available-in-sw");
  };
  WindowController2.prototype.onTokenRefresh = function() {
    return function() {
    };
  };
  WindowController2.prototype.logEvent = function(messageType, data) {
    return __awaiter(this, void 0, void 0, function() {
      var eventType, analytics;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            eventType = getEventType(messageType);
            return [4, this.firebaseDependencies.analyticsProvider.get()];
          case 1:
            analytics = _a2.sent();
            analytics.logEvent(eventType, {
              message_id: data[CONSOLE_CAMPAIGN_ID],
              message_name: data[CONSOLE_CAMPAIGN_NAME],
              message_time: data[CONSOLE_CAMPAIGN_TIME],
              message_device_time: Math.floor(Date.now() / 1e3)
            });
            return [2];
        }
      });
    });
  };
  return WindowController2;
}();
function getEventType(messageType) {
  switch (messageType) {
    case MessageType.NOTIFICATION_CLICKED:
      return "notification_open";
    case MessageType.PUSH_RECEIVED:
      return "notification_foreground";
    default:
      throw new Error();
  }
}
function stripInternalFields(internalPayload) {
  delete internalPayload.messageType;
  delete internalPayload.isFirebaseMessaging;
  return internalPayload;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
  var e_1, _a2;
  if (!app || !app.options) {
    throw getMissingValueError("App Configuration Object");
  }
  if (!app.name) {
    throw getMissingValueError("App Name");
  }
  var configKeys = [
    "projectId",
    "apiKey",
    "appId",
    "messagingSenderId"
  ];
  var options = app.options;
  try {
    for (var configKeys_1 = __values$1(configKeys), configKeys_1_1 = configKeys_1.next(); !configKeys_1_1.done; configKeys_1_1 = configKeys_1.next()) {
      var keyName = configKeys_1_1.value;
      if (!options[keyName]) {
        throw getMissingValueError(keyName);
      }
    }
  } catch (e_1_1) {
    e_1 = { error: e_1_1 };
  } finally {
    try {
      if (configKeys_1_1 && !configKeys_1_1.done && (_a2 = configKeys_1.return))
        _a2.call(configKeys_1);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return {
    appName: app.name,
    projectId: options.projectId,
    apiKey: options.apiKey,
    appId: options.appId,
    senderId: options.messagingSenderId
  };
}
function getMissingValueError(valueName) {
  return ERROR_FACTORY$3.create("missing-app-config-values", {
    valueName
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MESSAGING_NAME = "messaging";
function factoryMethod(container) {
  var app = container.getProvider("app").getImmediate();
  var appConfig = extractAppConfig(app);
  var installations = container.getProvider("installations").getImmediate();
  var analyticsProvider = container.getProvider("analytics-internal");
  var firebaseDependencies = {
    app,
    appConfig,
    installations,
    analyticsProvider
  };
  if (!isSupported$1()) {
    throw ERROR_FACTORY$3.create("unsupported-browser");
  }
  if (self && "ServiceWorkerGlobalScope" in self) {
    return new SwController(firebaseDependencies);
  } else {
    return new WindowController(firebaseDependencies);
  }
}
var NAMESPACE_EXPORTS = {
  isSupported: isSupported$1
};
firebase$1.INTERNAL.registerComponent(new Component(MESSAGING_NAME, factoryMethod, "PUBLIC").setServiceProps(NAMESPACE_EXPORTS));
function isSupported$1() {
  if (self && "ServiceWorkerGlobalScope" in self) {
    return isSWControllerSupported();
  } else {
    return isWindowControllerSupported();
  }
}
function isWindowControllerSupported() {
  return "indexedDB" in window && indexedDB !== null && navigator.cookieEnabled && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window && "fetch" in window && ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification") && PushSubscription.prototype.hasOwnProperty("getKey");
}
function isSWControllerSupported() {
  return "indexedDB" in self && indexedDB !== null && "PushManager" in self && "Notification" in self && ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification") && PushSubscription.prototype.hasOwnProperty("getKey");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_HOST = "firebasestorage.googleapis.com";
var CONFIG_STORAGE_BUCKET_KEY = "storageBucket";
var DEFAULT_MAX_OPERATION_RETRY_TIME = 2 * 60 * 1e3;
var DEFAULT_MAX_UPLOAD_RETRY_TIME = 10 * 60 * 1e3;
var FirebaseStorageError = function(_super) {
  __extends$1(FirebaseStorageError2, _super);
  function FirebaseStorageError2(code, message) {
    var _this = _super.call(this, prependCode(code), "Firebase Storage: " + message + " (" + prependCode(code) + ")") || this;
    _this.customData = { serverResponse: null };
    Object.setPrototypeOf(_this, FirebaseStorageError2.prototype);
    return _this;
  }
  FirebaseStorageError2.prototype.codeEquals = function(code) {
    return prependCode(code) === this.code;
  };
  Object.defineProperty(FirebaseStorageError2.prototype, "message", {
    get: function() {
      if (this.customData.serverResponse) {
        return this.message + "\n" + this.customData.serverResponse;
      } else {
        return this.message;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FirebaseStorageError2.prototype, "serverResponse", {
    get: function() {
      return this.customData.serverResponse;
    },
    set: function(serverResponse) {
      this.customData.serverResponse = serverResponse;
    },
    enumerable: false,
    configurable: true
  });
  return FirebaseStorageError2;
}(FirebaseError);
var Code = {
  UNKNOWN: "unknown",
  OBJECT_NOT_FOUND: "object-not-found",
  BUCKET_NOT_FOUND: "bucket-not-found",
  PROJECT_NOT_FOUND: "project-not-found",
  QUOTA_EXCEEDED: "quota-exceeded",
  UNAUTHENTICATED: "unauthenticated",
  UNAUTHORIZED: "unauthorized",
  RETRY_LIMIT_EXCEEDED: "retry-limit-exceeded",
  INVALID_CHECKSUM: "invalid-checksum",
  CANCELED: "canceled",
  INVALID_EVENT_NAME: "invalid-event-name",
  INVALID_URL: "invalid-url",
  INVALID_DEFAULT_BUCKET: "invalid-default-bucket",
  NO_DEFAULT_BUCKET: "no-default-bucket",
  CANNOT_SLICE_BLOB: "cannot-slice-blob",
  SERVER_FILE_WRONG_SIZE: "server-file-wrong-size",
  NO_DOWNLOAD_URL: "no-download-url",
  INVALID_ARGUMENT: "invalid-argument",
  INVALID_ARGUMENT_COUNT: "invalid-argument-count",
  APP_DELETED: "app-deleted",
  INVALID_ROOT_OPERATION: "invalid-root-operation",
  INVALID_FORMAT: "invalid-format",
  INTERNAL_ERROR: "internal-error",
  UNSUPPORTED_ENVIRONMENT: "unsupported-environment"
};
function prependCode(code) {
  return "storage/" + code;
}
function unknown() {
  var message = "An unknown error occurred, please check the error payload for server response.";
  return new FirebaseStorageError(Code.UNKNOWN, message);
}
function objectNotFound(path) {
  return new FirebaseStorageError(Code.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function quotaExceeded(bucket) {
  return new FirebaseStorageError(Code.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on https://firebase.google.com/pricing/.");
}
function unauthenticated() {
  var message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
  return new FirebaseStorageError(Code.UNAUTHENTICATED, message);
}
function unauthorized(path) {
  return new FirebaseStorageError(Code.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function retryLimitExceeded() {
  return new FirebaseStorageError(Code.RETRY_LIMIT_EXCEEDED, "Max retry time for operation exceeded, please try again.");
}
function canceled() {
  return new FirebaseStorageError(Code.CANCELED, "User canceled the upload/download.");
}
function invalidUrl(url) {
  return new FirebaseStorageError(Code.INVALID_URL, "Invalid URL '" + url + "'.");
}
function invalidDefaultBucket(bucket) {
  return new FirebaseStorageError(Code.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function noDefaultBucket() {
  return new FirebaseStorageError(Code.NO_DEFAULT_BUCKET, "No default bucket found. Did you set the '" + CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function cannotSliceBlob() {
  return new FirebaseStorageError(Code.CANNOT_SLICE_BLOB, "Cannot slice blob for upload. Please retry the upload.");
}
function serverFileWrongSize() {
  return new FirebaseStorageError(Code.SERVER_FILE_WRONG_SIZE, "Server recorded incorrect upload file size, please retry the upload.");
}
function noDownloadURL() {
  return new FirebaseStorageError(Code.NO_DOWNLOAD_URL, "The given file does not have any download URLs.");
}
function invalidArgument(message) {
  return new FirebaseStorageError(Code.INVALID_ARGUMENT, message);
}
function appDeleted() {
  return new FirebaseStorageError(Code.APP_DELETED, "The Firebase app was deleted.");
}
function invalidRootOperation(name2) {
  return new FirebaseStorageError(Code.INVALID_ROOT_OPERATION, "The operation '" + name2 + "' cannot be performed on a root reference, create a non-root reference using child, such as .child('file.png').");
}
function invalidFormat(format2, message) {
  return new FirebaseStorageError(Code.INVALID_FORMAT, "String does not match format '" + format2 + "': " + message);
}
function internalError(message) {
  throw new FirebaseStorageError(Code.INTERNAL_ERROR, "Internal error: " + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StringFormat = {
  RAW: "raw",
  BASE64: "base64",
  BASE64URL: "base64url",
  DATA_URL: "data_url"
};
var StringData = function() {
  function StringData2(data, contentType) {
    this.data = data;
    this.contentType = contentType || null;
  }
  return StringData2;
}();
function dataFromString(format2, stringData) {
  switch (format2) {
    case StringFormat.RAW:
      return new StringData(utf8Bytes_(stringData));
    case StringFormat.BASE64:
    case StringFormat.BASE64URL:
      return new StringData(base64Bytes_(format2, stringData));
    case StringFormat.DATA_URL:
      return new StringData(dataURLBytes_(stringData), dataURLContentType_(stringData));
  }
  throw unknown();
}
function utf8Bytes_(value) {
  var b3 = [];
  for (var i = 0; i < value.length; i++) {
    var c3 = value.charCodeAt(i);
    if (c3 <= 127) {
      b3.push(c3);
    } else {
      if (c3 <= 2047) {
        b3.push(192 | c3 >> 6, 128 | c3 & 63);
      } else {
        if ((c3 & 64512) === 55296) {
          var valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
          if (!valid) {
            b3.push(239, 191, 189);
          } else {
            var hi2 = c3;
            var lo2 = value.charCodeAt(++i);
            c3 = 65536 | (hi2 & 1023) << 10 | lo2 & 1023;
            b3.push(240 | c3 >> 18, 128 | c3 >> 12 & 63, 128 | c3 >> 6 & 63, 128 | c3 & 63);
          }
        } else {
          if ((c3 & 64512) === 56320) {
            b3.push(239, 191, 189);
          } else {
            b3.push(224 | c3 >> 12, 128 | c3 >> 6 & 63, 128 | c3 & 63);
          }
        }
      }
    }
  }
  return new Uint8Array(b3);
}
function percentEncodedBytes_(value) {
  var decoded;
  try {
    decoded = decodeURIComponent(value);
  } catch (e28) {
    throw invalidFormat(StringFormat.DATA_URL, "Malformed data URL.");
  }
  return utf8Bytes_(decoded);
}
function base64Bytes_(format2, value) {
  switch (format2) {
    case StringFormat.BASE64: {
      var hasMinus = value.indexOf("-") !== -1;
      var hasUnder = value.indexOf("_") !== -1;
      if (hasMinus || hasUnder) {
        var invalidChar = hasMinus ? "-" : "_";
        throw invalidFormat(format2, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
      }
      break;
    }
    case StringFormat.BASE64URL: {
      var hasPlus = value.indexOf("+") !== -1;
      var hasSlash = value.indexOf("/") !== -1;
      if (hasPlus || hasSlash) {
        var invalidChar = hasPlus ? "+" : "/";
        throw invalidFormat(format2, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
      }
      value = value.replace(/-/g, "+").replace(/_/g, "/");
      break;
    }
  }
  var bytes;
  try {
    bytes = atob(value);
  } catch (e28) {
    throw invalidFormat(format2, "Invalid character found");
  }
  var array2 = new Uint8Array(bytes.length);
  for (var i = 0; i < bytes.length; i++) {
    array2[i] = bytes.charCodeAt(i);
  }
  return array2;
}
var DataURLParts = function() {
  function DataURLParts2(dataURL) {
    this.base64 = false;
    this.contentType = null;
    var matches = dataURL.match(/^data:([^,]+)?,/);
    if (matches === null) {
      throw invalidFormat(StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
    }
    var middle = matches[1] || null;
    if (middle != null) {
      this.base64 = endsWith(middle, ";base64");
      this.contentType = this.base64 ? middle.substring(0, middle.length - ";base64".length) : middle;
    }
    this.rest = dataURL.substring(dataURL.indexOf(",") + 1);
  }
  return DataURLParts2;
}();
function dataURLBytes_(dataUrl) {
  var parts = new DataURLParts(dataUrl);
  if (parts.base64) {
    return base64Bytes_(StringFormat.BASE64, parts.rest);
  } else {
    return percentEncodedBytes_(parts.rest);
  }
}
function dataURLContentType_(dataUrl) {
  var parts = new DataURLParts(dataUrl);
  return parts.contentType;
}
function endsWith(s3, end) {
  var longEnough = s3.length >= end.length;
  if (!longEnough) {
    return false;
  }
  return s3.substring(s3.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TaskEvent = {
  STATE_CHANGED: "state_changed"
};
var InternalTaskState = {
  RUNNING: "running",
  PAUSING: "pausing",
  PAUSED: "paused",
  SUCCESS: "success",
  CANCELING: "canceling",
  CANCELED: "canceled",
  ERROR: "error"
};
var TaskState = {
  RUNNING: "running",
  PAUSED: "paused",
  SUCCESS: "success",
  CANCELED: "canceled",
  ERROR: "error"
};
function taskStateFromInternalTaskState(state) {
  switch (state) {
    case InternalTaskState.RUNNING:
    case InternalTaskState.PAUSING:
    case InternalTaskState.CANCELING:
      return TaskState.RUNNING;
    case InternalTaskState.PAUSED:
      return TaskState.PAUSED;
    case InternalTaskState.SUCCESS:
      return TaskState.SUCCESS;
    case InternalTaskState.CANCELED:
      return TaskState.CANCELED;
    case InternalTaskState.ERROR:
      return TaskState.ERROR;
    default:
      return TaskState.ERROR;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ErrorCode;
(function(ErrorCode2) {
  ErrorCode2[ErrorCode2["NO_ERROR"] = 0] = "NO_ERROR";
  ErrorCode2[ErrorCode2["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
  ErrorCode2[ErrorCode2["ABORT"] = 2] = "ABORT";
})(ErrorCode || (ErrorCode = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var NetworkXhrIo = function() {
  function NetworkXhrIo2() {
    var _this = this;
    this.sent_ = false;
    this.xhr_ = new XMLHttpRequest();
    this.errorCode_ = ErrorCode.NO_ERROR;
    this.sendPromise_ = new Promise(function(resolve) {
      _this.xhr_.addEventListener("abort", function() {
        _this.errorCode_ = ErrorCode.ABORT;
        resolve(_this);
      });
      _this.xhr_.addEventListener("error", function() {
        _this.errorCode_ = ErrorCode.NETWORK_ERROR;
        resolve(_this);
      });
      _this.xhr_.addEventListener("load", function() {
        resolve(_this);
      });
    });
  }
  NetworkXhrIo2.prototype.send = function(url, method, body, headers) {
    if (this.sent_) {
      throw internalError("cannot .send() more than once");
    }
    this.sent_ = true;
    this.xhr_.open(method, url, true);
    if (headers !== void 0) {
      for (var key in headers) {
        if (headers.hasOwnProperty(key)) {
          this.xhr_.setRequestHeader(key, headers[key].toString());
        }
      }
    }
    if (body !== void 0) {
      this.xhr_.send(body);
    } else {
      this.xhr_.send();
    }
    return this.sendPromise_;
  };
  NetworkXhrIo2.prototype.getErrorCode = function() {
    if (!this.sent_) {
      throw internalError("cannot .getErrorCode() before sending");
    }
    return this.errorCode_;
  };
  NetworkXhrIo2.prototype.getStatus = function() {
    if (!this.sent_) {
      throw internalError("cannot .getStatus() before sending");
    }
    try {
      return this.xhr_.status;
    } catch (e28) {
      return -1;
    }
  };
  NetworkXhrIo2.prototype.getResponseText = function() {
    if (!this.sent_) {
      throw internalError("cannot .getResponseText() before sending");
    }
    return this.xhr_.responseText;
  };
  NetworkXhrIo2.prototype.abort = function() {
    this.xhr_.abort();
  };
  NetworkXhrIo2.prototype.getResponseHeader = function(header) {
    return this.xhr_.getResponseHeader(header);
  };
  NetworkXhrIo2.prototype.addUploadProgressListener = function(listener) {
    if (this.xhr_.upload != null) {
      this.xhr_.upload.addEventListener("progress", listener);
    }
  };
  NetworkXhrIo2.prototype.removeUploadProgressListener = function(listener) {
    if (this.xhr_.upload != null) {
      this.xhr_.upload.removeEventListener("progress", listener);
    }
  };
  return NetworkXhrIo2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var XhrIoPool = function() {
  function XhrIoPool2() {
  }
  XhrIoPool2.prototype.createXhrIo = function() {
    return new NetworkXhrIo();
  };
  return XhrIoPool2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isJustDef(p3) {
  return p3 !== void 0;
}
function isFunction$2(p3) {
  return typeof p3 === "function";
}
function isNonArrayObject(p3) {
  return typeof p3 === "object" && !Array.isArray(p3);
}
function isString$1(p3) {
  return typeof p3 === "string" || p3 instanceof String;
}
function isNativeBlob(p3) {
  return isNativeBlobDefined() && p3 instanceof Blob;
}
function isNativeBlobDefined() {
  return typeof Blob !== "undefined";
}
function validateNumber(argument, minValue, maxValue, value) {
  if (value < minValue) {
    throw new FirebaseStorageError(Code.INVALID_ARGUMENT, "Invalid value for '" + argument + "'. Expected " + minValue + " or greater.");
  }
  if (value > maxValue) {
    throw new FirebaseStorageError(Code.INVALID_ARGUMENT, "Invalid value for '" + argument + "'. Expected " + maxValue + " or less.");
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getBlobBuilder() {
  if (typeof BlobBuilder !== "undefined") {
    return BlobBuilder;
  } else if (typeof WebKitBlobBuilder !== "undefined") {
    return WebKitBlobBuilder;
  } else {
    return void 0;
  }
}
function getBlob() {
  var args = [];
  for (var _i2 = 0; _i2 < arguments.length; _i2++) {
    args[_i2] = arguments[_i2];
  }
  var BlobBuilder2 = getBlobBuilder();
  if (BlobBuilder2 !== void 0) {
    var bb2 = new BlobBuilder2();
    for (var i = 0; i < args.length; i++) {
      bb2.append(args[i]);
    }
    return bb2.getBlob();
  } else {
    if (isNativeBlobDefined()) {
      return new Blob(args);
    } else {
      throw new FirebaseStorageError(Code.UNSUPPORTED_ENVIRONMENT, "This browser doesn't seem to support creating Blobs");
    }
  }
}
function sliceBlob(blob, start2, end) {
  if (blob.webkitSlice) {
    return blob.webkitSlice(start2, end);
  } else if (blob.mozSlice) {
    return blob.mozSlice(start2, end);
  } else if (blob.slice) {
    return blob.slice(start2, end);
  }
  return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FbsBlob = function() {
  function FbsBlob2(data, elideCopy) {
    var size = 0;
    var blobType = "";
    if (isNativeBlob(data)) {
      this.data_ = data;
      size = data.size;
      blobType = data.type;
    } else if (data instanceof ArrayBuffer) {
      if (elideCopy) {
        this.data_ = new Uint8Array(data);
      } else {
        this.data_ = new Uint8Array(data.byteLength);
        this.data_.set(new Uint8Array(data));
      }
      size = this.data_.length;
    } else if (data instanceof Uint8Array) {
      if (elideCopy) {
        this.data_ = data;
      } else {
        this.data_ = new Uint8Array(data.length);
        this.data_.set(data);
      }
      size = data.length;
    }
    this.size_ = size;
    this.type_ = blobType;
  }
  FbsBlob2.prototype.size = function() {
    return this.size_;
  };
  FbsBlob2.prototype.type = function() {
    return this.type_;
  };
  FbsBlob2.prototype.slice = function(startByte, endByte) {
    if (isNativeBlob(this.data_)) {
      var realBlob = this.data_;
      var sliced = sliceBlob(realBlob, startByte, endByte);
      if (sliced === null) {
        return null;
      }
      return new FbsBlob2(sliced);
    } else {
      var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
      return new FbsBlob2(slice, true);
    }
  };
  FbsBlob2.getBlob = function() {
    var args = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      args[_i2] = arguments[_i2];
    }
    if (isNativeBlobDefined()) {
      var blobby = args.map(function(val) {
        if (val instanceof FbsBlob2) {
          return val.data_;
        } else {
          return val;
        }
      });
      return new FbsBlob2(getBlob.apply(null, blobby));
    } else {
      var uint8Arrays = args.map(function(val) {
        if (isString$1(val)) {
          return dataFromString(StringFormat.RAW, val).data;
        } else {
          return val.data_;
        }
      });
      var finalLength_1 = 0;
      uint8Arrays.forEach(function(array2) {
        finalLength_1 += array2.byteLength;
      });
      var merged_1 = new Uint8Array(finalLength_1);
      var index_1 = 0;
      uint8Arrays.forEach(function(array2) {
        for (var i = 0; i < array2.length; i++) {
          merged_1[index_1++] = array2[i];
        }
      });
      return new FbsBlob2(merged_1, true);
    }
  };
  FbsBlob2.prototype.uploadData = function() {
    return this.data_;
  };
  return FbsBlob2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Location = function() {
  function Location2(bucket, path) {
    this.bucket = bucket;
    this.path_ = path;
  }
  Object.defineProperty(Location2.prototype, "path", {
    get: function() {
      return this.path_;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Location2.prototype, "isRoot", {
    get: function() {
      return this.path.length === 0;
    },
    enumerable: false,
    configurable: true
  });
  Location2.prototype.fullServerUrl = function() {
    var encode2 = encodeURIComponent;
    return "/b/" + encode2(this.bucket) + "/o/" + encode2(this.path);
  };
  Location2.prototype.bucketOnlyServerUrl = function() {
    var encode2 = encodeURIComponent;
    return "/b/" + encode2(this.bucket) + "/o";
  };
  Location2.makeFromBucketSpec = function(bucketString) {
    var bucketLocation;
    try {
      bucketLocation = Location2.makeFromUrl(bucketString);
    } catch (e28) {
      return new Location2(bucketString, "");
    }
    if (bucketLocation.path === "") {
      return bucketLocation;
    } else {
      throw invalidDefaultBucket(bucketString);
    }
  };
  Location2.makeFromUrl = function(url) {
    var location2 = null;
    var bucketDomain = "([A-Za-z0-9.\\-_]+)";
    function gsModify(loc) {
      if (loc.path.charAt(loc.path.length - 1) === "/") {
        loc.path_ = loc.path_.slice(0, -1);
      }
    }
    var gsPath = "(/(.*))?$";
    var gsRegex = new RegExp("^gs://" + bucketDomain + gsPath, "i");
    var gsIndices = { bucket: 1, path: 3 };
    function httpModify(loc) {
      loc.path_ = decodeURIComponent(loc.path);
    }
    var version2 = "v[A-Za-z0-9_]+";
    var firebaseStorageHost = DEFAULT_HOST.replace(/[.]/g, "\\.");
    var firebaseStoragePath = "(/([^?#]*).*)?$";
    var firebaseStorageRegExp = new RegExp("^https?://" + firebaseStorageHost + "/" + version2 + "/b/" + bucketDomain + "/o" + firebaseStoragePath, "i");
    var firebaseStorageIndices = { bucket: 1, path: 3 };
    var cloudStorageHost = "(?:storage.googleapis.com|storage.cloud.google.com)";
    var cloudStoragePath = "([^?#]*)";
    var cloudStorageRegExp = new RegExp("^https?://" + cloudStorageHost + "/" + bucketDomain + "/" + cloudStoragePath, "i");
    var cloudStorageIndices = { bucket: 1, path: 2 };
    var groups = [
      { regex: gsRegex, indices: gsIndices, postModify: gsModify },
      {
        regex: firebaseStorageRegExp,
        indices: firebaseStorageIndices,
        postModify: httpModify
      },
      {
        regex: cloudStorageRegExp,
        indices: cloudStorageIndices,
        postModify: httpModify
      }
    ];
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var captures = group.regex.exec(url);
      if (captures) {
        var bucketValue = captures[group.indices.bucket];
        var pathValue = captures[group.indices.path];
        if (!pathValue) {
          pathValue = "";
        }
        location2 = new Location2(bucketValue, pathValue);
        group.postModify(location2);
        break;
      }
    }
    if (location2 == null) {
      throw invalidUrl(url);
    }
    return location2;
  };
  return Location2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function jsonObjectOrNull(s3) {
  var obj;
  try {
    obj = JSON.parse(s3);
  } catch (e28) {
    return null;
  }
  if (isNonArrayObject(obj)) {
    return obj;
  } else {
    return null;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function parent(path) {
  if (path.length === 0) {
    return null;
  }
  var index = path.lastIndexOf("/");
  if (index === -1) {
    return "";
  }
  var newPath = path.slice(0, index);
  return newPath;
}
function child(path, childPath) {
  var canonicalChildPath = childPath.split("/").filter(function(component) {
    return component.length > 0;
  }).join("/");
  if (path.length === 0) {
    return canonicalChildPath;
  } else {
    return path + "/" + canonicalChildPath;
  }
}
function lastComponent(path) {
  var index = path.lastIndexOf("/", path.length - 2);
  if (index === -1) {
    return path;
  } else {
    return path.slice(index + 1);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function makeUrl(urlPart) {
  return "https://" + DEFAULT_HOST + "/v0" + urlPart;
}
function makeQueryString(params2) {
  var encode2 = encodeURIComponent;
  var queryPart = "?";
  for (var key in params2) {
    if (params2.hasOwnProperty(key)) {
      var nextPart = encode2(key) + "=" + encode2(params2[key]);
      queryPart = queryPart + nextPart + "&";
    }
  }
  queryPart = queryPart.slice(0, -1);
  return queryPart;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function noXform_(metadata2, value) {
  return value;
}
var Mapping = function() {
  function Mapping2(server, local, writable, xform) {
    this.server = server;
    this.local = local || server;
    this.writable = !!writable;
    this.xform = xform || noXform_;
  }
  return Mapping2;
}();
var mappings_ = null;
function xformPath(fullPath) {
  if (!isString$1(fullPath) || fullPath.length < 2) {
    return fullPath;
  } else {
    return lastComponent(fullPath);
  }
}
function getMappings() {
  if (mappings_) {
    return mappings_;
  }
  var mappings = [];
  mappings.push(new Mapping("bucket"));
  mappings.push(new Mapping("generation"));
  mappings.push(new Mapping("metageneration"));
  mappings.push(new Mapping("name", "fullPath", true));
  function mappingsXformPath(_metadata, fullPath) {
    return xformPath(fullPath);
  }
  var nameMapping = new Mapping("name");
  nameMapping.xform = mappingsXformPath;
  mappings.push(nameMapping);
  function xformSize(_metadata, size) {
    if (size !== void 0) {
      return Number(size);
    } else {
      return size;
    }
  }
  var sizeMapping = new Mapping("size");
  sizeMapping.xform = xformSize;
  mappings.push(sizeMapping);
  mappings.push(new Mapping("timeCreated"));
  mappings.push(new Mapping("updated"));
  mappings.push(new Mapping("md5Hash", null, true));
  mappings.push(new Mapping("cacheControl", null, true));
  mappings.push(new Mapping("contentDisposition", null, true));
  mappings.push(new Mapping("contentEncoding", null, true));
  mappings.push(new Mapping("contentLanguage", null, true));
  mappings.push(new Mapping("contentType", null, true));
  mappings.push(new Mapping("metadata", "customMetadata", true));
  mappings_ = mappings;
  return mappings_;
}
function addRef(metadata2, service) {
  function generateRef() {
    var bucket = metadata2["bucket"];
    var path = metadata2["fullPath"];
    var loc = new Location(bucket, path);
    return service.makeStorageReference(loc);
  }
  Object.defineProperty(metadata2, "ref", { get: generateRef });
}
function fromResource(service, resource, mappings) {
  var metadata2 = {};
  metadata2["type"] = "file";
  var len = mappings.length;
  for (var i = 0; i < len; i++) {
    var mapping = mappings[i];
    metadata2[mapping.local] = mapping.xform(metadata2, resource[mapping.server]);
  }
  addRef(metadata2, service);
  return metadata2;
}
function fromResourceString(service, resourceString, mappings) {
  var obj = jsonObjectOrNull(resourceString);
  if (obj === null) {
    return null;
  }
  var resource = obj;
  return fromResource(service, resource, mappings);
}
function downloadUrlFromResourceString(metadata2, resourceString) {
  var obj = jsonObjectOrNull(resourceString);
  if (obj === null) {
    return null;
  }
  if (!isString$1(obj["downloadTokens"])) {
    return null;
  }
  var tokens2 = obj["downloadTokens"];
  if (tokens2.length === 0) {
    return null;
  }
  var encode2 = encodeURIComponent;
  var tokensList = tokens2.split(",");
  var urls = tokensList.map(function(token2) {
    var bucket = metadata2["bucket"];
    var path = metadata2["fullPath"];
    var urlPart = "/b/" + encode2(bucket) + "/o/" + encode2(path);
    var base = makeUrl(urlPart);
    var queryString = makeQueryString({
      alt: "media",
      token: token2
    });
    return base + queryString;
  });
  return urls[0];
}
function toResourceString(metadata2, mappings) {
  var resource = {};
  var len = mappings.length;
  for (var i = 0; i < len; i++) {
    var mapping = mappings[i];
    if (mapping.writable) {
      resource[mapping.server] = metadata2[mapping.local];
    }
  }
  return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PREFIXES_KEY = "prefixes";
var ITEMS_KEY = "items";
function fromBackendResponse(service, bucket, resource) {
  var listResult = {
    prefixes: [],
    items: [],
    nextPageToken: resource["nextPageToken"]
  };
  if (resource[PREFIXES_KEY]) {
    for (var _i2 = 0, _a2 = resource[PREFIXES_KEY]; _i2 < _a2.length; _i2++) {
      var path = _a2[_i2];
      var pathWithoutTrailingSlash = path.replace(/\/$/, "");
      var reference = service.makeStorageReference(new Location(bucket, pathWithoutTrailingSlash));
      listResult.prefixes.push(reference);
    }
  }
  if (resource[ITEMS_KEY]) {
    for (var _b2 = 0, _c2 = resource[ITEMS_KEY]; _b2 < _c2.length; _b2++) {
      var item = _c2[_b2];
      var reference = service.makeStorageReference(new Location(bucket, item["name"]));
      listResult.items.push(reference);
    }
  }
  return listResult;
}
function fromResponseString(service, bucket, resourceString) {
  var obj = jsonObjectOrNull(resourceString);
  if (obj === null) {
    return null;
  }
  var resource = obj;
  return fromBackendResponse(service, bucket, resource);
}
var RequestInfo = function() {
  function RequestInfo2(url, method, handler, timeout) {
    this.url = url;
    this.method = method;
    this.handler = handler;
    this.timeout = timeout;
    this.urlParams = {};
    this.headers = {};
    this.body = null;
    this.errorHandler = null;
    this.progressCallback = null;
    this.successCodes = [200];
    this.additionalRetryCodes = [];
  }
  return RequestInfo2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function handlerCheck(cndn) {
  if (!cndn) {
    throw unknown();
  }
}
function metadataHandler(service, mappings) {
  function handler(xhr, text) {
    var metadata2 = fromResourceString(service, text, mappings);
    handlerCheck(metadata2 !== null);
    return metadata2;
  }
  return handler;
}
function listHandler(service, bucket) {
  function handler(xhr, text) {
    var listResult = fromResponseString(service, bucket, text);
    handlerCheck(listResult !== null);
    return listResult;
  }
  return handler;
}
function downloadUrlHandler(service, mappings) {
  function handler(xhr, text) {
    var metadata2 = fromResourceString(service, text, mappings);
    handlerCheck(metadata2 !== null);
    return downloadUrlFromResourceString(metadata2, text);
  }
  return handler;
}
function sharedErrorHandler(location2) {
  function errorHandler(xhr, err) {
    var newErr;
    if (xhr.getStatus() === 401) {
      newErr = unauthenticated();
    } else {
      if (xhr.getStatus() === 402) {
        newErr = quotaExceeded(location2.bucket);
      } else {
        if (xhr.getStatus() === 403) {
          newErr = unauthorized(location2.path);
        } else {
          newErr = err;
        }
      }
    }
    newErr.serverResponse = err.serverResponse;
    return newErr;
  }
  return errorHandler;
}
function objectErrorHandler(location2) {
  var shared = sharedErrorHandler(location2);
  function errorHandler(xhr, err) {
    var newErr = shared(xhr, err);
    if (xhr.getStatus() === 404) {
      newErr = objectNotFound(location2.path);
    }
    newErr.serverResponse = err.serverResponse;
    return newErr;
  }
  return errorHandler;
}
function getMetadata(service, location2, mappings) {
  var urlPart = location2.fullServerUrl();
  var url = makeUrl(urlPart);
  var method = "GET";
  var timeout = service.maxOperationRetryTime;
  var requestInfo = new RequestInfo(url, method, metadataHandler(service, mappings), timeout);
  requestInfo.errorHandler = objectErrorHandler(location2);
  return requestInfo;
}
function list(service, location2, delimiter, pageToken, maxResults) {
  var urlParams = {};
  if (location2.isRoot) {
    urlParams["prefix"] = "";
  } else {
    urlParams["prefix"] = location2.path + "/";
  }
  if (delimiter && delimiter.length > 0) {
    urlParams["delimiter"] = delimiter;
  }
  if (pageToken) {
    urlParams["pageToken"] = pageToken;
  }
  if (maxResults) {
    urlParams["maxResults"] = maxResults;
  }
  var urlPart = location2.bucketOnlyServerUrl();
  var url = makeUrl(urlPart);
  var method = "GET";
  var timeout = service.maxOperationRetryTime;
  var requestInfo = new RequestInfo(url, method, listHandler(service, location2.bucket), timeout);
  requestInfo.urlParams = urlParams;
  requestInfo.errorHandler = sharedErrorHandler(location2);
  return requestInfo;
}
function getDownloadUrl(service, location2, mappings) {
  var urlPart = location2.fullServerUrl();
  var url = makeUrl(urlPart);
  var method = "GET";
  var timeout = service.maxOperationRetryTime;
  var requestInfo = new RequestInfo(url, method, downloadUrlHandler(service, mappings), timeout);
  requestInfo.errorHandler = objectErrorHandler(location2);
  return requestInfo;
}
function updateMetadata(service, location2, metadata2, mappings) {
  var urlPart = location2.fullServerUrl();
  var url = makeUrl(urlPart);
  var method = "PATCH";
  var body = toResourceString(metadata2, mappings);
  var headers = { "Content-Type": "application/json; charset=utf-8" };
  var timeout = service.maxOperationRetryTime;
  var requestInfo = new RequestInfo(url, method, metadataHandler(service, mappings), timeout);
  requestInfo.headers = headers;
  requestInfo.body = body;
  requestInfo.errorHandler = objectErrorHandler(location2);
  return requestInfo;
}
function deleteObject(service, location2) {
  var urlPart = location2.fullServerUrl();
  var url = makeUrl(urlPart);
  var method = "DELETE";
  var timeout = service.maxOperationRetryTime;
  function handler(_xhr, _text) {
  }
  var requestInfo = new RequestInfo(url, method, handler, timeout);
  requestInfo.successCodes = [200, 204];
  requestInfo.errorHandler = objectErrorHandler(location2);
  return requestInfo;
}
function determineContentType_(metadata2, blob) {
  return metadata2 && metadata2["contentType"] || blob && blob.type() || "application/octet-stream";
}
function metadataForUpload_(location2, blob, metadata2) {
  var metadataClone = Object.assign({}, metadata2);
  metadataClone["fullPath"] = location2.path;
  metadataClone["size"] = blob.size();
  if (!metadataClone["contentType"]) {
    metadataClone["contentType"] = determineContentType_(null, blob);
  }
  return metadataClone;
}
function multipartUpload(service, location2, mappings, blob, metadata2) {
  var urlPart = location2.bucketOnlyServerUrl();
  var headers = {
    "X-Goog-Upload-Protocol": "multipart"
  };
  function genBoundary() {
    var str = "";
    for (var i = 0; i < 2; i++) {
      str = str + Math.random().toString().slice(2);
    }
    return str;
  }
  var boundary = genBoundary();
  headers["Content-Type"] = "multipart/related; boundary=" + boundary;
  var metadata_ = metadataForUpload_(location2, blob, metadata2);
  var metadataString = toResourceString(metadata_, mappings);
  var preBlobPart = "--" + boundary + "\r\nContent-Type: application/json; charset=utf-8\r\n\r\n" + metadataString + "\r\n--" + boundary + "\r\nContent-Type: " + metadata_["contentType"] + "\r\n\r\n";
  var postBlobPart = "\r\n--" + boundary + "--";
  var body = FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
  if (body === null) {
    throw cannotSliceBlob();
  }
  var urlParams = { name: metadata_["fullPath"] };
  var url = makeUrl(urlPart);
  var method = "POST";
  var timeout = service.maxUploadRetryTime;
  var requestInfo = new RequestInfo(url, method, metadataHandler(service, mappings), timeout);
  requestInfo.urlParams = urlParams;
  requestInfo.headers = headers;
  requestInfo.body = body.uploadData();
  requestInfo.errorHandler = sharedErrorHandler(location2);
  return requestInfo;
}
var ResumableUploadStatus = function() {
  function ResumableUploadStatus2(current, total, finalized, metadata2) {
    this.current = current;
    this.total = total;
    this.finalized = !!finalized;
    this.metadata = metadata2 || null;
  }
  return ResumableUploadStatus2;
}();
function checkResumeHeader_(xhr, allowed) {
  var status = null;
  try {
    status = xhr.getResponseHeader("X-Goog-Upload-Status");
  } catch (e28) {
    handlerCheck(false);
  }
  var allowedStatus = allowed || ["active"];
  handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
  return status;
}
function createResumableUpload(service, location2, mappings, blob, metadata2) {
  var urlPart = location2.bucketOnlyServerUrl();
  var metadataForUpload = metadataForUpload_(location2, blob, metadata2);
  var urlParams = { name: metadataForUpload["fullPath"] };
  var url = makeUrl(urlPart);
  var method = "POST";
  var headers = {
    "X-Goog-Upload-Protocol": "resumable",
    "X-Goog-Upload-Command": "start",
    "X-Goog-Upload-Header-Content-Length": blob.size(),
    "X-Goog-Upload-Header-Content-Type": metadataForUpload["contentType"],
    "Content-Type": "application/json; charset=utf-8"
  };
  var body = toResourceString(metadataForUpload, mappings);
  var timeout = service.maxUploadRetryTime;
  function handler(xhr) {
    checkResumeHeader_(xhr);
    var url2;
    try {
      url2 = xhr.getResponseHeader("X-Goog-Upload-URL");
    } catch (e28) {
      handlerCheck(false);
    }
    handlerCheck(isString$1(url2));
    return url2;
  }
  var requestInfo = new RequestInfo(url, method, handler, timeout);
  requestInfo.urlParams = urlParams;
  requestInfo.headers = headers;
  requestInfo.body = body;
  requestInfo.errorHandler = sharedErrorHandler(location2);
  return requestInfo;
}
function getResumableUploadStatus(service, location2, url, blob) {
  var headers = { "X-Goog-Upload-Command": "query" };
  function handler(xhr) {
    var status = checkResumeHeader_(xhr, ["active", "final"]);
    var sizeString = null;
    try {
      sizeString = xhr.getResponseHeader("X-Goog-Upload-Size-Received");
    } catch (e28) {
      handlerCheck(false);
    }
    if (!sizeString) {
      handlerCheck(false);
    }
    var size = Number(sizeString);
    handlerCheck(!isNaN(size));
    return new ResumableUploadStatus(size, blob.size(), status === "final");
  }
  var method = "POST";
  var timeout = service.maxUploadRetryTime;
  var requestInfo = new RequestInfo(url, method, handler, timeout);
  requestInfo.headers = headers;
  requestInfo.errorHandler = sharedErrorHandler(location2);
  return requestInfo;
}
var resumableUploadChunkSize = 256 * 1024;
function continueResumableUpload(location2, service, url, blob, chunkSize, mappings, status, progressCallback) {
  var status_ = new ResumableUploadStatus(0, 0);
  if (status) {
    status_.current = status.current;
    status_.total = status.total;
  } else {
    status_.current = 0;
    status_.total = blob.size();
  }
  if (blob.size() !== status_.total) {
    throw serverFileWrongSize();
  }
  var bytesLeft = status_.total - status_.current;
  var bytesToUpload = bytesLeft;
  if (chunkSize > 0) {
    bytesToUpload = Math.min(bytesToUpload, chunkSize);
  }
  var startByte = status_.current;
  var endByte = startByte + bytesToUpload;
  var uploadCommand = bytesToUpload === bytesLeft ? "upload, finalize" : "upload";
  var headers = {
    "X-Goog-Upload-Command": uploadCommand,
    "X-Goog-Upload-Offset": status_.current
  };
  var body = blob.slice(startByte, endByte);
  if (body === null) {
    throw cannotSliceBlob();
  }
  function handler(xhr, text) {
    var uploadStatus = checkResumeHeader_(xhr, ["active", "final"]);
    var newCurrent = status_.current + bytesToUpload;
    var size = blob.size();
    var metadata2;
    if (uploadStatus === "final") {
      metadata2 = metadataHandler(service, mappings)(xhr, text);
    } else {
      metadata2 = null;
    }
    return new ResumableUploadStatus(newCurrent, size, uploadStatus === "final", metadata2);
  }
  var method = "POST";
  var timeout = service.maxUploadRetryTime;
  var requestInfo = new RequestInfo(url, method, handler, timeout);
  requestInfo.headers = headers;
  requestInfo.body = body.uploadData();
  requestInfo.progressCallback = progressCallback || null;
  requestInfo.errorHandler = sharedErrorHandler(location2);
  return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Observer = function() {
  function Observer2(nextOrObserver, error2, complete) {
    var asFunctions = isFunction$2(nextOrObserver) || error2 != null || complete != null;
    if (asFunctions) {
      this.next = nextOrObserver;
      this.error = error2;
      this.complete = complete;
    } else {
      var observer = nextOrObserver;
      this.next = observer.next;
      this.error = observer.error;
      this.complete = observer.complete;
    }
  }
  return Observer2;
}();
var UploadTaskSnapshot = function() {
  function UploadTaskSnapshot2(bytesTransferred, totalBytes, state, metadata2, task, ref2) {
    this.bytesTransferred = bytesTransferred;
    this.totalBytes = totalBytes;
    this.state = state;
    this.metadata = metadata2;
    this.task = task;
    this.ref = ref2;
  }
  return UploadTaskSnapshot2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function async(f3) {
  return function() {
    var argsToForward = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      argsToForward[_i2] = arguments[_i2];
    }
    Promise.resolve().then(function() {
      return f3.apply(void 0, argsToForward);
    });
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var UploadTask = function() {
  function UploadTask2(ref2, blob, metadata2) {
    var _this = this;
    if (metadata2 === void 0) {
      metadata2 = null;
    }
    this._transferred = 0;
    this._needToFetchStatus = false;
    this._needToFetchMetadata = false;
    this._observers = [];
    this._error = void 0;
    this._uploadUrl = void 0;
    this._request = void 0;
    this._chunkMultiplier = 1;
    this._resolve = void 0;
    this._reject = void 0;
    this._ref = ref2;
    this._blob = blob;
    this._metadata = metadata2;
    this._mappings = getMappings();
    this._resumable = this._shouldDoResumable(this._blob);
    this._state = InternalTaskState.RUNNING;
    this._errorHandler = function(error2) {
      _this._request = void 0;
      _this._chunkMultiplier = 1;
      if (error2.codeEquals(Code.CANCELED)) {
        _this._needToFetchStatus = true;
        _this.completeTransitions_();
      } else {
        _this._error = error2;
        _this._transition(InternalTaskState.ERROR);
      }
    };
    this._metadataErrorHandler = function(error2) {
      _this._request = void 0;
      if (error2.codeEquals(Code.CANCELED)) {
        _this.completeTransitions_();
      } else {
        _this._error = error2;
        _this._transition(InternalTaskState.ERROR);
      }
    };
    this._promise = new Promise(function(resolve, reject) {
      _this._resolve = resolve;
      _this._reject = reject;
      _this._start();
    });
    this._promise.then(null, function() {
    });
  }
  UploadTask2.prototype._makeProgressCallback = function() {
    var _this = this;
    var sizeBefore = this._transferred;
    return function(loaded) {
      return _this._updateProgress(sizeBefore + loaded);
    };
  };
  UploadTask2.prototype._shouldDoResumable = function(blob) {
    return blob.size() > 256 * 1024;
  };
  UploadTask2.prototype._start = function() {
    if (this._state !== InternalTaskState.RUNNING) {
      return;
    }
    if (this._request !== void 0) {
      return;
    }
    if (this._resumable) {
      if (this._uploadUrl === void 0) {
        this._createResumable();
      } else {
        if (this._needToFetchStatus) {
          this._fetchStatus();
        } else {
          if (this._needToFetchMetadata) {
            this._fetchMetadata();
          } else {
            this._continueUpload();
          }
        }
      }
    } else {
      this._oneShotUpload();
    }
  };
  UploadTask2.prototype._resolveToken = function(callback) {
    var _this = this;
    this._ref.storage.getAuthToken().then(function(authToken) {
      switch (_this._state) {
        case InternalTaskState.RUNNING:
          callback(authToken);
          break;
        case InternalTaskState.CANCELING:
          _this._transition(InternalTaskState.CANCELED);
          break;
        case InternalTaskState.PAUSING:
          _this._transition(InternalTaskState.PAUSED);
          break;
      }
    });
  };
  UploadTask2.prototype._createResumable = function() {
    var _this = this;
    this._resolveToken(function(authToken) {
      var requestInfo = createResumableUpload(_this._ref.storage, _this._ref._location, _this._mappings, _this._blob, _this._metadata);
      var createRequest = _this._ref.storage.makeRequest(requestInfo, authToken);
      _this._request = createRequest;
      createRequest.getPromise().then(function(url) {
        _this._request = void 0;
        _this._uploadUrl = url;
        _this._needToFetchStatus = false;
        _this.completeTransitions_();
      }, _this._errorHandler);
    });
  };
  UploadTask2.prototype._fetchStatus = function() {
    var _this = this;
    var url = this._uploadUrl;
    this._resolveToken(function(authToken) {
      var requestInfo = getResumableUploadStatus(_this._ref.storage, _this._ref._location, url, _this._blob);
      var statusRequest = _this._ref.storage.makeRequest(requestInfo, authToken);
      _this._request = statusRequest;
      statusRequest.getPromise().then(function(status) {
        status = status;
        _this._request = void 0;
        _this._updateProgress(status.current);
        _this._needToFetchStatus = false;
        if (status.finalized) {
          _this._needToFetchMetadata = true;
        }
        _this.completeTransitions_();
      }, _this._errorHandler);
    });
  };
  UploadTask2.prototype._continueUpload = function() {
    var _this = this;
    var chunkSize = resumableUploadChunkSize * this._chunkMultiplier;
    var status = new ResumableUploadStatus(this._transferred, this._blob.size());
    var url = this._uploadUrl;
    this._resolveToken(function(authToken) {
      var requestInfo;
      try {
        requestInfo = continueResumableUpload(_this._ref._location, _this._ref.storage, url, _this._blob, chunkSize, _this._mappings, status, _this._makeProgressCallback());
      } catch (e28) {
        _this._error = e28;
        _this._transition(InternalTaskState.ERROR);
        return;
      }
      var uploadRequest = _this._ref.storage.makeRequest(requestInfo, authToken);
      _this._request = uploadRequest;
      uploadRequest.getPromise().then(function(newStatus) {
        _this._increaseMultiplier();
        _this._request = void 0;
        _this._updateProgress(newStatus.current);
        if (newStatus.finalized) {
          _this._metadata = newStatus.metadata;
          _this._transition(InternalTaskState.SUCCESS);
        } else {
          _this.completeTransitions_();
        }
      }, _this._errorHandler);
    });
  };
  UploadTask2.prototype._increaseMultiplier = function() {
    var currentSize = resumableUploadChunkSize * this._chunkMultiplier;
    if (currentSize < 32 * 1024 * 1024) {
      this._chunkMultiplier *= 2;
    }
  };
  UploadTask2.prototype._fetchMetadata = function() {
    var _this = this;
    this._resolveToken(function(authToken) {
      var requestInfo = getMetadata(_this._ref.storage, _this._ref._location, _this._mappings);
      var metadataRequest = _this._ref.storage.makeRequest(requestInfo, authToken);
      _this._request = metadataRequest;
      metadataRequest.getPromise().then(function(metadata2) {
        _this._request = void 0;
        _this._metadata = metadata2;
        _this._transition(InternalTaskState.SUCCESS);
      }, _this._metadataErrorHandler);
    });
  };
  UploadTask2.prototype._oneShotUpload = function() {
    var _this = this;
    this._resolveToken(function(authToken) {
      var requestInfo = multipartUpload(_this._ref.storage, _this._ref._location, _this._mappings, _this._blob, _this._metadata);
      var multipartRequest = _this._ref.storage.makeRequest(requestInfo, authToken);
      _this._request = multipartRequest;
      multipartRequest.getPromise().then(function(metadata2) {
        _this._request = void 0;
        _this._metadata = metadata2;
        _this._updateProgress(_this._blob.size());
        _this._transition(InternalTaskState.SUCCESS);
      }, _this._errorHandler);
    });
  };
  UploadTask2.prototype._updateProgress = function(transferred) {
    var old = this._transferred;
    this._transferred = transferred;
    if (this._transferred !== old) {
      this._notifyObservers();
    }
  };
  UploadTask2.prototype._transition = function(state) {
    if (this._state === state) {
      return;
    }
    switch (state) {
      case InternalTaskState.CANCELING:
        this._state = state;
        if (this._request !== void 0) {
          this._request.cancel();
        }
        break;
      case InternalTaskState.PAUSING:
        this._state = state;
        if (this._request !== void 0) {
          this._request.cancel();
        }
        break;
      case InternalTaskState.RUNNING:
        var wasPaused = this._state === InternalTaskState.PAUSED;
        this._state = state;
        if (wasPaused) {
          this._notifyObservers();
          this._start();
        }
        break;
      case InternalTaskState.PAUSED:
        this._state = state;
        this._notifyObservers();
        break;
      case InternalTaskState.CANCELED:
        this._error = canceled();
        this._state = state;
        this._notifyObservers();
        break;
      case InternalTaskState.ERROR:
        this._state = state;
        this._notifyObservers();
        break;
      case InternalTaskState.SUCCESS:
        this._state = state;
        this._notifyObservers();
        break;
    }
  };
  UploadTask2.prototype.completeTransitions_ = function() {
    switch (this._state) {
      case InternalTaskState.PAUSING:
        this._transition(InternalTaskState.PAUSED);
        break;
      case InternalTaskState.CANCELING:
        this._transition(InternalTaskState.CANCELED);
        break;
      case InternalTaskState.RUNNING:
        this._start();
        break;
    }
  };
  Object.defineProperty(UploadTask2.prototype, "snapshot", {
    get: function() {
      var externalState = taskStateFromInternalTaskState(this._state);
      return new UploadTaskSnapshot(this._transferred, this._blob.size(), externalState, this._metadata, this, this._ref);
    },
    enumerable: false,
    configurable: true
  });
  UploadTask2.prototype.on = function(type, nextOrObserver, error2, completed) {
    var _this = this;
    var observer = new Observer(nextOrObserver, error2, completed);
    this._addObserver(observer);
    return function() {
      _this._removeObserver(observer);
    };
  };
  UploadTask2.prototype.then = function(onFulfilled, onRejected) {
    return this._promise.then(onFulfilled, onRejected);
  };
  UploadTask2.prototype.catch = function(onRejected) {
    return this.then(null, onRejected);
  };
  UploadTask2.prototype._addObserver = function(observer) {
    this._observers.push(observer);
    this._notifyObserver(observer);
  };
  UploadTask2.prototype._removeObserver = function(observer) {
    var i = this._observers.indexOf(observer);
    if (i !== -1) {
      this._observers.splice(i, 1);
    }
  };
  UploadTask2.prototype._notifyObservers = function() {
    var _this = this;
    this._finishPromise();
    var observers = this._observers.slice();
    observers.forEach(function(observer) {
      _this._notifyObserver(observer);
    });
  };
  UploadTask2.prototype._finishPromise = function() {
    if (this._resolve !== void 0) {
      var triggered = true;
      switch (taskStateFromInternalTaskState(this._state)) {
        case TaskState.SUCCESS:
          async(this._resolve.bind(null, this.snapshot))();
          break;
        case TaskState.CANCELED:
        case TaskState.ERROR:
          var toCall = this._reject;
          async(toCall.bind(null, this._error))();
          break;
        default:
          triggered = false;
          break;
      }
      if (triggered) {
        this._resolve = void 0;
        this._reject = void 0;
      }
    }
  };
  UploadTask2.prototype._notifyObserver = function(observer) {
    var externalState = taskStateFromInternalTaskState(this._state);
    switch (externalState) {
      case TaskState.RUNNING:
      case TaskState.PAUSED:
        if (observer.next) {
          async(observer.next.bind(observer, this.snapshot))();
        }
        break;
      case TaskState.SUCCESS:
        if (observer.complete) {
          async(observer.complete.bind(observer))();
        }
        break;
      case TaskState.CANCELED:
      case TaskState.ERROR:
        if (observer.error) {
          async(observer.error.bind(observer, this._error))();
        }
        break;
      default:
        if (observer.error) {
          async(observer.error.bind(observer, this._error))();
        }
    }
  };
  UploadTask2.prototype.resume = function() {
    var valid = this._state === InternalTaskState.PAUSED || this._state === InternalTaskState.PAUSING;
    if (valid) {
      this._transition(InternalTaskState.RUNNING);
    }
    return valid;
  };
  UploadTask2.prototype.pause = function() {
    var valid = this._state === InternalTaskState.RUNNING;
    if (valid) {
      this._transition(InternalTaskState.PAUSING);
    }
    return valid;
  };
  UploadTask2.prototype.cancel = function() {
    var valid = this._state === InternalTaskState.RUNNING || this._state === InternalTaskState.PAUSING;
    if (valid) {
      this._transition(InternalTaskState.CANCELING);
    }
    return valid;
  };
  return UploadTask2;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Reference$1 = function() {
  function Reference2(_service, location2) {
    this._service = _service;
    if (location2 instanceof Location) {
      this._location = location2;
    } else {
      this._location = Location.makeFromUrl(location2);
    }
  }
  Reference2.prototype.toString = function() {
    return "gs://" + this._location.bucket + "/" + this._location.path;
  };
  Reference2.prototype.newRef = function(service, location2) {
    return new Reference2(service, location2);
  };
  Object.defineProperty(Reference2.prototype, "root", {
    get: function() {
      var location2 = new Location(this._location.bucket, "");
      return this.newRef(this._service, location2);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Reference2.prototype, "bucket", {
    get: function() {
      return this._location.bucket;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Reference2.prototype, "fullPath", {
    get: function() {
      return this._location.path;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Reference2.prototype, "name", {
    get: function() {
      return lastComponent(this._location.path);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Reference2.prototype, "storage", {
    get: function() {
      return this._service;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Reference2.prototype, "parent", {
    get: function() {
      var newPath = parent(this._location.path);
      if (newPath === null) {
        return null;
      }
      var location2 = new Location(this._location.bucket, newPath);
      return new Reference2(this._service, location2);
    },
    enumerable: false,
    configurable: true
  });
  Reference2.prototype._throwIfRoot = function(name2) {
    if (this._location.path === "") {
      throw invalidRootOperation(name2);
    }
  };
  return Reference2;
}();
function uploadBytesResumable(ref2, data, metadata2) {
  if (metadata2 === void 0) {
    metadata2 = null;
  }
  ref2._throwIfRoot("uploadBytesResumable");
  return new UploadTask(ref2, new FbsBlob(data), metadata2);
}
function uploadString(ref2, value, format2, metadata2) {
  if (format2 === void 0) {
    format2 = StringFormat.RAW;
  }
  ref2._throwIfRoot("putString");
  var data = dataFromString(format2, value);
  var metadataClone = __assign({}, metadata2);
  if (metadataClone["contentType"] == null && data.contentType != null) {
    metadataClone["contentType"] = data.contentType;
  }
  return new UploadTask(ref2, new FbsBlob(data.data, true), metadataClone);
}
function listAll(ref2) {
  var accumulator = {
    prefixes: [],
    items: []
  };
  return listAllHelper(ref2, accumulator).then(function() {
    return accumulator;
  });
}
function listAllHelper(ref2, accumulator, pageToken) {
  return __awaiter(this, void 0, void 0, function() {
    var opt, nextPage;
    var _a2, _b2;
    return __generator(this, function(_c2) {
      switch (_c2.label) {
        case 0:
          opt = {
            pageToken
          };
          return [4, list$1(ref2, opt)];
        case 1:
          nextPage = _c2.sent();
          (_a2 = accumulator.prefixes).push.apply(_a2, nextPage.prefixes);
          (_b2 = accumulator.items).push.apply(_b2, nextPage.items);
          if (!(nextPage.nextPageToken != null))
            return [3, 3];
          return [4, listAllHelper(ref2, accumulator, nextPage.nextPageToken)];
        case 2:
          _c2.sent();
          _c2.label = 3;
        case 3:
          return [2];
      }
    });
  });
}
function list$1(ref2, options) {
  return __awaiter(this, void 0, void 0, function() {
    var authToken, op2, requestInfo;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (options != null) {
            if (typeof options.maxResults === "number") {
              validateNumber("options.maxResults", 1, 1e3, options.maxResults);
            }
          }
          return [4, ref2.storage.getAuthToken()];
        case 1:
          authToken = _a2.sent();
          op2 = options || {};
          requestInfo = list(ref2.storage, ref2._location, "/", op2.pageToken, op2.maxResults);
          return [2, ref2.storage.makeRequest(requestInfo, authToken).getPromise()];
      }
    });
  });
}
function getMetadata$1(ref2) {
  return __awaiter(this, void 0, void 0, function() {
    var authToken, requestInfo;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          ref2._throwIfRoot("getMetadata");
          return [4, ref2.storage.getAuthToken()];
        case 1:
          authToken = _a2.sent();
          requestInfo = getMetadata(ref2.storage, ref2._location, getMappings());
          return [2, ref2.storage.makeRequest(requestInfo, authToken).getPromise()];
      }
    });
  });
}
function updateMetadata$1(ref2, metadata2) {
  return __awaiter(this, void 0, void 0, function() {
    var authToken, requestInfo;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          ref2._throwIfRoot("updateMetadata");
          return [4, ref2.storage.getAuthToken()];
        case 1:
          authToken = _a2.sent();
          requestInfo = updateMetadata(ref2.storage, ref2._location, metadata2, getMappings());
          return [2, ref2.storage.makeRequest(requestInfo, authToken).getPromise()];
      }
    });
  });
}
function getDownloadURL(ref2) {
  return __awaiter(this, void 0, void 0, function() {
    var authToken, requestInfo;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          ref2._throwIfRoot("getDownloadURL");
          return [4, ref2.storage.getAuthToken()];
        case 1:
          authToken = _a2.sent();
          requestInfo = getDownloadUrl(ref2.storage, ref2._location, getMappings());
          return [2, ref2.storage.makeRequest(requestInfo, authToken).getPromise().then(function(url) {
            if (url === null) {
              throw noDownloadURL();
            }
            return url;
          })];
      }
    });
  });
}
function deleteObject$1(ref2) {
  return __awaiter(this, void 0, void 0, function() {
    var authToken, requestInfo;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          ref2._throwIfRoot("deleteObject");
          return [4, ref2.storage.getAuthToken()];
        case 1:
          authToken = _a2.sent();
          requestInfo = deleteObject(ref2.storage, ref2._location);
          return [2, ref2.storage.makeRequest(requestInfo, authToken).getPromise()];
      }
    });
  });
}
function getChild(ref2, childPath) {
  var newPath = child(ref2._location.path, childPath);
  var location2 = new Location(ref2._location.bucket, newPath);
  return new Reference$1(ref2.storage, location2);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var UploadTaskSnapshotCompat = function() {
  function UploadTaskSnapshotCompat2(_delegate, task, ref2) {
    this._delegate = _delegate;
    this.task = task;
    this.ref = ref2;
  }
  Object.defineProperty(UploadTaskSnapshotCompat2.prototype, "bytesTransferred", {
    get: function() {
      return this._delegate.bytesTransferred;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(UploadTaskSnapshotCompat2.prototype, "metadata", {
    get: function() {
      return this._delegate.metadata;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(UploadTaskSnapshotCompat2.prototype, "state", {
    get: function() {
      return this._delegate.state;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(UploadTaskSnapshotCompat2.prototype, "totalBytes", {
    get: function() {
      return this._delegate.totalBytes;
    },
    enumerable: false,
    configurable: true
  });
  return UploadTaskSnapshotCompat2;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var UploadTaskCompat = function() {
  function UploadTaskCompat2(_delegate, _ref) {
    this._delegate = _delegate;
    this._ref = _ref;
    this.cancel = this._delegate.cancel.bind(this._delegate);
    this.catch = this._delegate.catch.bind(this._delegate);
    this.pause = this._delegate.pause.bind(this._delegate);
    this.resume = this._delegate.resume.bind(this._delegate);
    this._snapshot = new UploadTaskSnapshotCompat(this._delegate.snapshot, this, this._ref);
  }
  Object.defineProperty(UploadTaskCompat2.prototype, "snapshot", {
    get: function() {
      return this._snapshot;
    },
    enumerable: false,
    configurable: true
  });
  UploadTaskCompat2.prototype.then = function(onFulfilled, onRejected) {
    var _this = this;
    return this._delegate.then(function(snapshot) {
      if (onFulfilled) {
        return onFulfilled(new UploadTaskSnapshotCompat(snapshot, _this, _this._ref));
      }
    }, onRejected);
  };
  UploadTaskCompat2.prototype.on = function(type, nextOrObserver, error2, completed) {
    var _this = this;
    var wrappedNextOrObserver = void 0;
    if (!!nextOrObserver) {
      if (typeof nextOrObserver === "function") {
        wrappedNextOrObserver = function(taskSnapshot) {
          return nextOrObserver(new UploadTaskSnapshotCompat(taskSnapshot, _this, _this._ref));
        };
      } else {
        wrappedNextOrObserver = {
          next: !!nextOrObserver.next ? function(taskSnapshot) {
            return nextOrObserver.next(new UploadTaskSnapshotCompat(taskSnapshot, _this, _this._ref));
          } : void 0,
          complete: nextOrObserver.complete || void 0,
          error: nextOrObserver.error || void 0
        };
      }
    }
    return this._delegate.on(type, wrappedNextOrObserver, error2 || void 0, completed || void 0);
  };
  return UploadTaskCompat2;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ListResultCompat = function() {
  function ListResultCompat2(_delegate, _service) {
    this._delegate = _delegate;
    this._service = _service;
  }
  Object.defineProperty(ListResultCompat2.prototype, "prefixes", {
    get: function() {
      var _this = this;
      return this._delegate.prefixes.map(function(ref2) {
        return new ReferenceCompat(ref2, _this._service);
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ListResultCompat2.prototype, "items", {
    get: function() {
      var _this = this;
      return this._delegate.items.map(function(ref2) {
        return new ReferenceCompat(ref2, _this._service);
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ListResultCompat2.prototype, "nextPageToken", {
    get: function() {
      return this._delegate.nextPageToken || null;
    },
    enumerable: false,
    configurable: true
  });
  return ListResultCompat2;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ReferenceCompat = function() {
  function ReferenceCompat2(_delegate, storage) {
    this._delegate = _delegate;
    this.storage = storage;
  }
  Object.defineProperty(ReferenceCompat2.prototype, "name", {
    get: function() {
      return this._delegate.name;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ReferenceCompat2.prototype, "bucket", {
    get: function() {
      return this._delegate.bucket;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ReferenceCompat2.prototype, "fullPath", {
    get: function() {
      return this._delegate.fullPath;
    },
    enumerable: false,
    configurable: true
  });
  ReferenceCompat2.prototype.toString = function() {
    return this._delegate.toString();
  };
  ReferenceCompat2.prototype.child = function(childPath) {
    var reference = getChild(this._delegate, childPath);
    return new ReferenceCompat2(reference, this.storage);
  };
  Object.defineProperty(ReferenceCompat2.prototype, "root", {
    get: function() {
      return new ReferenceCompat2(this._delegate.root, this.storage);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ReferenceCompat2.prototype, "parent", {
    get: function() {
      var reference = this._delegate.parent;
      if (reference == null) {
        return null;
      }
      return new ReferenceCompat2(reference, this.storage);
    },
    enumerable: false,
    configurable: true
  });
  ReferenceCompat2.prototype.put = function(data, metadata2) {
    this._throwIfRoot("put");
    return new UploadTaskCompat(uploadBytesResumable(this._delegate, data, metadata2), this);
  };
  ReferenceCompat2.prototype.putString = function(value, format2, metadata2) {
    if (format2 === void 0) {
      format2 = StringFormat.RAW;
    }
    this._throwIfRoot("putString");
    return new UploadTaskCompat(uploadString(this._delegate, value, format2, metadata2), this);
  };
  ReferenceCompat2.prototype.listAll = function() {
    var _this = this;
    return listAll(this._delegate).then(function(r3) {
      return new ListResultCompat(r3, _this.storage);
    });
  };
  ReferenceCompat2.prototype.list = function(options) {
    var _this = this;
    return list$1(this._delegate, options).then(function(r3) {
      return new ListResultCompat(r3, _this.storage);
    });
  };
  ReferenceCompat2.prototype.getMetadata = function() {
    return getMetadata$1(this._delegate);
  };
  ReferenceCompat2.prototype.updateMetadata = function(metadata2) {
    return updateMetadata$1(this._delegate, metadata2);
  };
  ReferenceCompat2.prototype.getDownloadURL = function() {
    return getDownloadURL(this._delegate);
  };
  ReferenceCompat2.prototype.delete = function() {
    this._throwIfRoot("delete");
    return deleteObject$1(this._delegate);
  };
  ReferenceCompat2.prototype._throwIfRoot = function(name2) {
    if (this._delegate._location.path === "") {
      throw invalidRootOperation(name2);
    }
  };
  return ReferenceCompat2;
}();
var FailRequest = function() {
  function FailRequest2(error2) {
    this.promise_ = Promise.reject(error2);
  }
  FailRequest2.prototype.getPromise = function() {
    return this.promise_;
  };
  FailRequest2.prototype.cancel = function(_appDelete) {
  };
  return FailRequest2;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function start(f3, callback, timeout) {
  var waitSeconds = 1;
  var timeoutId = null;
  var hitTimeout = false;
  var cancelState = 0;
  function canceled2() {
    return cancelState === 2;
  }
  var triggeredCallback = false;
  function triggerCallback() {
    var args = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      args[_i2] = arguments[_i2];
    }
    if (!triggeredCallback) {
      triggeredCallback = true;
      callback.apply(null, args);
    }
  }
  function callWithDelay(millis) {
    timeoutId = setTimeout(function() {
      timeoutId = null;
      f3(handler, canceled2());
    }, millis);
  }
  function handler(success) {
    var args = [];
    for (var _i2 = 1; _i2 < arguments.length; _i2++) {
      args[_i2 - 1] = arguments[_i2];
    }
    if (triggeredCallback) {
      return;
    }
    if (success) {
      triggerCallback.call.apply(triggerCallback, __spreadArrays$1([null, success], args));
      return;
    }
    var mustStop = canceled2() || hitTimeout;
    if (mustStop) {
      triggerCallback.call.apply(triggerCallback, __spreadArrays$1([null, success], args));
      return;
    }
    if (waitSeconds < 64) {
      waitSeconds *= 2;
    }
    var waitMillis;
    if (cancelState === 1) {
      cancelState = 2;
      waitMillis = 0;
    } else {
      waitMillis = (waitSeconds + Math.random()) * 1e3;
    }
    callWithDelay(waitMillis);
  }
  var stopped = false;
  function stop2(wasTimeout) {
    if (stopped) {
      return;
    }
    stopped = true;
    if (triggeredCallback) {
      return;
    }
    if (timeoutId !== null) {
      if (!wasTimeout) {
        cancelState = 2;
      }
      clearTimeout(timeoutId);
      callWithDelay(0);
    } else {
      if (!wasTimeout) {
        cancelState = 1;
      }
    }
  }
  callWithDelay(0);
  setTimeout(function() {
    hitTimeout = true;
    stop2(true);
  }, timeout);
  return stop2;
}
function stop(id2) {
  id2(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var NetworkRequest = function() {
  function NetworkRequest2(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
    var _this = this;
    this.pendingXhr_ = null;
    this.backoffId_ = null;
    this.canceled_ = false;
    this.appDelete_ = false;
    this.url_ = url;
    this.method_ = method;
    this.headers_ = headers;
    this.body_ = body;
    this.successCodes_ = successCodes.slice();
    this.additionalRetryCodes_ = additionalRetryCodes.slice();
    this.callback_ = callback;
    this.errorCallback_ = errorCallback;
    this.progressCallback_ = progressCallback;
    this.timeout_ = timeout;
    this.pool_ = pool;
    this.promise_ = new Promise(function(resolve, reject) {
      _this.resolve_ = resolve;
      _this.reject_ = reject;
      _this.start_();
    });
  }
  NetworkRequest2.prototype.start_ = function() {
    var self2 = this;
    function doTheRequest(backoffCallback, canceled2) {
      if (canceled2) {
        backoffCallback(false, new RequestEndStatus(false, null, true));
        return;
      }
      var xhr = self2.pool_.createXhrIo();
      self2.pendingXhr_ = xhr;
      function progressListener(progressEvent) {
        var loaded = progressEvent.loaded;
        var total = progressEvent.lengthComputable ? progressEvent.total : -1;
        if (self2.progressCallback_ !== null) {
          self2.progressCallback_(loaded, total);
        }
      }
      if (self2.progressCallback_ !== null) {
        xhr.addUploadProgressListener(progressListener);
      }
      xhr.send(self2.url_, self2.method_, self2.body_, self2.headers_).then(function(xhr2) {
        if (self2.progressCallback_ !== null) {
          xhr2.removeUploadProgressListener(progressListener);
        }
        self2.pendingXhr_ = null;
        xhr2 = xhr2;
        var hitServer = xhr2.getErrorCode() === ErrorCode.NO_ERROR;
        var status = xhr2.getStatus();
        if (!hitServer || self2.isRetryStatusCode_(status)) {
          var wasCanceled = xhr2.getErrorCode() === ErrorCode.ABORT;
          backoffCallback(false, new RequestEndStatus(false, null, wasCanceled));
          return;
        }
        var successCode = self2.successCodes_.indexOf(status) !== -1;
        backoffCallback(true, new RequestEndStatus(successCode, xhr2));
      });
    }
    function backoffDone(requestWentThrough, status) {
      var resolve = self2.resolve_;
      var reject = self2.reject_;
      var xhr = status.xhr;
      if (status.wasSuccessCode) {
        try {
          var result2 = self2.callback_(xhr, xhr.getResponseText());
          if (isJustDef(result2)) {
            resolve(result2);
          } else {
            resolve();
          }
        } catch (e28) {
          reject(e28);
        }
      } else {
        if (xhr !== null) {
          var err = unknown();
          err.serverResponse = xhr.getResponseText();
          if (self2.errorCallback_) {
            reject(self2.errorCallback_(xhr, err));
          } else {
            reject(err);
          }
        } else {
          if (status.canceled) {
            var err = self2.appDelete_ ? appDeleted() : canceled();
            reject(err);
          } else {
            var err = retryLimitExceeded();
            reject(err);
          }
        }
      }
    }
    if (this.canceled_) {
      backoffDone(false, new RequestEndStatus(false, null, true));
    } else {
      this.backoffId_ = start(doTheRequest, backoffDone, this.timeout_);
    }
  };
  NetworkRequest2.prototype.getPromise = function() {
    return this.promise_;
  };
  NetworkRequest2.prototype.cancel = function(appDelete) {
    this.canceled_ = true;
    this.appDelete_ = appDelete || false;
    if (this.backoffId_ !== null) {
      stop(this.backoffId_);
    }
    if (this.pendingXhr_ !== null) {
      this.pendingXhr_.abort();
    }
  };
  NetworkRequest2.prototype.isRetryStatusCode_ = function(status) {
    var isFiveHundredCode = status >= 500 && status < 600;
    var extraRetryCodes = [
      408,
      429
    ];
    var isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
    var isRequestSpecificRetryCode = this.additionalRetryCodes_.indexOf(status) !== -1;
    return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
  };
  return NetworkRequest2;
}();
var RequestEndStatus = function() {
  function RequestEndStatus2(wasSuccessCode, xhr, canceled2) {
    this.wasSuccessCode = wasSuccessCode;
    this.xhr = xhr;
    this.canceled = !!canceled2;
  }
  return RequestEndStatus2;
}();
function addAuthHeader_(headers, authToken) {
  if (authToken !== null && authToken.length > 0) {
    headers["Authorization"] = "Firebase " + authToken;
  }
}
function addVersionHeader_(headers) {
  var version2 = typeof firebase$1 !== "undefined" ? firebase$1.SDK_VERSION : "AppManager";
  headers["X-Firebase-Storage-Version"] = "webjs/" + version2;
}
function addGmpidHeader_(headers, appId) {
  if (appId) {
    headers["X-Firebase-GMPID"] = appId;
  }
}
function makeRequest(requestInfo, appId, authToken, pool) {
  var queryPart = makeQueryString(requestInfo.urlParams);
  var url = requestInfo.url + queryPart;
  var headers = Object.assign({}, requestInfo.headers);
  addGmpidHeader_(headers, appId);
  addAuthHeader_(headers, authToken);
  addVersionHeader_(headers);
  return new NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isUrl(path) {
  return /^[A-Za-z]+:\/\//.test(path);
}
function refFromURL(service, url) {
  return new Reference$1(service, url);
}
function refFromPath(ref2, path) {
  if (ref2 instanceof StorageService) {
    var service = ref2;
    if (service._bucket == null) {
      throw noDefaultBucket();
    }
    var reference = new Reference$1(service, service._bucket);
    if (path != null) {
      return refFromPath(reference, path);
    } else {
      return reference;
    }
  } else {
    if (path !== void 0) {
      if (path.includes("..")) {
        throw invalidArgument('`path` param cannot contain ".."');
      }
      return getChild(ref2, path);
    } else {
      return ref2;
    }
  }
}
function ref(serviceOrRef, pathOrUrl) {
  if (pathOrUrl && isUrl(pathOrUrl)) {
    if (serviceOrRef instanceof StorageService) {
      return refFromURL(serviceOrRef, pathOrUrl);
    } else {
      throw invalidArgument("To use ref(service, url), the first argument must be a Storage instance.");
    }
  } else {
    return refFromPath(serviceOrRef, pathOrUrl);
  }
}
function extractBucket(config) {
  var bucketString = config === null || config === void 0 ? void 0 : config[CONFIG_STORAGE_BUCKET_KEY];
  if (bucketString == null) {
    return null;
  }
  return Location.makeFromBucketSpec(bucketString);
}
var StorageService = function() {
  function StorageService2(app, _authProvider, _pool, _url) {
    this.app = app;
    this._authProvider = _authProvider;
    this._pool = _pool;
    this._url = _url;
    this._bucket = null;
    this._appId = null;
    this._deleted = false;
    this._maxOperationRetryTime = DEFAULT_MAX_OPERATION_RETRY_TIME;
    this._maxUploadRetryTime = DEFAULT_MAX_UPLOAD_RETRY_TIME;
    this._requests = new Set();
    if (_url != null) {
      this._bucket = Location.makeFromBucketSpec(_url);
    } else {
      this._bucket = extractBucket(this.app.options);
    }
  }
  Object.defineProperty(StorageService2.prototype, "maxUploadRetryTime", {
    get: function() {
      return this._maxUploadRetryTime;
    },
    set: function(time) {
      validateNumber("time", 0, Number.POSITIVE_INFINITY, time);
      this._maxUploadRetryTime = time;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StorageService2.prototype, "maxOperationRetryTime", {
    get: function() {
      return this._maxOperationRetryTime;
    },
    set: function(time) {
      validateNumber("time", 0, Number.POSITIVE_INFINITY, time);
      this._maxOperationRetryTime = time;
    },
    enumerable: false,
    configurable: true
  });
  StorageService2.prototype.getAuthToken = function() {
    return __awaiter(this, void 0, void 0, function() {
      var auth, tokenData;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            auth = this._authProvider.getImmediate({ optional: true });
            if (!auth)
              return [3, 2];
            return [4, auth.getToken()];
          case 1:
            tokenData = _a2.sent();
            if (tokenData !== null) {
              return [2, tokenData.accessToken];
            }
            _a2.label = 2;
          case 2:
            return [2, null];
        }
      });
    });
  };
  StorageService2.prototype._delete = function() {
    this._deleted = true;
    this._requests.forEach(function(request) {
      return request.cancel();
    });
    this._requests.clear();
    return Promise.resolve();
  };
  StorageService2.prototype.makeStorageReference = function(loc) {
    return new Reference$1(this, loc);
  };
  StorageService2.prototype.makeRequest = function(requestInfo, authToken) {
    var _this = this;
    if (!this._deleted) {
      var request_1 = makeRequest(requestInfo, this._appId, authToken, this._pool);
      this._requests.add(request_1);
      request_1.getPromise().then(function() {
        return _this._requests.delete(request_1);
      }, function() {
        return _this._requests.delete(request_1);
      });
      return request_1;
    } else {
      return new FailRequest(appDeleted());
    }
  };
  return StorageService2;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StorageServiceCompat = function() {
  function StorageServiceCompat2(app, _delegate) {
    var _this = this;
    this.app = app;
    this._delegate = _delegate;
    this.INTERNAL = {
      delete: function() {
        return _this._delegate._delete();
      }
    };
  }
  Object.defineProperty(StorageServiceCompat2.prototype, "maxOperationRetryTime", {
    get: function() {
      return this._delegate.maxOperationRetryTime;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StorageServiceCompat2.prototype, "maxUploadRetryTime", {
    get: function() {
      return this._delegate.maxUploadRetryTime;
    },
    enumerable: false,
    configurable: true
  });
  StorageServiceCompat2.prototype.ref = function(path) {
    if (isUrl(path)) {
      throw invalidArgument("ref() expected a child path but got a URL, use refFromURL instead.");
    }
    return new ReferenceCompat(ref(this._delegate, path), this);
  };
  StorageServiceCompat2.prototype.refFromURL = function(url) {
    if (!isUrl(url)) {
      throw invalidArgument("refFromURL() expected a full URL but got a child path, use ref() instead.");
    }
    try {
      Location.makeFromUrl(url);
    } catch (e28) {
      throw invalidArgument("refFromUrl() expected a valid full URL but got an invalid one.");
    }
    return new ReferenceCompat(ref(this._delegate, url), this);
  };
  StorageServiceCompat2.prototype.setMaxUploadRetryTime = function(time) {
    this._delegate.maxUploadRetryTime = time;
  };
  StorageServiceCompat2.prototype.setMaxOperationRetryTime = function(time) {
    this._delegate.maxOperationRetryTime = time;
  };
  return StorageServiceCompat2;
}();
var name$5 = "@firebase/storage";
var version$5 = "0.4.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var STORAGE_TYPE = "storage";
function factory$1(container, url) {
  var app = container.getProvider("app").getImmediate();
  var authProvider = container.getProvider("auth-internal");
  var storageServiceCompat = new StorageServiceCompat(app, new StorageService(app, authProvider, new XhrIoPool(), url));
  return storageServiceCompat;
}
function registerStorage(instance) {
  var namespaceExports = {
    TaskState,
    TaskEvent,
    StringFormat,
    Storage: StorageService,
    Reference: ReferenceCompat
  };
  instance.INTERNAL.registerComponent(new Component(STORAGE_TYPE, factory$1, "PUBLIC").setServiceProps(namespaceExports).setMultipleInstances(true));
  instance.registerVersion(name$5, version$5);
}
registerStorage(firebase$1);
var name$4 = "@firebase/performance";
var version$4 = "0.4.5";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SDK_VERSION = version$4;
var TRACE_START_MARK_PREFIX = "FB-PERF-TRACE-START";
var TRACE_STOP_MARK_PREFIX = "FB-PERF-TRACE-STOP";
var TRACE_MEASURE_PREFIX = "FB-PERF-TRACE-MEASURE";
var OOB_TRACE_PAGE_LOAD_PREFIX = "_wt_";
var FIRST_PAINT_COUNTER_NAME = "_fp";
var FIRST_CONTENTFUL_PAINT_COUNTER_NAME = "_fcp";
var FIRST_INPUT_DELAY_COUNTER_NAME = "_fid";
var CONFIG_LOCAL_STORAGE_KEY = "@firebase/performance/config";
var CONFIG_EXPIRY_LOCAL_STORAGE_KEY = "@firebase/performance/configexpire";
var SERVICE = "performance";
var SERVICE_NAME = "Performance";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a$2;
var ERROR_DESCRIPTION_MAP$1 = (_a$2 = {}, _a$2["trace started"] = "Trace {$traceName} was started before.", _a$2["trace stopped"] = "Trace {$traceName} is not running.", _a$2["nonpositive trace startTime"] = "Trace {$traceName} startTime should be positive.", _a$2["nonpositive trace duration"] = "Trace {$traceName} duration should be positive.", _a$2["no window"] = "Window is not available.", _a$2["no app id"] = "App id is not available.", _a$2["no project id"] = "Project id is not available.", _a$2["no api key"] = "Api key is not available.", _a$2["invalid cc log"] = "Attempted to queue invalid cc event", _a$2["FB not default"] = "Performance can only start when Firebase app instance is the default one.", _a$2["RC response not ok"] = "RC response is not ok", _a$2["invalid attribute name"] = "Attribute name {$attributeName} is invalid.", _a$2["invalid attribute value"] = "Attribute value {$attributeValue} is invalid.", _a$2["invalid custom metric name"] = "Custom metric name {$customMetricName} is invalid", _a$2["invalid String merger input"] = "Input for String merger is invalid, contact support team to resolve.", _a$2);
var ERROR_FACTORY$2 = new ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP$1);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var consoleLogger = new Logger(SERVICE_NAME);
consoleLogger.logLevel = LogLevel.INFO;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var apiInstance;
var windowInstance;
var Api = function() {
  function Api2(window2) {
    this.window = window2;
    if (!window2) {
      throw ERROR_FACTORY$2.create("no window");
    }
    this.performance = window2.performance;
    this.PerformanceObserver = window2.PerformanceObserver;
    this.windowLocation = window2.location;
    this.navigator = window2.navigator;
    this.document = window2.document;
    if (this.navigator && this.navigator.cookieEnabled) {
      this.localStorage = window2.localStorage;
    }
    if (window2.perfMetrics && window2.perfMetrics.onFirstInputDelay) {
      this.onFirstInputDelay = window2.perfMetrics.onFirstInputDelay;
    }
  }
  Api2.prototype.getUrl = function() {
    return this.windowLocation.href.split("?")[0];
  };
  Api2.prototype.mark = function(name2) {
    if (!this.performance || !this.performance.mark) {
      return;
    }
    this.performance.mark(name2);
  };
  Api2.prototype.measure = function(measureName, mark1, mark2) {
    if (!this.performance || !this.performance.measure) {
      return;
    }
    this.performance.measure(measureName, mark1, mark2);
  };
  Api2.prototype.getEntriesByType = function(type) {
    if (!this.performance || !this.performance.getEntriesByType) {
      return [];
    }
    return this.performance.getEntriesByType(type);
  };
  Api2.prototype.getEntriesByName = function(name2) {
    if (!this.performance || !this.performance.getEntriesByName) {
      return [];
    }
    return this.performance.getEntriesByName(name2);
  };
  Api2.prototype.getTimeOrigin = function() {
    return this.performance && (this.performance.timeOrigin || this.performance.timing.navigationStart);
  };
  Api2.prototype.requiredApisAvailable = function() {
    if (!fetch || !Promise || !this.navigator || !this.navigator.cookieEnabled) {
      consoleLogger.info("Firebase Performance cannot start if browser does not support fetch and Promise or cookie is disabled.");
      return false;
    }
    if (!isIndexedDBAvailable()) {
      consoleLogger.info("IndexedDB is not supported by current browswer");
      return false;
    }
    return true;
  };
  Api2.prototype.setupObserver = function(entryType, callback) {
    if (!this.PerformanceObserver) {
      return;
    }
    var observer = new this.PerformanceObserver(function(list2) {
      for (var _i2 = 0, _a2 = list2.getEntries(); _i2 < _a2.length; _i2++) {
        var entry = _a2[_i2];
        callback(entry);
      }
    });
    observer.observe({ entryTypes: [entryType] });
  };
  Api2.getInstance = function() {
    if (apiInstance === void 0) {
      apiInstance = new Api2(windowInstance);
    }
    return apiInstance;
  };
  return Api2;
}();
function setupApi(window2) {
  windowInstance = window2;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function mergeStrings(part1, part2) {
  var sizeDiff = part1.length - part2.length;
  if (sizeDiff < 0 || sizeDiff > 1) {
    throw ERROR_FACTORY$2.create("invalid String merger input");
  }
  var resultArray = [];
  for (var i = 0; i < part1.length; i++) {
    resultArray.push(part1.charAt(i));
    if (part2.length > i) {
      resultArray.push(part2.charAt(i));
    }
  }
  return resultArray.join("");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var settingsServiceInstance;
var SettingsService = function() {
  function SettingsService2() {
    this.instrumentationEnabled = true;
    this.dataCollectionEnabled = true;
    this.loggingEnabled = false;
    this.tracesSamplingRate = 1;
    this.networkRequestsSamplingRate = 1;
    this.logEndPointUrl = "https://firebaselogging.googleapis.com/v0cc/log?format=json_proto";
    this.flTransportEndpointUrl = mergeStrings("hts/frbslgigp.ogepscmv/ieo/eaylg", "tp:/ieaeogn-agolai.o/1frlglgc/o");
    this.transportKey = mergeStrings("AzSC8r6ReiGqFMyfvgow", "Iayx0u-XT3vksVM-pIV");
    this.logSource = 462;
    this.logTraceAfterSampling = false;
    this.logNetworkAfterSampling = false;
    this.configTimeToLive = 12;
  }
  SettingsService2.prototype.getAppId = function() {
    var appId = this.firebaseAppInstance && this.firebaseAppInstance.options && this.firebaseAppInstance.options.appId;
    if (!appId) {
      throw ERROR_FACTORY$2.create("no app id");
    }
    return appId;
  };
  SettingsService2.prototype.getProjectId = function() {
    var projectId = this.firebaseAppInstance && this.firebaseAppInstance.options && this.firebaseAppInstance.options.projectId;
    if (!projectId) {
      throw ERROR_FACTORY$2.create("no project id");
    }
    return projectId;
  };
  SettingsService2.prototype.getApiKey = function() {
    var apiKey = this.firebaseAppInstance && this.firebaseAppInstance.options && this.firebaseAppInstance.options.apiKey;
    if (!apiKey) {
      throw ERROR_FACTORY$2.create("no api key");
    }
    return apiKey;
  };
  SettingsService2.prototype.getFlTransportFullUrl = function() {
    return this.flTransportEndpointUrl.concat("?key=", this.transportKey);
  };
  SettingsService2.getInstance = function() {
    if (settingsServiceInstance === void 0) {
      settingsServiceInstance = new SettingsService2();
    }
    return settingsServiceInstance;
  };
  return SettingsService2;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var iid;
function getIidPromise() {
  var iidPromise = SettingsService.getInstance().installationsService.getId();
  iidPromise.then(function(iidVal) {
    iid = iidVal;
  });
  return iidPromise;
}
function getIid() {
  return iid;
}
function getAuthTokenPromise() {
  var authTokenPromise = SettingsService.getInstance().installationsService.getToken();
  authTokenPromise.then(function(authTokenVal) {
  });
  return authTokenPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var VisibilityState;
(function(VisibilityState2) {
  VisibilityState2[VisibilityState2["UNKNOWN"] = 0] = "UNKNOWN";
  VisibilityState2[VisibilityState2["VISIBLE"] = 1] = "VISIBLE";
  VisibilityState2[VisibilityState2["HIDDEN"] = 2] = "HIDDEN";
})(VisibilityState || (VisibilityState = {}));
var RESERVED_ATTRIBUTE_PREFIXES = ["firebase_", "google_", "ga_"];
var ATTRIBUTE_FORMAT_REGEX = new RegExp("^[a-zA-Z]\\w*$");
var MAX_ATTRIBUTE_NAME_LENGTH = 40;
var MAX_ATTRIBUTE_VALUE_LENGTH = 100;
function getServiceWorkerStatus() {
  var navigator2 = Api.getInstance().navigator;
  if ("serviceWorker" in navigator2) {
    if (navigator2.serviceWorker.controller) {
      return 2;
    } else {
      return 3;
    }
  } else {
    return 1;
  }
}
function getVisibilityState() {
  var document2 = Api.getInstance().document;
  var visibilityState = document2.visibilityState;
  switch (visibilityState) {
    case "visible":
      return VisibilityState.VISIBLE;
    case "hidden":
      return VisibilityState.HIDDEN;
    default:
      return VisibilityState.UNKNOWN;
  }
}
function getEffectiveConnectionType() {
  var navigator2 = Api.getInstance().navigator;
  var navigatorConnection = navigator2.connection;
  var effectiveType = navigatorConnection && navigatorConnection.effectiveType;
  switch (effectiveType) {
    case "slow-2g":
      return 1;
    case "2g":
      return 2;
    case "3g":
      return 3;
    case "4g":
      return 4;
    default:
      return 0;
  }
}
function isValidCustomAttributeName(name2) {
  if (name2.length === 0 || name2.length > MAX_ATTRIBUTE_NAME_LENGTH) {
    return false;
  }
  var matchesReservedPrefix = RESERVED_ATTRIBUTE_PREFIXES.some(function(prefix) {
    return name2.startsWith(prefix);
  });
  return !matchesReservedPrefix && !!name2.match(ATTRIBUTE_FORMAT_REGEX);
}
function isValidCustomAttributeValue(value) {
  return value.length !== 0 && value.length <= MAX_ATTRIBUTE_VALUE_LENGTH;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var REMOTE_CONFIG_SDK_VERSION = "0.0.1";
var DEFAULT_CONFIGS = {
  loggingEnabled: true
};
var FIS_AUTH_PREFIX = "FIREBASE_INSTALLATIONS_AUTH";
function getConfig(iid2) {
  var config = getStoredConfig();
  if (config) {
    processConfig(config);
    return Promise.resolve();
  }
  return getRemoteConfig(iid2).then(processConfig).then(function(config2) {
    return storeConfig(config2);
  }, function() {
  });
}
function getStoredConfig() {
  var localStorage2 = Api.getInstance().localStorage;
  if (!localStorage2) {
    return;
  }
  var expiryString = localStorage2.getItem(CONFIG_EXPIRY_LOCAL_STORAGE_KEY);
  if (!expiryString || !configValid(expiryString)) {
    return;
  }
  var configStringified = localStorage2.getItem(CONFIG_LOCAL_STORAGE_KEY);
  if (!configStringified) {
    return;
  }
  try {
    var configResponse = JSON.parse(configStringified);
    return configResponse;
  } catch (_a2) {
    return;
  }
}
function storeConfig(config) {
  var localStorage2 = Api.getInstance().localStorage;
  if (!config || !localStorage2) {
    return;
  }
  localStorage2.setItem(CONFIG_LOCAL_STORAGE_KEY, JSON.stringify(config));
  localStorage2.setItem(CONFIG_EXPIRY_LOCAL_STORAGE_KEY, String(Date.now() + SettingsService.getInstance().configTimeToLive * 60 * 60 * 1e3));
}
var COULD_NOT_GET_CONFIG_MSG = "Could not fetch config, will use default configs";
function getRemoteConfig(iid2) {
  return getAuthTokenPromise().then(function(authToken) {
    var projectId = SettingsService.getInstance().getProjectId();
    var configEndPoint = "https://firebaseremoteconfig.googleapis.com/v1/projects/" + projectId + "/namespaces/fireperf:fetch?key=" + SettingsService.getInstance().getApiKey();
    var request = new Request(configEndPoint, {
      method: "POST",
      headers: { Authorization: FIS_AUTH_PREFIX + " " + authToken },
      body: JSON.stringify({
        app_instance_id: iid2,
        app_instance_id_token: authToken,
        app_id: SettingsService.getInstance().getAppId(),
        app_version: SDK_VERSION,
        sdk_version: REMOTE_CONFIG_SDK_VERSION
      })
    });
    return fetch(request).then(function(response) {
      if (response.ok) {
        return response.json();
      }
      throw ERROR_FACTORY$2.create("RC response not ok");
    });
  }).catch(function() {
    consoleLogger.info(COULD_NOT_GET_CONFIG_MSG);
    return void 0;
  });
}
function processConfig(config) {
  if (!config) {
    return config;
  }
  var settingsServiceInstance2 = SettingsService.getInstance();
  var entries = config.entries || {};
  if (entries.fpr_enabled !== void 0) {
    settingsServiceInstance2.loggingEnabled = String(entries.fpr_enabled) === "true";
  } else {
    settingsServiceInstance2.loggingEnabled = DEFAULT_CONFIGS.loggingEnabled;
  }
  if (entries.fpr_log_source) {
    settingsServiceInstance2.logSource = Number(entries.fpr_log_source);
  }
  if (entries.fpr_log_endpoint_url) {
    settingsServiceInstance2.logEndPointUrl = entries.fpr_log_endpoint_url;
  }
  if (entries.fpr_log_transport_key) {
    settingsServiceInstance2.transportKey = entries.fpr_log_transport_key;
  }
  if (entries.fpr_vc_network_request_sampling_rate !== void 0) {
    settingsServiceInstance2.networkRequestsSamplingRate = Number(entries.fpr_vc_network_request_sampling_rate);
  }
  if (entries.fpr_vc_trace_sampling_rate !== void 0) {
    settingsServiceInstance2.tracesSamplingRate = Number(entries.fpr_vc_trace_sampling_rate);
  }
  settingsServiceInstance2.logTraceAfterSampling = shouldLogAfterSampling(settingsServiceInstance2.tracesSamplingRate);
  settingsServiceInstance2.logNetworkAfterSampling = shouldLogAfterSampling(settingsServiceInstance2.networkRequestsSamplingRate);
  return config;
}
function configValid(expiry) {
  return Number(expiry) > Date.now();
}
function shouldLogAfterSampling(samplingRate) {
  return Math.random() <= samplingRate;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var initializationStatus = 1;
var initializationPromise;
function getInitializationPromise() {
  initializationStatus = 2;
  initializationPromise = initializationPromise || initializePerf();
  return initializationPromise;
}
function isPerfInitialized() {
  return initializationStatus === 3;
}
function initializePerf() {
  return getDocumentReadyComplete().then(function() {
    return getIidPromise();
  }).then(function(iid2) {
    return getConfig(iid2);
  }).then(function() {
    return changeInitializationStatus();
  }, function() {
    return changeInitializationStatus();
  });
}
function getDocumentReadyComplete() {
  var document2 = Api.getInstance().document;
  return new Promise(function(resolve) {
    if (document2 && document2.readyState !== "complete") {
      var handler_1 = function() {
        if (document2.readyState === "complete") {
          document2.removeEventListener("readystatechange", handler_1);
          resolve();
        }
      };
      document2.addEventListener("readystatechange", handler_1);
    } else {
      resolve();
    }
  });
}
function changeInitializationStatus() {
  initializationStatus = 3;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_SEND_INTERVAL_MS = 10 * 1e3;
var INITIAL_SEND_TIME_DELAY_MS = 5.5 * 1e3;
var DEFAULT_REMAINING_TRIES = 3;
var MAX_EVENT_COUNT_PER_REQUEST = 1e3;
var remainingTries = DEFAULT_REMAINING_TRIES;
var queue = [];
var isTransportSetup = false;
function setupTransportService() {
  if (!isTransportSetup) {
    processQueue(INITIAL_SEND_TIME_DELAY_MS);
    isTransportSetup = true;
  }
}
function processQueue(timeOffset) {
  setTimeout(function() {
    if (remainingTries === 0) {
      return;
    }
    if (!queue.length) {
      return processQueue(DEFAULT_SEND_INTERVAL_MS);
    }
    dispatchQueueEvents();
  }, timeOffset);
}
function dispatchQueueEvents() {
  var staged = queue.splice(0, MAX_EVENT_COUNT_PER_REQUEST);
  var log_event = staged.map(function(evt) {
    return {
      source_extension_json_proto3: evt.message,
      event_time_ms: String(evt.eventTime)
    };
  });
  var data = {
    request_time_ms: String(Date.now()),
    client_info: {
      client_type: 1,
      js_client_info: {}
    },
    log_source: SettingsService.getInstance().logSource,
    log_event
  };
  sendEventsToFl(data, staged).catch(function() {
    queue = __spreadArrays$1(staged, queue);
    remainingTries--;
    consoleLogger.info("Tries left: " + remainingTries + ".");
    processQueue(DEFAULT_SEND_INTERVAL_MS);
  });
}
function sendEventsToFl(data, staged) {
  return postToFlEndpoint(data).then(function(res) {
    if (!res.ok) {
      consoleLogger.info("Call to Firebase backend failed.");
    }
    return res.json();
  }).then(function(res) {
    var transportWait = Number(res.nextRequestWaitMillis);
    var requestOffset = DEFAULT_SEND_INTERVAL_MS;
    if (!isNaN(transportWait)) {
      requestOffset = Math.max(transportWait, requestOffset);
    }
    var logResponseDetails = res.logResponseDetails;
    if (Array.isArray(logResponseDetails) && logResponseDetails.length > 0 && logResponseDetails[0].responseAction === "RETRY_REQUEST_LATER") {
      queue = __spreadArrays$1(staged, queue);
      consoleLogger.info("Retry transport request later.");
    }
    remainingTries = DEFAULT_REMAINING_TRIES;
    processQueue(requestOffset);
  });
}
function postToFlEndpoint(data) {
  var flTransportFullUrl = SettingsService.getInstance().getFlTransportFullUrl();
  return fetch(flTransportFullUrl, {
    method: "POST",
    body: JSON.stringify(data)
  });
}
function addToQueue(evt) {
  if (!evt.eventTime || !evt.message) {
    throw ERROR_FACTORY$2.create("invalid cc log");
  }
  queue = __spreadArrays$1(queue, [evt]);
}
function transportHandler(serializer2) {
  return function() {
    var args = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      args[_i2] = arguments[_i2];
    }
    var message = serializer2.apply(void 0, args);
    addToQueue({
      message,
      eventTime: Date.now()
    });
  };
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logger$1;
function sendLog(resource, resourceType) {
  if (!logger$1) {
    logger$1 = transportHandler(serializer);
  }
  logger$1(resource, resourceType);
}
function logTrace(trace) {
  var settingsService = SettingsService.getInstance();
  if (!settingsService.instrumentationEnabled && trace.isAuto) {
    return;
  }
  if (!settingsService.dataCollectionEnabled && !trace.isAuto) {
    return;
  }
  if (!Api.getInstance().requiredApisAvailable()) {
    return;
  }
  if (trace.isAuto && getVisibilityState() !== VisibilityState.VISIBLE) {
    return;
  }
  if (isPerfInitialized()) {
    sendTraceLog(trace);
  } else {
    getInitializationPromise().then(function() {
      return sendTraceLog(trace);
    }, function() {
      return sendTraceLog(trace);
    });
  }
}
function sendTraceLog(trace) {
  if (!getIid()) {
    return;
  }
  var settingsService = SettingsService.getInstance();
  if (!settingsService.loggingEnabled || !settingsService.logTraceAfterSampling) {
    return;
  }
  setTimeout(function() {
    return sendLog(trace, 1);
  }, 0);
}
function logNetworkRequest(networkRequest) {
  var settingsService = SettingsService.getInstance();
  if (!settingsService.instrumentationEnabled) {
    return;
  }
  var networkRequestUrl = networkRequest.url;
  var logEndpointUrl = settingsService.logEndPointUrl.split("?")[0];
  var flEndpointUrl = settingsService.flTransportEndpointUrl.split("?")[0];
  if (networkRequestUrl === logEndpointUrl || networkRequestUrl === flEndpointUrl) {
    return;
  }
  if (!settingsService.loggingEnabled || !settingsService.logNetworkAfterSampling) {
    return;
  }
  setTimeout(function() {
    return sendLog(networkRequest, 0);
  }, 0);
}
function serializer(resource, resourceType) {
  if (resourceType === 0) {
    return serializeNetworkRequest(resource);
  }
  return serializeTrace(resource);
}
function serializeNetworkRequest(networkRequest) {
  var networkRequestMetric = {
    url: networkRequest.url,
    http_method: networkRequest.httpMethod || 0,
    http_response_code: 200,
    response_payload_bytes: networkRequest.responsePayloadBytes,
    client_start_time_us: networkRequest.startTimeUs,
    time_to_response_initiated_us: networkRequest.timeToResponseInitiatedUs,
    time_to_response_completed_us: networkRequest.timeToResponseCompletedUs
  };
  var perfMetric = {
    application_info: getApplicationInfo(),
    network_request_metric: networkRequestMetric
  };
  return JSON.stringify(perfMetric);
}
function serializeTrace(trace) {
  var traceMetric = {
    name: trace.name,
    is_auto: trace.isAuto,
    client_start_time_us: trace.startTimeUs,
    duration_us: trace.durationUs
  };
  if (Object.keys(trace.counters).length !== 0) {
    traceMetric.counters = trace.counters;
  }
  var customAttributes = trace.getAttributes();
  if (Object.keys(customAttributes).length !== 0) {
    traceMetric.custom_attributes = customAttributes;
  }
  var perfMetric = {
    application_info: getApplicationInfo(),
    trace_metric: traceMetric
  };
  return JSON.stringify(perfMetric);
}
function getApplicationInfo() {
  return {
    google_app_id: SettingsService.getInstance().getAppId(),
    app_instance_id: getIid(),
    web_app_info: {
      sdk_version: SDK_VERSION,
      page_url: Api.getInstance().getUrl(),
      service_worker_status: getServiceWorkerStatus(),
      visibility_state: getVisibilityState(),
      effective_connection_type: getEffectiveConnectionType()
    },
    application_process_state: 0
  };
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MAX_METRIC_NAME_LENGTH = 100;
var RESERVED_AUTO_PREFIX = "_";
var oobMetrics = [
  FIRST_PAINT_COUNTER_NAME,
  FIRST_CONTENTFUL_PAINT_COUNTER_NAME,
  FIRST_INPUT_DELAY_COUNTER_NAME
];
function isValidMetricName(name2, traceName) {
  if (name2.length === 0 || name2.length > MAX_METRIC_NAME_LENGTH) {
    return false;
  }
  return traceName && traceName.startsWith(OOB_TRACE_PAGE_LOAD_PREFIX) && oobMetrics.indexOf(name2) > -1 || !name2.startsWith(RESERVED_AUTO_PREFIX);
}
function convertMetricValueToInteger(providedValue) {
  var valueAsInteger = Math.floor(providedValue);
  if (valueAsInteger < providedValue) {
    consoleLogger.info("Metric value should be an Integer, setting the value as : " + valueAsInteger + ".");
  }
  return valueAsInteger;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Trace = function() {
  function Trace2(name2, isAuto, traceMeasureName) {
    if (isAuto === void 0) {
      isAuto = false;
    }
    this.name = name2;
    this.isAuto = isAuto;
    this.state = 1;
    this.customAttributes = {};
    this.counters = {};
    this.api = Api.getInstance();
    this.randomId = Math.floor(Math.random() * 1e6);
    if (!this.isAuto) {
      this.traceStartMark = TRACE_START_MARK_PREFIX + "-" + this.randomId + "-" + this.name;
      this.traceStopMark = TRACE_STOP_MARK_PREFIX + "-" + this.randomId + "-" + this.name;
      this.traceMeasure = traceMeasureName || TRACE_MEASURE_PREFIX + "-" + this.randomId + "-" + this.name;
      if (traceMeasureName) {
        this.calculateTraceMetrics();
      }
    }
  }
  Trace2.prototype.start = function() {
    if (this.state !== 1) {
      throw ERROR_FACTORY$2.create("trace started", {
        traceName: this.name
      });
    }
    this.api.mark(this.traceStartMark);
    this.state = 2;
  };
  Trace2.prototype.stop = function() {
    if (this.state !== 2) {
      throw ERROR_FACTORY$2.create("trace stopped", {
        traceName: this.name
      });
    }
    this.state = 3;
    this.api.mark(this.traceStopMark);
    this.api.measure(this.traceMeasure, this.traceStartMark, this.traceStopMark);
    this.calculateTraceMetrics();
    logTrace(this);
  };
  Trace2.prototype.record = function(startTime, duration, options) {
    if (startTime <= 0) {
      throw ERROR_FACTORY$2.create("nonpositive trace startTime", {
        traceName: this.name
      });
    }
    if (duration <= 0) {
      throw ERROR_FACTORY$2.create("nonpositive trace duration", {
        traceName: this.name
      });
    }
    this.durationUs = Math.floor(duration * 1e3);
    this.startTimeUs = Math.floor(startTime * 1e3);
    if (options && options.attributes) {
      this.customAttributes = __assign({}, options.attributes);
    }
    if (options && options.metrics) {
      for (var _i2 = 0, _a2 = Object.keys(options.metrics); _i2 < _a2.length; _i2++) {
        var metric = _a2[_i2];
        if (!isNaN(Number(options.metrics[metric]))) {
          this.counters[metric] = Number(Math.floor(options.metrics[metric]));
        }
      }
    }
    logTrace(this);
  };
  Trace2.prototype.incrementMetric = function(counter, numAsInteger) {
    if (numAsInteger === void 0) {
      numAsInteger = 1;
    }
    if (this.counters[counter] === void 0) {
      this.putMetric(counter, numAsInteger);
    } else {
      this.putMetric(counter, this.counters[counter] + numAsInteger);
    }
  };
  Trace2.prototype.putMetric = function(counter, numAsInteger) {
    if (isValidMetricName(counter, this.name)) {
      this.counters[counter] = convertMetricValueToInteger(numAsInteger);
    } else {
      throw ERROR_FACTORY$2.create("invalid custom metric name", {
        customMetricName: counter
      });
    }
  };
  Trace2.prototype.getMetric = function(counter) {
    return this.counters[counter] || 0;
  };
  Trace2.prototype.putAttribute = function(attr, value) {
    var isValidName = isValidCustomAttributeName(attr);
    var isValidValue = isValidCustomAttributeValue(value);
    if (isValidName && isValidValue) {
      this.customAttributes[attr] = value;
      return;
    }
    if (!isValidName) {
      throw ERROR_FACTORY$2.create("invalid attribute name", {
        attributeName: attr
      });
    }
    if (!isValidValue) {
      throw ERROR_FACTORY$2.create("invalid attribute value", {
        attributeValue: value
      });
    }
  };
  Trace2.prototype.getAttribute = function(attr) {
    return this.customAttributes[attr];
  };
  Trace2.prototype.removeAttribute = function(attr) {
    if (this.customAttributes[attr] === void 0) {
      return;
    }
    delete this.customAttributes[attr];
  };
  Trace2.prototype.getAttributes = function() {
    return __assign({}, this.customAttributes);
  };
  Trace2.prototype.setStartTime = function(startTime) {
    this.startTimeUs = startTime;
  };
  Trace2.prototype.setDuration = function(duration) {
    this.durationUs = duration;
  };
  Trace2.prototype.calculateTraceMetrics = function() {
    var perfMeasureEntries = this.api.getEntriesByName(this.traceMeasure);
    var perfMeasureEntry = perfMeasureEntries && perfMeasureEntries[0];
    if (perfMeasureEntry) {
      this.durationUs = Math.floor(perfMeasureEntry.duration * 1e3);
      this.startTimeUs = Math.floor((perfMeasureEntry.startTime + this.api.getTimeOrigin()) * 1e3);
    }
  };
  Trace2.createOobTrace = function(navigationTimings, paintTimings, firstInputDelay) {
    var route = Api.getInstance().getUrl();
    if (!route) {
      return;
    }
    var trace = new Trace2(OOB_TRACE_PAGE_LOAD_PREFIX + route, true);
    var timeOriginUs = Math.floor(Api.getInstance().getTimeOrigin() * 1e3);
    trace.setStartTime(timeOriginUs);
    if (navigationTimings && navigationTimings[0]) {
      trace.setDuration(Math.floor(navigationTimings[0].duration * 1e3));
      trace.putMetric("domInteractive", Math.floor(navigationTimings[0].domInteractive * 1e3));
      trace.putMetric("domContentLoadedEventEnd", Math.floor(navigationTimings[0].domContentLoadedEventEnd * 1e3));
      trace.putMetric("loadEventEnd", Math.floor(navigationTimings[0].loadEventEnd * 1e3));
    }
    var FIRST_PAINT = "first-paint";
    var FIRST_CONTENTFUL_PAINT = "first-contentful-paint";
    if (paintTimings) {
      var firstPaint = paintTimings.find(function(paintObject) {
        return paintObject.name === FIRST_PAINT;
      });
      if (firstPaint && firstPaint.startTime) {
        trace.putMetric(FIRST_PAINT_COUNTER_NAME, Math.floor(firstPaint.startTime * 1e3));
      }
      var firstContentfulPaint = paintTimings.find(function(paintObject) {
        return paintObject.name === FIRST_CONTENTFUL_PAINT;
      });
      if (firstContentfulPaint && firstContentfulPaint.startTime) {
        trace.putMetric(FIRST_CONTENTFUL_PAINT_COUNTER_NAME, Math.floor(firstContentfulPaint.startTime * 1e3));
      }
      if (firstInputDelay) {
        trace.putMetric(FIRST_INPUT_DELAY_COUNTER_NAME, Math.floor(firstInputDelay * 1e3));
      }
    }
    logTrace(trace);
  };
  Trace2.createUserTimingTrace = function(measureName) {
    var trace = new Trace2(measureName, false, measureName);
    logTrace(trace);
  };
  return Trace2;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createNetworkRequestEntry(entry) {
  var performanceEntry = entry;
  if (!performanceEntry || performanceEntry.responseStart === void 0) {
    return;
  }
  var timeOrigin = Api.getInstance().getTimeOrigin();
  var startTimeUs = Math.floor((performanceEntry.startTime + timeOrigin) * 1e3);
  var timeToResponseInitiatedUs = performanceEntry.responseStart ? Math.floor((performanceEntry.responseStart - performanceEntry.startTime) * 1e3) : void 0;
  var timeToResponseCompletedUs = Math.floor((performanceEntry.responseEnd - performanceEntry.startTime) * 1e3);
  var url = performanceEntry.name && performanceEntry.name.split("?")[0];
  var networkRequest = {
    url,
    responsePayloadBytes: performanceEntry.transferSize,
    startTimeUs,
    timeToResponseInitiatedUs,
    timeToResponseCompletedUs
  };
  logNetworkRequest(networkRequest);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FID_WAIT_TIME_MS = 5e3;
function setupOobResources() {
  if (!getIid()) {
    return;
  }
  setTimeout(function() {
    return setupOobTraces();
  }, 0);
  setTimeout(function() {
    return setupNetworkRequests();
  }, 0);
  setTimeout(function() {
    return setupUserTimingTraces();
  }, 0);
}
function setupNetworkRequests() {
  var api2 = Api.getInstance();
  var resources = api2.getEntriesByType("resource");
  for (var _i2 = 0, resources_1 = resources; _i2 < resources_1.length; _i2++) {
    var resource = resources_1[_i2];
    createNetworkRequestEntry(resource);
  }
  api2.setupObserver("resource", createNetworkRequestEntry);
}
function setupOobTraces() {
  var api2 = Api.getInstance();
  var navigationTimings = api2.getEntriesByType("navigation");
  var paintTimings = api2.getEntriesByType("paint");
  if (api2.onFirstInputDelay) {
    var timeoutId_1 = setTimeout(function() {
      Trace.createOobTrace(navigationTimings, paintTimings);
      timeoutId_1 = void 0;
    }, FID_WAIT_TIME_MS);
    api2.onFirstInputDelay(function(fid) {
      if (timeoutId_1) {
        clearTimeout(timeoutId_1);
        Trace.createOobTrace(navigationTimings, paintTimings, fid);
      }
    });
  } else {
    Trace.createOobTrace(navigationTimings, paintTimings);
  }
}
function setupUserTimingTraces() {
  var api2 = Api.getInstance();
  var measures = api2.getEntriesByType("measure");
  for (var _i2 = 0, measures_1 = measures; _i2 < measures_1.length; _i2++) {
    var measure = measures_1[_i2];
    createUserTimingTrace(measure);
  }
  api2.setupObserver("measure", createUserTimingTrace);
}
function createUserTimingTrace(measure) {
  var measureName = measure.name;
  if (measureName.substring(0, TRACE_MEASURE_PREFIX.length) === TRACE_MEASURE_PREFIX) {
    return;
  }
  Trace.createUserTimingTrace(measureName);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PerformanceController = function() {
  function PerformanceController2(app) {
    this.app = app;
    if (Api.getInstance().requiredApisAvailable()) {
      validateIndexedDBOpenable().then(function(isAvailable) {
        if (isAvailable) {
          setupTransportService();
          getInitializationPromise().then(setupOobResources, setupOobResources);
        }
      }).catch(function(error2) {
        consoleLogger.info("Environment doesn't support IndexedDB: " + error2);
      });
    }
  }
  PerformanceController2.prototype.trace = function(name2) {
    return new Trace(name2);
  };
  Object.defineProperty(PerformanceController2.prototype, "instrumentationEnabled", {
    get: function() {
      return SettingsService.getInstance().instrumentationEnabled;
    },
    set: function(val) {
      SettingsService.getInstance().instrumentationEnabled = val;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(PerformanceController2.prototype, "dataCollectionEnabled", {
    get: function() {
      return SettingsService.getInstance().dataCollectionEnabled;
    },
    set: function(val) {
      SettingsService.getInstance().dataCollectionEnabled = val;
    },
    enumerable: false,
    configurable: true
  });
  return PerformanceController2;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_ENTRY_NAME = "[DEFAULT]";
function registerPerformance(instance) {
  var factoryMethod2 = function(app, installations) {
    if (app.name !== DEFAULT_ENTRY_NAME) {
      throw ERROR_FACTORY$2.create("FB not default");
    }
    if (typeof window === "undefined") {
      throw ERROR_FACTORY$2.create("no window");
    }
    setupApi(window);
    SettingsService.getInstance().firebaseAppInstance = app;
    SettingsService.getInstance().installationsService = installations;
    return new PerformanceController(app);
  };
  instance.INTERNAL.registerComponent(new Component("performance", function(container) {
    var app = container.getProvider("app").getImmediate();
    var installations = container.getProvider("installations").getImmediate();
    return factoryMethod2(app, installations);
  }, "PUBLIC"));
  instance.registerVersion(name$4, version$4);
}
registerPerformance(firebase$1);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var GA_FID_KEY = "firebase_id";
var ORIGIN_KEY = "origin";
var FETCH_TIMEOUT_MILLIS = 60 * 1e3;
var DYNAMIC_CONFIG_URL = "https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig";
var GTAG_URL = "https://www.googletagmanager.com/gtag/js";
var GtagCommand;
(function(GtagCommand2) {
  GtagCommand2["EVENT"] = "event";
  GtagCommand2["SET"] = "set";
  GtagCommand2["CONFIG"] = "config";
})(GtagCommand || (GtagCommand = {}));
var EventName;
(function(EventName2) {
  EventName2["ADD_SHIPPING_INFO"] = "add_shipping_info";
  EventName2["ADD_PAYMENT_INFO"] = "add_payment_info";
  EventName2["ADD_TO_CART"] = "add_to_cart";
  EventName2["ADD_TO_WISHLIST"] = "add_to_wishlist";
  EventName2["BEGIN_CHECKOUT"] = "begin_checkout";
  EventName2["CHECKOUT_PROGRESS"] = "checkout_progress";
  EventName2["EXCEPTION"] = "exception";
  EventName2["GENERATE_LEAD"] = "generate_lead";
  EventName2["LOGIN"] = "login";
  EventName2["PAGE_VIEW"] = "page_view";
  EventName2["PURCHASE"] = "purchase";
  EventName2["REFUND"] = "refund";
  EventName2["REMOVE_FROM_CART"] = "remove_from_cart";
  EventName2["SCREEN_VIEW"] = "screen_view";
  EventName2["SEARCH"] = "search";
  EventName2["SELECT_CONTENT"] = "select_content";
  EventName2["SELECT_ITEM"] = "select_item";
  EventName2["SELECT_PROMOTION"] = "select_promotion";
  EventName2["SET_CHECKOUT_OPTION"] = "set_checkout_option";
  EventName2["SHARE"] = "share";
  EventName2["SIGN_UP"] = "sign_up";
  EventName2["TIMING_COMPLETE"] = "timing_complete";
  EventName2["VIEW_CART"] = "view_cart";
  EventName2["VIEW_ITEM"] = "view_item";
  EventName2["VIEW_ITEM_LIST"] = "view_item_list";
  EventName2["VIEW_PROMOTION"] = "view_promotion";
  EventName2["VIEW_SEARCH_RESULTS"] = "view_search_results";
})(EventName || (EventName = {}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function logEvent(gtagFunction, initializationPromise2, eventName, eventParams, options) {
  return __awaiter(this, void 0, void 0, function() {
    var measurementId, params2;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (!(options && options.global))
            return [3, 1];
          gtagFunction(GtagCommand.EVENT, eventName, eventParams);
          return [2];
        case 1:
          return [4, initializationPromise2];
        case 2:
          measurementId = _a2.sent();
          params2 = __assign(__assign({}, eventParams), { "send_to": measurementId });
          gtagFunction(GtagCommand.EVENT, eventName, params2);
          _a2.label = 3;
        case 3:
          return [2];
      }
    });
  });
}
function setCurrentScreen(gtagFunction, initializationPromise2, screenName, options) {
  return __awaiter(this, void 0, void 0, function() {
    var measurementId;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (!(options && options.global))
            return [3, 1];
          gtagFunction(GtagCommand.SET, { "screen_name": screenName });
          return [2, Promise.resolve()];
        case 1:
          return [4, initializationPromise2];
        case 2:
          measurementId = _a2.sent();
          gtagFunction(GtagCommand.CONFIG, measurementId, {
            update: true,
            "screen_name": screenName
          });
          _a2.label = 3;
        case 3:
          return [2];
      }
    });
  });
}
function setUserId(gtagFunction, initializationPromise2, id2, options) {
  return __awaiter(this, void 0, void 0, function() {
    var measurementId;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (!(options && options.global))
            return [3, 1];
          gtagFunction(GtagCommand.SET, { "user_id": id2 });
          return [2, Promise.resolve()];
        case 1:
          return [4, initializationPromise2];
        case 2:
          measurementId = _a2.sent();
          gtagFunction(GtagCommand.CONFIG, measurementId, {
            update: true,
            "user_id": id2
          });
          _a2.label = 3;
        case 3:
          return [2];
      }
    });
  });
}
function setUserProperties(gtagFunction, initializationPromise2, properties, options) {
  return __awaiter(this, void 0, void 0, function() {
    var flatProperties, _i2, _a2, key, measurementId;
    return __generator(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          if (!(options && options.global))
            return [3, 1];
          flatProperties = {};
          for (_i2 = 0, _a2 = Object.keys(properties); _i2 < _a2.length; _i2++) {
            key = _a2[_i2];
            flatProperties["user_properties." + key] = properties[key];
          }
          gtagFunction(GtagCommand.SET, flatProperties);
          return [2, Promise.resolve()];
        case 1:
          return [4, initializationPromise2];
        case 2:
          measurementId = _b2.sent();
          gtagFunction(GtagCommand.CONFIG, measurementId, {
            update: true,
            "user_properties": properties
          });
          _b2.label = 3;
        case 3:
          return [2];
      }
    });
  });
}
function setAnalyticsCollectionEnabled(initializationPromise2, enabled) {
  return __awaiter(this, void 0, void 0, function() {
    var measurementId;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, initializationPromise2];
        case 1:
          measurementId = _a2.sent();
          window["ga-disable-" + measurementId] = !enabled;
          return [2];
      }
    });
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logger = new Logger("@firebase/analytics");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function insertScriptTag(dataLayerName2) {
  var script2 = document.createElement("script");
  script2.src = GTAG_URL + "?l=" + dataLayerName2;
  script2.async = true;
  document.head.appendChild(script2);
}
function getOrCreateDataLayer(dataLayerName2) {
  var dataLayer = [];
  if (Array.isArray(window[dataLayerName2])) {
    dataLayer = window[dataLayerName2];
  } else {
    window[dataLayerName2] = dataLayer;
  }
  return dataLayer;
}
function gtagOnConfig(gtagCore, initializationPromisesMap2, dynamicConfigPromisesList2, measurementIdToAppId2, measurementId, gtagParams) {
  return __awaiter(this, void 0, void 0, function() {
    var correspondingAppId, dynamicConfigResults, foundConfig, e_1;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          correspondingAppId = measurementIdToAppId2[measurementId];
          _a2.label = 1;
        case 1:
          _a2.trys.push([1, 7, , 8]);
          if (!correspondingAppId)
            return [3, 3];
          return [4, initializationPromisesMap2[correspondingAppId]];
        case 2:
          _a2.sent();
          return [3, 6];
        case 3:
          return [4, Promise.all(dynamicConfigPromisesList2)];
        case 4:
          dynamicConfigResults = _a2.sent();
          foundConfig = dynamicConfigResults.find(function(config) {
            return config.measurementId === measurementId;
          });
          if (!foundConfig)
            return [3, 6];
          return [4, initializationPromisesMap2[foundConfig.appId]];
        case 5:
          _a2.sent();
          _a2.label = 6;
        case 6:
          return [3, 8];
        case 7:
          e_1 = _a2.sent();
          logger.error(e_1);
          return [3, 8];
        case 8:
          gtagCore(GtagCommand.CONFIG, measurementId, gtagParams);
          return [2];
      }
    });
  });
}
function gtagOnEvent(gtagCore, initializationPromisesMap2, dynamicConfigPromisesList2, measurementId, gtagParams) {
  return __awaiter(this, void 0, void 0, function() {
    var initializationPromisesToWaitFor, gaSendToList, dynamicConfigResults, _loop_1, _i2, gaSendToList_1, sendToId, state_1, e_2;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          _a2.trys.push([0, 4, , 5]);
          initializationPromisesToWaitFor = [];
          if (!(gtagParams && gtagParams["send_to"]))
            return [3, 2];
          gaSendToList = gtagParams["send_to"];
          if (!Array.isArray(gaSendToList)) {
            gaSendToList = [gaSendToList];
          }
          return [4, Promise.all(dynamicConfigPromisesList2)];
        case 1:
          dynamicConfigResults = _a2.sent();
          _loop_1 = function(sendToId2) {
            var foundConfig = dynamicConfigResults.find(function(config) {
              return config.measurementId === sendToId2;
            });
            var initializationPromise2 = foundConfig && initializationPromisesMap2[foundConfig.appId];
            if (initializationPromise2) {
              initializationPromisesToWaitFor.push(initializationPromise2);
            } else {
              initializationPromisesToWaitFor = [];
              return "break";
            }
          };
          for (_i2 = 0, gaSendToList_1 = gaSendToList; _i2 < gaSendToList_1.length; _i2++) {
            sendToId = gaSendToList_1[_i2];
            state_1 = _loop_1(sendToId);
            if (state_1 === "break")
              break;
          }
          _a2.label = 2;
        case 2:
          if (initializationPromisesToWaitFor.length === 0) {
            initializationPromisesToWaitFor = Object.values(initializationPromisesMap2);
          }
          return [4, Promise.all(initializationPromisesToWaitFor)];
        case 3:
          _a2.sent();
          gtagCore(GtagCommand.EVENT, measurementId, gtagParams || {});
          return [3, 5];
        case 4:
          e_2 = _a2.sent();
          logger.error(e_2);
          return [3, 5];
        case 5:
          return [2];
      }
    });
  });
}
function wrapGtag(gtagCore, initializationPromisesMap2, dynamicConfigPromisesList2, measurementIdToAppId2) {
  function gtagWrapper(command, idOrNameOrParams, gtagParams) {
    return __awaiter(this, void 0, void 0, function() {
      var e_3;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            _a2.trys.push([0, 6, , 7]);
            if (!(command === GtagCommand.EVENT))
              return [3, 2];
            return [4, gtagOnEvent(gtagCore, initializationPromisesMap2, dynamicConfigPromisesList2, idOrNameOrParams, gtagParams)];
          case 1:
            _a2.sent();
            return [3, 5];
          case 2:
            if (!(command === GtagCommand.CONFIG))
              return [3, 4];
            return [4, gtagOnConfig(gtagCore, initializationPromisesMap2, dynamicConfigPromisesList2, measurementIdToAppId2, idOrNameOrParams, gtagParams)];
          case 3:
            _a2.sent();
            return [3, 5];
          case 4:
            gtagCore(GtagCommand.SET, idOrNameOrParams);
            _a2.label = 5;
          case 5:
            return [3, 7];
          case 6:
            e_3 = _a2.sent();
            logger.error(e_3);
            return [3, 7];
          case 7:
            return [2];
        }
      });
    });
  }
  return gtagWrapper;
}
function wrapOrCreateGtag(initializationPromisesMap2, dynamicConfigPromisesList2, measurementIdToAppId2, dataLayerName2, gtagFunctionName) {
  var gtagCore = function() {
    window[dataLayerName2].push(arguments);
  };
  if (window[gtagFunctionName] && typeof window[gtagFunctionName] === "function") {
    gtagCore = window[gtagFunctionName];
  }
  window[gtagFunctionName] = wrapGtag(gtagCore, initializationPromisesMap2, dynamicConfigPromisesList2, measurementIdToAppId2);
  return {
    gtagCore,
    wrappedGtag: window[gtagFunctionName]
  };
}
function findGtagScriptOnPage() {
  var scriptTags = window.document.getElementsByTagName("script");
  for (var _i2 = 0, _a2 = Object.values(scriptTags); _i2 < _a2.length; _i2++) {
    var tag = _a2[_i2];
    if (tag.src && tag.src.includes(GTAG_URL)) {
      return tag;
    }
  }
  return null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a$1;
var ERRORS = (_a$1 = {}, _a$1["already-exists"] = "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.", _a$1["already-initialized"] = "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.", _a$1["interop-component-reg-failed"] = "Firebase Analytics Interop Component failed to instantiate: {$reason}", _a$1["invalid-analytics-context"] = "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}", _a$1["indexeddb-unavailable"] = "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}", _a$1["fetch-throttle"] = "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.", _a$1["config-fetch-failed"] = "Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}", _a$1["no-api-key"] = 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.', _a$1["no-app-id"] = 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.', _a$1);
var ERROR_FACTORY$1 = new ErrorFactory("analytics", "Analytics", ERRORS);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LONG_RETRY_FACTOR = 30;
var BASE_INTERVAL_MILLIS = 1e3;
var RetryData = function() {
  function RetryData2(throttleMetadata, intervalMillis) {
    if (throttleMetadata === void 0) {
      throttleMetadata = {};
    }
    if (intervalMillis === void 0) {
      intervalMillis = BASE_INTERVAL_MILLIS;
    }
    this.throttleMetadata = throttleMetadata;
    this.intervalMillis = intervalMillis;
  }
  RetryData2.prototype.getThrottleMetadata = function(appId) {
    return this.throttleMetadata[appId];
  };
  RetryData2.prototype.setThrottleMetadata = function(appId, metadata2) {
    this.throttleMetadata[appId] = metadata2;
  };
  RetryData2.prototype.deleteThrottleMetadata = function(appId) {
    delete this.throttleMetadata[appId];
  };
  return RetryData2;
}();
var defaultRetryData = new RetryData();
function getHeaders(apiKey) {
  return new Headers({
    Accept: "application/json",
    "x-goog-api-key": apiKey
  });
}
function fetchDynamicConfig(appFields) {
  var _a2;
  return __awaiter(this, void 0, void 0, function() {
    var appId, apiKey, request, appUrl, response, errorMessage, jsonResponse;
    return __generator(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          appId = appFields.appId, apiKey = appFields.apiKey;
          request = {
            method: "GET",
            headers: getHeaders(apiKey)
          };
          appUrl = DYNAMIC_CONFIG_URL.replace("{app-id}", appId);
          return [4, fetch(appUrl, request)];
        case 1:
          response = _b2.sent();
          if (!(response.status !== 200 && response.status !== 304))
            return [3, 6];
          errorMessage = "";
          _b2.label = 2;
        case 2:
          _b2.trys.push([2, 4, , 5]);
          return [4, response.json()];
        case 3:
          jsonResponse = _b2.sent();
          if ((_a2 = jsonResponse.error) === null || _a2 === void 0 ? void 0 : _a2.message) {
            errorMessage = jsonResponse.error.message;
          }
          return [3, 5];
        case 4:
          _b2.sent();
          return [3, 5];
        case 5:
          throw ERROR_FACTORY$1.create("config-fetch-failed", {
            httpStatus: response.status,
            responseMessage: errorMessage
          });
        case 6:
          return [2, response.json()];
      }
    });
  });
}
function fetchDynamicConfigWithRetry(app, retryData, timeoutMillis) {
  if (retryData === void 0) {
    retryData = defaultRetryData;
  }
  return __awaiter(this, void 0, void 0, function() {
    var _a2, appId, apiKey, measurementId, throttleMetadata, signal;
    var _this = this;
    return __generator(this, function(_b2) {
      _a2 = app.options, appId = _a2.appId, apiKey = _a2.apiKey, measurementId = _a2.measurementId;
      if (!appId) {
        throw ERROR_FACTORY$1.create("no-app-id");
      }
      if (!apiKey) {
        if (measurementId) {
          return [2, {
            measurementId,
            appId
          }];
        }
        throw ERROR_FACTORY$1.create("no-api-key");
      }
      throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
      };
      signal = new AnalyticsAbortSignal();
      setTimeout(function() {
        return __awaiter(_this, void 0, void 0, function() {
          return __generator(this, function(_a3) {
            signal.abort();
            return [2];
          });
        });
      }, timeoutMillis !== void 0 ? timeoutMillis : FETCH_TIMEOUT_MILLIS);
      return [2, attemptFetchDynamicConfigWithRetry({ appId, apiKey, measurementId }, throttleMetadata, signal, retryData)];
    });
  });
}
function attemptFetchDynamicConfigWithRetry(appFields, _a2, signal, retryData) {
  var throttleEndTimeMillis = _a2.throttleEndTimeMillis, backoffCount = _a2.backoffCount;
  if (retryData === void 0) {
    retryData = defaultRetryData;
  }
  return __awaiter(this, void 0, void 0, function() {
    var appId, measurementId, e_1, response, e_2, backoffMillis, throttleMetadata;
    return __generator(this, function(_b2) {
      switch (_b2.label) {
        case 0:
          appId = appFields.appId, measurementId = appFields.measurementId;
          _b2.label = 1;
        case 1:
          _b2.trys.push([1, 3, , 4]);
          return [4, setAbortableTimeout$1(signal, throttleEndTimeMillis)];
        case 2:
          _b2.sent();
          return [3, 4];
        case 3:
          e_1 = _b2.sent();
          if (measurementId) {
            logger.warn("Timed out fetching this Firebase app's measurement ID from the server." + (" Falling back to the measurement ID " + measurementId) + (' provided in the "measurementId" field in the local Firebase config. [' + e_1.message + "]"));
            return [2, { appId, measurementId }];
          }
          throw e_1;
        case 4:
          _b2.trys.push([4, 6, , 7]);
          return [4, fetchDynamicConfig(appFields)];
        case 5:
          response = _b2.sent();
          retryData.deleteThrottleMetadata(appId);
          return [2, response];
        case 6:
          e_2 = _b2.sent();
          if (!isRetriableError$1(e_2)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
              logger.warn("Failed to fetch this Firebase app's measurement ID from the server." + (" Falling back to the measurement ID " + measurementId) + (' provided in the "measurementId" field in the local Firebase config. [' + e_2.message + "]"));
              return [2, { appId, measurementId }];
            } else {
              throw e_2;
            }
          }
          backoffMillis = Number(e_2.customData.httpStatus) === 503 ? calculateBackoffMillis(backoffCount, retryData.intervalMillis, LONG_RETRY_FACTOR) : calculateBackoffMillis(backoffCount, retryData.intervalMillis);
          throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
          };
          retryData.setThrottleMetadata(appId, throttleMetadata);
          logger.debug("Calling attemptFetch again in " + backoffMillis + " millis");
          return [2, attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData)];
        case 7:
          return [2];
      }
    });
  });
}
function setAbortableTimeout$1(signal, throttleEndTimeMillis) {
  return new Promise(function(resolve, reject) {
    var backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
    var timeout = setTimeout(resolve, backoffMillis);
    signal.addEventListener(function() {
      clearTimeout(timeout);
      reject(ERROR_FACTORY$1.create("fetch-throttle", {
        throttleEndTimeMillis
      }));
    });
  });
}
function isRetriableError$1(e28) {
  if (!(e28 instanceof FirebaseError) || !e28.customData) {
    return false;
  }
  var httpStatus = Number(e28.customData["httpStatus"]);
  return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
var AnalyticsAbortSignal = function() {
  function AnalyticsAbortSignal2() {
    this.listeners = [];
  }
  AnalyticsAbortSignal2.prototype.addEventListener = function(listener) {
    this.listeners.push(listener);
  };
  AnalyticsAbortSignal2.prototype.abort = function() {
    this.listeners.forEach(function(listener) {
      return listener();
    });
  };
  return AnalyticsAbortSignal2;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function validateIndexedDB() {
  return __awaiter(this, void 0, void 0, function() {
    var e_1;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (!!isIndexedDBAvailable())
            return [3, 1];
          logger.warn(ERROR_FACTORY$1.create("indexeddb-unavailable", {
            errorInfo: "IndexedDB is not available in this environment."
          }).message);
          return [2, false];
        case 1:
          _a2.trys.push([1, 3, , 4]);
          return [4, validateIndexedDBOpenable()];
        case 2:
          _a2.sent();
          return [3, 4];
        case 3:
          e_1 = _a2.sent();
          logger.warn(ERROR_FACTORY$1.create("indexeddb-unavailable", {
            errorInfo: e_1
          }).message);
          return [2, false];
        case 4:
          return [2, true];
      }
    });
  });
}
function initializeIds(app, dynamicConfigPromisesList2, measurementIdToAppId2, installations, gtagCore) {
  return __awaiter(this, void 0, void 0, function() {
    var dynamicConfigPromise, fidPromise, _a2, dynamicConfig, fid, configProperties;
    var _b2;
    return __generator(this, function(_c2) {
      switch (_c2.label) {
        case 0:
          dynamicConfigPromise = fetchDynamicConfigWithRetry(app);
          dynamicConfigPromise.then(function(config) {
            measurementIdToAppId2[config.measurementId] = config.appId;
            if (app.options.measurementId && config.measurementId !== app.options.measurementId) {
              logger.warn("The measurement ID in the local Firebase config (" + app.options.measurementId + ")" + (" does not match the measurement ID fetched from the server (" + config.measurementId + ").") + " To ensure analytics events are always sent to the correct Analytics property, update the measurement ID field in the local config or remove it from the local config.");
            }
          }).catch(function(e28) {
            return logger.error(e28);
          });
          dynamicConfigPromisesList2.push(dynamicConfigPromise);
          fidPromise = validateIndexedDB().then(function(envIsValid) {
            if (envIsValid) {
              return installations.getId();
            } else {
              return void 0;
            }
          });
          return [4, Promise.all([
            dynamicConfigPromise,
            fidPromise
          ])];
        case 1:
          _a2 = _c2.sent(), dynamicConfig = _a2[0], fid = _a2[1];
          gtagCore("js", new Date());
          configProperties = (_b2 = {}, _b2[ORIGIN_KEY] = "firebase", _b2.update = true, _b2);
          if (fid != null) {
            configProperties[GA_FID_KEY] = fid;
          }
          gtagCore(GtagCommand.CONFIG, dynamicConfig.measurementId, configProperties);
          return [2, dynamicConfig.measurementId];
      }
    });
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var initializationPromisesMap = {};
var dynamicConfigPromisesList = [];
var measurementIdToAppId = {};
var dataLayerName = "dataLayer";
var gtagName = "gtag";
var gtagCoreFunction;
var wrappedGtagFunction;
var globalInitDone = false;
function settings(options) {
  if (globalInitDone) {
    throw ERROR_FACTORY$1.create("already-initialized");
  }
  if (options.dataLayerName) {
    dataLayerName = options.dataLayerName;
  }
  if (options.gtagName) {
    gtagName = options.gtagName;
  }
}
function warnOnBrowserContextMismatch() {
  var mismatchedEnvMessages = [];
  if (isBrowserExtension()) {
    mismatchedEnvMessages.push("This is a browser extension environment.");
  }
  if (!areCookiesEnabled()) {
    mismatchedEnvMessages.push("Cookies are not available.");
  }
  if (mismatchedEnvMessages.length > 0) {
    var details = mismatchedEnvMessages.map(function(message, index) {
      return "(" + (index + 1) + ") " + message;
    }).join(" ");
    var err = ERROR_FACTORY$1.create("invalid-analytics-context", {
      errorInfo: details
    });
    logger.warn(err.message);
  }
}
function factory(app, installations) {
  warnOnBrowserContextMismatch();
  var appId = app.options.appId;
  if (!appId) {
    throw ERROR_FACTORY$1.create("no-app-id");
  }
  if (!app.options.apiKey) {
    if (app.options.measurementId) {
      logger.warn('The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest' + (" measurement ID for this Firebase app. Falling back to the measurement ID " + app.options.measurementId) + ' provided in the "measurementId" field in the local Firebase config.');
    } else {
      throw ERROR_FACTORY$1.create("no-api-key");
    }
  }
  if (initializationPromisesMap[appId] != null) {
    throw ERROR_FACTORY$1.create("already-exists", {
      id: appId
    });
  }
  if (!globalInitDone) {
    if (!findGtagScriptOnPage()) {
      insertScriptTag(dataLayerName);
    }
    getOrCreateDataLayer(dataLayerName);
    var _a2 = wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagName), wrappedGtag = _a2.wrappedGtag, gtagCore = _a2.gtagCore;
    wrappedGtagFunction = wrappedGtag;
    gtagCoreFunction = gtagCore;
    globalInitDone = true;
  }
  initializationPromisesMap[appId] = initializeIds(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCoreFunction);
  var analyticsInstance = {
    app,
    logEvent: function(eventName, eventParams, options) {
      logEvent(wrappedGtagFunction, initializationPromisesMap[appId], eventName, eventParams, options).catch(function(e28) {
        return logger.error(e28);
      });
    },
    setCurrentScreen: function(screenName, options) {
      setCurrentScreen(wrappedGtagFunction, initializationPromisesMap[appId], screenName, options).catch(function(e28) {
        return logger.error(e28);
      });
    },
    setUserId: function(id2, options) {
      setUserId(wrappedGtagFunction, initializationPromisesMap[appId], id2, options).catch(function(e28) {
        return logger.error(e28);
      });
    },
    setUserProperties: function(properties, options) {
      setUserProperties(wrappedGtagFunction, initializationPromisesMap[appId], properties, options).catch(function(e28) {
        return logger.error(e28);
      });
    },
    setAnalyticsCollectionEnabled: function(enabled) {
      setAnalyticsCollectionEnabled(initializationPromisesMap[appId], enabled).catch(function(e28) {
        return logger.error(e28);
      });
    },
    INTERNAL: {
      delete: function() {
        delete initializationPromisesMap[appId];
        return Promise.resolve();
      }
    }
  };
  return analyticsInstance;
}
var name$3 = "@firebase/analytics";
var version$3 = "0.6.2";
var ANALYTICS_TYPE = "analytics";
function registerAnalytics(instance) {
  instance.INTERNAL.registerComponent(new Component(ANALYTICS_TYPE, function(container) {
    var app = container.getProvider("app").getImmediate();
    var installations = container.getProvider("installations").getImmediate();
    return factory(app, installations);
  }, "PUBLIC").setServiceProps({
    settings,
    EventName,
    isSupported
  }));
  instance.INTERNAL.registerComponent(new Component("analytics-internal", internalFactory, "PRIVATE"));
  instance.registerVersion(name$3, version$3);
  function internalFactory(container) {
    try {
      var analytics = container.getProvider(ANALYTICS_TYPE).getImmediate();
      return {
        logEvent: analytics.logEvent
      };
    } catch (e28) {
      throw ERROR_FACTORY$1.create("interop-component-reg-failed", {
        reason: e28
      });
    }
  }
}
registerAnalytics(firebase$1);
function isSupported() {
  return __awaiter(this, void 0, void 0, function() {
    var isDBOpenable;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (isBrowserExtension()) {
            return [2, false];
          }
          if (!areCookiesEnabled()) {
            return [2, false];
          }
          if (!isIndexedDBAvailable()) {
            return [2, false];
          }
          _a2.label = 1;
        case 1:
          _a2.trys.push([1, 3, , 4]);
          return [4, validateIndexedDBOpenable()];
        case 2:
          isDBOpenable = _a2.sent();
          return [2, isDBOpenable];
        case 3:
          _a2.sent();
          return [2, false];
        case 4:
          return [2];
      }
    });
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var CachingClient = function() {
  function CachingClient2(client, storage, storageCache, logger2) {
    this.client = client;
    this.storage = storage;
    this.storageCache = storageCache;
    this.logger = logger2;
  }
  CachingClient2.prototype.isCachedDataFresh = function(cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis) {
    if (!lastSuccessfulFetchTimestampMillis) {
      this.logger.debug("Config fetch cache check. Cache unpopulated.");
      return false;
    }
    var cacheAgeMillis = Date.now() - lastSuccessfulFetchTimestampMillis;
    var isCachedDataFresh = cacheAgeMillis <= cacheMaxAgeMillis;
    this.logger.debug("Config fetch cache check." + (" Cache age millis: " + cacheAgeMillis + ".") + (" Cache max age millis (minimumFetchIntervalMillis setting): " + cacheMaxAgeMillis + ".") + (" Is cache hit: " + isCachedDataFresh + "."));
    return isCachedDataFresh;
  };
  CachingClient2.prototype.fetch = function(request) {
    return __awaiter(this, void 0, void 0, function() {
      var _a2, lastSuccessfulFetchTimestampMillis, lastSuccessfulFetchResponse, response, storageOperations;
      return __generator(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            return [4, Promise.all([
              this.storage.getLastSuccessfulFetchTimestampMillis(),
              this.storage.getLastSuccessfulFetchResponse()
            ])];
          case 1:
            _a2 = _b2.sent(), lastSuccessfulFetchTimestampMillis = _a2[0], lastSuccessfulFetchResponse = _a2[1];
            if (lastSuccessfulFetchResponse && this.isCachedDataFresh(request.cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis)) {
              return [2, lastSuccessfulFetchResponse];
            }
            request.eTag = lastSuccessfulFetchResponse && lastSuccessfulFetchResponse.eTag;
            return [4, this.client.fetch(request)];
          case 2:
            response = _b2.sent();
            storageOperations = [
              this.storageCache.setLastSuccessfulFetchTimestampMillis(Date.now())
            ];
            if (response.status === 200) {
              storageOperations.push(this.storage.setLastSuccessfulFetchResponse(response));
            }
            return [4, Promise.all(storageOperations)];
          case 3:
            _b2.sent();
            return [2, response];
        }
      });
    });
  };
  return CachingClient2;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERROR_DESCRIPTION_MAP = (_a = {}, _a["registration-window"] = "Undefined window object. This SDK only supports usage in a browser environment.", _a["registration-project-id"] = "Undefined project identifier. Check Firebase app initialization.", _a["registration-api-key"] = "Undefined API key. Check Firebase app initialization.", _a["registration-app-id"] = "Undefined app identifier. Check Firebase app initialization.", _a["storage-open"] = "Error thrown when opening storage. Original error: {$originalErrorMessage}.", _a["storage-get"] = "Error thrown when reading from storage. Original error: {$originalErrorMessage}.", _a["storage-set"] = "Error thrown when writing to storage. Original error: {$originalErrorMessage}.", _a["storage-delete"] = "Error thrown when deleting from storage. Original error: {$originalErrorMessage}.", _a["fetch-client-network"] = "Fetch client failed to connect to a network. Check Internet connection. Original error: {$originalErrorMessage}.", _a["fetch-timeout"] = 'The config fetch request timed out.  Configure timeout using "fetchTimeoutMillis" SDK setting.', _a["fetch-throttle"] = 'The config fetch request timed out while in an exponential backoff state. Configure timeout using "fetchTimeoutMillis" SDK setting. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.', _a["fetch-client-parse"] = "Fetch client could not parse response. Original error: {$originalErrorMessage}.", _a["fetch-status"] = "Fetch server returned an HTTP error status. HTTP status: {$httpStatus}.", _a);
var ERROR_FACTORY = new ErrorFactory("remoteconfig", "Remote Config", ERROR_DESCRIPTION_MAP);
function hasErrorCode(e28, errorCode) {
  return e28 instanceof FirebaseError && e28.code.indexOf(errorCode) !== -1;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getUserLanguage(navigatorLanguage) {
  if (navigatorLanguage === void 0) {
    navigatorLanguage = navigator;
  }
  return navigatorLanguage.languages && navigatorLanguage.languages[0] || navigatorLanguage.language;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RestClient = function() {
  function RestClient2(firebaseInstallations, sdkVersion, namespace, projectId, apiKey, appId) {
    this.firebaseInstallations = firebaseInstallations;
    this.sdkVersion = sdkVersion;
    this.namespace = namespace;
    this.projectId = projectId;
    this.apiKey = apiKey;
    this.appId = appId;
  }
  RestClient2.prototype.fetch = function(request) {
    return __awaiter(this, void 0, void 0, function() {
      var _a2, installationId, installationToken, urlBase, url, headers, requestBody, options, fetchPromise, timeoutPromise, response, originalError_1, errorCode, status, responseEtag, config, state, responseBody, originalError_2;
      return __generator(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            return [4, Promise.all([
              this.firebaseInstallations.getId(),
              this.firebaseInstallations.getToken()
            ])];
          case 1:
            _a2 = _b2.sent(), installationId = _a2[0], installationToken = _a2[1];
            urlBase = window.FIREBASE_REMOTE_CONFIG_URL_BASE || "https://firebaseremoteconfig.googleapis.com";
            url = urlBase + "/v1/projects/" + this.projectId + "/namespaces/" + this.namespace + ":fetch?key=" + this.apiKey;
            headers = {
              "Content-Type": "application/json",
              "Content-Encoding": "gzip",
              "If-None-Match": request.eTag || "*"
            };
            requestBody = {
              sdk_version: this.sdkVersion,
              app_instance_id: installationId,
              app_instance_id_token: installationToken,
              app_id: this.appId,
              language_code: getUserLanguage()
            };
            options = {
              method: "POST",
              headers,
              body: JSON.stringify(requestBody)
            };
            fetchPromise = fetch(url, options);
            timeoutPromise = new Promise(function(_resolve, reject) {
              request.signal.addEventListener(function() {
                var error2 = new Error("The operation was aborted.");
                error2.name = "AbortError";
                reject(error2);
              });
            });
            _b2.label = 2;
          case 2:
            _b2.trys.push([2, 5, , 6]);
            return [4, Promise.race([fetchPromise, timeoutPromise])];
          case 3:
            _b2.sent();
            return [4, fetchPromise];
          case 4:
            response = _b2.sent();
            return [3, 6];
          case 5:
            originalError_1 = _b2.sent();
            errorCode = "fetch-client-network";
            if (originalError_1.name === "AbortError") {
              errorCode = "fetch-timeout";
            }
            throw ERROR_FACTORY.create(errorCode, {
              originalErrorMessage: originalError_1.message
            });
          case 6:
            status = response.status;
            responseEtag = response.headers.get("ETag") || void 0;
            if (!(response.status === 200))
              return [3, 11];
            responseBody = void 0;
            _b2.label = 7;
          case 7:
            _b2.trys.push([7, 9, , 10]);
            return [4, response.json()];
          case 8:
            responseBody = _b2.sent();
            return [3, 10];
          case 9:
            originalError_2 = _b2.sent();
            throw ERROR_FACTORY.create("fetch-client-parse", {
              originalErrorMessage: originalError_2.message
            });
          case 10:
            config = responseBody["entries"];
            state = responseBody["state"];
            _b2.label = 11;
          case 11:
            if (state === "INSTANCE_STATE_UNSPECIFIED") {
              status = 500;
            } else if (state === "NO_CHANGE") {
              status = 304;
            } else if (state === "NO_TEMPLATE" || state === "EMPTY_CONFIG") {
              config = {};
            }
            if (status !== 304 && status !== 200) {
              throw ERROR_FACTORY.create("fetch-status", {
                httpStatus: status
              });
            }
            return [2, { status, eTag: responseEtag, config }];
        }
      });
    });
  };
  return RestClient2;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RemoteConfigAbortSignal = function() {
  function RemoteConfigAbortSignal2() {
    this.listeners = [];
  }
  RemoteConfigAbortSignal2.prototype.addEventListener = function(listener) {
    this.listeners.push(listener);
  };
  RemoteConfigAbortSignal2.prototype.abort = function() {
    this.listeners.forEach(function(listener) {
      return listener();
    });
  };
  return RemoteConfigAbortSignal2;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_VALUE_FOR_BOOLEAN = false;
var DEFAULT_VALUE_FOR_STRING = "";
var DEFAULT_VALUE_FOR_NUMBER = 0;
var BOOLEAN_TRUTHY_VALUES = ["1", "true", "t", "yes", "y", "on"];
var Value = function() {
  function Value2(_source, _value) {
    if (_value === void 0) {
      _value = DEFAULT_VALUE_FOR_STRING;
    }
    this._source = _source;
    this._value = _value;
  }
  Value2.prototype.asString = function() {
    return this._value;
  };
  Value2.prototype.asBoolean = function() {
    if (this._source === "static") {
      return DEFAULT_VALUE_FOR_BOOLEAN;
    }
    return BOOLEAN_TRUTHY_VALUES.indexOf(this._value.toLowerCase()) >= 0;
  };
  Value2.prototype.asNumber = function() {
    if (this._source === "static") {
      return DEFAULT_VALUE_FOR_NUMBER;
    }
    var num = Number(this._value);
    if (isNaN(num)) {
      num = DEFAULT_VALUE_FOR_NUMBER;
    }
    return num;
  };
  Value2.prototype.getSource = function() {
    return this._source;
  };
  return Value2;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_FETCH_TIMEOUT_MILLIS = 60 * 1e3;
var DEFAULT_CACHE_MAX_AGE_MILLIS = 12 * 60 * 60 * 1e3;
var RemoteConfig = function() {
  function RemoteConfig2(app, _client, _storageCache, _storage, _logger) {
    this.app = app;
    this._client = _client;
    this._storageCache = _storageCache;
    this._storage = _storage;
    this._logger = _logger;
    this._isInitializationComplete = false;
    this.settings = {
      fetchTimeoutMillis: DEFAULT_FETCH_TIMEOUT_MILLIS,
      minimumFetchIntervalMillis: DEFAULT_CACHE_MAX_AGE_MILLIS
    };
    this.defaultConfig = {};
  }
  RemoteConfig2.prototype.setLogLevel = function(logLevel) {
    switch (logLevel) {
      case "debug":
        this._logger.logLevel = LogLevel.DEBUG;
        break;
      case "silent":
        this._logger.logLevel = LogLevel.SILENT;
        break;
      default:
        this._logger.logLevel = LogLevel.ERROR;
    }
  };
  Object.defineProperty(RemoteConfig2.prototype, "fetchTimeMillis", {
    get: function() {
      return this._storageCache.getLastSuccessfulFetchTimestampMillis() || -1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(RemoteConfig2.prototype, "lastFetchStatus", {
    get: function() {
      return this._storageCache.getLastFetchStatus() || "no-fetch-yet";
    },
    enumerable: false,
    configurable: true
  });
  RemoteConfig2.prototype.activate = function() {
    return __awaiter(this, void 0, void 0, function() {
      var _a2, lastSuccessfulFetchResponse, activeConfigEtag;
      return __generator(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            return [4, Promise.all([
              this._storage.getLastSuccessfulFetchResponse(),
              this._storage.getActiveConfigEtag()
            ])];
          case 1:
            _a2 = _b2.sent(), lastSuccessfulFetchResponse = _a2[0], activeConfigEtag = _a2[1];
            if (!lastSuccessfulFetchResponse || !lastSuccessfulFetchResponse.config || !lastSuccessfulFetchResponse.eTag || lastSuccessfulFetchResponse.eTag === activeConfigEtag) {
              return [2, false];
            }
            return [4, Promise.all([
              this._storageCache.setActiveConfig(lastSuccessfulFetchResponse.config),
              this._storage.setActiveConfigEtag(lastSuccessfulFetchResponse.eTag)
            ])];
          case 2:
            _b2.sent();
            return [2, true];
        }
      });
    });
  };
  RemoteConfig2.prototype.ensureInitialized = function() {
    var _this = this;
    if (!this._initializePromise) {
      this._initializePromise = this._storageCache.loadFromStorage().then(function() {
        _this._isInitializationComplete = true;
      });
    }
    return this._initializePromise;
  };
  RemoteConfig2.prototype.fetch = function() {
    return __awaiter(this, void 0, void 0, function() {
      var abortSignal, e_1, lastFetchStatus;
      var _this = this;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            abortSignal = new RemoteConfigAbortSignal();
            setTimeout(function() {
              return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a3) {
                  abortSignal.abort();
                  return [2];
                });
              });
            }, this.settings.fetchTimeoutMillis);
            _a2.label = 1;
          case 1:
            _a2.trys.push([1, 4, , 6]);
            return [4, this._client.fetch({
              cacheMaxAgeMillis: this.settings.minimumFetchIntervalMillis,
              signal: abortSignal
            })];
          case 2:
            _a2.sent();
            return [4, this._storageCache.setLastFetchStatus("success")];
          case 3:
            _a2.sent();
            return [3, 6];
          case 4:
            e_1 = _a2.sent();
            lastFetchStatus = hasErrorCode(e_1, "fetch-throttle") ? "throttle" : "failure";
            return [4, this._storageCache.setLastFetchStatus(lastFetchStatus)];
          case 5:
            _a2.sent();
            throw e_1;
          case 6:
            return [2];
        }
      });
    });
  };
  RemoteConfig2.prototype.fetchAndActivate = function() {
    return __awaiter(this, void 0, void 0, function() {
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            return [4, this.fetch()];
          case 1:
            _a2.sent();
            return [2, this.activate()];
        }
      });
    });
  };
  RemoteConfig2.prototype.getAll = function() {
    var _this = this;
    return getAllKeys(this._storageCache.getActiveConfig(), this.defaultConfig).reduce(function(allConfigs, key) {
      allConfigs[key] = _this.getValue(key);
      return allConfigs;
    }, {});
  };
  RemoteConfig2.prototype.getBoolean = function(key) {
    return this.getValue(key).asBoolean();
  };
  RemoteConfig2.prototype.getNumber = function(key) {
    return this.getValue(key).asNumber();
  };
  RemoteConfig2.prototype.getString = function(key) {
    return this.getValue(key).asString();
  };
  RemoteConfig2.prototype.getValue = function(key) {
    if (!this._isInitializationComplete) {
      this._logger.debug('A value was requested for key "' + key + '" before SDK initialization completed. Await on ensureInitialized if the intent was to get a previously activated value.');
    }
    var activeConfig = this._storageCache.getActiveConfig();
    if (activeConfig && activeConfig[key] !== void 0) {
      return new Value("remote", activeConfig[key]);
    } else if (this.defaultConfig && this.defaultConfig[key] !== void 0) {
      return new Value("default", String(this.defaultConfig[key]));
    }
    this._logger.debug('Returning static value for key "' + key + '". Define a default or remote value if this is unintentional.');
    return new Value("static");
  };
  return RemoteConfig2;
}();
function getAllKeys(obj1, obj2) {
  if (obj1 === void 0) {
    obj1 = {};
  }
  if (obj2 === void 0) {
    obj2 = {};
  }
  return Object.keys(__assign(__assign({}, obj1), obj2));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function toFirebaseError(event2, errorCode) {
  var originalError = event2.target.error || void 0;
  return ERROR_FACTORY.create(errorCode, {
    originalErrorMessage: originalError && originalError.message
  });
}
var APP_NAMESPACE_STORE = "app_namespace_store";
var DB_NAME = "firebase_remote_config";
var DB_VERSION = 1;
function openDatabase() {
  return new Promise(function(resolve, reject) {
    var request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = function(event2) {
      reject(toFirebaseError(event2, "storage-open"));
    };
    request.onsuccess = function(event2) {
      resolve(event2.target.result);
    };
    request.onupgradeneeded = function(event2) {
      var db2 = event2.target.result;
      switch (event2.oldVersion) {
        case 0:
          db2.createObjectStore(APP_NAMESPACE_STORE, {
            keyPath: "compositeKey"
          });
      }
    };
  });
}
var Storage = function() {
  function Storage2(appId, appName, namespace, openDbPromise) {
    if (openDbPromise === void 0) {
      openDbPromise = openDatabase();
    }
    this.appId = appId;
    this.appName = appName;
    this.namespace = namespace;
    this.openDbPromise = openDbPromise;
  }
  Storage2.prototype.getLastFetchStatus = function() {
    return this.get("last_fetch_status");
  };
  Storage2.prototype.setLastFetchStatus = function(status) {
    return this.set("last_fetch_status", status);
  };
  Storage2.prototype.getLastSuccessfulFetchTimestampMillis = function() {
    return this.get("last_successful_fetch_timestamp_millis");
  };
  Storage2.prototype.setLastSuccessfulFetchTimestampMillis = function(timestamp) {
    return this.set("last_successful_fetch_timestamp_millis", timestamp);
  };
  Storage2.prototype.getLastSuccessfulFetchResponse = function() {
    return this.get("last_successful_fetch_response");
  };
  Storage2.prototype.setLastSuccessfulFetchResponse = function(response) {
    return this.set("last_successful_fetch_response", response);
  };
  Storage2.prototype.getActiveConfig = function() {
    return this.get("active_config");
  };
  Storage2.prototype.setActiveConfig = function(config) {
    return this.set("active_config", config);
  };
  Storage2.prototype.getActiveConfigEtag = function() {
    return this.get("active_config_etag");
  };
  Storage2.prototype.setActiveConfigEtag = function(etag) {
    return this.set("active_config_etag", etag);
  };
  Storage2.prototype.getThrottleMetadata = function() {
    return this.get("throttle_metadata");
  };
  Storage2.prototype.setThrottleMetadata = function(metadata2) {
    return this.set("throttle_metadata", metadata2);
  };
  Storage2.prototype.deleteThrottleMetadata = function() {
    return this.delete("throttle_metadata");
  };
  Storage2.prototype.get = function(key) {
    return __awaiter(this, void 0, void 0, function() {
      var db2;
      var _this = this;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            return [4, this.openDbPromise];
          case 1:
            db2 = _a2.sent();
            return [2, new Promise(function(resolve, reject) {
              var transaction = db2.transaction([APP_NAMESPACE_STORE], "readonly");
              var objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
              var compositeKey = _this.createCompositeKey(key);
              try {
                var request = objectStore.get(compositeKey);
                request.onerror = function(event2) {
                  reject(toFirebaseError(event2, "storage-get"));
                };
                request.onsuccess = function(event2) {
                  var result2 = event2.target.result;
                  if (result2) {
                    resolve(result2.value);
                  } else {
                    resolve(void 0);
                  }
                };
              } catch (e28) {
                reject(ERROR_FACTORY.create("storage-get", {
                  originalErrorMessage: e28 && e28.message
                }));
              }
            })];
        }
      });
    });
  };
  Storage2.prototype.set = function(key, value) {
    return __awaiter(this, void 0, void 0, function() {
      var db2;
      var _this = this;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            return [4, this.openDbPromise];
          case 1:
            db2 = _a2.sent();
            return [2, new Promise(function(resolve, reject) {
              var transaction = db2.transaction([APP_NAMESPACE_STORE], "readwrite");
              var objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
              var compositeKey = _this.createCompositeKey(key);
              try {
                var request = objectStore.put({
                  compositeKey,
                  value
                });
                request.onerror = function(event2) {
                  reject(toFirebaseError(event2, "storage-set"));
                };
                request.onsuccess = function() {
                  resolve();
                };
              } catch (e28) {
                reject(ERROR_FACTORY.create("storage-set", {
                  originalErrorMessage: e28 && e28.message
                }));
              }
            })];
        }
      });
    });
  };
  Storage2.prototype.delete = function(key) {
    return __awaiter(this, void 0, void 0, function() {
      var db2;
      var _this = this;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            return [4, this.openDbPromise];
          case 1:
            db2 = _a2.sent();
            return [2, new Promise(function(resolve, reject) {
              var transaction = db2.transaction([APP_NAMESPACE_STORE], "readwrite");
              var objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
              var compositeKey = _this.createCompositeKey(key);
              try {
                var request = objectStore.delete(compositeKey);
                request.onerror = function(event2) {
                  reject(toFirebaseError(event2, "storage-delete"));
                };
                request.onsuccess = function() {
                  resolve();
                };
              } catch (e28) {
                reject(ERROR_FACTORY.create("storage-delete", {
                  originalErrorMessage: e28 && e28.message
                }));
              }
            })];
        }
      });
    });
  };
  Storage2.prototype.createCompositeKey = function(key) {
    return [this.appId, this.appName, this.namespace, key].join();
  };
  return Storage2;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StorageCache = function() {
  function StorageCache2(storage) {
    this.storage = storage;
  }
  StorageCache2.prototype.getLastFetchStatus = function() {
    return this.lastFetchStatus;
  };
  StorageCache2.prototype.getLastSuccessfulFetchTimestampMillis = function() {
    return this.lastSuccessfulFetchTimestampMillis;
  };
  StorageCache2.prototype.getActiveConfig = function() {
    return this.activeConfig;
  };
  StorageCache2.prototype.loadFromStorage = function() {
    return __awaiter(this, void 0, void 0, function() {
      var lastFetchStatusPromise, lastSuccessfulFetchTimestampMillisPromise, activeConfigPromise, lastFetchStatus, lastSuccessfulFetchTimestampMillis, activeConfig;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            lastFetchStatusPromise = this.storage.getLastFetchStatus();
            lastSuccessfulFetchTimestampMillisPromise = this.storage.getLastSuccessfulFetchTimestampMillis();
            activeConfigPromise = this.storage.getActiveConfig();
            return [4, lastFetchStatusPromise];
          case 1:
            lastFetchStatus = _a2.sent();
            if (lastFetchStatus) {
              this.lastFetchStatus = lastFetchStatus;
            }
            return [4, lastSuccessfulFetchTimestampMillisPromise];
          case 2:
            lastSuccessfulFetchTimestampMillis = _a2.sent();
            if (lastSuccessfulFetchTimestampMillis) {
              this.lastSuccessfulFetchTimestampMillis = lastSuccessfulFetchTimestampMillis;
            }
            return [4, activeConfigPromise];
          case 3:
            activeConfig = _a2.sent();
            if (activeConfig) {
              this.activeConfig = activeConfig;
            }
            return [2];
        }
      });
    });
  };
  StorageCache2.prototype.setLastFetchStatus = function(status) {
    this.lastFetchStatus = status;
    return this.storage.setLastFetchStatus(status);
  };
  StorageCache2.prototype.setLastSuccessfulFetchTimestampMillis = function(timestampMillis) {
    this.lastSuccessfulFetchTimestampMillis = timestampMillis;
    return this.storage.setLastSuccessfulFetchTimestampMillis(timestampMillis);
  };
  StorageCache2.prototype.setActiveConfig = function(activeConfig) {
    this.activeConfig = activeConfig;
    return this.storage.setActiveConfig(activeConfig);
  };
  return StorageCache2;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function setAbortableTimeout(signal, throttleEndTimeMillis) {
  return new Promise(function(resolve, reject) {
    var backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
    var timeout = setTimeout(resolve, backoffMillis);
    signal.addEventListener(function() {
      clearTimeout(timeout);
      reject(ERROR_FACTORY.create("fetch-throttle", {
        throttleEndTimeMillis
      }));
    });
  });
}
function isRetriableError(e28) {
  if (!(e28 instanceof FirebaseError) || !e28.customData) {
    return false;
  }
  var httpStatus = Number(e28.customData["httpStatus"]);
  return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
var RetryingClient = function() {
  function RetryingClient2(client, storage) {
    this.client = client;
    this.storage = storage;
  }
  RetryingClient2.prototype.fetch = function(request) {
    return __awaiter(this, void 0, void 0, function() {
      var throttleMetadata;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            return [4, this.storage.getThrottleMetadata()];
          case 1:
            throttleMetadata = _a2.sent() || {
              backoffCount: 0,
              throttleEndTimeMillis: Date.now()
            };
            return [2, this.attemptFetch(request, throttleMetadata)];
        }
      });
    });
  };
  RetryingClient2.prototype.attemptFetch = function(request, _a2) {
    var throttleEndTimeMillis = _a2.throttleEndTimeMillis, backoffCount = _a2.backoffCount;
    return __awaiter(this, void 0, void 0, function() {
      var response, e_1, throttleMetadata;
      return __generator(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            return [4, setAbortableTimeout(request.signal, throttleEndTimeMillis)];
          case 1:
            _b2.sent();
            _b2.label = 2;
          case 2:
            _b2.trys.push([2, 5, , 7]);
            return [4, this.client.fetch(request)];
          case 3:
            response = _b2.sent();
            return [4, this.storage.deleteThrottleMetadata()];
          case 4:
            _b2.sent();
            return [2, response];
          case 5:
            e_1 = _b2.sent();
            if (!isRetriableError(e_1)) {
              throw e_1;
            }
            throttleMetadata = {
              throttleEndTimeMillis: Date.now() + calculateBackoffMillis(backoffCount),
              backoffCount: backoffCount + 1
            };
            return [4, this.storage.setThrottleMetadata(throttleMetadata)];
          case 6:
            _b2.sent();
            return [2, this.attemptFetch(request, throttleMetadata)];
          case 7:
            return [2];
        }
      });
    });
  };
  return RetryingClient2;
}();
var name$2 = "@firebase/remote-config";
var version$2 = "0.1.30";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerRemoteConfig(firebaseInstance) {
  firebaseInstance.INTERNAL.registerComponent(new Component("remoteConfig", remoteConfigFactory, "PUBLIC").setMultipleInstances(true));
  firebaseInstance.registerVersion(name$2, version$2);
  function remoteConfigFactory(container, namespace) {
    var app = container.getProvider("app").getImmediate();
    var installations = container.getProvider("installations").getImmediate();
    if (typeof window === "undefined") {
      throw ERROR_FACTORY.create("registration-window");
    }
    var _a2 = app.options, projectId = _a2.projectId, apiKey = _a2.apiKey, appId = _a2.appId;
    if (!projectId) {
      throw ERROR_FACTORY.create("registration-project-id");
    }
    if (!apiKey) {
      throw ERROR_FACTORY.create("registration-api-key");
    }
    if (!appId) {
      throw ERROR_FACTORY.create("registration-app-id");
    }
    namespace = namespace || "firebase";
    var storage = new Storage(appId, app.name, namespace);
    var storageCache = new StorageCache(storage);
    var logger2 = new Logger(name$2);
    logger2.logLevel = LogLevel.ERROR;
    var restClient = new RestClient(installations, firebaseInstance.SDK_VERSION, namespace, projectId, apiKey, appId);
    var retryingClient = new RetryingClient(restClient, storage);
    var cachingClient = new CachingClient(retryingClient, storage, storageCache, logger2);
    var remoteConfigInstance = new RemoteConfig(app, cachingClient, storageCache, storage, logger2);
    remoteConfigInstance.ensureInitialized();
    return remoteConfigInstance;
  }
}
registerRemoteConfig(firebase$1);
var name$1 = "firebase";
var version$1 = "8.2.1";
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
firebase$1.registerVersion(name$1, version$1, "app");
var name$1$1 = "firebase";
var version$1$1 = "8.2.1";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
console.warn("\nIt looks like you're using the development build of the Firebase JS SDK.\nWhen deploying Firebase apps to production, it is advisable to only import\nthe individual SDK components you intend to use.\n\nFor the module builds, these are available in the following manner\n(replace <PACKAGE> with the name of a component - i.e. auth, database, etc):\n\nCommonJS Modules:\nconst firebase = require('firebase/app');\nrequire('firebase/<PACKAGE>');\n\nES Modules:\nimport firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n\nTypescript:\nimport firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n");
firebase$1.registerVersion(name$1$1, version$1$1);
/**
* @vue/shared v3.4.20
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const isFunction$1 = (val) => typeof val === "function";
const objectToString = Object.prototype.toString;
const toTypeString = (value) => objectToString.call(value);
const isPlainObject = (val) => toTypeString(val) === "[object Object]";
function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys$5(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$5(Object(source), true).forEach(function(key) {
        _defineProperty$5(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var load = function load2(url) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise(function(resolve, reject) {
    if (typeof document === "undefined") {
      return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var script2 = document.createElement("script");
    script2.async = true;
    script2.src = url;
    script2.defer = options.defer;
    if (options.preconnectOrigin) {
      var link = document.createElement("link");
      link.href = options.preconnectOrigin;
      link.rel = "preconnect";
      head.appendChild(link);
    }
    head.appendChild(script2);
    script2.onload = resolve;
    script2.onerror = reject;
  });
};
var mergeDeep = function mergeDeep2(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  if (!sources.length) {
    return target;
  }
  var source = sources.shift();
  if (!isPlainObject(target) || !isPlainObject(source)) {
    return;
  }
  for (var key in source) {
    if (isPlainObject(source[key])) {
      if (!target[key]) {
        Object.assign(target, _defineProperty$5({}, key, {}));
      }
      mergeDeep2(target[key], source[key]);
    } else {
      Object.assign(target, _defineProperty$5({}, key, source[key]));
    }
  }
  return mergeDeep2.apply(void 0, [target].concat(sources));
};
var isBrowser = function isBrowser2() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }
  return true;
};
var warn$1 = function warn(text) {
  var shouldLog = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  if (!isBrowser() || true) {
    return;
  }
  if (!shouldLog) {
    return;
  }
  console.warn("[vue-gtag] ".concat(text));
};
var validateScreenviewShape = function validateScreenviewShape2() {
  var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  warn$1('Missing "appName" property inside the plugin options.', obj.app_name == null);
  warn$1('Missing "name" property in the route.', obj.screen_name == null);
  return obj;
};
function getPathWithBase() {
  var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  var pathAsArray = path.split("/");
  var baseAsArray = base.split("/");
  if (pathAsArray[0] === "" && base[base.length - 1] === "/") {
    pathAsArray.shift();
  }
  return baseAsArray.join("/") + pathAsArray.join("/");
}
var getDefaultParams = function getDefaultParams2() {
  return {
    bootstrap: true,
    onReady: null,
    onError: null,
    onBeforeTrack: null,
    onAfterTrack: null,
    pageTrackerTemplate: null,
    customResourceURL: "https://www.googletagmanager.com/gtag/js",
    customPreconnectOrigin: "https://www.googletagmanager.com",
    deferScriptLoad: false,
    pageTrackerExcludedRoutes: [],
    pageTrackerEnabled: true,
    enabled: true,
    disableScriptLoad: false,
    pageTrackerScreenviewEnabled: false,
    appName: null,
    pageTrackerUseFullPath: false,
    pageTrackerPrependBase: true,
    pageTrackerSkipSamePath: true,
    globalDataLayerName: "dataLayer",
    globalObjectName: "gtag",
    defaultGroupName: "default",
    includes: null,
    config: {
      id: null,
      params: {
        send_page_view: false
      }
    }
  };
};
var params = {};
var setOptions = function setOptions2() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var defaultParams = getDefaultParams();
  params = mergeDeep(defaultParams, options);
};
var getOptions = function getOptions2() {
  return params;
};
var query = function() {
  var _window;
  var _getOptions = getOptions(), globalObjectName = _getOptions.globalObjectName;
  if (!isBrowser() || typeof window[globalObjectName] === "undefined") {
    return;
  }
  (_window = window)[globalObjectName].apply(_window, arguments);
};
var assignGlobalProperty = function assignGlobalProperty2(id2, value) {
  if (!isBrowser()) {
    return;
  }
  window["ga-disable-".concat(id2)] = value;
};
var disable = function() {
  var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
  var _getOptions = getOptions(), config = _getOptions.config, includes = _getOptions.includes;
  assignGlobalProperty(config.id, value);
  if (Array.isArray(includes)) {
    includes.forEach(function(domain) {
      return assignGlobalProperty(domain.id, value);
    });
  }
};
var optOut = function() {
  disable(true);
};
var router;
var getRouter = function getRouter2() {
  return router;
};
var event = function(name2) {
  var params2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _getOptions = getOptions(), includes = _getOptions.includes, defaultGroupName = _getOptions.defaultGroupName;
  if (params2.send_to == null && Array.isArray(includes) && includes.length) {
    params2.send_to = includes.map(function(domain) {
      return domain.id;
    }).concat(defaultGroupName);
  }
  query("event", name2, params2);
};
var pageview = function(param) {
  if (!isBrowser()) {
    return;
  }
  var template;
  if (typeof param === "string") {
    template = {
      page_path: param
    };
  } else if (param.path || param.fullPath) {
    var _getOptions = getOptions(), useFullPath = _getOptions.pageTrackerUseFullPath, useBase = _getOptions.pageTrackerPrependBase;
    var router2 = getRouter();
    var base = router2 && router2.options.base;
    var path = useFullPath ? param.fullPath : param.path;
    template = _objectSpread2(_objectSpread2({}, param.name && {
      page_title: param.name
    }), {}, {
      page_path: useBase ? getPathWithBase(path, base) : path
    });
  } else {
    template = param;
  }
  if (template.page_location == null) {
    template.page_location = window.location.href;
  }
  if (template.send_page_view == null) {
    template.send_page_view = true;
  }
  event("page_view", template);
};
var screenview = function(param) {
  var _getOptions = getOptions(), appName = _getOptions.appName;
  if (!param) {
    return;
  }
  var template;
  if (typeof param === "string") {
    template = {
      screen_name: param
    };
  } else {
    template = param;
  }
  template.app_name = template.app_name || appName;
  event("screen_view", template);
};
var registerGlobals = function() {
  if (!isBrowser()) {
    return;
  }
  var _getOptions = getOptions(), enabled = _getOptions.enabled, globalObjectName = _getOptions.globalObjectName, globalDataLayerName = _getOptions.globalDataLayerName;
  if (window[globalObjectName] == null) {
    window[globalDataLayerName] = window[globalDataLayerName] || [];
    window[globalObjectName] = function() {
      window[globalDataLayerName].push(arguments);
    };
  }
  window[globalObjectName]("js", new Date());
  if (!enabled) {
    optOut();
  }
  return window[globalObjectName];
};
var mergeDefaultParams = function mergeDefaultParams2(params2) {
  return _objectSpread2({
    send_page_view: false
  }, params2);
};
var addConfiguration = function() {
  var _getOptions = getOptions(), config = _getOptions.config, includes = _getOptions.includes;
  query("config", config.id, mergeDefaultParams(config.params));
  if (Array.isArray(includes)) {
    includes.forEach(function(domain) {
      query("config", domain.id, mergeDefaultParams(domain.params));
    });
  }
};
var track = function() {
  var to2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var from2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _getOptions = getOptions(), appName = _getOptions.appName, proxy = _getOptions.pageTrackerTemplate, useScreenview = _getOptions.pageTrackerScreenviewEnabled, skipSamePath = _getOptions.pageTrackerSkipSamePath;
  if (skipSamePath && to2.path === from2.path) {
    return;
  }
  var template = to2;
  if (isFunction$1(proxy)) {
    template = proxy(to2, from2);
  } else if (useScreenview) {
    template = validateScreenviewShape({
      app_name: appName,
      screen_name: to2.name
    });
  }
  if (useScreenview) {
    screenview(template);
    return;
  }
  pageview(template);
};
var isRouteExcluded = function isRouteExcluded2(route) {
  var _getOptions = getOptions(), routes = _getOptions.pageTrackerExcludedRoutes;
  return routes.includes(route.path) || routes.includes(route.name);
};
var addRoutesTracker = function() {
  var _getOptions2 = getOptions(), onBeforeTrack = _getOptions2.onBeforeTrack, onAfterTrack = _getOptions2.onAfterTrack;
  var router2 = getRouter();
  router2.isReady().then(function() {
    nextTick().then(function() {
      var currentRoute = router2.currentRoute;
      addConfiguration();
      if (isRouteExcluded(currentRoute.value)) {
        return;
      }
      track(currentRoute.value);
    });
    router2.afterEach(function(to2, from2) {
      nextTick().then(function() {
        if (isRouteExcluded(to2)) {
          return;
        }
        if (isFunction$1(onBeforeTrack)) {
          onBeforeTrack(to2, from2);
        }
        track(to2, from2);
        if (isFunction$1(onAfterTrack)) {
          onAfterTrack(to2, from2);
        }
      });
    });
  });
};
var bootstrap = function() {
  var _getOptions = getOptions(), onReady = _getOptions.onReady, onError = _getOptions.onError, globalObjectName = _getOptions.globalObjectName, globalDataLayerName = _getOptions.globalDataLayerName, config = _getOptions.config, customResourceURL = _getOptions.customResourceURL, customPreconnectOrigin = _getOptions.customPreconnectOrigin, deferScriptLoad = _getOptions.deferScriptLoad, pageTrackerEnabled = _getOptions.pageTrackerEnabled, disableScriptLoad = _getOptions.disableScriptLoad;
  var isPageTrackerEnabled = Boolean(pageTrackerEnabled && getRouter());
  registerGlobals();
  if (isPageTrackerEnabled) {
    addRoutesTracker();
  } else {
    addConfiguration();
  }
  if (disableScriptLoad) {
    return;
  }
  return load("".concat(customResourceURL, "?id=").concat(config.id, "&l=").concat(globalDataLayerName), {
    preconnectOrigin: customPreconnectOrigin,
    defer: deferScriptLoad
  }).then(function() {
    if (onReady) {
      onReady(window[globalObjectName]);
    }
  })["catch"](function(error2) {
    if (onError) {
      onError(error2);
    }
    return error2;
  });
};
var metadata = { "version": 4, "country_calling_codes": { "1": ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], "7": ["RU", "KZ"], "20": ["EG"], "27": ["ZA"], "30": ["GR"], "31": ["NL"], "32": ["BE"], "33": ["FR"], "34": ["ES"], "36": ["HU"], "39": ["IT", "VA"], "40": ["RO"], "41": ["CH"], "43": ["AT"], "44": ["GB", "GG", "IM", "JE"], "45": ["DK"], "46": ["SE"], "47": ["NO", "SJ"], "48": ["PL"], "49": ["DE"], "51": ["PE"], "52": ["MX"], "53": ["CU"], "54": ["AR"], "55": ["BR"], "56": ["CL"], "57": ["CO"], "58": ["VE"], "60": ["MY"], "61": ["AU", "CC", "CX"], "62": ["ID"], "63": ["PH"], "64": ["NZ"], "65": ["SG"], "66": ["TH"], "81": ["JP"], "82": ["KR"], "84": ["VN"], "86": ["CN"], "90": ["TR"], "91": ["IN"], "92": ["PK"], "93": ["AF"], "94": ["LK"], "95": ["MM"], "98": ["IR"], "211": ["SS"], "212": ["MA", "EH"], "213": ["DZ"], "216": ["TN"], "218": ["LY"], "220": ["GM"], "221": ["SN"], "222": ["MR"], "223": ["ML"], "224": ["GN"], "225": ["CI"], "226": ["BF"], "227": ["NE"], "228": ["TG"], "229": ["BJ"], "230": ["MU"], "231": ["LR"], "232": ["SL"], "233": ["GH"], "234": ["NG"], "235": ["TD"], "236": ["CF"], "237": ["CM"], "238": ["CV"], "239": ["ST"], "240": ["GQ"], "241": ["GA"], "242": ["CG"], "243": ["CD"], "244": ["AO"], "245": ["GW"], "246": ["IO"], "247": ["AC"], "248": ["SC"], "249": ["SD"], "250": ["RW"], "251": ["ET"], "252": ["SO"], "253": ["DJ"], "254": ["KE"], "255": ["TZ"], "256": ["UG"], "257": ["BI"], "258": ["MZ"], "260": ["ZM"], "261": ["MG"], "262": ["RE", "YT"], "263": ["ZW"], "264": ["NA"], "265": ["MW"], "266": ["LS"], "267": ["BW"], "268": ["SZ"], "269": ["KM"], "290": ["SH", "TA"], "291": ["ER"], "297": ["AW"], "298": ["FO"], "299": ["GL"], "350": ["GI"], "351": ["PT"], "352": ["LU"], "353": ["IE"], "354": ["IS"], "355": ["AL"], "356": ["MT"], "357": ["CY"], "358": ["FI", "AX"], "359": ["BG"], "370": ["LT"], "371": ["LV"], "372": ["EE"], "373": ["MD"], "374": ["AM"], "375": ["BY"], "376": ["AD"], "377": ["MC"], "378": ["SM"], "380": ["UA"], "381": ["RS"], "382": ["ME"], "383": ["XK"], "385": ["HR"], "386": ["SI"], "387": ["BA"], "389": ["MK"], "420": ["CZ"], "421": ["SK"], "423": ["LI"], "500": ["FK"], "501": ["BZ"], "502": ["GT"], "503": ["SV"], "504": ["HN"], "505": ["NI"], "506": ["CR"], "507": ["PA"], "508": ["PM"], "509": ["HT"], "590": ["GP", "BL", "MF"], "591": ["BO"], "592": ["GY"], "593": ["EC"], "594": ["GF"], "595": ["PY"], "596": ["MQ"], "597": ["SR"], "598": ["UY"], "599": ["CW", "BQ"], "670": ["TL"], "672": ["NF"], "673": ["BN"], "674": ["NR"], "675": ["PG"], "676": ["TO"], "677": ["SB"], "678": ["VU"], "679": ["FJ"], "680": ["PW"], "681": ["WF"], "682": ["CK"], "683": ["NU"], "685": ["WS"], "686": ["KI"], "687": ["NC"], "688": ["TV"], "689": ["PF"], "690": ["TK"], "691": ["FM"], "692": ["MH"], "850": ["KP"], "852": ["HK"], "853": ["MO"], "855": ["KH"], "856": ["LA"], "880": ["BD"], "886": ["TW"], "960": ["MV"], "961": ["LB"], "962": ["JO"], "963": ["SY"], "964": ["IQ"], "965": ["KW"], "966": ["SA"], "967": ["YE"], "968": ["OM"], "970": ["PS"], "971": ["AE"], "972": ["IL"], "973": ["BH"], "974": ["QA"], "975": ["BT"], "976": ["MN"], "977": ["NP"], "992": ["TJ"], "993": ["TM"], "994": ["AZ"], "995": ["GE"], "996": ["KG"], "998": ["UZ"] }, "countries": { "AC": ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], "AD": ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], "AE": ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AF": ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], "AG": ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], "AI": ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], "AL": ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], "AM": ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], "AO": ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], "AR": ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], "AS": ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], "AT": ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AU": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "AW": ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], "AX": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], "AZ": ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], "BA": ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], "BB": ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], "BD": ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], "BE": ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], "BF": ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], "BG": ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], "BH": ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], "BI": ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], "BJ": ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], "BL": ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], "BM": ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], "BN": ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], "BO": ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], "BQ": ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], "BR": ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], "BS": ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], "BT": ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], "BW": ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], "BY": ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], "BZ": ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], "CA": ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], "CC": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CD": ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], "CF": ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], "CG": ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], "CH": ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], "CI": ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], "CK": ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], "CL": ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], "CM": ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], "CN": ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], "CO": ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], "CR": ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], "CU": ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], "CV": ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], "CW": ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], "CX": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CY": ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], "CZ": ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], "DE": ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], "DJ": ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], "DK": ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], "DM": ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], "DO": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], "DZ": ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], "EC": ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], "EE": ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "EG": ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], "EH": ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], "ER": ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], "ES": ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], "ET": ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], "FI": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], "FJ": ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "FK": ["500", "00", "[2-7]\\d{4}", [5]], "FM": ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], "FO": ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], "FR": ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], "GA": ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], "GB": ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], "GD": ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], "GE": ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], "GF": ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], "GG": ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], "GH": ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], "GI": ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], "GL": ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], "GM": ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "GN": ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], "GP": ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], "GQ": ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], "GR": ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], "GT": ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "GU": ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], "GW": ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], "GY": ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "HK": ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "HN": ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], "HR": ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], "HT": ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], "HU": ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], "ID": ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], "IE": ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "IL": ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], "IM": ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], "IN": ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], "IO": ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], "IQ": ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "IR": ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], "IS": ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "IT": ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], "JE": ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], "JM": ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], "JO": ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "JP": ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], "KE": ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], "KG": ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "KH": ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "KI": ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], "KM": ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], "KN": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], "KP": ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], "KR": ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], "KW": ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], "KY": ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], "KZ": ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], "LA": ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], "LB": ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], "LC": ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], "LI": ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], "LK": ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], "LR": ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], "LS": ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], "LT": ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], "LU": ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], "LV": ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], "LY": ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], "MA": ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], "MC": ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], "MD": ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], "ME": ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], "MF": ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], "MG": ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], "MH": ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], "MK": ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], "ML": ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], "MM": ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], "MN": ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], "MO": ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], "MP": ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], "MQ": ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "MR": ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], "MS": ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], "MT": ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], "MU": ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], "MV": ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "MW": ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], "MX": ["52", "0[09]", "1(?:(?:22|44|7[27]|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-689]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], "MY": ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], "MZ": ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "NA": ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "NC": ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], "NE": ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]]], "NF": ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], "NG": ["234", "009", "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-6]|7(?:0[0-689]|[1-79])|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], "NI": ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], "NL": ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], "NO": ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], "NP": ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], "NR": ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], "NU": ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], "NZ": ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], "OM": ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], "PA": ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], "PE": ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], "PF": ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "PG": ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "PH": ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], "PK": ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], "PL": ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], "PM": ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "PR": ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], "PS": ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "PT": ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], "PW": ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "PY": ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], "QA": ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], "RE": ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], "RO": ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], "RS": ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], "RU": ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], "RW": ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], "SA": ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], "SB": ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], "SC": ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "SD": ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "SE": ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], "SG": ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "SH": ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], "SI": ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], "SJ": ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], "SK": ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], "SL": ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], "SM": ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], "SN": ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], "SO": ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], "SR": ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], "SS": ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "ST": ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], "SV": ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], "SX": ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], "SY": ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], "SZ": ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], "TA": ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], "TC": ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], "TD": ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "TG": ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], "TH": ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "TJ": ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], "TK": ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], "TL": ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], "TM": ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], "TN": ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], "TO": ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], "TR": ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], "TT": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], "TV": ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "TW": ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], "TZ": ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], "UA": ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], "UG": ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], "US": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:5056(?:[0-35-9]\\d|4[468])|7302[0-3]\\d)\\d{4}|(?:472[24]|505[2-57-9]|7306|983[237-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "UY": ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], "UZ": ["998", "810", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], "VA": ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], "VC": ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], "VE": ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], "VG": ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], "VI": ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], "VN": ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], "VU": ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], "WF": ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "WS": ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "XK": ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], "YE": ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], "YT": ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], "ZA": ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "ZM": ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], "ZW": ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, "nonGeographic": { "800": ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], "808": ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], "870": ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], "878": ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], "881": ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], "882": ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], "883": ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], "888": ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], "979": ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function withMetadataArgument(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  args.push(metadata);
  return func.apply(this, args);
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result2);
  };
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } });
    return _setPrototypeOf(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a3 = [null];
      a3.push.apply(a3, args2);
      var Constructor = Function.bind.apply(Parent2, a3);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e28) {
    return false;
  }
}
function _isNativeFunction(fn2) {
  return Function.toString.call(fn2).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o3, p3) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o6, p6) {
    o6.__proto__ = p6;
    return o6;
  };
  return _setPrototypeOf(o3, p3);
}
function _getPrototypeOf(o3) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o6) {
    return o6.__proto__ || Object.getPrototypeOf(o6);
  };
  return _getPrototypeOf(o3);
}
var ParseError = /* @__PURE__ */ function(_Error) {
  _inherits(ParseError2, _Error);
  var _super = _createSuper(ParseError2);
  function ParseError2(code) {
    var _this;
    _classCallCheck$2(this, ParseError2);
    _this = _super.call(this, code);
    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError2.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }
  return _createClass$2(ParseError2);
}(/* @__PURE__ */ _wrapNativeSuper(Error));
var MIN_LENGTH_FOR_NSN = 2;
var MAX_LENGTH_FOR_NSN = 17;
var MAX_LENGTH_COUNTRY_CODE = 3;
var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9";
var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]";
var TILDES = "~\u2053\u223C\uFF5E";
var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B";
function compare(a3, b3) {
  a3 = a3.split("-");
  b3 = b3.split("-");
  var pa2 = a3[0].split(".");
  var pb2 = b3[0].split(".");
  for (var i = 0; i < 3; i++) {
    var na2 = Number(pa2[i]);
    var nb2 = Number(pb2[i]);
    if (na2 > nb2)
      return 1;
    if (nb2 > na2)
      return -1;
    if (!isNaN(na2) && isNaN(nb2))
      return 1;
    if (isNaN(na2) && !isNaN(nb2))
      return -1;
  }
  if (a3[1] && b3[1]) {
    return a3[1] > b3[1] ? 1 : a3[1] < b3[1] ? -1 : 0;
  }
  return !a3[1] && b3[1] ? 1 : a3[1] && !b3[1] ? -1 : 0;
}
var objectConstructor = {}.constructor;
function isObject$1(object2) {
  return object2 !== void 0 && object2 !== null && object2.constructor === objectConstructor;
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var V3 = "1.2.0";
var V4 = "1.7.35";
var DEFAULT_EXT_PREFIX = " ext. ";
var CALLING_CODE_REG_EXP = /^\d+$/;
var Metadata = /* @__PURE__ */ function() {
  function Metadata2(metadata2) {
    _classCallCheck$1(this, Metadata2);
    validateMetadata(metadata2);
    this.metadata = metadata2;
    setVersion.call(this, metadata2);
  }
  _createClass$1(Metadata2, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function(_3) {
        return _3 !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3)
        return;
      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }
      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    }
  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }
      if (countryCode && countryCode !== "001") {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }
        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = void 0;
      }
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];
      if (countryCodes) {
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }
        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);
      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }
      if (this.nonGeographic()) {
        var metadata2 = this.nonGeographic()[callingCode];
        if (metadata2) {
          return metadata2;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return this.metadata.countries["001"];
        }
      }
    }
  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    }
  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    }
  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    }
  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1)
        return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    }
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== void 0;
    }
  }]);
  return Metadata2;
}();
var NumberingPlan = /* @__PURE__ */ function() {
  function NumberingPlan2(metadata2, globalMetadataObject) {
    _classCallCheck$1(this, NumberingPlan2);
    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata2;
    setVersion.call(this, globalMetadataObject.metadata);
  }
  _createClass$1(NumberingPlan2, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    }
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2)
        return;
      return this.metadata[1];
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2)
        return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2)
        return this.metadata[1];
      return this.metadata[2];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1)
        return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata2) {
      return metadata2[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
  }, {
    key: "formats",
    value: function formats() {
      var _this = this;
      var formats2 = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats2.map(function(_3) {
        return new Format(_3, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata2) {
      return metadata2[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      if (this.types() && this.types().length === 0) {
        return false;
      }
      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2)
        return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);
  return NumberingPlan2;
}();
var Format = /* @__PURE__ */ function() {
  function Format2(format2, metadata2) {
    _classCallCheck$1(this, Format2);
    this._format = format2;
    this.metadata = metadata2;
  }
  _createClass$1(Format2, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format2() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);
  return Format2;
}();
var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var Type = /* @__PURE__ */ function() {
  function Type2(type, metadata2) {
    _classCallCheck$1(this, Type2);
    this.type = type;
    this.metadata = metadata2;
  }
  _createClass$1(Type2, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1)
        return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1)
        return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
  return Type2;
}();
function getType(types, type) {
  switch (type) {
    case "FIXED_LINE":
      return types[0];
    case "MOBILE":
      return types[1];
    case "TOLL_FREE":
      return types[2];
    case "PREMIUM_RATE":
      return types[3];
    case "PERSONAL_NUMBER":
      return types[4];
    case "VOICEMAIL":
      return types[5];
    case "UAN":
      return types[6];
    case "PAGER":
      return types[7];
    case "VOIP":
      return types[8];
    case "SHARED_COST":
      return types[9];
  }
}
function validateMetadata(metadata2) {
  if (!metadata2) {
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  }
  if (!isObject$1(metadata2) || !isObject$1(metadata2.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject$1(metadata2) ? "an object of shape: { " + Object.keys(metadata2).join(", ") + " }" : "a " + typeOf(metadata2) + ": " + metadata2, "."));
  }
}
var typeOf = function typeOf2(_3) {
  return _typeof(_3);
};
function getCountryCallingCode(country, metadata2) {
  metadata2 = new Metadata(metadata2);
  if (metadata2.hasCountry(country)) {
    return metadata2.country(country).countryCallingCode();
  }
  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata2) {
  return metadata2.countries.hasOwnProperty(country);
}
function setVersion(metadata2) {
  var version2 = metadata2.version;
  if (typeof version2 === "number") {
    this.v1 = version2 === 1;
    this.v2 = version2 === 2;
    this.v3 = version2 === 3;
    this.v4 = version2 === 4;
  } else {
    if (!version2) {
      this.v1 = true;
    } else if (compare(version2, V3) === -1) {
      this.v2 = true;
    } else if (compare(version2, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
}
var RFC3966_EXTN_PREFIX = ";ext=";
var getExtensionDigitsPattern = function getExtensionDigitsPattern2(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
function createExtensionPattern(purpose) {
  var extLimitAfterExplicitLabel = "20";
  var extLimitAfterLikelyLabel = "15";
  var extLimitAfterAmbiguousChar = "9";
  var extLimitWhenNotSure = "6";
  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*";
  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  var optionalExtnSuffix = "#?";
  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)";
  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)";
  var ambiguousSeparator = "[- ]+";
  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*";
  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
var MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + VALID_DIGITS + "]{" + MIN_LENGTH_FOR_NSN + "}";
var VALID_PHONE_NUMBER = "[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){3,}[" + VALID_PUNCTUATION + VALID_DIGITS + "]*";
var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){1,2}$", "i");
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + "(?:" + createExtensionPattern() + ")?";
var VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + MIN_LENGTH_PHONE_NUMBER_PATTERN + "$|^" + VALID_PHONE_NUMBER_WITH_EXTENSION + "$", "i");
function isViablePhoneNumber(number2) {
  return number2.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number2);
}
function isViablePhoneNumberStart(number2) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number2);
}
var EXTN_PATTERN = new RegExp("(?:" + createExtensionPattern() + ")$", "i");
function extractExtension(number2) {
  var start2 = number2.search(EXTN_PATTERN);
  if (start2 < 0) {
    return {};
  }
  var numberWithoutExtension = number2.slice(0, start2);
  var matches = number2.match(EXTN_PATTERN);
  var i = 1;
  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }
    i++;
  }
}
var DIGITS = {
  "0": "0",
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "6": "6",
  "7": "7",
  "8": "8",
  "9": "9",
  "\uFF10": "0",
  "\uFF11": "1",
  "\uFF12": "2",
  "\uFF13": "3",
  "\uFF14": "4",
  "\uFF15": "5",
  "\uFF16": "6",
  "\uFF17": "7",
  "\uFF18": "8",
  "\uFF19": "9",
  "\u0660": "0",
  "\u0661": "1",
  "\u0662": "2",
  "\u0663": "3",
  "\u0664": "4",
  "\u0665": "5",
  "\u0666": "6",
  "\u0667": "7",
  "\u0668": "8",
  "\u0669": "9",
  "\u06F0": "0",
  "\u06F1": "1",
  "\u06F2": "2",
  "\u06F3": "3",
  "\u06F4": "4",
  "\u06F5": "5",
  "\u06F6": "6",
  "\u06F7": "7",
  "\u06F8": "8",
  "\u06F9": "9"
};
function parseDigit(character) {
  return DIGITS[character];
}
function _createForOfIteratorHelperLoose$4(o3, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o3[Symbol.iterator] || o3["@@iterator"];
  if (it2)
    return (it2 = it2.call(o3)).next.bind(it2);
  if (Array.isArray(o3) || (it2 = _unsupportedIterableToArray$5(o3)) || allowArrayLike && o3 && typeof o3.length === "number") {
    if (it2)
      o3 = it2;
    var i = 0;
    return function() {
      if (i >= o3.length)
        return { done: true };
      return { done: false, value: o3[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$5(o3, minLen) {
  if (!o3)
    return;
  if (typeof o3 === "string")
    return _arrayLikeToArray$5(o3, minLen);
  var n3 = Object.prototype.toString.call(o3).slice(8, -1);
  if (n3 === "Object" && o3.constructor)
    n3 = o3.constructor.name;
  if (n3 === "Map" || n3 === "Set")
    return Array.from(o3);
  if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3))
    return _arrayLikeToArray$5(o3, minLen);
}
function _arrayLikeToArray$5(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function parseIncompletePhoneNumber(string2) {
  var result2 = "";
  for (var _iterator = _createForOfIteratorHelperLoose$4(string2.split("")), _step; !(_step = _iterator()).done; ) {
    var character = _step.value;
    result2 += parsePhoneNumberCharacter(character, result2) || "";
  }
  return result2;
}
function parsePhoneNumberCharacter(character, prevParsedCharacters, emitEvent) {
  if (character === "+") {
    if (prevParsedCharacters) {
      if (typeof emitEvent === "function") {
        emitEvent("end");
      }
      return;
    }
    return "+";
  }
  return parseDigit(character);
}
function _createForOfIteratorHelperLoose$3(o3, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o3[Symbol.iterator] || o3["@@iterator"];
  if (it2)
    return (it2 = it2.call(o3)).next.bind(it2);
  if (Array.isArray(o3) || (it2 = _unsupportedIterableToArray$4(o3)) || allowArrayLike && o3 && typeof o3.length === "number") {
    if (it2)
      o3 = it2;
    var i = 0;
    return function() {
      if (i >= o3.length)
        return { done: true };
      return { done: false, value: o3[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$4(o3, minLen) {
  if (!o3)
    return;
  if (typeof o3 === "string")
    return _arrayLikeToArray$4(o3, minLen);
  var n3 = Object.prototype.toString.call(o3).slice(8, -1);
  if (n3 === "Object" && o3.constructor)
    n3 = o3.constructor.name;
  if (n3 === "Map" || n3 === "Set")
    return Array.from(o3);
  if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3))
    return _arrayLikeToArray$4(o3, minLen);
}
function _arrayLikeToArray$4(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function mergeArrays(a3, b3) {
  var merged = a3.slice();
  for (var _iterator = _createForOfIteratorHelperLoose$3(b3), _step; !(_step = _iterator()).done; ) {
    var element = _step.value;
    if (a3.indexOf(element) < 0) {
      merged.push(element);
    }
  }
  return merged.sort(function(a6, b10) {
    return a6 - b10;
  });
}
function checkNumberLength(nationalNumber, metadata2) {
  return checkNumberLengthForType(nationalNumber, void 0, metadata2);
}
function checkNumberLengthForType(nationalNumber, type, metadata2) {
  var type_info = metadata2.type(type);
  var possible_lengths = type_info && type_info.possibleLengths() || metadata2.possibleLengths();
  if (!possible_lengths) {
    return "IS_POSSIBLE";
  }
  if (type === "FIXED_LINE_OR_MOBILE") {
    if (!metadata2.type("FIXED_LINE")) {
      return checkNumberLengthForType(nationalNumber, "MOBILE", metadata2);
    }
    var mobile_type = metadata2.type("MOBILE");
    if (mobile_type) {
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths());
    }
  } else if (type && !type_info) {
    return "INVALID_LENGTH";
  }
  var actual_length = nationalNumber.length;
  var minimum_length = possible_lengths[0];
  if (minimum_length === actual_length) {
    return "IS_POSSIBLE";
  }
  if (minimum_length > actual_length) {
    return "TOO_SHORT";
  }
  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return "TOO_LONG";
  }
  return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function isPossiblePhoneNumber(input, options, metadata2) {
  if (options === void 0) {
    options = {};
  }
  metadata2 = new Metadata(metadata2);
  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error("Invalid phone number object passed");
    }
    metadata2.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }
    if (input.country) {
      if (!metadata2.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }
      metadata2.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error("Invalid phone number object passed");
      }
      metadata2.selectNumberingPlan(input.countryCallingCode);
    }
  }
  if (metadata2.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata2);
  } else {
    if (input.countryCallingCode && metadata2.isNonGeographicCallingCode(input.countryCallingCode)) {
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata2) {
  switch (checkNumberLength(nationalNumber, metadata2)) {
    case "IS_POSSIBLE":
      return true;
    default:
      return false;
  }
}
function matchesEntirely(text, regular_expression) {
  text = text || "";
  return new RegExp("^(?:" + regular_expression + ")$").test(text);
}
function _createForOfIteratorHelperLoose$2(o3, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o3[Symbol.iterator] || o3["@@iterator"];
  if (it2)
    return (it2 = it2.call(o3)).next.bind(it2);
  if (Array.isArray(o3) || (it2 = _unsupportedIterableToArray$3(o3)) || allowArrayLike && o3 && typeof o3.length === "number") {
    if (it2)
      o3 = it2;
    var i = 0;
    return function() {
      if (i >= o3.length)
        return { done: true };
      return { done: false, value: o3[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$3(o3, minLen) {
  if (!o3)
    return;
  if (typeof o3 === "string")
    return _arrayLikeToArray$3(o3, minLen);
  var n3 = Object.prototype.toString.call(o3).slice(8, -1);
  if (n3 === "Object" && o3.constructor)
    n3 = o3.constructor.name;
  if (n3 === "Map" || n3 === "Set")
    return Array.from(o3);
  if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3))
    return _arrayLikeToArray$3(o3, minLen);
}
function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var NON_FIXED_LINE_PHONE_TYPES = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function getNumberType(input, options, metadata2) {
  options = options || {};
  if (!input.country && !input.countryCallingCode) {
    return;
  }
  metadata2 = new Metadata(metadata2);
  metadata2.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  if (!matchesEntirely(nationalNumber, metadata2.nationalNumberPattern())) {
    return;
  }
  if (isNumberTypeEqualTo(nationalNumber, "FIXED_LINE", metadata2)) {
    if (metadata2.type("MOBILE") && metadata2.type("MOBILE").pattern() === "") {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (!metadata2.type("MOBILE")) {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (isNumberTypeEqualTo(nationalNumber, "MOBILE", metadata2)) {
      return "FIXED_LINE_OR_MOBILE";
    }
    return "FIXED_LINE";
  }
  for (var _iterator = _createForOfIteratorHelperLoose$2(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done; ) {
    var type = _step.value;
    if (isNumberTypeEqualTo(nationalNumber, type, metadata2)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata2) {
  type = metadata2.type(type);
  if (!type || !type.pattern()) {
    return false;
  }
  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }
  return matchesEntirely(nationalNumber, type.pattern());
}
function isValidNumber(input, options, metadata2) {
  options = options || {};
  metadata2 = new Metadata(metadata2);
  metadata2.selectNumberingPlan(input.country, input.countryCallingCode);
  if (metadata2.hasTypes()) {
    return getNumberType(input, options, metadata2.metadata) !== void 0;
  }
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata2.nationalNumberPattern());
}
function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata2) {
  var _metadata = new Metadata(metadata2);
  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return [];
  }
  return possibleCountries.filter(function(country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata2);
  });
}
function couldNationalNumberBelongToCountry(nationalNumber, country, metadata2) {
  var _metadata = new Metadata(metadata2);
  _metadata.selectNumberingPlan(country);
  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }
  return false;
}
function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), "g"), " ").trim();
}
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number2, format2, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix;
  _ref.carrierCode;
  _ref.metadata;
  var formattedNumber = number2.replace(new RegExp(format2.pattern()), useInternationalFormat ? format2.internationalFormat() : withNationalPrefix && format2.nationalPrefixFormattingRule() ? format2.format().replace(FIRST_GROUP_PATTERN, format2.nationalPrefixFormattingRule()) : format2.format());
  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }
  return formattedNumber;
}
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(country, callingCode, metadata2) {
  var countryMetadata = new Metadata(metadata2);
  countryMetadata.selectNumberingPlan(country, callingCode);
  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }
  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}
function formatRFC3966(_ref) {
  var number2 = _ref.number, ext = _ref.ext;
  if (!number2) {
    return "";
  }
  if (number2[0] !== "+") {
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  }
  return "tel:".concat(number2).concat(ext ? ";ext=" + ext : "");
}
function _createForOfIteratorHelperLoose$1(o3, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o3[Symbol.iterator] || o3["@@iterator"];
  if (it2)
    return (it2 = it2.call(o3)).next.bind(it2);
  if (Array.isArray(o3) || (it2 = _unsupportedIterableToArray$2(o3)) || allowArrayLike && o3 && typeof o3.length === "number") {
    if (it2)
      o3 = it2;
    var i = 0;
    return function() {
      if (i >= o3.length)
        return { done: true };
      return { done: false, value: o3[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$2(o3, minLen) {
  if (!o3)
    return;
  if (typeof o3 === "string")
    return _arrayLikeToArray$2(o3, minLen);
  var n3 = Object.prototype.toString.call(o3).slice(8, -1);
  if (n3 === "Object" && o3.constructor)
    n3 = o3.constructor.name;
  if (n3 === "Map" || n3 === "Set")
    return Array.from(o3);
  if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3))
    return _arrayLikeToArray$2(o3, minLen);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function ownKeys$4(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$4(Object(source), true).forEach(function(key) {
      _defineProperty$4(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata2) {
    return "".concat(formattedNumber).concat(metadata2.ext()).concat(extension);
  }
};
function formatNumber(input, format2, options, metadata2) {
  if (options) {
    options = _objectSpread$4(_objectSpread$4({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }
  metadata2 = new Metadata(metadata2);
  if (input.country && input.country !== "001") {
    if (!metadata2.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }
    metadata2.country(input.country);
  } else if (input.countryCallingCode) {
    metadata2.selectNumberingPlan(input.countryCallingCode);
  } else
    return input.phone || "";
  var countryCallingCode = metadata2.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  var number2;
  switch (format2) {
    case "NATIONAL":
      if (!nationalNumber) {
        return "";
      }
      number2 = formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata2, options);
      return addExtension(number2, input.ext, metadata2, options.formatExtension);
    case "INTERNATIONAL":
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }
      number2 = formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata2, options);
      number2 = "+".concat(countryCallingCode, " ").concat(number2);
      return addExtension(number2, input.ext, metadata2, options.formatExtension);
    case "E.164":
      return "+".concat(countryCallingCode).concat(nationalNumber);
    case "RFC3966":
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    case "IDD":
      if (!options.fromCountry) {
        return;
      }
      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata2);
      return addExtension(formattedNumber, input.ext, metadata2, options.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format2, '"'));
  }
}
function formatNationalNumber(number2, carrierCode, formatAs, metadata2, options) {
  var format2 = chooseFormatForNumber(metadata2.formats(), number2);
  if (!format2) {
    return number2;
  }
  return formatNationalNumberUsingFormat(number2, format2, {
    useInternationalFormat: formatAs === "INTERNATIONAL",
    withNationalPrefix: format2.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode,
    metadata: metadata2
  });
}
function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = _createForOfIteratorHelperLoose$1(availableFormats), _step; !(_step = _iterator()).done; ) {
    var format2 = _step.value;
    if (format2.leadingDigitsPatterns().length > 0) {
      var lastLeadingDigitsPattern = format2.leadingDigitsPatterns()[format2.leadingDigitsPatterns().length - 1];
      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    }
    if (matchesEntirely(nationalNnumber, format2.pattern())) {
      return format2;
    }
  }
}
function addExtension(formattedNumber, ext, metadata2, formatExtension2) {
  return ext ? formatExtension2(formattedNumber, ext, metadata2) : formattedNumber;
}
function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata2) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata2.metadata);
  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata2);
    if (countryCallingCode === "1") {
      return countryCallingCode + " " + formattedNumber;
    }
    return formattedNumber;
  }
  var iddPrefix = getIddPrefix(fromCountry, void 0, metadata2.metadata);
  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata2));
  }
}
function ownKeys$3(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$3(Object(source), true).forEach(function(key) {
      _defineProperty$3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var PhoneNumber = /* @__PURE__ */ function() {
  function PhoneNumber2(countryOrCountryCallingCode, nationalNumber, metadata2) {
    _classCallCheck(this, PhoneNumber2);
    if (!countryOrCountryCallingCode) {
      throw new TypeError("`country` or `countryCallingCode` not passed");
    }
    if (!nationalNumber) {
      throw new TypeError("`nationalNumber` not passed");
    }
    if (!metadata2) {
      throw new TypeError("`metadata` not passed");
    }
    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata2), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = "+" + this.countryCallingCode + this.nationalNumber;
    this.getMetadata = function() {
      return metadata2;
    };
  }
  _createClass(PhoneNumber2, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }
      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid2() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata2 = new Metadata(this.getMetadata());
      return metadata2.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    }
  }, {
    key: "getType",
    value: function getType2() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format2(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread$3(_objectSpread$3({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format("NATIONAL", options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format("INTERNATIONAL", options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format("RFC3966", options);
    }
  }]);
  return PhoneNumber2;
}();
var isCountryCode = function isCountryCode2(value) {
  return /^[A-Z]{2}$/.test(value);
};
function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata2 = new Metadata(metadataJson);
  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata2.selectNumberingPlan(country);
    countryCallingCode = metadata2.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
  }
  return {
    country,
    countryCallingCode
  };
}
var CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
function stripIddPrefix(number2, country, callingCode, metadata2) {
  if (!country) {
    return;
  }
  var countryMetadata = new Metadata(metadata2);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
  if (number2.search(IDDPrefixPattern) !== 0) {
    return;
  }
  number2 = number2.slice(number2.match(IDDPrefixPattern)[0].length);
  var matchedGroups = number2.match(CAPTURING_DIGIT_PATTERN);
  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === "0") {
      return;
    }
  }
  return number2;
}
function extractNationalNumberFromPossiblyIncompleteNumber(number2, metadata2) {
  if (number2 && metadata2.numberingPlan.nationalPrefixForParsing()) {
    var prefixPattern = new RegExp("^(?:" + metadata2.numberingPlan.nationalPrefixForParsing() + ")");
    var prefixMatch = prefixPattern.exec(number2);
    if (prefixMatch) {
      var nationalNumber;
      var carrierCode;
      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
      if (metadata2.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number2.replace(prefixPattern, metadata2.nationalPrefixTransformRule());
        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } else {
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number2.slice(prefixBeforeNationalNumber.length);
        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      }
      var nationalPrefix;
      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number2.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number2.slice(0, possiblePositionOfTheFirstCapturedGroup);
        if (possibleNationalPrefix === metadata2.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata2.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }
      return {
        nationalNumber,
        nationalPrefix,
        carrierCode
      };
    }
  }
  return {
    nationalNumber: number2
  };
}
function extractNationalNumber(number2, metadata2) {
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number2, metadata2), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
  if (nationalNumber !== number2) {
    if (!shouldHaveExtractedNationalPrefix(number2, nationalNumber, metadata2)) {
      return {
        nationalNumber: number2
      };
    }
    if (metadata2.possibleLengths()) {
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata2)) {
        return {
          nationalNumber: number2
        };
      }
    }
  }
  return {
    nationalNumber,
    carrierCode
  };
}
function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata2) {
  if (matchesEntirely(nationalNumberBefore, metadata2.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata2.nationalNumberPattern())) {
    return false;
  }
  return true;
}
function isPossibleIncompleteNationalNumber(nationalNumber, metadata2) {
  switch (checkNumberLength(nationalNumber, metadata2)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return false;
    default:
      return true;
  }
}
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number2, country, callingCode, metadata2) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata2) : callingCode;
  if (number2.indexOf(countryCallingCode) === 0) {
    metadata2 = new Metadata(metadata2);
    metadata2.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number2.slice(countryCallingCode.length);
    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata2), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
    var _extractNationalNumbe2 = extractNationalNumber(number2, metadata2), nationalNumber = _extractNationalNumbe2.nationalNumber;
    if (!matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata2.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata2) === "TOO_LONG") {
      return {
        countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }
  return {
    number: number2
  };
}
function extractCountryCallingCode(number2, country, callingCode, metadata2) {
  if (!number2) {
    return {};
  }
  var isNumberWithIddPrefix;
  if (number2[0] !== "+") {
    var numberWithoutIDD = stripIddPrefix(number2, country, callingCode, metadata2);
    if (numberWithoutIDD && numberWithoutIDD !== number2) {
      isNumberWithIddPrefix = true;
      number2 = "+" + numberWithoutIDD;
    } else {
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number2, country, callingCode, metadata2), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
        if (countryCallingCode) {
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode,
            number: shorterNumber
          };
        }
      }
      return {
        number: number2
      };
    }
  }
  if (number2[1] === "0") {
    return {};
  }
  metadata2 = new Metadata(metadata2);
  var i = 2;
  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number2.length) {
    var _countryCallingCode = number2.slice(1, i);
    if (metadata2.hasCallingCode(_countryCallingCode)) {
      metadata2.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: _countryCallingCode,
        number: number2.slice(i)
      };
    }
    i++;
  }
  return {};
}
function _createForOfIteratorHelperLoose(o3, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o3[Symbol.iterator] || o3["@@iterator"];
  if (it2)
    return (it2 = it2.call(o3)).next.bind(it2);
  if (Array.isArray(o3) || (it2 = _unsupportedIterableToArray$1(o3)) || allowArrayLike && o3 && typeof o3.length === "number") {
    if (it2)
      o3 = it2;
    var i = 0;
    return function() {
      if (i >= o3.length)
        return { done: true };
      return { done: false, value: o3[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o3, minLen) {
  if (!o3)
    return;
  if (typeof o3 === "string")
    return _arrayLikeToArray$1(o3, minLen);
  var n3 = Object.prototype.toString.call(o3).slice(8, -1);
  if (n3 === "Object" && o3.constructor)
    n3 = o3.constructor.name;
  if (n3 === "Map" || n3 === "Set")
    return Array.from(o3);
  if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3))
    return _arrayLikeToArray$1(o3, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries2 = _ref.countries, defaultCountry = _ref.defaultCountry, metadata2 = _ref.metadata;
  metadata2 = new Metadata(metadata2);
  var matchingCountries = [];
  for (var _iterator = _createForOfIteratorHelperLoose(countries2), _step; !(_step = _iterator()).done; ) {
    var country = _step.value;
    metadata2.country(country);
    if (metadata2.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata2.leadingDigits()) === 0) {
        return country;
      }
    } else if (getNumberType({
      phone: nationalPhoneNumber,
      country
    }, void 0, metadata2.metadata)) {
      if (defaultCountry) {
        if (country === defaultCountry) {
          return country;
        }
        matchingCountries.push(country);
      } else {
        return country;
      }
    }
  }
  if (matchingCountries.length > 0) {
    return matchingCountries[0];
  }
}
var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata2 = _ref.metadata;
  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata2.isNonGeographicCallingCode(callingCode)) {
      return "001";
    }
  }
  var possibleCountries = metadata2.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return;
  }
  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }
  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    defaultCountry,
    metadata: metadata2.metadata
  });
}
var PLUS_SIGN = "+";
var RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var RFC3966_PHONE_DIGIT_ = "([" + VALID_DIGITS + "]|" + RFC3966_VISUAL_SEPARATOR_ + ")";
var RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + "*[" + VALID_DIGITS + "]" + RFC3966_PHONE_DIGIT_ + "*$";
var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, "g");
var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = "[" + ALPHANUM_ + "]+((\\-)*[" + ALPHANUM_ + "])*";
var VALID_ALPHA_ = "a-zA-Z";
var RFC3966_TOPLABEL_ = "[" + VALID_ALPHA_ + "]+((\\-)*[" + ALPHANUM_ + "])*";
var RFC3966_DOMAINNAME_ = "^(" + RFC3966_DOMAINLABEL_ + "\\.)*" + RFC3966_TOPLABEL_ + "\\.?$";
var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, "g");
var RFC3966_PREFIX_ = "tel:";
var RFC3966_PHONE_CONTEXT_ = ";phone-context=";
var RFC3966_ISDN_SUBADDRESS_ = ";isub=";
function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_);
  if (indexOfPhoneContext < 0) {
    return null;
  }
  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length;
  if (phoneContextStart >= numberToExtractFrom.length) {
    return "";
  }
  var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart);
  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}
function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }
  if (phoneContext.length === 0) {
    return false;
  }
  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}
function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = extractPhoneContext(numberToParse);
  if (!isPhoneContextValid(phoneContext)) {
    throw new ParseError("NOT_A_NUMBER");
  }
  var phoneNumberString;
  if (phoneContext === null) {
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
  } else {
    phoneNumberString = "";
    if (phoneContext.charAt(0) === PLUS_SIGN) {
      phoneNumberString += phoneContext;
    }
    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
    var indexOfNationalNumber;
    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
    } else {
      indexOfNationalNumber = 0;
    }
    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  }
  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);
  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  }
  if (phoneNumberString !== "") {
    return phoneNumberString;
  }
}
var MAX_INPUT_STRING_LENGTH = 250;
var PHONE_NUMBER_START_PATTERN = new RegExp("[" + PLUS_CHARS + VALID_DIGITS + "]");
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
function parse(text, options, metadata2) {
  options = options || {};
  metadata2 = new Metadata(metadata2);
  if (options.defaultCountry && !metadata2.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    throw new Error("Unknown country: ".concat(options.defaultCountry));
  }
  var _parseInput = parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error2 = _parseInput.error;
  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error2 === "TOO_SHORT") {
        throw new ParseError("TOO_SHORT");
      }
      throw new ParseError("NOT_A_NUMBER");
    }
    return {};
  }
  var _parsePhoneNumber = parsePhoneNumber$3(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata2), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
  if (!metadata2.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    return {};
  }
  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_SHORT");
    }
    return {};
  }
  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_LONG");
    }
    return {};
  }
  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata2.metadata);
    if (country) {
      phoneNumber.country = country;
    }
    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }
    if (ext) {
      phoneNumber.ext = ext;
    }
    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  }
  var valid = (options.extended ? metadata2.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) : false;
  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  }
  return {
    country,
    countryCallingCode,
    carrierCode,
    valid,
    possible: valid ? true : options.extended === true && metadata2.possibleLengths() && isPossibleNumber(nationalNumber, metadata2) ? true : false,
    phone: nationalNumber,
    ext
  };
}
function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }
  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError("TOO_LONG");
    }
    return;
  }
  if (extract === false) {
    return text;
  }
  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
  if (startsAt < 0) {
    return;
  }
  return text.slice(startsAt).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
}
function parseInput(text, v22, extract) {
  var number2 = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text2) {
      return _extractFormattedPhoneNumber(text2, extract, v22);
    }
  });
  if (!number2) {
    return {};
  }
  if (!isViablePhoneNumber(number2)) {
    if (isViablePhoneNumberStart(number2)) {
      return {
        error: "TOO_SHORT"
      };
    }
    return {};
  }
  var withExtensionStripped = extractExtension(number2);
  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }
  return {
    number: number2
  };
}
function result(country, nationalNumber, ext) {
  var result2 = {
    country,
    phone: nationalNumber
  };
  if (ext) {
    result2.ext = ext;
  }
  return result2;
}
function parsePhoneNumber$3(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata2) {
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata2.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number2 = _extractCountryCallin.number;
  var country;
  if (countryCallingCode) {
    metadata2.selectNumberingPlan(countryCallingCode);
  } else if (number2 && (defaultCountry || defaultCallingCode)) {
    metadata2.selectNumberingPlan(defaultCountry, defaultCallingCode);
    if (defaultCountry) {
      country = defaultCountry;
    }
    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata2.metadata);
  } else
    return {};
  if (!number2) {
    return {
      countryCallingCodeSource,
      countryCallingCode
    };
  }
  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number2), metadata2), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
  var exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber,
    defaultCountry,
    metadata: metadata2
  });
  if (exactCountry) {
    country = exactCountry;
    if (exactCountry === "001")
      ;
    else {
      metadata2.country(country);
    }
  }
  return {
    country,
    countryCallingCode,
    countryCallingCodeSource,
    nationalNumber,
    carrierCode
  };
}
function ownKeys$2(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$2(Object(source), true).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumberWithError(text, options, metadata2) {
  return parse(text, _objectSpread$2(_objectSpread$2({}, options), {}, {
    v2: true
  }), metadata2);
}
function ownKeys$1(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), true).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o3, minLen) {
  if (!o3)
    return;
  if (typeof o3 === "string")
    return _arrayLikeToArray(o3, minLen);
  var n3 = Object.prototype.toString.call(o3).slice(8, -1);
  if (n3 === "Object" && o3.constructor)
    n3 = o3.constructor.name;
  if (n3 === "Map" || n3 === "Set")
    return Array.from(o3);
  if (n3 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n3))
    return _arrayLikeToArray(o3, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i2 = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i2 == null)
    return;
  var _arr = [];
  var _n2 = true;
  var _d2 = false;
  var _s2, _e2;
  try {
    for (_i2 = _i2.call(arr); !(_n2 = (_s2 = _i2.next()).done); _n2 = true) {
      _arr.push(_s2.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d2 = true;
    _e2 = err;
  } finally {
    try {
      if (!_n2 && _i2["return"] != null)
        _i2["return"]();
    } finally {
      if (_d2)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
  var text;
  var options;
  var metadata2;
  if (typeof arg_1 === "string") {
    text = arg_1;
  } else
    throw new TypeError("A text for parsing must be a string.");
  if (!arg_2 || typeof arg_2 === "string") {
    if (arg_4) {
      options = arg_3;
      metadata2 = arg_4;
    } else {
      options = void 0;
      metadata2 = arg_3;
    }
    if (arg_2) {
      options = _objectSpread$1({
        defaultCountry: arg_2
      }, options);
    }
  } else if (isObject$1(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata2 = arg_3;
    } else {
      metadata2 = arg_2;
    }
  } else
    throw new Error("Invalid second argument: ".concat(arg_2));
  return {
    text,
    options,
    metadata: metadata2
  };
}
function ownKeys(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumber$2(text, options, metadata2) {
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata2)) {
    options = _objectSpread(_objectSpread({}, options), {}, {
      defaultCountry: void 0
    });
  }
  try {
    return parsePhoneNumberWithError(text, options, metadata2);
  } catch (error2) {
    if (error2 instanceof ParseError)
      ;
    else {
      throw error2;
    }
  }
}
function parsePhoneNumber$1() {
  var _normalizeArguments = normalizeArguments(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata2 = _normalizeArguments.metadata;
  return parsePhoneNumber$2(text, options, metadata2);
}
function parsePhoneNumber() {
  return withMetadataArgument(parsePhoneNumber$1, arguments);
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getAugmentedNamespace(n3) {
  if (n3.__esModule)
    return n3;
  var a3 = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n3).forEach(function(k3) {
    var d3 = Object.getOwnPropertyDescriptor(n3, k3);
    Object.defineProperty(a3, k3, d3.get ? d3 : {
      enumerable: true,
      get: function() {
        return n3[k3];
      }
    });
  });
  return a3;
}
function Cache(maxSize) {
  this._maxSize = maxSize;
  this.clear();
}
Cache.prototype.clear = function() {
  this._size = 0;
  this._values = Object.create(null);
};
Cache.prototype.get = function(key) {
  return this._values[key];
};
Cache.prototype.set = function(key, value) {
  this._size >= this._maxSize && this.clear();
  if (!(key in this._values))
    this._size++;
  return this._values[key] = value;
};
var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, DIGIT_REGEX = /^\d+$/, LEAD_DIGIT_REGEX = /^\d/, SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, MAX_CACHE_SIZE = 512;
var pathCache = new Cache(MAX_CACHE_SIZE), setCache = new Cache(MAX_CACHE_SIZE), getCache = new Cache(MAX_CACHE_SIZE);
var propertyExpr = {
  Cache,
  split,
  normalizePath,
  setter: function(path) {
    var parts = normalizePath(path);
    return setCache.get(path) || setCache.set(path, function setter(obj, value) {
      var index = 0;
      var len = parts.length;
      var data = obj;
      while (index < len - 1) {
        var part = parts[index];
        if (part === "__proto__" || part === "constructor" || part === "prototype") {
          return obj;
        }
        data = data[parts[index++]];
      }
      data[parts[index]] = value;
    });
  },
  getter: function(path, safe) {
    var parts = normalizePath(path);
    return getCache.get(path) || getCache.set(path, function getter(data) {
      var index = 0, len = parts.length;
      while (index < len) {
        if (data != null || !safe)
          data = data[parts[index++]];
        else
          return;
      }
      return data;
    });
  },
  join: function(segments) {
    return segments.reduce(function(path, part) {
      return path + (isQuoted(part) || DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
    }, "");
  },
  forEach: function(path, cb2, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb2, thisArg);
  }
};
function normalizePath(path) {
  return pathCache.get(path) || pathCache.set(path, split(path).map(function(part) {
    return part.replace(CLEAN_QUOTES_REGEX, "$2");
  }));
}
function split(path) {
  return path.match(SPLIT_REGEX) || [""];
}
function forEach(parts, iter, thisArg) {
  var len = parts.length, part, idx, isArray2, isBracket;
  for (idx = 0; idx < len; idx++) {
    part = parts[idx];
    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }
      isBracket = isQuoted(part);
      isArray2 = !isBracket && /^\d+$/.test(part);
      iter.call(thisArg, part, isBracket, isArray2, idx, parts);
    }
  }
}
function isQuoted(str) {
  return typeof str === "string" && str && ["'", '"'].indexOf(str.charAt(0)) !== -1;
}
function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX);
}
function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part);
}
function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part));
}
var toposort$1 = { exports: {} };
toposort$1.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges);
};
toposort$1.exports.array = toposort;
function toposort(nodes, edges) {
  var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = makeOutgoingEdges(edges), nodesHash = makeNodesHash(nodes);
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    }
  });
  while (i--) {
    if (!visited[i])
      visit(nodes[i], i, new Set());
  }
  return sorted;
  function visit(node, i3, predecessors) {
    if (predecessors.has(node)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node);
      } catch (e28) {
        nodeRep = "";
      }
      throw new Error("Cyclic dependency" + nodeRep);
    }
    if (!nodesHash.has(node)) {
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
    }
    if (visited[i3])
      return;
    visited[i3] = true;
    var outgoing = outgoingEdges.get(node) || new Set();
    outgoing = Array.from(outgoing);
    if (i3 = outgoing.length) {
      predecessors.add(node);
      do {
        var child2 = outgoing[--i3];
        visit(child2, nodesHash.get(child2), predecessors);
      } while (i3);
      predecessors.delete(node);
    }
    sorted[--cursor] = node;
  }
}
function uniqueNodes(arr) {
  var res = new Set();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res);
}
function makeOutgoingEdges(arr) {
  var edges = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    if (!edges.has(edge[0]))
      edges.set(edge[0], new Set());
    if (!edges.has(edge[1]))
      edges.set(edge[1], new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges;
}
function makeNodesHash(arr) {
  var res = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i);
  }
  return res;
}
const toString$1 = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : () => "";
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
  if (val != +val)
    return "NaN";
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? "-0" : "" + val;
}
function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false)
    return "" + val;
  const typeOf3 = typeof val;
  if (typeOf3 === "number")
    return printNumber(val);
  if (typeOf3 === "string")
    return quoteStrings ? `"${val}"` : val;
  if (typeOf3 === "function")
    return "[Function " + (val.name || "anonymous") + "]";
  if (typeOf3 === "symbol")
    return symbolToString.call(val).replace(SYMBOL_REGEXP, "Symbol($1)");
  const tag = toString$1.call(val).slice(8, -1);
  if (tag === "Date")
    return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
  if (tag === "Error" || val instanceof Error)
    return "[" + errorToString.call(val) + "]";
  if (tag === "RegExp")
    return regExpToString.call(val);
  return null;
}
function printValue(value, quoteStrings) {
  let result2 = printSimpleValue(value, quoteStrings);
  if (result2 !== null)
    return result2;
  return JSON.stringify(value, function(key, value2) {
    let result3 = printSimpleValue(this[key], quoteStrings);
    if (result3 !== null)
      return result3;
    return value2;
  }, 2);
}
function toArray$1(value) {
  return value == null ? [] : [].concat(value);
}
let _Symbol$toStringTag;
let strReg = /\$\{\s*(\w+)\s*\}/g;
_Symbol$toStringTag = Symbol.toStringTag;
class ValidationError extends Error {
  static formatError(message, params2) {
    const path = params2.label || params2.path || "this";
    if (path !== params2.path)
      params2 = Object.assign({}, params2, {
        path
      });
    if (typeof message === "string")
      return message.replace(strReg, (_3, key) => printValue(params2[key]));
    if (typeof message === "function")
      return message(params2);
    return message;
  }
  static isError(err) {
    return err && err.name === "ValidationError";
  }
  constructor(errorOrErrors, value, field, type, disableStack) {
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.errors = void 0;
    this.params = void 0;
    this.inner = void 0;
    this[_Symbol$toStringTag] = "Error";
    this.name = "ValidationError";
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray$1(errorOrErrors).forEach((err) => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        const innerErrors = err.inner.length ? err.inner : [err];
        this.inner.push(...innerErrors);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (!disableStack && Error.captureStackTrace)
      Error.captureStackTrace(this, ValidationError);
  }
}
let mixed = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : ".";
    return type !== "mixed" ? `${path} must be a \`${type}\` type, but the final value was: \`${printValue(value, true)}\`` + castMsg : `${path} must match the configured type. The validated value was: \`${printValue(value, true)}\`` + castMsg;
  }
};
let string = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
};
let number = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
};
let date = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
};
let boolean = {
  isValue: "${path} field must be ${value}"
};
let object = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let array = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
let tuple = {
  notType: (params2) => {
    const {
      path,
      value,
      spec
    } = params2;
    const typeLen = spec.types.length;
    if (Array.isArray(value)) {
      if (value.length < typeLen)
        return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
      if (value.length > typeLen)
        return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
    }
    return ValidationError.formatError(mixed.notType, params2);
  }
};
Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean,
  tuple
});
const isSchema = (obj) => obj && obj.__isYupSchema__;
class Condition {
  static fromOptions(refs, config) {
    if (!config.then && !config.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: is2,
      then,
      otherwise
    } = config;
    let check = typeof is2 === "function" ? is2 : (...values) => values.every((value) => value === is2);
    return new Condition(refs, (values, schema) => {
      var _branch;
      let branch = check(...values) ? then : otherwise;
      return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
    });
  }
  constructor(refs, builder) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;
    this.fn = builder;
  }
  resolve(base, options) {
    let values = this.refs.map((ref2) => ref2.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn(values, base, options);
    if (schema === void 0 || schema === base) {
      return base;
    }
    if (!isSchema(schema))
      throw new TypeError("conditions must return a schema object");
    return schema.resolve(options);
  }
}
const prefixes = {
  context: "$",
  value: "."
};
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== "string")
      throw new TypeError("ref must be a string, got: " + key);
    this.key = key.trim();
    if (key === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : "";
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && propertyExpr.getter(this.path, true);
    this.map = options.map;
  }
  getValue(value, parent2, context) {
    let result2 = this.isContext ? context : this.isValue ? value : parent2;
    if (this.getter)
      result2 = this.getter(result2 || {});
    if (this.map)
      result2 = this.map(result2);
    return result2;
  }
  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(value) {
    return value && value.__isYupRef;
  }
}
Reference.prototype.__isYupRef = true;
const isAbsent = (value) => value == null;
function createValidation(config) {
  function validate({
    value,
    path = "",
    options,
    originalValue,
    schema
  }, panic, next) {
    const {
      name: name2,
      test: test2,
      params: params2,
      message,
      skipAbsent
    } = config;
    let {
      parent: parent2,
      context,
      abortEarly = schema.spec.abortEarly,
      disableStackTrace = schema.spec.disableStackTrace
    } = options;
    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent2, context) : item;
    }
    function createError(overrides = {}) {
      var _overrides$disableSta;
      const nextParams = Object.assign({
        value,
        originalValue,
        label: schema.spec.label,
        path: overrides.path || path,
        spec: schema.spec
      }, params2, overrides.params);
      for (const key of Object.keys(nextParams))
        nextParams[key] = resolve(nextParams[key]);
      const error2 = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name2, (_overrides$disableSta = overrides.disableStackTrace) != null ? _overrides$disableSta : disableStackTrace);
      error2.params = nextParams;
      return error2;
    }
    const invalid = abortEarly ? panic : next;
    let ctx = {
      path,
      parent: parent2,
      type: name2,
      from: options.from,
      createError,
      resolve,
      options,
      originalValue,
      schema
    };
    const handleResult = (validOrError) => {
      if (ValidationError.isError(validOrError))
        invalid(validOrError);
      else if (!validOrError)
        invalid(createError());
      else
        next(null);
    };
    const handleError = (err) => {
      if (ValidationError.isError(err))
        invalid(err);
      else
        panic(err);
    };
    const shouldSkip = skipAbsent && isAbsent(value);
    if (shouldSkip) {
      return handleResult(true);
    }
    let result2;
    try {
      var _result;
      result2 = test2.call(ctx, value, ctx);
      if (typeof ((_result = result2) == null ? void 0 : _result.then) === "function") {
        if (options.sync) {
          throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        }
        return Promise.resolve(result2).then(handleResult, handleError);
      }
    } catch (err) {
      handleError(err);
      return;
    }
    handleResult(result2);
  }
  validate.OPTIONS = config;
  return validate;
}
function getIn(schema, path, value, context = value) {
  let parent2, lastPart, lastPartDebug;
  if (!path)
    return {
      parent: parent2,
      parentPath: path,
      schema
    };
  propertyExpr.forEach(path, (_part, isBracket, isArray2) => {
    let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
    schema = schema.resolve({
      context,
      parent: parent2,
      value
    });
    let isTuple = schema.type === "tuple";
    let idx = isArray2 ? parseInt(part, 10) : 0;
    if (schema.innerType || isTuple) {
      if (isTuple && !isArray2)
        throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. because there is no value at that index. `);
      }
      parent2 = value;
      value = value && value[idx];
      schema = isTuple ? schema.spec.types[idx] : schema.innerType;
    }
    if (!isArray2) {
      if (!schema.fields || !schema.fields[part])
        throw new Error(`The schema does not contain the path: ${path}. (failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
      parent2 = value;
      value = value && value[part];
      schema = schema.fields[part];
    }
    lastPart = part;
    lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
  });
  return {
    schema,
    parent: parent2,
    parentPath: lastPart
  };
}
class ReferenceSet extends Set {
  describe() {
    const description = [];
    for (const item of this.values()) {
      description.push(Reference.isRef(item) ? item.describe() : item);
    }
    return description;
  }
  resolveAll(resolve) {
    let result2 = [];
    for (const item of this.values()) {
      result2.push(resolve(item));
    }
    return result2;
  }
  clone() {
    return new ReferenceSet(this.values());
  }
  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.forEach((value) => next.add(value));
    removeItems.forEach((value) => next.delete(value));
    return next;
  }
}
function clone$2(src, seen = new Map()) {
  if (isSchema(src) || !src || typeof src !== "object")
    return src;
  if (seen.has(src))
    return seen.get(src);
  let copy;
  if (src instanceof Date) {
    copy = new Date(src.getTime());
    seen.set(src, copy);
  } else if (src instanceof RegExp) {
    copy = new RegExp(src);
    seen.set(src, copy);
  } else if (Array.isArray(src)) {
    copy = new Array(src.length);
    seen.set(src, copy);
    for (let i = 0; i < src.length; i++)
      copy[i] = clone$2(src[i], seen);
  } else if (src instanceof Map) {
    copy = new Map();
    seen.set(src, copy);
    for (const [k3, v3] of src.entries())
      copy.set(k3, clone$2(v3, seen));
  } else if (src instanceof Set) {
    copy = new Set();
    seen.set(src, copy);
    for (const v3 of src)
      copy.add(clone$2(v3, seen));
  } else if (src instanceof Object) {
    copy = {};
    seen.set(src, copy);
    for (const [k3, v3] of Object.entries(src))
      copy[k3] = clone$2(v3, seen);
  } else {
    throw Error(`Unable to clone ${src}`);
  }
  return copy;
}
class Schema {
  constructor(options) {
    this.type = void 0;
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this.internalTests = {};
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this._typeCheck = void 0;
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = options.type;
    this._typeCheck = options.check;
    this.spec = Object.assign({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      disableStackTrace: false,
      nullable: false,
      optional: true,
      coerce: true
    }, options == null ? void 0 : options.spec);
    this.withMutation((s3) => {
      s3.nonNullable();
    });
  }
  get _type() {
    return this.type;
  }
  clone(spec) {
    if (this._mutate) {
      if (spec)
        Object.assign(this.spec, spec);
      return this;
    }
    const next = Object.create(Object.getPrototypeOf(this));
    next.type = this.type;
    next._typeCheck = this._typeCheck;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.internalTests = Object.assign({}, this.internalTests);
    next.exclusiveTests = Object.assign({}, this.exclusiveTests);
    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone$2(Object.assign({}, this.spec, spec));
    return next;
  }
  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }
  meta(...args) {
    if (args.length === 0)
      return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  }
  withMutation(fn2) {
    let before = this._mutate;
    this._mutate = true;
    let result2 = fn2(this);
    this._mutate = before;
    return result2;
  }
  concat(schema) {
    if (!schema || schema === this)
      return this;
    if (schema.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();
    const mergedSpec = Object.assign({}, base.spec, combined.spec);
    combined.spec = mergedSpec;
    combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests;
    combined.withMutation((next) => {
      schema.tests.forEach((fn2) => {
        next.test(fn2.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }
  isType(v3) {
    if (v3 == null) {
      if (this.spec.nullable && v3 === null)
        return true;
      if (this.spec.optional && v3 === void 0)
        return true;
      return false;
    }
    return this._typeCheck(v3);
  }
  resolve(options) {
    let schema = this;
    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((prevSchema, condition) => condition.resolve(prevSchema, options), schema);
      schema = schema.resolve(options);
    }
    return schema;
  }
  resolveOptions(options) {
    var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
    return Object.assign({}, options, {
      from: options.from || [],
      strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
      abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
      recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
      disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
    });
  }
  cast(value, options = {}) {
    let resolvedSchema = this.resolve(Object.assign({
      value
    }, options));
    let allowOptionality = options.assert === "ignore-optionality";
    let result2 = resolvedSchema._cast(value, options);
    if (options.assert !== false && !resolvedSchema.isType(result2)) {
      if (allowOptionality && isAbsent(result2)) {
        return result2;
      }
      let formattedValue = printValue(value);
      let formattedResult = printValue(result2);
      throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value that satisfies the schema type: "${resolvedSchema.type}". 

attempted value: ${formattedValue} 
` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
    }
    return result2;
  }
  _cast(rawValue, options) {
    let value = rawValue === void 0 ? rawValue : this.transforms.reduce((prevValue, fn2) => fn2.call(this, prevValue, rawValue, this), rawValue);
    if (value === void 0) {
      value = this.getDefault(options);
    }
    return value;
  }
  _validate(_value, options = {}, panic, next) {
    let {
      path,
      originalValue = _value,
      strict = this.spec.strict
    } = options;
    let value = _value;
    if (!strict) {
      value = this._cast(value, Object.assign({
        assert: false
      }, options));
    }
    let initialTests = [];
    for (let test2 of Object.values(this.internalTests)) {
      if (test2)
        initialTests.push(test2);
    }
    this.runTests({
      path,
      value,
      originalValue,
      options,
      tests: initialTests
    }, panic, (initialErrors) => {
      if (initialErrors.length) {
        return next(initialErrors, value);
      }
      this.runTests({
        path,
        value,
        originalValue,
        options,
        tests: this.tests
      }, panic, next);
    });
  }
  runTests(runOptions, panic, next) {
    let fired = false;
    let {
      tests,
      value,
      originalValue,
      path,
      options
    } = runOptions;
    let panicOnce = (arg) => {
      if (fired)
        return;
      fired = true;
      panic(arg, value);
    };
    let nextOnce = (arg) => {
      if (fired)
        return;
      fired = true;
      next(arg, value);
    };
    let count = tests.length;
    let nestedErrors = [];
    if (!count)
      return nextOnce([]);
    let args = {
      value,
      originalValue,
      path,
      options,
      schema: this
    };
    for (let i = 0; i < tests.length; i++) {
      const test2 = tests[i];
      test2(args, panicOnce, function finishTestRun(err) {
        if (err) {
          Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
        }
        if (--count <= 0) {
          nextOnce(nestedErrors);
        }
      });
    }
  }
  asNestedTest({
    key,
    index,
    parent: parent2,
    parentPath,
    originalParent,
    options
  }) {
    const k3 = key != null ? key : index;
    if (k3 == null) {
      throw TypeError("Must include `key` or `index` for nested validations");
    }
    const isIndex = typeof k3 === "number";
    let value = parent2[k3];
    const testOptions = Object.assign({}, options, {
      strict: true,
      parent: parent2,
      value,
      originalValue: originalParent[k3],
      key: void 0,
      [isIndex ? "index" : "key"]: k3,
      path: isIndex || k3.includes(".") ? `${parentPath || ""}[${value ? k3 : `"${k3}"`}]` : (parentPath ? `${parentPath}.` : "") + key
    });
    return (_3, panic, next) => this.resolve(testOptions)._validate(value, testOptions, panic, next);
  }
  validate(value, options) {
    var _options$disableStack2;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
    return new Promise((resolve, reject) => schema._validate(value, options, (error2, parsed) => {
      if (ValidationError.isError(error2))
        error2.value = parsed;
      reject(error2);
    }, (errors, validated) => {
      if (errors.length)
        reject(new ValidationError(errors, validated, void 0, void 0, disableStackTrace));
      else
        resolve(validated);
    }));
  }
  validateSync(value, options) {
    var _options$disableStack3;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let result2;
    let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
    schema._validate(value, Object.assign({}, options, {
      sync: true
    }), (error2, parsed) => {
      if (ValidationError.isError(error2))
        error2.value = parsed;
      throw error2;
    }, (errors, validated) => {
      if (errors.length)
        throw new ValidationError(errors, value, void 0, void 0, disableStackTrace);
      result2 = validated;
    });
    return result2;
  }
  isValid(value, options) {
    return this.validate(value, options).then(() => true, (err) => {
      if (ValidationError.isError(err))
        return false;
      throw err;
    });
  }
  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err))
        return false;
      throw err;
    }
  }
  _getDefault(options) {
    let defaultValue = this.spec.default;
    if (defaultValue == null) {
      return defaultValue;
    }
    return typeof defaultValue === "function" ? defaultValue.call(this, options) : clone$2(defaultValue);
  }
  getDefault(options) {
    let schema = this.resolve(options || {});
    return schema._getDefault(options);
  }
  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }
    let next = this.clone({
      default: def
    });
    return next;
  }
  strict(isStrict = true) {
    return this.clone({
      strict: isStrict
    });
  }
  nullability(nullable, message) {
    const next = this.clone({
      nullable
    });
    next.internalTests.nullable = createValidation({
      message,
      name: "nullable",
      test(value) {
        return value === null ? this.schema.spec.nullable : true;
      }
    });
    return next;
  }
  optionality(optional, message) {
    const next = this.clone({
      optional
    });
    next.internalTests.optionality = createValidation({
      message,
      name: "optionality",
      test(value) {
        return value === void 0 ? this.schema.spec.optional : true;
      }
    });
    return next;
  }
  optional() {
    return this.optionality(true);
  }
  defined(message = mixed.defined) {
    return this.optionality(false, message);
  }
  nullable() {
    return this.nullability(true);
  }
  nonNullable(message = mixed.notNull) {
    return this.nullability(false, message);
  }
  required(message = mixed.required) {
    return this.clone().withMutation((next) => next.nonNullable(message).defined(message));
  }
  notRequired() {
    return this.clone().withMutation((next) => next.nullable().optional());
  }
  transform(fn2) {
    let next = this.clone();
    next.transforms.push(fn2);
    return next;
  }
  test(...args) {
    let opts;
    if (args.length === 1) {
      if (typeof args[0] === "function") {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }
    if (opts.message === void 0)
      opts.message = mixed.default;
    if (typeof opts.test !== "function")
      throw new TypeError("`test` is a required parameters");
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
    if (opts.exclusive) {
      if (!opts.name)
        throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    }
    if (opts.name)
      next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter((fn2) => {
      if (fn2.OPTIONS.name === opts.name) {
        if (isExclusive)
          return false;
        if (fn2.OPTIONS.test === validate.OPTIONS.test)
          return false;
      }
      return true;
    });
    next.tests.push(validate);
    return next;
  }
  when(keys2, options) {
    if (!Array.isArray(keys2) && typeof keys2 !== "string") {
      options = keys2;
      keys2 = ".";
    }
    let next = this.clone();
    let deps = toArray$1(keys2).map((key) => new Reference(key));
    deps.forEach((dep) => {
      if (dep.isSibling)
        next.deps.push(dep.key);
    });
    next.conditions.push(typeof options === "function" ? new Condition(deps, options) : Condition.fromOptions(deps, options));
    return next;
  }
  typeError(message) {
    let next = this.clone();
    next.internalTests.typeError = createValidation({
      message,
      name: "typeError",
      skipAbsent: true,
      test(value) {
        if (!this.schema._typeCheck(value))
          return this.createError({
            params: {
              type: this.schema.type
            }
          });
        return true;
      }
    });
    return next;
  }
  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach((val) => {
      next._whitelist.add(val);
      next._blacklist.delete(val);
    });
    next.internalTests.whiteList = createValidation({
      message,
      name: "oneOf",
      skipAbsent: true,
      test(value) {
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: Array.from(valids).join(", "),
            resolved
          }
        });
      }
    });
    return next;
  }
  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach((val) => {
      next._blacklist.add(val);
      next._whitelist.delete(val);
    });
    next.internalTests.blacklist = createValidation({
      message,
      name: "notOneOf",
      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value))
          return this.createError({
            params: {
              values: Array.from(invalids).join(", "),
              resolved
            }
          });
        return true;
      }
    });
    return next;
  }
  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const {
      label,
      meta,
      optional,
      nullable
    } = next.spec;
    const description = {
      meta,
      label,
      optional,
      nullable,
      default: next.getDefault(options),
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map((fn2) => ({
        name: fn2.OPTIONS.name,
        params: fn2.OPTIONS.params
      })).filter((n3, idx, list2) => list2.findIndex((c3) => c3.name === n3.name) === idx)
    };
    return description;
  }
}
Schema.prototype.__isYupSchema__ = true;
for (const method of ["validate", "validateSync"])
  Schema.prototype[`${method}At`] = function(path, value, options = {}) {
    const {
      parent: parent2,
      parentPath,
      schema
    } = getIn(this, path, value, options.context);
    return schema[method](parent2 && parent2[parentPath], Object.assign({}, options, {
      parent: parent2,
      path
    }));
  };
for (const alias of ["equals", "is"])
  Schema.prototype[alias] = Schema.prototype.oneOf;
for (const alias of ["not", "nope"])
  Schema.prototype[alias] = Schema.prototype.notOneOf;
let rEmail = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let isTrimmed = (value) => isAbsent(value) || value === value.trim();
let objStringTag = {}.toString();
function create$6() {
  return new StringSchema();
}
class StringSchema extends Schema {
  constructor() {
    super({
      type: "string",
      check(value) {
        if (value instanceof String)
          value = value.valueOf();
        return typeof value === "string";
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (!ctx.spec.coerce || ctx.isType(value))
          return value;
        if (Array.isArray(value))
          return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag)
          return value;
        return strValue;
      });
    });
  }
  required(message) {
    return super.required(message).withMutation((schema) => schema.test({
      message: message || mixed.required,
      name: "required",
      skipAbsent: true,
      test: (value) => !!value.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((schema) => {
      schema.tests = schema.tests.filter((t3) => t3.OPTIONS.name !== "required");
      return schema;
    });
  }
  length(length, message = string.length) {
    return this.test({
      message,
      name: "length",
      exclusive: true,
      params: {
        length
      },
      skipAbsent: true,
      test(value) {
        return value.length === this.resolve(length);
      }
    });
  }
  min(min2, message = string.min) {
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        min: min2
      },
      skipAbsent: true,
      test(value) {
        return value.length >= this.resolve(min2);
      }
    });
  }
  max(max2, message = string.max) {
    return this.test({
      name: "max",
      exclusive: true,
      message,
      params: {
        max: max2
      },
      skipAbsent: true,
      test(value) {
        return value.length <= this.resolve(max2);
      }
    });
  }
  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name2;
    if (options) {
      if (typeof options === "object") {
        ({
          excludeEmptyString = false,
          message,
          name: name2
        } = options);
      } else {
        message = options;
      }
    }
    return this.test({
      name: name2 || "matches",
      message: message || string.matches,
      params: {
        regex
      },
      skipAbsent: true,
      test: (value) => value === "" && excludeEmptyString || value.search(regex) !== -1
    });
  }
  email(message = string.email) {
    return this.matches(rEmail, {
      name: "email",
      message,
      excludeEmptyString: true
    });
  }
  url(message = string.url) {
    return this.matches(rUrl, {
      name: "url",
      message,
      excludeEmptyString: true
    });
  }
  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: "uuid",
      message,
      excludeEmptyString: false
    });
  }
  ensure() {
    return this.default("").transform((val) => val === null ? "" : val);
  }
  trim(message = string.trim) {
    return this.transform((val) => val != null ? val.trim() : val).test({
      message,
      name: "trim",
      test: isTrimmed
    });
  }
  lowercase(message = string.lowercase) {
    return this.transform((value) => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: "string_case",
      exclusive: true,
      skipAbsent: true,
      test: (value) => isAbsent(value) || value === value.toLowerCase()
    });
  }
  uppercase(message = string.uppercase) {
    return this.transform((value) => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: "string_case",
      exclusive: true,
      skipAbsent: true,
      test: (value) => isAbsent(value) || value === value.toUpperCase()
    });
  }
}
create$6.prototype = StringSchema.prototype;
const isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function toNumber(str, defaultValue = 0) {
  return Number(str) || defaultValue;
}
function parseIsoDate(date2) {
  const regexResult = isoReg.exec(date2);
  if (!regexResult)
    return Date.parse ? Date.parse(date2) : Number.NaN;
  const struct = {
    year: toNumber(regexResult[1]),
    month: toNumber(regexResult[2], 1) - 1,
    day: toNumber(regexResult[3], 1),
    hour: toNumber(regexResult[4]),
    minute: toNumber(regexResult[5]),
    second: toNumber(regexResult[6]),
    millisecond: regexResult[7] ? toNumber(regexResult[7].substring(0, 3)) : 0,
    z: regexResult[8] || void 0,
    plusMinus: regexResult[9] || void 0,
    hourOffset: toNumber(regexResult[10]),
    minuteOffset: toNumber(regexResult[11])
  };
  if (struct.z === void 0 && struct.plusMinus === void 0) {
    return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
  }
  let totalMinutesOffset = 0;
  if (struct.z !== "Z" && struct.plusMinus !== void 0) {
    totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
    if (struct.plusMinus === "+")
      totalMinutesOffset = 0 - totalMinutesOffset;
  }
  return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
let invalidDate$1 = new Date("");
let isDate$1 = (obj) => Object.prototype.toString.call(obj) === "[object Date]";
class DateSchema extends Schema {
  constructor() {
    super({
      type: "date",
      check(v3) {
        return isDate$1(v3) && !isNaN(v3.getTime());
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (!ctx.spec.coerce || ctx.isType(value) || value === null)
          return value;
        value = parseIsoDate(value);
        return !isNaN(value) ? new Date(value) : DateSchema.INVALID_DATE;
      });
    });
  }
  prepareParam(ref2, name2) {
    let param;
    if (!Reference.isRef(ref2)) {
      let cast = this.cast(ref2);
      if (!this._typeCheck(cast))
        throw new TypeError(`\`${name2}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref2;
    }
    return param;
  }
  min(min2, message = date.min) {
    let limit = this.prepareParam(min2, "min");
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        min: min2
      },
      skipAbsent: true,
      test(value) {
        return value >= this.resolve(limit);
      }
    });
  }
  max(max2, message = date.max) {
    let limit = this.prepareParam(max2, "max");
    return this.test({
      message,
      name: "max",
      exclusive: true,
      params: {
        max: max2
      },
      skipAbsent: true,
      test(value) {
        return value <= this.resolve(limit);
      }
    });
  }
}
DateSchema.INVALID_DATE = invalidDate$1;
var momentTimezone$1 = { exports: {} };
var momentTimezone = { exports: {} };
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var hookCallback;
function hooks() {
  return hookCallback.apply(null, arguments);
}
function setHookCallback(callback) {
  hookCallback = callback;
}
function isArray(input) {
  return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
}
function isObject(input) {
  return input != null && Object.prototype.toString.call(input) === "[object Object]";
}
function hasOwnProp(a3, b3) {
  return Object.prototype.hasOwnProperty.call(a3, b3);
}
function isObjectEmpty(obj) {
  if (Object.getOwnPropertyNames) {
    return Object.getOwnPropertyNames(obj).length === 0;
  } else {
    var k3;
    for (k3 in obj) {
      if (hasOwnProp(obj, k3)) {
        return false;
      }
    }
    return true;
  }
}
function isUndefined(input) {
  return input === void 0;
}
function isNumber(input) {
  return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
}
function isDate(input) {
  return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
}
function map(arr, fn2) {
  var res = [], i, arrLen = arr.length;
  for (i = 0; i < arrLen; ++i) {
    res.push(fn2(arr[i], i));
  }
  return res;
}
function extend(a3, b3) {
  for (var i in b3) {
    if (hasOwnProp(b3, i)) {
      a3[i] = b3[i];
    }
  }
  if (hasOwnProp(b3, "toString")) {
    a3.toString = b3.toString;
  }
  if (hasOwnProp(b3, "valueOf")) {
    a3.valueOf = b3.valueOf;
  }
  return a3;
}
function createUTC(input, format2, locale2, strict) {
  return createLocalOrUTC(input, format2, locale2, strict, true).utc();
}
function defaultParsingFlags() {
  return {
    empty: false,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: false,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: false,
    userInvalidated: false,
    iso: false,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: false,
    weekdayMismatch: false
  };
}
function getParsingFlags(m3) {
  if (m3._pf == null) {
    m3._pf = defaultParsingFlags();
  }
  return m3._pf;
}
var some;
if (Array.prototype.some) {
  some = Array.prototype.some;
} else {
  some = function(fun) {
    var t3 = Object(this), len = t3.length >>> 0, i;
    for (i = 0; i < len; i++) {
      if (i in t3 && fun.call(this, t3[i], i, t3)) {
        return true;
      }
    }
    return false;
  };
}
function isValid(m3) {
  var flags = null, parsedParts = false, isNowValid = m3._d && !isNaN(m3._d.getTime());
  if (isNowValid) {
    flags = getParsingFlags(m3);
    parsedParts = some.call(flags.parsedDateParts, function(i) {
      return i != null;
    });
    isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
    if (m3._strict) {
      isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === void 0;
    }
  }
  if (Object.isFrozen == null || !Object.isFrozen(m3)) {
    m3._isValid = isNowValid;
  } else {
    return isNowValid;
  }
  return m3._isValid;
}
function createInvalid(flags) {
  var m3 = createUTC(NaN);
  if (flags != null) {
    extend(getParsingFlags(m3), flags);
  } else {
    getParsingFlags(m3).userInvalidated = true;
  }
  return m3;
}
var momentProperties = hooks.momentProperties = [], updateInProgress = false;
function copyConfig(to2, from2) {
  var i, prop, val, momentPropertiesLen = momentProperties.length;
  if (!isUndefined(from2._isAMomentObject)) {
    to2._isAMomentObject = from2._isAMomentObject;
  }
  if (!isUndefined(from2._i)) {
    to2._i = from2._i;
  }
  if (!isUndefined(from2._f)) {
    to2._f = from2._f;
  }
  if (!isUndefined(from2._l)) {
    to2._l = from2._l;
  }
  if (!isUndefined(from2._strict)) {
    to2._strict = from2._strict;
  }
  if (!isUndefined(from2._tzm)) {
    to2._tzm = from2._tzm;
  }
  if (!isUndefined(from2._isUTC)) {
    to2._isUTC = from2._isUTC;
  }
  if (!isUndefined(from2._offset)) {
    to2._offset = from2._offset;
  }
  if (!isUndefined(from2._pf)) {
    to2._pf = getParsingFlags(from2);
  }
  if (!isUndefined(from2._locale)) {
    to2._locale = from2._locale;
  }
  if (momentPropertiesLen > 0) {
    for (i = 0; i < momentPropertiesLen; i++) {
      prop = momentProperties[i];
      val = from2[prop];
      if (!isUndefined(val)) {
        to2[prop] = val;
      }
    }
  }
  return to2;
}
function Moment(config) {
  copyConfig(this, config);
  this._d = new Date(config._d != null ? config._d.getTime() : NaN);
  if (!this.isValid()) {
    this._d = new Date(NaN);
  }
  if (updateInProgress === false) {
    updateInProgress = true;
    hooks.updateOffset(this);
    updateInProgress = false;
  }
}
function isMoment(obj) {
  return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
}
function warn2(msg) {
  if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) {
    console.warn("Deprecation warning: " + msg);
  }
}
function deprecate(msg, fn2) {
  var firstTime = true;
  return extend(function() {
    if (hooks.deprecationHandler != null) {
      hooks.deprecationHandler(null, msg);
    }
    if (firstTime) {
      var args = [], arg, i, key, argLen = arguments.length;
      for (i = 0; i < argLen; i++) {
        arg = "";
        if (typeof arguments[i] === "object") {
          arg += "\n[" + i + "] ";
          for (key in arguments[0]) {
            if (hasOwnProp(arguments[0], key)) {
              arg += key + ": " + arguments[0][key] + ", ";
            }
          }
          arg = arg.slice(0, -2);
        } else {
          arg = arguments[i];
        }
        args.push(arg);
      }
      warn2(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
      firstTime = false;
    }
    return fn2.apply(this, arguments);
  }, fn2);
}
var deprecations = {};
function deprecateSimple(name2, msg) {
  if (hooks.deprecationHandler != null) {
    hooks.deprecationHandler(name2, msg);
  }
  if (!deprecations[name2]) {
    warn2(msg);
    deprecations[name2] = true;
  }
}
hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;
function isFunction(input) {
  return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
}
function set(config) {
  var prop, i;
  for (i in config) {
    if (hasOwnProp(config, i)) {
      prop = config[i];
      if (isFunction(prop)) {
        this[i] = prop;
      } else {
        this["_" + i] = prop;
      }
    }
  }
  this._config = config;
  this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
}
function mergeConfigs(parentConfig, childConfig) {
  var res = extend({}, parentConfig), prop;
  for (prop in childConfig) {
    if (hasOwnProp(childConfig, prop)) {
      if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
        res[prop] = {};
        extend(res[prop], parentConfig[prop]);
        extend(res[prop], childConfig[prop]);
      } else if (childConfig[prop] != null) {
        res[prop] = childConfig[prop];
      } else {
        delete res[prop];
      }
    }
  }
  for (prop in parentConfig) {
    if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
      res[prop] = extend({}, res[prop]);
    }
  }
  return res;
}
function Locale(config) {
  if (config != null) {
    this.set(config);
  }
}
var keys;
if (Object.keys) {
  keys = Object.keys;
} else {
  keys = function(obj) {
    var i, res = [];
    for (i in obj) {
      if (hasOwnProp(obj, i)) {
        res.push(i);
      }
    }
    return res;
  };
}
var defaultCalendar = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function calendar(key, mom, now2) {
  var output = this._calendar[key] || this._calendar["sameElse"];
  return isFunction(output) ? output.call(mom, now2) : output;
}
function zeroFill(number2, targetLength, forceSign) {
  var absNumber = "" + Math.abs(number2), zerosToFill = targetLength - absNumber.length, sign2 = number2 >= 0;
  return (sign2 ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}
var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
function addFormatToken(token2, padded, ordinal2, callback) {
  var func = callback;
  if (typeof callback === "string") {
    func = function() {
      return this[callback]();
    };
  }
  if (token2) {
    formatTokenFunctions[token2] = func;
  }
  if (padded) {
    formatTokenFunctions[padded[0]] = function() {
      return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
    };
  }
  if (ordinal2) {
    formatTokenFunctions[ordinal2] = function() {
      return this.localeData().ordinal(func.apply(this, arguments), token2);
    };
  }
}
function removeFormattingTokens(input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|\]$/g, "");
  }
  return input.replace(/\\/g, "");
}
function makeFormatFunction(format2) {
  var array2 = format2.match(formattingTokens), i, length;
  for (i = 0, length = array2.length; i < length; i++) {
    if (formatTokenFunctions[array2[i]]) {
      array2[i] = formatTokenFunctions[array2[i]];
    } else {
      array2[i] = removeFormattingTokens(array2[i]);
    }
  }
  return function(mom) {
    var output = "", i3;
    for (i3 = 0; i3 < length; i3++) {
      output += isFunction(array2[i3]) ? array2[i3].call(mom, format2) : array2[i3];
    }
    return output;
  };
}
function formatMoment(m3, format2) {
  if (!m3.isValid()) {
    return m3.localeData().invalidDate();
  }
  format2 = expandFormat(format2, m3.localeData());
  formatFunctions[format2] = formatFunctions[format2] || makeFormatFunction(format2);
  return formatFunctions[format2](m3);
}
function expandFormat(format2, locale2) {
  var i = 5;
  function replaceLongDateFormatTokens(input) {
    return locale2.longDateFormat(input) || input;
  }
  localFormattingTokens.lastIndex = 0;
  while (i >= 0 && localFormattingTokens.test(format2)) {
    format2 = format2.replace(localFormattingTokens, replaceLongDateFormatTokens);
    localFormattingTokens.lastIndex = 0;
    i -= 1;
  }
  return format2;
}
var defaultLongDateFormat = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function longDateFormat(key) {
  var format2 = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
  if (format2 || !formatUpper) {
    return format2;
  }
  this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
    if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") {
      return tok.slice(1);
    }
    return tok;
  }).join("");
  return this._longDateFormat[key];
}
var defaultInvalidDate = "Invalid date";
function invalidDate() {
  return this._invalidDate;
}
var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
function ordinal(number2) {
  return this._ordinal.replace("%d", number2);
}
var defaultRelativeTime = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function relativeTime(number2, withoutSuffix, string2, isFuture) {
  var output = this._relativeTime[string2];
  return isFunction(output) ? output(number2, withoutSuffix, string2, isFuture) : output.replace(/%d/i, number2);
}
function pastFuture(diff2, output) {
  var format2 = this._relativeTime[diff2 > 0 ? "future" : "past"];
  return isFunction(format2) ? format2(output) : format2.replace(/%s/i, output);
}
var aliases = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function normalizeUnits(units) {
  return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : void 0;
}
function normalizeObjectUnits(inputObject) {
  var normalizedInput = {}, normalizedProp, prop;
  for (prop in inputObject) {
    if (hasOwnProp(inputObject, prop)) {
      normalizedProp = normalizeUnits(prop);
      if (normalizedProp) {
        normalizedInput[normalizedProp] = inputObject[prop];
      }
    }
  }
  return normalizedInput;
}
var priorities = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function getPrioritizedUnits(unitsObj) {
  var units = [], u3;
  for (u3 in unitsObj) {
    if (hasOwnProp(unitsObj, u3)) {
      units.push({ unit: u3, priority: priorities[u3] });
    }
  }
  units.sort(function(a3, b3) {
    return a3.priority - b3.priority;
  });
  return units;
}
var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
regexes = {};
function addRegexToken(token2, regex, strictRegex) {
  regexes[token2] = isFunction(regex) ? regex : function(isStrict, localeData2) {
    return isStrict && strictRegex ? strictRegex : regex;
  };
}
function getParseRegexForToken(token2, config) {
  if (!hasOwnProp(regexes, token2)) {
    return new RegExp(unescapeFormat(token2));
  }
  return regexes[token2](config._strict, config._locale);
}
function unescapeFormat(s3) {
  return regexEscape(s3.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p22, p3, p42) {
    return p1 || p22 || p3 || p42;
  }));
}
function regexEscape(s3) {
  return s3.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function absFloor(number2) {
  if (number2 < 0) {
    return Math.ceil(number2) || 0;
  } else {
    return Math.floor(number2);
  }
}
function toInt(argumentForCoercion) {
  var coercedNumber = +argumentForCoercion, value = 0;
  if (coercedNumber !== 0 && isFinite(coercedNumber)) {
    value = absFloor(coercedNumber);
  }
  return value;
}
var tokens = {};
function addParseToken(token2, callback) {
  var i, func = callback, tokenLen;
  if (typeof token2 === "string") {
    token2 = [token2];
  }
  if (isNumber(callback)) {
    func = function(input, array2) {
      array2[callback] = toInt(input);
    };
  }
  tokenLen = token2.length;
  for (i = 0; i < tokenLen; i++) {
    tokens[token2[i]] = func;
  }
}
function addWeekParseToken(token2, callback) {
  addParseToken(token2, function(input, array2, config, token3) {
    config._w = config._w || {};
    callback(input, config._w, config, token3);
  });
}
function addTimeToArrayFromToken(token2, input, config) {
  if (input != null && hasOwnProp(tokens, token2)) {
    tokens[token2](input, config._a, config, token2);
  }
}
function isLeapYear(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
addFormatToken("Y", 0, 0, function() {
  var y3 = this.year();
  return y3 <= 9999 ? zeroFill(y3, 4) : "+" + y3;
});
addFormatToken(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
addFormatToken(0, ["YYYY", 4], 0, "year");
addFormatToken(0, ["YYYYY", 5], 0, "year");
addFormatToken(0, ["YYYYYY", 6, true], 0, "year");
addRegexToken("Y", matchSigned);
addRegexToken("YY", match1to2, match2);
addRegexToken("YYYY", match1to4, match4);
addRegexToken("YYYYY", match1to6, match6);
addRegexToken("YYYYYY", match1to6, match6);
addParseToken(["YYYYY", "YYYYYY"], YEAR);
addParseToken("YYYY", function(input, array2) {
  array2[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken("YY", function(input, array2) {
  array2[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken("Y", function(input, array2) {
  array2[YEAR] = parseInt(input, 10);
});
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
hooks.parseTwoDigitYear = function(input) {
  return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3);
};
var getSetYear = makeGetSet("FullYear", true);
function getIsLeapYear() {
  return isLeapYear(this.year());
}
function makeGetSet(unit, keepTime) {
  return function(value) {
    if (value != null) {
      set$1(this, unit, value);
      hooks.updateOffset(this, keepTime);
      return this;
    } else {
      return get(this, unit);
    }
  };
}
function get(mom, unit) {
  if (!mom.isValid()) {
    return NaN;
  }
  var d3 = mom._d, isUTC = mom._isUTC;
  switch (unit) {
    case "Milliseconds":
      return isUTC ? d3.getUTCMilliseconds() : d3.getMilliseconds();
    case "Seconds":
      return isUTC ? d3.getUTCSeconds() : d3.getSeconds();
    case "Minutes":
      return isUTC ? d3.getUTCMinutes() : d3.getMinutes();
    case "Hours":
      return isUTC ? d3.getUTCHours() : d3.getHours();
    case "Date":
      return isUTC ? d3.getUTCDate() : d3.getDate();
    case "Day":
      return isUTC ? d3.getUTCDay() : d3.getDay();
    case "Month":
      return isUTC ? d3.getUTCMonth() : d3.getMonth();
    case "FullYear":
      return isUTC ? d3.getUTCFullYear() : d3.getFullYear();
    default:
      return NaN;
  }
}
function set$1(mom, unit, value) {
  var d3, isUTC, year, month, date2;
  if (!mom.isValid() || isNaN(value)) {
    return;
  }
  d3 = mom._d;
  isUTC = mom._isUTC;
  switch (unit) {
    case "Milliseconds":
      return void (isUTC ? d3.setUTCMilliseconds(value) : d3.setMilliseconds(value));
    case "Seconds":
      return void (isUTC ? d3.setUTCSeconds(value) : d3.setSeconds(value));
    case "Minutes":
      return void (isUTC ? d3.setUTCMinutes(value) : d3.setMinutes(value));
    case "Hours":
      return void (isUTC ? d3.setUTCHours(value) : d3.setHours(value));
    case "Date":
      return void (isUTC ? d3.setUTCDate(value) : d3.setDate(value));
    case "FullYear":
      break;
    default:
      return;
  }
  year = value;
  month = mom.month();
  date2 = mom.date();
  date2 = date2 === 29 && month === 1 && !isLeapYear(year) ? 28 : date2;
  void (isUTC ? d3.setUTCFullYear(year, month, date2) : d3.setFullYear(year, month, date2));
}
function stringGet(units) {
  units = normalizeUnits(units);
  if (isFunction(this[units])) {
    return this[units]();
  }
  return this;
}
function stringSet(units, value) {
  if (typeof units === "object") {
    units = normalizeObjectUnits(units);
    var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
    for (i = 0; i < prioritizedLen; i++) {
      this[prioritized[i].unit](units[prioritized[i].unit]);
    }
  } else {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
      return this[units](value);
    }
  }
  return this;
}
function mod(n3, x3) {
  return (n3 % x3 + x3) % x3;
}
var indexOf;
if (Array.prototype.indexOf) {
  indexOf = Array.prototype.indexOf;
} else {
  indexOf = function(o3) {
    var i;
    for (i = 0; i < this.length; ++i) {
      if (this[i] === o3) {
        return i;
      }
    }
    return -1;
  };
}
function daysInMonth(year, month) {
  if (isNaN(year) || isNaN(month)) {
    return NaN;
  }
  var modMonth = mod(month, 12);
  year += (month - modMonth) / 12;
  return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
}
addFormatToken("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
addFormatToken("MMM", 0, 0, function(format2) {
  return this.localeData().monthsShort(this, format2);
});
addFormatToken("MMMM", 0, 0, function(format2) {
  return this.localeData().months(this, format2);
});
addRegexToken("M", match1to2, match1to2NoLeadingZero);
addRegexToken("MM", match1to2, match2);
addRegexToken("MMM", function(isStrict, locale2) {
  return locale2.monthsShortRegex(isStrict);
});
addRegexToken("MMMM", function(isStrict, locale2) {
  return locale2.monthsRegex(isStrict);
});
addParseToken(["M", "MM"], function(input, array2) {
  array2[MONTH] = toInt(input) - 1;
});
addParseToken(["MMM", "MMMM"], function(input, array2, config, token2) {
  var month = config._locale.monthsParse(input, token2, config._strict);
  if (month != null) {
    array2[MONTH] = month;
  } else {
    getParsingFlags(config).invalidMonth = input;
  }
});
var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
function localeMonths(m3, format2) {
  if (!m3) {
    return isArray(this._months) ? this._months : this._months["standalone"];
  }
  return isArray(this._months) ? this._months[m3.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format2) ? "format" : "standalone"][m3.month()];
}
function localeMonthsShort(m3, format2) {
  if (!m3) {
    return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
  }
  return isArray(this._monthsShort) ? this._monthsShort[m3.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format2) ? "format" : "standalone"][m3.month()];
}
function handleStrictParse(monthName, format2, strict) {
  var i, ii2, mom, llc = monthName.toLocaleLowerCase();
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
    for (i = 0; i < 12; ++i) {
      mom = createUTC([2e3, i]);
      this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
      this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format2 === "MMM") {
      ii2 = indexOf.call(this._shortMonthsParse, llc);
      return ii2 !== -1 ? ii2 : null;
    } else {
      ii2 = indexOf.call(this._longMonthsParse, llc);
      return ii2 !== -1 ? ii2 : null;
    }
  } else {
    if (format2 === "MMM") {
      ii2 = indexOf.call(this._shortMonthsParse, llc);
      if (ii2 !== -1) {
        return ii2;
      }
      ii2 = indexOf.call(this._longMonthsParse, llc);
      return ii2 !== -1 ? ii2 : null;
    } else {
      ii2 = indexOf.call(this._longMonthsParse, llc);
      if (ii2 !== -1) {
        return ii2;
      }
      ii2 = indexOf.call(this._shortMonthsParse, llc);
      return ii2 !== -1 ? ii2 : null;
    }
  }
}
function localeMonthsParse(monthName, format2, strict) {
  var i, mom, regex;
  if (this._monthsParseExact) {
    return handleStrictParse.call(this, monthName, format2, strict);
  }
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
  }
  for (i = 0; i < 12; i++) {
    mom = createUTC([2e3, i]);
    if (strict && !this._longMonthsParse[i]) {
      this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
      this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
    }
    if (!strict && !this._monthsParse[i]) {
      regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
      this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
    }
    if (strict && format2 === "MMMM" && this._longMonthsParse[i].test(monthName)) {
      return i;
    } else if (strict && format2 === "MMM" && this._shortMonthsParse[i].test(monthName)) {
      return i;
    } else if (!strict && this._monthsParse[i].test(monthName)) {
      return i;
    }
  }
}
function setMonth(mom, value) {
  if (!mom.isValid()) {
    return mom;
  }
  if (typeof value === "string") {
    if (/^\d+$/.test(value)) {
      value = toInt(value);
    } else {
      value = mom.localeData().monthsParse(value);
      if (!isNumber(value)) {
        return mom;
      }
    }
  }
  var month = value, date2 = mom.date();
  date2 = date2 < 29 ? date2 : Math.min(date2, daysInMonth(mom.year(), month));
  void (mom._isUTC ? mom._d.setUTCMonth(month, date2) : mom._d.setMonth(month, date2));
  return mom;
}
function getSetMonth(value) {
  if (value != null) {
    setMonth(this, value);
    hooks.updateOffset(this, true);
    return this;
  } else {
    return get(this, "Month");
  }
}
function getDaysInMonth() {
  return daysInMonth(this.year(), this.month());
}
function monthsShortRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsShortStrictRegex;
    } else {
      return this._monthsShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsShortRegex")) {
      this._monthsShortRegex = defaultMonthsShortRegex;
    }
    return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
  }
}
function monthsRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsStrictRegex;
    } else {
      return this._monthsRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsRegex")) {
      this._monthsRegex = defaultMonthsRegex;
    }
    return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
  }
}
function computeMonthsParse() {
  function cmpLenRev(a3, b3) {
    return b3.length - a3.length;
  }
  var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
  for (i = 0; i < 12; i++) {
    mom = createUTC([2e3, i]);
    shortP = regexEscape(this.monthsShort(mom, ""));
    longP = regexEscape(this.months(mom, ""));
    shortPieces.push(shortP);
    longPieces.push(longP);
    mixedPieces.push(longP);
    mixedPieces.push(shortP);
  }
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._monthsShortRegex = this._monthsRegex;
  this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
  this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
}
function createDate(y3, m3, d3, h3, M3, s3, ms2) {
  var date2;
  if (y3 < 100 && y3 >= 0) {
    date2 = new Date(y3 + 400, m3, d3, h3, M3, s3, ms2);
    if (isFinite(date2.getFullYear())) {
      date2.setFullYear(y3);
    }
  } else {
    date2 = new Date(y3, m3, d3, h3, M3, s3, ms2);
  }
  return date2;
}
function createUTCDate(y3) {
  var date2, args;
  if (y3 < 100 && y3 >= 0) {
    args = Array.prototype.slice.call(arguments);
    args[0] = y3 + 400;
    date2 = new Date(Date.UTC.apply(null, args));
    if (isFinite(date2.getUTCFullYear())) {
      date2.setUTCFullYear(y3);
    }
  } else {
    date2 = new Date(Date.UTC.apply(null, arguments));
  }
  return date2;
}
function firstWeekOffset(year, dow, doy) {
  var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
  return -fwdlw + fwd - 1;
}
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
  var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
  if (dayOfYear <= 0) {
    resYear = year - 1;
    resDayOfYear = daysInYear(resYear) + dayOfYear;
  } else if (dayOfYear > daysInYear(year)) {
    resYear = year + 1;
    resDayOfYear = dayOfYear - daysInYear(year);
  } else {
    resYear = year;
    resDayOfYear = dayOfYear;
  }
  return {
    year: resYear,
    dayOfYear: resDayOfYear
  };
}
function weekOfYear(mom, dow, doy) {
  var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
  if (week < 1) {
    resYear = mom.year() - 1;
    resWeek = week + weeksInYear(resYear, dow, doy);
  } else if (week > weeksInYear(mom.year(), dow, doy)) {
    resWeek = week - weeksInYear(mom.year(), dow, doy);
    resYear = mom.year() + 1;
  } else {
    resYear = mom.year();
    resWeek = week;
  }
  return {
    week: resWeek,
    year: resYear
  };
}
function weeksInYear(year, dow, doy) {
  var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
  return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}
addFormatToken("w", ["ww", 2], "wo", "week");
addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
addRegexToken("w", match1to2, match1to2NoLeadingZero);
addRegexToken("ww", match1to2, match2);
addRegexToken("W", match1to2, match1to2NoLeadingZero);
addRegexToken("WW", match1to2, match2);
addWeekParseToken(["w", "ww", "W", "WW"], function(input, week, config, token2) {
  week[token2.substr(0, 1)] = toInt(input);
});
function localeWeek(mom) {
  return weekOfYear(mom, this._week.dow, this._week.doy).week;
}
var defaultLocaleWeek = {
  dow: 0,
  doy: 6
};
function localeFirstDayOfWeek() {
  return this._week.dow;
}
function localeFirstDayOfYear() {
  return this._week.doy;
}
function getSetWeek(input) {
  var week = this.localeData().week(this);
  return input == null ? week : this.add((input - week) * 7, "d");
}
function getSetISOWeek(input) {
  var week = weekOfYear(this, 1, 4).week;
  return input == null ? week : this.add((input - week) * 7, "d");
}
addFormatToken("d", 0, "do", "day");
addFormatToken("dd", 0, 0, function(format2) {
  return this.localeData().weekdaysMin(this, format2);
});
addFormatToken("ddd", 0, 0, function(format2) {
  return this.localeData().weekdaysShort(this, format2);
});
addFormatToken("dddd", 0, 0, function(format2) {
  return this.localeData().weekdays(this, format2);
});
addFormatToken("e", 0, 0, "weekday");
addFormatToken("E", 0, 0, "isoWeekday");
addRegexToken("d", match1to2);
addRegexToken("e", match1to2);
addRegexToken("E", match1to2);
addRegexToken("dd", function(isStrict, locale2) {
  return locale2.weekdaysMinRegex(isStrict);
});
addRegexToken("ddd", function(isStrict, locale2) {
  return locale2.weekdaysShortRegex(isStrict);
});
addRegexToken("dddd", function(isStrict, locale2) {
  return locale2.weekdaysRegex(isStrict);
});
addWeekParseToken(["dd", "ddd", "dddd"], function(input, week, config, token2) {
  var weekday = config._locale.weekdaysParse(input, token2, config._strict);
  if (weekday != null) {
    week.d = weekday;
  } else {
    getParsingFlags(config).invalidWeekday = input;
  }
});
addWeekParseToken(["d", "e", "E"], function(input, week, config, token2) {
  week[token2] = toInt(input);
});
function parseWeekday(input, locale2) {
  if (typeof input !== "string") {
    return input;
  }
  if (!isNaN(input)) {
    return parseInt(input, 10);
  }
  input = locale2.weekdaysParse(input);
  if (typeof input === "number") {
    return input;
  }
  return null;
}
function parseIsoWeekday(input, locale2) {
  if (typeof input === "string") {
    return locale2.weekdaysParse(input) % 7 || 7;
  }
  return isNaN(input) ? null : input;
}
function shiftWeekdays(ws2, n3) {
  return ws2.slice(n3, 7).concat(ws2.slice(0, n3));
}
var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
function localeWeekdays(m3, format2) {
  var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m3 && m3 !== true && this._weekdays.isFormat.test(format2) ? "format" : "standalone"];
  return m3 === true ? shiftWeekdays(weekdays, this._week.dow) : m3 ? weekdays[m3.day()] : weekdays;
}
function localeWeekdaysShort(m3) {
  return m3 === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m3 ? this._weekdaysShort[m3.day()] : this._weekdaysShort;
}
function localeWeekdaysMin(m3) {
  return m3 === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m3 ? this._weekdaysMin[m3.day()] : this._weekdaysMin;
}
function handleStrictParse$1(weekdayName, format2, strict) {
  var i, ii2, mom, llc = weekdayName.toLocaleLowerCase();
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._minWeekdaysParse = [];
    for (i = 0; i < 7; ++i) {
      mom = createUTC([2e3, 1]).day(i);
      this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
      this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
      this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format2 === "dddd") {
      ii2 = indexOf.call(this._weekdaysParse, llc);
      return ii2 !== -1 ? ii2 : null;
    } else if (format2 === "ddd") {
      ii2 = indexOf.call(this._shortWeekdaysParse, llc);
      return ii2 !== -1 ? ii2 : null;
    } else {
      ii2 = indexOf.call(this._minWeekdaysParse, llc);
      return ii2 !== -1 ? ii2 : null;
    }
  } else {
    if (format2 === "dddd") {
      ii2 = indexOf.call(this._weekdaysParse, llc);
      if (ii2 !== -1) {
        return ii2;
      }
      ii2 = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii2 !== -1) {
        return ii2;
      }
      ii2 = indexOf.call(this._minWeekdaysParse, llc);
      return ii2 !== -1 ? ii2 : null;
    } else if (format2 === "ddd") {
      ii2 = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii2 !== -1) {
        return ii2;
      }
      ii2 = indexOf.call(this._weekdaysParse, llc);
      if (ii2 !== -1) {
        return ii2;
      }
      ii2 = indexOf.call(this._minWeekdaysParse, llc);
      return ii2 !== -1 ? ii2 : null;
    } else {
      ii2 = indexOf.call(this._minWeekdaysParse, llc);
      if (ii2 !== -1) {
        return ii2;
      }
      ii2 = indexOf.call(this._weekdaysParse, llc);
      if (ii2 !== -1) {
        return ii2;
      }
      ii2 = indexOf.call(this._shortWeekdaysParse, llc);
      return ii2 !== -1 ? ii2 : null;
    }
  }
}
function localeWeekdaysParse(weekdayName, format2, strict) {
  var i, mom, regex;
  if (this._weekdaysParseExact) {
    return handleStrictParse$1.call(this, weekdayName, format2, strict);
  }
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._minWeekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._fullWeekdaysParse = [];
  }
  for (i = 0; i < 7; i++) {
    mom = createUTC([2e3, 1]).day(i);
    if (strict && !this._fullWeekdaysParse[i]) {
      this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
      this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
      this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
    }
    if (!this._weekdaysParse[i]) {
      regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
      this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
    }
    if (strict && format2 === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (strict && format2 === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (strict && format2 === "dd" && this._minWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
      return i;
    }
  }
}
function getSetDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var day = get(this, "Day");
  if (input != null) {
    input = parseWeekday(input, this.localeData());
    return this.add(input - day, "d");
  } else {
    return day;
  }
}
function getSetLocaleDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return input == null ? weekday : this.add(input - weekday, "d");
}
function getSetISODayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    var weekday = parseIsoWeekday(input, this.localeData());
    return this.day(this.day() % 7 ? weekday : weekday - 7);
  } else {
    return this.day() || 7;
  }
}
function weekdaysRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysStrictRegex;
    } else {
      return this._weekdaysRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      this._weekdaysRegex = defaultWeekdaysRegex;
    }
    return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
  }
}
function weekdaysShortRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysShortStrictRegex;
    } else {
      return this._weekdaysShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysShortRegex")) {
      this._weekdaysShortRegex = defaultWeekdaysShortRegex;
    }
    return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
  }
}
function weekdaysMinRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysMinStrictRegex;
    } else {
      return this._weekdaysMinRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysMinRegex")) {
      this._weekdaysMinRegex = defaultWeekdaysMinRegex;
    }
    return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
  }
}
function computeWeekdaysParse() {
  function cmpLenRev(a3, b3) {
    return b3.length - a3.length;
  }
  var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
  for (i = 0; i < 7; i++) {
    mom = createUTC([2e3, 1]).day(i);
    minp = regexEscape(this.weekdaysMin(mom, ""));
    shortp = regexEscape(this.weekdaysShort(mom, ""));
    longp = regexEscape(this.weekdays(mom, ""));
    minPieces.push(minp);
    shortPieces.push(shortp);
    longPieces.push(longp);
    mixedPieces.push(minp);
    mixedPieces.push(shortp);
    mixedPieces.push(longp);
  }
  minPieces.sort(cmpLenRev);
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._weekdaysShortRegex = this._weekdaysRegex;
  this._weekdaysMinRegex = this._weekdaysRegex;
  this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
  this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
  this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
}
function hFormat() {
  return this.hours() % 12 || 12;
}
function kFormat() {
  return this.hours() || 24;
}
addFormatToken("H", ["HH", 2], 0, "hour");
addFormatToken("h", ["hh", 2], 0, hFormat);
addFormatToken("k", ["kk", 2], 0, kFormat);
addFormatToken("hmm", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});
addFormatToken("hmmss", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
addFormatToken("Hmm", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2);
});
addFormatToken("Hmmss", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
function meridiem(token2, lowercase) {
  addFormatToken(token2, 0, 0, function() {
    return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
  });
}
meridiem("a", true);
meridiem("A", false);
function matchMeridiem(isStrict, locale2) {
  return locale2._meridiemParse;
}
addRegexToken("a", matchMeridiem);
addRegexToken("A", matchMeridiem);
addRegexToken("H", match1to2, match1to2HasZero);
addRegexToken("h", match1to2, match1to2NoLeadingZero);
addRegexToken("k", match1to2, match1to2NoLeadingZero);
addRegexToken("HH", match1to2, match2);
addRegexToken("hh", match1to2, match2);
addRegexToken("kk", match1to2, match2);
addRegexToken("hmm", match3to4);
addRegexToken("hmmss", match5to6);
addRegexToken("Hmm", match3to4);
addRegexToken("Hmmss", match5to6);
addParseToken(["H", "HH"], HOUR);
addParseToken(["k", "kk"], function(input, array2, config) {
  var kInput = toInt(input);
  array2[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(["a", "A"], function(input, array2, config) {
  config._isPm = config._locale.isPM(input);
  config._meridiem = input;
});
addParseToken(["h", "hh"], function(input, array2, config) {
  array2[HOUR] = toInt(input);
  getParsingFlags(config).bigHour = true;
});
addParseToken("hmm", function(input, array2, config) {
  var pos = input.length - 2;
  array2[HOUR] = toInt(input.substr(0, pos));
  array2[MINUTE] = toInt(input.substr(pos));
  getParsingFlags(config).bigHour = true;
});
addParseToken("hmmss", function(input, array2, config) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array2[HOUR] = toInt(input.substr(0, pos1));
  array2[MINUTE] = toInt(input.substr(pos1, 2));
  array2[SECOND] = toInt(input.substr(pos2));
  getParsingFlags(config).bigHour = true;
});
addParseToken("Hmm", function(input, array2, config) {
  var pos = input.length - 2;
  array2[HOUR] = toInt(input.substr(0, pos));
  array2[MINUTE] = toInt(input.substr(pos));
});
addParseToken("Hmmss", function(input, array2, config) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array2[HOUR] = toInt(input.substr(0, pos1));
  array2[MINUTE] = toInt(input.substr(pos1, 2));
  array2[SECOND] = toInt(input.substr(pos2));
});
function localeIsPM(input) {
  return (input + "").toLowerCase().charAt(0) === "p";
}
var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", true);
function localeMeridiem(hours2, minutes2, isLower) {
  if (hours2 > 11) {
    return isLower ? "pm" : "PM";
  } else {
    return isLower ? "am" : "AM";
  }
}
var baseConfig = {
  calendar: defaultCalendar,
  longDateFormat: defaultLongDateFormat,
  invalidDate: defaultInvalidDate,
  ordinal: defaultOrdinal,
  dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
  relativeTime: defaultRelativeTime,
  months: defaultLocaleMonths,
  monthsShort: defaultLocaleMonthsShort,
  week: defaultLocaleWeek,
  weekdays: defaultLocaleWeekdays,
  weekdaysMin: defaultLocaleWeekdaysMin,
  weekdaysShort: defaultLocaleWeekdaysShort,
  meridiemParse: defaultLocaleMeridiemParse
};
var locales = {}, localeFamilies = {}, globalLocale;
function commonPrefix(arr1, arr2) {
  var i, minl = Math.min(arr1.length, arr2.length);
  for (i = 0; i < minl; i += 1) {
    if (arr1[i] !== arr2[i]) {
      return i;
    }
  }
  return minl;
}
function normalizeLocale(key) {
  return key ? key.toLowerCase().replace("_", "-") : key;
}
function chooseLocale(names) {
  var i = 0, j3, next, locale2, split2;
  while (i < names.length) {
    split2 = normalizeLocale(names[i]).split("-");
    j3 = split2.length;
    next = normalizeLocale(names[i + 1]);
    next = next ? next.split("-") : null;
    while (j3 > 0) {
      locale2 = loadLocale(split2.slice(0, j3).join("-"));
      if (locale2) {
        return locale2;
      }
      if (next && next.length >= j3 && commonPrefix(split2, next) >= j3 - 1) {
        break;
      }
      j3--;
    }
    i++;
  }
  return globalLocale;
}
function isLocaleNameSane(name2) {
  return !!(name2 && name2.match("^[^/\\\\]*$"));
}
function loadLocale(name2) {
  var oldLocale = null, aliasedRequire;
  if (locales[name2] === void 0 && typeof module !== "undefined" && module && module.exports && isLocaleNameSane(name2)) {
    try {
      oldLocale = globalLocale._abbr;
      aliasedRequire = require;
      aliasedRequire("./locale/" + name2);
      getSetGlobalLocale(oldLocale);
    } catch (e28) {
      locales[name2] = null;
    }
  }
  return locales[name2];
}
function getSetGlobalLocale(key, values) {
  var data;
  if (key) {
    if (isUndefined(values)) {
      data = getLocale(key);
    } else {
      data = defineLocale(key, values);
    }
    if (data) {
      globalLocale = data;
    } else {
      if (typeof console !== "undefined" && console.warn) {
        console.warn("Locale " + key + " not found. Did you forget to load it?");
      }
    }
  }
  return globalLocale._abbr;
}
function defineLocale(name2, config) {
  if (config !== null) {
    var locale2, parentConfig = baseConfig;
    config.abbr = name2;
    if (locales[name2] != null) {
      deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
      parentConfig = locales[name2]._config;
    } else if (config.parentLocale != null) {
      if (locales[config.parentLocale] != null) {
        parentConfig = locales[config.parentLocale]._config;
      } else {
        locale2 = loadLocale(config.parentLocale);
        if (locale2 != null) {
          parentConfig = locale2._config;
        } else {
          if (!localeFamilies[config.parentLocale]) {
            localeFamilies[config.parentLocale] = [];
          }
          localeFamilies[config.parentLocale].push({
            name: name2,
            config
          });
          return null;
        }
      }
    }
    locales[name2] = new Locale(mergeConfigs(parentConfig, config));
    if (localeFamilies[name2]) {
      localeFamilies[name2].forEach(function(x3) {
        defineLocale(x3.name, x3.config);
      });
    }
    getSetGlobalLocale(name2);
    return locales[name2];
  } else {
    delete locales[name2];
    return null;
  }
}
function updateLocale(name2, config) {
  if (config != null) {
    var locale2, tmpLocale, parentConfig = baseConfig;
    if (locales[name2] != null && locales[name2].parentLocale != null) {
      locales[name2].set(mergeConfigs(locales[name2]._config, config));
    } else {
      tmpLocale = loadLocale(name2);
      if (tmpLocale != null) {
        parentConfig = tmpLocale._config;
      }
      config = mergeConfigs(parentConfig, config);
      if (tmpLocale == null) {
        config.abbr = name2;
      }
      locale2 = new Locale(config);
      locale2.parentLocale = locales[name2];
      locales[name2] = locale2;
    }
    getSetGlobalLocale(name2);
  } else {
    if (locales[name2] != null) {
      if (locales[name2].parentLocale != null) {
        locales[name2] = locales[name2].parentLocale;
        if (name2 === getSetGlobalLocale()) {
          getSetGlobalLocale(name2);
        }
      } else if (locales[name2] != null) {
        delete locales[name2];
      }
    }
  }
  return locales[name2];
}
function getLocale(key) {
  var locale2;
  if (key && key._locale && key._locale._abbr) {
    key = key._locale._abbr;
  }
  if (!key) {
    return globalLocale;
  }
  if (!isArray(key)) {
    locale2 = loadLocale(key);
    if (locale2) {
      return locale2;
    }
    key = [key];
  }
  return chooseLocale(key);
}
function listLocales() {
  return keys(locales);
}
function checkOverflow(m3) {
  var overflow, a3 = m3._a;
  if (a3 && getParsingFlags(m3).overflow === -2) {
    overflow = a3[MONTH] < 0 || a3[MONTH] > 11 ? MONTH : a3[DATE] < 1 || a3[DATE] > daysInMonth(a3[YEAR], a3[MONTH]) ? DATE : a3[HOUR] < 0 || a3[HOUR] > 24 || a3[HOUR] === 24 && (a3[MINUTE] !== 0 || a3[SECOND] !== 0 || a3[MILLISECOND] !== 0) ? HOUR : a3[MINUTE] < 0 || a3[MINUTE] > 59 ? MINUTE : a3[SECOND] < 0 || a3[SECOND] > 59 ? SECOND : a3[MILLISECOND] < 0 || a3[MILLISECOND] > 999 ? MILLISECOND : -1;
    if (getParsingFlags(m3)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
      overflow = DATE;
    }
    if (getParsingFlags(m3)._overflowWeeks && overflow === -1) {
      overflow = WEEK;
    }
    if (getParsingFlags(m3)._overflowWeekday && overflow === -1) {
      overflow = WEEKDAY;
    }
    getParsingFlags(m3).overflow = overflow;
  }
  return m3;
}
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, false],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, false],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, false],
  ["YYYY", /\d{4}/, false]
], isoTimes = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function configFromISO(config) {
  var i, l3, string2 = config._i, match = extendedIsoRegex.exec(string2) || basicIsoRegex.exec(string2), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
  if (match) {
    getParsingFlags(config).iso = true;
    for (i = 0, l3 = isoDatesLen; i < l3; i++) {
      if (isoDates[i][1].exec(match[1])) {
        dateFormat = isoDates[i][0];
        allowTime = isoDates[i][2] !== false;
        break;
      }
    }
    if (dateFormat == null) {
      config._isValid = false;
      return;
    }
    if (match[3]) {
      for (i = 0, l3 = isoTimesLen; i < l3; i++) {
        if (isoTimes[i][1].exec(match[3])) {
          timeFormat = (match[2] || " ") + isoTimes[i][0];
          break;
        }
      }
      if (timeFormat == null) {
        config._isValid = false;
        return;
      }
    }
    if (!allowTime && timeFormat != null) {
      config._isValid = false;
      return;
    }
    if (match[4]) {
      if (tzRegex.exec(match[4])) {
        tzFormat = "Z";
      } else {
        config._isValid = false;
        return;
      }
    }
    config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
    configFromStringAndFormat(config);
  } else {
    config._isValid = false;
  }
}
function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  var result2 = [
    untruncateYear(yearStr),
    defaultLocaleMonthsShort.indexOf(monthStr),
    parseInt(dayStr, 10),
    parseInt(hourStr, 10),
    parseInt(minuteStr, 10)
  ];
  if (secondStr) {
    result2.push(parseInt(secondStr, 10));
  }
  return result2;
}
function untruncateYear(yearStr) {
  var year = parseInt(yearStr, 10);
  if (year <= 49) {
    return 2e3 + year;
  } else if (year <= 999) {
    return 1900 + year;
  }
  return year;
}
function preprocessRFC2822(s3) {
  return s3.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function checkWeekday(weekdayStr, parsedInput, config) {
  if (weekdayStr) {
    var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
    if (weekdayProvided !== weekdayActual) {
      getParsingFlags(config).weekdayMismatch = true;
      config._isValid = false;
      return false;
    }
  }
  return true;
}
function calculateOffset(obsOffset, militaryOffset, numOffset) {
  if (obsOffset) {
    return obsOffsets[obsOffset];
  } else if (militaryOffset) {
    return 0;
  } else {
    var hm2 = parseInt(numOffset, 10), m3 = hm2 % 100, h3 = (hm2 - m3) / 100;
    return h3 * 60 + m3;
  }
}
function configFromRFC2822(config) {
  var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
  if (match) {
    parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
    if (!checkWeekday(match[1], parsedArray, config)) {
      return;
    }
    config._a = parsedArray;
    config._tzm = calculateOffset(match[8], match[9], match[10]);
    config._d = createUTCDate.apply(null, config._a);
    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    getParsingFlags(config).rfc2822 = true;
  } else {
    config._isValid = false;
  }
}
function configFromString(config) {
  var matched = aspNetJsonRegex.exec(config._i);
  if (matched !== null) {
    config._d = new Date(+matched[1]);
    return;
  }
  configFromISO(config);
  if (config._isValid === false) {
    delete config._isValid;
  } else {
    return;
  }
  configFromRFC2822(config);
  if (config._isValid === false) {
    delete config._isValid;
  } else {
    return;
  }
  if (config._strict) {
    config._isValid = false;
  } else {
    hooks.createFromInputFallback(config);
  }
}
hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
  config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
});
function defaults(a3, b3, c3) {
  if (a3 != null) {
    return a3;
  }
  if (b3 != null) {
    return b3;
  }
  return c3;
}
function currentDateArray(config) {
  var nowValue = new Date(hooks.now());
  if (config._useUTC) {
    return [
      nowValue.getUTCFullYear(),
      nowValue.getUTCMonth(),
      nowValue.getUTCDate()
    ];
  }
  return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}
function configFromArray(config) {
  var i, date2, input = [], currentDate, expectedWeekday, yearToUse;
  if (config._d) {
    return;
  }
  currentDate = currentDateArray(config);
  if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
    dayOfYearFromWeekInfo(config);
  }
  if (config._dayOfYear != null) {
    yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
    if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
      getParsingFlags(config)._overflowDayOfYear = true;
    }
    date2 = createUTCDate(yearToUse, 0, config._dayOfYear);
    config._a[MONTH] = date2.getUTCMonth();
    config._a[DATE] = date2.getUTCDate();
  }
  for (i = 0; i < 3 && config._a[i] == null; ++i) {
    config._a[i] = input[i] = currentDate[i];
  }
  for (; i < 7; i++) {
    config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
  }
  if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
    config._nextDay = true;
    config._a[HOUR] = 0;
  }
  config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
  expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
  if (config._tzm != null) {
    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
  }
  if (config._nextDay) {
    config._a[HOUR] = 24;
  }
  if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) {
    getParsingFlags(config).weekdayMismatch = true;
  }
}
function dayOfYearFromWeekInfo(config) {
  var w3, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
  w3 = config._w;
  if (w3.GG != null || w3.W != null || w3.E != null) {
    dow = 1;
    doy = 4;
    weekYear = defaults(w3.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
    week = defaults(w3.W, 1);
    weekday = defaults(w3.E, 1);
    if (weekday < 1 || weekday > 7) {
      weekdayOverflow = true;
    }
  } else {
    dow = config._locale._week.dow;
    doy = config._locale._week.doy;
    curWeek = weekOfYear(createLocal(), dow, doy);
    weekYear = defaults(w3.gg, config._a[YEAR], curWeek.year);
    week = defaults(w3.w, curWeek.week);
    if (w3.d != null) {
      weekday = w3.d;
      if (weekday < 0 || weekday > 6) {
        weekdayOverflow = true;
      }
    } else if (w3.e != null) {
      weekday = w3.e + dow;
      if (w3.e < 0 || w3.e > 6) {
        weekdayOverflow = true;
      }
    } else {
      weekday = dow;
    }
  }
  if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
    getParsingFlags(config)._overflowWeeks = true;
  } else if (weekdayOverflow != null) {
    getParsingFlags(config)._overflowWeekday = true;
  } else {
    temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
    config._a[YEAR] = temp.year;
    config._dayOfYear = temp.dayOfYear;
  }
}
hooks.ISO_8601 = function() {
};
hooks.RFC_2822 = function() {
};
function configFromStringAndFormat(config) {
  if (config._f === hooks.ISO_8601) {
    configFromISO(config);
    return;
  }
  if (config._f === hooks.RFC_2822) {
    configFromRFC2822(config);
    return;
  }
  config._a = [];
  getParsingFlags(config).empty = true;
  var string2 = "" + config._i, i, parsedInput, tokens2, token2, skipped, stringLength2 = string2.length, totalParsedInputLength = 0, era, tokenLen;
  tokens2 = expandFormat(config._f, config._locale).match(formattingTokens) || [];
  tokenLen = tokens2.length;
  for (i = 0; i < tokenLen; i++) {
    token2 = tokens2[i];
    parsedInput = (string2.match(getParseRegexForToken(token2, config)) || [])[0];
    if (parsedInput) {
      skipped = string2.substr(0, string2.indexOf(parsedInput));
      if (skipped.length > 0) {
        getParsingFlags(config).unusedInput.push(skipped);
      }
      string2 = string2.slice(string2.indexOf(parsedInput) + parsedInput.length);
      totalParsedInputLength += parsedInput.length;
    }
    if (formatTokenFunctions[token2]) {
      if (parsedInput) {
        getParsingFlags(config).empty = false;
      } else {
        getParsingFlags(config).unusedTokens.push(token2);
      }
      addTimeToArrayFromToken(token2, parsedInput, config);
    } else if (config._strict && !parsedInput) {
      getParsingFlags(config).unusedTokens.push(token2);
    }
  }
  getParsingFlags(config).charsLeftOver = stringLength2 - totalParsedInputLength;
  if (string2.length > 0) {
    getParsingFlags(config).unusedInput.push(string2);
  }
  if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
    getParsingFlags(config).bigHour = void 0;
  }
  getParsingFlags(config).parsedDateParts = config._a.slice(0);
  getParsingFlags(config).meridiem = config._meridiem;
  config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
  era = getParsingFlags(config).era;
  if (era !== null) {
    config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
  }
  configFromArray(config);
  checkOverflow(config);
}
function meridiemFixWrap(locale2, hour, meridiem2) {
  var isPm;
  if (meridiem2 == null) {
    return hour;
  }
  if (locale2.meridiemHour != null) {
    return locale2.meridiemHour(hour, meridiem2);
  } else if (locale2.isPM != null) {
    isPm = locale2.isPM(meridiem2);
    if (isPm && hour < 12) {
      hour += 12;
    }
    if (!isPm && hour === 12) {
      hour = 0;
    }
    return hour;
  } else {
    return hour;
  }
}
function configFromStringAndArray(config) {
  var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
  if (configfLen === 0) {
    getParsingFlags(config).invalidFormat = true;
    config._d = new Date(NaN);
    return;
  }
  for (i = 0; i < configfLen; i++) {
    currentScore = 0;
    validFormatFound = false;
    tempConfig = copyConfig({}, config);
    if (config._useUTC != null) {
      tempConfig._useUTC = config._useUTC;
    }
    tempConfig._f = config._f[i];
    configFromStringAndFormat(tempConfig);
    if (isValid(tempConfig)) {
      validFormatFound = true;
    }
    currentScore += getParsingFlags(tempConfig).charsLeftOver;
    currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
    getParsingFlags(tempConfig).score = currentScore;
    if (!bestFormatIsValid) {
      if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
        if (validFormatFound) {
          bestFormatIsValid = true;
        }
      }
    } else {
      if (currentScore < scoreToBeat) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
      }
    }
  }
  extend(config, bestMoment || tempConfig);
}
function configFromObject(config) {
  if (config._d) {
    return;
  }
  var i = normalizeObjectUnits(config._i), dayOrDate = i.day === void 0 ? i.date : i.day;
  config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function(obj) {
    return obj && parseInt(obj, 10);
  });
  configFromArray(config);
}
function createFromConfig(config) {
  var res = new Moment(checkOverflow(prepareConfig(config)));
  if (res._nextDay) {
    res.add(1, "d");
    res._nextDay = void 0;
  }
  return res;
}
function prepareConfig(config) {
  var input = config._i, format2 = config._f;
  config._locale = config._locale || getLocale(config._l);
  if (input === null || format2 === void 0 && input === "") {
    return createInvalid({ nullInput: true });
  }
  if (typeof input === "string") {
    config._i = input = config._locale.preparse(input);
  }
  if (isMoment(input)) {
    return new Moment(checkOverflow(input));
  } else if (isDate(input)) {
    config._d = input;
  } else if (isArray(format2)) {
    configFromStringAndArray(config);
  } else if (format2) {
    configFromStringAndFormat(config);
  } else {
    configFromInput(config);
  }
  if (!isValid(config)) {
    config._d = null;
  }
  return config;
}
function configFromInput(config) {
  var input = config._i;
  if (isUndefined(input)) {
    config._d = new Date(hooks.now());
  } else if (isDate(input)) {
    config._d = new Date(input.valueOf());
  } else if (typeof input === "string") {
    configFromString(config);
  } else if (isArray(input)) {
    config._a = map(input.slice(0), function(obj) {
      return parseInt(obj, 10);
    });
    configFromArray(config);
  } else if (isObject(input)) {
    configFromObject(config);
  } else if (isNumber(input)) {
    config._d = new Date(input);
  } else {
    hooks.createFromInputFallback(config);
  }
}
function createLocalOrUTC(input, format2, locale2, strict, isUTC) {
  var c3 = {};
  if (format2 === true || format2 === false) {
    strict = format2;
    format2 = void 0;
  }
  if (locale2 === true || locale2 === false) {
    strict = locale2;
    locale2 = void 0;
  }
  if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
    input = void 0;
  }
  c3._isAMomentObject = true;
  c3._useUTC = c3._isUTC = isUTC;
  c3._l = locale2;
  c3._i = input;
  c3._f = format2;
  c3._strict = strict;
  return createFromConfig(c3);
}
function createLocal(input, format2, locale2, strict) {
  return createLocalOrUTC(input, format2, locale2, strict, false);
}
var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
  var other = createLocal.apply(null, arguments);
  if (this.isValid() && other.isValid()) {
    return other < this ? this : other;
  } else {
    return createInvalid();
  }
}), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
  var other = createLocal.apply(null, arguments);
  if (this.isValid() && other.isValid()) {
    return other > this ? this : other;
  } else {
    return createInvalid();
  }
});
function pickBy(fn2, moments) {
  var res, i;
  if (moments.length === 1 && isArray(moments[0])) {
    moments = moments[0];
  }
  if (!moments.length) {
    return createLocal();
  }
  res = moments[0];
  for (i = 1; i < moments.length; ++i) {
    if (!moments[i].isValid() || moments[i][fn2](res)) {
      res = moments[i];
    }
  }
  return res;
}
function min() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isBefore", args);
}
function max() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isAfter", args);
}
var now = function() {
  return Date.now ? Date.now() : +new Date();
};
var ordering = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function isDurationValid(m3) {
  var key, unitHasDecimal = false, i, orderLen = ordering.length;
  for (key in m3) {
    if (hasOwnProp(m3, key) && !(indexOf.call(ordering, key) !== -1 && (m3[key] == null || !isNaN(m3[key])))) {
      return false;
    }
  }
  for (i = 0; i < orderLen; ++i) {
    if (m3[ordering[i]]) {
      if (unitHasDecimal) {
        return false;
      }
      if (parseFloat(m3[ordering[i]]) !== toInt(m3[ordering[i]])) {
        unitHasDecimal = true;
      }
    }
  }
  return true;
}
function isValid$1() {
  return this._isValid;
}
function createInvalid$1() {
  return createDuration(NaN);
}
function Duration(duration) {
  var normalizedInput = normalizeObjectUnits(duration), years2 = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months2 = normalizedInput.month || 0, weeks2 = normalizedInput.week || normalizedInput.isoWeek || 0, days2 = normalizedInput.day || 0, hours2 = normalizedInput.hour || 0, minutes2 = normalizedInput.minute || 0, seconds2 = normalizedInput.second || 0, milliseconds2 = normalizedInput.millisecond || 0;
  this._isValid = isDurationValid(normalizedInput);
  this._milliseconds = +milliseconds2 + seconds2 * 1e3 + minutes2 * 6e4 + hours2 * 1e3 * 60 * 60;
  this._days = +days2 + weeks2 * 7;
  this._months = +months2 + quarters * 3 + years2 * 12;
  this._data = {};
  this._locale = getLocale();
  this._bubble();
}
function isDuration(obj) {
  return obj instanceof Duration;
}
function absRound(number2) {
  if (number2 < 0) {
    return Math.round(-1 * number2) * -1;
  } else {
    return Math.round(number2);
  }
}
function compareArrays(array1, array2, dontConvert) {
  var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
  for (i = 0; i < len; i++) {
    if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
      diffs++;
    }
  }
  return diffs + lengthDiff;
}
function offset(token2, separator) {
  addFormatToken(token2, 0, 0, function() {
    var offset2 = this.utcOffset(), sign2 = "+";
    if (offset2 < 0) {
      offset2 = -offset2;
      sign2 = "-";
    }
    return sign2 + zeroFill(~~(offset2 / 60), 2) + separator + zeroFill(~~offset2 % 60, 2);
  });
}
offset("Z", ":");
offset("ZZ", "");
addRegexToken("Z", matchShortOffset);
addRegexToken("ZZ", matchShortOffset);
addParseToken(["Z", "ZZ"], function(input, array2, config) {
  config._useUTC = true;
  config._tzm = offsetFromString(matchShortOffset, input);
});
var chunkOffset = /([\+\-]|\d\d)/gi;
function offsetFromString(matcher, string2) {
  var matches = (string2 || "").match(matcher), chunk, parts, minutes2;
  if (matches === null) {
    return null;
  }
  chunk = matches[matches.length - 1] || [];
  parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
  minutes2 = +(parts[1] * 60) + toInt(parts[2]);
  return minutes2 === 0 ? 0 : parts[0] === "+" ? minutes2 : -minutes2;
}
function cloneWithOffset(input, model) {
  var res, diff2;
  if (model._isUTC) {
    res = model.clone();
    diff2 = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
    res._d.setTime(res._d.valueOf() + diff2);
    hooks.updateOffset(res, false);
    return res;
  } else {
    return createLocal(input).local();
  }
}
function getDateOffset(m3) {
  return -Math.round(m3._d.getTimezoneOffset());
}
hooks.updateOffset = function() {
};
function getSetOffset(input, keepLocalTime, keepMinutes) {
  var offset2 = this._offset || 0, localAdjust;
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    if (typeof input === "string") {
      input = offsetFromString(matchShortOffset, input);
      if (input === null) {
        return this;
      }
    } else if (Math.abs(input) < 16 && !keepMinutes) {
      input = input * 60;
    }
    if (!this._isUTC && keepLocalTime) {
      localAdjust = getDateOffset(this);
    }
    this._offset = input;
    this._isUTC = true;
    if (localAdjust != null) {
      this.add(localAdjust, "m");
    }
    if (offset2 !== input) {
      if (!keepLocalTime || this._changeInProgress) {
        addSubtract(this, createDuration(input - offset2, "m"), 1, false);
      } else if (!this._changeInProgress) {
        this._changeInProgress = true;
        hooks.updateOffset(this, true);
        this._changeInProgress = null;
      }
    }
    return this;
  } else {
    return this._isUTC ? offset2 : getDateOffset(this);
  }
}
function getSetZone(input, keepLocalTime) {
  if (input != null) {
    if (typeof input !== "string") {
      input = -input;
    }
    this.utcOffset(input, keepLocalTime);
    return this;
  } else {
    return -this.utcOffset();
  }
}
function setOffsetToUTC(keepLocalTime) {
  return this.utcOffset(0, keepLocalTime);
}
function setOffsetToLocal(keepLocalTime) {
  if (this._isUTC) {
    this.utcOffset(0, keepLocalTime);
    this._isUTC = false;
    if (keepLocalTime) {
      this.subtract(getDateOffset(this), "m");
    }
  }
  return this;
}
function setOffsetToParsedOffset() {
  if (this._tzm != null) {
    this.utcOffset(this._tzm, false, true);
  } else if (typeof this._i === "string") {
    var tZone = offsetFromString(matchOffset, this._i);
    if (tZone != null) {
      this.utcOffset(tZone);
    } else {
      this.utcOffset(0, true);
    }
  }
  return this;
}
function hasAlignedHourOffset(input) {
  if (!this.isValid()) {
    return false;
  }
  input = input ? createLocal(input).utcOffset() : 0;
  return (this.utcOffset() - input) % 60 === 0;
}
function isDaylightSavingTime() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function isDaylightSavingTimeShifted() {
  if (!isUndefined(this._isDSTShifted)) {
    return this._isDSTShifted;
  }
  var c3 = {}, other;
  copyConfig(c3, this);
  c3 = prepareConfig(c3);
  if (c3._a) {
    other = c3._isUTC ? createUTC(c3._a) : createLocal(c3._a);
    this._isDSTShifted = this.isValid() && compareArrays(c3._a, other.toArray()) > 0;
  } else {
    this._isDSTShifted = false;
  }
  return this._isDSTShifted;
}
function isLocal() {
  return this.isValid() ? !this._isUTC : false;
}
function isUtcOffset() {
  return this.isValid() ? this._isUTC : false;
}
function isUtc() {
  return this.isValid() ? this._isUTC && this._offset === 0 : false;
}
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function createDuration(input, key) {
  var duration = input, match = null, sign2, ret, diffRes;
  if (isDuration(input)) {
    duration = {
      ms: input._milliseconds,
      d: input._days,
      M: input._months
    };
  } else if (isNumber(input) || !isNaN(+input)) {
    duration = {};
    if (key) {
      duration[key] = +input;
    } else {
      duration.milliseconds = +input;
    }
  } else if (match = aspNetRegex.exec(input)) {
    sign2 = match[1] === "-" ? -1 : 1;
    duration = {
      y: 0,
      d: toInt(match[DATE]) * sign2,
      h: toInt(match[HOUR]) * sign2,
      m: toInt(match[MINUTE]) * sign2,
      s: toInt(match[SECOND]) * sign2,
      ms: toInt(absRound(match[MILLISECOND] * 1e3)) * sign2
    };
  } else if (match = isoRegex.exec(input)) {
    sign2 = match[1] === "-" ? -1 : 1;
    duration = {
      y: parseIso(match[2], sign2),
      M: parseIso(match[3], sign2),
      w: parseIso(match[4], sign2),
      d: parseIso(match[5], sign2),
      h: parseIso(match[6], sign2),
      m: parseIso(match[7], sign2),
      s: parseIso(match[8], sign2)
    };
  } else if (duration == null) {
    duration = {};
  } else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
    diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
    duration = {};
    duration.ms = diffRes.milliseconds;
    duration.M = diffRes.months;
  }
  ret = new Duration(duration);
  if (isDuration(input) && hasOwnProp(input, "_locale")) {
    ret._locale = input._locale;
  }
  if (isDuration(input) && hasOwnProp(input, "_isValid")) {
    ret._isValid = input._isValid;
  }
  return ret;
}
createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;
function parseIso(inp, sign2) {
  var res = inp && parseFloat(inp.replace(",", "."));
  return (isNaN(res) ? 0 : res) * sign2;
}
function positiveMomentsDifference(base, other) {
  var res = {};
  res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
  if (base.clone().add(res.months, "M").isAfter(other)) {
    --res.months;
  }
  res.milliseconds = +other - +base.clone().add(res.months, "M");
  return res;
}
function momentsDifference(base, other) {
  var res;
  if (!(base.isValid() && other.isValid())) {
    return { milliseconds: 0, months: 0 };
  }
  other = cloneWithOffset(other, base);
  if (base.isBefore(other)) {
    res = positiveMomentsDifference(base, other);
  } else {
    res = positiveMomentsDifference(other, base);
    res.milliseconds = -res.milliseconds;
    res.months = -res.months;
  }
  return res;
}
function createAdder(direction, name2) {
  return function(val, period) {
    var dur, tmp;
    if (period !== null && !isNaN(+period)) {
      deprecateSimple(name2, "moment()." + name2 + "(period, number) is deprecated. Please use moment()." + name2 + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
      tmp = val;
      val = period;
      period = tmp;
    }
    dur = createDuration(val, period);
    addSubtract(this, dur, direction);
    return this;
  };
}
function addSubtract(mom, duration, isAdding, updateOffset) {
  var milliseconds2 = duration._milliseconds, days2 = absRound(duration._days), months2 = absRound(duration._months);
  if (!mom.isValid()) {
    return;
  }
  updateOffset = updateOffset == null ? true : updateOffset;
  if (months2) {
    setMonth(mom, get(mom, "Month") + months2 * isAdding);
  }
  if (days2) {
    set$1(mom, "Date", get(mom, "Date") + days2 * isAdding);
  }
  if (milliseconds2) {
    mom._d.setTime(mom._d.valueOf() + milliseconds2 * isAdding);
  }
  if (updateOffset) {
    hooks.updateOffset(mom, days2 || months2);
  }
}
var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
function isString(input) {
  return typeof input === "string" || input instanceof String;
}
function isMomentInput(input) {
  return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === void 0;
}
function isMomentInputObject(input) {
  var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], i, property, propertyLen = properties.length;
  for (i = 0; i < propertyLen; i += 1) {
    property = properties[i];
    propertyTest = propertyTest || hasOwnProp(input, property);
  }
  return objectTest && propertyTest;
}
function isNumberOrStringArray(input) {
  var arrayTest = isArray(input), dataTypeTest = false;
  if (arrayTest) {
    dataTypeTest = input.filter(function(item) {
      return !isNumber(item) && isString(input);
    }).length === 0;
  }
  return arrayTest && dataTypeTest;
}
function isCalendarSpec(input) {
  var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], i, property;
  for (i = 0; i < properties.length; i += 1) {
    property = properties[i];
    propertyTest = propertyTest || hasOwnProp(input, property);
  }
  return objectTest && propertyTest;
}
function getCalendarFormat(myMoment, now2) {
  var diff2 = myMoment.diff(now2, "days", true);
  return diff2 < -6 ? "sameElse" : diff2 < -1 ? "lastWeek" : diff2 < 0 ? "lastDay" : diff2 < 1 ? "sameDay" : diff2 < 2 ? "nextDay" : diff2 < 7 ? "nextWeek" : "sameElse";
}
function calendar$1(time, formats) {
  if (arguments.length === 1) {
    if (!arguments[0]) {
      time = void 0;
      formats = void 0;
    } else if (isMomentInput(arguments[0])) {
      time = arguments[0];
      formats = void 0;
    } else if (isCalendarSpec(arguments[0])) {
      formats = arguments[0];
      time = void 0;
    }
  }
  var now2 = time || createLocal(), sod = cloneWithOffset(now2, this).startOf("day"), format2 = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format2]) ? formats[format2].call(this, now2) : formats[format2]);
  return this.format(output || this.localeData().calendar(format2, this, createLocal(now2)));
}
function clone() {
  return new Moment(this);
}
function isAfter(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() > localInput.valueOf();
  } else {
    return localInput.valueOf() < this.clone().startOf(units).valueOf();
  }
}
function isBefore(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() < localInput.valueOf();
  } else {
    return this.clone().endOf(units).valueOf() < localInput.valueOf();
  }
}
function isBetween(from2, to2, units, inclusivity) {
  var localFrom = isMoment(from2) ? from2 : createLocal(from2), localTo = isMoment(to2) ? to2 : createLocal(to2);
  if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
    return false;
  }
  inclusivity = inclusivity || "()";
  return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
}
function isSame(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input), inputMs;
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() === localInput.valueOf();
  } else {
    inputMs = localInput.valueOf();
    return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
  }
}
function isSameOrAfter(input, units) {
  return this.isSame(input, units) || this.isAfter(input, units);
}
function isSameOrBefore(input, units) {
  return this.isSame(input, units) || this.isBefore(input, units);
}
function diff(input, units, asFloat) {
  var that, zoneDelta, output;
  if (!this.isValid()) {
    return NaN;
  }
  that = cloneWithOffset(input, this);
  if (!that.isValid()) {
    return NaN;
  }
  zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
  units = normalizeUnits(units);
  switch (units) {
    case "year":
      output = monthDiff(this, that) / 12;
      break;
    case "month":
      output = monthDiff(this, that);
      break;
    case "quarter":
      output = monthDiff(this, that) / 3;
      break;
    case "second":
      output = (this - that) / 1e3;
      break;
    case "minute":
      output = (this - that) / 6e4;
      break;
    case "hour":
      output = (this - that) / 36e5;
      break;
    case "day":
      output = (this - that - zoneDelta) / 864e5;
      break;
    case "week":
      output = (this - that - zoneDelta) / 6048e5;
      break;
    default:
      output = this - that;
  }
  return asFloat ? output : absFloor(output);
}
function monthDiff(a3, b3) {
  if (a3.date() < b3.date()) {
    return -monthDiff(b3, a3);
  }
  var wholeMonthDiff = (b3.year() - a3.year()) * 12 + (b3.month() - a3.month()), anchor = a3.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
  if (b3 - anchor < 0) {
    anchor2 = a3.clone().add(wholeMonthDiff - 1, "months");
    adjust = (b3 - anchor) / (anchor - anchor2);
  } else {
    anchor2 = a3.clone().add(wholeMonthDiff + 1, "months");
    adjust = (b3 - anchor) / (anchor2 - anchor);
  }
  return -(wholeMonthDiff + adjust) || 0;
}
hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function toString2() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function toISOString(keepOffset) {
  if (!this.isValid()) {
    return null;
  }
  var utc = keepOffset !== true, m3 = utc ? this.clone().utc() : this;
  if (m3.year() < 0 || m3.year() > 9999) {
    return formatMoment(m3, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
  }
  if (isFunction(Date.prototype.toISOString)) {
    if (utc) {
      return this.toDate().toISOString();
    } else {
      return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(m3, "Z"));
    }
  }
  return formatMoment(m3, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
}
function inspect() {
  if (!this.isValid()) {
    return "moment.invalid(/* " + this._i + " */)";
  }
  var func = "moment", zone = "", prefix, year, datetime, suffix;
  if (!this.isLocal()) {
    func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
    zone = "Z";
  }
  prefix = "[" + func + '("]';
  year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
  datetime = "-MM-DD[T]HH:mm:ss.SSS";
  suffix = zone + '[")]';
  return this.format(prefix + year + datetime + suffix);
}
function format(inputString) {
  if (!inputString) {
    inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
  }
  var output = formatMoment(this, inputString);
  return this.localeData().postformat(output);
}
function from(time, withoutSuffix) {
  if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
    return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function fromNow(withoutSuffix) {
  return this.from(createLocal(), withoutSuffix);
}
function to(time, withoutSuffix) {
  if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
    return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function toNow(withoutSuffix) {
  return this.to(createLocal(), withoutSuffix);
}
function locale(key) {
  var newLocaleData;
  if (key === void 0) {
    return this._locale._abbr;
  } else {
    newLocaleData = getLocale(key);
    if (newLocaleData != null) {
      this._locale = newLocaleData;
    }
    return this;
  }
}
var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
  if (key === void 0) {
    return this.localeData();
  } else {
    return this.locale(key);
  }
});
function localeData() {
  return this._locale;
}
var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
function mod$1(dividend, divisor) {
  return (dividend % divisor + divisor) % divisor;
}
function localStartOfDate(y3, m3, d3) {
  if (y3 < 100 && y3 >= 0) {
    return new Date(y3 + 400, m3, d3) - MS_PER_400_YEARS;
  } else {
    return new Date(y3, m3, d3).valueOf();
  }
}
function utcStartOfDate(y3, m3, d3) {
  if (y3 < 100 && y3 >= 0) {
    return Date.UTC(y3 + 400, m3, d3) - MS_PER_400_YEARS;
  } else {
    return Date.UTC(y3, m3, d3);
  }
}
function startOf(units) {
  var time, startOfDate;
  units = normalizeUnits(units);
  if (units === void 0 || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time = startOfDate(this.year(), 0, 1);
      break;
    case "quarter":
      time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
      break;
    case "month":
      time = startOfDate(this.year(), this.month(), 1);
      break;
    case "week":
      time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
      break;
    case "isoWeek":
      time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
      break;
    case "day":
    case "date":
      time = startOfDate(this.year(), this.month(), this.date());
      break;
    case "hour":
      time = this._d.valueOf();
      time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
      break;
    case "minute":
      time = this._d.valueOf();
      time -= mod$1(time, MS_PER_MINUTE);
      break;
    case "second":
      time = this._d.valueOf();
      time -= mod$1(time, MS_PER_SECOND);
      break;
  }
  this._d.setTime(time);
  hooks.updateOffset(this, true);
  return this;
}
function endOf(units) {
  var time, startOfDate;
  units = normalizeUnits(units);
  if (units === void 0 || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time = startOfDate(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
      break;
    case "month":
      time = startOfDate(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
      break;
    case "isoWeek":
      time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
      break;
    case "day":
    case "date":
      time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      time = this._d.valueOf();
      time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
      break;
    case "minute":
      time = this._d.valueOf();
      time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
      break;
    case "second":
      time = this._d.valueOf();
      time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
      break;
  }
  this._d.setTime(time);
  hooks.updateOffset(this, true);
  return this;
}
function valueOf() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function unix() {
  return Math.floor(this.valueOf() / 1e3);
}
function toDate() {
  return new Date(this.valueOf());
}
function toArray() {
  var m3 = this;
  return [
    m3.year(),
    m3.month(),
    m3.date(),
    m3.hour(),
    m3.minute(),
    m3.second(),
    m3.millisecond()
  ];
}
function toObject() {
  var m3 = this;
  return {
    years: m3.year(),
    months: m3.month(),
    date: m3.date(),
    hours: m3.hours(),
    minutes: m3.minutes(),
    seconds: m3.seconds(),
    milliseconds: m3.milliseconds()
  };
}
function toJSON2() {
  return this.isValid() ? this.toISOString() : null;
}
function isValid$2() {
  return isValid(this);
}
function parsingFlags() {
  return extend({}, getParsingFlags(this));
}
function invalidAt() {
  return getParsingFlags(this).overflow;
}
function creationData() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
addFormatToken("N", 0, 0, "eraAbbr");
addFormatToken("NN", 0, 0, "eraAbbr");
addFormatToken("NNN", 0, 0, "eraAbbr");
addFormatToken("NNNN", 0, 0, "eraName");
addFormatToken("NNNNN", 0, 0, "eraNarrow");
addFormatToken("y", ["y", 1], "yo", "eraYear");
addFormatToken("y", ["yy", 2], 0, "eraYear");
addFormatToken("y", ["yyy", 3], 0, "eraYear");
addFormatToken("y", ["yyyy", 4], 0, "eraYear");
addRegexToken("N", matchEraAbbr);
addRegexToken("NN", matchEraAbbr);
addRegexToken("NNN", matchEraAbbr);
addRegexToken("NNNN", matchEraName);
addRegexToken("NNNNN", matchEraNarrow);
addParseToken(["N", "NN", "NNN", "NNNN", "NNNNN"], function(input, array2, config, token2) {
  var era = config._locale.erasParse(input, token2, config._strict);
  if (era) {
    getParsingFlags(config).era = era;
  } else {
    getParsingFlags(config).invalidEra = input;
  }
});
addRegexToken("y", matchUnsigned);
addRegexToken("yy", matchUnsigned);
addRegexToken("yyy", matchUnsigned);
addRegexToken("yyyy", matchUnsigned);
addRegexToken("yo", matchEraYearOrdinal);
addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
addParseToken(["yo"], function(input, array2, config, token2) {
  var match;
  if (config._locale._eraYearOrdinalRegex) {
    match = input.match(config._locale._eraYearOrdinalRegex);
  }
  if (config._locale.eraYearOrdinalParse) {
    array2[YEAR] = config._locale.eraYearOrdinalParse(input, match);
  } else {
    array2[YEAR] = parseInt(input, 10);
  }
});
function localeEras(m3, format2) {
  var i, l3, date2, eras = this._eras || getLocale("en")._eras;
  for (i = 0, l3 = eras.length; i < l3; ++i) {
    switch (typeof eras[i].since) {
      case "string":
        date2 = hooks(eras[i].since).startOf("day");
        eras[i].since = date2.valueOf();
        break;
    }
    switch (typeof eras[i].until) {
      case "undefined":
        eras[i].until = Infinity;
        break;
      case "string":
        date2 = hooks(eras[i].until).startOf("day").valueOf();
        eras[i].until = date2.valueOf();
        break;
    }
  }
  return eras;
}
function localeErasParse(eraName, format2, strict) {
  var i, l3, eras = this.eras(), name2, abbr, narrow;
  eraName = eraName.toUpperCase();
  for (i = 0, l3 = eras.length; i < l3; ++i) {
    name2 = eras[i].name.toUpperCase();
    abbr = eras[i].abbr.toUpperCase();
    narrow = eras[i].narrow.toUpperCase();
    if (strict) {
      switch (format2) {
        case "N":
        case "NN":
        case "NNN":
          if (abbr === eraName) {
            return eras[i];
          }
          break;
        case "NNNN":
          if (name2 === eraName) {
            return eras[i];
          }
          break;
        case "NNNNN":
          if (narrow === eraName) {
            return eras[i];
          }
          break;
      }
    } else if ([name2, abbr, narrow].indexOf(eraName) >= 0) {
      return eras[i];
    }
  }
}
function localeErasConvertYear(era, year) {
  var dir = era.since <= era.until ? 1 : -1;
  if (year === void 0) {
    return hooks(era.since).year();
  } else {
    return hooks(era.since).year() + (year - era.offset) * dir;
  }
}
function getEraName() {
  var i, l3, val, eras = this.localeData().eras();
  for (i = 0, l3 = eras.length; i < l3; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].name;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].name;
    }
  }
  return "";
}
function getEraNarrow() {
  var i, l3, val, eras = this.localeData().eras();
  for (i = 0, l3 = eras.length; i < l3; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].narrow;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].narrow;
    }
  }
  return "";
}
function getEraAbbr() {
  var i, l3, val, eras = this.localeData().eras();
  for (i = 0, l3 = eras.length; i < l3; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].abbr;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].abbr;
    }
  }
  return "";
}
function getEraYear() {
  var i, l3, dir, val, eras = this.localeData().eras();
  for (i = 0, l3 = eras.length; i < l3; ++i) {
    dir = eras[i].since <= eras[i].until ? 1 : -1;
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
      return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
    }
  }
  return this.year();
}
function erasNameRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNameRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNameRegex : this._erasRegex;
}
function erasAbbrRegex(isStrict) {
  if (!hasOwnProp(this, "_erasAbbrRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasAbbrRegex : this._erasRegex;
}
function erasNarrowRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNarrowRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNarrowRegex : this._erasRegex;
}
function matchEraAbbr(isStrict, locale2) {
  return locale2.erasAbbrRegex(isStrict);
}
function matchEraName(isStrict, locale2) {
  return locale2.erasNameRegex(isStrict);
}
function matchEraNarrow(isStrict, locale2) {
  return locale2.erasNarrowRegex(isStrict);
}
function matchEraYearOrdinal(isStrict, locale2) {
  return locale2._eraYearOrdinalRegex || matchUnsigned;
}
function computeErasParse() {
  var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l3, erasName, erasAbbr, erasNarrow, eras = this.eras();
  for (i = 0, l3 = eras.length; i < l3; ++i) {
    erasName = regexEscape(eras[i].name);
    erasAbbr = regexEscape(eras[i].abbr);
    erasNarrow = regexEscape(eras[i].narrow);
    namePieces.push(erasName);
    abbrPieces.push(erasAbbr);
    narrowPieces.push(erasNarrow);
    mixedPieces.push(erasName);
    mixedPieces.push(erasAbbr);
    mixedPieces.push(erasNarrow);
  }
  this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
  this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
  this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
}
addFormatToken(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
addFormatToken(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function addWeekYearFormatToken(token2, getter) {
  addFormatToken(0, [token2, token2.length], 0, getter);
}
addWeekYearFormatToken("gggg", "weekYear");
addWeekYearFormatToken("ggggg", "weekYear");
addWeekYearFormatToken("GGGG", "isoWeekYear");
addWeekYearFormatToken("GGGGG", "isoWeekYear");
addRegexToken("G", matchSigned);
addRegexToken("g", matchSigned);
addRegexToken("GG", match1to2, match2);
addRegexToken("gg", match1to2, match2);
addRegexToken("GGGG", match1to4, match4);
addRegexToken("gggg", match1to4, match4);
addRegexToken("GGGGG", match1to6, match6);
addRegexToken("ggggg", match1to6, match6);
addWeekParseToken(["gggg", "ggggg", "GGGG", "GGGGG"], function(input, week, config, token2) {
  week[token2.substr(0, 2)] = toInt(input);
});
addWeekParseToken(["gg", "GG"], function(input, week, config, token2) {
  week[token2] = hooks.parseTwoDigitYear(input);
});
function getSetWeekYear(input) {
  return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
}
function getSetISOWeekYear(input) {
  return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
}
function getISOWeeksInYear() {
  return weeksInYear(this.year(), 1, 4);
}
function getISOWeeksInISOWeekYear() {
  return weeksInYear(this.isoWeekYear(), 1, 4);
}
function getWeeksInYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}
function getWeeksInWeekYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
}
function getSetWeekYearHelper(input, week, weekday, dow, doy) {
  var weeksTarget;
  if (input == null) {
    return weekOfYear(this, dow, doy).year;
  } else {
    weeksTarget = weeksInYear(input, dow, doy);
    if (week > weeksTarget) {
      week = weeksTarget;
    }
    return setWeekAll.call(this, input, week, weekday, dow, doy);
  }
}
function setWeekAll(weekYear, week, weekday, dow, doy) {
  var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date2 = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
  this.year(date2.getUTCFullYear());
  this.month(date2.getUTCMonth());
  this.date(date2.getUTCDate());
  return this;
}
addFormatToken("Q", 0, "Qo", "quarter");
addRegexToken("Q", match1);
addParseToken("Q", function(input, array2) {
  array2[MONTH] = (toInt(input) - 1) * 3;
});
function getSetQuarter(input) {
  return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}
addFormatToken("D", ["DD", 2], "Do", "date");
addRegexToken("D", match1to2, match1to2NoLeadingZero);
addRegexToken("DD", match1to2, match2);
addRegexToken("Do", function(isStrict, locale2) {
  return isStrict ? locale2._dayOfMonthOrdinalParse || locale2._ordinalParse : locale2._dayOfMonthOrdinalParseLenient;
});
addParseToken(["D", "DD"], DATE);
addParseToken("Do", function(input, array2) {
  array2[DATE] = toInt(input.match(match1to2)[0]);
});
var getSetDayOfMonth = makeGetSet("Date", true);
addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
addRegexToken("DDD", match1to3);
addRegexToken("DDDD", match3);
addParseToken(["DDD", "DDDD"], function(input, array2, config) {
  config._dayOfYear = toInt(input);
});
function getSetDayOfYear(input) {
  var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
  return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
}
addFormatToken("m", ["mm", 2], 0, "minute");
addRegexToken("m", match1to2, match1to2HasZero);
addRegexToken("mm", match1to2, match2);
addParseToken(["m", "mm"], MINUTE);
var getSetMinute = makeGetSet("Minutes", false);
addFormatToken("s", ["ss", 2], 0, "second");
addRegexToken("s", match1to2, match1to2HasZero);
addRegexToken("ss", match1to2, match2);
addParseToken(["s", "ss"], SECOND);
var getSetSecond = makeGetSet("Seconds", false);
addFormatToken("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
addFormatToken(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
addFormatToken(0, ["SSS", 3], 0, "millisecond");
addFormatToken(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
addFormatToken(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
addFormatToken(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
addFormatToken(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
addRegexToken("S", match1to3, match1);
addRegexToken("SS", match1to3, match2);
addRegexToken("SSS", match1to3, match3);
var token, getSetMillisecond;
for (token = "SSSS"; token.length <= 9; token += "S") {
  addRegexToken(token, matchUnsigned);
}
function parseMs(input, array2) {
  array2[MILLISECOND] = toInt(("0." + input) * 1e3);
}
for (token = "S"; token.length <= 9; token += "S") {
  addParseToken(token, parseMs);
}
getSetMillisecond = makeGetSet("Milliseconds", false);
addFormatToken("z", 0, 0, "zoneAbbr");
addFormatToken("zz", 0, 0, "zoneName");
function getZoneAbbr() {
  return this._isUTC ? "UTC" : "";
}
function getZoneName() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var proto = Moment.prototype;
proto.add = add;
proto.calendar = calendar$1;
proto.clone = clone;
proto.diff = diff;
proto.endOf = endOf;
proto.format = format;
proto.from = from;
proto.fromNow = fromNow;
proto.to = to;
proto.toNow = toNow;
proto.get = stringGet;
proto.invalidAt = invalidAt;
proto.isAfter = isAfter;
proto.isBefore = isBefore;
proto.isBetween = isBetween;
proto.isSame = isSame;
proto.isSameOrAfter = isSameOrAfter;
proto.isSameOrBefore = isSameOrBefore;
proto.isValid = isValid$2;
proto.lang = lang;
proto.locale = locale;
proto.localeData = localeData;
proto.max = prototypeMax;
proto.min = prototypeMin;
proto.parsingFlags = parsingFlags;
proto.set = stringSet;
proto.startOf = startOf;
proto.subtract = subtract;
proto.toArray = toArray;
proto.toObject = toObject;
proto.toDate = toDate;
proto.toISOString = toISOString;
proto.inspect = inspect;
if (typeof Symbol !== "undefined" && Symbol.for != null) {
  proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
    return "Moment<" + this.format() + ">";
  };
}
proto.toJSON = toJSON2;
proto.toString = toString2;
proto.unix = unix;
proto.valueOf = valueOf;
proto.creationData = creationData;
proto.eraName = getEraName;
proto.eraNarrow = getEraNarrow;
proto.eraAbbr = getEraAbbr;
proto.eraYear = getEraYear;
proto.year = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week = proto.weeks = getSetWeek;
proto.isoWeek = proto.isoWeeks = getSetISOWeek;
proto.weeksInYear = getWeeksInYear;
proto.weeksInWeekYear = getWeeksInWeekYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
proto.date = getSetDayOfMonth;
proto.day = proto.days = getSetDayOfWeek;
proto.weekday = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset = getSetOffset;
proto.utc = setOffsetToUTC;
proto.local = setOffsetToLocal;
proto.parseZone = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST = isDaylightSavingTime;
proto.isLocal = isLocal;
proto.isUtcOffset = isUtcOffset;
proto.isUtc = isUtc;
proto.isUTC = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
function createUnix(input) {
  return createLocal(input * 1e3);
}
function createInZone() {
  return createLocal.apply(null, arguments).parseZone();
}
function preParsePostFormat(string2) {
  return string2;
}
var proto$1 = Locale.prototype;
proto$1.calendar = calendar;
proto$1.longDateFormat = longDateFormat;
proto$1.invalidDate = invalidDate;
proto$1.ordinal = ordinal;
proto$1.preparse = preParsePostFormat;
proto$1.postformat = preParsePostFormat;
proto$1.relativeTime = relativeTime;
proto$1.pastFuture = pastFuture;
proto$1.set = set;
proto$1.eras = localeEras;
proto$1.erasParse = localeErasParse;
proto$1.erasConvertYear = localeErasConvertYear;
proto$1.erasAbbrRegex = erasAbbrRegex;
proto$1.erasNameRegex = erasNameRegex;
proto$1.erasNarrowRegex = erasNarrowRegex;
proto$1.months = localeMonths;
proto$1.monthsShort = localeMonthsShort;
proto$1.monthsParse = localeMonthsParse;
proto$1.monthsRegex = monthsRegex;
proto$1.monthsShortRegex = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;
proto$1.weekdays = localeWeekdays;
proto$1.weekdaysMin = localeWeekdaysMin;
proto$1.weekdaysShort = localeWeekdaysShort;
proto$1.weekdaysParse = localeWeekdaysParse;
proto$1.weekdaysRegex = weekdaysRegex;
proto$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1.weekdaysMinRegex = weekdaysMinRegex;
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;
function get$1(format2, index, field, setter) {
  var locale2 = getLocale(), utc = createUTC().set(setter, index);
  return locale2[field](utc, format2);
}
function listMonthsImpl(format2, index, field) {
  if (isNumber(format2)) {
    index = format2;
    format2 = void 0;
  }
  format2 = format2 || "";
  if (index != null) {
    return get$1(format2, index, field, "month");
  }
  var i, out = [];
  for (i = 0; i < 12; i++) {
    out[i] = get$1(format2, i, field, "month");
  }
  return out;
}
function listWeekdaysImpl(localeSorted, format2, index, field) {
  if (typeof localeSorted === "boolean") {
    if (isNumber(format2)) {
      index = format2;
      format2 = void 0;
    }
    format2 = format2 || "";
  } else {
    format2 = localeSorted;
    index = format2;
    localeSorted = false;
    if (isNumber(format2)) {
      index = format2;
      format2 = void 0;
    }
    format2 = format2 || "";
  }
  var locale2 = getLocale(), shift = localeSorted ? locale2._week.dow : 0, i, out = [];
  if (index != null) {
    return get$1(format2, (index + shift) % 7, field, "day");
  }
  for (i = 0; i < 7; i++) {
    out[i] = get$1(format2, (i + shift) % 7, field, "day");
  }
  return out;
}
function listMonths(format2, index) {
  return listMonthsImpl(format2, index, "months");
}
function listMonthsShort(format2, index) {
  return listMonthsImpl(format2, index, "monthsShort");
}
function listWeekdays(localeSorted, format2, index) {
  return listWeekdaysImpl(localeSorted, format2, index, "weekdays");
}
function listWeekdaysShort(localeSorted, format2, index) {
  return listWeekdaysImpl(localeSorted, format2, index, "weekdaysShort");
}
function listWeekdaysMin(localeSorted, format2, index) {
  return listWeekdaysImpl(localeSorted, format2, index, "weekdaysMin");
}
getSetGlobalLocale("en", {
  eras: [
    {
      since: "0001-01-01",
      until: Infinity,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -Infinity,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(number2) {
    var b3 = number2 % 10, output = toInt(number2 % 100 / 10) === 1 ? "th" : b3 === 1 ? "st" : b3 === 2 ? "nd" : b3 === 3 ? "rd" : "th";
    return number2 + output;
  }
});
hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
var mathAbs = Math.abs;
function abs() {
  var data = this._data;
  this._milliseconds = mathAbs(this._milliseconds);
  this._days = mathAbs(this._days);
  this._months = mathAbs(this._months);
  data.milliseconds = mathAbs(data.milliseconds);
  data.seconds = mathAbs(data.seconds);
  data.minutes = mathAbs(data.minutes);
  data.hours = mathAbs(data.hours);
  data.months = mathAbs(data.months);
  data.years = mathAbs(data.years);
  return this;
}
function addSubtract$1(duration, input, value, direction) {
  var other = createDuration(input, value);
  duration._milliseconds += direction * other._milliseconds;
  duration._days += direction * other._days;
  duration._months += direction * other._months;
  return duration._bubble();
}
function add$1(input, value) {
  return addSubtract$1(this, input, value, 1);
}
function subtract$1(input, value) {
  return addSubtract$1(this, input, value, -1);
}
function absCeil(number2) {
  if (number2 < 0) {
    return Math.floor(number2);
  } else {
    return Math.ceil(number2);
  }
}
function bubble() {
  var milliseconds2 = this._milliseconds, days2 = this._days, months2 = this._months, data = this._data, seconds2, minutes2, hours2, years2, monthsFromDays;
  if (!(milliseconds2 >= 0 && days2 >= 0 && months2 >= 0 || milliseconds2 <= 0 && days2 <= 0 && months2 <= 0)) {
    milliseconds2 += absCeil(monthsToDays(months2) + days2) * 864e5;
    days2 = 0;
    months2 = 0;
  }
  data.milliseconds = milliseconds2 % 1e3;
  seconds2 = absFloor(milliseconds2 / 1e3);
  data.seconds = seconds2 % 60;
  minutes2 = absFloor(seconds2 / 60);
  data.minutes = minutes2 % 60;
  hours2 = absFloor(minutes2 / 60);
  data.hours = hours2 % 24;
  days2 += absFloor(hours2 / 24);
  monthsFromDays = absFloor(daysToMonths(days2));
  months2 += monthsFromDays;
  days2 -= absCeil(monthsToDays(monthsFromDays));
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  data.days = days2;
  data.months = months2;
  data.years = years2;
  return this;
}
function daysToMonths(days2) {
  return days2 * 4800 / 146097;
}
function monthsToDays(months2) {
  return months2 * 146097 / 4800;
}
function as(units) {
  if (!this.isValid()) {
    return NaN;
  }
  var days2, months2, milliseconds2 = this._milliseconds;
  units = normalizeUnits(units);
  if (units === "month" || units === "quarter" || units === "year") {
    days2 = this._days + milliseconds2 / 864e5;
    months2 = this._months + daysToMonths(days2);
    switch (units) {
      case "month":
        return months2;
      case "quarter":
        return months2 / 3;
      case "year":
        return months2 / 12;
    }
  } else {
    days2 = this._days + Math.round(monthsToDays(this._months));
    switch (units) {
      case "week":
        return days2 / 7 + milliseconds2 / 6048e5;
      case "day":
        return days2 + milliseconds2 / 864e5;
      case "hour":
        return days2 * 24 + milliseconds2 / 36e5;
      case "minute":
        return days2 * 1440 + milliseconds2 / 6e4;
      case "second":
        return days2 * 86400 + milliseconds2 / 1e3;
      case "millisecond":
        return Math.floor(days2 * 864e5) + milliseconds2;
      default:
        throw new Error("Unknown unit " + units);
    }
  }
}
function makeAs(alias) {
  return function() {
    return this.as(alias);
  };
}
var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
function clone$1() {
  return createDuration(this);
}
function get$2(units) {
  units = normalizeUnits(units);
  return this.isValid() ? this[units + "s"]() : NaN;
}
function makeGetter(name2) {
  return function() {
    return this.isValid() ? this._data[name2] : NaN;
  };
}
var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
function weeks() {
  return absFloor(this.days() / 7);
}
var round = Math.round, thresholds = {
  ss: 44,
  s: 45,
  m: 45,
  h: 22,
  d: 26,
  w: null,
  M: 11
};
function substituteTimeAgo(string2, number2, withoutSuffix, isFuture, locale2) {
  return locale2.relativeTime(number2 || 1, !!withoutSuffix, string2, isFuture);
}
function relativeTime$1(posNegDuration, withoutSuffix, thresholds2, locale2) {
  var duration = createDuration(posNegDuration).abs(), seconds2 = round(duration.as("s")), minutes2 = round(duration.as("m")), hours2 = round(duration.as("h")), days2 = round(duration.as("d")), months2 = round(duration.as("M")), weeks2 = round(duration.as("w")), years2 = round(duration.as("y")), a3 = seconds2 <= thresholds2.ss && ["s", seconds2] || seconds2 < thresholds2.s && ["ss", seconds2] || minutes2 <= 1 && ["m"] || minutes2 < thresholds2.m && ["mm", minutes2] || hours2 <= 1 && ["h"] || hours2 < thresholds2.h && ["hh", hours2] || days2 <= 1 && ["d"] || days2 < thresholds2.d && ["dd", days2];
  if (thresholds2.w != null) {
    a3 = a3 || weeks2 <= 1 && ["w"] || weeks2 < thresholds2.w && ["ww", weeks2];
  }
  a3 = a3 || months2 <= 1 && ["M"] || months2 < thresholds2.M && ["MM", months2] || years2 <= 1 && ["y"] || ["yy", years2];
  a3[2] = withoutSuffix;
  a3[3] = +posNegDuration > 0;
  a3[4] = locale2;
  return substituteTimeAgo.apply(null, a3);
}
function getSetRelativeTimeRounding(roundingFunction) {
  if (roundingFunction === void 0) {
    return round;
  }
  if (typeof roundingFunction === "function") {
    round = roundingFunction;
    return true;
  }
  return false;
}
function getSetRelativeTimeThreshold(threshold, limit) {
  if (thresholds[threshold] === void 0) {
    return false;
  }
  if (limit === void 0) {
    return thresholds[threshold];
  }
  thresholds[threshold] = limit;
  if (threshold === "s") {
    thresholds.ss = limit - 1;
  }
  return true;
}
function humanize(argWithSuffix, argThresholds) {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var withSuffix = false, th = thresholds, locale2, output;
  if (typeof argWithSuffix === "object") {
    argThresholds = argWithSuffix;
    argWithSuffix = false;
  }
  if (typeof argWithSuffix === "boolean") {
    withSuffix = argWithSuffix;
  }
  if (typeof argThresholds === "object") {
    th = Object.assign({}, thresholds, argThresholds);
    if (argThresholds.s != null && argThresholds.ss == null) {
      th.ss = argThresholds.s - 1;
    }
  }
  locale2 = this.localeData();
  output = relativeTime$1(this, !withSuffix, th, locale2);
  if (withSuffix) {
    output = locale2.pastFuture(+this, output);
  }
  return locale2.postformat(output);
}
var abs$1 = Math.abs;
function sign(x3) {
  return (x3 > 0) - (x3 < 0) || +x3;
}
function toISOString$1() {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var seconds2 = abs$1(this._milliseconds) / 1e3, days2 = abs$1(this._days), months2 = abs$1(this._months), minutes2, hours2, years2, s3, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
  if (!total) {
    return "P0D";
  }
  minutes2 = absFloor(seconds2 / 60);
  hours2 = absFloor(minutes2 / 60);
  seconds2 %= 60;
  minutes2 %= 60;
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  s3 = seconds2 ? seconds2.toFixed(3).replace(/\.?0+$/, "") : "";
  totalSign = total < 0 ? "-" : "";
  ymSign = sign(this._months) !== sign(total) ? "-" : "";
  daysSign = sign(this._days) !== sign(total) ? "-" : "";
  hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
  return totalSign + "P" + (years2 ? ymSign + years2 + "Y" : "") + (months2 ? ymSign + months2 + "M" : "") + (days2 ? daysSign + days2 + "D" : "") + (hours2 || minutes2 || seconds2 ? "T" : "") + (hours2 ? hmsSign + hours2 + "H" : "") + (minutes2 ? hmsSign + minutes2 + "M" : "") + (seconds2 ? hmsSign + s3 + "S" : "");
}
var proto$2 = Duration.prototype;
proto$2.isValid = isValid$1;
proto$2.abs = abs;
proto$2.add = add$1;
proto$2.subtract = subtract$1;
proto$2.as = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale;
proto$2.localeData = localeData;
proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
proto$2.lang = lang;
addFormatToken("X", 0, 0, "unix");
addFormatToken("x", 0, 0, "valueOf");
addRegexToken("x", matchSigned);
addRegexToken("X", matchTimestamp);
addParseToken("X", function(input, array2, config) {
  config._d = new Date(parseFloat(input) * 1e3);
});
addParseToken("x", function(input, array2, config) {
  config._d = new Date(toInt(input));
});
//! moment.js
hooks.version = "2.30.1";
setHookCallback(createLocal);
hooks.fn = proto;
hooks.min = min;
hooks.max = max;
hooks.now = now;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto;
hooks.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  DATE: "YYYY-MM-DD",
  TIME: "HH:mm",
  TIME_SECONDS: "HH:mm:ss",
  TIME_MS: "HH:mm:ss.SSS",
  WEEK: "GGGG-[W]WW",
  MONTH: "YYYY-MM"
};
var moment$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": hooks
}, Symbol.toStringTag, { value: "Module" }));
var require$$0 = /* @__PURE__ */ getAugmentedNamespace(moment$2);
(function(module2) {
  //! moment-timezone.js
  //! version : 0.5.45
  //! Copyright (c) JS Foundation and other contributors
  //! license : MIT
  //! github.com/moment/moment-timezone
  (function(root, factory2) {
    if (module2.exports) {
      module2.exports = factory2(require$$0);
    } else {
      factory2(root.moment);
    }
  })(commonjsGlobal, function(moment2) {
    if (moment2.version === void 0 && moment2.default) {
      moment2 = moment2.default;
    }
    var VERSION2 = "0.5.45", zones2 = {}, links2 = {}, countries2 = {}, names = {}, guesses = {}, cachedGuess;
    if (!moment2 || typeof moment2.version !== "string") {
      logError("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
    }
    var momentVersion = moment2.version.split("."), major = +momentVersion[0], minor = +momentVersion[1];
    if (major < 2 || major === 2 && minor < 6) {
      logError("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + moment2.version + ". See momentjs.com");
    }
    function charCodeToInt(charCode) {
      if (charCode > 96) {
        return charCode - 87;
      } else if (charCode > 64) {
        return charCode - 29;
      }
      return charCode - 48;
    }
    function unpackBase60(string2) {
      var i = 0, parts = string2.split("."), whole = parts[0], fractional = parts[1] || "", multiplier = 1, num, out = 0, sign2 = 1;
      if (string2.charCodeAt(0) === 45) {
        i = 1;
        sign2 = -1;
      }
      for (i; i < whole.length; i++) {
        num = charCodeToInt(whole.charCodeAt(i));
        out = 60 * out + num;
      }
      for (i = 0; i < fractional.length; i++) {
        multiplier = multiplier / 60;
        num = charCodeToInt(fractional.charCodeAt(i));
        out += num * multiplier;
      }
      return out * sign2;
    }
    function arrayToInt(array2) {
      for (var i = 0; i < array2.length; i++) {
        array2[i] = unpackBase60(array2[i]);
      }
    }
    function intToUntil(array2, length) {
      for (var i = 0; i < length; i++) {
        array2[i] = Math.round((array2[i - 1] || 0) + array2[i] * 6e4);
      }
      array2[length - 1] = Infinity;
    }
    function mapIndices(source, indices) {
      var out = [], i;
      for (i = 0; i < indices.length; i++) {
        out[i] = source[indices[i]];
      }
      return out;
    }
    function unpack(string2) {
      var data = string2.split("|"), offsets = data[2].split(" "), indices = data[3].split(""), untils = data[4].split(" ");
      arrayToInt(offsets);
      arrayToInt(indices);
      arrayToInt(untils);
      intToUntil(untils, indices.length);
      return {
        name: data[0],
        abbrs: mapIndices(data[1].split(" "), indices),
        offsets: mapIndices(offsets, indices),
        untils,
        population: data[5] | 0
      };
    }
    function Zone(packedString) {
      if (packedString) {
        this._set(unpack(packedString));
      }
    }
    function closest(num, arr) {
      var len = arr.length;
      if (num < arr[0]) {
        return 0;
      } else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) {
        return len - 1;
      } else if (num >= arr[len - 1]) {
        return -1;
      }
      var mid;
      var lo2 = 0;
      var hi2 = len - 1;
      while (hi2 - lo2 > 1) {
        mid = Math.floor((lo2 + hi2) / 2);
        if (arr[mid] <= num) {
          lo2 = mid;
        } else {
          hi2 = mid;
        }
      }
      return hi2;
    }
    Zone.prototype = {
      _set: function(unpacked) {
        this.name = unpacked.name;
        this.abbrs = unpacked.abbrs;
        this.untils = unpacked.untils;
        this.offsets = unpacked.offsets;
        this.population = unpacked.population;
      },
      _index: function(timestamp) {
        var target = +timestamp, untils = this.untils, i;
        i = closest(target, untils);
        if (i >= 0) {
          return i;
        }
      },
      countries: function() {
        var zone_name = this.name;
        return Object.keys(countries2).filter(function(country_code) {
          return countries2[country_code].zones.indexOf(zone_name) !== -1;
        });
      },
      parse: function(timestamp) {
        var target = +timestamp, offsets = this.offsets, untils = this.untils, max2 = untils.length - 1, offset2, offsetNext, offsetPrev, i;
        for (i = 0; i < max2; i++) {
          offset2 = offsets[i];
          offsetNext = offsets[i + 1];
          offsetPrev = offsets[i ? i - 1 : i];
          if (offset2 < offsetNext && tz.moveAmbiguousForward) {
            offset2 = offsetNext;
          } else if (offset2 > offsetPrev && tz.moveInvalidForward) {
            offset2 = offsetPrev;
          }
          if (target < untils[i] - offset2 * 6e4) {
            return offsets[i];
          }
        }
        return offsets[max2];
      },
      abbr: function(mom) {
        return this.abbrs[this._index(mom)];
      },
      offset: function(mom) {
        logError("zone.offset has been deprecated in favor of zone.utcOffset");
        return this.offsets[this._index(mom)];
      },
      utcOffset: function(mom) {
        return this.offsets[this._index(mom)];
      }
    };
    function Country(country_name, zone_names) {
      this.name = country_name;
      this.zones = zone_names;
    }
    function OffsetAt(at2) {
      var timeString = at2.toTimeString();
      var abbr = timeString.match(/\([a-z ]+\)/i);
      if (abbr && abbr[0]) {
        abbr = abbr[0].match(/[A-Z]/g);
        abbr = abbr ? abbr.join("") : void 0;
      } else {
        abbr = timeString.match(/[A-Z]{3,5}/g);
        abbr = abbr ? abbr[0] : void 0;
      }
      if (abbr === "GMT") {
        abbr = void 0;
      }
      this.at = +at2;
      this.abbr = abbr;
      this.offset = at2.getTimezoneOffset();
    }
    function ZoneScore(zone) {
      this.zone = zone;
      this.offsetScore = 0;
      this.abbrScore = 0;
    }
    ZoneScore.prototype.scoreOffsetAt = function(offsetAt) {
      this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
      if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, "") !== offsetAt.abbr) {
        this.abbrScore++;
      }
    };
    function findChange(low, high) {
      var mid, diff2;
      while (diff2 = ((high.at - low.at) / 12e4 | 0) * 6e4) {
        mid = new OffsetAt(new Date(low.at + diff2));
        if (mid.offset === low.offset) {
          low = mid;
        } else {
          high = mid;
        }
      }
      return low;
    }
    function userOffsets() {
      var startYear = new Date().getFullYear() - 2, last = new OffsetAt(new Date(startYear, 0, 1)), lastOffset = last.offset, offsets = [last], change, next, nextOffset, i;
      for (i = 1; i < 48; i++) {
        nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
        if (nextOffset !== lastOffset) {
          next = new OffsetAt(new Date(startYear, i, 1));
          change = findChange(last, next);
          offsets.push(change);
          offsets.push(new OffsetAt(new Date(change.at + 6e4)));
          last = next;
          lastOffset = nextOffset;
        }
      }
      for (i = 0; i < 4; i++) {
        offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
        offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
      }
      return offsets;
    }
    function sortZoneScores(a3, b3) {
      if (a3.offsetScore !== b3.offsetScore) {
        return a3.offsetScore - b3.offsetScore;
      }
      if (a3.abbrScore !== b3.abbrScore) {
        return a3.abbrScore - b3.abbrScore;
      }
      if (a3.zone.population !== b3.zone.population) {
        return b3.zone.population - a3.zone.population;
      }
      return b3.zone.name.localeCompare(a3.zone.name);
    }
    function addToGuesses(name2, offsets) {
      var i, offset2;
      arrayToInt(offsets);
      for (i = 0; i < offsets.length; i++) {
        offset2 = offsets[i];
        guesses[offset2] = guesses[offset2] || {};
        guesses[offset2][name2] = true;
      }
    }
    function guessesForUserOffsets(offsets) {
      var offsetsLength = offsets.length, filteredGuesses = {}, out = [], checkedOffsets = {}, i, j3, offset2, guessesOffset;
      for (i = 0; i < offsetsLength; i++) {
        offset2 = offsets[i].offset;
        if (checkedOffsets.hasOwnProperty(offset2)) {
          continue;
        }
        guessesOffset = guesses[offset2] || {};
        for (j3 in guessesOffset) {
          if (guessesOffset.hasOwnProperty(j3)) {
            filteredGuesses[j3] = true;
          }
        }
        checkedOffsets[offset2] = true;
      }
      for (i in filteredGuesses) {
        if (filteredGuesses.hasOwnProperty(i)) {
          out.push(names[i]);
        }
      }
      return out;
    }
    function rebuildGuess() {
      try {
        var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (intlName && intlName.length > 3) {
          var name2 = names[normalizeName(intlName)];
          if (name2) {
            return name2;
          }
          logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
        }
      } catch (e28) {
      }
      var offsets = userOffsets(), offsetsLength = offsets.length, guesses2 = guessesForUserOffsets(offsets), zoneScores = [], zoneScore, i, j3;
      for (i = 0; i < guesses2.length; i++) {
        zoneScore = new ZoneScore(getZone(guesses2[i]));
        for (j3 = 0; j3 < offsetsLength; j3++) {
          zoneScore.scoreOffsetAt(offsets[j3]);
        }
        zoneScores.push(zoneScore);
      }
      zoneScores.sort(sortZoneScores);
      return zoneScores.length > 0 ? zoneScores[0].zone.name : void 0;
    }
    function guess(ignoreCache) {
      if (!cachedGuess || ignoreCache) {
        cachedGuess = rebuildGuess();
      }
      return cachedGuess;
    }
    function normalizeName(name2) {
      return (name2 || "").toLowerCase().replace(/\//g, "_");
    }
    function addZone(packed) {
      var i, name2, split2, normalized;
      if (typeof packed === "string") {
        packed = [packed];
      }
      for (i = 0; i < packed.length; i++) {
        split2 = packed[i].split("|");
        name2 = split2[0];
        normalized = normalizeName(name2);
        zones2[normalized] = packed[i];
        names[normalized] = name2;
        addToGuesses(normalized, split2[2].split(" "));
      }
    }
    function getZone(name2, caller) {
      name2 = normalizeName(name2);
      var zone = zones2[name2];
      var link;
      if (zone instanceof Zone) {
        return zone;
      }
      if (typeof zone === "string") {
        zone = new Zone(zone);
        zones2[name2] = zone;
        return zone;
      }
      if (links2[name2] && caller !== getZone && (link = getZone(links2[name2], getZone))) {
        zone = zones2[name2] = new Zone();
        zone._set(link);
        zone.name = names[name2];
        return zone;
      }
      return null;
    }
    function getNames() {
      var i, out = [];
      for (i in names) {
        if (names.hasOwnProperty(i) && (zones2[i] || zones2[links2[i]]) && names[i]) {
          out.push(names[i]);
        }
      }
      return out.sort();
    }
    function getCountryNames() {
      return Object.keys(countries2);
    }
    function addLink(aliases2) {
      var i, alias, normal0, normal1;
      if (typeof aliases2 === "string") {
        aliases2 = [aliases2];
      }
      for (i = 0; i < aliases2.length; i++) {
        alias = aliases2[i].split("|");
        normal0 = normalizeName(alias[0]);
        normal1 = normalizeName(alias[1]);
        links2[normal0] = normal1;
        names[normal0] = alias[0];
        links2[normal1] = normal0;
        names[normal1] = alias[1];
      }
    }
    function addCountries(data) {
      var i, country_code, country_zones, split2;
      if (!data || !data.length)
        return;
      for (i = 0; i < data.length; i++) {
        split2 = data[i].split("|");
        country_code = split2[0].toUpperCase();
        country_zones = split2[1].split(" ");
        countries2[country_code] = new Country(country_code, country_zones);
      }
    }
    function getCountry(name2) {
      name2 = name2.toUpperCase();
      return countries2[name2] || null;
    }
    function zonesForCountry(country, with_offset) {
      country = getCountry(country);
      if (!country)
        return null;
      var zones3 = country.zones.sort();
      if (with_offset) {
        return zones3.map(function(zone_name) {
          var zone = getZone(zone_name);
          return {
            name: zone_name,
            offset: zone.utcOffset(new Date())
          };
        });
      }
      return zones3;
    }
    function loadData(data) {
      addZone(data.zones);
      addLink(data.links);
      addCountries(data.countries);
      tz.dataVersion = data.version;
    }
    function zoneExists(name2) {
      if (!zoneExists.didShowError) {
        zoneExists.didShowError = true;
        logError("moment.tz.zoneExists('" + name2 + "') has been deprecated in favor of !moment.tz.zone('" + name2 + "')");
      }
      return !!getZone(name2);
    }
    function needsOffset(m3) {
      var isUnixTimestamp = m3._f === "X" || m3._f === "x";
      return !!(m3._a && m3._tzm === void 0 && !isUnixTimestamp);
    }
    function logError(message) {
      if (typeof console !== "undefined" && typeof console.error === "function") {
        console.error(message);
      }
    }
    function tz(input) {
      var args = Array.prototype.slice.call(arguments, 0, -1), name2 = arguments[arguments.length - 1], out = moment2.utc.apply(null, args), zone;
      if (!moment2.isMoment(input) && needsOffset(out) && (zone = getZone(name2))) {
        out.add(zone.parse(out), "minutes");
      }
      out.tz(name2);
      return out;
    }
    tz.version = VERSION2;
    tz.dataVersion = "";
    tz._zones = zones2;
    tz._links = links2;
    tz._names = names;
    tz._countries = countries2;
    tz.add = addZone;
    tz.link = addLink;
    tz.load = loadData;
    tz.zone = getZone;
    tz.zoneExists = zoneExists;
    tz.guess = guess;
    tz.names = getNames;
    tz.Zone = Zone;
    tz.unpack = unpack;
    tz.unpackBase60 = unpackBase60;
    tz.needsOffset = needsOffset;
    tz.moveInvalidForward = true;
    tz.moveAmbiguousForward = false;
    tz.countries = getCountryNames;
    tz.zonesForCountry = zonesForCountry;
    var fn2 = moment2.fn;
    moment2.tz = tz;
    moment2.defaultZone = null;
    moment2.updateOffset = function(mom, keepTime) {
      var zone = moment2.defaultZone, offset2;
      if (mom._z === void 0) {
        if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
          mom._d = moment2.utc(mom._a)._d;
          mom.utc().add(zone.parse(mom), "minutes");
        }
        mom._z = zone;
      }
      if (mom._z) {
        offset2 = mom._z.utcOffset(mom);
        if (Math.abs(offset2) < 16) {
          offset2 = offset2 / 60;
        }
        if (mom.utcOffset !== void 0) {
          var z3 = mom._z;
          mom.utcOffset(-offset2, keepTime);
          mom._z = z3;
        } else {
          mom.zone(offset2, keepTime);
        }
      }
    };
    fn2.tz = function(name2, keepTime) {
      if (name2) {
        if (typeof name2 !== "string") {
          throw new Error("Time zone name must be a string, got " + name2 + " [" + typeof name2 + "]");
        }
        this._z = getZone(name2);
        if (this._z) {
          moment2.updateOffset(this, keepTime);
        } else {
          logError("Moment Timezone has no data for " + name2 + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
        }
        return this;
      }
      if (this._z) {
        return this._z.name;
      }
    };
    function abbrWrap(old) {
      return function() {
        if (this._z) {
          return this._z.abbr(this);
        }
        return old.call(this);
      };
    }
    function resetZoneWrap(old) {
      return function() {
        this._z = null;
        return old.apply(this, arguments);
      };
    }
    function resetZoneWrap2(old) {
      return function() {
        if (arguments.length > 0)
          this._z = null;
        return old.apply(this, arguments);
      };
    }
    fn2.zoneName = abbrWrap(fn2.zoneName);
    fn2.zoneAbbr = abbrWrap(fn2.zoneAbbr);
    fn2.utc = resetZoneWrap(fn2.utc);
    fn2.local = resetZoneWrap(fn2.local);
    fn2.utcOffset = resetZoneWrap2(fn2.utcOffset);
    moment2.tz.setDefault = function(name2) {
      if (major < 2 || major === 2 && minor < 9) {
        logError("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + moment2.version + ".");
      }
      moment2.defaultZone = name2 ? getZone(name2) : null;
      return moment2;
    };
    var momentProperties2 = moment2.momentProperties;
    if (Object.prototype.toString.call(momentProperties2) === "[object Array]") {
      momentProperties2.push("_z");
      momentProperties2.push("_a");
    } else if (momentProperties2) {
      momentProperties2._z = null;
    }
    return moment2;
  });
})(momentTimezone);
const version = "2024a";
const zones = [
  "Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
  "Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5",
  "Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
  "Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6",
  "Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
  "Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
  "Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6",
  "Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5",
  "Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3",
  "Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4",
  "Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5",
  "Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|",
  "Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
  "Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5",
  "Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
  "Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|",
  "Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
  "Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
  "Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
  "America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
  "America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
  "America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5",
  "America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
  "America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
  "America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
  "America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
  "America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
  "America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
  "America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
  "America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
  "America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
  "America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
  "America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
  "America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
  "America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
  "America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
  "America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5",
  "America/Bahia_Banderas|LMT MST CST MDT PST CDT|71 70 60 60 80 50|0121312141313131313131313131313131313152525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3",
  "America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
  "America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
  "America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
  "America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3",
  "America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
  "America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5",
  "America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
  "America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
  "America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
  "America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
  "America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5",
  "America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
  "America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
  "America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4",
  "America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
  "America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
  "America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
  "America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
  "America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
  "America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2",
  "America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
  "America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
  "America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
  "America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
  "America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
  "America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
  "America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
  "America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
  "America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
  "America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3",
  "America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
  "America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
  "America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
  "America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5",
  "America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4",
  "America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
  "America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
  "America/Hermosillo|LMT MST CST MDT PST|7n.Q 70 60 60 80|0121312141313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
  "America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
  "America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
  "America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
  "America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
  "America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5",
  "America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
  "America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
  "America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
  "America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
  "America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
  "America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4",
  "America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
  "America/Mazatlan|LMT MST CST MDT PST|75.E 70 60 60 80|0121312141313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4",
  "America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
  "America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5",
  "America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
  "America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6",
  "America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
  "America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
  "America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5",
  "America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
  "America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
  "America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
  "America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
  "America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
  "America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
  "America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
  "America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
  "America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
  "America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
  "America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
  "America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
  "America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
  "America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
  "America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
  "America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
  "America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
  "America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5",
  "America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
  "America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
  "America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452",
  "America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
  "America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
  "America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
  "America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
  "America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
  "America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
  "America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3",
  "America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
  "Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10",
  "Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
  "Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4",
  "Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
  "Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
  "Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5",
  "Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
  "Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
  "Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
  "Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40",
  "Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25",
  "Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5",
  "Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5",
  "Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5",
  "Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
  "Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
  "Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
  "Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
  "Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
  "Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
  "Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
  "Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
  "Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6",
  "Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
  "Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5",
  "Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
  "Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4",
  "Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6",
  "Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
  "Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
  "Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
  "Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
  "Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
  "Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5",
  "Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
  "Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
  "Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
  "Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
  "Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5",
  "Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4",
  "Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5",
  "Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
  "Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
  "Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
  "Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
  "Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
  "Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
  "Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4",
  "Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5",
  "Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
  "Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
  "Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
  "Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
  "Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
  "Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
  "Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5",
  "Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
  "Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
  "Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
  "Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
  "Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4",
  "Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
  "Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
  "Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
  "Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
  "Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
  "Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
  "Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|",
  "Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
  "Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5",
  "Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
  "Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
  "Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
  "Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
  "Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
  "Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
  "Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
  "Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 XA0 Wou JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6",
  "Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
  "Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
  "Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
  "Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
  "Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
  "Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
  "Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
  "Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
  "Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
  "Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4",
  "Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
  "Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
  "Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
  "Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3",
  "Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4",
  "Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30",
  "Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
  "Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5",
  "Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5",
  "Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
  "Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3",
  "Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4",
  "Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4",
  "Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
  "Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347",
  "Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
  "Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5",
  "Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
  "CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
  "Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2",
  "CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
  "Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
  "EST|EST|50|0||",
  "EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "Etc/GMT-0|GMT|0|0||",
  "Etc/GMT-1|+01|-10|0||",
  "Etc/GMT-10|+10|-a0|0||",
  "Etc/GMT-11|+11|-b0|0||",
  "Etc/GMT-12|+12|-c0|0||",
  "Etc/GMT-13|+13|-d0|0||",
  "Etc/GMT-14|+14|-e0|0||",
  "Etc/GMT-2|+02|-20|0||",
  "Etc/GMT-3|+03|-30|0||",
  "Etc/GMT-4|+04|-40|0||",
  "Etc/GMT-5|+05|-50|0||",
  "Etc/GMT-6|+06|-60|0||",
  "Etc/GMT-7|+07|-70|0||",
  "Etc/GMT-8|+08|-80|0||",
  "Etc/GMT-9|+09|-90|0||",
  "Etc/GMT+1|-01|10|0||",
  "Etc/GMT+10|-10|a0|0||",
  "Etc/GMT+11|-11|b0|0||",
  "Etc/GMT+12|-12|c0|0||",
  "Etc/GMT+2|-02|20|0||",
  "Etc/GMT+3|-03|30|0||",
  "Etc/GMT+4|-04|40|0||",
  "Etc/GMT+5|-05|50|0||",
  "Etc/GMT+6|-06|60|0||",
  "Etc/GMT+7|-07|70|0||",
  "Etc/GMT+8|-08|80|0||",
  "Etc/GMT+9|-09|90|0||",
  "Etc/UTC|UTC|0|0||",
  "Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5",
  "Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3",
  "Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
  "Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5",
  "Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6",
  "Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
  "Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5",
  "Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5",
  "Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
  "Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4",
  "Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4",
  "Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3",
  "Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
  "Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
  "Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5",
  "Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
  "Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
  "Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5",
  "Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
  "Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
  "Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6",
  "Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
  "Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4",
  "Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5",
  "Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
  "Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
  "Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
  "Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
  "Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4",
  "Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
  "Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
  "Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5",
  "Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
  "Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5",
  "Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
  "HST|HST|a0|0||",
  "Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
  "Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4",
  "Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
  "Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3",
  "MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
  "MST|MST|70|0||",
  "MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600",
  "Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3",
  "Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4",
  "Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
  "Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1",
  "Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483",
  "Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4",
  "Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3",
  "Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
  "Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
  "Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
  "Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
  "Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4",
  "Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2",
  "Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
  "Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
  "Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2",
  "Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
  "Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2",
  "Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4",
  "Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
  "Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3",
  "Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56",
  "Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
  "Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
  "Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
  "PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
  "WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|"
];
const links = [
  "Africa/Abidjan|Africa/Accra",
  "Africa/Abidjan|Africa/Bamako",
  "Africa/Abidjan|Africa/Banjul",
  "Africa/Abidjan|Africa/Conakry",
  "Africa/Abidjan|Africa/Dakar",
  "Africa/Abidjan|Africa/Freetown",
  "Africa/Abidjan|Africa/Lome",
  "Africa/Abidjan|Africa/Nouakchott",
  "Africa/Abidjan|Africa/Ouagadougou",
  "Africa/Abidjan|Africa/Timbuktu",
  "Africa/Abidjan|Atlantic/Reykjavik",
  "Africa/Abidjan|Atlantic/St_Helena",
  "Africa/Abidjan|Iceland",
  "Africa/Cairo|Egypt",
  "Africa/Johannesburg|Africa/Maseru",
  "Africa/Johannesburg|Africa/Mbabane",
  "Africa/Lagos|Africa/Bangui",
  "Africa/Lagos|Africa/Brazzaville",
  "Africa/Lagos|Africa/Douala",
  "Africa/Lagos|Africa/Kinshasa",
  "Africa/Lagos|Africa/Libreville",
  "Africa/Lagos|Africa/Luanda",
  "Africa/Lagos|Africa/Malabo",
  "Africa/Lagos|Africa/Niamey",
  "Africa/Lagos|Africa/Porto-Novo",
  "Africa/Maputo|Africa/Blantyre",
  "Africa/Maputo|Africa/Bujumbura",
  "Africa/Maputo|Africa/Gaborone",
  "Africa/Maputo|Africa/Harare",
  "Africa/Maputo|Africa/Kigali",
  "Africa/Maputo|Africa/Lubumbashi",
  "Africa/Maputo|Africa/Lusaka",
  "Africa/Nairobi|Africa/Addis_Ababa",
  "Africa/Nairobi|Africa/Asmara",
  "Africa/Nairobi|Africa/Asmera",
  "Africa/Nairobi|Africa/Dar_es_Salaam",
  "Africa/Nairobi|Africa/Djibouti",
  "Africa/Nairobi|Africa/Kampala",
  "Africa/Nairobi|Africa/Mogadishu",
  "Africa/Nairobi|Indian/Antananarivo",
  "Africa/Nairobi|Indian/Comoro",
  "Africa/Nairobi|Indian/Mayotte",
  "Africa/Tripoli|Libya",
  "America/Adak|America/Atka",
  "America/Adak|US/Aleutian",
  "America/Anchorage|US/Alaska",
  "America/Argentina/Buenos_Aires|America/Buenos_Aires",
  "America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
  "America/Argentina/Catamarca|America/Catamarca",
  "America/Argentina/Cordoba|America/Cordoba",
  "America/Argentina/Cordoba|America/Rosario",
  "America/Argentina/Jujuy|America/Jujuy",
  "America/Argentina/Mendoza|America/Mendoza",
  "America/Chicago|US/Central",
  "America/Denver|America/Shiprock",
  "America/Denver|Navajo",
  "America/Denver|US/Mountain",
  "America/Detroit|US/Michigan",
  "America/Edmonton|America/Yellowknife",
  "America/Edmonton|Canada/Mountain",
  "America/Fort_Wayne|America/Indiana/Indianapolis",
  "America/Fort_Wayne|America/Indianapolis",
  "America/Fort_Wayne|US/East-Indiana",
  "America/Godthab|America/Nuuk",
  "America/Halifax|Canada/Atlantic",
  "America/Havana|Cuba",
  "America/Indiana/Knox|America/Knox_IN",
  "America/Indiana/Knox|US/Indiana-Starke",
  "America/Iqaluit|America/Pangnirtung",
  "America/Jamaica|Jamaica",
  "America/Kentucky/Louisville|America/Louisville",
  "America/Los_Angeles|US/Pacific",
  "America/Manaus|Brazil/West",
  "America/Mazatlan|Mexico/BajaSur",
  "America/Mexico_City|Mexico/General",
  "America/New_York|US/Eastern",
  "America/Noronha|Brazil/DeNoronha",
  "America/Panama|America/Atikokan",
  "America/Panama|America/Cayman",
  "America/Panama|America/Coral_Harbour",
  "America/Phoenix|America/Creston",
  "America/Phoenix|US/Arizona",
  "America/Puerto_Rico|America/Anguilla",
  "America/Puerto_Rico|America/Antigua",
  "America/Puerto_Rico|America/Aruba",
  "America/Puerto_Rico|America/Blanc-Sablon",
  "America/Puerto_Rico|America/Curacao",
  "America/Puerto_Rico|America/Dominica",
  "America/Puerto_Rico|America/Grenada",
  "America/Puerto_Rico|America/Guadeloupe",
  "America/Puerto_Rico|America/Kralendijk",
  "America/Puerto_Rico|America/Lower_Princes",
  "America/Puerto_Rico|America/Marigot",
  "America/Puerto_Rico|America/Montserrat",
  "America/Puerto_Rico|America/Port_of_Spain",
  "America/Puerto_Rico|America/St_Barthelemy",
  "America/Puerto_Rico|America/St_Kitts",
  "America/Puerto_Rico|America/St_Lucia",
  "America/Puerto_Rico|America/St_Thomas",
  "America/Puerto_Rico|America/St_Vincent",
  "America/Puerto_Rico|America/Tortola",
  "America/Puerto_Rico|America/Virgin",
  "America/Regina|Canada/Saskatchewan",
  "America/Rio_Branco|America/Porto_Acre",
  "America/Rio_Branco|Brazil/Acre",
  "America/Santiago|Chile/Continental",
  "America/Sao_Paulo|Brazil/East",
  "America/St_Johns|Canada/Newfoundland",
  "America/Tijuana|America/Ensenada",
  "America/Tijuana|America/Santa_Isabel",
  "America/Tijuana|Mexico/BajaNorte",
  "America/Toronto|America/Montreal",
  "America/Toronto|America/Nassau",
  "America/Toronto|America/Nipigon",
  "America/Toronto|America/Thunder_Bay",
  "America/Toronto|Canada/Eastern",
  "America/Vancouver|Canada/Pacific",
  "America/Whitehorse|Canada/Yukon",
  "America/Winnipeg|America/Rainy_River",
  "America/Winnipeg|Canada/Central",
  "Asia/Ashgabat|Asia/Ashkhabad",
  "Asia/Bangkok|Asia/Phnom_Penh",
  "Asia/Bangkok|Asia/Vientiane",
  "Asia/Bangkok|Indian/Christmas",
  "Asia/Brunei|Asia/Kuching",
  "Asia/Dhaka|Asia/Dacca",
  "Asia/Dubai|Asia/Muscat",
  "Asia/Dubai|Indian/Mahe",
  "Asia/Dubai|Indian/Reunion",
  "Asia/Ho_Chi_Minh|Asia/Saigon",
  "Asia/Hong_Kong|Hongkong",
  "Asia/Jerusalem|Asia/Tel_Aviv",
  "Asia/Jerusalem|Israel",
  "Asia/Kathmandu|Asia/Katmandu",
  "Asia/Kolkata|Asia/Calcutta",
  "Asia/Kuala_Lumpur|Asia/Singapore",
  "Asia/Kuala_Lumpur|Singapore",
  "Asia/Macau|Asia/Macao",
  "Asia/Makassar|Asia/Ujung_Pandang",
  "Asia/Nicosia|Europe/Nicosia",
  "Asia/Qatar|Asia/Bahrain",
  "Asia/Rangoon|Asia/Yangon",
  "Asia/Rangoon|Indian/Cocos",
  "Asia/Riyadh|Antarctica/Syowa",
  "Asia/Riyadh|Asia/Aden",
  "Asia/Riyadh|Asia/Kuwait",
  "Asia/Seoul|ROK",
  "Asia/Shanghai|Asia/Chongqing",
  "Asia/Shanghai|Asia/Chungking",
  "Asia/Shanghai|Asia/Harbin",
  "Asia/Shanghai|PRC",
  "Asia/Taipei|ROC",
  "Asia/Tehran|Iran",
  "Asia/Thimphu|Asia/Thimbu",
  "Asia/Tokyo|Japan",
  "Asia/Ulaanbaatar|Asia/Ulan_Bator",
  "Asia/Urumqi|Asia/Kashgar",
  "Atlantic/Faroe|Atlantic/Faeroe",
  "Australia/Adelaide|Australia/South",
  "Australia/Brisbane|Australia/Queensland",
  "Australia/Broken_Hill|Australia/Yancowinna",
  "Australia/Darwin|Australia/North",
  "Australia/Hobart|Australia/Currie",
  "Australia/Hobart|Australia/Tasmania",
  "Australia/Lord_Howe|Australia/LHI",
  "Australia/Melbourne|Australia/Victoria",
  "Australia/Perth|Australia/West",
  "Australia/Sydney|Australia/ACT",
  "Australia/Sydney|Australia/Canberra",
  "Australia/Sydney|Australia/NSW",
  "Etc/GMT-0|Etc/GMT",
  "Etc/GMT-0|Etc/GMT+0",
  "Etc/GMT-0|Etc/GMT0",
  "Etc/GMT-0|Etc/Greenwich",
  "Etc/GMT-0|GMT",
  "Etc/GMT-0|GMT+0",
  "Etc/GMT-0|GMT-0",
  "Etc/GMT-0|GMT0",
  "Etc/GMT-0|Greenwich",
  "Etc/UTC|Etc/UCT",
  "Etc/UTC|Etc/Universal",
  "Etc/UTC|Etc/Zulu",
  "Etc/UTC|UCT",
  "Etc/UTC|UTC",
  "Etc/UTC|Universal",
  "Etc/UTC|Zulu",
  "Europe/Belgrade|Europe/Ljubljana",
  "Europe/Belgrade|Europe/Podgorica",
  "Europe/Belgrade|Europe/Sarajevo",
  "Europe/Belgrade|Europe/Skopje",
  "Europe/Belgrade|Europe/Zagreb",
  "Europe/Berlin|Arctic/Longyearbyen",
  "Europe/Berlin|Atlantic/Jan_Mayen",
  "Europe/Berlin|Europe/Copenhagen",
  "Europe/Berlin|Europe/Oslo",
  "Europe/Berlin|Europe/Stockholm",
  "Europe/Brussels|Europe/Amsterdam",
  "Europe/Brussels|Europe/Luxembourg",
  "Europe/Chisinau|Europe/Tiraspol",
  "Europe/Dublin|Eire",
  "Europe/Helsinki|Europe/Mariehamn",
  "Europe/Istanbul|Asia/Istanbul",
  "Europe/Istanbul|Turkey",
  "Europe/Kiev|Europe/Kyiv",
  "Europe/Kiev|Europe/Uzhgorod",
  "Europe/Kiev|Europe/Zaporozhye",
  "Europe/Lisbon|Portugal",
  "Europe/London|Europe/Belfast",
  "Europe/London|Europe/Guernsey",
  "Europe/London|Europe/Isle_of_Man",
  "Europe/London|Europe/Jersey",
  "Europe/London|GB",
  "Europe/London|GB-Eire",
  "Europe/Moscow|W-SU",
  "Europe/Paris|Europe/Monaco",
  "Europe/Prague|Europe/Bratislava",
  "Europe/Rome|Europe/San_Marino",
  "Europe/Rome|Europe/Vatican",
  "Europe/Warsaw|Poland",
  "Europe/Zurich|Europe/Busingen",
  "Europe/Zurich|Europe/Vaduz",
  "Indian/Maldives|Indian/Kerguelen",
  "Pacific/Auckland|Antarctica/McMurdo",
  "Pacific/Auckland|Antarctica/South_Pole",
  "Pacific/Auckland|NZ",
  "Pacific/Chatham|NZ-CHAT",
  "Pacific/Easter|Chile/EasterIsland",
  "Pacific/Enderbury|Pacific/Kanton",
  "Pacific/Guadalcanal|Pacific/Pohnpei",
  "Pacific/Guadalcanal|Pacific/Ponape",
  "Pacific/Guam|Pacific/Saipan",
  "Pacific/Honolulu|Pacific/Johnston",
  "Pacific/Honolulu|US/Hawaii",
  "Pacific/Kwajalein|Kwajalein",
  "Pacific/Pago_Pago|Pacific/Midway",
  "Pacific/Pago_Pago|Pacific/Samoa",
  "Pacific/Pago_Pago|US/Samoa",
  "Pacific/Port_Moresby|Antarctica/DumontDUrville",
  "Pacific/Port_Moresby|Pacific/Chuuk",
  "Pacific/Port_Moresby|Pacific/Truk",
  "Pacific/Port_Moresby|Pacific/Yap",
  "Pacific/Tarawa|Pacific/Funafuti",
  "Pacific/Tarawa|Pacific/Majuro",
  "Pacific/Tarawa|Pacific/Wake",
  "Pacific/Tarawa|Pacific/Wallis"
];
const countries = [
  "AD|Europe/Andorra",
  "AE|Asia/Dubai",
  "AF|Asia/Kabul",
  "AG|America/Puerto_Rico America/Antigua",
  "AI|America/Puerto_Rico America/Anguilla",
  "AL|Europe/Tirane",
  "AM|Asia/Yerevan",
  "AO|Africa/Lagos Africa/Luanda",
  "AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa",
  "AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
  "AS|Pacific/Pago_Pago",
  "AT|Europe/Vienna",
  "AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
  "AW|America/Puerto_Rico America/Aruba",
  "AX|Europe/Helsinki Europe/Mariehamn",
  "AZ|Asia/Baku",
  "BA|Europe/Belgrade Europe/Sarajevo",
  "BB|America/Barbados",
  "BD|Asia/Dhaka",
  "BE|Europe/Brussels",
  "BF|Africa/Abidjan Africa/Ouagadougou",
  "BG|Europe/Sofia",
  "BH|Asia/Qatar Asia/Bahrain",
  "BI|Africa/Maputo Africa/Bujumbura",
  "BJ|Africa/Lagos Africa/Porto-Novo",
  "BL|America/Puerto_Rico America/St_Barthelemy",
  "BM|Atlantic/Bermuda",
  "BN|Asia/Kuching Asia/Brunei",
  "BO|America/La_Paz",
  "BQ|America/Puerto_Rico America/Kralendijk",
  "BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
  "BS|America/Toronto America/Nassau",
  "BT|Asia/Thimphu",
  "BW|Africa/Maputo Africa/Gaborone",
  "BY|Europe/Minsk",
  "BZ|America/Belize",
  "CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston",
  "CC|Asia/Yangon Indian/Cocos",
  "CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
  "CF|Africa/Lagos Africa/Bangui",
  "CG|Africa/Lagos Africa/Brazzaville",
  "CH|Europe/Zurich",
  "CI|Africa/Abidjan",
  "CK|Pacific/Rarotonga",
  "CL|America/Santiago America/Punta_Arenas Pacific/Easter",
  "CM|Africa/Lagos Africa/Douala",
  "CN|Asia/Shanghai Asia/Urumqi",
  "CO|America/Bogota",
  "CR|America/Costa_Rica",
  "CU|America/Havana",
  "CV|Atlantic/Cape_Verde",
  "CW|America/Puerto_Rico America/Curacao",
  "CX|Asia/Bangkok Indian/Christmas",
  "CY|Asia/Nicosia Asia/Famagusta",
  "CZ|Europe/Prague",
  "DE|Europe/Zurich Europe/Berlin Europe/Busingen",
  "DJ|Africa/Nairobi Africa/Djibouti",
  "DK|Europe/Berlin Europe/Copenhagen",
  "DM|America/Puerto_Rico America/Dominica",
  "DO|America/Santo_Domingo",
  "DZ|Africa/Algiers",
  "EC|America/Guayaquil Pacific/Galapagos",
  "EE|Europe/Tallinn",
  "EG|Africa/Cairo",
  "EH|Africa/El_Aaiun",
  "ER|Africa/Nairobi Africa/Asmara",
  "ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
  "ET|Africa/Nairobi Africa/Addis_Ababa",
  "FI|Europe/Helsinki",
  "FJ|Pacific/Fiji",
  "FK|Atlantic/Stanley",
  "FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei",
  "FO|Atlantic/Faroe",
  "FR|Europe/Paris",
  "GA|Africa/Lagos Africa/Libreville",
  "GB|Europe/London",
  "GD|America/Puerto_Rico America/Grenada",
  "GE|Asia/Tbilisi",
  "GF|America/Cayenne",
  "GG|Europe/London Europe/Guernsey",
  "GH|Africa/Abidjan Africa/Accra",
  "GI|Europe/Gibraltar",
  "GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
  "GM|Africa/Abidjan Africa/Banjul",
  "GN|Africa/Abidjan Africa/Conakry",
  "GP|America/Puerto_Rico America/Guadeloupe",
  "GQ|Africa/Lagos Africa/Malabo",
  "GR|Europe/Athens",
  "GS|Atlantic/South_Georgia",
  "GT|America/Guatemala",
  "GU|Pacific/Guam",
  "GW|Africa/Bissau",
  "GY|America/Guyana",
  "HK|Asia/Hong_Kong",
  "HN|America/Tegucigalpa",
  "HR|Europe/Belgrade Europe/Zagreb",
  "HT|America/Port-au-Prince",
  "HU|Europe/Budapest",
  "ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
  "IE|Europe/Dublin",
  "IL|Asia/Jerusalem",
  "IM|Europe/London Europe/Isle_of_Man",
  "IN|Asia/Kolkata",
  "IO|Indian/Chagos",
  "IQ|Asia/Baghdad",
  "IR|Asia/Tehran",
  "IS|Africa/Abidjan Atlantic/Reykjavik",
  "IT|Europe/Rome",
  "JE|Europe/London Europe/Jersey",
  "JM|America/Jamaica",
  "JO|Asia/Amman",
  "JP|Asia/Tokyo",
  "KE|Africa/Nairobi",
  "KG|Asia/Bishkek",
  "KH|Asia/Bangkok Asia/Phnom_Penh",
  "KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati",
  "KM|Africa/Nairobi Indian/Comoro",
  "KN|America/Puerto_Rico America/St_Kitts",
  "KP|Asia/Pyongyang",
  "KR|Asia/Seoul",
  "KW|Asia/Riyadh Asia/Kuwait",
  "KY|America/Panama America/Cayman",
  "KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
  "LA|Asia/Bangkok Asia/Vientiane",
  "LB|Asia/Beirut",
  "LC|America/Puerto_Rico America/St_Lucia",
  "LI|Europe/Zurich Europe/Vaduz",
  "LK|Asia/Colombo",
  "LR|Africa/Monrovia",
  "LS|Africa/Johannesburg Africa/Maseru",
  "LT|Europe/Vilnius",
  "LU|Europe/Brussels Europe/Luxembourg",
  "LV|Europe/Riga",
  "LY|Africa/Tripoli",
  "MA|Africa/Casablanca",
  "MC|Europe/Paris Europe/Monaco",
  "MD|Europe/Chisinau",
  "ME|Europe/Belgrade Europe/Podgorica",
  "MF|America/Puerto_Rico America/Marigot",
  "MG|Africa/Nairobi Indian/Antananarivo",
  "MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro",
  "MK|Europe/Belgrade Europe/Skopje",
  "ML|Africa/Abidjan Africa/Bamako",
  "MM|Asia/Yangon",
  "MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
  "MO|Asia/Macau",
  "MP|Pacific/Guam Pacific/Saipan",
  "MQ|America/Martinique",
  "MR|Africa/Abidjan Africa/Nouakchott",
  "MS|America/Puerto_Rico America/Montserrat",
  "MT|Europe/Malta",
  "MU|Indian/Mauritius",
  "MV|Indian/Maldives",
  "MW|Africa/Maputo Africa/Blantyre",
  "MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana",
  "MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur",
  "MZ|Africa/Maputo",
  "NA|Africa/Windhoek",
  "NC|Pacific/Noumea",
  "NE|Africa/Lagos Africa/Niamey",
  "NF|Pacific/Norfolk",
  "NG|Africa/Lagos",
  "NI|America/Managua",
  "NL|Europe/Brussels Europe/Amsterdam",
  "NO|Europe/Berlin Europe/Oslo",
  "NP|Asia/Kathmandu",
  "NR|Pacific/Nauru",
  "NU|Pacific/Niue",
  "NZ|Pacific/Auckland Pacific/Chatham",
  "OM|Asia/Dubai Asia/Muscat",
  "PA|America/Panama",
  "PE|America/Lima",
  "PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
  "PG|Pacific/Port_Moresby Pacific/Bougainville",
  "PH|Asia/Manila",
  "PK|Asia/Karachi",
  "PL|Europe/Warsaw",
  "PM|America/Miquelon",
  "PN|Pacific/Pitcairn",
  "PR|America/Puerto_Rico",
  "PS|Asia/Gaza Asia/Hebron",
  "PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
  "PW|Pacific/Palau",
  "PY|America/Asuncion",
  "QA|Asia/Qatar",
  "RE|Asia/Dubai Indian/Reunion",
  "RO|Europe/Bucharest",
  "RS|Europe/Belgrade",
  "RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
  "RW|Africa/Maputo Africa/Kigali",
  "SA|Asia/Riyadh",
  "SB|Pacific/Guadalcanal",
  "SC|Asia/Dubai Indian/Mahe",
  "SD|Africa/Khartoum",
  "SE|Europe/Berlin Europe/Stockholm",
  "SG|Asia/Singapore",
  "SH|Africa/Abidjan Atlantic/St_Helena",
  "SI|Europe/Belgrade Europe/Ljubljana",
  "SJ|Europe/Berlin Arctic/Longyearbyen",
  "SK|Europe/Prague Europe/Bratislava",
  "SL|Africa/Abidjan Africa/Freetown",
  "SM|Europe/Rome Europe/San_Marino",
  "SN|Africa/Abidjan Africa/Dakar",
  "SO|Africa/Nairobi Africa/Mogadishu",
  "SR|America/Paramaribo",
  "SS|Africa/Juba",
  "ST|Africa/Sao_Tome",
  "SV|America/El_Salvador",
  "SX|America/Puerto_Rico America/Lower_Princes",
  "SY|Asia/Damascus",
  "SZ|Africa/Johannesburg Africa/Mbabane",
  "TC|America/Grand_Turk",
  "TD|Africa/Ndjamena",
  "TF|Asia/Dubai Indian/Maldives Indian/Kerguelen",
  "TG|Africa/Abidjan Africa/Lome",
  "TH|Asia/Bangkok",
  "TJ|Asia/Dushanbe",
  "TK|Pacific/Fakaofo",
  "TL|Asia/Dili",
  "TM|Asia/Ashgabat",
  "TN|Africa/Tunis",
  "TO|Pacific/Tongatapu",
  "TR|Europe/Istanbul",
  "TT|America/Puerto_Rico America/Port_of_Spain",
  "TV|Pacific/Tarawa Pacific/Funafuti",
  "TW|Asia/Taipei",
  "TZ|Africa/Nairobi Africa/Dar_es_Salaam",
  "UA|Europe/Simferopol Europe/Kyiv",
  "UG|Africa/Nairobi Africa/Kampala",
  "UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake",
  "US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
  "UY|America/Montevideo",
  "UZ|Asia/Samarkand Asia/Tashkent",
  "VA|Europe/Rome Europe/Vatican",
  "VC|America/Puerto_Rico America/St_Vincent",
  "VE|America/Caracas",
  "VG|America/Puerto_Rico America/Tortola",
  "VI|America/Puerto_Rico America/St_Thomas",
  "VN|Asia/Bangkok Asia/Ho_Chi_Minh",
  "VU|Pacific/Efate",
  "WF|Pacific/Tarawa Pacific/Wallis",
  "WS|Pacific/Apia",
  "YE|Asia/Riyadh Asia/Aden",
  "YT|Africa/Nairobi Indian/Mayotte",
  "ZA|Africa/Johannesburg",
  "ZM|Africa/Maputo Africa/Lusaka",
  "ZW|Africa/Maputo Africa/Harare"
];
var require$$1 = {
  version,
  zones,
  links,
  countries
};
var moment = momentTimezone$1.exports = momentTimezone.exports;
moment.tz.load(require$$1);
var moment$1 = momentTimezone$1.exports;
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(module2, exports2) {
  (function() {
    var undefined$1;
    var VERSION2 = "4.17.21";
    var LARGE_ARRAY_SIZE = 200;
    var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var MAX_MEMOIZE_SIZE = 500;
    var PLACEHOLDER = "__lodash_placeholder__";
    var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    var HOT_COUNT = 800, HOT_SPAN = 16;
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    var reTrimStart = /^\s+/;
    var reWhitespace = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags = /\w*$/;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsOctal = /^0o[0-7]+$/i;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reApos = RegExp(rsApos, "g");
    var reComboMark = RegExp(rsCombo, "g");
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    var reUnicodeWord = RegExp([
      rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
      rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
      rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
      rsUpper + "+" + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join("|"), "g");
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];
    var templateCounter = -1;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    var deburredLetters = {
      "\xC0": "A",
      "\xC1": "A",
      "\xC2": "A",
      "\xC3": "A",
      "\xC4": "A",
      "\xC5": "A",
      "\xE0": "a",
      "\xE1": "a",
      "\xE2": "a",
      "\xE3": "a",
      "\xE4": "a",
      "\xE5": "a",
      "\xC7": "C",
      "\xE7": "c",
      "\xD0": "D",
      "\xF0": "d",
      "\xC8": "E",
      "\xC9": "E",
      "\xCA": "E",
      "\xCB": "E",
      "\xE8": "e",
      "\xE9": "e",
      "\xEA": "e",
      "\xEB": "e",
      "\xCC": "I",
      "\xCD": "I",
      "\xCE": "I",
      "\xCF": "I",
      "\xEC": "i",
      "\xED": "i",
      "\xEE": "i",
      "\xEF": "i",
      "\xD1": "N",
      "\xF1": "n",
      "\xD2": "O",
      "\xD3": "O",
      "\xD4": "O",
      "\xD5": "O",
      "\xD6": "O",
      "\xD8": "O",
      "\xF2": "o",
      "\xF3": "o",
      "\xF4": "o",
      "\xF5": "o",
      "\xF6": "o",
      "\xF8": "o",
      "\xD9": "U",
      "\xDA": "U",
      "\xDB": "U",
      "\xDC": "U",
      "\xF9": "u",
      "\xFA": "u",
      "\xFB": "u",
      "\xFC": "u",
      "\xDD": "Y",
      "\xFD": "y",
      "\xFF": "y",
      "\xC6": "Ae",
      "\xE6": "ae",
      "\xDE": "Th",
      "\xFE": "th",
      "\xDF": "ss",
      "\u0100": "A",
      "\u0102": "A",
      "\u0104": "A",
      "\u0101": "a",
      "\u0103": "a",
      "\u0105": "a",
      "\u0106": "C",
      "\u0108": "C",
      "\u010A": "C",
      "\u010C": "C",
      "\u0107": "c",
      "\u0109": "c",
      "\u010B": "c",
      "\u010D": "c",
      "\u010E": "D",
      "\u0110": "D",
      "\u010F": "d",
      "\u0111": "d",
      "\u0112": "E",
      "\u0114": "E",
      "\u0116": "E",
      "\u0118": "E",
      "\u011A": "E",
      "\u0113": "e",
      "\u0115": "e",
      "\u0117": "e",
      "\u0119": "e",
      "\u011B": "e",
      "\u011C": "G",
      "\u011E": "G",
      "\u0120": "G",
      "\u0122": "G",
      "\u011D": "g",
      "\u011F": "g",
      "\u0121": "g",
      "\u0123": "g",
      "\u0124": "H",
      "\u0126": "H",
      "\u0125": "h",
      "\u0127": "h",
      "\u0128": "I",
      "\u012A": "I",
      "\u012C": "I",
      "\u012E": "I",
      "\u0130": "I",
      "\u0129": "i",
      "\u012B": "i",
      "\u012D": "i",
      "\u012F": "i",
      "\u0131": "i",
      "\u0134": "J",
      "\u0135": "j",
      "\u0136": "K",
      "\u0137": "k",
      "\u0138": "k",
      "\u0139": "L",
      "\u013B": "L",
      "\u013D": "L",
      "\u013F": "L",
      "\u0141": "L",
      "\u013A": "l",
      "\u013C": "l",
      "\u013E": "l",
      "\u0140": "l",
      "\u0142": "l",
      "\u0143": "N",
      "\u0145": "N",
      "\u0147": "N",
      "\u014A": "N",
      "\u0144": "n",
      "\u0146": "n",
      "\u0148": "n",
      "\u014B": "n",
      "\u014C": "O",
      "\u014E": "O",
      "\u0150": "O",
      "\u014D": "o",
      "\u014F": "o",
      "\u0151": "o",
      "\u0154": "R",
      "\u0156": "R",
      "\u0158": "R",
      "\u0155": "r",
      "\u0157": "r",
      "\u0159": "r",
      "\u015A": "S",
      "\u015C": "S",
      "\u015E": "S",
      "\u0160": "S",
      "\u015B": "s",
      "\u015D": "s",
      "\u015F": "s",
      "\u0161": "s",
      "\u0162": "T",
      "\u0164": "T",
      "\u0166": "T",
      "\u0163": "t",
      "\u0165": "t",
      "\u0167": "t",
      "\u0168": "U",
      "\u016A": "U",
      "\u016C": "U",
      "\u016E": "U",
      "\u0170": "U",
      "\u0172": "U",
      "\u0169": "u",
      "\u016B": "u",
      "\u016D": "u",
      "\u016F": "u",
      "\u0171": "u",
      "\u0173": "u",
      "\u0174": "W",
      "\u0175": "w",
      "\u0176": "Y",
      "\u0177": "y",
      "\u0178": "Y",
      "\u0179": "Z",
      "\u017B": "Z",
      "\u017D": "Z",
      "\u017A": "z",
      "\u017C": "z",
      "\u017E": "z",
      "\u0132": "IJ",
      "\u0133": "ij",
      "\u0152": "Oe",
      "\u0153": "oe",
      "\u0149": "'n",
      "\u017F": "s"
    };
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };
    var freeParseFloat = parseFloat, freeParseInt = parseInt;
    var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var freeExports = exports2 && !exports2.nodeType && exports2;
    var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e28) {
      }
    }();
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator(array2, setter, iteratee, accumulator) {
      var index = -1, length = array2 == null ? 0 : array2.length;
      while (++index < length) {
        var value = array2[index];
        setter(accumulator, value, iteratee(value), array2);
      }
      return accumulator;
    }
    function arrayEach(array2, iteratee) {
      var index = -1, length = array2 == null ? 0 : array2.length;
      while (++index < length) {
        if (iteratee(array2[index], index, array2) === false) {
          break;
        }
      }
      return array2;
    }
    function arrayEachRight(array2, iteratee) {
      var length = array2 == null ? 0 : array2.length;
      while (length--) {
        if (iteratee(array2[length], length, array2) === false) {
          break;
        }
      }
      return array2;
    }
    function arrayEvery(array2, predicate) {
      var index = -1, length = array2 == null ? 0 : array2.length;
      while (++index < length) {
        if (!predicate(array2[index], index, array2)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter(array2, predicate) {
      var index = -1, length = array2 == null ? 0 : array2.length, resIndex = 0, result2 = [];
      while (++index < length) {
        var value = array2[index];
        if (predicate(value, index, array2)) {
          result2[resIndex++] = value;
        }
      }
      return result2;
    }
    function arrayIncludes(array2, value) {
      var length = array2 == null ? 0 : array2.length;
      return !!length && baseIndexOf(array2, value, 0) > -1;
    }
    function arrayIncludesWith(array2, value, comparator) {
      var index = -1, length = array2 == null ? 0 : array2.length;
      while (++index < length) {
        if (comparator(value, array2[index])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap(array2, iteratee) {
      var index = -1, length = array2 == null ? 0 : array2.length, result2 = Array(length);
      while (++index < length) {
        result2[index] = iteratee(array2[index], index, array2);
      }
      return result2;
    }
    function arrayPush(array2, values) {
      var index = -1, length = values.length, offset2 = array2.length;
      while (++index < length) {
        array2[offset2 + index] = values[index];
      }
      return array2;
    }
    function arrayReduce(array2, iteratee, accumulator, initAccum) {
      var index = -1, length = array2 == null ? 0 : array2.length;
      if (initAccum && length) {
        accumulator = array2[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array2[index], index, array2);
      }
      return accumulator;
    }
    function arrayReduceRight(array2, iteratee, accumulator, initAccum) {
      var length = array2 == null ? 0 : array2.length;
      if (initAccum && length) {
        accumulator = array2[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array2[length], length, array2);
      }
      return accumulator;
    }
    function arraySome(array2, predicate) {
      var index = -1, length = array2 == null ? 0 : array2.length;
      while (++index < length) {
        if (predicate(array2[index], index, array2)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty("length");
    function asciiToArray(string2) {
      return string2.split("");
    }
    function asciiWords(string2) {
      return string2.match(reAsciiWord) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result2;
      eachFunc(collection, function(value, key, collection2) {
        if (predicate(value, key, collection2)) {
          result2 = key;
          return false;
        }
      });
      return result2;
    }
    function baseFindIndex(array2, predicate, fromIndex, fromRight) {
      var length = array2.length, index = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index-- : ++index < length) {
        if (predicate(array2[index], index, array2)) {
          return index;
        }
      }
      return -1;
    }
    function baseIndexOf(array2, value, fromIndex) {
      return value === value ? strictIndexOf(array2, value, fromIndex) : baseFindIndex(array2, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array2, value, fromIndex, comparator) {
      var index = fromIndex - 1, length = array2.length;
      while (++index < length) {
        if (comparator(array2[index], value)) {
          return index;
        }
      }
      return -1;
    }
    function baseIsNaN(value) {
      return value !== value;
    }
    function baseMean(array2, iteratee) {
      var length = array2 == null ? 0 : array2.length;
      return length ? baseSum(array2, iteratee) / length : NAN;
    }
    function baseProperty(key) {
      return function(object2) {
        return object2 == null ? undefined$1 : object2[key];
      };
    }
    function basePropertyOf(object2) {
      return function(key) {
        return object2 == null ? undefined$1 : object2[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value, index, collection2) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection2);
      });
      return accumulator;
    }
    function baseSortBy(array2, comparer) {
      var length = array2.length;
      array2.sort(comparer);
      while (length--) {
        array2[length] = array2[length].value;
      }
      return array2;
    }
    function baseSum(array2, iteratee) {
      var result2, index = -1, length = array2.length;
      while (++index < length) {
        var current = iteratee(array2[index]);
        if (current !== undefined$1) {
          result2 = result2 === undefined$1 ? current : result2 + current;
        }
      }
      return result2;
    }
    function baseTimes(n3, iteratee) {
      var index = -1, result2 = Array(n3);
      while (++index < n3) {
        result2[index] = iteratee(index);
      }
      return result2;
    }
    function baseToPairs(object2, props) {
      return arrayMap(props, function(key) {
        return [key, object2[key]];
      });
    }
    function baseTrim(string2) {
      return string2 ? string2.slice(0, trimmedEndIndex(string2) + 1).replace(reTrimStart, "") : string2;
    }
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    function baseValues(object2, props) {
      return arrayMap(props, function(key) {
        return object2[key];
      });
    }
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index = -1, length = strSymbols.length;
      while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
      }
      return index;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index = strSymbols.length;
      while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
      }
      return index;
    }
    function countHolders(array2, placeholder) {
      var length = array2.length, result2 = 0;
      while (length--) {
        if (array2[length] === placeholder) {
          ++result2;
        }
      }
      return result2;
    }
    var deburrLetter = basePropertyOf(deburredLetters);
    var escapeHtmlChar = basePropertyOf(htmlEscapes);
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }
    function getValue(object2, key) {
      return object2 == null ? undefined$1 : object2[key];
    }
    function hasUnicode(string2) {
      return reHasUnicode.test(string2);
    }
    function hasUnicodeWord(string2) {
      return reHasUnicodeWord.test(string2);
    }
    function iteratorToArray(iterator) {
      var data, result2 = [];
      while (!(data = iterator.next()).done) {
        result2.push(data.value);
      }
      return result2;
    }
    function mapToArray(map2) {
      var index = -1, result2 = Array(map2.size);
      map2.forEach(function(value, key) {
        result2[++index] = [key, value];
      });
      return result2;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function replaceHolders(array2, placeholder) {
      var index = -1, length = array2.length, resIndex = 0, result2 = [];
      while (++index < length) {
        var value = array2[index];
        if (value === placeholder || value === PLACEHOLDER) {
          array2[index] = PLACEHOLDER;
          result2[resIndex++] = index;
        }
      }
      return result2;
    }
    function setToArray(set2) {
      var index = -1, result2 = Array(set2.size);
      set2.forEach(function(value) {
        result2[++index] = value;
      });
      return result2;
    }
    function setToPairs(set2) {
      var index = -1, result2 = Array(set2.size);
      set2.forEach(function(value) {
        result2[++index] = [value, value];
      });
      return result2;
    }
    function strictIndexOf(array2, value, fromIndex) {
      var index = fromIndex - 1, length = array2.length;
      while (++index < length) {
        if (array2[index] === value) {
          return index;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array2, value, fromIndex) {
      var index = fromIndex + 1;
      while (index--) {
        if (array2[index] === value) {
          return index;
        }
      }
      return index;
    }
    function stringSize(string2) {
      return hasUnicode(string2) ? unicodeSize(string2) : asciiSize(string2);
    }
    function stringToArray(string2) {
      return hasUnicode(string2) ? unicodeToArray(string2) : asciiToArray(string2);
    }
    function trimmedEndIndex(string2) {
      var index = string2.length;
      while (index-- && reWhitespace.test(string2.charAt(index))) {
      }
      return index;
    }
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    function unicodeSize(string2) {
      var result2 = reUnicode.lastIndex = 0;
      while (reUnicode.test(string2)) {
        ++result2;
      }
      return result2;
    }
    function unicodeToArray(string2) {
      return string2.match(reUnicode) || [];
    }
    function unicodeWords(string2) {
      return string2.match(reUnicodeWord) || [];
    }
    var runInContext = function runInContext2(context) {
      context = context == null ? root : _3.defaults(root.Object(), context, _3.pick(root, contextProps));
      var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
      var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
      var coreJsData = context["__core-js_shared__"];
      var funcToString = funcProto.toString;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      var idCounter = 0;
      var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      var nativeObjectToString = objectProto.toString;
      var objectCtorString = funcToString.call(Object2);
      var oldDash = root._;
      var reIsNative = RegExp2("^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
      var Buffer2 = moduleExports ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined$1, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined$1;
      var defineProperty = function() {
        try {
          var func = getNative(Object2, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e28) {
        }
      }();
      var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
      var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
      var DataView2 = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
      var metaMap = WeakMap2 && new WeakMap2();
      var realNames = {};
      var dataViewCtorString = toSource(DataView2), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
      var symbolProto = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1, symbolToString2 = symbolProto ? symbolProto.toString : undefined$1;
      function lodash2(value) {
        if (isObjectLike(value) && !isArray2(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty2.call(value, "__wrapped__")) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      var baseCreate = function() {
        function object2() {
        }
        return function(proto2) {
          if (!isObject2(proto2)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto2);
          }
          object2.prototype = proto2;
          var result3 = new object2();
          object2.prototype = undefined$1;
          return result3;
        };
      }();
      function baseLodash() {
      }
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }
      lodash2.templateSettings = {
        "escape": reEscape,
        "evaluate": reEvaluate,
        "interpolate": reInterpolate,
        "variable": "",
        "imports": {
          "_": lodash2
        }
      };
      lodash2.prototype = baseLodash.prototype;
      lodash2.prototype.constructor = lodash2;
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      function lazyClone() {
        var result3 = new LazyWrapper(this.__wrapped__);
        result3.__actions__ = copyArray(this.__actions__);
        result3.__dir__ = this.__dir__;
        result3.__filtered__ = this.__filtered__;
        result3.__iteratees__ = copyArray(this.__iteratees__);
        result3.__takeCount__ = this.__takeCount__;
        result3.__views__ = copyArray(this.__views__);
        return result3;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result3 = new LazyWrapper(this);
          result3.__dir__ = -1;
          result3.__filtered__ = true;
        } else {
          result3 = this.clone();
          result3.__dir__ *= -1;
        }
        return result3;
      }
      function lazyValue() {
        var array2 = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray2(array2), isRight = dir < 0, arrLength = isArr ? array2.length : 0, view = getView(0, arrLength, this.__views__), start2 = view.start, end = view.end, length = end - start2, index = isRight ? end : start2 - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length && takeCount == length) {
          return baseWrapperValue(array2, this.__actions__);
        }
        var result3 = [];
        outer:
          while (length-- && resIndex < takeCount) {
            index += dir;
            var iterIndex = -1, value = array2[index];
            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed2 = iteratee2(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed2;
              } else if (!computed2) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result3[resIndex++] = value;
          }
        return result3;
      }
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }
      function hashDelete(key) {
        var result3 = this.has(key) && delete this.__data__[key];
        this.size -= result3 ? 1 : 0;
        return result3;
      }
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result3 = data[key];
          return result3 === HASH_UNDEFINED ? undefined$1 : result3;
        }
        return hasOwnProperty2.call(data, key) ? data[key] : undefined$1;
      }
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty2.call(data, key);
      }
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
        return this;
      }
      Hash.prototype.clear = hashClear;
      Hash.prototype["delete"] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;
      function ListCache(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        return index < 0 ? undefined$1 : data[index][1];
      }
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }
      function listCacheSet(key, value) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index][1] = value;
        }
        return this;
      }
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype["delete"] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      function MapCache(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash(),
          "map": new (Map2 || ListCache)(),
          "string": new Hash()
        };
      }
      function mapCacheDelete(key) {
        var result3 = getMapData(this, key)["delete"](key);
        this.size -= result3 ? 1 : 0;
        return result3;
      }
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }
      function mapCacheSet(key, value) {
        var data = getMapData(this, key), size2 = data.size;
        data.set(key, value);
        this.size += data.size == size2 ? 0 : 1;
        return this;
      }
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype["delete"] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      function SetCache(values2) {
        var index = -1, length = values2 == null ? 0 : values2.length;
        this.__data__ = new MapCache();
        while (++index < length) {
          this.add(values2[index]);
        }
      }
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }
      function setCacheHas(value) {
        return this.__data__.has(value);
      }
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;
      function Stack(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
      }
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }
      function stackDelete(key) {
        var data = this.__data__, result3 = data["delete"](key);
        this.size = data.size;
        return result3;
      }
      function stackGet(key) {
        return this.__data__.get(key);
      }
      function stackHas(key) {
        return this.__data__.has(key);
      }
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }
      Stack.prototype.clear = stackClear;
      Stack.prototype["delete"] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer2(value), isType = !isArr && !isArg && !isBuff && isTypedArray2(value), skipIndexes = isArr || isArg || isBuff || isType, result3 = skipIndexes ? baseTimes(value.length, String2) : [], length = result3.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length)))) {
            result3.push(key);
          }
        }
        return result3;
      }
      function arraySample(array2) {
        var length = array2.length;
        return length ? array2[baseRandom(0, length - 1)] : undefined$1;
      }
      function arraySampleSize(array2, n3) {
        return shuffleSelf(copyArray(array2), baseClamp(n3, 0, array2.length));
      }
      function arrayShuffle(array2) {
        return shuffleSelf(copyArray(array2));
      }
      function assignMergeValue(object2, key, value) {
        if (value !== undefined$1 && !eq(object2[key], value) || value === undefined$1 && !(key in object2)) {
          baseAssignValue(object2, key, value);
        }
      }
      function assignValue(object2, key, value) {
        var objValue = object2[key];
        if (!(hasOwnProperty2.call(object2, key) && eq(objValue, value)) || value === undefined$1 && !(key in object2)) {
          baseAssignValue(object2, key, value);
        }
      }
      function assocIndexOf(array2, key) {
        var length = array2.length;
        while (length--) {
          if (eq(array2[length][0], key)) {
            return length;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee2, accumulator) {
        baseEach(collection, function(value, key, collection2) {
          setter(accumulator, value, iteratee2(value), collection2);
        });
        return accumulator;
      }
      function baseAssign(object2, source) {
        return object2 && copyObject(source, keys2(source), object2);
      }
      function baseAssignIn(object2, source) {
        return object2 && copyObject(source, keysIn(source), object2);
      }
      function baseAssignValue(object2, key, value) {
        if (key == "__proto__" && defineProperty) {
          defineProperty(object2, key, {
            "configurable": true,
            "enumerable": true,
            "value": value,
            "writable": true
          });
        } else {
          object2[key] = value;
        }
      }
      function baseAt(object2, paths) {
        var index = -1, length = paths.length, result3 = Array2(length), skip = object2 == null;
        while (++index < length) {
          result3[index] = skip ? undefined$1 : get2(object2, paths[index]);
        }
        return result3;
      }
      function baseClamp(number2, lower, upper) {
        if (number2 === number2) {
          if (upper !== undefined$1) {
            number2 = number2 <= upper ? number2 : upper;
          }
          if (lower !== undefined$1) {
            number2 = number2 >= lower ? number2 : lower;
          }
        }
        return number2;
      }
      function baseClone(value, bitmask, customizer, key, object2, stack) {
        var result3, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result3 = object2 ? customizer(value, key, object2, stack) : customizer(value);
        }
        if (result3 !== undefined$1) {
          return result3;
        }
        if (!isObject2(value)) {
          return value;
        }
        var isArr = isArray2(value);
        if (isArr) {
          result3 = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result3);
          }
        } else {
          var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
          if (isBuffer2(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object2) {
            result3 = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result3, value)) : copySymbols(value, baseAssign(result3, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object2 ? value : {};
            }
            result3 = initCloneByTag(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result3);
        if (isSet(value)) {
          value.forEach(function(subValue) {
            result3.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function(subValue, key2) {
            result3.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys2 : isFlat ? keysIn : keys2;
        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach(props || value, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value[key2];
          }
          assignValue(result3, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
        });
        return result3;
      }
      function baseConforms(source) {
        var props = keys2(source);
        return function(object2) {
          return baseConformsTo(object2, source, props);
        };
      }
      function baseConformsTo(object2, source, props) {
        var length = props.length;
        if (object2 == null) {
          return !length;
        }
        object2 = Object2(object2);
        while (length--) {
          var key = props[length], predicate = source[key], value = object2[key];
          if (value === undefined$1 && !(key in object2) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return setTimeout2(function() {
          func.apply(undefined$1, args);
        }, wait);
      }
      function baseDifference(array2, values2, iteratee2, comparator) {
        var index = -1, includes2 = arrayIncludes, isCommon = true, length = array2.length, result3 = [], valuesLength = values2.length;
        if (!length) {
          return result3;
        }
        if (iteratee2) {
          values2 = arrayMap(values2, baseUnary(iteratee2));
        }
        if (comparator) {
          includes2 = arrayIncludesWith;
          isCommon = false;
        } else if (values2.length >= LARGE_ARRAY_SIZE) {
          includes2 = cacheHas;
          isCommon = false;
          values2 = new SetCache(values2);
        }
        outer:
          while (++index < length) {
            var value = array2[index], computed2 = iteratee2 == null ? value : iteratee2(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed2 === computed2) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values2[valuesIndex] === computed2) {
                  continue outer;
                }
              }
              result3.push(value);
            } else if (!includes2(values2, computed2, comparator)) {
              result3.push(value);
            }
          }
        return result3;
      }
      var baseEach = createBaseEach(baseForOwn);
      var baseEachRight = createBaseEach(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result3 = true;
        baseEach(collection, function(value, index, collection2) {
          result3 = !!predicate(value, index, collection2);
          return result3;
        });
        return result3;
      }
      function baseExtremum(array2, iteratee2, comparator) {
        var index = -1, length = array2.length;
        while (++index < length) {
          var value = array2[index], current = iteratee2(value);
          if (current != null && (computed2 === undefined$1 ? current === current && !isSymbol(current) : comparator(current, computed2))) {
            var computed2 = current, result3 = value;
          }
        }
        return result3;
      }
      function baseFill(array2, value, start2, end) {
        var length = array2.length;
        start2 = toInteger(start2);
        if (start2 < 0) {
          start2 = -start2 > length ? 0 : length + start2;
        }
        end = end === undefined$1 || end > length ? length : toInteger(end);
        if (end < 0) {
          end += length;
        }
        end = start2 > end ? 0 : toLength(end);
        while (start2 < end) {
          array2[start2++] = value;
        }
        return array2;
      }
      function baseFilter(collection, predicate) {
        var result3 = [];
        baseEach(collection, function(value, index, collection2) {
          if (predicate(value, index, collection2)) {
            result3.push(value);
          }
        });
        return result3;
      }
      function baseFlatten(array2, depth, predicate, isStrict, result3) {
        var index = -1, length = array2.length;
        predicate || (predicate = isFlattenable);
        result3 || (result3 = []);
        while (++index < length) {
          var value = array2[index];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten(value, depth - 1, predicate, isStrict, result3);
            } else {
              arrayPush(result3, value);
            }
          } else if (!isStrict) {
            result3[result3.length] = value;
          }
        }
        return result3;
      }
      var baseFor = createBaseFor();
      var baseForRight = createBaseFor(true);
      function baseForOwn(object2, iteratee2) {
        return object2 && baseFor(object2, iteratee2, keys2);
      }
      function baseForOwnRight(object2, iteratee2) {
        return object2 && baseForRight(object2, iteratee2, keys2);
      }
      function baseFunctions(object2, props) {
        return arrayFilter(props, function(key) {
          return isFunction2(object2[key]);
        });
      }
      function baseGet(object2, path) {
        path = castPath(path, object2);
        var index = 0, length = path.length;
        while (object2 != null && index < length) {
          object2 = object2[toKey(path[index++])];
        }
        return index && index == length ? object2 : undefined$1;
      }
      function baseGetAllKeys(object2, keysFunc, symbolsFunc) {
        var result3 = keysFunc(object2);
        return isArray2(object2) ? result3 : arrayPush(result3, symbolsFunc(object2));
      }
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString2(value);
      }
      function baseGt(value, other) {
        return value > other;
      }
      function baseHas(object2, key) {
        return object2 != null && hasOwnProperty2.call(object2, key);
      }
      function baseHasIn(object2, key) {
        return object2 != null && key in Object2(object2);
      }
      function baseInRange(number2, start2, end) {
        return number2 >= nativeMin(start2, end) && number2 < nativeMax(start2, end);
      }
      function baseIntersection(arrays, iteratee2, comparator) {
        var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result3 = [];
        while (othIndex--) {
          var array2 = arrays[othIndex];
          if (othIndex && iteratee2) {
            array2 = arrayMap(array2, baseUnary(iteratee2));
          }
          maxLength = nativeMin(array2.length, maxLength);
          caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array2.length >= 120) ? new SetCache(othIndex && array2) : undefined$1;
        }
        array2 = arrays[0];
        var index = -1, seen = caches[0];
        outer:
          while (++index < length && result3.length < maxLength) {
            var value = array2[index], computed2 = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? cacheHas(seen, computed2) : includes2(result3, computed2, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed2) : includes2(arrays[othIndex], computed2, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed2);
              }
              result3.push(value);
            }
          }
        return result3;
      }
      function baseInverter(object2, setter, iteratee2, accumulator) {
        baseForOwn(object2, function(value, key, object3) {
          setter(accumulator, iteratee2(value), key, object3);
        });
        return accumulator;
      }
      function baseInvoke(object2, path, args) {
        path = castPath(path, object2);
        object2 = parent2(object2, path);
        var func = object2 == null ? object2 : object2[toKey(last(path))];
        return func == null ? undefined$1 : apply(func, object2, args);
      }
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }
      function baseIsArrayBuffer(value) {
        return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
      }
      function baseIsDate(value) {
        return isObjectLike(value) && baseGetTag(value) == dateTag;
      }
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }
      function baseIsEqualDeep(object2, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray2(object2), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object2), othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer2(object2)) {
          if (!isBuffer2(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray2(object2) ? equalArrays(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag(object2, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty2.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack());
        return equalObjects(object2, other, bitmask, customizer, equalFunc, stack);
      }
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }
      function baseIsMatch(object2, source, matchData, customizer) {
        var index = matchData.length, length = index, noCustomizer = !customizer;
        if (object2 == null) {
          return !length;
        }
        object2 = Object2(object2);
        while (index--) {
          var data = matchData[index];
          if (noCustomizer && data[2] ? data[1] !== object2[data[0]] : !(data[0] in object2)) {
            return false;
          }
        }
        while (++index < length) {
          data = matchData[index];
          var key = data[0], objValue = object2[key], srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object2)) {
              return false;
            }
          } else {
            var stack = new Stack();
            if (customizer) {
              var result3 = customizer(objValue, srcValue, key, object2, source, stack);
            }
            if (!(result3 === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result3)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative(value) {
        if (!isObject2(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction2(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }
      function baseIsRegExp(value) {
        return isObjectLike(value) && baseGetTag(value) == regexpTag;
      }
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }
      function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }
      function baseIteratee(value) {
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == "object") {
          return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }
        return property(value);
      }
      function baseKeys(object2) {
        if (!isPrototype(object2)) {
          return nativeKeys(object2);
        }
        var result3 = [];
        for (var key in Object2(object2)) {
          if (hasOwnProperty2.call(object2, key) && key != "constructor") {
            result3.push(key);
          }
        }
        return result3;
      }
      function baseKeysIn(object2) {
        if (!isObject2(object2)) {
          return nativeKeysIn(object2);
        }
        var isProto = isPrototype(object2), result3 = [];
        for (var key in object2) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object2, key)))) {
            result3.push(key);
          }
        }
        return result3;
      }
      function baseLt(value, other) {
        return value < other;
      }
      function baseMap(collection, iteratee2) {
        var index = -1, result3 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value, key, collection2) {
          result3[++index] = iteratee2(value, key, collection2);
        });
        return result3;
      }
      function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function(object2) {
          return object2 === source || baseIsMatch(object2, source, matchData);
        };
      }
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function(object2) {
          var objValue = get2(object2, path);
          return objValue === undefined$1 && objValue === srcValue ? hasIn(object2, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }
      function baseMerge(object2, source, srcIndex, customizer, stack) {
        if (object2 === source) {
          return;
        }
        baseFor(source, function(srcValue, key) {
          stack || (stack = new Stack());
          if (isObject2(srcValue)) {
            baseMergeDeep(object2, source, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet2(object2, key), srcValue, key + "", object2, source, stack) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue(object2, key, newValue);
          }
        }, keysIn);
      }
      function baseMergeDeep(object2, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet2(object2, key), srcValue = safeGet2(source, key), stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object2, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object2, source, stack) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer2(srcValue), isTyped = !isArr && !isBuff && isTypedArray2(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray2(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject2(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject2(objValue) || isFunction2(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack["delete"](srcValue);
        }
        assignMergeValue(object2, key, newValue);
      }
      function baseNth(array2, n3) {
        var length = array2.length;
        if (!length) {
          return;
        }
        n3 += n3 < 0 ? length : 0;
        return isIndex(n3, length) ? array2[n3] : undefined$1;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function(iteratee2) {
            if (isArray2(iteratee2)) {
              return function(value) {
                return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
              };
            }
            return iteratee2;
          });
        } else {
          iteratees = [identity];
        }
        var index = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        var result3 = baseMap(collection, function(value, key, collection2) {
          var criteria = arrayMap(iteratees, function(iteratee2) {
            return iteratee2(value);
          });
          return { "criteria": criteria, "index": ++index, "value": value };
        });
        return baseSortBy(result3, function(object2, other) {
          return compareMultiple(object2, other, orders);
        });
      }
      function basePick(object2, paths) {
        return basePickBy(object2, paths, function(value, path) {
          return hasIn(object2, path);
        });
      }
      function basePickBy(object2, paths, predicate) {
        var index = -1, length = paths.length, result3 = {};
        while (++index < length) {
          var path = paths[index], value = baseGet(object2, path);
          if (predicate(value, path)) {
            baseSet(result3, castPath(path, object2), value);
          }
        }
        return result3;
      }
      function basePropertyDeep(path) {
        return function(object2) {
          return baseGet(object2, path);
        };
      }
      function basePullAll(array2, values2, iteratee2, comparator) {
        var indexOf3 = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values2.length, seen = array2;
        if (array2 === values2) {
          values2 = copyArray(values2);
        }
        if (iteratee2) {
          seen = arrayMap(array2, baseUnary(iteratee2));
        }
        while (++index < length) {
          var fromIndex = 0, value = values2[index], computed2 = iteratee2 ? iteratee2(value) : value;
          while ((fromIndex = indexOf3(seen, computed2, fromIndex, comparator)) > -1) {
            if (seen !== array2) {
              splice.call(seen, fromIndex, 1);
            }
            splice.call(array2, fromIndex, 1);
          }
        }
        return array2;
      }
      function basePullAt(array2, indexes) {
        var length = array2 ? indexes.length : 0, lastIndex = length - 1;
        while (length--) {
          var index = indexes[length];
          if (length == lastIndex || index !== previous) {
            var previous = index;
            if (isIndex(index)) {
              splice.call(array2, index, 1);
            } else {
              baseUnset(array2, index);
            }
          }
        }
        return array2;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start2, end, step, fromRight) {
        var index = -1, length = nativeMax(nativeCeil((end - start2) / (step || 1)), 0), result3 = Array2(length);
        while (length--) {
          result3[fromRight ? length : ++index] = start2;
          start2 += step;
        }
        return result3;
      }
      function baseRepeat(string2, n3) {
        var result3 = "";
        if (!string2 || n3 < 1 || n3 > MAX_SAFE_INTEGER) {
          return result3;
        }
        do {
          if (n3 % 2) {
            result3 += string2;
          }
          n3 = nativeFloor(n3 / 2);
          if (n3) {
            string2 += string2;
          }
        } while (n3);
        return result3;
      }
      function baseRest(func, start2) {
        return setToString(overRest(func, start2, identity), func + "");
      }
      function baseSample(collection) {
        return arraySample(values(collection));
      }
      function baseSampleSize(collection, n3) {
        var array2 = values(collection);
        return shuffleSelf(array2, baseClamp(n3, 0, array2.length));
      }
      function baseSet(object2, path, value, customizer) {
        if (!isObject2(object2)) {
          return object2;
        }
        path = castPath(path, object2);
        var index = -1, length = path.length, lastIndex = length - 1, nested = object2;
        while (nested != null && ++index < length) {
          var key = toKey(path[index]), newValue = value;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object2;
          }
          if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject2(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object2;
      }
      var baseSetData = !metaMap ? identity : function(func, data) {
        metaMap.set(func, data);
        return func;
      };
      var baseSetToString = !defineProperty ? identity : function(func, string2) {
        return defineProperty(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant(string2),
          "writable": true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }
      function baseSlice(array2, start2, end) {
        var index = -1, length = array2.length;
        if (start2 < 0) {
          start2 = -start2 > length ? 0 : length + start2;
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start2 > end ? 0 : end - start2 >>> 0;
        start2 >>>= 0;
        var result3 = Array2(length);
        while (++index < length) {
          result3[index] = array2[index + start2];
        }
        return result3;
      }
      function baseSome(collection, predicate) {
        var result3;
        baseEach(collection, function(value, index, collection2) {
          result3 = predicate(value, index, collection2);
          return !result3;
        });
        return !!result3;
      }
      function baseSortedIndex(array2, value, retHighest) {
        var low = 0, high = array2 == null ? low : array2.length;
        if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1, computed2 = array2[mid];
            if (computed2 !== null && !isSymbol(computed2) && (retHighest ? computed2 <= value : computed2 < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array2, value, identity, retHighest);
      }
      function baseSortedIndexBy(array2, value, iteratee2, retHighest) {
        var low = 0, high = array2 == null ? 0 : array2.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee2(value);
        var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2), computed2 = iteratee2(array2[mid]), othIsDefined = computed2 !== undefined$1, othIsNull = computed2 === null, othIsReflexive = computed2 === computed2, othIsSymbol = isSymbol(computed2);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed2 <= value : computed2 < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array2, iteratee2) {
        var index = -1, length = array2.length, resIndex = 0, result3 = [];
        while (++index < length) {
          var value = array2[index], computed2 = iteratee2 ? iteratee2(value) : value;
          if (!index || !eq(computed2, seen)) {
            var seen = computed2;
            result3[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result3;
      }
      function baseToNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        return +value;
      }
      function baseToString(value) {
        if (typeof value == "string") {
          return value;
        }
        if (isArray2(value)) {
          return arrayMap(value, baseToString) + "";
        }
        if (isSymbol(value)) {
          return symbolToString2 ? symbolToString2.call(value) : "";
        }
        var result3 = value + "";
        return result3 == "0" && 1 / value == -INFINITY ? "-0" : result3;
      }
      function baseUniq(array2, iteratee2, comparator) {
        var index = -1, includes2 = arrayIncludes, length = array2.length, isCommon = true, result3 = [], seen = result3;
        if (comparator) {
          isCommon = false;
          includes2 = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE) {
          var set3 = iteratee2 ? null : createSet(array2);
          if (set3) {
            return setToArray(set3);
          }
          isCommon = false;
          includes2 = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee2 ? [] : result3;
        }
        outer:
          while (++index < length) {
            var value = array2[index], computed2 = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed2 === computed2) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed2) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed2);
              }
              result3.push(value);
            } else if (!includes2(seen, computed2, comparator)) {
              if (seen !== result3) {
                seen.push(computed2);
              }
              result3.push(value);
            }
          }
        return result3;
      }
      function baseUnset(object2, path) {
        path = castPath(path, object2);
        object2 = parent2(object2, path);
        return object2 == null || delete object2[toKey(last(path))];
      }
      function baseUpdate(object2, path, updater, customizer) {
        return baseSet(object2, path, updater(baseGet(object2, path)), customizer);
      }
      function baseWhile(array2, predicate, isDrop, fromRight) {
        var length = array2.length, index = fromRight ? length : -1;
        while ((fromRight ? index-- : ++index < length) && predicate(array2[index], index, array2)) {
        }
        return isDrop ? baseSlice(array2, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array2, fromRight ? index + 1 : 0, fromRight ? length : index);
      }
      function baseWrapperValue(value, actions) {
        var result3 = value;
        if (result3 instanceof LazyWrapper) {
          result3 = result3.value();
        }
        return arrayReduce(actions, function(result4, action) {
          return action.func.apply(action.thisArg, arrayPush([result4], action.args));
        }, result3);
      }
      function baseXor(arrays, iteratee2, comparator) {
        var length = arrays.length;
        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }
        var index = -1, result3 = Array2(length);
        while (++index < length) {
          var array2 = arrays[index], othIndex = -1;
          while (++othIndex < length) {
            if (othIndex != index) {
              result3[index] = baseDifference(result3[index] || array2, arrays[othIndex], iteratee2, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result3, 1), iteratee2, comparator);
      }
      function baseZipObject(props, values2, assignFunc) {
        var index = -1, length = props.length, valsLength = values2.length, result3 = {};
        while (++index < length) {
          var value = index < valsLength ? values2[index] : undefined$1;
          assignFunc(result3, props[index], value);
        }
        return result3;
      }
      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }
      function castFunction(value) {
        return typeof value == "function" ? value : identity;
      }
      function castPath(value, object2) {
        if (isArray2(value)) {
          return value;
        }
        return isKey(value, object2) ? [value] : stringToPath(toString3(value));
      }
      var castRest = baseRest;
      function castSlice(array2, start2, end) {
        var length = array2.length;
        end = end === undefined$1 ? length : end;
        return !start2 && end >= length ? array2 : baseSlice(array2, start2, end);
      }
      var clearTimeout2 = ctxClearTimeout || function(id2) {
        return root.clearTimeout(id2);
      };
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length, result3 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result3);
        return result3;
      }
      function cloneArrayBuffer(arrayBuffer) {
        var result3 = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array2(result3).set(new Uint8Array2(arrayBuffer));
        return result3;
      }
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp(regexp) {
        var result3 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result3.lastIndex = regexp.lastIndex;
        return result3;
      }
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
      }
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
          var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object2, other, orders) {
        var index = -1, objCriteria = object2.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
        while (++index < length) {
          var result3 = compareAscending(objCriteria[index], othCriteria[index]);
          if (result3) {
            if (index >= ordersLength) {
              return result3;
            }
            var order = orders[index];
            return result3 * (order == "desc" ? -1 : 1);
          }
        }
        return object2.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result3 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result3[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result3[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result3[leftIndex++] = args[argsIndex++];
        }
        return result3;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result3 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result3[argsIndex] = args[argsIndex];
        }
        var offset2 = argsIndex;
        while (++rightIndex < rightLength) {
          result3[offset2 + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result3[offset2 + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result3;
      }
      function copyArray(source, array2) {
        var index = -1, length = source.length;
        array2 || (array2 = Array2(length));
        while (++index < length) {
          array2[index] = source[index];
        }
        return array2;
      }
      function copyObject(source, props, object2, customizer) {
        var isNew = !object2;
        object2 || (object2 = {});
        var index = -1, length = props.length;
        while (++index < length) {
          var key = props[index];
          var newValue = customizer ? customizer(object2[key], source[key], key, object2, source) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object2, key, newValue);
          } else {
            assignValue(object2, key, newValue);
          }
        }
        return object2;
      }
      function copySymbols(source, object2) {
        return copyObject(source, getSymbols(source), object2);
      }
      function copySymbolsIn(source, object2) {
        return copyObject(source, getSymbolsIn(source), object2);
      }
      function createAggregator(setter, initializer) {
        return function(collection, iteratee2) {
          var func = isArray2(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
        };
      }
      function createAssigner(assigner) {
        return baseRest(function(object2, sources) {
          var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined$1, guard = length > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined$1 : customizer;
            length = 1;
          }
          object2 = Object2(object2);
          while (++index < length) {
            var source = sources[index];
            if (source) {
              assigner(object2, source, index, customizer);
            }
          }
          return object2;
        });
      }
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee2) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee2);
          }
          var length = collection.length, index = fromRight ? length : -1, iterable = Object2(collection);
          while (fromRight ? index-- : ++index < length) {
            if (iteratee2(iterable[index], index, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor(fromRight) {
        return function(object2, iteratee2, keysFunc) {
          var index = -1, iterable = Object2(object2), props = keysFunc(object2), length = props.length;
          while (length--) {
            var key = props[fromRight ? length : ++index];
            if (iteratee2(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object2;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var fn2 = this && this !== root && this instanceof wrapper ? Ctor : func;
          return fn2.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst(methodName) {
        return function(string2) {
          string2 = toString3(string2);
          var strSymbols = hasUnicode(string2) ? stringToArray(string2) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string2.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string2.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder(callback) {
        return function(string2) {
          return arrayReduce(words(deburr(string2).replace(reApos, "")), callback, "");
        };
      }
      function createCtor(Ctor) {
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate(Ctor.prototype), result3 = Ctor.apply(thisBinding, args);
          return isObject2(result3) ? result3 : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index = length, placeholder = getHolder(wrapper);
          while (index--) {
            args[index] = arguments[index];
          }
          var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length -= holders.length;
          if (length < arity) {
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined$1, args, holders, undefined$1, undefined$1, arity - length);
          }
          var fn2 = this && this !== root && this instanceof wrapper ? Ctor : func;
          return apply(fn2, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object2(collection);
          if (!isArrayLike(collection)) {
            var iteratee2 = getIteratee(predicate, 3);
            collection = keys2(collection);
            predicate = function(key) {
              return iteratee2(iterable[key], key, iterable);
            };
          }
          var index = findIndexFunc(collection, predicate, fromIndex);
          return index > -1 ? iterable[iteratee2 ? collection[index] : index] : undefined$1;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index--) {
            var func = funcs[index];
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            if (prereq && !wrapper && getFuncName(func) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index = wrapper ? index : length;
          while (++index < length) {
            func = funcs[index];
            var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined$1;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && isArray2(value)) {
              return wrapper.plant(value).value();
            }
            var index2 = 0, result3 = length ? funcs[index2].apply(this, args) : value;
            while (++index2 < length) {
              result3 = funcs[index2].call(this, result3);
            }
            return result3;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index = length;
          while (index--) {
            args[index] = arguments[index];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length -= holdersCount;
          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary2, arity - length);
          }
          var thisBinding = isBind ? thisArg : this, fn2 = isBindKey ? thisBinding[func] : func;
          length = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }
          if (isAry && ary2 < length) {
            args.length = ary2;
          }
          if (this && this !== root && this instanceof wrapper) {
            fn2 = Ctor || createCtor(fn2);
          }
          return fn2.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function(object2, iteratee2) {
          return baseInverter(object2, setter, toIteratee(iteratee2), {});
        };
      }
      function createMathOperation(operator, defaultValue) {
        return function(value, other) {
          var result3;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result3 = value;
          }
          if (other !== undefined$1) {
            if (result3 === undefined$1) {
              return other;
            }
            if (typeof value == "string" || typeof other == "string") {
              value = baseToString(value);
              other = baseToString(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result3 = operator(value, other);
          }
          return result3;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee2) {
              return apply(iteratee2, thisArg, args);
            });
          });
        });
      }
      function createPadding(length, chars) {
        chars = chars === undefined$1 ? " " : baseToString(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }
        var result3 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode(chars) ? castSlice(stringToArray(result3), 0, length).join("") : result3.slice(0, length);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn2 = this && this !== root && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply(fn2, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange(fromRight) {
        return function(start2, end, step) {
          if (step && typeof step != "number" && isIterateeCall(start2, end, step)) {
            end = step = undefined$1;
          }
          start2 = toFinite(start2);
          if (end === undefined$1) {
            end = start2;
            start2 = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$1 ? start2 < end ? 1 : -1 : toFinite(step);
          return baseRange(start2, end, step, fromRight);
        };
      }
      function createRelationalOperation(operator) {
        return function(value, other) {
          if (!(typeof value == "string" && typeof other == "string")) {
            value = toNumber2(value);
            other = toNumber2(other);
          }
          return operator(value, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary2,
          arity
        ];
        var result3 = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result3, newData);
        }
        result3.placeholder = placeholder;
        return setWrapToString(result3, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math2[methodName];
        return function(number2, precision) {
          number2 = toNumber2(number2);
          precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
          if (precision && nativeIsFinite(number2)) {
            var pair = (toString3(number2) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
            pair = (toString3(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
          }
          return func(number2);
        };
      }
      var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop2 : function(values2) {
        return new Set2(values2);
      };
      function createToPairs(keysFunc) {
        return function(object2) {
          var tag = getTag(object2);
          if (tag == mapTag) {
            return mapToArray(object2);
          }
          if (tag == setTag) {
            return setToPairs(object2);
          }
          return baseToPairs(object2, keysFunc(object2));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var length = partials ? partials.length : 0;
        if (!length) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary2 = ary2 === undefined$1 ? ary2 : nativeMax(toInteger(ary2), 0);
        arity = arity === undefined$1 ? arity : toInteger(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials, holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data = isBindKey ? undefined$1 : getData(func);
        var newData = [
          func,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary2,
          arity
        ];
        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result3 = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result3 = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result3 = createPartial(func, bitmask, thisArg, partials);
        } else {
          result3 = createHybrid.apply(undefined$1, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result3, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object2) {
        if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty2.call(object2, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object2, source, stack) {
        if (isObject2(objValue) && isObject2(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack["delete"](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value) {
        return isPlainObject2(value) ? undefined$1 : value;
      }
      function equalArrays(array2, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array2.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array2);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array2;
        }
        var index = -1, result3 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
        stack.set(array2, other);
        stack.set(other, array2);
        while (++index < arrLength) {
          var arrValue = array2[index], othValue = other[index];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index, other, array2, stack) : customizer(arrValue, othValue, index, array2, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result3 = false;
            break;
          }
          if (seen) {
            if (!arraySome(other, function(othValue2, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result3 = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result3 = false;
            break;
          }
        }
        stack["delete"](array2);
        stack["delete"](other);
        return result3;
      }
      function equalByTag(object2, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
              return false;
            }
            object2 = object2.buffer;
            other = other.buffer;
          case arrayBufferTag:
            if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object2), new Uint8Array2(other))) {
              return false;
            }
            return true;
          case boolTag:
          case dateTag:
          case numberTag:
            return eq(+object2, +other);
          case errorTag:
            return object2.name == other.name && object2.message == other.message;
          case regexpTag:
          case stringTag:
            return object2 == other + "";
          case mapTag:
            var convert = mapToArray;
          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object2.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object2);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            stack.set(object2, other);
            var result3 = equalArrays(convert(object2), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object2);
            return result3;
          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object2) == symbolValueOf.call(other);
            }
        }
        return false;
      }
      function equalObjects(object2, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys2(object2), objLength = objProps.length, othProps = getAllKeys2(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index = objLength;
        while (index--) {
          var key = objProps[index];
          if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object2);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object2;
        }
        var result3 = true;
        stack.set(object2, other);
        stack.set(other, object2);
        var skipCtor = isPartial;
        while (++index < objLength) {
          key = objProps[index];
          var objValue = object2[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
          }
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result3 = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result3 && !skipCtor) {
          var objCtor = object2.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result3 = false;
          }
        }
        stack["delete"](object2);
        stack["delete"](other);
        return result3;
      }
      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + "");
      }
      function getAllKeys2(object2) {
        return baseGetAllKeys(object2, keys2, getSymbols);
      }
      function getAllKeysIn(object2) {
        return baseGetAllKeys(object2, keysIn, getSymbolsIn);
      }
      var getData = !metaMap ? noop2 : function(func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result3 = func.name + "", array2 = realNames[result3], length = hasOwnProperty2.call(realNames, result3) ? array2.length : 0;
        while (length--) {
          var data = array2[length], otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result3;
      }
      function getHolder(func) {
        var object2 = hasOwnProperty2.call(lodash2, "placeholder") ? lodash2 : func;
        return object2.placeholder;
      }
      function getIteratee() {
        var result3 = lodash2.iteratee || iteratee;
        result3 = result3 === iteratee ? baseIteratee : result3;
        return arguments.length ? result3(arguments[0], arguments[1]) : result3;
      }
      function getMapData(map3, key) {
        var data = map3.__data__;
        return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
      }
      function getMatchData(object2) {
        var result3 = keys2(object2), length = result3.length;
        while (length--) {
          var key = result3[length], value = object2[key];
          result3[length] = [key, value, isStrictComparable(value)];
        }
        return result3;
      }
      function getNative(object2, key) {
        var value = getValue(object2, key);
        return baseIsNative(value) ? value : undefined$1;
      }
      function getRawTag(value) {
        var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
        try {
          value[symToStringTag] = undefined$1;
          var unmasked = true;
        } catch (e28) {
        }
        var result3 = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result3;
      }
      var getSymbols = !nativeGetSymbols ? stubArray : function(object2) {
        if (object2 == null) {
          return [];
        }
        object2 = Object2(object2);
        return arrayFilter(nativeGetSymbols(object2), function(symbol) {
          return propertyIsEnumerable.call(object2, symbol);
        });
      };
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object2) {
        var result3 = [];
        while (object2) {
          arrayPush(result3, getSymbols(object2));
          object2 = getPrototype(object2);
        }
        return result3;
      };
      var getTag = baseGetTag;
      if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
        getTag = function(value) {
          var result3 = baseGetTag(value), Ctor = result3 == objectTag ? value.constructor : undefined$1, ctorString = Ctor ? toSource(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result3;
        };
      }
      function getView(start2, end, transforms) {
        var index = -1, length = transforms.length;
        while (++index < length) {
          var data = transforms[index], size2 = data.size;
          switch (data.type) {
            case "drop":
              start2 += size2;
              break;
            case "dropRight":
              end -= size2;
              break;
            case "take":
              end = nativeMin(end, start2 + size2);
              break;
            case "takeRight":
              start2 = nativeMax(start2, end - size2);
              break;
          }
        }
        return { "start": start2, "end": end };
      }
      function getWrapDetails(source) {
        var match = source.match(reWrapDetails);
        return match ? match[1].split(reSplitDetails) : [];
      }
      function hasPath(object2, path, hasFunc) {
        path = castPath(path, object2);
        var index = -1, length = path.length, result3 = false;
        while (++index < length) {
          var key = toKey(path[index]);
          if (!(result3 = object2 != null && hasFunc(object2, key))) {
            break;
          }
          object2 = object2[key];
        }
        if (result3 || ++index != length) {
          return result3;
        }
        length = object2 == null ? 0 : object2.length;
        return !!length && isLength(length) && isIndex(key, length) && (isArray2(object2) || isArguments(object2));
      }
      function initCloneArray(array2) {
        var length = array2.length, result3 = new array2.constructor(length);
        if (length && typeof array2[0] == "string" && hasOwnProperty2.call(array2, "index")) {
          result3.index = array2.index;
          result3.input = array2.input;
        }
        return result3;
      }
      function initCloneObject(object2) {
        return typeof object2.constructor == "function" && !isPrototype(object2) ? baseCreate(getPrototype(object2)) : {};
      }
      function initCloneByTag(object2, tag, isDeep) {
        var Ctor = object2.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object2);
          case boolTag:
          case dateTag:
            return new Ctor(+object2);
          case dataViewTag:
            return cloneDataView(object2, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object2, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object2);
          case regexpTag:
            return cloneRegExp(object2);
          case setTag:
            return new Ctor();
          case symbolTag:
            return cloneSymbol(object2);
        }
      }
      function insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) {
          return source;
        }
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length > 2 ? ", " : " ");
        return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
      }
      function isFlattenable(value) {
        return isArray2(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
      }
      function isIterateeCall(value, index, object2) {
        if (!isObject2(object2)) {
          return false;
        }
        var type = typeof index;
        if (type == "number" ? isArrayLike(object2) && isIndex(index, object2.length) : type == "string" && index in object2) {
          return eq(object2[index], value);
        }
        return false;
      }
      function isKey(value, object2) {
        if (isArray2(value)) {
          return false;
        }
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object2 != null && value in Object2(object2);
      }
      function isKeyable(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func), other = lodash2[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }
      var isMaskable = coreJsData ? isFunction2 : stubFalse;
      function isPrototype(value) {
        var Ctor = value && value.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto;
        return value === proto2;
      }
      function isStrictComparable(value) {
        return value === value && !isObject2(value);
      }
      function matchesStrictComparable(key, srcValue) {
        return function(object2) {
          if (object2 == null) {
            return false;
          }
          return object2[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object2));
        };
      }
      function memoizeCapped(func) {
        var result3 = memoize(func, function(key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });
        var cache = result3.cache;
        return result3;
      }
      function mergeData(data, source) {
        var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) {
          data[7] = value;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
        }
        if (data[9] == null) {
          data[9] = source[9];
        }
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
      }
      function nativeKeysIn(object2) {
        var result3 = [];
        if (object2 != null) {
          for (var key in Object2(object2)) {
            result3.push(key);
          }
        }
        return result3;
      }
      function objectToString2(value) {
        return nativeObjectToString.call(value);
      }
      function overRest(func, start2, transform2) {
        start2 = nativeMax(start2 === undefined$1 ? func.length - 1 : start2, 0);
        return function() {
          var args = arguments, index = -1, length = nativeMax(args.length - start2, 0), array2 = Array2(length);
          while (++index < length) {
            array2[index] = args[start2 + index];
          }
          index = -1;
          var otherArgs = Array2(start2 + 1);
          while (++index < start2) {
            otherArgs[index] = args[index];
          }
          otherArgs[start2] = transform2(array2);
          return apply(func, this, otherArgs);
        };
      }
      function parent2(object2, path) {
        return path.length < 2 ? object2 : baseGet(object2, baseSlice(path, 0, -1));
      }
      function reorder(array2, indexes) {
        var arrLength = array2.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array2);
        while (length--) {
          var index = indexes[length];
          array2[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
        }
        return array2;
      }
      function safeGet2(object2, key) {
        if (key === "constructor" && typeof object2[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object2[key];
      }
      var setData = shortOut(baseSetData);
      var setTimeout2 = ctxSetTimeout || function(func, wait) {
        return root.setTimeout(func, wait);
      };
      var setToString = shortOut(baseSetToString);
      function setWrapToString(wrapper, reference, bitmask) {
        var source = reference + "";
        return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }
      function shortOut(func) {
        var count = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }
      function shuffleSelf(array2, size2) {
        var index = -1, length = array2.length, lastIndex = length - 1;
        size2 = size2 === undefined$1 ? length : size2;
        while (++index < size2) {
          var rand = baseRandom(index, lastIndex), value = array2[rand];
          array2[rand] = array2[index];
          array2[index] = value;
        }
        array2.length = size2;
        return array2;
      }
      var stringToPath = memoizeCapped(function(string2) {
        var result3 = [];
        if (string2.charCodeAt(0) === 46) {
          result3.push("");
        }
        string2.replace(rePropName, function(match, number2, quote, subString) {
          result3.push(quote ? subString.replace(reEscapeChar, "$1") : number2 || match);
        });
        return result3;
      });
      function toKey(value) {
        if (typeof value == "string" || isSymbol(value)) {
          return value;
        }
        var result3 = value + "";
        return result3 == "0" && 1 / value == -INFINITY ? "-0" : result3;
      }
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e28) {
          }
          try {
            return func + "";
          } catch (e28) {
          }
        }
        return "";
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function(pair) {
          var value = "_." + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result3 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result3.__actions__ = copyArray(wrapper.__actions__);
        result3.__index__ = wrapper.__index__;
        result3.__values__ = wrapper.__values__;
        return result3;
      }
      function chunk(array2, size2, guard) {
        if (guard ? isIterateeCall(array2, size2, guard) : size2 === undefined$1) {
          size2 = 1;
        } else {
          size2 = nativeMax(toInteger(size2), 0);
        }
        var length = array2 == null ? 0 : array2.length;
        if (!length || size2 < 1) {
          return [];
        }
        var index = 0, resIndex = 0, result3 = Array2(nativeCeil(length / size2));
        while (index < length) {
          result3[resIndex++] = baseSlice(array2, index, index += size2);
        }
        return result3;
      }
      function compact(array2) {
        var index = -1, length = array2 == null ? 0 : array2.length, resIndex = 0, result3 = [];
        while (++index < length) {
          var value = array2[index];
          if (value) {
            result3[resIndex++] = value;
          }
        }
        return result3;
      }
      function concat() {
        var length = arguments.length;
        if (!length) {
          return [];
        }
        var args = Array2(length - 1), array2 = arguments[0], index = length;
        while (index--) {
          args[index - 1] = arguments[index];
        }
        return arrayPush(isArray2(array2) ? copyArray(array2) : [array2], baseFlatten(args, 1));
      }
      var difference = baseRest(function(array2, values2) {
        return isArrayLikeObject(array2) ? baseDifference(array2, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
      });
      var differenceBy = baseRest(function(array2, values2) {
        var iteratee2 = last(values2);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return isArrayLikeObject(array2) ? baseDifference(array2, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
      });
      var differenceWith = baseRest(function(array2, values2) {
        var comparator = last(values2);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject(array2) ? baseDifference(array2, baseFlatten(values2, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
      });
      function drop(array2, n3, guard) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return [];
        }
        n3 = guard || n3 === undefined$1 ? 1 : toInteger(n3);
        return baseSlice(array2, n3 < 0 ? 0 : n3, length);
      }
      function dropRight(array2, n3, guard) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return [];
        }
        n3 = guard || n3 === undefined$1 ? 1 : toInteger(n3);
        n3 = length - n3;
        return baseSlice(array2, 0, n3 < 0 ? 0 : n3);
      }
      function dropRightWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3), true) : [];
      }
      function fill(array2, value, start2, end) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return [];
        }
        if (start2 && typeof start2 != "number" && isIterateeCall(array2, value, start2)) {
          start2 = 0;
          end = length;
        }
        return baseFill(array2, value, start2, end);
      }
      function findIndex(array2, predicate, fromIndex) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseFindIndex(array2, getIteratee(predicate, 3), index);
      }
      function findLastIndex(array2, predicate, fromIndex) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return -1;
        }
        var index = length - 1;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
        }
        return baseFindIndex(array2, getIteratee(predicate, 3), index, true);
      }
      function flatten(array2) {
        var length = array2 == null ? 0 : array2.length;
        return length ? baseFlatten(array2, 1) : [];
      }
      function flattenDeep(array2) {
        var length = array2 == null ? 0 : array2.length;
        return length ? baseFlatten(array2, INFINITY) : [];
      }
      function flattenDepth(array2, depth) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(array2, depth);
      }
      function fromPairs(pairs) {
        var index = -1, length = pairs == null ? 0 : pairs.length, result3 = {};
        while (++index < length) {
          var pair = pairs[index];
          result3[pair[0]] = pair[1];
        }
        return result3;
      }
      function head(array2) {
        return array2 && array2.length ? array2[0] : undefined$1;
      }
      function indexOf2(array2, value, fromIndex) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseIndexOf(array2, value, index);
      }
      function initial(array2) {
        var length = array2 == null ? 0 : array2.length;
        return length ? baseSlice(array2, 0, -1) : [];
      }
      var intersection = baseRest(function(arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        if (iteratee2 === last(mapped)) {
          iteratee2 = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
      });
      var intersectionWith = baseRest(function(arrays) {
        var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });
      function join(array2, separator) {
        return array2 == null ? "" : nativeJoin.call(array2, separator);
      }
      function last(array2) {
        var length = array2 == null ? 0 : array2.length;
        return length ? array2[length - 1] : undefined$1;
      }
      function lastIndexOf(array2, value, fromIndex) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return -1;
        }
        var index = length;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
        }
        return value === value ? strictLastIndexOf(array2, value, index) : baseFindIndex(array2, baseIsNaN, index, true);
      }
      function nth(array2, n3) {
        return array2 && array2.length ? baseNth(array2, toInteger(n3)) : undefined$1;
      }
      var pull = baseRest(pullAll);
      function pullAll(array2, values2) {
        return array2 && array2.length && values2 && values2.length ? basePullAll(array2, values2) : array2;
      }
      function pullAllBy(array2, values2, iteratee2) {
        return array2 && array2.length && values2 && values2.length ? basePullAll(array2, values2, getIteratee(iteratee2, 2)) : array2;
      }
      function pullAllWith(array2, values2, comparator) {
        return array2 && array2.length && values2 && values2.length ? basePullAll(array2, values2, undefined$1, comparator) : array2;
      }
      var pullAt = flatRest(function(array2, indexes) {
        var length = array2 == null ? 0 : array2.length, result3 = baseAt(array2, indexes);
        basePullAt(array2, arrayMap(indexes, function(index) {
          return isIndex(index, length) ? +index : index;
        }).sort(compareAscending));
        return result3;
      });
      function remove2(array2, predicate) {
        var result3 = [];
        if (!(array2 && array2.length)) {
          return result3;
        }
        var index = -1, indexes = [], length = array2.length;
        predicate = getIteratee(predicate, 3);
        while (++index < length) {
          var value = array2[index];
          if (predicate(value, index, array2)) {
            result3.push(value);
            indexes.push(index);
          }
        }
        basePullAt(array2, indexes);
        return result3;
      }
      function reverse(array2) {
        return array2 == null ? array2 : nativeReverse.call(array2);
      }
      function slice(array2, start2, end) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return [];
        }
        if (end && typeof end != "number" && isIterateeCall(array2, start2, end)) {
          start2 = 0;
          end = length;
        } else {
          start2 = start2 == null ? 0 : toInteger(start2);
          end = end === undefined$1 ? length : toInteger(end);
        }
        return baseSlice(array2, start2, end);
      }
      function sortedIndex(array2, value) {
        return baseSortedIndex(array2, value);
      }
      function sortedIndexBy(array2, value, iteratee2) {
        return baseSortedIndexBy(array2, value, getIteratee(iteratee2, 2));
      }
      function sortedIndexOf(array2, value) {
        var length = array2 == null ? 0 : array2.length;
        if (length) {
          var index = baseSortedIndex(array2, value);
          if (index < length && eq(array2[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function sortedLastIndex(array2, value) {
        return baseSortedIndex(array2, value, true);
      }
      function sortedLastIndexBy(array2, value, iteratee2) {
        return baseSortedIndexBy(array2, value, getIteratee(iteratee2, 2), true);
      }
      function sortedLastIndexOf(array2, value) {
        var length = array2 == null ? 0 : array2.length;
        if (length) {
          var index = baseSortedIndex(array2, value, true) - 1;
          if (eq(array2[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function sortedUniq(array2) {
        return array2 && array2.length ? baseSortedUniq(array2) : [];
      }
      function sortedUniqBy(array2, iteratee2) {
        return array2 && array2.length ? baseSortedUniq(array2, getIteratee(iteratee2, 2)) : [];
      }
      function tail(array2) {
        var length = array2 == null ? 0 : array2.length;
        return length ? baseSlice(array2, 1, length) : [];
      }
      function take(array2, n3, guard) {
        if (!(array2 && array2.length)) {
          return [];
        }
        n3 = guard || n3 === undefined$1 ? 1 : toInteger(n3);
        return baseSlice(array2, 0, n3 < 0 ? 0 : n3);
      }
      function takeRight(array2, n3, guard) {
        var length = array2 == null ? 0 : array2.length;
        if (!length) {
          return [];
        }
        n3 = guard || n3 === undefined$1 ? 1 : toInteger(n3);
        n3 = length - n3;
        return baseSlice(array2, n3 < 0 ? 0 : n3, length);
      }
      function takeRightWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest(function(arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });
      var unionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
      });
      var unionWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
      });
      function uniq(array2) {
        return array2 && array2.length ? baseUniq(array2) : [];
      }
      function uniqBy(array2, iteratee2) {
        return array2 && array2.length ? baseUniq(array2, getIteratee(iteratee2, 2)) : [];
      }
      function uniqWith(array2, comparator) {
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return array2 && array2.length ? baseUniq(array2, undefined$1, comparator) : [];
      }
      function unzip(array2) {
        if (!(array2 && array2.length)) {
          return [];
        }
        var length = 0;
        array2 = arrayFilter(array2, function(group) {
          if (isArrayLikeObject(group)) {
            length = nativeMax(group.length, length);
            return true;
          }
        });
        return baseTimes(length, function(index) {
          return arrayMap(array2, baseProperty(index));
        });
      }
      function unzipWith(array2, iteratee2) {
        if (!(array2 && array2.length)) {
          return [];
        }
        var result3 = unzip(array2);
        if (iteratee2 == null) {
          return result3;
        }
        return arrayMap(result3, function(group) {
          return apply(iteratee2, undefined$1, group);
        });
      }
      var without = baseRest(function(array2, values2) {
        return isArrayLikeObject(array2) ? baseDifference(array2, values2) : [];
      });
      var xor = baseRest(function(arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });
      var xorBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
      });
      var xorWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
      });
      var zip = baseRest(unzip);
      function zipObject(props, values2) {
        return baseZipObject(props || [], values2 || [], assignValue);
      }
      function zipObjectDeep(props, values2) {
        return baseZipObject(props || [], values2 || [], baseSet);
      }
      var zipWith = baseRest(function(arrays) {
        var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined$1;
        iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
        return unzipWith(arrays, iteratee2);
      });
      function chain(value) {
        var result3 = lodash2(value);
        result3.__chain__ = true;
        return result3;
      }
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }
      function thru(value, interceptor) {
        return interceptor(value);
      }
      var wrapperAt = flatRest(function(paths) {
        var length = paths.length, start2 = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object2) {
          return baseAt(object2, paths);
        };
        if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start2)) {
          return this.thru(interceptor);
        }
        value = value.slice(start2, +start2 + (length ? 1 : 0));
        value.__actions__.push({
          "func": thru,
          "args": [interceptor],
          "thisArg": undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function(array2) {
          if (length && !array2.length) {
            array2.push(undefined$1);
          }
          return array2;
        });
      });
      function wrapperChain() {
        return chain(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray2(this.value());
        }
        var done = this.__index__ >= this.__values__.length, value = done ? undefined$1 : this.__values__[this.__index__++];
        return { "done": done, "value": value };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value) {
        var result3, parent3 = this;
        while (parent3 instanceof baseLodash) {
          var clone3 = wrapperClone(parent3);
          clone3.__index__ = 0;
          clone3.__values__ = undefined$1;
          if (result3) {
            previous.__wrapped__ = clone3;
          } else {
            result3 = clone3;
          }
          var previous = clone3;
          parent3 = parent3.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result3;
      }
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            "func": thru,
            "args": [reverse],
            "thisArg": undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function(result3, value, key) {
        if (hasOwnProperty2.call(result3, key)) {
          ++result3[key];
        } else {
          baseAssignValue(result3, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func = isArray2(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter2(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find = createFind(findIndex);
      var findLast = createFind(findLastIndex);
      function flatMap(collection, iteratee2) {
        return baseFlatten(map2(collection, iteratee2), 1);
      }
      function flatMapDeep(collection, iteratee2) {
        return baseFlatten(map2(collection, iteratee2), INFINITY);
      }
      function flatMapDepth(collection, iteratee2, depth) {
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(map2(collection, iteratee2), depth);
      }
      function forEach2(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function forEachRight(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee2, 3));
      }
      var groupBy = createAggregator(function(result3, value, key) {
        if (hasOwnProperty2.call(result3, key)) {
          result3[key].push(value);
        } else {
          baseAssignValue(result3, key, [value]);
        }
      });
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString2(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }
      var invokeMap = baseRest(function(collection, path, args) {
        var index = -1, isFunc = typeof path == "function", result3 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value) {
          result3[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
        });
        return result3;
      });
      var keyBy = createAggregator(function(result3, value, key) {
        baseAssignValue(result3, key, value);
      });
      function map2(collection, iteratee2) {
        var func = isArray2(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray2(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray2(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition = createAggregator(function(result3, value, key) {
        result3[key ? 0 : 1].push(value);
      }, function() {
        return [[], []];
      });
      function reduce(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
      }
      function reduceRight(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray2(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n3, guard) {
        if (guard ? isIterateeCall(collection, n3, guard) : n3 === undefined$1) {
          n3 = 1;
        } else {
          n3 = toInteger(n3);
        }
        var func = isArray2(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n3);
      }
      function shuffle(collection) {
        var func = isArray2(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString2(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }
      function some2(collection, predicate, guard) {
        var func = isArray2(collection) ? arraySome : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length = iteratees.length;
        if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });
      var now2 = ctxNow || function() {
        return root.Date.now();
      };
      function after(n3, func) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n3 = toInteger(n3);
        return function() {
          if (--n3 < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n3, guard) {
        n3 = guard ? undefined$1 : n3;
        n3 = func && n3 == null ? func.length : n3;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n3);
      }
      function before(n3, func) {
        var result3;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n3 = toInteger(n3);
        return function() {
          if (--n3 > 0) {
            result3 = func.apply(this, arguments);
          }
          if (n3 <= 1) {
            func = undefined$1;
          }
          return result3;
        };
      }
      var bind2 = baseRest(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind2));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest(function(object2, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object2, partials, holders);
      });
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result3 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result3.placeholder = curry.placeholder;
        return result3;
      }
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result3 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result3.placeholder = curryRight.placeholder;
        return result3;
      }
      function debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result3, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        wait = toNumber2(wait) || 0;
        if (isObject2(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax(toNumber2(options.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result3 = func.apply(thisArg, args);
          return result3;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout2(timerExpired, wait);
          return leading ? invokeFunc(time) : result3;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now2();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout2(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$1;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result3;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout2(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result3 : trailingEdge(now2());
        }
        function debounced() {
          var time = now2(), isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout2(timerId);
              timerId = setTimeout2(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout2(timerExpired, wait);
          }
          return result3;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer3 = baseRest(function(func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest(function(func, wait, args) {
        return baseDelay(func, toNumber2(wait) || 0, args);
      });
      function flip(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize(func, resolver) {
        if (typeof func != "function" || resolver != null && typeof resolver != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var memoized = function() {
          var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
          if (cache.has(key)) {
            return cache.get(key);
          }
          var result3 = func.apply(this, args);
          memoized.cache = cache.set(key, result3) || cache;
          return result3;
        };
        memoized.cache = new (memoize.Cache || MapCache)();
        return memoized;
      }
      memoize.Cache = MapCache;
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once(func) {
        return before(2, func);
      }
      var overArgs = castRest(function(func, transforms) {
        transforms = transforms.length == 1 && isArray2(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest(function(args) {
          var index = -1, length = nativeMin(args.length, funcsLength);
          while (++index < length) {
            args[index] = transforms[index].call(this, args[index]);
          }
          return apply(func, this, args);
        });
      });
      var partial = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest(function(func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });
      function rest(func, start2) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start2 = start2 === undefined$1 ? start2 : toInteger(start2);
        return baseRest(func, start2);
      }
      function spread2(func, start2) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start2 = start2 == null ? 0 : nativeMax(toInteger(start2), 0);
        return baseRest(function(args) {
          var array2 = args[start2], otherArgs = castSlice(args, 0, start2);
          if (array2) {
            arrayPush(otherArgs, array2);
          }
          return apply(func, this, otherArgs);
        });
      }
      function throttle2(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        if (isObject2(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        return debounce(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray2(value) ? value : [value];
      }
      function clone2(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }
      function cloneWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
      }
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }
      function conformsTo(object2, source) {
        return source == null || baseConformsTo(object2, source, keys2(source));
      }
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }
      var gt2 = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function(value, other) {
        return value >= other;
      });
      var isArguments = baseIsArguments(function() {
        return arguments;
      }()) ? baseIsArguments : function(value) {
        return isObjectLike(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
      };
      var isArray2 = Array2.isArray;
      var isArrayBuffer2 = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction2(value);
      }
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }
      function isBoolean2(value) {
        return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
      }
      var isBuffer2 = nativeIsBuffer || stubFalse;
      var isDate2 = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
      function isElement(value) {
        return isObjectLike(value) && value.nodeType === 1 && !isPlainObject2(value);
      }
      function isEmpty2(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike(value) && (isArray2(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer2(value) || isTypedArray2(value) || isArguments(value))) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty2.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual(value, other) {
        return baseIsEqual(value, other);
      }
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        var result3 = customizer ? customizer(value, other) : undefined$1;
        return result3 === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result3;
      }
      function isError(value) {
        if (!isObjectLike(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject2(value);
      }
      function isFinite2(value) {
        return typeof value == "number" && nativeIsFinite(value);
      }
      function isFunction2(value) {
        if (!isObject2(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }
      function isInteger(value) {
        return typeof value == "number" && value == toInteger(value);
      }
      function isLength(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      function isObject2(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      function isObjectLike(value) {
        return value != null && typeof value == "object";
      }
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      function isMatch(object2, source) {
        return object2 === source || baseIsMatch(object2, source, getMatchData(source));
      }
      function isMatchWith(object2, source, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseIsMatch(object2, source, getMatchData(source), customizer);
      }
      function isNaN2(value) {
        return isNumber2(value) && value != +value;
      }
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error2(CORE_ERROR_TEXT);
        }
        return baseIsNative(value);
      }
      function isNull(value) {
        return value === null;
      }
      function isNil(value) {
        return value == null;
      }
      function isNumber2(value) {
        return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
      }
      function isPlainObject2(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto2 = getPrototype(value);
        if (proto2 === null) {
          return true;
        }
        var Ctor = hasOwnProperty2.call(proto2, "constructor") && proto2.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }
      var isRegExp2 = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
      }
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      function isString2(value) {
        return typeof value == "string" || !isArray2(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
      }
      function isSymbol(value) {
        return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
      }
      var isTypedArray2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      function isUndefined2(value) {
        return value === undefined$1;
      }
      function isWeakMap(value) {
        return isObjectLike(value) && getTag(value) == weakMapTag;
      }
      function isWeakSet(value) {
        return isObjectLike(value) && baseGetTag(value) == weakSetTag;
      }
      var lt2 = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function(value, other) {
        return value <= other;
      });
      function toArray2(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike(value)) {
          return isString2(value) ? stringToArray(value) : copyArray(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
        return func(value);
      }
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber2(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign2 = value < 0 ? -1 : 1;
          return sign2 * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }
      function toInteger(value) {
        var result3 = toFinite(value), remainder = result3 % 1;
        return result3 === result3 ? remainder ? result3 - remainder : result3 : 0;
      }
      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }
      function toNumber2(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject2(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject2(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }
      function toSafeInteger(value) {
        return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
      }
      function toString3(value) {
        return value == null ? "" : baseToString(value);
      }
      var assign2 = createAssigner(function(object2, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys2(source), object2);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty2.call(source, key)) {
            assignValue(object2, key, source[key]);
          }
        }
      });
      var assignIn = createAssigner(function(object2, source) {
        copyObject(source, keysIn(source), object2);
      });
      var assignInWith = createAssigner(function(object2, source, srcIndex, customizer) {
        copyObject(source, keysIn(source), object2, customizer);
      });
      var assignWith = createAssigner(function(object2, source, srcIndex, customizer) {
        copyObject(source, keys2(source), object2, customizer);
      });
      var at2 = flatRest(baseAt);
      function create(prototype2, properties) {
        var result3 = baseCreate(prototype2);
        return properties == null ? result3 : baseAssign(result3, properties);
      }
      var defaults2 = baseRest(function(object2, sources) {
        object2 = Object2(object2);
        var index = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined$1;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          var props = keysIn(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object2[key];
            if (value === undefined$1 || eq(value, objectProto[key]) && !hasOwnProperty2.call(object2, key)) {
              object2[key] = source[key];
            }
          }
        }
        return object2;
      });
      var defaultsDeep = baseRest(function(args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply(mergeWith, undefined$1, args);
      });
      function findKey2(object2, predicate) {
        return baseFindKey(object2, getIteratee(predicate, 3), baseForOwn);
      }
      function findLastKey(object2, predicate) {
        return baseFindKey(object2, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object2, iteratee2) {
        return object2 == null ? object2 : baseFor(object2, getIteratee(iteratee2, 3), keysIn);
      }
      function forInRight(object2, iteratee2) {
        return object2 == null ? object2 : baseForRight(object2, getIteratee(iteratee2, 3), keysIn);
      }
      function forOwn(object2, iteratee2) {
        return object2 && baseForOwn(object2, getIteratee(iteratee2, 3));
      }
      function forOwnRight(object2, iteratee2) {
        return object2 && baseForOwnRight(object2, getIteratee(iteratee2, 3));
      }
      function functions(object2) {
        return object2 == null ? [] : baseFunctions(object2, keys2(object2));
      }
      function functionsIn(object2) {
        return object2 == null ? [] : baseFunctions(object2, keysIn(object2));
      }
      function get2(object2, path, defaultValue) {
        var result3 = object2 == null ? undefined$1 : baseGet(object2, path);
        return result3 === undefined$1 ? defaultValue : result3;
      }
      function has(object2, path) {
        return object2 != null && hasPath(object2, path, baseHas);
      }
      function hasIn(object2, path) {
        return object2 != null && hasPath(object2, path, baseHasIn);
      }
      var invert = createInverter(function(result3, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        result3[value] = key;
      }, constant(identity));
      var invertBy = createInverter(function(result3, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        if (hasOwnProperty2.call(result3, value)) {
          result3[value].push(key);
        } else {
          result3[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest(baseInvoke);
      function keys2(object2) {
        return isArrayLike(object2) ? arrayLikeKeys(object2) : baseKeys(object2);
      }
      function keysIn(object2) {
        return isArrayLike(object2) ? arrayLikeKeys(object2, true) : baseKeysIn(object2);
      }
      function mapKeys(object2, iteratee2) {
        var result3 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object2, function(value, key, object3) {
          baseAssignValue(result3, iteratee2(value, key, object3), value);
        });
        return result3;
      }
      function mapValues2(object2, iteratee2) {
        var result3 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object2, function(value, key, object3) {
          baseAssignValue(result3, key, iteratee2(value, key, object3));
        });
        return result3;
      }
      var merge2 = createAssigner(function(object2, source, srcIndex) {
        baseMerge(object2, source, srcIndex);
      });
      var mergeWith = createAssigner(function(object2, source, srcIndex, customizer) {
        baseMerge(object2, source, srcIndex, customizer);
      });
      var omit = flatRest(function(object2, paths) {
        var result3 = {};
        if (object2 == null) {
          return result3;
        }
        var isDeep = false;
        paths = arrayMap(paths, function(path) {
          path = castPath(path, object2);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object2, getAllKeysIn(object2), result3);
        if (isDeep) {
          result3 = baseClone(result3, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length = paths.length;
        while (length--) {
          baseUnset(result3, paths[length]);
        }
        return result3;
      });
      function omitBy(object2, predicate) {
        return pickBy2(object2, negate(getIteratee(predicate)));
      }
      var pick = flatRest(function(object2, paths) {
        return object2 == null ? {} : basePick(object2, paths);
      });
      function pickBy2(object2, predicate) {
        if (object2 == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object2), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object2, props, function(value, path) {
          return predicate(value, path[0]);
        });
      }
      function result2(object2, path, defaultValue) {
        path = castPath(path, object2);
        var index = -1, length = path.length;
        if (!length) {
          length = 1;
          object2 = undefined$1;
        }
        while (++index < length) {
          var value = object2 == null ? undefined$1 : object2[toKey(path[index])];
          if (value === undefined$1) {
            index = length;
            value = defaultValue;
          }
          object2 = isFunction2(value) ? value.call(object2) : value;
        }
        return object2;
      }
      function set2(object2, path, value) {
        return object2 == null ? object2 : baseSet(object2, path, value);
      }
      function setWith(object2, path, value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object2 == null ? object2 : baseSet(object2, path, value, customizer);
      }
      var toPairs = createToPairs(keys2);
      var toPairsIn = createToPairs(keysIn);
      function transform(object2, iteratee2, accumulator) {
        var isArr = isArray2(object2), isArrLike = isArr || isBuffer2(object2) || isTypedArray2(object2);
        iteratee2 = getIteratee(iteratee2, 4);
        if (accumulator == null) {
          var Ctor = object2 && object2.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject2(object2)) {
            accumulator = isFunction2(Ctor) ? baseCreate(getPrototype(object2)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object2, function(value, index, object3) {
          return iteratee2(accumulator, value, index, object3);
        });
        return accumulator;
      }
      function unset(object2, path) {
        return object2 == null ? true : baseUnset(object2, path);
      }
      function update2(object2, path, updater) {
        return object2 == null ? object2 : baseUpdate(object2, path, castFunction(updater));
      }
      function updateWith(object2, path, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object2 == null ? object2 : baseUpdate(object2, path, castFunction(updater), customizer);
      }
      function values(object2) {
        return object2 == null ? [] : baseValues(object2, keys2(object2));
      }
      function valuesIn(object2) {
        return object2 == null ? [] : baseValues(object2, keysIn(object2));
      }
      function clamp(number2, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber2(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber2(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber2(number2), lower, upper);
      }
      function inRange(number2, start2, end) {
        start2 = toFinite(start2);
        if (end === undefined$1) {
          end = start2;
          start2 = 0;
        } else {
          end = toFinite(end);
        }
        number2 = toNumber2(number2);
        return baseInRange(number2, start2, end);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase = createCompounder(function(result3, word, index) {
        word = word.toLowerCase();
        return result3 + (index ? capitalize(word) : word);
      });
      function capitalize(string2) {
        return upperFirst(toString3(string2).toLowerCase());
      }
      function deburr(string2) {
        string2 = toString3(string2);
        return string2 && string2.replace(reLatin, deburrLetter).replace(reComboMark, "");
      }
      function endsWith2(string2, target, position) {
        string2 = toString3(string2);
        target = baseToString(target);
        var length = string2.length;
        position = position === undefined$1 ? length : baseClamp(toInteger(position), 0, length);
        var end = position;
        position -= target.length;
        return position >= 0 && string2.slice(position, end) == target;
      }
      function escape2(string2) {
        string2 = toString3(string2);
        return string2 && reHasUnescapedHtml.test(string2) ? string2.replace(reUnescapedHtml, escapeHtmlChar) : string2;
      }
      function escapeRegExp(string2) {
        string2 = toString3(string2);
        return string2 && reHasRegExpChar.test(string2) ? string2.replace(reRegExpChar, "\\$&") : string2;
      }
      var kebabCase = createCompounder(function(result3, word, index) {
        return result3 + (index ? "-" : "") + word.toLowerCase();
      });
      var lowerCase = createCompounder(function(result3, word, index) {
        return result3 + (index ? " " : "") + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst("toLowerCase");
      function pad(string2, length, chars) {
        string2 = toString3(string2);
        length = toInteger(length);
        var strLength = length ? stringSize(string2) : 0;
        if (!length || strLength >= length) {
          return string2;
        }
        var mid = (length - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string2 + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string2, length, chars) {
        string2 = toString3(string2);
        length = toInteger(length);
        var strLength = length ? stringSize(string2) : 0;
        return length && strLength < length ? string2 + createPadding(length - strLength, chars) : string2;
      }
      function padStart(string2, length, chars) {
        string2 = toString3(string2);
        length = toInteger(length);
        var strLength = length ? stringSize(string2) : 0;
        return length && strLength < length ? createPadding(length - strLength, chars) + string2 : string2;
      }
      function parseInt2(string2, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString3(string2).replace(reTrimStart, ""), radix || 0);
      }
      function repeat(string2, n3, guard) {
        if (guard ? isIterateeCall(string2, n3, guard) : n3 === undefined$1) {
          n3 = 1;
        } else {
          n3 = toInteger(n3);
        }
        return baseRepeat(toString3(string2), n3);
      }
      function replace() {
        var args = arguments, string2 = toString3(args[0]);
        return args.length < 3 ? string2 : string2.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder(function(result3, word, index) {
        return result3 + (index ? "_" : "") + word.toLowerCase();
      });
      function split2(string2, separator, limit) {
        if (limit && typeof limit != "number" && isIterateeCall(string2, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string2 = toString3(string2);
        if (string2 && (typeof separator == "string" || separator != null && !isRegExp2(separator))) {
          separator = baseToString(separator);
          if (!separator && hasUnicode(string2)) {
            return castSlice(stringToArray(string2), 0, limit);
          }
        }
        return string2.split(separator, limit);
      }
      var startCase = createCompounder(function(result3, word, index) {
        return result3 + (index ? " " : "") + upperFirst(word);
      });
      function startsWith(string2, target, position) {
        string2 = toString3(string2);
        position = position == null ? 0 : baseClamp(toInteger(position), 0, string2.length);
        target = baseToString(target);
        return string2.slice(position, position + target.length) == target;
      }
      function template(string2, options, guard) {
        var settings2 = lodash2.templateSettings;
        if (guard && isIterateeCall(string2, options, guard)) {
          options = undefined$1;
        }
        string2 = toString3(string2);
        options = assignInWith({}, options, settings2, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings2.imports, customDefaultsAssignIn), importsKeys = keys2(imports), importsValues = baseValues(imports, importsKeys);
        var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
        var reDelimiters = RegExp2((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
        var sourceURL = "//# sourceURL=" + (hasOwnProperty2.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
        string2.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset2) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source += string2.slice(index, offset2).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index = offset2 + match.length;
          return match;
        });
        source += "';\n";
        var variable = hasOwnProperty2.call(options, "variable") && options.variable;
        if (!variable) {
          source = "with (obj) {\n" + source + "\n}\n";
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
        source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
        var result3 = attempt(function() {
          return Function2(importsKeys, sourceURL + "return " + source).apply(undefined$1, importsValues);
        });
        result3.source = source;
        if (isError(result3)) {
          throw result3;
        }
        return result3;
      }
      function toLower(value) {
        return toString3(value).toLowerCase();
      }
      function toUpper(value) {
        return toString3(value).toUpperCase();
      }
      function trim2(string2, chars, guard) {
        string2 = toString3(string2);
        if (string2 && (guard || chars === undefined$1)) {
          return baseTrim(string2);
        }
        if (!string2 || !(chars = baseToString(chars))) {
          return string2;
        }
        var strSymbols = stringToArray(string2), chrSymbols = stringToArray(chars), start2 = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start2, end).join("");
      }
      function trimEnd(string2, chars, guard) {
        string2 = toString3(string2);
        if (string2 && (guard || chars === undefined$1)) {
          return string2.slice(0, trimmedEndIndex(string2) + 1);
        }
        if (!string2 || !(chars = baseToString(chars))) {
          return string2;
        }
        var strSymbols = stringToArray(string2), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
        return castSlice(strSymbols, 0, end).join("");
      }
      function trimStart(string2, chars, guard) {
        string2 = toString3(string2);
        if (string2 && (guard || chars === undefined$1)) {
          return string2.replace(reTrimStart, "");
        }
        if (!string2 || !(chars = baseToString(chars))) {
          return string2;
        }
        var strSymbols = stringToArray(string2), start2 = charsStartIndex(strSymbols, stringToArray(chars));
        return castSlice(strSymbols, start2).join("");
      }
      function truncate(string2, options) {
        var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
        if (isObject2(options)) {
          var separator = "separator" in options ? options.separator : separator;
          length = "length" in options ? toInteger(options.length) : length;
          omission = "omission" in options ? baseToString(options.omission) : omission;
        }
        string2 = toString3(string2);
        var strLength = string2.length;
        if (hasUnicode(string2)) {
          var strSymbols = stringToArray(string2);
          strLength = strSymbols.length;
        }
        if (length >= strLength) {
          return string2;
        }
        var end = length - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result3 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string2.slice(0, end);
        if (separator === undefined$1) {
          return result3 + omission;
        }
        if (strSymbols) {
          end += result3.length - end;
        }
        if (isRegExp2(separator)) {
          if (string2.slice(end).search(separator)) {
            var match, substring = result3;
            if (!separator.global) {
              separator = RegExp2(separator.source, toString3(reFlags.exec(separator)) + "g");
            }
            separator.lastIndex = 0;
            while (match = separator.exec(substring)) {
              var newEnd = match.index;
            }
            result3 = result3.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string2.indexOf(baseToString(separator), end) != end) {
          var index = result3.lastIndexOf(separator);
          if (index > -1) {
            result3 = result3.slice(0, index);
          }
        }
        return result3 + omission;
      }
      function unescape2(string2) {
        string2 = toString3(string2);
        return string2 && reHasEscapedHtml.test(string2) ? string2.replace(reEscapedHtml, unescapeHtmlChar) : string2;
      }
      var upperCase = createCompounder(function(result3, word, index) {
        return result3 + (index ? " " : "") + word.toUpperCase();
      });
      var upperFirst = createCaseFirst("toUpperCase");
      function words(string2, pattern, guard) {
        string2 = toString3(string2);
        pattern = guard ? undefined$1 : pattern;
        if (pattern === undefined$1) {
          return hasUnicodeWord(string2) ? unicodeWords(string2) : asciiWords(string2);
        }
        return string2.match(pattern) || [];
      }
      var attempt = baseRest(function(func, args) {
        try {
          return apply(func, undefined$1, args);
        } catch (e28) {
          return isError(e28) ? e28 : new Error2(e28);
        }
      });
      var bindAll = flatRest(function(object2, methodNames) {
        arrayEach(methodNames, function(key) {
          key = toKey(key);
          baseAssignValue(object2, key, bind2(object2[key], object2));
        });
        return object2;
      });
      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
        pairs = !length ? [] : arrayMap(pairs, function(pair) {
          if (typeof pair[1] != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest(function(args) {
          var index = -1;
          while (++index < length) {
            var pair = pairs[index];
            if (apply(pair[0], this, args)) {
              return apply(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source) {
        return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
      }
      function constant(value) {
        return function() {
          return value;
        };
      }
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      var flow = createFlow();
      var flowRight = createFlow(true);
      function identity(value) {
        return value;
      }
      function iteratee(func) {
        return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
      }
      function matches(source) {
        return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
      }
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }
      var method = baseRest(function(path, args) {
        return function(object2) {
          return baseInvoke(object2, path, args);
        };
      });
      var methodOf = baseRest(function(object2, args) {
        return function(path) {
          return baseInvoke(object2, path, args);
        };
      });
      function mixin(object2, source, options) {
        var props = keys2(source), methodNames = baseFunctions(source, props);
        if (options == null && !(isObject2(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object2;
          object2 = this;
          methodNames = baseFunctions(source, keys2(source));
        }
        var chain2 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction2(object2);
        arrayEach(methodNames, function(methodName) {
          var func = source[methodName];
          object2[methodName] = func;
          if (isFunc) {
            object2.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain2 || chainAll) {
                var result3 = object2(this.__wrapped__), actions = result3.__actions__ = copyArray(this.__actions__);
                actions.push({ "func": func, "args": arguments, "thisArg": object2 });
                result3.__chain__ = chainAll;
                return result3;
              }
              return func.apply(object2, arrayPush([this.value()], arguments));
            };
          }
        });
        return object2;
      }
      function noConflict() {
        if (root._ === this) {
          root._ = oldDash;
        }
        return this;
      }
      function noop2() {
      }
      function nthArg(n3) {
        n3 = toInteger(n3);
        return baseRest(function(args) {
          return baseNth(args, n3);
        });
      }
      var over = createOver(arrayMap);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome);
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }
      function propertyOf(object2) {
        return function(path) {
          return object2 == null ? undefined$1 : baseGet(object2, path);
        };
      }
      var range = createRange();
      var rangeRight = createRange(true);
      function stubArray() {
        return [];
      }
      function stubFalse() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return "";
      }
      function stubTrue() {
        return true;
      }
      function times(n3, iteratee2) {
        n3 = toInteger(n3);
        if (n3 < 1 || n3 > MAX_SAFE_INTEGER) {
          return [];
        }
        var index = MAX_ARRAY_LENGTH, length = nativeMin(n3, MAX_ARRAY_LENGTH);
        iteratee2 = getIteratee(iteratee2);
        n3 -= MAX_ARRAY_LENGTH;
        var result3 = baseTimes(length, iteratee2);
        while (++index < n3) {
          iteratee2(index);
        }
        return result3;
      }
      function toPath(value) {
        if (isArray2(value)) {
          return arrayMap(value, toKey);
        }
        return isSymbol(value) ? [value] : copyArray(stringToPath(toString3(value)));
      }
      function uniqueId(prefix) {
        var id2 = ++idCounter;
        return toString3(prefix) + id2;
      }
      var add2 = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound("ceil");
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound("floor");
      function max2(array2) {
        return array2 && array2.length ? baseExtremum(array2, identity, baseGt) : undefined$1;
      }
      function maxBy(array2, iteratee2) {
        return array2 && array2.length ? baseExtremum(array2, getIteratee(iteratee2, 2), baseGt) : undefined$1;
      }
      function mean(array2) {
        return baseMean(array2, identity);
      }
      function meanBy(array2, iteratee2) {
        return baseMean(array2, getIteratee(iteratee2, 2));
      }
      function min2(array2) {
        return array2 && array2.length ? baseExtremum(array2, identity, baseLt) : undefined$1;
      }
      function minBy(array2, iteratee2) {
        return array2 && array2.length ? baseExtremum(array2, getIteratee(iteratee2, 2), baseLt) : undefined$1;
      }
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round2 = createRound("round");
      var subtract2 = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum(array2) {
        return array2 && array2.length ? baseSum(array2, identity) : 0;
      }
      function sumBy(array2, iteratee2) {
        return array2 && array2.length ? baseSum(array2, getIteratee(iteratee2, 2)) : 0;
      }
      lodash2.after = after;
      lodash2.ary = ary;
      lodash2.assign = assign2;
      lodash2.assignIn = assignIn;
      lodash2.assignInWith = assignInWith;
      lodash2.assignWith = assignWith;
      lodash2.at = at2;
      lodash2.before = before;
      lodash2.bind = bind2;
      lodash2.bindAll = bindAll;
      lodash2.bindKey = bindKey;
      lodash2.castArray = castArray;
      lodash2.chain = chain;
      lodash2.chunk = chunk;
      lodash2.compact = compact;
      lodash2.concat = concat;
      lodash2.cond = cond;
      lodash2.conforms = conforms;
      lodash2.constant = constant;
      lodash2.countBy = countBy;
      lodash2.create = create;
      lodash2.curry = curry;
      lodash2.curryRight = curryRight;
      lodash2.debounce = debounce;
      lodash2.defaults = defaults2;
      lodash2.defaultsDeep = defaultsDeep;
      lodash2.defer = defer3;
      lodash2.delay = delay;
      lodash2.difference = difference;
      lodash2.differenceBy = differenceBy;
      lodash2.differenceWith = differenceWith;
      lodash2.drop = drop;
      lodash2.dropRight = dropRight;
      lodash2.dropRightWhile = dropRightWhile;
      lodash2.dropWhile = dropWhile;
      lodash2.fill = fill;
      lodash2.filter = filter2;
      lodash2.flatMap = flatMap;
      lodash2.flatMapDeep = flatMapDeep;
      lodash2.flatMapDepth = flatMapDepth;
      lodash2.flatten = flatten;
      lodash2.flattenDeep = flattenDeep;
      lodash2.flattenDepth = flattenDepth;
      lodash2.flip = flip;
      lodash2.flow = flow;
      lodash2.flowRight = flowRight;
      lodash2.fromPairs = fromPairs;
      lodash2.functions = functions;
      lodash2.functionsIn = functionsIn;
      lodash2.groupBy = groupBy;
      lodash2.initial = initial;
      lodash2.intersection = intersection;
      lodash2.intersectionBy = intersectionBy;
      lodash2.intersectionWith = intersectionWith;
      lodash2.invert = invert;
      lodash2.invertBy = invertBy;
      lodash2.invokeMap = invokeMap;
      lodash2.iteratee = iteratee;
      lodash2.keyBy = keyBy;
      lodash2.keys = keys2;
      lodash2.keysIn = keysIn;
      lodash2.map = map2;
      lodash2.mapKeys = mapKeys;
      lodash2.mapValues = mapValues2;
      lodash2.matches = matches;
      lodash2.matchesProperty = matchesProperty;
      lodash2.memoize = memoize;
      lodash2.merge = merge2;
      lodash2.mergeWith = mergeWith;
      lodash2.method = method;
      lodash2.methodOf = methodOf;
      lodash2.mixin = mixin;
      lodash2.negate = negate;
      lodash2.nthArg = nthArg;
      lodash2.omit = omit;
      lodash2.omitBy = omitBy;
      lodash2.once = once;
      lodash2.orderBy = orderBy;
      lodash2.over = over;
      lodash2.overArgs = overArgs;
      lodash2.overEvery = overEvery;
      lodash2.overSome = overSome;
      lodash2.partial = partial;
      lodash2.partialRight = partialRight;
      lodash2.partition = partition;
      lodash2.pick = pick;
      lodash2.pickBy = pickBy2;
      lodash2.property = property;
      lodash2.propertyOf = propertyOf;
      lodash2.pull = pull;
      lodash2.pullAll = pullAll;
      lodash2.pullAllBy = pullAllBy;
      lodash2.pullAllWith = pullAllWith;
      lodash2.pullAt = pullAt;
      lodash2.range = range;
      lodash2.rangeRight = rangeRight;
      lodash2.rearg = rearg;
      lodash2.reject = reject;
      lodash2.remove = remove2;
      lodash2.rest = rest;
      lodash2.reverse = reverse;
      lodash2.sampleSize = sampleSize;
      lodash2.set = set2;
      lodash2.setWith = setWith;
      lodash2.shuffle = shuffle;
      lodash2.slice = slice;
      lodash2.sortBy = sortBy;
      lodash2.sortedUniq = sortedUniq;
      lodash2.sortedUniqBy = sortedUniqBy;
      lodash2.split = split2;
      lodash2.spread = spread2;
      lodash2.tail = tail;
      lodash2.take = take;
      lodash2.takeRight = takeRight;
      lodash2.takeRightWhile = takeRightWhile;
      lodash2.takeWhile = takeWhile;
      lodash2.tap = tap;
      lodash2.throttle = throttle2;
      lodash2.thru = thru;
      lodash2.toArray = toArray2;
      lodash2.toPairs = toPairs;
      lodash2.toPairsIn = toPairsIn;
      lodash2.toPath = toPath;
      lodash2.toPlainObject = toPlainObject;
      lodash2.transform = transform;
      lodash2.unary = unary;
      lodash2.union = union;
      lodash2.unionBy = unionBy;
      lodash2.unionWith = unionWith;
      lodash2.uniq = uniq;
      lodash2.uniqBy = uniqBy;
      lodash2.uniqWith = uniqWith;
      lodash2.unset = unset;
      lodash2.unzip = unzip;
      lodash2.unzipWith = unzipWith;
      lodash2.update = update2;
      lodash2.updateWith = updateWith;
      lodash2.values = values;
      lodash2.valuesIn = valuesIn;
      lodash2.without = without;
      lodash2.words = words;
      lodash2.wrap = wrap;
      lodash2.xor = xor;
      lodash2.xorBy = xorBy;
      lodash2.xorWith = xorWith;
      lodash2.zip = zip;
      lodash2.zipObject = zipObject;
      lodash2.zipObjectDeep = zipObjectDeep;
      lodash2.zipWith = zipWith;
      lodash2.entries = toPairs;
      lodash2.entriesIn = toPairsIn;
      lodash2.extend = assignIn;
      lodash2.extendWith = assignInWith;
      mixin(lodash2, lodash2);
      lodash2.add = add2;
      lodash2.attempt = attempt;
      lodash2.camelCase = camelCase;
      lodash2.capitalize = capitalize;
      lodash2.ceil = ceil;
      lodash2.clamp = clamp;
      lodash2.clone = clone2;
      lodash2.cloneDeep = cloneDeep;
      lodash2.cloneDeepWith = cloneDeepWith;
      lodash2.cloneWith = cloneWith;
      lodash2.conformsTo = conformsTo;
      lodash2.deburr = deburr;
      lodash2.defaultTo = defaultTo;
      lodash2.divide = divide;
      lodash2.endsWith = endsWith2;
      lodash2.eq = eq;
      lodash2.escape = escape2;
      lodash2.escapeRegExp = escapeRegExp;
      lodash2.every = every;
      lodash2.find = find;
      lodash2.findIndex = findIndex;
      lodash2.findKey = findKey2;
      lodash2.findLast = findLast;
      lodash2.findLastIndex = findLastIndex;
      lodash2.findLastKey = findLastKey;
      lodash2.floor = floor;
      lodash2.forEach = forEach2;
      lodash2.forEachRight = forEachRight;
      lodash2.forIn = forIn;
      lodash2.forInRight = forInRight;
      lodash2.forOwn = forOwn;
      lodash2.forOwnRight = forOwnRight;
      lodash2.get = get2;
      lodash2.gt = gt2;
      lodash2.gte = gte;
      lodash2.has = has;
      lodash2.hasIn = hasIn;
      lodash2.head = head;
      lodash2.identity = identity;
      lodash2.includes = includes;
      lodash2.indexOf = indexOf2;
      lodash2.inRange = inRange;
      lodash2.invoke = invoke;
      lodash2.isArguments = isArguments;
      lodash2.isArray = isArray2;
      lodash2.isArrayBuffer = isArrayBuffer2;
      lodash2.isArrayLike = isArrayLike;
      lodash2.isArrayLikeObject = isArrayLikeObject;
      lodash2.isBoolean = isBoolean2;
      lodash2.isBuffer = isBuffer2;
      lodash2.isDate = isDate2;
      lodash2.isElement = isElement;
      lodash2.isEmpty = isEmpty2;
      lodash2.isEqual = isEqual;
      lodash2.isEqualWith = isEqualWith;
      lodash2.isError = isError;
      lodash2.isFinite = isFinite2;
      lodash2.isFunction = isFunction2;
      lodash2.isInteger = isInteger;
      lodash2.isLength = isLength;
      lodash2.isMap = isMap;
      lodash2.isMatch = isMatch;
      lodash2.isMatchWith = isMatchWith;
      lodash2.isNaN = isNaN2;
      lodash2.isNative = isNative;
      lodash2.isNil = isNil;
      lodash2.isNull = isNull;
      lodash2.isNumber = isNumber2;
      lodash2.isObject = isObject2;
      lodash2.isObjectLike = isObjectLike;
      lodash2.isPlainObject = isPlainObject2;
      lodash2.isRegExp = isRegExp2;
      lodash2.isSafeInteger = isSafeInteger;
      lodash2.isSet = isSet;
      lodash2.isString = isString2;
      lodash2.isSymbol = isSymbol;
      lodash2.isTypedArray = isTypedArray2;
      lodash2.isUndefined = isUndefined2;
      lodash2.isWeakMap = isWeakMap;
      lodash2.isWeakSet = isWeakSet;
      lodash2.join = join;
      lodash2.kebabCase = kebabCase;
      lodash2.last = last;
      lodash2.lastIndexOf = lastIndexOf;
      lodash2.lowerCase = lowerCase;
      lodash2.lowerFirst = lowerFirst;
      lodash2.lt = lt2;
      lodash2.lte = lte;
      lodash2.max = max2;
      lodash2.maxBy = maxBy;
      lodash2.mean = mean;
      lodash2.meanBy = meanBy;
      lodash2.min = min2;
      lodash2.minBy = minBy;
      lodash2.stubArray = stubArray;
      lodash2.stubFalse = stubFalse;
      lodash2.stubObject = stubObject;
      lodash2.stubString = stubString;
      lodash2.stubTrue = stubTrue;
      lodash2.multiply = multiply;
      lodash2.nth = nth;
      lodash2.noConflict = noConflict;
      lodash2.noop = noop2;
      lodash2.now = now2;
      lodash2.pad = pad;
      lodash2.padEnd = padEnd;
      lodash2.padStart = padStart;
      lodash2.parseInt = parseInt2;
      lodash2.random = random;
      lodash2.reduce = reduce;
      lodash2.reduceRight = reduceRight;
      lodash2.repeat = repeat;
      lodash2.replace = replace;
      lodash2.result = result2;
      lodash2.round = round2;
      lodash2.runInContext = runInContext2;
      lodash2.sample = sample;
      lodash2.size = size;
      lodash2.snakeCase = snakeCase;
      lodash2.some = some2;
      lodash2.sortedIndex = sortedIndex;
      lodash2.sortedIndexBy = sortedIndexBy;
      lodash2.sortedIndexOf = sortedIndexOf;
      lodash2.sortedLastIndex = sortedLastIndex;
      lodash2.sortedLastIndexBy = sortedLastIndexBy;
      lodash2.sortedLastIndexOf = sortedLastIndexOf;
      lodash2.startCase = startCase;
      lodash2.startsWith = startsWith;
      lodash2.subtract = subtract2;
      lodash2.sum = sum;
      lodash2.sumBy = sumBy;
      lodash2.template = template;
      lodash2.times = times;
      lodash2.toFinite = toFinite;
      lodash2.toInteger = toInteger;
      lodash2.toLength = toLength;
      lodash2.toLower = toLower;
      lodash2.toNumber = toNumber2;
      lodash2.toSafeInteger = toSafeInteger;
      lodash2.toString = toString3;
      lodash2.toUpper = toUpper;
      lodash2.trim = trim2;
      lodash2.trimEnd = trimEnd;
      lodash2.trimStart = trimStart;
      lodash2.truncate = truncate;
      lodash2.unescape = unescape2;
      lodash2.uniqueId = uniqueId;
      lodash2.upperCase = upperCase;
      lodash2.upperFirst = upperFirst;
      lodash2.each = forEach2;
      lodash2.eachRight = forEachRight;
      lodash2.first = head;
      mixin(lodash2, function() {
        var source = {};
        baseForOwn(lodash2, function(func, methodName) {
          if (!hasOwnProperty2.call(lodash2.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }(), { "chain": false });
      lodash2.VERSION = VERSION2;
      arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
        lodash2[methodName].placeholder = lodash2;
      });
      arrayEach(["drop", "take"], function(methodName, index) {
        LazyWrapper.prototype[methodName] = function(n3) {
          n3 = n3 === undefined$1 ? 1 : nativeMax(toInteger(n3), 0);
          var result3 = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
          if (result3.__filtered__) {
            result3.__takeCount__ = nativeMin(n3, result3.__takeCount__);
          } else {
            result3.__views__.push({
              "size": nativeMin(n3, MAX_ARRAY_LENGTH),
              "type": methodName + (result3.__dir__ < 0 ? "Right" : "")
            });
          }
          return result3;
        };
        LazyWrapper.prototype[methodName + "Right"] = function(n3) {
          return this.reverse()[methodName](n3).reverse();
        };
      });
      arrayEach(["filter", "map", "takeWhile"], function(methodName, index) {
        var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function(iteratee2) {
          var result3 = this.clone();
          result3.__iteratees__.push({
            "iteratee": getIteratee(iteratee2, 3),
            "type": type
          });
          result3.__filtered__ = result3.__filtered__ || isFilter;
          return result3;
        };
      });
      arrayEach(["head", "last"], function(methodName, index) {
        var takeName = "take" + (index ? "Right" : "");
        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach(["initial", "tail"], function(methodName, index) {
        var dropName = "drop" + (index ? "" : "Right");
        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function() {
        return this.filter(identity);
      };
      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
        if (typeof path == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value) {
          return baseInvoke(value, path, args);
        });
      });
      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function(start2, end) {
        start2 = toInteger(start2);
        var result3 = this;
        if (result3.__filtered__ && (start2 > 0 || end < 0)) {
          return new LazyWrapper(result3);
        }
        if (start2 < 0) {
          result3 = result3.takeRight(-start2);
        } else if (start2) {
          result3 = result3.drop(start2);
        }
        if (end !== undefined$1) {
          end = toInteger(end);
          result3 = end < 0 ? result3.dropRight(-end) : result3.take(end - start2);
        }
        return result3;
      };
      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH);
      };
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash2.prototype[methodName] = function() {
          var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray2(value);
          var interceptor = function(value2) {
            var result4 = lodashFunc.apply(lodash2, arrayPush([value2], args));
            return isTaker && chainAll ? result4[0] : result4;
          };
          if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result3 = func.apply(value, args);
            result3.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
            return new LodashWrapper(result3, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result3 = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result3.value()[0] : result3.value() : result3;
        };
      });
      arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
        var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash2.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray2(value) ? value : [], args);
          }
          return this[chainName](function(value2) {
            return func.apply(isArray2(value2) ? value2 : [], args);
          });
        };
      });
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash2[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty2.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ "name": methodName, "func": lodashFunc });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        "name": "wrapper",
        "func": undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash2.prototype.at = wrapperAt;
      lodash2.prototype.chain = wrapperChain;
      lodash2.prototype.commit = wrapperCommit;
      lodash2.prototype.next = wrapperNext;
      lodash2.prototype.plant = wrapperPlant;
      lodash2.prototype.reverse = wrapperReverse;
      lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
      lodash2.prototype.first = lodash2.prototype.head;
      if (symIterator) {
        lodash2.prototype[symIterator] = wrapperToIterator;
      }
      return lodash2;
    };
    var _3 = runInContext();
    if (freeModule) {
      (freeModule.exports = _3)._ = _3;
      freeExports._ = _3;
    } else {
      root._ = _3;
    }
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
var rngBrowser = { exports: {} };
var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
  var rnds8 = new Uint8Array(16);
  rngBrowser.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  var rnds = new Array(16);
  rngBrowser.exports = function mathRNG() {
    for (var i = 0, r3; i < 16; i++) {
      if ((i & 3) === 0)
        r3 = Math.random() * 4294967296;
      rnds[i] = r3 >>> ((i & 3) << 3) & 255;
    }
    return rnds;
  };
}
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 256).toString(16).substr(1);
}
function bytesToUuid$2(buf, offset2) {
  var i = offset2 || 0;
  var bth = byteToHex;
  return [
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]],
    "-",
    bth[buf[i++]],
    bth[buf[i++]],
    "-",
    bth[buf[i++]],
    bth[buf[i++]],
    "-",
    bth[buf[i++]],
    bth[buf[i++]],
    "-",
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]]
  ].join("");
}
var bytesToUuid_1 = bytesToUuid$2;
var rng$1 = rngBrowser.exports;
var bytesToUuid$1 = bytesToUuid_1;
var _nodeId;
var _clockseq;
var _lastMSecs = 0;
var _lastNSecs = 0;
function v1$1(options, buf, offset2) {
  var i = buf && offset2 || 0;
  var b3 = buf || [];
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== void 0 ? options.clockseq : _clockseq;
  if (node == null || clockseq == null) {
    var seedBytes = rng$1();
    if (node == null) {
      node = _nodeId = [
        seedBytes[0] | 1,
        seedBytes[1],
        seedBytes[2],
        seedBytes[3],
        seedBytes[4],
        seedBytes[5]
      ];
    }
    if (clockseq == null) {
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
    }
  }
  var msecs = options.msecs !== void 0 ? options.msecs : new Date().getTime();
  var nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs + 1;
  var dt2 = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
  if (dt2 < 0 && options.clockseq === void 0) {
    clockseq = clockseq + 1 & 16383;
  }
  if ((dt2 < 0 || msecs > _lastMSecs) && options.nsecs === void 0) {
    nsecs = 0;
  }
  if (nsecs >= 1e4) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }
  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;
  msecs += 122192928e5;
  var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
  b3[i++] = tl >>> 24 & 255;
  b3[i++] = tl >>> 16 & 255;
  b3[i++] = tl >>> 8 & 255;
  b3[i++] = tl & 255;
  var tmh = msecs / 4294967296 * 1e4 & 268435455;
  b3[i++] = tmh >>> 8 & 255;
  b3[i++] = tmh & 255;
  b3[i++] = tmh >>> 24 & 15 | 16;
  b3[i++] = tmh >>> 16 & 255;
  b3[i++] = clockseq >>> 8 | 128;
  b3[i++] = clockseq & 255;
  for (var n3 = 0; n3 < 6; ++n3) {
    b3[i + n3] = node[n3];
  }
  return buf ? buf : bytesToUuid$1(b3);
}
var v1_1 = v1$1;
var rng = rngBrowser.exports;
var bytesToUuid = bytesToUuid_1;
function v4$1(options, buf, offset2) {
  var i = buf && offset2 || 0;
  if (typeof options == "string") {
    buf = options === "binary" ? new Array(16) : null;
    options = null;
  }
  options = options || {};
  var rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    for (var ii2 = 0; ii2 < 16; ++ii2) {
      buf[i + ii2] = rnds[ii2];
    }
  }
  return buf || bytesToUuid(rnds);
}
var v4_1 = v4$1;
var v1 = v1_1;
var v4 = v4_1;
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
var uuid_1 = uuid;
const FCM$1 = registerPlugin("FCM", {
  web: () => Promise.resolve().then(function() {
    return web$2;
  }).then((m3) => new m3.FCMWeb())
});
const PushNotifications = registerPlugin("PushNotifications", {});
const Browser$1 = registerPlugin("Browser", {
  web: () => Promise.resolve().then(function() {
    return web$1;
  }).then((m3) => new m3.BrowserWeb())
});
var script$1 = defineComponent({
  name: "SingleOtpInput",
  props: {
    inputType: {
      type: String,
      validator: (value) => ["number", "tel", "letter-numeric", "password"].includes(value),
      default: "tel"
    },
    inputmode: {
      type: String,
      default: "numeric"
    },
    value: {
      type: [String, Number]
    },
    separator: {
      type: String
    },
    focus: {
      type: Boolean
    },
    inputClasses: {
      type: [String, Array]
    },
    conditionalClass: {
      type: String
    },
    shouldAutoFocus: {
      type: Boolean
    },
    isLastChild: {
      type: Boolean
    },
    placeholder: {
      type: String
    },
    isDisabled: {
      type: Boolean
    }
  },
  emits: ["on-change", "on-keydown", "on-paste", "on-focus", "on-blur"],
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const model = ref$1(props.value || "");
    const input = ref$1(null);
    const handleOnChange = () => {
      model.value = model.value.toString();
      if (model.value.length > 1) {
        model.value = model.value.slice(0, 1);
      }
      return emit("on-change", model.value);
    };
    const isCodeLetter = (charCode) => charCode >= 65 && charCode <= 90;
    const isCodeNumeric = (charCode) => charCode >= 48 && charCode <= 57 || charCode >= 96 && charCode <= 105;
    const handleOnKeyDown = (event2) => {
      if (props.isDisabled) {
        event2.preventDefault();
      }
      const keyEvent = event2 || window.event;
      const charCode = keyEvent.which ? keyEvent.which : keyEvent.keyCode;
      if (isCodeNumeric(charCode) || props.inputType === "letter-numeric" && isCodeLetter(charCode) || [8, 9, 13, 37, 39, 46, 86].includes(charCode)) {
        emit("on-keydown", event2);
      } else {
        keyEvent.preventDefault();
      }
    };
    const handleOnPaste = (event2) => emit("on-paste", event2);
    const handleOnFocus = () => {
      input.value.select();
      return emit("on-focus");
    };
    const handleOnBlur = () => emit("on-blur");
    watch(() => props.value, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        model.value = newValue;
      }
    });
    watch(() => props.focus, (newFocusValue, oldFocusValue) => {
      if (oldFocusValue !== newFocusValue && input.value && props.focus) {
        input.value.focus();
        input.value.select();
      }
    });
    onMounted(() => {
      if (input.value && props.focus && props.shouldAutoFocus) {
        input.value.focus();
        input.value.select();
      }
    });
    return {
      handleOnChange,
      handleOnKeyDown,
      handleOnPaste,
      handleOnFocus,
      handleOnBlur,
      input,
      model,
      inputTypeValue: props.inputType === "letter-numeric" ? "text" : props.inputType
    };
  }
});
const _hoisted_1$1 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_2$1 = ["type", "inputmode", "placeholder", "disabled"];
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = ["innerHTML"];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$1, [withDirectives(createElementVNode("input", {
    "data-test": "single-input",
    type: _ctx.inputTypeValue,
    inputmode: _ctx.inputmode,
    placeholder: _ctx.placeholder,
    disabled: _ctx.isDisabled,
    ref: "input",
    min: "0",
    max: "9",
    maxlength: "1",
    pattern: "[0-9]",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.model = $event),
    class: normalizeClass([_ctx.inputClasses, _ctx.conditionalClass, {
      "is-complete": _ctx.model
    }]),
    onInput: _cache[1] || (_cache[1] = function() {
      return _ctx.handleOnChange && _ctx.handleOnChange(...arguments);
    }),
    onKeydown: _cache[2] || (_cache[2] = function() {
      return _ctx.handleOnKeyDown && _ctx.handleOnKeyDown(...arguments);
    }),
    onPaste: _cache[3] || (_cache[3] = function() {
      return _ctx.handleOnPaste && _ctx.handleOnPaste(...arguments);
    }),
    onFocus: _cache[4] || (_cache[4] = function() {
      return _ctx.handleOnFocus && _ctx.handleOnFocus(...arguments);
    }),
    onBlur: _cache[5] || (_cache[5] = function() {
      return _ctx.handleOnBlur && _ctx.handleOnBlur(...arguments);
    })
  }, null, 42, _hoisted_2$1), [[vModelDynamic, _ctx.model]]), !_ctx.isLastChild && _ctx.separator ? (openBlock(), createElementBlock("span", _hoisted_3, [createElementVNode("span", {
    innerHTML: _ctx.separator
  }, null, 8, _hoisted_4)])) : createCommentVNode("", true)]);
}
script$1.render = render$1;
const BACKSPACE = 8;
const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;
const DELETE = 46;
var script = /* @__PURE__ */ defineComponent({
  name: "Vue3OtpInput",
  components: {
    SingleOtpInput: script$1
  },
  props: {
    value: {
      type: String,
      default: "",
      required: true
    },
    numInputs: {
      default: 4
    },
    separator: {
      type: String,
      default: "**"
    },
    inputClasses: {
      type: [String, Array]
    },
    conditionalClass: {
      type: Array,
      default: []
    },
    inputType: {
      type: String,
      validator: (value) => ["number", "tel", "letter-numeric", "password"].includes(value)
    },
    inputmode: {
      type: String,
      validator: (value) => ["numeric", "text", "tel", "none"].includes(value),
      default: "numeric"
    },
    shouldAutoFocus: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: Array,
      default: []
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const activeInput = ref$1(0);
    const otp = ref$1([]);
    const oldOtp = ref$1([]);
    watch(() => props.value, (val) => {
      const fill = unref(val).split("");
      otp.value = fill;
    }, {
      immediate: true
    });
    const handleOnFocus = (index) => {
      activeInput.value = index;
    };
    const handleOnBlur = () => {
      activeInput.value = -1;
    };
    const checkFilledAllInputs = () => {
      if (otp.value.join("").length === props.numInputs) {
        emit("update:value", otp.value.join(""));
        return emit("on-complete", otp.value.join(""));
      }
      return "Wait until the user enters the required number of characters";
    };
    const focusInput = (input) => {
      activeInput.value = Math.max(Math.min(props.numInputs - 1, input), 0);
    };
    const focusNextInput = () => {
      focusInput(activeInput.value + 1);
    };
    const focusPrevInput = () => {
      focusInput(activeInput.value - 1);
    };
    const changeCodeAtFocus = (value) => {
      oldOtp.value = Object.assign([], otp.value);
      otp.value[activeInput.value] = value;
      if (oldOtp.value.join("") !== otp.value.join("")) {
        emit("update:value", otp.value.join(""));
        emit("on-change", otp.value.join(""));
        checkFilledAllInputs();
      }
    };
    const handleOnPaste = (event2) => {
      event2.preventDefault();
      const pastedData = event2.clipboardData.getData("text/plain").slice(0, props.numInputs - activeInput.value).split("");
      if (props.inputType === "number" && !pastedData.join("").match(/^\d+$/)) {
        return "Invalid pasted data";
      }
      if (props.inputType === "letter-numeric" && !pastedData.join("").match(/^\w+$/)) {
        return "Invalid pasted data";
      }
      const currentCharsInOtp = otp.value.slice(0, activeInput.value);
      const combinedWithPastedData = currentCharsInOtp.concat(pastedData);
      combinedWithPastedData.slice(0, props.numInputs).forEach(function(value, i) {
        otp.value[i] = value;
      });
      focusInput(combinedWithPastedData.slice(0, props.numInputs).length);
      return checkFilledAllInputs();
    };
    const handleOnChange = (value) => {
      changeCodeAtFocus(value);
      focusNextInput();
    };
    const clearInput = () => {
      if (otp.value.length > 0) {
        emit("update:value", "");
        emit("on-change", "");
      }
      otp.value = [];
      activeInput.value = 0;
    };
    const fillInput = (value) => {
      const fill = value.split("");
      if (fill.length === props.numInputs) {
        otp.value = fill;
        emit("update:value", otp.value.join(""));
        emit("on-complete", otp.value.join(""));
      }
    };
    const handleOnKeyDown = (event2) => {
      switch (event2.keyCode) {
        case BACKSPACE:
          event2.preventDefault();
          changeCodeAtFocus("");
          focusPrevInput();
          break;
        case DELETE:
          event2.preventDefault();
          changeCodeAtFocus("");
          break;
        case LEFT_ARROW:
          event2.preventDefault();
          focusPrevInput();
          break;
        case RIGHT_ARROW:
          event2.preventDefault();
          focusNextInput();
          break;
      }
    };
    return {
      activeInput,
      otp,
      oldOtp,
      clearInput,
      handleOnPaste,
      handleOnKeyDown,
      handleOnBlur,
      changeCodeAtFocus,
      focusInput,
      focusNextInput,
      focusPrevInput,
      handleOnFocus,
      checkFilledAllInputs,
      handleOnChange,
      fillInput
    };
  }
});
const _hoisted_1 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_2 = {
  key: 0,
  autocomplete: "off",
  name: "hidden",
  type: "text",
  style: {
    "display": "none"
  }
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SingleOtpInput = resolveComponent("SingleOtpInput");
  return openBlock(), createElementBlock("div", _hoisted_1, [_ctx.inputType === "password" ? (openBlock(), createElementBlock("input", _hoisted_2)) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.numInputs, (_3, i) => {
    return openBlock(), createBlock(_component_SingleOtpInput, {
      key: i,
      focus: _ctx.activeInput === i,
      value: _ctx.otp[i],
      separator: _ctx.separator,
      "input-type": _ctx.inputType,
      inputmode: _ctx.inputmode,
      "input-classes": _ctx.inputClasses,
      conditionalClass: _ctx.conditionalClass[i],
      "is-last-child": i === _ctx.numInputs - 1,
      "should-auto-focus": _ctx.shouldAutoFocus,
      placeholder: _ctx.placeholder[i],
      "is-disabled": _ctx.isDisabled,
      onOnChange: _ctx.handleOnChange,
      onOnKeydown: _ctx.handleOnKeyDown,
      onOnPaste: _ctx.handleOnPaste,
      onOnFocus: ($event) => _ctx.handleOnFocus(i),
      onOnBlur: _ctx.handleOnBlur
    }, null, 8, ["focus", "value", "separator", "input-type", "inputmode", "input-classes", "conditionalClass", "is-last-child", "should-auto-focus", "placeholder", "is-disabled", "onOnChange", "onOnKeydown", "onOnPaste", "onOnFocus", "onOnBlur"]);
  }), 128))]);
}
script.render = render;
var entry_esm = /* @__PURE__ */ (() => {
  const installable = script;
  installable.install = (app) => {
    app.component("Vue3OtpInput", installable);
  };
  return installable;
})();
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var defer = function defer2() {
  var state = false;
  var callbacks = [];
  var resolve = function resolve2() {
    if (state) {
      return;
    }
    state = true;
    for (var i = 0, len = callbacks.length; i < len; i++) {
      callbacks[i]();
    }
  };
  var then = function then2(cb2) {
    if (!state) {
      callbacks.push(cb2);
      return;
    }
    cb2();
  };
  var deferred = {
    resolved: function resolved() {
      return state;
    },
    resolve,
    promise: {
      then
    }
  };
  return deferred;
};
var ownProp = Object.prototype.hasOwnProperty;
function createRecaptcha() {
  var deferred = defer();
  return {
    notify: function notify() {
      deferred.resolve();
    },
    wait: function wait() {
      return deferred.promise;
    },
    render: function render3(ele, options, cb2) {
      this.wait().then(function() {
        cb2(window.grecaptcha.render(ele, options));
      });
    },
    reset: function reset(widgetId) {
      if (typeof widgetId === "undefined") {
        return;
      }
      this.assertLoaded();
      this.wait().then(function() {
        return window.grecaptcha.reset(widgetId);
      });
    },
    execute: function execute(widgetId) {
      if (typeof widgetId === "undefined") {
        return;
      }
      this.assertLoaded();
      this.wait().then(function() {
        return window.grecaptcha.execute(widgetId);
      });
    },
    checkRecaptchaLoad: function checkRecaptchaLoad() {
      if (ownProp.call(window, "grecaptcha") && ownProp.call(window.grecaptcha, "render")) {
        this.notify();
      }
    },
    assertLoaded: function assertLoaded() {
      if (!deferred.resolved()) {
        throw new Error("ReCAPTCHA has not been loaded");
      }
    }
  };
}
var recaptcha = createRecaptcha();
if (typeof window !== "undefined") {
  window.vueRecaptchaApiLoaded = recaptcha.notify;
}
var Recaptcha = defineComponent({
  name: "VueRecaptcha",
  props: {
    sitekey: {
      type: String,
      required: true
    },
    theme: {
      type: String
    },
    badge: {
      type: String
    },
    type: {
      type: String
    },
    size: {
      type: String
    },
    tabindex: {
      type: String
    },
    loadRecaptchaScript: {
      type: Boolean,
      "default": true
    },
    recaptchaScriptId: {
      type: String,
      "default": "__RECAPTCHA_SCRIPT"
    },
    recaptchaHost: {
      type: String,
      "default": "www.google.com"
    },
    language: {
      type: String,
      "default": ""
    }
  },
  emits: ["render", "verify", "expired", "error"],
  setup: function setup(props, _ref) {
    var slots = _ref.slots, emit = _ref.emit;
    var root = ref$1(null);
    var widgetId = ref$1(null);
    var emitVerify = function emitVerify2(response) {
      emit("verify", response);
    };
    var emitExpired = function emitExpired2() {
      emit("expired");
    };
    var emitError = function emitError2() {
      emit("error");
    };
    onMounted(function() {
      recaptcha.checkRecaptchaLoad();
      if (props.loadRecaptchaScript) {
        if (!document.getElementById(props.recaptchaScriptId)) {
          var script2 = document.createElement("script");
          script2.id = props.recaptchaScriptId;
          script2.src = "https://" + props.recaptchaHost + "/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=" + props.language;
          script2.async = true;
          script2.defer = true;
          document.head.appendChild(script2);
        }
      }
      var opts = _extends({}, props, {
        callback: emitVerify,
        "expired-callback": emitExpired,
        "error-callback": emitError
      });
      var $root = root.value;
      var container = slots["default"] ? $root.children[0] : $root;
      recaptcha.render(container, opts, function(id2) {
        widgetId.value = id2;
        emit("render", id2);
      });
    });
    return {
      root,
      widgetId,
      reset: function reset() {
        recaptcha.reset(widgetId.value);
      },
      execute: function execute() {
        recaptcha.execute(widgetId.value);
      }
    };
  },
  render: function render2() {
    var defaultSlot = this.$slots["default"];
    var defaultContent;
    if (typeof defaultSlot === "function") {
      defaultContent = defaultSlot();
    } else {
      defaultContent = defaultSlot;
    }
    return h$1R("div", {
      ref: "root"
    }, defaultContent);
  }
});
function unrefElement(elRef) {
  var _a2;
  const plain = toValue(elRef);
  return (_a2 = plain == null ? void 0 : plain.$el) != null ? _a2 : plain;
}
const defaultWindow = isClient ? window : void 0;
function useEventListener(...args) {
  let target;
  let events;
  let listeners;
  let options;
  if (typeof args[0] === "string" || Array.isArray(args[0])) {
    [events, listeners, options] = args;
    target = defaultWindow;
  } else {
    [target, events, listeners, options] = args;
  }
  if (!target)
    return noop$1;
  if (!Array.isArray(events))
    events = [events];
  if (!Array.isArray(listeners))
    listeners = [listeners];
  const cleanups = [];
  const cleanup = () => {
    cleanups.forEach((fn2) => fn2());
    cleanups.length = 0;
  };
  const register = (el, event2, listener, options2) => {
    el.addEventListener(event2, listener, options2);
    return () => el.removeEventListener(event2, listener, options2);
  };
  const stopWatch = watch(() => [unrefElement(target), toValue(options)], ([el, options2]) => {
    cleanup();
    if (!el)
      return;
    const optionsClone = isObject$3(options2) ? __spreadValues({}, options2) : options2;
    cleanups.push(...events.flatMap((event2) => {
      return listeners.map((listener) => register(el, event2, listener, optionsClone));
    }));
  }, { immediate: true, flush: "post" });
  const stop2 = () => {
    stopWatch();
    cleanup();
  };
  tryOnScopeDispose(stop2);
  return stop2;
}
let _iOSWorkaround = false;
function onClickOutside(target, handler, options = {}) {
  const { window: window2 = defaultWindow, ignore = [], capture = true, detectIframe = false } = options;
  if (!window2)
    return noop$1;
  if (isIOS && !_iOSWorkaround) {
    _iOSWorkaround = true;
    Array.from(window2.document.body.children).forEach((el) => el.addEventListener("click", noop$1));
    window2.document.documentElement.addEventListener("click", noop$1);
  }
  let shouldListen = true;
  const shouldIgnore = (event2) => {
    return ignore.some((target2) => {
      if (typeof target2 === "string") {
        return Array.from(window2.document.querySelectorAll(target2)).some((el) => el === event2.target || event2.composedPath().includes(el));
      } else {
        const el = unrefElement(target2);
        return el && (event2.target === el || event2.composedPath().includes(el));
      }
    });
  };
  const listener = (event2) => {
    const el = unrefElement(target);
    if (!el || el === event2.target || event2.composedPath().includes(el))
      return;
    if (event2.detail === 0)
      shouldListen = !shouldIgnore(event2);
    if (!shouldListen) {
      shouldListen = true;
      return;
    }
    handler(event2);
  };
  const cleanup = [
    useEventListener(window2, "click", listener, { passive: true, capture }),
    useEventListener(window2, "pointerdown", (e28) => {
      const el = unrefElement(target);
      shouldListen = !shouldIgnore(e28) && !!(el && !e28.composedPath().includes(el));
    }, { passive: true }),
    detectIframe && useEventListener(window2, "blur", (event2) => {
      setTimeout(() => {
        var _a2;
        const el = unrefElement(target);
        if (((_a2 = window2.document.activeElement) == null ? void 0 : _a2.tagName) === "IFRAME" && !(el == null ? void 0 : el.contains(window2.document.activeElement)))
          handler(event2);
      }, 0);
    })
  ].filter(Boolean);
  const stop2 = () => cleanup.forEach((fn2) => fn2());
  return stop2;
}
const vOnClickOutside = {
  [directiveHooks.mounted](el, binding) {
    const capture = !binding.modifiers.bubble;
    if (typeof binding.value === "function") {
      el.__onClickOutside_stop = onClickOutside(el, binding.value, { capture });
    } else {
      const [handler, options] = binding.value;
      el.__onClickOutside_stop = onClickOutside(el, handler, Object.assign({ capture }, options));
    }
  },
  [directiveHooks.unmounted](el) {
    el.__onClickOutside_stop();
  }
};
function createKeyPredicate(keyFilter) {
  if (typeof keyFilter === "function")
    return keyFilter;
  else if (typeof keyFilter === "string")
    return (event2) => event2.key === keyFilter;
  else if (Array.isArray(keyFilter))
    return (event2) => keyFilter.includes(event2.key);
  return () => true;
}
function onKeyStroke(...args) {
  let key;
  let handler;
  let options = {};
  if (args.length === 3) {
    key = args[0];
    handler = args[1];
    options = args[2];
  } else if (args.length === 2) {
    if (typeof args[1] === "object") {
      key = true;
      handler = args[0];
      options = args[1];
    } else {
      key = args[0];
      handler = args[1];
    }
  } else {
    key = true;
    handler = args[0];
  }
  const {
    target = defaultWindow,
    eventName = "keydown",
    passive = false,
    dedupe = false
  } = options;
  const predicate = createKeyPredicate(key);
  const listener = (e28) => {
    if (e28.repeat && toValue(dedupe))
      return;
    if (predicate(e28))
      handler(e28);
  };
  return useEventListener(target, eventName, listener, passive);
}
({
  [directiveHooks.mounted](el, binding) {
    var _a2, _b2;
    const keys2 = (_b2 = (_a2 = binding.arg) == null ? void 0 : _a2.split(",")) != null ? _b2 : true;
    if (typeof binding.value === "function") {
      onKeyStroke(keys2, binding.value, {
        target: el
      });
    } else {
      const [handler, options] = binding.value;
      onKeyStroke(keys2, handler, __spreadValues({
        target: el
      }, options));
    }
  }
});
const DEFAULT_DELAY = 500;
const DEFAULT_THRESHOLD = 10;
function onLongPress(target, handler, options) {
  var _a2, _b2;
  const elementRef = computed(() => unrefElement(target));
  let timeout;
  let posStart;
  function clear() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = void 0;
    }
    posStart = void 0;
  }
  function onDown(ev2) {
    var _a22, _b22, _c2, _d2;
    if (((_a22 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a22.self) && ev2.target !== elementRef.value)
      return;
    clear();
    if ((_b22 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b22.prevent)
      ev2.preventDefault();
    if ((_c2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _c2.stop)
      ev2.stopPropagation();
    posStart = {
      x: ev2.x,
      y: ev2.y
    };
    timeout = setTimeout(() => handler(ev2), (_d2 = options == null ? void 0 : options.delay) != null ? _d2 : DEFAULT_DELAY);
  }
  function onMove(ev2) {
    var _a22, _b22, _c2, _d2;
    if (((_a22 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a22.self) && ev2.target !== elementRef.value)
      return;
    if (!posStart || (options == null ? void 0 : options.distanceThreshold) === false)
      return;
    if ((_b22 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b22.prevent)
      ev2.preventDefault();
    if ((_c2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _c2.stop)
      ev2.stopPropagation();
    const dx2 = ev2.x - posStart.x;
    const dy2 = ev2.y - posStart.y;
    const distance = Math.sqrt(dx2 * dx2 + dy2 * dy2);
    if (distance >= ((_d2 = options == null ? void 0 : options.distanceThreshold) != null ? _d2 : DEFAULT_THRESHOLD))
      clear();
  }
  const listenerOptions = {
    capture: (_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.capture,
    once: (_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.once
  };
  const cleanup = [
    useEventListener(elementRef, "pointerdown", onDown, listenerOptions),
    useEventListener(elementRef, "pointermove", onMove, listenerOptions),
    useEventListener(elementRef, ["pointerup", "pointerleave"], clear, listenerOptions)
  ];
  const stop2 = () => cleanup.forEach((fn2) => fn2());
  return stop2;
}
({
  [directiveHooks.mounted](el, binding) {
    if (typeof binding.value === "function")
      onLongPress(el, binding.value, { modifiers: binding.modifiers });
    else
      onLongPress(el, ...binding.value);
  }
});
function useMounted() {
  const isMounted = ref$1(false);
  if (getCurrentInstance()) {
    onMounted(() => {
      isMounted.value = true;
    });
  }
  return isMounted;
}
function useSupported(callback) {
  const isMounted = useMounted();
  return computed(() => {
    isMounted.value;
    return Boolean(callback());
  });
}
function useElementHover(el, options = {}) {
  const {
    delayEnter = 0,
    delayLeave = 0,
    window: window2 = defaultWindow
  } = options;
  const isHovered = ref$1(false);
  let timer;
  const toggle = (entering) => {
    const delay = entering ? delayEnter : delayLeave;
    if (timer) {
      clearTimeout(timer);
      timer = void 0;
    }
    if (delay)
      timer = setTimeout(() => isHovered.value = entering, delay);
    else
      isHovered.value = entering;
  };
  if (!window2)
    return isHovered;
  useEventListener(el, "mouseenter", () => toggle(true), { passive: true });
  useEventListener(el, "mouseleave", () => toggle(false), { passive: true });
  return isHovered;
}
({
  [directiveHooks.mounted](el, binding) {
    if (typeof binding.value === "function") {
      const isHovered = useElementHover(el);
      watch(isHovered, (v3) => binding.value(v3));
    }
  }
});
function useResizeObserver(target, callback, options = {}) {
  const _a2 = options, { window: window2 = defaultWindow } = _a2, observerOptions = __objRest(_a2, ["window"]);
  let observer;
  const isSupported2 = useSupported(() => window2 && "ResizeObserver" in window2);
  const cleanup = () => {
    if (observer) {
      observer.disconnect();
      observer = void 0;
    }
  };
  const targets = computed(() => Array.isArray(target) ? target.map((el) => unrefElement(el)) : [unrefElement(target)]);
  const stopWatch = watch(targets, (els) => {
    cleanup();
    if (isSupported2.value && window2) {
      observer = new ResizeObserver(callback);
      for (const _el of els)
        _el && observer.observe(_el, observerOptions);
    }
  }, { immediate: true, flush: "post", deep: true });
  const stop2 = () => {
    cleanup();
    stopWatch();
  };
  tryOnScopeDispose(stop2);
  return {
    isSupported: isSupported2,
    stop: stop2
  };
}
function useElementSize(target, initialSize = { width: 0, height: 0 }, options = {}) {
  const { window: window2 = defaultWindow, box = "content-box" } = options;
  const isSVG = computed(() => {
    var _a2, _b2;
    return (_b2 = (_a2 = unrefElement(target)) == null ? void 0 : _a2.namespaceURI) == null ? void 0 : _b2.includes("svg");
  });
  const width = ref$1(initialSize.width);
  const height = ref$1(initialSize.height);
  const { stop: stop1 } = useResizeObserver(target, ([entry]) => {
    const boxSize = box === "border-box" ? entry.borderBoxSize : box === "content-box" ? entry.contentBoxSize : entry.devicePixelContentBoxSize;
    if (window2 && isSVG.value) {
      const $elem = unrefElement(target);
      if ($elem) {
        const styles = window2.getComputedStyle($elem);
        width.value = Number.parseFloat(styles.width);
        height.value = Number.parseFloat(styles.height);
      }
    } else {
      if (boxSize) {
        const formatBoxSize = Array.isArray(boxSize) ? boxSize : [boxSize];
        width.value = formatBoxSize.reduce((acc, { inlineSize }) => acc + inlineSize, 0);
        height.value = formatBoxSize.reduce((acc, { blockSize }) => acc + blockSize, 0);
      } else {
        width.value = entry.contentRect.width;
        height.value = entry.contentRect.height;
      }
    }
  }, options);
  tryOnMounted(() => {
    const ele = unrefElement(target);
    if (ele) {
      width.value = "offsetWidth" in ele ? ele.offsetWidth : initialSize.width;
      height.value = "offsetHeight" in ele ? ele.offsetHeight : initialSize.height;
    }
  });
  const stop2 = watch(() => unrefElement(target), (ele) => {
    width.value = ele ? initialSize.width : 0;
    height.value = ele ? initialSize.height : 0;
  });
  function stop3() {
    stop1();
    stop2();
  }
  return {
    width,
    height,
    stop: stop3
  };
}
({
  [directiveHooks.mounted](el, binding) {
    var _a2;
    const handler = typeof binding.value === "function" ? binding.value : (_a2 = binding.value) == null ? void 0 : _a2[0];
    const options = typeof binding.value === "function" ? [] : binding.value.slice(1);
    const { width, height } = useElementSize(el, ...options);
    watch([width, height], ([width2, height2]) => handler({ width: width2, height: height2 }));
  }
});
function useIntersectionObserver(target, callback, options = {}) {
  const {
    root,
    rootMargin = "0px",
    threshold = 0.1,
    window: window2 = defaultWindow,
    immediate = true
  } = options;
  const isSupported2 = useSupported(() => window2 && "IntersectionObserver" in window2);
  const targets = computed(() => {
    const _target = toValue(target);
    return (Array.isArray(_target) ? _target : [_target]).map(unrefElement).filter(notNullish);
  });
  let cleanup = noop$1;
  const isActive = ref$1(immediate);
  const stopWatch = isSupported2.value ? watch(() => [targets.value, unrefElement(root), isActive.value], ([targets2, root2]) => {
    cleanup();
    if (!isActive.value)
      return;
    if (!targets2.length)
      return;
    const observer = new IntersectionObserver(callback, {
      root: unrefElement(root2),
      rootMargin,
      threshold
    });
    targets2.forEach((el) => el && observer.observe(el));
    cleanup = () => {
      observer.disconnect();
      cleanup = noop$1;
    };
  }, { immediate, flush: "post" }) : noop$1;
  const stop2 = () => {
    cleanup();
    stopWatch();
    isActive.value = false;
  };
  tryOnScopeDispose(stop2);
  return {
    isSupported: isSupported2,
    isActive,
    pause() {
      cleanup();
      isActive.value = false;
    },
    resume() {
      isActive.value = true;
    },
    stop: stop2
  };
}
function useElementVisibility(element, options = {}) {
  const { window: window2 = defaultWindow, scrollTarget } = options;
  const elementIsVisible = ref$1(false);
  useIntersectionObserver(element, (intersectionObserverEntries) => {
    let isIntersecting = elementIsVisible.value;
    let latestTime = 0;
    for (const entry of intersectionObserverEntries) {
      if (entry.time >= latestTime) {
        latestTime = entry.time;
        isIntersecting = entry.isIntersecting;
      }
    }
    elementIsVisible.value = isIntersecting;
  }, {
    root: scrollTarget,
    window: window2,
    threshold: 0
  });
  return elementIsVisible;
}
({
  [directiveHooks.mounted](el, binding) {
    if (typeof binding.value === "function") {
      const handler = binding.value;
      const isVisible = useElementVisibility(el);
      watch(isVisible, (v3) => handler(v3), { immediate: true });
    } else {
      const [handler, options] = binding.value;
      const isVisible = useElementVisibility(el, options);
      watch(isVisible, (v3) => handler(v3), { immediate: true });
    }
  }
});
const ARRIVED_STATE_THRESHOLD_PIXELS = 1;
function useScroll(element, options = {}) {
  const {
    throttle: throttle2 = 0,
    idle = 200,
    onStop = noop$1,
    onScroll = noop$1,
    offset: offset2 = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions = {
      capture: false,
      passive: true
    },
    behavior = "auto",
    window: window2 = defaultWindow
  } = options;
  const internalX = ref$1(0);
  const internalY = ref$1(0);
  const x3 = computed({
    get() {
      return internalX.value;
    },
    set(x22) {
      scrollTo(x22, void 0);
    }
  });
  const y3 = computed({
    get() {
      return internalY.value;
    },
    set(y22) {
      scrollTo(void 0, y22);
    }
  });
  function scrollTo(_x2, _y2) {
    var _a2, _b2, _c2;
    if (!window2)
      return;
    const _element = toValue(element);
    if (!_element)
      return;
    (_c2 = _element instanceof Document ? window2.document.body : _element) == null ? void 0 : _c2.scrollTo({
      top: (_a2 = toValue(_y2)) != null ? _a2 : y3.value,
      left: (_b2 = toValue(_x2)) != null ? _b2 : x3.value,
      behavior: toValue(behavior)
    });
  }
  const isScrolling = ref$1(false);
  const arrivedState = reactive({
    left: true,
    right: false,
    top: true,
    bottom: false
  });
  const directions = reactive({
    left: false,
    right: false,
    top: false,
    bottom: false
  });
  const onScrollEnd = (e28) => {
    if (!isScrolling.value)
      return;
    isScrolling.value = false;
    directions.left = false;
    directions.right = false;
    directions.top = false;
    directions.bottom = false;
    onStop(e28);
  };
  const onScrollEndDebounced = useDebounceFn(onScrollEnd, throttle2 + idle);
  const setArrivedState = (target) => {
    var _a2;
    if (!window2)
      return;
    const el = target.document ? target.document.documentElement : (_a2 = target.documentElement) != null ? _a2 : target;
    const { display, flexDirection } = getComputedStyle(el);
    const scrollLeft = el.scrollLeft;
    directions.left = scrollLeft < internalX.value;
    directions.right = scrollLeft > internalX.value;
    const left = Math.abs(scrollLeft) <= 0 + (offset2.left || 0);
    const right = Math.abs(scrollLeft) + el.clientWidth >= el.scrollWidth - (offset2.right || 0) - ARRIVED_STATE_THRESHOLD_PIXELS;
    if (display === "flex" && flexDirection === "row-reverse") {
      arrivedState.left = right;
      arrivedState.right = left;
    } else {
      arrivedState.left = left;
      arrivedState.right = right;
    }
    internalX.value = scrollLeft;
    let scrollTop = el.scrollTop;
    if (target === window2.document && !scrollTop)
      scrollTop = window2.document.body.scrollTop;
    directions.top = scrollTop < internalY.value;
    directions.bottom = scrollTop > internalY.value;
    const top = Math.abs(scrollTop) <= 0 + (offset2.top || 0);
    const bottom = Math.abs(scrollTop) + el.clientHeight >= el.scrollHeight - (offset2.bottom || 0) - ARRIVED_STATE_THRESHOLD_PIXELS;
    if (display === "flex" && flexDirection === "column-reverse") {
      arrivedState.top = bottom;
      arrivedState.bottom = top;
    } else {
      arrivedState.top = top;
      arrivedState.bottom = bottom;
    }
    internalY.value = scrollTop;
  };
  const onScrollHandler = (e28) => {
    var _a2;
    if (!window2)
      return;
    const eventTarget = (_a2 = e28.target.documentElement) != null ? _a2 : e28.target;
    setArrivedState(eventTarget);
    isScrolling.value = true;
    onScrollEndDebounced(e28);
    onScroll(e28);
  };
  useEventListener(element, "scroll", throttle2 ? useThrottleFn(onScrollHandler, throttle2, true, false) : onScrollHandler, eventListenerOptions);
  tryOnMounted(() => {
    const _element = toValue(element);
    if (!_element)
      return;
    setArrivedState(_element);
  });
  useEventListener(element, "scrollend", onScrollEnd, eventListenerOptions);
  return {
    x: x3,
    y: y3,
    isScrolling,
    arrivedState,
    directions,
    measure() {
      const _element = toValue(element);
      if (window2 && _element)
        setArrivedState(_element);
    }
  };
}
function resolveElement(el) {
  if (typeof Window !== "undefined" && el instanceof Window)
    return el.document.documentElement;
  if (typeof Document !== "undefined" && el instanceof Document)
    return el.documentElement;
  return el;
}
function useInfiniteScroll(element, onLoadMore, options = {}) {
  var _a2;
  const {
    direction = "bottom",
    interval = 100,
    canLoadMore = () => true
  } = options;
  const state = reactive(useScroll(element, __spreadProps(__spreadValues({}, options), {
    offset: __spreadValues({
      [direction]: (_a2 = options.distance) != null ? _a2 : 0
    }, options.offset)
  })));
  const promise = ref$1();
  const isLoading = computed(() => !!promise.value);
  const observedElement = computed(() => {
    return resolveElement(toValue(element));
  });
  const isElementVisible = useElementVisibility(observedElement);
  function checkAndLoad() {
    state.measure();
    if (!observedElement.value || !isElementVisible.value || !canLoadMore(observedElement.value))
      return;
    const { scrollHeight, clientHeight, scrollWidth, clientWidth } = observedElement.value;
    const isNarrower = direction === "bottom" || direction === "top" ? scrollHeight <= clientHeight : scrollWidth <= clientWidth;
    if (state.arrivedState[direction] || isNarrower) {
      if (!promise.value) {
        promise.value = Promise.all([
          onLoadMore(state),
          new Promise((resolve) => setTimeout(resolve, interval))
        ]).finally(() => {
          promise.value = null;
          nextTick(() => checkAndLoad());
        });
      }
    }
  }
  watch(() => [state.arrivedState[direction], isElementVisible.value], checkAndLoad, { immediate: true });
  return {
    isLoading
  };
}
({
  [directiveHooks.mounted](el, binding) {
    if (typeof binding.value === "function")
      useInfiniteScroll(el, binding.value);
    else
      useInfiniteScroll(el, ...binding.value);
  }
});
({
  [directiveHooks.mounted](el, binding) {
    if (typeof binding.value === "function")
      useIntersectionObserver(el, binding.value);
    else
      useIntersectionObserver(el, ...binding.value);
  }
});
({
  [directiveHooks.mounted](el, binding) {
    if (typeof binding.value === "function") {
      const handler = binding.value;
      const state = useScroll(el, {
        onScroll() {
          handler(state);
        },
        onStop() {
          handler(state);
        }
      });
    } else {
      const [handler, options] = binding.value;
      const state = useScroll(el, __spreadProps(__spreadValues({}, options), {
        onScroll(e28) {
          var _a2;
          (_a2 = options.onScroll) == null ? void 0 : _a2.call(options, e28);
          handler(state);
        },
        onStop(e28) {
          var _a2;
          (_a2 = options.onStop) == null ? void 0 : _a2.call(options, e28);
          handler(state);
        }
      }));
    }
  }
});
function checkOverflowScroll(ele) {
  const style2 = window.getComputedStyle(ele);
  if (style2.overflowX === "scroll" || style2.overflowY === "scroll" || style2.overflowX === "auto" && ele.clientWidth < ele.scrollWidth || style2.overflowY === "auto" && ele.clientHeight < ele.scrollHeight) {
    return true;
  } else {
    const parent2 = ele.parentNode;
    if (!parent2 || parent2.tagName === "BODY")
      return false;
    return checkOverflowScroll(parent2);
  }
}
function preventDefault(rawEvent) {
  const e28 = rawEvent || window.event;
  const _target = e28.target;
  if (checkOverflowScroll(_target))
    return false;
  if (e28.touches.length > 1)
    return true;
  if (e28.preventDefault)
    e28.preventDefault();
  return false;
}
const elInitialOverflow = /* @__PURE__ */ new WeakMap();
function useScrollLock(element, initialState = false) {
  const isLocked = ref$1(initialState);
  let stopTouchMoveListener = null;
  let initialOverflow;
  watch(toRef(element), (el) => {
    const target = resolveElement(toValue(el));
    if (target) {
      const ele = target;
      if (!elInitialOverflow.get(ele))
        elInitialOverflow.set(ele, initialOverflow);
      if (isLocked.value)
        ele.style.overflow = "hidden";
    }
  }, {
    immediate: true
  });
  const lock = () => {
    const el = resolveElement(toValue(element));
    if (!el || isLocked.value)
      return;
    if (isIOS) {
      stopTouchMoveListener = useEventListener(el, "touchmove", (e28) => {
        preventDefault(e28);
      }, { passive: false });
    }
    el.style.overflow = "hidden";
    isLocked.value = true;
  };
  const unlock = () => {
    var _a2;
    const el = resolveElement(toValue(element));
    if (!el || !isLocked.value)
      return;
    isIOS && (stopTouchMoveListener == null ? void 0 : stopTouchMoveListener());
    el.style.overflow = (_a2 = elInitialOverflow.get(el)) != null ? _a2 : "";
    elInitialOverflow.delete(el);
    isLocked.value = false;
  };
  tryOnScopeDispose(unlock);
  return computed({
    get() {
      return isLocked.value;
    },
    set(v3) {
      if (v3)
        lock();
      else
        unlock();
    }
  });
}
function onScrollLock() {
  let isMounted = false;
  const state = ref$1(false);
  return (el, binding) => {
    state.value = binding.value;
    if (isMounted)
      return;
    isMounted = true;
    const isLocked = useScrollLock(el, binding.value);
    watch(state, (v3) => isLocked.value = v3);
  };
}
onScrollLock();
var style = "";
const SafeArea = registerPlugin("SafeArea", {
  web: () => Promise.resolve().then(function() {
    return web;
  }).then((m3) => new m3.SafeAreaWeb())
});
class FCMWeb extends WebPlugin {
  constructor() {
    super({
      name: "FCM",
      platforms: ["web"]
    });
  }
  subscribeTo(_options) {
    throw this.unimplemented("Not implemented on web.");
  }
  unsubscribeFrom(_options) {
    throw this.unimplemented("Not implemented on web.");
  }
  getToken() {
    throw this.unimplemented("Not implemented on web.");
  }
  deleteInstance() {
    throw this.unimplemented("Not implemented on web.");
  }
  setAutoInit(_options) {
    throw this.unimplemented("Not implemented on web.");
  }
  isAutoInitEnabled() {
    throw this.unimplemented("Not implemented on web.");
  }
  refreshToken() {
    throw this.unimplemented("Not implemented on web.");
  }
}
const FCM = new FCMWeb();
var web$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FCMWeb,
  FCM
}, Symbol.toStringTag, { value: "Module" }));
class BrowserWeb extends WebPlugin {
  constructor() {
    super();
    this._lastWindow = null;
  }
  async open(options) {
    this._lastWindow = window.open(options.url, options.windowName || "_blank");
  }
  async close() {
    return new Promise((resolve, reject) => {
      if (this._lastWindow != null) {
        this._lastWindow.close();
        this._lastWindow = null;
        resolve();
      } else {
        reject("No active window to close!");
      }
    });
  }
}
const Browser = new BrowserWeb();
var web$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BrowserWeb,
  Browser
}, Symbol.toStringTag, { value: "Module" }));
class SafeAreaWeb extends WebPlugin {
  async getSafeAreaInsets() {
    return {
      insets: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }
    };
  }
  async getStatusBarHeight() {
    return {
      statusBarHeight: 0
    };
  }
  setImmersiveNavigationBar() {
    throw this.unimplemented("Method not supported on Web.");
  }
}
var web = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SafeAreaWeb
}, Symbol.toStringTag, { value: "Module" }));
export { $$h as $, _$E as A, B$M as B, Capacitor as C, d$1H as D, render$g as E, render$5 as F, uuid_1 as G, PushNotifications as H, I$y as I, FCM$1 as J, K$o as K, render$b as L, render$c as M, render$a as N, render$k as O, P$O as P, I$v as Q, p$3z as R, render$7 as S, T$4 as T, render$d as U, V$u as V, render$3 as W, render$9 as X, p$3y as Y, render$p as Z, _$D as _, api as a, $$l as a0, Browser$1 as a1, hooks as a2, _$C as a3, g$P as a4, l$18 as a5, render$i as a6, h$U as a7, p$2t as a8, _$3 as a9, render$v as aA, render$n as aB, Q$5 as aC, render$e as aD, k$G as aE, z$q as aF, D$d as aG, d$4 as aH, registerPlugin as aI, V$4 as aJ, render$w as aK, SafeArea as aL, moment$1 as aa, render$6 as ab, entry_esm as ac, c$1T as ad, Recaptcha as ae, Re$2 as af, p$32 as ag, render$t as ah, h$4 as ai, render$u as aj, g$Q as ak, render$l as al, o as am, render$j as an, render$2 as ao, render$s as ap, render$r as aq, render$m as ar, vOnClickOutside as as, f$U as at, B$D as au, render$h as av, c$1S as aw, z$k as ax, Z$3 as ay, x$5 as az, axios$1 as b, bootstrap as c, c as d, event as e, firebase$1 as f, create$6 as g, y$C as h, c$1X as i, p$3A as j, render$8 as k, lodash as l, momentTimezone$1 as m, g$16 as n, c$1D as o, p$3x as p, q$C as q, render$q as r, setOptions as s, render$o as t, useFavicon as u, f$1w as v, parsePhoneNumber as w, render$4 as x, y$5 as y, render$f as z };
